var o8 = Object.defineProperty;
var a8 = (s, A, u) => A in s ? o8(s, A, { enumerable: !0, configurable: !0, writable: !0, value: u }) : s[A] = u;
var Ci = (s, A, u) => a8(s, typeof A != "symbol" ? A + "" : A, u);
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Text, MobileDialog, Dialog, Avatar, DialogHeader, DialogBody, DialogFooter, Button, Heading, Radio, Checkbox, Loader, Chip } from "@babylonlabs-io/core-ui";
import _, { SupportedResult, ReadStatus, PlayStatus, viewSdk } from "@keystonehq/sdk";
import { SigningStargateClient } from "@cosmjs/stargate";
import De, { createContext, useMemo, useContext, useReducer, useEffect, useDebugValue, useCallback, useState, useRef, createElement, Suspense, memo, useLayoutEffect } from "react";
import { createPortal } from "react-dom";
import { twJoin, twMerge } from "tailwind-merge";
import { createClient, custom, weiUnits, ContractFunctionExecutionError as ContractFunctionExecutionError$1, hexToString, trim as trim$1, formatUnits as formatUnits$1, getAddress as getAddress$1, SwitchChainError, numberToHex as numberToHex$1, UserRejectedRequestError, parseEther } from "viem";
import { BitcoinAdapter } from "@reown/appkit-adapter-bitcoin";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { bitcoin as bitcoin$2, bitcoinSignet } from "@reown/appkit/networks";
import { createAppKit, useAppKitAccount } from "@reown/appkit/react";
import { createStorage, cookieStorage } from "wagmi";
var buffer$1 = {}, base64Js$1 = {};
base64Js$1.byteLength = byteLength;
base64Js$1.toByteArray = toByteArray;
base64Js$1.fromByteArray = fromByteArray;
var lookup = [], revLookup = [], Arr = typeof Uint8Array < "u" ? Uint8Array : Array, code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i$2 = 0, len = code.length; i$2 < len; ++i$2)
  lookup[i$2] = code[i$2], revLookup[code.charCodeAt(i$2)] = i$2;
revLookup[45] = 62;
revLookup[95] = 63;
function getLens(s) {
  var A = s.length;
  if (A % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var u = s.indexOf("=");
  u === -1 && (u = A);
  var p = u === A ? 0 : 4 - u % 4;
  return [u, p];
}
function byteLength(s) {
  var A = getLens(s), u = A[0], p = A[1];
  return (u + p) * 3 / 4 - p;
}
function _byteLength(s, A, u) {
  return (A + u) * 3 / 4 - u;
}
function toByteArray(s) {
  var A, u = getLens(s), p = u[0], t = u[1], l = new Arr(_byteLength(s, p, t)), m = 0, b = t > 0 ? p - 4 : p, k;
  for (k = 0; k < b; k += 4)
    A = revLookup[s.charCodeAt(k)] << 18 | revLookup[s.charCodeAt(k + 1)] << 12 | revLookup[s.charCodeAt(k + 2)] << 6 | revLookup[s.charCodeAt(k + 3)], l[m++] = A >> 16 & 255, l[m++] = A >> 8 & 255, l[m++] = A & 255;
  return t === 2 && (A = revLookup[s.charCodeAt(k)] << 2 | revLookup[s.charCodeAt(k + 1)] >> 4, l[m++] = A & 255), t === 1 && (A = revLookup[s.charCodeAt(k)] << 10 | revLookup[s.charCodeAt(k + 1)] << 4 | revLookup[s.charCodeAt(k + 2)] >> 2, l[m++] = A >> 8 & 255, l[m++] = A & 255), l;
}
function tripletToBase64(s) {
  return lookup[s >> 18 & 63] + lookup[s >> 12 & 63] + lookup[s >> 6 & 63] + lookup[s & 63];
}
function encodeChunk(s, A, u) {
  for (var p, t = [], l = A; l < u; l += 3)
    p = (s[l] << 16 & 16711680) + (s[l + 1] << 8 & 65280) + (s[l + 2] & 255), t.push(tripletToBase64(p));
  return t.join("");
}
function fromByteArray(s) {
  for (var A, u = s.length, p = u % 3, t = [], l = 16383, m = 0, b = u - p; m < b; m += l)
    t.push(encodeChunk(s, m, m + l > b ? b : m + l));
  return p === 1 ? (A = s[u - 1], t.push(
    lookup[A >> 2] + lookup[A << 4 & 63] + "=="
  )) : p === 2 && (A = (s[u - 2] << 8) + s[u - 1], t.push(
    lookup[A >> 10] + lookup[A >> 4 & 63] + lookup[A << 2 & 63] + "="
  )), t.join("");
}
var ieee754 = {};
ieee754.read = function(s, A, u, p, t) {
  var l, m, b = t * 8 - p - 1, k = (1 << b) - 1, C = k >> 1, B = -7, Q = u ? t - 1 : 0, P = u ? -1 : 1, x = s[A + Q];
  for (Q += P, l = x & (1 << -B) - 1, x >>= -B, B += b; B > 0; l = l * 256 + s[A + Q], Q += P, B -= 8)
    ;
  for (m = l & (1 << -B) - 1, l >>= -B, B += p; B > 0; m = m * 256 + s[A + Q], Q += P, B -= 8)
    ;
  if (l === 0)
    l = 1 - C;
  else {
    if (l === k)
      return m ? NaN : (x ? -1 : 1) * (1 / 0);
    m = m + Math.pow(2, p), l = l - C;
  }
  return (x ? -1 : 1) * m * Math.pow(2, l - p);
};
ieee754.write = function(s, A, u, p, t, l) {
  var m, b, k, C = l * 8 - t - 1, B = (1 << C) - 1, Q = B >> 1, P = t === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, x = p ? 0 : l - 1, M = p ? 1 : -1, F = A < 0 || A === 0 && 1 / A < 0 ? 1 : 0;
  for (A = Math.abs(A), isNaN(A) || A === 1 / 0 ? (b = isNaN(A) ? 1 : 0, m = B) : (m = Math.floor(Math.log(A) / Math.LN2), A * (k = Math.pow(2, -m)) < 1 && (m--, k *= 2), m + Q >= 1 ? A += P / k : A += P * Math.pow(2, 1 - Q), A * k >= 2 && (m++, k /= 2), m + Q >= B ? (b = 0, m = B) : m + Q >= 1 ? (b = (A * k - 1) * Math.pow(2, t), m = m + Q) : (b = A * Math.pow(2, Q - 1) * Math.pow(2, t), m = 0)); t >= 8; s[u + x] = b & 255, x += M, b /= 256, t -= 8)
    ;
  for (m = m << t | b, C += t; C > 0; s[u + x] = m & 255, x += M, m /= 256, C -= 8)
    ;
  s[u + x - M] |= F * 128;
};
(function(s) {
  const A = base64Js$1, u = ieee754, p = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  s.Buffer = B, s.SlowBuffer = Pe, s.INSPECT_MAX_BYTES = 50;
  const t = 2147483647;
  s.kMaxLength = t;
  const { Uint8Array: l, ArrayBuffer: m, SharedArrayBuffer: b } = globalThis;
  B.TYPED_ARRAY_SUPPORT = k(), !B.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function k() {
    try {
      const Rr = new l(1), Er = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(Er, l.prototype), Object.setPrototypeOf(Rr, Er), Rr.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(B.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (B.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(B.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (B.isBuffer(this))
        return this.byteOffset;
    }
  });
  function C(Rr) {
    if (Rr > t)
      throw new RangeError('The value "' + Rr + '" is invalid for option "size"');
    const Er = new l(Rr);
    return Object.setPrototypeOf(Er, B.prototype), Er;
  }
  function B(Rr, Er, Or) {
    if (typeof Rr == "number") {
      if (typeof Er == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return M(Rr);
    }
    return Q(Rr, Er, Or);
  }
  B.poolSize = 8192;
  function Q(Rr, Er, Or) {
    if (typeof Rr == "string")
      return F(Rr, Er);
    if (m.isView(Rr))
      return ge(Rr);
    if (Rr == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Rr
      );
    if (In(Rr, m) || Rr && In(Rr.buffer, m) || typeof b < "u" && (In(Rr, b) || Rr && In(Rr.buffer, b)))
      return pe(Rr, Er, Or);
    if (typeof Rr == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const wn = Rr.valueOf && Rr.valueOf();
    if (wn != null && wn !== Rr)
      return B.from(wn, Er, Or);
    const Kn = Ie(Rr);
    if (Kn) return Kn;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof Rr[Symbol.toPrimitive] == "function")
      return B.from(Rr[Symbol.toPrimitive]("string"), Er, Or);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Rr
    );
  }
  B.from = function(Rr, Er, Or) {
    return Q(Rr, Er, Or);
  }, Object.setPrototypeOf(B.prototype, l.prototype), Object.setPrototypeOf(B, l);
  function P(Rr) {
    if (typeof Rr != "number")
      throw new TypeError('"size" argument must be of type number');
    if (Rr < 0)
      throw new RangeError('The value "' + Rr + '" is invalid for option "size"');
  }
  function x(Rr, Er, Or) {
    return P(Rr), Rr <= 0 ? C(Rr) : Er !== void 0 ? typeof Or == "string" ? C(Rr).fill(Er, Or) : C(Rr).fill(Er) : C(Rr);
  }
  B.alloc = function(Rr, Er, Or) {
    return x(Rr, Er, Or);
  };
  function M(Rr) {
    return P(Rr), C(Rr < 0 ? 0 : be(Rr) | 0);
  }
  B.allocUnsafe = function(Rr) {
    return M(Rr);
  }, B.allocUnsafeSlow = function(Rr) {
    return M(Rr);
  };
  function F(Rr, Er) {
    if ((typeof Er != "string" || Er === "") && (Er = "utf8"), !B.isEncoding(Er))
      throw new TypeError("Unknown encoding: " + Er);
    const Or = Te(Rr, Er) | 0;
    let wn = C(Or);
    const Kn = wn.write(Rr, Er);
    return Kn !== Or && (wn = wn.slice(0, Kn)), wn;
  }
  function le(Rr) {
    const Er = Rr.length < 0 ? 0 : be(Rr.length) | 0, Or = C(Er);
    for (let wn = 0; wn < Er; wn += 1)
      Or[wn] = Rr[wn] & 255;
    return Or;
  }
  function ge(Rr) {
    if (In(Rr, l)) {
      const Er = new l(Rr);
      return pe(Er.buffer, Er.byteOffset, Er.byteLength);
    }
    return le(Rr);
  }
  function pe(Rr, Er, Or) {
    if (Er < 0 || Rr.byteLength < Er)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (Rr.byteLength < Er + (Or || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let wn;
    return Er === void 0 && Or === void 0 ? wn = new l(Rr) : Or === void 0 ? wn = new l(Rr, Er) : wn = new l(Rr, Er, Or), Object.setPrototypeOf(wn, B.prototype), wn;
  }
  function Ie(Rr) {
    if (B.isBuffer(Rr)) {
      const Er = be(Rr.length) | 0, Or = C(Er);
      return Or.length === 0 || Rr.copy(Or, 0, 0, Er), Or;
    }
    if (Rr.length !== void 0)
      return typeof Rr.length != "number" || zr(Rr.length) ? C(0) : le(Rr);
    if (Rr.type === "Buffer" && Array.isArray(Rr.data))
      return le(Rr.data);
  }
  function be(Rr) {
    if (Rr >= t)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + t.toString(16) + " bytes");
    return Rr | 0;
  }
  function Pe(Rr) {
    return +Rr != Rr && (Rr = 0), B.alloc(+Rr);
  }
  B.isBuffer = function(Er) {
    return Er != null && Er._isBuffer === !0 && Er !== B.prototype;
  }, B.compare = function(Er, Or) {
    if (In(Er, l) && (Er = B.from(Er, Er.offset, Er.byteLength)), In(Or, l) && (Or = B.from(Or, Or.offset, Or.byteLength)), !B.isBuffer(Er) || !B.isBuffer(Or))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (Er === Or) return 0;
    let wn = Er.length, Kn = Or.length;
    for (let Ln = 0, Wn = Math.min(wn, Kn); Ln < Wn; ++Ln)
      if (Er[Ln] !== Or[Ln]) {
        wn = Er[Ln], Kn = Or[Ln];
        break;
      }
    return wn < Kn ? -1 : Kn < wn ? 1 : 0;
  }, B.isEncoding = function(Er) {
    switch (String(Er).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, B.concat = function(Er, Or) {
    if (!Array.isArray(Er))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (Er.length === 0)
      return B.alloc(0);
    let wn;
    if (Or === void 0)
      for (Or = 0, wn = 0; wn < Er.length; ++wn)
        Or += Er[wn].length;
    const Kn = B.allocUnsafe(Or);
    let Ln = 0;
    for (wn = 0; wn < Er.length; ++wn) {
      let Wn = Er[wn];
      if (In(Wn, l))
        Ln + Wn.length > Kn.length ? (B.isBuffer(Wn) || (Wn = B.from(Wn)), Wn.copy(Kn, Ln)) : l.prototype.set.call(
          Kn,
          Wn,
          Ln
        );
      else if (B.isBuffer(Wn))
        Wn.copy(Kn, Ln);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      Ln += Wn.length;
    }
    return Kn;
  };
  function Te(Rr, Er) {
    if (B.isBuffer(Rr))
      return Rr.length;
    if (m.isView(Rr) || In(Rr, m))
      return Rr.byteLength;
    if (typeof Rr != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof Rr
      );
    const Or = Rr.length, wn = arguments.length > 2 && arguments[2] === !0;
    if (!wn && Or === 0) return 0;
    let Kn = !1;
    for (; ; )
      switch (Er) {
        case "ascii":
        case "latin1":
        case "binary":
          return Or;
        case "utf8":
        case "utf-8":
          return Yn(Rr).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Or * 2;
        case "hex":
          return Or >>> 1;
        case "base64":
          return Cn(Rr).length;
        default:
          if (Kn)
            return wn ? -1 : Yn(Rr).length;
          Er = ("" + Er).toLowerCase(), Kn = !0;
      }
  }
  B.byteLength = Te;
  function Qe(Rr, Er, Or) {
    let wn = !1;
    if ((Er === void 0 || Er < 0) && (Er = 0), Er > this.length || ((Or === void 0 || Or > this.length) && (Or = this.length), Or <= 0) || (Or >>>= 0, Er >>>= 0, Or <= Er))
      return "";
    for (Rr || (Rr = "utf8"); ; )
      switch (Rr) {
        case "hex":
          return lr(this, Er, Or);
        case "utf8":
        case "utf-8":
          return er(this, Er, Or);
        case "ascii":
          return nr(this, Er, Or);
        case "latin1":
        case "binary":
          return fr(this, Er, Or);
        case "base64":
          return rr(this, Er, Or);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return br(this, Er, Or);
        default:
          if (wn) throw new TypeError("Unknown encoding: " + Rr);
          Rr = (Rr + "").toLowerCase(), wn = !0;
      }
  }
  B.prototype._isBuffer = !0;
  function xe(Rr, Er, Or) {
    const wn = Rr[Er];
    Rr[Er] = Rr[Or], Rr[Or] = wn;
  }
  B.prototype.swap16 = function() {
    const Er = this.length;
    if (Er % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let Or = 0; Or < Er; Or += 2)
      xe(this, Or, Or + 1);
    return this;
  }, B.prototype.swap32 = function() {
    const Er = this.length;
    if (Er % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let Or = 0; Or < Er; Or += 4)
      xe(this, Or, Or + 3), xe(this, Or + 1, Or + 2);
    return this;
  }, B.prototype.swap64 = function() {
    const Er = this.length;
    if (Er % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let Or = 0; Or < Er; Or += 8)
      xe(this, Or, Or + 7), xe(this, Or + 1, Or + 6), xe(this, Or + 2, Or + 5), xe(this, Or + 3, Or + 4);
    return this;
  }, B.prototype.toString = function() {
    const Er = this.length;
    return Er === 0 ? "" : arguments.length === 0 ? er(this, 0, Er) : Qe.apply(this, arguments);
  }, B.prototype.toLocaleString = B.prototype.toString, B.prototype.equals = function(Er) {
    if (!B.isBuffer(Er)) throw new TypeError("Argument must be a Buffer");
    return this === Er ? !0 : B.compare(this, Er) === 0;
  }, B.prototype.inspect = function() {
    let Er = "";
    const Or = s.INSPECT_MAX_BYTES;
    return Er = this.toString("hex", 0, Or).replace(/(.{2})/g, "$1 ").trim(), this.length > Or && (Er += " ... "), "<Buffer " + Er + ">";
  }, p && (B.prototype[p] = B.prototype.inspect), B.prototype.compare = function(Er, Or, wn, Kn, Ln) {
    if (In(Er, l) && (Er = B.from(Er, Er.offset, Er.byteLength)), !B.isBuffer(Er))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof Er
      );
    if (Or === void 0 && (Or = 0), wn === void 0 && (wn = Er ? Er.length : 0), Kn === void 0 && (Kn = 0), Ln === void 0 && (Ln = this.length), Or < 0 || wn > Er.length || Kn < 0 || Ln > this.length)
      throw new RangeError("out of range index");
    if (Kn >= Ln && Or >= wn)
      return 0;
    if (Kn >= Ln)
      return -1;
    if (Or >= wn)
      return 1;
    if (Or >>>= 0, wn >>>= 0, Kn >>>= 0, Ln >>>= 0, this === Er) return 0;
    let Wn = Ln - Kn, Sn = wn - Or;
    const hi = Math.min(Wn, Sn), ki = this.slice(Kn, Ln), xi = Er.slice(Or, wn);
    for (let _i = 0; _i < hi; ++_i)
      if (ki[_i] !== xi[_i]) {
        Wn = ki[_i], Sn = xi[_i];
        break;
      }
    return Wn < Sn ? -1 : Sn < Wn ? 1 : 0;
  };
  function Ee(Rr, Er, Or, wn, Kn) {
    if (Rr.length === 0) return -1;
    if (typeof Or == "string" ? (wn = Or, Or = 0) : Or > 2147483647 ? Or = 2147483647 : Or < -2147483648 && (Or = -2147483648), Or = +Or, zr(Or) && (Or = Kn ? 0 : Rr.length - 1), Or < 0 && (Or = Rr.length + Or), Or >= Rr.length) {
      if (Kn) return -1;
      Or = Rr.length - 1;
    } else if (Or < 0)
      if (Kn) Or = 0;
      else return -1;
    if (typeof Er == "string" && (Er = B.from(Er, wn)), B.isBuffer(Er))
      return Er.length === 0 ? -1 : He(Rr, Er, Or, wn, Kn);
    if (typeof Er == "number")
      return Er = Er & 255, typeof l.prototype.indexOf == "function" ? Kn ? l.prototype.indexOf.call(Rr, Er, Or) : l.prototype.lastIndexOf.call(Rr, Er, Or) : He(Rr, [Er], Or, wn, Kn);
    throw new TypeError("val must be string, number or Buffer");
  }
  function He(Rr, Er, Or, wn, Kn) {
    let Ln = 1, Wn = Rr.length, Sn = Er.length;
    if (wn !== void 0 && (wn = String(wn).toLowerCase(), wn === "ucs2" || wn === "ucs-2" || wn === "utf16le" || wn === "utf-16le")) {
      if (Rr.length < 2 || Er.length < 2)
        return -1;
      Ln = 2, Wn /= 2, Sn /= 2, Or /= 2;
    }
    function hi(xi, _i) {
      return Ln === 1 ? xi[_i] : xi.readUInt16BE(_i * Ln);
    }
    let ki;
    if (Kn) {
      let xi = -1;
      for (ki = Or; ki < Wn; ki++)
        if (hi(Rr, ki) === hi(Er, xi === -1 ? 0 : ki - xi)) {
          if (xi === -1 && (xi = ki), ki - xi + 1 === Sn) return xi * Ln;
        } else
          xi !== -1 && (ki -= ki - xi), xi = -1;
    } else
      for (Or + Sn > Wn && (Or = Wn - Sn), ki = Or; ki >= 0; ki--) {
        let xi = !0;
        for (let _i = 0; _i < Sn; _i++)
          if (hi(Rr, ki + _i) !== hi(Er, _i)) {
            xi = !1;
            break;
          }
        if (xi) return ki;
      }
    return -1;
  }
  B.prototype.includes = function(Er, Or, wn) {
    return this.indexOf(Er, Or, wn) !== -1;
  }, B.prototype.indexOf = function(Er, Or, wn) {
    return Ee(this, Er, Or, wn, !0);
  }, B.prototype.lastIndexOf = function(Er, Or, wn) {
    return Ee(this, Er, Or, wn, !1);
  };
  function ve(Rr, Er, Or, wn) {
    Or = Number(Or) || 0;
    const Kn = Rr.length - Or;
    wn ? (wn = Number(wn), wn > Kn && (wn = Kn)) : wn = Kn;
    const Ln = Er.length;
    wn > Ln / 2 && (wn = Ln / 2);
    let Wn;
    for (Wn = 0; Wn < wn; ++Wn) {
      const Sn = parseInt(Er.substr(Wn * 2, 2), 16);
      if (zr(Sn)) return Wn;
      Rr[Or + Wn] = Sn;
    }
    return Wn;
  }
  function we(Rr, Er, Or, wn) {
    return Xr(Yn(Er, Rr.length - Or), Rr, Or, wn);
  }
  function Ce(Rr, Er, Or, wn) {
    return Xr(si(Er), Rr, Or, wn);
  }
  function Se(Rr, Er, Or, wn) {
    return Xr(Cn(Er), Rr, Or, wn);
  }
  function Ne(Rr, Er, Or, wn) {
    return Xr(vn(Er, Rr.length - Or), Rr, Or, wn);
  }
  B.prototype.write = function(Er, Or, wn, Kn) {
    if (Or === void 0)
      Kn = "utf8", wn = this.length, Or = 0;
    else if (wn === void 0 && typeof Or == "string")
      Kn = Or, wn = this.length, Or = 0;
    else if (isFinite(Or))
      Or = Or >>> 0, isFinite(wn) ? (wn = wn >>> 0, Kn === void 0 && (Kn = "utf8")) : (Kn = wn, wn = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const Ln = this.length - Or;
    if ((wn === void 0 || wn > Ln) && (wn = Ln), Er.length > 0 && (wn < 0 || Or < 0) || Or > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    Kn || (Kn = "utf8");
    let Wn = !1;
    for (; ; )
      switch (Kn) {
        case "hex":
          return ve(this, Er, Or, wn);
        case "utf8":
        case "utf-8":
          return we(this, Er, Or, wn);
        case "ascii":
        case "latin1":
        case "binary":
          return Ce(this, Er, Or, wn);
        case "base64":
          return Se(this, Er, Or, wn);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Ne(this, Er, Or, wn);
        default:
          if (Wn) throw new TypeError("Unknown encoding: " + Kn);
          Kn = ("" + Kn).toLowerCase(), Wn = !0;
      }
  }, B.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function rr(Rr, Er, Or) {
    return Er === 0 && Or === Rr.length ? A.fromByteArray(Rr) : A.fromByteArray(Rr.slice(Er, Or));
  }
  function er(Rr, Er, Or) {
    Or = Math.min(Rr.length, Or);
    const wn = [];
    let Kn = Er;
    for (; Kn < Or; ) {
      const Ln = Rr[Kn];
      let Wn = null, Sn = Ln > 239 ? 4 : Ln > 223 ? 3 : Ln > 191 ? 2 : 1;
      if (Kn + Sn <= Or) {
        let hi, ki, xi, _i;
        switch (Sn) {
          case 1:
            Ln < 128 && (Wn = Ln);
            break;
          case 2:
            hi = Rr[Kn + 1], (hi & 192) === 128 && (_i = (Ln & 31) << 6 | hi & 63, _i > 127 && (Wn = _i));
            break;
          case 3:
            hi = Rr[Kn + 1], ki = Rr[Kn + 2], (hi & 192) === 128 && (ki & 192) === 128 && (_i = (Ln & 15) << 12 | (hi & 63) << 6 | ki & 63, _i > 2047 && (_i < 55296 || _i > 57343) && (Wn = _i));
            break;
          case 4:
            hi = Rr[Kn + 1], ki = Rr[Kn + 2], xi = Rr[Kn + 3], (hi & 192) === 128 && (ki & 192) === 128 && (xi & 192) === 128 && (_i = (Ln & 15) << 18 | (hi & 63) << 12 | (ki & 63) << 6 | xi & 63, _i > 65535 && _i < 1114112 && (Wn = _i));
        }
      }
      Wn === null ? (Wn = 65533, Sn = 1) : Wn > 65535 && (Wn -= 65536, wn.push(Wn >>> 10 & 1023 | 55296), Wn = 56320 | Wn & 1023), wn.push(Wn), Kn += Sn;
    }
    return sr(wn);
  }
  const ir = 4096;
  function sr(Rr) {
    const Er = Rr.length;
    if (Er <= ir)
      return String.fromCharCode.apply(String, Rr);
    let Or = "", wn = 0;
    for (; wn < Er; )
      Or += String.fromCharCode.apply(
        String,
        Rr.slice(wn, wn += ir)
      );
    return Or;
  }
  function nr(Rr, Er, Or) {
    let wn = "";
    Or = Math.min(Rr.length, Or);
    for (let Kn = Er; Kn < Or; ++Kn)
      wn += String.fromCharCode(Rr[Kn] & 127);
    return wn;
  }
  function fr(Rr, Er, Or) {
    let wn = "";
    Or = Math.min(Rr.length, Or);
    for (let Kn = Er; Kn < Or; ++Kn)
      wn += String.fromCharCode(Rr[Kn]);
    return wn;
  }
  function lr(Rr, Er, Or) {
    const wn = Rr.length;
    (!Er || Er < 0) && (Er = 0), (!Or || Or < 0 || Or > wn) && (Or = wn);
    let Kn = "";
    for (let Ln = Er; Ln < Or; ++Ln)
      Kn += En[Rr[Ln]];
    return Kn;
  }
  function br(Rr, Er, Or) {
    const wn = Rr.slice(Er, Or);
    let Kn = "";
    for (let Ln = 0; Ln < wn.length - 1; Ln += 2)
      Kn += String.fromCharCode(wn[Ln] + wn[Ln + 1] * 256);
    return Kn;
  }
  B.prototype.slice = function(Er, Or) {
    const wn = this.length;
    Er = ~~Er, Or = Or === void 0 ? wn : ~~Or, Er < 0 ? (Er += wn, Er < 0 && (Er = 0)) : Er > wn && (Er = wn), Or < 0 ? (Or += wn, Or < 0 && (Or = 0)) : Or > wn && (Or = wn), Or < Er && (Or = Er);
    const Kn = this.subarray(Er, Or);
    return Object.setPrototypeOf(Kn, B.prototype), Kn;
  };
  function Br(Rr, Er, Or) {
    if (Rr % 1 !== 0 || Rr < 0) throw new RangeError("offset is not uint");
    if (Rr + Er > Or) throw new RangeError("Trying to access beyond buffer length");
  }
  B.prototype.readUintLE = B.prototype.readUIntLE = function(Er, Or, wn) {
    Er = Er >>> 0, Or = Or >>> 0, wn || Br(Er, Or, this.length);
    let Kn = this[Er], Ln = 1, Wn = 0;
    for (; ++Wn < Or && (Ln *= 256); )
      Kn += this[Er + Wn] * Ln;
    return Kn;
  }, B.prototype.readUintBE = B.prototype.readUIntBE = function(Er, Or, wn) {
    Er = Er >>> 0, Or = Or >>> 0, wn || Br(Er, Or, this.length);
    let Kn = this[Er + --Or], Ln = 1;
    for (; Or > 0 && (Ln *= 256); )
      Kn += this[Er + --Or] * Ln;
    return Kn;
  }, B.prototype.readUint8 = B.prototype.readUInt8 = function(Er, Or) {
    return Er = Er >>> 0, Or || Br(Er, 1, this.length), this[Er];
  }, B.prototype.readUint16LE = B.prototype.readUInt16LE = function(Er, Or) {
    return Er = Er >>> 0, Or || Br(Er, 2, this.length), this[Er] | this[Er + 1] << 8;
  }, B.prototype.readUint16BE = B.prototype.readUInt16BE = function(Er, Or) {
    return Er = Er >>> 0, Or || Br(Er, 2, this.length), this[Er] << 8 | this[Er + 1];
  }, B.prototype.readUint32LE = B.prototype.readUInt32LE = function(Er, Or) {
    return Er = Er >>> 0, Or || Br(Er, 4, this.length), (this[Er] | this[Er + 1] << 8 | this[Er + 2] << 16) + this[Er + 3] * 16777216;
  }, B.prototype.readUint32BE = B.prototype.readUInt32BE = function(Er, Or) {
    return Er = Er >>> 0, Or || Br(Er, 4, this.length), this[Er] * 16777216 + (this[Er + 1] << 16 | this[Er + 2] << 8 | this[Er + 3]);
  }, B.prototype.readBigUInt64LE = Zr(function(Er) {
    Er = Er >>> 0, fn(Er, "offset");
    const Or = this[Er], wn = this[Er + 7];
    (Or === void 0 || wn === void 0) && jr(Er, this.length - 8);
    const Kn = Or + this[++Er] * 2 ** 8 + this[++Er] * 2 ** 16 + this[++Er] * 2 ** 24, Ln = this[++Er] + this[++Er] * 2 ** 8 + this[++Er] * 2 ** 16 + wn * 2 ** 24;
    return BigInt(Kn) + (BigInt(Ln) << BigInt(32));
  }), B.prototype.readBigUInt64BE = Zr(function(Er) {
    Er = Er >>> 0, fn(Er, "offset");
    const Or = this[Er], wn = this[Er + 7];
    (Or === void 0 || wn === void 0) && jr(Er, this.length - 8);
    const Kn = Or * 2 ** 24 + this[++Er] * 2 ** 16 + this[++Er] * 2 ** 8 + this[++Er], Ln = this[++Er] * 2 ** 24 + this[++Er] * 2 ** 16 + this[++Er] * 2 ** 8 + wn;
    return (BigInt(Kn) << BigInt(32)) + BigInt(Ln);
  }), B.prototype.readIntLE = function(Er, Or, wn) {
    Er = Er >>> 0, Or = Or >>> 0, wn || Br(Er, Or, this.length);
    let Kn = this[Er], Ln = 1, Wn = 0;
    for (; ++Wn < Or && (Ln *= 256); )
      Kn += this[Er + Wn] * Ln;
    return Ln *= 128, Kn >= Ln && (Kn -= Math.pow(2, 8 * Or)), Kn;
  }, B.prototype.readIntBE = function(Er, Or, wn) {
    Er = Er >>> 0, Or = Or >>> 0, wn || Br(Er, Or, this.length);
    let Kn = Or, Ln = 1, Wn = this[Er + --Kn];
    for (; Kn > 0 && (Ln *= 256); )
      Wn += this[Er + --Kn] * Ln;
    return Ln *= 128, Wn >= Ln && (Wn -= Math.pow(2, 8 * Or)), Wn;
  }, B.prototype.readInt8 = function(Er, Or) {
    return Er = Er >>> 0, Or || Br(Er, 1, this.length), this[Er] & 128 ? (255 - this[Er] + 1) * -1 : this[Er];
  }, B.prototype.readInt16LE = function(Er, Or) {
    Er = Er >>> 0, Or || Br(Er, 2, this.length);
    const wn = this[Er] | this[Er + 1] << 8;
    return wn & 32768 ? wn | 4294901760 : wn;
  }, B.prototype.readInt16BE = function(Er, Or) {
    Er = Er >>> 0, Or || Br(Er, 2, this.length);
    const wn = this[Er + 1] | this[Er] << 8;
    return wn & 32768 ? wn | 4294901760 : wn;
  }, B.prototype.readInt32LE = function(Er, Or) {
    return Er = Er >>> 0, Or || Br(Er, 4, this.length), this[Er] | this[Er + 1] << 8 | this[Er + 2] << 16 | this[Er + 3] << 24;
  }, B.prototype.readInt32BE = function(Er, Or) {
    return Er = Er >>> 0, Or || Br(Er, 4, this.length), this[Er] << 24 | this[Er + 1] << 16 | this[Er + 2] << 8 | this[Er + 3];
  }, B.prototype.readBigInt64LE = Zr(function(Er) {
    Er = Er >>> 0, fn(Er, "offset");
    const Or = this[Er], wn = this[Er + 7];
    (Or === void 0 || wn === void 0) && jr(Er, this.length - 8);
    const Kn = this[Er + 4] + this[Er + 5] * 2 ** 8 + this[Er + 6] * 2 ** 16 + (wn << 24);
    return (BigInt(Kn) << BigInt(32)) + BigInt(Or + this[++Er] * 2 ** 8 + this[++Er] * 2 ** 16 + this[++Er] * 2 ** 24);
  }), B.prototype.readBigInt64BE = Zr(function(Er) {
    Er = Er >>> 0, fn(Er, "offset");
    const Or = this[Er], wn = this[Er + 7];
    (Or === void 0 || wn === void 0) && jr(Er, this.length - 8);
    const Kn = (Or << 24) + // Overflow
    this[++Er] * 2 ** 16 + this[++Er] * 2 ** 8 + this[++Er];
    return (BigInt(Kn) << BigInt(32)) + BigInt(this[++Er] * 2 ** 24 + this[++Er] * 2 ** 16 + this[++Er] * 2 ** 8 + wn);
  }), B.prototype.readFloatLE = function(Er, Or) {
    return Er = Er >>> 0, Or || Br(Er, 4, this.length), u.read(this, Er, !0, 23, 4);
  }, B.prototype.readFloatBE = function(Er, Or) {
    return Er = Er >>> 0, Or || Br(Er, 4, this.length), u.read(this, Er, !1, 23, 4);
  }, B.prototype.readDoubleLE = function(Er, Or) {
    return Er = Er >>> 0, Or || Br(Er, 8, this.length), u.read(this, Er, !0, 52, 8);
  }, B.prototype.readDoubleBE = function(Er, Or) {
    return Er = Er >>> 0, Or || Br(Er, 8, this.length), u.read(this, Er, !1, 52, 8);
  };
  function Fr(Rr, Er, Or, wn, Kn, Ln) {
    if (!B.isBuffer(Rr)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (Er > Kn || Er < Ln) throw new RangeError('"value" argument is out of bounds');
    if (Or + wn > Rr.length) throw new RangeError("Index out of range");
  }
  B.prototype.writeUintLE = B.prototype.writeUIntLE = function(Er, Or, wn, Kn) {
    if (Er = +Er, Or = Or >>> 0, wn = wn >>> 0, !Kn) {
      const Sn = Math.pow(2, 8 * wn) - 1;
      Fr(this, Er, Or, wn, Sn, 0);
    }
    let Ln = 1, Wn = 0;
    for (this[Or] = Er & 255; ++Wn < wn && (Ln *= 256); )
      this[Or + Wn] = Er / Ln & 255;
    return Or + wn;
  }, B.prototype.writeUintBE = B.prototype.writeUIntBE = function(Er, Or, wn, Kn) {
    if (Er = +Er, Or = Or >>> 0, wn = wn >>> 0, !Kn) {
      const Sn = Math.pow(2, 8 * wn) - 1;
      Fr(this, Er, Or, wn, Sn, 0);
    }
    let Ln = wn - 1, Wn = 1;
    for (this[Or + Ln] = Er & 255; --Ln >= 0 && (Wn *= 256); )
      this[Or + Ln] = Er / Wn & 255;
    return Or + wn;
  }, B.prototype.writeUint8 = B.prototype.writeUInt8 = function(Er, Or, wn) {
    return Er = +Er, Or = Or >>> 0, wn || Fr(this, Er, Or, 1, 255, 0), this[Or] = Er & 255, Or + 1;
  }, B.prototype.writeUint16LE = B.prototype.writeUInt16LE = function(Er, Or, wn) {
    return Er = +Er, Or = Or >>> 0, wn || Fr(this, Er, Or, 2, 65535, 0), this[Or] = Er & 255, this[Or + 1] = Er >>> 8, Or + 2;
  }, B.prototype.writeUint16BE = B.prototype.writeUInt16BE = function(Er, Or, wn) {
    return Er = +Er, Or = Or >>> 0, wn || Fr(this, Er, Or, 2, 65535, 0), this[Or] = Er >>> 8, this[Or + 1] = Er & 255, Or + 2;
  }, B.prototype.writeUint32LE = B.prototype.writeUInt32LE = function(Er, Or, wn) {
    return Er = +Er, Or = Or >>> 0, wn || Fr(this, Er, Or, 4, 4294967295, 0), this[Or + 3] = Er >>> 24, this[Or + 2] = Er >>> 16, this[Or + 1] = Er >>> 8, this[Or] = Er & 255, Or + 4;
  }, B.prototype.writeUint32BE = B.prototype.writeUInt32BE = function(Er, Or, wn) {
    return Er = +Er, Or = Or >>> 0, wn || Fr(this, Er, Or, 4, 4294967295, 0), this[Or] = Er >>> 24, this[Or + 1] = Er >>> 16, this[Or + 2] = Er >>> 8, this[Or + 3] = Er & 255, Or + 4;
  };
  function Gr(Rr, Er, Or, wn, Kn) {
    Jr(Er, wn, Kn, Rr, Or, 7);
    let Ln = Number(Er & BigInt(4294967295));
    Rr[Or++] = Ln, Ln = Ln >> 8, Rr[Or++] = Ln, Ln = Ln >> 8, Rr[Or++] = Ln, Ln = Ln >> 8, Rr[Or++] = Ln;
    let Wn = Number(Er >> BigInt(32) & BigInt(4294967295));
    return Rr[Or++] = Wn, Wn = Wn >> 8, Rr[Or++] = Wn, Wn = Wn >> 8, Rr[Or++] = Wn, Wn = Wn >> 8, Rr[Or++] = Wn, Or;
  }
  function qr(Rr, Er, Or, wn, Kn) {
    Jr(Er, wn, Kn, Rr, Or, 7);
    let Ln = Number(Er & BigInt(4294967295));
    Rr[Or + 7] = Ln, Ln = Ln >> 8, Rr[Or + 6] = Ln, Ln = Ln >> 8, Rr[Or + 5] = Ln, Ln = Ln >> 8, Rr[Or + 4] = Ln;
    let Wn = Number(Er >> BigInt(32) & BigInt(4294967295));
    return Rr[Or + 3] = Wn, Wn = Wn >> 8, Rr[Or + 2] = Wn, Wn = Wn >> 8, Rr[Or + 1] = Wn, Wn = Wn >> 8, Rr[Or] = Wn, Or + 8;
  }
  B.prototype.writeBigUInt64LE = Zr(function(Er, Or = 0) {
    return Gr(this, Er, Or, BigInt(0), BigInt("0xffffffffffffffff"));
  }), B.prototype.writeBigUInt64BE = Zr(function(Er, Or = 0) {
    return qr(this, Er, Or, BigInt(0), BigInt("0xffffffffffffffff"));
  }), B.prototype.writeIntLE = function(Er, Or, wn, Kn) {
    if (Er = +Er, Or = Or >>> 0, !Kn) {
      const hi = Math.pow(2, 8 * wn - 1);
      Fr(this, Er, Or, wn, hi - 1, -hi);
    }
    let Ln = 0, Wn = 1, Sn = 0;
    for (this[Or] = Er & 255; ++Ln < wn && (Wn *= 256); )
      Er < 0 && Sn === 0 && this[Or + Ln - 1] !== 0 && (Sn = 1), this[Or + Ln] = (Er / Wn >> 0) - Sn & 255;
    return Or + wn;
  }, B.prototype.writeIntBE = function(Er, Or, wn, Kn) {
    if (Er = +Er, Or = Or >>> 0, !Kn) {
      const hi = Math.pow(2, 8 * wn - 1);
      Fr(this, Er, Or, wn, hi - 1, -hi);
    }
    let Ln = wn - 1, Wn = 1, Sn = 0;
    for (this[Or + Ln] = Er & 255; --Ln >= 0 && (Wn *= 256); )
      Er < 0 && Sn === 0 && this[Or + Ln + 1] !== 0 && (Sn = 1), this[Or + Ln] = (Er / Wn >> 0) - Sn & 255;
    return Or + wn;
  }, B.prototype.writeInt8 = function(Er, Or, wn) {
    return Er = +Er, Or = Or >>> 0, wn || Fr(this, Er, Or, 1, 127, -128), Er < 0 && (Er = 255 + Er + 1), this[Or] = Er & 255, Or + 1;
  }, B.prototype.writeInt16LE = function(Er, Or, wn) {
    return Er = +Er, Or = Or >>> 0, wn || Fr(this, Er, Or, 2, 32767, -32768), this[Or] = Er & 255, this[Or + 1] = Er >>> 8, Or + 2;
  }, B.prototype.writeInt16BE = function(Er, Or, wn) {
    return Er = +Er, Or = Or >>> 0, wn || Fr(this, Er, Or, 2, 32767, -32768), this[Or] = Er >>> 8, this[Or + 1] = Er & 255, Or + 2;
  }, B.prototype.writeInt32LE = function(Er, Or, wn) {
    return Er = +Er, Or = Or >>> 0, wn || Fr(this, Er, Or, 4, 2147483647, -2147483648), this[Or] = Er & 255, this[Or + 1] = Er >>> 8, this[Or + 2] = Er >>> 16, this[Or + 3] = Er >>> 24, Or + 4;
  }, B.prototype.writeInt32BE = function(Er, Or, wn) {
    return Er = +Er, Or = Or >>> 0, wn || Fr(this, Er, Or, 4, 2147483647, -2147483648), Er < 0 && (Er = 4294967295 + Er + 1), this[Or] = Er >>> 24, this[Or + 1] = Er >>> 16, this[Or + 2] = Er >>> 8, this[Or + 3] = Er & 255, Or + 4;
  }, B.prototype.writeBigInt64LE = Zr(function(Er, Or = 0) {
    return Gr(this, Er, Or, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), B.prototype.writeBigInt64BE = Zr(function(Er, Or = 0) {
    return qr(this, Er, Or, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function Hr(Rr, Er, Or, wn, Kn, Ln) {
    if (Or + wn > Rr.length) throw new RangeError("Index out of range");
    if (Or < 0) throw new RangeError("Index out of range");
  }
  function un(Rr, Er, Or, wn, Kn) {
    return Er = +Er, Or = Or >>> 0, Kn || Hr(Rr, Er, Or, 4), u.write(Rr, Er, Or, wn, 23, 4), Or + 4;
  }
  B.prototype.writeFloatLE = function(Er, Or, wn) {
    return un(this, Er, Or, !0, wn);
  }, B.prototype.writeFloatBE = function(Er, Or, wn) {
    return un(this, Er, Or, !1, wn);
  };
  function Dr(Rr, Er, Or, wn, Kn) {
    return Er = +Er, Or = Or >>> 0, Kn || Hr(Rr, Er, Or, 8), u.write(Rr, Er, Or, wn, 52, 8), Or + 8;
  }
  B.prototype.writeDoubleLE = function(Er, Or, wn) {
    return Dr(this, Er, Or, !0, wn);
  }, B.prototype.writeDoubleBE = function(Er, Or, wn) {
    return Dr(this, Er, Or, !1, wn);
  }, B.prototype.copy = function(Er, Or, wn, Kn) {
    if (!B.isBuffer(Er)) throw new TypeError("argument should be a Buffer");
    if (wn || (wn = 0), !Kn && Kn !== 0 && (Kn = this.length), Or >= Er.length && (Or = Er.length), Or || (Or = 0), Kn > 0 && Kn < wn && (Kn = wn), Kn === wn || Er.length === 0 || this.length === 0) return 0;
    if (Or < 0)
      throw new RangeError("targetStart out of bounds");
    if (wn < 0 || wn >= this.length) throw new RangeError("Index out of range");
    if (Kn < 0) throw new RangeError("sourceEnd out of bounds");
    Kn > this.length && (Kn = this.length), Er.length - Or < Kn - wn && (Kn = Er.length - Or + wn);
    const Ln = Kn - wn;
    return this === Er && typeof l.prototype.copyWithin == "function" ? this.copyWithin(Or, wn, Kn) : l.prototype.set.call(
      Er,
      this.subarray(wn, Kn),
      Or
    ), Ln;
  }, B.prototype.fill = function(Er, Or, wn, Kn) {
    if (typeof Er == "string") {
      if (typeof Or == "string" ? (Kn = Or, Or = 0, wn = this.length) : typeof wn == "string" && (Kn = wn, wn = this.length), Kn !== void 0 && typeof Kn != "string")
        throw new TypeError("encoding must be a string");
      if (typeof Kn == "string" && !B.isEncoding(Kn))
        throw new TypeError("Unknown encoding: " + Kn);
      if (Er.length === 1) {
        const Wn = Er.charCodeAt(0);
        (Kn === "utf8" && Wn < 128 || Kn === "latin1") && (Er = Wn);
      }
    } else typeof Er == "number" ? Er = Er & 255 : typeof Er == "boolean" && (Er = Number(Er));
    if (Or < 0 || this.length < Or || this.length < wn)
      throw new RangeError("Out of range index");
    if (wn <= Or)
      return this;
    Or = Or >>> 0, wn = wn === void 0 ? this.length : wn >>> 0, Er || (Er = 0);
    let Ln;
    if (typeof Er == "number")
      for (Ln = Or; Ln < wn; ++Ln)
        this[Ln] = Er;
    else {
      const Wn = B.isBuffer(Er) ? Er : B.from(Er, Kn), Sn = Wn.length;
      if (Sn === 0)
        throw new TypeError('The value "' + Er + '" is invalid for argument "value"');
      for (Ln = 0; Ln < wn - Or; ++Ln)
        this[Ln + Or] = Wn[Ln % Sn];
    }
    return this;
  };
  const wr = {};
  function yr(Rr, Er, Or) {
    wr[Rr] = class extends Or {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: Er.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${Rr}]`, this.stack, delete this.name;
      }
      get code() {
        return Rr;
      }
      set code(Kn) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: Kn,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${Rr}]: ${this.message}`;
      }
    };
  }
  yr(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(Rr) {
      return Rr ? `${Rr} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), yr(
    "ERR_INVALID_ARG_TYPE",
    function(Rr, Er) {
      return `The "${Rr}" argument must be of type number. Received type ${typeof Er}`;
    },
    TypeError
  ), yr(
    "ERR_OUT_OF_RANGE",
    function(Rr, Er, Or) {
      let wn = `The value of "${Rr}" is out of range.`, Kn = Or;
      return Number.isInteger(Or) && Math.abs(Or) > 2 ** 32 ? Kn = Qr(String(Or)) : typeof Or == "bigint" && (Kn = String(Or), (Or > BigInt(2) ** BigInt(32) || Or < -(BigInt(2) ** BigInt(32))) && (Kn = Qr(Kn)), Kn += "n"), wn += ` It must be ${Er}. Received ${Kn}`, wn;
    },
    RangeError
  );
  function Qr(Rr) {
    let Er = "", Or = Rr.length;
    const wn = Rr[0] === "-" ? 1 : 0;
    for (; Or >= wn + 4; Or -= 3)
      Er = `_${Rr.slice(Or - 3, Or)}${Er}`;
    return `${Rr.slice(0, Or)}${Er}`;
  }
  function _r(Rr, Er, Or) {
    fn(Er, "offset"), (Rr[Er] === void 0 || Rr[Er + Or] === void 0) && jr(Er, Rr.length - (Or + 1));
  }
  function Jr(Rr, Er, Or, wn, Kn, Ln) {
    if (Rr > Or || Rr < Er) {
      const Wn = typeof Er == "bigint" ? "n" : "";
      let Sn;
      throw Er === 0 || Er === BigInt(0) ? Sn = `>= 0${Wn} and < 2${Wn} ** ${(Ln + 1) * 8}${Wn}` : Sn = `>= -(2${Wn} ** ${(Ln + 1) * 8 - 1}${Wn}) and < 2 ** ${(Ln + 1) * 8 - 1}${Wn}`, new wr.ERR_OUT_OF_RANGE("value", Sn, Rr);
    }
    _r(wn, Kn, Ln);
  }
  function fn(Rr, Er) {
    if (typeof Rr != "number")
      throw new wr.ERR_INVALID_ARG_TYPE(Er, "number", Rr);
  }
  function jr(Rr, Er, Or) {
    throw Math.floor(Rr) !== Rr ? (fn(Rr, Or), new wr.ERR_OUT_OF_RANGE("offset", "an integer", Rr)) : Er < 0 ? new wr.ERR_BUFFER_OUT_OF_BOUNDS() : new wr.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${Er}`,
      Rr
    );
  }
  const dn = /[^+/0-9A-Za-z-_]/g;
  function Tn(Rr) {
    if (Rr = Rr.split("=")[0], Rr = Rr.trim().replace(dn, ""), Rr.length < 2) return "";
    for (; Rr.length % 4 !== 0; )
      Rr = Rr + "=";
    return Rr;
  }
  function Yn(Rr, Er) {
    Er = Er || 1 / 0;
    let Or;
    const wn = Rr.length;
    let Kn = null;
    const Ln = [];
    for (let Wn = 0; Wn < wn; ++Wn) {
      if (Or = Rr.charCodeAt(Wn), Or > 55295 && Or < 57344) {
        if (!Kn) {
          if (Or > 56319) {
            (Er -= 3) > -1 && Ln.push(239, 191, 189);
            continue;
          } else if (Wn + 1 === wn) {
            (Er -= 3) > -1 && Ln.push(239, 191, 189);
            continue;
          }
          Kn = Or;
          continue;
        }
        if (Or < 56320) {
          (Er -= 3) > -1 && Ln.push(239, 191, 189), Kn = Or;
          continue;
        }
        Or = (Kn - 55296 << 10 | Or - 56320) + 65536;
      } else Kn && (Er -= 3) > -1 && Ln.push(239, 191, 189);
      if (Kn = null, Or < 128) {
        if ((Er -= 1) < 0) break;
        Ln.push(Or);
      } else if (Or < 2048) {
        if ((Er -= 2) < 0) break;
        Ln.push(
          Or >> 6 | 192,
          Or & 63 | 128
        );
      } else if (Or < 65536) {
        if ((Er -= 3) < 0) break;
        Ln.push(
          Or >> 12 | 224,
          Or >> 6 & 63 | 128,
          Or & 63 | 128
        );
      } else if (Or < 1114112) {
        if ((Er -= 4) < 0) break;
        Ln.push(
          Or >> 18 | 240,
          Or >> 12 & 63 | 128,
          Or >> 6 & 63 | 128,
          Or & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return Ln;
  }
  function si(Rr) {
    const Er = [];
    for (let Or = 0; Or < Rr.length; ++Or)
      Er.push(Rr.charCodeAt(Or) & 255);
    return Er;
  }
  function vn(Rr, Er) {
    let Or, wn, Kn;
    const Ln = [];
    for (let Wn = 0; Wn < Rr.length && !((Er -= 2) < 0); ++Wn)
      Or = Rr.charCodeAt(Wn), wn = Or >> 8, Kn = Or % 256, Ln.push(Kn), Ln.push(wn);
    return Ln;
  }
  function Cn(Rr) {
    return A.toByteArray(Tn(Rr));
  }
  function Xr(Rr, Er, Or, wn) {
    let Kn;
    for (Kn = 0; Kn < wn && !(Kn + Or >= Er.length || Kn >= Rr.length); ++Kn)
      Er[Kn + Or] = Rr[Kn];
    return Kn;
  }
  function In(Rr, Er) {
    return Rr instanceof Er || Rr != null && Rr.constructor != null && Rr.constructor.name != null && Rr.constructor.name === Er.name;
  }
  function zr(Rr) {
    return Rr !== Rr;
  }
  const En = function() {
    const Rr = "0123456789abcdef", Er = new Array(256);
    for (let Or = 0; Or < 16; ++Or) {
      const wn = Or * 16;
      for (let Kn = 0; Kn < 16; ++Kn)
        Er[wn + Kn] = Rr[Or] + Rr[Kn];
    }
    return Er;
  }();
  function Zr(Rr) {
    return typeof BigInt > "u" ? kr : Rr;
  }
  function kr() {
    throw new Error("BigInt not supported");
  }
})(buffer$1);
const Buffer = buffer$1.Buffer, Buffer$1 = buffer$1.Buffer;
function getDefaultExportFromCjs$1(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
var browser$c = { exports: {} }, process = browser$c.exports = {}, cachedSetTimeout, cachedClearTimeout;
function defaultSetTimout() {
  throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? cachedSetTimeout = setTimeout : cachedSetTimeout = defaultSetTimout;
  } catch {
    cachedSetTimeout = defaultSetTimout;
  }
  try {
    typeof clearTimeout == "function" ? cachedClearTimeout = clearTimeout : cachedClearTimeout = defaultClearTimeout;
  } catch {
    cachedClearTimeout = defaultClearTimeout;
  }
})();
function runTimeout(s) {
  if (cachedSetTimeout === setTimeout)
    return setTimeout(s, 0);
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout)
    return cachedSetTimeout = setTimeout, setTimeout(s, 0);
  try {
    return cachedSetTimeout(s, 0);
  } catch {
    try {
      return cachedSetTimeout.call(null, s, 0);
    } catch {
      return cachedSetTimeout.call(this, s, 0);
    }
  }
}
function runClearTimeout(s) {
  if (cachedClearTimeout === clearTimeout)
    return clearTimeout(s);
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout)
    return cachedClearTimeout = clearTimeout, clearTimeout(s);
  try {
    return cachedClearTimeout(s);
  } catch {
    try {
      return cachedClearTimeout.call(null, s);
    } catch {
      return cachedClearTimeout.call(this, s);
    }
  }
}
var queue = [], draining = !1, currentQueue, queueIndex = -1;
function cleanUpNextTick() {
  !draining || !currentQueue || (draining = !1, currentQueue.length ? queue = currentQueue.concat(queue) : queueIndex = -1, queue.length && drainQueue());
}
function drainQueue() {
  if (!draining) {
    var s = runTimeout(cleanUpNextTick);
    draining = !0;
    for (var A = queue.length; A; ) {
      for (currentQueue = queue, queue = []; ++queueIndex < A; )
        currentQueue && currentQueue[queueIndex].run();
      queueIndex = -1, A = queue.length;
    }
    currentQueue = null, draining = !1, runClearTimeout(s);
  }
}
process.nextTick = function(s) {
  var A = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var u = 1; u < arguments.length; u++)
      A[u - 1] = arguments[u];
  queue.push(new Item(s, A)), queue.length === 1 && !draining && runTimeout(drainQueue);
};
function Item(s, A) {
  this.fun = s, this.array = A;
}
Item.prototype.run = function() {
  this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = !0;
process.env = {};
process.argv = [];
process.version = "";
process.versions = {};
function noop() {
}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(s) {
  return [];
};
process.binding = function(s) {
  throw new Error("process.binding is not supported");
};
process.cwd = function() {
  return "/";
};
process.chdir = function(s) {
  throw new Error("process.chdir is not supported");
};
process.umask = function() {
  return 0;
};
var browserExports = browser$c.exports;
const process$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(browserExports);
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
function getAugmentedNamespace(s) {
  if (Object.prototype.hasOwnProperty.call(s, "__esModule")) return s;
  var A = s.default;
  if (typeof A == "function") {
    var u = function p() {
      return this instanceof p ? Reflect.construct(A, arguments, this.constructor) : A.apply(this, arguments);
    };
    u.prototype = A.prototype;
  } else u = {};
  return Object.defineProperty(u, "__esModule", { value: !0 }), Object.keys(s).forEach(function(p) {
    var t = Object.getOwnPropertyDescriptor(s, p);
    Object.defineProperty(u, p, t.get ? t : {
      enumerable: !0,
      get: function() {
        return s[p];
      }
    });
  }), u;
}
var src$4 = {}, address$1 = {}, networks$1 = {}, hasRequiredNetworks$1;
function requireNetworks$1() {
  return hasRequiredNetworks$1 || (hasRequiredNetworks$1 = 1, Object.defineProperty(networks$1, "__esModule", { value: !0 }), networks$1.testnet = networks$1.regtest = networks$1.bitcoin = void 0, networks$1.bitcoin = {
    /**
     * The message prefix used for signing Bitcoin messages.
     */
    messagePrefix: `Bitcoin Signed Message:
`,
    /**
     * The Bech32 prefix used for Bitcoin addresses.
     */
    bech32: "bc",
    /**
     * The BIP32 key prefixes for Bitcoin.
     */
    bip32: {
      /**
       * The public key prefix for BIP32 extended public keys.
       */
      public: 76067358,
      /**
       * The private key prefix for BIP32 extended private keys.
       */
      private: 76066276
    },
    /**
     * The prefix for Bitcoin public key hashes.
     */
    pubKeyHash: 0,
    /**
     * The prefix for Bitcoin script hashes.
     */
    scriptHash: 5,
    /**
     * The prefix for Bitcoin Wallet Import Format (WIF) private keys.
     */
    wif: 128
  }, networks$1.regtest = {
    messagePrefix: `Bitcoin Signed Message:
`,
    bech32: "bcrt",
    bip32: {
      public: 70617039,
      private: 70615956
    },
    pubKeyHash: 111,
    scriptHash: 196,
    wif: 239
  }, networks$1.testnet = {
    messagePrefix: `Bitcoin Signed Message:
`,
    bech32: "tb",
    bip32: {
      public: 70617039,
      private: 70615956
    },
    pubKeyHash: 111,
    scriptHash: 196,
    wif: 239
  }), networks$1;
}
var payments = {}, embed = {}, script$1 = {}, bip66 = {}, hasRequiredBip66;
function requireBip66() {
  if (hasRequiredBip66) return bip66;
  hasRequiredBip66 = 1, Object.defineProperty(bip66, "__esModule", { value: !0 }), bip66.encode = bip66.decode = bip66.check = void 0;
  function s(p) {
    if (p.length < 8 || p.length > 72 || p[0] !== 48 || p[1] !== p.length - 2 || p[2] !== 2) return !1;
    const t = p[3];
    if (t === 0 || 5 + t >= p.length || p[4 + t] !== 2) return !1;
    const l = p[5 + t];
    return !(l === 0 || 6 + t + l !== p.length || p[4] & 128 || t > 1 && p[4] === 0 && !(p[5] & 128) || p[t + 6] & 128 || l > 1 && p[t + 6] === 0 && !(p[t + 7] & 128));
  }
  bip66.check = s;
  function A(p) {
    if (p.length < 8) throw new Error("DER sequence length is too short");
    if (p.length > 72) throw new Error("DER sequence length is too long");
    if (p[0] !== 48) throw new Error("Expected DER sequence");
    if (p[1] !== p.length - 2)
      throw new Error("DER sequence length is invalid");
    if (p[2] !== 2) throw new Error("Expected DER integer");
    const t = p[3];
    if (t === 0) throw new Error("R length is zero");
    if (5 + t >= p.length) throw new Error("R length is too long");
    if (p[4 + t] !== 2) throw new Error("Expected DER integer (2)");
    const l = p[5 + t];
    if (l === 0) throw new Error("S length is zero");
    if (6 + t + l !== p.length) throw new Error("S length is invalid");
    if (p[4] & 128) throw new Error("R value is negative");
    if (t > 1 && p[4] === 0 && !(p[5] & 128))
      throw new Error("R value excessively padded");
    if (p[t + 6] & 128) throw new Error("S value is negative");
    if (l > 1 && p[t + 6] === 0 && !(p[t + 7] & 128))
      throw new Error("S value excessively padded");
    return {
      r: p.slice(4, 4 + t),
      s: p.slice(6 + t)
    };
  }
  bip66.decode = A;
  function u(p, t) {
    const l = p.length, m = t.length;
    if (l === 0) throw new Error("R length is zero");
    if (m === 0) throw new Error("S length is zero");
    if (l > 33) throw new Error("R length is too long");
    if (m > 33) throw new Error("S length is too long");
    if (p[0] & 128) throw new Error("R value is negative");
    if (t[0] & 128) throw new Error("S value is negative");
    if (l > 1 && p[0] === 0 && !(p[1] & 128))
      throw new Error("R value excessively padded");
    if (m > 1 && t[0] === 0 && !(t[1] & 128))
      throw new Error("S value excessively padded");
    const b = Buffer.allocUnsafe(6 + l + m);
    return b[0] = 48, b[1] = b.length - 2, b[2] = 2, b[3] = p.length, p.copy(b, 4), b[4 + l] = 2, b[5 + l] = t.length, t.copy(b, 6 + l), b;
  }
  return bip66.encode = u, bip66;
}
var ops = {}, hasRequiredOps;
function requireOps() {
  if (hasRequiredOps) return ops;
  hasRequiredOps = 1, Object.defineProperty(ops, "__esModule", { value: !0 }), ops.REVERSE_OPS = ops.OPS = void 0;
  const s = {
    OP_FALSE: 0,
    OP_0: 0,
    OP_PUSHDATA1: 76,
    OP_PUSHDATA2: 77,
    OP_PUSHDATA4: 78,
    OP_1NEGATE: 79,
    OP_RESERVED: 80,
    OP_TRUE: 81,
    OP_1: 81,
    OP_2: 82,
    OP_3: 83,
    OP_4: 84,
    OP_5: 85,
    OP_6: 86,
    OP_7: 87,
    OP_8: 88,
    OP_9: 89,
    OP_10: 90,
    OP_11: 91,
    OP_12: 92,
    OP_13: 93,
    OP_14: 94,
    OP_15: 95,
    OP_16: 96,
    OP_NOP: 97,
    OP_VER: 98,
    OP_IF: 99,
    OP_NOTIF: 100,
    OP_VERIF: 101,
    OP_VERNOTIF: 102,
    OP_ELSE: 103,
    OP_ENDIF: 104,
    OP_VERIFY: 105,
    OP_RETURN: 106,
    OP_TOALTSTACK: 107,
    OP_FROMALTSTACK: 108,
    OP_2DROP: 109,
    OP_2DUP: 110,
    OP_3DUP: 111,
    OP_2OVER: 112,
    OP_2ROT: 113,
    OP_2SWAP: 114,
    OP_IFDUP: 115,
    OP_DEPTH: 116,
    OP_DROP: 117,
    OP_DUP: 118,
    OP_NIP: 119,
    OP_OVER: 120,
    OP_PICK: 121,
    OP_ROLL: 122,
    OP_ROT: 123,
    OP_SWAP: 124,
    OP_TUCK: 125,
    OP_CAT: 126,
    OP_SUBSTR: 127,
    OP_LEFT: 128,
    OP_RIGHT: 129,
    OP_SIZE: 130,
    OP_INVERT: 131,
    OP_AND: 132,
    OP_OR: 133,
    OP_XOR: 134,
    OP_EQUAL: 135,
    OP_EQUALVERIFY: 136,
    OP_RESERVED1: 137,
    OP_RESERVED2: 138,
    OP_1ADD: 139,
    OP_1SUB: 140,
    OP_2MUL: 141,
    OP_2DIV: 142,
    OP_NEGATE: 143,
    OP_ABS: 144,
    OP_NOT: 145,
    OP_0NOTEQUAL: 146,
    OP_ADD: 147,
    OP_SUB: 148,
    OP_MUL: 149,
    OP_DIV: 150,
    OP_MOD: 151,
    OP_LSHIFT: 152,
    OP_RSHIFT: 153,
    OP_BOOLAND: 154,
    OP_BOOLOR: 155,
    OP_NUMEQUAL: 156,
    OP_NUMEQUALVERIFY: 157,
    OP_NUMNOTEQUAL: 158,
    OP_LESSTHAN: 159,
    OP_GREATERTHAN: 160,
    OP_LESSTHANOREQUAL: 161,
    OP_GREATERTHANOREQUAL: 162,
    OP_MIN: 163,
    OP_MAX: 164,
    OP_WITHIN: 165,
    OP_RIPEMD160: 166,
    OP_SHA1: 167,
    OP_SHA256: 168,
    OP_HASH160: 169,
    OP_HASH256: 170,
    OP_CODESEPARATOR: 171,
    OP_CHECKSIG: 172,
    OP_CHECKSIGVERIFY: 173,
    OP_CHECKMULTISIG: 174,
    OP_CHECKMULTISIGVERIFY: 175,
    OP_NOP1: 176,
    OP_NOP2: 177,
    OP_CHECKLOCKTIMEVERIFY: 177,
    OP_NOP3: 178,
    OP_CHECKSEQUENCEVERIFY: 178,
    OP_NOP4: 179,
    OP_NOP5: 180,
    OP_NOP6: 181,
    OP_NOP7: 182,
    OP_NOP8: 183,
    OP_NOP9: 184,
    OP_NOP10: 185,
    OP_CHECKSIGADD: 186,
    OP_PUBKEYHASH: 253,
    OP_PUBKEY: 254,
    OP_INVALIDOPCODE: 255
  };
  ops.OPS = s;
  const A = {};
  ops.REVERSE_OPS = A;
  for (const u of Object.keys(s)) {
    const p = s[u];
    A[p] = u;
  }
  return ops;
}
var push_data = {}, hasRequiredPush_data;
function requirePush_data() {
  if (hasRequiredPush_data) return push_data;
  hasRequiredPush_data = 1, Object.defineProperty(push_data, "__esModule", { value: !0 }), push_data.decode = push_data.encode = push_data.encodingLength = void 0;
  const s = requireOps();
  function A(t) {
    return t < s.OPS.OP_PUSHDATA1 ? 1 : t <= 255 ? 2 : t <= 65535 ? 3 : 5;
  }
  push_data.encodingLength = A;
  function u(t, l, m) {
    const b = A(l);
    return b === 1 ? t.writeUInt8(l, m) : b === 2 ? (t.writeUInt8(s.OPS.OP_PUSHDATA1, m), t.writeUInt8(l, m + 1)) : b === 3 ? (t.writeUInt8(s.OPS.OP_PUSHDATA2, m), t.writeUInt16LE(l, m + 1)) : (t.writeUInt8(s.OPS.OP_PUSHDATA4, m), t.writeUInt32LE(l, m + 1)), b;
  }
  push_data.encode = u;
  function p(t, l) {
    const m = t.readUInt8(l);
    let b, k;
    if (m < s.OPS.OP_PUSHDATA1)
      b = m, k = 1;
    else if (m === s.OPS.OP_PUSHDATA1) {
      if (l + 2 > t.length) return null;
      b = t.readUInt8(l + 1), k = 2;
    } else if (m === s.OPS.OP_PUSHDATA2) {
      if (l + 3 > t.length) return null;
      b = t.readUInt16LE(l + 1), k = 3;
    } else {
      if (l + 5 > t.length) return null;
      if (m !== s.OPS.OP_PUSHDATA4) throw new Error("Unexpected opcode");
      b = t.readUInt32LE(l + 1), k = 5;
    }
    return {
      opcode: m,
      number: b,
      size: k
    };
  }
  return push_data.decode = p, push_data;
}
var script_number = {}, hasRequiredScript_number;
function requireScript_number() {
  if (hasRequiredScript_number) return script_number;
  hasRequiredScript_number = 1, Object.defineProperty(script_number, "__esModule", { value: !0 }), script_number.encode = script_number.decode = void 0;
  function s(p, t, l) {
    t = t || 4, l = l === void 0 ? !0 : l;
    const m = p.length;
    if (m === 0) return 0;
    if (m > t) throw new TypeError("Script number overflow");
    if (l && (p[m - 1] & 127) === 0 && (m <= 1 || (p[m - 2] & 128) === 0))
      throw new Error("Non-minimally encoded script number");
    if (m === 5) {
      const k = p.readUInt32LE(0), C = p.readUInt8(4);
      return C & 128 ? -((C & -129) * 4294967296 + k) : C * 4294967296 + k;
    }
    let b = 0;
    for (let k = 0; k < m; ++k)
      b |= p[k] << 8 * k;
    return p[m - 1] & 128 ? -(b & ~(128 << 8 * (m - 1))) : b;
  }
  script_number.decode = s;
  function A(p) {
    return p > 2147483647 ? 5 : p > 8388607 ? 4 : p > 32767 ? 3 : p > 127 ? 2 : p > 0 ? 1 : 0;
  }
  function u(p) {
    let t = Math.abs(p);
    const l = A(t), m = Buffer.allocUnsafe(l), b = p < 0;
    for (let k = 0; k < l; ++k)
      m.writeUInt8(t & 255, k), t >>= 8;
    return m[l - 1] & 128 ? m.writeUInt8(b ? 128 : 0, l - 1) : b && (m[l - 1] |= 128), m;
  }
  return script_number.encode = u, script_number;
}
var script_signature = {}, types$9 = {}, dist$n = {}, hasRequiredDist$n;
function requireDist$n() {
  return hasRequiredDist$n || (hasRequiredDist$n = 1, function(s) {
    Object.defineProperties(s, { __esModule: { value: !0 }, [Symbol.toStringTag]: { value: "Module" } });
    var A = {}, u = {};
    u.byteLength = B, u.toByteArray = P, u.fromByteArray = F;
    for (var p = [], t = [], l = typeof Uint8Array < "u" ? Uint8Array : Array, m = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", b = 0, k = m.length; b < k; ++b)
      p[b] = m[b], t[m.charCodeAt(b)] = b;
    t[45] = 62, t[95] = 63;
    function C(pe) {
      var Ie = pe.length;
      if (Ie % 4 > 0)
        throw new Error("Invalid string. Length must be a multiple of 4");
      var be = pe.indexOf("=");
      be === -1 && (be = Ie);
      var Pe = be === Ie ? 0 : 4 - be % 4;
      return [be, Pe];
    }
    function B(pe) {
      var Ie = C(pe), be = Ie[0], Pe = Ie[1];
      return (be + Pe) * 3 / 4 - Pe;
    }
    function Q(pe, Ie, be) {
      return (Ie + be) * 3 / 4 - be;
    }
    function P(pe) {
      var Ie, be = C(pe), Pe = be[0], Te = be[1], Qe = new l(Q(pe, Pe, Te)), xe = 0, Ee = Te > 0 ? Pe - 4 : Pe, He;
      for (He = 0; He < Ee; He += 4)
        Ie = t[pe.charCodeAt(He)] << 18 | t[pe.charCodeAt(He + 1)] << 12 | t[pe.charCodeAt(He + 2)] << 6 | t[pe.charCodeAt(He + 3)], Qe[xe++] = Ie >> 16 & 255, Qe[xe++] = Ie >> 8 & 255, Qe[xe++] = Ie & 255;
      return Te === 2 && (Ie = t[pe.charCodeAt(He)] << 2 | t[pe.charCodeAt(He + 1)] >> 4, Qe[xe++] = Ie & 255), Te === 1 && (Ie = t[pe.charCodeAt(He)] << 10 | t[pe.charCodeAt(He + 1)] << 4 | t[pe.charCodeAt(He + 2)] >> 2, Qe[xe++] = Ie >> 8 & 255, Qe[xe++] = Ie & 255), Qe;
    }
    function x(pe) {
      return p[pe >> 18 & 63] + p[pe >> 12 & 63] + p[pe >> 6 & 63] + p[pe & 63];
    }
    function M(pe, Ie, be) {
      for (var Pe, Te = [], Qe = Ie; Qe < be; Qe += 3)
        Pe = (pe[Qe] << 16 & 16711680) + (pe[Qe + 1] << 8 & 65280) + (pe[Qe + 2] & 255), Te.push(x(Pe));
      return Te.join("");
    }
    function F(pe) {
      for (var Ie, be = pe.length, Pe = be % 3, Te = [], Qe = 16383, xe = 0, Ee = be - Pe; xe < Ee; xe += Qe)
        Te.push(M(pe, xe, xe + Qe > Ee ? Ee : xe + Qe));
      return Pe === 1 ? (Ie = pe[be - 1], Te.push(
        p[Ie >> 2] + p[Ie << 4 & 63] + "=="
      )) : Pe === 2 && (Ie = (pe[be - 2] << 8) + pe[be - 1], Te.push(
        p[Ie >> 10] + p[Ie >> 4 & 63] + p[Ie << 2 & 63] + "="
      )), Te.join("");
    }
    var le = {};
    le.read = function(pe, Ie, be, Pe, Te) {
      var Qe, xe, Ee = Te * 8 - Pe - 1, He = (1 << Ee) - 1, ve = He >> 1, we = -7, Ce = be ? Te - 1 : 0, Se = be ? -1 : 1, Ne = pe[Ie + Ce];
      for (Ce += Se, Qe = Ne & (1 << -we) - 1, Ne >>= -we, we += Ee; we > 0; Qe = Qe * 256 + pe[Ie + Ce], Ce += Se, we -= 8)
        ;
      for (xe = Qe & (1 << -we) - 1, Qe >>= -we, we += Pe; we > 0; xe = xe * 256 + pe[Ie + Ce], Ce += Se, we -= 8)
        ;
      if (Qe === 0)
        Qe = 1 - ve;
      else {
        if (Qe === He)
          return xe ? NaN : (Ne ? -1 : 1) * (1 / 0);
        xe = xe + Math.pow(2, Pe), Qe = Qe - ve;
      }
      return (Ne ? -1 : 1) * xe * Math.pow(2, Qe - Pe);
    }, le.write = function(pe, Ie, be, Pe, Te, Qe) {
      var xe, Ee, He, ve = Qe * 8 - Te - 1, we = (1 << ve) - 1, Ce = we >> 1, Se = Te === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, Ne = Pe ? 0 : Qe - 1, rr = Pe ? 1 : -1, er = Ie < 0 || Ie === 0 && 1 / Ie < 0 ? 1 : 0;
      for (Ie = Math.abs(Ie), isNaN(Ie) || Ie === 1 / 0 ? (Ee = isNaN(Ie) ? 1 : 0, xe = we) : (xe = Math.floor(Math.log(Ie) / Math.LN2), Ie * (He = Math.pow(2, -xe)) < 1 && (xe--, He *= 2), xe + Ce >= 1 ? Ie += Se / He : Ie += Se * Math.pow(2, 1 - Ce), Ie * He >= 2 && (xe++, He /= 2), xe + Ce >= we ? (Ee = 0, xe = we) : xe + Ce >= 1 ? (Ee = (Ie * He - 1) * Math.pow(2, Te), xe = xe + Ce) : (Ee = Ie * Math.pow(2, Ce - 1) * Math.pow(2, Te), xe = 0)); Te >= 8; pe[be + Ne] = Ee & 255, Ne += rr, Ee /= 256, Te -= 8)
        ;
      for (xe = xe << Te | Ee, ve += Te; ve > 0; pe[be + Ne] = xe & 255, Ne += rr, xe /= 256, ve -= 8)
        ;
      pe[be + Ne - rr] |= er * 128;
    };
    (function(pe) {
      const Ie = u, be = le, Pe = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
      pe.Buffer = we, pe.SlowBuffer = br, pe.INSPECT_MAX_BYTES = 50;
      const Te = 2147483647;
      pe.kMaxLength = Te;
      const { Uint8Array: Qe, ArrayBuffer: xe, SharedArrayBuffer: Ee } = globalThis;
      we.TYPED_ARRAY_SUPPORT = He(), !we.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
        "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
      );
      function He() {
        try {
          const Pr = new Qe(1), vr = { foo: function() {
            return 42;
          } };
          return Object.setPrototypeOf(vr, Qe.prototype), Object.setPrototypeOf(Pr, vr), Pr.foo() === 42;
        } catch {
          return !1;
        }
      }
      Object.defineProperty(we.prototype, "parent", {
        enumerable: !0,
        get: function() {
          if (we.isBuffer(this))
            return this.buffer;
        }
      }), Object.defineProperty(we.prototype, "offset", {
        enumerable: !0,
        get: function() {
          if (we.isBuffer(this))
            return this.byteOffset;
        }
      });
      function ve(Pr) {
        if (Pr > Te)
          throw new RangeError('The value "' + Pr + '" is invalid for option "size"');
        const vr = new Qe(Pr);
        return Object.setPrototypeOf(vr, we.prototype), vr;
      }
      function we(Pr, vr, Cr) {
        if (typeof Pr == "number") {
          if (typeof vr == "string")
            throw new TypeError(
              'The "string" argument must be of type string. Received type number'
            );
          return rr(Pr);
        }
        return Ce(Pr, vr, Cr);
      }
      we.poolSize = 8192;
      function Ce(Pr, vr, Cr) {
        if (typeof Pr == "string")
          return er(Pr, vr);
        if (xe.isView(Pr))
          return sr(Pr);
        if (Pr == null)
          throw new TypeError(
            "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Pr
          );
        if (ms(Pr, xe) || Pr && ms(Pr.buffer, xe) || typeof Ee < "u" && (ms(Pr, Ee) || Pr && ms(Pr.buffer, Ee)))
          return nr(Pr, vr, Cr);
        if (typeof Pr == "number")
          throw new TypeError(
            'The "value" argument must not be of type number. Received type number'
          );
        const yn = Pr.valueOf && Pr.valueOf();
        if (yn != null && yn !== Pr)
          return we.from(yn, vr, Cr);
        const Pn = fr(Pr);
        if (Pn) return Pn;
        if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof Pr[Symbol.toPrimitive] == "function")
          return we.from(Pr[Symbol.toPrimitive]("string"), vr, Cr);
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Pr
        );
      }
      we.from = function(Pr, vr, Cr) {
        return Ce(Pr, vr, Cr);
      }, Object.setPrototypeOf(we.prototype, Qe.prototype), Object.setPrototypeOf(we, Qe);
      function Se(Pr) {
        if (typeof Pr != "number")
          throw new TypeError('"size" argument must be of type number');
        if (Pr < 0)
          throw new RangeError('The value "' + Pr + '" is invalid for option "size"');
      }
      function Ne(Pr, vr, Cr) {
        return Se(Pr), Pr <= 0 ? ve(Pr) : vr !== void 0 ? typeof Cr == "string" ? ve(Pr).fill(vr, Cr) : ve(Pr).fill(vr) : ve(Pr);
      }
      we.alloc = function(Pr, vr, Cr) {
        return Ne(Pr, vr, Cr);
      };
      function rr(Pr) {
        return Se(Pr), ve(Pr < 0 ? 0 : lr(Pr) | 0);
      }
      we.allocUnsafe = function(Pr) {
        return rr(Pr);
      }, we.allocUnsafeSlow = function(Pr) {
        return rr(Pr);
      };
      function er(Pr, vr) {
        if ((typeof vr != "string" || vr === "") && (vr = "utf8"), !we.isEncoding(vr))
          throw new TypeError("Unknown encoding: " + vr);
        const Cr = Br(Pr, vr) | 0;
        let yn = ve(Cr);
        const Pn = yn.write(Pr, vr);
        return Pn !== Cr && (yn = yn.slice(0, Pn)), yn;
      }
      function ir(Pr) {
        const vr = Pr.length < 0 ? 0 : lr(Pr.length) | 0, Cr = ve(vr);
        for (let yn = 0; yn < vr; yn += 1)
          Cr[yn] = Pr[yn] & 255;
        return Cr;
      }
      function sr(Pr) {
        if (ms(Pr, Qe)) {
          const vr = new Qe(Pr);
          return nr(vr.buffer, vr.byteOffset, vr.byteLength);
        }
        return ir(Pr);
      }
      function nr(Pr, vr, Cr) {
        if (vr < 0 || Pr.byteLength < vr)
          throw new RangeError('"offset" is outside of buffer bounds');
        if (Pr.byteLength < vr + (Cr || 0))
          throw new RangeError('"length" is outside of buffer bounds');
        let yn;
        return vr === void 0 && Cr === void 0 ? yn = new Qe(Pr) : Cr === void 0 ? yn = new Qe(Pr, vr) : yn = new Qe(Pr, vr, Cr), Object.setPrototypeOf(yn, we.prototype), yn;
      }
      function fr(Pr) {
        if (we.isBuffer(Pr)) {
          const vr = lr(Pr.length) | 0, Cr = ve(vr);
          return Cr.length === 0 || Pr.copy(Cr, 0, 0, vr), Cr;
        }
        if (Pr.length !== void 0)
          return typeof Pr.length != "number" || Ui(Pr.length) ? ve(0) : ir(Pr);
        if (Pr.type === "Buffer" && Array.isArray(Pr.data))
          return ir(Pr.data);
      }
      function lr(Pr) {
        if (Pr >= Te)
          throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + Te.toString(16) + " bytes");
        return Pr | 0;
      }
      function br(Pr) {
        return +Pr != Pr && (Pr = 0), we.alloc(+Pr);
      }
      we.isBuffer = function(vr) {
        return vr != null && vr._isBuffer === !0 && vr !== we.prototype;
      }, we.compare = function(vr, Cr) {
        if (ms(vr, Qe) && (vr = we.from(vr, vr.offset, vr.byteLength)), ms(Cr, Qe) && (Cr = we.from(Cr, Cr.offset, Cr.byteLength)), !we.isBuffer(vr) || !we.isBuffer(Cr))
          throw new TypeError(
            'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
          );
        if (vr === Cr) return 0;
        let yn = vr.length, Pn = Cr.length;
        for (let $n = 0, ui = Math.min(yn, Pn); $n < ui; ++$n)
          if (vr[$n] !== Cr[$n]) {
            yn = vr[$n], Pn = Cr[$n];
            break;
          }
        return yn < Pn ? -1 : Pn < yn ? 1 : 0;
      }, we.isEncoding = function(vr) {
        switch (String(vr).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return !0;
          default:
            return !1;
        }
      }, we.concat = function(vr, Cr) {
        if (!Array.isArray(vr))
          throw new TypeError('"list" argument must be an Array of Buffers');
        if (vr.length === 0)
          return we.alloc(0);
        let yn;
        if (Cr === void 0)
          for (Cr = 0, yn = 0; yn < vr.length; ++yn)
            Cr += vr[yn].length;
        const Pn = we.allocUnsafe(Cr);
        let $n = 0;
        for (yn = 0; yn < vr.length; ++yn) {
          let ui = vr[yn];
          if (ms(ui, Qe))
            $n + ui.length > Pn.length ? (we.isBuffer(ui) || (ui = we.from(ui)), ui.copy(Pn, $n)) : Qe.prototype.set.call(
              Pn,
              ui,
              $n
            );
          else if (we.isBuffer(ui))
            ui.copy(Pn, $n);
          else
            throw new TypeError('"list" argument must be an Array of Buffers');
          $n += ui.length;
        }
        return Pn;
      };
      function Br(Pr, vr) {
        if (we.isBuffer(Pr))
          return Pr.length;
        if (xe.isView(Pr) || ms(Pr, xe))
          return Pr.byteLength;
        if (typeof Pr != "string")
          throw new TypeError(
            'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof Pr
          );
        const Cr = Pr.length, yn = arguments.length > 2 && arguments[2] === !0;
        if (!yn && Cr === 0) return 0;
        let Pn = !1;
        for (; ; )
          switch (vr) {
            case "ascii":
            case "latin1":
            case "binary":
              return Cr;
            case "utf8":
            case "utf-8":
              return hi(Pr).length;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return Cr * 2;
            case "hex":
              return Cr >>> 1;
            case "base64":
              return _i(Pr).length;
            default:
              if (Pn)
                return yn ? -1 : hi(Pr).length;
              vr = ("" + vr).toLowerCase(), Pn = !0;
          }
      }
      we.byteLength = Br;
      function Fr(Pr, vr, Cr) {
        let yn = !1;
        if ((vr === void 0 || vr < 0) && (vr = 0), vr > this.length || ((Cr === void 0 || Cr > this.length) && (Cr = this.length), Cr <= 0) || (Cr >>>= 0, vr >>>= 0, Cr <= vr))
          return "";
        for (Pr || (Pr = "utf8"); ; )
          switch (Pr) {
            case "hex":
              return Yn(this, vr, Cr);
            case "utf8":
            case "utf-8":
              return Jr(this, vr, Cr);
            case "ascii":
              return dn(this, vr, Cr);
            case "latin1":
            case "binary":
              return Tn(this, vr, Cr);
            case "base64":
              return _r(this, vr, Cr);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return si(this, vr, Cr);
            default:
              if (yn) throw new TypeError("Unknown encoding: " + Pr);
              Pr = (Pr + "").toLowerCase(), yn = !0;
          }
      }
      we.prototype._isBuffer = !0;
      function Gr(Pr, vr, Cr) {
        const yn = Pr[vr];
        Pr[vr] = Pr[Cr], Pr[Cr] = yn;
      }
      we.prototype.swap16 = function() {
        const vr = this.length;
        if (vr % 2 !== 0)
          throw new RangeError("Buffer size must be a multiple of 16-bits");
        for (let Cr = 0; Cr < vr; Cr += 2)
          Gr(this, Cr, Cr + 1);
        return this;
      }, we.prototype.swap32 = function() {
        const vr = this.length;
        if (vr % 4 !== 0)
          throw new RangeError("Buffer size must be a multiple of 32-bits");
        for (let Cr = 0; Cr < vr; Cr += 4)
          Gr(this, Cr, Cr + 3), Gr(this, Cr + 1, Cr + 2);
        return this;
      }, we.prototype.swap64 = function() {
        const vr = this.length;
        if (vr % 8 !== 0)
          throw new RangeError("Buffer size must be a multiple of 64-bits");
        for (let Cr = 0; Cr < vr; Cr += 8)
          Gr(this, Cr, Cr + 7), Gr(this, Cr + 1, Cr + 6), Gr(this, Cr + 2, Cr + 5), Gr(this, Cr + 3, Cr + 4);
        return this;
      }, we.prototype.toString = function() {
        const vr = this.length;
        return vr === 0 ? "" : arguments.length === 0 ? Jr(this, 0, vr) : Fr.apply(this, arguments);
      }, we.prototype.toLocaleString = we.prototype.toString, we.prototype.equals = function(vr) {
        if (!we.isBuffer(vr)) throw new TypeError("Argument must be a Buffer");
        return this === vr ? !0 : we.compare(this, vr) === 0;
      }, we.prototype.inspect = function() {
        let vr = "";
        const Cr = pe.INSPECT_MAX_BYTES;
        return vr = this.toString("hex", 0, Cr).replace(/(.{2})/g, "$1 ").trim(), this.length > Cr && (vr += " ... "), "<Buffer " + vr + ">";
      }, Pe && (we.prototype[Pe] = we.prototype.inspect), we.prototype.compare = function(vr, Cr, yn, Pn, $n) {
        if (ms(vr, Qe) && (vr = we.from(vr, vr.offset, vr.byteLength)), !we.isBuffer(vr))
          throw new TypeError(
            'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof vr
          );
        if (Cr === void 0 && (Cr = 0), yn === void 0 && (yn = vr ? vr.length : 0), Pn === void 0 && (Pn = 0), $n === void 0 && ($n = this.length), Cr < 0 || yn > vr.length || Pn < 0 || $n > this.length)
          throw new RangeError("out of range index");
        if (Pn >= $n && Cr >= yn)
          return 0;
        if (Pn >= $n)
          return -1;
        if (Cr >= yn)
          return 1;
        if (Cr >>>= 0, yn >>>= 0, Pn >>>= 0, $n >>>= 0, this === vr) return 0;
        let ui = $n - Pn, Ei = yn - Cr;
        const zi = Math.min(ui, Ei), Gi = this.slice(Pn, $n), Vi = vr.slice(Cr, yn);
        for (let Ur = 0; Ur < zi; ++Ur)
          if (Gi[Ur] !== Vi[Ur]) {
            ui = Gi[Ur], Ei = Vi[Ur];
            break;
          }
        return ui < Ei ? -1 : Ei < ui ? 1 : 0;
      };
      function qr(Pr, vr, Cr, yn, Pn) {
        if (Pr.length === 0) return -1;
        if (typeof Cr == "string" ? (yn = Cr, Cr = 0) : Cr > 2147483647 ? Cr = 2147483647 : Cr < -2147483648 && (Cr = -2147483648), Cr = +Cr, Ui(Cr) && (Cr = Pn ? 0 : Pr.length - 1), Cr < 0 && (Cr = Pr.length + Cr), Cr >= Pr.length) {
          if (Pn) return -1;
          Cr = Pr.length - 1;
        } else if (Cr < 0)
          if (Pn) Cr = 0;
          else return -1;
        if (typeof vr == "string" && (vr = we.from(vr, yn)), we.isBuffer(vr))
          return vr.length === 0 ? -1 : Hr(Pr, vr, Cr, yn, Pn);
        if (typeof vr == "number")
          return vr = vr & 255, typeof Qe.prototype.indexOf == "function" ? Pn ? Qe.prototype.indexOf.call(Pr, vr, Cr) : Qe.prototype.lastIndexOf.call(Pr, vr, Cr) : Hr(Pr, [vr], Cr, yn, Pn);
        throw new TypeError("val must be string, number or Buffer");
      }
      function Hr(Pr, vr, Cr, yn, Pn) {
        let $n = 1, ui = Pr.length, Ei = vr.length;
        if (yn !== void 0 && (yn = String(yn).toLowerCase(), yn === "ucs2" || yn === "ucs-2" || yn === "utf16le" || yn === "utf-16le")) {
          if (Pr.length < 2 || vr.length < 2)
            return -1;
          $n = 2, ui /= 2, Ei /= 2, Cr /= 2;
        }
        function zi(Vi, Ur) {
          return $n === 1 ? Vi[Ur] : Vi.readUInt16BE(Ur * $n);
        }
        let Gi;
        if (Pn) {
          let Vi = -1;
          for (Gi = Cr; Gi < ui; Gi++)
            if (zi(Pr, Gi) === zi(vr, Vi === -1 ? 0 : Gi - Vi)) {
              if (Vi === -1 && (Vi = Gi), Gi - Vi + 1 === Ei) return Vi * $n;
            } else
              Vi !== -1 && (Gi -= Gi - Vi), Vi = -1;
        } else
          for (Cr + Ei > ui && (Cr = ui - Ei), Gi = Cr; Gi >= 0; Gi--) {
            let Vi = !0;
            for (let Ur = 0; Ur < Ei; Ur++)
              if (zi(Pr, Gi + Ur) !== zi(vr, Ur)) {
                Vi = !1;
                break;
              }
            if (Vi) return Gi;
          }
        return -1;
      }
      we.prototype.includes = function(vr, Cr, yn) {
        return this.indexOf(vr, Cr, yn) !== -1;
      }, we.prototype.indexOf = function(vr, Cr, yn) {
        return qr(this, vr, Cr, yn, !0);
      }, we.prototype.lastIndexOf = function(vr, Cr, yn) {
        return qr(this, vr, Cr, yn, !1);
      };
      function un(Pr, vr, Cr, yn) {
        Cr = Number(Cr) || 0;
        const Pn = Pr.length - Cr;
        yn ? (yn = Number(yn), yn > Pn && (yn = Pn)) : yn = Pn;
        const $n = vr.length;
        yn > $n / 2 && (yn = $n / 2);
        let ui;
        for (ui = 0; ui < yn; ++ui) {
          const Ei = parseInt(vr.substr(ui * 2, 2), 16);
          if (Ui(Ei)) return ui;
          Pr[Cr + ui] = Ei;
        }
        return ui;
      }
      function Dr(Pr, vr, Cr, yn) {
        return Li(hi(vr, Pr.length - Cr), Pr, Cr, yn);
      }
      function wr(Pr, vr, Cr, yn) {
        return Li(ki(vr), Pr, Cr, yn);
      }
      function yr(Pr, vr, Cr, yn) {
        return Li(_i(vr), Pr, Cr, yn);
      }
      function Qr(Pr, vr, Cr, yn) {
        return Li(xi(vr, Pr.length - Cr), Pr, Cr, yn);
      }
      we.prototype.write = function(vr, Cr, yn, Pn) {
        if (Cr === void 0)
          Pn = "utf8", yn = this.length, Cr = 0;
        else if (yn === void 0 && typeof Cr == "string")
          Pn = Cr, yn = this.length, Cr = 0;
        else if (isFinite(Cr))
          Cr = Cr >>> 0, isFinite(yn) ? (yn = yn >>> 0, Pn === void 0 && (Pn = "utf8")) : (Pn = yn, yn = void 0);
        else
          throw new Error(
            "Buffer.write(string, encoding, offset[, length]) is no longer supported"
          );
        const $n = this.length - Cr;
        if ((yn === void 0 || yn > $n) && (yn = $n), vr.length > 0 && (yn < 0 || Cr < 0) || Cr > this.length)
          throw new RangeError("Attempt to write outside buffer bounds");
        Pn || (Pn = "utf8");
        let ui = !1;
        for (; ; )
          switch (Pn) {
            case "hex":
              return un(this, vr, Cr, yn);
            case "utf8":
            case "utf-8":
              return Dr(this, vr, Cr, yn);
            case "ascii":
            case "latin1":
            case "binary":
              return wr(this, vr, Cr, yn);
            case "base64":
              return yr(this, vr, Cr, yn);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return Qr(this, vr, Cr, yn);
            default:
              if (ui) throw new TypeError("Unknown encoding: " + Pn);
              Pn = ("" + Pn).toLowerCase(), ui = !0;
          }
      }, we.prototype.toJSON = function() {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };
      function _r(Pr, vr, Cr) {
        return vr === 0 && Cr === Pr.length ? Ie.fromByteArray(Pr) : Ie.fromByteArray(Pr.slice(vr, Cr));
      }
      function Jr(Pr, vr, Cr) {
        Cr = Math.min(Pr.length, Cr);
        const yn = [];
        let Pn = vr;
        for (; Pn < Cr; ) {
          const $n = Pr[Pn];
          let ui = null, Ei = $n > 239 ? 4 : $n > 223 ? 3 : $n > 191 ? 2 : 1;
          if (Pn + Ei <= Cr) {
            let zi, Gi, Vi, Ur;
            switch (Ei) {
              case 1:
                $n < 128 && (ui = $n);
                break;
              case 2:
                zi = Pr[Pn + 1], (zi & 192) === 128 && (Ur = ($n & 31) << 6 | zi & 63, Ur > 127 && (ui = Ur));
                break;
              case 3:
                zi = Pr[Pn + 1], Gi = Pr[Pn + 2], (zi & 192) === 128 && (Gi & 192) === 128 && (Ur = ($n & 15) << 12 | (zi & 63) << 6 | Gi & 63, Ur > 2047 && (Ur < 55296 || Ur > 57343) && (ui = Ur));
                break;
              case 4:
                zi = Pr[Pn + 1], Gi = Pr[Pn + 2], Vi = Pr[Pn + 3], (zi & 192) === 128 && (Gi & 192) === 128 && (Vi & 192) === 128 && (Ur = ($n & 15) << 18 | (zi & 63) << 12 | (Gi & 63) << 6 | Vi & 63, Ur > 65535 && Ur < 1114112 && (ui = Ur));
            }
          }
          ui === null ? (ui = 65533, Ei = 1) : ui > 65535 && (ui -= 65536, yn.push(ui >>> 10 & 1023 | 55296), ui = 56320 | ui & 1023), yn.push(ui), Pn += Ei;
        }
        return jr(yn);
      }
      const fn = 4096;
      function jr(Pr) {
        const vr = Pr.length;
        if (vr <= fn)
          return String.fromCharCode.apply(String, Pr);
        let Cr = "", yn = 0;
        for (; yn < vr; )
          Cr += String.fromCharCode.apply(
            String,
            Pr.slice(yn, yn += fn)
          );
        return Cr;
      }
      function dn(Pr, vr, Cr) {
        let yn = "";
        Cr = Math.min(Pr.length, Cr);
        for (let Pn = vr; Pn < Cr; ++Pn)
          yn += String.fromCharCode(Pr[Pn] & 127);
        return yn;
      }
      function Tn(Pr, vr, Cr) {
        let yn = "";
        Cr = Math.min(Pr.length, Cr);
        for (let Pn = vr; Pn < Cr; ++Pn)
          yn += String.fromCharCode(Pr[Pn]);
        return yn;
      }
      function Yn(Pr, vr, Cr) {
        const yn = Pr.length;
        (!vr || vr < 0) && (vr = 0), (!Cr || Cr < 0 || Cr > yn) && (Cr = yn);
        let Pn = "";
        for (let $n = vr; $n < Cr; ++$n)
          Pn += Mi[Pr[$n]];
        return Pn;
      }
      function si(Pr, vr, Cr) {
        const yn = Pr.slice(vr, Cr);
        let Pn = "";
        for (let $n = 0; $n < yn.length - 1; $n += 2)
          Pn += String.fromCharCode(yn[$n] + yn[$n + 1] * 256);
        return Pn;
      }
      we.prototype.slice = function(vr, Cr) {
        const yn = this.length;
        vr = ~~vr, Cr = Cr === void 0 ? yn : ~~Cr, vr < 0 ? (vr += yn, vr < 0 && (vr = 0)) : vr > yn && (vr = yn), Cr < 0 ? (Cr += yn, Cr < 0 && (Cr = 0)) : Cr > yn && (Cr = yn), Cr < vr && (Cr = vr);
        const Pn = this.subarray(vr, Cr);
        return Object.setPrototypeOf(Pn, we.prototype), Pn;
      };
      function vn(Pr, vr, Cr) {
        if (Pr % 1 !== 0 || Pr < 0) throw new RangeError("offset is not uint");
        if (Pr + vr > Cr) throw new RangeError("Trying to access beyond buffer length");
      }
      we.prototype.readUintLE = we.prototype.readUIntLE = function(vr, Cr, yn) {
        vr = vr >>> 0, Cr = Cr >>> 0, yn || vn(vr, Cr, this.length);
        let Pn = this[vr], $n = 1, ui = 0;
        for (; ++ui < Cr && ($n *= 256); )
          Pn += this[vr + ui] * $n;
        return Pn;
      }, we.prototype.readUintBE = we.prototype.readUIntBE = function(vr, Cr, yn) {
        vr = vr >>> 0, Cr = Cr >>> 0, yn || vn(vr, Cr, this.length);
        let Pn = this[vr + --Cr], $n = 1;
        for (; Cr > 0 && ($n *= 256); )
          Pn += this[vr + --Cr] * $n;
        return Pn;
      }, we.prototype.readUint8 = we.prototype.readUInt8 = function(vr, Cr) {
        return vr = vr >>> 0, Cr || vn(vr, 1, this.length), this[vr];
      }, we.prototype.readUint16LE = we.prototype.readUInt16LE = function(vr, Cr) {
        return vr = vr >>> 0, Cr || vn(vr, 2, this.length), this[vr] | this[vr + 1] << 8;
      }, we.prototype.readUint16BE = we.prototype.readUInt16BE = function(vr, Cr) {
        return vr = vr >>> 0, Cr || vn(vr, 2, this.length), this[vr] << 8 | this[vr + 1];
      }, we.prototype.readUint32LE = we.prototype.readUInt32LE = function(vr, Cr) {
        return vr = vr >>> 0, Cr || vn(vr, 4, this.length), (this[vr] | this[vr + 1] << 8 | this[vr + 2] << 16) + this[vr + 3] * 16777216;
      }, we.prototype.readUint32BE = we.prototype.readUInt32BE = function(vr, Cr) {
        return vr = vr >>> 0, Cr || vn(vr, 4, this.length), this[vr] * 16777216 + (this[vr + 1] << 16 | this[vr + 2] << 8 | this[vr + 3]);
      }, we.prototype.readBigUInt64LE = Ls(function(vr) {
        vr = vr >>> 0, Kn(vr, "offset");
        const Cr = this[vr], yn = this[vr + 7];
        (Cr === void 0 || yn === void 0) && Ln(vr, this.length - 8);
        const Pn = Cr + this[++vr] * 2 ** 8 + this[++vr] * 2 ** 16 + this[++vr] * 2 ** 24, $n = this[++vr] + this[++vr] * 2 ** 8 + this[++vr] * 2 ** 16 + yn * 2 ** 24;
        return BigInt(Pn) + (BigInt($n) << BigInt(32));
      }), we.prototype.readBigUInt64BE = Ls(function(vr) {
        vr = vr >>> 0, Kn(vr, "offset");
        const Cr = this[vr], yn = this[vr + 7];
        (Cr === void 0 || yn === void 0) && Ln(vr, this.length - 8);
        const Pn = Cr * 2 ** 24 + this[++vr] * 2 ** 16 + this[++vr] * 2 ** 8 + this[++vr], $n = this[++vr] * 2 ** 24 + this[++vr] * 2 ** 16 + this[++vr] * 2 ** 8 + yn;
        return (BigInt(Pn) << BigInt(32)) + BigInt($n);
      }), we.prototype.readIntLE = function(vr, Cr, yn) {
        vr = vr >>> 0, Cr = Cr >>> 0, yn || vn(vr, Cr, this.length);
        let Pn = this[vr], $n = 1, ui = 0;
        for (; ++ui < Cr && ($n *= 256); )
          Pn += this[vr + ui] * $n;
        return $n *= 128, Pn >= $n && (Pn -= Math.pow(2, 8 * Cr)), Pn;
      }, we.prototype.readIntBE = function(vr, Cr, yn) {
        vr = vr >>> 0, Cr = Cr >>> 0, yn || vn(vr, Cr, this.length);
        let Pn = Cr, $n = 1, ui = this[vr + --Pn];
        for (; Pn > 0 && ($n *= 256); )
          ui += this[vr + --Pn] * $n;
        return $n *= 128, ui >= $n && (ui -= Math.pow(2, 8 * Cr)), ui;
      }, we.prototype.readInt8 = function(vr, Cr) {
        return vr = vr >>> 0, Cr || vn(vr, 1, this.length), this[vr] & 128 ? (255 - this[vr] + 1) * -1 : this[vr];
      }, we.prototype.readInt16LE = function(vr, Cr) {
        vr = vr >>> 0, Cr || vn(vr, 2, this.length);
        const yn = this[vr] | this[vr + 1] << 8;
        return yn & 32768 ? yn | 4294901760 : yn;
      }, we.prototype.readInt16BE = function(vr, Cr) {
        vr = vr >>> 0, Cr || vn(vr, 2, this.length);
        const yn = this[vr + 1] | this[vr] << 8;
        return yn & 32768 ? yn | 4294901760 : yn;
      }, we.prototype.readInt32LE = function(vr, Cr) {
        return vr = vr >>> 0, Cr || vn(vr, 4, this.length), this[vr] | this[vr + 1] << 8 | this[vr + 2] << 16 | this[vr + 3] << 24;
      }, we.prototype.readInt32BE = function(vr, Cr) {
        return vr = vr >>> 0, Cr || vn(vr, 4, this.length), this[vr] << 24 | this[vr + 1] << 16 | this[vr + 2] << 8 | this[vr + 3];
      }, we.prototype.readBigInt64LE = Ls(function(vr) {
        vr = vr >>> 0, Kn(vr, "offset");
        const Cr = this[vr], yn = this[vr + 7];
        (Cr === void 0 || yn === void 0) && Ln(vr, this.length - 8);
        const Pn = this[vr + 4] + this[vr + 5] * 2 ** 8 + this[vr + 6] * 2 ** 16 + (yn << 24);
        return (BigInt(Pn) << BigInt(32)) + BigInt(Cr + this[++vr] * 2 ** 8 + this[++vr] * 2 ** 16 + this[++vr] * 2 ** 24);
      }), we.prototype.readBigInt64BE = Ls(function(vr) {
        vr = vr >>> 0, Kn(vr, "offset");
        const Cr = this[vr], yn = this[vr + 7];
        (Cr === void 0 || yn === void 0) && Ln(vr, this.length - 8);
        const Pn = (Cr << 24) + // Overflow
        this[++vr] * 2 ** 16 + this[++vr] * 2 ** 8 + this[++vr];
        return (BigInt(Pn) << BigInt(32)) + BigInt(this[++vr] * 2 ** 24 + this[++vr] * 2 ** 16 + this[++vr] * 2 ** 8 + yn);
      }), we.prototype.readFloatLE = function(vr, Cr) {
        return vr = vr >>> 0, Cr || vn(vr, 4, this.length), be.read(this, vr, !0, 23, 4);
      }, we.prototype.readFloatBE = function(vr, Cr) {
        return vr = vr >>> 0, Cr || vn(vr, 4, this.length), be.read(this, vr, !1, 23, 4);
      }, we.prototype.readDoubleLE = function(vr, Cr) {
        return vr = vr >>> 0, Cr || vn(vr, 8, this.length), be.read(this, vr, !0, 52, 8);
      }, we.prototype.readDoubleBE = function(vr, Cr) {
        return vr = vr >>> 0, Cr || vn(vr, 8, this.length), be.read(this, vr, !1, 52, 8);
      };
      function Cn(Pr, vr, Cr, yn, Pn, $n) {
        if (!we.isBuffer(Pr)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (vr > Pn || vr < $n) throw new RangeError('"value" argument is out of bounds');
        if (Cr + yn > Pr.length) throw new RangeError("Index out of range");
      }
      we.prototype.writeUintLE = we.prototype.writeUIntLE = function(vr, Cr, yn, Pn) {
        if (vr = +vr, Cr = Cr >>> 0, yn = yn >>> 0, !Pn) {
          const Ei = Math.pow(2, 8 * yn) - 1;
          Cn(this, vr, Cr, yn, Ei, 0);
        }
        let $n = 1, ui = 0;
        for (this[Cr] = vr & 255; ++ui < yn && ($n *= 256); )
          this[Cr + ui] = vr / $n & 255;
        return Cr + yn;
      }, we.prototype.writeUintBE = we.prototype.writeUIntBE = function(vr, Cr, yn, Pn) {
        if (vr = +vr, Cr = Cr >>> 0, yn = yn >>> 0, !Pn) {
          const Ei = Math.pow(2, 8 * yn) - 1;
          Cn(this, vr, Cr, yn, Ei, 0);
        }
        let $n = yn - 1, ui = 1;
        for (this[Cr + $n] = vr & 255; --$n >= 0 && (ui *= 256); )
          this[Cr + $n] = vr / ui & 255;
        return Cr + yn;
      }, we.prototype.writeUint8 = we.prototype.writeUInt8 = function(vr, Cr, yn) {
        return vr = +vr, Cr = Cr >>> 0, yn || Cn(this, vr, Cr, 1, 255, 0), this[Cr] = vr & 255, Cr + 1;
      }, we.prototype.writeUint16LE = we.prototype.writeUInt16LE = function(vr, Cr, yn) {
        return vr = +vr, Cr = Cr >>> 0, yn || Cn(this, vr, Cr, 2, 65535, 0), this[Cr] = vr & 255, this[Cr + 1] = vr >>> 8, Cr + 2;
      }, we.prototype.writeUint16BE = we.prototype.writeUInt16BE = function(vr, Cr, yn) {
        return vr = +vr, Cr = Cr >>> 0, yn || Cn(this, vr, Cr, 2, 65535, 0), this[Cr] = vr >>> 8, this[Cr + 1] = vr & 255, Cr + 2;
      }, we.prototype.writeUint32LE = we.prototype.writeUInt32LE = function(vr, Cr, yn) {
        return vr = +vr, Cr = Cr >>> 0, yn || Cn(this, vr, Cr, 4, 4294967295, 0), this[Cr + 3] = vr >>> 24, this[Cr + 2] = vr >>> 16, this[Cr + 1] = vr >>> 8, this[Cr] = vr & 255, Cr + 4;
      }, we.prototype.writeUint32BE = we.prototype.writeUInt32BE = function(vr, Cr, yn) {
        return vr = +vr, Cr = Cr >>> 0, yn || Cn(this, vr, Cr, 4, 4294967295, 0), this[Cr] = vr >>> 24, this[Cr + 1] = vr >>> 16, this[Cr + 2] = vr >>> 8, this[Cr + 3] = vr & 255, Cr + 4;
      };
      function Xr(Pr, vr, Cr, yn, Pn) {
        wn(vr, yn, Pn, Pr, Cr, 7);
        let $n = Number(vr & BigInt(4294967295));
        Pr[Cr++] = $n, $n = $n >> 8, Pr[Cr++] = $n, $n = $n >> 8, Pr[Cr++] = $n, $n = $n >> 8, Pr[Cr++] = $n;
        let ui = Number(vr >> BigInt(32) & BigInt(4294967295));
        return Pr[Cr++] = ui, ui = ui >> 8, Pr[Cr++] = ui, ui = ui >> 8, Pr[Cr++] = ui, ui = ui >> 8, Pr[Cr++] = ui, Cr;
      }
      function In(Pr, vr, Cr, yn, Pn) {
        wn(vr, yn, Pn, Pr, Cr, 7);
        let $n = Number(vr & BigInt(4294967295));
        Pr[Cr + 7] = $n, $n = $n >> 8, Pr[Cr + 6] = $n, $n = $n >> 8, Pr[Cr + 5] = $n, $n = $n >> 8, Pr[Cr + 4] = $n;
        let ui = Number(vr >> BigInt(32) & BigInt(4294967295));
        return Pr[Cr + 3] = ui, ui = ui >> 8, Pr[Cr + 2] = ui, ui = ui >> 8, Pr[Cr + 1] = ui, ui = ui >> 8, Pr[Cr] = ui, Cr + 8;
      }
      we.prototype.writeBigUInt64LE = Ls(function(vr, Cr = 0) {
        return Xr(this, vr, Cr, BigInt(0), BigInt("0xffffffffffffffff"));
      }), we.prototype.writeBigUInt64BE = Ls(function(vr, Cr = 0) {
        return In(this, vr, Cr, BigInt(0), BigInt("0xffffffffffffffff"));
      }), we.prototype.writeIntLE = function(vr, Cr, yn, Pn) {
        if (vr = +vr, Cr = Cr >>> 0, !Pn) {
          const zi = Math.pow(2, 8 * yn - 1);
          Cn(this, vr, Cr, yn, zi - 1, -zi);
        }
        let $n = 0, ui = 1, Ei = 0;
        for (this[Cr] = vr & 255; ++$n < yn && (ui *= 256); )
          vr < 0 && Ei === 0 && this[Cr + $n - 1] !== 0 && (Ei = 1), this[Cr + $n] = (vr / ui >> 0) - Ei & 255;
        return Cr + yn;
      }, we.prototype.writeIntBE = function(vr, Cr, yn, Pn) {
        if (vr = +vr, Cr = Cr >>> 0, !Pn) {
          const zi = Math.pow(2, 8 * yn - 1);
          Cn(this, vr, Cr, yn, zi - 1, -zi);
        }
        let $n = yn - 1, ui = 1, Ei = 0;
        for (this[Cr + $n] = vr & 255; --$n >= 0 && (ui *= 256); )
          vr < 0 && Ei === 0 && this[Cr + $n + 1] !== 0 && (Ei = 1), this[Cr + $n] = (vr / ui >> 0) - Ei & 255;
        return Cr + yn;
      }, we.prototype.writeInt8 = function(vr, Cr, yn) {
        return vr = +vr, Cr = Cr >>> 0, yn || Cn(this, vr, Cr, 1, 127, -128), vr < 0 && (vr = 255 + vr + 1), this[Cr] = vr & 255, Cr + 1;
      }, we.prototype.writeInt16LE = function(vr, Cr, yn) {
        return vr = +vr, Cr = Cr >>> 0, yn || Cn(this, vr, Cr, 2, 32767, -32768), this[Cr] = vr & 255, this[Cr + 1] = vr >>> 8, Cr + 2;
      }, we.prototype.writeInt16BE = function(vr, Cr, yn) {
        return vr = +vr, Cr = Cr >>> 0, yn || Cn(this, vr, Cr, 2, 32767, -32768), this[Cr] = vr >>> 8, this[Cr + 1] = vr & 255, Cr + 2;
      }, we.prototype.writeInt32LE = function(vr, Cr, yn) {
        return vr = +vr, Cr = Cr >>> 0, yn || Cn(this, vr, Cr, 4, 2147483647, -2147483648), this[Cr] = vr & 255, this[Cr + 1] = vr >>> 8, this[Cr + 2] = vr >>> 16, this[Cr + 3] = vr >>> 24, Cr + 4;
      }, we.prototype.writeInt32BE = function(vr, Cr, yn) {
        return vr = +vr, Cr = Cr >>> 0, yn || Cn(this, vr, Cr, 4, 2147483647, -2147483648), vr < 0 && (vr = 4294967295 + vr + 1), this[Cr] = vr >>> 24, this[Cr + 1] = vr >>> 16, this[Cr + 2] = vr >>> 8, this[Cr + 3] = vr & 255, Cr + 4;
      }, we.prototype.writeBigInt64LE = Ls(function(vr, Cr = 0) {
        return Xr(this, vr, Cr, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
      }), we.prototype.writeBigInt64BE = Ls(function(vr, Cr = 0) {
        return In(this, vr, Cr, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
      });
      function zr(Pr, vr, Cr, yn, Pn, $n) {
        if (Cr + yn > Pr.length) throw new RangeError("Index out of range");
        if (Cr < 0) throw new RangeError("Index out of range");
      }
      function En(Pr, vr, Cr, yn, Pn) {
        return vr = +vr, Cr = Cr >>> 0, Pn || zr(Pr, vr, Cr, 4), be.write(Pr, vr, Cr, yn, 23, 4), Cr + 4;
      }
      we.prototype.writeFloatLE = function(vr, Cr, yn) {
        return En(this, vr, Cr, !0, yn);
      }, we.prototype.writeFloatBE = function(vr, Cr, yn) {
        return En(this, vr, Cr, !1, yn);
      };
      function Zr(Pr, vr, Cr, yn, Pn) {
        return vr = +vr, Cr = Cr >>> 0, Pn || zr(Pr, vr, Cr, 8), be.write(Pr, vr, Cr, yn, 52, 8), Cr + 8;
      }
      we.prototype.writeDoubleLE = function(vr, Cr, yn) {
        return Zr(this, vr, Cr, !0, yn);
      }, we.prototype.writeDoubleBE = function(vr, Cr, yn) {
        return Zr(this, vr, Cr, !1, yn);
      }, we.prototype.copy = function(vr, Cr, yn, Pn) {
        if (!we.isBuffer(vr)) throw new TypeError("argument should be a Buffer");
        if (yn || (yn = 0), !Pn && Pn !== 0 && (Pn = this.length), Cr >= vr.length && (Cr = vr.length), Cr || (Cr = 0), Pn > 0 && Pn < yn && (Pn = yn), Pn === yn || vr.length === 0 || this.length === 0) return 0;
        if (Cr < 0)
          throw new RangeError("targetStart out of bounds");
        if (yn < 0 || yn >= this.length) throw new RangeError("Index out of range");
        if (Pn < 0) throw new RangeError("sourceEnd out of bounds");
        Pn > this.length && (Pn = this.length), vr.length - Cr < Pn - yn && (Pn = vr.length - Cr + yn);
        const $n = Pn - yn;
        return this === vr && typeof Qe.prototype.copyWithin == "function" ? this.copyWithin(Cr, yn, Pn) : Qe.prototype.set.call(
          vr,
          this.subarray(yn, Pn),
          Cr
        ), $n;
      }, we.prototype.fill = function(vr, Cr, yn, Pn) {
        if (typeof vr == "string") {
          if (typeof Cr == "string" ? (Pn = Cr, Cr = 0, yn = this.length) : typeof yn == "string" && (Pn = yn, yn = this.length), Pn !== void 0 && typeof Pn != "string")
            throw new TypeError("encoding must be a string");
          if (typeof Pn == "string" && !we.isEncoding(Pn))
            throw new TypeError("Unknown encoding: " + Pn);
          if (vr.length === 1) {
            const ui = vr.charCodeAt(0);
            (Pn === "utf8" && ui < 128 || Pn === "latin1") && (vr = ui);
          }
        } else typeof vr == "number" ? vr = vr & 255 : typeof vr == "boolean" && (vr = Number(vr));
        if (Cr < 0 || this.length < Cr || this.length < yn)
          throw new RangeError("Out of range index");
        if (yn <= Cr)
          return this;
        Cr = Cr >>> 0, yn = yn === void 0 ? this.length : yn >>> 0, vr || (vr = 0);
        let $n;
        if (typeof vr == "number")
          for ($n = Cr; $n < yn; ++$n)
            this[$n] = vr;
        else {
          const ui = we.isBuffer(vr) ? vr : we.from(vr, Pn), Ei = ui.length;
          if (Ei === 0)
            throw new TypeError('The value "' + vr + '" is invalid for argument "value"');
          for ($n = 0; $n < yn - Cr; ++$n)
            this[$n + Cr] = ui[$n % Ei];
        }
        return this;
      };
      const kr = {};
      function Rr(Pr, vr, Cr) {
        kr[Pr] = class extends Cr {
          constructor() {
            super(), Object.defineProperty(this, "message", {
              value: vr.apply(this, arguments),
              writable: !0,
              configurable: !0
            }), this.name = `${this.name} [${Pr}]`, this.stack, delete this.name;
          }
          get code() {
            return Pr;
          }
          set code(Pn) {
            Object.defineProperty(this, "code", {
              configurable: !0,
              enumerable: !0,
              value: Pn,
              writable: !0
            });
          }
          toString() {
            return `${this.name} [${Pr}]: ${this.message}`;
          }
        };
      }
      Rr(
        "ERR_BUFFER_OUT_OF_BOUNDS",
        function(Pr) {
          return Pr ? `${Pr} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
        },
        RangeError
      ), Rr(
        "ERR_INVALID_ARG_TYPE",
        function(Pr, vr) {
          return `The "${Pr}" argument must be of type number. Received type ${typeof vr}`;
        },
        TypeError
      ), Rr(
        "ERR_OUT_OF_RANGE",
        function(Pr, vr, Cr) {
          let yn = `The value of "${Pr}" is out of range.`, Pn = Cr;
          return Number.isInteger(Cr) && Math.abs(Cr) > 2 ** 32 ? Pn = Er(String(Cr)) : typeof Cr == "bigint" && (Pn = String(Cr), (Cr > BigInt(2) ** BigInt(32) || Cr < -(BigInt(2) ** BigInt(32))) && (Pn = Er(Pn)), Pn += "n"), yn += ` It must be ${vr}. Received ${Pn}`, yn;
        },
        RangeError
      );
      function Er(Pr) {
        let vr = "", Cr = Pr.length;
        const yn = Pr[0] === "-" ? 1 : 0;
        for (; Cr >= yn + 4; Cr -= 3)
          vr = `_${Pr.slice(Cr - 3, Cr)}${vr}`;
        return `${Pr.slice(0, Cr)}${vr}`;
      }
      function Or(Pr, vr, Cr) {
        Kn(vr, "offset"), (Pr[vr] === void 0 || Pr[vr + Cr] === void 0) && Ln(vr, Pr.length - (Cr + 1));
      }
      function wn(Pr, vr, Cr, yn, Pn, $n) {
        if (Pr > Cr || Pr < vr) {
          const ui = typeof vr == "bigint" ? "n" : "";
          let Ei;
          throw vr === 0 || vr === BigInt(0) ? Ei = `>= 0${ui} and < 2${ui} ** ${($n + 1) * 8}${ui}` : Ei = `>= -(2${ui} ** ${($n + 1) * 8 - 1}${ui}) and < 2 ** ${($n + 1) * 8 - 1}${ui}`, new kr.ERR_OUT_OF_RANGE("value", Ei, Pr);
        }
        Or(yn, Pn, $n);
      }
      function Kn(Pr, vr) {
        if (typeof Pr != "number")
          throw new kr.ERR_INVALID_ARG_TYPE(vr, "number", Pr);
      }
      function Ln(Pr, vr, Cr) {
        throw Math.floor(Pr) !== Pr ? (Kn(Pr, Cr), new kr.ERR_OUT_OF_RANGE("offset", "an integer", Pr)) : vr < 0 ? new kr.ERR_BUFFER_OUT_OF_BOUNDS() : new kr.ERR_OUT_OF_RANGE(
          "offset",
          `>= 0 and <= ${vr}`,
          Pr
        );
      }
      const Wn = /[^+/0-9A-Za-z-_]/g;
      function Sn(Pr) {
        if (Pr = Pr.split("=")[0], Pr = Pr.trim().replace(Wn, ""), Pr.length < 2) return "";
        for (; Pr.length % 4 !== 0; )
          Pr = Pr + "=";
        return Pr;
      }
      function hi(Pr, vr) {
        vr = vr || 1 / 0;
        let Cr;
        const yn = Pr.length;
        let Pn = null;
        const $n = [];
        for (let ui = 0; ui < yn; ++ui) {
          if (Cr = Pr.charCodeAt(ui), Cr > 55295 && Cr < 57344) {
            if (!Pn) {
              if (Cr > 56319) {
                (vr -= 3) > -1 && $n.push(239, 191, 189);
                continue;
              } else if (ui + 1 === yn) {
                (vr -= 3) > -1 && $n.push(239, 191, 189);
                continue;
              }
              Pn = Cr;
              continue;
            }
            if (Cr < 56320) {
              (vr -= 3) > -1 && $n.push(239, 191, 189), Pn = Cr;
              continue;
            }
            Cr = (Pn - 55296 << 10 | Cr - 56320) + 65536;
          } else Pn && (vr -= 3) > -1 && $n.push(239, 191, 189);
          if (Pn = null, Cr < 128) {
            if ((vr -= 1) < 0) break;
            $n.push(Cr);
          } else if (Cr < 2048) {
            if ((vr -= 2) < 0) break;
            $n.push(
              Cr >> 6 | 192,
              Cr & 63 | 128
            );
          } else if (Cr < 65536) {
            if ((vr -= 3) < 0) break;
            $n.push(
              Cr >> 12 | 224,
              Cr >> 6 & 63 | 128,
              Cr & 63 | 128
            );
          } else if (Cr < 1114112) {
            if ((vr -= 4) < 0) break;
            $n.push(
              Cr >> 18 | 240,
              Cr >> 12 & 63 | 128,
              Cr >> 6 & 63 | 128,
              Cr & 63 | 128
            );
          } else
            throw new Error("Invalid code point");
        }
        return $n;
      }
      function ki(Pr) {
        const vr = [];
        for (let Cr = 0; Cr < Pr.length; ++Cr)
          vr.push(Pr.charCodeAt(Cr) & 255);
        return vr;
      }
      function xi(Pr, vr) {
        let Cr, yn, Pn;
        const $n = [];
        for (let ui = 0; ui < Pr.length && !((vr -= 2) < 0); ++ui)
          Cr = Pr.charCodeAt(ui), yn = Cr >> 8, Pn = Cr % 256, $n.push(Pn), $n.push(yn);
        return $n;
      }
      function _i(Pr) {
        return Ie.toByteArray(Sn(Pr));
      }
      function Li(Pr, vr, Cr, yn) {
        let Pn;
        for (Pn = 0; Pn < yn && !(Pn + Cr >= vr.length || Pn >= Pr.length); ++Pn)
          vr[Pn + Cr] = Pr[Pn];
        return Pn;
      }
      function ms(Pr, vr) {
        return Pr instanceof vr || Pr != null && Pr.constructor != null && Pr.constructor.name != null && Pr.constructor.name === vr.name;
      }
      function Ui(Pr) {
        return Pr !== Pr;
      }
      const Mi = function() {
        const Pr = "0123456789abcdef", vr = new Array(256);
        for (let Cr = 0; Cr < 16; ++Cr) {
          const yn = Cr * 16;
          for (let Pn = 0; Pn < 16; ++Pn)
            vr[yn + Pn] = Pr[Cr] + Pr[Pn];
        }
        return vr;
      }();
      function Ls(Pr) {
        return typeof BigInt > "u" ? Ds : Pr;
      }
      function Ds() {
        throw new Error("BigInt not supported");
      }
    })(A);
    const ge = A.Buffer;
    s.Blob = A.Blob, s.BlobOptions = A.BlobOptions, s.Buffer = A.Buffer, s.File = A.File, s.FileOptions = A.FileOptions, s.INSPECT_MAX_BYTES = A.INSPECT_MAX_BYTES, s.SlowBuffer = A.SlowBuffer, s.TranscodeEncoding = A.TranscodeEncoding, s.atob = A.atob, s.btoa = A.btoa, s.constants = A.constants, s.default = ge, s.isAscii = A.isAscii, s.isUtf8 = A.isUtf8, s.kMaxLength = A.kMaxLength, s.kStringMaxLength = A.kStringMaxLength, s.resolveObjectURL = A.resolveObjectURL, s.transcode = A.transcode;
  }(dist$n)), dist$n;
}
var native$3, hasRequiredNative$2;
function requireNative$2() {
  if (hasRequiredNative$2) return native$3;
  hasRequiredNative$2 = 1;
  var s = {
    Array: function(u) {
      return u != null && u.constructor === Array;
    },
    Boolean: function(u) {
      return typeof u == "boolean";
    },
    Function: function(u) {
      return typeof u == "function";
    },
    Nil: function(u) {
      return u == null;
    },
    Number: function(u) {
      return typeof u == "number";
    },
    Object: function(u) {
      return typeof u == "object";
    },
    String: function(u) {
      return typeof u == "string";
    },
    "": function() {
      return !0;
    }
  };
  s.Null = s.Nil;
  for (var A in s)
    s[A].toJSON = (function(u) {
      return u;
    }).bind(null, A);
  return native$3 = s, native$3;
}
var errors$5, hasRequiredErrors$5;
function requireErrors$5() {
  if (hasRequiredErrors$5) return errors$5;
  hasRequiredErrors$5 = 1;
  var s = requireNative$2();
  function A(P) {
    return P.name || P.toString().match(/function (.*?)\s*\(/)[1];
  }
  function u(P) {
    return s.Nil(P) ? "" : A(P.constructor);
  }
  function p(P) {
    return s.Function(P) ? "" : s.String(P) ? JSON.stringify(P) : P && s.Object(P) ? "" : P;
  }
  function t(P, x) {
    Error.captureStackTrace && Error.captureStackTrace(P, x);
  }
  function l(P) {
    return s.Function(P) ? P.toJSON ? P.toJSON() : A(P) : s.Array(P) ? "Array" : P && s.Object(P) ? "Object" : P !== void 0 ? P : "";
  }
  function m(P, x, M) {
    var F = p(x);
    return "Expected " + l(P) + ", got" + (M !== "" ? " " + M : "") + (F !== "" ? " " + F : "");
  }
  function b(P, x, M) {
    M = M || u(x), this.message = m(P, x, M), t(this, b), this.__type = P, this.__value = x, this.__valueTypeName = M;
  }
  b.prototype = Object.create(Error.prototype), b.prototype.constructor = b;
  function k(P, x, M, F, le) {
    var ge = '" of type ';
    return x === "key" && (ge = '" with key type '), m('property "' + l(M) + ge + l(P), F, le);
  }
  function C(P, x, M, F, le) {
    P ? (le = le || u(F), this.message = k(P, M, x, F, le)) : this.message = 'Unexpected property "' + x + '"', t(this, b), this.__label = M, this.__property = x, this.__type = P, this.__value = F, this.__valueTypeName = le;
  }
  C.prototype = Object.create(Error.prototype), C.prototype.constructor = b;
  function B(P, x) {
    return new b(P, {}, x);
  }
  function Q(P, x, M) {
    return P instanceof C ? (x = x + "." + P.__property, P = new C(
      P.__type,
      x,
      P.__label,
      P.__value,
      P.__valueTypeName
    )) : P instanceof b && (P = new C(
      P.__type,
      x,
      M,
      P.__value,
      P.__valueTypeName
    )), t(P), P;
  }
  return errors$5 = {
    TfTypeError: b,
    TfPropertyTypeError: C,
    tfCustomError: B,
    tfSubError: Q,
    tfJSON: l,
    getValueTypeName: u
  }, errors$5;
}
var extra, hasRequiredExtra;
function requireExtra() {
  if (hasRequiredExtra) return extra;
  hasRequiredExtra = 1;
  var s = requireNative$2(), A = requireErrors$5();
  function u(Te) {
    return Buffer.isBuffer(Te);
  }
  function p(Te) {
    return typeof Te == "string" && /^([0-9a-f]{2})+$/i.test(Te);
  }
  function t(Te, Qe) {
    var xe = Te.toJSON();
    function Ee(He) {
      if (!Te(He)) return !1;
      if (He.length === Qe) return !0;
      throw A.tfCustomError(xe + "(Length: " + Qe + ")", xe + "(Length: " + He.length + ")");
    }
    return Ee.toJSON = function() {
      return xe;
    }, Ee;
  }
  var l = t.bind(null, s.Array), m = t.bind(null, u), b = t.bind(null, p), k = t.bind(null, s.String);
  function C(Te, Qe, xe) {
    xe = xe || s.Number;
    function Ee(He, ve) {
      return xe(He, ve) && He > Te && He < Qe;
    }
    return Ee.toJSON = function() {
      return `${xe.toJSON()} between [${Te}, ${Qe}]`;
    }, Ee;
  }
  var B = Math.pow(2, 53) - 1;
  function Q(Te) {
    return typeof Te == "number" && isFinite(Te);
  }
  function P(Te) {
    return Te << 24 >> 24 === Te;
  }
  function x(Te) {
    return Te << 16 >> 16 === Te;
  }
  function M(Te) {
    return (Te | 0) === Te;
  }
  function F(Te) {
    return typeof Te == "number" && Te >= -B && Te <= B && Math.floor(Te) === Te;
  }
  function le(Te) {
    return (Te & 255) === Te;
  }
  function ge(Te) {
    return (Te & 65535) === Te;
  }
  function pe(Te) {
    return Te >>> 0 === Te;
  }
  function Ie(Te) {
    return typeof Te == "number" && Te >= 0 && Te <= B && Math.floor(Te) === Te;
  }
  var be = {
    ArrayN: l,
    Buffer: u,
    BufferN: m,
    Finite: Q,
    Hex: p,
    HexN: b,
    Int8: P,
    Int16: x,
    Int32: M,
    Int53: F,
    Range: C,
    StringN: k,
    UInt8: le,
    UInt16: ge,
    UInt32: pe,
    UInt53: Ie
  };
  for (var Pe in be)
    be[Pe].toJSON = (function(Te) {
      return Te;
    }).bind(null, Pe);
  return extra = be, extra;
}
var typeforce_1, hasRequiredTypeforce;
function requireTypeforce() {
  if (hasRequiredTypeforce) return typeforce_1;
  hasRequiredTypeforce = 1;
  var s = requireErrors$5(), A = requireNative$2(), u = s.tfJSON, p = s.TfTypeError, t = s.TfPropertyTypeError, l = s.tfSubError, m = s.getValueTypeName, b = {
    arrayOf: function(x, M) {
      x = k(x), M = M || {};
      function F(le, ge) {
        return !A.Array(le) || A.Nil(le) || M.minLength !== void 0 && le.length < M.minLength || M.maxLength !== void 0 && le.length > M.maxLength || M.length !== void 0 && le.length !== M.length ? !1 : le.every(function(pe, Ie) {
          try {
            return C(x, pe, ge);
          } catch (be) {
            throw l(be, Ie);
          }
        });
      }
      return F.toJSON = function() {
        var le = "[" + u(x) + "]";
        return M.length !== void 0 ? le += "{" + M.length + "}" : (M.minLength !== void 0 || M.maxLength !== void 0) && (le += "{" + (M.minLength === void 0 ? 0 : M.minLength) + "," + (M.maxLength === void 0 ? 1 / 0 : M.maxLength) + "}"), le;
      }, F;
    },
    maybe: function P(x) {
      x = k(x);
      function M(F, le) {
        return A.Nil(F) || x(F, le, P);
      }
      return M.toJSON = function() {
        return "?" + u(x);
      }, M;
    },
    map: function(x, M) {
      x = k(x), M && (M = k(M));
      function F(le, ge) {
        if (!A.Object(le) || A.Nil(le)) return !1;
        for (var pe in le) {
          try {
            M && C(M, pe, ge);
          } catch (be) {
            throw l(be, pe, "key");
          }
          try {
            var Ie = le[pe];
            C(x, Ie, ge);
          } catch (be) {
            throw l(be, pe);
          }
        }
        return !0;
      }
      return M ? F.toJSON = function() {
        return "{" + u(M) + ": " + u(x) + "}";
      } : F.toJSON = function() {
        return "{" + u(x) + "}";
      }, F;
    },
    object: function(x) {
      var M = {};
      for (var F in x)
        M[F] = k(x[F]);
      function le(ge, pe) {
        if (!A.Object(ge) || A.Nil(ge)) return !1;
        var Ie;
        try {
          for (Ie in M) {
            var be = M[Ie], Pe = ge[Ie];
            C(be, Pe, pe);
          }
        } catch (Te) {
          throw l(Te, Ie);
        }
        if (pe) {
          for (Ie in ge)
            if (!M[Ie])
              throw new t(void 0, Ie);
        }
        return !0;
      }
      return le.toJSON = function() {
        return u(M);
      }, le;
    },
    anyOf: function() {
      var x = [].slice.call(arguments).map(k);
      function M(F, le) {
        return x.some(function(ge) {
          try {
            return C(ge, F, le);
          } catch {
            return !1;
          }
        });
      }
      return M.toJSON = function() {
        return x.map(u).join("|");
      }, M;
    },
    allOf: function() {
      var x = [].slice.call(arguments).map(k);
      function M(F, le) {
        return x.every(function(ge) {
          try {
            return C(ge, F, le);
          } catch {
            return !1;
          }
        });
      }
      return M.toJSON = function() {
        return x.map(u).join(" & ");
      }, M;
    },
    quacksLike: function(x) {
      function M(F) {
        return x === m(F);
      }
      return M.toJSON = function() {
        return x;
      }, M;
    },
    tuple: function() {
      var x = [].slice.call(arguments).map(k);
      function M(F, le) {
        return A.Nil(F) || A.Nil(F.length) || le && F.length !== x.length ? !1 : x.every(function(ge, pe) {
          try {
            return C(ge, F[pe], le);
          } catch (Ie) {
            throw l(Ie, pe);
          }
        });
      }
      return M.toJSON = function() {
        return "(" + x.map(u).join(", ") + ")";
      }, M;
    },
    value: function(x) {
      function M(F) {
        return F === x;
      }
      return M.toJSON = function() {
        return x;
      }, M;
    }
  };
  b.oneOf = b.anyOf;
  function k(P) {
    if (A.String(P))
      return P[0] === "?" ? b.maybe(P.slice(1)) : A[P] || b.quacksLike(P);
    if (P && A.Object(P)) {
      if (A.Array(P)) {
        if (P.length !== 1) throw new TypeError("Expected compile() parameter of type Array of length 1");
        return b.arrayOf(P[0]);
      }
      return b.object(P);
    } else if (A.Function(P))
      return P;
    return b.value(P);
  }
  function C(P, x, M, F) {
    if (A.Function(P)) {
      if (P(x, M)) return !0;
      throw new p(F || P, x);
    }
    return C(k(P), x, M);
  }
  for (var B in A)
    C[B] = A[B];
  for (B in b)
    C[B] = b[B];
  var Q = requireExtra();
  for (B in Q)
    C[B] = Q[B];
  return C.compile = k, C.TfTypeError = p, C.TfPropertyTypeError = t, typeforce_1 = C, typeforce_1;
}
var hasRequiredTypes$9;
function requireTypes$9() {
  return hasRequiredTypes$9 || (hasRequiredTypes$9 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.oneOf = s.Null = s.BufferN = s.Function = s.UInt32 = s.UInt8 = s.tuple = s.maybe = s.Hex = s.Buffer = s.String = s.Boolean = s.Array = s.Number = s.Hash256bit = s.Hash160bit = s.Buffer256bit = s.isTaptree = s.isTapleaf = s.TAPLEAF_VERSION_MASK = s.Satoshi = s.isPoint = s.stacksEqual = s.typeforce = void 0;
    const A = requireDist$n();
    s.typeforce = requireTypeforce();
    const u = A.Buffer.alloc(32, 0), p = A.Buffer.from(
      "fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f",
      "hex"
    );
    function t(B, Q) {
      return B.length !== Q.length ? !1 : B.every((P, x) => P.equals(Q[x]));
    }
    s.stacksEqual = t;
    function l(B) {
      if (!A.Buffer.isBuffer(B) || B.length < 33) return !1;
      const Q = B[0], P = B.slice(1, 33);
      if (P.compare(u) === 0 || P.compare(p) >= 0) return !1;
      if ((Q === 2 || Q === 3) && B.length === 33)
        return !0;
      const x = B.slice(33);
      return x.compare(u) === 0 || x.compare(p) >= 0 ? !1 : Q === 4 && B.length === 65;
    }
    s.isPoint = l;
    const m = 21 * 1e14;
    function b(B) {
      return s.typeforce.UInt53(B) && B <= m;
    }
    s.Satoshi = b, s.TAPLEAF_VERSION_MASK = 254;
    function k(B) {
      return !B || !("output" in B) || !A.Buffer.isBuffer(B.output) ? !1 : B.version !== void 0 ? (B.version & s.TAPLEAF_VERSION_MASK) === B.version : !0;
    }
    s.isTapleaf = k;
    function C(B) {
      return (0, s.Array)(B) ? B.length !== 2 ? !1 : B.every((Q) => C(Q)) : k(B);
    }
    s.isTaptree = C, s.Buffer256bit = s.typeforce.BufferN(32), s.Hash160bit = s.typeforce.BufferN(20), s.Hash256bit = s.typeforce.BufferN(32), s.Number = s.typeforce.Number, s.Array = s.typeforce.Array, s.Boolean = s.typeforce.Boolean, s.String = s.typeforce.String, s.Buffer = s.typeforce.Buffer, s.Hex = s.typeforce.Hex, s.maybe = s.typeforce.maybe, s.tuple = s.typeforce.tuple, s.UInt8 = s.typeforce.UInt8, s.UInt32 = s.typeforce.UInt32, s.Function = s.typeforce.Function, s.BufferN = s.typeforce.BufferN, s.Null = s.typeforce.Null, s.oneOf = s.typeforce.oneOf;
  }(types$9)), types$9;
}
var hasRequiredScript_signature;
function requireScript_signature() {
  if (hasRequiredScript_signature) return script_signature;
  hasRequiredScript_signature = 1, Object.defineProperty(script_signature, "__esModule", { value: !0 }), script_signature.encode = script_signature.decode = void 0;
  const s = requireBip66(), A = requireScript$1(), u = requireTypes$9(), { typeforce: p } = u, t = Buffer.alloc(1, 0);
  function l(C) {
    let B = 0;
    for (; C[B] === 0; ) ++B;
    return B === C.length ? t : (C = C.slice(B), C[0] & 128 ? Buffer.concat([t, C], 1 + C.length) : C);
  }
  function m(C) {
    C[0] === 0 && (C = C.slice(1));
    const B = Buffer.alloc(32, 0), Q = Math.max(0, 32 - C.length);
    return C.copy(B, Q), B;
  }
  function b(C) {
    const B = C.readUInt8(C.length - 1);
    if (!(0, A.isDefinedHashType)(B))
      throw new Error("Invalid hashType " + B);
    const Q = s.decode(C.slice(0, -1)), P = m(Q.r), x = m(Q.s);
    return { signature: Buffer.concat([P, x], 64), hashType: B };
  }
  script_signature.decode = b;
  function k(C, B) {
    if (p(
      {
        signature: u.BufferN(64),
        hashType: u.UInt8
      },
      { signature: C, hashType: B }
    ), !(0, A.isDefinedHashType)(B))
      throw new Error("Invalid hashType " + B);
    const Q = Buffer.allocUnsafe(1);
    Q.writeUInt8(B, 0);
    const P = l(C.slice(0, 32)), x = l(C.slice(32, 64));
    return Buffer.concat([s.encode(P, x), Q]);
  }
  return script_signature.encode = k, script_signature;
}
var hasRequiredScript$1;
function requireScript$1() {
  return hasRequiredScript$1 || (hasRequiredScript$1 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.signature = s.number = s.isCanonicalScriptSignature = s.isDefinedHashType = s.isCanonicalPubKey = s.toStack = s.fromASM = s.toASM = s.decompile = s.compile = s.countNonPushOnlyOPs = s.isPushOnly = s.OPS = void 0;
    const A = requireBip66(), u = requireOps();
    Object.defineProperty(s, "OPS", {
      enumerable: !0,
      get: function() {
        return u.OPS;
      }
    });
    const p = requirePush_data(), t = requireScript_number(), l = requireScript_signature(), m = requireTypes$9(), { typeforce: b } = m, k = u.OPS.OP_RESERVED;
    function C(Ee) {
      return m.Number(Ee) && (Ee === u.OPS.OP_0 || Ee >= u.OPS.OP_1 && Ee <= u.OPS.OP_16 || Ee === u.OPS.OP_1NEGATE);
    }
    function B(Ee) {
      return m.Buffer(Ee) || C(Ee);
    }
    function Q(Ee) {
      return m.Array(Ee) && Ee.every(B);
    }
    s.isPushOnly = Q;
    function P(Ee) {
      return Ee.length - Ee.filter(B).length;
    }
    s.countNonPushOnlyOPs = P;
    function x(Ee) {
      if (Ee.length === 0) return u.OPS.OP_0;
      if (Ee.length === 1) {
        if (Ee[0] >= 1 && Ee[0] <= 16) return k + Ee[0];
        if (Ee[0] === 129) return u.OPS.OP_1NEGATE;
      }
    }
    function M(Ee) {
      return Buffer.isBuffer(Ee);
    }
    function F(Ee) {
      return m.Array(Ee);
    }
    function le(Ee) {
      return Buffer.isBuffer(Ee);
    }
    function ge(Ee) {
      if (M(Ee)) return Ee;
      b(m.Array, Ee);
      const He = Ee.reduce((Ce, Se) => le(Se) ? Se.length === 1 && x(Se) !== void 0 ? Ce + 1 : Ce + p.encodingLength(Se.length) + Se.length : Ce + 1, 0), ve = Buffer.allocUnsafe(He);
      let we = 0;
      if (Ee.forEach((Ce) => {
        if (le(Ce)) {
          const Se = x(Ce);
          if (Se !== void 0) {
            ve.writeUInt8(Se, we), we += 1;
            return;
          }
          we += p.encode(ve, Ce.length, we), Ce.copy(ve, we), we += Ce.length;
        } else
          ve.writeUInt8(Ce, we), we += 1;
      }), we !== ve.length) throw new Error("Could not decode chunks");
      return ve;
    }
    s.compile = ge;
    function pe(Ee) {
      if (F(Ee)) return Ee;
      b(m.Buffer, Ee);
      const He = [];
      let ve = 0;
      for (; ve < Ee.length; ) {
        const we = Ee[ve];
        if (we > u.OPS.OP_0 && we <= u.OPS.OP_PUSHDATA4) {
          const Ce = p.decode(Ee, ve);
          if (Ce === null || (ve += Ce.size, ve + Ce.number > Ee.length)) return null;
          const Se = Ee.slice(ve, ve + Ce.number);
          ve += Ce.number;
          const Ne = x(Se);
          Ne !== void 0 ? He.push(Ne) : He.push(Se);
        } else
          He.push(we), ve += 1;
      }
      return He;
    }
    s.decompile = pe;
    function Ie(Ee) {
      if (M(Ee) && (Ee = pe(Ee)), !Ee)
        throw new Error("Could not convert invalid chunks to ASM");
      return Ee.map((He) => {
        if (le(He)) {
          const ve = x(He);
          if (ve === void 0) return He.toString("hex");
          He = ve;
        }
        return u.REVERSE_OPS[He];
      }).join(" ");
    }
    s.toASM = Ie;
    function be(Ee) {
      return b(m.String, Ee), ge(
        Ee.split(" ").map((He) => u.OPS[He] !== void 0 ? u.OPS[He] : (b(m.Hex, He), Buffer.from(He, "hex")))
      );
    }
    s.fromASM = be;
    function Pe(Ee) {
      return Ee = pe(Ee), b(Q, Ee), Ee.map((He) => le(He) ? He : He === u.OPS.OP_0 ? Buffer.allocUnsafe(0) : t.encode(He - k));
    }
    s.toStack = Pe;
    function Te(Ee) {
      return m.isPoint(Ee);
    }
    s.isCanonicalPubKey = Te;
    function Qe(Ee) {
      const He = Ee & -129;
      return He > 0 && He < 4;
    }
    s.isDefinedHashType = Qe;
    function xe(Ee) {
      return !Buffer.isBuffer(Ee) || !Qe(Ee[Ee.length - 1]) ? !1 : A.check(Ee.slice(0, -1));
    }
    s.isCanonicalScriptSignature = xe, s.number = t, s.signature = l;
  }(script$1)), script$1;
}
var lazy = {}, hasRequiredLazy;
function requireLazy() {
  if (hasRequiredLazy) return lazy;
  hasRequiredLazy = 1, Object.defineProperty(lazy, "__esModule", { value: !0 }), lazy.value = lazy.prop = void 0;
  function s(u, p, t) {
    Object.defineProperty(u, p, {
      configurable: !0,
      enumerable: !0,
      get() {
        const l = t.call(this);
        return this[p] = l, l;
      },
      set(l) {
        Object.defineProperty(this, p, {
          configurable: !0,
          enumerable: !0,
          value: l,
          writable: !0
        });
      }
    });
  }
  lazy.prop = s;
  function A(u) {
    let p;
    return () => (p !== void 0 || (p = u()), p);
  }
  return lazy.value = A, lazy;
}
var hasRequiredEmbed;
function requireEmbed() {
  if (hasRequiredEmbed) return embed;
  hasRequiredEmbed = 1, Object.defineProperty(embed, "__esModule", { value: !0 }), embed.p2data = void 0;
  const s = requireNetworks$1(), A = requireScript$1(), u = requireTypes$9(), p = requireLazy(), t = A.OPS;
  function l(m, b) {
    if (!m.data && !m.output) throw new TypeError("Not enough data");
    b = Object.assign({ validate: !0 }, b || {}), (0, u.typeforce)(
      {
        network: u.typeforce.maybe(u.typeforce.Object),
        output: u.typeforce.maybe(u.typeforce.Buffer),
        data: u.typeforce.maybe(
          u.typeforce.arrayOf(u.typeforce.Buffer)
        )
      },
      m
    );
    const C = { name: "embed", network: m.network || s.bitcoin };
    if (p.prop(C, "output", () => {
      if (m.data)
        return A.compile([t.OP_RETURN].concat(m.data));
    }), p.prop(C, "data", () => {
      if (m.output)
        return A.decompile(m.output).slice(1);
    }), b.validate && m.output) {
      const B = A.decompile(m.output);
      if (B[0] !== t.OP_RETURN) throw new TypeError("Output is invalid");
      if (!B.slice(1).every(u.typeforce.Buffer))
        throw new TypeError("Output is invalid");
      if (m.data && !(0, u.stacksEqual)(m.data, C.data))
        throw new TypeError("Data mismatch");
    }
    return Object.assign(C, m);
  }
  return embed.p2data = l, embed;
}
var p2ms = {}, hasRequiredP2ms;
function requireP2ms() {
  if (hasRequiredP2ms) return p2ms;
  hasRequiredP2ms = 1, Object.defineProperty(p2ms, "__esModule", { value: !0 }), p2ms.p2ms = void 0;
  const s = requireNetworks$1(), A = requireScript$1(), u = requireTypes$9(), p = requireLazy(), t = A.OPS, l = t.OP_RESERVED;
  function m(b, k) {
    if (!b.input && !b.output && !(b.pubkeys && b.m !== void 0) && !b.signatures)
      throw new TypeError("Not enough data");
    k = Object.assign({ validate: !0 }, k || {});
    function C(F) {
      return A.isCanonicalScriptSignature(F) || (k.allowIncomplete && F === t.OP_0) !== void 0;
    }
    (0, u.typeforce)(
      {
        network: u.typeforce.maybe(u.typeforce.Object),
        m: u.typeforce.maybe(u.typeforce.Number),
        n: u.typeforce.maybe(u.typeforce.Number),
        output: u.typeforce.maybe(u.typeforce.Buffer),
        pubkeys: u.typeforce.maybe(
          u.typeforce.arrayOf(u.isPoint)
        ),
        signatures: u.typeforce.maybe(
          u.typeforce.arrayOf(C)
        ),
        input: u.typeforce.maybe(u.typeforce.Buffer)
      },
      b
    );
    const Q = { network: b.network || s.bitcoin };
    let P = [], x = !1;
    function M(F) {
      x || (x = !0, P = A.decompile(F), Q.m = P[0] - l, Q.n = P[P.length - 2] - l, Q.pubkeys = P.slice(1, -2));
    }
    if (p.prop(Q, "output", () => {
      if (b.m && Q.n && b.pubkeys)
        return A.compile(
          [].concat(
            l + b.m,
            b.pubkeys,
            l + Q.n,
            t.OP_CHECKMULTISIG
          )
        );
    }), p.prop(Q, "m", () => {
      if (Q.output)
        return M(Q.output), Q.m;
    }), p.prop(Q, "n", () => {
      if (Q.pubkeys)
        return Q.pubkeys.length;
    }), p.prop(Q, "pubkeys", () => {
      if (b.output)
        return M(b.output), Q.pubkeys;
    }), p.prop(Q, "signatures", () => {
      if (b.input)
        return A.decompile(b.input).slice(1);
    }), p.prop(Q, "input", () => {
      if (b.signatures)
        return A.compile([t.OP_0].concat(b.signatures));
    }), p.prop(Q, "witness", () => {
      if (Q.input)
        return [];
    }), p.prop(Q, "name", () => {
      if (!(!Q.m || !Q.n))
        return `p2ms(${Q.m} of ${Q.n})`;
    }), k.validate) {
      if (b.output) {
        if (M(b.output), !u.typeforce.Number(P[0]))
          throw new TypeError("Output is invalid");
        if (!u.typeforce.Number(P[P.length - 2]))
          throw new TypeError("Output is invalid");
        if (P[P.length - 1] !== t.OP_CHECKMULTISIG)
          throw new TypeError("Output is invalid");
        if (Q.m <= 0 || Q.n > 16 || Q.m > Q.n || Q.n !== P.length - 3)
          throw new TypeError("Output is invalid");
        if (!Q.pubkeys.every((F) => (0, u.isPoint)(F)))
          throw new TypeError("Output is invalid");
        if (b.m !== void 0 && b.m !== Q.m) throw new TypeError("m mismatch");
        if (b.n !== void 0 && b.n !== Q.n) throw new TypeError("n mismatch");
        if (b.pubkeys && !(0, u.stacksEqual)(b.pubkeys, Q.pubkeys))
          throw new TypeError("Pubkeys mismatch");
      }
      if (b.pubkeys) {
        if (b.n !== void 0 && b.n !== b.pubkeys.length)
          throw new TypeError("Pubkey count mismatch");
        if (Q.n = b.pubkeys.length, Q.n < Q.m) throw new TypeError("Pubkey count cannot be less than m");
      }
      if (b.signatures) {
        if (b.signatures.length < Q.m)
          throw new TypeError("Not enough signatures provided");
        if (b.signatures.length > Q.m)
          throw new TypeError("Too many signatures provided");
      }
      if (b.input) {
        if (b.input[0] !== t.OP_0) throw new TypeError("Input is invalid");
        if (Q.signatures.length === 0 || !Q.signatures.every(C))
          throw new TypeError("Input has invalid signature(s)");
        if (b.signatures && !(0, u.stacksEqual)(b.signatures, Q.signatures))
          throw new TypeError("Signature mismatch");
        if (b.m !== void 0 && b.m !== b.signatures.length)
          throw new TypeError("Signature count mismatch");
      }
    }
    return Object.assign(Q, b);
  }
  return p2ms.p2ms = m, p2ms;
}
var p2pk = {}, hasRequiredP2pk;
function requireP2pk() {
  if (hasRequiredP2pk) return p2pk;
  hasRequiredP2pk = 1, Object.defineProperty(p2pk, "__esModule", { value: !0 }), p2pk.p2pk = void 0;
  const s = requireNetworks$1(), A = requireScript$1(), u = requireTypes$9(), p = requireLazy(), t = A.OPS;
  function l(m, b) {
    if (!m.input && !m.output && !m.pubkey && !m.input && !m.signature)
      throw new TypeError("Not enough data");
    b = Object.assign({ validate: !0 }, b || {}), (0, u.typeforce)(
      {
        network: u.typeforce.maybe(u.typeforce.Object),
        output: u.typeforce.maybe(u.typeforce.Buffer),
        pubkey: u.typeforce.maybe(u.isPoint),
        signature: u.typeforce.maybe(A.isCanonicalScriptSignature),
        input: u.typeforce.maybe(u.typeforce.Buffer)
      },
      m
    );
    const k = p.value(() => A.decompile(m.input)), B = { name: "p2pk", network: m.network || s.bitcoin };
    if (p.prop(B, "output", () => {
      if (m.pubkey)
        return A.compile([m.pubkey, t.OP_CHECKSIG]);
    }), p.prop(B, "pubkey", () => {
      if (m.output)
        return m.output.slice(1, -1);
    }), p.prop(B, "signature", () => {
      if (m.input)
        return k()[0];
    }), p.prop(B, "input", () => {
      if (m.signature)
        return A.compile([m.signature]);
    }), p.prop(B, "witness", () => {
      if (B.input)
        return [];
    }), b.validate) {
      if (m.output) {
        if (m.output[m.output.length - 1] !== t.OP_CHECKSIG)
          throw new TypeError("Output is invalid");
        if (!(0, u.isPoint)(B.pubkey))
          throw new TypeError("Output pubkey is invalid");
        if (m.pubkey && !m.pubkey.equals(B.pubkey))
          throw new TypeError("Pubkey mismatch");
      }
      if (m.signature && m.input && !m.input.equals(B.input))
        throw new TypeError("Signature mismatch");
      if (m.input) {
        if (k().length !== 1) throw new TypeError("Input is invalid");
        if (!A.isCanonicalScriptSignature(B.signature))
          throw new TypeError("Input has invalid signature");
      }
    }
    return Object.assign(B, m);
  }
  return p2pk.p2pk = l, p2pk;
}
var p2pkh = {}, crypto$7 = {}, ripemd160$5 = {}, legacy$1 = {}, _md$1 = {}, utils$l = {}, crypto$6 = {}, hasRequiredCrypto$4;
function requireCrypto$4() {
  return hasRequiredCrypto$4 || (hasRequiredCrypto$4 = 1, Object.defineProperty(crypto$6, "__esModule", { value: !0 }), crypto$6.crypto = void 0, crypto$6.crypto = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0), crypto$6;
}
var hasRequiredUtils$j;
function requireUtils$j() {
  return hasRequiredUtils$j || (hasRequiredUtils$j = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.wrapXOFConstructorWithOpts = s.wrapConstructorWithOpts = s.wrapConstructor = s.Hash = s.nextTick = s.swap32IfBE = s.byteSwapIfBE = s.swap8IfBE = s.isLE = void 0, s.isBytes = u, s.anumber = p, s.abytes = t, s.ahash = l, s.aexists = m, s.aoutput = b, s.u8 = k, s.u32 = C, s.clean = B, s.createView = Q, s.rotr = P, s.rotl = x, s.byteSwap = M, s.byteSwap32 = F, s.bytesToHex = pe, s.hexToBytes = Pe, s.asyncLoop = Qe, s.utf8ToBytes = xe, s.bytesToUtf8 = Ee, s.toBytes = He, s.kdfInputToBytes = ve, s.concatBytes = we, s.checkOpts = Ce, s.createHasher = Ne, s.createOptHasher = rr, s.createXOFer = er, s.randomBytes = ir;
    const A = /* @__PURE__ */ requireCrypto$4();
    function u(sr) {
      return sr instanceof Uint8Array || ArrayBuffer.isView(sr) && sr.constructor.name === "Uint8Array";
    }
    function p(sr) {
      if (!Number.isSafeInteger(sr) || sr < 0)
        throw new Error("positive integer expected, got " + sr);
    }
    function t(sr, ...nr) {
      if (!u(sr))
        throw new Error("Uint8Array expected");
      if (nr.length > 0 && !nr.includes(sr.length))
        throw new Error("Uint8Array expected of length " + nr + ", got length=" + sr.length);
    }
    function l(sr) {
      if (typeof sr != "function" || typeof sr.create != "function")
        throw new Error("Hash should be wrapped by utils.createHasher");
      p(sr.outputLen), p(sr.blockLen);
    }
    function m(sr, nr = !0) {
      if (sr.destroyed)
        throw new Error("Hash instance has been destroyed");
      if (nr && sr.finished)
        throw new Error("Hash#digest() has already been called");
    }
    function b(sr, nr) {
      t(sr);
      const fr = nr.outputLen;
      if (sr.length < fr)
        throw new Error("digestInto() expects output buffer of length at least " + fr);
    }
    function k(sr) {
      return new Uint8Array(sr.buffer, sr.byteOffset, sr.byteLength);
    }
    function C(sr) {
      return new Uint32Array(sr.buffer, sr.byteOffset, Math.floor(sr.byteLength / 4));
    }
    function B(...sr) {
      for (let nr = 0; nr < sr.length; nr++)
        sr[nr].fill(0);
    }
    function Q(sr) {
      return new DataView(sr.buffer, sr.byteOffset, sr.byteLength);
    }
    function P(sr, nr) {
      return sr << 32 - nr | sr >>> nr;
    }
    function x(sr, nr) {
      return sr << nr | sr >>> 32 - nr >>> 0;
    }
    s.isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
    function M(sr) {
      return sr << 24 & 4278190080 | sr << 8 & 16711680 | sr >>> 8 & 65280 | sr >>> 24 & 255;
    }
    s.swap8IfBE = s.isLE ? (sr) => sr : (sr) => M(sr), s.byteSwapIfBE = s.swap8IfBE;
    function F(sr) {
      for (let nr = 0; nr < sr.length; nr++)
        sr[nr] = M(sr[nr]);
      return sr;
    }
    s.swap32IfBE = s.isLE ? (sr) => sr : F;
    const le = /* @ts-ignore */ typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function", ge = /* @__PURE__ */ Array.from({ length: 256 }, (sr, nr) => nr.toString(16).padStart(2, "0"));
    function pe(sr) {
      if (t(sr), le)
        return sr.toHex();
      let nr = "";
      for (let fr = 0; fr < sr.length; fr++)
        nr += ge[sr[fr]];
      return nr;
    }
    const Ie = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
    function be(sr) {
      if (sr >= Ie._0 && sr <= Ie._9)
        return sr - Ie._0;
      if (sr >= Ie.A && sr <= Ie.F)
        return sr - (Ie.A - 10);
      if (sr >= Ie.a && sr <= Ie.f)
        return sr - (Ie.a - 10);
    }
    function Pe(sr) {
      if (typeof sr != "string")
        throw new Error("hex string expected, got " + typeof sr);
      if (le)
        return Uint8Array.fromHex(sr);
      const nr = sr.length, fr = nr / 2;
      if (nr % 2)
        throw new Error("hex string expected, got unpadded hex of length " + nr);
      const lr = new Uint8Array(fr);
      for (let br = 0, Br = 0; br < fr; br++, Br += 2) {
        const Fr = be(sr.charCodeAt(Br)), Gr = be(sr.charCodeAt(Br + 1));
        if (Fr === void 0 || Gr === void 0) {
          const qr = sr[Br] + sr[Br + 1];
          throw new Error('hex string expected, got non-hex character "' + qr + '" at index ' + Br);
        }
        lr[br] = Fr * 16 + Gr;
      }
      return lr;
    }
    const Te = async () => {
    };
    s.nextTick = Te;
    async function Qe(sr, nr, fr) {
      let lr = Date.now();
      for (let br = 0; br < sr; br++) {
        fr(br);
        const Br = Date.now() - lr;
        Br >= 0 && Br < nr || (await (0, s.nextTick)(), lr += Br);
      }
    }
    function xe(sr) {
      if (typeof sr != "string")
        throw new Error("string expected");
      return new Uint8Array(new TextEncoder().encode(sr));
    }
    function Ee(sr) {
      return new TextDecoder().decode(sr);
    }
    function He(sr) {
      return typeof sr == "string" && (sr = xe(sr)), t(sr), sr;
    }
    function ve(sr) {
      return typeof sr == "string" && (sr = xe(sr)), t(sr), sr;
    }
    function we(...sr) {
      let nr = 0;
      for (let lr = 0; lr < sr.length; lr++) {
        const br = sr[lr];
        t(br), nr += br.length;
      }
      const fr = new Uint8Array(nr);
      for (let lr = 0, br = 0; lr < sr.length; lr++) {
        const Br = sr[lr];
        fr.set(Br, br), br += Br.length;
      }
      return fr;
    }
    function Ce(sr, nr) {
      if (nr !== void 0 && {}.toString.call(nr) !== "[object Object]")
        throw new Error("options should be object or undefined");
      return Object.assign(sr, nr);
    }
    class Se {
    }
    s.Hash = Se;
    function Ne(sr) {
      const nr = (lr) => sr().update(He(lr)).digest(), fr = sr();
      return nr.outputLen = fr.outputLen, nr.blockLen = fr.blockLen, nr.create = () => sr(), nr;
    }
    function rr(sr) {
      const nr = (lr, br) => sr(br).update(He(lr)).digest(), fr = sr({});
      return nr.outputLen = fr.outputLen, nr.blockLen = fr.blockLen, nr.create = (lr) => sr(lr), nr;
    }
    function er(sr) {
      const nr = (lr, br) => sr(br).update(He(lr)).digest(), fr = sr({});
      return nr.outputLen = fr.outputLen, nr.blockLen = fr.blockLen, nr.create = (lr) => sr(lr), nr;
    }
    s.wrapConstructor = Ne, s.wrapConstructorWithOpts = rr, s.wrapXOFConstructorWithOpts = er;
    function ir(sr = 32) {
      if (A.crypto && typeof A.crypto.getRandomValues == "function")
        return A.crypto.getRandomValues(new Uint8Array(sr));
      if (A.crypto && typeof A.crypto.randomBytes == "function")
        return Uint8Array.from(A.crypto.randomBytes(sr));
      throw new Error("crypto.getRandomValues must be defined");
    }
  }(utils$l)), utils$l;
}
var hasRequired_md$1;
function require_md$1() {
  if (hasRequired_md$1) return _md$1;
  hasRequired_md$1 = 1, Object.defineProperty(_md$1, "__esModule", { value: !0 }), _md$1.SHA512_IV = _md$1.SHA384_IV = _md$1.SHA224_IV = _md$1.SHA256_IV = _md$1.HashMD = void 0, _md$1.setBigUint64 = A, _md$1.Chi = u, _md$1.Maj = p;
  const s = /* @__PURE__ */ requireUtils$j();
  function A(l, m, b, k) {
    if (typeof l.setBigUint64 == "function")
      return l.setBigUint64(m, b, k);
    const C = BigInt(32), B = BigInt(4294967295), Q = Number(b >> C & B), P = Number(b & B), x = k ? 4 : 0, M = k ? 0 : 4;
    l.setUint32(m + x, Q, k), l.setUint32(m + M, P, k);
  }
  function u(l, m, b) {
    return l & m ^ ~l & b;
  }
  function p(l, m, b) {
    return l & m ^ l & b ^ m & b;
  }
  class t extends s.Hash {
    constructor(m, b, k, C) {
      super(), this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.blockLen = m, this.outputLen = b, this.padOffset = k, this.isLE = C, this.buffer = new Uint8Array(m), this.view = (0, s.createView)(this.buffer);
    }
    update(m) {
      (0, s.aexists)(this), m = (0, s.toBytes)(m), (0, s.abytes)(m);
      const { view: b, buffer: k, blockLen: C } = this, B = m.length;
      for (let Q = 0; Q < B; ) {
        const P = Math.min(C - this.pos, B - Q);
        if (P === C) {
          const x = (0, s.createView)(m);
          for (; C <= B - Q; Q += C)
            this.process(x, Q);
          continue;
        }
        k.set(m.subarray(Q, Q + P), this.pos), this.pos += P, Q += P, this.pos === C && (this.process(b, 0), this.pos = 0);
      }
      return this.length += m.length, this.roundClean(), this;
    }
    digestInto(m) {
      (0, s.aexists)(this), (0, s.aoutput)(m, this), this.finished = !0;
      const { buffer: b, view: k, blockLen: C, isLE: B } = this;
      let { pos: Q } = this;
      b[Q++] = 128, (0, s.clean)(this.buffer.subarray(Q)), this.padOffset > C - Q && (this.process(k, 0), Q = 0);
      for (let le = Q; le < C; le++)
        b[le] = 0;
      A(k, C - 8, BigInt(this.length * 8), B), this.process(k, 0);
      const P = (0, s.createView)(m), x = this.outputLen;
      if (x % 4)
        throw new Error("_sha2: outputLen should be aligned to 32bit");
      const M = x / 4, F = this.get();
      if (M > F.length)
        throw new Error("_sha2: outputLen bigger than state");
      for (let le = 0; le < M; le++)
        P.setUint32(4 * le, F[le], B);
    }
    digest() {
      const { buffer: m, outputLen: b } = this;
      this.digestInto(m);
      const k = m.slice(0, b);
      return this.destroy(), k;
    }
    _cloneInto(m) {
      m || (m = new this.constructor()), m.set(...this.get());
      const { blockLen: b, buffer: k, length: C, finished: B, destroyed: Q, pos: P } = this;
      return m.destroyed = Q, m.finished = B, m.length = C, m.pos = P, C % b && m.buffer.set(k), m;
    }
    clone() {
      return this._cloneInto();
    }
  }
  return _md$1.HashMD = t, _md$1.SHA256_IV = Uint32Array.from([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ]), _md$1.SHA224_IV = Uint32Array.from([
    3238371032,
    914150663,
    812702999,
    4144912697,
    4290775857,
    1750603025,
    1694076839,
    3204075428
  ]), _md$1.SHA384_IV = Uint32Array.from([
    3418070365,
    3238371032,
    1654270250,
    914150663,
    2438529370,
    812702999,
    355462360,
    4144912697,
    1731405415,
    4290775857,
    2394180231,
    1750603025,
    3675008525,
    1694076839,
    1203062813,
    3204075428
  ]), _md$1.SHA512_IV = Uint32Array.from([
    1779033703,
    4089235720,
    3144134277,
    2227873595,
    1013904242,
    4271175723,
    2773480762,
    1595750129,
    1359893119,
    2917565137,
    2600822924,
    725511199,
    528734635,
    4215389547,
    1541459225,
    327033209
  ]), _md$1;
}
var hasRequiredLegacy$1;
function requireLegacy$1() {
  if (hasRequiredLegacy$1) return legacy$1;
  hasRequiredLegacy$1 = 1, Object.defineProperty(legacy$1, "__esModule", { value: !0 }), legacy$1.ripemd160 = legacy$1.RIPEMD160 = legacy$1.md5 = legacy$1.MD5 = legacy$1.sha1 = legacy$1.SHA1 = void 0;
  const s = /* @__PURE__ */ require_md$1(), A = /* @__PURE__ */ requireUtils$j(), u = /* @__PURE__ */ Uint32Array.from([
    1732584193,
    4023233417,
    2562383102,
    271733878,
    3285377520
  ]), p = /* @__PURE__ */ new Uint32Array(80);
  class t extends s.HashMD {
    constructor() {
      super(64, 20, 8, !1), this.A = u[0] | 0, this.B = u[1] | 0, this.C = u[2] | 0, this.D = u[3] | 0, this.E = u[4] | 0;
    }
    get() {
      const { A: Ee, B: He, C: ve, D: we, E: Ce } = this;
      return [Ee, He, ve, we, Ce];
    }
    set(Ee, He, ve, we, Ce) {
      this.A = Ee | 0, this.B = He | 0, this.C = ve | 0, this.D = we | 0, this.E = Ce | 0;
    }
    process(Ee, He) {
      for (let rr = 0; rr < 16; rr++, He += 4)
        p[rr] = Ee.getUint32(He, !1);
      for (let rr = 16; rr < 80; rr++)
        p[rr] = (0, A.rotl)(p[rr - 3] ^ p[rr - 8] ^ p[rr - 14] ^ p[rr - 16], 1);
      let { A: ve, B: we, C: Ce, D: Se, E: Ne } = this;
      for (let rr = 0; rr < 80; rr++) {
        let er, ir;
        rr < 20 ? (er = (0, s.Chi)(we, Ce, Se), ir = 1518500249) : rr < 40 ? (er = we ^ Ce ^ Se, ir = 1859775393) : rr < 60 ? (er = (0, s.Maj)(we, Ce, Se), ir = 2400959708) : (er = we ^ Ce ^ Se, ir = 3395469782);
        const sr = (0, A.rotl)(ve, 5) + er + Ne + ir + p[rr] | 0;
        Ne = Se, Se = Ce, Ce = (0, A.rotl)(we, 30), we = ve, ve = sr;
      }
      ve = ve + this.A | 0, we = we + this.B | 0, Ce = Ce + this.C | 0, Se = Se + this.D | 0, Ne = Ne + this.E | 0, this.set(ve, we, Ce, Se, Ne);
    }
    roundClean() {
      (0, A.clean)(p);
    }
    destroy() {
      this.set(0, 0, 0, 0, 0), (0, A.clean)(this.buffer);
    }
  }
  legacy$1.SHA1 = t, legacy$1.sha1 = (0, A.createHasher)(() => new t());
  const l = /* @__PURE__ */ Math.pow(2, 32), m = /* @__PURE__ */ Array.from({ length: 64 }, (xe, Ee) => Math.floor(l * Math.abs(Math.sin(Ee + 1)))), b = /* @__PURE__ */ u.slice(0, 4), k = /* @__PURE__ */ new Uint32Array(16);
  class C extends s.HashMD {
    constructor() {
      super(64, 16, 8, !0), this.A = b[0] | 0, this.B = b[1] | 0, this.C = b[2] | 0, this.D = b[3] | 0;
    }
    get() {
      const { A: Ee, B: He, C: ve, D: we } = this;
      return [Ee, He, ve, we];
    }
    set(Ee, He, ve, we) {
      this.A = Ee | 0, this.B = He | 0, this.C = ve | 0, this.D = we | 0;
    }
    process(Ee, He) {
      for (let Ne = 0; Ne < 16; Ne++, He += 4)
        k[Ne] = Ee.getUint32(He, !0);
      let { A: ve, B: we, C: Ce, D: Se } = this;
      for (let Ne = 0; Ne < 64; Ne++) {
        let rr, er, ir;
        Ne < 16 ? (rr = (0, s.Chi)(we, Ce, Se), er = Ne, ir = [7, 12, 17, 22]) : Ne < 32 ? (rr = (0, s.Chi)(Se, we, Ce), er = (5 * Ne + 1) % 16, ir = [5, 9, 14, 20]) : Ne < 48 ? (rr = we ^ Ce ^ Se, er = (3 * Ne + 5) % 16, ir = [4, 11, 16, 23]) : (rr = Ce ^ (we | ~Se), er = 7 * Ne % 16, ir = [6, 10, 15, 21]), rr = rr + ve + m[Ne] + k[er], ve = Se, Se = Ce, Ce = we, we = we + (0, A.rotl)(rr, ir[Ne % 4]);
      }
      ve = ve + this.A | 0, we = we + this.B | 0, Ce = Ce + this.C | 0, Se = Se + this.D | 0, this.set(ve, we, Ce, Se);
    }
    roundClean() {
      (0, A.clean)(k);
    }
    destroy() {
      this.set(0, 0, 0, 0), (0, A.clean)(this.buffer);
    }
  }
  legacy$1.MD5 = C, legacy$1.md5 = (0, A.createHasher)(() => new C());
  const B = /* @__PURE__ */ Uint8Array.from([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
  ]), Q = Uint8Array.from(new Array(16).fill(0).map((xe, Ee) => Ee)), P = Q.map((xe) => (9 * xe + 5) % 16), x = /* @__PURE__ */ (() => {
    const He = [[Q], [P]];
    for (let ve = 0; ve < 4; ve++)
      for (let we of He)
        we.push(we[ve].map((Ce) => B[Ce]));
    return He;
  })(), M = x[0], F = x[1], le = /* @__PURE__ */ [
    [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
    [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
    [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
    [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
    [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
  ].map((xe) => Uint8Array.from(xe)), ge = /* @__PURE__ */ M.map((xe, Ee) => xe.map((He) => le[Ee][He])), pe = /* @__PURE__ */ F.map((xe, Ee) => xe.map((He) => le[Ee][He])), Ie = /* @__PURE__ */ Uint32Array.from([
    0,
    1518500249,
    1859775393,
    2400959708,
    2840853838
  ]), be = /* @__PURE__ */ Uint32Array.from([
    1352829926,
    1548603684,
    1836072691,
    2053994217,
    0
  ]);
  function Pe(xe, Ee, He, ve) {
    return xe === 0 ? Ee ^ He ^ ve : xe === 1 ? Ee & He | ~Ee & ve : xe === 2 ? (Ee | ~He) ^ ve : xe === 3 ? Ee & ve | He & ~ve : Ee ^ (He | ~ve);
  }
  const Te = /* @__PURE__ */ new Uint32Array(16);
  class Qe extends s.HashMD {
    constructor() {
      super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
    }
    get() {
      const { h0: Ee, h1: He, h2: ve, h3: we, h4: Ce } = this;
      return [Ee, He, ve, we, Ce];
    }
    set(Ee, He, ve, we, Ce) {
      this.h0 = Ee | 0, this.h1 = He | 0, this.h2 = ve | 0, this.h3 = we | 0, this.h4 = Ce | 0;
    }
    process(Ee, He) {
      for (let fr = 0; fr < 16; fr++, He += 4)
        Te[fr] = Ee.getUint32(He, !0);
      let ve = this.h0 | 0, we = ve, Ce = this.h1 | 0, Se = Ce, Ne = this.h2 | 0, rr = Ne, er = this.h3 | 0, ir = er, sr = this.h4 | 0, nr = sr;
      for (let fr = 0; fr < 5; fr++) {
        const lr = 4 - fr, br = Ie[fr], Br = be[fr], Fr = M[fr], Gr = F[fr], qr = ge[fr], Hr = pe[fr];
        for (let un = 0; un < 16; un++) {
          const Dr = (0, A.rotl)(ve + Pe(fr, Ce, Ne, er) + Te[Fr[un]] + br, qr[un]) + sr | 0;
          ve = sr, sr = er, er = (0, A.rotl)(Ne, 10) | 0, Ne = Ce, Ce = Dr;
        }
        for (let un = 0; un < 16; un++) {
          const Dr = (0, A.rotl)(we + Pe(lr, Se, rr, ir) + Te[Gr[un]] + Br, Hr[un]) + nr | 0;
          we = nr, nr = ir, ir = (0, A.rotl)(rr, 10) | 0, rr = Se, Se = Dr;
        }
      }
      this.set(this.h1 + Ne + ir | 0, this.h2 + er + nr | 0, this.h3 + sr + we | 0, this.h4 + ve + Se | 0, this.h0 + Ce + rr | 0);
    }
    roundClean() {
      (0, A.clean)(Te);
    }
    destroy() {
      this.destroyed = !0, (0, A.clean)(this.buffer), this.set(0, 0, 0, 0, 0);
    }
  }
  return legacy$1.RIPEMD160 = Qe, legacy$1.ripemd160 = (0, A.createHasher)(() => new Qe()), legacy$1;
}
var hasRequiredRipemd160$2;
function requireRipemd160$2() {
  if (hasRequiredRipemd160$2) return ripemd160$5;
  hasRequiredRipemd160$2 = 1, Object.defineProperty(ripemd160$5, "__esModule", { value: !0 }), ripemd160$5.ripemd160 = ripemd160$5.RIPEMD160 = void 0;
  const s = /* @__PURE__ */ requireLegacy$1();
  return ripemd160$5.RIPEMD160 = s.RIPEMD160, ripemd160$5.ripemd160 = s.ripemd160, ripemd160$5;
}
var sha1$5 = {}, hasRequiredSha1$3;
function requireSha1$3() {
  if (hasRequiredSha1$3) return sha1$5;
  hasRequiredSha1$3 = 1, Object.defineProperty(sha1$5, "__esModule", { value: !0 }), sha1$5.sha1 = sha1$5.SHA1 = void 0;
  const s = /* @__PURE__ */ requireLegacy$1();
  return sha1$5.SHA1 = s.SHA1, sha1$5.sha1 = s.sha1, sha1$5;
}
var sha256$a = {}, sha2 = {}, _u64$1 = {}, hasRequired_u64$1;
function require_u64$1() {
  if (hasRequired_u64$1) return _u64$1;
  hasRequired_u64$1 = 1, Object.defineProperty(_u64$1, "__esModule", { value: !0 }), _u64$1.toBig = _u64$1.shrSL = _u64$1.shrSH = _u64$1.rotrSL = _u64$1.rotrSH = _u64$1.rotrBL = _u64$1.rotrBH = _u64$1.rotr32L = _u64$1.rotr32H = _u64$1.rotlSL = _u64$1.rotlSH = _u64$1.rotlBL = _u64$1.rotlBH = _u64$1.add5L = _u64$1.add5H = _u64$1.add4L = _u64$1.add4H = _u64$1.add3L = _u64$1.add3H = void 0, _u64$1.add = ge, _u64$1.fromBig = u, _u64$1.split = p;
  const s = /* @__PURE__ */ BigInt(2 ** 32 - 1), A = /* @__PURE__ */ BigInt(32);
  function u(Ee, He = !1) {
    return He ? { h: Number(Ee & s), l: Number(Ee >> A & s) } : { h: Number(Ee >> A & s) | 0, l: Number(Ee & s) | 0 };
  }
  function p(Ee, He = !1) {
    const ve = Ee.length;
    let we = new Uint32Array(ve), Ce = new Uint32Array(ve);
    for (let Se = 0; Se < ve; Se++) {
      const { h: Ne, l: rr } = u(Ee[Se], He);
      [we[Se], Ce[Se]] = [Ne, rr];
    }
    return [we, Ce];
  }
  const t = (Ee, He) => BigInt(Ee >>> 0) << A | BigInt(He >>> 0);
  _u64$1.toBig = t;
  const l = (Ee, He, ve) => Ee >>> ve;
  _u64$1.shrSH = l;
  const m = (Ee, He, ve) => Ee << 32 - ve | He >>> ve;
  _u64$1.shrSL = m;
  const b = (Ee, He, ve) => Ee >>> ve | He << 32 - ve;
  _u64$1.rotrSH = b;
  const k = (Ee, He, ve) => Ee << 32 - ve | He >>> ve;
  _u64$1.rotrSL = k;
  const C = (Ee, He, ve) => Ee << 64 - ve | He >>> ve - 32;
  _u64$1.rotrBH = C;
  const B = (Ee, He, ve) => Ee >>> ve - 32 | He << 64 - ve;
  _u64$1.rotrBL = B;
  const Q = (Ee, He) => He;
  _u64$1.rotr32H = Q;
  const P = (Ee, He) => Ee;
  _u64$1.rotr32L = P;
  const x = (Ee, He, ve) => Ee << ve | He >>> 32 - ve;
  _u64$1.rotlSH = x;
  const M = (Ee, He, ve) => He << ve | Ee >>> 32 - ve;
  _u64$1.rotlSL = M;
  const F = (Ee, He, ve) => He << ve - 32 | Ee >>> 64 - ve;
  _u64$1.rotlBH = F;
  const le = (Ee, He, ve) => Ee << ve - 32 | He >>> 64 - ve;
  _u64$1.rotlBL = le;
  function ge(Ee, He, ve, we) {
    const Ce = (He >>> 0) + (we >>> 0);
    return { h: Ee + ve + (Ce / 2 ** 32 | 0) | 0, l: Ce | 0 };
  }
  const pe = (Ee, He, ve) => (Ee >>> 0) + (He >>> 0) + (ve >>> 0);
  _u64$1.add3L = pe;
  const Ie = (Ee, He, ve, we) => He + ve + we + (Ee / 2 ** 32 | 0) | 0;
  _u64$1.add3H = Ie;
  const be = (Ee, He, ve, we) => (Ee >>> 0) + (He >>> 0) + (ve >>> 0) + (we >>> 0);
  _u64$1.add4L = be;
  const Pe = (Ee, He, ve, we, Ce) => He + ve + we + Ce + (Ee / 2 ** 32 | 0) | 0;
  _u64$1.add4H = Pe;
  const Te = (Ee, He, ve, we, Ce) => (Ee >>> 0) + (He >>> 0) + (ve >>> 0) + (we >>> 0) + (Ce >>> 0);
  _u64$1.add5L = Te;
  const Qe = (Ee, He, ve, we, Ce, Se) => He + ve + we + Ce + Se + (Ee / 2 ** 32 | 0) | 0;
  _u64$1.add5H = Qe;
  const xe = {
    fromBig: u,
    split: p,
    toBig: t,
    shrSH: l,
    shrSL: m,
    rotrSH: b,
    rotrSL: k,
    rotrBH: C,
    rotrBL: B,
    rotr32H: Q,
    rotr32L: P,
    rotlSH: x,
    rotlSL: M,
    rotlBH: F,
    rotlBL: le,
    add: ge,
    add3L: pe,
    add3H: Ie,
    add4L: be,
    add4H: Pe,
    add5H: Qe,
    add5L: Te
  };
  return _u64$1.default = xe, _u64$1;
}
var hasRequiredSha2;
function requireSha2() {
  if (hasRequiredSha2) return sha2;
  hasRequiredSha2 = 1, Object.defineProperty(sha2, "__esModule", { value: !0 }), sha2.sha512_224 = sha2.sha512_256 = sha2.sha384 = sha2.sha512 = sha2.sha224 = sha2.sha256 = sha2.SHA512_256 = sha2.SHA512_224 = sha2.SHA384 = sha2.SHA512 = sha2.SHA224 = sha2.SHA256 = void 0;
  const s = /* @__PURE__ */ require_md$1(), A = /* @__PURE__ */ require_u64$1(), u = /* @__PURE__ */ requireUtils$j(), p = /* @__PURE__ */ Uint32Array.from([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]), t = /* @__PURE__ */ new Uint32Array(64);
  class l extends s.HashMD {
    constructor(Ie = 32) {
      super(64, Ie, 8, !1), this.A = s.SHA256_IV[0] | 0, this.B = s.SHA256_IV[1] | 0, this.C = s.SHA256_IV[2] | 0, this.D = s.SHA256_IV[3] | 0, this.E = s.SHA256_IV[4] | 0, this.F = s.SHA256_IV[5] | 0, this.G = s.SHA256_IV[6] | 0, this.H = s.SHA256_IV[7] | 0;
    }
    get() {
      const { A: Ie, B: be, C: Pe, D: Te, E: Qe, F: xe, G: Ee, H: He } = this;
      return [Ie, be, Pe, Te, Qe, xe, Ee, He];
    }
    // prettier-ignore
    set(Ie, be, Pe, Te, Qe, xe, Ee, He) {
      this.A = Ie | 0, this.B = be | 0, this.C = Pe | 0, this.D = Te | 0, this.E = Qe | 0, this.F = xe | 0, this.G = Ee | 0, this.H = He | 0;
    }
    process(Ie, be) {
      for (let Ce = 0; Ce < 16; Ce++, be += 4)
        t[Ce] = Ie.getUint32(be, !1);
      for (let Ce = 16; Ce < 64; Ce++) {
        const Se = t[Ce - 15], Ne = t[Ce - 2], rr = (0, u.rotr)(Se, 7) ^ (0, u.rotr)(Se, 18) ^ Se >>> 3, er = (0, u.rotr)(Ne, 17) ^ (0, u.rotr)(Ne, 19) ^ Ne >>> 10;
        t[Ce] = er + t[Ce - 7] + rr + t[Ce - 16] | 0;
      }
      let { A: Pe, B: Te, C: Qe, D: xe, E: Ee, F: He, G: ve, H: we } = this;
      for (let Ce = 0; Ce < 64; Ce++) {
        const Se = (0, u.rotr)(Ee, 6) ^ (0, u.rotr)(Ee, 11) ^ (0, u.rotr)(Ee, 25), Ne = we + Se + (0, s.Chi)(Ee, He, ve) + p[Ce] + t[Ce] | 0, er = ((0, u.rotr)(Pe, 2) ^ (0, u.rotr)(Pe, 13) ^ (0, u.rotr)(Pe, 22)) + (0, s.Maj)(Pe, Te, Qe) | 0;
        we = ve, ve = He, He = Ee, Ee = xe + Ne | 0, xe = Qe, Qe = Te, Te = Pe, Pe = Ne + er | 0;
      }
      Pe = Pe + this.A | 0, Te = Te + this.B | 0, Qe = Qe + this.C | 0, xe = xe + this.D | 0, Ee = Ee + this.E | 0, He = He + this.F | 0, ve = ve + this.G | 0, we = we + this.H | 0, this.set(Pe, Te, Qe, xe, Ee, He, ve, we);
    }
    roundClean() {
      (0, u.clean)(t);
    }
    destroy() {
      this.set(0, 0, 0, 0, 0, 0, 0, 0), (0, u.clean)(this.buffer);
    }
  }
  sha2.SHA256 = l;
  class m extends l {
    constructor() {
      super(28), this.A = s.SHA224_IV[0] | 0, this.B = s.SHA224_IV[1] | 0, this.C = s.SHA224_IV[2] | 0, this.D = s.SHA224_IV[3] | 0, this.E = s.SHA224_IV[4] | 0, this.F = s.SHA224_IV[5] | 0, this.G = s.SHA224_IV[6] | 0, this.H = s.SHA224_IV[7] | 0;
    }
  }
  sha2.SHA224 = m;
  const b = A.split([
    "0x428a2f98d728ae22",
    "0x7137449123ef65cd",
    "0xb5c0fbcfec4d3b2f",
    "0xe9b5dba58189dbbc",
    "0x3956c25bf348b538",
    "0x59f111f1b605d019",
    "0x923f82a4af194f9b",
    "0xab1c5ed5da6d8118",
    "0xd807aa98a3030242",
    "0x12835b0145706fbe",
    "0x243185be4ee4b28c",
    "0x550c7dc3d5ffb4e2",
    "0x72be5d74f27b896f",
    "0x80deb1fe3b1696b1",
    "0x9bdc06a725c71235",
    "0xc19bf174cf692694",
    "0xe49b69c19ef14ad2",
    "0xefbe4786384f25e3",
    "0x0fc19dc68b8cd5b5",
    "0x240ca1cc77ac9c65",
    "0x2de92c6f592b0275",
    "0x4a7484aa6ea6e483",
    "0x5cb0a9dcbd41fbd4",
    "0x76f988da831153b5",
    "0x983e5152ee66dfab",
    "0xa831c66d2db43210",
    "0xb00327c898fb213f",
    "0xbf597fc7beef0ee4",
    "0xc6e00bf33da88fc2",
    "0xd5a79147930aa725",
    "0x06ca6351e003826f",
    "0x142929670a0e6e70",
    "0x27b70a8546d22ffc",
    "0x2e1b21385c26c926",
    "0x4d2c6dfc5ac42aed",
    "0x53380d139d95b3df",
    "0x650a73548baf63de",
    "0x766a0abb3c77b2a8",
    "0x81c2c92e47edaee6",
    "0x92722c851482353b",
    "0xa2bfe8a14cf10364",
    "0xa81a664bbc423001",
    "0xc24b8b70d0f89791",
    "0xc76c51a30654be30",
    "0xd192e819d6ef5218",
    "0xd69906245565a910",
    "0xf40e35855771202a",
    "0x106aa07032bbd1b8",
    "0x19a4c116b8d2d0c8",
    "0x1e376c085141ab53",
    "0x2748774cdf8eeb99",
    "0x34b0bcb5e19b48a8",
    "0x391c0cb3c5c95a63",
    "0x4ed8aa4ae3418acb",
    "0x5b9cca4f7763e373",
    "0x682e6ff3d6b2b8a3",
    "0x748f82ee5defb2fc",
    "0x78a5636f43172f60",
    "0x84c87814a1f0ab72",
    "0x8cc702081a6439ec",
    "0x90befffa23631e28",
    "0xa4506cebde82bde9",
    "0xbef9a3f7b2c67915",
    "0xc67178f2e372532b",
    "0xca273eceea26619c",
    "0xd186b8c721c0c207",
    "0xeada7dd6cde0eb1e",
    "0xf57d4f7fee6ed178",
    "0x06f067aa72176fba",
    "0x0a637dc5a2c898a6",
    "0x113f9804bef90dae",
    "0x1b710b35131c471b",
    "0x28db77f523047d84",
    "0x32caab7b40c72493",
    "0x3c9ebe0a15c9bebc",
    "0x431d67c49c100d4c",
    "0x4cc5d4becb3e42b6",
    "0x597f299cfc657e2a",
    "0x5fcb6fab3ad6faec",
    "0x6c44198c4a475817"
  ].map((pe) => BigInt(pe))), k = b[0], C = b[1], B = /* @__PURE__ */ new Uint32Array(80), Q = /* @__PURE__ */ new Uint32Array(80);
  class P extends s.HashMD {
    constructor(Ie = 64) {
      super(128, Ie, 16, !1), this.Ah = s.SHA512_IV[0] | 0, this.Al = s.SHA512_IV[1] | 0, this.Bh = s.SHA512_IV[2] | 0, this.Bl = s.SHA512_IV[3] | 0, this.Ch = s.SHA512_IV[4] | 0, this.Cl = s.SHA512_IV[5] | 0, this.Dh = s.SHA512_IV[6] | 0, this.Dl = s.SHA512_IV[7] | 0, this.Eh = s.SHA512_IV[8] | 0, this.El = s.SHA512_IV[9] | 0, this.Fh = s.SHA512_IV[10] | 0, this.Fl = s.SHA512_IV[11] | 0, this.Gh = s.SHA512_IV[12] | 0, this.Gl = s.SHA512_IV[13] | 0, this.Hh = s.SHA512_IV[14] | 0, this.Hl = s.SHA512_IV[15] | 0;
    }
    // prettier-ignore
    get() {
      const { Ah: Ie, Al: be, Bh: Pe, Bl: Te, Ch: Qe, Cl: xe, Dh: Ee, Dl: He, Eh: ve, El: we, Fh: Ce, Fl: Se, Gh: Ne, Gl: rr, Hh: er, Hl: ir } = this;
      return [Ie, be, Pe, Te, Qe, xe, Ee, He, ve, we, Ce, Se, Ne, rr, er, ir];
    }
    // prettier-ignore
    set(Ie, be, Pe, Te, Qe, xe, Ee, He, ve, we, Ce, Se, Ne, rr, er, ir) {
      this.Ah = Ie | 0, this.Al = be | 0, this.Bh = Pe | 0, this.Bl = Te | 0, this.Ch = Qe | 0, this.Cl = xe | 0, this.Dh = Ee | 0, this.Dl = He | 0, this.Eh = ve | 0, this.El = we | 0, this.Fh = Ce | 0, this.Fl = Se | 0, this.Gh = Ne | 0, this.Gl = rr | 0, this.Hh = er | 0, this.Hl = ir | 0;
    }
    process(Ie, be) {
      for (let fr = 0; fr < 16; fr++, be += 4)
        B[fr] = Ie.getUint32(be), Q[fr] = Ie.getUint32(be += 4);
      for (let fr = 16; fr < 80; fr++) {
        const lr = B[fr - 15] | 0, br = Q[fr - 15] | 0, Br = A.rotrSH(lr, br, 1) ^ A.rotrSH(lr, br, 8) ^ A.shrSH(lr, br, 7), Fr = A.rotrSL(lr, br, 1) ^ A.rotrSL(lr, br, 8) ^ A.shrSL(lr, br, 7), Gr = B[fr - 2] | 0, qr = Q[fr - 2] | 0, Hr = A.rotrSH(Gr, qr, 19) ^ A.rotrBH(Gr, qr, 61) ^ A.shrSH(Gr, qr, 6), un = A.rotrSL(Gr, qr, 19) ^ A.rotrBL(Gr, qr, 61) ^ A.shrSL(Gr, qr, 6), Dr = A.add4L(Fr, un, Q[fr - 7], Q[fr - 16]), wr = A.add4H(Dr, Br, Hr, B[fr - 7], B[fr - 16]);
        B[fr] = wr | 0, Q[fr] = Dr | 0;
      }
      let { Ah: Pe, Al: Te, Bh: Qe, Bl: xe, Ch: Ee, Cl: He, Dh: ve, Dl: we, Eh: Ce, El: Se, Fh: Ne, Fl: rr, Gh: er, Gl: ir, Hh: sr, Hl: nr } = this;
      for (let fr = 0; fr < 80; fr++) {
        const lr = A.rotrSH(Ce, Se, 14) ^ A.rotrSH(Ce, Se, 18) ^ A.rotrBH(Ce, Se, 41), br = A.rotrSL(Ce, Se, 14) ^ A.rotrSL(Ce, Se, 18) ^ A.rotrBL(Ce, Se, 41), Br = Ce & Ne ^ ~Ce & er, Fr = Se & rr ^ ~Se & ir, Gr = A.add5L(nr, br, Fr, C[fr], Q[fr]), qr = A.add5H(Gr, sr, lr, Br, k[fr], B[fr]), Hr = Gr | 0, un = A.rotrSH(Pe, Te, 28) ^ A.rotrBH(Pe, Te, 34) ^ A.rotrBH(Pe, Te, 39), Dr = A.rotrSL(Pe, Te, 28) ^ A.rotrBL(Pe, Te, 34) ^ A.rotrBL(Pe, Te, 39), wr = Pe & Qe ^ Pe & Ee ^ Qe & Ee, yr = Te & xe ^ Te & He ^ xe & He;
        sr = er | 0, nr = ir | 0, er = Ne | 0, ir = rr | 0, Ne = Ce | 0, rr = Se | 0, { h: Ce, l: Se } = A.add(ve | 0, we | 0, qr | 0, Hr | 0), ve = Ee | 0, we = He | 0, Ee = Qe | 0, He = xe | 0, Qe = Pe | 0, xe = Te | 0;
        const Qr = A.add3L(Hr, Dr, yr);
        Pe = A.add3H(Qr, qr, un, wr), Te = Qr | 0;
      }
      ({ h: Pe, l: Te } = A.add(this.Ah | 0, this.Al | 0, Pe | 0, Te | 0)), { h: Qe, l: xe } = A.add(this.Bh | 0, this.Bl | 0, Qe | 0, xe | 0), { h: Ee, l: He } = A.add(this.Ch | 0, this.Cl | 0, Ee | 0, He | 0), { h: ve, l: we } = A.add(this.Dh | 0, this.Dl | 0, ve | 0, we | 0), { h: Ce, l: Se } = A.add(this.Eh | 0, this.El | 0, Ce | 0, Se | 0), { h: Ne, l: rr } = A.add(this.Fh | 0, this.Fl | 0, Ne | 0, rr | 0), { h: er, l: ir } = A.add(this.Gh | 0, this.Gl | 0, er | 0, ir | 0), { h: sr, l: nr } = A.add(this.Hh | 0, this.Hl | 0, sr | 0, nr | 0), this.set(Pe, Te, Qe, xe, Ee, He, ve, we, Ce, Se, Ne, rr, er, ir, sr, nr);
    }
    roundClean() {
      (0, u.clean)(B, Q);
    }
    destroy() {
      (0, u.clean)(this.buffer), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
  }
  sha2.SHA512 = P;
  class x extends P {
    constructor() {
      super(48), this.Ah = s.SHA384_IV[0] | 0, this.Al = s.SHA384_IV[1] | 0, this.Bh = s.SHA384_IV[2] | 0, this.Bl = s.SHA384_IV[3] | 0, this.Ch = s.SHA384_IV[4] | 0, this.Cl = s.SHA384_IV[5] | 0, this.Dh = s.SHA384_IV[6] | 0, this.Dl = s.SHA384_IV[7] | 0, this.Eh = s.SHA384_IV[8] | 0, this.El = s.SHA384_IV[9] | 0, this.Fh = s.SHA384_IV[10] | 0, this.Fl = s.SHA384_IV[11] | 0, this.Gh = s.SHA384_IV[12] | 0, this.Gl = s.SHA384_IV[13] | 0, this.Hh = s.SHA384_IV[14] | 0, this.Hl = s.SHA384_IV[15] | 0;
    }
  }
  sha2.SHA384 = x;
  const M = /* @__PURE__ */ Uint32Array.from([
    2352822216,
    424955298,
    1944164710,
    2312950998,
    502970286,
    855612546,
    1738396948,
    1479516111,
    258812777,
    2077511080,
    2011393907,
    79989058,
    1067287976,
    1780299464,
    286451373,
    2446758561
  ]), F = /* @__PURE__ */ Uint32Array.from([
    573645204,
    4230739756,
    2673172387,
    3360449730,
    596883563,
    1867755857,
    2520282905,
    1497426621,
    2519219938,
    2827943907,
    3193839141,
    1401305490,
    721525244,
    746961066,
    246885852,
    2177182882
  ]);
  class le extends P {
    constructor() {
      super(28), this.Ah = M[0] | 0, this.Al = M[1] | 0, this.Bh = M[2] | 0, this.Bl = M[3] | 0, this.Ch = M[4] | 0, this.Cl = M[5] | 0, this.Dh = M[6] | 0, this.Dl = M[7] | 0, this.Eh = M[8] | 0, this.El = M[9] | 0, this.Fh = M[10] | 0, this.Fl = M[11] | 0, this.Gh = M[12] | 0, this.Gl = M[13] | 0, this.Hh = M[14] | 0, this.Hl = M[15] | 0;
    }
  }
  sha2.SHA512_224 = le;
  class ge extends P {
    constructor() {
      super(32), this.Ah = F[0] | 0, this.Al = F[1] | 0, this.Bh = F[2] | 0, this.Bl = F[3] | 0, this.Ch = F[4] | 0, this.Cl = F[5] | 0, this.Dh = F[6] | 0, this.Dl = F[7] | 0, this.Eh = F[8] | 0, this.El = F[9] | 0, this.Fh = F[10] | 0, this.Fl = F[11] | 0, this.Gh = F[12] | 0, this.Gl = F[13] | 0, this.Hh = F[14] | 0, this.Hl = F[15] | 0;
    }
  }
  return sha2.SHA512_256 = ge, sha2.sha256 = (0, u.createHasher)(() => new l()), sha2.sha224 = (0, u.createHasher)(() => new m()), sha2.sha512 = (0, u.createHasher)(() => new P()), sha2.sha384 = (0, u.createHasher)(() => new x()), sha2.sha512_256 = (0, u.createHasher)(() => new ge()), sha2.sha512_224 = (0, u.createHasher)(() => new le()), sha2;
}
var hasRequiredSha256$4;
function requireSha256$4() {
  if (hasRequiredSha256$4) return sha256$a;
  hasRequiredSha256$4 = 1, Object.defineProperty(sha256$a, "__esModule", { value: !0 }), sha256$a.sha224 = sha256$a.SHA224 = sha256$a.sha256 = sha256$a.SHA256 = void 0;
  const s = /* @__PURE__ */ requireSha2();
  return sha256$a.SHA256 = s.SHA256, sha256$a.sha256 = s.sha256, sha256$a.SHA224 = s.SHA224, sha256$a.sha224 = s.sha224, sha256$a;
}
var hasRequiredCrypto$3;
function requireCrypto$3() {
  return hasRequiredCrypto$3 || (hasRequiredCrypto$3 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.taggedHash = s.TAGGED_HASH_PREFIXES = s.TAGS = s.hash256 = s.hash160 = s.sha256 = s.sha1 = s.ripemd160 = void 0;
    const A = /* @__PURE__ */ requireRipemd160$2(), u = /* @__PURE__ */ requireSha1$3(), p = /* @__PURE__ */ requireSha256$4();
    function t(B) {
      return Buffer.from((0, A.ripemd160)(Uint8Array.from(B)));
    }
    s.ripemd160 = t;
    function l(B) {
      return Buffer.from((0, u.sha1)(Uint8Array.from(B)));
    }
    s.sha1 = l;
    function m(B) {
      return Buffer.from((0, p.sha256)(Uint8Array.from(B)));
    }
    s.sha256 = m;
    function b(B) {
      return Buffer.from(
        (0, A.ripemd160)((0, p.sha256)(Uint8Array.from(B)))
      );
    }
    s.hash160 = b;
    function k(B) {
      return Buffer.from(
        (0, p.sha256)((0, p.sha256)(Uint8Array.from(B)))
      );
    }
    s.hash256 = k, s.TAGS = [
      "BIP0340/challenge",
      "BIP0340/aux",
      "BIP0340/nonce",
      "TapLeaf",
      "TapBranch",
      "TapSighash",
      "TapTweak",
      "KeyAgg list",
      "KeyAgg coefficient"
    ], s.TAGGED_HASH_PREFIXES = {
      "BIP0340/challenge": Buffer.from([
        123,
        181,
        45,
        122,
        159,
        239,
        88,
        50,
        62,
        177,
        191,
        122,
        64,
        125,
        179,
        130,
        210,
        243,
        242,
        216,
        27,
        177,
        34,
        79,
        73,
        254,
        81,
        143,
        109,
        72,
        211,
        124,
        123,
        181,
        45,
        122,
        159,
        239,
        88,
        50,
        62,
        177,
        191,
        122,
        64,
        125,
        179,
        130,
        210,
        243,
        242,
        216,
        27,
        177,
        34,
        79,
        73,
        254,
        81,
        143,
        109,
        72,
        211,
        124
      ]),
      "BIP0340/aux": Buffer.from([
        241,
        239,
        78,
        94,
        192,
        99,
        202,
        218,
        109,
        148,
        202,
        250,
        157,
        152,
        126,
        160,
        105,
        38,
        88,
        57,
        236,
        193,
        31,
        151,
        45,
        119,
        165,
        46,
        216,
        193,
        204,
        144,
        241,
        239,
        78,
        94,
        192,
        99,
        202,
        218,
        109,
        148,
        202,
        250,
        157,
        152,
        126,
        160,
        105,
        38,
        88,
        57,
        236,
        193,
        31,
        151,
        45,
        119,
        165,
        46,
        216,
        193,
        204,
        144
      ]),
      "BIP0340/nonce": Buffer.from([
        7,
        73,
        119,
        52,
        167,
        155,
        203,
        53,
        91,
        155,
        140,
        125,
        3,
        79,
        18,
        28,
        244,
        52,
        215,
        62,
        247,
        45,
        218,
        25,
        135,
        0,
        97,
        251,
        82,
        191,
        235,
        47,
        7,
        73,
        119,
        52,
        167,
        155,
        203,
        53,
        91,
        155,
        140,
        125,
        3,
        79,
        18,
        28,
        244,
        52,
        215,
        62,
        247,
        45,
        218,
        25,
        135,
        0,
        97,
        251,
        82,
        191,
        235,
        47
      ]),
      TapLeaf: Buffer.from([
        174,
        234,
        143,
        220,
        66,
        8,
        152,
        49,
        5,
        115,
        75,
        88,
        8,
        29,
        30,
        38,
        56,
        211,
        95,
        28,
        181,
        64,
        8,
        212,
        211,
        87,
        202,
        3,
        190,
        120,
        233,
        238,
        174,
        234,
        143,
        220,
        66,
        8,
        152,
        49,
        5,
        115,
        75,
        88,
        8,
        29,
        30,
        38,
        56,
        211,
        95,
        28,
        181,
        64,
        8,
        212,
        211,
        87,
        202,
        3,
        190,
        120,
        233,
        238
      ]),
      TapBranch: Buffer.from([
        25,
        65,
        161,
        242,
        229,
        110,
        185,
        95,
        162,
        169,
        241,
        148,
        190,
        92,
        1,
        247,
        33,
        111,
        51,
        237,
        130,
        176,
        145,
        70,
        52,
        144,
        208,
        91,
        245,
        22,
        160,
        21,
        25,
        65,
        161,
        242,
        229,
        110,
        185,
        95,
        162,
        169,
        241,
        148,
        190,
        92,
        1,
        247,
        33,
        111,
        51,
        237,
        130,
        176,
        145,
        70,
        52,
        144,
        208,
        91,
        245,
        22,
        160,
        21
      ]),
      TapSighash: Buffer.from([
        244,
        10,
        72,
        223,
        75,
        42,
        112,
        200,
        180,
        146,
        75,
        242,
        101,
        70,
        97,
        237,
        61,
        149,
        253,
        102,
        163,
        19,
        235,
        135,
        35,
        117,
        151,
        198,
        40,
        228,
        160,
        49,
        244,
        10,
        72,
        223,
        75,
        42,
        112,
        200,
        180,
        146,
        75,
        242,
        101,
        70,
        97,
        237,
        61,
        149,
        253,
        102,
        163,
        19,
        235,
        135,
        35,
        117,
        151,
        198,
        40,
        228,
        160,
        49
      ]),
      TapTweak: Buffer.from([
        232,
        15,
        225,
        99,
        156,
        156,
        160,
        80,
        227,
        175,
        27,
        57,
        193,
        67,
        198,
        62,
        66,
        156,
        188,
        235,
        21,
        217,
        64,
        251,
        181,
        197,
        161,
        244,
        175,
        87,
        197,
        233,
        232,
        15,
        225,
        99,
        156,
        156,
        160,
        80,
        227,
        175,
        27,
        57,
        193,
        67,
        198,
        62,
        66,
        156,
        188,
        235,
        21,
        217,
        64,
        251,
        181,
        197,
        161,
        244,
        175,
        87,
        197,
        233
      ]),
      "KeyAgg list": Buffer.from([
        72,
        28,
        151,
        28,
        60,
        11,
        70,
        215,
        240,
        178,
        117,
        174,
        89,
        141,
        78,
        44,
        126,
        215,
        49,
        156,
        89,
        74,
        92,
        110,
        199,
        158,
        160,
        212,
        153,
        2,
        148,
        240,
        72,
        28,
        151,
        28,
        60,
        11,
        70,
        215,
        240,
        178,
        117,
        174,
        89,
        141,
        78,
        44,
        126,
        215,
        49,
        156,
        89,
        74,
        92,
        110,
        199,
        158,
        160,
        212,
        153,
        2,
        148,
        240
      ]),
      "KeyAgg coefficient": Buffer.from([
        191,
        201,
        4,
        3,
        77,
        28,
        136,
        232,
        200,
        14,
        34,
        229,
        61,
        36,
        86,
        109,
        100,
        130,
        78,
        214,
        66,
        114,
        129,
        192,
        145,
        0,
        249,
        77,
        205,
        82,
        201,
        129,
        191,
        201,
        4,
        3,
        77,
        28,
        136,
        232,
        200,
        14,
        34,
        229,
        61,
        36,
        86,
        109,
        100,
        130,
        78,
        214,
        66,
        114,
        129,
        192,
        145,
        0,
        249,
        77,
        205,
        82,
        201,
        129
      ])
    };
    function C(B, Q) {
      return m(Buffer.concat([s.TAGGED_HASH_PREFIXES[B], Q]));
    }
    s.taggedHash = C;
  }(crypto$7)), crypto$7;
}
var src$3, hasRequiredSrc$4;
function requireSrc$4() {
  if (hasRequiredSrc$4) return src$3;
  hasRequiredSrc$4 = 1;
  function s(A) {
    if (A.length >= 255)
      throw new TypeError("Alphabet too long");
    for (var u = new Uint8Array(256), p = 0; p < u.length; p++)
      u[p] = 255;
    for (var t = 0; t < A.length; t++) {
      var l = A.charAt(t), m = l.charCodeAt(0);
      if (u[m] !== 255)
        throw new TypeError(l + " is ambiguous");
      u[m] = t;
    }
    var b = A.length, k = A.charAt(0), C = Math.log(b) / Math.log(256), B = Math.log(256) / Math.log(b);
    function Q(M) {
      if (M instanceof Uint8Array || (ArrayBuffer.isView(M) ? M = new Uint8Array(M.buffer, M.byteOffset, M.byteLength) : Array.isArray(M) && (M = Uint8Array.from(M))), !(M instanceof Uint8Array))
        throw new TypeError("Expected Uint8Array");
      if (M.length === 0)
        return "";
      for (var F = 0, le = 0, ge = 0, pe = M.length; ge !== pe && M[ge] === 0; )
        ge++, F++;
      for (var Ie = (pe - ge) * B + 1 >>> 0, be = new Uint8Array(Ie); ge !== pe; ) {
        for (var Pe = M[ge], Te = 0, Qe = Ie - 1; (Pe !== 0 || Te < le) && Qe !== -1; Qe--, Te++)
          Pe += 256 * be[Qe] >>> 0, be[Qe] = Pe % b >>> 0, Pe = Pe / b >>> 0;
        if (Pe !== 0)
          throw new Error("Non-zero carry");
        le = Te, ge++;
      }
      for (var xe = Ie - le; xe !== Ie && be[xe] === 0; )
        xe++;
      for (var Ee = k.repeat(F); xe < Ie; ++xe)
        Ee += A.charAt(be[xe]);
      return Ee;
    }
    function P(M) {
      if (typeof M != "string")
        throw new TypeError("Expected String");
      if (M.length === 0)
        return new Uint8Array();
      for (var F = 0, le = 0, ge = 0; M[F] === k; )
        le++, F++;
      for (var pe = (M.length - F) * C + 1 >>> 0, Ie = new Uint8Array(pe); M[F]; ) {
        var be = M.charCodeAt(F);
        if (be > 255)
          return;
        var Pe = u[be];
        if (Pe === 255)
          return;
        for (var Te = 0, Qe = pe - 1; (Pe !== 0 || Te < ge) && Qe !== -1; Qe--, Te++)
          Pe += b * Ie[Qe] >>> 0, Ie[Qe] = Pe % 256 >>> 0, Pe = Pe / 256 >>> 0;
        if (Pe !== 0)
          throw new Error("Non-zero carry");
        ge = Te, F++;
      }
      for (var xe = pe - ge; xe !== pe && Ie[xe] === 0; )
        xe++;
      for (var Ee = new Uint8Array(le + (pe - xe)), He = le; xe !== pe; )
        Ee[He++] = Ie[xe++];
      return Ee;
    }
    function x(M) {
      var F = P(M);
      if (F)
        return F;
      throw new Error("Non-base" + b + " character");
    }
    return {
      encode: Q,
      decodeUnsafe: P,
      decode: x
    };
  }
  return src$3 = s, src$3;
}
var bs58$1, hasRequiredBs58$1;
function requireBs58$1() {
  return hasRequiredBs58$1 || (hasRequiredBs58$1 = 1, bs58$1 = requireSrc$4()("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz")), bs58$1;
}
var base$3, hasRequiredBase$3;
function requireBase$3() {
  if (hasRequiredBase$3) return base$3;
  hasRequiredBase$3 = 1;
  var s = requireBs58$1();
  return base$3 = function(A) {
    function u(m) {
      var b = Uint8Array.from(m), k = A(b), C = b.length + 4, B = new Uint8Array(C);
      return B.set(b, 0), B.set(k.subarray(0, 4), b.length), s.encode(B, C);
    }
    function p(m) {
      var b = m.slice(0, -4), k = m.slice(-4), C = A(b);
      if (!(k[0] ^ C[0] | k[1] ^ C[1] | k[2] ^ C[2] | k[3] ^ C[3]))
        return b;
    }
    function t(m) {
      var b = s.decodeUnsafe(m);
      if (b)
        return p(b);
    }
    function l(m) {
      var b = s.decode(m), k = p(b);
      if (!k) throw new Error("Invalid checksum");
      return k;
    }
    return {
      encode: u,
      decode: l,
      decodeUnsafe: t
    };
  }, base$3;
}
var bs58check$1, hasRequiredBs58check$1;
function requireBs58check$1() {
  if (hasRequiredBs58check$1) return bs58check$1;
  hasRequiredBs58check$1 = 1;
  var { sha256: s } = /* @__PURE__ */ requireSha256$4(), A = requireBase$3();
  function u(p) {
    return s(s(p));
  }
  return bs58check$1 = A(u), bs58check$1;
}
var hasRequiredP2pkh;
function requireP2pkh() {
  if (hasRequiredP2pkh) return p2pkh;
  hasRequiredP2pkh = 1, Object.defineProperty(p2pkh, "__esModule", { value: !0 }), p2pkh.p2pkh = void 0;
  const s = requireCrypto$3(), A = requireNetworks$1(), u = requireScript$1(), p = requireTypes$9(), t = requireLazy(), l = requireBs58check$1(), m = u.OPS;
  function b(k, C) {
    if (!k.address && !k.hash && !k.output && !k.pubkey && !k.input)
      throw new TypeError("Not enough data");
    C = Object.assign({ validate: !0 }, C || {}), (0, p.typeforce)(
      {
        network: p.typeforce.maybe(p.typeforce.Object),
        address: p.typeforce.maybe(p.typeforce.String),
        hash: p.typeforce.maybe(p.typeforce.BufferN(20)),
        output: p.typeforce.maybe(p.typeforce.BufferN(25)),
        pubkey: p.typeforce.maybe(p.isPoint),
        signature: p.typeforce.maybe(u.isCanonicalScriptSignature),
        input: p.typeforce.maybe(p.typeforce.Buffer)
      },
      k
    );
    const B = t.value(() => {
      const M = Buffer.from(l.decode(k.address)), F = M.readUInt8(0), le = M.slice(1);
      return { version: F, hash: le };
    }), Q = t.value(() => u.decompile(k.input)), P = k.network || A.bitcoin, x = { name: "p2pkh", network: P };
    if (t.prop(x, "address", () => {
      if (!x.hash) return;
      const M = Buffer.allocUnsafe(21);
      return M.writeUInt8(P.pubKeyHash, 0), x.hash.copy(M, 1), l.encode(M);
    }), t.prop(x, "hash", () => {
      if (k.output) return k.output.slice(3, 23);
      if (k.address) return B().hash;
      if (k.pubkey || x.pubkey) return s.hash160(k.pubkey || x.pubkey);
    }), t.prop(x, "output", () => {
      if (x.hash)
        return u.compile([
          m.OP_DUP,
          m.OP_HASH160,
          x.hash,
          m.OP_EQUALVERIFY,
          m.OP_CHECKSIG
        ]);
    }), t.prop(x, "pubkey", () => {
      if (k.input)
        return Q()[1];
    }), t.prop(x, "signature", () => {
      if (k.input)
        return Q()[0];
    }), t.prop(x, "input", () => {
      if (k.pubkey && k.signature)
        return u.compile([k.signature, k.pubkey]);
    }), t.prop(x, "witness", () => {
      if (x.input)
        return [];
    }), C.validate) {
      let M = Buffer.from([]);
      if (k.address) {
        if (B().version !== P.pubKeyHash)
          throw new TypeError("Invalid version or Network mismatch");
        if (B().hash.length !== 20) throw new TypeError("Invalid address");
        M = B().hash;
      }
      if (k.hash) {
        if (M.length > 0 && !M.equals(k.hash))
          throw new TypeError("Hash mismatch");
        M = k.hash;
      }
      if (k.output) {
        if (k.output.length !== 25 || k.output[0] !== m.OP_DUP || k.output[1] !== m.OP_HASH160 || k.output[2] !== 20 || k.output[23] !== m.OP_EQUALVERIFY || k.output[24] !== m.OP_CHECKSIG)
          throw new TypeError("Output is invalid");
        const F = k.output.slice(3, 23);
        if (M.length > 0 && !M.equals(F))
          throw new TypeError("Hash mismatch");
        M = F;
      }
      if (k.pubkey) {
        const F = s.hash160(k.pubkey);
        if (M.length > 0 && !M.equals(F))
          throw new TypeError("Hash mismatch");
        M = F;
      }
      if (k.input) {
        const F = Q();
        if (F.length !== 2) throw new TypeError("Input is invalid");
        if (!u.isCanonicalScriptSignature(F[0]))
          throw new TypeError("Input has invalid signature");
        if (!(0, p.isPoint)(F[1]))
          throw new TypeError("Input has invalid pubkey");
        if (k.signature && !k.signature.equals(F[0]))
          throw new TypeError("Signature mismatch");
        if (k.pubkey && !k.pubkey.equals(F[1]))
          throw new TypeError("Pubkey mismatch");
        const le = s.hash160(F[1]);
        if (M.length > 0 && !M.equals(le))
          throw new TypeError("Hash mismatch");
      }
    }
    return Object.assign(x, k);
  }
  return p2pkh.p2pkh = b, p2pkh;
}
var p2sh = {}, hasRequiredP2sh;
function requireP2sh() {
  if (hasRequiredP2sh) return p2sh;
  hasRequiredP2sh = 1, Object.defineProperty(p2sh, "__esModule", { value: !0 }), p2sh.p2sh = void 0;
  const s = requireCrypto$3(), A = requireNetworks$1(), u = requireScript$1(), p = requireTypes$9(), t = requireLazy(), l = requireBs58check$1(), m = u.OPS;
  function b(k, C) {
    if (!k.address && !k.hash && !k.output && !k.redeem && !k.input)
      throw new TypeError("Not enough data");
    C = Object.assign({ validate: !0 }, C || {}), (0, p.typeforce)(
      {
        network: p.typeforce.maybe(p.typeforce.Object),
        address: p.typeforce.maybe(p.typeforce.String),
        hash: p.typeforce.maybe(p.typeforce.BufferN(20)),
        output: p.typeforce.maybe(p.typeforce.BufferN(23)),
        redeem: p.typeforce.maybe({
          network: p.typeforce.maybe(p.typeforce.Object),
          output: p.typeforce.maybe(p.typeforce.Buffer),
          input: p.typeforce.maybe(p.typeforce.Buffer),
          witness: p.typeforce.maybe(
            p.typeforce.arrayOf(p.typeforce.Buffer)
          )
        }),
        input: p.typeforce.maybe(p.typeforce.Buffer),
        witness: p.typeforce.maybe(
          p.typeforce.arrayOf(p.typeforce.Buffer)
        )
      },
      k
    );
    let B = k.network;
    B || (B = k.redeem && k.redeem.network || A.bitcoin);
    const Q = { network: B }, P = t.value(() => {
      const F = Buffer.from(l.decode(k.address)), le = F.readUInt8(0), ge = F.slice(1);
      return { version: le, hash: ge };
    }), x = t.value(() => u.decompile(k.input)), M = t.value(() => {
      const F = x(), le = F[F.length - 1];
      return {
        network: B,
        output: le === m.OP_FALSE ? Buffer.from([]) : le,
        input: u.compile(F.slice(0, -1)),
        witness: k.witness || []
      };
    });
    if (t.prop(Q, "address", () => {
      if (!Q.hash) return;
      const F = Buffer.allocUnsafe(21);
      return F.writeUInt8(Q.network.scriptHash, 0), Q.hash.copy(F, 1), l.encode(F);
    }), t.prop(Q, "hash", () => {
      if (k.output) return k.output.slice(2, 22);
      if (k.address) return P().hash;
      if (Q.redeem && Q.redeem.output) return s.hash160(Q.redeem.output);
    }), t.prop(Q, "output", () => {
      if (Q.hash)
        return u.compile([m.OP_HASH160, Q.hash, m.OP_EQUAL]);
    }), t.prop(Q, "redeem", () => {
      if (k.input)
        return M();
    }), t.prop(Q, "input", () => {
      if (!(!k.redeem || !k.redeem.input || !k.redeem.output))
        return u.compile(
          [].concat(u.decompile(k.redeem.input), k.redeem.output)
        );
    }), t.prop(Q, "witness", () => {
      if (Q.redeem && Q.redeem.witness) return Q.redeem.witness;
      if (Q.input) return [];
    }), t.prop(Q, "name", () => {
      const F = ["p2sh"];
      return Q.redeem !== void 0 && Q.redeem.name !== void 0 && F.push(Q.redeem.name), F.join("-");
    }), C.validate) {
      let F = Buffer.from([]);
      if (k.address) {
        if (P().version !== B.scriptHash)
          throw new TypeError("Invalid version or Network mismatch");
        if (P().hash.length !== 20) throw new TypeError("Invalid address");
        F = P().hash;
      }
      if (k.hash) {
        if (F.length > 0 && !F.equals(k.hash))
          throw new TypeError("Hash mismatch");
        F = k.hash;
      }
      if (k.output) {
        if (k.output.length !== 23 || k.output[0] !== m.OP_HASH160 || k.output[1] !== 20 || k.output[22] !== m.OP_EQUAL)
          throw new TypeError("Output is invalid");
        const ge = k.output.slice(2, 22);
        if (F.length > 0 && !F.equals(ge))
          throw new TypeError("Hash mismatch");
        F = ge;
      }
      const le = (ge) => {
        if (ge.output) {
          const pe = u.decompile(ge.output);
          if (!pe || pe.length < 1)
            throw new TypeError("Redeem.output too short");
          if (ge.output.byteLength > 520)
            throw new TypeError(
              "Redeem.output unspendable if larger than 520 bytes"
            );
          if (u.countNonPushOnlyOPs(pe) > 201)
            throw new TypeError(
              "Redeem.output unspendable with more than 201 non-push ops"
            );
          const Ie = s.hash160(ge.output);
          if (F.length > 0 && !F.equals(Ie))
            throw new TypeError("Hash mismatch");
          F = Ie;
        }
        if (ge.input) {
          const pe = ge.input.length > 0, Ie = ge.witness && ge.witness.length > 0;
          if (!pe && !Ie) throw new TypeError("Empty input");
          if (pe && Ie)
            throw new TypeError("Input and witness provided");
          if (pe) {
            const be = u.decompile(ge.input);
            if (!u.isPushOnly(be))
              throw new TypeError("Non push-only scriptSig");
          }
        }
      };
      if (k.input) {
        const ge = x();
        if (!ge || ge.length < 1) throw new TypeError("Input too short");
        if (!Buffer.isBuffer(M().output))
          throw new TypeError("Input is invalid");
        le(M());
      }
      if (k.redeem) {
        if (k.redeem.network && k.redeem.network !== B)
          throw new TypeError("Network mismatch");
        if (k.input) {
          const ge = M();
          if (k.redeem.output && !k.redeem.output.equals(ge.output))
            throw new TypeError("Redeem.output mismatch");
          if (k.redeem.input && !k.redeem.input.equals(ge.input))
            throw new TypeError("Redeem.input mismatch");
        }
        le(k.redeem);
      }
      if (k.witness && k.redeem && k.redeem.witness && !(0, p.stacksEqual)(k.redeem.witness, k.witness))
        throw new TypeError("Witness and redeem.witness mismatch");
    }
    return Object.assign(Q, k);
  }
  return p2sh.p2sh = b, p2sh;
}
var p2wpkh = {}, dist$m = {}, hasRequiredDist$m;
function requireDist$m() {
  if (hasRequiredDist$m) return dist$m;
  hasRequiredDist$m = 1, Object.defineProperty(dist$m, "__esModule", { value: !0 }), dist$m.bech32m = dist$m.bech32 = void 0;
  const s = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", A = {};
  for (let C = 0; C < s.length; C++) {
    const B = s.charAt(C);
    A[B] = C;
  }
  function u(C) {
    const B = C >> 25;
    return (C & 33554431) << 5 ^ -(B >> 0 & 1) & 996825010 ^ -(B >> 1 & 1) & 642813549 ^ -(B >> 2 & 1) & 513874426 ^ -(B >> 3 & 1) & 1027748829 ^ -(B >> 4 & 1) & 705979059;
  }
  function p(C) {
    let B = 1;
    for (let Q = 0; Q < C.length; ++Q) {
      const P = C.charCodeAt(Q);
      if (P < 33 || P > 126)
        return "Invalid prefix (" + C + ")";
      B = u(B) ^ P >> 5;
    }
    B = u(B);
    for (let Q = 0; Q < C.length; ++Q) {
      const P = C.charCodeAt(Q);
      B = u(B) ^ P & 31;
    }
    return B;
  }
  function t(C, B, Q, P) {
    let x = 0, M = 0;
    const F = (1 << Q) - 1, le = [];
    for (let ge = 0; ge < C.length; ++ge)
      for (x = x << B | C[ge], M += B; M >= Q; )
        M -= Q, le.push(x >> M & F);
    if (P)
      M > 0 && le.push(x << Q - M & F);
    else {
      if (M >= B)
        return "Excess padding";
      if (x << Q - M & F)
        return "Non-zero padding";
    }
    return le;
  }
  function l(C) {
    return t(C, 8, 5, !0);
  }
  function m(C) {
    const B = t(C, 5, 8, !1);
    if (Array.isArray(B))
      return B;
  }
  function b(C) {
    const B = t(C, 5, 8, !1);
    if (Array.isArray(B))
      return B;
    throw new Error(B);
  }
  function k(C) {
    let B;
    C === "bech32" ? B = 1 : B = 734539939;
    function Q(F, le, ge) {
      if (ge = ge || 90, F.length + 7 + le.length > ge)
        throw new TypeError("Exceeds length limit");
      F = F.toLowerCase();
      let pe = p(F);
      if (typeof pe == "string")
        throw new Error(pe);
      let Ie = F + "1";
      for (let be = 0; be < le.length; ++be) {
        const Pe = le[be];
        if (Pe >> 5 !== 0)
          throw new Error("Non 5-bit word");
        pe = u(pe) ^ Pe, Ie += s.charAt(Pe);
      }
      for (let be = 0; be < 6; ++be)
        pe = u(pe);
      pe ^= B;
      for (let be = 0; be < 6; ++be) {
        const Pe = pe >> (5 - be) * 5 & 31;
        Ie += s.charAt(Pe);
      }
      return Ie;
    }
    function P(F, le) {
      if (le = le || 90, F.length < 8)
        return F + " too short";
      if (F.length > le)
        return "Exceeds length limit";
      const ge = F.toLowerCase(), pe = F.toUpperCase();
      if (F !== ge && F !== pe)
        return "Mixed-case string " + F;
      F = ge;
      const Ie = F.lastIndexOf("1");
      if (Ie === -1)
        return "No separator character for " + F;
      if (Ie === 0)
        return "Missing prefix for " + F;
      const be = F.slice(0, Ie), Pe = F.slice(Ie + 1);
      if (Pe.length < 6)
        return "Data too short";
      let Te = p(be);
      if (typeof Te == "string")
        return Te;
      const Qe = [];
      for (let xe = 0; xe < Pe.length; ++xe) {
        const Ee = Pe.charAt(xe), He = A[Ee];
        if (He === void 0)
          return "Unknown character " + Ee;
        Te = u(Te) ^ He, !(xe + 6 >= Pe.length) && Qe.push(He);
      }
      return Te !== B ? "Invalid checksum for " + F : { prefix: be, words: Qe };
    }
    function x(F, le) {
      const ge = P(F, le);
      if (typeof ge == "object")
        return ge;
    }
    function M(F, le) {
      const ge = P(F, le);
      if (typeof ge == "object")
        return ge;
      throw new Error(ge);
    }
    return {
      decodeUnsafe: x,
      decode: M,
      encode: Q,
      toWords: l,
      fromWordsUnsafe: m,
      fromWords: b
    };
  }
  return dist$m.bech32 = k("bech32"), dist$m.bech32m = k("bech32m"), dist$m;
}
var hasRequiredP2wpkh;
function requireP2wpkh() {
  if (hasRequiredP2wpkh) return p2wpkh;
  hasRequiredP2wpkh = 1, Object.defineProperty(p2wpkh, "__esModule", { value: !0 }), p2wpkh.p2wpkh = void 0;
  const s = requireCrypto$3(), A = requireNetworks$1(), u = requireScript$1(), p = requireTypes$9(), t = requireLazy(), l = requireDist$m(), m = u.OPS, b = Buffer.alloc(0);
  function k(C, B) {
    if (!C.address && !C.hash && !C.output && !C.pubkey && !C.witness)
      throw new TypeError("Not enough data");
    B = Object.assign({ validate: !0 }, B || {}), (0, p.typeforce)(
      {
        address: p.typeforce.maybe(p.typeforce.String),
        hash: p.typeforce.maybe(p.typeforce.BufferN(20)),
        input: p.typeforce.maybe(p.typeforce.BufferN(0)),
        network: p.typeforce.maybe(p.typeforce.Object),
        output: p.typeforce.maybe(p.typeforce.BufferN(22)),
        pubkey: p.typeforce.maybe(p.isPoint),
        signature: p.typeforce.maybe(u.isCanonicalScriptSignature),
        witness: p.typeforce.maybe(
          p.typeforce.arrayOf(p.typeforce.Buffer)
        )
      },
      C
    );
    const Q = t.value(() => {
      const M = l.bech32.decode(C.address), F = M.words.shift(), le = l.bech32.fromWords(M.words);
      return {
        version: F,
        prefix: M.prefix,
        data: Buffer.from(le)
      };
    }), P = C.network || A.bitcoin, x = { name: "p2wpkh", network: P };
    if (t.prop(x, "address", () => {
      if (!x.hash) return;
      const M = l.bech32.toWords(x.hash);
      return M.unshift(0), l.bech32.encode(P.bech32, M);
    }), t.prop(x, "hash", () => {
      if (C.output) return C.output.slice(2, 22);
      if (C.address) return Q().data;
      if (C.pubkey || x.pubkey) return s.hash160(C.pubkey || x.pubkey);
    }), t.prop(x, "output", () => {
      if (x.hash)
        return u.compile([m.OP_0, x.hash]);
    }), t.prop(x, "pubkey", () => {
      if (C.pubkey) return C.pubkey;
      if (C.witness)
        return C.witness[1];
    }), t.prop(x, "signature", () => {
      if (C.witness)
        return C.witness[0];
    }), t.prop(x, "input", () => {
      if (x.witness)
        return b;
    }), t.prop(x, "witness", () => {
      if (C.pubkey && C.signature)
        return [C.signature, C.pubkey];
    }), B.validate) {
      let M = Buffer.from([]);
      if (C.address) {
        if (P && P.bech32 !== Q().prefix)
          throw new TypeError("Invalid prefix or Network mismatch");
        if (Q().version !== 0)
          throw new TypeError("Invalid address version");
        if (Q().data.length !== 20)
          throw new TypeError("Invalid address data");
        M = Q().data;
      }
      if (C.hash) {
        if (M.length > 0 && !M.equals(C.hash))
          throw new TypeError("Hash mismatch");
        M = C.hash;
      }
      if (C.output) {
        if (C.output.length !== 22 || C.output[0] !== m.OP_0 || C.output[1] !== 20)
          throw new TypeError("Output is invalid");
        if (M.length > 0 && !M.equals(C.output.slice(2)))
          throw new TypeError("Hash mismatch");
        M = C.output.slice(2);
      }
      if (C.pubkey) {
        const F = s.hash160(C.pubkey);
        if (M.length > 0 && !M.equals(F))
          throw new TypeError("Hash mismatch");
        if (M = F, !(0, p.isPoint)(C.pubkey) || C.pubkey.length !== 33)
          throw new TypeError("Invalid pubkey for p2wpkh");
      }
      if (C.witness) {
        if (C.witness.length !== 2) throw new TypeError("Witness is invalid");
        if (!u.isCanonicalScriptSignature(C.witness[0]))
          throw new TypeError("Witness has invalid signature");
        if (!(0, p.isPoint)(C.witness[1]) || C.witness[1].length !== 33)
          throw new TypeError("Witness has invalid pubkey");
        if (C.signature && !C.signature.equals(C.witness[0]))
          throw new TypeError("Signature mismatch");
        if (C.pubkey && !C.pubkey.equals(C.witness[1]))
          throw new TypeError("Pubkey mismatch");
        const F = s.hash160(C.witness[1]);
        if (M.length > 0 && !M.equals(F))
          throw new TypeError("Hash mismatch");
      }
    }
    return Object.assign(x, C);
  }
  return p2wpkh.p2wpkh = k, p2wpkh;
}
var p2wsh = {}, hasRequiredP2wsh;
function requireP2wsh() {
  if (hasRequiredP2wsh) return p2wsh;
  hasRequiredP2wsh = 1, Object.defineProperty(p2wsh, "__esModule", { value: !0 }), p2wsh.p2wsh = void 0;
  const s = requireCrypto$3(), A = requireNetworks$1(), u = requireScript$1(), p = requireTypes$9(), t = requireLazy(), l = requireDist$m(), m = u.OPS, b = Buffer.alloc(0);
  function k(B) {
    return !!(Buffer.isBuffer(B) && B.length === 65 && B[0] === 4 && (0, p.isPoint)(B));
  }
  function C(B, Q) {
    if (!B.address && !B.hash && !B.output && !B.redeem && !B.witness)
      throw new TypeError("Not enough data");
    Q = Object.assign({ validate: !0 }, Q || {}), (0, p.typeforce)(
      {
        network: p.typeforce.maybe(p.typeforce.Object),
        address: p.typeforce.maybe(p.typeforce.String),
        hash: p.typeforce.maybe(p.typeforce.BufferN(32)),
        output: p.typeforce.maybe(p.typeforce.BufferN(34)),
        redeem: p.typeforce.maybe({
          input: p.typeforce.maybe(p.typeforce.Buffer),
          network: p.typeforce.maybe(p.typeforce.Object),
          output: p.typeforce.maybe(p.typeforce.Buffer),
          witness: p.typeforce.maybe(
            p.typeforce.arrayOf(p.typeforce.Buffer)
          )
        }),
        input: p.typeforce.maybe(p.typeforce.BufferN(0)),
        witness: p.typeforce.maybe(
          p.typeforce.arrayOf(p.typeforce.Buffer)
        )
      },
      B
    );
    const P = t.value(() => {
      const le = l.bech32.decode(B.address), ge = le.words.shift(), pe = l.bech32.fromWords(le.words);
      return {
        version: ge,
        prefix: le.prefix,
        data: Buffer.from(pe)
      };
    }), x = t.value(() => u.decompile(B.redeem.input));
    let M = B.network;
    M || (M = B.redeem && B.redeem.network || A.bitcoin);
    const F = { network: M };
    if (t.prop(F, "address", () => {
      if (!F.hash) return;
      const le = l.bech32.toWords(F.hash);
      return le.unshift(0), l.bech32.encode(M.bech32, le);
    }), t.prop(F, "hash", () => {
      if (B.output) return B.output.slice(2);
      if (B.address) return P().data;
      if (F.redeem && F.redeem.output) return s.sha256(F.redeem.output);
    }), t.prop(F, "output", () => {
      if (F.hash)
        return u.compile([m.OP_0, F.hash]);
    }), t.prop(F, "redeem", () => {
      if (B.witness)
        return {
          output: B.witness[B.witness.length - 1],
          input: b,
          witness: B.witness.slice(0, -1)
        };
    }), t.prop(F, "input", () => {
      if (F.witness)
        return b;
    }), t.prop(F, "witness", () => {
      if (B.redeem && B.redeem.input && B.redeem.input.length > 0 && B.redeem.output && B.redeem.output.length > 0) {
        const le = u.toStack(x());
        return F.redeem = Object.assign({ witness: le }, B.redeem), F.redeem.input = b, [].concat(le, B.redeem.output);
      }
      if (B.redeem && B.redeem.output && B.redeem.witness)
        return [].concat(B.redeem.witness, B.redeem.output);
    }), t.prop(F, "name", () => {
      const le = ["p2wsh"];
      return F.redeem !== void 0 && F.redeem.name !== void 0 && le.push(F.redeem.name), le.join("-");
    }), Q.validate) {
      let le = Buffer.from([]);
      if (B.address) {
        if (P().prefix !== M.bech32)
          throw new TypeError("Invalid prefix or Network mismatch");
        if (P().version !== 0)
          throw new TypeError("Invalid address version");
        if (P().data.length !== 32)
          throw new TypeError("Invalid address data");
        le = P().data;
      }
      if (B.hash) {
        if (le.length > 0 && !le.equals(B.hash))
          throw new TypeError("Hash mismatch");
        le = B.hash;
      }
      if (B.output) {
        if (B.output.length !== 34 || B.output[0] !== m.OP_0 || B.output[1] !== 32)
          throw new TypeError("Output is invalid");
        const ge = B.output.slice(2);
        if (le.length > 0 && !le.equals(ge))
          throw new TypeError("Hash mismatch");
        le = ge;
      }
      if (B.redeem) {
        if (B.redeem.network && B.redeem.network !== M)
          throw new TypeError("Network mismatch");
        if (B.redeem.input && B.redeem.input.length > 0 && B.redeem.witness && B.redeem.witness.length > 0)
          throw new TypeError("Ambiguous witness source");
        if (B.redeem.output) {
          const ge = u.decompile(B.redeem.output);
          if (!ge || ge.length < 1)
            throw new TypeError("Redeem.output is invalid");
          if (B.redeem.output.byteLength > 3600)
            throw new TypeError(
              "Redeem.output unspendable if larger than 3600 bytes"
            );
          if (u.countNonPushOnlyOPs(ge) > 201)
            throw new TypeError(
              "Redeem.output unspendable with more than 201 non-push ops"
            );
          const pe = s.sha256(B.redeem.output);
          if (le.length > 0 && !le.equals(pe))
            throw new TypeError("Hash mismatch");
          le = pe;
        }
        if (B.redeem.input && !u.isPushOnly(x()))
          throw new TypeError("Non push-only scriptSig");
        if (B.witness && B.redeem.witness && !(0, p.stacksEqual)(B.witness, B.redeem.witness))
          throw new TypeError("Witness and redeem.witness mismatch");
        if (B.redeem.input && x().some(k) || B.redeem.output && (u.decompile(B.redeem.output) || []).some(
          k
        ))
          throw new TypeError(
            "redeem.input or redeem.output contains uncompressed pubkey"
          );
      }
      if (B.witness && B.witness.length > 0) {
        const ge = B.witness[B.witness.length - 1];
        if (B.redeem && B.redeem.output && !B.redeem.output.equals(ge))
          throw new TypeError("Witness and redeem.output mismatch");
        if (B.witness.some(k) || (u.decompile(ge) || []).some(k))
          throw new TypeError("Witness contains uncompressed pubkey");
      }
    }
    return Object.assign(F, B);
  }
  return p2wsh.p2wsh = C, p2wsh;
}
var p2tr = {}, ecc_lib = {}, hasRequiredEcc_lib;
function requireEcc_lib() {
  if (hasRequiredEcc_lib) return ecc_lib;
  hasRequiredEcc_lib = 1, Object.defineProperty(ecc_lib, "__esModule", { value: !0 }), ecc_lib.getEccLib = ecc_lib.initEccLib = void 0;
  const s = {};
  function A(b, k) {
    b ? b !== s.eccLib && (k != null && k.DANGER_DO_NOT_VERIFY_ECCLIB || t(b), s.eccLib = b) : s.eccLib = b;
  }
  ecc_lib.initEccLib = A;
  function u() {
    if (!s.eccLib)
      throw new Error(
        "No ECC Library provided. You must call initEccLib() with a valid TinySecp256k1Interface instance"
      );
    return s.eccLib;
  }
  ecc_lib.getEccLib = u;
  const p = (b) => Buffer.from(b, "hex");
  function t(b) {
    l(typeof b.isXOnlyPoint == "function"), l(
      b.isXOnlyPoint(
        p("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798")
      )
    ), l(
      b.isXOnlyPoint(
        p("fffffffffffffffffffffffffffffffffffffffffffffffffffffffeeffffc2e")
      )
    ), l(
      b.isXOnlyPoint(
        p("f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9")
      )
    ), l(
      b.isXOnlyPoint(
        p("0000000000000000000000000000000000000000000000000000000000000001")
      )
    ), l(
      !b.isXOnlyPoint(
        p("0000000000000000000000000000000000000000000000000000000000000000")
      )
    ), l(
      !b.isXOnlyPoint(
        p("fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f")
      )
    ), l(typeof b.xOnlyPointAddTweak == "function"), m.forEach((k) => {
      const C = b.xOnlyPointAddTweak(p(k.pubkey), p(k.tweak));
      k.result === null ? l(C === null) : (l(C !== null), l(C.parity === k.parity), l(Buffer.from(C.xOnlyPubkey).equals(p(k.result))));
    });
  }
  function l(b) {
    if (!b) throw new Error("ecc library invalid");
  }
  const m = [
    {
      pubkey: "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
      tweak: "fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140",
      parity: -1,
      result: null
    },
    {
      pubkey: "1617d38ed8d8657da4d4761e8057bc396ea9e4b9d29776d4be096016dbd2509b",
      tweak: "a8397a935f0dfceba6ba9618f6451ef4d80637abf4e6af2669fbc9de6a8fd2ac",
      parity: 1,
      result: "e478f99dab91052ab39a33ea35fd5e6e4933f4d28023cd597c9a1f6760346adf"
    },
    {
      pubkey: "2c0b7cf95324a07d05398b240174dc0c2be444d96b159aa6c7f7b1e668680991",
      tweak: "823c3cd2142744b075a87eade7e1b8678ba308d566226a0056ca2b7a76f86b47",
      parity: 0,
      result: "9534f8dc8c6deda2dc007655981c78b49c5d96c778fbf363462a11ec9dfd948c"
    }
  ];
  return ecc_lib;
}
var bip341 = {}, bufferutils = {}, safeBuffer$1 = { exports: {} };
var hasRequiredSafeBuffer$1;
function requireSafeBuffer$1() {
  return hasRequiredSafeBuffer$1 || (hasRequiredSafeBuffer$1 = 1, function(s, A) {
    var u = requireDist$n(), p = u.Buffer;
    function t(m, b) {
      for (var k in m)
        b[k] = m[k];
    }
    p.from && p.alloc && p.allocUnsafe && p.allocUnsafeSlow ? s.exports = u : (t(u, A), A.Buffer = l);
    function l(m, b, k) {
      return p(m, b, k);
    }
    l.prototype = Object.create(p.prototype), t(p, l), l.from = function(m, b, k) {
      if (typeof m == "number")
        throw new TypeError("Argument must not be a number");
      return p(m, b, k);
    }, l.alloc = function(m, b, k) {
      if (typeof m != "number")
        throw new TypeError("Argument must be a number");
      var C = p(m);
      return b !== void 0 ? typeof k == "string" ? C.fill(b, k) : C.fill(b) : C.fill(0), C;
    }, l.allocUnsafe = function(m) {
      if (typeof m != "number")
        throw new TypeError("Argument must be a number");
      return p(m);
    }, l.allocUnsafeSlow = function(m) {
      if (typeof m != "number")
        throw new TypeError("Argument must be a number");
      return u.SlowBuffer(m);
    };
  }(safeBuffer$1, safeBuffer$1.exports)), safeBuffer$1.exports;
}
var varuintBitcoin, hasRequiredVaruintBitcoin;
function requireVaruintBitcoin() {
  if (hasRequiredVaruintBitcoin) return varuintBitcoin;
  hasRequiredVaruintBitcoin = 1;
  var s = requireSafeBuffer$1().Buffer, A = 9007199254740991;
  function u(m) {
    if (m < 0 || m > A || m % 1 !== 0) throw new RangeError("value out of range");
  }
  function p(m, b, k) {
    if (u(m), b || (b = s.allocUnsafe(l(m))), !s.isBuffer(b)) throw new TypeError("buffer must be a Buffer instance");
    return k || (k = 0), m < 253 ? (b.writeUInt8(m, k), p.bytes = 1) : m <= 65535 ? (b.writeUInt8(253, k), b.writeUInt16LE(m, k + 1), p.bytes = 3) : m <= 4294967295 ? (b.writeUInt8(254, k), b.writeUInt32LE(m, k + 1), p.bytes = 5) : (b.writeUInt8(255, k), b.writeUInt32LE(m >>> 0, k + 1), b.writeUInt32LE(m / 4294967296 | 0, k + 5), p.bytes = 9), b;
  }
  function t(m, b) {
    if (!s.isBuffer(m)) throw new TypeError("buffer must be a Buffer instance");
    b || (b = 0);
    var k = m.readUInt8(b);
    if (k < 253)
      return t.bytes = 1, k;
    if (k === 253)
      return t.bytes = 3, m.readUInt16LE(b + 1);
    if (k === 254)
      return t.bytes = 5, m.readUInt32LE(b + 1);
    t.bytes = 9;
    var C = m.readUInt32LE(b + 1), B = m.readUInt32LE(b + 5), Q = B * 4294967296 + C;
    return u(Q), Q;
  }
  function l(m) {
    return u(m), m < 253 ? 1 : m <= 65535 ? 3 : m <= 4294967295 ? 5 : 9;
  }
  return varuintBitcoin = { encode: p, decode: t, encodingLength: l }, varuintBitcoin;
}
var hasRequiredBufferutils;
function requireBufferutils() {
  if (hasRequiredBufferutils) return bufferutils;
  hasRequiredBufferutils = 1, Object.defineProperty(bufferutils, "__esModule", { value: !0 }), bufferutils.BufferReader = bufferutils.BufferWriter = bufferutils.cloneBuffer = bufferutils.reverseBuffer = bufferutils.writeUInt64LE = bufferutils.readUInt64LE = bufferutils.varuint = void 0;
  const s = requireTypes$9(), { typeforce: A } = s, u = requireVaruintBitcoin();
  bufferutils.varuint = u;
  function p(B, Q) {
    if (typeof B != "number")
      throw new Error("cannot write a non-number as a number");
    if (B < 0)
      throw new Error("specified a negative value for writing an unsigned value");
    if (B > Q) throw new Error("RangeError: value out of range");
    if (Math.floor(B) !== B)
      throw new Error("value has a fractional component");
  }
  function t(B, Q) {
    const P = B.readUInt32LE(Q);
    let x = B.readUInt32LE(Q + 4);
    return x *= 4294967296, p(x + P, 9007199254740991), x + P;
  }
  bufferutils.readUInt64LE = t;
  function l(B, Q, P) {
    return p(Q, 9007199254740991), B.writeInt32LE(Q & -1, P), B.writeUInt32LE(Math.floor(Q / 4294967296), P + 4), P + 8;
  }
  bufferutils.writeUInt64LE = l;
  function m(B) {
    if (B.length < 1) return B;
    let Q = B.length - 1, P = 0;
    for (let x = 0; x < B.length / 2; x++)
      P = B[x], B[x] = B[Q], B[Q] = P, Q--;
    return B;
  }
  bufferutils.reverseBuffer = m;
  function b(B) {
    const Q = Buffer.allocUnsafe(B.length);
    return B.copy(Q), Q;
  }
  bufferutils.cloneBuffer = b;
  class k {
    static withCapacity(Q) {
      return new k(Buffer.alloc(Q));
    }
    constructor(Q, P = 0) {
      this.buffer = Q, this.offset = P, A(s.tuple(s.Buffer, s.UInt32), [Q, P]);
    }
    writeUInt8(Q) {
      this.offset = this.buffer.writeUInt8(Q, this.offset);
    }
    writeInt32(Q) {
      this.offset = this.buffer.writeInt32LE(Q, this.offset);
    }
    writeUInt32(Q) {
      this.offset = this.buffer.writeUInt32LE(Q, this.offset);
    }
    writeUInt64(Q) {
      this.offset = l(this.buffer, Q, this.offset);
    }
    writeVarInt(Q) {
      u.encode(Q, this.buffer, this.offset), this.offset += u.encode.bytes;
    }
    writeSlice(Q) {
      if (this.buffer.length < this.offset + Q.length)
        throw new Error("Cannot write slice out of bounds");
      this.offset += Q.copy(this.buffer, this.offset);
    }
    writeVarSlice(Q) {
      this.writeVarInt(Q.length), this.writeSlice(Q);
    }
    writeVector(Q) {
      this.writeVarInt(Q.length), Q.forEach((P) => this.writeVarSlice(P));
    }
    end() {
      if (this.buffer.length === this.offset)
        return this.buffer;
      throw new Error(`buffer size ${this.buffer.length}, offset ${this.offset}`);
    }
  }
  bufferutils.BufferWriter = k;
  class C {
    constructor(Q, P = 0) {
      this.buffer = Q, this.offset = P, A(s.tuple(s.Buffer, s.UInt32), [Q, P]);
    }
    readUInt8() {
      const Q = this.buffer.readUInt8(this.offset);
      return this.offset++, Q;
    }
    readInt32() {
      const Q = this.buffer.readInt32LE(this.offset);
      return this.offset += 4, Q;
    }
    readUInt32() {
      const Q = this.buffer.readUInt32LE(this.offset);
      return this.offset += 4, Q;
    }
    readUInt64() {
      const Q = t(this.buffer, this.offset);
      return this.offset += 8, Q;
    }
    readVarInt() {
      const Q = u.decode(this.buffer, this.offset);
      return this.offset += u.decode.bytes, Q;
    }
    readSlice(Q) {
      if (this.buffer.length < this.offset + Q)
        throw new Error("Cannot read slice out of bounds");
      const P = this.buffer.slice(this.offset, this.offset + Q);
      return this.offset += Q, P;
    }
    readVarSlice() {
      return this.readSlice(this.readVarInt());
    }
    readVector() {
      const Q = this.readVarInt(), P = [];
      for (let x = 0; x < Q; x++) P.push(this.readVarSlice());
      return P;
    }
  }
  return bufferutils.BufferReader = C, bufferutils;
}
var hasRequiredBip341;
function requireBip341() {
  return hasRequiredBip341 || (hasRequiredBip341 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.tweakKey = s.tapTweakHash = s.tapleafHash = s.findScriptPath = s.toHashTree = s.rootHashFromPath = s.MAX_TAPTREE_DEPTH = s.LEAF_VERSION_TAPSCRIPT = void 0;
    const A = requireDist$n(), u = requireEcc_lib(), p = requireCrypto$3(), t = requireBufferutils(), l = requireTypes$9();
    s.LEAF_VERSION_TAPSCRIPT = 192, s.MAX_TAPTREE_DEPTH = 128;
    const m = (F) => "left" in F && "right" in F;
    function b(F, le) {
      if (F.length < 33)
        throw new TypeError(
          `The control-block length is too small. Got ${F.length}, expected min 33.`
        );
      const ge = (F.length - 33) / 32;
      let pe = le;
      for (let Ie = 0; Ie < ge; Ie++) {
        const be = F.slice(33 + 32 * Ie, 65 + 32 * Ie);
        pe.compare(be) < 0 ? pe = x(pe, be) : pe = x(be, pe);
      }
      return pe;
    }
    s.rootHashFromPath = b;
    function k(F) {
      if ((0, l.isTapleaf)(F))
        return { hash: B(F) };
      const le = [k(F[0]), k(F[1])];
      le.sort((Ie, be) => Ie.hash.compare(be.hash));
      const [ge, pe] = le;
      return {
        hash: x(ge.hash, pe.hash),
        left: ge,
        right: pe
      };
    }
    s.toHashTree = k;
    function C(F, le) {
      if (m(F)) {
        const ge = C(F.left, le);
        if (ge !== void 0) return [...ge, F.right.hash];
        const pe = C(F.right, le);
        if (pe !== void 0) return [...pe, F.left.hash];
      } else if (F.hash.equals(le))
        return [];
    }
    s.findScriptPath = C;
    function B(F) {
      const le = F.version || s.LEAF_VERSION_TAPSCRIPT;
      return p.taggedHash(
        "TapLeaf",
        A.Buffer.concat([
          A.Buffer.from([le]),
          M(F.output)
        ])
      );
    }
    s.tapleafHash = B;
    function Q(F, le) {
      return p.taggedHash(
        "TapTweak",
        A.Buffer.concat(le ? [F, le] : [F])
      );
    }
    s.tapTweakHash = Q;
    function P(F, le) {
      if (!A.Buffer.isBuffer(F) || F.length !== 32 || le && le.length !== 32) return null;
      const ge = Q(F, le), pe = (0, u.getEccLib)().xOnlyPointAddTweak(F, ge);
      return !pe || pe.xOnlyPubkey === null ? null : {
        parity: pe.parity,
        x: A.Buffer.from(pe.xOnlyPubkey)
      };
    }
    s.tweakKey = P;
    function x(F, le) {
      return p.taggedHash("TapBranch", A.Buffer.concat([F, le]));
    }
    function M(F) {
      const le = t.varuint.encodingLength(F.length), ge = A.Buffer.allocUnsafe(le);
      return t.varuint.encode(F.length, ge), A.Buffer.concat([ge, F]);
    }
  }(bip341)), bip341;
}
var hasRequiredP2tr;
function requireP2tr() {
  if (hasRequiredP2tr) return p2tr;
  hasRequiredP2tr = 1, Object.defineProperty(p2tr, "__esModule", { value: !0 }), p2tr.p2tr = void 0;
  const s = requireDist$n(), A = requireNetworks$1(), u = requireScript$1(), p = requireTypes$9(), t = requireEcc_lib(), l = requireBip341(), m = requireLazy(), b = requireDist$m(), k = requireAddress$1(), C = u.OPS, B = 1, Q = 80;
  function P(x, M) {
    if (!x.address && !x.output && !x.pubkey && !x.internalPubkey && !(x.witness && x.witness.length > 1))
      throw new TypeError("Not enough data");
    M = Object.assign({ validate: !0 }, M || {}), (0, p.typeforce)(
      {
        address: p.typeforce.maybe(p.typeforce.String),
        input: p.typeforce.maybe(p.typeforce.BufferN(0)),
        network: p.typeforce.maybe(p.typeforce.Object),
        output: p.typeforce.maybe(p.typeforce.BufferN(34)),
        internalPubkey: p.typeforce.maybe(p.typeforce.BufferN(32)),
        hash: p.typeforce.maybe(p.typeforce.BufferN(32)),
        pubkey: p.typeforce.maybe(p.typeforce.BufferN(32)),
        signature: p.typeforce.maybe(
          p.typeforce.anyOf(
            p.typeforce.BufferN(64),
            p.typeforce.BufferN(65)
          )
        ),
        witness: p.typeforce.maybe(
          p.typeforce.arrayOf(p.typeforce.Buffer)
        ),
        scriptTree: p.typeforce.maybe(p.isTaptree),
        redeem: p.typeforce.maybe({
          output: p.typeforce.maybe(p.typeforce.Buffer),
          redeemVersion: p.typeforce.maybe(p.typeforce.Number),
          witness: p.typeforce.maybe(
            p.typeforce.arrayOf(p.typeforce.Buffer)
          )
        }),
        redeemVersion: p.typeforce.maybe(p.typeforce.Number)
      },
      x
    );
    const F = m.value(() => (0, k.fromBech32)(x.address)), le = m.value(() => {
      if (!(!x.witness || !x.witness.length))
        return x.witness.length >= 2 && x.witness[x.witness.length - 1][0] === Q ? x.witness.slice(0, -1) : x.witness.slice();
    }), ge = m.value(() => {
      if (x.scriptTree) return (0, l.toHashTree)(x.scriptTree);
      if (x.hash) return { hash: x.hash };
    }), pe = x.network || A.bitcoin, Ie = { name: "p2tr", network: pe };
    if (m.prop(Ie, "address", () => {
      if (!Ie.pubkey) return;
      const be = b.bech32m.toWords(Ie.pubkey);
      return be.unshift(B), b.bech32m.encode(pe.bech32, be);
    }), m.prop(Ie, "hash", () => {
      const be = ge();
      if (be) return be.hash;
      const Pe = le();
      if (Pe && Pe.length > 1) {
        const Te = Pe[Pe.length - 1], Qe = Te[0] & p.TAPLEAF_VERSION_MASK, xe = Pe[Pe.length - 2], Ee = (0, l.tapleafHash)({
          output: xe,
          version: Qe
        });
        return (0, l.rootHashFromPath)(Te, Ee);
      }
      return null;
    }), m.prop(Ie, "output", () => {
      if (Ie.pubkey)
        return u.compile([C.OP_1, Ie.pubkey]);
    }), m.prop(Ie, "redeemVersion", () => x.redeemVersion ? x.redeemVersion : x.redeem && x.redeem.redeemVersion !== void 0 && x.redeem.redeemVersion !== null ? x.redeem.redeemVersion : l.LEAF_VERSION_TAPSCRIPT), m.prop(Ie, "redeem", () => {
      const be = le();
      if (!(!be || be.length < 2))
        return {
          output: be[be.length - 2],
          witness: be.slice(0, -2),
          redeemVersion: be[be.length - 1][0] & p.TAPLEAF_VERSION_MASK
        };
    }), m.prop(Ie, "pubkey", () => {
      if (x.pubkey) return x.pubkey;
      if (x.output) return x.output.slice(2);
      if (x.address) return F().data;
      if (Ie.internalPubkey) {
        const be = (0, l.tweakKey)(Ie.internalPubkey, Ie.hash);
        if (be) return be.x;
      }
    }), m.prop(Ie, "internalPubkey", () => {
      if (x.internalPubkey) return x.internalPubkey;
      const be = le();
      if (be && be.length > 1)
        return be[be.length - 1].slice(1, 33);
    }), m.prop(Ie, "signature", () => {
      if (x.signature) return x.signature;
      const be = le();
      if (!(!be || be.length !== 1))
        return be[0];
    }), m.prop(Ie, "witness", () => {
      if (x.witness) return x.witness;
      const be = ge();
      if (be && x.redeem && x.redeem.output && x.internalPubkey) {
        const Pe = (0, l.tapleafHash)({
          output: x.redeem.output,
          version: Ie.redeemVersion
        }), Te = (0, l.findScriptPath)(be, Pe);
        if (!Te) return;
        const Qe = (0, l.tweakKey)(x.internalPubkey, be.hash);
        if (!Qe) return;
        const xe = s.Buffer.concat(
          [
            s.Buffer.from([Ie.redeemVersion | Qe.parity]),
            x.internalPubkey
          ].concat(Te)
        );
        return [x.redeem.output, xe];
      }
      if (x.signature) return [x.signature];
    }), M.validate) {
      let be = s.Buffer.from([]);
      if (x.address) {
        if (pe && pe.bech32 !== F().prefix)
          throw new TypeError("Invalid prefix or Network mismatch");
        if (F().version !== B)
          throw new TypeError("Invalid address version");
        if (F().data.length !== 32)
          throw new TypeError("Invalid address data");
        be = F().data;
      }
      if (x.pubkey) {
        if (be.length > 0 && !be.equals(x.pubkey))
          throw new TypeError("Pubkey mismatch");
        be = x.pubkey;
      }
      if (x.output) {
        if (x.output.length !== 34 || x.output[0] !== C.OP_1 || x.output[1] !== 32)
          throw new TypeError("Output is invalid");
        if (be.length > 0 && !be.equals(x.output.slice(2)))
          throw new TypeError("Pubkey mismatch");
        be = x.output.slice(2);
      }
      if (x.internalPubkey) {
        const Qe = (0, l.tweakKey)(x.internalPubkey, Ie.hash);
        if (be.length > 0 && !be.equals(Qe.x))
          throw new TypeError("Pubkey mismatch");
        be = Qe.x;
      }
      if (be && be.length && !(0, t.getEccLib)().isXOnlyPoint(be))
        throw new TypeError("Invalid pubkey for p2tr");
      const Pe = ge();
      if (x.hash && Pe && !x.hash.equals(Pe.hash))
        throw new TypeError("Hash mismatch");
      if (x.redeem && x.redeem.output && Pe) {
        const Qe = (0, l.tapleafHash)({
          output: x.redeem.output,
          version: Ie.redeemVersion
        });
        if (!(0, l.findScriptPath)(Pe, Qe))
          throw new TypeError("Redeem script not in tree");
      }
      const Te = le();
      if (x.redeem && Ie.redeem) {
        if (x.redeem.redeemVersion && x.redeem.redeemVersion !== Ie.redeem.redeemVersion)
          throw new TypeError("Redeem.redeemVersion and witness mismatch");
        if (x.redeem.output) {
          if (u.decompile(x.redeem.output).length === 0)
            throw new TypeError("Redeem.output is invalid");
          if (Ie.redeem.output && !x.redeem.output.equals(Ie.redeem.output))
            throw new TypeError("Redeem.output and witness mismatch");
        }
        if (x.redeem.witness && Ie.redeem.witness && !(0, p.stacksEqual)(x.redeem.witness, Ie.redeem.witness))
          throw new TypeError("Redeem.witness and witness mismatch");
      }
      if (Te && Te.length)
        if (Te.length === 1) {
          if (x.signature && !x.signature.equals(Te[0]))
            throw new TypeError("Signature mismatch");
        } else {
          const Qe = Te[Te.length - 1];
          if (Qe.length < 33)
            throw new TypeError(
              `The control-block length is too small. Got ${Qe.length}, expected min 33.`
            );
          if ((Qe.length - 33) % 32 !== 0)
            throw new TypeError(
              `The control-block length of ${Qe.length} is incorrect!`
            );
          const xe = (Qe.length - 33) / 32;
          if (xe > 128)
            throw new TypeError(
              `The script path is too long. Got ${xe}, expected max 128.`
            );
          const Ee = Qe.slice(1, 33);
          if (x.internalPubkey && !x.internalPubkey.equals(Ee))
            throw new TypeError("Internal pubkey mismatch");
          if (!(0, t.getEccLib)().isXOnlyPoint(Ee))
            throw new TypeError("Invalid internalPubkey for p2tr witness");
          const He = Qe[0] & p.TAPLEAF_VERSION_MASK, ve = Te[Te.length - 2], we = (0, l.tapleafHash)({
            output: ve,
            version: He
          }), Ce = (0, l.rootHashFromPath)(Qe, we), Se = (0, l.tweakKey)(Ee, Ce);
          if (!Se)
            throw new TypeError("Invalid outputKey for p2tr witness");
          if (be.length && !be.equals(Se.x))
            throw new TypeError("Pubkey mismatch for p2tr witness");
          if (Se.parity !== (Qe[0] & 1))
            throw new Error("Incorrect parity");
        }
    }
    return Object.assign(Ie, x);
  }
  return p2tr.p2tr = P, p2tr;
}
var hasRequiredPayments;
function requirePayments() {
  return hasRequiredPayments || (hasRequiredPayments = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.p2tr = s.p2wsh = s.p2wpkh = s.p2sh = s.p2pkh = s.p2pk = s.p2ms = s.embed = void 0;
    const A = requireEmbed();
    Object.defineProperty(s, "embed", {
      enumerable: !0,
      get: function() {
        return A.p2data;
      }
    });
    const u = requireP2ms();
    Object.defineProperty(s, "p2ms", {
      enumerable: !0,
      get: function() {
        return u.p2ms;
      }
    });
    const p = requireP2pk();
    Object.defineProperty(s, "p2pk", {
      enumerable: !0,
      get: function() {
        return p.p2pk;
      }
    });
    const t = requireP2pkh();
    Object.defineProperty(s, "p2pkh", {
      enumerable: !0,
      get: function() {
        return t.p2pkh;
      }
    });
    const l = requireP2sh();
    Object.defineProperty(s, "p2sh", {
      enumerable: !0,
      get: function() {
        return l.p2sh;
      }
    });
    const m = requireP2wpkh();
    Object.defineProperty(s, "p2wpkh", {
      enumerable: !0,
      get: function() {
        return m.p2wpkh;
      }
    });
    const b = requireP2wsh();
    Object.defineProperty(s, "p2wsh", {
      enumerable: !0,
      get: function() {
        return b.p2wsh;
      }
    });
    const k = requireP2tr();
    Object.defineProperty(s, "p2tr", {
      enumerable: !0,
      get: function() {
        return k.p2tr;
      }
    });
  }(payments)), payments;
}
var hasRequiredAddress$1;
function requireAddress$1() {
  if (hasRequiredAddress$1) return address$1;
  hasRequiredAddress$1 = 1, Object.defineProperty(address$1, "__esModule", { value: !0 }), address$1.toOutputScript = address$1.fromOutputScript = address$1.toBech32 = address$1.toBase58Check = address$1.fromBech32 = address$1.fromBase58Check = void 0;
  const s = requireNetworks$1(), A = requirePayments(), u = requireScript$1(), p = requireTypes$9(), t = requireDist$m(), l = requireBs58check$1(), m = 40, b = 2, k = 16, C = 2, B = 80, Q = "WARNING: Sending to a future segwit version address can lead to loss of funds. End users MUST be warned carefully in the GUI and asked if they wish to proceed with caution. Wallets should verify the segwit version from the output of fromBech32, then decide when it is safe to use which version of segwit.";
  function P(Ie, be) {
    const Pe = Ie.slice(2);
    if (Pe.length < b || Pe.length > m)
      throw new TypeError("Invalid program length for segwit address");
    const Te = Ie[0] - B;
    if (Te < C || Te > k)
      throw new TypeError("Invalid version for segwit address");
    if (Ie[1] !== Pe.length)
      throw new TypeError("Invalid script for segwit address");
    return console.warn(Q), le(Pe, Te, be.bech32);
  }
  function x(Ie) {
    const be = Buffer.from(l.decode(Ie));
    if (be.length < 21) throw new TypeError(Ie + " is too short");
    if (be.length > 21) throw new TypeError(Ie + " is too long");
    const Pe = be.readUInt8(0), Te = be.slice(1);
    return { version: Pe, hash: Te };
  }
  address$1.fromBase58Check = x;
  function M(Ie) {
    let be, Pe;
    try {
      be = t.bech32.decode(Ie);
    } catch {
    }
    if (be) {
      if (Pe = be.words[0], Pe !== 0) throw new TypeError(Ie + " uses wrong encoding");
    } else if (be = t.bech32m.decode(Ie), Pe = be.words[0], Pe === 0) throw new TypeError(Ie + " uses wrong encoding");
    const Te = t.bech32.fromWords(be.words.slice(1));
    return {
      version: Pe,
      prefix: be.prefix,
      data: Buffer.from(Te)
    };
  }
  address$1.fromBech32 = M;
  function F(Ie, be) {
    (0, p.typeforce)(
      (0, p.tuple)(p.Hash160bit, p.UInt8),
      arguments
    );
    const Pe = Buffer.allocUnsafe(21);
    return Pe.writeUInt8(be, 0), Ie.copy(Pe, 1), l.encode(Pe);
  }
  address$1.toBase58Check = F;
  function le(Ie, be, Pe) {
    const Te = t.bech32.toWords(Ie);
    return Te.unshift(be), be === 0 ? t.bech32.encode(Pe, Te) : t.bech32m.encode(Pe, Te);
  }
  address$1.toBech32 = le;
  function ge(Ie, be) {
    be = be || s.bitcoin;
    try {
      return A.p2pkh({ output: Ie, network: be }).address;
    } catch {
    }
    try {
      return A.p2sh({ output: Ie, network: be }).address;
    } catch {
    }
    try {
      return A.p2wpkh({ output: Ie, network: be }).address;
    } catch {
    }
    try {
      return A.p2wsh({ output: Ie, network: be }).address;
    } catch {
    }
    try {
      return A.p2tr({ output: Ie, network: be }).address;
    } catch {
    }
    try {
      return P(Ie, be);
    } catch {
    }
    throw new Error(u.toASM(Ie) + " has no matching Address");
  }
  address$1.fromOutputScript = ge;
  function pe(Ie, be) {
    be = be || s.bitcoin;
    let Pe, Te;
    try {
      Pe = x(Ie);
    } catch {
    }
    if (Pe) {
      if (Pe.version === be.pubKeyHash)
        return A.p2pkh({ hash: Pe.hash }).output;
      if (Pe.version === be.scriptHash)
        return A.p2sh({ hash: Pe.hash }).output;
    } else {
      try {
        Te = M(Ie);
      } catch {
      }
      if (Te) {
        if (Te.prefix !== be.bech32)
          throw new Error(Ie + " has an invalid prefix");
        if (Te.version === 0) {
          if (Te.data.length === 20)
            return A.p2wpkh({ hash: Te.data }).output;
          if (Te.data.length === 32)
            return A.p2wsh({ hash: Te.data }).output;
        } else if (Te.version === 1) {
          if (Te.data.length === 32)
            return A.p2tr({ pubkey: Te.data }).output;
        } else if (Te.version >= C && Te.version <= k && Te.data.length >= b && Te.data.length <= m)
          return console.warn(Q), u.compile([
            Te.version + B,
            Te.data
          ]);
      }
    }
    throw new Error(Ie + " has no matching Script");
  }
  return address$1.toOutputScript = pe, address$1;
}
var block = {}, merkle$3 = {}, hasRequiredMerkle$3;
function requireMerkle$3() {
  if (hasRequiredMerkle$3) return merkle$3;
  hasRequiredMerkle$3 = 1, Object.defineProperty(merkle$3, "__esModule", { value: !0 }), merkle$3.fastMerkleRoot = void 0;
  function s(A, u) {
    if (!Array.isArray(A)) throw TypeError("Expected values Array");
    if (typeof u != "function")
      throw TypeError("Expected digest Function");
    let p = A.length;
    const t = A.concat();
    for (; p > 1; ) {
      let l = 0;
      for (let m = 0; m < p; m += 2, ++l) {
        const b = t[m], k = m + 1 === p ? b : t[m + 1], C = Buffer.concat([b, k]);
        t[l] = u(C);
      }
      p = l;
    }
    return t[0];
  }
  return merkle$3.fastMerkleRoot = s, merkle$3;
}
var transaction$1 = {}, hasRequiredTransaction$1;
function requireTransaction$1() {
  if (hasRequiredTransaction$1) return transaction$1;
  hasRequiredTransaction$1 = 1, Object.defineProperty(transaction$1, "__esModule", { value: !0 }), transaction$1.Transaction = void 0;
  const s = requireBufferutils(), A = requireCrypto$3(), u = requireScript$1(), p = requireScript$1(), t = requireTypes$9(), { typeforce: l } = t;
  function m(le) {
    const ge = le.length;
    return s.varuint.encodingLength(ge) + ge;
  }
  function b(le) {
    const ge = le.length;
    return s.varuint.encodingLength(ge) + le.reduce((pe, Ie) => pe + m(Ie), 0);
  }
  const k = Buffer.allocUnsafe(0), C = [], B = Buffer.from(
    "0000000000000000000000000000000000000000000000000000000000000000",
    "hex"
  ), Q = Buffer.from(
    "0000000000000000000000000000000000000000000000000000000000000001",
    "hex"
  ), P = Buffer.from("ffffffffffffffff", "hex"), x = {
    script: k,
    valueBuffer: P
  };
  function M(le) {
    return le.value !== void 0;
  }
  class F {
    constructor() {
      this.version = 1, this.locktime = 0, this.ins = [], this.outs = [];
    }
    static fromBuffer(ge, pe) {
      const Ie = new s.BufferReader(ge), be = new F();
      be.version = Ie.readInt32();
      const Pe = Ie.readUInt8(), Te = Ie.readUInt8();
      let Qe = !1;
      Pe === F.ADVANCED_TRANSACTION_MARKER && Te === F.ADVANCED_TRANSACTION_FLAG ? Qe = !0 : Ie.offset -= 2;
      const xe = Ie.readVarInt();
      for (let He = 0; He < xe; ++He)
        be.ins.push({
          hash: Ie.readSlice(32),
          index: Ie.readUInt32(),
          script: Ie.readVarSlice(),
          sequence: Ie.readUInt32(),
          witness: C
        });
      const Ee = Ie.readVarInt();
      for (let He = 0; He < Ee; ++He)
        be.outs.push({
          value: Ie.readUInt64(),
          script: Ie.readVarSlice()
        });
      if (Qe) {
        for (let He = 0; He < xe; ++He)
          be.ins[He].witness = Ie.readVector();
        if (!be.hasWitnesses())
          throw new Error("Transaction has superfluous witness data");
      }
      if (be.locktime = Ie.readUInt32(), pe) return be;
      if (Ie.offset !== ge.length)
        throw new Error("Transaction has unexpected data");
      return be;
    }
    static fromHex(ge) {
      return F.fromBuffer(Buffer.from(ge, "hex"), !1);
    }
    static isCoinbaseHash(ge) {
      l(t.Hash256bit, ge);
      for (let pe = 0; pe < 32; ++pe)
        if (ge[pe] !== 0) return !1;
      return !0;
    }
    isCoinbase() {
      return this.ins.length === 1 && F.isCoinbaseHash(this.ins[0].hash);
    }
    addInput(ge, pe, Ie, be) {
      return l(
        t.tuple(
          t.Hash256bit,
          t.UInt32,
          t.maybe(t.UInt32),
          t.maybe(t.Buffer)
        ),
        arguments
      ), t.Null(Ie) && (Ie = F.DEFAULT_SEQUENCE), this.ins.push({
        hash: ge,
        index: pe,
        script: be || k,
        sequence: Ie,
        witness: C
      }) - 1;
    }
    addOutput(ge, pe) {
      return l(t.tuple(t.Buffer, t.Satoshi), arguments), this.outs.push({
        script: ge,
        value: pe
      }) - 1;
    }
    hasWitnesses() {
      return this.ins.some((ge) => ge.witness.length !== 0);
    }
    stripWitnesses() {
      this.ins.forEach((ge) => {
        ge.witness = C;
      });
    }
    weight() {
      const ge = this.byteLength(!1), pe = this.byteLength(!0);
      return ge * 3 + pe;
    }
    virtualSize() {
      return Math.ceil(this.weight() / 4);
    }
    byteLength(ge = !0) {
      const pe = ge && this.hasWitnesses();
      return (pe ? 10 : 8) + s.varuint.encodingLength(this.ins.length) + s.varuint.encodingLength(this.outs.length) + this.ins.reduce((Ie, be) => Ie + 40 + m(be.script), 0) + this.outs.reduce((Ie, be) => Ie + 8 + m(be.script), 0) + (pe ? this.ins.reduce((Ie, be) => Ie + b(be.witness), 0) : 0);
    }
    clone() {
      const ge = new F();
      return ge.version = this.version, ge.locktime = this.locktime, ge.ins = this.ins.map((pe) => ({
        hash: pe.hash,
        index: pe.index,
        script: pe.script,
        sequence: pe.sequence,
        witness: pe.witness
      })), ge.outs = this.outs.map((pe) => ({
        script: pe.script,
        value: pe.value
      })), ge;
    }
    /**
     * Hash transaction for signing a specific input.
     *
     * Bitcoin uses a different hash for each signed transaction input.
     * This method copies the transaction, makes the necessary changes based on the
     * hashType, and then hashes the result.
     * This hash can then be used to sign the provided transaction input.
     */
    hashForSignature(ge, pe, Ie) {
      if (l(
        t.tuple(
          t.UInt32,
          t.Buffer,
          /* types.UInt8 */
          t.Number
        ),
        arguments
      ), ge >= this.ins.length) return Q;
      const be = u.compile(
        u.decompile(pe).filter((Qe) => Qe !== p.OPS.OP_CODESEPARATOR)
      ), Pe = this.clone();
      if ((Ie & 31) === F.SIGHASH_NONE)
        Pe.outs = [], Pe.ins.forEach((Qe, xe) => {
          xe !== ge && (Qe.sequence = 0);
        });
      else if ((Ie & 31) === F.SIGHASH_SINGLE) {
        if (ge >= this.outs.length) return Q;
        Pe.outs.length = ge + 1;
        for (let Qe = 0; Qe < ge; Qe++)
          Pe.outs[Qe] = x;
        Pe.ins.forEach((Qe, xe) => {
          xe !== ge && (Qe.sequence = 0);
        });
      }
      Ie & F.SIGHASH_ANYONECANPAY ? (Pe.ins = [Pe.ins[ge]], Pe.ins[0].script = be) : (Pe.ins.forEach((Qe) => {
        Qe.script = k;
      }), Pe.ins[ge].script = be);
      const Te = Buffer.allocUnsafe(Pe.byteLength(!1) + 4);
      return Te.writeInt32LE(Ie, Te.length - 4), Pe.__toBuffer(Te, 0, !1), A.hash256(Te);
    }
    hashForWitnessV1(ge, pe, Ie, be, Pe, Te) {
      if (l(
        t.tuple(
          t.UInt32,
          l.arrayOf(t.Buffer),
          l.arrayOf(t.Satoshi),
          t.UInt32
        ),
        arguments
      ), Ie.length !== this.ins.length || pe.length !== this.ins.length)
        throw new Error("Must supply prevout script and value for all inputs");
      const Qe = be === F.SIGHASH_DEFAULT ? F.SIGHASH_ALL : be & F.SIGHASH_OUTPUT_MASK, Ee = (be & F.SIGHASH_INPUT_MASK) === F.SIGHASH_ANYONECANPAY, He = Qe === F.SIGHASH_NONE, ve = Qe === F.SIGHASH_SINGLE;
      let we = k, Ce = k, Se = k, Ne = k, rr = k;
      if (!Ee) {
        let nr = s.BufferWriter.withCapacity(
          36 * this.ins.length
        );
        this.ins.forEach((fr) => {
          nr.writeSlice(fr.hash), nr.writeUInt32(fr.index);
        }), we = A.sha256(nr.end()), nr = s.BufferWriter.withCapacity(
          8 * this.ins.length
        ), Ie.forEach((fr) => nr.writeUInt64(fr)), Ce = A.sha256(nr.end()), nr = s.BufferWriter.withCapacity(
          pe.map(m).reduce((fr, lr) => fr + lr)
        ), pe.forEach(
          (fr) => nr.writeVarSlice(fr)
        ), Se = A.sha256(nr.end()), nr = s.BufferWriter.withCapacity(
          4 * this.ins.length
        ), this.ins.forEach((fr) => nr.writeUInt32(fr.sequence)), Ne = A.sha256(nr.end());
      }
      if (He || ve) {
        if (ve && ge < this.outs.length) {
          const nr = this.outs[ge], fr = s.BufferWriter.withCapacity(
            8 + m(nr.script)
          );
          fr.writeUInt64(nr.value), fr.writeVarSlice(nr.script), rr = A.sha256(fr.end());
        }
      } else {
        const nr = this.outs.map((lr) => 8 + m(lr.script)).reduce((lr, br) => lr + br), fr = s.BufferWriter.withCapacity(nr);
        this.outs.forEach((lr) => {
          fr.writeUInt64(lr.value), fr.writeVarSlice(lr.script);
        }), rr = A.sha256(fr.end());
      }
      const er = (Pe ? 2 : 0) + (Te ? 1 : 0), ir = 174 - (Ee ? 49 : 0) - (He ? 32 : 0) + (Te ? 32 : 0) + (Pe ? 37 : 0), sr = s.BufferWriter.withCapacity(ir);
      if (sr.writeUInt8(be), sr.writeInt32(this.version), sr.writeUInt32(this.locktime), sr.writeSlice(we), sr.writeSlice(Ce), sr.writeSlice(Se), sr.writeSlice(Ne), He || ve || sr.writeSlice(rr), sr.writeUInt8(er), Ee) {
        const nr = this.ins[ge];
        sr.writeSlice(nr.hash), sr.writeUInt32(nr.index), sr.writeUInt64(Ie[ge]), sr.writeVarSlice(pe[ge]), sr.writeUInt32(nr.sequence);
      } else
        sr.writeUInt32(ge);
      if (Te) {
        const nr = s.BufferWriter.withCapacity(
          m(Te)
        );
        nr.writeVarSlice(Te), sr.writeSlice(A.sha256(nr.end()));
      }
      return ve && sr.writeSlice(rr), Pe && (sr.writeSlice(Pe), sr.writeUInt8(0), sr.writeUInt32(4294967295)), A.taggedHash(
        "TapSighash",
        Buffer.concat([Buffer.from([0]), sr.end()])
      );
    }
    hashForWitnessV0(ge, pe, Ie, be) {
      l(
        t.tuple(t.UInt32, t.Buffer, t.Satoshi, t.UInt32),
        arguments
      );
      let Pe = Buffer.from([]), Te, Qe = B, xe = B, Ee = B;
      if (be & F.SIGHASH_ANYONECANPAY || (Pe = Buffer.allocUnsafe(36 * this.ins.length), Te = new s.BufferWriter(Pe, 0), this.ins.forEach((ve) => {
        Te.writeSlice(ve.hash), Te.writeUInt32(ve.index);
      }), xe = A.hash256(Pe)), !(be & F.SIGHASH_ANYONECANPAY) && (be & 31) !== F.SIGHASH_SINGLE && (be & 31) !== F.SIGHASH_NONE && (Pe = Buffer.allocUnsafe(4 * this.ins.length), Te = new s.BufferWriter(Pe, 0), this.ins.forEach((ve) => {
        Te.writeUInt32(ve.sequence);
      }), Ee = A.hash256(Pe)), (be & 31) !== F.SIGHASH_SINGLE && (be & 31) !== F.SIGHASH_NONE) {
        const ve = this.outs.reduce((we, Ce) => we + 8 + m(Ce.script), 0);
        Pe = Buffer.allocUnsafe(ve), Te = new s.BufferWriter(Pe, 0), this.outs.forEach((we) => {
          Te.writeUInt64(we.value), Te.writeVarSlice(we.script);
        }), Qe = A.hash256(Pe);
      } else if ((be & 31) === F.SIGHASH_SINGLE && ge < this.outs.length) {
        const ve = this.outs[ge];
        Pe = Buffer.allocUnsafe(8 + m(ve.script)), Te = new s.BufferWriter(Pe, 0), Te.writeUInt64(ve.value), Te.writeVarSlice(ve.script), Qe = A.hash256(Pe);
      }
      Pe = Buffer.allocUnsafe(156 + m(pe)), Te = new s.BufferWriter(Pe, 0);
      const He = this.ins[ge];
      return Te.writeInt32(this.version), Te.writeSlice(xe), Te.writeSlice(Ee), Te.writeSlice(He.hash), Te.writeUInt32(He.index), Te.writeVarSlice(pe), Te.writeUInt64(Ie), Te.writeUInt32(He.sequence), Te.writeSlice(Qe), Te.writeUInt32(this.locktime), Te.writeUInt32(be), A.hash256(Pe);
    }
    getHash(ge) {
      return ge && this.isCoinbase() ? Buffer.alloc(32, 0) : A.hash256(this.__toBuffer(void 0, void 0, ge));
    }
    getId() {
      return (0, s.reverseBuffer)(this.getHash(!1)).toString(
        "hex"
      );
    }
    toBuffer(ge, pe) {
      return this.__toBuffer(ge, pe, !0);
    }
    toHex() {
      return this.toBuffer(void 0, void 0).toString("hex");
    }
    setInputScript(ge, pe) {
      l(t.tuple(t.Number, t.Buffer), arguments), this.ins[ge].script = pe;
    }
    setWitness(ge, pe) {
      l(t.tuple(t.Number, [t.Buffer]), arguments), this.ins[ge].witness = pe;
    }
    __toBuffer(ge, pe, Ie = !1) {
      ge || (ge = Buffer.allocUnsafe(this.byteLength(Ie)));
      const be = new s.BufferWriter(
        ge,
        pe || 0
      );
      be.writeInt32(this.version);
      const Pe = Ie && this.hasWitnesses();
      return Pe && (be.writeUInt8(F.ADVANCED_TRANSACTION_MARKER), be.writeUInt8(F.ADVANCED_TRANSACTION_FLAG)), be.writeVarInt(this.ins.length), this.ins.forEach((Te) => {
        be.writeSlice(Te.hash), be.writeUInt32(Te.index), be.writeVarSlice(Te.script), be.writeUInt32(Te.sequence);
      }), be.writeVarInt(this.outs.length), this.outs.forEach((Te) => {
        M(Te) ? be.writeUInt64(Te.value) : be.writeSlice(Te.valueBuffer), be.writeVarSlice(Te.script);
      }), Pe && this.ins.forEach((Te) => {
        be.writeVector(Te.witness);
      }), be.writeUInt32(this.locktime), pe !== void 0 ? ge.slice(pe, be.offset) : ge;
    }
  }
  return transaction$1.Transaction = F, F.DEFAULT_SEQUENCE = 4294967295, F.SIGHASH_DEFAULT = 0, F.SIGHASH_ALL = 1, F.SIGHASH_NONE = 2, F.SIGHASH_SINGLE = 3, F.SIGHASH_ANYONECANPAY = 128, F.SIGHASH_OUTPUT_MASK = 3, F.SIGHASH_INPUT_MASK = 128, F.ADVANCED_TRANSACTION_MARKER = 0, F.ADVANCED_TRANSACTION_FLAG = 1, transaction$1;
}
var hasRequiredBlock;
function requireBlock() {
  if (hasRequiredBlock) return block;
  hasRequiredBlock = 1, Object.defineProperty(block, "__esModule", { value: !0 }), block.Block = void 0;
  const s = requireBufferutils(), A = requireCrypto$3(), u = requireMerkle$3(), p = requireTransaction$1(), t = requireTypes$9(), { typeforce: l } = t, m = new TypeError(
    "Cannot compute merkle root for zero transactions"
  ), b = new TypeError(
    "Cannot compute witness commit for non-segwit block"
  );
  class k {
    constructor() {
      this.version = 1, this.prevHash = void 0, this.merkleRoot = void 0, this.timestamp = 0, this.witnessCommit = void 0, this.bits = 0, this.nonce = 0, this.transactions = void 0;
    }
    static fromBuffer(P) {
      if (P.length < 80) throw new Error("Buffer too small (< 80 bytes)");
      const x = new s.BufferReader(P), M = new k();
      if (M.version = x.readInt32(), M.prevHash = x.readSlice(32), M.merkleRoot = x.readSlice(32), M.timestamp = x.readUInt32(), M.bits = x.readUInt32(), M.nonce = x.readUInt32(), P.length === 80) return M;
      const F = () => {
        const pe = p.Transaction.fromBuffer(
          x.buffer.slice(x.offset),
          !0
        );
        return x.offset += pe.byteLength(), pe;
      }, le = x.readVarInt();
      M.transactions = [];
      for (let pe = 0; pe < le; ++pe) {
        const Ie = F();
        M.transactions.push(Ie);
      }
      const ge = M.getWitnessCommit();
      return ge && (M.witnessCommit = ge), M;
    }
    static fromHex(P) {
      return k.fromBuffer(Buffer.from(P, "hex"));
    }
    static calculateTarget(P) {
      const x = ((P & 4278190080) >> 24) - 3, M = P & 8388607, F = Buffer.alloc(32, 0);
      return F.writeUIntBE(M, 29 - x, 3), F;
    }
    static calculateMerkleRoot(P, x) {
      if (l([{ getHash: t.Function }], P), P.length === 0) throw m;
      if (x && !C(P))
        throw b;
      const M = P.map(
        (le) => le.getHash(x)
      ), F = (0, u.fastMerkleRoot)(M, A.hash256);
      return x ? A.hash256(
        Buffer.concat([F, P[0].ins[0].witness[0]])
      ) : F;
    }
    getWitnessCommit() {
      if (!C(this.transactions)) return null;
      const P = this.transactions[0].outs.filter(
        (M) => M.script.slice(0, 6).equals(Buffer.from("6a24aa21a9ed", "hex"))
      ).map((M) => M.script.slice(6, 38));
      if (P.length === 0) return null;
      const x = P[P.length - 1];
      return x instanceof Buffer && x.length === 32 ? x : null;
    }
    hasWitnessCommit() {
      return this.witnessCommit instanceof Buffer && this.witnessCommit.length === 32 || this.getWitnessCommit() !== null;
    }
    hasWitness() {
      return B(this.transactions);
    }
    weight() {
      const P = this.byteLength(!1, !1), x = this.byteLength(!1, !0);
      return P * 3 + x;
    }
    byteLength(P, x = !0) {
      return P || !this.transactions ? 80 : 80 + s.varuint.encodingLength(this.transactions.length) + this.transactions.reduce((M, F) => M + F.byteLength(x), 0);
    }
    getHash() {
      return A.hash256(this.toBuffer(!0));
    }
    getId() {
      return (0, s.reverseBuffer)(this.getHash()).toString("hex");
    }
    getUTCDate() {
      const P = /* @__PURE__ */ new Date(0);
      return P.setUTCSeconds(this.timestamp), P;
    }
    // TODO: buffer, offset compatibility
    toBuffer(P) {
      const x = Buffer.allocUnsafe(this.byteLength(P)), M = new s.BufferWriter(x);
      return M.writeInt32(this.version), M.writeSlice(this.prevHash), M.writeSlice(this.merkleRoot), M.writeUInt32(this.timestamp), M.writeUInt32(this.bits), M.writeUInt32(this.nonce), P || !this.transactions || (s.varuint.encode(
        this.transactions.length,
        x,
        M.offset
      ), M.offset += s.varuint.encode.bytes, this.transactions.forEach((F) => {
        const le = F.byteLength();
        F.toBuffer(x, M.offset), M.offset += le;
      })), x;
    }
    toHex(P) {
      return this.toBuffer(P).toString("hex");
    }
    checkTxRoots() {
      const P = this.hasWitnessCommit();
      return !P && this.hasWitness() ? !1 : this.__checkMerkleRoot() && (P ? this.__checkWitnessCommit() : !0);
    }
    checkProofOfWork() {
      const P = (0, s.reverseBuffer)(this.getHash()), x = k.calculateTarget(this.bits);
      return P.compare(x) <= 0;
    }
    __checkMerkleRoot() {
      if (!this.transactions) throw m;
      const P = k.calculateMerkleRoot(this.transactions);
      return this.merkleRoot.compare(P) === 0;
    }
    __checkWitnessCommit() {
      if (!this.transactions) throw m;
      if (!this.hasWitnessCommit()) throw b;
      const P = k.calculateMerkleRoot(
        this.transactions,
        !0
      );
      return this.witnessCommit.compare(P) === 0;
    }
  }
  block.Block = k;
  function C(Q) {
    return Q instanceof Array && Q[0] && Q[0].ins && Q[0].ins instanceof Array && Q[0].ins[0] && Q[0].ins[0].witness && Q[0].ins[0].witness instanceof Array && Q[0].ins[0].witness.length > 0;
  }
  function B(Q) {
    return Q instanceof Array && Q.some(
      (P) => typeof P == "object" && P.ins instanceof Array && P.ins.some(
        (x) => typeof x == "object" && x.witness instanceof Array && x.witness.length > 0
      )
    );
  }
  return block;
}
var psbt$4 = {}, psbt$3 = {}, combiner = {}, parser = {}, fromBuffer = {}, converter = {}, typeFields = {}, hasRequiredTypeFields;
function requireTypeFields() {
  return hasRequiredTypeFields || (hasRequiredTypeFields = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), function(A) {
      A[A.UNSIGNED_TX = 0] = "UNSIGNED_TX", A[A.GLOBAL_XPUB = 1] = "GLOBAL_XPUB";
    }(s.GlobalTypes || (s.GlobalTypes = {})), s.GLOBAL_TYPE_NAMES = ["unsignedTx", "globalXpub"], function(A) {
      A[A.NON_WITNESS_UTXO = 0] = "NON_WITNESS_UTXO", A[A.WITNESS_UTXO = 1] = "WITNESS_UTXO", A[A.PARTIAL_SIG = 2] = "PARTIAL_SIG", A[A.SIGHASH_TYPE = 3] = "SIGHASH_TYPE", A[A.REDEEM_SCRIPT = 4] = "REDEEM_SCRIPT", A[A.WITNESS_SCRIPT = 5] = "WITNESS_SCRIPT", A[A.BIP32_DERIVATION = 6] = "BIP32_DERIVATION", A[A.FINAL_SCRIPTSIG = 7] = "FINAL_SCRIPTSIG", A[A.FINAL_SCRIPTWITNESS = 8] = "FINAL_SCRIPTWITNESS", A[A.POR_COMMITMENT = 9] = "POR_COMMITMENT", A[A.TAP_KEY_SIG = 19] = "TAP_KEY_SIG", A[A.TAP_SCRIPT_SIG = 20] = "TAP_SCRIPT_SIG", A[A.TAP_LEAF_SCRIPT = 21] = "TAP_LEAF_SCRIPT", A[A.TAP_BIP32_DERIVATION = 22] = "TAP_BIP32_DERIVATION", A[A.TAP_INTERNAL_KEY = 23] = "TAP_INTERNAL_KEY", A[A.TAP_MERKLE_ROOT = 24] = "TAP_MERKLE_ROOT";
    }(s.InputTypes || (s.InputTypes = {})), s.INPUT_TYPE_NAMES = [
      "nonWitnessUtxo",
      "witnessUtxo",
      "partialSig",
      "sighashType",
      "redeemScript",
      "witnessScript",
      "bip32Derivation",
      "finalScriptSig",
      "finalScriptWitness",
      "porCommitment",
      "tapKeySig",
      "tapScriptSig",
      "tapLeafScript",
      "tapBip32Derivation",
      "tapInternalKey",
      "tapMerkleRoot"
    ], function(A) {
      A[A.REDEEM_SCRIPT = 0] = "REDEEM_SCRIPT", A[A.WITNESS_SCRIPT = 1] = "WITNESS_SCRIPT", A[A.BIP32_DERIVATION = 2] = "BIP32_DERIVATION", A[A.TAP_INTERNAL_KEY = 5] = "TAP_INTERNAL_KEY", A[A.TAP_TREE = 6] = "TAP_TREE", A[A.TAP_BIP32_DERIVATION = 7] = "TAP_BIP32_DERIVATION";
    }(s.OutputTypes || (s.OutputTypes = {})), s.OUTPUT_TYPE_NAMES = [
      "redeemScript",
      "witnessScript",
      "bip32Derivation",
      "tapInternalKey",
      "tapTree",
      "tapBip32Derivation"
    ];
  }(typeFields)), typeFields;
}
var globalXpub = {}, hasRequiredGlobalXpub;
function requireGlobalXpub() {
  if (hasRequiredGlobalXpub) return globalXpub;
  hasRequiredGlobalXpub = 1, Object.defineProperty(globalXpub, "__esModule", { value: !0 });
  const s = requireTypeFields(), A = (m) => [...Array(m).keys()];
  function u(m) {
    if (m.key[0] !== s.GlobalTypes.GLOBAL_XPUB)
      throw new Error(
        "Decode Error: could not decode globalXpub with key 0x" + m.key.toString("hex")
      );
    if (m.key.length !== 79 || ![2, 3].includes(m.key[46]))
      throw new Error(
        "Decode Error: globalXpub has invalid extended pubkey in key 0x" + m.key.toString("hex")
      );
    if (m.value.length / 4 % 1 !== 0)
      throw new Error(
        "Decode Error: Global GLOBAL_XPUB value length should be multiple of 4"
      );
    const b = m.key.slice(1), k = {
      masterFingerprint: m.value.slice(0, 4),
      extendedPubkey: b,
      path: "m"
    };
    for (const C of A(m.value.length / 4 - 1)) {
      const B = m.value.readUInt32LE(C * 4 + 4), Q = !!(B & 2147483648), P = B & 2147483647;
      k.path += "/" + P.toString(10) + (Q ? "'" : "");
    }
    return k;
  }
  globalXpub.decode = u;
  function p(m) {
    const b = Buffer.from([s.GlobalTypes.GLOBAL_XPUB]), k = Buffer.concat([b, m.extendedPubkey]), C = m.path.split("/"), B = Buffer.allocUnsafe(C.length * 4);
    m.masterFingerprint.copy(B, 0);
    let Q = 4;
    return C.slice(1).forEach((P) => {
      const x = P.slice(-1) === "'";
      let M = 2147483647 & parseInt(x ? P.slice(0, -1) : P, 10);
      x && (M += 2147483648), B.writeUInt32LE(M, Q), Q += 4;
    }), {
      key: k,
      value: B
    };
  }
  globalXpub.encode = p, globalXpub.expected = "{ masterFingerprint: Buffer; extendedPubkey: Buffer; path: string; }";
  function t(m) {
    const b = m.extendedPubkey, k = m.masterFingerprint, C = m.path;
    return Buffer.isBuffer(b) && b.length === 78 && [2, 3].indexOf(b[45]) > -1 && Buffer.isBuffer(k) && k.length === 4 && typeof C == "string" && !!C.match(/^m(\/\d+'?)*$/);
  }
  globalXpub.check = t;
  function l(m, b, k) {
    const C = b.extendedPubkey.toString("hex");
    return k.has(C) ? !1 : (k.add(C), m.filter((B) => B.extendedPubkey.equals(b.extendedPubkey)).length === 0);
  }
  return globalXpub.canAddToArray = l, globalXpub;
}
var unsignedTx = {}, hasRequiredUnsignedTx;
function requireUnsignedTx() {
  if (hasRequiredUnsignedTx) return unsignedTx;
  hasRequiredUnsignedTx = 1, Object.defineProperty(unsignedTx, "__esModule", { value: !0 });
  const s = requireTypeFields();
  function A(u) {
    return {
      key: Buffer.from([s.GlobalTypes.UNSIGNED_TX]),
      value: u.toBuffer()
    };
  }
  return unsignedTx.encode = A, unsignedTx;
}
var finalScriptSig = {}, hasRequiredFinalScriptSig;
function requireFinalScriptSig() {
  if (hasRequiredFinalScriptSig) return finalScriptSig;
  hasRequiredFinalScriptSig = 1, Object.defineProperty(finalScriptSig, "__esModule", { value: !0 });
  const s = requireTypeFields();
  function A(l) {
    if (l.key[0] !== s.InputTypes.FINAL_SCRIPTSIG)
      throw new Error(
        "Decode Error: could not decode finalScriptSig with key 0x" + l.key.toString("hex")
      );
    return l.value;
  }
  finalScriptSig.decode = A;
  function u(l) {
    return {
      key: Buffer.from([s.InputTypes.FINAL_SCRIPTSIG]),
      value: l
    };
  }
  finalScriptSig.encode = u, finalScriptSig.expected = "Buffer";
  function p(l) {
    return Buffer.isBuffer(l);
  }
  finalScriptSig.check = p;
  function t(l, m) {
    return !!l && !!m && l.finalScriptSig === void 0;
  }
  return finalScriptSig.canAdd = t, finalScriptSig;
}
var finalScriptWitness = {}, hasRequiredFinalScriptWitness;
function requireFinalScriptWitness() {
  if (hasRequiredFinalScriptWitness) return finalScriptWitness;
  hasRequiredFinalScriptWitness = 1, Object.defineProperty(finalScriptWitness, "__esModule", { value: !0 });
  const s = requireTypeFields();
  function A(l) {
    if (l.key[0] !== s.InputTypes.FINAL_SCRIPTWITNESS)
      throw new Error(
        "Decode Error: could not decode finalScriptWitness with key 0x" + l.key.toString("hex")
      );
    return l.value;
  }
  finalScriptWitness.decode = A;
  function u(l) {
    return {
      key: Buffer.from([s.InputTypes.FINAL_SCRIPTWITNESS]),
      value: l
    };
  }
  finalScriptWitness.encode = u, finalScriptWitness.expected = "Buffer";
  function p(l) {
    return Buffer.isBuffer(l);
  }
  finalScriptWitness.check = p;
  function t(l, m) {
    return !!l && !!m && l.finalScriptWitness === void 0;
  }
  return finalScriptWitness.canAdd = t, finalScriptWitness;
}
var nonWitnessUtxo = {}, hasRequiredNonWitnessUtxo;
function requireNonWitnessUtxo() {
  if (hasRequiredNonWitnessUtxo) return nonWitnessUtxo;
  hasRequiredNonWitnessUtxo = 1, Object.defineProperty(nonWitnessUtxo, "__esModule", { value: !0 });
  const s = requireTypeFields();
  function A(l) {
    if (l.key[0] !== s.InputTypes.NON_WITNESS_UTXO)
      throw new Error(
        "Decode Error: could not decode nonWitnessUtxo with key 0x" + l.key.toString("hex")
      );
    return l.value;
  }
  nonWitnessUtxo.decode = A;
  function u(l) {
    return {
      key: Buffer.from([s.InputTypes.NON_WITNESS_UTXO]),
      value: l
    };
  }
  nonWitnessUtxo.encode = u, nonWitnessUtxo.expected = "Buffer";
  function p(l) {
    return Buffer.isBuffer(l);
  }
  nonWitnessUtxo.check = p;
  function t(l, m) {
    return !!l && !!m && l.nonWitnessUtxo === void 0;
  }
  return nonWitnessUtxo.canAdd = t, nonWitnessUtxo;
}
var partialSig = {}, hasRequiredPartialSig;
function requirePartialSig() {
  if (hasRequiredPartialSig) return partialSig;
  hasRequiredPartialSig = 1, Object.defineProperty(partialSig, "__esModule", { value: !0 });
  const s = requireTypeFields();
  function A(m) {
    if (m.key[0] !== s.InputTypes.PARTIAL_SIG)
      throw new Error(
        "Decode Error: could not decode partialSig with key 0x" + m.key.toString("hex")
      );
    if (!(m.key.length === 34 || m.key.length === 66) || ![2, 3, 4].includes(m.key[1]))
      throw new Error(
        "Decode Error: partialSig has invalid pubkey in key 0x" + m.key.toString("hex")
      );
    return {
      pubkey: m.key.slice(1),
      signature: m.value
    };
  }
  partialSig.decode = A;
  function u(m) {
    const b = Buffer.from([s.InputTypes.PARTIAL_SIG]);
    return {
      key: Buffer.concat([b, m.pubkey]),
      value: m.signature
    };
  }
  partialSig.encode = u, partialSig.expected = "{ pubkey: Buffer; signature: Buffer; }";
  function p(m) {
    return Buffer.isBuffer(m.pubkey) && Buffer.isBuffer(m.signature) && [33, 65].includes(m.pubkey.length) && [2, 3, 4].includes(m.pubkey[0]) && t(m.signature);
  }
  partialSig.check = p;
  function t(m) {
    if (!Buffer.isBuffer(m) || m.length < 9 || m[0] !== 48 || m.length !== m[1] + 3 || m[2] !== 2) return !1;
    const b = m[3];
    if (b > 33 || b < 1 || m[3 + b + 1] !== 2) return !1;
    const k = m[3 + b + 2];
    return !(k > 33 || k < 1 || m.length !== 3 + b + 2 + k + 2);
  }
  function l(m, b, k) {
    const C = b.pubkey.toString("hex");
    return k.has(C) ? !1 : (k.add(C), m.filter((B) => B.pubkey.equals(b.pubkey)).length === 0);
  }
  return partialSig.canAddToArray = l, partialSig;
}
var porCommitment = {}, hasRequiredPorCommitment;
function requirePorCommitment() {
  if (hasRequiredPorCommitment) return porCommitment;
  hasRequiredPorCommitment = 1, Object.defineProperty(porCommitment, "__esModule", { value: !0 });
  const s = requireTypeFields();
  function A(l) {
    if (l.key[0] !== s.InputTypes.POR_COMMITMENT)
      throw new Error(
        "Decode Error: could not decode porCommitment with key 0x" + l.key.toString("hex")
      );
    return l.value.toString("utf8");
  }
  porCommitment.decode = A;
  function u(l) {
    return {
      key: Buffer.from([s.InputTypes.POR_COMMITMENT]),
      value: Buffer.from(l, "utf8")
    };
  }
  porCommitment.encode = u, porCommitment.expected = "string";
  function p(l) {
    return typeof l == "string";
  }
  porCommitment.check = p;
  function t(l, m) {
    return !!l && !!m && l.porCommitment === void 0;
  }
  return porCommitment.canAdd = t, porCommitment;
}
var sighashType = {}, hasRequiredSighashType;
function requireSighashType() {
  if (hasRequiredSighashType) return sighashType;
  hasRequiredSighashType = 1, Object.defineProperty(sighashType, "__esModule", { value: !0 });
  const s = requireTypeFields();
  function A(l) {
    if (l.key[0] !== s.InputTypes.SIGHASH_TYPE)
      throw new Error(
        "Decode Error: could not decode sighashType with key 0x" + l.key.toString("hex")
      );
    return l.value.readUInt32LE(0);
  }
  sighashType.decode = A;
  function u(l) {
    const m = Buffer.from([s.InputTypes.SIGHASH_TYPE]), b = Buffer.allocUnsafe(4);
    return b.writeUInt32LE(l, 0), {
      key: m,
      value: b
    };
  }
  sighashType.encode = u, sighashType.expected = "number";
  function p(l) {
    return typeof l == "number";
  }
  sighashType.check = p;
  function t(l, m) {
    return !!l && !!m && l.sighashType === void 0;
  }
  return sighashType.canAdd = t, sighashType;
}
var tapKeySig = {}, hasRequiredTapKeySig;
function requireTapKeySig() {
  if (hasRequiredTapKeySig) return tapKeySig;
  hasRequiredTapKeySig = 1, Object.defineProperty(tapKeySig, "__esModule", { value: !0 });
  const s = requireTypeFields();
  function A(l) {
    if (l.key[0] !== s.InputTypes.TAP_KEY_SIG || l.key.length !== 1)
      throw new Error(
        "Decode Error: could not decode tapKeySig with key 0x" + l.key.toString("hex")
      );
    if (!p(l.value))
      throw new Error(
        "Decode Error: tapKeySig not a valid 64-65-byte BIP340 signature"
      );
    return l.value;
  }
  tapKeySig.decode = A;
  function u(l) {
    return { key: Buffer.from([s.InputTypes.TAP_KEY_SIG]), value: l };
  }
  tapKeySig.encode = u, tapKeySig.expected = "Buffer";
  function p(l) {
    return Buffer.isBuffer(l) && (l.length === 64 || l.length === 65);
  }
  tapKeySig.check = p;
  function t(l, m) {
    return !!l && !!m && l.tapKeySig === void 0;
  }
  return tapKeySig.canAdd = t, tapKeySig;
}
var tapLeafScript = {}, hasRequiredTapLeafScript;
function requireTapLeafScript() {
  if (hasRequiredTapLeafScript) return tapLeafScript;
  hasRequiredTapLeafScript = 1, Object.defineProperty(tapLeafScript, "__esModule", { value: !0 });
  const s = requireTypeFields();
  function A(l) {
    if (l.key[0] !== s.InputTypes.TAP_LEAF_SCRIPT)
      throw new Error(
        "Decode Error: could not decode tapLeafScript with key 0x" + l.key.toString("hex")
      );
    if ((l.key.length - 2) % 32 !== 0)
      throw new Error(
        "Decode Error: tapLeafScript has invalid control block in key 0x" + l.key.toString("hex")
      );
    const m = l.value[l.value.length - 1];
    if ((l.key[1] & 254) !== m)
      throw new Error(
        "Decode Error: tapLeafScript bad leaf version in key 0x" + l.key.toString("hex")
      );
    const b = l.value.slice(0, -1);
    return { controlBlock: l.key.slice(1), script: b, leafVersion: m };
  }
  tapLeafScript.decode = A;
  function u(l) {
    const m = Buffer.from([s.InputTypes.TAP_LEAF_SCRIPT]), b = Buffer.from([l.leafVersion]);
    return {
      key: Buffer.concat([m, l.controlBlock]),
      value: Buffer.concat([l.script, b])
    };
  }
  tapLeafScript.encode = u, tapLeafScript.expected = "{ controlBlock: Buffer; leafVersion: number, script: Buffer; }";
  function p(l) {
    return Buffer.isBuffer(l.controlBlock) && (l.controlBlock.length - 1) % 32 === 0 && (l.controlBlock[0] & 254) === l.leafVersion && Buffer.isBuffer(l.script);
  }
  tapLeafScript.check = p;
  function t(l, m, b) {
    const k = m.controlBlock.toString("hex");
    return b.has(k) ? !1 : (b.add(k), l.filter((C) => C.controlBlock.equals(m.controlBlock)).length === 0);
  }
  return tapLeafScript.canAddToArray = t, tapLeafScript;
}
var tapMerkleRoot = {}, hasRequiredTapMerkleRoot;
function requireTapMerkleRoot() {
  if (hasRequiredTapMerkleRoot) return tapMerkleRoot;
  hasRequiredTapMerkleRoot = 1, Object.defineProperty(tapMerkleRoot, "__esModule", { value: !0 });
  const s = requireTypeFields();
  function A(l) {
    if (l.key[0] !== s.InputTypes.TAP_MERKLE_ROOT || l.key.length !== 1)
      throw new Error(
        "Decode Error: could not decode tapMerkleRoot with key 0x" + l.key.toString("hex")
      );
    if (!p(l.value))
      throw new Error("Decode Error: tapMerkleRoot not a 32-byte hash");
    return l.value;
  }
  tapMerkleRoot.decode = A;
  function u(l) {
    return { key: Buffer.from([s.InputTypes.TAP_MERKLE_ROOT]), value: l };
  }
  tapMerkleRoot.encode = u, tapMerkleRoot.expected = "Buffer";
  function p(l) {
    return Buffer.isBuffer(l) && l.length === 32;
  }
  tapMerkleRoot.check = p;
  function t(l, m) {
    return !!l && !!m && l.tapMerkleRoot === void 0;
  }
  return tapMerkleRoot.canAdd = t, tapMerkleRoot;
}
var tapScriptSig = {}, hasRequiredTapScriptSig;
function requireTapScriptSig() {
  if (hasRequiredTapScriptSig) return tapScriptSig;
  hasRequiredTapScriptSig = 1, Object.defineProperty(tapScriptSig, "__esModule", { value: !0 });
  const s = requireTypeFields();
  function A(l) {
    if (l.key[0] !== s.InputTypes.TAP_SCRIPT_SIG)
      throw new Error(
        "Decode Error: could not decode tapScriptSig with key 0x" + l.key.toString("hex")
      );
    if (l.key.length !== 65)
      throw new Error(
        "Decode Error: tapScriptSig has invalid key 0x" + l.key.toString("hex")
      );
    if (l.value.length !== 64 && l.value.length !== 65)
      throw new Error(
        "Decode Error: tapScriptSig has invalid signature in key 0x" + l.key.toString("hex")
      );
    const m = l.key.slice(1, 33), b = l.key.slice(33);
    return {
      pubkey: m,
      leafHash: b,
      signature: l.value
    };
  }
  tapScriptSig.decode = A;
  function u(l) {
    const m = Buffer.from([s.InputTypes.TAP_SCRIPT_SIG]);
    return {
      key: Buffer.concat([m, l.pubkey, l.leafHash]),
      value: l.signature
    };
  }
  tapScriptSig.encode = u, tapScriptSig.expected = "{ pubkey: Buffer; leafHash: Buffer; signature: Buffer; }";
  function p(l) {
    return Buffer.isBuffer(l.pubkey) && Buffer.isBuffer(l.leafHash) && Buffer.isBuffer(l.signature) && l.pubkey.length === 32 && l.leafHash.length === 32 && (l.signature.length === 64 || l.signature.length === 65);
  }
  tapScriptSig.check = p;
  function t(l, m, b) {
    const k = m.pubkey.toString("hex") + m.leafHash.toString("hex");
    return b.has(k) ? !1 : (b.add(k), l.filter(
      (C) => C.pubkey.equals(m.pubkey) && C.leafHash.equals(m.leafHash)
    ).length === 0);
  }
  return tapScriptSig.canAddToArray = t, tapScriptSig;
}
var witnessUtxo = {}, tools = {}, varint$4 = {}, hasRequiredVarint$4;
function requireVarint$4() {
  if (hasRequiredVarint$4) return varint$4;
  hasRequiredVarint$4 = 1, Object.defineProperty(varint$4, "__esModule", { value: !0 });
  const s = 9007199254740991;
  function A(l) {
    if (l < 0 || l > s || l % 1 !== 0)
      throw new RangeError("value out of range");
  }
  function u(l, m, b) {
    if (A(l), m || (m = Buffer.allocUnsafe(t(l))), !Buffer.isBuffer(m))
      throw new TypeError("buffer must be a Buffer instance");
    return b || (b = 0), l < 253 ? (m.writeUInt8(l, b), Object.assign(u, { bytes: 1 })) : l <= 65535 ? (m.writeUInt8(253, b), m.writeUInt16LE(l, b + 1), Object.assign(u, { bytes: 3 })) : l <= 4294967295 ? (m.writeUInt8(254, b), m.writeUInt32LE(l, b + 1), Object.assign(u, { bytes: 5 })) : (m.writeUInt8(255, b), m.writeUInt32LE(l >>> 0, b + 1), m.writeUInt32LE(l / 4294967296 | 0, b + 5), Object.assign(u, { bytes: 9 })), m;
  }
  varint$4.encode = u;
  function p(l, m) {
    if (!Buffer.isBuffer(l))
      throw new TypeError("buffer must be a Buffer instance");
    m || (m = 0);
    const b = l.readUInt8(m);
    if (b < 253)
      return Object.assign(p, { bytes: 1 }), b;
    if (b === 253)
      return Object.assign(p, { bytes: 3 }), l.readUInt16LE(m + 1);
    if (b === 254)
      return Object.assign(p, { bytes: 5 }), l.readUInt32LE(m + 1);
    {
      Object.assign(p, { bytes: 9 });
      const k = l.readUInt32LE(m + 1), B = l.readUInt32LE(m + 5) * 4294967296 + k;
      return A(B), B;
    }
  }
  varint$4.decode = p;
  function t(l) {
    return A(l), l < 253 ? 1 : l <= 65535 ? 3 : l <= 4294967295 ? 5 : 9;
  }
  return varint$4.encodingLength = t, varint$4;
}
var hasRequiredTools;
function requireTools() {
  if (hasRequiredTools) return tools;
  hasRequiredTools = 1, Object.defineProperty(tools, "__esModule", { value: !0 });
  const s = requireVarint$4();
  tools.range = (b) => [...Array(b).keys()];
  function A(b) {
    if (b.length < 1) return b;
    let k = b.length - 1, C = 0;
    for (let B = 0; B < b.length / 2; B++)
      C = b[B], b[B] = b[k], b[k] = C, k--;
    return b;
  }
  tools.reverseBuffer = A;
  function u(b) {
    const k = b.map(p);
    return k.push(Buffer.from([0])), Buffer.concat(k);
  }
  tools.keyValsToBuffer = u;
  function p(b) {
    const k = b.key.length, C = b.value.length, B = s.encodingLength(k), Q = s.encodingLength(C), P = Buffer.allocUnsafe(
      B + k + Q + C
    );
    return s.encode(k, P, 0), b.key.copy(P, B), s.encode(C, P, B + k), b.value.copy(P, B + k + Q), P;
  }
  tools.keyValToBuffer = p;
  function t(b, k) {
    if (typeof b != "number")
      throw new Error("cannot write a non-number as a number");
    if (b < 0)
      throw new Error("specified a negative value for writing an unsigned value");
    if (b > k) throw new Error("RangeError: value out of range");
    if (Math.floor(b) !== b)
      throw new Error("value has a fractional component");
  }
  function l(b, k) {
    const C = b.readUInt32LE(k);
    let B = b.readUInt32LE(k + 4);
    return B *= 4294967296, t(B + C, 9007199254740991), B + C;
  }
  tools.readUInt64LE = l;
  function m(b, k, C) {
    return t(k, 9007199254740991), b.writeInt32LE(k & -1, C), b.writeUInt32LE(Math.floor(k / 4294967296), C + 4), C + 8;
  }
  return tools.writeUInt64LE = m, tools;
}
var hasRequiredWitnessUtxo;
function requireWitnessUtxo() {
  if (hasRequiredWitnessUtxo) return witnessUtxo;
  hasRequiredWitnessUtxo = 1, Object.defineProperty(witnessUtxo, "__esModule", { value: !0 });
  const s = requireTypeFields(), A = requireTools(), u = requireVarint$4();
  function p(b) {
    if (b.key[0] !== s.InputTypes.WITNESS_UTXO)
      throw new Error(
        "Decode Error: could not decode witnessUtxo with key 0x" + b.key.toString("hex")
      );
    const k = A.readUInt64LE(b.value, 0);
    let C = 8;
    const B = u.decode(b.value, C);
    C += u.encodingLength(B);
    const Q = b.value.slice(C);
    if (Q.length !== B)
      throw new Error("Decode Error: WITNESS_UTXO script is not proper length");
    return {
      script: Q,
      value: k
    };
  }
  witnessUtxo.decode = p;
  function t(b) {
    const { script: k, value: C } = b, B = u.encodingLength(k.length), Q = Buffer.allocUnsafe(8 + B + k.length);
    return A.writeUInt64LE(Q, C, 0), u.encode(k.length, Q, 8), k.copy(Q, 8 + B), {
      key: Buffer.from([s.InputTypes.WITNESS_UTXO]),
      value: Q
    };
  }
  witnessUtxo.encode = t, witnessUtxo.expected = "{ script: Buffer; value: number; }";
  function l(b) {
    return Buffer.isBuffer(b.script) && typeof b.value == "number";
  }
  witnessUtxo.check = l;
  function m(b, k) {
    return !!b && !!k && b.witnessUtxo === void 0;
  }
  return witnessUtxo.canAdd = m, witnessUtxo;
}
var tapTree$1 = {}, hasRequiredTapTree;
function requireTapTree() {
  if (hasRequiredTapTree) return tapTree$1;
  hasRequiredTapTree = 1, Object.defineProperty(tapTree$1, "__esModule", { value: !0 });
  const s = requireTypeFields(), A = requireVarint$4();
  function u(m) {
    if (m.key[0] !== s.OutputTypes.TAP_TREE || m.key.length !== 1)
      throw new Error(
        "Decode Error: could not decode tapTree with key 0x" + m.key.toString("hex")
      );
    let b = 0;
    const k = [];
    for (; b < m.value.length; ) {
      const C = m.value[b++], B = m.value[b++], Q = A.decode(m.value, b);
      b += A.encodingLength(Q), k.push({
        depth: C,
        leafVersion: B,
        script: m.value.slice(b, b + Q)
      }), b += Q;
    }
    return { leaves: k };
  }
  tapTree$1.decode = u;
  function p(m) {
    const b = Buffer.from([s.OutputTypes.TAP_TREE]), k = [].concat(
      ...m.leaves.map((C) => [
        Buffer.of(C.depth, C.leafVersion),
        A.encode(C.script.length),
        C.script
      ])
    );
    return {
      key: b,
      value: Buffer.concat(k)
    };
  }
  tapTree$1.encode = p, tapTree$1.expected = "{ leaves: [{ depth: number; leafVersion: number, script: Buffer; }] }";
  function t(m) {
    return Array.isArray(m.leaves) && m.leaves.every(
      (b) => b.depth >= 0 && b.depth <= 128 && (b.leafVersion & 254) === b.leafVersion && Buffer.isBuffer(b.script)
    );
  }
  tapTree$1.check = t;
  function l(m, b) {
    return !!m && !!b && m.tapTree === void 0;
  }
  return tapTree$1.canAdd = l, tapTree$1;
}
var bip32Derivation = {}, hasRequiredBip32Derivation;
function requireBip32Derivation() {
  if (hasRequiredBip32Derivation) return bip32Derivation;
  hasRequiredBip32Derivation = 1, Object.defineProperty(bip32Derivation, "__esModule", { value: !0 });
  const s = (p) => [...Array(p).keys()], A = (p) => p.length === 33 && [2, 3].includes(p[0]) || p.length === 65 && p[0] === 4;
  function u(p, t = A) {
    function l(B) {
      if (B.key[0] !== p)
        throw new Error(
          "Decode Error: could not decode bip32Derivation with key 0x" + B.key.toString("hex")
        );
      const Q = B.key.slice(1);
      if (!t(Q))
        throw new Error(
          "Decode Error: bip32Derivation has invalid pubkey in key 0x" + B.key.toString("hex")
        );
      if (B.value.length / 4 % 1 !== 0)
        throw new Error(
          "Decode Error: Input BIP32_DERIVATION value length should be multiple of 4"
        );
      const P = {
        masterFingerprint: B.value.slice(0, 4),
        pubkey: Q,
        path: "m"
      };
      for (const x of s(B.value.length / 4 - 1)) {
        const M = B.value.readUInt32LE(x * 4 + 4), F = !!(M & 2147483648), le = M & 2147483647;
        P.path += "/" + le.toString(10) + (F ? "'" : "");
      }
      return P;
    }
    function m(B) {
      const Q = Buffer.from([p]), P = Buffer.concat([Q, B.pubkey]), x = B.path.split("/"), M = Buffer.allocUnsafe(x.length * 4);
      B.masterFingerprint.copy(M, 0);
      let F = 4;
      return x.slice(1).forEach((le) => {
        const ge = le.slice(-1) === "'";
        let pe = 2147483647 & parseInt(ge ? le.slice(0, -1) : le, 10);
        ge && (pe += 2147483648), M.writeUInt32LE(pe, F), F += 4;
      }), {
        key: P,
        value: M
      };
    }
    const b = "{ masterFingerprint: Buffer; pubkey: Buffer; path: string; }";
    function k(B) {
      return Buffer.isBuffer(B.pubkey) && Buffer.isBuffer(B.masterFingerprint) && typeof B.path == "string" && t(B.pubkey) && B.masterFingerprint.length === 4;
    }
    function C(B, Q, P) {
      const x = Q.pubkey.toString("hex");
      return P.has(x) ? !1 : (P.add(x), B.filter((M) => M.pubkey.equals(Q.pubkey)).length === 0);
    }
    return {
      decode: l,
      encode: m,
      check: k,
      expected: b,
      canAddToArray: C
    };
  }
  return bip32Derivation.makeConverter = u, bip32Derivation;
}
var checkPubkey = {}, hasRequiredCheckPubkey;
function requireCheckPubkey() {
  if (hasRequiredCheckPubkey) return checkPubkey;
  hasRequiredCheckPubkey = 1, Object.defineProperty(checkPubkey, "__esModule", { value: !0 });
  function s(A) {
    return u;
    function u(p) {
      let t;
      if (A.includes(p.key[0]) && (t = p.key.slice(1), !(t.length === 33 || t.length === 65) || ![2, 3, 4].includes(t[0])))
        throw new Error(
          "Format Error: invalid pubkey in key 0x" + p.key.toString("hex")
        );
      return t;
    }
  }
  return checkPubkey.makeChecker = s, checkPubkey;
}
var redeemScript = {}, hasRequiredRedeemScript;
function requireRedeemScript() {
  if (hasRequiredRedeemScript) return redeemScript;
  hasRequiredRedeemScript = 1, Object.defineProperty(redeemScript, "__esModule", { value: !0 });
  function s(A) {
    function u(b) {
      if (b.key[0] !== A)
        throw new Error(
          "Decode Error: could not decode redeemScript with key 0x" + b.key.toString("hex")
        );
      return b.value;
    }
    function p(b) {
      return {
        key: Buffer.from([A]),
        value: b
      };
    }
    const t = "Buffer";
    function l(b) {
      return Buffer.isBuffer(b);
    }
    function m(b, k) {
      return !!b && !!k && b.redeemScript === void 0;
    }
    return {
      decode: u,
      encode: p,
      check: l,
      expected: t,
      canAdd: m
    };
  }
  return redeemScript.makeConverter = s, redeemScript;
}
var tapBip32Derivation = {}, hasRequiredTapBip32Derivation;
function requireTapBip32Derivation() {
  if (hasRequiredTapBip32Derivation) return tapBip32Derivation;
  hasRequiredTapBip32Derivation = 1, Object.defineProperty(tapBip32Derivation, "__esModule", { value: !0 });
  const s = requireVarint$4(), A = requireBip32Derivation(), u = (t) => t.length === 32;
  function p(t) {
    const l = A.makeConverter(t, u);
    function m(B) {
      const Q = s.decode(B.value), P = s.encodingLength(Q), x = l.decode({
        key: B.key,
        value: B.value.slice(P + Q * 32)
      }), M = new Array(Q);
      for (let F = 0, le = P; F < Q; F++, le += 32)
        M[F] = B.value.slice(le, le + 32);
      return Object.assign({}, x, { leafHashes: M });
    }
    function b(B) {
      const Q = l.encode(B), P = s.encodingLength(B.leafHashes.length), x = Buffer.allocUnsafe(P);
      s.encode(B.leafHashes.length, x);
      const M = Buffer.concat([x, ...B.leafHashes, Q.value]);
      return Object.assign({}, Q, { value: M });
    }
    const k = "{ masterFingerprint: Buffer; pubkey: Buffer; path: string; leafHashes: Buffer[]; }";
    function C(B) {
      return Array.isArray(B.leafHashes) && B.leafHashes.every(
        (Q) => Buffer.isBuffer(Q) && Q.length === 32
      ) && l.check(B);
    }
    return {
      decode: m,
      encode: b,
      check: C,
      expected: k,
      canAddToArray: l.canAddToArray
    };
  }
  return tapBip32Derivation.makeConverter = p, tapBip32Derivation;
}
var tapInternalKey = {}, hasRequiredTapInternalKey;
function requireTapInternalKey() {
  if (hasRequiredTapInternalKey) return tapInternalKey;
  hasRequiredTapInternalKey = 1, Object.defineProperty(tapInternalKey, "__esModule", { value: !0 });
  function s(A) {
    function u(b) {
      if (b.key[0] !== A || b.key.length !== 1)
        throw new Error(
          "Decode Error: could not decode tapInternalKey with key 0x" + b.key.toString("hex")
        );
      if (b.value.length !== 32)
        throw new Error(
          "Decode Error: tapInternalKey not a 32-byte x-only pubkey"
        );
      return b.value;
    }
    function p(b) {
      return { key: Buffer.from([A]), value: b };
    }
    const t = "Buffer";
    function l(b) {
      return Buffer.isBuffer(b) && b.length === 32;
    }
    function m(b, k) {
      return !!b && !!k && b.tapInternalKey === void 0;
    }
    return {
      decode: u,
      encode: p,
      check: l,
      expected: t,
      canAdd: m
    };
  }
  return tapInternalKey.makeConverter = s, tapInternalKey;
}
var witnessScript = {}, hasRequiredWitnessScript;
function requireWitnessScript() {
  if (hasRequiredWitnessScript) return witnessScript;
  hasRequiredWitnessScript = 1, Object.defineProperty(witnessScript, "__esModule", { value: !0 });
  function s(A) {
    function u(b) {
      if (b.key[0] !== A)
        throw new Error(
          "Decode Error: could not decode witnessScript with key 0x" + b.key.toString("hex")
        );
      return b.value;
    }
    function p(b) {
      return {
        key: Buffer.from([A]),
        value: b
      };
    }
    const t = "Buffer";
    function l(b) {
      return Buffer.isBuffer(b);
    }
    function m(b, k) {
      return !!b && !!k && b.witnessScript === void 0;
    }
    return {
      decode: u,
      encode: p,
      check: l,
      expected: t,
      canAdd: m
    };
  }
  return witnessScript.makeConverter = s, witnessScript;
}
var hasRequiredConverter;
function requireConverter() {
  if (hasRequiredConverter) return converter;
  hasRequiredConverter = 1, Object.defineProperty(converter, "__esModule", { value: !0 });
  const s = requireTypeFields(), A = requireGlobalXpub(), u = requireUnsignedTx(), p = requireFinalScriptSig(), t = requireFinalScriptWitness(), l = requireNonWitnessUtxo(), m = requirePartialSig(), b = requirePorCommitment(), k = requireSighashType(), C = requireTapKeySig(), B = requireTapLeafScript(), Q = requireTapMerkleRoot(), P = requireTapScriptSig(), x = requireWitnessUtxo(), M = requireTapTree(), F = requireBip32Derivation(), le = requireCheckPubkey(), ge = requireRedeemScript(), pe = requireTapBip32Derivation(), Ie = requireTapInternalKey(), be = requireWitnessScript(), Pe = {
    unsignedTx: u,
    globalXpub: A,
    // pass an Array of key bytes that require pubkey beside the key
    checkPubkey: le.makeChecker([])
  };
  converter.globals = Pe;
  const Te = {
    nonWitnessUtxo: l,
    partialSig: m,
    sighashType: k,
    finalScriptSig: p,
    finalScriptWitness: t,
    porCommitment: b,
    witnessUtxo: x,
    bip32Derivation: F.makeConverter(
      s.InputTypes.BIP32_DERIVATION
    ),
    redeemScript: ge.makeConverter(
      s.InputTypes.REDEEM_SCRIPT
    ),
    witnessScript: be.makeConverter(
      s.InputTypes.WITNESS_SCRIPT
    ),
    checkPubkey: le.makeChecker([
      s.InputTypes.PARTIAL_SIG,
      s.InputTypes.BIP32_DERIVATION
    ]),
    tapKeySig: C,
    tapScriptSig: P,
    tapLeafScript: B,
    tapBip32Derivation: pe.makeConverter(
      s.InputTypes.TAP_BIP32_DERIVATION
    ),
    tapInternalKey: Ie.makeConverter(
      s.InputTypes.TAP_INTERNAL_KEY
    ),
    tapMerkleRoot: Q
  };
  converter.inputs = Te;
  const Qe = {
    bip32Derivation: F.makeConverter(
      s.OutputTypes.BIP32_DERIVATION
    ),
    redeemScript: ge.makeConverter(
      s.OutputTypes.REDEEM_SCRIPT
    ),
    witnessScript: be.makeConverter(
      s.OutputTypes.WITNESS_SCRIPT
    ),
    checkPubkey: le.makeChecker([
      s.OutputTypes.BIP32_DERIVATION
    ]),
    tapBip32Derivation: pe.makeConverter(
      s.OutputTypes.TAP_BIP32_DERIVATION
    ),
    tapTree: M,
    tapInternalKey: Ie.makeConverter(
      s.OutputTypes.TAP_INTERNAL_KEY
    )
  };
  return converter.outputs = Qe, converter;
}
var hasRequiredFromBuffer;
function requireFromBuffer() {
  if (hasRequiredFromBuffer) return fromBuffer;
  hasRequiredFromBuffer = 1, Object.defineProperty(fromBuffer, "__esModule", { value: !0 });
  const s = requireConverter(), A = requireTools(), u = requireVarint$4(), p = requireTypeFields();
  function t(b, k) {
    let C = 0;
    function B() {
      const Qe = u.decode(b, C);
      C += u.encodingLength(Qe);
      const xe = b.slice(C, C + Qe);
      return C += Qe, xe;
    }
    function Q() {
      const Qe = b.readUInt32BE(C);
      return C += 4, Qe;
    }
    function P() {
      const Qe = b.readUInt8(C);
      return C += 1, Qe;
    }
    function x() {
      const Qe = B(), xe = B();
      return {
        key: Qe,
        value: xe
      };
    }
    function M() {
      if (C >= b.length)
        throw new Error("Format Error: Unexpected End of PSBT");
      const Qe = b.readUInt8(C) === 0;
      return Qe && C++, Qe;
    }
    if (Q() !== 1886610036)
      throw new Error("Format Error: Invalid Magic Number");
    if (P() !== 255)
      throw new Error(
        "Format Error: Magic Number must be followed by 0xff separator"
      );
    const F = [], le = {};
    for (; !M(); ) {
      const Qe = x(), xe = Qe.key.toString("hex");
      if (le[xe])
        throw new Error(
          "Format Error: Keys must be unique for global keymap: key " + xe
        );
      le[xe] = 1, F.push(Qe);
    }
    const ge = F.filter(
      (Qe) => Qe.key[0] === p.GlobalTypes.UNSIGNED_TX
    );
    if (ge.length !== 1)
      throw new Error("Format Error: Only one UNSIGNED_TX allowed");
    const pe = k(ge[0].value), { inputCount: Ie, outputCount: be } = pe.getInputOutputCounts(), Pe = [], Te = [];
    for (const Qe of A.range(Ie)) {
      const xe = {}, Ee = [];
      for (; !M(); ) {
        const He = x(), ve = He.key.toString("hex");
        if (xe[ve])
          throw new Error(
            "Format Error: Keys must be unique for each input: input index " + Qe + " key " + ve
          );
        xe[ve] = 1, Ee.push(He);
      }
      Pe.push(Ee);
    }
    for (const Qe of A.range(be)) {
      const xe = {}, Ee = [];
      for (; !M(); ) {
        const He = x(), ve = He.key.toString("hex");
        if (xe[ve])
          throw new Error(
            "Format Error: Keys must be unique for each output: output index " + Qe + " key " + ve
          );
        xe[ve] = 1, Ee.push(He);
      }
      Te.push(Ee);
    }
    return m(pe, {
      globalMapKeyVals: F,
      inputKeyVals: Pe,
      outputKeyVals: Te
    });
  }
  fromBuffer.psbtFromBuffer = t;
  function l(b, k, C) {
    if (!k.equals(Buffer.from([C])))
      throw new Error(
        `Format Error: Invalid ${b} key: ${k.toString("hex")}`
      );
  }
  fromBuffer.checkKeyBuffer = l;
  function m(b, { globalMapKeyVals: k, inputKeyVals: C, outputKeyVals: B }) {
    const Q = {
      unsignedTx: b
    };
    let P = 0;
    for (const ge of k)
      switch (ge.key[0]) {
        case p.GlobalTypes.UNSIGNED_TX:
          if (l(
            "global",
            ge.key,
            p.GlobalTypes.UNSIGNED_TX
          ), P > 0)
            throw new Error("Format Error: GlobalMap has multiple UNSIGNED_TX");
          P++;
          break;
        case p.GlobalTypes.GLOBAL_XPUB:
          Q.globalXpub === void 0 && (Q.globalXpub = []), Q.globalXpub.push(s.globals.globalXpub.decode(ge));
          break;
        default:
          Q.unknownKeyVals || (Q.unknownKeyVals = []), Q.unknownKeyVals.push(ge);
      }
    const x = C.length, M = B.length, F = [], le = [];
    for (const ge of A.range(x)) {
      const pe = {};
      for (const Ie of C[ge])
        switch (s.inputs.checkPubkey(Ie), Ie.key[0]) {
          case p.InputTypes.NON_WITNESS_UTXO:
            if (l(
              "input",
              Ie.key,
              p.InputTypes.NON_WITNESS_UTXO
            ), pe.nonWitnessUtxo !== void 0)
              throw new Error(
                "Format Error: Input has multiple NON_WITNESS_UTXO"
              );
            pe.nonWitnessUtxo = s.inputs.nonWitnessUtxo.decode(Ie);
            break;
          case p.InputTypes.WITNESS_UTXO:
            if (l(
              "input",
              Ie.key,
              p.InputTypes.WITNESS_UTXO
            ), pe.witnessUtxo !== void 0)
              throw new Error("Format Error: Input has multiple WITNESS_UTXO");
            pe.witnessUtxo = s.inputs.witnessUtxo.decode(Ie);
            break;
          case p.InputTypes.PARTIAL_SIG:
            pe.partialSig === void 0 && (pe.partialSig = []), pe.partialSig.push(s.inputs.partialSig.decode(Ie));
            break;
          case p.InputTypes.SIGHASH_TYPE:
            if (l(
              "input",
              Ie.key,
              p.InputTypes.SIGHASH_TYPE
            ), pe.sighashType !== void 0)
              throw new Error("Format Error: Input has multiple SIGHASH_TYPE");
            pe.sighashType = s.inputs.sighashType.decode(Ie);
            break;
          case p.InputTypes.REDEEM_SCRIPT:
            if (l(
              "input",
              Ie.key,
              p.InputTypes.REDEEM_SCRIPT
            ), pe.redeemScript !== void 0)
              throw new Error("Format Error: Input has multiple REDEEM_SCRIPT");
            pe.redeemScript = s.inputs.redeemScript.decode(Ie);
            break;
          case p.InputTypes.WITNESS_SCRIPT:
            if (l(
              "input",
              Ie.key,
              p.InputTypes.WITNESS_SCRIPT
            ), pe.witnessScript !== void 0)
              throw new Error("Format Error: Input has multiple WITNESS_SCRIPT");
            pe.witnessScript = s.inputs.witnessScript.decode(Ie);
            break;
          case p.InputTypes.BIP32_DERIVATION:
            pe.bip32Derivation === void 0 && (pe.bip32Derivation = []), pe.bip32Derivation.push(
              s.inputs.bip32Derivation.decode(Ie)
            );
            break;
          case p.InputTypes.FINAL_SCRIPTSIG:
            l(
              "input",
              Ie.key,
              p.InputTypes.FINAL_SCRIPTSIG
            ), pe.finalScriptSig = s.inputs.finalScriptSig.decode(Ie);
            break;
          case p.InputTypes.FINAL_SCRIPTWITNESS:
            l(
              "input",
              Ie.key,
              p.InputTypes.FINAL_SCRIPTWITNESS
            ), pe.finalScriptWitness = s.inputs.finalScriptWitness.decode(
              Ie
            );
            break;
          case p.InputTypes.POR_COMMITMENT:
            l(
              "input",
              Ie.key,
              p.InputTypes.POR_COMMITMENT
            ), pe.porCommitment = s.inputs.porCommitment.decode(Ie);
            break;
          case p.InputTypes.TAP_KEY_SIG:
            l(
              "input",
              Ie.key,
              p.InputTypes.TAP_KEY_SIG
            ), pe.tapKeySig = s.inputs.tapKeySig.decode(Ie);
            break;
          case p.InputTypes.TAP_SCRIPT_SIG:
            pe.tapScriptSig === void 0 && (pe.tapScriptSig = []), pe.tapScriptSig.push(s.inputs.tapScriptSig.decode(Ie));
            break;
          case p.InputTypes.TAP_LEAF_SCRIPT:
            pe.tapLeafScript === void 0 && (pe.tapLeafScript = []), pe.tapLeafScript.push(s.inputs.tapLeafScript.decode(Ie));
            break;
          case p.InputTypes.TAP_BIP32_DERIVATION:
            pe.tapBip32Derivation === void 0 && (pe.tapBip32Derivation = []), pe.tapBip32Derivation.push(
              s.inputs.tapBip32Derivation.decode(Ie)
            );
            break;
          case p.InputTypes.TAP_INTERNAL_KEY:
            l(
              "input",
              Ie.key,
              p.InputTypes.TAP_INTERNAL_KEY
            ), pe.tapInternalKey = s.inputs.tapInternalKey.decode(Ie);
            break;
          case p.InputTypes.TAP_MERKLE_ROOT:
            l(
              "input",
              Ie.key,
              p.InputTypes.TAP_MERKLE_ROOT
            ), pe.tapMerkleRoot = s.inputs.tapMerkleRoot.decode(Ie);
            break;
          default:
            pe.unknownKeyVals || (pe.unknownKeyVals = []), pe.unknownKeyVals.push(Ie);
        }
      F.push(pe);
    }
    for (const ge of A.range(M)) {
      const pe = {};
      for (const Ie of B[ge])
        switch (s.outputs.checkPubkey(Ie), Ie.key[0]) {
          case p.OutputTypes.REDEEM_SCRIPT:
            if (l(
              "output",
              Ie.key,
              p.OutputTypes.REDEEM_SCRIPT
            ), pe.redeemScript !== void 0)
              throw new Error("Format Error: Output has multiple REDEEM_SCRIPT");
            pe.redeemScript = s.outputs.redeemScript.decode(Ie);
            break;
          case p.OutputTypes.WITNESS_SCRIPT:
            if (l(
              "output",
              Ie.key,
              p.OutputTypes.WITNESS_SCRIPT
            ), pe.witnessScript !== void 0)
              throw new Error("Format Error: Output has multiple WITNESS_SCRIPT");
            pe.witnessScript = s.outputs.witnessScript.decode(Ie);
            break;
          case p.OutputTypes.BIP32_DERIVATION:
            pe.bip32Derivation === void 0 && (pe.bip32Derivation = []), pe.bip32Derivation.push(
              s.outputs.bip32Derivation.decode(Ie)
            );
            break;
          case p.OutputTypes.TAP_INTERNAL_KEY:
            l(
              "output",
              Ie.key,
              p.OutputTypes.TAP_INTERNAL_KEY
            ), pe.tapInternalKey = s.outputs.tapInternalKey.decode(Ie);
            break;
          case p.OutputTypes.TAP_TREE:
            l(
              "output",
              Ie.key,
              p.OutputTypes.TAP_TREE
            ), pe.tapTree = s.outputs.tapTree.decode(Ie);
            break;
          case p.OutputTypes.TAP_BIP32_DERIVATION:
            pe.tapBip32Derivation === void 0 && (pe.tapBip32Derivation = []), pe.tapBip32Derivation.push(
              s.outputs.tapBip32Derivation.decode(Ie)
            );
            break;
          default:
            pe.unknownKeyVals || (pe.unknownKeyVals = []), pe.unknownKeyVals.push(Ie);
        }
      le.push(pe);
    }
    return { globalMap: Q, inputs: F, outputs: le };
  }
  return fromBuffer.psbtFromKeyVals = m, fromBuffer;
}
var toBuffer$1 = {}, hasRequiredToBuffer$2;
function requireToBuffer$2() {
  if (hasRequiredToBuffer$2) return toBuffer$1;
  hasRequiredToBuffer$2 = 1, Object.defineProperty(toBuffer$1, "__esModule", { value: !0 });
  const s = requireConverter(), A = requireTools();
  function u({ globalMap: m, inputs: b, outputs: k }) {
    const { globalKeyVals: C, inputKeyVals: B, outputKeyVals: Q } = l({
      globalMap: m,
      inputs: b,
      outputs: k
    }), P = A.keyValsToBuffer(C), x = (ge) => ge.length === 0 ? [Buffer.from([0])] : ge.map(A.keyValsToBuffer), M = x(B), F = x(Q), le = Buffer.allocUnsafe(5);
    return le.writeUIntBE(482972169471, 0, 5), Buffer.concat(
      [le, P].concat(M, F)
    );
  }
  toBuffer$1.psbtToBuffer = u;
  const p = (m, b) => m.key.compare(b.key);
  function t(m, b) {
    const k = /* @__PURE__ */ new Set(), C = Object.entries(m).reduce((Q, [P, x]) => {
      if (P === "unknownKeyVals") return Q;
      const M = b[P];
      if (M === void 0) return Q;
      const F = (Array.isArray(x) ? x : [x]).map(
        M.encode
      );
      return F.map((ge) => ge.key.toString("hex")).forEach((ge) => {
        if (k.has(ge))
          throw new Error("Serialize Error: Duplicate key: " + ge);
        k.add(ge);
      }), Q.concat(F);
    }, []), B = m.unknownKeyVals ? m.unknownKeyVals.filter((Q) => !k.has(Q.key.toString("hex"))) : [];
    return C.concat(B).sort(p);
  }
  function l({ globalMap: m, inputs: b, outputs: k }) {
    return {
      globalKeyVals: t(m, s.globals),
      inputKeyVals: b.map((C) => t(C, s.inputs)),
      outputKeyVals: k.map((C) => t(C, s.outputs))
    };
  }
  return toBuffer$1.psbtToKeyVals = l, toBuffer$1;
}
var hasRequiredParser;
function requireParser() {
  return hasRequiredParser || (hasRequiredParser = 1, function(s) {
    function A(u) {
      for (var p in u) s.hasOwnProperty(p) || (s[p] = u[p]);
    }
    Object.defineProperty(s, "__esModule", { value: !0 }), A(requireFromBuffer()), A(requireToBuffer$2());
  }(parser)), parser;
}
var hasRequiredCombiner;
function requireCombiner() {
  if (hasRequiredCombiner) return combiner;
  hasRequiredCombiner = 1, Object.defineProperty(combiner, "__esModule", { value: !0 });
  const s = requireParser();
  function A(l) {
    const m = l[0], b = s.psbtToKeyVals(m), k = l.slice(1);
    if (k.length === 0) throw new Error("Combine: Nothing to combine");
    const C = p(m);
    if (C === void 0)
      throw new Error("Combine: Self missing transaction");
    const B = t(b.globalKeyVals), Q = b.inputKeyVals.map(t), P = b.outputKeyVals.map(t);
    for (const x of k) {
      const M = p(x);
      if (M === void 0 || !M.toBuffer().equals(C.toBuffer()))
        throw new Error(
          "Combine: One of the Psbts does not have the same transaction."
        );
      const F = s.psbtToKeyVals(x);
      t(F.globalKeyVals).forEach(
        u(
          B,
          b.globalKeyVals,
          F.globalKeyVals
        )
      ), F.inputKeyVals.map(t).forEach(
        (Ie, be) => Ie.forEach(
          u(
            Q[be],
            b.inputKeyVals[be],
            F.inputKeyVals[be]
          )
        )
      ), F.outputKeyVals.map(t).forEach(
        (Ie, be) => Ie.forEach(
          u(
            P[be],
            b.outputKeyVals[be],
            F.outputKeyVals[be]
          )
        )
      );
    }
    return s.psbtFromKeyVals(C, {
      globalMapKeyVals: b.globalKeyVals,
      inputKeyVals: b.inputKeyVals,
      outputKeyVals: b.outputKeyVals
    });
  }
  combiner.combine = A;
  function u(l, m, b) {
    return (k) => {
      if (l.has(k)) return;
      const C = b.filter((B) => B.key.toString("hex") === k)[0];
      m.push(C), l.add(k);
    };
  }
  function p(l) {
    return l.globalMap.unsignedTx;
  }
  function t(l) {
    const m = /* @__PURE__ */ new Set();
    return l.forEach((b) => {
      const k = b.key.toString("hex");
      if (m.has(k))
        throw new Error("Combine: KeyValue Map keys should be unique");
      m.add(k);
    }), m;
  }
  return combiner;
}
var utils$k = {}, hasRequiredUtils$i;
function requireUtils$i() {
  return hasRequiredUtils$i || (hasRequiredUtils$i = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    const A = requireConverter();
    function u(x, M) {
      const F = x[M];
      if (F === void 0) throw new Error(`No input #${M}`);
      return F;
    }
    s.checkForInput = u;
    function p(x, M) {
      const F = x[M];
      if (F === void 0) throw new Error(`No output #${M}`);
      return F;
    }
    s.checkForOutput = p;
    function t(x, M, F) {
      if (x.key[0] < F)
        throw new Error(
          "Use the method for your specific key instead of addUnknownKeyVal*"
        );
      if (M && M.filter((le) => le.key.equals(x.key)).length !== 0)
        throw new Error(`Duplicate Key: ${x.key.toString("hex")}`);
    }
    s.checkHasKey = t;
    function l(x) {
      let M = 0;
      return Object.keys(x).forEach((F) => {
        Number(isNaN(Number(F))) && M++;
      }), M;
    }
    s.getEnumLength = l;
    function m(x, M) {
      let F = !1;
      if (M.nonWitnessUtxo || M.witnessUtxo) {
        const le = !!M.redeemScript, ge = !!M.witnessScript, pe = !le || !!M.finalScriptSig, Ie = !ge || !!M.finalScriptWitness, be = !!M.finalScriptSig || !!M.finalScriptWitness;
        F = pe && Ie && be;
      }
      if (F === !1)
        throw new Error(
          `Input #${x} has too much or too little data to clean`
        );
    }
    s.inputCheckUncleanFinalized = m;
    function b(x, M, F, le) {
      throw new Error(
        `Data for ${x} key ${M} is incorrect: Expected ${F} and got ${JSON.stringify(le)}`
      );
    }
    function k(x) {
      return (M, F) => {
        for (const le of Object.keys(M)) {
          const ge = M[le], { canAdd: pe, canAddToArray: Ie, check: be, expected: Pe } = (
            // @ts-ignore
            A[x + "s"][le] || {}
          ), Te = !!Ie;
          if (be)
            if (Te) {
              if (!Array.isArray(ge) || // @ts-ignore
              F[le] && !Array.isArray(F[le]))
                throw new Error(`Key type ${le} must be an array`);
              ge.every(be) || b(x, le, Pe, ge);
              const Qe = F[le] || [], xe = /* @__PURE__ */ new Set();
              if (!ge.every((Ee) => Ie(Qe, Ee, xe)))
                throw new Error("Can not add duplicate data to array");
              F[le] = Qe.concat(ge);
            } else {
              if (be(ge) || b(x, le, Pe, ge), !pe(F, ge))
                throw new Error(`Can not add duplicate data to ${x}`);
              F[le] = ge;
            }
        }
      };
    }
    s.updateGlobal = k("global"), s.updateInput = k("input"), s.updateOutput = k("output");
    function C(x, M) {
      const F = x.length - 1, le = u(x, F);
      s.updateInput(M, le);
    }
    s.addInputAttributes = C;
    function B(x, M) {
      const F = x.length - 1, le = p(x, F);
      s.updateOutput(M, le);
    }
    s.addOutputAttributes = B;
    function Q(x, M) {
      if (!Buffer.isBuffer(M) || M.length < 4)
        throw new Error("Set Version: Invalid Transaction");
      return M.writeUInt32LE(x, 0), M;
    }
    s.defaultVersionSetter = Q;
    function P(x, M) {
      if (!Buffer.isBuffer(M) || M.length < 4)
        throw new Error("Set Locktime: Invalid Transaction");
      return M.writeUInt32LE(x, M.length - 4), M;
    }
    s.defaultLocktimeSetter = P;
  }(utils$k)), utils$k;
}
var hasRequiredPsbt$4;
function requirePsbt$4() {
  if (hasRequiredPsbt$4) return psbt$3;
  hasRequiredPsbt$4 = 1, Object.defineProperty(psbt$3, "__esModule", { value: !0 });
  const s = requireCombiner(), A = requireParser(), u = requireTypeFields(), p = requireUtils$i();
  class t {
    constructor(m) {
      this.inputs = [], this.outputs = [], this.globalMap = {
        unsignedTx: m
      };
    }
    static fromBase64(m, b) {
      const k = Buffer.from(m, "base64");
      return this.fromBuffer(k, b);
    }
    static fromHex(m, b) {
      const k = Buffer.from(m, "hex");
      return this.fromBuffer(k, b);
    }
    static fromBuffer(m, b) {
      const k = A.psbtFromBuffer(m, b), C = new this(k.globalMap.unsignedTx);
      return Object.assign(C, k), C;
    }
    toBase64() {
      return this.toBuffer().toString("base64");
    }
    toHex() {
      return this.toBuffer().toString("hex");
    }
    toBuffer() {
      return A.psbtToBuffer(this);
    }
    updateGlobal(m) {
      return p.updateGlobal(m, this.globalMap), this;
    }
    updateInput(m, b) {
      const k = p.checkForInput(this.inputs, m);
      return p.updateInput(b, k), this;
    }
    updateOutput(m, b) {
      const k = p.checkForOutput(this.outputs, m);
      return p.updateOutput(b, k), this;
    }
    addUnknownKeyValToGlobal(m) {
      return p.checkHasKey(
        m,
        this.globalMap.unknownKeyVals,
        p.getEnumLength(u.GlobalTypes)
      ), this.globalMap.unknownKeyVals || (this.globalMap.unknownKeyVals = []), this.globalMap.unknownKeyVals.push(m), this;
    }
    addUnknownKeyValToInput(m, b) {
      const k = p.checkForInput(this.inputs, m);
      return p.checkHasKey(
        b,
        k.unknownKeyVals,
        p.getEnumLength(u.InputTypes)
      ), k.unknownKeyVals || (k.unknownKeyVals = []), k.unknownKeyVals.push(b), this;
    }
    addUnknownKeyValToOutput(m, b) {
      const k = p.checkForOutput(this.outputs, m);
      return p.checkHasKey(
        b,
        k.unknownKeyVals,
        p.getEnumLength(u.OutputTypes)
      ), k.unknownKeyVals || (k.unknownKeyVals = []), k.unknownKeyVals.push(b), this;
    }
    addInput(m) {
      this.globalMap.unsignedTx.addInput(m), this.inputs.push({
        unknownKeyVals: []
      });
      const b = m.unknownKeyVals || [], k = this.inputs.length - 1;
      if (!Array.isArray(b))
        throw new Error("unknownKeyVals must be an Array");
      return b.forEach(
        (C) => this.addUnknownKeyValToInput(k, C)
      ), p.addInputAttributes(this.inputs, m), this;
    }
    addOutput(m) {
      this.globalMap.unsignedTx.addOutput(m), this.outputs.push({
        unknownKeyVals: []
      });
      const b = m.unknownKeyVals || [], k = this.outputs.length - 1;
      if (!Array.isArray(b))
        throw new Error("unknownKeyVals must be an Array");
      return b.forEach(
        (C) => this.addUnknownKeyValToOutput(k, C)
      ), p.addOutputAttributes(this.outputs, m), this;
    }
    clearFinalizedInput(m) {
      const b = p.checkForInput(this.inputs, m);
      p.inputCheckUncleanFinalized(m, b);
      for (const k of Object.keys(b))
        [
          "witnessUtxo",
          "nonWitnessUtxo",
          "finalScriptSig",
          "finalScriptWitness",
          "unknownKeyVals"
        ].includes(k) || delete b[k];
      return this;
    }
    combine(...m) {
      const b = s.combine([this].concat(m));
      return Object.assign(this, b), this;
    }
    getTransaction() {
      return this.globalMap.unsignedTx.toBuffer();
    }
  }
  return psbt$3.Psbt = t, psbt$3;
}
var bip371 = {}, psbtutils = {}, hasRequiredPsbtutils;
function requirePsbtutils() {
  if (hasRequiredPsbtutils) return psbtutils;
  hasRequiredPsbtutils = 1, Object.defineProperty(psbtutils, "__esModule", { value: !0 }), psbtutils.signatureBlocksAction = psbtutils.checkInputForSig = psbtutils.pubkeyInScript = psbtutils.pubkeyPositionInScript = psbtutils.witnessStackToScriptWitness = psbtutils.isP2TR = psbtutils.isP2SHScript = psbtutils.isP2WSHScript = psbtutils.isP2WPKH = psbtutils.isP2PKH = psbtutils.isP2PK = psbtutils.isP2MS = void 0;
  const s = requireVarint$4(), A = requireScript$1(), u = requireTransaction$1(), p = requireCrypto$3(), t = requirePayments();
  function l(x) {
    return (M) => {
      try {
        return x({ output: M }), !0;
      } catch {
        return !1;
      }
    };
  }
  psbtutils.isP2MS = l(t.p2ms), psbtutils.isP2PK = l(t.p2pk), psbtutils.isP2PKH = l(t.p2pkh), psbtutils.isP2WPKH = l(t.p2wpkh), psbtutils.isP2WSHScript = l(t.p2wsh), psbtutils.isP2SHScript = l(t.p2sh), psbtutils.isP2TR = l(t.p2tr);
  function m(x) {
    let M = Buffer.allocUnsafe(0);
    function F(Ie) {
      M = Buffer.concat([M, Buffer.from(Ie)]);
    }
    function le(Ie) {
      const be = M.length, Pe = s.encodingLength(Ie);
      M = Buffer.concat([M, Buffer.allocUnsafe(Pe)]), s.encode(Ie, M, be);
    }
    function ge(Ie) {
      le(Ie.length), F(Ie);
    }
    function pe(Ie) {
      le(Ie.length), Ie.forEach(ge);
    }
    return pe(x), M;
  }
  psbtutils.witnessStackToScriptWitness = m;
  function b(x, M) {
    const F = (0, p.hash160)(x), le = x.slice(1, 33), ge = A.decompile(M);
    if (ge === null) throw new Error("Unknown script error");
    return ge.findIndex((pe) => typeof pe == "number" ? !1 : pe.equals(x) || pe.equals(F) || pe.equals(le));
  }
  psbtutils.pubkeyPositionInScript = b;
  function k(x, M) {
    return b(x, M) !== -1;
  }
  psbtutils.pubkeyInScript = k;
  function C(x, M) {
    return Q(x).some(
      (le) => B(le, A.signature.decode, M)
    );
  }
  psbtutils.checkInputForSig = C;
  function B(x, M, F) {
    const { hashType: le } = M(x), ge = [];
    switch (le & u.Transaction.SIGHASH_ANYONECANPAY && ge.push("addInput"), le & 31) {
      case u.Transaction.SIGHASH_ALL:
        break;
      case u.Transaction.SIGHASH_SINGLE:
      case u.Transaction.SIGHASH_NONE:
        ge.push("addOutput"), ge.push("setInputSequence");
        break;
    }
    return ge.indexOf(F) === -1;
  }
  psbtutils.signatureBlocksAction = B;
  function Q(x) {
    let M = [];
    if ((x.partialSig || []).length === 0) {
      if (!x.finalScriptSig && !x.finalScriptWitness) return [];
      M = P(x);
    } else
      M = x.partialSig;
    return M.map((F) => F.signature);
  }
  function P(x) {
    const M = x.finalScriptSig ? A.decompile(x.finalScriptSig) || [] : [], F = x.finalScriptWitness ? A.decompile(x.finalScriptWitness) || [] : [];
    return M.concat(F).filter((le) => Buffer.isBuffer(le) && A.isCanonicalScriptSignature(le)).map((le) => ({ signature: le }));
  }
  return psbtutils;
}
var hasRequiredBip371;
function requireBip371() {
  if (hasRequiredBip371) return bip371;
  hasRequiredBip371 = 1, Object.defineProperty(bip371, "__esModule", { value: !0 }), bip371.checkTaprootInputForSigs = bip371.tapTreeFromList = bip371.tapTreeToList = bip371.tweakInternalPubKey = bip371.checkTaprootOutputFields = bip371.checkTaprootInputFields = bip371.isTaprootOutput = bip371.isTaprootInput = bip371.serializeTaprootSignature = bip371.tapScriptFinalizer = bip371.toXOnly = void 0;
  const s = requireTypes$9(), A = requireTransaction$1(), u = requirePsbtutils(), p = requireBip341(), t = requirePayments(), l = requirePsbtutils(), m = (ir) => ir.length === 32 ? ir : ir.slice(1, 33);
  bip371.toXOnly = m;
  function b(ir, sr, nr) {
    const fr = Ne(
      sr,
      ir,
      nr
    );
    try {
      const br = Ce(sr, fr).concat(fr.script).concat(fr.controlBlock);
      return {
        finalScriptWitness: (0, u.witnessStackToScriptWitness)(br)
      };
    } catch (lr) {
      throw new Error(`Can not finalize taproot input #${ir}: ${lr}`);
    }
  }
  bip371.tapScriptFinalizer = b;
  function k(ir, sr) {
    const nr = sr ? Buffer.from([sr]) : Buffer.from([]);
    return Buffer.concat([ir, nr]);
  }
  bip371.serializeTaprootSignature = k;
  function C(ir) {
    return ir && !!(ir.tapInternalKey || ir.tapMerkleRoot || ir.tapLeafScript && ir.tapLeafScript.length || ir.tapBip32Derivation && ir.tapBip32Derivation.length || ir.witnessUtxo && (0, u.isP2TR)(ir.witnessUtxo.script));
  }
  bip371.isTaprootInput = C;
  function B(ir, sr) {
    return ir && !!(ir.tapInternalKey || ir.tapTree || ir.tapBip32Derivation && ir.tapBip32Derivation.length || sr && (0, u.isP2TR)(sr));
  }
  bip371.isTaprootOutput = B;
  function Q(ir, sr, nr) {
    Ee(ir, sr, nr), ve(ir, sr, nr);
  }
  bip371.checkTaprootInputFields = Q;
  function P(ir, sr, nr) {
    He(ir, sr, nr), x(ir, sr);
  }
  bip371.checkTaprootOutputFields = P;
  function x(ir, sr) {
    if (!sr.tapTree && !sr.tapInternalKey) return;
    const nr = sr.tapInternalKey || ir.tapInternalKey, fr = sr.tapTree || ir.tapTree;
    if (nr) {
      const { script: lr } = ir, br = M(nr, fr);
      if (lr && !lr.equals(br))
        throw new Error("Error adding output. Script or address missmatch.");
    }
  }
  function M(ir, sr) {
    const nr = sr && ge(sr.leaves), { output: fr } = (0, t.p2tr)({
      internalPubkey: ir,
      scriptTree: nr
    });
    return fr;
  }
  function F(ir, sr) {
    const nr = sr.tapInternalKey, fr = nr && (0, p.tweakKey)(nr, sr.tapMerkleRoot);
    if (!fr)
      throw new Error(
        `Cannot tweak tap internal key for input #${ir}. Public key: ${nr && nr.toString("hex")}`
      );
    return fr.x;
  }
  bip371.tweakInternalPubKey = F;
  function le(ir) {
    if (!(0, s.isTaptree)(ir))
      throw new Error(
        "Cannot convert taptree to tapleaf list. Expecting a tapree structure."
      );
    return Te(ir);
  }
  bip371.tapTreeToList = le;
  function ge(ir = []) {
    return ir.length === 1 && ir[0].depth === 0 ? {
      output: ir[0].script,
      version: ir[0].leafVersion
    } : Qe(ir);
  }
  bip371.tapTreeFromList = ge;
  function pe(ir, sr) {
    return be(ir).some(
      (fr) => (0, l.signatureBlocksAction)(fr, Ie, sr)
    );
  }
  bip371.checkTaprootInputForSigs = pe;
  function Ie(ir) {
    return {
      signature: ir.slice(0, 64),
      hashType: ir.slice(64)[0] || A.Transaction.SIGHASH_DEFAULT
    };
  }
  function be(ir) {
    const sr = [];
    if (ir.tapKeySig && sr.push(ir.tapKeySig), ir.tapScriptSig && sr.push(...ir.tapScriptSig.map((nr) => nr.signature)), !sr.length) {
      const nr = Pe(ir.finalScriptWitness);
      nr && sr.push(nr);
    }
    return sr;
  }
  function Pe(ir) {
    if (!ir) return;
    const sr = ir.slice(2);
    if (sr.length === 64 || sr.length === 65) return sr;
  }
  function Te(ir, sr = [], nr = 0) {
    if (nr > p.MAX_TAPTREE_DEPTH)
      throw new Error("Max taptree depth exceeded.");
    return ir ? (0, s.isTapleaf)(ir) ? (sr.push({
      depth: nr,
      leafVersion: ir.version || p.LEAF_VERSION_TAPSCRIPT,
      script: ir.output
    }), sr) : (ir[0] && Te(ir[0], sr, nr + 1), ir[1] && Te(ir[1], sr, nr + 1), sr) : [];
  }
  function Qe(ir) {
    let sr;
    for (const nr of ir)
      if (sr = xe(nr, sr), !sr) throw new Error("No room left to insert tapleaf in tree");
    return sr;
  }
  function xe(ir, sr, nr = 0) {
    if (nr > p.MAX_TAPTREE_DEPTH)
      throw new Error("Max taptree depth exceeded.");
    if (ir.depth === nr)
      return sr ? void 0 : {
        output: ir.script,
        version: ir.leafVersion
      };
    if ((0, s.isTapleaf)(sr)) return;
    const fr = xe(ir, sr && sr[0], nr + 1);
    if (fr) return [fr, sr && sr[1]];
    const lr = xe(ir, sr && sr[1], nr + 1);
    if (lr) return [sr && sr[0], lr];
  }
  function Ee(ir, sr, nr) {
    const fr = C(ir) && er(sr), lr = er(ir) && C(sr), br = ir === sr && C(sr) && er(sr);
    if (fr || lr || br)
      throw new Error(
        `Invalid arguments for Psbt.${nr}. Cannot use both taproot and non-taproot fields.`
      );
  }
  function He(ir, sr, nr) {
    const fr = B(ir) && er(sr), lr = er(ir) && B(sr), br = ir === sr && B(sr) && er(sr);
    if (fr || lr || br)
      throw new Error(
        `Invalid arguments for Psbt.${nr}. Cannot use both taproot and non-taproot fields.`
      );
  }
  function ve(ir, sr, nr) {
    if (sr.tapMerkleRoot) {
      const fr = (sr.tapLeafScript || []).every(
        (br) => we(br, sr.tapMerkleRoot)
      ), lr = (ir.tapLeafScript || []).every(
        (br) => we(br, sr.tapMerkleRoot)
      );
      if (!fr || !lr)
        throw new Error(
          `Invalid arguments for Psbt.${nr}. Tapleaf not part of taptree.`
        );
    } else if (ir.tapMerkleRoot && !(sr.tapLeafScript || []).every(
      (lr) => we(lr, ir.tapMerkleRoot)
    ))
      throw new Error(
        `Invalid arguments for Psbt.${nr}. Tapleaf not part of taptree.`
      );
  }
  function we(ir, sr) {
    if (!sr) return !0;
    const nr = (0, p.tapleafHash)({
      output: ir.script,
      version: ir.leafVersion
    });
    return (0, p.rootHashFromPath)(
      ir.controlBlock,
      nr
    ).equals(sr);
  }
  function Ce(ir, sr) {
    const nr = (0, p.tapleafHash)({
      output: sr.script,
      version: sr.leafVersion
    });
    return (ir.tapScriptSig || []).filter((fr) => fr.leafHash.equals(nr)).map((fr) => Se(sr.script, fr)).sort((fr, lr) => lr.positionInScript - fr.positionInScript).map((fr) => fr.signature);
  }
  function Se(ir, sr) {
    return Object.assign(
      {
        positionInScript: (0, u.pubkeyPositionInScript)(
          sr.pubkey,
          ir
        )
      },
      sr
    );
  }
  function Ne(ir, sr, nr) {
    if (!ir.tapScriptSig || !ir.tapScriptSig.length)
      throw new Error(
        `Can not finalize taproot input #${sr}. No tapleaf script signature provided.`
      );
    const fr = (ir.tapLeafScript || []).sort((lr, br) => lr.controlBlock.length - br.controlBlock.length).find(
      (lr) => rr(lr, ir.tapScriptSig, nr)
    );
    if (!fr)
      throw new Error(
        `Can not finalize taproot input #${sr}. Signature for tapleaf script not found.`
      );
    return fr;
  }
  function rr(ir, sr, nr) {
    const fr = (0, p.tapleafHash)({
      output: ir.script,
      version: ir.leafVersion
    });
    return (!nr || nr.equals(fr)) && sr.find((br) => br.leafHash.equals(fr)) !== void 0;
  }
  function er(ir) {
    return ir && !!(ir.redeemScript || ir.witnessScript || ir.bip32Derivation && ir.bip32Derivation.length);
  }
  return bip371;
}
var hasRequiredPsbt$3;
function requirePsbt$3() {
  if (hasRequiredPsbt$3) return psbt$4;
  hasRequiredPsbt$3 = 1, Object.defineProperty(psbt$4, "__esModule", { value: !0 }), psbt$4.Psbt = void 0;
  const s = requirePsbt$4(), A = requireVarint$4(), u = requireUtils$i(), p = requireAddress$1(), t = requireBufferutils(), l = requireNetworks$1(), m = requirePayments(), b = requireBip341(), k = requireScript$1(), C = requireTransaction$1(), B = requireBip371(), Q = requirePsbtutils(), P = {
    /**
     * A bitcoinjs Network object. This is only used if you pass an `address`
     * parameter to addOutput. Otherwise it is not needed and can be left default.
     */
    network: l.bitcoin,
    /**
     * When extractTransaction is called, the fee rate is checked.
     * THIS IS NOT TO BE RELIED ON.
     * It is only here as a last ditch effort to prevent sending a 500 BTC fee etc.
     */
    maximumFeeRate: 5e3
    // satoshi per byte
  };
  class x {
    static fromBase64(kr, Rr = {}) {
      const Er = Buffer.from(kr, "base64");
      return this.fromBuffer(Er, Rr);
    }
    static fromHex(kr, Rr = {}) {
      const Er = Buffer.from(kr, "hex");
      return this.fromBuffer(Er, Rr);
    }
    static fromBuffer(kr, Rr = {}) {
      const Er = s.Psbt.fromBuffer(kr, M), Or = new x(Rr, Er);
      return ve(Or.__CACHE.__TX, Or.__CACHE), Or;
    }
    constructor(kr = {}, Rr = new s.Psbt(new F())) {
      this.data = Rr, this.opts = Object.assign({}, P, kr), this.__CACHE = {
        __NON_WITNESS_UTXO_TX_CACHE: [],
        __NON_WITNESS_UTXO_BUF_CACHE: [],
        __TX_IN_CACHE: {},
        __TX: this.data.globalMap.unsignedTx.tx,
        // Psbt's predecessor (TransactionBuilder - now removed) behavior
        // was to not confirm input values  before signing.
        // Even though we highly encourage people to get
        // the full parent transaction to verify values, the ability to
        // sign non-segwit inputs without the full transaction was often
        // requested. So the only way to activate is to use @ts-ignore.
        // We will disable exporting the Psbt when unsafe sign is active.
        // because it is not BIP174 compliant.
        __UNSAFE_SIGN_NONSEGWIT: !1
      }, this.data.inputs.length === 0 && this.setVersion(2);
      const Er = (Or, wn, Kn, Ln) => Object.defineProperty(Or, wn, {
        enumerable: Kn,
        writable: Ln
      });
      Er(this, "__CACHE", !1, !0), Er(this, "opts", !1, !0);
    }
    get inputCount() {
      return this.data.inputs.length;
    }
    get version() {
      return this.__CACHE.__TX.version;
    }
    set version(kr) {
      this.setVersion(kr);
    }
    get locktime() {
      return this.__CACHE.__TX.locktime;
    }
    set locktime(kr) {
      this.setLocktime(kr);
    }
    get txInputs() {
      return this.__CACHE.__TX.ins.map((kr) => ({
        hash: (0, t.cloneBuffer)(kr.hash),
        index: kr.index,
        sequence: kr.sequence
      }));
    }
    get txOutputs() {
      return this.__CACHE.__TX.outs.map((kr) => {
        let Rr;
        try {
          Rr = (0, p.fromOutputScript)(
            kr.script,
            this.opts.network
          );
        } catch {
        }
        return {
          script: (0, t.cloneBuffer)(kr.script),
          value: kr.value,
          address: Rr
        };
      });
    }
    combine(...kr) {
      return this.data.combine(...kr.map((Rr) => Rr.data)), this;
    }
    clone() {
      const kr = x.fromBuffer(this.data.toBuffer());
      return kr.opts = JSON.parse(JSON.stringify(this.opts)), kr;
    }
    setMaximumFeeRate(kr) {
      Pe(kr), this.opts.maximumFeeRate = kr;
    }
    setVersion(kr) {
      Pe(kr), Qe(this.data.inputs, "setVersion");
      const Rr = this.__CACHE;
      return Rr.__TX.version = kr, Rr.__EXTRACTED_TX = void 0, this;
    }
    setLocktime(kr) {
      Pe(kr), Qe(this.data.inputs, "setLocktime");
      const Rr = this.__CACHE;
      return Rr.__TX.locktime = kr, Rr.__EXTRACTED_TX = void 0, this;
    }
    setInputSequence(kr, Rr) {
      Pe(Rr), Qe(this.data.inputs, "setInputSequence");
      const Er = this.__CACHE;
      if (Er.__TX.ins.length <= kr)
        throw new Error("Input index too high");
      return Er.__TX.ins[kr].sequence = Rr, Er.__EXTRACTED_TX = void 0, this;
    }
    addInputs(kr) {
      return kr.forEach((Rr) => this.addInput(Rr)), this;
    }
    addInput(kr) {
      if (arguments.length > 1 || !kr || kr.hash === void 0 || kr.index === void 0)
        throw new Error(
          "Invalid arguments for Psbt.addInput. Requires single object with at least [hash] and [index]"
        );
      (0, B.checkTaprootInputFields)(kr, kr, "addInput"), Qe(this.data.inputs, "addInput"), kr.witnessScript && In(kr.witnessScript);
      const Rr = this.__CACHE;
      this.data.addInput(kr);
      const Er = Rr.__TX.ins[Rr.__TX.ins.length - 1];
      we(Rr, Er);
      const Or = this.data.inputs.length - 1, wn = this.data.inputs[Or];
      return wn.nonWitnessUtxo && yr(this.__CACHE, wn, Or), Rr.__FEE = void 0, Rr.__FEE_RATE = void 0, Rr.__EXTRACTED_TX = void 0, this;
    }
    addOutputs(kr) {
      return kr.forEach((Rr) => this.addOutput(Rr)), this;
    }
    addOutput(kr) {
      if (arguments.length > 1 || !kr || kr.value === void 0 || kr.address === void 0 && kr.script === void 0)
        throw new Error(
          "Invalid arguments for Psbt.addOutput. Requires single object with at least [script or address] and [value]"
        );
      Qe(this.data.inputs, "addOutput");
      const { address: Rr } = kr;
      if (typeof Rr == "string") {
        const { network: Or } = this.opts, wn = (0, p.toOutputScript)(Rr, Or);
        kr = Object.assign({}, kr, { script: wn });
      }
      (0, B.checkTaprootOutputFields)(kr, kr, "addOutput");
      const Er = this.__CACHE;
      return this.data.addOutput(kr), Er.__FEE = void 0, Er.__FEE_RATE = void 0, Er.__EXTRACTED_TX = void 0, this;
    }
    extractTransaction(kr) {
      if (!this.data.inputs.every(Ie)) throw new Error("Not finalized");
      const Rr = this.__CACHE;
      if (kr || Te(this, Rr, this.opts), Rr.__EXTRACTED_TX) return Rr.__EXTRACTED_TX;
      const Er = Rr.__TX.clone();
      return Qr(this.data.inputs, Er, Rr, !0), Er;
    }
    getFeeRate() {
      return rr(
        "__FEE_RATE",
        "fee rate",
        this.data.inputs,
        this.__CACHE
      );
    }
    getFee() {
      return rr("__FEE", "fee", this.data.inputs, this.__CACHE);
    }
    finalizeAllInputs() {
      return (0, u.checkForInput)(this.data.inputs, 0), En(this.data.inputs.length).forEach((kr) => this.finalizeInput(kr)), this;
    }
    finalizeInput(kr, Rr) {
      const Er = (0, u.checkForInput)(this.data.inputs, kr);
      return (0, B.isTaprootInput)(Er) ? this._finalizeTaprootInput(
        kr,
        Er,
        void 0,
        Rr
      ) : this._finalizeInput(kr, Er, Rr);
    }
    finalizeTaprootInput(kr, Rr, Er = B.tapScriptFinalizer) {
      const Or = (0, u.checkForInput)(this.data.inputs, kr);
      if ((0, B.isTaprootInput)(Or))
        return this._finalizeTaprootInput(
          kr,
          Or,
          Rr,
          Er
        );
      throw new Error(`Cannot finalize input #${kr}. Not Taproot.`);
    }
    _finalizeInput(kr, Rr, Er = er) {
      const { script: Or, isP2SH: wn, isP2WSH: Kn, isSegwit: Ln } = qr(
        kr,
        Rr,
        this.__CACHE
      );
      if (!Or) throw new Error(`No script found for input #${kr}`);
      xe(Rr);
      const { finalScriptSig: Wn, finalScriptWitness: Sn } = Er(
        kr,
        Rr,
        Or,
        Ln,
        wn,
        Kn
      );
      if (Wn && this.data.updateInput(kr, { finalScriptSig: Wn }), Sn && this.data.updateInput(kr, { finalScriptWitness: Sn }), !Wn && !Sn)
        throw new Error(`Unknown error finalizing input #${kr}`);
      return this.data.clearFinalizedInput(kr), this;
    }
    _finalizeTaprootInput(kr, Rr, Er, Or = B.tapScriptFinalizer) {
      if (!Rr.witnessUtxo)
        throw new Error(
          `Cannot finalize input #${kr}. Missing withness utxo.`
        );
      if (Rr.tapKeySig) {
        const wn = m.p2tr({
          output: Rr.witnessUtxo.script,
          signature: Rr.tapKeySig
        }), Kn = (0, Q.witnessStackToScriptWitness)(
          wn.witness
        );
        this.data.updateInput(kr, { finalScriptWitness: Kn });
      } else {
        const { finalScriptWitness: wn } = Or(
          kr,
          Rr,
          Er
        );
        this.data.updateInput(kr, { finalScriptWitness: wn });
      }
      return this.data.clearFinalizedInput(kr), this;
    }
    getInputType(kr) {
      const Rr = (0, u.checkForInput)(this.data.inputs, kr), Er = Jr(kr, Rr, this.__CACHE), Or = Xr(
        Er,
        kr,
        "input",
        Rr.redeemScript || Tn(Rr.finalScriptSig),
        Rr.witnessScript || Yn(Rr.finalScriptWitness)
      ), wn = Or.type === "raw" ? "" : Or.type + "-", Kn = zr(Or.meaningfulScript);
      return wn + Kn;
    }
    inputHasPubkey(kr, Rr) {
      const Er = (0, u.checkForInput)(this.data.inputs, kr);
      return jr(Rr, Er, kr, this.__CACHE);
    }
    inputHasHDKey(kr, Rr) {
      const Er = (0, u.checkForInput)(this.data.inputs, kr), Or = be(Rr);
      return !!Er.bip32Derivation && Er.bip32Derivation.some(Or);
    }
    outputHasPubkey(kr, Rr) {
      const Er = (0, u.checkForOutput)(this.data.outputs, kr);
      return dn(Rr, Er, kr, this.__CACHE);
    }
    outputHasHDKey(kr, Rr) {
      const Er = (0, u.checkForOutput)(this.data.outputs, kr), Or = be(Rr);
      return !!Er.bip32Derivation && Er.bip32Derivation.some(Or);
    }
    validateSignaturesOfAllInputs(kr) {
      return (0, u.checkForInput)(this.data.inputs, 0), En(this.data.inputs.length).map(
        (Er) => this.validateSignaturesOfInput(Er, kr)
      ).reduce((Er, Or) => Or === !0 && Er, !0);
    }
    validateSignaturesOfInput(kr, Rr, Er) {
      const Or = this.data.inputs[kr];
      return (0, B.isTaprootInput)(Or) ? this.validateSignaturesOfTaprootInput(
        kr,
        Rr,
        Er
      ) : this._validateSignaturesOfInput(kr, Rr, Er);
    }
    _validateSignaturesOfInput(kr, Rr, Er) {
      const Or = this.data.inputs[kr], wn = (Or || {}).partialSig;
      if (!Or || !wn || wn.length < 1)
        throw new Error("No signatures to validate");
      if (typeof Rr != "function")
        throw new Error("Need validator function to validate signatures");
      const Kn = Er ? wn.filter((ki) => ki.pubkey.equals(Er)) : wn;
      if (Kn.length < 1) throw new Error("No signatures for this pubkey");
      const Ln = [];
      let Wn, Sn, hi;
      for (const ki of Kn) {
        const xi = k.signature.decode(ki.signature), { hash: _i, script: Li } = hi !== xi.hashType ? nr(
          kr,
          Object.assign({}, Or, { sighashType: xi.hashType }),
          this.__CACHE,
          !0
        ) : { hash: Wn, script: Sn };
        hi = xi.hashType, Wn = _i, Sn = Li, Ee(ki.pubkey, Li, "verify"), Ln.push(Rr(ki.pubkey, _i, xi.signature));
      }
      return Ln.every((ki) => ki === !0);
    }
    validateSignaturesOfTaprootInput(kr, Rr, Er) {
      const Or = this.data.inputs[kr], wn = (Or || {}).tapKeySig, Kn = (Or || {}).tapScriptSig;
      if (!Or && !wn && !(Kn && !Kn.length))
        throw new Error("No signatures to validate");
      if (typeof Rr != "function")
        throw new Error("Need validator function to validate signatures");
      Er = Er && (0, B.toXOnly)(Er);
      const Ln = Er ? Br(
        kr,
        Or,
        this.data.inputs,
        Er,
        this.__CACHE
      ) : fr(
        kr,
        Or,
        this.data.inputs,
        this.__CACHE
      );
      if (!Ln.length) throw new Error("No signatures for this pubkey");
      const Wn = Ln.find((hi) => !hi.leafHash);
      let Sn = 0;
      if (wn && Wn) {
        if (!Rr(
          Wn.pubkey,
          Wn.hash,
          br(wn)
        )) return !1;
        Sn++;
      }
      if (Kn)
        for (const hi of Kn) {
          const ki = Ln.find((xi) => hi.pubkey.equals(xi.pubkey));
          if (ki) {
            if (!Rr(
              hi.pubkey,
              ki.hash,
              br(hi.signature)
            )) return !1;
            Sn++;
          }
        }
      return Sn > 0;
    }
    signAllInputsHD(kr, Rr = [C.Transaction.SIGHASH_ALL]) {
      if (!kr || !kr.publicKey || !kr.fingerprint)
        throw new Error("Need HDSigner to sign input");
      const Er = [];
      for (const Or of En(this.data.inputs.length))
        try {
          this.signInputHD(Or, kr, Rr), Er.push(!0);
        } catch {
          Er.push(!1);
        }
      if (Er.every((Or) => Or === !1))
        throw new Error("No inputs were signed");
      return this;
    }
    signAllInputsHDAsync(kr, Rr = [C.Transaction.SIGHASH_ALL]) {
      return new Promise((Er, Or) => {
        if (!kr || !kr.publicKey || !kr.fingerprint)
          return Or(new Error("Need HDSigner to sign input"));
        const wn = [], Kn = [];
        for (const Ln of En(this.data.inputs.length))
          Kn.push(
            this.signInputHDAsync(Ln, kr, Rr).then(
              () => {
                wn.push(!0);
              },
              () => {
                wn.push(!1);
              }
            )
          );
        return Promise.all(Kn).then(() => {
          if (wn.every((Ln) => Ln === !1))
            return Or(new Error("No inputs were signed"));
          Er();
        });
      });
    }
    signInputHD(kr, Rr, Er = [C.Transaction.SIGHASH_ALL]) {
      if (!Rr || !Rr.publicKey || !Rr.fingerprint)
        throw new Error("Need HDSigner to sign input");
      return Hr(kr, this.data.inputs, Rr).forEach((wn) => this.signInput(kr, wn, Er)), this;
    }
    signInputHDAsync(kr, Rr, Er = [C.Transaction.SIGHASH_ALL]) {
      return new Promise((Or, wn) => {
        if (!Rr || !Rr.publicKey || !Rr.fingerprint)
          return wn(new Error("Need HDSigner to sign input"));
        const Ln = Hr(kr, this.data.inputs, Rr).map(
          (Wn) => this.signInputAsync(kr, Wn, Er)
        );
        return Promise.all(Ln).then(() => {
          Or();
        }).catch(wn);
      });
    }
    signAllInputs(kr, Rr) {
      if (!kr || !kr.publicKey)
        throw new Error("Need Signer to sign input");
      const Er = [];
      for (const Or of En(this.data.inputs.length))
        try {
          this.signInput(Or, kr, Rr), Er.push(!0);
        } catch {
          Er.push(!1);
        }
      if (Er.every((Or) => Or === !1))
        throw new Error("No inputs were signed");
      return this;
    }
    signAllInputsAsync(kr, Rr) {
      return new Promise((Er, Or) => {
        if (!kr || !kr.publicKey)
          return Or(new Error("Need Signer to sign input"));
        const wn = [], Kn = [];
        for (const [Ln] of this.data.inputs.entries())
          Kn.push(
            this.signInputAsync(Ln, kr, Rr).then(
              () => {
                wn.push(!0);
              },
              () => {
                wn.push(!1);
              }
            )
          );
        return Promise.all(Kn).then(() => {
          if (wn.every((Ln) => Ln === !1))
            return Or(new Error("No inputs were signed"));
          Er();
        });
      });
    }
    signInput(kr, Rr, Er) {
      if (!Rr || !Rr.publicKey)
        throw new Error("Need Signer to sign input");
      const Or = (0, u.checkForInput)(this.data.inputs, kr);
      return (0, B.isTaprootInput)(Or) ? this._signTaprootInput(
        kr,
        Or,
        Rr,
        void 0,
        Er
      ) : this._signInput(kr, Rr, Er);
    }
    signTaprootInput(kr, Rr, Er, Or) {
      if (!Rr || !Rr.publicKey)
        throw new Error("Need Signer to sign input");
      const wn = (0, u.checkForInput)(this.data.inputs, kr);
      if ((0, B.isTaprootInput)(wn))
        return this._signTaprootInput(
          kr,
          wn,
          Rr,
          Er,
          Or
        );
      throw new Error(`Input #${kr} is not of type Taproot.`);
    }
    _signInput(kr, Rr, Er = [C.Transaction.SIGHASH_ALL]) {
      const { hash: Or, sighashType: wn } = sr(
        this.data.inputs,
        kr,
        Rr.publicKey,
        this.__CACHE,
        Er
      ), Kn = [
        {
          pubkey: Rr.publicKey,
          signature: k.signature.encode(Rr.sign(Or), wn)
        }
      ];
      return this.data.updateInput(kr, { partialSig: Kn }), this;
    }
    _signTaprootInput(kr, Rr, Er, Or, wn = [C.Transaction.SIGHASH_DEFAULT]) {
      const Kn = this.checkTaprootHashesForSig(
        kr,
        Rr,
        Er,
        Or,
        wn
      ), Ln = Kn.filter((Sn) => !Sn.leafHash).map(
        (Sn) => (0, B.serializeTaprootSignature)(
          Er.signSchnorr(Sn.hash),
          Rr.sighashType
        )
      )[0], Wn = Kn.filter((Sn) => !!Sn.leafHash).map((Sn) => ({
        pubkey: (0, B.toXOnly)(Er.publicKey),
        signature: (0, B.serializeTaprootSignature)(
          Er.signSchnorr(Sn.hash),
          Rr.sighashType
        ),
        leafHash: Sn.leafHash
      }));
      return Ln && this.data.updateInput(kr, { tapKeySig: Ln }), Wn.length && this.data.updateInput(kr, { tapScriptSig: Wn }), this;
    }
    signInputAsync(kr, Rr, Er) {
      return Promise.resolve().then(() => {
        if (!Rr || !Rr.publicKey)
          throw new Error("Need Signer to sign input");
        const Or = (0, u.checkForInput)(this.data.inputs, kr);
        return (0, B.isTaprootInput)(Or) ? this._signTaprootInputAsync(
          kr,
          Or,
          Rr,
          void 0,
          Er
        ) : this._signInputAsync(kr, Rr, Er);
      });
    }
    signTaprootInputAsync(kr, Rr, Er, Or) {
      return Promise.resolve().then(() => {
        if (!Rr || !Rr.publicKey)
          throw new Error("Need Signer to sign input");
        const wn = (0, u.checkForInput)(this.data.inputs, kr);
        if ((0, B.isTaprootInput)(wn))
          return this._signTaprootInputAsync(
            kr,
            wn,
            Rr,
            Er,
            Or
          );
        throw new Error(`Input #${kr} is not of type Taproot.`);
      });
    }
    _signInputAsync(kr, Rr, Er = [C.Transaction.SIGHASH_ALL]) {
      const { hash: Or, sighashType: wn } = sr(
        this.data.inputs,
        kr,
        Rr.publicKey,
        this.__CACHE,
        Er
      );
      return Promise.resolve(Rr.sign(Or)).then((Kn) => {
        const Ln = [
          {
            pubkey: Rr.publicKey,
            signature: k.signature.encode(Kn, wn)
          }
        ];
        this.data.updateInput(kr, { partialSig: Ln });
      });
    }
    async _signTaprootInputAsync(kr, Rr, Er, Or, wn = [C.Transaction.SIGHASH_DEFAULT]) {
      const Kn = this.checkTaprootHashesForSig(
        kr,
        Rr,
        Er,
        Or,
        wn
      ), Ln = [], Wn = Kn.filter((hi) => !hi.leafHash)[0];
      if (Wn) {
        const hi = Promise.resolve(
          Er.signSchnorr(Wn.hash)
        ).then((ki) => ({
          tapKeySig: (0, B.serializeTaprootSignature)(
            ki,
            Rr.sighashType
          )
        }));
        Ln.push(hi);
      }
      const Sn = Kn.filter((hi) => !!hi.leafHash);
      if (Sn.length) {
        const hi = Sn.map((ki) => Promise.resolve(Er.signSchnorr(ki.hash)).then(
          (xi) => ({ tapScriptSig: [
            {
              pubkey: (0, B.toXOnly)(Er.publicKey),
              signature: (0, B.serializeTaprootSignature)(
                xi,
                Rr.sighashType
              ),
              leafHash: ki.leafHash
            }
          ] })
        ));
        Ln.push(...hi);
      }
      return Promise.all(Ln).then((hi) => {
        hi.forEach((ki) => this.data.updateInput(kr, ki));
      });
    }
    checkTaprootHashesForSig(kr, Rr, Er, Or, wn) {
      if (typeof Er.signSchnorr != "function")
        throw new Error(
          `Need Schnorr Signer to sign taproot input #${kr}.`
        );
      const Kn = Br(
        kr,
        Rr,
        this.data.inputs,
        Er.publicKey,
        this.__CACHE,
        Or,
        wn
      );
      if (!Kn || !Kn.length)
        throw new Error(
          `Can not sign for input #${kr} with the key ${Er.publicKey.toString(
            "hex"
          )}`
        );
      return Kn;
    }
    toBuffer() {
      return ge(this.__CACHE), this.data.toBuffer();
    }
    toHex() {
      return ge(this.__CACHE), this.data.toHex();
    }
    toBase64() {
      return ge(this.__CACHE), this.data.toBase64();
    }
    updateGlobal(kr) {
      return this.data.updateGlobal(kr), this;
    }
    updateInput(kr, Rr) {
      return Rr.witnessScript && In(Rr.witnessScript), (0, B.checkTaprootInputFields)(
        this.data.inputs[kr],
        Rr,
        "updateInput"
      ), this.data.updateInput(kr, Rr), Rr.nonWitnessUtxo && yr(
        this.__CACHE,
        this.data.inputs[kr],
        kr
      ), this;
    }
    updateOutput(kr, Rr) {
      const Er = this.data.outputs[kr];
      return (0, B.checkTaprootOutputFields)(
        Er,
        Rr,
        "updateOutput"
      ), this.data.updateOutput(kr, Rr), this;
    }
    addUnknownKeyValToGlobal(kr) {
      return this.data.addUnknownKeyValToGlobal(kr), this;
    }
    addUnknownKeyValToInput(kr, Rr) {
      return this.data.addUnknownKeyValToInput(kr, Rr), this;
    }
    addUnknownKeyValToOutput(kr, Rr) {
      return this.data.addUnknownKeyValToOutput(kr, Rr), this;
    }
    clearFinalizedInput(kr) {
      return this.data.clearFinalizedInput(kr), this;
    }
  }
  psbt$4.Psbt = x;
  const M = (Zr) => new F(Zr);
  class F {
    constructor(kr = Buffer.from([2, 0, 0, 0, 0, 0, 0, 0, 0, 0])) {
      this.tx = C.Transaction.fromBuffer(kr), He(this.tx), Object.defineProperty(this, "tx", {
        enumerable: !1,
        writable: !0
      });
    }
    getInputOutputCounts() {
      return {
        inputCount: this.tx.ins.length,
        outputCount: this.tx.outs.length
      };
    }
    addInput(kr) {
      if (kr.hash === void 0 || kr.index === void 0 || !Buffer.isBuffer(kr.hash) && typeof kr.hash != "string" || typeof kr.index != "number")
        throw new Error("Error adding input.");
      const Rr = typeof kr.hash == "string" ? (0, t.reverseBuffer)(Buffer.from(kr.hash, "hex")) : kr.hash;
      this.tx.addInput(Rr, kr.index, kr.sequence);
    }
    addOutput(kr) {
      if (kr.script === void 0 || kr.value === void 0 || !Buffer.isBuffer(kr.script) || typeof kr.value != "number")
        throw new Error("Error adding output.");
      this.tx.addOutput(kr.script, kr.value);
    }
    toBuffer() {
      return this.tx.toBuffer();
    }
  }
  function le(Zr, kr, Rr) {
    switch (Rr) {
      case "pubkey":
      case "pubkeyhash":
      case "witnesspubkeyhash":
        return pe(1, Zr.partialSig);
      case "multisig":
        const Er = m.p2ms({ output: kr });
        return pe(Er.m, Zr.partialSig, Er.pubkeys);
      default:
        return !1;
    }
  }
  function ge(Zr) {
    if (Zr.__UNSAFE_SIGN_NONSEGWIT !== !1)
      throw new Error("Not BIP174 compliant, can not export");
  }
  function pe(Zr, kr, Rr) {
    if (!kr) return !1;
    let Er;
    if (Rr ? Er = Rr.map((Or) => {
      const wn = si(Or);
      return kr.find((Kn) => Kn.pubkey.equals(wn));
    }).filter((Or) => !!Or) : Er = kr, Er.length > Zr) throw new Error("Too many signatures");
    return Er.length === Zr;
  }
  function Ie(Zr) {
    return !!Zr.finalScriptSig || !!Zr.finalScriptWitness;
  }
  function be(Zr) {
    return (kr) => !(!kr.masterFingerprint.equals(Zr.fingerprint) || !Zr.derivePath(kr.path).publicKey.equals(kr.pubkey));
  }
  function Pe(Zr) {
    if (typeof Zr != "number" || Zr !== Math.floor(Zr) || Zr > 4294967295 || Zr < 0)
      throw new Error("Invalid 32 bit integer");
  }
  function Te(Zr, kr, Rr) {
    const Er = kr.__FEE_RATE || Zr.getFeeRate(), Or = kr.__EXTRACTED_TX.virtualSize(), wn = Er * Or;
    if (Er >= Rr.maximumFeeRate)
      throw new Error(
        `Warning: You are paying around ${(wn / 1e8).toFixed(8)} in fees, which is ${Er} satoshi per byte for a transaction with a VSize of ${Or} bytes (segwit counted as 0.25 byte per byte). Use setMaximumFeeRate method to raise your threshold, or pass true to the first arg of extractTransaction.`
      );
  }
  function Qe(Zr, kr) {
    Zr.forEach((Rr) => {
      if ((0, B.isTaprootInput)(Rr) ? (0, B.checkTaprootInputForSigs)(Rr, kr) : (0, Q.checkInputForSig)(Rr, kr))
        throw new Error("Can not modify transaction, signatures exist.");
    });
  }
  function xe(Zr) {
    if (!Zr.sighashType || !Zr.partialSig) return;
    const { partialSig: kr, sighashType: Rr } = Zr;
    kr.forEach((Er) => {
      const { hashType: Or } = k.signature.decode(Er.signature);
      if (Rr !== Or)
        throw new Error("Signature sighash does not match input sighash type");
    });
  }
  function Ee(Zr, kr, Rr) {
    if (!(0, Q.pubkeyInScript)(Zr, kr))
      throw new Error(
        `Can not ${Rr} for this input with the key ${Zr.toString("hex")}`
      );
  }
  function He(Zr) {
    if (!Zr.ins.every(
      (Rr) => Rr.script && Rr.script.length === 0 && Rr.witness && Rr.witness.length === 0
    ))
      throw new Error("Format Error: Transaction ScriptSigs are not empty");
  }
  function ve(Zr, kr) {
    Zr.ins.forEach((Rr) => {
      we(kr, Rr);
    });
  }
  function we(Zr, kr) {
    const Rr = (0, t.reverseBuffer)(Buffer.from(kr.hash)).toString("hex") + ":" + kr.index;
    if (Zr.__TX_IN_CACHE[Rr]) throw new Error("Duplicate input detected.");
    Zr.__TX_IN_CACHE[Rr] = 1;
  }
  function Ce(Zr, kr) {
    return (Rr, Er, Or, wn) => {
      const Kn = Zr({
        redeem: { output: Or }
      }).output;
      if (!Er.equals(Kn))
        throw new Error(
          `${kr} for ${wn} #${Rr} doesn't match the scriptPubKey in the prevout`
        );
    };
  }
  const Se = Ce(m.p2sh, "Redeem script"), Ne = Ce(
    m.p2wsh,
    "Witness script"
  );
  function rr(Zr, kr, Rr, Er) {
    if (!Rr.every(Ie))
      throw new Error(`PSBT must be finalized to calculate ${kr}`);
    if (Zr === "__FEE_RATE" && Er.__FEE_RATE) return Er.__FEE_RATE;
    if (Zr === "__FEE" && Er.__FEE) return Er.__FEE;
    let Or, wn = !0;
    if (Er.__EXTRACTED_TX ? (Or = Er.__EXTRACTED_TX, wn = !1) : Or = Er.__TX.clone(), Qr(Rr, Or, Er, wn), Zr === "__FEE_RATE") return Er.__FEE_RATE;
    if (Zr === "__FEE") return Er.__FEE;
  }
  function er(Zr, kr, Rr, Er, Or, wn) {
    const Kn = zr(Rr);
    if (!le(kr, Rr, Kn))
      throw new Error(`Can not finalize input #${Zr}`);
    return ir(
      Rr,
      Kn,
      kr.partialSig,
      Er,
      Or,
      wn
    );
  }
  function ir(Zr, kr, Rr, Er, Or, wn) {
    let Kn, Ln;
    const Wn = Gr(Zr, kr, Rr), Sn = wn ? m.p2wsh({ redeem: Wn }) : null, hi = Or ? m.p2sh({ redeem: Sn || Wn }) : null;
    return Er ? (Sn ? Ln = (0, Q.witnessStackToScriptWitness)(
      Sn.witness
    ) : Ln = (0, Q.witnessStackToScriptWitness)(
      Wn.witness
    ), hi && (Kn = hi.input)) : hi ? Kn = hi.input : Kn = Wn.input, {
      finalScriptSig: Kn,
      finalScriptWitness: Ln
    };
  }
  function sr(Zr, kr, Rr, Er, Or) {
    const wn = (0, u.checkForInput)(Zr, kr), { hash: Kn, sighashType: Ln, script: Wn } = nr(
      kr,
      wn,
      Er,
      !1,
      Or
    );
    return Ee(Rr, Wn, "sign"), {
      hash: Kn,
      sighashType: Ln
    };
  }
  function nr(Zr, kr, Rr, Er, Or) {
    const wn = Rr.__TX, Kn = kr.sighashType || C.Transaction.SIGHASH_ALL;
    Fr(Kn, Or);
    let Ln, Wn;
    if (kr.nonWitnessUtxo) {
      const ki = _r(
        Rr,
        kr,
        Zr
      ), xi = wn.ins[Zr].hash, _i = ki.getHash();
      if (!xi.equals(_i))
        throw new Error(
          `Non-witness UTXO hash for input #${Zr} doesn't match the hash specified in the prevout`
        );
      const Li = wn.ins[Zr].index;
      Wn = ki.outs[Li];
    } else if (kr.witnessUtxo)
      Wn = kr.witnessUtxo;
    else
      throw new Error("Need a Utxo input item for signing");
    const { meaningfulScript: Sn, type: hi } = Xr(
      Wn.script,
      Zr,
      "input",
      kr.redeemScript,
      kr.witnessScript
    );
    if (["p2sh-p2wsh", "p2wsh"].indexOf(hi) >= 0)
      Ln = wn.hashForWitnessV0(
        Zr,
        Sn,
        Wn.value,
        Kn
      );
    else if ((0, Q.isP2WPKH)(Sn)) {
      const ki = m.p2pkh({
        hash: Sn.slice(2)
      }).output;
      Ln = wn.hashForWitnessV0(
        Zr,
        ki,
        Wn.value,
        Kn
      );
    } else {
      if (kr.nonWitnessUtxo === void 0 && Rr.__UNSAFE_SIGN_NONSEGWIT === !1)
        throw new Error(
          `Input #${Zr} has witnessUtxo but non-segwit script: ${Sn.toString("hex")}`
        );
      !Er && Rr.__UNSAFE_SIGN_NONSEGWIT !== !1 && console.warn(
        `Warning: Signing non-segwit inputs without the full parent transaction means there is a chance that a miner could feed you incorrect information to trick you into paying large fees. This behavior is the same as Psbt's predecessor (TransactionBuilder - now removed) when signing non-segwit scripts. You are not able to export this Psbt with toBuffer|toBase64|toHex since it is not BIP174 compliant.
*********************
PROCEED WITH CAUTION!
*********************`
      ), Ln = wn.hashForSignature(
        Zr,
        Sn,
        Kn
      );
    }
    return {
      script: Sn,
      sighashType: Kn,
      hash: Ln
    };
  }
  function fr(Zr, kr, Rr, Er) {
    const Or = [];
    if (kr.tapInternalKey) {
      const Kn = lr(Zr, kr, Er);
      Kn && Or.push(Kn);
    }
    if (kr.tapScriptSig) {
      const Kn = kr.tapScriptSig.map((Ln) => Ln.pubkey);
      Or.push(...Kn);
    }
    return Or.map(
      (Kn) => Br(Zr, kr, Rr, Kn, Er)
    ).flat();
  }
  function lr(Zr, kr, Rr) {
    const { script: Er } = fn(Zr, kr, Rr);
    return (0, Q.isP2TR)(Er) ? Er.subarray(2, 34) : null;
  }
  function br(Zr) {
    return Zr.length === 64 ? Zr : Zr.subarray(0, 64);
  }
  function Br(Zr, kr, Rr, Er, Or, wn, Kn) {
    const Ln = Or.__TX, Wn = kr.sighashType || C.Transaction.SIGHASH_DEFAULT;
    Fr(Wn, Kn);
    const Sn = Rr.map(
      (Li, ms) => fn(ms, Li, Or)
    ), hi = Sn.map((Li) => Li.script), ki = Sn.map((Li) => Li.value), xi = [];
    if (kr.tapInternalKey && !wn) {
      const Li = lr(Zr, kr, Or) || Buffer.from([]);
      if ((0, B.toXOnly)(Er).equals(Li)) {
        const ms = Ln.hashForWitnessV1(
          Zr,
          hi,
          ki,
          Wn
        );
        xi.push({ pubkey: Er, hash: ms });
      }
    }
    const _i = (kr.tapLeafScript || []).filter((Li) => (0, Q.pubkeyInScript)(Er, Li.script)).map((Li) => {
      const ms = (0, b.tapleafHash)({
        output: Li.script,
        version: Li.leafVersion
      });
      return Object.assign({ hash: ms }, Li);
    }).filter(
      (Li) => !wn || wn.equals(Li.hash)
    ).map((Li) => {
      const ms = Ln.hashForWitnessV1(
        Zr,
        hi,
        ki,
        Wn,
        Li.hash
      );
      return {
        pubkey: Er,
        hash: ms,
        leafHash: Li.hash
      };
    });
    return xi.concat(_i);
  }
  function Fr(Zr, kr) {
    if (kr && kr.indexOf(Zr) < 0) {
      const Rr = wr(Zr);
      throw new Error(
        `Sighash type is not allowed. Retry the sign method passing the sighashTypes array of whitelisted types. Sighash type: ${Rr}`
      );
    }
  }
  function Gr(Zr, kr, Rr) {
    let Er;
    switch (kr) {
      case "multisig":
        const Or = un(Zr, Rr);
        Er = m.p2ms({
          output: Zr,
          signatures: Or
        });
        break;
      case "pubkey":
        Er = m.p2pk({
          output: Zr,
          signature: Rr[0].signature
        });
        break;
      case "pubkeyhash":
        Er = m.p2pkh({
          output: Zr,
          pubkey: Rr[0].pubkey,
          signature: Rr[0].signature
        });
        break;
      case "witnesspubkeyhash":
        Er = m.p2wpkh({
          output: Zr,
          pubkey: Rr[0].pubkey,
          signature: Rr[0].signature
        });
        break;
    }
    return Er;
  }
  function qr(Zr, kr, Rr) {
    const Er = Rr.__TX, Or = {
      script: null,
      isSegwit: !1,
      isP2SH: !1,
      isP2WSH: !1
    };
    if (Or.isP2SH = !!kr.redeemScript, Or.isP2WSH = !!kr.witnessScript, kr.witnessScript)
      Or.script = kr.witnessScript;
    else if (kr.redeemScript)
      Or.script = kr.redeemScript;
    else if (kr.nonWitnessUtxo) {
      const wn = _r(
        Rr,
        kr,
        Zr
      ), Kn = Er.ins[Zr].index;
      Or.script = wn.outs[Kn].script;
    } else kr.witnessUtxo && (Or.script = kr.witnessUtxo.script);
    return (kr.witnessScript || (0, Q.isP2WPKH)(Or.script)) && (Or.isSegwit = !0), Or;
  }
  function Hr(Zr, kr, Rr) {
    const Er = (0, u.checkForInput)(kr, Zr);
    if (!Er.bip32Derivation || Er.bip32Derivation.length === 0)
      throw new Error("Need bip32Derivation to sign with HD");
    const Or = Er.bip32Derivation.map((Kn) => {
      if (Kn.masterFingerprint.equals(Rr.fingerprint))
        return Kn;
    }).filter((Kn) => !!Kn);
    if (Or.length === 0)
      throw new Error(
        "Need one bip32Derivation masterFingerprint to match the HDSigner fingerprint"
      );
    return Or.map((Kn) => {
      const Ln = Rr.derivePath(Kn.path);
      if (!Kn.pubkey.equals(Ln.publicKey))
        throw new Error("pubkey did not match bip32Derivation");
      return Ln;
    });
  }
  function un(Zr, kr) {
    return m.p2ms({ output: Zr }).pubkeys.map((Er) => (kr.filter((Or) => Or.pubkey.equals(Er))[0] || {}).signature).filter((Er) => !!Er);
  }
  function Dr(Zr) {
    let kr = 0;
    function Rr(Kn) {
      return kr += Kn, Zr.slice(kr - Kn, kr);
    }
    function Er() {
      const Kn = A.decode(Zr, kr);
      return kr += A.decode.bytes, Kn;
    }
    function Or() {
      return Rr(Er());
    }
    function wn() {
      const Kn = Er(), Ln = [];
      for (let Wn = 0; Wn < Kn; Wn++) Ln.push(Or());
      return Ln;
    }
    return wn();
  }
  function wr(Zr) {
    let kr = Zr & C.Transaction.SIGHASH_ANYONECANPAY ? "SIGHASH_ANYONECANPAY | " : "";
    switch (Zr & 31) {
      case C.Transaction.SIGHASH_ALL:
        kr += "SIGHASH_ALL";
        break;
      case C.Transaction.SIGHASH_SINGLE:
        kr += "SIGHASH_SINGLE";
        break;
      case C.Transaction.SIGHASH_NONE:
        kr += "SIGHASH_NONE";
        break;
    }
    return kr;
  }
  function yr(Zr, kr, Rr) {
    Zr.__NON_WITNESS_UTXO_BUF_CACHE[Rr] = kr.nonWitnessUtxo;
    const Er = C.Transaction.fromBuffer(kr.nonWitnessUtxo);
    Zr.__NON_WITNESS_UTXO_TX_CACHE[Rr] = Er;
    const Or = Zr, wn = Rr;
    delete kr.nonWitnessUtxo, Object.defineProperty(kr, "nonWitnessUtxo", {
      enumerable: !0,
      get() {
        const Kn = Or.__NON_WITNESS_UTXO_BUF_CACHE[wn], Ln = Or.__NON_WITNESS_UTXO_TX_CACHE[wn];
        if (Kn !== void 0)
          return Kn;
        {
          const Wn = Ln.toBuffer();
          return Or.__NON_WITNESS_UTXO_BUF_CACHE[wn] = Wn, Wn;
        }
      },
      set(Kn) {
        Or.__NON_WITNESS_UTXO_BUF_CACHE[wn] = Kn;
      }
    });
  }
  function Qr(Zr, kr, Rr, Er) {
    let Or = 0;
    Zr.forEach((Wn, Sn) => {
      if (Er && Wn.finalScriptSig && (kr.ins[Sn].script = Wn.finalScriptSig), Er && Wn.finalScriptWitness && (kr.ins[Sn].witness = Dr(
        Wn.finalScriptWitness
      )), Wn.witnessUtxo)
        Or += Wn.witnessUtxo.value;
      else if (Wn.nonWitnessUtxo) {
        const hi = _r(Rr, Wn, Sn), ki = kr.ins[Sn].index, xi = hi.outs[ki];
        Or += xi.value;
      }
    });
    const wn = kr.outs.reduce((Wn, Sn) => Wn + Sn.value, 0), Kn = Or - wn;
    if (Kn < 0)
      throw new Error("Outputs are spending more than Inputs");
    const Ln = kr.virtualSize();
    Rr.__FEE = Kn, Rr.__EXTRACTED_TX = kr, Rr.__FEE_RATE = Math.floor(Kn / Ln);
  }
  function _r(Zr, kr, Rr) {
    const Er = Zr.__NON_WITNESS_UTXO_TX_CACHE;
    return Er[Rr] || yr(Zr, kr, Rr), Er[Rr];
  }
  function Jr(Zr, kr, Rr) {
    const { script: Er } = fn(Zr, kr, Rr);
    return Er;
  }
  function fn(Zr, kr, Rr) {
    if (kr.witnessUtxo !== void 0)
      return {
        script: kr.witnessUtxo.script,
        value: kr.witnessUtxo.value
      };
    if (kr.nonWitnessUtxo !== void 0) {
      const Or = _r(
        Rr,
        kr,
        Zr
      ).outs[Rr.__TX.ins[Zr].index];
      return { script: Or.script, value: Or.value };
    } else
      throw new Error("Can't find pubkey in input without Utxo data");
  }
  function jr(Zr, kr, Rr, Er) {
    const Or = Jr(Rr, kr, Er), { meaningfulScript: wn } = Xr(
      Or,
      Rr,
      "input",
      kr.redeemScript,
      kr.witnessScript
    );
    return (0, Q.pubkeyInScript)(Zr, wn);
  }
  function dn(Zr, kr, Rr, Er) {
    const Or = Er.__TX.outs[Rr].script, { meaningfulScript: wn } = Xr(
      Or,
      Rr,
      "output",
      kr.redeemScript,
      kr.witnessScript
    );
    return (0, Q.pubkeyInScript)(Zr, wn);
  }
  function Tn(Zr) {
    if (!Zr) return;
    const kr = k.decompile(Zr);
    if (!kr) return;
    const Rr = kr[kr.length - 1];
    if (!(!Buffer.isBuffer(Rr) || vn(Rr) || Cn(Rr) || !k.decompile(Rr)))
      return Rr;
  }
  function Yn(Zr) {
    if (!Zr) return;
    const kr = Dr(Zr), Rr = kr[kr.length - 1];
    if (!(vn(Rr) || !k.decompile(Rr)))
      return Rr;
  }
  function si(Zr) {
    if (Zr.length === 65) {
      const kr = Zr[64] & 1, Rr = Zr.slice(0, 33);
      return Rr[0] = 2 | kr, Rr;
    }
    return Zr.slice();
  }
  function vn(Zr) {
    return Zr.length === 33 && k.isCanonicalPubKey(Zr);
  }
  function Cn(Zr) {
    return k.isCanonicalScriptSignature(Zr);
  }
  function Xr(Zr, kr, Rr, Er, Or) {
    const wn = (0, Q.isP2SHScript)(Zr), Kn = wn && Er && (0, Q.isP2WSHScript)(Er), Ln = (0, Q.isP2WSHScript)(Zr);
    if (wn && Er === void 0)
      throw new Error("scriptPubkey is P2SH but redeemScript missing");
    if ((Ln || Kn) && Or === void 0)
      throw new Error(
        "scriptPubkey or redeemScript is P2WSH but witnessScript missing"
      );
    let Wn;
    return Kn ? (Wn = Or, Se(kr, Zr, Er, Rr), Ne(kr, Er, Or, Rr), In(Wn)) : Ln ? (Wn = Or, Ne(kr, Zr, Or, Rr), In(Wn)) : wn ? (Wn = Er, Se(kr, Zr, Er, Rr)) : Wn = Zr, {
      meaningfulScript: Wn,
      type: Kn ? "p2sh-p2wsh" : wn ? "p2sh" : Ln ? "p2wsh" : "raw"
    };
  }
  function In(Zr) {
    if ((0, Q.isP2WPKH)(Zr) || (0, Q.isP2SHScript)(Zr))
      throw new Error("P2WPKH or P2SH can not be contained within P2WSH");
  }
  function zr(Zr) {
    return (0, Q.isP2WPKH)(Zr) ? "witnesspubkeyhash" : (0, Q.isP2PKH)(Zr) ? "pubkeyhash" : (0, Q.isP2MS)(Zr) ? "multisig" : (0, Q.isP2PK)(Zr) ? "pubkey" : "nonstandard";
  }
  function En(Zr) {
    return [...Array(Zr).keys()];
  }
  return psbt$4;
}
var hasRequiredSrc$3;
function requireSrc$3() {
  return hasRequiredSrc$3 || (hasRequiredSrc$3 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.initEccLib = s.Transaction = s.opcodes = s.Psbt = s.Block = s.script = s.payments = s.networks = s.crypto = s.address = void 0;
    const A = requireAddress$1();
    s.address = A;
    const u = requireCrypto$3();
    s.crypto = u;
    const p = requireNetworks$1();
    s.networks = p;
    const t = requirePayments();
    s.payments = t;
    const l = requireScript$1();
    s.script = l;
    var m = requireBlock();
    Object.defineProperty(s, "Block", {
      enumerable: !0,
      get: function() {
        return m.Block;
      }
    });
    var b = requirePsbt$3();
    Object.defineProperty(s, "Psbt", {
      enumerable: !0,
      get: function() {
        return b.Psbt;
      }
    });
    var k = requireOps();
    Object.defineProperty(s, "opcodes", {
      enumerable: !0,
      get: function() {
        return k.OPS;
      }
    });
    var C = requireTransaction$1();
    Object.defineProperty(s, "Transaction", {
      enumerable: !0,
      get: function() {
        return C.Transaction;
      }
    });
    var B = requireEcc_lib();
    Object.defineProperty(s, "initEccLib", {
      enumerable: !0,
      get: function() {
        return B.initEccLib;
      }
    });
  }(src$4)), src$4;
}
var srcExports = requireSrc$3(), dist$l = {}, secp256k1$7 = {}, _shortw_utils$1 = {}, weierstrass$3 = {}, hmac$5 = {}, hasRequiredHmac$3;
function requireHmac$3() {
  return hasRequiredHmac$3 || (hasRequiredHmac$3 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.hmac = s.HMAC = void 0;
    const A = /* @__PURE__ */ requireUtils$j();
    class u extends A.Hash {
      constructor(l, m) {
        super(), this.finished = !1, this.destroyed = !1, (0, A.ahash)(l);
        const b = (0, A.toBytes)(m);
        if (this.iHash = l.create(), typeof this.iHash.update != "function")
          throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
        const k = this.blockLen, C = new Uint8Array(k);
        C.set(b.length > k ? l.create().update(b).digest() : b);
        for (let B = 0; B < C.length; B++)
          C[B] ^= 54;
        this.iHash.update(C), this.oHash = l.create();
        for (let B = 0; B < C.length; B++)
          C[B] ^= 106;
        this.oHash.update(C), (0, A.clean)(C);
      }
      update(l) {
        return (0, A.aexists)(this), this.iHash.update(l), this;
      }
      digestInto(l) {
        (0, A.aexists)(this), (0, A.abytes)(l, this.outputLen), this.finished = !0, this.iHash.digestInto(l), this.oHash.update(l), this.oHash.digestInto(l), this.destroy();
      }
      digest() {
        const l = new Uint8Array(this.oHash.outputLen);
        return this.digestInto(l), l;
      }
      _cloneInto(l) {
        l || (l = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: m, iHash: b, finished: k, destroyed: C, blockLen: B, outputLen: Q } = this;
        return l = l, l.finished = k, l.destroyed = C, l.blockLen = B, l.outputLen = Q, l.oHash = m._cloneInto(l.oHash), l.iHash = b._cloneInto(l.iHash), l;
      }
      clone() {
        return this._cloneInto();
      }
      destroy() {
        this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
      }
    }
    s.HMAC = u;
    const p = (t, l, m) => new u(t, l).update(m).digest();
    s.hmac = p, s.hmac.create = (t, l) => new u(t, l);
  }(hmac$5)), hmac$5;
}
var utils$j = {}, hasRequiredUtils$h;
function requireUtils$h() {
  return hasRequiredUtils$h || (hasRequiredUtils$h = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.notImplemented = s.bitMask = s.utf8ToBytes = s.randomBytes = s.isBytes = s.hexToBytes = s.concatBytes = s.bytesToUtf8 = s.bytesToHex = s.anumber = s.abytes = void 0, s.abool = l, s._abool2 = m, s._abytes2 = b, s.numberToHexUnpadded = k, s.hexToNumber = C, s.bytesToNumberBE = B, s.bytesToNumberLE = Q, s.numberToBytesBE = P, s.numberToBytesLE = x, s.numberToVarBytesBE = M, s.ensureBytes = F, s.equalBytes = le, s.copyBytes = ge, s.asciiToBytes = pe, s.inRange = be, s.aInRange = Pe, s.bitLen = Te, s.bitGet = Qe, s.bitSet = xe, s.createHmacDrbg = He, s.validateObject = we, s.isHash = Ce, s._validateObject = Se, s.memoized = rr;
    const A = /* @__PURE__ */ requireUtils$j();
    var u = /* @__PURE__ */ requireUtils$j();
    Object.defineProperty(s, "abytes", { enumerable: !0, get: function() {
      return u.abytes;
    } }), Object.defineProperty(s, "anumber", { enumerable: !0, get: function() {
      return u.anumber;
    } }), Object.defineProperty(s, "bytesToHex", { enumerable: !0, get: function() {
      return u.bytesToHex;
    } }), Object.defineProperty(s, "bytesToUtf8", { enumerable: !0, get: function() {
      return u.bytesToUtf8;
    } }), Object.defineProperty(s, "concatBytes", { enumerable: !0, get: function() {
      return u.concatBytes;
    } }), Object.defineProperty(s, "hexToBytes", { enumerable: !0, get: function() {
      return u.hexToBytes;
    } }), Object.defineProperty(s, "isBytes", { enumerable: !0, get: function() {
      return u.isBytes;
    } }), Object.defineProperty(s, "randomBytes", { enumerable: !0, get: function() {
      return u.randomBytes;
    } }), Object.defineProperty(s, "utf8ToBytes", { enumerable: !0, get: function() {
      return u.utf8ToBytes;
    } });
    const p = /* @__PURE__ */ BigInt(0), t = /* @__PURE__ */ BigInt(1);
    function l(er, ir) {
      if (typeof ir != "boolean")
        throw new Error(er + " boolean expected, got " + ir);
    }
    function m(er, ir = "") {
      if (typeof er != "boolean") {
        const sr = ir && `"${ir}"`;
        throw new Error(sr + "expected boolean, got type=" + typeof er);
      }
      return er;
    }
    function b(er, ir, sr = "") {
      const nr = (0, A.isBytes)(er), fr = er == null ? void 0 : er.length, lr = ir !== void 0;
      if (!nr || lr && fr !== ir) {
        const br = sr && `"${sr}" `, Br = lr ? ` of length ${ir}` : "", Fr = nr ? `length=${fr}` : `type=${typeof er}`;
        throw new Error(br + "expected Uint8Array" + Br + ", got " + Fr);
      }
      return er;
    }
    function k(er) {
      const ir = er.toString(16);
      return ir.length & 1 ? "0" + ir : ir;
    }
    function C(er) {
      if (typeof er != "string")
        throw new Error("hex string expected, got " + typeof er);
      return er === "" ? p : BigInt("0x" + er);
    }
    function B(er) {
      return C((0, A.bytesToHex)(er));
    }
    function Q(er) {
      return (0, A.abytes)(er), C((0, A.bytesToHex)(Uint8Array.from(er).reverse()));
    }
    function P(er, ir) {
      return (0, A.hexToBytes)(er.toString(16).padStart(ir * 2, "0"));
    }
    function x(er, ir) {
      return P(er, ir).reverse();
    }
    function M(er) {
      return (0, A.hexToBytes)(k(er));
    }
    function F(er, ir, sr) {
      let nr;
      if (typeof ir == "string")
        try {
          nr = (0, A.hexToBytes)(ir);
        } catch (lr) {
          throw new Error(er + " must be hex string or Uint8Array, cause: " + lr);
        }
      else if ((0, A.isBytes)(ir))
        nr = Uint8Array.from(ir);
      else
        throw new Error(er + " must be hex string or Uint8Array");
      const fr = nr.length;
      if (typeof sr == "number" && fr !== sr)
        throw new Error(er + " of length " + sr + " expected, got " + fr);
      return nr;
    }
    function le(er, ir) {
      if (er.length !== ir.length)
        return !1;
      let sr = 0;
      for (let nr = 0; nr < er.length; nr++)
        sr |= er[nr] ^ ir[nr];
      return sr === 0;
    }
    function ge(er) {
      return Uint8Array.from(er);
    }
    function pe(er) {
      return Uint8Array.from(er, (ir, sr) => {
        const nr = ir.charCodeAt(0);
        if (ir.length !== 1 || nr > 127)
          throw new Error(`string contains non-ASCII character "${er[sr]}" with code ${nr} at position ${sr}`);
        return nr;
      });
    }
    const Ie = (er) => typeof er == "bigint" && p <= er;
    function be(er, ir, sr) {
      return Ie(er) && Ie(ir) && Ie(sr) && ir <= er && er < sr;
    }
    function Pe(er, ir, sr, nr) {
      if (!be(ir, sr, nr))
        throw new Error("expected valid " + er + ": " + sr + " <= n < " + nr + ", got " + ir);
    }
    function Te(er) {
      let ir;
      for (ir = 0; er > p; er >>= t, ir += 1)
        ;
      return ir;
    }
    function Qe(er, ir) {
      return er >> BigInt(ir) & t;
    }
    function xe(er, ir, sr) {
      return er | (sr ? t : p) << BigInt(ir);
    }
    const Ee = (er) => (t << BigInt(er)) - t;
    s.bitMask = Ee;
    function He(er, ir, sr) {
      if (typeof er != "number" || er < 2)
        throw new Error("hashLen must be a number");
      if (typeof ir != "number" || ir < 2)
        throw new Error("qByteLen must be a number");
      if (typeof sr != "function")
        throw new Error("hmacFn must be a function");
      const nr = (Dr) => new Uint8Array(Dr), fr = (Dr) => Uint8Array.of(Dr);
      let lr = nr(er), br = nr(er), Br = 0;
      const Fr = () => {
        lr.fill(1), br.fill(0), Br = 0;
      }, Gr = (...Dr) => sr(br, lr, ...Dr), qr = (Dr = nr(0)) => {
        br = Gr(fr(0), Dr), lr = Gr(), Dr.length !== 0 && (br = Gr(fr(1), Dr), lr = Gr());
      }, Hr = () => {
        if (Br++ >= 1e3)
          throw new Error("drbg: tried 1000 values");
        let Dr = 0;
        const wr = [];
        for (; Dr < ir; ) {
          lr = Gr();
          const yr = lr.slice();
          wr.push(yr), Dr += lr.length;
        }
        return (0, A.concatBytes)(...wr);
      };
      return (Dr, wr) => {
        Fr(), qr(Dr);
        let yr;
        for (; !(yr = wr(Hr())); )
          qr();
        return Fr(), yr;
      };
    }
    const ve = {
      bigint: (er) => typeof er == "bigint",
      function: (er) => typeof er == "function",
      boolean: (er) => typeof er == "boolean",
      string: (er) => typeof er == "string",
      stringOrUint8Array: (er) => typeof er == "string" || (0, A.isBytes)(er),
      isSafeInteger: (er) => Number.isSafeInteger(er),
      array: (er) => Array.isArray(er),
      field: (er, ir) => ir.Fp.isValid(er),
      hash: (er) => typeof er == "function" && Number.isSafeInteger(er.outputLen)
    };
    function we(er, ir, sr = {}) {
      const nr = (fr, lr, br) => {
        const Br = ve[lr];
        if (typeof Br != "function")
          throw new Error("invalid validator function");
        const Fr = er[fr];
        if (!(br && Fr === void 0) && !Br(Fr, er))
          throw new Error("param " + String(fr) + " is invalid. Expected " + lr + ", got " + Fr);
      };
      for (const [fr, lr] of Object.entries(ir))
        nr(fr, lr, !1);
      for (const [fr, lr] of Object.entries(sr))
        nr(fr, lr, !0);
      return er;
    }
    function Ce(er) {
      return typeof er == "function" && Number.isSafeInteger(er.outputLen);
    }
    function Se(er, ir, sr = {}) {
      if (!er || typeof er != "object")
        throw new Error("expected valid options object");
      function nr(fr, lr, br) {
        const Br = er[fr];
        if (br && Br === void 0)
          return;
        const Fr = typeof Br;
        if (Fr !== lr || Br === null)
          throw new Error(`param "${fr}" is invalid: expected ${lr}, got ${Fr}`);
      }
      Object.entries(ir).forEach(([fr, lr]) => nr(fr, lr, !1)), Object.entries(sr).forEach(([fr, lr]) => nr(fr, lr, !0));
    }
    const Ne = () => {
      throw new Error("not implemented");
    };
    s.notImplemented = Ne;
    function rr(er) {
      const ir = /* @__PURE__ */ new WeakMap();
      return (sr, ...nr) => {
        const fr = ir.get(sr);
        if (fr !== void 0)
          return fr;
        const lr = er(sr, ...nr);
        return ir.set(sr, lr), lr;
      };
    }
  }(utils$j)), utils$j;
}
var curve$2 = {}, modular$1 = {}, hasRequiredModular$1;
function requireModular$1() {
  if (hasRequiredModular$1) return modular$1;
  hasRequiredModular$1 = 1, Object.defineProperty(modular$1, "__esModule", { value: !0 }), modular$1.isNegativeLE = void 0, modular$1.mod = Q, modular$1.pow = P, modular$1.pow2 = x, modular$1.invert = M, modular$1.tonelliShanks = Ie, modular$1.FpSqrt = be, modular$1.validateField = Qe, modular$1.FpPow = xe, modular$1.FpInvertBatch = Ee, modular$1.FpDiv = He, modular$1.FpLegendre = ve, modular$1.FpIsSquare = we, modular$1.nLength = Ce, modular$1.Field = Se, modular$1.FpSqrtOdd = Ne, modular$1.FpSqrtEven = rr, modular$1.hashToPrivateScalar = er, modular$1.getFieldBytesLength = ir, modular$1.getMinHashLength = sr, modular$1.mapHashToField = nr;
  const s = /* @__PURE__ */ requireUtils$h(), A = BigInt(0), u = BigInt(1), p = /* @__PURE__ */ BigInt(2), t = /* @__PURE__ */ BigInt(3), l = /* @__PURE__ */ BigInt(4), m = /* @__PURE__ */ BigInt(5), b = /* @__PURE__ */ BigInt(7), k = /* @__PURE__ */ BigInt(8), C = /* @__PURE__ */ BigInt(9), B = /* @__PURE__ */ BigInt(16);
  function Q(fr, lr) {
    const br = fr % lr;
    return br >= A ? br : lr + br;
  }
  function P(fr, lr, br) {
    return xe(Se(br), fr, lr);
  }
  function x(fr, lr, br) {
    let Br = fr;
    for (; lr-- > A; )
      Br *= Br, Br %= br;
    return Br;
  }
  function M(fr, lr) {
    if (fr === A)
      throw new Error("invert: expected non-zero number");
    if (lr <= A)
      throw new Error("invert: expected positive modulus, got " + lr);
    let br = Q(fr, lr), Br = lr, Fr = A, Gr = u;
    for (; br !== A; ) {
      const Hr = Br / br, un = Br % br, Dr = Fr - Gr * Hr;
      Br = br, br = un, Fr = Gr, Gr = Dr;
    }
    if (Br !== u)
      throw new Error("invert: does not exist");
    return Q(Fr, lr);
  }
  function F(fr, lr, br) {
    if (!fr.eql(fr.sqr(lr), br))
      throw new Error("Cannot find square root");
  }
  function le(fr, lr) {
    const br = (fr.ORDER + u) / l, Br = fr.pow(lr, br);
    return F(fr, Br, lr), Br;
  }
  function ge(fr, lr) {
    const br = (fr.ORDER - m) / k, Br = fr.mul(lr, p), Fr = fr.pow(Br, br), Gr = fr.mul(lr, Fr), qr = fr.mul(fr.mul(Gr, p), Fr), Hr = fr.mul(Gr, fr.sub(qr, fr.ONE));
    return F(fr, Hr, lr), Hr;
  }
  function pe(fr) {
    const lr = Se(fr), br = Ie(fr), Br = br(lr, lr.neg(lr.ONE)), Fr = br(lr, Br), Gr = br(lr, lr.neg(Br)), qr = (fr + b) / B;
    return (Hr, un) => {
      let Dr = Hr.pow(un, qr), wr = Hr.mul(Dr, Br);
      const yr = Hr.mul(Dr, Fr), Qr = Hr.mul(Dr, Gr), _r = Hr.eql(Hr.sqr(wr), un), Jr = Hr.eql(Hr.sqr(yr), un);
      Dr = Hr.cmov(Dr, wr, _r), wr = Hr.cmov(Qr, yr, Jr);
      const fn = Hr.eql(Hr.sqr(wr), un), jr = Hr.cmov(Dr, wr, fn);
      return F(Hr, jr, un), jr;
    };
  }
  function Ie(fr) {
    if (fr < t)
      throw new Error("sqrt is not defined for small field");
    let lr = fr - u, br = 0;
    for (; lr % p === A; )
      lr /= p, br++;
    let Br = p;
    const Fr = Se(fr);
    for (; ve(Fr, Br) === 1; )
      if (Br++ > 1e3)
        throw new Error("Cannot find square root: probably non-prime P");
    if (br === 1)
      return le;
    let Gr = Fr.pow(Br, lr);
    const qr = (lr + u) / p;
    return function(un, Dr) {
      if (un.is0(Dr))
        return Dr;
      if (ve(un, Dr) !== 1)
        throw new Error("Cannot find square root");
      let wr = br, yr = un.mul(un.ONE, Gr), Qr = un.pow(Dr, lr), _r = un.pow(Dr, qr);
      for (; !un.eql(Qr, un.ONE); ) {
        if (un.is0(Qr))
          return un.ZERO;
        let Jr = 1, fn = un.sqr(Qr);
        for (; !un.eql(fn, un.ONE); )
          if (Jr++, fn = un.sqr(fn), Jr === wr)
            throw new Error("Cannot find square root");
        const jr = u << BigInt(wr - Jr - 1), dn = un.pow(yr, jr);
        wr = Jr, yr = un.sqr(dn), Qr = un.mul(Qr, yr), _r = un.mul(_r, dn);
      }
      return _r;
    };
  }
  function be(fr) {
    return fr % l === t ? le : fr % k === m ? ge : fr % B === C ? pe(fr) : Ie(fr);
  }
  const Pe = (fr, lr) => (Q(fr, lr) & u) === u;
  modular$1.isNegativeLE = Pe;
  const Te = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
  ];
  function Qe(fr) {
    const lr = {
      ORDER: "bigint",
      MASK: "bigint",
      BYTES: "number",
      BITS: "number"
    }, br = Te.reduce((Br, Fr) => (Br[Fr] = "function", Br), lr);
    return (0, s._validateObject)(fr, br), fr;
  }
  function xe(fr, lr, br) {
    if (br < A)
      throw new Error("invalid exponent, negatives unsupported");
    if (br === A)
      return fr.ONE;
    if (br === u)
      return lr;
    let Br = fr.ONE, Fr = lr;
    for (; br > A; )
      br & u && (Br = fr.mul(Br, Fr)), Fr = fr.sqr(Fr), br >>= u;
    return Br;
  }
  function Ee(fr, lr, br = !1) {
    const Br = new Array(lr.length).fill(br ? fr.ZERO : void 0), Fr = lr.reduce((qr, Hr, un) => fr.is0(Hr) ? qr : (Br[un] = qr, fr.mul(qr, Hr)), fr.ONE), Gr = fr.inv(Fr);
    return lr.reduceRight((qr, Hr, un) => fr.is0(Hr) ? qr : (Br[un] = fr.mul(qr, Br[un]), fr.mul(qr, Hr)), Gr), Br;
  }
  function He(fr, lr, br) {
    return fr.mul(lr, typeof br == "bigint" ? M(br, fr.ORDER) : fr.inv(br));
  }
  function ve(fr, lr) {
    const br = (fr.ORDER - u) / p, Br = fr.pow(lr, br), Fr = fr.eql(Br, fr.ONE), Gr = fr.eql(Br, fr.ZERO), qr = fr.eql(Br, fr.neg(fr.ONE));
    if (!Fr && !Gr && !qr)
      throw new Error("invalid Legendre symbol result");
    return Fr ? 1 : Gr ? 0 : -1;
  }
  function we(fr, lr) {
    return ve(fr, lr) === 1;
  }
  function Ce(fr, lr) {
    lr !== void 0 && (0, s.anumber)(lr);
    const br = lr !== void 0 ? lr : fr.toString(2).length, Br = Math.ceil(br / 8);
    return { nBitLength: br, nByteLength: Br };
  }
  function Se(fr, lr, br = !1, Br = {}) {
    if (fr <= A)
      throw new Error("invalid field: expected ORDER > 0, got " + fr);
    let Fr, Gr, qr = !1, Hr;
    if (typeof lr == "object" && lr != null) {
      if (Br.sqrt || br)
        throw new Error("cannot specify opts in two arguments");
      const Qr = lr;
      Qr.BITS && (Fr = Qr.BITS), Qr.sqrt && (Gr = Qr.sqrt), typeof Qr.isLE == "boolean" && (br = Qr.isLE), typeof Qr.modFromBytes == "boolean" && (qr = Qr.modFromBytes), Hr = Qr.allowedLengths;
    } else
      typeof lr == "number" && (Fr = lr), Br.sqrt && (Gr = Br.sqrt);
    const { nBitLength: un, nByteLength: Dr } = Ce(fr, Fr);
    if (Dr > 2048)
      throw new Error("invalid field: expected ORDER of <= 2048 bytes");
    let wr;
    const yr = Object.freeze({
      ORDER: fr,
      isLE: br,
      BITS: un,
      BYTES: Dr,
      MASK: (0, s.bitMask)(un),
      ZERO: A,
      ONE: u,
      allowedLengths: Hr,
      create: (Qr) => Q(Qr, fr),
      isValid: (Qr) => {
        if (typeof Qr != "bigint")
          throw new Error("invalid field element: expected bigint, got " + typeof Qr);
        return A <= Qr && Qr < fr;
      },
      is0: (Qr) => Qr === A,
      // is valid and invertible
      isValidNot0: (Qr) => !yr.is0(Qr) && yr.isValid(Qr),
      isOdd: (Qr) => (Qr & u) === u,
      neg: (Qr) => Q(-Qr, fr),
      eql: (Qr, _r) => Qr === _r,
      sqr: (Qr) => Q(Qr * Qr, fr),
      add: (Qr, _r) => Q(Qr + _r, fr),
      sub: (Qr, _r) => Q(Qr - _r, fr),
      mul: (Qr, _r) => Q(Qr * _r, fr),
      pow: (Qr, _r) => xe(yr, Qr, _r),
      div: (Qr, _r) => Q(Qr * M(_r, fr), fr),
      // Same as above, but doesn't normalize
      sqrN: (Qr) => Qr * Qr,
      addN: (Qr, _r) => Qr + _r,
      subN: (Qr, _r) => Qr - _r,
      mulN: (Qr, _r) => Qr * _r,
      inv: (Qr) => M(Qr, fr),
      sqrt: Gr || ((Qr) => (wr || (wr = be(fr)), wr(yr, Qr))),
      toBytes: (Qr) => br ? (0, s.numberToBytesLE)(Qr, Dr) : (0, s.numberToBytesBE)(Qr, Dr),
      fromBytes: (Qr, _r = !0) => {
        if (Hr) {
          if (!Hr.includes(Qr.length) || Qr.length > Dr)
            throw new Error("Field.fromBytes: expected " + Hr + " bytes, got " + Qr.length);
          const fn = new Uint8Array(Dr);
          fn.set(Qr, br ? 0 : fn.length - Qr.length), Qr = fn;
        }
        if (Qr.length !== Dr)
          throw new Error("Field.fromBytes: expected " + Dr + " bytes, got " + Qr.length);
        let Jr = br ? (0, s.bytesToNumberLE)(Qr) : (0, s.bytesToNumberBE)(Qr);
        if (qr && (Jr = Q(Jr, fr)), !_r && !yr.isValid(Jr))
          throw new Error("invalid field element: outside of range 0..ORDER");
        return Jr;
      },
      // TODO: we don't need it here, move out to separate fn
      invertBatch: (Qr) => Ee(yr, Qr),
      // We can't move this out because Fp6, Fp12 implement it
      // and it's unclear what to return in there.
      cmov: (Qr, _r, Jr) => Jr ? _r : Qr
    });
    return Object.freeze(yr);
  }
  function Ne(fr, lr) {
    if (!fr.isOdd)
      throw new Error("Field doesn't have isOdd");
    const br = fr.sqrt(lr);
    return fr.isOdd(br) ? br : fr.neg(br);
  }
  function rr(fr, lr) {
    if (!fr.isOdd)
      throw new Error("Field doesn't have isOdd");
    const br = fr.sqrt(lr);
    return fr.isOdd(br) ? fr.neg(br) : br;
  }
  function er(fr, lr, br = !1) {
    fr = (0, s.ensureBytes)("privateHash", fr);
    const Br = fr.length, Fr = Ce(lr).nByteLength + 8;
    if (Fr < 24 || Br < Fr || Br > 1024)
      throw new Error("hashToPrivateScalar: expected " + Fr + "-1024 bytes of input, got " + Br);
    const Gr = br ? (0, s.bytesToNumberLE)(fr) : (0, s.bytesToNumberBE)(fr);
    return Q(Gr, lr - u) + u;
  }
  function ir(fr) {
    if (typeof fr != "bigint")
      throw new Error("field order must be bigint");
    const lr = fr.toString(2).length;
    return Math.ceil(lr / 8);
  }
  function sr(fr) {
    const lr = ir(fr);
    return lr + Math.ceil(lr / 2);
  }
  function nr(fr, lr, br = !1) {
    const Br = fr.length, Fr = ir(lr), Gr = sr(lr);
    if (Br < 16 || Br < Gr || Br > 1024)
      throw new Error("expected " + Gr + "-1024 bytes of input, got " + Br);
    const qr = br ? (0, s.bytesToNumberLE)(fr) : (0, s.bytesToNumberBE)(fr), Hr = Q(qr, lr - u) + u;
    return br ? (0, s.numberToBytesLE)(Hr, Fr) : (0, s.numberToBytesBE)(Hr, Fr);
  }
  return modular$1;
}
var hasRequiredCurve$2;
function requireCurve$2() {
  if (hasRequiredCurve$2) return curve$2;
  hasRequiredCurve$2 = 1, Object.defineProperty(curve$2, "__esModule", { value: !0 }), curve$2.wNAF = void 0, curve$2.negateCt = t, curve$2.normalizeZ = l, curve$2.mulEndoUnsafe = le, curve$2.pippenger = ge, curve$2.precomputeMSMUnsafe = pe, curve$2.validateBasic = Ie, curve$2._createCurveFields = Pe;
  const s = /* @__PURE__ */ requireUtils$h(), A = /* @__PURE__ */ requireModular$1(), u = BigInt(0), p = BigInt(1);
  function t(Te, Qe) {
    const xe = Qe.negate();
    return Te ? xe : Qe;
  }
  function l(Te, Qe) {
    const xe = (0, A.FpInvertBatch)(Te.Fp, Qe.map((Ee) => Ee.Z));
    return Qe.map((Ee, He) => Te.fromAffine(Ee.toAffine(xe[He])));
  }
  function m(Te, Qe) {
    if (!Number.isSafeInteger(Te) || Te <= 0 || Te > Qe)
      throw new Error("invalid window size, expected [1.." + Qe + "], got W=" + Te);
  }
  function b(Te, Qe) {
    m(Te, Qe);
    const xe = Math.ceil(Qe / Te) + 1, Ee = 2 ** (Te - 1), He = 2 ** Te, ve = (0, s.bitMask)(Te), we = BigInt(Te);
    return { windows: xe, windowSize: Ee, mask: ve, maxNumber: He, shiftBy: we };
  }
  function k(Te, Qe, xe) {
    const { windowSize: Ee, mask: He, maxNumber: ve, shiftBy: we } = xe;
    let Ce = Number(Te & He), Se = Te >> we;
    Ce > Ee && (Ce -= ve, Se += p);
    const Ne = Qe * Ee, rr = Ne + Math.abs(Ce) - 1, er = Ce === 0, ir = Ce < 0, sr = Qe % 2 !== 0;
    return { nextN: Se, offset: rr, isZero: er, isNeg: ir, isNegF: sr, offsetF: Ne };
  }
  function C(Te, Qe) {
    if (!Array.isArray(Te))
      throw new Error("array expected");
    Te.forEach((xe, Ee) => {
      if (!(xe instanceof Qe))
        throw new Error("invalid point at index " + Ee);
    });
  }
  function B(Te, Qe) {
    if (!Array.isArray(Te))
      throw new Error("array of scalars expected");
    Te.forEach((xe, Ee) => {
      if (!Qe.isValid(xe))
        throw new Error("invalid scalar at index " + Ee);
    });
  }
  const Q = /* @__PURE__ */ new WeakMap(), P = /* @__PURE__ */ new WeakMap();
  function x(Te) {
    return P.get(Te) || 1;
  }
  function M(Te) {
    if (Te !== u)
      throw new Error("invalid wNAF");
  }
  class F {
    // Parametrized with a given Point class (not individual point)
    constructor(Qe, xe) {
      this.BASE = Qe.BASE, this.ZERO = Qe.ZERO, this.Fn = Qe.Fn, this.bits = xe;
    }
    // non-const time multiplication ladder
    _unsafeLadder(Qe, xe, Ee = this.ZERO) {
      let He = Qe;
      for (; xe > u; )
        xe & p && (Ee = Ee.add(He)), He = He.double(), xe >>= p;
      return Ee;
    }
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @param point Point instance
     * @param W window size
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(Qe, xe) {
      const { windows: Ee, windowSize: He } = b(xe, this.bits), ve = [];
      let we = Qe, Ce = we;
      for (let Se = 0; Se < Ee; Se++) {
        Ce = we, ve.push(Ce);
        for (let Ne = 1; Ne < He; Ne++)
          Ce = Ce.add(we), ve.push(Ce);
        we = Ce.double();
      }
      return ve;
    }
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * More compact implementation:
     * https://github.com/paulmillr/noble-secp256k1/blob/47cb1669b6e506ad66b35fe7d76132ae97465da2/index.ts#L502-L541
     * @returns real and fake (for const-time) points
     */
    wNAF(Qe, xe, Ee) {
      if (!this.Fn.isValid(Ee))
        throw new Error("invalid scalar");
      let He = this.ZERO, ve = this.BASE;
      const we = b(Qe, this.bits);
      for (let Ce = 0; Ce < we.windows; Ce++) {
        const { nextN: Se, offset: Ne, isZero: rr, isNeg: er, isNegF: ir, offsetF: sr } = k(Ee, Ce, we);
        Ee = Se, rr ? ve = ve.add(t(ir, xe[sr])) : He = He.add(t(er, xe[Ne]));
      }
      return M(Ee), { p: He, f: ve };
    }
    /**
     * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
     * @param acc accumulator point to add result of multiplication
     * @returns point
     */
    wNAFUnsafe(Qe, xe, Ee, He = this.ZERO) {
      const ve = b(Qe, this.bits);
      for (let we = 0; we < ve.windows && Ee !== u; we++) {
        const { nextN: Ce, offset: Se, isZero: Ne, isNeg: rr } = k(Ee, we, ve);
        if (Ee = Ce, !Ne) {
          const er = xe[Se];
          He = He.add(rr ? er.negate() : er);
        }
      }
      return M(Ee), He;
    }
    getPrecomputes(Qe, xe, Ee) {
      let He = Q.get(xe);
      return He || (He = this.precomputeWindow(xe, Qe), Qe !== 1 && (typeof Ee == "function" && (He = Ee(He)), Q.set(xe, He))), He;
    }
    cached(Qe, xe, Ee) {
      const He = x(Qe);
      return this.wNAF(He, this.getPrecomputes(He, Qe, Ee), xe);
    }
    unsafe(Qe, xe, Ee, He) {
      const ve = x(Qe);
      return ve === 1 ? this._unsafeLadder(Qe, xe, He) : this.wNAFUnsafe(ve, this.getPrecomputes(ve, Qe, Ee), xe, He);
    }
    // We calculate precomputes for elliptic curve point multiplication
    // using windowed method. This specifies window size and
    // stores precomputed values. Usually only base point would be precomputed.
    createCache(Qe, xe) {
      m(xe, this.bits), P.set(Qe, xe), Q.delete(Qe);
    }
    hasCache(Qe) {
      return x(Qe) !== 1;
    }
  }
  curve$2.wNAF = F;
  function le(Te, Qe, xe, Ee) {
    let He = Qe, ve = Te.ZERO, we = Te.ZERO;
    for (; xe > u || Ee > u; )
      xe & p && (ve = ve.add(He)), Ee & p && (we = we.add(He)), He = He.double(), xe >>= p, Ee >>= p;
    return { p1: ve, p2: we };
  }
  function ge(Te, Qe, xe, Ee) {
    C(xe, Te), B(Ee, Qe);
    const He = xe.length, ve = Ee.length;
    if (He !== ve)
      throw new Error("arrays of points and scalars must have equal length");
    const we = Te.ZERO, Ce = (0, s.bitLen)(BigInt(He));
    let Se = 1;
    Ce > 12 ? Se = Ce - 3 : Ce > 4 ? Se = Ce - 2 : Ce > 0 && (Se = 2);
    const Ne = (0, s.bitMask)(Se), rr = new Array(Number(Ne) + 1).fill(we), er = Math.floor((Qe.BITS - 1) / Se) * Se;
    let ir = we;
    for (let sr = er; sr >= 0; sr -= Se) {
      rr.fill(we);
      for (let fr = 0; fr < ve; fr++) {
        const lr = Ee[fr], br = Number(lr >> BigInt(sr) & Ne);
        rr[br] = rr[br].add(xe[fr]);
      }
      let nr = we;
      for (let fr = rr.length - 1, lr = we; fr > 0; fr--)
        lr = lr.add(rr[fr]), nr = nr.add(lr);
      if (ir = ir.add(nr), sr !== 0)
        for (let fr = 0; fr < Se; fr++)
          ir = ir.double();
    }
    return ir;
  }
  function pe(Te, Qe, xe, Ee) {
    m(Ee, Qe.BITS), C(xe, Te);
    const He = Te.ZERO, ve = 2 ** Ee - 1, we = Math.ceil(Qe.BITS / Ee), Ce = (0, s.bitMask)(Ee), Se = xe.map((Ne) => {
      const rr = [];
      for (let er = 0, ir = Ne; er < ve; er++)
        rr.push(ir), ir = ir.add(Ne);
      return rr;
    });
    return (Ne) => {
      if (B(Ne, Qe), Ne.length > xe.length)
        throw new Error("array of scalars must be smaller than array of points");
      let rr = He;
      for (let er = 0; er < we; er++) {
        if (rr !== He)
          for (let sr = 0; sr < Ee; sr++)
            rr = rr.double();
        const ir = BigInt(we * Ee - (er + 1) * Ee);
        for (let sr = 0; sr < Ne.length; sr++) {
          const nr = Ne[sr], fr = Number(nr >> ir & Ce);
          fr && (rr = rr.add(Se[sr][fr - 1]));
        }
      }
      return rr;
    };
  }
  function Ie(Te) {
    return (0, A.validateField)(Te.Fp), (0, s.validateObject)(Te, {
      n: "bigint",
      h: "bigint",
      Gx: "field",
      Gy: "field"
    }, {
      nBitLength: "isSafeInteger",
      nByteLength: "isSafeInteger"
    }), Object.freeze({
      ...(0, A.nLength)(Te.n, Te.nBitLength),
      ...Te,
      p: Te.Fp.ORDER
    });
  }
  function be(Te, Qe, xe) {
    if (Qe) {
      if (Qe.ORDER !== Te)
        throw new Error("Field.ORDER must match order: Fp == p, Fn == n");
      return (0, A.validateField)(Qe), Qe;
    } else
      return (0, A.Field)(Te, { isLE: xe });
  }
  function Pe(Te, Qe, xe = {}, Ee) {
    if (Ee === void 0 && (Ee = Te === "edwards"), !Qe || typeof Qe != "object")
      throw new Error(`expected valid ${Te} CURVE object`);
    for (const Se of ["p", "n", "h"]) {
      const Ne = Qe[Se];
      if (!(typeof Ne == "bigint" && Ne > u))
        throw new Error(`CURVE.${Se} must be positive bigint`);
    }
    const He = be(Qe.p, xe.Fp, Ee), ve = be(Qe.n, xe.Fn, Ee), Ce = ["Gx", "Gy", "a", Te === "weierstrass" ? "b" : "d"];
    for (const Se of Ce)
      if (!He.isValid(Qe[Se]))
        throw new Error(`CURVE.${Se} must be valid field element of CURVE.Fp`);
    return Qe = Object.freeze(Object.assign({}, Qe)), { CURVE: Qe, Fp: He, Fn: ve };
  }
  return curve$2;
}
var hasRequiredWeierstrass$1;
function requireWeierstrass$1() {
  return hasRequiredWeierstrass$1 || (hasRequiredWeierstrass$1 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.DER = s.DERErr = void 0, s._splitEndoScalar = b, s._normFnElement = le, s.weierstrassN = ge, s.SWUFpSqrtRatio = Ie, s.mapToCurveSimpleSWU = be, s.ecdh = Te, s.ecdsa = Qe, s.weierstrassPoints = xe, s._legacyHelperEquat = ve, s.weierstrass = Se;
    const A = /* @__PURE__ */ requireHmac$3(), u = /* @__PURE__ */ requireUtils$j(), p = /* @__PURE__ */ requireUtils$h(), t = /* @__PURE__ */ requireCurve$2(), l = /* @__PURE__ */ requireModular$1(), m = (Ne, rr) => (Ne + (Ne >= 0 ? rr : -rr) / x) / rr;
    function b(Ne, rr, er) {
      const [[ir, sr], [nr, fr]] = rr, lr = m(fr * Ne, er), br = m(-sr * Ne, er);
      let Br = Ne - lr * ir - br * nr, Fr = -lr * sr - br * fr;
      const Gr = Br < Q, qr = Fr < Q;
      Gr && (Br = -Br), qr && (Fr = -Fr);
      const Hr = (0, p.bitMask)(Math.ceil((0, p.bitLen)(er) / 2)) + P;
      if (Br < Q || Br >= Hr || Fr < Q || Fr >= Hr)
        throw new Error("splitScalar (endomorphism): failed, k=" + Ne);
      return { k1neg: Gr, k1: Br, k2neg: qr, k2: Fr };
    }
    function k(Ne) {
      if (!["compact", "recovered", "der"].includes(Ne))
        throw new Error('Signature format must be "compact", "recovered", or "der"');
      return Ne;
    }
    function C(Ne, rr) {
      const er = {};
      for (let ir of Object.keys(rr))
        er[ir] = Ne[ir] === void 0 ? rr[ir] : Ne[ir];
      return (0, p._abool2)(er.lowS, "lowS"), (0, p._abool2)(er.prehash, "prehash"), er.format !== void 0 && k(er.format), er;
    }
    class B extends Error {
      constructor(rr = "") {
        super(rr);
      }
    }
    s.DERErr = B, s.DER = {
      // asn.1 DER encoding utils
      Err: B,
      // Basic building block is TLV (Tag-Length-Value)
      _tlv: {
        encode: (Ne, rr) => {
          const { Err: er } = s.DER;
          if (Ne < 0 || Ne > 256)
            throw new er("tlv.encode: wrong tag");
          if (rr.length & 1)
            throw new er("tlv.encode: unpadded data");
          const ir = rr.length / 2, sr = (0, p.numberToHexUnpadded)(ir);
          if (sr.length / 2 & 128)
            throw new er("tlv.encode: long form length too big");
          const nr = ir > 127 ? (0, p.numberToHexUnpadded)(sr.length / 2 | 128) : "";
          return (0, p.numberToHexUnpadded)(Ne) + nr + sr + rr;
        },
        // v - value, l - left bytes (unparsed)
        decode(Ne, rr) {
          const { Err: er } = s.DER;
          let ir = 0;
          if (Ne < 0 || Ne > 256)
            throw new er("tlv.encode: wrong tag");
          if (rr.length < 2 || rr[ir++] !== Ne)
            throw new er("tlv.decode: wrong tlv");
          const sr = rr[ir++], nr = !!(sr & 128);
          let fr = 0;
          if (!nr)
            fr = sr;
          else {
            const br = sr & 127;
            if (!br)
              throw new er("tlv.decode(long): indefinite length not supported");
            if (br > 4)
              throw new er("tlv.decode(long): byte length is too big");
            const Br = rr.subarray(ir, ir + br);
            if (Br.length !== br)
              throw new er("tlv.decode: length bytes not complete");
            if (Br[0] === 0)
              throw new er("tlv.decode(long): zero leftmost byte");
            for (const Fr of Br)
              fr = fr << 8 | Fr;
            if (ir += br, fr < 128)
              throw new er("tlv.decode(long): not minimal encoding");
          }
          const lr = rr.subarray(ir, ir + fr);
          if (lr.length !== fr)
            throw new er("tlv.decode: wrong value length");
          return { v: lr, l: rr.subarray(ir + fr) };
        }
      },
      // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
      // since we always use positive integers here. It must always be empty:
      // - add zero byte if exists
      // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
      _int: {
        encode(Ne) {
          const { Err: rr } = s.DER;
          if (Ne < Q)
            throw new rr("integer: negative integers are not allowed");
          let er = (0, p.numberToHexUnpadded)(Ne);
          if (Number.parseInt(er[0], 16) & 8 && (er = "00" + er), er.length & 1)
            throw new rr("unexpected DER parsing assertion: unpadded hex");
          return er;
        },
        decode(Ne) {
          const { Err: rr } = s.DER;
          if (Ne[0] & 128)
            throw new rr("invalid signature integer: negative");
          if (Ne[0] === 0 && !(Ne[1] & 128))
            throw new rr("invalid signature integer: unnecessary leading zero");
          return (0, p.bytesToNumberBE)(Ne);
        }
      },
      toSig(Ne) {
        const { Err: rr, _int: er, _tlv: ir } = s.DER, sr = (0, p.ensureBytes)("signature", Ne), { v: nr, l: fr } = ir.decode(48, sr);
        if (fr.length)
          throw new rr("invalid signature: left bytes after parsing");
        const { v: lr, l: br } = ir.decode(2, nr), { v: Br, l: Fr } = ir.decode(2, br);
        if (Fr.length)
          throw new rr("invalid signature: left bytes after parsing");
        return { r: er.decode(lr), s: er.decode(Br) };
      },
      hexFromSig(Ne) {
        const { _tlv: rr, _int: er } = s.DER, ir = rr.encode(2, er.encode(Ne.r)), sr = rr.encode(2, er.encode(Ne.s)), nr = ir + sr;
        return rr.encode(48, nr);
      }
    };
    const Q = BigInt(0), P = BigInt(1), x = BigInt(2), M = BigInt(3), F = BigInt(4);
    function le(Ne, rr) {
      const { BYTES: er } = Ne;
      let ir;
      if (typeof rr == "bigint")
        ir = rr;
      else {
        let sr = (0, p.ensureBytes)("private key", rr);
        try {
          ir = Ne.fromBytes(sr);
        } catch {
          throw new Error(`invalid private key: expected ui8a of size ${er}, got ${typeof rr}`);
        }
      }
      if (!Ne.isValidNot0(ir))
        throw new Error("invalid private key: out of range [1..N-1]");
      return ir;
    }
    function ge(Ne, rr = {}) {
      const er = (0, t._createCurveFields)("weierstrass", Ne, rr), { Fp: ir, Fn: sr } = er;
      let nr = er.CURVE;
      const { h: fr, n: lr } = nr;
      (0, p._validateObject)(rr, {}, {
        allowInfinityPoint: "boolean",
        clearCofactor: "function",
        isTorsionFree: "function",
        fromBytes: "function",
        toBytes: "function",
        endo: "object",
        wrapPrivateKey: "boolean"
      });
      const { endo: br } = rr;
      if (br && (!ir.is0(nr.a) || typeof br.beta != "bigint" || !Array.isArray(br.basises)))
        throw new Error('invalid endo: expected "beta": bigint and "basises": array');
      const Br = Pe(ir, sr);
      function Fr() {
        if (!ir.isOdd)
          throw new Error("compression is not supported: Field does not have .isOdd()");
      }
      function Gr(Cn, Xr, In) {
        const { x: zr, y: En } = Xr.toAffine(), Zr = ir.toBytes(zr);
        if ((0, p._abool2)(In, "isCompressed"), In) {
          Fr();
          const kr = !ir.isOdd(En);
          return (0, p.concatBytes)(pe(kr), Zr);
        } else
          return (0, p.concatBytes)(Uint8Array.of(4), Zr, ir.toBytes(En));
      }
      function qr(Cn) {
        (0, p._abytes2)(Cn, void 0, "Point");
        const { publicKey: Xr, publicKeyUncompressed: In } = Br, zr = Cn.length, En = Cn[0], Zr = Cn.subarray(1);
        if (zr === Xr && (En === 2 || En === 3)) {
          const kr = ir.fromBytes(Zr);
          if (!ir.isValid(kr))
            throw new Error("bad point: is not on curve, wrong x");
          const Rr = Dr(kr);
          let Er;
          try {
            Er = ir.sqrt(Rr);
          } catch (Kn) {
            const Ln = Kn instanceof Error ? ": " + Kn.message : "";
            throw new Error("bad point: is not on curve, sqrt error" + Ln);
          }
          Fr();
          const Or = ir.isOdd(Er);
          return (En & 1) === 1 !== Or && (Er = ir.neg(Er)), { x: kr, y: Er };
        } else if (zr === In && En === 4) {
          const kr = ir.BYTES, Rr = ir.fromBytes(Zr.subarray(0, kr)), Er = ir.fromBytes(Zr.subarray(kr, kr * 2));
          if (!wr(Rr, Er))
            throw new Error("bad point: is not on curve");
          return { x: Rr, y: Er };
        } else
          throw new Error(`bad point: got length ${zr}, expected compressed=${Xr} or uncompressed=${In}`);
      }
      const Hr = rr.toBytes || Gr, un = rr.fromBytes || qr;
      function Dr(Cn) {
        const Xr = ir.sqr(Cn), In = ir.mul(Xr, Cn);
        return ir.add(ir.add(In, ir.mul(Cn, nr.a)), nr.b);
      }
      function wr(Cn, Xr) {
        const In = ir.sqr(Xr), zr = Dr(Cn);
        return ir.eql(In, zr);
      }
      if (!wr(nr.Gx, nr.Gy))
        throw new Error("bad curve params: generator point");
      const yr = ir.mul(ir.pow(nr.a, M), F), Qr = ir.mul(ir.sqr(nr.b), BigInt(27));
      if (ir.is0(ir.add(yr, Qr)))
        throw new Error("bad curve params: a or b");
      function _r(Cn, Xr, In = !1) {
        if (!ir.isValid(Xr) || In && ir.is0(Xr))
          throw new Error(`bad point coordinate ${Cn}`);
        return Xr;
      }
      function Jr(Cn) {
        if (!(Cn instanceof Yn))
          throw new Error("ProjectivePoint expected");
      }
      function fn(Cn) {
        if (!br || !br.basises)
          throw new Error("no endo");
        return b(Cn, br.basises, sr.ORDER);
      }
      const jr = (0, p.memoized)((Cn, Xr) => {
        const { X: In, Y: zr, Z: En } = Cn;
        if (ir.eql(En, ir.ONE))
          return { x: In, y: zr };
        const Zr = Cn.is0();
        Xr == null && (Xr = Zr ? ir.ONE : ir.inv(En));
        const kr = ir.mul(In, Xr), Rr = ir.mul(zr, Xr), Er = ir.mul(En, Xr);
        if (Zr)
          return { x: ir.ZERO, y: ir.ZERO };
        if (!ir.eql(Er, ir.ONE))
          throw new Error("invZ was invalid");
        return { x: kr, y: Rr };
      }), dn = (0, p.memoized)((Cn) => {
        if (Cn.is0()) {
          if (rr.allowInfinityPoint && !ir.is0(Cn.Y))
            return;
          throw new Error("bad point: ZERO");
        }
        const { x: Xr, y: In } = Cn.toAffine();
        if (!ir.isValid(Xr) || !ir.isValid(In))
          throw new Error("bad point: x or y not field elements");
        if (!wr(Xr, In))
          throw new Error("bad point: equation left != right");
        if (!Cn.isTorsionFree())
          throw new Error("bad point: not in prime-order subgroup");
        return !0;
      });
      function Tn(Cn, Xr, In, zr, En) {
        return In = new Yn(ir.mul(In.X, Cn), In.Y, In.Z), Xr = (0, t.negateCt)(zr, Xr), In = (0, t.negateCt)(En, In), Xr.add(In);
      }
      class Yn {
        /** Does NOT validate if the point is valid. Use `.assertValidity()`. */
        constructor(Xr, In, zr) {
          this.X = _r("x", Xr), this.Y = _r("y", In, !0), this.Z = _r("z", zr), Object.freeze(this);
        }
        static CURVE() {
          return nr;
        }
        /** Does NOT validate if the point is valid. Use `.assertValidity()`. */
        static fromAffine(Xr) {
          const { x: In, y: zr } = Xr || {};
          if (!Xr || !ir.isValid(In) || !ir.isValid(zr))
            throw new Error("invalid affine point");
          if (Xr instanceof Yn)
            throw new Error("projective point not allowed");
          return ir.is0(In) && ir.is0(zr) ? Yn.ZERO : new Yn(In, zr, ir.ONE);
        }
        static fromBytes(Xr) {
          const In = Yn.fromAffine(un((0, p._abytes2)(Xr, void 0, "point")));
          return In.assertValidity(), In;
        }
        static fromHex(Xr) {
          return Yn.fromBytes((0, p.ensureBytes)("pointHex", Xr));
        }
        get x() {
          return this.toAffine().x;
        }
        get y() {
          return this.toAffine().y;
        }
        /**
         *
         * @param windowSize
         * @param isLazy true will defer table computation until the first multiplication
         * @returns
         */
        precompute(Xr = 8, In = !0) {
          return vn.createCache(this, Xr), In || this.multiply(M), this;
        }
        // TODO: return `this`
        /** A point on curve is valid if it conforms to equation. */
        assertValidity() {
          dn(this);
        }
        hasEvenY() {
          const { y: Xr } = this.toAffine();
          if (!ir.isOdd)
            throw new Error("Field doesn't support isOdd");
          return !ir.isOdd(Xr);
        }
        /** Compare one point to another. */
        equals(Xr) {
          Jr(Xr);
          const { X: In, Y: zr, Z: En } = this, { X: Zr, Y: kr, Z: Rr } = Xr, Er = ir.eql(ir.mul(In, Rr), ir.mul(Zr, En)), Or = ir.eql(ir.mul(zr, Rr), ir.mul(kr, En));
          return Er && Or;
        }
        /** Flips point to one corresponding to (x, -y) in Affine coordinates. */
        negate() {
          return new Yn(this.X, ir.neg(this.Y), this.Z);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
          const { a: Xr, b: In } = nr, zr = ir.mul(In, M), { X: En, Y: Zr, Z: kr } = this;
          let Rr = ir.ZERO, Er = ir.ZERO, Or = ir.ZERO, wn = ir.mul(En, En), Kn = ir.mul(Zr, Zr), Ln = ir.mul(kr, kr), Wn = ir.mul(En, Zr);
          return Wn = ir.add(Wn, Wn), Or = ir.mul(En, kr), Or = ir.add(Or, Or), Rr = ir.mul(Xr, Or), Er = ir.mul(zr, Ln), Er = ir.add(Rr, Er), Rr = ir.sub(Kn, Er), Er = ir.add(Kn, Er), Er = ir.mul(Rr, Er), Rr = ir.mul(Wn, Rr), Or = ir.mul(zr, Or), Ln = ir.mul(Xr, Ln), Wn = ir.sub(wn, Ln), Wn = ir.mul(Xr, Wn), Wn = ir.add(Wn, Or), Or = ir.add(wn, wn), wn = ir.add(Or, wn), wn = ir.add(wn, Ln), wn = ir.mul(wn, Wn), Er = ir.add(Er, wn), Ln = ir.mul(Zr, kr), Ln = ir.add(Ln, Ln), wn = ir.mul(Ln, Wn), Rr = ir.sub(Rr, wn), Or = ir.mul(Ln, Kn), Or = ir.add(Or, Or), Or = ir.add(Or, Or), new Yn(Rr, Er, Or);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(Xr) {
          Jr(Xr);
          const { X: In, Y: zr, Z: En } = this, { X: Zr, Y: kr, Z: Rr } = Xr;
          let Er = ir.ZERO, Or = ir.ZERO, wn = ir.ZERO;
          const Kn = nr.a, Ln = ir.mul(nr.b, M);
          let Wn = ir.mul(In, Zr), Sn = ir.mul(zr, kr), hi = ir.mul(En, Rr), ki = ir.add(In, zr), xi = ir.add(Zr, kr);
          ki = ir.mul(ki, xi), xi = ir.add(Wn, Sn), ki = ir.sub(ki, xi), xi = ir.add(In, En);
          let _i = ir.add(Zr, Rr);
          return xi = ir.mul(xi, _i), _i = ir.add(Wn, hi), xi = ir.sub(xi, _i), _i = ir.add(zr, En), Er = ir.add(kr, Rr), _i = ir.mul(_i, Er), Er = ir.add(Sn, hi), _i = ir.sub(_i, Er), wn = ir.mul(Kn, xi), Er = ir.mul(Ln, hi), wn = ir.add(Er, wn), Er = ir.sub(Sn, wn), wn = ir.add(Sn, wn), Or = ir.mul(Er, wn), Sn = ir.add(Wn, Wn), Sn = ir.add(Sn, Wn), hi = ir.mul(Kn, hi), xi = ir.mul(Ln, xi), Sn = ir.add(Sn, hi), hi = ir.sub(Wn, hi), hi = ir.mul(Kn, hi), xi = ir.add(xi, hi), Wn = ir.mul(Sn, xi), Or = ir.add(Or, Wn), Wn = ir.mul(_i, xi), Er = ir.mul(ki, Er), Er = ir.sub(Er, Wn), Wn = ir.mul(ki, Sn), wn = ir.mul(_i, wn), wn = ir.add(wn, Wn), new Yn(Er, Or, wn);
        }
        subtract(Xr) {
          return this.add(Xr.negate());
        }
        is0() {
          return this.equals(Yn.ZERO);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */
        multiply(Xr) {
          const { endo: In } = rr;
          if (!sr.isValidNot0(Xr))
            throw new Error("invalid scalar: out of range");
          let zr, En;
          const Zr = (kr) => vn.cached(this, kr, (Rr) => (0, t.normalizeZ)(Yn, Rr));
          if (In) {
            const { k1neg: kr, k1: Rr, k2neg: Er, k2: Or } = fn(Xr), { p: wn, f: Kn } = Zr(Rr), { p: Ln, f: Wn } = Zr(Or);
            En = Kn.add(Wn), zr = Tn(In.beta, wn, Ln, kr, Er);
          } else {
            const { p: kr, f: Rr } = Zr(Xr);
            zr = kr, En = Rr;
          }
          return (0, t.normalizeZ)(Yn, [zr, En])[0];
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed secret key e.g. sig verification, which works over *public* keys.
         */
        multiplyUnsafe(Xr) {
          const { endo: In } = rr, zr = this;
          if (!sr.isValid(Xr))
            throw new Error("invalid scalar: out of range");
          if (Xr === Q || zr.is0())
            return Yn.ZERO;
          if (Xr === P)
            return zr;
          if (vn.hasCache(this))
            return this.multiply(Xr);
          if (In) {
            const { k1neg: En, k1: Zr, k2neg: kr, k2: Rr } = fn(Xr), { p1: Er, p2: Or } = (0, t.mulEndoUnsafe)(Yn, zr, Zr, Rr);
            return Tn(In.beta, Er, Or, En, kr);
          } else
            return vn.unsafe(zr, Xr);
        }
        multiplyAndAddUnsafe(Xr, In, zr) {
          const En = this.multiplyUnsafe(In).add(Xr.multiplyUnsafe(zr));
          return En.is0() ? void 0 : En;
        }
        /**
         * Converts Projective point to affine (x, y) coordinates.
         * @param invertedZ Z^-1 (inverted zero) - optional, precomputation is useful for invertBatch
         */
        toAffine(Xr) {
          return jr(this, Xr);
        }
        /**
         * Checks whether Point is free of torsion elements (is in prime subgroup).
         * Always torsion-free for cofactor=1 curves.
         */
        isTorsionFree() {
          const { isTorsionFree: Xr } = rr;
          return fr === P ? !0 : Xr ? Xr(Yn, this) : vn.unsafe(this, lr).is0();
        }
        clearCofactor() {
          const { clearCofactor: Xr } = rr;
          return fr === P ? this : Xr ? Xr(Yn, this) : this.multiplyUnsafe(fr);
        }
        isSmallOrder() {
          return this.multiplyUnsafe(fr).is0();
        }
        toBytes(Xr = !0) {
          return (0, p._abool2)(Xr, "isCompressed"), this.assertValidity(), Hr(Yn, this, Xr);
        }
        toHex(Xr = !0) {
          return (0, p.bytesToHex)(this.toBytes(Xr));
        }
        toString() {
          return `<Point ${this.is0() ? "ZERO" : this.toHex()}>`;
        }
        // TODO: remove
        get px() {
          return this.X;
        }
        get py() {
          return this.X;
        }
        get pz() {
          return this.Z;
        }
        toRawBytes(Xr = !0) {
          return this.toBytes(Xr);
        }
        _setWindowSize(Xr) {
          this.precompute(Xr);
        }
        static normalizeZ(Xr) {
          return (0, t.normalizeZ)(Yn, Xr);
        }
        static msm(Xr, In) {
          return (0, t.pippenger)(Yn, sr, Xr, In);
        }
        static fromPrivateKey(Xr) {
          return Yn.BASE.multiply(le(sr, Xr));
        }
      }
      Yn.BASE = new Yn(nr.Gx, nr.Gy, ir.ONE), Yn.ZERO = new Yn(ir.ZERO, ir.ONE, ir.ZERO), Yn.Fp = ir, Yn.Fn = sr;
      const si = sr.BITS, vn = new t.wNAF(Yn, rr.endo ? Math.ceil(si / 2) : si);
      return Yn.BASE.precompute(8), Yn;
    }
    function pe(Ne) {
      return Uint8Array.of(Ne ? 2 : 3);
    }
    function Ie(Ne, rr) {
      const er = Ne.ORDER;
      let ir = Q;
      for (let un = er - P; un % x === Q; un /= x)
        ir += P;
      const sr = ir, nr = x << sr - P - P, fr = nr * x, lr = (er - P) / fr, br = (lr - P) / x, Br = fr - P, Fr = nr, Gr = Ne.pow(rr, lr), qr = Ne.pow(rr, (lr + P) / x);
      let Hr = (un, Dr) => {
        let wr = Gr, yr = Ne.pow(Dr, Br), Qr = Ne.sqr(yr);
        Qr = Ne.mul(Qr, Dr);
        let _r = Ne.mul(un, Qr);
        _r = Ne.pow(_r, br), _r = Ne.mul(_r, yr), yr = Ne.mul(_r, Dr), Qr = Ne.mul(_r, un);
        let Jr = Ne.mul(Qr, yr);
        _r = Ne.pow(Jr, Fr);
        let fn = Ne.eql(_r, Ne.ONE);
        yr = Ne.mul(Qr, qr), _r = Ne.mul(Jr, wr), Qr = Ne.cmov(yr, Qr, fn), Jr = Ne.cmov(_r, Jr, fn);
        for (let jr = sr; jr > P; jr--) {
          let dn = jr - x;
          dn = x << dn - P;
          let Tn = Ne.pow(Jr, dn);
          const Yn = Ne.eql(Tn, Ne.ONE);
          yr = Ne.mul(Qr, wr), wr = Ne.mul(wr, wr), Tn = Ne.mul(Jr, wr), Qr = Ne.cmov(yr, Qr, Yn), Jr = Ne.cmov(Tn, Jr, Yn);
        }
        return { isValid: fn, value: Qr };
      };
      if (Ne.ORDER % F === M) {
        const un = (Ne.ORDER - M) / F, Dr = Ne.sqrt(Ne.neg(rr));
        Hr = (wr, yr) => {
          let Qr = Ne.sqr(yr);
          const _r = Ne.mul(wr, yr);
          Qr = Ne.mul(Qr, _r);
          let Jr = Ne.pow(Qr, un);
          Jr = Ne.mul(Jr, _r);
          const fn = Ne.mul(Jr, Dr), jr = Ne.mul(Ne.sqr(Jr), yr), dn = Ne.eql(jr, wr);
          let Tn = Ne.cmov(fn, Jr, dn);
          return { isValid: dn, value: Tn };
        };
      }
      return Hr;
    }
    function be(Ne, rr) {
      (0, l.validateField)(Ne);
      const { A: er, B: ir, Z: sr } = rr;
      if (!Ne.isValid(er) || !Ne.isValid(ir) || !Ne.isValid(sr))
        throw new Error("mapToCurveSimpleSWU: invalid opts");
      const nr = Ie(Ne, sr);
      if (!Ne.isOdd)
        throw new Error("Field does not have .isOdd()");
      return (fr) => {
        let lr, br, Br, Fr, Gr, qr, Hr, un;
        lr = Ne.sqr(fr), lr = Ne.mul(lr, sr), br = Ne.sqr(lr), br = Ne.add(br, lr), Br = Ne.add(br, Ne.ONE), Br = Ne.mul(Br, ir), Fr = Ne.cmov(sr, Ne.neg(br), !Ne.eql(br, Ne.ZERO)), Fr = Ne.mul(Fr, er), br = Ne.sqr(Br), qr = Ne.sqr(Fr), Gr = Ne.mul(qr, er), br = Ne.add(br, Gr), br = Ne.mul(br, Br), qr = Ne.mul(qr, Fr), Gr = Ne.mul(qr, ir), br = Ne.add(br, Gr), Hr = Ne.mul(lr, Br);
        const { isValid: Dr, value: wr } = nr(br, qr);
        un = Ne.mul(lr, fr), un = Ne.mul(un, wr), Hr = Ne.cmov(Hr, Br, Dr), un = Ne.cmov(un, wr, Dr);
        const yr = Ne.isOdd(fr) === Ne.isOdd(un);
        un = Ne.cmov(Ne.neg(un), un, yr);
        const Qr = (0, l.FpInvertBatch)(Ne, [Fr], !0)[0];
        return Hr = Ne.mul(Hr, Qr), { x: Hr, y: un };
      };
    }
    function Pe(Ne, rr) {
      return {
        secretKey: rr.BYTES,
        publicKey: 1 + Ne.BYTES,
        publicKeyUncompressed: 1 + 2 * Ne.BYTES,
        publicKeyHasPrefix: !0,
        signature: 2 * rr.BYTES
      };
    }
    function Te(Ne, rr = {}) {
      const { Fn: er } = Ne, ir = rr.randomBytes || p.randomBytes, sr = Object.assign(Pe(Ne.Fp, er), { seed: (0, l.getMinHashLength)(er.ORDER) });
      function nr(Hr) {
        try {
          return !!le(er, Hr);
        } catch {
          return !1;
        }
      }
      function fr(Hr, un) {
        const { publicKey: Dr, publicKeyUncompressed: wr } = sr;
        try {
          const yr = Hr.length;
          return un === !0 && yr !== Dr || un === !1 && yr !== wr ? !1 : !!Ne.fromBytes(Hr);
        } catch {
          return !1;
        }
      }
      function lr(Hr = ir(sr.seed)) {
        return (0, l.mapHashToField)((0, p._abytes2)(Hr, sr.seed, "seed"), er.ORDER);
      }
      function br(Hr, un = !0) {
        return Ne.BASE.multiply(le(er, Hr)).toBytes(un);
      }
      function Br(Hr) {
        const un = lr(Hr);
        return { secretKey: un, publicKey: br(un) };
      }
      function Fr(Hr) {
        if (typeof Hr == "bigint")
          return !1;
        if (Hr instanceof Ne)
          return !0;
        const { secretKey: un, publicKey: Dr, publicKeyUncompressed: wr } = sr;
        if (er.allowedLengths || un === Dr)
          return;
        const yr = (0, p.ensureBytes)("key", Hr).length;
        return yr === Dr || yr === wr;
      }
      function Gr(Hr, un, Dr = !0) {
        if (Fr(Hr) === !0)
          throw new Error("first arg must be private key");
        if (Fr(un) === !1)
          throw new Error("second arg must be public key");
        const wr = le(er, Hr);
        return Ne.fromHex(un).multiply(wr).toBytes(Dr);
      }
      return Object.freeze({ getPublicKey: br, getSharedSecret: Gr, keygen: Br, Point: Ne, utils: {
        isValidSecretKey: nr,
        isValidPublicKey: fr,
        randomSecretKey: lr,
        // TODO: remove
        isValidPrivateKey: nr,
        randomPrivateKey: lr,
        normPrivateKeyToScalar: (Hr) => le(er, Hr),
        precompute(Hr = 8, un = Ne.BASE) {
          return un.precompute(Hr, !1);
        }
      }, lengths: sr });
    }
    function Qe(Ne, rr, er = {}) {
      (0, u.ahash)(rr), (0, p._validateObject)(er, {}, {
        hmac: "function",
        lowS: "boolean",
        randomBytes: "function",
        bits2int: "function",
        bits2int_modN: "function"
      });
      const ir = er.randomBytes || p.randomBytes, sr = er.hmac || ((In, ...zr) => (0, A.hmac)(rr, In, (0, p.concatBytes)(...zr))), { Fp: nr, Fn: fr } = Ne, { ORDER: lr, BITS: br } = fr, { keygen: Br, getPublicKey: Fr, getSharedSecret: Gr, utils: qr, lengths: Hr } = Te(Ne, er), un = {
        prehash: !1,
        lowS: typeof er.lowS == "boolean" ? er.lowS : !1,
        format: void 0,
        //'compact' as ECDSASigFormat,
        extraEntropy: !1
      }, Dr = "compact";
      function wr(In) {
        const zr = lr >> P;
        return In > zr;
      }
      function yr(In, zr) {
        if (!fr.isValidNot0(zr))
          throw new Error(`invalid signature ${In}: out of range 1..Point.Fn.ORDER`);
        return zr;
      }
      function Qr(In, zr) {
        k(zr);
        const En = Hr.signature, Zr = zr === "compact" ? En : zr === "recovered" ? En + 1 : void 0;
        return (0, p._abytes2)(In, Zr, `${zr} signature`);
      }
      class _r {
        constructor(zr, En, Zr) {
          this.r = yr("r", zr), this.s = yr("s", En), Zr != null && (this.recovery = Zr), Object.freeze(this);
        }
        static fromBytes(zr, En = Dr) {
          Qr(zr, En);
          let Zr;
          if (En === "der") {
            const { r: Or, s: wn } = s.DER.toSig((0, p._abytes2)(zr));
            return new _r(Or, wn);
          }
          En === "recovered" && (Zr = zr[0], En = "compact", zr = zr.subarray(1));
          const kr = fr.BYTES, Rr = zr.subarray(0, kr), Er = zr.subarray(kr, kr * 2);
          return new _r(fr.fromBytes(Rr), fr.fromBytes(Er), Zr);
        }
        static fromHex(zr, En) {
          return this.fromBytes((0, p.hexToBytes)(zr), En);
        }
        addRecoveryBit(zr) {
          return new _r(this.r, this.s, zr);
        }
        recoverPublicKey(zr) {
          const En = nr.ORDER, { r: Zr, s: kr, recovery: Rr } = this;
          if (Rr == null || ![0, 1, 2, 3].includes(Rr))
            throw new Error("recovery id invalid");
          if (lr * x < En && Rr > 1)
            throw new Error("recovery id is ambiguous for h>1 curve");
          const Or = Rr === 2 || Rr === 3 ? Zr + lr : Zr;
          if (!nr.isValid(Or))
            throw new Error("recovery id 2 or 3 invalid");
          const wn = nr.toBytes(Or), Kn = Ne.fromBytes((0, p.concatBytes)(pe((Rr & 1) === 0), wn)), Ln = fr.inv(Or), Wn = fn((0, p.ensureBytes)("msgHash", zr)), Sn = fr.create(-Wn * Ln), hi = fr.create(kr * Ln), ki = Ne.BASE.multiplyUnsafe(Sn).add(Kn.multiplyUnsafe(hi));
          if (ki.is0())
            throw new Error("point at infinify");
          return ki.assertValidity(), ki;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
          return wr(this.s);
        }
        toBytes(zr = Dr) {
          if (k(zr), zr === "der")
            return (0, p.hexToBytes)(s.DER.hexFromSig(this));
          const En = fr.toBytes(this.r), Zr = fr.toBytes(this.s);
          if (zr === "recovered") {
            if (this.recovery == null)
              throw new Error("recovery bit must be present");
            return (0, p.concatBytes)(Uint8Array.of(this.recovery), En, Zr);
          }
          return (0, p.concatBytes)(En, Zr);
        }
        toHex(zr) {
          return (0, p.bytesToHex)(this.toBytes(zr));
        }
        // TODO: remove
        assertValidity() {
        }
        static fromCompact(zr) {
          return _r.fromBytes((0, p.ensureBytes)("sig", zr), "compact");
        }
        static fromDER(zr) {
          return _r.fromBytes((0, p.ensureBytes)("sig", zr), "der");
        }
        normalizeS() {
          return this.hasHighS() ? new _r(this.r, fr.neg(this.s), this.recovery) : this;
        }
        toDERRawBytes() {
          return this.toBytes("der");
        }
        toDERHex() {
          return (0, p.bytesToHex)(this.toBytes("der"));
        }
        toCompactRawBytes() {
          return this.toBytes("compact");
        }
        toCompactHex() {
          return (0, p.bytesToHex)(this.toBytes("compact"));
        }
      }
      const Jr = er.bits2int || function(zr) {
        if (zr.length > 8192)
          throw new Error("input is too large");
        const En = (0, p.bytesToNumberBE)(zr), Zr = zr.length * 8 - br;
        return Zr > 0 ? En >> BigInt(Zr) : En;
      }, fn = er.bits2int_modN || function(zr) {
        return fr.create(Jr(zr));
      }, jr = (0, p.bitMask)(br);
      function dn(In) {
        return (0, p.aInRange)("num < 2^" + br, In, Q, jr), fr.toBytes(In);
      }
      function Tn(In, zr) {
        return (0, p._abytes2)(In, void 0, "message"), zr ? (0, p._abytes2)(rr(In), void 0, "prehashed message") : In;
      }
      function Yn(In, zr, En) {
        if (["recovered", "canonical"].some((Sn) => Sn in En))
          throw new Error("sign() legacy options not supported");
        const { lowS: Zr, prehash: kr, extraEntropy: Rr } = C(En, un);
        In = Tn(In, kr);
        const Er = fn(In), Or = le(fr, zr), wn = [dn(Or), dn(Er)];
        if (Rr != null && Rr !== !1) {
          const Sn = Rr === !0 ? ir(Hr.secretKey) : Rr;
          wn.push((0, p.ensureBytes)("extraEntropy", Sn));
        }
        const Kn = (0, p.concatBytes)(...wn), Ln = Er;
        function Wn(Sn) {
          const hi = Jr(Sn);
          if (!fr.isValidNot0(hi))
            return;
          const ki = fr.inv(hi), xi = Ne.BASE.multiply(hi).toAffine(), _i = fr.create(xi.x);
          if (_i === Q)
            return;
          const Li = fr.create(ki * fr.create(Ln + _i * Or));
          if (Li === Q)
            return;
          let ms = (xi.x === _i ? 0 : 2) | Number(xi.y & P), Ui = Li;
          return Zr && wr(Li) && (Ui = fr.neg(Li), ms ^= 1), new _r(_i, Ui, ms);
        }
        return { seed: Kn, k2sig: Wn };
      }
      function si(In, zr, En = {}) {
        In = (0, p.ensureBytes)("message", In);
        const { seed: Zr, k2sig: kr } = Yn(In, zr, En);
        return (0, p.createHmacDrbg)(rr.outputLen, fr.BYTES, sr)(Zr, kr);
      }
      function vn(In) {
        let zr;
        const En = typeof In == "string" || (0, p.isBytes)(In), Zr = !En && In !== null && typeof In == "object" && typeof In.r == "bigint" && typeof In.s == "bigint";
        if (!En && !Zr)
          throw new Error("invalid signature, expected Uint8Array, hex string or Signature instance");
        if (Zr)
          zr = new _r(In.r, In.s);
        else if (En) {
          try {
            zr = _r.fromBytes((0, p.ensureBytes)("sig", In), "der");
          } catch (kr) {
            if (!(kr instanceof s.DER.Err))
              throw kr;
          }
          if (!zr)
            try {
              zr = _r.fromBytes((0, p.ensureBytes)("sig", In), "compact");
            } catch {
              return !1;
            }
        }
        return zr || !1;
      }
      function Cn(In, zr, En, Zr = {}) {
        const { lowS: kr, prehash: Rr, format: Er } = C(Zr, un);
        if (En = (0, p.ensureBytes)("publicKey", En), zr = Tn((0, p.ensureBytes)("message", zr), Rr), "strict" in Zr)
          throw new Error("options.strict was renamed to lowS");
        const Or = Er === void 0 ? vn(In) : _r.fromBytes((0, p.ensureBytes)("sig", In), Er);
        if (Or === !1)
          return !1;
        try {
          const wn = Ne.fromBytes(En);
          if (kr && Or.hasHighS())
            return !1;
          const { r: Kn, s: Ln } = Or, Wn = fn(zr), Sn = fr.inv(Ln), hi = fr.create(Wn * Sn), ki = fr.create(Kn * Sn), xi = Ne.BASE.multiplyUnsafe(hi).add(wn.multiplyUnsafe(ki));
          return xi.is0() ? !1 : fr.create(xi.x) === Kn;
        } catch {
          return !1;
        }
      }
      function Xr(In, zr, En = {}) {
        const { prehash: Zr } = C(En, un);
        return zr = Tn(zr, Zr), _r.fromBytes(In, "recovered").recoverPublicKey(zr).toBytes();
      }
      return Object.freeze({
        keygen: Br,
        getPublicKey: Fr,
        getSharedSecret: Gr,
        utils: qr,
        lengths: Hr,
        Point: Ne,
        sign: si,
        verify: Cn,
        recoverPublicKey: Xr,
        Signature: _r,
        hash: rr
      });
    }
    function xe(Ne) {
      const { CURVE: rr, curveOpts: er } = Ee(Ne), ir = ge(rr, er);
      return we(Ne, ir);
    }
    function Ee(Ne) {
      const rr = {
        a: Ne.a,
        b: Ne.b,
        p: Ne.Fp.ORDER,
        n: Ne.n,
        h: Ne.h,
        Gx: Ne.Gx,
        Gy: Ne.Gy
      }, er = Ne.Fp;
      let ir = Ne.allowedPrivateKeyLengths ? Array.from(new Set(Ne.allowedPrivateKeyLengths.map((fr) => Math.ceil(fr / 2)))) : void 0;
      const sr = (0, l.Field)(rr.n, {
        BITS: Ne.nBitLength,
        allowedLengths: ir,
        modFromBytes: Ne.wrapPrivateKey
      }), nr = {
        Fp: er,
        Fn: sr,
        allowInfinityPoint: Ne.allowInfinityPoint,
        endo: Ne.endo,
        isTorsionFree: Ne.isTorsionFree,
        clearCofactor: Ne.clearCofactor,
        fromBytes: Ne.fromBytes,
        toBytes: Ne.toBytes
      };
      return { CURVE: rr, curveOpts: nr };
    }
    function He(Ne) {
      const { CURVE: rr, curveOpts: er } = Ee(Ne), ir = {
        hmac: Ne.hmac,
        randomBytes: Ne.randomBytes,
        lowS: Ne.lowS,
        bits2int: Ne.bits2int,
        bits2int_modN: Ne.bits2int_modN
      };
      return { CURVE: rr, curveOpts: er, hash: Ne.hash, ecdsaOpts: ir };
    }
    function ve(Ne, rr, er) {
      function ir(sr) {
        const nr = Ne.sqr(sr), fr = Ne.mul(nr, sr);
        return Ne.add(Ne.add(fr, Ne.mul(sr, rr)), er);
      }
      return ir;
    }
    function we(Ne, rr) {
      const { Fp: er, Fn: ir } = rr;
      function sr(fr) {
        return (0, p.inRange)(fr, P, ir.ORDER);
      }
      const nr = ve(er, Ne.a, Ne.b);
      return Object.assign({}, {
        CURVE: Ne,
        Point: rr,
        ProjectivePoint: rr,
        normPrivateKeyToScalar: (fr) => le(ir, fr),
        weierstrassEquation: nr,
        isWithinCurveOrder: sr
      });
    }
    function Ce(Ne, rr) {
      const er = rr.Point;
      return Object.assign({}, rr, {
        ProjectivePoint: er,
        CURVE: Object.assign({}, Ne, (0, l.nLength)(er.Fn.ORDER, er.Fn.BITS))
      });
    }
    function Se(Ne) {
      const { CURVE: rr, curveOpts: er, hash: ir, ecdsaOpts: sr } = He(Ne), nr = ge(rr, er), fr = Qe(nr, ir, sr);
      return Ce(Ne, fr);
    }
  }(weierstrass$3)), weierstrass$3;
}
var hasRequired_shortw_utils$1;
function require_shortw_utils$1() {
  if (hasRequired_shortw_utils$1) return _shortw_utils$1;
  hasRequired_shortw_utils$1 = 1, Object.defineProperty(_shortw_utils$1, "__esModule", { value: !0 }), _shortw_utils$1.getHash = A, _shortw_utils$1.createCurve = u;
  const s = /* @__PURE__ */ requireWeierstrass$1();
  function A(p) {
    return { hash: p };
  }
  function u(p, t) {
    const l = (m) => (0, s.weierstrass)({ ...p, hash: m });
    return { ...l(t), create: l };
  }
  return _shortw_utils$1;
}
var hashToCurve$1 = {}, hasRequiredHashToCurve$1;
function requireHashToCurve$1() {
  return hasRequiredHashToCurve$1 || (hasRequiredHashToCurve$1 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s._DST_scalar = void 0, s.expand_message_xmd = k, s.expand_message_xof = C, s.hash_to_field = B, s.isogenyMap = Q, s.createHasher = P;
    const A = /* @__PURE__ */ requireUtils$h(), u = /* @__PURE__ */ requireModular$1(), p = A.bytesToNumberBE;
    function t(x, M) {
      if (m(x), m(M), x < 0 || x >= 1 << 8 * M)
        throw new Error("invalid I2OSP input: " + x);
      const F = Array.from({ length: M }).fill(0);
      for (let le = M - 1; le >= 0; le--)
        F[le] = x & 255, x >>>= 8;
      return new Uint8Array(F);
    }
    function l(x, M) {
      const F = new Uint8Array(x.length);
      for (let le = 0; le < x.length; le++)
        F[le] = x[le] ^ M[le];
      return F;
    }
    function m(x) {
      if (!Number.isSafeInteger(x))
        throw new Error("number expected");
    }
    function b(x) {
      if (!(0, A.isBytes)(x) && typeof x != "string")
        throw new Error("DST must be Uint8Array or string");
      return typeof x == "string" ? (0, A.utf8ToBytes)(x) : x;
    }
    function k(x, M, F, le) {
      (0, A.abytes)(x), m(F), M = b(M), M.length > 255 && (M = le((0, A.concatBytes)((0, A.utf8ToBytes)("H2C-OVERSIZE-DST-"), M)));
      const { outputLen: ge, blockLen: pe } = le, Ie = Math.ceil(F / ge);
      if (F > 65535 || Ie > 255)
        throw new Error("expand_message_xmd: invalid lenInBytes");
      const be = (0, A.concatBytes)(M, t(M.length, 1)), Pe = t(0, pe), Te = t(F, 2), Qe = new Array(Ie), xe = le((0, A.concatBytes)(Pe, x, Te, t(0, 1), be));
      Qe[0] = le((0, A.concatBytes)(xe, t(1, 1), be));
      for (let He = 1; He <= Ie; He++) {
        const ve = [l(xe, Qe[He - 1]), t(He + 1, 1), be];
        Qe[He] = le((0, A.concatBytes)(...ve));
      }
      return (0, A.concatBytes)(...Qe).slice(0, F);
    }
    function C(x, M, F, le, ge) {
      if ((0, A.abytes)(x), m(F), M = b(M), M.length > 255) {
        const pe = Math.ceil(2 * le / 8);
        M = ge.create({ dkLen: pe }).update((0, A.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(M).digest();
      }
      if (F > 65535 || M.length > 255)
        throw new Error("expand_message_xof: invalid lenInBytes");
      return ge.create({ dkLen: F }).update(x).update(t(F, 2)).update(M).update(t(M.length, 1)).digest();
    }
    function B(x, M, F) {
      (0, A._validateObject)(F, {
        p: "bigint",
        m: "number",
        k: "number",
        hash: "function"
      });
      const { p: le, k: ge, m: pe, hash: Ie, expand: be, DST: Pe } = F;
      if (!(0, A.isHash)(F.hash))
        throw new Error("expected valid hash");
      (0, A.abytes)(x), m(M);
      const Te = le.toString(2).length, Qe = Math.ceil((Te + ge) / 8), xe = M * pe * Qe;
      let Ee;
      if (be === "xmd")
        Ee = k(x, Pe, xe, Ie);
      else if (be === "xof")
        Ee = C(x, Pe, xe, ge, Ie);
      else if (be === "_internal_pass")
        Ee = x;
      else
        throw new Error('expand must be "xmd" or "xof"');
      const He = new Array(M);
      for (let ve = 0; ve < M; ve++) {
        const we = new Array(pe);
        for (let Ce = 0; Ce < pe; Ce++) {
          const Se = Qe * (Ce + ve * pe), Ne = Ee.subarray(Se, Se + Qe);
          we[Ce] = (0, u.mod)(p(Ne), le);
        }
        He[ve] = we;
      }
      return He;
    }
    function Q(x, M) {
      const F = M.map((le) => Array.from(le).reverse());
      return (le, ge) => {
        const [pe, Ie, be, Pe] = F.map((xe) => xe.reduce((Ee, He) => x.add(x.mul(Ee, le), He))), [Te, Qe] = (0, u.FpInvertBatch)(x, [Ie, Pe], !0);
        return le = x.mul(pe, Te), ge = x.mul(ge, x.mul(be, Qe)), { x: le, y: ge };
      };
    }
    s._DST_scalar = (0, A.utf8ToBytes)("HashToScalar-");
    function P(x, M, F) {
      if (typeof M != "function")
        throw new Error("mapToCurve() must be defined");
      function le(pe) {
        return x.fromAffine(M(pe));
      }
      function ge(pe) {
        const Ie = pe.clearCofactor();
        return Ie.equals(x.ZERO) ? x.ZERO : (Ie.assertValidity(), Ie);
      }
      return {
        defaults: F,
        hashToCurve(pe, Ie) {
          const be = Object.assign({}, F, Ie), Pe = B(pe, 2, be), Te = le(Pe[0]), Qe = le(Pe[1]);
          return ge(Te.add(Qe));
        },
        encodeToCurve(pe, Ie) {
          const be = F.encodeDST ? { DST: F.encodeDST } : {}, Pe = Object.assign({}, F, be, Ie), Te = B(pe, 1, Pe), Qe = le(Te[0]);
          return ge(Qe);
        },
        /** See {@link H2CHasher} */
        mapToCurve(pe) {
          if (!Array.isArray(pe))
            throw new Error("expected array of bigints");
          for (const Ie of pe)
            if (typeof Ie != "bigint")
              throw new Error("expected array of bigints");
          return ge(le(pe));
        },
        // hash_to_scalar can produce 0: https://www.rfc-editor.org/errata/eid8393
        // RFC 9380, draft-irtf-cfrg-bbs-signatures-08
        hashToScalar(pe, Ie) {
          const be = x.Fn.ORDER, Pe = Object.assign({}, F, { p: be, m: 1, DST: s._DST_scalar }, Ie);
          return B(pe, 1, Pe)[0][0];
        }
      };
    }
  }(hashToCurve$1)), hashToCurve$1;
}
var hasRequiredSecp256k1$5;
function requireSecp256k1$5() {
  return hasRequiredSecp256k1$5 || (hasRequiredSecp256k1$5 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.encodeToCurve = s.hashToCurve = s.secp256k1_hasher = s.schnorr = s.secp256k1 = void 0;
    const A = /* @__PURE__ */ requireSha2(), u = /* @__PURE__ */ requireUtils$j(), p = /* @__PURE__ */ require_shortw_utils$1(), t = /* @__PURE__ */ requireHashToCurve$1(), l = /* @__PURE__ */ requireModular$1(), m = /* @__PURE__ */ requireWeierstrass$1(), b = /* @__PURE__ */ requireUtils$h(), k = {
      p: BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"),
      n: BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"),
      h: BigInt(1),
      a: BigInt(0),
      b: BigInt(7),
      Gx: BigInt("0x79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"),
      Gy: BigInt("0x483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8")
    }, C = {
      beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
      basises: [
        [BigInt("0x3086d221a7d46bcde86c90e49284eb15"), -BigInt("0xe4437ed6010e88286f547fa90abfe4c3")],
        [BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), BigInt("0x3086d221a7d46bcde86c90e49284eb15")]
      ]
    }, B = /* @__PURE__ */ BigInt(0), Q = /* @__PURE__ */ BigInt(1), P = /* @__PURE__ */ BigInt(2);
    function x(Ce) {
      const Se = k.p, Ne = BigInt(3), rr = BigInt(6), er = BigInt(11), ir = BigInt(22), sr = BigInt(23), nr = BigInt(44), fr = BigInt(88), lr = Ce * Ce * Ce % Se, br = lr * lr * Ce % Se, Br = (0, l.pow2)(br, Ne, Se) * br % Se, Fr = (0, l.pow2)(Br, Ne, Se) * br % Se, Gr = (0, l.pow2)(Fr, P, Se) * lr % Se, qr = (0, l.pow2)(Gr, er, Se) * Gr % Se, Hr = (0, l.pow2)(qr, ir, Se) * qr % Se, un = (0, l.pow2)(Hr, nr, Se) * Hr % Se, Dr = (0, l.pow2)(un, fr, Se) * un % Se, wr = (0, l.pow2)(Dr, nr, Se) * Hr % Se, yr = (0, l.pow2)(wr, Ne, Se) * br % Se, Qr = (0, l.pow2)(yr, sr, Se) * qr % Se, _r = (0, l.pow2)(Qr, rr, Se) * lr % Se, Jr = (0, l.pow2)(_r, P, Se);
      if (!M.eql(M.sqr(Jr), Ce))
        throw new Error("Cannot find square root");
      return Jr;
    }
    const M = (0, l.Field)(k.p, { sqrt: x });
    s.secp256k1 = (0, p.createCurve)({ ...k, Fp: M, lowS: !0, endo: C }, A.sha256);
    const F = {};
    function le(Ce, ...Se) {
      let Ne = F[Ce];
      if (Ne === void 0) {
        const rr = (0, A.sha256)((0, b.utf8ToBytes)(Ce));
        Ne = (0, b.concatBytes)(rr, rr), F[Ce] = Ne;
      }
      return (0, A.sha256)((0, b.concatBytes)(Ne, ...Se));
    }
    const ge = (Ce) => Ce.toBytes(!0).slice(1), pe = s.secp256k1.Point, Ie = (Ce) => Ce % P === B;
    function be(Ce) {
      const { Fn: Se, BASE: Ne } = pe, rr = (0, m._normFnElement)(Se, Ce), er = Ne.multiply(rr);
      return { scalar: Ie(er.y) ? rr : Se.neg(rr), bytes: ge(er) };
    }
    function Pe(Ce) {
      const Se = M;
      if (!Se.isValidNot0(Ce))
        throw new Error("invalid x: Fail if x ≥ p");
      const Ne = Se.create(Ce * Ce), rr = Se.create(Ne * Ce + BigInt(7));
      let er = Se.sqrt(rr);
      Ie(er) || (er = Se.neg(er));
      const ir = pe.fromAffine({ x: Ce, y: er });
      return ir.assertValidity(), ir;
    }
    const Te = b.bytesToNumberBE;
    function Qe(...Ce) {
      return pe.Fn.create(Te(le("BIP0340/challenge", ...Ce)));
    }
    function xe(Ce) {
      return be(Ce).bytes;
    }
    function Ee(Ce, Se, Ne = (0, u.randomBytes)(32)) {
      const { Fn: rr } = pe, er = (0, b.ensureBytes)("message", Ce), { bytes: ir, scalar: sr } = be(Se), nr = (0, b.ensureBytes)("auxRand", Ne, 32), fr = rr.toBytes(sr ^ Te(le("BIP0340/aux", nr))), lr = le("BIP0340/nonce", fr, ir, er), { bytes: br, scalar: Br } = be(lr), Fr = Qe(br, ir, er), Gr = new Uint8Array(64);
      if (Gr.set(br, 0), Gr.set(rr.toBytes(rr.create(Br + Fr * sr)), 32), !He(Gr, er, ir))
        throw new Error("sign: Invalid signature produced");
      return Gr;
    }
    function He(Ce, Se, Ne) {
      const { Fn: rr, BASE: er } = pe, ir = (0, b.ensureBytes)("signature", Ce, 64), sr = (0, b.ensureBytes)("message", Se), nr = (0, b.ensureBytes)("publicKey", Ne, 32);
      try {
        const fr = Pe(Te(nr)), lr = Te(ir.subarray(0, 32));
        if (!(0, b.inRange)(lr, Q, k.p))
          return !1;
        const br = Te(ir.subarray(32, 64));
        if (!(0, b.inRange)(br, Q, k.n))
          return !1;
        const Br = Qe(rr.toBytes(lr), ge(fr), sr), Fr = er.multiplyUnsafe(br).add(fr.multiplyUnsafe(rr.neg(Br))), { x: Gr, y: qr } = Fr.toAffine();
        return !(Fr.is0() || !Ie(qr) || Gr !== lr);
      } catch {
        return !1;
      }
    }
    s.schnorr = (() => {
      const Ne = (er = (0, u.randomBytes)(48)) => (0, l.mapHashToField)(er, k.n);
      s.secp256k1.utils.randomSecretKey;
      function rr(er) {
        const ir = Ne(er);
        return { secretKey: ir, publicKey: xe(ir) };
      }
      return {
        keygen: rr,
        getPublicKey: xe,
        sign: Ee,
        verify: He,
        Point: pe,
        utils: {
          randomSecretKey: Ne,
          randomPrivateKey: Ne,
          taggedHash: le,
          // TODO: remove
          lift_x: Pe,
          pointToBytes: ge,
          numberToBytesBE: b.numberToBytesBE,
          bytesToNumberBE: b.bytesToNumberBE,
          mod: l.mod
        },
        lengths: {
          secretKey: 32,
          publicKey: 32,
          publicKeyHasPrefix: !1,
          signature: 64,
          seed: 48
        }
      };
    })();
    const ve = (0, t.isogenyMap)(M, [
      // xNum
      [
        "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
        "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
        "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
        "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
      ],
      // xDen
      [
        "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
        "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
        "0x0000000000000000000000000000000000000000000000000000000000000001"
        // LAST 1
      ],
      // yNum
      [
        "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
        "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
        "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
        "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
      ],
      // yDen
      [
        "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
        "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
        "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
        "0x0000000000000000000000000000000000000000000000000000000000000001"
        // LAST 1
      ]
    ].map((Ce) => Ce.map((Se) => BigInt(Se)))), we = (0, m.mapToCurveSimpleSWU)(M, {
      A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
      B: BigInt("1771"),
      Z: M.create(BigInt("-11"))
    });
    s.secp256k1_hasher = (0, t.createHasher)(s.secp256k1.Point, (Ce) => {
      const { x: Se, y: Ne } = we(M.create(Ce[0]));
      return ve(Se, Ne);
    }, {
      DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
      encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
      p: M.ORDER,
      m: 1,
      k: 128,
      expand: "xmd",
      hash: A.sha256
    }), s.hashToCurve = s.secp256k1_hasher.hashToCurve, s.encodeToCurve = s.secp256k1_hasher.encodeToCurve;
  }(secp256k1$7)), secp256k1$7;
}
var utils$i = {}, hasRequiredUtils$g;
function requireUtils$g() {
  if (hasRequiredUtils$g) return utils$i;
  hasRequiredUtils$g = 1, Object.defineProperty(utils$i, "__esModule", { value: !0 }), utils$i.isHash = utils$i.validateObject = utils$i.memoized = utils$i.notImplemented = utils$i.createHmacDrbg = utils$i.bitMask = utils$i.bitSet = utils$i.bitGet = utils$i.bitLen = utils$i.aInRange = utils$i.inRange = utils$i.asciiToBytes = utils$i.copyBytes = utils$i.equalBytes = utils$i.ensureBytes = utils$i.numberToVarBytesBE = utils$i.numberToBytesLE = utils$i.numberToBytesBE = utils$i.bytesToNumberLE = utils$i.bytesToNumberBE = utils$i.hexToNumber = utils$i.numberToHexUnpadded = utils$i.abool = utils$i.utf8ToBytes = utils$i.randomBytes = utils$i.isBytes = utils$i.hexToBytes = utils$i.concatBytes = utils$i.bytesToUtf8 = utils$i.bytesToHex = utils$i.anumber = utils$i.abytes = void 0;
  const s = /* @__PURE__ */ requireUtils$h();
  return utils$i.abytes = s.abytes, utils$i.anumber = s.anumber, utils$i.bytesToHex = s.bytesToHex, utils$i.bytesToUtf8 = s.bytesToUtf8, utils$i.concatBytes = s.concatBytes, utils$i.hexToBytes = s.hexToBytes, utils$i.isBytes = s.isBytes, utils$i.randomBytes = s.randomBytes, utils$i.utf8ToBytes = s.utf8ToBytes, utils$i.abool = s.abool, utils$i.numberToHexUnpadded = s.numberToHexUnpadded, utils$i.hexToNumber = s.hexToNumber, utils$i.bytesToNumberBE = s.bytesToNumberBE, utils$i.bytesToNumberLE = s.bytesToNumberLE, utils$i.numberToBytesBE = s.numberToBytesBE, utils$i.numberToBytesLE = s.numberToBytesLE, utils$i.numberToVarBytesBE = s.numberToVarBytesBE, utils$i.ensureBytes = s.ensureBytes, utils$i.equalBytes = s.equalBytes, utils$i.copyBytes = s.copyBytes, utils$i.asciiToBytes = s.asciiToBytes, utils$i.inRange = s.inRange, utils$i.aInRange = s.aInRange, utils$i.bitLen = s.bitLen, utils$i.bitGet = s.bitGet, utils$i.bitSet = s.bitSet, utils$i.bitMask = s.bitMask, utils$i.createHmacDrbg = s.createHmacDrbg, utils$i.notImplemented = s.notImplemented, utils$i.memoized = s.memoized, utils$i.validateObject = s.validateObject, utils$i.isHash = s.isHash, utils$i;
}
var hasRequiredDist$l;
function requireDist$l() {
  if (hasRequiredDist$l) return dist$l;
  hasRequiredDist$l = 1;
  var s = /* @__PURE__ */ requireSecp256k1$5(), A = /* @__PURE__ */ requireModular$1(), u = /* @__PURE__ */ requireUtils$g();
  function p(Zr) {
    var kr = /* @__PURE__ */ Object.create(null);
    return Zr && Object.keys(Zr).forEach(function(Rr) {
      if (Rr !== "default") {
        var Er = Object.getOwnPropertyDescriptor(Zr, Rr);
        Object.defineProperty(kr, Rr, Er.get ? Er : {
          enumerable: !0,
          get: function() {
            return Zr[Rr];
          }
        });
      }
    }), kr.default = Zr, Object.freeze(kr);
  }
  var t = /* @__PURE__ */ p(A), l = /* @__PURE__ */ p(u);
  const m = s.secp256k1.ProjectivePoint, b = "Expected Private", k = "Expected Point", C = "Expected Tweak", B = "Expected Hash", Q = "Expected Signature", P = "Expected Extra Data (32 bytes)", x = "Expected Scalar", M = "Bad Recovery Id", F = 32, le = 32, ge = new Uint8Array([
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    186,
    174,
    220,
    230,
    175,
    72,
    160,
    59,
    191,
    210,
    94,
    140,
    208,
    54,
    65,
    65
  ]), pe = 32, Ie = new Uint8Array(32), be = new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    69,
    81,
    35,
    25,
    80,
    183,
    95,
    196,
    64,
    45,
    161,
    114,
    47,
    201,
    186,
    238
  ]), Pe = BigInt(1);
  function Te(Zr) {
    return Zr instanceof Uint8Array;
  }
  function Qe(Zr, kr) {
    for (let Rr = 0; Rr < 32; ++Rr)
      if (Zr[Rr] !== kr[Rr])
        return Zr[Rr] < kr[Rr] ? -1 : 1;
    return 0;
  }
  function xe(Zr) {
    return Qe(Zr, Ie) === 0;
  }
  function Ee(Zr) {
    return !(!(Zr instanceof Uint8Array) || Zr.length !== le || Qe(Zr, ge) >= 0);
  }
  function He(Zr) {
    return Zr instanceof Uint8Array && Zr.length === 64 && Qe(Zr.subarray(0, 32), ge) < 0 && Qe(Zr.subarray(32, 64), ge) < 0;
  }
  function ve(Zr) {
    return Te(Zr) && Zr.length === 64 && Qe(Zr.subarray(0, 32), be) < 0;
  }
  function we(Zr) {
    return !(xe(Zr.subarray(0, 32)) || xe(Zr.subarray(32, 64)));
  }
  function Ce(Zr) {
    return Zr instanceof Uint8Array && Zr.length === F;
  }
  function Se(Zr) {
    return Zr === void 0 || Zr instanceof Uint8Array && Zr.length === pe;
  }
  function Ne(Zr) {
    let kr;
    if (typeof Zr == "bigint")
      kr = Zr;
    else if (typeof Zr == "number" && Number.isSafeInteger(Zr) && Zr >= 0)
      kr = BigInt(Zr);
    else if (typeof Zr == "string") {
      if (Zr.length !== 64)
        throw new Error("Expected 32 bytes of private scalar");
      kr = l.hexToNumber(Zr);
    } else if (Zr instanceof Uint8Array) {
      if (Zr.length !== 32)
        throw new Error("Expected 32 bytes of private scalar");
      kr = l.bytesToNumberBE(Zr);
    } else
      throw new TypeError("Expected valid private scalar");
    if (kr < 0) throw new Error("Expected private scalar >= 0");
    return kr;
  }
  function rr(Zr) {
    return s.secp256k1.utils.normPrivateKeyToScalar(Zr);
  }
  function er(Zr, kr) {
    const Rr = rr(Zr), Er = Ne(kr), Or = l.numberToBytesBE(t.mod(Rr + Er, s.secp256k1.CURVE.n), 32);
    return s.secp256k1.utils.isValidPrivateKey(Or) ? Or : null;
  }
  function ir(Zr, kr) {
    const Rr = rr(Zr), Er = Ne(kr), Or = l.numberToBytesBE(t.mod(Rr - Er, s.secp256k1.CURVE.n), 32);
    return s.secp256k1.utils.isValidPrivateKey(Or) ? Or : null;
  }
  function sr(Zr) {
    const kr = rr(Zr), Rr = l.numberToBytesBE(s.secp256k1.CURVE.n - kr, 32);
    return s.secp256k1.utils.isValidPrivateKey(Rr) ? Rr : null;
  }
  function nr(Zr, kr, Rr) {
    const Er = Fr(Zr), Or = Ne(kr), wn = m.BASE.multiplyAndAddUnsafe(Er, Or, Pe);
    if (!wn) throw new Error("Tweaked point at infinity");
    return wn.toRawBytes(Rr);
  }
  function fr(Zr, kr, Rr) {
    const Er = Fr(Zr), Or = typeof kr == "string" ? kr : l.bytesToHex(kr), wn = l.hexToNumber(Or);
    return Er.multiply(wn).toRawBytes(Rr);
  }
  function lr(Zr, kr) {
    return Zr === void 0 ? kr !== void 0 ? Hr(kr) : !0 : !!Zr;
  }
  function br(Zr) {
    try {
      return Zr();
    } catch {
      return null;
    }
  }
  function Br(Zr) {
    return s.schnorr.utils.lift_x(l.bytesToNumberBE(Zr));
  }
  function Fr(Zr) {
    return Zr.length === 32 ? Br(Zr) : m.fromHex(Zr);
  }
  function Gr(Zr, kr) {
    if (Zr.length === 32 !== kr) return !1;
    try {
      return kr ? !!Br(Zr) : !!m.fromHex(Zr);
    } catch {
      return !1;
    }
  }
  function qr(Zr) {
    return Gr(Zr, !1);
  }
  function Hr(Zr) {
    return Gr(Zr, !1) && Zr.length === 33;
  }
  function un(Zr) {
    return s.secp256k1.utils.isValidPrivateKey(Zr);
  }
  function Dr(Zr) {
    return Gr(Zr, !0);
  }
  function wr(Zr, kr) {
    if (!Dr(Zr))
      throw new Error(k);
    if (!Ee(kr))
      throw new Error(C);
    return br(() => {
      const Rr = nr(Zr, kr, !0);
      return { parity: Rr[0] % 2 === 1 ? 1 : 0, xOnlyPubkey: Rr.slice(1) };
    });
  }
  function yr(Zr) {
    if (!qr(Zr))
      throw new Error(k);
    return Zr.slice(1, 33);
  }
  function Qr(Zr, kr) {
    if (!un(Zr))
      throw new Error(b);
    return br(
      () => s.secp256k1.getPublicKey(Zr, lr(kr))
    );
  }
  function _r(Zr) {
    if (!un(Zr))
      throw new Error(b);
    return yr(Qr(Zr));
  }
  function Jr(Zr, kr) {
    if (!qr(Zr))
      throw new Error(k);
    return Fr(Zr).toRawBytes(lr(kr, Zr));
  }
  function fn(Zr, kr, Rr) {
    if (!qr(Zr))
      throw new Error(k);
    if (!Ee(kr))
      throw new Error(C);
    return br(
      () => fr(Zr, kr, lr(Rr, Zr))
    );
  }
  function jr(Zr, kr, Rr) {
    if (!qr(Zr) || !qr(kr))
      throw new Error(k);
    return br(() => {
      const Er = Fr(Zr), Or = Fr(kr);
      return Er.equals(Or.negate()) ? null : Er.add(Or).toRawBytes(lr(Rr, Zr));
    });
  }
  function dn(Zr, kr, Rr) {
    if (!qr(Zr))
      throw new Error(k);
    if (!Ee(kr))
      throw new Error(C);
    return br(
      () => nr(Zr, kr, lr(Rr, Zr))
    );
  }
  function Tn(Zr, kr) {
    if (!un(Zr))
      throw new Error(b);
    if (!Ee(kr))
      throw new Error(C);
    return br(() => er(Zr, kr));
  }
  function Yn(Zr, kr) {
    if (!un(Zr))
      throw new Error(b);
    if (!Ee(kr))
      throw new Error(C);
    return br(() => ir(Zr, kr));
  }
  function si(Zr) {
    if (!un(Zr))
      throw new Error(b);
    return sr(Zr);
  }
  function vn(Zr, kr, Rr) {
    if (!un(kr))
      throw new Error(b);
    if (!Ce(Zr))
      throw new Error(x);
    if (!Se(Rr))
      throw new Error(P);
    return s.secp256k1.sign(Zr, kr, { extraEntropy: Rr }).toCompactRawBytes();
  }
  function Cn(Zr, kr, Rr) {
    if (!un(kr))
      throw new Error(b);
    if (!Ce(Zr))
      throw new Error(x);
    if (!Se(Rr))
      throw new Error(P);
    const Er = s.secp256k1.sign(Zr, kr, { extraEntropy: Rr });
    return {
      signature: Er.toCompactRawBytes(),
      recoveryId: Er.recovery
    };
  }
  function Xr(Zr, kr, Rr) {
    if (!un(kr))
      throw new Error(b);
    if (!Ce(Zr))
      throw new Error(x);
    if (!Se(Rr))
      throw new Error(P);
    return s.schnorr.sign(Zr, kr, Rr);
  }
  function In(Zr, kr, Rr, Er) {
    if (!Ce(Zr))
      throw new Error(B);
    if (!He(kr) || !we(kr))
      throw new Error(Q);
    if (Rr & 2 && !ve(kr))
      throw new Error(M);
    if (!Dr(kr.subarray(0, 32)))
      throw new Error(Q);
    const wn = s.secp256k1.Signature.fromCompact(kr).addRecoveryBit(Rr).recoverPublicKey(Zr);
    if (!wn) throw new Error(Q);
    return wn.toRawBytes(lr(Er));
  }
  function zr(Zr, kr, Rr, Er) {
    if (!qr(kr))
      throw new Error(k);
    if (!He(Rr))
      throw new Error(Q);
    if (!Ce(Zr))
      throw new Error(x);
    return s.secp256k1.verify(Rr, Zr, kr, { lowS: Er });
  }
  function En(Zr, kr, Rr) {
    if (!Dr(kr))
      throw new Error(k);
    if (!He(Rr))
      throw new Error(Q);
    if (!Ce(Zr))
      throw new Error(x);
    return s.schnorr.verify(Rr, Zr, kr);
  }
  return dist$l.isPoint = qr, dist$l.isPointCompressed = Hr, dist$l.isPrivate = un, dist$l.isXOnlyPoint = Dr, dist$l.pointAdd = jr, dist$l.pointAddScalar = dn, dist$l.pointCompress = Jr, dist$l.pointFromScalar = Qr, dist$l.pointMultiply = fn, dist$l.privateAdd = Tn, dist$l.privateNegate = si, dist$l.privateSub = Yn, dist$l.recover = In, dist$l.sign = vn, dist$l.signRecoverable = Cn, dist$l.signSchnorr = Xr, dist$l.verify = zr, dist$l.verifySchnorr = En, dist$l.xOnlyPointAddTweak = wr, dist$l.xOnlyPointFromPoint = yr, dist$l.xOnlyPointFromScalar = _r, dist$l;
}
var distExports$1 = requireDist$l();
const me = /* @__PURE__ */ getDefaultExportFromCjs(distExports$1);
var dist$k = {}, utils$h = {}, stringHelper = {}, commonjsBrowser = {}, v1$2 = {}, rng$3 = {}, hasRequiredRng$1;
function requireRng$1() {
  if (hasRequiredRng$1) return rng$3;
  hasRequiredRng$1 = 1, Object.defineProperty(rng$3, "__esModule", {
    value: !0
  }), rng$3.default = u;
  let s;
  const A = new Uint8Array(16);
  function u() {
    if (!s && (s = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !s))
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return s(A);
  }
  return rng$3;
}
var stringify$3 = {}, validate$3 = {}, regex$1 = {}, hasRequiredRegex$1;
function requireRegex$1() {
  if (hasRequiredRegex$1) return regex$1;
  hasRequiredRegex$1 = 1, Object.defineProperty(regex$1, "__esModule", {
    value: !0
  }), regex$1.default = void 0;
  var s = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
  return regex$1.default = s, regex$1;
}
var hasRequiredValidate$1;
function requireValidate$1() {
  if (hasRequiredValidate$1) return validate$3;
  hasRequiredValidate$1 = 1, Object.defineProperty(validate$3, "__esModule", {
    value: !0
  }), validate$3.default = void 0;
  var s = A(/* @__PURE__ */ requireRegex$1());
  function A(t) {
    return t && t.__esModule ? t : { default: t };
  }
  function u(t) {
    return typeof t == "string" && s.default.test(t);
  }
  var p = u;
  return validate$3.default = p, validate$3;
}
var hasRequiredStringify$1;
function requireStringify$1() {
  if (hasRequiredStringify$1) return stringify$3;
  hasRequiredStringify$1 = 1, Object.defineProperty(stringify$3, "__esModule", {
    value: !0
  }), stringify$3.default = void 0, stringify$3.unsafeStringify = p;
  var s = A(/* @__PURE__ */ requireValidate$1());
  function A(m) {
    return m && m.__esModule ? m : { default: m };
  }
  const u = [];
  for (let m = 0; m < 256; ++m)
    u.push((m + 256).toString(16).slice(1));
  function p(m, b = 0) {
    return u[m[b + 0]] + u[m[b + 1]] + u[m[b + 2]] + u[m[b + 3]] + "-" + u[m[b + 4]] + u[m[b + 5]] + "-" + u[m[b + 6]] + u[m[b + 7]] + "-" + u[m[b + 8]] + u[m[b + 9]] + "-" + u[m[b + 10]] + u[m[b + 11]] + u[m[b + 12]] + u[m[b + 13]] + u[m[b + 14]] + u[m[b + 15]];
  }
  function t(m, b = 0) {
    const k = p(m, b);
    if (!(0, s.default)(k))
      throw TypeError("Stringified UUID is invalid");
    return k;
  }
  var l = t;
  return stringify$3.default = l, stringify$3;
}
var hasRequiredV1$1;
function requireV1$1() {
  if (hasRequiredV1$1) return v1$2;
  hasRequiredV1$1 = 1, Object.defineProperty(v1$2, "__esModule", {
    value: !0
  }), v1$2.default = void 0;
  var s = u(/* @__PURE__ */ requireRng$1()), A = /* @__PURE__ */ requireStringify$1();
  function u(C) {
    return C && C.__esModule ? C : { default: C };
  }
  let p, t, l = 0, m = 0;
  function b(C, B, Q) {
    let P = B && Q || 0;
    const x = B || new Array(16);
    C = C || {};
    let M = C.node || p, F = C.clockseq !== void 0 ? C.clockseq : t;
    if (M == null || F == null) {
      const Pe = C.random || (C.rng || s.default)();
      M == null && (M = p = [Pe[0] | 1, Pe[1], Pe[2], Pe[3], Pe[4], Pe[5]]), F == null && (F = t = (Pe[6] << 8 | Pe[7]) & 16383);
    }
    let le = C.msecs !== void 0 ? C.msecs : Date.now(), ge = C.nsecs !== void 0 ? C.nsecs : m + 1;
    const pe = le - l + (ge - m) / 1e4;
    if (pe < 0 && C.clockseq === void 0 && (F = F + 1 & 16383), (pe < 0 || le > l) && C.nsecs === void 0 && (ge = 0), ge >= 1e4)
      throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    l = le, m = ge, t = F, le += 122192928e5;
    const Ie = ((le & 268435455) * 1e4 + ge) % 4294967296;
    x[P++] = Ie >>> 24 & 255, x[P++] = Ie >>> 16 & 255, x[P++] = Ie >>> 8 & 255, x[P++] = Ie & 255;
    const be = le / 4294967296 * 1e4 & 268435455;
    x[P++] = be >>> 8 & 255, x[P++] = be & 255, x[P++] = be >>> 24 & 15 | 16, x[P++] = be >>> 16 & 255, x[P++] = F >>> 8 | 128, x[P++] = F & 255;
    for (let Pe = 0; Pe < 6; ++Pe)
      x[P + Pe] = M[Pe];
    return B || (0, A.unsafeStringify)(x);
  }
  var k = b;
  return v1$2.default = k, v1$2;
}
var v3$2 = {}, v35$2 = {}, parse$2 = {}, hasRequiredParse$2;
function requireParse$2() {
  if (hasRequiredParse$2) return parse$2;
  hasRequiredParse$2 = 1, Object.defineProperty(parse$2, "__esModule", {
    value: !0
  }), parse$2.default = void 0;
  var s = A(/* @__PURE__ */ requireValidate$1());
  function A(t) {
    return t && t.__esModule ? t : { default: t };
  }
  function u(t) {
    if (!(0, s.default)(t))
      throw TypeError("Invalid UUID");
    let l;
    const m = new Uint8Array(16);
    return m[0] = (l = parseInt(t.slice(0, 8), 16)) >>> 24, m[1] = l >>> 16 & 255, m[2] = l >>> 8 & 255, m[3] = l & 255, m[4] = (l = parseInt(t.slice(9, 13), 16)) >>> 8, m[5] = l & 255, m[6] = (l = parseInt(t.slice(14, 18), 16)) >>> 8, m[7] = l & 255, m[8] = (l = parseInt(t.slice(19, 23), 16)) >>> 8, m[9] = l & 255, m[10] = (l = parseInt(t.slice(24, 36), 16)) / 1099511627776 & 255, m[11] = l / 4294967296 & 255, m[12] = l >>> 24 & 255, m[13] = l >>> 16 & 255, m[14] = l >>> 8 & 255, m[15] = l & 255, m;
  }
  var p = u;
  return parse$2.default = p, parse$2;
}
var hasRequiredV35$1;
function requireV35$1() {
  if (hasRequiredV35$1) return v35$2;
  hasRequiredV35$1 = 1, Object.defineProperty(v35$2, "__esModule", {
    value: !0
  }), v35$2.URL = v35$2.DNS = void 0, v35$2.default = m;
  var s = /* @__PURE__ */ requireStringify$1(), A = u(/* @__PURE__ */ requireParse$2());
  function u(b) {
    return b && b.__esModule ? b : { default: b };
  }
  function p(b) {
    b = unescape(encodeURIComponent(b));
    const k = [];
    for (let C = 0; C < b.length; ++C)
      k.push(b.charCodeAt(C));
    return k;
  }
  const t = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
  v35$2.DNS = t;
  const l = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
  v35$2.URL = l;
  function m(b, k, C) {
    function B(Q, P, x, M) {
      var F;
      if (typeof Q == "string" && (Q = p(Q)), typeof P == "string" && (P = (0, A.default)(P)), ((F = P) === null || F === void 0 ? void 0 : F.length) !== 16)
        throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
      let le = new Uint8Array(16 + Q.length);
      if (le.set(P), le.set(Q, P.length), le = C(le), le[6] = le[6] & 15 | k, le[8] = le[8] & 63 | 128, x) {
        M = M || 0;
        for (let ge = 0; ge < 16; ++ge)
          x[M + ge] = le[ge];
        return x;
      }
      return (0, s.unsafeStringify)(le);
    }
    try {
      B.name = b;
    } catch {
    }
    return B.DNS = t, B.URL = l, B;
  }
  return v35$2;
}
var md5$5 = {}, hasRequiredMd5$3;
function requireMd5$3() {
  if (hasRequiredMd5$3) return md5$5;
  hasRequiredMd5$3 = 1, Object.defineProperty(md5$5, "__esModule", {
    value: !0
  }), md5$5.default = void 0;
  function s(x) {
    if (typeof x == "string") {
      const M = unescape(encodeURIComponent(x));
      x = new Uint8Array(M.length);
      for (let F = 0; F < M.length; ++F)
        x[F] = M.charCodeAt(F);
    }
    return A(p(t(x), x.length * 8));
  }
  function A(x) {
    const M = [], F = x.length * 32, le = "0123456789abcdef";
    for (let ge = 0; ge < F; ge += 8) {
      const pe = x[ge >> 5] >>> ge % 32 & 255, Ie = parseInt(le.charAt(pe >>> 4 & 15) + le.charAt(pe & 15), 16);
      M.push(Ie);
    }
    return M;
  }
  function u(x) {
    return (x + 64 >>> 9 << 4) + 14 + 1;
  }
  function p(x, M) {
    x[M >> 5] |= 128 << M % 32, x[u(M) - 1] = M;
    let F = 1732584193, le = -271733879, ge = -1732584194, pe = 271733878;
    for (let Ie = 0; Ie < x.length; Ie += 16) {
      const be = F, Pe = le, Te = ge, Qe = pe;
      F = k(F, le, ge, pe, x[Ie], 7, -680876936), pe = k(pe, F, le, ge, x[Ie + 1], 12, -389564586), ge = k(ge, pe, F, le, x[Ie + 2], 17, 606105819), le = k(le, ge, pe, F, x[Ie + 3], 22, -1044525330), F = k(F, le, ge, pe, x[Ie + 4], 7, -176418897), pe = k(pe, F, le, ge, x[Ie + 5], 12, 1200080426), ge = k(ge, pe, F, le, x[Ie + 6], 17, -1473231341), le = k(le, ge, pe, F, x[Ie + 7], 22, -45705983), F = k(F, le, ge, pe, x[Ie + 8], 7, 1770035416), pe = k(pe, F, le, ge, x[Ie + 9], 12, -1958414417), ge = k(ge, pe, F, le, x[Ie + 10], 17, -42063), le = k(le, ge, pe, F, x[Ie + 11], 22, -1990404162), F = k(F, le, ge, pe, x[Ie + 12], 7, 1804603682), pe = k(pe, F, le, ge, x[Ie + 13], 12, -40341101), ge = k(ge, pe, F, le, x[Ie + 14], 17, -1502002290), le = k(le, ge, pe, F, x[Ie + 15], 22, 1236535329), F = C(F, le, ge, pe, x[Ie + 1], 5, -165796510), pe = C(pe, F, le, ge, x[Ie + 6], 9, -1069501632), ge = C(ge, pe, F, le, x[Ie + 11], 14, 643717713), le = C(le, ge, pe, F, x[Ie], 20, -373897302), F = C(F, le, ge, pe, x[Ie + 5], 5, -701558691), pe = C(pe, F, le, ge, x[Ie + 10], 9, 38016083), ge = C(ge, pe, F, le, x[Ie + 15], 14, -660478335), le = C(le, ge, pe, F, x[Ie + 4], 20, -405537848), F = C(F, le, ge, pe, x[Ie + 9], 5, 568446438), pe = C(pe, F, le, ge, x[Ie + 14], 9, -1019803690), ge = C(ge, pe, F, le, x[Ie + 3], 14, -187363961), le = C(le, ge, pe, F, x[Ie + 8], 20, 1163531501), F = C(F, le, ge, pe, x[Ie + 13], 5, -1444681467), pe = C(pe, F, le, ge, x[Ie + 2], 9, -51403784), ge = C(ge, pe, F, le, x[Ie + 7], 14, 1735328473), le = C(le, ge, pe, F, x[Ie + 12], 20, -1926607734), F = B(F, le, ge, pe, x[Ie + 5], 4, -378558), pe = B(pe, F, le, ge, x[Ie + 8], 11, -2022574463), ge = B(ge, pe, F, le, x[Ie + 11], 16, 1839030562), le = B(le, ge, pe, F, x[Ie + 14], 23, -35309556), F = B(F, le, ge, pe, x[Ie + 1], 4, -1530992060), pe = B(pe, F, le, ge, x[Ie + 4], 11, 1272893353), ge = B(ge, pe, F, le, x[Ie + 7], 16, -155497632), le = B(le, ge, pe, F, x[Ie + 10], 23, -1094730640), F = B(F, le, ge, pe, x[Ie + 13], 4, 681279174), pe = B(pe, F, le, ge, x[Ie], 11, -358537222), ge = B(ge, pe, F, le, x[Ie + 3], 16, -722521979), le = B(le, ge, pe, F, x[Ie + 6], 23, 76029189), F = B(F, le, ge, pe, x[Ie + 9], 4, -640364487), pe = B(pe, F, le, ge, x[Ie + 12], 11, -421815835), ge = B(ge, pe, F, le, x[Ie + 15], 16, 530742520), le = B(le, ge, pe, F, x[Ie + 2], 23, -995338651), F = Q(F, le, ge, pe, x[Ie], 6, -198630844), pe = Q(pe, F, le, ge, x[Ie + 7], 10, 1126891415), ge = Q(ge, pe, F, le, x[Ie + 14], 15, -1416354905), le = Q(le, ge, pe, F, x[Ie + 5], 21, -57434055), F = Q(F, le, ge, pe, x[Ie + 12], 6, 1700485571), pe = Q(pe, F, le, ge, x[Ie + 3], 10, -1894986606), ge = Q(ge, pe, F, le, x[Ie + 10], 15, -1051523), le = Q(le, ge, pe, F, x[Ie + 1], 21, -2054922799), F = Q(F, le, ge, pe, x[Ie + 8], 6, 1873313359), pe = Q(pe, F, le, ge, x[Ie + 15], 10, -30611744), ge = Q(ge, pe, F, le, x[Ie + 6], 15, -1560198380), le = Q(le, ge, pe, F, x[Ie + 13], 21, 1309151649), F = Q(F, le, ge, pe, x[Ie + 4], 6, -145523070), pe = Q(pe, F, le, ge, x[Ie + 11], 10, -1120210379), ge = Q(ge, pe, F, le, x[Ie + 2], 15, 718787259), le = Q(le, ge, pe, F, x[Ie + 9], 21, -343485551), F = l(F, be), le = l(le, Pe), ge = l(ge, Te), pe = l(pe, Qe);
    }
    return [F, le, ge, pe];
  }
  function t(x) {
    if (x.length === 0)
      return [];
    const M = x.length * 8, F = new Uint32Array(u(M));
    for (let le = 0; le < M; le += 8)
      F[le >> 5] |= (x[le / 8] & 255) << le % 32;
    return F;
  }
  function l(x, M) {
    const F = (x & 65535) + (M & 65535);
    return (x >> 16) + (M >> 16) + (F >> 16) << 16 | F & 65535;
  }
  function m(x, M) {
    return x << M | x >>> 32 - M;
  }
  function b(x, M, F, le, ge, pe) {
    return l(m(l(l(M, x), l(le, pe)), ge), F);
  }
  function k(x, M, F, le, ge, pe, Ie) {
    return b(M & F | ~M & le, x, M, ge, pe, Ie);
  }
  function C(x, M, F, le, ge, pe, Ie) {
    return b(M & le | F & ~le, x, M, ge, pe, Ie);
  }
  function B(x, M, F, le, ge, pe, Ie) {
    return b(M ^ F ^ le, x, M, ge, pe, Ie);
  }
  function Q(x, M, F, le, ge, pe, Ie) {
    return b(F ^ (M | ~le), x, M, ge, pe, Ie);
  }
  var P = s;
  return md5$5.default = P, md5$5;
}
var hasRequiredV3$1;
function requireV3$1() {
  if (hasRequiredV3$1) return v3$2;
  hasRequiredV3$1 = 1, Object.defineProperty(v3$2, "__esModule", {
    value: !0
  }), v3$2.default = void 0;
  var s = u(/* @__PURE__ */ requireV35$1()), A = u(/* @__PURE__ */ requireMd5$3());
  function u(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var t = (0, s.default)("v3", 48, A.default);
  return v3$2.default = t, v3$2;
}
var v4$3 = {}, native$2 = {}, hasRequiredNative$1;
function requireNative$1() {
  if (hasRequiredNative$1) return native$2;
  hasRequiredNative$1 = 1, Object.defineProperty(native$2, "__esModule", {
    value: !0
  }), native$2.default = void 0;
  var A = {
    randomUUID: typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto)
  };
  return native$2.default = A, native$2;
}
var hasRequiredV4$1;
function requireV4$1() {
  if (hasRequiredV4$1) return v4$3;
  hasRequiredV4$1 = 1, Object.defineProperty(v4$3, "__esModule", {
    value: !0
  }), v4$3.default = void 0;
  var s = p(/* @__PURE__ */ requireNative$1()), A = p(/* @__PURE__ */ requireRng$1()), u = /* @__PURE__ */ requireStringify$1();
  function p(m) {
    return m && m.__esModule ? m : { default: m };
  }
  function t(m, b, k) {
    if (s.default.randomUUID && !b && !m)
      return s.default.randomUUID();
    m = m || {};
    const C = m.random || (m.rng || A.default)();
    if (C[6] = C[6] & 15 | 64, C[8] = C[8] & 63 | 128, b) {
      k = k || 0;
      for (let B = 0; B < 16; ++B)
        b[k + B] = C[B];
      return b;
    }
    return (0, u.unsafeStringify)(C);
  }
  var l = t;
  return v4$3.default = l, v4$3;
}
var v5$2 = {}, sha1$4 = {}, hasRequiredSha1$2;
function requireSha1$2() {
  if (hasRequiredSha1$2) return sha1$4;
  hasRequiredSha1$2 = 1, Object.defineProperty(sha1$4, "__esModule", {
    value: !0
  }), sha1$4.default = void 0;
  function s(t, l, m, b) {
    switch (t) {
      case 0:
        return l & m ^ ~l & b;
      case 1:
        return l ^ m ^ b;
      case 2:
        return l & m ^ l & b ^ m & b;
      case 3:
        return l ^ m ^ b;
    }
  }
  function A(t, l) {
    return t << l | t >>> 32 - l;
  }
  function u(t) {
    const l = [1518500249, 1859775393, 2400959708, 3395469782], m = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
    if (typeof t == "string") {
      const B = unescape(encodeURIComponent(t));
      t = [];
      for (let Q = 0; Q < B.length; ++Q)
        t.push(B.charCodeAt(Q));
    } else Array.isArray(t) || (t = Array.prototype.slice.call(t));
    t.push(128);
    const b = t.length / 4 + 2, k = Math.ceil(b / 16), C = new Array(k);
    for (let B = 0; B < k; ++B) {
      const Q = new Uint32Array(16);
      for (let P = 0; P < 16; ++P)
        Q[P] = t[B * 64 + P * 4] << 24 | t[B * 64 + P * 4 + 1] << 16 | t[B * 64 + P * 4 + 2] << 8 | t[B * 64 + P * 4 + 3];
      C[B] = Q;
    }
    C[k - 1][14] = (t.length - 1) * 8 / Math.pow(2, 32), C[k - 1][14] = Math.floor(C[k - 1][14]), C[k - 1][15] = (t.length - 1) * 8 & 4294967295;
    for (let B = 0; B < k; ++B) {
      const Q = new Uint32Array(80);
      for (let ge = 0; ge < 16; ++ge)
        Q[ge] = C[B][ge];
      for (let ge = 16; ge < 80; ++ge)
        Q[ge] = A(Q[ge - 3] ^ Q[ge - 8] ^ Q[ge - 14] ^ Q[ge - 16], 1);
      let P = m[0], x = m[1], M = m[2], F = m[3], le = m[4];
      for (let ge = 0; ge < 80; ++ge) {
        const pe = Math.floor(ge / 20), Ie = A(P, 5) + s(pe, x, M, F) + le + l[pe] + Q[ge] >>> 0;
        le = F, F = M, M = A(x, 30) >>> 0, x = P, P = Ie;
      }
      m[0] = m[0] + P >>> 0, m[1] = m[1] + x >>> 0, m[2] = m[2] + M >>> 0, m[3] = m[3] + F >>> 0, m[4] = m[4] + le >>> 0;
    }
    return [m[0] >> 24 & 255, m[0] >> 16 & 255, m[0] >> 8 & 255, m[0] & 255, m[1] >> 24 & 255, m[1] >> 16 & 255, m[1] >> 8 & 255, m[1] & 255, m[2] >> 24 & 255, m[2] >> 16 & 255, m[2] >> 8 & 255, m[2] & 255, m[3] >> 24 & 255, m[3] >> 16 & 255, m[3] >> 8 & 255, m[3] & 255, m[4] >> 24 & 255, m[4] >> 16 & 255, m[4] >> 8 & 255, m[4] & 255];
  }
  var p = u;
  return sha1$4.default = p, sha1$4;
}
var hasRequiredV5$1;
function requireV5$1() {
  if (hasRequiredV5$1) return v5$2;
  hasRequiredV5$1 = 1, Object.defineProperty(v5$2, "__esModule", {
    value: !0
  }), v5$2.default = void 0;
  var s = u(/* @__PURE__ */ requireV35$1()), A = u(/* @__PURE__ */ requireSha1$2());
  function u(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var t = (0, s.default)("v5", 80, A.default);
  return v5$2.default = t, v5$2;
}
var nil$2 = {}, hasRequiredNil$1;
function requireNil$1() {
  if (hasRequiredNil$1) return nil$2;
  hasRequiredNil$1 = 1, Object.defineProperty(nil$2, "__esModule", {
    value: !0
  }), nil$2.default = void 0;
  var s = "00000000-0000-0000-0000-000000000000";
  return nil$2.default = s, nil$2;
}
var version$8 = {}, hasRequiredVersion$2;
function requireVersion$2() {
  if (hasRequiredVersion$2) return version$8;
  hasRequiredVersion$2 = 1, Object.defineProperty(version$8, "__esModule", {
    value: !0
  }), version$8.default = void 0;
  var s = A(/* @__PURE__ */ requireValidate$1());
  function A(t) {
    return t && t.__esModule ? t : { default: t };
  }
  function u(t) {
    if (!(0, s.default)(t))
      throw TypeError("Invalid UUID");
    return parseInt(t.slice(14, 15), 16);
  }
  var p = u;
  return version$8.default = p, version$8;
}
var hasRequiredCommonjsBrowser;
function requireCommonjsBrowser() {
  return hasRequiredCommonjsBrowser || (hasRequiredCommonjsBrowser = 1, function(s) {
    Object.defineProperty(s, "__esModule", {
      value: !0
    }), Object.defineProperty(s, "NIL", {
      enumerable: !0,
      get: function() {
        return l.default;
      }
    }), Object.defineProperty(s, "parse", {
      enumerable: !0,
      get: function() {
        return C.default;
      }
    }), Object.defineProperty(s, "stringify", {
      enumerable: !0,
      get: function() {
        return k.default;
      }
    }), Object.defineProperty(s, "v1", {
      enumerable: !0,
      get: function() {
        return A.default;
      }
    }), Object.defineProperty(s, "v3", {
      enumerable: !0,
      get: function() {
        return u.default;
      }
    }), Object.defineProperty(s, "v4", {
      enumerable: !0,
      get: function() {
        return p.default;
      }
    }), Object.defineProperty(s, "v5", {
      enumerable: !0,
      get: function() {
        return t.default;
      }
    }), Object.defineProperty(s, "validate", {
      enumerable: !0,
      get: function() {
        return b.default;
      }
    }), Object.defineProperty(s, "version", {
      enumerable: !0,
      get: function() {
        return m.default;
      }
    });
    var A = B(/* @__PURE__ */ requireV1$1()), u = B(/* @__PURE__ */ requireV3$1()), p = B(/* @__PURE__ */ requireV4$1()), t = B(/* @__PURE__ */ requireV5$1()), l = B(/* @__PURE__ */ requireNil$1()), m = B(/* @__PURE__ */ requireVersion$2()), b = B(/* @__PURE__ */ requireValidate$1()), k = B(/* @__PURE__ */ requireStringify$1()), C = B(/* @__PURE__ */ requireParse$2());
    function B(Q) {
      return Q && Q.__esModule ? Q : { default: Q };
    }
  }(commonjsBrowser)), commonjsBrowser;
}
var coin$1 = {}, hasRequiredCoin$1;
function requireCoin$1() {
  if (hasRequiredCoin$1) return coin$1;
  hasRequiredCoin$1 = 1, Object.defineProperty(coin$1, "__esModule", { value: !0 }), coin$1.getCoinSymbol = void 0;
  function s(A) {
    var u;
    return (u = {
      0: "BTC",
      2: "LTC",
      3: "DOGE",
      4: "RDD",
      5: "DASH",
      6: "PPC",
      7: "NMC",
      8: "FTC",
      9: "XCP",
      10: "BLK",
      11: "NSR",
      12: "NBT",
      13: "MZC",
      14: "VIA",
      15: "XCH",
      16: "RBY",
      17: "GRS",
      18: "DGC",
      19: "CCN",
      20: "DGB",
      22: "MONA",
      23: "CLAM",
      24: "XPM",
      25: "NEOS",
      26: "JBS",
      27: "ZRC",
      28: "VTC",
      29: "NXT",
      30: "BURST",
      31: "MUE",
      32: "ZOOM",
      33: "VASH",
      34: "CDN",
      35: "SDC",
      36: "PKB",
      37: "PND",
      38: "START",
      39: "MOIN",
      40: "EXP",
      41: "EMC2",
      42: "DCR",
      43: "XEM",
      44: "PART",
      45: "ARG",
      48: "SHR",
      49: "GCR",
      50: "NVC",
      51: "AC",
      52: "BTCD",
      53: "DOPE",
      54: "TPC",
      55: "AIB",
      56: "EDRC",
      57: "SYS",
      58: "SLR",
      59: "SMLY",
      60: "ETH",
      61: "ETC",
      62: "PSB",
      63: "LDCN",
      65: "XBC",
      66: "IOP",
      67: "NXS",
      68: "INSN",
      69: "OK",
      70: "BRIT",
      71: "CMP",
      72: "CRW",
      73: "BELA",
      74: "ICX",
      75: "FJC",
      76: "MIX",
      77: "XVG",
      78: "EFL",
      79: "CLUB",
      80: "RICHX",
      81: "POT",
      82: "QRK",
      83: "TRC",
      84: "GRC",
      85: "AUR",
      86: "IXC",
      87: "NLG",
      88: "BITB",
      89: "BTA",
      90: "XMY",
      91: "BSD",
      92: "UNO",
      93: "MTR",
      94: "GB",
      95: "SHM",
      96: "CRX",
      97: "BIQ",
      98: "EVO",
      99: "STO",
      100: "BIGUP",
      101: "GAME",
      102: "DLC",
      103: "ZYD",
      104: "DBIC",
      105: "STRAT",
      106: "SH",
      107: "MARS",
      108: "UBQ",
      109: "PTC",
      110: "NRO",
      111: "ARK",
      112: "USC",
      113: "THC",
      114: "LINX",
      115: "ECN",
      116: "DNR",
      117: "PINK",
      118: "ATOM",
      119: "PIVX",
      120: "FLASH",
      121: "ZEN",
      122: "PUT",
      123: "ZNY",
      124: "UNIFY",
      125: "XST",
      126: "BRK",
      127: "VC",
      128: "XMR",
      129: "VOX",
      130: "NAV",
      131: "FCT",
      132: "EC",
      133: "ZEC",
      134: "LSK",
      135: "STEEM",
      136: "XZC",
      137: "RBTC",
      139: "RPT",
      140: "LBC",
      141: "KMD",
      142: "BSQ",
      143: "RIC",
      144: "XRP",
      145: "BCH",
      146: "NEBL",
      147: "ZCL",
      148: "XLM",
      149: "NLC2",
      150: "WHL",
      151: "ERC",
      152: "DMD",
      153: "BTM",
      154: "BIO",
      155: "XWCC",
      156: "BTG",
      157: "BTC2X",
      158: "SSN",
      159: "TOA",
      160: "BTX",
      161: "ACC",
      162: "BCO",
      163: "ELLA",
      164: "PIRL",
      165: "XNO",
      166: "VIVO",
      167: "FRST",
      168: "HNC",
      169: "BUZZ",
      170: "MBRS",
      171: "HC",
      172: "HTML",
      173: "ODN",
      174: "ONX",
      175: "RVN",
      176: "GBX",
      177: "BTCZ",
      178: "POA",
      179: "NYC",
      180: "MXT",
      181: "WC",
      182: "MNX",
      183: "BTCP",
      184: "MUSIC",
      185: "BCA",
      186: "CRAVE",
      187: "STAK",
      188: "WBTC",
      189: "LCH",
      190: "EXCL",
      192: "LCC",
      193: "XFE",
      194: "EOS",
      195: "TRX",
      196: "KOBO",
      197: "HUSH",
      198: "BAN",
      199: "ETF",
      200: "OMNI",
      201: "BIFI",
      202: "UFO",
      203: "CNMC",
      204: "BCN",
      205: "RIN",
      206: "ATP",
      207: "EVT",
      208: "ATN",
      209: "BIS",
      210: "NEET",
      211: "BOPO",
      212: "OOT",
      213: "ALIAS",
      214: "MONK",
      215: "BOXY",
      216: "FLO",
      217: "MEC",
      218: "BTDX",
      219: "XAX",
      220: "ANON",
      221: "LTZ",
      222: "BITG",
      223: "ICP",
      224: "SMART",
      225: "XUEZ",
      226: "HLM",
      227: "WEB",
      228: "ACM",
      229: "NOS",
      230: "BITC",
      231: "HTH",
      232: "TZC",
      233: "VAR",
      234: "IOV",
      235: "FIO",
      236: "BSV",
      237: "DXN",
      238: "QRL",
      239: "PCX",
      240: "LOKI",
      242: "NIM",
      243: "SOV",
      244: "JCT",
      245: "SLP",
      246: "EWT",
      247: "UC",
      248: "EXOS",
      249: "ECA",
      250: "SOOM",
      251: "XRD",
      252: "FREE",
      253: "NPW",
      254: "BST",
      256: "NANO",
      257: "BTCC",
      259: "ZEST",
      260: "ABT",
      261: "PION",
      262: "DT3",
      263: "ZBUX",
      264: "KPL",
      265: "TPAY",
      266: "ZILLA",
      267: "ANK",
      268: "BCC",
      269: "HPB",
      270: "ONE",
      271: "SBC",
      272: "IPC",
      273: "DMTC",
      274: "OGC",
      275: "SHIT",
      276: "ANDES",
      277: "AREPA",
      278: "BOLI",
      279: "RIL",
      280: "HTR",
      281: "FCTID",
      282: "BRAVO",
      283: "ALGO",
      284: "BZX",
      285: "GXX",
      286: "HEAT",
      287: "XDN",
      288: "FSN",
      289: "CPC",
      290: "BOLD",
      291: "IOST",
      292: "TKEY",
      293: "USE",
      294: "BCZ",
      295: "IOC",
      296: "ASF",
      297: "MASS",
      298: "FAIR",
      299: "NUKO",
      300: "GNX",
      301: "DIVI",
      302: "CMT",
      303: "EUNO",
      304: "IOTX",
      305: "ONION",
      306: "8BIT",
      307: "ATC",
      308: "BTS",
      309: "CKB",
      310: "UGAS",
      311: "ADS",
      312: "ARA",
      313: "ZIL",
      314: "MOAC",
      315: "SWTC",
      316: "VNSC",
      317: "PLUG",
      318: "MAN",
      319: "ECC",
      320: "RPD",
      321: "RAP",
      322: "GARD",
      323: "ZER",
      324: "EBST",
      325: "SHARD",
      326: "MRX",
      327: "CMM",
      328: "BLOCK",
      329: "AUDAX",
      330: "LUNA",
      331: "ZPM",
      332: "KUVA",
      333: "MEM",
      334: "CS",
      335: "SWIFT",
      336: "FIX",
      337: "CPC",
      338: "VGO",
      339: "DVT",
      340: "N8V",
      341: "MTNS",
      342: "BLAST",
      343: "DCT",
      344: "AUX",
      345: "USDP",
      346: "HTDF",
      347: "YEC",
      348: "QLC",
      349: "TEA",
      350: "ARW",
      351: "MDM",
      352: "CYB",
      353: "LTO",
      354: "DOT",
      355: "AEON",
      356: "RES",
      357: "AYA",
      358: "DAPS",
      359: "CSC",
      360: "VSYS",
      361: "NOLLAR",
      362: "XNOS",
      363: "CPU",
      364: "LAMB",
      365: "VCT",
      366: "CZR",
      367: "ABBC",
      368: "HET",
      369: "XAS",
      370: "VDL",
      371: "MED",
      372: "ZVC",
      373: "VESTX",
      374: "DBT",
      375: "SEOS",
      376: "MXW",
      377: "ZNZ",
      378: "XCX",
      379: "SOX",
      380: "NYZO",
      381: "ULC",
      382: "RYO",
      383: "KAL",
      384: "XSN",
      385: "DOGEC",
      386: "BMV",
      387: "QBC",
      388: "IMG",
      389: "QOS",
      390: "PKT",
      391: "LHD",
      392: "CENNZ",
      393: "HSN",
      394: "CRO",
      395: "UMBRU",
      396: "EVER",
      397: "NEAR",
      398: "XPC",
      399: "ZOC",
      400: "NIX",
      401: "UC",
      402: "GALI",
      403: "OLT",
      404: "XBI",
      405: "DONU",
      406: "EARTHS",
      407: "HDD",
      408: "SUGAR",
      409: "AILE",
      410: "TENT",
      411: "TAN",
      412: "AIN",
      413: "MSR",
      414: "SUMO",
      415: "ETN",
      416: "BYTZ",
      417: "WOW",
      418: "XTNC",
      419: "LTHN",
      420: "NODE",
      421: "AGM",
      422: "CCX",
      423: "TNET",
      424: "TELOS",
      425: "AION",
      426: "BC",
      427: "KTV",
      428: "ZCR",
      429: "ERG",
      430: "PESO",
      431: "BTC2",
      432: "XRPHD",
      433: "WE",
      434: "KSM",
      435: "PCN",
      436: "NCH",
      437: "ICU",
      438: "LN",
      439: "DTP",
      440: "BTCR",
      441: "AERGO",
      442: "XTH",
      443: "LV",
      444: "PHR",
      445: "VITAE",
      446: "COCOS",
      447: "DIN",
      448: "SPL",
      449: "YCE",
      450: "XLR",
      451: "KTS",
      452: "DGLD",
      453: "XNS",
      454: "EM",
      455: "SHN",
      456: "SEELE",
      457: "AE",
      458: "ODX",
      459: "KAVA",
      460: "GLEEC",
      461: "FIL",
      462: "RUTA",
      463: "CSDT",
      464: "ETI",
      465: "ZSLP",
      466: "ERE",
      467: "DX",
      468: "CPS",
      469: "BTH",
      470: "MESG",
      471: "FIMK",
      472: "AR",
      473: "OGO",
      474: "ROSE",
      475: "BARE",
      476: "GLEEC",
      477: "CLR",
      478: "RNG",
      479: "OLO",
      480: "PEXA",
      481: "MOON",
      482: "OCEAN",
      483: "BNT",
      484: "AMO",
      485: "FCH",
      486: "LAT",
      487: "COIN",
      488: "VEO",
      489: "CCA",
      490: "GFN",
      491: "BIP",
      492: "KPG",
      493: "FIN",
      494: "BAND",
      495: "DROP",
      496: "BHT",
      497: "LYRA",
      498: "CS",
      499: "RUPX",
      500: "THETA",
      501: "SOL",
      502: "THT",
      503: "CFX",
      504: "KUMA",
      505: "HASH",
      506: "CSPR",
      507: "EARTH",
      508: "EGLD",
      509: "CHI",
      510: "KOTO",
      511: "OTC",
      512: "XRD",
      513: "SEELEN",
      514: "AETH",
      515: "DNA",
      516: "VEE",
      517: "SIERRA",
      518: "LET",
      519: "BSC",
      520: "BTCV",
      521: "ABA",
      522: "SCC",
      523: "EDG",
      524: "AMS",
      525: "GOSS",
      526: "BU",
      527: "GRAM",
      528: "YAP",
      529: "SCRT",
      530: "NOVO",
      531: "GHOST",
      532: "HST",
      533: "PRJ",
      534: "YOU",
      535: "XHV",
      536: "BYND",
      537: "JOYS",
      538: "VAL",
      539: "FLOW",
      540: "SMESH",
      541: "SCDO",
      542: "IQS",
      543: "BIND",
      544: "COINEVO",
      545: "SCRIBE",
      546: "HYN",
      547: "BHP",
      548: "BBC",
      549: "MKF",
      550: "XDC",
      551: "STR",
      552: "SUM",
      553: "HBC",
      555: "BCS",
      556: "KTS",
      557: "LKR",
      558: "TAO",
      559: "XWC",
      560: "DEAL",
      561: "NTY",
      562: "TOP",
      564: "AG",
      565: "CICO",
      566: "IRIS",
      567: "NCG",
      568: "LRG",
      569: "SERO",
      570: "BDX",
      571: "CCXX",
      572: "SLS",
      573: "SRM",
      575: "VIVT",
      576: "BPS",
      577: "NKN",
      578: "ICL",
      579: "BONO",
      580: "PLC",
      581: "DUN",
      582: "DMCH",
      583: "CTC",
      584: "KELP",
      585: "GBCR",
      586: "XDAG",
      587: "PRV",
      588: "SCAP",
      589: "TFUEL",
      590: "GTM",
      591: "RNL",
      592: "GRIN",
      593: "MWC",
      594: "DOCK",
      595: "POLYX",
      596: "DIVER",
      597: "XEP",
      598: "APN",
      599: "TFC",
      600: "UTE",
      601: "MTC",
      602: "NC",
      603: "XINY",
      604: "DYN",
      605: "BUFS",
      606: "STOS",
      607: "TON",
      608: "TAFT",
      609: "HYDRA",
      610: "NOR",
      613: "WCN",
      614: "OPT",
      615: "PSWAP",
      616: "VAL",
      617: "XOR",
      618: "SSP",
      619: "DEI",
      621: "ZERO",
      622: "ALPHA",
      623: "BDECO",
      624: "NOBL",
      625: "EAST",
      626: "KDA",
      627: "SOUL",
      628: "LORE",
      629: "FNR",
      630: "NEXUS",
      631: "QTZ",
      632: "XMA",
      633: "CALL",
      634: "VAL",
      635: "POKT",
      636: "EMIT",
      637: "APTOS",
      638: "ADON",
      639: "BTSG",
      640: "LFC",
      641: "KCS",
      642: "KCC",
      643: "AZERO",
      644: "TREE",
      645: "LX",
      646: "XLN",
      647: "CIC",
      648: "ZRB",
      650: "UCO",
      651: "SFX",
      652: "SFT",
      653: "WSFX",
      654: "USDG",
      655: "WMP",
      659: "KOIN",
      660: "PIRATE",
      663: "SFRX",
      666: "ACT",
      667: "PRKL",
      668: "SSC",
      669: "GC",
      670: "PLGR",
      671: "MPLGR",
      672: "KNOX",
      673: "ZED",
      674: "CNDL",
      675: "WLKR",
      676: "WLKRR",
      677: "YUNGE",
      678: "Voken",
      679: "APL",
      680: "Evrynet",
      681: "NENG",
      682: "CHTA",
      685: "OAS",
      686: "KAR",
      688: "CET",
      690: "KLV",
      694: "VTBC",
      698: "VEIL",
      699: "GTB",
      700: "XDAI",
      701: "COM",
      702: "CCC",
      707: "MCOIN",
      711: "CHC",
      712: "SERF",
      713: "XTL",
      714: "BNB",
      715: "SIN",
      716: "DLN",
      717: "BONTE",
      718: "PEER",
      725: "MCX",
      730: "HEALIOS",
      731: "BMK",
      734: "DENTX",
      737: "ATOP",
      747: "CFG",
      750: "XPRT",
      757: "HONEY",
      768: "BALLZ",
      770: "COSA",
      771: "BR",
      775: "PLSR",
      776: "KEY",
      777: "BTW",
      780: "PLCUC",
      781: "PLCUX",
      782: "PLCU",
      784: "SUI",
      786: "UIDD",
      787: "ACA",
      788: "BNC",
      789: "TAU",
      799: "PDEX",
      800: "BEET",
      801: "DST",
      804: "ZKS",
      808: "QVT",
      809: "SDN",
      810: "ASTR",
      813: "MEER",
      818: "VET",
      819: "REEF",
      820: "CLO",
      822: "BDB",
      827: "ACE",
      828: "CCN",
      831: "CRUZ",
      832: "SAPP",
      833: "777",
      834: "KYAN",
      835: "AZR",
      836: "CFL",
      837: "DASHD",
      838: "TRTT",
      839: "UCR",
      840: "PNY",
      841: "BECN",
      842: "MONK",
      843: "SAGA",
      844: "SUV",
      845: "ESK",
      846: "OWO",
      847: "PEPS",
      848: "BIR",
      849: "MOBIC",
      850: "FLS",
      852: "DSM",
      853: "PRCY",
      858: "HVH",
      866: "MOB",
      868: "IF",
      877: "NAM",
      880: "LUM",
      883: "ZBC",
      886: "ADF",
      888: "NEO",
      889: "TOMO",
      890: "XSEL",
      896: "LKSC",
      898: "AS",
      899: "XEC",
      900: "LMO",
      901: "NXT",
      904: "HNT",
      907: "FIS",
      909: "SGE",
      911: "GERT",
      916: "META",
      917: "FRA",
      919: "CCD",
      921: "AVN",
      925: "DIP",
      928: "GHM",
      931: "RUNE",
      945: "UNLOCK",
      955: "LTP",
      960: "VKAX",
      966: "MATIC",
      968: "UNW",
      970: "TWINS",
      977: "TLOS",
      981: "TAFECO",
      985: "AU",
      987: "VCG",
      988: "XAZAB",
      989: "AIOZ",
      990: "CORE",
      991: "PEC",
      992: "UNT",
      993: "XRB",
      994: "QUAI",
      995: "CAPS",
      996: "OKT",
      997: "SUM",
      998: "LBTC",
      999: "BCD",
      1e3: "BTN",
      1001: "TT",
      1002: "BKT",
      1003: "NODL",
      1004: "PCOIN",
      1005: "TAO",
      1006: "HSK",
      1007: "FTM",
      1008: "RPG",
      1010: "HT",
      1011: "ELV",
      1013: "BIC",
      1020: "EVC",
      1022: "XRD",
      1023: "ONE",
      1024: "ONT",
      1025: "CZZ",
      1026: "KEX",
      1027: "MCM",
      1032: "BTCR",
      1042: "MFID",
      1111: "BBC",
      1120: "RISE",
      1122: "CMT",
      1128: "ETSC",
      1129: "DFI",
      1130: "DFI",
      1137: "$DAG",
      1145: "CDY",
      1155: "EFI",
      1170: "HOO",
      1234: "ALPH",
      1284: "GLMR",
      1285: "MOVR",
      1298: "WPC",
      1308: "WEI",
      1337: "DFC",
      1397: "HYC",
      1410: "TENTSLP",
      1510: "XSC",
      1512: "AAC",
      1533: "BEAM",
      1555: "APC",
      1616: "ELF",
      1618: "AUDL",
      1620: "ATH",
      1627: "LUME",
      1642: "NEW",
      1657: "BTA",
      1668: "NEOX",
      1669: "MEWC",
      1688: "BCX",
      1729: "XTZ",
      1776: "LBTC",
      1777: "BBP",
      1784: "JPYS",
      1789: "VEGA",
      1815: "ADA",
      1818: "CUBE",
      1856: "TES",
      1888: "ZTX",
      1899: "XEC",
      1901: "CLC",
      1919: "VIPS",
      1926: "CITY",
      1955: "XX",
      1977: "XMX",
      1984: "TRTL",
      1985: "SLRT",
      1986: "QTH",
      1987: "EGEM",
      1988: "MIRA",
      1989: "HODL",
      1990: "PHL",
      1991: "SC",
      1996: "MYT",
      1997: "POLIS",
      1998: "XMCC",
      1999: "COLX",
      2e3: "GIN",
      2001: "MNP",
      2002: "MLN",
      2017: "KIN",
      2018: "EOSC",
      2019: "GBT",
      2020: "PKC",
      2021: "SKT",
      2022: "XHT",
      2048: "MCASH",
      2049: "TRUE",
      2086: "KILT",
      2109: "SAMA",
      2112: "IoTE",
      2137: "XRG",
      2182: "CHZ",
      2221: "ASK",
      2301: "QTUM",
      2302: "ETP",
      2303: "GXC",
      2304: "CRP",
      2305: "ELA",
      2338: "SNOW",
      2365: "XIN",
      2570: "AOA",
      2718: "NAS",
      2894: "REOSC",
      2941: "BND",
      3003: "LUX",
      3030: "HBAR",
      3077: "COS",
      3276: "CCC",
      3333: "SXP",
      3377: "ROI",
      3381: "DYN",
      3383: "SEQ",
      3552: "DEO",
      3564: "DST",
      3601: "CY",
      4040: "FC8",
      4096: "YEE",
      4218: "IOTA",
      4219: "SMR",
      4242: "AXE",
      4343: "XYM",
      4444: "C4E",
      4919: "XVM",
      5006: "SBC",
      5248: "FIC",
      5353: "HNS",
      5404: "ISK",
      5467: "ALTME",
      5555: "FUND",
      5757: "STX",
      5895: "VOW",
      5920: "SLU",
      6060: "GO",
      6174: "MOI",
      6599: "RSC",
      6666: "BPA",
      6688: "SAFE",
      6779: "COTI",
      6969: "ROGER",
      7091: "TOPL",
      7331: "KLY",
      7341: "SHFT",
      7777: "BTV",
      8e3: "SKY",
      8192: "PAC",
      8217: "KLAY",
      8339: "BTQ",
      8444: "XCH",
      8680: "PLMNT",
      8888: "SBTC",
      8964: "NULS",
      8997: "BBC",
      8998: "JGC",
      8999: "BTP",
      9e3: "AVAX",
      9001: "ARB1",
      9002: "BOBA",
      9003: "LOOP",
      9004: "STRK",
      9005: "AVAXC",
      9006: "BSC",
      9797: "NRG",
      9888: "BTF",
      9999: "GOD",
      1e4: "FO",
      10226: "RTM",
      10291: "XRC",
      10605: "XPI",
      11111: "ESS",
      12345: "IPOS",
      12586: "MINA",
      13107: "BTY",
      13108: "YCC",
      14001: "WAX",
      15845: "SDGO",
      16181: "XTX",
      16754: "ARDR",
      18e3: "MTR",
      19165: "SAFE",
      19167: "FLUX",
      19169: "RITO",
      20036: "XND",
      21004: "C4EI",
      21888: "PCT",
      22504: "PWR",
      25252: "BELL",
      25718: "CHX",
      29223: "NEXA",
      31102: "ESN",
      33416: "TEO",
      33878: "BTCS",
      34952: "BTT",
      37992: "FXTC",
      39321: "AMA",
      42069: "FACT",
      43028: "AXIV",
      49262: "EVE",
      49344: "STASH",
      52752: "CELO",
      61616: "TH",
      65536: "KETH",
      69420: "GRLC",
      70007: "GWL",
      77777: "ZYN",
      88888: "RYO",
      99999: "WICC",
      100500: "HOME",
      101010: "STC",
      105105: "STRAX",
      111111: "KAS",
      161803: "APTA",
      200625: "AKA",
      200665: "GENOM",
      246529: "ATS",
      261131: "ZAMA",
      314159: "PI",
      333332: "VALUE",
      333333: "3333",
      424242: "X42",
      534352: "SCR",
      666666: "VITE",
      888888: "SEA",
      1048576: "AMAX",
      1171337: "ILT",
      1313114: "ETHO",
      1313500: "XERO",
      1712144: "LAX",
      3924011: "EPK",
      4741444: "HYD",
      5249353: "BCO",
      5249354: "BHD",
      5264462: "PTN",
      5655640: "VLX",
      5718350: "WAN",
      5741564: "WAVES",
      5741565: "WEST",
      6382179: "ABC",
      6517357: "CRM",
      7562605: "SEM",
      7567736: "ION",
      7777777: "FCT",
      7825266: "WGR",
      7825267: "OBSR",
      8163271: "AFS",
      15118976: "XDS",
      61717561: "AQUA",
      88888888: "HATCH",
      91927009: "kUSD",
      99999996: "GENS",
      99999997: "EQ",
      99999998: "FLUID",
      99999999: "QKC",
      608589380: "FVDC"
    }[A]) !== null && u !== void 0 ? u : "";
  }
  return coin$1.getCoinSymbol = s, coin$1;
}
var hasRequiredStringHelper;
function requireStringHelper() {
  return hasRequiredStringHelper || (hasRequiredStringHelper = 1, function(s) {
    var A = stringHelper && stringHelper.__createBinding || (Object.create ? function(Q, P, x, M) {
      M === void 0 && (M = x);
      var F = Object.getOwnPropertyDescriptor(P, x);
      (!F || ("get" in F ? !P.__esModule : F.writable || F.configurable)) && (F = { enumerable: !0, get: function() {
        return P[x];
      } }), Object.defineProperty(Q, M, F);
    } : function(Q, P, x, M) {
      M === void 0 && (M = x), Q[M] = P[x];
    }), u = stringHelper && stringHelper.__setModuleDefault || (Object.create ? function(Q, P) {
      Object.defineProperty(Q, "default", { enumerable: !0, value: P });
    } : function(Q, P) {
      Q.default = P;
    }), p = stringHelper && stringHelper.__importStar || function(Q) {
      if (Q && Q.__esModule) return Q;
      var P = {};
      if (Q != null) for (var x in Q) x !== "default" && Object.prototype.hasOwnProperty.call(Q, x) && A(P, Q, x);
      return u(P, Q), P;
    }, t = stringHelper && stringHelper.__exportStar || function(Q, P) {
      for (var x in Q) x !== "default" && !Object.prototype.hasOwnProperty.call(P, x) && A(P, Q, x);
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), s.parsePath = s.uuidStringify = s.uuidParse = s.toBuffer = s.toHex = s.uuid = void 0;
    const l = p(/* @__PURE__ */ requireCommonjsBrowser());
    s.uuid = l, t(requireCoin$1(), s);
    function m(Q) {
      return Q === void 0 ? "" : Buffer.from(Q).toString("hex");
    }
    s.toHex = m;
    function b(Q) {
      return Buffer.from(Q ?? "", "hex");
    }
    s.toBuffer = b;
    function k(Q) {
      return Buffer.from(l.parse(Q));
    }
    s.uuidParse = k;
    function C(Q) {
      return l.stringify(Q);
    }
    s.uuidStringify = C;
    function B(Q) {
      return Q.replace(/^m\//i, "").split("/").map((x) => {
        const M = x.endsWith("'");
        return {
          index: Number(M ? x.substring(0, x.length - 1) : x),
          hardened: M
        };
      });
    }
    s.parsePath = B;
  }(stringHelper)), stringHelper;
}
var crypto$5 = {}, dist$j = {}, extendStatics = function(s, A) {
  return extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, p) {
    u.__proto__ = p;
  } || function(u, p) {
    for (var t in p) Object.prototype.hasOwnProperty.call(p, t) && (u[t] = p[t]);
  }, extendStatics(s, A);
};
function __extends(s, A) {
  if (typeof A != "function" && A !== null)
    throw new TypeError("Class extends value " + String(A) + " is not a constructor or null");
  extendStatics(s, A);
  function u() {
    this.constructor = s;
  }
  s.prototype = A === null ? Object.create(A) : (u.prototype = A.prototype, new u());
}
var __assign = function() {
  return __assign = Object.assign || function(A) {
    for (var u, p = 1, t = arguments.length; p < t; p++) {
      u = arguments[p];
      for (var l in u) Object.prototype.hasOwnProperty.call(u, l) && (A[l] = u[l]);
    }
    return A;
  }, __assign.apply(this, arguments);
};
function __rest(s, A) {
  var u = {};
  for (var p in s) Object.prototype.hasOwnProperty.call(s, p) && A.indexOf(p) < 0 && (u[p] = s[p]);
  if (s != null && typeof Object.getOwnPropertySymbols == "function")
    for (var t = 0, p = Object.getOwnPropertySymbols(s); t < p.length; t++)
      A.indexOf(p[t]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[t]) && (u[p[t]] = s[p[t]]);
  return u;
}
function __decorate(s, A, u, p) {
  var t = arguments.length, l = t < 3 ? A : p === null ? p = Object.getOwnPropertyDescriptor(A, u) : p, m;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") l = Reflect.decorate(s, A, u, p);
  else for (var b = s.length - 1; b >= 0; b--) (m = s[b]) && (l = (t < 3 ? m(l) : t > 3 ? m(A, u, l) : m(A, u)) || l);
  return t > 3 && l && Object.defineProperty(A, u, l), l;
}
function __param(s, A) {
  return function(u, p) {
    A(u, p, s);
  };
}
function __esDecorate(s, A, u, p, t, l) {
  function m(ge) {
    if (ge !== void 0 && typeof ge != "function") throw new TypeError("Function expected");
    return ge;
  }
  for (var b = p.kind, k = b === "getter" ? "get" : b === "setter" ? "set" : "value", C = !A && s ? p.static ? s : s.prototype : null, B = A || (C ? Object.getOwnPropertyDescriptor(C, p.name) : {}), Q, P = !1, x = u.length - 1; x >= 0; x--) {
    var M = {};
    for (var F in p) M[F] = F === "access" ? {} : p[F];
    for (var F in p.access) M.access[F] = p.access[F];
    M.addInitializer = function(ge) {
      if (P) throw new TypeError("Cannot add initializers after decoration has completed");
      l.push(m(ge || null));
    };
    var le = (0, u[x])(b === "accessor" ? { get: B.get, set: B.set } : B[k], M);
    if (b === "accessor") {
      if (le === void 0) continue;
      if (le === null || typeof le != "object") throw new TypeError("Object expected");
      (Q = m(le.get)) && (B.get = Q), (Q = m(le.set)) && (B.set = Q), (Q = m(le.init)) && t.unshift(Q);
    } else (Q = m(le)) && (b === "field" ? t.unshift(Q) : B[k] = Q);
  }
  C && Object.defineProperty(C, p.name, B), P = !0;
}
function __runInitializers(s, A, u) {
  for (var p = arguments.length > 2, t = 0; t < A.length; t++)
    u = p ? A[t].call(s, u) : A[t].call(s);
  return p ? u : void 0;
}
function __propKey(s) {
  return typeof s == "symbol" ? s : "".concat(s);
}
function __setFunctionName(s, A, u) {
  return typeof A == "symbol" && (A = A.description ? "[".concat(A.description, "]") : ""), Object.defineProperty(s, "name", { configurable: !0, value: u ? "".concat(u, " ", A) : A });
}
function __metadata(s, A) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(s, A);
}
function __awaiter$1(s, A, u, p) {
  function t(l) {
    return l instanceof u ? l : new u(function(m) {
      m(l);
    });
  }
  return new (u || (u = Promise))(function(l, m) {
    function b(B) {
      try {
        C(p.next(B));
      } catch (Q) {
        m(Q);
      }
    }
    function k(B) {
      try {
        C(p.throw(B));
      } catch (Q) {
        m(Q);
      }
    }
    function C(B) {
      B.done ? l(B.value) : t(B.value).then(b, k);
    }
    C((p = p.apply(s, A || [])).next());
  });
}
function __generator(s, A) {
  var u = { label: 0, sent: function() {
    if (l[0] & 1) throw l[1];
    return l[1];
  }, trys: [], ops: [] }, p, t, l, m = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return m.next = b(0), m.throw = b(1), m.return = b(2), typeof Symbol == "function" && (m[Symbol.iterator] = function() {
    return this;
  }), m;
  function b(C) {
    return function(B) {
      return k([C, B]);
    };
  }
  function k(C) {
    if (p) throw new TypeError("Generator is already executing.");
    for (; m && (m = 0, C[0] && (u = 0)), u; ) try {
      if (p = 1, t && (l = C[0] & 2 ? t.return : C[0] ? t.throw || ((l = t.return) && l.call(t), 0) : t.next) && !(l = l.call(t, C[1])).done) return l;
      switch (t = 0, l && (C = [C[0] & 2, l.value]), C[0]) {
        case 0:
        case 1:
          l = C;
          break;
        case 4:
          return u.label++, { value: C[1], done: !1 };
        case 5:
          u.label++, t = C[1], C = [0];
          continue;
        case 7:
          C = u.ops.pop(), u.trys.pop();
          continue;
        default:
          if (l = u.trys, !(l = l.length > 0 && l[l.length - 1]) && (C[0] === 6 || C[0] === 2)) {
            u = 0;
            continue;
          }
          if (C[0] === 3 && (!l || C[1] > l[0] && C[1] < l[3])) {
            u.label = C[1];
            break;
          }
          if (C[0] === 6 && u.label < l[1]) {
            u.label = l[1], l = C;
            break;
          }
          if (l && u.label < l[2]) {
            u.label = l[2], u.ops.push(C);
            break;
          }
          l[2] && u.ops.pop(), u.trys.pop();
          continue;
      }
      C = A.call(s, u);
    } catch (B) {
      C = [6, B], t = 0;
    } finally {
      p = l = 0;
    }
    if (C[0] & 5) throw C[1];
    return { value: C[0] ? C[1] : void 0, done: !0 };
  }
}
var __createBinding = Object.create ? function(s, A, u, p) {
  p === void 0 && (p = u);
  var t = Object.getOwnPropertyDescriptor(A, u);
  (!t || ("get" in t ? !A.__esModule : t.writable || t.configurable)) && (t = { enumerable: !0, get: function() {
    return A[u];
  } }), Object.defineProperty(s, p, t);
} : function(s, A, u, p) {
  p === void 0 && (p = u), s[p] = A[u];
};
function __exportStar(s, A) {
  for (var u in s) u !== "default" && !Object.prototype.hasOwnProperty.call(A, u) && __createBinding(A, s, u);
}
function __values$1(s) {
  var A = typeof Symbol == "function" && Symbol.iterator, u = A && s[A], p = 0;
  if (u) return u.call(s);
  if (s && typeof s.length == "number") return {
    next: function() {
      return s && p >= s.length && (s = void 0), { value: s && s[p++], done: !s };
    }
  };
  throw new TypeError(A ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(s, A) {
  var u = typeof Symbol == "function" && s[Symbol.iterator];
  if (!u) return s;
  var p = u.call(s), t, l = [], m;
  try {
    for (; (A === void 0 || A-- > 0) && !(t = p.next()).done; ) l.push(t.value);
  } catch (b) {
    m = { error: b };
  } finally {
    try {
      t && !t.done && (u = p.return) && u.call(p);
    } finally {
      if (m) throw m.error;
    }
  }
  return l;
}
function __spread() {
  for (var s = [], A = 0; A < arguments.length; A++)
    s = s.concat(__read(arguments[A]));
  return s;
}
function __spreadArrays() {
  for (var s = 0, A = 0, u = arguments.length; A < u; A++) s += arguments[A].length;
  for (var p = Array(s), t = 0, A = 0; A < u; A++)
    for (var l = arguments[A], m = 0, b = l.length; m < b; m++, t++)
      p[t] = l[m];
  return p;
}
function __spreadArray(s, A, u) {
  if (u || arguments.length === 2) for (var p = 0, t = A.length, l; p < t; p++)
    (l || !(p in A)) && (l || (l = Array.prototype.slice.call(A, 0, p)), l[p] = A[p]);
  return s.concat(l || Array.prototype.slice.call(A));
}
function __await(s) {
  return this instanceof __await ? (this.v = s, this) : new __await(s);
}
function __asyncGenerator(s, A, u) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var p = u.apply(s, A || []), t, l = [];
  return t = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), b("next"), b("throw"), b("return", m), t[Symbol.asyncIterator] = function() {
    return this;
  }, t;
  function m(x) {
    return function(M) {
      return Promise.resolve(M).then(x, Q);
    };
  }
  function b(x, M) {
    p[x] && (t[x] = function(F) {
      return new Promise(function(le, ge) {
        l.push([x, F, le, ge]) > 1 || k(x, F);
      });
    }, M && (t[x] = M(t[x])));
  }
  function k(x, M) {
    try {
      C(p[x](M));
    } catch (F) {
      P(l[0][3], F);
    }
  }
  function C(x) {
    x.value instanceof __await ? Promise.resolve(x.value.v).then(B, Q) : P(l[0][2], x);
  }
  function B(x) {
    k("next", x);
  }
  function Q(x) {
    k("throw", x);
  }
  function P(x, M) {
    x(M), l.shift(), l.length && k(l[0][0], l[0][1]);
  }
}
function __asyncDelegator(s) {
  var A, u;
  return A = {}, p("next"), p("throw", function(t) {
    throw t;
  }), p("return"), A[Symbol.iterator] = function() {
    return this;
  }, A;
  function p(t, l) {
    A[t] = s[t] ? function(m) {
      return (u = !u) ? { value: __await(s[t](m)), done: !1 } : l ? l(m) : m;
    } : l;
  }
}
function __asyncValues(s) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var A = s[Symbol.asyncIterator], u;
  return A ? A.call(s) : (s = typeof __values$1 == "function" ? __values$1(s) : s[Symbol.iterator](), u = {}, p("next"), p("throw"), p("return"), u[Symbol.asyncIterator] = function() {
    return this;
  }, u);
  function p(l) {
    u[l] = s[l] && function(m) {
      return new Promise(function(b, k) {
        m = s[l](m), t(b, k, m.done, m.value);
      });
    };
  }
  function t(l, m, b, k) {
    Promise.resolve(k).then(function(C) {
      l({ value: C, done: b });
    }, m);
  }
}
function __makeTemplateObject(s, A) {
  return Object.defineProperty ? Object.defineProperty(s, "raw", { value: A }) : s.raw = A, s;
}
var __setModuleDefault = Object.create ? function(s, A) {
  Object.defineProperty(s, "default", { enumerable: !0, value: A });
} : function(s, A) {
  s.default = A;
}, ownKeys = function(s) {
  return ownKeys = Object.getOwnPropertyNames || function(A) {
    var u = [];
    for (var p in A) Object.prototype.hasOwnProperty.call(A, p) && (u[u.length] = p);
    return u;
  }, ownKeys(s);
};
function __importStar(s) {
  if (s && s.__esModule) return s;
  var A = {};
  if (s != null) for (var u = ownKeys(s), p = 0; p < u.length; p++) u[p] !== "default" && __createBinding(A, s, u[p]);
  return __setModuleDefault(A, s), A;
}
function __importDefault(s) {
  return s && s.__esModule ? s : { default: s };
}
function __classPrivateFieldGet$1(s, A, u, p) {
  if (u === "a" && !p) throw new TypeError("Private accessor was defined without a getter");
  if (typeof A == "function" ? s !== A || !p : !A.has(s)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return u === "m" ? p : u === "a" ? p.call(s) : p ? p.value : A.get(s);
}
function __classPrivateFieldSet(s, A, u, p, t) {
  if (p === "m") throw new TypeError("Private method is not writable");
  if (p === "a" && !t) throw new TypeError("Private accessor was defined without a setter");
  if (typeof A == "function" ? s !== A || !t : !A.has(s)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return p === "a" ? t.call(s, u) : t ? t.value = u : A.set(s, u), u;
}
function __classPrivateFieldIn(s, A) {
  if (A === null || typeof A != "object" && typeof A != "function") throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof s == "function" ? A === s : s.has(A);
}
function __addDisposableResource(s, A, u) {
  if (A != null) {
    if (typeof A != "object" && typeof A != "function") throw new TypeError("Object expected.");
    var p, t;
    if (u) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      p = A[Symbol.asyncDispose];
    }
    if (p === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      p = A[Symbol.dispose], u && (t = p);
    }
    if (typeof p != "function") throw new TypeError("Object not disposable.");
    t && (p = function() {
      try {
        t.call(this);
      } catch (l) {
        return Promise.reject(l);
      }
    }), s.stack.push({ value: A, dispose: p, async: u });
  } else u && s.stack.push({ async: !0 });
  return A;
}
var _SuppressedError = typeof SuppressedError == "function" ? SuppressedError : function(s, A, u) {
  var p = new Error(u);
  return p.name = "SuppressedError", p.error = s, p.suppressed = A, p;
};
function __disposeResources(s) {
  function A(l) {
    s.error = s.hasError ? new _SuppressedError(l, s.error, "An error was suppressed during disposal.") : l, s.hasError = !0;
  }
  var u, p = 0;
  function t() {
    for (; u = s.stack.pop(); )
      try {
        if (!u.async && p === 1) return p = 0, s.stack.push(u), Promise.resolve().then(t);
        if (u.dispose) {
          var l = u.dispose.call(u.value);
          if (u.async) return p |= 2, Promise.resolve(l).then(t, function(m) {
            return A(m), t();
          });
        } else p |= 1;
      } catch (m) {
        A(m);
      }
    if (p === 1) return s.hasError ? Promise.reject(s.error) : Promise.resolve();
    if (s.hasError) throw s.error;
  }
  return t();
}
function __rewriteRelativeImportExtension(s, A) {
  return typeof s == "string" && /^\.\.?\//.test(s) ? s.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(u, p, t, l, m) {
    return p ? A ? ".jsx" : ".js" : t && (!l || !m) ? u : t + l + "." + m.toLowerCase() + "js";
  }) : s;
}
const tslib_es6 = {
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter: __awaiter$1,
  __generator,
  __createBinding,
  __exportStar,
  __values: __values$1,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet: __classPrivateFieldGet$1,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension
}, tslib_es6$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __addDisposableResource,
  get __assign() {
    return __assign;
  },
  __asyncDelegator,
  __asyncGenerator,
  __asyncValues,
  __await,
  __awaiter: __awaiter$1,
  __classPrivateFieldGet: __classPrivateFieldGet$1,
  __classPrivateFieldIn,
  __classPrivateFieldSet,
  __createBinding,
  __decorate,
  __disposeResources,
  __esDecorate,
  __exportStar,
  __extends,
  __generator,
  __importDefault,
  __importStar,
  __makeTemplateObject,
  __metadata,
  __param,
  __propKey,
  __read,
  __rest,
  __rewriteRelativeImportExtension,
  __runInitializers,
  __setFunctionName,
  __spread,
  __spreadArray,
  __spreadArrays,
  __values: __values$1,
  default: tslib_es6
}, Symbol.toStringTag, { value: "Module" })), require$$0$2 = /* @__PURE__ */ getAugmentedNamespace(tslib_es6$1);
var patchCBOR$1 = {}, utils$g = {}, lib$7 = {}, cborSync$3 = { exports: {} }, DataItem$1 = {}, hasRequiredDataItem$1;
function requireDataItem$1() {
  if (hasRequiredDataItem$1) return DataItem$1;
  hasRequiredDataItem$1 = 1, Object.defineProperty(DataItem$1, "__esModule", { value: !0 }), DataItem$1.DataItem = void 0;
  class s {
    constructor(u, p) {
      this.setTag = (t) => {
        this.tag = t;
      }, this.clearTag = () => {
        this.tag = void 0;
      }, this.getTag = () => this.tag, this.getData = () => this.data, this.data = u, this.tag = p;
    }
  }
  return DataItem$1.DataItem = s, DataItem$1;
}
var cborSync$2 = cborSync$3.exports, hasRequiredCborSync$1;
function requireCborSync$1() {
  return hasRequiredCborSync$1 || (hasRequiredCborSync$1 = 1, function(s) {
    (function(A, u) {
      s.exports ? s.exports = u() : A.CBOR = u();
    })(cborSync$2, function() {
      const { DataItem: A } = requireDataItem$1();
      var u = function() {
        function p(Qe) {
          this.$hex = Qe;
        }
        p.prototype = {
          length: function() {
            return this.$hex.length / 2;
          },
          toString: function(Qe) {
            if (!Qe || Qe === "hex" || Qe === 16)
              return this.$hex;
            if (Qe === "utf-8") {
              for (var xe = "", Ee = 0; Ee < this.$hex.length; Ee += 2)
                xe += "%" + this.$hex.substring(Ee, Ee + 2);
              return decodeURIComponent(xe);
            }
            if (Qe === "latin") {
              for (var xe = [], Ee = 0; Ee < this.$hex.length; Ee += 2)
                xe.push(parseInt(this.$hex.substring(Ee, Ee + 2), 16));
              return String.fromCharCode.apply(String, xe);
            }
            throw new Error("Unrecognised format: " + Qe);
          }
        }, p.fromLatinString = function(Qe) {
          for (var xe = "", Ee = 0; Ee < Qe.length; Ee++) {
            var He = Qe.charCodeAt(Ee).toString(16);
            He.length === 1 && (He = "0" + He), xe += He;
          }
          return new p(xe);
        }, p.fromUtf8String = function(Qe) {
          for (var xe = encodeURIComponent(Qe), Ee = "", He = 0; He < xe.length; He++)
            if (xe.charAt(He) === "%")
              Ee += xe.substring(He + 1, He + 3), He += 2;
            else {
              var ve = xe.charCodeAt(He).toString(16);
              ve.length < 2 && (ve = "0" + ve), Ee += ve;
            }
          return new p(Ee);
        };
        var t = [], l = {}, m = function(Qe) {
          return function() {
            throw new Error(Qe + " not implemented");
          };
        };
        function b() {
        }
        b.prototype = {
          peekByte: m("peekByte"),
          readByte: m("readByte"),
          readChunk: m("readChunk"),
          readFloat16: function() {
            var Qe = this.readUint16(), xe = (Qe & 32767) >> 10, Ee = Qe & 1023, He = Qe & 32768;
            if (xe === 31)
              return Ee === 0 ? He ? -1 / 0 : 1 / 0 : NaN;
            var ve = xe ? Math.pow(2, xe - 25) * (1024 + Ee) : Math.pow(2, -24) * Ee;
            return He ? -ve : ve;
          },
          readFloat32: function() {
            var Qe = this.readUint32(), xe = (Qe & 2147483647) >> 23, Ee = Qe & 8388607, He = Qe & 2147483648;
            if (xe === 255)
              return Ee === 0 ? He ? -1 / 0 : 1 / 0 : NaN;
            var ve = xe ? Math.pow(2, xe - 23 - 127) * (8388608 + Ee) : Math.pow(2, -149) * Ee;
            return He ? -ve : ve;
          },
          readFloat64: function() {
            var Qe = this.readUint32(), xe = this.readUint32(), Ee = Qe >> 20 & 2047, He = (Qe & 1048575) * 4294967296 + xe, ve = Qe & 2147483648;
            if (Ee === 2047)
              return He === 0 ? ve ? -1 / 0 : 1 / 0 : NaN;
            var we = Ee ? Math.pow(2, Ee - 52 - 1023) * (4503599627370496 + He) : Math.pow(2, -1074) * He;
            return ve ? -we : we;
          },
          readUint16: function() {
            return this.readByte() * 256 + this.readByte();
          },
          readUint32: function() {
            return this.readUint16() * 65536 + this.readUint16();
          },
          readUint64: function() {
            return this.readUint32() * 4294967296 + this.readUint32();
          }
        };
        function k() {
        }
        k.prototype = {
          writeByte: m("writeByte"),
          result: m("result"),
          writeFloat16: m("writeFloat16"),
          writeFloat32: m("writeFloat32"),
          writeFloat64: m("writeFloat64"),
          writeUint16: function(Qe) {
            this.writeByte(Qe >> 8 & 255), this.writeByte(Qe & 255);
          },
          writeUint32: function(Qe) {
            this.writeUint16(Qe >> 16 & 65535), this.writeUint16(Qe & 65535);
          },
          writeUint64: function(Qe) {
            if (Qe >= 9007199254740992 || Qe <= -9007199254740992)
              throw new Error("Cannot encode Uint64 of: " + Qe + " magnitude to big (floating point errors)");
            this.writeUint32(Math.floor(Qe / 4294967296)), this.writeUint32(Qe % 4294967296);
          },
          writeString: m("writeString"),
          canWriteBinary: function(Qe) {
            return !1;
          },
          writeBinary: m("writeChunk")
        };
        function C(Qe) {
          var xe = Qe.readByte(), Ee = xe >> 5, He = xe & 31;
          return { type: Ee, value: He };
        }
        function B(Qe, xe) {
          var Ee = Qe.value;
          if (Ee < 24)
            return Ee;
          if (Ee == 24)
            return xe.readByte();
          if (Ee == 25)
            return xe.readUint16();
          if (Ee == 26)
            return xe.readUint32();
          if (Ee == 27)
            return xe.readUint64();
          if (Ee == 31)
            return null;
          m("Additional info: " + Ee)();
        }
        function Q(Qe, xe, Ee) {
          Ee.writeByte(Qe << 5 | xe);
        }
        function P(Qe, xe, Ee) {
          var He = Qe << 5;
          xe < 24 ? Ee.writeByte(He | xe) : xe < 256 ? (Ee.writeByte(He | 24), Ee.writeByte(xe)) : xe < 65536 ? (Ee.writeByte(He | 25), Ee.writeUint16(xe)) : xe < 4294967296 ? (Ee.writeByte(He | 26), Ee.writeUint32(xe)) : (Ee.writeByte(He | 27), Ee.writeUint64(xe));
        }
        var x = new Error();
        function M(Qe) {
          var xe = C(Qe);
          switch (xe.type) {
            case 0:
              return B(xe, Qe);
            case 1:
              return -1 - B(xe, Qe);
            case 2:
              return Qe.readChunk(B(xe, Qe));
            case 3:
              var Ee = Qe.readChunk(B(xe, Qe));
              return Ee.toString("utf-8");
            case 4:
            case 5:
              var He = B(xe, Qe), rr = [];
              if (He !== null) {
                xe.type === 5 && (He *= 2);
                for (var ve = 0; ve < He; ve++)
                  rr[ve] = M(Qe);
              } else
                for (var we; (we = M(Qe)) !== x; )
                  rr.push(we);
              if (xe.type === 5) {
                for (var Ce = {}, ve = 0; ve < rr.length; ve += 2)
                  Ce[rr[ve]] = rr[ve + 1];
                return Ce;
              } else
                return rr;
            case 6:
              var Se = B(xe, Qe), Ne = l[Se], rr = M(Qe);
              return Ne ? Ne(rr) : rr;
            case 7:
              if (xe.value === 25)
                return Qe.readFloat16();
              if (xe.value === 26)
                return Qe.readFloat32();
              if (xe.value === 27)
                return Qe.readFloat64();
              switch (B(xe, Qe)) {
                case 20:
                  return !1;
                case 21:
                  return !0;
                case 22:
                  return null;
                case 23:
                  return;
                case null:
                  return x;
                default:
                  throw new Error("Unknown fixed value: " + xe.value);
              }
            default:
              throw new Error("Unsupported header: " + JSON.stringify(xe));
          }
          throw new Error("not implemented yet");
        }
        function F(Qe, xe) {
          for (var Ee = 0; Ee < t.length; Ee++) {
            var He = t[Ee].fn(Qe);
            if (He !== void 0)
              return P(6, t[Ee].tag, xe), F(He, xe);
          }
          if (Qe && typeof Qe.toCBOR == "function" && (Qe = Qe.toCBOR()), Qe === !1)
            P(7, 20, xe);
          else if (Qe === !0)
            P(7, 21, xe);
          else if (Qe === null)
            P(7, 22, xe);
          else if (Qe === void 0)
            P(7, 23, xe);
          else if (typeof Qe == "number")
            Math.floor(Qe) === Qe && Qe < 9007199254740992 && Qe > -9007199254740992 ? Qe < 0 ? P(1, -1 - Qe, xe) : P(0, Qe, xe) : (Q(7, 27, xe), xe.writeFloat64(Qe));
          else if (typeof Qe == "string")
            xe.writeString(Qe, function(we) {
              P(3, we, xe);
            });
          else if (xe.canWriteBinary(Qe))
            xe.writeBinary(Qe, function(we) {
              P(2, we, xe);
            });
          else if (typeof Qe == "object")
            if (pe.config.useToJSON && typeof Qe.toJSON == "function" && (Qe = Qe.toJSON()), Array.isArray(Qe)) {
              P(4, Qe.length, xe);
              for (var Ee = 0; Ee < Qe.length; Ee++)
                F(Qe[Ee], xe);
            } else {
              var ve = Object.keys(Qe);
              P(5, ve.length, xe);
              for (var Ee = 0; Ee < ve.length; Ee++) {
                const Ce = parseInt(ve[Ee]);
                isNaN(Ce) ? (F(ve[Ee], xe), F(Qe[ve[Ee]], xe)) : (F(Ce, xe), F(Qe[ve[Ee]], xe));
              }
            }
          else
            throw new Error("CBOR encoding not supported: " + Qe);
        }
        var le = [], ge = [], pe = {
          config: {
            useToJSON: !0
          },
          addWriter: function(Qe, xe) {
            typeof Qe == "string" ? ge.push(function(Ee) {
              if (Qe === Ee)
                return xe(Ee);
            }) : ge.push(Qe);
          },
          addReader: function(Qe, xe) {
            typeof Qe == "string" ? le.push(function(Ee, He) {
              if (Qe === He)
                return xe(Ee, He);
            }) : le.push(Qe);
          },
          encode: function(Qe, xe) {
            for (var Ee = 0; Ee < ge.length; Ee++) {
              var He = ge[Ee], ve = He(xe);
              if (ve)
                return F(Qe, ve), ve.result();
            }
            throw new Error("Unsupported output format: " + xe);
          },
          encodeDataItem: function(Qe, xe) {
            for (var Ee = 0; Ee < ge.length; Ee++) {
              var He = ge[Ee], ve = He(xe);
              if (ve)
                return Qe.getTag() !== void 0 ? (F(Qe, ve), ve.result()) : (F(Qe.getData(), ve), ve.result());
            }
            throw new Error("Unsupported output format: " + xe);
          },
          decode: function(Qe, xe) {
            for (var Ee = 0; Ee < le.length; Ee++) {
              var He = le[Ee], ve = He(Qe, xe);
              if (ve)
                return M(ve);
            }
            throw new Error("Unsupported input format: " + xe);
          },
          decodeToDataItem: function(Qe, xe) {
            for (var Ee = 0; Ee < le.length; Ee++) {
              var He = le[Ee], ve = He(Qe, xe);
              if (ve) {
                const we = M(ve);
                return we instanceof A ? we : new A(we);
              }
            }
            throw new Error("Unsupported input format: " + xe);
          },
          addSemanticEncode: function(Qe, xe) {
            if (typeof Qe != "number" || Qe % 1 !== 0 || Qe < 0)
              throw new Error("Tag must be a positive integer");
            return t.push({ tag: Qe, fn: xe }), this;
          },
          addSemanticDecode: function(Qe, xe) {
            if (typeof Qe != "number" || Qe % 1 !== 0 || Qe < 0)
              throw new Error("Tag must be a positive integer");
            return l[Qe] = xe, this;
          }
        };
        function Ie(Qe) {
          this.buffer = Qe, this.pos = 0;
        }
        Ie.prototype = Object.create(b.prototype), Ie.prototype.peekByte = function() {
          return this.buffer[this.pos];
        }, Ie.prototype.readByte = function() {
          return this.buffer[this.pos++];
        }, Ie.prototype.readUint16 = function() {
          var Qe = this.buffer.readUInt16BE(this.pos);
          return this.pos += 2, Qe;
        }, Ie.prototype.readUint32 = function() {
          var Qe = this.buffer.readUInt32BE(this.pos);
          return this.pos += 4, Qe;
        }, Ie.prototype.readFloat32 = function() {
          var Qe = this.buffer.readFloatBE(this.pos);
          return this.pos += 4, Qe;
        }, Ie.prototype.readFloat64 = function() {
          var Qe = this.buffer.readDoubleBE(this.pos);
          return this.pos += 8, Qe;
        }, Ie.prototype.readChunk = function(Qe) {
          var xe = Buffer.alloc(Qe);
          return this.buffer.copy(xe, 0, this.pos, this.pos += Qe), xe;
        };
        function be(Qe) {
          this.byteLength = 0, this.defaultBufferLength = 16384, this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0, this.completeBuffers = [], this.stringFormat = Qe;
        }
        be.prototype = Object.create(k.prototype), be.prototype.writeByte = function(Qe) {
          this.latestBuffer[this.latestBufferOffset++] = Qe, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0), this.byteLength++;
        }, be.prototype.writeFloat32 = function(Qe) {
          var xe = Buffer.alloc(4);
          xe.writeFloatBE(Qe, 0), this.writeBuffer(xe);
        }, be.prototype.writeFloat64 = function(Qe) {
          var xe = Buffer.alloc(8);
          xe.writeDoubleBE(Qe, 0), this.writeBuffer(xe);
        }, be.prototype.writeString = function(Qe, xe) {
          var Ee = Buffer.from(Qe, "utf-8");
          xe(Ee.length), this.writeBuffer(Ee);
        }, be.prototype.canWriteBinary = function(Qe) {
          return Qe instanceof Buffer;
        }, be.prototype.writeBinary = function(Qe, xe) {
          xe(Qe.length), this.writeBuffer(Qe);
        }, be.prototype.writeBuffer = function(Qe) {
          if (!(Qe instanceof Buffer))
            throw new TypeError("BufferWriter only accepts Buffers");
          this.latestBufferOffset ? this.latestBuffer.length - this.latestBufferOffset >= Qe.length ? (Qe.copy(this.latestBuffer, this.latestBufferOffset), this.latestBufferOffset += Qe.length, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0)) : (this.completeBuffers.push(this.latestBuffer.slice(0, this.latestBufferOffset)), this.completeBuffers.push(Qe), this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0) : this.completeBuffers.push(Qe), this.byteLength += Qe.length;
        }, be.prototype.result = function() {
          for (var Qe = Buffer.alloc(this.byteLength), xe = 0, Ee = 0; Ee < this.completeBuffers.length; Ee++) {
            var He = this.completeBuffers[Ee];
            He.copy(Qe, xe, 0, He.length), xe += He.length;
          }
          return this.latestBufferOffset && this.latestBuffer.copy(Qe, xe, 0, this.latestBufferOffset), this.stringFormat ? Qe.toString(this.stringFormat) : Qe;
        }, typeof Buffer == "function" && (pe.addReader(function(Qe, xe) {
          if (Buffer.isBuffer(Qe))
            return new Ie(Qe);
          if (xe === "hex" || xe === "base64") {
            var Ee = Buffer.from(Qe, xe);
            return new Ie(Ee);
          }
        }), pe.addWriter(function(Qe) {
          if (!Qe || Qe === "buffer")
            return new be();
          if (Qe === "hex" || Qe === "base64")
            return new be(Qe);
        }));
        function Pe(Qe) {
          this.hex = Qe, this.pos = 0;
        }
        Pe.prototype = Object.create(b.prototype), Pe.prototype.peekByte = function() {
          var Qe = this.hex.substring(this.pos, 2);
          return parseInt(Qe, 16);
        }, Pe.prototype.readByte = function() {
          var Qe = this.hex.substring(this.pos, this.pos + 2);
          return this.pos += 2, parseInt(Qe, 16);
        }, Pe.prototype.readChunk = function(Qe) {
          var xe = this.hex.substring(this.pos, this.pos + Qe * 2);
          return this.pos += Qe * 2, typeof Buffer == "function" ? Buffer.from(xe, "hex") : new p(xe);
        };
        function Te(Qe) {
          this.$hex = "", this.finalFormat = Qe || "hex";
        }
        return Te.prototype = Object.create(k.prototype), Te.prototype.writeByte = function(Qe) {
          if (Qe < 0 || Qe > 255)
            throw new Error("Byte value out of range: " + Qe);
          var xe = Qe.toString(16);
          xe.length == 1 && (xe = "0" + xe), this.$hex += xe;
        }, Te.prototype.canWriteBinary = function(Qe) {
          return Qe instanceof p || typeof Buffer == "function" && Qe instanceof Buffer;
        }, Te.prototype.writeBinary = function(Qe, xe) {
          if (Qe instanceof p)
            xe(Qe.length()), this.$hex += Qe.$hex;
          else if (typeof Buffer == "function" && Qe instanceof Buffer)
            xe(Qe.length), this.$hex += Qe.toString("hex");
          else
            throw new TypeError("HexWriter only accepts BinaryHex or Buffers");
        }, Te.prototype.result = function() {
          return this.finalFormat === "buffer" && typeof Buffer == "function" ? Buffer.from(this.$hex, "hex") : new p(this.$hex).toString(this.finalFormat);
        }, Te.prototype.writeString = function(Qe, xe) {
          var Ee = p.fromUtf8String(Qe);
          xe(Ee.length()), this.$hex += Ee.$hex;
        }, pe.addReader(function(Qe, xe) {
          if (Qe instanceof p || Qe.$hex)
            return new Pe(Qe.$hex);
          if (xe === "hex")
            return new Pe(Qe);
        }), pe.addWriter(function(Qe) {
          if (Qe === "hex")
            return new Te();
        }), pe;
      }();
      return u.addSemanticEncode(0, function(p) {
        if (p instanceof Date)
          return p.toISOString();
      }).addSemanticDecode(0, function(p) {
        return new Date(p);
      }).addSemanticDecode(1, function(p) {
        return new Date(p);
      }), u;
    });
  }(cborSync$3)), cborSync$3.exports;
}
var hasRequiredLib$7;
function requireLib$7() {
  return hasRequiredLib$7 || (hasRequiredLib$7 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.DataItem = s.addWriter = s.addReader = s.addSemanticEncode = s.addSemanticDecode = s.decodeToDataItem = s.encodeDataItem = void 0;
    var A = requireCborSync$1();
    Object.defineProperty(s, "encodeDataItem", { enumerable: !0, get: function() {
      return A.encodeDataItem;
    } }), Object.defineProperty(s, "decodeToDataItem", { enumerable: !0, get: function() {
      return A.decodeToDataItem;
    } }), Object.defineProperty(s, "addSemanticDecode", { enumerable: !0, get: function() {
      return A.addSemanticDecode;
    } }), Object.defineProperty(s, "addSemanticEncode", { enumerable: !0, get: function() {
      return A.addSemanticEncode;
    } }), Object.defineProperty(s, "addReader", { enumerable: !0, get: function() {
      return A.addReader;
    } }), Object.defineProperty(s, "addWriter", { enumerable: !0, get: function() {
      return A.addWriter;
    } });
    var u = requireDataItem$1();
    Object.defineProperty(s, "DataItem", { enumerable: !0, get: function() {
      return u.DataItem;
    } });
  }(lib$7)), lib$7;
}
var hasRequiredUtils$f;
function requireUtils$f() {
  if (hasRequiredUtils$f) return utils$g;
  hasRequiredUtils$f = 1, Object.defineProperty(utils$g, "__esModule", { value: !0 }), utils$g.patchTags = void 0;
  const s = requireLib$7(), A = [], u = (p) => {
    p.forEach((t) => {
      A.find((l) => l === t) || ((0, s.addSemanticEncode)(t, (l) => {
        if (l instanceof s.DataItem && l.getTag() === t)
          return l.getData();
      }), (0, s.addSemanticDecode)(t, (l) => new s.DataItem(l, t)), A.push(t));
    });
  };
  return utils$g.patchTags = u, utils$g;
}
var RegistryType$1 = {}, hasRequiredRegistryType$1;
function requireRegistryType$1() {
  if (hasRequiredRegistryType$1) return RegistryType$1;
  hasRequiredRegistryType$1 = 1, Object.defineProperty(RegistryType$1, "__esModule", { value: !0 }), RegistryType$1.RegistryTypes = RegistryType$1.RegistryType = void 0;
  class s {
    constructor(u, p) {
      this.type = u, this.tag = p, this.getTag = () => this.tag, this.getType = () => this.type;
    }
  }
  return RegistryType$1.RegistryType = s, RegistryType$1.RegistryTypes = {
    UUID: new s("uuid", 37),
    BYTES: new s("bytes", void 0),
    CRYPTO_HDKEY: new s("crypto-hdkey", 303),
    CRYPTO_KEYPATH: new s("crypto-keypath", 304),
    CRYPTO_COIN_INFO: new s("crypto-coin-info", 305),
    CRYPTO_ECKEY: new s("crypto-eckey", 306),
    CRYPTO_OUTPUT: new s("crypto-output", 308),
    CRYPTO_PSBT: new s("crypto-psbt", 310),
    CRYPTO_ACCOUNT: new s("crypto-account", 311),
    CRYPTO_MULTI_ACCOUNTS: new s("crypto-multi-accounts", 1103),
    QR_HARDWARE_CALL: new s("qr-hardware-call", 1201),
    KEY_DERIVATION_CALL: new s("key-derivation-call", 1301),
    KEY_DERIVATION_SCHEMA: new s("key-derivation-schema", 1302)
  }, RegistryType$1;
}
var ScriptExpression$1 = {}, hasRequiredScriptExpression$1;
function requireScriptExpression$1() {
  return hasRequiredScriptExpression$1 || (hasRequiredScriptExpression$1 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.ScriptExpressions = s.ScriptExpression = void 0;
    class A {
      constructor(p, t) {
        this.tag = p, this.expression = t, this.getTag = () => this.tag, this.getExpression = () => this.expression;
      }
    }
    s.ScriptExpression = A, A.fromTag = (u) => Object.values(s.ScriptExpressions).find((t) => t.getTag() === u), s.ScriptExpressions = {
      SCRIPT_HASH: new A(400, "sh"),
      WITNESS_SCRIPT_HASH: new A(401, "wsh"),
      PUBLIC_KEY: new A(402, "pk"),
      PUBLIC_KEY_HASH: new A(403, "pkh"),
      WITNESS_PUBLIC_KEY_HASH: new A(404, "wpkh"),
      COMBO: new A(405, "combo"),
      MULTISIG: new A(406, "multi"),
      SORTED_MULTISIG: new A(407, "sortedmulti"),
      ADDRESS: new A(307, "addr"),
      RAW_SCRIPT: new A(408, "raw")
    };
  }(ScriptExpression$1)), ScriptExpression$1;
}
var hasRequiredPatchCBOR$1;
function requirePatchCBOR$1() {
  if (hasRequiredPatchCBOR$1) return patchCBOR$1;
  hasRequiredPatchCBOR$1 = 1, Object.defineProperty(patchCBOR$1, "__esModule", { value: !0 });
  const s = requireUtils$f(), A = requireRegistryType$1(), u = requireScriptExpression$1(), p = Object.values(A.RegistryTypes).filter((l) => !!l.getTag()).map((l) => l.getTag()), t = Object.values(u.ScriptExpressions).map((l) => l.getTag());
  return (0, s.patchTags)(p.concat(t)), patchCBOR$1;
}
var CryptoHDKey$1 = {}, inherits_browser = { exports: {} }, hasRequiredInherits_browser;
function requireInherits_browser() {
  return hasRequiredInherits_browser || (hasRequiredInherits_browser = 1, typeof Object.create == "function" ? inherits_browser.exports = function(A, u) {
    u && (A.super_ = u, A.prototype = Object.create(u.prototype, {
      constructor: {
        value: A,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : inherits_browser.exports = function(A, u) {
    if (u) {
      A.super_ = u;
      var p = function() {
      };
      p.prototype = u.prototype, A.prototype = new p(), A.prototype.constructor = A;
    }
  }), inherits_browser.exports;
}
var readableBrowser$1 = { exports: {} }, events = { exports: {} }, hasRequiredEvents;
function requireEvents() {
  if (hasRequiredEvents) return events.exports;
  hasRequiredEvents = 1;
  var s = typeof Reflect == "object" ? Reflect : null, A = s && typeof s.apply == "function" ? s.apply : function(Pe, Te, Qe) {
    return Function.prototype.apply.call(Pe, Te, Qe);
  }, u;
  s && typeof s.ownKeys == "function" ? u = s.ownKeys : Object.getOwnPropertySymbols ? u = function(Pe) {
    return Object.getOwnPropertyNames(Pe).concat(Object.getOwnPropertySymbols(Pe));
  } : u = function(Pe) {
    return Object.getOwnPropertyNames(Pe);
  };
  function p(be) {
    console && console.warn && console.warn(be);
  }
  var t = Number.isNaN || function(Pe) {
    return Pe !== Pe;
  };
  function l() {
    l.init.call(this);
  }
  events.exports = l, events.exports.once = ge, l.EventEmitter = l, l.prototype._events = void 0, l.prototype._eventsCount = 0, l.prototype._maxListeners = void 0;
  var m = 10;
  function b(be) {
    if (typeof be != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof be);
  }
  Object.defineProperty(l, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return m;
    },
    set: function(be) {
      if (typeof be != "number" || be < 0 || t(be))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + be + ".");
      m = be;
    }
  }), l.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, l.prototype.setMaxListeners = function(Pe) {
    if (typeof Pe != "number" || Pe < 0 || t(Pe))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + Pe + ".");
    return this._maxListeners = Pe, this;
  };
  function k(be) {
    return be._maxListeners === void 0 ? l.defaultMaxListeners : be._maxListeners;
  }
  l.prototype.getMaxListeners = function() {
    return k(this);
  }, l.prototype.emit = function(Pe) {
    for (var Te = [], Qe = 1; Qe < arguments.length; Qe++) Te.push(arguments[Qe]);
    var xe = Pe === "error", Ee = this._events;
    if (Ee !== void 0)
      xe = xe && Ee.error === void 0;
    else if (!xe)
      return !1;
    if (xe) {
      var He;
      if (Te.length > 0 && (He = Te[0]), He instanceof Error)
        throw He;
      var ve = new Error("Unhandled error." + (He ? " (" + He.message + ")" : ""));
      throw ve.context = He, ve;
    }
    var we = Ee[Pe];
    if (we === void 0)
      return !1;
    if (typeof we == "function")
      A(we, this, Te);
    else
      for (var Ce = we.length, Se = M(we, Ce), Qe = 0; Qe < Ce; ++Qe)
        A(Se[Qe], this, Te);
    return !0;
  };
  function C(be, Pe, Te, Qe) {
    var xe, Ee, He;
    if (b(Te), Ee = be._events, Ee === void 0 ? (Ee = be._events = /* @__PURE__ */ Object.create(null), be._eventsCount = 0) : (Ee.newListener !== void 0 && (be.emit(
      "newListener",
      Pe,
      Te.listener ? Te.listener : Te
    ), Ee = be._events), He = Ee[Pe]), He === void 0)
      He = Ee[Pe] = Te, ++be._eventsCount;
    else if (typeof He == "function" ? He = Ee[Pe] = Qe ? [Te, He] : [He, Te] : Qe ? He.unshift(Te) : He.push(Te), xe = k(be), xe > 0 && He.length > xe && !He.warned) {
      He.warned = !0;
      var ve = new Error("Possible EventEmitter memory leak detected. " + He.length + " " + String(Pe) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      ve.name = "MaxListenersExceededWarning", ve.emitter = be, ve.type = Pe, ve.count = He.length, p(ve);
    }
    return be;
  }
  l.prototype.addListener = function(Pe, Te) {
    return C(this, Pe, Te, !1);
  }, l.prototype.on = l.prototype.addListener, l.prototype.prependListener = function(Pe, Te) {
    return C(this, Pe, Te, !0);
  };
  function B() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function Q(be, Pe, Te) {
    var Qe = { fired: !1, wrapFn: void 0, target: be, type: Pe, listener: Te }, xe = B.bind(Qe);
    return xe.listener = Te, Qe.wrapFn = xe, xe;
  }
  l.prototype.once = function(Pe, Te) {
    return b(Te), this.on(Pe, Q(this, Pe, Te)), this;
  }, l.prototype.prependOnceListener = function(Pe, Te) {
    return b(Te), this.prependListener(Pe, Q(this, Pe, Te)), this;
  }, l.prototype.removeListener = function(Pe, Te) {
    var Qe, xe, Ee, He, ve;
    if (b(Te), xe = this._events, xe === void 0)
      return this;
    if (Qe = xe[Pe], Qe === void 0)
      return this;
    if (Qe === Te || Qe.listener === Te)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete xe[Pe], xe.removeListener && this.emit("removeListener", Pe, Qe.listener || Te));
    else if (typeof Qe != "function") {
      for (Ee = -1, He = Qe.length - 1; He >= 0; He--)
        if (Qe[He] === Te || Qe[He].listener === Te) {
          ve = Qe[He].listener, Ee = He;
          break;
        }
      if (Ee < 0)
        return this;
      Ee === 0 ? Qe.shift() : F(Qe, Ee), Qe.length === 1 && (xe[Pe] = Qe[0]), xe.removeListener !== void 0 && this.emit("removeListener", Pe, ve || Te);
    }
    return this;
  }, l.prototype.off = l.prototype.removeListener, l.prototype.removeAllListeners = function(Pe) {
    var Te, Qe, xe;
    if (Qe = this._events, Qe === void 0)
      return this;
    if (Qe.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : Qe[Pe] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete Qe[Pe]), this;
    if (arguments.length === 0) {
      var Ee = Object.keys(Qe), He;
      for (xe = 0; xe < Ee.length; ++xe)
        He = Ee[xe], He !== "removeListener" && this.removeAllListeners(He);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (Te = Qe[Pe], typeof Te == "function")
      this.removeListener(Pe, Te);
    else if (Te !== void 0)
      for (xe = Te.length - 1; xe >= 0; xe--)
        this.removeListener(Pe, Te[xe]);
    return this;
  };
  function P(be, Pe, Te) {
    var Qe = be._events;
    if (Qe === void 0)
      return [];
    var xe = Qe[Pe];
    return xe === void 0 ? [] : typeof xe == "function" ? Te ? [xe.listener || xe] : [xe] : Te ? le(xe) : M(xe, xe.length);
  }
  l.prototype.listeners = function(Pe) {
    return P(this, Pe, !0);
  }, l.prototype.rawListeners = function(Pe) {
    return P(this, Pe, !1);
  }, l.listenerCount = function(be, Pe) {
    return typeof be.listenerCount == "function" ? be.listenerCount(Pe) : x.call(be, Pe);
  }, l.prototype.listenerCount = x;
  function x(be) {
    var Pe = this._events;
    if (Pe !== void 0) {
      var Te = Pe[be];
      if (typeof Te == "function")
        return 1;
      if (Te !== void 0)
        return Te.length;
    }
    return 0;
  }
  l.prototype.eventNames = function() {
    return this._eventsCount > 0 ? u(this._events) : [];
  };
  function M(be, Pe) {
    for (var Te = new Array(Pe), Qe = 0; Qe < Pe; ++Qe)
      Te[Qe] = be[Qe];
    return Te;
  }
  function F(be, Pe) {
    for (; Pe + 1 < be.length; Pe++)
      be[Pe] = be[Pe + 1];
    be.pop();
  }
  function le(be) {
    for (var Pe = new Array(be.length), Te = 0; Te < Pe.length; ++Te)
      Pe[Te] = be[Te].listener || be[Te];
    return Pe;
  }
  function ge(be, Pe) {
    return new Promise(function(Te, Qe) {
      function xe(He) {
        be.removeListener(Pe, Ee), Qe(He);
      }
      function Ee() {
        typeof be.removeListener == "function" && be.removeListener("error", xe), Te([].slice.call(arguments));
      }
      Ie(be, Pe, Ee, { once: !0 }), Pe !== "error" && pe(be, xe, { once: !0 });
    });
  }
  function pe(be, Pe, Te) {
    typeof be.on == "function" && Ie(be, "error", Pe, Te);
  }
  function Ie(be, Pe, Te, Qe) {
    if (typeof be.on == "function")
      Qe.once ? be.once(Pe, Te) : be.on(Pe, Te);
    else if (typeof be.addEventListener == "function")
      be.addEventListener(Pe, function xe(Ee) {
        Qe.once && be.removeEventListener(Pe, xe), Te(Ee);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof be);
  }
  return events.exports;
}
var streamBrowser$1, hasRequiredStreamBrowser$1;
function requireStreamBrowser$1() {
  return hasRequiredStreamBrowser$1 || (hasRequiredStreamBrowser$1 = 1, streamBrowser$1 = requireEvents().EventEmitter), streamBrowser$1;
}
var util$1 = {}, types$8 = {}, shams$1, hasRequiredShams$1;
function requireShams$1() {
  return hasRequiredShams$1 || (hasRequiredShams$1 = 1, shams$1 = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var A = {}, u = Symbol("test"), p = Object(u);
    if (typeof u == "string" || Object.prototype.toString.call(u) !== "[object Symbol]" || Object.prototype.toString.call(p) !== "[object Symbol]")
      return !1;
    var t = 42;
    A[u] = t;
    for (var l in A)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(A).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(A).length !== 0)
      return !1;
    var m = Object.getOwnPropertySymbols(A);
    if (m.length !== 1 || m[0] !== u || !Object.prototype.propertyIsEnumerable.call(A, u))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var b = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(A, u)
      );
      if (b.value !== t || b.enumerable !== !0)
        return !1;
    }
    return !0;
  }), shams$1;
}
var shams, hasRequiredShams;
function requireShams() {
  if (hasRequiredShams) return shams;
  hasRequiredShams = 1;
  var s = requireShams$1();
  return shams = function() {
    return s() && !!Symbol.toStringTag;
  }, shams;
}
var esObjectAtoms, hasRequiredEsObjectAtoms;
function requireEsObjectAtoms() {
  return hasRequiredEsObjectAtoms || (hasRequiredEsObjectAtoms = 1, esObjectAtoms = Object), esObjectAtoms;
}
var esErrors, hasRequiredEsErrors;
function requireEsErrors() {
  return hasRequiredEsErrors || (hasRequiredEsErrors = 1, esErrors = Error), esErrors;
}
var _eval, hasRequired_eval;
function require_eval() {
  return hasRequired_eval || (hasRequired_eval = 1, _eval = EvalError), _eval;
}
var range$1, hasRequiredRange$1;
function requireRange$1() {
  return hasRequiredRange$1 || (hasRequiredRange$1 = 1, range$1 = RangeError), range$1;
}
var ref, hasRequiredRef;
function requireRef() {
  return hasRequiredRef || (hasRequiredRef = 1, ref = ReferenceError), ref;
}
var syntax, hasRequiredSyntax;
function requireSyntax() {
  return hasRequiredSyntax || (hasRequiredSyntax = 1, syntax = SyntaxError), syntax;
}
var type, hasRequiredType;
function requireType() {
  return hasRequiredType || (hasRequiredType = 1, type = TypeError), type;
}
var uri, hasRequiredUri;
function requireUri() {
  return hasRequiredUri || (hasRequiredUri = 1, uri = URIError), uri;
}
var abs, hasRequiredAbs;
function requireAbs() {
  return hasRequiredAbs || (hasRequiredAbs = 1, abs = Math.abs), abs;
}
var floor, hasRequiredFloor;
function requireFloor() {
  return hasRequiredFloor || (hasRequiredFloor = 1, floor = Math.floor), floor;
}
var max$1, hasRequiredMax$1;
function requireMax$1() {
  return hasRequiredMax$1 || (hasRequiredMax$1 = 1, max$1 = Math.max), max$1;
}
var min, hasRequiredMin;
function requireMin() {
  return hasRequiredMin || (hasRequiredMin = 1, min = Math.min), min;
}
var pow$1, hasRequiredPow;
function requirePow() {
  return hasRequiredPow || (hasRequiredPow = 1, pow$1 = Math.pow), pow$1;
}
var round, hasRequiredRound;
function requireRound() {
  return hasRequiredRound || (hasRequiredRound = 1, round = Math.round), round;
}
var _isNaN, hasRequired_isNaN;
function require_isNaN() {
  return hasRequired_isNaN || (hasRequired_isNaN = 1, _isNaN = Number.isNaN || function(A) {
    return A !== A;
  }), _isNaN;
}
var sign$3, hasRequiredSign$1;
function requireSign$1() {
  if (hasRequiredSign$1) return sign$3;
  hasRequiredSign$1 = 1;
  var s = /* @__PURE__ */ require_isNaN();
  return sign$3 = function(u) {
    return s(u) || u === 0 ? u : u < 0 ? -1 : 1;
  }, sign$3;
}
var gOPD, hasRequiredGOPD;
function requireGOPD() {
  return hasRequiredGOPD || (hasRequiredGOPD = 1, gOPD = Object.getOwnPropertyDescriptor), gOPD;
}
var gopd, hasRequiredGopd;
function requireGopd() {
  if (hasRequiredGopd) return gopd;
  hasRequiredGopd = 1;
  var s = /* @__PURE__ */ requireGOPD();
  if (s)
    try {
      s([], "length");
    } catch {
      s = null;
    }
  return gopd = s, gopd;
}
var esDefineProperty, hasRequiredEsDefineProperty;
function requireEsDefineProperty() {
  if (hasRequiredEsDefineProperty) return esDefineProperty;
  hasRequiredEsDefineProperty = 1;
  var s = Object.defineProperty || !1;
  if (s)
    try {
      s({}, "a", { value: 1 });
    } catch {
      s = !1;
    }
  return esDefineProperty = s, esDefineProperty;
}
var hasSymbols, hasRequiredHasSymbols;
function requireHasSymbols() {
  if (hasRequiredHasSymbols) return hasSymbols;
  hasRequiredHasSymbols = 1;
  var s = typeof Symbol < "u" && Symbol, A = requireShams$1();
  return hasSymbols = function() {
    return typeof s != "function" || typeof Symbol != "function" || typeof s("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : A();
  }, hasSymbols;
}
var Reflect_getPrototypeOf, hasRequiredReflect_getPrototypeOf;
function requireReflect_getPrototypeOf() {
  return hasRequiredReflect_getPrototypeOf || (hasRequiredReflect_getPrototypeOf = 1, Reflect_getPrototypeOf = typeof Reflect < "u" && Reflect.getPrototypeOf || null), Reflect_getPrototypeOf;
}
var Object_getPrototypeOf, hasRequiredObject_getPrototypeOf;
function requireObject_getPrototypeOf() {
  if (hasRequiredObject_getPrototypeOf) return Object_getPrototypeOf;
  hasRequiredObject_getPrototypeOf = 1;
  var s = /* @__PURE__ */ requireEsObjectAtoms();
  return Object_getPrototypeOf = s.getPrototypeOf || null, Object_getPrototypeOf;
}
var implementation$4, hasRequiredImplementation$4;
function requireImplementation$4() {
  if (hasRequiredImplementation$4) return implementation$4;
  hasRequiredImplementation$4 = 1;
  var s = "Function.prototype.bind called on incompatible ", A = Object.prototype.toString, u = Math.max, p = "[object Function]", t = function(k, C) {
    for (var B = [], Q = 0; Q < k.length; Q += 1)
      B[Q] = k[Q];
    for (var P = 0; P < C.length; P += 1)
      B[P + k.length] = C[P];
    return B;
  }, l = function(k, C) {
    for (var B = [], Q = C, P = 0; Q < k.length; Q += 1, P += 1)
      B[P] = k[Q];
    return B;
  }, m = function(b, k) {
    for (var C = "", B = 0; B < b.length; B += 1)
      C += b[B], B + 1 < b.length && (C += k);
    return C;
  };
  return implementation$4 = function(k) {
    var C = this;
    if (typeof C != "function" || A.apply(C) !== p)
      throw new TypeError(s + C);
    for (var B = l(arguments, 1), Q, P = function() {
      if (this instanceof Q) {
        var ge = C.apply(
          this,
          t(B, arguments)
        );
        return Object(ge) === ge ? ge : this;
      }
      return C.apply(
        k,
        t(B, arguments)
      );
    }, x = u(0, C.length - B.length), M = [], F = 0; F < x; F++)
      M[F] = "$" + F;
    if (Q = Function("binder", "return function (" + m(M, ",") + "){ return binder.apply(this,arguments); }")(P), C.prototype) {
      var le = function() {
      };
      le.prototype = C.prototype, Q.prototype = new le(), le.prototype = null;
    }
    return Q;
  }, implementation$4;
}
var functionBind, hasRequiredFunctionBind;
function requireFunctionBind() {
  if (hasRequiredFunctionBind) return functionBind;
  hasRequiredFunctionBind = 1;
  var s = requireImplementation$4();
  return functionBind = Function.prototype.bind || s, functionBind;
}
var functionCall, hasRequiredFunctionCall;
function requireFunctionCall() {
  return hasRequiredFunctionCall || (hasRequiredFunctionCall = 1, functionCall = Function.prototype.call), functionCall;
}
var functionApply, hasRequiredFunctionApply;
function requireFunctionApply() {
  return hasRequiredFunctionApply || (hasRequiredFunctionApply = 1, functionApply = Function.prototype.apply), functionApply;
}
var reflectApply, hasRequiredReflectApply;
function requireReflectApply() {
  return hasRequiredReflectApply || (hasRequiredReflectApply = 1, reflectApply = typeof Reflect < "u" && Reflect && Reflect.apply), reflectApply;
}
var actualApply, hasRequiredActualApply;
function requireActualApply() {
  if (hasRequiredActualApply) return actualApply;
  hasRequiredActualApply = 1;
  var s = requireFunctionBind(), A = requireFunctionApply(), u = requireFunctionCall(), p = requireReflectApply();
  return actualApply = p || s.call(u, A), actualApply;
}
var callBindApplyHelpers, hasRequiredCallBindApplyHelpers;
function requireCallBindApplyHelpers() {
  if (hasRequiredCallBindApplyHelpers) return callBindApplyHelpers;
  hasRequiredCallBindApplyHelpers = 1;
  var s = requireFunctionBind(), A = /* @__PURE__ */ requireType(), u = requireFunctionCall(), p = requireActualApply();
  return callBindApplyHelpers = function(l) {
    if (l.length < 1 || typeof l[0] != "function")
      throw new A("a function is required");
    return p(s, u, l);
  }, callBindApplyHelpers;
}
var get, hasRequiredGet;
function requireGet() {
  if (hasRequiredGet) return get;
  hasRequiredGet = 1;
  var s = requireCallBindApplyHelpers(), A = /* @__PURE__ */ requireGopd(), u;
  try {
    u = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (m) {
    if (!m || typeof m != "object" || !("code" in m) || m.code !== "ERR_PROTO_ACCESS")
      throw m;
  }
  var p = !!u && A && A(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), t = Object, l = t.getPrototypeOf;
  return get = p && typeof p.get == "function" ? s([p.get]) : typeof l == "function" ? (
    /** @type {import('./get')} */
    function(b) {
      return l(b == null ? b : t(b));
    }
  ) : !1, get;
}
var getProto, hasRequiredGetProto;
function requireGetProto() {
  if (hasRequiredGetProto) return getProto;
  hasRequiredGetProto = 1;
  var s = requireReflect_getPrototypeOf(), A = requireObject_getPrototypeOf(), u = /* @__PURE__ */ requireGet();
  return getProto = s ? function(t) {
    return s(t);
  } : A ? function(t) {
    if (!t || typeof t != "object" && typeof t != "function")
      throw new TypeError("getProto: not an object");
    return A(t);
  } : u ? function(t) {
    return u(t);
  } : null, getProto;
}
var hasown, hasRequiredHasown;
function requireHasown() {
  if (hasRequiredHasown) return hasown;
  hasRequiredHasown = 1;
  var s = Function.prototype.call, A = Object.prototype.hasOwnProperty, u = requireFunctionBind();
  return hasown = u.call(s, A), hasown;
}
var getIntrinsic, hasRequiredGetIntrinsic;
function requireGetIntrinsic() {
  if (hasRequiredGetIntrinsic) return getIntrinsic;
  hasRequiredGetIntrinsic = 1;
  var s, A = /* @__PURE__ */ requireEsObjectAtoms(), u = /* @__PURE__ */ requireEsErrors(), p = /* @__PURE__ */ require_eval(), t = /* @__PURE__ */ requireRange$1(), l = /* @__PURE__ */ requireRef(), m = /* @__PURE__ */ requireSyntax(), b = /* @__PURE__ */ requireType(), k = /* @__PURE__ */ requireUri(), C = /* @__PURE__ */ requireAbs(), B = /* @__PURE__ */ requireFloor(), Q = /* @__PURE__ */ requireMax$1(), P = /* @__PURE__ */ requireMin(), x = /* @__PURE__ */ requirePow(), M = /* @__PURE__ */ requireRound(), F = /* @__PURE__ */ requireSign$1(), le = Function, ge = function(un) {
    try {
      return le('"use strict"; return (' + un + ").constructor;")();
    } catch {
    }
  }, pe = /* @__PURE__ */ requireGopd(), Ie = /* @__PURE__ */ requireEsDefineProperty(), be = function() {
    throw new b();
  }, Pe = pe ? function() {
    try {
      return arguments.callee, be;
    } catch {
      try {
        return pe(arguments, "callee").get;
      } catch {
        return be;
      }
    }
  }() : be, Te = requireHasSymbols()(), Qe = requireGetProto(), xe = requireObject_getPrototypeOf(), Ee = requireReflect_getPrototypeOf(), He = requireFunctionApply(), ve = requireFunctionCall(), we = {}, Ce = typeof Uint8Array > "u" || !Qe ? s : Qe(Uint8Array), Se = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? s : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? s : ArrayBuffer,
    "%ArrayIteratorPrototype%": Te && Qe ? Qe([][Symbol.iterator]()) : s,
    "%AsyncFromSyncIteratorPrototype%": s,
    "%AsyncFunction%": we,
    "%AsyncGenerator%": we,
    "%AsyncGeneratorFunction%": we,
    "%AsyncIteratorPrototype%": we,
    "%Atomics%": typeof Atomics > "u" ? s : Atomics,
    "%BigInt%": typeof BigInt > "u" ? s : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? s : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? s : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? s : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": u,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": p,
    "%Float16Array%": typeof Float16Array > "u" ? s : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? s : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? s : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? s : FinalizationRegistry,
    "%Function%": le,
    "%GeneratorFunction%": we,
    "%Int8Array%": typeof Int8Array > "u" ? s : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? s : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? s : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": Te && Qe ? Qe(Qe([][Symbol.iterator]())) : s,
    "%JSON%": typeof JSON == "object" ? JSON : s,
    "%Map%": typeof Map > "u" ? s : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !Te || !Qe ? s : Qe((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": A,
    "%Object.getOwnPropertyDescriptor%": pe,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? s : Promise,
    "%Proxy%": typeof Proxy > "u" ? s : Proxy,
    "%RangeError%": t,
    "%ReferenceError%": l,
    "%Reflect%": typeof Reflect > "u" ? s : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? s : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !Te || !Qe ? s : Qe((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? s : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": Te && Qe ? Qe(""[Symbol.iterator]()) : s,
    "%Symbol%": Te ? Symbol : s,
    "%SyntaxError%": m,
    "%ThrowTypeError%": Pe,
    "%TypedArray%": Ce,
    "%TypeError%": b,
    "%Uint8Array%": typeof Uint8Array > "u" ? s : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? s : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? s : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? s : Uint32Array,
    "%URIError%": k,
    "%WeakMap%": typeof WeakMap > "u" ? s : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? s : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? s : WeakSet,
    "%Function.prototype.call%": ve,
    "%Function.prototype.apply%": He,
    "%Object.defineProperty%": Ie,
    "%Object.getPrototypeOf%": xe,
    "%Math.abs%": C,
    "%Math.floor%": B,
    "%Math.max%": Q,
    "%Math.min%": P,
    "%Math.pow%": x,
    "%Math.round%": M,
    "%Math.sign%": F,
    "%Reflect.getPrototypeOf%": Ee
  };
  if (Qe)
    try {
      null.error;
    } catch (un) {
      var Ne = Qe(Qe(un));
      Se["%Error.prototype%"] = Ne;
    }
  var rr = function un(Dr) {
    var wr;
    if (Dr === "%AsyncFunction%")
      wr = ge("async function () {}");
    else if (Dr === "%GeneratorFunction%")
      wr = ge("function* () {}");
    else if (Dr === "%AsyncGeneratorFunction%")
      wr = ge("async function* () {}");
    else if (Dr === "%AsyncGenerator%") {
      var yr = un("%AsyncGeneratorFunction%");
      yr && (wr = yr.prototype);
    } else if (Dr === "%AsyncIteratorPrototype%") {
      var Qr = un("%AsyncGenerator%");
      Qr && Qe && (wr = Qe(Qr.prototype));
    }
    return Se[Dr] = wr, wr;
  }, er = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, ir = requireFunctionBind(), sr = /* @__PURE__ */ requireHasown(), nr = ir.call(ve, Array.prototype.concat), fr = ir.call(He, Array.prototype.splice), lr = ir.call(ve, String.prototype.replace), br = ir.call(ve, String.prototype.slice), Br = ir.call(ve, RegExp.prototype.exec), Fr = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, Gr = /\\(\\)?/g, qr = function(Dr) {
    var wr = br(Dr, 0, 1), yr = br(Dr, -1);
    if (wr === "%" && yr !== "%")
      throw new m("invalid intrinsic syntax, expected closing `%`");
    if (yr === "%" && wr !== "%")
      throw new m("invalid intrinsic syntax, expected opening `%`");
    var Qr = [];
    return lr(Dr, Fr, function(_r, Jr, fn, jr) {
      Qr[Qr.length] = fn ? lr(jr, Gr, "$1") : Jr || _r;
    }), Qr;
  }, Hr = function(Dr, wr) {
    var yr = Dr, Qr;
    if (sr(er, yr) && (Qr = er[yr], yr = "%" + Qr[0] + "%"), sr(Se, yr)) {
      var _r = Se[yr];
      if (_r === we && (_r = rr(yr)), typeof _r > "u" && !wr)
        throw new b("intrinsic " + Dr + " exists, but is not available. Please file an issue!");
      return {
        alias: Qr,
        name: yr,
        value: _r
      };
    }
    throw new m("intrinsic " + Dr + " does not exist!");
  };
  return getIntrinsic = function(Dr, wr) {
    if (typeof Dr != "string" || Dr.length === 0)
      throw new b("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof wr != "boolean")
      throw new b('"allowMissing" argument must be a boolean');
    if (Br(/^%?[^%]*%?$/, Dr) === null)
      throw new m("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var yr = qr(Dr), Qr = yr.length > 0 ? yr[0] : "", _r = Hr("%" + Qr + "%", wr), Jr = _r.name, fn = _r.value, jr = !1, dn = _r.alias;
    dn && (Qr = dn[0], fr(yr, nr([0, 1], dn)));
    for (var Tn = 1, Yn = !0; Tn < yr.length; Tn += 1) {
      var si = yr[Tn], vn = br(si, 0, 1), Cn = br(si, -1);
      if ((vn === '"' || vn === "'" || vn === "`" || Cn === '"' || Cn === "'" || Cn === "`") && vn !== Cn)
        throw new m("property names with quotes must have matching quotes");
      if ((si === "constructor" || !Yn) && (jr = !0), Qr += "." + si, Jr = "%" + Qr + "%", sr(Se, Jr))
        fn = Se[Jr];
      else if (fn != null) {
        if (!(si in fn)) {
          if (!wr)
            throw new b("base intrinsic for " + Dr + " exists, but the property is not available.");
          return;
        }
        if (pe && Tn + 1 >= yr.length) {
          var Xr = pe(fn, si);
          Yn = !!Xr, Yn && "get" in Xr && !("originalValue" in Xr.get) ? fn = Xr.get : fn = fn[si];
        } else
          Yn = sr(fn, si), fn = fn[si];
        Yn && !jr && (Se[Jr] = fn);
      }
    }
    return fn;
  }, getIntrinsic;
}
var callBound$1, hasRequiredCallBound$1;
function requireCallBound$1() {
  if (hasRequiredCallBound$1) return callBound$1;
  hasRequiredCallBound$1 = 1;
  var s = /* @__PURE__ */ requireGetIntrinsic(), A = requireCallBindApplyHelpers(), u = A([s("%String.prototype.indexOf%")]);
  return callBound$1 = function(t, l) {
    var m = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      s(t, !!l)
    );
    return typeof m == "function" && u(t, ".prototype.") > -1 ? A(
      /** @type {const} */
      [m]
    ) : m;
  }, callBound$1;
}
var isArguments$1, hasRequiredIsArguments$1;
function requireIsArguments$1() {
  if (hasRequiredIsArguments$1) return isArguments$1;
  hasRequiredIsArguments$1 = 1;
  var s = requireShams()(), A = /* @__PURE__ */ requireCallBound$1(), u = A("Object.prototype.toString"), p = function(b) {
    return s && b && typeof b == "object" && Symbol.toStringTag in b ? !1 : u(b) === "[object Arguments]";
  }, t = function(b) {
    return p(b) ? !0 : b !== null && typeof b == "object" && "length" in b && typeof b.length == "number" && b.length >= 0 && u(b) !== "[object Array]" && "callee" in b && u(b.callee) === "[object Function]";
  }, l = function() {
    return p(arguments);
  }();
  return p.isLegacyArguments = t, isArguments$1 = l ? p : t, isArguments$1;
}
var isRegex, hasRequiredIsRegex;
function requireIsRegex() {
  if (hasRequiredIsRegex) return isRegex;
  hasRequiredIsRegex = 1;
  var s = /* @__PURE__ */ requireCallBound$1(), A = requireShams()(), u = /* @__PURE__ */ requireHasown(), p = /* @__PURE__ */ requireGopd(), t;
  if (A) {
    var l = s("RegExp.prototype.exec"), m = {}, b = function() {
      throw m;
    }, k = {
      toString: b,
      valueOf: b
    };
    typeof Symbol.toPrimitive == "symbol" && (k[Symbol.toPrimitive] = b), t = function(P) {
      if (!P || typeof P != "object")
        return !1;
      var x = (
        /** @type {NonNullable<typeof gOPD>} */
        p(
          /** @type {{ lastIndex?: unknown }} */
          P,
          "lastIndex"
        )
      ), M = x && u(x, "value");
      if (!M)
        return !1;
      try {
        l(
          P,
          /** @type {string} */
          /** @type {unknown} */
          k
        );
      } catch (F) {
        return F === m;
      }
    };
  } else {
    var C = s("Object.prototype.toString"), B = "[object RegExp]";
    t = function(P) {
      return !P || typeof P != "object" && typeof P != "function" ? !1 : C(P) === B;
    };
  }
  return isRegex = t, isRegex;
}
var safeRegexTest, hasRequiredSafeRegexTest;
function requireSafeRegexTest() {
  if (hasRequiredSafeRegexTest) return safeRegexTest;
  hasRequiredSafeRegexTest = 1;
  var s = /* @__PURE__ */ requireCallBound$1(), A = requireIsRegex(), u = s("RegExp.prototype.exec"), p = /* @__PURE__ */ requireType();
  return safeRegexTest = function(l) {
    if (!A(l))
      throw new p("`regex` must be a RegExp");
    return function(b) {
      return u(l, b) !== null;
    };
  }, safeRegexTest;
}
var isGeneratorFunction, hasRequiredIsGeneratorFunction;
function requireIsGeneratorFunction() {
  if (hasRequiredIsGeneratorFunction) return isGeneratorFunction;
  hasRequiredIsGeneratorFunction = 1;
  var s = /* @__PURE__ */ requireCallBound$1(), A = /* @__PURE__ */ requireSafeRegexTest(), u = A(/^\s*(?:function)?\*/), p = requireShams()(), t = requireGetProto(), l = s("Object.prototype.toString"), m = s("Function.prototype.toString"), b = function() {
    if (!p)
      return !1;
    try {
      return Function("return function*() {}")();
    } catch {
    }
  }, k;
  return isGeneratorFunction = function(B) {
    if (typeof B != "function")
      return !1;
    if (u(m(B)))
      return !0;
    if (!p) {
      var Q = l(B);
      return Q === "[object GeneratorFunction]";
    }
    if (!t)
      return !1;
    if (typeof k > "u") {
      var P = b();
      k = P ? (
        /** @type {GeneratorFunctionConstructor} */
        t(P)
      ) : !1;
    }
    return t(B) === k;
  }, isGeneratorFunction;
}
var isCallable, hasRequiredIsCallable;
function requireIsCallable() {
  if (hasRequiredIsCallable) return isCallable;
  hasRequiredIsCallable = 1;
  var s = Function.prototype.toString, A = typeof Reflect == "object" && Reflect !== null && Reflect.apply, u, p;
  if (typeof A == "function" && typeof Object.defineProperty == "function")
    try {
      u = Object.defineProperty({}, "length", {
        get: function() {
          throw p;
        }
      }), p = {}, A(function() {
        throw 42;
      }, null, u);
    } catch (pe) {
      pe !== p && (A = null);
    }
  else
    A = null;
  var t = /^\s*class\b/, l = function(Ie) {
    try {
      var be = s.call(Ie);
      return t.test(be);
    } catch {
      return !1;
    }
  }, m = function(Ie) {
    try {
      return l(Ie) ? !1 : (s.call(Ie), !0);
    } catch {
      return !1;
    }
  }, b = Object.prototype.toString, k = "[object Object]", C = "[object Function]", B = "[object GeneratorFunction]", Q = "[object HTMLAllCollection]", P = "[object HTML document.all class]", x = "[object HTMLCollection]", M = typeof Symbol == "function" && !!Symbol.toStringTag, F = !(0 in [,]), le = function() {
    return !1;
  };
  if (typeof document == "object") {
    var ge = document.all;
    b.call(ge) === b.call(document.all) && (le = function(Ie) {
      if ((F || !Ie) && (typeof Ie > "u" || typeof Ie == "object"))
        try {
          var be = b.call(Ie);
          return (be === Q || be === P || be === x || be === k) && Ie("") == null;
        } catch {
        }
      return !1;
    });
  }
  return isCallable = A ? function(Ie) {
    if (le(Ie))
      return !0;
    if (!Ie || typeof Ie != "function" && typeof Ie != "object")
      return !1;
    try {
      A(Ie, null, u);
    } catch (be) {
      if (be !== p)
        return !1;
    }
    return !l(Ie) && m(Ie);
  } : function(Ie) {
    if (le(Ie))
      return !0;
    if (!Ie || typeof Ie != "function" && typeof Ie != "object")
      return !1;
    if (M)
      return m(Ie);
    if (l(Ie))
      return !1;
    var be = b.call(Ie);
    return be !== C && be !== B && !/^\[object HTML/.test(be) ? !1 : m(Ie);
  }, isCallable;
}
var forEach, hasRequiredForEach;
function requireForEach() {
  if (hasRequiredForEach) return forEach;
  hasRequiredForEach = 1;
  var s = requireIsCallable(), A = Object.prototype.toString, u = Object.prototype.hasOwnProperty, p = function(k, C, B) {
    for (var Q = 0, P = k.length; Q < P; Q++)
      u.call(k, Q) && (B == null ? C(k[Q], Q, k) : C.call(B, k[Q], Q, k));
  }, t = function(k, C, B) {
    for (var Q = 0, P = k.length; Q < P; Q++)
      B == null ? C(k.charAt(Q), Q, k) : C.call(B, k.charAt(Q), Q, k);
  }, l = function(k, C, B) {
    for (var Q in k)
      u.call(k, Q) && (B == null ? C(k[Q], Q, k) : C.call(B, k[Q], Q, k));
  };
  function m(b) {
    return A.call(b) === "[object Array]";
  }
  return forEach = function(k, C, B) {
    if (!s(C))
      throw new TypeError("iterator must be a function");
    var Q;
    arguments.length >= 3 && (Q = B), m(k) ? p(k, C, Q) : typeof k == "string" ? t(k, C, Q) : l(k, C, Q);
  }, forEach;
}
var possibleTypedArrayNames, hasRequiredPossibleTypedArrayNames;
function requirePossibleTypedArrayNames() {
  return hasRequiredPossibleTypedArrayNames || (hasRequiredPossibleTypedArrayNames = 1, possibleTypedArrayNames = [
    "Float16Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
  ]), possibleTypedArrayNames;
}
var availableTypedArrays, hasRequiredAvailableTypedArrays;
function requireAvailableTypedArrays() {
  if (hasRequiredAvailableTypedArrays) return availableTypedArrays;
  hasRequiredAvailableTypedArrays = 1;
  var s = /* @__PURE__ */ requirePossibleTypedArrayNames(), A = typeof globalThis > "u" ? commonjsGlobal : globalThis;
  return availableTypedArrays = function() {
    for (var p = [], t = 0; t < s.length; t++)
      typeof A[s[t]] == "function" && (p[p.length] = s[t]);
    return p;
  }, availableTypedArrays;
}
var callBind = { exports: {} }, defineDataProperty, hasRequiredDefineDataProperty;
function requireDefineDataProperty() {
  if (hasRequiredDefineDataProperty) return defineDataProperty;
  hasRequiredDefineDataProperty = 1;
  var s = /* @__PURE__ */ requireEsDefineProperty(), A = /* @__PURE__ */ requireSyntax(), u = /* @__PURE__ */ requireType(), p = /* @__PURE__ */ requireGopd();
  return defineDataProperty = function(l, m, b) {
    if (!l || typeof l != "object" && typeof l != "function")
      throw new u("`obj` must be an object or a function`");
    if (typeof m != "string" && typeof m != "symbol")
      throw new u("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
      throw new u("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
      throw new u("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
      throw new u("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != "boolean")
      throw new u("`loose`, if provided, must be a boolean");
    var k = arguments.length > 3 ? arguments[3] : null, C = arguments.length > 4 ? arguments[4] : null, B = arguments.length > 5 ? arguments[5] : null, Q = arguments.length > 6 ? arguments[6] : !1, P = !!p && p(l, m);
    if (s)
      s(l, m, {
        configurable: B === null && P ? P.configurable : !B,
        enumerable: k === null && P ? P.enumerable : !k,
        value: b,
        writable: C === null && P ? P.writable : !C
      });
    else if (Q || !k && !C && !B)
      l[m] = b;
    else
      throw new A("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }, defineDataProperty;
}
var hasPropertyDescriptors_1, hasRequiredHasPropertyDescriptors;
function requireHasPropertyDescriptors() {
  if (hasRequiredHasPropertyDescriptors) return hasPropertyDescriptors_1;
  hasRequiredHasPropertyDescriptors = 1;
  var s = /* @__PURE__ */ requireEsDefineProperty(), A = function() {
    return !!s;
  };
  return A.hasArrayLengthDefineBug = function() {
    if (!s)
      return null;
    try {
      return s([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, hasPropertyDescriptors_1 = A, hasPropertyDescriptors_1;
}
var setFunctionLength, hasRequiredSetFunctionLength;
function requireSetFunctionLength() {
  if (hasRequiredSetFunctionLength) return setFunctionLength;
  hasRequiredSetFunctionLength = 1;
  var s = /* @__PURE__ */ requireGetIntrinsic(), A = /* @__PURE__ */ requireDefineDataProperty(), u = /* @__PURE__ */ requireHasPropertyDescriptors()(), p = /* @__PURE__ */ requireGopd(), t = /* @__PURE__ */ requireType(), l = s("%Math.floor%");
  return setFunctionLength = function(b, k) {
    if (typeof b != "function")
      throw new t("`fn` is not a function");
    if (typeof k != "number" || k < 0 || k > 4294967295 || l(k) !== k)
      throw new t("`length` must be a positive 32-bit integer");
    var C = arguments.length > 2 && !!arguments[2], B = !0, Q = !0;
    if ("length" in b && p) {
      var P = p(b, "length");
      P && !P.configurable && (B = !1), P && !P.writable && (Q = !1);
    }
    return (B || Q || !C) && (u ? A(
      /** @type {Parameters<define>[0]} */
      b,
      "length",
      k,
      !0,
      !0
    ) : A(
      /** @type {Parameters<define>[0]} */
      b,
      "length",
      k
    )), b;
  }, setFunctionLength;
}
var applyBind, hasRequiredApplyBind;
function requireApplyBind() {
  if (hasRequiredApplyBind) return applyBind;
  hasRequiredApplyBind = 1;
  var s = requireFunctionBind(), A = requireFunctionApply(), u = requireActualApply();
  return applyBind = function() {
    return u(s, A, arguments);
  }, applyBind;
}
var hasRequiredCallBind;
function requireCallBind() {
  return hasRequiredCallBind || (hasRequiredCallBind = 1, function(s) {
    var A = /* @__PURE__ */ requireSetFunctionLength(), u = /* @__PURE__ */ requireEsDefineProperty(), p = requireCallBindApplyHelpers(), t = requireApplyBind();
    s.exports = function(m) {
      var b = p(arguments), k = m.length - (arguments.length - 1);
      return A(
        b,
        1 + (k > 0 ? k : 0),
        !0
      );
    }, u ? u(s.exports, "apply", { value: t }) : s.exports.apply = t;
  }(callBind)), callBind.exports;
}
var whichTypedArray, hasRequiredWhichTypedArray;
function requireWhichTypedArray() {
  if (hasRequiredWhichTypedArray) return whichTypedArray;
  hasRequiredWhichTypedArray = 1;
  var s = requireForEach(), A = /* @__PURE__ */ requireAvailableTypedArrays(), u = requireCallBind(), p = /* @__PURE__ */ requireCallBound$1(), t = /* @__PURE__ */ requireGopd(), l = requireGetProto(), m = p("Object.prototype.toString"), b = requireShams()(), k = typeof globalThis > "u" ? commonjsGlobal : globalThis, C = A(), B = p("String.prototype.slice"), Q = p("Array.prototype.indexOf", !0) || function(le, ge) {
    for (var pe = 0; pe < le.length; pe += 1)
      if (le[pe] === ge)
        return pe;
    return -1;
  }, P = { __proto__: null };
  b && t && l ? s(C, function(F) {
    var le = new k[F]();
    if (Symbol.toStringTag in le && l) {
      var ge = l(le), pe = t(ge, Symbol.toStringTag);
      if (!pe && ge) {
        var Ie = l(ge);
        pe = t(Ie, Symbol.toStringTag);
      }
      P["$" + F] = u(pe.get);
    }
  }) : s(C, function(F) {
    var le = new k[F](), ge = le.slice || le.set;
    ge && (P[
      /** @type {`$${import('.').TypedArrayName}`} */
      "$" + F
    ] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */
    // @ts-expect-error TODO FIXME
    u(ge));
  });
  var x = function(le) {
    var ge = !1;
    return s(
      /** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */
      P,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(pe, Ie) {
        if (!ge)
          try {
            "$" + pe(le) === Ie && (ge = /** @type {import('.').TypedArrayName} */
            B(Ie, 1));
          } catch {
          }
      }
    ), ge;
  }, M = function(le) {
    var ge = !1;
    return s(
      /** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */
      P,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(pe, Ie) {
        if (!ge)
          try {
            pe(le), ge = /** @type {import('.').TypedArrayName} */
            B(Ie, 1);
          } catch {
          }
      }
    ), ge;
  };
  return whichTypedArray = function(le) {
    if (!le || typeof le != "object")
      return !1;
    if (!b) {
      var ge = B(m(le), 8, -1);
      return Q(C, ge) > -1 ? ge : ge !== "Object" ? !1 : M(le);
    }
    return t ? x(le) : null;
  }, whichTypedArray;
}
var isTypedArray, hasRequiredIsTypedArray;
function requireIsTypedArray() {
  if (hasRequiredIsTypedArray) return isTypedArray;
  hasRequiredIsTypedArray = 1;
  var s = /* @__PURE__ */ requireWhichTypedArray();
  return isTypedArray = function(u) {
    return !!s(u);
  }, isTypedArray;
}
var hasRequiredTypes$8;
function requireTypes$8() {
  return hasRequiredTypes$8 || (hasRequiredTypes$8 = 1, function(s) {
    var A = /* @__PURE__ */ requireIsArguments$1(), u = requireIsGeneratorFunction(), p = /* @__PURE__ */ requireWhichTypedArray(), t = /* @__PURE__ */ requireIsTypedArray();
    function l(Tn) {
      return Tn.call.bind(Tn);
    }
    var m = typeof BigInt < "u", b = typeof Symbol < "u", k = l(Object.prototype.toString), C = l(Number.prototype.valueOf), B = l(String.prototype.valueOf), Q = l(Boolean.prototype.valueOf);
    if (m)
      var P = l(BigInt.prototype.valueOf);
    if (b)
      var x = l(Symbol.prototype.valueOf);
    function M(Tn, Yn) {
      if (typeof Tn != "object")
        return !1;
      try {
        return Yn(Tn), !0;
      } catch {
        return !1;
      }
    }
    s.isArgumentsObject = A, s.isGeneratorFunction = u, s.isTypedArray = t;
    function F(Tn) {
      return typeof Promise < "u" && Tn instanceof Promise || Tn !== null && typeof Tn == "object" && typeof Tn.then == "function" && typeof Tn.catch == "function";
    }
    s.isPromise = F;
    function le(Tn) {
      return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(Tn) : t(Tn) || br(Tn);
    }
    s.isArrayBufferView = le;
    function ge(Tn) {
      return p(Tn) === "Uint8Array";
    }
    s.isUint8Array = ge;
    function pe(Tn) {
      return p(Tn) === "Uint8ClampedArray";
    }
    s.isUint8ClampedArray = pe;
    function Ie(Tn) {
      return p(Tn) === "Uint16Array";
    }
    s.isUint16Array = Ie;
    function be(Tn) {
      return p(Tn) === "Uint32Array";
    }
    s.isUint32Array = be;
    function Pe(Tn) {
      return p(Tn) === "Int8Array";
    }
    s.isInt8Array = Pe;
    function Te(Tn) {
      return p(Tn) === "Int16Array";
    }
    s.isInt16Array = Te;
    function Qe(Tn) {
      return p(Tn) === "Int32Array";
    }
    s.isInt32Array = Qe;
    function xe(Tn) {
      return p(Tn) === "Float32Array";
    }
    s.isFloat32Array = xe;
    function Ee(Tn) {
      return p(Tn) === "Float64Array";
    }
    s.isFloat64Array = Ee;
    function He(Tn) {
      return p(Tn) === "BigInt64Array";
    }
    s.isBigInt64Array = He;
    function ve(Tn) {
      return p(Tn) === "BigUint64Array";
    }
    s.isBigUint64Array = ve;
    function we(Tn) {
      return k(Tn) === "[object Map]";
    }
    we.working = typeof Map < "u" && we(/* @__PURE__ */ new Map());
    function Ce(Tn) {
      return typeof Map > "u" ? !1 : we.working ? we(Tn) : Tn instanceof Map;
    }
    s.isMap = Ce;
    function Se(Tn) {
      return k(Tn) === "[object Set]";
    }
    Se.working = typeof Set < "u" && Se(/* @__PURE__ */ new Set());
    function Ne(Tn) {
      return typeof Set > "u" ? !1 : Se.working ? Se(Tn) : Tn instanceof Set;
    }
    s.isSet = Ne;
    function rr(Tn) {
      return k(Tn) === "[object WeakMap]";
    }
    rr.working = typeof WeakMap < "u" && rr(/* @__PURE__ */ new WeakMap());
    function er(Tn) {
      return typeof WeakMap > "u" ? !1 : rr.working ? rr(Tn) : Tn instanceof WeakMap;
    }
    s.isWeakMap = er;
    function ir(Tn) {
      return k(Tn) === "[object WeakSet]";
    }
    ir.working = typeof WeakSet < "u" && ir(/* @__PURE__ */ new WeakSet());
    function sr(Tn) {
      return ir(Tn);
    }
    s.isWeakSet = sr;
    function nr(Tn) {
      return k(Tn) === "[object ArrayBuffer]";
    }
    nr.working = typeof ArrayBuffer < "u" && nr(new ArrayBuffer());
    function fr(Tn) {
      return typeof ArrayBuffer > "u" ? !1 : nr.working ? nr(Tn) : Tn instanceof ArrayBuffer;
    }
    s.isArrayBuffer = fr;
    function lr(Tn) {
      return k(Tn) === "[object DataView]";
    }
    lr.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && lr(new DataView(new ArrayBuffer(1), 0, 1));
    function br(Tn) {
      return typeof DataView > "u" ? !1 : lr.working ? lr(Tn) : Tn instanceof DataView;
    }
    s.isDataView = br;
    var Br = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
    function Fr(Tn) {
      return k(Tn) === "[object SharedArrayBuffer]";
    }
    function Gr(Tn) {
      return typeof Br > "u" ? !1 : (typeof Fr.working > "u" && (Fr.working = Fr(new Br())), Fr.working ? Fr(Tn) : Tn instanceof Br);
    }
    s.isSharedArrayBuffer = Gr;
    function qr(Tn) {
      return k(Tn) === "[object AsyncFunction]";
    }
    s.isAsyncFunction = qr;
    function Hr(Tn) {
      return k(Tn) === "[object Map Iterator]";
    }
    s.isMapIterator = Hr;
    function un(Tn) {
      return k(Tn) === "[object Set Iterator]";
    }
    s.isSetIterator = un;
    function Dr(Tn) {
      return k(Tn) === "[object Generator]";
    }
    s.isGeneratorObject = Dr;
    function wr(Tn) {
      return k(Tn) === "[object WebAssembly.Module]";
    }
    s.isWebAssemblyCompiledModule = wr;
    function yr(Tn) {
      return M(Tn, C);
    }
    s.isNumberObject = yr;
    function Qr(Tn) {
      return M(Tn, B);
    }
    s.isStringObject = Qr;
    function _r(Tn) {
      return M(Tn, Q);
    }
    s.isBooleanObject = _r;
    function Jr(Tn) {
      return m && M(Tn, P);
    }
    s.isBigIntObject = Jr;
    function fn(Tn) {
      return b && M(Tn, x);
    }
    s.isSymbolObject = fn;
    function jr(Tn) {
      return yr(Tn) || Qr(Tn) || _r(Tn) || Jr(Tn) || fn(Tn);
    }
    s.isBoxedPrimitive = jr;
    function dn(Tn) {
      return typeof Uint8Array < "u" && (fr(Tn) || Gr(Tn));
    }
    s.isAnyArrayBuffer = dn, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(Tn) {
      Object.defineProperty(s, Tn, {
        enumerable: !1,
        value: function() {
          throw new Error(Tn + " is not supported in userland");
        }
      });
    });
  }(types$8)), types$8;
}
var isBufferBrowser, hasRequiredIsBufferBrowser;
function requireIsBufferBrowser() {
  return hasRequiredIsBufferBrowser || (hasRequiredIsBufferBrowser = 1, isBufferBrowser = function(A) {
    return A && typeof A == "object" && typeof A.copy == "function" && typeof A.fill == "function" && typeof A.readUInt8 == "function";
  }), isBufferBrowser;
}
var hasRequiredUtil$1;
function requireUtil$1() {
  return hasRequiredUtil$1 || (hasRequiredUtil$1 = 1, function(s) {
    var A = Object.getOwnPropertyDescriptors || function(br) {
      for (var Br = Object.keys(br), Fr = {}, Gr = 0; Gr < Br.length; Gr++)
        Fr[Br[Gr]] = Object.getOwnPropertyDescriptor(br, Br[Gr]);
      return Fr;
    }, u = /%[sdj%]/g;
    s.format = function(lr) {
      if (!Pe(lr)) {
        for (var br = [], Br = 0; Br < arguments.length; Br++)
          br.push(m(arguments[Br]));
        return br.join(" ");
      }
      for (var Br = 1, Fr = arguments, Gr = Fr.length, qr = String(lr).replace(u, function(un) {
        if (un === "%%") return "%";
        if (Br >= Gr) return un;
        switch (un) {
          case "%s":
            return String(Fr[Br++]);
          case "%d":
            return Number(Fr[Br++]);
          case "%j":
            try {
              return JSON.stringify(Fr[Br++]);
            } catch {
              return "[Circular]";
            }
          default:
            return un;
        }
      }), Hr = Fr[Br]; Br < Gr; Hr = Fr[++Br])
        pe(Hr) || !Ee(Hr) ? qr += " " + Hr : qr += " " + m(Hr);
      return qr;
    }, s.deprecate = function(lr, br) {
      if (typeof process$1 < "u" && process$1.noDeprecation === !0)
        return lr;
      if (typeof process$1 > "u")
        return function() {
          return s.deprecate(lr, br).apply(this, arguments);
        };
      var Br = !1;
      function Fr() {
        if (!Br) {
          if (process$1.throwDeprecation)
            throw new Error(br);
          process$1.traceDeprecation ? console.trace(br) : console.error(br), Br = !0;
        }
        return lr.apply(this, arguments);
      }
      return Fr;
    };
    var p = {}, t = /^$/;
    if (process$1.env.NODE_DEBUG) {
      var l = process$1.env.NODE_DEBUG;
      l = l.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), t = new RegExp("^" + l + "$", "i");
    }
    s.debuglog = function(lr) {
      if (lr = lr.toUpperCase(), !p[lr])
        if (t.test(lr)) {
          var br = process$1.pid;
          p[lr] = function() {
            var Br = s.format.apply(s, arguments);
            console.error("%s %d: %s", lr, br, Br);
          };
        } else
          p[lr] = function() {
          };
      return p[lr];
    };
    function m(lr, br) {
      var Br = {
        seen: [],
        stylize: k
      };
      return arguments.length >= 3 && (Br.depth = arguments[2]), arguments.length >= 4 && (Br.colors = arguments[3]), ge(br) ? Br.showHidden = br : br && s._extend(Br, br), Qe(Br.showHidden) && (Br.showHidden = !1), Qe(Br.depth) && (Br.depth = 2), Qe(Br.colors) && (Br.colors = !1), Qe(Br.customInspect) && (Br.customInspect = !0), Br.colors && (Br.stylize = b), B(Br, lr, Br.depth);
    }
    s.inspect = m, m.colors = {
      bold: [1, 22],
      italic: [3, 23],
      underline: [4, 24],
      inverse: [7, 27],
      white: [37, 39],
      grey: [90, 39],
      black: [30, 39],
      blue: [34, 39],
      cyan: [36, 39],
      green: [32, 39],
      magenta: [35, 39],
      red: [31, 39],
      yellow: [33, 39]
    }, m.styles = {
      special: "cyan",
      number: "yellow",
      boolean: "yellow",
      undefined: "grey",
      null: "bold",
      string: "green",
      date: "magenta",
      // "name": intentionally not styling
      regexp: "red"
    };
    function b(lr, br) {
      var Br = m.styles[br];
      return Br ? "\x1B[" + m.colors[Br][0] + "m" + lr + "\x1B[" + m.colors[Br][1] + "m" : lr;
    }
    function k(lr, br) {
      return lr;
    }
    function C(lr) {
      var br = {};
      return lr.forEach(function(Br, Fr) {
        br[Br] = !0;
      }), br;
    }
    function B(lr, br, Br) {
      if (lr.customInspect && br && we(br.inspect) && // Filter out the util module, it's inspect function is special
      br.inspect !== s.inspect && // Also filter out any prototype objects using the circular check.
      !(br.constructor && br.constructor.prototype === br)) {
        var Fr = br.inspect(Br, lr);
        return Pe(Fr) || (Fr = B(lr, Fr, Br)), Fr;
      }
      var Gr = Q(lr, br);
      if (Gr)
        return Gr;
      var qr = Object.keys(br), Hr = C(qr);
      if (lr.showHidden && (qr = Object.getOwnPropertyNames(br)), ve(br) && (qr.indexOf("message") >= 0 || qr.indexOf("description") >= 0))
        return P(br);
      if (qr.length === 0) {
        if (we(br)) {
          var un = br.name ? ": " + br.name : "";
          return lr.stylize("[Function" + un + "]", "special");
        }
        if (xe(br))
          return lr.stylize(RegExp.prototype.toString.call(br), "regexp");
        if (He(br))
          return lr.stylize(Date.prototype.toString.call(br), "date");
        if (ve(br))
          return P(br);
      }
      var Dr = "", wr = !1, yr = ["{", "}"];
      if (le(br) && (wr = !0, yr = ["[", "]"]), we(br)) {
        var Qr = br.name ? ": " + br.name : "";
        Dr = " [Function" + Qr + "]";
      }
      if (xe(br) && (Dr = " " + RegExp.prototype.toString.call(br)), He(br) && (Dr = " " + Date.prototype.toUTCString.call(br)), ve(br) && (Dr = " " + P(br)), qr.length === 0 && (!wr || br.length == 0))
        return yr[0] + Dr + yr[1];
      if (Br < 0)
        return xe(br) ? lr.stylize(RegExp.prototype.toString.call(br), "regexp") : lr.stylize("[Object]", "special");
      lr.seen.push(br);
      var _r;
      return wr ? _r = x(lr, br, Br, Hr, qr) : _r = qr.map(function(Jr) {
        return M(lr, br, Br, Hr, Jr, wr);
      }), lr.seen.pop(), F(_r, Dr, yr);
    }
    function Q(lr, br) {
      if (Qe(br))
        return lr.stylize("undefined", "undefined");
      if (Pe(br)) {
        var Br = "'" + JSON.stringify(br).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return lr.stylize(Br, "string");
      }
      if (be(br))
        return lr.stylize("" + br, "number");
      if (ge(br))
        return lr.stylize("" + br, "boolean");
      if (pe(br))
        return lr.stylize("null", "null");
    }
    function P(lr) {
      return "[" + Error.prototype.toString.call(lr) + "]";
    }
    function x(lr, br, Br, Fr, Gr) {
      for (var qr = [], Hr = 0, un = br.length; Hr < un; ++Hr)
        ir(br, String(Hr)) ? qr.push(M(
          lr,
          br,
          Br,
          Fr,
          String(Hr),
          !0
        )) : qr.push("");
      return Gr.forEach(function(Dr) {
        Dr.match(/^\d+$/) || qr.push(M(
          lr,
          br,
          Br,
          Fr,
          Dr,
          !0
        ));
      }), qr;
    }
    function M(lr, br, Br, Fr, Gr, qr) {
      var Hr, un, Dr;
      if (Dr = Object.getOwnPropertyDescriptor(br, Gr) || { value: br[Gr] }, Dr.get ? Dr.set ? un = lr.stylize("[Getter/Setter]", "special") : un = lr.stylize("[Getter]", "special") : Dr.set && (un = lr.stylize("[Setter]", "special")), ir(Fr, Gr) || (Hr = "[" + Gr + "]"), un || (lr.seen.indexOf(Dr.value) < 0 ? (pe(Br) ? un = B(lr, Dr.value, null) : un = B(lr, Dr.value, Br - 1), un.indexOf(`
`) > -1 && (qr ? un = un.split(`
`).map(function(wr) {
        return "  " + wr;
      }).join(`
`).slice(2) : un = `
` + un.split(`
`).map(function(wr) {
        return "   " + wr;
      }).join(`
`))) : un = lr.stylize("[Circular]", "special")), Qe(Hr)) {
        if (qr && Gr.match(/^\d+$/))
          return un;
        Hr = JSON.stringify("" + Gr), Hr.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (Hr = Hr.slice(1, -1), Hr = lr.stylize(Hr, "name")) : (Hr = Hr.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), Hr = lr.stylize(Hr, "string"));
      }
      return Hr + ": " + un;
    }
    function F(lr, br, Br) {
      var Fr = lr.reduce(function(Gr, qr) {
        return qr.indexOf(`
`) >= 0, Gr + qr.replace(/\u001b\[\d\d?m/g, "").length + 1;
      }, 0);
      return Fr > 60 ? Br[0] + (br === "" ? "" : br + `
 `) + " " + lr.join(`,
  `) + " " + Br[1] : Br[0] + br + " " + lr.join(", ") + " " + Br[1];
    }
    s.types = requireTypes$8();
    function le(lr) {
      return Array.isArray(lr);
    }
    s.isArray = le;
    function ge(lr) {
      return typeof lr == "boolean";
    }
    s.isBoolean = ge;
    function pe(lr) {
      return lr === null;
    }
    s.isNull = pe;
    function Ie(lr) {
      return lr == null;
    }
    s.isNullOrUndefined = Ie;
    function be(lr) {
      return typeof lr == "number";
    }
    s.isNumber = be;
    function Pe(lr) {
      return typeof lr == "string";
    }
    s.isString = Pe;
    function Te(lr) {
      return typeof lr == "symbol";
    }
    s.isSymbol = Te;
    function Qe(lr) {
      return lr === void 0;
    }
    s.isUndefined = Qe;
    function xe(lr) {
      return Ee(lr) && Se(lr) === "[object RegExp]";
    }
    s.isRegExp = xe, s.types.isRegExp = xe;
    function Ee(lr) {
      return typeof lr == "object" && lr !== null;
    }
    s.isObject = Ee;
    function He(lr) {
      return Ee(lr) && Se(lr) === "[object Date]";
    }
    s.isDate = He, s.types.isDate = He;
    function ve(lr) {
      return Ee(lr) && (Se(lr) === "[object Error]" || lr instanceof Error);
    }
    s.isError = ve, s.types.isNativeError = ve;
    function we(lr) {
      return typeof lr == "function";
    }
    s.isFunction = we;
    function Ce(lr) {
      return lr === null || typeof lr == "boolean" || typeof lr == "number" || typeof lr == "string" || typeof lr == "symbol" || // ES6 symbol
      typeof lr > "u";
    }
    s.isPrimitive = Ce, s.isBuffer = requireIsBufferBrowser();
    function Se(lr) {
      return Object.prototype.toString.call(lr);
    }
    function Ne(lr) {
      return lr < 10 ? "0" + lr.toString(10) : lr.toString(10);
    }
    var rr = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    function er() {
      var lr = /* @__PURE__ */ new Date(), br = [
        Ne(lr.getHours()),
        Ne(lr.getMinutes()),
        Ne(lr.getSeconds())
      ].join(":");
      return [lr.getDate(), rr[lr.getMonth()], br].join(" ");
    }
    s.log = function() {
      console.log("%s - %s", er(), s.format.apply(s, arguments));
    }, s.inherits = requireInherits_browser(), s._extend = function(lr, br) {
      if (!br || !Ee(br)) return lr;
      for (var Br = Object.keys(br), Fr = Br.length; Fr--; )
        lr[Br[Fr]] = br[Br[Fr]];
      return lr;
    };
    function ir(lr, br) {
      return Object.prototype.hasOwnProperty.call(lr, br);
    }
    var sr = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
    s.promisify = function(br) {
      if (typeof br != "function")
        throw new TypeError('The "original" argument must be of type Function');
      if (sr && br[sr]) {
        var Br = br[sr];
        if (typeof Br != "function")
          throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        return Object.defineProperty(Br, sr, {
          value: Br,
          enumerable: !1,
          writable: !1,
          configurable: !0
        }), Br;
      }
      function Br() {
        for (var Fr, Gr, qr = new Promise(function(Dr, wr) {
          Fr = Dr, Gr = wr;
        }), Hr = [], un = 0; un < arguments.length; un++)
          Hr.push(arguments[un]);
        Hr.push(function(Dr, wr) {
          Dr ? Gr(Dr) : Fr(wr);
        });
        try {
          br.apply(this, Hr);
        } catch (Dr) {
          Gr(Dr);
        }
        return qr;
      }
      return Object.setPrototypeOf(Br, Object.getPrototypeOf(br)), sr && Object.defineProperty(Br, sr, {
        value: Br,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Object.defineProperties(
        Br,
        A(br)
      );
    }, s.promisify.custom = sr;
    function nr(lr, br) {
      if (!lr) {
        var Br = new Error("Promise was rejected with a falsy value");
        Br.reason = lr, lr = Br;
      }
      return br(lr);
    }
    function fr(lr) {
      if (typeof lr != "function")
        throw new TypeError('The "original" argument must be of type Function');
      function br() {
        for (var Br = [], Fr = 0; Fr < arguments.length; Fr++)
          Br.push(arguments[Fr]);
        var Gr = Br.pop();
        if (typeof Gr != "function")
          throw new TypeError("The last argument must be of type Function");
        var qr = this, Hr = function() {
          return Gr.apply(qr, arguments);
        };
        lr.apply(this, Br).then(
          function(un) {
            process$1.nextTick(Hr.bind(null, null, un));
          },
          function(un) {
            process$1.nextTick(nr.bind(null, un, Hr));
          }
        );
      }
      return Object.setPrototypeOf(br, Object.getPrototypeOf(lr)), Object.defineProperties(
        br,
        A(lr)
      ), br;
    }
    s.callbackify = fr;
  }(util$1)), util$1;
}
var buffer_list, hasRequiredBuffer_list;
function requireBuffer_list() {
  if (hasRequiredBuffer_list) return buffer_list;
  hasRequiredBuffer_list = 1;
  function s(M, F) {
    var le = Object.keys(M);
    if (Object.getOwnPropertySymbols) {
      var ge = Object.getOwnPropertySymbols(M);
      F && (ge = ge.filter(function(pe) {
        return Object.getOwnPropertyDescriptor(M, pe).enumerable;
      })), le.push.apply(le, ge);
    }
    return le;
  }
  function A(M) {
    for (var F = 1; F < arguments.length; F++) {
      var le = arguments[F] != null ? arguments[F] : {};
      F % 2 ? s(Object(le), !0).forEach(function(ge) {
        u(M, ge, le[ge]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(M, Object.getOwnPropertyDescriptors(le)) : s(Object(le)).forEach(function(ge) {
        Object.defineProperty(M, ge, Object.getOwnPropertyDescriptor(le, ge));
      });
    }
    return M;
  }
  function u(M, F, le) {
    return F = m(F), F in M ? Object.defineProperty(M, F, { value: le, enumerable: !0, configurable: !0, writable: !0 }) : M[F] = le, M;
  }
  function p(M, F) {
    if (!(M instanceof F))
      throw new TypeError("Cannot call a class as a function");
  }
  function t(M, F) {
    for (var le = 0; le < F.length; le++) {
      var ge = F[le];
      ge.enumerable = ge.enumerable || !1, ge.configurable = !0, "value" in ge && (ge.writable = !0), Object.defineProperty(M, m(ge.key), ge);
    }
  }
  function l(M, F, le) {
    return F && t(M.prototype, F), Object.defineProperty(M, "prototype", { writable: !1 }), M;
  }
  function m(M) {
    var F = b(M, "string");
    return typeof F == "symbol" ? F : String(F);
  }
  function b(M, F) {
    if (typeof M != "object" || M === null) return M;
    var le = M[Symbol.toPrimitive];
    if (le !== void 0) {
      var ge = le.call(M, F);
      if (typeof ge != "object") return ge;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(M);
  }
  var k = requireDist$n(), C = k.Buffer, B = requireUtil$1(), Q = B.inspect, P = Q && Q.custom || "inspect";
  function x(M, F, le) {
    C.prototype.copy.call(M, F, le);
  }
  return buffer_list = /* @__PURE__ */ function() {
    function M() {
      p(this, M), this.head = null, this.tail = null, this.length = 0;
    }
    return l(M, [{
      key: "push",
      value: function(le) {
        var ge = {
          data: le,
          next: null
        };
        this.length > 0 ? this.tail.next = ge : this.head = ge, this.tail = ge, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(le) {
        var ge = {
          data: le,
          next: this.head
        };
        this.length === 0 && (this.tail = ge), this.head = ge, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var le = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, le;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(le) {
        if (this.length === 0) return "";
        for (var ge = this.head, pe = "" + ge.data; ge = ge.next; ) pe += le + ge.data;
        return pe;
      }
    }, {
      key: "concat",
      value: function(le) {
        if (this.length === 0) return C.alloc(0);
        for (var ge = C.allocUnsafe(le >>> 0), pe = this.head, Ie = 0; pe; )
          x(pe.data, ge, Ie), Ie += pe.data.length, pe = pe.next;
        return ge;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(le, ge) {
        var pe;
        return le < this.head.data.length ? (pe = this.head.data.slice(0, le), this.head.data = this.head.data.slice(le)) : le === this.head.data.length ? pe = this.shift() : pe = ge ? this._getString(le) : this._getBuffer(le), pe;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(le) {
        var ge = this.head, pe = 1, Ie = ge.data;
        for (le -= Ie.length; ge = ge.next; ) {
          var be = ge.data, Pe = le > be.length ? be.length : le;
          if (Pe === be.length ? Ie += be : Ie += be.slice(0, le), le -= Pe, le === 0) {
            Pe === be.length ? (++pe, ge.next ? this.head = ge.next : this.head = this.tail = null) : (this.head = ge, ge.data = be.slice(Pe));
            break;
          }
          ++pe;
        }
        return this.length -= pe, Ie;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(le) {
        var ge = C.allocUnsafe(le), pe = this.head, Ie = 1;
        for (pe.data.copy(ge), le -= pe.data.length; pe = pe.next; ) {
          var be = pe.data, Pe = le > be.length ? be.length : le;
          if (be.copy(ge, ge.length - le, 0, Pe), le -= Pe, le === 0) {
            Pe === be.length ? (++Ie, pe.next ? this.head = pe.next : this.head = this.tail = null) : (this.head = pe, pe.data = be.slice(Pe));
            break;
          }
          ++Ie;
        }
        return this.length -= Ie, ge;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: P,
      value: function(le, ge) {
        return Q(this, A(A({}, ge), {}, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), M;
  }(), buffer_list;
}
var destroy_1$1, hasRequiredDestroy$1;
function requireDestroy$1() {
  if (hasRequiredDestroy$1) return destroy_1$1;
  hasRequiredDestroy$1 = 1;
  function s(m, b) {
    var k = this, C = this._readableState && this._readableState.destroyed, B = this._writableState && this._writableState.destroyed;
    return C || B ? (b ? b(m) : m && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process$1.nextTick(t, this, m)) : process$1.nextTick(t, this, m)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(m || null, function(Q) {
      !b && Q ? k._writableState ? k._writableState.errorEmitted ? process$1.nextTick(u, k) : (k._writableState.errorEmitted = !0, process$1.nextTick(A, k, Q)) : process$1.nextTick(A, k, Q) : b ? (process$1.nextTick(u, k), b(Q)) : process$1.nextTick(u, k);
    }), this);
  }
  function A(m, b) {
    t(m, b), u(m);
  }
  function u(m) {
    m._writableState && !m._writableState.emitClose || m._readableState && !m._readableState.emitClose || m.emit("close");
  }
  function p() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function t(m, b) {
    m.emit("error", b);
  }
  function l(m, b) {
    var k = m._readableState, C = m._writableState;
    k && k.autoDestroy || C && C.autoDestroy ? m.destroy(b) : m.emit("error", b);
  }
  return destroy_1$1 = {
    destroy: s,
    undestroy: p,
    errorOrDestroy: l
  }, destroy_1$1;
}
var errorsBrowser = {}, hasRequiredErrorsBrowser;
function requireErrorsBrowser() {
  if (hasRequiredErrorsBrowser) return errorsBrowser;
  hasRequiredErrorsBrowser = 1;
  function s(b, k) {
    b.prototype = Object.create(k.prototype), b.prototype.constructor = b, b.__proto__ = k;
  }
  var A = {};
  function u(b, k, C) {
    C || (C = Error);
    function B(P, x, M) {
      return typeof k == "string" ? k : k(P, x, M);
    }
    var Q = /* @__PURE__ */ function(P) {
      s(x, P);
      function x(M, F, le) {
        return P.call(this, B(M, F, le)) || this;
      }
      return x;
    }(C);
    Q.prototype.name = C.name, Q.prototype.code = b, A[b] = Q;
  }
  function p(b, k) {
    if (Array.isArray(b)) {
      var C = b.length;
      return b = b.map(function(B) {
        return String(B);
      }), C > 2 ? "one of ".concat(k, " ").concat(b.slice(0, C - 1).join(", "), ", or ") + b[C - 1] : C === 2 ? "one of ".concat(k, " ").concat(b[0], " or ").concat(b[1]) : "of ".concat(k, " ").concat(b[0]);
    } else
      return "of ".concat(k, " ").concat(String(b));
  }
  function t(b, k, C) {
    return b.substr(0, k.length) === k;
  }
  function l(b, k, C) {
    return (C === void 0 || C > b.length) && (C = b.length), b.substring(C - k.length, C) === k;
  }
  function m(b, k, C) {
    return typeof C != "number" && (C = 0), C + k.length > b.length ? !1 : b.indexOf(k, C) !== -1;
  }
  return u("ERR_INVALID_OPT_VALUE", function(b, k) {
    return 'The value "' + k + '" is invalid for option "' + b + '"';
  }, TypeError), u("ERR_INVALID_ARG_TYPE", function(b, k, C) {
    var B;
    typeof k == "string" && t(k, "not ") ? (B = "must not be", k = k.replace(/^not /, "")) : B = "must be";
    var Q;
    if (l(b, " argument"))
      Q = "The ".concat(b, " ").concat(B, " ").concat(p(k, "type"));
    else {
      var P = m(b, ".") ? "property" : "argument";
      Q = 'The "'.concat(b, '" ').concat(P, " ").concat(B, " ").concat(p(k, "type"));
    }
    return Q += ". Received type ".concat(typeof C), Q;
  }, TypeError), u("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), u("ERR_METHOD_NOT_IMPLEMENTED", function(b) {
    return "The " + b + " method is not implemented";
  }), u("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), u("ERR_STREAM_DESTROYED", function(b) {
    return "Cannot call " + b + " after a stream was destroyed";
  }), u("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), u("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), u("ERR_STREAM_WRITE_AFTER_END", "write after end"), u("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), u("ERR_UNKNOWN_ENCODING", function(b) {
    return "Unknown encoding: " + b;
  }, TypeError), u("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), errorsBrowser.codes = A, errorsBrowser;
}
var state, hasRequiredState;
function requireState() {
  if (hasRequiredState) return state;
  hasRequiredState = 1;
  var s = requireErrorsBrowser().codes.ERR_INVALID_OPT_VALUE;
  function A(p, t, l) {
    return p.highWaterMark != null ? p.highWaterMark : t ? p[l] : null;
  }
  function u(p, t, l, m) {
    var b = A(t, m, l);
    if (b != null) {
      if (!(isFinite(b) && Math.floor(b) === b) || b < 0) {
        var k = m ? l : "highWaterMark";
        throw new s(k, b);
      }
      return Math.floor(b);
    }
    return p.objectMode ? 16 : 16 * 1024;
  }
  return state = {
    getHighWaterMark: u
  }, state;
}
var browser$b, hasRequiredBrowser$b;
function requireBrowser$b() {
  if (hasRequiredBrowser$b) return browser$b;
  hasRequiredBrowser$b = 1, browser$b = s;
  function s(u, p) {
    if (A("noDeprecation"))
      return u;
    var t = !1;
    function l() {
      if (!t) {
        if (A("throwDeprecation"))
          throw new Error(p);
        A("traceDeprecation") ? console.trace(p) : console.warn(p), t = !0;
      }
      return u.apply(this, arguments);
    }
    return l;
  }
  function A(u) {
    try {
      if (!commonjsGlobal.localStorage) return !1;
    } catch {
      return !1;
    }
    var p = commonjsGlobal.localStorage[u];
    return p == null ? !1 : String(p).toLowerCase() === "true";
  }
  return browser$b;
}
var _stream_writable$1, hasRequired_stream_writable$1;
function require_stream_writable$1() {
  if (hasRequired_stream_writable$1) return _stream_writable$1;
  hasRequired_stream_writable$1 = 1, _stream_writable$1 = xe;
  function s(Gr) {
    var qr = this;
    this.next = null, this.entry = null, this.finish = function() {
      Fr(qr, Gr);
    };
  }
  var A;
  xe.WritableState = Te;
  var u = {
    deprecate: requireBrowser$b()
  }, p = requireStreamBrowser$1(), t = requireDist$n().Buffer, l = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function m(Gr) {
    return t.from(Gr);
  }
  function b(Gr) {
    return t.isBuffer(Gr) || Gr instanceof l;
  }
  var k = requireDestroy$1(), C = requireState(), B = C.getHighWaterMark, Q = requireErrorsBrowser().codes, P = Q.ERR_INVALID_ARG_TYPE, x = Q.ERR_METHOD_NOT_IMPLEMENTED, M = Q.ERR_MULTIPLE_CALLBACK, F = Q.ERR_STREAM_CANNOT_PIPE, le = Q.ERR_STREAM_DESTROYED, ge = Q.ERR_STREAM_NULL_VALUES, pe = Q.ERR_STREAM_WRITE_AFTER_END, Ie = Q.ERR_UNKNOWN_ENCODING, be = k.errorOrDestroy;
  requireInherits_browser()(xe, p);
  function Pe() {
  }
  function Te(Gr, qr, Hr) {
    A = A || require_stream_duplex$1(), Gr = Gr || {}, typeof Hr != "boolean" && (Hr = qr instanceof A), this.objectMode = !!Gr.objectMode, Hr && (this.objectMode = this.objectMode || !!Gr.writableObjectMode), this.highWaterMark = B(this, Gr, "writableHighWaterMark", Hr), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var un = Gr.decodeStrings === !1;
    this.decodeStrings = !un, this.defaultEncoding = Gr.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(Dr) {
      rr(qr, Dr);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = Gr.emitClose !== !1, this.autoDestroy = !!Gr.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new s(this);
  }
  Te.prototype.getBuffer = function() {
    for (var qr = this.bufferedRequest, Hr = []; qr; )
      Hr.push(qr), qr = qr.next;
    return Hr;
  }, function() {
    try {
      Object.defineProperty(Te.prototype, "buffer", {
        get: u.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var Qe;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (Qe = Function.prototype[Symbol.hasInstance], Object.defineProperty(xe, Symbol.hasInstance, {
    value: function(qr) {
      return Qe.call(this, qr) ? !0 : this !== xe ? !1 : qr && qr._writableState instanceof Te;
    }
  })) : Qe = function(qr) {
    return qr instanceof this;
  };
  function xe(Gr) {
    A = A || require_stream_duplex$1();
    var qr = this instanceof A;
    if (!qr && !Qe.call(xe, this)) return new xe(Gr);
    this._writableState = new Te(Gr, this, qr), this.writable = !0, Gr && (typeof Gr.write == "function" && (this._write = Gr.write), typeof Gr.writev == "function" && (this._writev = Gr.writev), typeof Gr.destroy == "function" && (this._destroy = Gr.destroy), typeof Gr.final == "function" && (this._final = Gr.final)), p.call(this);
  }
  xe.prototype.pipe = function() {
    be(this, new F());
  };
  function Ee(Gr, qr) {
    var Hr = new pe();
    be(Gr, Hr), process$1.nextTick(qr, Hr);
  }
  function He(Gr, qr, Hr, un) {
    var Dr;
    return Hr === null ? Dr = new ge() : typeof Hr != "string" && !qr.objectMode && (Dr = new P("chunk", ["string", "Buffer"], Hr)), Dr ? (be(Gr, Dr), process$1.nextTick(un, Dr), !1) : !0;
  }
  xe.prototype.write = function(Gr, qr, Hr) {
    var un = this._writableState, Dr = !1, wr = !un.objectMode && b(Gr);
    return wr && !t.isBuffer(Gr) && (Gr = m(Gr)), typeof qr == "function" && (Hr = qr, qr = null), wr ? qr = "buffer" : qr || (qr = un.defaultEncoding), typeof Hr != "function" && (Hr = Pe), un.ending ? Ee(this, Hr) : (wr || He(this, un, Gr, Hr)) && (un.pendingcb++, Dr = we(this, un, wr, Gr, qr, Hr)), Dr;
  }, xe.prototype.cork = function() {
    this._writableState.corked++;
  }, xe.prototype.uncork = function() {
    var Gr = this._writableState;
    Gr.corked && (Gr.corked--, !Gr.writing && !Gr.corked && !Gr.bufferProcessing && Gr.bufferedRequest && sr(this, Gr));
  }, xe.prototype.setDefaultEncoding = function(qr) {
    if (typeof qr == "string" && (qr = qr.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((qr + "").toLowerCase()) > -1)) throw new Ie(qr);
    return this._writableState.defaultEncoding = qr, this;
  }, Object.defineProperty(xe.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function ve(Gr, qr, Hr) {
    return !Gr.objectMode && Gr.decodeStrings !== !1 && typeof qr == "string" && (qr = t.from(qr, Hr)), qr;
  }
  Object.defineProperty(xe.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function we(Gr, qr, Hr, un, Dr, wr) {
    if (!Hr) {
      var yr = ve(qr, un, Dr);
      un !== yr && (Hr = !0, Dr = "buffer", un = yr);
    }
    var Qr = qr.objectMode ? 1 : un.length;
    qr.length += Qr;
    var _r = qr.length < qr.highWaterMark;
    if (_r || (qr.needDrain = !0), qr.writing || qr.corked) {
      var Jr = qr.lastBufferedRequest;
      qr.lastBufferedRequest = {
        chunk: un,
        encoding: Dr,
        isBuf: Hr,
        callback: wr,
        next: null
      }, Jr ? Jr.next = qr.lastBufferedRequest : qr.bufferedRequest = qr.lastBufferedRequest, qr.bufferedRequestCount += 1;
    } else
      Ce(Gr, qr, !1, Qr, un, Dr, wr);
    return _r;
  }
  function Ce(Gr, qr, Hr, un, Dr, wr, yr) {
    qr.writelen = un, qr.writecb = yr, qr.writing = !0, qr.sync = !0, qr.destroyed ? qr.onwrite(new le("write")) : Hr ? Gr._writev(Dr, qr.onwrite) : Gr._write(Dr, wr, qr.onwrite), qr.sync = !1;
  }
  function Se(Gr, qr, Hr, un, Dr) {
    --qr.pendingcb, Hr ? (process$1.nextTick(Dr, un), process$1.nextTick(br, Gr, qr), Gr._writableState.errorEmitted = !0, be(Gr, un)) : (Dr(un), Gr._writableState.errorEmitted = !0, be(Gr, un), br(Gr, qr));
  }
  function Ne(Gr) {
    Gr.writing = !1, Gr.writecb = null, Gr.length -= Gr.writelen, Gr.writelen = 0;
  }
  function rr(Gr, qr) {
    var Hr = Gr._writableState, un = Hr.sync, Dr = Hr.writecb;
    if (typeof Dr != "function") throw new M();
    if (Ne(Hr), qr) Se(Gr, Hr, un, qr, Dr);
    else {
      var wr = nr(Hr) || Gr.destroyed;
      !wr && !Hr.corked && !Hr.bufferProcessing && Hr.bufferedRequest && sr(Gr, Hr), un ? process$1.nextTick(er, Gr, Hr, wr, Dr) : er(Gr, Hr, wr, Dr);
    }
  }
  function er(Gr, qr, Hr, un) {
    Hr || ir(Gr, qr), qr.pendingcb--, un(), br(Gr, qr);
  }
  function ir(Gr, qr) {
    qr.length === 0 && qr.needDrain && (qr.needDrain = !1, Gr.emit("drain"));
  }
  function sr(Gr, qr) {
    qr.bufferProcessing = !0;
    var Hr = qr.bufferedRequest;
    if (Gr._writev && Hr && Hr.next) {
      var un = qr.bufferedRequestCount, Dr = new Array(un), wr = qr.corkedRequestsFree;
      wr.entry = Hr;
      for (var yr = 0, Qr = !0; Hr; )
        Dr[yr] = Hr, Hr.isBuf || (Qr = !1), Hr = Hr.next, yr += 1;
      Dr.allBuffers = Qr, Ce(Gr, qr, !0, qr.length, Dr, "", wr.finish), qr.pendingcb++, qr.lastBufferedRequest = null, wr.next ? (qr.corkedRequestsFree = wr.next, wr.next = null) : qr.corkedRequestsFree = new s(qr), qr.bufferedRequestCount = 0;
    } else {
      for (; Hr; ) {
        var _r = Hr.chunk, Jr = Hr.encoding, fn = Hr.callback, jr = qr.objectMode ? 1 : _r.length;
        if (Ce(Gr, qr, !1, jr, _r, Jr, fn), Hr = Hr.next, qr.bufferedRequestCount--, qr.writing)
          break;
      }
      Hr === null && (qr.lastBufferedRequest = null);
    }
    qr.bufferedRequest = Hr, qr.bufferProcessing = !1;
  }
  xe.prototype._write = function(Gr, qr, Hr) {
    Hr(new x("_write()"));
  }, xe.prototype._writev = null, xe.prototype.end = function(Gr, qr, Hr) {
    var un = this._writableState;
    return typeof Gr == "function" ? (Hr = Gr, Gr = null, qr = null) : typeof qr == "function" && (Hr = qr, qr = null), Gr != null && this.write(Gr, qr), un.corked && (un.corked = 1, this.uncork()), un.ending || Br(this, un, Hr), this;
  }, Object.defineProperty(xe.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function nr(Gr) {
    return Gr.ending && Gr.length === 0 && Gr.bufferedRequest === null && !Gr.finished && !Gr.writing;
  }
  function fr(Gr, qr) {
    Gr._final(function(Hr) {
      qr.pendingcb--, Hr && be(Gr, Hr), qr.prefinished = !0, Gr.emit("prefinish"), br(Gr, qr);
    });
  }
  function lr(Gr, qr) {
    !qr.prefinished && !qr.finalCalled && (typeof Gr._final == "function" && !qr.destroyed ? (qr.pendingcb++, qr.finalCalled = !0, process$1.nextTick(fr, Gr, qr)) : (qr.prefinished = !0, Gr.emit("prefinish")));
  }
  function br(Gr, qr) {
    var Hr = nr(qr);
    if (Hr && (lr(Gr, qr), qr.pendingcb === 0 && (qr.finished = !0, Gr.emit("finish"), qr.autoDestroy))) {
      var un = Gr._readableState;
      (!un || un.autoDestroy && un.endEmitted) && Gr.destroy();
    }
    return Hr;
  }
  function Br(Gr, qr, Hr) {
    qr.ending = !0, br(Gr, qr), Hr && (qr.finished ? process$1.nextTick(Hr) : Gr.once("finish", Hr)), qr.ended = !0, Gr.writable = !1;
  }
  function Fr(Gr, qr, Hr) {
    var un = Gr.entry;
    for (Gr.entry = null; un; ) {
      var Dr = un.callback;
      qr.pendingcb--, Dr(Hr), un = un.next;
    }
    qr.corkedRequestsFree.next = Gr;
  }
  return Object.defineProperty(xe.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(qr) {
      this._writableState && (this._writableState.destroyed = qr);
    }
  }), xe.prototype.destroy = k.destroy, xe.prototype._undestroy = k.undestroy, xe.prototype._destroy = function(Gr, qr) {
    qr(Gr);
  }, _stream_writable$1;
}
var _stream_duplex$1, hasRequired_stream_duplex$1;
function require_stream_duplex$1() {
  if (hasRequired_stream_duplex$1) return _stream_duplex$1;
  hasRequired_stream_duplex$1 = 1;
  var s = Object.keys || function(C) {
    var B = [];
    for (var Q in C) B.push(Q);
    return B;
  };
  _stream_duplex$1 = m;
  var A = require_stream_readable$1(), u = require_stream_writable$1();
  requireInherits_browser()(m, A);
  for (var p = s(u.prototype), t = 0; t < p.length; t++) {
    var l = p[t];
    m.prototype[l] || (m.prototype[l] = u.prototype[l]);
  }
  function m(C) {
    if (!(this instanceof m)) return new m(C);
    A.call(this, C), u.call(this, C), this.allowHalfOpen = !0, C && (C.readable === !1 && (this.readable = !1), C.writable === !1 && (this.writable = !1), C.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", b)));
  }
  Object.defineProperty(m.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(m.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(m.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function b() {
    this._writableState.ended || process$1.nextTick(k, this);
  }
  function k(C) {
    C.end();
  }
  return Object.defineProperty(m.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(B) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = B, this._writableState.destroyed = B);
    }
  }), _stream_duplex$1;
}
var string_decoder = {}, hasRequiredString_decoder;
function requireString_decoder() {
  if (hasRequiredString_decoder) return string_decoder;
  hasRequiredString_decoder = 1;
  var s = requireSafeBuffer$1().Buffer, A = s.isEncoding || function(ge) {
    switch (ge = "" + ge, ge && ge.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function u(ge) {
    if (!ge) return "utf8";
    for (var pe; ; )
      switch (ge) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return ge;
        default:
          if (pe) return;
          ge = ("" + ge).toLowerCase(), pe = !0;
      }
  }
  function p(ge) {
    var pe = u(ge);
    if (typeof pe != "string" && (s.isEncoding === A || !A(ge))) throw new Error("Unknown encoding: " + ge);
    return pe || ge;
  }
  string_decoder.StringDecoder = t;
  function t(ge) {
    this.encoding = p(ge);
    var pe;
    switch (this.encoding) {
      case "utf16le":
        this.text = Q, this.end = P, pe = 4;
        break;
      case "utf8":
        this.fillLast = k, pe = 4;
        break;
      case "base64":
        this.text = x, this.end = M, pe = 3;
        break;
      default:
        this.write = F, this.end = le;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = s.allocUnsafe(pe);
  }
  t.prototype.write = function(ge) {
    if (ge.length === 0) return "";
    var pe, Ie;
    if (this.lastNeed) {
      if (pe = this.fillLast(ge), pe === void 0) return "";
      Ie = this.lastNeed, this.lastNeed = 0;
    } else
      Ie = 0;
    return Ie < ge.length ? pe ? pe + this.text(ge, Ie) : this.text(ge, Ie) : pe || "";
  }, t.prototype.end = B, t.prototype.text = C, t.prototype.fillLast = function(ge) {
    if (this.lastNeed <= ge.length)
      return ge.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    ge.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, ge.length), this.lastNeed -= ge.length;
  };
  function l(ge) {
    return ge <= 127 ? 0 : ge >> 5 === 6 ? 2 : ge >> 4 === 14 ? 3 : ge >> 3 === 30 ? 4 : ge >> 6 === 2 ? -1 : -2;
  }
  function m(ge, pe, Ie) {
    var be = pe.length - 1;
    if (be < Ie) return 0;
    var Pe = l(pe[be]);
    return Pe >= 0 ? (Pe > 0 && (ge.lastNeed = Pe - 1), Pe) : --be < Ie || Pe === -2 ? 0 : (Pe = l(pe[be]), Pe >= 0 ? (Pe > 0 && (ge.lastNeed = Pe - 2), Pe) : --be < Ie || Pe === -2 ? 0 : (Pe = l(pe[be]), Pe >= 0 ? (Pe > 0 && (Pe === 2 ? Pe = 0 : ge.lastNeed = Pe - 3), Pe) : 0));
  }
  function b(ge, pe, Ie) {
    if ((pe[0] & 192) !== 128)
      return ge.lastNeed = 0, "�";
    if (ge.lastNeed > 1 && pe.length > 1) {
      if ((pe[1] & 192) !== 128)
        return ge.lastNeed = 1, "�";
      if (ge.lastNeed > 2 && pe.length > 2 && (pe[2] & 192) !== 128)
        return ge.lastNeed = 2, "�";
    }
  }
  function k(ge) {
    var pe = this.lastTotal - this.lastNeed, Ie = b(this, ge);
    if (Ie !== void 0) return Ie;
    if (this.lastNeed <= ge.length)
      return ge.copy(this.lastChar, pe, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    ge.copy(this.lastChar, pe, 0, ge.length), this.lastNeed -= ge.length;
  }
  function C(ge, pe) {
    var Ie = m(this, ge, pe);
    if (!this.lastNeed) return ge.toString("utf8", pe);
    this.lastTotal = Ie;
    var be = ge.length - (Ie - this.lastNeed);
    return ge.copy(this.lastChar, 0, be), ge.toString("utf8", pe, be);
  }
  function B(ge) {
    var pe = ge && ge.length ? this.write(ge) : "";
    return this.lastNeed ? pe + "�" : pe;
  }
  function Q(ge, pe) {
    if ((ge.length - pe) % 2 === 0) {
      var Ie = ge.toString("utf16le", pe);
      if (Ie) {
        var be = Ie.charCodeAt(Ie.length - 1);
        if (be >= 55296 && be <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = ge[ge.length - 2], this.lastChar[1] = ge[ge.length - 1], Ie.slice(0, -1);
      }
      return Ie;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = ge[ge.length - 1], ge.toString("utf16le", pe, ge.length - 1);
  }
  function P(ge) {
    var pe = ge && ge.length ? this.write(ge) : "";
    if (this.lastNeed) {
      var Ie = this.lastTotal - this.lastNeed;
      return pe + this.lastChar.toString("utf16le", 0, Ie);
    }
    return pe;
  }
  function x(ge, pe) {
    var Ie = (ge.length - pe) % 3;
    return Ie === 0 ? ge.toString("base64", pe) : (this.lastNeed = 3 - Ie, this.lastTotal = 3, Ie === 1 ? this.lastChar[0] = ge[ge.length - 1] : (this.lastChar[0] = ge[ge.length - 2], this.lastChar[1] = ge[ge.length - 1]), ge.toString("base64", pe, ge.length - Ie));
  }
  function M(ge) {
    var pe = ge && ge.length ? this.write(ge) : "";
    return this.lastNeed ? pe + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : pe;
  }
  function F(ge) {
    return ge.toString(this.encoding);
  }
  function le(ge) {
    return ge && ge.length ? this.write(ge) : "";
  }
  return string_decoder;
}
var endOfStream, hasRequiredEndOfStream;
function requireEndOfStream() {
  if (hasRequiredEndOfStream) return endOfStream;
  hasRequiredEndOfStream = 1;
  var s = requireErrorsBrowser().codes.ERR_STREAM_PREMATURE_CLOSE;
  function A(l) {
    var m = !1;
    return function() {
      if (!m) {
        m = !0;
        for (var b = arguments.length, k = new Array(b), C = 0; C < b; C++)
          k[C] = arguments[C];
        l.apply(this, k);
      }
    };
  }
  function u() {
  }
  function p(l) {
    return l.setHeader && typeof l.abort == "function";
  }
  function t(l, m, b) {
    if (typeof m == "function") return t(l, null, m);
    m || (m = {}), b = A(b || u);
    var k = m.readable || m.readable !== !1 && l.readable, C = m.writable || m.writable !== !1 && l.writable, B = function() {
      l.writable || P();
    }, Q = l._writableState && l._writableState.finished, P = function() {
      C = !1, Q = !0, k || b.call(l);
    }, x = l._readableState && l._readableState.endEmitted, M = function() {
      k = !1, x = !0, C || b.call(l);
    }, F = function(Ie) {
      b.call(l, Ie);
    }, le = function() {
      var Ie;
      if (k && !x)
        return (!l._readableState || !l._readableState.ended) && (Ie = new s()), b.call(l, Ie);
      if (C && !Q)
        return (!l._writableState || !l._writableState.ended) && (Ie = new s()), b.call(l, Ie);
    }, ge = function() {
      l.req.on("finish", P);
    };
    return p(l) ? (l.on("complete", P), l.on("abort", le), l.req ? ge() : l.on("request", ge)) : C && !l._writableState && (l.on("end", B), l.on("close", B)), l.on("end", M), l.on("finish", P), m.error !== !1 && l.on("error", F), l.on("close", le), function() {
      l.removeListener("complete", P), l.removeListener("abort", le), l.removeListener("request", ge), l.req && l.req.removeListener("finish", P), l.removeListener("end", B), l.removeListener("close", B), l.removeListener("finish", P), l.removeListener("end", M), l.removeListener("error", F), l.removeListener("close", le);
    };
  }
  return endOfStream = t, endOfStream;
}
var async_iterator, hasRequiredAsync_iterator;
function requireAsync_iterator() {
  if (hasRequiredAsync_iterator) return async_iterator;
  hasRequiredAsync_iterator = 1;
  var s;
  function A(Ie, be, Pe) {
    return be = u(be), be in Ie ? Object.defineProperty(Ie, be, { value: Pe, enumerable: !0, configurable: !0, writable: !0 }) : Ie[be] = Pe, Ie;
  }
  function u(Ie) {
    var be = p(Ie, "string");
    return typeof be == "symbol" ? be : String(be);
  }
  function p(Ie, be) {
    if (typeof Ie != "object" || Ie === null) return Ie;
    var Pe = Ie[Symbol.toPrimitive];
    if (Pe !== void 0) {
      var Te = Pe.call(Ie, be);
      if (typeof Te != "object") return Te;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (be === "string" ? String : Number)(Ie);
  }
  var t = requireEndOfStream(), l = Symbol("lastResolve"), m = Symbol("lastReject"), b = Symbol("error"), k = Symbol("ended"), C = Symbol("lastPromise"), B = Symbol("handlePromise"), Q = Symbol("stream");
  function P(Ie, be) {
    return {
      value: Ie,
      done: be
    };
  }
  function x(Ie) {
    var be = Ie[l];
    if (be !== null) {
      var Pe = Ie[Q].read();
      Pe !== null && (Ie[C] = null, Ie[l] = null, Ie[m] = null, be(P(Pe, !1)));
    }
  }
  function M(Ie) {
    process$1.nextTick(x, Ie);
  }
  function F(Ie, be) {
    return function(Pe, Te) {
      Ie.then(function() {
        if (be[k]) {
          Pe(P(void 0, !0));
          return;
        }
        be[B](Pe, Te);
      }, Te);
    };
  }
  var le = Object.getPrototypeOf(function() {
  }), ge = Object.setPrototypeOf((s = {
    get stream() {
      return this[Q];
    },
    next: function() {
      var be = this, Pe = this[b];
      if (Pe !== null)
        return Promise.reject(Pe);
      if (this[k])
        return Promise.resolve(P(void 0, !0));
      if (this[Q].destroyed)
        return new Promise(function(Ee, He) {
          process$1.nextTick(function() {
            be[b] ? He(be[b]) : Ee(P(void 0, !0));
          });
        });
      var Te = this[C], Qe;
      if (Te)
        Qe = new Promise(F(Te, this));
      else {
        var xe = this[Q].read();
        if (xe !== null)
          return Promise.resolve(P(xe, !1));
        Qe = new Promise(this[B]);
      }
      return this[C] = Qe, Qe;
    }
  }, A(s, Symbol.asyncIterator, function() {
    return this;
  }), A(s, "return", function() {
    var be = this;
    return new Promise(function(Pe, Te) {
      be[Q].destroy(null, function(Qe) {
        if (Qe) {
          Te(Qe);
          return;
        }
        Pe(P(void 0, !0));
      });
    });
  }), s), le), pe = function(be) {
    var Pe, Te = Object.create(ge, (Pe = {}, A(Pe, Q, {
      value: be,
      writable: !0
    }), A(Pe, l, {
      value: null,
      writable: !0
    }), A(Pe, m, {
      value: null,
      writable: !0
    }), A(Pe, b, {
      value: null,
      writable: !0
    }), A(Pe, k, {
      value: be._readableState.endEmitted,
      writable: !0
    }), A(Pe, B, {
      value: function(xe, Ee) {
        var He = Te[Q].read();
        He ? (Te[C] = null, Te[l] = null, Te[m] = null, xe(P(He, !1))) : (Te[l] = xe, Te[m] = Ee);
      },
      writable: !0
    }), Pe));
    return Te[C] = null, t(be, function(Qe) {
      if (Qe && Qe.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var xe = Te[m];
        xe !== null && (Te[C] = null, Te[l] = null, Te[m] = null, xe(Qe)), Te[b] = Qe;
        return;
      }
      var Ee = Te[l];
      Ee !== null && (Te[C] = null, Te[l] = null, Te[m] = null, Ee(P(void 0, !0))), Te[k] = !0;
    }), be.on("readable", M.bind(null, Te)), Te;
  };
  return async_iterator = pe, async_iterator;
}
var fromBrowser, hasRequiredFromBrowser;
function requireFromBrowser() {
  return hasRequiredFromBrowser || (hasRequiredFromBrowser = 1, fromBrowser = function() {
    throw new Error("Readable.from is not available in the browser");
  }), fromBrowser;
}
var _stream_readable$1, hasRequired_stream_readable$1;
function require_stream_readable$1() {
  if (hasRequired_stream_readable$1) return _stream_readable$1;
  hasRequired_stream_readable$1 = 1, _stream_readable$1 = Ee;
  var s;
  Ee.ReadableState = xe, requireEvents().EventEmitter;
  var A = function(yr, Qr) {
    return yr.listeners(Qr).length;
  }, u = requireStreamBrowser$1(), p = requireDist$n().Buffer, t = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function l(wr) {
    return p.from(wr);
  }
  function m(wr) {
    return p.isBuffer(wr) || wr instanceof t;
  }
  var b = requireUtil$1(), k;
  b && b.debuglog ? k = b.debuglog("stream") : k = function() {
  };
  var C = requireBuffer_list(), B = requireDestroy$1(), Q = requireState(), P = Q.getHighWaterMark, x = requireErrorsBrowser().codes, M = x.ERR_INVALID_ARG_TYPE, F = x.ERR_STREAM_PUSH_AFTER_EOF, le = x.ERR_METHOD_NOT_IMPLEMENTED, ge = x.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, pe, Ie, be;
  requireInherits_browser()(Ee, u);
  var Pe = B.errorOrDestroy, Te = ["error", "close", "destroy", "pause", "resume"];
  function Qe(wr, yr, Qr) {
    if (typeof wr.prependListener == "function") return wr.prependListener(yr, Qr);
    !wr._events || !wr._events[yr] ? wr.on(yr, Qr) : Array.isArray(wr._events[yr]) ? wr._events[yr].unshift(Qr) : wr._events[yr] = [Qr, wr._events[yr]];
  }
  function xe(wr, yr, Qr) {
    s = s || require_stream_duplex$1(), wr = wr || {}, typeof Qr != "boolean" && (Qr = yr instanceof s), this.objectMode = !!wr.objectMode, Qr && (this.objectMode = this.objectMode || !!wr.readableObjectMode), this.highWaterMark = P(this, wr, "readableHighWaterMark", Qr), this.buffer = new C(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = wr.emitClose !== !1, this.autoDestroy = !!wr.autoDestroy, this.destroyed = !1, this.defaultEncoding = wr.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, wr.encoding && (pe || (pe = requireString_decoder().StringDecoder), this.decoder = new pe(wr.encoding), this.encoding = wr.encoding);
  }
  function Ee(wr) {
    if (s = s || require_stream_duplex$1(), !(this instanceof Ee)) return new Ee(wr);
    var yr = this instanceof s;
    this._readableState = new xe(wr, this, yr), this.readable = !0, wr && (typeof wr.read == "function" && (this._read = wr.read), typeof wr.destroy == "function" && (this._destroy = wr.destroy)), u.call(this);
  }
  Object.defineProperty(Ee.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(yr) {
      this._readableState && (this._readableState.destroyed = yr);
    }
  }), Ee.prototype.destroy = B.destroy, Ee.prototype._undestroy = B.undestroy, Ee.prototype._destroy = function(wr, yr) {
    yr(wr);
  }, Ee.prototype.push = function(wr, yr) {
    var Qr = this._readableState, _r;
    return Qr.objectMode ? _r = !0 : typeof wr == "string" && (yr = yr || Qr.defaultEncoding, yr !== Qr.encoding && (wr = p.from(wr, yr), yr = ""), _r = !0), He(this, wr, yr, !1, _r);
  }, Ee.prototype.unshift = function(wr) {
    return He(this, wr, null, !0, !1);
  };
  function He(wr, yr, Qr, _r, Jr) {
    k("readableAddChunk", yr);
    var fn = wr._readableState;
    if (yr === null)
      fn.reading = !1, rr(wr, fn);
    else {
      var jr;
      if (Jr || (jr = we(fn, yr)), jr)
        Pe(wr, jr);
      else if (fn.objectMode || yr && yr.length > 0)
        if (typeof yr != "string" && !fn.objectMode && Object.getPrototypeOf(yr) !== p.prototype && (yr = l(yr)), _r)
          fn.endEmitted ? Pe(wr, new ge()) : ve(wr, fn, yr, !0);
        else if (fn.ended)
          Pe(wr, new F());
        else {
          if (fn.destroyed)
            return !1;
          fn.reading = !1, fn.decoder && !Qr ? (yr = fn.decoder.write(yr), fn.objectMode || yr.length !== 0 ? ve(wr, fn, yr, !1) : sr(wr, fn)) : ve(wr, fn, yr, !1);
        }
      else _r || (fn.reading = !1, sr(wr, fn));
    }
    return !fn.ended && (fn.length < fn.highWaterMark || fn.length === 0);
  }
  function ve(wr, yr, Qr, _r) {
    yr.flowing && yr.length === 0 && !yr.sync ? (yr.awaitDrain = 0, wr.emit("data", Qr)) : (yr.length += yr.objectMode ? 1 : Qr.length, _r ? yr.buffer.unshift(Qr) : yr.buffer.push(Qr), yr.needReadable && er(wr)), sr(wr, yr);
  }
  function we(wr, yr) {
    var Qr;
    return !m(yr) && typeof yr != "string" && yr !== void 0 && !wr.objectMode && (Qr = new M("chunk", ["string", "Buffer", "Uint8Array"], yr)), Qr;
  }
  Ee.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, Ee.prototype.setEncoding = function(wr) {
    pe || (pe = requireString_decoder().StringDecoder);
    var yr = new pe(wr);
    this._readableState.decoder = yr, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var Qr = this._readableState.buffer.head, _r = ""; Qr !== null; )
      _r += yr.write(Qr.data), Qr = Qr.next;
    return this._readableState.buffer.clear(), _r !== "" && this._readableState.buffer.push(_r), this._readableState.length = _r.length, this;
  };
  var Ce = 1073741824;
  function Se(wr) {
    return wr >= Ce ? wr = Ce : (wr--, wr |= wr >>> 1, wr |= wr >>> 2, wr |= wr >>> 4, wr |= wr >>> 8, wr |= wr >>> 16, wr++), wr;
  }
  function Ne(wr, yr) {
    return wr <= 0 || yr.length === 0 && yr.ended ? 0 : yr.objectMode ? 1 : wr !== wr ? yr.flowing && yr.length ? yr.buffer.head.data.length : yr.length : (wr > yr.highWaterMark && (yr.highWaterMark = Se(wr)), wr <= yr.length ? wr : yr.ended ? yr.length : (yr.needReadable = !0, 0));
  }
  Ee.prototype.read = function(wr) {
    k("read", wr), wr = parseInt(wr, 10);
    var yr = this._readableState, Qr = wr;
    if (wr !== 0 && (yr.emittedReadable = !1), wr === 0 && yr.needReadable && ((yr.highWaterMark !== 0 ? yr.length >= yr.highWaterMark : yr.length > 0) || yr.ended))
      return k("read: emitReadable", yr.length, yr.ended), yr.length === 0 && yr.ended ? Hr(this) : er(this), null;
    if (wr = Ne(wr, yr), wr === 0 && yr.ended)
      return yr.length === 0 && Hr(this), null;
    var _r = yr.needReadable;
    k("need readable", _r), (yr.length === 0 || yr.length - wr < yr.highWaterMark) && (_r = !0, k("length less than watermark", _r)), yr.ended || yr.reading ? (_r = !1, k("reading or ended", _r)) : _r && (k("do read"), yr.reading = !0, yr.sync = !0, yr.length === 0 && (yr.needReadable = !0), this._read(yr.highWaterMark), yr.sync = !1, yr.reading || (wr = Ne(Qr, yr)));
    var Jr;
    return wr > 0 ? Jr = qr(wr, yr) : Jr = null, Jr === null ? (yr.needReadable = yr.length <= yr.highWaterMark, wr = 0) : (yr.length -= wr, yr.awaitDrain = 0), yr.length === 0 && (yr.ended || (yr.needReadable = !0), Qr !== wr && yr.ended && Hr(this)), Jr !== null && this.emit("data", Jr), Jr;
  };
  function rr(wr, yr) {
    if (k("onEofChunk"), !yr.ended) {
      if (yr.decoder) {
        var Qr = yr.decoder.end();
        Qr && Qr.length && (yr.buffer.push(Qr), yr.length += yr.objectMode ? 1 : Qr.length);
      }
      yr.ended = !0, yr.sync ? er(wr) : (yr.needReadable = !1, yr.emittedReadable || (yr.emittedReadable = !0, ir(wr)));
    }
  }
  function er(wr) {
    var yr = wr._readableState;
    k("emitReadable", yr.needReadable, yr.emittedReadable), yr.needReadable = !1, yr.emittedReadable || (k("emitReadable", yr.flowing), yr.emittedReadable = !0, process$1.nextTick(ir, wr));
  }
  function ir(wr) {
    var yr = wr._readableState;
    k("emitReadable_", yr.destroyed, yr.length, yr.ended), !yr.destroyed && (yr.length || yr.ended) && (wr.emit("readable"), yr.emittedReadable = !1), yr.needReadable = !yr.flowing && !yr.ended && yr.length <= yr.highWaterMark, Gr(wr);
  }
  function sr(wr, yr) {
    yr.readingMore || (yr.readingMore = !0, process$1.nextTick(nr, wr, yr));
  }
  function nr(wr, yr) {
    for (; !yr.reading && !yr.ended && (yr.length < yr.highWaterMark || yr.flowing && yr.length === 0); ) {
      var Qr = yr.length;
      if (k("maybeReadMore read 0"), wr.read(0), Qr === yr.length)
        break;
    }
    yr.readingMore = !1;
  }
  Ee.prototype._read = function(wr) {
    Pe(this, new le("_read()"));
  }, Ee.prototype.pipe = function(wr, yr) {
    var Qr = this, _r = this._readableState;
    switch (_r.pipesCount) {
      case 0:
        _r.pipes = wr;
        break;
      case 1:
        _r.pipes = [_r.pipes, wr];
        break;
      default:
        _r.pipes.push(wr);
        break;
    }
    _r.pipesCount += 1, k("pipe count=%d opts=%j", _r.pipesCount, yr);
    var Jr = (!yr || yr.end !== !1) && wr !== process$1.stdout && wr !== process$1.stderr, fn = Jr ? dn : zr;
    _r.endEmitted ? process$1.nextTick(fn) : Qr.once("end", fn), wr.on("unpipe", jr);
    function jr(En, Zr) {
      k("onunpipe"), En === Qr && Zr && Zr.hasUnpiped === !1 && (Zr.hasUnpiped = !0, si());
    }
    function dn() {
      k("onend"), wr.end();
    }
    var Tn = fr(Qr);
    wr.on("drain", Tn);
    var Yn = !1;
    function si() {
      k("cleanup"), wr.removeListener("close", Xr), wr.removeListener("finish", In), wr.removeListener("drain", Tn), wr.removeListener("error", Cn), wr.removeListener("unpipe", jr), Qr.removeListener("end", dn), Qr.removeListener("end", zr), Qr.removeListener("data", vn), Yn = !0, _r.awaitDrain && (!wr._writableState || wr._writableState.needDrain) && Tn();
    }
    Qr.on("data", vn);
    function vn(En) {
      k("ondata");
      var Zr = wr.write(En);
      k("dest.write", Zr), Zr === !1 && ((_r.pipesCount === 1 && _r.pipes === wr || _r.pipesCount > 1 && Dr(_r.pipes, wr) !== -1) && !Yn && (k("false write response, pause", _r.awaitDrain), _r.awaitDrain++), Qr.pause());
    }
    function Cn(En) {
      k("onerror", En), zr(), wr.removeListener("error", Cn), A(wr, "error") === 0 && Pe(wr, En);
    }
    Qe(wr, "error", Cn);
    function Xr() {
      wr.removeListener("finish", In), zr();
    }
    wr.once("close", Xr);
    function In() {
      k("onfinish"), wr.removeListener("close", Xr), zr();
    }
    wr.once("finish", In);
    function zr() {
      k("unpipe"), Qr.unpipe(wr);
    }
    return wr.emit("pipe", Qr), _r.flowing || (k("pipe resume"), Qr.resume()), wr;
  };
  function fr(wr) {
    return function() {
      var Qr = wr._readableState;
      k("pipeOnDrain", Qr.awaitDrain), Qr.awaitDrain && Qr.awaitDrain--, Qr.awaitDrain === 0 && A(wr, "data") && (Qr.flowing = !0, Gr(wr));
    };
  }
  Ee.prototype.unpipe = function(wr) {
    var yr = this._readableState, Qr = {
      hasUnpiped: !1
    };
    if (yr.pipesCount === 0) return this;
    if (yr.pipesCount === 1)
      return wr && wr !== yr.pipes ? this : (wr || (wr = yr.pipes), yr.pipes = null, yr.pipesCount = 0, yr.flowing = !1, wr && wr.emit("unpipe", this, Qr), this);
    if (!wr) {
      var _r = yr.pipes, Jr = yr.pipesCount;
      yr.pipes = null, yr.pipesCount = 0, yr.flowing = !1;
      for (var fn = 0; fn < Jr; fn++) _r[fn].emit("unpipe", this, {
        hasUnpiped: !1
      });
      return this;
    }
    var jr = Dr(yr.pipes, wr);
    return jr === -1 ? this : (yr.pipes.splice(jr, 1), yr.pipesCount -= 1, yr.pipesCount === 1 && (yr.pipes = yr.pipes[0]), wr.emit("unpipe", this, Qr), this);
  }, Ee.prototype.on = function(wr, yr) {
    var Qr = u.prototype.on.call(this, wr, yr), _r = this._readableState;
    return wr === "data" ? (_r.readableListening = this.listenerCount("readable") > 0, _r.flowing !== !1 && this.resume()) : wr === "readable" && !_r.endEmitted && !_r.readableListening && (_r.readableListening = _r.needReadable = !0, _r.flowing = !1, _r.emittedReadable = !1, k("on readable", _r.length, _r.reading), _r.length ? er(this) : _r.reading || process$1.nextTick(br, this)), Qr;
  }, Ee.prototype.addListener = Ee.prototype.on, Ee.prototype.removeListener = function(wr, yr) {
    var Qr = u.prototype.removeListener.call(this, wr, yr);
    return wr === "readable" && process$1.nextTick(lr, this), Qr;
  }, Ee.prototype.removeAllListeners = function(wr) {
    var yr = u.prototype.removeAllListeners.apply(this, arguments);
    return (wr === "readable" || wr === void 0) && process$1.nextTick(lr, this), yr;
  };
  function lr(wr) {
    var yr = wr._readableState;
    yr.readableListening = wr.listenerCount("readable") > 0, yr.resumeScheduled && !yr.paused ? yr.flowing = !0 : wr.listenerCount("data") > 0 && wr.resume();
  }
  function br(wr) {
    k("readable nexttick read 0"), wr.read(0);
  }
  Ee.prototype.resume = function() {
    var wr = this._readableState;
    return wr.flowing || (k("resume"), wr.flowing = !wr.readableListening, Br(this, wr)), wr.paused = !1, this;
  };
  function Br(wr, yr) {
    yr.resumeScheduled || (yr.resumeScheduled = !0, process$1.nextTick(Fr, wr, yr));
  }
  function Fr(wr, yr) {
    k("resume", yr.reading), yr.reading || wr.read(0), yr.resumeScheduled = !1, wr.emit("resume"), Gr(wr), yr.flowing && !yr.reading && wr.read(0);
  }
  Ee.prototype.pause = function() {
    return k("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (k("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function Gr(wr) {
    var yr = wr._readableState;
    for (k("flow", yr.flowing); yr.flowing && wr.read() !== null; ) ;
  }
  Ee.prototype.wrap = function(wr) {
    var yr = this, Qr = this._readableState, _r = !1;
    wr.on("end", function() {
      if (k("wrapped end"), Qr.decoder && !Qr.ended) {
        var jr = Qr.decoder.end();
        jr && jr.length && yr.push(jr);
      }
      yr.push(null);
    }), wr.on("data", function(jr) {
      if (k("wrapped data"), Qr.decoder && (jr = Qr.decoder.write(jr)), !(Qr.objectMode && jr == null) && !(!Qr.objectMode && (!jr || !jr.length))) {
        var dn = yr.push(jr);
        dn || (_r = !0, wr.pause());
      }
    });
    for (var Jr in wr)
      this[Jr] === void 0 && typeof wr[Jr] == "function" && (this[Jr] = /* @__PURE__ */ function(dn) {
        return function() {
          return wr[dn].apply(wr, arguments);
        };
      }(Jr));
    for (var fn = 0; fn < Te.length; fn++)
      wr.on(Te[fn], this.emit.bind(this, Te[fn]));
    return this._read = function(jr) {
      k("wrapped _read", jr), _r && (_r = !1, wr.resume());
    }, this;
  }, typeof Symbol == "function" && (Ee.prototype[Symbol.asyncIterator] = function() {
    return Ie === void 0 && (Ie = requireAsync_iterator()), Ie(this);
  }), Object.defineProperty(Ee.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(Ee.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(Ee.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(yr) {
      this._readableState && (this._readableState.flowing = yr);
    }
  }), Ee._fromList = qr, Object.defineProperty(Ee.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function qr(wr, yr) {
    if (yr.length === 0) return null;
    var Qr;
    return yr.objectMode ? Qr = yr.buffer.shift() : !wr || wr >= yr.length ? (yr.decoder ? Qr = yr.buffer.join("") : yr.buffer.length === 1 ? Qr = yr.buffer.first() : Qr = yr.buffer.concat(yr.length), yr.buffer.clear()) : Qr = yr.buffer.consume(wr, yr.decoder), Qr;
  }
  function Hr(wr) {
    var yr = wr._readableState;
    k("endReadable", yr.endEmitted), yr.endEmitted || (yr.ended = !0, process$1.nextTick(un, yr, wr));
  }
  function un(wr, yr) {
    if (k("endReadableNT", wr.endEmitted, wr.length), !wr.endEmitted && wr.length === 0 && (wr.endEmitted = !0, yr.readable = !1, yr.emit("end"), wr.autoDestroy)) {
      var Qr = yr._writableState;
      (!Qr || Qr.autoDestroy && Qr.finished) && yr.destroy();
    }
  }
  typeof Symbol == "function" && (Ee.from = function(wr, yr) {
    return be === void 0 && (be = requireFromBrowser()), be(Ee, wr, yr);
  });
  function Dr(wr, yr) {
    for (var Qr = 0, _r = wr.length; Qr < _r; Qr++)
      if (wr[Qr] === yr) return Qr;
    return -1;
  }
  return _stream_readable$1;
}
var _stream_transform$1, hasRequired_stream_transform$1;
function require_stream_transform$1() {
  if (hasRequired_stream_transform$1) return _stream_transform$1;
  hasRequired_stream_transform$1 = 1, _stream_transform$1 = b;
  var s = requireErrorsBrowser().codes, A = s.ERR_METHOD_NOT_IMPLEMENTED, u = s.ERR_MULTIPLE_CALLBACK, p = s.ERR_TRANSFORM_ALREADY_TRANSFORMING, t = s.ERR_TRANSFORM_WITH_LENGTH_0, l = require_stream_duplex$1();
  requireInherits_browser()(b, l);
  function m(B, Q) {
    var P = this._transformState;
    P.transforming = !1;
    var x = P.writecb;
    if (x === null)
      return this.emit("error", new u());
    P.writechunk = null, P.writecb = null, Q != null && this.push(Q), x(B);
    var M = this._readableState;
    M.reading = !1, (M.needReadable || M.length < M.highWaterMark) && this._read(M.highWaterMark);
  }
  function b(B) {
    if (!(this instanceof b)) return new b(B);
    l.call(this, B), this._transformState = {
      afterTransform: m.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, B && (typeof B.transform == "function" && (this._transform = B.transform), typeof B.flush == "function" && (this._flush = B.flush)), this.on("prefinish", k);
  }
  function k() {
    var B = this;
    typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(Q, P) {
      C(B, Q, P);
    }) : C(this, null, null);
  }
  b.prototype.push = function(B, Q) {
    return this._transformState.needTransform = !1, l.prototype.push.call(this, B, Q);
  }, b.prototype._transform = function(B, Q, P) {
    P(new A("_transform()"));
  }, b.prototype._write = function(B, Q, P) {
    var x = this._transformState;
    if (x.writecb = P, x.writechunk = B, x.writeencoding = Q, !x.transforming) {
      var M = this._readableState;
      (x.needTransform || M.needReadable || M.length < M.highWaterMark) && this._read(M.highWaterMark);
    }
  }, b.prototype._read = function(B) {
    var Q = this._transformState;
    Q.writechunk !== null && !Q.transforming ? (Q.transforming = !0, this._transform(Q.writechunk, Q.writeencoding, Q.afterTransform)) : Q.needTransform = !0;
  }, b.prototype._destroy = function(B, Q) {
    l.prototype._destroy.call(this, B, function(P) {
      Q(P);
    });
  };
  function C(B, Q, P) {
    if (Q) return B.emit("error", Q);
    if (P != null && B.push(P), B._writableState.length) throw new t();
    if (B._transformState.transforming) throw new p();
    return B.push(null);
  }
  return _stream_transform$1;
}
var _stream_passthrough$1, hasRequired_stream_passthrough$1;
function require_stream_passthrough$1() {
  if (hasRequired_stream_passthrough$1) return _stream_passthrough$1;
  hasRequired_stream_passthrough$1 = 1, _stream_passthrough$1 = A;
  var s = require_stream_transform$1();
  requireInherits_browser()(A, s);
  function A(u) {
    if (!(this instanceof A)) return new A(u);
    s.call(this, u);
  }
  return A.prototype._transform = function(u, p, t) {
    t(null, u);
  }, _stream_passthrough$1;
}
var pipeline_1, hasRequiredPipeline;
function requirePipeline() {
  if (hasRequiredPipeline) return pipeline_1;
  hasRequiredPipeline = 1;
  var s;
  function A(P) {
    var x = !1;
    return function() {
      x || (x = !0, P.apply(void 0, arguments));
    };
  }
  var u = requireErrorsBrowser().codes, p = u.ERR_MISSING_ARGS, t = u.ERR_STREAM_DESTROYED;
  function l(P) {
    if (P) throw P;
  }
  function m(P) {
    return P.setHeader && typeof P.abort == "function";
  }
  function b(P, x, M, F) {
    F = A(F);
    var le = !1;
    P.on("close", function() {
      le = !0;
    }), s === void 0 && (s = requireEndOfStream()), s(P, {
      readable: x,
      writable: M
    }, function(pe) {
      if (pe) return F(pe);
      le = !0, F();
    });
    var ge = !1;
    return function(pe) {
      if (!le && !ge) {
        if (ge = !0, m(P)) return P.abort();
        if (typeof P.destroy == "function") return P.destroy();
        F(pe || new t("pipe"));
      }
    };
  }
  function k(P) {
    P();
  }
  function C(P, x) {
    return P.pipe(x);
  }
  function B(P) {
    return !P.length || typeof P[P.length - 1] != "function" ? l : P.pop();
  }
  function Q() {
    for (var P = arguments.length, x = new Array(P), M = 0; M < P; M++)
      x[M] = arguments[M];
    var F = B(x);
    if (Array.isArray(x[0]) && (x = x[0]), x.length < 2)
      throw new p("streams");
    var le, ge = x.map(function(pe, Ie) {
      var be = Ie < x.length - 1, Pe = Ie > 0;
      return b(pe, be, Pe, function(Te) {
        le || (le = Te), Te && ge.forEach(k), !be && (ge.forEach(k), F(le));
      });
    });
    return x.reduce(C);
  }
  return pipeline_1 = Q, pipeline_1;
}
var hasRequiredReadableBrowser$1;
function requireReadableBrowser$1() {
  return hasRequiredReadableBrowser$1 || (hasRequiredReadableBrowser$1 = 1, function(s, A) {
    A = s.exports = require_stream_readable$1(), A.Stream = A, A.Readable = A, A.Writable = require_stream_writable$1(), A.Duplex = require_stream_duplex$1(), A.Transform = require_stream_transform$1(), A.PassThrough = require_stream_passthrough$1(), A.finished = requireEndOfStream(), A.pipeline = requirePipeline();
  }(readableBrowser$1, readableBrowser$1.exports)), readableBrowser$1.exports;
}
var hashBase$1, hasRequiredHashBase$1;
function requireHashBase$1() {
  if (hasRequiredHashBase$1) return hashBase$1;
  hasRequiredHashBase$1 = 1;
  var s = requireSafeBuffer$1().Buffer, A = requireReadableBrowser$1().Transform, u = requireInherits_browser();
  function p(l, m) {
    if (!s.isBuffer(l) && typeof l != "string")
      throw new TypeError(m + " must be a string or a buffer");
  }
  function t(l) {
    A.call(this), this._block = s.allocUnsafe(l), this._blockSize = l, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }
  return u(t, A), t.prototype._transform = function(l, m, b) {
    var k = null;
    try {
      this.update(l, m);
    } catch (C) {
      k = C;
    }
    b(k);
  }, t.prototype._flush = function(l) {
    var m = null;
    try {
      this.push(this.digest());
    } catch (b) {
      m = b;
    }
    l(m);
  }, t.prototype.update = function(l, m) {
    if (p(l, "Data"), this._finalized) throw new Error("Digest already called");
    s.isBuffer(l) || (l = s.from(l, m));
    for (var b = this._block, k = 0; this._blockOffset + l.length - k >= this._blockSize; ) {
      for (var C = this._blockOffset; C < this._blockSize; ) b[C++] = l[k++];
      this._update(), this._blockOffset = 0;
    }
    for (; k < l.length; ) b[this._blockOffset++] = l[k++];
    for (var B = 0, Q = l.length * 8; Q > 0; ++B)
      this._length[B] += Q, Q = this._length[B] / 4294967296 | 0, Q > 0 && (this._length[B] -= 4294967296 * Q);
    return this;
  }, t.prototype._update = function() {
    throw new Error("_update is not implemented");
  }, t.prototype.digest = function(l) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = !0;
    var m = this._digest();
    l !== void 0 && (m = m.toString(l)), this._block.fill(0), this._blockOffset = 0;
    for (var b = 0; b < 4; ++b) this._length[b] = 0;
    return m;
  }, t.prototype._digest = function() {
    throw new Error("_digest is not implemented");
  }, hashBase$1 = t, hashBase$1;
}
var md5_js, hasRequiredMd5_js;
function requireMd5_js() {
  if (hasRequiredMd5_js) return md5_js;
  hasRequiredMd5_js = 1;
  var s = requireInherits_browser(), A = requireHashBase$1(), u = requireSafeBuffer$1().Buffer, p = new Array(16);
  function t() {
    A.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
  }
  s(t, A), t.prototype._update = function() {
    for (var B = p, Q = 0; Q < 16; ++Q) B[Q] = this._block.readInt32LE(Q * 4);
    var P = this._a, x = this._b, M = this._c, F = this._d;
    P = m(P, x, M, F, B[0], 3614090360, 7), F = m(F, P, x, M, B[1], 3905402710, 12), M = m(M, F, P, x, B[2], 606105819, 17), x = m(x, M, F, P, B[3], 3250441966, 22), P = m(P, x, M, F, B[4], 4118548399, 7), F = m(F, P, x, M, B[5], 1200080426, 12), M = m(M, F, P, x, B[6], 2821735955, 17), x = m(x, M, F, P, B[7], 4249261313, 22), P = m(P, x, M, F, B[8], 1770035416, 7), F = m(F, P, x, M, B[9], 2336552879, 12), M = m(M, F, P, x, B[10], 4294925233, 17), x = m(x, M, F, P, B[11], 2304563134, 22), P = m(P, x, M, F, B[12], 1804603682, 7), F = m(F, P, x, M, B[13], 4254626195, 12), M = m(M, F, P, x, B[14], 2792965006, 17), x = m(x, M, F, P, B[15], 1236535329, 22), P = b(P, x, M, F, B[1], 4129170786, 5), F = b(F, P, x, M, B[6], 3225465664, 9), M = b(M, F, P, x, B[11], 643717713, 14), x = b(x, M, F, P, B[0], 3921069994, 20), P = b(P, x, M, F, B[5], 3593408605, 5), F = b(F, P, x, M, B[10], 38016083, 9), M = b(M, F, P, x, B[15], 3634488961, 14), x = b(x, M, F, P, B[4], 3889429448, 20), P = b(P, x, M, F, B[9], 568446438, 5), F = b(F, P, x, M, B[14], 3275163606, 9), M = b(M, F, P, x, B[3], 4107603335, 14), x = b(x, M, F, P, B[8], 1163531501, 20), P = b(P, x, M, F, B[13], 2850285829, 5), F = b(F, P, x, M, B[2], 4243563512, 9), M = b(M, F, P, x, B[7], 1735328473, 14), x = b(x, M, F, P, B[12], 2368359562, 20), P = k(P, x, M, F, B[5], 4294588738, 4), F = k(F, P, x, M, B[8], 2272392833, 11), M = k(M, F, P, x, B[11], 1839030562, 16), x = k(x, M, F, P, B[14], 4259657740, 23), P = k(P, x, M, F, B[1], 2763975236, 4), F = k(F, P, x, M, B[4], 1272893353, 11), M = k(M, F, P, x, B[7], 4139469664, 16), x = k(x, M, F, P, B[10], 3200236656, 23), P = k(P, x, M, F, B[13], 681279174, 4), F = k(F, P, x, M, B[0], 3936430074, 11), M = k(M, F, P, x, B[3], 3572445317, 16), x = k(x, M, F, P, B[6], 76029189, 23), P = k(P, x, M, F, B[9], 3654602809, 4), F = k(F, P, x, M, B[12], 3873151461, 11), M = k(M, F, P, x, B[15], 530742520, 16), x = k(x, M, F, P, B[2], 3299628645, 23), P = C(P, x, M, F, B[0], 4096336452, 6), F = C(F, P, x, M, B[7], 1126891415, 10), M = C(M, F, P, x, B[14], 2878612391, 15), x = C(x, M, F, P, B[5], 4237533241, 21), P = C(P, x, M, F, B[12], 1700485571, 6), F = C(F, P, x, M, B[3], 2399980690, 10), M = C(M, F, P, x, B[10], 4293915773, 15), x = C(x, M, F, P, B[1], 2240044497, 21), P = C(P, x, M, F, B[8], 1873313359, 6), F = C(F, P, x, M, B[15], 4264355552, 10), M = C(M, F, P, x, B[6], 2734768916, 15), x = C(x, M, F, P, B[13], 1309151649, 21), P = C(P, x, M, F, B[4], 4149444226, 6), F = C(F, P, x, M, B[11], 3174756917, 10), M = C(M, F, P, x, B[2], 718787259, 15), x = C(x, M, F, P, B[9], 3951481745, 21), this._a = this._a + P | 0, this._b = this._b + x | 0, this._c = this._c + M | 0, this._d = this._d + F | 0;
  }, t.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var B = u.allocUnsafe(16);
    return B.writeInt32LE(this._a, 0), B.writeInt32LE(this._b, 4), B.writeInt32LE(this._c, 8), B.writeInt32LE(this._d, 12), B;
  };
  function l(B, Q) {
    return B << Q | B >>> 32 - Q;
  }
  function m(B, Q, P, x, M, F, le) {
    return l(B + (Q & P | ~Q & x) + M + F | 0, le) + Q | 0;
  }
  function b(B, Q, P, x, M, F, le) {
    return l(B + (Q & x | P & ~x) + M + F | 0, le) + Q | 0;
  }
  function k(B, Q, P, x, M, F, le) {
    return l(B + (Q ^ P ^ x) + M + F | 0, le) + Q | 0;
  }
  function C(B, Q, P, x, M, F, le) {
    return l(B + (P ^ (Q | ~x)) + M + F | 0, le) + Q | 0;
  }
  return md5_js = t, md5_js;
}
var ripemd160$4, hasRequiredRipemd160$1;
function requireRipemd160$1() {
  if (hasRequiredRipemd160$1) return ripemd160$4;
  hasRequiredRipemd160$1 = 1;
  var s = requireDist$n().Buffer, A = requireInherits_browser(), u = requireHashBase$1(), p = new Array(16), t = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], l = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], m = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], b = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ], k = [0, 1518500249, 1859775393, 2400959708, 2840853838], C = [1352829926, 1548603684, 1836072691, 2053994217, 0];
  function B() {
    u.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
  }
  A(B, u), B.prototype._update = function() {
    for (var ge = p, pe = 0; pe < 16; ++pe) ge[pe] = this._block.readInt32LE(pe * 4);
    for (var Ie = this._a | 0, be = this._b | 0, Pe = this._c | 0, Te = this._d | 0, Qe = this._e | 0, xe = this._a | 0, Ee = this._b | 0, He = this._c | 0, ve = this._d | 0, we = this._e | 0, Ce = 0; Ce < 80; Ce += 1) {
      var Se, Ne;
      Ce < 16 ? (Se = P(Ie, be, Pe, Te, Qe, ge[t[Ce]], k[0], m[Ce]), Ne = le(xe, Ee, He, ve, we, ge[l[Ce]], C[0], b[Ce])) : Ce < 32 ? (Se = x(Ie, be, Pe, Te, Qe, ge[t[Ce]], k[1], m[Ce]), Ne = F(xe, Ee, He, ve, we, ge[l[Ce]], C[1], b[Ce])) : Ce < 48 ? (Se = M(Ie, be, Pe, Te, Qe, ge[t[Ce]], k[2], m[Ce]), Ne = M(xe, Ee, He, ve, we, ge[l[Ce]], C[2], b[Ce])) : Ce < 64 ? (Se = F(Ie, be, Pe, Te, Qe, ge[t[Ce]], k[3], m[Ce]), Ne = x(xe, Ee, He, ve, we, ge[l[Ce]], C[3], b[Ce])) : (Se = le(Ie, be, Pe, Te, Qe, ge[t[Ce]], k[4], m[Ce]), Ne = P(xe, Ee, He, ve, we, ge[l[Ce]], C[4], b[Ce])), Ie = Qe, Qe = Te, Te = Q(Pe, 10), Pe = be, be = Se, xe = we, we = ve, ve = Q(He, 10), He = Ee, Ee = Ne;
    }
    var rr = this._b + Pe + ve | 0;
    this._b = this._c + Te + we | 0, this._c = this._d + Qe + xe | 0, this._d = this._e + Ie + Ee | 0, this._e = this._a + be + He | 0, this._a = rr;
  }, B.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var ge = s.alloc ? s.alloc(20) : new s(20);
    return ge.writeInt32LE(this._a, 0), ge.writeInt32LE(this._b, 4), ge.writeInt32LE(this._c, 8), ge.writeInt32LE(this._d, 12), ge.writeInt32LE(this._e, 16), ge;
  };
  function Q(ge, pe) {
    return ge << pe | ge >>> 32 - pe;
  }
  function P(ge, pe, Ie, be, Pe, Te, Qe, xe) {
    return Q(ge + (pe ^ Ie ^ be) + Te + Qe | 0, xe) + Pe | 0;
  }
  function x(ge, pe, Ie, be, Pe, Te, Qe, xe) {
    return Q(ge + (pe & Ie | ~pe & be) + Te + Qe | 0, xe) + Pe | 0;
  }
  function M(ge, pe, Ie, be, Pe, Te, Qe, xe) {
    return Q(ge + ((pe | ~Ie) ^ be) + Te + Qe | 0, xe) + Pe | 0;
  }
  function F(ge, pe, Ie, be, Pe, Te, Qe, xe) {
    return Q(ge + (pe & be | Ie & ~be) + Te + Qe | 0, xe) + Pe | 0;
  }
  function le(ge, pe, Ie, be, Pe, Te, Qe, xe) {
    return Q(ge + (pe ^ (Ie | ~be)) + Te + Qe | 0, xe) + Pe | 0;
  }
  return ripemd160$4 = B, ripemd160$4;
}
var sha_js = { exports: {} }, isarray$1, hasRequiredIsarray$1;
function requireIsarray$1() {
  if (hasRequiredIsarray$1) return isarray$1;
  hasRequiredIsarray$1 = 1;
  var s = {}.toString;
  return isarray$1 = Array.isArray || function(A) {
    return s.call(A) == "[object Array]";
  }, isarray$1;
}
var typedArrayBuffer, hasRequiredTypedArrayBuffer;
function requireTypedArrayBuffer() {
  if (hasRequiredTypedArrayBuffer) return typedArrayBuffer;
  hasRequiredTypedArrayBuffer = 1;
  var s = /* @__PURE__ */ requireType(), A = /* @__PURE__ */ requireCallBound$1(), u = A("TypedArray.prototype.buffer", !0), p = /* @__PURE__ */ requireIsTypedArray();
  return typedArrayBuffer = u || function(l) {
    if (!p(l))
      throw new s("Not a Typed Array");
    return l.buffer;
  }, typedArrayBuffer;
}
var toBuffer, hasRequiredToBuffer$1;
function requireToBuffer$1() {
  if (hasRequiredToBuffer$1) return toBuffer;
  hasRequiredToBuffer$1 = 1;
  var s = requireSafeBuffer$1().Buffer, A = requireIsarray$1(), u = /* @__PURE__ */ requireTypedArrayBuffer(), p = ArrayBuffer.isView || function(k) {
    try {
      return u(k), !0;
    } catch {
      return !1;
    }
  }, t = typeof Uint8Array < "u", l = typeof ArrayBuffer < "u" && typeof Uint8Array < "u", m = l && (s.prototype instanceof Uint8Array || s.TYPED_ARRAY_SUPPORT);
  return toBuffer = function(k, C) {
    if (k instanceof s)
      return k;
    if (typeof k == "string")
      return s.from(k, C);
    if (l && p(k)) {
      if (k.byteLength === 0)
        return s.alloc(0);
      if (m) {
        var B = s.from(k.buffer, k.byteOffset, k.byteLength);
        if (B.byteLength === k.byteLength)
          return B;
      }
      var Q = k instanceof Uint8Array ? k : new Uint8Array(k.buffer, k.byteOffset, k.byteLength), P = s.from(Q);
      if (P.length === k.byteLength)
        return P;
    }
    if (t && k instanceof Uint8Array)
      return s.from(k);
    var x = A(k);
    if (x)
      for (var M = 0; M < k.length; M += 1) {
        var F = k[M];
        if (typeof F != "number" || F < 0 || F > 255 || ~~F !== F)
          throw new RangeError("Array items must be numbers in the range 0-255.");
      }
    if (x || s.isBuffer(k) && k.constructor && typeof k.constructor.isBuffer == "function" && k.constructor.isBuffer(k))
      return s.from(k);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
  }, toBuffer;
}
var hash$q, hasRequiredHash$2;
function requireHash$2() {
  if (hasRequiredHash$2) return hash$q;
  hasRequiredHash$2 = 1;
  var s = requireSafeBuffer$1().Buffer, A = /* @__PURE__ */ requireToBuffer$1();
  function u(p, t) {
    this._block = s.alloc(p), this._finalSize = t, this._blockSize = p, this._len = 0;
  }
  return u.prototype.update = function(p, t) {
    p = A(p, t || "utf8");
    for (var l = this._block, m = this._blockSize, b = p.length, k = this._len, C = 0; C < b; ) {
      for (var B = k % m, Q = Math.min(b - C, m - B), P = 0; P < Q; P++)
        l[B + P] = p[C + P];
      k += Q, C += Q, k % m === 0 && this._update(l);
    }
    return this._len += b, this;
  }, u.prototype.digest = function(p) {
    var t = this._len % this._blockSize;
    this._block[t] = 128, this._block.fill(0, t + 1), t >= this._finalSize && (this._update(this._block), this._block.fill(0));
    var l = this._len * 8;
    if (l <= 4294967295)
      this._block.writeUInt32BE(l, this._blockSize - 4);
    else {
      var m = (l & 4294967295) >>> 0, b = (l - m) / 4294967296;
      this._block.writeUInt32BE(b, this._blockSize - 8), this._block.writeUInt32BE(m, this._blockSize - 4);
    }
    this._update(this._block);
    var k = this._hash();
    return p ? k.toString(p) : k;
  }, u.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
  }, hash$q = u, hash$q;
}
var sha$2, hasRequiredSha$2;
function requireSha$2() {
  if (hasRequiredSha$2) return sha$2;
  hasRequiredSha$2 = 1;
  var s = requireInherits_browser(), A = requireHash$2(), u = requireSafeBuffer$1().Buffer, p = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], t = new Array(80);
  function l() {
    this.init(), this._w = t, A.call(this, 64, 56);
  }
  s(l, A), l.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function m(C) {
    return C << 5 | C >>> 27;
  }
  function b(C) {
    return C << 30 | C >>> 2;
  }
  function k(C, B, Q, P) {
    return C === 0 ? B & Q | ~B & P : C === 2 ? B & Q | B & P | Q & P : B ^ Q ^ P;
  }
  return l.prototype._update = function(C) {
    for (var B = this._w, Q = this._a | 0, P = this._b | 0, x = this._c | 0, M = this._d | 0, F = this._e | 0, le = 0; le < 16; ++le)
      B[le] = C.readInt32BE(le * 4);
    for (; le < 80; ++le)
      B[le] = B[le - 3] ^ B[le - 8] ^ B[le - 14] ^ B[le - 16];
    for (var ge = 0; ge < 80; ++ge) {
      var pe = ~~(ge / 20), Ie = m(Q) + k(pe, P, x, M) + F + B[ge] + p[pe] | 0;
      F = M, M = x, x = b(P), P = Q, Q = Ie;
    }
    this._a = Q + this._a | 0, this._b = P + this._b | 0, this._c = x + this._c | 0, this._d = M + this._d | 0, this._e = F + this._e | 0;
  }, l.prototype._hash = function() {
    var C = u.allocUnsafe(20);
    return C.writeInt32BE(this._a | 0, 0), C.writeInt32BE(this._b | 0, 4), C.writeInt32BE(this._c | 0, 8), C.writeInt32BE(this._d | 0, 12), C.writeInt32BE(this._e | 0, 16), C;
  }, sha$2 = l, sha$2;
}
var sha1$3, hasRequiredSha1$1;
function requireSha1$1() {
  if (hasRequiredSha1$1) return sha1$3;
  hasRequiredSha1$1 = 1;
  var s = requireInherits_browser(), A = requireHash$2(), u = requireSafeBuffer$1().Buffer, p = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], t = new Array(80);
  function l() {
    this.init(), this._w = t, A.call(this, 64, 56);
  }
  s(l, A), l.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function m(B) {
    return B << 1 | B >>> 31;
  }
  function b(B) {
    return B << 5 | B >>> 27;
  }
  function k(B) {
    return B << 30 | B >>> 2;
  }
  function C(B, Q, P, x) {
    return B === 0 ? Q & P | ~Q & x : B === 2 ? Q & P | Q & x | P & x : Q ^ P ^ x;
  }
  return l.prototype._update = function(B) {
    for (var Q = this._w, P = this._a | 0, x = this._b | 0, M = this._c | 0, F = this._d | 0, le = this._e | 0, ge = 0; ge < 16; ++ge)
      Q[ge] = B.readInt32BE(ge * 4);
    for (; ge < 80; ++ge)
      Q[ge] = m(Q[ge - 3] ^ Q[ge - 8] ^ Q[ge - 14] ^ Q[ge - 16]);
    for (var pe = 0; pe < 80; ++pe) {
      var Ie = ~~(pe / 20), be = b(P) + C(Ie, x, M, F) + le + Q[pe] + p[Ie] | 0;
      le = F, F = M, M = k(x), x = P, P = be;
    }
    this._a = P + this._a | 0, this._b = x + this._b | 0, this._c = M + this._c | 0, this._d = F + this._d | 0, this._e = le + this._e | 0;
  }, l.prototype._hash = function() {
    var B = u.allocUnsafe(20);
    return B.writeInt32BE(this._a | 0, 0), B.writeInt32BE(this._b | 0, 4), B.writeInt32BE(this._c | 0, 8), B.writeInt32BE(this._d | 0, 12), B.writeInt32BE(this._e | 0, 16), B;
  }, sha1$3 = l, sha1$3;
}
var sha256$9, hasRequiredSha256$3;
function requireSha256$3() {
  if (hasRequiredSha256$3) return sha256$9;
  hasRequiredSha256$3 = 1;
  var s = requireInherits_browser(), A = requireHash$2(), u = requireSafeBuffer$1().Buffer, p = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ], t = new Array(64);
  function l() {
    this.init(), this._w = t, A.call(this, 64, 56);
  }
  s(l, A), l.prototype.init = function() {
    return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
  };
  function m(P, x, M) {
    return M ^ P & (x ^ M);
  }
  function b(P, x, M) {
    return P & x | M & (P | x);
  }
  function k(P) {
    return (P >>> 2 | P << 30) ^ (P >>> 13 | P << 19) ^ (P >>> 22 | P << 10);
  }
  function C(P) {
    return (P >>> 6 | P << 26) ^ (P >>> 11 | P << 21) ^ (P >>> 25 | P << 7);
  }
  function B(P) {
    return (P >>> 7 | P << 25) ^ (P >>> 18 | P << 14) ^ P >>> 3;
  }
  function Q(P) {
    return (P >>> 17 | P << 15) ^ (P >>> 19 | P << 13) ^ P >>> 10;
  }
  return l.prototype._update = function(P) {
    for (var x = this._w, M = this._a | 0, F = this._b | 0, le = this._c | 0, ge = this._d | 0, pe = this._e | 0, Ie = this._f | 0, be = this._g | 0, Pe = this._h | 0, Te = 0; Te < 16; ++Te)
      x[Te] = P.readInt32BE(Te * 4);
    for (; Te < 64; ++Te)
      x[Te] = Q(x[Te - 2]) + x[Te - 7] + B(x[Te - 15]) + x[Te - 16] | 0;
    for (var Qe = 0; Qe < 64; ++Qe) {
      var xe = Pe + C(pe) + m(pe, Ie, be) + p[Qe] + x[Qe] | 0, Ee = k(M) + b(M, F, le) | 0;
      Pe = be, be = Ie, Ie = pe, pe = ge + xe | 0, ge = le, le = F, F = M, M = xe + Ee | 0;
    }
    this._a = M + this._a | 0, this._b = F + this._b | 0, this._c = le + this._c | 0, this._d = ge + this._d | 0, this._e = pe + this._e | 0, this._f = Ie + this._f | 0, this._g = be + this._g | 0, this._h = Pe + this._h | 0;
  }, l.prototype._hash = function() {
    var P = u.allocUnsafe(32);
    return P.writeInt32BE(this._a, 0), P.writeInt32BE(this._b, 4), P.writeInt32BE(this._c, 8), P.writeInt32BE(this._d, 12), P.writeInt32BE(this._e, 16), P.writeInt32BE(this._f, 20), P.writeInt32BE(this._g, 24), P.writeInt32BE(this._h, 28), P;
  }, sha256$9 = l, sha256$9;
}
var sha224$2, hasRequiredSha224;
function requireSha224() {
  if (hasRequiredSha224) return sha224$2;
  hasRequiredSha224 = 1;
  var s = requireInherits_browser(), A = requireSha256$3(), u = requireHash$2(), p = requireSafeBuffer$1().Buffer, t = new Array(64);
  function l() {
    this.init(), this._w = t, u.call(this, 64, 56);
  }
  return s(l, A), l.prototype.init = function() {
    return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
  }, l.prototype._hash = function() {
    var m = p.allocUnsafe(28);
    return m.writeInt32BE(this._a, 0), m.writeInt32BE(this._b, 4), m.writeInt32BE(this._c, 8), m.writeInt32BE(this._d, 12), m.writeInt32BE(this._e, 16), m.writeInt32BE(this._f, 20), m.writeInt32BE(this._g, 24), m;
  }, sha224$2 = l, sha224$2;
}
var sha512$4, hasRequiredSha512$1;
function requireSha512$1() {
  if (hasRequiredSha512$1) return sha512$4;
  hasRequiredSha512$1 = 1;
  var s = requireInherits_browser(), A = requireHash$2(), u = requireSafeBuffer$1().Buffer, p = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ], t = new Array(160);
  function l() {
    this.init(), this._w = t, A.call(this, 128, 112);
  }
  s(l, A), l.prototype.init = function() {
    return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
  };
  function m(F, le, ge) {
    return ge ^ F & (le ^ ge);
  }
  function b(F, le, ge) {
    return F & le | ge & (F | le);
  }
  function k(F, le) {
    return (F >>> 28 | le << 4) ^ (le >>> 2 | F << 30) ^ (le >>> 7 | F << 25);
  }
  function C(F, le) {
    return (F >>> 14 | le << 18) ^ (F >>> 18 | le << 14) ^ (le >>> 9 | F << 23);
  }
  function B(F, le) {
    return (F >>> 1 | le << 31) ^ (F >>> 8 | le << 24) ^ F >>> 7;
  }
  function Q(F, le) {
    return (F >>> 1 | le << 31) ^ (F >>> 8 | le << 24) ^ (F >>> 7 | le << 25);
  }
  function P(F, le) {
    return (F >>> 19 | le << 13) ^ (le >>> 29 | F << 3) ^ F >>> 6;
  }
  function x(F, le) {
    return (F >>> 19 | le << 13) ^ (le >>> 29 | F << 3) ^ (F >>> 6 | le << 26);
  }
  function M(F, le) {
    return F >>> 0 < le >>> 0 ? 1 : 0;
  }
  return l.prototype._update = function(F) {
    for (var le = this._w, ge = this._ah | 0, pe = this._bh | 0, Ie = this._ch | 0, be = this._dh | 0, Pe = this._eh | 0, Te = this._fh | 0, Qe = this._gh | 0, xe = this._hh | 0, Ee = this._al | 0, He = this._bl | 0, ve = this._cl | 0, we = this._dl | 0, Ce = this._el | 0, Se = this._fl | 0, Ne = this._gl | 0, rr = this._hl | 0, er = 0; er < 32; er += 2)
      le[er] = F.readInt32BE(er * 4), le[er + 1] = F.readInt32BE(er * 4 + 4);
    for (; er < 160; er += 2) {
      var ir = le[er - 30], sr = le[er - 30 + 1], nr = B(ir, sr), fr = Q(sr, ir);
      ir = le[er - 4], sr = le[er - 4 + 1];
      var lr = P(ir, sr), br = x(sr, ir), Br = le[er - 14], Fr = le[er - 14 + 1], Gr = le[er - 32], qr = le[er - 32 + 1], Hr = fr + Fr | 0, un = nr + Br + M(Hr, fr) | 0;
      Hr = Hr + br | 0, un = un + lr + M(Hr, br) | 0, Hr = Hr + qr | 0, un = un + Gr + M(Hr, qr) | 0, le[er] = un, le[er + 1] = Hr;
    }
    for (var Dr = 0; Dr < 160; Dr += 2) {
      un = le[Dr], Hr = le[Dr + 1];
      var wr = b(ge, pe, Ie), yr = b(Ee, He, ve), Qr = k(ge, Ee), _r = k(Ee, ge), Jr = C(Pe, Ce), fn = C(Ce, Pe), jr = p[Dr], dn = p[Dr + 1], Tn = m(Pe, Te, Qe), Yn = m(Ce, Se, Ne), si = rr + fn | 0, vn = xe + Jr + M(si, rr) | 0;
      si = si + Yn | 0, vn = vn + Tn + M(si, Yn) | 0, si = si + dn | 0, vn = vn + jr + M(si, dn) | 0, si = si + Hr | 0, vn = vn + un + M(si, Hr) | 0;
      var Cn = _r + yr | 0, Xr = Qr + wr + M(Cn, _r) | 0;
      xe = Qe, rr = Ne, Qe = Te, Ne = Se, Te = Pe, Se = Ce, Ce = we + si | 0, Pe = be + vn + M(Ce, we) | 0, be = Ie, we = ve, Ie = pe, ve = He, pe = ge, He = Ee, Ee = si + Cn | 0, ge = vn + Xr + M(Ee, si) | 0;
    }
    this._al = this._al + Ee | 0, this._bl = this._bl + He | 0, this._cl = this._cl + ve | 0, this._dl = this._dl + we | 0, this._el = this._el + Ce | 0, this._fl = this._fl + Se | 0, this._gl = this._gl + Ne | 0, this._hl = this._hl + rr | 0, this._ah = this._ah + ge + M(this._al, Ee) | 0, this._bh = this._bh + pe + M(this._bl, He) | 0, this._ch = this._ch + Ie + M(this._cl, ve) | 0, this._dh = this._dh + be + M(this._dl, we) | 0, this._eh = this._eh + Pe + M(this._el, Ce) | 0, this._fh = this._fh + Te + M(this._fl, Se) | 0, this._gh = this._gh + Qe + M(this._gl, Ne) | 0, this._hh = this._hh + xe + M(this._hl, rr) | 0;
  }, l.prototype._hash = function() {
    var F = u.allocUnsafe(64);
    function le(ge, pe, Ie) {
      F.writeInt32BE(ge, Ie), F.writeInt32BE(pe, Ie + 4);
    }
    return le(this._ah, this._al, 0), le(this._bh, this._bl, 8), le(this._ch, this._cl, 16), le(this._dh, this._dl, 24), le(this._eh, this._el, 32), le(this._fh, this._fl, 40), le(this._gh, this._gl, 48), le(this._hh, this._hl, 56), F;
  }, sha512$4 = l, sha512$4;
}
var sha384$2, hasRequiredSha384;
function requireSha384() {
  if (hasRequiredSha384) return sha384$2;
  hasRequiredSha384 = 1;
  var s = requireInherits_browser(), A = requireSha512$1(), u = requireHash$2(), p = requireSafeBuffer$1().Buffer, t = new Array(160);
  function l() {
    this.init(), this._w = t, u.call(this, 128, 112);
  }
  return s(l, A), l.prototype.init = function() {
    return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
  }, l.prototype._hash = function() {
    var m = p.allocUnsafe(48);
    function b(k, C, B) {
      m.writeInt32BE(k, B), m.writeInt32BE(C, B + 4);
    }
    return b(this._ah, this._al, 0), b(this._bh, this._bl, 8), b(this._ch, this._cl, 16), b(this._dh, this._dl, 24), b(this._eh, this._el, 32), b(this._fh, this._fl, 40), m;
  }, sha384$2 = l, sha384$2;
}
var hasRequiredSha_js;
function requireSha_js() {
  return hasRequiredSha_js || (hasRequiredSha_js = 1, function(s) {
    s.exports = function(u) {
      var p = u.toLowerCase(), t = s.exports[p];
      if (!t)
        throw new Error(p + " is not supported (we accept pull requests)");
      return new t();
    }, s.exports.sha = requireSha$2(), s.exports.sha1 = requireSha1$1(), s.exports.sha224 = requireSha224(), s.exports.sha256 = requireSha256$3(), s.exports.sha384 = requireSha384(), s.exports.sha512 = requireSha512$1();
  }(sha_js)), sha_js.exports;
}
var streamBrowserify, hasRequiredStreamBrowserify;
function requireStreamBrowserify() {
  if (hasRequiredStreamBrowserify) return streamBrowserify;
  hasRequiredStreamBrowserify = 1, streamBrowserify = u;
  var s = requireEvents().EventEmitter, A = requireInherits_browser();
  A(u, s), u.Readable = require_stream_readable$1(), u.Writable = require_stream_writable$1(), u.Duplex = require_stream_duplex$1(), u.Transform = require_stream_transform$1(), u.PassThrough = require_stream_passthrough$1(), u.finished = requireEndOfStream(), u.pipeline = requirePipeline(), u.Stream = u;
  function u() {
    s.call(this);
  }
  return u.prototype.pipe = function(p, t) {
    var l = this;
    function m(x) {
      p.writable && p.write(x) === !1 && l.pause && l.pause();
    }
    l.on("data", m);
    function b() {
      l.readable && l.resume && l.resume();
    }
    p.on("drain", b), !p._isStdio && (!t || t.end !== !1) && (l.on("end", C), l.on("close", B));
    var k = !1;
    function C() {
      k || (k = !0, p.end());
    }
    function B() {
      k || (k = !0, typeof p.destroy == "function" && p.destroy());
    }
    function Q(x) {
      if (P(), s.listenerCount(this, "error") === 0)
        throw x;
    }
    l.on("error", Q), p.on("error", Q);
    function P() {
      l.removeListener("data", m), p.removeListener("drain", b), l.removeListener("end", C), l.removeListener("close", B), l.removeListener("error", Q), p.removeListener("error", Q), l.removeListener("end", P), l.removeListener("close", P), p.removeListener("close", P);
    }
    return l.on("end", P), l.on("close", P), p.on("close", P), p.emit("pipe", l), p;
  }, streamBrowserify;
}
var cipherBase, hasRequiredCipherBase;
function requireCipherBase() {
  if (hasRequiredCipherBase) return cipherBase;
  hasRequiredCipherBase = 1;
  var s = requireSafeBuffer$1().Buffer, A = requireStreamBrowserify().Transform, u = requireString_decoder().StringDecoder, p = requireInherits_browser();
  function t(k) {
    A.call(this), this.hashMode = typeof k == "string", this.hashMode ? this[k] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
  }
  p(t, A);
  var l = typeof Uint8Array < "u", m = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && ArrayBuffer.isView && (s.prototype instanceof Uint8Array || s.TYPED_ARRAY_SUPPORT);
  function b(k, C) {
    if (k instanceof s)
      return k;
    if (typeof k == "string")
      return s.from(k, C);
    if (m && ArrayBuffer.isView(k)) {
      if (k.byteLength === 0)
        return s.alloc(0);
      var B = s.from(k.buffer, k.byteOffset, k.byteLength);
      if (B.byteLength === k.byteLength)
        return B;
    }
    if (l && k instanceof Uint8Array || s.isBuffer(k) && k.constructor && typeof k.constructor.isBuffer == "function" && k.constructor.isBuffer(k))
      return s.from(k);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
  }
  return t.prototype.update = function(k, C, B) {
    var Q = b(k, C), P = this._update(Q);
    return this.hashMode ? this : (B && (P = this._toString(P, B)), P);
  }, t.prototype.setAutoPadding = function() {
  }, t.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
  }, t.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
  }, t.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
  }, t.prototype._transform = function(k, C, B) {
    var Q;
    try {
      this.hashMode ? this._update(k) : this.push(this._update(k));
    } catch (P) {
      Q = P;
    } finally {
      B(Q);
    }
  }, t.prototype._flush = function(k) {
    var C;
    try {
      this.push(this.__final());
    } catch (B) {
      C = B;
    }
    k(C);
  }, t.prototype._finalOrDigest = function(k) {
    var C = this.__final() || s.alloc(0);
    return k && (C = this._toString(C, k, !0)), C;
  }, t.prototype._toString = function(k, C, B) {
    if (this._decoder || (this._decoder = new u(C), this._encoding = C), this._encoding !== C)
      throw new Error("can’t switch encodings");
    var Q = this._decoder.write(k);
    return B && (Q += this._decoder.end()), Q;
  }, cipherBase = t, cipherBase;
}
var browser$a, hasRequiredBrowser$a;
function requireBrowser$a() {
  if (hasRequiredBrowser$a) return browser$a;
  hasRequiredBrowser$a = 1;
  var s = requireInherits_browser(), A = requireMd5_js(), u = requireRipemd160$1(), p = requireSha_js(), t = requireCipherBase();
  function l(m) {
    t.call(this, "digest"), this._hash = m;
  }
  return s(l, t), l.prototype._update = function(m) {
    this._hash.update(m);
  }, l.prototype._final = function() {
    return this._hash.digest();
  }, browser$a = function(b) {
    return b = b.toLowerCase(), b === "md5" ? new A() : b === "rmd160" || b === "ripemd160" ? new u() : new l(p(b));
  }, browser$a;
}
var src$2, hasRequiredSrc$2;
function requireSrc$2() {
  if (hasRequiredSrc$2) return src$2;
  hasRequiredSrc$2 = 1;
  var s = requireSafeBuffer$1().Buffer;
  function A(u) {
    if (u.length >= 255)
      throw new TypeError("Alphabet too long");
    for (var p = new Uint8Array(256), t = 0; t < p.length; t++)
      p[t] = 255;
    for (var l = 0; l < u.length; l++) {
      var m = u.charAt(l), b = m.charCodeAt(0);
      if (p[b] !== 255)
        throw new TypeError(m + " is ambiguous");
      p[b] = l;
    }
    var k = u.length, C = u.charAt(0), B = Math.log(k) / Math.log(256), Q = Math.log(256) / Math.log(k);
    function P(F) {
      if ((Array.isArray(F) || F instanceof Uint8Array) && (F = s.from(F)), !s.isBuffer(F))
        throw new TypeError("Expected Buffer");
      if (F.length === 0)
        return "";
      for (var le = 0, ge = 0, pe = 0, Ie = F.length; pe !== Ie && F[pe] === 0; )
        pe++, le++;
      for (var be = (Ie - pe) * Q + 1 >>> 0, Pe = new Uint8Array(be); pe !== Ie; ) {
        for (var Te = F[pe], Qe = 0, xe = be - 1; (Te !== 0 || Qe < ge) && xe !== -1; xe--, Qe++)
          Te += 256 * Pe[xe] >>> 0, Pe[xe] = Te % k >>> 0, Te = Te / k >>> 0;
        if (Te !== 0)
          throw new Error("Non-zero carry");
        ge = Qe, pe++;
      }
      for (var Ee = be - ge; Ee !== be && Pe[Ee] === 0; )
        Ee++;
      for (var He = C.repeat(le); Ee < be; ++Ee)
        He += u.charAt(Pe[Ee]);
      return He;
    }
    function x(F) {
      if (typeof F != "string")
        throw new TypeError("Expected String");
      if (F.length === 0)
        return s.alloc(0);
      for (var le = 0, ge = 0, pe = 0; F[le] === C; )
        ge++, le++;
      for (var Ie = (F.length - le) * B + 1 >>> 0, be = new Uint8Array(Ie); le < F.length; ) {
        var Pe = F.charCodeAt(le);
        if (Pe > 255)
          return;
        var Te = p[Pe];
        if (Te === 255)
          return;
        for (var Qe = 0, xe = Ie - 1; (Te !== 0 || Qe < pe) && xe !== -1; xe--, Qe++)
          Te += k * be[xe] >>> 0, be[xe] = Te % 256 >>> 0, Te = Te / 256 >>> 0;
        if (Te !== 0)
          throw new Error("Non-zero carry");
        pe = Qe, le++;
      }
      for (var Ee = Ie - pe; Ee !== Ie && be[Ee] === 0; )
        Ee++;
      var He = s.allocUnsafe(ge + (Ie - Ee));
      He.fill(0, 0, ge);
      for (var ve = ge; Ee !== Ie; )
        He[ve++] = be[Ee++];
      return He;
    }
    function M(F) {
      var le = x(F);
      if (le)
        return le;
      throw new Error("Non-base" + k + " character");
    }
    return {
      encode: P,
      decodeUnsafe: x,
      decode: M
    };
  }
  return src$2 = A, src$2;
}
var bs58, hasRequiredBs58;
function requireBs58() {
  if (hasRequiredBs58) return bs58;
  hasRequiredBs58 = 1;
  var s = requireSrc$2(), A = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  return bs58 = s(A), bs58;
}
var base$2, hasRequiredBase$2;
function requireBase$2() {
  if (hasRequiredBase$2) return base$2;
  hasRequiredBase$2 = 1;
  var s = requireBs58(), A = requireSafeBuffer$1().Buffer;
  return base$2 = function(u) {
    function p(b) {
      var k = u(b);
      return s.encode(A.concat([
        b,
        k
      ], b.length + 4));
    }
    function t(b) {
      var k = b.slice(0, -4), C = b.slice(-4), B = u(k);
      if (!(C[0] ^ B[0] | C[1] ^ B[1] | C[2] ^ B[2] | C[3] ^ B[3]))
        return k;
    }
    function l(b) {
      var k = s.decodeUnsafe(b);
      if (k)
        return t(k);
    }
    function m(b) {
      var k = s.decode(b), C = t(k);
      if (!C) throw new Error("Invalid checksum");
      return C;
    }
    return {
      encode: p,
      decode: m,
      decodeUnsafe: l
    };
  }, base$2;
}
var bs58check, hasRequiredBs58check;
function requireBs58check() {
  if (hasRequiredBs58check) return bs58check;
  hasRequiredBs58check = 1;
  var s = requireBrowser$a(), A = requireBase$2();
  function u(p) {
    var t = s("sha256").update(p).digest();
    return s("sha256").update(t).digest();
  }
  return bs58check = A(u), bs58check;
}
var CryptoCoinInfo$1 = {}, RegistryItem$1 = {}, dist$i = {}, ur$1 = {}, errors$4 = {}, hasRequiredErrors$4;
function requireErrors$4() {
  if (hasRequiredErrors$4) return errors$4;
  hasRequiredErrors$4 = 1, Object.defineProperty(errors$4, "__esModule", { value: !0 }), errors$4.InvalidChecksumError = errors$4.InvalidSequenceComponentError = errors$4.InvalidTypeError = errors$4.InvalidPathLengthError = errors$4.InvalidSchemeError = void 0;
  class s extends Error {
    constructor() {
      super("Invalid Scheme"), this.name = "InvalidSchemeError";
    }
  }
  errors$4.InvalidSchemeError = s;
  class A extends Error {
    constructor() {
      super("Invalid Path"), this.name = "InvalidPathLengthError";
    }
  }
  errors$4.InvalidPathLengthError = A;
  class u extends Error {
    constructor() {
      super("Invalid Type"), this.name = "InvalidTypeError";
    }
  }
  errors$4.InvalidTypeError = u;
  class p extends Error {
    constructor() {
      super("Invalid Sequence Component"), this.name = "InvalidSequenceComponentError";
    }
  }
  errors$4.InvalidSequenceComponentError = p;
  class t extends Error {
    constructor() {
      super("Invalid Checksum"), this.name = "InvalidChecksumError";
    }
  }
  return errors$4.InvalidChecksumError = t, errors$4;
}
var utils$f = {};
const createBuffer = Buffer$1.from && Buffer$1.alloc && Buffer$1.allocUnsafe && Buffer$1.allocUnsafeSlow ? Buffer$1.from : (
  // support for Node < 5.10
  (s) => new Buffer$1(s)
);
function defineCrc(s, A) {
  const u = (p, t) => A(p, t) >>> 0;
  return u.signed = A, u.unsigned = u, u.model = s, u;
}
const crc1 = defineCrc("crc1", function(s, A) {
  Buffer$1.isBuffer(s) || (s = createBuffer(s));
  let u = ~~A, p = 0;
  for (let t = 0; t < s.length; t++) {
    const l = s[t];
    p += l;
  }
  return u += p % 256, u % 256;
});
let TABLE$8 = [
  0,
  7,
  14,
  9,
  28,
  27,
  18,
  21,
  56,
  63,
  54,
  49,
  36,
  35,
  42,
  45,
  112,
  119,
  126,
  121,
  108,
  107,
  98,
  101,
  72,
  79,
  70,
  65,
  84,
  83,
  90,
  93,
  224,
  231,
  238,
  233,
  252,
  251,
  242,
  245,
  216,
  223,
  214,
  209,
  196,
  195,
  202,
  205,
  144,
  151,
  158,
  153,
  140,
  139,
  130,
  133,
  168,
  175,
  166,
  161,
  180,
  179,
  186,
  189,
  199,
  192,
  201,
  206,
  219,
  220,
  213,
  210,
  255,
  248,
  241,
  246,
  227,
  228,
  237,
  234,
  183,
  176,
  185,
  190,
  171,
  172,
  165,
  162,
  143,
  136,
  129,
  134,
  147,
  148,
  157,
  154,
  39,
  32,
  41,
  46,
  59,
  60,
  53,
  50,
  31,
  24,
  17,
  22,
  3,
  4,
  13,
  10,
  87,
  80,
  89,
  94,
  75,
  76,
  69,
  66,
  111,
  104,
  97,
  102,
  115,
  116,
  125,
  122,
  137,
  142,
  135,
  128,
  149,
  146,
  155,
  156,
  177,
  182,
  191,
  184,
  173,
  170,
  163,
  164,
  249,
  254,
  247,
  240,
  229,
  226,
  235,
  236,
  193,
  198,
  207,
  200,
  221,
  218,
  211,
  212,
  105,
  110,
  103,
  96,
  117,
  114,
  123,
  124,
  81,
  86,
  95,
  88,
  77,
  74,
  67,
  68,
  25,
  30,
  23,
  16,
  5,
  2,
  11,
  12,
  33,
  38,
  47,
  40,
  61,
  58,
  51,
  52,
  78,
  73,
  64,
  71,
  82,
  85,
  92,
  91,
  118,
  113,
  120,
  127,
  106,
  109,
  100,
  99,
  62,
  57,
  48,
  55,
  34,
  37,
  44,
  43,
  6,
  1,
  8,
  15,
  26,
  29,
  20,
  19,
  174,
  169,
  160,
  167,
  178,
  181,
  188,
  187,
  150,
  145,
  152,
  159,
  138,
  141,
  132,
  131,
  222,
  217,
  208,
  215,
  194,
  197,
  204,
  203,
  230,
  225,
  232,
  239,
  250,
  253,
  244,
  243
];
typeof Int32Array < "u" && (TABLE$8 = new Int32Array(TABLE$8));
const crc8 = defineCrc("crc-8", function(s, A) {
  Buffer$1.isBuffer(s) || (s = createBuffer(s));
  let u = ~~A;
  for (let p = 0; p < s.length; p++) {
    const t = s[p];
    u = TABLE$8[(u ^ t) & 255] & 255;
  }
  return u;
});
let TABLE$7 = [
  0,
  94,
  188,
  226,
  97,
  63,
  221,
  131,
  194,
  156,
  126,
  32,
  163,
  253,
  31,
  65,
  157,
  195,
  33,
  127,
  252,
  162,
  64,
  30,
  95,
  1,
  227,
  189,
  62,
  96,
  130,
  220,
  35,
  125,
  159,
  193,
  66,
  28,
  254,
  160,
  225,
  191,
  93,
  3,
  128,
  222,
  60,
  98,
  190,
  224,
  2,
  92,
  223,
  129,
  99,
  61,
  124,
  34,
  192,
  158,
  29,
  67,
  161,
  255,
  70,
  24,
  250,
  164,
  39,
  121,
  155,
  197,
  132,
  218,
  56,
  102,
  229,
  187,
  89,
  7,
  219,
  133,
  103,
  57,
  186,
  228,
  6,
  88,
  25,
  71,
  165,
  251,
  120,
  38,
  196,
  154,
  101,
  59,
  217,
  135,
  4,
  90,
  184,
  230,
  167,
  249,
  27,
  69,
  198,
  152,
  122,
  36,
  248,
  166,
  68,
  26,
  153,
  199,
  37,
  123,
  58,
  100,
  134,
  216,
  91,
  5,
  231,
  185,
  140,
  210,
  48,
  110,
  237,
  179,
  81,
  15,
  78,
  16,
  242,
  172,
  47,
  113,
  147,
  205,
  17,
  79,
  173,
  243,
  112,
  46,
  204,
  146,
  211,
  141,
  111,
  49,
  178,
  236,
  14,
  80,
  175,
  241,
  19,
  77,
  206,
  144,
  114,
  44,
  109,
  51,
  209,
  143,
  12,
  82,
  176,
  238,
  50,
  108,
  142,
  208,
  83,
  13,
  239,
  177,
  240,
  174,
  76,
  18,
  145,
  207,
  45,
  115,
  202,
  148,
  118,
  40,
  171,
  245,
  23,
  73,
  8,
  86,
  180,
  234,
  105,
  55,
  213,
  139,
  87,
  9,
  235,
  181,
  54,
  104,
  138,
  212,
  149,
  203,
  41,
  119,
  244,
  170,
  72,
  22,
  233,
  183,
  85,
  11,
  136,
  214,
  52,
  106,
  43,
  117,
  151,
  201,
  74,
  20,
  246,
  168,
  116,
  42,
  200,
  150,
  21,
  75,
  169,
  247,
  182,
  232,
  10,
  84,
  215,
  137,
  107,
  53
];
typeof Int32Array < "u" && (TABLE$7 = new Int32Array(TABLE$7));
const crc81wire = defineCrc("dallas-1-wire", function(s, A) {
  Buffer$1.isBuffer(s) || (s = createBuffer(s));
  let u = ~~A;
  for (let p = 0; p < s.length; p++) {
    const t = s[p];
    u = TABLE$7[(u ^ t) & 255] & 255;
  }
  return u;
});
let TABLE$6 = [
  0,
  49345,
  49537,
  320,
  49921,
  960,
  640,
  49729,
  50689,
  1728,
  1920,
  51009,
  1280,
  50625,
  50305,
  1088,
  52225,
  3264,
  3456,
  52545,
  3840,
  53185,
  52865,
  3648,
  2560,
  51905,
  52097,
  2880,
  51457,
  2496,
  2176,
  51265,
  55297,
  6336,
  6528,
  55617,
  6912,
  56257,
  55937,
  6720,
  7680,
  57025,
  57217,
  8e3,
  56577,
  7616,
  7296,
  56385,
  5120,
  54465,
  54657,
  5440,
  55041,
  6080,
  5760,
  54849,
  53761,
  4800,
  4992,
  54081,
  4352,
  53697,
  53377,
  4160,
  61441,
  12480,
  12672,
  61761,
  13056,
  62401,
  62081,
  12864,
  13824,
  63169,
  63361,
  14144,
  62721,
  13760,
  13440,
  62529,
  15360,
  64705,
  64897,
  15680,
  65281,
  16320,
  16e3,
  65089,
  64001,
  15040,
  15232,
  64321,
  14592,
  63937,
  63617,
  14400,
  10240,
  59585,
  59777,
  10560,
  60161,
  11200,
  10880,
  59969,
  60929,
  11968,
  12160,
  61249,
  11520,
  60865,
  60545,
  11328,
  58369,
  9408,
  9600,
  58689,
  9984,
  59329,
  59009,
  9792,
  8704,
  58049,
  58241,
  9024,
  57601,
  8640,
  8320,
  57409,
  40961,
  24768,
  24960,
  41281,
  25344,
  41921,
  41601,
  25152,
  26112,
  42689,
  42881,
  26432,
  42241,
  26048,
  25728,
  42049,
  27648,
  44225,
  44417,
  27968,
  44801,
  28608,
  28288,
  44609,
  43521,
  27328,
  27520,
  43841,
  26880,
  43457,
  43137,
  26688,
  30720,
  47297,
  47489,
  31040,
  47873,
  31680,
  31360,
  47681,
  48641,
  32448,
  32640,
  48961,
  32e3,
  48577,
  48257,
  31808,
  46081,
  29888,
  30080,
  46401,
  30464,
  47041,
  46721,
  30272,
  29184,
  45761,
  45953,
  29504,
  45313,
  29120,
  28800,
  45121,
  20480,
  37057,
  37249,
  20800,
  37633,
  21440,
  21120,
  37441,
  38401,
  22208,
  22400,
  38721,
  21760,
  38337,
  38017,
  21568,
  39937,
  23744,
  23936,
  40257,
  24320,
  40897,
  40577,
  24128,
  23040,
  39617,
  39809,
  23360,
  39169,
  22976,
  22656,
  38977,
  34817,
  18624,
  18816,
  35137,
  19200,
  35777,
  35457,
  19008,
  19968,
  36545,
  36737,
  20288,
  36097,
  19904,
  19584,
  35905,
  17408,
  33985,
  34177,
  17728,
  34561,
  18368,
  18048,
  34369,
  33281,
  17088,
  17280,
  33601,
  16640,
  33217,
  32897,
  16448
];
typeof Int32Array < "u" && (TABLE$6 = new Int32Array(TABLE$6));
const crc16 = defineCrc("crc-16", function(s, A) {
  Buffer$1.isBuffer(s) || (s = createBuffer(s));
  let u = ~~A;
  for (let p = 0; p < s.length; p++) {
    const t = s[p];
    u = (TABLE$6[(u ^ t) & 255] ^ u >> 8) & 65535;
  }
  return u;
});
let TABLE$5 = [
  0,
  4129,
  8258,
  12387,
  16516,
  20645,
  24774,
  28903,
  33032,
  37161,
  41290,
  45419,
  49548,
  53677,
  57806,
  61935,
  4657,
  528,
  12915,
  8786,
  21173,
  17044,
  29431,
  25302,
  37689,
  33560,
  45947,
  41818,
  54205,
  50076,
  62463,
  58334,
  9314,
  13379,
  1056,
  5121,
  25830,
  29895,
  17572,
  21637,
  42346,
  46411,
  34088,
  38153,
  58862,
  62927,
  50604,
  54669,
  13907,
  9842,
  5649,
  1584,
  30423,
  26358,
  22165,
  18100,
  46939,
  42874,
  38681,
  34616,
  63455,
  59390,
  55197,
  51132,
  18628,
  22757,
  26758,
  30887,
  2112,
  6241,
  10242,
  14371,
  51660,
  55789,
  59790,
  63919,
  35144,
  39273,
  43274,
  47403,
  23285,
  19156,
  31415,
  27286,
  6769,
  2640,
  14899,
  10770,
  56317,
  52188,
  64447,
  60318,
  39801,
  35672,
  47931,
  43802,
  27814,
  31879,
  19684,
  23749,
  11298,
  15363,
  3168,
  7233,
  60846,
  64911,
  52716,
  56781,
  44330,
  48395,
  36200,
  40265,
  32407,
  28342,
  24277,
  20212,
  15891,
  11826,
  7761,
  3696,
  65439,
  61374,
  57309,
  53244,
  48923,
  44858,
  40793,
  36728,
  37256,
  33193,
  45514,
  41451,
  53516,
  49453,
  61774,
  57711,
  4224,
  161,
  12482,
  8419,
  20484,
  16421,
  28742,
  24679,
  33721,
  37784,
  41979,
  46042,
  49981,
  54044,
  58239,
  62302,
  689,
  4752,
  8947,
  13010,
  16949,
  21012,
  25207,
  29270,
  46570,
  42443,
  38312,
  34185,
  62830,
  58703,
  54572,
  50445,
  13538,
  9411,
  5280,
  1153,
  29798,
  25671,
  21540,
  17413,
  42971,
  47098,
  34713,
  38840,
  59231,
  63358,
  50973,
  55100,
  9939,
  14066,
  1681,
  5808,
  26199,
  30326,
  17941,
  22068,
  55628,
  51565,
  63758,
  59695,
  39368,
  35305,
  47498,
  43435,
  22596,
  18533,
  30726,
  26663,
  6336,
  2273,
  14466,
  10403,
  52093,
  56156,
  60223,
  64286,
  35833,
  39896,
  43963,
  48026,
  19061,
  23124,
  27191,
  31254,
  2801,
  6864,
  10931,
  14994,
  64814,
  60687,
  56684,
  52557,
  48554,
  44427,
  40424,
  36297,
  31782,
  27655,
  23652,
  19525,
  15522,
  11395,
  7392,
  3265,
  61215,
  65342,
  53085,
  57212,
  44955,
  49082,
  36825,
  40952,
  28183,
  32310,
  20053,
  24180,
  11923,
  16050,
  3793,
  7920
];
typeof Int32Array < "u" && (TABLE$5 = new Int32Array(TABLE$5));
const crc16ccitt = defineCrc("ccitt", function(s, A) {
  Buffer$1.isBuffer(s) || (s = createBuffer(s));
  let u = typeof A < "u" ? ~~A : 65535;
  for (let p = 0; p < s.length; p++) {
    const t = s[p];
    u = (TABLE$5[(u >> 8 ^ t) & 255] ^ u << 8) & 65535;
  }
  return u;
});
let TABLE$4 = [
  0,
  49345,
  49537,
  320,
  49921,
  960,
  640,
  49729,
  50689,
  1728,
  1920,
  51009,
  1280,
  50625,
  50305,
  1088,
  52225,
  3264,
  3456,
  52545,
  3840,
  53185,
  52865,
  3648,
  2560,
  51905,
  52097,
  2880,
  51457,
  2496,
  2176,
  51265,
  55297,
  6336,
  6528,
  55617,
  6912,
  56257,
  55937,
  6720,
  7680,
  57025,
  57217,
  8e3,
  56577,
  7616,
  7296,
  56385,
  5120,
  54465,
  54657,
  5440,
  55041,
  6080,
  5760,
  54849,
  53761,
  4800,
  4992,
  54081,
  4352,
  53697,
  53377,
  4160,
  61441,
  12480,
  12672,
  61761,
  13056,
  62401,
  62081,
  12864,
  13824,
  63169,
  63361,
  14144,
  62721,
  13760,
  13440,
  62529,
  15360,
  64705,
  64897,
  15680,
  65281,
  16320,
  16e3,
  65089,
  64001,
  15040,
  15232,
  64321,
  14592,
  63937,
  63617,
  14400,
  10240,
  59585,
  59777,
  10560,
  60161,
  11200,
  10880,
  59969,
  60929,
  11968,
  12160,
  61249,
  11520,
  60865,
  60545,
  11328,
  58369,
  9408,
  9600,
  58689,
  9984,
  59329,
  59009,
  9792,
  8704,
  58049,
  58241,
  9024,
  57601,
  8640,
  8320,
  57409,
  40961,
  24768,
  24960,
  41281,
  25344,
  41921,
  41601,
  25152,
  26112,
  42689,
  42881,
  26432,
  42241,
  26048,
  25728,
  42049,
  27648,
  44225,
  44417,
  27968,
  44801,
  28608,
  28288,
  44609,
  43521,
  27328,
  27520,
  43841,
  26880,
  43457,
  43137,
  26688,
  30720,
  47297,
  47489,
  31040,
  47873,
  31680,
  31360,
  47681,
  48641,
  32448,
  32640,
  48961,
  32e3,
  48577,
  48257,
  31808,
  46081,
  29888,
  30080,
  46401,
  30464,
  47041,
  46721,
  30272,
  29184,
  45761,
  45953,
  29504,
  45313,
  29120,
  28800,
  45121,
  20480,
  37057,
  37249,
  20800,
  37633,
  21440,
  21120,
  37441,
  38401,
  22208,
  22400,
  38721,
  21760,
  38337,
  38017,
  21568,
  39937,
  23744,
  23936,
  40257,
  24320,
  40897,
  40577,
  24128,
  23040,
  39617,
  39809,
  23360,
  39169,
  22976,
  22656,
  38977,
  34817,
  18624,
  18816,
  35137,
  19200,
  35777,
  35457,
  19008,
  19968,
  36545,
  36737,
  20288,
  36097,
  19904,
  19584,
  35905,
  17408,
  33985,
  34177,
  17728,
  34561,
  18368,
  18048,
  34369,
  33281,
  17088,
  17280,
  33601,
  16640,
  33217,
  32897,
  16448
];
typeof Int32Array < "u" && (TABLE$4 = new Int32Array(TABLE$4));
const crc16modbus = defineCrc("crc-16-modbus", function(s, A) {
  Buffer$1.isBuffer(s) || (s = createBuffer(s));
  let u = typeof A < "u" ? ~~A : 65535;
  for (let p = 0; p < s.length; p++) {
    const t = s[p];
    u = (TABLE$4[(u ^ t) & 255] ^ u >> 8) & 65535;
  }
  return u;
}), crc16xmodem = defineCrc("xmodem", function(s, A) {
  Buffer$1.isBuffer(s) || (s = createBuffer(s));
  let u = typeof A < "u" ? ~~A : 0;
  for (let p = 0; p < s.length; p++) {
    const t = s[p];
    let l = u >>> 8 & 255;
    l ^= t & 255, l ^= l >>> 4, u = u << 8 & 65535, u ^= l, l = l << 5 & 65535, u ^= l, l = l << 7 & 65535, u ^= l;
  }
  return u;
});
let TABLE$3 = [
  0,
  4489,
  8978,
  12955,
  17956,
  22445,
  25910,
  29887,
  35912,
  40385,
  44890,
  48851,
  51820,
  56293,
  59774,
  63735,
  4225,
  264,
  13203,
  8730,
  22181,
  18220,
  30135,
  25662,
  40137,
  36160,
  49115,
  44626,
  56045,
  52068,
  63999,
  59510,
  8450,
  12427,
  528,
  5017,
  26406,
  30383,
  17460,
  21949,
  44362,
  48323,
  36440,
  40913,
  60270,
  64231,
  51324,
  55797,
  12675,
  8202,
  4753,
  792,
  30631,
  26158,
  21685,
  17724,
  48587,
  44098,
  40665,
  36688,
  64495,
  60006,
  55549,
  51572,
  16900,
  21389,
  24854,
  28831,
  1056,
  5545,
  10034,
  14011,
  52812,
  57285,
  60766,
  64727,
  34920,
  39393,
  43898,
  47859,
  21125,
  17164,
  29079,
  24606,
  5281,
  1320,
  14259,
  9786,
  57037,
  53060,
  64991,
  60502,
  39145,
  35168,
  48123,
  43634,
  25350,
  29327,
  16404,
  20893,
  9506,
  13483,
  1584,
  6073,
  61262,
  65223,
  52316,
  56789,
  43370,
  47331,
  35448,
  39921,
  29575,
  25102,
  20629,
  16668,
  13731,
  9258,
  5809,
  1848,
  65487,
  60998,
  56541,
  52564,
  47595,
  43106,
  39673,
  35696,
  33800,
  38273,
  42778,
  46739,
  49708,
  54181,
  57662,
  61623,
  2112,
  6601,
  11090,
  15067,
  20068,
  24557,
  28022,
  31999,
  38025,
  34048,
  47003,
  42514,
  53933,
  49956,
  61887,
  57398,
  6337,
  2376,
  15315,
  10842,
  24293,
  20332,
  32247,
  27774,
  42250,
  46211,
  34328,
  38801,
  58158,
  62119,
  49212,
  53685,
  10562,
  14539,
  2640,
  7129,
  28518,
  32495,
  19572,
  24061,
  46475,
  41986,
  38553,
  34576,
  62383,
  57894,
  53437,
  49460,
  14787,
  10314,
  6865,
  2904,
  32743,
  28270,
  23797,
  19836,
  50700,
  55173,
  58654,
  62615,
  32808,
  37281,
  41786,
  45747,
  19012,
  23501,
  26966,
  30943,
  3168,
  7657,
  12146,
  16123,
  54925,
  50948,
  62879,
  58390,
  37033,
  33056,
  46011,
  41522,
  23237,
  19276,
  31191,
  26718,
  7393,
  3432,
  16371,
  11898,
  59150,
  63111,
  50204,
  54677,
  41258,
  45219,
  33336,
  37809,
  27462,
  31439,
  18516,
  23005,
  11618,
  15595,
  3696,
  8185,
  63375,
  58886,
  54429,
  50452,
  45483,
  40994,
  37561,
  33584,
  31687,
  27214,
  22741,
  18780,
  15843,
  11370,
  7921,
  3960
];
typeof Int32Array < "u" && (TABLE$3 = new Int32Array(TABLE$3));
const crc16kermit = defineCrc("kermit", function(s, A) {
  Buffer$1.isBuffer(s) || (s = createBuffer(s));
  let u = typeof A < "u" ? ~~A : 0;
  for (let p = 0; p < s.length; p++) {
    const t = s[p];
    u = (TABLE$3[(u ^ t) & 255] ^ u >> 8) & 65535;
  }
  return u;
});
let TABLE$2 = [
  0,
  8801531,
  9098509,
  825846,
  9692897,
  1419802,
  1651692,
  10452759,
  10584377,
  2608578,
  2839604,
  11344079,
  3303384,
  11807523,
  12104405,
  4128302,
  12930697,
  4391538,
  5217156,
  13227903,
  5679208,
  13690003,
  14450021,
  5910942,
  6606768,
  14844747,
  15604413,
  6837830,
  16197969,
  7431594,
  8256604,
  16494759,
  840169,
  9084178,
  8783076,
  18463,
  10434312,
  1670131,
  1434117,
  9678590,
  11358416,
  2825259,
  2590173,
  10602790,
  4109873,
  12122826,
  11821884,
  3289031,
  13213536,
  5231515,
  4409965,
  12912278,
  5929345,
  14431610,
  13675660,
  5693559,
  6823513,
  15618722,
  14863188,
  6588335,
  16513208,
  8238147,
  7417269,
  16212302,
  1680338,
  10481449,
  9664223,
  1391140,
  9061683,
  788936,
  36926,
  8838341,
  12067563,
  4091408,
  3340262,
  11844381,
  2868234,
  11372785,
  10555655,
  2579964,
  14478683,
  5939616,
  5650518,
  13661357,
  5180346,
  13190977,
  12967607,
  4428364,
  8219746,
  16457881,
  16234863,
  7468436,
  15633027,
  6866552,
  6578062,
  14816117,
  1405499,
  9649856,
  10463030,
  1698765,
  8819930,
  55329,
  803287,
  9047340,
  11858690,
  3325945,
  4072975,
  12086004,
  2561507,
  10574104,
  11387118,
  2853909,
  13647026,
  5664841,
  5958079,
  14460228,
  4446803,
  12949160,
  13176670,
  5194661,
  7454091,
  16249200,
  16476294,
  8201341,
  14834538,
  6559633,
  6852199,
  15647388,
  3360676,
  11864927,
  12161705,
  4185682,
  10527045,
  2551230,
  2782280,
  11286707,
  9619101,
  1346150,
  1577872,
  10379115,
  73852,
  8875143,
  9172337,
  899466,
  16124205,
  7357910,
  8182816,
  16421083,
  6680524,
  14918455,
  15678145,
  6911546,
  5736468,
  13747439,
  14507289,
  5968354,
  12873461,
  4334094,
  5159928,
  13170435,
  4167245,
  12180150,
  11879232,
  3346363,
  11301036,
  2767959,
  2532769,
  10545498,
  10360692,
  1596303,
  1360505,
  9604738,
  913813,
  9157998,
  8856728,
  92259,
  16439492,
  8164415,
  7343561,
  16138546,
  6897189,
  15692510,
  14936872,
  6662099,
  5986813,
  14488838,
  13733104,
  5750795,
  13156124,
  5174247,
  4352529,
  12855018,
  2810998,
  11315341,
  10498427,
  2522496,
  12124823,
  4148844,
  3397530,
  11901793,
  9135439,
  862644,
  110658,
  8912057,
  1606574,
  10407765,
  9590435,
  1317464,
  15706879,
  6940164,
  6651890,
  14889737,
  8145950,
  16384229,
  16161043,
  7394792,
  5123014,
  13133629,
  12910283,
  4370992,
  14535975,
  5997020,
  5707818,
  13718737,
  2504095,
  10516836,
  11329682,
  2796649,
  11916158,
  3383173,
  4130419,
  12143240,
  8893606,
  129117,
  876971,
  9121104,
  1331783,
  9576124,
  10389322,
  1625009,
  14908182,
  6633453,
  6925851,
  15721184,
  7380471,
  16175372,
  16402682,
  8127489,
  4389423,
  12891860,
  13119266,
  5137369,
  13704398,
  5722165,
  6015427,
  14517560
];
typeof Int32Array < "u" && (TABLE$2 = new Int32Array(TABLE$2));
const crc24 = defineCrc("crc-24", function(s, A) {
  Buffer$1.isBuffer(s) || (s = createBuffer(s));
  let u = typeof A < "u" ? ~~A : 11994318;
  for (let p = 0; p < s.length; p++) {
    const t = s[p];
    u = (TABLE$2[(u >> 16 ^ t) & 255] ^ u << 8) & 16777215;
  }
  return u;
});
let TABLE$1 = [
  0,
  1996959894,
  3993919788,
  2567524794,
  124634137,
  1886057615,
  3915621685,
  2657392035,
  249268274,
  2044508324,
  3772115230,
  2547177864,
  162941995,
  2125561021,
  3887607047,
  2428444049,
  498536548,
  1789927666,
  4089016648,
  2227061214,
  450548861,
  1843258603,
  4107580753,
  2211677639,
  325883990,
  1684777152,
  4251122042,
  2321926636,
  335633487,
  1661365465,
  4195302755,
  2366115317,
  997073096,
  1281953886,
  3579855332,
  2724688242,
  1006888145,
  1258607687,
  3524101629,
  2768942443,
  901097722,
  1119000684,
  3686517206,
  2898065728,
  853044451,
  1172266101,
  3705015759,
  2882616665,
  651767980,
  1373503546,
  3369554304,
  3218104598,
  565507253,
  1454621731,
  3485111705,
  3099436303,
  671266974,
  1594198024,
  3322730930,
  2970347812,
  795835527,
  1483230225,
  3244367275,
  3060149565,
  1994146192,
  31158534,
  2563907772,
  4023717930,
  1907459465,
  112637215,
  2680153253,
  3904427059,
  2013776290,
  251722036,
  2517215374,
  3775830040,
  2137656763,
  141376813,
  2439277719,
  3865271297,
  1802195444,
  476864866,
  2238001368,
  4066508878,
  1812370925,
  453092731,
  2181625025,
  4111451223,
  1706088902,
  314042704,
  2344532202,
  4240017532,
  1658658271,
  366619977,
  2362670323,
  4224994405,
  1303535960,
  984961486,
  2747007092,
  3569037538,
  1256170817,
  1037604311,
  2765210733,
  3554079995,
  1131014506,
  879679996,
  2909243462,
  3663771856,
  1141124467,
  855842277,
  2852801631,
  3708648649,
  1342533948,
  654459306,
  3188396048,
  3373015174,
  1466479909,
  544179635,
  3110523913,
  3462522015,
  1591671054,
  702138776,
  2966460450,
  3352799412,
  1504918807,
  783551873,
  3082640443,
  3233442989,
  3988292384,
  2596254646,
  62317068,
  1957810842,
  3939845945,
  2647816111,
  81470997,
  1943803523,
  3814918930,
  2489596804,
  225274430,
  2053790376,
  3826175755,
  2466906013,
  167816743,
  2097651377,
  4027552580,
  2265490386,
  503444072,
  1762050814,
  4150417245,
  2154129355,
  426522225,
  1852507879,
  4275313526,
  2312317920,
  282753626,
  1742555852,
  4189708143,
  2394877945,
  397917763,
  1622183637,
  3604390888,
  2714866558,
  953729732,
  1340076626,
  3518719985,
  2797360999,
  1068828381,
  1219638859,
  3624741850,
  2936675148,
  906185462,
  1090812512,
  3747672003,
  2825379669,
  829329135,
  1181335161,
  3412177804,
  3160834842,
  628085408,
  1382605366,
  3423369109,
  3138078467,
  570562233,
  1426400815,
  3317316542,
  2998733608,
  733239954,
  1555261956,
  3268935591,
  3050360625,
  752459403,
  1541320221,
  2607071920,
  3965973030,
  1969922972,
  40735498,
  2617837225,
  3943577151,
  1913087877,
  83908371,
  2512341634,
  3803740692,
  2075208622,
  213261112,
  2463272603,
  3855990285,
  2094854071,
  198958881,
  2262029012,
  4057260610,
  1759359992,
  534414190,
  2176718541,
  4139329115,
  1873836001,
  414664567,
  2282248934,
  4279200368,
  1711684554,
  285281116,
  2405801727,
  4167216745,
  1634467795,
  376229701,
  2685067896,
  3608007406,
  1308918612,
  956543938,
  2808555105,
  3495958263,
  1231636301,
  1047427035,
  2932959818,
  3654703836,
  1088359270,
  936918e3,
  2847714899,
  3736837829,
  1202900863,
  817233897,
  3183342108,
  3401237130,
  1404277552,
  615818150,
  3134207493,
  3453421203,
  1423857449,
  601450431,
  3009837614,
  3294710456,
  1567103746,
  711928724,
  3020668471,
  3272380065,
  1510334235,
  755167117
];
typeof Int32Array < "u" && (TABLE$1 = new Int32Array(TABLE$1));
const crc32$1 = defineCrc("crc-32", function(s, A) {
  Buffer$1.isBuffer(s) || (s = createBuffer(s));
  let u = A === 0 ? 0 : ~~A ^ -1;
  for (let p = 0; p < s.length; p++) {
    const t = s[p];
    u = TABLE$1[(u ^ t) & 255] ^ u >>> 8;
  }
  return u ^ -1;
});
let TABLE = [
  0,
  1996959894,
  3993919788,
  2567524794,
  124634137,
  1886057615,
  3915621685,
  2657392035,
  249268274,
  2044508324,
  3772115230,
  2547177864,
  162941995,
  2125561021,
  3887607047,
  2428444049,
  498536548,
  1789927666,
  4089016648,
  2227061214,
  450548861,
  1843258603,
  4107580753,
  2211677639,
  325883990,
  1684777152,
  4251122042,
  2321926636,
  335633487,
  1661365465,
  4195302755,
  2366115317,
  997073096,
  1281953886,
  3579855332,
  2724688242,
  1006888145,
  1258607687,
  3524101629,
  2768942443,
  901097722,
  1119000684,
  3686517206,
  2898065728,
  853044451,
  1172266101,
  3705015759,
  2882616665,
  651767980,
  1373503546,
  3369554304,
  3218104598,
  565507253,
  1454621731,
  3485111705,
  3099436303,
  671266974,
  1594198024,
  3322730930,
  2970347812,
  795835527,
  1483230225,
  3244367275,
  3060149565,
  1994146192,
  31158534,
  2563907772,
  4023717930,
  1907459465,
  112637215,
  2680153253,
  3904427059,
  2013776290,
  251722036,
  2517215374,
  3775830040,
  2137656763,
  141376813,
  2439277719,
  3865271297,
  1802195444,
  476864866,
  2238001368,
  4066508878,
  1812370925,
  453092731,
  2181625025,
  4111451223,
  1706088902,
  314042704,
  2344532202,
  4240017532,
  1658658271,
  366619977,
  2362670323,
  4224994405,
  1303535960,
  984961486,
  2747007092,
  3569037538,
  1256170817,
  1037604311,
  2765210733,
  3554079995,
  1131014506,
  879679996,
  2909243462,
  3663771856,
  1141124467,
  855842277,
  2852801631,
  3708648649,
  1342533948,
  654459306,
  3188396048,
  3373015174,
  1466479909,
  544179635,
  3110523913,
  3462522015,
  1591671054,
  702138776,
  2966460450,
  3352799412,
  1504918807,
  783551873,
  3082640443,
  3233442989,
  3988292384,
  2596254646,
  62317068,
  1957810842,
  3939845945,
  2647816111,
  81470997,
  1943803523,
  3814918930,
  2489596804,
  225274430,
  2053790376,
  3826175755,
  2466906013,
  167816743,
  2097651377,
  4027552580,
  2265490386,
  503444072,
  1762050814,
  4150417245,
  2154129355,
  426522225,
  1852507879,
  4275313526,
  2312317920,
  282753626,
  1742555852,
  4189708143,
  2394877945,
  397917763,
  1622183637,
  3604390888,
  2714866558,
  953729732,
  1340076626,
  3518719985,
  2797360999,
  1068828381,
  1219638859,
  3624741850,
  2936675148,
  906185462,
  1090812512,
  3747672003,
  2825379669,
  829329135,
  1181335161,
  3412177804,
  3160834842,
  628085408,
  1382605366,
  3423369109,
  3138078467,
  570562233,
  1426400815,
  3317316542,
  2998733608,
  733239954,
  1555261956,
  3268935591,
  3050360625,
  752459403,
  1541320221,
  2607071920,
  3965973030,
  1969922972,
  40735498,
  2617837225,
  3943577151,
  1913087877,
  83908371,
  2512341634,
  3803740692,
  2075208622,
  213261112,
  2463272603,
  3855990285,
  2094854071,
  198958881,
  2262029012,
  4057260610,
  1759359992,
  534414190,
  2176718541,
  4139329115,
  1873836001,
  414664567,
  2282248934,
  4279200368,
  1711684554,
  285281116,
  2405801727,
  4167216745,
  1634467795,
  376229701,
  2685067896,
  3608007406,
  1308918612,
  956543938,
  2808555105,
  3495958263,
  1231636301,
  1047427035,
  2932959818,
  3654703836,
  1088359270,
  936918e3,
  2847714899,
  3736837829,
  1202900863,
  817233897,
  3183342108,
  3401237130,
  1404277552,
  615818150,
  3134207493,
  3453421203,
  1423857449,
  601450431,
  3009837614,
  3294710456,
  1567103746,
  711928724,
  3020668471,
  3272380065,
  1510334235,
  755167117
];
typeof Int32Array < "u" && (TABLE = new Int32Array(TABLE));
const crcjam = defineCrc("jam", function(s, A = -1) {
  Buffer$1.isBuffer(s) || (s = createBuffer(s));
  let u = A === 0 ? 0 : ~~A;
  for (let p = 0; p < s.length; p++) {
    const t = s[p];
    u = TABLE[(u ^ t) & 255] ^ u >>> 8;
  }
  return u;
}), index = {
  crc1,
  crc8,
  crc81wire,
  crc16,
  crc16ccitt,
  crc16modbus,
  crc16xmodem,
  crc16kermit,
  crc24,
  crc32: crc32$1,
  crcjam
}, crc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  crc1,
  crc16,
  crc16ccitt,
  crc16kermit,
  crc16modbus,
  crc16xmodem,
  crc24,
  crc32: crc32$1,
  crc8,
  crc81wire,
  crcjam,
  default: index
}, Symbol.toStringTag, { value: "Module" })), require$$1$3 = /* @__PURE__ */ getAugmentedNamespace(crc);
var hasRequiredUtils$e;
function requireUtils$e() {
  if (hasRequiredUtils$e) return utils$f;
  hasRequiredUtils$e = 1;
  var s = utils$f && utils$f.__importDefault || function(le) {
    return le && le.__esModule ? le : { default: le };
  };
  Object.defineProperty(utils$f, "__esModule", { value: !0 }), utils$f.bufferXOR = utils$f.setDifference = utils$f.arrayContains = utils$f.arraysEqual = utils$f.hasPrefix = utils$f.isURType = utils$f.intToBytes = utils$f.toUint32 = utils$f.getCRCHex = utils$f.getCRC = utils$f.split = utils$f.partition = utils$f.sha256Hash = void 0;
  const A = s(requireSha_js()), u = require$$1$3, p = (le) => A.default("sha256").update(le).digest();
  utils$f.sha256Hash = p;
  const t = (le, ge) => le.match(new RegExp(".{1," + ge + "}", "g")) || [le];
  utils$f.partition = t;
  const l = (le, ge) => [le.slice(0, -ge), le.slice(-ge)];
  utils$f.split = l;
  const m = (le) => u.crc32(le);
  utils$f.getCRC = m;
  const b = (le) => u.crc32(le).toString(16).padStart(8, "0");
  utils$f.getCRCHex = b;
  const k = (le) => le >>> 0;
  utils$f.toUint32 = k;
  const C = (le) => {
    const ge = new ArrayBuffer(4);
    return new DataView(ge).setUint32(0, le, !1), Buffer.from(ge);
  };
  utils$f.intToBytes = C;
  const B = (le) => le.split("").every((ge, pe) => {
    let Ie = le.charCodeAt(pe);
    return 97 <= Ie && Ie <= 122 || 48 <= Ie && Ie <= 57 || Ie === 45;
  });
  utils$f.isURType = B;
  const Q = (le, ge) => le.indexOf(ge) === 0;
  utils$f.hasPrefix = Q;
  const P = (le, ge) => le.length !== ge.length ? !1 : le.every((pe) => ge.includes(pe));
  utils$f.arraysEqual = P;
  const x = (le, ge) => ge.every((pe) => le.includes(pe));
  utils$f.arrayContains = x;
  const M = (le, ge) => le.filter((pe) => ge.indexOf(pe) < 0);
  utils$f.setDifference = M;
  const F = (le, ge) => {
    const pe = Math.max(le.length, ge.length), Ie = Buffer.allocUnsafe(pe);
    for (let be = 0; be < pe; ++be)
      Ie[be] = le[be] ^ ge[be];
    return Ie;
  };
  return utils$f.bufferXOR = F, utils$f;
}
var cbor = {}, main$5 = { exports: {} }, main$4 = main$5.exports, hasRequiredMain$4;
function requireMain$4() {
  return hasRequiredMain$4 || (hasRequiredMain$4 = 1, function(s) {
    (function(A, u) {
      s.exports ? s.exports = u() : A.CBOR = u();
    })(main$4, function() {
      var A = function() {
        function u(Te) {
          this.$hex = Te;
        }
        u.prototype = {
          length: function() {
            return this.$hex.length / 2;
          },
          toString: function(Te) {
            if (!Te || Te === "hex" || Te === 16) return this.$hex;
            if (Te === "utf-8") {
              for (var Qe = "", xe = 0; xe < this.$hex.length; xe += 2)
                Qe += "%" + this.$hex.substring(xe, xe + 2);
              return decodeURIComponent(Qe);
            }
            if (Te === "latin") {
              for (var Qe = [], xe = 0; xe < this.$hex.length; xe += 2)
                Qe.push(parseInt(this.$hex.substring(xe, xe + 2), 16));
              return String.fromCharCode.apply(String, Qe);
            }
            throw new Error("Unrecognised format: " + Te);
          }
        }, u.fromLatinString = function(Te) {
          for (var Qe = "", xe = 0; xe < Te.length; xe++) {
            var Ee = Te.charCodeAt(xe).toString(16);
            Ee.length === 1 && (Ee = "0" + Ee), Qe += Ee;
          }
          return new u(Qe);
        }, u.fromUtf8String = function(Te) {
          for (var Qe = encodeURIComponent(Te), xe = "", Ee = 0; Ee < Qe.length; Ee++)
            if (Qe.charAt(Ee) === "%")
              xe += Qe.substring(Ee + 1, Ee + 3), Ee += 2;
            else {
              var He = Qe.charCodeAt(Ee).toString(16);
              He.length < 2 && (He = "0" + He), xe += He;
            }
          return new u(xe);
        };
        var p = [], t = {}, l = function(Te) {
          return function() {
            throw new Error(Te + " not implemented");
          };
        };
        function m() {
        }
        m.prototype = {
          peekByte: l("peekByte"),
          readByte: l("readByte"),
          readChunk: l("readChunk"),
          readFloat16: function() {
            var Te = this.readUint16(), Qe = (Te & 32767) >> 10, xe = Te & 1023, Ee = Te & 32768;
            if (Qe === 31)
              return xe === 0 ? Ee ? -1 / 0 : 1 / 0 : NaN;
            var He = Qe ? Math.pow(2, Qe - 25) * (1024 + xe) : Math.pow(2, -24) * xe;
            return Ee ? -He : He;
          },
          readFloat32: function() {
            var Te = this.readUint32(), Qe = (Te & 2147483647) >> 23, xe = Te & 8388607, Ee = Te & 2147483648;
            if (Qe === 255)
              return xe === 0 ? Ee ? -1 / 0 : 1 / 0 : NaN;
            var He = Qe ? Math.pow(2, Qe - 23 - 127) * (8388608 + xe) : Math.pow(2, -149) * xe;
            return Ee ? -He : He;
          },
          readFloat64: function() {
            var Te = this.readUint32(), Qe = this.readUint32(), xe = Te >> 20 & 2047, Ee = (Te & 1048575) * 4294967296 + Qe, He = Te & 2147483648;
            if (xe === 2047)
              return Ee === 0 ? He ? -1 / 0 : 1 / 0 : NaN;
            var ve = xe ? Math.pow(2, xe - 52 - 1023) * (4503599627370496 + Ee) : Math.pow(2, -1074) * Ee;
            return He ? -ve : ve;
          },
          readUint16: function() {
            return this.readByte() * 256 + this.readByte();
          },
          readUint32: function() {
            return this.readUint16() * 65536 + this.readUint16();
          },
          readUint64: function() {
            return this.readUint32() * 4294967296 + this.readUint32();
          }
        };
        function b() {
        }
        b.prototype = {
          writeByte: l("writeByte"),
          result: l("result"),
          writeFloat16: l("writeFloat16"),
          writeFloat32: l("writeFloat32"),
          writeFloat64: l("writeFloat64"),
          writeUint16: function(Te) {
            this.writeByte(Te >> 8 & 255), this.writeByte(Te & 255);
          },
          writeUint32: function(Te) {
            this.writeUint16(Te >> 16 & 65535), this.writeUint16(Te & 65535);
          },
          writeUint64: function(Te) {
            if (Te >= 9007199254740992 || Te <= -9007199254740992)
              throw new Error("Cannot encode Uint64 of: " + Te + " magnitude to big (floating point errors)");
            this.writeUint32(Math.floor(Te / 4294967296)), this.writeUint32(Te % 4294967296);
          },
          writeString: l("writeString"),
          canWriteBinary: function(Te) {
            return !1;
          },
          writeBinary: l("writeChunk")
        };
        function k(Te) {
          var Qe = Te.readByte(), xe = Qe >> 5, Ee = Qe & 31;
          return { type: xe, value: Ee };
        }
        function C(Te, Qe) {
          var xe = Te.value;
          if (xe < 24)
            return xe;
          if (xe == 24)
            return Qe.readByte();
          if (xe == 25)
            return Qe.readUint16();
          if (xe == 26)
            return Qe.readUint32();
          if (xe == 27)
            return Qe.readUint64();
          if (xe == 31)
            return null;
          l("Additional info: " + xe)();
        }
        function B(Te, Qe, xe) {
          xe.writeByte(Te << 5 | Qe);
        }
        function Q(Te, Qe, xe) {
          var Ee = Te << 5;
          Qe < 24 ? xe.writeByte(Ee | Qe) : Qe < 256 ? (xe.writeByte(Ee | 24), xe.writeByte(Qe)) : Qe < 65536 ? (xe.writeByte(Ee | 25), xe.writeUint16(Qe)) : Qe < 4294967296 ? (xe.writeByte(Ee | 26), xe.writeUint32(Qe)) : (xe.writeByte(Ee | 27), xe.writeUint64(Qe));
        }
        var P = new Error();
        function x(Te) {
          var Qe = k(Te);
          switch (Qe.type) {
            case 0:
              return C(Qe, Te);
            case 1:
              return -1 - C(Qe, Te);
            case 2:
              return Te.readChunk(C(Qe, Te));
            case 3:
              var xe = Te.readChunk(C(Qe, Te));
              return xe.toString("utf-8");
            case 4:
            case 5:
              var Ee = C(Qe, Te), Ne = [];
              if (Ee !== null) {
                Qe.type === 5 && (Ee *= 2);
                for (var He = 0; He < Ee; He++)
                  Ne[He] = x(Te);
              } else
                for (var ve; (ve = x(Te)) !== P; )
                  Ne.push(ve);
              if (Qe.type === 5) {
                for (var we = {}, He = 0; He < Ne.length; He += 2)
                  we[Ne[He]] = Ne[He + 1];
                return we;
              } else
                return Ne;
            case 6:
              var Ce = C(Qe, Te), Se = t[Ce], Ne = x(Te);
              return Se ? Se(Ne) : Ne;
            case 7:
              if (Qe.value === 25)
                return Te.readFloat16();
              if (Qe.value === 26)
                return Te.readFloat32();
              if (Qe.value === 27)
                return Te.readFloat64();
              switch (C(Qe, Te)) {
                case 20:
                  return !1;
                case 21:
                  return !0;
                case 22:
                  return null;
                case 23:
                  return;
                case null:
                  return P;
                default:
                  throw new Error("Unknown fixed value: " + Qe.value);
              }
            default:
              throw new Error("Unsupported header: " + JSON.stringify(Qe));
          }
          throw new Error("not implemented yet");
        }
        function M(Te, Qe) {
          for (var xe = 0; xe < p.length; xe++) {
            var Ee = p[xe].fn(Te);
            if (Ee !== void 0)
              return Q(6, p[xe].tag, Qe), M(Ee, Qe);
          }
          if (Te && typeof Te.toCBOR == "function" && (Te = Te.toCBOR()), Te === !1)
            Q(7, 20, Qe);
          else if (Te === !0)
            Q(7, 21, Qe);
          else if (Te === null)
            Q(7, 22, Qe);
          else if (Te === void 0)
            Q(7, 23, Qe);
          else if (typeof Te == "number")
            Math.floor(Te) === Te && Te < 9007199254740992 && Te > -9007199254740992 ? Te < 0 ? Q(1, -1 - Te, Qe) : Q(0, Te, Qe) : (B(7, 27, Qe), Qe.writeFloat64(Te));
          else if (typeof Te == "string")
            Qe.writeString(Te, function(ve) {
              Q(3, ve, Qe);
            });
          else if (Qe.canWriteBinary(Te))
            Qe.writeBinary(Te, function(ve) {
              Q(2, ve, Qe);
            });
          else if (typeof Te == "object")
            if (ge.config.useToJSON && typeof Te.toJSON == "function" && (Te = Te.toJSON()), Array.isArray(Te)) {
              Q(4, Te.length, Qe);
              for (var xe = 0; xe < Te.length; xe++)
                M(Te[xe], Qe);
            } else {
              var He = Object.keys(Te);
              Q(5, He.length, Qe);
              for (var xe = 0; xe < He.length; xe++)
                M(He[xe], Qe), M(Te[He[xe]], Qe);
            }
          else
            throw new Error("CBOR encoding not supported: " + Te);
        }
        var F = [], le = [], ge = {
          config: {
            useToJSON: !0
          },
          addWriter: function(Te, Qe) {
            typeof Te == "string" ? le.push(function(xe) {
              if (Te === xe) return Qe(xe);
            }) : le.push(Te);
          },
          addReader: function(Te, Qe) {
            typeof Te == "string" ? F.push(function(xe, Ee) {
              if (Te === Ee) return Qe(xe, Ee);
            }) : F.push(Te);
          },
          encode: function(Te, Qe) {
            for (var xe = 0; xe < le.length; xe++) {
              var Ee = le[xe], He = Ee(Qe);
              if (He)
                return M(Te, He), He.result();
            }
            throw new Error("Unsupported output format: " + Qe);
          },
          decode: function(Te, Qe) {
            for (var xe = 0; xe < F.length; xe++) {
              var Ee = F[xe], He = Ee(Te, Qe);
              if (He)
                return x(He);
            }
            throw new Error("Unsupported input format: " + Qe);
          },
          addSemanticEncode: function(Te, Qe) {
            if (typeof Te != "number" || Te % 1 !== 0 || Te < 0)
              throw new Error("Tag must be a positive integer");
            return p.push({ tag: Te, fn: Qe }), this;
          },
          addSemanticDecode: function(Te, Qe) {
            if (typeof Te != "number" || Te % 1 !== 0 || Te < 0)
              throw new Error("Tag must be a positive integer");
            return t[Te] = Qe, this;
          },
          Reader: m,
          Writer: b
        };
        function pe(Te) {
          this.buffer = Te, this.pos = 0;
        }
        pe.prototype = Object.create(m.prototype), pe.prototype.peekByte = function() {
          return this.buffer[this.pos];
        }, pe.prototype.readByte = function() {
          return this.buffer[this.pos++];
        }, pe.prototype.readUint16 = function() {
          var Te = this.buffer.readUInt16BE(this.pos);
          return this.pos += 2, Te;
        }, pe.prototype.readUint32 = function() {
          var Te = this.buffer.readUInt32BE(this.pos);
          return this.pos += 4, Te;
        }, pe.prototype.readFloat32 = function() {
          var Te = this.buffer.readFloatBE(this.pos);
          return this.pos += 4, Te;
        }, pe.prototype.readFloat64 = function() {
          var Te = this.buffer.readDoubleBE(this.pos);
          return this.pos += 8, Te;
        }, pe.prototype.readChunk = function(Te) {
          var Qe = Buffer.alloc(Te);
          return this.buffer.copy(Qe, 0, this.pos, this.pos += Te), Qe;
        };
        function Ie(Te) {
          this.byteLength = 0, this.defaultBufferLength = 16384, this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0, this.completeBuffers = [], this.stringFormat = Te;
        }
        Ie.prototype = Object.create(b.prototype), Ie.prototype.writeByte = function(Te) {
          this.latestBuffer[this.latestBufferOffset++] = Te, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0), this.byteLength++;
        }, Ie.prototype.writeFloat32 = function(Te) {
          var Qe = Buffer.alloc(4);
          Qe.writeFloatBE(Te, 0), this.writeBuffer(Qe);
        }, Ie.prototype.writeFloat64 = function(Te) {
          var Qe = Buffer.alloc(8);
          Qe.writeDoubleBE(Te, 0), this.writeBuffer(Qe);
        }, Ie.prototype.writeString = function(Te, Qe) {
          var xe = Buffer.from(Te, "utf-8");
          Qe(xe.length), this.writeBuffer(xe);
        }, Ie.prototype.canWriteBinary = function(Te) {
          return Te instanceof Buffer;
        }, Ie.prototype.writeBinary = function(Te, Qe) {
          Qe(Te.length), this.writeBuffer(Te);
        }, Ie.prototype.writeBuffer = function(Te) {
          if (!(Te instanceof Buffer)) throw new TypeError("BufferWriter only accepts Buffers");
          this.latestBufferOffset ? this.latestBuffer.length - this.latestBufferOffset >= Te.length ? (Te.copy(this.latestBuffer, this.latestBufferOffset), this.latestBufferOffset += Te.length, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0)) : (this.completeBuffers.push(this.latestBuffer.slice(0, this.latestBufferOffset)), this.completeBuffers.push(Te), this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0) : this.completeBuffers.push(Te), this.byteLength += Te.length;
        }, Ie.prototype.result = function() {
          for (var Te = Buffer.alloc(this.byteLength), Qe = 0, xe = 0; xe < this.completeBuffers.length; xe++) {
            var Ee = this.completeBuffers[xe];
            Ee.copy(Te, Qe, 0, Ee.length), Qe += Ee.length;
          }
          return this.latestBufferOffset && this.latestBuffer.copy(Te, Qe, 0, this.latestBufferOffset), this.stringFormat ? Te.toString(this.stringFormat) : Te;
        }, typeof Buffer == "function" && (ge.addReader(function(Te, Qe) {
          if (Te instanceof Buffer)
            return new pe(Te);
          if (Qe === "hex" || Qe === "base64") {
            var xe = Buffer.from(Te, Qe);
            return new pe(xe);
          }
        }), ge.addWriter(function(Te) {
          if (!Te || Te === "buffer")
            return new Ie();
          if (Te === "hex" || Te === "base64")
            return new Ie(Te);
        }));
        function be(Te) {
          this.hex = Te, this.pos = 0;
        }
        be.prototype = Object.create(m.prototype), be.prototype.peekByte = function() {
          var Te = this.hex.substring(this.pos, 2);
          return parseInt(Te, 16);
        }, be.prototype.readByte = function() {
          var Te = this.hex.substring(this.pos, this.pos + 2);
          return this.pos += 2, parseInt(Te, 16);
        }, be.prototype.readChunk = function(Te) {
          var Qe = this.hex.substring(this.pos, this.pos + Te * 2);
          return this.pos += Te * 2, typeof Buffer == "function" ? Buffer.from(Qe, "hex") : new u(Qe);
        };
        function Pe(Te) {
          this.$hex = "", this.finalFormat = Te || "hex";
        }
        return Pe.prototype = Object.create(b.prototype), Pe.prototype.writeByte = function(Te) {
          if (Te < 0 || Te > 255) throw new Error("Byte value out of range: " + Te);
          var Qe = Te.toString(16);
          Qe.length == 1 && (Qe = "0" + Qe), this.$hex += Qe;
        }, Pe.prototype.canWriteBinary = function(Te) {
          return Te instanceof u || typeof Buffer == "function" && Te instanceof Buffer;
        }, Pe.prototype.writeBinary = function(Te, Qe) {
          if (Te instanceof u)
            Qe(Te.length()), this.$hex += Te.$hex;
          else if (typeof Buffer == "function" && Te instanceof Buffer)
            Qe(Te.length), this.$hex += Te.toString("hex");
          else
            throw new TypeError("HexWriter only accepts BinaryHex or Buffers");
        }, Pe.prototype.result = function() {
          return this.finalFormat === "buffer" && typeof Buffer == "function" ? Buffer.from(this.$hex, "hex") : new u(this.$hex).toString(this.finalFormat);
        }, Pe.prototype.writeString = function(Te, Qe) {
          var xe = u.fromUtf8String(Te);
          Qe(xe.length()), this.$hex += xe.$hex;
        }, ge.addReader(function(Te, Qe) {
          if (Te instanceof u || Te.$hex)
            return new be(Te.$hex);
          if (Qe === "hex")
            return new be(Te);
        }), ge.addWriter(function(Te) {
          if (Te === "hex")
            return new Pe();
        }), ge;
      }();
      return A.addSemanticEncode(0, function(u) {
        if (u instanceof Date)
          return u.toISOString();
      }).addSemanticDecode(0, function(u) {
        return new Date(u);
      }).addSemanticDecode(1, function(u) {
        return new Date(u);
      }), A;
    });
  }(main$5)), main$5.exports;
}
var hasRequiredCbor;
function requireCbor() {
  if (hasRequiredCbor) return cbor;
  hasRequiredCbor = 1, Object.defineProperty(cbor, "__esModule", { value: !0 }), cbor.cborDecode = cbor.cborEncode = void 0;
  const s = requireMain$4(), A = (p) => s.encode(p);
  cbor.cborEncode = A;
  const u = (p) => s.decode(Buffer.isBuffer(p) ? p : Buffer.from(p, "hex"));
  return cbor.cborDecode = u, cbor;
}
var hasRequiredUr$1;
function requireUr$1() {
  if (hasRequiredUr$1) return ur$1;
  hasRequiredUr$1 = 1, Object.defineProperty(ur$1, "__esModule", { value: !0 });
  const s = requireErrors$4(), A = requireUtils$e(), u = requireCbor();
  class p {
    constructor(l, m = "bytes") {
      if (this._cborPayload = l, this._type = m, !A.isURType(this._type))
        throw new s.InvalidTypeError();
    }
    static fromBuffer(l) {
      return new p(u.cborEncode(l));
    }
    static from(l, m) {
      return p.fromBuffer(Buffer.from(l, m));
    }
    decodeCBOR() {
      return u.cborDecode(this._cborPayload);
    }
    get type() {
      return this._type;
    }
    get cbor() {
      return this._cborPayload;
    }
    equals(l) {
      return this.type === l.type && this.cbor.equals(l.cbor);
    }
  }
  return ur$1.default = p, ur$1;
}
var urEncoder = {}, fountainEncoder = {}, assert$2 = { exports: {} }, errors$3 = {}, hasRequiredErrors$3;
function requireErrors$3() {
  if (hasRequiredErrors$3) return errors$3;
  hasRequiredErrors$3 = 1;
  function s(pe) {
    "@babel/helpers - typeof";
    return s = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Ie) {
      return typeof Ie;
    } : function(Ie) {
      return Ie && typeof Symbol == "function" && Ie.constructor === Symbol && Ie !== Symbol.prototype ? "symbol" : typeof Ie;
    }, s(pe);
  }
  function A(pe, Ie, be) {
    return Object.defineProperty(pe, "prototype", { writable: !1 }), pe;
  }
  function u(pe, Ie) {
    if (!(pe instanceof Ie))
      throw new TypeError("Cannot call a class as a function");
  }
  function p(pe, Ie) {
    if (typeof Ie != "function" && Ie !== null)
      throw new TypeError("Super expression must either be null or a function");
    pe.prototype = Object.create(Ie && Ie.prototype, { constructor: { value: pe, writable: !0, configurable: !0 } }), Object.defineProperty(pe, "prototype", { writable: !1 }), Ie && t(pe, Ie);
  }
  function t(pe, Ie) {
    return t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Pe, Te) {
      return Pe.__proto__ = Te, Pe;
    }, t(pe, Ie);
  }
  function l(pe) {
    var Ie = k();
    return function() {
      var Pe = C(pe), Te;
      if (Ie) {
        var Qe = C(this).constructor;
        Te = Reflect.construct(Pe, arguments, Qe);
      } else
        Te = Pe.apply(this, arguments);
      return m(this, Te);
    };
  }
  function m(pe, Ie) {
    if (Ie && (s(Ie) === "object" || typeof Ie == "function"))
      return Ie;
    if (Ie !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return b(pe);
  }
  function b(pe) {
    if (pe === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return pe;
  }
  function k() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function C(pe) {
    return C = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(be) {
      return be.__proto__ || Object.getPrototypeOf(be);
    }, C(pe);
  }
  var B = {}, Q, P;
  function x(pe, Ie, be) {
    be || (be = Error);
    function Pe(Qe, xe, Ee) {
      return typeof Ie == "string" ? Ie : Ie(Qe, xe, Ee);
    }
    var Te = /* @__PURE__ */ function(Qe) {
      p(Ee, Qe);
      var xe = l(Ee);
      function Ee(He, ve, we) {
        var Ce;
        return u(this, Ee), Ce = xe.call(this, Pe(He, ve, we)), Ce.code = pe, Ce;
      }
      return A(Ee);
    }(be);
    B[pe] = Te;
  }
  function M(pe, Ie) {
    if (Array.isArray(pe)) {
      var be = pe.length;
      return pe = pe.map(function(Pe) {
        return String(Pe);
      }), be > 2 ? "one of ".concat(Ie, " ").concat(pe.slice(0, be - 1).join(", "), ", or ") + pe[be - 1] : be === 2 ? "one of ".concat(Ie, " ").concat(pe[0], " or ").concat(pe[1]) : "of ".concat(Ie, " ").concat(pe[0]);
    } else
      return "of ".concat(Ie, " ").concat(String(pe));
  }
  function F(pe, Ie, be) {
    return pe.substr(0, Ie.length) === Ie;
  }
  function le(pe, Ie, be) {
    return (be === void 0 || be > pe.length) && (be = pe.length), pe.substring(be - Ie.length, be) === Ie;
  }
  function ge(pe, Ie, be) {
    return typeof be != "number" && (be = 0), be + Ie.length > pe.length ? !1 : pe.indexOf(Ie, be) !== -1;
  }
  return x("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError), x("ERR_INVALID_ARG_TYPE", function(pe, Ie, be) {
    Q === void 0 && (Q = requireAssert$2()), Q(typeof pe == "string", "'name' must be a string");
    var Pe;
    typeof Ie == "string" && F(Ie, "not ") ? (Pe = "must not be", Ie = Ie.replace(/^not /, "")) : Pe = "must be";
    var Te;
    if (le(pe, " argument"))
      Te = "The ".concat(pe, " ").concat(Pe, " ").concat(M(Ie, "type"));
    else {
      var Qe = ge(pe, ".") ? "property" : "argument";
      Te = 'The "'.concat(pe, '" ').concat(Qe, " ").concat(Pe, " ").concat(M(Ie, "type"));
    }
    return Te += ". Received type ".concat(s(be)), Te;
  }, TypeError), x("ERR_INVALID_ARG_VALUE", function(pe, Ie) {
    var be = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "is invalid";
    P === void 0 && (P = requireUtil$1());
    var Pe = P.inspect(Ie);
    return Pe.length > 128 && (Pe = "".concat(Pe.slice(0, 128), "...")), "The argument '".concat(pe, "' ").concat(be, ". Received ").concat(Pe);
  }, TypeError), x("ERR_INVALID_RETURN_VALUE", function(pe, Ie, be) {
    var Pe;
    return be && be.constructor && be.constructor.name ? Pe = "instance of ".concat(be.constructor.name) : Pe = "type ".concat(s(be)), "Expected ".concat(pe, ' to be returned from the "').concat(Ie, '"') + " function but got ".concat(Pe, ".");
  }, TypeError), x("ERR_MISSING_ARGS", function() {
    for (var pe = arguments.length, Ie = new Array(pe), be = 0; be < pe; be++)
      Ie[be] = arguments[be];
    Q === void 0 && (Q = requireAssert$2()), Q(Ie.length > 0, "At least one arg needs to be specified");
    var Pe = "The ", Te = Ie.length;
    switch (Ie = Ie.map(function(Qe) {
      return '"'.concat(Qe, '"');
    }), Te) {
      case 1:
        Pe += "".concat(Ie[0], " argument");
        break;
      case 2:
        Pe += "".concat(Ie[0], " and ").concat(Ie[1], " arguments");
        break;
      default:
        Pe += Ie.slice(0, Te - 1).join(", "), Pe += ", and ".concat(Ie[Te - 1], " arguments");
        break;
    }
    return "".concat(Pe, " must be specified");
  }, TypeError), errors$3.codes = B, errors$3;
}
var assertion_error, hasRequiredAssertion_error;
function requireAssertion_error() {
  if (hasRequiredAssertion_error) return assertion_error;
  hasRequiredAssertion_error = 1;
  function s(sr, nr) {
    var fr = Object.keys(sr);
    if (Object.getOwnPropertySymbols) {
      var lr = Object.getOwnPropertySymbols(sr);
      nr && (lr = lr.filter(function(br) {
        return Object.getOwnPropertyDescriptor(sr, br).enumerable;
      })), fr.push.apply(fr, lr);
    }
    return fr;
  }
  function A(sr) {
    for (var nr = 1; nr < arguments.length; nr++) {
      var fr = arguments[nr] != null ? arguments[nr] : {};
      nr % 2 ? s(Object(fr), !0).forEach(function(lr) {
        u(sr, lr, fr[lr]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(sr, Object.getOwnPropertyDescriptors(fr)) : s(Object(fr)).forEach(function(lr) {
        Object.defineProperty(sr, lr, Object.getOwnPropertyDescriptor(fr, lr));
      });
    }
    return sr;
  }
  function u(sr, nr, fr) {
    return nr = m(nr), nr in sr ? Object.defineProperty(sr, nr, { value: fr, enumerable: !0, configurable: !0, writable: !0 }) : sr[nr] = fr, sr;
  }
  function p(sr, nr) {
    if (!(sr instanceof nr))
      throw new TypeError("Cannot call a class as a function");
  }
  function t(sr, nr) {
    for (var fr = 0; fr < nr.length; fr++) {
      var lr = nr[fr];
      lr.enumerable = lr.enumerable || !1, lr.configurable = !0, "value" in lr && (lr.writable = !0), Object.defineProperty(sr, m(lr.key), lr);
    }
  }
  function l(sr, nr, fr) {
    return nr && t(sr.prototype, nr), Object.defineProperty(sr, "prototype", { writable: !1 }), sr;
  }
  function m(sr) {
    var nr = b(sr, "string");
    return pe(nr) === "symbol" ? nr : String(nr);
  }
  function b(sr, nr) {
    if (pe(sr) !== "object" || sr === null) return sr;
    var fr = sr[Symbol.toPrimitive];
    if (fr !== void 0) {
      var lr = fr.call(sr, nr);
      if (pe(lr) !== "object") return lr;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(sr);
  }
  function k(sr, nr) {
    if (typeof nr != "function" && nr !== null)
      throw new TypeError("Super expression must either be null or a function");
    sr.prototype = Object.create(nr && nr.prototype, { constructor: { value: sr, writable: !0, configurable: !0 } }), Object.defineProperty(sr, "prototype", { writable: !1 }), nr && le(sr, nr);
  }
  function C(sr) {
    var nr = M();
    return function() {
      var lr = ge(sr), br;
      if (nr) {
        var Br = ge(this).constructor;
        br = Reflect.construct(lr, arguments, Br);
      } else
        br = lr.apply(this, arguments);
      return B(this, br);
    };
  }
  function B(sr, nr) {
    if (nr && (pe(nr) === "object" || typeof nr == "function"))
      return nr;
    if (nr !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return Q(sr);
  }
  function Q(sr) {
    if (sr === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return sr;
  }
  function P(sr) {
    var nr = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
    return P = function(lr) {
      if (lr === null || !F(lr)) return lr;
      if (typeof lr != "function")
        throw new TypeError("Super expression must either be null or a function");
      if (typeof nr < "u") {
        if (nr.has(lr)) return nr.get(lr);
        nr.set(lr, br);
      }
      function br() {
        return x(lr, arguments, ge(this).constructor);
      }
      return br.prototype = Object.create(lr.prototype, { constructor: { value: br, enumerable: !1, writable: !0, configurable: !0 } }), le(br, lr);
    }, P(sr);
  }
  function x(sr, nr, fr) {
    return M() ? x = Reflect.construct.bind() : x = function(br, Br, Fr) {
      var Gr = [null];
      Gr.push.apply(Gr, Br);
      var qr = Function.bind.apply(br, Gr), Hr = new qr();
      return Fr && le(Hr, Fr.prototype), Hr;
    }, x.apply(null, arguments);
  }
  function M() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function F(sr) {
    return Function.toString.call(sr).indexOf("[native code]") !== -1;
  }
  function le(sr, nr) {
    return le = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(lr, br) {
      return lr.__proto__ = br, lr;
    }, le(sr, nr);
  }
  function ge(sr) {
    return ge = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(fr) {
      return fr.__proto__ || Object.getPrototypeOf(fr);
    }, ge(sr);
  }
  function pe(sr) {
    "@babel/helpers - typeof";
    return pe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(nr) {
      return typeof nr;
    } : function(nr) {
      return nr && typeof Symbol == "function" && nr.constructor === Symbol && nr !== Symbol.prototype ? "symbol" : typeof nr;
    }, pe(sr);
  }
  var Ie = requireUtil$1(), be = Ie.inspect, Pe = requireErrors$3(), Te = Pe.codes.ERR_INVALID_ARG_TYPE;
  function Qe(sr, nr, fr) {
    return (fr === void 0 || fr > sr.length) && (fr = sr.length), sr.substring(fr - nr.length, fr) === nr;
  }
  function xe(sr, nr) {
    if (nr = Math.floor(nr), sr.length == 0 || nr == 0) return "";
    var fr = sr.length * nr;
    for (nr = Math.floor(Math.log(nr) / Math.log(2)); nr; )
      sr += sr, nr--;
    return sr += sr.substring(0, fr - sr.length), sr;
  }
  var Ee = "", He = "", ve = "", we = "", Ce = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
  }, Se = 10;
  function Ne(sr) {
    var nr = Object.keys(sr), fr = Object.create(Object.getPrototypeOf(sr));
    return nr.forEach(function(lr) {
      fr[lr] = sr[lr];
    }), Object.defineProperty(fr, "message", {
      value: sr.message
    }), fr;
  }
  function rr(sr) {
    return be(sr, {
      compact: !1,
      customInspect: !1,
      depth: 1e3,
      maxArrayLength: 1 / 0,
      // Assert compares only enumerable properties (with a few exceptions).
      showHidden: !1,
      // Having a long line as error is better than wrapping the line for
      // comparison for now.
      // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
      // have meta information about the inspected properties (i.e., know where
      // in what line the property starts and ends).
      breakLength: 1 / 0,
      // Assert does not detect proxies currently.
      showProxy: !1,
      sorted: !0,
      // Inspect getters as we also check them when comparing entries.
      getters: !0
    });
  }
  function er(sr, nr, fr) {
    var lr = "", br = "", Br = 0, Fr = "", Gr = !1, qr = rr(sr), Hr = qr.split(`
`), un = rr(nr).split(`
`), Dr = 0, wr = "";
    if (fr === "strictEqual" && pe(sr) === "object" && pe(nr) === "object" && sr !== null && nr !== null && (fr = "strictEqualObject"), Hr.length === 1 && un.length === 1 && Hr[0] !== un[0]) {
      var yr = Hr[0].length + un[0].length;
      if (yr <= Se) {
        if ((pe(sr) !== "object" || sr === null) && (pe(nr) !== "object" || nr === null) && (sr !== 0 || nr !== 0))
          return "".concat(Ce[fr], `

`) + "".concat(Hr[0], " !== ").concat(un[0], `
`);
      } else if (fr !== "strictEqualObject") {
        var Qr = process$1.stderr && process$1.stderr.isTTY ? process$1.stderr.columns : 80;
        if (yr < Qr) {
          for (; Hr[0][Dr] === un[0][Dr]; )
            Dr++;
          Dr > 2 && (wr = `
  `.concat(xe(" ", Dr), "^"), Dr = 0);
        }
      }
    }
    for (var _r = Hr[Hr.length - 1], Jr = un[un.length - 1]; _r === Jr && (Dr++ < 2 ? Fr = `
  `.concat(_r).concat(Fr) : lr = _r, Hr.pop(), un.pop(), !(Hr.length === 0 || un.length === 0)); )
      _r = Hr[Hr.length - 1], Jr = un[un.length - 1];
    var fn = Math.max(Hr.length, un.length);
    if (fn === 0) {
      var jr = qr.split(`
`);
      if (jr.length > 30)
        for (jr[26] = "".concat(Ee, "...").concat(we); jr.length > 27; )
          jr.pop();
      return "".concat(Ce.notIdentical, `

`).concat(jr.join(`
`), `
`);
    }
    Dr > 3 && (Fr = `
`.concat(Ee, "...").concat(we).concat(Fr), Gr = !0), lr !== "" && (Fr = `
  `.concat(lr).concat(Fr), lr = "");
    var dn = 0, Tn = Ce[fr] + `
`.concat(He, "+ actual").concat(we, " ").concat(ve, "- expected").concat(we), Yn = " ".concat(Ee, "...").concat(we, " Lines skipped");
    for (Dr = 0; Dr < fn; Dr++) {
      var si = Dr - Br;
      if (Hr.length < Dr + 1)
        si > 1 && Dr > 2 && (si > 4 ? (br += `
`.concat(Ee, "...").concat(we), Gr = !0) : si > 3 && (br += `
  `.concat(un[Dr - 2]), dn++), br += `
  `.concat(un[Dr - 1]), dn++), Br = Dr, lr += `
`.concat(ve, "-").concat(we, " ").concat(un[Dr]), dn++;
      else if (un.length < Dr + 1)
        si > 1 && Dr > 2 && (si > 4 ? (br += `
`.concat(Ee, "...").concat(we), Gr = !0) : si > 3 && (br += `
  `.concat(Hr[Dr - 2]), dn++), br += `
  `.concat(Hr[Dr - 1]), dn++), Br = Dr, br += `
`.concat(He, "+").concat(we, " ").concat(Hr[Dr]), dn++;
      else {
        var vn = un[Dr], Cn = Hr[Dr], Xr = Cn !== vn && (!Qe(Cn, ",") || Cn.slice(0, -1) !== vn);
        Xr && Qe(vn, ",") && vn.slice(0, -1) === Cn && (Xr = !1, Cn += ","), Xr ? (si > 1 && Dr > 2 && (si > 4 ? (br += `
`.concat(Ee, "...").concat(we), Gr = !0) : si > 3 && (br += `
  `.concat(Hr[Dr - 2]), dn++), br += `
  `.concat(Hr[Dr - 1]), dn++), Br = Dr, br += `
`.concat(He, "+").concat(we, " ").concat(Cn), lr += `
`.concat(ve, "-").concat(we, " ").concat(vn), dn += 2) : (br += lr, lr = "", (si === 1 || Dr === 0) && (br += `
  `.concat(Cn), dn++));
      }
      if (dn > 20 && Dr < fn - 2)
        return "".concat(Tn).concat(Yn, `
`).concat(br, `
`).concat(Ee, "...").concat(we).concat(lr, `
`) + "".concat(Ee, "...").concat(we);
    }
    return "".concat(Tn).concat(Gr ? Yn : "", `
`).concat(br).concat(lr).concat(Fr).concat(wr);
  }
  var ir = /* @__PURE__ */ function(sr, nr) {
    k(lr, sr);
    var fr = C(lr);
    function lr(br) {
      var Br;
      if (p(this, lr), pe(br) !== "object" || br === null)
        throw new Te("options", "Object", br);
      var Fr = br.message, Gr = br.operator, qr = br.stackStartFn, Hr = br.actual, un = br.expected, Dr = Error.stackTraceLimit;
      if (Error.stackTraceLimit = 0, Fr != null)
        Br = fr.call(this, String(Fr));
      else if (process$1.stderr && process$1.stderr.isTTY && (process$1.stderr && process$1.stderr.getColorDepth && process$1.stderr.getColorDepth() !== 1 ? (Ee = "\x1B[34m", He = "\x1B[32m", we = "\x1B[39m", ve = "\x1B[31m") : (Ee = "", He = "", we = "", ve = "")), pe(Hr) === "object" && Hr !== null && pe(un) === "object" && un !== null && "stack" in Hr && Hr instanceof Error && "stack" in un && un instanceof Error && (Hr = Ne(Hr), un = Ne(un)), Gr === "deepStrictEqual" || Gr === "strictEqual")
        Br = fr.call(this, er(Hr, un, Gr));
      else if (Gr === "notDeepStrictEqual" || Gr === "notStrictEqual") {
        var wr = Ce[Gr], yr = rr(Hr).split(`
`);
        if (Gr === "notStrictEqual" && pe(Hr) === "object" && Hr !== null && (wr = Ce.notStrictEqualObject), yr.length > 30)
          for (yr[26] = "".concat(Ee, "...").concat(we); yr.length > 27; )
            yr.pop();
        yr.length === 1 ? Br = fr.call(this, "".concat(wr, " ").concat(yr[0])) : Br = fr.call(this, "".concat(wr, `

`).concat(yr.join(`
`), `
`));
      } else {
        var Qr = rr(Hr), _r = "", Jr = Ce[Gr];
        Gr === "notDeepEqual" || Gr === "notEqual" ? (Qr = "".concat(Ce[Gr], `

`).concat(Qr), Qr.length > 1024 && (Qr = "".concat(Qr.slice(0, 1021), "..."))) : (_r = "".concat(rr(un)), Qr.length > 512 && (Qr = "".concat(Qr.slice(0, 509), "...")), _r.length > 512 && (_r = "".concat(_r.slice(0, 509), "...")), Gr === "deepEqual" || Gr === "equal" ? Qr = "".concat(Jr, `

`).concat(Qr, `

should equal

`) : _r = " ".concat(Gr, " ").concat(_r)), Br = fr.call(this, "".concat(Qr).concat(_r));
      }
      return Error.stackTraceLimit = Dr, Br.generatedMessage = !Fr, Object.defineProperty(Q(Br), "name", {
        value: "AssertionError [ERR_ASSERTION]",
        enumerable: !1,
        writable: !0,
        configurable: !0
      }), Br.code = "ERR_ASSERTION", Br.actual = Hr, Br.expected = un, Br.operator = Gr, Error.captureStackTrace && Error.captureStackTrace(Q(Br), qr), Br.stack, Br.name = "AssertionError", B(Br);
    }
    return l(lr, [{
      key: "toString",
      value: function() {
        return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
      }
    }, {
      key: nr,
      value: function(Br, Fr) {
        return be(this, A(A({}, Fr), {}, {
          customInspect: !1,
          depth: 0
        }));
      }
    }]), lr;
  }(/* @__PURE__ */ P(Error), be.custom);
  return assertion_error = ir, assertion_error;
}
var isArguments, hasRequiredIsArguments;
function requireIsArguments() {
  if (hasRequiredIsArguments) return isArguments;
  hasRequiredIsArguments = 1;
  var s = Object.prototype.toString;
  return isArguments = function(u) {
    var p = s.call(u), t = p === "[object Arguments]";
    return t || (t = p !== "[object Array]" && u !== null && typeof u == "object" && typeof u.length == "number" && u.length >= 0 && s.call(u.callee) === "[object Function]"), t;
  }, isArguments;
}
var implementation$3, hasRequiredImplementation$3;
function requireImplementation$3() {
  if (hasRequiredImplementation$3) return implementation$3;
  hasRequiredImplementation$3 = 1;
  var s;
  if (!Object.keys) {
    var A = Object.prototype.hasOwnProperty, u = Object.prototype.toString, p = requireIsArguments(), t = Object.prototype.propertyIsEnumerable, l = !t.call({ toString: null }, "toString"), m = t.call(function() {
    }, "prototype"), b = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ], k = function(P) {
      var x = P.constructor;
      return x && x.prototype === P;
    }, C = {
      $applicationCache: !0,
      $console: !0,
      $external: !0,
      $frame: !0,
      $frameElement: !0,
      $frames: !0,
      $innerHeight: !0,
      $innerWidth: !0,
      $onmozfullscreenchange: !0,
      $onmozfullscreenerror: !0,
      $outerHeight: !0,
      $outerWidth: !0,
      $pageXOffset: !0,
      $pageYOffset: !0,
      $parent: !0,
      $scrollLeft: !0,
      $scrollTop: !0,
      $scrollX: !0,
      $scrollY: !0,
      $self: !0,
      $webkitIndexedDB: !0,
      $webkitStorageInfo: !0,
      $window: !0
    }, B = function() {
      if (typeof window > "u")
        return !1;
      for (var P in window)
        try {
          if (!C["$" + P] && A.call(window, P) && window[P] !== null && typeof window[P] == "object")
            try {
              k(window[P]);
            } catch {
              return !0;
            }
        } catch {
          return !0;
        }
      return !1;
    }(), Q = function(P) {
      if (typeof window > "u" || !B)
        return k(P);
      try {
        return k(P);
      } catch {
        return !1;
      }
    };
    s = function(x) {
      var M = x !== null && typeof x == "object", F = u.call(x) === "[object Function]", le = p(x), ge = M && u.call(x) === "[object String]", pe = [];
      if (!M && !F && !le)
        throw new TypeError("Object.keys called on a non-object");
      var Ie = m && F;
      if (ge && x.length > 0 && !A.call(x, 0))
        for (var be = 0; be < x.length; ++be)
          pe.push(String(be));
      if (le && x.length > 0)
        for (var Pe = 0; Pe < x.length; ++Pe)
          pe.push(String(Pe));
      else
        for (var Te in x)
          !(Ie && Te === "prototype") && A.call(x, Te) && pe.push(String(Te));
      if (l)
        for (var Qe = Q(x), xe = 0; xe < b.length; ++xe)
          !(Qe && b[xe] === "constructor") && A.call(x, b[xe]) && pe.push(b[xe]);
      return pe;
    };
  }
  return implementation$3 = s, implementation$3;
}
var objectKeys, hasRequiredObjectKeys;
function requireObjectKeys() {
  if (hasRequiredObjectKeys) return objectKeys;
  hasRequiredObjectKeys = 1;
  var s = Array.prototype.slice, A = requireIsArguments(), u = Object.keys, p = u ? function(m) {
    return u(m);
  } : requireImplementation$3(), t = Object.keys;
  return p.shim = function() {
    if (Object.keys) {
      var m = function() {
        var b = Object.keys(arguments);
        return b && b.length === arguments.length;
      }(1, 2);
      m || (Object.keys = function(k) {
        return A(k) ? t(s.call(k)) : t(k);
      });
    } else
      Object.keys = p;
    return Object.keys || p;
  }, objectKeys = p, objectKeys;
}
var implementation$2, hasRequiredImplementation$2;
function requireImplementation$2() {
  if (hasRequiredImplementation$2) return implementation$2;
  hasRequiredImplementation$2 = 1;
  var s = requireObjectKeys(), A = requireShams$1()(), u = /* @__PURE__ */ requireCallBound$1(), p = /* @__PURE__ */ requireEsObjectAtoms(), t = u("Array.prototype.push"), l = u("Object.prototype.propertyIsEnumerable"), m = A ? p.getOwnPropertySymbols : null;
  return implementation$2 = function(k, C) {
    if (k == null)
      throw new TypeError("target must be an object");
    var B = p(k);
    if (arguments.length === 1)
      return B;
    for (var Q = 1; Q < arguments.length; ++Q) {
      var P = p(arguments[Q]), x = s(P), M = A && (p.getOwnPropertySymbols || m);
      if (M)
        for (var F = M(P), le = 0; le < F.length; ++le) {
          var ge = F[le];
          l(P, ge) && t(x, ge);
        }
      for (var pe = 0; pe < x.length; ++pe) {
        var Ie = x[pe];
        if (l(P, Ie)) {
          var be = P[Ie];
          B[Ie] = be;
        }
      }
    }
    return B;
  }, implementation$2;
}
var polyfill$2, hasRequiredPolyfill$2;
function requirePolyfill$2() {
  if (hasRequiredPolyfill$2) return polyfill$2;
  hasRequiredPolyfill$2 = 1;
  var s = requireImplementation$2(), A = function() {
    if (!Object.assign)
      return !1;
    for (var p = "abcdefghijklmnopqrst", t = p.split(""), l = {}, m = 0; m < t.length; ++m)
      l[t[m]] = t[m];
    var b = Object.assign({}, l), k = "";
    for (var C in b)
      k += C;
    return p !== k;
  }, u = function() {
    if (!Object.assign || !Object.preventExtensions)
      return !1;
    var p = Object.preventExtensions({ 1: 2 });
    try {
      Object.assign(p, "xy");
    } catch {
      return p[1] === "y";
    }
    return !1;
  };
  return polyfill$2 = function() {
    return !Object.assign || A() || u() ? s : Object.assign;
  }, polyfill$2;
}
var implementation$1, hasRequiredImplementation$1;
function requireImplementation$1() {
  if (hasRequiredImplementation$1) return implementation$1;
  hasRequiredImplementation$1 = 1;
  var s = function(A) {
    return A !== A;
  };
  return implementation$1 = function(u, p) {
    return u === 0 && p === 0 ? 1 / u === 1 / p : !!(u === p || s(u) && s(p));
  }, implementation$1;
}
var polyfill$1, hasRequiredPolyfill$1;
function requirePolyfill$1() {
  if (hasRequiredPolyfill$1) return polyfill$1;
  hasRequiredPolyfill$1 = 1;
  var s = requireImplementation$1();
  return polyfill$1 = function() {
    return typeof Object.is == "function" ? Object.is : s;
  }, polyfill$1;
}
var callBound, hasRequiredCallBound;
function requireCallBound() {
  if (hasRequiredCallBound) return callBound;
  hasRequiredCallBound = 1;
  var s = /* @__PURE__ */ requireGetIntrinsic(), A = requireCallBind(), u = A(s("String.prototype.indexOf"));
  return callBound = function(t, l) {
    var m = s(t, !!l);
    return typeof m == "function" && u(t, ".prototype.") > -1 ? A(m) : m;
  }, callBound;
}
var defineProperties_1, hasRequiredDefineProperties;
function requireDefineProperties() {
  if (hasRequiredDefineProperties) return defineProperties_1;
  hasRequiredDefineProperties = 1;
  var s = requireObjectKeys(), A = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", u = Object.prototype.toString, p = Array.prototype.concat, t = /* @__PURE__ */ requireDefineDataProperty(), l = function(C) {
    return typeof C == "function" && u.call(C) === "[object Function]";
  }, m = /* @__PURE__ */ requireHasPropertyDescriptors()(), b = function(C, B, Q, P) {
    if (B in C) {
      if (P === !0) {
        if (C[B] === Q)
          return;
      } else if (!l(P) || !P())
        return;
    }
    m ? t(C, B, Q, !0) : t(C, B, Q);
  }, k = function(C, B) {
    var Q = arguments.length > 2 ? arguments[2] : {}, P = s(B);
    A && (P = p.call(P, Object.getOwnPropertySymbols(B)));
    for (var x = 0; x < P.length; x += 1)
      b(C, P[x], B[P[x]], Q[P[x]]);
  };
  return k.supportsDescriptors = !!m, defineProperties_1 = k, defineProperties_1;
}
var shim$1, hasRequiredShim$1;
function requireShim$1() {
  if (hasRequiredShim$1) return shim$1;
  hasRequiredShim$1 = 1;
  var s = requirePolyfill$1(), A = requireDefineProperties();
  return shim$1 = function() {
    var p = s();
    return A(Object, { is: p }, {
      is: function() {
        return Object.is !== p;
      }
    }), p;
  }, shim$1;
}
var objectIs, hasRequiredObjectIs;
function requireObjectIs() {
  if (hasRequiredObjectIs) return objectIs;
  hasRequiredObjectIs = 1;
  var s = requireDefineProperties(), A = requireCallBind(), u = requireImplementation$1(), p = requirePolyfill$1(), t = requireShim$1(), l = A(p(), Object);
  return s(l, {
    getPolyfill: p,
    implementation: u,
    shim: t
  }), objectIs = l, objectIs;
}
var implementation, hasRequiredImplementation;
function requireImplementation() {
  return hasRequiredImplementation || (hasRequiredImplementation = 1, implementation = function(A) {
    return A !== A;
  }), implementation;
}
var polyfill, hasRequiredPolyfill;
function requirePolyfill() {
  if (hasRequiredPolyfill) return polyfill;
  hasRequiredPolyfill = 1;
  var s = requireImplementation();
  return polyfill = function() {
    return Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a") ? Number.isNaN : s;
  }, polyfill;
}
var shim, hasRequiredShim;
function requireShim() {
  if (hasRequiredShim) return shim;
  hasRequiredShim = 1;
  var s = requireDefineProperties(), A = requirePolyfill();
  return shim = function() {
    var p = A();
    return s(Number, { isNaN: p }, {
      isNaN: function() {
        return Number.isNaN !== p;
      }
    }), p;
  }, shim;
}
var isNan, hasRequiredIsNan;
function requireIsNan() {
  if (hasRequiredIsNan) return isNan;
  hasRequiredIsNan = 1;
  var s = requireCallBind(), A = requireDefineProperties(), u = requireImplementation(), p = requirePolyfill(), t = requireShim(), l = s(p(), Number);
  return A(l, {
    getPolyfill: p,
    implementation: u,
    shim: t
  }), isNan = l, isNan;
}
var comparisons, hasRequiredComparisons;
function requireComparisons() {
  if (hasRequiredComparisons) return comparisons;
  hasRequiredComparisons = 1;
  function s(Xr, In) {
    return l(Xr) || t(Xr, In) || u(Xr, In) || A();
  }
  function A() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function u(Xr, In) {
    if (Xr) {
      if (typeof Xr == "string") return p(Xr, In);
      var zr = Object.prototype.toString.call(Xr).slice(8, -1);
      if (zr === "Object" && Xr.constructor && (zr = Xr.constructor.name), zr === "Map" || zr === "Set") return Array.from(Xr);
      if (zr === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(zr)) return p(Xr, In);
    }
  }
  function p(Xr, In) {
    (In == null || In > Xr.length) && (In = Xr.length);
    for (var zr = 0, En = new Array(In); zr < In; zr++) En[zr] = Xr[zr];
    return En;
  }
  function t(Xr, In) {
    var zr = Xr == null ? null : typeof Symbol < "u" && Xr[Symbol.iterator] || Xr["@@iterator"];
    if (zr != null) {
      var En, Zr, kr, Rr, Er = [], Or = !0, wn = !1;
      try {
        if (kr = (zr = zr.call(Xr)).next, In !== 0) for (; !(Or = (En = kr.call(zr)).done) && (Er.push(En.value), Er.length !== In); Or = !0) ;
      } catch (Kn) {
        wn = !0, Zr = Kn;
      } finally {
        try {
          if (!Or && zr.return != null && (Rr = zr.return(), Object(Rr) !== Rr)) return;
        } finally {
          if (wn) throw Zr;
        }
      }
      return Er;
    }
  }
  function l(Xr) {
    if (Array.isArray(Xr)) return Xr;
  }
  function m(Xr) {
    "@babel/helpers - typeof";
    return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(In) {
      return typeof In;
    } : function(In) {
      return In && typeof Symbol == "function" && In.constructor === Symbol && In !== Symbol.prototype ? "symbol" : typeof In;
    }, m(Xr);
  }
  var b = /a/g.flags !== void 0, k = function(In) {
    var zr = [];
    return In.forEach(function(En) {
      return zr.push(En);
    }), zr;
  }, C = function(In) {
    var zr = [];
    return In.forEach(function(En, Zr) {
      return zr.push([Zr, En]);
    }), zr;
  }, B = Object.is ? Object.is : requireObjectIs(), Q = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
  }, P = Number.isNaN ? Number.isNaN : requireIsNan();
  function x(Xr) {
    return Xr.call.bind(Xr);
  }
  var M = x(Object.prototype.hasOwnProperty), F = x(Object.prototype.propertyIsEnumerable), le = x(Object.prototype.toString), ge = requireUtil$1().types, pe = ge.isAnyArrayBuffer, Ie = ge.isArrayBufferView, be = ge.isDate, Pe = ge.isMap, Te = ge.isRegExp, Qe = ge.isSet, xe = ge.isNativeError, Ee = ge.isBoxedPrimitive, He = ge.isNumberObject, ve = ge.isStringObject, we = ge.isBooleanObject, Ce = ge.isBigIntObject, Se = ge.isSymbolObject, Ne = ge.isFloat32Array, rr = ge.isFloat64Array;
  function er(Xr) {
    if (Xr.length === 0 || Xr.length > 10) return !0;
    for (var In = 0; In < Xr.length; In++) {
      var zr = Xr.charCodeAt(In);
      if (zr < 48 || zr > 57) return !0;
    }
    return Xr.length === 10 && Xr >= Math.pow(2, 32);
  }
  function ir(Xr) {
    return Object.keys(Xr).filter(er).concat(Q(Xr).filter(Object.prototype.propertyIsEnumerable.bind(Xr)));
  }
  function sr(Xr, In) {
    if (Xr === In)
      return 0;
    for (var zr = Xr.length, En = In.length, Zr = 0, kr = Math.min(zr, En); Zr < kr; ++Zr)
      if (Xr[Zr] !== In[Zr]) {
        zr = Xr[Zr], En = In[Zr];
        break;
      }
    return zr < En ? -1 : En < zr ? 1 : 0;
  }
  var nr = !0, fr = !1, lr = 0, br = 1, Br = 2, Fr = 3;
  function Gr(Xr, In) {
    return b ? Xr.source === In.source && Xr.flags === In.flags : RegExp.prototype.toString.call(Xr) === RegExp.prototype.toString.call(In);
  }
  function qr(Xr, In) {
    if (Xr.byteLength !== In.byteLength)
      return !1;
    for (var zr = 0; zr < Xr.byteLength; zr++)
      if (Xr[zr] !== In[zr])
        return !1;
    return !0;
  }
  function Hr(Xr, In) {
    return Xr.byteLength !== In.byteLength ? !1 : sr(new Uint8Array(Xr.buffer, Xr.byteOffset, Xr.byteLength), new Uint8Array(In.buffer, In.byteOffset, In.byteLength)) === 0;
  }
  function un(Xr, In) {
    return Xr.byteLength === In.byteLength && sr(new Uint8Array(Xr), new Uint8Array(In)) === 0;
  }
  function Dr(Xr, In) {
    return He(Xr) ? He(In) && B(Number.prototype.valueOf.call(Xr), Number.prototype.valueOf.call(In)) : ve(Xr) ? ve(In) && String.prototype.valueOf.call(Xr) === String.prototype.valueOf.call(In) : we(Xr) ? we(In) && Boolean.prototype.valueOf.call(Xr) === Boolean.prototype.valueOf.call(In) : Ce(Xr) ? Ce(In) && BigInt.prototype.valueOf.call(Xr) === BigInt.prototype.valueOf.call(In) : Se(In) && Symbol.prototype.valueOf.call(Xr) === Symbol.prototype.valueOf.call(In);
  }
  function wr(Xr, In, zr, En) {
    if (Xr === In)
      return Xr !== 0 ? !0 : zr ? B(Xr, In) : !0;
    if (zr) {
      if (m(Xr) !== "object")
        return typeof Xr == "number" && P(Xr) && P(In);
      if (m(In) !== "object" || Xr === null || In === null || Object.getPrototypeOf(Xr) !== Object.getPrototypeOf(In))
        return !1;
    } else {
      if (Xr === null || m(Xr) !== "object")
        return In === null || m(In) !== "object" ? Xr == In : !1;
      if (In === null || m(In) !== "object")
        return !1;
    }
    var Zr = le(Xr), kr = le(In);
    if (Zr !== kr)
      return !1;
    if (Array.isArray(Xr)) {
      if (Xr.length !== In.length)
        return !1;
      var Rr = ir(Xr), Er = ir(In);
      return Rr.length !== Er.length ? !1 : Qr(Xr, In, zr, En, br, Rr);
    }
    if (Zr === "[object Object]" && (!Pe(Xr) && Pe(In) || !Qe(Xr) && Qe(In)))
      return !1;
    if (be(Xr)) {
      if (!be(In) || Date.prototype.getTime.call(Xr) !== Date.prototype.getTime.call(In))
        return !1;
    } else if (Te(Xr)) {
      if (!Te(In) || !Gr(Xr, In))
        return !1;
    } else if (xe(Xr) || Xr instanceof Error) {
      if (Xr.message !== In.message || Xr.name !== In.name)
        return !1;
    } else if (Ie(Xr)) {
      if (!zr && (Ne(Xr) || rr(Xr))) {
        if (!qr(Xr, In))
          return !1;
      } else if (!Hr(Xr, In))
        return !1;
      var Or = ir(Xr), wn = ir(In);
      return Or.length !== wn.length ? !1 : Qr(Xr, In, zr, En, lr, Or);
    } else {
      if (Qe(Xr))
        return !Qe(In) || Xr.size !== In.size ? !1 : Qr(Xr, In, zr, En, Br);
      if (Pe(Xr))
        return !Pe(In) || Xr.size !== In.size ? !1 : Qr(Xr, In, zr, En, Fr);
      if (pe(Xr)) {
        if (!un(Xr, In))
          return !1;
      } else if (Ee(Xr) && !Dr(Xr, In))
        return !1;
    }
    return Qr(Xr, In, zr, En, lr);
  }
  function yr(Xr, In) {
    return In.filter(function(zr) {
      return F(Xr, zr);
    });
  }
  function Qr(Xr, In, zr, En, Zr, kr) {
    if (arguments.length === 5) {
      kr = Object.keys(Xr);
      var Rr = Object.keys(In);
      if (kr.length !== Rr.length)
        return !1;
    }
    for (var Er = 0; Er < kr.length; Er++)
      if (!M(In, kr[Er]))
        return !1;
    if (zr && arguments.length === 5) {
      var Or = Q(Xr);
      if (Or.length !== 0) {
        var wn = 0;
        for (Er = 0; Er < Or.length; Er++) {
          var Kn = Or[Er];
          if (F(Xr, Kn)) {
            if (!F(In, Kn))
              return !1;
            kr.push(Kn), wn++;
          } else if (F(In, Kn))
            return !1;
        }
        var Ln = Q(In);
        if (Or.length !== Ln.length && yr(In, Ln).length !== wn)
          return !1;
      } else {
        var Wn = Q(In);
        if (Wn.length !== 0 && yr(In, Wn).length !== 0)
          return !1;
      }
    }
    if (kr.length === 0 && (Zr === lr || Zr === br && Xr.length === 0 || Xr.size === 0))
      return !0;
    if (En === void 0)
      En = {
        val1: /* @__PURE__ */ new Map(),
        val2: /* @__PURE__ */ new Map(),
        position: 0
      };
    else {
      var Sn = En.val1.get(Xr);
      if (Sn !== void 0) {
        var hi = En.val2.get(In);
        if (hi !== void 0)
          return Sn === hi;
      }
      En.position++;
    }
    En.val1.set(Xr, En.position), En.val2.set(In, En.position);
    var ki = si(Xr, In, zr, kr, En, Zr);
    return En.val1.delete(Xr), En.val2.delete(In), ki;
  }
  function _r(Xr, In, zr, En) {
    for (var Zr = k(Xr), kr = 0; kr < Zr.length; kr++) {
      var Rr = Zr[kr];
      if (wr(In, Rr, zr, En))
        return Xr.delete(Rr), !0;
    }
    return !1;
  }
  function Jr(Xr) {
    switch (m(Xr)) {
      case "undefined":
        return null;
      case "object":
        return;
      case "symbol":
        return !1;
      case "string":
        Xr = +Xr;
      // Loose equal entries exist only if the string is possible to convert to
      // a regular number and not NaN.
      // Fall through
      case "number":
        if (P(Xr))
          return !1;
    }
    return !0;
  }
  function fn(Xr, In, zr) {
    var En = Jr(zr);
    return En ?? (In.has(En) && !Xr.has(En));
  }
  function jr(Xr, In, zr, En, Zr) {
    var kr = Jr(zr);
    if (kr != null)
      return kr;
    var Rr = In.get(kr);
    return Rr === void 0 && !In.has(kr) || !wr(En, Rr, !1, Zr) ? !1 : !Xr.has(kr) && wr(En, Rr, !1, Zr);
  }
  function dn(Xr, In, zr, En) {
    for (var Zr = null, kr = k(Xr), Rr = 0; Rr < kr.length; Rr++) {
      var Er = kr[Rr];
      if (m(Er) === "object" && Er !== null)
        Zr === null && (Zr = /* @__PURE__ */ new Set()), Zr.add(Er);
      else if (!In.has(Er)) {
        if (zr || !fn(Xr, In, Er))
          return !1;
        Zr === null && (Zr = /* @__PURE__ */ new Set()), Zr.add(Er);
      }
    }
    if (Zr !== null) {
      for (var Or = k(In), wn = 0; wn < Or.length; wn++) {
        var Kn = Or[wn];
        if (m(Kn) === "object" && Kn !== null) {
          if (!_r(Zr, Kn, zr, En)) return !1;
        } else if (!zr && !Xr.has(Kn) && !_r(Zr, Kn, zr, En))
          return !1;
      }
      return Zr.size === 0;
    }
    return !0;
  }
  function Tn(Xr, In, zr, En, Zr, kr) {
    for (var Rr = k(Xr), Er = 0; Er < Rr.length; Er++) {
      var Or = Rr[Er];
      if (wr(zr, Or, Zr, kr) && wr(En, In.get(Or), Zr, kr))
        return Xr.delete(Or), !0;
    }
    return !1;
  }
  function Yn(Xr, In, zr, En) {
    for (var Zr = null, kr = C(Xr), Rr = 0; Rr < kr.length; Rr++) {
      var Er = s(kr[Rr], 2), Or = Er[0], wn = Er[1];
      if (m(Or) === "object" && Or !== null)
        Zr === null && (Zr = /* @__PURE__ */ new Set()), Zr.add(Or);
      else {
        var Kn = In.get(Or);
        if (Kn === void 0 && !In.has(Or) || !wr(wn, Kn, zr, En)) {
          if (zr || !jr(Xr, In, Or, wn, En)) return !1;
          Zr === null && (Zr = /* @__PURE__ */ new Set()), Zr.add(Or);
        }
      }
    }
    if (Zr !== null) {
      for (var Ln = C(In), Wn = 0; Wn < Ln.length; Wn++) {
        var Sn = s(Ln[Wn], 2), hi = Sn[0], ki = Sn[1];
        if (m(hi) === "object" && hi !== null) {
          if (!Tn(Zr, Xr, hi, ki, zr, En)) return !1;
        } else if (!zr && (!Xr.has(hi) || !wr(Xr.get(hi), ki, !1, En)) && !Tn(Zr, Xr, hi, ki, !1, En))
          return !1;
      }
      return Zr.size === 0;
    }
    return !0;
  }
  function si(Xr, In, zr, En, Zr, kr) {
    var Rr = 0;
    if (kr === Br) {
      if (!dn(Xr, In, zr, Zr))
        return !1;
    } else if (kr === Fr) {
      if (!Yn(Xr, In, zr, Zr))
        return !1;
    } else if (kr === br)
      for (; Rr < Xr.length; Rr++)
        if (M(Xr, Rr)) {
          if (!M(In, Rr) || !wr(Xr[Rr], In[Rr], zr, Zr))
            return !1;
        } else {
          if (M(In, Rr))
            return !1;
          for (var Er = Object.keys(Xr); Rr < Er.length; Rr++) {
            var Or = Er[Rr];
            if (!M(In, Or) || !wr(Xr[Or], In[Or], zr, Zr))
              return !1;
          }
          return Er.length === Object.keys(In).length;
        }
    for (Rr = 0; Rr < En.length; Rr++) {
      var wn = En[Rr];
      if (!wr(Xr[wn], In[wn], zr, Zr))
        return !1;
    }
    return !0;
  }
  function vn(Xr, In) {
    return wr(Xr, In, fr);
  }
  function Cn(Xr, In) {
    return wr(Xr, In, nr);
  }
  return comparisons = {
    isDeepEqual: vn,
    isDeepStrictEqual: Cn
  }, comparisons;
}
var hasRequiredAssert$2;
function requireAssert$2() {
  if (hasRequiredAssert$2) return assert$2.exports;
  hasRequiredAssert$2 = 1;
  function s(Br) {
    "@babel/helpers - typeof";
    return s = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Fr) {
      return typeof Fr;
    } : function(Fr) {
      return Fr && typeof Symbol == "function" && Fr.constructor === Symbol && Fr !== Symbol.prototype ? "symbol" : typeof Fr;
    }, s(Br);
  }
  function A(Br, Fr, Gr) {
    return Object.defineProperty(Br, "prototype", { writable: !1 }), Br;
  }
  function u(Br, Fr) {
    if (!(Br instanceof Fr))
      throw new TypeError("Cannot call a class as a function");
  }
  var p = requireErrors$3(), t = p.codes, l = t.ERR_AMBIGUOUS_ARGUMENT, m = t.ERR_INVALID_ARG_TYPE, b = t.ERR_INVALID_ARG_VALUE, k = t.ERR_INVALID_RETURN_VALUE, C = t.ERR_MISSING_ARGS, B = requireAssertion_error(), Q = requireUtil$1(), P = Q.inspect, x = requireUtil$1().types, M = x.isPromise, F = x.isRegExp, le = requirePolyfill$2()(), ge = requirePolyfill$1()(), pe = requireCallBound()("RegExp.prototype.test"), Ie, be;
  function Pe() {
    var Br = requireComparisons();
    Ie = Br.isDeepEqual, be = Br.isDeepStrictEqual;
  }
  var Te = !1, Qe = assert$2.exports = we, xe = {};
  function Ee(Br) {
    throw Br.message instanceof Error ? Br.message : new B(Br);
  }
  function He(Br, Fr, Gr, qr, Hr) {
    var un = arguments.length, Dr;
    if (un === 0)
      Dr = "Failed";
    else if (un === 1)
      Gr = Br, Br = void 0;
    else {
      if (Te === !1) {
        Te = !0;
        var wr = process$1.emitWarning ? process$1.emitWarning : console.warn.bind(console);
        wr("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
      }
      un === 2 && (qr = "!=");
    }
    if (Gr instanceof Error) throw Gr;
    var yr = {
      actual: Br,
      expected: Fr,
      operator: qr === void 0 ? "fail" : qr,
      stackStartFn: Hr || He
    };
    Gr !== void 0 && (yr.message = Gr);
    var Qr = new B(yr);
    throw Dr && (Qr.message = Dr, Qr.generatedMessage = !0), Qr;
  }
  Qe.fail = He, Qe.AssertionError = B;
  function ve(Br, Fr, Gr, qr) {
    if (!Gr) {
      var Hr = !1;
      if (Fr === 0)
        Hr = !0, qr = "No value argument passed to `assert.ok()`";
      else if (qr instanceof Error)
        throw qr;
      var un = new B({
        actual: Gr,
        expected: !0,
        message: qr,
        operator: "==",
        stackStartFn: Br
      });
      throw un.generatedMessage = Hr, un;
    }
  }
  function we() {
    for (var Br = arguments.length, Fr = new Array(Br), Gr = 0; Gr < Br; Gr++)
      Fr[Gr] = arguments[Gr];
    ve.apply(void 0, [we, Fr.length].concat(Fr));
  }
  Qe.ok = we, Qe.equal = function Br(Fr, Gr, qr) {
    if (arguments.length < 2)
      throw new C("actual", "expected");
    Fr != Gr && Ee({
      actual: Fr,
      expected: Gr,
      message: qr,
      operator: "==",
      stackStartFn: Br
    });
  }, Qe.notEqual = function Br(Fr, Gr, qr) {
    if (arguments.length < 2)
      throw new C("actual", "expected");
    Fr == Gr && Ee({
      actual: Fr,
      expected: Gr,
      message: qr,
      operator: "!=",
      stackStartFn: Br
    });
  }, Qe.deepEqual = function Br(Fr, Gr, qr) {
    if (arguments.length < 2)
      throw new C("actual", "expected");
    Ie === void 0 && Pe(), Ie(Fr, Gr) || Ee({
      actual: Fr,
      expected: Gr,
      message: qr,
      operator: "deepEqual",
      stackStartFn: Br
    });
  }, Qe.notDeepEqual = function Br(Fr, Gr, qr) {
    if (arguments.length < 2)
      throw new C("actual", "expected");
    Ie === void 0 && Pe(), Ie(Fr, Gr) && Ee({
      actual: Fr,
      expected: Gr,
      message: qr,
      operator: "notDeepEqual",
      stackStartFn: Br
    });
  }, Qe.deepStrictEqual = function Br(Fr, Gr, qr) {
    if (arguments.length < 2)
      throw new C("actual", "expected");
    Ie === void 0 && Pe(), be(Fr, Gr) || Ee({
      actual: Fr,
      expected: Gr,
      message: qr,
      operator: "deepStrictEqual",
      stackStartFn: Br
    });
  }, Qe.notDeepStrictEqual = Ce;
  function Ce(Br, Fr, Gr) {
    if (arguments.length < 2)
      throw new C("actual", "expected");
    Ie === void 0 && Pe(), be(Br, Fr) && Ee({
      actual: Br,
      expected: Fr,
      message: Gr,
      operator: "notDeepStrictEqual",
      stackStartFn: Ce
    });
  }
  Qe.strictEqual = function Br(Fr, Gr, qr) {
    if (arguments.length < 2)
      throw new C("actual", "expected");
    ge(Fr, Gr) || Ee({
      actual: Fr,
      expected: Gr,
      message: qr,
      operator: "strictEqual",
      stackStartFn: Br
    });
  }, Qe.notStrictEqual = function Br(Fr, Gr, qr) {
    if (arguments.length < 2)
      throw new C("actual", "expected");
    ge(Fr, Gr) && Ee({
      actual: Fr,
      expected: Gr,
      message: qr,
      operator: "notStrictEqual",
      stackStartFn: Br
    });
  };
  var Se = /* @__PURE__ */ A(function Br(Fr, Gr, qr) {
    var Hr = this;
    u(this, Br), Gr.forEach(function(un) {
      un in Fr && (qr !== void 0 && typeof qr[un] == "string" && F(Fr[un]) && pe(Fr[un], qr[un]) ? Hr[un] = qr[un] : Hr[un] = Fr[un]);
    });
  });
  function Ne(Br, Fr, Gr, qr, Hr, un) {
    if (!(Gr in Br) || !be(Br[Gr], Fr[Gr])) {
      if (!qr) {
        var Dr = new Se(Br, Hr), wr = new Se(Fr, Hr, Br), yr = new B({
          actual: Dr,
          expected: wr,
          operator: "deepStrictEqual",
          stackStartFn: un
        });
        throw yr.actual = Br, yr.expected = Fr, yr.operator = un.name, yr;
      }
      Ee({
        actual: Br,
        expected: Fr,
        message: qr,
        operator: un.name,
        stackStartFn: un
      });
    }
  }
  function rr(Br, Fr, Gr, qr) {
    if (typeof Fr != "function") {
      if (F(Fr)) return pe(Fr, Br);
      if (arguments.length === 2)
        throw new m("expected", ["Function", "RegExp"], Fr);
      if (s(Br) !== "object" || Br === null) {
        var Hr = new B({
          actual: Br,
          expected: Fr,
          message: Gr,
          operator: "deepStrictEqual",
          stackStartFn: qr
        });
        throw Hr.operator = qr.name, Hr;
      }
      var un = Object.keys(Fr);
      if (Fr instanceof Error)
        un.push("name", "message");
      else if (un.length === 0)
        throw new b("error", Fr, "may not be an empty object");
      return Ie === void 0 && Pe(), un.forEach(function(Dr) {
        typeof Br[Dr] == "string" && F(Fr[Dr]) && pe(Fr[Dr], Br[Dr]) || Ne(Br, Fr, Dr, Gr, un, qr);
      }), !0;
    }
    return Fr.prototype !== void 0 && Br instanceof Fr ? !0 : Error.isPrototypeOf(Fr) ? !1 : Fr.call({}, Br) === !0;
  }
  function er(Br) {
    if (typeof Br != "function")
      throw new m("fn", "Function", Br);
    try {
      Br();
    } catch (Fr) {
      return Fr;
    }
    return xe;
  }
  function ir(Br) {
    return M(Br) || Br !== null && s(Br) === "object" && typeof Br.then == "function" && typeof Br.catch == "function";
  }
  function sr(Br) {
    return Promise.resolve().then(function() {
      var Fr;
      if (typeof Br == "function") {
        if (Fr = Br(), !ir(Fr))
          throw new k("instance of Promise", "promiseFn", Fr);
      } else if (ir(Br))
        Fr = Br;
      else
        throw new m("promiseFn", ["Function", "Promise"], Br);
      return Promise.resolve().then(function() {
        return Fr;
      }).then(function() {
        return xe;
      }).catch(function(Gr) {
        return Gr;
      });
    });
  }
  function nr(Br, Fr, Gr, qr) {
    if (typeof Gr == "string") {
      if (arguments.length === 4)
        throw new m("error", ["Object", "Error", "Function", "RegExp"], Gr);
      if (s(Fr) === "object" && Fr !== null) {
        if (Fr.message === Gr)
          throw new l("error/message", 'The error message "'.concat(Fr.message, '" is identical to the message.'));
      } else if (Fr === Gr)
        throw new l("error/message", 'The error "'.concat(Fr, '" is identical to the message.'));
      qr = Gr, Gr = void 0;
    } else if (Gr != null && s(Gr) !== "object" && typeof Gr != "function")
      throw new m("error", ["Object", "Error", "Function", "RegExp"], Gr);
    if (Fr === xe) {
      var Hr = "";
      Gr && Gr.name && (Hr += " (".concat(Gr.name, ")")), Hr += qr ? ": ".concat(qr) : ".";
      var un = Br.name === "rejects" ? "rejection" : "exception";
      Ee({
        actual: void 0,
        expected: Gr,
        operator: Br.name,
        message: "Missing expected ".concat(un).concat(Hr),
        stackStartFn: Br
      });
    }
    if (Gr && !rr(Fr, Gr, qr, Br))
      throw Fr;
  }
  function fr(Br, Fr, Gr, qr) {
    if (Fr !== xe) {
      if (typeof Gr == "string" && (qr = Gr, Gr = void 0), !Gr || rr(Fr, Gr)) {
        var Hr = qr ? ": ".concat(qr) : ".", un = Br.name === "doesNotReject" ? "rejection" : "exception";
        Ee({
          actual: Fr,
          expected: Gr,
          operator: Br.name,
          message: "Got unwanted ".concat(un).concat(Hr, `
`) + 'Actual message: "'.concat(Fr && Fr.message, '"'),
          stackStartFn: Br
        });
      }
      throw Fr;
    }
  }
  Qe.throws = function Br(Fr) {
    for (var Gr = arguments.length, qr = new Array(Gr > 1 ? Gr - 1 : 0), Hr = 1; Hr < Gr; Hr++)
      qr[Hr - 1] = arguments[Hr];
    nr.apply(void 0, [Br, er(Fr)].concat(qr));
  }, Qe.rejects = function Br(Fr) {
    for (var Gr = arguments.length, qr = new Array(Gr > 1 ? Gr - 1 : 0), Hr = 1; Hr < Gr; Hr++)
      qr[Hr - 1] = arguments[Hr];
    return sr(Fr).then(function(un) {
      return nr.apply(void 0, [Br, un].concat(qr));
    });
  }, Qe.doesNotThrow = function Br(Fr) {
    for (var Gr = arguments.length, qr = new Array(Gr > 1 ? Gr - 1 : 0), Hr = 1; Hr < Gr; Hr++)
      qr[Hr - 1] = arguments[Hr];
    fr.apply(void 0, [Br, er(Fr)].concat(qr));
  }, Qe.doesNotReject = function Br(Fr) {
    for (var Gr = arguments.length, qr = new Array(Gr > 1 ? Gr - 1 : 0), Hr = 1; Hr < Gr; Hr++)
      qr[Hr - 1] = arguments[Hr];
    return sr(Fr).then(function(un) {
      return fr.apply(void 0, [Br, un].concat(qr));
    });
  }, Qe.ifError = function Br(Fr) {
    if (Fr != null) {
      var Gr = "ifError got unwanted exception: ";
      s(Fr) === "object" && typeof Fr.message == "string" ? Fr.message.length === 0 && Fr.constructor ? Gr += Fr.constructor.name : Gr += Fr.message : Gr += P(Fr);
      var qr = new B({
        actual: Fr,
        expected: null,
        operator: "ifError",
        message: Gr,
        stackStartFn: Br
      }), Hr = Fr.stack;
      if (typeof Hr == "string") {
        var un = Hr.split(`
`);
        un.shift();
        for (var Dr = qr.stack.split(`
`), wr = 0; wr < un.length; wr++) {
          var yr = Dr.indexOf(un[wr]);
          if (yr !== -1) {
            Dr = Dr.slice(0, yr);
            break;
          }
        }
        qr.stack = "".concat(Dr.join(`
`), `
`).concat(un.join(`
`));
      }
      throw qr;
    }
  };
  function lr(Br, Fr, Gr, qr, Hr) {
    if (!F(Fr))
      throw new m("regexp", "RegExp", Fr);
    var un = Hr === "match";
    if (typeof Br != "string" || pe(Fr, Br) !== un) {
      if (Gr instanceof Error)
        throw Gr;
      var Dr = !Gr;
      Gr = Gr || (typeof Br != "string" ? 'The "string" argument must be of type string. Received type ' + "".concat(s(Br), " (").concat(P(Br), ")") : (un ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat(P(Fr), `. Input:

`).concat(P(Br), `
`));
      var wr = new B({
        actual: Br,
        expected: Fr,
        message: Gr,
        operator: Hr,
        stackStartFn: qr
      });
      throw wr.generatedMessage = Dr, wr;
    }
  }
  Qe.match = function Br(Fr, Gr, qr) {
    lr(Fr, Gr, qr, Br, "match");
  }, Qe.doesNotMatch = function Br(Fr, Gr, qr) {
    lr(Fr, Gr, qr, Br, "doesNotMatch");
  };
  function br() {
    for (var Br = arguments.length, Fr = new Array(Br), Gr = 0; Gr < Br; Gr++)
      Fr[Gr] = arguments[Gr];
    ve.apply(void 0, [br, Fr.length].concat(Fr));
  }
  return Qe.strict = le(br, Qe, {
    equal: Qe.strictEqual,
    deepEqual: Qe.deepStrictEqual,
    notEqual: Qe.notStrictEqual,
    notDeepEqual: Qe.notDeepStrictEqual
  }), Qe.strict.strict = Qe.strict, assert$2.exports;
}
var fountainUtils = {}, xoshiro = {}, bignumber$1 = { exports: {} }, bignumber = bignumber$1.exports, hasRequiredBignumber;
function requireBignumber() {
  return hasRequiredBignumber || (hasRequiredBignumber = 1, function(s) {
    (function(A) {
      var u, p = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, t = Math.ceil, l = Math.floor, m = "[BigNumber Error] ", b = m + "Number primitive has more than 15 significant digits: ", k = 1e14, C = 14, B = 9007199254740991, Q = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], P = 1e7, x = 1e9;
      function M(Te) {
        var Qe, xe, Ee, He = Br.prototype = { constructor: Br, toString: null, valueOf: null }, ve = new Br(1), we = 20, Ce = 4, Se = -7, Ne = 21, rr = -1e7, er = 1e7, ir = !1, sr = 1, nr = 0, fr = {
          prefix: "",
          groupSize: 3,
          secondaryGroupSize: 0,
          groupSeparator: ",",
          decimalSeparator: ".",
          fractionGroupSize: 0,
          fractionGroupSeparator: " ",
          // non-breaking space
          suffix: ""
        }, lr = "0123456789abcdefghijklmnopqrstuvwxyz", br = !0;
        function Br(Dr, wr) {
          var yr, Qr, _r, Jr, fn, jr, dn, Tn, Yn = this;
          if (!(Yn instanceof Br)) return new Br(Dr, wr);
          if (wr == null) {
            if (Dr && Dr._isBigNumber === !0) {
              Yn.s = Dr.s, !Dr.c || Dr.e > er ? Yn.c = Yn.e = null : Dr.e < rr ? Yn.c = [Yn.e = 0] : (Yn.e = Dr.e, Yn.c = Dr.c.slice());
              return;
            }
            if ((jr = typeof Dr == "number") && Dr * 0 == 0) {
              if (Yn.s = 1 / Dr < 0 ? (Dr = -Dr, -1) : 1, Dr === ~~Dr) {
                for (Jr = 0, fn = Dr; fn >= 10; fn /= 10, Jr++) ;
                Jr > er ? Yn.c = Yn.e = null : (Yn.e = Jr, Yn.c = [Dr]);
                return;
              }
              Tn = String(Dr);
            } else {
              if (!p.test(Tn = String(Dr))) return Ee(Yn, Tn, jr);
              Yn.s = Tn.charCodeAt(0) == 45 ? (Tn = Tn.slice(1), -1) : 1;
            }
            (Jr = Tn.indexOf(".")) > -1 && (Tn = Tn.replace(".", "")), (fn = Tn.search(/e/i)) > 0 ? (Jr < 0 && (Jr = fn), Jr += +Tn.slice(fn + 1), Tn = Tn.substring(0, fn)) : Jr < 0 && (Jr = Tn.length);
          } else {
            if (pe(wr, 2, lr.length, "Base"), wr == 10 && br)
              return Yn = new Br(Dr), Hr(Yn, we + Yn.e + 1, Ce);
            if (Tn = String(Dr), jr = typeof Dr == "number") {
              if (Dr * 0 != 0) return Ee(Yn, Tn, jr, wr);
              if (Yn.s = 1 / Dr < 0 ? (Tn = Tn.slice(1), -1) : 1, Br.DEBUG && Tn.replace(/^0\.0*|\./, "").length > 15)
                throw Error(b + Dr);
            } else
              Yn.s = Tn.charCodeAt(0) === 45 ? (Tn = Tn.slice(1), -1) : 1;
            for (yr = lr.slice(0, wr), Jr = fn = 0, dn = Tn.length; fn < dn; fn++)
              if (yr.indexOf(Qr = Tn.charAt(fn)) < 0) {
                if (Qr == ".") {
                  if (fn > Jr) {
                    Jr = dn;
                    continue;
                  }
                } else if (!_r && (Tn == Tn.toUpperCase() && (Tn = Tn.toLowerCase()) || Tn == Tn.toLowerCase() && (Tn = Tn.toUpperCase()))) {
                  _r = !0, fn = -1, Jr = 0;
                  continue;
                }
                return Ee(Yn, String(Dr), jr, wr);
              }
            jr = !1, Tn = xe(Tn, wr, 10, Yn.s), (Jr = Tn.indexOf(".")) > -1 ? Tn = Tn.replace(".", "") : Jr = Tn.length;
          }
          for (fn = 0; Tn.charCodeAt(fn) === 48; fn++) ;
          for (dn = Tn.length; Tn.charCodeAt(--dn) === 48; ) ;
          if (Tn = Tn.slice(fn, ++dn)) {
            if (dn -= fn, jr && Br.DEBUG && dn > 15 && (Dr > B || Dr !== l(Dr)))
              throw Error(b + Yn.s * Dr);
            if ((Jr = Jr - fn - 1) > er)
              Yn.c = Yn.e = null;
            else if (Jr < rr)
              Yn.c = [Yn.e = 0];
            else {
              if (Yn.e = Jr, Yn.c = [], fn = (Jr + 1) % C, Jr < 0 && (fn += C), fn < dn) {
                for (fn && Yn.c.push(+Tn.slice(0, fn)), dn -= C; fn < dn; )
                  Yn.c.push(+Tn.slice(fn, fn += C));
                fn = C - (Tn = Tn.slice(fn)).length;
              } else
                fn -= dn;
              for (; fn--; Tn += "0") ;
              Yn.c.push(+Tn);
            }
          } else
            Yn.c = [Yn.e = 0];
        }
        Br.clone = M, Br.ROUND_UP = 0, Br.ROUND_DOWN = 1, Br.ROUND_CEIL = 2, Br.ROUND_FLOOR = 3, Br.ROUND_HALF_UP = 4, Br.ROUND_HALF_DOWN = 5, Br.ROUND_HALF_EVEN = 6, Br.ROUND_HALF_CEIL = 7, Br.ROUND_HALF_FLOOR = 8, Br.EUCLID = 9, Br.config = Br.set = function(Dr) {
          var wr, yr;
          if (Dr != null)
            if (typeof Dr == "object") {
              if (Dr.hasOwnProperty(wr = "DECIMAL_PLACES") && (yr = Dr[wr], pe(yr, 0, x, wr), we = yr), Dr.hasOwnProperty(wr = "ROUNDING_MODE") && (yr = Dr[wr], pe(yr, 0, 8, wr), Ce = yr), Dr.hasOwnProperty(wr = "EXPONENTIAL_AT") && (yr = Dr[wr], yr && yr.pop ? (pe(yr[0], -x, 0, wr), pe(yr[1], 0, x, wr), Se = yr[0], Ne = yr[1]) : (pe(yr, -x, x, wr), Se = -(Ne = yr < 0 ? -yr : yr))), Dr.hasOwnProperty(wr = "RANGE"))
                if (yr = Dr[wr], yr && yr.pop)
                  pe(yr[0], -x, -1, wr), pe(yr[1], 1, x, wr), rr = yr[0], er = yr[1];
                else if (pe(yr, -x, x, wr), yr)
                  rr = -(er = yr < 0 ? -yr : yr);
                else
                  throw Error(m + wr + " cannot be zero: " + yr);
              if (Dr.hasOwnProperty(wr = "CRYPTO"))
                if (yr = Dr[wr], yr === !!yr)
                  if (yr)
                    if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                      ir = yr;
                    else
                      throw ir = !yr, Error(m + "crypto unavailable");
                  else
                    ir = yr;
                else
                  throw Error(m + wr + " not true or false: " + yr);
              if (Dr.hasOwnProperty(wr = "MODULO_MODE") && (yr = Dr[wr], pe(yr, 0, 9, wr), sr = yr), Dr.hasOwnProperty(wr = "POW_PRECISION") && (yr = Dr[wr], pe(yr, 0, x, wr), nr = yr), Dr.hasOwnProperty(wr = "FORMAT"))
                if (yr = Dr[wr], typeof yr == "object") fr = yr;
                else throw Error(m + wr + " not an object: " + yr);
              if (Dr.hasOwnProperty(wr = "ALPHABET"))
                if (yr = Dr[wr], typeof yr == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(yr))
                  br = yr.slice(0, 10) == "0123456789", lr = yr;
                else
                  throw Error(m + wr + " invalid: " + yr);
            } else
              throw Error(m + "Object expected: " + Dr);
          return {
            DECIMAL_PLACES: we,
            ROUNDING_MODE: Ce,
            EXPONENTIAL_AT: [Se, Ne],
            RANGE: [rr, er],
            CRYPTO: ir,
            MODULO_MODE: sr,
            POW_PRECISION: nr,
            FORMAT: fr,
            ALPHABET: lr
          };
        }, Br.isBigNumber = function(Dr) {
          if (!Dr || Dr._isBigNumber !== !0) return !1;
          if (!Br.DEBUG) return !0;
          var wr, yr, Qr = Dr.c, _r = Dr.e, Jr = Dr.s;
          e: if ({}.toString.call(Qr) == "[object Array]") {
            if ((Jr === 1 || Jr === -1) && _r >= -x && _r <= x && _r === l(_r)) {
              if (Qr[0] === 0) {
                if (_r === 0 && Qr.length === 1) return !0;
                break e;
              }
              if (wr = (_r + 1) % C, wr < 1 && (wr += C), String(Qr[0]).length == wr) {
                for (wr = 0; wr < Qr.length; wr++)
                  if (yr = Qr[wr], yr < 0 || yr >= k || yr !== l(yr)) break e;
                if (yr !== 0) return !0;
              }
            }
          } else if (Qr === null && _r === null && (Jr === null || Jr === 1 || Jr === -1))
            return !0;
          throw Error(m + "Invalid BigNumber: " + Dr);
        }, Br.maximum = Br.max = function() {
          return Gr(arguments, -1);
        }, Br.minimum = Br.min = function() {
          return Gr(arguments, 1);
        }, Br.random = function() {
          var Dr = 9007199254740992, wr = Math.random() * Dr & 2097151 ? function() {
            return l(Math.random() * Dr);
          } : function() {
            return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
          };
          return function(yr) {
            var Qr, _r, Jr, fn, jr, dn = 0, Tn = [], Yn = new Br(ve);
            if (yr == null ? yr = we : pe(yr, 0, x), fn = t(yr / C), ir)
              if (crypto.getRandomValues) {
                for (Qr = crypto.getRandomValues(new Uint32Array(fn *= 2)); dn < fn; )
                  jr = Qr[dn] * 131072 + (Qr[dn + 1] >>> 11), jr >= 9e15 ? (_r = crypto.getRandomValues(new Uint32Array(2)), Qr[dn] = _r[0], Qr[dn + 1] = _r[1]) : (Tn.push(jr % 1e14), dn += 2);
                dn = fn / 2;
              } else if (crypto.randomBytes) {
                for (Qr = crypto.randomBytes(fn *= 7); dn < fn; )
                  jr = (Qr[dn] & 31) * 281474976710656 + Qr[dn + 1] * 1099511627776 + Qr[dn + 2] * 4294967296 + Qr[dn + 3] * 16777216 + (Qr[dn + 4] << 16) + (Qr[dn + 5] << 8) + Qr[dn + 6], jr >= 9e15 ? crypto.randomBytes(7).copy(Qr, dn) : (Tn.push(jr % 1e14), dn += 7);
                dn = fn / 7;
              } else
                throw ir = !1, Error(m + "crypto unavailable");
            if (!ir)
              for (; dn < fn; )
                jr = wr(), jr < 9e15 && (Tn[dn++] = jr % 1e14);
            for (fn = Tn[--dn], yr %= C, fn && yr && (jr = Q[C - yr], Tn[dn] = l(fn / jr) * jr); Tn[dn] === 0; Tn.pop(), dn--) ;
            if (dn < 0)
              Tn = [Jr = 0];
            else {
              for (Jr = -1; Tn[0] === 0; Tn.splice(0, 1), Jr -= C) ;
              for (dn = 1, jr = Tn[0]; jr >= 10; jr /= 10, dn++) ;
              dn < C && (Jr -= C - dn);
            }
            return Yn.e = Jr, Yn.c = Tn, Yn;
          };
        }(), Br.sum = function() {
          for (var Dr = 1, wr = arguments, yr = new Br(wr[0]); Dr < wr.length; ) yr = yr.plus(wr[Dr++]);
          return yr;
        }, xe = /* @__PURE__ */ function() {
          var Dr = "0123456789";
          function wr(yr, Qr, _r, Jr) {
            for (var fn, jr = [0], dn, Tn = 0, Yn = yr.length; Tn < Yn; ) {
              for (dn = jr.length; dn--; jr[dn] *= Qr) ;
              for (jr[0] += Jr.indexOf(yr.charAt(Tn++)), fn = 0; fn < jr.length; fn++)
                jr[fn] > _r - 1 && (jr[fn + 1] == null && (jr[fn + 1] = 0), jr[fn + 1] += jr[fn] / _r | 0, jr[fn] %= _r);
            }
            return jr.reverse();
          }
          return function(yr, Qr, _r, Jr, fn) {
            var jr, dn, Tn, Yn, si, vn, Cn, Xr, In = yr.indexOf("."), zr = we, En = Ce;
            for (In >= 0 && (Yn = nr, nr = 0, yr = yr.replace(".", ""), Xr = new Br(Qr), vn = Xr.pow(yr.length - In), nr = Yn, Xr.c = wr(
              Pe(le(vn.c), vn.e, "0"),
              10,
              _r,
              Dr
            ), Xr.e = Xr.c.length), Cn = wr(yr, Qr, _r, fn ? (jr = lr, Dr) : (jr = Dr, lr)), Tn = Yn = Cn.length; Cn[--Yn] == 0; Cn.pop()) ;
            if (!Cn[0]) return jr.charAt(0);
            if (In < 0 ? --Tn : (vn.c = Cn, vn.e = Tn, vn.s = Jr, vn = Qe(vn, Xr, zr, En, _r), Cn = vn.c, si = vn.r, Tn = vn.e), dn = Tn + zr + 1, In = Cn[dn], Yn = _r / 2, si = si || dn < 0 || Cn[dn + 1] != null, si = En < 4 ? (In != null || si) && (En == 0 || En == (vn.s < 0 ? 3 : 2)) : In > Yn || In == Yn && (En == 4 || si || En == 6 && Cn[dn - 1] & 1 || En == (vn.s < 0 ? 8 : 7)), dn < 1 || !Cn[0])
              yr = si ? Pe(jr.charAt(1), -zr, jr.charAt(0)) : jr.charAt(0);
            else {
              if (Cn.length = dn, si)
                for (--_r; ++Cn[--dn] > _r; )
                  Cn[dn] = 0, dn || (++Tn, Cn = [1].concat(Cn));
              for (Yn = Cn.length; !Cn[--Yn]; ) ;
              for (In = 0, yr = ""; In <= Yn; yr += jr.charAt(Cn[In++])) ;
              yr = Pe(yr, Tn, jr.charAt(0));
            }
            return yr;
          };
        }(), Qe = /* @__PURE__ */ function() {
          function Dr(Qr, _r, Jr) {
            var fn, jr, dn, Tn, Yn = 0, si = Qr.length, vn = _r % P, Cn = _r / P | 0;
            for (Qr = Qr.slice(); si--; )
              dn = Qr[si] % P, Tn = Qr[si] / P | 0, fn = Cn * dn + Tn * vn, jr = vn * dn + fn % P * P + Yn, Yn = (jr / Jr | 0) + (fn / P | 0) + Cn * Tn, Qr[si] = jr % Jr;
            return Yn && (Qr = [Yn].concat(Qr)), Qr;
          }
          function wr(Qr, _r, Jr, fn) {
            var jr, dn;
            if (Jr != fn)
              dn = Jr > fn ? 1 : -1;
            else
              for (jr = dn = 0; jr < Jr; jr++)
                if (Qr[jr] != _r[jr]) {
                  dn = Qr[jr] > _r[jr] ? 1 : -1;
                  break;
                }
            return dn;
          }
          function yr(Qr, _r, Jr, fn) {
            for (var jr = 0; Jr--; )
              Qr[Jr] -= jr, jr = Qr[Jr] < _r[Jr] ? 1 : 0, Qr[Jr] = jr * fn + Qr[Jr] - _r[Jr];
            for (; !Qr[0] && Qr.length > 1; Qr.splice(0, 1)) ;
          }
          return function(Qr, _r, Jr, fn, jr) {
            var dn, Tn, Yn, si, vn, Cn, Xr, In, zr, En, Zr, kr, Rr, Er, Or, wn, Kn, Ln = Qr.s == _r.s ? 1 : -1, Wn = Qr.c, Sn = _r.c;
            if (!Wn || !Wn[0] || !Sn || !Sn[0])
              return new Br(
                // Return NaN if either NaN, or both Infinity or 0.
                !Qr.s || !_r.s || (Wn ? Sn && Wn[0] == Sn[0] : !Sn) ? NaN : (
                  // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                  Wn && Wn[0] == 0 || !Sn ? Ln * 0 : Ln / 0
                )
              );
            for (In = new Br(Ln), zr = In.c = [], Tn = Qr.e - _r.e, Ln = Jr + Tn + 1, jr || (jr = k, Tn = F(Qr.e / C) - F(_r.e / C), Ln = Ln / C | 0), Yn = 0; Sn[Yn] == (Wn[Yn] || 0); Yn++) ;
            if (Sn[Yn] > (Wn[Yn] || 0) && Tn--, Ln < 0)
              zr.push(1), si = !0;
            else {
              for (Er = Wn.length, wn = Sn.length, Yn = 0, Ln += 2, vn = l(jr / (Sn[0] + 1)), vn > 1 && (Sn = Dr(Sn, vn, jr), Wn = Dr(Wn, vn, jr), wn = Sn.length, Er = Wn.length), Rr = wn, En = Wn.slice(0, wn), Zr = En.length; Zr < wn; En[Zr++] = 0) ;
              Kn = Sn.slice(), Kn = [0].concat(Kn), Or = Sn[0], Sn[1] >= jr / 2 && Or++;
              do {
                if (vn = 0, dn = wr(Sn, En, wn, Zr), dn < 0) {
                  if (kr = En[0], wn != Zr && (kr = kr * jr + (En[1] || 0)), vn = l(kr / Or), vn > 1)
                    for (vn >= jr && (vn = jr - 1), Cn = Dr(Sn, vn, jr), Xr = Cn.length, Zr = En.length; wr(Cn, En, Xr, Zr) == 1; )
                      vn--, yr(Cn, wn < Xr ? Kn : Sn, Xr, jr), Xr = Cn.length, dn = 1;
                  else
                    vn == 0 && (dn = vn = 1), Cn = Sn.slice(), Xr = Cn.length;
                  if (Xr < Zr && (Cn = [0].concat(Cn)), yr(En, Cn, Zr, jr), Zr = En.length, dn == -1)
                    for (; wr(Sn, En, wn, Zr) < 1; )
                      vn++, yr(En, wn < Zr ? Kn : Sn, Zr, jr), Zr = En.length;
                } else dn === 0 && (vn++, En = [0]);
                zr[Yn++] = vn, En[0] ? En[Zr++] = Wn[Rr] || 0 : (En = [Wn[Rr]], Zr = 1);
              } while ((Rr++ < Er || En[0] != null) && Ln--);
              si = En[0] != null, zr[0] || zr.splice(0, 1);
            }
            if (jr == k) {
              for (Yn = 1, Ln = zr[0]; Ln >= 10; Ln /= 10, Yn++) ;
              Hr(In, Jr + (In.e = Yn + Tn * C - 1) + 1, fn, si);
            } else
              In.e = Tn, In.r = +si;
            return In;
          };
        }();
        function Fr(Dr, wr, yr, Qr) {
          var _r, Jr, fn, jr, dn;
          if (yr == null ? yr = Ce : pe(yr, 0, 8), !Dr.c) return Dr.toString();
          if (_r = Dr.c[0], fn = Dr.e, wr == null)
            dn = le(Dr.c), dn = Qr == 1 || Qr == 2 && (fn <= Se || fn >= Ne) ? be(dn, fn) : Pe(dn, fn, "0");
          else if (Dr = Hr(new Br(Dr), wr, yr), Jr = Dr.e, dn = le(Dr.c), jr = dn.length, Qr == 1 || Qr == 2 && (wr <= Jr || Jr <= Se)) {
            for (; jr < wr; dn += "0", jr++) ;
            dn = be(dn, Jr);
          } else if (wr -= fn + (Qr === 2 && Jr > fn), dn = Pe(dn, Jr, "0"), Jr + 1 > jr) {
            if (--wr > 0) for (dn += "."; wr--; dn += "0") ;
          } else if (wr += Jr - jr, wr > 0)
            for (Jr + 1 == jr && (dn += "."); wr--; dn += "0") ;
          return Dr.s < 0 && _r ? "-" + dn : dn;
        }
        function Gr(Dr, wr) {
          for (var yr, Qr, _r = 1, Jr = new Br(Dr[0]); _r < Dr.length; _r++)
            Qr = new Br(Dr[_r]), (!Qr.s || (yr = ge(Jr, Qr)) === wr || yr === 0 && Jr.s === wr) && (Jr = Qr);
          return Jr;
        }
        function qr(Dr, wr, yr) {
          for (var Qr = 1, _r = wr.length; !wr[--_r]; wr.pop()) ;
          for (_r = wr[0]; _r >= 10; _r /= 10, Qr++) ;
          return (yr = Qr + yr * C - 1) > er ? Dr.c = Dr.e = null : yr < rr ? Dr.c = [Dr.e = 0] : (Dr.e = yr, Dr.c = wr), Dr;
        }
        Ee = /* @__PURE__ */ function() {
          var Dr = /^(-?)0([xbo])(?=\w[\w.]*$)/i, wr = /^([^.]+)\.$/, yr = /^\.([^.]+)$/, Qr = /^-?(Infinity|NaN)$/, _r = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
          return function(Jr, fn, jr, dn) {
            var Tn, Yn = jr ? fn : fn.replace(_r, "");
            if (Qr.test(Yn))
              Jr.s = isNaN(Yn) ? null : Yn < 0 ? -1 : 1;
            else {
              if (!jr && (Yn = Yn.replace(Dr, function(si, vn, Cn) {
                return Tn = (Cn = Cn.toLowerCase()) == "x" ? 16 : Cn == "b" ? 2 : 8, !dn || dn == Tn ? vn : si;
              }), dn && (Tn = dn, Yn = Yn.replace(wr, "$1").replace(yr, "0.$1")), fn != Yn))
                return new Br(Yn, Tn);
              if (Br.DEBUG)
                throw Error(m + "Not a" + (dn ? " base " + dn : "") + " number: " + fn);
              Jr.s = null;
            }
            Jr.c = Jr.e = null;
          };
        }();
        function Hr(Dr, wr, yr, Qr) {
          var _r, Jr, fn, jr, dn, Tn, Yn, si = Dr.c, vn = Q;
          if (si) {
            e: {
              for (_r = 1, jr = si[0]; jr >= 10; jr /= 10, _r++) ;
              if (Jr = wr - _r, Jr < 0)
                Jr += C, fn = wr, dn = si[Tn = 0], Yn = l(dn / vn[_r - fn - 1] % 10);
              else if (Tn = t((Jr + 1) / C), Tn >= si.length)
                if (Qr) {
                  for (; si.length <= Tn; si.push(0)) ;
                  dn = Yn = 0, _r = 1, Jr %= C, fn = Jr - C + 1;
                } else
                  break e;
              else {
                for (dn = jr = si[Tn], _r = 1; jr >= 10; jr /= 10, _r++) ;
                Jr %= C, fn = Jr - C + _r, Yn = fn < 0 ? 0 : l(dn / vn[_r - fn - 1] % 10);
              }
              if (Qr = Qr || wr < 0 || // Are there any non-zero digits after the rounding digit?
              // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
              // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
              si[Tn + 1] != null || (fn < 0 ? dn : dn % vn[_r - fn - 1]), Qr = yr < 4 ? (Yn || Qr) && (yr == 0 || yr == (Dr.s < 0 ? 3 : 2)) : Yn > 5 || Yn == 5 && (yr == 4 || Qr || yr == 6 && // Check whether the digit to the left of the rounding digit is odd.
              (Jr > 0 ? fn > 0 ? dn / vn[_r - fn] : 0 : si[Tn - 1]) % 10 & 1 || yr == (Dr.s < 0 ? 8 : 7)), wr < 1 || !si[0])
                return si.length = 0, Qr ? (wr -= Dr.e + 1, si[0] = vn[(C - wr % C) % C], Dr.e = -wr || 0) : si[0] = Dr.e = 0, Dr;
              if (Jr == 0 ? (si.length = Tn, jr = 1, Tn--) : (si.length = Tn + 1, jr = vn[C - Jr], si[Tn] = fn > 0 ? l(dn / vn[_r - fn] % vn[fn]) * jr : 0), Qr)
                for (; ; )
                  if (Tn == 0) {
                    for (Jr = 1, fn = si[0]; fn >= 10; fn /= 10, Jr++) ;
                    for (fn = si[0] += jr, jr = 1; fn >= 10; fn /= 10, jr++) ;
                    Jr != jr && (Dr.e++, si[0] == k && (si[0] = 1));
                    break;
                  } else {
                    if (si[Tn] += jr, si[Tn] != k) break;
                    si[Tn--] = 0, jr = 1;
                  }
              for (Jr = si.length; si[--Jr] === 0; si.pop()) ;
            }
            Dr.e > er ? Dr.c = Dr.e = null : Dr.e < rr && (Dr.c = [Dr.e = 0]);
          }
          return Dr;
        }
        function un(Dr) {
          var wr, yr = Dr.e;
          return yr === null ? Dr.toString() : (wr = le(Dr.c), wr = yr <= Se || yr >= Ne ? be(wr, yr) : Pe(wr, yr, "0"), Dr.s < 0 ? "-" + wr : wr);
        }
        return He.absoluteValue = He.abs = function() {
          var Dr = new Br(this);
          return Dr.s < 0 && (Dr.s = 1), Dr;
        }, He.comparedTo = function(Dr, wr) {
          return ge(this, new Br(Dr, wr));
        }, He.decimalPlaces = He.dp = function(Dr, wr) {
          var yr, Qr, _r, Jr = this;
          if (Dr != null)
            return pe(Dr, 0, x), wr == null ? wr = Ce : pe(wr, 0, 8), Hr(new Br(Jr), Dr + Jr.e + 1, wr);
          if (!(yr = Jr.c)) return null;
          if (Qr = ((_r = yr.length - 1) - F(this.e / C)) * C, _r = yr[_r]) for (; _r % 10 == 0; _r /= 10, Qr--) ;
          return Qr < 0 && (Qr = 0), Qr;
        }, He.dividedBy = He.div = function(Dr, wr) {
          return Qe(this, new Br(Dr, wr), we, Ce);
        }, He.dividedToIntegerBy = He.idiv = function(Dr, wr) {
          return Qe(this, new Br(Dr, wr), 0, 1);
        }, He.exponentiatedBy = He.pow = function(Dr, wr) {
          var yr, Qr, _r, Jr, fn, jr, dn, Tn, Yn, si = this;
          if (Dr = new Br(Dr), Dr.c && !Dr.isInteger())
            throw Error(m + "Exponent not an integer: " + un(Dr));
          if (wr != null && (wr = new Br(wr)), jr = Dr.e > 14, !si.c || !si.c[0] || si.c[0] == 1 && !si.e && si.c.length == 1 || !Dr.c || !Dr.c[0])
            return Yn = new Br(Math.pow(+un(si), jr ? Dr.s * (2 - Ie(Dr)) : +un(Dr))), wr ? Yn.mod(wr) : Yn;
          if (dn = Dr.s < 0, wr) {
            if (wr.c ? !wr.c[0] : !wr.s) return new Br(NaN);
            Qr = !dn && si.isInteger() && wr.isInteger(), Qr && (si = si.mod(wr));
          } else {
            if (Dr.e > 9 && (si.e > 0 || si.e < -1 || (si.e == 0 ? si.c[0] > 1 || jr && si.c[1] >= 24e7 : si.c[0] < 8e13 || jr && si.c[0] <= 9999975e7)))
              return Jr = si.s < 0 && Ie(Dr) ? -0 : 0, si.e > -1 && (Jr = 1 / Jr), new Br(dn ? 1 / Jr : Jr);
            nr && (Jr = t(nr / C + 2));
          }
          for (jr ? (yr = new Br(0.5), dn && (Dr.s = 1), Tn = Ie(Dr)) : (_r = Math.abs(+un(Dr)), Tn = _r % 2), Yn = new Br(ve); ; ) {
            if (Tn) {
              if (Yn = Yn.times(si), !Yn.c) break;
              Jr ? Yn.c.length > Jr && (Yn.c.length = Jr) : Qr && (Yn = Yn.mod(wr));
            }
            if (_r) {
              if (_r = l(_r / 2), _r === 0) break;
              Tn = _r % 2;
            } else if (Dr = Dr.times(yr), Hr(Dr, Dr.e + 1, 1), Dr.e > 14)
              Tn = Ie(Dr);
            else {
              if (_r = +un(Dr), _r === 0) break;
              Tn = _r % 2;
            }
            si = si.times(si), Jr ? si.c && si.c.length > Jr && (si.c.length = Jr) : Qr && (si = si.mod(wr));
          }
          return Qr ? Yn : (dn && (Yn = ve.div(Yn)), wr ? Yn.mod(wr) : Jr ? Hr(Yn, nr, Ce, fn) : Yn);
        }, He.integerValue = function(Dr) {
          var wr = new Br(this);
          return Dr == null ? Dr = Ce : pe(Dr, 0, 8), Hr(wr, wr.e + 1, Dr);
        }, He.isEqualTo = He.eq = function(Dr, wr) {
          return ge(this, new Br(Dr, wr)) === 0;
        }, He.isFinite = function() {
          return !!this.c;
        }, He.isGreaterThan = He.gt = function(Dr, wr) {
          return ge(this, new Br(Dr, wr)) > 0;
        }, He.isGreaterThanOrEqualTo = He.gte = function(Dr, wr) {
          return (wr = ge(this, new Br(Dr, wr))) === 1 || wr === 0;
        }, He.isInteger = function() {
          return !!this.c && F(this.e / C) > this.c.length - 2;
        }, He.isLessThan = He.lt = function(Dr, wr) {
          return ge(this, new Br(Dr, wr)) < 0;
        }, He.isLessThanOrEqualTo = He.lte = function(Dr, wr) {
          return (wr = ge(this, new Br(Dr, wr))) === -1 || wr === 0;
        }, He.isNaN = function() {
          return !this.s;
        }, He.isNegative = function() {
          return this.s < 0;
        }, He.isPositive = function() {
          return this.s > 0;
        }, He.isZero = function() {
          return !!this.c && this.c[0] == 0;
        }, He.minus = function(Dr, wr) {
          var yr, Qr, _r, Jr, fn = this, jr = fn.s;
          if (Dr = new Br(Dr, wr), wr = Dr.s, !jr || !wr) return new Br(NaN);
          if (jr != wr)
            return Dr.s = -wr, fn.plus(Dr);
          var dn = fn.e / C, Tn = Dr.e / C, Yn = fn.c, si = Dr.c;
          if (!dn || !Tn) {
            if (!Yn || !si) return Yn ? (Dr.s = -wr, Dr) : new Br(si ? fn : NaN);
            if (!Yn[0] || !si[0])
              return si[0] ? (Dr.s = -wr, Dr) : new Br(Yn[0] ? fn : (
                // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                Ce == 3 ? -0 : 0
              ));
          }
          if (dn = F(dn), Tn = F(Tn), Yn = Yn.slice(), jr = dn - Tn) {
            for ((Jr = jr < 0) ? (jr = -jr, _r = Yn) : (Tn = dn, _r = si), _r.reverse(), wr = jr; wr--; _r.push(0)) ;
            _r.reverse();
          } else
            for (Qr = (Jr = (jr = Yn.length) < (wr = si.length)) ? jr : wr, jr = wr = 0; wr < Qr; wr++)
              if (Yn[wr] != si[wr]) {
                Jr = Yn[wr] < si[wr];
                break;
              }
          if (Jr && (_r = Yn, Yn = si, si = _r, Dr.s = -Dr.s), wr = (Qr = si.length) - (yr = Yn.length), wr > 0) for (; wr--; Yn[yr++] = 0) ;
          for (wr = k - 1; Qr > jr; ) {
            if (Yn[--Qr] < si[Qr]) {
              for (yr = Qr; yr && !Yn[--yr]; Yn[yr] = wr) ;
              --Yn[yr], Yn[Qr] += k;
            }
            Yn[Qr] -= si[Qr];
          }
          for (; Yn[0] == 0; Yn.splice(0, 1), --Tn) ;
          return Yn[0] ? qr(Dr, Yn, Tn) : (Dr.s = Ce == 3 ? -1 : 1, Dr.c = [Dr.e = 0], Dr);
        }, He.modulo = He.mod = function(Dr, wr) {
          var yr, Qr, _r = this;
          return Dr = new Br(Dr, wr), !_r.c || !Dr.s || Dr.c && !Dr.c[0] ? new Br(NaN) : !Dr.c || _r.c && !_r.c[0] ? new Br(_r) : (sr == 9 ? (Qr = Dr.s, Dr.s = 1, yr = Qe(_r, Dr, 0, 3), Dr.s = Qr, yr.s *= Qr) : yr = Qe(_r, Dr, 0, sr), Dr = _r.minus(yr.times(Dr)), !Dr.c[0] && sr == 1 && (Dr.s = _r.s), Dr);
        }, He.multipliedBy = He.times = function(Dr, wr) {
          var yr, Qr, _r, Jr, fn, jr, dn, Tn, Yn, si, vn, Cn, Xr, In, zr, En = this, Zr = En.c, kr = (Dr = new Br(Dr, wr)).c;
          if (!Zr || !kr || !Zr[0] || !kr[0])
            return !En.s || !Dr.s || Zr && !Zr[0] && !kr || kr && !kr[0] && !Zr ? Dr.c = Dr.e = Dr.s = null : (Dr.s *= En.s, !Zr || !kr ? Dr.c = Dr.e = null : (Dr.c = [0], Dr.e = 0)), Dr;
          for (Qr = F(En.e / C) + F(Dr.e / C), Dr.s *= En.s, dn = Zr.length, si = kr.length, dn < si && (Xr = Zr, Zr = kr, kr = Xr, _r = dn, dn = si, si = _r), _r = dn + si, Xr = []; _r--; Xr.push(0)) ;
          for (In = k, zr = P, _r = si; --_r >= 0; ) {
            for (yr = 0, vn = kr[_r] % zr, Cn = kr[_r] / zr | 0, fn = dn, Jr = _r + fn; Jr > _r; )
              Tn = Zr[--fn] % zr, Yn = Zr[fn] / zr | 0, jr = Cn * Tn + Yn * vn, Tn = vn * Tn + jr % zr * zr + Xr[Jr] + yr, yr = (Tn / In | 0) + (jr / zr | 0) + Cn * Yn, Xr[Jr--] = Tn % In;
            Xr[Jr] = yr;
          }
          return yr ? ++Qr : Xr.splice(0, 1), qr(Dr, Xr, Qr);
        }, He.negated = function() {
          var Dr = new Br(this);
          return Dr.s = -Dr.s || null, Dr;
        }, He.plus = function(Dr, wr) {
          var yr, Qr = this, _r = Qr.s;
          if (Dr = new Br(Dr, wr), wr = Dr.s, !_r || !wr) return new Br(NaN);
          if (_r != wr)
            return Dr.s = -wr, Qr.minus(Dr);
          var Jr = Qr.e / C, fn = Dr.e / C, jr = Qr.c, dn = Dr.c;
          if (!Jr || !fn) {
            if (!jr || !dn) return new Br(_r / 0);
            if (!jr[0] || !dn[0]) return dn[0] ? Dr : new Br(jr[0] ? Qr : _r * 0);
          }
          if (Jr = F(Jr), fn = F(fn), jr = jr.slice(), _r = Jr - fn) {
            for (_r > 0 ? (fn = Jr, yr = dn) : (_r = -_r, yr = jr), yr.reverse(); _r--; yr.push(0)) ;
            yr.reverse();
          }
          for (_r = jr.length, wr = dn.length, _r - wr < 0 && (yr = dn, dn = jr, jr = yr, wr = _r), _r = 0; wr; )
            _r = (jr[--wr] = jr[wr] + dn[wr] + _r) / k | 0, jr[wr] = k === jr[wr] ? 0 : jr[wr] % k;
          return _r && (jr = [_r].concat(jr), ++fn), qr(Dr, jr, fn);
        }, He.precision = He.sd = function(Dr, wr) {
          var yr, Qr, _r, Jr = this;
          if (Dr != null && Dr !== !!Dr)
            return pe(Dr, 1, x), wr == null ? wr = Ce : pe(wr, 0, 8), Hr(new Br(Jr), Dr, wr);
          if (!(yr = Jr.c)) return null;
          if (_r = yr.length - 1, Qr = _r * C + 1, _r = yr[_r]) {
            for (; _r % 10 == 0; _r /= 10, Qr--) ;
            for (_r = yr[0]; _r >= 10; _r /= 10, Qr++) ;
          }
          return Dr && Jr.e + 1 > Qr && (Qr = Jr.e + 1), Qr;
        }, He.shiftedBy = function(Dr) {
          return pe(Dr, -B, B), this.times("1e" + Dr);
        }, He.squareRoot = He.sqrt = function() {
          var Dr, wr, yr, Qr, _r, Jr = this, fn = Jr.c, jr = Jr.s, dn = Jr.e, Tn = we + 4, Yn = new Br("0.5");
          if (jr !== 1 || !fn || !fn[0])
            return new Br(!jr || jr < 0 && (!fn || fn[0]) ? NaN : fn ? Jr : 1 / 0);
          if (jr = Math.sqrt(+un(Jr)), jr == 0 || jr == 1 / 0 ? (wr = le(fn), (wr.length + dn) % 2 == 0 && (wr += "0"), jr = Math.sqrt(+wr), dn = F((dn + 1) / 2) - (dn < 0 || dn % 2), jr == 1 / 0 ? wr = "5e" + dn : (wr = jr.toExponential(), wr = wr.slice(0, wr.indexOf("e") + 1) + dn), yr = new Br(wr)) : yr = new Br(jr + ""), yr.c[0]) {
            for (dn = yr.e, jr = dn + Tn, jr < 3 && (jr = 0); ; )
              if (_r = yr, yr = Yn.times(_r.plus(Qe(Jr, _r, Tn, 1))), le(_r.c).slice(0, jr) === (wr = le(yr.c)).slice(0, jr))
                if (yr.e < dn && --jr, wr = wr.slice(jr - 3, jr + 1), wr == "9999" || !Qr && wr == "4999") {
                  if (!Qr && (Hr(_r, _r.e + we + 2, 0), _r.times(_r).eq(Jr))) {
                    yr = _r;
                    break;
                  }
                  Tn += 4, jr += 4, Qr = 1;
                } else {
                  (!+wr || !+wr.slice(1) && wr.charAt(0) == "5") && (Hr(yr, yr.e + we + 2, 1), Dr = !yr.times(yr).eq(Jr));
                  break;
                }
          }
          return Hr(yr, yr.e + we + 1, Ce, Dr);
        }, He.toExponential = function(Dr, wr) {
          return Dr != null && (pe(Dr, 0, x), Dr++), Fr(this, Dr, wr, 1);
        }, He.toFixed = function(Dr, wr) {
          return Dr != null && (pe(Dr, 0, x), Dr = Dr + this.e + 1), Fr(this, Dr, wr);
        }, He.toFormat = function(Dr, wr, yr) {
          var Qr, _r = this;
          if (yr == null)
            Dr != null && wr && typeof wr == "object" ? (yr = wr, wr = null) : Dr && typeof Dr == "object" ? (yr = Dr, Dr = wr = null) : yr = fr;
          else if (typeof yr != "object")
            throw Error(m + "Argument not an object: " + yr);
          if (Qr = _r.toFixed(Dr, wr), _r.c) {
            var Jr, fn = Qr.split("."), jr = +yr.groupSize, dn = +yr.secondaryGroupSize, Tn = yr.groupSeparator || "", Yn = fn[0], si = fn[1], vn = _r.s < 0, Cn = vn ? Yn.slice(1) : Yn, Xr = Cn.length;
            if (dn && (Jr = jr, jr = dn, dn = Jr, Xr -= Jr), jr > 0 && Xr > 0) {
              for (Jr = Xr % jr || jr, Yn = Cn.substr(0, Jr); Jr < Xr; Jr += jr) Yn += Tn + Cn.substr(Jr, jr);
              dn > 0 && (Yn += Tn + Cn.slice(Jr)), vn && (Yn = "-" + Yn);
            }
            Qr = si ? Yn + (yr.decimalSeparator || "") + ((dn = +yr.fractionGroupSize) ? si.replace(
              new RegExp("\\d{" + dn + "}\\B", "g"),
              "$&" + (yr.fractionGroupSeparator || "")
            ) : si) : Yn;
          }
          return (yr.prefix || "") + Qr + (yr.suffix || "");
        }, He.toFraction = function(Dr) {
          var wr, yr, Qr, _r, Jr, fn, jr, dn, Tn, Yn, si, vn, Cn = this, Xr = Cn.c;
          if (Dr != null && (jr = new Br(Dr), !jr.isInteger() && (jr.c || jr.s !== 1) || jr.lt(ve)))
            throw Error(m + "Argument " + (jr.isInteger() ? "out of range: " : "not an integer: ") + un(jr));
          if (!Xr) return new Br(Cn);
          for (wr = new Br(ve), Tn = yr = new Br(ve), Qr = dn = new Br(ve), vn = le(Xr), Jr = wr.e = vn.length - Cn.e - 1, wr.c[0] = Q[(fn = Jr % C) < 0 ? C + fn : fn], Dr = !Dr || jr.comparedTo(wr) > 0 ? Jr > 0 ? wr : Tn : jr, fn = er, er = 1 / 0, jr = new Br(vn), dn.c[0] = 0; Yn = Qe(jr, wr, 0, 1), _r = yr.plus(Yn.times(Qr)), _r.comparedTo(Dr) != 1; )
            yr = Qr, Qr = _r, Tn = dn.plus(Yn.times(_r = Tn)), dn = _r, wr = jr.minus(Yn.times(_r = wr)), jr = _r;
          return _r = Qe(Dr.minus(yr), Qr, 0, 1), dn = dn.plus(_r.times(Tn)), yr = yr.plus(_r.times(Qr)), dn.s = Tn.s = Cn.s, Jr = Jr * 2, si = Qe(Tn, Qr, Jr, Ce).minus(Cn).abs().comparedTo(
            Qe(dn, yr, Jr, Ce).minus(Cn).abs()
          ) < 1 ? [Tn, Qr] : [dn, yr], er = fn, si;
        }, He.toNumber = function() {
          return +un(this);
        }, He.toPrecision = function(Dr, wr) {
          return Dr != null && pe(Dr, 1, x), Fr(this, Dr, wr, 2);
        }, He.toString = function(Dr) {
          var wr, yr = this, Qr = yr.s, _r = yr.e;
          return _r === null ? Qr ? (wr = "Infinity", Qr < 0 && (wr = "-" + wr)) : wr = "NaN" : (Dr == null ? wr = _r <= Se || _r >= Ne ? be(le(yr.c), _r) : Pe(le(yr.c), _r, "0") : Dr === 10 && br ? (yr = Hr(new Br(yr), we + _r + 1, Ce), wr = Pe(le(yr.c), yr.e, "0")) : (pe(Dr, 2, lr.length, "Base"), wr = xe(Pe(le(yr.c), _r, "0"), 10, Dr, Qr, !0)), Qr < 0 && yr.c[0] && (wr = "-" + wr)), wr;
        }, He.valueOf = He.toJSON = function() {
          return un(this);
        }, He._isBigNumber = !0, Te != null && Br.set(Te), Br;
      }
      function F(Te) {
        var Qe = Te | 0;
        return Te > 0 || Te === Qe ? Qe : Qe - 1;
      }
      function le(Te) {
        for (var Qe, xe, Ee = 1, He = Te.length, ve = Te[0] + ""; Ee < He; ) {
          for (Qe = Te[Ee++] + "", xe = C - Qe.length; xe--; Qe = "0" + Qe) ;
          ve += Qe;
        }
        for (He = ve.length; ve.charCodeAt(--He) === 48; ) ;
        return ve.slice(0, He + 1 || 1);
      }
      function ge(Te, Qe) {
        var xe, Ee, He = Te.c, ve = Qe.c, we = Te.s, Ce = Qe.s, Se = Te.e, Ne = Qe.e;
        if (!we || !Ce) return null;
        if (xe = He && !He[0], Ee = ve && !ve[0], xe || Ee) return xe ? Ee ? 0 : -Ce : we;
        if (we != Ce) return we;
        if (xe = we < 0, Ee = Se == Ne, !He || !ve) return Ee ? 0 : !He ^ xe ? 1 : -1;
        if (!Ee) return Se > Ne ^ xe ? 1 : -1;
        for (Ce = (Se = He.length) < (Ne = ve.length) ? Se : Ne, we = 0; we < Ce; we++) if (He[we] != ve[we]) return He[we] > ve[we] ^ xe ? 1 : -1;
        return Se == Ne ? 0 : Se > Ne ^ xe ? 1 : -1;
      }
      function pe(Te, Qe, xe, Ee) {
        if (Te < Qe || Te > xe || Te !== l(Te))
          throw Error(m + (Ee || "Argument") + (typeof Te == "number" ? Te < Qe || Te > xe ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(Te));
      }
      function Ie(Te) {
        var Qe = Te.c.length - 1;
        return F(Te.e / C) == Qe && Te.c[Qe] % 2 != 0;
      }
      function be(Te, Qe) {
        return (Te.length > 1 ? Te.charAt(0) + "." + Te.slice(1) : Te) + (Qe < 0 ? "e" : "e+") + Qe;
      }
      function Pe(Te, Qe, xe) {
        var Ee, He;
        if (Qe < 0) {
          for (He = xe + "."; ++Qe; He += xe) ;
          Te = He + Te;
        } else if (Ee = Te.length, ++Qe > Ee) {
          for (He = xe, Qe -= Ee; --Qe; He += xe) ;
          Te += He;
        } else Qe < Ee && (Te = Te.slice(0, Qe) + "." + Te.slice(Qe));
        return Te;
      }
      u = M(), u.default = u.BigNumber = u, s.exports ? s.exports = u : (A || (A = typeof self < "u" && self ? self : window), A.BigNumber = u);
    })(bignumber);
  }(bignumber$1)), bignumber$1.exports;
}
var jsbiUmd$1 = { exports: {} }, jsbiUmd = jsbiUmd$1.exports, hasRequiredJsbiUmd;
function requireJsbiUmd() {
  return hasRequiredJsbiUmd || (hasRequiredJsbiUmd = 1, function(s, A) {
    (function(u, p) {
      s.exports = p();
    })(jsbiUmd, function() {
      var u = Math.imul, p = Math.clz32, t = Math.abs, l = Math.max, m = Math.floor;
      class b extends Array {
        constructor(C, B) {
          if (super(C), this.sign = B, C > b.__kMaxLength) throw new RangeError("Maximum BigInt size exceeded");
        }
        static BigInt(C) {
          var B = Number.isFinite;
          if (typeof C == "number") {
            if (C === 0) return b.__zero();
            if (b.__isOneDigitInt(C)) return 0 > C ? b.__oneDigit(-C, !0) : b.__oneDigit(C, !1);
            if (!B(C) || m(C) !== C) throw new RangeError("The number " + C + " cannot be converted to BigInt because it is not an integer");
            return b.__fromDouble(C);
          }
          if (typeof C == "string") {
            const Q = b.__fromString(C);
            if (Q === null) throw new SyntaxError("Cannot convert " + C + " to a BigInt");
            return Q;
          }
          if (typeof C == "boolean") return C === !0 ? b.__oneDigit(1, !1) : b.__zero();
          if (typeof C == "object") {
            if (C.constructor === b) return C;
            const Q = b.__toPrimitive(C);
            return b.BigInt(Q);
          }
          throw new TypeError("Cannot convert " + C + " to a BigInt");
        }
        toDebugString() {
          const C = ["BigInt["];
          for (const B of this) C.push((B && (B >>> 0).toString(16)) + ", ");
          return C.push("]"), C.join("");
        }
        toString(C = 10) {
          if (2 > C || 36 < C) throw new RangeError("toString() radix argument must be between 2 and 36");
          return this.length === 0 ? "0" : (C & C - 1) == 0 ? b.__toStringBasePowerOfTwo(this, C) : b.__toStringGeneric(this, C, !1);
        }
        static toNumber(C) {
          const B = C.length;
          if (B === 0) return 0;
          if (B === 1) {
            const xe = C.__unsignedDigit(0);
            return C.sign ? -xe : xe;
          }
          const Q = C.__digit(B - 1), P = b.__clz30(Q), x = 30 * B - P;
          if (1024 < x) return C.sign ? -1 / 0 : 1 / 0;
          let M = x - 1, F = Q, le = B - 1;
          const ge = P + 3;
          let pe = ge === 32 ? 0 : F << ge;
          pe >>>= 12;
          const Ie = ge - 12;
          let be = 12 <= ge ? 0 : F << 20 + ge, Pe = 20 + ge;
          for (0 < Ie && 0 < le && (le--, F = C.__digit(le), pe |= F >>> 30 - Ie, be = F << Ie + 2, Pe = Ie + 2); 0 < Pe && 0 < le; ) le--, F = C.__digit(le), be |= 30 <= Pe ? F << Pe - 30 : F >>> 30 - Pe, Pe -= 30;
          const Te = b.__decideRounding(C, Pe, le, F);
          if ((Te === 1 || Te === 0 && (1 & be) == 1) && (be = be + 1 >>> 0, be === 0 && (pe++, pe >>> 20 != 0 && (pe = 0, M++, 1023 < M)))) return C.sign ? -1 / 0 : 1 / 0;
          const Qe = C.sign ? -2147483648 : 0;
          return M = M + 1023 << 20, b.__kBitConversionInts[1] = Qe | M | pe, b.__kBitConversionInts[0] = be, b.__kBitConversionDouble[0];
        }
        static unaryMinus(C) {
          if (C.length === 0) return C;
          const B = C.__copy();
          return B.sign = !C.sign, B;
        }
        static bitwiseNot(C) {
          return C.sign ? b.__absoluteSubOne(C).__trim() : b.__absoluteAddOne(C, !0);
        }
        static exponentiate(C, B) {
          if (B.sign) throw new RangeError("Exponent must be positive");
          if (B.length === 0) return b.__oneDigit(1, !1);
          if (C.length === 0) return C;
          if (C.length === 1 && C.__digit(0) === 1) return C.sign && (1 & B.__digit(0)) == 0 ? b.unaryMinus(C) : C;
          if (1 < B.length) throw new RangeError("BigInt too big");
          let Q = B.__unsignedDigit(0);
          if (Q === 1) return C;
          if (Q >= b.__kMaxLengthBits) throw new RangeError("BigInt too big");
          if (C.length === 1 && C.__digit(0) === 2) {
            const M = 1 + (0 | Q / 30), F = C.sign && (1 & Q) != 0, le = new b(M, F);
            le.__initializeDigits();
            const ge = 1 << Q % 30;
            return le.__setDigit(M - 1, ge), le;
          }
          let P = null, x = C;
          for ((1 & Q) != 0 && (P = C), Q >>= 1; Q !== 0; Q >>= 1) x = b.multiply(x, x), (1 & Q) != 0 && (P === null ? P = x : P = b.multiply(P, x));
          return P;
        }
        static multiply(C, B) {
          if (C.length === 0) return C;
          if (B.length === 0) return B;
          let Q = C.length + B.length;
          30 <= C.__clzmsd() + B.__clzmsd() && Q--;
          const P = new b(Q, C.sign !== B.sign);
          P.__initializeDigits();
          for (let x = 0; x < C.length; x++) b.__multiplyAccumulate(B, C.__digit(x), P, x);
          return P.__trim();
        }
        static divide(C, B) {
          if (B.length === 0) throw new RangeError("Division by zero");
          if (0 > b.__absoluteCompare(C, B)) return b.__zero();
          const Q = C.sign !== B.sign, P = B.__unsignedDigit(0);
          let x;
          if (B.length === 1 && 32767 >= P) {
            if (P === 1) return Q === C.sign ? C : b.unaryMinus(C);
            x = b.__absoluteDivSmall(C, P, null);
          } else x = b.__absoluteDivLarge(C, B, !0, !1);
          return x.sign = Q, x.__trim();
        }
        static remainder(C, B) {
          if (B.length === 0) throw new RangeError("Division by zero");
          if (0 > b.__absoluteCompare(C, B)) return C;
          const Q = B.__unsignedDigit(0);
          if (B.length === 1 && 32767 >= Q) {
            if (Q === 1) return b.__zero();
            const x = b.__absoluteModSmall(C, Q);
            return x === 0 ? b.__zero() : b.__oneDigit(x, C.sign);
          }
          const P = b.__absoluteDivLarge(C, B, !1, !0);
          return P.sign = C.sign, P.__trim();
        }
        static add(C, B) {
          const Q = C.sign;
          return Q === B.sign ? b.__absoluteAdd(C, B, Q) : 0 <= b.__absoluteCompare(C, B) ? b.__absoluteSub(C, B, Q) : b.__absoluteSub(B, C, !Q);
        }
        static subtract(C, B) {
          const Q = C.sign;
          return Q === B.sign ? 0 <= b.__absoluteCompare(C, B) ? b.__absoluteSub(C, B, Q) : b.__absoluteSub(B, C, !Q) : b.__absoluteAdd(C, B, Q);
        }
        static leftShift(C, B) {
          return B.length === 0 || C.length === 0 ? C : B.sign ? b.__rightShiftByAbsolute(C, B) : b.__leftShiftByAbsolute(C, B);
        }
        static signedRightShift(C, B) {
          return B.length === 0 || C.length === 0 ? C : B.sign ? b.__leftShiftByAbsolute(C, B) : b.__rightShiftByAbsolute(C, B);
        }
        static unsignedRightShift() {
          throw new TypeError("BigInts have no unsigned right shift; use >> instead");
        }
        static lessThan(C, B) {
          return 0 > b.__compareToBigInt(C, B);
        }
        static lessThanOrEqual(C, B) {
          return 0 >= b.__compareToBigInt(C, B);
        }
        static greaterThan(C, B) {
          return 0 < b.__compareToBigInt(C, B);
        }
        static greaterThanOrEqual(C, B) {
          return 0 <= b.__compareToBigInt(C, B);
        }
        static equal(C, B) {
          if (C.sign !== B.sign || C.length !== B.length) return !1;
          for (let Q = 0; Q < C.length; Q++) if (C.__digit(Q) !== B.__digit(Q)) return !1;
          return !0;
        }
        static notEqual(C, B) {
          return !b.equal(C, B);
        }
        static bitwiseAnd(C, B) {
          if (!C.sign && !B.sign) return b.__absoluteAnd(C, B).__trim();
          if (C.sign && B.sign) {
            const Q = l(C.length, B.length) + 1;
            let P = b.__absoluteSubOne(C, Q);
            const x = b.__absoluteSubOne(B);
            return P = b.__absoluteOr(P, x, P), b.__absoluteAddOne(P, !0, P).__trim();
          }
          return C.sign && ([C, B] = [B, C]), b.__absoluteAndNot(C, b.__absoluteSubOne(B)).__trim();
        }
        static bitwiseXor(C, B) {
          if (!C.sign && !B.sign) return b.__absoluteXor(C, B).__trim();
          if (C.sign && B.sign) {
            const x = l(C.length, B.length), M = b.__absoluteSubOne(C, x), F = b.__absoluteSubOne(B);
            return b.__absoluteXor(M, F, M).__trim();
          }
          const Q = l(C.length, B.length) + 1;
          C.sign && ([C, B] = [B, C]);
          let P = b.__absoluteSubOne(B, Q);
          return P = b.__absoluteXor(P, C, P), b.__absoluteAddOne(P, !0, P).__trim();
        }
        static bitwiseOr(C, B) {
          const Q = l(C.length, B.length);
          if (!C.sign && !B.sign) return b.__absoluteOr(C, B).__trim();
          if (C.sign && B.sign) {
            let x = b.__absoluteSubOne(C, Q);
            const M = b.__absoluteSubOne(B);
            return x = b.__absoluteAnd(x, M, x), b.__absoluteAddOne(x, !0, x).__trim();
          }
          C.sign && ([C, B] = [B, C]);
          let P = b.__absoluteSubOne(B, Q);
          return P = b.__absoluteAndNot(P, C, P), b.__absoluteAddOne(P, !0, P).__trim();
        }
        static asIntN(C, B) {
          if (B.length === 0) return B;
          if (C = m(C), 0 > C) throw new RangeError("Invalid value: not (convertible to) a safe integer");
          if (C === 0) return b.__zero();
          if (C >= b.__kMaxLengthBits) return B;
          const Q = 0 | (C + 29) / 30;
          if (B.length < Q) return B;
          const P = B.__unsignedDigit(Q - 1), x = 1 << (C - 1) % 30;
          if (B.length === Q && P < x) return B;
          if ((P & x) !== x) return b.__truncateToNBits(C, B);
          if (!B.sign) return b.__truncateAndSubFromPowerOfTwo(C, B, !0);
          if ((P & x - 1) == 0) {
            for (let M = Q - 2; 0 <= M; M--) if (B.__digit(M) !== 0) return b.__truncateAndSubFromPowerOfTwo(C, B, !1);
            return B.length === Q && P === x ? B : b.__truncateToNBits(C, B);
          }
          return b.__truncateAndSubFromPowerOfTwo(C, B, !1);
        }
        static asUintN(C, B) {
          if (B.length === 0) return B;
          if (C = m(C), 0 > C) throw new RangeError("Invalid value: not (convertible to) a safe integer");
          if (C === 0) return b.__zero();
          if (B.sign) {
            if (C > b.__kMaxLengthBits) throw new RangeError("BigInt too big");
            return b.__truncateAndSubFromPowerOfTwo(C, B, !1);
          }
          if (C >= b.__kMaxLengthBits) return B;
          const Q = 0 | (C + 29) / 30;
          if (B.length < Q) return B;
          const P = C % 30;
          return B.length == Q && (P === 0 || !(B.__digit(Q - 1) >>> P)) ? B : b.__truncateToNBits(C, B);
        }
        static ADD(C, B) {
          if (C = b.__toPrimitive(C), B = b.__toPrimitive(B), typeof C == "string") return typeof B != "string" && (B = B.toString()), C + B;
          if (typeof B == "string") return C.toString() + B;
          if (C = b.__toNumeric(C), B = b.__toNumeric(B), b.__isBigInt(C) && b.__isBigInt(B)) return b.add(C, B);
          if (typeof C == "number" && typeof B == "number") return C + B;
          throw new TypeError("Cannot mix BigInt and other types, use explicit conversions");
        }
        static LT(C, B) {
          return b.__compare(C, B, 0);
        }
        static LE(C, B) {
          return b.__compare(C, B, 1);
        }
        static GT(C, B) {
          return b.__compare(C, B, 2);
        }
        static GE(C, B) {
          return b.__compare(C, B, 3);
        }
        static EQ(C, B) {
          for (; ; ) {
            if (b.__isBigInt(C)) return b.__isBigInt(B) ? b.equal(C, B) : b.EQ(B, C);
            if (typeof C == "number") {
              if (b.__isBigInt(B)) return b.__equalToNumber(B, C);
              if (typeof B != "object") return C == B;
              B = b.__toPrimitive(B);
            } else if (typeof C == "string") {
              if (b.__isBigInt(B)) return C = b.__fromString(C), C !== null && b.equal(C, B);
              if (typeof B != "object") return C == B;
              B = b.__toPrimitive(B);
            } else if (typeof C == "boolean") {
              if (b.__isBigInt(B)) return b.__equalToNumber(B, +C);
              if (typeof B != "object") return C == B;
              B = b.__toPrimitive(B);
            } else if (typeof C == "symbol") {
              if (b.__isBigInt(B)) return !1;
              if (typeof B != "object") return C == B;
              B = b.__toPrimitive(B);
            } else if (typeof C == "object") {
              if (typeof B == "object" && B.constructor !== b) return C == B;
              C = b.__toPrimitive(C);
            } else return C == B;
          }
        }
        static NE(C, B) {
          return !b.EQ(C, B);
        }
        static __zero() {
          return new b(0, !1);
        }
        static __oneDigit(C, B) {
          const Q = new b(1, B);
          return Q.__setDigit(0, C), Q;
        }
        __copy() {
          const C = new b(this.length, this.sign);
          for (let B = 0; B < this.length; B++) C[B] = this[B];
          return C;
        }
        __trim() {
          let C = this.length, B = this[C - 1];
          for (; B === 0; ) C--, B = this[C - 1], this.pop();
          return C === 0 && (this.sign = !1), this;
        }
        __initializeDigits() {
          for (let C = 0; C < this.length; C++) this[C] = 0;
        }
        static __decideRounding(C, B, Q, P) {
          if (0 < B) return -1;
          let x;
          if (0 > B) x = -B - 1;
          else {
            if (Q === 0) return -1;
            Q--, P = C.__digit(Q), x = 29;
          }
          let M = 1 << x;
          if ((P & M) == 0) return -1;
          if (M -= 1, (P & M) != 0) return 1;
          for (; 0 < Q; ) if (Q--, C.__digit(Q) !== 0) return 1;
          return 0;
        }
        static __fromDouble(C) {
          b.__kBitConversionDouble[0] = C;
          const B = 2047 & b.__kBitConversionInts[1] >>> 20, Q = B - 1023, P = (0 | Q / 30) + 1, x = new b(P, 0 > C);
          let M = 1048575 & b.__kBitConversionInts[1] | 1048576, F = b.__kBitConversionInts[0];
          const le = 20, ge = Q % 30;
          let pe, Ie = 0;
          if (20 > ge) {
            const be = le - ge;
            Ie = be + 32, pe = M >>> be, M = M << 32 - be | F >>> be, F <<= 32 - be;
          } else if (ge === 20) Ie = 32, pe = M, M = F, F = 0;
          else {
            const be = ge - le;
            Ie = 32 - be, pe = M << be | F >>> 32 - be, M = F << be, F = 0;
          }
          x.__setDigit(P - 1, pe);
          for (let be = P - 2; 0 <= be; be--) 0 < Ie ? (Ie -= 30, pe = M >>> 2, M = M << 30 | F >>> 2, F <<= 30) : pe = 0, x.__setDigit(be, pe);
          return x.__trim();
        }
        static __isWhitespace(C) {
          return 13 >= C && 9 <= C || (159 >= C ? C == 32 : 131071 >= C ? C == 160 || C == 5760 : 196607 >= C ? (C &= 131071, 10 >= C || C == 40 || C == 41 || C == 47 || C == 95 || C == 4096) : C == 65279);
        }
        static __fromString(C, B = 0) {
          let Q = 0;
          const P = C.length;
          let x = 0;
          if (x === P) return b.__zero();
          let M = C.charCodeAt(x);
          for (; b.__isWhitespace(M); ) {
            if (++x === P) return b.__zero();
            M = C.charCodeAt(x);
          }
          if (M === 43) {
            if (++x === P) return null;
            M = C.charCodeAt(x), Q = 1;
          } else if (M === 45) {
            if (++x === P) return null;
            M = C.charCodeAt(x), Q = -1;
          }
          if (B === 0) {
            if (B = 10, M === 48) {
              if (++x === P) return b.__zero();
              if (M = C.charCodeAt(x), M === 88 || M === 120) {
                if (B = 16, ++x === P) return null;
                M = C.charCodeAt(x);
              } else if (M === 79 || M === 111) {
                if (B = 8, ++x === P) return null;
                M = C.charCodeAt(x);
              } else if (M === 66 || M === 98) {
                if (B = 2, ++x === P) return null;
                M = C.charCodeAt(x);
              }
            }
          } else if (B === 16 && M === 48) {
            if (++x === P) return b.__zero();
            if (M = C.charCodeAt(x), M === 88 || M === 120) {
              if (++x === P) return null;
              M = C.charCodeAt(x);
            }
          }
          if (Q != 0 && B !== 10) return null;
          for (; M === 48; ) {
            if (++x === P) return b.__zero();
            M = C.charCodeAt(x);
          }
          const F = P - x;
          let le = b.__kMaxBitsPerChar[B], ge = b.__kBitsPerCharTableMultiplier - 1;
          if (F > 1073741824 / le) return null;
          const pe = le * F + ge >>> b.__kBitsPerCharTableShift, Ie = new b(0 | (pe + 29) / 30, !1), be = 10 > B ? B : 10, Pe = 10 < B ? B - 10 : 0;
          if ((B & B - 1) == 0) {
            le >>= b.__kBitsPerCharTableShift;
            const Te = [], Qe = [];
            let xe = !1;
            do {
              let Ee = 0, He = 0;
              for (; ; ) {
                let ve;
                if (M - 48 >>> 0 < be) ve = M - 48;
                else if ((32 | M) - 97 >>> 0 < Pe) ve = (32 | M) - 87;
                else {
                  xe = !0;
                  break;
                }
                if (He += le, Ee = Ee << le | ve, ++x === P) {
                  xe = !0;
                  break;
                }
                if (M = C.charCodeAt(x), 30 < He + le) break;
              }
              Te.push(Ee), Qe.push(He);
            } while (!xe);
            b.__fillFromParts(Ie, Te, Qe);
          } else {
            Ie.__initializeDigits();
            let Te = !1, Qe = 0;
            do {
              let xe = 0, Ee = 1;
              for (; ; ) {
                let ve;
                if (M - 48 >>> 0 < be) ve = M - 48;
                else if ((32 | M) - 97 >>> 0 < Pe) ve = (32 | M) - 87;
                else {
                  Te = !0;
                  break;
                }
                const we = Ee * B;
                if (1073741823 < we) break;
                if (Ee = we, xe = xe * B + ve, Qe++, ++x === P) {
                  Te = !0;
                  break;
                }
                M = C.charCodeAt(x);
              }
              ge = 30 * b.__kBitsPerCharTableMultiplier - 1;
              const He = 0 | (le * Qe + ge >>> b.__kBitsPerCharTableShift) / 30;
              Ie.__inplaceMultiplyAdd(Ee, xe, He);
            } while (!Te);
          }
          if (x !== P) {
            if (!b.__isWhitespace(M)) return null;
            for (x++; x < P; x++) if (M = C.charCodeAt(x), !b.__isWhitespace(M)) return null;
          }
          return Ie.sign = Q == -1, Ie.__trim();
        }
        static __fillFromParts(C, B, Q) {
          let P = 0, x = 0, M = 0;
          for (let F = B.length - 1; 0 <= F; F--) {
            const le = B[F], ge = Q[F];
            x |= le << M, M += ge, M === 30 ? (C.__setDigit(P++, x), M = 0, x = 0) : 30 < M && (C.__setDigit(P++, 1073741823 & x), M -= 30, x = le >>> ge - M);
          }
          if (x !== 0) {
            if (P >= C.length) throw new Error("implementation bug");
            C.__setDigit(P++, x);
          }
          for (; P < C.length; P++) C.__setDigit(P, 0);
        }
        static __toStringBasePowerOfTwo(C, B) {
          const Q = C.length;
          let P = B - 1;
          P = (85 & P >>> 1) + (85 & P), P = (51 & P >>> 2) + (51 & P), P = (15 & P >>> 4) + (15 & P);
          const x = P, M = B - 1, F = C.__digit(Q - 1), le = b.__clz30(F);
          let ge = 0 | (30 * Q - le + x - 1) / x;
          if (C.sign && ge++, 268435456 < ge) throw new Error("string too long");
          const pe = Array(ge);
          let Ie = ge - 1, be = 0, Pe = 0;
          for (let Qe = 0; Qe < Q - 1; Qe++) {
            const xe = C.__digit(Qe), Ee = (be | xe << Pe) & M;
            pe[Ie--] = b.__kConversionChars[Ee];
            const He = x - Pe;
            for (be = xe >>> He, Pe = 30 - He; Pe >= x; ) pe[Ie--] = b.__kConversionChars[be & M], be >>>= x, Pe -= x;
          }
          const Te = (be | F << Pe) & M;
          for (pe[Ie--] = b.__kConversionChars[Te], be = F >>> x - Pe; be !== 0; ) pe[Ie--] = b.__kConversionChars[be & M], be >>>= x;
          if (C.sign && (pe[Ie--] = "-"), Ie != -1) throw new Error("implementation bug");
          return pe.join("");
        }
        static __toStringGeneric(C, B, Q) {
          const P = C.length;
          if (P === 0) return "";
          if (P === 1) {
            let Qe = C.__unsignedDigit(0).toString(B);
            return Q === !1 && C.sign && (Qe = "-" + Qe), Qe;
          }
          const x = 30 * P - b.__clz30(C.__digit(P - 1)), M = b.__kMaxBitsPerChar[B], F = M - 1;
          let le = x * b.__kBitsPerCharTableMultiplier;
          le += F - 1, le = 0 | le / F;
          const ge = le + 1 >> 1, pe = b.exponentiate(b.__oneDigit(B, !1), b.__oneDigit(ge, !1));
          let Ie, be;
          const Pe = pe.__unsignedDigit(0);
          if (pe.length === 1 && 32767 >= Pe) {
            Ie = new b(C.length, !1), Ie.__initializeDigits();
            let Qe = 0;
            for (let xe = 2 * C.length - 1; 0 <= xe; xe--) {
              const Ee = Qe << 15 | C.__halfDigit(xe);
              Ie.__setHalfDigit(xe, 0 | Ee / Pe), Qe = 0 | Ee % Pe;
            }
            be = Qe.toString(B);
          } else {
            const Qe = b.__absoluteDivLarge(C, pe, !0, !0);
            Ie = Qe.quotient;
            const xe = Qe.remainder.__trim();
            be = b.__toStringGeneric(xe, B, !0);
          }
          Ie.__trim();
          let Te = b.__toStringGeneric(Ie, B, !0);
          for (; be.length < ge; ) be = "0" + be;
          return Q === !1 && C.sign && (Te = "-" + Te), Te + be;
        }
        static __unequalSign(C) {
          return C ? -1 : 1;
        }
        static __absoluteGreater(C) {
          return C ? -1 : 1;
        }
        static __absoluteLess(C) {
          return C ? 1 : -1;
        }
        static __compareToBigInt(C, B) {
          const Q = C.sign;
          if (Q !== B.sign) return b.__unequalSign(Q);
          const P = b.__absoluteCompare(C, B);
          return 0 < P ? b.__absoluteGreater(Q) : 0 > P ? b.__absoluteLess(Q) : 0;
        }
        static __compareToNumber(C, B) {
          if (b.__isOneDigitInt(B)) {
            const Q = C.sign, P = 0 > B;
            if (Q !== P) return b.__unequalSign(Q);
            if (C.length === 0) {
              if (P) throw new Error("implementation bug");
              return B === 0 ? 0 : -1;
            }
            if (1 < C.length) return b.__absoluteGreater(Q);
            const x = t(B), M = C.__unsignedDigit(0);
            return M > x ? b.__absoluteGreater(Q) : M < x ? b.__absoluteLess(Q) : 0;
          }
          return b.__compareToDouble(C, B);
        }
        static __compareToDouble(C, B) {
          if (B !== B) return B;
          if (B === 1 / 0) return -1;
          if (B === -1 / 0) return 1;
          const Q = C.sign;
          if (Q !== 0 > B) return b.__unequalSign(Q);
          if (B === 0) throw new Error("implementation bug: should be handled elsewhere");
          if (C.length === 0) return -1;
          b.__kBitConversionDouble[0] = B;
          const P = 2047 & b.__kBitConversionInts[1] >>> 20;
          if (P == 2047) throw new Error("implementation bug: handled elsewhere");
          const x = P - 1023;
          if (0 > x) return b.__absoluteGreater(Q);
          const M = C.length;
          let F = C.__digit(M - 1);
          const le = b.__clz30(F), ge = 30 * M - le, pe = x + 1;
          if (ge < pe) return b.__absoluteLess(Q);
          if (ge > pe) return b.__absoluteGreater(Q);
          let Ie = 1048576 | 1048575 & b.__kBitConversionInts[1], be = b.__kBitConversionInts[0];
          const Pe = 20, Te = 29 - le;
          if (Te !== (0 | (ge - 1) % 30)) throw new Error("implementation bug");
          let Qe, xe = 0;
          if (20 > Te) {
            const Ee = Pe - Te;
            xe = Ee + 32, Qe = Ie >>> Ee, Ie = Ie << 32 - Ee | be >>> Ee, be <<= 32 - Ee;
          } else if (Te === 20) xe = 32, Qe = Ie, Ie = be, be = 0;
          else {
            const Ee = Te - Pe;
            xe = 32 - Ee, Qe = Ie << Ee | be >>> 32 - Ee, Ie = be << Ee, be = 0;
          }
          if (F >>>= 0, Qe >>>= 0, F > Qe) return b.__absoluteGreater(Q);
          if (F < Qe) return b.__absoluteLess(Q);
          for (let Ee = M - 2; 0 <= Ee; Ee--) {
            0 < xe ? (xe -= 30, Qe = Ie >>> 2, Ie = Ie << 30 | be >>> 2, be <<= 30) : Qe = 0;
            const He = C.__unsignedDigit(Ee);
            if (He > Qe) return b.__absoluteGreater(Q);
            if (He < Qe) return b.__absoluteLess(Q);
          }
          if (Ie !== 0 || be !== 0) {
            if (xe === 0) throw new Error("implementation bug");
            return b.__absoluteLess(Q);
          }
          return 0;
        }
        static __equalToNumber(C, B) {
          return b.__isOneDigitInt(B) ? B === 0 ? C.length === 0 : C.length === 1 && C.sign === 0 > B && C.__unsignedDigit(0) === t(B) : b.__compareToDouble(C, B) === 0;
        }
        static __comparisonResultToBool(C, B) {
          return B === 0 ? 0 > C : B === 1 ? 0 >= C : B === 2 ? 0 < C : B === 3 ? 0 <= C : void 0;
        }
        static __compare(C, B, Q) {
          if (C = b.__toPrimitive(C), B = b.__toPrimitive(B), typeof C == "string" && typeof B == "string") switch (Q) {
            case 0:
              return C < B;
            case 1:
              return C <= B;
            case 2:
              return C > B;
            case 3:
              return C >= B;
          }
          if (b.__isBigInt(C) && typeof B == "string") return B = b.__fromString(B), B !== null && b.__comparisonResultToBool(b.__compareToBigInt(C, B), Q);
          if (typeof C == "string" && b.__isBigInt(B)) return C = b.__fromString(C), C !== null && b.__comparisonResultToBool(b.__compareToBigInt(C, B), Q);
          if (C = b.__toNumeric(C), B = b.__toNumeric(B), b.__isBigInt(C)) {
            if (b.__isBigInt(B)) return b.__comparisonResultToBool(b.__compareToBigInt(C, B), Q);
            if (typeof B != "number") throw new Error("implementation bug");
            return b.__comparisonResultToBool(b.__compareToNumber(C, B), Q);
          }
          if (typeof C != "number") throw new Error("implementation bug");
          if (b.__isBigInt(B)) return b.__comparisonResultToBool(b.__compareToNumber(B, C), 2 ^ Q);
          if (typeof B != "number") throw new Error("implementation bug");
          return Q === 0 ? C < B : Q === 1 ? C <= B : Q === 2 ? C > B : Q === 3 ? C >= B : void 0;
        }
        __clzmsd() {
          return b.__clz30(this.__digit(this.length - 1));
        }
        static __absoluteAdd(C, B, Q) {
          if (C.length < B.length) return b.__absoluteAdd(B, C, Q);
          if (C.length === 0) return C;
          if (B.length === 0) return C.sign === Q ? C : b.unaryMinus(C);
          let P = C.length;
          (C.__clzmsd() === 0 || B.length === C.length && B.__clzmsd() === 0) && P++;
          const x = new b(P, Q);
          let M = 0, F = 0;
          for (; F < B.length; F++) {
            const le = C.__digit(F) + B.__digit(F) + M;
            M = le >>> 30, x.__setDigit(F, 1073741823 & le);
          }
          for (; F < C.length; F++) {
            const le = C.__digit(F) + M;
            M = le >>> 30, x.__setDigit(F, 1073741823 & le);
          }
          return F < x.length && x.__setDigit(F, M), x.__trim();
        }
        static __absoluteSub(C, B, Q) {
          if (C.length === 0) return C;
          if (B.length === 0) return C.sign === Q ? C : b.unaryMinus(C);
          const P = new b(C.length, Q);
          let x = 0, M = 0;
          for (; M < B.length; M++) {
            const F = C.__digit(M) - B.__digit(M) - x;
            x = 1 & F >>> 30, P.__setDigit(M, 1073741823 & F);
          }
          for (; M < C.length; M++) {
            const F = C.__digit(M) - x;
            x = 1 & F >>> 30, P.__setDigit(M, 1073741823 & F);
          }
          return P.__trim();
        }
        static __absoluteAddOne(C, B, Q = null) {
          const P = C.length;
          Q === null ? Q = new b(P, B) : Q.sign = B;
          let x = 1;
          for (let M = 0; M < P; M++) {
            const F = C.__digit(M) + x;
            x = F >>> 30, Q.__setDigit(M, 1073741823 & F);
          }
          return x != 0 && Q.__setDigitGrow(P, 1), Q;
        }
        static __absoluteSubOne(C, B) {
          const Q = C.length;
          B = B || Q;
          const P = new b(B, !1);
          let x = 1;
          for (let M = 0; M < Q; M++) {
            const F = C.__digit(M) - x;
            x = 1 & F >>> 30, P.__setDigit(M, 1073741823 & F);
          }
          if (x != 0) throw new Error("implementation bug");
          for (let M = Q; M < B; M++) P.__setDigit(M, 0);
          return P;
        }
        static __absoluteAnd(C, B, Q = null) {
          let P = C.length, x = B.length, M = x;
          if (P < x) {
            M = P;
            const ge = C, pe = P;
            C = B, P = x, B = ge, x = pe;
          }
          let F = M;
          Q === null ? Q = new b(F, !1) : F = Q.length;
          let le = 0;
          for (; le < M; le++) Q.__setDigit(le, C.__digit(le) & B.__digit(le));
          for (; le < F; le++) Q.__setDigit(le, 0);
          return Q;
        }
        static __absoluteAndNot(C, B, Q = null) {
          const P = C.length, x = B.length;
          let M = x;
          P < x && (M = P);
          let F = P;
          Q === null ? Q = new b(F, !1) : F = Q.length;
          let le = 0;
          for (; le < M; le++) Q.__setDigit(le, C.__digit(le) & ~B.__digit(le));
          for (; le < P; le++) Q.__setDigit(le, C.__digit(le));
          for (; le < F; le++) Q.__setDigit(le, 0);
          return Q;
        }
        static __absoluteOr(C, B, Q = null) {
          let P = C.length, x = B.length, M = x;
          if (P < x) {
            M = P;
            const ge = C, pe = P;
            C = B, P = x, B = ge, x = pe;
          }
          let F = P;
          Q === null ? Q = new b(F, !1) : F = Q.length;
          let le = 0;
          for (; le < M; le++) Q.__setDigit(le, C.__digit(le) | B.__digit(le));
          for (; le < P; le++) Q.__setDigit(le, C.__digit(le));
          for (; le < F; le++) Q.__setDigit(le, 0);
          return Q;
        }
        static __absoluteXor(C, B, Q = null) {
          let P = C.length, x = B.length, M = x;
          if (P < x) {
            M = P;
            const ge = C, pe = P;
            C = B, P = x, B = ge, x = pe;
          }
          let F = P;
          Q === null ? Q = new b(F, !1) : F = Q.length;
          let le = 0;
          for (; le < M; le++) Q.__setDigit(le, C.__digit(le) ^ B.__digit(le));
          for (; le < P; le++) Q.__setDigit(le, C.__digit(le));
          for (; le < F; le++) Q.__setDigit(le, 0);
          return Q;
        }
        static __absoluteCompare(C, B) {
          const Q = C.length - B.length;
          if (Q != 0) return Q;
          let P = C.length - 1;
          for (; 0 <= P && C.__digit(P) === B.__digit(P); ) P--;
          return 0 > P ? 0 : C.__unsignedDigit(P) > B.__unsignedDigit(P) ? 1 : -1;
        }
        static __multiplyAccumulate(C, B, Q, P) {
          if (B === 0) return;
          const x = 32767 & B, M = B >>> 15;
          let F = 0, le = 0;
          for (let ge, pe = 0; pe < C.length; pe++, P++) {
            ge = Q.__digit(P);
            const Ie = C.__digit(pe), be = 32767 & Ie, Pe = Ie >>> 15, Te = b.__imul(be, x), Qe = b.__imul(be, M), xe = b.__imul(Pe, x), Ee = b.__imul(Pe, M);
            ge += le + Te + F, F = ge >>> 30, ge &= 1073741823, ge += ((32767 & Qe) << 15) + ((32767 & xe) << 15), F += ge >>> 30, le = Ee + (Qe >>> 15) + (xe >>> 15), Q.__setDigit(P, 1073741823 & ge);
          }
          for (; F != 0 || le !== 0; P++) {
            let ge = Q.__digit(P);
            ge += F + le, le = 0, F = ge >>> 30, Q.__setDigit(P, 1073741823 & ge);
          }
        }
        static __internalMultiplyAdd(C, B, Q, P, x) {
          let M = Q, F = 0;
          for (let le = 0; le < P; le++) {
            const ge = C.__digit(le), pe = b.__imul(32767 & ge, B), Ie = b.__imul(ge >>> 15, B), be = pe + ((32767 & Ie) << 15) + F + M;
            M = be >>> 30, F = Ie >>> 15, x.__setDigit(le, 1073741823 & be);
          }
          if (x.length > P) for (x.__setDigit(P++, M + F); P < x.length; ) x.__setDigit(P++, 0);
          else if (M + F !== 0) throw new Error("implementation bug");
        }
        __inplaceMultiplyAdd(C, B, Q) {
          Q > this.length && (Q = this.length);
          const P = 32767 & C, x = C >>> 15;
          let M = 0, F = B;
          for (let le = 0; le < Q; le++) {
            const ge = this.__digit(le), pe = 32767 & ge, Ie = ge >>> 15, be = b.__imul(pe, P), Pe = b.__imul(pe, x), Te = b.__imul(Ie, P), Qe = b.__imul(Ie, x);
            let xe = F + be + M;
            M = xe >>> 30, xe &= 1073741823, xe += ((32767 & Pe) << 15) + ((32767 & Te) << 15), M += xe >>> 30, F = Qe + (Pe >>> 15) + (Te >>> 15), this.__setDigit(le, 1073741823 & xe);
          }
          if (M != 0 || F !== 0) throw new Error("implementation bug");
        }
        static __absoluteDivSmall(C, B, Q = null) {
          Q === null && (Q = new b(C.length, !1));
          let P = 0;
          for (let x, M = 2 * C.length - 1; 0 <= M; M -= 2) {
            x = (P << 15 | C.__halfDigit(M)) >>> 0;
            const F = 0 | x / B;
            P = 0 | x % B, x = (P << 15 | C.__halfDigit(M - 1)) >>> 0;
            const le = 0 | x / B;
            P = 0 | x % B, Q.__setDigit(M >>> 1, F << 15 | le);
          }
          return Q;
        }
        static __absoluteModSmall(C, B) {
          let Q = 0;
          for (let P = 2 * C.length - 1; 0 <= P; P--)
            Q = 0 | ((Q << 15 | C.__halfDigit(P)) >>> 0) % B;
          return Q;
        }
        static __absoluteDivLarge(C, B, Q, P) {
          const x = B.__halfDigitLength(), M = B.length, F = C.__halfDigitLength() - x;
          let le = null;
          Q && (le = new b(F + 2 >>> 1, !1), le.__initializeDigits());
          const ge = new b(x + 2 >>> 1, !1);
          ge.__initializeDigits();
          const pe = b.__clz15(B.__halfDigit(x - 1));
          0 < pe && (B = b.__specialLeftShift(B, pe, 0));
          const Ie = b.__specialLeftShift(C, pe, 1), be = B.__halfDigit(x - 1);
          let Pe = 0;
          for (let Te, Qe = F; 0 <= Qe; Qe--) {
            Te = 32767;
            const xe = Ie.__halfDigit(Qe + x);
            if (xe !== be) {
              const He = (xe << 15 | Ie.__halfDigit(Qe + x - 1)) >>> 0;
              Te = 0 | He / be;
              let ve = 0 | He % be;
              const we = B.__halfDigit(x - 2), Ce = Ie.__halfDigit(Qe + x - 2);
              for (; b.__imul(Te, we) >>> 0 > (ve << 16 | Ce) >>> 0 && (Te--, ve += be, !(32767 < ve)); ) ;
            }
            b.__internalMultiplyAdd(B, Te, 0, M, ge);
            let Ee = Ie.__inplaceSub(ge, Qe, x + 1);
            Ee !== 0 && (Ee = Ie.__inplaceAdd(B, Qe, x), Ie.__setHalfDigit(Qe + x, 32767 & Ie.__halfDigit(Qe + x) + Ee), Te--), Q && (1 & Qe ? Pe = Te << 15 : le.__setDigit(Qe >>> 1, Pe | Te));
          }
          if (P) return Ie.__inplaceRightShift(pe), Q ? { quotient: le, remainder: Ie } : Ie;
          if (Q) return le;
          throw new Error("unreachable");
        }
        static __clz15(C) {
          return b.__clz30(C) - 15;
        }
        __inplaceAdd(C, B, Q) {
          let P = 0;
          for (let x = 0; x < Q; x++) {
            const M = this.__halfDigit(B + x) + C.__halfDigit(x) + P;
            P = M >>> 15, this.__setHalfDigit(B + x, 32767 & M);
          }
          return P;
        }
        __inplaceSub(C, B, Q) {
          let P = 0;
          if (1 & B) {
            B >>= 1;
            let x = this.__digit(B), M = 32767 & x, F = 0;
            for (; F < Q - 1 >>> 1; F++) {
              const pe = C.__digit(F), Ie = (x >>> 15) - (32767 & pe) - P;
              P = 1 & Ie >>> 15, this.__setDigit(B + F, (32767 & Ie) << 15 | 32767 & M), x = this.__digit(B + F + 1), M = (32767 & x) - (pe >>> 15) - P, P = 1 & M >>> 15;
            }
            const le = C.__digit(F), ge = (x >>> 15) - (32767 & le) - P;
            if (P = 1 & ge >>> 15, this.__setDigit(B + F, (32767 & ge) << 15 | 32767 & M), B + F + 1 >= this.length) throw new RangeError("out of bounds");
            (1 & Q) == 0 && (x = this.__digit(B + F + 1), M = (32767 & x) - (le >>> 15) - P, P = 1 & M >>> 15, this.__setDigit(B + C.length, 1073709056 & x | 32767 & M));
          } else {
            B >>= 1;
            let x = 0;
            for (; x < C.length - 1; x++) {
              const pe = this.__digit(B + x), Ie = C.__digit(x), be = (32767 & pe) - (32767 & Ie) - P;
              P = 1 & be >>> 15;
              const Pe = (pe >>> 15) - (Ie >>> 15) - P;
              P = 1 & Pe >>> 15, this.__setDigit(B + x, (32767 & Pe) << 15 | 32767 & be);
            }
            const M = this.__digit(B + x), F = C.__digit(x), le = (32767 & M) - (32767 & F) - P;
            P = 1 & le >>> 15;
            let ge = 0;
            (1 & Q) == 0 && (ge = (M >>> 15) - (F >>> 15) - P, P = 1 & ge >>> 15), this.__setDigit(B + x, (32767 & ge) << 15 | 32767 & le);
          }
          return P;
        }
        __inplaceRightShift(C) {
          if (C === 0) return;
          let B = this.__digit(0) >>> C;
          const Q = this.length - 1;
          for (let P = 0; P < Q; P++) {
            const x = this.__digit(P + 1);
            this.__setDigit(P, 1073741823 & x << 30 - C | B), B = x >>> C;
          }
          this.__setDigit(Q, B);
        }
        static __specialLeftShift(C, B, Q) {
          const P = C.length, x = new b(P + Q, !1);
          if (B === 0) {
            for (let F = 0; F < P; F++) x.__setDigit(F, C.__digit(F));
            return 0 < Q && x.__setDigit(P, 0), x;
          }
          let M = 0;
          for (let F = 0; F < P; F++) {
            const le = C.__digit(F);
            x.__setDigit(F, 1073741823 & le << B | M), M = le >>> 30 - B;
          }
          return 0 < Q && x.__setDigit(P, M), x;
        }
        static __leftShiftByAbsolute(C, B) {
          const Q = b.__toShiftAmount(B);
          if (0 > Q) throw new RangeError("BigInt too big");
          const P = 0 | Q / 30, x = Q % 30, M = C.length, F = x !== 0 && C.__digit(M - 1) >>> 30 - x != 0, le = M + P + (F ? 1 : 0), ge = new b(le, C.sign);
          if (x === 0) {
            let pe = 0;
            for (; pe < P; pe++) ge.__setDigit(pe, 0);
            for (; pe < le; pe++) ge.__setDigit(pe, C.__digit(pe - P));
          } else {
            let pe = 0;
            for (let Ie = 0; Ie < P; Ie++) ge.__setDigit(Ie, 0);
            for (let Ie = 0; Ie < M; Ie++) {
              const be = C.__digit(Ie);
              ge.__setDigit(Ie + P, 1073741823 & be << x | pe), pe = be >>> 30 - x;
            }
            if (F) ge.__setDigit(M + P, pe);
            else if (pe !== 0) throw new Error("implementation bug");
          }
          return ge.__trim();
        }
        static __rightShiftByAbsolute(C, B) {
          const Q = C.length, P = C.sign, x = b.__toShiftAmount(B);
          if (0 > x) return b.__rightShiftByMaximum(P);
          const M = 0 | x / 30, F = x % 30;
          let le = Q - M;
          if (0 >= le) return b.__rightShiftByMaximum(P);
          let ge = !1;
          if (P) {
            if ((C.__digit(M) & (1 << F) - 1) != 0) ge = !0;
            else for (let Ie = 0; Ie < M; Ie++) if (C.__digit(Ie) !== 0) {
              ge = !0;
              break;
            }
          }
          ge && F === 0 && ~C.__digit(Q - 1) == 0 && le++;
          let pe = new b(le, P);
          if (F === 0) {
            pe.__setDigit(le - 1, 0);
            for (let Ie = M; Ie < Q; Ie++) pe.__setDigit(Ie - M, C.__digit(Ie));
          } else {
            let Ie = C.__digit(M) >>> F;
            const be = Q - M - 1;
            for (let Pe = 0; Pe < be; Pe++) {
              const Te = C.__digit(Pe + M + 1);
              pe.__setDigit(Pe, 1073741823 & Te << 30 - F | Ie), Ie = Te >>> F;
            }
            pe.__setDigit(be, Ie);
          }
          return ge && (pe = b.__absoluteAddOne(pe, !0, pe)), pe.__trim();
        }
        static __rightShiftByMaximum(C) {
          return C ? b.__oneDigit(1, !0) : b.__zero();
        }
        static __toShiftAmount(C) {
          if (1 < C.length) return -1;
          const B = C.__unsignedDigit(0);
          return B > b.__kMaxLengthBits ? -1 : B;
        }
        static __toPrimitive(C, B = "default") {
          if (typeof C != "object" || C.constructor === b) return C;
          if (typeof Symbol < "u" && typeof Symbol.toPrimitive == "symbol") {
            const x = C[Symbol.toPrimitive];
            if (x) {
              const M = x(B);
              if (typeof M != "object") return M;
              throw new TypeError("Cannot convert object to primitive value");
            }
          }
          const Q = C.valueOf;
          if (Q) {
            const x = Q.call(C);
            if (typeof x != "object") return x;
          }
          const P = C.toString;
          if (P) {
            const x = P.call(C);
            if (typeof x != "object") return x;
          }
          throw new TypeError("Cannot convert object to primitive value");
        }
        static __toNumeric(C) {
          return b.__isBigInt(C) ? C : +C;
        }
        static __isBigInt(C) {
          return typeof C == "object" && C !== null && C.constructor === b;
        }
        static __truncateToNBits(C, B) {
          const Q = 0 | (C + 29) / 30, P = new b(Q, B.sign), x = Q - 1;
          for (let F = 0; F < x; F++) P.__setDigit(F, B.__digit(F));
          let M = B.__digit(x);
          if (C % 30 != 0) {
            const F = 32 - C % 30;
            M = M << F >>> F;
          }
          return P.__setDigit(x, M), P.__trim();
        }
        static __truncateAndSubFromPowerOfTwo(C, B, Q) {
          var P = Math.min;
          const x = 0 | (C + 29) / 30, M = new b(x, Q);
          let F = 0;
          const le = x - 1;
          let ge = 0;
          for (const Pe = P(le, B.length); F < Pe; F++) {
            const Te = 0 - B.__digit(F) - ge;
            ge = 1 & Te >>> 30, M.__setDigit(F, 1073741823 & Te);
          }
          for (; F < le; F++) M.__setDigit(F, 0 | 1073741823 & -ge);
          let pe = le < B.length ? B.__digit(le) : 0;
          const Ie = C % 30;
          let be;
          if (Ie == 0) be = 0 - pe - ge, be &= 1073741823;
          else {
            const Pe = 32 - Ie;
            pe = pe << Pe >>> Pe;
            const Te = 1 << 32 - Pe;
            be = Te - pe - ge, be &= Te - 1;
          }
          return M.__setDigit(le, be), M.__trim();
        }
        __digit(C) {
          return this[C];
        }
        __unsignedDigit(C) {
          return this[C] >>> 0;
        }
        __setDigit(C, B) {
          this[C] = 0 | B;
        }
        __setDigitGrow(C, B) {
          this[C] = 0 | B;
        }
        __halfDigitLength() {
          const C = this.length;
          return 32767 >= this.__unsignedDigit(C - 1) ? 2 * C - 1 : 2 * C;
        }
        __halfDigit(C) {
          return 32767 & this[C >>> 1] >>> 15 * (1 & C);
        }
        __setHalfDigit(C, B) {
          const Q = C >>> 1, P = this.__digit(Q), x = 1 & C ? 32767 & P | B << 15 : 1073709056 & P | 32767 & B;
          this.__setDigit(Q, x);
        }
        static __digitPow(C, B) {
          let Q = 1;
          for (; 0 < B; ) 1 & B && (Q *= C), B >>>= 1, C *= C;
          return Q;
        }
        static __isOneDigitInt(C) {
          return (1073741823 & C) === C;
        }
      }
      return b.__kMaxLength = 33554432, b.__kMaxLengthBits = b.__kMaxLength << 5, b.__kMaxBitsPerChar = [0, 0, 32, 51, 64, 75, 83, 90, 96, 102, 107, 111, 115, 119, 122, 126, 128, 131, 134, 136, 139, 141, 143, 145, 147, 149, 151, 153, 154, 156, 158, 159, 160, 162, 163, 165, 166], b.__kBitsPerCharTableShift = 5, b.__kBitsPerCharTableMultiplier = 1 << b.__kBitsPerCharTableShift, b.__kConversionChars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"], b.__kBitConversionBuffer = new ArrayBuffer(8), b.__kBitConversionDouble = new Float64Array(b.__kBitConversionBuffer), b.__kBitConversionInts = new Int32Array(b.__kBitConversionBuffer), b.__clz30 = p ? function(k) {
        return p(k) - 2;
      } : function(k) {
        var C = Math.LN2, B = Math.log;
        return k === 0 ? 30 : 0 | 29 - (0 | B(k >>> 0) / C);
      }, b.__imul = u || function(k, C) {
        return 0 | k * C;
      }, b;
    });
  }(jsbiUmd$1)), jsbiUmd$1.exports;
}
var hasRequiredXoshiro;
function requireXoshiro() {
  if (hasRequiredXoshiro) return xoshiro;
  hasRequiredXoshiro = 1;
  var s = xoshiro && xoshiro.__importDefault || function(b) {
    return b && b.__esModule ? b : { default: b };
  };
  Object.defineProperty(xoshiro, "__esModule", { value: !0 });
  const A = requireUtils$e(), u = s(requireBignumber()), p = s(requireJsbiUmd()), t = 18446744073709552e3, l = (b, k) => p.default.bitwiseXor(p.default.asUintN(64, p.default.leftShift(b, p.default.BigInt(k))), p.default.BigInt(p.default.asUintN(64, p.default.signedRightShift(b, p.default.subtract(p.default.BigInt(64), p.default.BigInt(k))))));
  class m {
    constructor(k) {
      this.next = () => new u.default(this.roll().toString()), this.nextDouble = () => new u.default(this.roll().toString()).div(t + 1), this.nextInt = (B, Q) => Math.floor(this.nextDouble().toNumber() * (Q - B + 1) + B), this.nextByte = () => this.nextInt(0, 255), this.nextData = (B) => [...new Array(B)].map(() => this.nextByte());
      const C = A.sha256Hash(k);
      this.s = [p.default.BigInt(0), p.default.BigInt(0), p.default.BigInt(0), p.default.BigInt(0)], this.setS(C);
    }
    setS(k) {
      for (let C = 0; C < 4; C++) {
        let B = C * 8, Q = p.default.BigInt(0);
        for (let P = 0; P < 8; P++)
          Q = p.default.asUintN(64, p.default.leftShift(Q, p.default.BigInt(8))), Q = p.default.asUintN(64, p.default.bitwiseOr(Q, p.default.BigInt(k[B + P])));
        this.s[C] = p.default.asUintN(64, Q);
      }
    }
    roll() {
      const k = p.default.asUintN(64, p.default.multiply(l(p.default.asUintN(64, p.default.multiply(this.s[1], p.default.BigInt(5))), 7), p.default.BigInt(9))), C = p.default.asUintN(64, p.default.leftShift(this.s[1], p.default.BigInt(17)));
      return this.s[2] = p.default.asUintN(64, p.default.bitwiseXor(this.s[2], p.default.BigInt(this.s[0]))), this.s[3] = p.default.asUintN(64, p.default.bitwiseXor(this.s[3], p.default.BigInt(this.s[1]))), this.s[1] = p.default.asUintN(64, p.default.bitwiseXor(this.s[1], p.default.BigInt(this.s[2]))), this.s[0] = p.default.asUintN(64, p.default.bitwiseXor(this.s[0], p.default.BigInt(this.s[3]))), this.s[2] = p.default.asUintN(64, p.default.bitwiseXor(this.s[2], p.default.BigInt(C))), this.s[3] = p.default.asUintN(64, l(this.s[3], 45)), k;
    }
  }
  return xoshiro.default = m, xoshiro;
}
var precomputeAlias = function(s, A) {
  var u = s.reduce(function(B, Q) {
    if (Q < 0)
      throw new Error("Probability must be a positive: p[" + s.indexOf(Q) + "]=" + Q);
    return B + Q;
  }, 0);
  if (u === 0)
    throw new Error("Probability sum must be greater than zero.");
  for (var p = s.map(function(B) {
    return B * A / u;
  }), t = { prob: new Array(A), alias: new Array(A) }, l = [], m = [], b = A - 1; b >= 0; b--)
    p[b] < 1 ? l.push(b) : m.push(b);
  for (; l.length > 0 && m.length > 0; ) {
    var k = l.pop(), C = m.pop();
    t.prob[k] = p[k], t.alias[k] = C, p[C] = p[C] + p[k] - 1, p[C] < 1 ? l.push(C) : m.push(C);
  }
  for (; m.length > 0; )
    t.prob[m.pop()] = 1;
  for (; l.length > 0; )
    t.prob[l.pop()] = 1;
  return t;
}, draw = function(s, A, u) {
  var p = Math.floor(u() * s.prob.length);
  return A[u() < s.prob[p] ? p : s.alias[p]];
}, next = function(s, A, u, p) {
  if (p === void 0 && (p = 1), p === 1)
    return draw(s, A, u);
  for (var t = [], l = 0; l < p; l++)
    t.push(draw(s, A, u));
  return t;
}, sample = function(s, A, u) {
  if (u === void 0 && (u = Math.random), !Array.isArray(s))
    throw new Error("Probabilities must be an array.");
  if (s.length === 0)
    throw new Error("Probabilities array must not be empty.");
  var p = s.length, t = A ?? Array.from({ length: p }, function(m, b) {
    return b;
  }), l = precomputeAlias(s, p);
  return {
    next: function(m) {
      return m === void 0 && (m = 1), next(l, t, u, m);
    }
  };
};
const esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sample
}, Symbol.toStringTag, { value: "Module" })), require$$2$1 = /* @__PURE__ */ getAugmentedNamespace(esm);
var hasRequiredFountainUtils;
function requireFountainUtils() {
  return hasRequiredFountainUtils || (hasRequiredFountainUtils = 1, function(s) {
    var A = fountainUtils && fountainUtils.__importDefault || function(k) {
      return k && k.__esModule ? k : { default: k };
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), s.chooseFragments = s.shuffle = s.chooseDegree = void 0;
    const u = requireUtils$e(), p = A(requireXoshiro()), t = A(require$$2$1), l = (k, C) => {
      const B = [...new Array(k)].map((P, x) => 1 / (x + 1));
      return t.default(B, void 0, C.nextDouble).next() + 1;
    };
    s.chooseDegree = l;
    const m = (k, C) => {
      let B = [...k], Q = [];
      for (; B.length > 0; ) {
        let P = C.nextInt(0, B.length - 1), x = B[P];
        B.splice(P, 1), Q.push(x);
      }
      return Q;
    };
    s.shuffle = m;
    const b = (k, C, B) => {
      if (k <= C)
        return [k - 1];
      {
        const Q = Buffer.concat([u.intToBytes(k), u.intToBytes(B)]), P = new p.default(Q), x = s.chooseDegree(C, P), M = [...new Array(C)].map((le, ge) => ge);
        return s.shuffle(M, P).slice(0, x);
      }
    };
    s.chooseFragments = b;
  }(fountainUtils)), fountainUtils;
}
var hasRequiredFountainEncoder;
function requireFountainEncoder() {
  if (hasRequiredFountainEncoder) return fountainEncoder;
  hasRequiredFountainEncoder = 1;
  var s = fountainEncoder && fountainEncoder.__importDefault || function(b) {
    return b && b.__esModule ? b : { default: b };
  };
  Object.defineProperty(fountainEncoder, "__esModule", { value: !0 }), fountainEncoder.FountainEncoderPart = void 0;
  const A = s(requireAssert$2()), u = requireUtils$e(), p = requireFountainUtils(), t = requireCbor();
  class l {
    constructor(k, C, B, Q, P) {
      this._seqNum = k, this._seqLength = C, this._messageLength = B, this._checksum = Q, this._fragment = P;
    }
    get messageLength() {
      return this._messageLength;
    }
    get fragment() {
      return this._fragment;
    }
    get seqNum() {
      return this._seqNum;
    }
    get seqLength() {
      return this._seqLength;
    }
    get checksum() {
      return this._checksum;
    }
    cbor() {
      const k = t.cborEncode([
        this._seqNum,
        this._seqLength,
        this._messageLength,
        this._checksum,
        this._fragment
      ]);
      return Buffer.from(k);
    }
    description() {
      return `seqNum:${this._seqNum}, seqLen:${this._seqLength}, messageLen:${this._messageLength}, checksum:${this._checksum}, data:${this._fragment.toString("hex")}`;
    }
    static fromCBOR(k) {
      const [C, B, Q, P, x] = t.cborDecode(k);
      return A.default(typeof C == "number"), A.default(typeof B == "number"), A.default(typeof Q == "number"), A.default(typeof P == "number"), A.default(Buffer.isBuffer(x) && x.length > 0), new l(C, B, Q, P, Buffer.from(x));
    }
  }
  fountainEncoder.FountainEncoderPart = l;
  class m {
    constructor(k, C = 100, B = 0, Q = 10) {
      const P = m.findNominalFragmentLength(k.length, Q, C);
      this._messageLength = k.length, this._fragments = m.partitionMessage(k, P), this.fragmentLength = P, this.seqNum = u.toUint32(B), this.checksum = u.getCRC(k);
    }
    get fragmentsLength() {
      return this._fragments.length;
    }
    get fragments() {
      return this._fragments;
    }
    get messageLength() {
      return this._messageLength;
    }
    isComplete() {
      return this.seqNum >= this._fragments.length;
    }
    isSinglePart() {
      return this._fragments.length === 1;
    }
    seqLength() {
      return this._fragments.length;
    }
    mix(k) {
      return k.reduce((C, B) => u.bufferXOR(this._fragments[B], C), Buffer.alloc(this.fragmentLength, 0));
    }
    nextPart() {
      this.seqNum = u.toUint32(this.seqNum + 1);
      const k = p.chooseFragments(this.seqNum, this._fragments.length, this.checksum), C = this.mix(k);
      return new l(this.seqNum, this._fragments.length, this._messageLength, this.checksum, C);
    }
    static findNominalFragmentLength(k, C, B) {
      A.default(k > 0), A.default(C > 0), A.default(B >= C);
      const Q = Math.ceil(k / C);
      let P = 0;
      for (let x = 1; x <= Q && (P = Math.ceil(k / x), !(P <= B)); x++)
        ;
      return P;
    }
    static partitionMessage(k, C) {
      let B = Buffer.from(k), Q, P = [];
      for (; B.length > 0; )
        [Q, B] = u.split(B, -C), Q = Buffer.alloc(C, 0).fill(Q, 0, Q.length), P.push(Q);
      return P;
    }
  }
  return fountainEncoder.default = m, fountainEncoder;
}
var bytewords = {}, hasRequiredBytewords;
function requireBytewords() {
  if (hasRequiredBytewords) return bytewords;
  hasRequiredBytewords = 1;
  var s = bytewords && bytewords.__importDefault || function(pe) {
    return pe && pe.__esModule ? pe : { default: pe };
  };
  Object.defineProperty(bytewords, "__esModule", { value: !0 });
  const A = s(requireAssert$2()), u = requireUtils$e(), p = "ableacidalsoapexaquaarchatomauntawayaxisbackbaldbarnbeltbetabiasbluebodybragbrewbulbbuzzcalmcashcatschefcityclawcodecolacookcostcruxcurlcuspcyandarkdatadaysdelidicedietdoordowndrawdropdrumdulldutyeacheasyechoedgeepicevenexamexiteyesfactfairfernfigsfilmfishfizzflapflewfluxfoxyfreefrogfuelfundgalagamegeargemsgiftgirlglowgoodgraygrimgurugushgyrohalfhanghardhawkheathelphighhillholyhopehornhutsicedideaidleinchinkyintoirisironitemjadejazzjoinjoltjowljudojugsjumpjunkjurykeepkenokeptkeyskickkilnkingkitekiwiknoblamblavalazyleaflegsliarlimplionlistlogoloudloveluaulucklungmainmanymathmazememomenumeowmildmintmissmonknailnavyneednewsnextnoonnotenumbobeyoboeomitonyxopenovalowlspaidpartpeckplaypluspoempoolposepuffpumapurrquadquizraceramprealredorichroadrockroofrubyruinrunsrustsafesagascarsetssilkskewslotsoapsolosongstubsurfswantacotasktaxitenttiedtimetinytoiltombtoystriptunatwinuglyundouniturgeuservastveryvetovialvibeviewvisavoidvowswallwandwarmwaspwavewaxywebswhatwhenwhizwolfworkyankyawnyellyogayurtzapszerozestzinczonezoom";
  let t = [];
  const l = 256, m = 4, b = 2;
  var k;
  (function(pe) {
    pe.STANDARD = "standard", pe.URI = "uri", pe.MINIMAL = "minimal";
  })(k || (k = {}));
  const C = (pe) => p.slice(pe * m, pe * m + m), B = (pe) => {
    const Ie = C(pe);
    return `${Ie[0]}${Ie[m - 1]}`;
  }, Q = (pe) => {
    const Ie = u.getCRCHex(Buffer.from(pe, "hex"));
    return `${pe}${Ie}`;
  }, P = (pe, Ie) => {
    const be = Q(pe);
    return Buffer.from(be, "hex").reduce((Qe, xe) => [...Qe, C(xe)], []).join(Ie);
  }, x = (pe) => {
    const Ie = Q(pe);
    return Buffer.from(Ie, "hex").reduce((Te, Qe) => Te + B(Qe), "");
  }, M = (pe, Ie) => {
    A.default(pe.length === Ie, "Invalid Bytewords: word.length does not match wordLength provided");
    const be = 26;
    if (t.length === 0) {
      const Ee = be * be;
      t = [...new Array(Ee)].map(() => -1);
      for (let He = 0; He < l; He++) {
        const ve = C(He);
        let we = ve[0].charCodeAt(0) - 97, Se = (ve[3].charCodeAt(0) - 97) * be + we;
        t[Se] = He;
      }
    }
    let Pe = pe[0].toLowerCase().charCodeAt(0) - 97, Te = pe[Ie == 4 ? 3 : 1].toLowerCase().charCodeAt(0) - 97;
    A.default(0 <= Pe && Pe < be && 0 <= Te && Te < be, "Invalid Bytewords: invalid word");
    let Qe = Te * be + Pe, xe = t[Qe];
    if (A.default(xe !== -1, "Invalid Bytewords: value not in lookup table"), Ie == m) {
      const Ee = C(xe);
      let He = pe[1].toLowerCase(), ve = pe[2].toLowerCase();
      A.default(He === Ee[1] && ve === Ee[2], "Invalid Bytewords: invalid middle letters of word");
    }
    return Buffer.from([xe]).toString("hex");
  }, F = (pe, Ie, be) => {
    const Te = (be == m ? pe.split(Ie) : u.partition(pe, 2)).map((He) => M(He, be)).join("");
    A.default(Te.length >= 5, "Invalid Bytewords: invalid decoded string length");
    const [Qe, xe] = u.split(Buffer.from(Te, "hex"), 4), Ee = u.getCRCHex(Qe);
    return A.default(Ee === xe.toString("hex"), "Invalid Checksum"), Qe.toString("hex");
  }, le = (pe, Ie = k.MINIMAL) => {
    switch (Ie) {
      case k.STANDARD:
        return F(pe, " ", m);
      case k.URI:
        return F(pe, "-", m);
      case k.MINIMAL:
        return F(pe, "", b);
      default:
        throw new Error(`Invalid style ${Ie}`);
    }
  }, ge = (pe, Ie = k.MINIMAL) => {
    switch (Ie) {
      case k.STANDARD:
        return P(pe, " ");
      case k.URI:
        return P(pe, "-");
      case k.MINIMAL:
        return x(pe);
      default:
        throw new Error(`Invalid style ${Ie}`);
    }
  };
  return bytewords.default = {
    decode: le,
    encode: ge,
    STYLES: k
  }, bytewords;
}
var hasRequiredUrEncoder;
function requireUrEncoder() {
  if (hasRequiredUrEncoder) return urEncoder;
  hasRequiredUrEncoder = 1;
  var s = urEncoder && urEncoder.__importDefault || function(t) {
    return t && t.__esModule ? t : { default: t };
  };
  Object.defineProperty(urEncoder, "__esModule", { value: !0 });
  const A = s(requireFountainEncoder()), u = s(requireBytewords());
  class p {
    constructor(l, m, b, k) {
      this.ur = l, this.fountainEncoder = new A.default(l.cbor, m, b, k);
    }
    get fragmentsLength() {
      return this.fountainEncoder.fragmentsLength;
    }
    get fragments() {
      return this.fountainEncoder.fragments;
    }
    get messageLength() {
      return this.fountainEncoder.messageLength;
    }
    get cbor() {
      return this.ur.cbor;
    }
    encodeWhole() {
      return [...new Array(this.fragmentsLength)].map(() => this.nextPart());
    }
    nextPart() {
      const l = this.fountainEncoder.nextPart();
      return this.fountainEncoder.isSinglePart() ? p.encodeSinglePart(this.ur) : p.encodePart(this.ur.type, l);
    }
    static encodeUri(l, m) {
      const b = m.join("/");
      return [l, b].join(":");
    }
    static encodeUR(l) {
      return p.encodeUri("ur", l);
    }
    static encodePart(l, m) {
      const b = `${m.seqNum}-${m.seqLength}`, k = u.default.encode(m.cbor().toString("hex"), u.default.STYLES.MINIMAL);
      return p.encodeUR([l, b, k]);
    }
    static encodeSinglePart(l) {
      const m = u.default.encode(l.cbor.toString("hex"), u.default.STYLES.MINIMAL);
      return p.encodeUR([l.type, m]);
    }
  }
  return urEncoder.default = p, urEncoder;
}
var urDecoder = {}, fountainDecoder = {}, hasRequiredFountainDecoder;
function requireFountainDecoder() {
  if (hasRequiredFountainDecoder) return fountainDecoder;
  hasRequiredFountainDecoder = 1, Object.defineProperty(fountainDecoder, "__esModule", { value: !0 }), fountainDecoder.FountainDecoderPart = void 0;
  const s = requireUtils$e(), A = requireFountainUtils(), u = requireErrors$4();
  class p {
    constructor(m, b) {
      this._indexes = m, this._fragment = b;
    }
    get indexes() {
      return this._indexes;
    }
    get fragment() {
      return this._fragment;
    }
    static fromEncoderPart(m) {
      const b = A.chooseFragments(m.seqNum, m.seqLength, m.checksum), k = m.fragment;
      return new p(b, k);
    }
    isSimple() {
      return this.indexes.length === 1;
    }
  }
  fountainDecoder.FountainDecoderPart = p;
  class t {
    constructor() {
      this.result = void 0, this.expectedMessageLength = 0, this.expectedChecksum = 0, this.expectedFragmentLength = 0, this.processedPartsCount = 0, this.expectedPartIndexes = [], this.lastPartIndexes = [], this.queuedParts = [], this.receivedPartIndexes = [], this.mixedParts = [], this.simpleParts = [];
    }
    validatePart(m) {
      if (this.expectedPartIndexes.length === 0)
        [...new Array(m.seqLength)].forEach((b, k) => this.expectedPartIndexes.push(k)), this.expectedMessageLength = m.messageLength, this.expectedChecksum = m.checksum, this.expectedFragmentLength = m.fragment.length;
      else if (this.expectedPartIndexes.length !== m.seqLength || this.expectedMessageLength !== m.messageLength || this.expectedChecksum !== m.checksum || this.expectedFragmentLength !== m.fragment.length)
        return !1;
      return !0;
    }
    reducePartByPart(m, b) {
      if (s.arrayContains(m.indexes, b.indexes)) {
        const k = s.setDifference(m.indexes, b.indexes), C = s.bufferXOR(m.fragment, b.fragment);
        return new p(k, C);
      } else
        return m;
    }
    reduceMixedBy(m) {
      const b = [];
      this.mixedParts.map(({ value: k }) => this.reducePartByPart(k, m)).forEach((k) => {
        k.isSimple() ? this.queuedParts.push(k) : b.push({ key: k.indexes, value: k });
      }), this.mixedParts = b;
    }
    processSimplePart(m) {
      const b = m.indexes[0];
      if (!this.receivedPartIndexes.includes(b))
        if (this.simpleParts.push({ key: m.indexes, value: m }), this.receivedPartIndexes.push(b), s.arraysEqual(this.receivedPartIndexes, this.expectedPartIndexes)) {
          const k = this.simpleParts.map(({ value: Q }) => Q).sort((Q, P) => Q.indexes[0] - P.indexes[0]), C = t.joinFragments(k.map((Q) => Q.fragment), this.expectedMessageLength);
          s.getCRC(C) === this.expectedChecksum ? this.result = C : this.error = new u.InvalidChecksumError();
        } else
          this.reduceMixedBy(m);
    }
    processMixedPart(m) {
      if (this.mixedParts.some(({ key: k }) => s.arraysEqual(k, m.indexes)))
        return;
      let b = this.simpleParts.reduce((k, { value: C }) => this.reducePartByPart(k, C), m);
      b = this.mixedParts.reduce((k, { value: C }) => this.reducePartByPart(k, C), b), b.isSimple() ? this.queuedParts.push(b) : (this.reduceMixedBy(b), this.mixedParts.push({ key: b.indexes, value: b }));
    }
    processQueuedItem() {
      if (this.queuedParts.length === 0)
        return;
      const m = this.queuedParts.shift();
      m.isSimple() ? this.processSimplePart(m) : this.processMixedPart(m);
    }
    receivePart(m) {
      if (this.isComplete() || !this.validatePart(m))
        return !1;
      const b = p.fromEncoderPart(m);
      for (this.lastPartIndexes = b.indexes, this.queuedParts.push(b); !this.isComplete() && this.queuedParts.length > 0; )
        this.processQueuedItem();
      return this.processedPartsCount += 1, !0;
    }
    isComplete() {
      return this.result !== void 0 && this.result.length > 0;
    }
    isSuccess() {
      return !!(this.error === void 0 && this.isComplete());
    }
    resultMessage() {
      return this.isSuccess() ? this.result : Buffer.from([]);
    }
    isFailure() {
      return this.error !== void 0;
    }
    resultError() {
      return this.error ? this.error.message : "";
    }
    expectedPartCount() {
      return this.expectedPartIndexes.length;
    }
    getExpectedPartIndexes() {
      return [...this.expectedPartIndexes];
    }
    getReceivedPartIndexes() {
      return [...this.receivedPartIndexes];
    }
    getLastPartIndexes() {
      return [...this.lastPartIndexes];
    }
    estimatedPercentComplete() {
      if (this.isComplete())
        return 1;
      const m = this.expectedPartCount();
      return m === 0 ? 0 : Math.min(0.99, this.processedPartsCount / (m * 1.75));
    }
    getProgress() {
      if (this.isComplete())
        return 1;
      const m = this.expectedPartCount();
      return m === 0 ? 0 : this.receivedPartIndexes.length / m;
    }
  }
  return fountainDecoder.default = t, t.joinFragments = (l, m) => Buffer.concat(l).slice(0, m), fountainDecoder;
}
var hasRequiredUrDecoder;
function requireUrDecoder() {
  if (hasRequiredUrDecoder) return urDecoder;
  hasRequiredUrDecoder = 1;
  var s = urDecoder && urDecoder.__importDefault || function(C) {
    return C && C.__esModule ? C : { default: C };
  };
  Object.defineProperty(urDecoder, "__esModule", { value: !0 });
  const A = s(requireFountainDecoder()), u = s(requireBytewords()), p = s(requireAssert$2()), t = requireUtils$e(), l = requireErrors$4(), m = s(requireUr$1()), b = requireFountainEncoder();
  class k {
    constructor(B = new A.default(), Q = "bytes") {
      this.fountainDecoder = B, this.type = Q, p.default(t.isURType(Q), "Invalid UR type"), this.expected_type = "";
    }
    static decodeBody(B, Q) {
      const P = u.default.decode(Q, u.default.STYLES.MINIMAL);
      return new m.default(Buffer.from(P, "hex"), B);
    }
    validatePart(B) {
      return this.expected_type ? this.expected_type === B : t.isURType(B) ? (this.expected_type = B, !0) : !1;
    }
    static decode(B) {
      const [Q, P] = this.parse(B);
      if (P.length === 0)
        throw new l.InvalidPathLengthError();
      const x = P[0];
      return k.decodeBody(Q, x);
    }
    static parse(B) {
      const Q = B.toLowerCase();
      if (Q.slice(0, 3) !== "ur:")
        throw new l.InvalidSchemeError();
      const x = Q.slice(3).split("/"), M = x[0];
      if (x.length < 2)
        throw new l.InvalidPathLengthError();
      if (!t.isURType(M))
        throw new l.InvalidTypeError();
      return [M, x.slice(1)];
    }
    static parseSequenceComponent(B) {
      const Q = B.split("-");
      if (Q.length !== 2)
        throw new l.InvalidSequenceComponentError();
      const P = t.toUint32(Number(Q[0])), x = Number(Q[1]);
      if (P < 1 || x < 1)
        throw new l.InvalidSequenceComponentError();
      return [P, x];
    }
    receivePart(B) {
      if (this.result !== void 0)
        return !1;
      const [Q, P] = k.parse(B);
      if (!this.validatePart(Q))
        return !1;
      if (P.length === 1)
        return this.result = k.decodeBody(Q, P[0]), !0;
      if (P.length !== 2)
        throw new l.InvalidPathLengthError();
      const [x, M] = P, [F, le] = k.parseSequenceComponent(x), ge = u.default.decode(M, u.default.STYLES.MINIMAL), pe = b.FountainEncoderPart.fromCBOR(ge);
      return F !== pe.seqNum || le !== pe.seqLength || !this.fountainDecoder.receivePart(pe) ? !1 : (this.fountainDecoder.isSuccess() ? this.result = new m.default(this.fountainDecoder.resultMessage(), Q) : this.fountainDecoder.isFailure() && (this.error = new l.InvalidSchemeError()), !0);
    }
    resultUR() {
      return this.result ? this.result : new m.default(Buffer.from([]));
    }
    isComplete() {
      return this.result && this.result.cbor.length > 0;
    }
    isSuccess() {
      return !this.error && this.isComplete();
    }
    isError() {
      return this.error !== void 0;
    }
    resultError() {
      return this.error ? this.error.message : "";
    }
    expectedPartCount() {
      return this.fountainDecoder.expectedPartCount();
    }
    expectedPartIndexes() {
      return this.fountainDecoder.getExpectedPartIndexes();
    }
    receivedPartIndexes() {
      return this.fountainDecoder.getReceivedPartIndexes();
    }
    lastPartIndexes() {
      return this.fountainDecoder.getLastPartIndexes();
    }
    estimatedPercentComplete() {
      return this.fountainDecoder.estimatedPercentComplete();
    }
    getProgress() {
      return this.fountainDecoder.getProgress();
    }
  }
  return urDecoder.default = k, urDecoder;
}
var hasRequiredDist$k;
function requireDist$k() {
  if (hasRequiredDist$k) return dist$i;
  hasRequiredDist$k = 1;
  var s = dist$i && dist$i.__importDefault || function(t) {
    return t && t.__esModule ? t : { default: t };
  };
  Object.defineProperty(dist$i, "__esModule", { value: !0 }), dist$i.URDecoder = dist$i.UREncoder = dist$i.UR = void 0;
  const A = s(requireUr$1());
  dist$i.UR = A.default;
  const u = s(requireUrEncoder());
  dist$i.UREncoder = u.default;
  const p = s(requireUrDecoder());
  return dist$i.URDecoder = p.default, dist$i;
}
var hasRequiredRegistryItem$1;
function requireRegistryItem$1() {
  if (hasRequiredRegistryItem$1) return RegistryItem$1;
  hasRequiredRegistryItem$1 = 1, Object.defineProperty(RegistryItem$1, "__esModule", { value: !0 }), RegistryItem$1.RegistryItem = void 0;
  const s = requireDist$k(), A = requireLib$7();
  class u {
    constructor() {
      this.toCBOR = () => {
        if (this.toDataItem() === void 0)
          throw new Error(`#[ur-registry][RegistryItem][fn.toCBOR]: registry ${this.getRegistryType()}'s method toDataItem returns undefined`);
        return (0, A.encodeDataItem)(this.toDataItem());
      }, this.toUR = () => new s.UR(this.toCBOR(), this.getRegistryType().getType()), this.toUREncoder = (t, l, m) => {
        const b = this.toUR();
        return new s.UREncoder(b, t, l, m);
      };
    }
  }
  return RegistryItem$1.RegistryItem = u, RegistryItem$1;
}
var hasRequiredCryptoCoinInfo$1;
function requireCryptoCoinInfo$1() {
  return hasRequiredCryptoCoinInfo$1 || (hasRequiredCryptoCoinInfo$1 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.CryptoCoinInfo = s.Network = s.Type = void 0;
    const A = requireLib$7(), u = requireRegistryItem$1(), p = requireRegistryType$1();
    var t;
    (function(k) {
      k.type = "1", k.network = "2";
    })(t || (t = {}));
    var l;
    (function(k) {
      k[k.bitcoin = 0] = "bitcoin";
    })(l = s.Type || (s.Type = {}));
    var m;
    (function(k) {
      k[k.mainnet = 0] = "mainnet", k[k.testnet = 1] = "testnet";
    })(m = s.Network || (s.Network = {}));
    class b extends u.RegistryItem {
      constructor(C, B) {
        super(), this.type = C, this.network = B, this.getRegistryType = () => p.RegistryTypes.CRYPTO_COIN_INFO, this.getType = () => this.type || l.bitcoin, this.getNetwork = () => this.network || m.mainnet, this.toDataItem = () => {
          const Q = {};
          return this.type && (Q[t.type] = this.type), this.network && (Q[t.network] = this.network), new A.DataItem(Q);
        };
      }
    }
    s.CryptoCoinInfo = b, b.fromDataItem = (k) => {
      const C = k.getData(), B = C[t.type], Q = C[t.network];
      return new b(B, Q);
    }, b.fromCBOR = (k) => {
      const C = (0, A.decodeToDataItem)(k);
      return b.fromDataItem(C);
    };
  }(CryptoCoinInfo$1)), CryptoCoinInfo$1;
}
var CryptoKeypath$1 = {}, PathComponent$1 = {}, hasRequiredPathComponent$1;
function requirePathComponent$1() {
  if (hasRequiredPathComponent$1) return PathComponent$1;
  hasRequiredPathComponent$1 = 1, Object.defineProperty(PathComponent$1, "__esModule", { value: !0 }), PathComponent$1.PathComponent = void 0;
  class s {
    constructor(u) {
      if (this.getIndex = () => this.index, this.isWildcard = () => this.wildcard, this.isHardened = () => this.hardened, this.index = u.index, this.hardened = u.hardened, this.index !== void 0 ? this.wildcard = !1 : this.wildcard = !0, this.index && (this.index & s.HARDENED_BIT) !== 0)
        throw new Error(`#[ur-registry][PathComponent][fn.constructor]: Invalid index ${this.index} - most significant bit cannot be set`);
    }
  }
  return PathComponent$1.PathComponent = s, s.HARDENED_BIT = 2147483648, PathComponent$1;
}
var hasRequiredCryptoKeypath$1;
function requireCryptoKeypath$1() {
  if (hasRequiredCryptoKeypath$1) return CryptoKeypath$1;
  hasRequiredCryptoKeypath$1 = 1, Object.defineProperty(CryptoKeypath$1, "__esModule", { value: !0 }), CryptoKeypath$1.CryptoKeypath = void 0;
  const s = requireLib$7(), A = requirePathComponent$1(), u = requireRegistryItem$1(), p = requireRegistryType$1();
  var t;
  (function(m) {
    m[m.components = 1] = "components", m[m.source_fingerprint = 2] = "source_fingerprint", m[m.depth = 3] = "depth";
  })(t || (t = {}));
  class l extends u.RegistryItem {
    constructor(b = [], k, C) {
      super(), this.components = b, this.sourceFingerprint = k, this.depth = C, this.getRegistryType = () => p.RegistryTypes.CRYPTO_KEYPATH, this.getPath = () => this.components.length === 0 ? void 0 : this.components.map((Q) => `${Q.isWildcard() ? "*" : Q.getIndex()}${Q.isHardened() ? "'" : ""}`).join("/"), this.getComponents = () => this.components, this.getSourceFingerprint = () => this.sourceFingerprint, this.getDepth = () => this.depth, this.toDataItem = () => {
        const B = {}, Q = [];
        return this.components && this.components.forEach((P) => {
          P.isWildcard() ? Q.push([]) : Q.push(P.getIndex()), Q.push(P.isHardened());
        }), B[t.components] = Q, this.sourceFingerprint && (B[t.source_fingerprint] = this.sourceFingerprint.readUInt32BE(0)), this.depth !== void 0 && (B[t.depth] = this.depth), new s.DataItem(B);
      };
    }
  }
  return CryptoKeypath$1.CryptoKeypath = l, l.fromDataItem = (m) => {
    const b = m.getData(), k = [], C = b[t.components];
    if (C)
      for (let x = 0; x < C.length; x += 2) {
        const M = C[x + 1], F = C[x];
        typeof F == "number" ? k.push(new A.PathComponent({ index: F, hardened: M })) : k.push(new A.PathComponent({ hardened: M }));
      }
    const B = b[t.source_fingerprint];
    let Q;
    B && (Q = Buffer.alloc(4), Q.writeUInt32BE(B, 0));
    const P = b[t.depth];
    return new l(k, Q, P);
  }, l.fromCBOR = (m) => {
    const b = (0, s.decodeToDataItem)(m);
    return l.fromDataItem(b);
  }, CryptoKeypath$1;
}
var hasRequiredCryptoHDKey$1;
function requireCryptoHDKey$1() {
  if (hasRequiredCryptoHDKey$1) return CryptoHDKey$1;
  hasRequiredCryptoHDKey$1 = 1, Object.defineProperty(CryptoHDKey$1, "__esModule", { value: !0 }), CryptoHDKey$1.CryptoHDKey = void 0;
  const s = requireBs58check(), A = requireCryptoCoinInfo$1(), u = requireCryptoKeypath$1(), p = requireLib$7(), t = requireRegistryItem$1(), l = requireRegistryType$1();
  var m;
  (function(k) {
    k[k.is_master = 1] = "is_master", k[k.is_private = 2] = "is_private", k[k.key_data = 3] = "key_data", k[k.chain_code = 4] = "chain_code", k[k.use_info = 5] = "use_info", k[k.origin = 6] = "origin", k[k.children = 7] = "children", k[k.parent_fingerprint = 8] = "parent_fingerprint", k[k.name = 9] = "name", k[k.note = 10] = "note";
  })(m || (m = {}));
  class b extends t.RegistryItem {
    constructor(C) {
      super(), this.isECKey = () => !1, this.getKey = () => this.key, this.getChainCode = () => this.chainCode, this.isMaster = () => this.master, this.isPrivateKey = () => !!this.privateKey, this.getUseInfo = () => this.useInfo, this.getOrigin = () => this.origin, this.getChildren = () => this.children, this.getParentFingerprint = () => this.parentFingerprint, this.getName = () => this.name, this.getNote = () => this.note, this.getBip32Key = () => {
        var B, Q, P;
        let x, M, F = 0, le = Buffer.alloc(4).fill(0);
        if (this.isMaster())
          x = Buffer.from("0488ADE4", "hex"), M = 0, F = 0;
        else {
          M = ((B = this.getOrigin()) === null || B === void 0 ? void 0 : B.getComponents().length) || ((Q = this.getOrigin()) === null || Q === void 0 ? void 0 : Q.getDepth());
          const Pe = (P = this.getOrigin()) === null || P === void 0 ? void 0 : P.getComponents(), Te = Pe[Pe.length - 1];
          Te && (F = Te.isHardened() ? Te.getIndex() + 2147483648 : Te.getIndex(), this.getParentFingerprint() && (le = this.getParentFingerprint())), this.isPrivateKey() ? x = Buffer.from("0488ADE4", "hex") : x = Buffer.from("0488B21E", "hex");
        }
        const ge = Buffer.alloc(1);
        ge.writeUInt8(M, 0);
        const pe = Buffer.alloc(4);
        pe.writeUInt32BE(F, 0);
        const Ie = this.getChainCode(), be = this.getKey();
        return (0, s.encode)(Buffer.concat([x, ge, le, pe, Ie, be]));
      }, this.getRegistryType = () => l.RegistryTypes.CRYPTO_HDKEY, this.getOutputDescriptorContent = () => {
        var B, Q, P, x, M, F, le;
        let ge = "";
        return this.getOrigin() && !((B = this.getOrigin()) === null || B === void 0) && B.getSourceFingerprint() && !((Q = this.getOrigin()) === null || Q === void 0) && Q.getPath() && (ge += `${(x = (P = this.getOrigin()) === null || P === void 0 ? void 0 : P.getSourceFingerprint()) === null || x === void 0 ? void 0 : x.toString("hex")}/${(M = this.getOrigin()) === null || M === void 0 ? void 0 : M.getPath()}`), ge += this.getBip32Key(), this.getChildren() && !((F = this.getChildren()) === null || F === void 0) && F.getPath() && (ge += `/${(le = this.getChildren()) === null || le === void 0 ? void 0 : le.getPath()}`), ge;
      }, this.setupMasterKey = (B) => {
        this.master = !0, this.key = B.key, this.chainCode = B.chainCode;
      }, this.setupDeriveKey = (B) => {
        this.master = !1, this.privateKey = B.isPrivateKey, this.key = B.key, this.chainCode = B.chainCode, this.useInfo = B.useInfo, this.origin = B.origin, this.children = B.children, this.parentFingerprint = B.parentFingerprint, this.name = B.name, this.note = B.note;
      }, this.toDataItem = () => {
        const B = {};
        if (this.master)
          B[m.is_master] = !0, B[m.key_data] = this.key, B[m.chain_code] = this.chainCode;
        else {
          if (this.privateKey !== void 0 && (B[m.is_private] = this.privateKey), B[m.key_data] = this.key, this.chainCode && (B[m.chain_code] = this.chainCode), this.useInfo) {
            const Q = this.useInfo.toDataItem();
            Q.setTag(this.useInfo.getRegistryType().getTag()), B[m.use_info] = Q;
          }
          if (this.origin) {
            const Q = this.origin.toDataItem();
            Q.setTag(this.origin.getRegistryType().getTag()), B[m.origin] = Q;
          }
          if (this.children) {
            const Q = this.children.toDataItem();
            Q.setTag(this.children.getRegistryType().getTag()), B[m.children] = Q;
          }
          this.parentFingerprint && (B[m.parent_fingerprint] = this.parentFingerprint.readUInt32BE(0)), this.name !== void 0 && (B[m.name] = this.name), this.note !== void 0 && (B[m.note] = this.note);
        }
        return new p.DataItem(B);
      }, C.isMaster ? this.setupMasterKey(C) : this.setupDeriveKey(C);
    }
  }
  return CryptoHDKey$1.CryptoHDKey = b, b.fromDataItem = (k) => {
    const C = k.getData(), B = !!C[m.is_master], Q = C[m.is_private], P = C[m.key_data], x = C[m.chain_code], M = C[m.use_info] ? A.CryptoCoinInfo.fromDataItem(C[m.use_info]) : void 0, F = C[m.origin] ? u.CryptoKeypath.fromDataItem(C[m.origin]) : void 0, le = C[m.children] ? u.CryptoKeypath.fromDataItem(C[m.children]) : void 0, ge = C[m.parent_fingerprint];
    let pe;
    ge && (pe = Buffer.alloc(4), pe.writeUInt32BE(ge, 0));
    const Ie = C[m.name], be = C[m.note];
    return new b({
      isMaster: B,
      isPrivateKey: Q,
      key: P,
      chainCode: x,
      useInfo: M,
      origin: F,
      children: le,
      parentFingerprint: pe,
      name: Ie,
      note: be
    });
  }, b.fromCBOR = (k) => {
    const C = (0, p.decodeToDataItem)(k);
    return b.fromDataItem(C);
  }, CryptoHDKey$1;
}
var CryptoECKey$1 = {}, hasRequiredCryptoECKey$1;
function requireCryptoECKey$1() {
  if (hasRequiredCryptoECKey$1) return CryptoECKey$1;
  hasRequiredCryptoECKey$1 = 1, Object.defineProperty(CryptoECKey$1, "__esModule", { value: !0 }), CryptoECKey$1.CryptoECKey = void 0;
  const s = requireLib$7(), A = requireRegistryItem$1(), u = requireRegistryType$1();
  var p;
  (function(l) {
    l[l.curve = 1] = "curve", l[l.private = 2] = "private", l[l.data = 3] = "data";
  })(p || (p = {}));
  class t extends A.RegistryItem {
    constructor(m) {
      super(), this.isECKey = () => !0, this.getCurve = () => this.curve || 0, this.isPrivateKey = () => this.privateKey || !1, this.getData = () => this.data, this.getRegistryType = () => u.RegistryTypes.CRYPTO_ECKEY, this.toDataItem = () => {
        const b = {};
        return this.curve && (b[p.curve] = this.curve), this.privateKey !== void 0 && (b[p.private] = this.privateKey), b[p.data] = this.data, new s.DataItem(b);
      }, this.getOutputDescriptorContent = () => this.data.toString("hex"), this.data = m.data, this.curve = m.curve, this.privateKey = m.privateKey || void 0;
    }
  }
  return CryptoECKey$1.CryptoECKey = t, t.fromDataItem = (l) => {
    const m = l.getData(), b = m[p.curve], k = m[p.private], C = m[p.data];
    if (!C)
      throw new Error(`#[ur-registry][CryptoECKey][fn.fromDataItem]: decoded [dataItem][#data.data] is undefined: ${l}`);
    return new t({ data: C, curve: b, privateKey: k });
  }, t.fromCBOR = (l) => {
    const m = (0, s.decodeToDataItem)(l);
    return t.fromDataItem(m);
  }, CryptoECKey$1;
}
var Bytes$1 = {}, hasRequiredBytes$3;
function requireBytes$3() {
  if (hasRequiredBytes$3) return Bytes$1;
  hasRequiredBytes$3 = 1, Object.defineProperty(Bytes$1, "__esModule", { value: !0 }), Bytes$1.Bytes = void 0;
  const s = requireLib$7(), A = requireRegistryItem$1(), u = requireRegistryType$1();
  class p extends A.RegistryItem {
    constructor(l) {
      super(), this.bytes = l, this.getRegistryType = () => u.RegistryTypes.BYTES, this.getData = () => this.bytes, this.toDataItem = () => new s.DataItem(this.bytes);
    }
  }
  return Bytes$1.Bytes = p, p.fromDataItem = (t) => {
    const l = t.getData();
    if (!l)
      throw new Error(`#[ur-registry][Bytes][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${t}`);
    return new p(l);
  }, p.fromCBOR = (t) => {
    const l = (0, s.decodeToDataItem)(t);
    return p.fromDataItem(l);
  }, Bytes$1;
}
var CryptoOutput$1 = {}, MultiKey$1 = {}, hasRequiredMultiKey$1;
function requireMultiKey$1() {
  if (hasRequiredMultiKey$1) return MultiKey$1;
  hasRequiredMultiKey$1 = 1, Object.defineProperty(MultiKey$1, "__esModule", { value: !0 }), MultiKey$1.MultiKey = void 0;
  const s = requireCryptoECKey$1(), A = requireCryptoHDKey$1(), u = requireDataItem$1(), p = requireRegistryItem$1(), t = requireRegistryType$1();
  var l;
  (function(b) {
    b[b.threshold = 1] = "threshold", b[b.keys = 2] = "keys";
  })(l || (l = {}));
  class m extends p.RegistryItem {
    constructor(k, C) {
      super(), this.threshold = k, this.keys = C, this.getThreshold = () => this.threshold, this.getKeys = () => this.keys, this.toDataItem = () => {
        const B = {};
        B[l.threshold] = this.threshold;
        const Q = this.keys.map((P) => {
          const x = P.toDataItem();
          return x.setTag(P.getRegistryType().getTag()), x;
        });
        return B[l.keys] = Q, new u.DataItem(B);
      }, this.getOutputDescriptorContent = () => [
        this.getThreshold(),
        this.keys.map((B) => B.getOutputDescriptorContent()).join(",")
      ].join(",");
    }
  }
  return MultiKey$1.MultiKey = m, m.fromDataItem = (b) => {
    const k = b.getData(), C = k[l.threshold], B = k[l.keys], Q = [];
    return B.forEach((P) => {
      P.getTag() === t.RegistryTypes.CRYPTO_HDKEY.getTag() ? Q.push(A.CryptoHDKey.fromDataItem(P)) : P.getTag() === t.RegistryTypes.CRYPTO_ECKEY.getTag() && Q.push(s.CryptoECKey.fromDataItem(P));
    }), new m(C, Q);
  }, MultiKey$1;
}
var hasRequiredCryptoOutput$1;
function requireCryptoOutput$1() {
  if (hasRequiredCryptoOutput$1) return CryptoOutput$1;
  hasRequiredCryptoOutput$1 = 1, Object.defineProperty(CryptoOutput$1, "__esModule", { value: !0 }), CryptoOutput$1.CryptoOutput = void 0;
  const s = requireCryptoECKey$1(), A = requireCryptoHDKey$1(), u = requireLib$7(), p = requireMultiKey$1(), t = requireRegistryItem$1(), l = requireRegistryType$1(), m = requireScriptExpression$1();
  class b extends t.RegistryItem {
    constructor(C, B) {
      super(), this.scriptExpressions = C, this.cryptoKey = B, this.getRegistryType = () => l.RegistryTypes.CRYPTO_OUTPUT, this.getCryptoKey = () => this.cryptoKey, this.getHDKey = () => {
        if (this.cryptoKey instanceof A.CryptoHDKey)
          return this.cryptoKey;
      }, this.getECKey = () => {
        if (this.cryptoKey instanceof s.CryptoECKey)
          return this.cryptoKey;
      }, this.getMultiKey = () => {
        if (this.cryptoKey instanceof p.MultiKey)
          return this.cryptoKey;
      }, this.getScriptExpressions = () => this.scriptExpressions, this._toOutputDescriptor = (Q) => Q >= this.scriptExpressions.length ? this.cryptoKey.getOutputDescriptorContent() : `${this.scriptExpressions[Q].getExpression()}(${this._toOutputDescriptor(Q + 1)})`, this.toString = () => this._toOutputDescriptor(0), this.toDataItem = () => {
        let Q = this.cryptoKey.toDataItem();
        return (this.cryptoKey instanceof s.CryptoECKey || this.cryptoKey instanceof A.CryptoHDKey) && Q.setTag(this.cryptoKey.getRegistryType().getTag()), [...this.scriptExpressions].reverse().forEach((x) => {
          const M = x.getTag();
          Q.getTag() === void 0 ? Q.setTag(M) : Q = new u.DataItem(Q, M);
        }), Q;
      };
    }
  }
  return CryptoOutput$1.CryptoOutput = b, b.fromDataItem = (k) => {
    const C = [];
    let B = k;
    for (; ; ) {
      let x = B.getTag();
      const M = m.ScriptExpression.fromTag(x);
      if (M)
        if (C.push(M), B.getData() instanceof u.DataItem)
          B = B.getData(), x = B.getTag();
        else
          break;
      else
        break;
    }
    const Q = C.length;
    if (Q > 0 && (C[Q - 1].getExpression() === m.ScriptExpressions.MULTISIG.getExpression() || C[Q - 1].getExpression() === m.ScriptExpressions.SORTED_MULTISIG.getExpression())) {
      const x = p.MultiKey.fromDataItem(B);
      return new b(C, x);
    }
    if (B.getTag() === l.RegistryTypes.CRYPTO_HDKEY.getTag()) {
      const x = A.CryptoHDKey.fromDataItem(B);
      return new b(C, x);
    } else {
      const x = s.CryptoECKey.fromDataItem(B);
      return new b(C, x);
    }
  }, b.fromCBOR = (k) => {
    const C = (0, u.decodeToDataItem)(k);
    return b.fromDataItem(C);
  }, CryptoOutput$1;
}
var CryptoPSBT$1 = {}, hasRequiredCryptoPSBT$1;
function requireCryptoPSBT$1() {
  if (hasRequiredCryptoPSBT$1) return CryptoPSBT$1;
  hasRequiredCryptoPSBT$1 = 1, Object.defineProperty(CryptoPSBT$1, "__esModule", { value: !0 }), CryptoPSBT$1.CryptoPSBT = void 0;
  const s = requireLib$7(), A = requireRegistryItem$1(), u = requireRegistryType$1();
  class p extends A.RegistryItem {
    constructor(l) {
      super(), this.psbt = l, this.getRegistryType = () => u.RegistryTypes.CRYPTO_PSBT, this.getPSBT = () => this.psbt, this.toDataItem = () => new s.DataItem(this.psbt);
    }
  }
  return CryptoPSBT$1.CryptoPSBT = p, p.fromDataItem = (t) => {
    const l = t.getData();
    if (!l)
      throw new Error(`#[ur-registry][CryptoPSBT][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${t}`);
    return new p(l);
  }, p.fromCBOR = (t) => {
    const l = (0, s.decodeToDataItem)(t);
    return p.fromDataItem(l);
  }, CryptoPSBT$1;
}
var CryptoAccount$1 = {}, hasRequiredCryptoAccount$1;
function requireCryptoAccount$1() {
  if (hasRequiredCryptoAccount$1) return CryptoAccount$1;
  hasRequiredCryptoAccount$1 = 1, Object.defineProperty(CryptoAccount$1, "__esModule", { value: !0 }), CryptoAccount$1.CryptoAccount = void 0;
  const s = requireDist$j(), A = requireLib$7(), u = requireRegistryItem$1(), p = requireRegistryType$1();
  var t;
  (function(m) {
    m[m.masterFingerprint = 1] = "masterFingerprint", m[m.outputDescriptors = 2] = "outputDescriptors";
  })(t || (t = {}));
  class l extends u.RegistryItem {
    constructor(b, k) {
      super(), this.masterFingerprint = b, this.outputDescriptors = k, this.getRegistryType = () => p.RegistryTypes.CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getOutputDescriptors = () => this.outputDescriptors, this.toDataItem = () => {
        const C = {};
        return this.masterFingerprint && (C[t.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.outputDescriptors && (C[t.outputDescriptors] = this.outputDescriptors.map((B) => B.toDataItem())), new A.DataItem(C);
      };
    }
  }
  return CryptoAccount$1.CryptoAccount = l, l.fromDataItem = (m) => {
    const b = m.getData(), k = Buffer.alloc(4), C = b[t.masterFingerprint];
    C && k.writeUInt32BE(C, 0);
    const Q = b[t.outputDescriptors].map((P) => s.CryptoOutput.fromDataItem(P));
    return new l(k, Q);
  }, l.fromCBOR = (m) => {
    const b = (0, A.decodeToDataItem)(m);
    return l.fromDataItem(b);
  }, CryptoAccount$1;
}
var Decoder$1 = {}, errors$2 = {}, hasRequiredErrors$2;
function requireErrors$2() {
  if (hasRequiredErrors$2) return errors$2;
  hasRequiredErrors$2 = 1, Object.defineProperty(errors$2, "__esModule", { value: !0 }), errors$2.UnknownURTypeError = void 0;
  class s extends Error {
    constructor(u) {
      super(u);
    }
  }
  return errors$2.UnknownURTypeError = s, errors$2;
}
var hasRequiredDecoder$1;
function requireDecoder$1() {
  if (hasRequiredDecoder$1) return Decoder$1;
  hasRequiredDecoder$1 = 1, Object.defineProperty(Decoder$1, "__esModule", { value: !0 }), Decoder$1.URRegistryDecoder = void 0;
  const s = requireDist$k(), A = requireDist$j(), u = requireRegistryType$1(), p = requireErrors$2();
  class t extends s.URDecoder {
    constructor() {
      super(...arguments), this.resultRegistryType = () => {
        const m = this.resultUR();
        switch (m.type) {
          case u.RegistryTypes.BYTES.getType():
            return A.Bytes.fromCBOR(m.cbor);
          case u.RegistryTypes.CRYPTO_HDKEY.getType():
            return A.CryptoHDKey.fromCBOR(m.cbor);
          case u.RegistryTypes.CRYPTO_KEYPATH.getType():
            return A.CryptoKeypath.fromCBOR(m.cbor);
          case u.RegistryTypes.CRYPTO_COIN_INFO.getType():
            return A.CryptoCoinInfo.fromCBOR(m.cbor);
          case u.RegistryTypes.CRYPTO_ECKEY.getType():
            return A.CryptoECKey.fromCBOR(m.cbor);
          case u.RegistryTypes.CRYPTO_OUTPUT.getType():
            return A.CryptoOutput.fromCBOR(m.cbor);
          case u.RegistryTypes.CRYPTO_PSBT.getType():
            return A.CryptoPSBT.fromCBOR(m.cbor);
          case u.RegistryTypes.CRYPTO_ACCOUNT.getType():
            return A.CryptoAccount.fromCBOR(m.cbor);
          default:
            throw new p.UnknownURTypeError(`#[ur-registry][Decoder][fn.resultRegistryType]: registry type ${m.type} is not supported now`);
        }
      };
    }
  }
  return Decoder$1.URRegistryDecoder = t, Decoder$1;
}
var CryptoMultiAccounts$1 = {}, hasRequiredCryptoMultiAccounts$1;
function requireCryptoMultiAccounts$1() {
  if (hasRequiredCryptoMultiAccounts$1) return CryptoMultiAccounts$1;
  hasRequiredCryptoMultiAccounts$1 = 1, Object.defineProperty(CryptoMultiAccounts$1, "__esModule", { value: !0 }), CryptoMultiAccounts$1.CryptoMultiAccounts = void 0;
  const s = requireRegistryType$1(), A = requireCryptoHDKey$1(), u = requireRegistryItem$1(), p = requireLib$7();
  var t;
  (function(m) {
    m[m.masterFingerprint = 1] = "masterFingerprint", m[m.keys = 2] = "keys", m[m.device = 3] = "device", m[m.deviceId = 4] = "deviceId", m[m.version = 5] = "version";
  })(t || (t = {}));
  class l extends u.RegistryItem {
    constructor(b, k, C, B, Q) {
      super(), this.masterFingerprint = b, this.keys = k, this.device = C, this.deviceId = B, this.version = Q, this.getRegistryType = () => s.RegistryTypes.CRYPTO_MULTI_ACCOUNTS, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeys = () => this.keys, this.getDevice = () => this.device, this.getDeviceId = () => this.deviceId, this.getVersion = () => this.version, this.toDataItem = () => {
        const P = {};
        return this.masterFingerprint && (P[t.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.keys && (P[t.keys] = this.keys.map((x) => {
          const M = x.toDataItem();
          return M.setTag(x.getRegistryType().getTag()), M;
        })), this.device && (P[t.device] = this.device), this.deviceId && (P[t.deviceId] = this.deviceId), this.version && (P[t.version] = this.version), new p.DataItem(P);
      };
    }
  }
  return CryptoMultiAccounts$1.CryptoMultiAccounts = l, l.fromDataItem = (m) => {
    const b = m.getData(), k = Buffer.alloc(4), C = b[t.masterFingerprint];
    C && k.writeUInt32BE(C, 0);
    const Q = b[t.keys].map((F) => A.CryptoHDKey.fromDataItem(F)), P = b[t.device], x = b[t.deviceId], M = b[t.version];
    return new l(k, Q, P, x, M);
  }, l.fromCBOR = (m) => {
    const b = (0, p.decodeToDataItem)(m);
    return l.fromDataItem(b);
  }, CryptoMultiAccounts$1;
}
var QRHardwareCall$1 = {}, KeyDerivation$1 = {}, DerivationSchema$1 = {}, hasRequiredDerivationSchema$1;
function requireDerivationSchema$1() {
  return hasRequiredDerivationSchema$1 || (hasRequiredDerivationSchema$1 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.KeyDerivationSchema = s.DerivationAlgorithm = s.Curve = void 0;
    const A = requireRegistryType$1(), u = requireRegistryItem$1(), p = requireLib$7(), t = requireCryptoKeypath$1();
    var l;
    (function(C) {
      C[C.keyPath = 1] = "keyPath", C[C.curve = 2] = "curve", C[C.algo = 3] = "algo", C[C.chainType = 4] = "chainType";
    })(l || (l = {}));
    var m;
    (function(C) {
      C[C.secp256k1 = 0] = "secp256k1", C[C.ed25519 = 1] = "ed25519";
    })(m = s.Curve || (s.Curve = {}));
    var b;
    (function(C) {
      C[C.slip10 = 0] = "slip10", C[C.bip32ed25519 = 1] = "bip32ed25519";
    })(b = s.DerivationAlgorithm || (s.DerivationAlgorithm = {}));
    class k extends u.RegistryItem {
      constructor(B, Q = m.secp256k1, P = b.slip10, x) {
        super(), this.keypath = B, this.curve = Q, this.algo = P, this.chainType = x, this.getRegistryType = () => A.RegistryTypes.KEY_DERIVATION_SCHEMA, this.getKeypath = () => this.keypath, this.getCurve = () => this.curve, this.getAlgo = () => this.algo, this.getChainType = () => this.chainType, this.toDataItem = () => {
          const M = {}, F = this.getKeypath().toDataItem();
          return F.setTag(this.getKeypath().getRegistryType().getTag()), M[l.keyPath] = F, M[l.curve] = this.curve, M[l.algo] = this.algo, this.chainType && (M[l.chainType] = this.chainType), new p.DataItem(M);
        };
      }
    }
    s.KeyDerivationSchema = k, k.fromDataItem = (C) => {
      const B = C.getData(), Q = t.CryptoKeypath.fromDataItem(B[l.keyPath]), P = B[l.curve], x = B[l.algo], M = B[l.chainType];
      return new k(Q, P, x, M);
    }, k.fromCBOR = (C) => {
      const B = (0, p.decodeToDataItem)(C);
      return k.fromDataItem(B);
    };
  }(DerivationSchema$1)), DerivationSchema$1;
}
var hasRequiredKeyDerivation$1;
function requireKeyDerivation$1() {
  if (hasRequiredKeyDerivation$1) return KeyDerivation$1;
  hasRequiredKeyDerivation$1 = 1, Object.defineProperty(KeyDerivation$1, "__esModule", { value: !0 }), KeyDerivation$1.KeyDerivation = void 0;
  const s = requireRegistryType$1(), A = requireRegistryItem$1(), u = requireLib$7(), p = requireDerivationSchema$1();
  var t;
  (function(m) {
    m[m.schemas = 1] = "schemas";
  })(t || (t = {}));
  class l extends A.RegistryItem {
    constructor(b) {
      super(), this.schemas = b, this.getRegistryType = () => s.RegistryTypes.KEY_DERIVATION_CALL, this.getSchemas = () => this.schemas, this.toDataItem = () => {
        const k = {};
        return k[t.schemas] = this.schemas.map((C) => {
          const B = C.toDataItem();
          return B.setTag(C.getRegistryType().getTag()), B;
        }), new u.DataItem(k);
      };
    }
  }
  return KeyDerivation$1.KeyDerivation = l, l.fromDataItem = (m) => {
    const k = m.getData()[t.schemas].map((C) => p.KeyDerivationSchema.fromDataItem(C));
    return new l(k);
  }, l.fromCBOR = (m) => {
    const b = (0, u.decodeToDataItem)(m);
    return l.fromDataItem(b);
  }, KeyDerivation$1;
}
var hasRequiredQRHardwareCall$1;
function requireQRHardwareCall$1() {
  return hasRequiredQRHardwareCall$1 || (hasRequiredQRHardwareCall$1 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.QRHardwareCall = s.QRHardwareCallVersion = s.QRHardwareCallType = void 0;
    const A = requireRegistryType$1(), u = requireRegistryItem$1(), p = requireLib$7(), t = requireKeyDerivation$1();
    var l;
    (function(k) {
      k[k.type = 1] = "type", k[k.params = 2] = "params", k[k.origin = 3] = "origin", k[k.version = 4] = "version";
    })(l || (l = {}));
    var m;
    (function(k) {
      k[k.KeyDerivation = 0] = "KeyDerivation";
    })(m = s.QRHardwareCallType || (s.QRHardwareCallType = {})), function(k) {
      k[k.V0 = 0] = "V0", k[k.V1 = 1] = "V1";
    }(s.QRHardwareCallVersion || (s.QRHardwareCallVersion = {}));
    class b extends u.RegistryItem {
      constructor(C, B, Q, P) {
        super(), this.type = C, this.params = B, this.origin = Q, this.version = P, this.getRegistryType = () => A.RegistryTypes.QR_HARDWARE_CALL, this.getType = () => this.type, this.getParams = () => this.params, this.getOrigin = () => this.origin, this.getVersion = () => this.version, this.toDataItem = () => {
          const x = {};
          x[l.type] = this.type;
          const M = this.params.toDataItem();
          return M.setTag(this.params.getRegistryType().getTag()), x[l.params] = M, this.origin && (x[l.origin] = this.origin), this.version && (x[l.version] = this.version), new p.DataItem(x);
        };
      }
    }
    s.QRHardwareCall = b, b.fromDataItem = (k) => {
      const C = k.getData(), B = C[l.type] || m.KeyDerivation;
      let Q;
      switch (B) {
        case m.KeyDerivation:
          Q = t.KeyDerivation.fromDataItem(C[l.params]);
      }
      const P = C[l.origin], x = C[l.version];
      return new b(B, Q, P, x);
    }, b.fromCBOR = (k) => {
      const C = (0, p.decodeToDataItem)(k);
      return b.fromDataItem(C);
    };
  }(QRHardwareCall$1)), QRHardwareCall$1;
}
var types$7 = {}, hasRequiredTypes$7;
function requireTypes$7() {
  return hasRequiredTypes$7 || (hasRequiredTypes$7 = 1, Object.defineProperty(types$7, "__esModule", { value: !0 })), types$7;
}
var hasRequiredDist$j;
function requireDist$j() {
  return hasRequiredDist$j || (hasRequiredDist$j = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.Buffer = s.extend = s.PathComponent = s.ScriptExpressions = s.MultiKey = s.CryptoPSBT = s.CryptoOutput = s.CryptoECKey = s.CryptoCoinInfoNetwork = s.CryptoCoinInfoType = s.CryptoCoinInfo = s.CryptoKeypath = s.CryptoMultiAccounts = s.CryptoHDKey = s.CryptoAccount = s.Bytes = s.URRegistryDecoder = s.DataItem = void 0;
    const A = require$$0$2;
    requirePatchCBOR$1();
    const u = requireDist$n();
    Object.defineProperty(s, "Buffer", { enumerable: !0, get: function() {
      return u.Buffer;
    } });
    const p = requireCryptoHDKey$1();
    Object.defineProperty(s, "CryptoHDKey", { enumerable: !0, get: function() {
      return p.CryptoHDKey;
    } });
    const t = requireCryptoKeypath$1();
    Object.defineProperty(s, "CryptoKeypath", { enumerable: !0, get: function() {
      return t.CryptoKeypath;
    } });
    const l = requireCryptoCoinInfo$1();
    Object.defineProperty(s, "CryptoCoinInfo", { enumerable: !0, get: function() {
      return l.CryptoCoinInfo;
    } }), Object.defineProperty(s, "CryptoCoinInfoType", { enumerable: !0, get: function() {
      return l.Type;
    } }), Object.defineProperty(s, "CryptoCoinInfoNetwork", { enumerable: !0, get: function() {
      return l.Network;
    } });
    const m = requireCryptoECKey$1();
    Object.defineProperty(s, "CryptoECKey", { enumerable: !0, get: function() {
      return m.CryptoECKey;
    } });
    const b = requireBytes$3();
    Object.defineProperty(s, "Bytes", { enumerable: !0, get: function() {
      return b.Bytes;
    } });
    const k = requireCryptoOutput$1();
    Object.defineProperty(s, "CryptoOutput", { enumerable: !0, get: function() {
      return k.CryptoOutput;
    } });
    const C = requireCryptoPSBT$1();
    Object.defineProperty(s, "CryptoPSBT", { enumerable: !0, get: function() {
      return C.CryptoPSBT;
    } });
    const B = requireCryptoAccount$1();
    Object.defineProperty(s, "CryptoAccount", { enumerable: !0, get: function() {
      return B.CryptoAccount;
    } });
    const Q = requireDecoder$1();
    Object.defineProperty(s, "URRegistryDecoder", { enumerable: !0, get: function() {
      return Q.URRegistryDecoder;
    } });
    const P = requireMultiKey$1();
    Object.defineProperty(s, "MultiKey", { enumerable: !0, get: function() {
      return P.MultiKey;
    } });
    const x = requireScriptExpression$1();
    Object.defineProperty(s, "ScriptExpressions", { enumerable: !0, get: function() {
      return x.ScriptExpressions;
    } });
    const M = requirePathComponent$1();
    Object.defineProperty(s, "PathComponent", { enumerable: !0, get: function() {
      return M.PathComponent;
    } });
    const F = requireRegistryItem$1(), le = requireRegistryType$1(), ge = requireLib$7();
    var pe = requireLib$7();
    Object.defineProperty(s, "DataItem", { enumerable: !0, get: function() {
      return pe.DataItem;
    } });
    const Ie = requireUtils$f(), be = requireCryptoMultiAccounts$1();
    Object.defineProperty(s, "CryptoMultiAccounts", { enumerable: !0, get: function() {
      return be.CryptoMultiAccounts;
    } });
    const Pe = {
      URRegistryDecoder: Q.URRegistryDecoder,
      Bytes: b.Bytes,
      CryptoAccount: B.CryptoAccount,
      CryptoHDKey: p.CryptoHDKey,
      CryptoMultiAccounts: be.CryptoMultiAccounts,
      CryptoKeypath: t.CryptoKeypath,
      CryptoCoinInfo: l.CryptoCoinInfo,
      CryptoCoinInfoType: l.Type,
      CryptoCoinInfoNetwork: l.Network,
      CryptoECKey: m.CryptoECKey,
      CryptoOutput: k.CryptoOutput,
      CryptoPSBT: C.CryptoPSBT,
      MultiKey: P.MultiKey,
      ScriptExpressions: x.ScriptExpressions,
      PathComponent: M.PathComponent
    }, Te = {
      addReader: ge.addReader,
      addSemanticDecode: ge.addSemanticDecode,
      addSemanticEncode: ge.addSemanticEncode,
      addWriter: ge.addWriter,
      patchTags: Ie.patchTags
    }, Qe = {
      RegistryTypes: le.RegistryTypes,
      RegistryItem: F.RegistryItem,
      RegistryType: le.RegistryType,
      decodeToDataItem: ge.decodeToDataItem,
      encodeDataItem: ge.encodeDataItem,
      cbor: Te
    };
    s.extend = Qe, (0, A.__exportStar)(requireErrors$2(), s), (0, A.__exportStar)(requireDecoder$1(), s), (0, A.__exportStar)(requireLib$7(), s), (0, A.__exportStar)(requireCryptoAccount$1(), s), (0, A.__exportStar)(requireCryptoPSBT$1(), s), (0, A.__exportStar)(requireCryptoHDKey$1(), s), (0, A.__exportStar)(requireCryptoMultiAccounts$1(), s), (0, A.__exportStar)(requireQRHardwareCall$1(), s), (0, A.__exportStar)(requireKeyDerivation$1(), s), (0, A.__exportStar)(requireDerivationSchema$1(), s), (0, A.__exportStar)(requireCryptoOutput$1(), s), (0, A.__exportStar)(requireCryptoCoinInfo$1(), s), (0, A.__exportStar)(requireCryptoECKey$1(), s), (0, A.__exportStar)(requireMultiKey$1(), s), (0, A.__exportStar)(requireCryptoKeypath$1(), s), (0, A.__exportStar)(requirePatchCBOR$1(), s), (0, A.__exportStar)(requirePathComponent$1(), s), (0, A.__exportStar)(requireRegistryItem$1(), s), (0, A.__exportStar)(requireRegistryType$1(), s), (0, A.__exportStar)(requireTypes$7(), s), (0, A.__exportStar)(requireUtils$f(), s), s.default = Pe;
  }(dist$j)), dist$j;
}
var hasRequiredCrypto$2;
function requireCrypto$2() {
  if (hasRequiredCrypto$2) return crypto$5;
  hasRequiredCrypto$2 = 1, Object.defineProperty(crypto$5, "__esModule", { value: !0 }), crypto$5.pathToKeypath = void 0;
  const s = requireDist$j(), A = (u) => {
    const t = u.replace(/[m|M]\//, "").split("/").map((l) => {
      const m = parseInt(l.replace("'", ""), 10), b = l.endsWith("'");
      return new s.PathComponent({ index: m, hardened: b });
    });
    return new s.CryptoKeypath(t);
  };
  return crypto$5.pathToKeypath = A, crypto$5;
}
var hasRequiredUtils$d;
function requireUtils$d() {
  return hasRequiredUtils$d || (hasRequiredUtils$d = 1, function(s) {
    var A = utils$h && utils$h.__createBinding || (Object.create ? function(p, t, l, m) {
      m === void 0 && (m = l);
      var b = Object.getOwnPropertyDescriptor(t, l);
      (!b || ("get" in b ? !t.__esModule : b.writable || b.configurable)) && (b = { enumerable: !0, get: function() {
        return t[l];
      } }), Object.defineProperty(p, m, b);
    } : function(p, t, l, m) {
      m === void 0 && (m = l), p[m] = t[l];
    }), u = utils$h && utils$h.__exportStar || function(p, t) {
      for (var l in p) l !== "default" && !Object.prototype.hasOwnProperty.call(t, l) && A(t, p, l);
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), u(requireStringHelper(), s), u(requireCrypto$2(), s), u(requireCoin$1(), s);
  }(utils$h)), utils$h;
}
var sdk = {}, chains = {}, bitcoin$1 = {}, dist$h = { exports: {} }, bcUrRegistryBtc_cjs_production_min = {}, dist$g = {}, patchCBOR = {}, utils$e = {}, lib$6 = {}, cborSync$1 = { exports: {} }, DataItem = {}, hasRequiredDataItem;
function requireDataItem() {
  if (hasRequiredDataItem) return DataItem;
  hasRequiredDataItem = 1, Object.defineProperty(DataItem, "__esModule", { value: !0 }), DataItem.DataItem = void 0;
  let s = class {
    constructor(u, p) {
      this.setTag = (t) => {
        this.tag = t;
      }, this.clearTag = () => {
        this.tag = void 0;
      }, this.getTag = () => this.tag, this.getData = () => this.data, this.data = u, this.tag = p;
    }
  };
  return DataItem.DataItem = s, DataItem;
}
var cborSync = cborSync$1.exports, hasRequiredCborSync;
function requireCborSync() {
  return hasRequiredCborSync || (hasRequiredCborSync = 1, function(s) {
    (function(A, u) {
      s.exports ? s.exports = u() : A.CBOR = u();
    })(cborSync, function() {
      const { DataItem: A } = requireDataItem();
      var u = function() {
        function p(Qe) {
          this.$hex = Qe;
        }
        p.prototype = {
          length: function() {
            return this.$hex.length / 2;
          },
          toString: function(Qe) {
            if (!Qe || Qe === "hex" || Qe === 16)
              return this.$hex;
            if (Qe === "utf-8") {
              for (var xe = "", Ee = 0; Ee < this.$hex.length; Ee += 2)
                xe += "%" + this.$hex.substring(Ee, Ee + 2);
              return decodeURIComponent(xe);
            }
            if (Qe === "latin") {
              for (var xe = [], Ee = 0; Ee < this.$hex.length; Ee += 2)
                xe.push(parseInt(this.$hex.substring(Ee, Ee + 2), 16));
              return String.fromCharCode.apply(String, xe);
            }
            throw new Error("Unrecognised format: " + Qe);
          }
        }, p.fromLatinString = function(Qe) {
          for (var xe = "", Ee = 0; Ee < Qe.length; Ee++) {
            var He = Qe.charCodeAt(Ee).toString(16);
            He.length === 1 && (He = "0" + He), xe += He;
          }
          return new p(xe);
        }, p.fromUtf8String = function(Qe) {
          for (var xe = encodeURIComponent(Qe), Ee = "", He = 0; He < xe.length; He++)
            if (xe.charAt(He) === "%")
              Ee += xe.substring(He + 1, He + 3), He += 2;
            else {
              var ve = xe.charCodeAt(He).toString(16);
              ve.length < 2 && (ve = "0" + ve), Ee += ve;
            }
          return new p(Ee);
        };
        var t = [], l = {}, m = function(Qe) {
          return function() {
            throw new Error(Qe + " not implemented");
          };
        };
        function b() {
        }
        b.prototype = {
          peekByte: m("peekByte"),
          readByte: m("readByte"),
          readChunk: m("readChunk"),
          readFloat16: function() {
            var Qe = this.readUint16(), xe = (Qe & 32767) >> 10, Ee = Qe & 1023, He = Qe & 32768;
            if (xe === 31)
              return Ee === 0 ? He ? -1 / 0 : 1 / 0 : NaN;
            var ve = xe ? Math.pow(2, xe - 25) * (1024 + Ee) : Math.pow(2, -24) * Ee;
            return He ? -ve : ve;
          },
          readFloat32: function() {
            var Qe = this.readUint32(), xe = (Qe & 2147483647) >> 23, Ee = Qe & 8388607, He = Qe & 2147483648;
            if (xe === 255)
              return Ee === 0 ? He ? -1 / 0 : 1 / 0 : NaN;
            var ve = xe ? Math.pow(2, xe - 23 - 127) * (8388608 + Ee) : Math.pow(2, -149) * Ee;
            return He ? -ve : ve;
          },
          readFloat64: function() {
            var Qe = this.readUint32(), xe = this.readUint32(), Ee = Qe >> 20 & 2047, He = (Qe & 1048575) * 4294967296 + xe, ve = Qe & 2147483648;
            if (Ee === 2047)
              return He === 0 ? ve ? -1 / 0 : 1 / 0 : NaN;
            var we = Ee ? Math.pow(2, Ee - 52 - 1023) * (4503599627370496 + He) : Math.pow(2, -1074) * He;
            return ve ? -we : we;
          },
          readUint16: function() {
            return this.readByte() * 256 + this.readByte();
          },
          readUint32: function() {
            return this.readUint16() * 65536 + this.readUint16();
          },
          readUint64: function() {
            return this.readUint32() * 4294967296 + this.readUint32();
          }
        };
        function k() {
        }
        k.prototype = {
          writeByte: m("writeByte"),
          result: m("result"),
          writeFloat16: m("writeFloat16"),
          writeFloat32: m("writeFloat32"),
          writeFloat64: m("writeFloat64"),
          writeUint16: function(Qe) {
            this.writeByte(Qe >> 8 & 255), this.writeByte(Qe & 255);
          },
          writeUint32: function(Qe) {
            this.writeUint16(Qe >> 16 & 65535), this.writeUint16(Qe & 65535);
          },
          writeUint64: function(Qe) {
            if (Qe >= 9007199254740992 || Qe <= -9007199254740992)
              throw new Error("Cannot encode Uint64 of: " + Qe + " magnitude to big (floating point errors)");
            this.writeUint32(Math.floor(Qe / 4294967296)), this.writeUint32(Qe % 4294967296);
          },
          writeString: m("writeString"),
          canWriteBinary: function(Qe) {
            return !1;
          },
          writeBinary: m("writeChunk")
        };
        function C(Qe) {
          var xe = Qe.readByte(), Ee = xe >> 5, He = xe & 31;
          return { type: Ee, value: He };
        }
        function B(Qe, xe) {
          var Ee = Qe.value;
          if (Ee < 24)
            return Ee;
          if (Ee == 24)
            return xe.readByte();
          if (Ee == 25)
            return xe.readUint16();
          if (Ee == 26)
            return xe.readUint32();
          if (Ee == 27)
            return xe.readUint64();
          if (Ee == 31)
            return null;
          m("Additional info: " + Ee)();
        }
        function Q(Qe, xe, Ee) {
          Ee.writeByte(Qe << 5 | xe);
        }
        function P(Qe, xe, Ee) {
          var He = Qe << 5;
          xe < 24 ? Ee.writeByte(He | xe) : xe < 256 ? (Ee.writeByte(He | 24), Ee.writeByte(xe)) : xe < 65536 ? (Ee.writeByte(He | 25), Ee.writeUint16(xe)) : xe < 4294967296 ? (Ee.writeByte(He | 26), Ee.writeUint32(xe)) : (Ee.writeByte(He | 27), Ee.writeUint64(xe));
        }
        var x = new Error();
        function M(Qe) {
          var xe = C(Qe);
          switch (xe.type) {
            case 0:
              return B(xe, Qe);
            case 1:
              return -1 - B(xe, Qe);
            case 2:
              return Qe.readChunk(B(xe, Qe));
            case 3:
              var Ee = Qe.readChunk(B(xe, Qe));
              return Ee.toString("utf-8");
            case 4:
            case 5:
              var He = B(xe, Qe), rr = [];
              if (He !== null) {
                xe.type === 5 && (He *= 2);
                for (var ve = 0; ve < He; ve++)
                  rr[ve] = M(Qe);
              } else
                for (var we; (we = M(Qe)) !== x; )
                  rr.push(we);
              if (xe.type === 5) {
                for (var Ce = {}, ve = 0; ve < rr.length; ve += 2)
                  Ce[rr[ve]] = rr[ve + 1];
                return Ce;
              } else
                return rr;
            case 6:
              var Se = B(xe, Qe), Ne = l[Se], rr = M(Qe);
              return Ne ? Ne(rr) : rr;
            case 7:
              if (xe.value === 25)
                return Qe.readFloat16();
              if (xe.value === 26)
                return Qe.readFloat32();
              if (xe.value === 27)
                return Qe.readFloat64();
              switch (B(xe, Qe)) {
                case 20:
                  return !1;
                case 21:
                  return !0;
                case 22:
                  return null;
                case 23:
                  return;
                case null:
                  return x;
                default:
                  throw new Error("Unknown fixed value: " + xe.value);
              }
            default:
              throw new Error("Unsupported header: " + JSON.stringify(xe));
          }
          throw new Error("not implemented yet");
        }
        function F(Qe, xe) {
          for (var Ee = 0; Ee < t.length; Ee++) {
            var He = t[Ee].fn(Qe);
            if (He !== void 0)
              return P(6, t[Ee].tag, xe), F(He, xe);
          }
          if (Qe && typeof Qe.toCBOR == "function" && (Qe = Qe.toCBOR()), Qe === !1)
            P(7, 20, xe);
          else if (Qe === !0)
            P(7, 21, xe);
          else if (Qe === null)
            P(7, 22, xe);
          else if (Qe === void 0)
            P(7, 23, xe);
          else if (typeof Qe == "number")
            Math.floor(Qe) === Qe && Qe < 9007199254740992 && Qe > -9007199254740992 ? Qe < 0 ? P(1, -1 - Qe, xe) : P(0, Qe, xe) : (Q(7, 27, xe), xe.writeFloat64(Qe));
          else if (typeof Qe == "string")
            xe.writeString(Qe, function(we) {
              P(3, we, xe);
            });
          else if (xe.canWriteBinary(Qe))
            xe.writeBinary(Qe, function(we) {
              P(2, we, xe);
            });
          else if (typeof Qe == "object")
            if (pe.config.useToJSON && typeof Qe.toJSON == "function" && (Qe = Qe.toJSON()), Array.isArray(Qe)) {
              P(4, Qe.length, xe);
              for (var Ee = 0; Ee < Qe.length; Ee++)
                F(Qe[Ee], xe);
            } else {
              var ve = Object.keys(Qe);
              P(5, ve.length, xe);
              for (var Ee = 0; Ee < ve.length; Ee++) {
                const Ce = parseInt(ve[Ee]);
                isNaN(Ce) ? (F(ve[Ee], xe), F(Qe[ve[Ee]], xe)) : (F(Ce, xe), F(Qe[ve[Ee]], xe));
              }
            }
          else
            throw new Error("CBOR encoding not supported: " + Qe);
        }
        var le = [], ge = [], pe = {
          config: {
            useToJSON: !0
          },
          addWriter: function(Qe, xe) {
            typeof Qe == "string" ? ge.push(function(Ee) {
              if (Qe === Ee)
                return xe(Ee);
            }) : ge.push(Qe);
          },
          addReader: function(Qe, xe) {
            typeof Qe == "string" ? le.push(function(Ee, He) {
              if (Qe === He)
                return xe(Ee, He);
            }) : le.push(Qe);
          },
          encode: function(Qe, xe) {
            for (var Ee = 0; Ee < ge.length; Ee++) {
              var He = ge[Ee], ve = He(xe);
              if (ve)
                return F(Qe, ve), ve.result();
            }
            throw new Error("Unsupported output format: " + xe);
          },
          encodeDataItem: function(Qe, xe) {
            for (var Ee = 0; Ee < ge.length; Ee++) {
              var He = ge[Ee], ve = He(xe);
              if (ve)
                return Qe.getTag() !== void 0 ? (F(Qe, ve), ve.result()) : (F(Qe.getData(), ve), ve.result());
            }
            throw new Error("Unsupported output format: " + xe);
          },
          decode: function(Qe, xe) {
            for (var Ee = 0; Ee < le.length; Ee++) {
              var He = le[Ee], ve = He(Qe, xe);
              if (ve)
                return M(ve);
            }
            throw new Error("Unsupported input format: " + xe);
          },
          decodeToDataItem: function(Qe, xe) {
            for (var Ee = 0; Ee < le.length; Ee++) {
              var He = le[Ee], ve = He(Qe, xe);
              if (ve) {
                const we = M(ve);
                return we instanceof A ? we : new A(we);
              }
            }
            throw new Error("Unsupported input format: " + xe);
          },
          addSemanticEncode: function(Qe, xe) {
            if (typeof Qe != "number" || Qe % 1 !== 0 || Qe < 0)
              throw new Error("Tag must be a positive integer");
            return t.push({ tag: Qe, fn: xe }), this;
          },
          addSemanticDecode: function(Qe, xe) {
            if (typeof Qe != "number" || Qe % 1 !== 0 || Qe < 0)
              throw new Error("Tag must be a positive integer");
            return l[Qe] = xe, this;
          }
        };
        function Ie(Qe) {
          this.buffer = Qe, this.pos = 0;
        }
        Ie.prototype = Object.create(b.prototype), Ie.prototype.peekByte = function() {
          return this.buffer[this.pos];
        }, Ie.prototype.readByte = function() {
          return this.buffer[this.pos++];
        }, Ie.prototype.readUint16 = function() {
          var Qe = this.buffer.readUInt16BE(this.pos);
          return this.pos += 2, Qe;
        }, Ie.prototype.readUint32 = function() {
          var Qe = this.buffer.readUInt32BE(this.pos);
          return this.pos += 4, Qe;
        }, Ie.prototype.readFloat32 = function() {
          var Qe = this.buffer.readFloatBE(this.pos);
          return this.pos += 4, Qe;
        }, Ie.prototype.readFloat64 = function() {
          var Qe = this.buffer.readDoubleBE(this.pos);
          return this.pos += 8, Qe;
        }, Ie.prototype.readChunk = function(Qe) {
          var xe = Buffer.alloc(Qe);
          return this.buffer.copy(xe, 0, this.pos, this.pos += Qe), xe;
        };
        function be(Qe) {
          this.byteLength = 0, this.defaultBufferLength = 16384, this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0, this.completeBuffers = [], this.stringFormat = Qe;
        }
        be.prototype = Object.create(k.prototype), be.prototype.writeByte = function(Qe) {
          this.latestBuffer[this.latestBufferOffset++] = Qe, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0), this.byteLength++;
        }, be.prototype.writeFloat32 = function(Qe) {
          var xe = Buffer.alloc(4);
          xe.writeFloatBE(Qe, 0), this.writeBuffer(xe);
        }, be.prototype.writeFloat64 = function(Qe) {
          var xe = Buffer.alloc(8);
          xe.writeDoubleBE(Qe, 0), this.writeBuffer(xe);
        }, be.prototype.writeString = function(Qe, xe) {
          var Ee = Buffer.from(Qe, "utf-8");
          xe(Ee.length), this.writeBuffer(Ee);
        }, be.prototype.canWriteBinary = function(Qe) {
          return Qe instanceof Buffer;
        }, be.prototype.writeBinary = function(Qe, xe) {
          xe(Qe.length), this.writeBuffer(Qe);
        }, be.prototype.writeBuffer = function(Qe) {
          if (!(Qe instanceof Buffer))
            throw new TypeError("BufferWriter only accepts Buffers");
          this.latestBufferOffset ? this.latestBuffer.length - this.latestBufferOffset >= Qe.length ? (Qe.copy(this.latestBuffer, this.latestBufferOffset), this.latestBufferOffset += Qe.length, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0)) : (this.completeBuffers.push(this.latestBuffer.slice(0, this.latestBufferOffset)), this.completeBuffers.push(Qe), this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0) : this.completeBuffers.push(Qe), this.byteLength += Qe.length;
        }, be.prototype.result = function() {
          for (var Qe = Buffer.alloc(this.byteLength), xe = 0, Ee = 0; Ee < this.completeBuffers.length; Ee++) {
            var He = this.completeBuffers[Ee];
            He.copy(Qe, xe, 0, He.length), xe += He.length;
          }
          return this.latestBufferOffset && this.latestBuffer.copy(Qe, xe, 0, this.latestBufferOffset), this.stringFormat ? Qe.toString(this.stringFormat) : Qe;
        }, typeof Buffer == "function" && (pe.addReader(function(Qe, xe) {
          if (Buffer.isBuffer(Qe))
            return new Ie(Qe);
          if (xe === "hex" || xe === "base64") {
            var Ee = Buffer.from(Qe, xe);
            return new Ie(Ee);
          }
        }), pe.addWriter(function(Qe) {
          if (!Qe || Qe === "buffer")
            return new be();
          if (Qe === "hex" || Qe === "base64")
            return new be(Qe);
        }));
        function Pe(Qe) {
          this.hex = Qe, this.pos = 0;
        }
        Pe.prototype = Object.create(b.prototype), Pe.prototype.peekByte = function() {
          var Qe = this.hex.substring(this.pos, 2);
          return parseInt(Qe, 16);
        }, Pe.prototype.readByte = function() {
          var Qe = this.hex.substring(this.pos, this.pos + 2);
          return this.pos += 2, parseInt(Qe, 16);
        }, Pe.prototype.readChunk = function(Qe) {
          var xe = this.hex.substring(this.pos, this.pos + Qe * 2);
          return this.pos += Qe * 2, typeof Buffer == "function" ? Buffer.from(xe, "hex") : new p(xe);
        };
        function Te(Qe) {
          this.$hex = "", this.finalFormat = Qe || "hex";
        }
        return Te.prototype = Object.create(k.prototype), Te.prototype.writeByte = function(Qe) {
          if (Qe < 0 || Qe > 255)
            throw new Error("Byte value out of range: " + Qe);
          var xe = Qe.toString(16);
          xe.length == 1 && (xe = "0" + xe), this.$hex += xe;
        }, Te.prototype.canWriteBinary = function(Qe) {
          return Qe instanceof p || typeof Buffer == "function" && Qe instanceof Buffer;
        }, Te.prototype.writeBinary = function(Qe, xe) {
          if (Qe instanceof p)
            xe(Qe.length()), this.$hex += Qe.$hex;
          else if (typeof Buffer == "function" && Qe instanceof Buffer)
            xe(Qe.length), this.$hex += Qe.toString("hex");
          else
            throw new TypeError("HexWriter only accepts BinaryHex or Buffers");
        }, Te.prototype.result = function() {
          return this.finalFormat === "buffer" && typeof Buffer == "function" ? Buffer.from(this.$hex, "hex") : new p(this.$hex).toString(this.finalFormat);
        }, Te.prototype.writeString = function(Qe, xe) {
          var Ee = p.fromUtf8String(Qe);
          xe(Ee.length()), this.$hex += Ee.$hex;
        }, pe.addReader(function(Qe, xe) {
          if (Qe instanceof p || Qe.$hex)
            return new Pe(Qe.$hex);
          if (xe === "hex")
            return new Pe(Qe);
        }), pe.addWriter(function(Qe) {
          if (Qe === "hex")
            return new Te();
        }), pe;
      }();
      return u.addSemanticEncode(0, function(p) {
        if (p instanceof Date)
          return p.toISOString();
      }).addSemanticDecode(0, function(p) {
        return new Date(p);
      }).addSemanticDecode(1, function(p) {
        return new Date(p);
      }), u;
    });
  }(cborSync$1)), cborSync$1.exports;
}
var hasRequiredLib$6;
function requireLib$6() {
  return hasRequiredLib$6 || (hasRequiredLib$6 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.DataItem = s.addWriter = s.addReader = s.addSemanticEncode = s.addSemanticDecode = s.decodeToDataItem = s.encodeDataItem = void 0;
    var A = requireCborSync();
    Object.defineProperty(s, "encodeDataItem", { enumerable: !0, get: function() {
      return A.encodeDataItem;
    } }), Object.defineProperty(s, "decodeToDataItem", { enumerable: !0, get: function() {
      return A.decodeToDataItem;
    } }), Object.defineProperty(s, "addSemanticDecode", { enumerable: !0, get: function() {
      return A.addSemanticDecode;
    } }), Object.defineProperty(s, "addSemanticEncode", { enumerable: !0, get: function() {
      return A.addSemanticEncode;
    } }), Object.defineProperty(s, "addReader", { enumerable: !0, get: function() {
      return A.addReader;
    } }), Object.defineProperty(s, "addWriter", { enumerable: !0, get: function() {
      return A.addWriter;
    } });
    var u = requireDataItem();
    Object.defineProperty(s, "DataItem", { enumerable: !0, get: function() {
      return u.DataItem;
    } });
  }(lib$6)), lib$6;
}
var hasRequiredUtils$c;
function requireUtils$c() {
  if (hasRequiredUtils$c) return utils$e;
  hasRequiredUtils$c = 1, Object.defineProperty(utils$e, "__esModule", { value: !0 }), utils$e.patchTags = void 0;
  const s = requireLib$6(), A = [], u = (p) => {
    p.forEach((t) => {
      A.find((l) => l === t) || ((0, s.addSemanticEncode)(t, (l) => {
        if (l instanceof s.DataItem && l.getTag() === t)
          return l.getData();
      }), (0, s.addSemanticDecode)(t, (l) => new s.DataItem(l, t)), A.push(t));
    });
  };
  return utils$e.patchTags = u, utils$e;
}
var RegistryType = {}, hasRequiredRegistryType;
function requireRegistryType() {
  if (hasRequiredRegistryType) return RegistryType;
  hasRequiredRegistryType = 1, Object.defineProperty(RegistryType, "__esModule", { value: !0 }), RegistryType.RegistryTypes = RegistryType.RegistryType = void 0;
  let s = class {
    constructor(u, p) {
      this.type = u, this.tag = p, this.getTag = () => this.tag, this.getType = () => this.type;
    }
  };
  return RegistryType.RegistryType = s, RegistryType.RegistryTypes = {
    UUID: new s("uuid", 37),
    BYTES: new s("bytes", void 0),
    CRYPTO_HDKEY: new s("crypto-hdkey", 303),
    CRYPTO_KEYPATH: new s("crypto-keypath", 304),
    CRYPTO_COIN_INFO: new s("crypto-coin-info", 305),
    CRYPTO_ECKEY: new s("crypto-eckey", 306),
    CRYPTO_OUTPUT: new s("crypto-output", 308),
    CRYPTO_PSBT: new s("crypto-psbt", 310),
    CRYPTO_ACCOUNT: new s("crypto-account", 311),
    CRYPTO_MULTI_ACCOUNTS: new s("crypto-multi-accounts", 1103),
    QR_HARDWARE_CALL: new s("qr-hardware-call", 1201),
    KEY_DERIVATION_CALL: new s("key-derivation-call", 1301),
    KEY_DERIVATION_SCHEMA: new s("key-derivation-schema", 1302)
  }, RegistryType;
}
var ScriptExpression = {}, hasRequiredScriptExpression;
function requireScriptExpression() {
  return hasRequiredScriptExpression || (hasRequiredScriptExpression = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.ScriptExpressions = s.ScriptExpression = void 0;
    class A {
      constructor(p, t) {
        this.tag = p, this.expression = t, this.getTag = () => this.tag, this.getExpression = () => this.expression;
      }
    }
    s.ScriptExpression = A, A.fromTag = (u) => Object.values(s.ScriptExpressions).find((t) => t.getTag() === u), s.ScriptExpressions = {
      SCRIPT_HASH: new A(400, "sh"),
      WITNESS_SCRIPT_HASH: new A(401, "wsh"),
      PUBLIC_KEY: new A(402, "pk"),
      PUBLIC_KEY_HASH: new A(403, "pkh"),
      WITNESS_PUBLIC_KEY_HASH: new A(404, "wpkh"),
      COMBO: new A(405, "combo"),
      MULTISIG: new A(406, "multi"),
      SORTED_MULTISIG: new A(407, "sortedmulti"),
      ADDRESS: new A(307, "addr"),
      RAW_SCRIPT: new A(408, "raw")
    };
  }(ScriptExpression)), ScriptExpression;
}
var hasRequiredPatchCBOR;
function requirePatchCBOR() {
  if (hasRequiredPatchCBOR) return patchCBOR;
  hasRequiredPatchCBOR = 1, Object.defineProperty(patchCBOR, "__esModule", { value: !0 });
  const s = requireUtils$c(), A = requireRegistryType(), u = requireScriptExpression(), p = Object.values(A.RegistryTypes).filter((l) => !!l.getTag()).map((l) => l.getTag()), t = Object.values(u.ScriptExpressions).map((l) => l.getTag());
  return (0, s.patchTags)(p.concat(t)), patchCBOR;
}
var CryptoHDKey = {}, CryptoCoinInfo = {}, RegistryItem = {}, hasRequiredRegistryItem;
function requireRegistryItem() {
  if (hasRequiredRegistryItem) return RegistryItem;
  hasRequiredRegistryItem = 1, Object.defineProperty(RegistryItem, "__esModule", { value: !0 }), RegistryItem.RegistryItem = void 0;
  const s = requireDist$k(), A = requireLib$6();
  let u = class {
    constructor() {
      this.toCBOR = () => {
        if (this.toDataItem() === void 0)
          throw new Error(`#[ur-registry][RegistryItem][fn.toCBOR]: registry ${this.getRegistryType()}'s method toDataItem returns undefined`);
        return (0, A.encodeDataItem)(this.toDataItem());
      }, this.toUR = () => new s.UR(this.toCBOR(), this.getRegistryType().getType()), this.toUREncoder = (t, l, m) => {
        const b = this.toUR();
        return new s.UREncoder(b, t, l, m);
      };
    }
  };
  return RegistryItem.RegistryItem = u, RegistryItem;
}
var hasRequiredCryptoCoinInfo;
function requireCryptoCoinInfo() {
  return hasRequiredCryptoCoinInfo || (hasRequiredCryptoCoinInfo = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.CryptoCoinInfo = s.Network = s.Type = void 0;
    const A = requireLib$6(), u = requireRegistryItem(), p = requireRegistryType();
    var t;
    (function(k) {
      k.type = "1", k.network = "2";
    })(t || (t = {}));
    var l;
    (function(k) {
      k[k.bitcoin = 0] = "bitcoin";
    })(l = s.Type || (s.Type = {}));
    var m;
    (function(k) {
      k[k.mainnet = 0] = "mainnet", k[k.testnet = 1] = "testnet";
    })(m = s.Network || (s.Network = {}));
    class b extends u.RegistryItem {
      constructor(C, B) {
        super(), this.type = C, this.network = B, this.getRegistryType = () => p.RegistryTypes.CRYPTO_COIN_INFO, this.getType = () => this.type || l.bitcoin, this.getNetwork = () => this.network || m.mainnet, this.toDataItem = () => {
          const Q = {};
          return this.type && (Q[t.type] = this.type), this.network && (Q[t.network] = this.network), new A.DataItem(Q);
        };
      }
    }
    s.CryptoCoinInfo = b, b.fromDataItem = (k) => {
      const C = k.getData(), B = C[t.type], Q = C[t.network];
      return new b(B, Q);
    }, b.fromCBOR = (k) => {
      const C = (0, A.decodeToDataItem)(k);
      return b.fromDataItem(C);
    };
  }(CryptoCoinInfo)), CryptoCoinInfo;
}
var CryptoKeypath = {}, PathComponent = {}, hasRequiredPathComponent;
function requirePathComponent() {
  if (hasRequiredPathComponent) return PathComponent;
  hasRequiredPathComponent = 1, Object.defineProperty(PathComponent, "__esModule", { value: !0 }), PathComponent.PathComponent = void 0;
  let s = class y6 {
    constructor(u) {
      if (this.getIndex = () => this.index, this.isWildcard = () => this.wildcard, this.isHardened = () => this.hardened, this.index = u.index, this.hardened = u.hardened, this.index !== void 0 ? this.wildcard = !1 : this.wildcard = !0, this.index && (this.index & y6.HARDENED_BIT) !== 0)
        throw new Error(`#[ur-registry][PathComponent][fn.constructor]: Invalid index ${this.index} - most significant bit cannot be set`);
    }
  };
  return PathComponent.PathComponent = s, s.HARDENED_BIT = 2147483648, PathComponent;
}
var hasRequiredCryptoKeypath;
function requireCryptoKeypath() {
  if (hasRequiredCryptoKeypath) return CryptoKeypath;
  hasRequiredCryptoKeypath = 1, Object.defineProperty(CryptoKeypath, "__esModule", { value: !0 }), CryptoKeypath.CryptoKeypath = void 0;
  const s = requireLib$6(), A = requirePathComponent(), u = requireRegistryItem(), p = requireRegistryType();
  var t;
  (function(m) {
    m[m.components = 1] = "components", m[m.source_fingerprint = 2] = "source_fingerprint", m[m.depth = 3] = "depth";
  })(t || (t = {}));
  let l = class extends u.RegistryItem {
    constructor(b = [], k, C) {
      super(), this.components = b, this.sourceFingerprint = k, this.depth = C, this.getRegistryType = () => p.RegistryTypes.CRYPTO_KEYPATH, this.getPath = () => this.components.length === 0 ? void 0 : this.components.map((Q) => `${Q.isWildcard() ? "*" : Q.getIndex()}${Q.isHardened() ? "'" : ""}`).join("/"), this.getComponents = () => this.components, this.getSourceFingerprint = () => this.sourceFingerprint, this.getDepth = () => this.depth, this.toDataItem = () => {
        const B = {}, Q = [];
        return this.components && this.components.forEach((P) => {
          P.isWildcard() ? Q.push([]) : Q.push(P.getIndex()), Q.push(P.isHardened());
        }), B[t.components] = Q, this.sourceFingerprint && (B[t.source_fingerprint] = this.sourceFingerprint.readUInt32BE(0)), this.depth !== void 0 && (B[t.depth] = this.depth), new s.DataItem(B);
      };
    }
  };
  return CryptoKeypath.CryptoKeypath = l, l.fromDataItem = (m) => {
    const b = m.getData(), k = [], C = b[t.components];
    if (C)
      for (let x = 0; x < C.length; x += 2) {
        const M = C[x + 1], F = C[x];
        typeof F == "number" ? k.push(new A.PathComponent({ index: F, hardened: M })) : k.push(new A.PathComponent({ hardened: M }));
      }
    const B = b[t.source_fingerprint];
    let Q;
    B && (Q = Buffer.alloc(4), Q.writeUInt32BE(B, 0));
    const P = b[t.depth];
    return new l(k, Q, P);
  }, l.fromCBOR = (m) => {
    const b = (0, s.decodeToDataItem)(m);
    return l.fromDataItem(b);
  }, CryptoKeypath;
}
var hasRequiredCryptoHDKey;
function requireCryptoHDKey() {
  if (hasRequiredCryptoHDKey) return CryptoHDKey;
  hasRequiredCryptoHDKey = 1, Object.defineProperty(CryptoHDKey, "__esModule", { value: !0 }), CryptoHDKey.CryptoHDKey = void 0;
  const s = requireBs58check(), A = requireCryptoCoinInfo(), u = requireCryptoKeypath(), p = requireLib$6(), t = requireRegistryItem(), l = requireRegistryType();
  var m;
  (function(k) {
    k[k.is_master = 1] = "is_master", k[k.is_private = 2] = "is_private", k[k.key_data = 3] = "key_data", k[k.chain_code = 4] = "chain_code", k[k.use_info = 5] = "use_info", k[k.origin = 6] = "origin", k[k.children = 7] = "children", k[k.parent_fingerprint = 8] = "parent_fingerprint", k[k.name = 9] = "name", k[k.note = 10] = "note";
  })(m || (m = {}));
  let b = class extends t.RegistryItem {
    constructor(C) {
      super(), this.isECKey = () => !1, this.getKey = () => this.key, this.getChainCode = () => this.chainCode, this.isMaster = () => this.master, this.isPrivateKey = () => !!this.privateKey, this.getUseInfo = () => this.useInfo, this.getOrigin = () => this.origin, this.getChildren = () => this.children, this.getParentFingerprint = () => this.parentFingerprint, this.getName = () => this.name, this.getNote = () => this.note, this.getBip32Key = () => {
        var B, Q, P;
        let x, M, F = 0, le = Buffer.alloc(4).fill(0);
        if (this.isMaster())
          x = Buffer.from("0488ADE4", "hex"), M = 0, F = 0;
        else {
          M = ((B = this.getOrigin()) === null || B === void 0 ? void 0 : B.getComponents().length) || ((Q = this.getOrigin()) === null || Q === void 0 ? void 0 : Q.getDepth());
          const Pe = (P = this.getOrigin()) === null || P === void 0 ? void 0 : P.getComponents(), Te = Pe[Pe.length - 1];
          Te && (F = Te.isHardened() ? Te.getIndex() + 2147483648 : Te.getIndex(), this.getParentFingerprint() && (le = this.getParentFingerprint())), this.isPrivateKey() ? x = Buffer.from("0488ADE4", "hex") : x = Buffer.from("0488B21E", "hex");
        }
        const ge = Buffer.alloc(1);
        ge.writeUInt8(M, 0);
        const pe = Buffer.alloc(4);
        pe.writeUInt32BE(F, 0);
        const Ie = this.getChainCode(), be = this.getKey();
        return (0, s.encode)(Buffer.concat([x, ge, le, pe, Ie, be]));
      }, this.getRegistryType = () => l.RegistryTypes.CRYPTO_HDKEY, this.getOutputDescriptorContent = () => {
        var B, Q, P, x, M, F, le;
        let ge = "";
        return this.getOrigin() && !((B = this.getOrigin()) === null || B === void 0) && B.getSourceFingerprint() && !((Q = this.getOrigin()) === null || Q === void 0) && Q.getPath() && (ge += `${(x = (P = this.getOrigin()) === null || P === void 0 ? void 0 : P.getSourceFingerprint()) === null || x === void 0 ? void 0 : x.toString("hex")}/${(M = this.getOrigin()) === null || M === void 0 ? void 0 : M.getPath()}`), ge += this.getBip32Key(), this.getChildren() && !((F = this.getChildren()) === null || F === void 0) && F.getPath() && (ge += `/${(le = this.getChildren()) === null || le === void 0 ? void 0 : le.getPath()}`), ge;
      }, this.setupMasterKey = (B) => {
        this.master = !0, this.key = B.key, this.chainCode = B.chainCode;
      }, this.setupDeriveKey = (B) => {
        this.master = !1, this.privateKey = B.isPrivateKey, this.key = B.key, this.chainCode = B.chainCode, this.useInfo = B.useInfo, this.origin = B.origin, this.children = B.children, this.parentFingerprint = B.parentFingerprint, this.name = B.name, this.note = B.note;
      }, this.toDataItem = () => {
        const B = {};
        if (this.master)
          B[m.is_master] = !0, B[m.key_data] = this.key, B[m.chain_code] = this.chainCode;
        else {
          if (this.privateKey !== void 0 && (B[m.is_private] = this.privateKey), B[m.key_data] = this.key, this.chainCode && (B[m.chain_code] = this.chainCode), this.useInfo) {
            const Q = this.useInfo.toDataItem();
            Q.setTag(this.useInfo.getRegistryType().getTag()), B[m.use_info] = Q;
          }
          if (this.origin) {
            const Q = this.origin.toDataItem();
            Q.setTag(this.origin.getRegistryType().getTag()), B[m.origin] = Q;
          }
          if (this.children) {
            const Q = this.children.toDataItem();
            Q.setTag(this.children.getRegistryType().getTag()), B[m.children] = Q;
          }
          this.parentFingerprint && (B[m.parent_fingerprint] = this.parentFingerprint.readUInt32BE(0)), this.name !== void 0 && (B[m.name] = this.name), this.note !== void 0 && (B[m.note] = this.note);
        }
        return new p.DataItem(B);
      }, C.isMaster ? this.setupMasterKey(C) : this.setupDeriveKey(C);
    }
  };
  return CryptoHDKey.CryptoHDKey = b, b.fromDataItem = (k) => {
    const C = k.getData(), B = !!C[m.is_master], Q = C[m.is_private], P = C[m.key_data], x = C[m.chain_code], M = C[m.use_info] ? A.CryptoCoinInfo.fromDataItem(C[m.use_info]) : void 0, F = C[m.origin] ? u.CryptoKeypath.fromDataItem(C[m.origin]) : void 0, le = C[m.children] ? u.CryptoKeypath.fromDataItem(C[m.children]) : void 0, ge = C[m.parent_fingerprint];
    let pe;
    ge && (pe = Buffer.alloc(4), pe.writeUInt32BE(ge, 0));
    const Ie = C[m.name], be = C[m.note];
    return new b({
      isMaster: B,
      isPrivateKey: Q,
      key: P,
      chainCode: x,
      useInfo: M,
      origin: F,
      children: le,
      parentFingerprint: pe,
      name: Ie,
      note: be
    });
  }, b.fromCBOR = (k) => {
    const C = (0, p.decodeToDataItem)(k);
    return b.fromDataItem(C);
  }, CryptoHDKey;
}
var CryptoECKey = {}, hasRequiredCryptoECKey;
function requireCryptoECKey() {
  if (hasRequiredCryptoECKey) return CryptoECKey;
  hasRequiredCryptoECKey = 1, Object.defineProperty(CryptoECKey, "__esModule", { value: !0 }), CryptoECKey.CryptoECKey = void 0;
  const s = requireLib$6(), A = requireRegistryItem(), u = requireRegistryType();
  var p;
  (function(l) {
    l[l.curve = 1] = "curve", l[l.private = 2] = "private", l[l.data = 3] = "data";
  })(p || (p = {}));
  let t = class extends A.RegistryItem {
    constructor(m) {
      super(), this.isECKey = () => !0, this.getCurve = () => this.curve || 0, this.isPrivateKey = () => this.privateKey || !1, this.getData = () => this.data, this.getRegistryType = () => u.RegistryTypes.CRYPTO_ECKEY, this.toDataItem = () => {
        const b = {};
        return this.curve && (b[p.curve] = this.curve), this.privateKey !== void 0 && (b[p.private] = this.privateKey), b[p.data] = this.data, new s.DataItem(b);
      }, this.getOutputDescriptorContent = () => this.data.toString("hex"), this.data = m.data, this.curve = m.curve, this.privateKey = m.privateKey || void 0;
    }
  };
  return CryptoECKey.CryptoECKey = t, t.fromDataItem = (l) => {
    const m = l.getData(), b = m[p.curve], k = m[p.private], C = m[p.data];
    if (!C)
      throw new Error(`#[ur-registry][CryptoECKey][fn.fromDataItem]: decoded [dataItem][#data.data] is undefined: ${l}`);
    return new t({ data: C, curve: b, privateKey: k });
  }, t.fromCBOR = (l) => {
    const m = (0, s.decodeToDataItem)(l);
    return t.fromDataItem(m);
  }, CryptoECKey;
}
var Bytes = {}, hasRequiredBytes$2;
function requireBytes$2() {
  if (hasRequiredBytes$2) return Bytes;
  hasRequiredBytes$2 = 1, Object.defineProperty(Bytes, "__esModule", { value: !0 }), Bytes.Bytes = void 0;
  const s = requireLib$6(), A = requireRegistryItem(), u = requireRegistryType();
  let p = class extends A.RegistryItem {
    constructor(l) {
      super(), this.bytes = l, this.getRegistryType = () => u.RegistryTypes.BYTES, this.getData = () => this.bytes, this.toDataItem = () => new s.DataItem(this.bytes);
    }
  };
  return Bytes.Bytes = p, p.fromDataItem = (t) => {
    const l = t.getData();
    if (!l)
      throw new Error(`#[ur-registry][Bytes][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${t}`);
    return new p(l);
  }, p.fromCBOR = (t) => {
    const l = (0, s.decodeToDataItem)(t);
    return p.fromDataItem(l);
  }, Bytes;
}
var CryptoOutput = {}, MultiKey = {}, hasRequiredMultiKey;
function requireMultiKey() {
  if (hasRequiredMultiKey) return MultiKey;
  hasRequiredMultiKey = 1, Object.defineProperty(MultiKey, "__esModule", { value: !0 }), MultiKey.MultiKey = void 0;
  const s = requireCryptoECKey(), A = requireCryptoHDKey(), u = requireDataItem(), p = requireRegistryItem(), t = requireRegistryType();
  var l;
  (function(b) {
    b[b.threshold = 1] = "threshold", b[b.keys = 2] = "keys";
  })(l || (l = {}));
  let m = class extends p.RegistryItem {
    constructor(k, C) {
      super(), this.threshold = k, this.keys = C, this.getThreshold = () => this.threshold, this.getKeys = () => this.keys, this.toDataItem = () => {
        const B = {};
        B[l.threshold] = this.threshold;
        const Q = this.keys.map((P) => {
          const x = P.toDataItem();
          return x.setTag(P.getRegistryType().getTag()), x;
        });
        return B[l.keys] = Q, new u.DataItem(B);
      }, this.getOutputDescriptorContent = () => [
        this.getThreshold(),
        this.keys.map((B) => B.getOutputDescriptorContent()).join(",")
      ].join(",");
    }
  };
  return MultiKey.MultiKey = m, m.fromDataItem = (b) => {
    const k = b.getData(), C = k[l.threshold], B = k[l.keys], Q = [];
    return B.forEach((P) => {
      P.getTag() === t.RegistryTypes.CRYPTO_HDKEY.getTag() ? Q.push(A.CryptoHDKey.fromDataItem(P)) : P.getTag() === t.RegistryTypes.CRYPTO_ECKEY.getTag() && Q.push(s.CryptoECKey.fromDataItem(P));
    }), new m(C, Q);
  }, MultiKey;
}
var hasRequiredCryptoOutput;
function requireCryptoOutput() {
  if (hasRequiredCryptoOutput) return CryptoOutput;
  hasRequiredCryptoOutput = 1, Object.defineProperty(CryptoOutput, "__esModule", { value: !0 }), CryptoOutput.CryptoOutput = void 0;
  const s = requireCryptoECKey(), A = requireCryptoHDKey(), u = requireLib$6(), p = requireMultiKey(), t = requireRegistryItem(), l = requireRegistryType(), m = requireScriptExpression();
  let b = class extends t.RegistryItem {
    constructor(C, B) {
      super(), this.scriptExpressions = C, this.cryptoKey = B, this.getRegistryType = () => l.RegistryTypes.CRYPTO_OUTPUT, this.getCryptoKey = () => this.cryptoKey, this.getHDKey = () => {
        if (this.cryptoKey instanceof A.CryptoHDKey)
          return this.cryptoKey;
      }, this.getECKey = () => {
        if (this.cryptoKey instanceof s.CryptoECKey)
          return this.cryptoKey;
      }, this.getMultiKey = () => {
        if (this.cryptoKey instanceof p.MultiKey)
          return this.cryptoKey;
      }, this.getScriptExpressions = () => this.scriptExpressions, this._toOutputDescriptor = (Q) => Q >= this.scriptExpressions.length ? this.cryptoKey.getOutputDescriptorContent() : `${this.scriptExpressions[Q].getExpression()}(${this._toOutputDescriptor(Q + 1)})`, this.toString = () => this._toOutputDescriptor(0), this.toDataItem = () => {
        let Q = this.cryptoKey.toDataItem();
        return (this.cryptoKey instanceof s.CryptoECKey || this.cryptoKey instanceof A.CryptoHDKey) && Q.setTag(this.cryptoKey.getRegistryType().getTag()), [...this.scriptExpressions].reverse().forEach((x) => {
          const M = x.getTag();
          Q.getTag() === void 0 ? Q.setTag(M) : Q = new u.DataItem(Q, M);
        }), Q;
      };
    }
  };
  return CryptoOutput.CryptoOutput = b, b.fromDataItem = (k) => {
    const C = [];
    let B = k;
    for (; ; ) {
      let x = B.getTag();
      const M = m.ScriptExpression.fromTag(x);
      if (M)
        if (C.push(M), B.getData() instanceof u.DataItem)
          B = B.getData(), x = B.getTag();
        else
          break;
      else
        break;
    }
    const Q = C.length;
    if (Q > 0 && (C[Q - 1].getExpression() === m.ScriptExpressions.MULTISIG.getExpression() || C[Q - 1].getExpression() === m.ScriptExpressions.SORTED_MULTISIG.getExpression())) {
      const x = p.MultiKey.fromDataItem(B);
      return new b(C, x);
    }
    if (B.getTag() === l.RegistryTypes.CRYPTO_HDKEY.getTag()) {
      const x = A.CryptoHDKey.fromDataItem(B);
      return new b(C, x);
    } else {
      const x = s.CryptoECKey.fromDataItem(B);
      return new b(C, x);
    }
  }, b.fromCBOR = (k) => {
    const C = (0, u.decodeToDataItem)(k);
    return b.fromDataItem(C);
  }, CryptoOutput;
}
var CryptoPSBT = {}, hasRequiredCryptoPSBT;
function requireCryptoPSBT() {
  if (hasRequiredCryptoPSBT) return CryptoPSBT;
  hasRequiredCryptoPSBT = 1, Object.defineProperty(CryptoPSBT, "__esModule", { value: !0 }), CryptoPSBT.CryptoPSBT = void 0;
  const s = requireLib$6(), A = requireRegistryItem(), u = requireRegistryType();
  let p = class extends A.RegistryItem {
    constructor(l) {
      super(), this.psbt = l, this.getRegistryType = () => u.RegistryTypes.CRYPTO_PSBT, this.getPSBT = () => this.psbt, this.toDataItem = () => new s.DataItem(this.psbt);
    }
  };
  return CryptoPSBT.CryptoPSBT = p, p.fromDataItem = (t) => {
    const l = t.getData();
    if (!l)
      throw new Error(`#[ur-registry][CryptoPSBT][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${t}`);
    return new p(l);
  }, p.fromCBOR = (t) => {
    const l = (0, s.decodeToDataItem)(t);
    return p.fromDataItem(l);
  }, CryptoPSBT;
}
var CryptoAccount = {}, hasRequiredCryptoAccount;
function requireCryptoAccount() {
  if (hasRequiredCryptoAccount) return CryptoAccount;
  hasRequiredCryptoAccount = 1, Object.defineProperty(CryptoAccount, "__esModule", { value: !0 }), CryptoAccount.CryptoAccount = void 0;
  const s = requireDist$i(), A = requireLib$6(), u = requireRegistryItem(), p = requireRegistryType();
  var t;
  (function(m) {
    m[m.masterFingerprint = 1] = "masterFingerprint", m[m.outputDescriptors = 2] = "outputDescriptors";
  })(t || (t = {}));
  let l = class extends u.RegistryItem {
    constructor(b, k) {
      super(), this.masterFingerprint = b, this.outputDescriptors = k, this.getRegistryType = () => p.RegistryTypes.CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getOutputDescriptors = () => this.outputDescriptors, this.toDataItem = () => {
        const C = {};
        return this.masterFingerprint && (C[t.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.outputDescriptors && (C[t.outputDescriptors] = this.outputDescriptors.map((B) => B.toDataItem())), new A.DataItem(C);
      };
    }
  };
  return CryptoAccount.CryptoAccount = l, l.fromDataItem = (m) => {
    const b = m.getData(), k = Buffer.alloc(4), C = b[t.masterFingerprint];
    C && k.writeUInt32BE(C, 0);
    const Q = b[t.outputDescriptors].map((P) => s.CryptoOutput.fromDataItem(P));
    return new l(k, Q);
  }, l.fromCBOR = (m) => {
    const b = (0, A.decodeToDataItem)(m);
    return l.fromDataItem(b);
  }, CryptoAccount;
}
var Decoder = {}, errors$1 = {}, hasRequiredErrors$1;
function requireErrors$1() {
  if (hasRequiredErrors$1) return errors$1;
  hasRequiredErrors$1 = 1, Object.defineProperty(errors$1, "__esModule", { value: !0 }), errors$1.UnknownURTypeError = void 0;
  class s extends Error {
    constructor(u) {
      super(u);
    }
  }
  return errors$1.UnknownURTypeError = s, errors$1;
}
var hasRequiredDecoder;
function requireDecoder() {
  if (hasRequiredDecoder) return Decoder;
  hasRequiredDecoder = 1, Object.defineProperty(Decoder, "__esModule", { value: !0 }), Decoder.URRegistryDecoder = void 0;
  const s = requireDist$k(), A = requireDist$i(), u = requireRegistryType(), p = requireErrors$1();
  class t extends s.URDecoder {
    constructor() {
      super(...arguments), this.resultRegistryType = () => {
        const m = this.resultUR();
        switch (m.type) {
          case u.RegistryTypes.BYTES.getType():
            return A.Bytes.fromCBOR(m.cbor);
          case u.RegistryTypes.CRYPTO_HDKEY.getType():
            return A.CryptoHDKey.fromCBOR(m.cbor);
          case u.RegistryTypes.CRYPTO_KEYPATH.getType():
            return A.CryptoKeypath.fromCBOR(m.cbor);
          case u.RegistryTypes.CRYPTO_COIN_INFO.getType():
            return A.CryptoCoinInfo.fromCBOR(m.cbor);
          case u.RegistryTypes.CRYPTO_ECKEY.getType():
            return A.CryptoECKey.fromCBOR(m.cbor);
          case u.RegistryTypes.CRYPTO_OUTPUT.getType():
            return A.CryptoOutput.fromCBOR(m.cbor);
          case u.RegistryTypes.CRYPTO_PSBT.getType():
            return A.CryptoPSBT.fromCBOR(m.cbor);
          case u.RegistryTypes.CRYPTO_ACCOUNT.getType():
            return A.CryptoAccount.fromCBOR(m.cbor);
          default:
            throw new p.UnknownURTypeError(`#[ur-registry][Decoder][fn.resultRegistryType]: registry type ${m.type} is not supported now`);
        }
      };
    }
  }
  return Decoder.URRegistryDecoder = t, Decoder;
}
var CryptoMultiAccounts = {}, hasRequiredCryptoMultiAccounts;
function requireCryptoMultiAccounts() {
  if (hasRequiredCryptoMultiAccounts) return CryptoMultiAccounts;
  hasRequiredCryptoMultiAccounts = 1, Object.defineProperty(CryptoMultiAccounts, "__esModule", { value: !0 }), CryptoMultiAccounts.CryptoMultiAccounts = void 0;
  const s = requireRegistryType(), A = requireCryptoHDKey(), u = requireRegistryItem(), p = requireLib$6();
  var t;
  (function(m) {
    m[m.masterFingerprint = 1] = "masterFingerprint", m[m.keys = 2] = "keys", m[m.device = 3] = "device", m[m.deviceId = 4] = "deviceId", m[m.version = 5] = "version";
  })(t || (t = {}));
  let l = class extends u.RegistryItem {
    constructor(b, k, C, B, Q) {
      super(), this.masterFingerprint = b, this.keys = k, this.device = C, this.deviceId = B, this.version = Q, this.getRegistryType = () => s.RegistryTypes.CRYPTO_MULTI_ACCOUNTS, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeys = () => this.keys, this.getDevice = () => this.device, this.getDeviceId = () => this.deviceId, this.getVersion = () => this.version, this.toDataItem = () => {
        const P = {};
        return this.masterFingerprint && (P[t.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.keys && (P[t.keys] = this.keys.map((x) => {
          const M = x.toDataItem();
          return M.setTag(x.getRegistryType().getTag()), M;
        })), this.device && (P[t.device] = this.device), this.deviceId && (P[t.deviceId] = this.deviceId), this.version && (P[t.version] = this.version), new p.DataItem(P);
      };
    }
  };
  return CryptoMultiAccounts.CryptoMultiAccounts = l, l.fromDataItem = (m) => {
    const b = m.getData(), k = Buffer.alloc(4), C = b[t.masterFingerprint];
    C && k.writeUInt32BE(C, 0);
    const Q = b[t.keys].map((F) => A.CryptoHDKey.fromDataItem(F)), P = b[t.device], x = b[t.deviceId], M = b[t.version];
    return new l(k, Q, P, x, M);
  }, l.fromCBOR = (m) => {
    const b = (0, p.decodeToDataItem)(m);
    return l.fromDataItem(b);
  }, CryptoMultiAccounts;
}
var QRHardwareCall = {}, KeyDerivation = {}, DerivationSchema = {}, hasRequiredDerivationSchema;
function requireDerivationSchema() {
  return hasRequiredDerivationSchema || (hasRequiredDerivationSchema = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.KeyDerivationSchema = s.DerivationAlgorithm = s.Curve = void 0;
    const A = requireRegistryType(), u = requireRegistryItem(), p = requireLib$6(), t = requireCryptoKeypath();
    var l;
    (function(C) {
      C[C.keyPath = 1] = "keyPath", C[C.curve = 2] = "curve", C[C.algo = 3] = "algo";
    })(l || (l = {}));
    var m;
    (function(C) {
      C[C.secp256k1 = 0] = "secp256k1", C[C.ed25519 = 1] = "ed25519";
    })(m = s.Curve || (s.Curve = {}));
    var b;
    (function(C) {
      C[C.slip10 = 0] = "slip10", C[C.bip32ed25519 = 1] = "bip32ed25519";
    })(b = s.DerivationAlgorithm || (s.DerivationAlgorithm = {}));
    class k extends u.RegistryItem {
      constructor(B, Q = m.secp256k1, P = b.slip10) {
        super(), this.keypath = B, this.curve = Q, this.algo = P, this.getRegistryType = () => A.RegistryTypes.KEY_DERIVATION_SCHEMA, this.getKeypath = () => this.keypath, this.getCurve = () => this.curve, this.getAlgo = () => this.algo, this.toDataItem = () => {
          const x = {}, M = this.getKeypath().toDataItem();
          return M.setTag(this.getKeypath().getRegistryType().getTag()), x[l.keyPath] = M, x[l.curve] = this.curve, x[l.algo] = this.algo, new p.DataItem(x);
        };
      }
    }
    s.KeyDerivationSchema = k, k.fromDataItem = (C) => {
      const B = C.getData(), Q = t.CryptoKeypath.fromDataItem(B[l.keyPath]), P = B[l.curve], x = B[l.algo];
      return new k(Q, P, x);
    }, k.fromCBOR = (C) => {
      const B = (0, p.decodeToDataItem)(C);
      return k.fromDataItem(B);
    };
  }(DerivationSchema)), DerivationSchema;
}
var hasRequiredKeyDerivation;
function requireKeyDerivation() {
  if (hasRequiredKeyDerivation) return KeyDerivation;
  hasRequiredKeyDerivation = 1, Object.defineProperty(KeyDerivation, "__esModule", { value: !0 }), KeyDerivation.KeyDerivation = void 0;
  const s = requireRegistryType(), A = requireRegistryItem(), u = requireLib$6(), p = requireDerivationSchema();
  var t;
  (function(m) {
    m[m.schemas = 1] = "schemas";
  })(t || (t = {}));
  let l = class extends A.RegistryItem {
    constructor(b) {
      super(), this.schemas = b, this.getRegistryType = () => s.RegistryTypes.KEY_DERIVATION_CALL, this.getSchemas = () => this.schemas, this.toDataItem = () => {
        const k = {};
        return k[t.schemas] = this.schemas.map((C) => {
          const B = C.toDataItem();
          return B.setTag(C.getRegistryType().getTag()), B;
        }), new u.DataItem(k);
      };
    }
  };
  return KeyDerivation.KeyDerivation = l, l.fromDataItem = (m) => {
    const k = m.getData()[t.schemas].map((C) => p.KeyDerivationSchema.fromDataItem(C));
    return new l(k);
  }, l.fromCBOR = (m) => {
    const b = (0, u.decodeToDataItem)(m);
    return l.fromDataItem(b);
  }, KeyDerivation;
}
var hasRequiredQRHardwareCall;
function requireQRHardwareCall() {
  return hasRequiredQRHardwareCall || (hasRequiredQRHardwareCall = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.QRHardwareCall = s.QRHardwareCallType = void 0;
    const A = requireRegistryType(), u = requireRegistryItem(), p = requireLib$6(), t = requireKeyDerivation();
    var l;
    (function(k) {
      k[k.type = 1] = "type", k[k.params = 2] = "params", k[k.origin = 3] = "origin";
    })(l || (l = {}));
    var m;
    (function(k) {
      k[k.KeyDerivation = 0] = "KeyDerivation";
    })(m = s.QRHardwareCallType || (s.QRHardwareCallType = {}));
    class b extends u.RegistryItem {
      constructor(C, B, Q) {
        super(), this.type = C, this.params = B, this.origin = Q, this.getRegistryType = () => A.RegistryTypes.QR_HARDWARE_CALL, this.getType = () => this.type, this.getParams = () => this.params, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const P = {};
          P[l.type] = this.type;
          const x = this.params.toDataItem();
          return x.setTag(this.params.getRegistryType().getTag()), P[l.params] = x, this.origin && (P[l.origin] = this.origin), new p.DataItem(P);
        };
      }
    }
    s.QRHardwareCall = b, b.fromDataItem = (k) => {
      const C = k.getData(), B = C[l.type] || m.KeyDerivation;
      let Q;
      switch (B) {
        case m.KeyDerivation:
          Q = t.KeyDerivation.fromDataItem(C[l.params]);
      }
      const P = C[l.origin];
      return new b(B, Q, P);
    }, b.fromCBOR = (k) => {
      const C = (0, p.decodeToDataItem)(k);
      return b.fromDataItem(C);
    };
  }(QRHardwareCall)), QRHardwareCall;
}
var types$6 = {}, hasRequiredTypes$6;
function requireTypes$6() {
  return hasRequiredTypes$6 || (hasRequiredTypes$6 = 1, Object.defineProperty(types$6, "__esModule", { value: !0 })), types$6;
}
var hasRequiredDist$i;
function requireDist$i() {
  return hasRequiredDist$i || (hasRequiredDist$i = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.Buffer = s.extend = s.PathComponent = s.ScriptExpressions = s.MultiKey = s.CryptoPSBT = s.CryptoOutput = s.CryptoECKey = s.CryptoCoinInfoNetwork = s.CryptoCoinInfoType = s.CryptoCoinInfo = s.CryptoKeypath = s.CryptoMultiAccounts = s.CryptoHDKey = s.CryptoAccount = s.Bytes = s.URRegistryDecoder = s.DataItem = void 0;
    const A = require$$0$2;
    requirePatchCBOR();
    const u = requireDist$n();
    Object.defineProperty(s, "Buffer", { enumerable: !0, get: function() {
      return u.Buffer;
    } });
    const p = requireCryptoHDKey();
    Object.defineProperty(s, "CryptoHDKey", { enumerable: !0, get: function() {
      return p.CryptoHDKey;
    } });
    const t = requireCryptoKeypath();
    Object.defineProperty(s, "CryptoKeypath", { enumerable: !0, get: function() {
      return t.CryptoKeypath;
    } });
    const l = requireCryptoCoinInfo();
    Object.defineProperty(s, "CryptoCoinInfo", { enumerable: !0, get: function() {
      return l.CryptoCoinInfo;
    } }), Object.defineProperty(s, "CryptoCoinInfoType", { enumerable: !0, get: function() {
      return l.Type;
    } }), Object.defineProperty(s, "CryptoCoinInfoNetwork", { enumerable: !0, get: function() {
      return l.Network;
    } });
    const m = requireCryptoECKey();
    Object.defineProperty(s, "CryptoECKey", { enumerable: !0, get: function() {
      return m.CryptoECKey;
    } });
    const b = requireBytes$2();
    Object.defineProperty(s, "Bytes", { enumerable: !0, get: function() {
      return b.Bytes;
    } });
    const k = requireCryptoOutput();
    Object.defineProperty(s, "CryptoOutput", { enumerable: !0, get: function() {
      return k.CryptoOutput;
    } });
    const C = requireCryptoPSBT();
    Object.defineProperty(s, "CryptoPSBT", { enumerable: !0, get: function() {
      return C.CryptoPSBT;
    } });
    const B = requireCryptoAccount();
    Object.defineProperty(s, "CryptoAccount", { enumerable: !0, get: function() {
      return B.CryptoAccount;
    } });
    const Q = requireDecoder();
    Object.defineProperty(s, "URRegistryDecoder", { enumerable: !0, get: function() {
      return Q.URRegistryDecoder;
    } });
    const P = requireMultiKey();
    Object.defineProperty(s, "MultiKey", { enumerable: !0, get: function() {
      return P.MultiKey;
    } });
    const x = requireScriptExpression();
    Object.defineProperty(s, "ScriptExpressions", { enumerable: !0, get: function() {
      return x.ScriptExpressions;
    } });
    const M = requirePathComponent();
    Object.defineProperty(s, "PathComponent", { enumerable: !0, get: function() {
      return M.PathComponent;
    } });
    const F = requireRegistryItem(), le = requireRegistryType(), ge = requireLib$6();
    var pe = requireLib$6();
    Object.defineProperty(s, "DataItem", { enumerable: !0, get: function() {
      return pe.DataItem;
    } });
    const Ie = requireUtils$c(), be = requireCryptoMultiAccounts();
    Object.defineProperty(s, "CryptoMultiAccounts", { enumerable: !0, get: function() {
      return be.CryptoMultiAccounts;
    } });
    const Pe = {
      URRegistryDecoder: Q.URRegistryDecoder,
      Bytes: b.Bytes,
      CryptoAccount: B.CryptoAccount,
      CryptoHDKey: p.CryptoHDKey,
      CryptoMultiAccounts: be.CryptoMultiAccounts,
      CryptoKeypath: t.CryptoKeypath,
      CryptoCoinInfo: l.CryptoCoinInfo,
      CryptoCoinInfoType: l.Type,
      CryptoCoinInfoNetwork: l.Network,
      CryptoECKey: m.CryptoECKey,
      CryptoOutput: k.CryptoOutput,
      CryptoPSBT: C.CryptoPSBT,
      MultiKey: P.MultiKey,
      ScriptExpressions: x.ScriptExpressions,
      PathComponent: M.PathComponent
    }, Te = {
      addReader: ge.addReader,
      addSemanticDecode: ge.addSemanticDecode,
      addSemanticEncode: ge.addSemanticEncode,
      addWriter: ge.addWriter,
      patchTags: Ie.patchTags
    }, Qe = {
      RegistryTypes: le.RegistryTypes,
      RegistryItem: F.RegistryItem,
      RegistryType: le.RegistryType,
      decodeToDataItem: ge.decodeToDataItem,
      encodeDataItem: ge.encodeDataItem,
      cbor: Te
    };
    s.extend = Qe, (0, A.__exportStar)(requireErrors$1(), s), (0, A.__exportStar)(requireDecoder(), s), (0, A.__exportStar)(requireLib$6(), s), (0, A.__exportStar)(requireCryptoAccount(), s), (0, A.__exportStar)(requireCryptoPSBT(), s), (0, A.__exportStar)(requireCryptoHDKey(), s), (0, A.__exportStar)(requireCryptoMultiAccounts(), s), (0, A.__exportStar)(requireQRHardwareCall(), s), (0, A.__exportStar)(requireKeyDerivation(), s), (0, A.__exportStar)(requireDerivationSchema(), s), (0, A.__exportStar)(requireCryptoOutput(), s), (0, A.__exportStar)(requireCryptoCoinInfo(), s), (0, A.__exportStar)(requireCryptoECKey(), s), (0, A.__exportStar)(requireMultiKey(), s), (0, A.__exportStar)(requireCryptoKeypath(), s), (0, A.__exportStar)(requirePatchCBOR(), s), (0, A.__exportStar)(requirePathComponent(), s), (0, A.__exportStar)(requireRegistryItem(), s), (0, A.__exportStar)(requireRegistryType(), s), (0, A.__exportStar)(requireTypes$6(), s), (0, A.__exportStar)(requireUtils$c(), s), s.default = Pe;
  }(dist$g)), dist$g;
}
var getRandomValues$1, rnds8$1 = new Uint8Array(16);
function rng$2() {
  if (!getRandomValues$1 && (getRandomValues$1 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !getRandomValues$1))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues$1(rnds8$1);
}
const REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate$2(s) {
  return typeof s == "string" && REGEX.test(s);
}
var byteToHex$1 = [];
for (var i$1 = 0; i$1 < 256; ++i$1)
  byteToHex$1.push((i$1 + 256).toString(16).substr(1));
function stringify$2(s) {
  var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, u = (byteToHex$1[s[A + 0]] + byteToHex$1[s[A + 1]] + byteToHex$1[s[A + 2]] + byteToHex$1[s[A + 3]] + "-" + byteToHex$1[s[A + 4]] + byteToHex$1[s[A + 5]] + "-" + byteToHex$1[s[A + 6]] + byteToHex$1[s[A + 7]] + "-" + byteToHex$1[s[A + 8]] + byteToHex$1[s[A + 9]] + "-" + byteToHex$1[s[A + 10]] + byteToHex$1[s[A + 11]] + byteToHex$1[s[A + 12]] + byteToHex$1[s[A + 13]] + byteToHex$1[s[A + 14]] + byteToHex$1[s[A + 15]]).toLowerCase();
  if (!validate$2(u))
    throw TypeError("Stringified UUID is invalid");
  return u;
}
var _nodeId, _clockseq, _lastMSecs = 0, _lastNSecs = 0;
function v1$1(s, A, u) {
  var p = A && u || 0, t = A || new Array(16);
  s = s || {};
  var l = s.node || _nodeId, m = s.clockseq !== void 0 ? s.clockseq : _clockseq;
  if (l == null || m == null) {
    var b = s.random || (s.rng || rng$2)();
    l == null && (l = _nodeId = [b[0] | 1, b[1], b[2], b[3], b[4], b[5]]), m == null && (m = _clockseq = (b[6] << 8 | b[7]) & 16383);
  }
  var k = s.msecs !== void 0 ? s.msecs : Date.now(), C = s.nsecs !== void 0 ? s.nsecs : _lastNSecs + 1, B = k - _lastMSecs + (C - _lastNSecs) / 1e4;
  if (B < 0 && s.clockseq === void 0 && (m = m + 1 & 16383), (B < 0 || k > _lastMSecs) && s.nsecs === void 0 && (C = 0), C >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  _lastMSecs = k, _lastNSecs = C, _clockseq = m, k += 122192928e5;
  var Q = ((k & 268435455) * 1e4 + C) % 4294967296;
  t[p++] = Q >>> 24 & 255, t[p++] = Q >>> 16 & 255, t[p++] = Q >>> 8 & 255, t[p++] = Q & 255;
  var P = k / 4294967296 * 1e4 & 268435455;
  t[p++] = P >>> 8 & 255, t[p++] = P & 255, t[p++] = P >>> 24 & 15 | 16, t[p++] = P >>> 16 & 255, t[p++] = m >>> 8 | 128, t[p++] = m & 255;
  for (var x = 0; x < 6; ++x)
    t[p + x] = l[x];
  return A || stringify$2(t);
}
function parse$1(s) {
  if (!validate$2(s))
    throw TypeError("Invalid UUID");
  var A, u = new Uint8Array(16);
  return u[0] = (A = parseInt(s.slice(0, 8), 16)) >>> 24, u[1] = A >>> 16 & 255, u[2] = A >>> 8 & 255, u[3] = A & 255, u[4] = (A = parseInt(s.slice(9, 13), 16)) >>> 8, u[5] = A & 255, u[6] = (A = parseInt(s.slice(14, 18), 16)) >>> 8, u[7] = A & 255, u[8] = (A = parseInt(s.slice(19, 23), 16)) >>> 8, u[9] = A & 255, u[10] = (A = parseInt(s.slice(24, 36), 16)) / 1099511627776 & 255, u[11] = A / 4294967296 & 255, u[12] = A >>> 24 & 255, u[13] = A >>> 16 & 255, u[14] = A >>> 8 & 255, u[15] = A & 255, u;
}
function stringToBytes$1(s) {
  s = unescape(encodeURIComponent(s));
  for (var A = [], u = 0; u < s.length; ++u)
    A.push(s.charCodeAt(u));
  return A;
}
var DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", URL$1 = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function v35$1(s, A, u) {
  function p(t, l, m, b) {
    if (typeof t == "string" && (t = stringToBytes$1(t)), typeof l == "string" && (l = parse$1(l)), l.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var k = new Uint8Array(16 + t.length);
    if (k.set(l), k.set(t, l.length), k = u(k), k[6] = k[6] & 15 | A, k[8] = k[8] & 63 | 128, m) {
      b = b || 0;
      for (var C = 0; C < 16; ++C)
        m[b + C] = k[C];
      return m;
    }
    return stringify$2(k);
  }
  try {
    p.name = s;
  } catch {
  }
  return p.DNS = DNS, p.URL = URL$1, p;
}
function md5$4(s) {
  if (typeof s == "string") {
    var A = unescape(encodeURIComponent(s));
    s = new Uint8Array(A.length);
    for (var u = 0; u < A.length; ++u)
      s[u] = A.charCodeAt(u);
  }
  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(s), s.length * 8));
}
function md5ToHexEncodedArray(s) {
  for (var A = [], u = s.length * 32, p = "0123456789abcdef", t = 0; t < u; t += 8) {
    var l = s[t >> 5] >>> t % 32 & 255, m = parseInt(p.charAt(l >>> 4 & 15) + p.charAt(l & 15), 16);
    A.push(m);
  }
  return A;
}
function getOutputLength(s) {
  return (s + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5(s, A) {
  s[A >> 5] |= 128 << A % 32, s[getOutputLength(A) - 1] = A;
  for (var u = 1732584193, p = -271733879, t = -1732584194, l = 271733878, m = 0; m < s.length; m += 16) {
    var b = u, k = p, C = t, B = l;
    u = md5ff(u, p, t, l, s[m], 7, -680876936), l = md5ff(l, u, p, t, s[m + 1], 12, -389564586), t = md5ff(t, l, u, p, s[m + 2], 17, 606105819), p = md5ff(p, t, l, u, s[m + 3], 22, -1044525330), u = md5ff(u, p, t, l, s[m + 4], 7, -176418897), l = md5ff(l, u, p, t, s[m + 5], 12, 1200080426), t = md5ff(t, l, u, p, s[m + 6], 17, -1473231341), p = md5ff(p, t, l, u, s[m + 7], 22, -45705983), u = md5ff(u, p, t, l, s[m + 8], 7, 1770035416), l = md5ff(l, u, p, t, s[m + 9], 12, -1958414417), t = md5ff(t, l, u, p, s[m + 10], 17, -42063), p = md5ff(p, t, l, u, s[m + 11], 22, -1990404162), u = md5ff(u, p, t, l, s[m + 12], 7, 1804603682), l = md5ff(l, u, p, t, s[m + 13], 12, -40341101), t = md5ff(t, l, u, p, s[m + 14], 17, -1502002290), p = md5ff(p, t, l, u, s[m + 15], 22, 1236535329), u = md5gg(u, p, t, l, s[m + 1], 5, -165796510), l = md5gg(l, u, p, t, s[m + 6], 9, -1069501632), t = md5gg(t, l, u, p, s[m + 11], 14, 643717713), p = md5gg(p, t, l, u, s[m], 20, -373897302), u = md5gg(u, p, t, l, s[m + 5], 5, -701558691), l = md5gg(l, u, p, t, s[m + 10], 9, 38016083), t = md5gg(t, l, u, p, s[m + 15], 14, -660478335), p = md5gg(p, t, l, u, s[m + 4], 20, -405537848), u = md5gg(u, p, t, l, s[m + 9], 5, 568446438), l = md5gg(l, u, p, t, s[m + 14], 9, -1019803690), t = md5gg(t, l, u, p, s[m + 3], 14, -187363961), p = md5gg(p, t, l, u, s[m + 8], 20, 1163531501), u = md5gg(u, p, t, l, s[m + 13], 5, -1444681467), l = md5gg(l, u, p, t, s[m + 2], 9, -51403784), t = md5gg(t, l, u, p, s[m + 7], 14, 1735328473), p = md5gg(p, t, l, u, s[m + 12], 20, -1926607734), u = md5hh(u, p, t, l, s[m + 5], 4, -378558), l = md5hh(l, u, p, t, s[m + 8], 11, -2022574463), t = md5hh(t, l, u, p, s[m + 11], 16, 1839030562), p = md5hh(p, t, l, u, s[m + 14], 23, -35309556), u = md5hh(u, p, t, l, s[m + 1], 4, -1530992060), l = md5hh(l, u, p, t, s[m + 4], 11, 1272893353), t = md5hh(t, l, u, p, s[m + 7], 16, -155497632), p = md5hh(p, t, l, u, s[m + 10], 23, -1094730640), u = md5hh(u, p, t, l, s[m + 13], 4, 681279174), l = md5hh(l, u, p, t, s[m], 11, -358537222), t = md5hh(t, l, u, p, s[m + 3], 16, -722521979), p = md5hh(p, t, l, u, s[m + 6], 23, 76029189), u = md5hh(u, p, t, l, s[m + 9], 4, -640364487), l = md5hh(l, u, p, t, s[m + 12], 11, -421815835), t = md5hh(t, l, u, p, s[m + 15], 16, 530742520), p = md5hh(p, t, l, u, s[m + 2], 23, -995338651), u = md5ii(u, p, t, l, s[m], 6, -198630844), l = md5ii(l, u, p, t, s[m + 7], 10, 1126891415), t = md5ii(t, l, u, p, s[m + 14], 15, -1416354905), p = md5ii(p, t, l, u, s[m + 5], 21, -57434055), u = md5ii(u, p, t, l, s[m + 12], 6, 1700485571), l = md5ii(l, u, p, t, s[m + 3], 10, -1894986606), t = md5ii(t, l, u, p, s[m + 10], 15, -1051523), p = md5ii(p, t, l, u, s[m + 1], 21, -2054922799), u = md5ii(u, p, t, l, s[m + 8], 6, 1873313359), l = md5ii(l, u, p, t, s[m + 15], 10, -30611744), t = md5ii(t, l, u, p, s[m + 6], 15, -1560198380), p = md5ii(p, t, l, u, s[m + 13], 21, 1309151649), u = md5ii(u, p, t, l, s[m + 4], 6, -145523070), l = md5ii(l, u, p, t, s[m + 11], 10, -1120210379), t = md5ii(t, l, u, p, s[m + 2], 15, 718787259), p = md5ii(p, t, l, u, s[m + 9], 21, -343485551), u = safeAdd(u, b), p = safeAdd(p, k), t = safeAdd(t, C), l = safeAdd(l, B);
  }
  return [u, p, t, l];
}
function bytesToWords(s) {
  if (s.length === 0)
    return [];
  for (var A = s.length * 8, u = new Uint32Array(getOutputLength(A)), p = 0; p < A; p += 8)
    u[p >> 5] |= (s[p / 8] & 255) << p % 32;
  return u;
}
function safeAdd(s, A) {
  var u = (s & 65535) + (A & 65535), p = (s >> 16) + (A >> 16) + (u >> 16);
  return p << 16 | u & 65535;
}
function bitRotateLeft(s, A) {
  return s << A | s >>> 32 - A;
}
function md5cmn(s, A, u, p, t, l) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(A, s), safeAdd(p, l)), t), u);
}
function md5ff(s, A, u, p, t, l, m) {
  return md5cmn(A & u | ~A & p, s, A, t, l, m);
}
function md5gg(s, A, u, p, t, l, m) {
  return md5cmn(A & p | u & ~p, s, A, t, l, m);
}
function md5hh(s, A, u, p, t, l, m) {
  return md5cmn(A ^ u ^ p, s, A, t, l, m);
}
function md5ii(s, A, u, p, t, l, m) {
  return md5cmn(u ^ (A | ~p), s, A, t, l, m);
}
var v3$1 = v35$1("v3", 48, md5$4);
function v4$2(s, A, u) {
  s = s || {};
  var p = s.random || (s.rng || rng$2)();
  if (p[6] = p[6] & 15 | 64, p[8] = p[8] & 63 | 128, A) {
    u = u || 0;
    for (var t = 0; t < 16; ++t)
      A[u + t] = p[t];
    return A;
  }
  return stringify$2(p);
}
function f$1(s, A, u, p) {
  switch (s) {
    case 0:
      return A & u ^ ~A & p;
    case 1:
      return A ^ u ^ p;
    case 2:
      return A & u ^ A & p ^ u & p;
    case 3:
      return A ^ u ^ p;
  }
}
function ROTL(s, A) {
  return s << A | s >>> 32 - A;
}
function sha1$2(s) {
  var A = [1518500249, 1859775393, 2400959708, 3395469782], u = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof s == "string") {
    var p = unescape(encodeURIComponent(s));
    s = [];
    for (var t = 0; t < p.length; ++t)
      s.push(p.charCodeAt(t));
  } else Array.isArray(s) || (s = Array.prototype.slice.call(s));
  s.push(128);
  for (var l = s.length / 4 + 2, m = Math.ceil(l / 16), b = new Array(m), k = 0; k < m; ++k) {
    for (var C = new Uint32Array(16), B = 0; B < 16; ++B)
      C[B] = s[k * 64 + B * 4] << 24 | s[k * 64 + B * 4 + 1] << 16 | s[k * 64 + B * 4 + 2] << 8 | s[k * 64 + B * 4 + 3];
    b[k] = C;
  }
  b[m - 1][14] = (s.length - 1) * 8 / Math.pow(2, 32), b[m - 1][14] = Math.floor(b[m - 1][14]), b[m - 1][15] = (s.length - 1) * 8 & 4294967295;
  for (var Q = 0; Q < m; ++Q) {
    for (var P = new Uint32Array(80), x = 0; x < 16; ++x)
      P[x] = b[Q][x];
    for (var M = 16; M < 80; ++M)
      P[M] = ROTL(P[M - 3] ^ P[M - 8] ^ P[M - 14] ^ P[M - 16], 1);
    for (var F = u[0], le = u[1], ge = u[2], pe = u[3], Ie = u[4], be = 0; be < 80; ++be) {
      var Pe = Math.floor(be / 20), Te = ROTL(F, 5) + f$1(Pe, le, ge, pe) + Ie + A[Pe] + P[be] >>> 0;
      Ie = pe, pe = ge, ge = ROTL(le, 30) >>> 0, le = F, F = Te;
    }
    u[0] = u[0] + F >>> 0, u[1] = u[1] + le >>> 0, u[2] = u[2] + ge >>> 0, u[3] = u[3] + pe >>> 0, u[4] = u[4] + Ie >>> 0;
  }
  return [u[0] >> 24 & 255, u[0] >> 16 & 255, u[0] >> 8 & 255, u[0] & 255, u[1] >> 24 & 255, u[1] >> 16 & 255, u[1] >> 8 & 255, u[1] & 255, u[2] >> 24 & 255, u[2] >> 16 & 255, u[2] >> 8 & 255, u[2] & 255, u[3] >> 24 & 255, u[3] >> 16 & 255, u[3] >> 8 & 255, u[3] & 255, u[4] >> 24 & 255, u[4] >> 16 & 255, u[4] >> 8 & 255, u[4] & 255];
}
var v5$1 = v35$1("v5", 80, sha1$2);
const nil$1 = "00000000-0000-0000-0000-000000000000";
function version$7(s) {
  if (!validate$2(s))
    throw TypeError("Invalid UUID");
  return parseInt(s.substr(14, 1), 16);
}
const esmBrowser = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: nil$1,
  parse: parse$1,
  stringify: stringify$2,
  v1: v1$1,
  v3: v3$1,
  v4: v4$2,
  v5: v5$1,
  validate: validate$2,
  version: version$7
}, Symbol.toStringTag, { value: "Module" })), require$$1$2 = /* @__PURE__ */ getAugmentedNamespace(esmBrowser);
var hasRequiredBcUrRegistryBtc_cjs_production_min;
function requireBcUrRegistryBtc_cjs_production_min() {
  return hasRequiredBcUrRegistryBtc_cjs_production_min || (hasRequiredBcUrRegistryBtc_cjs_production_min = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$i(), u = require$$1$2;
    const p = { BTC_SIGN_REQUEST: new A.RegistryType("btc-sign-request", 8101), BTC_SIGNATURE: new A.RegistryType("btc-signature", 8102) }, { decodeToDataItem: t, RegistryTypes: l } = A.extend;
    var m, b;
    (m = s.DataType || (s.DataType = {}))[m.message = 1] = "message", function(x) {
      x[x.requestId = 1] = "requestId", x[x.signData = 2] = "signData", x[x.dataType = 3] = "dataType", x[x.derivationPaths = 4] = "derivationPaths", x[x.addresses = 5] = "addresses", x[x.origin = 6] = "origin";
    }(b || (b = {}));
    class k extends A.RegistryItem {
      constructor(M) {
        super(), this.getRegistryType = () => p.BTC_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataype = () => this.dataType, this.getDerivationPaths = () => this.derivationPaths.map((F) => F.getPath()), this.getAddress = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const F = {};
          return F[b.requestId] = new A.DataItem(this.requestId, l.UUID.getTag()), F[b.signData] = this.signData, F[b.dataType] = this.dataType, F[b.derivationPaths] = this.derivationPaths.map((le) => {
            const ge = le.toDataItem();
            return ge.setTag(le.getRegistryType().getTag()), ge;
          }), this.addresses && (F[b.addresses] = this.addresses), this.origin && (F[b.origin] = this.origin), new A.DataItem(F);
        }, this.requestId = M.requestId, this.signData = M.signData, this.dataType = M.dataType, this.derivationPaths = M.derivationPaths, this.addresses = M.addresses, this.origin = M.origin;
      }
      static constructBtcRequest(M, F, le, ge, pe, Ie, be) {
        const Pe = pe.map((Te, Qe) => {
          const xe = Te.replace(/[m|M]\//, "").split("/").map((Ee) => {
            const He = parseInt(Ee.replace("'", ""));
            let ve = !1;
            return Ee.endsWith("'") && (ve = !0), new A.PathComponent({ index: He, hardened: ve });
          });
          return new A.CryptoKeypath(xe, Buffer.from(F[Qe], "hex"));
        });
        return new k({ requestId: Buffer.from(u.parse(M)), signData: le, dataType: ge || s.DataType.message, derivationPaths: Pe, addresses: Ie || void 0, origin: be || void 0 });
      }
    }
    k.fromDataItem = (x) => {
      const M = x.getData(), F = M[b.requestId] ? M[b.requestId].getData() : void 0, le = M[b.signData], ge = M[b.dataType], pe = M[b.derivationPaths].map((Ie) => A.CryptoKeypath.fromDataItem(Ie));
      return new k({ requestId: F, signData: le, dataType: ge, derivationPaths: pe, addresses: M[b.addresses] ? M[b.addresses] : void 0, origin: M[b.origin] ? M[b.origin] : void 0 });
    }, k.fromCBOR = (x) => {
      const M = t(x);
      return k.fromDataItem(M);
    };
    const { RegistryTypes: C, decodeToDataItem: B } = A.extend;
    var Q;
    (function(x) {
      x[x.requestId = 1] = "requestId", x[x.signature = 2] = "signature", x[x.publicKey = 3] = "publicKey";
    })(Q || (Q = {}));
    class P extends A.RegistryItem {
      constructor(M, F, le) {
        super(), this.getRegistryType = () => p.BTC_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const ge = {};
          return ge[Q.requestId] = new A.DataItem(this.requestId, C.UUID.getTag()), ge[Q.signature] = this.signature, ge[Q.publicKey] = this.publicKey, new A.DataItem(ge);
        }, this.signature = M, this.requestId = F, this.publicKey = le;
      }
    }
    P.fromDataItem = (x) => {
      const M = x.getData(), F = M[Q.signature], le = M[Q.requestId].getData();
      return new P(F, le, M[Q.publicKey]);
    }, P.fromCBOR = (x) => {
      const M = B(x);
      return P.fromDataItem(M);
    }, A.patchTags(Object.values(p).filter((x) => !!x.getTag()).map((x) => x.getTag())), Object.keys(A).forEach(function(x) {
      x !== "default" && Object.defineProperty(s, x, { enumerable: !0, get: function() {
        return A[x];
      } });
    }), s.BtcSignRequest = k, s.BtcSignature = P;
  }(bcUrRegistryBtc_cjs_production_min)), bcUrRegistryBtc_cjs_production_min;
}
var bcUrRegistryBtc_cjs_development = {}, hasRequiredBcUrRegistryBtc_cjs_development;
function requireBcUrRegistryBtc_cjs_development() {
  return hasRequiredBcUrRegistryBtc_cjs_development || (hasRequiredBcUrRegistryBtc_cjs_development = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$i(), u = require$$1$2;
    const p = {
      BTC_SIGN_REQUEST: /* @__PURE__ */ new A.RegistryType("btc-sign-request", 8101),
      BTC_SIGNATURE: /* @__PURE__ */ new A.RegistryType("btc-signature", 8102)
    }, {
      decodeToDataItem: t,
      RegistryTypes: l
    } = A.extend;
    (function(P) {
      P[P.message = 1] = "message";
    })(s.DataType || (s.DataType = {}));
    var m;
    (function(P) {
      P[P.requestId = 1] = "requestId", P[P.signData = 2] = "signData", P[P.dataType = 3] = "dataType", P[P.derivationPaths = 4] = "derivationPaths", P[P.addresses = 5] = "addresses", P[P.origin = 6] = "origin";
    })(m || (m = {}));
    class b extends A.RegistryItem {
      constructor(x) {
        super(), this.getRegistryType = () => p.BTC_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataype = () => this.dataType, this.getDerivationPaths = () => this.derivationPaths.map((M) => M.getPath()), this.getAddress = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const M = {};
          return M[m.requestId] = new A.DataItem(this.requestId, l.UUID.getTag()), M[m.signData] = this.signData, M[m.dataType] = this.dataType, M[m.derivationPaths] = this.derivationPaths.map((F) => {
            const le = F.toDataItem();
            return le.setTag(F.getRegistryType().getTag()), le;
          }), this.addresses && (M[m.addresses] = this.addresses), this.origin && (M[m.origin] = this.origin), new A.DataItem(M);
        }, this.requestId = x.requestId, this.signData = x.signData, this.dataType = x.dataType, this.derivationPaths = x.derivationPaths, this.addresses = x.addresses, this.origin = x.origin;
      }
      static constructBtcRequest(x, M, F, le, ge, pe, Ie) {
        const be = ge.map((Pe, Te) => {
          const xe = Pe.replace(/[m|M]\//, "").split("/").map((Ee) => {
            const He = parseInt(Ee.replace("'", ""));
            let ve = !1;
            return Ee.endsWith("'") && (ve = !0), new A.PathComponent({
              index: He,
              hardened: ve
            });
          });
          return new A.CryptoKeypath(xe, Buffer.from(M[Te], "hex"));
        });
        return new b({
          requestId: Buffer.from(u.parse(x)),
          signData: F,
          dataType: le || s.DataType.message,
          derivationPaths: be,
          addresses: pe || void 0,
          origin: Ie || void 0
        });
      }
    }
    b.fromDataItem = (P) => {
      const x = P.getData(), M = x[m.requestId] ? x[m.requestId].getData() : void 0, F = x[m.signData], le = x[m.dataType], ge = x[m.derivationPaths].map((be) => A.CryptoKeypath.fromDataItem(be)), pe = x[m.addresses] ? x[m.addresses] : void 0, Ie = x[m.origin] ? x[m.origin] : void 0;
      return new b({
        requestId: M,
        signData: F,
        dataType: le,
        derivationPaths: ge,
        addresses: pe,
        origin: Ie
      });
    }, b.fromCBOR = (P) => {
      const x = t(P);
      return b.fromDataItem(x);
    };
    const {
      RegistryTypes: k,
      decodeToDataItem: C
    } = A.extend;
    var B;
    (function(P) {
      P[P.requestId = 1] = "requestId", P[P.signature = 2] = "signature", P[P.publicKey = 3] = "publicKey";
    })(B || (B = {}));
    class Q extends A.RegistryItem {
      constructor(x, M, F) {
        super(), this.getRegistryType = () => p.BTC_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const le = {};
          return le[B.requestId] = new A.DataItem(this.requestId, k.UUID.getTag()), le[B.signature] = this.signature, le[B.publicKey] = this.publicKey, new A.DataItem(le);
        }, this.signature = x, this.requestId = M, this.publicKey = F;
      }
    }
    Q.fromDataItem = (P) => {
      const x = P.getData(), M = x[B.signature], F = x[B.requestId].getData(), le = x[B.publicKey];
      return new Q(M, F, le);
    }, Q.fromCBOR = (P) => {
      const x = C(P);
      return Q.fromDataItem(x);
    }, A.patchTags(Object.values(p).filter((P) => !!P.getTag()).map((P) => P.getTag())), Object.keys(A).forEach(function(P) {
      P !== "default" && Object.defineProperty(s, P, {
        enumerable: !0,
        get: function() {
          return A[P];
        }
      });
    }), s.BtcSignRequest = b, s.BtcSignature = Q;
  }(bcUrRegistryBtc_cjs_development)), bcUrRegistryBtc_cjs_development;
}
var hasRequiredDist$h;
function requireDist$h() {
  return hasRequiredDist$h || (hasRequiredDist$h = 1, process$1.env.NODE_ENV === "production" ? dist$h.exports = requireBcUrRegistryBtc_cjs_production_min() : dist$h.exports = requireBcUrRegistryBtc_cjs_development()), dist$h.exports;
}
var ur = {}, hasRequiredUr;
function requireUr() {
  return hasRequiredUr || (hasRequiredUr = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.URType = s.UR = void 0;
    var A = requireDist$k();
    Object.defineProperty(s, "UR", { enumerable: !0, get: function() {
      return A.UR;
    } }), function(u) {
      u.CryptoPSBT = "crypto-psbt", u.CryptoMultiAccounts = "crypto-multi-accounts", u.CryptoHDKey = "crypto-hdkey", u.CryptoAccount = "crypto-account", u.BtcSignature = "btc-signature", u.ArweaveCryptoAccount = "arweave-crypto-account", u.EthSignature = "eth-signature", u.SolSignature = "sol-signature", u.StellarSignature = "stellar-signature", u.CosmosSignature = "cosmos-signature", u.EvmSignature = "evm-signature", u.AptosSignature = "aptos-signature", u.CardanoSignature = "cardano-signature", u.CardanoSignDataSignature = "cardano-sign-data-signature", u.CardanoSignCip8DataSignature = "cardano-sign-cip8-data-signature", u.CardanoCatalystSignature = "cardano-catalyst-voting-registration-signature", u.TronSignature = "keystone-sign-result", u.KeystoneSignResult = "keystone-sign-result", u.NearSignature = "near-signature", u.ArweaveSignature = "arweave-signature", u.SuiSignature = "sui-signature", u.XrpAccount = "bytes", u.XrpSignRequest = "bytes", u.XrpSignature = "bytes", u.TonSignature = "ton-signature";
    }(s.URType || (s.URType = {}));
  }(ur)), ur;
}
var hasRequiredBitcoin$1;
function requireBitcoin$1() {
  if (hasRequiredBitcoin$1) return bitcoin$1;
  hasRequiredBitcoin$1 = 1, Object.defineProperty(bitcoin$1, "__esModule", { value: !0 }), bitcoin$1.KeystoneBitcoinSDK = void 0;
  const s = requireDist$j(), A = requireDist$h(), u = requireUtils$d(), p = requireUr();
  class t {
    constructor(m) {
      this.config = m;
    }
    parsePSBT(m) {
      if (m.type !== p.URType.CryptoPSBT)
        throw new Error("type not match");
      return (0, u.toHex)(s.CryptoPSBT.fromCBOR(m.cbor).getPSBT());
    }
    generatePSBT(m) {
      return new s.CryptoPSBT(m).toUR();
    }
    generateSignRequest({ requestId: m, signData: b, dataType: k, accounts: C, origin: B }) {
      var Q;
      const P = [], x = [];
      return C.forEach((M) => {
        var F;
        P.push(new A.CryptoKeypath((0, u.parsePath)(M.path).map((le) => new A.PathComponent(le)), (0, u.toBuffer)(M.xfp))), x.push((F = M.address) !== null && F !== void 0 ? F : "");
      }), new A.BtcSignRequest({
        signData: (0, u.toBuffer)(b),
        dataType: k,
        derivationPaths: P,
        requestId: (0, u.uuidParse)(m),
        addresses: x,
        origin: B ?? ((Q = this.config) === null || Q === void 0 ? void 0 : Q.origin)
      }).toUR();
    }
    parseSignature(m) {
      if (m.type !== p.URType.BtcSignature)
        throw new Error("type not match");
      const b = A.BtcSignature.fromCBOR(m.cbor);
      return {
        requestId: (0, u.uuidStringify)(b.getRequestId()),
        signature: (0, u.toHex)(b.getSignature()),
        publicKey: (0, u.toHex)(b.getPublicKey())
      };
    }
  }
  return t.DataType = A.DataType, bitcoin$1.KeystoneBitcoinSDK = t, bitcoin$1;
}
var cosmos = {}, dist$f = { exports: {} }, bcUrRegistryCosmos_cjs_production_min = {}, hasRequiredBcUrRegistryCosmos_cjs_production_min;
function requireBcUrRegistryCosmos_cjs_production_min() {
  return hasRequiredBcUrRegistryCosmos_cjs_production_min || (hasRequiredBcUrRegistryCosmos_cjs_production_min = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$i(), u = require$$1$2;
    const p = { COSMOS_SIGN_REQUEST: new A.RegistryType("cosmos-sign-request", 4101), COSMOS_SIGNATURE: new A.RegistryType("cosmos-signature", 4102) }, { decodeToDataItem: t, RegistryTypes: l } = A.extend;
    var m, b;
    (m = s.SignDataType || (s.SignDataType = {}))[m.amino = 1] = "amino", m[m.direct = 2] = "direct", m[m.textual = 3] = "textual", m[m.message = 4] = "message", function(x) {
      x[x.requestId = 1] = "requestId", x[x.signData = 2] = "signData", x[x.dataType = 3] = "dataType", x[x.derivationPaths = 4] = "derivationPaths", x[x.addresses = 5] = "addresses", x[x.origin = 6] = "origin";
    }(b || (b = {}));
    class k extends A.RegistryItem {
      constructor(M) {
        super(), this.getRegistryType = () => p.COSMOS_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataype = () => this.dataType, this.getDerivationPaths = () => this.derivationPaths.map((F) => F.getPath()), this.getAddress = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const F = {};
          return F[b.requestId] = new A.DataItem(this.requestId, l.UUID.getTag()), F[b.signData] = this.signData, F[b.dataType] = this.dataType, F[b.derivationPaths] = this.derivationPaths.map((le) => {
            const ge = le.toDataItem();
            return ge.setTag(le.getRegistryType().getTag()), ge;
          }), this.addresses && (F[b.addresses] = this.addresses), this.origin && (F[b.origin] = this.origin), new A.DataItem(F);
        }, this.requestId = M.requestId, this.signData = M.signData, this.dataType = M.dataType, this.derivationPaths = M.derivationPaths, this.addresses = M.addresses, this.origin = M.origin;
      }
      static constructCosmosRequest(M, F, le, ge, pe, Ie, be) {
        const Pe = pe.map((Te, Qe) => {
          const xe = Te.replace(/[m|M]\//, "").split("/").map((Ee) => {
            const He = parseInt(Ee.replace("'", ""));
            let ve = !1;
            return Ee.endsWith("'") && (ve = !0), new A.PathComponent({ index: He, hardened: ve });
          });
          return new A.CryptoKeypath(xe, Buffer.from(F[Qe], "hex"));
        });
        return new k({ requestId: Buffer.from(u.parse(M)), signData: le, dataType: ge || s.SignDataType.amino, derivationPaths: Pe, addresses: Ie || void 0, origin: be || void 0 });
      }
    }
    k.fromDataItem = (x) => {
      const M = x.getData(), F = M[b.requestId] ? M[b.requestId].getData() : void 0, le = M[b.signData], ge = M[b.dataType], pe = M[b.derivationPaths].map((Ie) => A.CryptoKeypath.fromDataItem(Ie));
      return new k({ requestId: F, signData: le, dataType: ge, derivationPaths: pe, addresses: M[b.addresses] ? M[b.addresses] : void 0, origin: M[b.origin] ? M[b.origin] : void 0 });
    }, k.fromCBOR = (x) => {
      const M = t(x);
      return k.fromDataItem(M);
    };
    const { RegistryTypes: C, decodeToDataItem: B } = A.extend;
    var Q;
    (function(x) {
      x[x.requestId = 1] = "requestId", x[x.signature = 2] = "signature", x[x.publicKey = 3] = "publicKey";
    })(Q || (Q = {}));
    class P extends A.RegistryItem {
      constructor(M, F, le) {
        super(), this.getRegistryType = () => p.COSMOS_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const ge = {};
          return ge[Q.requestId] = new A.DataItem(this.requestId, C.UUID.getTag()), ge[Q.signature] = this.signature, ge[Q.publicKey] = this.publicKey, new A.DataItem(ge);
        }, this.signature = M, this.requestId = F, this.publicKey = le;
      }
    }
    P.fromDataItem = (x) => {
      const M = x.getData(), F = M[Q.signature], le = M[Q.requestId].getData();
      return new P(F, le, M[Q.publicKey]);
    }, P.fromCBOR = (x) => {
      const M = B(x);
      return P.fromDataItem(M);
    }, A.patchTags(Object.values(p).filter((x) => !!x.getTag()).map((x) => x.getTag())), Object.keys(A).forEach(function(x) {
      x !== "default" && Object.defineProperty(s, x, { enumerable: !0, get: function() {
        return A[x];
      } });
    }), s.CosmosSignRequest = k, s.CosmosSignature = P;
  }(bcUrRegistryCosmos_cjs_production_min)), bcUrRegistryCosmos_cjs_production_min;
}
var bcUrRegistryCosmos_cjs_development = {}, hasRequiredBcUrRegistryCosmos_cjs_development;
function requireBcUrRegistryCosmos_cjs_development() {
  return hasRequiredBcUrRegistryCosmos_cjs_development || (hasRequiredBcUrRegistryCosmos_cjs_development = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$i(), u = require$$1$2;
    const p = {
      COSMOS_SIGN_REQUEST: /* @__PURE__ */ new A.RegistryType("cosmos-sign-request", 4101),
      COSMOS_SIGNATURE: /* @__PURE__ */ new A.RegistryType("cosmos-signature", 4102)
    }, {
      decodeToDataItem: t,
      RegistryTypes: l
    } = A.extend;
    (function(P) {
      P[P.amino = 1] = "amino", P[P.direct = 2] = "direct", P[P.textual = 3] = "textual", P[P.message = 4] = "message";
    })(s.SignDataType || (s.SignDataType = {}));
    var m;
    (function(P) {
      P[P.requestId = 1] = "requestId", P[P.signData = 2] = "signData", P[P.dataType = 3] = "dataType", P[P.derivationPaths = 4] = "derivationPaths", P[P.addresses = 5] = "addresses", P[P.origin = 6] = "origin";
    })(m || (m = {}));
    class b extends A.RegistryItem {
      constructor(x) {
        super(), this.getRegistryType = () => p.COSMOS_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataype = () => this.dataType, this.getDerivationPaths = () => this.derivationPaths.map((M) => M.getPath()), this.getAddress = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const M = {};
          return M[m.requestId] = new A.DataItem(this.requestId, l.UUID.getTag()), M[m.signData] = this.signData, M[m.dataType] = this.dataType, M[m.derivationPaths] = this.derivationPaths.map((F) => {
            const le = F.toDataItem();
            return le.setTag(F.getRegistryType().getTag()), le;
          }), this.addresses && (M[m.addresses] = this.addresses), this.origin && (M[m.origin] = this.origin), new A.DataItem(M);
        }, this.requestId = x.requestId, this.signData = x.signData, this.dataType = x.dataType, this.derivationPaths = x.derivationPaths, this.addresses = x.addresses, this.origin = x.origin;
      }
      static constructCosmosRequest(x, M, F, le, ge, pe, Ie) {
        const be = ge.map((Pe, Te) => {
          const xe = Pe.replace(/[m|M]\//, "").split("/").map((Ee) => {
            const He = parseInt(Ee.replace("'", ""));
            let ve = !1;
            return Ee.endsWith("'") && (ve = !0), new A.PathComponent({
              index: He,
              hardened: ve
            });
          });
          return new A.CryptoKeypath(xe, Buffer.from(M[Te], "hex"));
        });
        return new b({
          requestId: Buffer.from(u.parse(x)),
          signData: F,
          dataType: le || s.SignDataType.amino,
          derivationPaths: be,
          addresses: pe || void 0,
          origin: Ie || void 0
        });
      }
    }
    b.fromDataItem = (P) => {
      const x = P.getData(), M = x[m.requestId] ? x[m.requestId].getData() : void 0, F = x[m.signData], le = x[m.dataType], ge = x[m.derivationPaths].map((be) => A.CryptoKeypath.fromDataItem(be)), pe = x[m.addresses] ? x[m.addresses] : void 0, Ie = x[m.origin] ? x[m.origin] : void 0;
      return new b({
        requestId: M,
        signData: F,
        dataType: le,
        derivationPaths: ge,
        addresses: pe,
        origin: Ie
      });
    }, b.fromCBOR = (P) => {
      const x = t(P);
      return b.fromDataItem(x);
    };
    const {
      RegistryTypes: k,
      decodeToDataItem: C
    } = A.extend;
    var B;
    (function(P) {
      P[P.requestId = 1] = "requestId", P[P.signature = 2] = "signature", P[P.publicKey = 3] = "publicKey";
    })(B || (B = {}));
    class Q extends A.RegistryItem {
      constructor(x, M, F) {
        super(), this.getRegistryType = () => p.COSMOS_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const le = {};
          return le[B.requestId] = new A.DataItem(this.requestId, k.UUID.getTag()), le[B.signature] = this.signature, le[B.publicKey] = this.publicKey, new A.DataItem(le);
        }, this.signature = x, this.requestId = M, this.publicKey = F;
      }
    }
    Q.fromDataItem = (P) => {
      const x = P.getData(), M = x[B.signature], F = x[B.requestId].getData(), le = x[B.publicKey];
      return new Q(M, F, le);
    }, Q.fromCBOR = (P) => {
      const x = C(P);
      return Q.fromDataItem(x);
    }, A.patchTags(Object.values(p).filter((P) => !!P.getTag()).map((P) => P.getTag())), Object.keys(A).forEach(function(P) {
      P !== "default" && Object.defineProperty(s, P, {
        enumerable: !0,
        get: function() {
          return A[P];
        }
      });
    }), s.CosmosSignRequest = b, s.CosmosSignature = Q;
  }(bcUrRegistryCosmos_cjs_development)), bcUrRegistryCosmos_cjs_development;
}
var hasRequiredDist$g;
function requireDist$g() {
  return hasRequiredDist$g || (hasRequiredDist$g = 1, process$1.env.NODE_ENV === "production" ? dist$f.exports = requireBcUrRegistryCosmos_cjs_production_min() : dist$f.exports = requireBcUrRegistryCosmos_cjs_development()), dist$f.exports;
}
var hasRequiredCosmos;
function requireCosmos() {
  if (hasRequiredCosmos) return cosmos;
  hasRequiredCosmos = 1, Object.defineProperty(cosmos, "__esModule", { value: !0 }), cosmos.KeystoneCosmosSDK = void 0;
  const s = requireUtils$d(), A = requireUr(), u = requireDist$g();
  class p {
    constructor(l) {
      this.config = l;
    }
    parseSignature(l) {
      if (l.type !== A.URType.CosmosSignature)
        throw new Error("type not match");
      const m = u.CosmosSignature.fromCBOR(l.cbor);
      return {
        requestId: (0, s.uuidStringify)(m.getRequestId()),
        signature: (0, s.toHex)(m.getSignature()),
        publicKey: (0, s.toHex)(m.getPublicKey())
      };
    }
    generateSignRequest({ requestId: l, signData: m, dataType: b, accounts: k, origin: C }) {
      var B;
      const Q = [], P = [];
      return k.forEach((x) => {
        Q.push(new u.CryptoKeypath((0, s.parsePath)(x.path).map((M) => new u.PathComponent(M)), (0, s.toBuffer)(x.xfp))), P.push(x.address);
      }), new u.CosmosSignRequest({
        signData: (0, s.toBuffer)(m),
        dataType: b,
        derivationPaths: Q,
        requestId: (0, s.uuidParse)(l),
        addresses: P,
        origin: C ?? ((B = this.config) === null || B === void 0 ? void 0 : B.origin)
      }).toUR();
    }
  }
  return p.DataType = u.SignDataType, cosmos.KeystoneCosmosSDK = p, cosmos;
}
var evm = {}, dist$e = { exports: {} }, bcUrRegistryEvm_cjs_production_min = {}, hasRequiredBcUrRegistryEvm_cjs_production_min;
function requireBcUrRegistryEvm_cjs_production_min() {
  return hasRequiredBcUrRegistryEvm_cjs_production_min || (hasRequiredBcUrRegistryEvm_cjs_production_min = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$i(), u = /* @__PURE__ */ requireCommonjsBrowser();
    const p = { EVM_SIGN_REQUEST: new A.RegistryType("evm-sign-request", 4101), EVM_SIGNATURE: new A.RegistryType("evm-signature", 4102) }, { decodeToDataItem: t, RegistryTypes: l } = A.extend;
    var m, b;
    (m = s.SignDataType || (s.SignDataType = {}))[m.arbitrary = 1] = "arbitrary", m[m.cosmosAmino = 2] = "cosmosAmino", m[m.cosmosDirect = 3] = "cosmosDirect", function(x) {
      x[x.requestId = 1] = "requestId", x[x.signData = 2] = "signData", x[x.dataType = 3] = "dataType", x[x.customChainIdentifier = 4] = "customChainIdentifier", x[x.derivationPath = 5] = "derivationPath", x[x.address = 6] = "address", x[x.origin = 7] = "origin";
    }(b || (b = {}));
    class k extends A.RegistryItem {
      constructor(M) {
        super(), this.getRegistryType = () => p.EVM_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataype = () => this.dataType, this.getCustomChainIdentifier = () => this.customChainIdentifier, this.getDerivationPath = () => this.derivationPath.getPath(), this.getAddress = () => this.address, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const F = {};
          F[b.requestId] = new A.DataItem(this.requestId, l.UUID.getTag()), F[b.signData] = this.signData, F[b.dataType] = this.dataType, F[b.customChainIdentifier] = this.customChainIdentifier;
          const le = this.derivationPath.toDataItem();
          return le.setTag(this.derivationPath.getRegistryType().getTag()), F[b.derivationPath] = le, this.address && (F[b.address] = this.address), this.origin && (F[b.origin] = this.origin), new A.DataItem(F);
        }, this.requestId = M.requestId, this.signData = M.signData, this.dataType = M.dataType, this.customChainIdentifier = M.customChainIdentifier, this.derivationPath = M.derivationPath, this.address = M.address, this.origin = M.origin;
      }
      static parsePath(M, F) {
        const le = M.replace(/[m|M]\//, "").split("/").map((ge) => {
          const pe = parseInt(ge.replace("'", ""));
          let Ie = !1;
          return ge.endsWith("'") && (Ie = !0), new A.PathComponent({ index: pe, hardened: Ie });
        });
        return new A.CryptoKeypath(le, Buffer.from(F, "hex"));
      }
      static constructEvmRequest(M, F, le, ge, pe, Ie, be, Pe) {
        return new k({ requestId: Buffer.from(u.parse(M)), signData: le, dataType: ge || s.SignDataType.arbitrary, customChainIdentifier: pe, derivationPath: k.parsePath(Ie, F), address: be, origin: Pe });
      }
    }
    k.fromDataItem = (x) => {
      const M = x.getData(), F = M[b.requestId] ? M[b.requestId].getData() : void 0;
      return new k({ requestId: F, signData: M[b.signData], dataType: M[b.dataType], customChainIdentifier: M[b.customChainIdentifier], derivationPath: A.CryptoKeypath.fromDataItem(M[b.derivationPath]), address: M[b.address], origin: M[b.origin] });
    }, k.fromCBOR = (x) => {
      const M = t(x);
      return k.fromDataItem(M);
    };
    const { RegistryTypes: C, decodeToDataItem: B } = A.extend;
    var Q;
    (function(x) {
      x[x.requestId = 1] = "requestId", x[x.signature = 2] = "signature";
    })(Q || (Q = {}));
    class P extends A.RegistryItem {
      constructor(M, F) {
        super(), this.getRegistryType = () => p.EVM_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const le = {};
          return le[Q.requestId] = new A.DataItem(this.requestId, C.UUID.getTag()), le[Q.signature] = this.signature, new A.DataItem(le);
        }, this.signature = M, this.requestId = F;
      }
    }
    P.fromDataItem = (x) => {
      const M = x.getData(), F = M[Q.signature], le = M[Q.requestId].getData();
      return new P(F, le);
    }, P.fromCBOR = (x) => {
      const M = B(x);
      return P.fromDataItem(M);
    }, A.patchTags(Object.values(p).filter((x) => !!x.getTag()).map((x) => x.getTag())), Object.keys(A).forEach(function(x) {
      x !== "default" && Object.defineProperty(s, x, { enumerable: !0, get: function() {
        return A[x];
      } });
    }), s.EvmSignRequest = k, s.EvmSignature = P;
  }(bcUrRegistryEvm_cjs_production_min)), bcUrRegistryEvm_cjs_production_min;
}
var bcUrRegistryEvm_cjs_development = {}, hasRequiredBcUrRegistryEvm_cjs_development;
function requireBcUrRegistryEvm_cjs_development() {
  return hasRequiredBcUrRegistryEvm_cjs_development || (hasRequiredBcUrRegistryEvm_cjs_development = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$i(), u = /* @__PURE__ */ requireCommonjsBrowser();
    const p = {
      EVM_SIGN_REQUEST: /* @__PURE__ */ new A.RegistryType("evm-sign-request", 4101),
      EVM_SIGNATURE: /* @__PURE__ */ new A.RegistryType("evm-signature", 4102)
    }, {
      decodeToDataItem: t,
      RegistryTypes: l
    } = A.extend;
    (function(P) {
      P[P.arbitrary = 1] = "arbitrary", P[P.cosmosAmino = 2] = "cosmosAmino", P[P.cosmosDirect = 3] = "cosmosDirect";
    })(s.SignDataType || (s.SignDataType = {}));
    var m;
    (function(P) {
      P[P.requestId = 1] = "requestId", P[P.signData = 2] = "signData", P[P.dataType = 3] = "dataType", P[P.customChainIdentifier = 4] = "customChainIdentifier", P[P.derivationPath = 5] = "derivationPath", P[P.address = 6] = "address", P[P.origin = 7] = "origin";
    })(m || (m = {}));
    class b extends A.RegistryItem {
      constructor(x) {
        super(), this.getRegistryType = () => p.EVM_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataype = () => this.dataType, this.getCustomChainIdentifier = () => this.customChainIdentifier, this.getDerivationPath = () => this.derivationPath.getPath(), this.getAddress = () => this.address, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const M = {};
          M[m.requestId] = new A.DataItem(this.requestId, l.UUID.getTag()), M[m.signData] = this.signData, M[m.dataType] = this.dataType, M[m.customChainIdentifier] = this.customChainIdentifier;
          const F = this.derivationPath.toDataItem();
          return F.setTag(this.derivationPath.getRegistryType().getTag()), M[m.derivationPath] = F, this.address && (M[m.address] = this.address), this.origin && (M[m.origin] = this.origin), new A.DataItem(M);
        }, this.requestId = x.requestId, this.signData = x.signData, this.dataType = x.dataType, this.customChainIdentifier = x.customChainIdentifier, this.derivationPath = x.derivationPath, this.address = x.address, this.origin = x.origin;
      }
      static parsePath(x, M) {
        const le = x.replace(/[m|M]\//, "").split("/").map((ge) => {
          const pe = parseInt(ge.replace("'", ""));
          let Ie = !1;
          return ge.endsWith("'") && (Ie = !0), new A.PathComponent({
            index: pe,
            hardened: Ie
          });
        });
        return new A.CryptoKeypath(le, Buffer.from(M, "hex"));
      }
      static constructEvmRequest(x, M, F, le, ge, pe, Ie, be) {
        return new b({
          requestId: Buffer.from(u.parse(x)),
          signData: F,
          dataType: le || s.SignDataType.arbitrary,
          customChainIdentifier: ge,
          derivationPath: b.parsePath(pe, M),
          address: Ie,
          origin: be
        });
      }
    }
    b.fromDataItem = (P) => {
      const x = P.getData(), M = x[m.requestId] ? x[m.requestId].getData() : void 0;
      return new b({
        requestId: M,
        signData: x[m.signData],
        dataType: x[m.dataType],
        customChainIdentifier: x[m.customChainIdentifier],
        derivationPath: A.CryptoKeypath.fromDataItem(x[m.derivationPath]),
        address: x[m.address],
        origin: x[m.origin]
      });
    }, b.fromCBOR = (P) => {
      const x = t(P);
      return b.fromDataItem(x);
    };
    const {
      RegistryTypes: k,
      decodeToDataItem: C
    } = A.extend;
    var B;
    (function(P) {
      P[P.requestId = 1] = "requestId", P[P.signature = 2] = "signature";
    })(B || (B = {}));
    class Q extends A.RegistryItem {
      constructor(x, M) {
        super(), this.getRegistryType = () => p.EVM_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const F = {};
          return F[B.requestId] = new A.DataItem(this.requestId, k.UUID.getTag()), F[B.signature] = this.signature, new A.DataItem(F);
        }, this.signature = x, this.requestId = M;
      }
    }
    Q.fromDataItem = (P) => {
      const x = P.getData(), M = x[B.signature], F = x[B.requestId].getData();
      return new Q(M, F);
    }, Q.fromCBOR = (P) => {
      const x = C(P);
      return Q.fromDataItem(x);
    }, A.patchTags(Object.values(p).filter((P) => !!P.getTag()).map((P) => P.getTag())), Object.keys(A).forEach(function(P) {
      P !== "default" && Object.defineProperty(s, P, {
        enumerable: !0,
        get: function() {
          return A[P];
        }
      });
    }), s.EvmSignRequest = b, s.EvmSignature = Q;
  }(bcUrRegistryEvm_cjs_development)), bcUrRegistryEvm_cjs_development;
}
var hasRequiredDist$f;
function requireDist$f() {
  return hasRequiredDist$f || (hasRequiredDist$f = 1, process$1.env.NODE_ENV === "production" ? dist$e.exports = requireBcUrRegistryEvm_cjs_production_min() : dist$e.exports = requireBcUrRegistryEvm_cjs_development()), dist$e.exports;
}
var hasRequiredEvm;
function requireEvm() {
  if (hasRequiredEvm) return evm;
  hasRequiredEvm = 1, Object.defineProperty(evm, "__esModule", { value: !0 }), evm.KeystoneEvmSDK = void 0;
  const s = requireUtils$d(), A = requireUr(), u = requireDist$f();
  class p {
    constructor(l) {
      this.config = l;
    }
    parseSignature(l) {
      if (l.type !== A.URType.EvmSignature)
        throw new Error("type not match");
      const m = u.EvmSignature.fromCBOR(l.cbor);
      return {
        requestId: (0, s.uuidStringify)(m.getRequestId()),
        signature: (0, s.toHex)(m.getSignature())
      };
    }
    generateSignRequest({ requestId: l, signData: m, dataType: b, customChainIdentifier: k, account: C, origin: B }) {
      var Q;
      const P = new u.CryptoKeypath((0, s.parsePath)(C.path).map((x) => new u.PathComponent(x)), (0, s.toBuffer)(C.xfp));
      return new u.EvmSignRequest({
        signData: (0, s.toBuffer)(m),
        dataType: b,
        customChainIdentifier: k,
        derivationPath: P,
        requestId: (0, s.uuidParse)(l),
        address: C.address !== void 0 ? (0, s.toBuffer)(C.address.substring(C.address.startsWith("0x") ? 2 : 0)) : void 0,
        origin: B ?? ((Q = this.config) === null || Q === void 0 ? void 0 : Q.origin)
      }).toUR();
    }
  }
  return p.DataType = u.SignDataType, evm.KeystoneEvmSDK = p, evm;
}
var ethereum$2 = {}, dist$d = { exports: {} }, bcUrRegistryEth_cjs_production_min = {}, cryptoBrowserify = {}, browser$9 = { exports: {} }, hasRequiredBrowser$9;
function requireBrowser$9() {
  if (hasRequiredBrowser$9) return browser$9.exports;
  hasRequiredBrowser$9 = 1;
  var s = 65536, A = 4294967295;
  function u() {
    throw new Error(`Secure random number generation is not supported by this browser.
Use Chrome, Firefox or Internet Explorer 11`);
  }
  var p = requireSafeBuffer$1().Buffer, t = commonjsGlobal.crypto || commonjsGlobal.msCrypto;
  t && t.getRandomValues ? browser$9.exports = l : browser$9.exports = u;
  function l(m, b) {
    if (m > A) throw new RangeError("requested too many random bytes");
    var k = p.allocUnsafe(m);
    if (m > 0)
      if (m > s)
        for (var C = 0; C < m; C += s)
          t.getRandomValues(k.slice(C, C + s));
      else
        t.getRandomValues(k);
    return typeof b == "function" ? process$1.nextTick(function() {
      b(null, k);
    }) : k;
  }
  return browser$9.exports;
}
var legacy, hasRequiredLegacy;
function requireLegacy() {
  if (hasRequiredLegacy) return legacy;
  hasRequiredLegacy = 1;
  var s = requireInherits_browser(), A = requireSafeBuffer$1().Buffer, u = requireCipherBase(), p = A.alloc(128), t = 64;
  function l(m, b) {
    u.call(this, "digest"), typeof b == "string" && (b = A.from(b)), this._alg = m, this._key = b, b.length > t ? b = m(b) : b.length < t && (b = A.concat([b, p], t));
    for (var k = this._ipad = A.allocUnsafe(t), C = this._opad = A.allocUnsafe(t), B = 0; B < t; B++)
      k[B] = b[B] ^ 54, C[B] = b[B] ^ 92;
    this._hash = [k];
  }
  return s(l, u), l.prototype._update = function(m) {
    this._hash.push(m);
  }, l.prototype._final = function() {
    var m = this._alg(A.concat(this._hash));
    return this._alg(A.concat([this._opad, m]));
  }, legacy = l, legacy;
}
var md5$3, hasRequiredMd5$2;
function requireMd5$2() {
  if (hasRequiredMd5$2) return md5$3;
  hasRequiredMd5$2 = 1;
  var s = requireMd5_js();
  return md5$3 = function(A) {
    return new s().update(A).digest();
  }, md5$3;
}
var browser$8, hasRequiredBrowser$8;
function requireBrowser$8() {
  if (hasRequiredBrowser$8) return browser$8;
  hasRequiredBrowser$8 = 1;
  var s = requireInherits_browser(), A = requireLegacy(), u = requireCipherBase(), p = requireSafeBuffer$1().Buffer, t = requireMd5$2(), l = requireRipemd160$1(), m = requireSha_js(), b = p.alloc(128);
  function k(C, B) {
    u.call(this, "digest"), typeof B == "string" && (B = p.from(B));
    var Q = C === "sha512" || C === "sha384" ? 128 : 64;
    if (this._alg = C, this._key = B, B.length > Q) {
      var P = C === "rmd160" ? new l() : m(C);
      B = P.update(B).digest();
    } else B.length < Q && (B = p.concat([B, b], Q));
    for (var x = this._ipad = p.allocUnsafe(Q), M = this._opad = p.allocUnsafe(Q), F = 0; F < Q; F++)
      x[F] = B[F] ^ 54, M[F] = B[F] ^ 92;
    this._hash = C === "rmd160" ? new l() : m(C), this._hash.update(x);
  }
  return s(k, u), k.prototype._update = function(C) {
    this._hash.update(C);
  }, k.prototype._final = function() {
    var C = this._hash.digest(), B = this._alg === "rmd160" ? new l() : m(this._alg);
    return B.update(this._opad).update(C).digest();
  }, browser$8 = function(B, Q) {
    return B = B.toLowerCase(), B === "rmd160" || B === "ripemd160" ? new k("rmd160", Q) : B === "md5" ? new A(t, Q) : new k(B, Q);
  }, browser$8;
}
const sha224WithRSAEncryption = { sign: "rsa", hash: "sha224", id: "302d300d06096086480165030402040500041c" }, sha256WithRSAEncryption = { sign: "rsa", hash: "sha256", id: "3031300d060960864801650304020105000420" }, sha384WithRSAEncryption = { sign: "rsa", hash: "sha384", id: "3041300d060960864801650304020205000430" }, sha512WithRSAEncryption = { sign: "rsa", hash: "sha512", id: "3051300d060960864801650304020305000440" }, sha256$8 = { sign: "ecdsa", hash: "sha256", id: "" }, sha224$1 = { sign: "ecdsa", hash: "sha224", id: "" }, sha384$1 = { sign: "ecdsa", hash: "sha384", id: "" }, sha512$3 = { sign: "ecdsa", hash: "sha512", id: "" }, DSA = { sign: "dsa", hash: "sha1", id: "" }, ripemd160WithRSA = { sign: "rsa", hash: "rmd160", id: "3021300906052b2403020105000414" }, md5WithRSAEncryption = { sign: "rsa", hash: "md5", id: "3020300c06082a864886f70d020505000410" }, require$$6 = {
  sha224WithRSAEncryption,
  "RSA-SHA224": { sign: "ecdsa/rsa", hash: "sha224", id: "302d300d06096086480165030402040500041c" },
  sha256WithRSAEncryption,
  "RSA-SHA256": { sign: "ecdsa/rsa", hash: "sha256", id: "3031300d060960864801650304020105000420" },
  sha384WithRSAEncryption,
  "RSA-SHA384": { sign: "ecdsa/rsa", hash: "sha384", id: "3041300d060960864801650304020205000430" },
  sha512WithRSAEncryption,
  "RSA-SHA512": { sign: "ecdsa/rsa", hash: "sha512", id: "3051300d060960864801650304020305000440" },
  "RSA-SHA1": { sign: "rsa", hash: "sha1", id: "3021300906052b0e03021a05000414" },
  "ecdsa-with-SHA1": { sign: "ecdsa", hash: "sha1", id: "" },
  sha256: sha256$8,
  sha224: sha224$1,
  sha384: sha384$1,
  sha512: sha512$3,
  "DSA-SHA": { sign: "dsa", hash: "sha1", id: "" },
  "DSA-SHA1": { sign: "dsa", hash: "sha1", id: "" },
  DSA,
  "DSA-WITH-SHA224": { sign: "dsa", hash: "sha224", id: "" },
  "DSA-SHA224": { sign: "dsa", hash: "sha224", id: "" },
  "DSA-WITH-SHA256": { sign: "dsa", hash: "sha256", id: "" },
  "DSA-SHA256": { sign: "dsa", hash: "sha256", id: "" },
  "DSA-WITH-SHA384": { sign: "dsa", hash: "sha384", id: "" },
  "DSA-SHA384": { sign: "dsa", hash: "sha384", id: "" },
  "DSA-WITH-SHA512": { sign: "dsa", hash: "sha512", id: "" },
  "DSA-SHA512": { sign: "dsa", hash: "sha512", id: "" },
  "DSA-RIPEMD160": { sign: "dsa", hash: "rmd160", id: "" },
  ripemd160WithRSA,
  "RSA-RIPEMD160": { sign: "rsa", hash: "rmd160", id: "3021300906052b2403020105000414" },
  md5WithRSAEncryption,
  "RSA-MD5": { sign: "rsa", hash: "md5", id: "3020300c06082a864886f70d020505000410" }
};
var algos, hasRequiredAlgos;
function requireAlgos() {
  return hasRequiredAlgos || (hasRequiredAlgos = 1, algos = require$$6), algos;
}
var browser$7 = {}, precondition, hasRequiredPrecondition;
function requirePrecondition() {
  if (hasRequiredPrecondition) return precondition;
  hasRequiredPrecondition = 1;
  var s = Math.pow(2, 30) - 1;
  return precondition = function(A, u) {
    if (typeof A != "number")
      throw new TypeError("Iterations not a number");
    if (A < 0)
      throw new TypeError("Bad iterations");
    if (typeof u != "number")
      throw new TypeError("Key length not a number");
    if (u < 0 || u > s || u !== u)
      throw new TypeError("Bad key length");
  }, precondition;
}
var defaultEncoding_1, hasRequiredDefaultEncoding;
function requireDefaultEncoding() {
  if (hasRequiredDefaultEncoding) return defaultEncoding_1;
  hasRequiredDefaultEncoding = 1;
  var s;
  if (commonjsGlobal.process && commonjsGlobal.process.browser)
    s = "utf-8";
  else if (commonjsGlobal.process && commonjsGlobal.process.version) {
    var A = parseInt(process$1.version.split(".")[0].slice(1), 10);
    s = A >= 6 ? "utf-8" : "binary";
  } else
    s = "utf-8";
  return defaultEncoding_1 = s, defaultEncoding_1;
}
var makeHash, hasRequiredMakeHash;
function requireMakeHash() {
  if (hasRequiredMakeHash) return makeHash;
  hasRequiredMakeHash = 1;
  var s = 4, A = new Buffer(s);
  A.fill(0);
  var u = 8, p = 16;
  function t(l) {
    if (l.length % s !== 0) {
      var m = l.length + (s - l.length % s);
      l = Buffer.concat([l, A], m);
    }
    for (var b = new Array(l.length >>> 2), k = 0, C = 0; k < l.length; k += s, C++)
      b[C] = l.readInt32LE(k);
    return b;
  }
  return makeHash = function(m, b) {
    var k = b(t(m), m.length * u);
    m = new Buffer(p);
    for (var C = 0; C < k.length; C++)
      m.writeInt32LE(k[C], C << 2, !0);
    return m;
  }, makeHash;
}
var md5$2, hasRequiredMd5$1;
function requireMd5$1() {
  if (hasRequiredMd5$1) return md5$2;
  hasRequiredMd5$1 = 1;
  var s = requireMakeHash();
  function A(C, B) {
    C[B >> 5] |= 128 << B % 32, C[(B + 64 >>> 9 << 4) + 14] = B;
    for (var Q = 1732584193, P = -271733879, x = -1732584194, M = 271733878, F = 0; F < C.length; F += 16) {
      var le = Q, ge = P, pe = x, Ie = M;
      Q = p(Q, P, x, M, C[F + 0], 7, -680876936), M = p(M, Q, P, x, C[F + 1], 12, -389564586), x = p(x, M, Q, P, C[F + 2], 17, 606105819), P = p(P, x, M, Q, C[F + 3], 22, -1044525330), Q = p(Q, P, x, M, C[F + 4], 7, -176418897), M = p(M, Q, P, x, C[F + 5], 12, 1200080426), x = p(x, M, Q, P, C[F + 6], 17, -1473231341), P = p(P, x, M, Q, C[F + 7], 22, -45705983), Q = p(Q, P, x, M, C[F + 8], 7, 1770035416), M = p(M, Q, P, x, C[F + 9], 12, -1958414417), x = p(x, M, Q, P, C[F + 10], 17, -42063), P = p(P, x, M, Q, C[F + 11], 22, -1990404162), Q = p(Q, P, x, M, C[F + 12], 7, 1804603682), M = p(M, Q, P, x, C[F + 13], 12, -40341101), x = p(x, M, Q, P, C[F + 14], 17, -1502002290), P = p(P, x, M, Q, C[F + 15], 22, 1236535329), Q = t(Q, P, x, M, C[F + 1], 5, -165796510), M = t(M, Q, P, x, C[F + 6], 9, -1069501632), x = t(x, M, Q, P, C[F + 11], 14, 643717713), P = t(P, x, M, Q, C[F + 0], 20, -373897302), Q = t(Q, P, x, M, C[F + 5], 5, -701558691), M = t(M, Q, P, x, C[F + 10], 9, 38016083), x = t(x, M, Q, P, C[F + 15], 14, -660478335), P = t(P, x, M, Q, C[F + 4], 20, -405537848), Q = t(Q, P, x, M, C[F + 9], 5, 568446438), M = t(M, Q, P, x, C[F + 14], 9, -1019803690), x = t(x, M, Q, P, C[F + 3], 14, -187363961), P = t(P, x, M, Q, C[F + 8], 20, 1163531501), Q = t(Q, P, x, M, C[F + 13], 5, -1444681467), M = t(M, Q, P, x, C[F + 2], 9, -51403784), x = t(x, M, Q, P, C[F + 7], 14, 1735328473), P = t(P, x, M, Q, C[F + 12], 20, -1926607734), Q = l(Q, P, x, M, C[F + 5], 4, -378558), M = l(M, Q, P, x, C[F + 8], 11, -2022574463), x = l(x, M, Q, P, C[F + 11], 16, 1839030562), P = l(P, x, M, Q, C[F + 14], 23, -35309556), Q = l(Q, P, x, M, C[F + 1], 4, -1530992060), M = l(M, Q, P, x, C[F + 4], 11, 1272893353), x = l(x, M, Q, P, C[F + 7], 16, -155497632), P = l(P, x, M, Q, C[F + 10], 23, -1094730640), Q = l(Q, P, x, M, C[F + 13], 4, 681279174), M = l(M, Q, P, x, C[F + 0], 11, -358537222), x = l(x, M, Q, P, C[F + 3], 16, -722521979), P = l(P, x, M, Q, C[F + 6], 23, 76029189), Q = l(Q, P, x, M, C[F + 9], 4, -640364487), M = l(M, Q, P, x, C[F + 12], 11, -421815835), x = l(x, M, Q, P, C[F + 15], 16, 530742520), P = l(P, x, M, Q, C[F + 2], 23, -995338651), Q = m(Q, P, x, M, C[F + 0], 6, -198630844), M = m(M, Q, P, x, C[F + 7], 10, 1126891415), x = m(x, M, Q, P, C[F + 14], 15, -1416354905), P = m(P, x, M, Q, C[F + 5], 21, -57434055), Q = m(Q, P, x, M, C[F + 12], 6, 1700485571), M = m(M, Q, P, x, C[F + 3], 10, -1894986606), x = m(x, M, Q, P, C[F + 10], 15, -1051523), P = m(P, x, M, Q, C[F + 1], 21, -2054922799), Q = m(Q, P, x, M, C[F + 8], 6, 1873313359), M = m(M, Q, P, x, C[F + 15], 10, -30611744), x = m(x, M, Q, P, C[F + 6], 15, -1560198380), P = m(P, x, M, Q, C[F + 13], 21, 1309151649), Q = m(Q, P, x, M, C[F + 4], 6, -145523070), M = m(M, Q, P, x, C[F + 11], 10, -1120210379), x = m(x, M, Q, P, C[F + 2], 15, 718787259), P = m(P, x, M, Q, C[F + 9], 21, -343485551), Q = b(Q, le), P = b(P, ge), x = b(x, pe), M = b(M, Ie);
    }
    return [Q, P, x, M];
  }
  function u(C, B, Q, P, x, M) {
    return b(k(b(b(B, C), b(P, M)), x), Q);
  }
  function p(C, B, Q, P, x, M, F) {
    return u(B & Q | ~B & P, C, B, x, M, F);
  }
  function t(C, B, Q, P, x, M, F) {
    return u(B & P | Q & ~P, C, B, x, M, F);
  }
  function l(C, B, Q, P, x, M, F) {
    return u(B ^ Q ^ P, C, B, x, M, F);
  }
  function m(C, B, Q, P, x, M, F) {
    return u(Q ^ (B | ~P), C, B, x, M, F);
  }
  function b(C, B) {
    var Q = (C & 65535) + (B & 65535), P = (C >> 16) + (B >> 16) + (Q >> 16);
    return P << 16 | Q & 65535;
  }
  function k(C, B) {
    return C << B | C >>> 32 - B;
  }
  return md5$2 = function(B) {
    return s(B, A);
  }, md5$2;
}
var hashBase, hasRequiredHashBase;
function requireHashBase() {
  if (hasRequiredHashBase) return hashBase;
  hasRequiredHashBase = 1;
  var s = requireStreamBrowserify().Transform, A = requireInherits_browser();
  function u(p) {
    s.call(this), this._block = new Buffer(p), this._blockSize = p, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }
  return A(u, s), u.prototype._transform = function(p, t, l) {
    var m = null;
    try {
      t !== "buffer" && (p = new Buffer(p, t)), this.update(p);
    } catch (b) {
      m = b;
    }
    l(m);
  }, u.prototype._flush = function(p) {
    var t = null;
    try {
      this.push(this._digest());
    } catch (l) {
      t = l;
    }
    p(t);
  }, u.prototype.update = function(p, t) {
    if (!Buffer.isBuffer(p) && typeof p != "string") throw new TypeError("Data must be a string or a buffer");
    if (this._finalized) throw new Error("Digest already called");
    Buffer.isBuffer(p) || (p = new Buffer(p, t || "binary"));
    for (var l = this._block, m = 0; this._blockOffset + p.length - m >= this._blockSize; ) {
      for (var b = this._blockOffset; b < this._blockSize; ) l[b++] = p[m++];
      this._update(), this._blockOffset = 0;
    }
    for (; m < p.length; ) l[this._blockOffset++] = p[m++];
    for (var k = 0, C = p.length * 8; C > 0; ++k)
      this._length[k] += C, C = this._length[k] / 4294967296 | 0, C > 0 && (this._length[k] -= 4294967296 * C);
    return this;
  }, u.prototype._update = function(p) {
    throw new Error("_update is not implemented");
  }, u.prototype.digest = function(p) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = !0;
    var t = this._digest();
    return p !== void 0 && (t = t.toString(p)), t;
  }, u.prototype._digest = function() {
    throw new Error("_digest is not implemented");
  }, hashBase = u, hashBase;
}
var ripemd160$3, hasRequiredRipemd160;
function requireRipemd160() {
  if (hasRequiredRipemd160) return ripemd160$3;
  hasRequiredRipemd160 = 1;
  var s = requireInherits_browser(), A = requireHashBase();
  function u() {
    A.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
  }
  s(u, A), u.prototype._update = function() {
    for (var C = new Array(16), B = 0; B < 16; ++B) C[B] = this._block.readInt32LE(B * 4);
    var Q = this._a, P = this._b, x = this._c, M = this._d, F = this._e;
    Q = t(Q, P, x, M, F, C[0], 0, 11), x = p(x, 10), F = t(F, Q, P, x, M, C[1], 0, 14), P = p(P, 10), M = t(M, F, Q, P, x, C[2], 0, 15), Q = p(Q, 10), x = t(x, M, F, Q, P, C[3], 0, 12), F = p(F, 10), P = t(P, x, M, F, Q, C[4], 0, 5), M = p(M, 10), Q = t(Q, P, x, M, F, C[5], 0, 8), x = p(x, 10), F = t(F, Q, P, x, M, C[6], 0, 7), P = p(P, 10), M = t(M, F, Q, P, x, C[7], 0, 9), Q = p(Q, 10), x = t(x, M, F, Q, P, C[8], 0, 11), F = p(F, 10), P = t(P, x, M, F, Q, C[9], 0, 13), M = p(M, 10), Q = t(Q, P, x, M, F, C[10], 0, 14), x = p(x, 10), F = t(F, Q, P, x, M, C[11], 0, 15), P = p(P, 10), M = t(M, F, Q, P, x, C[12], 0, 6), Q = p(Q, 10), x = t(x, M, F, Q, P, C[13], 0, 7), F = p(F, 10), P = t(P, x, M, F, Q, C[14], 0, 9), M = p(M, 10), Q = t(Q, P, x, M, F, C[15], 0, 8), x = p(x, 10), F = l(F, Q, P, x, M, C[7], 1518500249, 7), P = p(P, 10), M = l(M, F, Q, P, x, C[4], 1518500249, 6), Q = p(Q, 10), x = l(x, M, F, Q, P, C[13], 1518500249, 8), F = p(F, 10), P = l(P, x, M, F, Q, C[1], 1518500249, 13), M = p(M, 10), Q = l(Q, P, x, M, F, C[10], 1518500249, 11), x = p(x, 10), F = l(F, Q, P, x, M, C[6], 1518500249, 9), P = p(P, 10), M = l(M, F, Q, P, x, C[15], 1518500249, 7), Q = p(Q, 10), x = l(x, M, F, Q, P, C[3], 1518500249, 15), F = p(F, 10), P = l(P, x, M, F, Q, C[12], 1518500249, 7), M = p(M, 10), Q = l(Q, P, x, M, F, C[0], 1518500249, 12), x = p(x, 10), F = l(F, Q, P, x, M, C[9], 1518500249, 15), P = p(P, 10), M = l(M, F, Q, P, x, C[5], 1518500249, 9), Q = p(Q, 10), x = l(x, M, F, Q, P, C[2], 1518500249, 11), F = p(F, 10), P = l(P, x, M, F, Q, C[14], 1518500249, 7), M = p(M, 10), Q = l(Q, P, x, M, F, C[11], 1518500249, 13), x = p(x, 10), F = l(F, Q, P, x, M, C[8], 1518500249, 12), P = p(P, 10), M = m(M, F, Q, P, x, C[3], 1859775393, 11), Q = p(Q, 10), x = m(x, M, F, Q, P, C[10], 1859775393, 13), F = p(F, 10), P = m(P, x, M, F, Q, C[14], 1859775393, 6), M = p(M, 10), Q = m(Q, P, x, M, F, C[4], 1859775393, 7), x = p(x, 10), F = m(F, Q, P, x, M, C[9], 1859775393, 14), P = p(P, 10), M = m(M, F, Q, P, x, C[15], 1859775393, 9), Q = p(Q, 10), x = m(x, M, F, Q, P, C[8], 1859775393, 13), F = p(F, 10), P = m(P, x, M, F, Q, C[1], 1859775393, 15), M = p(M, 10), Q = m(Q, P, x, M, F, C[2], 1859775393, 14), x = p(x, 10), F = m(F, Q, P, x, M, C[7], 1859775393, 8), P = p(P, 10), M = m(M, F, Q, P, x, C[0], 1859775393, 13), Q = p(Q, 10), x = m(x, M, F, Q, P, C[6], 1859775393, 6), F = p(F, 10), P = m(P, x, M, F, Q, C[13], 1859775393, 5), M = p(M, 10), Q = m(Q, P, x, M, F, C[11], 1859775393, 12), x = p(x, 10), F = m(F, Q, P, x, M, C[5], 1859775393, 7), P = p(P, 10), M = m(M, F, Q, P, x, C[12], 1859775393, 5), Q = p(Q, 10), x = b(x, M, F, Q, P, C[1], 2400959708, 11), F = p(F, 10), P = b(P, x, M, F, Q, C[9], 2400959708, 12), M = p(M, 10), Q = b(Q, P, x, M, F, C[11], 2400959708, 14), x = p(x, 10), F = b(F, Q, P, x, M, C[10], 2400959708, 15), P = p(P, 10), M = b(M, F, Q, P, x, C[0], 2400959708, 14), Q = p(Q, 10), x = b(x, M, F, Q, P, C[8], 2400959708, 15), F = p(F, 10), P = b(P, x, M, F, Q, C[12], 2400959708, 9), M = p(M, 10), Q = b(Q, P, x, M, F, C[4], 2400959708, 8), x = p(x, 10), F = b(F, Q, P, x, M, C[13], 2400959708, 9), P = p(P, 10), M = b(M, F, Q, P, x, C[3], 2400959708, 14), Q = p(Q, 10), x = b(x, M, F, Q, P, C[7], 2400959708, 5), F = p(F, 10), P = b(P, x, M, F, Q, C[15], 2400959708, 6), M = p(M, 10), Q = b(Q, P, x, M, F, C[14], 2400959708, 8), x = p(x, 10), F = b(F, Q, P, x, M, C[5], 2400959708, 6), P = p(P, 10), M = b(M, F, Q, P, x, C[6], 2400959708, 5), Q = p(Q, 10), x = b(x, M, F, Q, P, C[2], 2400959708, 12), F = p(F, 10), P = k(P, x, M, F, Q, C[4], 2840853838, 9), M = p(M, 10), Q = k(Q, P, x, M, F, C[0], 2840853838, 15), x = p(x, 10), F = k(F, Q, P, x, M, C[5], 2840853838, 5), P = p(P, 10), M = k(M, F, Q, P, x, C[9], 2840853838, 11), Q = p(Q, 10), x = k(x, M, F, Q, P, C[7], 2840853838, 6), F = p(F, 10), P = k(P, x, M, F, Q, C[12], 2840853838, 8), M = p(M, 10), Q = k(Q, P, x, M, F, C[2], 2840853838, 13), x = p(x, 10), F = k(F, Q, P, x, M, C[10], 2840853838, 12), P = p(P, 10), M = k(M, F, Q, P, x, C[14], 2840853838, 5), Q = p(Q, 10), x = k(x, M, F, Q, P, C[1], 2840853838, 12), F = p(F, 10), P = k(P, x, M, F, Q, C[3], 2840853838, 13), M = p(M, 10), Q = k(Q, P, x, M, F, C[8], 2840853838, 14), x = p(x, 10), F = k(F, Q, P, x, M, C[11], 2840853838, 11), P = p(P, 10), M = k(M, F, Q, P, x, C[6], 2840853838, 8), Q = p(Q, 10), x = k(x, M, F, Q, P, C[15], 2840853838, 5), F = p(F, 10), P = k(P, x, M, F, Q, C[13], 2840853838, 6), M = p(M, 10);
    var le = this._a, ge = this._b, pe = this._c, Ie = this._d, be = this._e;
    le = k(le, ge, pe, Ie, be, C[5], 1352829926, 8), pe = p(pe, 10), be = k(be, le, ge, pe, Ie, C[14], 1352829926, 9), ge = p(ge, 10), Ie = k(Ie, be, le, ge, pe, C[7], 1352829926, 9), le = p(le, 10), pe = k(pe, Ie, be, le, ge, C[0], 1352829926, 11), be = p(be, 10), ge = k(ge, pe, Ie, be, le, C[9], 1352829926, 13), Ie = p(Ie, 10), le = k(le, ge, pe, Ie, be, C[2], 1352829926, 15), pe = p(pe, 10), be = k(be, le, ge, pe, Ie, C[11], 1352829926, 15), ge = p(ge, 10), Ie = k(Ie, be, le, ge, pe, C[4], 1352829926, 5), le = p(le, 10), pe = k(pe, Ie, be, le, ge, C[13], 1352829926, 7), be = p(be, 10), ge = k(ge, pe, Ie, be, le, C[6], 1352829926, 7), Ie = p(Ie, 10), le = k(le, ge, pe, Ie, be, C[15], 1352829926, 8), pe = p(pe, 10), be = k(be, le, ge, pe, Ie, C[8], 1352829926, 11), ge = p(ge, 10), Ie = k(Ie, be, le, ge, pe, C[1], 1352829926, 14), le = p(le, 10), pe = k(pe, Ie, be, le, ge, C[10], 1352829926, 14), be = p(be, 10), ge = k(ge, pe, Ie, be, le, C[3], 1352829926, 12), Ie = p(Ie, 10), le = k(le, ge, pe, Ie, be, C[12], 1352829926, 6), pe = p(pe, 10), be = b(be, le, ge, pe, Ie, C[6], 1548603684, 9), ge = p(ge, 10), Ie = b(Ie, be, le, ge, pe, C[11], 1548603684, 13), le = p(le, 10), pe = b(pe, Ie, be, le, ge, C[3], 1548603684, 15), be = p(be, 10), ge = b(ge, pe, Ie, be, le, C[7], 1548603684, 7), Ie = p(Ie, 10), le = b(le, ge, pe, Ie, be, C[0], 1548603684, 12), pe = p(pe, 10), be = b(be, le, ge, pe, Ie, C[13], 1548603684, 8), ge = p(ge, 10), Ie = b(Ie, be, le, ge, pe, C[5], 1548603684, 9), le = p(le, 10), pe = b(pe, Ie, be, le, ge, C[10], 1548603684, 11), be = p(be, 10), ge = b(ge, pe, Ie, be, le, C[14], 1548603684, 7), Ie = p(Ie, 10), le = b(le, ge, pe, Ie, be, C[15], 1548603684, 7), pe = p(pe, 10), be = b(be, le, ge, pe, Ie, C[8], 1548603684, 12), ge = p(ge, 10), Ie = b(Ie, be, le, ge, pe, C[12], 1548603684, 7), le = p(le, 10), pe = b(pe, Ie, be, le, ge, C[4], 1548603684, 6), be = p(be, 10), ge = b(ge, pe, Ie, be, le, C[9], 1548603684, 15), Ie = p(Ie, 10), le = b(le, ge, pe, Ie, be, C[1], 1548603684, 13), pe = p(pe, 10), be = b(be, le, ge, pe, Ie, C[2], 1548603684, 11), ge = p(ge, 10), Ie = m(Ie, be, le, ge, pe, C[15], 1836072691, 9), le = p(le, 10), pe = m(pe, Ie, be, le, ge, C[5], 1836072691, 7), be = p(be, 10), ge = m(ge, pe, Ie, be, le, C[1], 1836072691, 15), Ie = p(Ie, 10), le = m(le, ge, pe, Ie, be, C[3], 1836072691, 11), pe = p(pe, 10), be = m(be, le, ge, pe, Ie, C[7], 1836072691, 8), ge = p(ge, 10), Ie = m(Ie, be, le, ge, pe, C[14], 1836072691, 6), le = p(le, 10), pe = m(pe, Ie, be, le, ge, C[6], 1836072691, 6), be = p(be, 10), ge = m(ge, pe, Ie, be, le, C[9], 1836072691, 14), Ie = p(Ie, 10), le = m(le, ge, pe, Ie, be, C[11], 1836072691, 12), pe = p(pe, 10), be = m(be, le, ge, pe, Ie, C[8], 1836072691, 13), ge = p(ge, 10), Ie = m(Ie, be, le, ge, pe, C[12], 1836072691, 5), le = p(le, 10), pe = m(pe, Ie, be, le, ge, C[2], 1836072691, 14), be = p(be, 10), ge = m(ge, pe, Ie, be, le, C[10], 1836072691, 13), Ie = p(Ie, 10), le = m(le, ge, pe, Ie, be, C[0], 1836072691, 13), pe = p(pe, 10), be = m(be, le, ge, pe, Ie, C[4], 1836072691, 7), ge = p(ge, 10), Ie = m(Ie, be, le, ge, pe, C[13], 1836072691, 5), le = p(le, 10), pe = l(pe, Ie, be, le, ge, C[8], 2053994217, 15), be = p(be, 10), ge = l(ge, pe, Ie, be, le, C[6], 2053994217, 5), Ie = p(Ie, 10), le = l(le, ge, pe, Ie, be, C[4], 2053994217, 8), pe = p(pe, 10), be = l(be, le, ge, pe, Ie, C[1], 2053994217, 11), ge = p(ge, 10), Ie = l(Ie, be, le, ge, pe, C[3], 2053994217, 14), le = p(le, 10), pe = l(pe, Ie, be, le, ge, C[11], 2053994217, 14), be = p(be, 10), ge = l(ge, pe, Ie, be, le, C[15], 2053994217, 6), Ie = p(Ie, 10), le = l(le, ge, pe, Ie, be, C[0], 2053994217, 14), pe = p(pe, 10), be = l(be, le, ge, pe, Ie, C[5], 2053994217, 6), ge = p(ge, 10), Ie = l(Ie, be, le, ge, pe, C[12], 2053994217, 9), le = p(le, 10), pe = l(pe, Ie, be, le, ge, C[2], 2053994217, 12), be = p(be, 10), ge = l(ge, pe, Ie, be, le, C[13], 2053994217, 9), Ie = p(Ie, 10), le = l(le, ge, pe, Ie, be, C[9], 2053994217, 12), pe = p(pe, 10), be = l(be, le, ge, pe, Ie, C[7], 2053994217, 5), ge = p(ge, 10), Ie = l(Ie, be, le, ge, pe, C[10], 2053994217, 15), le = p(le, 10), pe = l(pe, Ie, be, le, ge, C[14], 2053994217, 8), be = p(be, 10), ge = t(ge, pe, Ie, be, le, C[12], 0, 8), Ie = p(Ie, 10), le = t(le, ge, pe, Ie, be, C[15], 0, 5), pe = p(pe, 10), be = t(be, le, ge, pe, Ie, C[10], 0, 12), ge = p(ge, 10), Ie = t(Ie, be, le, ge, pe, C[4], 0, 9), le = p(le, 10), pe = t(pe, Ie, be, le, ge, C[1], 0, 12), be = p(be, 10), ge = t(ge, pe, Ie, be, le, C[5], 0, 5), Ie = p(Ie, 10), le = t(le, ge, pe, Ie, be, C[8], 0, 14), pe = p(pe, 10), be = t(be, le, ge, pe, Ie, C[7], 0, 6), ge = p(ge, 10), Ie = t(Ie, be, le, ge, pe, C[6], 0, 8), le = p(le, 10), pe = t(pe, Ie, be, le, ge, C[2], 0, 13), be = p(be, 10), ge = t(ge, pe, Ie, be, le, C[13], 0, 6), Ie = p(Ie, 10), le = t(le, ge, pe, Ie, be, C[14], 0, 5), pe = p(pe, 10), be = t(be, le, ge, pe, Ie, C[0], 0, 15), ge = p(ge, 10), Ie = t(Ie, be, le, ge, pe, C[3], 0, 13), le = p(le, 10), pe = t(pe, Ie, be, le, ge, C[9], 0, 11), be = p(be, 10), ge = t(ge, pe, Ie, be, le, C[11], 0, 11), Ie = p(Ie, 10);
    var Pe = this._b + x + Ie | 0;
    this._b = this._c + M + be | 0, this._c = this._d + F + le | 0, this._d = this._e + Q + ge | 0, this._e = this._a + P + pe | 0, this._a = Pe;
  }, u.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var C = new Buffer(20);
    return C.writeInt32LE(this._a, 0), C.writeInt32LE(this._b, 4), C.writeInt32LE(this._c, 8), C.writeInt32LE(this._d, 12), C.writeInt32LE(this._e, 16), C;
  };
  function p(C, B) {
    return C << B | C >>> 32 - B;
  }
  function t(C, B, Q, P, x, M, F, le) {
    return p(C + (B ^ Q ^ P) + M + F | 0, le) + x | 0;
  }
  function l(C, B, Q, P, x, M, F, le) {
    return p(C + (B & Q | ~B & P) + M + F | 0, le) + x | 0;
  }
  function m(C, B, Q, P, x, M, F, le) {
    return p(C + ((B | ~Q) ^ P) + M + F | 0, le) + x | 0;
  }
  function b(C, B, Q, P, x, M, F, le) {
    return p(C + (B & P | Q & ~P) + M + F | 0, le) + x | 0;
  }
  function k(C, B, Q, P, x, M, F, le) {
    return p(C + (B ^ (Q | ~P)) + M + F | 0, le) + x | 0;
  }
  return ripemd160$3 = u, ripemd160$3;
}
var toBuffer_1, hasRequiredToBuffer;
function requireToBuffer() {
  if (hasRequiredToBuffer) return toBuffer_1;
  hasRequiredToBuffer = 1;
  var s = requireSafeBuffer$1().Buffer, A = /* @__PURE__ */ requireToBuffer$1(), u = typeof Uint8Array < "u", p = u && typeof ArrayBuffer < "u", t = p && ArrayBuffer.isView;
  return toBuffer_1 = function(l, m, b) {
    if (typeof l == "string" || s.isBuffer(l) || u && l instanceof Uint8Array || t && t(l))
      return A(l, m);
    throw new TypeError(b + " must be a string, a Buffer, a Uint8Array, or a DataView");
  }, toBuffer_1;
}
var syncBrowser, hasRequiredSyncBrowser;
function requireSyncBrowser() {
  if (hasRequiredSyncBrowser) return syncBrowser;
  hasRequiredSyncBrowser = 1;
  var s = requireMd5$1(), A = requireRipemd160(), u = requireSha_js(), p = requireSafeBuffer$1().Buffer, t = requirePrecondition(), l = requireDefaultEncoding(), m = requireToBuffer(), b = p.alloc(128), k = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    "sha512-256": 32,
    ripemd160: 20,
    rmd160: 20
  }, C = {
    __proto__: null,
    "sha-1": "sha1",
    "sha-224": "sha224",
    "sha-256": "sha256",
    "sha-384": "sha384",
    "sha-512": "sha512",
    "ripemd-160": "ripemd160"
  };
  function B(M) {
    return new A().update(M).digest();
  }
  function Q(M) {
    function F(le) {
      return u(M).update(le).digest();
    }
    return M === "rmd160" || M === "ripemd160" ? B : M === "md5" ? s : F;
  }
  function P(M, F, le) {
    var ge = Q(M), pe = M === "sha512" || M === "sha384" ? 128 : 64;
    F.length > pe ? F = ge(F) : F.length < pe && (F = p.concat([F, b], pe));
    for (var Ie = p.allocUnsafe(pe + k[M]), be = p.allocUnsafe(pe + k[M]), Pe = 0; Pe < pe; Pe++)
      Ie[Pe] = F[Pe] ^ 54, be[Pe] = F[Pe] ^ 92;
    var Te = p.allocUnsafe(pe + le + 4);
    Ie.copy(Te, 0, 0, pe), this.ipad1 = Te, this.ipad2 = Ie, this.opad = be, this.alg = M, this.blocksize = pe, this.hash = ge, this.size = k[M];
  }
  P.prototype.run = function(M, F) {
    M.copy(F, this.blocksize);
    var le = this.hash(F);
    return le.copy(this.opad, this.blocksize), this.hash(this.opad);
  };
  function x(M, F, le, ge, pe) {
    t(le, ge), M = m(M, l, "Password"), F = m(F, l, "Salt");
    var Ie = (pe || "sha1").toLowerCase(), be = C[Ie] || Ie, Pe = k[be];
    if (typeof Pe != "number" || !Pe)
      throw new TypeError("Digest algorithm not supported: " + pe);
    var Te = new P(be, M, F.length), Qe = p.allocUnsafe(ge), xe = p.allocUnsafe(F.length + 4);
    F.copy(xe, 0, 0, F.length);
    for (var Ee = 0, He = Pe, ve = Math.ceil(ge / He), we = 1; we <= ve; we++) {
      xe.writeUInt32BE(we, F.length);
      for (var Ce = Te.run(xe, Te.ipad1), Se = Ce, Ne = 1; Ne < le; Ne++) {
        Se = Te.run(Se, Te.ipad2);
        for (var rr = 0; rr < He; rr++)
          Ce[rr] ^= Se[rr];
      }
      Ce.copy(Qe, Ee), Ee += He;
    }
    return Qe;
  }
  return syncBrowser = x, syncBrowser;
}
var async, hasRequiredAsync;
function requireAsync() {
  if (hasRequiredAsync) return async;
  hasRequiredAsync = 1;
  var s = requireSafeBuffer$1().Buffer, A = requirePrecondition(), u = requireDefaultEncoding(), p = requireSyncBrowser(), t = requireToBuffer(), l, m = commonjsGlobal.crypto && commonjsGlobal.crypto.subtle, b = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
  }, k = [], C;
  function B() {
    return C || (commonjsGlobal.process && commonjsGlobal.process.nextTick ? C = commonjsGlobal.process.nextTick : commonjsGlobal.queueMicrotask ? C = commonjsGlobal.queueMicrotask : commonjsGlobal.setImmediate ? C = commonjsGlobal.setImmediate : C = commonjsGlobal.setTimeout, C);
  }
  function Q(M, F, le, ge, pe) {
    return m.importKey("raw", M, { name: "PBKDF2" }, !1, ["deriveBits"]).then(function(Ie) {
      return m.deriveBits({
        name: "PBKDF2",
        salt: F,
        iterations: le,
        hash: {
          name: pe
        }
      }, Ie, ge << 3);
    }).then(function(Ie) {
      return s.from(Ie);
    });
  }
  function P(M) {
    if (commonjsGlobal.process && !commonjsGlobal.process.browser || !m || !m.importKey || !m.deriveBits)
      return Promise.resolve(!1);
    if (k[M] !== void 0)
      return k[M];
    l = l || s.alloc(8);
    var F = Q(l, l, 10, 128, M).then(
      function() {
        return !0;
      },
      function() {
        return !1;
      }
    );
    return k[M] = F, F;
  }
  function x(M, F) {
    M.then(function(le) {
      B()(function() {
        F(null, le);
      });
    }, function(le) {
      B()(function() {
        F(le);
      });
    });
  }
  return async = function(M, F, le, ge, pe, Ie) {
    typeof pe == "function" && (Ie = pe, pe = void 0), pe = pe || "sha1";
    var be = b[pe.toLowerCase()];
    if (!be || typeof commonjsGlobal.Promise != "function") {
      B()(function() {
        var Pe;
        try {
          Pe = p(M, F, le, ge, pe);
        } catch (Te) {
          Ie(Te);
          return;
        }
        Ie(null, Pe);
      });
      return;
    }
    if (A(le, ge), M = t(M, u, "Password"), F = t(F, u, "Salt"), typeof Ie != "function")
      throw new Error("No callback provided to pbkdf2");
    x(P(be).then(function(Pe) {
      return Pe ? Q(M, F, le, ge, be) : p(M, F, le, ge, pe);
    }), Ie);
  }, async;
}
var hasRequiredBrowser$7;
function requireBrowser$7() {
  return hasRequiredBrowser$7 || (hasRequiredBrowser$7 = 1, browser$7.pbkdf2 = requireAsync(), browser$7.pbkdf2Sync = requireSyncBrowser()), browser$7;
}
var browser$6 = {}, des$1 = {}, utils$d = {}, hasRequiredUtils$b;
function requireUtils$b() {
  if (hasRequiredUtils$b) return utils$d;
  hasRequiredUtils$b = 1, utils$d.readUInt32BE = function(t, l) {
    var m = t[0 + l] << 24 | t[1 + l] << 16 | t[2 + l] << 8 | t[3 + l];
    return m >>> 0;
  }, utils$d.writeUInt32BE = function(t, l, m) {
    t[0 + m] = l >>> 24, t[1 + m] = l >>> 16 & 255, t[2 + m] = l >>> 8 & 255, t[3 + m] = l & 255;
  }, utils$d.ip = function(t, l, m, b) {
    for (var k = 0, C = 0, B = 6; B >= 0; B -= 2) {
      for (var Q = 0; Q <= 24; Q += 8)
        k <<= 1, k |= l >>> Q + B & 1;
      for (var Q = 0; Q <= 24; Q += 8)
        k <<= 1, k |= t >>> Q + B & 1;
    }
    for (var B = 6; B >= 0; B -= 2) {
      for (var Q = 1; Q <= 25; Q += 8)
        C <<= 1, C |= l >>> Q + B & 1;
      for (var Q = 1; Q <= 25; Q += 8)
        C <<= 1, C |= t >>> Q + B & 1;
    }
    m[b + 0] = k >>> 0, m[b + 1] = C >>> 0;
  }, utils$d.rip = function(t, l, m, b) {
    for (var k = 0, C = 0, B = 0; B < 4; B++)
      for (var Q = 24; Q >= 0; Q -= 8)
        k <<= 1, k |= l >>> Q + B & 1, k <<= 1, k |= t >>> Q + B & 1;
    for (var B = 4; B < 8; B++)
      for (var Q = 24; Q >= 0; Q -= 8)
        C <<= 1, C |= l >>> Q + B & 1, C <<= 1, C |= t >>> Q + B & 1;
    m[b + 0] = k >>> 0, m[b + 1] = C >>> 0;
  }, utils$d.pc1 = function(t, l, m, b) {
    for (var k = 0, C = 0, B = 7; B >= 5; B--) {
      for (var Q = 0; Q <= 24; Q += 8)
        k <<= 1, k |= l >> Q + B & 1;
      for (var Q = 0; Q <= 24; Q += 8)
        k <<= 1, k |= t >> Q + B & 1;
    }
    for (var Q = 0; Q <= 24; Q += 8)
      k <<= 1, k |= l >> Q + B & 1;
    for (var B = 1; B <= 3; B++) {
      for (var Q = 0; Q <= 24; Q += 8)
        C <<= 1, C |= l >> Q + B & 1;
      for (var Q = 0; Q <= 24; Q += 8)
        C <<= 1, C |= t >> Q + B & 1;
    }
    for (var Q = 0; Q <= 24; Q += 8)
      C <<= 1, C |= t >> Q + B & 1;
    m[b + 0] = k >>> 0, m[b + 1] = C >>> 0;
  }, utils$d.r28shl = function(t, l) {
    return t << l & 268435455 | t >>> 28 - l;
  };
  var s = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
  ];
  utils$d.pc2 = function(t, l, m, b) {
    for (var k = 0, C = 0, B = s.length >>> 1, Q = 0; Q < B; Q++)
      k <<= 1, k |= t >>> s[Q] & 1;
    for (var Q = B; Q < s.length; Q++)
      C <<= 1, C |= l >>> s[Q] & 1;
    m[b + 0] = k >>> 0, m[b + 1] = C >>> 0;
  }, utils$d.expand = function(t, l, m) {
    var b = 0, k = 0;
    b = (t & 1) << 5 | t >>> 27;
    for (var C = 23; C >= 15; C -= 4)
      b <<= 6, b |= t >>> C & 63;
    for (var C = 11; C >= 3; C -= 4)
      k |= t >>> C & 63, k <<= 6;
    k |= (t & 31) << 1 | t >>> 31, l[m + 0] = b >>> 0, l[m + 1] = k >>> 0;
  };
  var A = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
  ];
  utils$d.substitute = function(t, l) {
    for (var m = 0, b = 0; b < 4; b++) {
      var k = t >>> 18 - b * 6 & 63, C = A[b * 64 + k];
      m <<= 4, m |= C;
    }
    for (var b = 0; b < 4; b++) {
      var k = l >>> 18 - b * 6 & 63, C = A[256 + b * 64 + k];
      m <<= 4, m |= C;
    }
    return m >>> 0;
  };
  var u = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
  ];
  return utils$d.permute = function(t) {
    for (var l = 0, m = 0; m < u.length; m++)
      l <<= 1, l |= t >>> u[m] & 1;
    return l >>> 0;
  }, utils$d.padSplit = function(t, l, m) {
    for (var b = t.toString(2); b.length < l; )
      b = "0" + b;
    for (var k = [], C = 0; C < l; C += m)
      k.push(b.slice(C, C + m));
    return k.join(" ");
  }, utils$d;
}
var minimalisticAssert, hasRequiredMinimalisticAssert;
function requireMinimalisticAssert() {
  if (hasRequiredMinimalisticAssert) return minimalisticAssert;
  hasRequiredMinimalisticAssert = 1, minimalisticAssert = s;
  function s(A, u) {
    if (!A)
      throw new Error(u || "Assertion failed");
  }
  return s.equal = function(u, p, t) {
    if (u != p)
      throw new Error(t || "Assertion failed: " + u + " != " + p);
  }, minimalisticAssert;
}
var cipher, hasRequiredCipher;
function requireCipher() {
  if (hasRequiredCipher) return cipher;
  hasRequiredCipher = 1;
  var s = requireMinimalisticAssert();
  function A(u) {
    this.options = u, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = u.padding !== !1;
  }
  return cipher = A, A.prototype._init = function() {
  }, A.prototype.update = function(p) {
    return p.length === 0 ? [] : this.type === "decrypt" ? this._updateDecrypt(p) : this._updateEncrypt(p);
  }, A.prototype._buffer = function(p, t) {
    for (var l = Math.min(this.buffer.length - this.bufferOff, p.length - t), m = 0; m < l; m++)
      this.buffer[this.bufferOff + m] = p[t + m];
    return this.bufferOff += l, l;
  }, A.prototype._flushBuffer = function(p, t) {
    return this._update(this.buffer, 0, p, t), this.bufferOff = 0, this.blockSize;
  }, A.prototype._updateEncrypt = function(p) {
    var t = 0, l = 0, m = (this.bufferOff + p.length) / this.blockSize | 0, b = new Array(m * this.blockSize);
    this.bufferOff !== 0 && (t += this._buffer(p, t), this.bufferOff === this.buffer.length && (l += this._flushBuffer(b, l)));
    for (var k = p.length - (p.length - t) % this.blockSize; t < k; t += this.blockSize)
      this._update(p, t, b, l), l += this.blockSize;
    for (; t < p.length; t++, this.bufferOff++)
      this.buffer[this.bufferOff] = p[t];
    return b;
  }, A.prototype._updateDecrypt = function(p) {
    for (var t = 0, l = 0, m = Math.ceil((this.bufferOff + p.length) / this.blockSize) - 1, b = new Array(m * this.blockSize); m > 0; m--)
      t += this._buffer(p, t), l += this._flushBuffer(b, l);
    return t += this._buffer(p, t), b;
  }, A.prototype.final = function(p) {
    var t;
    p && (t = this.update(p));
    var l;
    return this.type === "encrypt" ? l = this._finalEncrypt() : l = this._finalDecrypt(), t ? t.concat(l) : l;
  }, A.prototype._pad = function(p, t) {
    if (t === 0)
      return !1;
    for (; t < p.length; )
      p[t++] = 0;
    return !0;
  }, A.prototype._finalEncrypt = function() {
    if (!this._pad(this.buffer, this.bufferOff))
      return [];
    var p = new Array(this.blockSize);
    return this._update(this.buffer, 0, p, 0), p;
  }, A.prototype._unpad = function(p) {
    return p;
  }, A.prototype._finalDecrypt = function() {
    s.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var p = new Array(this.blockSize);
    return this._flushBuffer(p, 0), this._unpad(p);
  }, cipher;
}
var des, hasRequiredDes$1;
function requireDes$1() {
  if (hasRequiredDes$1) return des;
  hasRequiredDes$1 = 1;
  var s = requireMinimalisticAssert(), A = requireInherits_browser(), u = requireUtils$b(), p = requireCipher();
  function t() {
    this.tmp = new Array(2), this.keys = null;
  }
  function l(b) {
    p.call(this, b);
    var k = new t();
    this._desState = k, this.deriveKeys(k, b.key);
  }
  A(l, p), des = l, l.create = function(k) {
    return new l(k);
  };
  var m = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
  ];
  return l.prototype.deriveKeys = function(k, C) {
    k.keys = new Array(32), s.equal(C.length, this.blockSize, "Invalid key length");
    var B = u.readUInt32BE(C, 0), Q = u.readUInt32BE(C, 4);
    u.pc1(B, Q, k.tmp, 0), B = k.tmp[0], Q = k.tmp[1];
    for (var P = 0; P < k.keys.length; P += 2) {
      var x = m[P >>> 1];
      B = u.r28shl(B, x), Q = u.r28shl(Q, x), u.pc2(B, Q, k.keys, P);
    }
  }, l.prototype._update = function(k, C, B, Q) {
    var P = this._desState, x = u.readUInt32BE(k, C), M = u.readUInt32BE(k, C + 4);
    u.ip(x, M, P.tmp, 0), x = P.tmp[0], M = P.tmp[1], this.type === "encrypt" ? this._encrypt(P, x, M, P.tmp, 0) : this._decrypt(P, x, M, P.tmp, 0), x = P.tmp[0], M = P.tmp[1], u.writeUInt32BE(B, x, Q), u.writeUInt32BE(B, M, Q + 4);
  }, l.prototype._pad = function(k, C) {
    if (this.padding === !1)
      return !1;
    for (var B = k.length - C, Q = C; Q < k.length; Q++)
      k[Q] = B;
    return !0;
  }, l.prototype._unpad = function(k) {
    if (this.padding === !1)
      return k;
    for (var C = k[k.length - 1], B = k.length - C; B < k.length; B++)
      s.equal(k[B], C);
    return k.slice(0, k.length - C);
  }, l.prototype._encrypt = function(k, C, B, Q, P) {
    for (var x = C, M = B, F = 0; F < k.keys.length; F += 2) {
      var le = k.keys[F], ge = k.keys[F + 1];
      u.expand(M, k.tmp, 0), le ^= k.tmp[0], ge ^= k.tmp[1];
      var pe = u.substitute(le, ge), Ie = u.permute(pe), be = M;
      M = (x ^ Ie) >>> 0, x = be;
    }
    u.rip(M, x, Q, P);
  }, l.prototype._decrypt = function(k, C, B, Q, P) {
    for (var x = B, M = C, F = k.keys.length - 2; F >= 0; F -= 2) {
      var le = k.keys[F], ge = k.keys[F + 1];
      u.expand(x, k.tmp, 0), le ^= k.tmp[0], ge ^= k.tmp[1];
      var pe = u.substitute(le, ge), Ie = u.permute(pe), be = x;
      x = (M ^ Ie) >>> 0, M = be;
    }
    u.rip(x, M, Q, P);
  }, des;
}
var cbc$1 = {}, hasRequiredCbc$1;
function requireCbc$1() {
  if (hasRequiredCbc$1) return cbc$1;
  hasRequiredCbc$1 = 1;
  var s = requireMinimalisticAssert(), A = requireInherits_browser(), u = {};
  function p(l) {
    s.equal(l.length, 8, "Invalid IV length"), this.iv = new Array(8);
    for (var m = 0; m < this.iv.length; m++)
      this.iv[m] = l[m];
  }
  function t(l) {
    function m(B) {
      l.call(this, B), this._cbcInit();
    }
    A(m, l);
    for (var b = Object.keys(u), k = 0; k < b.length; k++) {
      var C = b[k];
      m.prototype[C] = u[C];
    }
    return m.create = function(Q) {
      return new m(Q);
    }, m;
  }
  return cbc$1.instantiate = t, u._cbcInit = function() {
    var m = new p(this.options.iv);
    this._cbcState = m;
  }, u._update = function(m, b, k, C) {
    var B = this._cbcState, Q = this.constructor.super_.prototype, P = B.iv;
    if (this.type === "encrypt") {
      for (var x = 0; x < this.blockSize; x++)
        P[x] ^= m[b + x];
      Q._update.call(this, P, 0, k, C);
      for (var x = 0; x < this.blockSize; x++)
        P[x] = k[C + x];
    } else {
      Q._update.call(this, m, b, k, C);
      for (var x = 0; x < this.blockSize; x++)
        k[C + x] ^= P[x];
      for (var x = 0; x < this.blockSize; x++)
        P[x] = m[b + x];
    }
  }, cbc$1;
}
var ede, hasRequiredEde;
function requireEde() {
  if (hasRequiredEde) return ede;
  hasRequiredEde = 1;
  var s = requireMinimalisticAssert(), A = requireInherits_browser(), u = requireCipher(), p = requireDes$1();
  function t(m, b) {
    s.equal(b.length, 24, "Invalid key length");
    var k = b.slice(0, 8), C = b.slice(8, 16), B = b.slice(16, 24);
    m === "encrypt" ? this.ciphers = [
      p.create({ type: "encrypt", key: k }),
      p.create({ type: "decrypt", key: C }),
      p.create({ type: "encrypt", key: B })
    ] : this.ciphers = [
      p.create({ type: "decrypt", key: B }),
      p.create({ type: "encrypt", key: C }),
      p.create({ type: "decrypt", key: k })
    ];
  }
  function l(m) {
    u.call(this, m);
    var b = new t(this.type, this.options.key);
    this._edeState = b;
  }
  return A(l, u), ede = l, l.create = function(b) {
    return new l(b);
  }, l.prototype._update = function(b, k, C, B) {
    var Q = this._edeState;
    Q.ciphers[0]._update(b, k, C, B), Q.ciphers[1]._update(C, B, C, B), Q.ciphers[2]._update(C, B, C, B);
  }, l.prototype._pad = p.prototype._pad, l.prototype._unpad = p.prototype._unpad, ede;
}
var hasRequiredDes;
function requireDes() {
  return hasRequiredDes || (hasRequiredDes = 1, des$1.utils = requireUtils$b(), des$1.Cipher = requireCipher(), des$1.DES = requireDes$1(), des$1.CBC = requireCbc$1(), des$1.EDE = requireEde()), des$1;
}
var browserifyDes, hasRequiredBrowserifyDes;
function requireBrowserifyDes() {
  if (hasRequiredBrowserifyDes) return browserifyDes;
  hasRequiredBrowserifyDes = 1;
  var s = requireCipherBase(), A = requireDes(), u = requireInherits_browser(), p = requireSafeBuffer$1().Buffer, t = {
    "des-ede3-cbc": A.CBC.instantiate(A.EDE),
    "des-ede3": A.EDE,
    "des-ede-cbc": A.CBC.instantiate(A.EDE),
    "des-ede": A.EDE,
    "des-cbc": A.CBC.instantiate(A.DES),
    "des-ecb": A.DES
  };
  t.des = t["des-cbc"], t.des3 = t["des-ede3-cbc"], browserifyDes = l, u(l, s);
  function l(m) {
    s.call(this);
    var b = m.mode.toLowerCase(), k = t[b], C;
    m.decrypt ? C = "decrypt" : C = "encrypt";
    var B = m.key;
    p.isBuffer(B) || (B = p.from(B)), (b === "des-ede" || b === "des-ede-cbc") && (B = p.concat([B, B.slice(0, 8)]));
    var Q = m.iv;
    p.isBuffer(Q) || (Q = p.from(Q)), this._des = k.create({
      key: B,
      iv: Q,
      type: C
    });
  }
  return l.prototype._update = function(m) {
    return p.from(this._des.update(m));
  }, l.prototype._final = function() {
    return p.from(this._des.final());
  }, browserifyDes;
}
var browser$5 = {}, encrypter = {}, ecb = {}, hasRequiredEcb;
function requireEcb() {
  return hasRequiredEcb || (hasRequiredEcb = 1, ecb.encrypt = function(s, A) {
    return s._cipher.encryptBlock(A);
  }, ecb.decrypt = function(s, A) {
    return s._cipher.decryptBlock(A);
  }), ecb;
}
var cbc = {}, bufferXor, hasRequiredBufferXor;
function requireBufferXor() {
  return hasRequiredBufferXor || (hasRequiredBufferXor = 1, bufferXor = function(A, u) {
    for (var p = Math.min(A.length, u.length), t = new Buffer(p), l = 0; l < p; ++l)
      t[l] = A[l] ^ u[l];
    return t;
  }), bufferXor;
}
var hasRequiredCbc;
function requireCbc() {
  if (hasRequiredCbc) return cbc;
  hasRequiredCbc = 1;
  var s = requireBufferXor();
  return cbc.encrypt = function(A, u) {
    var p = s(u, A._prev);
    return A._prev = A._cipher.encryptBlock(p), A._prev;
  }, cbc.decrypt = function(A, u) {
    var p = A._prev;
    A._prev = u;
    var t = A._cipher.decryptBlock(u);
    return s(t, p);
  }, cbc;
}
var cfb = {}, hasRequiredCfb;
function requireCfb() {
  if (hasRequiredCfb) return cfb;
  hasRequiredCfb = 1;
  var s = requireSafeBuffer$1().Buffer, A = requireBufferXor();
  function u(p, t, l) {
    var m = t.length, b = A(t, p._cache);
    return p._cache = p._cache.slice(m), p._prev = s.concat([p._prev, l ? t : b]), b;
  }
  return cfb.encrypt = function(p, t, l) {
    for (var m = s.allocUnsafe(0), b; t.length; )
      if (p._cache.length === 0 && (p._cache = p._cipher.encryptBlock(p._prev), p._prev = s.allocUnsafe(0)), p._cache.length <= t.length)
        b = p._cache.length, m = s.concat([m, u(p, t.slice(0, b), l)]), t = t.slice(b);
      else {
        m = s.concat([m, u(p, t, l)]);
        break;
      }
    return m;
  }, cfb;
}
var cfb8 = {}, hasRequiredCfb8;
function requireCfb8() {
  if (hasRequiredCfb8) return cfb8;
  hasRequiredCfb8 = 1;
  var s = requireSafeBuffer$1().Buffer;
  function A(u, p, t) {
    var l = u._cipher.encryptBlock(u._prev), m = l[0] ^ p;
    return u._prev = s.concat([
      u._prev.slice(1),
      s.from([t ? p : m])
    ]), m;
  }
  return cfb8.encrypt = function(u, p, t) {
    for (var l = p.length, m = s.allocUnsafe(l), b = -1; ++b < l; )
      m[b] = A(u, p[b], t);
    return m;
  }, cfb8;
}
var cfb1 = {}, hasRequiredCfb1;
function requireCfb1() {
  if (hasRequiredCfb1) return cfb1;
  hasRequiredCfb1 = 1;
  var s = requireSafeBuffer$1().Buffer;
  function A(p, t, l) {
    for (var m, b = -1, k = 8, C = 0, B, Q; ++b < k; )
      m = p._cipher.encryptBlock(p._prev), B = t & 1 << 7 - b ? 128 : 0, Q = m[0] ^ B, C += (Q & 128) >> b % 8, p._prev = u(p._prev, l ? B : Q);
    return C;
  }
  function u(p, t) {
    var l = p.length, m = -1, b = s.allocUnsafe(p.length);
    for (p = s.concat([p, s.from([t])]); ++m < l; )
      b[m] = p[m] << 1 | p[m + 1] >> 7;
    return b;
  }
  return cfb1.encrypt = function(p, t, l) {
    for (var m = t.length, b = s.allocUnsafe(m), k = -1; ++k < m; )
      b[k] = A(p, t[k], l);
    return b;
  }, cfb1;
}
var ofb = {}, hasRequiredOfb;
function requireOfb() {
  if (hasRequiredOfb) return ofb;
  hasRequiredOfb = 1;
  var s = requireBufferXor();
  function A(u) {
    return u._prev = u._cipher.encryptBlock(u._prev), u._prev;
  }
  return ofb.encrypt = function(u, p) {
    for (; u._cache.length < p.length; )
      u._cache = Buffer.concat([u._cache, A(u)]);
    var t = u._cache.slice(0, p.length);
    return u._cache = u._cache.slice(p.length), s(p, t);
  }, ofb;
}
var ctr = {}, incr32_1, hasRequiredIncr32;
function requireIncr32() {
  if (hasRequiredIncr32) return incr32_1;
  hasRequiredIncr32 = 1;
  function s(A) {
    for (var u = A.length, p; u--; )
      if (p = A.readUInt8(u), p === 255)
        A.writeUInt8(0, u);
      else {
        p++, A.writeUInt8(p, u);
        break;
      }
  }
  return incr32_1 = s, incr32_1;
}
var hasRequiredCtr;
function requireCtr() {
  if (hasRequiredCtr) return ctr;
  hasRequiredCtr = 1;
  var s = requireBufferXor(), A = requireSafeBuffer$1().Buffer, u = requireIncr32();
  function p(l) {
    var m = l._cipher.encryptBlockRaw(l._prev);
    return u(l._prev), m;
  }
  var t = 16;
  return ctr.encrypt = function(l, m) {
    var b = Math.ceil(m.length / t), k = l._cache.length;
    l._cache = A.concat([
      l._cache,
      A.allocUnsafe(b * t)
    ]);
    for (var C = 0; C < b; C++) {
      var B = p(l), Q = k + C * t;
      l._cache.writeUInt32BE(B[0], Q + 0), l._cache.writeUInt32BE(B[1], Q + 4), l._cache.writeUInt32BE(B[2], Q + 8), l._cache.writeUInt32BE(B[3], Q + 12);
    }
    var P = l._cache.slice(0, m.length);
    return l._cache = l._cache.slice(m.length), s(m, P);
  }, ctr;
}
const aes128 = { cipher: "AES", key: 128, iv: 16, mode: "CBC", type: "block" }, aes192 = { cipher: "AES", key: 192, iv: 16, mode: "CBC", type: "block" }, aes256 = { cipher: "AES", key: 256, iv: 16, mode: "CBC", type: "block" }, require$$2 = {
  "aes-128-ecb": { cipher: "AES", key: 128, iv: 0, mode: "ECB", type: "block" },
  "aes-192-ecb": { cipher: "AES", key: 192, iv: 0, mode: "ECB", type: "block" },
  "aes-256-ecb": { cipher: "AES", key: 256, iv: 0, mode: "ECB", type: "block" },
  "aes-128-cbc": { cipher: "AES", key: 128, iv: 16, mode: "CBC", type: "block" },
  "aes-192-cbc": { cipher: "AES", key: 192, iv: 16, mode: "CBC", type: "block" },
  "aes-256-cbc": { cipher: "AES", key: 256, iv: 16, mode: "CBC", type: "block" },
  aes128,
  aes192,
  aes256,
  "aes-128-cfb": { cipher: "AES", key: 128, iv: 16, mode: "CFB", type: "stream" },
  "aes-192-cfb": { cipher: "AES", key: 192, iv: 16, mode: "CFB", type: "stream" },
  "aes-256-cfb": { cipher: "AES", key: 256, iv: 16, mode: "CFB", type: "stream" },
  "aes-128-cfb8": { cipher: "AES", key: 128, iv: 16, mode: "CFB8", type: "stream" },
  "aes-192-cfb8": { cipher: "AES", key: 192, iv: 16, mode: "CFB8", type: "stream" },
  "aes-256-cfb8": { cipher: "AES", key: 256, iv: 16, mode: "CFB8", type: "stream" },
  "aes-128-cfb1": { cipher: "AES", key: 128, iv: 16, mode: "CFB1", type: "stream" },
  "aes-192-cfb1": { cipher: "AES", key: 192, iv: 16, mode: "CFB1", type: "stream" },
  "aes-256-cfb1": { cipher: "AES", key: 256, iv: 16, mode: "CFB1", type: "stream" },
  "aes-128-ofb": { cipher: "AES", key: 128, iv: 16, mode: "OFB", type: "stream" },
  "aes-192-ofb": { cipher: "AES", key: 192, iv: 16, mode: "OFB", type: "stream" },
  "aes-256-ofb": { cipher: "AES", key: 256, iv: 16, mode: "OFB", type: "stream" },
  "aes-128-ctr": { cipher: "AES", key: 128, iv: 16, mode: "CTR", type: "stream" },
  "aes-192-ctr": { cipher: "AES", key: 192, iv: 16, mode: "CTR", type: "stream" },
  "aes-256-ctr": { cipher: "AES", key: 256, iv: 16, mode: "CTR", type: "stream" },
  "aes-128-gcm": { cipher: "AES", key: 128, iv: 12, mode: "GCM", type: "auth" },
  "aes-192-gcm": { cipher: "AES", key: 192, iv: 12, mode: "GCM", type: "auth" },
  "aes-256-gcm": { cipher: "AES", key: 256, iv: 12, mode: "GCM", type: "auth" }
};
var modes_1, hasRequiredModes$1;
function requireModes$1() {
  if (hasRequiredModes$1) return modes_1;
  hasRequiredModes$1 = 1;
  var s = {
    ECB: requireEcb(),
    CBC: requireCbc(),
    CFB: requireCfb(),
    CFB8: requireCfb8(),
    CFB1: requireCfb1(),
    OFB: requireOfb(),
    CTR: requireCtr(),
    GCM: requireCtr()
  }, A = require$$2;
  for (var u in A)
    A[u].module = s[A[u].mode];
  return modes_1 = A, modes_1;
}
var aes = {}, hasRequiredAes;
function requireAes() {
  if (hasRequiredAes) return aes;
  hasRequiredAes = 1;
  var s = requireSafeBuffer$1().Buffer;
  function A(b) {
    s.isBuffer(b) || (b = s.from(b));
    for (var k = b.length / 4 | 0, C = new Array(k), B = 0; B < k; B++)
      C[B] = b.readUInt32BE(B * 4);
    return C;
  }
  function u(b) {
    for (var k = 0; k < b.length; b++)
      b[k] = 0;
  }
  function p(b, k, C, B, Q) {
    for (var P = C[0], x = C[1], M = C[2], F = C[3], le = b[0] ^ k[0], ge = b[1] ^ k[1], pe = b[2] ^ k[2], Ie = b[3] ^ k[3], be, Pe, Te, Qe, xe = 4, Ee = 1; Ee < Q; Ee++)
      be = P[le >>> 24] ^ x[ge >>> 16 & 255] ^ M[pe >>> 8 & 255] ^ F[Ie & 255] ^ k[xe++], Pe = P[ge >>> 24] ^ x[pe >>> 16 & 255] ^ M[Ie >>> 8 & 255] ^ F[le & 255] ^ k[xe++], Te = P[pe >>> 24] ^ x[Ie >>> 16 & 255] ^ M[le >>> 8 & 255] ^ F[ge & 255] ^ k[xe++], Qe = P[Ie >>> 24] ^ x[le >>> 16 & 255] ^ M[ge >>> 8 & 255] ^ F[pe & 255] ^ k[xe++], le = be, ge = Pe, pe = Te, Ie = Qe;
    return be = (B[le >>> 24] << 24 | B[ge >>> 16 & 255] << 16 | B[pe >>> 8 & 255] << 8 | B[Ie & 255]) ^ k[xe++], Pe = (B[ge >>> 24] << 24 | B[pe >>> 16 & 255] << 16 | B[Ie >>> 8 & 255] << 8 | B[le & 255]) ^ k[xe++], Te = (B[pe >>> 24] << 24 | B[Ie >>> 16 & 255] << 16 | B[le >>> 8 & 255] << 8 | B[ge & 255]) ^ k[xe++], Qe = (B[Ie >>> 24] << 24 | B[le >>> 16 & 255] << 16 | B[ge >>> 8 & 255] << 8 | B[pe & 255]) ^ k[xe++], be = be >>> 0, Pe = Pe >>> 0, Te = Te >>> 0, Qe = Qe >>> 0, [be, Pe, Te, Qe];
  }
  var t = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], l = function() {
    for (var b = new Array(256), k = 0; k < 256; k++)
      k < 128 ? b[k] = k << 1 : b[k] = k << 1 ^ 283;
    for (var C = [], B = [], Q = [[], [], [], []], P = [[], [], [], []], x = 0, M = 0, F = 0; F < 256; ++F) {
      var le = M ^ M << 1 ^ M << 2 ^ M << 3 ^ M << 4;
      le = le >>> 8 ^ le & 255 ^ 99, C[x] = le, B[le] = x;
      var ge = b[x], pe = b[ge], Ie = b[pe], be = b[le] * 257 ^ le * 16843008;
      Q[0][x] = be << 24 | be >>> 8, Q[1][x] = be << 16 | be >>> 16, Q[2][x] = be << 8 | be >>> 24, Q[3][x] = be, be = Ie * 16843009 ^ pe * 65537 ^ ge * 257 ^ x * 16843008, P[0][le] = be << 24 | be >>> 8, P[1][le] = be << 16 | be >>> 16, P[2][le] = be << 8 | be >>> 24, P[3][le] = be, x === 0 ? x = M = 1 : (x = ge ^ b[b[b[Ie ^ ge]]], M ^= b[b[M]]);
    }
    return {
      SBOX: C,
      INV_SBOX: B,
      SUB_MIX: Q,
      INV_SUB_MIX: P
    };
  }();
  function m(b) {
    this._key = A(b), this._reset();
  }
  return m.blockSize = 16, m.keySize = 256 / 8, m.prototype.blockSize = m.blockSize, m.prototype.keySize = m.keySize, m.prototype._reset = function() {
    for (var b = this._key, k = b.length, C = k + 6, B = (C + 1) * 4, Q = [], P = 0; P < k; P++)
      Q[P] = b[P];
    for (P = k; P < B; P++) {
      var x = Q[P - 1];
      P % k === 0 ? (x = x << 8 | x >>> 24, x = l.SBOX[x >>> 24] << 24 | l.SBOX[x >>> 16 & 255] << 16 | l.SBOX[x >>> 8 & 255] << 8 | l.SBOX[x & 255], x ^= t[P / k | 0] << 24) : k > 6 && P % k === 4 && (x = l.SBOX[x >>> 24] << 24 | l.SBOX[x >>> 16 & 255] << 16 | l.SBOX[x >>> 8 & 255] << 8 | l.SBOX[x & 255]), Q[P] = Q[P - k] ^ x;
    }
    for (var M = [], F = 0; F < B; F++) {
      var le = B - F, ge = Q[le - (F % 4 ? 0 : 4)];
      F < 4 || le <= 4 ? M[F] = ge : M[F] = l.INV_SUB_MIX[0][l.SBOX[ge >>> 24]] ^ l.INV_SUB_MIX[1][l.SBOX[ge >>> 16 & 255]] ^ l.INV_SUB_MIX[2][l.SBOX[ge >>> 8 & 255]] ^ l.INV_SUB_MIX[3][l.SBOX[ge & 255]];
    }
    this._nRounds = C, this._keySchedule = Q, this._invKeySchedule = M;
  }, m.prototype.encryptBlockRaw = function(b) {
    return b = A(b), p(b, this._keySchedule, l.SUB_MIX, l.SBOX, this._nRounds);
  }, m.prototype.encryptBlock = function(b) {
    var k = this.encryptBlockRaw(b), C = s.allocUnsafe(16);
    return C.writeUInt32BE(k[0], 0), C.writeUInt32BE(k[1], 4), C.writeUInt32BE(k[2], 8), C.writeUInt32BE(k[3], 12), C;
  }, m.prototype.decryptBlock = function(b) {
    b = A(b);
    var k = b[1];
    b[1] = b[3], b[3] = k;
    var C = p(b, this._invKeySchedule, l.INV_SUB_MIX, l.INV_SBOX, this._nRounds), B = s.allocUnsafe(16);
    return B.writeUInt32BE(C[0], 0), B.writeUInt32BE(C[3], 4), B.writeUInt32BE(C[2], 8), B.writeUInt32BE(C[1], 12), B;
  }, m.prototype.scrub = function() {
    u(this._keySchedule), u(this._invKeySchedule), u(this._key);
  }, aes.AES = m, aes;
}
var ghash, hasRequiredGhash;
function requireGhash() {
  if (hasRequiredGhash) return ghash;
  hasRequiredGhash = 1;
  var s = requireSafeBuffer$1().Buffer, A = s.alloc(16, 0);
  function u(l) {
    return [
      l.readUInt32BE(0),
      l.readUInt32BE(4),
      l.readUInt32BE(8),
      l.readUInt32BE(12)
    ];
  }
  function p(l) {
    var m = s.allocUnsafe(16);
    return m.writeUInt32BE(l[0] >>> 0, 0), m.writeUInt32BE(l[1] >>> 0, 4), m.writeUInt32BE(l[2] >>> 0, 8), m.writeUInt32BE(l[3] >>> 0, 12), m;
  }
  function t(l) {
    this.h = l, this.state = s.alloc(16, 0), this.cache = s.allocUnsafe(0);
  }
  return t.prototype.ghash = function(l) {
    for (var m = -1; ++m < l.length; )
      this.state[m] ^= l[m];
    this._multiply();
  }, t.prototype._multiply = function() {
    for (var l = u(this.h), m = [0, 0, 0, 0], b, k, C, B = -1; ++B < 128; ) {
      for (k = (this.state[~~(B / 8)] & 1 << 7 - B % 8) !== 0, k && (m[0] ^= l[0], m[1] ^= l[1], m[2] ^= l[2], m[3] ^= l[3]), C = (l[3] & 1) !== 0, b = 3; b > 0; b--)
        l[b] = l[b] >>> 1 | (l[b - 1] & 1) << 31;
      l[0] = l[0] >>> 1, C && (l[0] = l[0] ^ 225 << 24);
    }
    this.state = p(m);
  }, t.prototype.update = function(l) {
    this.cache = s.concat([this.cache, l]);
    for (var m; this.cache.length >= 16; )
      m = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(m);
  }, t.prototype.final = function(l, m) {
    return this.cache.length && this.ghash(s.concat([this.cache, A], 16)), this.ghash(p([0, l, 0, m])), this.state;
  }, ghash = t, ghash;
}
var authCipher, hasRequiredAuthCipher;
function requireAuthCipher() {
  if (hasRequiredAuthCipher) return authCipher;
  hasRequiredAuthCipher = 1;
  var s = requireAes(), A = requireSafeBuffer$1().Buffer, u = requireCipherBase(), p = requireInherits_browser(), t = requireGhash(), l = requireBufferXor(), m = requireIncr32();
  function b(B, Q) {
    var P = 0;
    B.length !== Q.length && P++;
    for (var x = Math.min(B.length, Q.length), M = 0; M < x; ++M)
      P += B[M] ^ Q[M];
    return P;
  }
  function k(B, Q, P) {
    if (Q.length === 12)
      return B._finID = A.concat([Q, A.from([0, 0, 0, 1])]), A.concat([Q, A.from([0, 0, 0, 2])]);
    var x = new t(P), M = Q.length, F = M % 16;
    x.update(Q), F && (F = 16 - F, x.update(A.alloc(F, 0))), x.update(A.alloc(8, 0));
    var le = M * 8, ge = A.alloc(8);
    ge.writeUIntBE(le, 0, 8), x.update(ge), B._finID = x.state;
    var pe = A.from(B._finID);
    return m(pe), pe;
  }
  function C(B, Q, P, x) {
    u.call(this);
    var M = A.alloc(4, 0);
    this._cipher = new s.AES(Q);
    var F = this._cipher.encryptBlock(M);
    this._ghash = new t(F), P = k(this, P, F), this._prev = A.from(P), this._cache = A.allocUnsafe(0), this._secCache = A.allocUnsafe(0), this._decrypt = x, this._alen = 0, this._len = 0, this._mode = B, this._authTag = null, this._called = !1;
  }
  return p(C, u), C.prototype._update = function(B) {
    if (!this._called && this._alen) {
      var Q = 16 - this._alen % 16;
      Q < 16 && (Q = A.alloc(Q, 0), this._ghash.update(Q));
    }
    this._called = !0;
    var P = this._mode.encrypt(this, B);
    return this._decrypt ? this._ghash.update(B) : this._ghash.update(P), this._len += B.length, P;
  }, C.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var B = l(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && b(B, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = B, this._cipher.scrub();
  }, C.prototype.getAuthTag = function() {
    if (this._decrypt || !A.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
  }, C.prototype.setAuthTag = function(Q) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = Q;
  }, C.prototype.setAAD = function(Q) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(Q), this._alen += Q.length;
  }, authCipher = C, authCipher;
}
var streamCipher, hasRequiredStreamCipher;
function requireStreamCipher() {
  if (hasRequiredStreamCipher) return streamCipher;
  hasRequiredStreamCipher = 1;
  var s = requireAes(), A = requireSafeBuffer$1().Buffer, u = requireCipherBase(), p = requireInherits_browser();
  function t(l, m, b, k) {
    u.call(this), this._cipher = new s.AES(m), this._prev = A.from(b), this._cache = A.allocUnsafe(0), this._secCache = A.allocUnsafe(0), this._decrypt = k, this._mode = l;
  }
  return p(t, u), t.prototype._update = function(l) {
    return this._mode.encrypt(this, l, this._decrypt);
  }, t.prototype._final = function() {
    this._cipher.scrub();
  }, streamCipher = t, streamCipher;
}
var evp_bytestokey, hasRequiredEvp_bytestokey;
function requireEvp_bytestokey() {
  if (hasRequiredEvp_bytestokey) return evp_bytestokey;
  hasRequiredEvp_bytestokey = 1;
  var s = requireSafeBuffer$1().Buffer, A = requireMd5_js();
  function u(p, t, l, m) {
    if (s.isBuffer(p) || (p = s.from(p, "binary")), t && (s.isBuffer(t) || (t = s.from(t, "binary")), t.length !== 8))
      throw new RangeError("salt should be Buffer with 8 byte length");
    for (var b = l / 8, k = s.alloc(b), C = s.alloc(m || 0), B = s.alloc(0); b > 0 || m > 0; ) {
      var Q = new A();
      Q.update(B), Q.update(p), t && Q.update(t), B = Q.digest();
      var P = 0;
      if (b > 0) {
        var x = k.length - b;
        P = Math.min(b, B.length), B.copy(k, x, 0, P), b -= P;
      }
      if (P < B.length && m > 0) {
        var M = C.length - m, F = Math.min(m, B.length - P);
        B.copy(C, M, P, P + F), m -= F;
      }
    }
    return B.fill(0), { key: k, iv: C };
  }
  return evp_bytestokey = u, evp_bytestokey;
}
var hasRequiredEncrypter;
function requireEncrypter() {
  if (hasRequiredEncrypter) return encrypter;
  hasRequiredEncrypter = 1;
  var s = requireModes$1(), A = requireAuthCipher(), u = requireSafeBuffer$1().Buffer, p = requireStreamCipher(), t = requireCipherBase(), l = requireAes(), m = requireEvp_bytestokey(), b = requireInherits_browser();
  function k(x, M, F) {
    t.call(this), this._cache = new B(), this._cipher = new l.AES(M), this._prev = u.from(F), this._mode = x, this._autopadding = !0;
  }
  b(k, t), k.prototype._update = function(x) {
    this._cache.add(x);
    for (var M, F, le = []; M = this._cache.get(); )
      F = this._mode.encrypt(this, M), le.push(F);
    return u.concat(le);
  };
  var C = u.alloc(16, 16);
  k.prototype._final = function() {
    var x = this._cache.flush();
    if (this._autopadding)
      return x = this._mode.encrypt(this, x), this._cipher.scrub(), x;
    if (!x.equals(C))
      throw this._cipher.scrub(), new Error("data not multiple of block length");
  }, k.prototype.setAutoPadding = function(x) {
    return this._autopadding = !!x, this;
  };
  function B() {
    this.cache = u.allocUnsafe(0);
  }
  B.prototype.add = function(x) {
    this.cache = u.concat([this.cache, x]);
  }, B.prototype.get = function() {
    if (this.cache.length > 15) {
      var x = this.cache.slice(0, 16);
      return this.cache = this.cache.slice(16), x;
    }
    return null;
  }, B.prototype.flush = function() {
    for (var x = 16 - this.cache.length, M = u.allocUnsafe(x), F = -1; ++F < x; )
      M.writeUInt8(x, F);
    return u.concat([this.cache, M]);
  };
  function Q(x, M, F) {
    var le = s[x.toLowerCase()];
    if (!le) throw new TypeError("invalid suite type");
    if (typeof M == "string" && (M = u.from(M)), M.length !== le.key / 8) throw new TypeError("invalid key length " + M.length);
    if (typeof F == "string" && (F = u.from(F)), le.mode !== "GCM" && F.length !== le.iv) throw new TypeError("invalid iv length " + F.length);
    return le.type === "stream" ? new p(le.module, M, F) : le.type === "auth" ? new A(le.module, M, F) : new k(le.module, M, F);
  }
  function P(x, M) {
    var F = s[x.toLowerCase()];
    if (!F) throw new TypeError("invalid suite type");
    var le = m(M, !1, F.key, F.iv);
    return Q(x, le.key, le.iv);
  }
  return encrypter.createCipheriv = Q, encrypter.createCipher = P, encrypter;
}
var decrypter = {}, hasRequiredDecrypter;
function requireDecrypter() {
  if (hasRequiredDecrypter) return decrypter;
  hasRequiredDecrypter = 1;
  var s = requireAuthCipher(), A = requireSafeBuffer$1().Buffer, u = requireModes$1(), p = requireStreamCipher(), t = requireCipherBase(), l = requireAes(), m = requireEvp_bytestokey(), b = requireInherits_browser();
  function k(x, M, F) {
    t.call(this), this._cache = new C(), this._last = void 0, this._cipher = new l.AES(M), this._prev = A.from(F), this._mode = x, this._autopadding = !0;
  }
  b(k, t), k.prototype._update = function(x) {
    this._cache.add(x);
    for (var M, F, le = []; M = this._cache.get(this._autopadding); )
      F = this._mode.decrypt(this, M), le.push(F);
    return A.concat(le);
  }, k.prototype._final = function() {
    var x = this._cache.flush();
    if (this._autopadding)
      return B(this._mode.decrypt(this, x));
    if (x)
      throw new Error("data not multiple of block length");
  }, k.prototype.setAutoPadding = function(x) {
    return this._autopadding = !!x, this;
  };
  function C() {
    this.cache = A.allocUnsafe(0);
  }
  C.prototype.add = function(x) {
    this.cache = A.concat([this.cache, x]);
  }, C.prototype.get = function(x) {
    var M;
    if (x) {
      if (this.cache.length > 16)
        return M = this.cache.slice(0, 16), this.cache = this.cache.slice(16), M;
    } else if (this.cache.length >= 16)
      return M = this.cache.slice(0, 16), this.cache = this.cache.slice(16), M;
    return null;
  }, C.prototype.flush = function() {
    if (this.cache.length) return this.cache;
  };
  function B(x) {
    var M = x[15];
    if (M < 1 || M > 16)
      throw new Error("unable to decrypt data");
    for (var F = -1; ++F < M; )
      if (x[F + (16 - M)] !== M)
        throw new Error("unable to decrypt data");
    if (M !== 16)
      return x.slice(0, 16 - M);
  }
  function Q(x, M, F) {
    var le = u[x.toLowerCase()];
    if (!le) throw new TypeError("invalid suite type");
    if (typeof F == "string" && (F = A.from(F)), le.mode !== "GCM" && F.length !== le.iv) throw new TypeError("invalid iv length " + F.length);
    if (typeof M == "string" && (M = A.from(M)), M.length !== le.key / 8) throw new TypeError("invalid key length " + M.length);
    return le.type === "stream" ? new p(le.module, M, F, !0) : le.type === "auth" ? new s(le.module, M, F, !0) : new k(le.module, M, F);
  }
  function P(x, M) {
    var F = u[x.toLowerCase()];
    if (!F) throw new TypeError("invalid suite type");
    var le = m(M, !1, F.key, F.iv);
    return Q(x, le.key, le.iv);
  }
  return decrypter.createDecipher = P, decrypter.createDecipheriv = Q, decrypter;
}
var hasRequiredBrowser$6;
function requireBrowser$6() {
  if (hasRequiredBrowser$6) return browser$5;
  hasRequiredBrowser$6 = 1;
  var s = requireEncrypter(), A = requireDecrypter(), u = require$$2;
  function p() {
    return Object.keys(u);
  }
  return browser$5.createCipher = browser$5.Cipher = s.createCipher, browser$5.createCipheriv = browser$5.Cipheriv = s.createCipheriv, browser$5.createDecipher = browser$5.Decipher = A.createDecipher, browser$5.createDecipheriv = browser$5.Decipheriv = A.createDecipheriv, browser$5.listCiphers = browser$5.getCiphers = p, browser$5;
}
var modes = {}, hasRequiredModes;
function requireModes() {
  return hasRequiredModes || (hasRequiredModes = 1, function(s) {
    s["des-ecb"] = {
      key: 8,
      iv: 0
    }, s["des-cbc"] = s.des = {
      key: 8,
      iv: 8
    }, s["des-ede3-cbc"] = s.des3 = {
      key: 24,
      iv: 8
    }, s["des-ede3"] = {
      key: 24,
      iv: 0
    }, s["des-ede-cbc"] = {
      key: 16,
      iv: 8
    }, s["des-ede"] = {
      key: 16,
      iv: 0
    };
  }(modes)), modes;
}
var hasRequiredBrowser$5;
function requireBrowser$5() {
  if (hasRequiredBrowser$5) return browser$6;
  hasRequiredBrowser$5 = 1;
  var s = requireBrowserifyDes(), A = requireBrowser$6(), u = requireModes$1(), p = requireModes(), t = requireEvp_bytestokey();
  function l(B, Q) {
    B = B.toLowerCase();
    var P, x;
    if (u[B])
      P = u[B].key, x = u[B].iv;
    else if (p[B])
      P = p[B].key * 8, x = p[B].iv;
    else
      throw new TypeError("invalid suite type");
    var M = t(Q, !1, P, x);
    return b(B, M.key, M.iv);
  }
  function m(B, Q) {
    B = B.toLowerCase();
    var P, x;
    if (u[B])
      P = u[B].key, x = u[B].iv;
    else if (p[B])
      P = p[B].key * 8, x = p[B].iv;
    else
      throw new TypeError("invalid suite type");
    var M = t(Q, !1, P, x);
    return k(B, M.key, M.iv);
  }
  function b(B, Q, P) {
    if (B = B.toLowerCase(), u[B]) return A.createCipheriv(B, Q, P);
    if (p[B]) return new s({ key: Q, iv: P, mode: B });
    throw new TypeError("invalid suite type");
  }
  function k(B, Q, P) {
    if (B = B.toLowerCase(), u[B]) return A.createDecipheriv(B, Q, P);
    if (p[B]) return new s({ key: Q, iv: P, mode: B, decrypt: !0 });
    throw new TypeError("invalid suite type");
  }
  function C() {
    return Object.keys(p).concat(A.getCiphers());
  }
  return browser$6.createCipher = browser$6.Cipher = l, browser$6.createCipheriv = browser$6.Cipheriv = b, browser$6.createDecipher = browser$6.Decipher = m, browser$6.createDecipheriv = browser$6.Decipheriv = k, browser$6.listCiphers = browser$6.getCiphers = C, browser$6;
}
var browser$4 = {}, bn$3 = { exports: {} }, bn$2 = bn$3.exports, hasRequiredBn$1;
function requireBn$1() {
  return hasRequiredBn$1 || (hasRequiredBn$1 = 1, function(s) {
    (function(A, u) {
      function p(ve, we) {
        if (!ve) throw new Error(we || "Assertion failed");
      }
      function t(ve, we) {
        ve.super_ = we;
        var Ce = function() {
        };
        Ce.prototype = we.prototype, ve.prototype = new Ce(), ve.prototype.constructor = ve;
      }
      function l(ve, we, Ce) {
        if (l.isBN(ve))
          return ve;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, ve !== null && ((we === "le" || we === "be") && (Ce = we, we = 10), this._init(ve || 0, we || 10, Ce || "be"));
      }
      typeof A == "object" ? A.exports = l : u.BN = l, l.BN = l, l.wordSize = 26;
      var m;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? m = window.Buffer : m = requireDist$n().Buffer;
      } catch {
      }
      l.isBN = function(we) {
        return we instanceof l ? !0 : we !== null && typeof we == "object" && we.constructor.wordSize === l.wordSize && Array.isArray(we.words);
      }, l.max = function(we, Ce) {
        return we.cmp(Ce) > 0 ? we : Ce;
      }, l.min = function(we, Ce) {
        return we.cmp(Ce) < 0 ? we : Ce;
      }, l.prototype._init = function(we, Ce, Se) {
        if (typeof we == "number")
          return this._initNumber(we, Ce, Se);
        if (typeof we == "object")
          return this._initArray(we, Ce, Se);
        Ce === "hex" && (Ce = 16), p(Ce === (Ce | 0) && Ce >= 2 && Ce <= 36), we = we.toString().replace(/\s+/g, "");
        var Ne = 0;
        we[0] === "-" && (Ne++, this.negative = 1), Ne < we.length && (Ce === 16 ? this._parseHex(we, Ne, Se) : (this._parseBase(we, Ce, Ne), Se === "le" && this._initArray(this.toArray(), Ce, Se)));
      }, l.prototype._initNumber = function(we, Ce, Se) {
        we < 0 && (this.negative = 1, we = -we), we < 67108864 ? (this.words = [we & 67108863], this.length = 1) : we < 4503599627370496 ? (this.words = [
          we & 67108863,
          we / 67108864 & 67108863
        ], this.length = 2) : (p(we < 9007199254740992), this.words = [
          we & 67108863,
          we / 67108864 & 67108863,
          1
        ], this.length = 3), Se === "le" && this._initArray(this.toArray(), Ce, Se);
      }, l.prototype._initArray = function(we, Ce, Se) {
        if (p(typeof we.length == "number"), we.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(we.length / 3), this.words = new Array(this.length);
        for (var Ne = 0; Ne < this.length; Ne++)
          this.words[Ne] = 0;
        var rr, er, ir = 0;
        if (Se === "be")
          for (Ne = we.length - 1, rr = 0; Ne >= 0; Ne -= 3)
            er = we[Ne] | we[Ne - 1] << 8 | we[Ne - 2] << 16, this.words[rr] |= er << ir & 67108863, this.words[rr + 1] = er >>> 26 - ir & 67108863, ir += 24, ir >= 26 && (ir -= 26, rr++);
        else if (Se === "le")
          for (Ne = 0, rr = 0; Ne < we.length; Ne += 3)
            er = we[Ne] | we[Ne + 1] << 8 | we[Ne + 2] << 16, this.words[rr] |= er << ir & 67108863, this.words[rr + 1] = er >>> 26 - ir & 67108863, ir += 24, ir >= 26 && (ir -= 26, rr++);
        return this.strip();
      };
      function b(ve, we) {
        var Ce = ve.charCodeAt(we);
        return Ce >= 65 && Ce <= 70 ? Ce - 55 : Ce >= 97 && Ce <= 102 ? Ce - 87 : Ce - 48 & 15;
      }
      function k(ve, we, Ce) {
        var Se = b(ve, Ce);
        return Ce - 1 >= we && (Se |= b(ve, Ce - 1) << 4), Se;
      }
      l.prototype._parseHex = function(we, Ce, Se) {
        this.length = Math.ceil((we.length - Ce) / 6), this.words = new Array(this.length);
        for (var Ne = 0; Ne < this.length; Ne++)
          this.words[Ne] = 0;
        var rr = 0, er = 0, ir;
        if (Se === "be")
          for (Ne = we.length - 1; Ne >= Ce; Ne -= 2)
            ir = k(we, Ce, Ne) << rr, this.words[er] |= ir & 67108863, rr >= 18 ? (rr -= 18, er += 1, this.words[er] |= ir >>> 26) : rr += 8;
        else {
          var sr = we.length - Ce;
          for (Ne = sr % 2 === 0 ? Ce + 1 : Ce; Ne < we.length; Ne += 2)
            ir = k(we, Ce, Ne) << rr, this.words[er] |= ir & 67108863, rr >= 18 ? (rr -= 18, er += 1, this.words[er] |= ir >>> 26) : rr += 8;
        }
        this.strip();
      };
      function C(ve, we, Ce, Se) {
        for (var Ne = 0, rr = Math.min(ve.length, Ce), er = we; er < rr; er++) {
          var ir = ve.charCodeAt(er) - 48;
          Ne *= Se, ir >= 49 ? Ne += ir - 49 + 10 : ir >= 17 ? Ne += ir - 17 + 10 : Ne += ir;
        }
        return Ne;
      }
      l.prototype._parseBase = function(we, Ce, Se) {
        this.words = [0], this.length = 1;
        for (var Ne = 0, rr = 1; rr <= 67108863; rr *= Ce)
          Ne++;
        Ne--, rr = rr / Ce | 0;
        for (var er = we.length - Se, ir = er % Ne, sr = Math.min(er, er - ir) + Se, nr = 0, fr = Se; fr < sr; fr += Ne)
          nr = C(we, fr, fr + Ne, Ce), this.imuln(rr), this.words[0] + nr < 67108864 ? this.words[0] += nr : this._iaddn(nr);
        if (ir !== 0) {
          var lr = 1;
          for (nr = C(we, fr, we.length, Ce), fr = 0; fr < ir; fr++)
            lr *= Ce;
          this.imuln(lr), this.words[0] + nr < 67108864 ? this.words[0] += nr : this._iaddn(nr);
        }
        this.strip();
      }, l.prototype.copy = function(we) {
        we.words = new Array(this.length);
        for (var Ce = 0; Ce < this.length; Ce++)
          we.words[Ce] = this.words[Ce];
        we.length = this.length, we.negative = this.negative, we.red = this.red;
      }, l.prototype.clone = function() {
        var we = new l(null);
        return this.copy(we), we;
      }, l.prototype._expand = function(we) {
        for (; this.length < we; )
          this.words[this.length++] = 0;
        return this;
      }, l.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, l.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, l.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var B = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], Q = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], P = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      l.prototype.toString = function(we, Ce) {
        we = we || 10, Ce = Ce | 0 || 1;
        var Se;
        if (we === 16 || we === "hex") {
          Se = "";
          for (var Ne = 0, rr = 0, er = 0; er < this.length; er++) {
            var ir = this.words[er], sr = ((ir << Ne | rr) & 16777215).toString(16);
            rr = ir >>> 24 - Ne & 16777215, Ne += 2, Ne >= 26 && (Ne -= 26, er--), rr !== 0 || er !== this.length - 1 ? Se = B[6 - sr.length] + sr + Se : Se = sr + Se;
          }
          for (rr !== 0 && (Se = rr.toString(16) + Se); Se.length % Ce !== 0; )
            Se = "0" + Se;
          return this.negative !== 0 && (Se = "-" + Se), Se;
        }
        if (we === (we | 0) && we >= 2 && we <= 36) {
          var nr = Q[we], fr = P[we];
          Se = "";
          var lr = this.clone();
          for (lr.negative = 0; !lr.isZero(); ) {
            var br = lr.modn(fr).toString(we);
            lr = lr.idivn(fr), lr.isZero() ? Se = br + Se : Se = B[nr - br.length] + br + Se;
          }
          for (this.isZero() && (Se = "0" + Se); Se.length % Ce !== 0; )
            Se = "0" + Se;
          return this.negative !== 0 && (Se = "-" + Se), Se;
        }
        p(!1, "Base should be between 2 and 36");
      }, l.prototype.toNumber = function() {
        var we = this.words[0];
        return this.length === 2 ? we += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? we += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && p(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -we : we;
      }, l.prototype.toJSON = function() {
        return this.toString(16);
      }, l.prototype.toBuffer = function(we, Ce) {
        return p(typeof m < "u"), this.toArrayLike(m, we, Ce);
      }, l.prototype.toArray = function(we, Ce) {
        return this.toArrayLike(Array, we, Ce);
      }, l.prototype.toArrayLike = function(we, Ce, Se) {
        var Ne = this.byteLength(), rr = Se || Math.max(1, Ne);
        p(Ne <= rr, "byte array longer than desired length"), p(rr > 0, "Requested array length <= 0"), this.strip();
        var er = Ce === "le", ir = new we(rr), sr, nr, fr = this.clone();
        if (er) {
          for (nr = 0; !fr.isZero(); nr++)
            sr = fr.andln(255), fr.iushrn(8), ir[nr] = sr;
          for (; nr < rr; nr++)
            ir[nr] = 0;
        } else {
          for (nr = 0; nr < rr - Ne; nr++)
            ir[nr] = 0;
          for (nr = 0; !fr.isZero(); nr++)
            sr = fr.andln(255), fr.iushrn(8), ir[rr - nr - 1] = sr;
        }
        return ir;
      }, Math.clz32 ? l.prototype._countBits = function(we) {
        return 32 - Math.clz32(we);
      } : l.prototype._countBits = function(we) {
        var Ce = we, Se = 0;
        return Ce >= 4096 && (Se += 13, Ce >>>= 13), Ce >= 64 && (Se += 7, Ce >>>= 7), Ce >= 8 && (Se += 4, Ce >>>= 4), Ce >= 2 && (Se += 2, Ce >>>= 2), Se + Ce;
      }, l.prototype._zeroBits = function(we) {
        if (we === 0) return 26;
        var Ce = we, Se = 0;
        return (Ce & 8191) === 0 && (Se += 13, Ce >>>= 13), (Ce & 127) === 0 && (Se += 7, Ce >>>= 7), (Ce & 15) === 0 && (Se += 4, Ce >>>= 4), (Ce & 3) === 0 && (Se += 2, Ce >>>= 2), (Ce & 1) === 0 && Se++, Se;
      }, l.prototype.bitLength = function() {
        var we = this.words[this.length - 1], Ce = this._countBits(we);
        return (this.length - 1) * 26 + Ce;
      };
      function x(ve) {
        for (var we = new Array(ve.bitLength()), Ce = 0; Ce < we.length; Ce++) {
          var Se = Ce / 26 | 0, Ne = Ce % 26;
          we[Ce] = (ve.words[Se] & 1 << Ne) >>> Ne;
        }
        return we;
      }
      l.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var we = 0, Ce = 0; Ce < this.length; Ce++) {
          var Se = this._zeroBits(this.words[Ce]);
          if (we += Se, Se !== 26) break;
        }
        return we;
      }, l.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, l.prototype.toTwos = function(we) {
        return this.negative !== 0 ? this.abs().inotn(we).iaddn(1) : this.clone();
      }, l.prototype.fromTwos = function(we) {
        return this.testn(we - 1) ? this.notn(we).iaddn(1).ineg() : this.clone();
      }, l.prototype.isNeg = function() {
        return this.negative !== 0;
      }, l.prototype.neg = function() {
        return this.clone().ineg();
      }, l.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, l.prototype.iuor = function(we) {
        for (; this.length < we.length; )
          this.words[this.length++] = 0;
        for (var Ce = 0; Ce < we.length; Ce++)
          this.words[Ce] = this.words[Ce] | we.words[Ce];
        return this.strip();
      }, l.prototype.ior = function(we) {
        return p((this.negative | we.negative) === 0), this.iuor(we);
      }, l.prototype.or = function(we) {
        return this.length > we.length ? this.clone().ior(we) : we.clone().ior(this);
      }, l.prototype.uor = function(we) {
        return this.length > we.length ? this.clone().iuor(we) : we.clone().iuor(this);
      }, l.prototype.iuand = function(we) {
        var Ce;
        this.length > we.length ? Ce = we : Ce = this;
        for (var Se = 0; Se < Ce.length; Se++)
          this.words[Se] = this.words[Se] & we.words[Se];
        return this.length = Ce.length, this.strip();
      }, l.prototype.iand = function(we) {
        return p((this.negative | we.negative) === 0), this.iuand(we);
      }, l.prototype.and = function(we) {
        return this.length > we.length ? this.clone().iand(we) : we.clone().iand(this);
      }, l.prototype.uand = function(we) {
        return this.length > we.length ? this.clone().iuand(we) : we.clone().iuand(this);
      }, l.prototype.iuxor = function(we) {
        var Ce, Se;
        this.length > we.length ? (Ce = this, Se = we) : (Ce = we, Se = this);
        for (var Ne = 0; Ne < Se.length; Ne++)
          this.words[Ne] = Ce.words[Ne] ^ Se.words[Ne];
        if (this !== Ce)
          for (; Ne < Ce.length; Ne++)
            this.words[Ne] = Ce.words[Ne];
        return this.length = Ce.length, this.strip();
      }, l.prototype.ixor = function(we) {
        return p((this.negative | we.negative) === 0), this.iuxor(we);
      }, l.prototype.xor = function(we) {
        return this.length > we.length ? this.clone().ixor(we) : we.clone().ixor(this);
      }, l.prototype.uxor = function(we) {
        return this.length > we.length ? this.clone().iuxor(we) : we.clone().iuxor(this);
      }, l.prototype.inotn = function(we) {
        p(typeof we == "number" && we >= 0);
        var Ce = Math.ceil(we / 26) | 0, Se = we % 26;
        this._expand(Ce), Se > 0 && Ce--;
        for (var Ne = 0; Ne < Ce; Ne++)
          this.words[Ne] = ~this.words[Ne] & 67108863;
        return Se > 0 && (this.words[Ne] = ~this.words[Ne] & 67108863 >> 26 - Se), this.strip();
      }, l.prototype.notn = function(we) {
        return this.clone().inotn(we);
      }, l.prototype.setn = function(we, Ce) {
        p(typeof we == "number" && we >= 0);
        var Se = we / 26 | 0, Ne = we % 26;
        return this._expand(Se + 1), Ce ? this.words[Se] = this.words[Se] | 1 << Ne : this.words[Se] = this.words[Se] & ~(1 << Ne), this.strip();
      }, l.prototype.iadd = function(we) {
        var Ce;
        if (this.negative !== 0 && we.negative === 0)
          return this.negative = 0, Ce = this.isub(we), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && we.negative !== 0)
          return we.negative = 0, Ce = this.isub(we), we.negative = 1, Ce._normSign();
        var Se, Ne;
        this.length > we.length ? (Se = this, Ne = we) : (Se = we, Ne = this);
        for (var rr = 0, er = 0; er < Ne.length; er++)
          Ce = (Se.words[er] | 0) + (Ne.words[er] | 0) + rr, this.words[er] = Ce & 67108863, rr = Ce >>> 26;
        for (; rr !== 0 && er < Se.length; er++)
          Ce = (Se.words[er] | 0) + rr, this.words[er] = Ce & 67108863, rr = Ce >>> 26;
        if (this.length = Se.length, rr !== 0)
          this.words[this.length] = rr, this.length++;
        else if (Se !== this)
          for (; er < Se.length; er++)
            this.words[er] = Se.words[er];
        return this;
      }, l.prototype.add = function(we) {
        var Ce;
        return we.negative !== 0 && this.negative === 0 ? (we.negative = 0, Ce = this.sub(we), we.negative ^= 1, Ce) : we.negative === 0 && this.negative !== 0 ? (this.negative = 0, Ce = we.sub(this), this.negative = 1, Ce) : this.length > we.length ? this.clone().iadd(we) : we.clone().iadd(this);
      }, l.prototype.isub = function(we) {
        if (we.negative !== 0) {
          we.negative = 0;
          var Ce = this.iadd(we);
          return we.negative = 1, Ce._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(we), this.negative = 1, this._normSign();
        var Se = this.cmp(we);
        if (Se === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var Ne, rr;
        Se > 0 ? (Ne = this, rr = we) : (Ne = we, rr = this);
        for (var er = 0, ir = 0; ir < rr.length; ir++)
          Ce = (Ne.words[ir] | 0) - (rr.words[ir] | 0) + er, er = Ce >> 26, this.words[ir] = Ce & 67108863;
        for (; er !== 0 && ir < Ne.length; ir++)
          Ce = (Ne.words[ir] | 0) + er, er = Ce >> 26, this.words[ir] = Ce & 67108863;
        if (er === 0 && ir < Ne.length && Ne !== this)
          for (; ir < Ne.length; ir++)
            this.words[ir] = Ne.words[ir];
        return this.length = Math.max(this.length, ir), Ne !== this && (this.negative = 1), this.strip();
      }, l.prototype.sub = function(we) {
        return this.clone().isub(we);
      };
      function M(ve, we, Ce) {
        Ce.negative = we.negative ^ ve.negative;
        var Se = ve.length + we.length | 0;
        Ce.length = Se, Se = Se - 1 | 0;
        var Ne = ve.words[0] | 0, rr = we.words[0] | 0, er = Ne * rr, ir = er & 67108863, sr = er / 67108864 | 0;
        Ce.words[0] = ir;
        for (var nr = 1; nr < Se; nr++) {
          for (var fr = sr >>> 26, lr = sr & 67108863, br = Math.min(nr, we.length - 1), Br = Math.max(0, nr - ve.length + 1); Br <= br; Br++) {
            var Fr = nr - Br | 0;
            Ne = ve.words[Fr] | 0, rr = we.words[Br] | 0, er = Ne * rr + lr, fr += er / 67108864 | 0, lr = er & 67108863;
          }
          Ce.words[nr] = lr | 0, sr = fr | 0;
        }
        return sr !== 0 ? Ce.words[nr] = sr | 0 : Ce.length--, Ce.strip();
      }
      var F = function(we, Ce, Se) {
        var Ne = we.words, rr = Ce.words, er = Se.words, ir = 0, sr, nr, fr, lr = Ne[0] | 0, br = lr & 8191, Br = lr >>> 13, Fr = Ne[1] | 0, Gr = Fr & 8191, qr = Fr >>> 13, Hr = Ne[2] | 0, un = Hr & 8191, Dr = Hr >>> 13, wr = Ne[3] | 0, yr = wr & 8191, Qr = wr >>> 13, _r = Ne[4] | 0, Jr = _r & 8191, fn = _r >>> 13, jr = Ne[5] | 0, dn = jr & 8191, Tn = jr >>> 13, Yn = Ne[6] | 0, si = Yn & 8191, vn = Yn >>> 13, Cn = Ne[7] | 0, Xr = Cn & 8191, In = Cn >>> 13, zr = Ne[8] | 0, En = zr & 8191, Zr = zr >>> 13, kr = Ne[9] | 0, Rr = kr & 8191, Er = kr >>> 13, Or = rr[0] | 0, wn = Or & 8191, Kn = Or >>> 13, Ln = rr[1] | 0, Wn = Ln & 8191, Sn = Ln >>> 13, hi = rr[2] | 0, ki = hi & 8191, xi = hi >>> 13, _i = rr[3] | 0, Li = _i & 8191, ms = _i >>> 13, Ui = rr[4] | 0, Mi = Ui & 8191, Ls = Ui >>> 13, Ds = rr[5] | 0, Pr = Ds & 8191, vr = Ds >>> 13, Cr = rr[6] | 0, yn = Cr & 8191, Pn = Cr >>> 13, $n = rr[7] | 0, ui = $n & 8191, Ei = $n >>> 13, zi = rr[8] | 0, Gi = zi & 8191, Vi = zi >>> 13, Ur = rr[9] | 0, $i = Ur & 8191, Es = Ur >>> 13;
        Se.negative = we.negative ^ Ce.negative, Se.length = 19, sr = Math.imul(br, wn), nr = Math.imul(br, Kn), nr = nr + Math.imul(Br, wn) | 0, fr = Math.imul(Br, Kn);
        var pn = (ir + sr | 0) + ((nr & 8191) << 13) | 0;
        ir = (fr + (nr >>> 13) | 0) + (pn >>> 26) | 0, pn &= 67108863, sr = Math.imul(Gr, wn), nr = Math.imul(Gr, Kn), nr = nr + Math.imul(qr, wn) | 0, fr = Math.imul(qr, Kn), sr = sr + Math.imul(br, Wn) | 0, nr = nr + Math.imul(br, Sn) | 0, nr = nr + Math.imul(Br, Wn) | 0, fr = fr + Math.imul(Br, Sn) | 0;
        var Nr = (ir + sr | 0) + ((nr & 8191) << 13) | 0;
        ir = (fr + (nr >>> 13) | 0) + (Nr >>> 26) | 0, Nr &= 67108863, sr = Math.imul(un, wn), nr = Math.imul(un, Kn), nr = nr + Math.imul(Dr, wn) | 0, fr = Math.imul(Dr, Kn), sr = sr + Math.imul(Gr, Wn) | 0, nr = nr + Math.imul(Gr, Sn) | 0, nr = nr + Math.imul(qr, Wn) | 0, fr = fr + Math.imul(qr, Sn) | 0, sr = sr + Math.imul(br, ki) | 0, nr = nr + Math.imul(br, xi) | 0, nr = nr + Math.imul(Br, ki) | 0, fr = fr + Math.imul(Br, xi) | 0;
        var Qn = (ir + sr | 0) + ((nr & 8191) << 13) | 0;
        ir = (fr + (nr >>> 13) | 0) + (Qn >>> 26) | 0, Qn &= 67108863, sr = Math.imul(yr, wn), nr = Math.imul(yr, Kn), nr = nr + Math.imul(Qr, wn) | 0, fr = Math.imul(Qr, Kn), sr = sr + Math.imul(un, Wn) | 0, nr = nr + Math.imul(un, Sn) | 0, nr = nr + Math.imul(Dr, Wn) | 0, fr = fr + Math.imul(Dr, Sn) | 0, sr = sr + Math.imul(Gr, ki) | 0, nr = nr + Math.imul(Gr, xi) | 0, nr = nr + Math.imul(qr, ki) | 0, fr = fr + Math.imul(qr, xi) | 0, sr = sr + Math.imul(br, Li) | 0, nr = nr + Math.imul(br, ms) | 0, nr = nr + Math.imul(Br, Li) | 0, fr = fr + Math.imul(Br, ms) | 0;
        var zn = (ir + sr | 0) + ((nr & 8191) << 13) | 0;
        ir = (fr + (nr >>> 13) | 0) + (zn >>> 26) | 0, zn &= 67108863, sr = Math.imul(Jr, wn), nr = Math.imul(Jr, Kn), nr = nr + Math.imul(fn, wn) | 0, fr = Math.imul(fn, Kn), sr = sr + Math.imul(yr, Wn) | 0, nr = nr + Math.imul(yr, Sn) | 0, nr = nr + Math.imul(Qr, Wn) | 0, fr = fr + Math.imul(Qr, Sn) | 0, sr = sr + Math.imul(un, ki) | 0, nr = nr + Math.imul(un, xi) | 0, nr = nr + Math.imul(Dr, ki) | 0, fr = fr + Math.imul(Dr, xi) | 0, sr = sr + Math.imul(Gr, Li) | 0, nr = nr + Math.imul(Gr, ms) | 0, nr = nr + Math.imul(qr, Li) | 0, fr = fr + Math.imul(qr, ms) | 0, sr = sr + Math.imul(br, Mi) | 0, nr = nr + Math.imul(br, Ls) | 0, nr = nr + Math.imul(Br, Mi) | 0, fr = fr + Math.imul(Br, Ls) | 0;
        var ti = (ir + sr | 0) + ((nr & 8191) << 13) | 0;
        ir = (fr + (nr >>> 13) | 0) + (ti >>> 26) | 0, ti &= 67108863, sr = Math.imul(dn, wn), nr = Math.imul(dn, Kn), nr = nr + Math.imul(Tn, wn) | 0, fr = Math.imul(Tn, Kn), sr = sr + Math.imul(Jr, Wn) | 0, nr = nr + Math.imul(Jr, Sn) | 0, nr = nr + Math.imul(fn, Wn) | 0, fr = fr + Math.imul(fn, Sn) | 0, sr = sr + Math.imul(yr, ki) | 0, nr = nr + Math.imul(yr, xi) | 0, nr = nr + Math.imul(Qr, ki) | 0, fr = fr + Math.imul(Qr, xi) | 0, sr = sr + Math.imul(un, Li) | 0, nr = nr + Math.imul(un, ms) | 0, nr = nr + Math.imul(Dr, Li) | 0, fr = fr + Math.imul(Dr, ms) | 0, sr = sr + Math.imul(Gr, Mi) | 0, nr = nr + Math.imul(Gr, Ls) | 0, nr = nr + Math.imul(qr, Mi) | 0, fr = fr + Math.imul(qr, Ls) | 0, sr = sr + Math.imul(br, Pr) | 0, nr = nr + Math.imul(br, vr) | 0, nr = nr + Math.imul(Br, Pr) | 0, fr = fr + Math.imul(Br, vr) | 0;
        var v = (ir + sr | 0) + ((nr & 8191) << 13) | 0;
        ir = (fr + (nr >>> 13) | 0) + (v >>> 26) | 0, v &= 67108863, sr = Math.imul(si, wn), nr = Math.imul(si, Kn), nr = nr + Math.imul(vn, wn) | 0, fr = Math.imul(vn, Kn), sr = sr + Math.imul(dn, Wn) | 0, nr = nr + Math.imul(dn, Sn) | 0, nr = nr + Math.imul(Tn, Wn) | 0, fr = fr + Math.imul(Tn, Sn) | 0, sr = sr + Math.imul(Jr, ki) | 0, nr = nr + Math.imul(Jr, xi) | 0, nr = nr + Math.imul(fn, ki) | 0, fr = fr + Math.imul(fn, xi) | 0, sr = sr + Math.imul(yr, Li) | 0, nr = nr + Math.imul(yr, ms) | 0, nr = nr + Math.imul(Qr, Li) | 0, fr = fr + Math.imul(Qr, ms) | 0, sr = sr + Math.imul(un, Mi) | 0, nr = nr + Math.imul(un, Ls) | 0, nr = nr + Math.imul(Dr, Mi) | 0, fr = fr + Math.imul(Dr, Ls) | 0, sr = sr + Math.imul(Gr, Pr) | 0, nr = nr + Math.imul(Gr, vr) | 0, nr = nr + Math.imul(qr, Pr) | 0, fr = fr + Math.imul(qr, vr) | 0, sr = sr + Math.imul(br, yn) | 0, nr = nr + Math.imul(br, Pn) | 0, nr = nr + Math.imul(Br, yn) | 0, fr = fr + Math.imul(Br, Pn) | 0;
        var d = (ir + sr | 0) + ((nr & 8191) << 13) | 0;
        ir = (fr + (nr >>> 13) | 0) + (d >>> 26) | 0, d &= 67108863, sr = Math.imul(Xr, wn), nr = Math.imul(Xr, Kn), nr = nr + Math.imul(In, wn) | 0, fr = Math.imul(In, Kn), sr = sr + Math.imul(si, Wn) | 0, nr = nr + Math.imul(si, Sn) | 0, nr = nr + Math.imul(vn, Wn) | 0, fr = fr + Math.imul(vn, Sn) | 0, sr = sr + Math.imul(dn, ki) | 0, nr = nr + Math.imul(dn, xi) | 0, nr = nr + Math.imul(Tn, ki) | 0, fr = fr + Math.imul(Tn, xi) | 0, sr = sr + Math.imul(Jr, Li) | 0, nr = nr + Math.imul(Jr, ms) | 0, nr = nr + Math.imul(fn, Li) | 0, fr = fr + Math.imul(fn, ms) | 0, sr = sr + Math.imul(yr, Mi) | 0, nr = nr + Math.imul(yr, Ls) | 0, nr = nr + Math.imul(Qr, Mi) | 0, fr = fr + Math.imul(Qr, Ls) | 0, sr = sr + Math.imul(un, Pr) | 0, nr = nr + Math.imul(un, vr) | 0, nr = nr + Math.imul(Dr, Pr) | 0, fr = fr + Math.imul(Dr, vr) | 0, sr = sr + Math.imul(Gr, yn) | 0, nr = nr + Math.imul(Gr, Pn) | 0, nr = nr + Math.imul(qr, yn) | 0, fr = fr + Math.imul(qr, Pn) | 0, sr = sr + Math.imul(br, ui) | 0, nr = nr + Math.imul(br, Ei) | 0, nr = nr + Math.imul(Br, ui) | 0, fr = fr + Math.imul(Br, Ei) | 0;
        var I = (ir + sr | 0) + ((nr & 8191) << 13) | 0;
        ir = (fr + (nr >>> 13) | 0) + (I >>> 26) | 0, I &= 67108863, sr = Math.imul(En, wn), nr = Math.imul(En, Kn), nr = nr + Math.imul(Zr, wn) | 0, fr = Math.imul(Zr, Kn), sr = sr + Math.imul(Xr, Wn) | 0, nr = nr + Math.imul(Xr, Sn) | 0, nr = nr + Math.imul(In, Wn) | 0, fr = fr + Math.imul(In, Sn) | 0, sr = sr + Math.imul(si, ki) | 0, nr = nr + Math.imul(si, xi) | 0, nr = nr + Math.imul(vn, ki) | 0, fr = fr + Math.imul(vn, xi) | 0, sr = sr + Math.imul(dn, Li) | 0, nr = nr + Math.imul(dn, ms) | 0, nr = nr + Math.imul(Tn, Li) | 0, fr = fr + Math.imul(Tn, ms) | 0, sr = sr + Math.imul(Jr, Mi) | 0, nr = nr + Math.imul(Jr, Ls) | 0, nr = nr + Math.imul(fn, Mi) | 0, fr = fr + Math.imul(fn, Ls) | 0, sr = sr + Math.imul(yr, Pr) | 0, nr = nr + Math.imul(yr, vr) | 0, nr = nr + Math.imul(Qr, Pr) | 0, fr = fr + Math.imul(Qr, vr) | 0, sr = sr + Math.imul(un, yn) | 0, nr = nr + Math.imul(un, Pn) | 0, nr = nr + Math.imul(Dr, yn) | 0, fr = fr + Math.imul(Dr, Pn) | 0, sr = sr + Math.imul(Gr, ui) | 0, nr = nr + Math.imul(Gr, Ei) | 0, nr = nr + Math.imul(qr, ui) | 0, fr = fr + Math.imul(qr, Ei) | 0, sr = sr + Math.imul(br, Gi) | 0, nr = nr + Math.imul(br, Vi) | 0, nr = nr + Math.imul(Br, Gi) | 0, fr = fr + Math.imul(Br, Vi) | 0;
        var n = (ir + sr | 0) + ((nr & 8191) << 13) | 0;
        ir = (fr + (nr >>> 13) | 0) + (n >>> 26) | 0, n &= 67108863, sr = Math.imul(Rr, wn), nr = Math.imul(Rr, Kn), nr = nr + Math.imul(Er, wn) | 0, fr = Math.imul(Er, Kn), sr = sr + Math.imul(En, Wn) | 0, nr = nr + Math.imul(En, Sn) | 0, nr = nr + Math.imul(Zr, Wn) | 0, fr = fr + Math.imul(Zr, Sn) | 0, sr = sr + Math.imul(Xr, ki) | 0, nr = nr + Math.imul(Xr, xi) | 0, nr = nr + Math.imul(In, ki) | 0, fr = fr + Math.imul(In, xi) | 0, sr = sr + Math.imul(si, Li) | 0, nr = nr + Math.imul(si, ms) | 0, nr = nr + Math.imul(vn, Li) | 0, fr = fr + Math.imul(vn, ms) | 0, sr = sr + Math.imul(dn, Mi) | 0, nr = nr + Math.imul(dn, Ls) | 0, nr = nr + Math.imul(Tn, Mi) | 0, fr = fr + Math.imul(Tn, Ls) | 0, sr = sr + Math.imul(Jr, Pr) | 0, nr = nr + Math.imul(Jr, vr) | 0, nr = nr + Math.imul(fn, Pr) | 0, fr = fr + Math.imul(fn, vr) | 0, sr = sr + Math.imul(yr, yn) | 0, nr = nr + Math.imul(yr, Pn) | 0, nr = nr + Math.imul(Qr, yn) | 0, fr = fr + Math.imul(Qr, Pn) | 0, sr = sr + Math.imul(un, ui) | 0, nr = nr + Math.imul(un, Ei) | 0, nr = nr + Math.imul(Dr, ui) | 0, fr = fr + Math.imul(Dr, Ei) | 0, sr = sr + Math.imul(Gr, Gi) | 0, nr = nr + Math.imul(Gr, Vi) | 0, nr = nr + Math.imul(qr, Gi) | 0, fr = fr + Math.imul(qr, Vi) | 0, sr = sr + Math.imul(br, $i) | 0, nr = nr + Math.imul(br, Es) | 0, nr = nr + Math.imul(Br, $i) | 0, fr = fr + Math.imul(Br, Es) | 0;
        var a = (ir + sr | 0) + ((nr & 8191) << 13) | 0;
        ir = (fr + (nr >>> 13) | 0) + (a >>> 26) | 0, a &= 67108863, sr = Math.imul(Rr, Wn), nr = Math.imul(Rr, Sn), nr = nr + Math.imul(Er, Wn) | 0, fr = Math.imul(Er, Sn), sr = sr + Math.imul(En, ki) | 0, nr = nr + Math.imul(En, xi) | 0, nr = nr + Math.imul(Zr, ki) | 0, fr = fr + Math.imul(Zr, xi) | 0, sr = sr + Math.imul(Xr, Li) | 0, nr = nr + Math.imul(Xr, ms) | 0, nr = nr + Math.imul(In, Li) | 0, fr = fr + Math.imul(In, ms) | 0, sr = sr + Math.imul(si, Mi) | 0, nr = nr + Math.imul(si, Ls) | 0, nr = nr + Math.imul(vn, Mi) | 0, fr = fr + Math.imul(vn, Ls) | 0, sr = sr + Math.imul(dn, Pr) | 0, nr = nr + Math.imul(dn, vr) | 0, nr = nr + Math.imul(Tn, Pr) | 0, fr = fr + Math.imul(Tn, vr) | 0, sr = sr + Math.imul(Jr, yn) | 0, nr = nr + Math.imul(Jr, Pn) | 0, nr = nr + Math.imul(fn, yn) | 0, fr = fr + Math.imul(fn, Pn) | 0, sr = sr + Math.imul(yr, ui) | 0, nr = nr + Math.imul(yr, Ei) | 0, nr = nr + Math.imul(Qr, ui) | 0, fr = fr + Math.imul(Qr, Ei) | 0, sr = sr + Math.imul(un, Gi) | 0, nr = nr + Math.imul(un, Vi) | 0, nr = nr + Math.imul(Dr, Gi) | 0, fr = fr + Math.imul(Dr, Vi) | 0, sr = sr + Math.imul(Gr, $i) | 0, nr = nr + Math.imul(Gr, Es) | 0, nr = nr + Math.imul(qr, $i) | 0, fr = fr + Math.imul(qr, Es) | 0;
        var E = (ir + sr | 0) + ((nr & 8191) << 13) | 0;
        ir = (fr + (nr >>> 13) | 0) + (E >>> 26) | 0, E &= 67108863, sr = Math.imul(Rr, ki), nr = Math.imul(Rr, xi), nr = nr + Math.imul(Er, ki) | 0, fr = Math.imul(Er, xi), sr = sr + Math.imul(En, Li) | 0, nr = nr + Math.imul(En, ms) | 0, nr = nr + Math.imul(Zr, Li) | 0, fr = fr + Math.imul(Zr, ms) | 0, sr = sr + Math.imul(Xr, Mi) | 0, nr = nr + Math.imul(Xr, Ls) | 0, nr = nr + Math.imul(In, Mi) | 0, fr = fr + Math.imul(In, Ls) | 0, sr = sr + Math.imul(si, Pr) | 0, nr = nr + Math.imul(si, vr) | 0, nr = nr + Math.imul(vn, Pr) | 0, fr = fr + Math.imul(vn, vr) | 0, sr = sr + Math.imul(dn, yn) | 0, nr = nr + Math.imul(dn, Pn) | 0, nr = nr + Math.imul(Tn, yn) | 0, fr = fr + Math.imul(Tn, Pn) | 0, sr = sr + Math.imul(Jr, ui) | 0, nr = nr + Math.imul(Jr, Ei) | 0, nr = nr + Math.imul(fn, ui) | 0, fr = fr + Math.imul(fn, Ei) | 0, sr = sr + Math.imul(yr, Gi) | 0, nr = nr + Math.imul(yr, Vi) | 0, nr = nr + Math.imul(Qr, Gi) | 0, fr = fr + Math.imul(Qr, Vi) | 0, sr = sr + Math.imul(un, $i) | 0, nr = nr + Math.imul(un, Es) | 0, nr = nr + Math.imul(Dr, $i) | 0, fr = fr + Math.imul(Dr, Es) | 0;
        var T = (ir + sr | 0) + ((nr & 8191) << 13) | 0;
        ir = (fr + (nr >>> 13) | 0) + (T >>> 26) | 0, T &= 67108863, sr = Math.imul(Rr, Li), nr = Math.imul(Rr, ms), nr = nr + Math.imul(Er, Li) | 0, fr = Math.imul(Er, ms), sr = sr + Math.imul(En, Mi) | 0, nr = nr + Math.imul(En, Ls) | 0, nr = nr + Math.imul(Zr, Mi) | 0, fr = fr + Math.imul(Zr, Ls) | 0, sr = sr + Math.imul(Xr, Pr) | 0, nr = nr + Math.imul(Xr, vr) | 0, nr = nr + Math.imul(In, Pr) | 0, fr = fr + Math.imul(In, vr) | 0, sr = sr + Math.imul(si, yn) | 0, nr = nr + Math.imul(si, Pn) | 0, nr = nr + Math.imul(vn, yn) | 0, fr = fr + Math.imul(vn, Pn) | 0, sr = sr + Math.imul(dn, ui) | 0, nr = nr + Math.imul(dn, Ei) | 0, nr = nr + Math.imul(Tn, ui) | 0, fr = fr + Math.imul(Tn, Ei) | 0, sr = sr + Math.imul(Jr, Gi) | 0, nr = nr + Math.imul(Jr, Vi) | 0, nr = nr + Math.imul(fn, Gi) | 0, fr = fr + Math.imul(fn, Vi) | 0, sr = sr + Math.imul(yr, $i) | 0, nr = nr + Math.imul(yr, Es) | 0, nr = nr + Math.imul(Qr, $i) | 0, fr = fr + Math.imul(Qr, Es) | 0;
        var L = (ir + sr | 0) + ((nr & 8191) << 13) | 0;
        ir = (fr + (nr >>> 13) | 0) + (L >>> 26) | 0, L &= 67108863, sr = Math.imul(Rr, Mi), nr = Math.imul(Rr, Ls), nr = nr + Math.imul(Er, Mi) | 0, fr = Math.imul(Er, Ls), sr = sr + Math.imul(En, Pr) | 0, nr = nr + Math.imul(En, vr) | 0, nr = nr + Math.imul(Zr, Pr) | 0, fr = fr + Math.imul(Zr, vr) | 0, sr = sr + Math.imul(Xr, yn) | 0, nr = nr + Math.imul(Xr, Pn) | 0, nr = nr + Math.imul(In, yn) | 0, fr = fr + Math.imul(In, Pn) | 0, sr = sr + Math.imul(si, ui) | 0, nr = nr + Math.imul(si, Ei) | 0, nr = nr + Math.imul(vn, ui) | 0, fr = fr + Math.imul(vn, Ei) | 0, sr = sr + Math.imul(dn, Gi) | 0, nr = nr + Math.imul(dn, Vi) | 0, nr = nr + Math.imul(Tn, Gi) | 0, fr = fr + Math.imul(Tn, Vi) | 0, sr = sr + Math.imul(Jr, $i) | 0, nr = nr + Math.imul(Jr, Es) | 0, nr = nr + Math.imul(fn, $i) | 0, fr = fr + Math.imul(fn, Es) | 0;
        var he = (ir + sr | 0) + ((nr & 8191) << 13) | 0;
        ir = (fr + (nr >>> 13) | 0) + (he >>> 26) | 0, he &= 67108863, sr = Math.imul(Rr, Pr), nr = Math.imul(Rr, vr), nr = nr + Math.imul(Er, Pr) | 0, fr = Math.imul(Er, vr), sr = sr + Math.imul(En, yn) | 0, nr = nr + Math.imul(En, Pn) | 0, nr = nr + Math.imul(Zr, yn) | 0, fr = fr + Math.imul(Zr, Pn) | 0, sr = sr + Math.imul(Xr, ui) | 0, nr = nr + Math.imul(Xr, Ei) | 0, nr = nr + Math.imul(In, ui) | 0, fr = fr + Math.imul(In, Ei) | 0, sr = sr + Math.imul(si, Gi) | 0, nr = nr + Math.imul(si, Vi) | 0, nr = nr + Math.imul(vn, Gi) | 0, fr = fr + Math.imul(vn, Vi) | 0, sr = sr + Math.imul(dn, $i) | 0, nr = nr + Math.imul(dn, Es) | 0, nr = nr + Math.imul(Tn, $i) | 0, fr = fr + Math.imul(Tn, Es) | 0;
        var Be = (ir + sr | 0) + ((nr & 8191) << 13) | 0;
        ir = (fr + (nr >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, sr = Math.imul(Rr, yn), nr = Math.imul(Rr, Pn), nr = nr + Math.imul(Er, yn) | 0, fr = Math.imul(Er, Pn), sr = sr + Math.imul(En, ui) | 0, nr = nr + Math.imul(En, Ei) | 0, nr = nr + Math.imul(Zr, ui) | 0, fr = fr + Math.imul(Zr, Ei) | 0, sr = sr + Math.imul(Xr, Gi) | 0, nr = nr + Math.imul(Xr, Vi) | 0, nr = nr + Math.imul(In, Gi) | 0, fr = fr + Math.imul(In, Vi) | 0, sr = sr + Math.imul(si, $i) | 0, nr = nr + Math.imul(si, Es) | 0, nr = nr + Math.imul(vn, $i) | 0, fr = fr + Math.imul(vn, Es) | 0;
        var Me = (ir + sr | 0) + ((nr & 8191) << 13) | 0;
        ir = (fr + (nr >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, sr = Math.imul(Rr, ui), nr = Math.imul(Rr, Ei), nr = nr + Math.imul(Er, ui) | 0, fr = Math.imul(Er, Ei), sr = sr + Math.imul(En, Gi) | 0, nr = nr + Math.imul(En, Vi) | 0, nr = nr + Math.imul(Zr, Gi) | 0, fr = fr + Math.imul(Zr, Vi) | 0, sr = sr + Math.imul(Xr, $i) | 0, nr = nr + Math.imul(Xr, Es) | 0, nr = nr + Math.imul(In, $i) | 0, fr = fr + Math.imul(In, Es) | 0;
        var tr = (ir + sr | 0) + ((nr & 8191) << 13) | 0;
        ir = (fr + (nr >>> 13) | 0) + (tr >>> 26) | 0, tr &= 67108863, sr = Math.imul(Rr, Gi), nr = Math.imul(Rr, Vi), nr = nr + Math.imul(Er, Gi) | 0, fr = Math.imul(Er, Vi), sr = sr + Math.imul(En, $i) | 0, nr = nr + Math.imul(En, Es) | 0, nr = nr + Math.imul(Zr, $i) | 0, fr = fr + Math.imul(Zr, Es) | 0;
        var or = (ir + sr | 0) + ((nr & 8191) << 13) | 0;
        ir = (fr + (nr >>> 13) | 0) + (or >>> 26) | 0, or &= 67108863, sr = Math.imul(Rr, $i), nr = Math.imul(Rr, Es), nr = nr + Math.imul(Er, $i) | 0, fr = Math.imul(Er, Es);
        var cr = (ir + sr | 0) + ((nr & 8191) << 13) | 0;
        return ir = (fr + (nr >>> 13) | 0) + (cr >>> 26) | 0, cr &= 67108863, er[0] = pn, er[1] = Nr, er[2] = Qn, er[3] = zn, er[4] = ti, er[5] = v, er[6] = d, er[7] = I, er[8] = n, er[9] = a, er[10] = E, er[11] = T, er[12] = L, er[13] = he, er[14] = Be, er[15] = Me, er[16] = tr, er[17] = or, er[18] = cr, ir !== 0 && (er[19] = ir, Se.length++), Se;
      };
      Math.imul || (F = M);
      function le(ve, we, Ce) {
        Ce.negative = we.negative ^ ve.negative, Ce.length = ve.length + we.length;
        for (var Se = 0, Ne = 0, rr = 0; rr < Ce.length - 1; rr++) {
          var er = Ne;
          Ne = 0;
          for (var ir = Se & 67108863, sr = Math.min(rr, we.length - 1), nr = Math.max(0, rr - ve.length + 1); nr <= sr; nr++) {
            var fr = rr - nr, lr = ve.words[fr] | 0, br = we.words[nr] | 0, Br = lr * br, Fr = Br & 67108863;
            er = er + (Br / 67108864 | 0) | 0, Fr = Fr + ir | 0, ir = Fr & 67108863, er = er + (Fr >>> 26) | 0, Ne += er >>> 26, er &= 67108863;
          }
          Ce.words[rr] = ir, Se = er, er = Ne;
        }
        return Se !== 0 ? Ce.words[rr] = Se : Ce.length--, Ce.strip();
      }
      function ge(ve, we, Ce) {
        var Se = new pe();
        return Se.mulp(ve, we, Ce);
      }
      l.prototype.mulTo = function(we, Ce) {
        var Se, Ne = this.length + we.length;
        return this.length === 10 && we.length === 10 ? Se = F(this, we, Ce) : Ne < 63 ? Se = M(this, we, Ce) : Ne < 1024 ? Se = le(this, we, Ce) : Se = ge(this, we, Ce), Se;
      };
      function pe(ve, we) {
        this.x = ve, this.y = we;
      }
      pe.prototype.makeRBT = function(we) {
        for (var Ce = new Array(we), Se = l.prototype._countBits(we) - 1, Ne = 0; Ne < we; Ne++)
          Ce[Ne] = this.revBin(Ne, Se, we);
        return Ce;
      }, pe.prototype.revBin = function(we, Ce, Se) {
        if (we === 0 || we === Se - 1) return we;
        for (var Ne = 0, rr = 0; rr < Ce; rr++)
          Ne |= (we & 1) << Ce - rr - 1, we >>= 1;
        return Ne;
      }, pe.prototype.permute = function(we, Ce, Se, Ne, rr, er) {
        for (var ir = 0; ir < er; ir++)
          Ne[ir] = Ce[we[ir]], rr[ir] = Se[we[ir]];
      }, pe.prototype.transform = function(we, Ce, Se, Ne, rr, er) {
        this.permute(er, we, Ce, Se, Ne, rr);
        for (var ir = 1; ir < rr; ir <<= 1)
          for (var sr = ir << 1, nr = Math.cos(2 * Math.PI / sr), fr = Math.sin(2 * Math.PI / sr), lr = 0; lr < rr; lr += sr)
            for (var br = nr, Br = fr, Fr = 0; Fr < ir; Fr++) {
              var Gr = Se[lr + Fr], qr = Ne[lr + Fr], Hr = Se[lr + Fr + ir], un = Ne[lr + Fr + ir], Dr = br * Hr - Br * un;
              un = br * un + Br * Hr, Hr = Dr, Se[lr + Fr] = Gr + Hr, Ne[lr + Fr] = qr + un, Se[lr + Fr + ir] = Gr - Hr, Ne[lr + Fr + ir] = qr - un, Fr !== sr && (Dr = nr * br - fr * Br, Br = nr * Br + fr * br, br = Dr);
            }
      }, pe.prototype.guessLen13b = function(we, Ce) {
        var Se = Math.max(Ce, we) | 1, Ne = Se & 1, rr = 0;
        for (Se = Se / 2 | 0; Se; Se = Se >>> 1)
          rr++;
        return 1 << rr + 1 + Ne;
      }, pe.prototype.conjugate = function(we, Ce, Se) {
        if (!(Se <= 1))
          for (var Ne = 0; Ne < Se / 2; Ne++) {
            var rr = we[Ne];
            we[Ne] = we[Se - Ne - 1], we[Se - Ne - 1] = rr, rr = Ce[Ne], Ce[Ne] = -Ce[Se - Ne - 1], Ce[Se - Ne - 1] = -rr;
          }
      }, pe.prototype.normalize13b = function(we, Ce) {
        for (var Se = 0, Ne = 0; Ne < Ce / 2; Ne++) {
          var rr = Math.round(we[2 * Ne + 1] / Ce) * 8192 + Math.round(we[2 * Ne] / Ce) + Se;
          we[Ne] = rr & 67108863, rr < 67108864 ? Se = 0 : Se = rr / 67108864 | 0;
        }
        return we;
      }, pe.prototype.convert13b = function(we, Ce, Se, Ne) {
        for (var rr = 0, er = 0; er < Ce; er++)
          rr = rr + (we[er] | 0), Se[2 * er] = rr & 8191, rr = rr >>> 13, Se[2 * er + 1] = rr & 8191, rr = rr >>> 13;
        for (er = 2 * Ce; er < Ne; ++er)
          Se[er] = 0;
        p(rr === 0), p((rr & -8192) === 0);
      }, pe.prototype.stub = function(we) {
        for (var Ce = new Array(we), Se = 0; Se < we; Se++)
          Ce[Se] = 0;
        return Ce;
      }, pe.prototype.mulp = function(we, Ce, Se) {
        var Ne = 2 * this.guessLen13b(we.length, Ce.length), rr = this.makeRBT(Ne), er = this.stub(Ne), ir = new Array(Ne), sr = new Array(Ne), nr = new Array(Ne), fr = new Array(Ne), lr = new Array(Ne), br = new Array(Ne), Br = Se.words;
        Br.length = Ne, this.convert13b(we.words, we.length, ir, Ne), this.convert13b(Ce.words, Ce.length, fr, Ne), this.transform(ir, er, sr, nr, Ne, rr), this.transform(fr, er, lr, br, Ne, rr);
        for (var Fr = 0; Fr < Ne; Fr++) {
          var Gr = sr[Fr] * lr[Fr] - nr[Fr] * br[Fr];
          nr[Fr] = sr[Fr] * br[Fr] + nr[Fr] * lr[Fr], sr[Fr] = Gr;
        }
        return this.conjugate(sr, nr, Ne), this.transform(sr, nr, Br, er, Ne, rr), this.conjugate(Br, er, Ne), this.normalize13b(Br, Ne), Se.negative = we.negative ^ Ce.negative, Se.length = we.length + Ce.length, Se.strip();
      }, l.prototype.mul = function(we) {
        var Ce = new l(null);
        return Ce.words = new Array(this.length + we.length), this.mulTo(we, Ce);
      }, l.prototype.mulf = function(we) {
        var Ce = new l(null);
        return Ce.words = new Array(this.length + we.length), ge(this, we, Ce);
      }, l.prototype.imul = function(we) {
        return this.clone().mulTo(we, this);
      }, l.prototype.imuln = function(we) {
        p(typeof we == "number"), p(we < 67108864);
        for (var Ce = 0, Se = 0; Se < this.length; Se++) {
          var Ne = (this.words[Se] | 0) * we, rr = (Ne & 67108863) + (Ce & 67108863);
          Ce >>= 26, Ce += Ne / 67108864 | 0, Ce += rr >>> 26, this.words[Se] = rr & 67108863;
        }
        return Ce !== 0 && (this.words[Se] = Ce, this.length++), this.length = we === 0 ? 1 : this.length, this;
      }, l.prototype.muln = function(we) {
        return this.clone().imuln(we);
      }, l.prototype.sqr = function() {
        return this.mul(this);
      }, l.prototype.isqr = function() {
        return this.imul(this.clone());
      }, l.prototype.pow = function(we) {
        var Ce = x(we);
        if (Ce.length === 0) return new l(1);
        for (var Se = this, Ne = 0; Ne < Ce.length && Ce[Ne] === 0; Ne++, Se = Se.sqr())
          ;
        if (++Ne < Ce.length)
          for (var rr = Se.sqr(); Ne < Ce.length; Ne++, rr = rr.sqr())
            Ce[Ne] !== 0 && (Se = Se.mul(rr));
        return Se;
      }, l.prototype.iushln = function(we) {
        p(typeof we == "number" && we >= 0);
        var Ce = we % 26, Se = (we - Ce) / 26, Ne = 67108863 >>> 26 - Ce << 26 - Ce, rr;
        if (Ce !== 0) {
          var er = 0;
          for (rr = 0; rr < this.length; rr++) {
            var ir = this.words[rr] & Ne, sr = (this.words[rr] | 0) - ir << Ce;
            this.words[rr] = sr | er, er = ir >>> 26 - Ce;
          }
          er && (this.words[rr] = er, this.length++);
        }
        if (Se !== 0) {
          for (rr = this.length - 1; rr >= 0; rr--)
            this.words[rr + Se] = this.words[rr];
          for (rr = 0; rr < Se; rr++)
            this.words[rr] = 0;
          this.length += Se;
        }
        return this.strip();
      }, l.prototype.ishln = function(we) {
        return p(this.negative === 0), this.iushln(we);
      }, l.prototype.iushrn = function(we, Ce, Se) {
        p(typeof we == "number" && we >= 0);
        var Ne;
        Ce ? Ne = (Ce - Ce % 26) / 26 : Ne = 0;
        var rr = we % 26, er = Math.min((we - rr) / 26, this.length), ir = 67108863 ^ 67108863 >>> rr << rr, sr = Se;
        if (Ne -= er, Ne = Math.max(0, Ne), sr) {
          for (var nr = 0; nr < er; nr++)
            sr.words[nr] = this.words[nr];
          sr.length = er;
        }
        if (er !== 0) if (this.length > er)
          for (this.length -= er, nr = 0; nr < this.length; nr++)
            this.words[nr] = this.words[nr + er];
        else
          this.words[0] = 0, this.length = 1;
        var fr = 0;
        for (nr = this.length - 1; nr >= 0 && (fr !== 0 || nr >= Ne); nr--) {
          var lr = this.words[nr] | 0;
          this.words[nr] = fr << 26 - rr | lr >>> rr, fr = lr & ir;
        }
        return sr && fr !== 0 && (sr.words[sr.length++] = fr), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, l.prototype.ishrn = function(we, Ce, Se) {
        return p(this.negative === 0), this.iushrn(we, Ce, Se);
      }, l.prototype.shln = function(we) {
        return this.clone().ishln(we);
      }, l.prototype.ushln = function(we) {
        return this.clone().iushln(we);
      }, l.prototype.shrn = function(we) {
        return this.clone().ishrn(we);
      }, l.prototype.ushrn = function(we) {
        return this.clone().iushrn(we);
      }, l.prototype.testn = function(we) {
        p(typeof we == "number" && we >= 0);
        var Ce = we % 26, Se = (we - Ce) / 26, Ne = 1 << Ce;
        if (this.length <= Se) return !1;
        var rr = this.words[Se];
        return !!(rr & Ne);
      }, l.prototype.imaskn = function(we) {
        p(typeof we == "number" && we >= 0);
        var Ce = we % 26, Se = (we - Ce) / 26;
        if (p(this.negative === 0, "imaskn works only with positive numbers"), this.length <= Se)
          return this;
        if (Ce !== 0 && Se++, this.length = Math.min(Se, this.length), Ce !== 0) {
          var Ne = 67108863 ^ 67108863 >>> Ce << Ce;
          this.words[this.length - 1] &= Ne;
        }
        return this.strip();
      }, l.prototype.maskn = function(we) {
        return this.clone().imaskn(we);
      }, l.prototype.iaddn = function(we) {
        return p(typeof we == "number"), p(we < 67108864), we < 0 ? this.isubn(-we) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < we ? (this.words[0] = we - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(we), this.negative = 1, this) : this._iaddn(we);
      }, l.prototype._iaddn = function(we) {
        this.words[0] += we;
        for (var Ce = 0; Ce < this.length && this.words[Ce] >= 67108864; Ce++)
          this.words[Ce] -= 67108864, Ce === this.length - 1 ? this.words[Ce + 1] = 1 : this.words[Ce + 1]++;
        return this.length = Math.max(this.length, Ce + 1), this;
      }, l.prototype.isubn = function(we) {
        if (p(typeof we == "number"), p(we < 67108864), we < 0) return this.iaddn(-we);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(we), this.negative = 1, this;
        if (this.words[0] -= we, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var Ce = 0; Ce < this.length && this.words[Ce] < 0; Ce++)
            this.words[Ce] += 67108864, this.words[Ce + 1] -= 1;
        return this.strip();
      }, l.prototype.addn = function(we) {
        return this.clone().iaddn(we);
      }, l.prototype.subn = function(we) {
        return this.clone().isubn(we);
      }, l.prototype.iabs = function() {
        return this.negative = 0, this;
      }, l.prototype.abs = function() {
        return this.clone().iabs();
      }, l.prototype._ishlnsubmul = function(we, Ce, Se) {
        var Ne = we.length + Se, rr;
        this._expand(Ne);
        var er, ir = 0;
        for (rr = 0; rr < we.length; rr++) {
          er = (this.words[rr + Se] | 0) + ir;
          var sr = (we.words[rr] | 0) * Ce;
          er -= sr & 67108863, ir = (er >> 26) - (sr / 67108864 | 0), this.words[rr + Se] = er & 67108863;
        }
        for (; rr < this.length - Se; rr++)
          er = (this.words[rr + Se] | 0) + ir, ir = er >> 26, this.words[rr + Se] = er & 67108863;
        if (ir === 0) return this.strip();
        for (p(ir === -1), ir = 0, rr = 0; rr < this.length; rr++)
          er = -(this.words[rr] | 0) + ir, ir = er >> 26, this.words[rr] = er & 67108863;
        return this.negative = 1, this.strip();
      }, l.prototype._wordDiv = function(we, Ce) {
        var Se = this.length - we.length, Ne = this.clone(), rr = we, er = rr.words[rr.length - 1] | 0, ir = this._countBits(er);
        Se = 26 - ir, Se !== 0 && (rr = rr.ushln(Se), Ne.iushln(Se), er = rr.words[rr.length - 1] | 0);
        var sr = Ne.length - rr.length, nr;
        if (Ce !== "mod") {
          nr = new l(null), nr.length = sr + 1, nr.words = new Array(nr.length);
          for (var fr = 0; fr < nr.length; fr++)
            nr.words[fr] = 0;
        }
        var lr = Ne.clone()._ishlnsubmul(rr, 1, sr);
        lr.negative === 0 && (Ne = lr, nr && (nr.words[sr] = 1));
        for (var br = sr - 1; br >= 0; br--) {
          var Br = (Ne.words[rr.length + br] | 0) * 67108864 + (Ne.words[rr.length + br - 1] | 0);
          for (Br = Math.min(Br / er | 0, 67108863), Ne._ishlnsubmul(rr, Br, br); Ne.negative !== 0; )
            Br--, Ne.negative = 0, Ne._ishlnsubmul(rr, 1, br), Ne.isZero() || (Ne.negative ^= 1);
          nr && (nr.words[br] = Br);
        }
        return nr && nr.strip(), Ne.strip(), Ce !== "div" && Se !== 0 && Ne.iushrn(Se), {
          div: nr || null,
          mod: Ne
        };
      }, l.prototype.divmod = function(we, Ce, Se) {
        if (p(!we.isZero()), this.isZero())
          return {
            div: new l(0),
            mod: new l(0)
          };
        var Ne, rr, er;
        return this.negative !== 0 && we.negative === 0 ? (er = this.neg().divmod(we, Ce), Ce !== "mod" && (Ne = er.div.neg()), Ce !== "div" && (rr = er.mod.neg(), Se && rr.negative !== 0 && rr.iadd(we)), {
          div: Ne,
          mod: rr
        }) : this.negative === 0 && we.negative !== 0 ? (er = this.divmod(we.neg(), Ce), Ce !== "mod" && (Ne = er.div.neg()), {
          div: Ne,
          mod: er.mod
        }) : (this.negative & we.negative) !== 0 ? (er = this.neg().divmod(we.neg(), Ce), Ce !== "div" && (rr = er.mod.neg(), Se && rr.negative !== 0 && rr.isub(we)), {
          div: er.div,
          mod: rr
        }) : we.length > this.length || this.cmp(we) < 0 ? {
          div: new l(0),
          mod: this
        } : we.length === 1 ? Ce === "div" ? {
          div: this.divn(we.words[0]),
          mod: null
        } : Ce === "mod" ? {
          div: null,
          mod: new l(this.modn(we.words[0]))
        } : {
          div: this.divn(we.words[0]),
          mod: new l(this.modn(we.words[0]))
        } : this._wordDiv(we, Ce);
      }, l.prototype.div = function(we) {
        return this.divmod(we, "div", !1).div;
      }, l.prototype.mod = function(we) {
        return this.divmod(we, "mod", !1).mod;
      }, l.prototype.umod = function(we) {
        return this.divmod(we, "mod", !0).mod;
      }, l.prototype.divRound = function(we) {
        var Ce = this.divmod(we);
        if (Ce.mod.isZero()) return Ce.div;
        var Se = Ce.div.negative !== 0 ? Ce.mod.isub(we) : Ce.mod, Ne = we.ushrn(1), rr = we.andln(1), er = Se.cmp(Ne);
        return er < 0 || rr === 1 && er === 0 ? Ce.div : Ce.div.negative !== 0 ? Ce.div.isubn(1) : Ce.div.iaddn(1);
      }, l.prototype.modn = function(we) {
        p(we <= 67108863);
        for (var Ce = (1 << 26) % we, Se = 0, Ne = this.length - 1; Ne >= 0; Ne--)
          Se = (Ce * Se + (this.words[Ne] | 0)) % we;
        return Se;
      }, l.prototype.idivn = function(we) {
        p(we <= 67108863);
        for (var Ce = 0, Se = this.length - 1; Se >= 0; Se--) {
          var Ne = (this.words[Se] | 0) + Ce * 67108864;
          this.words[Se] = Ne / we | 0, Ce = Ne % we;
        }
        return this.strip();
      }, l.prototype.divn = function(we) {
        return this.clone().idivn(we);
      }, l.prototype.egcd = function(we) {
        p(we.negative === 0), p(!we.isZero());
        var Ce = this, Se = we.clone();
        Ce.negative !== 0 ? Ce = Ce.umod(we) : Ce = Ce.clone();
        for (var Ne = new l(1), rr = new l(0), er = new l(0), ir = new l(1), sr = 0; Ce.isEven() && Se.isEven(); )
          Ce.iushrn(1), Se.iushrn(1), ++sr;
        for (var nr = Se.clone(), fr = Ce.clone(); !Ce.isZero(); ) {
          for (var lr = 0, br = 1; (Ce.words[0] & br) === 0 && lr < 26; ++lr, br <<= 1) ;
          if (lr > 0)
            for (Ce.iushrn(lr); lr-- > 0; )
              (Ne.isOdd() || rr.isOdd()) && (Ne.iadd(nr), rr.isub(fr)), Ne.iushrn(1), rr.iushrn(1);
          for (var Br = 0, Fr = 1; (Se.words[0] & Fr) === 0 && Br < 26; ++Br, Fr <<= 1) ;
          if (Br > 0)
            for (Se.iushrn(Br); Br-- > 0; )
              (er.isOdd() || ir.isOdd()) && (er.iadd(nr), ir.isub(fr)), er.iushrn(1), ir.iushrn(1);
          Ce.cmp(Se) >= 0 ? (Ce.isub(Se), Ne.isub(er), rr.isub(ir)) : (Se.isub(Ce), er.isub(Ne), ir.isub(rr));
        }
        return {
          a: er,
          b: ir,
          gcd: Se.iushln(sr)
        };
      }, l.prototype._invmp = function(we) {
        p(we.negative === 0), p(!we.isZero());
        var Ce = this, Se = we.clone();
        Ce.negative !== 0 ? Ce = Ce.umod(we) : Ce = Ce.clone();
        for (var Ne = new l(1), rr = new l(0), er = Se.clone(); Ce.cmpn(1) > 0 && Se.cmpn(1) > 0; ) {
          for (var ir = 0, sr = 1; (Ce.words[0] & sr) === 0 && ir < 26; ++ir, sr <<= 1) ;
          if (ir > 0)
            for (Ce.iushrn(ir); ir-- > 0; )
              Ne.isOdd() && Ne.iadd(er), Ne.iushrn(1);
          for (var nr = 0, fr = 1; (Se.words[0] & fr) === 0 && nr < 26; ++nr, fr <<= 1) ;
          if (nr > 0)
            for (Se.iushrn(nr); nr-- > 0; )
              rr.isOdd() && rr.iadd(er), rr.iushrn(1);
          Ce.cmp(Se) >= 0 ? (Ce.isub(Se), Ne.isub(rr)) : (Se.isub(Ce), rr.isub(Ne));
        }
        var lr;
        return Ce.cmpn(1) === 0 ? lr = Ne : lr = rr, lr.cmpn(0) < 0 && lr.iadd(we), lr;
      }, l.prototype.gcd = function(we) {
        if (this.isZero()) return we.abs();
        if (we.isZero()) return this.abs();
        var Ce = this.clone(), Se = we.clone();
        Ce.negative = 0, Se.negative = 0;
        for (var Ne = 0; Ce.isEven() && Se.isEven(); Ne++)
          Ce.iushrn(1), Se.iushrn(1);
        do {
          for (; Ce.isEven(); )
            Ce.iushrn(1);
          for (; Se.isEven(); )
            Se.iushrn(1);
          var rr = Ce.cmp(Se);
          if (rr < 0) {
            var er = Ce;
            Ce = Se, Se = er;
          } else if (rr === 0 || Se.cmpn(1) === 0)
            break;
          Ce.isub(Se);
        } while (!0);
        return Se.iushln(Ne);
      }, l.prototype.invm = function(we) {
        return this.egcd(we).a.umod(we);
      }, l.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, l.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, l.prototype.andln = function(we) {
        return this.words[0] & we;
      }, l.prototype.bincn = function(we) {
        p(typeof we == "number");
        var Ce = we % 26, Se = (we - Ce) / 26, Ne = 1 << Ce;
        if (this.length <= Se)
          return this._expand(Se + 1), this.words[Se] |= Ne, this;
        for (var rr = Ne, er = Se; rr !== 0 && er < this.length; er++) {
          var ir = this.words[er] | 0;
          ir += rr, rr = ir >>> 26, ir &= 67108863, this.words[er] = ir;
        }
        return rr !== 0 && (this.words[er] = rr, this.length++), this;
      }, l.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, l.prototype.cmpn = function(we) {
        var Ce = we < 0;
        if (this.negative !== 0 && !Ce) return -1;
        if (this.negative === 0 && Ce) return 1;
        this.strip();
        var Se;
        if (this.length > 1)
          Se = 1;
        else {
          Ce && (we = -we), p(we <= 67108863, "Number is too big");
          var Ne = this.words[0] | 0;
          Se = Ne === we ? 0 : Ne < we ? -1 : 1;
        }
        return this.negative !== 0 ? -Se | 0 : Se;
      }, l.prototype.cmp = function(we) {
        if (this.negative !== 0 && we.negative === 0) return -1;
        if (this.negative === 0 && we.negative !== 0) return 1;
        var Ce = this.ucmp(we);
        return this.negative !== 0 ? -Ce | 0 : Ce;
      }, l.prototype.ucmp = function(we) {
        if (this.length > we.length) return 1;
        if (this.length < we.length) return -1;
        for (var Ce = 0, Se = this.length - 1; Se >= 0; Se--) {
          var Ne = this.words[Se] | 0, rr = we.words[Se] | 0;
          if (Ne !== rr) {
            Ne < rr ? Ce = -1 : Ne > rr && (Ce = 1);
            break;
          }
        }
        return Ce;
      }, l.prototype.gtn = function(we) {
        return this.cmpn(we) === 1;
      }, l.prototype.gt = function(we) {
        return this.cmp(we) === 1;
      }, l.prototype.gten = function(we) {
        return this.cmpn(we) >= 0;
      }, l.prototype.gte = function(we) {
        return this.cmp(we) >= 0;
      }, l.prototype.ltn = function(we) {
        return this.cmpn(we) === -1;
      }, l.prototype.lt = function(we) {
        return this.cmp(we) === -1;
      }, l.prototype.lten = function(we) {
        return this.cmpn(we) <= 0;
      }, l.prototype.lte = function(we) {
        return this.cmp(we) <= 0;
      }, l.prototype.eqn = function(we) {
        return this.cmpn(we) === 0;
      }, l.prototype.eq = function(we) {
        return this.cmp(we) === 0;
      }, l.red = function(we) {
        return new Ee(we);
      }, l.prototype.toRed = function(we) {
        return p(!this.red, "Already a number in reduction context"), p(this.negative === 0, "red works only with positives"), we.convertTo(this)._forceRed(we);
      }, l.prototype.fromRed = function() {
        return p(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, l.prototype._forceRed = function(we) {
        return this.red = we, this;
      }, l.prototype.forceRed = function(we) {
        return p(!this.red, "Already a number in reduction context"), this._forceRed(we);
      }, l.prototype.redAdd = function(we) {
        return p(this.red, "redAdd works only with red numbers"), this.red.add(this, we);
      }, l.prototype.redIAdd = function(we) {
        return p(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, we);
      }, l.prototype.redSub = function(we) {
        return p(this.red, "redSub works only with red numbers"), this.red.sub(this, we);
      }, l.prototype.redISub = function(we) {
        return p(this.red, "redISub works only with red numbers"), this.red.isub(this, we);
      }, l.prototype.redShl = function(we) {
        return p(this.red, "redShl works only with red numbers"), this.red.shl(this, we);
      }, l.prototype.redMul = function(we) {
        return p(this.red, "redMul works only with red numbers"), this.red._verify2(this, we), this.red.mul(this, we);
      }, l.prototype.redIMul = function(we) {
        return p(this.red, "redMul works only with red numbers"), this.red._verify2(this, we), this.red.imul(this, we);
      }, l.prototype.redSqr = function() {
        return p(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, l.prototype.redISqr = function() {
        return p(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, l.prototype.redSqrt = function() {
        return p(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, l.prototype.redInvm = function() {
        return p(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, l.prototype.redNeg = function() {
        return p(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, l.prototype.redPow = function(we) {
        return p(this.red && !we.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, we);
      };
      var Ie = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function be(ve, we) {
        this.name = ve, this.p = new l(we, 16), this.n = this.p.bitLength(), this.k = new l(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      be.prototype._tmp = function() {
        var we = new l(null);
        return we.words = new Array(Math.ceil(this.n / 13)), we;
      }, be.prototype.ireduce = function(we) {
        var Ce = we, Se;
        do
          this.split(Ce, this.tmp), Ce = this.imulK(Ce), Ce = Ce.iadd(this.tmp), Se = Ce.bitLength();
        while (Se > this.n);
        var Ne = Se < this.n ? -1 : Ce.ucmp(this.p);
        return Ne === 0 ? (Ce.words[0] = 0, Ce.length = 1) : Ne > 0 ? Ce.isub(this.p) : Ce.strip !== void 0 ? Ce.strip() : Ce._strip(), Ce;
      }, be.prototype.split = function(we, Ce) {
        we.iushrn(this.n, 0, Ce);
      }, be.prototype.imulK = function(we) {
        return we.imul(this.k);
      };
      function Pe() {
        be.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      t(Pe, be), Pe.prototype.split = function(we, Ce) {
        for (var Se = 4194303, Ne = Math.min(we.length, 9), rr = 0; rr < Ne; rr++)
          Ce.words[rr] = we.words[rr];
        if (Ce.length = Ne, we.length <= 9) {
          we.words[0] = 0, we.length = 1;
          return;
        }
        var er = we.words[9];
        for (Ce.words[Ce.length++] = er & Se, rr = 10; rr < we.length; rr++) {
          var ir = we.words[rr] | 0;
          we.words[rr - 10] = (ir & Se) << 4 | er >>> 22, er = ir;
        }
        er >>>= 22, we.words[rr - 10] = er, er === 0 && we.length > 10 ? we.length -= 10 : we.length -= 9;
      }, Pe.prototype.imulK = function(we) {
        we.words[we.length] = 0, we.words[we.length + 1] = 0, we.length += 2;
        for (var Ce = 0, Se = 0; Se < we.length; Se++) {
          var Ne = we.words[Se] | 0;
          Ce += Ne * 977, we.words[Se] = Ce & 67108863, Ce = Ne * 64 + (Ce / 67108864 | 0);
        }
        return we.words[we.length - 1] === 0 && (we.length--, we.words[we.length - 1] === 0 && we.length--), we;
      };
      function Te() {
        be.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      t(Te, be);
      function Qe() {
        be.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      t(Qe, be);
      function xe() {
        be.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      t(xe, be), xe.prototype.imulK = function(we) {
        for (var Ce = 0, Se = 0; Se < we.length; Se++) {
          var Ne = (we.words[Se] | 0) * 19 + Ce, rr = Ne & 67108863;
          Ne >>>= 26, we.words[Se] = rr, Ce = Ne;
        }
        return Ce !== 0 && (we.words[we.length++] = Ce), we;
      }, l._prime = function(we) {
        if (Ie[we]) return Ie[we];
        var Ce;
        if (we === "k256")
          Ce = new Pe();
        else if (we === "p224")
          Ce = new Te();
        else if (we === "p192")
          Ce = new Qe();
        else if (we === "p25519")
          Ce = new xe();
        else
          throw new Error("Unknown prime " + we);
        return Ie[we] = Ce, Ce;
      };
      function Ee(ve) {
        if (typeof ve == "string") {
          var we = l._prime(ve);
          this.m = we.p, this.prime = we;
        } else
          p(ve.gtn(1), "modulus must be greater than 1"), this.m = ve, this.prime = null;
      }
      Ee.prototype._verify1 = function(we) {
        p(we.negative === 0, "red works only with positives"), p(we.red, "red works only with red numbers");
      }, Ee.prototype._verify2 = function(we, Ce) {
        p((we.negative | Ce.negative) === 0, "red works only with positives"), p(
          we.red && we.red === Ce.red,
          "red works only with red numbers"
        );
      }, Ee.prototype.imod = function(we) {
        return this.prime ? this.prime.ireduce(we)._forceRed(this) : we.umod(this.m)._forceRed(this);
      }, Ee.prototype.neg = function(we) {
        return we.isZero() ? we.clone() : this.m.sub(we)._forceRed(this);
      }, Ee.prototype.add = function(we, Ce) {
        this._verify2(we, Ce);
        var Se = we.add(Ce);
        return Se.cmp(this.m) >= 0 && Se.isub(this.m), Se._forceRed(this);
      }, Ee.prototype.iadd = function(we, Ce) {
        this._verify2(we, Ce);
        var Se = we.iadd(Ce);
        return Se.cmp(this.m) >= 0 && Se.isub(this.m), Se;
      }, Ee.prototype.sub = function(we, Ce) {
        this._verify2(we, Ce);
        var Se = we.sub(Ce);
        return Se.cmpn(0) < 0 && Se.iadd(this.m), Se._forceRed(this);
      }, Ee.prototype.isub = function(we, Ce) {
        this._verify2(we, Ce);
        var Se = we.isub(Ce);
        return Se.cmpn(0) < 0 && Se.iadd(this.m), Se;
      }, Ee.prototype.shl = function(we, Ce) {
        return this._verify1(we), this.imod(we.ushln(Ce));
      }, Ee.prototype.imul = function(we, Ce) {
        return this._verify2(we, Ce), this.imod(we.imul(Ce));
      }, Ee.prototype.mul = function(we, Ce) {
        return this._verify2(we, Ce), this.imod(we.mul(Ce));
      }, Ee.prototype.isqr = function(we) {
        return this.imul(we, we.clone());
      }, Ee.prototype.sqr = function(we) {
        return this.mul(we, we);
      }, Ee.prototype.sqrt = function(we) {
        if (we.isZero()) return we.clone();
        var Ce = this.m.andln(3);
        if (p(Ce % 2 === 1), Ce === 3) {
          var Se = this.m.add(new l(1)).iushrn(2);
          return this.pow(we, Se);
        }
        for (var Ne = this.m.subn(1), rr = 0; !Ne.isZero() && Ne.andln(1) === 0; )
          rr++, Ne.iushrn(1);
        p(!Ne.isZero());
        var er = new l(1).toRed(this), ir = er.redNeg(), sr = this.m.subn(1).iushrn(1), nr = this.m.bitLength();
        for (nr = new l(2 * nr * nr).toRed(this); this.pow(nr, sr).cmp(ir) !== 0; )
          nr.redIAdd(ir);
        for (var fr = this.pow(nr, Ne), lr = this.pow(we, Ne.addn(1).iushrn(1)), br = this.pow(we, Ne), Br = rr; br.cmp(er) !== 0; ) {
          for (var Fr = br, Gr = 0; Fr.cmp(er) !== 0; Gr++)
            Fr = Fr.redSqr();
          p(Gr < Br);
          var qr = this.pow(fr, new l(1).iushln(Br - Gr - 1));
          lr = lr.redMul(qr), fr = qr.redSqr(), br = br.redMul(fr), Br = Gr;
        }
        return lr;
      }, Ee.prototype.invm = function(we) {
        var Ce = we._invmp(this.m);
        return Ce.negative !== 0 ? (Ce.negative = 0, this.imod(Ce).redNeg()) : this.imod(Ce);
      }, Ee.prototype.pow = function(we, Ce) {
        if (Ce.isZero()) return new l(1).toRed(this);
        if (Ce.cmpn(1) === 0) return we.clone();
        var Se = 4, Ne = new Array(1 << Se);
        Ne[0] = new l(1).toRed(this), Ne[1] = we;
        for (var rr = 2; rr < Ne.length; rr++)
          Ne[rr] = this.mul(Ne[rr - 1], we);
        var er = Ne[0], ir = 0, sr = 0, nr = Ce.bitLength() % 26;
        for (nr === 0 && (nr = 26), rr = Ce.length - 1; rr >= 0; rr--) {
          for (var fr = Ce.words[rr], lr = nr - 1; lr >= 0; lr--) {
            var br = fr >> lr & 1;
            if (er !== Ne[0] && (er = this.sqr(er)), br === 0 && ir === 0) {
              sr = 0;
              continue;
            }
            ir <<= 1, ir |= br, sr++, !(sr !== Se && (rr !== 0 || lr !== 0)) && (er = this.mul(er, Ne[ir]), sr = 0, ir = 0);
          }
          nr = 26;
        }
        return er;
      }, Ee.prototype.convertTo = function(we) {
        var Ce = we.umod(this.m);
        return Ce === we ? Ce.clone() : Ce;
      }, Ee.prototype.convertFrom = function(we) {
        var Ce = we.clone();
        return Ce.red = null, Ce;
      }, l.mont = function(we) {
        return new He(we);
      };
      function He(ve) {
        Ee.call(this, ve), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new l(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      t(He, Ee), He.prototype.convertTo = function(we) {
        return this.imod(we.ushln(this.shift));
      }, He.prototype.convertFrom = function(we) {
        var Ce = this.imod(we.mul(this.rinv));
        return Ce.red = null, Ce;
      }, He.prototype.imul = function(we, Ce) {
        if (we.isZero() || Ce.isZero())
          return we.words[0] = 0, we.length = 1, we;
        var Se = we.imul(Ce), Ne = Se.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), rr = Se.isub(Ne).iushrn(this.shift), er = rr;
        return rr.cmp(this.m) >= 0 ? er = rr.isub(this.m) : rr.cmpn(0) < 0 && (er = rr.iadd(this.m)), er._forceRed(this);
      }, He.prototype.mul = function(we, Ce) {
        if (we.isZero() || Ce.isZero()) return new l(0)._forceRed(this);
        var Se = we.mul(Ce), Ne = Se.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), rr = Se.isub(Ne).iushrn(this.shift), er = rr;
        return rr.cmp(this.m) >= 0 ? er = rr.isub(this.m) : rr.cmpn(0) < 0 && (er = rr.iadd(this.m)), er._forceRed(this);
      }, He.prototype.invm = function(we) {
        var Ce = this.imod(we._invmp(this.m).mul(this.r2));
        return Ce._forceRed(this);
      };
    })(s, bn$2);
  }(bn$3)), bn$3.exports;
}
var brorand = { exports: {} }, hasRequiredBrorand;
function requireBrorand() {
  if (hasRequiredBrorand) return brorand.exports;
  hasRequiredBrorand = 1;
  var s;
  brorand.exports = function(t) {
    return s || (s = new A(null)), s.generate(t);
  };
  function A(p) {
    this.rand = p;
  }
  if (brorand.exports.Rand = A, A.prototype.generate = function(t) {
    return this._rand(t);
  }, A.prototype._rand = function(t) {
    if (this.rand.getBytes)
      return this.rand.getBytes(t);
    for (var l = new Uint8Array(t), m = 0; m < l.length; m++)
      l[m] = this.rand.getByte();
    return l;
  }, typeof self == "object")
    self.crypto && self.crypto.getRandomValues ? A.prototype._rand = function(t) {
      var l = new Uint8Array(t);
      return self.crypto.getRandomValues(l), l;
    } : self.msCrypto && self.msCrypto.getRandomValues ? A.prototype._rand = function(t) {
      var l = new Uint8Array(t);
      return self.msCrypto.getRandomValues(l), l;
    } : typeof window == "object" && (A.prototype._rand = function() {
      throw new Error("Not implemented yet");
    });
  else
    try {
      var u = requireCryptoBrowserify();
      if (typeof u.randomBytes != "function")
        throw new Error("Not supported");
      A.prototype._rand = function(t) {
        return u.randomBytes(t);
      };
    } catch {
    }
  return brorand.exports;
}
var mr, hasRequiredMr;
function requireMr() {
  if (hasRequiredMr) return mr;
  hasRequiredMr = 1;
  var s = requireBn$1(), A = requireBrorand();
  function u(p) {
    this.rand = p || new A.Rand();
  }
  return mr = u, u.create = function(t) {
    return new u(t);
  }, u.prototype._randbelow = function(t) {
    var l = t.bitLength(), m = Math.ceil(l / 8);
    do
      var b = new s(this.rand.generate(m));
    while (b.cmp(t) >= 0);
    return b;
  }, u.prototype._randrange = function(t, l) {
    var m = l.sub(t);
    return t.add(this._randbelow(m));
  }, u.prototype.test = function(t, l, m) {
    var b = t.bitLength(), k = s.mont(t), C = new s(1).toRed(k);
    l || (l = Math.max(1, b / 48 | 0));
    for (var B = t.subn(1), Q = 0; !B.testn(Q); Q++)
      ;
    for (var P = t.shrn(Q), x = B.toRed(k), M = !0; l > 0; l--) {
      var F = this._randrange(new s(2), B);
      m && m(F);
      var le = F.toRed(k).redPow(P);
      if (!(le.cmp(C) === 0 || le.cmp(x) === 0)) {
        for (var ge = 1; ge < Q; ge++) {
          if (le = le.redSqr(), le.cmp(C) === 0)
            return !1;
          if (le.cmp(x) === 0)
            break;
        }
        if (ge === Q)
          return !1;
      }
    }
    return M;
  }, u.prototype.getDivisor = function(t, l) {
    var m = t.bitLength(), b = s.mont(t), k = new s(1).toRed(b);
    l || (l = Math.max(1, m / 48 | 0));
    for (var C = t.subn(1), B = 0; !C.testn(B); B++)
      ;
    for (var Q = t.shrn(B), P = C.toRed(b); l > 0; l--) {
      var x = this._randrange(new s(2), C), M = t.gcd(x);
      if (M.cmpn(1) !== 0)
        return M;
      var F = x.toRed(b).redPow(Q);
      if (!(F.cmp(k) === 0 || F.cmp(P) === 0)) {
        for (var le = 1; le < B; le++) {
          if (F = F.redSqr(), F.cmp(k) === 0)
            return F.fromRed().subn(1).gcd(t);
          if (F.cmp(P) === 0)
            break;
        }
        if (le === B)
          return F = F.redSqr(), F.fromRed().subn(1).gcd(t);
      }
    }
    return !1;
  }, mr;
}
var generatePrime, hasRequiredGeneratePrime;
function requireGeneratePrime() {
  if (hasRequiredGeneratePrime) return generatePrime;
  hasRequiredGeneratePrime = 1;
  var s = requireBrowser$9();
  generatePrime = le, le.simpleSieve = M, le.fermatTest = F;
  var A = requireBn$1(), u = new A(24), p = requireMr(), t = new p(), l = new A(1), m = new A(2), b = new A(5);
  new A(16), new A(8);
  var k = new A(10), C = new A(3);
  new A(7);
  var B = new A(11), Q = new A(4);
  new A(12);
  var P = null;
  function x() {
    if (P !== null)
      return P;
    var ge = 1048576, pe = [];
    pe[0] = 2;
    for (var Ie = 1, be = 3; be < ge; be += 2) {
      for (var Pe = Math.ceil(Math.sqrt(be)), Te = 0; Te < Ie && pe[Te] <= Pe && be % pe[Te] !== 0; Te++)
        ;
      Ie !== Te && pe[Te] <= Pe || (pe[Ie++] = be);
    }
    return P = pe, pe;
  }
  function M(ge) {
    for (var pe = x(), Ie = 0; Ie < pe.length; Ie++)
      if (ge.modn(pe[Ie]) === 0)
        return ge.cmpn(pe[Ie]) === 0;
    return !0;
  }
  function F(ge) {
    var pe = A.mont(ge);
    return m.toRed(pe).redPow(ge.subn(1)).fromRed().cmpn(1) === 0;
  }
  function le(ge, pe) {
    if (ge < 16)
      return pe === 2 || pe === 5 ? new A([140, 123]) : new A([140, 39]);
    pe = new A(pe);
    for (var Ie, be; ; ) {
      for (Ie = new A(s(Math.ceil(ge / 8))); Ie.bitLength() > ge; )
        Ie.ishrn(1);
      if (Ie.isEven() && Ie.iadd(l), Ie.testn(1) || Ie.iadd(m), pe.cmp(m)) {
        if (!pe.cmp(b))
          for (; Ie.mod(k).cmp(C); )
            Ie.iadd(Q);
      } else for (; Ie.mod(u).cmp(B); )
        Ie.iadd(Q);
      if (be = Ie.shrn(1), M(be) && M(Ie) && F(be) && F(Ie) && t.test(be) && t.test(Ie))
        return Ie;
    }
  }
  return generatePrime;
}
const modp1 = { gen: "02", prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff" }, modp2 = { gen: "02", prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff" }, modp5 = { gen: "02", prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff" }, modp14 = { gen: "02", prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff" }, modp15 = { gen: "02", prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff" }, modp16 = { gen: "02", prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff" }, modp17 = { gen: "02", prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff" }, modp18 = { gen: "02", prime: "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" }, require$$1$1 = {
  modp1,
  modp2,
  modp5,
  modp14,
  modp15,
  modp16,
  modp17,
  modp18
};
var dh, hasRequiredDh;
function requireDh() {
  if (hasRequiredDh) return dh;
  hasRequiredDh = 1;
  var s = requireBn$1(), A = requireMr(), u = new A(), p = new s(24), t = new s(11), l = new s(10), m = new s(3), b = new s(7), k = requireGeneratePrime(), C = requireBrowser$9();
  dh = M;
  function B(le, ge) {
    return ge = ge || "utf8", Buffer.isBuffer(le) || (le = new Buffer(le, ge)), this._pub = new s(le), this;
  }
  function Q(le, ge) {
    return ge = ge || "utf8", Buffer.isBuffer(le) || (le = new Buffer(le, ge)), this._priv = new s(le), this;
  }
  var P = {};
  function x(le, ge) {
    var pe = ge.toString("hex"), Ie = [pe, le.toString(16)].join("_");
    if (Ie in P)
      return P[Ie];
    var be = 0;
    if (le.isEven() || !k.simpleSieve || !k.fermatTest(le) || !u.test(le))
      return be += 1, pe === "02" || pe === "05" ? be += 8 : be += 4, P[Ie] = be, be;
    u.test(le.shrn(1)) || (be += 2);
    var Pe;
    switch (pe) {
      case "02":
        le.mod(p).cmp(t) && (be += 8);
        break;
      case "05":
        Pe = le.mod(l), Pe.cmp(m) && Pe.cmp(b) && (be += 8);
        break;
      default:
        be += 4;
    }
    return P[Ie] = be, be;
  }
  function M(le, ge, pe) {
    this.setGenerator(ge), this.__prime = new s(le), this._prime = s.mont(this.__prime), this._primeLen = le.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, pe ? (this.setPublicKey = B, this.setPrivateKey = Q) : this._primeCode = 8;
  }
  Object.defineProperty(M.prototype, "verifyError", {
    enumerable: !0,
    get: function() {
      return typeof this._primeCode != "number" && (this._primeCode = x(this.__prime, this.__gen)), this._primeCode;
    }
  }), M.prototype.generateKeys = function() {
    return this._priv || (this._priv = new s(C(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
  }, M.prototype.computeSecret = function(le) {
    le = new s(le), le = le.toRed(this._prime);
    var ge = le.redPow(this._priv).fromRed(), pe = new Buffer(ge.toArray()), Ie = this.getPrime();
    if (pe.length < Ie.length) {
      var be = new Buffer(Ie.length - pe.length);
      be.fill(0), pe = Buffer.concat([be, pe]);
    }
    return pe;
  }, M.prototype.getPublicKey = function(ge) {
    return F(this._pub, ge);
  }, M.prototype.getPrivateKey = function(ge) {
    return F(this._priv, ge);
  }, M.prototype.getPrime = function(le) {
    return F(this.__prime, le);
  }, M.prototype.getGenerator = function(le) {
    return F(this._gen, le);
  }, M.prototype.setGenerator = function(le, ge) {
    return ge = ge || "utf8", Buffer.isBuffer(le) || (le = new Buffer(le, ge)), this.__gen = le, this._gen = new s(le), this;
  };
  function F(le, ge) {
    var pe = new Buffer(le.toArray());
    return ge ? pe.toString(ge) : pe;
  }
  return dh;
}
var hasRequiredBrowser$4;
function requireBrowser$4() {
  if (hasRequiredBrowser$4) return browser$4;
  hasRequiredBrowser$4 = 1;
  var s = requireGeneratePrime(), A = require$$1$1, u = requireDh();
  function p(m) {
    var b = new Buffer(A[m].prime, "hex"), k = new Buffer(A[m].gen, "hex");
    return new u(b, k);
  }
  var t = {
    binary: !0,
    hex: !0,
    base64: !0
  };
  function l(m, b, k, C) {
    return Buffer.isBuffer(b) || t[b] === void 0 ? l(m, "binary", b, k) : (b = b || "binary", C = C || "binary", k = k || new Buffer([2]), Buffer.isBuffer(k) || (k = new Buffer(k, C)), typeof m == "number" ? new u(s(m, k), k, !0) : (Buffer.isBuffer(m) || (m = new Buffer(m, b)), new u(m, k, !0)));
  }
  return browser$4.DiffieHellmanGroup = browser$4.createDiffieHellmanGroup = browser$4.getDiffieHellman = p, browser$4.createDiffieHellman = browser$4.DiffieHellman = l, browser$4;
}
var readableBrowser = { exports: {} }, processNextickArgs = { exports: {} }, hasRequiredProcessNextickArgs;
function requireProcessNextickArgs() {
  if (hasRequiredProcessNextickArgs) return processNextickArgs.exports;
  hasRequiredProcessNextickArgs = 1, typeof process$1 > "u" || !process$1.version || process$1.version.indexOf("v0.") === 0 || process$1.version.indexOf("v1.") === 0 && process$1.version.indexOf("v1.8.") !== 0 ? processNextickArgs.exports = { nextTick: s } : processNextickArgs.exports = process$1;
  function s(A, u, p, t) {
    if (typeof A != "function")
      throw new TypeError('"callback" argument must be a function');
    var l = arguments.length, m, b;
    switch (l) {
      case 0:
      case 1:
        return process$1.nextTick(A);
      case 2:
        return process$1.nextTick(function() {
          A.call(null, u);
        });
      case 3:
        return process$1.nextTick(function() {
          A.call(null, u, p);
        });
      case 4:
        return process$1.nextTick(function() {
          A.call(null, u, p, t);
        });
      default:
        for (m = new Array(l - 1), b = 0; b < m.length; )
          m[b++] = arguments[b];
        return process$1.nextTick(function() {
          A.apply(null, m);
        });
    }
  }
  return processNextickArgs.exports;
}
var isarray, hasRequiredIsarray;
function requireIsarray() {
  if (hasRequiredIsarray) return isarray;
  hasRequiredIsarray = 1;
  var s = {}.toString;
  return isarray = Array.isArray || function(A) {
    return s.call(A) == "[object Array]";
  }, isarray;
}
var streamBrowser, hasRequiredStreamBrowser;
function requireStreamBrowser() {
  return hasRequiredStreamBrowser || (hasRequiredStreamBrowser = 1, streamBrowser = requireEvents().EventEmitter), streamBrowser;
}
var safeBuffer = { exports: {} }, hasRequiredSafeBuffer;
function requireSafeBuffer() {
  return hasRequiredSafeBuffer || (hasRequiredSafeBuffer = 1, function(s, A) {
    var u = requireDist$n(), p = u.Buffer;
    function t(m, b) {
      for (var k in m)
        b[k] = m[k];
    }
    p.from && p.alloc && p.allocUnsafe && p.allocUnsafeSlow ? s.exports = u : (t(u, A), A.Buffer = l);
    function l(m, b, k) {
      return p(m, b, k);
    }
    t(p, l), l.from = function(m, b, k) {
      if (typeof m == "number")
        throw new TypeError("Argument must not be a number");
      return p(m, b, k);
    }, l.alloc = function(m, b, k) {
      if (typeof m != "number")
        throw new TypeError("Argument must be a number");
      var C = p(m);
      return b !== void 0 ? typeof k == "string" ? C.fill(b, k) : C.fill(b) : C.fill(0), C;
    }, l.allocUnsafe = function(m) {
      if (typeof m != "number")
        throw new TypeError("Argument must be a number");
      return p(m);
    }, l.allocUnsafeSlow = function(m) {
      if (typeof m != "number")
        throw new TypeError("Argument must be a number");
      return u.SlowBuffer(m);
    };
  }(safeBuffer, safeBuffer.exports)), safeBuffer.exports;
}
var util = {}, hasRequiredUtil;
function requireUtil() {
  if (hasRequiredUtil) return util;
  hasRequiredUtil = 1;
  function s(F) {
    return Array.isArray ? Array.isArray(F) : M(F) === "[object Array]";
  }
  util.isArray = s;
  function A(F) {
    return typeof F == "boolean";
  }
  util.isBoolean = A;
  function u(F) {
    return F === null;
  }
  util.isNull = u;
  function p(F) {
    return F == null;
  }
  util.isNullOrUndefined = p;
  function t(F) {
    return typeof F == "number";
  }
  util.isNumber = t;
  function l(F) {
    return typeof F == "string";
  }
  util.isString = l;
  function m(F) {
    return typeof F == "symbol";
  }
  util.isSymbol = m;
  function b(F) {
    return F === void 0;
  }
  util.isUndefined = b;
  function k(F) {
    return M(F) === "[object RegExp]";
  }
  util.isRegExp = k;
  function C(F) {
    return typeof F == "object" && F !== null;
  }
  util.isObject = C;
  function B(F) {
    return M(F) === "[object Date]";
  }
  util.isDate = B;
  function Q(F) {
    return M(F) === "[object Error]" || F instanceof Error;
  }
  util.isError = Q;
  function P(F) {
    return typeof F == "function";
  }
  util.isFunction = P;
  function x(F) {
    return F === null || typeof F == "boolean" || typeof F == "number" || typeof F == "string" || typeof F == "symbol" || // ES6 symbol
    typeof F > "u";
  }
  util.isPrimitive = x, util.isBuffer = requireDist$n().Buffer.isBuffer;
  function M(F) {
    return Object.prototype.toString.call(F);
  }
  return util;
}
var BufferList = { exports: {} }, hasRequiredBufferList;
function requireBufferList() {
  return hasRequiredBufferList || (hasRequiredBufferList = 1, function(s) {
    function A(l, m) {
      if (!(l instanceof m))
        throw new TypeError("Cannot call a class as a function");
    }
    var u = requireSafeBuffer().Buffer, p = requireUtil$1();
    function t(l, m, b) {
      l.copy(m, b);
    }
    s.exports = function() {
      function l() {
        A(this, l), this.head = null, this.tail = null, this.length = 0;
      }
      return l.prototype.push = function(b) {
        var k = { data: b, next: null };
        this.length > 0 ? this.tail.next = k : this.head = k, this.tail = k, ++this.length;
      }, l.prototype.unshift = function(b) {
        var k = { data: b, next: this.head };
        this.length === 0 && (this.tail = k), this.head = k, ++this.length;
      }, l.prototype.shift = function() {
        if (this.length !== 0) {
          var b = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, b;
        }
      }, l.prototype.clear = function() {
        this.head = this.tail = null, this.length = 0;
      }, l.prototype.join = function(b) {
        if (this.length === 0) return "";
        for (var k = this.head, C = "" + k.data; k = k.next; )
          C += b + k.data;
        return C;
      }, l.prototype.concat = function(b) {
        if (this.length === 0) return u.alloc(0);
        for (var k = u.allocUnsafe(b >>> 0), C = this.head, B = 0; C; )
          t(C.data, k, B), B += C.data.length, C = C.next;
        return k;
      }, l;
    }(), p && p.inspect && p.inspect.custom && (s.exports.prototype[p.inspect.custom] = function() {
      var l = p.inspect({ length: this.length });
      return this.constructor.name + " " + l;
    });
  }(BufferList)), BufferList.exports;
}
var destroy_1, hasRequiredDestroy;
function requireDestroy() {
  if (hasRequiredDestroy) return destroy_1;
  hasRequiredDestroy = 1;
  var s = requireProcessNextickArgs();
  function A(t, l) {
    var m = this, b = this._readableState && this._readableState.destroyed, k = this._writableState && this._writableState.destroyed;
    return b || k ? (l ? l(t) : t && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, s.nextTick(p, this, t)) : s.nextTick(p, this, t)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function(C) {
      !l && C ? m._writableState ? m._writableState.errorEmitted || (m._writableState.errorEmitted = !0, s.nextTick(p, m, C)) : s.nextTick(p, m, C) : l && l(C);
    }), this);
  }
  function u() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function p(t, l) {
    t.emit("error", l);
  }
  return destroy_1 = {
    destroy: A,
    undestroy: u
  }, destroy_1;
}
var _stream_writable, hasRequired_stream_writable;
function require_stream_writable() {
  if (hasRequired_stream_writable) return _stream_writable;
  hasRequired_stream_writable = 1;
  var s = requireProcessNextickArgs();
  _stream_writable = F;
  function A(er) {
    var ir = this;
    this.next = null, this.entry = null, this.finish = function() {
      rr(ir, er);
    };
  }
  var u = !process$1.browser && ["v0.10", "v0.9."].indexOf(process$1.version.slice(0, 5)) > -1 ? setImmediate : s.nextTick, p;
  F.WritableState = x;
  var t = Object.create(requireUtil());
  t.inherits = requireInherits_browser();
  var l = {
    deprecate: requireBrowser$b()
  }, m = requireStreamBrowser(), b = requireSafeBuffer().Buffer, k = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function C(er) {
    return b.from(er);
  }
  function B(er) {
    return b.isBuffer(er) || er instanceof k;
  }
  var Q = requireDestroy();
  t.inherits(F, m);
  function P() {
  }
  function x(er, ir) {
    p = p || require_stream_duplex(), er = er || {};
    var sr = ir instanceof p;
    this.objectMode = !!er.objectMode, sr && (this.objectMode = this.objectMode || !!er.writableObjectMode);
    var nr = er.highWaterMark, fr = er.writableHighWaterMark, lr = this.objectMode ? 16 : 16 * 1024;
    nr || nr === 0 ? this.highWaterMark = nr : sr && (fr || fr === 0) ? this.highWaterMark = fr : this.highWaterMark = lr, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var br = er.decodeStrings === !1;
    this.decodeStrings = !br, this.defaultEncoding = er.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(Br) {
      Qe(ir, Br);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new A(this);
  }
  x.prototype.getBuffer = function() {
    for (var ir = this.bufferedRequest, sr = []; ir; )
      sr.push(ir), ir = ir.next;
    return sr;
  }, function() {
    try {
      Object.defineProperty(x.prototype, "buffer", {
        get: l.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var M;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (M = Function.prototype[Symbol.hasInstance], Object.defineProperty(F, Symbol.hasInstance, {
    value: function(er) {
      return M.call(this, er) ? !0 : this !== F ? !1 : er && er._writableState instanceof x;
    }
  })) : M = function(er) {
    return er instanceof this;
  };
  function F(er) {
    if (p = p || require_stream_duplex(), !M.call(F, this) && !(this instanceof p))
      return new F(er);
    this._writableState = new x(er, this), this.writable = !0, er && (typeof er.write == "function" && (this._write = er.write), typeof er.writev == "function" && (this._writev = er.writev), typeof er.destroy == "function" && (this._destroy = er.destroy), typeof er.final == "function" && (this._final = er.final)), m.call(this);
  }
  F.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
  };
  function le(er, ir) {
    var sr = new Error("write after end");
    er.emit("error", sr), s.nextTick(ir, sr);
  }
  function ge(er, ir, sr, nr) {
    var fr = !0, lr = !1;
    return sr === null ? lr = new TypeError("May not write null values to stream") : typeof sr != "string" && sr !== void 0 && !ir.objectMode && (lr = new TypeError("Invalid non-string/buffer chunk")), lr && (er.emit("error", lr), s.nextTick(nr, lr), fr = !1), fr;
  }
  F.prototype.write = function(er, ir, sr) {
    var nr = this._writableState, fr = !1, lr = !nr.objectMode && B(er);
    return lr && !b.isBuffer(er) && (er = C(er)), typeof ir == "function" && (sr = ir, ir = null), lr ? ir = "buffer" : ir || (ir = nr.defaultEncoding), typeof sr != "function" && (sr = P), nr.ended ? le(this, sr) : (lr || ge(this, nr, er, sr)) && (nr.pendingcb++, fr = Ie(this, nr, lr, er, ir, sr)), fr;
  }, F.prototype.cork = function() {
    var er = this._writableState;
    er.corked++;
  }, F.prototype.uncork = function() {
    var er = this._writableState;
    er.corked && (er.corked--, !er.writing && !er.corked && !er.bufferProcessing && er.bufferedRequest && He(this, er));
  }, F.prototype.setDefaultEncoding = function(ir) {
    if (typeof ir == "string" && (ir = ir.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((ir + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + ir);
    return this._writableState.defaultEncoding = ir, this;
  };
  function pe(er, ir, sr) {
    return !er.objectMode && er.decodeStrings !== !1 && typeof ir == "string" && (ir = b.from(ir, sr)), ir;
  }
  Object.defineProperty(F.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function Ie(er, ir, sr, nr, fr, lr) {
    if (!sr) {
      var br = pe(ir, nr, fr);
      nr !== br && (sr = !0, fr = "buffer", nr = br);
    }
    var Br = ir.objectMode ? 1 : nr.length;
    ir.length += Br;
    var Fr = ir.length < ir.highWaterMark;
    if (Fr || (ir.needDrain = !0), ir.writing || ir.corked) {
      var Gr = ir.lastBufferedRequest;
      ir.lastBufferedRequest = {
        chunk: nr,
        encoding: fr,
        isBuf: sr,
        callback: lr,
        next: null
      }, Gr ? Gr.next = ir.lastBufferedRequest : ir.bufferedRequest = ir.lastBufferedRequest, ir.bufferedRequestCount += 1;
    } else
      be(er, ir, !1, Br, nr, fr, lr);
    return Fr;
  }
  function be(er, ir, sr, nr, fr, lr, br) {
    ir.writelen = nr, ir.writecb = br, ir.writing = !0, ir.sync = !0, sr ? er._writev(fr, ir.onwrite) : er._write(fr, lr, ir.onwrite), ir.sync = !1;
  }
  function Pe(er, ir, sr, nr, fr) {
    --ir.pendingcb, sr ? (s.nextTick(fr, nr), s.nextTick(Se, er, ir), er._writableState.errorEmitted = !0, er.emit("error", nr)) : (fr(nr), er._writableState.errorEmitted = !0, er.emit("error", nr), Se(er, ir));
  }
  function Te(er) {
    er.writing = !1, er.writecb = null, er.length -= er.writelen, er.writelen = 0;
  }
  function Qe(er, ir) {
    var sr = er._writableState, nr = sr.sync, fr = sr.writecb;
    if (Te(sr), ir) Pe(er, sr, nr, ir, fr);
    else {
      var lr = ve(sr);
      !lr && !sr.corked && !sr.bufferProcessing && sr.bufferedRequest && He(er, sr), nr ? u(xe, er, sr, lr, fr) : xe(er, sr, lr, fr);
    }
  }
  function xe(er, ir, sr, nr) {
    sr || Ee(er, ir), ir.pendingcb--, nr(), Se(er, ir);
  }
  function Ee(er, ir) {
    ir.length === 0 && ir.needDrain && (ir.needDrain = !1, er.emit("drain"));
  }
  function He(er, ir) {
    ir.bufferProcessing = !0;
    var sr = ir.bufferedRequest;
    if (er._writev && sr && sr.next) {
      var nr = ir.bufferedRequestCount, fr = new Array(nr), lr = ir.corkedRequestsFree;
      lr.entry = sr;
      for (var br = 0, Br = !0; sr; )
        fr[br] = sr, sr.isBuf || (Br = !1), sr = sr.next, br += 1;
      fr.allBuffers = Br, be(er, ir, !0, ir.length, fr, "", lr.finish), ir.pendingcb++, ir.lastBufferedRequest = null, lr.next ? (ir.corkedRequestsFree = lr.next, lr.next = null) : ir.corkedRequestsFree = new A(ir), ir.bufferedRequestCount = 0;
    } else {
      for (; sr; ) {
        var Fr = sr.chunk, Gr = sr.encoding, qr = sr.callback, Hr = ir.objectMode ? 1 : Fr.length;
        if (be(er, ir, !1, Hr, Fr, Gr, qr), sr = sr.next, ir.bufferedRequestCount--, ir.writing)
          break;
      }
      sr === null && (ir.lastBufferedRequest = null);
    }
    ir.bufferedRequest = sr, ir.bufferProcessing = !1;
  }
  F.prototype._write = function(er, ir, sr) {
    sr(new Error("_write() is not implemented"));
  }, F.prototype._writev = null, F.prototype.end = function(er, ir, sr) {
    var nr = this._writableState;
    typeof er == "function" ? (sr = er, er = null, ir = null) : typeof ir == "function" && (sr = ir, ir = null), er != null && this.write(er, ir), nr.corked && (nr.corked = 1, this.uncork()), nr.ending || Ne(this, nr, sr);
  };
  function ve(er) {
    return er.ending && er.length === 0 && er.bufferedRequest === null && !er.finished && !er.writing;
  }
  function we(er, ir) {
    er._final(function(sr) {
      ir.pendingcb--, sr && er.emit("error", sr), ir.prefinished = !0, er.emit("prefinish"), Se(er, ir);
    });
  }
  function Ce(er, ir) {
    !ir.prefinished && !ir.finalCalled && (typeof er._final == "function" ? (ir.pendingcb++, ir.finalCalled = !0, s.nextTick(we, er, ir)) : (ir.prefinished = !0, er.emit("prefinish")));
  }
  function Se(er, ir) {
    var sr = ve(ir);
    return sr && (Ce(er, ir), ir.pendingcb === 0 && (ir.finished = !0, er.emit("finish"))), sr;
  }
  function Ne(er, ir, sr) {
    ir.ending = !0, Se(er, ir), sr && (ir.finished ? s.nextTick(sr) : er.once("finish", sr)), ir.ended = !0, er.writable = !1;
  }
  function rr(er, ir, sr) {
    var nr = er.entry;
    for (er.entry = null; nr; ) {
      var fr = nr.callback;
      ir.pendingcb--, fr(sr), nr = nr.next;
    }
    ir.corkedRequestsFree.next = er;
  }
  return Object.defineProperty(F.prototype, "destroyed", {
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(er) {
      this._writableState && (this._writableState.destroyed = er);
    }
  }), F.prototype.destroy = Q.destroy, F.prototype._undestroy = Q.undestroy, F.prototype._destroy = function(er, ir) {
    this.end(), ir(er);
  }, _stream_writable;
}
var _stream_duplex, hasRequired_stream_duplex;
function require_stream_duplex() {
  if (hasRequired_stream_duplex) return _stream_duplex;
  hasRequired_stream_duplex = 1;
  var s = requireProcessNextickArgs(), A = Object.keys || function(Q) {
    var P = [];
    for (var x in Q)
      P.push(x);
    return P;
  };
  _stream_duplex = k;
  var u = Object.create(requireUtil());
  u.inherits = requireInherits_browser();
  var p = require_stream_readable(), t = require_stream_writable();
  u.inherits(k, p);
  for (var l = A(t.prototype), m = 0; m < l.length; m++) {
    var b = l[m];
    k.prototype[b] || (k.prototype[b] = t.prototype[b]);
  }
  function k(Q) {
    if (!(this instanceof k)) return new k(Q);
    p.call(this, Q), t.call(this, Q), Q && Q.readable === !1 && (this.readable = !1), Q && Q.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, Q && Q.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", C);
  }
  Object.defineProperty(k.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function C() {
    this.allowHalfOpen || this._writableState.ended || s.nextTick(B, this);
  }
  function B(Q) {
    Q.end();
  }
  return Object.defineProperty(k.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(Q) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = Q, this._writableState.destroyed = Q);
    }
  }), k.prototype._destroy = function(Q, P) {
    this.push(null), this.end(), s.nextTick(P, Q);
  }, _stream_duplex;
}
var _stream_readable, hasRequired_stream_readable;
function require_stream_readable() {
  if (hasRequired_stream_readable) return _stream_readable;
  hasRequired_stream_readable = 1;
  var s = requireProcessNextickArgs();
  _stream_readable = pe;
  var A = requireIsarray(), u;
  pe.ReadableState = ge, requireEvents().EventEmitter;
  var p = function(qr, Hr) {
    return qr.listeners(Hr).length;
  }, t = requireStreamBrowser(), l = requireSafeBuffer().Buffer, m = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function b(qr) {
    return l.from(qr);
  }
  function k(qr) {
    return l.isBuffer(qr) || qr instanceof m;
  }
  var C = Object.create(requireUtil());
  C.inherits = requireInherits_browser();
  var B = requireUtil$1(), Q = void 0;
  B && B.debuglog ? Q = B.debuglog("stream") : Q = function() {
  };
  var P = requireBufferList(), x = requireDestroy(), M;
  C.inherits(pe, t);
  var F = ["error", "close", "destroy", "pause", "resume"];
  function le(qr, Hr, un) {
    if (typeof qr.prependListener == "function") return qr.prependListener(Hr, un);
    !qr._events || !qr._events[Hr] ? qr.on(Hr, un) : A(qr._events[Hr]) ? qr._events[Hr].unshift(un) : qr._events[Hr] = [un, qr._events[Hr]];
  }
  function ge(qr, Hr) {
    u = u || require_stream_duplex(), qr = qr || {};
    var un = Hr instanceof u;
    this.objectMode = !!qr.objectMode, un && (this.objectMode = this.objectMode || !!qr.readableObjectMode);
    var Dr = qr.highWaterMark, wr = qr.readableHighWaterMark, yr = this.objectMode ? 16 : 16 * 1024;
    Dr || Dr === 0 ? this.highWaterMark = Dr : un && (wr || wr === 0) ? this.highWaterMark = wr : this.highWaterMark = yr, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new P(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = qr.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, qr.encoding && (M || (M = requireString_decoder().StringDecoder), this.decoder = new M(qr.encoding), this.encoding = qr.encoding);
  }
  function pe(qr) {
    if (u = u || require_stream_duplex(), !(this instanceof pe)) return new pe(qr);
    this._readableState = new ge(qr, this), this.readable = !0, qr && (typeof qr.read == "function" && (this._read = qr.read), typeof qr.destroy == "function" && (this._destroy = qr.destroy)), t.call(this);
  }
  Object.defineProperty(pe.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(qr) {
      this._readableState && (this._readableState.destroyed = qr);
    }
  }), pe.prototype.destroy = x.destroy, pe.prototype._undestroy = x.undestroy, pe.prototype._destroy = function(qr, Hr) {
    this.push(null), Hr(qr);
  }, pe.prototype.push = function(qr, Hr) {
    var un = this._readableState, Dr;
    return un.objectMode ? Dr = !0 : typeof qr == "string" && (Hr = Hr || un.defaultEncoding, Hr !== un.encoding && (qr = l.from(qr, Hr), Hr = ""), Dr = !0), Ie(this, qr, Hr, !1, Dr);
  }, pe.prototype.unshift = function(qr) {
    return Ie(this, qr, null, !0, !1);
  };
  function Ie(qr, Hr, un, Dr, wr) {
    var yr = qr._readableState;
    if (Hr === null)
      yr.reading = !1, He(qr, yr);
    else {
      var Qr;
      wr || (Qr = Pe(yr, Hr)), Qr ? qr.emit("error", Qr) : yr.objectMode || Hr && Hr.length > 0 ? (typeof Hr != "string" && !yr.objectMode && Object.getPrototypeOf(Hr) !== l.prototype && (Hr = b(Hr)), Dr ? yr.endEmitted ? qr.emit("error", new Error("stream.unshift() after end event")) : be(qr, yr, Hr, !0) : yr.ended ? qr.emit("error", new Error("stream.push() after EOF")) : (yr.reading = !1, yr.decoder && !un ? (Hr = yr.decoder.write(Hr), yr.objectMode || Hr.length !== 0 ? be(qr, yr, Hr, !1) : Ce(qr, yr)) : be(qr, yr, Hr, !1))) : Dr || (yr.reading = !1);
    }
    return Te(yr);
  }
  function be(qr, Hr, un, Dr) {
    Hr.flowing && Hr.length === 0 && !Hr.sync ? (qr.emit("data", un), qr.read(0)) : (Hr.length += Hr.objectMode ? 1 : un.length, Dr ? Hr.buffer.unshift(un) : Hr.buffer.push(un), Hr.needReadable && ve(qr)), Ce(qr, Hr);
  }
  function Pe(qr, Hr) {
    var un;
    return !k(Hr) && typeof Hr != "string" && Hr !== void 0 && !qr.objectMode && (un = new TypeError("Invalid non-string/buffer chunk")), un;
  }
  function Te(qr) {
    return !qr.ended && (qr.needReadable || qr.length < qr.highWaterMark || qr.length === 0);
  }
  pe.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, pe.prototype.setEncoding = function(qr) {
    return M || (M = requireString_decoder().StringDecoder), this._readableState.decoder = new M(qr), this._readableState.encoding = qr, this;
  };
  var Qe = 8388608;
  function xe(qr) {
    return qr >= Qe ? qr = Qe : (qr--, qr |= qr >>> 1, qr |= qr >>> 2, qr |= qr >>> 4, qr |= qr >>> 8, qr |= qr >>> 16, qr++), qr;
  }
  function Ee(qr, Hr) {
    return qr <= 0 || Hr.length === 0 && Hr.ended ? 0 : Hr.objectMode ? 1 : qr !== qr ? Hr.flowing && Hr.length ? Hr.buffer.head.data.length : Hr.length : (qr > Hr.highWaterMark && (Hr.highWaterMark = xe(qr)), qr <= Hr.length ? qr : Hr.ended ? Hr.length : (Hr.needReadable = !0, 0));
  }
  pe.prototype.read = function(qr) {
    Q("read", qr), qr = parseInt(qr, 10);
    var Hr = this._readableState, un = qr;
    if (qr !== 0 && (Hr.emittedReadable = !1), qr === 0 && Hr.needReadable && (Hr.length >= Hr.highWaterMark || Hr.ended))
      return Q("read: emitReadable", Hr.length, Hr.ended), Hr.length === 0 && Hr.ended ? Br(this) : ve(this), null;
    if (qr = Ee(qr, Hr), qr === 0 && Hr.ended)
      return Hr.length === 0 && Br(this), null;
    var Dr = Hr.needReadable;
    Q("need readable", Dr), (Hr.length === 0 || Hr.length - qr < Hr.highWaterMark) && (Dr = !0, Q("length less than watermark", Dr)), Hr.ended || Hr.reading ? (Dr = !1, Q("reading or ended", Dr)) : Dr && (Q("do read"), Hr.reading = !0, Hr.sync = !0, Hr.length === 0 && (Hr.needReadable = !0), this._read(Hr.highWaterMark), Hr.sync = !1, Hr.reading || (qr = Ee(un, Hr)));
    var wr;
    return qr > 0 ? wr = nr(qr, Hr) : wr = null, wr === null ? (Hr.needReadable = !0, qr = 0) : Hr.length -= qr, Hr.length === 0 && (Hr.ended || (Hr.needReadable = !0), un !== qr && Hr.ended && Br(this)), wr !== null && this.emit("data", wr), wr;
  };
  function He(qr, Hr) {
    if (!Hr.ended) {
      if (Hr.decoder) {
        var un = Hr.decoder.end();
        un && un.length && (Hr.buffer.push(un), Hr.length += Hr.objectMode ? 1 : un.length);
      }
      Hr.ended = !0, ve(qr);
    }
  }
  function ve(qr) {
    var Hr = qr._readableState;
    Hr.needReadable = !1, Hr.emittedReadable || (Q("emitReadable", Hr.flowing), Hr.emittedReadable = !0, Hr.sync ? s.nextTick(we, qr) : we(qr));
  }
  function we(qr) {
    Q("emit readable"), qr.emit("readable"), sr(qr);
  }
  function Ce(qr, Hr) {
    Hr.readingMore || (Hr.readingMore = !0, s.nextTick(Se, qr, Hr));
  }
  function Se(qr, Hr) {
    for (var un = Hr.length; !Hr.reading && !Hr.flowing && !Hr.ended && Hr.length < Hr.highWaterMark && (Q("maybeReadMore read 0"), qr.read(0), un !== Hr.length); )
      un = Hr.length;
    Hr.readingMore = !1;
  }
  pe.prototype._read = function(qr) {
    this.emit("error", new Error("_read() is not implemented"));
  }, pe.prototype.pipe = function(qr, Hr) {
    var un = this, Dr = this._readableState;
    switch (Dr.pipesCount) {
      case 0:
        Dr.pipes = qr;
        break;
      case 1:
        Dr.pipes = [Dr.pipes, qr];
        break;
      default:
        Dr.pipes.push(qr);
        break;
    }
    Dr.pipesCount += 1, Q("pipe count=%d opts=%j", Dr.pipesCount, Hr);
    var wr = (!Hr || Hr.end !== !1) && qr !== process$1.stdout && qr !== process$1.stderr, yr = wr ? _r : Cn;
    Dr.endEmitted ? s.nextTick(yr) : un.once("end", yr), qr.on("unpipe", Qr);
    function Qr(Xr, In) {
      Q("onunpipe"), Xr === un && In && In.hasUnpiped === !1 && (In.hasUnpiped = !0, jr());
    }
    function _r() {
      Q("onend"), qr.end();
    }
    var Jr = Ne(un);
    qr.on("drain", Jr);
    var fn = !1;
    function jr() {
      Q("cleanup"), qr.removeListener("close", si), qr.removeListener("finish", vn), qr.removeListener("drain", Jr), qr.removeListener("error", Yn), qr.removeListener("unpipe", Qr), un.removeListener("end", _r), un.removeListener("end", Cn), un.removeListener("data", Tn), fn = !0, Dr.awaitDrain && (!qr._writableState || qr._writableState.needDrain) && Jr();
    }
    var dn = !1;
    un.on("data", Tn);
    function Tn(Xr) {
      Q("ondata"), dn = !1;
      var In = qr.write(Xr);
      In === !1 && !dn && ((Dr.pipesCount === 1 && Dr.pipes === qr || Dr.pipesCount > 1 && Gr(Dr.pipes, qr) !== -1) && !fn && (Q("false write response, pause", Dr.awaitDrain), Dr.awaitDrain++, dn = !0), un.pause());
    }
    function Yn(Xr) {
      Q("onerror", Xr), Cn(), qr.removeListener("error", Yn), p(qr, "error") === 0 && qr.emit("error", Xr);
    }
    le(qr, "error", Yn);
    function si() {
      qr.removeListener("finish", vn), Cn();
    }
    qr.once("close", si);
    function vn() {
      Q("onfinish"), qr.removeListener("close", si), Cn();
    }
    qr.once("finish", vn);
    function Cn() {
      Q("unpipe"), un.unpipe(qr);
    }
    return qr.emit("pipe", un), Dr.flowing || (Q("pipe resume"), un.resume()), qr;
  };
  function Ne(qr) {
    return function() {
      var Hr = qr._readableState;
      Q("pipeOnDrain", Hr.awaitDrain), Hr.awaitDrain && Hr.awaitDrain--, Hr.awaitDrain === 0 && p(qr, "data") && (Hr.flowing = !0, sr(qr));
    };
  }
  pe.prototype.unpipe = function(qr) {
    var Hr = this._readableState, un = { hasUnpiped: !1 };
    if (Hr.pipesCount === 0) return this;
    if (Hr.pipesCount === 1)
      return qr && qr !== Hr.pipes ? this : (qr || (qr = Hr.pipes), Hr.pipes = null, Hr.pipesCount = 0, Hr.flowing = !1, qr && qr.emit("unpipe", this, un), this);
    if (!qr) {
      var Dr = Hr.pipes, wr = Hr.pipesCount;
      Hr.pipes = null, Hr.pipesCount = 0, Hr.flowing = !1;
      for (var yr = 0; yr < wr; yr++)
        Dr[yr].emit("unpipe", this, { hasUnpiped: !1 });
      return this;
    }
    var Qr = Gr(Hr.pipes, qr);
    return Qr === -1 ? this : (Hr.pipes.splice(Qr, 1), Hr.pipesCount -= 1, Hr.pipesCount === 1 && (Hr.pipes = Hr.pipes[0]), qr.emit("unpipe", this, un), this);
  }, pe.prototype.on = function(qr, Hr) {
    var un = t.prototype.on.call(this, qr, Hr);
    if (qr === "data")
      this._readableState.flowing !== !1 && this.resume();
    else if (qr === "readable") {
      var Dr = this._readableState;
      !Dr.endEmitted && !Dr.readableListening && (Dr.readableListening = Dr.needReadable = !0, Dr.emittedReadable = !1, Dr.reading ? Dr.length && ve(this) : s.nextTick(rr, this));
    }
    return un;
  }, pe.prototype.addListener = pe.prototype.on;
  function rr(qr) {
    Q("readable nexttick read 0"), qr.read(0);
  }
  pe.prototype.resume = function() {
    var qr = this._readableState;
    return qr.flowing || (Q("resume"), qr.flowing = !0, er(this, qr)), this;
  };
  function er(qr, Hr) {
    Hr.resumeScheduled || (Hr.resumeScheduled = !0, s.nextTick(ir, qr, Hr));
  }
  function ir(qr, Hr) {
    Hr.reading || (Q("resume read 0"), qr.read(0)), Hr.resumeScheduled = !1, Hr.awaitDrain = 0, qr.emit("resume"), sr(qr), Hr.flowing && !Hr.reading && qr.read(0);
  }
  pe.prototype.pause = function() {
    return Q("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (Q("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
  };
  function sr(qr) {
    var Hr = qr._readableState;
    for (Q("flow", Hr.flowing); Hr.flowing && qr.read() !== null; )
      ;
  }
  pe.prototype.wrap = function(qr) {
    var Hr = this, un = this._readableState, Dr = !1;
    qr.on("end", function() {
      if (Q("wrapped end"), un.decoder && !un.ended) {
        var Qr = un.decoder.end();
        Qr && Qr.length && Hr.push(Qr);
      }
      Hr.push(null);
    }), qr.on("data", function(Qr) {
      if (Q("wrapped data"), un.decoder && (Qr = un.decoder.write(Qr)), !(un.objectMode && Qr == null) && !(!un.objectMode && (!Qr || !Qr.length))) {
        var _r = Hr.push(Qr);
        _r || (Dr = !0, qr.pause());
      }
    });
    for (var wr in qr)
      this[wr] === void 0 && typeof qr[wr] == "function" && (this[wr] = /* @__PURE__ */ function(Qr) {
        return function() {
          return qr[Qr].apply(qr, arguments);
        };
      }(wr));
    for (var yr = 0; yr < F.length; yr++)
      qr.on(F[yr], this.emit.bind(this, F[yr]));
    return this._read = function(Qr) {
      Q("wrapped _read", Qr), Dr && (Dr = !1, qr.resume());
    }, this;
  }, Object.defineProperty(pe.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), pe._fromList = nr;
  function nr(qr, Hr) {
    if (Hr.length === 0) return null;
    var un;
    return Hr.objectMode ? un = Hr.buffer.shift() : !qr || qr >= Hr.length ? (Hr.decoder ? un = Hr.buffer.join("") : Hr.buffer.length === 1 ? un = Hr.buffer.head.data : un = Hr.buffer.concat(Hr.length), Hr.buffer.clear()) : un = fr(qr, Hr.buffer, Hr.decoder), un;
  }
  function fr(qr, Hr, un) {
    var Dr;
    return qr < Hr.head.data.length ? (Dr = Hr.head.data.slice(0, qr), Hr.head.data = Hr.head.data.slice(qr)) : qr === Hr.head.data.length ? Dr = Hr.shift() : Dr = un ? lr(qr, Hr) : br(qr, Hr), Dr;
  }
  function lr(qr, Hr) {
    var un = Hr.head, Dr = 1, wr = un.data;
    for (qr -= wr.length; un = un.next; ) {
      var yr = un.data, Qr = qr > yr.length ? yr.length : qr;
      if (Qr === yr.length ? wr += yr : wr += yr.slice(0, qr), qr -= Qr, qr === 0) {
        Qr === yr.length ? (++Dr, un.next ? Hr.head = un.next : Hr.head = Hr.tail = null) : (Hr.head = un, un.data = yr.slice(Qr));
        break;
      }
      ++Dr;
    }
    return Hr.length -= Dr, wr;
  }
  function br(qr, Hr) {
    var un = l.allocUnsafe(qr), Dr = Hr.head, wr = 1;
    for (Dr.data.copy(un), qr -= Dr.data.length; Dr = Dr.next; ) {
      var yr = Dr.data, Qr = qr > yr.length ? yr.length : qr;
      if (yr.copy(un, un.length - qr, 0, Qr), qr -= Qr, qr === 0) {
        Qr === yr.length ? (++wr, Dr.next ? Hr.head = Dr.next : Hr.head = Hr.tail = null) : (Hr.head = Dr, Dr.data = yr.slice(Qr));
        break;
      }
      ++wr;
    }
    return Hr.length -= wr, un;
  }
  function Br(qr) {
    var Hr = qr._readableState;
    if (Hr.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    Hr.endEmitted || (Hr.ended = !0, s.nextTick(Fr, Hr, qr));
  }
  function Fr(qr, Hr) {
    !qr.endEmitted && qr.length === 0 && (qr.endEmitted = !0, Hr.readable = !1, Hr.emit("end"));
  }
  function Gr(qr, Hr) {
    for (var un = 0, Dr = qr.length; un < Dr; un++)
      if (qr[un] === Hr) return un;
    return -1;
  }
  return _stream_readable;
}
var _stream_transform, hasRequired_stream_transform;
function require_stream_transform() {
  if (hasRequired_stream_transform) return _stream_transform;
  hasRequired_stream_transform = 1, _stream_transform = p;
  var s = require_stream_duplex(), A = Object.create(requireUtil());
  A.inherits = requireInherits_browser(), A.inherits(p, s);
  function u(m, b) {
    var k = this._transformState;
    k.transforming = !1;
    var C = k.writecb;
    if (!C)
      return this.emit("error", new Error("write callback called multiple times"));
    k.writechunk = null, k.writecb = null, b != null && this.push(b), C(m);
    var B = this._readableState;
    B.reading = !1, (B.needReadable || B.length < B.highWaterMark) && this._read(B.highWaterMark);
  }
  function p(m) {
    if (!(this instanceof p)) return new p(m);
    s.call(this, m), this._transformState = {
      afterTransform: u.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, m && (typeof m.transform == "function" && (this._transform = m.transform), typeof m.flush == "function" && (this._flush = m.flush)), this.on("prefinish", t);
  }
  function t() {
    var m = this;
    typeof this._flush == "function" ? this._flush(function(b, k) {
      l(m, b, k);
    }) : l(this, null, null);
  }
  p.prototype.push = function(m, b) {
    return this._transformState.needTransform = !1, s.prototype.push.call(this, m, b);
  }, p.prototype._transform = function(m, b, k) {
    throw new Error("_transform() is not implemented");
  }, p.prototype._write = function(m, b, k) {
    var C = this._transformState;
    if (C.writecb = k, C.writechunk = m, C.writeencoding = b, !C.transforming) {
      var B = this._readableState;
      (C.needTransform || B.needReadable || B.length < B.highWaterMark) && this._read(B.highWaterMark);
    }
  }, p.prototype._read = function(m) {
    var b = this._transformState;
    b.writechunk !== null && b.writecb && !b.transforming ? (b.transforming = !0, this._transform(b.writechunk, b.writeencoding, b.afterTransform)) : b.needTransform = !0;
  }, p.prototype._destroy = function(m, b) {
    var k = this;
    s.prototype._destroy.call(this, m, function(C) {
      b(C), k.emit("close");
    });
  };
  function l(m, b, k) {
    if (b) return m.emit("error", b);
    if (k != null && m.push(k), m._writableState.length) throw new Error("Calling transform done when ws.length != 0");
    if (m._transformState.transforming) throw new Error("Calling transform done when still transforming");
    return m.push(null);
  }
  return _stream_transform;
}
var _stream_passthrough, hasRequired_stream_passthrough;
function require_stream_passthrough() {
  if (hasRequired_stream_passthrough) return _stream_passthrough;
  hasRequired_stream_passthrough = 1, _stream_passthrough = u;
  var s = require_stream_transform(), A = Object.create(requireUtil());
  A.inherits = requireInherits_browser(), A.inherits(u, s);
  function u(p) {
    if (!(this instanceof u)) return new u(p);
    s.call(this, p);
  }
  return u.prototype._transform = function(p, t, l) {
    l(null, p);
  }, _stream_passthrough;
}
var hasRequiredReadableBrowser;
function requireReadableBrowser() {
  return hasRequiredReadableBrowser || (hasRequiredReadableBrowser = 1, function(s, A) {
    A = s.exports = require_stream_readable(), A.Stream = A, A.Readable = A, A.Writable = require_stream_writable(), A.Duplex = require_stream_duplex(), A.Transform = require_stream_transform(), A.PassThrough = require_stream_passthrough();
  }(readableBrowser, readableBrowser.exports)), readableBrowser.exports;
}
var sign$2 = { exports: {} }, bn$1 = { exports: {} }, bn = bn$1.exports, hasRequiredBn;
function requireBn() {
  return hasRequiredBn || (hasRequiredBn = 1, function(s) {
    (function(A, u) {
      function p(Ce, Se) {
        if (!Ce) throw new Error(Se || "Assertion failed");
      }
      function t(Ce, Se) {
        Ce.super_ = Se;
        var Ne = function() {
        };
        Ne.prototype = Se.prototype, Ce.prototype = new Ne(), Ce.prototype.constructor = Ce;
      }
      function l(Ce, Se, Ne) {
        if (l.isBN(Ce))
          return Ce;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, Ce !== null && ((Se === "le" || Se === "be") && (Ne = Se, Se = 10), this._init(Ce || 0, Se || 10, Ne || "be"));
      }
      typeof A == "object" ? A.exports = l : u.BN = l, l.BN = l, l.wordSize = 26;
      var m;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? m = window.Buffer : m = requireDist$n().Buffer;
      } catch {
      }
      l.isBN = function(Se) {
        return Se instanceof l ? !0 : Se !== null && typeof Se == "object" && Se.constructor.wordSize === l.wordSize && Array.isArray(Se.words);
      }, l.max = function(Se, Ne) {
        return Se.cmp(Ne) > 0 ? Se : Ne;
      }, l.min = function(Se, Ne) {
        return Se.cmp(Ne) < 0 ? Se : Ne;
      }, l.prototype._init = function(Se, Ne, rr) {
        if (typeof Se == "number")
          return this._initNumber(Se, Ne, rr);
        if (typeof Se == "object")
          return this._initArray(Se, Ne, rr);
        Ne === "hex" && (Ne = 16), p(Ne === (Ne | 0) && Ne >= 2 && Ne <= 36), Se = Se.toString().replace(/\s+/g, "");
        var er = 0;
        Se[0] === "-" && (er++, this.negative = 1), er < Se.length && (Ne === 16 ? this._parseHex(Se, er, rr) : (this._parseBase(Se, Ne, er), rr === "le" && this._initArray(this.toArray(), Ne, rr)));
      }, l.prototype._initNumber = function(Se, Ne, rr) {
        Se < 0 && (this.negative = 1, Se = -Se), Se < 67108864 ? (this.words = [Se & 67108863], this.length = 1) : Se < 4503599627370496 ? (this.words = [
          Se & 67108863,
          Se / 67108864 & 67108863
        ], this.length = 2) : (p(Se < 9007199254740992), this.words = [
          Se & 67108863,
          Se / 67108864 & 67108863,
          1
        ], this.length = 3), rr === "le" && this._initArray(this.toArray(), Ne, rr);
      }, l.prototype._initArray = function(Se, Ne, rr) {
        if (p(typeof Se.length == "number"), Se.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(Se.length / 3), this.words = new Array(this.length);
        for (var er = 0; er < this.length; er++)
          this.words[er] = 0;
        var ir, sr, nr = 0;
        if (rr === "be")
          for (er = Se.length - 1, ir = 0; er >= 0; er -= 3)
            sr = Se[er] | Se[er - 1] << 8 | Se[er - 2] << 16, this.words[ir] |= sr << nr & 67108863, this.words[ir + 1] = sr >>> 26 - nr & 67108863, nr += 24, nr >= 26 && (nr -= 26, ir++);
        else if (rr === "le")
          for (er = 0, ir = 0; er < Se.length; er += 3)
            sr = Se[er] | Se[er + 1] << 8 | Se[er + 2] << 16, this.words[ir] |= sr << nr & 67108863, this.words[ir + 1] = sr >>> 26 - nr & 67108863, nr += 24, nr >= 26 && (nr -= 26, ir++);
        return this._strip();
      };
      function b(Ce, Se) {
        var Ne = Ce.charCodeAt(Se);
        if (Ne >= 48 && Ne <= 57)
          return Ne - 48;
        if (Ne >= 65 && Ne <= 70)
          return Ne - 55;
        if (Ne >= 97 && Ne <= 102)
          return Ne - 87;
        p(!1, "Invalid character in " + Ce);
      }
      function k(Ce, Se, Ne) {
        var rr = b(Ce, Ne);
        return Ne - 1 >= Se && (rr |= b(Ce, Ne - 1) << 4), rr;
      }
      l.prototype._parseHex = function(Se, Ne, rr) {
        this.length = Math.ceil((Se.length - Ne) / 6), this.words = new Array(this.length);
        for (var er = 0; er < this.length; er++)
          this.words[er] = 0;
        var ir = 0, sr = 0, nr;
        if (rr === "be")
          for (er = Se.length - 1; er >= Ne; er -= 2)
            nr = k(Se, Ne, er) << ir, this.words[sr] |= nr & 67108863, ir >= 18 ? (ir -= 18, sr += 1, this.words[sr] |= nr >>> 26) : ir += 8;
        else {
          var fr = Se.length - Ne;
          for (er = fr % 2 === 0 ? Ne + 1 : Ne; er < Se.length; er += 2)
            nr = k(Se, Ne, er) << ir, this.words[sr] |= nr & 67108863, ir >= 18 ? (ir -= 18, sr += 1, this.words[sr] |= nr >>> 26) : ir += 8;
        }
        this._strip();
      };
      function C(Ce, Se, Ne, rr) {
        for (var er = 0, ir = 0, sr = Math.min(Ce.length, Ne), nr = Se; nr < sr; nr++) {
          var fr = Ce.charCodeAt(nr) - 48;
          er *= rr, fr >= 49 ? ir = fr - 49 + 10 : fr >= 17 ? ir = fr - 17 + 10 : ir = fr, p(fr >= 0 && ir < rr, "Invalid character"), er += ir;
        }
        return er;
      }
      l.prototype._parseBase = function(Se, Ne, rr) {
        this.words = [0], this.length = 1;
        for (var er = 0, ir = 1; ir <= 67108863; ir *= Ne)
          er++;
        er--, ir = ir / Ne | 0;
        for (var sr = Se.length - rr, nr = sr % er, fr = Math.min(sr, sr - nr) + rr, lr = 0, br = rr; br < fr; br += er)
          lr = C(Se, br, br + er, Ne), this.imuln(ir), this.words[0] + lr < 67108864 ? this.words[0] += lr : this._iaddn(lr);
        if (nr !== 0) {
          var Br = 1;
          for (lr = C(Se, br, Se.length, Ne), br = 0; br < nr; br++)
            Br *= Ne;
          this.imuln(Br), this.words[0] + lr < 67108864 ? this.words[0] += lr : this._iaddn(lr);
        }
        this._strip();
      }, l.prototype.copy = function(Se) {
        Se.words = new Array(this.length);
        for (var Ne = 0; Ne < this.length; Ne++)
          Se.words[Ne] = this.words[Ne];
        Se.length = this.length, Se.negative = this.negative, Se.red = this.red;
      };
      function B(Ce, Se) {
        Ce.words = Se.words, Ce.length = Se.length, Ce.negative = Se.negative, Ce.red = Se.red;
      }
      if (l.prototype._move = function(Se) {
        B(Se, this);
      }, l.prototype.clone = function() {
        var Se = new l(null);
        return this.copy(Se), Se;
      }, l.prototype._expand = function(Se) {
        for (; this.length < Se; )
          this.words[this.length++] = 0;
        return this;
      }, l.prototype._strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, l.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, typeof Symbol < "u" && typeof Symbol.for == "function")
        try {
          l.prototype[Symbol.for("nodejs.util.inspect.custom")] = Q;
        } catch {
          l.prototype.inspect = Q;
        }
      else
        l.prototype.inspect = Q;
      function Q() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      }
      var P = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], x = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], M = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      l.prototype.toString = function(Se, Ne) {
        Se = Se || 10, Ne = Ne | 0 || 1;
        var rr;
        if (Se === 16 || Se === "hex") {
          rr = "";
          for (var er = 0, ir = 0, sr = 0; sr < this.length; sr++) {
            var nr = this.words[sr], fr = ((nr << er | ir) & 16777215).toString(16);
            ir = nr >>> 24 - er & 16777215, er += 2, er >= 26 && (er -= 26, sr--), ir !== 0 || sr !== this.length - 1 ? rr = P[6 - fr.length] + fr + rr : rr = fr + rr;
          }
          for (ir !== 0 && (rr = ir.toString(16) + rr); rr.length % Ne !== 0; )
            rr = "0" + rr;
          return this.negative !== 0 && (rr = "-" + rr), rr;
        }
        if (Se === (Se | 0) && Se >= 2 && Se <= 36) {
          var lr = x[Se], br = M[Se];
          rr = "";
          var Br = this.clone();
          for (Br.negative = 0; !Br.isZero(); ) {
            var Fr = Br.modrn(br).toString(Se);
            Br = Br.idivn(br), Br.isZero() ? rr = Fr + rr : rr = P[lr - Fr.length] + Fr + rr;
          }
          for (this.isZero() && (rr = "0" + rr); rr.length % Ne !== 0; )
            rr = "0" + rr;
          return this.negative !== 0 && (rr = "-" + rr), rr;
        }
        p(!1, "Base should be between 2 and 36");
      }, l.prototype.toNumber = function() {
        var Se = this.words[0];
        return this.length === 2 ? Se += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Se += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && p(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Se : Se;
      }, l.prototype.toJSON = function() {
        return this.toString(16, 2);
      }, m && (l.prototype.toBuffer = function(Se, Ne) {
        return this.toArrayLike(m, Se, Ne);
      }), l.prototype.toArray = function(Se, Ne) {
        return this.toArrayLike(Array, Se, Ne);
      };
      var F = function(Se, Ne) {
        return Se.allocUnsafe ? Se.allocUnsafe(Ne) : new Se(Ne);
      };
      l.prototype.toArrayLike = function(Se, Ne, rr) {
        this._strip();
        var er = this.byteLength(), ir = rr || Math.max(1, er);
        p(er <= ir, "byte array longer than desired length"), p(ir > 0, "Requested array length <= 0");
        var sr = F(Se, ir), nr = Ne === "le" ? "LE" : "BE";
        return this["_toArrayLike" + nr](sr, er), sr;
      }, l.prototype._toArrayLikeLE = function(Se, Ne) {
        for (var rr = 0, er = 0, ir = 0, sr = 0; ir < this.length; ir++) {
          var nr = this.words[ir] << sr | er;
          Se[rr++] = nr & 255, rr < Se.length && (Se[rr++] = nr >> 8 & 255), rr < Se.length && (Se[rr++] = nr >> 16 & 255), sr === 6 ? (rr < Se.length && (Se[rr++] = nr >> 24 & 255), er = 0, sr = 0) : (er = nr >>> 24, sr += 2);
        }
        if (rr < Se.length)
          for (Se[rr++] = er; rr < Se.length; )
            Se[rr++] = 0;
      }, l.prototype._toArrayLikeBE = function(Se, Ne) {
        for (var rr = Se.length - 1, er = 0, ir = 0, sr = 0; ir < this.length; ir++) {
          var nr = this.words[ir] << sr | er;
          Se[rr--] = nr & 255, rr >= 0 && (Se[rr--] = nr >> 8 & 255), rr >= 0 && (Se[rr--] = nr >> 16 & 255), sr === 6 ? (rr >= 0 && (Se[rr--] = nr >> 24 & 255), er = 0, sr = 0) : (er = nr >>> 24, sr += 2);
        }
        if (rr >= 0)
          for (Se[rr--] = er; rr >= 0; )
            Se[rr--] = 0;
      }, Math.clz32 ? l.prototype._countBits = function(Se) {
        return 32 - Math.clz32(Se);
      } : l.prototype._countBits = function(Se) {
        var Ne = Se, rr = 0;
        return Ne >= 4096 && (rr += 13, Ne >>>= 13), Ne >= 64 && (rr += 7, Ne >>>= 7), Ne >= 8 && (rr += 4, Ne >>>= 4), Ne >= 2 && (rr += 2, Ne >>>= 2), rr + Ne;
      }, l.prototype._zeroBits = function(Se) {
        if (Se === 0) return 26;
        var Ne = Se, rr = 0;
        return (Ne & 8191) === 0 && (rr += 13, Ne >>>= 13), (Ne & 127) === 0 && (rr += 7, Ne >>>= 7), (Ne & 15) === 0 && (rr += 4, Ne >>>= 4), (Ne & 3) === 0 && (rr += 2, Ne >>>= 2), (Ne & 1) === 0 && rr++, rr;
      }, l.prototype.bitLength = function() {
        var Se = this.words[this.length - 1], Ne = this._countBits(Se);
        return (this.length - 1) * 26 + Ne;
      };
      function le(Ce) {
        for (var Se = new Array(Ce.bitLength()), Ne = 0; Ne < Se.length; Ne++) {
          var rr = Ne / 26 | 0, er = Ne % 26;
          Se[Ne] = Ce.words[rr] >>> er & 1;
        }
        return Se;
      }
      l.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var Se = 0, Ne = 0; Ne < this.length; Ne++) {
          var rr = this._zeroBits(this.words[Ne]);
          if (Se += rr, rr !== 26) break;
        }
        return Se;
      }, l.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, l.prototype.toTwos = function(Se) {
        return this.negative !== 0 ? this.abs().inotn(Se).iaddn(1) : this.clone();
      }, l.prototype.fromTwos = function(Se) {
        return this.testn(Se - 1) ? this.notn(Se).iaddn(1).ineg() : this.clone();
      }, l.prototype.isNeg = function() {
        return this.negative !== 0;
      }, l.prototype.neg = function() {
        return this.clone().ineg();
      }, l.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, l.prototype.iuor = function(Se) {
        for (; this.length < Se.length; )
          this.words[this.length++] = 0;
        for (var Ne = 0; Ne < Se.length; Ne++)
          this.words[Ne] = this.words[Ne] | Se.words[Ne];
        return this._strip();
      }, l.prototype.ior = function(Se) {
        return p((this.negative | Se.negative) === 0), this.iuor(Se);
      }, l.prototype.or = function(Se) {
        return this.length > Se.length ? this.clone().ior(Se) : Se.clone().ior(this);
      }, l.prototype.uor = function(Se) {
        return this.length > Se.length ? this.clone().iuor(Se) : Se.clone().iuor(this);
      }, l.prototype.iuand = function(Se) {
        var Ne;
        this.length > Se.length ? Ne = Se : Ne = this;
        for (var rr = 0; rr < Ne.length; rr++)
          this.words[rr] = this.words[rr] & Se.words[rr];
        return this.length = Ne.length, this._strip();
      }, l.prototype.iand = function(Se) {
        return p((this.negative | Se.negative) === 0), this.iuand(Se);
      }, l.prototype.and = function(Se) {
        return this.length > Se.length ? this.clone().iand(Se) : Se.clone().iand(this);
      }, l.prototype.uand = function(Se) {
        return this.length > Se.length ? this.clone().iuand(Se) : Se.clone().iuand(this);
      }, l.prototype.iuxor = function(Se) {
        var Ne, rr;
        this.length > Se.length ? (Ne = this, rr = Se) : (Ne = Se, rr = this);
        for (var er = 0; er < rr.length; er++)
          this.words[er] = Ne.words[er] ^ rr.words[er];
        if (this !== Ne)
          for (; er < Ne.length; er++)
            this.words[er] = Ne.words[er];
        return this.length = Ne.length, this._strip();
      }, l.prototype.ixor = function(Se) {
        return p((this.negative | Se.negative) === 0), this.iuxor(Se);
      }, l.prototype.xor = function(Se) {
        return this.length > Se.length ? this.clone().ixor(Se) : Se.clone().ixor(this);
      }, l.prototype.uxor = function(Se) {
        return this.length > Se.length ? this.clone().iuxor(Se) : Se.clone().iuxor(this);
      }, l.prototype.inotn = function(Se) {
        p(typeof Se == "number" && Se >= 0);
        var Ne = Math.ceil(Se / 26) | 0, rr = Se % 26;
        this._expand(Ne), rr > 0 && Ne--;
        for (var er = 0; er < Ne; er++)
          this.words[er] = ~this.words[er] & 67108863;
        return rr > 0 && (this.words[er] = ~this.words[er] & 67108863 >> 26 - rr), this._strip();
      }, l.prototype.notn = function(Se) {
        return this.clone().inotn(Se);
      }, l.prototype.setn = function(Se, Ne) {
        p(typeof Se == "number" && Se >= 0);
        var rr = Se / 26 | 0, er = Se % 26;
        return this._expand(rr + 1), Ne ? this.words[rr] = this.words[rr] | 1 << er : this.words[rr] = this.words[rr] & ~(1 << er), this._strip();
      }, l.prototype.iadd = function(Se) {
        var Ne;
        if (this.negative !== 0 && Se.negative === 0)
          return this.negative = 0, Ne = this.isub(Se), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && Se.negative !== 0)
          return Se.negative = 0, Ne = this.isub(Se), Se.negative = 1, Ne._normSign();
        var rr, er;
        this.length > Se.length ? (rr = this, er = Se) : (rr = Se, er = this);
        for (var ir = 0, sr = 0; sr < er.length; sr++)
          Ne = (rr.words[sr] | 0) + (er.words[sr] | 0) + ir, this.words[sr] = Ne & 67108863, ir = Ne >>> 26;
        for (; ir !== 0 && sr < rr.length; sr++)
          Ne = (rr.words[sr] | 0) + ir, this.words[sr] = Ne & 67108863, ir = Ne >>> 26;
        if (this.length = rr.length, ir !== 0)
          this.words[this.length] = ir, this.length++;
        else if (rr !== this)
          for (; sr < rr.length; sr++)
            this.words[sr] = rr.words[sr];
        return this;
      }, l.prototype.add = function(Se) {
        var Ne;
        return Se.negative !== 0 && this.negative === 0 ? (Se.negative = 0, Ne = this.sub(Se), Se.negative ^= 1, Ne) : Se.negative === 0 && this.negative !== 0 ? (this.negative = 0, Ne = Se.sub(this), this.negative = 1, Ne) : this.length > Se.length ? this.clone().iadd(Se) : Se.clone().iadd(this);
      }, l.prototype.isub = function(Se) {
        if (Se.negative !== 0) {
          Se.negative = 0;
          var Ne = this.iadd(Se);
          return Se.negative = 1, Ne._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(Se), this.negative = 1, this._normSign();
        var rr = this.cmp(Se);
        if (rr === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var er, ir;
        rr > 0 ? (er = this, ir = Se) : (er = Se, ir = this);
        for (var sr = 0, nr = 0; nr < ir.length; nr++)
          Ne = (er.words[nr] | 0) - (ir.words[nr] | 0) + sr, sr = Ne >> 26, this.words[nr] = Ne & 67108863;
        for (; sr !== 0 && nr < er.length; nr++)
          Ne = (er.words[nr] | 0) + sr, sr = Ne >> 26, this.words[nr] = Ne & 67108863;
        if (sr === 0 && nr < er.length && er !== this)
          for (; nr < er.length; nr++)
            this.words[nr] = er.words[nr];
        return this.length = Math.max(this.length, nr), er !== this && (this.negative = 1), this._strip();
      }, l.prototype.sub = function(Se) {
        return this.clone().isub(Se);
      };
      function ge(Ce, Se, Ne) {
        Ne.negative = Se.negative ^ Ce.negative;
        var rr = Ce.length + Se.length | 0;
        Ne.length = rr, rr = rr - 1 | 0;
        var er = Ce.words[0] | 0, ir = Se.words[0] | 0, sr = er * ir, nr = sr & 67108863, fr = sr / 67108864 | 0;
        Ne.words[0] = nr;
        for (var lr = 1; lr < rr; lr++) {
          for (var br = fr >>> 26, Br = fr & 67108863, Fr = Math.min(lr, Se.length - 1), Gr = Math.max(0, lr - Ce.length + 1); Gr <= Fr; Gr++) {
            var qr = lr - Gr | 0;
            er = Ce.words[qr] | 0, ir = Se.words[Gr] | 0, sr = er * ir + Br, br += sr / 67108864 | 0, Br = sr & 67108863;
          }
          Ne.words[lr] = Br | 0, fr = br | 0;
        }
        return fr !== 0 ? Ne.words[lr] = fr | 0 : Ne.length--, Ne._strip();
      }
      var pe = function(Se, Ne, rr) {
        var er = Se.words, ir = Ne.words, sr = rr.words, nr = 0, fr, lr, br, Br = er[0] | 0, Fr = Br & 8191, Gr = Br >>> 13, qr = er[1] | 0, Hr = qr & 8191, un = qr >>> 13, Dr = er[2] | 0, wr = Dr & 8191, yr = Dr >>> 13, Qr = er[3] | 0, _r = Qr & 8191, Jr = Qr >>> 13, fn = er[4] | 0, jr = fn & 8191, dn = fn >>> 13, Tn = er[5] | 0, Yn = Tn & 8191, si = Tn >>> 13, vn = er[6] | 0, Cn = vn & 8191, Xr = vn >>> 13, In = er[7] | 0, zr = In & 8191, En = In >>> 13, Zr = er[8] | 0, kr = Zr & 8191, Rr = Zr >>> 13, Er = er[9] | 0, Or = Er & 8191, wn = Er >>> 13, Kn = ir[0] | 0, Ln = Kn & 8191, Wn = Kn >>> 13, Sn = ir[1] | 0, hi = Sn & 8191, ki = Sn >>> 13, xi = ir[2] | 0, _i = xi & 8191, Li = xi >>> 13, ms = ir[3] | 0, Ui = ms & 8191, Mi = ms >>> 13, Ls = ir[4] | 0, Ds = Ls & 8191, Pr = Ls >>> 13, vr = ir[5] | 0, Cr = vr & 8191, yn = vr >>> 13, Pn = ir[6] | 0, $n = Pn & 8191, ui = Pn >>> 13, Ei = ir[7] | 0, zi = Ei & 8191, Gi = Ei >>> 13, Vi = ir[8] | 0, Ur = Vi & 8191, $i = Vi >>> 13, Es = ir[9] | 0, pn = Es & 8191, Nr = Es >>> 13;
        rr.negative = Se.negative ^ Ne.negative, rr.length = 19, fr = Math.imul(Fr, Ln), lr = Math.imul(Fr, Wn), lr = lr + Math.imul(Gr, Ln) | 0, br = Math.imul(Gr, Wn);
        var Qn = (nr + fr | 0) + ((lr & 8191) << 13) | 0;
        nr = (br + (lr >>> 13) | 0) + (Qn >>> 26) | 0, Qn &= 67108863, fr = Math.imul(Hr, Ln), lr = Math.imul(Hr, Wn), lr = lr + Math.imul(un, Ln) | 0, br = Math.imul(un, Wn), fr = fr + Math.imul(Fr, hi) | 0, lr = lr + Math.imul(Fr, ki) | 0, lr = lr + Math.imul(Gr, hi) | 0, br = br + Math.imul(Gr, ki) | 0;
        var zn = (nr + fr | 0) + ((lr & 8191) << 13) | 0;
        nr = (br + (lr >>> 13) | 0) + (zn >>> 26) | 0, zn &= 67108863, fr = Math.imul(wr, Ln), lr = Math.imul(wr, Wn), lr = lr + Math.imul(yr, Ln) | 0, br = Math.imul(yr, Wn), fr = fr + Math.imul(Hr, hi) | 0, lr = lr + Math.imul(Hr, ki) | 0, lr = lr + Math.imul(un, hi) | 0, br = br + Math.imul(un, ki) | 0, fr = fr + Math.imul(Fr, _i) | 0, lr = lr + Math.imul(Fr, Li) | 0, lr = lr + Math.imul(Gr, _i) | 0, br = br + Math.imul(Gr, Li) | 0;
        var ti = (nr + fr | 0) + ((lr & 8191) << 13) | 0;
        nr = (br + (lr >>> 13) | 0) + (ti >>> 26) | 0, ti &= 67108863, fr = Math.imul(_r, Ln), lr = Math.imul(_r, Wn), lr = lr + Math.imul(Jr, Ln) | 0, br = Math.imul(Jr, Wn), fr = fr + Math.imul(wr, hi) | 0, lr = lr + Math.imul(wr, ki) | 0, lr = lr + Math.imul(yr, hi) | 0, br = br + Math.imul(yr, ki) | 0, fr = fr + Math.imul(Hr, _i) | 0, lr = lr + Math.imul(Hr, Li) | 0, lr = lr + Math.imul(un, _i) | 0, br = br + Math.imul(un, Li) | 0, fr = fr + Math.imul(Fr, Ui) | 0, lr = lr + Math.imul(Fr, Mi) | 0, lr = lr + Math.imul(Gr, Ui) | 0, br = br + Math.imul(Gr, Mi) | 0;
        var v = (nr + fr | 0) + ((lr & 8191) << 13) | 0;
        nr = (br + (lr >>> 13) | 0) + (v >>> 26) | 0, v &= 67108863, fr = Math.imul(jr, Ln), lr = Math.imul(jr, Wn), lr = lr + Math.imul(dn, Ln) | 0, br = Math.imul(dn, Wn), fr = fr + Math.imul(_r, hi) | 0, lr = lr + Math.imul(_r, ki) | 0, lr = lr + Math.imul(Jr, hi) | 0, br = br + Math.imul(Jr, ki) | 0, fr = fr + Math.imul(wr, _i) | 0, lr = lr + Math.imul(wr, Li) | 0, lr = lr + Math.imul(yr, _i) | 0, br = br + Math.imul(yr, Li) | 0, fr = fr + Math.imul(Hr, Ui) | 0, lr = lr + Math.imul(Hr, Mi) | 0, lr = lr + Math.imul(un, Ui) | 0, br = br + Math.imul(un, Mi) | 0, fr = fr + Math.imul(Fr, Ds) | 0, lr = lr + Math.imul(Fr, Pr) | 0, lr = lr + Math.imul(Gr, Ds) | 0, br = br + Math.imul(Gr, Pr) | 0;
        var d = (nr + fr | 0) + ((lr & 8191) << 13) | 0;
        nr = (br + (lr >>> 13) | 0) + (d >>> 26) | 0, d &= 67108863, fr = Math.imul(Yn, Ln), lr = Math.imul(Yn, Wn), lr = lr + Math.imul(si, Ln) | 0, br = Math.imul(si, Wn), fr = fr + Math.imul(jr, hi) | 0, lr = lr + Math.imul(jr, ki) | 0, lr = lr + Math.imul(dn, hi) | 0, br = br + Math.imul(dn, ki) | 0, fr = fr + Math.imul(_r, _i) | 0, lr = lr + Math.imul(_r, Li) | 0, lr = lr + Math.imul(Jr, _i) | 0, br = br + Math.imul(Jr, Li) | 0, fr = fr + Math.imul(wr, Ui) | 0, lr = lr + Math.imul(wr, Mi) | 0, lr = lr + Math.imul(yr, Ui) | 0, br = br + Math.imul(yr, Mi) | 0, fr = fr + Math.imul(Hr, Ds) | 0, lr = lr + Math.imul(Hr, Pr) | 0, lr = lr + Math.imul(un, Ds) | 0, br = br + Math.imul(un, Pr) | 0, fr = fr + Math.imul(Fr, Cr) | 0, lr = lr + Math.imul(Fr, yn) | 0, lr = lr + Math.imul(Gr, Cr) | 0, br = br + Math.imul(Gr, yn) | 0;
        var I = (nr + fr | 0) + ((lr & 8191) << 13) | 0;
        nr = (br + (lr >>> 13) | 0) + (I >>> 26) | 0, I &= 67108863, fr = Math.imul(Cn, Ln), lr = Math.imul(Cn, Wn), lr = lr + Math.imul(Xr, Ln) | 0, br = Math.imul(Xr, Wn), fr = fr + Math.imul(Yn, hi) | 0, lr = lr + Math.imul(Yn, ki) | 0, lr = lr + Math.imul(si, hi) | 0, br = br + Math.imul(si, ki) | 0, fr = fr + Math.imul(jr, _i) | 0, lr = lr + Math.imul(jr, Li) | 0, lr = lr + Math.imul(dn, _i) | 0, br = br + Math.imul(dn, Li) | 0, fr = fr + Math.imul(_r, Ui) | 0, lr = lr + Math.imul(_r, Mi) | 0, lr = lr + Math.imul(Jr, Ui) | 0, br = br + Math.imul(Jr, Mi) | 0, fr = fr + Math.imul(wr, Ds) | 0, lr = lr + Math.imul(wr, Pr) | 0, lr = lr + Math.imul(yr, Ds) | 0, br = br + Math.imul(yr, Pr) | 0, fr = fr + Math.imul(Hr, Cr) | 0, lr = lr + Math.imul(Hr, yn) | 0, lr = lr + Math.imul(un, Cr) | 0, br = br + Math.imul(un, yn) | 0, fr = fr + Math.imul(Fr, $n) | 0, lr = lr + Math.imul(Fr, ui) | 0, lr = lr + Math.imul(Gr, $n) | 0, br = br + Math.imul(Gr, ui) | 0;
        var n = (nr + fr | 0) + ((lr & 8191) << 13) | 0;
        nr = (br + (lr >>> 13) | 0) + (n >>> 26) | 0, n &= 67108863, fr = Math.imul(zr, Ln), lr = Math.imul(zr, Wn), lr = lr + Math.imul(En, Ln) | 0, br = Math.imul(En, Wn), fr = fr + Math.imul(Cn, hi) | 0, lr = lr + Math.imul(Cn, ki) | 0, lr = lr + Math.imul(Xr, hi) | 0, br = br + Math.imul(Xr, ki) | 0, fr = fr + Math.imul(Yn, _i) | 0, lr = lr + Math.imul(Yn, Li) | 0, lr = lr + Math.imul(si, _i) | 0, br = br + Math.imul(si, Li) | 0, fr = fr + Math.imul(jr, Ui) | 0, lr = lr + Math.imul(jr, Mi) | 0, lr = lr + Math.imul(dn, Ui) | 0, br = br + Math.imul(dn, Mi) | 0, fr = fr + Math.imul(_r, Ds) | 0, lr = lr + Math.imul(_r, Pr) | 0, lr = lr + Math.imul(Jr, Ds) | 0, br = br + Math.imul(Jr, Pr) | 0, fr = fr + Math.imul(wr, Cr) | 0, lr = lr + Math.imul(wr, yn) | 0, lr = lr + Math.imul(yr, Cr) | 0, br = br + Math.imul(yr, yn) | 0, fr = fr + Math.imul(Hr, $n) | 0, lr = lr + Math.imul(Hr, ui) | 0, lr = lr + Math.imul(un, $n) | 0, br = br + Math.imul(un, ui) | 0, fr = fr + Math.imul(Fr, zi) | 0, lr = lr + Math.imul(Fr, Gi) | 0, lr = lr + Math.imul(Gr, zi) | 0, br = br + Math.imul(Gr, Gi) | 0;
        var a = (nr + fr | 0) + ((lr & 8191) << 13) | 0;
        nr = (br + (lr >>> 13) | 0) + (a >>> 26) | 0, a &= 67108863, fr = Math.imul(kr, Ln), lr = Math.imul(kr, Wn), lr = lr + Math.imul(Rr, Ln) | 0, br = Math.imul(Rr, Wn), fr = fr + Math.imul(zr, hi) | 0, lr = lr + Math.imul(zr, ki) | 0, lr = lr + Math.imul(En, hi) | 0, br = br + Math.imul(En, ki) | 0, fr = fr + Math.imul(Cn, _i) | 0, lr = lr + Math.imul(Cn, Li) | 0, lr = lr + Math.imul(Xr, _i) | 0, br = br + Math.imul(Xr, Li) | 0, fr = fr + Math.imul(Yn, Ui) | 0, lr = lr + Math.imul(Yn, Mi) | 0, lr = lr + Math.imul(si, Ui) | 0, br = br + Math.imul(si, Mi) | 0, fr = fr + Math.imul(jr, Ds) | 0, lr = lr + Math.imul(jr, Pr) | 0, lr = lr + Math.imul(dn, Ds) | 0, br = br + Math.imul(dn, Pr) | 0, fr = fr + Math.imul(_r, Cr) | 0, lr = lr + Math.imul(_r, yn) | 0, lr = lr + Math.imul(Jr, Cr) | 0, br = br + Math.imul(Jr, yn) | 0, fr = fr + Math.imul(wr, $n) | 0, lr = lr + Math.imul(wr, ui) | 0, lr = lr + Math.imul(yr, $n) | 0, br = br + Math.imul(yr, ui) | 0, fr = fr + Math.imul(Hr, zi) | 0, lr = lr + Math.imul(Hr, Gi) | 0, lr = lr + Math.imul(un, zi) | 0, br = br + Math.imul(un, Gi) | 0, fr = fr + Math.imul(Fr, Ur) | 0, lr = lr + Math.imul(Fr, $i) | 0, lr = lr + Math.imul(Gr, Ur) | 0, br = br + Math.imul(Gr, $i) | 0;
        var E = (nr + fr | 0) + ((lr & 8191) << 13) | 0;
        nr = (br + (lr >>> 13) | 0) + (E >>> 26) | 0, E &= 67108863, fr = Math.imul(Or, Ln), lr = Math.imul(Or, Wn), lr = lr + Math.imul(wn, Ln) | 0, br = Math.imul(wn, Wn), fr = fr + Math.imul(kr, hi) | 0, lr = lr + Math.imul(kr, ki) | 0, lr = lr + Math.imul(Rr, hi) | 0, br = br + Math.imul(Rr, ki) | 0, fr = fr + Math.imul(zr, _i) | 0, lr = lr + Math.imul(zr, Li) | 0, lr = lr + Math.imul(En, _i) | 0, br = br + Math.imul(En, Li) | 0, fr = fr + Math.imul(Cn, Ui) | 0, lr = lr + Math.imul(Cn, Mi) | 0, lr = lr + Math.imul(Xr, Ui) | 0, br = br + Math.imul(Xr, Mi) | 0, fr = fr + Math.imul(Yn, Ds) | 0, lr = lr + Math.imul(Yn, Pr) | 0, lr = lr + Math.imul(si, Ds) | 0, br = br + Math.imul(si, Pr) | 0, fr = fr + Math.imul(jr, Cr) | 0, lr = lr + Math.imul(jr, yn) | 0, lr = lr + Math.imul(dn, Cr) | 0, br = br + Math.imul(dn, yn) | 0, fr = fr + Math.imul(_r, $n) | 0, lr = lr + Math.imul(_r, ui) | 0, lr = lr + Math.imul(Jr, $n) | 0, br = br + Math.imul(Jr, ui) | 0, fr = fr + Math.imul(wr, zi) | 0, lr = lr + Math.imul(wr, Gi) | 0, lr = lr + Math.imul(yr, zi) | 0, br = br + Math.imul(yr, Gi) | 0, fr = fr + Math.imul(Hr, Ur) | 0, lr = lr + Math.imul(Hr, $i) | 0, lr = lr + Math.imul(un, Ur) | 0, br = br + Math.imul(un, $i) | 0, fr = fr + Math.imul(Fr, pn) | 0, lr = lr + Math.imul(Fr, Nr) | 0, lr = lr + Math.imul(Gr, pn) | 0, br = br + Math.imul(Gr, Nr) | 0;
        var T = (nr + fr | 0) + ((lr & 8191) << 13) | 0;
        nr = (br + (lr >>> 13) | 0) + (T >>> 26) | 0, T &= 67108863, fr = Math.imul(Or, hi), lr = Math.imul(Or, ki), lr = lr + Math.imul(wn, hi) | 0, br = Math.imul(wn, ki), fr = fr + Math.imul(kr, _i) | 0, lr = lr + Math.imul(kr, Li) | 0, lr = lr + Math.imul(Rr, _i) | 0, br = br + Math.imul(Rr, Li) | 0, fr = fr + Math.imul(zr, Ui) | 0, lr = lr + Math.imul(zr, Mi) | 0, lr = lr + Math.imul(En, Ui) | 0, br = br + Math.imul(En, Mi) | 0, fr = fr + Math.imul(Cn, Ds) | 0, lr = lr + Math.imul(Cn, Pr) | 0, lr = lr + Math.imul(Xr, Ds) | 0, br = br + Math.imul(Xr, Pr) | 0, fr = fr + Math.imul(Yn, Cr) | 0, lr = lr + Math.imul(Yn, yn) | 0, lr = lr + Math.imul(si, Cr) | 0, br = br + Math.imul(si, yn) | 0, fr = fr + Math.imul(jr, $n) | 0, lr = lr + Math.imul(jr, ui) | 0, lr = lr + Math.imul(dn, $n) | 0, br = br + Math.imul(dn, ui) | 0, fr = fr + Math.imul(_r, zi) | 0, lr = lr + Math.imul(_r, Gi) | 0, lr = lr + Math.imul(Jr, zi) | 0, br = br + Math.imul(Jr, Gi) | 0, fr = fr + Math.imul(wr, Ur) | 0, lr = lr + Math.imul(wr, $i) | 0, lr = lr + Math.imul(yr, Ur) | 0, br = br + Math.imul(yr, $i) | 0, fr = fr + Math.imul(Hr, pn) | 0, lr = lr + Math.imul(Hr, Nr) | 0, lr = lr + Math.imul(un, pn) | 0, br = br + Math.imul(un, Nr) | 0;
        var L = (nr + fr | 0) + ((lr & 8191) << 13) | 0;
        nr = (br + (lr >>> 13) | 0) + (L >>> 26) | 0, L &= 67108863, fr = Math.imul(Or, _i), lr = Math.imul(Or, Li), lr = lr + Math.imul(wn, _i) | 0, br = Math.imul(wn, Li), fr = fr + Math.imul(kr, Ui) | 0, lr = lr + Math.imul(kr, Mi) | 0, lr = lr + Math.imul(Rr, Ui) | 0, br = br + Math.imul(Rr, Mi) | 0, fr = fr + Math.imul(zr, Ds) | 0, lr = lr + Math.imul(zr, Pr) | 0, lr = lr + Math.imul(En, Ds) | 0, br = br + Math.imul(En, Pr) | 0, fr = fr + Math.imul(Cn, Cr) | 0, lr = lr + Math.imul(Cn, yn) | 0, lr = lr + Math.imul(Xr, Cr) | 0, br = br + Math.imul(Xr, yn) | 0, fr = fr + Math.imul(Yn, $n) | 0, lr = lr + Math.imul(Yn, ui) | 0, lr = lr + Math.imul(si, $n) | 0, br = br + Math.imul(si, ui) | 0, fr = fr + Math.imul(jr, zi) | 0, lr = lr + Math.imul(jr, Gi) | 0, lr = lr + Math.imul(dn, zi) | 0, br = br + Math.imul(dn, Gi) | 0, fr = fr + Math.imul(_r, Ur) | 0, lr = lr + Math.imul(_r, $i) | 0, lr = lr + Math.imul(Jr, Ur) | 0, br = br + Math.imul(Jr, $i) | 0, fr = fr + Math.imul(wr, pn) | 0, lr = lr + Math.imul(wr, Nr) | 0, lr = lr + Math.imul(yr, pn) | 0, br = br + Math.imul(yr, Nr) | 0;
        var he = (nr + fr | 0) + ((lr & 8191) << 13) | 0;
        nr = (br + (lr >>> 13) | 0) + (he >>> 26) | 0, he &= 67108863, fr = Math.imul(Or, Ui), lr = Math.imul(Or, Mi), lr = lr + Math.imul(wn, Ui) | 0, br = Math.imul(wn, Mi), fr = fr + Math.imul(kr, Ds) | 0, lr = lr + Math.imul(kr, Pr) | 0, lr = lr + Math.imul(Rr, Ds) | 0, br = br + Math.imul(Rr, Pr) | 0, fr = fr + Math.imul(zr, Cr) | 0, lr = lr + Math.imul(zr, yn) | 0, lr = lr + Math.imul(En, Cr) | 0, br = br + Math.imul(En, yn) | 0, fr = fr + Math.imul(Cn, $n) | 0, lr = lr + Math.imul(Cn, ui) | 0, lr = lr + Math.imul(Xr, $n) | 0, br = br + Math.imul(Xr, ui) | 0, fr = fr + Math.imul(Yn, zi) | 0, lr = lr + Math.imul(Yn, Gi) | 0, lr = lr + Math.imul(si, zi) | 0, br = br + Math.imul(si, Gi) | 0, fr = fr + Math.imul(jr, Ur) | 0, lr = lr + Math.imul(jr, $i) | 0, lr = lr + Math.imul(dn, Ur) | 0, br = br + Math.imul(dn, $i) | 0, fr = fr + Math.imul(_r, pn) | 0, lr = lr + Math.imul(_r, Nr) | 0, lr = lr + Math.imul(Jr, pn) | 0, br = br + Math.imul(Jr, Nr) | 0;
        var Be = (nr + fr | 0) + ((lr & 8191) << 13) | 0;
        nr = (br + (lr >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, fr = Math.imul(Or, Ds), lr = Math.imul(Or, Pr), lr = lr + Math.imul(wn, Ds) | 0, br = Math.imul(wn, Pr), fr = fr + Math.imul(kr, Cr) | 0, lr = lr + Math.imul(kr, yn) | 0, lr = lr + Math.imul(Rr, Cr) | 0, br = br + Math.imul(Rr, yn) | 0, fr = fr + Math.imul(zr, $n) | 0, lr = lr + Math.imul(zr, ui) | 0, lr = lr + Math.imul(En, $n) | 0, br = br + Math.imul(En, ui) | 0, fr = fr + Math.imul(Cn, zi) | 0, lr = lr + Math.imul(Cn, Gi) | 0, lr = lr + Math.imul(Xr, zi) | 0, br = br + Math.imul(Xr, Gi) | 0, fr = fr + Math.imul(Yn, Ur) | 0, lr = lr + Math.imul(Yn, $i) | 0, lr = lr + Math.imul(si, Ur) | 0, br = br + Math.imul(si, $i) | 0, fr = fr + Math.imul(jr, pn) | 0, lr = lr + Math.imul(jr, Nr) | 0, lr = lr + Math.imul(dn, pn) | 0, br = br + Math.imul(dn, Nr) | 0;
        var Me = (nr + fr | 0) + ((lr & 8191) << 13) | 0;
        nr = (br + (lr >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, fr = Math.imul(Or, Cr), lr = Math.imul(Or, yn), lr = lr + Math.imul(wn, Cr) | 0, br = Math.imul(wn, yn), fr = fr + Math.imul(kr, $n) | 0, lr = lr + Math.imul(kr, ui) | 0, lr = lr + Math.imul(Rr, $n) | 0, br = br + Math.imul(Rr, ui) | 0, fr = fr + Math.imul(zr, zi) | 0, lr = lr + Math.imul(zr, Gi) | 0, lr = lr + Math.imul(En, zi) | 0, br = br + Math.imul(En, Gi) | 0, fr = fr + Math.imul(Cn, Ur) | 0, lr = lr + Math.imul(Cn, $i) | 0, lr = lr + Math.imul(Xr, Ur) | 0, br = br + Math.imul(Xr, $i) | 0, fr = fr + Math.imul(Yn, pn) | 0, lr = lr + Math.imul(Yn, Nr) | 0, lr = lr + Math.imul(si, pn) | 0, br = br + Math.imul(si, Nr) | 0;
        var tr = (nr + fr | 0) + ((lr & 8191) << 13) | 0;
        nr = (br + (lr >>> 13) | 0) + (tr >>> 26) | 0, tr &= 67108863, fr = Math.imul(Or, $n), lr = Math.imul(Or, ui), lr = lr + Math.imul(wn, $n) | 0, br = Math.imul(wn, ui), fr = fr + Math.imul(kr, zi) | 0, lr = lr + Math.imul(kr, Gi) | 0, lr = lr + Math.imul(Rr, zi) | 0, br = br + Math.imul(Rr, Gi) | 0, fr = fr + Math.imul(zr, Ur) | 0, lr = lr + Math.imul(zr, $i) | 0, lr = lr + Math.imul(En, Ur) | 0, br = br + Math.imul(En, $i) | 0, fr = fr + Math.imul(Cn, pn) | 0, lr = lr + Math.imul(Cn, Nr) | 0, lr = lr + Math.imul(Xr, pn) | 0, br = br + Math.imul(Xr, Nr) | 0;
        var or = (nr + fr | 0) + ((lr & 8191) << 13) | 0;
        nr = (br + (lr >>> 13) | 0) + (or >>> 26) | 0, or &= 67108863, fr = Math.imul(Or, zi), lr = Math.imul(Or, Gi), lr = lr + Math.imul(wn, zi) | 0, br = Math.imul(wn, Gi), fr = fr + Math.imul(kr, Ur) | 0, lr = lr + Math.imul(kr, $i) | 0, lr = lr + Math.imul(Rr, Ur) | 0, br = br + Math.imul(Rr, $i) | 0, fr = fr + Math.imul(zr, pn) | 0, lr = lr + Math.imul(zr, Nr) | 0, lr = lr + Math.imul(En, pn) | 0, br = br + Math.imul(En, Nr) | 0;
        var cr = (nr + fr | 0) + ((lr & 8191) << 13) | 0;
        nr = (br + (lr >>> 13) | 0) + (cr >>> 26) | 0, cr &= 67108863, fr = Math.imul(Or, Ur), lr = Math.imul(Or, $i), lr = lr + Math.imul(wn, Ur) | 0, br = Math.imul(wn, $i), fr = fr + Math.imul(kr, pn) | 0, lr = lr + Math.imul(kr, Nr) | 0, lr = lr + Math.imul(Rr, pn) | 0, br = br + Math.imul(Rr, Nr) | 0;
        var dr = (nr + fr | 0) + ((lr & 8191) << 13) | 0;
        nr = (br + (lr >>> 13) | 0) + (dr >>> 26) | 0, dr &= 67108863, fr = Math.imul(Or, pn), lr = Math.imul(Or, Nr), lr = lr + Math.imul(wn, pn) | 0, br = Math.imul(wn, Nr);
        var gr = (nr + fr | 0) + ((lr & 8191) << 13) | 0;
        return nr = (br + (lr >>> 13) | 0) + (gr >>> 26) | 0, gr &= 67108863, sr[0] = Qn, sr[1] = zn, sr[2] = ti, sr[3] = v, sr[4] = d, sr[5] = I, sr[6] = n, sr[7] = a, sr[8] = E, sr[9] = T, sr[10] = L, sr[11] = he, sr[12] = Be, sr[13] = Me, sr[14] = tr, sr[15] = or, sr[16] = cr, sr[17] = dr, sr[18] = gr, nr !== 0 && (sr[19] = nr, rr.length++), rr;
      };
      Math.imul || (pe = ge);
      function Ie(Ce, Se, Ne) {
        Ne.negative = Se.negative ^ Ce.negative, Ne.length = Ce.length + Se.length;
        for (var rr = 0, er = 0, ir = 0; ir < Ne.length - 1; ir++) {
          var sr = er;
          er = 0;
          for (var nr = rr & 67108863, fr = Math.min(ir, Se.length - 1), lr = Math.max(0, ir - Ce.length + 1); lr <= fr; lr++) {
            var br = ir - lr, Br = Ce.words[br] | 0, Fr = Se.words[lr] | 0, Gr = Br * Fr, qr = Gr & 67108863;
            sr = sr + (Gr / 67108864 | 0) | 0, qr = qr + nr | 0, nr = qr & 67108863, sr = sr + (qr >>> 26) | 0, er += sr >>> 26, sr &= 67108863;
          }
          Ne.words[ir] = nr, rr = sr, sr = er;
        }
        return rr !== 0 ? Ne.words[ir] = rr : Ne.length--, Ne._strip();
      }
      function be(Ce, Se, Ne) {
        return Ie(Ce, Se, Ne);
      }
      l.prototype.mulTo = function(Se, Ne) {
        var rr, er = this.length + Se.length;
        return this.length === 10 && Se.length === 10 ? rr = pe(this, Se, Ne) : er < 63 ? rr = ge(this, Se, Ne) : er < 1024 ? rr = Ie(this, Se, Ne) : rr = be(this, Se, Ne), rr;
      }, l.prototype.mul = function(Se) {
        var Ne = new l(null);
        return Ne.words = new Array(this.length + Se.length), this.mulTo(Se, Ne);
      }, l.prototype.mulf = function(Se) {
        var Ne = new l(null);
        return Ne.words = new Array(this.length + Se.length), be(this, Se, Ne);
      }, l.prototype.imul = function(Se) {
        return this.clone().mulTo(Se, this);
      }, l.prototype.imuln = function(Se) {
        var Ne = Se < 0;
        Ne && (Se = -Se), p(typeof Se == "number"), p(Se < 67108864);
        for (var rr = 0, er = 0; er < this.length; er++) {
          var ir = (this.words[er] | 0) * Se, sr = (ir & 67108863) + (rr & 67108863);
          rr >>= 26, rr += ir / 67108864 | 0, rr += sr >>> 26, this.words[er] = sr & 67108863;
        }
        return rr !== 0 && (this.words[er] = rr, this.length++), this.length = Se === 0 ? 1 : this.length, Ne ? this.ineg() : this;
      }, l.prototype.muln = function(Se) {
        return this.clone().imuln(Se);
      }, l.prototype.sqr = function() {
        return this.mul(this);
      }, l.prototype.isqr = function() {
        return this.imul(this.clone());
      }, l.prototype.pow = function(Se) {
        var Ne = le(Se);
        if (Ne.length === 0) return new l(1);
        for (var rr = this, er = 0; er < Ne.length && Ne[er] === 0; er++, rr = rr.sqr())
          ;
        if (++er < Ne.length)
          for (var ir = rr.sqr(); er < Ne.length; er++, ir = ir.sqr())
            Ne[er] !== 0 && (rr = rr.mul(ir));
        return rr;
      }, l.prototype.iushln = function(Se) {
        p(typeof Se == "number" && Se >= 0);
        var Ne = Se % 26, rr = (Se - Ne) / 26, er = 67108863 >>> 26 - Ne << 26 - Ne, ir;
        if (Ne !== 0) {
          var sr = 0;
          for (ir = 0; ir < this.length; ir++) {
            var nr = this.words[ir] & er, fr = (this.words[ir] | 0) - nr << Ne;
            this.words[ir] = fr | sr, sr = nr >>> 26 - Ne;
          }
          sr && (this.words[ir] = sr, this.length++);
        }
        if (rr !== 0) {
          for (ir = this.length - 1; ir >= 0; ir--)
            this.words[ir + rr] = this.words[ir];
          for (ir = 0; ir < rr; ir++)
            this.words[ir] = 0;
          this.length += rr;
        }
        return this._strip();
      }, l.prototype.ishln = function(Se) {
        return p(this.negative === 0), this.iushln(Se);
      }, l.prototype.iushrn = function(Se, Ne, rr) {
        p(typeof Se == "number" && Se >= 0);
        var er;
        Ne ? er = (Ne - Ne % 26) / 26 : er = 0;
        var ir = Se % 26, sr = Math.min((Se - ir) / 26, this.length), nr = 67108863 ^ 67108863 >>> ir << ir, fr = rr;
        if (er -= sr, er = Math.max(0, er), fr) {
          for (var lr = 0; lr < sr; lr++)
            fr.words[lr] = this.words[lr];
          fr.length = sr;
        }
        if (sr !== 0) if (this.length > sr)
          for (this.length -= sr, lr = 0; lr < this.length; lr++)
            this.words[lr] = this.words[lr + sr];
        else
          this.words[0] = 0, this.length = 1;
        var br = 0;
        for (lr = this.length - 1; lr >= 0 && (br !== 0 || lr >= er); lr--) {
          var Br = this.words[lr] | 0;
          this.words[lr] = br << 26 - ir | Br >>> ir, br = Br & nr;
        }
        return fr && br !== 0 && (fr.words[fr.length++] = br), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
      }, l.prototype.ishrn = function(Se, Ne, rr) {
        return p(this.negative === 0), this.iushrn(Se, Ne, rr);
      }, l.prototype.shln = function(Se) {
        return this.clone().ishln(Se);
      }, l.prototype.ushln = function(Se) {
        return this.clone().iushln(Se);
      }, l.prototype.shrn = function(Se) {
        return this.clone().ishrn(Se);
      }, l.prototype.ushrn = function(Se) {
        return this.clone().iushrn(Se);
      }, l.prototype.testn = function(Se) {
        p(typeof Se == "number" && Se >= 0);
        var Ne = Se % 26, rr = (Se - Ne) / 26, er = 1 << Ne;
        if (this.length <= rr) return !1;
        var ir = this.words[rr];
        return !!(ir & er);
      }, l.prototype.imaskn = function(Se) {
        p(typeof Se == "number" && Se >= 0);
        var Ne = Se % 26, rr = (Se - Ne) / 26;
        if (p(this.negative === 0, "imaskn works only with positive numbers"), this.length <= rr)
          return this;
        if (Ne !== 0 && rr++, this.length = Math.min(rr, this.length), Ne !== 0) {
          var er = 67108863 ^ 67108863 >>> Ne << Ne;
          this.words[this.length - 1] &= er;
        }
        return this._strip();
      }, l.prototype.maskn = function(Se) {
        return this.clone().imaskn(Se);
      }, l.prototype.iaddn = function(Se) {
        return p(typeof Se == "number"), p(Se < 67108864), Se < 0 ? this.isubn(-Se) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= Se ? (this.words[0] = Se - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Se), this.negative = 1, this) : this._iaddn(Se);
      }, l.prototype._iaddn = function(Se) {
        this.words[0] += Se;
        for (var Ne = 0; Ne < this.length && this.words[Ne] >= 67108864; Ne++)
          this.words[Ne] -= 67108864, Ne === this.length - 1 ? this.words[Ne + 1] = 1 : this.words[Ne + 1]++;
        return this.length = Math.max(this.length, Ne + 1), this;
      }, l.prototype.isubn = function(Se) {
        if (p(typeof Se == "number"), p(Se < 67108864), Se < 0) return this.iaddn(-Se);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(Se), this.negative = 1, this;
        if (this.words[0] -= Se, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var Ne = 0; Ne < this.length && this.words[Ne] < 0; Ne++)
            this.words[Ne] += 67108864, this.words[Ne + 1] -= 1;
        return this._strip();
      }, l.prototype.addn = function(Se) {
        return this.clone().iaddn(Se);
      }, l.prototype.subn = function(Se) {
        return this.clone().isubn(Se);
      }, l.prototype.iabs = function() {
        return this.negative = 0, this;
      }, l.prototype.abs = function() {
        return this.clone().iabs();
      }, l.prototype._ishlnsubmul = function(Se, Ne, rr) {
        var er = Se.length + rr, ir;
        this._expand(er);
        var sr, nr = 0;
        for (ir = 0; ir < Se.length; ir++) {
          sr = (this.words[ir + rr] | 0) + nr;
          var fr = (Se.words[ir] | 0) * Ne;
          sr -= fr & 67108863, nr = (sr >> 26) - (fr / 67108864 | 0), this.words[ir + rr] = sr & 67108863;
        }
        for (; ir < this.length - rr; ir++)
          sr = (this.words[ir + rr] | 0) + nr, nr = sr >> 26, this.words[ir + rr] = sr & 67108863;
        if (nr === 0) return this._strip();
        for (p(nr === -1), nr = 0, ir = 0; ir < this.length; ir++)
          sr = -(this.words[ir] | 0) + nr, nr = sr >> 26, this.words[ir] = sr & 67108863;
        return this.negative = 1, this._strip();
      }, l.prototype._wordDiv = function(Se, Ne) {
        var rr = this.length - Se.length, er = this.clone(), ir = Se, sr = ir.words[ir.length - 1] | 0, nr = this._countBits(sr);
        rr = 26 - nr, rr !== 0 && (ir = ir.ushln(rr), er.iushln(rr), sr = ir.words[ir.length - 1] | 0);
        var fr = er.length - ir.length, lr;
        if (Ne !== "mod") {
          lr = new l(null), lr.length = fr + 1, lr.words = new Array(lr.length);
          for (var br = 0; br < lr.length; br++)
            lr.words[br] = 0;
        }
        var Br = er.clone()._ishlnsubmul(ir, 1, fr);
        Br.negative === 0 && (er = Br, lr && (lr.words[fr] = 1));
        for (var Fr = fr - 1; Fr >= 0; Fr--) {
          var Gr = (er.words[ir.length + Fr] | 0) * 67108864 + (er.words[ir.length + Fr - 1] | 0);
          for (Gr = Math.min(Gr / sr | 0, 67108863), er._ishlnsubmul(ir, Gr, Fr); er.negative !== 0; )
            Gr--, er.negative = 0, er._ishlnsubmul(ir, 1, Fr), er.isZero() || (er.negative ^= 1);
          lr && (lr.words[Fr] = Gr);
        }
        return lr && lr._strip(), er._strip(), Ne !== "div" && rr !== 0 && er.iushrn(rr), {
          div: lr || null,
          mod: er
        };
      }, l.prototype.divmod = function(Se, Ne, rr) {
        if (p(!Se.isZero()), this.isZero())
          return {
            div: new l(0),
            mod: new l(0)
          };
        var er, ir, sr;
        return this.negative !== 0 && Se.negative === 0 ? (sr = this.neg().divmod(Se, Ne), Ne !== "mod" && (er = sr.div.neg()), Ne !== "div" && (ir = sr.mod.neg(), rr && ir.negative !== 0 && ir.iadd(Se)), {
          div: er,
          mod: ir
        }) : this.negative === 0 && Se.negative !== 0 ? (sr = this.divmod(Se.neg(), Ne), Ne !== "mod" && (er = sr.div.neg()), {
          div: er,
          mod: sr.mod
        }) : (this.negative & Se.negative) !== 0 ? (sr = this.neg().divmod(Se.neg(), Ne), Ne !== "div" && (ir = sr.mod.neg(), rr && ir.negative !== 0 && ir.isub(Se)), {
          div: sr.div,
          mod: ir
        }) : Se.length > this.length || this.cmp(Se) < 0 ? {
          div: new l(0),
          mod: this
        } : Se.length === 1 ? Ne === "div" ? {
          div: this.divn(Se.words[0]),
          mod: null
        } : Ne === "mod" ? {
          div: null,
          mod: new l(this.modrn(Se.words[0]))
        } : {
          div: this.divn(Se.words[0]),
          mod: new l(this.modrn(Se.words[0]))
        } : this._wordDiv(Se, Ne);
      }, l.prototype.div = function(Se) {
        return this.divmod(Se, "div", !1).div;
      }, l.prototype.mod = function(Se) {
        return this.divmod(Se, "mod", !1).mod;
      }, l.prototype.umod = function(Se) {
        return this.divmod(Se, "mod", !0).mod;
      }, l.prototype.divRound = function(Se) {
        var Ne = this.divmod(Se);
        if (Ne.mod.isZero()) return Ne.div;
        var rr = Ne.div.negative !== 0 ? Ne.mod.isub(Se) : Ne.mod, er = Se.ushrn(1), ir = Se.andln(1), sr = rr.cmp(er);
        return sr < 0 || ir === 1 && sr === 0 ? Ne.div : Ne.div.negative !== 0 ? Ne.div.isubn(1) : Ne.div.iaddn(1);
      }, l.prototype.modrn = function(Se) {
        var Ne = Se < 0;
        Ne && (Se = -Se), p(Se <= 67108863);
        for (var rr = (1 << 26) % Se, er = 0, ir = this.length - 1; ir >= 0; ir--)
          er = (rr * er + (this.words[ir] | 0)) % Se;
        return Ne ? -er : er;
      }, l.prototype.modn = function(Se) {
        return this.modrn(Se);
      }, l.prototype.idivn = function(Se) {
        var Ne = Se < 0;
        Ne && (Se = -Se), p(Se <= 67108863);
        for (var rr = 0, er = this.length - 1; er >= 0; er--) {
          var ir = (this.words[er] | 0) + rr * 67108864;
          this.words[er] = ir / Se | 0, rr = ir % Se;
        }
        return this._strip(), Ne ? this.ineg() : this;
      }, l.prototype.divn = function(Se) {
        return this.clone().idivn(Se);
      }, l.prototype.egcd = function(Se) {
        p(Se.negative === 0), p(!Se.isZero());
        var Ne = this, rr = Se.clone();
        Ne.negative !== 0 ? Ne = Ne.umod(Se) : Ne = Ne.clone();
        for (var er = new l(1), ir = new l(0), sr = new l(0), nr = new l(1), fr = 0; Ne.isEven() && rr.isEven(); )
          Ne.iushrn(1), rr.iushrn(1), ++fr;
        for (var lr = rr.clone(), br = Ne.clone(); !Ne.isZero(); ) {
          for (var Br = 0, Fr = 1; (Ne.words[0] & Fr) === 0 && Br < 26; ++Br, Fr <<= 1) ;
          if (Br > 0)
            for (Ne.iushrn(Br); Br-- > 0; )
              (er.isOdd() || ir.isOdd()) && (er.iadd(lr), ir.isub(br)), er.iushrn(1), ir.iushrn(1);
          for (var Gr = 0, qr = 1; (rr.words[0] & qr) === 0 && Gr < 26; ++Gr, qr <<= 1) ;
          if (Gr > 0)
            for (rr.iushrn(Gr); Gr-- > 0; )
              (sr.isOdd() || nr.isOdd()) && (sr.iadd(lr), nr.isub(br)), sr.iushrn(1), nr.iushrn(1);
          Ne.cmp(rr) >= 0 ? (Ne.isub(rr), er.isub(sr), ir.isub(nr)) : (rr.isub(Ne), sr.isub(er), nr.isub(ir));
        }
        return {
          a: sr,
          b: nr,
          gcd: rr.iushln(fr)
        };
      }, l.prototype._invmp = function(Se) {
        p(Se.negative === 0), p(!Se.isZero());
        var Ne = this, rr = Se.clone();
        Ne.negative !== 0 ? Ne = Ne.umod(Se) : Ne = Ne.clone();
        for (var er = new l(1), ir = new l(0), sr = rr.clone(); Ne.cmpn(1) > 0 && rr.cmpn(1) > 0; ) {
          for (var nr = 0, fr = 1; (Ne.words[0] & fr) === 0 && nr < 26; ++nr, fr <<= 1) ;
          if (nr > 0)
            for (Ne.iushrn(nr); nr-- > 0; )
              er.isOdd() && er.iadd(sr), er.iushrn(1);
          for (var lr = 0, br = 1; (rr.words[0] & br) === 0 && lr < 26; ++lr, br <<= 1) ;
          if (lr > 0)
            for (rr.iushrn(lr); lr-- > 0; )
              ir.isOdd() && ir.iadd(sr), ir.iushrn(1);
          Ne.cmp(rr) >= 0 ? (Ne.isub(rr), er.isub(ir)) : (rr.isub(Ne), ir.isub(er));
        }
        var Br;
        return Ne.cmpn(1) === 0 ? Br = er : Br = ir, Br.cmpn(0) < 0 && Br.iadd(Se), Br;
      }, l.prototype.gcd = function(Se) {
        if (this.isZero()) return Se.abs();
        if (Se.isZero()) return this.abs();
        var Ne = this.clone(), rr = Se.clone();
        Ne.negative = 0, rr.negative = 0;
        for (var er = 0; Ne.isEven() && rr.isEven(); er++)
          Ne.iushrn(1), rr.iushrn(1);
        do {
          for (; Ne.isEven(); )
            Ne.iushrn(1);
          for (; rr.isEven(); )
            rr.iushrn(1);
          var ir = Ne.cmp(rr);
          if (ir < 0) {
            var sr = Ne;
            Ne = rr, rr = sr;
          } else if (ir === 0 || rr.cmpn(1) === 0)
            break;
          Ne.isub(rr);
        } while (!0);
        return rr.iushln(er);
      }, l.prototype.invm = function(Se) {
        return this.egcd(Se).a.umod(Se);
      }, l.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, l.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, l.prototype.andln = function(Se) {
        return this.words[0] & Se;
      }, l.prototype.bincn = function(Se) {
        p(typeof Se == "number");
        var Ne = Se % 26, rr = (Se - Ne) / 26, er = 1 << Ne;
        if (this.length <= rr)
          return this._expand(rr + 1), this.words[rr] |= er, this;
        for (var ir = er, sr = rr; ir !== 0 && sr < this.length; sr++) {
          var nr = this.words[sr] | 0;
          nr += ir, ir = nr >>> 26, nr &= 67108863, this.words[sr] = nr;
        }
        return ir !== 0 && (this.words[sr] = ir, this.length++), this;
      }, l.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, l.prototype.cmpn = function(Se) {
        var Ne = Se < 0;
        if (this.negative !== 0 && !Ne) return -1;
        if (this.negative === 0 && Ne) return 1;
        this._strip();
        var rr;
        if (this.length > 1)
          rr = 1;
        else {
          Ne && (Se = -Se), p(Se <= 67108863, "Number is too big");
          var er = this.words[0] | 0;
          rr = er === Se ? 0 : er < Se ? -1 : 1;
        }
        return this.negative !== 0 ? -rr | 0 : rr;
      }, l.prototype.cmp = function(Se) {
        if (this.negative !== 0 && Se.negative === 0) return -1;
        if (this.negative === 0 && Se.negative !== 0) return 1;
        var Ne = this.ucmp(Se);
        return this.negative !== 0 ? -Ne | 0 : Ne;
      }, l.prototype.ucmp = function(Se) {
        if (this.length > Se.length) return 1;
        if (this.length < Se.length) return -1;
        for (var Ne = 0, rr = this.length - 1; rr >= 0; rr--) {
          var er = this.words[rr] | 0, ir = Se.words[rr] | 0;
          if (er !== ir) {
            er < ir ? Ne = -1 : er > ir && (Ne = 1);
            break;
          }
        }
        return Ne;
      }, l.prototype.gtn = function(Se) {
        return this.cmpn(Se) === 1;
      }, l.prototype.gt = function(Se) {
        return this.cmp(Se) === 1;
      }, l.prototype.gten = function(Se) {
        return this.cmpn(Se) >= 0;
      }, l.prototype.gte = function(Se) {
        return this.cmp(Se) >= 0;
      }, l.prototype.ltn = function(Se) {
        return this.cmpn(Se) === -1;
      }, l.prototype.lt = function(Se) {
        return this.cmp(Se) === -1;
      }, l.prototype.lten = function(Se) {
        return this.cmpn(Se) <= 0;
      }, l.prototype.lte = function(Se) {
        return this.cmp(Se) <= 0;
      }, l.prototype.eqn = function(Se) {
        return this.cmpn(Se) === 0;
      }, l.prototype.eq = function(Se) {
        return this.cmp(Se) === 0;
      }, l.red = function(Se) {
        return new ve(Se);
      }, l.prototype.toRed = function(Se) {
        return p(!this.red, "Already a number in reduction context"), p(this.negative === 0, "red works only with positives"), Se.convertTo(this)._forceRed(Se);
      }, l.prototype.fromRed = function() {
        return p(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, l.prototype._forceRed = function(Se) {
        return this.red = Se, this;
      }, l.prototype.forceRed = function(Se) {
        return p(!this.red, "Already a number in reduction context"), this._forceRed(Se);
      }, l.prototype.redAdd = function(Se) {
        return p(this.red, "redAdd works only with red numbers"), this.red.add(this, Se);
      }, l.prototype.redIAdd = function(Se) {
        return p(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Se);
      }, l.prototype.redSub = function(Se) {
        return p(this.red, "redSub works only with red numbers"), this.red.sub(this, Se);
      }, l.prototype.redISub = function(Se) {
        return p(this.red, "redISub works only with red numbers"), this.red.isub(this, Se);
      }, l.prototype.redShl = function(Se) {
        return p(this.red, "redShl works only with red numbers"), this.red.shl(this, Se);
      }, l.prototype.redMul = function(Se) {
        return p(this.red, "redMul works only with red numbers"), this.red._verify2(this, Se), this.red.mul(this, Se);
      }, l.prototype.redIMul = function(Se) {
        return p(this.red, "redMul works only with red numbers"), this.red._verify2(this, Se), this.red.imul(this, Se);
      }, l.prototype.redSqr = function() {
        return p(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, l.prototype.redISqr = function() {
        return p(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, l.prototype.redSqrt = function() {
        return p(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, l.prototype.redInvm = function() {
        return p(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, l.prototype.redNeg = function() {
        return p(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, l.prototype.redPow = function(Se) {
        return p(this.red && !Se.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Se);
      };
      var Pe = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Te(Ce, Se) {
        this.name = Ce, this.p = new l(Se, 16), this.n = this.p.bitLength(), this.k = new l(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Te.prototype._tmp = function() {
        var Se = new l(null);
        return Se.words = new Array(Math.ceil(this.n / 13)), Se;
      }, Te.prototype.ireduce = function(Se) {
        var Ne = Se, rr;
        do
          this.split(Ne, this.tmp), Ne = this.imulK(Ne), Ne = Ne.iadd(this.tmp), rr = Ne.bitLength();
        while (rr > this.n);
        var er = rr < this.n ? -1 : Ne.ucmp(this.p);
        return er === 0 ? (Ne.words[0] = 0, Ne.length = 1) : er > 0 ? Ne.isub(this.p) : Ne.strip !== void 0 ? Ne.strip() : Ne._strip(), Ne;
      }, Te.prototype.split = function(Se, Ne) {
        Se.iushrn(this.n, 0, Ne);
      }, Te.prototype.imulK = function(Se) {
        return Se.imul(this.k);
      };
      function Qe() {
        Te.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      t(Qe, Te), Qe.prototype.split = function(Se, Ne) {
        for (var rr = 4194303, er = Math.min(Se.length, 9), ir = 0; ir < er; ir++)
          Ne.words[ir] = Se.words[ir];
        if (Ne.length = er, Se.length <= 9) {
          Se.words[0] = 0, Se.length = 1;
          return;
        }
        var sr = Se.words[9];
        for (Ne.words[Ne.length++] = sr & rr, ir = 10; ir < Se.length; ir++) {
          var nr = Se.words[ir] | 0;
          Se.words[ir - 10] = (nr & rr) << 4 | sr >>> 22, sr = nr;
        }
        sr >>>= 22, Se.words[ir - 10] = sr, sr === 0 && Se.length > 10 ? Se.length -= 10 : Se.length -= 9;
      }, Qe.prototype.imulK = function(Se) {
        Se.words[Se.length] = 0, Se.words[Se.length + 1] = 0, Se.length += 2;
        for (var Ne = 0, rr = 0; rr < Se.length; rr++) {
          var er = Se.words[rr] | 0;
          Ne += er * 977, Se.words[rr] = Ne & 67108863, Ne = er * 64 + (Ne / 67108864 | 0);
        }
        return Se.words[Se.length - 1] === 0 && (Se.length--, Se.words[Se.length - 1] === 0 && Se.length--), Se;
      };
      function xe() {
        Te.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      t(xe, Te);
      function Ee() {
        Te.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      t(Ee, Te);
      function He() {
        Te.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      t(He, Te), He.prototype.imulK = function(Se) {
        for (var Ne = 0, rr = 0; rr < Se.length; rr++) {
          var er = (Se.words[rr] | 0) * 19 + Ne, ir = er & 67108863;
          er >>>= 26, Se.words[rr] = ir, Ne = er;
        }
        return Ne !== 0 && (Se.words[Se.length++] = Ne), Se;
      }, l._prime = function(Se) {
        if (Pe[Se]) return Pe[Se];
        var Ne;
        if (Se === "k256")
          Ne = new Qe();
        else if (Se === "p224")
          Ne = new xe();
        else if (Se === "p192")
          Ne = new Ee();
        else if (Se === "p25519")
          Ne = new He();
        else
          throw new Error("Unknown prime " + Se);
        return Pe[Se] = Ne, Ne;
      };
      function ve(Ce) {
        if (typeof Ce == "string") {
          var Se = l._prime(Ce);
          this.m = Se.p, this.prime = Se;
        } else
          p(Ce.gtn(1), "modulus must be greater than 1"), this.m = Ce, this.prime = null;
      }
      ve.prototype._verify1 = function(Se) {
        p(Se.negative === 0, "red works only with positives"), p(Se.red, "red works only with red numbers");
      }, ve.prototype._verify2 = function(Se, Ne) {
        p((Se.negative | Ne.negative) === 0, "red works only with positives"), p(
          Se.red && Se.red === Ne.red,
          "red works only with red numbers"
        );
      }, ve.prototype.imod = function(Se) {
        return this.prime ? this.prime.ireduce(Se)._forceRed(this) : (B(Se, Se.umod(this.m)._forceRed(this)), Se);
      }, ve.prototype.neg = function(Se) {
        return Se.isZero() ? Se.clone() : this.m.sub(Se)._forceRed(this);
      }, ve.prototype.add = function(Se, Ne) {
        this._verify2(Se, Ne);
        var rr = Se.add(Ne);
        return rr.cmp(this.m) >= 0 && rr.isub(this.m), rr._forceRed(this);
      }, ve.prototype.iadd = function(Se, Ne) {
        this._verify2(Se, Ne);
        var rr = Se.iadd(Ne);
        return rr.cmp(this.m) >= 0 && rr.isub(this.m), rr;
      }, ve.prototype.sub = function(Se, Ne) {
        this._verify2(Se, Ne);
        var rr = Se.sub(Ne);
        return rr.cmpn(0) < 0 && rr.iadd(this.m), rr._forceRed(this);
      }, ve.prototype.isub = function(Se, Ne) {
        this._verify2(Se, Ne);
        var rr = Se.isub(Ne);
        return rr.cmpn(0) < 0 && rr.iadd(this.m), rr;
      }, ve.prototype.shl = function(Se, Ne) {
        return this._verify1(Se), this.imod(Se.ushln(Ne));
      }, ve.prototype.imul = function(Se, Ne) {
        return this._verify2(Se, Ne), this.imod(Se.imul(Ne));
      }, ve.prototype.mul = function(Se, Ne) {
        return this._verify2(Se, Ne), this.imod(Se.mul(Ne));
      }, ve.prototype.isqr = function(Se) {
        return this.imul(Se, Se.clone());
      }, ve.prototype.sqr = function(Se) {
        return this.mul(Se, Se);
      }, ve.prototype.sqrt = function(Se) {
        if (Se.isZero()) return Se.clone();
        var Ne = this.m.andln(3);
        if (p(Ne % 2 === 1), Ne === 3) {
          var rr = this.m.add(new l(1)).iushrn(2);
          return this.pow(Se, rr);
        }
        for (var er = this.m.subn(1), ir = 0; !er.isZero() && er.andln(1) === 0; )
          ir++, er.iushrn(1);
        p(!er.isZero());
        var sr = new l(1).toRed(this), nr = sr.redNeg(), fr = this.m.subn(1).iushrn(1), lr = this.m.bitLength();
        for (lr = new l(2 * lr * lr).toRed(this); this.pow(lr, fr).cmp(nr) !== 0; )
          lr.redIAdd(nr);
        for (var br = this.pow(lr, er), Br = this.pow(Se, er.addn(1).iushrn(1)), Fr = this.pow(Se, er), Gr = ir; Fr.cmp(sr) !== 0; ) {
          for (var qr = Fr, Hr = 0; qr.cmp(sr) !== 0; Hr++)
            qr = qr.redSqr();
          p(Hr < Gr);
          var un = this.pow(br, new l(1).iushln(Gr - Hr - 1));
          Br = Br.redMul(un), br = un.redSqr(), Fr = Fr.redMul(br), Gr = Hr;
        }
        return Br;
      }, ve.prototype.invm = function(Se) {
        var Ne = Se._invmp(this.m);
        return Ne.negative !== 0 ? (Ne.negative = 0, this.imod(Ne).redNeg()) : this.imod(Ne);
      }, ve.prototype.pow = function(Se, Ne) {
        if (Ne.isZero()) return new l(1).toRed(this);
        if (Ne.cmpn(1) === 0) return Se.clone();
        var rr = 4, er = new Array(1 << rr);
        er[0] = new l(1).toRed(this), er[1] = Se;
        for (var ir = 2; ir < er.length; ir++)
          er[ir] = this.mul(er[ir - 1], Se);
        var sr = er[0], nr = 0, fr = 0, lr = Ne.bitLength() % 26;
        for (lr === 0 && (lr = 26), ir = Ne.length - 1; ir >= 0; ir--) {
          for (var br = Ne.words[ir], Br = lr - 1; Br >= 0; Br--) {
            var Fr = br >> Br & 1;
            if (sr !== er[0] && (sr = this.sqr(sr)), Fr === 0 && nr === 0) {
              fr = 0;
              continue;
            }
            nr <<= 1, nr |= Fr, fr++, !(fr !== rr && (ir !== 0 || Br !== 0)) && (sr = this.mul(sr, er[nr]), fr = 0, nr = 0);
          }
          lr = 26;
        }
        return sr;
      }, ve.prototype.convertTo = function(Se) {
        var Ne = Se.umod(this.m);
        return Ne === Se ? Ne.clone() : Ne;
      }, ve.prototype.convertFrom = function(Se) {
        var Ne = Se.clone();
        return Ne.red = null, Ne;
      }, l.mont = function(Se) {
        return new we(Se);
      };
      function we(Ce) {
        ve.call(this, Ce), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new l(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      t(we, ve), we.prototype.convertTo = function(Se) {
        return this.imod(Se.ushln(this.shift));
      }, we.prototype.convertFrom = function(Se) {
        var Ne = this.imod(Se.mul(this.rinv));
        return Ne.red = null, Ne;
      }, we.prototype.imul = function(Se, Ne) {
        if (Se.isZero() || Ne.isZero())
          return Se.words[0] = 0, Se.length = 1, Se;
        var rr = Se.imul(Ne), er = rr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ir = rr.isub(er).iushrn(this.shift), sr = ir;
        return ir.cmp(this.m) >= 0 ? sr = ir.isub(this.m) : ir.cmpn(0) < 0 && (sr = ir.iadd(this.m)), sr._forceRed(this);
      }, we.prototype.mul = function(Se, Ne) {
        if (Se.isZero() || Ne.isZero()) return new l(0)._forceRed(this);
        var rr = Se.mul(Ne), er = rr.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ir = rr.isub(er).iushrn(this.shift), sr = ir;
        return ir.cmp(this.m) >= 0 ? sr = ir.isub(this.m) : ir.cmpn(0) < 0 && (sr = ir.iadd(this.m)), sr._forceRed(this);
      }, we.prototype.invm = function(Se) {
        var Ne = this.imod(Se._invmp(this.m).mul(this.r2));
        return Ne._forceRed(this);
      };
    })(s, bn);
  }(bn$1)), bn$1.exports;
}
var browserifyRsa, hasRequiredBrowserifyRsa;
function requireBrowserifyRsa() {
  if (hasRequiredBrowserifyRsa) return browserifyRsa;
  hasRequiredBrowserifyRsa = 1;
  var s = requireBn(), A = requireBrowser$9(), u = requireSafeBuffer$1().Buffer;
  function p(m) {
    var b = m.modulus.byteLength(), k;
    do
      k = new s(A(b));
    while (k.cmp(m.modulus) >= 0 || !k.umod(m.prime1) || !k.umod(m.prime2));
    return k;
  }
  function t(m) {
    var b = p(m), k = b.toRed(s.mont(m.modulus)).redPow(new s(m.publicExponent)).fromRed();
    return { blinder: k, unblinder: b.invm(m.modulus) };
  }
  function l(m, b) {
    var k = t(b), C = b.modulus.byteLength(), B = new s(m).mul(k.blinder).umod(b.modulus), Q = B.toRed(s.mont(b.prime1)), P = B.toRed(s.mont(b.prime2)), x = b.coefficient, M = b.prime1, F = b.prime2, le = Q.redPow(b.exponent1).fromRed(), ge = P.redPow(b.exponent2).fromRed(), pe = le.isub(ge).imul(x).umod(M).imul(F);
    return ge.iadd(pe).imul(k.unblinder).umod(b.modulus).toArrayLike(u, "be", C);
  }
  return l.getr = p, browserifyRsa = l, browserifyRsa;
}
var elliptic$2 = {};
const version$6 = "6.6.1", require$$0$1 = {
  version: version$6
};
var utils$c = {}, utils$b = {}, hasRequiredUtils$a;
function requireUtils$a() {
  return hasRequiredUtils$a || (hasRequiredUtils$a = 1, function(s) {
    var A = s;
    function u(l, m) {
      if (Array.isArray(l))
        return l.slice();
      if (!l)
        return [];
      var b = [];
      if (typeof l != "string") {
        for (var k = 0; k < l.length; k++)
          b[k] = l[k] | 0;
        return b;
      }
      if (m === "hex") {
        l = l.replace(/[^a-z0-9]+/ig, ""), l.length % 2 !== 0 && (l = "0" + l);
        for (var k = 0; k < l.length; k += 2)
          b.push(parseInt(l[k] + l[k + 1], 16));
      } else
        for (var k = 0; k < l.length; k++) {
          var C = l.charCodeAt(k), B = C >> 8, Q = C & 255;
          B ? b.push(B, Q) : b.push(Q);
        }
      return b;
    }
    A.toArray = u;
    function p(l) {
      return l.length === 1 ? "0" + l : l;
    }
    A.zero2 = p;
    function t(l) {
      for (var m = "", b = 0; b < l.length; b++)
        m += p(l[b].toString(16));
      return m;
    }
    A.toHex = t, A.encode = function(m, b) {
      return b === "hex" ? t(m) : m;
    };
  }(utils$b)), utils$b;
}
var hasRequiredUtils$9;
function requireUtils$9() {
  return hasRequiredUtils$9 || (hasRequiredUtils$9 = 1, function(s) {
    var A = s, u = requireBn$1(), p = requireMinimalisticAssert(), t = requireUtils$a();
    A.assert = p, A.toArray = t.toArray, A.zero2 = t.zero2, A.toHex = t.toHex, A.encode = t.encode;
    function l(B, Q, P) {
      var x = new Array(Math.max(B.bitLength(), P) + 1), M;
      for (M = 0; M < x.length; M += 1)
        x[M] = 0;
      var F = 1 << Q + 1, le = B.clone();
      for (M = 0; M < x.length; M++) {
        var ge, pe = le.andln(F - 1);
        le.isOdd() ? (pe > (F >> 1) - 1 ? ge = (F >> 1) - pe : ge = pe, le.isubn(ge)) : ge = 0, x[M] = ge, le.iushrn(1);
      }
      return x;
    }
    A.getNAF = l;
    function m(B, Q) {
      var P = [
        [],
        []
      ];
      B = B.clone(), Q = Q.clone();
      for (var x = 0, M = 0, F; B.cmpn(-x) > 0 || Q.cmpn(-M) > 0; ) {
        var le = B.andln(3) + x & 3, ge = Q.andln(3) + M & 3;
        le === 3 && (le = -1), ge === 3 && (ge = -1);
        var pe;
        (le & 1) === 0 ? pe = 0 : (F = B.andln(7) + x & 7, (F === 3 || F === 5) && ge === 2 ? pe = -le : pe = le), P[0].push(pe);
        var Ie;
        (ge & 1) === 0 ? Ie = 0 : (F = Q.andln(7) + M & 7, (F === 3 || F === 5) && le === 2 ? Ie = -ge : Ie = ge), P[1].push(Ie), 2 * x === pe + 1 && (x = 1 - x), 2 * M === Ie + 1 && (M = 1 - M), B.iushrn(1), Q.iushrn(1);
      }
      return P;
    }
    A.getJSF = m;
    function b(B, Q, P) {
      var x = "_" + Q;
      B.prototype[Q] = function() {
        return this[x] !== void 0 ? this[x] : this[x] = P.call(this);
      };
    }
    A.cachedProperty = b;
    function k(B) {
      return typeof B == "string" ? A.toArray(B, "hex") : B;
    }
    A.parseBytes = k;
    function C(B) {
      return new u(B, "hex", "le");
    }
    A.intFromLE = C;
  }(utils$c)), utils$c;
}
var curve$1 = {}, base$1, hasRequiredBase$1;
function requireBase$1() {
  if (hasRequiredBase$1) return base$1;
  hasRequiredBase$1 = 1;
  var s = requireBn$1(), A = requireUtils$9(), u = A.getNAF, p = A.getJSF, t = A.assert;
  function l(b, k) {
    this.type = b, this.p = new s(k.p, 16), this.red = k.prime ? s.red(k.prime) : s.mont(this.p), this.zero = new s(0).toRed(this.red), this.one = new s(1).toRed(this.red), this.two = new s(2).toRed(this.red), this.n = k.n && new s(k.n, 16), this.g = k.g && this.pointFromJSON(k.g, k.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
    var C = this.n && this.p.div(this.n);
    !C || C.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
  }
  base$1 = l, l.prototype.point = function() {
    throw new Error("Not implemented");
  }, l.prototype.validate = function() {
    throw new Error("Not implemented");
  }, l.prototype._fixedNafMul = function(k, C) {
    t(k.precomputed);
    var B = k._getDoubles(), Q = u(C, 1, this._bitLength), P = (1 << B.step + 1) - (B.step % 2 === 0 ? 2 : 1);
    P /= 3;
    var x = [], M, F;
    for (M = 0; M < Q.length; M += B.step) {
      F = 0;
      for (var le = M + B.step - 1; le >= M; le--)
        F = (F << 1) + Q[le];
      x.push(F);
    }
    for (var ge = this.jpoint(null, null, null), pe = this.jpoint(null, null, null), Ie = P; Ie > 0; Ie--) {
      for (M = 0; M < x.length; M++)
        F = x[M], F === Ie ? pe = pe.mixedAdd(B.points[M]) : F === -Ie && (pe = pe.mixedAdd(B.points[M].neg()));
      ge = ge.add(pe);
    }
    return ge.toP();
  }, l.prototype._wnafMul = function(k, C) {
    var B = 4, Q = k._getNAFPoints(B);
    B = Q.wnd;
    for (var P = Q.points, x = u(C, B, this._bitLength), M = this.jpoint(null, null, null), F = x.length - 1; F >= 0; F--) {
      for (var le = 0; F >= 0 && x[F] === 0; F--)
        le++;
      if (F >= 0 && le++, M = M.dblp(le), F < 0)
        break;
      var ge = x[F];
      t(ge !== 0), k.type === "affine" ? ge > 0 ? M = M.mixedAdd(P[ge - 1 >> 1]) : M = M.mixedAdd(P[-ge - 1 >> 1].neg()) : ge > 0 ? M = M.add(P[ge - 1 >> 1]) : M = M.add(P[-ge - 1 >> 1].neg());
    }
    return k.type === "affine" ? M.toP() : M;
  }, l.prototype._wnafMulAdd = function(k, C, B, Q, P) {
    var x = this._wnafT1, M = this._wnafT2, F = this._wnafT3, le = 0, ge, pe, Ie;
    for (ge = 0; ge < Q; ge++) {
      Ie = C[ge];
      var be = Ie._getNAFPoints(k);
      x[ge] = be.wnd, M[ge] = be.points;
    }
    for (ge = Q - 1; ge >= 1; ge -= 2) {
      var Pe = ge - 1, Te = ge;
      if (x[Pe] !== 1 || x[Te] !== 1) {
        F[Pe] = u(B[Pe], x[Pe], this._bitLength), F[Te] = u(B[Te], x[Te], this._bitLength), le = Math.max(F[Pe].length, le), le = Math.max(F[Te].length, le);
        continue;
      }
      var Qe = [
        C[Pe],
        /* 1 */
        null,
        /* 3 */
        null,
        /* 5 */
        C[Te]
        /* 7 */
      ];
      C[Pe].y.cmp(C[Te].y) === 0 ? (Qe[1] = C[Pe].add(C[Te]), Qe[2] = C[Pe].toJ().mixedAdd(C[Te].neg())) : C[Pe].y.cmp(C[Te].y.redNeg()) === 0 ? (Qe[1] = C[Pe].toJ().mixedAdd(C[Te]), Qe[2] = C[Pe].add(C[Te].neg())) : (Qe[1] = C[Pe].toJ().mixedAdd(C[Te]), Qe[2] = C[Pe].toJ().mixedAdd(C[Te].neg()));
      var xe = [
        -3,
        /* -1 -1 */
        -1,
        /* -1 0 */
        -5,
        /* -1 1 */
        -7,
        /* 0 -1 */
        0,
        /* 0 0 */
        7,
        /* 0 1 */
        5,
        /* 1 -1 */
        1,
        /* 1 0 */
        3
        /* 1 1 */
      ], Ee = p(B[Pe], B[Te]);
      for (le = Math.max(Ee[0].length, le), F[Pe] = new Array(le), F[Te] = new Array(le), pe = 0; pe < le; pe++) {
        var He = Ee[0][pe] | 0, ve = Ee[1][pe] | 0;
        F[Pe][pe] = xe[(He + 1) * 3 + (ve + 1)], F[Te][pe] = 0, M[Pe] = Qe;
      }
    }
    var we = this.jpoint(null, null, null), Ce = this._wnafT4;
    for (ge = le; ge >= 0; ge--) {
      for (var Se = 0; ge >= 0; ) {
        var Ne = !0;
        for (pe = 0; pe < Q; pe++)
          Ce[pe] = F[pe][ge] | 0, Ce[pe] !== 0 && (Ne = !1);
        if (!Ne)
          break;
        Se++, ge--;
      }
      if (ge >= 0 && Se++, we = we.dblp(Se), ge < 0)
        break;
      for (pe = 0; pe < Q; pe++) {
        var rr = Ce[pe];
        rr !== 0 && (rr > 0 ? Ie = M[pe][rr - 1 >> 1] : rr < 0 && (Ie = M[pe][-rr - 1 >> 1].neg()), Ie.type === "affine" ? we = we.mixedAdd(Ie) : we = we.add(Ie));
      }
    }
    for (ge = 0; ge < Q; ge++)
      M[ge] = null;
    return P ? we : we.toP();
  };
  function m(b, k) {
    this.curve = b, this.type = k, this.precomputed = null;
  }
  return l.BasePoint = m, m.prototype.eq = function() {
    throw new Error("Not implemented");
  }, m.prototype.validate = function() {
    return this.curve.validate(this);
  }, l.prototype.decodePoint = function(k, C) {
    k = A.toArray(k, C);
    var B = this.p.byteLength();
    if ((k[0] === 4 || k[0] === 6 || k[0] === 7) && k.length - 1 === 2 * B) {
      k[0] === 6 ? t(k[k.length - 1] % 2 === 0) : k[0] === 7 && t(k[k.length - 1] % 2 === 1);
      var Q = this.point(
        k.slice(1, 1 + B),
        k.slice(1 + B, 1 + 2 * B)
      );
      return Q;
    } else if ((k[0] === 2 || k[0] === 3) && k.length - 1 === B)
      return this.pointFromX(k.slice(1, 1 + B), k[0] === 3);
    throw new Error("Unknown point format");
  }, m.prototype.encodeCompressed = function(k) {
    return this.encode(k, !0);
  }, m.prototype._encode = function(k) {
    var C = this.curve.p.byteLength(), B = this.getX().toArray("be", C);
    return k ? [this.getY().isEven() ? 2 : 3].concat(B) : [4].concat(B, this.getY().toArray("be", C));
  }, m.prototype.encode = function(k, C) {
    return A.encode(this._encode(C), k);
  }, m.prototype.precompute = function(k) {
    if (this.precomputed)
      return this;
    var C = {
      doubles: null,
      naf: null,
      beta: null
    };
    return C.naf = this._getNAFPoints(8), C.doubles = this._getDoubles(4, k), C.beta = this._getBeta(), this.precomputed = C, this;
  }, m.prototype._hasDoubles = function(k) {
    if (!this.precomputed)
      return !1;
    var C = this.precomputed.doubles;
    return C ? C.points.length >= Math.ceil((k.bitLength() + 1) / C.step) : !1;
  }, m.prototype._getDoubles = function(k, C) {
    if (this.precomputed && this.precomputed.doubles)
      return this.precomputed.doubles;
    for (var B = [this], Q = this, P = 0; P < C; P += k) {
      for (var x = 0; x < k; x++)
        Q = Q.dbl();
      B.push(Q);
    }
    return {
      step: k,
      points: B
    };
  }, m.prototype._getNAFPoints = function(k) {
    if (this.precomputed && this.precomputed.naf)
      return this.precomputed.naf;
    for (var C = [this], B = (1 << k) - 1, Q = B === 1 ? null : this.dbl(), P = 1; P < B; P++)
      C[P] = C[P - 1].add(Q);
    return {
      wnd: k,
      points: C
    };
  }, m.prototype._getBeta = function() {
    return null;
  }, m.prototype.dblp = function(k) {
    for (var C = this, B = 0; B < k; B++)
      C = C.dbl();
    return C;
  }, base$1;
}
var short, hasRequiredShort;
function requireShort() {
  if (hasRequiredShort) return short;
  hasRequiredShort = 1;
  var s = requireUtils$9(), A = requireBn$1(), u = requireInherits_browser(), p = requireBase$1(), t = s.assert;
  function l(k) {
    p.call(this, "short", k), this.a = new A(k.a, 16).toRed(this.red), this.b = new A(k.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(k), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
  }
  u(l, p), short = l, l.prototype._getEndomorphism = function(C) {
    if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
      var B, Q;
      if (C.beta)
        B = new A(C.beta, 16).toRed(this.red);
      else {
        var P = this._getEndoRoots(this.p);
        B = P[0].cmp(P[1]) < 0 ? P[0] : P[1], B = B.toRed(this.red);
      }
      if (C.lambda)
        Q = new A(C.lambda, 16);
      else {
        var x = this._getEndoRoots(this.n);
        this.g.mul(x[0]).x.cmp(this.g.x.redMul(B)) === 0 ? Q = x[0] : (Q = x[1], t(this.g.mul(Q).x.cmp(this.g.x.redMul(B)) === 0));
      }
      var M;
      return C.basis ? M = C.basis.map(function(F) {
        return {
          a: new A(F.a, 16),
          b: new A(F.b, 16)
        };
      }) : M = this._getEndoBasis(Q), {
        beta: B,
        lambda: Q,
        basis: M
      };
    }
  }, l.prototype._getEndoRoots = function(C) {
    var B = C === this.p ? this.red : A.mont(C), Q = new A(2).toRed(B).redInvm(), P = Q.redNeg(), x = new A(3).toRed(B).redNeg().redSqrt().redMul(Q), M = P.redAdd(x).fromRed(), F = P.redSub(x).fromRed();
    return [M, F];
  }, l.prototype._getEndoBasis = function(C) {
    for (var B = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), Q = C, P = this.n.clone(), x = new A(1), M = new A(0), F = new A(0), le = new A(1), ge, pe, Ie, be, Pe, Te, Qe, xe = 0, Ee, He; Q.cmpn(0) !== 0; ) {
      var ve = P.div(Q);
      Ee = P.sub(ve.mul(Q)), He = F.sub(ve.mul(x));
      var we = le.sub(ve.mul(M));
      if (!Ie && Ee.cmp(B) < 0)
        ge = Qe.neg(), pe = x, Ie = Ee.neg(), be = He;
      else if (Ie && ++xe === 2)
        break;
      Qe = Ee, P = Q, Q = Ee, F = x, x = He, le = M, M = we;
    }
    Pe = Ee.neg(), Te = He;
    var Ce = Ie.sqr().add(be.sqr()), Se = Pe.sqr().add(Te.sqr());
    return Se.cmp(Ce) >= 0 && (Pe = ge, Te = pe), Ie.negative && (Ie = Ie.neg(), be = be.neg()), Pe.negative && (Pe = Pe.neg(), Te = Te.neg()), [
      { a: Ie, b: be },
      { a: Pe, b: Te }
    ];
  }, l.prototype._endoSplit = function(C) {
    var B = this.endo.basis, Q = B[0], P = B[1], x = P.b.mul(C).divRound(this.n), M = Q.b.neg().mul(C).divRound(this.n), F = x.mul(Q.a), le = M.mul(P.a), ge = x.mul(Q.b), pe = M.mul(P.b), Ie = C.sub(F).sub(le), be = ge.add(pe).neg();
    return { k1: Ie, k2: be };
  }, l.prototype.pointFromX = function(C, B) {
    C = new A(C, 16), C.red || (C = C.toRed(this.red));
    var Q = C.redSqr().redMul(C).redIAdd(C.redMul(this.a)).redIAdd(this.b), P = Q.redSqrt();
    if (P.redSqr().redSub(Q).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var x = P.fromRed().isOdd();
    return (B && !x || !B && x) && (P = P.redNeg()), this.point(C, P);
  }, l.prototype.validate = function(C) {
    if (C.inf)
      return !0;
    var B = C.x, Q = C.y, P = this.a.redMul(B), x = B.redSqr().redMul(B).redIAdd(P).redIAdd(this.b);
    return Q.redSqr().redISub(x).cmpn(0) === 0;
  }, l.prototype._endoWnafMulAdd = function(C, B, Q) {
    for (var P = this._endoWnafT1, x = this._endoWnafT2, M = 0; M < C.length; M++) {
      var F = this._endoSplit(B[M]), le = C[M], ge = le._getBeta();
      F.k1.negative && (F.k1.ineg(), le = le.neg(!0)), F.k2.negative && (F.k2.ineg(), ge = ge.neg(!0)), P[M * 2] = le, P[M * 2 + 1] = ge, x[M * 2] = F.k1, x[M * 2 + 1] = F.k2;
    }
    for (var pe = this._wnafMulAdd(1, P, x, M * 2, Q), Ie = 0; Ie < M * 2; Ie++)
      P[Ie] = null, x[Ie] = null;
    return pe;
  };
  function m(k, C, B, Q) {
    p.BasePoint.call(this, k, "affine"), C === null && B === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new A(C, 16), this.y = new A(B, 16), Q && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
  }
  u(m, p.BasePoint), l.prototype.point = function(C, B, Q) {
    return new m(this, C, B, Q);
  }, l.prototype.pointFromJSON = function(C, B) {
    return m.fromJSON(this, C, B);
  }, m.prototype._getBeta = function() {
    if (this.curve.endo) {
      var C = this.precomputed;
      if (C && C.beta)
        return C.beta;
      var B = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
      if (C) {
        var Q = this.curve, P = function(x) {
          return Q.point(x.x.redMul(Q.endo.beta), x.y);
        };
        C.beta = B, B.precomputed = {
          beta: null,
          naf: C.naf && {
            wnd: C.naf.wnd,
            points: C.naf.points.map(P)
          },
          doubles: C.doubles && {
            step: C.doubles.step,
            points: C.doubles.points.map(P)
          }
        };
      }
      return B;
    }
  }, m.prototype.toJSON = function() {
    return this.precomputed ? [this.x, this.y, this.precomputed && {
      doubles: this.precomputed.doubles && {
        step: this.precomputed.doubles.step,
        points: this.precomputed.doubles.points.slice(1)
      },
      naf: this.precomputed.naf && {
        wnd: this.precomputed.naf.wnd,
        points: this.precomputed.naf.points.slice(1)
      }
    }] : [this.x, this.y];
  }, m.fromJSON = function(C, B, Q) {
    typeof B == "string" && (B = JSON.parse(B));
    var P = C.point(B[0], B[1], Q);
    if (!B[2])
      return P;
    function x(F) {
      return C.point(F[0], F[1], Q);
    }
    var M = B[2];
    return P.precomputed = {
      beta: null,
      doubles: M.doubles && {
        step: M.doubles.step,
        points: [P].concat(M.doubles.points.map(x))
      },
      naf: M.naf && {
        wnd: M.naf.wnd,
        points: [P].concat(M.naf.points.map(x))
      }
    }, P;
  }, m.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
  }, m.prototype.isInfinity = function() {
    return this.inf;
  }, m.prototype.add = function(C) {
    if (this.inf)
      return C;
    if (C.inf)
      return this;
    if (this.eq(C))
      return this.dbl();
    if (this.neg().eq(C))
      return this.curve.point(null, null);
    if (this.x.cmp(C.x) === 0)
      return this.curve.point(null, null);
    var B = this.y.redSub(C.y);
    B.cmpn(0) !== 0 && (B = B.redMul(this.x.redSub(C.x).redInvm()));
    var Q = B.redSqr().redISub(this.x).redISub(C.x), P = B.redMul(this.x.redSub(Q)).redISub(this.y);
    return this.curve.point(Q, P);
  }, m.prototype.dbl = function() {
    if (this.inf)
      return this;
    var C = this.y.redAdd(this.y);
    if (C.cmpn(0) === 0)
      return this.curve.point(null, null);
    var B = this.curve.a, Q = this.x.redSqr(), P = C.redInvm(), x = Q.redAdd(Q).redIAdd(Q).redIAdd(B).redMul(P), M = x.redSqr().redISub(this.x.redAdd(this.x)), F = x.redMul(this.x.redSub(M)).redISub(this.y);
    return this.curve.point(M, F);
  }, m.prototype.getX = function() {
    return this.x.fromRed();
  }, m.prototype.getY = function() {
    return this.y.fromRed();
  }, m.prototype.mul = function(C) {
    return C = new A(C, 16), this.isInfinity() ? this : this._hasDoubles(C) ? this.curve._fixedNafMul(this, C) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [C]) : this.curve._wnafMul(this, C);
  }, m.prototype.mulAdd = function(C, B, Q) {
    var P = [this, B], x = [C, Q];
    return this.curve.endo ? this.curve._endoWnafMulAdd(P, x) : this.curve._wnafMulAdd(1, P, x, 2);
  }, m.prototype.jmulAdd = function(C, B, Q) {
    var P = [this, B], x = [C, Q];
    return this.curve.endo ? this.curve._endoWnafMulAdd(P, x, !0) : this.curve._wnafMulAdd(1, P, x, 2, !0);
  }, m.prototype.eq = function(C) {
    return this === C || this.inf === C.inf && (this.inf || this.x.cmp(C.x) === 0 && this.y.cmp(C.y) === 0);
  }, m.prototype.neg = function(C) {
    if (this.inf)
      return this;
    var B = this.curve.point(this.x, this.y.redNeg());
    if (C && this.precomputed) {
      var Q = this.precomputed, P = function(x) {
        return x.neg();
      };
      B.precomputed = {
        naf: Q.naf && {
          wnd: Q.naf.wnd,
          points: Q.naf.points.map(P)
        },
        doubles: Q.doubles && {
          step: Q.doubles.step,
          points: Q.doubles.points.map(P)
        }
      };
    }
    return B;
  }, m.prototype.toJ = function() {
    if (this.inf)
      return this.curve.jpoint(null, null, null);
    var C = this.curve.jpoint(this.x, this.y, this.curve.one);
    return C;
  };
  function b(k, C, B, Q) {
    p.BasePoint.call(this, k, "jacobian"), C === null && B === null && Q === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new A(0)) : (this.x = new A(C, 16), this.y = new A(B, 16), this.z = new A(Q, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
  }
  return u(b, p.BasePoint), l.prototype.jpoint = function(C, B, Q) {
    return new b(this, C, B, Q);
  }, b.prototype.toP = function() {
    if (this.isInfinity())
      return this.curve.point(null, null);
    var C = this.z.redInvm(), B = C.redSqr(), Q = this.x.redMul(B), P = this.y.redMul(B).redMul(C);
    return this.curve.point(Q, P);
  }, b.prototype.neg = function() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
  }, b.prototype.add = function(C) {
    if (this.isInfinity())
      return C;
    if (C.isInfinity())
      return this;
    var B = C.z.redSqr(), Q = this.z.redSqr(), P = this.x.redMul(B), x = C.x.redMul(Q), M = this.y.redMul(B.redMul(C.z)), F = C.y.redMul(Q.redMul(this.z)), le = P.redSub(x), ge = M.redSub(F);
    if (le.cmpn(0) === 0)
      return ge.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var pe = le.redSqr(), Ie = pe.redMul(le), be = P.redMul(pe), Pe = ge.redSqr().redIAdd(Ie).redISub(be).redISub(be), Te = ge.redMul(be.redISub(Pe)).redISub(M.redMul(Ie)), Qe = this.z.redMul(C.z).redMul(le);
    return this.curve.jpoint(Pe, Te, Qe);
  }, b.prototype.mixedAdd = function(C) {
    if (this.isInfinity())
      return C.toJ();
    if (C.isInfinity())
      return this;
    var B = this.z.redSqr(), Q = this.x, P = C.x.redMul(B), x = this.y, M = C.y.redMul(B).redMul(this.z), F = Q.redSub(P), le = x.redSub(M);
    if (F.cmpn(0) === 0)
      return le.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var ge = F.redSqr(), pe = ge.redMul(F), Ie = Q.redMul(ge), be = le.redSqr().redIAdd(pe).redISub(Ie).redISub(Ie), Pe = le.redMul(Ie.redISub(be)).redISub(x.redMul(pe)), Te = this.z.redMul(F);
    return this.curve.jpoint(be, Pe, Te);
  }, b.prototype.dblp = function(C) {
    if (C === 0)
      return this;
    if (this.isInfinity())
      return this;
    if (!C)
      return this.dbl();
    var B;
    if (this.curve.zeroA || this.curve.threeA) {
      var Q = this;
      for (B = 0; B < C; B++)
        Q = Q.dbl();
      return Q;
    }
    var P = this.curve.a, x = this.curve.tinv, M = this.x, F = this.y, le = this.z, ge = le.redSqr().redSqr(), pe = F.redAdd(F);
    for (B = 0; B < C; B++) {
      var Ie = M.redSqr(), be = pe.redSqr(), Pe = be.redSqr(), Te = Ie.redAdd(Ie).redIAdd(Ie).redIAdd(P.redMul(ge)), Qe = M.redMul(be), xe = Te.redSqr().redISub(Qe.redAdd(Qe)), Ee = Qe.redISub(xe), He = Te.redMul(Ee);
      He = He.redIAdd(He).redISub(Pe);
      var ve = pe.redMul(le);
      B + 1 < C && (ge = ge.redMul(Pe)), M = xe, le = ve, pe = He;
    }
    return this.curve.jpoint(M, pe.redMul(x), le);
  }, b.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
  }, b.prototype._zeroDbl = function() {
    var C, B, Q;
    if (this.zOne) {
      var P = this.x.redSqr(), x = this.y.redSqr(), M = x.redSqr(), F = this.x.redAdd(x).redSqr().redISub(P).redISub(M);
      F = F.redIAdd(F);
      var le = P.redAdd(P).redIAdd(P), ge = le.redSqr().redISub(F).redISub(F), pe = M.redIAdd(M);
      pe = pe.redIAdd(pe), pe = pe.redIAdd(pe), C = ge, B = le.redMul(F.redISub(ge)).redISub(pe), Q = this.y.redAdd(this.y);
    } else {
      var Ie = this.x.redSqr(), be = this.y.redSqr(), Pe = be.redSqr(), Te = this.x.redAdd(be).redSqr().redISub(Ie).redISub(Pe);
      Te = Te.redIAdd(Te);
      var Qe = Ie.redAdd(Ie).redIAdd(Ie), xe = Qe.redSqr(), Ee = Pe.redIAdd(Pe);
      Ee = Ee.redIAdd(Ee), Ee = Ee.redIAdd(Ee), C = xe.redISub(Te).redISub(Te), B = Qe.redMul(Te.redISub(C)).redISub(Ee), Q = this.y.redMul(this.z), Q = Q.redIAdd(Q);
    }
    return this.curve.jpoint(C, B, Q);
  }, b.prototype._threeDbl = function() {
    var C, B, Q;
    if (this.zOne) {
      var P = this.x.redSqr(), x = this.y.redSqr(), M = x.redSqr(), F = this.x.redAdd(x).redSqr().redISub(P).redISub(M);
      F = F.redIAdd(F);
      var le = P.redAdd(P).redIAdd(P).redIAdd(this.curve.a), ge = le.redSqr().redISub(F).redISub(F);
      C = ge;
      var pe = M.redIAdd(M);
      pe = pe.redIAdd(pe), pe = pe.redIAdd(pe), B = le.redMul(F.redISub(ge)).redISub(pe), Q = this.y.redAdd(this.y);
    } else {
      var Ie = this.z.redSqr(), be = this.y.redSqr(), Pe = this.x.redMul(be), Te = this.x.redSub(Ie).redMul(this.x.redAdd(Ie));
      Te = Te.redAdd(Te).redIAdd(Te);
      var Qe = Pe.redIAdd(Pe);
      Qe = Qe.redIAdd(Qe);
      var xe = Qe.redAdd(Qe);
      C = Te.redSqr().redISub(xe), Q = this.y.redAdd(this.z).redSqr().redISub(be).redISub(Ie);
      var Ee = be.redSqr();
      Ee = Ee.redIAdd(Ee), Ee = Ee.redIAdd(Ee), Ee = Ee.redIAdd(Ee), B = Te.redMul(Qe.redISub(C)).redISub(Ee);
    }
    return this.curve.jpoint(C, B, Q);
  }, b.prototype._dbl = function() {
    var C = this.curve.a, B = this.x, Q = this.y, P = this.z, x = P.redSqr().redSqr(), M = B.redSqr(), F = Q.redSqr(), le = M.redAdd(M).redIAdd(M).redIAdd(C.redMul(x)), ge = B.redAdd(B);
    ge = ge.redIAdd(ge);
    var pe = ge.redMul(F), Ie = le.redSqr().redISub(pe.redAdd(pe)), be = pe.redISub(Ie), Pe = F.redSqr();
    Pe = Pe.redIAdd(Pe), Pe = Pe.redIAdd(Pe), Pe = Pe.redIAdd(Pe);
    var Te = le.redMul(be).redISub(Pe), Qe = Q.redAdd(Q).redMul(P);
    return this.curve.jpoint(Ie, Te, Qe);
  }, b.prototype.trpl = function() {
    if (!this.curve.zeroA)
      return this.dbl().add(this);
    var C = this.x.redSqr(), B = this.y.redSqr(), Q = this.z.redSqr(), P = B.redSqr(), x = C.redAdd(C).redIAdd(C), M = x.redSqr(), F = this.x.redAdd(B).redSqr().redISub(C).redISub(P);
    F = F.redIAdd(F), F = F.redAdd(F).redIAdd(F), F = F.redISub(M);
    var le = F.redSqr(), ge = P.redIAdd(P);
    ge = ge.redIAdd(ge), ge = ge.redIAdd(ge), ge = ge.redIAdd(ge);
    var pe = x.redIAdd(F).redSqr().redISub(M).redISub(le).redISub(ge), Ie = B.redMul(pe);
    Ie = Ie.redIAdd(Ie), Ie = Ie.redIAdd(Ie);
    var be = this.x.redMul(le).redISub(Ie);
    be = be.redIAdd(be), be = be.redIAdd(be);
    var Pe = this.y.redMul(pe.redMul(ge.redISub(pe)).redISub(F.redMul(le)));
    Pe = Pe.redIAdd(Pe), Pe = Pe.redIAdd(Pe), Pe = Pe.redIAdd(Pe);
    var Te = this.z.redAdd(F).redSqr().redISub(Q).redISub(le);
    return this.curve.jpoint(be, Pe, Te);
  }, b.prototype.mul = function(C, B) {
    return C = new A(C, B), this.curve._wnafMul(this, C);
  }, b.prototype.eq = function(C) {
    if (C.type === "affine")
      return this.eq(C.toJ());
    if (this === C)
      return !0;
    var B = this.z.redSqr(), Q = C.z.redSqr();
    if (this.x.redMul(Q).redISub(C.x.redMul(B)).cmpn(0) !== 0)
      return !1;
    var P = B.redMul(this.z), x = Q.redMul(C.z);
    return this.y.redMul(x).redISub(C.y.redMul(P)).cmpn(0) === 0;
  }, b.prototype.eqXToP = function(C) {
    var B = this.z.redSqr(), Q = C.toRed(this.curve.red).redMul(B);
    if (this.x.cmp(Q) === 0)
      return !0;
    for (var P = C.clone(), x = this.curve.redN.redMul(B); ; ) {
      if (P.iadd(this.curve.n), P.cmp(this.curve.p) >= 0)
        return !1;
      if (Q.redIAdd(x), this.x.cmp(Q) === 0)
        return !0;
    }
  }, b.prototype.inspect = function() {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
  }, b.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, short;
}
var mont, hasRequiredMont;
function requireMont() {
  if (hasRequiredMont) return mont;
  hasRequiredMont = 1;
  var s = requireBn$1(), A = requireInherits_browser(), u = requireBase$1(), p = requireUtils$9();
  function t(m) {
    u.call(this, "mont", m), this.a = new s(m.a, 16).toRed(this.red), this.b = new s(m.b, 16).toRed(this.red), this.i4 = new s(4).toRed(this.red).redInvm(), this.two = new s(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
  }
  A(t, u), mont = t, t.prototype.validate = function(b) {
    var k = b.normalize().x, C = k.redSqr(), B = C.redMul(k).redAdd(C.redMul(this.a)).redAdd(k), Q = B.redSqrt();
    return Q.redSqr().cmp(B) === 0;
  };
  function l(m, b, k) {
    u.BasePoint.call(this, m, "projective"), b === null && k === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new s(b, 16), this.z = new s(k, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
  }
  return A(l, u.BasePoint), t.prototype.decodePoint = function(b, k) {
    return this.point(p.toArray(b, k), 1);
  }, t.prototype.point = function(b, k) {
    return new l(this, b, k);
  }, t.prototype.pointFromJSON = function(b) {
    return l.fromJSON(this, b);
  }, l.prototype.precompute = function() {
  }, l.prototype._encode = function() {
    return this.getX().toArray("be", this.curve.p.byteLength());
  }, l.fromJSON = function(b, k) {
    return new l(b, k[0], k[1] || b.one);
  }, l.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, l.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, l.prototype.dbl = function() {
    var b = this.x.redAdd(this.z), k = b.redSqr(), C = this.x.redSub(this.z), B = C.redSqr(), Q = k.redSub(B), P = k.redMul(B), x = Q.redMul(B.redAdd(this.curve.a24.redMul(Q)));
    return this.curve.point(P, x);
  }, l.prototype.add = function() {
    throw new Error("Not supported on Montgomery curve");
  }, l.prototype.diffAdd = function(b, k) {
    var C = this.x.redAdd(this.z), B = this.x.redSub(this.z), Q = b.x.redAdd(b.z), P = b.x.redSub(b.z), x = P.redMul(C), M = Q.redMul(B), F = k.z.redMul(x.redAdd(M).redSqr()), le = k.x.redMul(x.redISub(M).redSqr());
    return this.curve.point(F, le);
  }, l.prototype.mul = function(b) {
    for (var k = b.clone(), C = this, B = this.curve.point(null, null), Q = this, P = []; k.cmpn(0) !== 0; k.iushrn(1))
      P.push(k.andln(1));
    for (var x = P.length - 1; x >= 0; x--)
      P[x] === 0 ? (C = C.diffAdd(B, Q), B = B.dbl()) : (B = C.diffAdd(B, Q), C = C.dbl());
    return B;
  }, l.prototype.mulAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, l.prototype.jumlAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, l.prototype.eq = function(b) {
    return this.getX().cmp(b.getX()) === 0;
  }, l.prototype.normalize = function() {
    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
  }, l.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, mont;
}
var edwards$1, hasRequiredEdwards$1;
function requireEdwards$1() {
  if (hasRequiredEdwards$1) return edwards$1;
  hasRequiredEdwards$1 = 1;
  var s = requireUtils$9(), A = requireBn$1(), u = requireInherits_browser(), p = requireBase$1(), t = s.assert;
  function l(b) {
    this.twisted = (b.a | 0) !== 1, this.mOneA = this.twisted && (b.a | 0) === -1, this.extended = this.mOneA, p.call(this, "edwards", b), this.a = new A(b.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new A(b.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new A(b.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), t(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (b.c | 0) === 1;
  }
  u(l, p), edwards$1 = l, l.prototype._mulA = function(k) {
    return this.mOneA ? k.redNeg() : this.a.redMul(k);
  }, l.prototype._mulC = function(k) {
    return this.oneC ? k : this.c.redMul(k);
  }, l.prototype.jpoint = function(k, C, B, Q) {
    return this.point(k, C, B, Q);
  }, l.prototype.pointFromX = function(k, C) {
    k = new A(k, 16), k.red || (k = k.toRed(this.red));
    var B = k.redSqr(), Q = this.c2.redSub(this.a.redMul(B)), P = this.one.redSub(this.c2.redMul(this.d).redMul(B)), x = Q.redMul(P.redInvm()), M = x.redSqrt();
    if (M.redSqr().redSub(x).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var F = M.fromRed().isOdd();
    return (C && !F || !C && F) && (M = M.redNeg()), this.point(k, M);
  }, l.prototype.pointFromY = function(k, C) {
    k = new A(k, 16), k.red || (k = k.toRed(this.red));
    var B = k.redSqr(), Q = B.redSub(this.c2), P = B.redMul(this.d).redMul(this.c2).redSub(this.a), x = Q.redMul(P.redInvm());
    if (x.cmp(this.zero) === 0) {
      if (C)
        throw new Error("invalid point");
      return this.point(this.zero, k);
    }
    var M = x.redSqrt();
    if (M.redSqr().redSub(x).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    return M.fromRed().isOdd() !== C && (M = M.redNeg()), this.point(M, k);
  }, l.prototype.validate = function(k) {
    if (k.isInfinity())
      return !0;
    k.normalize();
    var C = k.x.redSqr(), B = k.y.redSqr(), Q = C.redMul(this.a).redAdd(B), P = this.c2.redMul(this.one.redAdd(this.d.redMul(C).redMul(B)));
    return Q.cmp(P) === 0;
  };
  function m(b, k, C, B, Q) {
    p.BasePoint.call(this, b, "projective"), k === null && C === null && B === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new A(k, 16), this.y = new A(C, 16), this.z = B ? new A(B, 16) : this.curve.one, this.t = Q && new A(Q, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
  }
  return u(m, p.BasePoint), l.prototype.pointFromJSON = function(k) {
    return m.fromJSON(this, k);
  }, l.prototype.point = function(k, C, B, Q) {
    return new m(this, k, C, B, Q);
  }, m.fromJSON = function(k, C) {
    return new m(k, C[0], C[1], C[2]);
  }, m.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, m.prototype.isInfinity = function() {
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
  }, m.prototype._extDbl = function() {
    var k = this.x.redSqr(), C = this.y.redSqr(), B = this.z.redSqr();
    B = B.redIAdd(B);
    var Q = this.curve._mulA(k), P = this.x.redAdd(this.y).redSqr().redISub(k).redISub(C), x = Q.redAdd(C), M = x.redSub(B), F = Q.redSub(C), le = P.redMul(M), ge = x.redMul(F), pe = P.redMul(F), Ie = M.redMul(x);
    return this.curve.point(le, ge, Ie, pe);
  }, m.prototype._projDbl = function() {
    var k = this.x.redAdd(this.y).redSqr(), C = this.x.redSqr(), B = this.y.redSqr(), Q, P, x, M, F, le;
    if (this.curve.twisted) {
      M = this.curve._mulA(C);
      var ge = M.redAdd(B);
      this.zOne ? (Q = k.redSub(C).redSub(B).redMul(ge.redSub(this.curve.two)), P = ge.redMul(M.redSub(B)), x = ge.redSqr().redSub(ge).redSub(ge)) : (F = this.z.redSqr(), le = ge.redSub(F).redISub(F), Q = k.redSub(C).redISub(B).redMul(le), P = ge.redMul(M.redSub(B)), x = ge.redMul(le));
    } else
      M = C.redAdd(B), F = this.curve._mulC(this.z).redSqr(), le = M.redSub(F).redSub(F), Q = this.curve._mulC(k.redISub(M)).redMul(le), P = this.curve._mulC(M).redMul(C.redISub(B)), x = M.redMul(le);
    return this.curve.point(Q, P, x);
  }, m.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
  }, m.prototype._extAdd = function(k) {
    var C = this.y.redSub(this.x).redMul(k.y.redSub(k.x)), B = this.y.redAdd(this.x).redMul(k.y.redAdd(k.x)), Q = this.t.redMul(this.curve.dd).redMul(k.t), P = this.z.redMul(k.z.redAdd(k.z)), x = B.redSub(C), M = P.redSub(Q), F = P.redAdd(Q), le = B.redAdd(C), ge = x.redMul(M), pe = F.redMul(le), Ie = x.redMul(le), be = M.redMul(F);
    return this.curve.point(ge, pe, be, Ie);
  }, m.prototype._projAdd = function(k) {
    var C = this.z.redMul(k.z), B = C.redSqr(), Q = this.x.redMul(k.x), P = this.y.redMul(k.y), x = this.curve.d.redMul(Q).redMul(P), M = B.redSub(x), F = B.redAdd(x), le = this.x.redAdd(this.y).redMul(k.x.redAdd(k.y)).redISub(Q).redISub(P), ge = C.redMul(M).redMul(le), pe, Ie;
    return this.curve.twisted ? (pe = C.redMul(F).redMul(P.redSub(this.curve._mulA(Q))), Ie = M.redMul(F)) : (pe = C.redMul(F).redMul(P.redSub(Q)), Ie = this.curve._mulC(M).redMul(F)), this.curve.point(ge, pe, Ie);
  }, m.prototype.add = function(k) {
    return this.isInfinity() ? k : k.isInfinity() ? this : this.curve.extended ? this._extAdd(k) : this._projAdd(k);
  }, m.prototype.mul = function(k) {
    return this._hasDoubles(k) ? this.curve._fixedNafMul(this, k) : this.curve._wnafMul(this, k);
  }, m.prototype.mulAdd = function(k, C, B) {
    return this.curve._wnafMulAdd(1, [this, C], [k, B], 2, !1);
  }, m.prototype.jmulAdd = function(k, C, B) {
    return this.curve._wnafMulAdd(1, [this, C], [k, B], 2, !0);
  }, m.prototype.normalize = function() {
    if (this.zOne)
      return this;
    var k = this.z.redInvm();
    return this.x = this.x.redMul(k), this.y = this.y.redMul(k), this.t && (this.t = this.t.redMul(k)), this.z = this.curve.one, this.zOne = !0, this;
  }, m.prototype.neg = function() {
    return this.curve.point(
      this.x.redNeg(),
      this.y,
      this.z,
      this.t && this.t.redNeg()
    );
  }, m.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, m.prototype.getY = function() {
    return this.normalize(), this.y.fromRed();
  }, m.prototype.eq = function(k) {
    return this === k || this.getX().cmp(k.getX()) === 0 && this.getY().cmp(k.getY()) === 0;
  }, m.prototype.eqXToP = function(k) {
    var C = k.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(C) === 0)
      return !0;
    for (var B = k.clone(), Q = this.curve.redN.redMul(this.z); ; ) {
      if (B.iadd(this.curve.n), B.cmp(this.curve.p) >= 0)
        return !1;
      if (C.redIAdd(Q), this.x.cmp(C) === 0)
        return !0;
    }
  }, m.prototype.toP = m.prototype.normalize, m.prototype.mixedAdd = m.prototype.add, edwards$1;
}
var hasRequiredCurve$1;
function requireCurve$1() {
  return hasRequiredCurve$1 || (hasRequiredCurve$1 = 1, function(s) {
    var A = s;
    A.base = requireBase$1(), A.short = requireShort(), A.mont = requireMont(), A.edwards = requireEdwards$1();
  }(curve$1)), curve$1;
}
var curves = {}, hash$p = {}, utils$a = {}, hasRequiredUtils$8;
function requireUtils$8() {
  if (hasRequiredUtils$8) return utils$a;
  hasRequiredUtils$8 = 1;
  var s = requireMinimalisticAssert(), A = requireInherits_browser();
  utils$a.inherits = A;
  function u(we, Ce) {
    return (we.charCodeAt(Ce) & 64512) !== 55296 || Ce < 0 || Ce + 1 >= we.length ? !1 : (we.charCodeAt(Ce + 1) & 64512) === 56320;
  }
  function p(we, Ce) {
    if (Array.isArray(we))
      return we.slice();
    if (!we)
      return [];
    var Se = [];
    if (typeof we == "string")
      if (Ce) {
        if (Ce === "hex")
          for (we = we.replace(/[^a-z0-9]+/ig, ""), we.length % 2 !== 0 && (we = "0" + we), rr = 0; rr < we.length; rr += 2)
            Se.push(parseInt(we[rr] + we[rr + 1], 16));
      } else for (var Ne = 0, rr = 0; rr < we.length; rr++) {
        var er = we.charCodeAt(rr);
        er < 128 ? Se[Ne++] = er : er < 2048 ? (Se[Ne++] = er >> 6 | 192, Se[Ne++] = er & 63 | 128) : u(we, rr) ? (er = 65536 + ((er & 1023) << 10) + (we.charCodeAt(++rr) & 1023), Se[Ne++] = er >> 18 | 240, Se[Ne++] = er >> 12 & 63 | 128, Se[Ne++] = er >> 6 & 63 | 128, Se[Ne++] = er & 63 | 128) : (Se[Ne++] = er >> 12 | 224, Se[Ne++] = er >> 6 & 63 | 128, Se[Ne++] = er & 63 | 128);
      }
    else
      for (rr = 0; rr < we.length; rr++)
        Se[rr] = we[rr] | 0;
    return Se;
  }
  utils$a.toArray = p;
  function t(we) {
    for (var Ce = "", Se = 0; Se < we.length; Se++)
      Ce += b(we[Se].toString(16));
    return Ce;
  }
  utils$a.toHex = t;
  function l(we) {
    var Ce = we >>> 24 | we >>> 8 & 65280 | we << 8 & 16711680 | (we & 255) << 24;
    return Ce >>> 0;
  }
  utils$a.htonl = l;
  function m(we, Ce) {
    for (var Se = "", Ne = 0; Ne < we.length; Ne++) {
      var rr = we[Ne];
      Ce === "little" && (rr = l(rr)), Se += k(rr.toString(16));
    }
    return Se;
  }
  utils$a.toHex32 = m;
  function b(we) {
    return we.length === 1 ? "0" + we : we;
  }
  utils$a.zero2 = b;
  function k(we) {
    return we.length === 7 ? "0" + we : we.length === 6 ? "00" + we : we.length === 5 ? "000" + we : we.length === 4 ? "0000" + we : we.length === 3 ? "00000" + we : we.length === 2 ? "000000" + we : we.length === 1 ? "0000000" + we : we;
  }
  utils$a.zero8 = k;
  function C(we, Ce, Se, Ne) {
    var rr = Se - Ce;
    s(rr % 4 === 0);
    for (var er = new Array(rr / 4), ir = 0, sr = Ce; ir < er.length; ir++, sr += 4) {
      var nr;
      Ne === "big" ? nr = we[sr] << 24 | we[sr + 1] << 16 | we[sr + 2] << 8 | we[sr + 3] : nr = we[sr + 3] << 24 | we[sr + 2] << 16 | we[sr + 1] << 8 | we[sr], er[ir] = nr >>> 0;
    }
    return er;
  }
  utils$a.join32 = C;
  function B(we, Ce) {
    for (var Se = new Array(we.length * 4), Ne = 0, rr = 0; Ne < we.length; Ne++, rr += 4) {
      var er = we[Ne];
      Ce === "big" ? (Se[rr] = er >>> 24, Se[rr + 1] = er >>> 16 & 255, Se[rr + 2] = er >>> 8 & 255, Se[rr + 3] = er & 255) : (Se[rr + 3] = er >>> 24, Se[rr + 2] = er >>> 16 & 255, Se[rr + 1] = er >>> 8 & 255, Se[rr] = er & 255);
    }
    return Se;
  }
  utils$a.split32 = B;
  function Q(we, Ce) {
    return we >>> Ce | we << 32 - Ce;
  }
  utils$a.rotr32 = Q;
  function P(we, Ce) {
    return we << Ce | we >>> 32 - Ce;
  }
  utils$a.rotl32 = P;
  function x(we, Ce) {
    return we + Ce >>> 0;
  }
  utils$a.sum32 = x;
  function M(we, Ce, Se) {
    return we + Ce + Se >>> 0;
  }
  utils$a.sum32_3 = M;
  function F(we, Ce, Se, Ne) {
    return we + Ce + Se + Ne >>> 0;
  }
  utils$a.sum32_4 = F;
  function le(we, Ce, Se, Ne, rr) {
    return we + Ce + Se + Ne + rr >>> 0;
  }
  utils$a.sum32_5 = le;
  function ge(we, Ce, Se, Ne) {
    var rr = we[Ce], er = we[Ce + 1], ir = Ne + er >>> 0, sr = (ir < Ne ? 1 : 0) + Se + rr;
    we[Ce] = sr >>> 0, we[Ce + 1] = ir;
  }
  utils$a.sum64 = ge;
  function pe(we, Ce, Se, Ne) {
    var rr = Ce + Ne >>> 0, er = (rr < Ce ? 1 : 0) + we + Se;
    return er >>> 0;
  }
  utils$a.sum64_hi = pe;
  function Ie(we, Ce, Se, Ne) {
    var rr = Ce + Ne;
    return rr >>> 0;
  }
  utils$a.sum64_lo = Ie;
  function be(we, Ce, Se, Ne, rr, er, ir, sr) {
    var nr = 0, fr = Ce;
    fr = fr + Ne >>> 0, nr += fr < Ce ? 1 : 0, fr = fr + er >>> 0, nr += fr < er ? 1 : 0, fr = fr + sr >>> 0, nr += fr < sr ? 1 : 0;
    var lr = we + Se + rr + ir + nr;
    return lr >>> 0;
  }
  utils$a.sum64_4_hi = be;
  function Pe(we, Ce, Se, Ne, rr, er, ir, sr) {
    var nr = Ce + Ne + er + sr;
    return nr >>> 0;
  }
  utils$a.sum64_4_lo = Pe;
  function Te(we, Ce, Se, Ne, rr, er, ir, sr, nr, fr) {
    var lr = 0, br = Ce;
    br = br + Ne >>> 0, lr += br < Ce ? 1 : 0, br = br + er >>> 0, lr += br < er ? 1 : 0, br = br + sr >>> 0, lr += br < sr ? 1 : 0, br = br + fr >>> 0, lr += br < fr ? 1 : 0;
    var Br = we + Se + rr + ir + nr + lr;
    return Br >>> 0;
  }
  utils$a.sum64_5_hi = Te;
  function Qe(we, Ce, Se, Ne, rr, er, ir, sr, nr, fr) {
    var lr = Ce + Ne + er + sr + fr;
    return lr >>> 0;
  }
  utils$a.sum64_5_lo = Qe;
  function xe(we, Ce, Se) {
    var Ne = Ce << 32 - Se | we >>> Se;
    return Ne >>> 0;
  }
  utils$a.rotr64_hi = xe;
  function Ee(we, Ce, Se) {
    var Ne = we << 32 - Se | Ce >>> Se;
    return Ne >>> 0;
  }
  utils$a.rotr64_lo = Ee;
  function He(we, Ce, Se) {
    return we >>> Se;
  }
  utils$a.shr64_hi = He;
  function ve(we, Ce, Se) {
    var Ne = we << 32 - Se | Ce >>> Se;
    return Ne >>> 0;
  }
  return utils$a.shr64_lo = ve, utils$a;
}
var common$2 = {}, hasRequiredCommon$2;
function requireCommon$2() {
  if (hasRequiredCommon$2) return common$2;
  hasRequiredCommon$2 = 1;
  var s = requireUtils$8(), A = requireMinimalisticAssert();
  function u() {
    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
  }
  return common$2.BlockHash = u, u.prototype.update = function(t, l) {
    if (t = s.toArray(t, l), this.pending ? this.pending = this.pending.concat(t) : this.pending = t, this.pendingTotal += t.length, this.pending.length >= this._delta8) {
      t = this.pending;
      var m = t.length % this._delta8;
      this.pending = t.slice(t.length - m, t.length), this.pending.length === 0 && (this.pending = null), t = s.join32(t, 0, t.length - m, this.endian);
      for (var b = 0; b < t.length; b += this._delta32)
        this._update(t, b, b + this._delta32);
    }
    return this;
  }, u.prototype.digest = function(t) {
    return this.update(this._pad()), A(this.pending === null), this._digest(t);
  }, u.prototype._pad = function() {
    var t = this.pendingTotal, l = this._delta8, m = l - (t + this.padLength) % l, b = new Array(m + this.padLength);
    b[0] = 128;
    for (var k = 1; k < m; k++)
      b[k] = 0;
    if (t <<= 3, this.endian === "big") {
      for (var C = 8; C < this.padLength; C++)
        b[k++] = 0;
      b[k++] = 0, b[k++] = 0, b[k++] = 0, b[k++] = 0, b[k++] = t >>> 24 & 255, b[k++] = t >>> 16 & 255, b[k++] = t >>> 8 & 255, b[k++] = t & 255;
    } else
      for (b[k++] = t & 255, b[k++] = t >>> 8 & 255, b[k++] = t >>> 16 & 255, b[k++] = t >>> 24 & 255, b[k++] = 0, b[k++] = 0, b[k++] = 0, b[k++] = 0, C = 8; C < this.padLength; C++)
        b[k++] = 0;
    return b;
  }, common$2;
}
var sha$1 = {}, common$1 = {}, hasRequiredCommon$1;
function requireCommon$1() {
  if (hasRequiredCommon$1) return common$1;
  hasRequiredCommon$1 = 1;
  var s = requireUtils$8(), A = s.rotr32;
  function u(B, Q, P, x) {
    if (B === 0)
      return p(Q, P, x);
    if (B === 1 || B === 3)
      return l(Q, P, x);
    if (B === 2)
      return t(Q, P, x);
  }
  common$1.ft_1 = u;
  function p(B, Q, P) {
    return B & Q ^ ~B & P;
  }
  common$1.ch32 = p;
  function t(B, Q, P) {
    return B & Q ^ B & P ^ Q & P;
  }
  common$1.maj32 = t;
  function l(B, Q, P) {
    return B ^ Q ^ P;
  }
  common$1.p32 = l;
  function m(B) {
    return A(B, 2) ^ A(B, 13) ^ A(B, 22);
  }
  common$1.s0_256 = m;
  function b(B) {
    return A(B, 6) ^ A(B, 11) ^ A(B, 25);
  }
  common$1.s1_256 = b;
  function k(B) {
    return A(B, 7) ^ A(B, 18) ^ B >>> 3;
  }
  common$1.g0_256 = k;
  function C(B) {
    return A(B, 17) ^ A(B, 19) ^ B >>> 10;
  }
  return common$1.g1_256 = C, common$1;
}
var _1, hasRequired_1;
function require_1() {
  if (hasRequired_1) return _1;
  hasRequired_1 = 1;
  var s = requireUtils$8(), A = requireCommon$2(), u = requireCommon$1(), p = s.rotl32, t = s.sum32, l = s.sum32_5, m = u.ft_1, b = A.BlockHash, k = [
    1518500249,
    1859775393,
    2400959708,
    3395469782
  ];
  function C() {
    if (!(this instanceof C))
      return new C();
    b.call(this), this.h = [
      1732584193,
      4023233417,
      2562383102,
      271733878,
      3285377520
    ], this.W = new Array(80);
  }
  return s.inherits(C, b), _1 = C, C.blockSize = 512, C.outSize = 160, C.hmacStrength = 80, C.padLength = 64, C.prototype._update = function(Q, P) {
    for (var x = this.W, M = 0; M < 16; M++)
      x[M] = Q[P + M];
    for (; M < x.length; M++)
      x[M] = p(x[M - 3] ^ x[M - 8] ^ x[M - 14] ^ x[M - 16], 1);
    var F = this.h[0], le = this.h[1], ge = this.h[2], pe = this.h[3], Ie = this.h[4];
    for (M = 0; M < x.length; M++) {
      var be = ~~(M / 20), Pe = l(p(F, 5), m(be, le, ge, pe), Ie, x[M], k[be]);
      Ie = pe, pe = ge, ge = p(le, 30), le = F, F = Pe;
    }
    this.h[0] = t(this.h[0], F), this.h[1] = t(this.h[1], le), this.h[2] = t(this.h[2], ge), this.h[3] = t(this.h[3], pe), this.h[4] = t(this.h[4], Ie);
  }, C.prototype._digest = function(Q) {
    return Q === "hex" ? s.toHex32(this.h, "big") : s.split32(this.h, "big");
  }, _1;
}
var _256, hasRequired_256;
function require_256() {
  if (hasRequired_256) return _256;
  hasRequired_256 = 1;
  var s = requireUtils$8(), A = requireCommon$2(), u = requireCommon$1(), p = requireMinimalisticAssert(), t = s.sum32, l = s.sum32_4, m = s.sum32_5, b = u.ch32, k = u.maj32, C = u.s0_256, B = u.s1_256, Q = u.g0_256, P = u.g1_256, x = A.BlockHash, M = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ];
  function F() {
    if (!(this instanceof F))
      return new F();
    x.call(this), this.h = [
      1779033703,
      3144134277,
      1013904242,
      2773480762,
      1359893119,
      2600822924,
      528734635,
      1541459225
    ], this.k = M, this.W = new Array(64);
  }
  return s.inherits(F, x), _256 = F, F.blockSize = 512, F.outSize = 256, F.hmacStrength = 192, F.padLength = 64, F.prototype._update = function(ge, pe) {
    for (var Ie = this.W, be = 0; be < 16; be++)
      Ie[be] = ge[pe + be];
    for (; be < Ie.length; be++)
      Ie[be] = l(P(Ie[be - 2]), Ie[be - 7], Q(Ie[be - 15]), Ie[be - 16]);
    var Pe = this.h[0], Te = this.h[1], Qe = this.h[2], xe = this.h[3], Ee = this.h[4], He = this.h[5], ve = this.h[6], we = this.h[7];
    for (p(this.k.length === Ie.length), be = 0; be < Ie.length; be++) {
      var Ce = m(we, B(Ee), b(Ee, He, ve), this.k[be], Ie[be]), Se = t(C(Pe), k(Pe, Te, Qe));
      we = ve, ve = He, He = Ee, Ee = t(xe, Ce), xe = Qe, Qe = Te, Te = Pe, Pe = t(Ce, Se);
    }
    this.h[0] = t(this.h[0], Pe), this.h[1] = t(this.h[1], Te), this.h[2] = t(this.h[2], Qe), this.h[3] = t(this.h[3], xe), this.h[4] = t(this.h[4], Ee), this.h[5] = t(this.h[5], He), this.h[6] = t(this.h[6], ve), this.h[7] = t(this.h[7], we);
  }, F.prototype._digest = function(ge) {
    return ge === "hex" ? s.toHex32(this.h, "big") : s.split32(this.h, "big");
  }, _256;
}
var _224, hasRequired_224;
function require_224() {
  if (hasRequired_224) return _224;
  hasRequired_224 = 1;
  var s = requireUtils$8(), A = require_256();
  function u() {
    if (!(this instanceof u))
      return new u();
    A.call(this), this.h = [
      3238371032,
      914150663,
      812702999,
      4144912697,
      4290775857,
      1750603025,
      1694076839,
      3204075428
    ];
  }
  return s.inherits(u, A), _224 = u, u.blockSize = 512, u.outSize = 224, u.hmacStrength = 192, u.padLength = 64, u.prototype._digest = function(t) {
    return t === "hex" ? s.toHex32(this.h.slice(0, 7), "big") : s.split32(this.h.slice(0, 7), "big");
  }, _224;
}
var _512, hasRequired_512;
function require_512() {
  if (hasRequired_512) return _512;
  hasRequired_512 = 1;
  var s = requireUtils$8(), A = requireCommon$2(), u = requireMinimalisticAssert(), p = s.rotr64_hi, t = s.rotr64_lo, l = s.shr64_hi, m = s.shr64_lo, b = s.sum64, k = s.sum64_hi, C = s.sum64_lo, B = s.sum64_4_hi, Q = s.sum64_4_lo, P = s.sum64_5_hi, x = s.sum64_5_lo, M = A.BlockHash, F = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ];
  function le() {
    if (!(this instanceof le))
      return new le();
    M.call(this), this.h = [
      1779033703,
      4089235720,
      3144134277,
      2227873595,
      1013904242,
      4271175723,
      2773480762,
      1595750129,
      1359893119,
      2917565137,
      2600822924,
      725511199,
      528734635,
      4215389547,
      1541459225,
      327033209
    ], this.k = F, this.W = new Array(160);
  }
  s.inherits(le, M), _512 = le, le.blockSize = 1024, le.outSize = 512, le.hmacStrength = 192, le.padLength = 128, le.prototype._prepareBlock = function(Se, Ne) {
    for (var rr = this.W, er = 0; er < 32; er++)
      rr[er] = Se[Ne + er];
    for (; er < rr.length; er += 2) {
      var ir = ve(rr[er - 4], rr[er - 3]), sr = we(rr[er - 4], rr[er - 3]), nr = rr[er - 14], fr = rr[er - 13], lr = Ee(rr[er - 30], rr[er - 29]), br = He(rr[er - 30], rr[er - 29]), Br = rr[er - 32], Fr = rr[er - 31];
      rr[er] = B(
        ir,
        sr,
        nr,
        fr,
        lr,
        br,
        Br,
        Fr
      ), rr[er + 1] = Q(
        ir,
        sr,
        nr,
        fr,
        lr,
        br,
        Br,
        Fr
      );
    }
  }, le.prototype._update = function(Se, Ne) {
    this._prepareBlock(Se, Ne);
    var rr = this.W, er = this.h[0], ir = this.h[1], sr = this.h[2], nr = this.h[3], fr = this.h[4], lr = this.h[5], br = this.h[6], Br = this.h[7], Fr = this.h[8], Gr = this.h[9], qr = this.h[10], Hr = this.h[11], un = this.h[12], Dr = this.h[13], wr = this.h[14], yr = this.h[15];
    u(this.k.length === rr.length);
    for (var Qr = 0; Qr < rr.length; Qr += 2) {
      var _r = wr, Jr = yr, fn = Qe(Fr, Gr), jr = xe(Fr, Gr), dn = ge(Fr, Gr, qr, Hr, un), Tn = pe(Fr, Gr, qr, Hr, un, Dr), Yn = this.k[Qr], si = this.k[Qr + 1], vn = rr[Qr], Cn = rr[Qr + 1], Xr = P(
        _r,
        Jr,
        fn,
        jr,
        dn,
        Tn,
        Yn,
        si,
        vn,
        Cn
      ), In = x(
        _r,
        Jr,
        fn,
        jr,
        dn,
        Tn,
        Yn,
        si,
        vn,
        Cn
      );
      _r = Pe(er, ir), Jr = Te(er, ir), fn = Ie(er, ir, sr, nr, fr), jr = be(er, ir, sr, nr, fr, lr);
      var zr = k(_r, Jr, fn, jr), En = C(_r, Jr, fn, jr);
      wr = un, yr = Dr, un = qr, Dr = Hr, qr = Fr, Hr = Gr, Fr = k(br, Br, Xr, In), Gr = C(Br, Br, Xr, In), br = fr, Br = lr, fr = sr, lr = nr, sr = er, nr = ir, er = k(Xr, In, zr, En), ir = C(Xr, In, zr, En);
    }
    b(this.h, 0, er, ir), b(this.h, 2, sr, nr), b(this.h, 4, fr, lr), b(this.h, 6, br, Br), b(this.h, 8, Fr, Gr), b(this.h, 10, qr, Hr), b(this.h, 12, un, Dr), b(this.h, 14, wr, yr);
  }, le.prototype._digest = function(Se) {
    return Se === "hex" ? s.toHex32(this.h, "big") : s.split32(this.h, "big");
  };
  function ge(Ce, Se, Ne, rr, er) {
    var ir = Ce & Ne ^ ~Ce & er;
    return ir < 0 && (ir += 4294967296), ir;
  }
  function pe(Ce, Se, Ne, rr, er, ir) {
    var sr = Se & rr ^ ~Se & ir;
    return sr < 0 && (sr += 4294967296), sr;
  }
  function Ie(Ce, Se, Ne, rr, er) {
    var ir = Ce & Ne ^ Ce & er ^ Ne & er;
    return ir < 0 && (ir += 4294967296), ir;
  }
  function be(Ce, Se, Ne, rr, er, ir) {
    var sr = Se & rr ^ Se & ir ^ rr & ir;
    return sr < 0 && (sr += 4294967296), sr;
  }
  function Pe(Ce, Se) {
    var Ne = p(Ce, Se, 28), rr = p(Se, Ce, 2), er = p(Se, Ce, 7), ir = Ne ^ rr ^ er;
    return ir < 0 && (ir += 4294967296), ir;
  }
  function Te(Ce, Se) {
    var Ne = t(Ce, Se, 28), rr = t(Se, Ce, 2), er = t(Se, Ce, 7), ir = Ne ^ rr ^ er;
    return ir < 0 && (ir += 4294967296), ir;
  }
  function Qe(Ce, Se) {
    var Ne = p(Ce, Se, 14), rr = p(Ce, Se, 18), er = p(Se, Ce, 9), ir = Ne ^ rr ^ er;
    return ir < 0 && (ir += 4294967296), ir;
  }
  function xe(Ce, Se) {
    var Ne = t(Ce, Se, 14), rr = t(Ce, Se, 18), er = t(Se, Ce, 9), ir = Ne ^ rr ^ er;
    return ir < 0 && (ir += 4294967296), ir;
  }
  function Ee(Ce, Se) {
    var Ne = p(Ce, Se, 1), rr = p(Ce, Se, 8), er = l(Ce, Se, 7), ir = Ne ^ rr ^ er;
    return ir < 0 && (ir += 4294967296), ir;
  }
  function He(Ce, Se) {
    var Ne = t(Ce, Se, 1), rr = t(Ce, Se, 8), er = m(Ce, Se, 7), ir = Ne ^ rr ^ er;
    return ir < 0 && (ir += 4294967296), ir;
  }
  function ve(Ce, Se) {
    var Ne = p(Ce, Se, 19), rr = p(Se, Ce, 29), er = l(Ce, Se, 6), ir = Ne ^ rr ^ er;
    return ir < 0 && (ir += 4294967296), ir;
  }
  function we(Ce, Se) {
    var Ne = t(Ce, Se, 19), rr = t(Se, Ce, 29), er = m(Ce, Se, 6), ir = Ne ^ rr ^ er;
    return ir < 0 && (ir += 4294967296), ir;
  }
  return _512;
}
var _384, hasRequired_384;
function require_384() {
  if (hasRequired_384) return _384;
  hasRequired_384 = 1;
  var s = requireUtils$8(), A = require_512();
  function u() {
    if (!(this instanceof u))
      return new u();
    A.call(this), this.h = [
      3418070365,
      3238371032,
      1654270250,
      914150663,
      2438529370,
      812702999,
      355462360,
      4144912697,
      1731405415,
      4290775857,
      2394180231,
      1750603025,
      3675008525,
      1694076839,
      1203062813,
      3204075428
    ];
  }
  return s.inherits(u, A), _384 = u, u.blockSize = 1024, u.outSize = 384, u.hmacStrength = 192, u.padLength = 128, u.prototype._digest = function(t) {
    return t === "hex" ? s.toHex32(this.h.slice(0, 12), "big") : s.split32(this.h.slice(0, 12), "big");
  }, _384;
}
var hasRequiredSha$1;
function requireSha$1() {
  return hasRequiredSha$1 || (hasRequiredSha$1 = 1, sha$1.sha1 = require_1(), sha$1.sha224 = require_224(), sha$1.sha256 = require_256(), sha$1.sha384 = require_384(), sha$1.sha512 = require_512()), sha$1;
}
var ripemd$1 = {}, hasRequiredRipemd$1;
function requireRipemd$1() {
  if (hasRequiredRipemd$1) return ripemd$1;
  hasRequiredRipemd$1 = 1;
  var s = requireUtils$8(), A = requireCommon$2(), u = s.rotl32, p = s.sum32, t = s.sum32_3, l = s.sum32_4, m = A.BlockHash;
  function b() {
    if (!(this instanceof b))
      return new b();
    m.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
  }
  s.inherits(b, m), ripemd$1.ripemd160 = b, b.blockSize = 512, b.outSize = 160, b.hmacStrength = 192, b.padLength = 64, b.prototype._update = function(le, ge) {
    for (var pe = this.h[0], Ie = this.h[1], be = this.h[2], Pe = this.h[3], Te = this.h[4], Qe = pe, xe = Ie, Ee = be, He = Pe, ve = Te, we = 0; we < 80; we++) {
      var Ce = p(
        u(
          l(pe, k(we, Ie, be, Pe), le[Q[we] + ge], C(we)),
          x[we]
        ),
        Te
      );
      pe = Te, Te = Pe, Pe = u(be, 10), be = Ie, Ie = Ce, Ce = p(
        u(
          l(Qe, k(79 - we, xe, Ee, He), le[P[we] + ge], B(we)),
          M[we]
        ),
        ve
      ), Qe = ve, ve = He, He = u(Ee, 10), Ee = xe, xe = Ce;
    }
    Ce = t(this.h[1], be, He), this.h[1] = t(this.h[2], Pe, ve), this.h[2] = t(this.h[3], Te, Qe), this.h[3] = t(this.h[4], pe, xe), this.h[4] = t(this.h[0], Ie, Ee), this.h[0] = Ce;
  }, b.prototype._digest = function(le) {
    return le === "hex" ? s.toHex32(this.h, "little") : s.split32(this.h, "little");
  };
  function k(F, le, ge, pe) {
    return F <= 15 ? le ^ ge ^ pe : F <= 31 ? le & ge | ~le & pe : F <= 47 ? (le | ~ge) ^ pe : F <= 63 ? le & pe | ge & ~pe : le ^ (ge | ~pe);
  }
  function C(F) {
    return F <= 15 ? 0 : F <= 31 ? 1518500249 : F <= 47 ? 1859775393 : F <= 63 ? 2400959708 : 2840853838;
  }
  function B(F) {
    return F <= 15 ? 1352829926 : F <= 31 ? 1548603684 : F <= 47 ? 1836072691 : F <= 63 ? 2053994217 : 0;
  }
  var Q = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], P = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], x = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], M = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ];
  return ripemd$1;
}
var hmac$4, hasRequiredHmac$2;
function requireHmac$2() {
  if (hasRequiredHmac$2) return hmac$4;
  hasRequiredHmac$2 = 1;
  var s = requireUtils$8(), A = requireMinimalisticAssert();
  function u(p, t, l) {
    if (!(this instanceof u))
      return new u(p, t, l);
    this.Hash = p, this.blockSize = p.blockSize / 8, this.outSize = p.outSize / 8, this.inner = null, this.outer = null, this._init(s.toArray(t, l));
  }
  return hmac$4 = u, u.prototype._init = function(t) {
    t.length > this.blockSize && (t = new this.Hash().update(t).digest()), A(t.length <= this.blockSize);
    for (var l = t.length; l < this.blockSize; l++)
      t.push(0);
    for (l = 0; l < t.length; l++)
      t[l] ^= 54;
    for (this.inner = new this.Hash().update(t), l = 0; l < t.length; l++)
      t[l] ^= 106;
    this.outer = new this.Hash().update(t);
  }, u.prototype.update = function(t, l) {
    return this.inner.update(t, l), this;
  }, u.prototype.digest = function(t) {
    return this.outer.update(this.inner.digest()), this.outer.digest(t);
  }, hmac$4;
}
var hasRequiredHash$1;
function requireHash$1() {
  return hasRequiredHash$1 || (hasRequiredHash$1 = 1, function(s) {
    var A = s;
    A.utils = requireUtils$8(), A.common = requireCommon$2(), A.sha = requireSha$1(), A.ripemd = requireRipemd$1(), A.hmac = requireHmac$2(), A.sha1 = A.sha.sha1, A.sha256 = A.sha.sha256, A.sha224 = A.sha.sha224, A.sha384 = A.sha.sha384, A.sha512 = A.sha.sha512, A.ripemd160 = A.ripemd.ripemd160;
  }(hash$p)), hash$p;
}
var secp256k1$6, hasRequiredSecp256k1$4;
function requireSecp256k1$4() {
  return hasRequiredSecp256k1$4 || (hasRequiredSecp256k1$4 = 1, secp256k1$6 = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), secp256k1$6;
}
var hasRequiredCurves;
function requireCurves() {
  return hasRequiredCurves || (hasRequiredCurves = 1, function(s) {
    var A = s, u = requireHash$1(), p = requireCurve$1(), t = requireUtils$9(), l = t.assert;
    function m(C) {
      C.type === "short" ? this.curve = new p.short(C) : C.type === "edwards" ? this.curve = new p.edwards(C) : this.curve = new p.mont(C), this.g = this.curve.g, this.n = this.curve.n, this.hash = C.hash, l(this.g.validate(), "Invalid curve"), l(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    A.PresetCurve = m;
    function b(C, B) {
      Object.defineProperty(A, C, {
        configurable: !0,
        enumerable: !0,
        get: function() {
          var Q = new m(B);
          return Object.defineProperty(A, C, {
            configurable: !0,
            enumerable: !0,
            value: Q
          }), Q;
        }
      });
    }
    b("p192", {
      type: "short",
      prime: "p192",
      p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
      b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
      n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
      hash: u.sha256,
      gRed: !1,
      g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
      ]
    }), b("p224", {
      type: "short",
      prime: "p224",
      p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
      b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
      n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
      hash: u.sha256,
      gRed: !1,
      g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
      ]
    }), b("p256", {
      type: "short",
      prime: null,
      p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
      a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
      b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
      n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
      hash: u.sha256,
      gRed: !1,
      g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
      ]
    }), b("p384", {
      type: "short",
      prime: null,
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
      a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
      b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
      n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
      hash: u.sha384,
      gRed: !1,
      g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
      ]
    }), b("p521", {
      type: "short",
      prime: null,
      p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
      a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
      b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
      n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
      hash: u.sha512,
      gRed: !1,
      g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
      ]
    }), b("curve25519", {
      type: "mont",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "76d06",
      b: "1",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: u.sha256,
      gRed: !1,
      g: [
        "9"
      ]
    }), b("ed25519", {
      type: "edwards",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "-1",
      c: "1",
      // -121665 * (121666^(-1)) (mod P)
      d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: u.sha256,
      gRed: !1,
      g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
      ]
    });
    var k;
    try {
      k = requireSecp256k1$4();
    } catch {
      k = void 0;
    }
    b("secp256k1", {
      type: "short",
      prime: "k256",
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
      a: "0",
      b: "7",
      n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
      h: "1",
      hash: u.sha256,
      // Precomputed endomorphism
      beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
      lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
      basis: [
        {
          a: "3086d221a7d46bcde86c90e49284eb15",
          b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
          a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
          b: "3086d221a7d46bcde86c90e49284eb15"
        }
      ],
      gRed: !1,
      g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        k
      ]
    });
  }(curves)), curves;
}
var hmacDrbg, hasRequiredHmacDrbg;
function requireHmacDrbg() {
  if (hasRequiredHmacDrbg) return hmacDrbg;
  hasRequiredHmacDrbg = 1;
  var s = requireHash$1(), A = requireUtils$a(), u = requireMinimalisticAssert();
  function p(t) {
    if (!(this instanceof p))
      return new p(t);
    this.hash = t.hash, this.predResist = !!t.predResist, this.outLen = this.hash.outSize, this.minEntropy = t.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
    var l = A.toArray(t.entropy, t.entropyEnc || "hex"), m = A.toArray(t.nonce, t.nonceEnc || "hex"), b = A.toArray(t.pers, t.persEnc || "hex");
    u(
      l.length >= this.minEntropy / 8,
      "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
    ), this._init(l, m, b);
  }
  return hmacDrbg = p, p.prototype._init = function(l, m, b) {
    var k = l.concat(m).concat(b);
    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
    for (var C = 0; C < this.V.length; C++)
      this.K[C] = 0, this.V[C] = 1;
    this._update(k), this._reseed = 1, this.reseedInterval = 281474976710656;
  }, p.prototype._hmac = function() {
    return new s.hmac(this.hash, this.K);
  }, p.prototype._update = function(l) {
    var m = this._hmac().update(this.V).update([0]);
    l && (m = m.update(l)), this.K = m.digest(), this.V = this._hmac().update(this.V).digest(), l && (this.K = this._hmac().update(this.V).update([1]).update(l).digest(), this.V = this._hmac().update(this.V).digest());
  }, p.prototype.reseed = function(l, m, b, k) {
    typeof m != "string" && (k = b, b = m, m = null), l = A.toArray(l, m), b = A.toArray(b, k), u(
      l.length >= this.minEntropy / 8,
      "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
    ), this._update(l.concat(b || [])), this._reseed = 1;
  }, p.prototype.generate = function(l, m, b, k) {
    if (this._reseed > this.reseedInterval)
      throw new Error("Reseed is required");
    typeof m != "string" && (k = b, b = m, m = null), b && (b = A.toArray(b, k || "hex"), this._update(b));
    for (var C = []; C.length < l; )
      this.V = this._hmac().update(this.V).digest(), C = C.concat(this.V);
    var B = C.slice(0, l);
    return this._update(b), this._reseed++, A.encode(B, m);
  }, hmacDrbg;
}
var key$1, hasRequiredKey$1;
function requireKey$1() {
  if (hasRequiredKey$1) return key$1;
  hasRequiredKey$1 = 1;
  var s = requireBn$1(), A = requireUtils$9(), u = A.assert;
  function p(t, l) {
    this.ec = t, this.priv = null, this.pub = null, l.priv && this._importPrivate(l.priv, l.privEnc), l.pub && this._importPublic(l.pub, l.pubEnc);
  }
  return key$1 = p, p.fromPublic = function(l, m, b) {
    return m instanceof p ? m : new p(l, {
      pub: m,
      pubEnc: b
    });
  }, p.fromPrivate = function(l, m, b) {
    return m instanceof p ? m : new p(l, {
      priv: m,
      privEnc: b
    });
  }, p.prototype.validate = function() {
    var l = this.getPublic();
    return l.isInfinity() ? { result: !1, reason: "Invalid public key" } : l.validate() ? l.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
  }, p.prototype.getPublic = function(l, m) {
    return typeof l == "string" && (m = l, l = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), m ? this.pub.encode(m, l) : this.pub;
  }, p.prototype.getPrivate = function(l) {
    return l === "hex" ? this.priv.toString(16, 2) : this.priv;
  }, p.prototype._importPrivate = function(l, m) {
    this.priv = new s(l, m || 16), this.priv = this.priv.umod(this.ec.curve.n);
  }, p.prototype._importPublic = function(l, m) {
    if (l.x || l.y) {
      this.ec.curve.type === "mont" ? u(l.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && u(l.x && l.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(l.x, l.y);
      return;
    }
    this.pub = this.ec.curve.decodePoint(l, m);
  }, p.prototype.derive = function(l) {
    return l.validate() || u(l.validate(), "public point not validated"), l.mul(this.priv).getX();
  }, p.prototype.sign = function(l, m, b) {
    return this.ec.sign(l, this, m, b);
  }, p.prototype.verify = function(l, m, b) {
    return this.ec.verify(l, m, this, void 0, b);
  }, p.prototype.inspect = function() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
  }, key$1;
}
var signature$3, hasRequiredSignature$3;
function requireSignature$3() {
  if (hasRequiredSignature$3) return signature$3;
  hasRequiredSignature$3 = 1;
  var s = requireBn$1(), A = requireUtils$9(), u = A.assert;
  function p(k, C) {
    if (k instanceof p)
      return k;
    this._importDER(k, C) || (u(k.r && k.s, "Signature without r or s"), this.r = new s(k.r, 16), this.s = new s(k.s, 16), k.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = k.recoveryParam);
  }
  signature$3 = p;
  function t() {
    this.place = 0;
  }
  function l(k, C) {
    var B = k[C.place++];
    if (!(B & 128))
      return B;
    var Q = B & 15;
    if (Q === 0 || Q > 4 || k[C.place] === 0)
      return !1;
    for (var P = 0, x = 0, M = C.place; x < Q; x++, M++)
      P <<= 8, P |= k[M], P >>>= 0;
    return P <= 127 ? !1 : (C.place = M, P);
  }
  function m(k) {
    for (var C = 0, B = k.length - 1; !k[C] && !(k[C + 1] & 128) && C < B; )
      C++;
    return C === 0 ? k : k.slice(C);
  }
  p.prototype._importDER = function(C, B) {
    C = A.toArray(C, B);
    var Q = new t();
    if (C[Q.place++] !== 48)
      return !1;
    var P = l(C, Q);
    if (P === !1 || P + Q.place !== C.length || C[Q.place++] !== 2)
      return !1;
    var x = l(C, Q);
    if (x === !1 || (C[Q.place] & 128) !== 0)
      return !1;
    var M = C.slice(Q.place, x + Q.place);
    if (Q.place += x, C[Q.place++] !== 2)
      return !1;
    var F = l(C, Q);
    if (F === !1 || C.length !== F + Q.place || (C[Q.place] & 128) !== 0)
      return !1;
    var le = C.slice(Q.place, F + Q.place);
    if (M[0] === 0)
      if (M[1] & 128)
        M = M.slice(1);
      else
        return !1;
    if (le[0] === 0)
      if (le[1] & 128)
        le = le.slice(1);
      else
        return !1;
    return this.r = new s(M), this.s = new s(le), this.recoveryParam = null, !0;
  };
  function b(k, C) {
    if (C < 128) {
      k.push(C);
      return;
    }
    var B = 1 + (Math.log(C) / Math.LN2 >>> 3);
    for (k.push(B | 128); --B; )
      k.push(C >>> (B << 3) & 255);
    k.push(C);
  }
  return p.prototype.toDER = function(C) {
    var B = this.r.toArray(), Q = this.s.toArray();
    for (B[0] & 128 && (B = [0].concat(B)), Q[0] & 128 && (Q = [0].concat(Q)), B = m(B), Q = m(Q); !Q[0] && !(Q[1] & 128); )
      Q = Q.slice(1);
    var P = [2];
    b(P, B.length), P = P.concat(B), P.push(2), b(P, Q.length);
    var x = P.concat(Q), M = [48];
    return b(M, x.length), M = M.concat(x), A.encode(M, C);
  }, signature$3;
}
var ec, hasRequiredEc;
function requireEc() {
  if (hasRequiredEc) return ec;
  hasRequiredEc = 1;
  var s = requireBn$1(), A = requireHmacDrbg(), u = requireUtils$9(), p = requireCurves(), t = requireBrorand(), l = u.assert, m = requireKey$1(), b = requireSignature$3();
  function k(C) {
    if (!(this instanceof k))
      return new k(C);
    typeof C == "string" && (l(
      Object.prototype.hasOwnProperty.call(p, C),
      "Unknown curve " + C
    ), C = p[C]), C instanceof p.PresetCurve && (C = { curve: C }), this.curve = C.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = C.curve.g, this.g.precompute(C.curve.n.bitLength() + 1), this.hash = C.hash || C.curve.hash;
  }
  return ec = k, k.prototype.keyPair = function(B) {
    return new m(this, B);
  }, k.prototype.keyFromPrivate = function(B, Q) {
    return m.fromPrivate(this, B, Q);
  }, k.prototype.keyFromPublic = function(B, Q) {
    return m.fromPublic(this, B, Q);
  }, k.prototype.genKeyPair = function(B) {
    B || (B = {});
    for (var Q = new A({
      hash: this.hash,
      pers: B.pers,
      persEnc: B.persEnc || "utf8",
      entropy: B.entropy || t(this.hash.hmacStrength),
      entropyEnc: B.entropy && B.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), P = this.n.byteLength(), x = this.n.sub(new s(2)); ; ) {
      var M = new s(Q.generate(P));
      if (!(M.cmp(x) > 0))
        return M.iaddn(1), this.keyFromPrivate(M);
    }
  }, k.prototype._truncateToN = function(B, Q, P) {
    var x;
    if (s.isBN(B) || typeof B == "number")
      B = new s(B, 16), x = B.byteLength();
    else if (typeof B == "object")
      x = B.length, B = new s(B, 16);
    else {
      var M = B.toString();
      x = M.length + 1 >>> 1, B = new s(M, 16);
    }
    typeof P != "number" && (P = x * 8);
    var F = P - this.n.bitLength();
    return F > 0 && (B = B.ushrn(F)), !Q && B.cmp(this.n) >= 0 ? B.sub(this.n) : B;
  }, k.prototype.sign = function(B, Q, P, x) {
    if (typeof P == "object" && (x = P, P = null), x || (x = {}), typeof B != "string" && typeof B != "number" && !s.isBN(B)) {
      l(
        typeof B == "object" && B && typeof B.length == "number",
        "Expected message to be an array-like, a hex string, or a BN instance"
      ), l(B.length >>> 0 === B.length);
      for (var M = 0; M < B.length; M++) l((B[M] & 255) === B[M]);
    }
    Q = this.keyFromPrivate(Q, P), B = this._truncateToN(B, !1, x.msgBitLength), l(!B.isNeg(), "Can not sign a negative message");
    var F = this.n.byteLength(), le = Q.getPrivate().toArray("be", F), ge = B.toArray("be", F);
    l(new s(ge).eq(B), "Can not sign message");
    for (var pe = new A({
      hash: this.hash,
      entropy: le,
      nonce: ge,
      pers: x.pers,
      persEnc: x.persEnc || "utf8"
    }), Ie = this.n.sub(new s(1)), be = 0; ; be++) {
      var Pe = x.k ? x.k(be) : new s(pe.generate(this.n.byteLength()));
      if (Pe = this._truncateToN(Pe, !0), !(Pe.cmpn(1) <= 0 || Pe.cmp(Ie) >= 0)) {
        var Te = this.g.mul(Pe);
        if (!Te.isInfinity()) {
          var Qe = Te.getX(), xe = Qe.umod(this.n);
          if (xe.cmpn(0) !== 0) {
            var Ee = Pe.invm(this.n).mul(xe.mul(Q.getPrivate()).iadd(B));
            if (Ee = Ee.umod(this.n), Ee.cmpn(0) !== 0) {
              var He = (Te.getY().isOdd() ? 1 : 0) | (Qe.cmp(xe) !== 0 ? 2 : 0);
              return x.canonical && Ee.cmp(this.nh) > 0 && (Ee = this.n.sub(Ee), He ^= 1), new b({ r: xe, s: Ee, recoveryParam: He });
            }
          }
        }
      }
    }
  }, k.prototype.verify = function(B, Q, P, x, M) {
    M || (M = {}), B = this._truncateToN(B, !1, M.msgBitLength), P = this.keyFromPublic(P, x), Q = new b(Q, "hex");
    var F = Q.r, le = Q.s;
    if (F.cmpn(1) < 0 || F.cmp(this.n) >= 0 || le.cmpn(1) < 0 || le.cmp(this.n) >= 0)
      return !1;
    var ge = le.invm(this.n), pe = ge.mul(B).umod(this.n), Ie = ge.mul(F).umod(this.n), be;
    return this.curve._maxwellTrick ? (be = this.g.jmulAdd(pe, P.getPublic(), Ie), be.isInfinity() ? !1 : be.eqXToP(F)) : (be = this.g.mulAdd(pe, P.getPublic(), Ie), be.isInfinity() ? !1 : be.getX().umod(this.n).cmp(F) === 0);
  }, k.prototype.recoverPubKey = function(C, B, Q, P) {
    l((3 & Q) === Q, "The recovery param is more than two bits"), B = new b(B, P);
    var x = this.n, M = new s(C), F = B.r, le = B.s, ge = Q & 1, pe = Q >> 1;
    if (F.cmp(this.curve.p.umod(this.curve.n)) >= 0 && pe)
      throw new Error("Unable to find sencond key candinate");
    pe ? F = this.curve.pointFromX(F.add(this.curve.n), ge) : F = this.curve.pointFromX(F, ge);
    var Ie = B.r.invm(x), be = x.sub(M).mul(Ie).umod(x), Pe = le.mul(Ie).umod(x);
    return this.g.mulAdd(be, F, Pe);
  }, k.prototype.getKeyRecoveryParam = function(C, B, Q, P) {
    if (B = new b(B, P), B.recoveryParam !== null)
      return B.recoveryParam;
    for (var x = 0; x < 4; x++) {
      var M;
      try {
        M = this.recoverPubKey(C, B, x);
      } catch {
        continue;
      }
      if (M.eq(Q))
        return x;
    }
    throw new Error("Unable to find valid recovery factor");
  }, ec;
}
var key, hasRequiredKey;
function requireKey() {
  if (hasRequiredKey) return key;
  hasRequiredKey = 1;
  var s = requireUtils$9(), A = s.assert, u = s.parseBytes, p = s.cachedProperty;
  function t(l, m) {
    this.eddsa = l, this._secret = u(m.secret), l.isPoint(m.pub) ? this._pub = m.pub : this._pubBytes = u(m.pub);
  }
  return t.fromPublic = function(m, b) {
    return b instanceof t ? b : new t(m, { pub: b });
  }, t.fromSecret = function(m, b) {
    return b instanceof t ? b : new t(m, { secret: b });
  }, t.prototype.secret = function() {
    return this._secret;
  }, p(t, "pubBytes", function() {
    return this.eddsa.encodePoint(this.pub());
  }), p(t, "pub", function() {
    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
  }), p(t, "privBytes", function() {
    var m = this.eddsa, b = this.hash(), k = m.encodingLength - 1, C = b.slice(0, m.encodingLength);
    return C[0] &= 248, C[k] &= 127, C[k] |= 64, C;
  }), p(t, "priv", function() {
    return this.eddsa.decodeInt(this.privBytes());
  }), p(t, "hash", function() {
    return this.eddsa.hash().update(this.secret()).digest();
  }), p(t, "messagePrefix", function() {
    return this.hash().slice(this.eddsa.encodingLength);
  }), t.prototype.sign = function(m) {
    return A(this._secret, "KeyPair can only verify"), this.eddsa.sign(m, this);
  }, t.prototype.verify = function(m, b) {
    return this.eddsa.verify(m, b, this);
  }, t.prototype.getSecret = function(m) {
    return A(this._secret, "KeyPair is public only"), s.encode(this.secret(), m);
  }, t.prototype.getPublic = function(m) {
    return s.encode(this.pubBytes(), m);
  }, key = t, key;
}
var signature$2, hasRequiredSignature$2;
function requireSignature$2() {
  if (hasRequiredSignature$2) return signature$2;
  hasRequiredSignature$2 = 1;
  var s = requireBn$1(), A = requireUtils$9(), u = A.assert, p = A.cachedProperty, t = A.parseBytes;
  function l(m, b) {
    this.eddsa = m, typeof b != "object" && (b = t(b)), Array.isArray(b) && (u(b.length === m.encodingLength * 2, "Signature has invalid size"), b = {
      R: b.slice(0, m.encodingLength),
      S: b.slice(m.encodingLength)
    }), u(b.R && b.S, "Signature without R or S"), m.isPoint(b.R) && (this._R = b.R), b.S instanceof s && (this._S = b.S), this._Rencoded = Array.isArray(b.R) ? b.R : b.Rencoded, this._Sencoded = Array.isArray(b.S) ? b.S : b.Sencoded;
  }
  return p(l, "S", function() {
    return this.eddsa.decodeInt(this.Sencoded());
  }), p(l, "R", function() {
    return this.eddsa.decodePoint(this.Rencoded());
  }), p(l, "Rencoded", function() {
    return this.eddsa.encodePoint(this.R());
  }), p(l, "Sencoded", function() {
    return this.eddsa.encodeInt(this.S());
  }), l.prototype.toBytes = function() {
    return this.Rencoded().concat(this.Sencoded());
  }, l.prototype.toHex = function() {
    return A.encode(this.toBytes(), "hex").toUpperCase();
  }, signature$2 = l, signature$2;
}
var eddsa, hasRequiredEddsa;
function requireEddsa() {
  if (hasRequiredEddsa) return eddsa;
  hasRequiredEddsa = 1;
  var s = requireHash$1(), A = requireCurves(), u = requireUtils$9(), p = u.assert, t = u.parseBytes, l = requireKey(), m = requireSignature$2();
  function b(k) {
    if (p(k === "ed25519", "only tested with ed25519 so far"), !(this instanceof b))
      return new b(k);
    k = A[k].curve, this.curve = k, this.g = k.g, this.g.precompute(k.n.bitLength() + 1), this.pointClass = k.point().constructor, this.encodingLength = Math.ceil(k.n.bitLength() / 8), this.hash = s.sha512;
  }
  return eddsa = b, b.prototype.sign = function(C, B) {
    C = t(C);
    var Q = this.keyFromSecret(B), P = this.hashInt(Q.messagePrefix(), C), x = this.g.mul(P), M = this.encodePoint(x), F = this.hashInt(M, Q.pubBytes(), C).mul(Q.priv()), le = P.add(F).umod(this.curve.n);
    return this.makeSignature({ R: x, S: le, Rencoded: M });
  }, b.prototype.verify = function(C, B, Q) {
    if (C = t(C), B = this.makeSignature(B), B.S().gte(B.eddsa.curve.n) || B.S().isNeg())
      return !1;
    var P = this.keyFromPublic(Q), x = this.hashInt(B.Rencoded(), P.pubBytes(), C), M = this.g.mul(B.S()), F = B.R().add(P.pub().mul(x));
    return F.eq(M);
  }, b.prototype.hashInt = function() {
    for (var C = this.hash(), B = 0; B < arguments.length; B++)
      C.update(arguments[B]);
    return u.intFromLE(C.digest()).umod(this.curve.n);
  }, b.prototype.keyFromPublic = function(C) {
    return l.fromPublic(this, C);
  }, b.prototype.keyFromSecret = function(C) {
    return l.fromSecret(this, C);
  }, b.prototype.makeSignature = function(C) {
    return C instanceof m ? C : new m(this, C);
  }, b.prototype.encodePoint = function(C) {
    var B = C.getY().toArray("le", this.encodingLength);
    return B[this.encodingLength - 1] |= C.getX().isOdd() ? 128 : 0, B;
  }, b.prototype.decodePoint = function(C) {
    C = u.parseBytes(C);
    var B = C.length - 1, Q = C.slice(0, B).concat(C[B] & -129), P = (C[B] & 128) !== 0, x = u.intFromLE(Q);
    return this.curve.pointFromY(x, P);
  }, b.prototype.encodeInt = function(C) {
    return C.toArray("le", this.encodingLength);
  }, b.prototype.decodeInt = function(C) {
    return u.intFromLE(C);
  }, b.prototype.isPoint = function(C) {
    return C instanceof this.pointClass;
  }, eddsa;
}
var hasRequiredElliptic$2;
function requireElliptic$2() {
  return hasRequiredElliptic$2 || (hasRequiredElliptic$2 = 1, function(s) {
    var A = s;
    A.version = require$$0$1.version, A.utils = requireUtils$9(), A.rand = requireBrorand(), A.curve = requireCurve$1(), A.curves = requireCurves(), A.ec = requireEc(), A.eddsa = requireEddsa();
  }(elliptic$2)), elliptic$2;
}
var asn1$1 = {}, asn1 = {}, api = {}, vmBrowserify = {}, hasRequiredVmBrowserify;
function requireVmBrowserify() {
  return hasRequiredVmBrowserify || (hasRequiredVmBrowserify = 1, function(exports) {
    var indexOf = function(s, A) {
      if (s.indexOf) return s.indexOf(A);
      for (var u = 0; u < s.length; u++)
        if (s[u] === A) return u;
      return -1;
    }, Object_keys = function(s) {
      if (Object.keys) return Object.keys(s);
      var A = [];
      for (var u in s) A.push(u);
      return A;
    }, forEach = function(s, A) {
      if (s.forEach) return s.forEach(A);
      for (var u = 0; u < s.length; u++)
        A(s[u], u, s);
    }, defineProp = function() {
      try {
        return Object.defineProperty({}, "_", {}), function(s, A, u) {
          Object.defineProperty(s, A, {
            writable: !0,
            enumerable: !1,
            configurable: !0,
            value: u
          });
        };
      } catch {
        return function(A, u, p) {
          A[u] = p;
        };
      }
    }(), globals = [
      "Array",
      "Boolean",
      "Date",
      "Error",
      "EvalError",
      "Function",
      "Infinity",
      "JSON",
      "Math",
      "NaN",
      "Number",
      "Object",
      "RangeError",
      "ReferenceError",
      "RegExp",
      "String",
      "SyntaxError",
      "TypeError",
      "URIError",
      "decodeURI",
      "decodeURIComponent",
      "encodeURI",
      "encodeURIComponent",
      "escape",
      "eval",
      "isFinite",
      "isNaN",
      "parseFloat",
      "parseInt",
      "undefined",
      "unescape"
    ];
    function Context() {
    }
    Context.prototype = {};
    var Script = exports.Script = function(A) {
      if (!(this instanceof Script)) return new Script(A);
      this.code = A;
    };
    Script.prototype.runInContext = function(s) {
      if (!(s instanceof Context))
        throw new TypeError("needs a 'context' argument.");
      var A = document.createElement("iframe");
      A.style || (A.style = {}), A.style.display = "none", document.body.appendChild(A);
      var u = A.contentWindow, p = u.eval, t = u.execScript;
      !p && t && (t.call(u, "null"), p = u.eval), forEach(Object_keys(s), function(b) {
        u[b] = s[b];
      }), forEach(globals, function(b) {
        s[b] && (u[b] = s[b]);
      });
      var l = Object_keys(u), m = p.call(u, this.code);
      return forEach(Object_keys(u), function(b) {
        (b in s || indexOf(l, b) === -1) && (s[b] = u[b]);
      }), forEach(globals, function(b) {
        b in s || defineProp(s, b, u[b]);
      }), document.body.removeChild(A), m;
    }, Script.prototype.runInThisContext = function() {
      return eval(this.code);
    }, Script.prototype.runInNewContext = function(s) {
      var A = Script.createContext(s), u = this.runInContext(A);
      return s && forEach(Object_keys(A), function(p) {
        s[p] = A[p];
      }), u;
    }, forEach(Object_keys(Script.prototype), function(s) {
      exports[s] = Script[s] = function(A) {
        var u = Script(A);
        return u[s].apply(u, [].slice.call(arguments, 1));
      };
    }), exports.isContext = function(s) {
      return s instanceof Context;
    }, exports.createScript = function(s) {
      return exports.Script(s);
    }, exports.createContext = Script.createContext = function(s) {
      var A = new Context();
      return typeof s == "object" && forEach(Object_keys(s), function(u) {
        A[u] = s[u];
      }), A;
    };
  }(vmBrowserify)), vmBrowserify;
}
var hasRequiredApi;
function requireApi() {
  return hasRequiredApi || (hasRequiredApi = 1, function(s) {
    var A = requireAsn1$1(), u = requireInherits_browser(), p = s;
    p.define = function(m, b) {
      return new t(m, b);
    };
    function t(l, m) {
      this.name = l, this.body = m, this.decoders = {}, this.encoders = {};
    }
    t.prototype._createNamed = function(m) {
      var b;
      try {
        b = requireVmBrowserify().runInThisContext(
          "(function " + this.name + `(entity) {
  this._initNamed(entity);
})`
        );
      } catch {
        b = function(C) {
          this._initNamed(C);
        };
      }
      return u(b, m), b.prototype._initNamed = function(C) {
        m.call(this, C);
      }, new b(this);
    }, t.prototype._getDecoder = function(m) {
      return m = m || "der", this.decoders.hasOwnProperty(m) || (this.decoders[m] = this._createNamed(A.decoders[m])), this.decoders[m];
    }, t.prototype.decode = function(m, b, k) {
      return this._getDecoder(b).decode(m, k);
    }, t.prototype._getEncoder = function(m) {
      return m = m || "der", this.encoders.hasOwnProperty(m) || (this.encoders[m] = this._createNamed(A.encoders[m])), this.encoders[m];
    }, t.prototype.encode = function(m, b, k) {
      return this._getEncoder(b).encode(m, k);
    };
  }(api)), api;
}
var base = {}, reporter = {}, hasRequiredReporter;
function requireReporter() {
  if (hasRequiredReporter) return reporter;
  hasRequiredReporter = 1;
  var s = requireInherits_browser();
  function A(p) {
    this._reporterState = {
      obj: null,
      path: [],
      options: p || {},
      errors: []
    };
  }
  reporter.Reporter = A, A.prototype.isError = function(t) {
    return t instanceof u;
  }, A.prototype.save = function() {
    var t = this._reporterState;
    return { obj: t.obj, pathLen: t.path.length };
  }, A.prototype.restore = function(t) {
    var l = this._reporterState;
    l.obj = t.obj, l.path = l.path.slice(0, t.pathLen);
  }, A.prototype.enterKey = function(t) {
    return this._reporterState.path.push(t);
  }, A.prototype.exitKey = function(t) {
    var l = this._reporterState;
    l.path = l.path.slice(0, t - 1);
  }, A.prototype.leaveKey = function(t, l, m) {
    var b = this._reporterState;
    this.exitKey(t), b.obj !== null && (b.obj[l] = m);
  }, A.prototype.path = function() {
    return this._reporterState.path.join("/");
  }, A.prototype.enterObject = function() {
    var t = this._reporterState, l = t.obj;
    return t.obj = {}, l;
  }, A.prototype.leaveObject = function(t) {
    var l = this._reporterState, m = l.obj;
    return l.obj = t, m;
  }, A.prototype.error = function(t) {
    var l, m = this._reporterState, b = t instanceof u;
    if (b ? l = t : l = new u(m.path.map(function(k) {
      return "[" + JSON.stringify(k) + "]";
    }).join(""), t.message || t, t.stack), !m.options.partial)
      throw l;
    return b || m.errors.push(l), l;
  }, A.prototype.wrapResult = function(t) {
    var l = this._reporterState;
    return l.options.partial ? {
      result: this.isError(t) ? null : t,
      errors: l.errors
    } : t;
  };
  function u(p, t) {
    this.path = p, this.rethrow(t);
  }
  return s(u, Error), u.prototype.rethrow = function(t) {
    if (this.message = t + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, u), !this.stack)
      try {
        throw new Error(this.message);
      } catch (l) {
        this.stack = l.stack;
      }
    return this;
  }, reporter;
}
var buffer = {}, hasRequiredBuffer;
function requireBuffer() {
  if (hasRequiredBuffer) return buffer;
  hasRequiredBuffer = 1;
  var s = requireInherits_browser(), A = requireBase().Reporter, u = requireDist$n().Buffer;
  function p(l, m) {
    if (A.call(this, m), !u.isBuffer(l)) {
      this.error("Input not Buffer");
      return;
    }
    this.base = l, this.offset = 0, this.length = l.length;
  }
  s(p, A), buffer.DecoderBuffer = p, p.prototype.save = function() {
    return { offset: this.offset, reporter: A.prototype.save.call(this) };
  }, p.prototype.restore = function(m) {
    var b = new p(this.base);
    return b.offset = m.offset, b.length = this.offset, this.offset = m.offset, A.prototype.restore.call(this, m.reporter), b;
  }, p.prototype.isEmpty = function() {
    return this.offset === this.length;
  }, p.prototype.readUInt8 = function(m) {
    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(m || "DecoderBuffer overrun");
  }, p.prototype.skip = function(m, b) {
    if (!(this.offset + m <= this.length))
      return this.error(b || "DecoderBuffer overrun");
    var k = new p(this.base);
    return k._reporterState = this._reporterState, k.offset = this.offset, k.length = this.offset + m, this.offset += m, k;
  }, p.prototype.raw = function(m) {
    return this.base.slice(m ? m.offset : this.offset, this.length);
  };
  function t(l, m) {
    if (Array.isArray(l))
      this.length = 0, this.value = l.map(function(b) {
        return b instanceof t || (b = new t(b, m)), this.length += b.length, b;
      }, this);
    else if (typeof l == "number") {
      if (!(0 <= l && l <= 255))
        return m.error("non-byte EncoderBuffer value");
      this.value = l, this.length = 1;
    } else if (typeof l == "string")
      this.value = l, this.length = u.byteLength(l);
    else if (u.isBuffer(l))
      this.value = l, this.length = l.length;
    else
      return m.error("Unsupported type: " + typeof l);
  }
  return buffer.EncoderBuffer = t, t.prototype.join = function(m, b) {
    return m || (m = new u(this.length)), b || (b = 0), this.length === 0 || (Array.isArray(this.value) ? this.value.forEach(function(k) {
      k.join(m, b), b += k.length;
    }) : (typeof this.value == "number" ? m[b] = this.value : typeof this.value == "string" ? m.write(this.value, b) : u.isBuffer(this.value) && this.value.copy(m, b), b += this.length)), m;
  }, buffer;
}
var node, hasRequiredNode;
function requireNode() {
  if (hasRequiredNode) return node;
  hasRequiredNode = 1;
  var s = requireBase().Reporter, A = requireBase().EncoderBuffer, u = requireBase().DecoderBuffer, p = requireMinimalisticAssert(), t = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
  ], l = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
  ].concat(t), m = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
  ];
  function b(C, B) {
    var Q = {};
    this._baseState = Q, Q.enc = C, Q.parent = B || null, Q.children = null, Q.tag = null, Q.args = null, Q.reverseArgs = null, Q.choice = null, Q.optional = !1, Q.any = !1, Q.obj = !1, Q.use = null, Q.useDecoder = null, Q.key = null, Q.default = null, Q.explicit = null, Q.implicit = null, Q.contains = null, Q.parent || (Q.children = [], this._wrap());
  }
  node = b;
  var k = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
  ];
  return b.prototype.clone = function() {
    var B = this._baseState, Q = {};
    k.forEach(function(x) {
      Q[x] = B[x];
    });
    var P = new this.constructor(Q.parent);
    return P._baseState = Q, P;
  }, b.prototype._wrap = function() {
    var B = this._baseState;
    l.forEach(function(Q) {
      this[Q] = function() {
        var x = new this.constructor(this);
        return B.children.push(x), x[Q].apply(x, arguments);
      };
    }, this);
  }, b.prototype._init = function(B) {
    var Q = this._baseState;
    p(Q.parent === null), B.call(this), Q.children = Q.children.filter(function(P) {
      return P._baseState.parent === this;
    }, this), p.equal(Q.children.length, 1, "Root node can have only one child");
  }, b.prototype._useArgs = function(B) {
    var Q = this._baseState, P = B.filter(function(x) {
      return x instanceof this.constructor;
    }, this);
    B = B.filter(function(x) {
      return !(x instanceof this.constructor);
    }, this), P.length !== 0 && (p(Q.children === null), Q.children = P, P.forEach(function(x) {
      x._baseState.parent = this;
    }, this)), B.length !== 0 && (p(Q.args === null), Q.args = B, Q.reverseArgs = B.map(function(x) {
      if (typeof x != "object" || x.constructor !== Object)
        return x;
      var M = {};
      return Object.keys(x).forEach(function(F) {
        F == (F | 0) && (F |= 0);
        var le = x[F];
        M[le] = F;
      }), M;
    }));
  }, m.forEach(function(C) {
    b.prototype[C] = function() {
      var Q = this._baseState;
      throw new Error(C + " not implemented for encoding: " + Q.enc);
    };
  }), t.forEach(function(C) {
    b.prototype[C] = function() {
      var Q = this._baseState, P = Array.prototype.slice.call(arguments);
      return p(Q.tag === null), Q.tag = C, this._useArgs(P), this;
    };
  }), b.prototype.use = function(B) {
    p(B);
    var Q = this._baseState;
    return p(Q.use === null), Q.use = B, this;
  }, b.prototype.optional = function() {
    var B = this._baseState;
    return B.optional = !0, this;
  }, b.prototype.def = function(B) {
    var Q = this._baseState;
    return p(Q.default === null), Q.default = B, Q.optional = !0, this;
  }, b.prototype.explicit = function(B) {
    var Q = this._baseState;
    return p(Q.explicit === null && Q.implicit === null), Q.explicit = B, this;
  }, b.prototype.implicit = function(B) {
    var Q = this._baseState;
    return p(Q.explicit === null && Q.implicit === null), Q.implicit = B, this;
  }, b.prototype.obj = function() {
    var B = this._baseState, Q = Array.prototype.slice.call(arguments);
    return B.obj = !0, Q.length !== 0 && this._useArgs(Q), this;
  }, b.prototype.key = function(B) {
    var Q = this._baseState;
    return p(Q.key === null), Q.key = B, this;
  }, b.prototype.any = function() {
    var B = this._baseState;
    return B.any = !0, this;
  }, b.prototype.choice = function(B) {
    var Q = this._baseState;
    return p(Q.choice === null), Q.choice = B, this._useArgs(Object.keys(B).map(function(P) {
      return B[P];
    })), this;
  }, b.prototype.contains = function(B) {
    var Q = this._baseState;
    return p(Q.use === null), Q.contains = B, this;
  }, b.prototype._decode = function(B, Q) {
    var P = this._baseState;
    if (P.parent === null)
      return B.wrapResult(P.children[0]._decode(B, Q));
    var x = P.default, M = !0, F = null;
    if (P.key !== null && (F = B.enterKey(P.key)), P.optional) {
      var le = null;
      if (P.explicit !== null ? le = P.explicit : P.implicit !== null ? le = P.implicit : P.tag !== null && (le = P.tag), le === null && !P.any) {
        var ge = B.save();
        try {
          P.choice === null ? this._decodeGeneric(P.tag, B, Q) : this._decodeChoice(B, Q), M = !0;
        } catch {
          M = !1;
        }
        B.restore(ge);
      } else if (M = this._peekTag(B, le, P.any), B.isError(M))
        return M;
    }
    var pe;
    if (P.obj && M && (pe = B.enterObject()), M) {
      if (P.explicit !== null) {
        var Ie = this._decodeTag(B, P.explicit);
        if (B.isError(Ie))
          return Ie;
        B = Ie;
      }
      var be = B.offset;
      if (P.use === null && P.choice === null) {
        if (P.any)
          var ge = B.save();
        var Pe = this._decodeTag(
          B,
          P.implicit !== null ? P.implicit : P.tag,
          P.any
        );
        if (B.isError(Pe))
          return Pe;
        P.any ? x = B.raw(ge) : B = Pe;
      }
      if (Q && Q.track && P.tag !== null && Q.track(B.path(), be, B.length, "tagged"), Q && Q.track && P.tag !== null && Q.track(B.path(), B.offset, B.length, "content"), P.any ? x = x : P.choice === null ? x = this._decodeGeneric(P.tag, B, Q) : x = this._decodeChoice(B, Q), B.isError(x))
        return x;
      if (!P.any && P.choice === null && P.children !== null && P.children.forEach(function(xe) {
        xe._decode(B, Q);
      }), P.contains && (P.tag === "octstr" || P.tag === "bitstr")) {
        var Te = new u(x);
        x = this._getUse(P.contains, B._reporterState.obj)._decode(Te, Q);
      }
    }
    return P.obj && M && (x = B.leaveObject(pe)), P.key !== null && (x !== null || M === !0) ? B.leaveKey(F, P.key, x) : F !== null && B.exitKey(F), x;
  }, b.prototype._decodeGeneric = function(B, Q, P) {
    var x = this._baseState;
    return B === "seq" || B === "set" ? null : B === "seqof" || B === "setof" ? this._decodeList(Q, B, x.args[0], P) : /str$/.test(B) ? this._decodeStr(Q, B, P) : B === "objid" && x.args ? this._decodeObjid(Q, x.args[0], x.args[1], P) : B === "objid" ? this._decodeObjid(Q, null, null, P) : B === "gentime" || B === "utctime" ? this._decodeTime(Q, B, P) : B === "null_" ? this._decodeNull(Q, P) : B === "bool" ? this._decodeBool(Q, P) : B === "objDesc" ? this._decodeStr(Q, B, P) : B === "int" || B === "enum" ? this._decodeInt(Q, x.args && x.args[0], P) : x.use !== null ? this._getUse(x.use, Q._reporterState.obj)._decode(Q, P) : Q.error("unknown tag: " + B);
  }, b.prototype._getUse = function(B, Q) {
    var P = this._baseState;
    return P.useDecoder = this._use(B, Q), p(P.useDecoder._baseState.parent === null), P.useDecoder = P.useDecoder._baseState.children[0], P.implicit !== P.useDecoder._baseState.implicit && (P.useDecoder = P.useDecoder.clone(), P.useDecoder._baseState.implicit = P.implicit), P.useDecoder;
  }, b.prototype._decodeChoice = function(B, Q) {
    var P = this._baseState, x = null, M = !1;
    return Object.keys(P.choice).some(function(F) {
      var le = B.save(), ge = P.choice[F];
      try {
        var pe = ge._decode(B, Q);
        if (B.isError(pe))
          return !1;
        x = { type: F, value: pe }, M = !0;
      } catch {
        return B.restore(le), !1;
      }
      return !0;
    }, this), M ? x : B.error("Choice not matched");
  }, b.prototype._createEncoderBuffer = function(B) {
    return new A(B, this.reporter);
  }, b.prototype._encode = function(B, Q, P) {
    var x = this._baseState;
    if (!(x.default !== null && x.default === B)) {
      var M = this._encodeValue(B, Q, P);
      if (M !== void 0 && !this._skipDefault(M, Q, P))
        return M;
    }
  }, b.prototype._encodeValue = function(B, Q, P) {
    var x = this._baseState;
    if (x.parent === null)
      return x.children[0]._encode(B, Q || new s());
    var ge = null;
    if (this.reporter = Q, x.optional && B === void 0)
      if (x.default !== null)
        B = x.default;
      else
        return;
    var M = null, F = !1;
    if (x.any)
      ge = this._createEncoderBuffer(B);
    else if (x.choice)
      ge = this._encodeChoice(B, Q);
    else if (x.contains)
      M = this._getUse(x.contains, P)._encode(B, Q), F = !0;
    else if (x.children)
      M = x.children.map(function(be) {
        if (be._baseState.tag === "null_")
          return be._encode(null, Q, B);
        if (be._baseState.key === null)
          return Q.error("Child should have a key");
        var Pe = Q.enterKey(be._baseState.key);
        if (typeof B != "object")
          return Q.error("Child expected, but input is not object");
        var Te = be._encode(B[be._baseState.key], Q, B);
        return Q.leaveKey(Pe), Te;
      }, this).filter(function(be) {
        return be;
      }), M = this._createEncoderBuffer(M);
    else if (x.tag === "seqof" || x.tag === "setof") {
      if (!(x.args && x.args.length === 1))
        return Q.error("Too many args for : " + x.tag);
      if (!Array.isArray(B))
        return Q.error("seqof/setof, but data is not Array");
      var le = this.clone();
      le._baseState.implicit = null, M = this._createEncoderBuffer(B.map(function(be) {
        var Pe = this._baseState;
        return this._getUse(Pe.args[0], B)._encode(be, Q);
      }, le));
    } else x.use !== null ? ge = this._getUse(x.use, P)._encode(B, Q) : (M = this._encodePrimitive(x.tag, B), F = !0);
    var ge;
    if (!x.any && x.choice === null) {
      var pe = x.implicit !== null ? x.implicit : x.tag, Ie = x.implicit === null ? "universal" : "context";
      pe === null ? x.use === null && Q.error("Tag could be omitted only for .use()") : x.use === null && (ge = this._encodeComposite(pe, F, Ie, M));
    }
    return x.explicit !== null && (ge = this._encodeComposite(x.explicit, !1, "context", ge)), ge;
  }, b.prototype._encodeChoice = function(B, Q) {
    var P = this._baseState, x = P.choice[B.type];
    return x || p(
      !1,
      B.type + " not found in " + JSON.stringify(Object.keys(P.choice))
    ), x._encode(B.value, Q);
  }, b.prototype._encodePrimitive = function(B, Q) {
    var P = this._baseState;
    if (/str$/.test(B))
      return this._encodeStr(Q, B);
    if (B === "objid" && P.args)
      return this._encodeObjid(Q, P.reverseArgs[0], P.args[1]);
    if (B === "objid")
      return this._encodeObjid(Q, null, null);
    if (B === "gentime" || B === "utctime")
      return this._encodeTime(Q, B);
    if (B === "null_")
      return this._encodeNull();
    if (B === "int" || B === "enum")
      return this._encodeInt(Q, P.args && P.reverseArgs[0]);
    if (B === "bool")
      return this._encodeBool(Q);
    if (B === "objDesc")
      return this._encodeStr(Q, B);
    throw new Error("Unsupported tag: " + B);
  }, b.prototype._isNumstr = function(B) {
    return /^[0-9 ]*$/.test(B);
  }, b.prototype._isPrintstr = function(B) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(B);
  }, node;
}
var hasRequiredBase;
function requireBase() {
  return hasRequiredBase || (hasRequiredBase = 1, function(s) {
    var A = s;
    A.Reporter = requireReporter().Reporter, A.DecoderBuffer = requireBuffer().DecoderBuffer, A.EncoderBuffer = requireBuffer().EncoderBuffer, A.Node = requireNode();
  }(base)), base;
}
var constants$5 = {}, der = {}, hasRequiredDer$2;
function requireDer$2() {
  return hasRequiredDer$2 || (hasRequiredDer$2 = 1, function(s) {
    var A = requireConstants$5();
    s.tagClass = {
      0: "universal",
      1: "application",
      2: "context",
      3: "private"
    }, s.tagClassByName = A._reverse(s.tagClass), s.tag = {
      0: "end",
      1: "bool",
      2: "int",
      3: "bitstr",
      4: "octstr",
      5: "null_",
      6: "objid",
      7: "objDesc",
      8: "external",
      9: "real",
      10: "enum",
      11: "embed",
      12: "utf8str",
      13: "relativeOid",
      16: "seq",
      17: "set",
      18: "numstr",
      19: "printstr",
      20: "t61str",
      21: "videostr",
      22: "ia5str",
      23: "utctime",
      24: "gentime",
      25: "graphstr",
      26: "iso646str",
      27: "genstr",
      28: "unistr",
      29: "charstr",
      30: "bmpstr"
    }, s.tagByName = A._reverse(s.tag);
  }(der)), der;
}
var hasRequiredConstants$5;
function requireConstants$5() {
  return hasRequiredConstants$5 || (hasRequiredConstants$5 = 1, function(s) {
    var A = s;
    A._reverse = function(p) {
      var t = {};
      return Object.keys(p).forEach(function(l) {
        (l | 0) == l && (l = l | 0);
        var m = p[l];
        t[m] = l;
      }), t;
    }, A.der = requireDer$2();
  }(constants$5)), constants$5;
}
var decoders = {}, der_1$1, hasRequiredDer$1;
function requireDer$1() {
  if (hasRequiredDer$1) return der_1$1;
  hasRequiredDer$1 = 1;
  var s = requireInherits_browser(), A = requireAsn1$1(), u = A.base, p = A.bignum, t = A.constants.der;
  function l(C) {
    this.enc = "der", this.name = C.name, this.entity = C, this.tree = new m(), this.tree._init(C.body);
  }
  der_1$1 = l, l.prototype.decode = function(B, Q) {
    return B instanceof u.DecoderBuffer || (B = new u.DecoderBuffer(B, Q)), this.tree._decode(B, Q);
  };
  function m(C) {
    u.Node.call(this, "der", C);
  }
  s(m, u.Node), m.prototype._peekTag = function(B, Q, P) {
    if (B.isEmpty())
      return !1;
    var x = B.save(), M = b(B, 'Failed to peek tag: "' + Q + '"');
    return B.isError(M) ? M : (B.restore(x), M.tag === Q || M.tagStr === Q || M.tagStr + "of" === Q || P);
  }, m.prototype._decodeTag = function(B, Q, P) {
    var x = b(
      B,
      'Failed to decode tag of "' + Q + '"'
    );
    if (B.isError(x))
      return x;
    var M = k(
      B,
      x.primitive,
      'Failed to get length of "' + Q + '"'
    );
    if (B.isError(M))
      return M;
    if (!P && x.tag !== Q && x.tagStr !== Q && x.tagStr + "of" !== Q)
      return B.error('Failed to match tag: "' + Q + '"');
    if (x.primitive || M !== null)
      return B.skip(M, 'Failed to match body of: "' + Q + '"');
    var F = B.save(), le = this._skipUntilEnd(
      B,
      'Failed to skip indefinite length body: "' + this.tag + '"'
    );
    return B.isError(le) ? le : (M = B.offset - F.offset, B.restore(F), B.skip(M, 'Failed to match body of: "' + Q + '"'));
  }, m.prototype._skipUntilEnd = function(B, Q) {
    for (; ; ) {
      var P = b(B, Q);
      if (B.isError(P))
        return P;
      var x = k(B, P.primitive, Q);
      if (B.isError(x))
        return x;
      var M;
      if (P.primitive || x !== null ? M = B.skip(x) : M = this._skipUntilEnd(B, Q), B.isError(M))
        return M;
      if (P.tagStr === "end")
        break;
    }
  }, m.prototype._decodeList = function(B, Q, P, x) {
    for (var M = []; !B.isEmpty(); ) {
      var F = this._peekTag(B, "end");
      if (B.isError(F))
        return F;
      var le = P.decode(B, "der", x);
      if (B.isError(le) && F)
        break;
      M.push(le);
    }
    return M;
  }, m.prototype._decodeStr = function(B, Q) {
    if (Q === "bitstr") {
      var P = B.readUInt8();
      return B.isError(P) ? P : { unused: P, data: B.raw() };
    } else if (Q === "bmpstr") {
      var x = B.raw();
      if (x.length % 2 === 1)
        return B.error("Decoding of string type: bmpstr length mismatch");
      for (var M = "", F = 0; F < x.length / 2; F++)
        M += String.fromCharCode(x.readUInt16BE(F * 2));
      return M;
    } else if (Q === "numstr") {
      var le = B.raw().toString("ascii");
      return this._isNumstr(le) ? le : B.error("Decoding of string type: numstr unsupported characters");
    } else {
      if (Q === "octstr")
        return B.raw();
      if (Q === "objDesc")
        return B.raw();
      if (Q === "printstr") {
        var ge = B.raw().toString("ascii");
        return this._isPrintstr(ge) ? ge : B.error("Decoding of string type: printstr unsupported characters");
      } else return /str$/.test(Q) ? B.raw().toString() : B.error("Decoding of string type: " + Q + " unsupported");
    }
  }, m.prototype._decodeObjid = function(B, Q, P) {
    for (var x, M = [], F = 0; !B.isEmpty(); ) {
      var le = B.readUInt8();
      F <<= 7, F |= le & 127, (le & 128) === 0 && (M.push(F), F = 0);
    }
    le & 128 && M.push(F);
    var ge = M[0] / 40 | 0, pe = M[0] % 40;
    if (P ? x = M : x = [ge, pe].concat(M.slice(1)), Q) {
      var Ie = Q[x.join(" ")];
      Ie === void 0 && (Ie = Q[x.join(".")]), Ie !== void 0 && (x = Ie);
    }
    return x;
  }, m.prototype._decodeTime = function(B, Q) {
    var P = B.raw().toString();
    if (Q === "gentime")
      var x = P.slice(0, 4) | 0, M = P.slice(4, 6) | 0, F = P.slice(6, 8) | 0, le = P.slice(8, 10) | 0, ge = P.slice(10, 12) | 0, pe = P.slice(12, 14) | 0;
    else if (Q === "utctime") {
      var x = P.slice(0, 2) | 0, M = P.slice(2, 4) | 0, F = P.slice(4, 6) | 0, le = P.slice(6, 8) | 0, ge = P.slice(8, 10) | 0, pe = P.slice(10, 12) | 0;
      x < 70 ? x = 2e3 + x : x = 1900 + x;
    } else
      return B.error("Decoding " + Q + " time is not supported yet");
    return Date.UTC(x, M - 1, F, le, ge, pe, 0);
  }, m.prototype._decodeNull = function(B) {
    return null;
  }, m.prototype._decodeBool = function(B) {
    var Q = B.readUInt8();
    return B.isError(Q) ? Q : Q !== 0;
  }, m.prototype._decodeInt = function(B, Q) {
    var P = B.raw(), x = new p(P);
    return Q && (x = Q[x.toString(10)] || x), x;
  }, m.prototype._use = function(B, Q) {
    return typeof B == "function" && (B = B(Q)), B._getDecoder("der").tree;
  };
  function b(C, B) {
    var Q = C.readUInt8(B);
    if (C.isError(Q))
      return Q;
    var P = t.tagClass[Q >> 6], x = (Q & 32) === 0;
    if ((Q & 31) === 31) {
      var M = Q;
      for (Q = 0; (M & 128) === 128; ) {
        if (M = C.readUInt8(B), C.isError(M))
          return M;
        Q <<= 7, Q |= M & 127;
      }
    } else
      Q &= 31;
    var F = t.tag[Q];
    return {
      cls: P,
      primitive: x,
      tag: Q,
      tagStr: F
    };
  }
  function k(C, B, Q) {
    var P = C.readUInt8(Q);
    if (C.isError(P))
      return P;
    if (!B && P === 128)
      return null;
    if ((P & 128) === 0)
      return P;
    var x = P & 127;
    if (x > 4)
      return C.error("length octect is too long");
    P = 0;
    for (var M = 0; M < x; M++) {
      P <<= 8;
      var F = C.readUInt8(Q);
      if (C.isError(F))
        return F;
      P |= F;
    }
    return P;
  }
  return der_1$1;
}
var pem$1, hasRequiredPem$1;
function requirePem$1() {
  if (hasRequiredPem$1) return pem$1;
  hasRequiredPem$1 = 1;
  var s = requireInherits_browser(), A = requireDist$n().Buffer, u = requireDer$1();
  function p(t) {
    u.call(this, t), this.enc = "pem";
  }
  return s(p, u), pem$1 = p, p.prototype.decode = function(l, m) {
    for (var b = l.toString().split(/[\r\n]+/g), k = m.label.toUpperCase(), C = /^-----(BEGIN|END) ([^-]+)-----$/, B = -1, Q = -1, P = 0; P < b.length; P++) {
      var x = b[P].match(C);
      if (x !== null && x[2] === k)
        if (B === -1) {
          if (x[1] !== "BEGIN")
            break;
          B = P;
        } else {
          if (x[1] !== "END")
            break;
          Q = P;
          break;
        }
    }
    if (B === -1 || Q === -1)
      throw new Error("PEM section not found for: " + k);
    var M = b.slice(B + 1, Q).join("");
    M.replace(/[^a-z0-9\+\/=]+/gi, "");
    var F = new A(M, "base64");
    return u.prototype.decode.call(this, F, m);
  }, pem$1;
}
var hasRequiredDecoders;
function requireDecoders() {
  return hasRequiredDecoders || (hasRequiredDecoders = 1, function(s) {
    var A = s;
    A.der = requireDer$1(), A.pem = requirePem$1();
  }(decoders)), decoders;
}
var encoders = {}, der_1, hasRequiredDer;
function requireDer() {
  if (hasRequiredDer) return der_1;
  hasRequiredDer = 1;
  var s = requireInherits_browser(), A = requireDist$n().Buffer, u = requireAsn1$1(), p = u.base, t = u.constants.der;
  function l(C) {
    this.enc = "der", this.name = C.name, this.entity = C, this.tree = new m(), this.tree._init(C.body);
  }
  der_1 = l, l.prototype.encode = function(B, Q) {
    return this.tree._encode(B, Q).join();
  };
  function m(C) {
    p.Node.call(this, "der", C);
  }
  s(m, p.Node), m.prototype._encodeComposite = function(B, Q, P, x) {
    var M = k(B, Q, P, this.reporter);
    if (x.length < 128) {
      var ge = new A(2);
      return ge[0] = M, ge[1] = x.length, this._createEncoderBuffer([ge, x]);
    }
    for (var F = 1, le = x.length; le >= 256; le >>= 8)
      F++;
    var ge = new A(2 + F);
    ge[0] = M, ge[1] = 128 | F;
    for (var le = 1 + F, pe = x.length; pe > 0; le--, pe >>= 8)
      ge[le] = pe & 255;
    return this._createEncoderBuffer([ge, x]);
  }, m.prototype._encodeStr = function(B, Q) {
    if (Q === "bitstr")
      return this._createEncoderBuffer([B.unused | 0, B.data]);
    if (Q === "bmpstr") {
      for (var P = new A(B.length * 2), x = 0; x < B.length; x++)
        P.writeUInt16BE(B.charCodeAt(x), x * 2);
      return this._createEncoderBuffer(P);
    } else return Q === "numstr" ? this._isNumstr(B) ? this._createEncoderBuffer(B) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : Q === "printstr" ? this._isPrintstr(B) ? this._createEncoderBuffer(B) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(Q) ? this._createEncoderBuffer(B) : Q === "objDesc" ? this._createEncoderBuffer(B) : this.reporter.error("Encoding of string type: " + Q + " unsupported");
  }, m.prototype._encodeObjid = function(B, Q, P) {
    if (typeof B == "string") {
      if (!Q)
        return this.reporter.error("string objid given, but no values map found");
      if (!Q.hasOwnProperty(B))
        return this.reporter.error("objid not found in values map");
      B = Q[B].split(/[\s\.]+/g);
      for (var x = 0; x < B.length; x++)
        B[x] |= 0;
    } else if (Array.isArray(B)) {
      B = B.slice();
      for (var x = 0; x < B.length; x++)
        B[x] |= 0;
    }
    if (!Array.isArray(B))
      return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(B));
    if (!P) {
      if (B[1] >= 40)
        return this.reporter.error("Second objid identifier OOB");
      B.splice(0, 2, B[0] * 40 + B[1]);
    }
    for (var M = 0, x = 0; x < B.length; x++) {
      var F = B[x];
      for (M++; F >= 128; F >>= 7)
        M++;
    }
    for (var le = new A(M), ge = le.length - 1, x = B.length - 1; x >= 0; x--) {
      var F = B[x];
      for (le[ge--] = F & 127; (F >>= 7) > 0; )
        le[ge--] = 128 | F & 127;
    }
    return this._createEncoderBuffer(le);
  };
  function b(C) {
    return C < 10 ? "0" + C : C;
  }
  m.prototype._encodeTime = function(B, Q) {
    var P, x = new Date(B);
    return Q === "gentime" ? P = [
      b(x.getFullYear()),
      b(x.getUTCMonth() + 1),
      b(x.getUTCDate()),
      b(x.getUTCHours()),
      b(x.getUTCMinutes()),
      b(x.getUTCSeconds()),
      "Z"
    ].join("") : Q === "utctime" ? P = [
      b(x.getFullYear() % 100),
      b(x.getUTCMonth() + 1),
      b(x.getUTCDate()),
      b(x.getUTCHours()),
      b(x.getUTCMinutes()),
      b(x.getUTCSeconds()),
      "Z"
    ].join("") : this.reporter.error("Encoding " + Q + " time is not supported yet"), this._encodeStr(P, "octstr");
  }, m.prototype._encodeNull = function() {
    return this._createEncoderBuffer("");
  }, m.prototype._encodeInt = function(B, Q) {
    if (typeof B == "string") {
      if (!Q)
        return this.reporter.error("String int or enum given, but no values map");
      if (!Q.hasOwnProperty(B))
        return this.reporter.error("Values map doesn't contain: " + JSON.stringify(B));
      B = Q[B];
    }
    if (typeof B != "number" && !A.isBuffer(B)) {
      var P = B.toArray();
      !B.sign && P[0] & 128 && P.unshift(0), B = new A(P);
    }
    if (A.isBuffer(B)) {
      var x = B.length;
      B.length === 0 && x++;
      var F = new A(x);
      return B.copy(F), B.length === 0 && (F[0] = 0), this._createEncoderBuffer(F);
    }
    if (B < 128)
      return this._createEncoderBuffer(B);
    if (B < 256)
      return this._createEncoderBuffer([0, B]);
    for (var x = 1, M = B; M >= 256; M >>= 8)
      x++;
    for (var F = new Array(x), M = F.length - 1; M >= 0; M--)
      F[M] = B & 255, B >>= 8;
    return F[0] & 128 && F.unshift(0), this._createEncoderBuffer(new A(F));
  }, m.prototype._encodeBool = function(B) {
    return this._createEncoderBuffer(B ? 255 : 0);
  }, m.prototype._use = function(B, Q) {
    return typeof B == "function" && (B = B(Q)), B._getEncoder("der").tree;
  }, m.prototype._skipDefault = function(B, Q, P) {
    var x = this._baseState, M;
    if (x.default === null)
      return !1;
    var F = B.join();
    if (x.defaultBuffer === void 0 && (x.defaultBuffer = this._encodeValue(x.default, Q, P).join()), F.length !== x.defaultBuffer.length)
      return !1;
    for (M = 0; M < F.length; M++)
      if (F[M] !== x.defaultBuffer[M])
        return !1;
    return !0;
  };
  function k(C, B, Q, P) {
    var x;
    if (C === "seqof" ? C = "seq" : C === "setof" && (C = "set"), t.tagByName.hasOwnProperty(C))
      x = t.tagByName[C];
    else if (typeof C == "number" && (C | 0) === C)
      x = C;
    else
      return P.error("Unknown tag: " + C);
    return x >= 31 ? P.error("Multi-octet tag encoding unsupported") : (B || (x |= 32), x |= t.tagClassByName[Q || "universal"] << 6, x);
  }
  return der_1;
}
var pem, hasRequiredPem;
function requirePem() {
  if (hasRequiredPem) return pem;
  hasRequiredPem = 1;
  var s = requireInherits_browser(), A = requireDer();
  function u(p) {
    A.call(this, p), this.enc = "pem";
  }
  return s(u, A), pem = u, u.prototype.encode = function(t, l) {
    for (var m = A.prototype.encode.call(this, t), b = m.toString("base64"), k = ["-----BEGIN " + l.label + "-----"], C = 0; C < b.length; C += 64)
      k.push(b.slice(C, C + 64));
    return k.push("-----END " + l.label + "-----"), k.join(`
`);
  }, pem;
}
var hasRequiredEncoders;
function requireEncoders() {
  return hasRequiredEncoders || (hasRequiredEncoders = 1, function(s) {
    var A = s;
    A.der = requireDer(), A.pem = requirePem();
  }(encoders)), encoders;
}
var hasRequiredAsn1$1;
function requireAsn1$1() {
  return hasRequiredAsn1$1 || (hasRequiredAsn1$1 = 1, function(s) {
    var A = s;
    A.bignum = requireBn$1(), A.define = requireApi().define, A.base = requireBase(), A.constants = requireConstants$5(), A.decoders = requireDecoders(), A.encoders = requireEncoders();
  }(asn1)), asn1;
}
var certificate, hasRequiredCertificate;
function requireCertificate() {
  if (hasRequiredCertificate) return certificate;
  hasRequiredCertificate = 1;
  var s = requireAsn1$1(), A = s.define("Time", function() {
    this.choice({
      utcTime: this.utctime(),
      generalTime: this.gentime()
    });
  }), u = s.define("AttributeTypeValue", function() {
    this.seq().obj(
      this.key("type").objid(),
      this.key("value").any()
    );
  }), p = s.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("parameters").optional(),
      this.key("curve").objid().optional()
    );
  }), t = s.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(p),
      this.key("subjectPublicKey").bitstr()
    );
  }), l = s.define("RelativeDistinguishedName", function() {
    this.setof(u);
  }), m = s.define("RDNSequence", function() {
    this.seqof(l);
  }), b = s.define("Name", function() {
    this.choice({
      rdnSequence: this.use(m)
    });
  }), k = s.define("Validity", function() {
    this.seq().obj(
      this.key("notBefore").use(A),
      this.key("notAfter").use(A)
    );
  }), C = s.define("Extension", function() {
    this.seq().obj(
      this.key("extnID").objid(),
      this.key("critical").bool().def(!1),
      this.key("extnValue").octstr()
    );
  }), B = s.define("TBSCertificate", function() {
    this.seq().obj(
      this.key("version").explicit(0).int().optional(),
      this.key("serialNumber").int(),
      this.key("signature").use(p),
      this.key("issuer").use(b),
      this.key("validity").use(k),
      this.key("subject").use(b),
      this.key("subjectPublicKeyInfo").use(t),
      this.key("issuerUniqueID").implicit(1).bitstr().optional(),
      this.key("subjectUniqueID").implicit(2).bitstr().optional(),
      this.key("extensions").explicit(3).seqof(C).optional()
    );
  }), Q = s.define("X509Certificate", function() {
    this.seq().obj(
      this.key("tbsCertificate").use(B),
      this.key("signatureAlgorithm").use(p),
      this.key("signatureValue").bitstr()
    );
  });
  return certificate = Q, certificate;
}
var hasRequiredAsn1;
function requireAsn1() {
  if (hasRequiredAsn1) return asn1$1;
  hasRequiredAsn1 = 1;
  var s = requireAsn1$1();
  asn1$1.certificate = requireCertificate();
  var A = s.define("RSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("modulus").int(),
      this.key("publicExponent").int(),
      this.key("privateExponent").int(),
      this.key("prime1").int(),
      this.key("prime2").int(),
      this.key("exponent1").int(),
      this.key("exponent2").int(),
      this.key("coefficient").int()
    );
  });
  asn1$1.RSAPrivateKey = A;
  var u = s.define("RSAPublicKey", function() {
    this.seq().obj(
      this.key("modulus").int(),
      this.key("publicExponent").int()
    );
  });
  asn1$1.RSAPublicKey = u;
  var p = s.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("none").null_().optional(),
      this.key("curve").objid().optional(),
      this.key("params").seq().obj(
        this.key("p").int(),
        this.key("q").int(),
        this.key("g").int()
      ).optional()
    );
  }), t = s.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(p),
      this.key("subjectPublicKey").bitstr()
    );
  });
  asn1$1.PublicKey = t;
  var l = s.define("PrivateKeyInfo", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("algorithm").use(p),
      this.key("subjectPrivateKey").octstr()
    );
  });
  asn1$1.PrivateKey = l;
  var m = s.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").seq().obj(
        this.key("id").objid(),
        this.key("decrypt").seq().obj(
          this.key("kde").seq().obj(
            this.key("id").objid(),
            this.key("kdeparams").seq().obj(
              this.key("salt").octstr(),
              this.key("iters").int()
            )
          ),
          this.key("cipher").seq().obj(
            this.key("algo").objid(),
            this.key("iv").octstr()
          )
        )
      ),
      this.key("subjectPrivateKey").octstr()
    );
  });
  asn1$1.EncryptedPrivateKey = m;
  var b = s.define("DSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("p").int(),
      this.key("q").int(),
      this.key("g").int(),
      this.key("pub_key").int(),
      this.key("priv_key").int()
    );
  });
  asn1$1.DSAPrivateKey = b, asn1$1.DSAparam = s.define("DSAparam", function() {
    this.int();
  });
  var k = s.define("ECParameters", function() {
    this.choice({
      namedCurve: this.objid()
    });
  }), C = s.define("ECPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("privateKey").octstr(),
      this.key("parameters").optional().explicit(0).use(k),
      this.key("publicKey").optional().explicit(1).bitstr()
    );
  });
  return asn1$1.ECPrivateKey = C, asn1$1.signature = s.define("signature", function() {
    this.seq().obj(
      this.key("r").int(),
      this.key("s").int()
    );
  }), asn1$1;
}
const require$$1 = {
  "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
  "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
  "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
  "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
  "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
  "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
  "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
  "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
  "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
  "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
  "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
  "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};
var fixProc, hasRequiredFixProc;
function requireFixProc() {
  if (hasRequiredFixProc) return fixProc;
  hasRequiredFixProc = 1;
  var s = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, A = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, u = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, p = requireEvp_bytestokey(), t = requireBrowser$6(), l = requireSafeBuffer$1().Buffer;
  return fixProc = function(m, b) {
    var k = m.toString(), C = k.match(s), B;
    if (C) {
      var P = "aes" + C[1], x = l.from(C[2], "hex"), M = l.from(C[3].replace(/[\r\n]/g, ""), "base64"), F = p(b, x.slice(0, 8), parseInt(C[1], 10)).key, le = [], ge = t.createDecipheriv(P, F, x);
      le.push(ge.update(M)), le.push(ge.final()), B = l.concat(le);
    } else {
      var Q = k.match(u);
      B = l.from(Q[2].replace(/[\r\n]/g, ""), "base64");
    }
    var pe = k.match(A)[1];
    return {
      tag: pe,
      data: B
    };
  }, fixProc;
}
var parseAsn1, hasRequiredParseAsn1;
function requireParseAsn1() {
  if (hasRequiredParseAsn1) return parseAsn1;
  hasRequiredParseAsn1 = 1;
  var s = requireAsn1(), A = require$$1, u = requireFixProc(), p = requireBrowser$6(), t = requireBrowser$7(), l = requireSafeBuffer$1().Buffer;
  function m(k, C) {
    var B = k.algorithm.decrypt.kde.kdeparams.salt, Q = parseInt(k.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), P = A[k.algorithm.decrypt.cipher.algo.join(".")], x = k.algorithm.decrypt.cipher.iv, M = k.subjectPrivateKey, F = parseInt(P.split("-")[1], 10) / 8, le = t.pbkdf2Sync(C, B, Q, F, "sha1"), ge = p.createDecipheriv(P, le, x), pe = [];
    return pe.push(ge.update(M)), pe.push(ge.final()), l.concat(pe);
  }
  function b(k) {
    var C;
    typeof k == "object" && !l.isBuffer(k) && (C = k.passphrase, k = k.key), typeof k == "string" && (k = l.from(k));
    var B = u(k, C), Q = B.tag, P = B.data, x, M;
    switch (Q) {
      case "CERTIFICATE":
        M = s.certificate.decode(P, "der").tbsCertificate.subjectPublicKeyInfo;
      // falls through
      case "PUBLIC KEY":
        switch (M || (M = s.PublicKey.decode(P, "der")), x = M.algorithm.algorithm.join("."), x) {
          case "1.2.840.113549.1.1.1":
            return s.RSAPublicKey.decode(M.subjectPublicKey.data, "der");
          case "1.2.840.10045.2.1":
            return M.subjectPrivateKey = M.subjectPublicKey, {
              type: "ec",
              data: M
            };
          case "1.2.840.10040.4.1":
            return M.algorithm.params.pub_key = s.DSAparam.decode(M.subjectPublicKey.data, "der"), {
              type: "dsa",
              data: M.algorithm.params
            };
          default:
            throw new Error("unknown key id " + x);
        }
      // throw new Error('unknown key type ' + type)
      case "ENCRYPTED PRIVATE KEY":
        P = s.EncryptedPrivateKey.decode(P, "der"), P = m(P, C);
      // falls through
      case "PRIVATE KEY":
        switch (M = s.PrivateKey.decode(P, "der"), x = M.algorithm.algorithm.join("."), x) {
          case "1.2.840.113549.1.1.1":
            return s.RSAPrivateKey.decode(M.subjectPrivateKey, "der");
          case "1.2.840.10045.2.1":
            return {
              curve: M.algorithm.curve,
              privateKey: s.ECPrivateKey.decode(M.subjectPrivateKey, "der").privateKey
            };
          case "1.2.840.10040.4.1":
            return M.algorithm.params.priv_key = s.DSAparam.decode(M.subjectPrivateKey, "der"), {
              type: "dsa",
              params: M.algorithm.params
            };
          default:
            throw new Error("unknown key id " + x);
        }
      // throw new Error('unknown key type ' + type)
      case "RSA PUBLIC KEY":
        return s.RSAPublicKey.decode(P, "der");
      case "RSA PRIVATE KEY":
        return s.RSAPrivateKey.decode(P, "der");
      case "DSA PRIVATE KEY":
        return {
          type: "dsa",
          params: s.DSAPrivateKey.decode(P, "der")
        };
      case "EC PRIVATE KEY":
        return P = s.ECPrivateKey.decode(P, "der"), {
          curve: P.parameters.value,
          privateKey: P.privateKey
        };
      default:
        throw new Error("unknown key type " + Q);
    }
  }
  return b.signature = s.signature, parseAsn1 = b, parseAsn1;
}
const require$$4 = {
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
};
var hasRequiredSign;
function requireSign() {
  if (hasRequiredSign) return sign$2.exports;
  hasRequiredSign = 1;
  var s = requireSafeBuffer$1().Buffer, A = requireBrowser$8(), u = /* @__PURE__ */ requireBrowserifyRsa(), p = requireElliptic$2().ec, t = requireBn(), l = requireParseAsn1(), m = require$$4, b = 1;
  function k(ge, pe, Ie, be, Pe) {
    var Te = l(pe);
    if (Te.curve) {
      if (be !== "ecdsa" && be !== "ecdsa/rsa")
        throw new Error("wrong private key type");
      return C(ge, Te);
    } else if (Te.type === "dsa") {
      if (be !== "dsa")
        throw new Error("wrong private key type");
      return B(ge, Te, Ie);
    }
    if (be !== "rsa" && be !== "ecdsa/rsa")
      throw new Error("wrong private key type");
    if (pe.padding !== void 0 && pe.padding !== b)
      throw new Error("illegal or unsupported padding mode");
    ge = s.concat([Pe, ge]);
    for (var Qe = Te.modulus.byteLength(), xe = [0, 1]; ge.length + xe.length + 1 < Qe; )
      xe.push(255);
    xe.push(0);
    for (var Ee = -1; ++Ee < ge.length; )
      xe.push(ge[Ee]);
    var He = u(xe, Te);
    return He;
  }
  function C(ge, pe) {
    var Ie = m[pe.curve.join(".")];
    if (!Ie)
      throw new Error("unknown curve " + pe.curve.join("."));
    var be = new p(Ie), Pe = be.keyFromPrivate(pe.privateKey), Te = Pe.sign(ge);
    return s.from(Te.toDER());
  }
  function B(ge, pe, Ie) {
    for (var be = pe.params.priv_key, Pe = pe.params.p, Te = pe.params.q, Qe = pe.params.g, xe = new t(0), Ee, He = x(ge, Te).mod(Te), ve = !1, we = P(be, Te, ge, Ie); ve === !1; )
      Ee = F(Te, we, Ie), xe = le(Qe, Ee, Pe, Te), ve = Ee.invm(Te).imul(He.add(be.mul(xe))).mod(Te), ve.cmpn(0) === 0 && (ve = !1, xe = new t(0));
    return Q(xe, ve);
  }
  function Q(ge, pe) {
    ge = ge.toArray(), pe = pe.toArray(), ge[0] & 128 && (ge = [0].concat(ge)), pe[0] & 128 && (pe = [0].concat(pe));
    var Ie = ge.length + pe.length + 4, be = [
      48,
      Ie,
      2,
      ge.length
    ];
    return be = be.concat(ge, [2, pe.length], pe), s.from(be);
  }
  function P(ge, pe, Ie, be) {
    if (ge = s.from(ge.toArray()), ge.length < pe.byteLength()) {
      var Pe = s.alloc(pe.byteLength() - ge.length);
      ge = s.concat([Pe, ge]);
    }
    var Te = Ie.length, Qe = M(Ie, pe), xe = s.alloc(Te);
    xe.fill(1);
    var Ee = s.alloc(Te);
    return Ee = A(be, Ee).update(xe).update(s.from([0])).update(ge).update(Qe).digest(), xe = A(be, Ee).update(xe).digest(), Ee = A(be, Ee).update(xe).update(s.from([1])).update(ge).update(Qe).digest(), xe = A(be, Ee).update(xe).digest(), { k: Ee, v: xe };
  }
  function x(ge, pe) {
    var Ie = new t(ge), be = (ge.length << 3) - pe.bitLength();
    return be > 0 && Ie.ishrn(be), Ie;
  }
  function M(ge, pe) {
    ge = x(ge, pe), ge = ge.mod(pe);
    var Ie = s.from(ge.toArray());
    if (Ie.length < pe.byteLength()) {
      var be = s.alloc(pe.byteLength() - Ie.length);
      Ie = s.concat([be, Ie]);
    }
    return Ie;
  }
  function F(ge, pe, Ie) {
    var be, Pe;
    do {
      for (be = s.alloc(0); be.length * 8 < ge.bitLength(); )
        pe.v = A(Ie, pe.k).update(pe.v).digest(), be = s.concat([be, pe.v]);
      Pe = x(be, ge), pe.k = A(Ie, pe.k).update(pe.v).update(s.from([0])).digest(), pe.v = A(Ie, pe.k).update(pe.v).digest();
    } while (Pe.cmp(ge) !== -1);
    return Pe;
  }
  function le(ge, pe, Ie, be) {
    return ge.toRed(t.mont(Ie)).redPow(pe).fromRed().mod(be);
  }
  return sign$2.exports = k, sign$2.exports.getKey = P, sign$2.exports.makeKey = F, sign$2.exports;
}
var verify_1, hasRequiredVerify;
function requireVerify() {
  if (hasRequiredVerify) return verify_1;
  hasRequiredVerify = 1;
  var s = requireSafeBuffer$1().Buffer, A = requireBn(), u = requireElliptic$2().ec, p = requireParseAsn1(), t = require$$4;
  function l(C, B, Q, P, x) {
    var M = p(Q);
    if (M.type === "ec") {
      if (P !== "ecdsa" && P !== "ecdsa/rsa")
        throw new Error("wrong public key type");
      return m(C, B, M);
    } else if (M.type === "dsa") {
      if (P !== "dsa")
        throw new Error("wrong public key type");
      return b(C, B, M);
    }
    if (P !== "rsa" && P !== "ecdsa/rsa")
      throw new Error("wrong public key type");
    B = s.concat([x, B]);
    for (var F = M.modulus.byteLength(), le = [1], ge = 0; B.length + le.length + 2 < F; )
      le.push(255), ge += 1;
    le.push(0);
    for (var pe = -1; ++pe < B.length; )
      le.push(B[pe]);
    le = s.from(le);
    var Ie = A.mont(M.modulus);
    C = new A(C).toRed(Ie), C = C.redPow(new A(M.publicExponent)), C = s.from(C.fromRed().toArray());
    var be = ge < 8 ? 1 : 0;
    for (F = Math.min(C.length, le.length), C.length !== le.length && (be = 1), pe = -1; ++pe < F; )
      be |= C[pe] ^ le[pe];
    return be === 0;
  }
  function m(C, B, Q) {
    var P = t[Q.data.algorithm.curve.join(".")];
    if (!P)
      throw new Error("unknown curve " + Q.data.algorithm.curve.join("."));
    var x = new u(P), M = Q.data.subjectPrivateKey.data;
    return x.verify(B, C, M);
  }
  function b(C, B, Q) {
    var P = Q.data.p, x = Q.data.q, M = Q.data.g, F = Q.data.pub_key, le = p.signature.decode(C, "der"), ge = le.s, pe = le.r;
    k(ge, x), k(pe, x);
    var Ie = A.mont(P), be = ge.invm(x), Pe = M.toRed(Ie).redPow(new A(B).mul(be).mod(x)).fromRed().mul(F.toRed(Ie).redPow(pe.mul(be).mod(x)).fromRed()).mod(P).mod(x);
    return Pe.cmp(pe) === 0;
  }
  function k(C, B) {
    if (C.cmpn(0) <= 0)
      throw new Error("invalid sig");
    if (C.cmp(B) >= 0)
      throw new Error("invalid sig");
  }
  return verify_1 = l, verify_1;
}
var browser$3, hasRequiredBrowser$3;
function requireBrowser$3() {
  if (hasRequiredBrowser$3) return browser$3;
  hasRequiredBrowser$3 = 1;
  var s = requireSafeBuffer$1().Buffer, A = requireBrowser$a(), u = requireReadableBrowser(), p = requireInherits_browser(), t = requireSign(), l = requireVerify(), m = require$$6;
  Object.keys(m).forEach(function(Q) {
    m[Q].id = s.from(m[Q].id, "hex"), m[Q.toLowerCase()] = m[Q];
  });
  function b(Q) {
    u.Writable.call(this);
    var P = m[Q];
    if (!P)
      throw new Error("Unknown message digest");
    this._hashType = P.hash, this._hash = A(P.hash), this._tag = P.id, this._signType = P.sign;
  }
  p(b, u.Writable), b.prototype._write = function(P, x, M) {
    this._hash.update(P), M();
  }, b.prototype.update = function(P, x) {
    return this._hash.update(typeof P == "string" ? s.from(P, x) : P), this;
  }, b.prototype.sign = function(P, x) {
    this.end();
    var M = this._hash.digest(), F = t(M, P, this._hashType, this._signType, this._tag);
    return x ? F.toString(x) : F;
  };
  function k(Q) {
    u.Writable.call(this);
    var P = m[Q];
    if (!P)
      throw new Error("Unknown message digest");
    this._hash = A(P.hash), this._tag = P.id, this._signType = P.sign;
  }
  p(k, u.Writable), k.prototype._write = function(P, x, M) {
    this._hash.update(P), M();
  }, k.prototype.update = function(P, x) {
    return this._hash.update(typeof P == "string" ? s.from(P, x) : P), this;
  }, k.prototype.verify = function(P, x, M) {
    var F = typeof x == "string" ? s.from(x, M) : x;
    this.end();
    var le = this._hash.digest();
    return l(F, le, P, this._signType, this._tag);
  };
  function C(Q) {
    return new b(Q);
  }
  function B(Q) {
    return new k(Q);
  }
  return browser$3 = {
    Sign: C,
    Verify: B,
    createSign: C,
    createVerify: B
  }, browser$3;
}
var browser$2, hasRequiredBrowser$2;
function requireBrowser$2() {
  if (hasRequiredBrowser$2) return browser$2;
  hasRequiredBrowser$2 = 1;
  var s = requireElliptic$2(), A = requireBn$1();
  browser$2 = function(m) {
    return new p(m);
  };
  var u = {
    secp256k1: {
      name: "secp256k1",
      byteLength: 32
    },
    secp224r1: {
      name: "p224",
      byteLength: 28
    },
    prime256v1: {
      name: "p256",
      byteLength: 32
    },
    prime192v1: {
      name: "p192",
      byteLength: 24
    },
    ed25519: {
      name: "ed25519",
      byteLength: 32
    },
    secp384r1: {
      name: "p384",
      byteLength: 48
    },
    secp521r1: {
      name: "p521",
      byteLength: 66
    }
  };
  u.p224 = u.secp224r1, u.p256 = u.secp256r1 = u.prime256v1, u.p192 = u.secp192r1 = u.prime192v1, u.p384 = u.secp384r1, u.p521 = u.secp521r1;
  function p(l) {
    this.curveType = u[l], this.curveType || (this.curveType = {
      name: l
    }), this.curve = new s.ec(this.curveType.name), this.keys = void 0;
  }
  p.prototype.generateKeys = function(l, m) {
    return this.keys = this.curve.genKeyPair(), this.getPublicKey(l, m);
  }, p.prototype.computeSecret = function(l, m, b) {
    m = m || "utf8", Buffer.isBuffer(l) || (l = new Buffer(l, m));
    var k = this.curve.keyFromPublic(l).getPublic(), C = k.mul(this.keys.getPrivate()).getX();
    return t(C, b, this.curveType.byteLength);
  }, p.prototype.getPublicKey = function(l, m) {
    var b = this.keys.getPublic(m === "compressed", !0);
    return m === "hybrid" && (b[b.length - 1] % 2 ? b[0] = 7 : b[0] = 6), t(b, l);
  }, p.prototype.getPrivateKey = function(l) {
    return t(this.keys.getPrivate(), l);
  }, p.prototype.setPublicKey = function(l, m) {
    return m = m || "utf8", Buffer.isBuffer(l) || (l = new Buffer(l, m)), this.keys._importPublic(l), this;
  }, p.prototype.setPrivateKey = function(l, m) {
    m = m || "utf8", Buffer.isBuffer(l) || (l = new Buffer(l, m));
    var b = new A(l);
    return b = b.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(b), this;
  };
  function t(l, m, b) {
    Array.isArray(l) || (l = l.toArray());
    var k = new Buffer(l);
    if (b && k.length < b) {
      var C = new Buffer(b - k.length);
      C.fill(0), k = Buffer.concat([C, k]);
    }
    return m ? k.toString(m) : k;
  }
  return browser$2;
}
var browser$1 = {}, mgf, hasRequiredMgf;
function requireMgf() {
  if (hasRequiredMgf) return mgf;
  hasRequiredMgf = 1;
  var s = requireBrowser$a(), A = requireSafeBuffer$1().Buffer;
  mgf = function(p, t) {
    for (var l = A.alloc(0), m = 0, b; l.length < t; )
      b = u(m++), l = A.concat([l, s("sha1").update(p).update(b).digest()]);
    return l.slice(0, t);
  };
  function u(p) {
    var t = A.allocUnsafe(4);
    return t.writeUInt32BE(p, 0), t;
  }
  return mgf;
}
var xor, hasRequiredXor;
function requireXor() {
  return hasRequiredXor || (hasRequiredXor = 1, xor = function(A, u) {
    for (var p = A.length, t = -1; ++t < p; )
      A[t] ^= u[t];
    return A;
  }), xor;
}
var withPublic_1, hasRequiredWithPublic;
function requireWithPublic() {
  if (hasRequiredWithPublic) return withPublic_1;
  hasRequiredWithPublic = 1;
  var s = requireBn$1(), A = requireSafeBuffer$1().Buffer;
  function u(p, t) {
    return A.from(p.toRed(s.mont(t.modulus)).redPow(new s(t.publicExponent)).fromRed().toArray());
  }
  return withPublic_1 = u, withPublic_1;
}
var publicEncrypt, hasRequiredPublicEncrypt;
function requirePublicEncrypt() {
  if (hasRequiredPublicEncrypt) return publicEncrypt;
  hasRequiredPublicEncrypt = 1;
  var s = requireParseAsn1(), A = requireBrowser$9(), u = requireBrowser$a(), p = requireMgf(), t = requireXor(), l = requireBn$1(), m = requireWithPublic(), b = /* @__PURE__ */ requireBrowserifyRsa(), k = requireSafeBuffer$1().Buffer;
  publicEncrypt = function(x, M, F) {
    var le;
    x.padding ? le = x.padding : F ? le = 1 : le = 4;
    var ge = s(x), pe;
    if (le === 4)
      pe = C(ge, M);
    else if (le === 1)
      pe = B(ge, M, F);
    else if (le === 3) {
      if (pe = new l(M), pe.cmp(ge.modulus) >= 0)
        throw new Error("data too long for modulus");
    } else
      throw new Error("unknown padding");
    return F ? b(pe, ge) : m(pe, ge);
  };
  function C(P, x) {
    var M = P.modulus.byteLength(), F = x.length, le = u("sha1").update(k.alloc(0)).digest(), ge = le.length, pe = 2 * ge;
    if (F > M - pe - 2)
      throw new Error("message too long");
    var Ie = k.alloc(M - F - pe - 2), be = M - ge - 1, Pe = A(ge), Te = t(k.concat([le, Ie, k.alloc(1, 1), x], be), p(Pe, be)), Qe = t(Pe, p(Te, ge));
    return new l(k.concat([k.alloc(1), Qe, Te], M));
  }
  function B(P, x, M) {
    var F = x.length, le = P.modulus.byteLength();
    if (F > le - 11)
      throw new Error("message too long");
    var ge;
    return M ? ge = k.alloc(le - F - 3, 255) : ge = Q(le - F - 3), new l(k.concat([k.from([0, M ? 1 : 2]), ge, k.alloc(1), x], le));
  }
  function Q(P) {
    for (var x = k.allocUnsafe(P), M = 0, F = A(P * 2), le = 0, ge; M < P; )
      le === F.length && (F = A(P * 2), le = 0), ge = F[le++], ge && (x[M++] = ge);
    return x;
  }
  return publicEncrypt;
}
var privateDecrypt, hasRequiredPrivateDecrypt;
function requirePrivateDecrypt() {
  if (hasRequiredPrivateDecrypt) return privateDecrypt;
  hasRequiredPrivateDecrypt = 1;
  var s = requireParseAsn1(), A = requireMgf(), u = requireXor(), p = requireBn$1(), t = /* @__PURE__ */ requireBrowserifyRsa(), l = requireBrowser$a(), m = requireWithPublic(), b = requireSafeBuffer$1().Buffer;
  privateDecrypt = function(P, x, M) {
    var F;
    P.padding ? F = P.padding : M ? F = 1 : F = 4;
    var le = s(P), ge = le.modulus.byteLength();
    if (x.length > ge || new p(x).cmp(le.modulus) >= 0)
      throw new Error("decryption error");
    var pe;
    M ? pe = m(new p(x), le) : pe = t(x, le);
    var Ie = b.alloc(ge - pe.length);
    if (pe = b.concat([Ie, pe], ge), F === 4)
      return k(le, pe);
    if (F === 1)
      return C(le, pe, M);
    if (F === 3)
      return pe;
    throw new Error("unknown padding");
  };
  function k(Q, P) {
    var x = Q.modulus.byteLength(), M = l("sha1").update(b.alloc(0)).digest(), F = M.length;
    if (P[0] !== 0)
      throw new Error("decryption error");
    var le = P.slice(1, F + 1), ge = P.slice(F + 1), pe = u(le, A(ge, F)), Ie = u(ge, A(pe, x - F - 1));
    if (B(M, Ie.slice(0, F)))
      throw new Error("decryption error");
    for (var be = F; Ie[be] === 0; )
      be++;
    if (Ie[be++] !== 1)
      throw new Error("decryption error");
    return Ie.slice(be);
  }
  function C(Q, P, x) {
    for (var M = P.slice(0, 2), F = 2, le = 0; P[F++] !== 0; )
      if (F >= P.length) {
        le++;
        break;
      }
    var ge = P.slice(2, F - 1);
    if ((M.toString("hex") !== "0002" && !x || M.toString("hex") !== "0001" && x) && le++, ge.length < 8 && le++, le)
      throw new Error("decryption error");
    return P.slice(F);
  }
  function B(Q, P) {
    Q = b.from(Q), P = b.from(P);
    var x = 0, M = Q.length;
    Q.length !== P.length && (x++, M = Math.min(Q.length, P.length));
    for (var F = -1; ++F < M; )
      x += Q[F] ^ P[F];
    return x;
  }
  return privateDecrypt;
}
var hasRequiredBrowser$1;
function requireBrowser$1() {
  return hasRequiredBrowser$1 || (hasRequiredBrowser$1 = 1, function(s) {
    s.publicEncrypt = requirePublicEncrypt(), s.privateDecrypt = requirePrivateDecrypt(), s.privateEncrypt = function(u, p) {
      return s.publicEncrypt(u, p, !0);
    }, s.publicDecrypt = function(u, p) {
      return s.privateDecrypt(u, p, !0);
    };
  }(browser$1)), browser$1;
}
var browser = {}, hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser) return browser;
  hasRequiredBrowser = 1;
  function s() {
    throw new Error(`secure random number generation not supported by this browser
use chrome, FireFox or Internet Explorer 11`);
  }
  var A = requireSafeBuffer$1(), u = requireBrowser$9(), p = A.Buffer, t = A.kMaxLength, l = commonjsGlobal.crypto || commonjsGlobal.msCrypto, m = Math.pow(2, 32) - 1;
  function b(P, x) {
    if (typeof P != "number" || P !== P)
      throw new TypeError("offset must be a number");
    if (P > m || P < 0)
      throw new TypeError("offset must be a uint32");
    if (P > t || P > x)
      throw new RangeError("offset out of range");
  }
  function k(P, x, M) {
    if (typeof P != "number" || P !== P)
      throw new TypeError("size must be a number");
    if (P > m || P < 0)
      throw new TypeError("size must be a uint32");
    if (P + x > M || P > t)
      throw new RangeError("buffer too small");
  }
  l && l.getRandomValues || !process$1.browser ? (browser.randomFill = C, browser.randomFillSync = Q) : (browser.randomFill = s, browser.randomFillSync = s);
  function C(P, x, M, F) {
    if (!p.isBuffer(P) && !(P instanceof commonjsGlobal.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof x == "function")
      F = x, x = 0, M = P.length;
    else if (typeof M == "function")
      F = M, M = P.length - x;
    else if (typeof F != "function")
      throw new TypeError('"cb" argument must be a function');
    return b(x, P.length), k(M, x, P.length), B(P, x, M, F);
  }
  function B(P, x, M, F) {
    if (process$1.browser) {
      var le = P.buffer, ge = new Uint8Array(le, x, M);
      if (l.getRandomValues(ge), F) {
        process$1.nextTick(function() {
          F(null, P);
        });
        return;
      }
      return P;
    }
    if (F) {
      u(M, function(Ie, be) {
        if (Ie)
          return F(Ie);
        be.copy(P, x), F(null, P);
      });
      return;
    }
    var pe = u(M);
    return pe.copy(P, x), P;
  }
  function Q(P, x, M) {
    if (typeof x > "u" && (x = 0), !p.isBuffer(P) && !(P instanceof commonjsGlobal.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    return b(x, P.length), M === void 0 && (M = P.length - x), k(M, x, P.length), B(P, x, M);
  }
  return browser;
}
var hasRequiredCryptoBrowserify;
function requireCryptoBrowserify() {
  if (hasRequiredCryptoBrowserify) return cryptoBrowserify;
  hasRequiredCryptoBrowserify = 1, cryptoBrowserify.randomBytes = cryptoBrowserify.rng = cryptoBrowserify.pseudoRandomBytes = cryptoBrowserify.prng = requireBrowser$9(), cryptoBrowserify.createHash = cryptoBrowserify.Hash = requireBrowser$a(), cryptoBrowserify.createHmac = cryptoBrowserify.Hmac = requireBrowser$8();
  var s = requireAlgos(), A = Object.keys(s), u = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
  ].concat(A);
  cryptoBrowserify.getHashes = function() {
    return u;
  };
  var p = requireBrowser$7();
  cryptoBrowserify.pbkdf2 = p.pbkdf2, cryptoBrowserify.pbkdf2Sync = p.pbkdf2Sync;
  var t = requireBrowser$5();
  cryptoBrowserify.Cipher = t.Cipher, cryptoBrowserify.createCipher = t.createCipher, cryptoBrowserify.Cipheriv = t.Cipheriv, cryptoBrowserify.createCipheriv = t.createCipheriv, cryptoBrowserify.Decipher = t.Decipher, cryptoBrowserify.createDecipher = t.createDecipher, cryptoBrowserify.Decipheriv = t.Decipheriv, cryptoBrowserify.createDecipheriv = t.createDecipheriv, cryptoBrowserify.getCiphers = t.getCiphers, cryptoBrowserify.listCiphers = t.listCiphers;
  var l = requireBrowser$4();
  cryptoBrowserify.DiffieHellmanGroup = l.DiffieHellmanGroup, cryptoBrowserify.createDiffieHellmanGroup = l.createDiffieHellmanGroup, cryptoBrowserify.getDiffieHellman = l.getDiffieHellman, cryptoBrowserify.createDiffieHellman = l.createDiffieHellman, cryptoBrowserify.DiffieHellman = l.DiffieHellman;
  var m = requireBrowser$3();
  cryptoBrowserify.createSign = m.createSign, cryptoBrowserify.Sign = m.Sign, cryptoBrowserify.createVerify = m.createVerify, cryptoBrowserify.Verify = m.Verify, cryptoBrowserify.createECDH = requireBrowser$2();
  var b = requireBrowser$1();
  cryptoBrowserify.publicEncrypt = b.publicEncrypt, cryptoBrowserify.privateEncrypt = b.privateEncrypt, cryptoBrowserify.publicDecrypt = b.publicDecrypt, cryptoBrowserify.privateDecrypt = b.privateDecrypt;
  var k = requireBrowser();
  return cryptoBrowserify.randomFill = k.randomFill, cryptoBrowserify.randomFillSync = k.randomFillSync, cryptoBrowserify.createCredentials = function() {
    throw new Error(`sorry, createCredentials is not implemented yet
we accept pull requests
https://github.com/browserify/crypto-browserify`);
  }, cryptoBrowserify.constants = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
  }, cryptoBrowserify;
}
var lib$5, hasRequiredLib$5;
function requireLib$5() {
  if (hasRequiredLib$5) return lib$5;
  hasRequiredLib$5 = 1;
  const s = {
    IMPOSSIBLE_CASE: "Impossible case. Please create issue.",
    TWEAK_ADD: "The tweak was out of range or the resulted private key is invalid",
    TWEAK_MUL: "The tweak was out of range or equal to zero",
    CONTEXT_RANDOMIZE_UNKNOW: "Unknow error on context randomization",
    SECKEY_INVALID: "Private Key is invalid",
    PUBKEY_PARSE: "Public Key could not be parsed",
    PUBKEY_SERIALIZE: "Public Key serialization error",
    PUBKEY_COMBINE: "The sum of the public keys is not valid",
    SIG_PARSE: "Signature could not be parsed",
    SIGN: "The nonce generation function failed, or the private key was invalid",
    RECOVER: "Public key could not be recover",
    ECDH: "Scalar was invalid (zero or overflow)"
  };
  function A(m, b) {
    if (!m) throw new Error(b);
  }
  function u(m, b, k) {
    if (A(b instanceof Uint8Array, `Expected ${m} to be an Uint8Array`), k !== void 0)
      if (Array.isArray(k)) {
        const C = k.join(", "), B = `Expected ${m} to be an Uint8Array with length [${C}]`;
        A(k.includes(b.length), B);
      } else {
        const C = `Expected ${m} to be an Uint8Array with length ${k}`;
        A(b.length === k, C);
      }
  }
  function p(m) {
    A(l(m) === "Boolean", "Expected compressed to be a Boolean");
  }
  function t(m = (k) => new Uint8Array(k), b) {
    return typeof m == "function" && (m = m(b)), u("output", m, b), m;
  }
  function l(m) {
    return Object.prototype.toString.call(m).slice(8, -1);
  }
  return lib$5 = (m) => ({
    contextRandomize(b) {
      switch (A(
        b === null || b instanceof Uint8Array,
        "Expected seed to be an Uint8Array or null"
      ), b !== null && u("seed", b, 32), m.contextRandomize(b)) {
        case 1:
          throw new Error(s.CONTEXT_RANDOMIZE_UNKNOW);
      }
    },
    privateKeyVerify(b) {
      return u("private key", b, 32), m.privateKeyVerify(b) === 0;
    },
    privateKeyNegate(b) {
      switch (u("private key", b, 32), m.privateKeyNegate(b)) {
        case 0:
          return b;
        case 1:
          throw new Error(s.IMPOSSIBLE_CASE);
      }
    },
    privateKeyTweakAdd(b, k) {
      switch (u("private key", b, 32), u("tweak", k, 32), m.privateKeyTweakAdd(b, k)) {
        case 0:
          return b;
        case 1:
          throw new Error(s.TWEAK_ADD);
      }
    },
    privateKeyTweakMul(b, k) {
      switch (u("private key", b, 32), u("tweak", k, 32), m.privateKeyTweakMul(b, k)) {
        case 0:
          return b;
        case 1:
          throw new Error(s.TWEAK_MUL);
      }
    },
    publicKeyVerify(b) {
      return u("public key", b, [33, 65]), m.publicKeyVerify(b) === 0;
    },
    publicKeyCreate(b, k = !0, C) {
      switch (u("private key", b, 32), p(k), C = t(C, k ? 33 : 65), m.publicKeyCreate(C, b)) {
        case 0:
          return C;
        case 1:
          throw new Error(s.SECKEY_INVALID);
        case 2:
          throw new Error(s.PUBKEY_SERIALIZE);
      }
    },
    publicKeyConvert(b, k = !0, C) {
      switch (u("public key", b, [33, 65]), p(k), C = t(C, k ? 33 : 65), m.publicKeyConvert(C, b)) {
        case 0:
          return C;
        case 1:
          throw new Error(s.PUBKEY_PARSE);
        case 2:
          throw new Error(s.PUBKEY_SERIALIZE);
      }
    },
    publicKeyNegate(b, k = !0, C) {
      switch (u("public key", b, [33, 65]), p(k), C = t(C, k ? 33 : 65), m.publicKeyNegate(C, b)) {
        case 0:
          return C;
        case 1:
          throw new Error(s.PUBKEY_PARSE);
        case 2:
          throw new Error(s.IMPOSSIBLE_CASE);
        case 3:
          throw new Error(s.PUBKEY_SERIALIZE);
      }
    },
    publicKeyCombine(b, k = !0, C) {
      A(Array.isArray(b), "Expected public keys to be an Array"), A(b.length > 0, "Expected public keys array will have more than zero items");
      for (const B of b)
        u("public key", B, [33, 65]);
      switch (p(k), C = t(C, k ? 33 : 65), m.publicKeyCombine(C, b)) {
        case 0:
          return C;
        case 1:
          throw new Error(s.PUBKEY_PARSE);
        case 2:
          throw new Error(s.PUBKEY_COMBINE);
        case 3:
          throw new Error(s.PUBKEY_SERIALIZE);
      }
    },
    publicKeyTweakAdd(b, k, C = !0, B) {
      switch (u("public key", b, [33, 65]), u("tweak", k, 32), p(C), B = t(B, C ? 33 : 65), m.publicKeyTweakAdd(B, b, k)) {
        case 0:
          return B;
        case 1:
          throw new Error(s.PUBKEY_PARSE);
        case 2:
          throw new Error(s.TWEAK_ADD);
      }
    },
    publicKeyTweakMul(b, k, C = !0, B) {
      switch (u("public key", b, [33, 65]), u("tweak", k, 32), p(C), B = t(B, C ? 33 : 65), m.publicKeyTweakMul(B, b, k)) {
        case 0:
          return B;
        case 1:
          throw new Error(s.PUBKEY_PARSE);
        case 2:
          throw new Error(s.TWEAK_MUL);
      }
    },
    signatureNormalize(b) {
      switch (u("signature", b, 64), m.signatureNormalize(b)) {
        case 0:
          return b;
        case 1:
          throw new Error(s.SIG_PARSE);
      }
    },
    signatureExport(b, k) {
      u("signature", b, 64), k = t(k, 72);
      const C = { output: k, outputlen: 72 };
      switch (m.signatureExport(C, b)) {
        case 0:
          return k.slice(0, C.outputlen);
        case 1:
          throw new Error(s.SIG_PARSE);
        case 2:
          throw new Error(s.IMPOSSIBLE_CASE);
      }
    },
    signatureImport(b, k) {
      switch (u("signature", b), k = t(k, 64), m.signatureImport(k, b)) {
        case 0:
          return k;
        case 1:
          throw new Error(s.SIG_PARSE);
        case 2:
          throw new Error(s.IMPOSSIBLE_CASE);
      }
    },
    ecdsaSign(b, k, C = {}, B) {
      u("message", b, 32), u("private key", k, 32), A(l(C) === "Object", "Expected options to be an Object"), C.data !== void 0 && u("options.data", C.data), C.noncefn !== void 0 && A(l(C.noncefn) === "Function", "Expected options.noncefn to be a Function"), B = t(B, 64);
      const Q = { signature: B, recid: null };
      switch (m.ecdsaSign(Q, b, k, C.data, C.noncefn)) {
        case 0:
          return Q;
        case 1:
          throw new Error(s.SIGN);
        case 2:
          throw new Error(s.IMPOSSIBLE_CASE);
      }
    },
    ecdsaVerify(b, k, C) {
      switch (u("signature", b, 64), u("message", k, 32), u("public key", C, [33, 65]), m.ecdsaVerify(b, k, C)) {
        case 0:
          return !0;
        case 3:
          return !1;
        case 1:
          throw new Error(s.SIG_PARSE);
        case 2:
          throw new Error(s.PUBKEY_PARSE);
      }
    },
    ecdsaRecover(b, k, C, B = !0, Q) {
      switch (u("signature", b, 64), A(
        l(k) === "Number" && k >= 0 && k <= 3,
        "Expected recovery id to be a Number within interval [0, 3]"
      ), u("message", C, 32), p(B), Q = t(Q, B ? 33 : 65), m.ecdsaRecover(Q, b, k, C)) {
        case 0:
          return Q;
        case 1:
          throw new Error(s.SIG_PARSE);
        case 2:
          throw new Error(s.RECOVER);
        case 3:
          throw new Error(s.IMPOSSIBLE_CASE);
      }
    },
    ecdh(b, k, C = {}, B) {
      switch (u("public key", b, [33, 65]), u("private key", k, 32), A(l(C) === "Object", "Expected options to be an Object"), C.data !== void 0 && u("options.data", C.data), C.hashfn !== void 0 ? (A(l(C.hashfn) === "Function", "Expected options.hashfn to be a Function"), C.xbuf !== void 0 && u("options.xbuf", C.xbuf, 32), C.ybuf !== void 0 && u("options.ybuf", C.ybuf, 32), u("output", B)) : B = t(B, 32), m.ecdh(B, b, k, C.data, C.hashfn, C.xbuf, C.ybuf)) {
        case 0:
          return B;
        case 1:
          throw new Error(s.PUBKEY_PARSE);
        case 2:
          throw new Error(s.ECDH);
      }
    }
  }), lib$5;
}
var elliptic$1, hasRequiredElliptic$1;
function requireElliptic$1() {
  if (hasRequiredElliptic$1) return elliptic$1;
  hasRequiredElliptic$1 = 1;
  const s = requireElliptic$2().ec, A = new s("secp256k1"), u = A.curve, p = u.n.constructor;
  function t(k, C) {
    let B = new p(C);
    if (B.cmp(u.p) >= 0) return null;
    B = B.toRed(u.red);
    let Q = B.redSqr().redIMul(B).redIAdd(u.b).redSqrt();
    k === 3 !== Q.isOdd() && (Q = Q.redNeg());
    const P = B.redSqr().redIMul(B);
    return Q.redSqr().redISub(P.redIAdd(u.b)).isZero() ? A.keyPair({ pub: { x: B, y: Q } }) : null;
  }
  function l(k, C, B) {
    let Q = new p(C), P = new p(B);
    if (Q.cmp(u.p) >= 0 || P.cmp(u.p) >= 0 || (Q = Q.toRed(u.red), P = P.toRed(u.red), (k === 6 || k === 7) && P.isOdd() !== (k === 7))) return null;
    const x = Q.redSqr().redIMul(Q);
    return P.redSqr().redISub(x.redIAdd(u.b)).isZero() ? A.keyPair({ pub: { x: Q, y: P } }) : null;
  }
  function m(k) {
    const C = k[0];
    switch (C) {
      case 2:
      case 3:
        return k.length !== 33 ? null : t(C, k.subarray(1, 33));
      case 4:
      case 6:
      case 7:
        return k.length !== 65 ? null : l(C, k.subarray(1, 33), k.subarray(33, 65));
      default:
        return null;
    }
  }
  function b(k, C) {
    const B = C.encode(null, k.length === 33);
    for (let Q = 0; Q < k.length; ++Q) k[Q] = B[Q];
  }
  return elliptic$1 = {
    contextRandomize() {
      return 0;
    },
    privateKeyVerify(k) {
      const C = new p(k);
      return C.cmp(u.n) < 0 && !C.isZero() ? 0 : 1;
    },
    privateKeyNegate(k) {
      const C = new p(k), B = u.n.sub(C).umod(u.n).toArrayLike(Uint8Array, "be", 32);
      return k.set(B), 0;
    },
    privateKeyTweakAdd(k, C) {
      const B = new p(C);
      if (B.cmp(u.n) >= 0 || (B.iadd(new p(k)), B.cmp(u.n) >= 0 && B.isub(u.n), B.isZero())) return 1;
      const Q = B.toArrayLike(Uint8Array, "be", 32);
      return k.set(Q), 0;
    },
    privateKeyTweakMul(k, C) {
      let B = new p(C);
      if (B.cmp(u.n) >= 0 || B.isZero()) return 1;
      B.imul(new p(k)), B.cmp(u.n) >= 0 && (B = B.umod(u.n));
      const Q = B.toArrayLike(Uint8Array, "be", 32);
      return k.set(Q), 0;
    },
    publicKeyVerify(k) {
      return m(k) === null ? 1 : 0;
    },
    publicKeyCreate(k, C) {
      const B = new p(C);
      if (B.cmp(u.n) >= 0 || B.isZero()) return 1;
      const Q = A.keyFromPrivate(C).getPublic();
      return b(k, Q), 0;
    },
    publicKeyConvert(k, C) {
      const B = m(C);
      if (B === null) return 1;
      const Q = B.getPublic();
      return b(k, Q), 0;
    },
    publicKeyNegate(k, C) {
      const B = m(C);
      if (B === null) return 1;
      const Q = B.getPublic();
      return Q.y = Q.y.redNeg(), b(k, Q), 0;
    },
    publicKeyCombine(k, C) {
      const B = new Array(C.length);
      for (let P = 0; P < C.length; ++P)
        if (B[P] = m(C[P]), B[P] === null) return 1;
      let Q = B[0].getPublic();
      for (let P = 1; P < B.length; ++P) Q = Q.add(B[P].pub);
      return Q.isInfinity() ? 2 : (b(k, Q), 0);
    },
    publicKeyTweakAdd(k, C, B) {
      const Q = m(C);
      if (Q === null) return 1;
      if (B = new p(B), B.cmp(u.n) >= 0) return 2;
      const P = Q.getPublic().add(u.g.mul(B));
      return P.isInfinity() ? 2 : (b(k, P), 0);
    },
    publicKeyTweakMul(k, C, B) {
      const Q = m(C);
      if (Q === null) return 1;
      if (B = new p(B), B.cmp(u.n) >= 0 || B.isZero()) return 2;
      const P = Q.getPublic().mul(B);
      return b(k, P), 0;
    },
    signatureNormalize(k) {
      const C = new p(k.subarray(0, 32)), B = new p(k.subarray(32, 64));
      return C.cmp(u.n) >= 0 || B.cmp(u.n) >= 0 ? 1 : (B.cmp(A.nh) === 1 && k.set(u.n.sub(B).toArrayLike(Uint8Array, "be", 32), 32), 0);
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureExport(k, C) {
      const B = C.subarray(0, 32), Q = C.subarray(32, 64);
      if (new p(B).cmp(u.n) >= 0 || new p(Q).cmp(u.n) >= 0) return 1;
      const { output: P } = k;
      let x = P.subarray(4, 37);
      x[0] = 0, x.set(B, 1);
      let M = 33, F = 0;
      for (; M > 1 && x[F] === 0 && !(x[F + 1] & 128); --M, ++F) ;
      if (x = x.subarray(F), x[0] & 128 || M > 1 && x[0] === 0 && !(x[1] & 128)) return 1;
      let le = P.subarray(39, 72);
      le[0] = 0, le.set(Q, 1);
      let ge = 33, pe = 0;
      for (; ge > 1 && le[pe] === 0 && !(le[pe + 1] & 128); --ge, ++pe) ;
      return le = le.subarray(pe), le[0] & 128 || ge > 1 && le[0] === 0 && !(le[1] & 128) ? 1 : (k.outputlen = 6 + M + ge, P[0] = 48, P[1] = k.outputlen - 2, P[2] = 2, P[3] = x.length, P.set(x, 4), P[4 + M] = 2, P[5 + M] = le.length, P.set(le, 6 + M), 0);
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureImport(k, C) {
      if (C.length < 8 || C.length > 72 || C[0] !== 48 || C[1] !== C.length - 2 || C[2] !== 2) return 1;
      const B = C[3];
      if (B === 0 || 5 + B >= C.length || C[4 + B] !== 2) return 1;
      const Q = C[5 + B];
      if (Q === 0 || 6 + B + Q !== C.length || C[4] & 128 || B > 1 && C[4] === 0 && !(C[5] & 128) || C[B + 6] & 128 || Q > 1 && C[B + 6] === 0 && !(C[B + 7] & 128)) return 1;
      let P = C.subarray(4, 4 + B);
      if (P.length === 33 && P[0] === 0 && (P = P.subarray(1)), P.length > 32) return 1;
      let x = C.subarray(6 + B);
      if (x.length === 33 && x[0] === 0 && (x = x.slice(1)), x.length > 32) throw new Error("S length is too long");
      let M = new p(P);
      M.cmp(u.n) >= 0 && (M = new p(0));
      let F = new p(C.subarray(6 + B));
      return F.cmp(u.n) >= 0 && (F = new p(0)), k.set(M.toArrayLike(Uint8Array, "be", 32), 0), k.set(F.toArrayLike(Uint8Array, "be", 32), 32), 0;
    },
    ecdsaSign(k, C, B, Q, P) {
      if (P) {
        const F = P;
        P = (le) => {
          const ge = F(C, B, null, Q, le);
          if (!(ge instanceof Uint8Array && ge.length === 32)) throw new Error("This is the way");
          return new p(ge);
        };
      }
      const x = new p(B);
      if (x.cmp(u.n) >= 0 || x.isZero()) return 1;
      let M;
      try {
        M = A.sign(C, B, { canonical: !0, k: P, pers: Q });
      } catch {
        return 1;
      }
      return k.signature.set(M.r.toArrayLike(Uint8Array, "be", 32), 0), k.signature.set(M.s.toArrayLike(Uint8Array, "be", 32), 32), k.recid = M.recoveryParam, 0;
    },
    ecdsaVerify(k, C, B) {
      const Q = { r: k.subarray(0, 32), s: k.subarray(32, 64) }, P = new p(Q.r), x = new p(Q.s);
      if (P.cmp(u.n) >= 0 || x.cmp(u.n) >= 0) return 1;
      if (x.cmp(A.nh) === 1 || P.isZero() || x.isZero()) return 3;
      const M = m(B);
      if (M === null) return 2;
      const F = M.getPublic();
      return A.verify(C, Q, F) ? 0 : 3;
    },
    ecdsaRecover(k, C, B, Q) {
      const P = { r: C.slice(0, 32), s: C.slice(32, 64) }, x = new p(P.r), M = new p(P.s);
      if (x.cmp(u.n) >= 0 || M.cmp(u.n) >= 0) return 1;
      if (x.isZero() || M.isZero()) return 2;
      let F;
      try {
        F = A.recoverPubKey(Q, P, B);
      } catch {
        return 2;
      }
      return b(k, F), 0;
    },
    ecdh(k, C, B, Q, P, x, M) {
      const F = m(C);
      if (F === null) return 1;
      const le = new p(B);
      if (le.cmp(u.n) >= 0 || le.isZero()) return 2;
      const ge = F.getPublic().mul(le);
      if (P === void 0) {
        const pe = ge.encode(null, !0), Ie = A.hash().update(pe).digest();
        for (let be = 0; be < 32; ++be) k[be] = Ie[be];
      } else {
        x || (x = new Uint8Array(32));
        const pe = ge.getX().toArray("be", 32);
        for (let Te = 0; Te < 32; ++Te) x[Te] = pe[Te];
        M || (M = new Uint8Array(32));
        const Ie = ge.getY().toArray("be", 32);
        for (let Te = 0; Te < 32; ++Te) M[Te] = Ie[Te];
        const be = P(x, M, Q);
        if (!(be instanceof Uint8Array && be.length === k.length)) return 2;
        k.set(be);
      }
      return 0;
    }
  }, elliptic$1;
}
var elliptic, hasRequiredElliptic;
function requireElliptic() {
  return hasRequiredElliptic || (hasRequiredElliptic = 1, elliptic = requireLib$5()(requireElliptic$1())), elliptic;
}
var hdkey, hasRequiredHdkey;
function requireHdkey() {
  if (hasRequiredHdkey) return hdkey;
  hasRequiredHdkey = 1;
  var s = requireAssert$2(), A = requireSafeBuffer$1().Buffer, u = requireCryptoBrowserify(), p = requireBs58check(), t = requireRipemd160$1(), l = requireElliptic(), m = A.from("Bitcoin seed", "utf8"), b = 2147483648, k = 78, C = { private: 76066276, public: 76067358 };
  function B(M) {
    this.versions = M || C, this.depth = 0, this.index = 0, this._privateKey = null, this._publicKey = null, this.chainCode = null, this._fingerprint = 0, this.parentFingerprint = 0;
  }
  Object.defineProperty(B.prototype, "fingerprint", { get: function() {
    return this._fingerprint;
  } }), Object.defineProperty(B.prototype, "identifier", { get: function() {
    return this._identifier;
  } }), Object.defineProperty(B.prototype, "pubKeyHash", { get: function() {
    return this.identifier;
  } }), Object.defineProperty(B.prototype, "privateKey", {
    get: function() {
      return this._privateKey;
    },
    set: function(M) {
      s.equal(M.length, 32, "Private key must be 32 bytes."), s(l.privateKeyVerify(M) === !0, "Invalid private key"), this._privateKey = M, this._publicKey = A.from(l.publicKeyCreate(M, !0)), this._identifier = x(this.publicKey), this._fingerprint = this._identifier.slice(0, 4).readUInt32BE(0);
    }
  });
  function Q(M, F) {
    M._publicKey = A.from(F), M._identifier = x(F), M._fingerprint = M._identifier.slice(0, 4).readUInt32BE(0), M._privateKey = null;
  }
  Object.defineProperty(B.prototype, "publicKey", {
    get: function() {
      return this._publicKey;
    },
    set: function(M) {
      s(M.length === 33 || M.length === 65, "Public key must be 33 or 65 bytes."), s(l.publicKeyVerify(M) === !0, "Invalid public key");
      const F = M.length === 65 ? l.publicKeyConvert(M, !0) : M;
      Q(this, F);
    }
  }), Object.defineProperty(B.prototype, "privateExtendedKey", {
    get: function() {
      return this._privateKey ? p.encode(P(this, this.versions.private, A.concat([A.alloc(1, 0), this.privateKey]))) : null;
    }
  }), Object.defineProperty(B.prototype, "publicExtendedKey", {
    get: function() {
      return p.encode(P(this, this.versions.public, this.publicKey));
    }
  }), B.prototype.derive = function(M) {
    if (M === "m" || M === "M" || M === "m'" || M === "M'")
      return this;
    var F = M.split("/"), le = this;
    return F.forEach(function(ge, pe) {
      if (pe === 0) {
        s(/^[mM]{1}/.test(ge), 'Path must start with "m" or "M"');
        return;
      }
      var Ie = ge.length > 1 && ge[ge.length - 1] === "'", be = parseInt(ge, 10);
      s(be < b, "Invalid index"), Ie && (be += b), le = le.deriveChild(be);
    }), le;
  }, B.prototype.deriveChild = function(M) {
    var F = M >= b, le = A.allocUnsafe(4);
    le.writeUInt32BE(M, 0);
    var ge;
    if (F) {
      s(this.privateKey, "Could not derive hardened child key");
      var pe = this.privateKey, Ie = A.alloc(1, 0);
      pe = A.concat([Ie, pe]), ge = A.concat([pe, le]);
    } else
      ge = A.concat([this.publicKey, le]);
    var be = u.createHmac("sha512", this.chainCode).update(ge).digest(), Pe = be.slice(0, 32), Te = be.slice(32), Qe = new B(this.versions);
    if (this.privateKey)
      try {
        Qe.privateKey = A.from(l.privateKeyTweakAdd(A.from(this.privateKey), Pe));
      } catch {
        return this.deriveChild(M + 1);
      }
    else
      try {
        Qe.publicKey = A.from(l.publicKeyTweakAdd(A.from(this.publicKey), Pe, !0));
      } catch {
        return this.deriveChild(M + 1);
      }
    return Qe.chainCode = Te, Qe.depth = this.depth + 1, Qe.parentFingerprint = this.fingerprint, Qe.index = M, Qe;
  }, B.prototype.sign = function(M) {
    return A.from(l.ecdsaSign(Uint8Array.from(M), Uint8Array.from(this.privateKey)).signature);
  }, B.prototype.verify = function(M, F) {
    return l.ecdsaVerify(
      Uint8Array.from(F),
      Uint8Array.from(M),
      Uint8Array.from(this.publicKey)
    );
  }, B.prototype.wipePrivateData = function() {
    return this._privateKey && u.randomBytes(this._privateKey.length).copy(this._privateKey), this._privateKey = null, this;
  }, B.prototype.toJSON = function() {
    return {
      xpriv: this.privateExtendedKey,
      xpub: this.publicExtendedKey
    };
  }, B.fromMasterSeed = function(M, F) {
    var le = u.createHmac("sha512", m).update(M).digest(), ge = le.slice(0, 32), pe = le.slice(32), Ie = new B(F);
    return Ie.chainCode = pe, Ie.privateKey = ge, Ie;
  }, B.fromExtendedKey = function(M, F, le) {
    F = F || C, le = le || !1;
    var ge = new B(F), pe = p.decode(M), Ie = pe.readUInt32BE(0);
    s(Ie === F.private || Ie === F.public, "Version mismatch: does not match private or public"), ge.depth = pe.readUInt8(4), ge.parentFingerprint = pe.readUInt32BE(5), ge.index = pe.readUInt32BE(9), ge.chainCode = pe.slice(13, 45);
    var be = pe.slice(45);
    return be.readUInt8(0) === 0 ? (s(Ie === F.private, "Version mismatch: version does not match private"), ge.privateKey = be.slice(1)) : (s(Ie === F.public, "Version mismatch: version does not match public"), le ? Q(ge, be) : ge.publicKey = be), ge;
  }, B.fromJSON = function(M) {
    return B.fromExtendedKey(M.xpriv);
  };
  function P(M, F, le) {
    var ge = A.allocUnsafe(k);
    ge.writeUInt32BE(F, 0), ge.writeUInt8(M.depth, 4);
    var pe = M.depth ? M.parentFingerprint : 0;
    return ge.writeUInt32BE(pe, 5), ge.writeUInt32BE(M.index, 9), M.chainCode.copy(ge, 13), le.copy(ge, 45), ge;
  }
  function x(M) {
    var F = u.createHash("sha256").update(M).digest();
    return new t().update(F).digest();
  }
  return B.HARDENED_OFFSET = b, hdkey = B, hdkey;
}
var cjs$5 = {}, constants$4 = {}, secp256k1$5 = {}, secp256k1$4 = {}, sha256$7 = {}, _md = {}, _assert = {}, hasRequired_assert;
function require_assert() {
  if (hasRequired_assert) return _assert;
  hasRequired_assert = 1, Object.defineProperty(_assert, "__esModule", { value: !0 }), _assert.output = _assert.exists = _assert.hash = _assert.bytes = _assert.bool = _assert.number = _assert.isBytes = void 0;
  function s(k) {
    if (!Number.isSafeInteger(k) || k < 0)
      throw new Error(`positive integer expected, not ${k}`);
  }
  _assert.number = s;
  function A(k) {
    if (typeof k != "boolean")
      throw new Error(`boolean expected, not ${k}`);
  }
  _assert.bool = A;
  function u(k) {
    return k instanceof Uint8Array || k != null && typeof k == "object" && k.constructor.name === "Uint8Array";
  }
  _assert.isBytes = u;
  function p(k, ...C) {
    if (!u(k))
      throw new Error("Uint8Array expected");
    if (C.length > 0 && !C.includes(k.length))
      throw new Error(`Uint8Array expected of length ${C}, not of length=${k.length}`);
  }
  _assert.bytes = p;
  function t(k) {
    if (typeof k != "function" || typeof k.create != "function")
      throw new Error("Hash should be wrapped by utils.wrapConstructor");
    s(k.outputLen), s(k.blockLen);
  }
  _assert.hash = t;
  function l(k, C = !0) {
    if (k.destroyed)
      throw new Error("Hash instance has been destroyed");
    if (C && k.finished)
      throw new Error("Hash#digest() has already been called");
  }
  _assert.exists = l;
  function m(k, C) {
    p(k);
    const B = C.outputLen;
    if (k.length < B)
      throw new Error(`digestInto() expects output buffer of length at least ${B}`);
  }
  _assert.output = m;
  const b = { number: s, bool: A, bytes: p, hash: t, exists: l, output: m };
  return _assert.default = b, _assert;
}
var utils$9 = {}, crypto$4 = {}, hasRequiredCrypto$1;
function requireCrypto$1() {
  return hasRequiredCrypto$1 || (hasRequiredCrypto$1 = 1, Object.defineProperty(crypto$4, "__esModule", { value: !0 }), crypto$4.crypto = void 0, crypto$4.crypto = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0), crypto$4;
}
var hasRequiredUtils$7;
function requireUtils$7() {
  return hasRequiredUtils$7 || (hasRequiredUtils$7 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.randomBytes = s.wrapXOFConstructorWithOpts = s.wrapConstructorWithOpts = s.wrapConstructor = s.checkOpts = s.Hash = s.concatBytes = s.toBytes = s.utf8ToBytes = s.asyncLoop = s.nextTick = s.hexToBytes = s.bytesToHex = s.byteSwap32 = s.byteSwapIfBE = s.byteSwap = s.isLE = s.rotl = s.rotr = s.createView = s.u32 = s.u8 = s.isBytes = void 0;
    const A = /* @__PURE__ */ requireCrypto$1(), u = /* @__PURE__ */ require_assert();
    function p(we) {
      return we instanceof Uint8Array || we != null && typeof we == "object" && we.constructor.name === "Uint8Array";
    }
    s.isBytes = p;
    const t = (we) => new Uint8Array(we.buffer, we.byteOffset, we.byteLength);
    s.u8 = t;
    const l = (we) => new Uint32Array(we.buffer, we.byteOffset, Math.floor(we.byteLength / 4));
    s.u32 = l;
    const m = (we) => new DataView(we.buffer, we.byteOffset, we.byteLength);
    s.createView = m;
    const b = (we, Ce) => we << 32 - Ce | we >>> Ce;
    s.rotr = b;
    const k = (we, Ce) => we << Ce | we >>> 32 - Ce >>> 0;
    s.rotl = k, s.isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
    const C = (we) => we << 24 & 4278190080 | we << 8 & 16711680 | we >>> 8 & 65280 | we >>> 24 & 255;
    s.byteSwap = C, s.byteSwapIfBE = s.isLE ? (we) => we : (we) => (0, s.byteSwap)(we);
    function B(we) {
      for (let Ce = 0; Ce < we.length; Ce++)
        we[Ce] = (0, s.byteSwap)(we[Ce]);
    }
    s.byteSwap32 = B;
    const Q = /* @__PURE__ */ Array.from({ length: 256 }, (we, Ce) => Ce.toString(16).padStart(2, "0"));
    function P(we) {
      (0, u.bytes)(we);
      let Ce = "";
      for (let Se = 0; Se < we.length; Se++)
        Ce += Q[we[Se]];
      return Ce;
    }
    s.bytesToHex = P;
    const x = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
    function M(we) {
      if (we >= x._0 && we <= x._9)
        return we - x._0;
      if (we >= x._A && we <= x._F)
        return we - (x._A - 10);
      if (we >= x._a && we <= x._f)
        return we - (x._a - 10);
    }
    function F(we) {
      if (typeof we != "string")
        throw new Error("hex string expected, got " + typeof we);
      const Ce = we.length, Se = Ce / 2;
      if (Ce % 2)
        throw new Error("padded hex string expected, got unpadded hex of length " + Ce);
      const Ne = new Uint8Array(Se);
      for (let rr = 0, er = 0; rr < Se; rr++, er += 2) {
        const ir = M(we.charCodeAt(er)), sr = M(we.charCodeAt(er + 1));
        if (ir === void 0 || sr === void 0) {
          const nr = we[er] + we[er + 1];
          throw new Error('hex string expected, got non-hex character "' + nr + '" at index ' + er);
        }
        Ne[rr] = ir * 16 + sr;
      }
      return Ne;
    }
    s.hexToBytes = F;
    const le = async () => {
    };
    s.nextTick = le;
    async function ge(we, Ce, Se) {
      let Ne = Date.now();
      for (let rr = 0; rr < we; rr++) {
        Se(rr);
        const er = Date.now() - Ne;
        er >= 0 && er < Ce || (await (0, s.nextTick)(), Ne += er);
      }
    }
    s.asyncLoop = ge;
    function pe(we) {
      if (typeof we != "string")
        throw new Error(`utf8ToBytes expected string, got ${typeof we}`);
      return new Uint8Array(new TextEncoder().encode(we));
    }
    s.utf8ToBytes = pe;
    function Ie(we) {
      return typeof we == "string" && (we = pe(we)), (0, u.bytes)(we), we;
    }
    s.toBytes = Ie;
    function be(...we) {
      let Ce = 0;
      for (let Ne = 0; Ne < we.length; Ne++) {
        const rr = we[Ne];
        (0, u.bytes)(rr), Ce += rr.length;
      }
      const Se = new Uint8Array(Ce);
      for (let Ne = 0, rr = 0; Ne < we.length; Ne++) {
        const er = we[Ne];
        Se.set(er, rr), rr += er.length;
      }
      return Se;
    }
    s.concatBytes = be;
    class Pe {
      // Safe version that clones internal state
      clone() {
        return this._cloneInto();
      }
    }
    s.Hash = Pe;
    const Te = {}.toString;
    function Qe(we, Ce) {
      if (Ce !== void 0 && Te.call(Ce) !== "[object Object]")
        throw new Error("Options should be object or undefined");
      return Object.assign(we, Ce);
    }
    s.checkOpts = Qe;
    function xe(we) {
      const Ce = (Ne) => we().update(Ie(Ne)).digest(), Se = we();
      return Ce.outputLen = Se.outputLen, Ce.blockLen = Se.blockLen, Ce.create = () => we(), Ce;
    }
    s.wrapConstructor = xe;
    function Ee(we) {
      const Ce = (Ne, rr) => we(rr).update(Ie(Ne)).digest(), Se = we({});
      return Ce.outputLen = Se.outputLen, Ce.blockLen = Se.blockLen, Ce.create = (Ne) => we(Ne), Ce;
    }
    s.wrapConstructorWithOpts = Ee;
    function He(we) {
      const Ce = (Ne, rr) => we(rr).update(Ie(Ne)).digest(), Se = we({});
      return Ce.outputLen = Se.outputLen, Ce.blockLen = Se.blockLen, Ce.create = (Ne) => we(Ne), Ce;
    }
    s.wrapXOFConstructorWithOpts = He;
    function ve(we = 32) {
      if (A.crypto && typeof A.crypto.getRandomValues == "function")
        return A.crypto.getRandomValues(new Uint8Array(we));
      throw new Error("crypto.getRandomValues must be defined");
    }
    s.randomBytes = ve;
  }(utils$9)), utils$9;
}
var hasRequired_md;
function require_md() {
  if (hasRequired_md) return _md;
  hasRequired_md = 1, Object.defineProperty(_md, "__esModule", { value: !0 }), _md.HashMD = _md.Maj = _md.Chi = void 0;
  const s = /* @__PURE__ */ require_assert(), A = /* @__PURE__ */ requireUtils$7();
  function u(m, b, k, C) {
    if (typeof m.setBigUint64 == "function")
      return m.setBigUint64(b, k, C);
    const B = BigInt(32), Q = BigInt(4294967295), P = Number(k >> B & Q), x = Number(k & Q), M = C ? 4 : 0, F = C ? 0 : 4;
    m.setUint32(b + M, P, C), m.setUint32(b + F, x, C);
  }
  const p = (m, b, k) => m & b ^ ~m & k;
  _md.Chi = p;
  const t = (m, b, k) => m & b ^ m & k ^ b & k;
  _md.Maj = t;
  class l extends A.Hash {
    constructor(b, k, C, B) {
      super(), this.blockLen = b, this.outputLen = k, this.padOffset = C, this.isLE = B, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(b), this.view = (0, A.createView)(this.buffer);
    }
    update(b) {
      (0, s.exists)(this);
      const { view: k, buffer: C, blockLen: B } = this;
      b = (0, A.toBytes)(b);
      const Q = b.length;
      for (let P = 0; P < Q; ) {
        const x = Math.min(B - this.pos, Q - P);
        if (x === B) {
          const M = (0, A.createView)(b);
          for (; B <= Q - P; P += B)
            this.process(M, P);
          continue;
        }
        C.set(b.subarray(P, P + x), this.pos), this.pos += x, P += x, this.pos === B && (this.process(k, 0), this.pos = 0);
      }
      return this.length += b.length, this.roundClean(), this;
    }
    digestInto(b) {
      (0, s.exists)(this), (0, s.output)(b, this), this.finished = !0;
      const { buffer: k, view: C, blockLen: B, isLE: Q } = this;
      let { pos: P } = this;
      k[P++] = 128, this.buffer.subarray(P).fill(0), this.padOffset > B - P && (this.process(C, 0), P = 0);
      for (let ge = P; ge < B; ge++)
        k[ge] = 0;
      u(C, B - 8, BigInt(this.length * 8), Q), this.process(C, 0);
      const x = (0, A.createView)(b), M = this.outputLen;
      if (M % 4)
        throw new Error("_sha2: outputLen should be aligned to 32bit");
      const F = M / 4, le = this.get();
      if (F > le.length)
        throw new Error("_sha2: outputLen bigger than state");
      for (let ge = 0; ge < F; ge++)
        x.setUint32(4 * ge, le[ge], Q);
    }
    digest() {
      const { buffer: b, outputLen: k } = this;
      this.digestInto(b);
      const C = b.slice(0, k);
      return this.destroy(), C;
    }
    _cloneInto(b) {
      b || (b = new this.constructor()), b.set(...this.get());
      const { blockLen: k, buffer: C, length: B, finished: Q, destroyed: P, pos: x } = this;
      return b.length = B, b.pos = x, b.finished = Q, b.destroyed = P, B % k && b.buffer.set(C), b;
    }
  }
  return _md.HashMD = l, _md;
}
var hasRequiredSha256$2;
function requireSha256$2() {
  if (hasRequiredSha256$2) return sha256$7;
  hasRequiredSha256$2 = 1, Object.defineProperty(sha256$7, "__esModule", { value: !0 }), sha256$7.sha224 = sha256$7.sha256 = void 0;
  const s = /* @__PURE__ */ require_md(), A = /* @__PURE__ */ requireUtils$7(), u = /* @__PURE__ */ new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]), p = /* @__PURE__ */ new Uint32Array([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ]), t = /* @__PURE__ */ new Uint32Array(64);
  class l extends s.HashMD {
    constructor() {
      super(64, 32, 8, !1), this.A = p[0] | 0, this.B = p[1] | 0, this.C = p[2] | 0, this.D = p[3] | 0, this.E = p[4] | 0, this.F = p[5] | 0, this.G = p[6] | 0, this.H = p[7] | 0;
    }
    get() {
      const { A: k, B: C, C: B, D: Q, E: P, F: x, G: M, H: F } = this;
      return [k, C, B, Q, P, x, M, F];
    }
    // prettier-ignore
    set(k, C, B, Q, P, x, M, F) {
      this.A = k | 0, this.B = C | 0, this.C = B | 0, this.D = Q | 0, this.E = P | 0, this.F = x | 0, this.G = M | 0, this.H = F | 0;
    }
    process(k, C) {
      for (let pe = 0; pe < 16; pe++, C += 4)
        t[pe] = k.getUint32(C, !1);
      for (let pe = 16; pe < 64; pe++) {
        const Ie = t[pe - 15], be = t[pe - 2], Pe = (0, A.rotr)(Ie, 7) ^ (0, A.rotr)(Ie, 18) ^ Ie >>> 3, Te = (0, A.rotr)(be, 17) ^ (0, A.rotr)(be, 19) ^ be >>> 10;
        t[pe] = Te + t[pe - 7] + Pe + t[pe - 16] | 0;
      }
      let { A: B, B: Q, C: P, D: x, E: M, F, G: le, H: ge } = this;
      for (let pe = 0; pe < 64; pe++) {
        const Ie = (0, A.rotr)(M, 6) ^ (0, A.rotr)(M, 11) ^ (0, A.rotr)(M, 25), be = ge + Ie + (0, s.Chi)(M, F, le) + u[pe] + t[pe] | 0, Te = ((0, A.rotr)(B, 2) ^ (0, A.rotr)(B, 13) ^ (0, A.rotr)(B, 22)) + (0, s.Maj)(B, Q, P) | 0;
        ge = le, le = F, F = M, M = x + be | 0, x = P, P = Q, Q = B, B = be + Te | 0;
      }
      B = B + this.A | 0, Q = Q + this.B | 0, P = P + this.C | 0, x = x + this.D | 0, M = M + this.E | 0, F = F + this.F | 0, le = le + this.G | 0, ge = ge + this.H | 0, this.set(B, Q, P, x, M, F, le, ge);
    }
    roundClean() {
      t.fill(0);
    }
    destroy() {
      this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
    }
  }
  class m extends l {
    constructor() {
      super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
    }
  }
  return sha256$7.sha256 = (0, A.wrapConstructor)(() => new l()), sha256$7.sha224 = (0, A.wrapConstructor)(() => new m()), sha256$7;
}
var _shortw_utils = {}, hmac$3 = {}, hasRequiredHmac$1;
function requireHmac$1() {
  return hasRequiredHmac$1 || (hasRequiredHmac$1 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.hmac = s.HMAC = void 0;
    const A = /* @__PURE__ */ require_assert(), u = /* @__PURE__ */ requireUtils$7();
    class p extends u.Hash {
      constructor(m, b) {
        super(), this.finished = !1, this.destroyed = !1, (0, A.hash)(m);
        const k = (0, u.toBytes)(b);
        if (this.iHash = m.create(), typeof this.iHash.update != "function")
          throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
        const C = this.blockLen, B = new Uint8Array(C);
        B.set(k.length > C ? m.create().update(k).digest() : k);
        for (let Q = 0; Q < B.length; Q++)
          B[Q] ^= 54;
        this.iHash.update(B), this.oHash = m.create();
        for (let Q = 0; Q < B.length; Q++)
          B[Q] ^= 106;
        this.oHash.update(B), B.fill(0);
      }
      update(m) {
        return (0, A.exists)(this), this.iHash.update(m), this;
      }
      digestInto(m) {
        (0, A.exists)(this), (0, A.bytes)(m, this.outputLen), this.finished = !0, this.iHash.digestInto(m), this.oHash.update(m), this.oHash.digestInto(m), this.destroy();
      }
      digest() {
        const m = new Uint8Array(this.oHash.outputLen);
        return this.digestInto(m), m;
      }
      _cloneInto(m) {
        m || (m = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: b, iHash: k, finished: C, destroyed: B, blockLen: Q, outputLen: P } = this;
        return m = m, m.finished = C, m.destroyed = B, m.blockLen = Q, m.outputLen = P, m.oHash = b._cloneInto(m.oHash), m.iHash = k._cloneInto(m.iHash), m;
      }
      destroy() {
        this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
      }
    }
    s.HMAC = p;
    const t = (l, m, b) => new p(l, m).update(b).digest();
    s.hmac = t, s.hmac.create = (l, m) => new p(l, m);
  }(hmac$3)), hmac$3;
}
var weierstrass$2 = {}, curve = {}, modular = {}, utils$8 = {}, hasRequiredUtils$6;
function requireUtils$6() {
  if (hasRequiredUtils$6) return utils$8;
  hasRequiredUtils$6 = 1, Object.defineProperty(utils$8, "__esModule", { value: !0 }), utils$8.bitMask = void 0, utils$8.isBytes = p, utils$8.abytes = t, utils$8.bytesToHex = m, utils$8.numberToHexUnpadded = b, utils$8.hexToNumber = k, utils$8.hexToBytes = Q, utils$8.bytesToNumberBE = P, utils$8.bytesToNumberLE = x, utils$8.numberToBytesBE = M, utils$8.numberToBytesLE = F, utils$8.numberToVarBytesBE = le, utils$8.ensureBytes = ge, utils$8.concatBytes = pe, utils$8.equalBytes = Ie, utils$8.utf8ToBytes = be, utils$8.bitLen = Pe, utils$8.bitGet = Te, utils$8.bitSet = Qe, utils$8.createHmacDrbg = ve, utils$8.validateObject = Ce;
  const s = /* @__PURE__ */ BigInt(0), A = /* @__PURE__ */ BigInt(1), u = /* @__PURE__ */ BigInt(2);
  function p(Se) {
    return Se instanceof Uint8Array || Se != null && typeof Se == "object" && Se.constructor.name === "Uint8Array";
  }
  function t(Se) {
    if (!p(Se))
      throw new Error("Uint8Array expected");
  }
  const l = /* @__PURE__ */ Array.from({ length: 256 }, (Se, Ne) => Ne.toString(16).padStart(2, "0"));
  function m(Se) {
    t(Se);
    let Ne = "";
    for (let rr = 0; rr < Se.length; rr++)
      Ne += l[Se[rr]];
    return Ne;
  }
  function b(Se) {
    const Ne = Se.toString(16);
    return Ne.length & 1 ? `0${Ne}` : Ne;
  }
  function k(Se) {
    if (typeof Se != "string")
      throw new Error("hex string expected, got " + typeof Se);
    return BigInt(Se === "" ? "0" : `0x${Se}`);
  }
  const C = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
  function B(Se) {
    if (Se >= C._0 && Se <= C._9)
      return Se - C._0;
    if (Se >= C._A && Se <= C._F)
      return Se - (C._A - 10);
    if (Se >= C._a && Se <= C._f)
      return Se - (C._a - 10);
  }
  function Q(Se) {
    if (typeof Se != "string")
      throw new Error("hex string expected, got " + typeof Se);
    const Ne = Se.length, rr = Ne / 2;
    if (Ne % 2)
      throw new Error("padded hex string expected, got unpadded hex of length " + Ne);
    const er = new Uint8Array(rr);
    for (let ir = 0, sr = 0; ir < rr; ir++, sr += 2) {
      const nr = B(Se.charCodeAt(sr)), fr = B(Se.charCodeAt(sr + 1));
      if (nr === void 0 || fr === void 0) {
        const lr = Se[sr] + Se[sr + 1];
        throw new Error('hex string expected, got non-hex character "' + lr + '" at index ' + sr);
      }
      er[ir] = nr * 16 + fr;
    }
    return er;
  }
  function P(Se) {
    return k(m(Se));
  }
  function x(Se) {
    return t(Se), k(m(Uint8Array.from(Se).reverse()));
  }
  function M(Se, Ne) {
    return Q(Se.toString(16).padStart(Ne * 2, "0"));
  }
  function F(Se, Ne) {
    return M(Se, Ne).reverse();
  }
  function le(Se) {
    return Q(b(Se));
  }
  function ge(Se, Ne, rr) {
    let er;
    if (typeof Ne == "string")
      try {
        er = Q(Ne);
      } catch (sr) {
        throw new Error(`${Se} must be valid hex string, got "${Ne}". Cause: ${sr}`);
      }
    else if (p(Ne))
      er = Uint8Array.from(Ne);
    else
      throw new Error(`${Se} must be hex string or Uint8Array`);
    const ir = er.length;
    if (typeof rr == "number" && ir !== rr)
      throw new Error(`${Se} expected ${rr} bytes, got ${ir}`);
    return er;
  }
  function pe(...Se) {
    let Ne = 0;
    for (let er = 0; er < Se.length; er++) {
      const ir = Se[er];
      t(ir), Ne += ir.length;
    }
    const rr = new Uint8Array(Ne);
    for (let er = 0, ir = 0; er < Se.length; er++) {
      const sr = Se[er];
      rr.set(sr, ir), ir += sr.length;
    }
    return rr;
  }
  function Ie(Se, Ne) {
    if (Se.length !== Ne.length)
      return !1;
    let rr = 0;
    for (let er = 0; er < Se.length; er++)
      rr |= Se[er] ^ Ne[er];
    return rr === 0;
  }
  function be(Se) {
    if (typeof Se != "string")
      throw new Error(`utf8ToBytes expected string, got ${typeof Se}`);
    return new Uint8Array(new TextEncoder().encode(Se));
  }
  function Pe(Se) {
    let Ne;
    for (Ne = 0; Se > s; Se >>= A, Ne += 1)
      ;
    return Ne;
  }
  function Te(Se, Ne) {
    return Se >> BigInt(Ne) & A;
  }
  function Qe(Se, Ne, rr) {
    return Se | (rr ? A : s) << BigInt(Ne);
  }
  const xe = (Se) => (u << BigInt(Se - 1)) - A;
  utils$8.bitMask = xe;
  const Ee = (Se) => new Uint8Array(Se), He = (Se) => Uint8Array.from(Se);
  function ve(Se, Ne, rr) {
    if (typeof Se != "number" || Se < 2)
      throw new Error("hashLen must be a number");
    if (typeof Ne != "number" || Ne < 2)
      throw new Error("qByteLen must be a number");
    if (typeof rr != "function")
      throw new Error("hmacFn must be a function");
    let er = Ee(Se), ir = Ee(Se), sr = 0;
    const nr = () => {
      er.fill(1), ir.fill(0), sr = 0;
    }, fr = (...Fr) => rr(ir, er, ...Fr), lr = (Fr = Ee()) => {
      ir = fr(He([0]), Fr), er = fr(), Fr.length !== 0 && (ir = fr(He([1]), Fr), er = fr());
    }, br = () => {
      if (sr++ >= 1e3)
        throw new Error("drbg: tried 1000 values");
      let Fr = 0;
      const Gr = [];
      for (; Fr < Ne; ) {
        er = fr();
        const qr = er.slice();
        Gr.push(qr), Fr += er.length;
      }
      return pe(...Gr);
    };
    return (Fr, Gr) => {
      nr(), lr(Fr);
      let qr;
      for (; !(qr = Gr(br())); )
        lr();
      return nr(), qr;
    };
  }
  const we = {
    bigint: (Se) => typeof Se == "bigint",
    function: (Se) => typeof Se == "function",
    boolean: (Se) => typeof Se == "boolean",
    string: (Se) => typeof Se == "string",
    stringOrUint8Array: (Se) => typeof Se == "string" || p(Se),
    isSafeInteger: (Se) => Number.isSafeInteger(Se),
    array: (Se) => Array.isArray(Se),
    field: (Se, Ne) => Ne.Fp.isValid(Se),
    hash: (Se) => typeof Se == "function" && Number.isSafeInteger(Se.outputLen)
  };
  function Ce(Se, Ne, rr = {}) {
    const er = (ir, sr, nr) => {
      const fr = we[sr];
      if (typeof fr != "function")
        throw new Error(`Invalid validator "${sr}", expected function`);
      const lr = Se[ir];
      if (!(nr && lr === void 0) && !fr(lr, Se))
        throw new Error(`Invalid param ${String(ir)}=${lr} (${typeof lr}), expected ${sr}`);
    };
    for (const [ir, sr] of Object.entries(Ne))
      er(ir, sr, !1);
    for (const [ir, sr] of Object.entries(rr))
      er(ir, sr, !0);
    return Se;
  }
  return utils$8;
}
var hasRequiredModular;
function requireModular() {
  if (hasRequiredModular) return modular;
  hasRequiredModular = 1, Object.defineProperty(modular, "__esModule", { value: !0 }), modular.isNegativeLE = void 0, modular.mod = k, modular.pow = C, modular.pow2 = B, modular.invert = Q, modular.tonelliShanks = P, modular.FpSqrt = x, modular.validateField = le, modular.FpPow = ge, modular.FpInvertBatch = pe, modular.FpDiv = Ie, modular.FpIsSquare = be, modular.nLength = Pe, modular.Field = Te, modular.FpSqrtOdd = Qe, modular.FpSqrtEven = xe, modular.hashToPrivateScalar = Ee, modular.getFieldBytesLength = He, modular.getMinHashLength = ve, modular.mapHashToField = we;
  const s = /* @__PURE__ */ requireUtils$6(), A = BigInt(0), u = BigInt(1), p = BigInt(2), t = BigInt(3), l = BigInt(4), m = BigInt(5), b = BigInt(8);
  BigInt(9), BigInt(16);
  function k(Ce, Se) {
    const Ne = Ce % Se;
    return Ne >= A ? Ne : Se + Ne;
  }
  function C(Ce, Se, Ne) {
    if (Ne <= A || Se < A)
      throw new Error("Expected power/modulo > 0");
    if (Ne === u)
      return A;
    let rr = u;
    for (; Se > A; )
      Se & u && (rr = rr * Ce % Ne), Ce = Ce * Ce % Ne, Se >>= u;
    return rr;
  }
  function B(Ce, Se, Ne) {
    let rr = Ce;
    for (; Se-- > A; )
      rr *= rr, rr %= Ne;
    return rr;
  }
  function Q(Ce, Se) {
    if (Ce === A || Se <= A)
      throw new Error(`invert: expected positive integers, got n=${Ce} mod=${Se}`);
    let Ne = k(Ce, Se), rr = Se, er = A, ir = u;
    for (; Ne !== A; ) {
      const nr = rr / Ne, fr = rr % Ne, lr = er - ir * nr;
      rr = Ne, Ne = fr, er = ir, ir = lr;
    }
    if (rr !== u)
      throw new Error("invert: does not exist");
    return k(er, Se);
  }
  function P(Ce) {
    const Se = (Ce - u) / p;
    let Ne, rr, er;
    for (Ne = Ce - u, rr = 0; Ne % p === A; Ne /= p, rr++)
      ;
    for (er = p; er < Ce && C(er, Se, Ce) !== Ce - u; er++)
      ;
    if (rr === 1) {
      const sr = (Ce + u) / l;
      return function(fr, lr) {
        const br = fr.pow(lr, sr);
        if (!fr.eql(fr.sqr(br), lr))
          throw new Error("Cannot find square root");
        return br;
      };
    }
    const ir = (Ne + u) / p;
    return function(nr, fr) {
      if (nr.pow(fr, Se) === nr.neg(nr.ONE))
        throw new Error("Cannot find square root");
      let lr = rr, br = nr.pow(nr.mul(nr.ONE, er), Ne), Br = nr.pow(fr, ir), Fr = nr.pow(fr, Ne);
      for (; !nr.eql(Fr, nr.ONE); ) {
        if (nr.eql(Fr, nr.ZERO))
          return nr.ZERO;
        let Gr = 1;
        for (let Hr = nr.sqr(Fr); Gr < lr && !nr.eql(Hr, nr.ONE); Gr++)
          Hr = nr.sqr(Hr);
        const qr = nr.pow(br, u << BigInt(lr - Gr - 1));
        br = nr.sqr(qr), Br = nr.mul(Br, qr), Fr = nr.mul(Fr, br), lr = Gr;
      }
      return Br;
    };
  }
  function x(Ce) {
    if (Ce % l === t) {
      const Se = (Ce + u) / l;
      return function(rr, er) {
        const ir = rr.pow(er, Se);
        if (!rr.eql(rr.sqr(ir), er))
          throw new Error("Cannot find square root");
        return ir;
      };
    }
    if (Ce % b === m) {
      const Se = (Ce - m) / b;
      return function(rr, er) {
        const ir = rr.mul(er, p), sr = rr.pow(ir, Se), nr = rr.mul(er, sr), fr = rr.mul(rr.mul(nr, p), sr), lr = rr.mul(nr, rr.sub(fr, rr.ONE));
        if (!rr.eql(rr.sqr(lr), er))
          throw new Error("Cannot find square root");
        return lr;
      };
    }
    return P(Ce);
  }
  const M = (Ce, Se) => (k(Ce, Se) & u) === u;
  modular.isNegativeLE = M;
  const F = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
  ];
  function le(Ce) {
    const Se = {
      ORDER: "bigint",
      MASK: "bigint",
      BYTES: "isSafeInteger",
      BITS: "isSafeInteger"
    }, Ne = F.reduce((rr, er) => (rr[er] = "function", rr), Se);
    return (0, s.validateObject)(Ce, Ne);
  }
  function ge(Ce, Se, Ne) {
    if (Ne < A)
      throw new Error("Expected power > 0");
    if (Ne === A)
      return Ce.ONE;
    if (Ne === u)
      return Se;
    let rr = Ce.ONE, er = Se;
    for (; Ne > A; )
      Ne & u && (rr = Ce.mul(rr, er)), er = Ce.sqr(er), Ne >>= u;
    return rr;
  }
  function pe(Ce, Se) {
    const Ne = new Array(Se.length), rr = Se.reduce((ir, sr, nr) => Ce.is0(sr) ? ir : (Ne[nr] = ir, Ce.mul(ir, sr)), Ce.ONE), er = Ce.inv(rr);
    return Se.reduceRight((ir, sr, nr) => Ce.is0(sr) ? ir : (Ne[nr] = Ce.mul(ir, Ne[nr]), Ce.mul(ir, sr)), er), Ne;
  }
  function Ie(Ce, Se, Ne) {
    return Ce.mul(Se, typeof Ne == "bigint" ? Q(Ne, Ce.ORDER) : Ce.inv(Ne));
  }
  function be(Ce) {
    const Se = (Ce.ORDER - u) / p;
    return (Ne) => {
      const rr = Ce.pow(Ne, Se);
      return Ce.eql(rr, Ce.ZERO) || Ce.eql(rr, Ce.ONE);
    };
  }
  function Pe(Ce, Se) {
    const Ne = Se !== void 0 ? Se : Ce.toString(2).length, rr = Math.ceil(Ne / 8);
    return { nBitLength: Ne, nByteLength: rr };
  }
  function Te(Ce, Se, Ne = !1, rr = {}) {
    if (Ce <= A)
      throw new Error(`Expected Field ORDER > 0, got ${Ce}`);
    const { nBitLength: er, nByteLength: ir } = Pe(Ce, Se);
    if (ir > 2048)
      throw new Error("Field lengths over 2048 bytes are not supported");
    const sr = x(Ce), nr = Object.freeze({
      ORDER: Ce,
      BITS: er,
      BYTES: ir,
      MASK: (0, s.bitMask)(er),
      ZERO: A,
      ONE: u,
      create: (fr) => k(fr, Ce),
      isValid: (fr) => {
        if (typeof fr != "bigint")
          throw new Error(`Invalid field element: expected bigint, got ${typeof fr}`);
        return A <= fr && fr < Ce;
      },
      is0: (fr) => fr === A,
      isOdd: (fr) => (fr & u) === u,
      neg: (fr) => k(-fr, Ce),
      eql: (fr, lr) => fr === lr,
      sqr: (fr) => k(fr * fr, Ce),
      add: (fr, lr) => k(fr + lr, Ce),
      sub: (fr, lr) => k(fr - lr, Ce),
      mul: (fr, lr) => k(fr * lr, Ce),
      pow: (fr, lr) => ge(nr, fr, lr),
      div: (fr, lr) => k(fr * Q(lr, Ce), Ce),
      // Same as above, but doesn't normalize
      sqrN: (fr) => fr * fr,
      addN: (fr, lr) => fr + lr,
      subN: (fr, lr) => fr - lr,
      mulN: (fr, lr) => fr * lr,
      inv: (fr) => Q(fr, Ce),
      sqrt: rr.sqrt || ((fr) => sr(nr, fr)),
      invertBatch: (fr) => pe(nr, fr),
      // TODO: do we really need constant cmov?
      // We don't have const-time bigints anyway, so probably will be not very useful
      cmov: (fr, lr, br) => br ? lr : fr,
      toBytes: (fr) => Ne ? (0, s.numberToBytesLE)(fr, ir) : (0, s.numberToBytesBE)(fr, ir),
      fromBytes: (fr) => {
        if (fr.length !== ir)
          throw new Error(`Fp.fromBytes: expected ${ir}, got ${fr.length}`);
        return Ne ? (0, s.bytesToNumberLE)(fr) : (0, s.bytesToNumberBE)(fr);
      }
    });
    return Object.freeze(nr);
  }
  function Qe(Ce, Se) {
    if (!Ce.isOdd)
      throw new Error("Field doesn't have isOdd");
    const Ne = Ce.sqrt(Se);
    return Ce.isOdd(Ne) ? Ne : Ce.neg(Ne);
  }
  function xe(Ce, Se) {
    if (!Ce.isOdd)
      throw new Error("Field doesn't have isOdd");
    const Ne = Ce.sqrt(Se);
    return Ce.isOdd(Ne) ? Ce.neg(Ne) : Ne;
  }
  function Ee(Ce, Se, Ne = !1) {
    Ce = (0, s.ensureBytes)("privateHash", Ce);
    const rr = Ce.length, er = Pe(Se).nByteLength + 8;
    if (er < 24 || rr < er || rr > 1024)
      throw new Error(`hashToPrivateScalar: expected ${er}-1024 bytes of input, got ${rr}`);
    const ir = Ne ? (0, s.bytesToNumberLE)(Ce) : (0, s.bytesToNumberBE)(Ce);
    return k(ir, Se - u) + u;
  }
  function He(Ce) {
    if (typeof Ce != "bigint")
      throw new Error("field order must be bigint");
    const Se = Ce.toString(2).length;
    return Math.ceil(Se / 8);
  }
  function ve(Ce) {
    const Se = He(Ce);
    return Se + Math.ceil(Se / 2);
  }
  function we(Ce, Se, Ne = !1) {
    const rr = Ce.length, er = He(Se), ir = ve(Se);
    if (rr < 16 || rr < ir || rr > 1024)
      throw new Error(`expected ${ir}-1024 bytes of input, got ${rr}`);
    const sr = Ne ? (0, s.bytesToNumberBE)(Ce) : (0, s.bytesToNumberLE)(Ce), nr = k(sr, Se - u) + u;
    return Ne ? (0, s.numberToBytesLE)(nr, er) : (0, s.numberToBytesBE)(nr, er);
  }
  return modular;
}
var hasRequiredCurve;
function requireCurve() {
  if (hasRequiredCurve) return curve;
  hasRequiredCurve = 1, Object.defineProperty(curve, "__esModule", { value: !0 }), curve.wNAF = t, curve.validateBasic = l;
  const s = /* @__PURE__ */ requireModular(), A = /* @__PURE__ */ requireUtils$6(), u = BigInt(0), p = BigInt(1);
  function t(m, b) {
    const k = (B, Q) => {
      const P = Q.negate();
      return B ? P : Q;
    }, C = (B) => {
      const Q = Math.ceil(b / B) + 1, P = 2 ** (B - 1);
      return { windows: Q, windowSize: P };
    };
    return {
      constTimeNegate: k,
      // non-const time multiplication ladder
      unsafeLadder(B, Q) {
        let P = m.ZERO, x = B;
        for (; Q > u; )
          Q & p && (P = P.add(x)), x = x.double(), Q >>= p;
        return P;
      },
      /**
       * Creates a wNAF precomputation window. Used for caching.
       * Default window size is set by `utils.precompute()` and is equal to 8.
       * Number of precomputed points depends on the curve size:
       * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
       * - 𝑊 is the window size
       * - 𝑛 is the bitlength of the curve order.
       * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
       * @returns precomputed point tables flattened to a single array
       */
      precomputeWindow(B, Q) {
        const { windows: P, windowSize: x } = C(Q), M = [];
        let F = B, le = F;
        for (let ge = 0; ge < P; ge++) {
          le = F, M.push(le);
          for (let pe = 1; pe < x; pe++)
            le = le.add(F), M.push(le);
          F = le.double();
        }
        return M;
      },
      /**
       * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
       * @param W window size
       * @param precomputes precomputed tables
       * @param n scalar (we don't check here, but should be less than curve order)
       * @returns real and fake (for const-time) points
       */
      wNAF(B, Q, P) {
        const { windows: x, windowSize: M } = C(B);
        let F = m.ZERO, le = m.BASE;
        const ge = BigInt(2 ** B - 1), pe = 2 ** B, Ie = BigInt(B);
        for (let be = 0; be < x; be++) {
          const Pe = be * M;
          let Te = Number(P & ge);
          P >>= Ie, Te > M && (Te -= pe, P += p);
          const Qe = Pe, xe = Pe + Math.abs(Te) - 1, Ee = be % 2 !== 0, He = Te < 0;
          Te === 0 ? le = le.add(k(Ee, Q[Qe])) : F = F.add(k(He, Q[xe]));
        }
        return { p: F, f: le };
      },
      wNAFCached(B, Q, P, x) {
        const M = B._WINDOW_SIZE || 1;
        let F = Q.get(B);
        return F || (F = this.precomputeWindow(B, M), M !== 1 && Q.set(B, x(F))), this.wNAF(M, F, P);
      }
    };
  }
  function l(m) {
    return (0, s.validateField)(m.Fp), (0, A.validateObject)(m, {
      n: "bigint",
      h: "bigint",
      Gx: "field",
      Gy: "field"
    }, {
      nBitLength: "isSafeInteger",
      nByteLength: "isSafeInteger"
    }), Object.freeze({
      ...(0, s.nLength)(m.n, m.nBitLength),
      ...m,
      p: m.Fp.ORDER
    });
  }
  return curve;
}
var hasRequiredWeierstrass;
function requireWeierstrass() {
  return hasRequiredWeierstrass || (hasRequiredWeierstrass = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.DER = void 0, s.weierstrassPoints = x, s.weierstrass = F, s.SWUFpSqrtRatio = le, s.mapToCurveSimpleSWU = ge;
    const A = /* @__PURE__ */ requireCurve(), u = /* @__PURE__ */ requireModular(), p = /* @__PURE__ */ requireUtils$6(), t = /* @__PURE__ */ requireUtils$6();
    function l(pe) {
      const Ie = (0, A.validateBasic)(pe);
      p.validateObject(Ie, {
        a: "field",
        b: "field"
      }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
      });
      const { endo: be, Fp: Pe, a: Te } = Ie;
      if (be) {
        if (!Pe.eql(Te, Pe.ZERO))
          throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof be != "object" || typeof be.beta != "bigint" || typeof be.splitScalar != "function")
          throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
      }
      return Object.freeze({ ...Ie });
    }
    const { bytesToNumberBE: m, hexToBytes: b } = p;
    s.DER = {
      // asn.1 DER encoding utils
      Err: class extends Error {
        constructor(Ie = "") {
          super(Ie);
        }
      },
      _parseInt(pe) {
        const { Err: Ie } = s.DER;
        if (pe.length < 2 || pe[0] !== 2)
          throw new Ie("Invalid signature integer tag");
        const be = pe[1], Pe = pe.subarray(2, be + 2);
        if (!be || Pe.length !== be)
          throw new Ie("Invalid signature integer: wrong length");
        if (Pe[0] & 128)
          throw new Ie("Invalid signature integer: negative");
        if (Pe[0] === 0 && !(Pe[1] & 128))
          throw new Ie("Invalid signature integer: unnecessary leading zero");
        return { d: m(Pe), l: pe.subarray(be + 2) };
      },
      toSig(pe) {
        const { Err: Ie } = s.DER, be = typeof pe == "string" ? b(pe) : pe;
        p.abytes(be);
        let Pe = be.length;
        if (Pe < 2 || be[0] != 48)
          throw new Ie("Invalid signature tag");
        if (be[1] !== Pe - 2)
          throw new Ie("Invalid signature: incorrect length");
        const { d: Te, l: Qe } = s.DER._parseInt(be.subarray(2)), { d: xe, l: Ee } = s.DER._parseInt(Qe);
        if (Ee.length)
          throw new Ie("Invalid signature: left bytes after parsing");
        return { r: Te, s: xe };
      },
      hexFromSig(pe) {
        const Ie = (ve) => Number.parseInt(ve[0], 16) & 8 ? "00" + ve : ve, be = (ve) => {
          const we = ve.toString(16);
          return we.length & 1 ? `0${we}` : we;
        }, Pe = Ie(be(pe.s)), Te = Ie(be(pe.r)), Qe = Pe.length / 2, xe = Te.length / 2, Ee = be(Qe), He = be(xe);
        return `30${be(xe + Qe + 4)}02${He}${Te}02${Ee}${Pe}`;
      }
    };
    const k = BigInt(0), C = BigInt(1), B = BigInt(2), Q = BigInt(3), P = BigInt(4);
    function x(pe) {
      const Ie = l(pe), { Fp: be } = Ie, Pe = Ie.toBytes || ((rr, er, ir) => {
        const sr = er.toAffine();
        return p.concatBytes(Uint8Array.from([4]), be.toBytes(sr.x), be.toBytes(sr.y));
      }), Te = Ie.fromBytes || ((rr) => {
        const er = rr.subarray(1), ir = be.fromBytes(er.subarray(0, be.BYTES)), sr = be.fromBytes(er.subarray(be.BYTES, 2 * be.BYTES));
        return { x: ir, y: sr };
      });
      function Qe(rr) {
        const { a: er, b: ir } = Ie, sr = be.sqr(rr), nr = be.mul(sr, rr);
        return be.add(be.add(nr, be.mul(rr, er)), ir);
      }
      if (!be.eql(be.sqr(Ie.Gy), Qe(Ie.Gx)))
        throw new Error("bad generator point: equation left != right");
      function xe(rr) {
        return typeof rr == "bigint" && k < rr && rr < Ie.n;
      }
      function Ee(rr) {
        if (!xe(rr))
          throw new Error("Expected valid bigint: 0 < bigint < curve.n");
      }
      function He(rr) {
        const { allowedPrivateKeyLengths: er, nByteLength: ir, wrapPrivateKey: sr, n: nr } = Ie;
        if (er && typeof rr != "bigint") {
          if (p.isBytes(rr) && (rr = p.bytesToHex(rr)), typeof rr != "string" || !er.includes(rr.length))
            throw new Error("Invalid key");
          rr = rr.padStart(ir * 2, "0");
        }
        let fr;
        try {
          fr = typeof rr == "bigint" ? rr : p.bytesToNumberBE((0, t.ensureBytes)("private key", rr, ir));
        } catch {
          throw new Error(`private key must be ${ir} bytes, hex or bigint, not ${typeof rr}`);
        }
        return sr && (fr = u.mod(fr, nr)), Ee(fr), fr;
      }
      const ve = /* @__PURE__ */ new Map();
      function we(rr) {
        if (!(rr instanceof Ce))
          throw new Error("ProjectivePoint expected");
      }
      class Ce {
        constructor(er, ir, sr) {
          if (this.px = er, this.py = ir, this.pz = sr, er == null || !be.isValid(er))
            throw new Error("x required");
          if (ir == null || !be.isValid(ir))
            throw new Error("y required");
          if (sr == null || !be.isValid(sr))
            throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(er) {
          const { x: ir, y: sr } = er || {};
          if (!er || !be.isValid(ir) || !be.isValid(sr))
            throw new Error("invalid affine point");
          if (er instanceof Ce)
            throw new Error("projective point not allowed");
          const nr = (fr) => be.eql(fr, be.ZERO);
          return nr(ir) && nr(sr) ? Ce.ZERO : new Ce(ir, sr, be.ONE);
        }
        get x() {
          return this.toAffine().x;
        }
        get y() {
          return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */
        static normalizeZ(er) {
          const ir = be.invertBatch(er.map((sr) => sr.pz));
          return er.map((sr, nr) => sr.toAffine(ir[nr])).map(Ce.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */
        static fromHex(er) {
          const ir = Ce.fromAffine(Te((0, t.ensureBytes)("pointHex", er)));
          return ir.assertValidity(), ir;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(er) {
          return Ce.BASE.multiply(He(er));
        }
        // "Private method", don't use it directly
        _setWindowSize(er) {
          this._WINDOW_SIZE = er, ve.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
          if (this.is0()) {
            if (Ie.allowInfinityPoint && !be.is0(this.py))
              return;
            throw new Error("bad point: ZERO");
          }
          const { x: er, y: ir } = this.toAffine();
          if (!be.isValid(er) || !be.isValid(ir))
            throw new Error("bad point: x or y not FE");
          const sr = be.sqr(ir), nr = Qe(er);
          if (!be.eql(sr, nr))
            throw new Error("bad point: equation left != right");
          if (!this.isTorsionFree())
            throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
          const { y: er } = this.toAffine();
          if (be.isOdd)
            return !be.isOdd(er);
          throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */
        equals(er) {
          we(er);
          const { px: ir, py: sr, pz: nr } = this, { px: fr, py: lr, pz: br } = er, Br = be.eql(be.mul(ir, br), be.mul(fr, nr)), Fr = be.eql(be.mul(sr, br), be.mul(lr, nr));
          return Br && Fr;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */
        negate() {
          return new Ce(this.px, be.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
          const { a: er, b: ir } = Ie, sr = be.mul(ir, Q), { px: nr, py: fr, pz: lr } = this;
          let br = be.ZERO, Br = be.ZERO, Fr = be.ZERO, Gr = be.mul(nr, nr), qr = be.mul(fr, fr), Hr = be.mul(lr, lr), un = be.mul(nr, fr);
          return un = be.add(un, un), Fr = be.mul(nr, lr), Fr = be.add(Fr, Fr), br = be.mul(er, Fr), Br = be.mul(sr, Hr), Br = be.add(br, Br), br = be.sub(qr, Br), Br = be.add(qr, Br), Br = be.mul(br, Br), br = be.mul(un, br), Fr = be.mul(sr, Fr), Hr = be.mul(er, Hr), un = be.sub(Gr, Hr), un = be.mul(er, un), un = be.add(un, Fr), Fr = be.add(Gr, Gr), Gr = be.add(Fr, Gr), Gr = be.add(Gr, Hr), Gr = be.mul(Gr, un), Br = be.add(Br, Gr), Hr = be.mul(fr, lr), Hr = be.add(Hr, Hr), Gr = be.mul(Hr, un), br = be.sub(br, Gr), Fr = be.mul(Hr, qr), Fr = be.add(Fr, Fr), Fr = be.add(Fr, Fr), new Ce(br, Br, Fr);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(er) {
          we(er);
          const { px: ir, py: sr, pz: nr } = this, { px: fr, py: lr, pz: br } = er;
          let Br = be.ZERO, Fr = be.ZERO, Gr = be.ZERO;
          const qr = Ie.a, Hr = be.mul(Ie.b, Q);
          let un = be.mul(ir, fr), Dr = be.mul(sr, lr), wr = be.mul(nr, br), yr = be.add(ir, sr), Qr = be.add(fr, lr);
          yr = be.mul(yr, Qr), Qr = be.add(un, Dr), yr = be.sub(yr, Qr), Qr = be.add(ir, nr);
          let _r = be.add(fr, br);
          return Qr = be.mul(Qr, _r), _r = be.add(un, wr), Qr = be.sub(Qr, _r), _r = be.add(sr, nr), Br = be.add(lr, br), _r = be.mul(_r, Br), Br = be.add(Dr, wr), _r = be.sub(_r, Br), Gr = be.mul(qr, Qr), Br = be.mul(Hr, wr), Gr = be.add(Br, Gr), Br = be.sub(Dr, Gr), Gr = be.add(Dr, Gr), Fr = be.mul(Br, Gr), Dr = be.add(un, un), Dr = be.add(Dr, un), wr = be.mul(qr, wr), Qr = be.mul(Hr, Qr), Dr = be.add(Dr, wr), wr = be.sub(un, wr), wr = be.mul(qr, wr), Qr = be.add(Qr, wr), un = be.mul(Dr, Qr), Fr = be.add(Fr, un), un = be.mul(_r, Qr), Br = be.mul(yr, Br), Br = be.sub(Br, un), un = be.mul(yr, Dr), Gr = be.mul(_r, Gr), Gr = be.add(Gr, un), new Ce(Br, Fr, Gr);
        }
        subtract(er) {
          return this.add(er.negate());
        }
        is0() {
          return this.equals(Ce.ZERO);
        }
        wNAF(er) {
          return Ne.wNAFCached(this, ve, er, (ir) => {
            const sr = be.invertBatch(ir.map((nr) => nr.pz));
            return ir.map((nr, fr) => nr.toAffine(sr[fr])).map(Ce.fromAffine);
          });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */
        multiplyUnsafe(er) {
          const ir = Ce.ZERO;
          if (er === k)
            return ir;
          if (Ee(er), er === C)
            return this;
          const { endo: sr } = Ie;
          if (!sr)
            return Ne.unsafeLadder(this, er);
          let { k1neg: nr, k1: fr, k2neg: lr, k2: br } = sr.splitScalar(er), Br = ir, Fr = ir, Gr = this;
          for (; fr > k || br > k; )
            fr & C && (Br = Br.add(Gr)), br & C && (Fr = Fr.add(Gr)), Gr = Gr.double(), fr >>= C, br >>= C;
          return nr && (Br = Br.negate()), lr && (Fr = Fr.negate()), Fr = new Ce(be.mul(Fr.px, sr.beta), Fr.py, Fr.pz), Br.add(Fr);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */
        multiply(er) {
          Ee(er);
          let ir = er, sr, nr;
          const { endo: fr } = Ie;
          if (fr) {
            const { k1neg: lr, k1: br, k2neg: Br, k2: Fr } = fr.splitScalar(ir);
            let { p: Gr, f: qr } = this.wNAF(br), { p: Hr, f: un } = this.wNAF(Fr);
            Gr = Ne.constTimeNegate(lr, Gr), Hr = Ne.constTimeNegate(Br, Hr), Hr = new Ce(be.mul(Hr.px, fr.beta), Hr.py, Hr.pz), sr = Gr.add(Hr), nr = qr.add(un);
          } else {
            const { p: lr, f: br } = this.wNAF(ir);
            sr = lr, nr = br;
          }
          return Ce.normalizeZ([sr, nr])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */
        multiplyAndAddUnsafe(er, ir, sr) {
          const nr = Ce.BASE, fr = (br, Br) => Br === k || Br === C || !br.equals(nr) ? br.multiplyUnsafe(Br) : br.multiply(Br), lr = fr(this, ir).add(fr(er, sr));
          return lr.is0() ? void 0 : lr;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(er) {
          const { px: ir, py: sr, pz: nr } = this, fr = this.is0();
          er == null && (er = fr ? be.ONE : be.inv(nr));
          const lr = be.mul(ir, er), br = be.mul(sr, er), Br = be.mul(nr, er);
          if (fr)
            return { x: be.ZERO, y: be.ZERO };
          if (!be.eql(Br, be.ONE))
            throw new Error("invZ was invalid");
          return { x: lr, y: br };
        }
        isTorsionFree() {
          const { h: er, isTorsionFree: ir } = Ie;
          if (er === C)
            return !0;
          if (ir)
            return ir(Ce, this);
          throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
          const { h: er, clearCofactor: ir } = Ie;
          return er === C ? this : ir ? ir(Ce, this) : this.multiplyUnsafe(Ie.h);
        }
        toRawBytes(er = !0) {
          return this.assertValidity(), Pe(Ce, this, er);
        }
        toHex(er = !0) {
          return p.bytesToHex(this.toRawBytes(er));
        }
      }
      Ce.BASE = new Ce(Ie.Gx, Ie.Gy, be.ONE), Ce.ZERO = new Ce(be.ZERO, be.ONE, be.ZERO);
      const Se = Ie.nBitLength, Ne = (0, A.wNAF)(Ce, Ie.endo ? Math.ceil(Se / 2) : Se);
      return {
        CURVE: Ie,
        ProjectivePoint: Ce,
        normPrivateKeyToScalar: He,
        weierstrassEquation: Qe,
        isWithinCurveOrder: xe
      };
    }
    function M(pe) {
      const Ie = (0, A.validateBasic)(pe);
      return p.validateObject(Ie, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
      }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
      }), Object.freeze({ lowS: !0, ...Ie });
    }
    function F(pe) {
      const Ie = M(pe), { Fp: be, n: Pe } = Ie, Te = be.BYTES + 1, Qe = 2 * be.BYTES + 1;
      function xe(Qr) {
        return k < Qr && Qr < be.ORDER;
      }
      function Ee(Qr) {
        return u.mod(Qr, Pe);
      }
      function He(Qr) {
        return u.invert(Qr, Pe);
      }
      const { ProjectivePoint: ve, normPrivateKeyToScalar: we, weierstrassEquation: Ce, isWithinCurveOrder: Se } = x({
        ...Ie,
        toBytes(Qr, _r, Jr) {
          const fn = _r.toAffine(), jr = be.toBytes(fn.x), dn = p.concatBytes;
          return Jr ? dn(Uint8Array.from([_r.hasEvenY() ? 2 : 3]), jr) : dn(Uint8Array.from([4]), jr, be.toBytes(fn.y));
        },
        fromBytes(Qr) {
          const _r = Qr.length, Jr = Qr[0], fn = Qr.subarray(1);
          if (_r === Te && (Jr === 2 || Jr === 3)) {
            const jr = p.bytesToNumberBE(fn);
            if (!xe(jr))
              throw new Error("Point is not on curve");
            const dn = Ce(jr);
            let Tn;
            try {
              Tn = be.sqrt(dn);
            } catch (vn) {
              const Cn = vn instanceof Error ? ": " + vn.message : "";
              throw new Error("Point is not on curve" + Cn);
            }
            const Yn = (Tn & C) === C;
            return (Jr & 1) === 1 !== Yn && (Tn = be.neg(Tn)), { x: jr, y: Tn };
          } else if (_r === Qe && Jr === 4) {
            const jr = be.fromBytes(fn.subarray(0, be.BYTES)), dn = be.fromBytes(fn.subarray(be.BYTES, 2 * be.BYTES));
            return { x: jr, y: dn };
          } else
            throw new Error(`Point of length ${_r} was invalid. Expected ${Te} compressed bytes or ${Qe} uncompressed bytes`);
        }
      }), Ne = (Qr) => p.bytesToHex(p.numberToBytesBE(Qr, Ie.nByteLength));
      function rr(Qr) {
        const _r = Pe >> C;
        return Qr > _r;
      }
      function er(Qr) {
        return rr(Qr) ? Ee(-Qr) : Qr;
      }
      const ir = (Qr, _r, Jr) => p.bytesToNumberBE(Qr.slice(_r, Jr));
      class sr {
        constructor(_r, Jr, fn) {
          this.r = _r, this.s = Jr, this.recovery = fn, this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(_r) {
          const Jr = Ie.nByteLength;
          return _r = (0, t.ensureBytes)("compactSignature", _r, Jr * 2), new sr(ir(_r, 0, Jr), ir(_r, Jr, 2 * Jr));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(_r) {
          const { r: Jr, s: fn } = s.DER.toSig((0, t.ensureBytes)("DER", _r));
          return new sr(Jr, fn);
        }
        assertValidity() {
          if (!Se(this.r))
            throw new Error("r must be 0 < r < CURVE.n");
          if (!Se(this.s))
            throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(_r) {
          return new sr(this.r, this.s, _r);
        }
        recoverPublicKey(_r) {
          const { r: Jr, s: fn, recovery: jr } = this, dn = Fr((0, t.ensureBytes)("msgHash", _r));
          if (jr == null || ![0, 1, 2, 3].includes(jr))
            throw new Error("recovery id invalid");
          const Tn = jr === 2 || jr === 3 ? Jr + Ie.n : Jr;
          if (Tn >= be.ORDER)
            throw new Error("recovery id 2 or 3 invalid");
          const Yn = (jr & 1) === 0 ? "02" : "03", si = ve.fromHex(Yn + Ne(Tn)), vn = He(Tn), Cn = Ee(-dn * vn), Xr = Ee(fn * vn), In = ve.BASE.multiplyAndAddUnsafe(si, Cn, Xr);
          if (!In)
            throw new Error("point at infinify");
          return In.assertValidity(), In;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
          return rr(this.s);
        }
        normalizeS() {
          return this.hasHighS() ? new sr(this.r, Ee(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
          return p.hexToBytes(this.toDERHex());
        }
        toDERHex() {
          return s.DER.hexFromSig({ r: this.r, s: this.s });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
          return p.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
          return Ne(this.r) + Ne(this.s);
        }
      }
      const nr = {
        isValidPrivateKey(Qr) {
          try {
            return we(Qr), !0;
          } catch {
            return !1;
          }
        },
        normPrivateKeyToScalar: we,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */
        randomPrivateKey: () => {
          const Qr = u.getMinHashLength(Ie.n);
          return u.mapHashToField(Ie.randomBytes(Qr), Ie.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */
        precompute(Qr = 8, _r = ve.BASE) {
          return _r._setWindowSize(Qr), _r.multiply(BigInt(3)), _r;
        }
      };
      function fr(Qr, _r = !0) {
        return ve.fromPrivateKey(Qr).toRawBytes(_r);
      }
      function lr(Qr) {
        const _r = p.isBytes(Qr), Jr = typeof Qr == "string", fn = (_r || Jr) && Qr.length;
        return _r ? fn === Te || fn === Qe : Jr ? fn === 2 * Te || fn === 2 * Qe : Qr instanceof ve;
      }
      function br(Qr, _r, Jr = !0) {
        if (lr(Qr))
          throw new Error("first arg must be private key");
        if (!lr(_r))
          throw new Error("second arg must be public key");
        return ve.fromHex(_r).multiply(we(Qr)).toRawBytes(Jr);
      }
      const Br = Ie.bits2int || function(Qr) {
        const _r = p.bytesToNumberBE(Qr), Jr = Qr.length * 8 - Ie.nBitLength;
        return Jr > 0 ? _r >> BigInt(Jr) : _r;
      }, Fr = Ie.bits2int_modN || function(Qr) {
        return Ee(Br(Qr));
      }, Gr = p.bitMask(Ie.nBitLength);
      function qr(Qr) {
        if (typeof Qr != "bigint")
          throw new Error("bigint expected");
        if (!(k <= Qr && Qr < Gr))
          throw new Error(`bigint expected < 2^${Ie.nBitLength}`);
        return p.numberToBytesBE(Qr, Ie.nByteLength);
      }
      function Hr(Qr, _r, Jr = un) {
        if (["recovered", "canonical"].some((En) => En in Jr))
          throw new Error("sign() legacy options not supported");
        const { hash: fn, randomBytes: jr } = Ie;
        let { lowS: dn, prehash: Tn, extraEntropy: Yn } = Jr;
        dn == null && (dn = !0), Qr = (0, t.ensureBytes)("msgHash", Qr), Tn && (Qr = (0, t.ensureBytes)("prehashed msgHash", fn(Qr)));
        const si = Fr(Qr), vn = we(_r), Cn = [qr(vn), qr(si)];
        if (Yn != null && Yn !== !1) {
          const En = Yn === !0 ? jr(be.BYTES) : Yn;
          Cn.push((0, t.ensureBytes)("extraEntropy", En));
        }
        const Xr = p.concatBytes(...Cn), In = si;
        function zr(En) {
          const Zr = Br(En);
          if (!Se(Zr))
            return;
          const kr = He(Zr), Rr = ve.BASE.multiply(Zr).toAffine(), Er = Ee(Rr.x);
          if (Er === k)
            return;
          const Or = Ee(kr * Ee(In + Er * vn));
          if (Or === k)
            return;
          let wn = (Rr.x === Er ? 0 : 2) | Number(Rr.y & C), Kn = Or;
          return dn && rr(Or) && (Kn = er(Or), wn ^= 1), new sr(Er, Kn, wn);
        }
        return { seed: Xr, k2sig: zr };
      }
      const un = { lowS: Ie.lowS, prehash: !1 }, Dr = { lowS: Ie.lowS, prehash: !1 };
      function wr(Qr, _r, Jr = un) {
        const { seed: fn, k2sig: jr } = Hr(Qr, _r, Jr), dn = Ie;
        return p.createHmacDrbg(dn.hash.outputLen, dn.nByteLength, dn.hmac)(fn, jr);
      }
      ve.BASE._setWindowSize(8);
      function yr(Qr, _r, Jr, fn = Dr) {
        var Rr;
        const jr = Qr;
        if (_r = (0, t.ensureBytes)("msgHash", _r), Jr = (0, t.ensureBytes)("publicKey", Jr), "strict" in fn)
          throw new Error("options.strict was renamed to lowS");
        const { lowS: dn, prehash: Tn } = fn;
        let Yn, si;
        try {
          if (typeof jr == "string" || p.isBytes(jr))
            try {
              Yn = sr.fromDER(jr);
            } catch (Er) {
              if (!(Er instanceof s.DER.Err))
                throw Er;
              Yn = sr.fromCompact(jr);
            }
          else if (typeof jr == "object" && typeof jr.r == "bigint" && typeof jr.s == "bigint") {
            const { r: Er, s: Or } = jr;
            Yn = new sr(Er, Or);
          } else
            throw new Error("PARSE");
          si = ve.fromHex(Jr);
        } catch (Er) {
          if (Er.message === "PARSE")
            throw new Error("signature must be Signature instance, Uint8Array or hex string");
          return !1;
        }
        if (dn && Yn.hasHighS())
          return !1;
        Tn && (_r = Ie.hash(_r));
        const { r: vn, s: Cn } = Yn, Xr = Fr(_r), In = He(Cn), zr = Ee(Xr * In), En = Ee(vn * In), Zr = (Rr = ve.BASE.multiplyAndAddUnsafe(si, zr, En)) == null ? void 0 : Rr.toAffine();
        return Zr ? Ee(Zr.x) === vn : !1;
      }
      return {
        CURVE: Ie,
        getPublicKey: fr,
        getSharedSecret: br,
        sign: wr,
        verify: yr,
        ProjectivePoint: ve,
        Signature: sr,
        utils: nr
      };
    }
    function le(pe, Ie) {
      const be = pe.ORDER;
      let Pe = k;
      for (let rr = be - C; rr % B === k; rr /= B)
        Pe += C;
      const Te = Pe, Qe = B << Te - C - C, xe = Qe * B, Ee = (be - C) / xe, He = (Ee - C) / B, ve = xe - C, we = Qe, Ce = pe.pow(Ie, Ee), Se = pe.pow(Ie, (Ee + C) / B);
      let Ne = (rr, er) => {
        let ir = Ce, sr = pe.pow(er, ve), nr = pe.sqr(sr);
        nr = pe.mul(nr, er);
        let fr = pe.mul(rr, nr);
        fr = pe.pow(fr, He), fr = pe.mul(fr, sr), sr = pe.mul(fr, er), nr = pe.mul(fr, rr);
        let lr = pe.mul(nr, sr);
        fr = pe.pow(lr, we);
        let br = pe.eql(fr, pe.ONE);
        sr = pe.mul(nr, Se), fr = pe.mul(lr, ir), nr = pe.cmov(sr, nr, br), lr = pe.cmov(fr, lr, br);
        for (let Br = Te; Br > C; Br--) {
          let Fr = Br - B;
          Fr = B << Fr - C;
          let Gr = pe.pow(lr, Fr);
          const qr = pe.eql(Gr, pe.ONE);
          sr = pe.mul(nr, ir), ir = pe.mul(ir, ir), Gr = pe.mul(lr, ir), nr = pe.cmov(sr, nr, qr), lr = pe.cmov(Gr, lr, qr);
        }
        return { isValid: br, value: nr };
      };
      if (pe.ORDER % P === Q) {
        const rr = (pe.ORDER - Q) / P, er = pe.sqrt(pe.neg(Ie));
        Ne = (ir, sr) => {
          let nr = pe.sqr(sr);
          const fr = pe.mul(ir, sr);
          nr = pe.mul(nr, fr);
          let lr = pe.pow(nr, rr);
          lr = pe.mul(lr, fr);
          const br = pe.mul(lr, er), Br = pe.mul(pe.sqr(lr), sr), Fr = pe.eql(Br, ir);
          let Gr = pe.cmov(br, lr, Fr);
          return { isValid: Fr, value: Gr };
        };
      }
      return Ne;
    }
    function ge(pe, Ie) {
      if (u.validateField(pe), !pe.isValid(Ie.A) || !pe.isValid(Ie.B) || !pe.isValid(Ie.Z))
        throw new Error("mapToCurveSimpleSWU: invalid opts");
      const be = le(pe, Ie.Z);
      if (!pe.isOdd)
        throw new Error("Fp.isOdd is not implemented!");
      return (Pe) => {
        let Te, Qe, xe, Ee, He, ve, we, Ce;
        Te = pe.sqr(Pe), Te = pe.mul(Te, Ie.Z), Qe = pe.sqr(Te), Qe = pe.add(Qe, Te), xe = pe.add(Qe, pe.ONE), xe = pe.mul(xe, Ie.B), Ee = pe.cmov(Ie.Z, pe.neg(Qe), !pe.eql(Qe, pe.ZERO)), Ee = pe.mul(Ee, Ie.A), Qe = pe.sqr(xe), ve = pe.sqr(Ee), He = pe.mul(ve, Ie.A), Qe = pe.add(Qe, He), Qe = pe.mul(Qe, xe), ve = pe.mul(ve, Ee), He = pe.mul(ve, Ie.B), Qe = pe.add(Qe, He), we = pe.mul(Te, xe);
        const { isValid: Se, value: Ne } = be(Qe, ve);
        Ce = pe.mul(Te, Pe), Ce = pe.mul(Ce, Ne), we = pe.cmov(we, xe, Se), Ce = pe.cmov(Ce, Ne, Se);
        const rr = pe.isOdd(Pe) === pe.isOdd(Ce);
        return Ce = pe.cmov(pe.neg(Ce), Ce, rr), we = pe.div(we, Ee), { x: we, y: Ce };
      };
    }
  }(weierstrass$2)), weierstrass$2;
}
var hasRequired_shortw_utils;
function require_shortw_utils() {
  if (hasRequired_shortw_utils) return _shortw_utils;
  hasRequired_shortw_utils = 1, Object.defineProperty(_shortw_utils, "__esModule", { value: !0 }), _shortw_utils.getHash = p, _shortw_utils.createCurve = t;
  const s = /* @__PURE__ */ requireHmac$1(), A = /* @__PURE__ */ requireUtils$7(), u = /* @__PURE__ */ requireWeierstrass();
  function p(l) {
    return {
      hash: l,
      hmac: (m, ...b) => (0, s.hmac)(l, m, (0, A.concatBytes)(...b)),
      randomBytes: A.randomBytes
    };
  }
  function t(l, m) {
    const b = (k) => (0, u.weierstrass)({ ...l, ...p(k) });
    return Object.freeze({ ...b(m), create: b });
  }
  return _shortw_utils;
}
var hashToCurve = {}, hasRequiredHashToCurve;
function requireHashToCurve() {
  if (hasRequiredHashToCurve) return hashToCurve;
  hasRequiredHashToCurve = 1, Object.defineProperty(hashToCurve, "__esModule", { value: !0 }), hashToCurve.expand_message_xmd = m, hashToCurve.expand_message_xof = b, hashToCurve.hash_to_field = k, hashToCurve.isogenyMap = C, hashToCurve.createHasher = B;
  const s = /* @__PURE__ */ requireModular(), A = /* @__PURE__ */ requireUtils$6(), u = A.bytesToNumberBE;
  function p(Q, P) {
    if (Q < 0 || Q >= 1 << 8 * P)
      throw new Error(`bad I2OSP call: value=${Q} length=${P}`);
    const x = Array.from({ length: P }).fill(0);
    for (let M = P - 1; M >= 0; M--)
      x[M] = Q & 255, Q >>>= 8;
    return new Uint8Array(x);
  }
  function t(Q, P) {
    const x = new Uint8Array(Q.length);
    for (let M = 0; M < Q.length; M++)
      x[M] = Q[M] ^ P[M];
    return x;
  }
  function l(Q) {
    if (!Number.isSafeInteger(Q))
      throw new Error("number expected");
  }
  function m(Q, P, x, M) {
    (0, A.abytes)(Q), (0, A.abytes)(P), l(x), P.length > 255 && (P = M((0, A.concatBytes)((0, A.utf8ToBytes)("H2C-OVERSIZE-DST-"), P)));
    const { outputLen: F, blockLen: le } = M, ge = Math.ceil(x / F);
    if (ge > 255)
      throw new Error("Invalid xmd length");
    const pe = (0, A.concatBytes)(P, p(P.length, 1)), Ie = p(0, le), be = p(x, 2), Pe = new Array(ge), Te = M((0, A.concatBytes)(Ie, Q, be, p(0, 1), pe));
    Pe[0] = M((0, A.concatBytes)(Te, p(1, 1), pe));
    for (let xe = 1; xe <= ge; xe++) {
      const Ee = [t(Te, Pe[xe - 1]), p(xe + 1, 1), pe];
      Pe[xe] = M((0, A.concatBytes)(...Ee));
    }
    return (0, A.concatBytes)(...Pe).slice(0, x);
  }
  function b(Q, P, x, M, F) {
    if ((0, A.abytes)(Q), (0, A.abytes)(P), l(x), P.length > 255) {
      const le = Math.ceil(2 * M / 8);
      P = F.create({ dkLen: le }).update((0, A.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(P).digest();
    }
    if (x > 65535 || P.length > 255)
      throw new Error("expand_message_xof: invalid lenInBytes");
    return F.create({ dkLen: x }).update(Q).update(p(x, 2)).update(P).update(p(P.length, 1)).digest();
  }
  function k(Q, P, x) {
    (0, A.validateObject)(x, {
      DST: "stringOrUint8Array",
      p: "bigint",
      m: "isSafeInteger",
      k: "isSafeInteger",
      hash: "hash"
    });
    const { p: M, k: F, m: le, hash: ge, expand: pe, DST: Ie } = x;
    (0, A.abytes)(Q), l(P);
    const be = typeof Ie == "string" ? (0, A.utf8ToBytes)(Ie) : Ie, Pe = M.toString(2).length, Te = Math.ceil((Pe + F) / 8), Qe = P * le * Te;
    let xe;
    if (pe === "xmd")
      xe = m(Q, be, Qe, ge);
    else if (pe === "xof")
      xe = b(Q, be, Qe, F, ge);
    else if (pe === "_internal_pass")
      xe = Q;
    else
      throw new Error('expand must be "xmd" or "xof"');
    const Ee = new Array(P);
    for (let He = 0; He < P; He++) {
      const ve = new Array(le);
      for (let we = 0; we < le; we++) {
        const Ce = Te * (we + He * le), Se = xe.subarray(Ce, Ce + Te);
        ve[we] = (0, s.mod)(u(Se), M);
      }
      Ee[He] = ve;
    }
    return Ee;
  }
  function C(Q, P) {
    const x = P.map((M) => Array.from(M).reverse());
    return (M, F) => {
      const [le, ge, pe, Ie] = x.map((be) => be.reduce((Pe, Te) => Q.add(Q.mul(Pe, M), Te)));
      return M = Q.div(le, ge), F = Q.mul(F, Q.div(pe, Ie)), { x: M, y: F };
    };
  }
  function B(Q, P, x) {
    if (typeof P != "function")
      throw new Error("mapToCurve() must be defined");
    return {
      // Encodes byte string to elliptic curve.
      // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
      hashToCurve(M, F) {
        const le = k(M, 2, { ...x, DST: x.DST, ...F }), ge = Q.fromAffine(P(le[0])), pe = Q.fromAffine(P(le[1])), Ie = ge.add(pe).clearCofactor();
        return Ie.assertValidity(), Ie;
      },
      // Encodes byte string to elliptic curve.
      // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
      encodeToCurve(M, F) {
        const le = k(M, 1, { ...x, DST: x.encodeDST, ...F }), ge = Q.fromAffine(P(le[0])).clearCofactor();
        return ge.assertValidity(), ge;
      },
      // Same as encodeToCurve, but without hash
      mapToCurve(M) {
        if (!Array.isArray(M))
          throw new Error("mapToCurve: expected array of bigints");
        for (const le of M)
          if (typeof le != "bigint")
            throw new Error(`mapToCurve: expected array of bigints, got ${le} in array`);
        const F = Q.fromAffine(P(M)).clearCofactor();
        return F.assertValidity(), F;
      }
    };
  }
  return hashToCurve;
}
var hasRequiredSecp256k1$3;
function requireSecp256k1$3() {
  return hasRequiredSecp256k1$3 || (hasRequiredSecp256k1$3 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.encodeToCurve = s.hashToCurve = s.schnorr = s.secp256k1 = void 0;
    const A = /* @__PURE__ */ requireSha256$2(), u = /* @__PURE__ */ requireUtils$7(), p = /* @__PURE__ */ require_shortw_utils(), t = /* @__PURE__ */ requireHashToCurve(), l = /* @__PURE__ */ requireModular(), m = /* @__PURE__ */ requireUtils$6(), b = /* @__PURE__ */ requireWeierstrass(), k = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), C = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), B = BigInt(1), Q = BigInt(2), P = (sr, nr) => (sr + nr / Q) / nr;
    function x(sr) {
      const nr = k, fr = BigInt(3), lr = BigInt(6), br = BigInt(11), Br = BigInt(22), Fr = BigInt(23), Gr = BigInt(44), qr = BigInt(88), Hr = sr * sr * sr % nr, un = Hr * Hr * sr % nr, Dr = (0, l.pow2)(un, fr, nr) * un % nr, wr = (0, l.pow2)(Dr, fr, nr) * un % nr, yr = (0, l.pow2)(wr, Q, nr) * Hr % nr, Qr = (0, l.pow2)(yr, br, nr) * yr % nr, _r = (0, l.pow2)(Qr, Br, nr) * Qr % nr, Jr = (0, l.pow2)(_r, Gr, nr) * _r % nr, fn = (0, l.pow2)(Jr, qr, nr) * Jr % nr, jr = (0, l.pow2)(fn, Gr, nr) * _r % nr, dn = (0, l.pow2)(jr, fr, nr) * un % nr, Tn = (0, l.pow2)(dn, Fr, nr) * Qr % nr, Yn = (0, l.pow2)(Tn, lr, nr) * Hr % nr, si = (0, l.pow2)(Yn, Q, nr);
      if (!M.eql(M.sqr(si), sr))
        throw new Error("Cannot find square root");
      return si;
    }
    const M = (0, l.Field)(k, void 0, void 0, { sqrt: x });
    s.secp256k1 = (0, p.createCurve)({
      a: BigInt(0),
      // equation params: a, b
      b: BigInt(7),
      // Seem to be rigid: bitcointalk.org/index.php?topic=289795.msg3183975#msg3183975
      Fp: M,
      // Field's prime: 2n**256n - 2n**32n - 2n**9n - 2n**8n - 2n**7n - 2n**6n - 2n**4n - 1n
      n: C,
      // Curve order, total count of valid points in the field
      // Base point (x, y) aka generator point
      Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
      Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
      h: BigInt(1),
      // Cofactor
      lowS: !0,
      // Allow only low-S signatures by default in sign() and verify()
      /**
       * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
       * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
       * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
       * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
       */
      endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (sr) => {
          const nr = C, fr = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), lr = -B * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), br = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), Br = fr, Fr = BigInt("0x100000000000000000000000000000000"), Gr = P(Br * sr, nr), qr = P(-lr * sr, nr);
          let Hr = (0, l.mod)(sr - Gr * fr - qr * br, nr), un = (0, l.mod)(-Gr * lr - qr * Br, nr);
          const Dr = Hr > Fr, wr = un > Fr;
          if (Dr && (Hr = nr - Hr), wr && (un = nr - un), Hr > Fr || un > Fr)
            throw new Error("splitScalar: Endomorphism failed, k=" + sr);
          return { k1neg: Dr, k1: Hr, k2neg: wr, k2: un };
        }
      }
    }, A.sha256);
    const F = BigInt(0), le = (sr) => typeof sr == "bigint" && F < sr && sr < k, ge = (sr) => typeof sr == "bigint" && F < sr && sr < C, pe = {};
    function Ie(sr, ...nr) {
      let fr = pe[sr];
      if (fr === void 0) {
        const lr = (0, A.sha256)(Uint8Array.from(sr, (br) => br.charCodeAt(0)));
        fr = (0, m.concatBytes)(lr, lr), pe[sr] = fr;
      }
      return (0, A.sha256)((0, m.concatBytes)(fr, ...nr));
    }
    const be = (sr) => sr.toRawBytes(!0).slice(1), Pe = (sr) => (0, m.numberToBytesBE)(sr, 32), Te = (sr) => (0, l.mod)(sr, k), Qe = (sr) => (0, l.mod)(sr, C), xe = s.secp256k1.ProjectivePoint, Ee = (sr, nr, fr) => xe.BASE.multiplyAndAddUnsafe(sr, nr, fr);
    function He(sr) {
      let nr = s.secp256k1.utils.normPrivateKeyToScalar(sr), fr = xe.fromPrivateKey(nr);
      return { scalar: fr.hasEvenY() ? nr : Qe(-nr), bytes: be(fr) };
    }
    function ve(sr) {
      if (!le(sr))
        throw new Error("bad x: need 0 < x < p");
      const nr = Te(sr * sr), fr = Te(nr * sr + BigInt(7));
      let lr = x(fr);
      lr % Q !== F && (lr = Te(-lr));
      const br = new xe(sr, lr, B);
      return br.assertValidity(), br;
    }
    function we(...sr) {
      return Qe((0, m.bytesToNumberBE)(Ie("BIP0340/challenge", ...sr)));
    }
    function Ce(sr) {
      return He(sr).bytes;
    }
    function Se(sr, nr, fr = (0, u.randomBytes)(32)) {
      const lr = (0, m.ensureBytes)("message", sr), { bytes: br, scalar: Br } = He(nr), Fr = (0, m.ensureBytes)("auxRand", fr, 32), Gr = Pe(Br ^ (0, m.bytesToNumberBE)(Ie("BIP0340/aux", Fr))), qr = Ie("BIP0340/nonce", Gr, br, lr), Hr = Qe((0, m.bytesToNumberBE)(qr));
      if (Hr === F)
        throw new Error("sign failed: k is zero");
      const { bytes: un, scalar: Dr } = He(Hr), wr = we(un, br, lr), yr = new Uint8Array(64);
      if (yr.set(un, 0), yr.set(Pe(Qe(Dr + wr * Br)), 32), !Ne(yr, lr, br))
        throw new Error("sign: Invalid signature produced");
      return yr;
    }
    function Ne(sr, nr, fr) {
      const lr = (0, m.ensureBytes)("signature", sr, 64), br = (0, m.ensureBytes)("message", nr), Br = (0, m.ensureBytes)("publicKey", fr, 32);
      try {
        const Fr = ve((0, m.bytesToNumberBE)(Br)), Gr = (0, m.bytesToNumberBE)(lr.subarray(0, 32));
        if (!le(Gr))
          return !1;
        const qr = (0, m.bytesToNumberBE)(lr.subarray(32, 64));
        if (!ge(qr))
          return !1;
        const Hr = we(Pe(Gr), be(Fr), br), un = Ee(Fr, qr, Qe(-Hr));
        return !(!un || !un.hasEvenY() || un.toAffine().x !== Gr);
      } catch {
        return !1;
      }
    }
    s.schnorr = {
      getPublicKey: Ce,
      sign: Se,
      verify: Ne,
      utils: {
        randomPrivateKey: s.secp256k1.utils.randomPrivateKey,
        lift_x: ve,
        pointToBytes: be,
        numberToBytesBE: m.numberToBytesBE,
        bytesToNumberBE: m.bytesToNumberBE,
        taggedHash: Ie,
        mod: l.mod
      }
    };
    const rr = (0, t.isogenyMap)(M, [
      // xNum
      [
        "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
        "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
        "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
        "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
      ],
      // xDen
      [
        "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
        "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
        "0x0000000000000000000000000000000000000000000000000000000000000001"
        // LAST 1
      ],
      // yNum
      [
        "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
        "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
        "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
        "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
      ],
      // yDen
      [
        "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
        "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
        "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
        "0x0000000000000000000000000000000000000000000000000000000000000001"
        // LAST 1
      ]
    ].map((sr) => sr.map((nr) => BigInt(nr)))), er = (0, b.mapToCurveSimpleSWU)(M, {
      A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
      B: BigInt("1771"),
      Z: M.create(BigInt("-11"))
    }), ir = (0, t.createHasher)(s.secp256k1.ProjectivePoint, (sr) => {
      const { x: nr, y: fr } = er(M.create(sr[0]));
      return rr(nr, fr);
    }, {
      DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
      encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
      p: M.ORDER,
      m: 1,
      k: 128,
      expand: "xmd",
      hash: A.sha256
    });
    s.hashToCurve = ir.hashToCurve, s.encodeToCurve = ir.encodeToCurve;
  }(secp256k1$4)), secp256k1$4;
}
var hasRequiredSecp256k1$2;
function requireSecp256k1$2() {
  return hasRequiredSecp256k1$2 || (hasRequiredSecp256k1$2 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.secp256k1 = void 0;
    var A = /* @__PURE__ */ requireSecp256k1$3();
    Object.defineProperty(s, "secp256k1", { enumerable: !0, get: function() {
      return A.secp256k1;
    } });
  }(secp256k1$5)), secp256k1$5;
}
var bytes$2 = {}, random$1 = {}, hasRequiredRandom$1;
function requireRandom$1() {
  if (hasRequiredRandom$1) return random$1;
  hasRequiredRandom$1 = 1, Object.defineProperty(random$1, "__esModule", { value: !0 }), random$1.getRandomBytesSync = A, random$1.getRandomBytes = u;
  const s = /* @__PURE__ */ requireUtils$7();
  function A(p) {
    return (0, s.randomBytes)(p);
  }
  async function u(p) {
    return (0, s.randomBytes)(p);
  }
  return random$1;
}
function commonjsRequire(s) {
  throw new Error('Could not dynamically require "' + s + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var utils$7 = { exports: {} }, utils$6 = utils$7.exports, hasRequiredUtils$5;
function requireUtils$5() {
  return hasRequiredUtils$5 || (hasRequiredUtils$5 = 1, function(s, A) {
    var u = utils$6 && utils$6.__importDefault || function(P) {
      return P && P.__esModule ? P : { default: P };
    };
    Object.defineProperty(A, "__esModule", { value: !0 }), A.crypto = A.utf8ToBytes = A.createView = A.concatBytes = A.toHex = A.bytesToHex = A.assertBytes = A.assertBool = void 0, A.bytesToUtf8 = k, A.hexToBytes = C, A.equalsBytes = B, A.wrapHash = Q;
    const p = u(/* @__PURE__ */ require_assert()), t = /* @__PURE__ */ requireUtils$7(), l = p.default.bool;
    A.assertBool = l;
    const m = p.default.bytes;
    A.assertBytes = m;
    var b = /* @__PURE__ */ requireUtils$7();
    Object.defineProperty(A, "bytesToHex", { enumerable: !0, get: function() {
      return b.bytesToHex;
    } }), Object.defineProperty(A, "toHex", { enumerable: !0, get: function() {
      return b.bytesToHex;
    } }), Object.defineProperty(A, "concatBytes", { enumerable: !0, get: function() {
      return b.concatBytes;
    } }), Object.defineProperty(A, "createView", { enumerable: !0, get: function() {
      return b.createView;
    } }), Object.defineProperty(A, "utf8ToBytes", { enumerable: !0, get: function() {
      return b.utf8ToBytes;
    } });
    function k(P) {
      if (!(P instanceof Uint8Array))
        throw new TypeError(`bytesToUtf8 expected Uint8Array, got ${typeof P}`);
      return new TextDecoder().decode(P);
    }
    function C(P) {
      const x = P.startsWith("0x") ? P.substring(2) : P;
      return (0, t.hexToBytes)(x);
    }
    function B(P, x) {
      if (P.length !== x.length)
        return !1;
      for (let M = 0; M < P.length; M++)
        if (P[M] !== x[M])
          return !1;
      return !0;
    }
    function Q(P) {
      return (x) => (p.default.bytes(x), P(x));
    }
    A.crypto = (() => {
      const P = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0, x = typeof commonjsRequire == "function" && commonjsRequire.bind(s);
      return {
        node: x && !P ? x("crypto") : void 0,
        web: P
      };
    })();
  }(utils$7, utils$7.exports)), utils$7.exports;
}
var helpers = {}, internal = {}, hasRequiredInternal;
function requireInternal() {
  if (hasRequiredInternal) return internal;
  hasRequiredInternal = 1, Object.defineProperty(internal, "__esModule", { value: !0 }), internal.getKeys = internal.fromAscii = internal.fromUtf8 = internal.toAscii = internal.arrayContainsArray = internal.getBinarySize = internal.padToEven = internal.stripHexPrefix = internal.isHexString = void 0;
  const s = requireBytes$1();
  function A(B, Q) {
    return !(typeof B != "string" || !B.match(/^0x[0-9A-Fa-f]*$/) || typeof Q < "u" && Q > 0 && B.length !== 2 + 2 * Q);
  }
  internal.isHexString = A;
  const u = (B) => {
    if (typeof B != "string")
      throw new Error(`[stripHexPrefix] input must be type 'string', received ${typeof B}`);
    return A(B) ? B.slice(2) : B;
  };
  internal.stripHexPrefix = u;
  function p(B) {
    let Q = B;
    if (typeof Q != "string")
      throw new Error(`[padToEven] value must be type 'string', received ${typeof Q}`);
    return Q.length % 2 && (Q = `0${Q}`), Q;
  }
  internal.padToEven = p;
  function t(B) {
    if (typeof B != "string")
      throw new Error(`[getBinarySize] method requires input type 'string', received ${typeof B}`);
    return (0, s.utf8ToBytes)(B).byteLength;
  }
  internal.getBinarySize = t;
  function l(B, Q, P) {
    if (Array.isArray(B) !== !0)
      throw new Error(`[arrayContainsArray] method requires input 'superset' to be an array, got type '${typeof B}'`);
    if (Array.isArray(Q) !== !0)
      throw new Error(`[arrayContainsArray] method requires input 'subset' to be an array, got type '${typeof Q}'`);
    return Q[P === !0 ? "some" : "every"]((x) => B.indexOf(x) >= 0);
  }
  internal.arrayContainsArray = l;
  function m(B) {
    let Q = "", P = 0;
    const x = B.length;
    for (B.substring(0, 2) === "0x" && (P = 2); P < x; P += 2) {
      const M = parseInt(B.substr(P, 2), 16);
      Q += String.fromCharCode(M);
    }
    return Q;
  }
  internal.toAscii = m;
  function b(B) {
    const Q = (0, s.utf8ToBytes)(B);
    return `0x${p((0, s.bytesToUnprefixedHex)(Q)).replace(/^0+|0+$/g, "")}`;
  }
  internal.fromUtf8 = b;
  function k(B) {
    let Q = "";
    for (let P = 0; P < B.length; P++) {
      const M = B.charCodeAt(P).toString(16);
      Q += M.length < 2 ? `0${M}` : M;
    }
    return `0x${Q}`;
  }
  internal.fromAscii = k;
  function C(B, Q, P) {
    if (!Array.isArray(B))
      throw new Error(`[getKeys] method expects input 'params' to be an array, got ${typeof B}`);
    if (typeof Q != "string")
      throw new Error(`[getKeys] method expects input 'key' to be type 'string', got ${typeof B}`);
    const x = [];
    for (let M = 0; M < B.length; M++) {
      let F = B[M][Q];
      if (P === !0 && !F)
        F = "";
      else if (typeof F != "string")
        throw new Error(`invalid abi - expected type 'string', received ${typeof F}`);
      x.push(F);
    }
    return x;
  }
  return internal.getKeys = C, internal;
}
var hasRequiredHelpers;
function requireHelpers() {
  if (hasRequiredHelpers) return helpers;
  hasRequiredHelpers = 1, Object.defineProperty(helpers, "__esModule", { value: !0 }), helpers.assertIsString = helpers.assertIsArray = helpers.assertIsBytes = helpers.assertIsHexString = void 0;
  const s = requireInternal(), A = function(l) {
    if (!(0, s.isHexString)(l)) {
      const m = `This method only supports 0x-prefixed hex strings but input was: ${l}`;
      throw new Error(m);
    }
  };
  helpers.assertIsHexString = A;
  const u = function(l) {
    if (!(l instanceof Uint8Array)) {
      const m = `This method only supports Uint8Array but input was: ${l}`;
      throw new Error(m);
    }
  };
  helpers.assertIsBytes = u;
  const p = function(l) {
    if (!Array.isArray(l)) {
      const m = `This method only supports number arrays but input was: ${l}`;
      throw new Error(m);
    }
  };
  helpers.assertIsArray = p;
  const t = function(l) {
    if (typeof l != "string") {
      const m = `This method only supports strings but input was: ${l}`;
      throw new Error(m);
    }
  };
  return helpers.assertIsString = t, helpers;
}
var hasRequiredBytes$1;
function requireBytes$1() {
  return hasRequiredBytes$1 || (hasRequiredBytes$1 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.hexToBigInt = s.utf8ToBytes = s.equalsBytes = s.bytesToUtf8 = s.bigInt64ToBytes = s.int32ToBytes = s.bytesToBigInt64 = s.bytesToInt32 = s.concatBytes = s.randomBytes = s.compareBytes = s.intToUnpaddedBytes = s.bigIntToAddressBytes = s.bigIntToUnpaddedBytes = s.bigIntMin = s.bigIntMax = s.bigIntToHex = s.validateNoLeadingZeroes = s.short = s.addHexPrefix = s.toUnsigned = s.fromSigned = s.toBytes = s.unpadHex = s.unpadArray = s.unpadBytes = s.setLengthRight = s.setLengthLeft = s.zeros = s.bigIntToBytes = s.intToBytes = s.intToHex = s.hexToBytes = s.bytesToInt = s.bytesToBigInt = s.bytesToHex = s.unprefixedHexToBytes = s.bytesToUnprefixedHex = void 0;
    const A = /* @__PURE__ */ requireRandom$1(), u = /* @__PURE__ */ requireUtils$5(), p = requireHelpers(), t = requireInternal(), l = BigInt(0);
    s.bytesToUnprefixedHex = u.bytesToHex;
    const m = {}, b = {};
    for (let yr = 0; yr < 16; yr++) {
      const Qr = yr, _r = yr * 16, Jr = yr.toString(16).toLowerCase();
      b[Jr] = Qr, b[Jr.toUpperCase()] = Qr, m[Jr] = _r, m[Jr.toUpperCase()] = _r;
    }
    function k(yr) {
      const Qr = yr.length, _r = new Uint8Array(Qr / 2);
      for (let Jr = 0; Jr < Qr; Jr += 2)
        _r[Jr / 2] = m[yr[Jr]] + b[yr[Jr + 1]];
      return _r;
    }
    const C = (yr) => {
      if (yr.slice(0, 2) === "0x")
        throw new Error("hex string is prefixed with 0x, should be unprefixed");
      return k((0, t.padToEven)(yr));
    };
    s.unprefixedHexToBytes = C;
    const B = Array.from({ length: 256 }, (yr, Qr) => Qr.toString(16).padStart(2, "0")), Q = (yr) => {
      let Qr = "0x";
      if (yr === void 0 || yr.length === 0)
        return Qr;
      for (const _r of yr)
        Qr = `${Qr}${B[_r]}`;
      return Qr;
    };
    s.bytesToHex = Q;
    const P = [];
    for (let yr = 0; yr <= 256 * 256 - 1; yr++)
      P[yr] = BigInt(yr);
    const x = (yr, Qr = !1) => {
      Qr && yr.reverse();
      const _r = (0, s.bytesToHex)(yr);
      return _r === "0x" ? l : _r.length === 4 ? P[yr[0]] : _r.length === 6 ? P[yr[0] * 256 + yr[1]] : BigInt(_r);
    };
    s.bytesToBigInt = x;
    const M = (yr) => {
      const Qr = Number((0, s.bytesToBigInt)(yr));
      if (!Number.isSafeInteger(Qr))
        throw new Error("Number exceeds 53 bits");
      return Qr;
    };
    s.bytesToInt = M;
    const F = (yr) => {
      if (typeof yr != "string")
        throw new Error(`hex argument type ${typeof yr} must be of type string`);
      if (!/^0x[0-9a-fA-F]*$/.test(yr))
        throw new Error(`Input must be a 0x-prefixed hexadecimal string, got ${yr}`);
      const Qr = yr.slice(2);
      return k(Qr.length % 2 === 0 ? Qr : (0, t.padToEven)(Qr));
    };
    s.hexToBytes = F;
    const le = (yr) => {
      if (!Number.isSafeInteger(yr) || yr < 0)
        throw new Error(`Received an invalid integer type: ${yr}`);
      return `0x${yr.toString(16)}`;
    };
    s.intToHex = le;
    const ge = (yr) => {
      const Qr = (0, s.intToHex)(yr);
      return (0, s.hexToBytes)(Qr);
    };
    s.intToBytes = ge;
    const pe = (yr, Qr = !1) => {
      const _r = (0, s.toBytes)(`0x${(0, t.padToEven)(yr.toString(16))}`);
      return Qr ? _r.reverse() : _r;
    };
    s.bigIntToBytes = pe;
    const Ie = (yr) => new Uint8Array(yr);
    s.zeros = Ie;
    const be = (yr, Qr, _r) => _r ? yr.length < Qr ? new Uint8Array([...yr, ...(0, s.zeros)(Qr - yr.length)]) : yr.subarray(0, Qr) : yr.length < Qr ? new Uint8Array([...(0, s.zeros)(Qr - yr.length), ...yr]) : yr.subarray(-Qr), Pe = (yr, Qr) => ((0, p.assertIsBytes)(yr), be(yr, Qr, !1));
    s.setLengthLeft = Pe;
    const Te = (yr, Qr) => ((0, p.assertIsBytes)(yr), be(yr, Qr, !0));
    s.setLengthRight = Te;
    const Qe = (yr) => {
      let Qr = yr[0];
      for (; yr.length > 0 && Qr.toString() === "0"; )
        yr = yr.slice(1), Qr = yr[0];
      return yr;
    }, xe = (yr) => ((0, p.assertIsBytes)(yr), Qe(yr));
    s.unpadBytes = xe;
    const Ee = (yr) => ((0, p.assertIsArray)(yr), Qe(yr));
    s.unpadArray = Ee;
    const He = (yr) => ((0, p.assertIsHexString)(yr), `0x${Qe((0, t.stripHexPrefix)(yr))}`);
    s.unpadHex = He;
    const ve = (yr) => {
      if (yr == null)
        return new Uint8Array();
      if (Array.isArray(yr) || yr instanceof Uint8Array)
        return Uint8Array.from(yr);
      if (typeof yr == "string") {
        if (!(0, t.isHexString)(yr))
          throw new Error(`Cannot convert string to Uint8Array. toBytes only supports 0x-prefixed hex strings and this string was given: ${yr}`);
        return (0, s.hexToBytes)(yr);
      }
      if (typeof yr == "number")
        return (0, s.intToBytes)(yr);
      if (typeof yr == "bigint") {
        if (yr < l)
          throw new Error(`Cannot convert negative bigint to Uint8Array. Given: ${yr}`);
        let Qr = yr.toString(16);
        return Qr.length % 2 && (Qr = "0" + Qr), (0, s.unprefixedHexToBytes)(Qr);
      }
      if (yr.toBytes !== void 0)
        return yr.toBytes();
      throw new Error("invalid type");
    };
    s.toBytes = ve;
    const we = (yr) => BigInt.asIntN(256, (0, s.bytesToBigInt)(yr));
    s.fromSigned = we;
    const Ce = (yr) => (0, s.bigIntToBytes)(BigInt.asUintN(256, yr));
    s.toUnsigned = Ce;
    const Se = (yr) => typeof yr != "string" || (0, t.isHexString)(yr) ? yr : `0x${yr}`;
    s.addHexPrefix = Se;
    const Ne = (yr, Qr = 50) => {
      const _r = yr instanceof Uint8Array ? (0, s.bytesToHex)(yr) : yr, Jr = _r.slice(0, 2) === "0x" ? Qr + 2 : Qr;
      return _r.length <= Jr ? _r : _r.slice(0, Jr) + "…";
    };
    s.short = Ne;
    const rr = (yr) => {
      for (const [Qr, _r] of Object.entries(yr))
        if (_r !== void 0 && _r.length > 0 && _r[0] === 0)
          throw new Error(`${Qr} cannot have leading zeroes, received: ${(0, s.bytesToHex)(_r)}`);
    };
    s.validateNoLeadingZeroes = rr;
    const er = (yr) => `0x${yr.toString(16)}`;
    s.bigIntToHex = er;
    const ir = (...yr) => yr.reduce((Qr, _r) => _r > Qr ? _r : Qr);
    s.bigIntMax = ir;
    const sr = (...yr) => yr.reduce((Qr, _r) => _r < Qr ? _r : Qr);
    s.bigIntMin = sr;
    const nr = (yr) => (0, s.unpadBytes)((0, s.bigIntToBytes)(yr));
    s.bigIntToUnpaddedBytes = nr;
    const fr = (yr, Qr = !0) => {
      const _r = (0, s.bigIntToBytes)(yr);
      if (Qr && _r.length > 20)
        throw Error(`Invalid address bytes length=${_r.length} strict=${Qr}`);
      return (0, s.setLengthLeft)(_r, 20);
    };
    s.bigIntToAddressBytes = fr;
    const lr = (yr) => (0, s.unpadBytes)((0, s.intToBytes)(yr));
    s.intToUnpaddedBytes = lr;
    const br = (yr, Qr) => {
      const _r = (0, s.bytesToBigInt)(yr), Jr = (0, s.bytesToBigInt)(Qr);
      return _r > Jr ? 1 : _r < Jr ? -1 : 0;
    };
    s.compareBytes = br;
    const Br = (yr) => (0, A.getRandomBytesSync)(yr);
    s.randomBytes = Br;
    const Fr = (...yr) => {
      if (yr.length === 1)
        return yr[0];
      const Qr = yr.reduce((Jr, fn) => Jr + fn.length, 0), _r = new Uint8Array(Qr);
      for (let Jr = 0, fn = 0; Jr < yr.length; Jr++) {
        const jr = yr[Jr];
        _r.set(jr, fn), fn += jr.length;
      }
      return _r;
    };
    s.concatBytes = Fr;
    function Gr(yr, Qr = !1) {
      return yr.length < 4 && (yr = be(yr, 4, Qr)), new DataView(yr.buffer, yr.byteOffset, yr.byteLength).getUint32(0, Qr);
    }
    s.bytesToInt32 = Gr;
    function qr(yr, Qr = !1) {
      return yr.length < 8 && (yr = be(yr, 8, Qr)), new DataView(yr.buffer, yr.byteOffset, yr.byteLength).getBigUint64(0, Qr);
    }
    s.bytesToBigInt64 = qr;
    function Hr(yr, Qr = !1) {
      const _r = new ArrayBuffer(4);
      return new DataView(_r).setUint32(0, yr, Qr), new Uint8Array(_r);
    }
    s.int32ToBytes = Hr;
    function un(yr, Qr = !1) {
      const _r = new ArrayBuffer(8);
      return new DataView(_r).setBigUint64(0, yr, Qr), new Uint8Array(_r);
    }
    s.bigInt64ToBytes = un;
    var Dr = /* @__PURE__ */ requireUtils$5();
    Object.defineProperty(s, "bytesToUtf8", { enumerable: !0, get: function() {
      return Dr.bytesToUtf8;
    } }), Object.defineProperty(s, "equalsBytes", { enumerable: !0, get: function() {
      return Dr.equalsBytes;
    } }), Object.defineProperty(s, "utf8ToBytes", { enumerable: !0, get: function() {
      return Dr.utf8ToBytes;
    } });
    function wr(yr) {
      return (0, s.bytesToBigInt)((0, s.hexToBytes)((0, t.isHexString)(yr) ? yr : `0x${yr}`));
    }
    s.hexToBigInt = wr;
  }(bytes$2)), bytes$2;
}
var hasRequiredConstants$4;
function requireConstants$4() {
  return hasRequiredConstants$4 || (hasRequiredConstants$4 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.BIGINT_2EXP256 = s.BIGINT_2EXP224 = s.BIGINT_2EXP160 = s.BIGINT_2EXP96 = s.BIGINT_224 = s.BIGINT_160 = s.BIGINT_100 = s.BIGINT_96 = s.BIGINT_256 = s.BIGINT_255 = s.BIGINT_128 = s.BIGINT_64 = s.BIGINT_32 = s.BIGINT_31 = s.BIGINT_28 = s.BIGINT_27 = s.BIGINT_8 = s.BIGINT_7 = s.BIGINT_3 = s.BIGINT_2 = s.BIGINT_1 = s.BIGINT_0 = s.BIGINT_NEG1 = s.RIPEMD160_ADDRESS_STRING = s.MAX_WITHDRAWALS_PER_PAYLOAD = s.RLP_EMPTY_STRING = s.KECCAK256_RLP = s.KECCAK256_RLP_S = s.KECCAK256_RLP_ARRAY = s.KECCAK256_RLP_ARRAY_S = s.KECCAK256_NULL = s.KECCAK256_NULL_S = s.TWO_POW256 = s.SECP256K1_ORDER_DIV_2 = s.SECP256K1_ORDER = s.MAX_INTEGER_BIGINT = s.MAX_INTEGER = s.MAX_UINT64 = void 0;
    const A = /* @__PURE__ */ requireSecp256k1$2(), u = requireBytes$1();
    s.MAX_UINT64 = BigInt("0xffffffffffffffff"), s.MAX_INTEGER = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), s.MAX_INTEGER_BIGINT = BigInt("115792089237316195423570985008687907853269984665640564039457584007913129639935"), s.SECP256K1_ORDER = A.secp256k1.CURVE.n, s.SECP256K1_ORDER_DIV_2 = A.secp256k1.CURVE.n / BigInt(2), s.TWO_POW256 = BigInt("0x10000000000000000000000000000000000000000000000000000000000000000"), s.KECCAK256_NULL_S = "0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", s.KECCAK256_NULL = (0, u.hexToBytes)(s.KECCAK256_NULL_S), s.KECCAK256_RLP_ARRAY_S = "0x1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", s.KECCAK256_RLP_ARRAY = (0, u.hexToBytes)(s.KECCAK256_RLP_ARRAY_S), s.KECCAK256_RLP_S = "0x56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", s.KECCAK256_RLP = (0, u.hexToBytes)(s.KECCAK256_RLP_S), s.RLP_EMPTY_STRING = Uint8Array.from([128]), s.MAX_WITHDRAWALS_PER_PAYLOAD = 16, s.RIPEMD160_ADDRESS_STRING = "0000000000000000000000000000000000000003", s.BIGINT_NEG1 = BigInt(-1), s.BIGINT_0 = BigInt(0), s.BIGINT_1 = BigInt(1), s.BIGINT_2 = BigInt(2), s.BIGINT_3 = BigInt(3), s.BIGINT_7 = BigInt(7), s.BIGINT_8 = BigInt(8), s.BIGINT_27 = BigInt(27), s.BIGINT_28 = BigInt(28), s.BIGINT_31 = BigInt(31), s.BIGINT_32 = BigInt(32), s.BIGINT_64 = BigInt(64), s.BIGINT_128 = BigInt(128), s.BIGINT_255 = BigInt(255), s.BIGINT_256 = BigInt(256), s.BIGINT_96 = BigInt(96), s.BIGINT_100 = BigInt(100), s.BIGINT_160 = BigInt(160), s.BIGINT_224 = BigInt(224), s.BIGINT_2EXP96 = BigInt(7922816251426434e13), s.BIGINT_2EXP160 = BigInt(1461501637330903e33), s.BIGINT_2EXP224 = BigInt(2695994666715064e52), s.BIGINT_2EXP256 = s.BIGINT_2 ** s.BIGINT_256;
  }(constants$4)), constants$4;
}
var units = {}, hasRequiredUnits;
function requireUnits() {
  if (hasRequiredUnits) return units;
  hasRequiredUnits = 1, Object.defineProperty(units, "__esModule", { value: !0 }), units.formatBigDecimal = units.GWEI_TO_WEI = void 0;
  const s = requireConstants$4();
  units.GWEI_TO_WEI = BigInt(1e9);
  function A(u, p, t) {
    p === s.BIGINT_0 && (p = s.BIGINT_1);
    const l = u / p, m = (u - l * p) * t / p, b = String(t).length - 1 - String(m).length;
    return `${l}.${"0".repeat(b)}${m}`;
  }
  return units.formatBigDecimal = A, units;
}
var account$2 = {}, cjs$4 = {}, hasRequiredCjs$5;
function requireCjs$5() {
  if (hasRequiredCjs$5) return cjs$4;
  hasRequiredCjs$5 = 1, Object.defineProperty(cjs$4, "__esModule", { value: !0 }), cjs$4.RLP = cjs$4.utils = cjs$4.decode = cjs$4.encode = void 0;
  function s(ge) {
    if (Array.isArray(ge)) {
      const Ie = [];
      let be = 0;
      for (let Pe = 0; Pe < ge.length; Pe++) {
        const Te = s(ge[Pe]);
        Ie.push(Te), be += Te.length;
      }
      return B(p(be, 192), ...Ie);
    }
    const pe = le(ge);
    return pe.length === 1 && pe[0] < 128 ? pe : B(p(pe.length, 128), pe);
  }
  cjs$4.encode = s;
  function A(ge, pe, Ie) {
    if (Ie > ge.length)
      throw new Error("invalid RLP (safeSlice): end slice of Uint8Array out-of-bounds");
    return ge.slice(pe, Ie);
  }
  function u(ge) {
    if (ge[0] === 0)
      throw new Error("invalid RLP: extra zeros");
    return k(b(ge));
  }
  function p(ge, pe) {
    if (ge < 56)
      return Uint8Array.from([ge + pe]);
    const Ie = P(ge), be = Ie.length / 2, Pe = P(pe + 55 + be);
    return Uint8Array.from(C(Pe + Ie));
  }
  function t(ge, pe = !1) {
    if (typeof ge > "u" || ge === null || ge.length === 0)
      return Uint8Array.from([]);
    const Ie = le(ge), be = l(Ie);
    if (pe)
      return {
        data: be.data,
        remainder: be.remainder.slice()
      };
    if (be.remainder.length !== 0)
      throw new Error("invalid RLP: remainder must be zero");
    return be.data;
  }
  cjs$4.decode = t;
  function l(ge) {
    let pe, Ie, be, Pe, Te;
    const Qe = [], xe = ge[0];
    if (xe <= 127)
      return {
        data: ge.slice(0, 1),
        remainder: ge.subarray(1)
      };
    if (xe <= 183) {
      if (pe = xe - 127, xe === 128 ? be = Uint8Array.from([]) : be = A(ge, 1, pe), pe === 2 && be[0] < 128)
        throw new Error("invalid RLP encoding: invalid prefix, single byte < 0x80 are not prefixed");
      return {
        data: be,
        remainder: ge.subarray(pe)
      };
    } else if (xe <= 191) {
      if (Ie = xe - 182, ge.length - 1 < Ie)
        throw new Error("invalid RLP: not enough bytes for string length");
      if (pe = u(A(ge, 1, Ie)), pe <= 55)
        throw new Error("invalid RLP: expected string length to be greater than 55");
      return be = A(ge, Ie, pe + Ie), {
        data: be,
        remainder: ge.subarray(pe + Ie)
      };
    } else if (xe <= 247) {
      for (pe = xe - 191, Pe = A(ge, 1, pe); Pe.length; )
        Te = l(Pe), Qe.push(Te.data), Pe = Te.remainder;
      return {
        data: Qe,
        remainder: ge.subarray(pe)
      };
    } else {
      if (Ie = xe - 246, pe = u(A(ge, 1, Ie)), pe < 56)
        throw new Error("invalid RLP: encoded list too short");
      const Ee = Ie + pe;
      if (Ee > ge.length)
        throw new Error("invalid RLP: total length is larger than the data");
      for (Pe = A(ge, Ie, Ee); Pe.length; )
        Te = l(Pe), Qe.push(Te.data), Pe = Te.remainder;
      return {
        data: Qe,
        remainder: ge.subarray(Ee)
      };
    }
  }
  const m = Array.from({ length: 256 }, (ge, pe) => pe.toString(16).padStart(2, "0"));
  function b(ge) {
    let pe = "";
    for (let Ie = 0; Ie < ge.length; Ie++)
      pe += m[ge[Ie]];
    return pe;
  }
  function k(ge) {
    const pe = Number.parseInt(ge, 16);
    if (Number.isNaN(pe))
      throw new Error("Invalid byte sequence");
    return pe;
  }
  function C(ge) {
    if (typeof ge != "string")
      throw new TypeError("hexToBytes: expected string, got " + typeof ge);
    if (ge.length % 2)
      throw new Error("hexToBytes: received invalid unpadded hex");
    const pe = new Uint8Array(ge.length / 2);
    for (let Ie = 0; Ie < pe.length; Ie++) {
      const be = Ie * 2;
      pe[Ie] = k(ge.slice(be, be + 2));
    }
    return pe;
  }
  function B(...ge) {
    if (ge.length === 1)
      return ge[0];
    const pe = ge.reduce((be, Pe) => be + Pe.length, 0), Ie = new Uint8Array(pe);
    for (let be = 0, Pe = 0; be < ge.length; be++) {
      const Te = ge[be];
      Ie.set(Te, Pe), Pe += Te.length;
    }
    return Ie;
  }
  function Q(ge) {
    return new TextEncoder().encode(ge);
  }
  function P(ge) {
    if (ge < 0)
      throw new Error("Invalid integer as argument, must be unsigned!");
    const pe = ge.toString(16);
    return pe.length % 2 ? `0${pe}` : pe;
  }
  function x(ge) {
    return ge.length % 2 ? `0${ge}` : ge;
  }
  function M(ge) {
    return ge.length >= 2 && ge[0] === "0" && ge[1] === "x";
  }
  function F(ge) {
    return typeof ge != "string" ? ge : M(ge) ? ge.slice(2) : ge;
  }
  function le(ge) {
    if (ge instanceof Uint8Array)
      return ge;
    if (typeof ge == "string")
      return M(ge) ? C(x(F(ge))) : Q(ge);
    if (typeof ge == "number" || typeof ge == "bigint")
      return ge ? C(P(ge)) : Uint8Array.from([]);
    if (ge == null)
      return Uint8Array.from([]);
    throw new Error("toBytes: received unsupported type " + typeof ge);
  }
  return cjs$4.utils = {
    bytesToHex: b,
    concatBytes: B,
    hexToBytes: C,
    utf8ToBytes: Q
  }, cjs$4.RLP = { encode: s, decode: t }, cjs$4;
}
var keccak$2 = {}, sha3$2 = {}, _u64 = {}, hasRequired_u64;
function require_u64() {
  if (hasRequired_u64) return _u64;
  hasRequired_u64 = 1, Object.defineProperty(_u64, "__esModule", { value: !0 }), _u64.add5L = _u64.add5H = _u64.add4H = _u64.add4L = _u64.add3H = _u64.add3L = _u64.add = _u64.rotlBL = _u64.rotlBH = _u64.rotlSL = _u64.rotlSH = _u64.rotr32L = _u64.rotr32H = _u64.rotrBL = _u64.rotrBH = _u64.rotrSL = _u64.rotrSH = _u64.shrSL = _u64.shrSH = _u64.toBig = _u64.split = _u64.fromBig = void 0;
  const s = /* @__PURE__ */ BigInt(2 ** 32 - 1), A = /* @__PURE__ */ BigInt(32);
  function u(Ee, He = !1) {
    return He ? { h: Number(Ee & s), l: Number(Ee >> A & s) } : { h: Number(Ee >> A & s) | 0, l: Number(Ee & s) | 0 };
  }
  _u64.fromBig = u;
  function p(Ee, He = !1) {
    let ve = new Uint32Array(Ee.length), we = new Uint32Array(Ee.length);
    for (let Ce = 0; Ce < Ee.length; Ce++) {
      const { h: Se, l: Ne } = u(Ee[Ce], He);
      [ve[Ce], we[Ce]] = [Se, Ne];
    }
    return [ve, we];
  }
  _u64.split = p;
  const t = (Ee, He) => BigInt(Ee >>> 0) << A | BigInt(He >>> 0);
  _u64.toBig = t;
  const l = (Ee, He, ve) => Ee >>> ve;
  _u64.shrSH = l;
  const m = (Ee, He, ve) => Ee << 32 - ve | He >>> ve;
  _u64.shrSL = m;
  const b = (Ee, He, ve) => Ee >>> ve | He << 32 - ve;
  _u64.rotrSH = b;
  const k = (Ee, He, ve) => Ee << 32 - ve | He >>> ve;
  _u64.rotrSL = k;
  const C = (Ee, He, ve) => Ee << 64 - ve | He >>> ve - 32;
  _u64.rotrBH = C;
  const B = (Ee, He, ve) => Ee >>> ve - 32 | He << 64 - ve;
  _u64.rotrBL = B;
  const Q = (Ee, He) => He;
  _u64.rotr32H = Q;
  const P = (Ee, He) => Ee;
  _u64.rotr32L = P;
  const x = (Ee, He, ve) => Ee << ve | He >>> 32 - ve;
  _u64.rotlSH = x;
  const M = (Ee, He, ve) => He << ve | Ee >>> 32 - ve;
  _u64.rotlSL = M;
  const F = (Ee, He, ve) => He << ve - 32 | Ee >>> 64 - ve;
  _u64.rotlBH = F;
  const le = (Ee, He, ve) => Ee << ve - 32 | He >>> 64 - ve;
  _u64.rotlBL = le;
  function ge(Ee, He, ve, we) {
    const Ce = (He >>> 0) + (we >>> 0);
    return { h: Ee + ve + (Ce / 2 ** 32 | 0) | 0, l: Ce | 0 };
  }
  _u64.add = ge;
  const pe = (Ee, He, ve) => (Ee >>> 0) + (He >>> 0) + (ve >>> 0);
  _u64.add3L = pe;
  const Ie = (Ee, He, ve, we) => He + ve + we + (Ee / 2 ** 32 | 0) | 0;
  _u64.add3H = Ie;
  const be = (Ee, He, ve, we) => (Ee >>> 0) + (He >>> 0) + (ve >>> 0) + (we >>> 0);
  _u64.add4L = be;
  const Pe = (Ee, He, ve, we, Ce) => He + ve + we + Ce + (Ee / 2 ** 32 | 0) | 0;
  _u64.add4H = Pe;
  const Te = (Ee, He, ve, we, Ce) => (Ee >>> 0) + (He >>> 0) + (ve >>> 0) + (we >>> 0) + (Ce >>> 0);
  _u64.add5L = Te;
  const Qe = (Ee, He, ve, we, Ce, Se) => He + ve + we + Ce + Se + (Ee / 2 ** 32 | 0) | 0;
  _u64.add5H = Qe;
  const xe = {
    fromBig: u,
    split: p,
    toBig: t,
    shrSH: l,
    shrSL: m,
    rotrSH: b,
    rotrSL: k,
    rotrBH: C,
    rotrBL: B,
    rotr32H: Q,
    rotr32L: P,
    rotlSH: x,
    rotlSL: M,
    rotlBH: F,
    rotlBL: le,
    add: ge,
    add3L: pe,
    add3H: Ie,
    add4L: be,
    add4H: Pe,
    add5H: Qe,
    add5L: Te
  };
  return _u64.default = xe, _u64;
}
var hasRequiredSha3$1;
function requireSha3$1() {
  if (hasRequiredSha3$1) return sha3$2;
  hasRequiredSha3$1 = 1, Object.defineProperty(sha3$2, "__esModule", { value: !0 }), sha3$2.shake256 = sha3$2.shake128 = sha3$2.keccak_512 = sha3$2.keccak_384 = sha3$2.keccak_256 = sha3$2.keccak_224 = sha3$2.sha3_512 = sha3$2.sha3_384 = sha3$2.sha3_256 = sha3$2.sha3_224 = sha3$2.Keccak = sha3$2.keccakP = void 0;
  const s = /* @__PURE__ */ require_assert(), A = /* @__PURE__ */ require_u64(), u = /* @__PURE__ */ requireUtils$7(), p = [], t = [], l = [], m = /* @__PURE__ */ BigInt(0), b = /* @__PURE__ */ BigInt(1), k = /* @__PURE__ */ BigInt(2), C = /* @__PURE__ */ BigInt(7), B = /* @__PURE__ */ BigInt(256), Q = /* @__PURE__ */ BigInt(113);
  for (let be = 0, Pe = b, Te = 1, Qe = 0; be < 24; be++) {
    [Te, Qe] = [Qe, (2 * Te + 3 * Qe) % 5], p.push(2 * (5 * Qe + Te)), t.push((be + 1) * (be + 2) / 2 % 64);
    let xe = m;
    for (let Ee = 0; Ee < 7; Ee++)
      Pe = (Pe << b ^ (Pe >> C) * Q) % B, Pe & k && (xe ^= b << (b << /* @__PURE__ */ BigInt(Ee)) - b);
    l.push(xe);
  }
  const [P, x] = /* @__PURE__ */ (0, A.split)(l, !0), M = (be, Pe, Te) => Te > 32 ? (0, A.rotlBH)(be, Pe, Te) : (0, A.rotlSH)(be, Pe, Te), F = (be, Pe, Te) => Te > 32 ? (0, A.rotlBL)(be, Pe, Te) : (0, A.rotlSL)(be, Pe, Te);
  function le(be, Pe = 24) {
    const Te = new Uint32Array(10);
    for (let Qe = 24 - Pe; Qe < 24; Qe++) {
      for (let He = 0; He < 10; He++)
        Te[He] = be[He] ^ be[He + 10] ^ be[He + 20] ^ be[He + 30] ^ be[He + 40];
      for (let He = 0; He < 10; He += 2) {
        const ve = (He + 8) % 10, we = (He + 2) % 10, Ce = Te[we], Se = Te[we + 1], Ne = M(Ce, Se, 1) ^ Te[ve], rr = F(Ce, Se, 1) ^ Te[ve + 1];
        for (let er = 0; er < 50; er += 10)
          be[He + er] ^= Ne, be[He + er + 1] ^= rr;
      }
      let xe = be[2], Ee = be[3];
      for (let He = 0; He < 24; He++) {
        const ve = t[He], we = M(xe, Ee, ve), Ce = F(xe, Ee, ve), Se = p[He];
        xe = be[Se], Ee = be[Se + 1], be[Se] = we, be[Se + 1] = Ce;
      }
      for (let He = 0; He < 50; He += 10) {
        for (let ve = 0; ve < 10; ve++)
          Te[ve] = be[He + ve];
        for (let ve = 0; ve < 10; ve++)
          be[He + ve] ^= ~Te[(ve + 2) % 10] & Te[(ve + 4) % 10];
      }
      be[0] ^= P[Qe], be[1] ^= x[Qe];
    }
    Te.fill(0);
  }
  sha3$2.keccakP = le;
  class ge extends u.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(Pe, Te, Qe, xe = !1, Ee = 24) {
      if (super(), this.blockLen = Pe, this.suffix = Te, this.outputLen = Qe, this.enableXOF = xe, this.rounds = Ee, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, (0, s.number)(Qe), 0 >= this.blockLen || this.blockLen >= 200)
        throw new Error("Sha3 supports only keccak-f1600 function");
      this.state = new Uint8Array(200), this.state32 = (0, u.u32)(this.state);
    }
    keccak() {
      u.isLE || (0, u.byteSwap32)(this.state32), le(this.state32, this.rounds), u.isLE || (0, u.byteSwap32)(this.state32), this.posOut = 0, this.pos = 0;
    }
    update(Pe) {
      (0, s.exists)(this);
      const { blockLen: Te, state: Qe } = this;
      Pe = (0, u.toBytes)(Pe);
      const xe = Pe.length;
      for (let Ee = 0; Ee < xe; ) {
        const He = Math.min(Te - this.pos, xe - Ee);
        for (let ve = 0; ve < He; ve++)
          Qe[this.pos++] ^= Pe[Ee++];
        this.pos === Te && this.keccak();
      }
      return this;
    }
    finish() {
      if (this.finished)
        return;
      this.finished = !0;
      const { state: Pe, suffix: Te, pos: Qe, blockLen: xe } = this;
      Pe[Qe] ^= Te, (Te & 128) !== 0 && Qe === xe - 1 && this.keccak(), Pe[xe - 1] ^= 128, this.keccak();
    }
    writeInto(Pe) {
      (0, s.exists)(this, !1), (0, s.bytes)(Pe), this.finish();
      const Te = this.state, { blockLen: Qe } = this;
      for (let xe = 0, Ee = Pe.length; xe < Ee; ) {
        this.posOut >= Qe && this.keccak();
        const He = Math.min(Qe - this.posOut, Ee - xe);
        Pe.set(Te.subarray(this.posOut, this.posOut + He), xe), this.posOut += He, xe += He;
      }
      return Pe;
    }
    xofInto(Pe) {
      if (!this.enableXOF)
        throw new Error("XOF is not possible for this instance");
      return this.writeInto(Pe);
    }
    xof(Pe) {
      return (0, s.number)(Pe), this.xofInto(new Uint8Array(Pe));
    }
    digestInto(Pe) {
      if ((0, s.output)(Pe, this), this.finished)
        throw new Error("digest() was already called");
      return this.writeInto(Pe), this.destroy(), Pe;
    }
    digest() {
      return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
      this.destroyed = !0, this.state.fill(0);
    }
    _cloneInto(Pe) {
      const { blockLen: Te, suffix: Qe, outputLen: xe, rounds: Ee, enableXOF: He } = this;
      return Pe || (Pe = new ge(Te, Qe, xe, He, Ee)), Pe.state32.set(this.state32), Pe.pos = this.pos, Pe.posOut = this.posOut, Pe.finished = this.finished, Pe.rounds = Ee, Pe.suffix = Qe, Pe.outputLen = xe, Pe.enableXOF = He, Pe.destroyed = this.destroyed, Pe;
    }
  }
  sha3$2.Keccak = ge;
  const pe = (be, Pe, Te) => (0, u.wrapConstructor)(() => new ge(Pe, be, Te));
  sha3$2.sha3_224 = pe(6, 144, 224 / 8), sha3$2.sha3_256 = pe(6, 136, 256 / 8), sha3$2.sha3_384 = pe(6, 104, 384 / 8), sha3$2.sha3_512 = pe(6, 72, 512 / 8), sha3$2.keccak_224 = pe(1, 144, 224 / 8), sha3$2.keccak_256 = pe(1, 136, 256 / 8), sha3$2.keccak_384 = pe(1, 104, 384 / 8), sha3$2.keccak_512 = pe(1, 72, 512 / 8);
  const Ie = (be, Pe, Te) => (0, u.wrapXOFConstructorWithOpts)((Qe = {}) => new ge(Pe, be, Qe.dkLen === void 0 ? Te : Qe.dkLen, !0));
  return sha3$2.shake128 = Ie(31, 168, 128 / 8), sha3$2.shake256 = Ie(31, 136, 256 / 8), sha3$2;
}
var hasRequiredKeccak$1;
function requireKeccak$1() {
  if (hasRequiredKeccak$1) return keccak$2;
  hasRequiredKeccak$1 = 1, Object.defineProperty(keccak$2, "__esModule", { value: !0 }), keccak$2.keccak512 = keccak$2.keccak384 = keccak$2.keccak256 = keccak$2.keccak224 = void 0;
  const s = /* @__PURE__ */ requireSha3$1(), A = /* @__PURE__ */ requireUtils$5();
  return keccak$2.keccak224 = (0, A.wrapHash)(s.keccak_224), keccak$2.keccak256 = (() => {
    const u = (0, A.wrapHash)(s.keccak_256);
    return u.create = s.keccak_256.create, u;
  })(), keccak$2.keccak384 = (0, A.wrapHash)(s.keccak_384), keccak$2.keccak512 = (0, A.wrapHash)(s.keccak_512), keccak$2;
}
var hasRequiredAccount$2;
function requireAccount$2() {
  return hasRequiredAccount$2 || (hasRequiredAccount$2 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.accountBodyToRLP = s.accountBodyToSlim = s.accountBodyFromSlim = s.isZeroAddress = s.zeroAddress = s.importPublic = s.privateToAddress = s.privateToPublic = s.publicToAddress = s.pubToAddress = s.isValidPublic = s.isValidPrivate = s.generateAddress2 = s.generateAddress = s.isValidChecksumAddress = s.toChecksumAddress = s.isValidAddress = s.Account = void 0;
    const A = requireCjs$5(), u = /* @__PURE__ */ requireKeccak$1(), p = /* @__PURE__ */ requireSecp256k1$2(), t = requireBytes$1(), l = requireConstants$4(), m = requireHelpers(), b = requireInternal();
    class k {
      /**
       * This constructor assigns and validates the values.
       * Use the static factory methods to assist in creating an Account from varying data types.
       * undefined get assigned with the defaults present, but null args are retained as is
       */
      constructor(ve = l.BIGINT_0, we = l.BIGINT_0, Ce = l.KECCAK256_RLP, Se = l.KECCAK256_NULL, Ne = null, rr = 0) {
        this._nonce = null, this._balance = null, this._storageRoot = null, this._codeHash = null, this._codeSize = null, this._version = null, this._nonce = ve, this._balance = we, this._storageRoot = Ce, this._codeHash = Se, Ne === null && Se !== null && !this.isContract() && (Ne = 0), this._codeSize = Ne, this._version = rr, this._validate();
      }
      get version() {
        if (this._version !== null)
          return this._version;
        throw Error(`version=${this._version} not loaded`);
      }
      set version(ve) {
        this._version = ve;
      }
      get nonce() {
        if (this._nonce !== null)
          return this._nonce;
        throw Error(`nonce=${this._nonce} not loaded`);
      }
      set nonce(ve) {
        this._nonce = ve;
      }
      get balance() {
        if (this._balance !== null)
          return this._balance;
        throw Error(`balance=${this._balance} not loaded`);
      }
      set balance(ve) {
        this._balance = ve;
      }
      get storageRoot() {
        if (this._storageRoot !== null)
          return this._storageRoot;
        throw Error(`storageRoot=${this._storageRoot} not loaded`);
      }
      set storageRoot(ve) {
        this._storageRoot = ve;
      }
      get codeHash() {
        if (this._codeHash !== null)
          return this._codeHash;
        throw Error(`codeHash=${this._codeHash} not loaded`);
      }
      set codeHash(ve) {
        this._codeHash = ve;
      }
      get codeSize() {
        if (this._codeSize !== null)
          return this._codeSize;
        throw Error(`codeHash=${this._codeSize} not loaded`);
      }
      set codeSize(ve) {
        this._codeSize = ve;
      }
      static fromAccountData(ve) {
        const { nonce: we, balance: Ce, storageRoot: Se, codeHash: Ne } = ve;
        if (we === null || Ce === null || Se === null || Ne === null)
          throw Error("Partial fields not supported in fromAccountData");
        return new k(we !== void 0 ? (0, t.bytesToBigInt)((0, t.toBytes)(we)) : void 0, Ce !== void 0 ? (0, t.bytesToBigInt)((0, t.toBytes)(Ce)) : void 0, Se !== void 0 ? (0, t.toBytes)(Se) : void 0, Ne !== void 0 ? (0, t.toBytes)(Ne) : void 0);
      }
      static fromPartialAccountData(ve) {
        const { nonce: we, balance: Ce, storageRoot: Se, codeHash: Ne, codeSize: rr, version: er } = ve;
        if (we === null && Ce === null && Se === null && Ne === null && rr === null && er === null)
          throw Error("All partial fields null");
        return new k(we != null ? (0, t.bytesToBigInt)((0, t.toBytes)(we)) : we, Ce != null ? (0, t.bytesToBigInt)((0, t.toBytes)(Ce)) : Ce, Se != null ? (0, t.toBytes)(Se) : Se, Ne != null ? (0, t.toBytes)(Ne) : Ne, rr != null ? (0, t.bytesToInt)((0, t.toBytes)(rr)) : rr, er != null ? (0, t.bytesToInt)((0, t.toBytes)(er)) : er);
      }
      static fromRlpSerializedAccount(ve) {
        const we = A.RLP.decode(ve);
        if (!Array.isArray(we))
          throw new Error("Invalid serialized account input. Must be array");
        return this.fromValuesArray(we);
      }
      static fromRlpSerializedPartialAccount(ve) {
        const we = A.RLP.decode(ve);
        if (!Array.isArray(we))
          throw new Error("Invalid serialized account input. Must be array");
        let Ce = null;
        if (Array.isArray(we[0])) {
          const sr = (0, t.bytesToInt)(we[0][0]);
          if (sr !== 0 && sr !== 1)
            throw new Error(`Invalid isNullIndicator=${sr} for nonce`);
          sr === 1 && (Ce = (0, t.bytesToBigInt)(we[0][1]));
        } else
          throw new Error("Invalid partial nonce encoding. Must be array");
        let Se = null;
        if (Array.isArray(we[1])) {
          const sr = (0, t.bytesToInt)(we[1][0]);
          if (sr !== 0 && sr !== 1)
            throw new Error(`Invalid isNullIndicator=${sr} for balance`);
          sr === 1 && (Se = (0, t.bytesToBigInt)(we[1][1]));
        } else
          throw new Error("Invalid partial balance encoding. Must be array");
        let Ne = null;
        if (Array.isArray(we[2])) {
          const sr = (0, t.bytesToInt)(we[2][0]);
          if (sr !== 0 && sr !== 1)
            throw new Error(`Invalid isNullIndicator=${sr} for storageRoot`);
          sr === 1 && (Ne = we[2][1]);
        } else
          throw new Error("Invalid partial storageRoot encoding. Must be array");
        let rr = null;
        if (Array.isArray(we[3])) {
          const sr = (0, t.bytesToInt)(we[3][0]);
          if (sr !== 0 && sr !== 1)
            throw new Error(`Invalid isNullIndicator=${sr} for codeHash`);
          sr === 1 && (rr = we[3][1]);
        } else
          throw new Error("Invalid partial codeHash encoding. Must be array");
        let er = null;
        if (Array.isArray(we[4])) {
          const sr = (0, t.bytesToInt)(we[4][0]);
          if (sr !== 0 && sr !== 1)
            throw new Error(`Invalid isNullIndicator=${sr} for codeSize`);
          sr === 1 && (er = (0, t.bytesToInt)(we[4][1]));
        } else
          throw new Error("Invalid partial codeSize encoding. Must be array");
        let ir = null;
        if (Array.isArray(we[5])) {
          const sr = (0, t.bytesToInt)(we[5][0]);
          if (sr !== 0 && sr !== 1)
            throw new Error(`Invalid isNullIndicator=${sr} for version`);
          sr === 1 && (ir = (0, t.bytesToInt)(we[5][1]));
        } else
          throw new Error("Invalid partial version encoding. Must be array");
        return this.fromPartialAccountData({ balance: Se, nonce: Ce, storageRoot: Ne, codeHash: rr, codeSize: er, version: ir });
      }
      static fromValuesArray(ve) {
        const [we, Ce, Se, Ne] = ve;
        return new k((0, t.bytesToBigInt)(we), (0, t.bytesToBigInt)(Ce), Se, Ne);
      }
      _validate() {
        if (this._nonce !== null && this._nonce < l.BIGINT_0)
          throw new Error("nonce must be greater than zero");
        if (this._balance !== null && this._balance < l.BIGINT_0)
          throw new Error("balance must be greater than zero");
        if (this._storageRoot !== null && this._storageRoot.length !== 32)
          throw new Error("storageRoot must have a length of 32");
        if (this._codeHash !== null && this._codeHash.length !== 32)
          throw new Error("codeHash must have a length of 32");
        if (this._codeSize !== null && this._codeSize < l.BIGINT_0)
          throw new Error("codeSize must be greater than zero");
      }
      /**
       * Returns an array of Uint8Arrays of the raw bytes for the account, in order.
       */
      raw() {
        return [
          (0, t.bigIntToUnpaddedBytes)(this.nonce),
          (0, t.bigIntToUnpaddedBytes)(this.balance),
          this.storageRoot,
          this.codeHash
        ];
      }
      /**
       * Returns the RLP serialization of the account as a `Uint8Array`.
       */
      serialize() {
        return A.RLP.encode(this.raw());
      }
      serializeWithPartialInfo() {
        const ve = [], we = (0, t.intToUnpaddedBytes)(0), Ce = (0, t.intToUnpaddedBytes)(1);
        return this._nonce !== null ? ve.push([Ce, (0, t.bigIntToUnpaddedBytes)(this._nonce)]) : ve.push([we]), this._balance !== null ? ve.push([Ce, (0, t.bigIntToUnpaddedBytes)(this._balance)]) : ve.push([we]), this._storageRoot !== null ? ve.push([Ce, this._storageRoot]) : ve.push([we]), this._codeHash !== null ? ve.push([Ce, this._codeHash]) : ve.push([we]), this._codeSize !== null ? ve.push([Ce, (0, t.intToUnpaddedBytes)(this._codeSize)]) : ve.push([we]), this._version !== null ? ve.push([Ce, (0, t.intToUnpaddedBytes)(this._version)]) : ve.push([we]), A.RLP.encode(ve);
      }
      /**
       * Returns a `Boolean` determining if the account is a contract.
       */
      isContract() {
        if (this._codeHash === null && this._codeSize === null)
          throw Error("Insufficient data as codeHash=null and codeSize=null");
        return this._codeHash !== null && !(0, t.equalsBytes)(this._codeHash, l.KECCAK256_NULL) || this._codeSize !== null && this._codeSize !== 0;
      }
      /**
       * Returns a `Boolean` determining if the account is empty complying to the definition of
       * account emptiness in [EIP-161](https://eips.ethereum.org/EIPS/eip-161):
       * "An account is considered empty when it has no code and zero nonce and zero balance."
       */
      isEmpty() {
        return this._balance !== null && this.balance !== l.BIGINT_0 || this._nonce === null && this.nonce !== l.BIGINT_0 || this._codeHash !== null && !(0, t.equalsBytes)(this.codeHash, l.KECCAK256_NULL) ? !1 : this.balance === l.BIGINT_0 && this.nonce === l.BIGINT_0 && (0, t.equalsBytes)(this.codeHash, l.KECCAK256_NULL);
      }
    }
    s.Account = k;
    const C = function(He) {
      try {
        (0, m.assertIsString)(He);
      } catch {
        return !1;
      }
      return /^0x[0-9a-fA-F]{40}$/.test(He);
    };
    s.isValidAddress = C;
    const B = function(He, ve) {
      (0, m.assertIsHexString)(He);
      const we = (0, b.stripHexPrefix)(He).toLowerCase();
      let Ce = "";
      ve !== void 0 && (Ce = (0, t.bytesToBigInt)((0, t.toBytes)(ve)).toString() + "0x");
      const Se = (0, t.utf8ToBytes)(Ce + we), Ne = (0, t.bytesToHex)((0, u.keccak256)(Se)).slice(2);
      let rr = "";
      for (let er = 0; er < we.length; er++)
        parseInt(Ne[er], 16) >= 8 ? rr += we[er].toUpperCase() : rr += we[er];
      return `0x${rr}`;
    };
    s.toChecksumAddress = B;
    const Q = function(He, ve) {
      return (0, s.isValidAddress)(He) && (0, s.toChecksumAddress)(He, ve) === He;
    };
    s.isValidChecksumAddress = Q;
    const P = function(He, ve) {
      return (0, m.assertIsBytes)(He), (0, m.assertIsBytes)(ve), (0, t.bytesToBigInt)(ve) === l.BIGINT_0 ? (0, u.keccak256)(A.RLP.encode([He, Uint8Array.from([])])).subarray(-20) : (0, u.keccak256)(A.RLP.encode([He, ve])).subarray(-20);
    };
    s.generateAddress = P;
    const x = function(He, ve, we) {
      if ((0, m.assertIsBytes)(He), (0, m.assertIsBytes)(ve), (0, m.assertIsBytes)(we), He.length !== 20)
        throw new Error("Expected from to be of length 20");
      if (ve.length !== 32)
        throw new Error("Expected salt to be of length 32");
      return (0, u.keccak256)((0, t.concatBytes)((0, t.hexToBytes)("0xff"), He, ve, (0, u.keccak256)(we))).subarray(-20);
    };
    s.generateAddress2 = x;
    const M = function(He) {
      return p.secp256k1.utils.isValidPrivateKey(He);
    };
    s.isValidPrivate = M;
    const F = function(He, ve = !1) {
      if ((0, m.assertIsBytes)(He), He.length === 64)
        try {
          return p.secp256k1.ProjectivePoint.fromHex((0, t.concatBytes)(Uint8Array.from([4]), He)), !0;
        } catch {
          return !1;
        }
      if (!ve)
        return !1;
      try {
        return p.secp256k1.ProjectivePoint.fromHex(He), !0;
      } catch {
        return !1;
      }
    };
    s.isValidPublic = F;
    const le = function(He, ve = !1) {
      if ((0, m.assertIsBytes)(He), ve && He.length !== 64 && (He = p.secp256k1.ProjectivePoint.fromHex(He).toRawBytes(!1).slice(1)), He.length !== 64)
        throw new Error("Expected pubKey to be of length 64");
      return (0, u.keccak256)(He).subarray(-20);
    };
    s.pubToAddress = le, s.publicToAddress = s.pubToAddress;
    const ge = function(He) {
      return (0, m.assertIsBytes)(He), p.secp256k1.ProjectivePoint.fromPrivateKey(He).toRawBytes(!1).slice(1);
    };
    s.privateToPublic = ge;
    const pe = function(He) {
      return (0, s.publicToAddress)((0, s.privateToPublic)(He));
    };
    s.privateToAddress = pe;
    const Ie = function(He) {
      return (0, m.assertIsBytes)(He), He.length !== 64 && (He = p.secp256k1.ProjectivePoint.fromHex(He).toRawBytes(!1).slice(1)), He;
    };
    s.importPublic = Ie;
    const be = function() {
      const ve = (0, t.zeros)(20);
      return (0, t.bytesToHex)(ve);
    };
    s.zeroAddress = be;
    const Pe = function(He) {
      try {
        (0, m.assertIsString)(He);
      } catch {
        return !1;
      }
      return (0, s.zeroAddress)() === He;
    };
    s.isZeroAddress = Pe;
    function Te(He) {
      const [ve, we, Ce, Se] = He;
      return [
        ve,
        we,
        Ce.length === 0 ? l.KECCAK256_RLP : Ce,
        Se.length === 0 ? l.KECCAK256_NULL : Se
      ];
    }
    s.accountBodyFromSlim = Te;
    const Qe = new Uint8Array(0);
    function xe(He) {
      const [ve, we, Ce, Se] = He;
      return [
        ve,
        we,
        (0, t.equalsBytes)(Ce, l.KECCAK256_RLP) ? Qe : Ce,
        (0, t.equalsBytes)(Se, l.KECCAK256_NULL) ? Qe : Se
      ];
    }
    s.accountBodyToSlim = xe;
    function Ee(He, ve = !0) {
      const we = ve ? Te(He) : He;
      return A.RLP.encode(we);
    }
    s.accountBodyToRLP = Ee;
  }(account$2)), account$2;
}
var address = {}, hasRequiredAddress;
function requireAddress() {
  if (hasRequiredAddress) return address;
  hasRequiredAddress = 1, Object.defineProperty(address, "__esModule", { value: !0 }), address.Address = void 0;
  const s = requireAccount$2(), A = requireBytes$1(), u = requireConstants$4();
  class p {
    constructor(l) {
      if (l.length !== 20)
        throw new Error("Invalid address length");
      this.bytes = l;
    }
    /**
     * Returns the zero address.
     */
    static zero() {
      return new p((0, A.zeros)(20));
    }
    /**
     * Returns an Address object from a hex-encoded string.
     * @param str - Hex-encoded address
     */
    static fromString(l) {
      if (!(0, s.isValidAddress)(l))
        throw new Error(`Invalid address input=${l}`);
      return new p((0, A.hexToBytes)(l));
    }
    /**
     * Returns an address for a given public key.
     * @param pubKey The two points of an uncompressed key
     */
    static fromPublicKey(l) {
      if (!(l instanceof Uint8Array))
        throw new Error("Public key should be Uint8Array");
      const m = (0, s.pubToAddress)(l);
      return new p(m);
    }
    /**
     * Returns an address for a given private key.
     * @param privateKey A private key must be 256 bits wide
     */
    static fromPrivateKey(l) {
      if (!(l instanceof Uint8Array))
        throw new Error("Private key should be Uint8Array");
      const m = (0, s.privateToAddress)(l);
      return new p(m);
    }
    /**
     * Generates an address for a newly created contract.
     * @param from The address which is creating this new address
     * @param nonce The nonce of the from account
     */
    static generate(l, m) {
      if (typeof m != "bigint")
        throw new Error("Expected nonce to be a bigint");
      return new p((0, s.generateAddress)(l.bytes, (0, A.bigIntToBytes)(m)));
    }
    /**
     * Generates an address for a contract created using CREATE2.
     * @param from The address which is creating this new address
     * @param salt A salt
     * @param initCode The init code of the contract being created
     */
    static generate2(l, m, b) {
      if (!(m instanceof Uint8Array))
        throw new Error("Expected salt to be a Uint8Array");
      if (!(b instanceof Uint8Array))
        throw new Error("Expected initCode to be a Uint8Array");
      return new p((0, s.generateAddress2)(l.bytes, m, b));
    }
    /**
     * Is address equal to another.
     */
    equals(l) {
      return (0, A.equalsBytes)(this.bytes, l.bytes);
    }
    /**
     * Is address zero.
     */
    isZero() {
      return this.equals(p.zero());
    }
    /**
     * True if address is in the address range defined
     * by EIP-1352
     */
    isPrecompileOrSystemAddress() {
      const l = (0, A.bytesToBigInt)(this.bytes), m = u.BIGINT_0, b = BigInt("0xffff");
      return l >= m && l <= b;
    }
    /**
     * Returns hex encoding of address.
     */
    toString() {
      return (0, A.bytesToHex)(this.bytes);
    }
    /**
     * Returns a new Uint8Array representation of address.
     */
    toBytes() {
      return new Uint8Array(this.bytes);
    }
  }
  return address.Address = p, address;
}
var db = {}, hasRequiredDb;
function requireDb() {
  return hasRequiredDb || (hasRequiredDb = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.ValueEncoding = s.KeyEncoding = void 0, function(A) {
      A.String = "string", A.Bytes = "view", A.Number = "number";
    }(s.KeyEncoding || (s.KeyEncoding = {})), function(A) {
      A.String = "string", A.Bytes = "view", A.JSON = "json";
    }(s.ValueEncoding || (s.ValueEncoding = {}));
  }(db)), db;
}
var withdrawal = {}, types$5 = {}, hasRequiredTypes$5;
function requireTypes$5() {
  return hasRequiredTypes$5 || (hasRequiredTypes$5 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.toType = s.TypeOutput = s.isNestedUint8Array = void 0;
    const A = requireBytes$1(), u = requireInternal();
    function p(m) {
      if (!Array.isArray(m))
        return !1;
      for (const b of m)
        if (Array.isArray(b)) {
          if (!p(b))
            return !1;
        } else if (!(b instanceof Uint8Array))
          return !1;
      return !0;
    }
    s.isNestedUint8Array = p;
    var t;
    (function(m) {
      m[m.Number = 0] = "Number", m[m.BigInt = 1] = "BigInt", m[m.Uint8Array = 2] = "Uint8Array", m[m.PrefixedHexString = 3] = "PrefixedHexString";
    })(t = s.TypeOutput || (s.TypeOutput = {}));
    function l(m, b) {
      if (m === null)
        return null;
      if (m === void 0)
        return;
      if (typeof m == "string" && !(0, u.isHexString)(m))
        throw new Error(`A string must be provided with a 0x-prefix, given: ${m}`);
      if (typeof m == "number" && !Number.isSafeInteger(m))
        throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)");
      const k = (0, A.toBytes)(m);
      switch (b) {
        case t.Uint8Array:
          return k;
        case t.BigInt:
          return (0, A.bytesToBigInt)(k);
        case t.Number: {
          const C = (0, A.bytesToBigInt)(k);
          if (C > BigInt(Number.MAX_SAFE_INTEGER))
            throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative output type)");
          return Number(C);
        }
        case t.PrefixedHexString:
          return (0, A.bytesToHex)(k);
        default:
          throw new Error("unknown outputType");
      }
    }
    s.toType = l;
  }(types$5)), types$5;
}
var hasRequiredWithdrawal;
function requireWithdrawal() {
  if (hasRequiredWithdrawal) return withdrawal;
  hasRequiredWithdrawal = 1, Object.defineProperty(withdrawal, "__esModule", { value: !0 }), withdrawal.Withdrawal = void 0;
  const s = requireAddress(), A = requireBytes$1(), u = requireConstants$4(), p = requireTypes$5();
  class t {
    /**
     * This constructor assigns and validates the values.
     * Use the static factory methods to assist in creating a Withdrawal object from varying data types.
     * Its amount is in Gwei to match CL representation and for eventual ssz withdrawalsRoot
     */
    constructor(m, b, k, C) {
      this.index = m, this.validatorIndex = b, this.address = k, this.amount = C;
    }
    static fromWithdrawalData(m) {
      const { index: b, validatorIndex: k, address: C, amount: B } = m, Q = (0, p.toType)(b, p.TypeOutput.BigInt), P = (0, p.toType)(k, p.TypeOutput.BigInt), x = C instanceof s.Address ? C : new s.Address((0, A.toBytes)(C)), M = (0, p.toType)(B, p.TypeOutput.BigInt);
      return new t(Q, P, x, M);
    }
    static fromValuesArray(m) {
      if (m.length !== 4)
        throw Error(`Invalid withdrawalArray length expected=4 actual=${m.length}`);
      const [b, k, C, B] = m;
      return t.fromWithdrawalData({ index: b, validatorIndex: k, address: C, amount: B });
    }
    /**
     * Convert a withdrawal to a buffer array
     * @param withdrawal the withdrawal to convert
     * @returns buffer array of the withdrawal
     */
    static toBytesArray(m) {
      const { index: b, validatorIndex: k, address: C, amount: B } = m, Q = (0, p.toType)(b, p.TypeOutput.BigInt) === u.BIGINT_0 ? new Uint8Array() : (0, p.toType)(b, p.TypeOutput.Uint8Array), P = (0, p.toType)(k, p.TypeOutput.BigInt) === u.BIGINT_0 ? new Uint8Array() : (0, p.toType)(k, p.TypeOutput.Uint8Array), x = C instanceof s.Address ? C.bytes : (0, p.toType)(C, p.TypeOutput.Uint8Array), M = (0, p.toType)(B, p.TypeOutput.BigInt) === u.BIGINT_0 ? new Uint8Array() : (0, p.toType)(B, p.TypeOutput.Uint8Array);
      return [Q, P, x, M];
    }
    raw() {
      return t.toBytesArray(this);
    }
    toValue() {
      return {
        index: this.index,
        validatorIndex: this.validatorIndex,
        address: this.address.bytes,
        amount: this.amount
      };
    }
    toJSON() {
      return {
        index: (0, A.bigIntToHex)(this.index),
        validatorIndex: (0, A.bigIntToHex)(this.validatorIndex),
        address: (0, A.bytesToHex)(this.address.bytes),
        amount: (0, A.bigIntToHex)(this.amount)
      };
    }
  }
  return withdrawal.Withdrawal = t, withdrawal;
}
var signature$1 = {}, hasRequiredSignature$1;
function requireSignature$1() {
  if (hasRequiredSignature$1) return signature$1;
  hasRequiredSignature$1 = 1, Object.defineProperty(signature$1, "__esModule", { value: !0 }), signature$1.hashPersonalMessage = signature$1.isValidSignature = signature$1.fromRpcSig = signature$1.toCompactSig = signature$1.toRpcSig = signature$1.ecrecover = signature$1.calculateSigRecovery = signature$1.ecsign = void 0;
  const s = /* @__PURE__ */ requireKeccak$1(), A = /* @__PURE__ */ requireSecp256k1$2(), u = requireBytes$1(), p = requireConstants$4(), t = requireHelpers();
  function l(M, F, le) {
    const ge = A.secp256k1.sign(M, F), pe = ge.toCompactRawBytes(), Ie = pe.slice(0, 32), be = pe.slice(32, 64), Pe = le === void 0 ? BigInt(ge.recovery + 27) : BigInt(ge.recovery + 35) + BigInt(le) * p.BIGINT_2;
    return { r: Ie, s: be, v: Pe };
  }
  signature$1.ecsign = l;
  function m(M, F) {
    return M === p.BIGINT_0 || M === p.BIGINT_1 ? M : F === void 0 ? M - p.BIGINT_27 : M - (F * p.BIGINT_2 + BigInt(35));
  }
  signature$1.calculateSigRecovery = m;
  function b(M) {
    return M === p.BIGINT_0 || M === p.BIGINT_1;
  }
  const k = function(M, F, le, ge, pe) {
    const Ie = (0, u.concatBytes)((0, u.setLengthLeft)(le, 32), (0, u.setLengthLeft)(ge, 32)), be = m(F, pe);
    if (!b(be))
      throw new Error("Invalid signature v value");
    return A.secp256k1.Signature.fromCompact(Ie).addRecoveryBit(Number(be)).recoverPublicKey(M).toRawBytes(!1).slice(1);
  };
  signature$1.ecrecover = k;
  const C = function(M, F, le, ge) {
    const pe = m(M, ge);
    if (!b(pe))
      throw new Error("Invalid signature v value");
    return (0, u.bytesToHex)((0, u.concatBytes)((0, u.setLengthLeft)(F, 32), (0, u.setLengthLeft)(le, 32), (0, u.toBytes)(M)));
  };
  signature$1.toRpcSig = C;
  const B = function(M, F, le, ge) {
    const pe = m(M, ge);
    if (!b(pe))
      throw new Error("Invalid signature v value");
    const Ie = Uint8Array.from([...le]);
    return (M > BigInt(28) && M % p.BIGINT_2 === p.BIGINT_1 || M === p.BIGINT_1 || M === BigInt(28)) && (Ie[0] |= 128), (0, u.bytesToHex)((0, u.concatBytes)((0, u.setLengthLeft)(F, 32), (0, u.setLengthLeft)(Ie, 32)));
  };
  signature$1.toCompactSig = B;
  const Q = function(M) {
    const F = (0, u.toBytes)(M);
    let le, ge, pe;
    if (F.length >= 65)
      le = F.subarray(0, 32), ge = F.subarray(32, 64), pe = (0, u.bytesToBigInt)(F.subarray(64));
    else if (F.length === 64)
      le = F.subarray(0, 32), ge = F.subarray(32, 64), pe = BigInt((0, u.bytesToInt)(F.subarray(32, 33)) >> 7), ge[0] &= 127;
    else
      throw new Error("Invalid signature length");
    return pe < 27 && (pe = pe + p.BIGINT_27), {
      v: pe,
      r: le,
      s: ge
    };
  };
  signature$1.fromRpcSig = Q;
  const P = function(M, F, le, ge = !0, pe) {
    if (F.length !== 32 || le.length !== 32 || !b(m(M, pe)))
      return !1;
    const Ie = (0, u.bytesToBigInt)(F), be = (0, u.bytesToBigInt)(le);
    return !(Ie === p.BIGINT_0 || Ie >= p.SECP256K1_ORDER || be === p.BIGINT_0 || be >= p.SECP256K1_ORDER || ge && be >= p.SECP256K1_ORDER_DIV_2);
  };
  signature$1.isValidSignature = P;
  const x = function(M) {
    (0, t.assertIsBytes)(M);
    const F = (0, u.utf8ToBytes)(`Ethereum Signed Message:
${M.length}`);
    return (0, s.keccak256)((0, u.concatBytes)(F, M));
  };
  return signature$1.hashPersonalMessage = x, signature$1;
}
var asyncEventEmitter = {}, hasRequiredAsyncEventEmitter;
function requireAsyncEventEmitter() {
  if (hasRequiredAsyncEventEmitter) return asyncEventEmitter;
  hasRequiredAsyncEventEmitter = 1, Object.defineProperty(asyncEventEmitter, "__esModule", { value: !0 }), asyncEventEmitter.AsyncEventEmitter = void 0;
  const s = requireEvents();
  async function A(p, t, l) {
    let m;
    for await (const b of t)
      try {
        b.length < 2 ? b.call(p, l) : await new Promise((k, C) => {
          b.call(p, l, (B) => {
            B ? C(B) : k();
          });
        });
      } catch (k) {
        m = k;
      }
    if (m)
      throw m;
  }
  class u extends s.EventEmitter {
    emit(t, ...l) {
      let [m, b] = l;
      const k = this;
      let C = k._events[t] ?? [];
      return b === void 0 && typeof m == "function" && (b = m, m = void 0), (t === "newListener" || t === "removeListener") && (m = {
        event: m,
        fn: b
      }, b = void 0), C = Array.isArray(C) ? C : [C], A(k, C.slice(), m).then(b).catch(b), k.listenerCount(t) > 0;
    }
    once(t, l) {
      const m = this;
      let b;
      if (typeof l != "function")
        throw new TypeError("listener must be a function");
      return l.length >= 2 ? b = function(k, C) {
        m.removeListener(t, b), l(k, C);
      } : b = function(k) {
        m.removeListener(t, b), l(k, b);
      }, m.on(t, b), m;
    }
    first(t, l) {
      let m = this._events[t] ?? [];
      if (typeof l != "function")
        throw new TypeError("listener must be a function");
      return Array.isArray(m) || (this._events[t] = m = [m]), m.unshift(l), this;
    }
    before(t, l, m) {
      return this.beforeOrAfter(t, l, m);
    }
    after(t, l, m) {
      return this.beforeOrAfter(t, l, m, "after");
    }
    beforeOrAfter(t, l, m, b) {
      let k = this._events[t] ?? [], C, B;
      const Q = b === "after" ? 1 : 0;
      if (typeof m != "function")
        throw new TypeError("listener must be a function");
      if (typeof l != "function")
        throw new TypeError("target must be a function");
      for (Array.isArray(k) || (this._events[t] = k = [k]), B = k.length, C = k.length; C--; )
        if (k[C] === l) {
          B = C + Q;
          break;
        }
      return k.splice(B, 0, m), this;
    }
    on(t, l) {
      return super.on(t, l);
    }
    addListener(t, l) {
      return super.addListener(t, l);
    }
    prependListener(t, l) {
      return super.prependListener(t, l);
    }
    prependOnceListener(t, l) {
      return super.prependOnceListener(t, l);
    }
    removeAllListeners(t) {
      return super.removeAllListeners(t);
    }
    removeListener(t, l) {
      return super.removeListener(t, l);
    }
    eventNames() {
      return super.eventNames();
    }
    listeners(t) {
      return super.listeners(t);
    }
    listenerCount(t) {
      return super.listenerCount(t);
    }
    getMaxListeners() {
      return super.getMaxListeners();
    }
    setMaxListeners(t) {
      return super.setMaxListeners(t);
    }
  }
  return asyncEventEmitter.AsyncEventEmitter = u, asyncEventEmitter;
}
var blobs = {}, sha256$6 = {}, hasRequiredSha256$1;
function requireSha256$1() {
  if (hasRequiredSha256$1) return sha256$6;
  hasRequiredSha256$1 = 1, Object.defineProperty(sha256$6, "__esModule", { value: !0 }), sha256$6.sha256 = void 0;
  const s = /* @__PURE__ */ requireSha256$2(), A = /* @__PURE__ */ requireUtils$5();
  return sha256$6.sha256 = (0, A.wrapHash)(s.sha256), sha256$6;
}
var hasRequiredBlobs;
function requireBlobs() {
  return hasRequiredBlobs || (hasRequiredBlobs = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.commitmentsToVersionedHashes = s.computeVersionedHash = s.blobsToProofs = s.blobsToCommitments = s.getBlobs = void 0;
    const A = /* @__PURE__ */ requireSha256$1(), u = requireBytes$1(), p = 32, t = 4096, l = 32 * t, b = l * 2 - 1, k = p * t;
    function C(le, ge) {
      const pe = new Uint8Array(ge * l).fill(0);
      return pe.set(le), pe[le.byteLength] = 128, pe;
    }
    function B(le) {
      const ge = new Uint8Array(k);
      for (let pe = 0; pe < t; pe++) {
        const Ie = new Uint8Array(32);
        Ie.set(le.subarray(pe * 31, (pe + 1) * 31), 0), ge.set(Ie, pe * 32);
      }
      return ge;
    }
    const Q = (le) => {
      const ge = (0, u.utf8ToBytes)(le), pe = ge.byteLength;
      if (pe === 0)
        throw Error("invalid blob data");
      if (pe > b)
        throw Error("blob data is too large");
      const Ie = Math.ceil(pe / l), be = C(ge, Ie), Pe = [];
      for (let Te = 0; Te < Ie; Te++) {
        const Qe = be.subarray(Te * l, (Te + 1) * l), xe = B(Qe);
        Pe.push(xe);
      }
      return Pe;
    };
    s.getBlobs = Q;
    const P = (le, ge) => {
      const pe = [];
      for (const Ie of ge)
        pe.push(le.blobToKzgCommitment(Ie));
      return pe;
    };
    s.blobsToCommitments = P;
    const x = (le, ge, pe) => ge.map((be, Pe) => le.computeBlobKzgProof(be, pe[Pe]));
    s.blobsToProofs = x;
    const M = (le, ge) => {
      const pe = new Uint8Array(32);
      return pe.set([ge], 0), pe.set((0, A.sha256)(le).subarray(1), 1), pe;
    };
    s.computeVersionedHash = M;
    const F = (le) => {
      const ge = [];
      for (const pe of le)
        ge.push((0, s.computeVersionedHash)(pe, 1));
      return ge;
    };
    s.commitmentsToVersionedHashes = F;
  }(blobs)), blobs;
}
var genesis = {}, hasRequiredGenesis;
function requireGenesis() {
  if (hasRequiredGenesis) return genesis;
  hasRequiredGenesis = 1, Object.defineProperty(genesis, "__esModule", { value: !0 }), genesis.parseGethGenesisState = void 0;
  const s = requireBytes$1(), A = requireInternal();
  function u(p) {
    const t = {};
    for (const l of Object.keys(p.alloc)) {
      let { balance: m, code: b, storage: k, nonce: C } = p.alloc[l];
      const B = (0, s.addHexPrefix)(l.toLowerCase());
      m = (0, A.isHexString)(m) ? m : (0, s.bigIntToHex)(BigInt(m)), b = b !== void 0 ? (0, s.addHexPrefix)(b) : void 0, k = k !== void 0 ? Object.entries(k) : void 0, C = C !== void 0 ? (0, s.addHexPrefix)(C) : void 0, t[B] = [m, b, k, C];
    }
    return t;
  }
  return genesis.parseGethGenesisState = u, genesis;
}
var kzg = {}, hasRequiredKzg;
function requireKzg() {
  if (hasRequiredKzg) return kzg;
  hasRequiredKzg = 1, Object.defineProperty(kzg, "__esModule", { value: !0 }), kzg.initKZG = void 0;
  function s(A, u) {
    A.loadTrustedSetup();
  }
  return kzg.initKZG = s, kzg;
}
var lock = {}, hasRequiredLock;
function requireLock() {
  if (hasRequiredLock) return lock;
  hasRequiredLock = 1, Object.defineProperty(lock, "__esModule", { value: !0 }), lock.Lock = void 0;
  class s {
    constructor() {
      this.permits = 1, this.promiseResolverQueue = [];
    }
    /**
     * Returns a promise used to wait for a permit to become available. This method should be awaited on.
     * @returns  A promise that gets resolved when execution is allowed to proceed.
     */
    async acquire() {
      return this.permits > 0 ? (this.permits -= 1, Promise.resolve(!0)) : new Promise((u) => this.promiseResolverQueue.push(u));
    }
    /**
     * Increases the number of permits by one. If there are other functions waiting, one of them will
     * continue to execute in a future iteration of the event loop.
     */
    release() {
      if (this.permits += 1, this.permits > 1 && this.promiseResolverQueue.length > 0)
        console.warn("Lock.permits should never be > 0 when there is someone waiting.");
      else if (this.permits === 1 && this.promiseResolverQueue.length > 0) {
        this.permits -= 1;
        const u = this.promiseResolverQueue.shift();
        u && u(!0);
      }
    }
  }
  return lock.Lock = s, lock;
}
var mapDB = {}, hasRequiredMapDB;
function requireMapDB() {
  if (hasRequiredMapDB) return mapDB;
  hasRequiredMapDB = 1, Object.defineProperty(mapDB, "__esModule", { value: !0 }), mapDB.MapDB = void 0;
  const s = requireBytes$1();
  class A {
    constructor(p) {
      this._database = p ?? /* @__PURE__ */ new Map();
    }
    async get(p) {
      const t = p instanceof Uint8Array ? (0, s.bytesToUnprefixedHex)(p) : p.toString();
      return this._database.get(t);
    }
    async put(p, t) {
      const l = p instanceof Uint8Array ? (0, s.bytesToUnprefixedHex)(p) : p.toString();
      this._database.set(l, t);
    }
    async del(p) {
      const t = p instanceof Uint8Array ? (0, s.bytesToUnprefixedHex)(p) : p.toString();
      this._database.delete(t);
    }
    async batch(p) {
      for (const t of p)
        t.type === "del" && await this.del(t.key), t.type === "put" && await this.put(t.key, t.value);
    }
    /**
     * Note that the returned shallow copy will share the underlying database with the original
     *
     * @returns DB
     */
    shallowCopy() {
      return new A(this._database);
    }
    open() {
      return Promise.resolve();
    }
  }
  return mapDB.MapDB = A, mapDB;
}
var provider = {}, hasRequiredProvider;
function requireProvider() {
  if (hasRequiredProvider) return provider;
  hasRequiredProvider = 1, Object.defineProperty(provider, "__esModule", { value: !0 }), provider.getProvider = provider.fetchFromProvider = void 0;
  const s = async (u, p) => {
    const t = JSON.stringify({
      method: p.method,
      params: p.params,
      jsonrpc: "2.0",
      id: 1
    }), l = await fetch(u, {
      headers: {
        "content-type": "application/json"
      },
      method: "POST",
      body: t
    });
    if (!l.ok)
      throw new Error(`JSONRpcError: ${JSON.stringify({
        method: p.method,
        status: l.status,
        message: await l.text().catch(() => "Could not parse error message likely because of a network error")
      }, null, 2)}`);
    return (await l.json()).result;
  };
  provider.fetchFromProvider = s;
  const A = (u) => {
    if (typeof u == "string")
      return u;
    if (typeof u == "object" && u._getConnection !== void 0)
      return u._getConnection().url;
    throw new Error("Must provide valid provider URL or Web3Provider");
  };
  return provider.getProvider = A, provider;
}
var requests = {}, hasRequiredRequests;
function requireRequests() {
  return hasRequiredRequests || (hasRequiredRequests = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.CLRequestFactory = s.ConsolidationRequest = s.WithdrawalRequest = s.DepositRequest = s.CLRequest = s.CLRequestType = void 0;
    const A = requireCjs$5(), u = /* @__PURE__ */ requireUtils$5(), p = requireBytes$1(), t = requireConstants$4();
    var l;
    (function(Q) {
      Q[Q.Deposit = 0] = "Deposit", Q[Q.Withdrawal = 1] = "Withdrawal", Q[Q.Consolidation = 2] = "Consolidation";
    })(l = s.CLRequestType || (s.CLRequestType = {}));
    class m {
      constructor(P) {
        this.type = P;
      }
    }
    s.CLRequest = m;
    class b extends m {
      constructor(P, x, M, F, le) {
        super(l.Deposit), this.pubkey = P, this.withdrawalCredentials = x, this.amount = M, this.signature = F, this.index = le;
      }
      static fromRequestData(P) {
        const { pubkey: x, withdrawalCredentials: M, amount: F, signature: le, index: ge } = P;
        return new b(x, M, F, le, ge);
      }
      static fromJSON(P) {
        const { pubkey: x, withdrawalCredentials: M, amount: F, signature: le, index: ge } = P;
        return this.fromRequestData({
          pubkey: (0, p.hexToBytes)(x),
          withdrawalCredentials: (0, p.hexToBytes)(M),
          amount: (0, p.hexToBigInt)(F),
          signature: (0, p.hexToBytes)(le),
          index: (0, p.hexToBigInt)(ge)
        });
      }
      serialize() {
        const P = this.index === t.BIGINT_0 ? new Uint8Array() : (0, p.bigIntToBytes)(this.index), x = this.amount === t.BIGINT_0 ? new Uint8Array() : (0, p.bigIntToBytes)(this.amount);
        return (0, u.concatBytes)(Uint8Array.from([this.type]), A.RLP.encode([this.pubkey, this.withdrawalCredentials, x, this.signature, P]));
      }
      toJSON() {
        return {
          pubkey: (0, p.bytesToHex)(this.pubkey),
          withdrawalCredentials: (0, p.bytesToHex)(this.withdrawalCredentials),
          amount: (0, p.bigIntToHex)(this.amount),
          signature: (0, p.bytesToHex)(this.signature),
          index: (0, p.bigIntToHex)(this.index)
        };
      }
      static deserialize(P) {
        const [x, M, F, le, ge] = A.RLP.decode(P.slice(1));
        return this.fromRequestData({
          pubkey: x,
          withdrawalCredentials: M,
          amount: (0, p.bytesToBigInt)(F),
          signature: le,
          index: (0, p.bytesToBigInt)(ge)
        });
      }
    }
    s.DepositRequest = b;
    class k extends m {
      constructor(P, x, M) {
        super(l.Withdrawal), this.sourceAddress = P, this.validatorPubkey = x, this.amount = M;
      }
      static fromRequestData(P) {
        const { sourceAddress: x, validatorPubkey: M, amount: F } = P;
        return new k(x, M, F);
      }
      static fromJSON(P) {
        const { sourceAddress: x, validatorPubkey: M, amount: F } = P;
        return this.fromRequestData({
          sourceAddress: (0, p.hexToBytes)(x),
          validatorPubkey: (0, p.hexToBytes)(M),
          amount: (0, p.hexToBigInt)(F)
        });
      }
      serialize() {
        const P = this.amount === t.BIGINT_0 ? new Uint8Array() : (0, p.bigIntToBytes)(this.amount);
        return (0, u.concatBytes)(Uint8Array.from([this.type]), A.RLP.encode([this.sourceAddress, this.validatorPubkey, P]));
      }
      toJSON() {
        return {
          sourceAddress: (0, p.bytesToHex)(this.sourceAddress),
          validatorPubkey: (0, p.bytesToHex)(this.validatorPubkey),
          amount: (0, p.bigIntToHex)(this.amount)
        };
      }
      static deserialize(P) {
        const [x, M, F] = A.RLP.decode(P.slice(1));
        return this.fromRequestData({
          sourceAddress: x,
          validatorPubkey: M,
          amount: (0, p.bytesToBigInt)(F)
        });
      }
    }
    s.WithdrawalRequest = k;
    class C extends m {
      constructor(P, x, M) {
        super(l.Consolidation), this.sourceAddress = P, this.sourcePubkey = x, this.targetPubkey = M;
      }
      static fromRequestData(P) {
        const { sourceAddress: x, sourcePubkey: M, targetPubkey: F } = P;
        return new C(x, M, F);
      }
      static fromJSON(P) {
        const { sourceAddress: x, sourcePubkey: M, targetPubkey: F } = P;
        return this.fromRequestData({
          sourceAddress: (0, p.hexToBytes)(x),
          sourcePubkey: (0, p.hexToBytes)(M),
          targetPubkey: (0, p.hexToBytes)(F)
        });
      }
      serialize() {
        return (0, u.concatBytes)(Uint8Array.from([this.type]), A.RLP.encode([this.sourceAddress, this.sourcePubkey, this.targetPubkey]));
      }
      toJSON() {
        return {
          sourceAddress: (0, p.bytesToHex)(this.sourceAddress),
          sourcePubkey: (0, p.bytesToHex)(this.sourcePubkey),
          targetPubkey: (0, p.bytesToHex)(this.targetPubkey)
        };
      }
      static deserialize(P) {
        const [x, M, F] = A.RLP.decode(P.slice(1));
        return this.fromRequestData({
          sourceAddress: x,
          sourcePubkey: M,
          targetPubkey: F
        });
      }
    }
    s.ConsolidationRequest = C;
    class B {
      static fromSerializedRequest(P) {
        switch (P[0]) {
          case l.Deposit:
            return b.deserialize(P);
          case l.Withdrawal:
            return k.deserialize(P);
          case l.Consolidation:
            return C.deserialize(P);
          default:
            throw Error(`Invalid request type=${P[0]}`);
        }
      }
    }
    s.CLRequestFactory = B;
  }(requests)), requests;
}
var verkle = {}, hasRequiredVerkle;
function requireVerkle() {
  return hasRequiredVerkle || (hasRequiredVerkle = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.getVerkleTreeKeyForStorageSlot = s.chunkifyCode = s.getVerkleTreeKeyForCodeChunk = s.getVerkleTreeIndicesForCodeChunk = s.getVerkleTreeIndexesForStorageSlot = s.getVerkleKey = s.VERKLE_MAIN_STORAGE_OFFSET = s.VERKLE_NODE_WIDTH = s.VERKLE_CODE_OFFSET = s.VERKLE_HEADER_STORAGE_OFFSET = s.VERKLE_CODE_SIZE_LEAF_KEY = s.VERKLE_CODE_HASH_LEAF_KEY = s.VERKLE_NONCE_LEAF_KEY = s.VERKLE_BALANCE_LEAF_KEY = s.VERKLE_VERSION_LEAF_KEY = s.VerkleLeafType = s.verifyVerkleProof = s.getVerkleStem = void 0;
    const A = requireBytes$1();
    function u(Q, P, x = 0) {
      const M = (0, A.setLengthLeft)(P.toBytes(), 32);
      let F;
      return typeof x == "number" ? F = (0, A.setLengthRight)((0, A.int32ToBytes)(Number(x), !0), 32) : F = (0, A.setLengthRight)((0, A.bigIntToBytes)(BigInt(x), !0).slice(0, 32), 32), Q.getTreeKey(M, F, 0).slice(0, 31);
    }
    s.getVerkleStem = u;
    function p(Q, P, x) {
      return Q.verifyExecutionWitnessPreState((0, A.bytesToHex)(P), JSON.stringify(x));
    }
    s.verifyVerkleProof = p;
    var t;
    (function(Q) {
      Q[Q.Version = 0] = "Version", Q[Q.Balance = 1] = "Balance", Q[Q.Nonce = 2] = "Nonce", Q[Q.CodeHash = 3] = "CodeHash", Q[Q.CodeSize = 4] = "CodeSize";
    })(t = s.VerkleLeafType || (s.VerkleLeafType = {})), s.VERKLE_VERSION_LEAF_KEY = (0, A.intToBytes)(t.Version), s.VERKLE_BALANCE_LEAF_KEY = (0, A.intToBytes)(t.Balance), s.VERKLE_NONCE_LEAF_KEY = (0, A.intToBytes)(t.Nonce), s.VERKLE_CODE_HASH_LEAF_KEY = (0, A.intToBytes)(t.CodeHash), s.VERKLE_CODE_SIZE_LEAF_KEY = (0, A.intToBytes)(t.CodeSize), s.VERKLE_HEADER_STORAGE_OFFSET = 64, s.VERKLE_CODE_OFFSET = 128, s.VERKLE_NODE_WIDTH = 256, s.VERKLE_MAIN_STORAGE_OFFSET = BigInt(256) ** BigInt(31);
    const l = (Q, P) => {
      switch (P) {
        case t.Version:
          return (0, A.concatBytes)(Q, s.VERKLE_VERSION_LEAF_KEY);
        case t.Balance:
          return (0, A.concatBytes)(Q, s.VERKLE_BALANCE_LEAF_KEY);
        case t.Nonce:
          return (0, A.concatBytes)(Q, s.VERKLE_NONCE_LEAF_KEY);
        case t.CodeHash:
          return (0, A.concatBytes)(Q, s.VERKLE_CODE_HASH_LEAF_KEY);
        case t.CodeSize:
          return (0, A.concatBytes)(Q, s.VERKLE_CODE_SIZE_LEAF_KEY);
        default:
          return (0, A.concatBytes)(Q, P);
      }
    };
    s.getVerkleKey = l;
    function m(Q) {
      let P;
      Q < s.VERKLE_CODE_OFFSET - s.VERKLE_HEADER_STORAGE_OFFSET ? P = BigInt(s.VERKLE_HEADER_STORAGE_OFFSET) + Q : P = s.VERKLE_MAIN_STORAGE_OFFSET + Q;
      const x = P / BigInt(s.VERKLE_NODE_WIDTH), M = Number(P % BigInt(s.VERKLE_NODE_WIDTH));
      return { treeIndex: x, subIndex: M };
    }
    s.getVerkleTreeIndexesForStorageSlot = m;
    function b(Q) {
      const P = Math.floor((s.VERKLE_CODE_OFFSET + Q) / s.VERKLE_NODE_WIDTH), x = (s.VERKLE_CODE_OFFSET + Q) % s.VERKLE_NODE_WIDTH;
      return { treeIndex: P, subIndex: x };
    }
    s.getVerkleTreeIndicesForCodeChunk = b;
    const k = async (Q, P, x) => {
      const { treeIndex: M, subIndex: F } = b(P);
      return (0, A.concatBytes)(u(x, Q, M), (0, A.toBytes)(F));
    };
    s.getVerkleTreeKeyForCodeChunk = k;
    const C = (Q) => {
      if (Q.length % 31 !== 0) {
        const P = 31 - Q.length % 31;
        Q = (0, A.setLengthRight)(Q, Q.length + P);
      }
      throw new Error("Not implemented");
    };
    s.chunkifyCode = C;
    const B = async (Q, P, x) => {
      const { treeIndex: M, subIndex: F } = m(P);
      return (0, A.concatBytes)(u(x, Q, M), (0, A.toBytes)(F));
    };
    s.getVerkleTreeKeyForStorageSlot = B;
  }(verkle)), verkle;
}
var hasRequiredCjs$4;
function requireCjs$4() {
  return hasRequiredCjs$4 || (hasRequiredCjs$4 = 1, function(s) {
    var A = cjs$5 && cjs$5.__createBinding || (Object.create ? function(t, l, m, b) {
      b === void 0 && (b = m);
      var k = Object.getOwnPropertyDescriptor(l, m);
      (!k || ("get" in k ? !l.__esModule : k.writable || k.configurable)) && (k = { enumerable: !0, get: function() {
        return l[m];
      } }), Object.defineProperty(t, b, k);
    } : function(t, l, m, b) {
      b === void 0 && (b = m), t[b] = l[m];
    }), u = cjs$5 && cjs$5.__exportStar || function(t, l) {
      for (var m in t) m !== "default" && !Object.prototype.hasOwnProperty.call(l, m) && A(l, t, m);
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), s.toAscii = s.stripHexPrefix = s.padToEven = s.isHexString = s.getKeys = s.getBinarySize = s.fromUtf8 = s.fromAscii = s.arrayContainsArray = void 0, u(requireConstants$4(), s), u(requireUnits(), s), u(requireAccount$2(), s), u(requireAddress(), s), u(requireDb(), s), u(requireWithdrawal(), s), u(requireSignature$1(), s), u(requireBytes$1(), s), u(requireTypes$5(), s), u(requireAsyncEventEmitter(), s), u(requireBlobs(), s), u(requireGenesis(), s);
    var p = requireInternal();
    Object.defineProperty(s, "arrayContainsArray", { enumerable: !0, get: function() {
      return p.arrayContainsArray;
    } }), Object.defineProperty(s, "fromAscii", { enumerable: !0, get: function() {
      return p.fromAscii;
    } }), Object.defineProperty(s, "fromUtf8", { enumerable: !0, get: function() {
      return p.fromUtf8;
    } }), Object.defineProperty(s, "getBinarySize", { enumerable: !0, get: function() {
      return p.getBinarySize;
    } }), Object.defineProperty(s, "getKeys", { enumerable: !0, get: function() {
      return p.getKeys;
    } }), Object.defineProperty(s, "isHexString", { enumerable: !0, get: function() {
      return p.isHexString;
    } }), Object.defineProperty(s, "padToEven", { enumerable: !0, get: function() {
      return p.padToEven;
    } }), Object.defineProperty(s, "stripHexPrefix", { enumerable: !0, get: function() {
      return p.stripHexPrefix;
    } }), Object.defineProperty(s, "toAscii", { enumerable: !0, get: function() {
      return p.toAscii;
    } }), u(requireKzg(), s), u(requireLock(), s), u(requireMapDB(), s), u(requireProvider(), s), u(requireRequests(), s), u(requireVerkle(), s);
  }(cjs$5)), cjs$5;
}
var hasRequiredBcUrRegistryEth_cjs_production_min;
function requireBcUrRegistryEth_cjs_production_min() {
  return hasRequiredBcUrRegistryEth_cjs_production_min || (hasRequiredBcUrRegistryEth_cjs_production_min = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A, u = requireDist$i(), p = require$$1$2, t = (A = requireHdkey()) && typeof A == "object" && "default" in A ? A.default : A, l = requireCjs$4();
    const m = { ETH_SIGN_REQUEST: new u.RegistryType("eth-sign-request", 401), ETH_SIGNATURE: new u.RegistryType("eth-signature", 402), ETH_NFT_ITEM: new u.RegistryType("eth-nft-item", 403) }, { decodeToDataItem: b, RegistryTypes: k } = u.extend;
    var C, B;
    (function(be) {
      be[be.requestId = 1] = "requestId", be[be.signData = 2] = "signData", be[be.dataType = 3] = "dataType", be[be.chainId = 4] = "chainId", be[be.derivationPath = 5] = "derivationPath", be[be.address = 6] = "address", be[be.origin = 7] = "origin";
    })(C || (C = {})), (B = s.DataType || (s.DataType = {}))[B.transaction = 1] = "transaction", B[B.typedData = 2] = "typedData", B[B.personalMessage = 3] = "personalMessage", B[B.typedTransaction = 4] = "typedTransaction";
    class Q extends u.RegistryItem {
      constructor(Pe) {
        super(), this.getRegistryType = () => m.ETH_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataType = () => this.dataType, this.getChainId = () => this.chainId, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSourceFingerprint = () => this.derivationPath.getSourceFingerprint(), this.getSignRequestAddress = () => this.address, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Te = {};
          this.requestId && (Te[C.requestId] = new u.DataItem(this.requestId, k.UUID.getTag())), this.address && (Te[C.address] = this.address), this.chainId && (Te[C.chainId] = Number(this.chainId)), this.origin && (Te[C.origin] = this.origin), Te[C.signData] = this.signData, Te[C.dataType] = this.dataType;
          const Qe = this.derivationPath.toDataItem();
          return Qe.setTag(this.derivationPath.getRegistryType().getTag()), Te[C.derivationPath] = Qe, new u.DataItem(Te);
        }, this.requestId = Pe.requestId, this.signData = Pe.signData, this.dataType = Pe.dataType, this.chainId = Pe.chainId, this.derivationPath = Pe.derivationPath, this.address = Pe.address, this.origin = Pe.origin;
      }
      static constructETHRequest(Pe, Te, Qe, xe, Ee, He, ve, we) {
        const Ce = Qe.replace(/[m|M]\//, "").split("/"), Se = new u.CryptoKeypath(Ce.map((Ne) => {
          const rr = parseInt(Ne.replace("'", ""));
          let er = !1;
          return Ne.endsWith("'") && (er = !0), new u.PathComponent({ index: rr, hardened: er });
        }), Buffer.from(xe, "hex"));
        return new Q({ requestId: Ee ? Buffer.from(p.parse(Ee)) : void 0, signData: Pe, dataType: Te, derivationPath: Se, chainId: He, address: ve ? Buffer.from(ve.replace("0x", ""), "hex") : void 0, origin: we || void 0 });
      }
    }
    Q.fromDataItem = (be) => {
      const Pe = be.getData(), Te = Pe[C.signData], Qe = Pe[C.dataType], xe = u.CryptoKeypath.fromDataItem(Pe[C.derivationPath]), Ee = Pe[C.chainId] ? Pe[C.chainId] : void 0, He = Pe[C.address] ? Pe[C.address] : void 0, ve = Pe[C.requestId] ? Pe[C.requestId].getData() : void 0;
      return new Q({ requestId: ve, signData: Te, dataType: Qe, chainId: Ee, derivationPath: xe, address: He, origin: Pe[C.origin] ? Pe[C.origin] : void 0 });
    }, Q.fromCBOR = (be) => {
      const Pe = b(be);
      return Q.fromDataItem(Pe);
    };
    const { RegistryTypes: P, decodeToDataItem: x } = u.extend;
    var M;
    (function(be) {
      be[be.requestId = 1] = "requestId", be[be.signature = 2] = "signature", be[be.origin = 3] = "origin";
    })(M || (M = {}));
    class F extends u.RegistryItem {
      constructor(Pe, Te, Qe) {
        super(), this.getRegistryType = () => m.ETH_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const xe = {};
          return this.requestId && (xe[M.requestId] = new u.DataItem(this.requestId, P.UUID.getTag())), this.origin && (xe[M.origin] = this.origin), xe[M.signature] = this.signature, new u.DataItem(xe);
        }, this.signature = Pe, this.requestId = Te, this.origin = Qe;
      }
    }
    F.fromDataItem = (be) => {
      const Pe = be.getData(), Te = Pe[M.signature], Qe = Pe[M.requestId] ? Pe[M.requestId].getData() : void 0;
      return new F(Te, Qe, Pe[M.origin]);
    }, F.fromCBOR = (be) => {
      const Pe = x(be);
      return F.fromDataItem(Pe);
    };
    const { decodeToDataItem: le } = u.extend;
    var ge;
    (function(be) {
      be[be.chainId = 1] = "chainId", be[be.contractAddress = 2] = "contractAddress", be[be.contractName = 3] = "contractName", be[be.name = 4] = "name", be[be.mediaData = 5] = "mediaData";
    })(ge || (ge = {}));
    class pe extends u.RegistryItem {
      constructor(Pe) {
        super(), this.getRegistryType = () => m.ETH_NFT_ITEM, this.getChainId = () => this.chainId, this.getName = () => this.name, this.getmediaData = () => this.mediaData, this.getContractAddress = () => this.contractAddress, this.getContractName = () => this.contractName, this.toDataItem = () => {
          const Te = {};
          return Te[ge.chainId] = this.chainId, Te[ge.name] = this.name, Te[ge.contractAddress] = this.contractAddress, Te[ge.contractName] = this.contractName, Te[ge.mediaData] = this.mediaData, new u.DataItem(Te);
        }, this.chainId = Pe.chainId, this.name = Pe.name, this.contractAddress = Pe.contractAddress, this.contractName = Pe.contractName, this.mediaData = Pe.mediaData;
      }
      static constructETHNFTItem(Pe, Te, Qe, xe, Ee) {
        return new pe({ chainId: Pe, contractAddress: Te, contractName: Qe, mediaData: Ee, name: xe });
      }
    }
    pe.fromDataItem = (be) => {
      const Pe = be.getData();
      return new pe({ chainId: Pe[ge.chainId], name: Pe[ge.name], contractAddress: Pe[ge.contractAddress], contractName: Pe[ge.contractName], mediaData: Pe[ge.mediaData] });
    }, pe.fromCBOR = (be) => {
      const Pe = le(be);
      return pe.fromDataItem(Pe);
    };
    const Ie = (be, Pe) => {
      const Te = t.fromExtendedKey(be).derive(Pe), Qe = "0x" + Buffer.from(l.publicToAddress(Te.publicKey, !0)).toString("hex");
      return l.toChecksumAddress(Qe);
    };
    u.patchTags(Object.values(m).filter((be) => !!be.getTag()).map((be) => be.getTag())), Object.keys(u).forEach(function(be) {
      be !== "default" && Object.defineProperty(s, be, { enumerable: !0, get: function() {
        return u[be];
      } });
    }), s.ETHNFTItem = pe, s.ETHSignature = F, s.EthSignRequest = Q, s.findHDPathFromAddress = (be, Pe, Te, Qe) => {
      for (let xe = 0; xe < Te; xe++) {
        const Ee = Ie(Pe, "M/0/" + xe);
        if (be.toLowerCase() == Ee.toLowerCase()) return `${Qe}/0/${xe}`;
      }
      return null;
    }, s.generateAddressFromXpub = Ie;
  }(bcUrRegistryEth_cjs_production_min)), bcUrRegistryEth_cjs_production_min;
}
var bcUrRegistryEth_cjs_development = {}, hasRequiredBcUrRegistryEth_cjs_development;
function requireBcUrRegistryEth_cjs_development() {
  return hasRequiredBcUrRegistryEth_cjs_development || (hasRequiredBcUrRegistryEth_cjs_development = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    function A(be) {
      return be && typeof be == "object" && "default" in be ? be.default : be;
    }
    var u = requireDist$i(), p = require$$1$2, t = A(requireHdkey()), l = requireCjs$4();
    const m = {
      ETH_SIGN_REQUEST: /* @__PURE__ */ new u.RegistryType("eth-sign-request", 401),
      ETH_SIGNATURE: /* @__PURE__ */ new u.RegistryType("eth-signature", 402),
      ETH_NFT_ITEM: /* @__PURE__ */ new u.RegistryType("eth-nft-item", 403)
    }, {
      decodeToDataItem: b,
      RegistryTypes: k
    } = u.extend;
    var C;
    (function(be) {
      be[be.requestId = 1] = "requestId", be[be.signData = 2] = "signData", be[be.dataType = 3] = "dataType", be[be.chainId = 4] = "chainId", be[be.derivationPath = 5] = "derivationPath", be[be.address = 6] = "address", be[be.origin = 7] = "origin";
    })(C || (C = {})), function(be) {
      be[be.transaction = 1] = "transaction", be[be.typedData = 2] = "typedData", be[be.personalMessage = 3] = "personalMessage", be[be.typedTransaction = 4] = "typedTransaction";
    }(s.DataType || (s.DataType = {}));
    class B extends u.RegistryItem {
      constructor(Pe) {
        super(), this.getRegistryType = () => m.ETH_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataType = () => this.dataType, this.getChainId = () => this.chainId, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSourceFingerprint = () => this.derivationPath.getSourceFingerprint(), this.getSignRequestAddress = () => this.address, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Te = {};
          this.requestId && (Te[C.requestId] = new u.DataItem(this.requestId, k.UUID.getTag())), this.address && (Te[C.address] = this.address), this.chainId && (Te[C.chainId] = Number(this.chainId)), this.origin && (Te[C.origin] = this.origin), Te[C.signData] = this.signData, Te[C.dataType] = this.dataType;
          const Qe = this.derivationPath.toDataItem();
          return Qe.setTag(this.derivationPath.getRegistryType().getTag()), Te[C.derivationPath] = Qe, new u.DataItem(Te);
        }, this.requestId = Pe.requestId, this.signData = Pe.signData, this.dataType = Pe.dataType, this.chainId = Pe.chainId, this.derivationPath = Pe.derivationPath, this.address = Pe.address, this.origin = Pe.origin;
      }
      static constructETHRequest(Pe, Te, Qe, xe, Ee, He, ve, we) {
        const Ce = Qe.replace(/[m|M]\//, "").split("/"), Se = new u.CryptoKeypath(Ce.map((Ne) => {
          const rr = parseInt(Ne.replace("'", ""));
          let er = !1;
          return Ne.endsWith("'") && (er = !0), new u.PathComponent({
            index: rr,
            hardened: er
          });
        }), Buffer.from(xe, "hex"));
        return new B({
          requestId: Ee ? Buffer.from(p.parse(Ee)) : void 0,
          signData: Pe,
          dataType: Te,
          derivationPath: Se,
          chainId: He,
          address: ve ? Buffer.from(ve.replace("0x", ""), "hex") : void 0,
          origin: we || void 0
        });
      }
    }
    B.fromDataItem = (be) => {
      const Pe = be.getData(), Te = Pe[C.signData], Qe = Pe[C.dataType], xe = u.CryptoKeypath.fromDataItem(Pe[C.derivationPath]), Ee = Pe[C.chainId] ? Pe[C.chainId] : void 0, He = Pe[C.address] ? Pe[C.address] : void 0, ve = Pe[C.requestId] ? Pe[C.requestId].getData() : void 0, we = Pe[C.origin] ? Pe[C.origin] : void 0;
      return new B({
        requestId: ve,
        signData: Te,
        dataType: Qe,
        chainId: Ee,
        derivationPath: xe,
        address: He,
        origin: we
      });
    }, B.fromCBOR = (be) => {
      const Pe = b(be);
      return B.fromDataItem(Pe);
    };
    const {
      RegistryTypes: Q,
      decodeToDataItem: P
    } = u.extend;
    var x;
    (function(be) {
      be[be.requestId = 1] = "requestId", be[be.signature = 2] = "signature", be[be.origin = 3] = "origin";
    })(x || (x = {}));
    class M extends u.RegistryItem {
      constructor(Pe, Te, Qe) {
        super(), this.getRegistryType = () => m.ETH_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const xe = {};
          return this.requestId && (xe[x.requestId] = new u.DataItem(this.requestId, Q.UUID.getTag())), this.origin && (xe[x.origin] = this.origin), xe[x.signature] = this.signature, new u.DataItem(xe);
        }, this.signature = Pe, this.requestId = Te, this.origin = Qe;
      }
    }
    M.fromDataItem = (be) => {
      const Pe = be.getData(), Te = Pe[x.signature], Qe = Pe[x.requestId] ? Pe[x.requestId].getData() : void 0;
      return new M(Te, Qe, Pe[x.origin]);
    }, M.fromCBOR = (be) => {
      const Pe = P(be);
      return M.fromDataItem(Pe);
    };
    const {
      decodeToDataItem: F
    } = u.extend;
    var le;
    (function(be) {
      be[be.chainId = 1] = "chainId", be[be.contractAddress = 2] = "contractAddress", be[be.contractName = 3] = "contractName", be[be.name = 4] = "name", be[be.mediaData = 5] = "mediaData";
    })(le || (le = {}));
    class ge extends u.RegistryItem {
      constructor(Pe) {
        super(), this.getRegistryType = () => m.ETH_NFT_ITEM, this.getChainId = () => this.chainId, this.getName = () => this.name, this.getmediaData = () => this.mediaData, this.getContractAddress = () => this.contractAddress, this.getContractName = () => this.contractName, this.toDataItem = () => {
          const Te = {};
          return Te[le.chainId] = this.chainId, Te[le.name] = this.name, Te[le.contractAddress] = this.contractAddress, Te[le.contractName] = this.contractName, Te[le.mediaData] = this.mediaData, new u.DataItem(Te);
        }, this.chainId = Pe.chainId, this.name = Pe.name, this.contractAddress = Pe.contractAddress, this.contractName = Pe.contractName, this.mediaData = Pe.mediaData;
      }
      static constructETHNFTItem(Pe, Te, Qe, xe, Ee) {
        return new ge({
          chainId: Pe,
          contractAddress: Te,
          contractName: Qe,
          mediaData: Ee,
          name: xe
        });
      }
    }
    ge.fromDataItem = (be) => {
      const Pe = be.getData(), Te = Pe[le.chainId], Qe = Pe[le.name], xe = Pe[le.mediaData], Ee = Pe[le.contractAddress], He = Pe[le.contractName];
      return new ge({
        chainId: Te,
        name: Qe,
        contractAddress: Ee,
        contractName: He,
        mediaData: xe
      });
    }, ge.fromCBOR = (be) => {
      const Pe = F(be);
      return ge.fromDataItem(Pe);
    };
    const pe = (be, Pe) => {
      const Qe = t.fromExtendedKey(be).derive(Pe), xe = "0x" + Buffer.from(l.publicToAddress(Qe.publicKey, !0)).toString("hex");
      return l.toChecksumAddress(xe);
    }, Ie = (be, Pe, Te, Qe) => {
      for (let xe = 0; xe < Te; xe++) {
        const Ee = `M/0/${xe}`, He = pe(Pe, Ee);
        if (be.toLowerCase() == He.toLowerCase())
          return `${Qe}/0/${xe}`;
      }
      return null;
    };
    u.patchTags(Object.values(m).filter((be) => !!be.getTag()).map((be) => be.getTag())), Object.keys(u).forEach(function(be) {
      be !== "default" && Object.defineProperty(s, be, {
        enumerable: !0,
        get: function() {
          return u[be];
        }
      });
    }), s.ETHNFTItem = ge, s.ETHSignature = M, s.EthSignRequest = B, s.findHDPathFromAddress = Ie, s.generateAddressFromXpub = pe;
  }(bcUrRegistryEth_cjs_development)), bcUrRegistryEth_cjs_development;
}
var hasRequiredDist$e;
function requireDist$e() {
  return hasRequiredDist$e || (hasRequiredDist$e = 1, process$1.env.NODE_ENV === "production" ? dist$d.exports = requireBcUrRegistryEth_cjs_production_min() : dist$d.exports = requireBcUrRegistryEth_cjs_development()), dist$d.exports;
}
var hasRequiredEthereum$2;
function requireEthereum$2() {
  if (hasRequiredEthereum$2) return ethereum$2;
  hasRequiredEthereum$2 = 1, Object.defineProperty(ethereum$2, "__esModule", { value: !0 }), ethereum$2.KeystoneEthereumSDK = void 0;
  const s = requireDist$e(), A = requireUtils$d(), u = requireUr();
  class p {
    constructor(l) {
      this.config = l;
    }
    parseSignature(l) {
      if (l.type !== u.URType.EthSignature)
        throw new Error("type not match");
      const m = s.ETHSignature.fromCBOR(l.cbor), b = m.getRequestId();
      return {
        requestId: b === void 0 ? void 0 : (0, A.uuidStringify)(b),
        signature: (0, A.toHex)(m.getSignature()),
        origin: m.getOrigin()
      };
    }
    generateSignRequest({ requestId: l, signData: m, dataType: b, path: k, xfp: C, chainId: B, address: Q, origin: P }) {
      var x;
      return new s.EthSignRequest({
        requestId: (0, A.uuidParse)(l),
        signData: (0, A.toBuffer)(m),
        dataType: b,
        derivationPath: new s.CryptoKeypath((0, A.parsePath)(k).map((M) => new s.PathComponent(M)), (0, A.toBuffer)(C)),
        chainId: B,
        address: Q !== void 0 ? (0, A.toBuffer)(Q) : void 0,
        origin: P ?? ((x = this.config) === null || x === void 0 ? void 0 : x.origin)
      }).toUR();
    }
  }
  return p.DataType = s.DataType, ethereum$2.KeystoneEthereumSDK = p, ethereum$2;
}
var solana = {}, dist$c = { exports: {} }, bcUrRegistrySol_cjs_production_min = {}, hasRequiredBcUrRegistrySol_cjs_production_min;
function requireBcUrRegistrySol_cjs_production_min() {
  return hasRequiredBcUrRegistrySol_cjs_production_min || (hasRequiredBcUrRegistrySol_cjs_production_min = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$j(), u = require$$1$2;
    const p = { SOL_SIGN_REQUEST: new A.RegistryType("sol-sign-request", 1101), SOL_SIGNATURE: new A.RegistryType("sol-signature", 1102), SOL_NFT_ITEM: new A.RegistryType("sol-nft-item", 1104) }, { decodeToDataItem: t, RegistryTypes: l } = A.extend;
    var m, b;
    (m = s.SignType || (s.SignType = {}))[m.Transaction = 1] = "Transaction", m[m.Message = 2] = "Message", function(le) {
      le[le.requestId = 1] = "requestId", le[le.signData = 2] = "signData", le[le.derivationPath = 3] = "derivationPath", le[le.address = 4] = "address", le[le.origin = 5] = "origin", le[le.signType = 6] = "signType";
    }(b || (b = {}));
    class k extends A.RegistryItem {
      constructor(ge) {
        super(), this.getRegistryType = () => p.SOL_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSignRequestAddress = () => this.address, this.getOrigin = () => this.origin, this.getSignType = () => this.signType, this.toDataItem = () => {
          const pe = {};
          this.requestId && (pe[b.requestId] = new A.DataItem(this.requestId, l.UUID.getTag())), this.address && (pe[b.address] = this.address), this.origin && (pe[b.origin] = this.origin), pe[b.signData] = this.signData, pe[b.signType] = this.signType;
          const Ie = this.derivationPath.toDataItem();
          return Ie.setTag(this.derivationPath.getRegistryType().getTag()), pe[b.derivationPath] = Ie, new A.DataItem(pe);
        }, this.requestId = ge.requestId, this.signData = ge.signData, this.derivationPath = ge.derivationPath, this.address = ge.address, this.origin = ge.origin, this.signType = ge.signType;
      }
      static constructSOLRequest(ge, pe, Ie, be, Pe, Te, Qe) {
        const xe = pe.replace(/[m|M]\//, "").split("/"), Ee = new A.CryptoKeypath(xe.map((He) => {
          const ve = parseInt(He.replace("'", ""));
          let we = !1;
          return He.endsWith("'") && (we = !0), new A.PathComponent({ index: ve, hardened: we });
        }), Buffer.from(Ie, "hex"));
        return new k({ requestId: Pe ? Buffer.from(u.parse(Pe)) : void 0, signData: ge, derivationPath: Ee, address: Te ? Buffer.from(Te.replace("0x", ""), "hex") : void 0, origin: Qe || void 0, signType: be });
      }
    }
    k.fromDataItem = (le) => {
      const ge = le.getData(), pe = ge[b.signData], Ie = A.CryptoKeypath.fromDataItem(ge[b.derivationPath]), be = ge[b.address] ? ge[b.address] : void 0, Pe = ge[b.requestId] ? ge[b.requestId].getData() : void 0;
      return new k({ requestId: Pe, signData: pe, derivationPath: Ie, address: be, origin: ge[b.origin] ? ge[b.origin] : void 0, signType: ge[b.signType] });
    }, k.fromCBOR = (le) => {
      const ge = t(le);
      return k.fromDataItem(ge);
    };
    const { RegistryTypes: C, decodeToDataItem: B } = A.extend;
    var Q;
    (function(le) {
      le[le.requestId = 1] = "requestId", le[le.signature = 2] = "signature";
    })(Q || (Q = {}));
    class P extends A.RegistryItem {
      constructor(ge, pe) {
        super(), this.getRegistryType = () => p.SOL_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const Ie = {};
          return this.requestId && (Ie[Q.requestId] = new A.DataItem(this.requestId, C.UUID.getTag())), Ie[Q.signature] = this.signature, new A.DataItem(Ie);
        }, this.signature = ge, this.requestId = pe;
      }
    }
    P.fromDataItem = (le) => {
      const ge = le.getData(), pe = ge[Q.signature], Ie = ge[Q.requestId] ? ge[Q.requestId].getData() : void 0;
      return new P(pe, Ie);
    }, P.fromCBOR = (le) => {
      const ge = B(le);
      return P.fromDataItem(ge);
    };
    const { decodeToDataItem: x } = A.extend;
    var M;
    (function(le) {
      le[le.mintAddress = 1] = "mintAddress", le[le.collectionName = 2] = "collectionName", le[le.name = 3] = "name", le[le.mediaData = 4] = "mediaData";
    })(M || (M = {}));
    class F extends A.RegistryItem {
      constructor(ge) {
        super(), this.getRegistryType = () => p.SOL_NFT_ITEM, this.getName = () => this.name, this.getMediaData = () => this.mediaData, this.getMintAddress = () => this.mintAddress, this.getCollectionName = () => this.collectionName, this.toDataItem = () => {
          const pe = {};
          return pe[M.name] = this.name, pe[M.mintAddress] = this.mintAddress, pe[M.collectionName] = this.collectionName, pe[M.mediaData] = this.mediaData, new A.DataItem(pe);
        }, this.name = ge.name, this.mintAddress = ge.mintAddress, this.collectionName = ge.collectionName, this.mediaData = ge.mediaData;
      }
      static constructETHNFTItem(ge, pe, Ie, be) {
        return new F({ mintAddress: ge, collectionName: pe, mediaData: be, name: Ie });
      }
    }
    F.fromDataItem = (le) => {
      const ge = le.getData();
      return new F({ name: ge[M.name], mintAddress: ge[M.mintAddress], collectionName: ge[M.collectionName], mediaData: ge[M.mediaData] });
    }, F.fromCBOR = (le) => {
      const ge = x(le);
      return F.fromDataItem(ge);
    }, A.patchTags(Object.values(p).filter((le) => !!le.getTag()).map((le) => le.getTag())), Object.keys(A).forEach(function(le) {
      le !== "default" && Object.defineProperty(s, le, { enumerable: !0, get: function() {
        return A[le];
      } });
    }), s.SOLNFTItem = F, s.SolSignRequest = k, s.SolSignature = P;
  }(bcUrRegistrySol_cjs_production_min)), bcUrRegistrySol_cjs_production_min;
}
var bcUrRegistrySol_cjs_development = {}, hasRequiredBcUrRegistrySol_cjs_development;
function requireBcUrRegistrySol_cjs_development() {
  return hasRequiredBcUrRegistrySol_cjs_development || (hasRequiredBcUrRegistrySol_cjs_development = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$j(), u = require$$1$2;
    const p = {
      SOL_SIGN_REQUEST: /* @__PURE__ */ new A.RegistryType("sol-sign-request", 1101),
      SOL_SIGNATURE: /* @__PURE__ */ new A.RegistryType("sol-signature", 1102),
      SOL_NFT_ITEM: /* @__PURE__ */ new A.RegistryType("sol-nft-item", 1104)
    }, {
      decodeToDataItem: t,
      RegistryTypes: l
    } = A.extend;
    (function(F) {
      F[F.Transaction = 1] = "Transaction", F[F.Message = 2] = "Message";
    })(s.SignType || (s.SignType = {}));
    var m;
    (function(F) {
      F[F.requestId = 1] = "requestId", F[F.signData = 2] = "signData", F[F.derivationPath = 3] = "derivationPath", F[F.address = 4] = "address", F[F.origin = 5] = "origin", F[F.signType = 6] = "signType";
    })(m || (m = {}));
    class b extends A.RegistryItem {
      constructor(le) {
        super(), this.getRegistryType = () => p.SOL_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSignRequestAddress = () => this.address, this.getOrigin = () => this.origin, this.getSignType = () => this.signType, this.toDataItem = () => {
          const ge = {};
          this.requestId && (ge[m.requestId] = new A.DataItem(this.requestId, l.UUID.getTag())), this.address && (ge[m.address] = this.address), this.origin && (ge[m.origin] = this.origin), ge[m.signData] = this.signData, ge[m.signType] = this.signType;
          const pe = this.derivationPath.toDataItem();
          return pe.setTag(this.derivationPath.getRegistryType().getTag()), ge[m.derivationPath] = pe, new A.DataItem(ge);
        }, this.requestId = le.requestId, this.signData = le.signData, this.derivationPath = le.derivationPath, this.address = le.address, this.origin = le.origin, this.signType = le.signType;
      }
      static constructSOLRequest(le, ge, pe, Ie, be, Pe, Te) {
        const Qe = ge.replace(/[m|M]\//, "").split("/"), xe = new A.CryptoKeypath(Qe.map((Ee) => {
          const He = parseInt(Ee.replace("'", ""));
          let ve = !1;
          return Ee.endsWith("'") && (ve = !0), new A.PathComponent({
            index: He,
            hardened: ve
          });
        }), Buffer.from(pe, "hex"));
        return new b({
          requestId: be ? Buffer.from(u.parse(be)) : void 0,
          signData: le,
          derivationPath: xe,
          address: Pe ? Buffer.from(Pe.replace("0x", ""), "hex") : void 0,
          origin: Te || void 0,
          signType: Ie
        });
      }
    }
    b.fromDataItem = (F) => {
      const le = F.getData(), ge = le[m.signData], pe = A.CryptoKeypath.fromDataItem(le[m.derivationPath]), Ie = le[m.address] ? le[m.address] : void 0, be = le[m.requestId] ? le[m.requestId].getData() : void 0, Pe = le[m.origin] ? le[m.origin] : void 0, Te = le[m.signType];
      return new b({
        requestId: be,
        signData: ge,
        derivationPath: pe,
        address: Ie,
        origin: Pe,
        signType: Te
      });
    }, b.fromCBOR = (F) => {
      const le = t(F);
      return b.fromDataItem(le);
    };
    const {
      RegistryTypes: k,
      decodeToDataItem: C
    } = A.extend;
    var B;
    (function(F) {
      F[F.requestId = 1] = "requestId", F[F.signature = 2] = "signature";
    })(B || (B = {}));
    class Q extends A.RegistryItem {
      constructor(le, ge) {
        super(), this.getRegistryType = () => p.SOL_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const pe = {};
          return this.requestId && (pe[B.requestId] = new A.DataItem(this.requestId, k.UUID.getTag())), pe[B.signature] = this.signature, new A.DataItem(pe);
        }, this.signature = le, this.requestId = ge;
      }
    }
    Q.fromDataItem = (F) => {
      const le = F.getData(), ge = le[B.signature], pe = le[B.requestId] ? le[B.requestId].getData() : void 0;
      return new Q(ge, pe);
    }, Q.fromCBOR = (F) => {
      const le = C(F);
      return Q.fromDataItem(le);
    };
    const {
      decodeToDataItem: P
    } = A.extend;
    var x;
    (function(F) {
      F[F.mintAddress = 1] = "mintAddress", F[F.collectionName = 2] = "collectionName", F[F.name = 3] = "name", F[F.mediaData = 4] = "mediaData";
    })(x || (x = {}));
    class M extends A.RegistryItem {
      constructor(le) {
        super(), this.getRegistryType = () => p.SOL_NFT_ITEM, this.getName = () => this.name, this.getMediaData = () => this.mediaData, this.getMintAddress = () => this.mintAddress, this.getCollectionName = () => this.collectionName, this.toDataItem = () => {
          const ge = {};
          return ge[x.name] = this.name, ge[x.mintAddress] = this.mintAddress, ge[x.collectionName] = this.collectionName, ge[x.mediaData] = this.mediaData, new A.DataItem(ge);
        }, this.name = le.name, this.mintAddress = le.mintAddress, this.collectionName = le.collectionName, this.mediaData = le.mediaData;
      }
      static constructETHNFTItem(le, ge, pe, Ie) {
        return new M({
          mintAddress: le,
          collectionName: ge,
          mediaData: Ie,
          name: pe
        });
      }
    }
    M.fromDataItem = (F) => {
      const le = F.getData(), ge = le[x.name], pe = le[x.mediaData], Ie = le[x.mintAddress], be = le[x.collectionName];
      return new M({
        name: ge,
        mintAddress: Ie,
        collectionName: be,
        mediaData: pe
      });
    }, M.fromCBOR = (F) => {
      const le = P(F);
      return M.fromDataItem(le);
    }, A.patchTags(Object.values(p).filter((F) => !!F.getTag()).map((F) => F.getTag())), Object.keys(A).forEach(function(F) {
      F !== "default" && Object.defineProperty(s, F, {
        enumerable: !0,
        get: function() {
          return A[F];
        }
      });
    }), s.SOLNFTItem = M, s.SolSignRequest = b, s.SolSignature = Q;
  }(bcUrRegistrySol_cjs_development)), bcUrRegistrySol_cjs_development;
}
var hasRequiredDist$d;
function requireDist$d() {
  return hasRequiredDist$d || (hasRequiredDist$d = 1, process$1.env.NODE_ENV === "production" ? dist$c.exports = requireBcUrRegistrySol_cjs_production_min() : dist$c.exports = requireBcUrRegistrySol_cjs_development()), dist$c.exports;
}
var hasRequiredSolana;
function requireSolana() {
  if (hasRequiredSolana) return solana;
  hasRequiredSolana = 1, Object.defineProperty(solana, "__esModule", { value: !0 }), solana.KeystoneSolanaSDK = void 0;
  const s = requireDist$d(), A = requireUtils$d(), u = requireUr();
  class p {
    parseSignature(l) {
      if (l.type !== u.URType.SolSignature)
        throw new Error("type not match");
      const m = s.SolSignature.fromCBOR(l.cbor), b = m.getRequestId();
      return {
        requestId: b === void 0 ? void 0 : (0, A.uuidStringify)(b),
        signature: (0, A.toHex)(m.getSignature())
      };
    }
    generateSignRequest({ requestId: l, signData: m, dataType: b, path: k, xfp: C, address: B, origin: Q }) {
      return new s.SolSignRequest({
        requestId: (0, A.uuidParse)(l),
        signData: (0, A.toBuffer)(m),
        signType: b,
        derivationPath: new s.CryptoKeypath((0, A.parsePath)(k).map((P) => new s.PathComponent(P)), (0, A.toBuffer)(C)),
        address: B !== void 0 ? (0, A.toBuffer)(B) : void 0,
        origin: Q
      }).toUR();
    }
  }
  return p.DataType = s.SignType, solana.KeystoneSolanaSDK = p, solana;
}
var tron = {}, transfer = {}, contract_pb = {}, cjs$3 = {}, proto3 = {}, protoRuntime = {}, _enum = {}, assert$1 = {}, hasRequiredAssert$1;
function requireAssert$1() {
  if (hasRequiredAssert$1) return assert$1;
  hasRequiredAssert$1 = 1, Object.defineProperty(assert$1, "__esModule", { value: !0 }), assert$1.assertFloat32 = assert$1.assertUInt32 = assert$1.assertInt32 = assert$1.assert = void 0;
  function s(C, B) {
    if (!C)
      throw new Error(B);
  }
  assert$1.assert = s;
  const A = 34028234663852886e22, u = -34028234663852886e22, p = 4294967295, t = 2147483647, l = -2147483648;
  function m(C) {
    if (typeof C != "number")
      throw new Error("invalid int 32: " + typeof C);
    if (!Number.isInteger(C) || C > t || C < l)
      throw new Error("invalid int 32: " + C);
  }
  assert$1.assertInt32 = m;
  function b(C) {
    if (typeof C != "number")
      throw new Error("invalid uint 32: " + typeof C);
    if (!Number.isInteger(C) || C > p || C < 0)
      throw new Error("invalid uint 32: " + C);
  }
  assert$1.assertUInt32 = b;
  function k(C) {
    if (typeof C != "number")
      throw new Error("invalid float 32: " + typeof C);
    if (Number.isFinite(C) && (C > A || C < u))
      throw new Error("invalid float 32: " + C);
  }
  return assert$1.assertFloat32 = k, assert$1;
}
var hasRequired_enum;
function require_enum() {
  if (hasRequired_enum) return _enum;
  hasRequired_enum = 1, Object.defineProperty(_enum, "__esModule", { value: !0 }), _enum.makeEnum = _enum.makeEnumType = _enum.setEnumType = _enum.getEnumType = void 0;
  const s = requireAssert$1(), A = Symbol("@bufbuild/protobuf/enum-type");
  function u(b) {
    const k = b[A];
    return (0, s.assert)(k, "missing enum type on enum object"), k;
  }
  _enum.getEnumType = u;
  function p(b, k, C, B) {
    b[A] = t(k, C.map((Q) => ({
      no: Q.no,
      name: Q.name,
      localName: b[Q.no]
    })));
  }
  _enum.setEnumType = p;
  function t(b, k, C) {
    const B = /* @__PURE__ */ Object.create(null), Q = /* @__PURE__ */ Object.create(null), P = [];
    for (const x of k) {
      const M = m(x);
      P.push(M), B[x.name] = M, Q[x.no] = M;
    }
    return {
      typeName: b,
      values: P,
      // We do not surface options at this time
      // options: opt?.options ?? Object.create(null),
      findName(x) {
        return B[x];
      },
      findNumber(x) {
        return Q[x];
      }
    };
  }
  _enum.makeEnumType = t;
  function l(b, k, C) {
    const B = {};
    for (const Q of k) {
      const P = m(Q);
      B[P.localName] = P.no, B[P.no] = P.localName;
    }
    return p(B, b, k), B;
  }
  _enum.makeEnum = l;
  function m(b) {
    return "localName" in b ? b : Object.assign(Object.assign({}, b), { localName: b.name });
  }
  return _enum;
}
var messageType = {}, message = {}, hasRequiredMessage;
function requireMessage() {
  if (hasRequiredMessage) return message;
  hasRequiredMessage = 1, Object.defineProperty(message, "__esModule", { value: !0 }), message.Message = void 0;
  class s {
    /**
     * Compare with a message of the same type.
     * Note that this function disregards extensions and unknown fields.
     */
    equals(u) {
      return this.getType().runtime.util.equals(this.getType(), this, u);
    }
    /**
     * Create a deep copy.
     */
    clone() {
      return this.getType().runtime.util.clone(this);
    }
    /**
     * Parse from binary data, merging fields.
     *
     * Repeated fields are appended. Map entries are added, overwriting
     * existing keys.
     *
     * If a message field is already present, it will be merged with the
     * new data.
     */
    fromBinary(u, p) {
      const t = this.getType(), l = t.runtime.bin, m = l.makeReadOptions(p);
      return l.readMessage(this, m.readerFactory(u), u.byteLength, m), this;
    }
    /**
     * Parse a message from a JSON value.
     */
    fromJson(u, p) {
      const t = this.getType(), l = t.runtime.json, m = l.makeReadOptions(p);
      return l.readMessage(t, u, m, this), this;
    }
    /**
     * Parse a message from a JSON string.
     */
    fromJsonString(u, p) {
      let t;
      try {
        t = JSON.parse(u);
      } catch (l) {
        throw new Error(`cannot decode ${this.getType().typeName} from JSON: ${l instanceof Error ? l.message : String(l)}`);
      }
      return this.fromJson(t, p);
    }
    /**
     * Serialize the message to binary data.
     */
    toBinary(u) {
      const p = this.getType(), t = p.runtime.bin, l = t.makeWriteOptions(u), m = l.writerFactory();
      return t.writeMessage(this, m, l), m.finish();
    }
    /**
     * Serialize the message to a JSON value, a JavaScript value that can be
     * passed to JSON.stringify().
     */
    toJson(u) {
      const p = this.getType(), t = p.runtime.json, l = t.makeWriteOptions(u);
      return t.writeMessage(this, l);
    }
    /**
     * Serialize the message to a JSON string.
     */
    toJsonString(u) {
      var p;
      const t = this.toJson(u);
      return JSON.stringify(t, null, (p = u == null ? void 0 : u.prettySpaces) !== null && p !== void 0 ? p : 0);
    }
    /**
     * Override for serialization behavior. This will be invoked when calling
     * JSON.stringify on this message (i.e. JSON.stringify(msg)).
     *
     * Note that this will not serialize google.protobuf.Any with a packed
     * message because the protobuf JSON format specifies that it needs to be
     * unpacked, and this is only possible with a type registry to look up the
     * message type.  As a result, attempting to serialize a message with this
     * type will throw an Error.
     *
     * This method is protected because you should not need to invoke it
     * directly -- instead use JSON.stringify or toJsonString for
     * stringified JSON.  Alternatively, if actual JSON is desired, you should
     * use toJson.
     */
    toJSON() {
      return this.toJson({
        emitDefaultValues: !0
      });
    }
    /**
     * Retrieve the MessageType of this message - a singleton that represents
     * the protobuf message declaration and provides metadata for reflection-
     * based operations.
     */
    getType() {
      return Object.getPrototypeOf(this).constructor;
    }
  }
  return message.Message = s, message;
}
var hasRequiredMessageType;
function requireMessageType() {
  if (hasRequiredMessageType) return messageType;
  hasRequiredMessageType = 1, Object.defineProperty(messageType, "__esModule", { value: !0 }), messageType.makeMessageType = void 0;
  const s = requireMessage();
  function A(u, p, t, l) {
    var m;
    const b = (m = l == null ? void 0 : l.localName) !== null && m !== void 0 ? m : p.substring(p.lastIndexOf(".") + 1), k = {
      [b]: function(C) {
        u.util.initFields(this), u.util.initPartial(C, this);
      }
    }[b];
    return Object.setPrototypeOf(k.prototype, new s.Message()), Object.assign(k, {
      runtime: u,
      typeName: p,
      fields: u.util.newFieldList(t),
      fromBinary(C, B) {
        return new k().fromBinary(C, B);
      },
      fromJson(C, B) {
        return new k().fromJson(C, B);
      },
      fromJsonString(C, B) {
        return new k().fromJsonString(C, B);
      },
      equals(C, B) {
        return u.util.equals(k, C, B);
      }
    }), k;
  }
  return messageType.makeMessageType = A, messageType;
}
var extensions = {}, scalars = {}, protoInt64 = {}, varint$3 = {}, hasRequiredVarint$3;
function requireVarint$3() {
  if (hasRequiredVarint$3) return varint$3;
  hasRequiredVarint$3 = 1, Object.defineProperty(varint$3, "__esModule", { value: !0 }), varint$3.varint32read = varint$3.varint32write = varint$3.uInt64ToString = varint$3.int64ToString = varint$3.int64FromString = varint$3.varint64write = varint$3.varint64read = void 0;
  function s() {
    let P = 0, x = 0;
    for (let F = 0; F < 28; F += 7) {
      let le = this.buf[this.pos++];
      if (P |= (le & 127) << F, (le & 128) == 0)
        return this.assertBounds(), [P, x];
    }
    let M = this.buf[this.pos++];
    if (P |= (M & 15) << 28, x = (M & 112) >> 4, (M & 128) == 0)
      return this.assertBounds(), [P, x];
    for (let F = 3; F <= 31; F += 7) {
      let le = this.buf[this.pos++];
      if (x |= (le & 127) << F, (le & 128) == 0)
        return this.assertBounds(), [P, x];
    }
    throw new Error("invalid varint");
  }
  varint$3.varint64read = s;
  function A(P, x, M) {
    for (let ge = 0; ge < 28; ge = ge + 7) {
      const pe = P >>> ge, Ie = !(!(pe >>> 7) && x == 0), be = (Ie ? pe | 128 : pe) & 255;
      if (M.push(be), !Ie)
        return;
    }
    const F = P >>> 28 & 15 | (x & 7) << 4, le = x >> 3 != 0;
    if (M.push((le ? F | 128 : F) & 255), !!le) {
      for (let ge = 3; ge < 31; ge = ge + 7) {
        const pe = x >>> ge, Ie = !!(pe >>> 7), be = (Ie ? pe | 128 : pe) & 255;
        if (M.push(be), !Ie)
          return;
      }
      M.push(x >>> 31 & 1);
    }
  }
  varint$3.varint64write = A;
  const u = 4294967296;
  function p(P) {
    const x = P[0] === "-";
    x && (P = P.slice(1));
    const M = 1e6;
    let F = 0, le = 0;
    function ge(pe, Ie) {
      const be = Number(P.slice(pe, Ie));
      le *= M, F = F * M + be, F >= u && (le = le + (F / u | 0), F = F % u);
    }
    return ge(-24, -18), ge(-18, -12), ge(-12, -6), ge(-6), x ? k(F, le) : b(F, le);
  }
  varint$3.int64FromString = p;
  function t(P, x) {
    let M = b(P, x);
    const F = M.hi & 2147483648;
    F && (M = k(M.lo, M.hi));
    const le = l(M.lo, M.hi);
    return F ? "-" + le : le;
  }
  varint$3.int64ToString = t;
  function l(P, x) {
    if ({ lo: P, hi: x } = m(P, x), x <= 2097151)
      return String(u * x + P);
    const M = P & 16777215, F = (P >>> 24 | x << 8) & 16777215, le = x >> 16 & 65535;
    let ge = M + F * 6777216 + le * 6710656, pe = F + le * 8147497, Ie = le * 2;
    const be = 1e7;
    return ge >= be && (pe += Math.floor(ge / be), ge %= be), pe >= be && (Ie += Math.floor(pe / be), pe %= be), Ie.toString() + C(pe) + C(ge);
  }
  varint$3.uInt64ToString = l;
  function m(P, x) {
    return { lo: P >>> 0, hi: x >>> 0 };
  }
  function b(P, x) {
    return { lo: P | 0, hi: x | 0 };
  }
  function k(P, x) {
    return x = ~x, P ? P = ~P + 1 : x += 1, b(P, x);
  }
  const C = (P) => {
    const x = String(P);
    return "0000000".slice(x.length) + x;
  };
  function B(P, x) {
    if (P >= 0) {
      for (; P > 127; )
        x.push(P & 127 | 128), P = P >>> 7;
      x.push(P);
    } else {
      for (let M = 0; M < 9; M++)
        x.push(P & 127 | 128), P = P >> 7;
      x.push(1);
    }
  }
  varint$3.varint32write = B;
  function Q() {
    let P = this.buf[this.pos++], x = P & 127;
    if ((P & 128) == 0)
      return this.assertBounds(), x;
    if (P = this.buf[this.pos++], x |= (P & 127) << 7, (P & 128) == 0)
      return this.assertBounds(), x;
    if (P = this.buf[this.pos++], x |= (P & 127) << 14, (P & 128) == 0)
      return this.assertBounds(), x;
    if (P = this.buf[this.pos++], x |= (P & 127) << 21, (P & 128) == 0)
      return this.assertBounds(), x;
    P = this.buf[this.pos++], x |= (P & 15) << 28;
    for (let M = 5; (P & 128) !== 0 && M < 10; M++)
      P = this.buf[this.pos++];
    if ((P & 128) != 0)
      throw new Error("invalid varint");
    return this.assertBounds(), x >>> 0;
  }
  return varint$3.varint32read = Q, varint$3;
}
var hasRequiredProtoInt64;
function requireProtoInt64() {
  if (hasRequiredProtoInt64) return protoInt64;
  hasRequiredProtoInt64 = 1, Object.defineProperty(protoInt64, "__esModule", { value: !0 }), protoInt64.protoInt64 = void 0;
  const s = requireAssert$1(), A = requireVarint$3();
  function u() {
    const p = new DataView(new ArrayBuffer(8));
    if (typeof BigInt == "function" && typeof p.getBigInt64 == "function" && typeof p.getBigUint64 == "function" && typeof p.setBigInt64 == "function" && typeof p.setBigUint64 == "function" && (typeof process$1 != "object" || typeof process$1.env != "object" || process$1.env.BUF_BIGINT_DISABLE !== "1")) {
      const b = BigInt("-9223372036854775808"), k = BigInt("9223372036854775807"), C = BigInt("0"), B = BigInt("18446744073709551615");
      return {
        zero: BigInt(0),
        supported: !0,
        parse(Q) {
          const P = typeof Q == "bigint" ? Q : BigInt(Q);
          if (P > k || P < b)
            throw new Error(`int64 invalid: ${Q}`);
          return P;
        },
        uParse(Q) {
          const P = typeof Q == "bigint" ? Q : BigInt(Q);
          if (P > B || P < C)
            throw new Error(`uint64 invalid: ${Q}`);
          return P;
        },
        enc(Q) {
          return p.setBigInt64(0, this.parse(Q), !0), {
            lo: p.getInt32(0, !0),
            hi: p.getInt32(4, !0)
          };
        },
        uEnc(Q) {
          return p.setBigInt64(0, this.uParse(Q), !0), {
            lo: p.getInt32(0, !0),
            hi: p.getInt32(4, !0)
          };
        },
        dec(Q, P) {
          return p.setInt32(0, Q, !0), p.setInt32(4, P, !0), p.getBigInt64(0, !0);
        },
        uDec(Q, P) {
          return p.setInt32(0, Q, !0), p.setInt32(4, P, !0), p.getBigUint64(0, !0);
        }
      };
    }
    const l = (b) => (0, s.assert)(/^-?[0-9]+$/.test(b), `int64 invalid: ${b}`), m = (b) => (0, s.assert)(/^[0-9]+$/.test(b), `uint64 invalid: ${b}`);
    return {
      zero: "0",
      supported: !1,
      parse(b) {
        return typeof b != "string" && (b = b.toString()), l(b), b;
      },
      uParse(b) {
        return typeof b != "string" && (b = b.toString()), m(b), b;
      },
      enc(b) {
        return typeof b != "string" && (b = b.toString()), l(b), (0, A.int64FromString)(b);
      },
      uEnc(b) {
        return typeof b != "string" && (b = b.toString()), m(b), (0, A.int64FromString)(b);
      },
      dec(b, k) {
        return (0, A.int64ToString)(b, k);
      },
      uDec(b, k) {
        return (0, A.uInt64ToString)(b, k);
      }
    };
  }
  return protoInt64.protoInt64 = u(), protoInt64;
}
var scalar = {}, hasRequiredScalar;
function requireScalar() {
  if (hasRequiredScalar) return scalar;
  hasRequiredScalar = 1, Object.defineProperty(scalar, "__esModule", { value: !0 }), scalar.LongType = scalar.ScalarType = void 0;
  var s;
  (function(u) {
    u[u.DOUBLE = 1] = "DOUBLE", u[u.FLOAT = 2] = "FLOAT", u[u.INT64 = 3] = "INT64", u[u.UINT64 = 4] = "UINT64", u[u.INT32 = 5] = "INT32", u[u.FIXED64 = 6] = "FIXED64", u[u.FIXED32 = 7] = "FIXED32", u[u.BOOL = 8] = "BOOL", u[u.STRING = 9] = "STRING", u[u.BYTES = 12] = "BYTES", u[u.UINT32 = 13] = "UINT32", u[u.SFIXED32 = 15] = "SFIXED32", u[u.SFIXED64 = 16] = "SFIXED64", u[u.SINT32 = 17] = "SINT32", u[u.SINT64 = 18] = "SINT64";
  })(s || (scalar.ScalarType = s = {}));
  var A;
  return function(u) {
    u[u.BIGINT = 0] = "BIGINT", u[u.STRING = 1] = "STRING";
  }(A || (scalar.LongType = A = {})), scalar;
}
var hasRequiredScalars;
function requireScalars() {
  if (hasRequiredScalars) return scalars;
  hasRequiredScalars = 1, Object.defineProperty(scalars, "__esModule", { value: !0 }), scalars.isScalarZeroValue = scalars.scalarZeroValue = scalars.scalarEquals = void 0;
  const s = requireProtoInt64(), A = requireScalar();
  function u(l, m, b) {
    if (m === b)
      return !0;
    if (l == A.ScalarType.BYTES) {
      if (!(m instanceof Uint8Array) || !(b instanceof Uint8Array) || m.length !== b.length)
        return !1;
      for (let k = 0; k < m.length; k++)
        if (m[k] !== b[k])
          return !1;
      return !0;
    }
    switch (l) {
      case A.ScalarType.UINT64:
      case A.ScalarType.FIXED64:
      case A.ScalarType.INT64:
      case A.ScalarType.SFIXED64:
      case A.ScalarType.SINT64:
        return m == b;
    }
    return !1;
  }
  scalars.scalarEquals = u;
  function p(l, m) {
    switch (l) {
      case A.ScalarType.BOOL:
        return !1;
      case A.ScalarType.UINT64:
      case A.ScalarType.FIXED64:
      case A.ScalarType.INT64:
      case A.ScalarType.SFIXED64:
      case A.ScalarType.SINT64:
        return m == 0 ? s.protoInt64.zero : "0";
      case A.ScalarType.DOUBLE:
      case A.ScalarType.FLOAT:
        return 0;
      case A.ScalarType.BYTES:
        return new Uint8Array(0);
      case A.ScalarType.STRING:
        return "";
      default:
        return 0;
    }
  }
  scalars.scalarZeroValue = p;
  function t(l, m) {
    switch (l) {
      case A.ScalarType.BOOL:
        return m === !1;
      case A.ScalarType.STRING:
        return m === "";
      case A.ScalarType.BYTES:
        return m instanceof Uint8Array && !m.byteLength;
      default:
        return m == 0;
    }
  }
  return scalars.isScalarZeroValue = t, scalars;
}
var hasRequiredExtensions;
function requireExtensions() {
  if (hasRequiredExtensions) return extensions;
  hasRequiredExtensions = 1, Object.defineProperty(extensions, "__esModule", { value: !0 }), extensions.filterUnknownFields = extensions.createExtensionContainer = extensions.makeExtension = void 0;
  const s = requireScalars();
  function A(l, m, b, k) {
    let C;
    return {
      typeName: m,
      extendee: b,
      get field() {
        if (!C) {
          const B = typeof k == "function" ? k() : k;
          B.name = m.split(".").pop(), B.jsonName = `[${m}]`, C = l.util.newFieldList([B]).list()[0];
        }
        return C;
      },
      runtime: l
    };
  }
  extensions.makeExtension = A;
  function u(l) {
    const m = l.field.localName, b = /* @__PURE__ */ Object.create(null);
    return b[m] = p(l), [b, () => b[m]];
  }
  extensions.createExtensionContainer = u;
  function p(l) {
    const m = l.field;
    if (m.repeated)
      return [];
    if (m.default !== void 0)
      return m.default;
    switch (m.kind) {
      case "enum":
        return m.T.values[0].no;
      case "scalar":
        return (0, s.scalarZeroValue)(m.T, m.L);
      case "message":
        const b = m.T, k = new b();
        return b.fieldWrapper ? b.fieldWrapper.unwrapField(k) : k;
      case "map":
        throw "map fields are not allowed to be extensions";
    }
  }
  function t(l, m) {
    if (!m.repeated && (m.kind == "enum" || m.kind == "scalar")) {
      for (let b = l.length - 1; b >= 0; --b)
        if (l[b].no == m.no)
          return [l[b]];
      return [];
    }
    return l.filter((b) => b.no === m.no);
  }
  return extensions.filterUnknownFields = t, extensions;
}
var jsonFormat = {}, protoBase64 = {}, hasRequiredProtoBase64;
function requireProtoBase64() {
  if (hasRequiredProtoBase64) return protoBase64;
  hasRequiredProtoBase64 = 1, Object.defineProperty(protoBase64, "__esModule", { value: !0 }), protoBase64.protoBase64 = void 0;
  let s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split(""), A = [];
  for (let u = 0; u < s.length; u++)
    A[s[u].charCodeAt(0)] = u;
  return A[45] = s.indexOf("+"), A[95] = s.indexOf("/"), protoBase64.protoBase64 = {
    /**
     * Decodes a base64 string to a byte array.
     *
     * - ignores white-space, including line breaks and tabs
     * - allows inner padding (can decode concatenated base64 strings)
     * - does not require padding
     * - understands base64url encoding:
     *   "-" instead of "+",
     *   "_" instead of "/",
     *   no padding
     */
    dec(u) {
      let p = u.length * 3 / 4;
      u[u.length - 2] == "=" ? p -= 2 : u[u.length - 1] == "=" && (p -= 1);
      let t = new Uint8Array(p), l = 0, m = 0, b, k = 0;
      for (let C = 0; C < u.length; C++) {
        if (b = A[u.charCodeAt(C)], b === void 0)
          switch (u[C]) {
            // @ts-ignore TS7029: Fallthrough case in switch
            case "=":
              m = 0;
            // reset state when padding found
            // @ts-ignore TS7029: Fallthrough case in switch
            case `
`:
            case "\r":
            case "	":
            case " ":
              continue;
            // skip white-space, and padding
            default:
              throw Error("invalid base64 string.");
          }
        switch (m) {
          case 0:
            k = b, m = 1;
            break;
          case 1:
            t[l++] = k << 2 | (b & 48) >> 4, k = b, m = 2;
            break;
          case 2:
            t[l++] = (k & 15) << 4 | (b & 60) >> 2, k = b, m = 3;
            break;
          case 3:
            t[l++] = (k & 3) << 6 | b, m = 0;
            break;
        }
      }
      if (m == 1)
        throw Error("invalid base64 string.");
      return t.subarray(0, l);
    },
    /**
     * Encode a byte array to a base64 string.
     */
    enc(u) {
      let p = "", t = 0, l, m = 0;
      for (let b = 0; b < u.length; b++)
        switch (l = u[b], t) {
          case 0:
            p += s[l >> 2], m = (l & 3) << 4, t = 1;
            break;
          case 1:
            p += s[m | l >> 4], m = (l & 15) << 2, t = 2;
            break;
          case 2:
            p += s[m | l >> 6], p += s[l & 63], t = 0;
            break;
        }
      return t && (p += s[m], p += "=", t == 1 && (p += "=")), p;
    }
  }, protoBase64;
}
var extensionAccessor = {}, hasRequiredExtensionAccessor;
function requireExtensionAccessor() {
  if (hasRequiredExtensionAccessor) return extensionAccessor;
  hasRequiredExtensionAccessor = 1, Object.defineProperty(extensionAccessor, "__esModule", { value: !0 }), extensionAccessor.hasExtension = extensionAccessor.clearExtension = extensionAccessor.setExtension = extensionAccessor.getExtension = void 0;
  const s = requireAssert$1(), A = requireExtensions();
  function u(b, k, C) {
    m(k, b);
    const B = k.runtime.bin.makeReadOptions(C), Q = (0, A.filterUnknownFields)(b.getType().runtime.bin.listUnknownFields(b), k.field), [P, x] = (0, A.createExtensionContainer)(k);
    for (const M of Q)
      k.runtime.bin.readField(P, B.readerFactory(M.data), k.field, M.wireType, B);
    return x();
  }
  extensionAccessor.getExtension = u;
  function p(b, k, C, B) {
    m(k, b);
    const Q = k.runtime.bin.makeReadOptions(B), P = k.runtime.bin.makeWriteOptions(B);
    if (l(b, k)) {
      const le = b.getType().runtime.bin.listUnknownFields(b).filter((ge) => ge.no != k.field.no);
      b.getType().runtime.bin.discardUnknownFields(b);
      for (const ge of le)
        b.getType().runtime.bin.onUnknownField(b, ge.no, ge.wireType, ge.data);
    }
    const x = P.writerFactory();
    let M = k.field;
    !M.opt && !M.repeated && (M.kind == "enum" || M.kind == "scalar") && (M = Object.assign(Object.assign({}, k.field), { opt: !0 })), k.runtime.bin.writeField(M, C, x, P);
    const F = Q.readerFactory(x.finish());
    for (; F.pos < F.len; ) {
      const [le, ge] = F.tag(), pe = F.skip(ge, le);
      b.getType().runtime.bin.onUnknownField(b, le, ge, pe);
    }
  }
  extensionAccessor.setExtension = p;
  function t(b, k) {
    if (m(k, b), l(b, k)) {
      const C = b.getType().runtime.bin, B = C.listUnknownFields(b).filter((Q) => Q.no != k.field.no);
      C.discardUnknownFields(b);
      for (const Q of B)
        C.onUnknownField(b, Q.no, Q.wireType, Q.data);
    }
  }
  extensionAccessor.clearExtension = t;
  function l(b, k) {
    const C = b.getType();
    return k.extendee.typeName === C.typeName && !!C.runtime.bin.listUnknownFields(b).find((B) => B.no == k.field.no);
  }
  extensionAccessor.hasExtension = l;
  function m(b, k) {
    (0, s.assert)(b.extendee.typeName == k.getType().typeName, `extension ${b.typeName} can only be applied to message ${b.extendee.typeName}`);
  }
  return extensionAccessor;
}
var reflect = {}, hasRequiredReflect;
function requireReflect() {
  if (hasRequiredReflect) return reflect;
  hasRequiredReflect = 1, Object.defineProperty(reflect, "__esModule", { value: !0 }), reflect.clearField = reflect.isFieldSet = void 0;
  const s = requireScalars();
  function A(p, t) {
    const l = p.localName;
    if (p.repeated)
      return t[l].length > 0;
    if (p.oneof)
      return t[p.oneof.localName].case === l;
    switch (p.kind) {
      case "enum":
      case "scalar":
        return p.opt || p.req ? t[l] !== void 0 : p.kind == "enum" ? t[l] !== p.T.values[0].no : !(0, s.isScalarZeroValue)(p.T, t[l]);
      case "message":
        return t[l] !== void 0;
      case "map":
        return Object.keys(t[l]).length > 0;
    }
  }
  reflect.isFieldSet = A;
  function u(p, t) {
    const l = p.localName, m = !p.opt && !p.req;
    if (p.repeated)
      t[l] = [];
    else if (p.oneof)
      t[p.oneof.localName] = { case: void 0 };
    else
      switch (p.kind) {
        case "map":
          t[l] = {};
          break;
        case "enum":
          t[l] = m ? p.T.values[0].no : void 0;
          break;
        case "scalar":
          t[l] = m ? (0, s.scalarZeroValue)(p.T, p.L) : void 0;
          break;
        case "message":
          t[l] = void 0;
          break;
      }
  }
  return reflect.clearField = u, reflect;
}
var fieldWrapper = {}, isMessage = {}, hasRequiredIsMessage;
function requireIsMessage() {
  if (hasRequiredIsMessage) return isMessage;
  hasRequiredIsMessage = 1, Object.defineProperty(isMessage, "__esModule", { value: !0 }), isMessage.isMessage = void 0;
  const s = requireMessage();
  function A(u, p) {
    if (u === null || typeof u != "object" || !Object.getOwnPropertyNames(s.Message.prototype).every((l) => l in u && typeof u[l] == "function"))
      return !1;
    const t = u.getType();
    return t === null || typeof t != "function" || !("typeName" in t) || typeof t.typeName != "string" ? !1 : p === void 0 ? !0 : t.typeName == p.typeName;
  }
  return isMessage.isMessage = A, isMessage;
}
var hasRequiredFieldWrapper;
function requireFieldWrapper() {
  if (hasRequiredFieldWrapper) return fieldWrapper;
  hasRequiredFieldWrapper = 1, Object.defineProperty(fieldWrapper, "__esModule", { value: !0 }), fieldWrapper.getUnwrappedFieldType = fieldWrapper.wrapField = void 0;
  const s = requireScalar(), A = requireIsMessage();
  function u(l, m) {
    return (0, A.isMessage)(m) || !l.fieldWrapper ? m : l.fieldWrapper.wrapField(m);
  }
  fieldWrapper.wrapField = u;
  function p(l) {
    if (l.fieldKind === "message" && !l.repeated && l.oneof == null)
      return t[l.message.typeName];
  }
  fieldWrapper.getUnwrappedFieldType = p;
  const t = {
    "google.protobuf.DoubleValue": s.ScalarType.DOUBLE,
    "google.protobuf.FloatValue": s.ScalarType.FLOAT,
    "google.protobuf.Int64Value": s.ScalarType.INT64,
    "google.protobuf.UInt64Value": s.ScalarType.UINT64,
    "google.protobuf.Int32Value": s.ScalarType.INT32,
    "google.protobuf.UInt32Value": s.ScalarType.UINT32,
    "google.protobuf.BoolValue": s.ScalarType.BOOL,
    "google.protobuf.StringValue": s.ScalarType.STRING,
    "google.protobuf.BytesValue": s.ScalarType.BYTES
  };
  return fieldWrapper;
}
var hasRequiredJsonFormat;
function requireJsonFormat() {
  if (hasRequiredJsonFormat) return jsonFormat;
  hasRequiredJsonFormat = 1, Object.defineProperty(jsonFormat, "__esModule", { value: !0 }), jsonFormat.makeJsonFormat = void 0;
  const s = requireAssert$1(), A = requireProtoInt64(), u = requireProtoBase64(), p = requireExtensions(), t = requireExtensionAccessor(), l = requireReflect(), m = requireFieldWrapper(), b = requireScalars(), k = requireScalars(), C = requireScalar(), B = requireIsMessage(), Q = {
    ignoreUnknownFields: !1
  }, P = {
    emitDefaultValues: !1,
    enumAsInteger: !1,
    useProtoFieldName: !1,
    prettySpaces: 0
  };
  function x(ve) {
    return ve ? Object.assign(Object.assign({}, Q), ve) : Q;
  }
  function M(ve) {
    return ve ? Object.assign(Object.assign({}, P), ve) : P;
  }
  const F = Symbol(), le = Symbol();
  function ge() {
    return {
      makeReadOptions: x,
      makeWriteOptions: M,
      readMessage(ve, we, Ce, Se) {
        if (we == null || Array.isArray(we) || typeof we != "object")
          throw new Error(`cannot decode message ${ve.typeName} from JSON: ${pe(we)}`);
        Se = Se ?? new ve();
        const Ne = /* @__PURE__ */ new Map(), rr = Ce.typeRegistry;
        for (const [er, ir] of Object.entries(we)) {
          const sr = ve.fields.findJsonName(er);
          if (sr) {
            if (sr.oneof) {
              if (ir === null && sr.kind == "scalar")
                continue;
              const nr = Ne.get(sr.oneof);
              if (nr !== void 0)
                throw new Error(`cannot decode message ${ve.typeName} from JSON: multiple keys for oneof "${sr.oneof.name}" present: "${nr}", "${er}"`);
              Ne.set(sr.oneof, er);
            }
            Ie(Se, ir, sr, Ce, ve);
          } else {
            let nr = !1;
            if (rr != null && rr.findExtension && er.startsWith("[") && er.endsWith("]")) {
              const fr = rr.findExtension(er.substring(1, er.length - 1));
              if (fr && fr.extendee.typeName == ve.typeName) {
                nr = !0;
                const [lr, br] = (0, p.createExtensionContainer)(fr);
                Ie(lr, ir, fr.field, Ce, fr), (0, t.setExtension)(Se, fr, br(), Ce);
              }
            }
            if (!nr && !Ce.ignoreUnknownFields)
              throw new Error(`cannot decode message ${ve.typeName} from JSON: key "${er}" is unknown`);
          }
        }
        return Se;
      },
      writeMessage(ve, we) {
        const Ce = ve.getType(), Se = {};
        let Ne;
        try {
          for (Ne of Ce.fields.byNumber()) {
            if (!(0, l.isFieldSet)(Ne, ve)) {
              if (Ne.req)
                throw "required field not set";
              if (!we.emitDefaultValues || !Qe(Ne))
                continue;
            }
            const er = Ne.oneof ? ve[Ne.oneof.localName].value : ve[Ne.localName], ir = xe(Ne, er, we);
            ir !== void 0 && (Se[we.useProtoFieldName ? Ne.name : Ne.jsonName] = ir);
          }
          const rr = we.typeRegistry;
          if (rr != null && rr.findExtensionFor)
            for (const er of Ce.runtime.bin.listUnknownFields(ve)) {
              const ir = rr.findExtensionFor(Ce.typeName, er.no);
              if (ir && (0, t.hasExtension)(ve, ir)) {
                const sr = (0, t.getExtension)(ve, ir, we), nr = xe(ir.field, sr, we);
                nr !== void 0 && (Se[ir.field.jsonName] = nr);
              }
            }
        } catch (rr) {
          const er = Ne ? `cannot encode field ${Ce.typeName}.${Ne.name} to JSON` : `cannot encode message ${Ce.typeName} to JSON`, ir = rr instanceof Error ? rr.message : String(rr);
          throw new Error(er + (ir.length > 0 ? `: ${ir}` : ""));
        }
        return Se;
      },
      readScalar(ve, we, Ce) {
        return Pe(ve, we, Ce ?? C.LongType.BIGINT, !0);
      },
      writeScalar(ve, we, Ce) {
        if (we !== void 0 && (Ce || (0, k.isScalarZeroValue)(ve, we)))
          return He(ve, we);
      },
      debug: pe
    };
  }
  jsonFormat.makeJsonFormat = ge;
  function pe(ve) {
    if (ve === null)
      return "null";
    switch (typeof ve) {
      case "object":
        return Array.isArray(ve) ? "array" : "object";
      case "string":
        return ve.length > 100 ? "string" : `"${ve.split('"').join('\\"')}"`;
      default:
        return String(ve);
    }
  }
  function Ie(ve, we, Ce, Se, Ne) {
    let rr = Ce.localName;
    if (Ce.repeated) {
      if ((0, s.assert)(Ce.kind != "map"), we === null)
        return;
      if (!Array.isArray(we))
        throw new Error(`cannot decode field ${Ne.typeName}.${Ce.name} from JSON: ${pe(we)}`);
      const er = ve[rr];
      for (const ir of we) {
        if (ir === null)
          throw new Error(`cannot decode field ${Ne.typeName}.${Ce.name} from JSON: ${pe(ir)}`);
        switch (Ce.kind) {
          case "message":
            er.push(Ce.T.fromJson(ir, Se));
            break;
          case "enum":
            const sr = Te(Ce.T, ir, Se.ignoreUnknownFields, !0);
            sr !== le && er.push(sr);
            break;
          case "scalar":
            try {
              er.push(Pe(Ce.T, ir, Ce.L, !0));
            } catch (nr) {
              let fr = `cannot decode field ${Ne.typeName}.${Ce.name} from JSON: ${pe(ir)}`;
              throw nr instanceof Error && nr.message.length > 0 && (fr += `: ${nr.message}`), new Error(fr);
            }
            break;
        }
      }
    } else if (Ce.kind == "map") {
      if (we === null)
        return;
      if (typeof we != "object" || Array.isArray(we))
        throw new Error(`cannot decode field ${Ne.typeName}.${Ce.name} from JSON: ${pe(we)}`);
      const er = ve[rr];
      for (const [ir, sr] of Object.entries(we)) {
        if (sr === null)
          throw new Error(`cannot decode field ${Ne.typeName}.${Ce.name} from JSON: map value null`);
        let nr;
        try {
          nr = be(Ce.K, ir);
        } catch (fr) {
          let lr = `cannot decode map key for field ${Ne.typeName}.${Ce.name} from JSON: ${pe(we)}`;
          throw fr instanceof Error && fr.message.length > 0 && (lr += `: ${fr.message}`), new Error(lr);
        }
        switch (Ce.V.kind) {
          case "message":
            er[nr] = Ce.V.T.fromJson(sr, Se);
            break;
          case "enum":
            const fr = Te(Ce.V.T, sr, Se.ignoreUnknownFields, !0);
            fr !== le && (er[nr] = fr);
            break;
          case "scalar":
            try {
              er[nr] = Pe(Ce.V.T, sr, C.LongType.BIGINT, !0);
            } catch (lr) {
              let br = `cannot decode map value for field ${Ne.typeName}.${Ce.name} from JSON: ${pe(we)}`;
              throw lr instanceof Error && lr.message.length > 0 && (br += `: ${lr.message}`), new Error(br);
            }
            break;
        }
      }
    } else
      switch (Ce.oneof && (ve = ve[Ce.oneof.localName] = { case: rr }, rr = "value"), Ce.kind) {
        case "message":
          const er = Ce.T;
          if (we === null && er.typeName != "google.protobuf.Value")
            return;
          let ir = ve[rr];
          (0, B.isMessage)(ir) ? ir.fromJson(we, Se) : (ve[rr] = ir = er.fromJson(we, Se), er.fieldWrapper && !Ce.oneof && (ve[rr] = er.fieldWrapper.unwrapField(ir)));
          break;
        case "enum":
          const sr = Te(Ce.T, we, Se.ignoreUnknownFields, !1);
          switch (sr) {
            case F:
              (0, l.clearField)(Ce, ve);
              break;
            case le:
              break;
            default:
              ve[rr] = sr;
              break;
          }
          break;
        case "scalar":
          try {
            const nr = Pe(Ce.T, we, Ce.L, !1);
            switch (nr) {
              case F:
                (0, l.clearField)(Ce, ve);
                break;
              default:
                ve[rr] = nr;
                break;
            }
          } catch (nr) {
            let fr = `cannot decode field ${Ne.typeName}.${Ce.name} from JSON: ${pe(we)}`;
            throw nr instanceof Error && nr.message.length > 0 && (fr += `: ${nr.message}`), new Error(fr);
          }
          break;
      }
  }
  function be(ve, we) {
    if (ve === C.ScalarType.BOOL)
      switch (we) {
        case "true":
          we = !0;
          break;
        case "false":
          we = !1;
          break;
      }
    return Pe(ve, we, C.LongType.BIGINT, !0).toString();
  }
  function Pe(ve, we, Ce, Se) {
    if (we === null)
      return Se ? (0, b.scalarZeroValue)(ve, Ce) : F;
    switch (ve) {
      // float, double: JSON value will be a number or one of the special string values "NaN", "Infinity", and "-Infinity".
      // Either numbers or strings are accepted. Exponent notation is also accepted.
      case C.ScalarType.DOUBLE:
      case C.ScalarType.FLOAT:
        if (we === "NaN")
          return Number.NaN;
        if (we === "Infinity")
          return Number.POSITIVE_INFINITY;
        if (we === "-Infinity")
          return Number.NEGATIVE_INFINITY;
        if (we === "" || typeof we == "string" && we.trim().length !== we.length || typeof we != "string" && typeof we != "number")
          break;
        const Ne = Number(we);
        if (Number.isNaN(Ne) || !Number.isFinite(Ne))
          break;
        return ve == C.ScalarType.FLOAT && (0, s.assertFloat32)(Ne), Ne;
      // int32, fixed32, uint32: JSON value will be a decimal number. Either numbers or strings are accepted.
      case C.ScalarType.INT32:
      case C.ScalarType.FIXED32:
      case C.ScalarType.SFIXED32:
      case C.ScalarType.SINT32:
      case C.ScalarType.UINT32:
        let rr;
        if (typeof we == "number" ? rr = we : typeof we == "string" && we.length > 0 && we.trim().length === we.length && (rr = Number(we)), rr === void 0)
          break;
        return ve == C.ScalarType.UINT32 || ve == C.ScalarType.FIXED32 ? (0, s.assertUInt32)(rr) : (0, s.assertInt32)(rr), rr;
      // int64, fixed64, uint64: JSON value will be a decimal string. Either numbers or strings are accepted.
      case C.ScalarType.INT64:
      case C.ScalarType.SFIXED64:
      case C.ScalarType.SINT64:
        if (typeof we != "number" && typeof we != "string")
          break;
        const er = A.protoInt64.parse(we);
        return Ce ? er.toString() : er;
      case C.ScalarType.FIXED64:
      case C.ScalarType.UINT64:
        if (typeof we != "number" && typeof we != "string")
          break;
        const ir = A.protoInt64.uParse(we);
        return Ce ? ir.toString() : ir;
      // bool:
      case C.ScalarType.BOOL:
        if (typeof we != "boolean")
          break;
        return we;
      // string:
      case C.ScalarType.STRING:
        if (typeof we != "string")
          break;
        try {
          encodeURIComponent(we);
        } catch {
          throw new Error("invalid UTF8");
        }
        return we;
      // bytes: JSON value will be the data encoded as a string using standard base64 encoding with paddings.
      // Either standard or URL-safe base64 encoding with/without paddings are accepted.
      case C.ScalarType.BYTES:
        if (we === "")
          return new Uint8Array(0);
        if (typeof we != "string")
          break;
        return u.protoBase64.dec(we);
    }
    throw new Error();
  }
  function Te(ve, we, Ce, Se) {
    if (we === null)
      return ve.typeName == "google.protobuf.NullValue" ? 0 : Se ? ve.values[0].no : F;
    switch (typeof we) {
      case "number":
        if (Number.isInteger(we))
          return we;
        break;
      case "string":
        const Ne = ve.findName(we);
        if (Ne !== void 0)
          return Ne.no;
        if (Ce)
          return le;
        break;
    }
    throw new Error(`cannot decode enum ${ve.typeName} from JSON: ${pe(we)}`);
  }
  function Qe(ve) {
    return ve.repeated || ve.kind == "map" ? !0 : !(ve.oneof || ve.kind == "message" || ve.opt || ve.req);
  }
  function xe(ve, we, Ce) {
    if (ve.kind == "map") {
      (0, s.assert)(typeof we == "object" && we != null);
      const Se = {}, Ne = Object.entries(we);
      switch (ve.V.kind) {
        case "scalar":
          for (const [er, ir] of Ne)
            Se[er.toString()] = He(ve.V.T, ir);
          break;
        case "message":
          for (const [er, ir] of Ne)
            Se[er.toString()] = ir.toJson(Ce);
          break;
        case "enum":
          const rr = ve.V.T;
          for (const [er, ir] of Ne)
            Se[er.toString()] = Ee(rr, ir, Ce.enumAsInteger);
          break;
      }
      return Ce.emitDefaultValues || Ne.length > 0 ? Se : void 0;
    }
    if (ve.repeated) {
      (0, s.assert)(Array.isArray(we));
      const Se = [];
      switch (ve.kind) {
        case "scalar":
          for (let Ne = 0; Ne < we.length; Ne++)
            Se.push(He(ve.T, we[Ne]));
          break;
        case "enum":
          for (let Ne = 0; Ne < we.length; Ne++)
            Se.push(Ee(ve.T, we[Ne], Ce.enumAsInteger));
          break;
        case "message":
          for (let Ne = 0; Ne < we.length; Ne++)
            Se.push(we[Ne].toJson(Ce));
          break;
      }
      return Ce.emitDefaultValues || Se.length > 0 ? Se : void 0;
    }
    switch (ve.kind) {
      case "scalar":
        return He(ve.T, we);
      case "enum":
        return Ee(ve.T, we, Ce.enumAsInteger);
      case "message":
        return (0, m.wrapField)(ve.T, we).toJson(Ce);
    }
  }
  function Ee(ve, we, Ce) {
    var Se;
    if ((0, s.assert)(typeof we == "number"), ve.typeName == "google.protobuf.NullValue")
      return null;
    if (Ce)
      return we;
    const Ne = ve.findNumber(we);
    return (Se = Ne == null ? void 0 : Ne.name) !== null && Se !== void 0 ? Se : we;
  }
  function He(ve, we) {
    switch (ve) {
      // int32, fixed32, uint32: JSON value will be a decimal number. Either numbers or strings are accepted.
      case C.ScalarType.INT32:
      case C.ScalarType.SFIXED32:
      case C.ScalarType.SINT32:
      case C.ScalarType.FIXED32:
      case C.ScalarType.UINT32:
        return (0, s.assert)(typeof we == "number"), we;
      // float, double: JSON value will be a number or one of the special string values "NaN", "Infinity", and "-Infinity".
      // Either numbers or strings are accepted. Exponent notation is also accepted.
      case C.ScalarType.FLOAT:
      // assertFloat32(value);
      case C.ScalarType.DOUBLE:
        return (0, s.assert)(typeof we == "number"), Number.isNaN(we) ? "NaN" : we === Number.POSITIVE_INFINITY ? "Infinity" : we === Number.NEGATIVE_INFINITY ? "-Infinity" : we;
      // string:
      case C.ScalarType.STRING:
        return (0, s.assert)(typeof we == "string"), we;
      // bool:
      case C.ScalarType.BOOL:
        return (0, s.assert)(typeof we == "boolean"), we;
      // JSON value will be a decimal string. Either numbers or strings are accepted.
      case C.ScalarType.UINT64:
      case C.ScalarType.FIXED64:
      case C.ScalarType.INT64:
      case C.ScalarType.SFIXED64:
      case C.ScalarType.SINT64:
        return (0, s.assert)(typeof we == "bigint" || typeof we == "string" || typeof we == "number"), we.toString();
      // bytes: JSON value will be the data encoded as a string using standard base64 encoding with paddings.
      // Either standard or URL-safe base64 encoding with/without paddings are accepted.
      case C.ScalarType.BYTES:
        return (0, s.assert)(we instanceof Uint8Array), u.protoBase64.enc(we);
    }
  }
  return jsonFormat;
}
var binaryFormat = {}, binaryEncoding = {}, hasRequiredBinaryEncoding;
function requireBinaryEncoding() {
  if (hasRequiredBinaryEncoding) return binaryEncoding;
  hasRequiredBinaryEncoding = 1, Object.defineProperty(binaryEncoding, "__esModule", { value: !0 }), binaryEncoding.BinaryReader = binaryEncoding.BinaryWriter = binaryEncoding.WireType = void 0;
  const s = requireVarint$3(), A = requireAssert$1(), u = requireProtoInt64();
  var p;
  (function(m) {
    m[m.Varint = 0] = "Varint", m[m.Bit64 = 1] = "Bit64", m[m.LengthDelimited = 2] = "LengthDelimited", m[m.StartGroup = 3] = "StartGroup", m[m.EndGroup = 4] = "EndGroup", m[m.Bit32 = 5] = "Bit32";
  })(p || (binaryEncoding.WireType = p = {}));
  class t {
    constructor(b) {
      this.stack = [], this.textEncoder = b ?? new TextEncoder(), this.chunks = [], this.buf = [];
    }
    /**
     * Return all bytes written and reset this writer.
     */
    finish() {
      this.chunks.push(new Uint8Array(this.buf));
      let b = 0;
      for (let B = 0; B < this.chunks.length; B++)
        b += this.chunks[B].length;
      let k = new Uint8Array(b), C = 0;
      for (let B = 0; B < this.chunks.length; B++)
        k.set(this.chunks[B], C), C += this.chunks[B].length;
      return this.chunks = [], k;
    }
    /**
     * Start a new fork for length-delimited data like a message
     * or a packed repeated field.
     *
     * Must be joined later with `join()`.
     */
    fork() {
      return this.stack.push({ chunks: this.chunks, buf: this.buf }), this.chunks = [], this.buf = [], this;
    }
    /**
     * Join the last fork. Write its length and bytes, then
     * return to the previous state.
     */
    join() {
      let b = this.finish(), k = this.stack.pop();
      if (!k)
        throw new Error("invalid state, fork stack empty");
      return this.chunks = k.chunks, this.buf = k.buf, this.uint32(b.byteLength), this.raw(b);
    }
    /**
     * Writes a tag (field number and wire type).
     *
     * Equivalent to `uint32( (fieldNo << 3 | type) >>> 0 )`.
     *
     * Generated code should compute the tag ahead of time and call `uint32()`.
     */
    tag(b, k) {
      return this.uint32((b << 3 | k) >>> 0);
    }
    /**
     * Write a chunk of raw bytes.
     */
    raw(b) {
      return this.buf.length && (this.chunks.push(new Uint8Array(this.buf)), this.buf = []), this.chunks.push(b), this;
    }
    /**
     * Write a `uint32` value, an unsigned 32 bit varint.
     */
    uint32(b) {
      for ((0, A.assertUInt32)(b); b > 127; )
        this.buf.push(b & 127 | 128), b = b >>> 7;
      return this.buf.push(b), this;
    }
    /**
     * Write a `int32` value, a signed 32 bit varint.
     */
    int32(b) {
      return (0, A.assertInt32)(b), (0, s.varint32write)(b, this.buf), this;
    }
    /**
     * Write a `bool` value, a variant.
     */
    bool(b) {
      return this.buf.push(b ? 1 : 0), this;
    }
    /**
     * Write a `bytes` value, length-delimited arbitrary data.
     */
    bytes(b) {
      return this.uint32(b.byteLength), this.raw(b);
    }
    /**
     * Write a `string` value, length-delimited data converted to UTF-8 text.
     */
    string(b) {
      let k = this.textEncoder.encode(b);
      return this.uint32(k.byteLength), this.raw(k);
    }
    /**
     * Write a `float` value, 32-bit floating point number.
     */
    float(b) {
      (0, A.assertFloat32)(b);
      let k = new Uint8Array(4);
      return new DataView(k.buffer).setFloat32(0, b, !0), this.raw(k);
    }
    /**
     * Write a `double` value, a 64-bit floating point number.
     */
    double(b) {
      let k = new Uint8Array(8);
      return new DataView(k.buffer).setFloat64(0, b, !0), this.raw(k);
    }
    /**
     * Write a `fixed32` value, an unsigned, fixed-length 32-bit integer.
     */
    fixed32(b) {
      (0, A.assertUInt32)(b);
      let k = new Uint8Array(4);
      return new DataView(k.buffer).setUint32(0, b, !0), this.raw(k);
    }
    /**
     * Write a `sfixed32` value, a signed, fixed-length 32-bit integer.
     */
    sfixed32(b) {
      (0, A.assertInt32)(b);
      let k = new Uint8Array(4);
      return new DataView(k.buffer).setInt32(0, b, !0), this.raw(k);
    }
    /**
     * Write a `sint32` value, a signed, zigzag-encoded 32-bit varint.
     */
    sint32(b) {
      return (0, A.assertInt32)(b), b = (b << 1 ^ b >> 31) >>> 0, (0, s.varint32write)(b, this.buf), this;
    }
    /**
     * Write a `fixed64` value, a signed, fixed-length 64-bit integer.
     */
    sfixed64(b) {
      let k = new Uint8Array(8), C = new DataView(k.buffer), B = u.protoInt64.enc(b);
      return C.setInt32(0, B.lo, !0), C.setInt32(4, B.hi, !0), this.raw(k);
    }
    /**
     * Write a `fixed64` value, an unsigned, fixed-length 64 bit integer.
     */
    fixed64(b) {
      let k = new Uint8Array(8), C = new DataView(k.buffer), B = u.protoInt64.uEnc(b);
      return C.setInt32(0, B.lo, !0), C.setInt32(4, B.hi, !0), this.raw(k);
    }
    /**
     * Write a `int64` value, a signed 64-bit varint.
     */
    int64(b) {
      let k = u.protoInt64.enc(b);
      return (0, s.varint64write)(k.lo, k.hi, this.buf), this;
    }
    /**
     * Write a `sint64` value, a signed, zig-zag-encoded 64-bit varint.
     */
    sint64(b) {
      let k = u.protoInt64.enc(b), C = k.hi >> 31, B = k.lo << 1 ^ C, Q = (k.hi << 1 | k.lo >>> 31) ^ C;
      return (0, s.varint64write)(B, Q, this.buf), this;
    }
    /**
     * Write a `uint64` value, an unsigned 64-bit varint.
     */
    uint64(b) {
      let k = u.protoInt64.uEnc(b);
      return (0, s.varint64write)(k.lo, k.hi, this.buf), this;
    }
  }
  binaryEncoding.BinaryWriter = t;
  class l {
    constructor(b, k) {
      this.varint64 = s.varint64read, this.uint32 = s.varint32read, this.buf = b, this.len = b.length, this.pos = 0, this.view = new DataView(b.buffer, b.byteOffset, b.byteLength), this.textDecoder = k ?? new TextDecoder();
    }
    /**
     * Reads a tag - field number and wire type.
     */
    tag() {
      let b = this.uint32(), k = b >>> 3, C = b & 7;
      if (k <= 0 || C < 0 || C > 5)
        throw new Error("illegal tag: field no " + k + " wire type " + C);
      return [k, C];
    }
    /**
     * Skip one element and return the skipped data.
     *
     * When skipping StartGroup, provide the tags field number to check for
     * matching field number in the EndGroup tag.
     */
    skip(b, k) {
      let C = this.pos;
      switch (b) {
        case p.Varint:
          for (; this.buf[this.pos++] & 128; )
            ;
          break;
        // eslint-disable-next-line
        // @ts-ignore TS7029: Fallthrough case in switch
        case p.Bit64:
          this.pos += 4;
        // eslint-disable-next-line
        // @ts-ignore TS7029: Fallthrough case in switch
        case p.Bit32:
          this.pos += 4;
          break;
        case p.LengthDelimited:
          let B = this.uint32();
          this.pos += B;
          break;
        case p.StartGroup:
          for (; ; ) {
            const [Q, P] = this.tag();
            if (P === p.EndGroup) {
              if (k !== void 0 && Q !== k)
                throw new Error("invalid end group tag");
              break;
            }
            this.skip(P, Q);
          }
          break;
        default:
          throw new Error("cant skip wire type " + b);
      }
      return this.assertBounds(), this.buf.subarray(C, this.pos);
    }
    /**
     * Throws error if position in byte array is out of range.
     */
    assertBounds() {
      if (this.pos > this.len)
        throw new RangeError("premature EOF");
    }
    /**
     * Read a `int32` field, a signed 32 bit varint.
     */
    int32() {
      return this.uint32() | 0;
    }
    /**
     * Read a `sint32` field, a signed, zigzag-encoded 32-bit varint.
     */
    sint32() {
      let b = this.uint32();
      return b >>> 1 ^ -(b & 1);
    }
    /**
     * Read a `int64` field, a signed 64-bit varint.
     */
    int64() {
      return u.protoInt64.dec(...this.varint64());
    }
    /**
     * Read a `uint64` field, an unsigned 64-bit varint.
     */
    uint64() {
      return u.protoInt64.uDec(...this.varint64());
    }
    /**
     * Read a `sint64` field, a signed, zig-zag-encoded 64-bit varint.
     */
    sint64() {
      let [b, k] = this.varint64(), C = -(b & 1);
      return b = (b >>> 1 | (k & 1) << 31) ^ C, k = k >>> 1 ^ C, u.protoInt64.dec(b, k);
    }
    /**
     * Read a `bool` field, a variant.
     */
    bool() {
      let [b, k] = this.varint64();
      return b !== 0 || k !== 0;
    }
    /**
     * Read a `fixed32` field, an unsigned, fixed-length 32-bit integer.
     */
    fixed32() {
      return this.view.getUint32((this.pos += 4) - 4, !0);
    }
    /**
     * Read a `sfixed32` field, a signed, fixed-length 32-bit integer.
     */
    sfixed32() {
      return this.view.getInt32((this.pos += 4) - 4, !0);
    }
    /**
     * Read a `fixed64` field, an unsigned, fixed-length 64 bit integer.
     */
    fixed64() {
      return u.protoInt64.uDec(this.sfixed32(), this.sfixed32());
    }
    /**
     * Read a `fixed64` field, a signed, fixed-length 64-bit integer.
     */
    sfixed64() {
      return u.protoInt64.dec(this.sfixed32(), this.sfixed32());
    }
    /**
     * Read a `float` field, 32-bit floating point number.
     */
    float() {
      return this.view.getFloat32((this.pos += 4) - 4, !0);
    }
    /**
     * Read a `double` field, a 64-bit floating point number.
     */
    double() {
      return this.view.getFloat64((this.pos += 8) - 8, !0);
    }
    /**
     * Read a `bytes` field, length-delimited arbitrary data.
     */
    bytes() {
      let b = this.uint32(), k = this.pos;
      return this.pos += b, this.assertBounds(), this.buf.subarray(k, k + b);
    }
    /**
     * Read a `string` field, length-delimited data converted to UTF-8 text.
     */
    string() {
      return this.textDecoder.decode(this.bytes());
    }
  }
  return binaryEncoding.BinaryReader = l, binaryEncoding;
}
var hasRequiredBinaryFormat;
function requireBinaryFormat() {
  if (hasRequiredBinaryFormat) return binaryFormat;
  hasRequiredBinaryFormat = 1, Object.defineProperty(binaryFormat, "__esModule", { value: !0 }), binaryFormat.writeMapEntry = binaryFormat.makeBinaryFormat = void 0;
  const s = requireBinaryEncoding(), A = requireFieldWrapper(), u = requireScalars(), p = requireAssert$1(), t = requireReflect(), l = requireScalar(), m = requireIsMessage(), b = Symbol("@bufbuild/protobuf/unknown-fields"), k = {
    readUnknownFields: !0,
    readerFactory: (xe) => new s.BinaryReader(xe)
  }, C = {
    writeUnknownFields: !0,
    writerFactory: () => new s.BinaryWriter()
  };
  function B(xe) {
    return xe ? Object.assign(Object.assign({}, k), xe) : k;
  }
  function Q(xe) {
    return xe ? Object.assign(Object.assign({}, C), xe) : C;
  }
  function P() {
    return {
      makeReadOptions: B,
      makeWriteOptions: Q,
      listUnknownFields(xe) {
        var Ee;
        return (Ee = xe[b]) !== null && Ee !== void 0 ? Ee : [];
      },
      discardUnknownFields(xe) {
        delete xe[b];
      },
      writeUnknownFields(xe, Ee) {
        const ve = xe[b];
        if (ve)
          for (const we of ve)
            Ee.tag(we.no, we.wireType).raw(we.data);
      },
      onUnknownField(xe, Ee, He, ve) {
        const we = xe;
        Array.isArray(we[b]) || (we[b] = []), we[b].push({ no: Ee, wireType: He, data: ve });
      },
      readMessage(xe, Ee, He, ve, we) {
        const Ce = xe.getType(), Se = we ? Ee.len : Ee.pos + He;
        let Ne, rr;
        for (; Ee.pos < Se && ([Ne, rr] = Ee.tag(), !(we === !0 && rr == s.WireType.EndGroup)); ) {
          const er = Ce.fields.find(Ne);
          if (!er) {
            const ir = Ee.skip(rr, Ne);
            ve.readUnknownFields && this.onUnknownField(xe, Ne, rr, ir);
            continue;
          }
          x(xe, Ee, er, rr, ve);
        }
        if (we && // eslint-disable-line @typescript-eslint/strict-boolean-expressions
        (rr != s.WireType.EndGroup || Ne !== He))
          throw new Error("invalid end group tag");
      },
      readField: x,
      writeMessage(xe, Ee, He) {
        const ve = xe.getType();
        for (const we of ve.fields.byNumber()) {
          if (!(0, t.isFieldSet)(we, xe)) {
            if (we.req)
              throw new Error(`cannot encode field ${ve.typeName}.${we.name} to binary: required field not set`);
            continue;
          }
          const Ce = we.oneof ? xe[we.oneof.localName].value : xe[we.localName];
          pe(we, Ce, Ee, He);
        }
        return He.writeUnknownFields && this.writeUnknownFields(xe, Ee), Ee;
      },
      writeField(xe, Ee, He, ve) {
        Ee !== void 0 && pe(xe, Ee, He, ve);
      }
    };
  }
  binaryFormat.makeBinaryFormat = P;
  function x(xe, Ee, He, ve, we) {
    let { repeated: Ce, localName: Se } = He;
    switch (He.oneof && (xe = xe[He.oneof.localName], xe.case != Se && delete xe.value, xe.case = Se, Se = "value"), He.kind) {
      case "scalar":
      case "enum":
        const Ne = He.kind == "enum" ? l.ScalarType.INT32 : He.T;
        let rr = ge;
        if (He.kind == "scalar" && He.L > 0 && (rr = le), Ce) {
          let nr = xe[Se];
          if (ve == s.WireType.LengthDelimited && Ne != l.ScalarType.STRING && Ne != l.ScalarType.BYTES) {
            let lr = Ee.uint32() + Ee.pos;
            for (; Ee.pos < lr; )
              nr.push(rr(Ee, Ne));
          } else
            nr.push(rr(Ee, Ne));
        } else
          xe[Se] = rr(Ee, Ne);
        break;
      case "message":
        const er = He.T;
        Ce ? xe[Se].push(M(Ee, new er(), we, He)) : (0, m.isMessage)(xe[Se]) ? M(Ee, xe[Se], we, He) : (xe[Se] = M(Ee, new er(), we, He), er.fieldWrapper && !He.oneof && !He.repeated && (xe[Se] = er.fieldWrapper.unwrapField(xe[Se])));
        break;
      case "map":
        let [ir, sr] = F(He, Ee, we);
        xe[Se][ir] = sr;
        break;
    }
  }
  function M(xe, Ee, He, ve) {
    const we = Ee.getType().runtime.bin, Ce = ve == null ? void 0 : ve.delimited;
    return we.readMessage(
      Ee,
      xe,
      Ce ? ve.no : xe.uint32(),
      // eslint-disable-line @typescript-eslint/strict-boolean-expressions
      He,
      Ce
    ), Ee;
  }
  function F(xe, Ee, He) {
    const ve = Ee.uint32(), we = Ee.pos + ve;
    let Ce, Se;
    for (; Ee.pos < we; ) {
      const [Ne] = Ee.tag();
      switch (Ne) {
        case 1:
          Ce = ge(Ee, xe.K);
          break;
        case 2:
          switch (xe.V.kind) {
            case "scalar":
              Se = ge(Ee, xe.V.T);
              break;
            case "enum":
              Se = Ee.int32();
              break;
            case "message":
              Se = M(Ee, new xe.V.T(), He, void 0);
              break;
          }
          break;
      }
    }
    if (Ce === void 0 && (Ce = (0, u.scalarZeroValue)(xe.K, l.LongType.BIGINT)), typeof Ce != "string" && typeof Ce != "number" && (Ce = Ce.toString()), Se === void 0)
      switch (xe.V.kind) {
        case "scalar":
          Se = (0, u.scalarZeroValue)(xe.V.T, l.LongType.BIGINT);
          break;
        case "enum":
          Se = xe.V.T.values[0].no;
          break;
        case "message":
          Se = new xe.V.T();
          break;
      }
    return [Ce, Se];
  }
  function le(xe, Ee) {
    const He = ge(xe, Ee);
    return typeof He == "bigint" ? He.toString() : He;
  }
  function ge(xe, Ee) {
    switch (Ee) {
      case l.ScalarType.STRING:
        return xe.string();
      case l.ScalarType.BOOL:
        return xe.bool();
      case l.ScalarType.DOUBLE:
        return xe.double();
      case l.ScalarType.FLOAT:
        return xe.float();
      case l.ScalarType.INT32:
        return xe.int32();
      case l.ScalarType.INT64:
        return xe.int64();
      case l.ScalarType.UINT64:
        return xe.uint64();
      case l.ScalarType.FIXED64:
        return xe.fixed64();
      case l.ScalarType.BYTES:
        return xe.bytes();
      case l.ScalarType.FIXED32:
        return xe.fixed32();
      case l.ScalarType.SFIXED32:
        return xe.sfixed32();
      case l.ScalarType.SFIXED64:
        return xe.sfixed64();
      case l.ScalarType.SINT64:
        return xe.sint64();
      case l.ScalarType.UINT32:
        return xe.uint32();
      case l.ScalarType.SINT32:
        return xe.sint32();
    }
  }
  function pe(xe, Ee, He, ve) {
    (0, p.assert)(Ee !== void 0);
    const we = xe.repeated;
    switch (xe.kind) {
      case "scalar":
      case "enum":
        let Ce = xe.kind == "enum" ? l.ScalarType.INT32 : xe.T;
        if (we)
          if ((0, p.assert)(Array.isArray(Ee)), xe.packed)
            Te(He, Ce, xe.no, Ee);
          else
            for (const Se of Ee)
              Pe(He, Ce, xe.no, Se);
        else
          Pe(He, Ce, xe.no, Ee);
        break;
      case "message":
        if (we) {
          (0, p.assert)(Array.isArray(Ee));
          for (const Se of Ee)
            be(He, ve, xe, Se);
        } else
          be(He, ve, xe, Ee);
        break;
      case "map":
        (0, p.assert)(typeof Ee == "object" && Ee != null);
        for (const [Se, Ne] of Object.entries(Ee))
          Ie(He, ve, xe, Se, Ne);
        break;
    }
  }
  function Ie(xe, Ee, He, ve, we) {
    xe.tag(He.no, s.WireType.LengthDelimited), xe.fork();
    let Ce = ve;
    switch (He.K) {
      case l.ScalarType.INT32:
      case l.ScalarType.FIXED32:
      case l.ScalarType.UINT32:
      case l.ScalarType.SFIXED32:
      case l.ScalarType.SINT32:
        Ce = Number.parseInt(ve);
        break;
      case l.ScalarType.BOOL:
        (0, p.assert)(ve == "true" || ve == "false"), Ce = ve == "true";
        break;
    }
    switch (Pe(xe, He.K, 1, Ce), He.V.kind) {
      case "scalar":
        Pe(xe, He.V.T, 2, we);
        break;
      case "enum":
        Pe(xe, l.ScalarType.INT32, 2, we);
        break;
      case "message":
        (0, p.assert)(we !== void 0), xe.tag(2, s.WireType.LengthDelimited).bytes(we.toBinary(Ee));
        break;
    }
    xe.join();
  }
  binaryFormat.writeMapEntry = Ie;
  function be(xe, Ee, He, ve) {
    const we = (0, A.wrapField)(He.T, ve);
    He.delimited ? xe.tag(He.no, s.WireType.StartGroup).raw(we.toBinary(Ee)).tag(He.no, s.WireType.EndGroup) : xe.tag(He.no, s.WireType.LengthDelimited).bytes(we.toBinary(Ee));
  }
  function Pe(xe, Ee, He, ve) {
    (0, p.assert)(ve !== void 0);
    let [we, Ce] = Qe(Ee);
    xe.tag(He, we)[Ce](ve);
  }
  function Te(xe, Ee, He, ve) {
    if (!ve.length)
      return;
    xe.tag(He, s.WireType.LengthDelimited).fork();
    let [, we] = Qe(Ee);
    for (let Ce = 0; Ce < ve.length; Ce++)
      xe[we](ve[Ce]);
    xe.join();
  }
  function Qe(xe) {
    let Ee = s.WireType.Varint;
    switch (xe) {
      case l.ScalarType.BYTES:
      case l.ScalarType.STRING:
        Ee = s.WireType.LengthDelimited;
        break;
      case l.ScalarType.DOUBLE:
      case l.ScalarType.FIXED64:
      case l.ScalarType.SFIXED64:
        Ee = s.WireType.Bit64;
        break;
      case l.ScalarType.FIXED32:
      case l.ScalarType.SFIXED32:
      case l.ScalarType.FLOAT:
        Ee = s.WireType.Bit32;
        break;
    }
    const He = l.ScalarType[xe].toLowerCase();
    return [Ee, He];
  }
  return binaryFormat;
}
var utilCommon = {}, hasRequiredUtilCommon;
function requireUtilCommon() {
  if (hasRequiredUtilCommon) return utilCommon;
  hasRequiredUtilCommon = 1, Object.defineProperty(utilCommon, "__esModule", { value: !0 }), utilCommon.makeUtilCommon = void 0;
  const s = require_enum(), A = requireScalars(), u = requireScalar(), p = requireIsMessage();
  function t() {
    return {
      setEnumType: s.setEnumType,
      initPartial(b, k) {
        if (b === void 0)
          return;
        const C = k.getType();
        for (const B of C.fields.byMember()) {
          const Q = B.localName, P = k, x = b;
          if (x[Q] != null)
            switch (B.kind) {
              case "oneof":
                const M = x[Q].case;
                if (M === void 0)
                  continue;
                const F = B.findField(M);
                let le = x[Q].value;
                F && F.kind == "message" && !(0, p.isMessage)(le, F.T) ? le = new F.T(le) : F && F.kind === "scalar" && F.T === u.ScalarType.BYTES && (le = m(le)), P[Q] = { case: M, value: le };
                break;
              case "scalar":
              case "enum":
                let ge = x[Q];
                B.T === u.ScalarType.BYTES && (ge = B.repeated ? ge.map(m) : m(ge)), P[Q] = ge;
                break;
              case "map":
                switch (B.V.kind) {
                  case "scalar":
                  case "enum":
                    if (B.V.T === u.ScalarType.BYTES)
                      for (const [be, Pe] of Object.entries(x[Q]))
                        P[Q][be] = m(Pe);
                    else
                      Object.assign(P[Q], x[Q]);
                    break;
                  case "message":
                    const Ie = B.V.T;
                    for (const be of Object.keys(x[Q])) {
                      let Pe = x[Q][be];
                      Ie.fieldWrapper || (Pe = new Ie(Pe)), P[Q][be] = Pe;
                    }
                    break;
                }
                break;
              case "message":
                const pe = B.T;
                if (B.repeated)
                  P[Q] = x[Q].map((Ie) => (0, p.isMessage)(Ie, pe) ? Ie : new pe(Ie));
                else {
                  const Ie = x[Q];
                  pe.fieldWrapper ? /* We can't use BytesValue.typeName as that will create a circular import */ pe.typeName === "google.protobuf.BytesValue" ? P[Q] = m(Ie) : P[Q] = Ie : P[Q] = (0, p.isMessage)(Ie, pe) ? Ie : new pe(Ie);
                }
                break;
            }
        }
      },
      // TODO use isFieldSet() here to support future field presence
      equals(b, k, C) {
        return k === C ? !0 : !k || !C ? !1 : b.fields.byMember().every((B) => {
          const Q = k[B.localName], P = C[B.localName];
          if (B.repeated) {
            if (Q.length !== P.length)
              return !1;
            switch (B.kind) {
              case "message":
                return Q.every((x, M) => B.T.equals(x, P[M]));
              case "scalar":
                return Q.every((x, M) => (0, A.scalarEquals)(B.T, x, P[M]));
              case "enum":
                return Q.every((x, M) => (0, A.scalarEquals)(u.ScalarType.INT32, x, P[M]));
            }
            throw new Error(`repeated cannot contain ${B.kind}`);
          }
          switch (B.kind) {
            case "message":
              let x = Q, M = P;
              return B.T.fieldWrapper && (x !== void 0 && !(0, p.isMessage)(x) && (x = B.T.fieldWrapper.wrapField(x)), M !== void 0 && !(0, p.isMessage)(M) && (M = B.T.fieldWrapper.wrapField(M))), B.T.equals(x, M);
            case "enum":
              return (0, A.scalarEquals)(u.ScalarType.INT32, Q, P);
            case "scalar":
              return (0, A.scalarEquals)(B.T, Q, P);
            case "oneof":
              if (Q.case !== P.case)
                return !1;
              const F = B.findField(Q.case);
              if (F === void 0)
                return !0;
              switch (F.kind) {
                case "message":
                  return F.T.equals(Q.value, P.value);
                case "enum":
                  return (0, A.scalarEquals)(u.ScalarType.INT32, Q.value, P.value);
                case "scalar":
                  return (0, A.scalarEquals)(F.T, Q.value, P.value);
              }
              throw new Error(`oneof cannot contain ${F.kind}`);
            case "map":
              const le = Object.keys(Q).concat(Object.keys(P));
              switch (B.V.kind) {
                case "message":
                  const ge = B.V.T;
                  return le.every((Ie) => ge.equals(Q[Ie], P[Ie]));
                case "enum":
                  return le.every((Ie) => (0, A.scalarEquals)(u.ScalarType.INT32, Q[Ie], P[Ie]));
                case "scalar":
                  const pe = B.V.T;
                  return le.every((Ie) => (0, A.scalarEquals)(pe, Q[Ie], P[Ie]));
              }
              break;
          }
        });
      },
      // TODO use isFieldSet() here to support future field presence
      clone(b) {
        const k = b.getType(), C = new k(), B = C;
        for (const Q of k.fields.byMember()) {
          const P = b[Q.localName];
          let x;
          if (Q.repeated)
            x = P.map(l);
          else if (Q.kind == "map") {
            x = B[Q.localName];
            for (const [M, F] of Object.entries(P))
              x[M] = l(F);
          } else Q.kind == "oneof" ? x = Q.findField(P.case) ? { case: P.case, value: l(P.value) } : { case: void 0 } : x = l(P);
          B[Q.localName] = x;
        }
        for (const Q of k.runtime.bin.listUnknownFields(b))
          k.runtime.bin.onUnknownField(B, Q.no, Q.wireType, Q.data);
        return C;
      }
    };
  }
  utilCommon.makeUtilCommon = t;
  function l(b) {
    if (b === void 0)
      return b;
    if ((0, p.isMessage)(b))
      return b.clone();
    if (b instanceof Uint8Array) {
      const k = new Uint8Array(b.byteLength);
      return k.set(b), k;
    }
    return b;
  }
  function m(b) {
    return b instanceof Uint8Array ? b : new Uint8Array(b);
  }
  return utilCommon;
}
var hasRequiredProtoRuntime;
function requireProtoRuntime() {
  if (hasRequiredProtoRuntime) return protoRuntime;
  hasRequiredProtoRuntime = 1, Object.defineProperty(protoRuntime, "__esModule", { value: !0 }), protoRuntime.makeProtoRuntime = void 0;
  const s = require_enum(), A = requireMessageType(), u = requireExtensions(), p = requireJsonFormat(), t = requireBinaryFormat(), l = requireUtilCommon();
  function m(b, k, C) {
    return {
      syntax: b,
      json: (0, p.makeJsonFormat)(),
      bin: (0, t.makeBinaryFormat)(),
      util: Object.assign(Object.assign({}, (0, l.makeUtilCommon)()), {
        newFieldList: k,
        initFields: C
      }),
      makeMessageType(B, Q, P) {
        return (0, A.makeMessageType)(this, B, Q, P);
      },
      makeEnum: s.makeEnum,
      makeEnumType: s.makeEnumType,
      getEnumType: s.getEnumType,
      makeExtension(B, Q, P) {
        return (0, u.makeExtension)(this, B, Q, P);
      }
    };
  }
  return protoRuntime.makeProtoRuntime = m, protoRuntime;
}
var fieldList = {}, hasRequiredFieldList;
function requireFieldList() {
  if (hasRequiredFieldList) return fieldList;
  hasRequiredFieldList = 1, Object.defineProperty(fieldList, "__esModule", { value: !0 }), fieldList.InternalFieldList = void 0;
  class s {
    constructor(u, p) {
      this._fields = u, this._normalizer = p;
    }
    findJsonName(u) {
      if (!this.jsonNames) {
        const p = {};
        for (const t of this.list())
          p[t.jsonName] = p[t.name] = t;
        this.jsonNames = p;
      }
      return this.jsonNames[u];
    }
    find(u) {
      if (!this.numbers) {
        const p = {};
        for (const t of this.list())
          p[t.no] = t;
        this.numbers = p;
      }
      return this.numbers[u];
    }
    list() {
      return this.all || (this.all = this._normalizer(this._fields)), this.all;
    }
    byNumber() {
      return this.numbersAsc || (this.numbersAsc = this.list().concat().sort((u, p) => u.no - p.no)), this.numbersAsc;
    }
    byMember() {
      if (!this.members) {
        this.members = [];
        const u = this.members;
        let p;
        for (const t of this.list())
          t.oneof ? t.oneof !== p && (p = t.oneof, u.push(p)) : u.push(t);
      }
      return this.members;
    }
  }
  return fieldList.InternalFieldList = s, fieldList;
}
var fieldNormalize = {}, field$1 = {}, names = {}, hasRequiredNames;
function requireNames() {
  return hasRequiredNames || (hasRequiredNames = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.safeIdentifier = s.safeObjectProperty = s.findEnumSharedPrefix = s.fieldJsonName = s.localOneofName = s.localFieldName = s.localName = void 0;
    function A(M) {
      switch (M.kind) {
        case "field":
          return u(M.name, M.oneof !== void 0);
        case "oneof":
          return p(M.name);
        case "enum":
        case "message":
        case "service":
        case "extension": {
          const F = M.file.proto.package, le = F === void 0 ? 0 : F.length + 1, ge = M.typeName.substring(le).replace(/\./g, "_");
          return (0, s.safeObjectProperty)((0, s.safeIdentifier)(ge));
        }
        case "enum_value": {
          let F = M.name;
          const le = M.parent.sharedPrefix;
          return le !== void 0 && (F = F.substring(le.length)), (0, s.safeObjectProperty)(F);
        }
        case "rpc": {
          let F = M.name;
          return F.length == 0 ? F : (F = F[0].toLowerCase() + F.substring(1), (0, s.safeObjectProperty)(F));
        }
      }
    }
    s.localName = A;
    function u(M, F) {
      const le = m(M);
      return F ? le : (0, s.safeObjectProperty)(Q(le));
    }
    s.localFieldName = u;
    function p(M) {
      return u(M, !1);
    }
    s.localOneofName = p, s.fieldJsonName = m;
    function t(M, F) {
      const le = l(M) + "_";
      for (const ge of F) {
        if (!ge.toLowerCase().startsWith(le))
          return;
        const pe = ge.substring(le.length);
        if (pe.length == 0 || /^\d/.test(pe))
          return;
      }
      return le;
    }
    s.findEnumSharedPrefix = t;
    function l(M) {
      return (M.substring(0, 1) + M.substring(1).replace(/[A-Z]/g, (F) => "_" + F)).toLowerCase();
    }
    function m(M) {
      let F = !1;
      const le = [];
      for (let ge = 0; ge < M.length; ge++) {
        let pe = M.charAt(ge);
        switch (pe) {
          case "_":
            F = !0;
            break;
          case "0":
          case "1":
          case "2":
          case "3":
          case "4":
          case "5":
          case "6":
          case "7":
          case "8":
          case "9":
            le.push(pe), F = !1;
            break;
          default:
            F && (F = !1, pe = pe.toUpperCase()), le.push(pe);
            break;
        }
      }
      return le.join("");
    }
    const b = /* @__PURE__ */ new Set([
      // ECMAScript 2015 keywords
      "break",
      "case",
      "catch",
      "class",
      "const",
      "continue",
      "debugger",
      "default",
      "delete",
      "do",
      "else",
      "export",
      "extends",
      "false",
      "finally",
      "for",
      "function",
      "if",
      "import",
      "in",
      "instanceof",
      "new",
      "null",
      "return",
      "super",
      "switch",
      "this",
      "throw",
      "true",
      "try",
      "typeof",
      "var",
      "void",
      "while",
      "with",
      "yield",
      // ECMAScript 2015 future reserved keywords
      "enum",
      "implements",
      "interface",
      "let",
      "package",
      "private",
      "protected",
      "public",
      "static",
      // Class name cannot be 'Object' when targeting ES5 with module CommonJS
      "Object",
      // TypeScript keywords that cannot be used for types (as opposed to variables)
      "bigint",
      "number",
      "boolean",
      "string",
      "object",
      // Identifiers reserved for the runtime, so we can generate legible code
      "globalThis",
      "Uint8Array",
      "Partial"
    ]), k = /* @__PURE__ */ new Set([
      // names reserved by JavaScript
      "constructor",
      "toString",
      "toJSON",
      "valueOf"
    ]), C = /* @__PURE__ */ new Set([
      // names reserved by the runtime
      "getType",
      "clone",
      "equals",
      "fromBinary",
      "fromJson",
      "fromJsonString",
      "toBinary",
      "toJson",
      "toJsonString",
      // names reserved by the runtime for the future
      "toObject"
    ]), B = (M) => `${M}$`, Q = (M) => C.has(M) ? B(M) : M, P = (M) => k.has(M) ? B(M) : M;
    s.safeObjectProperty = P;
    const x = (M) => b.has(M) ? B(M) : M;
    s.safeIdentifier = x;
  }(names)), names;
}
var hasRequiredField$1;
function requireField$1() {
  if (hasRequiredField$1) return field$1;
  hasRequiredField$1 = 1, Object.defineProperty(field$1, "__esModule", { value: !0 }), field$1.InternalOneofInfo = void 0;
  const s = requireNames(), A = requireAssert$1();
  class u {
    constructor(t) {
      this.kind = "oneof", this.repeated = !1, this.packed = !1, this.opt = !1, this.req = !1, this.default = void 0, this.fields = [], this.name = t, this.localName = (0, s.localOneofName)(t);
    }
    addField(t) {
      (0, A.assert)(t.oneof === this, `field ${t.name} not one of ${this.name}`), this.fields.push(t);
    }
    findField(t) {
      if (!this._lookup) {
        this._lookup = /* @__PURE__ */ Object.create(null);
        for (let l = 0; l < this.fields.length; l++)
          this._lookup[this.fields[l].localName] = this.fields[l];
      }
      return this._lookup[t];
    }
  }
  return field$1.InternalOneofInfo = u, field$1;
}
var hasRequiredFieldNormalize;
function requireFieldNormalize() {
  if (hasRequiredFieldNormalize) return fieldNormalize;
  hasRequiredFieldNormalize = 1, Object.defineProperty(fieldNormalize, "__esModule", { value: !0 }), fieldNormalize.normalizeFieldInfos = void 0;
  const s = requireField$1(), A = requireNames(), u = requireScalar();
  function p(t, l) {
    var m, b, k, C, B, Q;
    const P = [];
    let x;
    for (const M of typeof t == "function" ? t() : t) {
      const F = M;
      if (F.localName = (0, A.localFieldName)(M.name, M.oneof !== void 0), F.jsonName = (m = M.jsonName) !== null && m !== void 0 ? m : (0, A.fieldJsonName)(M.name), F.repeated = (b = M.repeated) !== null && b !== void 0 ? b : !1, M.kind == "scalar" && (F.L = (k = M.L) !== null && k !== void 0 ? k : u.LongType.BIGINT), F.delimited = (C = M.delimited) !== null && C !== void 0 ? C : !1, F.req = (B = M.req) !== null && B !== void 0 ? B : !1, F.opt = (Q = M.opt) !== null && Q !== void 0 ? Q : !1, M.packed === void 0 && (l ? F.packed = M.kind == "enum" || M.kind == "scalar" && M.T != u.ScalarType.BYTES && M.T != u.ScalarType.STRING : F.packed = !1), M.oneof !== void 0) {
        const le = typeof M.oneof == "string" ? M.oneof : M.oneof.name;
        (!x || x.name != le) && (x = new s.InternalOneofInfo(le)), F.oneof = x, x.addField(F);
      }
      P.push(F);
    }
    return P;
  }
  return fieldNormalize.normalizeFieldInfos = p, fieldNormalize;
}
var hasRequiredProto3;
function requireProto3() {
  if (hasRequiredProto3) return proto3;
  hasRequiredProto3 = 1, Object.defineProperty(proto3, "__esModule", { value: !0 }), proto3.proto3 = void 0;
  const s = requireProtoRuntime(), A = requireFieldList(), u = requireScalars(), p = requireFieldNormalize();
  return proto3.proto3 = (0, s.makeProtoRuntime)(
    "proto3",
    (t) => new A.InternalFieldList(t, (l) => (0, p.normalizeFieldInfos)(l, !0)),
    // TODO merge with proto2 and initExtensionField, also see initPartial, equals, clone
    (t) => {
      for (const l of t.getType().fields.byMember()) {
        if (l.opt)
          continue;
        const m = l.localName, b = t;
        if (l.repeated) {
          b[m] = [];
          continue;
        }
        switch (l.kind) {
          case "oneof":
            b[m] = { case: void 0 };
            break;
          case "enum":
            b[m] = 0;
            break;
          case "map":
            b[m] = {};
            break;
          case "scalar":
            b[m] = (0, u.scalarZeroValue)(l.T, l.L);
            break;
        }
      }
    }
  ), proto3;
}
var proto2 = {}, hasRequiredProto2;
function requireProto2() {
  if (hasRequiredProto2) return proto2;
  hasRequiredProto2 = 1, Object.defineProperty(proto2, "__esModule", { value: !0 }), proto2.proto2 = void 0;
  const s = requireProtoRuntime(), A = requireFieldList(), u = requireFieldNormalize();
  return proto2.proto2 = (0, s.makeProtoRuntime)(
    "proto2",
    (p) => new A.InternalFieldList(p, (t) => (0, u.normalizeFieldInfos)(t, !1)),
    // TODO merge with proto3 and initExtensionField, also see initPartial, equals, clone
    (p) => {
      for (const t of p.getType().fields.byMember()) {
        const l = t.localName, m = p;
        if (t.repeated) {
          m[l] = [];
          continue;
        }
        switch (t.kind) {
          case "oneof":
            m[l] = { case: void 0 };
            break;
          case "map":
            m[l] = {};
            break;
        }
      }
    }
  ), proto2;
}
var protoDouble = {}, hasRequiredProtoDouble;
function requireProtoDouble() {
  return hasRequiredProtoDouble || (hasRequiredProtoDouble = 1, Object.defineProperty(protoDouble, "__esModule", { value: !0 }), protoDouble.protoDouble = void 0, protoDouble.protoDouble = {
    NaN: Number.NaN,
    POSITIVE_INFINITY: Number.POSITIVE_INFINITY,
    NEGATIVE_INFINITY: Number.NEGATIVE_INFINITY
  }), protoDouble;
}
var protoDelimited = {}, hasRequiredProtoDelimited;
function requireProtoDelimited() {
  return hasRequiredProtoDelimited || (hasRequiredProtoDelimited = 1, function(s) {
    var A = protoDelimited && protoDelimited.__asyncValues || function(l) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var m = l[Symbol.asyncIterator], b;
      return m ? m.call(l) : (l = typeof __values == "function" ? __values(l) : l[Symbol.iterator](), b = {}, k("next"), k("throw"), k("return"), b[Symbol.asyncIterator] = function() {
        return this;
      }, b);
      function k(B) {
        b[B] = l[B] && function(Q) {
          return new Promise(function(P, x) {
            Q = l[B](Q), C(P, x, Q.done, Q.value);
          });
        };
      }
      function C(B, Q, P, x) {
        Promise.resolve(x).then(function(M) {
          B({ value: M, done: P });
        }, Q);
      }
    }, u = protoDelimited && protoDelimited.__await || function(l) {
      return this instanceof u ? (this.v = l, this) : new u(l);
    }, p = protoDelimited && protoDelimited.__asyncGenerator || function(l, m, b) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var k = b.apply(l, m || []), C, B = [];
      return C = {}, P("next"), P("throw"), P("return", Q), C[Symbol.asyncIterator] = function() {
        return this;
      }, C;
      function Q(pe) {
        return function(Ie) {
          return Promise.resolve(Ie).then(pe, le);
        };
      }
      function P(pe, Ie) {
        k[pe] && (C[pe] = function(be) {
          return new Promise(function(Pe, Te) {
            B.push([pe, be, Pe, Te]) > 1 || x(pe, be);
          });
        }, Ie && (C[pe] = Ie(C[pe])));
      }
      function x(pe, Ie) {
        try {
          M(k[pe](Ie));
        } catch (be) {
          ge(B[0][3], be);
        }
      }
      function M(pe) {
        pe.value instanceof u ? Promise.resolve(pe.value.v).then(F, le) : ge(B[0][2], pe);
      }
      function F(pe) {
        x("next", pe);
      }
      function le(pe) {
        x("throw", pe);
      }
      function ge(pe, Ie) {
        pe(Ie), B.shift(), B.length && x(B[0][0], B[0][1]);
      }
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), s.protoDelimited = void 0;
    const t = requireBinaryEncoding();
    s.protoDelimited = {
      /**
       * Serialize a message, prefixing it with its size.
       */
      enc(l, m) {
        const b = l.getType().runtime.bin.makeWriteOptions(m);
        return b.writerFactory().bytes(l.toBinary(b)).finish();
      },
      /**
       * Parse a size-delimited message, ignoring extra bytes.
       */
      dec(l, m, b) {
        const k = l.runtime.bin.makeReadOptions(b);
        return l.fromBinary(k.readerFactory(m).bytes(), k);
      },
      /**
       * Parse a stream of size-delimited messages.
       */
      decStream(l, m) {
        return p(this, arguments, function* () {
          var k, C, B, Q;
          function P(ge, pe) {
            const Ie = new Uint8Array(ge.byteLength + pe.byteLength);
            return Ie.set(ge), Ie.set(pe, ge.length), Ie;
          }
          let x = new Uint8Array(0);
          try {
            for (var M = !0, F = A(m), le; le = yield u(F.next()), k = le.done, !k; M = !0)
              for (Q = le.value, M = !1, x = P(x, Q); ; ) {
                const pe = s.protoDelimited.peekSize(x);
                if (pe.eof || pe.offset + pe.size > x.byteLength)
                  break;
                yield yield u(s.protoDelimited.dec(l, x)), x = x.subarray(pe.offset + pe.size);
              }
          } catch (ge) {
            C = { error: ge };
          } finally {
            try {
              !M && !k && (B = F.return) && (yield u(B.call(F)));
            } finally {
              if (C) throw C.error;
            }
          }
          if (x.byteLength > 0)
            throw new Error("incomplete data");
        });
      },
      /**
       * Decodes the size from the given size-delimited message, which may be
       * incomplete.
       *
       * Returns an object with the following properties:
       * - size: The size of the delimited message in bytes
       * - offset: The offset in the given byte array where the message starts
       * - eof: true
       *
       * If the size-delimited data does not include all bytes of the varint size,
       * the following object is returned:
       * - size: null
       * - offset: null
       * - eof: false
       *
       * This function can be used to implement parsing of size-delimited messages
       * from a stream.
       */
      peekSize(l) {
        const m = { eof: !0, size: null, offset: null };
        for (let b = 0; b < 10; b++) {
          if (b > l.byteLength)
            return m;
          if ((l[b] & 128) == 0) {
            const k = new t.BinaryReader(l);
            let C;
            try {
              C = k.uint32();
            } catch (B) {
              if (B instanceof RangeError)
                return m;
              throw B;
            }
            return {
              eof: !1,
              size: C,
              offset: k.pos
            };
          }
        }
        throw new Error("invalid varint");
      }
    };
  }(protoDelimited)), protoDelimited;
}
var codegenInfo = {}, reifyWkt = {}, hasRequiredReifyWkt;
function requireReifyWkt() {
  if (hasRequiredReifyWkt) return reifyWkt;
  hasRequiredReifyWkt = 1, Object.defineProperty(reifyWkt, "__esModule", { value: !0 }), reifyWkt.reifyWkt = void 0;
  const s = requireScalar();
  function A(u) {
    switch (u.typeName) {
      case "google.protobuf.Any": {
        const p = u.fields.find((l) => l.number == 1 && l.fieldKind == "scalar" && l.scalar === s.ScalarType.STRING), t = u.fields.find((l) => l.number == 2 && l.fieldKind == "scalar" && l.scalar === s.ScalarType.BYTES);
        if (p && t)
          return {
            typeName: u.typeName,
            typeUrl: p,
            value: t
          };
        break;
      }
      case "google.protobuf.Timestamp": {
        const p = u.fields.find((l) => l.number == 1 && l.fieldKind == "scalar" && l.scalar === s.ScalarType.INT64), t = u.fields.find((l) => l.number == 2 && l.fieldKind == "scalar" && l.scalar === s.ScalarType.INT32);
        if (p && t)
          return {
            typeName: u.typeName,
            seconds: p,
            nanos: t
          };
        break;
      }
      case "google.protobuf.Duration": {
        const p = u.fields.find((l) => l.number == 1 && l.fieldKind == "scalar" && l.scalar === s.ScalarType.INT64), t = u.fields.find((l) => l.number == 2 && l.fieldKind == "scalar" && l.scalar === s.ScalarType.INT32);
        if (p && t)
          return {
            typeName: u.typeName,
            seconds: p,
            nanos: t
          };
        break;
      }
      case "google.protobuf.Struct": {
        const p = u.fields.find((t) => t.number == 1 && !t.repeated);
        if ((p == null ? void 0 : p.fieldKind) !== "map" || p.mapValue.kind !== "message" || p.mapValue.message.typeName !== "google.protobuf.Value")
          break;
        return { typeName: u.typeName, fields: p };
      }
      case "google.protobuf.Value": {
        const p = u.oneofs.find((B) => B.name === "kind"), t = u.fields.find((B) => B.number == 1 && B.oneof === p);
        if ((t == null ? void 0 : t.fieldKind) !== "enum" || t.enum.typeName !== "google.protobuf.NullValue")
          return;
        const l = u.fields.find((B) => B.number == 2 && B.fieldKind == "scalar" && B.scalar === s.ScalarType.DOUBLE && B.oneof === p), m = u.fields.find((B) => B.number == 3 && B.fieldKind == "scalar" && B.scalar === s.ScalarType.STRING && B.oneof === p), b = u.fields.find((B) => B.number == 4 && B.fieldKind == "scalar" && B.scalar === s.ScalarType.BOOL && B.oneof === p), k = u.fields.find((B) => B.number == 5 && B.oneof === p);
        if ((k == null ? void 0 : k.fieldKind) !== "message" || k.message.typeName !== "google.protobuf.Struct")
          return;
        const C = u.fields.find((B) => B.number == 6 && B.oneof === p);
        if ((C == null ? void 0 : C.fieldKind) !== "message" || C.message.typeName !== "google.protobuf.ListValue")
          return;
        if (p && l && m && b)
          return {
            typeName: u.typeName,
            kind: p,
            nullValue: t,
            numberValue: l,
            stringValue: m,
            boolValue: b,
            structValue: k,
            listValue: C
          };
        break;
      }
      case "google.protobuf.ListValue": {
        const p = u.fields.find((t) => t.number == 1 && t.repeated);
        if ((p == null ? void 0 : p.fieldKind) != "message" || p.message.typeName !== "google.protobuf.Value")
          break;
        return { typeName: u.typeName, values: p };
      }
      case "google.protobuf.FieldMask": {
        const p = u.fields.find((t) => t.number == 1 && t.fieldKind == "scalar" && t.scalar === s.ScalarType.STRING && t.repeated);
        if (p)
          return { typeName: u.typeName, paths: p };
        break;
      }
      case "google.protobuf.DoubleValue":
      case "google.protobuf.FloatValue":
      case "google.protobuf.Int64Value":
      case "google.protobuf.UInt64Value":
      case "google.protobuf.Int32Value":
      case "google.protobuf.UInt32Value":
      case "google.protobuf.BoolValue":
      case "google.protobuf.StringValue":
      case "google.protobuf.BytesValue": {
        const p = u.fields.find((t) => t.number == 1 && t.name == "value");
        if (!p || p.fieldKind !== "scalar")
          break;
        return { typeName: u.typeName, value: p };
      }
    }
  }
  return reifyWkt.reifyWkt = A, reifyWkt;
}
var hasRequiredCodegenInfo;
function requireCodegenInfo() {
  if (hasRequiredCodegenInfo) return codegenInfo;
  hasRequiredCodegenInfo = 1, Object.defineProperty(codegenInfo, "__esModule", { value: !0 }), codegenInfo.codegenInfo = void 0;
  const s = requireNames(), A = requireFieldWrapper(), u = requireScalars(), p = requireReifyWkt(), t = "@bufbuild/protobuf";
  return codegenInfo.codegenInfo = {
    packageName: "@bufbuild/protobuf",
    localName: s.localName,
    reifyWkt: p.reifyWkt,
    getUnwrappedFieldType: A.getUnwrappedFieldType,
    scalarDefaultValue: u.scalarZeroValue,
    scalarZeroValue: u.scalarZeroValue,
    safeIdentifier: s.safeIdentifier,
    safeObjectProperty: s.safeObjectProperty,
    // prettier-ignore
    symbols: {
      proto2: { typeOnly: !1, privateImportPath: "./proto2.js", publicImportPath: t },
      proto3: { typeOnly: !1, privateImportPath: "./proto3.js", publicImportPath: t },
      Message: { typeOnly: !1, privateImportPath: "./message.js", publicImportPath: t },
      PartialMessage: { typeOnly: !0, privateImportPath: "./message.js", publicImportPath: t },
      PlainMessage: { typeOnly: !0, privateImportPath: "./message.js", publicImportPath: t },
      FieldList: { typeOnly: !0, privateImportPath: "./field-list.js", publicImportPath: t },
      MessageType: { typeOnly: !0, privateImportPath: "./message-type.js", publicImportPath: t },
      Extension: { typeOnly: !0, privateImportPath: "./extension.js", publicImportPath: t },
      BinaryReadOptions: { typeOnly: !0, privateImportPath: "./binary-format.js", publicImportPath: t },
      BinaryWriteOptions: { typeOnly: !0, privateImportPath: "./binary-format.js", publicImportPath: t },
      JsonReadOptions: { typeOnly: !0, privateImportPath: "./json-format.js", publicImportPath: t },
      JsonWriteOptions: { typeOnly: !0, privateImportPath: "./json-format.js", publicImportPath: t },
      JsonValue: { typeOnly: !0, privateImportPath: "./json-format.js", publicImportPath: t },
      JsonObject: { typeOnly: !0, privateImportPath: "./json-format.js", publicImportPath: t },
      protoDouble: { typeOnly: !1, privateImportPath: "./proto-double.js", publicImportPath: t },
      protoInt64: { typeOnly: !1, privateImportPath: "./proto-int64.js", publicImportPath: t },
      ScalarType: { typeOnly: !1, privateImportPath: "./scalar.js", publicImportPath: t },
      LongType: { typeOnly: !1, privateImportPath: "./scalar.js", publicImportPath: t },
      MethodKind: { typeOnly: !1, privateImportPath: "./service-type.js", publicImportPath: t },
      MethodIdempotency: { typeOnly: !1, privateImportPath: "./service-type.js", publicImportPath: t },
      IMessageTypeRegistry: { typeOnly: !0, privateImportPath: "./type-registry.js", publicImportPath: t }
    },
    wktSourceFiles: [
      "google/protobuf/compiler/plugin.proto",
      "google/protobuf/any.proto",
      "google/protobuf/api.proto",
      "google/protobuf/descriptor.proto",
      "google/protobuf/duration.proto",
      "google/protobuf/empty.proto",
      "google/protobuf/field_mask.proto",
      "google/protobuf/source_context.proto",
      "google/protobuf/struct.proto",
      "google/protobuf/timestamp.proto",
      "google/protobuf/type.proto",
      "google/protobuf/wrappers.proto"
    ]
  }, codegenInfo;
}
var serviceType = {}, hasRequiredServiceType;
function requireServiceType() {
  if (hasRequiredServiceType) return serviceType;
  hasRequiredServiceType = 1, Object.defineProperty(serviceType, "__esModule", { value: !0 }), serviceType.MethodIdempotency = serviceType.MethodKind = void 0;
  var s;
  (function(u) {
    u[u.Unary = 0] = "Unary", u[u.ServerStreaming = 1] = "ServerStreaming", u[u.ClientStreaming = 2] = "ClientStreaming", u[u.BiDiStreaming = 3] = "BiDiStreaming";
  })(s || (serviceType.MethodKind = s = {}));
  var A;
  return function(u) {
    u[u.NoSideEffects = 1] = "NoSideEffects", u[u.Idempotent = 2] = "Idempotent";
  }(A || (serviceType.MethodIdempotency = A = {})), serviceType;
}
var createDescriptorSet = {}, descriptor_pb = {}, hasRequiredDescriptor_pb;
function requireDescriptor_pb() {
  if (hasRequiredDescriptor_pb) return descriptor_pb;
  hasRequiredDescriptor_pb = 1, Object.defineProperty(descriptor_pb, "__esModule", { value: !0 }), descriptor_pb.GeneratedCodeInfo_Annotation_Semantic = descriptor_pb.GeneratedCodeInfo_Annotation = descriptor_pb.GeneratedCodeInfo = descriptor_pb.SourceCodeInfo_Location = descriptor_pb.SourceCodeInfo = descriptor_pb.FeatureSetDefaults_FeatureSetEditionDefault = descriptor_pb.FeatureSetDefaults = descriptor_pb.FeatureSet_JsonFormat = descriptor_pb.FeatureSet_MessageEncoding = descriptor_pb.FeatureSet_Utf8Validation = descriptor_pb.FeatureSet_RepeatedFieldEncoding = descriptor_pb.FeatureSet_EnumType = descriptor_pb.FeatureSet_FieldPresence = descriptor_pb.FeatureSet = descriptor_pb.UninterpretedOption_NamePart = descriptor_pb.UninterpretedOption = descriptor_pb.MethodOptions_IdempotencyLevel = descriptor_pb.MethodOptions = descriptor_pb.ServiceOptions = descriptor_pb.EnumValueOptions = descriptor_pb.EnumOptions = descriptor_pb.OneofOptions = descriptor_pb.FieldOptions_FeatureSupport = descriptor_pb.FieldOptions_EditionDefault = descriptor_pb.FieldOptions_OptionTargetType = descriptor_pb.FieldOptions_OptionRetention = descriptor_pb.FieldOptions_JSType = descriptor_pb.FieldOptions_CType = descriptor_pb.FieldOptions = descriptor_pb.MessageOptions = descriptor_pb.FileOptions_OptimizeMode = descriptor_pb.FileOptions = descriptor_pb.MethodDescriptorProto = descriptor_pb.ServiceDescriptorProto = descriptor_pb.EnumValueDescriptorProto = descriptor_pb.EnumDescriptorProto_EnumReservedRange = descriptor_pb.EnumDescriptorProto = descriptor_pb.OneofDescriptorProto = descriptor_pb.FieldDescriptorProto_Label = descriptor_pb.FieldDescriptorProto_Type = descriptor_pb.FieldDescriptorProto = descriptor_pb.ExtensionRangeOptions_Declaration = descriptor_pb.ExtensionRangeOptions_VerificationState = descriptor_pb.ExtensionRangeOptions = descriptor_pb.DescriptorProto_ReservedRange = descriptor_pb.DescriptorProto_ExtensionRange = descriptor_pb.DescriptorProto = descriptor_pb.FileDescriptorProto = descriptor_pb.FileDescriptorSet = descriptor_pb.Edition = void 0;
  const s = requireProto2(), A = requireMessage();
  var u;
  (function(fn) {
    fn[fn.EDITION_UNKNOWN = 0] = "EDITION_UNKNOWN", fn[fn.EDITION_LEGACY = 900] = "EDITION_LEGACY", fn[fn.EDITION_PROTO2 = 998] = "EDITION_PROTO2", fn[fn.EDITION_PROTO3 = 999] = "EDITION_PROTO3", fn[fn.EDITION_2023 = 1e3] = "EDITION_2023", fn[fn.EDITION_2024 = 1001] = "EDITION_2024", fn[fn.EDITION_1_TEST_ONLY = 1] = "EDITION_1_TEST_ONLY", fn[fn.EDITION_2_TEST_ONLY = 2] = "EDITION_2_TEST_ONLY", fn[fn.EDITION_99997_TEST_ONLY = 99997] = "EDITION_99997_TEST_ONLY", fn[fn.EDITION_99998_TEST_ONLY = 99998] = "EDITION_99998_TEST_ONLY", fn[fn.EDITION_99999_TEST_ONLY = 99999] = "EDITION_99999_TEST_ONLY", fn[fn.EDITION_MAX = 2147483647] = "EDITION_MAX";
  })(u || (descriptor_pb.Edition = u = {})), s.proto2.util.setEnumType(u, "google.protobuf.Edition", [
    { no: 0, name: "EDITION_UNKNOWN" },
    { no: 900, name: "EDITION_LEGACY" },
    { no: 998, name: "EDITION_PROTO2" },
    { no: 999, name: "EDITION_PROTO3" },
    { no: 1e3, name: "EDITION_2023" },
    { no: 1001, name: "EDITION_2024" },
    { no: 1, name: "EDITION_1_TEST_ONLY" },
    { no: 2, name: "EDITION_2_TEST_ONLY" },
    { no: 99997, name: "EDITION_99997_TEST_ONLY" },
    { no: 99998, name: "EDITION_99998_TEST_ONLY" },
    { no: 99999, name: "EDITION_99999_TEST_ONLY" },
    { no: 2147483647, name: "EDITION_MAX" }
  ]);
  class p extends A.Message {
    constructor(jr) {
      super(), this.file = [], s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new p().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new p().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new p().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(p, jr, dn);
    }
  }
  descriptor_pb.FileDescriptorSet = p, p.runtime = s.proto2, p.typeName = "google.protobuf.FileDescriptorSet", p.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "file", kind: "message", T: t, repeated: !0 }
  ]);
  class t extends A.Message {
    constructor(jr) {
      super(), this.dependency = [], this.publicDependency = [], this.weakDependency = [], this.messageType = [], this.enumType = [], this.service = [], this.extension = [], s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new t().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new t().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new t().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(t, jr, dn);
    }
  }
  descriptor_pb.FileDescriptorProto = t, t.runtime = s.proto2, t.typeName = "google.protobuf.FileDescriptorProto", t.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
    { no: 2, name: "package", kind: "scalar", T: 9, opt: !0 },
    { no: 3, name: "dependency", kind: "scalar", T: 9, repeated: !0 },
    { no: 10, name: "public_dependency", kind: "scalar", T: 5, repeated: !0 },
    { no: 11, name: "weak_dependency", kind: "scalar", T: 5, repeated: !0 },
    { no: 4, name: "message_type", kind: "message", T: l, repeated: !0 },
    { no: 5, name: "enum_type", kind: "message", T: F, repeated: !0 },
    { no: 6, name: "service", kind: "message", T: pe, repeated: !0 },
    { no: 7, name: "extension", kind: "message", T: Q, repeated: !0 },
    { no: 8, name: "options", kind: "message", T: be, opt: !0 },
    { no: 9, name: "source_code_info", kind: "message", T: wr, opt: !0 },
    { no: 12, name: "syntax", kind: "scalar", T: 9, opt: !0 },
    { no: 14, name: "edition", kind: "enum", T: s.proto2.getEnumType(u), opt: !0 }
  ]);
  class l extends A.Message {
    constructor(jr) {
      super(), this.field = [], this.extension = [], this.nestedType = [], this.enumType = [], this.extensionRange = [], this.oneofDecl = [], this.reservedRange = [], this.reservedName = [], s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new l().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new l().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new l().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(l, jr, dn);
    }
  }
  descriptor_pb.DescriptorProto = l, l.runtime = s.proto2, l.typeName = "google.protobuf.DescriptorProto", l.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
    { no: 2, name: "field", kind: "message", T: Q, repeated: !0 },
    { no: 6, name: "extension", kind: "message", T: Q, repeated: !0 },
    { no: 3, name: "nested_type", kind: "message", T: l, repeated: !0 },
    { no: 4, name: "enum_type", kind: "message", T: F, repeated: !0 },
    { no: 5, name: "extension_range", kind: "message", T: m, repeated: !0 },
    { no: 8, name: "oneof_decl", kind: "message", T: M, repeated: !0 },
    { no: 7, name: "options", kind: "message", T: Te, opt: !0 },
    { no: 9, name: "reserved_range", kind: "message", T: b, repeated: !0 },
    { no: 10, name: "reserved_name", kind: "scalar", T: 9, repeated: !0 }
  ]);
  class m extends A.Message {
    constructor(jr) {
      super(), s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new m().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new m().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new m().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(m, jr, dn);
    }
  }
  descriptor_pb.DescriptorProto_ExtensionRange = m, m.runtime = s.proto2, m.typeName = "google.protobuf.DescriptorProto.ExtensionRange", m.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "start", kind: "scalar", T: 5, opt: !0 },
    { no: 2, name: "end", kind: "scalar", T: 5, opt: !0 },
    { no: 3, name: "options", kind: "message", T: k, opt: !0 }
  ]);
  class b extends A.Message {
    constructor(jr) {
      super(), s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new b().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new b().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new b().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(b, jr, dn);
    }
  }
  descriptor_pb.DescriptorProto_ReservedRange = b, b.runtime = s.proto2, b.typeName = "google.protobuf.DescriptorProto.ReservedRange", b.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "start", kind: "scalar", T: 5, opt: !0 },
    { no: 2, name: "end", kind: "scalar", T: 5, opt: !0 }
  ]);
  class k extends A.Message {
    constructor(jr) {
      super(), this.uninterpretedOption = [], this.declaration = [], s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new k().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new k().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new k().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(k, jr, dn);
    }
  }
  descriptor_pb.ExtensionRangeOptions = k, k.runtime = s.proto2, k.typeName = "google.protobuf.ExtensionRangeOptions", k.fields = s.proto2.util.newFieldList(() => [
    { no: 999, name: "uninterpreted_option", kind: "message", T: nr, repeated: !0 },
    { no: 2, name: "declaration", kind: "message", T: B, repeated: !0 },
    { no: 50, name: "features", kind: "message", T: lr, opt: !0 },
    { no: 3, name: "verification", kind: "enum", T: s.proto2.getEnumType(C), opt: !0, default: C.UNVERIFIED }
  ]);
  var C;
  (function(fn) {
    fn[fn.DECLARATION = 0] = "DECLARATION", fn[fn.UNVERIFIED = 1] = "UNVERIFIED";
  })(C || (descriptor_pb.ExtensionRangeOptions_VerificationState = C = {})), s.proto2.util.setEnumType(C, "google.protobuf.ExtensionRangeOptions.VerificationState", [
    { no: 0, name: "DECLARATION" },
    { no: 1, name: "UNVERIFIED" }
  ]);
  class B extends A.Message {
    constructor(jr) {
      super(), s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new B().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new B().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new B().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(B, jr, dn);
    }
  }
  descriptor_pb.ExtensionRangeOptions_Declaration = B, B.runtime = s.proto2, B.typeName = "google.protobuf.ExtensionRangeOptions.Declaration", B.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "number", kind: "scalar", T: 5, opt: !0 },
    { no: 2, name: "full_name", kind: "scalar", T: 9, opt: !0 },
    { no: 3, name: "type", kind: "scalar", T: 9, opt: !0 },
    { no: 5, name: "reserved", kind: "scalar", T: 8, opt: !0 },
    { no: 6, name: "repeated", kind: "scalar", T: 8, opt: !0 }
  ]);
  class Q extends A.Message {
    constructor(jr) {
      super(), s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new Q().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new Q().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new Q().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(Q, jr, dn);
    }
  }
  descriptor_pb.FieldDescriptorProto = Q, Q.runtime = s.proto2, Q.typeName = "google.protobuf.FieldDescriptorProto", Q.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
    { no: 3, name: "number", kind: "scalar", T: 5, opt: !0 },
    { no: 4, name: "label", kind: "enum", T: s.proto2.getEnumType(x), opt: !0 },
    { no: 5, name: "type", kind: "enum", T: s.proto2.getEnumType(P), opt: !0 },
    { no: 6, name: "type_name", kind: "scalar", T: 9, opt: !0 },
    { no: 2, name: "extendee", kind: "scalar", T: 9, opt: !0 },
    { no: 7, name: "default_value", kind: "scalar", T: 9, opt: !0 },
    { no: 9, name: "oneof_index", kind: "scalar", T: 5, opt: !0 },
    { no: 10, name: "json_name", kind: "scalar", T: 9, opt: !0 },
    { no: 8, name: "options", kind: "message", T: Qe, opt: !0 },
    { no: 17, name: "proto3_optional", kind: "scalar", T: 8, opt: !0 }
  ]);
  var P;
  (function(fn) {
    fn[fn.DOUBLE = 1] = "DOUBLE", fn[fn.FLOAT = 2] = "FLOAT", fn[fn.INT64 = 3] = "INT64", fn[fn.UINT64 = 4] = "UINT64", fn[fn.INT32 = 5] = "INT32", fn[fn.FIXED64 = 6] = "FIXED64", fn[fn.FIXED32 = 7] = "FIXED32", fn[fn.BOOL = 8] = "BOOL", fn[fn.STRING = 9] = "STRING", fn[fn.GROUP = 10] = "GROUP", fn[fn.MESSAGE = 11] = "MESSAGE", fn[fn.BYTES = 12] = "BYTES", fn[fn.UINT32 = 13] = "UINT32", fn[fn.ENUM = 14] = "ENUM", fn[fn.SFIXED32 = 15] = "SFIXED32", fn[fn.SFIXED64 = 16] = "SFIXED64", fn[fn.SINT32 = 17] = "SINT32", fn[fn.SINT64 = 18] = "SINT64";
  })(P || (descriptor_pb.FieldDescriptorProto_Type = P = {})), s.proto2.util.setEnumType(P, "google.protobuf.FieldDescriptorProto.Type", [
    { no: 1, name: "TYPE_DOUBLE" },
    { no: 2, name: "TYPE_FLOAT" },
    { no: 3, name: "TYPE_INT64" },
    { no: 4, name: "TYPE_UINT64" },
    { no: 5, name: "TYPE_INT32" },
    { no: 6, name: "TYPE_FIXED64" },
    { no: 7, name: "TYPE_FIXED32" },
    { no: 8, name: "TYPE_BOOL" },
    { no: 9, name: "TYPE_STRING" },
    { no: 10, name: "TYPE_GROUP" },
    { no: 11, name: "TYPE_MESSAGE" },
    { no: 12, name: "TYPE_BYTES" },
    { no: 13, name: "TYPE_UINT32" },
    { no: 14, name: "TYPE_ENUM" },
    { no: 15, name: "TYPE_SFIXED32" },
    { no: 16, name: "TYPE_SFIXED64" },
    { no: 17, name: "TYPE_SINT32" },
    { no: 18, name: "TYPE_SINT64" }
  ]);
  var x;
  (function(fn) {
    fn[fn.OPTIONAL = 1] = "OPTIONAL", fn[fn.REPEATED = 3] = "REPEATED", fn[fn.REQUIRED = 2] = "REQUIRED";
  })(x || (descriptor_pb.FieldDescriptorProto_Label = x = {})), s.proto2.util.setEnumType(x, "google.protobuf.FieldDescriptorProto.Label", [
    { no: 1, name: "LABEL_OPTIONAL" },
    { no: 3, name: "LABEL_REPEATED" },
    { no: 2, name: "LABEL_REQUIRED" }
  ]);
  class M extends A.Message {
    constructor(jr) {
      super(), s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new M().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new M().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new M().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(M, jr, dn);
    }
  }
  descriptor_pb.OneofDescriptorProto = M, M.runtime = s.proto2, M.typeName = "google.protobuf.OneofDescriptorProto", M.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
    { no: 2, name: "options", kind: "message", T: Se, opt: !0 }
  ]);
  class F extends A.Message {
    constructor(jr) {
      super(), this.value = [], this.reservedRange = [], this.reservedName = [], s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new F().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new F().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new F().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(F, jr, dn);
    }
  }
  descriptor_pb.EnumDescriptorProto = F, F.runtime = s.proto2, F.typeName = "google.protobuf.EnumDescriptorProto", F.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
    { no: 2, name: "value", kind: "message", T: ge, repeated: !0 },
    { no: 3, name: "options", kind: "message", T: Ne, opt: !0 },
    { no: 4, name: "reserved_range", kind: "message", T: le, repeated: !0 },
    { no: 5, name: "reserved_name", kind: "scalar", T: 9, repeated: !0 }
  ]);
  class le extends A.Message {
    constructor(jr) {
      super(), s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new le().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new le().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new le().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(le, jr, dn);
    }
  }
  descriptor_pb.EnumDescriptorProto_EnumReservedRange = le, le.runtime = s.proto2, le.typeName = "google.protobuf.EnumDescriptorProto.EnumReservedRange", le.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "start", kind: "scalar", T: 5, opt: !0 },
    { no: 2, name: "end", kind: "scalar", T: 5, opt: !0 }
  ]);
  class ge extends A.Message {
    constructor(jr) {
      super(), s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new ge().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new ge().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new ge().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(ge, jr, dn);
    }
  }
  descriptor_pb.EnumValueDescriptorProto = ge, ge.runtime = s.proto2, ge.typeName = "google.protobuf.EnumValueDescriptorProto", ge.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
    { no: 2, name: "number", kind: "scalar", T: 5, opt: !0 },
    { no: 3, name: "options", kind: "message", T: rr, opt: !0 }
  ]);
  class pe extends A.Message {
    constructor(jr) {
      super(), this.method = [], s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new pe().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new pe().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new pe().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(pe, jr, dn);
    }
  }
  descriptor_pb.ServiceDescriptorProto = pe, pe.runtime = s.proto2, pe.typeName = "google.protobuf.ServiceDescriptorProto", pe.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
    { no: 2, name: "method", kind: "message", T: Ie, repeated: !0 },
    { no: 3, name: "options", kind: "message", T: er, opt: !0 }
  ]);
  class Ie extends A.Message {
    constructor(jr) {
      super(), s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new Ie().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new Ie().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new Ie().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(Ie, jr, dn);
    }
  }
  descriptor_pb.MethodDescriptorProto = Ie, Ie.runtime = s.proto2, Ie.typeName = "google.protobuf.MethodDescriptorProto", Ie.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
    { no: 2, name: "input_type", kind: "scalar", T: 9, opt: !0 },
    { no: 3, name: "output_type", kind: "scalar", T: 9, opt: !0 },
    { no: 4, name: "options", kind: "message", T: ir, opt: !0 },
    { no: 5, name: "client_streaming", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 6, name: "server_streaming", kind: "scalar", T: 8, opt: !0, default: !1 }
  ]);
  class be extends A.Message {
    constructor(jr) {
      super(), this.uninterpretedOption = [], s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new be().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new be().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new be().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(be, jr, dn);
    }
  }
  descriptor_pb.FileOptions = be, be.runtime = s.proto2, be.typeName = "google.protobuf.FileOptions", be.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "java_package", kind: "scalar", T: 9, opt: !0 },
    { no: 8, name: "java_outer_classname", kind: "scalar", T: 9, opt: !0 },
    { no: 10, name: "java_multiple_files", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 20, name: "java_generate_equals_and_hash", kind: "scalar", T: 8, opt: !0 },
    { no: 27, name: "java_string_check_utf8", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 9, name: "optimize_for", kind: "enum", T: s.proto2.getEnumType(Pe), opt: !0, default: Pe.SPEED },
    { no: 11, name: "go_package", kind: "scalar", T: 9, opt: !0 },
    { no: 16, name: "cc_generic_services", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 17, name: "java_generic_services", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 18, name: "py_generic_services", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 23, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 31, name: "cc_enable_arenas", kind: "scalar", T: 8, opt: !0, default: !0 },
    { no: 36, name: "objc_class_prefix", kind: "scalar", T: 9, opt: !0 },
    { no: 37, name: "csharp_namespace", kind: "scalar", T: 9, opt: !0 },
    { no: 39, name: "swift_prefix", kind: "scalar", T: 9, opt: !0 },
    { no: 40, name: "php_class_prefix", kind: "scalar", T: 9, opt: !0 },
    { no: 41, name: "php_namespace", kind: "scalar", T: 9, opt: !0 },
    { no: 44, name: "php_metadata_namespace", kind: "scalar", T: 9, opt: !0 },
    { no: 45, name: "ruby_package", kind: "scalar", T: 9, opt: !0 },
    { no: 50, name: "features", kind: "message", T: lr, opt: !0 },
    { no: 999, name: "uninterpreted_option", kind: "message", T: nr, repeated: !0 }
  ]);
  var Pe;
  (function(fn) {
    fn[fn.SPEED = 1] = "SPEED", fn[fn.CODE_SIZE = 2] = "CODE_SIZE", fn[fn.LITE_RUNTIME = 3] = "LITE_RUNTIME";
  })(Pe || (descriptor_pb.FileOptions_OptimizeMode = Pe = {})), s.proto2.util.setEnumType(Pe, "google.protobuf.FileOptions.OptimizeMode", [
    { no: 1, name: "SPEED" },
    { no: 2, name: "CODE_SIZE" },
    { no: 3, name: "LITE_RUNTIME" }
  ]);
  class Te extends A.Message {
    constructor(jr) {
      super(), this.uninterpretedOption = [], s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new Te().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new Te().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new Te().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(Te, jr, dn);
    }
  }
  descriptor_pb.MessageOptions = Te, Te.runtime = s.proto2, Te.typeName = "google.protobuf.MessageOptions", Te.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "message_set_wire_format", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 2, name: "no_standard_descriptor_accessor", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 3, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 7, name: "map_entry", kind: "scalar", T: 8, opt: !0 },
    { no: 11, name: "deprecated_legacy_json_field_conflicts", kind: "scalar", T: 8, opt: !0 },
    { no: 12, name: "features", kind: "message", T: lr, opt: !0 },
    { no: 999, name: "uninterpreted_option", kind: "message", T: nr, repeated: !0 }
  ]);
  class Qe extends A.Message {
    constructor(jr) {
      super(), this.targets = [], this.editionDefaults = [], this.uninterpretedOption = [], s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new Qe().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new Qe().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new Qe().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(Qe, jr, dn);
    }
  }
  descriptor_pb.FieldOptions = Qe, Qe.runtime = s.proto2, Qe.typeName = "google.protobuf.FieldOptions", Qe.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "ctype", kind: "enum", T: s.proto2.getEnumType(xe), opt: !0, default: xe.STRING },
    { no: 2, name: "packed", kind: "scalar", T: 8, opt: !0 },
    { no: 6, name: "jstype", kind: "enum", T: s.proto2.getEnumType(Ee), opt: !0, default: Ee.JS_NORMAL },
    { no: 5, name: "lazy", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 15, name: "unverified_lazy", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 3, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 10, name: "weak", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 16, name: "debug_redact", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 17, name: "retention", kind: "enum", T: s.proto2.getEnumType(He), opt: !0 },
    { no: 19, name: "targets", kind: "enum", T: s.proto2.getEnumType(ve), repeated: !0 },
    { no: 20, name: "edition_defaults", kind: "message", T: we, repeated: !0 },
    { no: 21, name: "features", kind: "message", T: lr, opt: !0 },
    { no: 22, name: "feature_support", kind: "message", T: Ce, opt: !0 },
    { no: 999, name: "uninterpreted_option", kind: "message", T: nr, repeated: !0 }
  ]);
  var xe;
  (function(fn) {
    fn[fn.STRING = 0] = "STRING", fn[fn.CORD = 1] = "CORD", fn[fn.STRING_PIECE = 2] = "STRING_PIECE";
  })(xe || (descriptor_pb.FieldOptions_CType = xe = {})), s.proto2.util.setEnumType(xe, "google.protobuf.FieldOptions.CType", [
    { no: 0, name: "STRING" },
    { no: 1, name: "CORD" },
    { no: 2, name: "STRING_PIECE" }
  ]);
  var Ee;
  (function(fn) {
    fn[fn.JS_NORMAL = 0] = "JS_NORMAL", fn[fn.JS_STRING = 1] = "JS_STRING", fn[fn.JS_NUMBER = 2] = "JS_NUMBER";
  })(Ee || (descriptor_pb.FieldOptions_JSType = Ee = {})), s.proto2.util.setEnumType(Ee, "google.protobuf.FieldOptions.JSType", [
    { no: 0, name: "JS_NORMAL" },
    { no: 1, name: "JS_STRING" },
    { no: 2, name: "JS_NUMBER" }
  ]);
  var He;
  (function(fn) {
    fn[fn.RETENTION_UNKNOWN = 0] = "RETENTION_UNKNOWN", fn[fn.RETENTION_RUNTIME = 1] = "RETENTION_RUNTIME", fn[fn.RETENTION_SOURCE = 2] = "RETENTION_SOURCE";
  })(He || (descriptor_pb.FieldOptions_OptionRetention = He = {})), s.proto2.util.setEnumType(He, "google.protobuf.FieldOptions.OptionRetention", [
    { no: 0, name: "RETENTION_UNKNOWN" },
    { no: 1, name: "RETENTION_RUNTIME" },
    { no: 2, name: "RETENTION_SOURCE" }
  ]);
  var ve;
  (function(fn) {
    fn[fn.TARGET_TYPE_UNKNOWN = 0] = "TARGET_TYPE_UNKNOWN", fn[fn.TARGET_TYPE_FILE = 1] = "TARGET_TYPE_FILE", fn[fn.TARGET_TYPE_EXTENSION_RANGE = 2] = "TARGET_TYPE_EXTENSION_RANGE", fn[fn.TARGET_TYPE_MESSAGE = 3] = "TARGET_TYPE_MESSAGE", fn[fn.TARGET_TYPE_FIELD = 4] = "TARGET_TYPE_FIELD", fn[fn.TARGET_TYPE_ONEOF = 5] = "TARGET_TYPE_ONEOF", fn[fn.TARGET_TYPE_ENUM = 6] = "TARGET_TYPE_ENUM", fn[fn.TARGET_TYPE_ENUM_ENTRY = 7] = "TARGET_TYPE_ENUM_ENTRY", fn[fn.TARGET_TYPE_SERVICE = 8] = "TARGET_TYPE_SERVICE", fn[fn.TARGET_TYPE_METHOD = 9] = "TARGET_TYPE_METHOD";
  })(ve || (descriptor_pb.FieldOptions_OptionTargetType = ve = {})), s.proto2.util.setEnumType(ve, "google.protobuf.FieldOptions.OptionTargetType", [
    { no: 0, name: "TARGET_TYPE_UNKNOWN" },
    { no: 1, name: "TARGET_TYPE_FILE" },
    { no: 2, name: "TARGET_TYPE_EXTENSION_RANGE" },
    { no: 3, name: "TARGET_TYPE_MESSAGE" },
    { no: 4, name: "TARGET_TYPE_FIELD" },
    { no: 5, name: "TARGET_TYPE_ONEOF" },
    { no: 6, name: "TARGET_TYPE_ENUM" },
    { no: 7, name: "TARGET_TYPE_ENUM_ENTRY" },
    { no: 8, name: "TARGET_TYPE_SERVICE" },
    { no: 9, name: "TARGET_TYPE_METHOD" }
  ]);
  class we extends A.Message {
    constructor(jr) {
      super(), s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new we().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new we().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new we().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(we, jr, dn);
    }
  }
  descriptor_pb.FieldOptions_EditionDefault = we, we.runtime = s.proto2, we.typeName = "google.protobuf.FieldOptions.EditionDefault", we.fields = s.proto2.util.newFieldList(() => [
    { no: 3, name: "edition", kind: "enum", T: s.proto2.getEnumType(u), opt: !0 },
    { no: 2, name: "value", kind: "scalar", T: 9, opt: !0 }
  ]);
  class Ce extends A.Message {
    constructor(jr) {
      super(), s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new Ce().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new Ce().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new Ce().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(Ce, jr, dn);
    }
  }
  descriptor_pb.FieldOptions_FeatureSupport = Ce, Ce.runtime = s.proto2, Ce.typeName = "google.protobuf.FieldOptions.FeatureSupport", Ce.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "edition_introduced", kind: "enum", T: s.proto2.getEnumType(u), opt: !0 },
    { no: 2, name: "edition_deprecated", kind: "enum", T: s.proto2.getEnumType(u), opt: !0 },
    { no: 3, name: "deprecation_warning", kind: "scalar", T: 9, opt: !0 },
    { no: 4, name: "edition_removed", kind: "enum", T: s.proto2.getEnumType(u), opt: !0 }
  ]);
  class Se extends A.Message {
    constructor(jr) {
      super(), this.uninterpretedOption = [], s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new Se().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new Se().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new Se().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(Se, jr, dn);
    }
  }
  descriptor_pb.OneofOptions = Se, Se.runtime = s.proto2, Se.typeName = "google.protobuf.OneofOptions", Se.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "features", kind: "message", T: lr, opt: !0 },
    { no: 999, name: "uninterpreted_option", kind: "message", T: nr, repeated: !0 }
  ]);
  class Ne extends A.Message {
    constructor(jr) {
      super(), this.uninterpretedOption = [], s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new Ne().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new Ne().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new Ne().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(Ne, jr, dn);
    }
  }
  descriptor_pb.EnumOptions = Ne, Ne.runtime = s.proto2, Ne.typeName = "google.protobuf.EnumOptions", Ne.fields = s.proto2.util.newFieldList(() => [
    { no: 2, name: "allow_alias", kind: "scalar", T: 8, opt: !0 },
    { no: 3, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 6, name: "deprecated_legacy_json_field_conflicts", kind: "scalar", T: 8, opt: !0 },
    { no: 7, name: "features", kind: "message", T: lr, opt: !0 },
    { no: 999, name: "uninterpreted_option", kind: "message", T: nr, repeated: !0 }
  ]);
  class rr extends A.Message {
    constructor(jr) {
      super(), this.uninterpretedOption = [], s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new rr().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new rr().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new rr().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(rr, jr, dn);
    }
  }
  descriptor_pb.EnumValueOptions = rr, rr.runtime = s.proto2, rr.typeName = "google.protobuf.EnumValueOptions", rr.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 2, name: "features", kind: "message", T: lr, opt: !0 },
    { no: 3, name: "debug_redact", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 4, name: "feature_support", kind: "message", T: Ce, opt: !0 },
    { no: 999, name: "uninterpreted_option", kind: "message", T: nr, repeated: !0 }
  ]);
  class er extends A.Message {
    constructor(jr) {
      super(), this.uninterpretedOption = [], s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new er().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new er().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new er().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(er, jr, dn);
    }
  }
  descriptor_pb.ServiceOptions = er, er.runtime = s.proto2, er.typeName = "google.protobuf.ServiceOptions", er.fields = s.proto2.util.newFieldList(() => [
    { no: 34, name: "features", kind: "message", T: lr, opt: !0 },
    { no: 33, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 999, name: "uninterpreted_option", kind: "message", T: nr, repeated: !0 }
  ]);
  class ir extends A.Message {
    constructor(jr) {
      super(), this.uninterpretedOption = [], s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new ir().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new ir().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new ir().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(ir, jr, dn);
    }
  }
  descriptor_pb.MethodOptions = ir, ir.runtime = s.proto2, ir.typeName = "google.protobuf.MethodOptions", ir.fields = s.proto2.util.newFieldList(() => [
    { no: 33, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 34, name: "idempotency_level", kind: "enum", T: s.proto2.getEnumType(sr), opt: !0, default: sr.IDEMPOTENCY_UNKNOWN },
    { no: 35, name: "features", kind: "message", T: lr, opt: !0 },
    { no: 999, name: "uninterpreted_option", kind: "message", T: nr, repeated: !0 }
  ]);
  var sr;
  (function(fn) {
    fn[fn.IDEMPOTENCY_UNKNOWN = 0] = "IDEMPOTENCY_UNKNOWN", fn[fn.NO_SIDE_EFFECTS = 1] = "NO_SIDE_EFFECTS", fn[fn.IDEMPOTENT = 2] = "IDEMPOTENT";
  })(sr || (descriptor_pb.MethodOptions_IdempotencyLevel = sr = {})), s.proto2.util.setEnumType(sr, "google.protobuf.MethodOptions.IdempotencyLevel", [
    { no: 0, name: "IDEMPOTENCY_UNKNOWN" },
    { no: 1, name: "NO_SIDE_EFFECTS" },
    { no: 2, name: "IDEMPOTENT" }
  ]);
  class nr extends A.Message {
    constructor(jr) {
      super(), this.name = [], s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new nr().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new nr().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new nr().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(nr, jr, dn);
    }
  }
  descriptor_pb.UninterpretedOption = nr, nr.runtime = s.proto2, nr.typeName = "google.protobuf.UninterpretedOption", nr.fields = s.proto2.util.newFieldList(() => [
    { no: 2, name: "name", kind: "message", T: fr, repeated: !0 },
    { no: 3, name: "identifier_value", kind: "scalar", T: 9, opt: !0 },
    { no: 4, name: "positive_int_value", kind: "scalar", T: 4, opt: !0 },
    { no: 5, name: "negative_int_value", kind: "scalar", T: 3, opt: !0 },
    { no: 6, name: "double_value", kind: "scalar", T: 1, opt: !0 },
    { no: 7, name: "string_value", kind: "scalar", T: 12, opt: !0 },
    { no: 8, name: "aggregate_value", kind: "scalar", T: 9, opt: !0 }
  ]);
  class fr extends A.Message {
    constructor(jr) {
      super(), s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new fr().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new fr().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new fr().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(fr, jr, dn);
    }
  }
  descriptor_pb.UninterpretedOption_NamePart = fr, fr.runtime = s.proto2, fr.typeName = "google.protobuf.UninterpretedOption.NamePart", fr.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "name_part", kind: "scalar", T: 9, req: !0 },
    { no: 2, name: "is_extension", kind: "scalar", T: 8, req: !0 }
  ]);
  class lr extends A.Message {
    constructor(jr) {
      super(), s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new lr().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new lr().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new lr().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(lr, jr, dn);
    }
  }
  descriptor_pb.FeatureSet = lr, lr.runtime = s.proto2, lr.typeName = "google.protobuf.FeatureSet", lr.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "field_presence", kind: "enum", T: s.proto2.getEnumType(br), opt: !0 },
    { no: 2, name: "enum_type", kind: "enum", T: s.proto2.getEnumType(Br), opt: !0 },
    { no: 3, name: "repeated_field_encoding", kind: "enum", T: s.proto2.getEnumType(Fr), opt: !0 },
    { no: 4, name: "utf8_validation", kind: "enum", T: s.proto2.getEnumType(Gr), opt: !0 },
    { no: 5, name: "message_encoding", kind: "enum", T: s.proto2.getEnumType(qr), opt: !0 },
    { no: 6, name: "json_format", kind: "enum", T: s.proto2.getEnumType(Hr), opt: !0 }
  ]);
  var br;
  (function(fn) {
    fn[fn.FIELD_PRESENCE_UNKNOWN = 0] = "FIELD_PRESENCE_UNKNOWN", fn[fn.EXPLICIT = 1] = "EXPLICIT", fn[fn.IMPLICIT = 2] = "IMPLICIT", fn[fn.LEGACY_REQUIRED = 3] = "LEGACY_REQUIRED";
  })(br || (descriptor_pb.FeatureSet_FieldPresence = br = {})), s.proto2.util.setEnumType(br, "google.protobuf.FeatureSet.FieldPresence", [
    { no: 0, name: "FIELD_PRESENCE_UNKNOWN" },
    { no: 1, name: "EXPLICIT" },
    { no: 2, name: "IMPLICIT" },
    { no: 3, name: "LEGACY_REQUIRED" }
  ]);
  var Br;
  (function(fn) {
    fn[fn.ENUM_TYPE_UNKNOWN = 0] = "ENUM_TYPE_UNKNOWN", fn[fn.OPEN = 1] = "OPEN", fn[fn.CLOSED = 2] = "CLOSED";
  })(Br || (descriptor_pb.FeatureSet_EnumType = Br = {})), s.proto2.util.setEnumType(Br, "google.protobuf.FeatureSet.EnumType", [
    { no: 0, name: "ENUM_TYPE_UNKNOWN" },
    { no: 1, name: "OPEN" },
    { no: 2, name: "CLOSED" }
  ]);
  var Fr;
  (function(fn) {
    fn[fn.REPEATED_FIELD_ENCODING_UNKNOWN = 0] = "REPEATED_FIELD_ENCODING_UNKNOWN", fn[fn.PACKED = 1] = "PACKED", fn[fn.EXPANDED = 2] = "EXPANDED";
  })(Fr || (descriptor_pb.FeatureSet_RepeatedFieldEncoding = Fr = {})), s.proto2.util.setEnumType(Fr, "google.protobuf.FeatureSet.RepeatedFieldEncoding", [
    { no: 0, name: "REPEATED_FIELD_ENCODING_UNKNOWN" },
    { no: 1, name: "PACKED" },
    { no: 2, name: "EXPANDED" }
  ]);
  var Gr;
  (function(fn) {
    fn[fn.UTF8_VALIDATION_UNKNOWN = 0] = "UTF8_VALIDATION_UNKNOWN", fn[fn.VERIFY = 2] = "VERIFY", fn[fn.NONE = 3] = "NONE";
  })(Gr || (descriptor_pb.FeatureSet_Utf8Validation = Gr = {})), s.proto2.util.setEnumType(Gr, "google.protobuf.FeatureSet.Utf8Validation", [
    { no: 0, name: "UTF8_VALIDATION_UNKNOWN" },
    { no: 2, name: "VERIFY" },
    { no: 3, name: "NONE" }
  ]);
  var qr;
  (function(fn) {
    fn[fn.MESSAGE_ENCODING_UNKNOWN = 0] = "MESSAGE_ENCODING_UNKNOWN", fn[fn.LENGTH_PREFIXED = 1] = "LENGTH_PREFIXED", fn[fn.DELIMITED = 2] = "DELIMITED";
  })(qr || (descriptor_pb.FeatureSet_MessageEncoding = qr = {})), s.proto2.util.setEnumType(qr, "google.protobuf.FeatureSet.MessageEncoding", [
    { no: 0, name: "MESSAGE_ENCODING_UNKNOWN" },
    { no: 1, name: "LENGTH_PREFIXED" },
    { no: 2, name: "DELIMITED" }
  ]);
  var Hr;
  (function(fn) {
    fn[fn.JSON_FORMAT_UNKNOWN = 0] = "JSON_FORMAT_UNKNOWN", fn[fn.ALLOW = 1] = "ALLOW", fn[fn.LEGACY_BEST_EFFORT = 2] = "LEGACY_BEST_EFFORT";
  })(Hr || (descriptor_pb.FeatureSet_JsonFormat = Hr = {})), s.proto2.util.setEnumType(Hr, "google.protobuf.FeatureSet.JsonFormat", [
    { no: 0, name: "JSON_FORMAT_UNKNOWN" },
    { no: 1, name: "ALLOW" },
    { no: 2, name: "LEGACY_BEST_EFFORT" }
  ]);
  class un extends A.Message {
    constructor(jr) {
      super(), this.defaults = [], s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new un().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new un().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new un().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(un, jr, dn);
    }
  }
  descriptor_pb.FeatureSetDefaults = un, un.runtime = s.proto2, un.typeName = "google.protobuf.FeatureSetDefaults", un.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "defaults", kind: "message", T: Dr, repeated: !0 },
    { no: 4, name: "minimum_edition", kind: "enum", T: s.proto2.getEnumType(u), opt: !0 },
    { no: 5, name: "maximum_edition", kind: "enum", T: s.proto2.getEnumType(u), opt: !0 }
  ]);
  class Dr extends A.Message {
    constructor(jr) {
      super(), s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new Dr().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new Dr().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new Dr().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(Dr, jr, dn);
    }
  }
  descriptor_pb.FeatureSetDefaults_FeatureSetEditionDefault = Dr, Dr.runtime = s.proto2, Dr.typeName = "google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault", Dr.fields = s.proto2.util.newFieldList(() => [
    { no: 3, name: "edition", kind: "enum", T: s.proto2.getEnumType(u), opt: !0 },
    { no: 4, name: "overridable_features", kind: "message", T: lr, opt: !0 },
    { no: 5, name: "fixed_features", kind: "message", T: lr, opt: !0 }
  ]);
  class wr extends A.Message {
    constructor(jr) {
      super(), this.location = [], s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new wr().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new wr().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new wr().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(wr, jr, dn);
    }
  }
  descriptor_pb.SourceCodeInfo = wr, wr.runtime = s.proto2, wr.typeName = "google.protobuf.SourceCodeInfo", wr.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "location", kind: "message", T: yr, repeated: !0 }
  ]);
  class yr extends A.Message {
    constructor(jr) {
      super(), this.path = [], this.span = [], this.leadingDetachedComments = [], s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new yr().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new yr().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new yr().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(yr, jr, dn);
    }
  }
  descriptor_pb.SourceCodeInfo_Location = yr, yr.runtime = s.proto2, yr.typeName = "google.protobuf.SourceCodeInfo.Location", yr.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "path", kind: "scalar", T: 5, repeated: !0, packed: !0 },
    { no: 2, name: "span", kind: "scalar", T: 5, repeated: !0, packed: !0 },
    { no: 3, name: "leading_comments", kind: "scalar", T: 9, opt: !0 },
    { no: 4, name: "trailing_comments", kind: "scalar", T: 9, opt: !0 },
    { no: 6, name: "leading_detached_comments", kind: "scalar", T: 9, repeated: !0 }
  ]);
  class Qr extends A.Message {
    constructor(jr) {
      super(), this.annotation = [], s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new Qr().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new Qr().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new Qr().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(Qr, jr, dn);
    }
  }
  descriptor_pb.GeneratedCodeInfo = Qr, Qr.runtime = s.proto2, Qr.typeName = "google.protobuf.GeneratedCodeInfo", Qr.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "annotation", kind: "message", T: _r, repeated: !0 }
  ]);
  class _r extends A.Message {
    constructor(jr) {
      super(), this.path = [], s.proto2.util.initPartial(jr, this);
    }
    static fromBinary(jr, dn) {
      return new _r().fromBinary(jr, dn);
    }
    static fromJson(jr, dn) {
      return new _r().fromJson(jr, dn);
    }
    static fromJsonString(jr, dn) {
      return new _r().fromJsonString(jr, dn);
    }
    static equals(jr, dn) {
      return s.proto2.util.equals(_r, jr, dn);
    }
  }
  descriptor_pb.GeneratedCodeInfo_Annotation = _r, _r.runtime = s.proto2, _r.typeName = "google.protobuf.GeneratedCodeInfo.Annotation", _r.fields = s.proto2.util.newFieldList(() => [
    { no: 1, name: "path", kind: "scalar", T: 5, repeated: !0, packed: !0 },
    { no: 2, name: "source_file", kind: "scalar", T: 9, opt: !0 },
    { no: 3, name: "begin", kind: "scalar", T: 5, opt: !0 },
    { no: 4, name: "end", kind: "scalar", T: 5, opt: !0 },
    { no: 5, name: "semantic", kind: "enum", T: s.proto2.getEnumType(Jr), opt: !0 }
  ]);
  var Jr;
  return function(fn) {
    fn[fn.NONE = 0] = "NONE", fn[fn.SET = 1] = "SET", fn[fn.ALIAS = 2] = "ALIAS";
  }(Jr || (descriptor_pb.GeneratedCodeInfo_Annotation_Semantic = Jr = {})), s.proto2.util.setEnumType(Jr, "google.protobuf.GeneratedCodeInfo.Annotation.Semantic", [
    { no: 0, name: "NONE" },
    { no: 1, name: "SET" },
    { no: 2, name: "ALIAS" }
  ]), descriptor_pb;
}
var textFormat = {}, hasRequiredTextFormat;
function requireTextFormat() {
  if (hasRequiredTextFormat) return textFormat;
  hasRequiredTextFormat = 1, Object.defineProperty(textFormat, "__esModule", { value: !0 }), textFormat.parseTextFormatScalarValue = textFormat.parseTextFormatEnumValue = void 0;
  const s = requireAssert$1(), A = requireProtoInt64(), u = requireScalar();
  function p(m, b) {
    const k = m.values.find((C) => C.name === b);
    return (0, s.assert)(k, `cannot parse ${m.name} default value: ${b}`), k.number;
  }
  textFormat.parseTextFormatEnumValue = p;
  function t(m, b) {
    switch (m) {
      case u.ScalarType.STRING:
        return b;
      case u.ScalarType.BYTES: {
        const k = l(b);
        if (k === !1)
          throw new Error(`cannot parse ${u.ScalarType[m]} default value: ${b}`);
        return k;
      }
      case u.ScalarType.INT64:
      case u.ScalarType.SFIXED64:
      case u.ScalarType.SINT64:
        return A.protoInt64.parse(b);
      case u.ScalarType.UINT64:
      case u.ScalarType.FIXED64:
        return A.protoInt64.uParse(b);
      case u.ScalarType.DOUBLE:
      case u.ScalarType.FLOAT:
        switch (b) {
          case "inf":
            return Number.POSITIVE_INFINITY;
          case "-inf":
            return Number.NEGATIVE_INFINITY;
          case "nan":
            return Number.NaN;
          default:
            return parseFloat(b);
        }
      case u.ScalarType.BOOL:
        return b === "true";
      case u.ScalarType.INT32:
      case u.ScalarType.UINT32:
      case u.ScalarType.SINT32:
      case u.ScalarType.FIXED32:
      case u.ScalarType.SFIXED32:
        return parseInt(b, 10);
    }
  }
  textFormat.parseTextFormatScalarValue = t;
  function l(m) {
    const b = [], k = {
      tail: m,
      c: "",
      next() {
        return this.tail.length == 0 ? !1 : (this.c = this.tail[0], this.tail = this.tail.substring(1), !0);
      },
      take(C) {
        if (this.tail.length >= C) {
          const B = this.tail.substring(0, C);
          return this.tail = this.tail.substring(C), B;
        }
        return !1;
      }
    };
    for (; k.next(); )
      switch (k.c) {
        case "\\":
          if (k.next())
            switch (k.c) {
              case "\\":
                b.push(k.c.charCodeAt(0));
                break;
              case "b":
                b.push(8);
                break;
              case "f":
                b.push(12);
                break;
              case "n":
                b.push(10);
                break;
              case "r":
                b.push(13);
                break;
              case "t":
                b.push(9);
                break;
              case "v":
                b.push(11);
                break;
              case "0":
              case "1":
              case "2":
              case "3":
              case "4":
              case "5":
              case "6":
              case "7": {
                const C = k.c, B = k.take(2);
                if (B === !1)
                  return !1;
                const Q = parseInt(C + B, 8);
                if (isNaN(Q))
                  return !1;
                b.push(Q);
                break;
              }
              case "x": {
                const C = k.c, B = k.take(2);
                if (B === !1)
                  return !1;
                const Q = parseInt(C + B, 16);
                if (isNaN(Q))
                  return !1;
                b.push(Q);
                break;
              }
              case "u": {
                const C = k.c, B = k.take(4);
                if (B === !1)
                  return !1;
                const Q = parseInt(C + B, 16);
                if (isNaN(Q))
                  return !1;
                const P = new Uint8Array(4);
                new DataView(P.buffer).setInt32(0, Q, !0), b.push(P[0], P[1], P[2], P[3]);
                break;
              }
              case "U": {
                const C = k.c, B = k.take(8);
                if (B === !1)
                  return !1;
                const Q = A.protoInt64.uEnc(C + B), P = new Uint8Array(8), x = new DataView(P.buffer);
                x.setInt32(0, Q.lo, !0), x.setInt32(4, Q.hi, !0), b.push(P[0], P[1], P[2], P[3], P[4], P[5], P[6], P[7]);
                break;
              }
            }
          break;
        default:
          b.push(k.c.charCodeAt(0));
      }
    return new Uint8Array(b);
  }
  return textFormat;
}
var featureSet = {}, hasRequiredFeatureSet;
function requireFeatureSet() {
  if (hasRequiredFeatureSet) return featureSet;
  hasRequiredFeatureSet = 1, Object.defineProperty(featureSet, "__esModule", { value: !0 }), featureSet.createFeatureResolver = void 0;
  const s = requireDescriptor_pb(), A = requireProtoBase64();
  function u(l) {
    return s.FeatureSetDefaults.fromBinary(A.protoBase64.dec(
      /*upstream-inject-feature-defaults-start*/
      "ChMY5gciACoMCAEQAhgCIAMoATACChMY5wciACoMCAIQARgBIAIoATABChMY6AciDAgBEAEYASACKAEwASoAIOYHKOgH"
      /*upstream-inject-feature-defaults-end*/
    ), l);
  }
  function p(l, m, b) {
    var k;
    const C = m ?? u(b), B = C.minimumEdition, Q = C.maximumEdition;
    if (B === void 0 || Q === void 0 || C.defaults.some((M) => M.edition === void 0))
      throw new Error("Invalid FeatureSetDefaults");
    if (l < B)
      throw new Error(`Edition ${s.Edition[l]} is earlier than the minimum supported edition ${s.Edition[B]}`);
    if (Q < l)
      throw new Error(`Edition ${s.Edition[l]} is later than the maximum supported edition ${s.Edition[Q]}`);
    let P;
    for (const M of C.defaults) {
      const F = (k = M.edition) !== null && k !== void 0 ? k : 0;
      if (F > l || P !== void 0 && P.e > F)
        continue;
      let le;
      M.fixedFeatures && M.overridableFeatures ? (le = M.fixedFeatures, le.fromBinary(M.overridableFeatures.toBinary())) : M.fixedFeatures ? le = M.fixedFeatures : M.overridableFeatures ? le = M.overridableFeatures : le = new s.FeatureSet(), P = {
        e: F,
        f: le
      };
    }
    if (P === void 0)
      throw new Error(`No valid default found for edition ${s.Edition[l]}`);
    const x = P.f.toBinary(b);
    return (...M) => {
      const F = s.FeatureSet.fromBinary(x, b);
      for (const le of M)
        le !== void 0 && F.fromBinary(le.toBinary(b), b);
      if (!t(F))
        throw new Error(`Invalid FeatureSet for edition ${s.Edition[l]}`);
      return F;
    };
  }
  featureSet.createFeatureResolver = p;
  function t(l) {
    for (const m of s.FeatureSet.fields.list()) {
      const b = l[m.localName];
      if (b === void 0 || m.kind == "enum" && b === 0)
        return !1;
    }
    return !0;
  }
  return featureSet;
}
var hasRequiredCreateDescriptorSet;
function requireCreateDescriptorSet() {
  if (hasRequiredCreateDescriptorSet) return createDescriptorSet;
  hasRequiredCreateDescriptorSet = 1, Object.defineProperty(createDescriptorSet, "__esModule", { value: !0 }), createDescriptorSet.createDescriptorSet = void 0;
  const s = requireDescriptor_pb(), A = requireAssert$1(), u = requireServiceType(), p = requireNames(), t = requireTextFormat(), l = requireFeatureSet(), m = requireScalar(), b = requireIsMessage();
  function k(er, ir) {
    var sr;
    const nr = {
      files: [],
      enums: /* @__PURE__ */ new Map(),
      messages: /* @__PURE__ */ new Map(),
      services: /* @__PURE__ */ new Map(),
      extensions: /* @__PURE__ */ new Map(),
      mapEntries: /* @__PURE__ */ new Map()
    }, fr = (0, b.isMessage)(er, s.FileDescriptorSet) ? er.file : er instanceof Uint8Array ? s.FileDescriptorSet.fromBinary(er).file : er, lr = /* @__PURE__ */ new Map();
    for (const br of fr) {
      const Br = (sr = br.edition) !== null && sr !== void 0 ? sr : Ie(br.syntax, br.edition).edition;
      let Fr = lr.get(Br);
      Fr === void 0 && (Fr = (0, l.createFeatureResolver)(Br, ir == null ? void 0 : ir.featureSetDefaults, ir == null ? void 0 : ir.serializationOptions), lr.set(Br, Fr)), C(br, nr, Fr);
    }
    return nr;
  }
  createDescriptorSet.createDescriptorSet = k;
  function C(er, ir, sr) {
    var nr, fr;
    (0, A.assert)(er.name, "invalid FileDescriptorProto: missing name");
    const lr = Object.assign(Object.assign({ kind: "file", proto: er, deprecated: (fr = (nr = er.options) === null || nr === void 0 ? void 0 : nr.deprecated) !== null && fr !== void 0 ? fr : !1 }, Ie(er.syntax, er.edition)), {
      name: er.name.replace(/\.proto/, ""),
      dependencies: be(er, ir),
      enums: [],
      messages: [],
      extensions: [],
      services: [],
      toString() {
        return `file ${this.proto.name}`;
      },
      getSyntaxComments() {
        return Ce(this.proto.sourceCodeInfo, [
          Se.FileDescriptorProto_Syntax
        ]);
      },
      getPackageComments() {
        return Ce(this.proto.sourceCodeInfo, [
          Se.FileDescriptorProto_Package
        ]);
      },
      getFeatures() {
        var br;
        return sr((br = er.options) === null || br === void 0 ? void 0 : br.features);
      }
    });
    ir.mapEntries.clear();
    for (const br of er.enumType)
      P(br, lr, void 0, ir, sr);
    for (const br of er.messageType)
      x(br, lr, void 0, ir, sr);
    for (const br of er.service)
      M(br, lr, ir, sr);
    B(lr, ir, sr);
    for (const br of ir.mapEntries.values())
      Q(br, ir, sr);
    for (const br of lr.messages)
      Q(br, ir, sr), B(br, ir, sr);
    ir.mapEntries.clear(), ir.files.push(lr);
  }
  function B(er, ir, sr) {
    switch (er.kind) {
      case "file":
        for (const nr of er.proto.extension) {
          const fr = pe(nr, er, void 0, ir, sr);
          er.extensions.push(fr), ir.extensions.set(fr.typeName, fr);
        }
        break;
      case "message":
        for (const nr of er.proto.extension) {
          const fr = pe(nr, er.file, er, ir, sr);
          er.nestedExtensions.push(fr), ir.extensions.set(fr.typeName, fr);
        }
        for (const nr of er.nestedMessages)
          B(nr, ir, sr);
        break;
    }
  }
  function Q(er, ir, sr) {
    const nr = er.proto.oneofDecl.map((lr) => le(lr, er, sr)), fr = /* @__PURE__ */ new Set();
    for (const lr of er.proto.field) {
      const br = xe(lr, nr), Br = ge(lr, er.file, er, br, ir, sr);
      er.fields.push(Br), br === void 0 ? er.members.push(Br) : (br.fields.push(Br), fr.has(br) || (fr.add(br), er.members.push(br)));
    }
    for (const lr of nr.filter((br) => fr.has(br)))
      er.oneofs.push(lr);
    for (const lr of er.nestedMessages)
      Q(lr, ir, sr);
  }
  function P(er, ir, sr, nr, fr) {
    var lr, br, Br;
    (0, A.assert)(er.name, "invalid EnumDescriptorProto: missing name");
    const Fr = {
      kind: "enum",
      proto: er,
      deprecated: (br = (lr = er.options) === null || lr === void 0 ? void 0 : lr.deprecated) !== null && br !== void 0 ? br : !1,
      file: ir,
      parent: sr,
      name: er.name,
      typeName: Pe(er, sr, ir),
      values: [],
      sharedPrefix: (0, p.findEnumSharedPrefix)(er.name, er.value.map((Gr) => {
        var qr;
        return (qr = Gr.name) !== null && qr !== void 0 ? qr : "";
      })),
      toString() {
        return `enum ${this.typeName}`;
      },
      getComments() {
        const Gr = this.parent ? [
          ...this.parent.getComments().sourcePath,
          Se.DescriptorProto_EnumType,
          this.parent.proto.enumType.indexOf(this.proto)
        ] : [
          Se.FileDescriptorProto_EnumType,
          this.file.proto.enumType.indexOf(this.proto)
        ];
        return Ce(ir.proto.sourceCodeInfo, Gr);
      },
      getFeatures() {
        var Gr, qr;
        return fr((Gr = sr == null ? void 0 : sr.getFeatures()) !== null && Gr !== void 0 ? Gr : ir.getFeatures(), (qr = er.options) === null || qr === void 0 ? void 0 : qr.features);
      }
    };
    nr.enums.set(Fr.typeName, Fr), er.value.forEach((Gr) => {
      var qr, Hr;
      (0, A.assert)(Gr.name, "invalid EnumValueDescriptorProto: missing name"), (0, A.assert)(Gr.number !== void 0, "invalid EnumValueDescriptorProto: missing number"), Fr.values.push({
        kind: "enum_value",
        proto: Gr,
        deprecated: (Hr = (qr = Gr.options) === null || qr === void 0 ? void 0 : qr.deprecated) !== null && Hr !== void 0 ? Hr : !1,
        parent: Fr,
        name: Gr.name,
        number: Gr.number,
        toString() {
          return `enum value ${Fr.typeName}.${this.name}`;
        },
        declarationString() {
          var un;
          let Dr = `${this.name} = ${this.number}`;
          return ((un = this.proto.options) === null || un === void 0 ? void 0 : un.deprecated) === !0 && (Dr += " [deprecated = true]"), Dr;
        },
        getComments() {
          const un = [
            ...this.parent.getComments().sourcePath,
            Se.EnumDescriptorProto_Value,
            this.parent.proto.value.indexOf(this.proto)
          ];
          return Ce(ir.proto.sourceCodeInfo, un);
        },
        getFeatures() {
          var un;
          return fr(Fr.getFeatures(), (un = Gr.options) === null || un === void 0 ? void 0 : un.features);
        }
      });
    }), ((Br = sr == null ? void 0 : sr.nestedEnums) !== null && Br !== void 0 ? Br : ir.enums).push(Fr);
  }
  function x(er, ir, sr, nr, fr) {
    var lr, br, Br, Fr;
    (0, A.assert)(er.name, "invalid DescriptorProto: missing name");
    const Gr = {
      kind: "message",
      proto: er,
      deprecated: (br = (lr = er.options) === null || lr === void 0 ? void 0 : lr.deprecated) !== null && br !== void 0 ? br : !1,
      file: ir,
      parent: sr,
      name: er.name,
      typeName: Pe(er, sr, ir),
      fields: [],
      oneofs: [],
      members: [],
      nestedEnums: [],
      nestedMessages: [],
      nestedExtensions: [],
      toString() {
        return `message ${this.typeName}`;
      },
      getComments() {
        const qr = this.parent ? [
          ...this.parent.getComments().sourcePath,
          Se.DescriptorProto_NestedType,
          this.parent.proto.nestedType.indexOf(this.proto)
        ] : [
          Se.FileDescriptorProto_MessageType,
          this.file.proto.messageType.indexOf(this.proto)
        ];
        return Ce(ir.proto.sourceCodeInfo, qr);
      },
      getFeatures() {
        var qr, Hr;
        return fr((qr = sr == null ? void 0 : sr.getFeatures()) !== null && qr !== void 0 ? qr : ir.getFeatures(), (Hr = er.options) === null || Hr === void 0 ? void 0 : Hr.features);
      }
    };
    ((Br = er.options) === null || Br === void 0 ? void 0 : Br.mapEntry) === !0 ? nr.mapEntries.set(Gr.typeName, Gr) : (((Fr = sr == null ? void 0 : sr.nestedMessages) !== null && Fr !== void 0 ? Fr : ir.messages).push(Gr), nr.messages.set(Gr.typeName, Gr));
    for (const qr of er.enumType)
      P(qr, ir, Gr, nr, fr);
    for (const qr of er.nestedType)
      x(qr, ir, Gr, nr, fr);
  }
  function M(er, ir, sr, nr) {
    var fr, lr;
    (0, A.assert)(er.name, "invalid ServiceDescriptorProto: missing name");
    const br = {
      kind: "service",
      proto: er,
      deprecated: (lr = (fr = er.options) === null || fr === void 0 ? void 0 : fr.deprecated) !== null && lr !== void 0 ? lr : !1,
      file: ir,
      name: er.name,
      typeName: Pe(er, void 0, ir),
      methods: [],
      toString() {
        return `service ${this.typeName}`;
      },
      getComments() {
        const Br = [
          Se.FileDescriptorProto_Service,
          this.file.proto.service.indexOf(this.proto)
        ];
        return Ce(ir.proto.sourceCodeInfo, Br);
      },
      getFeatures() {
        var Br;
        return nr(ir.getFeatures(), (Br = er.options) === null || Br === void 0 ? void 0 : Br.features);
      }
    };
    ir.services.push(br), sr.services.set(br.typeName, br);
    for (const Br of er.method)
      br.methods.push(F(Br, br, sr, nr));
  }
  function F(er, ir, sr, nr) {
    var fr, lr, br;
    (0, A.assert)(er.name, "invalid MethodDescriptorProto: missing name"), (0, A.assert)(er.inputType, "invalid MethodDescriptorProto: missing input_type"), (0, A.assert)(er.outputType, "invalid MethodDescriptorProto: missing output_type");
    let Br;
    er.clientStreaming === !0 && er.serverStreaming === !0 ? Br = u.MethodKind.BiDiStreaming : er.clientStreaming === !0 ? Br = u.MethodKind.ClientStreaming : er.serverStreaming === !0 ? Br = u.MethodKind.ServerStreaming : Br = u.MethodKind.Unary;
    let Fr;
    switch ((fr = er.options) === null || fr === void 0 ? void 0 : fr.idempotencyLevel) {
      case s.MethodOptions_IdempotencyLevel.IDEMPOTENT:
        Fr = u.MethodIdempotency.Idempotent;
        break;
      case s.MethodOptions_IdempotencyLevel.NO_SIDE_EFFECTS:
        Fr = u.MethodIdempotency.NoSideEffects;
        break;
      case s.MethodOptions_IdempotencyLevel.IDEMPOTENCY_UNKNOWN:
      case void 0:
        Fr = void 0;
        break;
    }
    const Gr = sr.messages.get(Te(er.inputType)), qr = sr.messages.get(Te(er.outputType));
    (0, A.assert)(Gr, `invalid MethodDescriptorProto: input_type ${er.inputType} not found`), (0, A.assert)(qr, `invalid MethodDescriptorProto: output_type ${er.inputType} not found`);
    const Hr = er.name;
    return {
      kind: "rpc",
      proto: er,
      deprecated: (br = (lr = er.options) === null || lr === void 0 ? void 0 : lr.deprecated) !== null && br !== void 0 ? br : !1,
      parent: ir,
      name: Hr,
      methodKind: Br,
      input: Gr,
      output: qr,
      idempotency: Fr,
      toString() {
        return `rpc ${ir.typeName}.${Hr}`;
      },
      getComments() {
        const un = [
          ...this.parent.getComments().sourcePath,
          Se.ServiceDescriptorProto_Method,
          this.parent.proto.method.indexOf(this.proto)
        ];
        return Ce(ir.file.proto.sourceCodeInfo, un);
      },
      getFeatures() {
        var un;
        return nr(ir.getFeatures(), (un = er.options) === null || un === void 0 ? void 0 : un.features);
      }
    };
  }
  function le(er, ir, sr) {
    return (0, A.assert)(er.name, "invalid OneofDescriptorProto: missing name"), {
      kind: "oneof",
      proto: er,
      deprecated: !1,
      parent: ir,
      fields: [],
      name: er.name,
      toString() {
        return `oneof ${ir.typeName}.${this.name}`;
      },
      getComments() {
        const nr = [
          ...this.parent.getComments().sourcePath,
          Se.DescriptorProto_OneofDecl,
          this.parent.proto.oneofDecl.indexOf(this.proto)
        ];
        return Ce(ir.file.proto.sourceCodeInfo, nr);
      },
      getFeatures() {
        var nr;
        return sr(ir.getFeatures(), (nr = er.options) === null || nr === void 0 ? void 0 : nr.features);
      }
    };
  }
  function ge(er, ir, sr, nr, fr, lr) {
    var br, Br, Fr;
    (0, A.assert)(er.name, "invalid FieldDescriptorProto: missing name"), (0, A.assert)(er.number, "invalid FieldDescriptorProto: missing number"), (0, A.assert)(er.type, "invalid FieldDescriptorProto: missing type");
    const Gr = {
      proto: er,
      deprecated: (Br = (br = er.options) === null || br === void 0 ? void 0 : br.deprecated) !== null && Br !== void 0 ? Br : !1,
      name: er.name,
      number: er.number,
      parent: sr,
      oneof: nr,
      optional: Ee(er, ir.syntax),
      packedByDefault: He(er, lr),
      packed: ve(ir, sr, er, lr),
      jsonName: er.jsonName === (0, p.fieldJsonName)(er.name) ? void 0 : er.jsonName,
      scalar: void 0,
      longType: void 0,
      message: void 0,
      enum: void 0,
      mapKey: void 0,
      mapValue: void 0,
      declarationString: Ne,
      // toString, getComments, getFeatures are overridden in newExtension
      toString() {
        return `field ${this.parent.typeName}.${this.name}`;
      },
      getComments() {
        const Hr = [
          ...this.parent.getComments().sourcePath,
          Se.DescriptorProto_Field,
          this.parent.proto.field.indexOf(this.proto)
        ];
        return Ce(ir.proto.sourceCodeInfo, Hr);
      },
      getFeatures() {
        var Hr;
        return lr(sr.getFeatures(), (Hr = er.options) === null || Hr === void 0 ? void 0 : Hr.features);
      }
    }, qr = er.label === s.FieldDescriptorProto_Label.REPEATED;
    switch (er.type) {
      case s.FieldDescriptorProto_Type.MESSAGE:
      case s.FieldDescriptorProto_Type.GROUP: {
        (0, A.assert)(er.typeName, "invalid FieldDescriptorProto: missing type_name");
        const Hr = fr.mapEntries.get(Te(er.typeName));
        if (Hr !== void 0)
          return (0, A.assert)(qr, "invalid FieldDescriptorProto: expected map entry to be repeated"), Object.assign(Object.assign(Object.assign({}, Gr), { kind: "field", fieldKind: "map", repeated: !1 }), Qe(Hr));
        const un = fr.messages.get(Te(er.typeName));
        return (0, A.assert)(un !== void 0, `invalid FieldDescriptorProto: type_name ${er.typeName} not found`), Object.assign(Object.assign({}, Gr), {
          kind: "field",
          fieldKind: "message",
          repeated: qr,
          message: un
        });
      }
      case s.FieldDescriptorProto_Type.ENUM: {
        (0, A.assert)(er.typeName, "invalid FieldDescriptorProto: missing type_name");
        const Hr = fr.enums.get(Te(er.typeName));
        return (0, A.assert)(Hr !== void 0, `invalid FieldDescriptorProto: type_name ${er.typeName} not found`), Object.assign(Object.assign({}, Gr), {
          kind: "field",
          fieldKind: "enum",
          getDefaultValue: rr,
          repeated: qr,
          enum: Hr
        });
      }
      default: {
        const Hr = we[er.type];
        return (0, A.assert)(Hr, `invalid FieldDescriptorProto: unknown type ${er.type}`), Object.assign(Object.assign({}, Gr), {
          kind: "field",
          fieldKind: "scalar",
          getDefaultValue: rr,
          repeated: qr,
          scalar: Hr,
          longType: ((Fr = er.options) === null || Fr === void 0 ? void 0 : Fr.jstype) == s.FieldOptions_JSType.JS_STRING ? m.LongType.STRING : m.LongType.BIGINT
        });
      }
    }
  }
  function pe(er, ir, sr, nr, fr) {
    (0, A.assert)(er.extendee, "invalid FieldDescriptorProto: missing extendee");
    const lr = ge(
      er,
      ir,
      null,
      // to safe us many lines of duplicated code, we trick the type system
      void 0,
      nr,
      fr
    ), br = nr.messages.get(Te(er.extendee));
    return (0, A.assert)(br, `invalid FieldDescriptorProto: extendee ${er.extendee} not found`), Object.assign(Object.assign({}, lr), {
      kind: "extension",
      typeName: Pe(er, sr, ir),
      parent: sr,
      file: ir,
      extendee: br,
      // Must override toString, getComments, getFeatures from newField, because we
      // call newField with parent undefined.
      toString() {
        return `extension ${this.typeName}`;
      },
      getComments() {
        const Br = this.parent ? [
          ...this.parent.getComments().sourcePath,
          Se.DescriptorProto_Extension,
          this.parent.proto.extension.indexOf(er)
        ] : [
          Se.FileDescriptorProto_Extension,
          this.file.proto.extension.indexOf(er)
        ];
        return Ce(ir.proto.sourceCodeInfo, Br);
      },
      getFeatures() {
        var Br;
        return fr((sr ?? ir).getFeatures(), (Br = er.options) === null || Br === void 0 ? void 0 : Br.features);
      }
    });
  }
  function Ie(er, ir) {
    let sr, nr;
    switch (er) {
      case void 0:
      case "proto2":
        nr = "proto2", sr = s.Edition.EDITION_PROTO2;
        break;
      case "proto3":
        nr = "proto3", sr = s.Edition.EDITION_PROTO3;
        break;
      case "editions":
        switch (nr = "editions", ir) {
          case void 0:
          case s.Edition.EDITION_1_TEST_ONLY:
          case s.Edition.EDITION_2_TEST_ONLY:
          case s.Edition.EDITION_99997_TEST_ONLY:
          case s.Edition.EDITION_99998_TEST_ONLY:
          case s.Edition.EDITION_99999_TEST_ONLY:
          case s.Edition.EDITION_UNKNOWN:
            sr = s.Edition.EDITION_UNKNOWN;
            break;
          default:
            sr = ir;
            break;
        }
        break;
      default:
        throw new Error(`invalid FileDescriptorProto: unsupported syntax: ${er}`);
    }
    if (er === "editions" && ir === s.Edition.EDITION_UNKNOWN)
      throw new Error(`invalid FileDescriptorProto: syntax ${er} cannot have edition ${String(ir)}`);
    return {
      syntax: nr,
      edition: sr
    };
  }
  function be(er, ir) {
    return er.dependency.map((sr) => {
      const nr = ir.files.find((fr) => fr.proto.name === sr);
      return (0, A.assert)(nr), nr;
    });
  }
  function Pe(er, ir, sr) {
    (0, A.assert)(er.name, `invalid ${er.getType().typeName}: missing name`);
    let nr;
    return ir ? nr = `${ir.typeName}.${er.name}` : sr.proto.package !== void 0 ? nr = `${sr.proto.package}.${er.name}` : nr = `${er.name}`, nr;
  }
  function Te(er) {
    return er.startsWith(".") ? er.substring(1) : er;
  }
  function Qe(er) {
    var ir, sr;
    (0, A.assert)((ir = er.proto.options) === null || ir === void 0 ? void 0 : ir.mapEntry, `invalid DescriptorProto: expected ${er.toString()} to be a map entry`), (0, A.assert)(er.fields.length === 2, `invalid DescriptorProto: map entry ${er.toString()} has ${er.fields.length} fields`);
    const nr = er.fields.find((br) => br.proto.number === 1);
    (0, A.assert)(nr, `invalid DescriptorProto: map entry ${er.toString()} is missing key field`);
    const fr = nr.scalar;
    (0, A.assert)(fr !== void 0 && fr !== m.ScalarType.BYTES && fr !== m.ScalarType.FLOAT && fr !== m.ScalarType.DOUBLE, `invalid DescriptorProto: map entry ${er.toString()} has unexpected key type ${(sr = nr.proto.type) !== null && sr !== void 0 ? sr : -1}`);
    const lr = er.fields.find((br) => br.proto.number === 2);
    switch ((0, A.assert)(lr, `invalid DescriptorProto: map entry ${er.toString()} is missing value field`), lr.fieldKind) {
      case "scalar":
        return {
          mapKey: fr,
          mapValue: Object.assign(Object.assign({}, lr), { kind: "scalar" })
        };
      case "message":
        return {
          mapKey: fr,
          mapValue: Object.assign(Object.assign({}, lr), { kind: "message" })
        };
      case "enum":
        return {
          mapKey: fr,
          mapValue: Object.assign(Object.assign({}, lr), { kind: "enum" })
        };
      default:
        throw new Error("invalid DescriptorProto: unsupported map entry value field");
    }
  }
  function xe(er, ir) {
    var sr;
    const nr = er.oneofIndex;
    if (nr === void 0)
      return;
    let fr;
    return er.proto3Optional !== !0 && (fr = ir[nr], (0, A.assert)(fr, `invalid FieldDescriptorProto: oneof #${nr} for field #${(sr = er.number) !== null && sr !== void 0 ? sr : -1} not found`)), fr;
  }
  function Ee(er, ir) {
    switch (ir) {
      case "proto2":
        return er.oneofIndex === void 0 && er.label === s.FieldDescriptorProto_Label.OPTIONAL;
      case "proto3":
        return er.proto3Optional === !0;
      case "editions":
        return !1;
    }
  }
  function He(er, ir) {
    const { repeatedFieldEncoding: sr } = ir();
    if (sr != s.FeatureSet_RepeatedFieldEncoding.PACKED)
      return !1;
    switch (er.type) {
      case s.FieldDescriptorProto_Type.STRING:
      case s.FieldDescriptorProto_Type.BYTES:
      case s.FieldDescriptorProto_Type.GROUP:
      case s.FieldDescriptorProto_Type.MESSAGE:
        return !1;
      default:
        return !0;
    }
  }
  function ve(er, ir, sr, nr) {
    var fr, lr, br, Br, Fr, Gr;
    switch (sr.type) {
      case s.FieldDescriptorProto_Type.STRING:
      case s.FieldDescriptorProto_Type.BYTES:
      case s.FieldDescriptorProto_Type.GROUP:
      case s.FieldDescriptorProto_Type.MESSAGE:
        return !1;
      default:
        switch (er.edition) {
          case s.Edition.EDITION_PROTO2:
            return (lr = (fr = sr.options) === null || fr === void 0 ? void 0 : fr.packed) !== null && lr !== void 0 ? lr : !1;
          case s.Edition.EDITION_PROTO3:
            return (Br = (br = sr.options) === null || br === void 0 ? void 0 : br.packed) !== null && Br !== void 0 ? Br : !0;
          default: {
            const { repeatedFieldEncoding: qr } = nr((Fr = ir == null ? void 0 : ir.getFeatures()) !== null && Fr !== void 0 ? Fr : er.getFeatures(), (Gr = sr.options) === null || Gr === void 0 ? void 0 : Gr.features);
            return qr == s.FeatureSet_RepeatedFieldEncoding.PACKED;
          }
        }
    }
  }
  const we = {
    [s.FieldDescriptorProto_Type.DOUBLE]: m.ScalarType.DOUBLE,
    [s.FieldDescriptorProto_Type.FLOAT]: m.ScalarType.FLOAT,
    [s.FieldDescriptorProto_Type.INT64]: m.ScalarType.INT64,
    [s.FieldDescriptorProto_Type.UINT64]: m.ScalarType.UINT64,
    [s.FieldDescriptorProto_Type.INT32]: m.ScalarType.INT32,
    [s.FieldDescriptorProto_Type.FIXED64]: m.ScalarType.FIXED64,
    [s.FieldDescriptorProto_Type.FIXED32]: m.ScalarType.FIXED32,
    [s.FieldDescriptorProto_Type.BOOL]: m.ScalarType.BOOL,
    [s.FieldDescriptorProto_Type.STRING]: m.ScalarType.STRING,
    [s.FieldDescriptorProto_Type.GROUP]: void 0,
    [s.FieldDescriptorProto_Type.MESSAGE]: void 0,
    [s.FieldDescriptorProto_Type.BYTES]: m.ScalarType.BYTES,
    [s.FieldDescriptorProto_Type.UINT32]: m.ScalarType.UINT32,
    [s.FieldDescriptorProto_Type.ENUM]: void 0,
    [s.FieldDescriptorProto_Type.SFIXED32]: m.ScalarType.SFIXED32,
    [s.FieldDescriptorProto_Type.SFIXED64]: m.ScalarType.SFIXED64,
    [s.FieldDescriptorProto_Type.SINT32]: m.ScalarType.SINT32,
    [s.FieldDescriptorProto_Type.SINT64]: m.ScalarType.SINT64
  };
  function Ce(er, ir) {
    if (!er)
      return {
        leadingDetached: [],
        sourcePath: ir
      };
    for (const sr of er.location)
      if (sr.path.length === ir.length && !sr.path.some((nr, fr) => ir[fr] !== nr))
        return {
          leadingDetached: sr.leadingDetachedComments,
          leading: sr.leadingComments,
          trailing: sr.trailingComments,
          sourcePath: ir
        };
    return {
      leadingDetached: [],
      sourcePath: ir
    };
  }
  var Se;
  (function(er) {
    er[er.FileDescriptorProto_Package = 2] = "FileDescriptorProto_Package", er[er.FileDescriptorProto_MessageType = 4] = "FileDescriptorProto_MessageType", er[er.FileDescriptorProto_EnumType = 5] = "FileDescriptorProto_EnumType", er[er.FileDescriptorProto_Service = 6] = "FileDescriptorProto_Service", er[er.FileDescriptorProto_Extension = 7] = "FileDescriptorProto_Extension", er[er.FileDescriptorProto_Syntax = 12] = "FileDescriptorProto_Syntax", er[er.DescriptorProto_Field = 2] = "DescriptorProto_Field", er[er.DescriptorProto_NestedType = 3] = "DescriptorProto_NestedType", er[er.DescriptorProto_EnumType = 4] = "DescriptorProto_EnumType", er[er.DescriptorProto_Extension = 6] = "DescriptorProto_Extension", er[er.DescriptorProto_OneofDecl = 8] = "DescriptorProto_OneofDecl", er[er.EnumDescriptorProto_Value = 2] = "EnumDescriptorProto_Value", er[er.ServiceDescriptorProto_Method = 2] = "ServiceDescriptorProto_Method";
  })(Se || (Se = {}));
  function Ne() {
    var er, ir, sr;
    const nr = [];
    this.repeated && nr.push("repeated"), this.optional && nr.push("optional"), (this.kind === "extension" ? this.file : this.parent.file).syntax == "proto2" && this.proto.label === s.FieldDescriptorProto_Label.REQUIRED && nr.push("required");
    let lr;
    switch (this.fieldKind) {
      case "scalar":
        lr = m.ScalarType[this.scalar].toLowerCase();
        break;
      case "enum":
        lr = this.enum.typeName;
        break;
      case "message":
        lr = this.message.typeName;
        break;
      case "map": {
        const Fr = m.ScalarType[this.mapKey].toLowerCase();
        let Gr;
        switch (this.mapValue.kind) {
          case "scalar":
            Gr = m.ScalarType[this.mapValue.scalar].toLowerCase();
            break;
          case "enum":
            Gr = this.mapValue.enum.typeName;
            break;
          case "message":
            Gr = this.mapValue.message.typeName;
            break;
        }
        lr = `map<${Fr}, ${Gr}>`;
        break;
      }
    }
    nr.push(`${lr} ${this.name} = ${this.number}`);
    const br = [];
    ((er = this.proto.options) === null || er === void 0 ? void 0 : er.packed) !== void 0 && br.push(`packed = ${this.proto.options.packed.toString()}`);
    let Br = this.proto.defaultValue;
    return Br !== void 0 && ((this.proto.type == s.FieldDescriptorProto_Type.BYTES || this.proto.type == s.FieldDescriptorProto_Type.STRING) && (Br = '"' + Br.replace('"', '\\"') + '"'), br.push(`default = ${Br}`)), this.jsonName !== void 0 && br.push(`json_name = "${this.jsonName}"`), ((ir = this.proto.options) === null || ir === void 0 ? void 0 : ir.jstype) !== void 0 && br.push(`jstype = ${s.FieldOptions_JSType[this.proto.options.jstype]}`), ((sr = this.proto.options) === null || sr === void 0 ? void 0 : sr.deprecated) === !0 && br.push("deprecated = true"), br.length > 0 && nr.push("[" + br.join(", ") + "]"), nr.join(" ");
  }
  function rr() {
    const er = this.proto.defaultValue;
    if (er !== void 0)
      switch (this.fieldKind) {
        case "enum":
          return (0, t.parseTextFormatEnumValue)(this.enum, er);
        case "scalar":
          return (0, t.parseTextFormatScalarValue)(this.scalar, er);
        default:
          return;
      }
  }
  return createDescriptorSet;
}
var createRegistry = {}, hasRequiredCreateRegistry;
function requireCreateRegistry() {
  if (hasRequiredCreateRegistry) return createRegistry;
  hasRequiredCreateRegistry = 1, Object.defineProperty(createRegistry, "__esModule", { value: !0 }), createRegistry.createMutableRegistry = createRegistry.createRegistry = void 0;
  function s(...u) {
    const p = A(...u);
    return delete p.add, p;
  }
  createRegistry.createRegistry = s;
  function A(...u) {
    const p = {}, t = {}, l = {}, m = /* @__PURE__ */ new Map(), b = /* @__PURE__ */ new Map(), k = {
      findMessage(B) {
        return p[B];
      },
      findEnum(B) {
        return t[B];
      },
      findService(B) {
        return l[B];
      },
      findExtensionFor(B, Q) {
        var P, x;
        return (x = (P = b.get(B)) === null || P === void 0 ? void 0 : P.get(Q)) !== null && x !== void 0 ? x : void 0;
      },
      findExtension(B) {
        var Q;
        return (Q = m.get(B)) !== null && Q !== void 0 ? Q : void 0;
      },
      add(B) {
        var Q;
        if ("fields" in B)
          this.findMessage(B.typeName) || (p[B.typeName] = B, B.fields.list().forEach(C));
        else if ("methods" in B) {
          if (!this.findService(B.typeName)) {
            l[B.typeName] = B;
            for (const P of Object.values(B.methods))
              this.add(P.I), this.add(P.O);
          }
        } else if ("extendee" in B) {
          if (!m.has(B.typeName)) {
            m.set(B.typeName, B);
            const P = B.extendee.typeName;
            b.has(P) || b.set(P, /* @__PURE__ */ new Map()), (Q = b.get(P)) === null || Q === void 0 || Q.set(B.field.no, B), this.add(B.extendee), C(B.field);
          }
        } else
          t[B.typeName] = B;
      }
    };
    function C(B) {
      B.kind == "message" ? k.add(B.T) : B.kind == "map" && B.V.kind == "message" ? k.add(B.V.T) : B.kind == "enum" && k.add(B.T);
    }
    for (const B of u)
      k.add(B);
    return k;
  }
  return createRegistry.createMutableRegistry = A, createRegistry;
}
var createRegistryFromDesc = {}, timestamp_pb = {}, hasRequiredTimestamp_pb;
function requireTimestamp_pb() {
  if (hasRequiredTimestamp_pb) return timestamp_pb;
  hasRequiredTimestamp_pb = 1, Object.defineProperty(timestamp_pb, "__esModule", { value: !0 }), timestamp_pb.Timestamp = void 0;
  const s = requireMessage(), A = requireProtoInt64(), u = requireProto3();
  class p extends s.Message {
    constructor(l) {
      super(), this.seconds = A.protoInt64.zero, this.nanos = 0, u.proto3.util.initPartial(l, this);
    }
    fromJson(l, m) {
      if (typeof l != "string")
        throw new Error(`cannot decode google.protobuf.Timestamp from JSON: ${u.proto3.json.debug(l)}`);
      const b = l.match(/^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2}):([0-9]{2})(?:Z|\.([0-9]{3,9})Z|([+-][0-9][0-9]:[0-9][0-9]))$/);
      if (!b)
        throw new Error("cannot decode google.protobuf.Timestamp from JSON: invalid RFC 3339 string");
      const k = Date.parse(b[1] + "-" + b[2] + "-" + b[3] + "T" + b[4] + ":" + b[5] + ":" + b[6] + (b[8] ? b[8] : "Z"));
      if (Number.isNaN(k))
        throw new Error("cannot decode google.protobuf.Timestamp from JSON: invalid RFC 3339 string");
      if (k < Date.parse("0001-01-01T00:00:00Z") || k > Date.parse("9999-12-31T23:59:59Z"))
        throw new Error("cannot decode message google.protobuf.Timestamp from JSON: must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive");
      return this.seconds = A.protoInt64.parse(k / 1e3), this.nanos = 0, b[7] && (this.nanos = parseInt("1" + b[7] + "0".repeat(9 - b[7].length)) - 1e9), this;
    }
    toJson(l) {
      const m = Number(this.seconds) * 1e3;
      if (m < Date.parse("0001-01-01T00:00:00Z") || m > Date.parse("9999-12-31T23:59:59Z"))
        throw new Error("cannot encode google.protobuf.Timestamp to JSON: must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive");
      if (this.nanos < 0)
        throw new Error("cannot encode google.protobuf.Timestamp to JSON: nanos must not be negative");
      let b = "Z";
      if (this.nanos > 0) {
        const k = (this.nanos + 1e9).toString().substring(1);
        k.substring(3) === "000000" ? b = "." + k.substring(0, 3) + "Z" : k.substring(6) === "000" ? b = "." + k.substring(0, 6) + "Z" : b = "." + k + "Z";
      }
      return new Date(m).toISOString().replace(".000Z", b);
    }
    toDate() {
      return new Date(Number(this.seconds) * 1e3 + Math.ceil(this.nanos / 1e6));
    }
    static now() {
      return p.fromDate(/* @__PURE__ */ new Date());
    }
    static fromDate(l) {
      const m = l.getTime();
      return new p({
        seconds: A.protoInt64.parse(Math.floor(m / 1e3)),
        nanos: m % 1e3 * 1e6
      });
    }
    static fromBinary(l, m) {
      return new p().fromBinary(l, m);
    }
    static fromJson(l, m) {
      return new p().fromJson(l, m);
    }
    static fromJsonString(l, m) {
      return new p().fromJsonString(l, m);
    }
    static equals(l, m) {
      return u.proto3.util.equals(p, l, m);
    }
  }
  return timestamp_pb.Timestamp = p, p.runtime = u.proto3, p.typeName = "google.protobuf.Timestamp", p.fields = u.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "seconds",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 2,
      name: "nanos",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    }
  ]), timestamp_pb;
}
var duration_pb = {}, hasRequiredDuration_pb;
function requireDuration_pb() {
  if (hasRequiredDuration_pb) return duration_pb;
  hasRequiredDuration_pb = 1, Object.defineProperty(duration_pb, "__esModule", { value: !0 }), duration_pb.Duration = void 0;
  const s = requireMessage(), A = requireProtoInt64(), u = requireProto3();
  class p extends s.Message {
    constructor(l) {
      super(), this.seconds = A.protoInt64.zero, this.nanos = 0, u.proto3.util.initPartial(l, this);
    }
    fromJson(l, m) {
      if (typeof l != "string")
        throw new Error(`cannot decode google.protobuf.Duration from JSON: ${u.proto3.json.debug(l)}`);
      const b = l.match(/^(-?[0-9]+)(?:\.([0-9]+))?s/);
      if (b === null)
        throw new Error(`cannot decode google.protobuf.Duration from JSON: ${u.proto3.json.debug(l)}`);
      const k = Number(b[1]);
      if (k > 315576e6 || k < -315576e6)
        throw new Error(`cannot decode google.protobuf.Duration from JSON: ${u.proto3.json.debug(l)}`);
      if (this.seconds = A.protoInt64.parse(k), typeof b[2] == "string") {
        const C = b[2] + "0".repeat(9 - b[2].length);
        this.nanos = parseInt(C), (k < 0 || Object.is(k, -0)) && (this.nanos = -this.nanos);
      }
      return this;
    }
    toJson(l) {
      if (Number(this.seconds) > 315576e6 || Number(this.seconds) < -315576e6)
        throw new Error("cannot encode google.protobuf.Duration to JSON: value out of range");
      let m = this.seconds.toString();
      if (this.nanos !== 0) {
        let b = Math.abs(this.nanos).toString();
        b = "0".repeat(9 - b.length) + b, b.substring(3) === "000000" ? b = b.substring(0, 3) : b.substring(6) === "000" && (b = b.substring(0, 6)), m += "." + b, this.nanos < 0 && Number(this.seconds) == 0 && (m = "-" + m);
      }
      return m + "s";
    }
    static fromBinary(l, m) {
      return new p().fromBinary(l, m);
    }
    static fromJson(l, m) {
      return new p().fromJson(l, m);
    }
    static fromJsonString(l, m) {
      return new p().fromJsonString(l, m);
    }
    static equals(l, m) {
      return u.proto3.util.equals(p, l, m);
    }
  }
  return duration_pb.Duration = p, p.runtime = u.proto3, p.typeName = "google.protobuf.Duration", p.fields = u.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "seconds",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 2,
      name: "nanos",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    }
  ]), duration_pb;
}
var any_pb = {}, hasRequiredAny_pb;
function requireAny_pb() {
  if (hasRequiredAny_pb) return any_pb;
  hasRequiredAny_pb = 1, Object.defineProperty(any_pb, "__esModule", { value: !0 }), any_pb.Any = void 0;
  const s = requireMessage(), A = requireProto3();
  class u extends s.Message {
    constructor(t) {
      super(), this.typeUrl = "", this.value = new Uint8Array(0), A.proto3.util.initPartial(t, this);
    }
    toJson(t) {
      var l;
      if (this.typeUrl === "")
        return {};
      const m = this.typeUrlToName(this.typeUrl), b = (l = t == null ? void 0 : t.typeRegistry) === null || l === void 0 ? void 0 : l.findMessage(m);
      if (!b)
        throw new Error(`cannot encode message google.protobuf.Any to JSON: "${this.typeUrl}" is not in the type registry`);
      let C = b.fromBinary(this.value).toJson(t);
      return (m.startsWith("google.protobuf.") || C === null || Array.isArray(C) || typeof C != "object") && (C = { value: C }), C["@type"] = this.typeUrl, C;
    }
    fromJson(t, l) {
      var m;
      if (t === null || Array.isArray(t) || typeof t != "object")
        throw new Error(`cannot decode message google.protobuf.Any from JSON: expected object but got ${t === null ? "null" : Array.isArray(t) ? "array" : typeof t}`);
      if (Object.keys(t).length == 0)
        return this;
      const b = t["@type"];
      if (typeof b != "string" || b == "")
        throw new Error('cannot decode message google.protobuf.Any from JSON: "@type" is empty');
      const k = this.typeUrlToName(b), C = (m = l == null ? void 0 : l.typeRegistry) === null || m === void 0 ? void 0 : m.findMessage(k);
      if (!C)
        throw new Error(`cannot decode message google.protobuf.Any from JSON: ${b} is not in the type registry`);
      let B;
      if (k.startsWith("google.protobuf.") && Object.prototype.hasOwnProperty.call(t, "value"))
        B = C.fromJson(t.value, l);
      else {
        const Q = Object.assign({}, t);
        delete Q["@type"], B = C.fromJson(Q, l);
      }
      return this.packFrom(B), this;
    }
    packFrom(t) {
      this.value = t.toBinary(), this.typeUrl = this.typeNameToUrl(t.getType().typeName);
    }
    unpackTo(t) {
      return this.is(t.getType()) ? (t.fromBinary(this.value), !0) : !1;
    }
    unpack(t) {
      if (this.typeUrl === "")
        return;
      const l = t.findMessage(this.typeUrlToName(this.typeUrl));
      if (l)
        return l.fromBinary(this.value);
    }
    is(t) {
      if (this.typeUrl === "")
        return !1;
      const l = this.typeUrlToName(this.typeUrl);
      let m = "";
      return typeof t == "string" ? m = t : m = t.typeName, l === m;
    }
    typeNameToUrl(t) {
      return `type.googleapis.com/${t}`;
    }
    typeUrlToName(t) {
      if (!t.length)
        throw new Error(`invalid type url: ${t}`);
      const l = t.lastIndexOf("/"), m = l >= 0 ? t.substring(l + 1) : t;
      if (!m.length)
        throw new Error(`invalid type url: ${t}`);
      return m;
    }
    static pack(t) {
      const l = new u();
      return l.packFrom(t), l;
    }
    static fromBinary(t, l) {
      return new u().fromBinary(t, l);
    }
    static fromJson(t, l) {
      return new u().fromJson(t, l);
    }
    static fromJsonString(t, l) {
      return new u().fromJsonString(t, l);
    }
    static equals(t, l) {
      return A.proto3.util.equals(u, t, l);
    }
  }
  return any_pb.Any = u, u.runtime = A.proto3, u.typeName = "google.protobuf.Any", u.fields = A.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "type_url",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "value",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    }
  ]), any_pb;
}
var empty_pb = {}, hasRequiredEmpty_pb;
function requireEmpty_pb() {
  if (hasRequiredEmpty_pb) return empty_pb;
  hasRequiredEmpty_pb = 1, Object.defineProperty(empty_pb, "__esModule", { value: !0 }), empty_pb.Empty = void 0;
  const s = requireMessage(), A = requireProto3();
  class u extends s.Message {
    constructor(t) {
      super(), A.proto3.util.initPartial(t, this);
    }
    static fromBinary(t, l) {
      return new u().fromBinary(t, l);
    }
    static fromJson(t, l) {
      return new u().fromJson(t, l);
    }
    static fromJsonString(t, l) {
      return new u().fromJsonString(t, l);
    }
    static equals(t, l) {
      return A.proto3.util.equals(u, t, l);
    }
  }
  return empty_pb.Empty = u, u.runtime = A.proto3, u.typeName = "google.protobuf.Empty", u.fields = A.proto3.util.newFieldList(() => []), empty_pb;
}
var field_mask_pb = {}, hasRequiredField_mask_pb;
function requireField_mask_pb() {
  if (hasRequiredField_mask_pb) return field_mask_pb;
  hasRequiredField_mask_pb = 1, Object.defineProperty(field_mask_pb, "__esModule", { value: !0 }), field_mask_pb.FieldMask = void 0;
  const s = requireMessage(), A = requireProto3();
  class u extends s.Message {
    constructor(t) {
      super(), this.paths = [], A.proto3.util.initPartial(t, this);
    }
    toJson(t) {
      function l(m) {
        let b = !1;
        const k = [];
        for (let C = 0; C < m.length; C++) {
          let B = m.charAt(C);
          switch (B) {
            case "_":
              b = !0;
              break;
            case "0":
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
              k.push(B), b = !1;
              break;
            default:
              b && (b = !1, B = B.toUpperCase()), k.push(B);
              break;
          }
        }
        return k.join("");
      }
      return this.paths.map((m) => {
        if (m.match(/_[0-9]?_/g) || m.match(/[A-Z]/g))
          throw new Error('cannot encode google.protobuf.FieldMask to JSON: lowerCamelCase of path name "' + m + '" is irreversible');
        return l(m);
      }).join(",");
    }
    fromJson(t, l) {
      if (typeof t != "string")
        throw new Error("cannot decode google.protobuf.FieldMask from JSON: " + A.proto3.json.debug(t));
      if (t === "")
        return this;
      function m(b) {
        if (b.includes("_"))
          throw new Error("cannot decode google.protobuf.FieldMask from JSON: path names must be lowerCamelCase");
        const k = b.replace(/[A-Z]/g, (C) => "_" + C.toLowerCase());
        return k[0] === "_" ? k.substring(1) : k;
      }
      return this.paths = t.split(",").map(m), this;
    }
    static fromBinary(t, l) {
      return new u().fromBinary(t, l);
    }
    static fromJson(t, l) {
      return new u().fromJson(t, l);
    }
    static fromJsonString(t, l) {
      return new u().fromJsonString(t, l);
    }
    static equals(t, l) {
      return A.proto3.util.equals(u, t, l);
    }
  }
  return field_mask_pb.FieldMask = u, u.runtime = A.proto3, u.typeName = "google.protobuf.FieldMask", u.fields = A.proto3.util.newFieldList(() => [
    { no: 1, name: "paths", kind: "scalar", T: 9, repeated: !0 }
  ]), field_mask_pb;
}
var struct_pb = {}, hasRequiredStruct_pb;
function requireStruct_pb() {
  if (hasRequiredStruct_pb) return struct_pb;
  hasRequiredStruct_pb = 1, Object.defineProperty(struct_pb, "__esModule", { value: !0 }), struct_pb.ListValue = struct_pb.Value = struct_pb.Struct = struct_pb.NullValue = void 0;
  const s = requireProto3(), A = requireMessage();
  var u;
  (function(m) {
    m[m.NULL_VALUE = 0] = "NULL_VALUE";
  })(u || (struct_pb.NullValue = u = {})), s.proto3.util.setEnumType(u, "google.protobuf.NullValue", [
    { no: 0, name: "NULL_VALUE" }
  ]);
  class p extends A.Message {
    constructor(b) {
      super(), this.fields = {}, s.proto3.util.initPartial(b, this);
    }
    toJson(b) {
      const k = {};
      for (const [C, B] of Object.entries(this.fields))
        k[C] = B.toJson(b);
      return k;
    }
    fromJson(b, k) {
      if (typeof b != "object" || b == null || Array.isArray(b))
        throw new Error("cannot decode google.protobuf.Struct from JSON " + s.proto3.json.debug(b));
      for (const [C, B] of Object.entries(b))
        this.fields[C] = t.fromJson(B);
      return this;
    }
    static fromBinary(b, k) {
      return new p().fromBinary(b, k);
    }
    static fromJson(b, k) {
      return new p().fromJson(b, k);
    }
    static fromJsonString(b, k) {
      return new p().fromJsonString(b, k);
    }
    static equals(b, k) {
      return s.proto3.util.equals(p, b, k);
    }
  }
  struct_pb.Struct = p, p.runtime = s.proto3, p.typeName = "google.protobuf.Struct", p.fields = s.proto3.util.newFieldList(() => [
    { no: 1, name: "fields", kind: "map", K: 9, V: { kind: "message", T: t } }
  ]);
  class t extends A.Message {
    constructor(b) {
      super(), this.kind = { case: void 0 }, s.proto3.util.initPartial(b, this);
    }
    toJson(b) {
      switch (this.kind.case) {
        case "nullValue":
          return null;
        case "numberValue":
          if (!Number.isFinite(this.kind.value))
            throw new Error("google.protobuf.Value cannot be NaN or Infinity");
          return this.kind.value;
        case "boolValue":
          return this.kind.value;
        case "stringValue":
          return this.kind.value;
        case "structValue":
        case "listValue":
          return this.kind.value.toJson(Object.assign(Object.assign({}, b), { emitDefaultValues: !0 }));
      }
      throw new Error("google.protobuf.Value must have a value");
    }
    fromJson(b, k) {
      switch (typeof b) {
        case "number":
          this.kind = { case: "numberValue", value: b };
          break;
        case "string":
          this.kind = { case: "stringValue", value: b };
          break;
        case "boolean":
          this.kind = { case: "boolValue", value: b };
          break;
        case "object":
          b === null ? this.kind = { case: "nullValue", value: u.NULL_VALUE } : Array.isArray(b) ? this.kind = { case: "listValue", value: l.fromJson(b) } : this.kind = { case: "structValue", value: p.fromJson(b) };
          break;
        default:
          throw new Error("cannot decode google.protobuf.Value from JSON " + s.proto3.json.debug(b));
      }
      return this;
    }
    static fromBinary(b, k) {
      return new t().fromBinary(b, k);
    }
    static fromJson(b, k) {
      return new t().fromJson(b, k);
    }
    static fromJsonString(b, k) {
      return new t().fromJsonString(b, k);
    }
    static equals(b, k) {
      return s.proto3.util.equals(t, b, k);
    }
  }
  struct_pb.Value = t, t.runtime = s.proto3, t.typeName = "google.protobuf.Value", t.fields = s.proto3.util.newFieldList(() => [
    { no: 1, name: "null_value", kind: "enum", T: s.proto3.getEnumType(u), oneof: "kind" },
    { no: 2, name: "number_value", kind: "scalar", T: 1, oneof: "kind" },
    { no: 3, name: "string_value", kind: "scalar", T: 9, oneof: "kind" },
    { no: 4, name: "bool_value", kind: "scalar", T: 8, oneof: "kind" },
    { no: 5, name: "struct_value", kind: "message", T: p, oneof: "kind" },
    { no: 6, name: "list_value", kind: "message", T: l, oneof: "kind" }
  ]);
  class l extends A.Message {
    constructor(b) {
      super(), this.values = [], s.proto3.util.initPartial(b, this);
    }
    toJson(b) {
      return this.values.map((k) => k.toJson());
    }
    fromJson(b, k) {
      if (!Array.isArray(b))
        throw new Error("cannot decode google.protobuf.ListValue from JSON " + s.proto3.json.debug(b));
      for (let C of b)
        this.values.push(t.fromJson(C));
      return this;
    }
    static fromBinary(b, k) {
      return new l().fromBinary(b, k);
    }
    static fromJson(b, k) {
      return new l().fromJson(b, k);
    }
    static fromJsonString(b, k) {
      return new l().fromJsonString(b, k);
    }
    static equals(b, k) {
      return s.proto3.util.equals(l, b, k);
    }
  }
  return struct_pb.ListValue = l, l.runtime = s.proto3, l.typeName = "google.protobuf.ListValue", l.fields = s.proto3.util.newFieldList(() => [
    { no: 1, name: "values", kind: "message", T: t, repeated: !0 }
  ]), struct_pb;
}
var wrappers_pb = {}, hasRequiredWrappers_pb;
function requireWrappers_pb() {
  if (hasRequiredWrappers_pb) return wrappers_pb;
  hasRequiredWrappers_pb = 1, Object.defineProperty(wrappers_pb, "__esModule", { value: !0 }), wrappers_pb.BytesValue = wrappers_pb.StringValue = wrappers_pb.BoolValue = wrappers_pb.UInt32Value = wrappers_pb.Int32Value = wrappers_pb.UInt64Value = wrappers_pb.Int64Value = wrappers_pb.FloatValue = wrappers_pb.DoubleValue = void 0;
  const s = requireMessage(), A = requireProto3(), u = requireScalar(), p = requireProtoInt64();
  class t extends s.Message {
    constructor(M) {
      super(), this.value = 0, A.proto3.util.initPartial(M, this);
    }
    toJson(M) {
      return A.proto3.json.writeScalar(u.ScalarType.DOUBLE, this.value, !0);
    }
    fromJson(M, F) {
      try {
        this.value = A.proto3.json.readScalar(u.ScalarType.DOUBLE, M);
      } catch (le) {
        let ge = 'cannot decode message google.protobuf.DoubleValue from JSON"';
        throw le instanceof Error && le.message.length > 0 && (ge += `: ${le.message}`), new Error(ge);
      }
      return this;
    }
    static fromBinary(M, F) {
      return new t().fromBinary(M, F);
    }
    static fromJson(M, F) {
      return new t().fromJson(M, F);
    }
    static fromJsonString(M, F) {
      return new t().fromJsonString(M, F);
    }
    static equals(M, F) {
      return A.proto3.util.equals(t, M, F);
    }
  }
  wrappers_pb.DoubleValue = t, t.runtime = A.proto3, t.typeName = "google.protobuf.DoubleValue", t.fields = A.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "value",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    }
  ]), t.fieldWrapper = {
    wrapField(x) {
      return new t({ value: x });
    },
    unwrapField(x) {
      return x.value;
    }
  };
  class l extends s.Message {
    constructor(M) {
      super(), this.value = 0, A.proto3.util.initPartial(M, this);
    }
    toJson(M) {
      return A.proto3.json.writeScalar(u.ScalarType.FLOAT, this.value, !0);
    }
    fromJson(M, F) {
      try {
        this.value = A.proto3.json.readScalar(u.ScalarType.FLOAT, M);
      } catch (le) {
        let ge = 'cannot decode message google.protobuf.FloatValue from JSON"';
        throw le instanceof Error && le.message.length > 0 && (ge += `: ${le.message}`), new Error(ge);
      }
      return this;
    }
    static fromBinary(M, F) {
      return new l().fromBinary(M, F);
    }
    static fromJson(M, F) {
      return new l().fromJson(M, F);
    }
    static fromJsonString(M, F) {
      return new l().fromJsonString(M, F);
    }
    static equals(M, F) {
      return A.proto3.util.equals(l, M, F);
    }
  }
  wrappers_pb.FloatValue = l, l.runtime = A.proto3, l.typeName = "google.protobuf.FloatValue", l.fields = A.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "value",
      kind: "scalar",
      T: 2
      /* ScalarType.FLOAT */
    }
  ]), l.fieldWrapper = {
    wrapField(x) {
      return new l({ value: x });
    },
    unwrapField(x) {
      return x.value;
    }
  };
  class m extends s.Message {
    constructor(M) {
      super(), this.value = p.protoInt64.zero, A.proto3.util.initPartial(M, this);
    }
    toJson(M) {
      return A.proto3.json.writeScalar(u.ScalarType.INT64, this.value, !0);
    }
    fromJson(M, F) {
      try {
        this.value = A.proto3.json.readScalar(u.ScalarType.INT64, M);
      } catch (le) {
        let ge = 'cannot decode message google.protobuf.Int64Value from JSON"';
        throw le instanceof Error && le.message.length > 0 && (ge += `: ${le.message}`), new Error(ge);
      }
      return this;
    }
    static fromBinary(M, F) {
      return new m().fromBinary(M, F);
    }
    static fromJson(M, F) {
      return new m().fromJson(M, F);
    }
    static fromJsonString(M, F) {
      return new m().fromJsonString(M, F);
    }
    static equals(M, F) {
      return A.proto3.util.equals(m, M, F);
    }
  }
  wrappers_pb.Int64Value = m, m.runtime = A.proto3, m.typeName = "google.protobuf.Int64Value", m.fields = A.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "value",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    }
  ]), m.fieldWrapper = {
    wrapField(x) {
      return new m({ value: x });
    },
    unwrapField(x) {
      return x.value;
    }
  };
  class b extends s.Message {
    constructor(M) {
      super(), this.value = p.protoInt64.zero, A.proto3.util.initPartial(M, this);
    }
    toJson(M) {
      return A.proto3.json.writeScalar(u.ScalarType.UINT64, this.value, !0);
    }
    fromJson(M, F) {
      try {
        this.value = A.proto3.json.readScalar(u.ScalarType.UINT64, M);
      } catch (le) {
        let ge = 'cannot decode message google.protobuf.UInt64Value from JSON"';
        throw le instanceof Error && le.message.length > 0 && (ge += `: ${le.message}`), new Error(ge);
      }
      return this;
    }
    static fromBinary(M, F) {
      return new b().fromBinary(M, F);
    }
    static fromJson(M, F) {
      return new b().fromJson(M, F);
    }
    static fromJsonString(M, F) {
      return new b().fromJsonString(M, F);
    }
    static equals(M, F) {
      return A.proto3.util.equals(b, M, F);
    }
  }
  wrappers_pb.UInt64Value = b, b.runtime = A.proto3, b.typeName = "google.protobuf.UInt64Value", b.fields = A.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "value",
      kind: "scalar",
      T: 4
      /* ScalarType.UINT64 */
    }
  ]), b.fieldWrapper = {
    wrapField(x) {
      return new b({ value: x });
    },
    unwrapField(x) {
      return x.value;
    }
  };
  class k extends s.Message {
    constructor(M) {
      super(), this.value = 0, A.proto3.util.initPartial(M, this);
    }
    toJson(M) {
      return A.proto3.json.writeScalar(u.ScalarType.INT32, this.value, !0);
    }
    fromJson(M, F) {
      try {
        this.value = A.proto3.json.readScalar(u.ScalarType.INT32, M);
      } catch (le) {
        let ge = 'cannot decode message google.protobuf.Int32Value from JSON"';
        throw le instanceof Error && le.message.length > 0 && (ge += `: ${le.message}`), new Error(ge);
      }
      return this;
    }
    static fromBinary(M, F) {
      return new k().fromBinary(M, F);
    }
    static fromJson(M, F) {
      return new k().fromJson(M, F);
    }
    static fromJsonString(M, F) {
      return new k().fromJsonString(M, F);
    }
    static equals(M, F) {
      return A.proto3.util.equals(k, M, F);
    }
  }
  wrappers_pb.Int32Value = k, k.runtime = A.proto3, k.typeName = "google.protobuf.Int32Value", k.fields = A.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "value",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    }
  ]), k.fieldWrapper = {
    wrapField(x) {
      return new k({ value: x });
    },
    unwrapField(x) {
      return x.value;
    }
  };
  class C extends s.Message {
    constructor(M) {
      super(), this.value = 0, A.proto3.util.initPartial(M, this);
    }
    toJson(M) {
      return A.proto3.json.writeScalar(u.ScalarType.UINT32, this.value, !0);
    }
    fromJson(M, F) {
      try {
        this.value = A.proto3.json.readScalar(u.ScalarType.UINT32, M);
      } catch (le) {
        let ge = 'cannot decode message google.protobuf.UInt32Value from JSON"';
        throw le instanceof Error && le.message.length > 0 && (ge += `: ${le.message}`), new Error(ge);
      }
      return this;
    }
    static fromBinary(M, F) {
      return new C().fromBinary(M, F);
    }
    static fromJson(M, F) {
      return new C().fromJson(M, F);
    }
    static fromJsonString(M, F) {
      return new C().fromJsonString(M, F);
    }
    static equals(M, F) {
      return A.proto3.util.equals(C, M, F);
    }
  }
  wrappers_pb.UInt32Value = C, C.runtime = A.proto3, C.typeName = "google.protobuf.UInt32Value", C.fields = A.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "value",
      kind: "scalar",
      T: 13
      /* ScalarType.UINT32 */
    }
  ]), C.fieldWrapper = {
    wrapField(x) {
      return new C({ value: x });
    },
    unwrapField(x) {
      return x.value;
    }
  };
  class B extends s.Message {
    constructor(M) {
      super(), this.value = !1, A.proto3.util.initPartial(M, this);
    }
    toJson(M) {
      return A.proto3.json.writeScalar(u.ScalarType.BOOL, this.value, !0);
    }
    fromJson(M, F) {
      try {
        this.value = A.proto3.json.readScalar(u.ScalarType.BOOL, M);
      } catch (le) {
        let ge = 'cannot decode message google.protobuf.BoolValue from JSON"';
        throw le instanceof Error && le.message.length > 0 && (ge += `: ${le.message}`), new Error(ge);
      }
      return this;
    }
    static fromBinary(M, F) {
      return new B().fromBinary(M, F);
    }
    static fromJson(M, F) {
      return new B().fromJson(M, F);
    }
    static fromJsonString(M, F) {
      return new B().fromJsonString(M, F);
    }
    static equals(M, F) {
      return A.proto3.util.equals(B, M, F);
    }
  }
  wrappers_pb.BoolValue = B, B.runtime = A.proto3, B.typeName = "google.protobuf.BoolValue", B.fields = A.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "value",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]), B.fieldWrapper = {
    wrapField(x) {
      return new B({ value: x });
    },
    unwrapField(x) {
      return x.value;
    }
  };
  class Q extends s.Message {
    constructor(M) {
      super(), this.value = "", A.proto3.util.initPartial(M, this);
    }
    toJson(M) {
      return A.proto3.json.writeScalar(u.ScalarType.STRING, this.value, !0);
    }
    fromJson(M, F) {
      try {
        this.value = A.proto3.json.readScalar(u.ScalarType.STRING, M);
      } catch (le) {
        let ge = 'cannot decode message google.protobuf.StringValue from JSON"';
        throw le instanceof Error && le.message.length > 0 && (ge += `: ${le.message}`), new Error(ge);
      }
      return this;
    }
    static fromBinary(M, F) {
      return new Q().fromBinary(M, F);
    }
    static fromJson(M, F) {
      return new Q().fromJson(M, F);
    }
    static fromJsonString(M, F) {
      return new Q().fromJsonString(M, F);
    }
    static equals(M, F) {
      return A.proto3.util.equals(Q, M, F);
    }
  }
  wrappers_pb.StringValue = Q, Q.runtime = A.proto3, Q.typeName = "google.protobuf.StringValue", Q.fields = A.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "value",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]), Q.fieldWrapper = {
    wrapField(x) {
      return new Q({ value: x });
    },
    unwrapField(x) {
      return x.value;
    }
  };
  class P extends s.Message {
    constructor(M) {
      super(), this.value = new Uint8Array(0), A.proto3.util.initPartial(M, this);
    }
    toJson(M) {
      return A.proto3.json.writeScalar(u.ScalarType.BYTES, this.value, !0);
    }
    fromJson(M, F) {
      try {
        this.value = A.proto3.json.readScalar(u.ScalarType.BYTES, M);
      } catch (le) {
        let ge = 'cannot decode message google.protobuf.BytesValue from JSON"';
        throw le instanceof Error && le.message.length > 0 && (ge += `: ${le.message}`), new Error(ge);
      }
      return this;
    }
    static fromBinary(M, F) {
      return new P().fromBinary(M, F);
    }
    static fromJson(M, F) {
      return new P().fromJson(M, F);
    }
    static fromJsonString(M, F) {
      return new P().fromJsonString(M, F);
    }
    static equals(M, F) {
      return A.proto3.util.equals(P, M, F);
    }
  }
  return wrappers_pb.BytesValue = P, P.runtime = A.proto3, P.typeName = "google.protobuf.BytesValue", P.fields = A.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "value",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    }
  ]), P.fieldWrapper = {
    wrapField(x) {
      return new P({ value: x });
    },
    unwrapField(x) {
      return x.value;
    }
  }, wrappers_pb;
}
var hasRequiredCreateRegistryFromDesc;
function requireCreateRegistryFromDesc() {
  if (hasRequiredCreateRegistryFromDesc) return createRegistryFromDesc;
  hasRequiredCreateRegistryFromDesc = 1, Object.defineProperty(createRegistryFromDesc, "__esModule", { value: !0 }), createRegistryFromDesc.createRegistryFromDescriptors = void 0;
  const s = requireAssert$1(), A = requireProto3(), u = requireProto2(), p = requireNames(), t = requireTimestamp_pb(), l = requireDuration_pb(), m = requireAny_pb(), b = requireEmpty_pb(), k = requireField_mask_pb(), C = requireStruct_pb(), B = require_enum(), Q = requireWrappers_pb(), P = requireDescriptor_pb(), x = requireCreateDescriptorSet(), M = requireIsMessage(), F = [
    m.Any,
    l.Duration,
    b.Empty,
    k.FieldMask,
    C.Struct,
    C.Value,
    C.ListValue,
    t.Timestamp,
    l.Duration,
    Q.DoubleValue,
    Q.FloatValue,
    Q.Int64Value,
    Q.Int32Value,
    Q.UInt32Value,
    Q.UInt64Value,
    Q.BoolValue,
    Q.StringValue,
    Q.BytesValue
  ], le = [(0, B.getEnumType)(C.NullValue)];
  function ge(be, Pe = !0) {
    const Te = be instanceof Uint8Array || (0, M.isMessage)(be, P.FileDescriptorSet) ? (0, x.createDescriptorSet)(be) : be, Qe = /* @__PURE__ */ new Map(), xe = /* @__PURE__ */ new Map(), Ee = /* @__PURE__ */ new Map(), He = /* @__PURE__ */ new Map(), ve = {};
    if (Pe) {
      for (const we of F)
        xe.set(we.typeName, we);
      for (const we of le)
        Qe.set(we.typeName, we);
    }
    return {
      /**
       * May raise an error on invalid descriptors.
       */
      findEnum(we) {
        const Ce = Qe.get(we);
        if (Ce)
          return Ce;
        const Se = Te.enums.get(we);
        if (!Se)
          return;
        const rr = (Se.file.syntax == "proto3" ? A.proto3 : u.proto2).makeEnumType(we, Se.values.map((er) => ({
          no: er.number,
          name: er.name,
          localName: (0, p.localName)(er)
        })), {});
        return Qe.set(we, rr), rr;
      },
      /**
       * May raise an error on invalid descriptors.
       */
      findMessage(we) {
        const Ce = xe.get(we);
        if (Ce)
          return Ce;
        const Se = Te.messages.get(we);
        if (!Se)
          return;
        const Ne = Se.file.syntax == "proto3" ? A.proto3 : u.proto2, rr = [], er = Ne.makeMessageType(we, () => rr, {
          localName: (0, p.localName)(Se)
        });
        xe.set(we, er);
        for (const ir of Se.fields)
          rr.push(pe(ir, this));
        return er;
      },
      /**
       * May raise an error on invalid descriptors.
       */
      findService(we) {
        const Ce = ve[we];
        if (Ce)
          return Ce;
        const Se = Te.services.get(we);
        if (!Se)
          return;
        const Ne = {};
        for (const rr of Se.methods) {
          const er = Ie(rr.input, this, rr), ir = Ie(rr.output, this, rr);
          Ne[(0, p.localName)(rr)] = {
            name: rr.name,
            I: er,
            O: ir,
            kind: rr.methodKind,
            idempotency: rr.idempotency
            // We do not surface options at this time
            // options: {},
          };
        }
        return ve[we] = {
          typeName: Se.typeName,
          methods: Ne
        };
      },
      /**
       * May raise an error on invalid descriptors.
       */
      findExtensionFor(we, Ce) {
        var Se;
        if (!Te.messages.has(we))
          return;
        let Ne = He.get(we);
        if (!Ne) {
          Ne = /* @__PURE__ */ new Map(), He.set(we, Ne);
          for (const er of Te.extensions.values())
            er.extendee.typeName == we && Ne.set(er.number, er);
        }
        const rr = (Se = He.get(we)) === null || Se === void 0 ? void 0 : Se.get(Ce);
        return rr ? this.findExtension(rr.typeName) : void 0;
      },
      /**
       * May raise an error on invalid descriptors.
       */
      findExtension(we) {
        const Ce = Ee.get(we);
        if (Ce)
          return Ce;
        const Se = Te.extensions.get(we);
        if (!Se)
          return;
        const Ne = Ie(Se.extendee, this, Se), er = (Se.file.syntax == "proto3" ? A.proto3 : u.proto2).makeExtension(we, Ne, pe(Se, this));
        return Ee.set(we, er), er;
      }
    };
  }
  createRegistryFromDesc.createRegistryFromDescriptors = ge;
  function pe(be, Pe) {
    var Te;
    const Qe = {
      kind: be.fieldKind,
      no: be.number,
      name: be.name,
      jsonName: be.jsonName,
      delimited: be.proto.type == P.FieldDescriptorProto_Type.GROUP,
      repeated: be.repeated,
      packed: be.packed,
      oneof: (Te = be.oneof) === null || Te === void 0 ? void 0 : Te.name,
      opt: be.optional,
      req: be.proto.label === P.FieldDescriptorProto_Label.REQUIRED
    };
    switch (be.fieldKind) {
      case "map": {
        (0, s.assert)(be.kind == "field");
        let xe;
        switch (be.mapValue.kind) {
          case "scalar":
            xe = be.mapValue.scalar;
            break;
          case "enum": {
            xe = Ie(be.mapValue.enum, Pe, be);
            break;
          }
          case "message": {
            xe = Ie(be.mapValue.message, Pe, be);
            break;
          }
        }
        Qe.K = be.mapKey, Qe.V = {
          kind: be.mapValue.kind,
          T: xe
        };
        break;
      }
      case "message": {
        Qe.T = Ie(be.message, Pe, be);
        break;
      }
      case "enum": {
        Qe.T = Ie(be.enum, Pe, be), Qe.default = be.getDefaultValue();
        break;
      }
      case "scalar": {
        Qe.L = be.longType, Qe.T = be.scalar, Qe.default = be.getDefaultValue();
        break;
      }
    }
    return Qe;
  }
  function Ie(be, Pe, Te) {
    const Qe = be.kind == "message" ? Pe.findMessage(be.typeName) : Pe.findEnum(be.typeName);
    return (0, s.assert)(Qe, `${be.toString()}" for ${Te.toString()} not found`), Qe;
  }
  return createRegistryFromDesc;
}
var toPlainMessage = {}, hasRequiredToPlainMessage;
function requireToPlainMessage() {
  if (hasRequiredToPlainMessage) return toPlainMessage;
  hasRequiredToPlainMessage = 1, Object.defineProperty(toPlainMessage, "__esModule", { value: !0 }), toPlainMessage.toPlainMessage = void 0;
  const s = requireIsMessage();
  function A(p) {
    if (!(0, s.isMessage)(p))
      return p;
    const t = p.getType(), l = {};
    for (const m of t.fields.byMember()) {
      const b = p[m.localName];
      let k;
      if (m.repeated)
        k = b.map((C) => u(C));
      else if (m.kind == "map") {
        k = {};
        for (const [C, B] of Object.entries(b))
          k[C] = u(B);
      } else m.kind == "oneof" ? k = m.findField(b.case) ? { case: b.case, value: u(b.value) } : { case: void 0 } : k = u(b);
      l[m.localName] = k;
    }
    return l;
  }
  toPlainMessage.toPlainMessage = A;
  function u(p) {
    if (p === void 0)
      return p;
    if ((0, s.isMessage)(p))
      return A(p);
    if (p instanceof Uint8Array) {
      const t = new Uint8Array(p.byteLength);
      return t.set(p), t;
    }
    return p;
  }
  return toPlainMessage;
}
var plugin_pb = {}, hasRequiredPlugin_pb;
function requirePlugin_pb() {
  if (hasRequiredPlugin_pb) return plugin_pb;
  hasRequiredPlugin_pb = 1, Object.defineProperty(plugin_pb, "__esModule", { value: !0 }), plugin_pb.CodeGeneratorResponse_File = plugin_pb.CodeGeneratorResponse_Feature = plugin_pb.CodeGeneratorResponse = plugin_pb.CodeGeneratorRequest = plugin_pb.Version = void 0;
  const s = requireMessage(), A = requireProto2(), u = requireDescriptor_pb();
  class p extends s.Message {
    constructor(C) {
      super(), A.proto2.util.initPartial(C, this);
    }
    static fromBinary(C, B) {
      return new p().fromBinary(C, B);
    }
    static fromJson(C, B) {
      return new p().fromJson(C, B);
    }
    static fromJsonString(C, B) {
      return new p().fromJsonString(C, B);
    }
    static equals(C, B) {
      return A.proto2.util.equals(p, C, B);
    }
  }
  plugin_pb.Version = p, p.runtime = A.proto2, p.typeName = "google.protobuf.compiler.Version", p.fields = A.proto2.util.newFieldList(() => [
    { no: 1, name: "major", kind: "scalar", T: 5, opt: !0 },
    { no: 2, name: "minor", kind: "scalar", T: 5, opt: !0 },
    { no: 3, name: "patch", kind: "scalar", T: 5, opt: !0 },
    { no: 4, name: "suffix", kind: "scalar", T: 9, opt: !0 }
  ]);
  class t extends s.Message {
    constructor(C) {
      super(), this.fileToGenerate = [], this.protoFile = [], this.sourceFileDescriptors = [], A.proto2.util.initPartial(C, this);
    }
    static fromBinary(C, B) {
      return new t().fromBinary(C, B);
    }
    static fromJson(C, B) {
      return new t().fromJson(C, B);
    }
    static fromJsonString(C, B) {
      return new t().fromJsonString(C, B);
    }
    static equals(C, B) {
      return A.proto2.util.equals(t, C, B);
    }
  }
  plugin_pb.CodeGeneratorRequest = t, t.runtime = A.proto2, t.typeName = "google.protobuf.compiler.CodeGeneratorRequest", t.fields = A.proto2.util.newFieldList(() => [
    { no: 1, name: "file_to_generate", kind: "scalar", T: 9, repeated: !0 },
    { no: 2, name: "parameter", kind: "scalar", T: 9, opt: !0 },
    { no: 15, name: "proto_file", kind: "message", T: u.FileDescriptorProto, repeated: !0 },
    { no: 17, name: "source_file_descriptors", kind: "message", T: u.FileDescriptorProto, repeated: !0 },
    { no: 3, name: "compiler_version", kind: "message", T: p, opt: !0 }
  ]);
  class l extends s.Message {
    constructor(C) {
      super(), this.file = [], A.proto2.util.initPartial(C, this);
    }
    static fromBinary(C, B) {
      return new l().fromBinary(C, B);
    }
    static fromJson(C, B) {
      return new l().fromJson(C, B);
    }
    static fromJsonString(C, B) {
      return new l().fromJsonString(C, B);
    }
    static equals(C, B) {
      return A.proto2.util.equals(l, C, B);
    }
  }
  plugin_pb.CodeGeneratorResponse = l, l.runtime = A.proto2, l.typeName = "google.protobuf.compiler.CodeGeneratorResponse", l.fields = A.proto2.util.newFieldList(() => [
    { no: 1, name: "error", kind: "scalar", T: 9, opt: !0 },
    { no: 2, name: "supported_features", kind: "scalar", T: 4, opt: !0 },
    { no: 3, name: "minimum_edition", kind: "scalar", T: 5, opt: !0 },
    { no: 4, name: "maximum_edition", kind: "scalar", T: 5, opt: !0 },
    { no: 15, name: "file", kind: "message", T: b, repeated: !0 }
  ]);
  var m;
  (function(k) {
    k[k.NONE = 0] = "NONE", k[k.PROTO3_OPTIONAL = 1] = "PROTO3_OPTIONAL", k[k.SUPPORTS_EDITIONS = 2] = "SUPPORTS_EDITIONS";
  })(m || (plugin_pb.CodeGeneratorResponse_Feature = m = {})), A.proto2.util.setEnumType(m, "google.protobuf.compiler.CodeGeneratorResponse.Feature", [
    { no: 0, name: "FEATURE_NONE" },
    { no: 1, name: "FEATURE_PROTO3_OPTIONAL" },
    { no: 2, name: "FEATURE_SUPPORTS_EDITIONS" }
  ]);
  class b extends s.Message {
    constructor(C) {
      super(), A.proto2.util.initPartial(C, this);
    }
    static fromBinary(C, B) {
      return new b().fromBinary(C, B);
    }
    static fromJson(C, B) {
      return new b().fromJson(C, B);
    }
    static fromJsonString(C, B) {
      return new b().fromJsonString(C, B);
    }
    static equals(C, B) {
      return A.proto2.util.equals(b, C, B);
    }
  }
  return plugin_pb.CodeGeneratorResponse_File = b, b.runtime = A.proto2, b.typeName = "google.protobuf.compiler.CodeGeneratorResponse.File", b.fields = A.proto2.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
    { no: 2, name: "insertion_point", kind: "scalar", T: 9, opt: !0 },
    { no: 15, name: "content", kind: "scalar", T: 9, opt: !0 },
    { no: 16, name: "generated_code_info", kind: "message", T: u.GeneratedCodeInfo, opt: !0 }
  ]), plugin_pb;
}
var api_pb = {}, type_pb = {}, source_context_pb = {}, hasRequiredSource_context_pb;
function requireSource_context_pb() {
  if (hasRequiredSource_context_pb) return source_context_pb;
  hasRequiredSource_context_pb = 1, Object.defineProperty(source_context_pb, "__esModule", { value: !0 }), source_context_pb.SourceContext = void 0;
  const s = requireMessage(), A = requireProto3();
  class u extends s.Message {
    constructor(t) {
      super(), this.fileName = "", A.proto3.util.initPartial(t, this);
    }
    static fromBinary(t, l) {
      return new u().fromBinary(t, l);
    }
    static fromJson(t, l) {
      return new u().fromJson(t, l);
    }
    static fromJsonString(t, l) {
      return new u().fromJsonString(t, l);
    }
    static equals(t, l) {
      return A.proto3.util.equals(u, t, l);
    }
  }
  return source_context_pb.SourceContext = u, u.runtime = A.proto3, u.typeName = "google.protobuf.SourceContext", u.fields = A.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "file_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]), source_context_pb;
}
var hasRequiredType_pb;
function requireType_pb() {
  if (hasRequiredType_pb) return type_pb;
  hasRequiredType_pb = 1, Object.defineProperty(type_pb, "__esModule", { value: !0 }), type_pb.Option = type_pb.EnumValue = type_pb.Enum = type_pb.Field_Cardinality = type_pb.Field_Kind = type_pb.Field = type_pb.Type = type_pb.Syntax = void 0;
  const s = requireProto3(), A = requireMessage(), u = requireSource_context_pb(), p = requireAny_pb();
  var t;
  (function(P) {
    P[P.PROTO2 = 0] = "PROTO2", P[P.PROTO3 = 1] = "PROTO3", P[P.EDITIONS = 2] = "EDITIONS";
  })(t || (type_pb.Syntax = t = {})), s.proto3.util.setEnumType(t, "google.protobuf.Syntax", [
    { no: 0, name: "SYNTAX_PROTO2" },
    { no: 1, name: "SYNTAX_PROTO3" },
    { no: 2, name: "SYNTAX_EDITIONS" }
  ]);
  class l extends A.Message {
    constructor(x) {
      super(), this.name = "", this.fields = [], this.oneofs = [], this.options = [], this.syntax = t.PROTO2, this.edition = "", s.proto3.util.initPartial(x, this);
    }
    static fromBinary(x, M) {
      return new l().fromBinary(x, M);
    }
    static fromJson(x, M) {
      return new l().fromJson(x, M);
    }
    static fromJsonString(x, M) {
      return new l().fromJsonString(x, M);
    }
    static equals(x, M) {
      return s.proto3.util.equals(l, x, M);
    }
  }
  type_pb.Type = l, l.runtime = s.proto3, l.typeName = "google.protobuf.Type", l.fields = s.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "fields", kind: "message", T: m, repeated: !0 },
    { no: 3, name: "oneofs", kind: "scalar", T: 9, repeated: !0 },
    { no: 4, name: "options", kind: "message", T: Q, repeated: !0 },
    { no: 5, name: "source_context", kind: "message", T: u.SourceContext },
    { no: 6, name: "syntax", kind: "enum", T: s.proto3.getEnumType(t) },
    {
      no: 7,
      name: "edition",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]);
  class m extends A.Message {
    constructor(x) {
      super(), this.kind = b.TYPE_UNKNOWN, this.cardinality = k.UNKNOWN, this.number = 0, this.name = "", this.typeUrl = "", this.oneofIndex = 0, this.packed = !1, this.options = [], this.jsonName = "", this.defaultValue = "", s.proto3.util.initPartial(x, this);
    }
    static fromBinary(x, M) {
      return new m().fromBinary(x, M);
    }
    static fromJson(x, M) {
      return new m().fromJson(x, M);
    }
    static fromJsonString(x, M) {
      return new m().fromJsonString(x, M);
    }
    static equals(x, M) {
      return s.proto3.util.equals(m, x, M);
    }
  }
  type_pb.Field = m, m.runtime = s.proto3, m.typeName = "google.protobuf.Field", m.fields = s.proto3.util.newFieldList(() => [
    { no: 1, name: "kind", kind: "enum", T: s.proto3.getEnumType(b) },
    { no: 2, name: "cardinality", kind: "enum", T: s.proto3.getEnumType(k) },
    {
      no: 3,
      name: "number",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 4,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 6,
      name: "type_url",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 7,
      name: "oneof_index",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 8,
      name: "packed",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    { no: 9, name: "options", kind: "message", T: Q, repeated: !0 },
    {
      no: 10,
      name: "json_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 11,
      name: "default_value",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]);
  var b;
  (function(P) {
    P[P.TYPE_UNKNOWN = 0] = "TYPE_UNKNOWN", P[P.TYPE_DOUBLE = 1] = "TYPE_DOUBLE", P[P.TYPE_FLOAT = 2] = "TYPE_FLOAT", P[P.TYPE_INT64 = 3] = "TYPE_INT64", P[P.TYPE_UINT64 = 4] = "TYPE_UINT64", P[P.TYPE_INT32 = 5] = "TYPE_INT32", P[P.TYPE_FIXED64 = 6] = "TYPE_FIXED64", P[P.TYPE_FIXED32 = 7] = "TYPE_FIXED32", P[P.TYPE_BOOL = 8] = "TYPE_BOOL", P[P.TYPE_STRING = 9] = "TYPE_STRING", P[P.TYPE_GROUP = 10] = "TYPE_GROUP", P[P.TYPE_MESSAGE = 11] = "TYPE_MESSAGE", P[P.TYPE_BYTES = 12] = "TYPE_BYTES", P[P.TYPE_UINT32 = 13] = "TYPE_UINT32", P[P.TYPE_ENUM = 14] = "TYPE_ENUM", P[P.TYPE_SFIXED32 = 15] = "TYPE_SFIXED32", P[P.TYPE_SFIXED64 = 16] = "TYPE_SFIXED64", P[P.TYPE_SINT32 = 17] = "TYPE_SINT32", P[P.TYPE_SINT64 = 18] = "TYPE_SINT64";
  })(b || (type_pb.Field_Kind = b = {})), s.proto3.util.setEnumType(b, "google.protobuf.Field.Kind", [
    { no: 0, name: "TYPE_UNKNOWN" },
    { no: 1, name: "TYPE_DOUBLE" },
    { no: 2, name: "TYPE_FLOAT" },
    { no: 3, name: "TYPE_INT64" },
    { no: 4, name: "TYPE_UINT64" },
    { no: 5, name: "TYPE_INT32" },
    { no: 6, name: "TYPE_FIXED64" },
    { no: 7, name: "TYPE_FIXED32" },
    { no: 8, name: "TYPE_BOOL" },
    { no: 9, name: "TYPE_STRING" },
    { no: 10, name: "TYPE_GROUP" },
    { no: 11, name: "TYPE_MESSAGE" },
    { no: 12, name: "TYPE_BYTES" },
    { no: 13, name: "TYPE_UINT32" },
    { no: 14, name: "TYPE_ENUM" },
    { no: 15, name: "TYPE_SFIXED32" },
    { no: 16, name: "TYPE_SFIXED64" },
    { no: 17, name: "TYPE_SINT32" },
    { no: 18, name: "TYPE_SINT64" }
  ]);
  var k;
  (function(P) {
    P[P.UNKNOWN = 0] = "UNKNOWN", P[P.OPTIONAL = 1] = "OPTIONAL", P[P.REQUIRED = 2] = "REQUIRED", P[P.REPEATED = 3] = "REPEATED";
  })(k || (type_pb.Field_Cardinality = k = {})), s.proto3.util.setEnumType(k, "google.protobuf.Field.Cardinality", [
    { no: 0, name: "CARDINALITY_UNKNOWN" },
    { no: 1, name: "CARDINALITY_OPTIONAL" },
    { no: 2, name: "CARDINALITY_REQUIRED" },
    { no: 3, name: "CARDINALITY_REPEATED" }
  ]);
  class C extends A.Message {
    constructor(x) {
      super(), this.name = "", this.enumvalue = [], this.options = [], this.syntax = t.PROTO2, this.edition = "", s.proto3.util.initPartial(x, this);
    }
    static fromBinary(x, M) {
      return new C().fromBinary(x, M);
    }
    static fromJson(x, M) {
      return new C().fromJson(x, M);
    }
    static fromJsonString(x, M) {
      return new C().fromJsonString(x, M);
    }
    static equals(x, M) {
      return s.proto3.util.equals(C, x, M);
    }
  }
  type_pb.Enum = C, C.runtime = s.proto3, C.typeName = "google.protobuf.Enum", C.fields = s.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "enumvalue", kind: "message", T: B, repeated: !0 },
    { no: 3, name: "options", kind: "message", T: Q, repeated: !0 },
    { no: 4, name: "source_context", kind: "message", T: u.SourceContext },
    { no: 5, name: "syntax", kind: "enum", T: s.proto3.getEnumType(t) },
    {
      no: 6,
      name: "edition",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]);
  class B extends A.Message {
    constructor(x) {
      super(), this.name = "", this.number = 0, this.options = [], s.proto3.util.initPartial(x, this);
    }
    static fromBinary(x, M) {
      return new B().fromBinary(x, M);
    }
    static fromJson(x, M) {
      return new B().fromJson(x, M);
    }
    static fromJsonString(x, M) {
      return new B().fromJsonString(x, M);
    }
    static equals(x, M) {
      return s.proto3.util.equals(B, x, M);
    }
  }
  type_pb.EnumValue = B, B.runtime = s.proto3, B.typeName = "google.protobuf.EnumValue", B.fields = s.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "number",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    { no: 3, name: "options", kind: "message", T: Q, repeated: !0 }
  ]);
  class Q extends A.Message {
    constructor(x) {
      super(), this.name = "", s.proto3.util.initPartial(x, this);
    }
    static fromBinary(x, M) {
      return new Q().fromBinary(x, M);
    }
    static fromJson(x, M) {
      return new Q().fromJson(x, M);
    }
    static fromJsonString(x, M) {
      return new Q().fromJsonString(x, M);
    }
    static equals(x, M) {
      return s.proto3.util.equals(Q, x, M);
    }
  }
  return type_pb.Option = Q, Q.runtime = s.proto3, Q.typeName = "google.protobuf.Option", Q.fields = s.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "value", kind: "message", T: p.Any }
  ]), type_pb;
}
var hasRequiredApi_pb;
function requireApi_pb() {
  if (hasRequiredApi_pb) return api_pb;
  hasRequiredApi_pb = 1, Object.defineProperty(api_pb, "__esModule", { value: !0 }), api_pb.Mixin = api_pb.Method = api_pb.Api = void 0;
  const s = requireMessage(), A = requireType_pb(), u = requireSource_context_pb(), p = requireProto3();
  class t extends s.Message {
    constructor(k) {
      super(), this.name = "", this.methods = [], this.options = [], this.version = "", this.mixins = [], this.syntax = A.Syntax.PROTO2, p.proto3.util.initPartial(k, this);
    }
    static fromBinary(k, C) {
      return new t().fromBinary(k, C);
    }
    static fromJson(k, C) {
      return new t().fromJson(k, C);
    }
    static fromJsonString(k, C) {
      return new t().fromJsonString(k, C);
    }
    static equals(k, C) {
      return p.proto3.util.equals(t, k, C);
    }
  }
  api_pb.Api = t, t.runtime = p.proto3, t.typeName = "google.protobuf.Api", t.fields = p.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "methods", kind: "message", T: l, repeated: !0 },
    { no: 3, name: "options", kind: "message", T: A.Option, repeated: !0 },
    {
      no: 4,
      name: "version",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 5, name: "source_context", kind: "message", T: u.SourceContext },
    { no: 6, name: "mixins", kind: "message", T: m, repeated: !0 },
    { no: 7, name: "syntax", kind: "enum", T: p.proto3.getEnumType(A.Syntax) }
  ]);
  class l extends s.Message {
    constructor(k) {
      super(), this.name = "", this.requestTypeUrl = "", this.requestStreaming = !1, this.responseTypeUrl = "", this.responseStreaming = !1, this.options = [], this.syntax = A.Syntax.PROTO2, p.proto3.util.initPartial(k, this);
    }
    static fromBinary(k, C) {
      return new l().fromBinary(k, C);
    }
    static fromJson(k, C) {
      return new l().fromJson(k, C);
    }
    static fromJsonString(k, C) {
      return new l().fromJsonString(k, C);
    }
    static equals(k, C) {
      return p.proto3.util.equals(l, k, C);
    }
  }
  api_pb.Method = l, l.runtime = p.proto3, l.typeName = "google.protobuf.Method", l.fields = p.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "request_type_url",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "request_streaming",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 4,
      name: "response_type_url",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 5,
      name: "response_streaming",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    { no: 6, name: "options", kind: "message", T: A.Option, repeated: !0 },
    { no: 7, name: "syntax", kind: "enum", T: p.proto3.getEnumType(A.Syntax) }
  ]);
  class m extends s.Message {
    constructor(k) {
      super(), this.name = "", this.root = "", p.proto3.util.initPartial(k, this);
    }
    static fromBinary(k, C) {
      return new m().fromBinary(k, C);
    }
    static fromJson(k, C) {
      return new m().fromJson(k, C);
    }
    static fromJsonString(k, C) {
      return new m().fromJsonString(k, C);
    }
    static equals(k, C) {
      return p.proto3.util.equals(m, k, C);
    }
  }
  return api_pb.Mixin = m, m.runtime = p.proto3, m.typeName = "google.protobuf.Mixin", m.fields = p.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "root",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]), api_pb;
}
var hasRequiredCjs$3;
function requireCjs$3() {
  return hasRequiredCjs$3 || (hasRequiredCjs$3 = 1, function(s) {
    var A = cjs$3 && cjs$3.__createBinding || (Object.create ? function(be, Pe, Te, Qe) {
      Qe === void 0 && (Qe = Te);
      var xe = Object.getOwnPropertyDescriptor(Pe, Te);
      (!xe || ("get" in xe ? !Pe.__esModule : xe.writable || xe.configurable)) && (xe = { enumerable: !0, get: function() {
        return Pe[Te];
      } }), Object.defineProperty(be, Qe, xe);
    } : function(be, Pe, Te, Qe) {
      Qe === void 0 && (Qe = Te), be[Qe] = Pe[Te];
    }), u = cjs$3 && cjs$3.__exportStar || function(be, Pe) {
      for (var Te in be) Te !== "default" && !Object.prototype.hasOwnProperty.call(Pe, Te) && A(Pe, be, Te);
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), s.toPlainMessage = s.createRegistryFromDescriptors = s.createMutableRegistry = s.createRegistry = s.createDescriptorSet = s.BinaryReader = s.BinaryWriter = s.WireType = s.MethodIdempotency = s.MethodKind = s.clearExtension = s.hasExtension = s.setExtension = s.getExtension = s.ScalarType = s.LongType = s.isMessage = s.Message = s.codegenInfo = s.protoDelimited = s.protoBase64 = s.protoInt64 = s.protoDouble = s.proto2 = s.proto3 = void 0;
    var p = requireProto3();
    Object.defineProperty(s, "proto3", { enumerable: !0, get: function() {
      return p.proto3;
    } });
    var t = requireProto2();
    Object.defineProperty(s, "proto2", { enumerable: !0, get: function() {
      return t.proto2;
    } });
    var l = requireProtoDouble();
    Object.defineProperty(s, "protoDouble", { enumerable: !0, get: function() {
      return l.protoDouble;
    } });
    var m = requireProtoInt64();
    Object.defineProperty(s, "protoInt64", { enumerable: !0, get: function() {
      return m.protoInt64;
    } });
    var b = requireProtoBase64();
    Object.defineProperty(s, "protoBase64", { enumerable: !0, get: function() {
      return b.protoBase64;
    } });
    var k = requireProtoDelimited();
    Object.defineProperty(s, "protoDelimited", { enumerable: !0, get: function() {
      return k.protoDelimited;
    } });
    var C = requireCodegenInfo();
    Object.defineProperty(s, "codegenInfo", { enumerable: !0, get: function() {
      return C.codegenInfo;
    } });
    var B = requireMessage();
    Object.defineProperty(s, "Message", { enumerable: !0, get: function() {
      return B.Message;
    } });
    var Q = requireIsMessage();
    Object.defineProperty(s, "isMessage", { enumerable: !0, get: function() {
      return Q.isMessage;
    } });
    var P = requireScalar();
    Object.defineProperty(s, "LongType", { enumerable: !0, get: function() {
      return P.LongType;
    } }), Object.defineProperty(s, "ScalarType", { enumerable: !0, get: function() {
      return P.ScalarType;
    } });
    var x = requireExtensionAccessor();
    Object.defineProperty(s, "getExtension", { enumerable: !0, get: function() {
      return x.getExtension;
    } }), Object.defineProperty(s, "setExtension", { enumerable: !0, get: function() {
      return x.setExtension;
    } }), Object.defineProperty(s, "hasExtension", { enumerable: !0, get: function() {
      return x.hasExtension;
    } }), Object.defineProperty(s, "clearExtension", { enumerable: !0, get: function() {
      return x.clearExtension;
    } });
    var M = requireServiceType();
    Object.defineProperty(s, "MethodKind", { enumerable: !0, get: function() {
      return M.MethodKind;
    } }), Object.defineProperty(s, "MethodIdempotency", { enumerable: !0, get: function() {
      return M.MethodIdempotency;
    } });
    var F = requireBinaryEncoding();
    Object.defineProperty(s, "WireType", { enumerable: !0, get: function() {
      return F.WireType;
    } }), Object.defineProperty(s, "BinaryWriter", { enumerable: !0, get: function() {
      return F.BinaryWriter;
    } }), Object.defineProperty(s, "BinaryReader", { enumerable: !0, get: function() {
      return F.BinaryReader;
    } });
    var le = requireCreateDescriptorSet();
    Object.defineProperty(s, "createDescriptorSet", { enumerable: !0, get: function() {
      return le.createDescriptorSet;
    } });
    var ge = requireCreateRegistry();
    Object.defineProperty(s, "createRegistry", { enumerable: !0, get: function() {
      return ge.createRegistry;
    } }), Object.defineProperty(s, "createMutableRegistry", { enumerable: !0, get: function() {
      return ge.createMutableRegistry;
    } });
    var pe = requireCreateRegistryFromDesc();
    Object.defineProperty(s, "createRegistryFromDescriptors", { enumerable: !0, get: function() {
      return pe.createRegistryFromDescriptors;
    } });
    var Ie = requireToPlainMessage();
    Object.defineProperty(s, "toPlainMessage", { enumerable: !0, get: function() {
      return Ie.toPlainMessage;
    } }), u(requirePlugin_pb(), s), u(requireApi_pb(), s), u(requireAny_pb(), s), u(requireDescriptor_pb(), s), u(requireDuration_pb(), s), u(requireEmpty_pb(), s), u(requireField_mask_pb(), s), u(requireSource_context_pb(), s), u(requireStruct_pb(), s), u(requireTimestamp_pb(), s), u(requireType_pb(), s), u(requireWrappers_pb(), s);
  }(cjs$3)), cjs$3;
}
var hasRequiredContract_pb;
function requireContract_pb() {
  if (hasRequiredContract_pb) return contract_pb;
  hasRequiredContract_pb = 1, Object.defineProperty(contract_pb, "__esModule", { value: !0 }), contract_pb.TriggerSmartContract = contract_pb.TransferAssetContract = contract_pb.TransferContract = void 0;
  const s = /* @__PURE__ */ requireCjs$3();
  class A extends s.Message {
    constructor(l) {
      super(), this.ownerAddress = new Uint8Array(0), this.toAddress = new Uint8Array(0), this.amount = s.protoInt64.zero, s.proto3.util.initPartial(l, this);
    }
    static fromBinary(l, m) {
      return new A().fromBinary(l, m);
    }
    static fromJson(l, m) {
      return new A().fromJson(l, m);
    }
    static fromJsonString(l, m) {
      return new A().fromJsonString(l, m);
    }
    static equals(l, m) {
      return s.proto3.util.equals(A, l, m);
    }
  }
  A.runtime = s.proto3, A.typeName = "protocol.TransferContract", A.fields = s.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "owner_address",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 2,
      name: "to_address",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 3,
      name: "amount",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    }
  ]), contract_pb.TransferContract = A;
  class u extends s.Message {
    constructor(l) {
      super(), this.assetName = new Uint8Array(0), this.ownerAddress = new Uint8Array(0), this.toAddress = new Uint8Array(0), this.amount = s.protoInt64.zero, s.proto3.util.initPartial(l, this);
    }
    static fromBinary(l, m) {
      return new u().fromBinary(l, m);
    }
    static fromJson(l, m) {
      return new u().fromJson(l, m);
    }
    static fromJsonString(l, m) {
      return new u().fromJsonString(l, m);
    }
    static equals(l, m) {
      return s.proto3.util.equals(u, l, m);
    }
  }
  u.runtime = s.proto3, u.typeName = "protocol.TransferAssetContract", u.fields = s.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "asset_name",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 2,
      name: "owner_address",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 3,
      name: "to_address",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 4,
      name: "amount",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    }
  ]), contract_pb.TransferAssetContract = u;
  class p extends s.Message {
    constructor(l) {
      super(), this.ownerAddress = new Uint8Array(0), this.contractAddress = new Uint8Array(0), this.callValue = s.protoInt64.zero, this.data = new Uint8Array(0), this.callTokenValue = s.protoInt64.zero, this.tokenId = s.protoInt64.zero, s.proto3.util.initPartial(l, this);
    }
    static fromBinary(l, m) {
      return new p().fromBinary(l, m);
    }
    static fromJson(l, m) {
      return new p().fromJson(l, m);
    }
    static fromJsonString(l, m) {
      return new p().fromJsonString(l, m);
    }
    static equals(l, m) {
      return s.proto3.util.equals(p, l, m);
    }
  }
  return p.runtime = s.proto3, p.typeName = "protocol.TriggerSmartContract", p.fields = s.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "owner_address",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 2,
      name: "contract_address",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 3,
      name: "call_value",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 4,
      name: "data",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 5,
      name: "call_token_value",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 6,
      name: "token_id",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    }
  ]), contract_pb.TriggerSmartContract = p, contract_pb;
}
var tron_pb = {}, hasRequiredTron_pb;
function requireTron_pb() {
  return hasRequiredTron_pb || (hasRequiredTron_pb = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.Transaction_raw = s.Transaction_Contract_ContractType = s.Transaction_Contract = s.Transaction = s.authority = s.AccountId = void 0;
    const A = /* @__PURE__ */ requireCjs$3();
    class u extends A.Message {
      constructor(C) {
        super(), this.name = new Uint8Array(0), this.address = new Uint8Array(0), A.proto3.util.initPartial(C, this);
      }
      static fromBinary(C, B) {
        return new u().fromBinary(C, B);
      }
      static fromJson(C, B) {
        return new u().fromJson(C, B);
      }
      static fromJsonString(C, B) {
        return new u().fromJsonString(C, B);
      }
      static equals(C, B) {
        return A.proto3.util.equals(u, C, B);
      }
    }
    u.runtime = A.proto3, u.typeName = "protocol.AccountId", u.fields = A.proto3.util.newFieldList(() => [
      {
        no: 1,
        name: "name",
        kind: "scalar",
        T: 12
        /* ScalarType.BYTES */
      },
      {
        no: 2,
        name: "address",
        kind: "scalar",
        T: 12
        /* ScalarType.BYTES */
      }
    ]), s.AccountId = u;
    class p extends A.Message {
      constructor(C) {
        super(), this.permissionName = new Uint8Array(0), A.proto3.util.initPartial(C, this);
      }
      static fromBinary(C, B) {
        return new p().fromBinary(C, B);
      }
      static fromJson(C, B) {
        return new p().fromJson(C, B);
      }
      static fromJsonString(C, B) {
        return new p().fromJsonString(C, B);
      }
      static equals(C, B) {
        return A.proto3.util.equals(p, C, B);
      }
    }
    p.runtime = A.proto3, p.typeName = "protocol.authority", p.fields = A.proto3.util.newFieldList(() => [
      { no: 1, name: "account", kind: "message", T: u },
      {
        no: 2,
        name: "permission_name",
        kind: "scalar",
        T: 12
        /* ScalarType.BYTES */
      }
    ]), s.authority = p;
    class t extends A.Message {
      constructor(C) {
        super(), this.signature = [], A.proto3.util.initPartial(C, this);
      }
      static fromBinary(C, B) {
        return new t().fromBinary(C, B);
      }
      static fromJson(C, B) {
        return new t().fromJson(C, B);
      }
      static fromJsonString(C, B) {
        return new t().fromJsonString(C, B);
      }
      static equals(C, B) {
        return A.proto3.util.equals(t, C, B);
      }
    }
    t.runtime = A.proto3, t.typeName = "protocol.Transaction", t.fields = A.proto3.util.newFieldList(() => [
      { no: 1, name: "raw_data", kind: "message", T: b },
      { no: 2, name: "signature", kind: "scalar", T: 12, repeated: !0 }
    ]), s.Transaction = t;
    class l extends A.Message {
      constructor(C) {
        super(), this.type = m.AccountCreateContract, this.provider = new Uint8Array(0), this.ContractName = new Uint8Array(0), this.PermissionId = 0, A.proto3.util.initPartial(C, this);
      }
      static fromBinary(C, B) {
        return new l().fromBinary(C, B);
      }
      static fromJson(C, B) {
        return new l().fromJson(C, B);
      }
      static fromJsonString(C, B) {
        return new l().fromJsonString(C, B);
      }
      static equals(C, B) {
        return A.proto3.util.equals(l, C, B);
      }
    }
    l.runtime = A.proto3, l.typeName = "protocol.Transaction.Contract", l.fields = A.proto3.util.newFieldList(() => [
      { no: 1, name: "type", kind: "enum", T: A.proto3.getEnumType(m) },
      { no: 2, name: "parameter", kind: "message", T: A.Any },
      {
        no: 3,
        name: "provider",
        kind: "scalar",
        T: 12
        /* ScalarType.BYTES */
      },
      {
        no: 4,
        name: "ContractName",
        kind: "scalar",
        T: 12
        /* ScalarType.BYTES */
      },
      {
        no: 5,
        name: "Permission_id",
        kind: "scalar",
        T: 5
        /* ScalarType.INT32 */
      }
    ]), s.Transaction_Contract = l;
    var m;
    (function(k) {
      k[k.AccountCreateContract = 0] = "AccountCreateContract", k[k.TransferContract = 1] = "TransferContract", k[k.TransferAssetContract = 2] = "TransferAssetContract", k[k.TriggerSmartContract = 31] = "TriggerSmartContract";
    })(m = s.Transaction_Contract_ContractType || (s.Transaction_Contract_ContractType = {})), A.proto3.util.setEnumType(m, "protocol.Transaction.Contract.ContractType", [
      { no: 0, name: "AccountCreateContract" },
      { no: 1, name: "TransferContract" },
      { no: 2, name: "TransferAssetContract" },
      { no: 31, name: "TriggerSmartContract" }
    ]);
    class b extends A.Message {
      constructor(C) {
        super(), this.refBlockBytes = new Uint8Array(0), this.refBlockNum = A.protoInt64.zero, this.refBlockHash = new Uint8Array(0), this.expiration = A.protoInt64.zero, this.auths = [], this.data = new Uint8Array(0), this.contract = [], this.scripts = new Uint8Array(0), this.timestamp = A.protoInt64.zero, this.feeLimit = A.protoInt64.zero, A.proto3.util.initPartial(C, this);
      }
      static fromBinary(C, B) {
        return new b().fromBinary(C, B);
      }
      static fromJson(C, B) {
        return new b().fromJson(C, B);
      }
      static fromJsonString(C, B) {
        return new b().fromJsonString(C, B);
      }
      static equals(C, B) {
        return A.proto3.util.equals(b, C, B);
      }
    }
    b.runtime = A.proto3, b.typeName = "protocol.Transaction.raw", b.fields = A.proto3.util.newFieldList(() => [
      {
        no: 1,
        name: "ref_block_bytes",
        kind: "scalar",
        T: 12
        /* ScalarType.BYTES */
      },
      {
        no: 3,
        name: "ref_block_num",
        kind: "scalar",
        T: 3
        /* ScalarType.INT64 */
      },
      {
        no: 4,
        name: "ref_block_hash",
        kind: "scalar",
        T: 12
        /* ScalarType.BYTES */
      },
      {
        no: 8,
        name: "expiration",
        kind: "scalar",
        T: 3
        /* ScalarType.INT64 */
      },
      { no: 9, name: "auths", kind: "message", T: p, repeated: !0 },
      {
        no: 10,
        name: "data",
        kind: "scalar",
        T: 12
        /* ScalarType.BYTES */
      },
      { no: 11, name: "contract", kind: "message", T: l, repeated: !0 },
      {
        no: 12,
        name: "scripts",
        kind: "scalar",
        T: 12
        /* ScalarType.BYTES */
      },
      {
        no: 14,
        name: "timestamp",
        kind: "scalar",
        T: 3
        /* ScalarType.INT64 */
      },
      {
        no: 18,
        name: "fee_limit",
        kind: "scalar",
        T: 3
        /* ScalarType.INT64 */
      }
    ]), s.Transaction_raw = b;
  }(tron_pb)), tron_pb;
}
var tron_transaction_pb = {}, hasRequiredTron_transaction_pb;
function requireTron_transaction_pb() {
  if (hasRequiredTron_transaction_pb) return tron_transaction_pb;
  hasRequiredTron_transaction_pb = 1, Object.defineProperty(tron_transaction_pb, "__esModule", { value: !0 }), tron_transaction_pb.TronTx = tron_transaction_pb.Override = tron_transaction_pb.LatestBlock = void 0;
  const s = /* @__PURE__ */ requireCjs$3();
  class A extends s.Message {
    constructor(l) {
      super(), this.hash = "", this.number = 0, this.timestamp = s.protoInt64.zero, s.proto3.util.initPartial(l, this);
    }
    static fromBinary(l, m) {
      return new A().fromBinary(l, m);
    }
    static fromJson(l, m) {
      return new A().fromJson(l, m);
    }
    static fromJsonString(l, m) {
      return new A().fromJsonString(l, m);
    }
    static equals(l, m) {
      return s.proto3.util.equals(A, l, m);
    }
  }
  A.runtime = s.proto3, A.typeName = "protoc.LatestBlock", A.fields = s.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "hash",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "number",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 3,
      name: "timestamp",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    }
  ]), tron_transaction_pb.LatestBlock = A;
  class u extends s.Message {
    constructor(l) {
      super(), this.tokenShortName = "", this.tokenFullName = "", this.decimals = 0, s.proto3.util.initPartial(l, this);
    }
    static fromBinary(l, m) {
      return new u().fromBinary(l, m);
    }
    static fromJson(l, m) {
      return new u().fromJson(l, m);
    }
    static fromJsonString(l, m) {
      return new u().fromJsonString(l, m);
    }
    static equals(l, m) {
      return s.proto3.util.equals(u, l, m);
    }
  }
  u.runtime = s.proto3, u.typeName = "protoc.Override", u.fields = s.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "tokenShortName",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "tokenFullName",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "decimals",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    }
  ]), tron_transaction_pb.Override = u;
  class p extends s.Message {
    constructor(l) {
      super(), this.token = "", this.contractAddress = "", this.from = "", this.to = "", this.memo = "", this.value = "", this.fee = 0, s.proto3.util.initPartial(l, this);
    }
    static fromBinary(l, m) {
      return new p().fromBinary(l, m);
    }
    static fromJson(l, m) {
      return new p().fromJson(l, m);
    }
    static fromJsonString(l, m) {
      return new p().fromJsonString(l, m);
    }
    static equals(l, m) {
      return s.proto3.util.equals(p, l, m);
    }
  }
  return p.runtime = s.proto3, p.typeName = "protoc.TronTx", p.fields = s.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "token",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "contractAddress",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "from",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "to",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 5,
      name: "memo",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 6,
      name: "value",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 7, name: "latestBlock", kind: "message", T: A },
    { no: 8, name: "override", kind: "message", T: u },
    {
      no: 9,
      name: "fee",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    }
  ]), tron_transaction_pb.TronTx = p, tron_transaction_pb;
}
var hasRequiredTransfer;
function requireTransfer() {
  if (hasRequiredTransfer) return transfer;
  hasRequiredTransfer = 1;
  var s = transfer && transfer.__importDefault || function(k) {
    return k && k.__esModule ? k : { default: k };
  };
  Object.defineProperty(transfer, "__esModule", { value: !0 }), transfer.raw2tx = void 0;
  const A = s(requireBs58check$1()), u = requireContract_pb(), p = requireTron_pb(), t = requireUtils$d(), l = requireTron_transaction_pb();
  function m(k) {
    return A.default.encode(k);
  }
  function b(k, C) {
    let B;
    try {
      B = p.Transaction_raw.fromBinary(k);
    } catch {
      throw new Error("Sign data is invalid");
    }
    const Q = C !== void 0 ? {
      decimals: C.decimals,
      tokenFullName: C.name,
      tokenShortName: C.symbol
    } : null, P = Buffer.from([...new Uint8Array(8).fill(0), ...B.refBlockHash, ...new Uint8Array(16).fill(0)]), x = new l.LatestBlock({
      hash: (0, t.toHex)(P),
      number: +`0x${(0, t.toHex)(B.refBlockBytes.slice(0, 2))}`,
      timestamp: BigInt(Number(B.expiration) - 600 * 5 * 1e3)
    }), M = B.contract[0];
    if (M.parameter === void 0)
      throw new Error("contract is invalid");
    let F;
    switch (M.type) {
      case p.Transaction_Contract_ContractType.TransferContract:
        try {
          F = u.TransferContract.fromBinary(M.parameter.value);
        } catch {
          throw new Error("sign data is invalid");
        }
        return new l.TronTx({
          fee: Number(B.feeLimit),
          from: m(F.ownerAddress),
          latestBlock: x,
          to: m(F.toAddress),
          token: "TRX",
          value: F.amount.toString()
        });
      case p.Transaction_Contract_ContractType.TransferAssetContract:
        try {
          F = u.TransferAssetContract.fromBinary(M.parameter.value);
        } catch {
          throw new Error("sign data is invalid");
        }
        if (Q == null)
          throw new Error("token info is invalid");
        return new l.TronTx({
          fee: Number(B.feeLimit),
          from: m(F.ownerAddress),
          latestBlock: x,
          override: Q,
          to: m(F.toAddress),
          token: Buffer.from(F.assetName).toString(),
          value: F.amount.toString()
        });
      case p.Transaction_Contract_ContractType.TriggerSmartContract:
        try {
          F = u.TriggerSmartContract.fromBinary(M.parameter.value);
        } catch {
          throw new Error("sign data is invalid");
        }
        if (Q == null)
          throw new Error("token info is invalid");
        return new l.TronTx({
          contractAddress: m(F.contractAddress),
          fee: Number(B.feeLimit),
          from: m(F.ownerAddress),
          latestBlock: x,
          override: Q,
          to: m(Buffer.from([65, ...F.data.slice(16, 36)])),
          value: BigInt(`0x${Buffer.from(F.data.slice(36, 68)).toString("hex")}`).toString()
        });
      default:
        throw new Error("contract is not supported");
    }
  }
  return transfer.raw2tx = b, transfer;
}
var pako = {}, deflate$1 = {}, deflate = {}, trees = {}, hasRequiredTrees;
function requireTrees() {
  if (hasRequiredTrees) return trees;
  hasRequiredTrees = 1;
  const s = 4, A = 0, u = 1, p = 2;
  function t(kr) {
    let Rr = kr.length;
    for (; --Rr >= 0; )
      kr[Rr] = 0;
  }
  const l = 0, m = 1, b = 2, k = 3, C = 258, B = 29, Q = 256, P = Q + 1 + B, x = 30, M = 19, F = 2 * P + 1, le = 15, ge = 16, pe = 7, Ie = 256, be = 16, Pe = 17, Te = 18, Qe = (
    /* extra bits for each length code */
    new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0])
  ), xe = (
    /* extra bits for each distance code */
    new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13])
  ), Ee = (
    /* extra bits for each bit length code */
    new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7])
  ), He = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), ve = 512, we = new Array((P + 2) * 2);
  t(we);
  const Ce = new Array(x * 2);
  t(Ce);
  const Se = new Array(ve);
  t(Se);
  const Ne = new Array(C - k + 1);
  t(Ne);
  const rr = new Array(B);
  t(rr);
  const er = new Array(x);
  t(er);
  function ir(kr, Rr, Er, Or, wn) {
    this.static_tree = kr, this.extra_bits = Rr, this.extra_base = Er, this.elems = Or, this.max_length = wn, this.has_stree = kr && kr.length;
  }
  let sr, nr, fr;
  function lr(kr, Rr) {
    this.dyn_tree = kr, this.max_code = 0, this.stat_desc = Rr;
  }
  const br = (kr) => kr < 256 ? Se[kr] : Se[256 + (kr >>> 7)], Br = (kr, Rr) => {
    kr.pending_buf[kr.pending++] = Rr & 255, kr.pending_buf[kr.pending++] = Rr >>> 8 & 255;
  }, Fr = (kr, Rr, Er) => {
    kr.bi_valid > ge - Er ? (kr.bi_buf |= Rr << kr.bi_valid & 65535, Br(kr, kr.bi_buf), kr.bi_buf = Rr >> ge - kr.bi_valid, kr.bi_valid += Er - ge) : (kr.bi_buf |= Rr << kr.bi_valid & 65535, kr.bi_valid += Er);
  }, Gr = (kr, Rr, Er) => {
    Fr(
      kr,
      Er[Rr * 2],
      Er[Rr * 2 + 1]
      /*.Len*/
    );
  }, qr = (kr, Rr) => {
    let Er = 0;
    do
      Er |= kr & 1, kr >>>= 1, Er <<= 1;
    while (--Rr > 0);
    return Er >>> 1;
  }, Hr = (kr) => {
    kr.bi_valid === 16 ? (Br(kr, kr.bi_buf), kr.bi_buf = 0, kr.bi_valid = 0) : kr.bi_valid >= 8 && (kr.pending_buf[kr.pending++] = kr.bi_buf & 255, kr.bi_buf >>= 8, kr.bi_valid -= 8);
  }, un = (kr, Rr) => {
    const Er = Rr.dyn_tree, Or = Rr.max_code, wn = Rr.stat_desc.static_tree, Kn = Rr.stat_desc.has_stree, Ln = Rr.stat_desc.extra_bits, Wn = Rr.stat_desc.extra_base, Sn = Rr.stat_desc.max_length;
    let hi, ki, xi, _i, Li, ms, Ui = 0;
    for (_i = 0; _i <= le; _i++)
      kr.bl_count[_i] = 0;
    for (Er[kr.heap[kr.heap_max] * 2 + 1] = 0, hi = kr.heap_max + 1; hi < F; hi++)
      ki = kr.heap[hi], _i = Er[Er[ki * 2 + 1] * 2 + 1] + 1, _i > Sn && (_i = Sn, Ui++), Er[ki * 2 + 1] = _i, !(ki > Or) && (kr.bl_count[_i]++, Li = 0, ki >= Wn && (Li = Ln[ki - Wn]), ms = Er[ki * 2], kr.opt_len += ms * (_i + Li), Kn && (kr.static_len += ms * (wn[ki * 2 + 1] + Li)));
    if (Ui !== 0) {
      do {
        for (_i = Sn - 1; kr.bl_count[_i] === 0; )
          _i--;
        kr.bl_count[_i]--, kr.bl_count[_i + 1] += 2, kr.bl_count[Sn]--, Ui -= 2;
      } while (Ui > 0);
      for (_i = Sn; _i !== 0; _i--)
        for (ki = kr.bl_count[_i]; ki !== 0; )
          xi = kr.heap[--hi], !(xi > Or) && (Er[xi * 2 + 1] !== _i && (kr.opt_len += (_i - Er[xi * 2 + 1]) * Er[xi * 2], Er[xi * 2 + 1] = _i), ki--);
    }
  }, Dr = (kr, Rr, Er) => {
    const Or = new Array(le + 1);
    let wn = 0, Kn, Ln;
    for (Kn = 1; Kn <= le; Kn++)
      wn = wn + Er[Kn - 1] << 1, Or[Kn] = wn;
    for (Ln = 0; Ln <= Rr; Ln++) {
      let Wn = kr[Ln * 2 + 1];
      Wn !== 0 && (kr[Ln * 2] = qr(Or[Wn]++, Wn));
    }
  }, wr = () => {
    let kr, Rr, Er, Or, wn;
    const Kn = new Array(le + 1);
    for (Er = 0, Or = 0; Or < B - 1; Or++)
      for (rr[Or] = Er, kr = 0; kr < 1 << Qe[Or]; kr++)
        Ne[Er++] = Or;
    for (Ne[Er - 1] = Or, wn = 0, Or = 0; Or < 16; Or++)
      for (er[Or] = wn, kr = 0; kr < 1 << xe[Or]; kr++)
        Se[wn++] = Or;
    for (wn >>= 7; Or < x; Or++)
      for (er[Or] = wn << 7, kr = 0; kr < 1 << xe[Or] - 7; kr++)
        Se[256 + wn++] = Or;
    for (Rr = 0; Rr <= le; Rr++)
      Kn[Rr] = 0;
    for (kr = 0; kr <= 143; )
      we[kr * 2 + 1] = 8, kr++, Kn[8]++;
    for (; kr <= 255; )
      we[kr * 2 + 1] = 9, kr++, Kn[9]++;
    for (; kr <= 279; )
      we[kr * 2 + 1] = 7, kr++, Kn[7]++;
    for (; kr <= 287; )
      we[kr * 2 + 1] = 8, kr++, Kn[8]++;
    for (Dr(we, P + 1, Kn), kr = 0; kr < x; kr++)
      Ce[kr * 2 + 1] = 5, Ce[kr * 2] = qr(kr, 5);
    sr = new ir(we, Qe, Q + 1, P, le), nr = new ir(Ce, xe, 0, x, le), fr = new ir(new Array(0), Ee, 0, M, pe);
  }, yr = (kr) => {
    let Rr;
    for (Rr = 0; Rr < P; Rr++)
      kr.dyn_ltree[Rr * 2] = 0;
    for (Rr = 0; Rr < x; Rr++)
      kr.dyn_dtree[Rr * 2] = 0;
    for (Rr = 0; Rr < M; Rr++)
      kr.bl_tree[Rr * 2] = 0;
    kr.dyn_ltree[Ie * 2] = 1, kr.opt_len = kr.static_len = 0, kr.sym_next = kr.matches = 0;
  }, Qr = (kr) => {
    kr.bi_valid > 8 ? Br(kr, kr.bi_buf) : kr.bi_valid > 0 && (kr.pending_buf[kr.pending++] = kr.bi_buf), kr.bi_buf = 0, kr.bi_valid = 0;
  }, _r = (kr, Rr, Er, Or) => {
    const wn = Rr * 2, Kn = Er * 2;
    return kr[wn] < kr[Kn] || kr[wn] === kr[Kn] && Or[Rr] <= Or[Er];
  }, Jr = (kr, Rr, Er) => {
    const Or = kr.heap[Er];
    let wn = Er << 1;
    for (; wn <= kr.heap_len && (wn < kr.heap_len && _r(Rr, kr.heap[wn + 1], kr.heap[wn], kr.depth) && wn++, !_r(Rr, Or, kr.heap[wn], kr.depth)); )
      kr.heap[Er] = kr.heap[wn], Er = wn, wn <<= 1;
    kr.heap[Er] = Or;
  }, fn = (kr, Rr, Er) => {
    let Or, wn, Kn = 0, Ln, Wn;
    if (kr.sym_next !== 0)
      do
        Or = kr.pending_buf[kr.sym_buf + Kn++] & 255, Or += (kr.pending_buf[kr.sym_buf + Kn++] & 255) << 8, wn = kr.pending_buf[kr.sym_buf + Kn++], Or === 0 ? Gr(kr, wn, Rr) : (Ln = Ne[wn], Gr(kr, Ln + Q + 1, Rr), Wn = Qe[Ln], Wn !== 0 && (wn -= rr[Ln], Fr(kr, wn, Wn)), Or--, Ln = br(Or), Gr(kr, Ln, Er), Wn = xe[Ln], Wn !== 0 && (Or -= er[Ln], Fr(kr, Or, Wn)));
      while (Kn < kr.sym_next);
    Gr(kr, Ie, Rr);
  }, jr = (kr, Rr) => {
    const Er = Rr.dyn_tree, Or = Rr.stat_desc.static_tree, wn = Rr.stat_desc.has_stree, Kn = Rr.stat_desc.elems;
    let Ln, Wn, Sn = -1, hi;
    for (kr.heap_len = 0, kr.heap_max = F, Ln = 0; Ln < Kn; Ln++)
      Er[Ln * 2] !== 0 ? (kr.heap[++kr.heap_len] = Sn = Ln, kr.depth[Ln] = 0) : Er[Ln * 2 + 1] = 0;
    for (; kr.heap_len < 2; )
      hi = kr.heap[++kr.heap_len] = Sn < 2 ? ++Sn : 0, Er[hi * 2] = 1, kr.depth[hi] = 0, kr.opt_len--, wn && (kr.static_len -= Or[hi * 2 + 1]);
    for (Rr.max_code = Sn, Ln = kr.heap_len >> 1; Ln >= 1; Ln--)
      Jr(kr, Er, Ln);
    hi = Kn;
    do
      Ln = kr.heap[
        1
        /*SMALLEST*/
      ], kr.heap[
        1
        /*SMALLEST*/
      ] = kr.heap[kr.heap_len--], Jr(
        kr,
        Er,
        1
        /*SMALLEST*/
      ), Wn = kr.heap[
        1
        /*SMALLEST*/
      ], kr.heap[--kr.heap_max] = Ln, kr.heap[--kr.heap_max] = Wn, Er[hi * 2] = Er[Ln * 2] + Er[Wn * 2], kr.depth[hi] = (kr.depth[Ln] >= kr.depth[Wn] ? kr.depth[Ln] : kr.depth[Wn]) + 1, Er[Ln * 2 + 1] = Er[Wn * 2 + 1] = hi, kr.heap[
        1
        /*SMALLEST*/
      ] = hi++, Jr(
        kr,
        Er,
        1
        /*SMALLEST*/
      );
    while (kr.heap_len >= 2);
    kr.heap[--kr.heap_max] = kr.heap[
      1
      /*SMALLEST*/
    ], un(kr, Rr), Dr(Er, Sn, kr.bl_count);
  }, dn = (kr, Rr, Er) => {
    let Or, wn = -1, Kn, Ln = Rr[1], Wn = 0, Sn = 7, hi = 4;
    for (Ln === 0 && (Sn = 138, hi = 3), Rr[(Er + 1) * 2 + 1] = 65535, Or = 0; Or <= Er; Or++)
      Kn = Ln, Ln = Rr[(Or + 1) * 2 + 1], !(++Wn < Sn && Kn === Ln) && (Wn < hi ? kr.bl_tree[Kn * 2] += Wn : Kn !== 0 ? (Kn !== wn && kr.bl_tree[Kn * 2]++, kr.bl_tree[be * 2]++) : Wn <= 10 ? kr.bl_tree[Pe * 2]++ : kr.bl_tree[Te * 2]++, Wn = 0, wn = Kn, Ln === 0 ? (Sn = 138, hi = 3) : Kn === Ln ? (Sn = 6, hi = 3) : (Sn = 7, hi = 4));
  }, Tn = (kr, Rr, Er) => {
    let Or, wn = -1, Kn, Ln = Rr[1], Wn = 0, Sn = 7, hi = 4;
    for (Ln === 0 && (Sn = 138, hi = 3), Or = 0; Or <= Er; Or++)
      if (Kn = Ln, Ln = Rr[(Or + 1) * 2 + 1], !(++Wn < Sn && Kn === Ln)) {
        if (Wn < hi)
          do
            Gr(kr, Kn, kr.bl_tree);
          while (--Wn !== 0);
        else Kn !== 0 ? (Kn !== wn && (Gr(kr, Kn, kr.bl_tree), Wn--), Gr(kr, be, kr.bl_tree), Fr(kr, Wn - 3, 2)) : Wn <= 10 ? (Gr(kr, Pe, kr.bl_tree), Fr(kr, Wn - 3, 3)) : (Gr(kr, Te, kr.bl_tree), Fr(kr, Wn - 11, 7));
        Wn = 0, wn = Kn, Ln === 0 ? (Sn = 138, hi = 3) : Kn === Ln ? (Sn = 6, hi = 3) : (Sn = 7, hi = 4);
      }
  }, Yn = (kr) => {
    let Rr;
    for (dn(kr, kr.dyn_ltree, kr.l_desc.max_code), dn(kr, kr.dyn_dtree, kr.d_desc.max_code), jr(kr, kr.bl_desc), Rr = M - 1; Rr >= 3 && kr.bl_tree[He[Rr] * 2 + 1] === 0; Rr--)
      ;
    return kr.opt_len += 3 * (Rr + 1) + 5 + 5 + 4, Rr;
  }, si = (kr, Rr, Er, Or) => {
    let wn;
    for (Fr(kr, Rr - 257, 5), Fr(kr, Er - 1, 5), Fr(kr, Or - 4, 4), wn = 0; wn < Or; wn++)
      Fr(kr, kr.bl_tree[He[wn] * 2 + 1], 3);
    Tn(kr, kr.dyn_ltree, Rr - 1), Tn(kr, kr.dyn_dtree, Er - 1);
  }, vn = (kr) => {
    let Rr = 4093624447, Er;
    for (Er = 0; Er <= 31; Er++, Rr >>>= 1)
      if (Rr & 1 && kr.dyn_ltree[Er * 2] !== 0)
        return A;
    if (kr.dyn_ltree[18] !== 0 || kr.dyn_ltree[20] !== 0 || kr.dyn_ltree[26] !== 0)
      return u;
    for (Er = 32; Er < Q; Er++)
      if (kr.dyn_ltree[Er * 2] !== 0)
        return u;
    return A;
  };
  let Cn = !1;
  const Xr = (kr) => {
    Cn || (wr(), Cn = !0), kr.l_desc = new lr(kr.dyn_ltree, sr), kr.d_desc = new lr(kr.dyn_dtree, nr), kr.bl_desc = new lr(kr.bl_tree, fr), kr.bi_buf = 0, kr.bi_valid = 0, yr(kr);
  }, In = (kr, Rr, Er, Or) => {
    Fr(kr, (l << 1) + (Or ? 1 : 0), 3), Qr(kr), Br(kr, Er), Br(kr, ~Er), Er && kr.pending_buf.set(kr.window.subarray(Rr, Rr + Er), kr.pending), kr.pending += Er;
  }, zr = (kr) => {
    Fr(kr, m << 1, 3), Gr(kr, Ie, we), Hr(kr);
  }, En = (kr, Rr, Er, Or) => {
    let wn, Kn, Ln = 0;
    kr.level > 0 ? (kr.strm.data_type === p && (kr.strm.data_type = vn(kr)), jr(kr, kr.l_desc), jr(kr, kr.d_desc), Ln = Yn(kr), wn = kr.opt_len + 3 + 7 >>> 3, Kn = kr.static_len + 3 + 7 >>> 3, Kn <= wn && (wn = Kn)) : wn = Kn = Er + 5, Er + 4 <= wn && Rr !== -1 ? In(kr, Rr, Er, Or) : kr.strategy === s || Kn === wn ? (Fr(kr, (m << 1) + (Or ? 1 : 0), 3), fn(kr, we, Ce)) : (Fr(kr, (b << 1) + (Or ? 1 : 0), 3), si(kr, kr.l_desc.max_code + 1, kr.d_desc.max_code + 1, Ln + 1), fn(kr, kr.dyn_ltree, kr.dyn_dtree)), yr(kr), Or && Qr(kr);
  }, Zr = (kr, Rr, Er) => (kr.pending_buf[kr.sym_buf + kr.sym_next++] = Rr, kr.pending_buf[kr.sym_buf + kr.sym_next++] = Rr >> 8, kr.pending_buf[kr.sym_buf + kr.sym_next++] = Er, Rr === 0 ? kr.dyn_ltree[Er * 2]++ : (kr.matches++, Rr--, kr.dyn_ltree[(Ne[Er] + Q + 1) * 2]++, kr.dyn_dtree[br(Rr) * 2]++), kr.sym_next === kr.sym_end);
  return trees._tr_init = Xr, trees._tr_stored_block = In, trees._tr_flush_block = En, trees._tr_tally = Zr, trees._tr_align = zr, trees;
}
var adler32_1, hasRequiredAdler32;
function requireAdler32() {
  return hasRequiredAdler32 || (hasRequiredAdler32 = 1, adler32_1 = (A, u, p, t) => {
    let l = A & 65535 | 0, m = A >>> 16 & 65535 | 0, b = 0;
    for (; p !== 0; ) {
      b = p > 2e3 ? 2e3 : p, p -= b;
      do
        l = l + u[t++] | 0, m = m + l | 0;
      while (--b);
      l %= 65521, m %= 65521;
    }
    return l | m << 16 | 0;
  }), adler32_1;
}
var crc32_1, hasRequiredCrc32;
function requireCrc32() {
  if (hasRequiredCrc32) return crc32_1;
  hasRequiredCrc32 = 1;
  const s = () => {
    let p, t = [];
    for (var l = 0; l < 256; l++) {
      p = l;
      for (var m = 0; m < 8; m++)
        p = p & 1 ? 3988292384 ^ p >>> 1 : p >>> 1;
      t[l] = p;
    }
    return t;
  }, A = new Uint32Array(s());
  return crc32_1 = (p, t, l, m) => {
    const b = A, k = m + l;
    p ^= -1;
    for (let C = m; C < k; C++)
      p = p >>> 8 ^ b[(p ^ t[C]) & 255];
    return p ^ -1;
  }, crc32_1;
}
var messages, hasRequiredMessages;
function requireMessages() {
  return hasRequiredMessages || (hasRequiredMessages = 1, messages = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */
    1: "stream end",
    /* Z_STREAM_END      1  */
    0: "",
    /* Z_OK              0  */
    "-1": "file error",
    /* Z_ERRNO         (-1) */
    "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */
    "-3": "data error",
    /* Z_DATA_ERROR    (-3) */
    "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */
    "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */
    "-6": "incompatible version"
    /* Z_VERSION_ERROR (-6) */
  }), messages;
}
var constants$3, hasRequiredConstants$3;
function requireConstants$3() {
  return hasRequiredConstants$3 || (hasRequiredConstants$3 = 1, constants$3 = {
    /* Allowed flush values; see deflate() and inflate() below for details */
    Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
    * are errors, positive values are used for special but normal events.
    */
    Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */
    Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */
    Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */
    Z_DEFLATED: 8
    //Z_NULL:                 null // Use -1 or null inline, depending on var type
  }), constants$3;
}
var hasRequiredDeflate$1;
function requireDeflate$1() {
  if (hasRequiredDeflate$1) return deflate;
  hasRequiredDeflate$1 = 1;
  const { _tr_init: s, _tr_stored_block: A, _tr_flush_block: u, _tr_tally: p, _tr_align: t } = requireTrees(), l = requireAdler32(), m = requireCrc32(), b = requireMessages(), {
    Z_NO_FLUSH: k,
    Z_PARTIAL_FLUSH: C,
    Z_FULL_FLUSH: B,
    Z_FINISH: Q,
    Z_BLOCK: P,
    Z_OK: x,
    Z_STREAM_END: M,
    Z_STREAM_ERROR: F,
    Z_DATA_ERROR: le,
    Z_BUF_ERROR: ge,
    Z_DEFAULT_COMPRESSION: pe,
    Z_FILTERED: Ie,
    Z_HUFFMAN_ONLY: be,
    Z_RLE: Pe,
    Z_FIXED: Te,
    Z_DEFAULT_STRATEGY: Qe,
    Z_UNKNOWN: xe,
    Z_DEFLATED: Ee
  } = requireConstants$3(), He = 9, ve = 15, we = 8, Ne = 256 + 1 + 29, rr = 30, er = 19, ir = 2 * Ne + 1, sr = 15, nr = 3, fr = 258, lr = fr + nr + 1, br = 32, Br = 42, Fr = 57, Gr = 69, qr = 73, Hr = 91, un = 103, Dr = 113, wr = 666, yr = 1, Qr = 2, _r = 3, Jr = 4, fn = 3, jr = (Pr, vr) => (Pr.msg = b[vr], vr), dn = (Pr) => Pr * 2 - (Pr > 4 ? 9 : 0), Tn = (Pr) => {
    let vr = Pr.length;
    for (; --vr >= 0; )
      Pr[vr] = 0;
  }, Yn = (Pr) => {
    let vr, Cr, yn, Pn = Pr.w_size;
    vr = Pr.hash_size, yn = vr;
    do
      Cr = Pr.head[--yn], Pr.head[yn] = Cr >= Pn ? Cr - Pn : 0;
    while (--vr);
    vr = Pn, yn = vr;
    do
      Cr = Pr.prev[--yn], Pr.prev[yn] = Cr >= Pn ? Cr - Pn : 0;
    while (--vr);
  };
  let vn = (Pr, vr, Cr) => (vr << Pr.hash_shift ^ Cr) & Pr.hash_mask;
  const Cn = (Pr) => {
    const vr = Pr.state;
    let Cr = vr.pending;
    Cr > Pr.avail_out && (Cr = Pr.avail_out), Cr !== 0 && (Pr.output.set(vr.pending_buf.subarray(vr.pending_out, vr.pending_out + Cr), Pr.next_out), Pr.next_out += Cr, vr.pending_out += Cr, Pr.total_out += Cr, Pr.avail_out -= Cr, vr.pending -= Cr, vr.pending === 0 && (vr.pending_out = 0));
  }, Xr = (Pr, vr) => {
    u(Pr, Pr.block_start >= 0 ? Pr.block_start : -1, Pr.strstart - Pr.block_start, vr), Pr.block_start = Pr.strstart, Cn(Pr.strm);
  }, In = (Pr, vr) => {
    Pr.pending_buf[Pr.pending++] = vr;
  }, zr = (Pr, vr) => {
    Pr.pending_buf[Pr.pending++] = vr >>> 8 & 255, Pr.pending_buf[Pr.pending++] = vr & 255;
  }, En = (Pr, vr, Cr, yn) => {
    let Pn = Pr.avail_in;
    return Pn > yn && (Pn = yn), Pn === 0 ? 0 : (Pr.avail_in -= Pn, vr.set(Pr.input.subarray(Pr.next_in, Pr.next_in + Pn), Cr), Pr.state.wrap === 1 ? Pr.adler = l(Pr.adler, vr, Pn, Cr) : Pr.state.wrap === 2 && (Pr.adler = m(Pr.adler, vr, Pn, Cr)), Pr.next_in += Pn, Pr.total_in += Pn, Pn);
  }, Zr = (Pr, vr) => {
    let Cr = Pr.max_chain_length, yn = Pr.strstart, Pn, $n, ui = Pr.prev_length, Ei = Pr.nice_match;
    const zi = Pr.strstart > Pr.w_size - lr ? Pr.strstart - (Pr.w_size - lr) : 0, Gi = Pr.window, Vi = Pr.w_mask, Ur = Pr.prev, $i = Pr.strstart + fr;
    let Es = Gi[yn + ui - 1], pn = Gi[yn + ui];
    Pr.prev_length >= Pr.good_match && (Cr >>= 2), Ei > Pr.lookahead && (Ei = Pr.lookahead);
    do
      if (Pn = vr, !(Gi[Pn + ui] !== pn || Gi[Pn + ui - 1] !== Es || Gi[Pn] !== Gi[yn] || Gi[++Pn] !== Gi[yn + 1])) {
        yn += 2, Pn++;
        do
          ;
        while (Gi[++yn] === Gi[++Pn] && Gi[++yn] === Gi[++Pn] && Gi[++yn] === Gi[++Pn] && Gi[++yn] === Gi[++Pn] && Gi[++yn] === Gi[++Pn] && Gi[++yn] === Gi[++Pn] && Gi[++yn] === Gi[++Pn] && Gi[++yn] === Gi[++Pn] && yn < $i);
        if ($n = fr - ($i - yn), yn = $i - fr, $n > ui) {
          if (Pr.match_start = vr, ui = $n, $n >= Ei)
            break;
          Es = Gi[yn + ui - 1], pn = Gi[yn + ui];
        }
      }
    while ((vr = Ur[vr & Vi]) > zi && --Cr !== 0);
    return ui <= Pr.lookahead ? ui : Pr.lookahead;
  }, kr = (Pr) => {
    const vr = Pr.w_size;
    let Cr, yn, Pn;
    do {
      if (yn = Pr.window_size - Pr.lookahead - Pr.strstart, Pr.strstart >= vr + (vr - lr) && (Pr.window.set(Pr.window.subarray(vr, vr + vr - yn), 0), Pr.match_start -= vr, Pr.strstart -= vr, Pr.block_start -= vr, Pr.insert > Pr.strstart && (Pr.insert = Pr.strstart), Yn(Pr), yn += vr), Pr.strm.avail_in === 0)
        break;
      if (Cr = En(Pr.strm, Pr.window, Pr.strstart + Pr.lookahead, yn), Pr.lookahead += Cr, Pr.lookahead + Pr.insert >= nr)
        for (Pn = Pr.strstart - Pr.insert, Pr.ins_h = Pr.window[Pn], Pr.ins_h = vn(Pr, Pr.ins_h, Pr.window[Pn + 1]); Pr.insert && (Pr.ins_h = vn(Pr, Pr.ins_h, Pr.window[Pn + nr - 1]), Pr.prev[Pn & Pr.w_mask] = Pr.head[Pr.ins_h], Pr.head[Pr.ins_h] = Pn, Pn++, Pr.insert--, !(Pr.lookahead + Pr.insert < nr)); )
          ;
    } while (Pr.lookahead < lr && Pr.strm.avail_in !== 0);
  }, Rr = (Pr, vr) => {
    let Cr = Pr.pending_buf_size - 5 > Pr.w_size ? Pr.w_size : Pr.pending_buf_size - 5, yn, Pn, $n, ui = 0, Ei = Pr.strm.avail_in;
    do {
      if (yn = 65535, $n = Pr.bi_valid + 42 >> 3, Pr.strm.avail_out < $n || ($n = Pr.strm.avail_out - $n, Pn = Pr.strstart - Pr.block_start, yn > Pn + Pr.strm.avail_in && (yn = Pn + Pr.strm.avail_in), yn > $n && (yn = $n), yn < Cr && (yn === 0 && vr !== Q || vr === k || yn !== Pn + Pr.strm.avail_in)))
        break;
      ui = vr === Q && yn === Pn + Pr.strm.avail_in ? 1 : 0, A(Pr, 0, 0, ui), Pr.pending_buf[Pr.pending - 4] = yn, Pr.pending_buf[Pr.pending - 3] = yn >> 8, Pr.pending_buf[Pr.pending - 2] = ~yn, Pr.pending_buf[Pr.pending - 1] = ~yn >> 8, Cn(Pr.strm), Pn && (Pn > yn && (Pn = yn), Pr.strm.output.set(Pr.window.subarray(Pr.block_start, Pr.block_start + Pn), Pr.strm.next_out), Pr.strm.next_out += Pn, Pr.strm.avail_out -= Pn, Pr.strm.total_out += Pn, Pr.block_start += Pn, yn -= Pn), yn && (En(Pr.strm, Pr.strm.output, Pr.strm.next_out, yn), Pr.strm.next_out += yn, Pr.strm.avail_out -= yn, Pr.strm.total_out += yn);
    } while (ui === 0);
    return Ei -= Pr.strm.avail_in, Ei && (Ei >= Pr.w_size ? (Pr.matches = 2, Pr.window.set(Pr.strm.input.subarray(Pr.strm.next_in - Pr.w_size, Pr.strm.next_in), 0), Pr.strstart = Pr.w_size, Pr.insert = Pr.strstart) : (Pr.window_size - Pr.strstart <= Ei && (Pr.strstart -= Pr.w_size, Pr.window.set(Pr.window.subarray(Pr.w_size, Pr.w_size + Pr.strstart), 0), Pr.matches < 2 && Pr.matches++, Pr.insert > Pr.strstart && (Pr.insert = Pr.strstart)), Pr.window.set(Pr.strm.input.subarray(Pr.strm.next_in - Ei, Pr.strm.next_in), Pr.strstart), Pr.strstart += Ei, Pr.insert += Ei > Pr.w_size - Pr.insert ? Pr.w_size - Pr.insert : Ei), Pr.block_start = Pr.strstart), Pr.high_water < Pr.strstart && (Pr.high_water = Pr.strstart), ui ? Jr : vr !== k && vr !== Q && Pr.strm.avail_in === 0 && Pr.strstart === Pr.block_start ? Qr : ($n = Pr.window_size - Pr.strstart, Pr.strm.avail_in > $n && Pr.block_start >= Pr.w_size && (Pr.block_start -= Pr.w_size, Pr.strstart -= Pr.w_size, Pr.window.set(Pr.window.subarray(Pr.w_size, Pr.w_size + Pr.strstart), 0), Pr.matches < 2 && Pr.matches++, $n += Pr.w_size, Pr.insert > Pr.strstart && (Pr.insert = Pr.strstart)), $n > Pr.strm.avail_in && ($n = Pr.strm.avail_in), $n && (En(Pr.strm, Pr.window, Pr.strstart, $n), Pr.strstart += $n, Pr.insert += $n > Pr.w_size - Pr.insert ? Pr.w_size - Pr.insert : $n), Pr.high_water < Pr.strstart && (Pr.high_water = Pr.strstart), $n = Pr.bi_valid + 42 >> 3, $n = Pr.pending_buf_size - $n > 65535 ? 65535 : Pr.pending_buf_size - $n, Cr = $n > Pr.w_size ? Pr.w_size : $n, Pn = Pr.strstart - Pr.block_start, (Pn >= Cr || (Pn || vr === Q) && vr !== k && Pr.strm.avail_in === 0 && Pn <= $n) && (yn = Pn > $n ? $n : Pn, ui = vr === Q && Pr.strm.avail_in === 0 && yn === Pn ? 1 : 0, A(Pr, Pr.block_start, yn, ui), Pr.block_start += yn, Cn(Pr.strm)), ui ? _r : yr);
  }, Er = (Pr, vr) => {
    let Cr, yn;
    for (; ; ) {
      if (Pr.lookahead < lr) {
        if (kr(Pr), Pr.lookahead < lr && vr === k)
          return yr;
        if (Pr.lookahead === 0)
          break;
      }
      if (Cr = 0, Pr.lookahead >= nr && (Pr.ins_h = vn(Pr, Pr.ins_h, Pr.window[Pr.strstart + nr - 1]), Cr = Pr.prev[Pr.strstart & Pr.w_mask] = Pr.head[Pr.ins_h], Pr.head[Pr.ins_h] = Pr.strstart), Cr !== 0 && Pr.strstart - Cr <= Pr.w_size - lr && (Pr.match_length = Zr(Pr, Cr)), Pr.match_length >= nr)
        if (yn = p(Pr, Pr.strstart - Pr.match_start, Pr.match_length - nr), Pr.lookahead -= Pr.match_length, Pr.match_length <= Pr.max_lazy_match && Pr.lookahead >= nr) {
          Pr.match_length--;
          do
            Pr.strstart++, Pr.ins_h = vn(Pr, Pr.ins_h, Pr.window[Pr.strstart + nr - 1]), Cr = Pr.prev[Pr.strstart & Pr.w_mask] = Pr.head[Pr.ins_h], Pr.head[Pr.ins_h] = Pr.strstart;
          while (--Pr.match_length !== 0);
          Pr.strstart++;
        } else
          Pr.strstart += Pr.match_length, Pr.match_length = 0, Pr.ins_h = Pr.window[Pr.strstart], Pr.ins_h = vn(Pr, Pr.ins_h, Pr.window[Pr.strstart + 1]);
      else
        yn = p(Pr, 0, Pr.window[Pr.strstart]), Pr.lookahead--, Pr.strstart++;
      if (yn && (Xr(Pr, !1), Pr.strm.avail_out === 0))
        return yr;
    }
    return Pr.insert = Pr.strstart < nr - 1 ? Pr.strstart : nr - 1, vr === Q ? (Xr(Pr, !0), Pr.strm.avail_out === 0 ? _r : Jr) : Pr.sym_next && (Xr(Pr, !1), Pr.strm.avail_out === 0) ? yr : Qr;
  }, Or = (Pr, vr) => {
    let Cr, yn, Pn;
    for (; ; ) {
      if (Pr.lookahead < lr) {
        if (kr(Pr), Pr.lookahead < lr && vr === k)
          return yr;
        if (Pr.lookahead === 0)
          break;
      }
      if (Cr = 0, Pr.lookahead >= nr && (Pr.ins_h = vn(Pr, Pr.ins_h, Pr.window[Pr.strstart + nr - 1]), Cr = Pr.prev[Pr.strstart & Pr.w_mask] = Pr.head[Pr.ins_h], Pr.head[Pr.ins_h] = Pr.strstart), Pr.prev_length = Pr.match_length, Pr.prev_match = Pr.match_start, Pr.match_length = nr - 1, Cr !== 0 && Pr.prev_length < Pr.max_lazy_match && Pr.strstart - Cr <= Pr.w_size - lr && (Pr.match_length = Zr(Pr, Cr), Pr.match_length <= 5 && (Pr.strategy === Ie || Pr.match_length === nr && Pr.strstart - Pr.match_start > 4096) && (Pr.match_length = nr - 1)), Pr.prev_length >= nr && Pr.match_length <= Pr.prev_length) {
        Pn = Pr.strstart + Pr.lookahead - nr, yn = p(Pr, Pr.strstart - 1 - Pr.prev_match, Pr.prev_length - nr), Pr.lookahead -= Pr.prev_length - 1, Pr.prev_length -= 2;
        do
          ++Pr.strstart <= Pn && (Pr.ins_h = vn(Pr, Pr.ins_h, Pr.window[Pr.strstart + nr - 1]), Cr = Pr.prev[Pr.strstart & Pr.w_mask] = Pr.head[Pr.ins_h], Pr.head[Pr.ins_h] = Pr.strstart);
        while (--Pr.prev_length !== 0);
        if (Pr.match_available = 0, Pr.match_length = nr - 1, Pr.strstart++, yn && (Xr(Pr, !1), Pr.strm.avail_out === 0))
          return yr;
      } else if (Pr.match_available) {
        if (yn = p(Pr, 0, Pr.window[Pr.strstart - 1]), yn && Xr(Pr, !1), Pr.strstart++, Pr.lookahead--, Pr.strm.avail_out === 0)
          return yr;
      } else
        Pr.match_available = 1, Pr.strstart++, Pr.lookahead--;
    }
    return Pr.match_available && (yn = p(Pr, 0, Pr.window[Pr.strstart - 1]), Pr.match_available = 0), Pr.insert = Pr.strstart < nr - 1 ? Pr.strstart : nr - 1, vr === Q ? (Xr(Pr, !0), Pr.strm.avail_out === 0 ? _r : Jr) : Pr.sym_next && (Xr(Pr, !1), Pr.strm.avail_out === 0) ? yr : Qr;
  }, wn = (Pr, vr) => {
    let Cr, yn, Pn, $n;
    const ui = Pr.window;
    for (; ; ) {
      if (Pr.lookahead <= fr) {
        if (kr(Pr), Pr.lookahead <= fr && vr === k)
          return yr;
        if (Pr.lookahead === 0)
          break;
      }
      if (Pr.match_length = 0, Pr.lookahead >= nr && Pr.strstart > 0 && (Pn = Pr.strstart - 1, yn = ui[Pn], yn === ui[++Pn] && yn === ui[++Pn] && yn === ui[++Pn])) {
        $n = Pr.strstart + fr;
        do
          ;
        while (yn === ui[++Pn] && yn === ui[++Pn] && yn === ui[++Pn] && yn === ui[++Pn] && yn === ui[++Pn] && yn === ui[++Pn] && yn === ui[++Pn] && yn === ui[++Pn] && Pn < $n);
        Pr.match_length = fr - ($n - Pn), Pr.match_length > Pr.lookahead && (Pr.match_length = Pr.lookahead);
      }
      if (Pr.match_length >= nr ? (Cr = p(Pr, 1, Pr.match_length - nr), Pr.lookahead -= Pr.match_length, Pr.strstart += Pr.match_length, Pr.match_length = 0) : (Cr = p(Pr, 0, Pr.window[Pr.strstart]), Pr.lookahead--, Pr.strstart++), Cr && (Xr(Pr, !1), Pr.strm.avail_out === 0))
        return yr;
    }
    return Pr.insert = 0, vr === Q ? (Xr(Pr, !0), Pr.strm.avail_out === 0 ? _r : Jr) : Pr.sym_next && (Xr(Pr, !1), Pr.strm.avail_out === 0) ? yr : Qr;
  }, Kn = (Pr, vr) => {
    let Cr;
    for (; ; ) {
      if (Pr.lookahead === 0 && (kr(Pr), Pr.lookahead === 0)) {
        if (vr === k)
          return yr;
        break;
      }
      if (Pr.match_length = 0, Cr = p(Pr, 0, Pr.window[Pr.strstart]), Pr.lookahead--, Pr.strstart++, Cr && (Xr(Pr, !1), Pr.strm.avail_out === 0))
        return yr;
    }
    return Pr.insert = 0, vr === Q ? (Xr(Pr, !0), Pr.strm.avail_out === 0 ? _r : Jr) : Pr.sym_next && (Xr(Pr, !1), Pr.strm.avail_out === 0) ? yr : Qr;
  };
  function Ln(Pr, vr, Cr, yn, Pn) {
    this.good_length = Pr, this.max_lazy = vr, this.nice_length = Cr, this.max_chain = yn, this.func = Pn;
  }
  const Wn = [
    /*      good lazy nice chain */
    new Ln(0, 0, 0, 0, Rr),
    /* 0 store only */
    new Ln(4, 4, 8, 4, Er),
    /* 1 max speed, no lazy matches */
    new Ln(4, 5, 16, 8, Er),
    /* 2 */
    new Ln(4, 6, 32, 32, Er),
    /* 3 */
    new Ln(4, 4, 16, 16, Or),
    /* 4 lazy matches */
    new Ln(8, 16, 32, 32, Or),
    /* 5 */
    new Ln(8, 16, 128, 128, Or),
    /* 6 */
    new Ln(8, 32, 128, 256, Or),
    /* 7 */
    new Ln(32, 128, 258, 1024, Or),
    /* 8 */
    new Ln(32, 258, 258, 4096, Or)
    /* 9 max compression */
  ], Sn = (Pr) => {
    Pr.window_size = 2 * Pr.w_size, Tn(Pr.head), Pr.max_lazy_match = Wn[Pr.level].max_lazy, Pr.good_match = Wn[Pr.level].good_length, Pr.nice_match = Wn[Pr.level].nice_length, Pr.max_chain_length = Wn[Pr.level].max_chain, Pr.strstart = 0, Pr.block_start = 0, Pr.lookahead = 0, Pr.insert = 0, Pr.match_length = Pr.prev_length = nr - 1, Pr.match_available = 0, Pr.ins_h = 0;
  };
  function hi() {
    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = Ee, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Uint16Array(ir * 2), this.dyn_dtree = new Uint16Array((2 * rr + 1) * 2), this.bl_tree = new Uint16Array((2 * er + 1) * 2), Tn(this.dyn_ltree), Tn(this.dyn_dtree), Tn(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Uint16Array(sr + 1), this.heap = new Uint16Array(2 * Ne + 1), Tn(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Uint16Array(2 * Ne + 1), Tn(this.depth), this.sym_buf = 0, this.lit_bufsize = 0, this.sym_next = 0, this.sym_end = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
  }
  const ki = (Pr) => {
    if (!Pr)
      return 1;
    const vr = Pr.state;
    return !vr || vr.strm !== Pr || vr.status !== Br && //#ifdef GZIP
    vr.status !== Fr && //#endif
    vr.status !== Gr && vr.status !== qr && vr.status !== Hr && vr.status !== un && vr.status !== Dr && vr.status !== wr ? 1 : 0;
  }, xi = (Pr) => {
    if (ki(Pr))
      return jr(Pr, F);
    Pr.total_in = Pr.total_out = 0, Pr.data_type = xe;
    const vr = Pr.state;
    return vr.pending = 0, vr.pending_out = 0, vr.wrap < 0 && (vr.wrap = -vr.wrap), vr.status = //#ifdef GZIP
    vr.wrap === 2 ? Fr : (
      //#endif
      vr.wrap ? Br : Dr
    ), Pr.adler = vr.wrap === 2 ? 0 : 1, vr.last_flush = -2, s(vr), x;
  }, _i = (Pr) => {
    const vr = xi(Pr);
    return vr === x && Sn(Pr.state), vr;
  }, Li = (Pr, vr) => ki(Pr) || Pr.state.wrap !== 2 ? F : (Pr.state.gzhead = vr, x), ms = (Pr, vr, Cr, yn, Pn, $n) => {
    if (!Pr)
      return F;
    let ui = 1;
    if (vr === pe && (vr = 6), yn < 0 ? (ui = 0, yn = -yn) : yn > 15 && (ui = 2, yn -= 16), Pn < 1 || Pn > He || Cr !== Ee || yn < 8 || yn > 15 || vr < 0 || vr > 9 || $n < 0 || $n > Te || yn === 8 && ui !== 1)
      return jr(Pr, F);
    yn === 8 && (yn = 9);
    const Ei = new hi();
    return Pr.state = Ei, Ei.strm = Pr, Ei.status = Br, Ei.wrap = ui, Ei.gzhead = null, Ei.w_bits = yn, Ei.w_size = 1 << Ei.w_bits, Ei.w_mask = Ei.w_size - 1, Ei.hash_bits = Pn + 7, Ei.hash_size = 1 << Ei.hash_bits, Ei.hash_mask = Ei.hash_size - 1, Ei.hash_shift = ~~((Ei.hash_bits + nr - 1) / nr), Ei.window = new Uint8Array(Ei.w_size * 2), Ei.head = new Uint16Array(Ei.hash_size), Ei.prev = new Uint16Array(Ei.w_size), Ei.lit_bufsize = 1 << Pn + 6, Ei.pending_buf_size = Ei.lit_bufsize * 4, Ei.pending_buf = new Uint8Array(Ei.pending_buf_size), Ei.sym_buf = Ei.lit_bufsize, Ei.sym_end = (Ei.lit_bufsize - 1) * 3, Ei.level = vr, Ei.strategy = $n, Ei.method = Cr, _i(Pr);
  }, Ui = (Pr, vr) => ms(Pr, vr, Ee, ve, we, Qe), Mi = (Pr, vr) => {
    if (ki(Pr) || vr > P || vr < 0)
      return Pr ? jr(Pr, F) : F;
    const Cr = Pr.state;
    if (!Pr.output || Pr.avail_in !== 0 && !Pr.input || Cr.status === wr && vr !== Q)
      return jr(Pr, Pr.avail_out === 0 ? ge : F);
    const yn = Cr.last_flush;
    if (Cr.last_flush = vr, Cr.pending !== 0) {
      if (Cn(Pr), Pr.avail_out === 0)
        return Cr.last_flush = -1, x;
    } else if (Pr.avail_in === 0 && dn(vr) <= dn(yn) && vr !== Q)
      return jr(Pr, ge);
    if (Cr.status === wr && Pr.avail_in !== 0)
      return jr(Pr, ge);
    if (Cr.status === Br && Cr.wrap === 0 && (Cr.status = Dr), Cr.status === Br) {
      let Pn = Ee + (Cr.w_bits - 8 << 4) << 8, $n = -1;
      if (Cr.strategy >= be || Cr.level < 2 ? $n = 0 : Cr.level < 6 ? $n = 1 : Cr.level === 6 ? $n = 2 : $n = 3, Pn |= $n << 6, Cr.strstart !== 0 && (Pn |= br), Pn += 31 - Pn % 31, zr(Cr, Pn), Cr.strstart !== 0 && (zr(Cr, Pr.adler >>> 16), zr(Cr, Pr.adler & 65535)), Pr.adler = 1, Cr.status = Dr, Cn(Pr), Cr.pending !== 0)
        return Cr.last_flush = -1, x;
    }
    if (Cr.status === Fr) {
      if (Pr.adler = 0, In(Cr, 31), In(Cr, 139), In(Cr, 8), Cr.gzhead)
        In(
          Cr,
          (Cr.gzhead.text ? 1 : 0) + (Cr.gzhead.hcrc ? 2 : 0) + (Cr.gzhead.extra ? 4 : 0) + (Cr.gzhead.name ? 8 : 0) + (Cr.gzhead.comment ? 16 : 0)
        ), In(Cr, Cr.gzhead.time & 255), In(Cr, Cr.gzhead.time >> 8 & 255), In(Cr, Cr.gzhead.time >> 16 & 255), In(Cr, Cr.gzhead.time >> 24 & 255), In(Cr, Cr.level === 9 ? 2 : Cr.strategy >= be || Cr.level < 2 ? 4 : 0), In(Cr, Cr.gzhead.os & 255), Cr.gzhead.extra && Cr.gzhead.extra.length && (In(Cr, Cr.gzhead.extra.length & 255), In(Cr, Cr.gzhead.extra.length >> 8 & 255)), Cr.gzhead.hcrc && (Pr.adler = m(Pr.adler, Cr.pending_buf, Cr.pending, 0)), Cr.gzindex = 0, Cr.status = Gr;
      else if (In(Cr, 0), In(Cr, 0), In(Cr, 0), In(Cr, 0), In(Cr, 0), In(Cr, Cr.level === 9 ? 2 : Cr.strategy >= be || Cr.level < 2 ? 4 : 0), In(Cr, fn), Cr.status = Dr, Cn(Pr), Cr.pending !== 0)
        return Cr.last_flush = -1, x;
    }
    if (Cr.status === Gr) {
      if (Cr.gzhead.extra) {
        let Pn = Cr.pending, $n = (Cr.gzhead.extra.length & 65535) - Cr.gzindex;
        for (; Cr.pending + $n > Cr.pending_buf_size; ) {
          let Ei = Cr.pending_buf_size - Cr.pending;
          if (Cr.pending_buf.set(Cr.gzhead.extra.subarray(Cr.gzindex, Cr.gzindex + Ei), Cr.pending), Cr.pending = Cr.pending_buf_size, Cr.gzhead.hcrc && Cr.pending > Pn && (Pr.adler = m(Pr.adler, Cr.pending_buf, Cr.pending - Pn, Pn)), Cr.gzindex += Ei, Cn(Pr), Cr.pending !== 0)
            return Cr.last_flush = -1, x;
          Pn = 0, $n -= Ei;
        }
        let ui = new Uint8Array(Cr.gzhead.extra);
        Cr.pending_buf.set(ui.subarray(Cr.gzindex, Cr.gzindex + $n), Cr.pending), Cr.pending += $n, Cr.gzhead.hcrc && Cr.pending > Pn && (Pr.adler = m(Pr.adler, Cr.pending_buf, Cr.pending - Pn, Pn)), Cr.gzindex = 0;
      }
      Cr.status = qr;
    }
    if (Cr.status === qr) {
      if (Cr.gzhead.name) {
        let Pn = Cr.pending, $n;
        do {
          if (Cr.pending === Cr.pending_buf_size) {
            if (Cr.gzhead.hcrc && Cr.pending > Pn && (Pr.adler = m(Pr.adler, Cr.pending_buf, Cr.pending - Pn, Pn)), Cn(Pr), Cr.pending !== 0)
              return Cr.last_flush = -1, x;
            Pn = 0;
          }
          Cr.gzindex < Cr.gzhead.name.length ? $n = Cr.gzhead.name.charCodeAt(Cr.gzindex++) & 255 : $n = 0, In(Cr, $n);
        } while ($n !== 0);
        Cr.gzhead.hcrc && Cr.pending > Pn && (Pr.adler = m(Pr.adler, Cr.pending_buf, Cr.pending - Pn, Pn)), Cr.gzindex = 0;
      }
      Cr.status = Hr;
    }
    if (Cr.status === Hr) {
      if (Cr.gzhead.comment) {
        let Pn = Cr.pending, $n;
        do {
          if (Cr.pending === Cr.pending_buf_size) {
            if (Cr.gzhead.hcrc && Cr.pending > Pn && (Pr.adler = m(Pr.adler, Cr.pending_buf, Cr.pending - Pn, Pn)), Cn(Pr), Cr.pending !== 0)
              return Cr.last_flush = -1, x;
            Pn = 0;
          }
          Cr.gzindex < Cr.gzhead.comment.length ? $n = Cr.gzhead.comment.charCodeAt(Cr.gzindex++) & 255 : $n = 0, In(Cr, $n);
        } while ($n !== 0);
        Cr.gzhead.hcrc && Cr.pending > Pn && (Pr.adler = m(Pr.adler, Cr.pending_buf, Cr.pending - Pn, Pn));
      }
      Cr.status = un;
    }
    if (Cr.status === un) {
      if (Cr.gzhead.hcrc) {
        if (Cr.pending + 2 > Cr.pending_buf_size && (Cn(Pr), Cr.pending !== 0))
          return Cr.last_flush = -1, x;
        In(Cr, Pr.adler & 255), In(Cr, Pr.adler >> 8 & 255), Pr.adler = 0;
      }
      if (Cr.status = Dr, Cn(Pr), Cr.pending !== 0)
        return Cr.last_flush = -1, x;
    }
    if (Pr.avail_in !== 0 || Cr.lookahead !== 0 || vr !== k && Cr.status !== wr) {
      let Pn = Cr.level === 0 ? Rr(Cr, vr) : Cr.strategy === be ? Kn(Cr, vr) : Cr.strategy === Pe ? wn(Cr, vr) : Wn[Cr.level].func(Cr, vr);
      if ((Pn === _r || Pn === Jr) && (Cr.status = wr), Pn === yr || Pn === _r)
        return Pr.avail_out === 0 && (Cr.last_flush = -1), x;
      if (Pn === Qr && (vr === C ? t(Cr) : vr !== P && (A(Cr, 0, 0, !1), vr === B && (Tn(Cr.head), Cr.lookahead === 0 && (Cr.strstart = 0, Cr.block_start = 0, Cr.insert = 0))), Cn(Pr), Pr.avail_out === 0))
        return Cr.last_flush = -1, x;
    }
    return vr !== Q ? x : Cr.wrap <= 0 ? M : (Cr.wrap === 2 ? (In(Cr, Pr.adler & 255), In(Cr, Pr.adler >> 8 & 255), In(Cr, Pr.adler >> 16 & 255), In(Cr, Pr.adler >> 24 & 255), In(Cr, Pr.total_in & 255), In(Cr, Pr.total_in >> 8 & 255), In(Cr, Pr.total_in >> 16 & 255), In(Cr, Pr.total_in >> 24 & 255)) : (zr(Cr, Pr.adler >>> 16), zr(Cr, Pr.adler & 65535)), Cn(Pr), Cr.wrap > 0 && (Cr.wrap = -Cr.wrap), Cr.pending !== 0 ? x : M);
  }, Ls = (Pr) => {
    if (ki(Pr))
      return F;
    const vr = Pr.state.status;
    return Pr.state = null, vr === Dr ? jr(Pr, le) : x;
  }, Ds = (Pr, vr) => {
    let Cr = vr.length;
    if (ki(Pr))
      return F;
    const yn = Pr.state, Pn = yn.wrap;
    if (Pn === 2 || Pn === 1 && yn.status !== Br || yn.lookahead)
      return F;
    if (Pn === 1 && (Pr.adler = l(Pr.adler, vr, Cr, 0)), yn.wrap = 0, Cr >= yn.w_size) {
      Pn === 0 && (Tn(yn.head), yn.strstart = 0, yn.block_start = 0, yn.insert = 0);
      let zi = new Uint8Array(yn.w_size);
      zi.set(vr.subarray(Cr - yn.w_size, Cr), 0), vr = zi, Cr = yn.w_size;
    }
    const $n = Pr.avail_in, ui = Pr.next_in, Ei = Pr.input;
    for (Pr.avail_in = Cr, Pr.next_in = 0, Pr.input = vr, kr(yn); yn.lookahead >= nr; ) {
      let zi = yn.strstart, Gi = yn.lookahead - (nr - 1);
      do
        yn.ins_h = vn(yn, yn.ins_h, yn.window[zi + nr - 1]), yn.prev[zi & yn.w_mask] = yn.head[yn.ins_h], yn.head[yn.ins_h] = zi, zi++;
      while (--Gi);
      yn.strstart = zi, yn.lookahead = nr - 1, kr(yn);
    }
    return yn.strstart += yn.lookahead, yn.block_start = yn.strstart, yn.insert = yn.lookahead, yn.lookahead = 0, yn.match_length = yn.prev_length = nr - 1, yn.match_available = 0, Pr.next_in = ui, Pr.input = Ei, Pr.avail_in = $n, yn.wrap = Pn, x;
  };
  return deflate.deflateInit = Ui, deflate.deflateInit2 = ms, deflate.deflateReset = _i, deflate.deflateResetKeep = xi, deflate.deflateSetHeader = Li, deflate.deflate = Mi, deflate.deflateEnd = Ls, deflate.deflateSetDictionary = Ds, deflate.deflateInfo = "pako deflate (from Nodeca project)", deflate;
}
var common = {}, hasRequiredCommon;
function requireCommon() {
  if (hasRequiredCommon) return common;
  hasRequiredCommon = 1;
  const s = (A, u) => Object.prototype.hasOwnProperty.call(A, u);
  return common.assign = function(A) {
    const u = Array.prototype.slice.call(arguments, 1);
    for (; u.length; ) {
      const p = u.shift();
      if (p) {
        if (typeof p != "object")
          throw new TypeError(p + "must be non-object");
        for (const t in p)
          s(p, t) && (A[t] = p[t]);
      }
    }
    return A;
  }, common.flattenChunks = (A) => {
    let u = 0;
    for (let t = 0, l = A.length; t < l; t++)
      u += A[t].length;
    const p = new Uint8Array(u);
    for (let t = 0, l = 0, m = A.length; t < m; t++) {
      let b = A[t];
      p.set(b, l), l += b.length;
    }
    return p;
  }, common;
}
var strings = {}, hasRequiredStrings;
function requireStrings() {
  if (hasRequiredStrings) return strings;
  hasRequiredStrings = 1;
  let s = !0;
  try {
    String.fromCharCode.apply(null, new Uint8Array(1));
  } catch {
    s = !1;
  }
  const A = new Uint8Array(256);
  for (let p = 0; p < 256; p++)
    A[p] = p >= 252 ? 6 : p >= 248 ? 5 : p >= 240 ? 4 : p >= 224 ? 3 : p >= 192 ? 2 : 1;
  A[254] = A[254] = 1, strings.string2buf = (p) => {
    if (typeof TextEncoder == "function" && TextEncoder.prototype.encode)
      return new TextEncoder().encode(p);
    let t, l, m, b, k, C = p.length, B = 0;
    for (b = 0; b < C; b++)
      l = p.charCodeAt(b), (l & 64512) === 55296 && b + 1 < C && (m = p.charCodeAt(b + 1), (m & 64512) === 56320 && (l = 65536 + (l - 55296 << 10) + (m - 56320), b++)), B += l < 128 ? 1 : l < 2048 ? 2 : l < 65536 ? 3 : 4;
    for (t = new Uint8Array(B), k = 0, b = 0; k < B; b++)
      l = p.charCodeAt(b), (l & 64512) === 55296 && b + 1 < C && (m = p.charCodeAt(b + 1), (m & 64512) === 56320 && (l = 65536 + (l - 55296 << 10) + (m - 56320), b++)), l < 128 ? t[k++] = l : l < 2048 ? (t[k++] = 192 | l >>> 6, t[k++] = 128 | l & 63) : l < 65536 ? (t[k++] = 224 | l >>> 12, t[k++] = 128 | l >>> 6 & 63, t[k++] = 128 | l & 63) : (t[k++] = 240 | l >>> 18, t[k++] = 128 | l >>> 12 & 63, t[k++] = 128 | l >>> 6 & 63, t[k++] = 128 | l & 63);
    return t;
  };
  const u = (p, t) => {
    if (t < 65534 && p.subarray && s)
      return String.fromCharCode.apply(null, p.length === t ? p : p.subarray(0, t));
    let l = "";
    for (let m = 0; m < t; m++)
      l += String.fromCharCode(p[m]);
    return l;
  };
  return strings.buf2string = (p, t) => {
    const l = t || p.length;
    if (typeof TextDecoder == "function" && TextDecoder.prototype.decode)
      return new TextDecoder().decode(p.subarray(0, t));
    let m, b;
    const k = new Array(l * 2);
    for (b = 0, m = 0; m < l; ) {
      let C = p[m++];
      if (C < 128) {
        k[b++] = C;
        continue;
      }
      let B = A[C];
      if (B > 4) {
        k[b++] = 65533, m += B - 1;
        continue;
      }
      for (C &= B === 2 ? 31 : B === 3 ? 15 : 7; B > 1 && m < l; )
        C = C << 6 | p[m++] & 63, B--;
      if (B > 1) {
        k[b++] = 65533;
        continue;
      }
      C < 65536 ? k[b++] = C : (C -= 65536, k[b++] = 55296 | C >> 10 & 1023, k[b++] = 56320 | C & 1023);
    }
    return u(k, b);
  }, strings.utf8border = (p, t) => {
    t = t || p.length, t > p.length && (t = p.length);
    let l = t - 1;
    for (; l >= 0 && (p[l] & 192) === 128; )
      l--;
    return l < 0 || l === 0 ? t : l + A[p[l]] > t ? l : t;
  }, strings;
}
var zstream, hasRequiredZstream;
function requireZstream() {
  if (hasRequiredZstream) return zstream;
  hasRequiredZstream = 1;
  function s() {
    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
  }
  return zstream = s, zstream;
}
var hasRequiredDeflate;
function requireDeflate() {
  if (hasRequiredDeflate) return deflate$1;
  hasRequiredDeflate = 1;
  const s = requireDeflate$1(), A = requireCommon(), u = requireStrings(), p = requireMessages(), t = requireZstream(), l = Object.prototype.toString, {
    Z_NO_FLUSH: m,
    Z_SYNC_FLUSH: b,
    Z_FULL_FLUSH: k,
    Z_FINISH: C,
    Z_OK: B,
    Z_STREAM_END: Q,
    Z_DEFAULT_COMPRESSION: P,
    Z_DEFAULT_STRATEGY: x,
    Z_DEFLATED: M
  } = requireConstants$3();
  function F(Ie) {
    this.options = A.assign({
      level: P,
      method: M,
      chunkSize: 16384,
      windowBits: 15,
      memLevel: 8,
      strategy: x
    }, Ie || {});
    let be = this.options;
    be.raw && be.windowBits > 0 ? be.windowBits = -be.windowBits : be.gzip && be.windowBits > 0 && be.windowBits < 16 && (be.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new t(), this.strm.avail_out = 0;
    let Pe = s.deflateInit2(
      this.strm,
      be.level,
      be.method,
      be.windowBits,
      be.memLevel,
      be.strategy
    );
    if (Pe !== B)
      throw new Error(p[Pe]);
    if (be.header && s.deflateSetHeader(this.strm, be.header), be.dictionary) {
      let Te;
      if (typeof be.dictionary == "string" ? Te = u.string2buf(be.dictionary) : l.call(be.dictionary) === "[object ArrayBuffer]" ? Te = new Uint8Array(be.dictionary) : Te = be.dictionary, Pe = s.deflateSetDictionary(this.strm, Te), Pe !== B)
        throw new Error(p[Pe]);
      this._dict_set = !0;
    }
  }
  F.prototype.push = function(Ie, be) {
    const Pe = this.strm, Te = this.options.chunkSize;
    let Qe, xe;
    if (this.ended)
      return !1;
    for (be === ~~be ? xe = be : xe = be === !0 ? C : m, typeof Ie == "string" ? Pe.input = u.string2buf(Ie) : l.call(Ie) === "[object ArrayBuffer]" ? Pe.input = new Uint8Array(Ie) : Pe.input = Ie, Pe.next_in = 0, Pe.avail_in = Pe.input.length; ; ) {
      if (Pe.avail_out === 0 && (Pe.output = new Uint8Array(Te), Pe.next_out = 0, Pe.avail_out = Te), (xe === b || xe === k) && Pe.avail_out <= 6) {
        this.onData(Pe.output.subarray(0, Pe.next_out)), Pe.avail_out = 0;
        continue;
      }
      if (Qe = s.deflate(Pe, xe), Qe === Q)
        return Pe.next_out > 0 && this.onData(Pe.output.subarray(0, Pe.next_out)), Qe = s.deflateEnd(this.strm), this.onEnd(Qe), this.ended = !0, Qe === B;
      if (Pe.avail_out === 0) {
        this.onData(Pe.output);
        continue;
      }
      if (xe > 0 && Pe.next_out > 0) {
        this.onData(Pe.output.subarray(0, Pe.next_out)), Pe.avail_out = 0;
        continue;
      }
      if (Pe.avail_in === 0) break;
    }
    return !0;
  }, F.prototype.onData = function(Ie) {
    this.chunks.push(Ie);
  }, F.prototype.onEnd = function(Ie) {
    Ie === B && (this.result = A.flattenChunks(this.chunks)), this.chunks = [], this.err = Ie, this.msg = this.strm.msg;
  };
  function le(Ie, be) {
    const Pe = new F(be);
    if (Pe.push(Ie, !0), Pe.err)
      throw Pe.msg || p[Pe.err];
    return Pe.result;
  }
  function ge(Ie, be) {
    return be = be || {}, be.raw = !0, le(Ie, be);
  }
  function pe(Ie, be) {
    return be = be || {}, be.gzip = !0, le(Ie, be);
  }
  return deflate$1.Deflate = F, deflate$1.deflate = le, deflate$1.deflateRaw = ge, deflate$1.gzip = pe, deflate$1.constants = requireConstants$3(), deflate$1;
}
var inflate$1 = {}, inflate = {}, inffast, hasRequiredInffast;
function requireInffast() {
  if (hasRequiredInffast) return inffast;
  hasRequiredInffast = 1;
  const s = 16209, A = 16191;
  return inffast = function(p, t) {
    let l, m, b, k, C, B, Q, P, x, M, F, le, ge, pe, Ie, be, Pe, Te, Qe, xe, Ee, He, ve, we;
    const Ce = p.state;
    l = p.next_in, ve = p.input, m = l + (p.avail_in - 5), b = p.next_out, we = p.output, k = b - (t - p.avail_out), C = b + (p.avail_out - 257), B = Ce.dmax, Q = Ce.wsize, P = Ce.whave, x = Ce.wnext, M = Ce.window, F = Ce.hold, le = Ce.bits, ge = Ce.lencode, pe = Ce.distcode, Ie = (1 << Ce.lenbits) - 1, be = (1 << Ce.distbits) - 1;
    e:
      do {
        le < 15 && (F += ve[l++] << le, le += 8, F += ve[l++] << le, le += 8), Pe = ge[F & Ie];
        t:
          for (; ; ) {
            if (Te = Pe >>> 24, F >>>= Te, le -= Te, Te = Pe >>> 16 & 255, Te === 0)
              we[b++] = Pe & 65535;
            else if (Te & 16) {
              Qe = Pe & 65535, Te &= 15, Te && (le < Te && (F += ve[l++] << le, le += 8), Qe += F & (1 << Te) - 1, F >>>= Te, le -= Te), le < 15 && (F += ve[l++] << le, le += 8, F += ve[l++] << le, le += 8), Pe = pe[F & be];
              r:
                for (; ; ) {
                  if (Te = Pe >>> 24, F >>>= Te, le -= Te, Te = Pe >>> 16 & 255, Te & 16) {
                    if (xe = Pe & 65535, Te &= 15, le < Te && (F += ve[l++] << le, le += 8, le < Te && (F += ve[l++] << le, le += 8)), xe += F & (1 << Te) - 1, xe > B) {
                      p.msg = "invalid distance too far back", Ce.mode = s;
                      break e;
                    }
                    if (F >>>= Te, le -= Te, Te = b - k, xe > Te) {
                      if (Te = xe - Te, Te > P && Ce.sane) {
                        p.msg = "invalid distance too far back", Ce.mode = s;
                        break e;
                      }
                      if (Ee = 0, He = M, x === 0) {
                        if (Ee += Q - Te, Te < Qe) {
                          Qe -= Te;
                          do
                            we[b++] = M[Ee++];
                          while (--Te);
                          Ee = b - xe, He = we;
                        }
                      } else if (x < Te) {
                        if (Ee += Q + x - Te, Te -= x, Te < Qe) {
                          Qe -= Te;
                          do
                            we[b++] = M[Ee++];
                          while (--Te);
                          if (Ee = 0, x < Qe) {
                            Te = x, Qe -= Te;
                            do
                              we[b++] = M[Ee++];
                            while (--Te);
                            Ee = b - xe, He = we;
                          }
                        }
                      } else if (Ee += x - Te, Te < Qe) {
                        Qe -= Te;
                        do
                          we[b++] = M[Ee++];
                        while (--Te);
                        Ee = b - xe, He = we;
                      }
                      for (; Qe > 2; )
                        we[b++] = He[Ee++], we[b++] = He[Ee++], we[b++] = He[Ee++], Qe -= 3;
                      Qe && (we[b++] = He[Ee++], Qe > 1 && (we[b++] = He[Ee++]));
                    } else {
                      Ee = b - xe;
                      do
                        we[b++] = we[Ee++], we[b++] = we[Ee++], we[b++] = we[Ee++], Qe -= 3;
                      while (Qe > 2);
                      Qe && (we[b++] = we[Ee++], Qe > 1 && (we[b++] = we[Ee++]));
                    }
                  } else if ((Te & 64) === 0) {
                    Pe = pe[(Pe & 65535) + (F & (1 << Te) - 1)];
                    continue r;
                  } else {
                    p.msg = "invalid distance code", Ce.mode = s;
                    break e;
                  }
                  break;
                }
            } else if ((Te & 64) === 0) {
              Pe = ge[(Pe & 65535) + (F & (1 << Te) - 1)];
              continue t;
            } else if (Te & 32) {
              Ce.mode = A;
              break e;
            } else {
              p.msg = "invalid literal/length code", Ce.mode = s;
              break e;
            }
            break;
          }
      } while (l < m && b < C);
    Qe = le >> 3, l -= Qe, le -= Qe << 3, F &= (1 << le) - 1, p.next_in = l, p.next_out = b, p.avail_in = l < m ? 5 + (m - l) : 5 - (l - m), p.avail_out = b < C ? 257 + (C - b) : 257 - (b - C), Ce.hold = F, Ce.bits = le;
  }, inffast;
}
var inftrees, hasRequiredInftrees;
function requireInftrees() {
  if (hasRequiredInftrees) return inftrees;
  hasRequiredInftrees = 1;
  const s = 15, A = 852, u = 592, p = 0, t = 1, l = 2, m = new Uint16Array([
    /* Length codes 257..285 base */
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
  ]), b = new Uint8Array([
    /* Length codes 257..285 extra */
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
  ]), k = new Uint16Array([
    /* Distance codes 0..29 base */
    1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
  ]), C = new Uint8Array([
    /* Distance codes 0..29 extra */
    16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
  ]);
  return inftrees = (Q, P, x, M, F, le, ge, pe) => {
    const Ie = pe.bits;
    let be = 0, Pe = 0, Te = 0, Qe = 0, xe = 0, Ee = 0, He = 0, ve = 0, we = 0, Ce = 0, Se, Ne, rr, er, ir, sr = null, nr;
    const fr = new Uint16Array(s + 1), lr = new Uint16Array(s + 1);
    let br = null, Br, Fr, Gr;
    for (be = 0; be <= s; be++)
      fr[be] = 0;
    for (Pe = 0; Pe < M; Pe++)
      fr[P[x + Pe]]++;
    for (xe = Ie, Qe = s; Qe >= 1 && fr[Qe] === 0; Qe--)
      ;
    if (xe > Qe && (xe = Qe), Qe === 0)
      return F[le++] = 1 << 24 | 64 << 16 | 0, F[le++] = 1 << 24 | 64 << 16 | 0, pe.bits = 1, 0;
    for (Te = 1; Te < Qe && fr[Te] === 0; Te++)
      ;
    for (xe < Te && (xe = Te), ve = 1, be = 1; be <= s; be++)
      if (ve <<= 1, ve -= fr[be], ve < 0)
        return -1;
    if (ve > 0 && (Q === p || Qe !== 1))
      return -1;
    for (lr[1] = 0, be = 1; be < s; be++)
      lr[be + 1] = lr[be] + fr[be];
    for (Pe = 0; Pe < M; Pe++)
      P[x + Pe] !== 0 && (ge[lr[P[x + Pe]]++] = Pe);
    if (Q === p ? (sr = br = ge, nr = 20) : Q === t ? (sr = m, br = b, nr = 257) : (sr = k, br = C, nr = 0), Ce = 0, Pe = 0, be = Te, ir = le, Ee = xe, He = 0, rr = -1, we = 1 << xe, er = we - 1, Q === t && we > A || Q === l && we > u)
      return 1;
    for (; ; ) {
      Br = be - He, ge[Pe] + 1 < nr ? (Fr = 0, Gr = ge[Pe]) : ge[Pe] >= nr ? (Fr = br[ge[Pe] - nr], Gr = sr[ge[Pe] - nr]) : (Fr = 96, Gr = 0), Se = 1 << be - He, Ne = 1 << Ee, Te = Ne;
      do
        Ne -= Se, F[ir + (Ce >> He) + Ne] = Br << 24 | Fr << 16 | Gr | 0;
      while (Ne !== 0);
      for (Se = 1 << be - 1; Ce & Se; )
        Se >>= 1;
      if (Se !== 0 ? (Ce &= Se - 1, Ce += Se) : Ce = 0, Pe++, --fr[be] === 0) {
        if (be === Qe)
          break;
        be = P[x + ge[Pe]];
      }
      if (be > xe && (Ce & er) !== rr) {
        for (He === 0 && (He = xe), ir += Te, Ee = be - He, ve = 1 << Ee; Ee + He < Qe && (ve -= fr[Ee + He], !(ve <= 0)); )
          Ee++, ve <<= 1;
        if (we += 1 << Ee, Q === t && we > A || Q === l && we > u)
          return 1;
        rr = Ce & er, F[rr] = xe << 24 | Ee << 16 | ir - le | 0;
      }
    }
    return Ce !== 0 && (F[ir + Ce] = be - He << 24 | 64 << 16 | 0), pe.bits = xe, 0;
  }, inftrees;
}
var hasRequiredInflate$1;
function requireInflate$1() {
  if (hasRequiredInflate$1) return inflate;
  hasRequiredInflate$1 = 1;
  const s = requireAdler32(), A = requireCrc32(), u = requireInffast(), p = requireInftrees(), t = 0, l = 1, m = 2, {
    Z_FINISH: b,
    Z_BLOCK: k,
    Z_TREES: C,
    Z_OK: B,
    Z_STREAM_END: Q,
    Z_NEED_DICT: P,
    Z_STREAM_ERROR: x,
    Z_DATA_ERROR: M,
    Z_MEM_ERROR: F,
    Z_BUF_ERROR: le,
    Z_DEFLATED: ge
  } = requireConstants$3(), pe = 16180, Ie = 16181, be = 16182, Pe = 16183, Te = 16184, Qe = 16185, xe = 16186, Ee = 16187, He = 16188, ve = 16189, we = 16190, Ce = 16191, Se = 16192, Ne = 16193, rr = 16194, er = 16195, ir = 16196, sr = 16197, nr = 16198, fr = 16199, lr = 16200, br = 16201, Br = 16202, Fr = 16203, Gr = 16204, qr = 16205, Hr = 16206, un = 16207, Dr = 16208, wr = 16209, yr = 16210, Qr = 16211, _r = 852, Jr = 592, jr = 15, dn = (Ln) => (Ln >>> 24 & 255) + (Ln >>> 8 & 65280) + ((Ln & 65280) << 8) + ((Ln & 255) << 24);
  function Tn() {
    this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
  }
  const Yn = (Ln) => {
    if (!Ln)
      return 1;
    const Wn = Ln.state;
    return !Wn || Wn.strm !== Ln || Wn.mode < pe || Wn.mode > Qr ? 1 : 0;
  }, si = (Ln) => {
    if (Yn(Ln))
      return x;
    const Wn = Ln.state;
    return Ln.total_in = Ln.total_out = Wn.total = 0, Ln.msg = "", Wn.wrap && (Ln.adler = Wn.wrap & 1), Wn.mode = pe, Wn.last = 0, Wn.havedict = 0, Wn.flags = -1, Wn.dmax = 32768, Wn.head = null, Wn.hold = 0, Wn.bits = 0, Wn.lencode = Wn.lendyn = new Int32Array(_r), Wn.distcode = Wn.distdyn = new Int32Array(Jr), Wn.sane = 1, Wn.back = -1, B;
  }, vn = (Ln) => {
    if (Yn(Ln))
      return x;
    const Wn = Ln.state;
    return Wn.wsize = 0, Wn.whave = 0, Wn.wnext = 0, si(Ln);
  }, Cn = (Ln, Wn) => {
    let Sn;
    if (Yn(Ln))
      return x;
    const hi = Ln.state;
    return Wn < 0 ? (Sn = 0, Wn = -Wn) : (Sn = (Wn >> 4) + 5, Wn < 48 && (Wn &= 15)), Wn && (Wn < 8 || Wn > 15) ? x : (hi.window !== null && hi.wbits !== Wn && (hi.window = null), hi.wrap = Sn, hi.wbits = Wn, vn(Ln));
  }, Xr = (Ln, Wn) => {
    if (!Ln)
      return x;
    const Sn = new Tn();
    Ln.state = Sn, Sn.strm = Ln, Sn.window = null, Sn.mode = pe;
    const hi = Cn(Ln, Wn);
    return hi !== B && (Ln.state = null), hi;
  }, In = (Ln) => Xr(Ln, jr);
  let zr = !0, En, Zr;
  const kr = (Ln) => {
    if (zr) {
      En = new Int32Array(512), Zr = new Int32Array(32);
      let Wn = 0;
      for (; Wn < 144; )
        Ln.lens[Wn++] = 8;
      for (; Wn < 256; )
        Ln.lens[Wn++] = 9;
      for (; Wn < 280; )
        Ln.lens[Wn++] = 7;
      for (; Wn < 288; )
        Ln.lens[Wn++] = 8;
      for (p(l, Ln.lens, 0, 288, En, 0, Ln.work, { bits: 9 }), Wn = 0; Wn < 32; )
        Ln.lens[Wn++] = 5;
      p(m, Ln.lens, 0, 32, Zr, 0, Ln.work, { bits: 5 }), zr = !1;
    }
    Ln.lencode = En, Ln.lenbits = 9, Ln.distcode = Zr, Ln.distbits = 5;
  }, Rr = (Ln, Wn, Sn, hi) => {
    let ki;
    const xi = Ln.state;
    return xi.window === null && (xi.wsize = 1 << xi.wbits, xi.wnext = 0, xi.whave = 0, xi.window = new Uint8Array(xi.wsize)), hi >= xi.wsize ? (xi.window.set(Wn.subarray(Sn - xi.wsize, Sn), 0), xi.wnext = 0, xi.whave = xi.wsize) : (ki = xi.wsize - xi.wnext, ki > hi && (ki = hi), xi.window.set(Wn.subarray(Sn - hi, Sn - hi + ki), xi.wnext), hi -= ki, hi ? (xi.window.set(Wn.subarray(Sn - hi, Sn), 0), xi.wnext = hi, xi.whave = xi.wsize) : (xi.wnext += ki, xi.wnext === xi.wsize && (xi.wnext = 0), xi.whave < xi.wsize && (xi.whave += ki))), 0;
  }, Er = (Ln, Wn) => {
    let Sn, hi, ki, xi, _i, Li, ms, Ui, Mi, Ls, Ds, Pr, vr, Cr, yn = 0, Pn, $n, ui, Ei, zi, Gi, Vi, Ur;
    const $i = new Uint8Array(4);
    let Es, pn;
    const Nr = (
      /* permutation of code lengths */
      new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15])
    );
    if (Yn(Ln) || !Ln.output || !Ln.input && Ln.avail_in !== 0)
      return x;
    Sn = Ln.state, Sn.mode === Ce && (Sn.mode = Se), _i = Ln.next_out, ki = Ln.output, ms = Ln.avail_out, xi = Ln.next_in, hi = Ln.input, Li = Ln.avail_in, Ui = Sn.hold, Mi = Sn.bits, Ls = Li, Ds = ms, Ur = B;
    e:
      for (; ; )
        switch (Sn.mode) {
          case pe:
            if (Sn.wrap === 0) {
              Sn.mode = Se;
              break;
            }
            for (; Mi < 16; ) {
              if (Li === 0)
                break e;
              Li--, Ui += hi[xi++] << Mi, Mi += 8;
            }
            if (Sn.wrap & 2 && Ui === 35615) {
              Sn.wbits === 0 && (Sn.wbits = 15), Sn.check = 0, $i[0] = Ui & 255, $i[1] = Ui >>> 8 & 255, Sn.check = A(Sn.check, $i, 2, 0), Ui = 0, Mi = 0, Sn.mode = Ie;
              break;
            }
            if (Sn.head && (Sn.head.done = !1), !(Sn.wrap & 1) || /* check if zlib header allowed */
            (((Ui & 255) << 8) + (Ui >> 8)) % 31) {
              Ln.msg = "incorrect header check", Sn.mode = wr;
              break;
            }
            if ((Ui & 15) !== ge) {
              Ln.msg = "unknown compression method", Sn.mode = wr;
              break;
            }
            if (Ui >>>= 4, Mi -= 4, Vi = (Ui & 15) + 8, Sn.wbits === 0 && (Sn.wbits = Vi), Vi > 15 || Vi > Sn.wbits) {
              Ln.msg = "invalid window size", Sn.mode = wr;
              break;
            }
            Sn.dmax = 1 << Sn.wbits, Sn.flags = 0, Ln.adler = Sn.check = 1, Sn.mode = Ui & 512 ? ve : Ce, Ui = 0, Mi = 0;
            break;
          case Ie:
            for (; Mi < 16; ) {
              if (Li === 0)
                break e;
              Li--, Ui += hi[xi++] << Mi, Mi += 8;
            }
            if (Sn.flags = Ui, (Sn.flags & 255) !== ge) {
              Ln.msg = "unknown compression method", Sn.mode = wr;
              break;
            }
            if (Sn.flags & 57344) {
              Ln.msg = "unknown header flags set", Sn.mode = wr;
              break;
            }
            Sn.head && (Sn.head.text = Ui >> 8 & 1), Sn.flags & 512 && Sn.wrap & 4 && ($i[0] = Ui & 255, $i[1] = Ui >>> 8 & 255, Sn.check = A(Sn.check, $i, 2, 0)), Ui = 0, Mi = 0, Sn.mode = be;
          /* falls through */
          case be:
            for (; Mi < 32; ) {
              if (Li === 0)
                break e;
              Li--, Ui += hi[xi++] << Mi, Mi += 8;
            }
            Sn.head && (Sn.head.time = Ui), Sn.flags & 512 && Sn.wrap & 4 && ($i[0] = Ui & 255, $i[1] = Ui >>> 8 & 255, $i[2] = Ui >>> 16 & 255, $i[3] = Ui >>> 24 & 255, Sn.check = A(Sn.check, $i, 4, 0)), Ui = 0, Mi = 0, Sn.mode = Pe;
          /* falls through */
          case Pe:
            for (; Mi < 16; ) {
              if (Li === 0)
                break e;
              Li--, Ui += hi[xi++] << Mi, Mi += 8;
            }
            Sn.head && (Sn.head.xflags = Ui & 255, Sn.head.os = Ui >> 8), Sn.flags & 512 && Sn.wrap & 4 && ($i[0] = Ui & 255, $i[1] = Ui >>> 8 & 255, Sn.check = A(Sn.check, $i, 2, 0)), Ui = 0, Mi = 0, Sn.mode = Te;
          /* falls through */
          case Te:
            if (Sn.flags & 1024) {
              for (; Mi < 16; ) {
                if (Li === 0)
                  break e;
                Li--, Ui += hi[xi++] << Mi, Mi += 8;
              }
              Sn.length = Ui, Sn.head && (Sn.head.extra_len = Ui), Sn.flags & 512 && Sn.wrap & 4 && ($i[0] = Ui & 255, $i[1] = Ui >>> 8 & 255, Sn.check = A(Sn.check, $i, 2, 0)), Ui = 0, Mi = 0;
            } else Sn.head && (Sn.head.extra = null);
            Sn.mode = Qe;
          /* falls through */
          case Qe:
            if (Sn.flags & 1024 && (Pr = Sn.length, Pr > Li && (Pr = Li), Pr && (Sn.head && (Vi = Sn.head.extra_len - Sn.length, Sn.head.extra || (Sn.head.extra = new Uint8Array(Sn.head.extra_len)), Sn.head.extra.set(
              hi.subarray(
                xi,
                // extra field is limited to 65536 bytes
                // - no need for additional size check
                xi + Pr
              ),
              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
              Vi
            )), Sn.flags & 512 && Sn.wrap & 4 && (Sn.check = A(Sn.check, hi, Pr, xi)), Li -= Pr, xi += Pr, Sn.length -= Pr), Sn.length))
              break e;
            Sn.length = 0, Sn.mode = xe;
          /* falls through */
          case xe:
            if (Sn.flags & 2048) {
              if (Li === 0)
                break e;
              Pr = 0;
              do
                Vi = hi[xi + Pr++], Sn.head && Vi && Sn.length < 65536 && (Sn.head.name += String.fromCharCode(Vi));
              while (Vi && Pr < Li);
              if (Sn.flags & 512 && Sn.wrap & 4 && (Sn.check = A(Sn.check, hi, Pr, xi)), Li -= Pr, xi += Pr, Vi)
                break e;
            } else Sn.head && (Sn.head.name = null);
            Sn.length = 0, Sn.mode = Ee;
          /* falls through */
          case Ee:
            if (Sn.flags & 4096) {
              if (Li === 0)
                break e;
              Pr = 0;
              do
                Vi = hi[xi + Pr++], Sn.head && Vi && Sn.length < 65536 && (Sn.head.comment += String.fromCharCode(Vi));
              while (Vi && Pr < Li);
              if (Sn.flags & 512 && Sn.wrap & 4 && (Sn.check = A(Sn.check, hi, Pr, xi)), Li -= Pr, xi += Pr, Vi)
                break e;
            } else Sn.head && (Sn.head.comment = null);
            Sn.mode = He;
          /* falls through */
          case He:
            if (Sn.flags & 512) {
              for (; Mi < 16; ) {
                if (Li === 0)
                  break e;
                Li--, Ui += hi[xi++] << Mi, Mi += 8;
              }
              if (Sn.wrap & 4 && Ui !== (Sn.check & 65535)) {
                Ln.msg = "header crc mismatch", Sn.mode = wr;
                break;
              }
              Ui = 0, Mi = 0;
            }
            Sn.head && (Sn.head.hcrc = Sn.flags >> 9 & 1, Sn.head.done = !0), Ln.adler = Sn.check = 0, Sn.mode = Ce;
            break;
          case ve:
            for (; Mi < 32; ) {
              if (Li === 0)
                break e;
              Li--, Ui += hi[xi++] << Mi, Mi += 8;
            }
            Ln.adler = Sn.check = dn(Ui), Ui = 0, Mi = 0, Sn.mode = we;
          /* falls through */
          case we:
            if (Sn.havedict === 0)
              return Ln.next_out = _i, Ln.avail_out = ms, Ln.next_in = xi, Ln.avail_in = Li, Sn.hold = Ui, Sn.bits = Mi, P;
            Ln.adler = Sn.check = 1, Sn.mode = Ce;
          /* falls through */
          case Ce:
            if (Wn === k || Wn === C)
              break e;
          /* falls through */
          case Se:
            if (Sn.last) {
              Ui >>>= Mi & 7, Mi -= Mi & 7, Sn.mode = Hr;
              break;
            }
            for (; Mi < 3; ) {
              if (Li === 0)
                break e;
              Li--, Ui += hi[xi++] << Mi, Mi += 8;
            }
            switch (Sn.last = Ui & 1, Ui >>>= 1, Mi -= 1, Ui & 3) {
              case 0:
                Sn.mode = Ne;
                break;
              case 1:
                if (kr(Sn), Sn.mode = fr, Wn === C) {
                  Ui >>>= 2, Mi -= 2;
                  break e;
                }
                break;
              case 2:
                Sn.mode = ir;
                break;
              case 3:
                Ln.msg = "invalid block type", Sn.mode = wr;
            }
            Ui >>>= 2, Mi -= 2;
            break;
          case Ne:
            for (Ui >>>= Mi & 7, Mi -= Mi & 7; Mi < 32; ) {
              if (Li === 0)
                break e;
              Li--, Ui += hi[xi++] << Mi, Mi += 8;
            }
            if ((Ui & 65535) !== (Ui >>> 16 ^ 65535)) {
              Ln.msg = "invalid stored block lengths", Sn.mode = wr;
              break;
            }
            if (Sn.length = Ui & 65535, Ui = 0, Mi = 0, Sn.mode = rr, Wn === C)
              break e;
          /* falls through */
          case rr:
            Sn.mode = er;
          /* falls through */
          case er:
            if (Pr = Sn.length, Pr) {
              if (Pr > Li && (Pr = Li), Pr > ms && (Pr = ms), Pr === 0)
                break e;
              ki.set(hi.subarray(xi, xi + Pr), _i), Li -= Pr, xi += Pr, ms -= Pr, _i += Pr, Sn.length -= Pr;
              break;
            }
            Sn.mode = Ce;
            break;
          case ir:
            for (; Mi < 14; ) {
              if (Li === 0)
                break e;
              Li--, Ui += hi[xi++] << Mi, Mi += 8;
            }
            if (Sn.nlen = (Ui & 31) + 257, Ui >>>= 5, Mi -= 5, Sn.ndist = (Ui & 31) + 1, Ui >>>= 5, Mi -= 5, Sn.ncode = (Ui & 15) + 4, Ui >>>= 4, Mi -= 4, Sn.nlen > 286 || Sn.ndist > 30) {
              Ln.msg = "too many length or distance symbols", Sn.mode = wr;
              break;
            }
            Sn.have = 0, Sn.mode = sr;
          /* falls through */
          case sr:
            for (; Sn.have < Sn.ncode; ) {
              for (; Mi < 3; ) {
                if (Li === 0)
                  break e;
                Li--, Ui += hi[xi++] << Mi, Mi += 8;
              }
              Sn.lens[Nr[Sn.have++]] = Ui & 7, Ui >>>= 3, Mi -= 3;
            }
            for (; Sn.have < 19; )
              Sn.lens[Nr[Sn.have++]] = 0;
            if (Sn.lencode = Sn.lendyn, Sn.lenbits = 7, Es = { bits: Sn.lenbits }, Ur = p(t, Sn.lens, 0, 19, Sn.lencode, 0, Sn.work, Es), Sn.lenbits = Es.bits, Ur) {
              Ln.msg = "invalid code lengths set", Sn.mode = wr;
              break;
            }
            Sn.have = 0, Sn.mode = nr;
          /* falls through */
          case nr:
            for (; Sn.have < Sn.nlen + Sn.ndist; ) {
              for (; yn = Sn.lencode[Ui & (1 << Sn.lenbits) - 1], Pn = yn >>> 24, $n = yn >>> 16 & 255, ui = yn & 65535, !(Pn <= Mi); ) {
                if (Li === 0)
                  break e;
                Li--, Ui += hi[xi++] << Mi, Mi += 8;
              }
              if (ui < 16)
                Ui >>>= Pn, Mi -= Pn, Sn.lens[Sn.have++] = ui;
              else {
                if (ui === 16) {
                  for (pn = Pn + 2; Mi < pn; ) {
                    if (Li === 0)
                      break e;
                    Li--, Ui += hi[xi++] << Mi, Mi += 8;
                  }
                  if (Ui >>>= Pn, Mi -= Pn, Sn.have === 0) {
                    Ln.msg = "invalid bit length repeat", Sn.mode = wr;
                    break;
                  }
                  Vi = Sn.lens[Sn.have - 1], Pr = 3 + (Ui & 3), Ui >>>= 2, Mi -= 2;
                } else if (ui === 17) {
                  for (pn = Pn + 3; Mi < pn; ) {
                    if (Li === 0)
                      break e;
                    Li--, Ui += hi[xi++] << Mi, Mi += 8;
                  }
                  Ui >>>= Pn, Mi -= Pn, Vi = 0, Pr = 3 + (Ui & 7), Ui >>>= 3, Mi -= 3;
                } else {
                  for (pn = Pn + 7; Mi < pn; ) {
                    if (Li === 0)
                      break e;
                    Li--, Ui += hi[xi++] << Mi, Mi += 8;
                  }
                  Ui >>>= Pn, Mi -= Pn, Vi = 0, Pr = 11 + (Ui & 127), Ui >>>= 7, Mi -= 7;
                }
                if (Sn.have + Pr > Sn.nlen + Sn.ndist) {
                  Ln.msg = "invalid bit length repeat", Sn.mode = wr;
                  break;
                }
                for (; Pr--; )
                  Sn.lens[Sn.have++] = Vi;
              }
            }
            if (Sn.mode === wr)
              break;
            if (Sn.lens[256] === 0) {
              Ln.msg = "invalid code -- missing end-of-block", Sn.mode = wr;
              break;
            }
            if (Sn.lenbits = 9, Es = { bits: Sn.lenbits }, Ur = p(l, Sn.lens, 0, Sn.nlen, Sn.lencode, 0, Sn.work, Es), Sn.lenbits = Es.bits, Ur) {
              Ln.msg = "invalid literal/lengths set", Sn.mode = wr;
              break;
            }
            if (Sn.distbits = 6, Sn.distcode = Sn.distdyn, Es = { bits: Sn.distbits }, Ur = p(m, Sn.lens, Sn.nlen, Sn.ndist, Sn.distcode, 0, Sn.work, Es), Sn.distbits = Es.bits, Ur) {
              Ln.msg = "invalid distances set", Sn.mode = wr;
              break;
            }
            if (Sn.mode = fr, Wn === C)
              break e;
          /* falls through */
          case fr:
            Sn.mode = lr;
          /* falls through */
          case lr:
            if (Li >= 6 && ms >= 258) {
              Ln.next_out = _i, Ln.avail_out = ms, Ln.next_in = xi, Ln.avail_in = Li, Sn.hold = Ui, Sn.bits = Mi, u(Ln, Ds), _i = Ln.next_out, ki = Ln.output, ms = Ln.avail_out, xi = Ln.next_in, hi = Ln.input, Li = Ln.avail_in, Ui = Sn.hold, Mi = Sn.bits, Sn.mode === Ce && (Sn.back = -1);
              break;
            }
            for (Sn.back = 0; yn = Sn.lencode[Ui & (1 << Sn.lenbits) - 1], Pn = yn >>> 24, $n = yn >>> 16 & 255, ui = yn & 65535, !(Pn <= Mi); ) {
              if (Li === 0)
                break e;
              Li--, Ui += hi[xi++] << Mi, Mi += 8;
            }
            if ($n && ($n & 240) === 0) {
              for (Ei = Pn, zi = $n, Gi = ui; yn = Sn.lencode[Gi + ((Ui & (1 << Ei + zi) - 1) >> Ei)], Pn = yn >>> 24, $n = yn >>> 16 & 255, ui = yn & 65535, !(Ei + Pn <= Mi); ) {
                if (Li === 0)
                  break e;
                Li--, Ui += hi[xi++] << Mi, Mi += 8;
              }
              Ui >>>= Ei, Mi -= Ei, Sn.back += Ei;
            }
            if (Ui >>>= Pn, Mi -= Pn, Sn.back += Pn, Sn.length = ui, $n === 0) {
              Sn.mode = qr;
              break;
            }
            if ($n & 32) {
              Sn.back = -1, Sn.mode = Ce;
              break;
            }
            if ($n & 64) {
              Ln.msg = "invalid literal/length code", Sn.mode = wr;
              break;
            }
            Sn.extra = $n & 15, Sn.mode = br;
          /* falls through */
          case br:
            if (Sn.extra) {
              for (pn = Sn.extra; Mi < pn; ) {
                if (Li === 0)
                  break e;
                Li--, Ui += hi[xi++] << Mi, Mi += 8;
              }
              Sn.length += Ui & (1 << Sn.extra) - 1, Ui >>>= Sn.extra, Mi -= Sn.extra, Sn.back += Sn.extra;
            }
            Sn.was = Sn.length, Sn.mode = Br;
          /* falls through */
          case Br:
            for (; yn = Sn.distcode[Ui & (1 << Sn.distbits) - 1], Pn = yn >>> 24, $n = yn >>> 16 & 255, ui = yn & 65535, !(Pn <= Mi); ) {
              if (Li === 0)
                break e;
              Li--, Ui += hi[xi++] << Mi, Mi += 8;
            }
            if (($n & 240) === 0) {
              for (Ei = Pn, zi = $n, Gi = ui; yn = Sn.distcode[Gi + ((Ui & (1 << Ei + zi) - 1) >> Ei)], Pn = yn >>> 24, $n = yn >>> 16 & 255, ui = yn & 65535, !(Ei + Pn <= Mi); ) {
                if (Li === 0)
                  break e;
                Li--, Ui += hi[xi++] << Mi, Mi += 8;
              }
              Ui >>>= Ei, Mi -= Ei, Sn.back += Ei;
            }
            if (Ui >>>= Pn, Mi -= Pn, Sn.back += Pn, $n & 64) {
              Ln.msg = "invalid distance code", Sn.mode = wr;
              break;
            }
            Sn.offset = ui, Sn.extra = $n & 15, Sn.mode = Fr;
          /* falls through */
          case Fr:
            if (Sn.extra) {
              for (pn = Sn.extra; Mi < pn; ) {
                if (Li === 0)
                  break e;
                Li--, Ui += hi[xi++] << Mi, Mi += 8;
              }
              Sn.offset += Ui & (1 << Sn.extra) - 1, Ui >>>= Sn.extra, Mi -= Sn.extra, Sn.back += Sn.extra;
            }
            if (Sn.offset > Sn.dmax) {
              Ln.msg = "invalid distance too far back", Sn.mode = wr;
              break;
            }
            Sn.mode = Gr;
          /* falls through */
          case Gr:
            if (ms === 0)
              break e;
            if (Pr = Ds - ms, Sn.offset > Pr) {
              if (Pr = Sn.offset - Pr, Pr > Sn.whave && Sn.sane) {
                Ln.msg = "invalid distance too far back", Sn.mode = wr;
                break;
              }
              Pr > Sn.wnext ? (Pr -= Sn.wnext, vr = Sn.wsize - Pr) : vr = Sn.wnext - Pr, Pr > Sn.length && (Pr = Sn.length), Cr = Sn.window;
            } else
              Cr = ki, vr = _i - Sn.offset, Pr = Sn.length;
            Pr > ms && (Pr = ms), ms -= Pr, Sn.length -= Pr;
            do
              ki[_i++] = Cr[vr++];
            while (--Pr);
            Sn.length === 0 && (Sn.mode = lr);
            break;
          case qr:
            if (ms === 0)
              break e;
            ki[_i++] = Sn.length, ms--, Sn.mode = lr;
            break;
          case Hr:
            if (Sn.wrap) {
              for (; Mi < 32; ) {
                if (Li === 0)
                  break e;
                Li--, Ui |= hi[xi++] << Mi, Mi += 8;
              }
              if (Ds -= ms, Ln.total_out += Ds, Sn.total += Ds, Sn.wrap & 4 && Ds && (Ln.adler = Sn.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/
              Sn.flags ? A(Sn.check, ki, Ds, _i - Ds) : s(Sn.check, ki, Ds, _i - Ds)), Ds = ms, Sn.wrap & 4 && (Sn.flags ? Ui : dn(Ui)) !== Sn.check) {
                Ln.msg = "incorrect data check", Sn.mode = wr;
                break;
              }
              Ui = 0, Mi = 0;
            }
            Sn.mode = un;
          /* falls through */
          case un:
            if (Sn.wrap && Sn.flags) {
              for (; Mi < 32; ) {
                if (Li === 0)
                  break e;
                Li--, Ui += hi[xi++] << Mi, Mi += 8;
              }
              if (Sn.wrap & 4 && Ui !== (Sn.total & 4294967295)) {
                Ln.msg = "incorrect length check", Sn.mode = wr;
                break;
              }
              Ui = 0, Mi = 0;
            }
            Sn.mode = Dr;
          /* falls through */
          case Dr:
            Ur = Q;
            break e;
          case wr:
            Ur = M;
            break e;
          case yr:
            return F;
          case Qr:
          /* falls through */
          default:
            return x;
        }
    return Ln.next_out = _i, Ln.avail_out = ms, Ln.next_in = xi, Ln.avail_in = Li, Sn.hold = Ui, Sn.bits = Mi, (Sn.wsize || Ds !== Ln.avail_out && Sn.mode < wr && (Sn.mode < Hr || Wn !== b)) && Rr(Ln, Ln.output, Ln.next_out, Ds - Ln.avail_out), Ls -= Ln.avail_in, Ds -= Ln.avail_out, Ln.total_in += Ls, Ln.total_out += Ds, Sn.total += Ds, Sn.wrap & 4 && Ds && (Ln.adler = Sn.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
    Sn.flags ? A(Sn.check, ki, Ds, Ln.next_out - Ds) : s(Sn.check, ki, Ds, Ln.next_out - Ds)), Ln.data_type = Sn.bits + (Sn.last ? 64 : 0) + (Sn.mode === Ce ? 128 : 0) + (Sn.mode === fr || Sn.mode === rr ? 256 : 0), (Ls === 0 && Ds === 0 || Wn === b) && Ur === B && (Ur = le), Ur;
  }, Or = (Ln) => {
    if (Yn(Ln))
      return x;
    let Wn = Ln.state;
    return Wn.window && (Wn.window = null), Ln.state = null, B;
  }, wn = (Ln, Wn) => {
    if (Yn(Ln))
      return x;
    const Sn = Ln.state;
    return (Sn.wrap & 2) === 0 ? x : (Sn.head = Wn, Wn.done = !1, B);
  }, Kn = (Ln, Wn) => {
    const Sn = Wn.length;
    let hi, ki, xi;
    return Yn(Ln) || (hi = Ln.state, hi.wrap !== 0 && hi.mode !== we) ? x : hi.mode === we && (ki = 1, ki = s(ki, Wn, Sn, 0), ki !== hi.check) ? M : (xi = Rr(Ln, Wn, Sn, Sn), xi ? (hi.mode = yr, F) : (hi.havedict = 1, B));
  };
  return inflate.inflateReset = vn, inflate.inflateReset2 = Cn, inflate.inflateResetKeep = si, inflate.inflateInit = In, inflate.inflateInit2 = Xr, inflate.inflate = Er, inflate.inflateEnd = Or, inflate.inflateGetHeader = wn, inflate.inflateSetDictionary = Kn, inflate.inflateInfo = "pako inflate (from Nodeca project)", inflate;
}
var gzheader, hasRequiredGzheader;
function requireGzheader() {
  if (hasRequiredGzheader) return gzheader;
  hasRequiredGzheader = 1;
  function s() {
    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
  }
  return gzheader = s, gzheader;
}
var hasRequiredInflate;
function requireInflate() {
  if (hasRequiredInflate) return inflate$1;
  hasRequiredInflate = 1;
  const s = requireInflate$1(), A = requireCommon(), u = requireStrings(), p = requireMessages(), t = requireZstream(), l = requireGzheader(), m = Object.prototype.toString, {
    Z_NO_FLUSH: b,
    Z_FINISH: k,
    Z_OK: C,
    Z_STREAM_END: B,
    Z_NEED_DICT: Q,
    Z_STREAM_ERROR: P,
    Z_DATA_ERROR: x,
    Z_MEM_ERROR: M
  } = requireConstants$3();
  function F(pe) {
    this.options = A.assign({
      chunkSize: 1024 * 64,
      windowBits: 15,
      to: ""
    }, pe || {});
    const Ie = this.options;
    Ie.raw && Ie.windowBits >= 0 && Ie.windowBits < 16 && (Ie.windowBits = -Ie.windowBits, Ie.windowBits === 0 && (Ie.windowBits = -15)), Ie.windowBits >= 0 && Ie.windowBits < 16 && !(pe && pe.windowBits) && (Ie.windowBits += 32), Ie.windowBits > 15 && Ie.windowBits < 48 && (Ie.windowBits & 15) === 0 && (Ie.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new t(), this.strm.avail_out = 0;
    let be = s.inflateInit2(
      this.strm,
      Ie.windowBits
    );
    if (be !== C)
      throw new Error(p[be]);
    if (this.header = new l(), s.inflateGetHeader(this.strm, this.header), Ie.dictionary && (typeof Ie.dictionary == "string" ? Ie.dictionary = u.string2buf(Ie.dictionary) : m.call(Ie.dictionary) === "[object ArrayBuffer]" && (Ie.dictionary = new Uint8Array(Ie.dictionary)), Ie.raw && (be = s.inflateSetDictionary(this.strm, Ie.dictionary), be !== C)))
      throw new Error(p[be]);
  }
  F.prototype.push = function(pe, Ie) {
    const be = this.strm, Pe = this.options.chunkSize, Te = this.options.dictionary;
    let Qe, xe, Ee;
    if (this.ended) return !1;
    for (Ie === ~~Ie ? xe = Ie : xe = Ie === !0 ? k : b, m.call(pe) === "[object ArrayBuffer]" ? be.input = new Uint8Array(pe) : be.input = pe, be.next_in = 0, be.avail_in = be.input.length; ; ) {
      for (be.avail_out === 0 && (be.output = new Uint8Array(Pe), be.next_out = 0, be.avail_out = Pe), Qe = s.inflate(be, xe), Qe === Q && Te && (Qe = s.inflateSetDictionary(be, Te), Qe === C ? Qe = s.inflate(be, xe) : Qe === x && (Qe = Q)); be.avail_in > 0 && Qe === B && be.state.wrap > 0 && pe[be.next_in] !== 0; )
        s.inflateReset(be), Qe = s.inflate(be, xe);
      switch (Qe) {
        case P:
        case x:
        case Q:
        case M:
          return this.onEnd(Qe), this.ended = !0, !1;
      }
      if (Ee = be.avail_out, be.next_out && (be.avail_out === 0 || Qe === B))
        if (this.options.to === "string") {
          let He = u.utf8border(be.output, be.next_out), ve = be.next_out - He, we = u.buf2string(be.output, He);
          be.next_out = ve, be.avail_out = Pe - ve, ve && be.output.set(be.output.subarray(He, He + ve), 0), this.onData(we);
        } else
          this.onData(be.output.length === be.next_out ? be.output : be.output.subarray(0, be.next_out));
      if (!(Qe === C && Ee === 0)) {
        if (Qe === B)
          return Qe = s.inflateEnd(this.strm), this.onEnd(Qe), this.ended = !0, !0;
        if (be.avail_in === 0) break;
      }
    }
    return !0;
  }, F.prototype.onData = function(pe) {
    this.chunks.push(pe);
  }, F.prototype.onEnd = function(pe) {
    pe === C && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = A.flattenChunks(this.chunks)), this.chunks = [], this.err = pe, this.msg = this.strm.msg;
  };
  function le(pe, Ie) {
    const be = new F(Ie);
    if (be.push(pe), be.err) throw be.msg || p[be.err];
    return be.result;
  }
  function ge(pe, Ie) {
    return Ie = Ie || {}, Ie.raw = !0, le(pe, Ie);
  }
  return inflate$1.Inflate = F, inflate$1.inflate = le, inflate$1.inflateRaw = ge, inflate$1.ungzip = le, inflate$1.constants = requireConstants$3(), inflate$1;
}
var hasRequiredPako;
function requirePako() {
  if (hasRequiredPako) return pako;
  hasRequiredPako = 1;
  const { Deflate: s, deflate: A, deflateRaw: u, gzip: p } = requireDeflate(), { Inflate: t, inflate: l, inflateRaw: m, ungzip: b } = requireInflate(), k = requireConstants$3();
  return pako.Deflate = s, pako.deflate = A, pako.deflateRaw = u, pako.gzip = p, pako.Inflate = t, pako.inflate = l, pako.inflateRaw = m, pako.ungzip = b, pako.constants = k, pako;
}
var base_pb = {}, payload_pb = {}, transaction_pb = {}, bch_transaction_pb = {}, btc_transaction_pb = {}, hasRequiredBtc_transaction_pb;
function requireBtc_transaction_pb() {
  if (hasRequiredBtc_transaction_pb) return btc_transaction_pb;
  hasRequiredBtc_transaction_pb = 1, Object.defineProperty(btc_transaction_pb, "__esModule", { value: !0 }), btc_transaction_pb.Output = btc_transaction_pb.utxo = btc_transaction_pb.Input = btc_transaction_pb.Omni = btc_transaction_pb.BtcTx = void 0;
  const s = /* @__PURE__ */ requireCjs$3();
  class A extends s.Message {
    constructor(b) {
      super(), this.fee = s.protoInt64.zero, this.dustThreshold = 0, this.memo = "", this.inputs = [], this.outputs = [], s.proto3.util.initPartial(b, this);
    }
    static fromBinary(b, k) {
      return new A().fromBinary(b, k);
    }
    static fromJson(b, k) {
      return new A().fromJson(b, k);
    }
    static fromJsonString(b, k) {
      return new A().fromJsonString(b, k);
    }
    static equals(b, k) {
      return s.proto3.util.equals(A, b, k);
    }
  }
  A.runtime = s.proto3, A.typeName = "protoc.BtcTx", A.fields = s.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "fee",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 2,
      name: "dustThreshold",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 3,
      name: "memo",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 4, name: "inputs", kind: "message", T: p, repeated: !0 },
    { no: 5, name: "outputs", kind: "message", T: l, repeated: !0 },
    { no: 6, name: "omni", kind: "message", T: u }
  ]), btc_transaction_pb.BtcTx = A;
  class u extends s.Message {
    constructor(b) {
      super(), this.to = "", this.changeAddress = "", this.omniAmount = s.protoInt64.zero, this.propertyId = 0, s.proto3.util.initPartial(b, this);
    }
    static fromBinary(b, k) {
      return new u().fromBinary(b, k);
    }
    static fromJson(b, k) {
      return new u().fromJson(b, k);
    }
    static fromJsonString(b, k) {
      return new u().fromJsonString(b, k);
    }
    static equals(b, k) {
      return s.proto3.util.equals(u, b, k);
    }
  }
  u.runtime = s.proto3, u.typeName = "protoc.Omni", u.fields = s.proto3.util.newFieldList(() => [
    {
      no: 5,
      name: "to",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 6,
      name: "changeAddress",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 7,
      name: "omniAmount",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 8,
      name: "propertyId",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    }
  ]), btc_transaction_pb.Omni = u;
  class p extends s.Message {
    constructor(b) {
      super(), this.hash = "", this.index = 0, this.ownerKeyPath = "", s.proto3.util.initPartial(b, this);
    }
    static fromBinary(b, k) {
      return new p().fromBinary(b, k);
    }
    static fromJson(b, k) {
      return new p().fromJson(b, k);
    }
    static fromJsonString(b, k) {
      return new p().fromJsonString(b, k);
    }
    static equals(b, k) {
      return s.proto3.util.equals(p, b, k);
    }
  }
  p.runtime = s.proto3, p.typeName = "protoc.Input", p.fields = s.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "hash",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "index",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    { no: 3, name: "utxo", kind: "message", T: t },
    {
      no: 4,
      name: "ownerKeyPath",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]), btc_transaction_pb.Input = p;
  class t extends s.Message {
    constructor(b) {
      super(), this.publicKey = "", this.script = "", this.value = s.protoInt64.zero, s.proto3.util.initPartial(b, this);
    }
    static fromBinary(b, k) {
      return new t().fromBinary(b, k);
    }
    static fromJson(b, k) {
      return new t().fromJson(b, k);
    }
    static fromJsonString(b, k) {
      return new t().fromJsonString(b, k);
    }
    static equals(b, k) {
      return s.proto3.util.equals(t, b, k);
    }
  }
  t.runtime = s.proto3, t.typeName = "protoc.utxo", t.fields = s.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "publicKey",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "script",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "value",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    }
  ]), btc_transaction_pb.utxo = t;
  class l extends s.Message {
    constructor(b) {
      super(), this.address = "", this.value = s.protoInt64.zero, this.isChange = !1, this.changeAddressPath = "", s.proto3.util.initPartial(b, this);
    }
    static fromBinary(b, k) {
      return new l().fromBinary(b, k);
    }
    static fromJson(b, k) {
      return new l().fromJson(b, k);
    }
    static fromJsonString(b, k) {
      return new l().fromJsonString(b, k);
    }
    static equals(b, k) {
      return s.proto3.util.equals(l, b, k);
    }
  }
  return l.runtime = s.proto3, l.typeName = "protoc.Output", l.fields = s.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "address",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "value",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 3,
      name: "isChange",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 4,
      name: "changeAddressPath",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]), btc_transaction_pb.Output = l, btc_transaction_pb;
}
var hasRequiredBch_transaction_pb;
function requireBch_transaction_pb() {
  if (hasRequiredBch_transaction_pb) return bch_transaction_pb;
  hasRequiredBch_transaction_pb = 1, Object.defineProperty(bch_transaction_pb, "__esModule", { value: !0 }), bch_transaction_pb.BchTx_Input = bch_transaction_pb.BchTx = void 0;
  const s = /* @__PURE__ */ requireCjs$3(), A = requireBtc_transaction_pb();
  class u extends s.Message {
    constructor(l) {
      super(), this.fee = s.protoInt64.zero, this.dustThreshold = 0, this.memo = "", this.inputs = [], this.outputs = [], s.proto3.util.initPartial(l, this);
    }
    static fromBinary(l, m) {
      return new u().fromBinary(l, m);
    }
    static fromJson(l, m) {
      return new u().fromJson(l, m);
    }
    static fromJsonString(l, m) {
      return new u().fromJsonString(l, m);
    }
    static equals(l, m) {
      return s.proto3.util.equals(u, l, m);
    }
  }
  u.runtime = s.proto3, u.typeName = "protoc.BchTx", u.fields = s.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "fee",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 2,
      name: "dustThreshold",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 3,
      name: "memo",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 4, name: "inputs", kind: "message", T: p, repeated: !0 },
    { no: 5, name: "outputs", kind: "message", T: A.Output, repeated: !0 }
  ]), bch_transaction_pb.BchTx = u;
  class p extends s.Message {
    constructor(l) {
      super(), this.hash = "", this.index = 0, this.value = s.protoInt64.zero, this.pubkey = "", this.ownerKeyPath = "", s.proto3.util.initPartial(l, this);
    }
    static fromBinary(l, m) {
      return new p().fromBinary(l, m);
    }
    static fromJson(l, m) {
      return new p().fromJson(l, m);
    }
    static fromJsonString(l, m) {
      return new p().fromJsonString(l, m);
    }
    static equals(l, m) {
      return s.proto3.util.equals(p, l, m);
    }
  }
  return p.runtime = s.proto3, p.typeName = "protoc.BchTx.Input", p.fields = s.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "hash",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "index",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 3,
      name: "value",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 4,
      name: "pubkey",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 5,
      name: "ownerKeyPath",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]), bch_transaction_pb.BchTx_Input = p, bch_transaction_pb;
}
var dash_transaction_pb = {}, hasRequiredDash_transaction_pb;
function requireDash_transaction_pb() {
  if (hasRequiredDash_transaction_pb) return dash_transaction_pb;
  hasRequiredDash_transaction_pb = 1, Object.defineProperty(dash_transaction_pb, "__esModule", { value: !0 }), dash_transaction_pb.DashTx_Input = dash_transaction_pb.DashTx = void 0;
  const s = /* @__PURE__ */ requireCjs$3(), A = requireBtc_transaction_pb();
  class u extends s.Message {
    constructor(l) {
      super(), this.fee = s.protoInt64.zero, this.dustThreshold = 0, this.memo = "", this.inputs = [], this.outputs = [], s.proto3.util.initPartial(l, this);
    }
    static fromBinary(l, m) {
      return new u().fromBinary(l, m);
    }
    static fromJson(l, m) {
      return new u().fromJson(l, m);
    }
    static fromJsonString(l, m) {
      return new u().fromJsonString(l, m);
    }
    static equals(l, m) {
      return s.proto3.util.equals(u, l, m);
    }
  }
  u.runtime = s.proto3, u.typeName = "protoc.DashTx", u.fields = s.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "fee",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 2,
      name: "dustThreshold",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 3,
      name: "memo",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 4, name: "inputs", kind: "message", T: p, repeated: !0 },
    { no: 5, name: "outputs", kind: "message", T: A.Output, repeated: !0 }
  ]), dash_transaction_pb.DashTx = u;
  class p extends s.Message {
    constructor(l) {
      super(), this.hash = "", this.index = 0, this.value = s.protoInt64.zero, this.pubkey = "", this.ownerKeyPath = "", s.proto3.util.initPartial(l, this);
    }
    static fromBinary(l, m) {
      return new p().fromBinary(l, m);
    }
    static fromJson(l, m) {
      return new p().fromJson(l, m);
    }
    static fromJsonString(l, m) {
      return new p().fromJsonString(l, m);
    }
    static equals(l, m) {
      return s.proto3.util.equals(p, l, m);
    }
  }
  return p.runtime = s.proto3, p.typeName = "protoc.DashTx.Input", p.fields = s.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "hash",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "index",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 3,
      name: "value",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 4,
      name: "pubkey",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 5,
      name: "ownerKeyPath",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]), dash_transaction_pb.DashTx_Input = p, dash_transaction_pb;
}
var ltc_transaction_pb = {}, hasRequiredLtc_transaction_pb;
function requireLtc_transaction_pb() {
  if (hasRequiredLtc_transaction_pb) return ltc_transaction_pb;
  hasRequiredLtc_transaction_pb = 1, Object.defineProperty(ltc_transaction_pb, "__esModule", { value: !0 }), ltc_transaction_pb.LtcTx = void 0;
  const s = /* @__PURE__ */ requireCjs$3(), A = requireBtc_transaction_pb();
  class u extends s.Message {
    constructor(t) {
      super(), this.fee = s.protoInt64.zero, this.dustThreshold = 0, this.memo = "", this.inputs = [], this.outputs = [], s.proto3.util.initPartial(t, this);
    }
    static fromBinary(t, l) {
      return new u().fromBinary(t, l);
    }
    static fromJson(t, l) {
      return new u().fromJson(t, l);
    }
    static fromJsonString(t, l) {
      return new u().fromJsonString(t, l);
    }
    static equals(t, l) {
      return s.proto3.util.equals(u, t, l);
    }
  }
  return u.runtime = s.proto3, u.typeName = "protoc.LtcTx", u.fields = s.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "fee",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 2,
      name: "dustThreshold",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 3,
      name: "memo",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 4, name: "inputs", kind: "message", T: A.Input, repeated: !0 },
    { no: 5, name: "outputs", kind: "message", T: A.Output, repeated: !0 }
  ]), ltc_transaction_pb.LtcTx = u, ltc_transaction_pb;
}
var hasRequiredTransaction_pb;
function requireTransaction_pb() {
  if (hasRequiredTransaction_pb) return transaction_pb;
  hasRequiredTransaction_pb = 1, Object.defineProperty(transaction_pb, "__esModule", { value: !0 }), transaction_pb.SignTransaction = void 0;
  const s = /* @__PURE__ */ requireCjs$3(), A = requireTron_transaction_pb(), u = requireBch_transaction_pb(), p = requireDash_transaction_pb(), t = requireLtc_transaction_pb();
  class l extends s.Message {
    constructor(b) {
      super(), this.coinCode = "", this.signId = "", this.hdPath = "", this.timestamp = s.protoInt64.zero, this.decimal = 0, this.Transaction = { case: void 0 }, s.proto3.util.initPartial(b, this);
    }
    static fromBinary(b, k) {
      return new l().fromBinary(b, k);
    }
    static fromJson(b, k) {
      return new l().fromJson(b, k);
    }
    static fromJsonString(b, k) {
      return new l().fromJsonString(b, k);
    }
    static equals(b, k) {
      return s.proto3.util.equals(l, b, k);
    }
  }
  return l.runtime = s.proto3, l.typeName = "protoc.SignTransaction", l.fields = s.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "coinCode",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "signId",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "hdPath",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "timestamp",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 5,
      name: "decimal",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    { no: 8, name: "tronTx", kind: "message", T: A.TronTx, oneof: "Transaction" },
    { no: 10, name: "bchTx", kind: "message", T: u.BchTx, oneof: "Transaction" },
    { no: 11, name: "dashTx", kind: "message", T: p.DashTx, oneof: "Transaction" },
    { no: 12, name: "ltcTx", kind: "message", T: t.LtcTx, oneof: "Transaction" }
  ]), transaction_pb.SignTransaction = l, transaction_pb;
}
var sign_transaction_result_pb = {}, hasRequiredSign_transaction_result_pb;
function requireSign_transaction_result_pb() {
  if (hasRequiredSign_transaction_result_pb) return sign_transaction_result_pb;
  hasRequiredSign_transaction_result_pb = 1, Object.defineProperty(sign_transaction_result_pb, "__esModule", { value: !0 }), sign_transaction_result_pb.SignTransactionResult = void 0;
  const s = /* @__PURE__ */ requireCjs$3();
  class A extends s.Message {
    constructor(p) {
      super(), this.signId = "", this.txId = "", this.rawTx = "", s.proto3.util.initPartial(p, this);
    }
    static fromBinary(p, t) {
      return new A().fromBinary(p, t);
    }
    static fromJson(p, t) {
      return new A().fromJson(p, t);
    }
    static fromJsonString(p, t) {
      return new A().fromJsonString(p, t);
    }
    static equals(p, t) {
      return s.proto3.util.equals(A, p, t);
    }
  }
  return A.runtime = s.proto3, A.typeName = "protoc.SignTransactionResult", A.fields = s.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "signId",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "txId",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "rawTx",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]), sign_transaction_result_pb.SignTransactionResult = A, sign_transaction_result_pb;
}
var hasRequiredPayload_pb;
function requirePayload_pb() {
  return hasRequiredPayload_pb || (hasRequiredPayload_pb = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.Payload_Type = s.Payload = void 0;
    const A = /* @__PURE__ */ requireCjs$3(), u = requireTransaction_pb(), p = requireSign_transaction_result_pb();
    class t extends A.Message {
      constructor(b) {
        super(), this.type = l.RESERVE, this.xfp = "", this.Content = { case: void 0 }, A.proto3.util.initPartial(b, this);
      }
      static fromBinary(b, k) {
        return new t().fromBinary(b, k);
      }
      static fromJson(b, k) {
        return new t().fromJson(b, k);
      }
      static fromJsonString(b, k) {
        return new t().fromJsonString(b, k);
      }
      static equals(b, k) {
        return A.proto3.util.equals(t, b, k);
      }
    }
    t.runtime = A.proto3, t.typeName = "protoc.Payload", t.fields = A.proto3.util.newFieldList(() => [
      { no: 1, name: "type", kind: "enum", T: A.proto3.getEnumType(l) },
      {
        no: 2,
        name: "xfp",
        kind: "scalar",
        T: 9
        /* ScalarType.STRING */
      },
      { no: 4, name: "signTx", kind: "message", T: u.SignTransaction, oneof: "Content" },
      { no: 7, name: "signTxResult", kind: "message", T: p.SignTransactionResult, oneof: "Content" }
    ]), s.Payload = t;
    var l;
    (function(m) {
      m[m.RESERVE = 0] = "RESERVE", m[m.SYNC = 1] = "SYNC", m[m.SIGN_TX = 2] = "SIGN_TX", m[m.SIGN_MSG = 3] = "SIGN_MSG", m[m.SIGN_MULTI_SIG = 4] = "SIGN_MULTI_SIG", m[m.SYNC_MULTI_SIG_MSG = 5] = "SYNC_MULTI_SIG_MSG", m[m.SIGN_ETH_MULTI_SIG_MSG = 6] = "SIGN_ETH_MULTI_SIG_MSG", m[m.VERIFY_ADDRESS = 7] = "VERIFY_ADDRESS", m[m.STAKING = 8] = "STAKING", m[m.SIGN_TX_RESULT = 9] = "SIGN_TX_RESULT";
    })(l = s.Payload_Type || (s.Payload_Type = {})), A.proto3.util.setEnumType(l, "protoc.Payload.Type", [
      { no: 0, name: "TYPE_RESERVE" },
      { no: 1, name: "TYPE_SYNC" },
      { no: 2, name: "TYPE_SIGN_TX" },
      { no: 3, name: "TYPE_SIGN_MSG" },
      { no: 4, name: "TYPE_SIGN_MULTI_SIG" },
      { no: 5, name: "TYPE_SYNC_MULTI_SIG_MSG" },
      { no: 6, name: "TYPE_SIGN_ETH_MULTI_SIG_MSG" },
      { no: 7, name: "TYPE_VERIFY_ADDRESS" },
      { no: 8, name: "TYPE_STAKING" },
      { no: 9, name: "TYPE_SIGN_TX_RESULT" }
    ]);
  }(payload_pb)), payload_pb;
}
var hasRequiredBase_pb;
function requireBase_pb() {
  if (hasRequiredBase_pb) return base_pb;
  hasRequiredBase_pb = 1, Object.defineProperty(base_pb, "__esModule", { value: !0 }), base_pb.Base = void 0;
  const s = /* @__PURE__ */ requireCjs$3(), A = requirePayload_pb();
  class u extends s.Message {
    constructor(t) {
      super(), this.version = 0, this.description = "", this.Content = { case: void 0 }, this.deviceType = "", s.proto3.util.initPartial(t, this);
    }
    static fromBinary(t, l) {
      return new u().fromBinary(t, l);
    }
    static fromJson(t, l) {
      return new u().fromJson(t, l);
    }
    static fromJsonString(t, l) {
      return new u().fromJsonString(t, l);
    }
    static equals(t, l) {
      return s.proto3.util.equals(u, t, l);
    }
  }
  return u.runtime = s.proto3, u.typeName = "protoc.Base", u.fields = s.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "version",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 2,
      name: "description",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "data", kind: "message", T: A.Payload },
    { no: 4, name: "hotVersion", kind: "scalar", T: 5, oneof: "Content" },
    { no: 5, name: "coldVersion", kind: "scalar", T: 5, oneof: "Content" },
    {
      no: 6,
      name: "deviceType",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]), base_pb.Base = u, base_pb;
}
var dist$b = { exports: {} }, bcUrRegistryKeystone_cjs_production_min = {}, hasRequiredBcUrRegistryKeystone_cjs_production_min;
function requireBcUrRegistryKeystone_cjs_production_min() {
  return hasRequiredBcUrRegistryKeystone_cjs_production_min || (hasRequiredBcUrRegistryKeystone_cjs_production_min = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$i();
    const u = { KEYSTONE_SIGN_REQUEST: new A.RegistryType("keystone-sign-request", 6101), KEYSTONE_SIGN_RESULT: new A.RegistryType("keystone-sign-result", 6102) }, { decodeToDataItem: p } = A.extend;
    var t;
    (function(C) {
      C[C.signData = 1] = "signData", C[C.origin = 2] = "origin";
    })(t || (t = {}));
    class l extends A.RegistryItem {
      constructor(B) {
        super(), this.getRegistryType = () => u.KEYSTONE_SIGN_REQUEST, this.getSignData = () => this.signData, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Q = {};
          return Q[t.signData] = this.signData, this.origin && (Q[t.origin] = this.origin), new A.DataItem(Q);
        }, this.signData = B.signData, this.origin = B.origin;
      }
      static constructKeystoneRequest(B, Q) {
        return new l({ signData: B, origin: Q });
      }
    }
    l.fromDataItem = (C) => {
      const B = C.getData();
      return new l({ signData: B[t.signData], origin: B[t.origin] });
    }, l.fromCBOR = (C) => {
      const B = p(C);
      return l.fromDataItem(B);
    };
    const { decodeToDataItem: m } = A.extend;
    var b;
    (function(C) {
      C[C.signResult = 1] = "signResult";
    })(b || (b = {}));
    class k extends A.RegistryItem {
      constructor(B) {
        super(), this.getRegistryType = () => u.KEYSTONE_SIGN_RESULT, this.getSignResult = () => this.signResult, this.toDataItem = () => {
          const Q = {};
          return Q[b.signResult] = this.signResult, new A.DataItem(Q);
        }, this.signResult = B;
      }
    }
    k.fromDataItem = (C) => {
      const B = C.getData();
      return new k(B[b.signResult]);
    }, k.fromCBOR = (C) => {
      const B = m(C);
      return k.fromDataItem(B);
    }, A.patchTags(Object.values(u).filter((C) => !!C.getTag()).map((C) => C.getTag())), Object.keys(A).forEach(function(C) {
      C !== "default" && Object.defineProperty(s, C, { enumerable: !0, get: function() {
        return A[C];
      } });
    }), s.KeystoneSignRequest = l, s.KeystoneSignResult = k;
  }(bcUrRegistryKeystone_cjs_production_min)), bcUrRegistryKeystone_cjs_production_min;
}
var bcUrRegistryKeystone_cjs_development = {}, hasRequiredBcUrRegistryKeystone_cjs_development;
function requireBcUrRegistryKeystone_cjs_development() {
  return hasRequiredBcUrRegistryKeystone_cjs_development || (hasRequiredBcUrRegistryKeystone_cjs_development = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$i();
    const u = {
      KEYSTONE_SIGN_REQUEST: /* @__PURE__ */ new A.RegistryType("keystone-sign-request", 6101),
      KEYSTONE_SIGN_RESULT: /* @__PURE__ */ new A.RegistryType("keystone-sign-result", 6102)
    }, {
      decodeToDataItem: p
    } = A.extend;
    var t;
    (function(C) {
      C[C.signData = 1] = "signData", C[C.origin = 2] = "origin";
    })(t || (t = {}));
    class l extends A.RegistryItem {
      constructor(B) {
        super(), this.getRegistryType = () => u.KEYSTONE_SIGN_REQUEST, this.getSignData = () => this.signData, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Q = {};
          return Q[t.signData] = this.signData, this.origin && (Q[t.origin] = this.origin), new A.DataItem(Q);
        }, this.signData = B.signData, this.origin = B.origin;
      }
      static constructKeystoneRequest(B, Q) {
        return new l({
          signData: B,
          origin: Q
        });
      }
    }
    l.fromDataItem = (C) => {
      const B = C.getData();
      return new l({
        signData: B[t.signData],
        origin: B[t.origin]
      });
    }, l.fromCBOR = (C) => {
      const B = p(C);
      return l.fromDataItem(B);
    };
    const {
      decodeToDataItem: m
    } = A.extend;
    var b;
    (function(C) {
      C[C.signResult = 1] = "signResult";
    })(b || (b = {}));
    class k extends A.RegistryItem {
      constructor(B) {
        super(), this.getRegistryType = () => u.KEYSTONE_SIGN_RESULT, this.getSignResult = () => this.signResult, this.toDataItem = () => {
          const Q = {};
          return Q[b.signResult] = this.signResult, new A.DataItem(Q);
        }, this.signResult = B;
      }
    }
    k.fromDataItem = (C) => {
      const Q = C.getData()[b.signResult];
      return new k(Q);
    }, k.fromCBOR = (C) => {
      const B = m(C);
      return k.fromDataItem(B);
    }, A.patchTags(Object.values(u).filter((C) => !!C.getTag()).map((C) => C.getTag())), Object.keys(A).forEach(function(C) {
      C !== "default" && Object.defineProperty(s, C, {
        enumerable: !0,
        get: function() {
          return A[C];
        }
      });
    }), s.KeystoneSignRequest = l, s.KeystoneSignResult = k;
  }(bcUrRegistryKeystone_cjs_development)), bcUrRegistryKeystone_cjs_development;
}
var hasRequiredDist$c;
function requireDist$c() {
  return hasRequiredDist$c || (hasRequiredDist$c = 1, process$1.env.NODE_ENV === "production" ? dist$b.exports = requireBcUrRegistryKeystone_cjs_production_min() : dist$b.exports = requireBcUrRegistryKeystone_cjs_development()), dist$b.exports;
}
var hasRequiredTron;
function requireTron() {
  if (hasRequiredTron) return tron;
  hasRequiredTron = 1;
  var s = tron && tron.__importDefault || function(B) {
    return B && B.__esModule ? B : { default: B };
  };
  Object.defineProperty(tron, "__esModule", { value: !0 }), tron.KeystoneTronSDK = void 0;
  const A = requireUtils$d(), u = requireUr(), p = requireTransfer(), t = s(requirePako()), l = requireBase_pb(), m = requirePayload_pb(), b = requireTransaction_pb(), k = requireDist$c();
  class C {
    parseSignature(Q) {
      var P, x, M, F;
      if (Q.type !== u.URType.KeystoneSignResult)
        throw new Error("type not match");
      const le = k.KeystoneSignResult.fromCBOR(Q.cbor), ge = l.Base.fromBinary(t.default.ungzip(le.getSignResult()));
      if (((P = ge.data) === null || P === void 0 ? void 0 : P.Content.case) !== "signTxResult")
        throw new Error("invalid sign result");
      const { signId: pe, rawTx: Ie } = (F = (M = (x = ge.data) === null || x === void 0 ? void 0 : x.Content) === null || M === void 0 ? void 0 : M.value) !== null && F !== void 0 ? F : {};
      return {
        requestId: pe,
        raw: Ie
      };
    }
    generateSignRequest({ requestId: Q, signData: P, path: x, xfp: M, tokenInfo: F, origin: le }) {
      const ge = (0, p.raw2tx)((0, A.toBuffer)(P), F), pe = t.default.gzip(new l.Base({
        version: 2,
        description: "QrCode Protocol",
        deviceType: "",
        data: new m.Payload({
          xfp: M,
          type: m.Payload_Type.SIGN_TX,
          Content: {
            case: "signTx",
            value: new b.SignTransaction({
              coinCode: "TRON",
              hdPath: x,
              signId: Q,
              timestamp: BigInt(Date.now()),
              decimal: 6,
              Transaction: {
                case: "tronTx",
                value: ge
              }
            })
          }
        })
      }).toBinary());
      return new k.KeystoneSignRequest({
        signData: Buffer.from(pe),
        origin: le
      }).toUR();
    }
  }
  return tron.KeystoneTronSDK = C, tron;
}
var aptos = {}, dist$a = { exports: {} }, bcUrRegistryAptos_cjs_production_min = {}, hasRequiredBcUrRegistryAptos_cjs_production_min;
function requireBcUrRegistryAptos_cjs_production_min() {
  return hasRequiredBcUrRegistryAptos_cjs_production_min || (hasRequiredBcUrRegistryAptos_cjs_production_min = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$i(), u = require$$1$2;
    const p = { APTOS_SIGN_REQUEST: new A.RegistryType("aptos-sign-request", 3101), APTOS_SIGNATURE: new A.RegistryType("aptos-signature", 3102) }, { decodeToDataItem: t, RegistryTypes: l } = A.extend;
    var m, b;
    (m = s.SignType || (s.SignType = {}))[m.SingleSign = 1] = "SingleSign", m[m.MultiSign = 2] = "MultiSign", m[m.SignMessage = 3] = "SignMessage", function(x) {
      x[x.requestId = 1] = "requestId", x[x.signData = 2] = "signData", x[x.authenticationKeyDerivationPaths = 3] = "authenticationKeyDerivationPaths", x[x.accounts = 4] = "accounts", x[x.origin = 5] = "origin", x[x.signType = 6] = "signType";
    }(b || (b = {}));
    class k extends A.RegistryItem {
      constructor(M) {
        super(), this.getRegistryType = () => p.APTOS_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getAuthenticationKeyDerivationPaths = () => this.authenticationKeyDerivationPaths.map((F) => F.getPath()), this.getSignRequestAccounts = () => this.accounts, this.getOrigin = () => this.origin, this.getSignType = () => this.signType, this.toDataItem = () => {
          const F = {};
          return F[b.requestId] = new A.DataItem(this.requestId, l.UUID.getTag()), this.accounts && (F[b.accounts] = this.accounts), this.origin && (F[b.origin] = this.origin), F[b.signData] = this.signData, F[b.signType] = this.signType, F[b.authenticationKeyDerivationPaths] = this.authenticationKeyDerivationPaths.map((le) => {
            const ge = le.toDataItem();
            return ge.setTag(le.getRegistryType().getTag()), ge;
          }), new A.DataItem(F);
        }, this.requestId = M.requestId, this.signData = M.signData, this.authenticationKeyDerivationPaths = M.authenticationKeyDerivationPaths, this.accounts = M.accounts, this.origin = M.origin, this.signType = M.signType;
      }
      static constructAptosRequest(M, F, le, ge, pe, Ie, be) {
        const Pe = F.map((Te, Qe) => {
          const xe = Te.replace(/[m|M]\//, "").split("/").map((Ee) => {
            const He = parseInt(Ee.replace("'", ""));
            let ve = !1;
            return Ee.endsWith("'") && (ve = !0), new A.PathComponent({ index: He, hardened: ve });
          });
          return new A.CryptoKeypath(xe, Buffer.from(le[Qe], "hex"));
        });
        return new k({ requestId: Buffer.from(u.parse(pe)), signData: M, authenticationKeyDerivationPaths: Pe, accounts: Ie || void 0, origin: be || void 0, signType: ge || s.SignType.SingleSign });
      }
    }
    k.fromDataItem = (x) => {
      const M = x.getData(), F = M[b.signData], le = M[b.signType], ge = M[b.authenticationKeyDerivationPaths].map((be) => A.CryptoKeypath.fromDataItem(be)), pe = M[b.accounts] ? M[b.accounts] : void 0, Ie = M[b.requestId] ? M[b.requestId].getData() : void 0;
      return new k({ requestId: Ie, signData: F, authenticationKeyDerivationPaths: ge, accounts: pe, origin: M[b.origin] ? M[b.origin] : void 0, signType: le });
    }, k.fromCBOR = (x) => {
      const M = t(x);
      return k.fromDataItem(M);
    };
    const { RegistryTypes: C, decodeToDataItem: B } = A.extend;
    var Q;
    (function(x) {
      x[x.requestId = 1] = "requestId", x[x.signature = 2] = "signature", x[x.authenticationPublicKey = 3] = "authenticationPublicKey";
    })(Q || (Q = {}));
    class P extends A.RegistryItem {
      constructor(M, F, le) {
        super(), this.getRegistryType = () => p.APTOS_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getAuthenticationPublicKey = () => this.authenticationPublicKey, this.toDataItem = () => {
          const ge = {};
          return ge[Q.requestId] = new A.DataItem(this.requestId, C.UUID.getTag()), ge[Q.signature] = this.signature, ge[Q.authenticationPublicKey] = this.authenticationPublicKey, new A.DataItem(ge);
        }, this.signature = M, this.requestId = F, this.authenticationPublicKey = le;
      }
    }
    P.fromDataItem = (x) => {
      const M = x.getData(), F = M[Q.signature], le = M[Q.requestId].getData();
      return new P(F, le, M[Q.authenticationPublicKey]);
    }, P.fromCBOR = (x) => {
      const M = B(x);
      return P.fromDataItem(M);
    }, A.patchTags(Object.values(p).filter((x) => !!x.getTag()).map((x) => x.getTag())), Object.keys(A).forEach(function(x) {
      x !== "default" && Object.defineProperty(s, x, { enumerable: !0, get: function() {
        return A[x];
      } });
    }), s.AptosSignRequest = k, s.AptosSignature = P;
  }(bcUrRegistryAptos_cjs_production_min)), bcUrRegistryAptos_cjs_production_min;
}
var bcUrRegistryAptos_cjs_development = {}, hasRequiredBcUrRegistryAptos_cjs_development;
function requireBcUrRegistryAptos_cjs_development() {
  return hasRequiredBcUrRegistryAptos_cjs_development || (hasRequiredBcUrRegistryAptos_cjs_development = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$i(), u = require$$1$2;
    const p = {
      APTOS_SIGN_REQUEST: /* @__PURE__ */ new A.RegistryType("aptos-sign-request", 3101),
      APTOS_SIGNATURE: /* @__PURE__ */ new A.RegistryType("aptos-signature", 3102)
    }, {
      decodeToDataItem: t,
      RegistryTypes: l
    } = A.extend;
    (function(P) {
      P[P.SingleSign = 1] = "SingleSign", P[P.MultiSign = 2] = "MultiSign", P[P.SignMessage = 3] = "SignMessage";
    })(s.SignType || (s.SignType = {}));
    var m;
    (function(P) {
      P[P.requestId = 1] = "requestId", P[P.signData = 2] = "signData", P[P.authenticationKeyDerivationPaths = 3] = "authenticationKeyDerivationPaths", P[P.accounts = 4] = "accounts", P[P.origin = 5] = "origin", P[P.signType = 6] = "signType";
    })(m || (m = {}));
    class b extends A.RegistryItem {
      constructor(x) {
        super(), this.getRegistryType = () => p.APTOS_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getAuthenticationKeyDerivationPaths = () => this.authenticationKeyDerivationPaths.map((M) => M.getPath()), this.getSignRequestAccounts = () => this.accounts, this.getOrigin = () => this.origin, this.getSignType = () => this.signType, this.toDataItem = () => {
          const M = {};
          return M[m.requestId] = new A.DataItem(this.requestId, l.UUID.getTag()), this.accounts && (M[m.accounts] = this.accounts), this.origin && (M[m.origin] = this.origin), M[m.signData] = this.signData, M[m.signType] = this.signType, M[m.authenticationKeyDerivationPaths] = this.authenticationKeyDerivationPaths.map((F) => {
            const le = F.toDataItem();
            return le.setTag(F.getRegistryType().getTag()), le;
          }), new A.DataItem(M);
        }, this.requestId = x.requestId, this.signData = x.signData, this.authenticationKeyDerivationPaths = x.authenticationKeyDerivationPaths, this.accounts = x.accounts, this.origin = x.origin, this.signType = x.signType;
      }
      static constructAptosRequest(x, M, F, le, ge, pe, Ie) {
        const be = M.map((Pe, Te) => {
          const xe = Pe.replace(/[m|M]\//, "").split("/").map((Ee) => {
            const He = parseInt(Ee.replace("'", ""));
            let ve = !1;
            return Ee.endsWith("'") && (ve = !0), new A.PathComponent({
              index: He,
              hardened: ve
            });
          });
          return new A.CryptoKeypath(xe, Buffer.from(F[Te], "hex"));
        });
        return new b({
          requestId: Buffer.from(u.parse(ge)),
          signData: x,
          authenticationKeyDerivationPaths: be,
          accounts: pe || void 0,
          origin: Ie || void 0,
          signType: le || s.SignType.SingleSign
        });
      }
    }
    b.fromDataItem = (P) => {
      const x = P.getData(), M = x[m.signData], F = x[m.signType], le = x[m.authenticationKeyDerivationPaths].map((be) => A.CryptoKeypath.fromDataItem(be)), ge = x[m.accounts] ? x[m.accounts] : void 0, pe = x[m.requestId] ? x[m.requestId].getData() : void 0, Ie = x[m.origin] ? x[m.origin] : void 0;
      return new b({
        requestId: pe,
        signData: M,
        authenticationKeyDerivationPaths: le,
        accounts: ge,
        origin: Ie,
        signType: F
      });
    }, b.fromCBOR = (P) => {
      const x = t(P);
      return b.fromDataItem(x);
    };
    const {
      RegistryTypes: k,
      decodeToDataItem: C
    } = A.extend;
    var B;
    (function(P) {
      P[P.requestId = 1] = "requestId", P[P.signature = 2] = "signature", P[P.authenticationPublicKey = 3] = "authenticationPublicKey";
    })(B || (B = {}));
    class Q extends A.RegistryItem {
      constructor(x, M, F) {
        super(), this.getRegistryType = () => p.APTOS_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getAuthenticationPublicKey = () => this.authenticationPublicKey, this.toDataItem = () => {
          const le = {};
          return le[B.requestId] = new A.DataItem(this.requestId, k.UUID.getTag()), le[B.signature] = this.signature, le[B.authenticationPublicKey] = this.authenticationPublicKey, new A.DataItem(le);
        }, this.signature = x, this.requestId = M, this.authenticationPublicKey = F;
      }
    }
    Q.fromDataItem = (P) => {
      const x = P.getData(), M = x[B.signature], F = x[B.requestId].getData(), le = x[B.authenticationPublicKey];
      return new Q(M, F, le);
    }, Q.fromCBOR = (P) => {
      const x = C(P);
      return Q.fromDataItem(x);
    }, A.patchTags(Object.values(p).filter((P) => !!P.getTag()).map((P) => P.getTag())), Object.keys(A).forEach(function(P) {
      P !== "default" && Object.defineProperty(s, P, {
        enumerable: !0,
        get: function() {
          return A[P];
        }
      });
    }), s.AptosSignRequest = b, s.AptosSignature = Q;
  }(bcUrRegistryAptos_cjs_development)), bcUrRegistryAptos_cjs_development;
}
var hasRequiredDist$b;
function requireDist$b() {
  return hasRequiredDist$b || (hasRequiredDist$b = 1, process$1.env.NODE_ENV === "production" ? dist$a.exports = requireBcUrRegistryAptos_cjs_production_min() : dist$a.exports = requireBcUrRegistryAptos_cjs_development()), dist$a.exports;
}
var hasRequiredAptos;
function requireAptos() {
  if (hasRequiredAptos) return aptos;
  hasRequiredAptos = 1, Object.defineProperty(aptos, "__esModule", { value: !0 }), aptos.KeystoneAptosSDK = void 0;
  const s = requireDist$b(), A = requireUtils$d(), u = requireUr();
  class p {
    parseSignature(l) {
      if (l.type !== u.URType.AptosSignature)
        throw new Error("type not match");
      const m = s.AptosSignature.fromCBOR(l.cbor);
      return {
        requestId: (0, A.uuidStringify)(m.getRequestId()),
        signature: (0, A.toHex)(m.getSignature()),
        authenticationPublicKey: (0, A.toHex)(m.getAuthenticationPublicKey())
      };
    }
    generateSignRequest({ requestId: l, signData: m, signType: b, accounts: k, origin: C }) {
      const B = [], Q = [];
      if (k.forEach((P) => {
        B.push(new s.CryptoKeypath((0, A.parsePath)(P.path).map((x) => new s.PathComponent(x)), (0, A.toBuffer)(P.xfp))), P.key !== void 0 && Q.push((0, A.toBuffer)(P.key));
      }), Q.length > 0 && Q.length !== B.length)
        throw new Error("account and path count must match");
      return new s.AptosSignRequest({
        requestId: (0, A.uuidParse)(l),
        signData: (0, A.toBuffer)(m),
        signType: b,
        authenticationKeyDerivationPaths: B,
        accounts: Q,
        origin: C
      }).toUR();
    }
  }
  return p.SignType = s.SignType, aptos.KeystoneAptosSDK = p, aptos;
}
var bitcoin_cash = {}, keystone = {}, hasRequiredKeystone;
function requireKeystone() {
  return hasRequiredKeystone || (hasRequiredKeystone = 1, function(s) {
    var A = keystone && keystone.__importDefault || function(M) {
      return M && M.__esModule ? M : { default: M };
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), s.Keystone = s.TXCase = s.Chain = void 0;
    const u = A(requirePako()), p = requireUr(), t = requireDist$c(), l = requireBase_pb(), m = requirePayload_pb(), b = requireTransaction_pb(), k = requireLtc_transaction_pb(), C = requireBch_transaction_pb(), B = requireDash_transaction_pb();
    var Q;
    (function(M) {
      M.LTC = "LTC", M.BCH = "BCH", M.DASH = "DASH";
    })(Q = s.Chain || (s.Chain = {}));
    var P;
    (function(M) {
      M.LTC = "ltcTx", M.BCH = "bchTx", M.DASH = "dashTx";
    })(P = s.TXCase || (s.TXCase = {}));
    class x {
      generateSignData({ chain: F, requestId: le, signData: ge, xfp: pe }) {
        let Ie, be, Pe;
        switch (F) {
          case Q.LTC:
            Ie = new k.LtcTx(Object.assign(Object.assign({}, ge), { fee: BigInt(ge.fee), dustThreshold: 5460 })), Pe = Q.LTC, be = P.LTC;
            break;
          case Q.BCH:
            Ie = new C.BchTx(Object.assign(Object.assign({}, ge), { fee: BigInt(ge.fee), dustThreshold: 546 })), Pe = Q.BCH, be = P.BCH;
            break;
          case Q.DASH:
            Ie = new B.DashTx(Object.assign(Object.assign({}, ge), { fee: BigInt(ge.fee), dustThreshold: 546 })), Pe = Q.DASH, be = P.DASH;
            break;
          default:
            throw new Error("chain not support");
        }
        return u.default.gzip(new l.Base({
          version: 2,
          description: "QrCode Protocol",
          deviceType: "",
          data: new m.Payload({
            xfp: pe,
            type: m.Payload_Type.SIGN_TX,
            Content: {
              case: "signTx",
              value: new b.SignTransaction({
                coinCode: Pe,
                hdPath: "",
                signId: le,
                timestamp: BigInt(Date.now()),
                decimal: 8,
                Transaction: {
                  case: be,
                  value: Ie
                }
              })
            }
          })
        }).toBinary());
      }
      generateSignRequest(F) {
        const le = Buffer.from(this.generateSignData(F));
        return new t.KeystoneSignRequest({
          signData: le,
          origin: F.origin
        }).toUR();
      }
      parseSignResult(F) {
        var le, ge;
        if (F.type !== p.URType.KeystoneSignResult)
          throw new Error("type not match");
        const pe = t.KeystoneSignResult.fromCBOR(F.cbor), Ie = l.Base.fromBinary(u.default.ungzip(pe.getSignResult()));
        if (((le = Ie.data) === null || le === void 0 ? void 0 : le.Content.case) !== "signTxResult")
          throw new Error("invalid sign result");
        const be = (ge = Ie.data) === null || ge === void 0 ? void 0 : ge.Content.value;
        return {
          requestId: be.signId,
          rawData: be.rawTx
        };
      }
    }
    s.Keystone = x;
  }(keystone)), keystone;
}
var hasRequiredBitcoin_cash;
function requireBitcoin_cash() {
  if (hasRequiredBitcoin_cash) return bitcoin_cash;
  hasRequiredBitcoin_cash = 1, Object.defineProperty(bitcoin_cash, "__esModule", { value: !0 }), bitcoin_cash.KeystoneBitcoinCashSDK = void 0;
  const s = requireKeystone();
  class A extends s.Keystone {
    generateSignRequest(p) {
      return super.generateSignRequest(Object.assign({ chain: s.Chain.BCH }, p));
    }
  }
  return bitcoin_cash.KeystoneBitcoinCashSDK = A, bitcoin_cash;
}
var dash = {}, hasRequiredDash;
function requireDash() {
  if (hasRequiredDash) return dash;
  hasRequiredDash = 1, Object.defineProperty(dash, "__esModule", { value: !0 }), dash.KeystoneDashSDK = void 0;
  const s = requireKeystone();
  class A extends s.Keystone {
    generateSignRequest(p) {
      return super.generateSignRequest(Object.assign({ chain: s.Chain.DASH }, p));
    }
  }
  return dash.KeystoneDashSDK = A, dash;
}
var litecoin = {}, hasRequiredLitecoin;
function requireLitecoin() {
  if (hasRequiredLitecoin) return litecoin;
  hasRequiredLitecoin = 1, Object.defineProperty(litecoin, "__esModule", { value: !0 }), litecoin.KeystoneLitecoinSDK = void 0;
  const s = requireKeystone();
  class A extends s.Keystone {
    generateSignRequest(p) {
      return super.generateSignRequest(Object.assign({ chain: s.Chain.LTC }, p));
    }
  }
  return litecoin.KeystoneLitecoinSDK = A, litecoin;
}
var near = {}, dist$9 = { exports: {} }, bcUrRegistryNear_cjs_production_min = {}, hasRequiredBcUrRegistryNear_cjs_production_min;
function requireBcUrRegistryNear_cjs_production_min() {
  return hasRequiredBcUrRegistryNear_cjs_production_min || (hasRequiredBcUrRegistryNear_cjs_production_min = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$i(), u = require$$1$2;
    const p = { NEAR_SIGN_REQUEST: new A.RegistryType("near-sign-request", 2101), NEAR_SIGNATURE: new A.RegistryType("near-signature", 2102), CRYPTO_MULTI_ACCOUNTS: new A.RegistryType("crypto-multi-accounts", 2103) }, { decodeToDataItem: t, RegistryTypes: l } = A.extend;
    var m;
    (function(P) {
      P[P.requestId = 1] = "requestId", P[P.signData = 2] = "signData", P[P.derivationPath = 3] = "derivationPath", P[P.account = 4] = "account", P[P.origin = 5] = "origin";
    })(m || (m = {}));
    class b extends A.RegistryItem {
      constructor(x) {
        super(), this.getRegistryType = () => p.NEAR_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSignRequestAccount = () => this.account, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const M = {};
          this.requestId && (M[m.requestId] = new A.DataItem(this.requestId, l.UUID.getTag())), this.account && (M[m.account] = this.account), this.origin && (M[m.origin] = this.origin), M[m.signData] = this.signData;
          const F = this.derivationPath.toDataItem();
          return F.setTag(this.derivationPath.getRegistryType().getTag()), M[m.derivationPath] = F, new A.DataItem(M);
        }, this.requestId = x.requestId, this.signData = x.signData, this.derivationPath = x.derivationPath, this.account = x.account, this.origin = x.origin;
      }
      static constructNearRequest(x, M, F, le, ge, pe) {
        const Ie = M.replace(/[m|M]\//, "").split("/"), be = new A.CryptoKeypath(Ie.map((Pe) => {
          const Te = parseInt(Pe.replace("'", ""));
          let Qe = !1;
          return Pe.endsWith("'") && (Qe = !0), new A.PathComponent({ index: Te, hardened: Qe });
        }), Buffer.from(F, "hex"));
        return new b({ requestId: le ? Buffer.from(u.parse(le)) : void 0, signData: x, derivationPath: be, account: ge || void 0, origin: pe || void 0 });
      }
    }
    b.fromDataItem = (P) => {
      const x = P.getData(), M = x[m.signData], F = A.CryptoKeypath.fromDataItem(x[m.derivationPath]), le = x[m.account] ? x[m.account] : void 0, ge = x[m.requestId] ? x[m.requestId].getData() : void 0;
      return new b({ requestId: ge, signData: M, derivationPath: F, account: le, origin: x[m.origin] ? x[m.origin] : void 0 });
    }, b.fromCBOR = (P) => {
      const x = t(P);
      return b.fromDataItem(x);
    };
    const { RegistryTypes: k, decodeToDataItem: C } = A.extend;
    var B;
    (function(P) {
      P[P.requestId = 1] = "requestId", P[P.signature = 2] = "signature";
    })(B || (B = {}));
    class Q extends A.RegistryItem {
      constructor(x, M) {
        super(), this.getRegistryType = () => p.NEAR_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const F = {};
          return this.requestId && (F[B.requestId] = new A.DataItem(this.requestId, k.UUID.getTag())), F[B.signature] = this.signature, new A.DataItem(F);
        }, this.signature = x, this.requestId = M;
      }
    }
    Q.fromDataItem = (P) => {
      const x = P.getData(), M = x[B.signature], F = x[B.requestId] ? x[B.requestId].getData() : void 0;
      return new Q(M, F);
    }, Q.fromCBOR = (P) => {
      const x = C(P);
      return Q.fromDataItem(x);
    }, A.patchTags(Object.values(p).filter((P) => !!P.getTag()).map((P) => P.getTag())), Object.keys(A).forEach(function(P) {
      P !== "default" && Object.defineProperty(s, P, { enumerable: !0, get: function() {
        return A[P];
      } });
    }), s.NearSignRequest = b, s.NearSignature = Q;
  }(bcUrRegistryNear_cjs_production_min)), bcUrRegistryNear_cjs_production_min;
}
var bcUrRegistryNear_cjs_development = {}, hasRequiredBcUrRegistryNear_cjs_development;
function requireBcUrRegistryNear_cjs_development() {
  return hasRequiredBcUrRegistryNear_cjs_development || (hasRequiredBcUrRegistryNear_cjs_development = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$i(), u = require$$1$2;
    const p = {
      NEAR_SIGN_REQUEST: /* @__PURE__ */ new A.RegistryType("near-sign-request", 2101),
      NEAR_SIGNATURE: /* @__PURE__ */ new A.RegistryType("near-signature", 2102),
      CRYPTO_MULTI_ACCOUNTS: /* @__PURE__ */ new A.RegistryType("crypto-multi-accounts", 2103)
    }, {
      decodeToDataItem: t,
      RegistryTypes: l
    } = A.extend;
    var m;
    (function(P) {
      P[P.requestId = 1] = "requestId", P[P.signData = 2] = "signData", P[P.derivationPath = 3] = "derivationPath", P[P.account = 4] = "account", P[P.origin = 5] = "origin";
    })(m || (m = {}));
    class b extends A.RegistryItem {
      constructor(x) {
        super(), this.getRegistryType = () => p.NEAR_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSignRequestAccount = () => this.account, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const M = {};
          this.requestId && (M[m.requestId] = new A.DataItem(this.requestId, l.UUID.getTag())), this.account && (M[m.account] = this.account), this.origin && (M[m.origin] = this.origin), M[m.signData] = this.signData;
          const F = this.derivationPath.toDataItem();
          return F.setTag(this.derivationPath.getRegistryType().getTag()), M[m.derivationPath] = F, new A.DataItem(M);
        }, this.requestId = x.requestId, this.signData = x.signData, this.derivationPath = x.derivationPath, this.account = x.account, this.origin = x.origin;
      }
      static constructNearRequest(x, M, F, le, ge, pe) {
        const Ie = M.replace(/[m|M]\//, "").split("/"), be = new A.CryptoKeypath(Ie.map((Pe) => {
          const Te = parseInt(Pe.replace("'", ""));
          let Qe = !1;
          return Pe.endsWith("'") && (Qe = !0), new A.PathComponent({
            index: Te,
            hardened: Qe
          });
        }), Buffer.from(F, "hex"));
        return new b({
          requestId: le ? Buffer.from(u.parse(le)) : void 0,
          signData: x,
          derivationPath: be,
          account: ge || void 0,
          origin: pe || void 0
        });
      }
    }
    b.fromDataItem = (P) => {
      const x = P.getData(), M = x[m.signData], F = A.CryptoKeypath.fromDataItem(x[m.derivationPath]), le = x[m.account] ? x[m.account] : void 0, ge = x[m.requestId] ? x[m.requestId].getData() : void 0, pe = x[m.origin] ? x[m.origin] : void 0;
      return new b({
        requestId: ge,
        signData: M,
        derivationPath: F,
        account: le,
        origin: pe
      });
    }, b.fromCBOR = (P) => {
      const x = t(P);
      return b.fromDataItem(x);
    };
    const {
      RegistryTypes: k,
      decodeToDataItem: C
    } = A.extend;
    var B;
    (function(P) {
      P[P.requestId = 1] = "requestId", P[P.signature = 2] = "signature";
    })(B || (B = {}));
    class Q extends A.RegistryItem {
      constructor(x, M) {
        super(), this.getRegistryType = () => p.NEAR_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const F = {};
          return this.requestId && (F[B.requestId] = new A.DataItem(this.requestId, k.UUID.getTag())), F[B.signature] = this.signature, new A.DataItem(F);
        }, this.signature = x, this.requestId = M;
      }
    }
    Q.fromDataItem = (P) => {
      const x = P.getData(), M = x[B.signature], F = x[B.requestId] ? x[B.requestId].getData() : void 0;
      return new Q(M, F);
    }, Q.fromCBOR = (P) => {
      const x = C(P);
      return Q.fromDataItem(x);
    }, A.patchTags(Object.values(p).filter((P) => !!P.getTag()).map((P) => P.getTag())), Object.keys(A).forEach(function(P) {
      P !== "default" && Object.defineProperty(s, P, {
        enumerable: !0,
        get: function() {
          return A[P];
        }
      });
    }), s.NearSignRequest = b, s.NearSignature = Q;
  }(bcUrRegistryNear_cjs_development)), bcUrRegistryNear_cjs_development;
}
var hasRequiredDist$a;
function requireDist$a() {
  return hasRequiredDist$a || (hasRequiredDist$a = 1, process$1.env.NODE_ENV === "production" ? dist$9.exports = requireBcUrRegistryNear_cjs_production_min() : dist$9.exports = requireBcUrRegistryNear_cjs_development()), dist$9.exports;
}
var hasRequiredNear;
function requireNear() {
  if (hasRequiredNear) return near;
  hasRequiredNear = 1, Object.defineProperty(near, "__esModule", { value: !0 }), near.KeystoneNearSDK = void 0;
  const s = requireUtils$d(), A = requireUr(), u = requireDist$a();
  class p {
    parseSignature(l) {
      if (l.type !== A.URType.NearSignature)
        throw new Error("type not match");
      const m = u.NearSignature.fromCBOR(l.cbor), b = m.getRequestId();
      return {
        requestId: b === void 0 ? void 0 : (0, s.uuidStringify)(b),
        signature: m.getSignature().map((k) => (0, s.toHex)(k))
      };
    }
    generateSignRequest({ requestId: l, signData: m, path: b, xfp: k, account: C, origin: B }) {
      return new u.NearSignRequest({
        requestId: (0, s.uuidParse)(l),
        signData: m.map((Q) => (0, s.toBuffer)(Q)),
        derivationPath: new u.CryptoKeypath((0, s.parsePath)(b).map((Q) => new u.PathComponent(Q)), (0, s.toBuffer)(k)),
        account: C,
        origin: B
      }).toUR();
    }
  }
  return near.KeystoneNearSDK = p, near;
}
var cardano = {}, dist$8 = { exports: {} }, bcUrRegistryCardano_cjs_production_min = {}, hasRequiredBcUrRegistryCardano_cjs_production_min;
function requireBcUrRegistryCardano_cjs_production_min() {
  return hasRequiredBcUrRegistryCardano_cjs_production_min || (hasRequiredBcUrRegistryCardano_cjs_production_min = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$i(), u = require$$1$2;
    const p = { CARDANO_UTXO: new A.RegistryType("cardano-utxo", 2201), CARDANO_SIGN_REQUEST: new A.RegistryType("cardano-sign-request", 2202), CARDANO_SIGNATURE: new A.RegistryType("cardano-signature", 2203), CARDANO_CERT_KEY: new A.RegistryType("cardano-cert-key", 2204), CARDANO_SIGN_DATA_REQUEST: new A.RegistryType("cardano-sign-data-request", 2205), CARDANO_SIGN_DATA_SIGNATURE: new A.RegistryType("cardano-sign-data-signature", 2206), CARDANO_CATALYST_VOTING_REGISTRATION: new A.RegistryType("cardano-catalyst-voting-registration", 2207), CARDANO_CATALYST_VOTING_REGISTRATION_SIGNATURE: new A.RegistryType("cardano-catalyst-voting-registration-signature", 2208), CARDANO_DELEGATION: new A.RegistryType("cardano-delegation", 2209), CARDANO_SIGN_CIP8_DATA_REQUEST: new A.RegistryType("cardano-sign-cip8-data-request", 2210), CARDANO_SIGN_CIP8_DATA_SIGNATURE: new A.RegistryType("cardano-sign-cip8-data-signature", 2211) }, { decodeToDataItem: t } = A.extend;
    var l;
    (function(wr) {
      wr[wr.transactionHash = 1] = "transactionHash", wr[wr.index = 2] = "index", wr[wr.amount = 3] = "amount", wr[wr.keyPath = 4] = "keyPath", wr[wr.address = 5] = "address";
    })(l || (l = {}));
    class m extends A.RegistryItem {
      constructor(yr) {
        super(), this.getRegistryType = () => p.CARDANO_UTXO, this.getTransactionHash = () => this.transactionHash, this.getIndex = () => this.index, this.getKeyPath = () => this.keyPath.getPath(), this.getAmount = () => this.amount, this.getAddress = () => this.address, this.toDataItem = () => {
          const Qr = {};
          this.transactionHash && (Qr[l.transactionHash] = this.transactionHash), Qr[l.index] = this.index, Qr[l.amount] = this.amount;
          const _r = this.keyPath.toDataItem();
          return _r.setTag(this.keyPath.getRegistryType().getTag()), Qr[l.keyPath] = _r, Qr[l.address] = this.address, new A.DataItem(Qr);
        }, this.transactionHash = yr.transactionHash, this.index = yr.index, this.amount = yr.amount, this.keyPath = yr.keyPath, this.address = yr.address;
      }
      static constructCardanoUtxo({ transactionHash: yr, index: Qr, amount: _r, xfp: Jr, hdPath: fn, address: jr }) {
        const dn = fn.replace(/[m|M]\//, "").split("/"), Tn = new A.CryptoKeypath(dn.map((Yn) => {
          const si = parseInt(Yn.replace("'", "")), vn = Yn.endsWith("'");
          return new A.PathComponent({ index: si, hardened: vn });
        }), Buffer.from(Jr, "hex"));
        return new m({ transactionHash: Buffer.from(yr, "hex"), index: Qr, amount: _r, keyPath: Tn, address: jr });
      }
    }
    m.fromDataItem = (wr) => {
      const yr = wr.getData(), Qr = yr[l.transactionHash], _r = yr[l.index], Jr = A.CryptoKeypath.fromDataItem(yr[l.keyPath]);
      return new m({ transactionHash: Qr, index: _r, amount: yr[l.amount], keyPath: Jr, address: yr[l.address] });
    }, m.fromCBOR = (wr) => {
      const yr = t(wr);
      return m.fromDataItem(yr);
    };
    const { decodeToDataItem: b } = A.extend;
    var k;
    (function(wr) {
      wr[wr.keyHash = 1] = "keyHash", wr[wr.keyPath = 2] = "keyPath";
    })(k || (k = {}));
    class C extends A.RegistryItem {
      constructor(yr) {
        super(), this.getRegistryType = () => p.CARDANO_CERT_KEY, this.getKeyHash = () => this.keyHash, this.getKeyPath = () => this.keyPath.getPath(), this.toDataItem = () => {
          const Qr = {};
          Qr[k.keyHash] = this.keyHash;
          const _r = this.keyPath.toDataItem();
          return _r.setTag(this.keyPath.getRegistryType().getTag()), Qr[k.keyPath] = _r, new A.DataItem(Qr);
        }, this.keyHash = yr.keyHash, this.keyPath = yr.keyPath;
      }
      static constructCardanoCertKey({ keyHash: yr, xfp: Qr, keyPath: _r }) {
        const Jr = _r.replace(/[m|M]\//, "").split("/"), fn = new A.CryptoKeypath(Jr.map((jr) => {
          const dn = parseInt(jr.replace("'", "")), Tn = jr.endsWith("'");
          return new A.PathComponent({ index: dn, hardened: Tn });
        }), Buffer.from(Qr, "hex"));
        return new C({ keyHash: Buffer.from(yr, "hex"), keyPath: fn });
      }
    }
    C.fromDataItem = (wr) => {
      const yr = wr.getData(), Qr = yr[k.keyHash], _r = A.CryptoKeypath.fromDataItem(yr[k.keyPath]);
      return new C({ keyHash: Qr, keyPath: _r });
    }, C.fromCBOR = (wr) => {
      const yr = b(wr);
      return C.fromDataItem(yr);
    };
    const { decodeToDataItem: B, RegistryTypes: Q } = A.extend;
    var P;
    (function(wr) {
      wr[wr.requestId = 1] = "requestId", wr[wr.signData = 2] = "signData", wr[wr.utxos = 3] = "utxos", wr[wr.extraSigners = 4] = "extraSigners", wr[wr.origin = 5] = "origin";
    })(P || (P = {}));
    class x extends A.RegistryItem {
      constructor(yr) {
        super(), this.getRegistryType = () => p.CARDANO_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getUtxos = () => this.utxos, this.getAdditionalSigners = () => this.extraSigners, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Qr = {};
          return this.requestId && (Qr[P.requestId] = new A.DataItem(this.requestId, Q.UUID.getTag())), Qr[P.signData] = this.signData, Qr[P.utxos] = this.utxos.map((_r) => {
            const Jr = _r.toDataItem();
            return Jr.setTag(_r.getRegistryType().getTag()), Jr;
          }), Qr[P.extraSigners] = this.extraSigners.map((_r) => {
            const Jr = _r.toDataItem();
            return Jr.setTag(_r.getRegistryType().getTag()), Jr;
          }), this.origin && (Qr[P.origin] = this.origin), new A.DataItem(Qr);
        }, this.requestId = yr.requestId, this.signData = yr.signData, this.utxos = yr.utxos, this.extraSigners = yr.extraSigners, this.origin = yr.origin;
      }
      static constructCardanoSignRequest(yr, Qr, _r, Jr, fn) {
        const jr = Qr.map((Tn) => m.constructCardanoUtxo(Tn)), dn = _r.map((Tn) => C.constructCardanoCertKey(Tn));
        return new x({ requestId: Jr ? Buffer.from(u.parse(Jr)) : void 0, signData: yr, utxos: jr, extraSigners: dn, origin: fn || void 0 });
      }
    }
    x.fromDataItem = (wr) => {
      const yr = wr.getData(), Qr = yr[P.signData], _r = yr[P.utxos].map((jr) => m.fromDataItem(jr)), Jr = yr[P.extraSigners].map((jr) => C.fromDataItem(jr)), fn = yr[P.requestId] ? yr[P.requestId].getData() : void 0;
      return new x({ requestId: fn, signData: Qr, utxos: _r, extraSigners: Jr, origin: yr[P.origin] ? yr[P.origin] : void 0 });
    }, x.fromCBOR = (wr) => {
      const yr = B(wr);
      return x.fromDataItem(yr);
    };
    const { RegistryTypes: M, decodeToDataItem: F } = A.extend;
    var le;
    (function(wr) {
      wr[wr.requestId = 1] = "requestId", wr[wr.signature = 2] = "signature";
    })(le || (le = {}));
    class ge extends A.RegistryItem {
      constructor(yr, Qr) {
        super(), this.getRegistryType = () => p.CARDANO_SIGNATURE, this.getRequestId = () => this.requestId, this.getWitnessSet = () => this.witnessSet, this.toDataItem = () => {
          const _r = {};
          return this.requestId && (_r[le.requestId] = new A.DataItem(this.requestId, M.UUID.getTag())), _r[le.signature] = this.witnessSet, new A.DataItem(_r);
        }, this.witnessSet = yr, this.requestId = Qr;
      }
    }
    ge.fromDataItem = (wr) => {
      const yr = wr.getData(), Qr = yr[le.signature], _r = yr[le.requestId] ? yr[le.requestId].getData() : void 0;
      return new ge(Qr, _r);
    }, ge.fromCBOR = (wr) => {
      const yr = F(wr);
      return ge.fromDataItem(yr);
    };
    const { decodeToDataItem: pe, RegistryTypes: Ie } = A.extend;
    var be;
    (function(wr) {
      wr[wr.requestId = 1] = "requestId", wr[wr.signData = 2] = "signData", wr[wr.derivationPath = 3] = "derivationPath", wr[wr.origin = 4] = "origin", wr[wr.signType = 5] = "signType", wr[wr.xpub = 6] = "xpub";
    })(be || (be = {}));
    class Pe extends A.RegistryItem {
      constructor(yr) {
        super(), this.getRegistryType = () => p.CARDANO_SIGN_DATA_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getOrigin = () => this.origin, this.getXpub = () => this.xpub, this.toDataItem = () => {
          const Qr = {};
          this.requestId && (Qr[be.requestId] = new A.DataItem(this.requestId, Ie.UUID.getTag())), this.origin && (Qr[be.origin] = this.origin), Qr[be.signData] = this.signData;
          const _r = this.derivationPath.toDataItem();
          return _r.setTag(this.derivationPath.getRegistryType().getTag()), Qr[be.derivationPath] = _r, Qr[be.xpub] = this.xpub, new A.DataItem(Qr);
        }, this.requestId = yr.requestId, this.signData = yr.signData, this.derivationPath = yr.derivationPath, this.origin = yr.origin, this.xpub = yr.xpub;
      }
      static constructCardanoSignDataRequest(yr, Qr, _r, Jr, fn, jr) {
        const dn = Qr.replace(/[m|M]\//, "").split("/"), Tn = new A.CryptoKeypath(dn.map((Yn) => {
          const si = parseInt(Yn.replace("'", ""));
          let vn = !1;
          return Yn.endsWith("'") && (vn = !0), new A.PathComponent({ index: si, hardened: vn });
        }), Buffer.from(_r, "hex"));
        return new Pe({ requestId: fn ? Buffer.from(u.parse(fn)) : void 0, signData: Buffer.from(yr, "hex"), derivationPath: Tn, origin: jr || void 0, xpub: Buffer.from(Jr, "hex") });
      }
    }
    Pe.fromDataItem = (wr) => {
      const yr = wr.getData(), Qr = yr[be.signData], _r = A.CryptoKeypath.fromDataItem(yr[be.derivationPath]), Jr = yr[be.requestId] ? yr[be.requestId].getData() : void 0;
      return new Pe({ requestId: Jr, signData: Qr, derivationPath: _r, origin: yr[be.origin] ? yr[be.origin] : void 0, xpub: yr[be.xpub] });
    }, Pe.fromCBOR = (wr) => {
      const yr = pe(wr);
      return Pe.fromDataItem(yr);
    };
    const { RegistryTypes: Te, decodeToDataItem: Qe } = A.extend;
    var xe;
    (function(wr) {
      wr[wr.requestId = 1] = "requestId", wr[wr.signature = 2] = "signature", wr[wr.publicKey = 3] = "publicKey";
    })(xe || (xe = {}));
    class Ee extends A.RegistryItem {
      constructor(yr, Qr, _r) {
        super(), this.getRegistryType = () => p.CARDANO_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const Jr = {};
          return this.requestId && (Jr[xe.requestId] = new A.DataItem(this.requestId, Te.UUID.getTag())), Jr[xe.signature] = this.getSignature(), Jr[xe.publicKey] = this.getPublicKey(), new A.DataItem(Jr);
        }, this.signature = yr, this.publicKey = Qr, this.requestId = _r;
      }
    }
    Ee.fromDataItem = (wr) => {
      const yr = wr.getData(), Qr = yr[xe.signature], _r = yr[xe.publicKey], Jr = yr[xe.requestId] ? yr[xe.requestId].getData() : void 0;
      return new Ee(Qr, _r, Jr);
    }, Ee.fromCBOR = (wr) => {
      const yr = Qe(wr);
      return Ee.fromDataItem(yr);
    };
    const { decodeToDataItem: He } = A.extend;
    var ve;
    (function(wr) {
      wr[wr.pubKey = 1] = "pubKey", wr[wr.weight = 2] = "weight";
    })(ve || (ve = {}));
    class we extends A.RegistryItem {
      constructor(yr) {
        super(), this.getRegistryType = () => p.CARDANO_DELEGATION, this.getPubKey = () => this.pubKey, this.getWeight = () => this.weight, this.toDataItem = () => {
          const Qr = {};
          return Qr[ve.pubKey] = this.getPubKey(), Qr[ve.weight] = this.getWeight(), new A.DataItem(Qr);
        }, this.pubKey = yr.pubKey, this.weight = yr.weight;
      }
      static constructCardanoDelegation({ pubKey: yr, weight: Qr }) {
        return new we({ pubKey: yr, weight: Qr });
      }
    }
    we.fromDataItem = (wr) => {
      const yr = wr.getData();
      return new we({ pubKey: yr[ve.pubKey], weight: yr[ve.weight] });
    }, we.fromCBOR = (wr) => {
      const yr = He(wr);
      return we.fromDataItem(yr);
    };
    const { decodeToDataItem: Ce, RegistryTypes: Se } = A.extend;
    var Ne;
    (function(wr) {
      wr[wr.requestId = 1] = "requestId", wr[wr.delegations = 2] = "delegations", wr[wr.stakePub = 3] = "stakePub", wr[wr.paymentAddress = 4] = "paymentAddress", wr[wr.nonce = 5] = "nonce", wr[wr.voting_purpose = 6] = "voting_purpose", wr[wr.derivationPath = 7] = "derivationPath", wr[wr.origin = 8] = "origin", wr[wr.signType = 9] = "signType";
    })(Ne || (Ne = {}));
    const rr = (wr, yr) => {
      const Qr = wr.replace(/[m|M]\//, "").split("/");
      return new A.CryptoKeypath(Qr.map((_r) => {
        const Jr = parseInt(_r.replace("'", ""));
        let fn = !1;
        return _r.endsWith("'") && (fn = !0), new A.PathComponent({ index: Jr, hardened: fn });
      }), Buffer.from(yr, "hex"));
    };
    class er extends A.RegistryItem {
      constructor(yr) {
        super(), this.getRegistryType = () => p.CARDANO_CATALYST_VOTING_REGISTRATION, this.getRequestId = () => this.requestId, this.getDelegations = () => this.delegations, this.getStakePub = () => this.stakePub, this.getPaymentAddress = () => this.paymentAddress, this.getNonce = () => this.nonce, this.getVotingPurpose = () => this.voting_purpose, this.getDerivationPath = () => this.derivationPath.getPath(), this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Qr = {};
          this.requestId && (Qr[Ne.requestId] = new A.DataItem(this.requestId, Se.UUID.getTag())), Qr[Ne.stakePub] = this.stakePub, Qr[Ne.paymentAddress] = this.paymentAddress, Qr[Ne.nonce] = this.nonce, Qr[Ne.voting_purpose] = this.voting_purpose, Qr[Ne.delegations] = this.delegations.map((Jr) => {
            const fn = Jr.toDataItem();
            return fn.setTag(Jr.getRegistryType().getTag()), fn;
          }), this.origin && (Qr[Ne.origin] = this.origin);
          const _r = this.derivationPath.toDataItem();
          return _r.setTag(this.derivationPath.getRegistryType().getTag()), Qr[Ne.derivationPath] = _r, new A.DataItem(Qr);
        }, this.requestId = yr.requestId, this.derivationPath = yr.derivationPath, this.delegations = yr.delegations, this.stakePub = yr.stakePub, this.paymentAddress = yr.paymentAddress, this.nonce = yr.nonce, this.voting_purpose = yr.voting_purpose, this.origin = yr.origin;
      }
      static constructCardanoCatalystRequest(yr, Qr, _r, Jr, fn, jr, dn, Tn, Yn) {
        const si = Tn ? Buffer.from(u.parse(Tn)) : void 0, vn = yr.map((Cn) => we.constructCardanoDelegation({ pubKey: Buffer.from(Cn.pubKey, "hex"), weight: Cn.weight }));
        return new er({ requestId: si, delegations: vn, stakePub: Buffer.from(Qr, "hex"), paymentAddress: Buffer.from(_r, "hex"), nonce: Jr, voting_purpose: fn, derivationPath: rr(jr, dn), origin: Yn });
      }
    }
    er.fromDataItem = (wr) => {
      const yr = wr.getData(), Qr = yr[Ne.delegations].map((Yn) => we.fromDataItem(Yn)), _r = yr[Ne.stakePub], Jr = yr[Ne.paymentAddress], fn = yr[Ne.nonce], jr = yr[Ne.voting_purpose], dn = A.CryptoKeypath.fromDataItem(yr[Ne.derivationPath]), Tn = yr[Ne.requestId] ? yr[Ne.requestId].getData() : void 0;
      return new er({ requestId: Tn, delegations: Qr, stakePub: _r, paymentAddress: Jr, nonce: fn, voting_purpose: jr, derivationPath: dn, origin: yr[Ne.origin] ? yr[Ne.origin] : void 0 });
    }, er.fromCBOR = (wr) => {
      const yr = Ce(wr);
      return er.fromDataItem(yr);
    };
    const { RegistryTypes: ir, decodeToDataItem: sr } = A.extend;
    var nr;
    (function(wr) {
      wr[wr.requestId = 1] = "requestId", wr[wr.signature = 2] = "signature";
    })(nr || (nr = {}));
    class fr extends A.RegistryItem {
      constructor(yr, Qr) {
        super(), this.getRegistryType = () => p.CARDANO_CATALYST_VOTING_REGISTRATION_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const _r = {};
          return this.requestId && (_r[nr.requestId] = new A.DataItem(this.requestId, ir.UUID.getTag())), _r[nr.signature] = this.getSignature(), new A.DataItem(_r);
        }, this.signature = yr, this.requestId = Qr;
      }
    }
    fr.fromDataItem = (wr) => {
      const yr = wr.getData(), Qr = yr[nr.signature], _r = yr[nr.requestId] ? yr[nr.requestId].getData() : void 0;
      return new fr(Qr, _r);
    }, fr.fromCBOR = (wr) => {
      const yr = sr(wr);
      return fr.fromDataItem(yr);
    };
    const { decodeToDataItem: lr, RegistryTypes: br } = A.extend;
    var Br, Fr;
    (function(wr) {
      wr[wr.requestId = 1] = "requestId", wr[wr.signData = 2] = "signData", wr[wr.derivationPath = 3] = "derivationPath", wr[wr.origin = 4] = "origin", wr[wr.signType = 5] = "signType", wr[wr.xpub = 6] = "xpub", wr[wr.hashPayload = 7] = "hashPayload", wr[wr.addressBench32 = 8] = "addressBench32", wr[wr.addressFieldType = 9] = "addressFieldType";
    })(Br || (Br = {})), (Fr = s.MessageAddressFieldType || (s.MessageAddressFieldType = {})).ADDRESS = "ADDRESS", Fr.KEY_HASH = "KEY_HASH";
    class Gr extends A.RegistryItem {
      constructor(yr) {
        super(), this.getRegistryType = () => p.CARDANO_SIGN_CIP8_DATA_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getOrigin = () => this.origin, this.getXpub = () => this.xpub, this.getHashPayload = () => this.hashPayload, this.getAddressBench32 = () => this.addressBench32, this.getAddressFieldType = () => this.addressFieldType, this.toDataItem = () => {
          const Qr = {};
          this.requestId && (Qr[Br.requestId] = new A.DataItem(this.requestId, br.UUID.getTag())), this.origin && (Qr[Br.origin] = this.origin), Qr[Br.signData] = this.signData;
          const _r = this.derivationPath.toDataItem();
          return _r.setTag(this.derivationPath.getRegistryType().getTag()), Qr[Br.derivationPath] = _r, Qr[Br.xpub] = this.xpub, Qr[Br.hashPayload] = this.hashPayload, this.addressBench32 && (Qr[Br.addressBench32] = this.addressBench32), Qr[Br.addressFieldType] = this.addressFieldType, new A.DataItem(Qr);
        }, this.requestId = yr.requestId, this.signData = yr.signData, this.derivationPath = yr.derivationPath, this.origin = yr.origin, this.xpub = yr.xpub, this.hashPayload = yr.hashPayload, this.addressBench32 = yr.addressBench32, this.addressFieldType = yr.addressFieldType;
      }
      static constructCardanoSignCip8DataRequest(yr, Qr, _r, Jr, fn, jr, dn, Tn, Yn) {
        const si = Qr.replace(/[m|M]\//, "").split("/"), vn = new A.CryptoKeypath(si.map((Cn) => {
          const Xr = parseInt(Cn.replace("'", ""));
          let In = !1;
          return Cn.endsWith("'") && (In = !0), new A.PathComponent({ index: Xr, hardened: In });
        }), Buffer.from(_r, "hex"));
        return new Gr({ requestId: Tn ? Buffer.from(u.parse(Tn)) : void 0, signData: Buffer.from(yr, "hex"), derivationPath: vn, origin: Yn || void 0, xpub: Buffer.from(Jr, "hex"), hashPayload: fn, addressBench32: dn || void 0, addressFieldType: jr });
      }
    }
    Gr.fromDataItem = (wr) => {
      const yr = wr.getData(), Qr = yr[Br.signData], _r = A.CryptoKeypath.fromDataItem(yr[Br.derivationPath]), Jr = yr[Br.requestId] ? yr[Br.requestId].getData() : void 0;
      return new Gr({ requestId: Jr, signData: Qr, derivationPath: _r, origin: yr[Br.origin] ? yr[Br.origin] : void 0, xpub: yr[Br.xpub], hashPayload: yr[Br.hashPayload], addressBench32: yr[Br.addressBench32] ? yr[Br.addressBench32] : void 0, addressFieldType: yr[Br.addressFieldType] });
    }, Gr.fromCBOR = (wr) => {
      const yr = lr(wr);
      return Gr.fromDataItem(yr);
    };
    const { RegistryTypes: qr, decodeToDataItem: Hr } = A.extend;
    var un;
    (function(wr) {
      wr[wr.requestId = 1] = "requestId", wr[wr.signature = 2] = "signature", wr[wr.publicKey = 3] = "publicKey", wr[wr.addressField = 4] = "addressField";
    })(un || (un = {}));
    class Dr extends A.RegistryItem {
      constructor(yr, Qr, _r, Jr) {
        super(), this.getRegistryType = () => p.CARDANO_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.getAddressField = () => this.addressField, this.toDataItem = () => {
          const fn = {};
          return this.requestId && (fn[un.requestId] = new A.DataItem(this.requestId, qr.UUID.getTag())), fn[un.signature] = this.getSignature(), fn[un.publicKey] = this.getPublicKey(), fn[un.addressField] = this.getAddressField(), new A.DataItem(fn);
        }, this.signature = yr, this.publicKey = Qr, this.requestId = Jr, this.addressField = _r;
      }
    }
    Dr.fromDataItem = (wr) => {
      const yr = wr.getData(), Qr = yr[un.signature], _r = yr[un.publicKey], Jr = yr[un.requestId] ? yr[un.requestId].getData() : void 0;
      return new Dr(Qr, _r, yr[un.addressField], Jr);
    }, Dr.fromCBOR = (wr) => {
      const yr = Hr(wr);
      return Dr.fromDataItem(yr);
    }, A.patchTags(Object.values(p).filter((wr) => !!wr.getTag()).map((wr) => wr.getTag())), Object.keys(A).forEach(function(wr) {
      wr !== "default" && Object.defineProperty(s, wr, { enumerable: !0, get: function() {
        return A[wr];
      } });
    }), s.CardanoCatalystRequest = er, s.CardanoCatalystSignature = fr, s.CardanoCertKey = C, s.CardanoSignCip8DataRequest = Gr, s.CardanoSignCip8DataSignature = Dr, s.CardanoSignDataRequest = Pe, s.CardanoSignDataSignature = Ee, s.CardanoSignRequest = x, s.CardanoSignature = ge;
  }(bcUrRegistryCardano_cjs_production_min)), bcUrRegistryCardano_cjs_production_min;
}
var bcUrRegistryCardano_cjs_development = {}, hasRequiredBcUrRegistryCardano_cjs_development;
function requireBcUrRegistryCardano_cjs_development() {
  return hasRequiredBcUrRegistryCardano_cjs_development || (hasRequiredBcUrRegistryCardano_cjs_development = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$i(), u = require$$1$2;
    const p = {
      CARDANO_UTXO: /* @__PURE__ */ new A.RegistryType("cardano-utxo", 2201),
      CARDANO_SIGN_REQUEST: /* @__PURE__ */ new A.RegistryType("cardano-sign-request", 2202),
      CARDANO_SIGNATURE: /* @__PURE__ */ new A.RegistryType("cardano-signature", 2203),
      CARDANO_CERT_KEY: /* @__PURE__ */ new A.RegistryType("cardano-cert-key", 2204),
      CARDANO_SIGN_DATA_REQUEST: /* @__PURE__ */ new A.RegistryType("cardano-sign-data-request", 2205),
      CARDANO_SIGN_DATA_SIGNATURE: /* @__PURE__ */ new A.RegistryType("cardano-sign-data-signature", 2206),
      CARDANO_CATALYST_VOTING_REGISTRATION: /* @__PURE__ */ new A.RegistryType("cardano-catalyst-voting-registration", 2207),
      CARDANO_CATALYST_VOTING_REGISTRATION_SIGNATURE: /* @__PURE__ */ new A.RegistryType("cardano-catalyst-voting-registration-signature", 2208),
      CARDANO_DELEGATION: /* @__PURE__ */ new A.RegistryType("cardano-delegation", 2209),
      CARDANO_SIGN_CIP8_DATA_REQUEST: /* @__PURE__ */ new A.RegistryType("cardano-sign-cip8-data-request", 2210),
      CARDANO_SIGN_CIP8_DATA_SIGNATURE: /* @__PURE__ */ new A.RegistryType("cardano-sign-cip8-data-signature", 2211)
    }, {
      decodeToDataItem: t
    } = A.extend;
    var l;
    (function(Dr) {
      Dr[Dr.transactionHash = 1] = "transactionHash", Dr[Dr.index = 2] = "index", Dr[Dr.amount = 3] = "amount", Dr[Dr.keyPath = 4] = "keyPath", Dr[Dr.address = 5] = "address";
    })(l || (l = {}));
    class m extends A.RegistryItem {
      constructor(wr) {
        super(), this.getRegistryType = () => p.CARDANO_UTXO, this.getTransactionHash = () => this.transactionHash, this.getIndex = () => this.index, this.getKeyPath = () => this.keyPath.getPath(), this.getAmount = () => this.amount, this.getAddress = () => this.address, this.toDataItem = () => {
          const yr = {};
          this.transactionHash && (yr[l.transactionHash] = this.transactionHash), yr[l.index] = this.index, yr[l.amount] = this.amount;
          const Qr = this.keyPath.toDataItem();
          return Qr.setTag(this.keyPath.getRegistryType().getTag()), yr[l.keyPath] = Qr, yr[l.address] = this.address, new A.DataItem(yr);
        }, this.transactionHash = wr.transactionHash, this.index = wr.index, this.amount = wr.amount, this.keyPath = wr.keyPath, this.address = wr.address;
      }
      static constructCardanoUtxo({
        transactionHash: wr,
        index: yr,
        amount: Qr,
        xfp: _r,
        hdPath: Jr,
        address: fn
      }) {
        const jr = Jr.replace(/[m|M]\//, "").split("/"), dn = new A.CryptoKeypath(jr.map((Tn) => {
          const Yn = parseInt(Tn.replace("'", "")), si = Tn.endsWith("'");
          return new A.PathComponent({
            index: Yn,
            hardened: si
          });
        }), Buffer.from(_r, "hex"));
        return new m({
          transactionHash: Buffer.from(wr, "hex"),
          index: yr,
          amount: Qr,
          keyPath: dn,
          address: fn
        });
      }
    }
    m.fromDataItem = (Dr) => {
      const wr = Dr.getData(), yr = wr[l.transactionHash], Qr = wr[l.index], _r = A.CryptoKeypath.fromDataItem(wr[l.keyPath]), Jr = wr[l.address], fn = wr[l.amount];
      return new m({
        transactionHash: yr,
        index: Qr,
        amount: fn,
        keyPath: _r,
        address: Jr
      });
    }, m.fromCBOR = (Dr) => {
      const wr = t(Dr);
      return m.fromDataItem(wr);
    };
    const {
      decodeToDataItem: b
    } = A.extend;
    var k;
    (function(Dr) {
      Dr[Dr.keyHash = 1] = "keyHash", Dr[Dr.keyPath = 2] = "keyPath";
    })(k || (k = {}));
    class C extends A.RegistryItem {
      constructor(wr) {
        super(), this.getRegistryType = () => p.CARDANO_CERT_KEY, this.getKeyHash = () => this.keyHash, this.getKeyPath = () => this.keyPath.getPath(), this.toDataItem = () => {
          const yr = {};
          yr[k.keyHash] = this.keyHash;
          const Qr = this.keyPath.toDataItem();
          return Qr.setTag(this.keyPath.getRegistryType().getTag()), yr[k.keyPath] = Qr, new A.DataItem(yr);
        }, this.keyHash = wr.keyHash, this.keyPath = wr.keyPath;
      }
      static constructCardanoCertKey({
        keyHash: wr,
        xfp: yr,
        keyPath: Qr
      }) {
        const _r = Qr.replace(/[m|M]\//, "").split("/"), Jr = new A.CryptoKeypath(_r.map((fn) => {
          const jr = parseInt(fn.replace("'", "")), dn = fn.endsWith("'");
          return new A.PathComponent({
            index: jr,
            hardened: dn
          });
        }), Buffer.from(yr, "hex"));
        return new C({
          keyHash: Buffer.from(wr, "hex"),
          keyPath: Jr
        });
      }
    }
    C.fromDataItem = (Dr) => {
      const wr = Dr.getData(), yr = wr[k.keyHash], Qr = A.CryptoKeypath.fromDataItem(wr[k.keyPath]);
      return new C({
        keyHash: yr,
        keyPath: Qr
      });
    }, C.fromCBOR = (Dr) => {
      const wr = b(Dr);
      return C.fromDataItem(wr);
    };
    const {
      decodeToDataItem: B,
      RegistryTypes: Q
    } = A.extend;
    var P;
    (function(Dr) {
      Dr[Dr.requestId = 1] = "requestId", Dr[Dr.signData = 2] = "signData", Dr[Dr.utxos = 3] = "utxos", Dr[Dr.extraSigners = 4] = "extraSigners", Dr[Dr.origin = 5] = "origin";
    })(P || (P = {}));
    class x extends A.RegistryItem {
      constructor(wr) {
        super(), this.getRegistryType = () => p.CARDANO_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getUtxos = () => this.utxos, this.getAdditionalSigners = () => this.extraSigners, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const yr = {};
          return this.requestId && (yr[P.requestId] = new A.DataItem(this.requestId, Q.UUID.getTag())), yr[P.signData] = this.signData, yr[P.utxos] = this.utxos.map((Qr) => {
            const _r = Qr.toDataItem();
            return _r.setTag(Qr.getRegistryType().getTag()), _r;
          }), yr[P.extraSigners] = this.extraSigners.map((Qr) => {
            const _r = Qr.toDataItem();
            return _r.setTag(Qr.getRegistryType().getTag()), _r;
          }), this.origin && (yr[P.origin] = this.origin), new A.DataItem(yr);
        }, this.requestId = wr.requestId, this.signData = wr.signData, this.utxos = wr.utxos, this.extraSigners = wr.extraSigners, this.origin = wr.origin;
      }
      static constructCardanoSignRequest(wr, yr, Qr, _r, Jr) {
        const fn = yr.map((dn) => m.constructCardanoUtxo(dn)), jr = Qr.map((dn) => C.constructCardanoCertKey(dn));
        return new x({
          requestId: _r ? Buffer.from(u.parse(_r)) : void 0,
          signData: wr,
          utxos: fn,
          extraSigners: jr,
          origin: Jr || void 0
        });
      }
    }
    x.fromDataItem = (Dr) => {
      const wr = Dr.getData(), yr = wr[P.signData], Qr = wr[P.utxos].map((jr) => m.fromDataItem(jr)), _r = wr[P.extraSigners].map((jr) => C.fromDataItem(jr)), Jr = wr[P.requestId] ? wr[P.requestId].getData() : void 0, fn = wr[P.origin] ? wr[P.origin] : void 0;
      return new x({
        requestId: Jr,
        signData: yr,
        utxos: Qr,
        extraSigners: _r,
        origin: fn
      });
    }, x.fromCBOR = (Dr) => {
      const wr = B(Dr);
      return x.fromDataItem(wr);
    };
    const {
      RegistryTypes: M,
      decodeToDataItem: F
    } = A.extend;
    var le;
    (function(Dr) {
      Dr[Dr.requestId = 1] = "requestId", Dr[Dr.signature = 2] = "signature";
    })(le || (le = {}));
    class ge extends A.RegistryItem {
      constructor(wr, yr) {
        super(), this.getRegistryType = () => p.CARDANO_SIGNATURE, this.getRequestId = () => this.requestId, this.getWitnessSet = () => this.witnessSet, this.toDataItem = () => {
          const Qr = {};
          return this.requestId && (Qr[le.requestId] = new A.DataItem(this.requestId, M.UUID.getTag())), Qr[le.signature] = this.witnessSet, new A.DataItem(Qr);
        }, this.witnessSet = wr, this.requestId = yr;
      }
    }
    ge.fromDataItem = (Dr) => {
      const wr = Dr.getData(), yr = wr[le.signature], Qr = wr[le.requestId] ? wr[le.requestId].getData() : void 0;
      return new ge(yr, Qr);
    }, ge.fromCBOR = (Dr) => {
      const wr = F(Dr);
      return ge.fromDataItem(wr);
    };
    const {
      decodeToDataItem: pe,
      RegistryTypes: Ie
    } = A.extend;
    var be;
    (function(Dr) {
      Dr[Dr.requestId = 1] = "requestId", Dr[Dr.signData = 2] = "signData", Dr[Dr.derivationPath = 3] = "derivationPath", Dr[Dr.origin = 4] = "origin", Dr[Dr.signType = 5] = "signType", Dr[Dr.xpub = 6] = "xpub";
    })(be || (be = {}));
    class Pe extends A.RegistryItem {
      constructor(wr) {
        super(), this.getRegistryType = () => p.CARDANO_SIGN_DATA_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getOrigin = () => this.origin, this.getXpub = () => this.xpub, this.toDataItem = () => {
          const yr = {};
          this.requestId && (yr[be.requestId] = new A.DataItem(this.requestId, Ie.UUID.getTag())), this.origin && (yr[be.origin] = this.origin), yr[be.signData] = this.signData;
          const Qr = this.derivationPath.toDataItem();
          return Qr.setTag(this.derivationPath.getRegistryType().getTag()), yr[be.derivationPath] = Qr, yr[be.xpub] = this.xpub, new A.DataItem(yr);
        }, this.requestId = wr.requestId, this.signData = wr.signData, this.derivationPath = wr.derivationPath, this.origin = wr.origin, this.xpub = wr.xpub;
      }
      static constructCardanoSignDataRequest(wr, yr, Qr, _r, Jr, fn) {
        const jr = yr.replace(/[m|M]\//, "").split("/"), dn = new A.CryptoKeypath(jr.map((Tn) => {
          const Yn = parseInt(Tn.replace("'", ""));
          let si = !1;
          return Tn.endsWith("'") && (si = !0), new A.PathComponent({
            index: Yn,
            hardened: si
          });
        }), Buffer.from(Qr, "hex"));
        return new Pe({
          requestId: Jr ? Buffer.from(u.parse(Jr)) : void 0,
          signData: Buffer.from(wr, "hex"),
          derivationPath: dn,
          origin: fn || void 0,
          xpub: Buffer.from(_r, "hex")
        });
      }
    }
    Pe.fromDataItem = (Dr) => {
      const wr = Dr.getData(), yr = wr[be.signData], Qr = A.CryptoKeypath.fromDataItem(wr[be.derivationPath]), _r = wr[be.requestId] ? wr[be.requestId].getData() : void 0, Jr = wr[be.origin] ? wr[be.origin] : void 0, fn = wr[be.xpub];
      return new Pe({
        requestId: _r,
        signData: yr,
        derivationPath: Qr,
        origin: Jr,
        xpub: fn
      });
    }, Pe.fromCBOR = (Dr) => {
      const wr = pe(Dr);
      return Pe.fromDataItem(wr);
    };
    const {
      RegistryTypes: Te,
      decodeToDataItem: Qe
    } = A.extend;
    var xe;
    (function(Dr) {
      Dr[Dr.requestId = 1] = "requestId", Dr[Dr.signature = 2] = "signature", Dr[Dr.publicKey = 3] = "publicKey";
    })(xe || (xe = {}));
    class Ee extends A.RegistryItem {
      constructor(wr, yr, Qr) {
        super(), this.getRegistryType = () => p.CARDANO_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const _r = {};
          return this.requestId && (_r[xe.requestId] = new A.DataItem(this.requestId, Te.UUID.getTag())), _r[xe.signature] = this.getSignature(), _r[xe.publicKey] = this.getPublicKey(), new A.DataItem(_r);
        }, this.signature = wr, this.publicKey = yr, this.requestId = Qr;
      }
    }
    Ee.fromDataItem = (Dr) => {
      const wr = Dr.getData(), yr = wr[xe.signature], Qr = wr[xe.publicKey], _r = wr[xe.requestId] ? wr[xe.requestId].getData() : void 0;
      return new Ee(yr, Qr, _r);
    }, Ee.fromCBOR = (Dr) => {
      const wr = Qe(Dr);
      return Ee.fromDataItem(wr);
    };
    const {
      decodeToDataItem: He
    } = A.extend;
    var ve;
    (function(Dr) {
      Dr[Dr.pubKey = 1] = "pubKey", Dr[Dr.weight = 2] = "weight";
    })(ve || (ve = {}));
    class we extends A.RegistryItem {
      constructor(wr) {
        super(), this.getRegistryType = () => p.CARDANO_DELEGATION, this.getPubKey = () => this.pubKey, this.getWeight = () => this.weight, this.toDataItem = () => {
          const yr = {};
          return yr[ve.pubKey] = this.getPubKey(), yr[ve.weight] = this.getWeight(), new A.DataItem(yr);
        }, this.pubKey = wr.pubKey, this.weight = wr.weight;
      }
      static constructCardanoDelegation({
        pubKey: wr,
        weight: yr
      }) {
        return new we({
          pubKey: wr,
          weight: yr
        });
      }
    }
    we.fromDataItem = (Dr) => {
      const wr = Dr.getData(), yr = wr[ve.pubKey], Qr = wr[ve.weight];
      return new we({
        pubKey: yr,
        weight: Qr
      });
    }, we.fromCBOR = (Dr) => {
      const wr = He(Dr);
      return we.fromDataItem(wr);
    };
    const {
      decodeToDataItem: Ce,
      RegistryTypes: Se
    } = A.extend;
    var Ne;
    (function(Dr) {
      Dr[Dr.requestId = 1] = "requestId", Dr[Dr.delegations = 2] = "delegations", Dr[Dr.stakePub = 3] = "stakePub", Dr[Dr.paymentAddress = 4] = "paymentAddress", Dr[Dr.nonce = 5] = "nonce", Dr[Dr.voting_purpose = 6] = "voting_purpose", Dr[Dr.derivationPath = 7] = "derivationPath", Dr[Dr.origin = 8] = "origin", Dr[Dr.signType = 9] = "signType";
    })(Ne || (Ne = {}));
    const rr = (Dr, wr) => {
      const yr = Dr.replace(/[m|M]\//, "").split("/");
      return new A.CryptoKeypath(yr.map((Qr) => {
        const _r = parseInt(Qr.replace("'", ""));
        let Jr = !1;
        return Qr.endsWith("'") && (Jr = !0), new A.PathComponent({
          index: _r,
          hardened: Jr
        });
      }), Buffer.from(wr, "hex"));
    };
    class er extends A.RegistryItem {
      constructor(wr) {
        super(), this.getRegistryType = () => p.CARDANO_CATALYST_VOTING_REGISTRATION, this.getRequestId = () => this.requestId, this.getDelegations = () => this.delegations, this.getStakePub = () => this.stakePub, this.getPaymentAddress = () => this.paymentAddress, this.getNonce = () => this.nonce, this.getVotingPurpose = () => this.voting_purpose, this.getDerivationPath = () => this.derivationPath.getPath(), this.getOrigin = () => this.origin, this.toDataItem = () => {
          const yr = {};
          this.requestId && (yr[Ne.requestId] = new A.DataItem(this.requestId, Se.UUID.getTag())), yr[Ne.stakePub] = this.stakePub, yr[Ne.paymentAddress] = this.paymentAddress, yr[Ne.nonce] = this.nonce, yr[Ne.voting_purpose] = this.voting_purpose, yr[Ne.delegations] = this.delegations.map((_r) => {
            const Jr = _r.toDataItem();
            return Jr.setTag(_r.getRegistryType().getTag()), Jr;
          }), this.origin && (yr[Ne.origin] = this.origin);
          const Qr = this.derivationPath.toDataItem();
          return Qr.setTag(this.derivationPath.getRegistryType().getTag()), yr[Ne.derivationPath] = Qr, new A.DataItem(yr);
        }, this.requestId = wr.requestId, this.derivationPath = wr.derivationPath, this.delegations = wr.delegations, this.stakePub = wr.stakePub, this.paymentAddress = wr.paymentAddress, this.nonce = wr.nonce, this.voting_purpose = wr.voting_purpose, this.origin = wr.origin;
      }
      static constructCardanoCatalystRequest(wr, yr, Qr, _r, Jr, fn, jr, dn, Tn) {
        const Yn = dn ? Buffer.from(u.parse(dn)) : void 0, si = wr.map((vn) => we.constructCardanoDelegation({
          pubKey: Buffer.from(vn.pubKey, "hex"),
          weight: vn.weight
        }));
        return new er({
          requestId: Yn,
          delegations: si,
          stakePub: Buffer.from(yr, "hex"),
          paymentAddress: Buffer.from(Qr, "hex"),
          nonce: _r,
          voting_purpose: Jr,
          derivationPath: rr(fn, jr),
          origin: Tn
        });
      }
    }
    er.fromDataItem = (Dr) => {
      const wr = Dr.getData(), yr = wr[Ne.delegations].map((Yn) => we.fromDataItem(Yn)), Qr = wr[Ne.stakePub], _r = wr[Ne.paymentAddress], Jr = wr[Ne.nonce], fn = wr[Ne.voting_purpose], jr = A.CryptoKeypath.fromDataItem(wr[Ne.derivationPath]), dn = wr[Ne.requestId] ? wr[Ne.requestId].getData() : void 0, Tn = wr[Ne.origin] ? wr[Ne.origin] : void 0;
      return new er({
        requestId: dn,
        delegations: yr,
        stakePub: Qr,
        paymentAddress: _r,
        nonce: Jr,
        voting_purpose: fn,
        derivationPath: jr,
        origin: Tn
      });
    }, er.fromCBOR = (Dr) => {
      const wr = Ce(Dr);
      return er.fromDataItem(wr);
    };
    const {
      RegistryTypes: ir,
      decodeToDataItem: sr
    } = A.extend;
    var nr;
    (function(Dr) {
      Dr[Dr.requestId = 1] = "requestId", Dr[Dr.signature = 2] = "signature";
    })(nr || (nr = {}));
    class fr extends A.RegistryItem {
      constructor(wr, yr) {
        super(), this.getRegistryType = () => p.CARDANO_CATALYST_VOTING_REGISTRATION_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const Qr = {};
          return this.requestId && (Qr[nr.requestId] = new A.DataItem(this.requestId, ir.UUID.getTag())), Qr[nr.signature] = this.getSignature(), new A.DataItem(Qr);
        }, this.signature = wr, this.requestId = yr;
      }
    }
    fr.fromDataItem = (Dr) => {
      const wr = Dr.getData(), yr = wr[nr.signature], Qr = wr[nr.requestId] ? wr[nr.requestId].getData() : void 0;
      return new fr(yr, Qr);
    }, fr.fromCBOR = (Dr) => {
      const wr = sr(Dr);
      return fr.fromDataItem(wr);
    };
    const {
      decodeToDataItem: lr,
      RegistryTypes: br
    } = A.extend;
    var Br;
    (function(Dr) {
      Dr[Dr.requestId = 1] = "requestId", Dr[Dr.signData = 2] = "signData", Dr[Dr.derivationPath = 3] = "derivationPath", Dr[Dr.origin = 4] = "origin", Dr[Dr.signType = 5] = "signType", Dr[Dr.xpub = 6] = "xpub", Dr[Dr.hashPayload = 7] = "hashPayload", Dr[Dr.addressBench32 = 8] = "addressBench32", Dr[Dr.addressFieldType = 9] = "addressFieldType";
    })(Br || (Br = {})), function(Dr) {
      Dr.ADDRESS = "ADDRESS", Dr.KEY_HASH = "KEY_HASH";
    }(s.MessageAddressFieldType || (s.MessageAddressFieldType = {}));
    class Fr extends A.RegistryItem {
      constructor(wr) {
        super(), this.getRegistryType = () => p.CARDANO_SIGN_CIP8_DATA_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getOrigin = () => this.origin, this.getXpub = () => this.xpub, this.getHashPayload = () => this.hashPayload, this.getAddressBench32 = () => this.addressBench32, this.getAddressFieldType = () => this.addressFieldType, this.toDataItem = () => {
          const yr = {};
          this.requestId && (yr[Br.requestId] = new A.DataItem(this.requestId, br.UUID.getTag())), this.origin && (yr[Br.origin] = this.origin), yr[Br.signData] = this.signData;
          const Qr = this.derivationPath.toDataItem();
          return Qr.setTag(this.derivationPath.getRegistryType().getTag()), yr[Br.derivationPath] = Qr, yr[Br.xpub] = this.xpub, yr[Br.hashPayload] = this.hashPayload, this.addressBench32 && (yr[Br.addressBench32] = this.addressBench32), yr[Br.addressFieldType] = this.addressFieldType, new A.DataItem(yr);
        }, this.requestId = wr.requestId, this.signData = wr.signData, this.derivationPath = wr.derivationPath, this.origin = wr.origin, this.xpub = wr.xpub, this.hashPayload = wr.hashPayload, this.addressBench32 = wr.addressBench32, this.addressFieldType = wr.addressFieldType;
      }
      static constructCardanoSignCip8DataRequest(wr, yr, Qr, _r, Jr, fn, jr, dn, Tn) {
        const Yn = yr.replace(/[m|M]\//, "").split("/"), si = new A.CryptoKeypath(Yn.map((vn) => {
          const Cn = parseInt(vn.replace("'", ""));
          let Xr = !1;
          return vn.endsWith("'") && (Xr = !0), new A.PathComponent({
            index: Cn,
            hardened: Xr
          });
        }), Buffer.from(Qr, "hex"));
        return new Fr({
          requestId: dn ? Buffer.from(u.parse(dn)) : void 0,
          signData: Buffer.from(wr, "hex"),
          derivationPath: si,
          origin: Tn || void 0,
          xpub: Buffer.from(_r, "hex"),
          hashPayload: Jr,
          addressBench32: jr || void 0,
          addressFieldType: fn
        });
      }
    }
    Fr.fromDataItem = (Dr) => {
      const wr = Dr.getData(), yr = wr[Br.signData], Qr = A.CryptoKeypath.fromDataItem(wr[Br.derivationPath]), _r = wr[Br.requestId] ? wr[Br.requestId].getData() : void 0, Jr = wr[Br.origin] ? wr[Br.origin] : void 0, fn = wr[Br.xpub], jr = wr[Br.hashPayload], dn = wr[Br.addressBench32] ? wr[Br.addressBench32] : void 0, Tn = wr[Br.addressFieldType];
      return new Fr({
        requestId: _r,
        signData: yr,
        derivationPath: Qr,
        origin: Jr,
        xpub: fn,
        hashPayload: jr,
        addressBench32: dn,
        addressFieldType: Tn
      });
    }, Fr.fromCBOR = (Dr) => {
      const wr = lr(Dr);
      return Fr.fromDataItem(wr);
    };
    const {
      RegistryTypes: Gr,
      decodeToDataItem: qr
    } = A.extend;
    var Hr;
    (function(Dr) {
      Dr[Dr.requestId = 1] = "requestId", Dr[Dr.signature = 2] = "signature", Dr[Dr.publicKey = 3] = "publicKey", Dr[Dr.addressField = 4] = "addressField";
    })(Hr || (Hr = {}));
    class un extends A.RegistryItem {
      constructor(wr, yr, Qr, _r) {
        super(), this.getRegistryType = () => p.CARDANO_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.getAddressField = () => this.addressField, this.toDataItem = () => {
          const Jr = {};
          return this.requestId && (Jr[Hr.requestId] = new A.DataItem(this.requestId, Gr.UUID.getTag())), Jr[Hr.signature] = this.getSignature(), Jr[Hr.publicKey] = this.getPublicKey(), Jr[Hr.addressField] = this.getAddressField(), new A.DataItem(Jr);
        }, this.signature = wr, this.publicKey = yr, this.requestId = _r, this.addressField = Qr;
      }
    }
    un.fromDataItem = (Dr) => {
      const wr = Dr.getData(), yr = wr[Hr.signature], Qr = wr[Hr.publicKey], _r = wr[Hr.requestId] ? wr[Hr.requestId].getData() : void 0, Jr = wr[Hr.addressField];
      return new un(yr, Qr, Jr, _r);
    }, un.fromCBOR = (Dr) => {
      const wr = qr(Dr);
      return un.fromDataItem(wr);
    }, A.patchTags(Object.values(p).filter((Dr) => !!Dr.getTag()).map((Dr) => Dr.getTag())), Object.keys(A).forEach(function(Dr) {
      Dr !== "default" && Object.defineProperty(s, Dr, {
        enumerable: !0,
        get: function() {
          return A[Dr];
        }
      });
    }), s.CardanoCatalystRequest = er, s.CardanoCatalystSignature = fr, s.CardanoCertKey = C, s.CardanoSignCip8DataRequest = Fr, s.CardanoSignCip8DataSignature = un, s.CardanoSignDataRequest = Pe, s.CardanoSignDataSignature = Ee, s.CardanoSignRequest = x, s.CardanoSignature = ge;
  }(bcUrRegistryCardano_cjs_development)), bcUrRegistryCardano_cjs_development;
}
var hasRequiredDist$9;
function requireDist$9() {
  return hasRequiredDist$9 || (hasRequiredDist$9 = 1, process$1.env.NODE_ENV === "production" ? dist$8.exports = requireBcUrRegistryCardano_cjs_production_min() : dist$8.exports = requireBcUrRegistryCardano_cjs_development()), dist$8.exports;
}
var hasRequiredCardano;
function requireCardano() {
  if (hasRequiredCardano) return cardano;
  hasRequiredCardano = 1, Object.defineProperty(cardano, "__esModule", { value: !0 }), cardano.KeystoneCardanoSDK = void 0;
  const s = requireDist$9(), A = requireUtils$d(), u = requireUr();
  class p {
    parseSignature(l) {
      if (l.type !== u.URType.CardanoSignature)
        throw new Error("type not match");
      const m = s.CardanoSignature.fromCBOR(l.cbor), b = m.getRequestId();
      return {
        requestId: Buffer.isBuffer(b) ? (0, A.uuidStringify)(b) : "",
        witnessSet: (0, A.toHex)(m.getWitnessSet())
      };
    }
    parseSignDataSignature(l) {
      if (l.type !== u.URType.CardanoSignDataSignature)
        throw new Error("type not match");
      const m = s.CardanoSignDataSignature.fromCBOR(l.cbor), b = m.getRequestId();
      return {
        requestId: Buffer.isBuffer(b) ? (0, A.uuidStringify)(b) : "",
        signature: (0, A.toHex)(m.getSignature()),
        publicKey: (0, A.toHex)(m.getPublicKey())
      };
    }
    parseSignCip8DataSignature(l) {
      if (l.type !== u.URType.CardanoSignCip8DataSignature)
        throw new Error("type not match");
      const m = s.CardanoSignCip8DataSignature.fromCBOR(l.cbor), b = m.getSignature(), k = m.getPublicKey(), C = m.getAddressField();
      return {
        requestId: "",
        signature: (0, A.toHex)(b),
        publicKey: (0, A.toHex)(k),
        addressField: (0, A.toHex)(C)
      };
    }
    parseCatalystSignature(l) {
      if (l.type !== u.URType.CardanoCatalystSignature)
        throw new Error("type not match");
      const m = s.CardanoCatalystSignature.fromCBOR(l.cbor), b = m.getRequestId();
      return {
        requestId: Buffer.isBuffer(b) ? (0, A.uuidStringify)(b) : "",
        signature: (0, A.toHex)(m.getSignature())
      };
    }
    generateSignDataRequest({ requestId: l, payload: m, sigStructure: b, path: k, xpub: C, pubKey: B, xfp: Q, origin: P }) {
      return s.CardanoSignDataRequest.constructCardanoSignDataRequest(b ?? m, k, Q, B ?? C, l, P).toUR();
    }
    generateSignCip8DataRequest(l) {
      return s.CardanoSignCip8DataRequest.constructCardanoSignCip8DataRequest(l.messageHex, l.path, l.xfp, l.xpub, l.hashPayload, l.addressFieldType, "address" in l ? l.address : void 0, l.requestId, l.origin).toUR();
    }
    generateCatalystRequest(l) {
      return s.CardanoCatalystRequest.constructCardanoCatalystRequest(l.delegations, l.stakePub, l.paymentAddress, l.nonce, l.voting_purpose, l.path, l.xfp, l.requestId, l.origin).toUR();
    }
    generateSignRequest({ signData: l, utxos: m, extraSigners: b, requestId: k, origin: C }) {
      return s.CardanoSignRequest.constructCardanoSignRequest(l, m, b, k, C).toUR();
    }
  }
  return cardano.KeystoneCardanoSDK = p, cardano;
}
var arweave = {}, dist$7 = { exports: {} }, bcUrRegistryArweave_cjs_production_min = {}, hasRequiredBcUrRegistryArweave_cjs_production_min;
function requireBcUrRegistryArweave_cjs_production_min() {
  return hasRequiredBcUrRegistryArweave_cjs_production_min || (hasRequiredBcUrRegistryArweave_cjs_production_min = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$i(), u = require$$1$2;
    const p = { ARWEAVE_CRYPTO_ACCOUNT: new A.RegistryType("arweave-crypto-account", 5101), ARWEAVE_SIGN_REQUEST: new A.RegistryType("arweave-sign-request", 5102), ARWEAVE_SIGNATURE: new A.RegistryType("arweave-signature", 5103) }, { decodeToDataItem: t, RegistryTypes: l } = A.extend;
    var m, b, k;
    (m = s.SignType || (s.SignType = {}))[m.Transaction = 1] = "Transaction", m[m.DataItem = 2] = "DataItem", m[m.Message = 3] = "Message", (b = s.SaltLen || (s.SaltLen = {}))[b.Zero = 0] = "Zero", b[b.Digest = 32] = "Digest", function(ge) {
      ge[ge.masterFingerprint = 1] = "masterFingerprint", ge[ge.requestId = 2] = "requestId", ge[ge.signData = 3] = "signData", ge[ge.signType = 4] = "signType", ge[ge.saltLen = 5] = "saltLen", ge[ge.origin = 6] = "origin", ge[ge.account = 7] = "account";
    }(k || (k = {}));
    class C extends A.RegistryItem {
      constructor(pe) {
        super(), this.getRegistryType = () => p.ARWEAVE_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getSignType = () => this.signType, this.getSaltLen = () => this.saltLen, this.getOrigin = () => this.origin, this.getAccount = () => this.account, this.getMasterFingerprint = () => this.masterFingerprint, this.toDataItem = () => {
          const Ie = {};
          return this.requestId && (Ie[k.requestId] = new A.DataItem(this.requestId, l.UUID.getTag())), this.account && (Ie[k.account] = this.account), this.origin && (Ie[k.origin] = this.origin), Ie[k.masterFingerprint] = this.masterFingerprint.readUInt32BE(0), Ie[k.signData] = this.signData, Ie[k.signType] = this.signType, Ie[k.saltLen] = this.saltLen, new A.DataItem(Ie);
        }, this.masterFingerprint = pe.masterFingerprint, this.requestId = pe.requestId, this.signData = pe.signData, this.signType = pe.signType, this.saltLen = pe.saltLen, this.origin = pe.origin, this.account = pe.account;
      }
      static constructArweaveRequest(pe, Ie, be, Pe, Te, Qe, xe) {
        return new C({ masterFingerprint: Buffer.from(Ie, "hex"), requestId: Te ? Buffer.from(u.parse(Te)) : void 0, signData: pe, signType: be, saltLen: Pe, account: Qe, origin: xe });
      }
    }
    C.fromDataItem = (ge) => {
      const pe = ge.getData(), Ie = pe[k.signData], be = pe[k.account] ? pe[k.account] : void 0, Pe = pe[k.requestId] ? pe[k.requestId].getData() : void 0, Te = pe[k.origin] ? pe[k.origin] : void 0, Qe = pe[k.signType], xe = pe[k.saltLen], Ee = Buffer.alloc(4);
      return Ee.writeUInt32BE(pe[k.masterFingerprint], 0), new C({ masterFingerprint: Ee, requestId: Pe, signData: Ie, signType: Qe, saltLen: xe, origin: Te, account: be });
    }, C.fromCBOR = (ge) => {
      const pe = t(ge);
      return C.fromDataItem(pe);
    };
    const { RegistryTypes: B, decodeToDataItem: Q } = A.extend;
    var P;
    (function(ge) {
      ge[ge.requestId = 1] = "requestId", ge[ge.signature = 2] = "signature";
    })(P || (P = {}));
    class x extends A.RegistryItem {
      constructor(pe, Ie) {
        super(), this.getRegistryType = () => p.ARWEAVE_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const be = {};
          return this.requestId && (be[P.requestId] = new A.DataItem(this.requestId, B.UUID.getTag())), be[P.signature] = this.signature, new A.DataItem(be);
        }, this.signature = pe, this.requestId = Ie;
      }
    }
    x.fromDataItem = (ge) => {
      const pe = ge.getData(), Ie = pe[P.signature], be = pe[P.requestId] ? pe[P.requestId].getData() : void 0;
      return new x(Ie, be);
    }, x.fromCBOR = (ge) => {
      const pe = Q(ge);
      return x.fromDataItem(pe);
    };
    const { decodeToDataItem: M } = A.extend;
    var F;
    (function(ge) {
      ge[ge.masterFingerprint = 1] = "masterFingerprint", ge[ge.keyData = 2] = "keyData", ge[ge.device = 3] = "device";
    })(F || (F = {}));
    class le extends A.RegistryItem {
      constructor(pe, Ie, be) {
        super(), this.masterFingerprint = pe, this.keyData = Ie, this.device = be, this.getRegistryType = () => p.ARWEAVE_CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeyData = () => this.keyData, this.getDevice = () => this.device, this.toDataItem = () => {
          const Pe = {};
          return Pe[F.masterFingerprint] = this.masterFingerprint.readUInt32BE(0), Pe[F.keyData] = this.keyData, this.device && (Pe[F.device] = this.device), new A.DataItem(Pe);
        };
      }
    }
    le.fromDataItem = (ge) => {
      const pe = ge.getData(), Ie = pe[F.keyData], be = Buffer.alloc(4);
      return be.writeUInt32BE(pe[F.masterFingerprint], 0), new le(be, Ie, pe[F.device] ? pe[F.device] : void 0);
    }, le.fromCBOR = (ge) => {
      const pe = M(ge);
      return le.fromDataItem(pe);
    }, A.patchTags(Object.values(p).filter((ge) => !!ge.getTag()).map((ge) => ge.getTag())), Object.keys(A).forEach(function(ge) {
      ge !== "default" && Object.defineProperty(s, ge, { enumerable: !0, get: function() {
        return A[ge];
      } });
    }), s.ArweaveCryptoAccount = le, s.ArweaveSignRequest = C, s.ArweaveSignature = x;
  }(bcUrRegistryArweave_cjs_production_min)), bcUrRegistryArweave_cjs_production_min;
}
var bcUrRegistryArweave_cjs_development = {}, hasRequiredBcUrRegistryArweave_cjs_development;
function requireBcUrRegistryArweave_cjs_development() {
  return hasRequiredBcUrRegistryArweave_cjs_development || (hasRequiredBcUrRegistryArweave_cjs_development = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$i(), u = require$$1$2;
    const p = {
      ARWEAVE_CRYPTO_ACCOUNT: /* @__PURE__ */ new A.RegistryType("arweave-crypto-account", 5101),
      ARWEAVE_SIGN_REQUEST: /* @__PURE__ */ new A.RegistryType("arweave-sign-request", 5102),
      ARWEAVE_SIGNATURE: /* @__PURE__ */ new A.RegistryType("arweave-signature", 5103)
    }, {
      decodeToDataItem: t,
      RegistryTypes: l
    } = A.extend;
    (function(F) {
      F[F.Transaction = 1] = "Transaction", F[F.DataItem = 2] = "DataItem", F[F.Message = 3] = "Message";
    })(s.SignType || (s.SignType = {})), function(F) {
      F[F.Zero = 0] = "Zero", F[F.Digest = 32] = "Digest";
    }(s.SaltLen || (s.SaltLen = {}));
    var m;
    (function(F) {
      F[F.masterFingerprint = 1] = "masterFingerprint", F[F.requestId = 2] = "requestId", F[F.signData = 3] = "signData", F[F.signType = 4] = "signType", F[F.saltLen = 5] = "saltLen", F[F.origin = 6] = "origin", F[F.account = 7] = "account";
    })(m || (m = {}));
    class b extends A.RegistryItem {
      constructor(le) {
        super(), this.getRegistryType = () => p.ARWEAVE_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getSignType = () => this.signType, this.getSaltLen = () => this.saltLen, this.getOrigin = () => this.origin, this.getAccount = () => this.account, this.getMasterFingerprint = () => this.masterFingerprint, this.toDataItem = () => {
          const ge = {};
          return this.requestId && (ge[m.requestId] = new A.DataItem(this.requestId, l.UUID.getTag())), this.account && (ge[m.account] = this.account), this.origin && (ge[m.origin] = this.origin), ge[m.masterFingerprint] = this.masterFingerprint.readUInt32BE(0), ge[m.signData] = this.signData, ge[m.signType] = this.signType, ge[m.saltLen] = this.saltLen, new A.DataItem(ge);
        }, this.masterFingerprint = le.masterFingerprint, this.requestId = le.requestId, this.signData = le.signData, this.signType = le.signType, this.saltLen = le.saltLen, this.origin = le.origin, this.account = le.account;
      }
      static constructArweaveRequest(le, ge, pe, Ie, be, Pe, Te) {
        return new b({
          masterFingerprint: Buffer.from(ge, "hex"),
          requestId: be ? Buffer.from(u.parse(be)) : void 0,
          signData: le,
          signType: pe,
          saltLen: Ie,
          account: Pe,
          origin: Te
        });
      }
    }
    b.fromDataItem = (F) => {
      const le = F.getData(), ge = le[m.signData], pe = le[m.account] ? le[m.account] : void 0, Ie = le[m.requestId] ? le[m.requestId].getData() : void 0, be = le[m.origin] ? le[m.origin] : void 0, Pe = le[m.signType], Te = le[m.saltLen], Qe = Buffer.alloc(4), xe = le[m.masterFingerprint];
      return Qe.writeUInt32BE(xe, 0), new b({
        masterFingerprint: Qe,
        requestId: Ie,
        signData: ge,
        signType: Pe,
        saltLen: Te,
        origin: be,
        account: pe
      });
    }, b.fromCBOR = (F) => {
      const le = t(F);
      return b.fromDataItem(le);
    };
    const {
      RegistryTypes: k,
      decodeToDataItem: C
    } = A.extend;
    var B;
    (function(F) {
      F[F.requestId = 1] = "requestId", F[F.signature = 2] = "signature";
    })(B || (B = {}));
    class Q extends A.RegistryItem {
      constructor(le, ge) {
        super(), this.getRegistryType = () => p.ARWEAVE_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const pe = {};
          return this.requestId && (pe[B.requestId] = new A.DataItem(this.requestId, k.UUID.getTag())), pe[B.signature] = this.signature, new A.DataItem(pe);
        }, this.signature = le, this.requestId = ge;
      }
    }
    Q.fromDataItem = (F) => {
      const le = F.getData(), ge = le[B.signature], pe = le[B.requestId] ? le[B.requestId].getData() : void 0;
      return new Q(ge, pe);
    }, Q.fromCBOR = (F) => {
      const le = C(F);
      return Q.fromDataItem(le);
    };
    const {
      decodeToDataItem: P
    } = A.extend;
    var x;
    (function(F) {
      F[F.masterFingerprint = 1] = "masterFingerprint", F[F.keyData = 2] = "keyData", F[F.device = 3] = "device";
    })(x || (x = {}));
    class M extends A.RegistryItem {
      constructor(le, ge, pe) {
        super(), this.masterFingerprint = le, this.keyData = ge, this.device = pe, this.getRegistryType = () => p.ARWEAVE_CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeyData = () => this.keyData, this.getDevice = () => this.device, this.toDataItem = () => {
          const Ie = {};
          return Ie[x.masterFingerprint] = this.masterFingerprint.readUInt32BE(0), Ie[x.keyData] = this.keyData, this.device && (Ie[x.device] = this.device), new A.DataItem(Ie);
        };
      }
    }
    M.fromDataItem = (F) => {
      const le = F.getData(), ge = le[x.keyData], pe = Buffer.alloc(4), Ie = le[x.masterFingerprint];
      pe.writeUInt32BE(Ie, 0);
      const be = le[x.device] ? le[x.device] : void 0;
      return new M(pe, ge, be);
    }, M.fromCBOR = (F) => {
      const le = P(F);
      return M.fromDataItem(le);
    }, A.patchTags(Object.values(p).filter((F) => !!F.getTag()).map((F) => F.getTag())), Object.keys(A).forEach(function(F) {
      F !== "default" && Object.defineProperty(s, F, {
        enumerable: !0,
        get: function() {
          return A[F];
        }
      });
    }), s.ArweaveCryptoAccount = M, s.ArweaveSignRequest = b, s.ArweaveSignature = Q;
  }(bcUrRegistryArweave_cjs_development)), bcUrRegistryArweave_cjs_development;
}
var hasRequiredDist$8;
function requireDist$8() {
  return hasRequiredDist$8 || (hasRequiredDist$8 = 1, process$1.env.NODE_ENV === "production" ? dist$7.exports = requireBcUrRegistryArweave_cjs_production_min() : dist$7.exports = requireBcUrRegistryArweave_cjs_development()), dist$7.exports;
}
var hasRequiredArweave;
function requireArweave() {
  if (hasRequiredArweave) return arweave;
  hasRequiredArweave = 1, Object.defineProperty(arweave, "__esModule", { value: !0 }), arweave.KeystoneArweaveSDK = void 0;
  const s = requireUtils$d(), A = requireUr(), u = requireDist$8();
  class p {
    parseAccount(l) {
      if (l.type !== A.URType.ArweaveCryptoAccount)
        throw new Error("type not match");
      const m = u.ArweaveCryptoAccount.fromCBOR(l.cbor);
      return {
        masterFingerprint: (0, s.toHex)(m.getMasterFingerprint()),
        keyData: (0, s.toHex)(m.getKeyData()),
        device: m.getDevice()
      };
    }
    parseSignature(l) {
      if (l.type !== A.URType.ArweaveSignature)
        throw new Error("type not match");
      const m = u.ArweaveSignature.fromCBOR(l.cbor), b = m.getRequestId();
      return {
        requestId: (0, s.uuidStringify)(b),
        signature: (0, s.toHex)(m.getSignature())
      };
    }
    generateSignRequest({ requestId: l, signData: m, signType: b, saltLen: k, masterFingerprint: C, account: B, origin: Q }) {
      return new u.ArweaveSignRequest({
        requestId: (0, s.uuidParse)(l),
        signData: (0, s.toBuffer)(m),
        signType: b,
        saltLen: k,
        masterFingerprint: (0, s.toBuffer)(C),
        account: B !== void 0 ? (0, s.toBuffer)(B) : void 0,
        origin: Q
      }).toUR();
    }
  }
  return p.SignType = u.SignType, p.SaltLen = u.SaltLen, arweave.KeystoneArweaveSDK = p, arweave;
}
var sui = {}, dist$6 = { exports: {} }, bcUrRegistrySui_cjs_production_min = {}, hasRequiredBcUrRegistrySui_cjs_production_min;
function requireBcUrRegistrySui_cjs_production_min() {
  return hasRequiredBcUrRegistrySui_cjs_production_min || (hasRequiredBcUrRegistrySui_cjs_production_min = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$i(), u = /* @__PURE__ */ requireCommonjsBrowser();
    const p = { SUI_SIGN_REQUEST: new A.RegistryType("sui-sign-request", 7101), SUI_SIGNATURE: new A.RegistryType("sui-signature", 7102), SUI_SIGN_HASH_REQUEST: new A.RegistryType("sui-sign-hash-request", 7103) }, { decodeToDataItem: t, RegistryTypes: l } = A.extend;
    var m;
    (function(le) {
      le[le.requestId = 1] = "requestId", le[le.intentMessage = 2] = "intentMessage", le[le.derivationPaths = 3] = "derivationPaths", le[le.addresses = 4] = "addresses", le[le.origin = 5] = "origin";
    })(m || (m = {}));
    class b extends A.RegistryItem {
      constructor(ge) {
        super(), this.getRegistryType = () => p.SUI_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getIntentMessage = () => this.intentMessage, this.getDerivationPaths = () => this.derivationPaths.map((pe) => pe.getPath()), this.getAddresses = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const pe = {};
          return this.requestId && (pe[m.requestId] = new A.DataItem(this.requestId, l.UUID.getTag())), this.addresses && (pe[m.addresses] = this.addresses), this.origin && (pe[m.origin] = this.origin), pe[m.intentMessage] = this.intentMessage, pe[m.derivationPaths] = this.derivationPaths.map((Ie) => {
            const be = Ie.toDataItem();
            return be.setTag(Ie.getRegistryType().getTag()), be;
          }), new A.DataItem(pe);
        }, this.requestId = ge.requestId, this.intentMessage = ge.intentMessage, this.derivationPaths = ge.derivationPaths, this.addresses = ge.addresses, this.origin = ge.origin;
      }
      static constructSuiRequest(ge, pe, Ie, be, Pe, Te) {
        const Qe = pe.map((xe, Ee) => {
          const He = xe.replace(/[m|M]\//, "").split("/").map((ve) => {
            const we = parseInt(ve.replace("'", ""));
            let Ce = !1;
            return ve.endsWith("'") && (Ce = !0), new A.PathComponent({ index: we, hardened: Ce });
          });
          return new A.CryptoKeypath(He, Buffer.from(Ie[Ee], "hex"));
        });
        return new b({ requestId: Buffer.from(u.parse(be)), intentMessage: ge, derivationPaths: Qe, addresses: Pe || void 0, origin: Te || void 0 });
      }
    }
    b.fromDataItem = (le) => {
      const ge = le.getData(), pe = ge[m.intentMessage], Ie = ge[m.derivationPaths].map((Te) => A.CryptoKeypath.fromDataItem(Te)), be = ge[m.addresses] ? ge[m.addresses] : void 0, Pe = ge[m.requestId] ? ge[m.requestId].getData() : void 0;
      return new b({ requestId: Pe, intentMessage: pe, derivationPaths: Ie, addresses: be, origin: ge[m.origin] ? ge[m.origin] : void 0 });
    }, b.fromCBOR = (le) => {
      const ge = t(le);
      return b.fromDataItem(ge);
    };
    const { RegistryTypes: k, decodeToDataItem: C } = A.extend;
    var B;
    (function(le) {
      le[le.requestId = 1] = "requestId", le[le.signature = 2] = "signature", le[le.publicKey = 3] = "publicKey";
    })(B || (B = {}));
    class Q extends A.RegistryItem {
      constructor(ge, pe, Ie) {
        super(), this.getRegistryType = () => p.SUI_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const be = {};
          return this.requestId && (be[B.requestId] = new A.DataItem(this.requestId, k.UUID.getTag())), be[B.signature] = this.signature, this.publicKey && (be[B.publicKey] = this.publicKey), new A.DataItem(be);
        }, this.signature = ge, this.requestId = pe, this.publicKey = Ie;
      }
    }
    Q.fromDataItem = (le) => {
      const ge = le.getData(), pe = ge[B.signature], Ie = ge[B.requestId].getData();
      return new Q(pe, Ie, ge[B.publicKey]);
    }, Q.fromCBOR = (le) => {
      const ge = C(le);
      return Q.fromDataItem(ge);
    };
    const { decodeToDataItem: P, RegistryTypes: x } = A.extend;
    var M;
    (function(le) {
      le[le.requestId = 1] = "requestId", le[le.messageHash = 2] = "messageHash", le[le.derivationPaths = 3] = "derivationPaths", le[le.addresses = 4] = "addresses", le[le.origin = 5] = "origin";
    })(M || (M = {}));
    class F extends A.RegistryItem {
      constructor(ge) {
        super(), this.getRegistryType = () => p.SUI_SIGN_HASH_REQUEST, this.getRequestId = () => this.requestId, this.getMessageHash = () => this.messageHash, this.getDerivationPaths = () => this.derivationPaths.map((pe) => pe.getPath()), this.getAddresses = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const pe = {};
          return this.requestId && (pe[M.requestId] = new A.DataItem(this.requestId, x.UUID.getTag())), this.addresses && (pe[M.addresses] = this.addresses), this.origin && (pe[M.origin] = this.origin), pe[M.messageHash] = this.messageHash, pe[M.derivationPaths] = this.derivationPaths.map((Ie) => {
            const be = Ie.toDataItem();
            return be.setTag(Ie.getRegistryType().getTag()), be;
          }), new A.DataItem(pe);
        }, this.requestId = ge.requestId, this.messageHash = ge.messageHash, this.derivationPaths = ge.derivationPaths, this.addresses = ge.addresses, this.origin = ge.origin;
      }
      static constructSuiRequest(ge, pe, Ie, be, Pe, Te) {
        const Qe = pe.map((xe, Ee) => {
          const He = xe.replace(/[m|M]\//, "").split("/").map((ve) => {
            const we = parseInt(ve.replace("'", ""));
            let Ce = !1;
            return ve.endsWith("'") && (Ce = !0), new A.PathComponent({ index: we, hardened: Ce });
          });
          return new A.CryptoKeypath(He, Buffer.from(Ie[Ee], "hex"));
        });
        return new F({ requestId: Buffer.from(u.parse(be)), messageHash: ge, derivationPaths: Qe, addresses: Pe || void 0, origin: Te || void 0 });
      }
    }
    F.fromDataItem = (le) => {
      const ge = le.getData(), pe = ge[M.messageHash], Ie = ge[M.derivationPaths].map((Te) => A.CryptoKeypath.fromDataItem(Te)), be = ge[M.addresses] ? ge[M.addresses] : void 0, Pe = ge[M.requestId] ? ge[M.requestId].getData() : void 0;
      return new F({ requestId: Pe, messageHash: pe, derivationPaths: Ie, addresses: be, origin: ge[M.origin] ? ge[M.origin] : void 0 });
    }, F.fromCBOR = (le) => {
      const ge = P(le);
      return F.fromDataItem(ge);
    }, A.patchTags(Object.values(p).filter((le) => !!le.getTag()).map((le) => le.getTag())), Object.keys(A).forEach(function(le) {
      le !== "default" && Object.defineProperty(s, le, { enumerable: !0, get: function() {
        return A[le];
      } });
    }), s.SuiSignHashRequest = F, s.SuiSignRequest = b, s.SuiSignature = Q;
  }(bcUrRegistrySui_cjs_production_min)), bcUrRegistrySui_cjs_production_min;
}
var bcUrRegistrySui_cjs_development = {}, hasRequiredBcUrRegistrySui_cjs_development;
function requireBcUrRegistrySui_cjs_development() {
  return hasRequiredBcUrRegistrySui_cjs_development || (hasRequiredBcUrRegistrySui_cjs_development = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$i(), u = /* @__PURE__ */ requireCommonjsBrowser();
    const p = {
      SUI_SIGN_REQUEST: /* @__PURE__ */ new A.RegistryType("sui-sign-request", 7101),
      SUI_SIGNATURE: /* @__PURE__ */ new A.RegistryType("sui-signature", 7102),
      SUI_SIGN_HASH_REQUEST: /* @__PURE__ */ new A.RegistryType("sui-sign-hash-request", 7103)
    }, {
      decodeToDataItem: t,
      RegistryTypes: l
    } = A.extend;
    var m;
    (function(le) {
      le[le.requestId = 1] = "requestId", le[le.intentMessage = 2] = "intentMessage", le[le.derivationPaths = 3] = "derivationPaths", le[le.addresses = 4] = "addresses", le[le.origin = 5] = "origin";
    })(m || (m = {}));
    class b extends A.RegistryItem {
      constructor(ge) {
        super(), this.getRegistryType = () => p.SUI_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getIntentMessage = () => this.intentMessage, this.getDerivationPaths = () => this.derivationPaths.map((pe) => pe.getPath()), this.getAddresses = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const pe = {};
          return this.requestId && (pe[m.requestId] = new A.DataItem(this.requestId, l.UUID.getTag())), this.addresses && (pe[m.addresses] = this.addresses), this.origin && (pe[m.origin] = this.origin), pe[m.intentMessage] = this.intentMessage, pe[m.derivationPaths] = this.derivationPaths.map((Ie) => {
            const be = Ie.toDataItem();
            return be.setTag(Ie.getRegistryType().getTag()), be;
          }), new A.DataItem(pe);
        }, this.requestId = ge.requestId, this.intentMessage = ge.intentMessage, this.derivationPaths = ge.derivationPaths, this.addresses = ge.addresses, this.origin = ge.origin;
      }
      static constructSuiRequest(ge, pe, Ie, be, Pe, Te) {
        const Qe = pe.map((xe, Ee) => {
          const ve = xe.replace(/[m|M]\//, "").split("/").map((we) => {
            const Ce = parseInt(we.replace("'", ""));
            let Se = !1;
            return we.endsWith("'") && (Se = !0), new A.PathComponent({
              index: Ce,
              hardened: Se
            });
          });
          return new A.CryptoKeypath(ve, Buffer.from(Ie[Ee], "hex"));
        });
        return new b({
          requestId: Buffer.from(u.parse(be)),
          intentMessage: ge,
          derivationPaths: Qe,
          addresses: Pe || void 0,
          origin: Te || void 0
        });
      }
    }
    b.fromDataItem = (le) => {
      const ge = le.getData(), pe = ge[m.intentMessage], Ie = ge[m.derivationPaths].map((Qe) => A.CryptoKeypath.fromDataItem(Qe)), be = ge[m.addresses] ? ge[m.addresses] : void 0, Pe = ge[m.requestId] ? ge[m.requestId].getData() : void 0, Te = ge[m.origin] ? ge[m.origin] : void 0;
      return new b({
        requestId: Pe,
        intentMessage: pe,
        derivationPaths: Ie,
        addresses: be,
        origin: Te
      });
    }, b.fromCBOR = (le) => {
      const ge = t(le);
      return b.fromDataItem(ge);
    };
    const {
      RegistryTypes: k,
      decodeToDataItem: C
    } = A.extend;
    var B;
    (function(le) {
      le[le.requestId = 1] = "requestId", le[le.signature = 2] = "signature", le[le.publicKey = 3] = "publicKey";
    })(B || (B = {}));
    class Q extends A.RegistryItem {
      constructor(ge, pe, Ie) {
        super(), this.getRegistryType = () => p.SUI_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const be = {};
          return this.requestId && (be[B.requestId] = new A.DataItem(this.requestId, k.UUID.getTag())), be[B.signature] = this.signature, this.publicKey && (be[B.publicKey] = this.publicKey), new A.DataItem(be);
        }, this.signature = ge, this.requestId = pe, this.publicKey = Ie;
      }
    }
    Q.fromDataItem = (le) => {
      const ge = le.getData(), pe = ge[B.signature], Ie = ge[B.requestId].getData(), be = ge[B.publicKey];
      return new Q(pe, Ie, be);
    }, Q.fromCBOR = (le) => {
      const ge = C(le);
      return Q.fromDataItem(ge);
    };
    const {
      decodeToDataItem: P,
      RegistryTypes: x
    } = A.extend;
    var M;
    (function(le) {
      le[le.requestId = 1] = "requestId", le[le.messageHash = 2] = "messageHash", le[le.derivationPaths = 3] = "derivationPaths", le[le.addresses = 4] = "addresses", le[le.origin = 5] = "origin";
    })(M || (M = {}));
    class F extends A.RegistryItem {
      constructor(ge) {
        super(), this.getRegistryType = () => p.SUI_SIGN_HASH_REQUEST, this.getRequestId = () => this.requestId, this.getMessageHash = () => this.messageHash, this.getDerivationPaths = () => this.derivationPaths.map((pe) => pe.getPath()), this.getAddresses = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const pe = {};
          return this.requestId && (pe[M.requestId] = new A.DataItem(this.requestId, x.UUID.getTag())), this.addresses && (pe[M.addresses] = this.addresses), this.origin && (pe[M.origin] = this.origin), pe[M.messageHash] = this.messageHash, pe[M.derivationPaths] = this.derivationPaths.map((Ie) => {
            const be = Ie.toDataItem();
            return be.setTag(Ie.getRegistryType().getTag()), be;
          }), new A.DataItem(pe);
        }, this.requestId = ge.requestId, this.messageHash = ge.messageHash, this.derivationPaths = ge.derivationPaths, this.addresses = ge.addresses, this.origin = ge.origin;
      }
      static constructSuiRequest(ge, pe, Ie, be, Pe, Te) {
        const Qe = pe.map((xe, Ee) => {
          const ve = xe.replace(/[m|M]\//, "").split("/").map((we) => {
            const Ce = parseInt(we.replace("'", ""));
            let Se = !1;
            return we.endsWith("'") && (Se = !0), new A.PathComponent({
              index: Ce,
              hardened: Se
            });
          });
          return new A.CryptoKeypath(ve, Buffer.from(Ie[Ee], "hex"));
        });
        return new F({
          requestId: Buffer.from(u.parse(be)),
          messageHash: ge,
          derivationPaths: Qe,
          addresses: Pe || void 0,
          origin: Te || void 0
        });
      }
    }
    F.fromDataItem = (le) => {
      const ge = le.getData(), pe = ge[M.messageHash], Ie = ge[M.derivationPaths].map((Qe) => A.CryptoKeypath.fromDataItem(Qe)), be = ge[M.addresses] ? ge[M.addresses] : void 0, Pe = ge[M.requestId] ? ge[M.requestId].getData() : void 0, Te = ge[M.origin] ? ge[M.origin] : void 0;
      return new F({
        requestId: Pe,
        messageHash: pe,
        derivationPaths: Ie,
        addresses: be,
        origin: Te
      });
    }, F.fromCBOR = (le) => {
      const ge = P(le);
      return F.fromDataItem(ge);
    }, A.patchTags(Object.values(p).filter((le) => !!le.getTag()).map((le) => le.getTag())), Object.keys(A).forEach(function(le) {
      le !== "default" && Object.defineProperty(s, le, {
        enumerable: !0,
        get: function() {
          return A[le];
        }
      });
    }), s.SuiSignHashRequest = F, s.SuiSignRequest = b, s.SuiSignature = Q;
  }(bcUrRegistrySui_cjs_development)), bcUrRegistrySui_cjs_development;
}
var hasRequiredDist$7;
function requireDist$7() {
  return hasRequiredDist$7 || (hasRequiredDist$7 = 1, process$1.env.NODE_ENV === "production" ? dist$6.exports = requireBcUrRegistrySui_cjs_production_min() : dist$6.exports = requireBcUrRegistrySui_cjs_development()), dist$6.exports;
}
var blake2b$1 = {}, blake2 = {}, _blake = {}, hasRequired_blake;
function require_blake() {
  if (hasRequired_blake) return _blake;
  hasRequired_blake = 1, Object.defineProperty(_blake, "__esModule", { value: !0 }), _blake.BSIGMA = void 0, _blake.G1s = A, _blake.G2s = u;
  const s = /* @__PURE__ */ requireUtils$j();
  _blake.BSIGMA = Uint8Array.from([
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3,
    11,
    8,
    12,
    0,
    5,
    2,
    15,
    13,
    10,
    14,
    3,
    6,
    7,
    1,
    9,
    4,
    7,
    9,
    3,
    1,
    13,
    12,
    11,
    14,
    2,
    6,
    5,
    10,
    4,
    0,
    15,
    8,
    9,
    0,
    5,
    7,
    2,
    4,
    10,
    15,
    14,
    1,
    11,
    12,
    6,
    8,
    3,
    13,
    2,
    12,
    6,
    10,
    0,
    11,
    8,
    3,
    4,
    13,
    7,
    5,
    15,
    14,
    1,
    9,
    12,
    5,
    1,
    15,
    14,
    13,
    4,
    10,
    0,
    7,
    6,
    3,
    9,
    2,
    8,
    11,
    13,
    11,
    7,
    14,
    12,
    1,
    3,
    9,
    5,
    0,
    15,
    4,
    8,
    6,
    2,
    10,
    6,
    15,
    14,
    9,
    11,
    3,
    0,
    8,
    12,
    2,
    13,
    7,
    1,
    4,
    10,
    5,
    10,
    2,
    8,
    4,
    7,
    6,
    1,
    5,
    15,
    11,
    9,
    14,
    3,
    12,
    13,
    0,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3,
    // Blake1, unused in others
    11,
    8,
    12,
    0,
    5,
    2,
    15,
    13,
    10,
    14,
    3,
    6,
    7,
    1,
    9,
    4,
    7,
    9,
    3,
    1,
    13,
    12,
    11,
    14,
    2,
    6,
    5,
    10,
    4,
    0,
    15,
    8,
    9,
    0,
    5,
    7,
    2,
    4,
    10,
    15,
    14,
    1,
    11,
    12,
    6,
    8,
    3,
    13,
    2,
    12,
    6,
    10,
    0,
    11,
    8,
    3,
    4,
    13,
    7,
    5,
    15,
    14,
    1,
    9
  ]);
  function A(p, t, l, m, b) {
    return p = p + t + b | 0, m = (0, s.rotr)(m ^ p, 16), l = l + m | 0, t = (0, s.rotr)(t ^ l, 12), { a: p, b: t, c: l, d: m };
  }
  function u(p, t, l, m, b) {
    return p = p + t + b | 0, m = (0, s.rotr)(m ^ p, 8), l = l + m | 0, t = (0, s.rotr)(t ^ l, 7), { a: p, b: t, c: l, d: m };
  }
  return _blake;
}
var hasRequiredBlake2;
function requireBlake2() {
  if (hasRequiredBlake2) return blake2;
  hasRequiredBlake2 = 1, Object.defineProperty(blake2, "__esModule", { value: !0 }), blake2.blake2s = blake2.BLAKE2s = blake2.blake2b = blake2.BLAKE2b = blake2.BLAKE2 = void 0, blake2.compress = Q;
  const s = /* @__PURE__ */ require_blake(), A = /* @__PURE__ */ require_md$1(), u = /* @__PURE__ */ require_u64$1(), p = /* @__PURE__ */ requireUtils$j(), t = /* @__PURE__ */ Uint32Array.from([
    4089235720,
    1779033703,
    2227873595,
    3144134277,
    4271175723,
    1013904242,
    1595750129,
    2773480762,
    2917565137,
    1359893119,
    725511199,
    2600822924,
    4215389547,
    528734635,
    327033209,
    1541459225
  ]), l = /* @__PURE__ */ new Uint32Array(32);
  function m(M, F, le, ge, pe, Ie) {
    const be = pe[Ie], Pe = pe[Ie + 1];
    let Te = l[2 * M], Qe = l[2 * M + 1], xe = l[2 * F], Ee = l[2 * F + 1], He = l[2 * le], ve = l[2 * le + 1], we = l[2 * ge], Ce = l[2 * ge + 1], Se = u.add3L(Te, xe, be);
    Qe = u.add3H(Se, Qe, Ee, Pe), Te = Se | 0, { Dh: Ce, Dl: we } = { Dh: Ce ^ Qe, Dl: we ^ Te }, { Dh: Ce, Dl: we } = { Dh: u.rotr32H(Ce, we), Dl: u.rotr32L(Ce, we) }, { h: ve, l: He } = u.add(ve, He, Ce, we), { Bh: Ee, Bl: xe } = { Bh: Ee ^ ve, Bl: xe ^ He }, { Bh: Ee, Bl: xe } = { Bh: u.rotrSH(Ee, xe, 24), Bl: u.rotrSL(Ee, xe, 24) }, l[2 * M] = Te, l[2 * M + 1] = Qe, l[2 * F] = xe, l[2 * F + 1] = Ee, l[2 * le] = He, l[2 * le + 1] = ve, l[2 * ge] = we, l[2 * ge + 1] = Ce;
  }
  function b(M, F, le, ge, pe, Ie) {
    const be = pe[Ie], Pe = pe[Ie + 1];
    let Te = l[2 * M], Qe = l[2 * M + 1], xe = l[2 * F], Ee = l[2 * F + 1], He = l[2 * le], ve = l[2 * le + 1], we = l[2 * ge], Ce = l[2 * ge + 1], Se = u.add3L(Te, xe, be);
    Qe = u.add3H(Se, Qe, Ee, Pe), Te = Se | 0, { Dh: Ce, Dl: we } = { Dh: Ce ^ Qe, Dl: we ^ Te }, { Dh: Ce, Dl: we } = { Dh: u.rotrSH(Ce, we, 16), Dl: u.rotrSL(Ce, we, 16) }, { h: ve, l: He } = u.add(ve, He, Ce, we), { Bh: Ee, Bl: xe } = { Bh: Ee ^ ve, Bl: xe ^ He }, { Bh: Ee, Bl: xe } = { Bh: u.rotrBH(Ee, xe, 63), Bl: u.rotrBL(Ee, xe, 63) }, l[2 * M] = Te, l[2 * M + 1] = Qe, l[2 * F] = xe, l[2 * F + 1] = Ee, l[2 * le] = He, l[2 * le + 1] = ve, l[2 * ge] = we, l[2 * ge + 1] = Ce;
  }
  function k(M, F = {}, le, ge, pe) {
    if ((0, p.anumber)(le), M < 0 || M > le)
      throw new Error("outputLen bigger than keyLen");
    const { key: Ie, salt: be, personalization: Pe } = F;
    if (Ie !== void 0 && (Ie.length < 1 || Ie.length > le))
      throw new Error("key length must be undefined or 1.." + le);
    if (be !== void 0 && be.length !== ge)
      throw new Error("salt must be undefined or " + ge);
    if (Pe !== void 0 && Pe.length !== pe)
      throw new Error("personalization must be undefined or " + pe);
  }
  class C extends p.Hash {
    constructor(F, le) {
      super(), this.finished = !1, this.destroyed = !1, this.length = 0, this.pos = 0, (0, p.anumber)(F), (0, p.anumber)(le), this.blockLen = F, this.outputLen = le, this.buffer = new Uint8Array(F), this.buffer32 = (0, p.u32)(this.buffer);
    }
    update(F) {
      (0, p.aexists)(this), F = (0, p.toBytes)(F), (0, p.abytes)(F);
      const { blockLen: le, buffer: ge, buffer32: pe } = this, Ie = F.length, be = F.byteOffset, Pe = F.buffer;
      for (let Te = 0; Te < Ie; ) {
        this.pos === le && ((0, p.swap32IfBE)(pe), this.compress(pe, 0, !1), (0, p.swap32IfBE)(pe), this.pos = 0);
        const Qe = Math.min(le - this.pos, Ie - Te), xe = be + Te;
        if (Qe === le && !(xe % 4) && Te + Qe < Ie) {
          const Ee = new Uint32Array(Pe, xe, Math.floor((Ie - Te) / 4));
          (0, p.swap32IfBE)(Ee);
          for (let He = 0; Te + le < Ie; He += pe.length, Te += le)
            this.length += le, this.compress(Ee, He, !1);
          (0, p.swap32IfBE)(Ee);
          continue;
        }
        ge.set(F.subarray(Te, Te + Qe), this.pos), this.pos += Qe, this.length += Qe, Te += Qe;
      }
      return this;
    }
    digestInto(F) {
      (0, p.aexists)(this), (0, p.aoutput)(F, this);
      const { pos: le, buffer32: ge } = this;
      this.finished = !0, (0, p.clean)(this.buffer.subarray(le)), (0, p.swap32IfBE)(ge), this.compress(ge, 0, !0), (0, p.swap32IfBE)(ge);
      const pe = (0, p.u32)(F);
      this.get().forEach((Ie, be) => pe[be] = (0, p.swap8IfBE)(Ie));
    }
    digest() {
      const { buffer: F, outputLen: le } = this;
      this.digestInto(F);
      const ge = F.slice(0, le);
      return this.destroy(), ge;
    }
    _cloneInto(F) {
      const { buffer: le, length: ge, finished: pe, destroyed: Ie, outputLen: be, pos: Pe } = this;
      return F || (F = new this.constructor({ dkLen: be })), F.set(...this.get()), F.buffer.set(le), F.destroyed = Ie, F.finished = pe, F.length = ge, F.pos = Pe, F.outputLen = be, F;
    }
    clone() {
      return this._cloneInto();
    }
  }
  blake2.BLAKE2 = C;
  class B extends C {
    constructor(F = {}) {
      const le = F.dkLen === void 0 ? 64 : F.dkLen;
      super(128, le), this.v0l = t[0] | 0, this.v0h = t[1] | 0, this.v1l = t[2] | 0, this.v1h = t[3] | 0, this.v2l = t[4] | 0, this.v2h = t[5] | 0, this.v3l = t[6] | 0, this.v3h = t[7] | 0, this.v4l = t[8] | 0, this.v4h = t[9] | 0, this.v5l = t[10] | 0, this.v5h = t[11] | 0, this.v6l = t[12] | 0, this.v6h = t[13] | 0, this.v7l = t[14] | 0, this.v7h = t[15] | 0, k(le, F, 64, 16, 16);
      let { key: ge, personalization: pe, salt: Ie } = F, be = 0;
      if (ge !== void 0 && (ge = (0, p.toBytes)(ge), be = ge.length), this.v0l ^= this.outputLen | be << 8 | 65536 | 1 << 24, Ie !== void 0) {
        Ie = (0, p.toBytes)(Ie);
        const Pe = (0, p.u32)(Ie);
        this.v4l ^= (0, p.swap8IfBE)(Pe[0]), this.v4h ^= (0, p.swap8IfBE)(Pe[1]), this.v5l ^= (0, p.swap8IfBE)(Pe[2]), this.v5h ^= (0, p.swap8IfBE)(Pe[3]);
      }
      if (pe !== void 0) {
        pe = (0, p.toBytes)(pe);
        const Pe = (0, p.u32)(pe);
        this.v6l ^= (0, p.swap8IfBE)(Pe[0]), this.v6h ^= (0, p.swap8IfBE)(Pe[1]), this.v7l ^= (0, p.swap8IfBE)(Pe[2]), this.v7h ^= (0, p.swap8IfBE)(Pe[3]);
      }
      if (ge !== void 0) {
        const Pe = new Uint8Array(this.blockLen);
        Pe.set(ge), this.update(Pe);
      }
    }
    // prettier-ignore
    get() {
      let { v0l: F, v0h: le, v1l: ge, v1h: pe, v2l: Ie, v2h: be, v3l: Pe, v3h: Te, v4l: Qe, v4h: xe, v5l: Ee, v5h: He, v6l: ve, v6h: we, v7l: Ce, v7h: Se } = this;
      return [F, le, ge, pe, Ie, be, Pe, Te, Qe, xe, Ee, He, ve, we, Ce, Se];
    }
    // prettier-ignore
    set(F, le, ge, pe, Ie, be, Pe, Te, Qe, xe, Ee, He, ve, we, Ce, Se) {
      this.v0l = F | 0, this.v0h = le | 0, this.v1l = ge | 0, this.v1h = pe | 0, this.v2l = Ie | 0, this.v2h = be | 0, this.v3l = Pe | 0, this.v3h = Te | 0, this.v4l = Qe | 0, this.v4h = xe | 0, this.v5l = Ee | 0, this.v5h = He | 0, this.v6l = ve | 0, this.v6h = we | 0, this.v7l = Ce | 0, this.v7h = Se | 0;
    }
    compress(F, le, ge) {
      this.get().forEach((Te, Qe) => l[Qe] = Te), l.set(t, 16);
      let { h: pe, l: Ie } = u.fromBig(BigInt(this.length));
      l[24] = t[8] ^ Ie, l[25] = t[9] ^ pe, ge && (l[28] = ~l[28], l[29] = ~l[29]);
      let be = 0;
      const Pe = s.BSIGMA;
      for (let Te = 0; Te < 12; Te++)
        m(0, 4, 8, 12, F, le + 2 * Pe[be++]), b(0, 4, 8, 12, F, le + 2 * Pe[be++]), m(1, 5, 9, 13, F, le + 2 * Pe[be++]), b(1, 5, 9, 13, F, le + 2 * Pe[be++]), m(2, 6, 10, 14, F, le + 2 * Pe[be++]), b(2, 6, 10, 14, F, le + 2 * Pe[be++]), m(3, 7, 11, 15, F, le + 2 * Pe[be++]), b(3, 7, 11, 15, F, le + 2 * Pe[be++]), m(0, 5, 10, 15, F, le + 2 * Pe[be++]), b(0, 5, 10, 15, F, le + 2 * Pe[be++]), m(1, 6, 11, 12, F, le + 2 * Pe[be++]), b(1, 6, 11, 12, F, le + 2 * Pe[be++]), m(2, 7, 8, 13, F, le + 2 * Pe[be++]), b(2, 7, 8, 13, F, le + 2 * Pe[be++]), m(3, 4, 9, 14, F, le + 2 * Pe[be++]), b(3, 4, 9, 14, F, le + 2 * Pe[be++]);
      this.v0l ^= l[0] ^ l[16], this.v0h ^= l[1] ^ l[17], this.v1l ^= l[2] ^ l[18], this.v1h ^= l[3] ^ l[19], this.v2l ^= l[4] ^ l[20], this.v2h ^= l[5] ^ l[21], this.v3l ^= l[6] ^ l[22], this.v3h ^= l[7] ^ l[23], this.v4l ^= l[8] ^ l[24], this.v4h ^= l[9] ^ l[25], this.v5l ^= l[10] ^ l[26], this.v5h ^= l[11] ^ l[27], this.v6l ^= l[12] ^ l[28], this.v6h ^= l[13] ^ l[29], this.v7l ^= l[14] ^ l[30], this.v7h ^= l[15] ^ l[31], (0, p.clean)(l);
    }
    destroy() {
      this.destroyed = !0, (0, p.clean)(this.buffer32), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
  }
  blake2.BLAKE2b = B, blake2.blake2b = (0, p.createOptHasher)((M) => new B(M));
  function Q(M, F, le, ge, pe, Ie, be, Pe, Te, Qe, xe, Ee, He, ve, we, Ce, Se, Ne, rr, er) {
    let ir = 0;
    for (let sr = 0; sr < ge; sr++)
      ({ a: pe, b: Te, c: He, d: Se } = (0, s.G1s)(pe, Te, He, Se, le[F + M[ir++]])), { a: pe, b: Te, c: He, d: Se } = (0, s.G2s)(pe, Te, He, Se, le[F + M[ir++]]), { a: Ie, b: Qe, c: ve, d: Ne } = (0, s.G1s)(Ie, Qe, ve, Ne, le[F + M[ir++]]), { a: Ie, b: Qe, c: ve, d: Ne } = (0, s.G2s)(Ie, Qe, ve, Ne, le[F + M[ir++]]), { a: be, b: xe, c: we, d: rr } = (0, s.G1s)(be, xe, we, rr, le[F + M[ir++]]), { a: be, b: xe, c: we, d: rr } = (0, s.G2s)(be, xe, we, rr, le[F + M[ir++]]), { a: Pe, b: Ee, c: Ce, d: er } = (0, s.G1s)(Pe, Ee, Ce, er, le[F + M[ir++]]), { a: Pe, b: Ee, c: Ce, d: er } = (0, s.G2s)(Pe, Ee, Ce, er, le[F + M[ir++]]), { a: pe, b: Qe, c: we, d: er } = (0, s.G1s)(pe, Qe, we, er, le[F + M[ir++]]), { a: pe, b: Qe, c: we, d: er } = (0, s.G2s)(pe, Qe, we, er, le[F + M[ir++]]), { a: Ie, b: xe, c: Ce, d: Se } = (0, s.G1s)(Ie, xe, Ce, Se, le[F + M[ir++]]), { a: Ie, b: xe, c: Ce, d: Se } = (0, s.G2s)(Ie, xe, Ce, Se, le[F + M[ir++]]), { a: be, b: Ee, c: He, d: Ne } = (0, s.G1s)(be, Ee, He, Ne, le[F + M[ir++]]), { a: be, b: Ee, c: He, d: Ne } = (0, s.G2s)(be, Ee, He, Ne, le[F + M[ir++]]), { a: Pe, b: Te, c: ve, d: rr } = (0, s.G1s)(Pe, Te, ve, rr, le[F + M[ir++]]), { a: Pe, b: Te, c: ve, d: rr } = (0, s.G2s)(Pe, Te, ve, rr, le[F + M[ir++]]);
    return { v0: pe, v1: Ie, v2: be, v3: Pe, v4: Te, v5: Qe, v6: xe, v7: Ee, v8: He, v9: ve, v10: we, v11: Ce, v12: Se, v13: Ne, v14: rr, v15: er };
  }
  const P = A.SHA256_IV;
  class x extends C {
    constructor(F = {}) {
      const le = F.dkLen === void 0 ? 32 : F.dkLen;
      super(64, le), this.v0 = P[0] | 0, this.v1 = P[1] | 0, this.v2 = P[2] | 0, this.v3 = P[3] | 0, this.v4 = P[4] | 0, this.v5 = P[5] | 0, this.v6 = P[6] | 0, this.v7 = P[7] | 0, k(le, F, 32, 8, 8);
      let { key: ge, personalization: pe, salt: Ie } = F, be = 0;
      if (ge !== void 0 && (ge = (0, p.toBytes)(ge), be = ge.length), this.v0 ^= this.outputLen | be << 8 | 65536 | 1 << 24, Ie !== void 0) {
        Ie = (0, p.toBytes)(Ie);
        const Pe = (0, p.u32)(Ie);
        this.v4 ^= (0, p.swap8IfBE)(Pe[0]), this.v5 ^= (0, p.swap8IfBE)(Pe[1]);
      }
      if (pe !== void 0) {
        pe = (0, p.toBytes)(pe);
        const Pe = (0, p.u32)(pe);
        this.v6 ^= (0, p.swap8IfBE)(Pe[0]), this.v7 ^= (0, p.swap8IfBE)(Pe[1]);
      }
      if (ge !== void 0) {
        (0, p.abytes)(ge);
        const Pe = new Uint8Array(this.blockLen);
        Pe.set(ge), this.update(Pe);
      }
    }
    get() {
      const { v0: F, v1: le, v2: ge, v3: pe, v4: Ie, v5: be, v6: Pe, v7: Te } = this;
      return [F, le, ge, pe, Ie, be, Pe, Te];
    }
    // prettier-ignore
    set(F, le, ge, pe, Ie, be, Pe, Te) {
      this.v0 = F | 0, this.v1 = le | 0, this.v2 = ge | 0, this.v3 = pe | 0, this.v4 = Ie | 0, this.v5 = be | 0, this.v6 = Pe | 0, this.v7 = Te | 0;
    }
    compress(F, le, ge) {
      const { h: pe, l: Ie } = u.fromBig(BigInt(this.length)), { v0: be, v1: Pe, v2: Te, v3: Qe, v4: xe, v5: Ee, v6: He, v7: ve, v8: we, v9: Ce, v10: Se, v11: Ne, v12: rr, v13: er, v14: ir, v15: sr } = Q(s.BSIGMA, le, F, 10, this.v0, this.v1, this.v2, this.v3, this.v4, this.v5, this.v6, this.v7, P[0], P[1], P[2], P[3], Ie ^ P[4], pe ^ P[5], ge ? ~P[6] : P[6], P[7]);
      this.v0 ^= be ^ we, this.v1 ^= Pe ^ Ce, this.v2 ^= Te ^ Se, this.v3 ^= Qe ^ Ne, this.v4 ^= xe ^ rr, this.v5 ^= Ee ^ er, this.v6 ^= He ^ ir, this.v7 ^= ve ^ sr;
    }
    destroy() {
      this.destroyed = !0, (0, p.clean)(this.buffer32), this.set(0, 0, 0, 0, 0, 0, 0, 0);
    }
  }
  return blake2.BLAKE2s = x, blake2.blake2s = (0, p.createOptHasher)((M) => new x(M)), blake2;
}
var hasRequiredBlake2b;
function requireBlake2b() {
  if (hasRequiredBlake2b) return blake2b$1;
  hasRequiredBlake2b = 1, Object.defineProperty(blake2b$1, "__esModule", { value: !0 }), blake2b$1.blake2b = blake2b$1.BLAKE2b = void 0;
  const s = /* @__PURE__ */ requireBlake2();
  return blake2b$1.BLAKE2b = s.BLAKE2b, blake2b$1.blake2b = s.blake2b, blake2b$1;
}
var hasRequiredSui;
function requireSui() {
  if (hasRequiredSui) return sui;
  hasRequiredSui = 1, Object.defineProperty(sui, "__esModule", { value: !0 }), sui.KeystoneSuiSDK = void 0;
  const s = requireDist$7(), A = requireUtils$d(), u = requireUr(), p = /* @__PURE__ */ requireBlake2b();
  class t {
    constructor(m) {
      this.config = m;
    }
    parseSignature(m) {
      if (m.type !== u.URType.SuiSignature)
        throw new Error("type not match");
      const b = s.SuiSignature.fromCBOR(m.cbor), k = b.getRequestId();
      return {
        requestId: Buffer.isBuffer(k) ? (0, A.uuidStringify)(k) : "",
        signature: (0, A.toHex)(b.getSignature()),
        publicKey: (0, A.toHex)(b.getPublicKey())
      };
    }
    generateSignHashRequest({ requestId: m, messageHash: b, accounts: k, origin: C }) {
      const B = [], Q = [];
      if (k.forEach((P) => {
        B.push(new s.CryptoKeypath((0, A.parsePath)(P.path).map((x) => new s.PathComponent(x)), (0, A.toBuffer)(P.xfp))), P.address !== void 0 && Q.push((0, A.toBuffer)(P.address.startsWith("0x") ? P.address.substring(2) : P.address));
      }), Q.length > 0 && Q.length !== B.length)
        throw new Error("address and path count must match");
      return new s.SuiSignHashRequest({
        requestId: (0, A.uuidParse)(m),
        messageHash: b,
        derivationPaths: B,
        addresses: Q,
        origin: C
      }).toUR();
    }
    generateIntentMessageHash(m) {
      let b = (0, A.toBuffer)(m);
      const k = (0, p.blake2b)(Uint8Array.from(b), { dkLen: 32 });
      return (0, A.toHex)(k);
    }
    generateSignRequest({ requestId: m, intentMessage: b, accounts: k, origin: C }) {
      var B, Q, P;
      const x = (P = (Q = (B = this.config) === null || B === void 0 ? void 0 : B.sizeLimit) === null || Q === void 0 ? void 0 : Q.sui) !== null && P !== void 0 ? P : 2048, M = [], F = [];
      if (k.forEach((ge) => {
        M.push(new s.CryptoKeypath((0, A.parsePath)(ge.path).map((pe) => new s.PathComponent(pe)), (0, A.toBuffer)(ge.xfp))), ge.address !== void 0 && F.push((0, A.toBuffer)(ge.address.startsWith("0x") ? ge.address.substring(2) : ge.address));
      }), F.length > 0 && F.length !== M.length)
        throw new Error("address and path count must match");
      let le = (0, A.toBuffer)(b);
      if (le.length > x) {
        const ge = (0, p.blake2b)(Uint8Array.from(le), { dkLen: 32 });
        if (ge.length !== 32)
          throw new Error("hash length must be 32");
        return b = (0, A.toHex)(ge), new s.SuiSignHashRequest({
          requestId: (0, A.uuidParse)(m),
          messageHash: b,
          derivationPaths: M,
          addresses: F,
          origin: C
        }).toUR();
      }
      return new s.SuiSignRequest({
        requestId: (0, A.uuidParse)(m),
        intentMessage: (0, A.toBuffer)(b),
        derivationPaths: M,
        addresses: F,
        origin: C
      }).toUR();
    }
  }
  return sui.KeystoneSuiSDK = t, sui;
}
var ton = {}, dist$5 = { exports: {} }, bcUrRegistryTon_cjs_production_min = {}, hasRequiredBcUrRegistryTon_cjs_production_min;
function requireBcUrRegistryTon_cjs_production_min() {
  return hasRequiredBcUrRegistryTon_cjs_production_min || (hasRequiredBcUrRegistryTon_cjs_production_min = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$i(), u = /* @__PURE__ */ requireCommonjsBrowser();
    const p = { TRON_SIGN_REQUEST: new A.RegistryType("ton-sign-request", 7201), TRON_SIGNATURE: new A.RegistryType("ton-signature", 7202) }, { decodeToDataItem: t, RegistryTypes: l } = A.extend;
    var m, b;
    (function(x) {
      x[x.requestId = 1] = "requestId", x[x.signData = 2] = "signData", x[x.dataType = 3] = "dataType", x[x.derivationPath = 4] = "derivationPath", x[x.address = 5] = "address", x[x.origin = 6] = "origin";
    })(m || (m = {})), (b = s.DataType || (s.DataType = {}))[b.TRANSACTION = 1] = "TRANSACTION", b[b.SIGN_PROOF = 2] = "SIGN_PROOF";
    class k extends A.RegistryItem {
      constructor(M) {
        super(), this.getRegistryType = () => p.TRON_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath ? this.derivationPath.getPath() : void 0, this.getAddress = () => this.address, this.getOrigin = () => this.origin, this.getDataType = () => this.dataType, this.toDataItem = () => {
          const F = {};
          if (F[m.signData] = this.signData, F[m.dataType] = this.dataType, this.derivationPath) {
            const le = this.derivationPath.toDataItem();
            le.setTag(this.derivationPath.getRegistryType().getTag()), F[m.derivationPath] = le;
          }
          return this.requestId && (F[m.requestId] = new A.DataItem(this.requestId, l.UUID.getTag())), this.address && (F[m.address] = this.address), this.origin && (F[m.origin] = this.origin), new A.DataItem(F);
        }, this.requestId = M.requestId, this.signData = M.signData, this.derivationPath = M.derivationPath, this.address = M.address, this.origin = M.origin, this.dataType = M.dataType;
      }
      static parsePath(M, F) {
        const le = M.replace(/[m|M]\//, "").split("/").map((ge) => {
          const pe = parseInt(ge.replace("'", ""));
          let Ie = !1;
          return ge.endsWith("'") && (Ie = !0), new A.PathComponent({ index: pe, hardened: Ie });
        });
        return new A.CryptoKeypath(le, Buffer.from(F, "hex"));
      }
      static constructTonRequest(M, F, le, ge, pe, Ie, be) {
        return new k({ requestId: ge ? Buffer.from(u.parse(ge)) : void 0, signData: M, dataType: F, derivationPath: be && Ie ? k.parsePath(be, Ie) : void 0, address: le, origin: pe });
      }
    }
    k.fromDataItem = (x) => {
      const M = x.getData(), F = M[m.requestId] ? M[m.requestId].getData() : void 0, le = M[m.derivationPath] ? A.CryptoKeypath.fromDataItem(M[m.derivationPath]) : void 0;
      return new k({ requestId: F, signData: M[m.signData], dataType: M[m.dataType], derivationPath: le, address: M[m.address], origin: M[m.origin] });
    }, k.fromCBOR = (x) => {
      const M = t(x);
      return k.fromDataItem(M);
    };
    const { RegistryTypes: C, decodeToDataItem: B } = A.extend;
    var Q;
    (function(x) {
      x[x.requestId = 1] = "requestId", x[x.signature = 2] = "signature", x[x.origin = 3] = "origin";
    })(Q || (Q = {}));
    class P extends A.RegistryItem {
      constructor(M, F, le) {
        super(), this.getRegistryType = () => p.TRON_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const ge = {};
          return this.requestId && (ge[Q.requestId] = new A.DataItem(this.requestId, C.UUID.getTag())), this.origin && (ge[Q.origin] = this.origin), ge[Q.signature] = this.signature, new A.DataItem(ge);
        }, this.signature = M, this.requestId = F, this.origin = le;
      }
    }
    P.fromDataItem = (x) => {
      const M = x.getData(), F = M[Q.signature];
      let le, ge;
      return M[Q.requestId] && (le = M[Q.requestId].getData()), M[Q.origin] && (ge = M[Q.origin]), new P(F, le, ge);
    }, P.fromCBOR = (x) => {
      const M = B(x);
      return P.fromDataItem(M);
    }, A.patchTags(Object.values(p).filter((x) => !!x.getTag()).map((x) => x.getTag())), Object.keys(A).forEach(function(x) {
      x !== "default" && Object.defineProperty(s, x, { enumerable: !0, get: function() {
        return A[x];
      } });
    }), s.TonSignRequest = k, s.TonSignature = P;
  }(bcUrRegistryTon_cjs_production_min)), bcUrRegistryTon_cjs_production_min;
}
var bcUrRegistryTon_cjs_development = {}, hasRequiredBcUrRegistryTon_cjs_development;
function requireBcUrRegistryTon_cjs_development() {
  return hasRequiredBcUrRegistryTon_cjs_development || (hasRequiredBcUrRegistryTon_cjs_development = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$i(), u = /* @__PURE__ */ requireCommonjsBrowser();
    const p = {
      TRON_SIGN_REQUEST: /* @__PURE__ */ new A.RegistryType("ton-sign-request", 7201),
      TRON_SIGNATURE: /* @__PURE__ */ new A.RegistryType("ton-signature", 7202)
    }, {
      decodeToDataItem: t,
      RegistryTypes: l
    } = A.extend;
    var m;
    (function(P) {
      P[P.requestId = 1] = "requestId", P[P.signData = 2] = "signData", P[P.dataType = 3] = "dataType", P[P.derivationPath = 4] = "derivationPath", P[P.address = 5] = "address", P[P.origin = 6] = "origin";
    })(m || (m = {})), function(P) {
      P[P.TRANSACTION = 1] = "TRANSACTION", P[P.SIGN_PROOF = 2] = "SIGN_PROOF";
    }(s.DataType || (s.DataType = {}));
    class b extends A.RegistryItem {
      constructor(x) {
        super(), this.getRegistryType = () => p.TRON_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath ? this.derivationPath.getPath() : void 0, this.getAddress = () => this.address, this.getOrigin = () => this.origin, this.getDataType = () => this.dataType, this.toDataItem = () => {
          const M = {};
          if (M[m.signData] = this.signData, M[m.dataType] = this.dataType, this.derivationPath) {
            const F = this.derivationPath.toDataItem();
            F.setTag(this.derivationPath.getRegistryType().getTag()), M[m.derivationPath] = F;
          }
          return this.requestId && (M[m.requestId] = new A.DataItem(this.requestId, l.UUID.getTag())), this.address && (M[m.address] = this.address), this.origin && (M[m.origin] = this.origin), new A.DataItem(M);
        }, this.requestId = x.requestId, this.signData = x.signData, this.derivationPath = x.derivationPath, this.address = x.address, this.origin = x.origin, this.dataType = x.dataType;
      }
      static parsePath(x, M) {
        const le = x.replace(/[m|M]\//, "").split("/").map((ge) => {
          const pe = parseInt(ge.replace("'", ""));
          let Ie = !1;
          return ge.endsWith("'") && (Ie = !0), new A.PathComponent({
            index: pe,
            hardened: Ie
          });
        });
        return new A.CryptoKeypath(le, Buffer.from(M, "hex"));
      }
      static constructTonRequest(x, M, F, le, ge, pe, Ie) {
        return new b({
          requestId: le ? Buffer.from(u.parse(le)) : void 0,
          signData: x,
          dataType: M,
          derivationPath: Ie && pe ? b.parsePath(Ie, pe) : void 0,
          address: F,
          origin: ge
        });
      }
    }
    b.fromDataItem = (P) => {
      const x = P.getData(), M = x[m.requestId] ? x[m.requestId].getData() : void 0, F = x[m.derivationPath] ? A.CryptoKeypath.fromDataItem(x[m.derivationPath]) : void 0;
      return new b({
        requestId: M,
        signData: x[m.signData],
        dataType: x[m.dataType],
        derivationPath: F,
        address: x[m.address],
        origin: x[m.origin]
      });
    }, b.fromCBOR = (P) => {
      const x = t(P);
      return b.fromDataItem(x);
    };
    const {
      RegistryTypes: k,
      decodeToDataItem: C
    } = A.extend;
    var B;
    (function(P) {
      P[P.requestId = 1] = "requestId", P[P.signature = 2] = "signature", P[P.origin = 3] = "origin";
    })(B || (B = {}));
    class Q extends A.RegistryItem {
      constructor(x, M, F) {
        super(), this.getRegistryType = () => p.TRON_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const le = {};
          return this.requestId && (le[B.requestId] = new A.DataItem(this.requestId, k.UUID.getTag())), this.origin && (le[B.origin] = this.origin), le[B.signature] = this.signature, new A.DataItem(le);
        }, this.signature = x, this.requestId = M, this.origin = F;
      }
    }
    Q.fromDataItem = (P) => {
      const x = P.getData(), M = x[B.signature];
      let F, le;
      return x[B.requestId] && (F = x[B.requestId].getData()), x[B.origin] && (le = x[B.origin]), new Q(M, F, le);
    }, Q.fromCBOR = (P) => {
      const x = C(P);
      return Q.fromDataItem(x);
    }, A.patchTags(Object.values(p).filter((P) => !!P.getTag()).map((P) => P.getTag())), Object.keys(A).forEach(function(P) {
      P !== "default" && Object.defineProperty(s, P, {
        enumerable: !0,
        get: function() {
          return A[P];
        }
      });
    }), s.TonSignRequest = b, s.TonSignature = Q;
  }(bcUrRegistryTon_cjs_development)), bcUrRegistryTon_cjs_development;
}
var hasRequiredDist$6;
function requireDist$6() {
  return hasRequiredDist$6 || (hasRequiredDist$6 = 1, process$1.env.NODE_ENV === "production" ? dist$5.exports = requireBcUrRegistryTon_cjs_production_min() : dist$5.exports = requireBcUrRegistryTon_cjs_development()), dist$5.exports;
}
var hasRequiredTon;
function requireTon() {
  if (hasRequiredTon) return ton;
  hasRequiredTon = 1, Object.defineProperty(ton, "__esModule", { value: !0 }), ton.KeystoneTonSDK = void 0;
  const s = requireDist$6(), A = requireUtils$d(), u = requireUr();
  class p {
    constructor(l) {
      this.config = l;
    }
    parseSignature(l) {
      if (l.type !== u.URType.TonSignature)
        throw new Error("type not match");
      const m = s.TonSignature.fromCBOR(l.cbor), b = m.getRequestId();
      return {
        requestId: Buffer.isBuffer(b) ? (0, A.uuidStringify)(b) : "",
        signature: (0, A.toHex)(m.getSignature()),
        origin: m.getOrigin()
      };
    }
    generateSignRequest({ requestId: l, signData: m, dataType: b, xfp: k, derivationPath: C, address: B }) {
      var Q;
      return s.TonSignRequest.constructTonRequest((0, A.toBuffer)(m), b, B, l, (Q = this.config) === null || Q === void 0 ? void 0 : Q.origin, k, C).toUR();
    }
  }
  return p.DataType = s.DataType, ton.KeystoneTonSDK = p, ton;
}
var stellar = {}, dist$4 = { exports: {} }, bcUrRegistryStellar_cjs_production_min = {}, hasRequiredBcUrRegistryStellar_cjs_production_min;
function requireBcUrRegistryStellar_cjs_production_min() {
  return hasRequiredBcUrRegistryStellar_cjs_production_min || (hasRequiredBcUrRegistryStellar_cjs_production_min = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$i(), u = require$$1$2;
    const p = { STELLAR_SIGN_REQUEST: new A.RegistryType("stellar-sign-request", 8201), STELLAR_SIGNATURE: new A.RegistryType("stellar-signature", 8202) }, { decodeToDataItem: t, RegistryTypes: l } = A.extend;
    var m, b;
    (m = s.SignType || (s.SignType = {}))[m.Transaction = 1] = "Transaction", m[m.TransactionHash = 2] = "TransactionHash", m[m.Message = 3] = "Message", function(x) {
      x[x.requestId = 1] = "requestId", x[x.signData = 2] = "signData", x[x.derivationPath = 3] = "derivationPath", x[x.address = 4] = "address", x[x.origin = 5] = "origin", x[x.signType = 6] = "signType";
    }(b || (b = {}));
    class k extends A.RegistryItem {
      constructor(M) {
        super(), this.getRegistryType = () => p.STELLAR_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSignRequestAddress = () => this.address, this.getOrigin = () => this.origin, this.getSignType = () => this.signType, this.toDataItem = () => {
          const F = {};
          this.requestId && (F[b.requestId] = new A.DataItem(this.requestId, l.UUID.getTag())), this.address && (F[b.address] = this.address), this.origin && (F[b.origin] = this.origin), F[b.signData] = this.signData, F[b.signType] = this.signType;
          const le = this.derivationPath.toDataItem();
          return le.setTag(this.derivationPath.getRegistryType().getTag()), F[b.derivationPath] = le, new A.DataItem(F);
        }, this.requestId = M.requestId, this.signData = M.signData, this.derivationPath = M.derivationPath, this.address = M.address, this.origin = M.origin, this.signType = M.signType;
      }
      static constructStellarRequest(M, F, le, ge, pe, Ie, be) {
        const Pe = F.replace(/[m|M]\//, "").split("/"), Te = new A.CryptoKeypath(Pe.map((Qe) => {
          const xe = parseInt(Qe.replace("'", ""));
          let Ee = !1;
          return Qe.endsWith("'") && (Ee = !0), new A.PathComponent({ index: xe, hardened: Ee });
        }), Buffer.from(le, "hex"));
        return new k({ requestId: pe ? Buffer.from(u.parse(pe)) : void 0, signData: M, derivationPath: Te, address: Ie ? Buffer.from(Ie.replace("0x", ""), "hex") : void 0, origin: be || void 0, signType: ge });
      }
    }
    k.fromDataItem = (x) => {
      const M = x.getData(), F = M[b.signData], le = A.CryptoKeypath.fromDataItem(M[b.derivationPath]), ge = M[b.address] ? M[b.address] : void 0, pe = M[b.requestId] ? M[b.requestId].getData() : void 0;
      return new k({ requestId: pe, signData: F, derivationPath: le, address: ge, origin: M[b.origin] ? M[b.origin] : void 0, signType: M[b.signType] });
    }, k.fromCBOR = (x) => {
      const M = t(x);
      return k.fromDataItem(M);
    };
    const { RegistryTypes: C, decodeToDataItem: B } = A.extend;
    var Q;
    (function(x) {
      x[x.requestId = 1] = "requestId", x[x.signature = 2] = "signature";
    })(Q || (Q = {}));
    class P extends A.RegistryItem {
      constructor(M, F) {
        super(), this.getRegistryType = () => p.STELLAR_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const le = {};
          return this.requestId && (le[Q.requestId] = new A.DataItem(this.requestId, C.UUID.getTag())), le[Q.signature] = this.signature, new A.DataItem(le);
        }, this.signature = M, this.requestId = F;
      }
    }
    P.fromDataItem = (x) => {
      const M = x.getData(), F = M[Q.signature], le = M[Q.requestId] ? M[Q.requestId].getData() : void 0;
      return new P(F, le);
    }, P.fromCBOR = (x) => {
      const M = B(x);
      return P.fromDataItem(M);
    }, A.patchTags(Object.values(p).filter((x) => !!x.getTag()).map((x) => x.getTag())), Object.keys(A).forEach(function(x) {
      x !== "default" && Object.defineProperty(s, x, { enumerable: !0, get: function() {
        return A[x];
      } });
    }), s.StellarSignRequest = k, s.StellarSignature = P;
  }(bcUrRegistryStellar_cjs_production_min)), bcUrRegistryStellar_cjs_production_min;
}
var bcUrRegistryStellar_cjs_development = {}, hasRequiredBcUrRegistryStellar_cjs_development;
function requireBcUrRegistryStellar_cjs_development() {
  return hasRequiredBcUrRegistryStellar_cjs_development || (hasRequiredBcUrRegistryStellar_cjs_development = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var A = requireDist$i(), u = require$$1$2;
    const p = {
      STELLAR_SIGN_REQUEST: /* @__PURE__ */ new A.RegistryType("stellar-sign-request", 8201),
      STELLAR_SIGNATURE: /* @__PURE__ */ new A.RegistryType("stellar-signature", 8202)
    }, {
      decodeToDataItem: t,
      RegistryTypes: l
    } = A.extend;
    (function(P) {
      P[P.Transaction = 1] = "Transaction", P[P.TransactionHash = 2] = "TransactionHash", P[P.Message = 3] = "Message";
    })(s.SignType || (s.SignType = {}));
    var m;
    (function(P) {
      P[P.requestId = 1] = "requestId", P[P.signData = 2] = "signData", P[P.derivationPath = 3] = "derivationPath", P[P.address = 4] = "address", P[P.origin = 5] = "origin", P[P.signType = 6] = "signType";
    })(m || (m = {}));
    class b extends A.RegistryItem {
      constructor(x) {
        super(), this.getRegistryType = () => p.STELLAR_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSignRequestAddress = () => this.address, this.getOrigin = () => this.origin, this.getSignType = () => this.signType, this.toDataItem = () => {
          const M = {};
          this.requestId && (M[m.requestId] = new A.DataItem(this.requestId, l.UUID.getTag())), this.address && (M[m.address] = this.address), this.origin && (M[m.origin] = this.origin), M[m.signData] = this.signData, M[m.signType] = this.signType;
          const F = this.derivationPath.toDataItem();
          return F.setTag(this.derivationPath.getRegistryType().getTag()), M[m.derivationPath] = F, new A.DataItem(M);
        }, this.requestId = x.requestId, this.signData = x.signData, this.derivationPath = x.derivationPath, this.address = x.address, this.origin = x.origin, this.signType = x.signType;
      }
      static constructStellarRequest(x, M, F, le, ge, pe, Ie) {
        const be = M.replace(/[m|M]\//, "").split("/"), Pe = new A.CryptoKeypath(be.map((Te) => {
          const Qe = parseInt(Te.replace("'", ""));
          let xe = !1;
          return Te.endsWith("'") && (xe = !0), new A.PathComponent({
            index: Qe,
            hardened: xe
          });
        }), Buffer.from(F, "hex"));
        return new b({
          requestId: ge ? Buffer.from(u.parse(ge)) : void 0,
          signData: x,
          derivationPath: Pe,
          address: pe ? Buffer.from(pe.replace("0x", ""), "hex") : void 0,
          origin: Ie || void 0,
          signType: le
        });
      }
    }
    b.fromDataItem = (P) => {
      const x = P.getData(), M = x[m.signData], F = A.CryptoKeypath.fromDataItem(x[m.derivationPath]), le = x[m.address] ? x[m.address] : void 0, ge = x[m.requestId] ? x[m.requestId].getData() : void 0, pe = x[m.origin] ? x[m.origin] : void 0, Ie = x[m.signType];
      return new b({
        requestId: ge,
        signData: M,
        derivationPath: F,
        address: le,
        origin: pe,
        signType: Ie
      });
    }, b.fromCBOR = (P) => {
      const x = t(P);
      return b.fromDataItem(x);
    };
    const {
      RegistryTypes: k,
      decodeToDataItem: C
    } = A.extend;
    var B;
    (function(P) {
      P[P.requestId = 1] = "requestId", P[P.signature = 2] = "signature";
    })(B || (B = {}));
    class Q extends A.RegistryItem {
      constructor(x, M) {
        super(), this.getRegistryType = () => p.STELLAR_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const F = {};
          return this.requestId && (F[B.requestId] = new A.DataItem(this.requestId, k.UUID.getTag())), F[B.signature] = this.signature, new A.DataItem(F);
        }, this.signature = x, this.requestId = M;
      }
    }
    Q.fromDataItem = (P) => {
      const x = P.getData(), M = x[B.signature], F = x[B.requestId] ? x[B.requestId].getData() : void 0;
      return new Q(M, F);
    }, Q.fromCBOR = (P) => {
      const x = C(P);
      return Q.fromDataItem(x);
    }, A.patchTags(Object.values(p).filter((P) => !!P.getTag()).map((P) => P.getTag())), Object.keys(A).forEach(function(P) {
      P !== "default" && Object.defineProperty(s, P, {
        enumerable: !0,
        get: function() {
          return A[P];
        }
      });
    }), s.StellarSignRequest = b, s.StellarSignature = Q;
  }(bcUrRegistryStellar_cjs_development)), bcUrRegistryStellar_cjs_development;
}
var hasRequiredDist$5;
function requireDist$5() {
  return hasRequiredDist$5 || (hasRequiredDist$5 = 1, process$1.env.NODE_ENV === "production" ? dist$4.exports = requireBcUrRegistryStellar_cjs_production_min() : dist$4.exports = requireBcUrRegistryStellar_cjs_development()), dist$4.exports;
}
var hasRequiredStellar;
function requireStellar() {
  if (hasRequiredStellar) return stellar;
  hasRequiredStellar = 1, Object.defineProperty(stellar, "__esModule", { value: !0 }), stellar.KeystoneStellarSDK = void 0;
  const s = requireUtils$d(), A = requireUr(), u = requireDist$5();
  class p {
    parseSignature(l) {
      if (l.type !== A.URType.StellarSignature)
        throw new Error("type not match");
      const m = u.StellarSignature.fromCBOR(l.cbor), b = m.getRequestId();
      return {
        requestId: b === void 0 ? void 0 : (0, s.uuidStringify)(b),
        signature: (0, s.toHex)(m.getSignature())
      };
    }
    generateSignRequest({ requestId: l, signData: m, dataType: b, path: k, xfp: C, address: B, origin: Q }) {
      return new u.StellarSignRequest({
        requestId: (0, s.uuidParse)(l),
        signData: (0, s.toBuffer)(m),
        signType: b,
        derivationPath: new u.CryptoKeypath((0, s.parsePath)(k).map((P) => new u.PathComponent(P)), (0, s.toBuffer)(C)),
        address: B !== void 0 ? (0, s.toBuffer)(B) : void 0,
        origin: Q
      }).toUR();
    }
  }
  return p.DataType = u.SignType, stellar.KeystoneStellarSDK = p, stellar;
}
var hasRequiredChains;
function requireChains() {
  return hasRequiredChains || (hasRequiredChains = 1, function(s) {
    var A = chains && chains.__createBinding || (Object.create ? function(p, t, l, m) {
      m === void 0 && (m = l);
      var b = Object.getOwnPropertyDescriptor(t, l);
      (!b || ("get" in b ? !t.__esModule : b.writable || b.configurable)) && (b = { enumerable: !0, get: function() {
        return t[l];
      } }), Object.defineProperty(p, m, b);
    } : function(p, t, l, m) {
      m === void 0 && (m = l), p[m] = t[l];
    }), u = chains && chains.__exportStar || function(p, t) {
      for (var l in p) l !== "default" && !Object.prototype.hasOwnProperty.call(t, l) && A(t, p, l);
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), u(requireBitcoin$1(), s), u(requireCosmos(), s), u(requireEvm(), s), u(requireEthereum$2(), s), u(requireSolana(), s), u(requireTron(), s), u(requireAptos(), s), u(requireBitcoin_cash(), s), u(requireDash(), s), u(requireLitecoin(), s), u(requireNear(), s), u(requireCardano(), s), u(requireArweave(), s), u(requireSui(), s), u(requireTon(), s), u(requireStellar(), s);
  }(chains)), chains;
}
var wallet$1 = {}, hardwareCall = {}, hasRequiredHardwareCall;
function requireHardwareCall() {
  return hasRequiredHardwareCall || (hasRequiredHardwareCall = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.generateKeyDerivationCall = s.QRHardwareCallVersion = s.DerivationAlgorithm = s.Curve = void 0;
    const A = requireDist$j();
    Object.defineProperty(s, "Curve", { enumerable: !0, get: function() {
      return A.Curve;
    } }), Object.defineProperty(s, "DerivationAlgorithm", { enumerable: !0, get: function() {
      return A.DerivationAlgorithm;
    } }), Object.defineProperty(s, "QRHardwareCallVersion", { enumerable: !0, get: function() {
      return A.QRHardwareCallVersion;
    } });
    const u = requireUtils$d(), p = ({ schemas: t, origin: l, version: m }) => {
      const b = t.map(({ path: B, curve: Q = A.Curve.secp256k1, algo: P = A.DerivationAlgorithm.slip10, chainType: x }) => {
        if (Q === A.Curve.secp256k1 && P === A.DerivationAlgorithm.bip32ed25519)
          throw new Error("the combination of the given curve and algo not supported");
        return new A.KeyDerivationSchema((0, u.pathToKeypath)(B), Q, P, x);
      }), k = new A.KeyDerivation(b);
      return new A.QRHardwareCall(A.QRHardwareCallType.KeyDerivation, k, l, m ? A.QRHardwareCallVersion.V1 : A.QRHardwareCallVersion.V0).toUR();
    };
    s.generateKeyDerivationCall = p;
  }(hardwareCall)), hardwareCall;
}
var multiAccounts = {}, types$4 = {}, account$1 = {}, hasRequiredAccount$1;
function requireAccount$1() {
  return hasRequiredAccount$1 || (hasRequiredAccount$1 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.AccountNote = void 0, function(A) {
      A.Standard = "account.standard", A.LedgerLegacy = "account.ledger_legacy", A.LedgerLive = "account.ledger_live";
    }(s.AccountNote || (s.AccountNote = {}));
  }(account$1)), account$1;
}
var props = {}, hasRequiredProps;
function requireProps() {
  return hasRequiredProps || (hasRequiredProps = 1, Object.defineProperty(props, "__esModule", { value: !0 })), props;
}
var signature = {}, hasRequiredSignature;
function requireSignature() {
  return hasRequiredSignature || (hasRequiredSignature = 1, Object.defineProperty(signature, "__esModule", { value: !0 })), signature;
}
var token = {}, hasRequiredToken;
function requireToken() {
  return hasRequiredToken || (hasRequiredToken = 1, Object.defineProperty(token, "__esModule", { value: !0 })), token;
}
var config = {}, hasRequiredConfig;
function requireConfig() {
  return hasRequiredConfig || (hasRequiredConfig = 1, Object.defineProperty(config, "__esModule", { value: !0 })), config;
}
var hasRequiredTypes$4;
function requireTypes$4() {
  return hasRequiredTypes$4 || (hasRequiredTypes$4 = 1, function(s) {
    var A = types$4 && types$4.__createBinding || (Object.create ? function(p, t, l, m) {
      m === void 0 && (m = l);
      var b = Object.getOwnPropertyDescriptor(t, l);
      (!b || ("get" in b ? !t.__esModule : b.writable || b.configurable)) && (b = { enumerable: !0, get: function() {
        return t[l];
      } }), Object.defineProperty(p, m, b);
    } : function(p, t, l, m) {
      m === void 0 && (m = l), p[m] = t[l];
    }), u = types$4 && types$4.__exportStar || function(p, t) {
      for (var l in p) l !== "default" && !Object.prototype.hasOwnProperty.call(t, l) && A(t, p, l);
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), u(requireAccount$1(), s), u(requireProps(), s), u(requireSignature(), s), u(requireToken(), s), u(requireUr(), s), u(requireConfig(), s);
  }(types$4)), types$4;
}
var accountHelper = {}, hasRequiredAccountHelper;
function requireAccountHelper() {
  if (hasRequiredAccountHelper) return accountHelper;
  hasRequiredAccountHelper = 1, Object.defineProperty(accountHelper, "__esModule", { value: !0 }), accountHelper.generateExtraData = void 0;
  const s = {
    60: 1
    // ETH
  }, A = (u) => {
    var p;
    return {
      okx: {
        chainId: (p = s[u]) !== null && p !== void 0 ? p : u
      }
    };
  };
  return accountHelper.generateExtraData = A, accountHelper;
}
var hasRequiredMultiAccounts;
function requireMultiAccounts() {
  if (hasRequiredMultiAccounts) return multiAccounts;
  hasRequiredMultiAccounts = 1, Object.defineProperty(multiAccounts, "__esModule", { value: !0 }), multiAccounts.parseMultiAccounts = void 0;
  const s = requireTypes$4(), A = requireDist$j(), u = requireUtils$d(), p = requireAccountHelper(), t = (l) => {
    if (l.type !== s.URType.CryptoMultiAccounts)
      throw new Error("type not match");
    const m = A.CryptoMultiAccounts.fromCBOR(l.cbor), b = (0, u.toHex)(m.getMasterFingerprint());
    return {
      device: m.getDevice(),
      masterFingerprint: b,
      keys: m.getKeys().map((k) => {
        const C = (0, u.toHex)(k.getChainCode()), B = (0, u.toHex)(k.getParentFingerprint()), Q = k.getOrigin();
        if (Q === void 0)
          throw new Error("multi accounts is invalid");
        let P;
        C.length !== 0 && B.length !== 0 && (P = k.getBip32Key());
        const x = Q.getComponents()[1].getIndex();
        return {
          chain: (0, u.getCoinSymbol)(x),
          path: `m/${Q.getPath()}`,
          publicKey: (0, u.toHex)(k.getKey()),
          name: k.getName(),
          chainCode: C,
          extendedPublicKey: P,
          note: k.getNote(),
          extra: (0, p.generateExtraData)(x)
        };
      }),
      deviceId: m.getDeviceId(),
      deviceVersion: m.getVersion()
    };
  };
  return multiAccounts.parseMultiAccounts = t, multiAccounts;
}
var hdKey = {}, hasRequiredHdKey;
function requireHdKey() {
  if (hasRequiredHdKey) return hdKey;
  hasRequiredHdKey = 1, Object.defineProperty(hdKey, "__esModule", { value: !0 }), hdKey.parseTonAccount = hdKey.parseHDKey = void 0;
  const s = requireTypes$4(), A = requireDist$j(), u = requireUtils$d(), p = requireAccountHelper(), t = (m) => {
    var b;
    if (m.type !== s.URType.CryptoHDKey)
      throw new Error("type not match");
    const k = A.CryptoHDKey.fromCBOR(m.cbor), C = (0, u.toHex)(k.getChainCode()), B = (0, u.toHex)(k.getParentFingerprint()), Q = k.getOrigin();
    if (((b = k.getOrigin().getSourceFingerprint()) === null || b === void 0 ? void 0 : b.toString("hex")) === void 0)
      throw new Error("HDKey is invalid");
    let x;
    C.length !== 0 && B.length !== 0 && (x = k.getBip32Key());
    const M = Q.getComponents()[1].getIndex();
    return {
      chain: (0, u.getCoinSymbol)(M),
      path: `m/${Q.getPath()}`,
      publicKey: (0, u.toHex)(k.getKey()),
      name: k.getName(),
      xfp: Q.getSourceFingerprint().toString("hex"),
      chainCode: C,
      extendedPublicKey: x,
      note: k.getNote(),
      extra: (0, p.generateExtraData)(M)
    };
  };
  hdKey.parseHDKey = t;
  const l = (m) => {
    var b;
    if (m.type !== s.URType.CryptoHDKey)
      throw new Error("type not match");
    const k = A.CryptoHDKey.fromCBOR(m.cbor), C = k.getOrigin();
    if (C) {
      if (((b = k.getOrigin().getSourceFingerprint()) === null || b === void 0 ? void 0 : b.toString("hex")) === void 0)
        throw new Error("HDKey is invalid");
      return {
        path: `m/${C.getPath()}`,
        publicKey: (0, u.toHex)(k.getKey()),
        name: k.getName(),
        xfp: C.getSourceFingerprint().toString("hex")
      };
    } else
      return {
        publicKey: (0, u.toHex)(k.getKey()),
        name: k.getName()
      };
  };
  return hdKey.parseTonAccount = l, hdKey;
}
var account = {}, hasRequiredAccount;
function requireAccount() {
  if (hasRequiredAccount) return account;
  hasRequiredAccount = 1, Object.defineProperty(account, "__esModule", { value: !0 }), account.parseAccount = void 0;
  const s = requireTypes$4(), A = requireDist$j(), u = requireUtils$d(), p = requireAccountHelper(), t = (l) => {
    if (l.type !== s.URType.CryptoAccount)
      throw new Error("type not match");
    const m = A.CryptoAccount.fromCBOR(l.cbor), b = (0, u.toHex)(m.getMasterFingerprint()), k = [];
    return m.getOutputDescriptors().forEach((C) => {
      if (C.getRegistryType() !== A.RegistryTypes.CRYPTO_HDKEY) {
        const B = C.getCryptoKey(), Q = (0, u.toHex)(B.getChainCode()), P = (0, u.toHex)(B.getParentFingerprint()), x = B.getOrigin();
        if (x === void 0)
          throw new Error("account is invalid");
        let M;
        Q.length !== 0 && P.length !== 0 && (M = B.getBip32Key());
        const F = x.getComponents()[1].getIndex();
        k.push({
          chain: (0, u.getCoinSymbol)(F),
          path: `m/${x.getPath()}`,
          publicKey: (0, u.toHex)(B.getKey()),
          name: B.getName(),
          chainCode: Q,
          extendedPublicKey: M,
          note: B.getNote(),
          extra: (0, p.generateExtraData)(F)
        });
      }
    }), {
      masterFingerprint: b,
      keys: k
    };
  };
  return account.parseAccount = t, account;
}
var hasRequiredWallet$1;
function requireWallet$1() {
  return hasRequiredWallet$1 || (hasRequiredWallet$1 = 1, function(s) {
    var A = wallet$1 && wallet$1.__createBinding || (Object.create ? function(p, t, l, m) {
      m === void 0 && (m = l);
      var b = Object.getOwnPropertyDescriptor(t, l);
      (!b || ("get" in b ? !t.__esModule : b.writable || b.configurable)) && (b = { enumerable: !0, get: function() {
        return t[l];
      } }), Object.defineProperty(p, m, b);
    } : function(p, t, l, m) {
      m === void 0 && (m = l), p[m] = t[l];
    }), u = wallet$1 && wallet$1.__exportStar || function(p, t) {
      for (var l in p) l !== "default" && !Object.prototype.hasOwnProperty.call(t, l) && A(t, p, l);
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), u(requireHardwareCall(), s), u(requireMultiAccounts(), s), u(requireHdKey(), s), u(requireAccount(), s);
  }(wallet$1)), wallet$1;
}
var xrp$1 = {}, xrp = {}, dist$3 = {}, coretypes = {}, enums = {};
const TYPES = { Done: -1, Unknown: -2, NotPresent: 0, UInt16: 1, UInt32: 2, UInt64: 3, Hash128: 4, Hash256: 5, Amount: 6, Blob: 7, AccountID: 8, STObject: 14, STArray: 15, UInt8: 16, Hash160: 17, PathSet: 18, Vector256: 19, UInt96: 20, UInt192: 21, UInt384: 22, UInt512: 23, Issue: 24, XChainBridge: 25, Transaction: 10001, LedgerEntry: 10002, Validation: 10003, Metadata: 10004 }, LEDGER_ENTRY_TYPES = { Invalid: -1, AccountRoot: 97, DirectoryNode: 100, RippleState: 114, Ticket: 84, SignerList: 83, Offer: 111, Bridge: 105, LedgerHashes: 104, Amendments: 102, XChainOwnedClaimID: 113, XChainOwnedCreateAccountClaimID: 116, FeeSettings: 115, Escrow: 117, PayChannel: 120, Check: 67, DepositPreauth: 112, NegativeUNL: 78, NFTokenPage: 80, NFTokenOffer: 55, AMM: 121, DID: 73, Any: -3, Child: -2, Nickname: 110, Contract: 99, GeneratorMap: 103 }, FIELDS = /* @__PURE__ */ JSON.parse('[["Generic",{"nth":0,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Unknown"}],["Invalid",{"nth":-1,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Unknown"}],["ObjectEndMarker",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["ArrayEndMarker",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["hash",{"nth":257,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Hash256"}],["index",{"nth":258,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Hash256"}],["taker_gets_funded",{"nth":258,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Amount"}],["taker_pays_funded",{"nth":259,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Amount"}],["LedgerEntry",{"nth":257,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"LedgerEntry"}],["Transaction",{"nth":257,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Transaction"}],["Validation",{"nth":257,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Validation"}],["Metadata",{"nth":257,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Metadata"}],["CloseResolution",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt8"}],["Method",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt8"}],["TransactionResult",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt8"}],["TickSize",{"nth":16,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt8"}],["UNLModifyDisabling",{"nth":17,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt8"}],["HookResult",{"nth":18,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt8"}],["WasLockingChainSend",{"nth":19,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt8"}],["LedgerEntryType",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["TransactionType",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["SignerWeight",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["TransferFee",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["TradingFee",{"nth":5,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["DiscountedFee",{"nth":6,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["Version",{"nth":16,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["HookStateChangeCount",{"nth":17,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["HookEmitCount",{"nth":18,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["HookExecutionIndex",{"nth":19,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["HookApiVersion",{"nth":20,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["NetworkID",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["Flags",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["SourceTag",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["Sequence",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["PreviousTxnLgrSeq",{"nth":5,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["LedgerSequence",{"nth":6,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["CloseTime",{"nth":7,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["ParentCloseTime",{"nth":8,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["SigningTime",{"nth":9,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["Expiration",{"nth":10,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["TransferRate",{"nth":11,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["WalletSize",{"nth":12,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["OwnerCount",{"nth":13,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["DestinationTag",{"nth":14,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["HighQualityIn",{"nth":16,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["HighQualityOut",{"nth":17,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["LowQualityIn",{"nth":18,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["LowQualityOut",{"nth":19,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["QualityIn",{"nth":20,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["QualityOut",{"nth":21,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["StampEscrow",{"nth":22,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["BondAmount",{"nth":23,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["LoadFee",{"nth":24,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["OfferSequence",{"nth":25,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["FirstLedgerSequence",{"nth":26,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["LastLedgerSequence",{"nth":27,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["TransactionIndex",{"nth":28,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["OperationLimit",{"nth":29,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["ReferenceFeeUnits",{"nth":30,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["ReserveBase",{"nth":31,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["ReserveIncrement",{"nth":32,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["SetFlag",{"nth":33,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["ClearFlag",{"nth":34,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["SignerQuorum",{"nth":35,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["CancelAfter",{"nth":36,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["FinishAfter",{"nth":37,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["SignerListID",{"nth":38,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["SettleDelay",{"nth":39,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["TicketCount",{"nth":40,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["TicketSequence",{"nth":41,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["NFTokenTaxon",{"nth":42,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["MintedNFTokens",{"nth":43,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["BurnedNFTokens",{"nth":44,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["HookStateCount",{"nth":45,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["EmitGeneration",{"nth":46,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["VoteWeight",{"nth":48,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["FirstNFTokenSequence",{"nth":50,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["IndexNext",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["IndexPrevious",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["BookNode",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["OwnerNode",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["BaseFee",{"nth":5,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["ExchangeRate",{"nth":6,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["LowNode",{"nth":7,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["HighNode",{"nth":8,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["DestinationNode",{"nth":9,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["Cookie",{"nth":10,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["ServerVersion",{"nth":11,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["NFTokenOfferNode",{"nth":12,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["EmitBurden",{"nth":13,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["HookOn",{"nth":16,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["HookInstructionCount",{"nth":17,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["HookReturnCode",{"nth":18,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["ReferenceCount",{"nth":19,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["XChainClaimID",{"nth":20,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["XChainAccountCreateCount",{"nth":21,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["XChainAccountClaimCount",{"nth":22,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["EmailHash",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash128"}],["TakerPaysCurrency",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash160"}],["TakerPaysIssuer",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash160"}],["TakerGetsCurrency",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash160"}],["TakerGetsIssuer",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash160"}],["LedgerHash",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["ParentHash",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["TransactionHash",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["AccountHash",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["PreviousTxnID",{"nth":5,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["LedgerIndex",{"nth":6,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["WalletLocator",{"nth":7,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["RootIndex",{"nth":8,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["AccountTxnID",{"nth":9,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["NFTokenID",{"nth":10,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["EmitParentTxnID",{"nth":11,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["EmitNonce",{"nth":12,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["EmitHookHash",{"nth":13,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["AMMID",{"nth":14,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["BookDirectory",{"nth":16,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["InvoiceID",{"nth":17,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["Nickname",{"nth":18,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["Amendment",{"nth":19,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["Digest",{"nth":21,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["Channel",{"nth":22,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["ConsensusHash",{"nth":23,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["CheckID",{"nth":24,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["ValidatedHash",{"nth":25,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["PreviousPageMin",{"nth":26,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["NextPageMin",{"nth":27,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["NFTokenBuyOffer",{"nth":28,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["NFTokenSellOffer",{"nth":29,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["HookStateKey",{"nth":30,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["HookHash",{"nth":31,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["HookNamespace",{"nth":32,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["HookSetTxnID",{"nth":33,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["Amount",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["Balance",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["LimitAmount",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["TakerPays",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["TakerGets",{"nth":5,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["LowLimit",{"nth":6,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["HighLimit",{"nth":7,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["Fee",{"nth":8,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["SendMax",{"nth":9,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["DeliverMin",{"nth":10,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["Amount2",{"nth":11,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["BidMin",{"nth":12,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["BidMax",{"nth":13,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["MinimumOffer",{"nth":16,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["RippleEscrow",{"nth":17,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["DeliveredAmount",{"nth":18,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["NFTokenBrokerFee",{"nth":19,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["BaseFeeDrops",{"nth":22,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["ReserveBaseDrops",{"nth":23,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["ReserveIncrementDrops",{"nth":24,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["LPTokenOut",{"nth":25,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["LPTokenIn",{"nth":26,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["EPrice",{"nth":27,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["Price",{"nth":28,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["SignatureReward",{"nth":29,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["MinAccountCreateAmount",{"nth":30,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["LPTokenBalance",{"nth":31,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["PublicKey",{"nth":1,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["MessageKey",{"nth":2,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["SigningPubKey",{"nth":3,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["TxnSignature",{"nth":4,"isVLEncoded":true,"isSerialized":true,"isSigningField":false,"type":"Blob"}],["URI",{"nth":5,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["Signature",{"nth":6,"isVLEncoded":true,"isSerialized":true,"isSigningField":false,"type":"Blob"}],["Domain",{"nth":7,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["FundCode",{"nth":8,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["RemoveCode",{"nth":9,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["ExpireCode",{"nth":10,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["CreateCode",{"nth":11,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["MemoType",{"nth":12,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["MemoData",{"nth":13,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["MemoFormat",{"nth":14,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["Fulfillment",{"nth":16,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["Condition",{"nth":17,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["MasterSignature",{"nth":18,"isVLEncoded":true,"isSerialized":true,"isSigningField":false,"type":"Blob"}],["UNLModifyValidator",{"nth":19,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["ValidatorToDisable",{"nth":20,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["ValidatorToReEnable",{"nth":21,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["HookStateData",{"nth":22,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["HookReturnString",{"nth":23,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["HookParameterName",{"nth":24,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["HookParameterValue",{"nth":25,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["DIDDocument",{"nth":26,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["Data",{"nth":27,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["Account",{"nth":1,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["Owner",{"nth":2,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["Destination",{"nth":3,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["Issuer",{"nth":4,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["Authorize",{"nth":5,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["Unauthorize",{"nth":6,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["RegularKey",{"nth":8,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["NFTokenMinter",{"nth":9,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["EmitCallback",{"nth":10,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["HookAccount",{"nth":16,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["OtherChainSource",{"nth":18,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["OtherChainDestination",{"nth":19,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["AttestationSignerAccount",{"nth":20,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["AttestationRewardAccount",{"nth":21,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["LockingChainDoor",{"nth":22,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["IssuingChainDoor",{"nth":23,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["Indexes",{"nth":1,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Vector256"}],["Hashes",{"nth":2,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Vector256"}],["Amendments",{"nth":3,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Vector256"}],["NFTokenOffers",{"nth":4,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Vector256"}],["Paths",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"PathSet"}],["LockingChainIssue",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Issue"}],["IssuingChainIssue",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Issue"}],["Asset",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Issue"}],["Asset2",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Issue"}],["XChainBridge",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"XChainBridge"}],["TransactionMetaData",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["CreatedNode",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["DeletedNode",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["ModifiedNode",{"nth":5,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["PreviousFields",{"nth":6,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["FinalFields",{"nth":7,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["NewFields",{"nth":8,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["TemplateEntry",{"nth":9,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["Memo",{"nth":10,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["SignerEntry",{"nth":11,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["NFToken",{"nth":12,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["EmitDetails",{"nth":13,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["Hook",{"nth":14,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["Signer",{"nth":16,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["Majority",{"nth":18,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["DisabledValidator",{"nth":19,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["EmittedTxn",{"nth":20,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["HookExecution",{"nth":21,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["HookDefinition",{"nth":22,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["HookParameter",{"nth":23,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["HookGrant",{"nth":24,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["VoteEntry",{"nth":25,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["AuctionSlot",{"nth":26,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["AuthAccount",{"nth":27,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["XChainClaimProofSig",{"nth":28,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["XChainCreateAccountProofSig",{"nth":29,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["XChainClaimAttestationCollectionElement",{"nth":30,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["XChainCreateAccountAttestationCollectionElement",{"nth":31,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["Signers",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":false,"type":"STArray"}],["SignerEntries",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["Template",{"nth":5,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["Necessary",{"nth":6,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["Sufficient",{"nth":7,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["AffectedNodes",{"nth":8,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["Memos",{"nth":9,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["NFTokens",{"nth":10,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["Hooks",{"nth":11,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["VoteSlots",{"nth":12,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["Majorities",{"nth":16,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["DisabledValidators",{"nth":17,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["HookExecutions",{"nth":18,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["HookParameters",{"nth":19,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["HookGrants",{"nth":20,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["XChainClaimAttestations",{"nth":21,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["XChainCreateAccountAttestations",{"nth":22,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["AuthAccounts",{"nth":25,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}]]'), TRANSACTION_RESULTS = { telLOCAL_ERROR: -399, telBAD_DOMAIN: -398, telBAD_PATH_COUNT: -397, telBAD_PUBLIC_KEY: -396, telFAILED_PROCESSING: -395, telINSUF_FEE_P: -394, telNO_DST_PARTIAL: -393, telCAN_NOT_QUEUE: -392, telCAN_NOT_QUEUE_BALANCE: -391, telCAN_NOT_QUEUE_BLOCKS: -390, telCAN_NOT_QUEUE_BLOCKED: -389, telCAN_NOT_QUEUE_FEE: -388, telCAN_NOT_QUEUE_FULL: -387, telWRONG_NETWORK: -386, telREQUIRES_NETWORK_ID: -385, telNETWORK_ID_MAKES_TX_NON_CANONICAL: -384, temMALFORMED: -299, temBAD_AMOUNT: -298, temBAD_CURRENCY: -297, temBAD_EXPIRATION: -296, temBAD_FEE: -295, temBAD_ISSUER: -294, temBAD_LIMIT: -293, temBAD_OFFER: -292, temBAD_PATH: -291, temBAD_PATH_LOOP: -290, temBAD_REGKEY: -289, temBAD_SEND_XRP_LIMIT: -288, temBAD_SEND_XRP_MAX: -287, temBAD_SEND_XRP_NO_DIRECT: -286, temBAD_SEND_XRP_PARTIAL: -285, temBAD_SEND_XRP_PATHS: -284, temBAD_SEQUENCE: -283, temBAD_SIGNATURE: -282, temBAD_SRC_ACCOUNT: -281, temBAD_TRANSFER_RATE: -280, temDST_IS_SRC: -279, temDST_NEEDED: -278, temINVALID: -277, temINVALID_FLAG: -276, temREDUNDANT: -275, temRIPPLE_EMPTY: -274, temDISABLED: -273, temBAD_SIGNER: -272, temBAD_QUORUM: -271, temBAD_WEIGHT: -270, temBAD_TICK_SIZE: -269, temINVALID_ACCOUNT_ID: -268, temCANNOT_PREAUTH_SELF: -267, temINVALID_COUNT: -266, temUNCERTAIN: -265, temUNKNOWN: -264, temSEQ_AND_TICKET: -263, temBAD_NFTOKEN_TRANSFER_FEE: -262, temBAD_AMM_TOKENS: -261, temXCHAIN_EQUAL_DOOR_ACCOUNTS: -260, temXCHAIN_BAD_PROOF: -259, temXCHAIN_BRIDGE_BAD_ISSUES: -258, temXCHAIN_BRIDGE_NONDOOR_OWNER: -257, temXCHAIN_BRIDGE_BAD_MIN_ACCOUNT_CREATE_AMOUNT: -256, temXCHAIN_BRIDGE_BAD_REWARD_AMOUNT: -255, temEMPTY_DID: -254, tefFAILURE: -199, tefALREADY: -198, tefBAD_ADD_AUTH: -197, tefBAD_AUTH: -196, tefBAD_LEDGER: -195, tefCREATED: -194, tefEXCEPTION: -193, tefINTERNAL: -192, tefNO_AUTH_REQUIRED: -191, tefPAST_SEQ: -190, tefWRONG_PRIOR: -189, tefMASTER_DISABLED: -188, tefMAX_LEDGER: -187, tefBAD_SIGNATURE: -186, tefBAD_QUORUM: -185, tefNOT_MULTI_SIGNING: -184, tefBAD_AUTH_MASTER: -183, tefINVARIANT_FAILED: -182, tefTOO_BIG: -181, tefNO_TICKET: -180, tefNFTOKEN_IS_NOT_TRANSFERABLE: -179, terRETRY: -99, terFUNDS_SPENT: -98, terINSUF_FEE_B: -97, terNO_ACCOUNT: -96, terNO_AUTH: -95, terNO_LINE: -94, terOWNERS: -93, terPRE_SEQ: -92, terLAST: -91, terNO_RIPPLE: -90, terQUEUED: -89, terPRE_TICKET: -88, terNO_AMM: -87, terSUBMITTED: -86, tesSUCCESS: 0, tecCLAIM: 100, tecPATH_PARTIAL: 101, tecUNFUNDED_ADD: 102, tecUNFUNDED_OFFER: 103, tecUNFUNDED_PAYMENT: 104, tecFAILED_PROCESSING: 105, tecDIR_FULL: 121, tecINSUF_RESERVE_LINE: 122, tecINSUF_RESERVE_OFFER: 123, tecNO_DST: 124, tecNO_DST_INSUF_XRP: 125, tecNO_LINE_INSUF_RESERVE: 126, tecNO_LINE_REDUNDANT: 127, tecPATH_DRY: 128, tecUNFUNDED: 129, tecNO_ALTERNATIVE_KEY: 130, tecNO_REGULAR_KEY: 131, tecOWNERS: 132, tecNO_ISSUER: 133, tecNO_AUTH: 134, tecNO_LINE: 135, tecINSUFF_FEE: 136, tecFROZEN: 137, tecNO_TARGET: 138, tecNO_PERMISSION: 139, tecNO_ENTRY: 140, tecINSUFFICIENT_RESERVE: 141, tecNEED_MASTER_KEY: 142, tecDST_TAG_NEEDED: 143, tecINTERNAL: 144, tecOVERSIZE: 145, tecCRYPTOCONDITION_ERROR: 146, tecINVARIANT_FAILED: 147, tecEXPIRED: 148, tecDUPLICATE: 149, tecKILLED: 150, tecHAS_OBLIGATIONS: 151, tecTOO_SOON: 152, tecHOOK_REJECTED: 153, tecMAX_SEQUENCE_REACHED: 154, tecNO_SUITABLE_NFTOKEN_PAGE: 155, tecNFTOKEN_BUY_SELL_MISMATCH: 156, tecNFTOKEN_OFFER_TYPE_MISMATCH: 157, tecCANT_ACCEPT_OWN_NFTOKEN_OFFER: 158, tecINSUFFICIENT_FUNDS: 159, tecOBJECT_NOT_FOUND: 160, tecINSUFFICIENT_PAYMENT: 161, tecUNFUNDED_AMM: 162, tecAMM_BALANCE: 163, tecAMM_FAILED: 164, tecAMM_INVALID_TOKENS: 165, tecAMM_EMPTY: 166, tecAMM_NOT_EMPTY: 167, tecAMM_ACCOUNT: 168, tecINCOMPLETE: 169, tecXCHAIN_BAD_TRANSFER_ISSUE: 170, tecXCHAIN_NO_CLAIM_ID: 171, tecXCHAIN_BAD_CLAIM_ID: 172, tecXCHAIN_CLAIM_NO_QUORUM: 173, tecXCHAIN_PROOF_UNKNOWN_KEY: 174, tecXCHAIN_CREATE_ACCOUNT_NONXRP_ISSUE: 175, tecXCHAIN_WRONG_CHAIN: 176, tecXCHAIN_REWARD_MISMATCH: 177, tecXCHAIN_NO_SIGNERS_LIST: 178, tecXCHAIN_SENDING_ACCOUNT_MISMATCH: 179, tecXCHAIN_INSUFF_CREATE_AMOUNT: 180, tecXCHAIN_ACCOUNT_CREATE_PAST: 181, tecXCHAIN_ACCOUNT_CREATE_TOO_MANY: 182, tecXCHAIN_PAYMENT_FAILED: 183, tecXCHAIN_SELF_COMMIT: 184, tecXCHAIN_BAD_PUBLIC_KEY_ACCOUNT_PAIR: 185, tecXCHAIN_CREATE_ACCOUNT_DISABLED: 186, tecEMPTY_DID: 187 }, TRANSACTION_TYPES = { Invalid: -1, Payment: 0, EscrowCreate: 1, EscrowFinish: 2, AccountSet: 3, EscrowCancel: 4, SetRegularKey: 5, NickNameSet: 6, OfferCreate: 7, OfferCancel: 8, Contract: 9, TicketCreate: 10, TicketCancel: 11, SignerListSet: 12, PaymentChannelCreate: 13, PaymentChannelFund: 14, PaymentChannelClaim: 15, CheckCreate: 16, CheckCash: 17, CheckCancel: 18, DepositPreauth: 19, TrustSet: 20, AccountDelete: 21, SetHook: 22, NFTokenMint: 25, NFTokenBurn: 26, NFTokenCreateOffer: 27, NFTokenCancelOffer: 28, NFTokenAcceptOffer: 29, Clawback: 30, AMMCreate: 35, AMMDeposit: 36, AMMWithdraw: 37, AMMVote: 38, AMMBid: 39, AMMDelete: 40, XChainCreateClaimID: 41, XChainCommit: 42, XChainClaim: 43, XChainAccountCreateCommit: 44, XChainAddClaimAttestation: 45, XChainAddAccountCreateAttestation: 46, XChainModifyBridge: 47, XChainCreateBridge: 48, DIDSet: 49, DIDDelete: 50, EnableAmendment: 100, SetFee: 101, UNLModify: 102 }, require$$0 = {
  TYPES,
  LEDGER_ENTRY_TYPES,
  FIELDS,
  TRANSACTION_RESULTS,
  TRANSACTION_TYPES
};
var xrplDefinitionsBase = {}, bytes$1 = {}, hasRequiredBytes;
function requireBytes() {
  if (hasRequiredBytes) return bytes$1;
  hasRequiredBytes = 1, Object.defineProperty(bytes$1, "__esModule", { value: !0 }), bytes$1.BytesLookup = bytes$1.Bytes = void 0;
  const s = requireDist$n();
  class A {
    constructor(t, l, m) {
      this.name = t, this.ordinal = l, this.ordinalWidth = m, this.bytes = s.Buffer.alloc(m);
      for (let b = 0; b < m; b++)
        this.bytes[m - b - 1] = l >>> b * 8 & 255;
    }
    toJSON() {
      return this.name;
    }
    toBytesSink(t) {
      t.put(this.bytes);
    }
    toBytes() {
      return this.bytes;
    }
  }
  bytes$1.Bytes = A;
  class u {
    constructor(t, l) {
      this.ordinalWidth = l, Object.entries(t).forEach(([m, b]) => {
        this.add(m, b);
      });
    }
    /**
     * Add a new name value pair to the BytesLookup.
     *
     * @param name - A human readable name for the field.
     * @param value - The numeric value for the field.
     * @throws if the name or value already exist in the lookup because it's unclear how to decode.
     */
    add(t, l) {
      if (this[t])
        throw new SyntaxError(`Attempted to add a value with a duplicate name "${t}". This is not allowed because it is unclear how to decode.`);
      if (this[l.toString()])
        throw new SyntaxError(`Attempted to add a duplicate value under a different name (Given name: "${t}" and previous name: "${this[l.toString()]}. This is not allowed because it is unclear how to decode.
Given value: ${l.toString()}`);
      this[t] = new A(t, l, this.ordinalWidth), this[l.toString()] = this[t];
    }
    from(t) {
      return t instanceof A ? t : this[t];
    }
    fromParser(t) {
      return this.from(t.readUIntN(this.ordinalWidth).toString());
    }
  }
  return bytes$1.BytesLookup = u, bytes$1;
}
var field = {}, serializedType = {}, binarySerializer = {}, hasRequiredBinarySerializer;
function requireBinarySerializer() {
  if (hasRequiredBinarySerializer) return binarySerializer;
  hasRequiredBinarySerializer = 1;
  var s = binarySerializer && binarySerializer.__createBinding || (Object.create ? function(b, k, C, B) {
    B === void 0 && (B = C);
    var Q = Object.getOwnPropertyDescriptor(k, C);
    (!Q || ("get" in Q ? !k.__esModule : Q.writable || Q.configurable)) && (Q = { enumerable: !0, get: function() {
      return k[C];
    } }), Object.defineProperty(b, B, Q);
  } : function(b, k, C, B) {
    B === void 0 && (B = C), b[B] = k[C];
  }), A = binarySerializer && binarySerializer.__setModuleDefault || (Object.create ? function(b, k) {
    Object.defineProperty(b, "default", { enumerable: !0, value: k });
  } : function(b, k) {
    b.default = k;
  }), u = binarySerializer && binarySerializer.__importStar || function(b) {
    if (b && b.__esModule) return b;
    var k = {};
    if (b != null) for (var C in b) C !== "default" && Object.prototype.hasOwnProperty.call(b, C) && s(k, b, C);
    return A(k, b), k;
  };
  Object.defineProperty(binarySerializer, "__esModule", { value: !0 }), binarySerializer.BinarySerializer = binarySerializer.BytesList = void 0;
  const p = u(requireAssert$2()), t = requireDist$n();
  class l {
    constructor() {
      this.bytesArray = [];
    }
    /**
     * Get the total number of bytes in the BytesList
     *
     * @return the number of bytes
     */
    getLength() {
      return t.Buffer.concat(this.bytesArray).byteLength;
    }
    /**
     * Put bytes in the BytesList
     *
     * @param bytesArg A Buffer
     * @return this BytesList
     */
    put(k) {
      const C = t.Buffer.from(k);
      return this.bytesArray.push(C), this;
    }
    /**
     * Write this BytesList to the back of another bytes list
     *
     *  @param list The BytesList to write to
     */
    toBytesSink(k) {
      k.put(this.toBytes());
    }
    toBytes() {
      return t.Buffer.concat(this.bytesArray);
    }
    toHex() {
      return this.toBytes().toString("hex").toUpperCase();
    }
  }
  binarySerializer.BytesList = l;
  class m {
    constructor(k) {
      this.sink = new l(), this.sink = k;
    }
    /**
     * Write a value to this BinarySerializer
     *
     * @param value a SerializedType value
     */
    write(k) {
      k.toBytesSink(this.sink);
    }
    /**
     * Write bytes to this BinarySerializer
     *
     * @param bytes the bytes to write
     */
    put(k) {
      this.sink.put(k);
    }
    /**
     * Write a value of a given type to this BinarySerializer
     *
     * @param type the type to write
     * @param value a value of that type
     */
    writeType(k, C) {
      this.write(k.from(C));
    }
    /**
     * Write BytesList to this BinarySerializer
     *
     * @param bl BytesList to write to BinarySerializer
     */
    writeBytesList(k) {
      k.toBytesSink(this.sink);
    }
    /**
     * Calculate the header of Variable Length encoded bytes
     *
     * @param length the length of the bytes
     */
    encodeVariableLength(k) {
      const C = t.Buffer.alloc(3);
      if (k <= 192)
        return C[0] = k, C.slice(0, 1);
      if (k <= 12480)
        return k -= 193, C[0] = 193 + (k >>> 8), C[1] = k & 255, C.slice(0, 2);
      if (k <= 918744)
        return k -= 12481, C[0] = 241 + (k >>> 16), C[1] = k >> 8 & 255, C[2] = k & 255, C.slice(0, 3);
      throw new Error("Overflow error");
    }
    /**
     * Write field and value to BinarySerializer
     *
     * @param field field to write to BinarySerializer
     * @param value value to write to BinarySerializer
     */
    writeFieldAndValue(k, C, B = !1) {
      const Q = k.associatedType.from(C);
      p.ok(Q.toBytesSink !== void 0), p.ok(k.name !== void 0), this.sink.put(k.header), k.isVariableLengthEncoded ? this.writeLengthEncoded(Q, B) : Q.toBytesSink(this.sink);
    }
    /**
     * Write a variable length encoded value to the BinarySerializer
     *
     * @param value length encoded value to write to BytesList
     */
    writeLengthEncoded(k, C = !1) {
      const B = new l();
      C || k.toBytesSink(B), this.put(this.encodeVariableLength(B.getLength())), this.writeBytesList(B);
    }
  }
  return binarySerializer.BinarySerializer = m, binarySerializer;
}
var hasRequiredSerializedType;
function requireSerializedType() {
  if (hasRequiredSerializedType) return serializedType;
  hasRequiredSerializedType = 1, Object.defineProperty(serializedType, "__esModule", { value: !0 }), serializedType.Comparable = serializedType.SerializedType = void 0;
  const s = requireBinarySerializer(), A = requireDist$n();
  class u {
    constructor(l) {
      this.bytes = A.Buffer.alloc(0), this.bytes = l ?? A.Buffer.alloc(0);
    }
    static fromParser(l, m) {
      throw new Error("fromParser not implemented");
    }
    static from(l) {
      throw new Error("from not implemented");
    }
    /**
     * Write the bytes representation of a SerializedType to a BytesList
     *
     * @param list The BytesList to write SerializedType bytes to
     */
    toBytesSink(l) {
      l.put(this.bytes);
    }
    /**
     * Get the hex representation of a SerializedType's bytes
     *
     * @returns hex String of this.bytes
     */
    toHex() {
      return this.toBytes().toString("hex").toUpperCase();
    }
    /**
     * Get the bytes representation of a SerializedType
     *
     * @returns A buffer of the bytes
     */
    toBytes() {
      if (this.bytes)
        return this.bytes;
      const l = new s.BytesList();
      return this.toBytesSink(l), l.toBytes();
    }
    /**
     * Return the JSON representation of a SerializedType
     *
     * @param _definitions rippled definitions used to parse the values of transaction types and such.
     *                          Unused in default, but used in STObject, STArray
     *                          Can be customized for sidechains and amendments.
     * @returns any type, if not overloaded returns hexString representation of bytes
     */
    toJSON(l) {
      return this.toHex();
    }
    /**
     * @returns hexString representation of this.bytes
     */
    toString() {
      return this.toHex();
    }
  }
  serializedType.SerializedType = u;
  class p extends u {
    lt(l) {
      return this.compareTo(l) < 0;
    }
    eq(l) {
      return this.compareTo(l) === 0;
    }
    gt(l) {
      return this.compareTo(l) > 0;
    }
    gte(l) {
      return this.compareTo(l) > -1;
    }
    lte(l) {
      return this.compareTo(l) < 1;
    }
    /**
     * Overload this method to define how two Comparable SerializedTypes are compared
     *
     * @param other The comparable object to compare this to
     * @returns A number denoting the relationship of this and other
     */
    compareTo(l) {
      throw new Error(`cannot compare ${this.toString()} and ${l.toString()}`);
    }
  }
  return serializedType.Comparable = p, serializedType;
}
var constants$2 = {}, hasRequiredConstants$2;
function requireConstants$2() {
  return hasRequiredConstants$2 || (hasRequiredConstants$2 = 1, Object.defineProperty(constants$2, "__esModule", { value: !0 }), constants$2.TRANSACTION_RESULT_WIDTH = constants$2.TRANSACTION_TYPE_WIDTH = constants$2.LEDGER_ENTRY_WIDTH = constants$2.TYPE_WIDTH = void 0, constants$2.TYPE_WIDTH = 2, constants$2.LEDGER_ENTRY_WIDTH = 2, constants$2.TRANSACTION_TYPE_WIDTH = 2, constants$2.TRANSACTION_RESULT_WIDTH = 1), constants$2;
}
var hasRequiredField;
function requireField() {
  if (hasRequiredField) return field;
  hasRequiredField = 1, Object.defineProperty(field, "__esModule", { value: !0 }), field.FieldLookup = void 0;
  const s = requireBytes(), A = requireSerializedType(), u = requireConstants$2(), p = requireDist$n();
  function t(b, k) {
    const C = [];
    return b < 16 ? k < 16 ? C.push(b << 4 | k) : C.push(b << 4, k) : k < 16 ? C.push(k, b) : C.push(0, b, k), p.Buffer.from(C);
  }
  function l([b, k], C) {
    const B = t(C, k.nth);
    return {
      name: b,
      nth: k.nth,
      isVariableLengthEncoded: k.isVLEncoded,
      isSerialized: k.isSerialized,
      isSigningField: k.isSigningField,
      ordinal: C << 16 | k.nth,
      type: new s.Bytes(k.type, C, u.TYPE_WIDTH),
      header: B,
      associatedType: A.SerializedType
      // For later assignment in ./types/index.js or Definitions.updateAll(...)
    };
  }
  class m {
    constructor(k, C) {
      k.forEach(([B, Q]) => {
        const P = C[Q.type];
        this[B] = l([B, Q], P), this[this[B].ordinal.toString()] = this[B];
      });
    }
    fromString(k) {
      return this[k];
    }
  }
  return field.FieldLookup = m, field;
}
var hasRequiredXrplDefinitionsBase;
function requireXrplDefinitionsBase() {
  return hasRequiredXrplDefinitionsBase || (hasRequiredXrplDefinitionsBase = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.BytesLookup = s.Bytes = s.FieldLookup = s.XrplDefinitionsBase = void 0;
    const A = requireBytes();
    Object.defineProperty(s, "Bytes", { enumerable: !0, get: function() {
      return A.Bytes;
    } }), Object.defineProperty(s, "BytesLookup", { enumerable: !0, get: function() {
      return A.BytesLookup;
    } });
    const u = requireField();
    Object.defineProperty(s, "FieldLookup", { enumerable: !0, get: function() {
      return u.FieldLookup;
    } });
    const p = requireConstants$2();
    class t {
      /**
       * Present rippled types in a typed and updatable format.
       * For an example of the input format see `definitions.json`
       * To generate a new definitions file from rippled source code, use this tool: https://github.com/RichardAH/xrpl-codec-gen
       *
       * See the definitions.test.js file for examples of how to create your own updated definitions.json.
       *
       * @param enums - A json encoding of the core types, transaction types, transaction results, transaction names, and fields.
       * @param types - A list of type objects with the same name as the fields defined.
       *              You can use the coreTypes object if you are not adding new types.
       */
      constructor(m, b) {
        this.type = new A.BytesLookup(m.TYPES, p.TYPE_WIDTH), this.ledgerEntryType = new A.BytesLookup(m.LEDGER_ENTRY_TYPES, p.LEDGER_ENTRY_WIDTH), this.transactionType = new A.BytesLookup(m.TRANSACTION_TYPES, p.TRANSACTION_TYPE_WIDTH), this.transactionResult = new A.BytesLookup(m.TRANSACTION_RESULTS, p.TRANSACTION_RESULT_WIDTH), this.field = new u.FieldLookup(m.FIELDS, m.TYPES), this.transactionNames = Object.entries(m.TRANSACTION_TYPES).filter(([k, C]) => C >= 0).map(([k, C]) => k), this.dataTypes = {}, this.associateTypes(b);
      }
      /**
       * Associates each Field to a corresponding class that TypeScript can recognize.
       *
       * @param types a list of type objects with the same name as the fields defined.
       *              Defaults to xrpl.js's core type definitions.
       */
      associateTypes(m) {
        this.dataTypes = Object.assign({}, this.dataTypes, m), Object.values(this.field).forEach((b) => {
          b.associatedType = this.dataTypes[b.type.name];
        }), this.field.TransactionType.associatedType = this.transactionType, this.field.TransactionResult.associatedType = this.transactionResult, this.field.LedgerEntryType.associatedType = this.ledgerEntryType;
      }
      getAssociatedTypes() {
        return this.dataTypes;
      }
    }
    s.XrplDefinitionsBase = t;
  }(xrplDefinitionsBase)), xrplDefinitionsBase;
}
var hasRequiredEnums;
function requireEnums() {
  return hasRequiredEnums || (hasRequiredEnums = 1, function(s) {
    var A = enums && enums.__createBinding || (Object.create ? function(x, M, F, le) {
      le === void 0 && (le = F);
      var ge = Object.getOwnPropertyDescriptor(M, F);
      (!ge || ("get" in ge ? !M.__esModule : ge.writable || ge.configurable)) && (ge = { enumerable: !0, get: function() {
        return M[F];
      } }), Object.defineProperty(x, le, ge);
    } : function(x, M, F, le) {
      le === void 0 && (le = F), x[le] = M[F];
    }), u = enums && enums.__setModuleDefault || (Object.create ? function(x, M) {
      Object.defineProperty(x, "default", { enumerable: !0, value: M });
    } : function(x, M) {
      x.default = M;
    }), p = enums && enums.__importStar || function(x) {
      if (x && x.__esModule) return x;
      var M = {};
      if (x != null) for (var F in x) F !== "default" && Object.prototype.hasOwnProperty.call(x, F) && A(M, x, F);
      return u(M, x), M;
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), s.TRANSACTION_TYPES = s.TransactionType = s.TransactionResult = s.LedgerEntryType = s.Type = s.Field = s.DEFAULT_DEFINITIONS = s.XrplDefinitionsBase = s.Bytes = void 0;
    const t = p(require$$0), l = requireXrplDefinitionsBase();
    Object.defineProperty(s, "XrplDefinitionsBase", { enumerable: !0, get: function() {
      return l.XrplDefinitionsBase;
    } }), Object.defineProperty(s, "Bytes", { enumerable: !0, get: function() {
      return l.Bytes;
    } });
    const m = new l.XrplDefinitionsBase(t, {});
    s.DEFAULT_DEFINITIONS = m;
    const b = m.type;
    s.Type = b;
    const k = m.ledgerEntryType;
    s.LedgerEntryType = k;
    const C = m.transactionType;
    s.TransactionType = C;
    const B = m.transactionResult;
    s.TransactionResult = B;
    const Q = m.field;
    s.Field = Q;
    const P = m.transactionNames;
    s.TRANSACTION_TYPES = P;
  }(enums)), enums;
}
var types$3 = {}, accountId = {}, dist$2 = {}, xrpCodec = {}, utils$5 = {}, hasRequiredUtils$4;
function requireUtils$4() {
  if (hasRequiredUtils$4) return utils$5;
  hasRequiredUtils$4 = 1, Object.defineProperty(utils$5, "__esModule", { value: !0 }), utils$5.concatArgs = utils$5.seqEqual = void 0;
  function s(p, t) {
    if (p.length !== t.length)
      return !1;
    for (let l = 0; l < p.length; l++)
      if (p[l] !== t[l])
        return !1;
    return !0;
  }
  utils$5.seqEqual = s;
  function A(p) {
    return typeof p != "number";
  }
  function u(...p) {
    const t = [];
    return p.forEach((l) => {
      if (A(l))
        for (const m of l)
          t.push(m);
      else
        t.push(l);
    }), t;
  }
  return utils$5.concatArgs = u, utils$5;
}
var hasRequiredXrpCodec;
function requireXrpCodec() {
  if (hasRequiredXrpCodec) return xrpCodec;
  hasRequiredXrpCodec = 1, Object.defineProperty(xrpCodec, "__esModule", { value: !0 }), xrpCodec.isValidClassicAddress = xrpCodec.decodeAccountPublic = xrpCodec.encodeAccountPublic = xrpCodec.encodeNodePublic = xrpCodec.decodeNodePublic = xrpCodec.decodeAddress = xrpCodec.decodeAccountID = xrpCodec.encodeAddress = xrpCodec.encodeAccountID = xrpCodec.decodeSeed = xrpCodec.encodeSeed = xrpCodec.codec = void 0;
  const s = requireSrc$2(), A = requireBrowser$a(), u = requireUtils$4();
  class p {
    constructor(Pe) {
      this._sha256 = Pe.sha256, this._alphabet = Pe.alphabet, this._codec = s(this._alphabet);
    }
    /**
     * Encoder.
     *
     * @param bytes - Buffer of data to encode.
     * @param opts - Options object including the version bytes and the expected length of the data to encode.
     */
    encode(Pe, Te) {
      const Qe = Te.versions;
      return this._encodeVersioned(Pe, Qe, Te.expectedLength);
    }
    /**
     * Decoder.
     *
     * @param base58string - Base58Check-encoded string to decode.
     * @param opts - Options object including the version byte(s) and the expected length of the data after decoding.
     */
    /* eslint-disable max-lines-per-function --
     * TODO refactor */
    decode(Pe, Te) {
      var Qe;
      const xe = Te.versions, Ee = Te.versionTypes, He = this.decodeChecked(Pe);
      if (xe.length > 1 && !Te.expectedLength)
        throw new Error("expectedLength is required because there are >= 2 possible versions");
      const ve = typeof xe[0] == "number" ? 1 : xe[0].length, we = (Qe = Te.expectedLength) !== null && Qe !== void 0 ? Qe : He.length - ve, Ce = He.slice(0, -we), Se = He.slice(-we);
      for (let Ne = 0; Ne < xe.length; Ne++) {
        const rr = Array.isArray(xe[Ne]) ? xe[Ne] : [xe[Ne]];
        if ((0, u.seqEqual)(Ce, rr))
          return {
            version: rr,
            bytes: Se,
            type: Ee ? Ee[Ne] : null
          };
      }
      throw new Error("version_invalid: version bytes do not match any of the provided version(s)");
    }
    encodeChecked(Pe) {
      const Te = this._sha256(this._sha256(Pe)).slice(0, 4);
      return this._encodeRaw(Buffer.from((0, u.concatArgs)(Pe, Te)));
    }
    decodeChecked(Pe) {
      const Te = this._decodeRaw(Pe);
      if (Te.length < 5)
        throw new Error("invalid_input_size: decoded data must have length >= 5");
      if (!this._verifyCheckSum(Te))
        throw new Error("checksum_invalid");
      return Te.slice(0, -4);
    }
    _encodeVersioned(Pe, Te, Qe) {
      if (Qe && Pe.length !== Qe)
        throw new Error("unexpected_payload_length: bytes.length does not match expectedLength. Ensure that the bytes are a Buffer.");
      return this.encodeChecked(Buffer.from((0, u.concatArgs)(Te, Pe)));
    }
    _encodeRaw(Pe) {
      return this._codec.encode(Pe);
    }
    /* eslint-enable max-lines-per-function */
    _decodeRaw(Pe) {
      return this._codec.decode(Pe);
    }
    _verifyCheckSum(Pe) {
      const Te = this._sha256(this._sha256(Pe.slice(0, -4))).slice(0, 4), Qe = Pe.slice(-4);
      return (0, u.seqEqual)(Te, Qe);
    }
  }
  const t = 0, l = 35, m = 33, b = 28, k = [1, 225, 75], C = {
    sha256(be) {
      return A("sha256").update(Buffer.from(be)).digest();
    },
    alphabet: "rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz"
  }, B = new p(C);
  xrpCodec.codec = B;
  function Q(be, Pe) {
    if (be.length !== 16)
      throw new Error("entropy must have length 16");
    const Te = {
      expectedLength: 16,
      // for secp256k1, use `FAMILY_SEED`
      versions: Pe === "ed25519" ? k : [m]
    };
    return B.encode(be, Te);
  }
  xrpCodec.encodeSeed = Q;
  function P(be, Pe = {
    versionTypes: ["ed25519", "secp256k1"],
    versions: [k, m],
    expectedLength: 16
  }) {
    return B.decode(be, Pe);
  }
  xrpCodec.decodeSeed = P;
  function x(be) {
    const Pe = { versions: [t], expectedLength: 20 };
    return B.encode(be, Pe);
  }
  xrpCodec.encodeAccountID = x, xrpCodec.encodeAddress = x;
  function M(be) {
    const Pe = { versions: [t], expectedLength: 20 };
    return B.decode(be, Pe).bytes;
  }
  xrpCodec.decodeAccountID = M, xrpCodec.decodeAddress = M;
  function F(be) {
    const Pe = { versions: [b], expectedLength: 33 };
    return B.decode(be, Pe).bytes;
  }
  xrpCodec.decodeNodePublic = F;
  function le(be) {
    const Pe = { versions: [b], expectedLength: 33 };
    return B.encode(be, Pe);
  }
  xrpCodec.encodeNodePublic = le;
  function ge(be) {
    const Pe = { versions: [l], expectedLength: 33 };
    return B.encode(be, Pe);
  }
  xrpCodec.encodeAccountPublic = ge;
  function pe(be) {
    const Pe = { versions: [l], expectedLength: 33 };
    return B.decode(be, Pe).bytes;
  }
  xrpCodec.decodeAccountPublic = pe;
  function Ie(be) {
    try {
      M(be);
    } catch {
      return !1;
    }
    return !0;
  }
  return xrpCodec.isValidClassicAddress = Ie, xrpCodec;
}
var hasRequiredDist$4;
function requireDist$4() {
  return hasRequiredDist$4 || (hasRequiredDist$4 = 1, function(s) {
    var A = dist$2 && dist$2.__createBinding || (Object.create ? function(F, le, ge, pe) {
      pe === void 0 && (pe = ge);
      var Ie = Object.getOwnPropertyDescriptor(le, ge);
      (!Ie || ("get" in Ie ? !le.__esModule : Ie.writable || Ie.configurable)) && (Ie = { enumerable: !0, get: function() {
        return le[ge];
      } }), Object.defineProperty(F, pe, Ie);
    } : function(F, le, ge, pe) {
      pe === void 0 && (pe = ge), F[pe] = le[ge];
    }), u = dist$2 && dist$2.__setModuleDefault || (Object.create ? function(F, le) {
      Object.defineProperty(F, "default", { enumerable: !0, value: le });
    } : function(F, le) {
      F.default = le;
    }), p = dist$2 && dist$2.__importStar || function(F) {
      if (F && F.__esModule) return F;
      var le = {};
      if (F != null) for (var ge in F) ge !== "default" && Object.prototype.hasOwnProperty.call(F, ge) && A(le, F, ge);
      return u(le, F), le;
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), s.isValidXAddress = s.decodeXAddress = s.xAddressToClassicAddress = s.encodeXAddress = s.classicAddressToXAddress = s.isValidClassicAddress = s.decodeAccountPublic = s.encodeAccountPublic = s.decodeNodePublic = s.encodeNodePublic = s.decodeAccountID = s.encodeAccountID = s.decodeSeed = s.encodeSeed = s.codec = void 0;
    const t = p(requireAssert$2()), l = requireXrpCodec();
    Object.defineProperty(s, "codec", { enumerable: !0, get: function() {
      return l.codec;
    } }), Object.defineProperty(s, "encodeSeed", { enumerable: !0, get: function() {
      return l.encodeSeed;
    } }), Object.defineProperty(s, "decodeSeed", { enumerable: !0, get: function() {
      return l.decodeSeed;
    } }), Object.defineProperty(s, "encodeAccountID", { enumerable: !0, get: function() {
      return l.encodeAccountID;
    } }), Object.defineProperty(s, "decodeAccountID", { enumerable: !0, get: function() {
      return l.decodeAccountID;
    } }), Object.defineProperty(s, "encodeNodePublic", { enumerable: !0, get: function() {
      return l.encodeNodePublic;
    } }), Object.defineProperty(s, "decodeNodePublic", { enumerable: !0, get: function() {
      return l.decodeNodePublic;
    } }), Object.defineProperty(s, "encodeAccountPublic", { enumerable: !0, get: function() {
      return l.encodeAccountPublic;
    } }), Object.defineProperty(s, "decodeAccountPublic", { enumerable: !0, get: function() {
      return l.decodeAccountPublic;
    } }), Object.defineProperty(s, "isValidClassicAddress", { enumerable: !0, get: function() {
      return l.isValidClassicAddress;
    } });
    const m = {
      // 5, 68
      main: Buffer.from([5, 68]),
      // 4, 147
      test: Buffer.from([4, 147])
    }, b = 4294967295;
    function k(F, le, ge) {
      const pe = (0, l.decodeAccountID)(F);
      return C(pe, le, ge);
    }
    s.classicAddressToXAddress = k;
    function C(F, le, ge) {
      if (F.length !== 20)
        throw new Error("Account ID must be 20 bytes");
      if (le > b)
        throw new Error("Invalid tag");
      const pe = le || 0, Ie = le === !1 || le == null ? 0 : 1, be = Buffer.concat([
        ge ? m.test : m.main,
        F,
        Buffer.from([
          // 0x00 if no tag, 0x01 if 32-bit tag
          Ie,
          // first byte
          pe & 255,
          // second byte
          pe >> 8 & 255,
          // third byte
          pe >> 16 & 255,
          // fourth byte
          pe >> 24 & 255,
          0,
          0,
          0,
          // four zero bytes (reserved for 64-bit tags)
          0
        ])
      ]);
      return l.codec.encodeChecked(be);
    }
    s.encodeXAddress = C;
    function B(F) {
      const { accountId: le, tag: ge, test: pe } = Q(F);
      return {
        classicAddress: (0, l.encodeAccountID)(le),
        tag: ge,
        test: pe
      };
    }
    s.xAddressToClassicAddress = B;
    function Q(F) {
      const le = l.codec.decodeChecked(F), ge = P(le), pe = le.slice(2, 22), Ie = x(le);
      return {
        accountId: pe,
        tag: Ie,
        test: ge
      };
    }
    s.decodeXAddress = Q;
    function P(F) {
      const le = F.slice(0, 2);
      if (m.main.equals(le))
        return !1;
      if (m.test.equals(le))
        return !0;
      throw new Error("Invalid X-address: bad prefix");
    }
    function x(F) {
      const le = F[22];
      if (le >= 2)
        throw new Error("Unsupported X-address");
      return le === 1 ? F[23] + F[24] * 256 + F[25] * 65536 + F[26] * 16777216 : (t.strictEqual(le, 0, "flag must be zero to indicate no tag"), t.ok(Buffer.from("0000000000000000", "hex").equals(F.slice(23, 31)), "remaining bytes must be zero"), !1);
    }
    function M(F) {
      try {
        Q(F);
      } catch {
        return !1;
      }
      return !0;
    }
    s.isValidXAddress = M;
  }(dist$2)), dist$2;
}
var hash160$2 = {}, hash$o = {}, hasRequiredHash;
function requireHash() {
  if (hasRequiredHash) return hash$o;
  hasRequiredHash = 1, Object.defineProperty(hash$o, "__esModule", { value: !0 }), hash$o.Hash = void 0;
  const s = requireSerializedType(), A = requireDist$n();
  class u extends s.Comparable {
    constructor(t) {
      if (super(t), this.bytes.byteLength !== this.constructor.width)
        throw new Error(`Invalid Hash length ${this.bytes.byteLength}`);
    }
    /**
     * Construct a Hash object from an existing Hash object or a hex-string
     *
     * @param value A hash object or hex-string of a hash
     */
    static from(t) {
      if (t instanceof this)
        return t;
      if (typeof t == "string")
        return new this(A.Buffer.from(t, "hex"));
      throw new Error("Cannot construct Hash from given value");
    }
    /**
     * Read a Hash object from a BinaryParser
     *
     * @param parser BinaryParser to read the hash from
     * @param hint length of the bytes to read, optional
     */
    static fromParser(t, l) {
      return new this(t.read(l ?? this.width));
    }
    /**
     * Overloaded operator for comparing two hash objects
     *
     * @param other The Hash to compare this to
     */
    compareTo(t) {
      return this.bytes.compare(this.constructor.from(t).bytes);
    }
    /**
     * @returns the hex-string representation of this Hash
     */
    toString() {
      return this.toHex();
    }
    /**
     * Returns four bits at the specified depth within a hash
     *
     * @param depth The depth of the four bits
     * @returns The number represented by the four bits
     */
    nibblet(t) {
      const l = t > 0 ? t / 2 | 0 : 0;
      let m = this.bytes[l];
      return t % 2 === 0 ? m = (m & 240) >>> 4 : m = m & 15, m;
    }
  }
  return hash$o.Hash = u, hash$o;
}
var hasRequiredHash160;
function requireHash160() {
  if (hasRequiredHash160) return hash160$2;
  hasRequiredHash160 = 1, Object.defineProperty(hash160$2, "__esModule", { value: !0 }), hash160$2.Hash160 = void 0;
  const s = requireHash(), A = requireDist$n();
  class u extends s.Hash {
    constructor(t) {
      t && t.byteLength === 0 && (t = u.ZERO_160.bytes), super(t ?? u.ZERO_160.bytes);
    }
  }
  return hash160$2.Hash160 = u, u.width = 20, u.ZERO_160 = new u(A.Buffer.alloc(u.width)), hash160$2;
}
var hasRequiredAccountId;
function requireAccountId() {
  if (hasRequiredAccountId) return accountId;
  hasRequiredAccountId = 1, Object.defineProperty(accountId, "__esModule", { value: !0 }), accountId.AccountID = void 0;
  const s = requireDist$4(), A = requireHash160(), u = requireDist$n(), p = /^[A-F0-9]{40}$/;
  class t extends A.Hash160 {
    constructor(m) {
      super(m ?? t.defaultAccountID.bytes);
    }
    /**
     * Defines how to construct an AccountID
     *
     * @param value either an existing AccountID, a hex-string, or a base58 r-Address
     * @returns an AccountID object
     */
    static from(m) {
      if (m instanceof t)
        return m;
      if (typeof m == "string")
        return m === "" ? new t() : p.test(m) ? new t(u.Buffer.from(m, "hex")) : this.fromBase58(m);
      throw new Error("Cannot construct AccountID from value given");
    }
    /**
     * Defines how to build an AccountID from a base58 r-Address
     *
     * @param value a base58 r-Address
     * @returns an AccountID object
     */
    static fromBase58(m) {
      if ((0, s.isValidXAddress)(m)) {
        const b = (0, s.xAddressToClassicAddress)(m);
        if (b.tag !== !1)
          throw new Error("Only allowed to have tag on Account or Destination");
        m = b.classicAddress;
      }
      return new t(u.Buffer.from((0, s.decodeAccountID)(m)));
    }
    /**
     * Overload of toJSON
     *
     * @returns the base58 string for this AccountID
     */
    toJSON() {
      return this.toBase58();
    }
    /**
     * Defines how to encode AccountID into a base58 address
     *
     * @returns the base58 string defined by this.bytes
     */
    toBase58() {
      return (0, s.encodeAccountID)(this.bytes);
    }
  }
  return accountId.AccountID = t, t.defaultAccountID = new t(u.Buffer.alloc(20)), accountId;
}
var amount = {}, decimal$3 = { exports: {} }, decimal$2 = decimal$3.exports, hasRequiredDecimal$1;
function requireDecimal$1() {
  return hasRequiredDecimal$1 || (hasRequiredDecimal$1 = 1, function(s) {
    (function(A) {
      var u = 9e15, p = 1e9, t = "0123456789abcdef", l = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", m = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", b = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed at run-time using the `Decimal.config` method.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // 1 to MAX_DIGITS
        // The rounding mode used when rounding to `precision`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // 0 to 8
        // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP         0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
        // FLOOR      3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN  6 The IEEE 754 remainder function.
        // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
        //
        // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
        // division (9) are commonly used for the modulus operation. The other rounding modes can also
        // be used, but they may not give useful results.
        modulo: 1,
        // 0 to 9
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // 0 to -EXP_LIMIT
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // 0 to EXP_LIMIT
        // The minimum exponent value, beneath which underflow to zero occurs.
        // JavaScript numbers: -324  (5e-324)
        minE: -u,
        // -1 to -EXP_LIMIT
        // The maximum exponent value, above which overflow to Infinity occurs.
        // JavaScript numbers: 308  (1.7976931348623157e+308)
        maxE: u,
        // 1 to EXP_LIMIT
        // Whether to use cryptographically-secure random number generation, if available.
        crypto: !1
        // true/false
      }, k, C, B, Q, P = !0, x = "[DecimalError] ", M = x + "Invalid argument: ", F = x + "Precision limit exceeded", le = x + "crypto unavailable", ge = "[object Decimal]", pe = Math.floor, Ie = Math.pow, be = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, Pe = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, Te = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, Qe = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, xe = 1e7, Ee = 7, He = 9007199254740991, ve = l.length - 1, we = m.length - 1, Ce = { toStringTag: ge };
      Ce.absoluteValue = Ce.abs = function() {
        var pn = new this.constructor(this);
        return pn.s < 0 && (pn.s = 1), nr(pn);
      }, Ce.ceil = function() {
        return nr(new this.constructor(this), this.e + 1, 2);
      }, Ce.clampedTo = Ce.clamp = function(pn, Nr) {
        var Qn, zn = this, ti = zn.constructor;
        if (pn = new ti(pn), Nr = new ti(Nr), !pn.s || !Nr.s) return new ti(NaN);
        if (pn.gt(Nr)) throw Error(M + Nr);
        return Qn = zn.cmp(pn), Qn < 0 ? pn : zn.cmp(Nr) > 0 ? Nr : new ti(zn);
      }, Ce.comparedTo = Ce.cmp = function(pn) {
        var Nr, Qn, zn, ti, v = this, d = v.d, I = (pn = new v.constructor(pn)).d, n = v.s, a = pn.s;
        if (!d || !I)
          return !n || !a ? NaN : n !== a ? n : d === I ? 0 : !d ^ n < 0 ? 1 : -1;
        if (!d[0] || !I[0]) return d[0] ? n : I[0] ? -a : 0;
        if (n !== a) return n;
        if (v.e !== pn.e) return v.e > pn.e ^ n < 0 ? 1 : -1;
        for (zn = d.length, ti = I.length, Nr = 0, Qn = zn < ti ? zn : ti; Nr < Qn; ++Nr)
          if (d[Nr] !== I[Nr]) return d[Nr] > I[Nr] ^ n < 0 ? 1 : -1;
        return zn === ti ? 0 : zn > ti ^ n < 0 ? 1 : -1;
      }, Ce.cosine = Ce.cos = function() {
        var pn, Nr, Qn = this, zn = Qn.constructor;
        return Qn.d ? Qn.d[0] ? (pn = zn.precision, Nr = zn.rounding, zn.precision = pn + Math.max(Qn.e, Qn.sd()) + Ee, zn.rounding = 1, Qn = ir(zn, dn(zn, Qn)), zn.precision = pn, zn.rounding = Nr, nr(Q == 2 || Q == 3 ? Qn.neg() : Qn, pn, Nr, !0)) : new zn(1) : new zn(NaN);
      }, Ce.cubeRoot = Ce.cbrt = function() {
        var pn, Nr, Qn, zn, ti, v, d, I, n, a, E = this, T = E.constructor;
        if (!E.isFinite() || E.isZero()) return new T(E);
        for (P = !1, v = E.s * Ie(E.s * E, 1 / 3), !v || Math.abs(v) == 1 / 0 ? (Qn = Se(E.d), pn = E.e, (v = (pn - Qn.length + 1) % 3) && (Qn += v == 1 || v == -2 ? "0" : "00"), v = Ie(Qn, 1 / 3), pn = pe((pn + 1) / 3) - (pn % 3 == (pn < 0 ? -1 : 2)), v == 1 / 0 ? Qn = "5e" + pn : (Qn = v.toExponential(), Qn = Qn.slice(0, Qn.indexOf("e") + 1) + pn), zn = new T(Qn), zn.s = E.s) : zn = new T(v.toString()), d = (pn = T.precision) + 3; ; )
          if (I = zn, n = I.times(I).times(I), a = n.plus(E), zn = sr(a.plus(E).times(I), a.plus(n), d + 2, 1), Se(I.d).slice(0, d) === (Qn = Se(zn.d)).slice(0, d))
            if (Qn = Qn.slice(d - 3, d + 1), Qn == "9999" || !ti && Qn == "4999") {
              if (!ti && (nr(I, pn + 1, 0), I.times(I).times(I).eq(E))) {
                zn = I;
                break;
              }
              d += 4, ti = 1;
            } else {
              (!+Qn || !+Qn.slice(1) && Qn.charAt(0) == "5") && (nr(zn, pn + 1, 1), Nr = !zn.times(zn).times(zn).eq(E));
              break;
            }
        return P = !0, nr(zn, pn, T.rounding, Nr);
      }, Ce.decimalPlaces = Ce.dp = function() {
        var pn, Nr = this.d, Qn = NaN;
        if (Nr) {
          if (pn = Nr.length - 1, Qn = (pn - pe(this.e / Ee)) * Ee, pn = Nr[pn], pn) for (; pn % 10 == 0; pn /= 10) Qn--;
          Qn < 0 && (Qn = 0);
        }
        return Qn;
      }, Ce.dividedBy = Ce.div = function(pn) {
        return sr(this, new this.constructor(pn));
      }, Ce.dividedToIntegerBy = Ce.divToInt = function(pn) {
        var Nr = this, Qn = Nr.constructor;
        return nr(sr(Nr, new Qn(pn), 0, 1, 1), Qn.precision, Qn.rounding);
      }, Ce.equals = Ce.eq = function(pn) {
        return this.cmp(pn) === 0;
      }, Ce.floor = function() {
        return nr(new this.constructor(this), this.e + 1, 3);
      }, Ce.greaterThan = Ce.gt = function(pn) {
        return this.cmp(pn) > 0;
      }, Ce.greaterThanOrEqualTo = Ce.gte = function(pn) {
        var Nr = this.cmp(pn);
        return Nr == 1 || Nr === 0;
      }, Ce.hyperbolicCosine = Ce.cosh = function() {
        var pn, Nr, Qn, zn, ti, v = this, d = v.constructor, I = new d(1);
        if (!v.isFinite()) return new d(v.s ? 1 / 0 : NaN);
        if (v.isZero()) return I;
        Qn = d.precision, zn = d.rounding, d.precision = Qn + Math.max(v.e, v.sd()) + 4, d.rounding = 1, ti = v.d.length, ti < 32 ? (pn = Math.ceil(ti / 3), Nr = (1 / jr(4, pn)).toString()) : (pn = 16, Nr = "2.3283064365386962890625e-10"), v = fn(d, 1, v.times(Nr), new d(1), !0);
        for (var n, a = pn, E = new d(8); a--; )
          n = v.times(v), v = I.minus(n.times(E.minus(n.times(E))));
        return nr(v, d.precision = Qn, d.rounding = zn, !0);
      }, Ce.hyperbolicSine = Ce.sinh = function() {
        var pn, Nr, Qn, zn, ti = this, v = ti.constructor;
        if (!ti.isFinite() || ti.isZero()) return new v(ti);
        if (Nr = v.precision, Qn = v.rounding, v.precision = Nr + Math.max(ti.e, ti.sd()) + 4, v.rounding = 1, zn = ti.d.length, zn < 3)
          ti = fn(v, 2, ti, ti, !0);
        else {
          pn = 1.4 * Math.sqrt(zn), pn = pn > 16 ? 16 : pn | 0, ti = ti.times(1 / jr(5, pn)), ti = fn(v, 2, ti, ti, !0);
          for (var d, I = new v(5), n = new v(16), a = new v(20); pn--; )
            d = ti.times(ti), ti = ti.times(I.plus(d.times(n.times(d).plus(a))));
        }
        return v.precision = Nr, v.rounding = Qn, nr(ti, Nr, Qn, !0);
      }, Ce.hyperbolicTangent = Ce.tanh = function() {
        var pn, Nr, Qn = this, zn = Qn.constructor;
        return Qn.isFinite() ? Qn.isZero() ? new zn(Qn) : (pn = zn.precision, Nr = zn.rounding, zn.precision = pn + 7, zn.rounding = 1, sr(Qn.sinh(), Qn.cosh(), zn.precision = pn, zn.rounding = Nr)) : new zn(Qn.s);
      }, Ce.inverseCosine = Ce.acos = function() {
        var pn = this, Nr = pn.constructor, Qn = pn.abs().cmp(1), zn = Nr.precision, ti = Nr.rounding;
        return Qn !== -1 ? Qn === 0 ? pn.isNeg() ? Br(Nr, zn, ti) : new Nr(0) : new Nr(NaN) : pn.isZero() ? Br(Nr, zn + 4, ti).times(0.5) : (Nr.precision = zn + 6, Nr.rounding = 1, pn = new Nr(1).minus(pn).div(pn.plus(1)).sqrt().atan(), Nr.precision = zn, Nr.rounding = ti, pn.times(2));
      }, Ce.inverseHyperbolicCosine = Ce.acosh = function() {
        var pn, Nr, Qn = this, zn = Qn.constructor;
        return Qn.lte(1) ? new zn(Qn.eq(1) ? 0 : NaN) : Qn.isFinite() ? (pn = zn.precision, Nr = zn.rounding, zn.precision = pn + Math.max(Math.abs(Qn.e), Qn.sd()) + 4, zn.rounding = 1, P = !1, Qn = Qn.times(Qn).minus(1).sqrt().plus(Qn), P = !0, zn.precision = pn, zn.rounding = Nr, Qn.ln()) : new zn(Qn);
      }, Ce.inverseHyperbolicSine = Ce.asinh = function() {
        var pn, Nr, Qn = this, zn = Qn.constructor;
        return !Qn.isFinite() || Qn.isZero() ? new zn(Qn) : (pn = zn.precision, Nr = zn.rounding, zn.precision = pn + 2 * Math.max(Math.abs(Qn.e), Qn.sd()) + 6, zn.rounding = 1, P = !1, Qn = Qn.times(Qn).plus(1).sqrt().plus(Qn), P = !0, zn.precision = pn, zn.rounding = Nr, Qn.ln());
      }, Ce.inverseHyperbolicTangent = Ce.atanh = function() {
        var pn, Nr, Qn, zn, ti = this, v = ti.constructor;
        return ti.isFinite() ? ti.e >= 0 ? new v(ti.abs().eq(1) ? ti.s / 0 : ti.isZero() ? ti : NaN) : (pn = v.precision, Nr = v.rounding, zn = ti.sd(), Math.max(zn, pn) < 2 * -ti.e - 1 ? nr(new v(ti), pn, Nr, !0) : (v.precision = Qn = zn - ti.e, ti = sr(ti.plus(1), new v(1).minus(ti), Qn + pn, 1), v.precision = pn + 4, v.rounding = 1, ti = ti.ln(), v.precision = pn, v.rounding = Nr, ti.times(0.5))) : new v(NaN);
      }, Ce.inverseSine = Ce.asin = function() {
        var pn, Nr, Qn, zn, ti = this, v = ti.constructor;
        return ti.isZero() ? new v(ti) : (Nr = ti.abs().cmp(1), Qn = v.precision, zn = v.rounding, Nr !== -1 ? Nr === 0 ? (pn = Br(v, Qn + 4, zn).times(0.5), pn.s = ti.s, pn) : new v(NaN) : (v.precision = Qn + 6, v.rounding = 1, ti = ti.div(new v(1).minus(ti.times(ti)).sqrt().plus(1)).atan(), v.precision = Qn, v.rounding = zn, ti.times(2)));
      }, Ce.inverseTangent = Ce.atan = function() {
        var pn, Nr, Qn, zn, ti, v, d, I, n, a = this, E = a.constructor, T = E.precision, L = E.rounding;
        if (a.isFinite()) {
          if (a.isZero())
            return new E(a);
          if (a.abs().eq(1) && T + 4 <= we)
            return d = Br(E, T + 4, L).times(0.25), d.s = a.s, d;
        } else {
          if (!a.s) return new E(NaN);
          if (T + 4 <= we)
            return d = Br(E, T + 4, L).times(0.5), d.s = a.s, d;
        }
        for (E.precision = I = T + 10, E.rounding = 1, Qn = Math.min(28, I / Ee + 2 | 0), pn = Qn; pn; --pn) a = a.div(a.times(a).plus(1).sqrt().plus(1));
        for (P = !1, Nr = Math.ceil(I / Ee), zn = 1, n = a.times(a), d = new E(a), ti = a; pn !== -1; )
          if (ti = ti.times(n), v = d.minus(ti.div(zn += 2)), ti = ti.times(n), d = v.plus(ti.div(zn += 2)), d.d[Nr] !== void 0) for (pn = Nr; d.d[pn] === v.d[pn] && pn--; ) ;
        return Qn && (d = d.times(2 << Qn - 1)), P = !0, nr(d, E.precision = T, E.rounding = L, !0);
      }, Ce.isFinite = function() {
        return !!this.d;
      }, Ce.isInteger = Ce.isInt = function() {
        return !!this.d && pe(this.e / Ee) > this.d.length - 2;
      }, Ce.isNaN = function() {
        return !this.s;
      }, Ce.isNegative = Ce.isNeg = function() {
        return this.s < 0;
      }, Ce.isPositive = Ce.isPos = function() {
        return this.s > 0;
      }, Ce.isZero = function() {
        return !!this.d && this.d[0] === 0;
      }, Ce.lessThan = Ce.lt = function(pn) {
        return this.cmp(pn) < 0;
      }, Ce.lessThanOrEqualTo = Ce.lte = function(pn) {
        return this.cmp(pn) < 1;
      }, Ce.logarithm = Ce.log = function(pn) {
        var Nr, Qn, zn, ti, v, d, I, n, a = this, E = a.constructor, T = E.precision, L = E.rounding, he = 5;
        if (pn == null)
          pn = new E(10), Nr = !0;
        else {
          if (pn = new E(pn), Qn = pn.d, pn.s < 0 || !Qn || !Qn[0] || pn.eq(1)) return new E(NaN);
          Nr = pn.eq(10);
        }
        if (Qn = a.d, a.s < 0 || !Qn || !Qn[0] || a.eq(1))
          return new E(Qn && !Qn[0] ? -1 / 0 : a.s != 1 ? NaN : Qn ? 0 : 1 / 0);
        if (Nr)
          if (Qn.length > 1)
            v = !0;
          else {
            for (ti = Qn[0]; ti % 10 === 0; ) ti /= 10;
            v = ti !== 1;
          }
        if (P = !1, I = T + he, d = wr(a, I), zn = Nr ? br(E, I + 10) : wr(pn, I), n = sr(d, zn, I, 1), rr(n.d, ti = T, L))
          do
            if (I += 10, d = wr(a, I), zn = Nr ? br(E, I + 10) : wr(pn, I), n = sr(d, zn, I, 1), !v) {
              +Se(n.d).slice(ti + 1, ti + 15) + 1 == 1e14 && (n = nr(n, T + 1, 0));
              break;
            }
          while (rr(n.d, ti += 10, L));
        return P = !0, nr(n, T, L);
      }, Ce.minus = Ce.sub = function(pn) {
        var Nr, Qn, zn, ti, v, d, I, n, a, E, T, L, he = this, Be = he.constructor;
        if (pn = new Be(pn), !he.d || !pn.d)
          return !he.s || !pn.s ? pn = new Be(NaN) : he.d ? pn.s = -pn.s : pn = new Be(pn.d || he.s !== pn.s ? he : NaN), pn;
        if (he.s != pn.s)
          return pn.s = -pn.s, he.plus(pn);
        if (a = he.d, L = pn.d, I = Be.precision, n = Be.rounding, !a[0] || !L[0]) {
          if (L[0]) pn.s = -pn.s;
          else if (a[0]) pn = new Be(he);
          else return new Be(n === 3 ? -0 : 0);
          return P ? nr(pn, I, n) : pn;
        }
        if (Qn = pe(pn.e / Ee), E = pe(he.e / Ee), a = a.slice(), v = E - Qn, v) {
          for (T = v < 0, T ? (Nr = a, v = -v, d = L.length) : (Nr = L, Qn = E, d = a.length), zn = Math.max(Math.ceil(I / Ee), d) + 2, v > zn && (v = zn, Nr.length = 1), Nr.reverse(), zn = v; zn--; ) Nr.push(0);
          Nr.reverse();
        } else {
          for (zn = a.length, d = L.length, T = zn < d, T && (d = zn), zn = 0; zn < d; zn++)
            if (a[zn] != L[zn]) {
              T = a[zn] < L[zn];
              break;
            }
          v = 0;
        }
        for (T && (Nr = a, a = L, L = Nr, pn.s = -pn.s), d = a.length, zn = L.length - d; zn > 0; --zn) a[d++] = 0;
        for (zn = L.length; zn > v; ) {
          if (a[--zn] < L[zn]) {
            for (ti = zn; ti && a[--ti] === 0; ) a[ti] = xe - 1;
            --a[ti], a[zn] += xe;
          }
          a[zn] -= L[zn];
        }
        for (; a[--d] === 0; ) a.pop();
        for (; a[0] === 0; a.shift()) --Qn;
        return a[0] ? (pn.d = a, pn.e = lr(a, Qn), P ? nr(pn, I, n) : pn) : new Be(n === 3 ? -0 : 0);
      }, Ce.modulo = Ce.mod = function(pn) {
        var Nr, Qn = this, zn = Qn.constructor;
        return pn = new zn(pn), !Qn.d || !pn.s || pn.d && !pn.d[0] ? new zn(NaN) : !pn.d || Qn.d && !Qn.d[0] ? nr(new zn(Qn), zn.precision, zn.rounding) : (P = !1, zn.modulo == 9 ? (Nr = sr(Qn, pn.abs(), 0, 3, 1), Nr.s *= pn.s) : Nr = sr(Qn, pn, 0, zn.modulo, 1), Nr = Nr.times(pn), P = !0, Qn.minus(Nr));
      }, Ce.naturalExponential = Ce.exp = function() {
        return Dr(this);
      }, Ce.naturalLogarithm = Ce.ln = function() {
        return wr(this);
      }, Ce.negated = Ce.neg = function() {
        var pn = new this.constructor(this);
        return pn.s = -pn.s, nr(pn);
      }, Ce.plus = Ce.add = function(pn) {
        var Nr, Qn, zn, ti, v, d, I, n, a, E, T = this, L = T.constructor;
        if (pn = new L(pn), !T.d || !pn.d)
          return !T.s || !pn.s ? pn = new L(NaN) : T.d || (pn = new L(pn.d || T.s === pn.s ? T : NaN)), pn;
        if (T.s != pn.s)
          return pn.s = -pn.s, T.minus(pn);
        if (a = T.d, E = pn.d, I = L.precision, n = L.rounding, !a[0] || !E[0])
          return E[0] || (pn = new L(T)), P ? nr(pn, I, n) : pn;
        if (v = pe(T.e / Ee), zn = pe(pn.e / Ee), a = a.slice(), ti = v - zn, ti) {
          for (ti < 0 ? (Qn = a, ti = -ti, d = E.length) : (Qn = E, zn = v, d = a.length), v = Math.ceil(I / Ee), d = v > d ? v + 1 : d + 1, ti > d && (ti = d, Qn.length = 1), Qn.reverse(); ti--; ) Qn.push(0);
          Qn.reverse();
        }
        for (d = a.length, ti = E.length, d - ti < 0 && (ti = d, Qn = E, E = a, a = Qn), Nr = 0; ti; )
          Nr = (a[--ti] = a[ti] + E[ti] + Nr) / xe | 0, a[ti] %= xe;
        for (Nr && (a.unshift(Nr), ++zn), d = a.length; a[--d] == 0; ) a.pop();
        return pn.d = a, pn.e = lr(a, zn), P ? nr(pn, I, n) : pn;
      }, Ce.precision = Ce.sd = function(pn) {
        var Nr, Qn = this;
        if (pn !== void 0 && pn !== !!pn && pn !== 1 && pn !== 0) throw Error(M + pn);
        return Qn.d ? (Nr = Fr(Qn.d), pn && Qn.e + 1 > Nr && (Nr = Qn.e + 1)) : Nr = NaN, Nr;
      }, Ce.round = function() {
        var pn = this, Nr = pn.constructor;
        return nr(new Nr(pn), pn.e + 1, Nr.rounding);
      }, Ce.sine = Ce.sin = function() {
        var pn, Nr, Qn = this, zn = Qn.constructor;
        return Qn.isFinite() ? Qn.isZero() ? new zn(Qn) : (pn = zn.precision, Nr = zn.rounding, zn.precision = pn + Math.max(Qn.e, Qn.sd()) + Ee, zn.rounding = 1, Qn = Jr(zn, dn(zn, Qn)), zn.precision = pn, zn.rounding = Nr, nr(Q > 2 ? Qn.neg() : Qn, pn, Nr, !0)) : new zn(NaN);
      }, Ce.squareRoot = Ce.sqrt = function() {
        var pn, Nr, Qn, zn, ti, v, d = this, I = d.d, n = d.e, a = d.s, E = d.constructor;
        if (a !== 1 || !I || !I[0])
          return new E(!a || a < 0 && (!I || I[0]) ? NaN : I ? d : 1 / 0);
        for (P = !1, a = Math.sqrt(+d), a == 0 || a == 1 / 0 ? (Nr = Se(I), (Nr.length + n) % 2 == 0 && (Nr += "0"), a = Math.sqrt(Nr), n = pe((n + 1) / 2) - (n < 0 || n % 2), a == 1 / 0 ? Nr = "5e" + n : (Nr = a.toExponential(), Nr = Nr.slice(0, Nr.indexOf("e") + 1) + n), zn = new E(Nr)) : zn = new E(a.toString()), Qn = (n = E.precision) + 3; ; )
          if (v = zn, zn = v.plus(sr(d, v, Qn + 2, 1)).times(0.5), Se(v.d).slice(0, Qn) === (Nr = Se(zn.d)).slice(0, Qn))
            if (Nr = Nr.slice(Qn - 3, Qn + 1), Nr == "9999" || !ti && Nr == "4999") {
              if (!ti && (nr(v, n + 1, 0), v.times(v).eq(d))) {
                zn = v;
                break;
              }
              Qn += 4, ti = 1;
            } else {
              (!+Nr || !+Nr.slice(1) && Nr.charAt(0) == "5") && (nr(zn, n + 1, 1), pn = !zn.times(zn).eq(d));
              break;
            }
        return P = !0, nr(zn, n, E.rounding, pn);
      }, Ce.tangent = Ce.tan = function() {
        var pn, Nr, Qn = this, zn = Qn.constructor;
        return Qn.isFinite() ? Qn.isZero() ? new zn(Qn) : (pn = zn.precision, Nr = zn.rounding, zn.precision = pn + 10, zn.rounding = 1, Qn = Qn.sin(), Qn.s = 1, Qn = sr(Qn, new zn(1).minus(Qn.times(Qn)).sqrt(), pn + 10, 0), zn.precision = pn, zn.rounding = Nr, nr(Q == 2 || Q == 4 ? Qn.neg() : Qn, pn, Nr, !0)) : new zn(NaN);
      }, Ce.times = Ce.mul = function(pn) {
        var Nr, Qn, zn, ti, v, d, I, n, a, E = this, T = E.constructor, L = E.d, he = (pn = new T(pn)).d;
        if (pn.s *= E.s, !L || !L[0] || !he || !he[0])
          return new T(!pn.s || L && !L[0] && !he || he && !he[0] && !L ? NaN : !L || !he ? pn.s / 0 : pn.s * 0);
        for (Qn = pe(E.e / Ee) + pe(pn.e / Ee), n = L.length, a = he.length, n < a && (v = L, L = he, he = v, d = n, n = a, a = d), v = [], d = n + a, zn = d; zn--; ) v.push(0);
        for (zn = a; --zn >= 0; ) {
          for (Nr = 0, ti = n + zn; ti > zn; )
            I = v[ti] + he[zn] * L[ti - zn - 1] + Nr, v[ti--] = I % xe | 0, Nr = I / xe | 0;
          v[ti] = (v[ti] + Nr) % xe | 0;
        }
        for (; !v[--d]; ) v.pop();
        return Nr ? ++Qn : v.shift(), pn.d = v, pn.e = lr(v, Qn), P ? nr(pn, T.precision, T.rounding) : pn;
      }, Ce.toBinary = function(pn, Nr) {
        return Tn(this, 2, pn, Nr);
      }, Ce.toDecimalPlaces = Ce.toDP = function(pn, Nr) {
        var Qn = this, zn = Qn.constructor;
        return Qn = new zn(Qn), pn === void 0 ? Qn : (Ne(pn, 0, p), Nr === void 0 ? Nr = zn.rounding : Ne(Nr, 0, 8), nr(Qn, pn + Qn.e + 1, Nr));
      }, Ce.toExponential = function(pn, Nr) {
        var Qn, zn = this, ti = zn.constructor;
        return pn === void 0 ? Qn = fr(zn, !0) : (Ne(pn, 0, p), Nr === void 0 ? Nr = ti.rounding : Ne(Nr, 0, 8), zn = nr(new ti(zn), pn + 1, Nr), Qn = fr(zn, !0, pn + 1)), zn.isNeg() && !zn.isZero() ? "-" + Qn : Qn;
      }, Ce.toFixed = function(pn, Nr) {
        var Qn, zn, ti = this, v = ti.constructor;
        return pn === void 0 ? Qn = fr(ti) : (Ne(pn, 0, p), Nr === void 0 ? Nr = v.rounding : Ne(Nr, 0, 8), zn = nr(new v(ti), pn + ti.e + 1, Nr), Qn = fr(zn, !1, pn + zn.e + 1)), ti.isNeg() && !ti.isZero() ? "-" + Qn : Qn;
      }, Ce.toFraction = function(pn) {
        var Nr, Qn, zn, ti, v, d, I, n, a, E, T, L, he = this, Be = he.d, Me = he.constructor;
        if (!Be) return new Me(he);
        if (a = Qn = new Me(1), zn = n = new Me(0), Nr = new Me(zn), v = Nr.e = Fr(Be) - he.e - 1, d = v % Ee, Nr.d[0] = Ie(10, d < 0 ? Ee + d : d), pn == null)
          pn = v > 0 ? Nr : a;
        else {
          if (I = new Me(pn), !I.isInt() || I.lt(a)) throw Error(M + I);
          pn = I.gt(Nr) ? v > 0 ? Nr : a : I;
        }
        for (P = !1, I = new Me(Se(Be)), E = Me.precision, Me.precision = v = Be.length * Ee * 2; T = sr(I, Nr, 0, 1, 1), ti = Qn.plus(T.times(zn)), ti.cmp(pn) != 1; )
          Qn = zn, zn = ti, ti = a, a = n.plus(T.times(ti)), n = ti, ti = Nr, Nr = I.minus(T.times(ti)), I = ti;
        return ti = sr(pn.minus(Qn), zn, 0, 1, 1), n = n.plus(ti.times(a)), Qn = Qn.plus(ti.times(zn)), n.s = a.s = he.s, L = sr(a, zn, v, 1).minus(he).abs().cmp(sr(n, Qn, v, 1).minus(he).abs()) < 1 ? [a, zn] : [n, Qn], Me.precision = E, P = !0, L;
      }, Ce.toHexadecimal = Ce.toHex = function(pn, Nr) {
        return Tn(this, 16, pn, Nr);
      }, Ce.toNearest = function(pn, Nr) {
        var Qn = this, zn = Qn.constructor;
        if (Qn = new zn(Qn), pn == null) {
          if (!Qn.d) return Qn;
          pn = new zn(1), Nr = zn.rounding;
        } else {
          if (pn = new zn(pn), Nr === void 0 ? Nr = zn.rounding : Ne(Nr, 0, 8), !Qn.d) return pn.s ? Qn : pn;
          if (!pn.d)
            return pn.s && (pn.s = Qn.s), pn;
        }
        return pn.d[0] ? (P = !1, Qn = sr(Qn, pn, 0, Nr, 1).times(pn), P = !0, nr(Qn)) : (pn.s = Qn.s, Qn = pn), Qn;
      }, Ce.toNumber = function() {
        return +this;
      }, Ce.toOctal = function(pn, Nr) {
        return Tn(this, 8, pn, Nr);
      }, Ce.toPower = Ce.pow = function(pn) {
        var Nr, Qn, zn, ti, v, d, I = this, n = I.constructor, a = +(pn = new n(pn));
        if (!I.d || !pn.d || !I.d[0] || !pn.d[0]) return new n(Ie(+I, a));
        if (I = new n(I), I.eq(1)) return I;
        if (zn = n.precision, v = n.rounding, pn.eq(1)) return nr(I, zn, v);
        if (Nr = pe(pn.e / Ee), Nr >= pn.d.length - 1 && (Qn = a < 0 ? -a : a) <= He)
          return ti = qr(n, I, Qn, zn), pn.s < 0 ? new n(1).div(ti) : nr(ti, zn, v);
        if (d = I.s, d < 0) {
          if (Nr < pn.d.length - 1) return new n(NaN);
          if ((pn.d[Nr] & 1) == 0 && (d = 1), I.e == 0 && I.d[0] == 1 && I.d.length == 1)
            return I.s = d, I;
        }
        return Qn = Ie(+I, a), Nr = Qn == 0 || !isFinite(Qn) ? pe(a * (Math.log("0." + Se(I.d)) / Math.LN10 + I.e + 1)) : new n(Qn + "").e, Nr > n.maxE + 1 || Nr < n.minE - 1 ? new n(Nr > 0 ? d / 0 : 0) : (P = !1, n.rounding = I.s = 1, Qn = Math.min(12, (Nr + "").length), ti = Dr(pn.times(wr(I, zn + Qn)), zn), ti.d && (ti = nr(ti, zn + 5, 1), rr(ti.d, zn, v) && (Nr = zn + 10, ti = nr(Dr(pn.times(wr(I, Nr + Qn)), Nr), Nr + 5, 1), +Se(ti.d).slice(zn + 1, zn + 15) + 1 == 1e14 && (ti = nr(ti, zn + 1, 0)))), ti.s = d, P = !0, n.rounding = v, nr(ti, zn, v));
      }, Ce.toPrecision = function(pn, Nr) {
        var Qn, zn = this, ti = zn.constructor;
        return pn === void 0 ? Qn = fr(zn, zn.e <= ti.toExpNeg || zn.e >= ti.toExpPos) : (Ne(pn, 1, p), Nr === void 0 ? Nr = ti.rounding : Ne(Nr, 0, 8), zn = nr(new ti(zn), pn, Nr), Qn = fr(zn, pn <= zn.e || zn.e <= ti.toExpNeg, pn)), zn.isNeg() && !zn.isZero() ? "-" + Qn : Qn;
      }, Ce.toSignificantDigits = Ce.toSD = function(pn, Nr) {
        var Qn = this, zn = Qn.constructor;
        return pn === void 0 ? (pn = zn.precision, Nr = zn.rounding) : (Ne(pn, 1, p), Nr === void 0 ? Nr = zn.rounding : Ne(Nr, 0, 8)), nr(new zn(Qn), pn, Nr);
      }, Ce.toString = function() {
        var pn = this, Nr = pn.constructor, Qn = fr(pn, pn.e <= Nr.toExpNeg || pn.e >= Nr.toExpPos);
        return pn.isNeg() && !pn.isZero() ? "-" + Qn : Qn;
      }, Ce.truncated = Ce.trunc = function() {
        return nr(new this.constructor(this), this.e + 1, 1);
      }, Ce.valueOf = Ce.toJSON = function() {
        var pn = this, Nr = pn.constructor, Qn = fr(pn, pn.e <= Nr.toExpNeg || pn.e >= Nr.toExpPos);
        return pn.isNeg() ? "-" + Qn : Qn;
      };
      function Se(pn) {
        var Nr, Qn, zn, ti = pn.length - 1, v = "", d = pn[0];
        if (ti > 0) {
          for (v += d, Nr = 1; Nr < ti; Nr++)
            zn = pn[Nr] + "", Qn = Ee - zn.length, Qn && (v += Gr(Qn)), v += zn;
          d = pn[Nr], zn = d + "", Qn = Ee - zn.length, Qn && (v += Gr(Qn));
        } else if (d === 0)
          return "0";
        for (; d % 10 === 0; ) d /= 10;
        return v + d;
      }
      function Ne(pn, Nr, Qn) {
        if (pn !== ~~pn || pn < Nr || pn > Qn)
          throw Error(M + pn);
      }
      function rr(pn, Nr, Qn, zn) {
        var ti, v, d, I;
        for (v = pn[0]; v >= 10; v /= 10) --Nr;
        return --Nr < 0 ? (Nr += Ee, ti = 0) : (ti = Math.ceil((Nr + 1) / Ee), Nr %= Ee), v = Ie(10, Ee - Nr), I = pn[ti] % v | 0, zn == null ? Nr < 3 ? (Nr == 0 ? I = I / 100 | 0 : Nr == 1 && (I = I / 10 | 0), d = Qn < 4 && I == 99999 || Qn > 3 && I == 49999 || I == 5e4 || I == 0) : d = (Qn < 4 && I + 1 == v || Qn > 3 && I + 1 == v / 2) && (pn[ti + 1] / v / 100 | 0) == Ie(10, Nr - 2) - 1 || (I == v / 2 || I == 0) && (pn[ti + 1] / v / 100 | 0) == 0 : Nr < 4 ? (Nr == 0 ? I = I / 1e3 | 0 : Nr == 1 ? I = I / 100 | 0 : Nr == 2 && (I = I / 10 | 0), d = (zn || Qn < 4) && I == 9999 || !zn && Qn > 3 && I == 4999) : d = ((zn || Qn < 4) && I + 1 == v || !zn && Qn > 3 && I + 1 == v / 2) && (pn[ti + 1] / v / 1e3 | 0) == Ie(10, Nr - 3) - 1, d;
      }
      function er(pn, Nr, Qn) {
        for (var zn, ti = [0], v, d = 0, I = pn.length; d < I; ) {
          for (v = ti.length; v--; ) ti[v] *= Nr;
          for (ti[0] += t.indexOf(pn.charAt(d++)), zn = 0; zn < ti.length; zn++)
            ti[zn] > Qn - 1 && (ti[zn + 1] === void 0 && (ti[zn + 1] = 0), ti[zn + 1] += ti[zn] / Qn | 0, ti[zn] %= Qn);
        }
        return ti.reverse();
      }
      function ir(pn, Nr) {
        var Qn, zn, ti;
        if (Nr.isZero()) return Nr;
        zn = Nr.d.length, zn < 32 ? (Qn = Math.ceil(zn / 3), ti = (1 / jr(4, Qn)).toString()) : (Qn = 16, ti = "2.3283064365386962890625e-10"), pn.precision += Qn, Nr = fn(pn, 1, Nr.times(ti), new pn(1));
        for (var v = Qn; v--; ) {
          var d = Nr.times(Nr);
          Nr = d.times(d).minus(d).times(8).plus(1);
        }
        return pn.precision -= Qn, Nr;
      }
      var sr = /* @__PURE__ */ function() {
        function pn(zn, ti, v) {
          var d, I = 0, n = zn.length;
          for (zn = zn.slice(); n--; )
            d = zn[n] * ti + I, zn[n] = d % v | 0, I = d / v | 0;
          return I && zn.unshift(I), zn;
        }
        function Nr(zn, ti, v, d) {
          var I, n;
          if (v != d)
            n = v > d ? 1 : -1;
          else
            for (I = n = 0; I < v; I++)
              if (zn[I] != ti[I]) {
                n = zn[I] > ti[I] ? 1 : -1;
                break;
              }
          return n;
        }
        function Qn(zn, ti, v, d) {
          for (var I = 0; v--; )
            zn[v] -= I, I = zn[v] < ti[v] ? 1 : 0, zn[v] = I * d + zn[v] - ti[v];
          for (; !zn[0] && zn.length > 1; ) zn.shift();
        }
        return function(zn, ti, v, d, I, n) {
          var a, E, T, L, he, Be, Me, tr, or, cr, dr, gr, Ir, xr, Mr, Wr, $r, gn, Bn, kn, xn = zn.constructor, Un = zn.s == ti.s ? 1 : -1, Gn = zn.d, jn = ti.d;
          if (!Gn || !Gn[0] || !jn || !jn[0])
            return new xn(
              // Return NaN if either NaN, or both Infinity or 0.
              !zn.s || !ti.s || (Gn ? jn && Gn[0] == jn[0] : !jn) ? NaN : (
                // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
                Gn && Gn[0] == 0 || !jn ? Un * 0 : Un / 0
              )
            );
          for (n ? (he = 1, E = zn.e - ti.e) : (n = xe, he = Ee, E = pe(zn.e / he) - pe(ti.e / he)), Bn = jn.length, $r = Gn.length, or = new xn(Un), cr = or.d = [], T = 0; jn[T] == (Gn[T] || 0); T++) ;
          if (jn[T] > (Gn[T] || 0) && E--, v == null ? (xr = v = xn.precision, d = xn.rounding) : I ? xr = v + (zn.e - ti.e) + 1 : xr = v, xr < 0)
            cr.push(1), Be = !0;
          else {
            if (xr = xr / he + 2 | 0, T = 0, Bn == 1) {
              for (L = 0, jn = jn[0], xr++; (T < $r || L) && xr--; T++)
                Mr = L * n + (Gn[T] || 0), cr[T] = Mr / jn | 0, L = Mr % jn | 0;
              Be = L || T < $r;
            } else {
              for (L = n / (jn[0] + 1) | 0, L > 1 && (jn = pn(jn, L, n), Gn = pn(Gn, L, n), Bn = jn.length, $r = Gn.length), Wr = Bn, dr = Gn.slice(0, Bn), gr = dr.length; gr < Bn; ) dr[gr++] = 0;
              kn = jn.slice(), kn.unshift(0), gn = jn[0], jn[1] >= n / 2 && ++gn;
              do
                L = 0, a = Nr(jn, dr, Bn, gr), a < 0 ? (Ir = dr[0], Bn != gr && (Ir = Ir * n + (dr[1] || 0)), L = Ir / gn | 0, L > 1 ? (L >= n && (L = n - 1), Me = pn(jn, L, n), tr = Me.length, gr = dr.length, a = Nr(Me, dr, tr, gr), a == 1 && (L--, Qn(Me, Bn < tr ? kn : jn, tr, n))) : (L == 0 && (a = L = 1), Me = jn.slice()), tr = Me.length, tr < gr && Me.unshift(0), Qn(dr, Me, gr, n), a == -1 && (gr = dr.length, a = Nr(jn, dr, Bn, gr), a < 1 && (L++, Qn(dr, Bn < gr ? kn : jn, gr, n))), gr = dr.length) : a === 0 && (L++, dr = [0]), cr[T++] = L, a && dr[0] ? dr[gr++] = Gn[Wr] || 0 : (dr = [Gn[Wr]], gr = 1);
              while ((Wr++ < $r || dr[0] !== void 0) && xr--);
              Be = dr[0] !== void 0;
            }
            cr[0] || cr.shift();
          }
          if (he == 1)
            or.e = E, C = Be;
          else {
            for (T = 1, L = cr[0]; L >= 10; L /= 10) T++;
            or.e = T + E * he - 1, nr(or, I ? v + or.e + 1 : v, d, Be);
          }
          return or;
        };
      }();
      function nr(pn, Nr, Qn, zn) {
        var ti, v, d, I, n, a, E, T, L, he = pn.constructor;
        e: if (Nr != null) {
          if (T = pn.d, !T) return pn;
          for (ti = 1, I = T[0]; I >= 10; I /= 10) ti++;
          if (v = Nr - ti, v < 0)
            v += Ee, d = Nr, E = T[L = 0], n = E / Ie(10, ti - d - 1) % 10 | 0;
          else if (L = Math.ceil((v + 1) / Ee), I = T.length, L >= I)
            if (zn) {
              for (; I++ <= L; ) T.push(0);
              E = n = 0, ti = 1, v %= Ee, d = v - Ee + 1;
            } else
              break e;
          else {
            for (E = I = T[L], ti = 1; I >= 10; I /= 10) ti++;
            v %= Ee, d = v - Ee + ti, n = d < 0 ? 0 : E / Ie(10, ti - d - 1) % 10 | 0;
          }
          if (zn = zn || Nr < 0 || T[L + 1] !== void 0 || (d < 0 ? E : E % Ie(10, ti - d - 1)), a = Qn < 4 ? (n || zn) && (Qn == 0 || Qn == (pn.s < 0 ? 3 : 2)) : n > 5 || n == 5 && (Qn == 4 || zn || Qn == 6 && // Check whether the digit to the left of the rounding digit is odd.
          (v > 0 ? d > 0 ? E / Ie(10, ti - d) : 0 : T[L - 1]) % 10 & 1 || Qn == (pn.s < 0 ? 8 : 7)), Nr < 1 || !T[0])
            return T.length = 0, a ? (Nr -= pn.e + 1, T[0] = Ie(10, (Ee - Nr % Ee) % Ee), pn.e = -Nr || 0) : T[0] = pn.e = 0, pn;
          if (v == 0 ? (T.length = L, I = 1, L--) : (T.length = L + 1, I = Ie(10, Ee - v), T[L] = d > 0 ? (E / Ie(10, ti - d) % Ie(10, d) | 0) * I : 0), a)
            for (; ; )
              if (L == 0) {
                for (v = 1, d = T[0]; d >= 10; d /= 10) v++;
                for (d = T[0] += I, I = 1; d >= 10; d /= 10) I++;
                v != I && (pn.e++, T[0] == xe && (T[0] = 1));
                break;
              } else {
                if (T[L] += I, T[L] != xe) break;
                T[L--] = 0, I = 1;
              }
          for (v = T.length; T[--v] === 0; ) T.pop();
        }
        return P && (pn.e > he.maxE ? (pn.d = null, pn.e = NaN) : pn.e < he.minE && (pn.e = 0, pn.d = [0])), pn;
      }
      function fr(pn, Nr, Qn) {
        if (!pn.isFinite()) return yr(pn);
        var zn, ti = pn.e, v = Se(pn.d), d = v.length;
        return Nr ? (Qn && (zn = Qn - d) > 0 ? v = v.charAt(0) + "." + v.slice(1) + Gr(zn) : d > 1 && (v = v.charAt(0) + "." + v.slice(1)), v = v + (pn.e < 0 ? "e" : "e+") + pn.e) : ti < 0 ? (v = "0." + Gr(-ti - 1) + v, Qn && (zn = Qn - d) > 0 && (v += Gr(zn))) : ti >= d ? (v += Gr(ti + 1 - d), Qn && (zn = Qn - ti - 1) > 0 && (v = v + "." + Gr(zn))) : ((zn = ti + 1) < d && (v = v.slice(0, zn) + "." + v.slice(zn)), Qn && (zn = Qn - d) > 0 && (ti + 1 === d && (v += "."), v += Gr(zn))), v;
      }
      function lr(pn, Nr) {
        var Qn = pn[0];
        for (Nr *= Ee; Qn >= 10; Qn /= 10) Nr++;
        return Nr;
      }
      function br(pn, Nr, Qn) {
        if (Nr > ve)
          throw P = !0, Qn && (pn.precision = Qn), Error(F);
        return nr(new pn(l), Nr, 1, !0);
      }
      function Br(pn, Nr, Qn) {
        if (Nr > we) throw Error(F);
        return nr(new pn(m), Nr, Qn, !0);
      }
      function Fr(pn) {
        var Nr = pn.length - 1, Qn = Nr * Ee + 1;
        if (Nr = pn[Nr], Nr) {
          for (; Nr % 10 == 0; Nr /= 10) Qn--;
          for (Nr = pn[0]; Nr >= 10; Nr /= 10) Qn++;
        }
        return Qn;
      }
      function Gr(pn) {
        for (var Nr = ""; pn--; ) Nr += "0";
        return Nr;
      }
      function qr(pn, Nr, Qn, zn) {
        var ti, v = new pn(1), d = Math.ceil(zn / Ee + 4);
        for (P = !1; ; ) {
          if (Qn % 2 && (v = v.times(Nr), Yn(v.d, d) && (ti = !0)), Qn = pe(Qn / 2), Qn === 0) {
            Qn = v.d.length - 1, ti && v.d[Qn] === 0 && ++v.d[Qn];
            break;
          }
          Nr = Nr.times(Nr), Yn(Nr.d, d);
        }
        return P = !0, v;
      }
      function Hr(pn) {
        return pn.d[pn.d.length - 1] & 1;
      }
      function un(pn, Nr, Qn) {
        for (var zn, ti, v = new pn(Nr[0]), d = 0; ++d < Nr.length; ) {
          if (ti = new pn(Nr[d]), !ti.s) {
            v = ti;
            break;
          }
          zn = v.cmp(ti), (zn === Qn || zn === 0 && v.s === Qn) && (v = ti);
        }
        return v;
      }
      function Dr(pn, Nr) {
        var Qn, zn, ti, v, d, I, n, a = 0, E = 0, T = 0, L = pn.constructor, he = L.rounding, Be = L.precision;
        if (!pn.d || !pn.d[0] || pn.e > 17)
          return new L(pn.d ? pn.d[0] ? pn.s < 0 ? 0 : 1 / 0 : 1 : pn.s ? pn.s < 0 ? 0 : pn : NaN);
        for (Nr == null ? (P = !1, n = Be) : n = Nr, I = new L(0.03125); pn.e > -2; )
          pn = pn.times(I), T += 5;
        for (zn = Math.log(Ie(2, T)) / Math.LN10 * 2 + 5 | 0, n += zn, Qn = v = d = new L(1), L.precision = n; ; ) {
          if (v = nr(v.times(pn), n, 1), Qn = Qn.times(++E), I = d.plus(sr(v, Qn, n, 1)), Se(I.d).slice(0, n) === Se(d.d).slice(0, n)) {
            for (ti = T; ti--; ) d = nr(d.times(d), n, 1);
            if (Nr == null)
              if (a < 3 && rr(d.d, n - zn, he, a))
                L.precision = n += 10, Qn = v = I = new L(1), E = 0, a++;
              else
                return nr(d, L.precision = Be, he, P = !0);
            else
              return L.precision = Be, d;
          }
          d = I;
        }
      }
      function wr(pn, Nr) {
        var Qn, zn, ti, v, d, I, n, a, E, T, L, he = 1, Be = 10, Me = pn, tr = Me.d, or = Me.constructor, cr = or.rounding, dr = or.precision;
        if (Me.s < 0 || !tr || !tr[0] || !Me.e && tr[0] == 1 && tr.length == 1)
          return new or(tr && !tr[0] ? -1 / 0 : Me.s != 1 ? NaN : tr ? 0 : Me);
        if (Nr == null ? (P = !1, E = dr) : E = Nr, or.precision = E += Be, Qn = Se(tr), zn = Qn.charAt(0), Math.abs(v = Me.e) < 15e14) {
          for (; zn < 7 && zn != 1 || zn == 1 && Qn.charAt(1) > 3; )
            Me = Me.times(pn), Qn = Se(Me.d), zn = Qn.charAt(0), he++;
          v = Me.e, zn > 1 ? (Me = new or("0." + Qn), v++) : Me = new or(zn + "." + Qn.slice(1));
        } else
          return a = br(or, E + 2, dr).times(v + ""), Me = wr(new or(zn + "." + Qn.slice(1)), E - Be).plus(a), or.precision = dr, Nr == null ? nr(Me, dr, cr, P = !0) : Me;
        for (T = Me, n = d = Me = sr(Me.minus(1), Me.plus(1), E, 1), L = nr(Me.times(Me), E, 1), ti = 3; ; ) {
          if (d = nr(d.times(L), E, 1), a = n.plus(sr(d, new or(ti), E, 1)), Se(a.d).slice(0, E) === Se(n.d).slice(0, E))
            if (n = n.times(2), v !== 0 && (n = n.plus(br(or, E + 2, dr).times(v + ""))), n = sr(n, new or(he), E, 1), Nr == null)
              if (rr(n.d, E - Be, cr, I))
                or.precision = E += Be, a = d = Me = sr(T.minus(1), T.plus(1), E, 1), L = nr(Me.times(Me), E, 1), ti = I = 1;
              else
                return nr(n, or.precision = dr, cr, P = !0);
            else
              return or.precision = dr, n;
          n = a, ti += 2;
        }
      }
      function yr(pn) {
        return String(pn.s * pn.s / 0);
      }
      function Qr(pn, Nr) {
        var Qn, zn, ti;
        for ((Qn = Nr.indexOf(".")) > -1 && (Nr = Nr.replace(".", "")), (zn = Nr.search(/e/i)) > 0 ? (Qn < 0 && (Qn = zn), Qn += +Nr.slice(zn + 1), Nr = Nr.substring(0, zn)) : Qn < 0 && (Qn = Nr.length), zn = 0; Nr.charCodeAt(zn) === 48; zn++) ;
        for (ti = Nr.length; Nr.charCodeAt(ti - 1) === 48; --ti) ;
        if (Nr = Nr.slice(zn, ti), Nr) {
          if (ti -= zn, pn.e = Qn = Qn - zn - 1, pn.d = [], zn = (Qn + 1) % Ee, Qn < 0 && (zn += Ee), zn < ti) {
            for (zn && pn.d.push(+Nr.slice(0, zn)), ti -= Ee; zn < ti; ) pn.d.push(+Nr.slice(zn, zn += Ee));
            Nr = Nr.slice(zn), zn = Ee - Nr.length;
          } else
            zn -= ti;
          for (; zn--; ) Nr += "0";
          pn.d.push(+Nr), P && (pn.e > pn.constructor.maxE ? (pn.d = null, pn.e = NaN) : pn.e < pn.constructor.minE && (pn.e = 0, pn.d = [0]));
        } else
          pn.e = 0, pn.d = [0];
        return pn;
      }
      function _r(pn, Nr) {
        var Qn, zn, ti, v, d, I, n, a, E;
        if (Nr.indexOf("_") > -1) {
          if (Nr = Nr.replace(/(\d)_(?=\d)/g, "$1"), Qe.test(Nr)) return Qr(pn, Nr);
        } else if (Nr === "Infinity" || Nr === "NaN")
          return +Nr || (pn.s = NaN), pn.e = NaN, pn.d = null, pn;
        if (Pe.test(Nr))
          Qn = 16, Nr = Nr.toLowerCase();
        else if (be.test(Nr))
          Qn = 2;
        else if (Te.test(Nr))
          Qn = 8;
        else
          throw Error(M + Nr);
        for (v = Nr.search(/p/i), v > 0 ? (n = +Nr.slice(v + 1), Nr = Nr.substring(2, v)) : Nr = Nr.slice(2), v = Nr.indexOf("."), d = v >= 0, zn = pn.constructor, d && (Nr = Nr.replace(".", ""), I = Nr.length, v = I - v, ti = qr(zn, new zn(Qn), v, v * 2)), a = er(Nr, Qn, xe), E = a.length - 1, v = E; a[v] === 0; --v) a.pop();
        return v < 0 ? new zn(pn.s * 0) : (pn.e = lr(a, E), pn.d = a, P = !1, d && (pn = sr(pn, ti, I * 4)), n && (pn = pn.times(Math.abs(n) < 54 ? Ie(2, n) : k.pow(2, n))), P = !0, pn);
      }
      function Jr(pn, Nr) {
        var Qn, zn = Nr.d.length;
        if (zn < 3)
          return Nr.isZero() ? Nr : fn(pn, 2, Nr, Nr);
        Qn = 1.4 * Math.sqrt(zn), Qn = Qn > 16 ? 16 : Qn | 0, Nr = Nr.times(1 / jr(5, Qn)), Nr = fn(pn, 2, Nr, Nr);
        for (var ti, v = new pn(5), d = new pn(16), I = new pn(20); Qn--; )
          ti = Nr.times(Nr), Nr = Nr.times(v.plus(ti.times(d.times(ti).minus(I))));
        return Nr;
      }
      function fn(pn, Nr, Qn, zn, ti) {
        var v, d, I, n, a = pn.precision, E = Math.ceil(a / Ee);
        for (P = !1, n = Qn.times(Qn), I = new pn(zn); ; ) {
          if (d = sr(I.times(n), new pn(Nr++ * Nr++), a, 1), I = ti ? zn.plus(d) : zn.minus(d), zn = sr(d.times(n), new pn(Nr++ * Nr++), a, 1), d = I.plus(zn), d.d[E] !== void 0) {
            for (v = E; d.d[v] === I.d[v] && v--; ) ;
            if (v == -1) break;
          }
          v = I, I = zn, zn = d, d = v;
        }
        return P = !0, d.d.length = E + 1, d;
      }
      function jr(pn, Nr) {
        for (var Qn = pn; --Nr; ) Qn *= pn;
        return Qn;
      }
      function dn(pn, Nr) {
        var Qn, zn = Nr.s < 0, ti = Br(pn, pn.precision, 1), v = ti.times(0.5);
        if (Nr = Nr.abs(), Nr.lte(v))
          return Q = zn ? 4 : 1, Nr;
        if (Qn = Nr.divToInt(ti), Qn.isZero())
          Q = zn ? 3 : 2;
        else {
          if (Nr = Nr.minus(Qn.times(ti)), Nr.lte(v))
            return Q = Hr(Qn) ? zn ? 2 : 3 : zn ? 4 : 1, Nr;
          Q = Hr(Qn) ? zn ? 1 : 4 : zn ? 3 : 2;
        }
        return Nr.minus(ti).abs();
      }
      function Tn(pn, Nr, Qn, zn) {
        var ti, v, d, I, n, a, E, T, L, he = pn.constructor, Be = Qn !== void 0;
        if (Be ? (Ne(Qn, 1, p), zn === void 0 ? zn = he.rounding : Ne(zn, 0, 8)) : (Qn = he.precision, zn = he.rounding), !pn.isFinite())
          E = yr(pn);
        else {
          for (E = fr(pn), d = E.indexOf("."), Be ? (ti = 2, Nr == 16 ? Qn = Qn * 4 - 3 : Nr == 8 && (Qn = Qn * 3 - 2)) : ti = Nr, d >= 0 && (E = E.replace(".", ""), L = new he(1), L.e = E.length - d, L.d = er(fr(L), 10, ti), L.e = L.d.length), T = er(E, 10, ti), v = n = T.length; T[--n] == 0; ) T.pop();
          if (!T[0])
            E = Be ? "0p+0" : "0";
          else {
            if (d < 0 ? v-- : (pn = new he(pn), pn.d = T, pn.e = v, pn = sr(pn, L, Qn, zn, 0, ti), T = pn.d, v = pn.e, a = C), d = T[Qn], I = ti / 2, a = a || T[Qn + 1] !== void 0, a = zn < 4 ? (d !== void 0 || a) && (zn === 0 || zn === (pn.s < 0 ? 3 : 2)) : d > I || d === I && (zn === 4 || a || zn === 6 && T[Qn - 1] & 1 || zn === (pn.s < 0 ? 8 : 7)), T.length = Qn, a)
              for (; ++T[--Qn] > ti - 1; )
                T[Qn] = 0, Qn || (++v, T.unshift(1));
            for (n = T.length; !T[n - 1]; --n) ;
            for (d = 0, E = ""; d < n; d++) E += t.charAt(T[d]);
            if (Be) {
              if (n > 1)
                if (Nr == 16 || Nr == 8) {
                  for (d = Nr == 16 ? 4 : 3, --n; n % d; n++) E += "0";
                  for (T = er(E, ti, Nr), n = T.length; !T[n - 1]; --n) ;
                  for (d = 1, E = "1."; d < n; d++) E += t.charAt(T[d]);
                } else
                  E = E.charAt(0) + "." + E.slice(1);
              E = E + (v < 0 ? "p" : "p+") + v;
            } else if (v < 0) {
              for (; ++v; ) E = "0" + E;
              E = "0." + E;
            } else if (++v > n) for (v -= n; v--; ) E += "0";
            else v < n && (E = E.slice(0, v) + "." + E.slice(v));
          }
          E = (Nr == 16 ? "0x" : Nr == 2 ? "0b" : Nr == 8 ? "0o" : "") + E;
        }
        return pn.s < 0 ? "-" + E : E;
      }
      function Yn(pn, Nr) {
        if (pn.length > Nr)
          return pn.length = Nr, !0;
      }
      function si(pn) {
        return new this(pn).abs();
      }
      function vn(pn) {
        return new this(pn).acos();
      }
      function Cn(pn) {
        return new this(pn).acosh();
      }
      function Xr(pn, Nr) {
        return new this(pn).plus(Nr);
      }
      function In(pn) {
        return new this(pn).asin();
      }
      function zr(pn) {
        return new this(pn).asinh();
      }
      function En(pn) {
        return new this(pn).atan();
      }
      function Zr(pn) {
        return new this(pn).atanh();
      }
      function kr(pn, Nr) {
        pn = new this(pn), Nr = new this(Nr);
        var Qn, zn = this.precision, ti = this.rounding, v = zn + 4;
        return !pn.s || !Nr.s ? Qn = new this(NaN) : !pn.d && !Nr.d ? (Qn = Br(this, v, 1).times(Nr.s > 0 ? 0.25 : 0.75), Qn.s = pn.s) : !Nr.d || pn.isZero() ? (Qn = Nr.s < 0 ? Br(this, zn, ti) : new this(0), Qn.s = pn.s) : !pn.d || Nr.isZero() ? (Qn = Br(this, v, 1).times(0.5), Qn.s = pn.s) : Nr.s < 0 ? (this.precision = v, this.rounding = 1, Qn = this.atan(sr(pn, Nr, v, 1)), Nr = Br(this, v, 1), this.precision = zn, this.rounding = ti, Qn = pn.s < 0 ? Qn.minus(Nr) : Qn.plus(Nr)) : Qn = this.atan(sr(pn, Nr, v, 1)), Qn;
      }
      function Rr(pn) {
        return new this(pn).cbrt();
      }
      function Er(pn) {
        return nr(pn = new this(pn), pn.e + 1, 2);
      }
      function Or(pn, Nr, Qn) {
        return new this(pn).clamp(Nr, Qn);
      }
      function wn(pn) {
        if (!pn || typeof pn != "object") throw Error(x + "Object expected");
        var Nr, Qn, zn, ti = pn.defaults === !0, v = [
          "precision",
          1,
          p,
          "rounding",
          0,
          8,
          "toExpNeg",
          -u,
          0,
          "toExpPos",
          0,
          u,
          "maxE",
          0,
          u,
          "minE",
          -u,
          0,
          "modulo",
          0,
          9
        ];
        for (Nr = 0; Nr < v.length; Nr += 3)
          if (Qn = v[Nr], ti && (this[Qn] = b[Qn]), (zn = pn[Qn]) !== void 0)
            if (pe(zn) === zn && zn >= v[Nr + 1] && zn <= v[Nr + 2]) this[Qn] = zn;
            else throw Error(M + Qn + ": " + zn);
        if (Qn = "crypto", ti && (this[Qn] = b[Qn]), (zn = pn[Qn]) !== void 0)
          if (zn === !0 || zn === !1 || zn === 0 || zn === 1)
            if (zn)
              if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                this[Qn] = !0;
              else
                throw Error(le);
            else
              this[Qn] = !1;
          else
            throw Error(M + Qn + ": " + zn);
        return this;
      }
      function Kn(pn) {
        return new this(pn).cos();
      }
      function Ln(pn) {
        return new this(pn).cosh();
      }
      function Wn(pn) {
        var Nr, Qn, zn;
        function ti(v) {
          var d, I, n, a = this;
          if (!(a instanceof ti)) return new ti(v);
          if (a.constructor = ti, _i(v)) {
            a.s = v.s, P ? !v.d || v.e > ti.maxE ? (a.e = NaN, a.d = null) : v.e < ti.minE ? (a.e = 0, a.d = [0]) : (a.e = v.e, a.d = v.d.slice()) : (a.e = v.e, a.d = v.d ? v.d.slice() : v.d);
            return;
          }
          if (n = typeof v, n === "number") {
            if (v === 0) {
              a.s = 1 / v < 0 ? -1 : 1, a.e = 0, a.d = [0];
              return;
            }
            if (v < 0 ? (v = -v, a.s = -1) : a.s = 1, v === ~~v && v < 1e7) {
              for (d = 0, I = v; I >= 10; I /= 10) d++;
              P ? d > ti.maxE ? (a.e = NaN, a.d = null) : d < ti.minE ? (a.e = 0, a.d = [0]) : (a.e = d, a.d = [v]) : (a.e = d, a.d = [v]);
              return;
            }
            if (v * 0 !== 0) {
              v || (a.s = NaN), a.e = NaN, a.d = null;
              return;
            }
            return Qr(a, v.toString());
          }
          if (n === "string")
            return (I = v.charCodeAt(0)) === 45 ? (v = v.slice(1), a.s = -1) : (I === 43 && (v = v.slice(1)), a.s = 1), Qe.test(v) ? Qr(a, v) : _r(a, v);
          if (n === "bigint")
            return v < 0 ? (v = -v, a.s = -1) : a.s = 1, Qr(a, v.toString());
          throw Error(M + v);
        }
        if (ti.prototype = Ce, ti.ROUND_UP = 0, ti.ROUND_DOWN = 1, ti.ROUND_CEIL = 2, ti.ROUND_FLOOR = 3, ti.ROUND_HALF_UP = 4, ti.ROUND_HALF_DOWN = 5, ti.ROUND_HALF_EVEN = 6, ti.ROUND_HALF_CEIL = 7, ti.ROUND_HALF_FLOOR = 8, ti.EUCLID = 9, ti.config = ti.set = wn, ti.clone = Wn, ti.isDecimal = _i, ti.abs = si, ti.acos = vn, ti.acosh = Cn, ti.add = Xr, ti.asin = In, ti.asinh = zr, ti.atan = En, ti.atanh = Zr, ti.atan2 = kr, ti.cbrt = Rr, ti.ceil = Er, ti.clamp = Or, ti.cos = Kn, ti.cosh = Ln, ti.div = Sn, ti.exp = hi, ti.floor = ki, ti.hypot = xi, ti.ln = Li, ti.log = ms, ti.log10 = Mi, ti.log2 = Ui, ti.max = Ls, ti.min = Ds, ti.mod = Pr, ti.mul = vr, ti.pow = Cr, ti.random = yn, ti.round = Pn, ti.sign = $n, ti.sin = ui, ti.sinh = Ei, ti.sqrt = zi, ti.sub = Gi, ti.sum = Vi, ti.tan = Ur, ti.tanh = $i, ti.trunc = Es, pn === void 0 && (pn = {}), pn && pn.defaults !== !0)
          for (zn = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], Nr = 0; Nr < zn.length; ) pn.hasOwnProperty(Qn = zn[Nr++]) || (pn[Qn] = this[Qn]);
        return ti.config(pn), ti;
      }
      function Sn(pn, Nr) {
        return new this(pn).div(Nr);
      }
      function hi(pn) {
        return new this(pn).exp();
      }
      function ki(pn) {
        return nr(pn = new this(pn), pn.e + 1, 3);
      }
      function xi() {
        var pn, Nr, Qn = new this(0);
        for (P = !1, pn = 0; pn < arguments.length; )
          if (Nr = new this(arguments[pn++]), Nr.d)
            Qn.d && (Qn = Qn.plus(Nr.times(Nr)));
          else {
            if (Nr.s)
              return P = !0, new this(1 / 0);
            Qn = Nr;
          }
        return P = !0, Qn.sqrt();
      }
      function _i(pn) {
        return pn instanceof k || pn && pn.toStringTag === ge || !1;
      }
      function Li(pn) {
        return new this(pn).ln();
      }
      function ms(pn, Nr) {
        return new this(pn).log(Nr);
      }
      function Ui(pn) {
        return new this(pn).log(2);
      }
      function Mi(pn) {
        return new this(pn).log(10);
      }
      function Ls() {
        return un(this, arguments, -1);
      }
      function Ds() {
        return un(this, arguments, 1);
      }
      function Pr(pn, Nr) {
        return new this(pn).mod(Nr);
      }
      function vr(pn, Nr) {
        return new this(pn).mul(Nr);
      }
      function Cr(pn, Nr) {
        return new this(pn).pow(Nr);
      }
      function yn(pn) {
        var Nr, Qn, zn, ti, v = 0, d = new this(1), I = [];
        if (pn === void 0 ? pn = this.precision : Ne(pn, 1, p), zn = Math.ceil(pn / Ee), this.crypto)
          if (crypto.getRandomValues)
            for (Nr = crypto.getRandomValues(new Uint32Array(zn)); v < zn; )
              ti = Nr[v], ti >= 429e7 ? Nr[v] = crypto.getRandomValues(new Uint32Array(1))[0] : I[v++] = ti % 1e7;
          else if (crypto.randomBytes) {
            for (Nr = crypto.randomBytes(zn *= 4); v < zn; )
              ti = Nr[v] + (Nr[v + 1] << 8) + (Nr[v + 2] << 16) + ((Nr[v + 3] & 127) << 24), ti >= 214e7 ? crypto.randomBytes(4).copy(Nr, v) : (I.push(ti % 1e7), v += 4);
            v = zn / 4;
          } else
            throw Error(le);
        else for (; v < zn; ) I[v++] = Math.random() * 1e7 | 0;
        for (zn = I[--v], pn %= Ee, zn && pn && (ti = Ie(10, Ee - pn), I[v] = (zn / ti | 0) * ti); I[v] === 0; v--) I.pop();
        if (v < 0)
          Qn = 0, I = [0];
        else {
          for (Qn = -1; I[0] === 0; Qn -= Ee) I.shift();
          for (zn = 1, ti = I[0]; ti >= 10; ti /= 10) zn++;
          zn < Ee && (Qn -= Ee - zn);
        }
        return d.e = Qn, d.d = I, d;
      }
      function Pn(pn) {
        return nr(pn = new this(pn), pn.e + 1, this.rounding);
      }
      function $n(pn) {
        return pn = new this(pn), pn.d ? pn.d[0] ? pn.s : 0 * pn.s : pn.s || NaN;
      }
      function ui(pn) {
        return new this(pn).sin();
      }
      function Ei(pn) {
        return new this(pn).sinh();
      }
      function zi(pn) {
        return new this(pn).sqrt();
      }
      function Gi(pn, Nr) {
        return new this(pn).sub(Nr);
      }
      function Vi() {
        var pn = 0, Nr = arguments, Qn = new this(Nr[pn]);
        for (P = !1; Qn.s && ++pn < Nr.length; ) Qn = Qn.plus(Nr[pn]);
        return P = !0, nr(Qn, this.precision, this.rounding);
      }
      function Ur(pn) {
        return new this(pn).tan();
      }
      function $i(pn) {
        return new this(pn).tanh();
      }
      function Es(pn) {
        return nr(pn = new this(pn), pn.e + 1, 1);
      }
      k = Wn(b), k.prototype.constructor = k, k.default = k.Decimal = k, l = new k(l), m = new k(m), s.exports ? (typeof Symbol == "function" && typeof Symbol.iterator == "symbol" && (Ce[Symbol.for("nodejs.util.inspect.custom")] = Ce.toString, Ce[Symbol.toStringTag] = "Decimal"), s.exports = k) : (A || (A = typeof self < "u" && self && self.self == self ? self : window), B = A.Decimal, k.noConflict = function() {
        return A.Decimal = B, k;
      }, A.Decimal = k);
    })(decimal$2);
  }(decimal$3)), decimal$3.exports;
}
var binaryParser = {}, hasRequiredBinaryParser;
function requireBinaryParser() {
  if (hasRequiredBinaryParser) return binaryParser;
  hasRequiredBinaryParser = 1;
  var s = binaryParser && binaryParser.__createBinding || (Object.create ? function(b, k, C, B) {
    B === void 0 && (B = C);
    var Q = Object.getOwnPropertyDescriptor(k, C);
    (!Q || ("get" in Q ? !k.__esModule : Q.writable || Q.configurable)) && (Q = { enumerable: !0, get: function() {
      return k[C];
    } }), Object.defineProperty(b, B, Q);
  } : function(b, k, C, B) {
    B === void 0 && (B = C), b[B] = k[C];
  }), A = binaryParser && binaryParser.__setModuleDefault || (Object.create ? function(b, k) {
    Object.defineProperty(b, "default", { enumerable: !0, value: k });
  } : function(b, k) {
    b.default = k;
  }), u = binaryParser && binaryParser.__importStar || function(b) {
    if (b && b.__esModule) return b;
    var k = {};
    if (b != null) for (var C in b) C !== "default" && Object.prototype.hasOwnProperty.call(b, C) && s(k, b, C);
    return A(k, b), k;
  };
  Object.defineProperty(binaryParser, "__esModule", { value: !0 }), binaryParser.BinaryParser = void 0;
  const p = u(requireAssert$2()), t = requireEnums(), l = requireDist$n();
  class m {
    /**
     * Initialize bytes to a hex string
     *
     * @param hexBytes a hex string
     * @param definitions Rippled definitions used to parse the values of transaction types and such.
     *                          Can be customized for sidechains and amendments.
     */
    constructor(k, C = t.DEFAULT_DEFINITIONS) {
      this.bytes = l.Buffer.from(k, "hex"), this.definitions = C;
    }
    /**
     * Peek the first byte of the BinaryParser
     *
     * @returns The first byte of the BinaryParser
     */
    peek() {
      return p.ok(this.bytes.byteLength !== 0), this.bytes[0];
    }
    /**
     * Consume the first n bytes of the BinaryParser
     *
     * @param n the number of bytes to skip
     */
    skip(k) {
      p.ok(k <= this.bytes.byteLength), this.bytes = this.bytes.slice(k);
    }
    /**
     * read the first n bytes from the BinaryParser
     *
     * @param n The number of bytes to read
     * @return The bytes
     */
    read(k) {
      p.ok(k <= this.bytes.byteLength);
      const C = this.bytes.slice(0, k);
      return this.skip(k), C;
    }
    /**
     * Read an integer of given size
     *
     * @param n The number of bytes to read
     * @return The number represented by those bytes
     */
    readUIntN(k) {
      return p.ok(0 < k && k <= 4, "invalid n"), this.read(k).reduce((C, B) => C << 8 | B) >>> 0;
    }
    readUInt8() {
      return this.readUIntN(1);
    }
    readUInt16() {
      return this.readUIntN(2);
    }
    readUInt32() {
      return this.readUIntN(4);
    }
    size() {
      return this.bytes.byteLength;
    }
    end(k) {
      const C = this.bytes.byteLength;
      return C === 0 || k !== void 0 && C <= k;
    }
    /**
     * Reads variable length encoded bytes
     *
     * @return The variable length bytes
     */
    readVariableLength() {
      return this.read(this.readVariableLengthLength());
    }
    /**
     * Reads the length of the variable length encoded bytes
     *
     * @return The length of the variable length encoded bytes
     */
    readVariableLengthLength() {
      const k = this.readUInt8();
      if (k <= 192)
        return k;
      if (k <= 240) {
        const C = this.readUInt8();
        return 193 + (k - 193) * 256 + C;
      } else if (k <= 254) {
        const C = this.readUInt8(), B = this.readUInt8();
        return 12481 + (k - 241) * 65536 + C * 256 + B;
      }
      throw new Error("Invalid variable length indicator");
    }
    /**
     * Reads the field ordinal from the BinaryParser
     *
     * @return Field ordinal
     */
    readFieldOrdinal() {
      let k = this.readUInt8(), C = k & 15;
      if (k >>= 4, k === 0 && (k = this.readUInt8(), k === 0 || k < 16))
        throw new Error("Cannot read FieldOrdinal, type_code out of range");
      if (C === 0 && (C = this.readUInt8(), C === 0 || C < 16))
        throw new Error("Cannot read FieldOrdinal, field_code out of range");
      return k << 16 | C;
    }
    /**
     * Read the field from the BinaryParser
     *
     * @return The field represented by the bytes at the head of the BinaryParser
     */
    readField() {
      return this.definitions.field.fromString(this.readFieldOrdinal().toString());
    }
    /**
     * Read a given type from the BinaryParser
     *
     * @param type The type that you want to read from the BinaryParser
     * @return The instance of that type read from the BinaryParser
     */
    readType(k) {
      return k.fromParser(this);
    }
    /**
     * Get the type associated with a given field
     *
     * @param field The field that you wan to get the type of
     * @return The type associated with the given field
     */
    typeForField(k) {
      return k.associatedType;
    }
    /**
     * Read value of the type specified by field from the BinaryParser
     *
     * @param field The field that you want to get the associated value for
     * @return The value associated with the given field
     */
    readFieldValue(k) {
      const C = this.typeForField(k);
      if (!C)
        throw new Error(`unsupported: (${k.name}, ${k.type.name})`);
      const B = k.isVariableLengthEncoded ? this.readVariableLengthLength() : void 0, Q = C.fromParser(this, B);
      if (Q === void 0)
        throw new Error(`fromParser for (${k.name}, ${k.type.name}) -> undefined `);
      return Q;
    }
    /**
     * Get the next field and value from the BinaryParser
     *
     * @return The field and value
     */
    readFieldAndValue() {
      const k = this.readField();
      return [k, this.readFieldValue(k)];
    }
  }
  return binaryParser.BinaryParser = m, binaryParser;
}
var currency$1 = {}, hasRequiredCurrency$1;
function requireCurrency$1() {
  if (hasRequiredCurrency$1) return currency$1;
  hasRequiredCurrency$1 = 1, Object.defineProperty(currency$1, "__esModule", { value: !0 }), currency$1.Currency = void 0;
  const s = requireHash160(), A = requireDist$n(), u = /^0{40}$/, p = /^[A-Z0-9a-z?!@#$%^&*(){}[\]|]{3}$/, t = /^[A-F0-9]{40}$/, l = /^0{24}[\x00-\x7F]{6}0{10}$/;
  function m(F) {
    const le = A.Buffer.alloc(20);
    if (F !== "XRP") {
      const ge = F.split("").map((pe) => pe.charCodeAt(0));
      le.set(ge, 12);
    }
    return le;
  }
  function b(F) {
    return p.test(F);
  }
  function k(F) {
    const le = F.toString();
    return le === "XRP" ? null : b(le) ? le : null;
  }
  function C(F) {
    return t.test(F);
  }
  function B(F) {
    return F.length === 3 || C(F);
  }
  function Q(F) {
    return F.byteLength === 20;
  }
  function P(F) {
    return F instanceof A.Buffer ? Q(F) : B(F);
  }
  function x(F) {
    if (!P(F))
      throw new Error(`Unsupported Currency representation: ${F}`);
    return F.length === 3 ? m(F) : A.Buffer.from(F, "hex");
  }
  class M extends s.Hash160 {
    constructor(le) {
      super(le ?? M.XRP.bytes);
      const ge = this.bytes.toString("hex");
      u.test(ge) ? this._iso = "XRP" : l.test(ge) ? this._iso = k(this.bytes.slice(12, 15)) : this._iso = null;
    }
    /**
     * Return the ISO code of this currency
     *
     * @returns ISO code if it exists, else null
     */
    iso() {
      return this._iso;
    }
    /**
     * Constructs a Currency object
     *
     * @param val Currency object or a string representation of a currency
     */
    static from(le) {
      if (le instanceof M)
        return le;
      if (typeof le == "string")
        return new M(x(le));
      throw new Error("Cannot construct Currency from value given");
    }
    /**
     * Gets the JSON representation of a currency
     *
     * @returns JSON representation
     */
    toJSON() {
      const le = this.iso();
      return le !== null ? le : this.bytes.toString("hex").toUpperCase();
    }
  }
  return currency$1.Currency = M, M.XRP = new M(A.Buffer.alloc(20)), currency$1;
}
var BigInteger = { exports: {} }, hasRequiredBigInteger;
function requireBigInteger() {
  return hasRequiredBigInteger || (hasRequiredBigInteger = 1, function(s) {
    var A = function(u) {
      var p = 1e7, t = 7, l = 9007199254740992, m = M(l), b = "0123456789abcdefghijklmnopqrstuvwxyz", k = typeof BigInt == "function";
      function C(zr, En, Zr, kr) {
        return typeof zr > "u" ? C[0] : typeof En < "u" ? +En == 10 && !Zr ? Xr(zr) : jr(zr, En, Zr, kr) : Xr(zr);
      }
      function B(zr, En) {
        this.value = zr, this.sign = En, this.isSmall = !1;
      }
      B.prototype = Object.create(C.prototype);
      function Q(zr) {
        this.value = zr, this.sign = zr < 0, this.isSmall = !0;
      }
      Q.prototype = Object.create(C.prototype);
      function P(zr) {
        this.value = zr;
      }
      P.prototype = Object.create(C.prototype);
      function x(zr) {
        return -l < zr && zr < l;
      }
      function M(zr) {
        return zr < 1e7 ? [zr] : zr < 1e14 ? [zr % 1e7, Math.floor(zr / 1e7)] : [zr % 1e7, Math.floor(zr / 1e7) % 1e7, Math.floor(zr / 1e14)];
      }
      function F(zr) {
        le(zr);
        var En = zr.length;
        if (En < 4 && nr(zr, m) < 0)
          switch (En) {
            case 0:
              return 0;
            case 1:
              return zr[0];
            case 2:
              return zr[0] + zr[1] * p;
            default:
              return zr[0] + (zr[1] + zr[2] * p) * p;
          }
        return zr;
      }
      function le(zr) {
        for (var En = zr.length; zr[--En] === 0; ) ;
        zr.length = En + 1;
      }
      function ge(zr) {
        for (var En = new Array(zr), Zr = -1; ++Zr < zr; )
          En[Zr] = 0;
        return En;
      }
      function pe(zr) {
        return zr > 0 ? Math.floor(zr) : Math.ceil(zr);
      }
      function Ie(zr, En) {
        var Zr = zr.length, kr = En.length, Rr = new Array(Zr), Er = 0, Or = p, wn, Kn;
        for (Kn = 0; Kn < kr; Kn++)
          wn = zr[Kn] + En[Kn] + Er, Er = wn >= Or ? 1 : 0, Rr[Kn] = wn - Er * Or;
        for (; Kn < Zr; )
          wn = zr[Kn] + Er, Er = wn === Or ? 1 : 0, Rr[Kn++] = wn - Er * Or;
        return Er > 0 && Rr.push(Er), Rr;
      }
      function be(zr, En) {
        return zr.length >= En.length ? Ie(zr, En) : Ie(En, zr);
      }
      function Pe(zr, En) {
        var Zr = zr.length, kr = new Array(Zr), Rr = p, Er, Or;
        for (Or = 0; Or < Zr; Or++)
          Er = zr[Or] - Rr + En, En = Math.floor(Er / Rr), kr[Or] = Er - En * Rr, En += 1;
        for (; En > 0; )
          kr[Or++] = En % Rr, En = Math.floor(En / Rr);
        return kr;
      }
      B.prototype.add = function(zr) {
        var En = Xr(zr);
        if (this.sign !== En.sign)
          return this.subtract(En.negate());
        var Zr = this.value, kr = En.value;
        return En.isSmall ? new B(Pe(Zr, Math.abs(kr)), this.sign) : new B(be(Zr, kr), this.sign);
      }, B.prototype.plus = B.prototype.add, Q.prototype.add = function(zr) {
        var En = Xr(zr), Zr = this.value;
        if (Zr < 0 !== En.sign)
          return this.subtract(En.negate());
        var kr = En.value;
        if (En.isSmall) {
          if (x(Zr + kr)) return new Q(Zr + kr);
          kr = M(Math.abs(kr));
        }
        return new B(Pe(kr, Math.abs(Zr)), Zr < 0);
      }, Q.prototype.plus = Q.prototype.add, P.prototype.add = function(zr) {
        return new P(this.value + Xr(zr).value);
      }, P.prototype.plus = P.prototype.add;
      function Te(zr, En) {
        var Zr = zr.length, kr = En.length, Rr = new Array(Zr), Er = 0, Or = p, wn, Kn;
        for (wn = 0; wn < kr; wn++)
          Kn = zr[wn] - Er - En[wn], Kn < 0 ? (Kn += Or, Er = 1) : Er = 0, Rr[wn] = Kn;
        for (wn = kr; wn < Zr; wn++) {
          if (Kn = zr[wn] - Er, Kn < 0) Kn += Or;
          else {
            Rr[wn++] = Kn;
            break;
          }
          Rr[wn] = Kn;
        }
        for (; wn < Zr; wn++)
          Rr[wn] = zr[wn];
        return le(Rr), Rr;
      }
      function Qe(zr, En, Zr) {
        var kr;
        return nr(zr, En) >= 0 ? kr = Te(zr, En) : (kr = Te(En, zr), Zr = !Zr), kr = F(kr), typeof kr == "number" ? (Zr && (kr = -kr), new Q(kr)) : new B(kr, Zr);
      }
      function xe(zr, En, Zr) {
        var kr = zr.length, Rr = new Array(kr), Er = -En, Or = p, wn, Kn;
        for (wn = 0; wn < kr; wn++)
          Kn = zr[wn] + Er, Er = Math.floor(Kn / Or), Kn %= Or, Rr[wn] = Kn < 0 ? Kn + Or : Kn;
        return Rr = F(Rr), typeof Rr == "number" ? (Zr && (Rr = -Rr), new Q(Rr)) : new B(Rr, Zr);
      }
      B.prototype.subtract = function(zr) {
        var En = Xr(zr);
        if (this.sign !== En.sign)
          return this.add(En.negate());
        var Zr = this.value, kr = En.value;
        return En.isSmall ? xe(Zr, Math.abs(kr), this.sign) : Qe(Zr, kr, this.sign);
      }, B.prototype.minus = B.prototype.subtract, Q.prototype.subtract = function(zr) {
        var En = Xr(zr), Zr = this.value;
        if (Zr < 0 !== En.sign)
          return this.add(En.negate());
        var kr = En.value;
        return En.isSmall ? new Q(Zr - kr) : xe(kr, Math.abs(Zr), Zr >= 0);
      }, Q.prototype.minus = Q.prototype.subtract, P.prototype.subtract = function(zr) {
        return new P(this.value - Xr(zr).value);
      }, P.prototype.minus = P.prototype.subtract, B.prototype.negate = function() {
        return new B(this.value, !this.sign);
      }, Q.prototype.negate = function() {
        var zr = this.sign, En = new Q(-this.value);
        return En.sign = !zr, En;
      }, P.prototype.negate = function() {
        return new P(-this.value);
      }, B.prototype.abs = function() {
        return new B(this.value, !1);
      }, Q.prototype.abs = function() {
        return new Q(Math.abs(this.value));
      }, P.prototype.abs = function() {
        return new P(this.value >= 0 ? this.value : -this.value);
      };
      function Ee(zr, En) {
        var Zr = zr.length, kr = En.length, Rr = Zr + kr, Er = ge(Rr), Or = p, wn, Kn, Ln, Wn, Sn;
        for (Ln = 0; Ln < Zr; ++Ln) {
          Wn = zr[Ln];
          for (var hi = 0; hi < kr; ++hi)
            Sn = En[hi], wn = Wn * Sn + Er[Ln + hi], Kn = Math.floor(wn / Or), Er[Ln + hi] = wn - Kn * Or, Er[Ln + hi + 1] += Kn;
        }
        return le(Er), Er;
      }
      function He(zr, En) {
        var Zr = zr.length, kr = new Array(Zr), Rr = p, Er = 0, Or, wn;
        for (wn = 0; wn < Zr; wn++)
          Or = zr[wn] * En + Er, Er = Math.floor(Or / Rr), kr[wn] = Or - Er * Rr;
        for (; Er > 0; )
          kr[wn++] = Er % Rr, Er = Math.floor(Er / Rr);
        return kr;
      }
      function ve(zr, En) {
        for (var Zr = []; En-- > 0; ) Zr.push(0);
        return Zr.concat(zr);
      }
      function we(zr, En) {
        var Zr = Math.max(zr.length, En.length);
        if (Zr <= 30) return Ee(zr, En);
        Zr = Math.ceil(Zr / 2);
        var kr = zr.slice(Zr), Rr = zr.slice(0, Zr), Er = En.slice(Zr), Or = En.slice(0, Zr), wn = we(Rr, Or), Kn = we(kr, Er), Ln = we(be(Rr, kr), be(Or, Er)), Wn = be(be(wn, ve(Te(Te(Ln, wn), Kn), Zr)), ve(Kn, 2 * Zr));
        return le(Wn), Wn;
      }
      function Ce(zr, En) {
        return -0.012 * zr - 0.012 * En + 15e-6 * zr * En > 0;
      }
      B.prototype.multiply = function(zr) {
        var En = Xr(zr), Zr = this.value, kr = En.value, Rr = this.sign !== En.sign, Er;
        if (En.isSmall) {
          if (kr === 0) return C[0];
          if (kr === 1) return this;
          if (kr === -1) return this.negate();
          if (Er = Math.abs(kr), Er < p)
            return new B(He(Zr, Er), Rr);
          kr = M(Er);
        }
        return Ce(Zr.length, kr.length) ? new B(we(Zr, kr), Rr) : new B(Ee(Zr, kr), Rr);
      }, B.prototype.times = B.prototype.multiply;
      function Se(zr, En, Zr) {
        return zr < p ? new B(He(En, zr), Zr) : new B(Ee(En, M(zr)), Zr);
      }
      Q.prototype._multiplyBySmall = function(zr) {
        return x(zr.value * this.value) ? new Q(zr.value * this.value) : Se(Math.abs(zr.value), M(Math.abs(this.value)), this.sign !== zr.sign);
      }, B.prototype._multiplyBySmall = function(zr) {
        return zr.value === 0 ? C[0] : zr.value === 1 ? this : zr.value === -1 ? this.negate() : Se(Math.abs(zr.value), this.value, this.sign !== zr.sign);
      }, Q.prototype.multiply = function(zr) {
        return Xr(zr)._multiplyBySmall(this);
      }, Q.prototype.times = Q.prototype.multiply, P.prototype.multiply = function(zr) {
        return new P(this.value * Xr(zr).value);
      }, P.prototype.times = P.prototype.multiply;
      function Ne(zr) {
        var En = zr.length, Zr = ge(En + En), kr = p, Rr, Er, Or, wn, Kn;
        for (Or = 0; Or < En; Or++) {
          wn = zr[Or], Er = 0 - wn * wn;
          for (var Ln = Or; Ln < En; Ln++)
            Kn = zr[Ln], Rr = 2 * (wn * Kn) + Zr[Or + Ln] + Er, Er = Math.floor(Rr / kr), Zr[Or + Ln] = Rr - Er * kr;
          Zr[Or + En] = Er;
        }
        return le(Zr), Zr;
      }
      B.prototype.square = function() {
        return new B(Ne(this.value), !1);
      }, Q.prototype.square = function() {
        var zr = this.value * this.value;
        return x(zr) ? new Q(zr) : new B(Ne(M(Math.abs(this.value))), !1);
      }, P.prototype.square = function(zr) {
        return new P(this.value * this.value);
      };
      function rr(zr, En) {
        var Zr = zr.length, kr = En.length, Rr = p, Er = ge(En.length), Or = En[kr - 1], wn = Math.ceil(Rr / (2 * Or)), Kn = He(zr, wn), Ln = He(En, wn), Wn, Sn, hi, ki, xi, _i, Li;
        for (Kn.length <= Zr && Kn.push(0), Ln.push(0), Or = Ln[kr - 1], Sn = Zr - kr; Sn >= 0; Sn--) {
          for (Wn = Rr - 1, Kn[Sn + kr] !== Or && (Wn = Math.floor((Kn[Sn + kr] * Rr + Kn[Sn + kr - 1]) / Or)), hi = 0, ki = 0, _i = Ln.length, xi = 0; xi < _i; xi++)
            hi += Wn * Ln[xi], Li = Math.floor(hi / Rr), ki += Kn[Sn + xi] - (hi - Li * Rr), hi = Li, ki < 0 ? (Kn[Sn + xi] = ki + Rr, ki = -1) : (Kn[Sn + xi] = ki, ki = 0);
          for (; ki !== 0; ) {
            for (Wn -= 1, hi = 0, xi = 0; xi < _i; xi++)
              hi += Kn[Sn + xi] - Rr + Ln[xi], hi < 0 ? (Kn[Sn + xi] = hi + Rr, hi = 0) : (Kn[Sn + xi] = hi, hi = 1);
            ki += hi;
          }
          Er[Sn] = Wn;
        }
        return Kn = ir(Kn, wn)[0], [F(Er), F(Kn)];
      }
      function er(zr, En) {
        for (var Zr = zr.length, kr = En.length, Rr = [], Er = [], Or = p, wn, Kn, Ln, Wn, Sn; Zr; ) {
          if (Er.unshift(zr[--Zr]), le(Er), nr(Er, En) < 0) {
            Rr.push(0);
            continue;
          }
          Kn = Er.length, Ln = Er[Kn - 1] * Or + Er[Kn - 2], Wn = En[kr - 1] * Or + En[kr - 2], Kn > kr && (Ln = (Ln + 1) * Or), wn = Math.ceil(Ln / Wn);
          do {
            if (Sn = He(En, wn), nr(Sn, Er) <= 0) break;
            wn--;
          } while (wn);
          Rr.push(wn), Er = Te(Er, Sn);
        }
        return Rr.reverse(), [F(Rr), F(Er)];
      }
      function ir(zr, En) {
        var Zr = zr.length, kr = ge(Zr), Rr = p, Er, Or, wn, Kn;
        for (wn = 0, Er = Zr - 1; Er >= 0; --Er)
          Kn = wn * Rr + zr[Er], Or = pe(Kn / En), wn = Kn - Or * En, kr[Er] = Or | 0;
        return [kr, wn | 0];
      }
      function sr(zr, En) {
        var Zr, kr = Xr(En);
        if (k)
          return [new P(zr.value / kr.value), new P(zr.value % kr.value)];
        var Rr = zr.value, Er = kr.value, Or;
        if (Er === 0) throw new Error("Cannot divide by zero");
        if (zr.isSmall)
          return kr.isSmall ? [new Q(pe(Rr / Er)), new Q(Rr % Er)] : [C[0], zr];
        if (kr.isSmall) {
          if (Er === 1) return [zr, C[0]];
          if (Er == -1) return [zr.negate(), C[0]];
          var wn = Math.abs(Er);
          if (wn < p) {
            Zr = ir(Rr, wn), Or = F(Zr[0]);
            var Kn = Zr[1];
            return zr.sign && (Kn = -Kn), typeof Or == "number" ? (zr.sign !== kr.sign && (Or = -Or), [new Q(Or), new Q(Kn)]) : [new B(Or, zr.sign !== kr.sign), new Q(Kn)];
          }
          Er = M(wn);
        }
        var Ln = nr(Rr, Er);
        if (Ln === -1) return [C[0], zr];
        if (Ln === 0) return [C[zr.sign === kr.sign ? 1 : -1], C[0]];
        Rr.length + Er.length <= 200 ? Zr = rr(Rr, Er) : Zr = er(Rr, Er), Or = Zr[0];
        var Wn = zr.sign !== kr.sign, Sn = Zr[1], hi = zr.sign;
        return typeof Or == "number" ? (Wn && (Or = -Or), Or = new Q(Or)) : Or = new B(Or, Wn), typeof Sn == "number" ? (hi && (Sn = -Sn), Sn = new Q(Sn)) : Sn = new B(Sn, hi), [Or, Sn];
      }
      B.prototype.divmod = function(zr) {
        var En = sr(this, zr);
        return {
          quotient: En[0],
          remainder: En[1]
        };
      }, P.prototype.divmod = Q.prototype.divmod = B.prototype.divmod, B.prototype.divide = function(zr) {
        return sr(this, zr)[0];
      }, P.prototype.over = P.prototype.divide = function(zr) {
        return new P(this.value / Xr(zr).value);
      }, Q.prototype.over = Q.prototype.divide = B.prototype.over = B.prototype.divide, B.prototype.mod = function(zr) {
        return sr(this, zr)[1];
      }, P.prototype.mod = P.prototype.remainder = function(zr) {
        return new P(this.value % Xr(zr).value);
      }, Q.prototype.remainder = Q.prototype.mod = B.prototype.remainder = B.prototype.mod, B.prototype.pow = function(zr) {
        var En = Xr(zr), Zr = this.value, kr = En.value, Rr, Er, Or;
        if (kr === 0) return C[1];
        if (Zr === 0) return C[0];
        if (Zr === 1) return C[1];
        if (Zr === -1) return En.isEven() ? C[1] : C[-1];
        if (En.sign)
          return C[0];
        if (!En.isSmall) throw new Error("The exponent " + En.toString() + " is too large.");
        if (this.isSmall && x(Rr = Math.pow(Zr, kr)))
          return new Q(pe(Rr));
        for (Er = this, Or = C[1]; kr & !0 && (Or = Or.times(Er), --kr), kr !== 0; )
          kr /= 2, Er = Er.square();
        return Or;
      }, Q.prototype.pow = B.prototype.pow, P.prototype.pow = function(zr) {
        var En = Xr(zr), Zr = this.value, kr = En.value, Rr = BigInt(0), Er = BigInt(1), Or = BigInt(2);
        if (kr === Rr) return C[1];
        if (Zr === Rr) return C[0];
        if (Zr === Er) return C[1];
        if (Zr === BigInt(-1)) return En.isEven() ? C[1] : C[-1];
        if (En.isNegative()) return new P(Rr);
        for (var wn = this, Kn = C[1]; (kr & Er) === Er && (Kn = Kn.times(wn), --kr), kr !== Rr; )
          kr /= Or, wn = wn.square();
        return Kn;
      }, B.prototype.modPow = function(zr, En) {
        if (zr = Xr(zr), En = Xr(En), En.isZero()) throw new Error("Cannot take modPow with modulus 0");
        var Zr = C[1], kr = this.mod(En);
        for (zr.isNegative() && (zr = zr.multiply(C[-1]), kr = kr.modInv(En)); zr.isPositive(); ) {
          if (kr.isZero()) return C[0];
          zr.isOdd() && (Zr = Zr.multiply(kr).mod(En)), zr = zr.divide(2), kr = kr.square().mod(En);
        }
        return Zr;
      }, P.prototype.modPow = Q.prototype.modPow = B.prototype.modPow;
      function nr(zr, En) {
        if (zr.length !== En.length)
          return zr.length > En.length ? 1 : -1;
        for (var Zr = zr.length - 1; Zr >= 0; Zr--)
          if (zr[Zr] !== En[Zr]) return zr[Zr] > En[Zr] ? 1 : -1;
        return 0;
      }
      B.prototype.compareAbs = function(zr) {
        var En = Xr(zr), Zr = this.value, kr = En.value;
        return En.isSmall ? 1 : nr(Zr, kr);
      }, Q.prototype.compareAbs = function(zr) {
        var En = Xr(zr), Zr = Math.abs(this.value), kr = En.value;
        return En.isSmall ? (kr = Math.abs(kr), Zr === kr ? 0 : Zr > kr ? 1 : -1) : -1;
      }, P.prototype.compareAbs = function(zr) {
        var En = this.value, Zr = Xr(zr).value;
        return En = En >= 0 ? En : -En, Zr = Zr >= 0 ? Zr : -Zr, En === Zr ? 0 : En > Zr ? 1 : -1;
      }, B.prototype.compare = function(zr) {
        if (zr === 1 / 0)
          return -1;
        if (zr === -1 / 0)
          return 1;
        var En = Xr(zr), Zr = this.value, kr = En.value;
        return this.sign !== En.sign ? En.sign ? 1 : -1 : En.isSmall ? this.sign ? -1 : 1 : nr(Zr, kr) * (this.sign ? -1 : 1);
      }, B.prototype.compareTo = B.prototype.compare, Q.prototype.compare = function(zr) {
        if (zr === 1 / 0)
          return -1;
        if (zr === -1 / 0)
          return 1;
        var En = Xr(zr), Zr = this.value, kr = En.value;
        return En.isSmall ? Zr == kr ? 0 : Zr > kr ? 1 : -1 : Zr < 0 !== En.sign ? Zr < 0 ? -1 : 1 : Zr < 0 ? 1 : -1;
      }, Q.prototype.compareTo = Q.prototype.compare, P.prototype.compare = function(zr) {
        if (zr === 1 / 0)
          return -1;
        if (zr === -1 / 0)
          return 1;
        var En = this.value, Zr = Xr(zr).value;
        return En === Zr ? 0 : En > Zr ? 1 : -1;
      }, P.prototype.compareTo = P.prototype.compare, B.prototype.equals = function(zr) {
        return this.compare(zr) === 0;
      }, P.prototype.eq = P.prototype.equals = Q.prototype.eq = Q.prototype.equals = B.prototype.eq = B.prototype.equals, B.prototype.notEquals = function(zr) {
        return this.compare(zr) !== 0;
      }, P.prototype.neq = P.prototype.notEquals = Q.prototype.neq = Q.prototype.notEquals = B.prototype.neq = B.prototype.notEquals, B.prototype.greater = function(zr) {
        return this.compare(zr) > 0;
      }, P.prototype.gt = P.prototype.greater = Q.prototype.gt = Q.prototype.greater = B.prototype.gt = B.prototype.greater, B.prototype.lesser = function(zr) {
        return this.compare(zr) < 0;
      }, P.prototype.lt = P.prototype.lesser = Q.prototype.lt = Q.prototype.lesser = B.prototype.lt = B.prototype.lesser, B.prototype.greaterOrEquals = function(zr) {
        return this.compare(zr) >= 0;
      }, P.prototype.geq = P.prototype.greaterOrEquals = Q.prototype.geq = Q.prototype.greaterOrEquals = B.prototype.geq = B.prototype.greaterOrEquals, B.prototype.lesserOrEquals = function(zr) {
        return this.compare(zr) <= 0;
      }, P.prototype.leq = P.prototype.lesserOrEquals = Q.prototype.leq = Q.prototype.lesserOrEquals = B.prototype.leq = B.prototype.lesserOrEquals, B.prototype.isEven = function() {
        return (this.value[0] & 1) === 0;
      }, Q.prototype.isEven = function() {
        return (this.value & 1) === 0;
      }, P.prototype.isEven = function() {
        return (this.value & BigInt(1)) === BigInt(0);
      }, B.prototype.isOdd = function() {
        return (this.value[0] & 1) === 1;
      }, Q.prototype.isOdd = function() {
        return (this.value & 1) === 1;
      }, P.prototype.isOdd = function() {
        return (this.value & BigInt(1)) === BigInt(1);
      }, B.prototype.isPositive = function() {
        return !this.sign;
      }, Q.prototype.isPositive = function() {
        return this.value > 0;
      }, P.prototype.isPositive = Q.prototype.isPositive, B.prototype.isNegative = function() {
        return this.sign;
      }, Q.prototype.isNegative = function() {
        return this.value < 0;
      }, P.prototype.isNegative = Q.prototype.isNegative, B.prototype.isUnit = function() {
        return !1;
      }, Q.prototype.isUnit = function() {
        return Math.abs(this.value) === 1;
      }, P.prototype.isUnit = function() {
        return this.abs().value === BigInt(1);
      }, B.prototype.isZero = function() {
        return !1;
      }, Q.prototype.isZero = function() {
        return this.value === 0;
      }, P.prototype.isZero = function() {
        return this.value === BigInt(0);
      }, B.prototype.isDivisibleBy = function(zr) {
        var En = Xr(zr);
        return En.isZero() ? !1 : En.isUnit() ? !0 : En.compareAbs(2) === 0 ? this.isEven() : this.mod(En).isZero();
      }, P.prototype.isDivisibleBy = Q.prototype.isDivisibleBy = B.prototype.isDivisibleBy;
      function fr(zr) {
        var En = zr.abs();
        if (En.isUnit()) return !1;
        if (En.equals(2) || En.equals(3) || En.equals(5)) return !0;
        if (En.isEven() || En.isDivisibleBy(3) || En.isDivisibleBy(5)) return !1;
        if (En.lesser(49)) return !0;
      }
      function lr(zr, En) {
        for (var Zr = zr.prev(), kr = Zr, Rr = 0, Er, Or, wn; kr.isEven(); ) kr = kr.divide(2), Rr++;
        e: for (Or = 0; Or < En.length; Or++)
          if (!zr.lesser(En[Or]) && (wn = A(En[Or]).modPow(kr, zr), !(wn.isUnit() || wn.equals(Zr)))) {
            for (Er = Rr - 1; Er != 0; Er--) {
              if (wn = wn.square().mod(zr), wn.isUnit()) return !1;
              if (wn.equals(Zr)) continue e;
            }
            return !1;
          }
        return !0;
      }
      B.prototype.isPrime = function(zr) {
        var En = fr(this);
        if (En !== u) return En;
        var Zr = this.abs(), kr = Zr.bitLength();
        if (kr <= 64)
          return lr(Zr, [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37]);
        for (var Rr = Math.log(2) * kr.toJSNumber(), Er = Math.ceil(zr === !0 ? 2 * Math.pow(Rr, 2) : Rr), Or = [], wn = 0; wn < Er; wn++)
          Or.push(A(wn + 2));
        return lr(Zr, Or);
      }, P.prototype.isPrime = Q.prototype.isPrime = B.prototype.isPrime, B.prototype.isProbablePrime = function(zr, En) {
        var Zr = fr(this);
        if (Zr !== u) return Zr;
        for (var kr = this.abs(), Rr = zr === u ? 5 : zr, Er = [], Or = 0; Or < Rr; Or++)
          Er.push(A.randBetween(2, kr.minus(2), En));
        return lr(kr, Er);
      }, P.prototype.isProbablePrime = Q.prototype.isProbablePrime = B.prototype.isProbablePrime, B.prototype.modInv = function(zr) {
        for (var En = A.zero, Zr = A.one, kr = Xr(zr), Rr = this.abs(), Er, Or, wn; !Rr.isZero(); )
          Er = kr.divide(Rr), Or = En, wn = kr, En = Zr, kr = Rr, Zr = Or.subtract(Er.multiply(Zr)), Rr = wn.subtract(Er.multiply(Rr));
        if (!kr.isUnit()) throw new Error(this.toString() + " and " + zr.toString() + " are not co-prime");
        return En.compare(0) === -1 && (En = En.add(zr)), this.isNegative() ? En.negate() : En;
      }, P.prototype.modInv = Q.prototype.modInv = B.prototype.modInv, B.prototype.next = function() {
        var zr = this.value;
        return this.sign ? xe(zr, 1, this.sign) : new B(Pe(zr, 1), this.sign);
      }, Q.prototype.next = function() {
        var zr = this.value;
        return zr + 1 < l ? new Q(zr + 1) : new B(m, !1);
      }, P.prototype.next = function() {
        return new P(this.value + BigInt(1));
      }, B.prototype.prev = function() {
        var zr = this.value;
        return this.sign ? new B(Pe(zr, 1), !0) : xe(zr, 1, this.sign);
      }, Q.prototype.prev = function() {
        var zr = this.value;
        return zr - 1 > -l ? new Q(zr - 1) : new B(m, !0);
      }, P.prototype.prev = function() {
        return new P(this.value - BigInt(1));
      };
      for (var br = [1]; 2 * br[br.length - 1] <= p; ) br.push(2 * br[br.length - 1]);
      var Br = br.length, Fr = br[Br - 1];
      function Gr(zr) {
        return Math.abs(zr) <= p;
      }
      B.prototype.shiftLeft = function(zr) {
        var En = Xr(zr).toJSNumber();
        if (!Gr(En))
          throw new Error(String(En) + " is too large for shifting.");
        if (En < 0) return this.shiftRight(-En);
        var Zr = this;
        if (Zr.isZero()) return Zr;
        for (; En >= Br; )
          Zr = Zr.multiply(Fr), En -= Br - 1;
        return Zr.multiply(br[En]);
      }, P.prototype.shiftLeft = Q.prototype.shiftLeft = B.prototype.shiftLeft, B.prototype.shiftRight = function(zr) {
        var En, Zr = Xr(zr).toJSNumber();
        if (!Gr(Zr))
          throw new Error(String(Zr) + " is too large for shifting.");
        if (Zr < 0) return this.shiftLeft(-Zr);
        for (var kr = this; Zr >= Br; ) {
          if (kr.isZero() || kr.isNegative() && kr.isUnit()) return kr;
          En = sr(kr, Fr), kr = En[1].isNegative() ? En[0].prev() : En[0], Zr -= Br - 1;
        }
        return En = sr(kr, br[Zr]), En[1].isNegative() ? En[0].prev() : En[0];
      }, P.prototype.shiftRight = Q.prototype.shiftRight = B.prototype.shiftRight;
      function qr(zr, En, Zr) {
        En = Xr(En);
        for (var kr = zr.isNegative(), Rr = En.isNegative(), Er = kr ? zr.not() : zr, Or = Rr ? En.not() : En, wn = 0, Kn = 0, Ln = null, Wn = null, Sn = []; !Er.isZero() || !Or.isZero(); )
          Ln = sr(Er, Fr), wn = Ln[1].toJSNumber(), kr && (wn = Fr - 1 - wn), Wn = sr(Or, Fr), Kn = Wn[1].toJSNumber(), Rr && (Kn = Fr - 1 - Kn), Er = Ln[0], Or = Wn[0], Sn.push(Zr(wn, Kn));
        for (var hi = Zr(kr ? 1 : 0, Rr ? 1 : 0) !== 0 ? A(-1) : A(0), ki = Sn.length - 1; ki >= 0; ki -= 1)
          hi = hi.multiply(Fr).add(A(Sn[ki]));
        return hi;
      }
      B.prototype.not = function() {
        return this.negate().prev();
      }, P.prototype.not = Q.prototype.not = B.prototype.not, B.prototype.and = function(zr) {
        return qr(this, zr, function(En, Zr) {
          return En & Zr;
        });
      }, P.prototype.and = Q.prototype.and = B.prototype.and, B.prototype.or = function(zr) {
        return qr(this, zr, function(En, Zr) {
          return En | Zr;
        });
      }, P.prototype.or = Q.prototype.or = B.prototype.or, B.prototype.xor = function(zr) {
        return qr(this, zr, function(En, Zr) {
          return En ^ Zr;
        });
      }, P.prototype.xor = Q.prototype.xor = B.prototype.xor;
      var Hr = 1 << 30, un = (p & -p) * (p & -p) | Hr;
      function Dr(zr) {
        var En = zr.value, Zr = typeof En == "number" ? En | Hr : typeof En == "bigint" ? En | BigInt(Hr) : En[0] + En[1] * p | un;
        return Zr & -Zr;
      }
      function wr(zr, En) {
        if (En.compareTo(zr) <= 0) {
          var Zr = wr(zr, En.square(En)), kr = Zr.p, Rr = Zr.e, Er = kr.multiply(En);
          return Er.compareTo(zr) <= 0 ? { p: Er, e: Rr * 2 + 1 } : { p: kr, e: Rr * 2 };
        }
        return { p: A(1), e: 0 };
      }
      B.prototype.bitLength = function() {
        var zr = this;
        return zr.compareTo(A(0)) < 0 && (zr = zr.negate().subtract(A(1))), zr.compareTo(A(0)) === 0 ? A(0) : A(wr(zr, A(2)).e).add(A(1));
      }, P.prototype.bitLength = Q.prototype.bitLength = B.prototype.bitLength;
      function yr(zr, En) {
        return zr = Xr(zr), En = Xr(En), zr.greater(En) ? zr : En;
      }
      function Qr(zr, En) {
        return zr = Xr(zr), En = Xr(En), zr.lesser(En) ? zr : En;
      }
      function _r(zr, En) {
        if (zr = Xr(zr).abs(), En = Xr(En).abs(), zr.equals(En)) return zr;
        if (zr.isZero()) return En;
        if (En.isZero()) return zr;
        for (var Zr = C[1], kr, Rr; zr.isEven() && En.isEven(); )
          kr = Qr(Dr(zr), Dr(En)), zr = zr.divide(kr), En = En.divide(kr), Zr = Zr.multiply(kr);
        for (; zr.isEven(); )
          zr = zr.divide(Dr(zr));
        do {
          for (; En.isEven(); )
            En = En.divide(Dr(En));
          zr.greater(En) && (Rr = En, En = zr, zr = Rr), En = En.subtract(zr);
        } while (!En.isZero());
        return Zr.isUnit() ? zr : zr.multiply(Zr);
      }
      function Jr(zr, En) {
        return zr = Xr(zr).abs(), En = Xr(En).abs(), zr.divide(_r(zr, En)).multiply(En);
      }
      function fn(zr, En, Zr) {
        zr = Xr(zr), En = Xr(En);
        var kr = Zr || Math.random, Rr = Qr(zr, En), Er = yr(zr, En), Or = Er.subtract(Rr).add(1);
        if (Or.isSmall) return Rr.add(Math.floor(kr() * Or));
        for (var wn = Yn(Or, p).value, Kn = [], Ln = !0, Wn = 0; Wn < wn.length; Wn++) {
          var Sn = Ln ? wn[Wn] + (Wn + 1 < wn.length ? wn[Wn + 1] / p : 0) : p, hi = pe(kr() * Sn);
          Kn.push(hi), hi < wn[Wn] && (Ln = !1);
        }
        return Rr.add(C.fromArray(Kn, p, !1));
      }
      var jr = function(zr, En, Zr, kr) {
        Zr = Zr || b, zr = String(zr), kr || (zr = zr.toLowerCase(), Zr = Zr.toLowerCase());
        var Rr = zr.length, Er, Or = Math.abs(En), wn = {};
        for (Er = 0; Er < Zr.length; Er++)
          wn[Zr[Er]] = Er;
        for (Er = 0; Er < Rr; Er++) {
          var Kn = zr[Er];
          if (Kn !== "-" && Kn in wn && wn[Kn] >= Or) {
            if (Kn === "1" && Or === 1) continue;
            throw new Error(Kn + " is not a valid digit in base " + En + ".");
          }
        }
        En = Xr(En);
        var Ln = [], Wn = zr[0] === "-";
        for (Er = Wn ? 1 : 0; Er < zr.length; Er++) {
          var Kn = zr[Er];
          if (Kn in wn) Ln.push(Xr(wn[Kn]));
          else if (Kn === "<") {
            var Sn = Er;
            do
              Er++;
            while (zr[Er] !== ">" && Er < zr.length);
            Ln.push(Xr(zr.slice(Sn + 1, Er)));
          } else throw new Error(Kn + " is not a valid character");
        }
        return dn(Ln, En, Wn);
      };
      function dn(zr, En, Zr) {
        var kr = C[0], Rr = C[1], Er;
        for (Er = zr.length - 1; Er >= 0; Er--)
          kr = kr.add(zr[Er].times(Rr)), Rr = Rr.times(En);
        return Zr ? kr.negate() : kr;
      }
      function Tn(zr, En) {
        return En = En || b, zr < En.length ? En[zr] : "<" + zr + ">";
      }
      function Yn(zr, En) {
        if (En = A(En), En.isZero()) {
          if (zr.isZero()) return { value: [0], isNegative: !1 };
          throw new Error("Cannot convert nonzero numbers to base 0.");
        }
        if (En.equals(-1)) {
          if (zr.isZero()) return { value: [0], isNegative: !1 };
          if (zr.isNegative())
            return {
              value: [].concat.apply(
                [],
                Array.apply(null, Array(-zr.toJSNumber())).map(Array.prototype.valueOf, [1, 0])
              ),
              isNegative: !1
            };
          var Zr = Array.apply(null, Array(zr.toJSNumber() - 1)).map(Array.prototype.valueOf, [0, 1]);
          return Zr.unshift([1]), {
            value: [].concat.apply([], Zr),
            isNegative: !1
          };
        }
        var kr = !1;
        if (zr.isNegative() && En.isPositive() && (kr = !0, zr = zr.abs()), En.isUnit())
          return zr.isZero() ? { value: [0], isNegative: !1 } : {
            value: Array.apply(null, Array(zr.toJSNumber())).map(Number.prototype.valueOf, 1),
            isNegative: kr
          };
        for (var Rr = [], Er = zr, Or; Er.isNegative() || Er.compareAbs(En) >= 0; ) {
          Or = Er.divmod(En), Er = Or.quotient;
          var wn = Or.remainder;
          wn.isNegative() && (wn = En.minus(wn).abs(), Er = Er.next()), Rr.push(wn.toJSNumber());
        }
        return Rr.push(Er.toJSNumber()), { value: Rr.reverse(), isNegative: kr };
      }
      function si(zr, En, Zr) {
        var kr = Yn(zr, En);
        return (kr.isNegative ? "-" : "") + kr.value.map(function(Rr) {
          return Tn(Rr, Zr);
        }).join("");
      }
      B.prototype.toArray = function(zr) {
        return Yn(this, zr);
      }, Q.prototype.toArray = function(zr) {
        return Yn(this, zr);
      }, P.prototype.toArray = function(zr) {
        return Yn(this, zr);
      }, B.prototype.toString = function(zr, En) {
        if (zr === u && (zr = 10), zr !== 10 || En) return si(this, zr, En);
        for (var Zr = this.value, kr = Zr.length, Rr = String(Zr[--kr]), Er = "0000000", Or; --kr >= 0; )
          Or = String(Zr[kr]), Rr += Er.slice(Or.length) + Or;
        var wn = this.sign ? "-" : "";
        return wn + Rr;
      }, Q.prototype.toString = function(zr, En) {
        return zr === u && (zr = 10), zr != 10 || En ? si(this, zr, En) : String(this.value);
      }, P.prototype.toString = Q.prototype.toString, P.prototype.toJSON = B.prototype.toJSON = Q.prototype.toJSON = function() {
        return this.toString();
      }, B.prototype.valueOf = function() {
        return parseInt(this.toString(), 10);
      }, B.prototype.toJSNumber = B.prototype.valueOf, Q.prototype.valueOf = function() {
        return this.value;
      }, Q.prototype.toJSNumber = Q.prototype.valueOf, P.prototype.valueOf = P.prototype.toJSNumber = function() {
        return parseInt(this.toString(), 10);
      };
      function vn(zr) {
        if (x(+zr)) {
          var En = +zr;
          if (En === pe(En))
            return k ? new P(BigInt(En)) : new Q(En);
          throw new Error("Invalid integer: " + zr);
        }
        var Zr = zr[0] === "-";
        Zr && (zr = zr.slice(1));
        var kr = zr.split(/e/i);
        if (kr.length > 2) throw new Error("Invalid integer: " + kr.join("e"));
        if (kr.length === 2) {
          var Rr = kr[1];
          if (Rr[0] === "+" && (Rr = Rr.slice(1)), Rr = +Rr, Rr !== pe(Rr) || !x(Rr)) throw new Error("Invalid integer: " + Rr + " is not a valid exponent.");
          var Er = kr[0], Or = Er.indexOf(".");
          if (Or >= 0 && (Rr -= Er.length - Or - 1, Er = Er.slice(0, Or) + Er.slice(Or + 1)), Rr < 0) throw new Error("Cannot include negative exponent part for integers");
          Er += new Array(Rr + 1).join("0"), zr = Er;
        }
        var wn = /^([0-9][0-9]*)$/.test(zr);
        if (!wn) throw new Error("Invalid integer: " + zr);
        if (k)
          return new P(BigInt(Zr ? "-" + zr : zr));
        for (var Kn = [], Ln = zr.length, Wn = t, Sn = Ln - Wn; Ln > 0; )
          Kn.push(+zr.slice(Sn, Ln)), Sn -= Wn, Sn < 0 && (Sn = 0), Ln -= Wn;
        return le(Kn), new B(Kn, Zr);
      }
      function Cn(zr) {
        if (k)
          return new P(BigInt(zr));
        if (x(zr)) {
          if (zr !== pe(zr)) throw new Error(zr + " is not an integer.");
          return new Q(zr);
        }
        return vn(zr.toString());
      }
      function Xr(zr) {
        return typeof zr == "number" ? Cn(zr) : typeof zr == "string" ? vn(zr) : typeof zr == "bigint" ? new P(zr) : zr;
      }
      for (var In = 0; In < 1e3; In++)
        C[In] = Xr(In), In > 0 && (C[-In] = Xr(-In));
      return C.one = C[1], C.zero = C[0], C.minusOne = C[-1], C.max = yr, C.min = Qr, C.gcd = _r, C.lcm = Jr, C.isInstance = function(zr) {
        return zr instanceof B || zr instanceof Q || zr instanceof P;
      }, C.randBetween = fn, C.fromArray = function(zr, En, Zr) {
        return dn(zr.map(Xr), Xr(En || 10), Zr);
      }, C;
    }();
    s.hasOwnProperty("exports") && (s.exports = A);
  }(BigInteger)), BigInteger.exports;
}
var hasRequiredAmount;
function requireAmount() {
  if (hasRequiredAmount) return amount;
  hasRequiredAmount = 1, Object.defineProperty(amount, "__esModule", { value: !0 }), amount.Amount = void 0;
  const s = requireDecimal$1(), A = requireBinaryParser(), u = requireAccountId(), p = requireCurrency$1(), t = requireSerializedType(), l = requireBigInteger(), m = requireDist$n(), b = -96, k = 80, C = 16, B = new s.Decimal("1e17"), Q = new s.Decimal("1e-6"), P = l(4294967295);
  s.Decimal.config({
    toExpPos: k + C,
    toExpNeg: b - C
  });
  function x(F) {
    const le = Object.keys(F).sort();
    return le.length === 3 && le[0] === "currency" && le[1] === "issuer" && le[2] === "value";
  }
  class M extends t.SerializedType {
    constructor(le) {
      super(le ?? M.defaultAmount.bytes);
    }
    /**
     * Construct an amount from an IOU or string amount
     *
     * @param value An Amount, object representing an IOU, or a string
     *     representing an integer amount
     * @returns An Amount object
     */
    static from(le) {
      if (le instanceof M)
        return le;
      let ge = m.Buffer.alloc(8);
      if (typeof le == "string") {
        M.assertXrpIsValid(le);
        const pe = l(le), Ie = [m.Buffer.alloc(4), m.Buffer.alloc(4)];
        return Ie[0].writeUInt32BE(Number(pe.shiftRight(32)), 0), Ie[1].writeUInt32BE(Number(pe.and(P)), 0), ge = m.Buffer.concat(Ie), ge[0] |= 64, new M(ge);
      }
      if (x(le)) {
        const pe = new s.Decimal(le.value);
        if (M.assertIouIsValid(pe), pe.isZero())
          ge[0] |= 128;
        else {
          const Pe = pe.times(`1e${-(pe.e - 15)}`).abs().toString(), Te = l(Pe), Qe = [m.Buffer.alloc(4), m.Buffer.alloc(4)];
          Qe[0].writeUInt32BE(Number(Te.shiftRight(32)), 0), Qe[1].writeUInt32BE(Number(Te.and(P)), 0), ge = m.Buffer.concat(Qe), ge[0] |= 128, pe.gt(new s.Decimal(0)) && (ge[0] |= 64);
          const Ee = 97 + (pe.e - 15);
          ge[0] |= Ee >>> 2, ge[1] |= (Ee & 3) << 6;
        }
        const Ie = p.Currency.from(le.currency).toBytes(), be = u.AccountID.from(le.issuer).toBytes();
        return new M(m.Buffer.concat([ge, Ie, be]));
      }
      throw new Error("Invalid type to construct an Amount");
    }
    /**
     * Read an amount from a BinaryParser
     *
     * @param parser BinaryParser to read the Amount from
     * @returns An Amount object
     */
    static fromParser(le) {
      const pe = le.peek() & 128 ? 48 : 8;
      return new M(le.read(pe));
    }
    /**
     * Get the JSON representation of this Amount
     *
     * @returns the JSON interpretation of this.bytes
     */
    toJSON() {
      if (this.isNative()) {
        const le = this.bytes, pe = le[0] & 64 ? "" : "-";
        le[0] &= 63;
        const Ie = l(le.slice(0, 4).readUInt32BE(0)), be = l(le.slice(4).readUInt32BE(0)), Pe = Ie.shiftLeft(32).or(be);
        return `${pe}${Pe.toString()}`;
      } else {
        const le = new A.BinaryParser(this.toString()), ge = le.read(8), pe = p.Currency.fromParser(le), Ie = u.AccountID.fromParser(le), be = ge[0], Pe = ge[1], Qe = be & 64 ? "" : "-", xe = ((be & 63) << 2) + ((Pe & 255) >> 6) - 97;
        ge[0] = 0, ge[1] &= 63;
        const Ee = new s.Decimal(`${Qe}0x${ge.toString("hex")}`).times(`1e${xe}`);
        return M.assertIouIsValid(Ee), {
          value: Ee.toString(),
          currency: pe.toJSON(),
          issuer: Ie.toJSON()
        };
      }
    }
    /**
     * Validate XRP amount
     *
     * @param amount String representing XRP amount
     * @returns void, but will throw if invalid amount
     */
    static assertXrpIsValid(le) {
      if (le.indexOf(".") !== -1)
        throw new Error(`${le.toString()} is an illegal amount`);
      const ge = new s.Decimal(le);
      if (!ge.isZero() && (ge.lt(Q) || ge.gt(B)))
        throw new Error(`${le.toString()} is an illegal amount`);
    }
    /**
     * Validate IOU.value amount
     *
     * @param decimal Decimal.js object representing IOU.value
     * @returns void, but will throw if invalid amount
     */
    static assertIouIsValid(le) {
      if (!le.isZero()) {
        const ge = le.precision(), pe = le.e - 15;
        if (ge > C || pe > k || pe < b)
          throw new Error("Decimal precision out of range");
        this.verifyNoDecimal(le);
      }
    }
    /**
     * Ensure that the value after being multiplied by the exponent does not
     * contain a decimal.
     *
     * @param decimal a Decimal object
     * @returns a string of the object without a decimal
     */
    static verifyNoDecimal(le) {
      if (le.times(`1e${-(le.e - 15)}`).abs().toString().indexOf(".") !== -1)
        throw new Error("Decimal place found in integerNumberString");
    }
    /**
     * Test if this amount is in units of Native Currency(XRP)
     *
     * @returns true if Native (XRP)
     */
    isNative() {
      return (this.bytes[0] & 128) === 0;
    }
  }
  return amount.Amount = M, M.defaultAmount = new M(m.Buffer.from("4000000000000000", "hex")), amount;
}
var blob = {}, hasRequiredBlob;
function requireBlob() {
  if (hasRequiredBlob) return blob;
  hasRequiredBlob = 1, Object.defineProperty(blob, "__esModule", { value: !0 }), blob.Blob = void 0;
  const s = requireSerializedType(), A = requireDist$n();
  class u extends s.SerializedType {
    constructor(t) {
      super(t);
    }
    /**
     * Defines how to read a Blob from a BinaryParser
     *
     * @param parser The binary parser to read the Blob from
     * @param hint The length of the blob, computed by readVariableLengthLength() and passed in
     * @returns A Blob object
     */
    static fromParser(t, l) {
      return new u(t.read(l));
    }
    /**
     * Create a Blob object from a hex-string
     *
     * @param value existing Blob object or a hex-string
     * @returns A Blob object
     */
    static from(t) {
      if (t instanceof u)
        return t;
      if (typeof t == "string")
        return new u(A.Buffer.from(t, "hex"));
      throw new Error("Cannot construct Blob from value given");
    }
  }
  return blob.Blob = u, blob;
}
var hash128 = {}, hasRequiredHash128;
function requireHash128() {
  if (hasRequiredHash128) return hash128;
  hasRequiredHash128 = 1, Object.defineProperty(hash128, "__esModule", { value: !0 }), hash128.Hash128 = void 0;
  const s = requireHash(), A = requireDist$n();
  class u extends s.Hash {
    constructor(t) {
      t && t.byteLength === 0 && (t = u.ZERO_128.bytes), super(t ?? u.ZERO_128.bytes);
    }
    /**
     * Get the hex representation of a hash-128 bytes, allowing unset
     *
     * @returns hex String of this.bytes
     */
    toHex() {
      const t = this.toBytes().toString("hex").toUpperCase();
      return /^0+$/.exec(t) ? "" : t;
    }
  }
  return hash128.Hash128 = u, u.width = 16, u.ZERO_128 = new u(A.Buffer.alloc(u.width)), hash128;
}
var hash256 = {}, hasRequiredHash256;
function requireHash256() {
  if (hasRequiredHash256) return hash256;
  hasRequiredHash256 = 1, Object.defineProperty(hash256, "__esModule", { value: !0 }), hash256.Hash256 = void 0;
  const s = requireHash(), A = requireDist$n();
  class u extends s.Hash {
    constructor(t) {
      super(t ?? u.ZERO_256.bytes);
    }
  }
  return hash256.Hash256 = u, u.width = 32, u.ZERO_256 = new u(A.Buffer.alloc(u.width)), hash256;
}
var issue = {}, hasRequiredIssue;
function requireIssue() {
  if (hasRequiredIssue) return issue;
  hasRequiredIssue = 1, Object.defineProperty(issue, "__esModule", { value: !0 }), issue.Issue = void 0;
  const s = requireBinaryParser(), A = requireAccountId(), u = requireCurrency$1(), p = requireSerializedType(), t = requireDist$n();
  function l(b) {
    const k = Object.keys(b).sort();
    return k.length === 1 ? k[0] === "currency" : k.length === 2 && k[0] === "currency" && k[1] === "issuer";
  }
  class m extends p.SerializedType {
    constructor(k) {
      super(k ?? m.ZERO_ISSUED_CURRENCY.bytes);
    }
    /**
     * Construct an amount from an IOU or string amount
     *
     * @param value An Amount, object representing an IOU, or a string
     *     representing an integer amount
     * @returns An Amount object
     */
    static from(k) {
      if (k instanceof m)
        return k;
      if (l(k)) {
        const C = u.Currency.from(k.currency).toBytes();
        if (k.issuer == null)
          return new m(C);
        const B = A.AccountID.from(k.issuer).toBytes();
        return new m(t.Buffer.concat([C, B]));
      }
      throw new Error("Invalid type to construct an Amount");
    }
    /**
     * Read an amount from a BinaryParser
     *
     * @param parser BinaryParser to read the Amount from
     * @returns An Amount object
     */
    static fromParser(k) {
      const C = k.read(20);
      if (new u.Currency(C).toJSON() === "XRP")
        return new m(C);
      const B = [C, k.read(20)];
      return new m(t.Buffer.concat(B));
    }
    /**
     * Get the JSON representation of this Amount
     *
     * @returns the JSON interpretation of this.bytes
     */
    toJSON() {
      const k = new s.BinaryParser(this.toString()), C = u.Currency.fromParser(k);
      if (C.toJSON() === "XRP")
        return { currency: C.toJSON() };
      const B = A.AccountID.fromParser(k);
      return {
        currency: C.toJSON(),
        issuer: B.toJSON()
      };
    }
  }
  return issue.Issue = m, m.ZERO_ISSUED_CURRENCY = new m(t.Buffer.alloc(20)), issue;
}
var pathSet = {}, hasRequiredPathSet;
function requirePathSet() {
  if (hasRequiredPathSet) return pathSet;
  hasRequiredPathSet = 1, Object.defineProperty(pathSet, "__esModule", { value: !0 }), pathSet.PathSet = void 0;
  const s = requireAccountId(), A = requireCurrency$1(), u = requireBinaryParser(), p = requireSerializedType(), t = requireDist$n(), l = 0, m = 255, b = 1, k = 16, C = 32;
  function B(F) {
    return F.issuer !== void 0 || F.account !== void 0 || F.currency !== void 0;
  }
  function Q(F) {
    return Array.isArray(F) && F.length === 0 || Array.isArray(F) && Array.isArray(F[0]) && F[0].length === 0 || Array.isArray(F) && Array.isArray(F[0]) && B(F[0][0]);
  }
  class P extends p.SerializedType {
    /**
     * Create a Hop from a HopObject
     *
     * @param value Either a hop or HopObject to create a hop with
     * @returns a Hop
     */
    static from(le) {
      if (le instanceof P)
        return le;
      const ge = [t.Buffer.from([0])];
      return le.account && (ge.push(s.AccountID.from(le.account).toBytes()), ge[0][0] |= b), le.currency && (ge.push(A.Currency.from(le.currency).toBytes()), ge[0][0] |= k), le.issuer && (ge.push(s.AccountID.from(le.issuer).toBytes()), ge[0][0] |= C), new P(t.Buffer.concat(ge));
    }
    /**
     * Construct a Hop from a BinaryParser
     *
     * @param parser BinaryParser to read the Hop from
     * @returns a Hop
     */
    static fromParser(le) {
      const ge = le.readUInt8(), pe = [t.Buffer.from([ge])];
      return ge & b && pe.push(le.read(s.AccountID.width)), ge & k && pe.push(le.read(A.Currency.width)), ge & C && pe.push(le.read(s.AccountID.width)), new P(t.Buffer.concat(pe));
    }
    /**
     * Get the JSON interpretation of this hop
     *
     * @returns a HopObject, an JS object with optional account, issuer, and currency
     */
    toJSON() {
      const le = new u.BinaryParser(this.bytes.toString("hex")), ge = le.readUInt8();
      let pe, Ie, be;
      ge & b && (pe = s.AccountID.fromParser(le).toJSON()), ge & k && (Ie = A.Currency.fromParser(le).toJSON()), ge & C && (be = s.AccountID.fromParser(le).toJSON());
      const Pe = {};
      return pe && (Pe.account = pe), be && (Pe.issuer = be), Ie && (Pe.currency = Ie), Pe;
    }
    /**
     * get a number representing the type of this hop
     *
     * @returns a number to be bitwise and-ed with TYPE_ constants to describe the types in the hop
     */
    type() {
      return this.bytes[0];
    }
  }
  class x extends p.SerializedType {
    /**
     * construct a Path from an array of Hops
     *
     * @param value Path or array of HopObjects to construct a Path
     * @returns the Path
     */
    static from(le) {
      if (le instanceof x)
        return le;
      const ge = [];
      return le.forEach((pe) => {
        ge.push(P.from(pe).toBytes());
      }), new x(t.Buffer.concat(ge));
    }
    /**
     * Read a Path from a BinaryParser
     *
     * @param parser BinaryParser to read Path from
     * @returns the Path represented by the bytes read from the BinaryParser
     */
    static fromParser(le) {
      const ge = [];
      for (; !le.end() && (ge.push(P.fromParser(le).toBytes()), !(le.peek() === l || le.peek() === m)); )
        ;
      return new x(t.Buffer.concat(ge));
    }
    /**
     * Get the JSON representation of this Path
     *
     * @returns an Array of HopObject constructed from this.bytes
     */
    toJSON() {
      const le = [], ge = new u.BinaryParser(this.toString());
      for (; !ge.end(); )
        le.push(P.fromParser(ge).toJSON());
      return le;
    }
  }
  class M extends p.SerializedType {
    /**
     * Construct a PathSet from an Array of Arrays representing paths
     *
     * @param value A PathSet or Array of Array of HopObjects
     * @returns the PathSet constructed from value
     */
    static from(le) {
      if (le instanceof M)
        return le;
      if (Q(le)) {
        const ge = [];
        return le.forEach((pe) => {
          ge.push(x.from(pe).toBytes()), ge.push(t.Buffer.from([m]));
        }), ge[ge.length - 1] = t.Buffer.from([l]), new M(t.Buffer.concat(ge));
      }
      throw new Error("Cannot construct PathSet from given value");
    }
    /**
     * Construct a PathSet from a BinaryParser
     *
     * @param parser A BinaryParser to read PathSet from
     * @returns the PathSet read from parser
     */
    static fromParser(le) {
      const ge = [];
      for (; !le.end() && (ge.push(x.fromParser(le).toBytes()), ge.push(le.read(1)), ge[ge.length - 1][0] != l); )
        ;
      return new M(t.Buffer.concat(ge));
    }
    /**
     * Get the JSON representation of this PathSet
     *
     * @returns an Array of Array of HopObjects, representing this PathSet
     */
    toJSON() {
      const le = [], ge = new u.BinaryParser(this.toString());
      for (; !ge.end(); )
        le.push(x.fromParser(ge).toJSON()), ge.skip(1);
      return le;
    }
  }
  return pathSet.PathSet = M, pathSet;
}
var stArray = {}, stObject = {}, hasRequiredStObject;
function requireStObject() {
  if (hasRequiredStObject) return stObject;
  hasRequiredStObject = 1, Object.defineProperty(stObject, "__esModule", { value: !0 }), stObject.STObject = void 0;
  const s = requireEnums(), A = requireSerializedType(), u = requireDist$4(), p = requireBinaryParser(), t = requireBinarySerializer(), l = requireDist$n(), m = requireStArray(), b = l.Buffer.from([225]), k = "ObjectEndMarker", C = "STObject", B = "Destination", Q = "Account", P = "SourceTag", x = "DestinationTag";
  function M(ge, pe) {
    const Ie = (0, u.xAddressToClassicAddress)(pe);
    let be;
    if (ge === B)
      be = x;
    else if (ge === Q)
      be = P;
    else if (Ie.tag !== !1)
      throw new Error(`${ge} cannot have an associated tag`);
    return Ie.tag !== !1 ? { [ge]: Ie.classicAddress, [be]: Ie.tag } : { [ge]: Ie.classicAddress };
  }
  function F(ge, pe) {
    if (!(ge[P] === void 0 || pe[P] === void 0))
      throw new Error("Cannot have Account X-Address and SourceTag");
    if (!(ge[x] === void 0 || pe[x] === void 0))
      throw new Error("Cannot have Destination X-Address and DestinationTag");
  }
  class le extends A.SerializedType {
    /**
     * Construct a STObject from a BinaryParser
     *
     * @param parser BinaryParser to read STObject from
     * @returns A STObject object
     */
    static fromParser(pe) {
      const Ie = new t.BytesList(), be = new t.BinarySerializer(Ie);
      for (; !pe.end(); ) {
        const Pe = pe.readField();
        if (Pe.name === k)
          break;
        const Te = pe.readFieldValue(Pe);
        be.writeFieldAndValue(Pe, Te), Pe.type.name === C && be.put(b);
      }
      return new le(Ie.toBytes());
    }
    /**
     * Construct a STObject from a JSON object
     *
     * @param value An object to include
     * @param filter optional, denote which field to include in serialized object
     * @param definitions optional, types and values to use to encode/decode a transaction
     * @returns a STObject object
     */
    static from(pe, Ie, be = s.DEFAULT_DEFINITIONS) {
      if (pe instanceof le)
        return pe;
      const Pe = new t.BytesList(), Te = new t.BinarySerializer(Pe);
      let Qe = !1;
      const xe = Object.entries(pe).reduce((He, [ve, we]) => {
        let Ce;
        return we && (0, u.isValidXAddress)(we.toString()) && (Ce = M(ve, we.toString()), F(Ce, pe)), Object.assign(He, Ce ?? { [ve]: we });
      }, {});
      let Ee = Object.keys(xe).map((He) => be.field[He]).filter((He) => He !== void 0 && xe[He.name] !== void 0 && He.isSerialized).sort((He, ve) => He.ordinal - ve.ordinal);
      return Ie !== void 0 && (Ee = Ee.filter(Ie)), Ee.forEach((He) => {
        const ve = He.type.name === C ? this.from(xe[He.name], void 0, be) : He.type.name === "STArray" ? m.STArray.from(xe[He.name], be) : He.associatedType.from(xe[He.name]);
        if (ve == null)
          throw new TypeError(`Unable to interpret "${He.name}: ${xe[He.name]}".`);
        ve.name === "UNLModify" && (Qe = !0);
        const we = He.name == "Account" && Qe;
        Te.writeFieldAndValue(He, ve, we), He.type.name === C && Te.put(b);
      }), new le(Pe.toBytes());
    }
    /**
     * Get the JSON interpretation of this.bytes
     * @param definitions rippled definitions used to parse the values of transaction types and such.
     *                          Can be customized for sidechains and amendments.
     * @returns a JSON object
     */
    toJSON(pe) {
      const Ie = new p.BinaryParser(this.toString(), pe), be = {};
      for (; !Ie.end(); ) {
        const Pe = Ie.readField();
        if (Pe.name === k)
          break;
        be[Pe.name] = Ie.readFieldValue(Pe).toJSON(pe);
      }
      return be;
    }
  }
  return stObject.STObject = le, stObject;
}
var hasRequiredStArray;
function requireStArray() {
  if (hasRequiredStArray) return stArray;
  hasRequiredStArray = 1, Object.defineProperty(stArray, "__esModule", { value: !0 }), stArray.STArray = void 0;
  const s = requireEnums(), A = requireSerializedType(), u = requireStObject(), p = requireBinaryParser(), t = requireDist$n(), l = t.Buffer.from([241]), m = "ArrayEndMarker", b = t.Buffer.from([225]);
  function k(B) {
    return Array.isArray(B) && (B.length === 0 || typeof B[0] == "object");
  }
  class C extends A.SerializedType {
    /**
     * Construct an STArray from a BinaryParser
     *
     * @param parser BinaryParser to parse an STArray from
     * @returns An STArray Object
     */
    static fromParser(Q) {
      const P = [];
      for (; !Q.end(); ) {
        const x = Q.readField();
        if (x.name === m)
          break;
        P.push(x.header, Q.readFieldValue(x).toBytes(), b);
      }
      return P.push(l), new C(t.Buffer.concat(P));
    }
    /**
     * Construct an STArray from an Array of JSON Objects
     *
     * @param value STArray or Array of Objects to parse into an STArray
     * @param definitions optional, types and values to use to encode/decode a transaction
     * @returns An STArray object
     */
    static from(Q, P = s.DEFAULT_DEFINITIONS) {
      if (Q instanceof C)
        return Q;
      if (k(Q)) {
        const x = [];
        return Q.forEach((M) => {
          x.push(u.STObject.from(M, void 0, P).toBytes());
        }), x.push(l), new C(t.Buffer.concat(x));
      }
      throw new Error("Cannot construct STArray from value given");
    }
    /**
     * Return the JSON representation of this.bytes
     *
     * @param definitions optional, types and values to use to encode/decode a transaction
     * @returns An Array of JSON objects
     */
    toJSON(Q = s.DEFAULT_DEFINITIONS) {
      const P = [], x = new p.BinaryParser(this.toString(), Q);
      for (; !x.end(); ) {
        const M = x.readField();
        if (M.name === m)
          break;
        const F = {};
        F[M.name] = u.STObject.fromParser(x).toJSON(Q), P.push(F);
      }
      return P;
    }
  }
  return stArray.STArray = C, stArray;
}
var uint16 = {}, uint = {}, hasRequiredUint;
function requireUint() {
  if (hasRequiredUint) return uint;
  hasRequiredUint = 1, Object.defineProperty(uint, "__esModule", { value: !0 }), uint.UInt = void 0;
  const s = requireSerializedType();
  function A(p, t) {
    return p < t ? -1 : p == t ? 0 : 1;
  }
  class u extends s.Comparable {
    constructor(t) {
      super(t);
    }
    /**
     * Overload of compareTo for Comparable
     *
     * @param other other UInt to compare this to
     * @returns -1, 0, or 1 depending on how the objects relate to each other
     */
    compareTo(t) {
      return A(this.valueOf(), t.valueOf());
    }
    /**
     * Convert a UInt object to JSON
     *
     * @returns number or string represented by this.bytes
     */
    toJSON() {
      const t = this.valueOf();
      return typeof t == "number" ? t : t.toString();
    }
  }
  return uint.UInt = u, uint;
}
var hasRequiredUint16;
function requireUint16() {
  if (hasRequiredUint16) return uint16;
  hasRequiredUint16 = 1, Object.defineProperty(uint16, "__esModule", { value: !0 }), uint16.UInt16 = void 0;
  const s = requireUint(), A = requireDist$n();
  class u extends s.UInt {
    constructor(t) {
      super(t ?? u.defaultUInt16.bytes);
    }
    static fromParser(t) {
      return new u(t.read(u.width));
    }
    /**
     * Construct a UInt16 object from a number
     *
     * @param val UInt16 object or number
     */
    static from(t) {
      if (t instanceof u)
        return t;
      if (typeof t == "number") {
        const l = A.Buffer.alloc(u.width);
        return l.writeUInt16BE(t, 0), new u(l);
      }
      throw new Error("Can not construct UInt16 with given value");
    }
    /**
     * get the value of a UInt16 object
     *
     * @returns the number represented by this.bytes
     */
    valueOf() {
      return this.bytes.readUInt16BE(0);
    }
  }
  return uint16.UInt16 = u, u.width = 16 / 8, u.defaultUInt16 = new u(A.Buffer.alloc(u.width)), uint16;
}
var uint32 = {}, hasRequiredUint32;
function requireUint32() {
  if (hasRequiredUint32) return uint32;
  hasRequiredUint32 = 1, Object.defineProperty(uint32, "__esModule", { value: !0 }), uint32.UInt32 = void 0;
  const s = requireUint(), A = requireDist$n();
  class u extends s.UInt {
    constructor(t) {
      super(t ?? u.defaultUInt32.bytes);
    }
    static fromParser(t) {
      return new u(t.read(u.width));
    }
    /**
     * Construct a UInt32 object from a number
     *
     * @param val UInt32 object or number
     */
    static from(t) {
      if (t instanceof u)
        return t;
      const l = A.Buffer.alloc(u.width);
      if (typeof t == "string") {
        const m = Number.parseInt(t);
        return l.writeUInt32BE(m, 0), new u(l);
      }
      if (typeof t == "number")
        return l.writeUInt32BE(t, 0), new u(l);
      throw new Error("Cannot construct UInt32 from given value");
    }
    /**
     * get the value of a UInt32 object
     *
     * @returns the number represented by this.bytes
     */
    valueOf() {
      return this.bytes.readUInt32BE(0);
    }
  }
  return uint32.UInt32 = u, u.width = 32 / 8, u.defaultUInt32 = new u(A.Buffer.alloc(u.width)), uint32;
}
var uint64 = {}, hasRequiredUint64;
function requireUint64() {
  if (hasRequiredUint64) return uint64;
  hasRequiredUint64 = 1, Object.defineProperty(uint64, "__esModule", { value: !0 }), uint64.UInt64 = void 0;
  const s = requireUint(), A = requireBigInteger(), u = requireBigInteger(), p = requireDist$n(), t = /^[a-fA-F0-9]{1,16}$/, l = A(4294967295);
  class m extends s.UInt {
    constructor(k) {
      super(k ?? m.defaultUInt64.bytes);
    }
    static fromParser(k) {
      return new m(k.read(m.width));
    }
    /**
     * Construct a UInt64 object
     *
     * @param val A UInt64, hex-string, bigInt, or number
     * @returns A UInt64 object
     */
    static from(k) {
      if (k instanceof m)
        return k;
      let C = p.Buffer.alloc(m.width);
      if (typeof k == "number") {
        if (k < 0)
          throw new Error("value must be an unsigned integer");
        const B = A(k), Q = [p.Buffer.alloc(4), p.Buffer.alloc(4)];
        return Q[0].writeUInt32BE(Number(B.shiftRight(32)), 0), Q[1].writeUInt32BE(Number(B.and(l)), 0), new m(p.Buffer.concat(Q));
      }
      if (typeof k == "string") {
        if (!t.test(k))
          throw new Error(`${k} is not a valid hex-string`);
        const B = k.padStart(16, "0");
        return C = p.Buffer.from(B, "hex"), new m(C);
      }
      if ((0, u.isInstance)(k)) {
        const B = [p.Buffer.alloc(4), p.Buffer.alloc(4)];
        return B[0].writeUInt32BE(Number(k.shiftRight(A(32))), 0), B[1].writeUInt32BE(Number(k.and(l)), 0), new m(p.Buffer.concat(B));
      }
      throw new Error("Cannot construct UInt64 from given value");
    }
    /**
     * The JSON representation of a UInt64 object
     *
     * @returns a hex-string
     */
    toJSON() {
      return this.bytes.toString("hex").toUpperCase();
    }
    /**
     * Get the value of the UInt64
     *
     * @returns the number represented buy this.bytes
     */
    valueOf() {
      const k = A(this.bytes.slice(0, 4).readUInt32BE(0)), C = A(this.bytes.slice(4).readUInt32BE(0));
      return k.shiftLeft(A(32)).or(C);
    }
    /**
     * Get the bytes representation of the UInt64 object
     *
     * @returns 8 bytes representing the UInt64
     */
    toBytes() {
      return this.bytes;
    }
  }
  return uint64.UInt64 = m, m.width = 64 / 8, m.defaultUInt64 = new m(p.Buffer.alloc(m.width)), uint64;
}
var uint8 = {}, hasRequiredUint8;
function requireUint8() {
  if (hasRequiredUint8) return uint8;
  hasRequiredUint8 = 1, Object.defineProperty(uint8, "__esModule", { value: !0 }), uint8.UInt8 = void 0;
  const s = requireUint(), A = requireDist$n();
  class u extends s.UInt {
    constructor(t) {
      super(t ?? u.defaultUInt8.bytes);
    }
    static fromParser(t) {
      return new u(t.read(u.width));
    }
    /**
     * Construct a UInt8 object from a number
     *
     * @param val UInt8 object or number
     */
    static from(t) {
      if (t instanceof u)
        return t;
      if (typeof t == "number") {
        const l = A.Buffer.alloc(u.width);
        return l.writeUInt8(t, 0), new u(l);
      }
      throw new Error("Cannot construct UInt8 from given value");
    }
    /**
     * get the value of a UInt8 object
     *
     * @returns the number represented by this.bytes
     */
    valueOf() {
      return this.bytes.readUInt8(0);
    }
  }
  return uint8.UInt8 = u, u.width = 8 / 8, u.defaultUInt8 = new u(A.Buffer.alloc(u.width)), uint8;
}
var vector256 = {}, hasRequiredVector256;
function requireVector256() {
  if (hasRequiredVector256) return vector256;
  hasRequiredVector256 = 1, Object.defineProperty(vector256, "__esModule", { value: !0 }), vector256.Vector256 = void 0;
  const s = requireSerializedType(), A = requireHash256(), u = requireBinarySerializer();
  function p(l) {
    return Array.isArray(l) && (l.length === 0 || typeof l[0] == "string");
  }
  class t extends s.SerializedType {
    constructor(m) {
      super(m);
    }
    /**
     * Construct a Vector256 from a BinaryParser
     *
     * @param parser BinaryParser to
     * @param hint length of the vector, in bytes, optional
     * @returns a Vector256 object
     */
    static fromParser(m, b) {
      const k = new u.BytesList(), B = (b ?? m.size()) / 32;
      for (let Q = 0; Q < B; Q++)
        A.Hash256.fromParser(m).toBytesSink(k);
      return new t(k.toBytes());
    }
    /**
     * Construct a Vector256 object from an array of hashes
     *
     * @param value A Vector256 object or array of hex-strings representing Hash256's
     * @returns a Vector256 object
     */
    static from(m) {
      if (m instanceof t)
        return m;
      if (p(m)) {
        const b = new u.BytesList();
        return m.forEach((k) => {
          A.Hash256.from(k).toBytesSink(b);
        }), new t(b.toBytes());
      }
      throw new Error("Cannot construct Vector256 from given value");
    }
    /**
     * Return an Array of hex-strings represented by this.bytes
     *
     * @returns An Array of strings representing the Hash256 objects
     */
    toJSON() {
      if (this.bytes.byteLength % 32 !== 0)
        throw new Error("Invalid bytes for Vector256");
      const m = [];
      for (let b = 0; b < this.bytes.byteLength; b += 32)
        m.push(this.bytes.slice(b, b + 32).toString("hex").toUpperCase());
      return m;
    }
  }
  return vector256.Vector256 = t, vector256;
}
var xchainBridge = {}, hasRequiredXchainBridge;
function requireXchainBridge() {
  if (hasRequiredXchainBridge) return xchainBridge;
  hasRequiredXchainBridge = 1, Object.defineProperty(xchainBridge, "__esModule", { value: !0 }), xchainBridge.XChainBridge = void 0;
  const s = requireBinaryParser(), A = requireAccountId(), u = requireSerializedType(), p = requireDist$n(), t = requireIssue();
  function l(b) {
    const k = Object.keys(b).sort();
    return k.length === 4 && k[0] === "IssuingChainDoor" && k[1] === "IssuingChainIssue" && k[2] === "LockingChainDoor" && k[3] === "LockingChainIssue";
  }
  class m extends u.SerializedType {
    constructor(k) {
      super(k ?? m.ZERO_XCHAIN_BRIDGE.bytes);
    }
    /**
     * Construct a cross-chain bridge from a JSON
     *
     * @param value XChainBridge or JSON to parse into an XChainBridge
     * @returns An XChainBridge object
     */
    static from(k) {
      if (k instanceof m)
        return k;
      if (!l(k))
        throw new Error("Invalid type to construct an XChainBridge");
      const C = [];
      return this.TYPE_ORDER.forEach((B) => {
        const { name: Q, type: P } = B;
        P === A.AccountID && C.push(p.Buffer.from([20]));
        const x = P.from(k[Q]);
        C.push(x.toBytes());
      }), new m(p.Buffer.concat(C));
    }
    /**
     * Read an XChainBridge from a BinaryParser
     *
     * @param parser BinaryParser to read the XChainBridge from
     * @returns An XChainBridge object
     */
    static fromParser(k) {
      const C = [];
      return this.TYPE_ORDER.forEach((B) => {
        const { type: Q } = B;
        Q === A.AccountID && (k.skip(1), C.push(p.Buffer.from([20])));
        const P = Q.fromParser(k);
        C.push(P.toBytes());
      }), new m(p.Buffer.concat(C));
    }
    /**
     * Get the JSON representation of this XChainBridge
     *
     * @returns the JSON interpretation of this.bytes
     */
    toJSON() {
      const k = new s.BinaryParser(this.toString()), C = {};
      return m.TYPE_ORDER.forEach((B) => {
        const { name: Q, type: P } = B;
        P === A.AccountID && k.skip(1);
        const x = P.fromParser(k).toJSON();
        C[Q] = x;
      }), C;
    }
  }
  return xchainBridge.XChainBridge = m, m.ZERO_XCHAIN_BRIDGE = new m(p.Buffer.concat([
    p.Buffer.from([20]),
    p.Buffer.alloc(40),
    p.Buffer.from([20]),
    p.Buffer.alloc(40)
  ])), m.TYPE_ORDER = [
    { name: "LockingChainDoor", type: A.AccountID },
    { name: "LockingChainIssue", type: t.Issue },
    { name: "IssuingChainDoor", type: A.AccountID },
    { name: "IssuingChainIssue", type: t.Issue }
  ], xchainBridge;
}
var hasRequiredTypes$3;
function requireTypes$3() {
  return hasRequiredTypes$3 || (hasRequiredTypes$3 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.Vector256 = s.UInt64 = s.UInt32 = s.UInt16 = s.UInt8 = s.STObject = s.STArray = s.PathSet = s.Hash256 = s.Hash160 = s.Hash128 = s.Currency = s.Blob = s.Amount = s.AccountID = s.coreTypes = void 0;
    const A = requireAccountId();
    Object.defineProperty(s, "AccountID", { enumerable: !0, get: function() {
      return A.AccountID;
    } });
    const u = requireAmount();
    Object.defineProperty(s, "Amount", { enumerable: !0, get: function() {
      return u.Amount;
    } });
    const p = requireBlob();
    Object.defineProperty(s, "Blob", { enumerable: !0, get: function() {
      return p.Blob;
    } });
    const t = requireCurrency$1();
    Object.defineProperty(s, "Currency", { enumerable: !0, get: function() {
      return t.Currency;
    } });
    const l = requireHash128();
    Object.defineProperty(s, "Hash128", { enumerable: !0, get: function() {
      return l.Hash128;
    } });
    const m = requireHash160();
    Object.defineProperty(s, "Hash160", { enumerable: !0, get: function() {
      return m.Hash160;
    } });
    const b = requireHash256();
    Object.defineProperty(s, "Hash256", { enumerable: !0, get: function() {
      return b.Hash256;
    } });
    const k = requireIssue(), C = requirePathSet();
    Object.defineProperty(s, "PathSet", { enumerable: !0, get: function() {
      return C.PathSet;
    } });
    const B = requireStArray();
    Object.defineProperty(s, "STArray", { enumerable: !0, get: function() {
      return B.STArray;
    } });
    const Q = requireStObject();
    Object.defineProperty(s, "STObject", { enumerable: !0, get: function() {
      return Q.STObject;
    } });
    const P = requireUint16();
    Object.defineProperty(s, "UInt16", { enumerable: !0, get: function() {
      return P.UInt16;
    } });
    const x = requireUint32();
    Object.defineProperty(s, "UInt32", { enumerable: !0, get: function() {
      return x.UInt32;
    } });
    const M = requireUint64();
    Object.defineProperty(s, "UInt64", { enumerable: !0, get: function() {
      return M.UInt64;
    } });
    const F = requireUint8();
    Object.defineProperty(s, "UInt8", { enumerable: !0, get: function() {
      return F.UInt8;
    } });
    const le = requireVector256();
    Object.defineProperty(s, "Vector256", { enumerable: !0, get: function() {
      return le.Vector256;
    } });
    const ge = requireXchainBridge(), pe = requireEnums(), Ie = {
      AccountID: A.AccountID,
      Amount: u.Amount,
      Blob: p.Blob,
      Currency: t.Currency,
      Hash128: l.Hash128,
      Hash160: m.Hash160,
      Hash256: b.Hash256,
      Issue: k.Issue,
      PathSet: C.PathSet,
      STArray: B.STArray,
      STObject: Q.STObject,
      UInt8: F.UInt8,
      UInt16: P.UInt16,
      UInt32: x.UInt32,
      UInt64: M.UInt64,
      Vector256: le.Vector256,
      XChainBridge: ge.XChainBridge
    };
    s.coreTypes = Ie, pe.DEFAULT_DEFINITIONS.associateTypes(Ie);
  }(types$3)), types$3;
}
var binary = {}, hashPrefixes = {}, hasRequiredHashPrefixes;
function requireHashPrefixes() {
  if (hasRequiredHashPrefixes) return hashPrefixes;
  hasRequiredHashPrefixes = 1, Object.defineProperty(hashPrefixes, "__esModule", { value: !0 }), hashPrefixes.HashPrefix = void 0;
  const s = requireDist$n();
  function A(p) {
    const t = s.Buffer.alloc(4);
    return t.writeUInt32BE(p, 0), t;
  }
  const u = {
    transactionID: A(1415073280),
    // transaction plus metadata
    transaction: A(1397638144),
    // account state
    accountStateEntry: A(1296846336),
    // inner node in tree
    innerNode: A(1296649728),
    // ledger master data for signing
    ledgerHeader: A(1280791040),
    // inner transaction to sign
    transactionSig: A(1398036480),
    // inner transaction to sign
    transactionMultiSig: A(1397576704),
    // validation for signing
    validation: A(1447119872),
    // proposal for signing
    proposal: A(1347571712),
    // payment channel claim
    paymentChannelClaim: A(1129073920)
  };
  return hashPrefixes.HashPrefix = u, hashPrefixes;
}
var hashes = {}, hasRequiredHashes;
function requireHashes() {
  if (hasRequiredHashes) return hashes;
  hasRequiredHashes = 1, Object.defineProperty(hashes, "__esModule", { value: !0 }), hashes.transactionID = hashes.sha512Half = hashes.Sha512Half = void 0;
  const s = requireHashPrefixes(), A = requireBrowser$a(), u = requireHash256(), p = requireBinarySerializer(), t = requireDist$n();
  class l extends p.BytesList {
    constructor() {
      super(...arguments), this.hash = A("sha512");
    }
    /**
     * Construct a new Sha512Hash and write bytes this.hash
     *
     * @param bytes bytes to write to this.hash
     * @returns the new Sha512Hash object
     */
    static put(C) {
      return new l().put(C);
    }
    /**
     * Write bytes to an existing Sha512Hash
     *
     * @param bytes bytes to write to object
     * @returns the Sha512 object
     */
    put(C) {
      return this.hash.update(C), this;
    }
    /**
     * Compute SHA512 hash and slice in half
     *
     * @returns half of a SHA512 hash
     */
    finish256() {
      return t.Buffer.from(this.hash.digest().slice(0, 32));
    }
    /**
     * Constructs a Hash256 from the Sha512Half object
     *
     * @returns a Hash256 object
     */
    finish() {
      return new u.Hash256(this.finish256());
    }
  }
  hashes.Sha512Half = l;
  function m(...k) {
    const C = new l();
    return k.forEach((B) => C.put(B)), C.finish256();
  }
  hashes.sha512Half = m;
  function b(k) {
    return new u.Hash256(m(s.HashPrefix.transactionID, k));
  }
  return hashes.transactionID = b, hashes;
}
var hasRequiredBinary;
function requireBinary() {
  return hasRequiredBinary || (hasRequiredBinary = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.transactionID = s.sha512Half = s.binaryToJSON = s.signingClaimData = s.signingData = s.multiSigningData = s.readJSON = s.serializeObject = s.makeParser = s.BytesList = s.BinarySerializer = s.BinaryParser = void 0;
    const A = requireTypes$3(), u = requireBinaryParser();
    Object.defineProperty(s, "BinaryParser", { enumerable: !0, get: function() {
      return u.BinaryParser;
    } });
    const p = requireHashPrefixes(), t = requireBinarySerializer();
    Object.defineProperty(s, "BinarySerializer", { enumerable: !0, get: function() {
      return t.BinarySerializer;
    } }), Object.defineProperty(s, "BytesList", { enumerable: !0, get: function() {
      return t.BytesList;
    } });
    const l = requireHashes();
    Object.defineProperty(s, "sha512Half", { enumerable: !0, get: function() {
      return l.sha512Half;
    } }), Object.defineProperty(s, "transactionID", { enumerable: !0, get: function() {
      return l.transactionID;
    } });
    const m = requireEnums(), b = requireBigInteger(), k = (F, le) => new u.BinaryParser(F, le);
    s.makeParser = k;
    const C = (F, le = m.DEFAULT_DEFINITIONS) => F.readType(A.coreTypes.STObject).toJSON(le);
    s.readJSON = C;
    const B = (F, le) => C(k(F, le), le);
    s.binaryToJSON = B;
    function Q(F, le = {}) {
      const { prefix: ge, suffix: pe, signingFieldsOnly: Ie = !1, definitions: be } = le, Pe = new t.BytesList();
      ge && Pe.put(ge);
      const Te = Ie ? (Qe) => Qe.isSigningField : void 0;
      return A.coreTypes.STObject.from(F, Te, be).toBytesSink(Pe), pe && Pe.put(pe), Pe.toBytes();
    }
    s.serializeObject = Q;
    function P(F, le = p.HashPrefix.transactionSig, ge = {}) {
      return Q(F, {
        prefix: le,
        signingFieldsOnly: !0,
        definitions: ge.definitions
      });
    }
    s.signingData = P;
    function x(F) {
      const le = b(String(F.amount)), ge = p.HashPrefix.paymentChannelClaim, pe = A.coreTypes.Hash256.from(F.channel).toBytes(), Ie = A.coreTypes.UInt64.from(le).toBytes(), be = new t.BytesList();
      return be.put(ge), be.put(pe), be.put(Ie), be.toBytes();
    }
    s.signingClaimData = x;
    function M(F, le, ge = {
      definitions: m.DEFAULT_DEFINITIONS
    }) {
      const pe = p.HashPrefix.transactionMultiSig, Ie = A.coreTypes.AccountID.from(le).toBytes();
      return Q(F, {
        prefix: pe,
        suffix: Ie,
        signingFieldsOnly: !0,
        definitions: ge.definitions
      });
    }
    s.multiSigningData = M;
  }(binary)), binary;
}
var shamap = {}, hasRequiredShamap;
function requireShamap() {
  if (hasRequiredShamap) return shamap;
  hasRequiredShamap = 1, Object.defineProperty(shamap, "__esModule", { value: !0 }), shamap.ShaMapLeaf = shamap.ShaMapNode = shamap.ShaMap = void 0;
  const s = requireAssert$2(), A = requireTypes$3(), u = requireHashPrefixes(), p = requireHashes(), t = requireDist$n();
  class l {
  }
  shamap.ShaMapNode = l;
  class m extends l {
    constructor(B, Q) {
      super(), this.index = B, this.item = Q;
    }
    /**
     * @returns true as ShaMapLeaf is a leaf node
     */
    isLeaf() {
      return !0;
    }
    /**
     * @returns false as ShaMapLeaf is not an inner node
     */
    isInner() {
      return !1;
    }
    /**
     * Get the prefix of the this.item
     *
     * @returns The hash prefix, unless this.item is undefined, then it returns an empty Buffer
     */
    hashPrefix() {
      return this.item === void 0 ? t.Buffer.alloc(0) : this.item.hashPrefix();
    }
    /**
     * Hash the bytes representation of this
     *
     * @returns hash of this.item concatenated with this.index
     */
    hash() {
      const B = p.Sha512Half.put(this.hashPrefix());
      return this.toBytesSink(B), B.finish();
    }
    /**
     * Write the bytes representation of this to a BytesList
     * @param list BytesList to write bytes to
     */
    toBytesSink(B) {
      this.item !== void 0 && this.item.toBytesSink(B), this.index.toBytesSink(B);
    }
  }
  shamap.ShaMapLeaf = m;
  class b extends l {
    constructor(B = 0) {
      super(), this.depth = B, this.slotBits = 0, this.branches = Array(16);
    }
    /**
     * @returns true as ShaMapInner is an inner node
     */
    isInner() {
      return !0;
    }
    /**
     * @returns false as ShaMapInner is not a leaf node
     */
    isLeaf() {
      return !1;
    }
    /**
     * Get the hash prefix for this node
     *
     * @returns hash prefix describing an inner node
     */
    hashPrefix() {
      return u.HashPrefix.innerNode;
    }
    /**
     * Set a branch of this node to be another node
     *
     * @param slot Slot to add branch to this.branches
     * @param branch Branch to add
     */
    setBranch(B, Q) {
      this.slotBits = this.slotBits | 1 << B, this.branches[B] = Q;
    }
    /**
     * @returns true if node is empty
     */
    empty() {
      return this.slotBits === 0;
    }
    /**
     * Compute the hash of this node
     *
     * @returns The hash of this node
     */
    hash() {
      if (this.empty())
        return A.coreTypes.Hash256.ZERO_256;
      const B = p.Sha512Half.put(this.hashPrefix());
      return this.toBytesSink(B), B.finish();
    }
    /**
     * Writes the bytes representation of this node to a BytesList
     *
     * @param list BytesList to write bytes to
     */
    toBytesSink(B) {
      for (let Q = 0; Q < this.branches.length; Q++) {
        const P = this.branches[Q];
        (P ? P.hash() : A.coreTypes.Hash256.ZERO_256).toBytesSink(B);
      }
    }
    /**
     * Add item to the SHAMap
     *
     * @param index Hash of the index of the item being inserted
     * @param item Item to insert in the map
     * @param leaf Leaf node to insert when branch doesn't exist
     */
    addItem(B, Q, P) {
      if (s.strict.ok(B !== void 0), B !== void 0) {
        const x = B.nibblet(this.depth), M = this.branches[x];
        if (M === void 0)
          this.setBranch(x, P || new m(B, Q));
        else if (M instanceof m) {
          const F = new b(this.depth + 1);
          F.addItem(M.index, void 0, M), F.addItem(B, Q, P), this.setBranch(x, F);
        } else if (M instanceof b)
          M.addItem(B, Q, P);
        else
          throw new Error("invalid ShaMap.addItem call");
      }
    }
  }
  class k extends b {
  }
  return shamap.ShaMap = k, shamap;
}
var ledgerHashes = {}, hasRequiredLedgerHashes;
function requireLedgerHashes() {
  if (hasRequiredLedgerHashes) return ledgerHashes;
  hasRequiredLedgerHashes = 1;
  var s = ledgerHashes && ledgerHashes.__createBinding || (Object.create ? function(Te, Qe, xe, Ee) {
    Ee === void 0 && (Ee = xe);
    var He = Object.getOwnPropertyDescriptor(Qe, xe);
    (!He || ("get" in He ? !Qe.__esModule : He.writable || He.configurable)) && (He = { enumerable: !0, get: function() {
      return Qe[xe];
    } }), Object.defineProperty(Te, Ee, He);
  } : function(Te, Qe, xe, Ee) {
    Ee === void 0 && (Ee = xe), Te[Ee] = Qe[xe];
  }), A = ledgerHashes && ledgerHashes.__setModuleDefault || (Object.create ? function(Te, Qe) {
    Object.defineProperty(Te, "default", { enumerable: !0, value: Qe });
  } : function(Te, Qe) {
    Te.default = Qe;
  }), u = ledgerHashes && ledgerHashes.__importStar || function(Te) {
    if (Te && Te.__esModule) return Te;
    var Qe = {};
    if (Te != null) for (var xe in Te) xe !== "default" && Object.prototype.hasOwnProperty.call(Te, xe) && s(Qe, Te, xe);
    return A(Qe, Te), Qe;
  };
  Object.defineProperty(ledgerHashes, "__esModule", { value: !0 }), ledgerHashes.decodeLedgerData = ledgerHashes.ledgerHash = ledgerHashes.transactionTreeHash = ledgerHashes.accountStateHash = void 0;
  const p = u(requireAssert$2()), t = requireShamap(), l = requireHashPrefixes(), m = requireHashes(), b = requireBinary(), k = requireHash256(), C = requireStObject(), B = requireUint64(), Q = requireUint32(), P = requireUint8(), x = requireBinaryParser(), M = requireBigInteger();
  function F(Te, Qe) {
    const xe = new t.ShaMap();
    return Qe.forEach((Ee) => xe.addItem(...Te(Ee))), xe.hash();
  }
  function le(Te) {
    return p.ok(Te.hash), [k.Hash256.from(Te.hash), {
      hashPrefix() {
        return l.HashPrefix.transaction;
      },
      toBytesSink(Ee) {
        const He = new b.BinarySerializer(Ee);
        He.writeLengthEncoded(C.STObject.from(Te)), He.writeLengthEncoded(C.STObject.from(Te.metaData));
      }
    }, void 0];
  }
  function ge(Te) {
    const Qe = k.Hash256.from(Te.index), xe = (0, b.serializeObject)(Te);
    return [Qe, {
      hashPrefix() {
        return l.HashPrefix.accountStateEntry;
      },
      toBytesSink(He) {
        He.put(xe);
      }
    }, void 0];
  }
  function pe(Te) {
    return F(le, Te);
  }
  ledgerHashes.transactionTreeHash = pe;
  function Ie(Te) {
    return F(ge, Te);
  }
  ledgerHashes.accountStateHash = Ie;
  function be(Te) {
    const Qe = new m.Sha512Half();
    return Qe.put(l.HashPrefix.ledgerHeader), p.ok(Te.parent_close_time !== void 0), p.ok(Te.close_flags !== void 0), Q.UInt32.from(Te.ledger_index).toBytesSink(Qe), B.UInt64.from(M(String(Te.total_coins))).toBytesSink(Qe), k.Hash256.from(Te.parent_hash).toBytesSink(Qe), k.Hash256.from(Te.transaction_hash).toBytesSink(Qe), k.Hash256.from(Te.account_hash).toBytesSink(Qe), Q.UInt32.from(Te.parent_close_time).toBytesSink(Qe), Q.UInt32.from(Te.close_time).toBytesSink(Qe), P.UInt8.from(Te.close_time_resolution).toBytesSink(Qe), P.UInt8.from(Te.close_flags).toBytesSink(Qe), Qe.finish();
  }
  ledgerHashes.ledgerHash = be;
  function Pe(Te, Qe) {
    p.ok(typeof Te == "string", "binary must be a hex string");
    const xe = new x.BinaryParser(Te, Qe);
    return {
      ledger_index: xe.readUInt32(),
      total_coins: xe.readType(B.UInt64).valueOf().toString(),
      parent_hash: xe.readType(k.Hash256).toHex(),
      transaction_hash: xe.readType(k.Hash256).toHex(),
      account_hash: xe.readType(k.Hash256).toHex(),
      parent_close_time: xe.readUInt32(),
      close_time: xe.readUInt32(),
      close_time_resolution: xe.readUInt8(),
      close_flags: xe.readUInt8()
    };
  }
  return ledgerHashes.decodeLedgerData = Pe, ledgerHashes;
}
var quality = {}, hasRequiredQuality;
function requireQuality() {
  if (hasRequiredQuality) return quality;
  hasRequiredQuality = 1, Object.defineProperty(quality, "__esModule", { value: !0 }), quality.quality = void 0;
  const s = requireTypes$3(), A = requireDecimal$1(), u = requireBigInteger(), p = requireDist$n();
  let t = class {
    /**
     * Encode quality amount
     *
     * @param arg string representation of an amount
     * @returns Serialized quality
     */
    static encode(m) {
      const b = new A.Decimal(m), k = b.e - 15, C = b.times(`1e${-k}`).abs().toString(), B = s.coreTypes.UInt64.from(u(C)).toBytes();
      return B[0] = k + 100, B;
    }
    /**
     * Decode quality amount
     *
     * @param arg hex-string denoting serialized quality
     * @returns deserialized quality
     */
    static decode(m) {
      const b = p.Buffer.from(m, "hex").slice(-8), k = b[0] - 100;
      return new A.Decimal(`0x${b.slice(1).toString("hex")}`).times(`1e${k}`);
    }
  };
  return quality.quality = t, quality;
}
var hasRequiredCoretypes;
function requireCoretypes() {
  return hasRequiredCoretypes || (hasRequiredCoretypes = 1, function(s) {
    var A = coretypes && coretypes.__createBinding || (Object.create ? function(P, x, M, F) {
      F === void 0 && (F = M);
      var le = Object.getOwnPropertyDescriptor(x, M);
      (!le || ("get" in le ? !x.__esModule : le.writable || le.configurable)) && (le = { enumerable: !0, get: function() {
        return x[M];
      } }), Object.defineProperty(P, F, le);
    } : function(P, x, M, F) {
      F === void 0 && (F = M), P[F] = x[M];
    }), u = coretypes && coretypes.__setModuleDefault || (Object.create ? function(P, x) {
      Object.defineProperty(P, "default", { enumerable: !0, value: x });
    } : function(P, x) {
      P.default = x;
    }), p = coretypes && coretypes.__importStar || function(P) {
      if (P && P.__esModule) return P;
      var x = {};
      if (P != null) for (var M in P) M !== "default" && Object.prototype.hasOwnProperty.call(P, M) && A(x, P, M);
      return u(x, P), x;
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), s.types = s.ShaMap = s.HashPrefix = s.quality = s.TransactionResult = s.Type = s.LedgerEntryType = s.TransactionType = s.Field = s.DEFAULT_DEFINITIONS = s.ledgerHashes = s.binary = s.hashes = void 0;
    const t = requireEnums();
    Object.defineProperty(s, "DEFAULT_DEFINITIONS", { enumerable: !0, get: function() {
      return t.DEFAULT_DEFINITIONS;
    } }), Object.defineProperty(s, "Field", { enumerable: !0, get: function() {
      return t.Field;
    } }), Object.defineProperty(s, "TransactionType", { enumerable: !0, get: function() {
      return t.TransactionType;
    } }), Object.defineProperty(s, "LedgerEntryType", { enumerable: !0, get: function() {
      return t.LedgerEntryType;
    } }), Object.defineProperty(s, "Type", { enumerable: !0, get: function() {
      return t.Type;
    } }), Object.defineProperty(s, "TransactionResult", { enumerable: !0, get: function() {
      return t.TransactionResult;
    } });
    const l = p(requireTypes$3());
    s.types = l;
    const m = p(requireBinary());
    s.binary = m;
    const b = requireShamap();
    Object.defineProperty(s, "ShaMap", { enumerable: !0, get: function() {
      return b.ShaMap;
    } });
    const k = p(requireLedgerHashes());
    s.ledgerHashes = k;
    const C = p(requireHashes());
    s.hashes = C;
    const B = requireQuality();
    Object.defineProperty(s, "quality", { enumerable: !0, get: function() {
      return B.quality;
    } });
    const Q = requireHashPrefixes();
    Object.defineProperty(s, "HashPrefix", { enumerable: !0, get: function() {
      return Q.HashPrefix;
    } });
  }(coretypes)), coretypes;
}
var xrplDefinitions = {}, hasRequiredXrplDefinitions;
function requireXrplDefinitions() {
  if (hasRequiredXrplDefinitions) return xrplDefinitions;
  hasRequiredXrplDefinitions = 1, Object.defineProperty(xrplDefinitions, "__esModule", { value: !0 }), xrplDefinitions.XrplDefinitions = void 0;
  const s = requireXrplDefinitionsBase(), A = requireTypes$3();
  class u extends s.XrplDefinitionsBase {
    /**
     * Present rippled types in a typed and updatable format.
     * For an example of the input format see `definitions.json`
     * To generate a new definitions file from rippled source code, use this tool: https://github.com/RichardAH/xrpl-codec-gen
     *
     * See the definitions.test.js file for examples of how to create your own updated definitions.json.
     *
     * @param enums - A json encoding of the core types, transaction types, transaction results, transaction names, and fields.
     * @param additionalTypes - A list of SerializedType objects with the same name as the fields defined.
     *              These types will be included in addition to the coreTypes used on mainnet.
     */
    constructor(t, l) {
      const m = Object.assign({}, A.coreTypes, l);
      super(t, m);
    }
  }
  return xrplDefinitions.XrplDefinitions = u, xrplDefinitions;
}
var hasRequiredDist$3;
function requireDist$3() {
  return hasRequiredDist$3 || (hasRequiredDist$3 = 1, function(s) {
    var A = dist$3 && dist$3.__createBinding || (Object.create ? function(Te, Qe, xe, Ee) {
      Ee === void 0 && (Ee = xe);
      var He = Object.getOwnPropertyDescriptor(Qe, xe);
      (!He || ("get" in He ? !Qe.__esModule : He.writable || He.configurable)) && (He = { enumerable: !0, get: function() {
        return Qe[xe];
      } }), Object.defineProperty(Te, Ee, He);
    } : function(Te, Qe, xe, Ee) {
      Ee === void 0 && (Ee = xe), Te[Ee] = Qe[xe];
    }), u = dist$3 && dist$3.__setModuleDefault || (Object.create ? function(Te, Qe) {
      Object.defineProperty(Te, "default", { enumerable: !0, value: Qe });
    } : function(Te, Qe) {
      Te.default = Qe;
    }), p = dist$3 && dist$3.__importStar || function(Te) {
      if (Te && Te.__esModule) return Te;
      var Qe = {};
      if (Te != null) for (var xe in Te) xe !== "default" && Object.prototype.hasOwnProperty.call(Te, xe) && A(Qe, Te, xe);
      return u(Qe, Te), Qe;
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), s.coreTypes = s.DEFAULT_DEFINITIONS = s.XrplDefinitionsBase = s.XrplDefinitions = s.TRANSACTION_TYPES = s.decodeLedgerData = s.decodeQuality = s.encodeQuality = s.encodeForMultisigning = s.encodeForSigningClaim = s.encodeForSigning = s.encode = s.decode = void 0;
    const t = p(requireAssert$2()), l = requireCoretypes(), m = requireLedgerHashes();
    Object.defineProperty(s, "decodeLedgerData", { enumerable: !0, get: function() {
      return m.decodeLedgerData;
    } });
    const b = requireEnums();
    Object.defineProperty(s, "XrplDefinitionsBase", { enumerable: !0, get: function() {
      return b.XrplDefinitionsBase;
    } }), Object.defineProperty(s, "TRANSACTION_TYPES", { enumerable: !0, get: function() {
      return b.TRANSACTION_TYPES;
    } }), Object.defineProperty(s, "DEFAULT_DEFINITIONS", { enumerable: !0, get: function() {
      return b.DEFAULT_DEFINITIONS;
    } });
    const k = requireXrplDefinitions();
    Object.defineProperty(s, "XrplDefinitions", { enumerable: !0, get: function() {
      return k.XrplDefinitions;
    } });
    const C = requireTypes$3();
    Object.defineProperty(s, "coreTypes", { enumerable: !0, get: function() {
      return C.coreTypes;
    } });
    const { signingData: B, signingClaimData: Q, multiSigningData: P, binaryToJSON: x, serializeObject: M } = l.binary;
    function F(Te, Qe) {
      return t.ok(typeof Te == "string", "binary must be a hex string"), x(Te, Qe);
    }
    s.decode = F;
    function le(Te, Qe) {
      return t.ok(typeof Te == "object"), M(Te, { definitions: Qe }).toString("hex").toUpperCase();
    }
    s.encode = le;
    function ge(Te, Qe) {
      return t.ok(typeof Te == "object"), B(Te, l.HashPrefix.transactionSig, {
        definitions: Qe
      }).toString("hex").toUpperCase();
    }
    s.encodeForSigning = ge;
    function pe(Te) {
      return t.ok(typeof Te == "object"), Q(Te).toString("hex").toUpperCase();
    }
    s.encodeForSigningClaim = pe;
    function Ie(Te, Qe, xe) {
      return t.ok(typeof Te == "object"), t.equal(Te.SigningPubKey, ""), P(Te, Qe, xe ? { definitions: xe } : void 0).toString("hex").toUpperCase();
    }
    s.encodeForMultisigning = Ie;
    function be(Te) {
      return t.ok(typeof Te == "string"), l.quality.encode(Te).toString("hex").toUpperCase();
    }
    s.encodeQuality = be;
    function Pe(Te) {
      return t.ok(typeof Te == "string"), l.quality.decode(Te).toString();
    }
    s.decodeQuality = Pe;
  }(dist$3)), dist$3;
}
var hasRequiredXrp$1;
function requireXrp$1() {
  if (hasRequiredXrp$1) return xrp;
  hasRequiredXrp$1 = 1, Object.defineProperty(xrp, "__esModule", { value: !0 }), xrp.KeystoneXrpSDK = void 0;
  const s = requireDist$k(), A = requireDist$3();
  class u {
    parseAccount(t) {
      const l = t.decodeCBOR().toString();
      return JSON.parse(l);
    }
    parseSignature(t) {
      if (t.type !== "bytes")
        throw new Error("type not match");
      try {
        const l = t.decodeCBOR().toString("hex");
        return (0, A.decode)(l).TxnSignature;
      } catch {
        throw new Error("signature is invalid");
      }
    }
    generateSignRequest(t) {
      const l = JSON.stringify(t);
      return s.UR.fromBuffer(Buffer.from(l));
    }
  }
  return xrp.KeystoneXrpSDK = u, xrp;
}
var hasRequiredXrp;
function requireXrp() {
  return hasRequiredXrp || (hasRequiredXrp = 1, function(s) {
    var A = xrp$1 && xrp$1.__createBinding || (Object.create ? function(p, t, l, m) {
      m === void 0 && (m = l);
      var b = Object.getOwnPropertyDescriptor(t, l);
      (!b || ("get" in b ? !t.__esModule : b.writable || b.configurable)) && (b = { enumerable: !0, get: function() {
        return t[l];
      } }), Object.defineProperty(p, m, b);
    } : function(p, t, l, m) {
      m === void 0 && (m = l), p[m] = t[l];
    }), u = xrp$1 && xrp$1.__exportStar || function(p, t) {
      for (var l in p) l !== "default" && !Object.prototype.hasOwnProperty.call(t, l) && A(t, p, l);
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), u(requireXrp$1(), s);
  }(xrp$1)), xrp$1;
}
var hasRequiredSdk;
function requireSdk() {
  if (hasRequiredSdk) return sdk;
  hasRequiredSdk = 1;
  var s = sdk && sdk.__awaiter || function(m, b, k, C) {
    function B(Q) {
      return Q instanceof k ? Q : new k(function(P) {
        P(Q);
      });
    }
    return new (k || (k = Promise))(function(Q, P) {
      function x(le) {
        try {
          F(C.next(le));
        } catch (ge) {
          P(ge);
        }
      }
      function M(le) {
        try {
          F(C.throw(le));
        } catch (ge) {
          P(ge);
        }
      }
      function F(le) {
        le.done ? Q(le.value) : B(le.value).then(x, M);
      }
      F((C = C.apply(m, b || [])).next());
    });
  };
  Object.defineProperty(sdk, "__esModule", { value: !0 }), sdk.KeystoneSDK = void 0;
  const A = requireChains(), u = requireWallet$1(), p = requireXrp(), t = "https://keyst.one/statics/sdk/config.json";
  class l {
    constructor(b) {
      this.parseMultiAccounts = u.parseMultiAccounts, this.parseTonAccount = u.parseTonAccount, this.parseHDKey = u.parseHDKey, this.parseAccount = u.parseAccount, this.generateKeyDerivationCall = u.generateKeyDerivationCall, this.config = b;
    }
    static create(b) {
      return s(this, void 0, void 0, function* () {
        try {
          const C = yield (yield fetch(t)).json();
          return new l(Object.assign(Object.assign({}, b), C));
        } catch (k) {
          return console.error("fetch config error", k), new l(b);
        }
      });
    }
    get btc() {
      return this._btc === void 0 && (this._btc = new A.KeystoneBitcoinSDK()), this._btc;
    }
    get eth() {
      return this._eth === void 0 && (this._eth = new A.KeystoneEthereumSDK(this.config)), this._eth;
    }
    get sol() {
      return this._sol === void 0 && (this._sol = new A.KeystoneSolanaSDK()), this._sol;
    }
    get stellar() {
      return this._stellar === void 0 && (this._stellar = new A.KeystoneStellarSDK()), this._stellar;
    }
    get cosmos() {
      return this._cosmos === void 0 && (this._cosmos = new A.KeystoneCosmosSDK(this.config)), this._cosmos;
    }
    get evm() {
      return this._evm === void 0 && (this._evm = new A.KeystoneEvmSDK(this.config)), this._evm;
    }
    get tron() {
      return this._tron === void 0 && (this._tron = new A.KeystoneTronSDK()), this._tron;
    }
    get ltc() {
      return this._ltc === void 0 && (this._ltc = new A.KeystoneLitecoinSDK()), this._ltc;
    }
    get bch() {
      return this._bch === void 0 && (this._bch = new A.KeystoneBitcoinCashSDK()), this._bch;
    }
    get dash() {
      return this._dash === void 0 && (this._dash = new A.KeystoneDashSDK()), this._dash;
    }
    get aptos() {
      return this._aptos === void 0 && (this._aptos = new A.KeystoneAptosSDK()), this._aptos;
    }
    get near() {
      return this._near === void 0 && (this._near = new A.KeystoneNearSDK()), this._near;
    }
    get arweave() {
      return this._arweave === void 0 && (this._arweave = new A.KeystoneArweaveSDK()), this._arweave;
    }
    get sui() {
      return this._sui === void 0 && (this._sui = new A.KeystoneSuiSDK(this.config)), this._sui;
    }
    get cardano() {
      return this._cardano === void 0 && (this._cardano = new A.KeystoneCardanoSDK()), this._cardano;
    }
    get xrp() {
      return this._xrp === void 0 && (this._xrp = new p.KeystoneXrpSDK()), this._xrp;
    }
    get ton() {
      return this._ton === void 0 && (this._ton = new A.KeystoneTonSDK(this.config)), this._ton;
    }
  }
  return l.parseMultiAccounts = u.parseMultiAccounts, l.parseHDKey = u.parseHDKey, l.generateKeyDerivationCall = u.generateKeyDerivationCall, sdk.KeystoneSDK = l, sdk;
}
var hasRequiredDist$2;
function requireDist$2() {
  return hasRequiredDist$2 || (hasRequiredDist$2 = 1, function(s) {
    var A = dist$k && dist$k.__createBinding || (Object.create ? function(C, B, Q, P) {
      P === void 0 && (P = Q);
      var x = Object.getOwnPropertyDescriptor(B, Q);
      (!x || ("get" in x ? !B.__esModule : x.writable || x.configurable)) && (x = { enumerable: !0, get: function() {
        return B[Q];
      } }), Object.defineProperty(C, P, x);
    } : function(C, B, Q, P) {
      P === void 0 && (P = Q), C[P] = B[Q];
    }), u = dist$k && dist$k.__setModuleDefault || (Object.create ? function(C, B) {
      Object.defineProperty(C, "default", { enumerable: !0, value: B });
    } : function(C, B) {
      C.default = B;
    }), p = dist$k && dist$k.__importStar || function(C) {
      if (C && C.__esModule) return C;
      var B = {};
      if (C != null) for (var Q in C) Q !== "default" && Object.prototype.hasOwnProperty.call(C, Q) && A(B, C, Q);
      return u(B, C), B;
    }, t = dist$k && dist$k.__exportStar || function(C, B) {
      for (var Q in C) Q !== "default" && !Object.prototype.hasOwnProperty.call(B, Q) && A(B, C, Q);
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), s.utils = s.KeystoneSDK = s.QRHardwareCallVersion = s.DerivationAlgorithm = s.Curve = void 0;
    const l = p(requireUtils$d());
    s.utils = l;
    const m = requireSdk();
    Object.defineProperty(s, "KeystoneSDK", { enumerable: !0, get: function() {
      return m.KeystoneSDK;
    } }), t(requireDist$k(), s), t(requireTypes$4(), s), t(requireChains(), s);
    var b = requireHardwareCall();
    Object.defineProperty(s, "Curve", { enumerable: !0, get: function() {
      return b.Curve;
    } }), Object.defineProperty(s, "DerivationAlgorithm", { enumerable: !0, get: function() {
      return b.DerivationAlgorithm;
    } });
    var k = requireDist$j();
    Object.defineProperty(s, "QRHardwareCallVersion", { enumerable: !0, get: function() {
      return k.QRHardwareCallVersion;
    } }), s.default = m.KeystoneSDK;
  }(dist$k)), dist$k;
}
var distExports = requireDist$2();
const q = /* @__PURE__ */ getDefaultExportFromCjs(distExports);
function number(s) {
  if (!Number.isSafeInteger(s) || s < 0)
    throw new Error(`positive integer expected, not ${s}`);
}
function isBytes$6(s) {
  return s instanceof Uint8Array || s != null && typeof s == "object" && s.constructor.name === "Uint8Array";
}
function bytes(s, ...A) {
  if (!isBytes$6(s))
    throw new Error("Uint8Array expected");
  if (A.length > 0 && !A.includes(s.length))
    throw new Error(`Uint8Array expected of length ${A}, not of length=${s.length}`);
}
function hash$n(s) {
  if (typeof s != "function" || typeof s.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  number(s.outputLen), number(s.blockLen);
}
function exists(s, A = !0) {
  if (s.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (A && s.finished)
    throw new Error("Hash#digest() has already been called");
}
function output(s, A) {
  bytes(s);
  const u = A.outputLen;
  if (s.length < u)
    throw new Error(`digestInto() expects output buffer of length at least ${u}`);
}
const crypto$3 = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
const createView$2 = (s) => new DataView(s.buffer, s.byteOffset, s.byteLength), rotr$1 = (s, A) => s << 32 - A | s >>> A, rotl$1 = (s, A) => s << A | s >>> 32 - A >>> 0;
new Uint8Array(new Uint32Array([287454020]).buffer)[0];
const hexes$3 = /* @__PURE__ */ Array.from({ length: 256 }, (s, A) => A.toString(16).padStart(2, "0"));
function bytesToHex$3(s) {
  bytes(s);
  let A = "";
  for (let u = 0; u < s.length; u++)
    A += hexes$3[s[u]];
  return A;
}
const asciis$2 = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
function asciiToBase16$2(s) {
  if (s >= asciis$2._0 && s <= asciis$2._9)
    return s - asciis$2._0;
  if (s >= asciis$2._A && s <= asciis$2._F)
    return s - (asciis$2._A - 10);
  if (s >= asciis$2._a && s <= asciis$2._f)
    return s - (asciis$2._a - 10);
}
function hexToBytes$3(s) {
  if (typeof s != "string")
    throw new Error("hex string expected, got " + typeof s);
  const A = s.length, u = A / 2;
  if (A % 2)
    throw new Error("padded hex string expected, got unpadded hex of length " + A);
  const p = new Uint8Array(u);
  for (let t = 0, l = 0; t < u; t++, l += 2) {
    const m = asciiToBase16$2(s.charCodeAt(l)), b = asciiToBase16$2(s.charCodeAt(l + 1));
    if (m === void 0 || b === void 0) {
      const k = s[l] + s[l + 1];
      throw new Error('hex string expected, got non-hex character "' + k + '" at index ' + l);
    }
    p[t] = m * 16 + b;
  }
  return p;
}
function utf8ToBytes$2(s) {
  if (typeof s != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof s}`);
  return new Uint8Array(new TextEncoder().encode(s));
}
function toBytes$2(s) {
  return typeof s == "string" && (s = utf8ToBytes$2(s)), bytes(s), s;
}
function concatBytes$5(...s) {
  let A = 0;
  for (let p = 0; p < s.length; p++) {
    const t = s[p];
    bytes(t), A += t.length;
  }
  const u = new Uint8Array(A);
  for (let p = 0, t = 0; p < s.length; p++) {
    const l = s[p];
    u.set(l, t), t += l.length;
  }
  return u;
}
let Hash$1 = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function wrapConstructor(s) {
  const A = (p) => s().update(toBytes$2(p)).digest(), u = s();
  return A.outputLen = u.outputLen, A.blockLen = u.blockLen, A.create = () => s(), A;
}
function randomBytes$1(s = 32) {
  if (crypto$3 && typeof crypto$3.getRandomValues == "function")
    return crypto$3.getRandomValues(new Uint8Array(s));
  throw new Error("crypto.getRandomValues must be defined");
}
let HMAC$1 = class extends Hash$1 {
  constructor(A, u) {
    super(), this.finished = !1, this.destroyed = !1, hash$n(A);
    const p = toBytes$2(u);
    if (this.iHash = A.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const t = this.blockLen, l = new Uint8Array(t);
    l.set(p.length > t ? A.create().update(p).digest() : p);
    for (let m = 0; m < l.length; m++)
      l[m] ^= 54;
    this.iHash.update(l), this.oHash = A.create();
    for (let m = 0; m < l.length; m++)
      l[m] ^= 106;
    this.oHash.update(l), l.fill(0);
  }
  update(A) {
    return exists(this), this.iHash.update(A), this;
  }
  digestInto(A) {
    exists(this), bytes(A, this.outputLen), this.finished = !0, this.iHash.digestInto(A), this.oHash.update(A), this.oHash.digestInto(A), this.destroy();
  }
  digest() {
    const A = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(A), A;
  }
  _cloneInto(A) {
    A || (A = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: u, iHash: p, finished: t, destroyed: l, blockLen: m, outputLen: b } = this;
    return A = A, A.finished = t, A.destroyed = l, A.blockLen = m, A.outputLen = b, A.oHash = u._cloneInto(A.oHash), A.iHash = p._cloneInto(A.iHash), A;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
};
const hmac$2 = (s, A, u) => new HMAC$1(s, A).update(u).digest();
hmac$2.create = (s, A) => new HMAC$1(s, A);
function setBigUint64$1(s, A, u, p) {
  if (typeof s.setBigUint64 == "function")
    return s.setBigUint64(A, u, p);
  const t = BigInt(32), l = BigInt(4294967295), m = Number(u >> t & l), b = Number(u & l), k = p ? 4 : 0, C = p ? 0 : 4;
  s.setUint32(A + k, m, p), s.setUint32(A + C, b, p);
}
const Chi$1 = (s, A, u) => s & A ^ ~s & u, Maj$1 = (s, A, u) => s & A ^ s & u ^ A & u;
let HashMD$1 = class extends Hash$1 {
  constructor(A, u, p, t) {
    super(), this.blockLen = A, this.outputLen = u, this.padOffset = p, this.isLE = t, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(A), this.view = createView$2(this.buffer);
  }
  update(A) {
    exists(this);
    const { view: u, buffer: p, blockLen: t } = this;
    A = toBytes$2(A);
    const l = A.length;
    for (let m = 0; m < l; ) {
      const b = Math.min(t - this.pos, l - m);
      if (b === t) {
        const k = createView$2(A);
        for (; t <= l - m; m += t)
          this.process(k, m);
        continue;
      }
      p.set(A.subarray(m, m + b), this.pos), this.pos += b, m += b, this.pos === t && (this.process(u, 0), this.pos = 0);
    }
    return this.length += A.length, this.roundClean(), this;
  }
  digestInto(A) {
    exists(this), output(A, this), this.finished = !0;
    const { buffer: u, view: p, blockLen: t, isLE: l } = this;
    let { pos: m } = this;
    u[m++] = 128, this.buffer.subarray(m).fill(0), this.padOffset > t - m && (this.process(p, 0), m = 0);
    for (let Q = m; Q < t; Q++)
      u[Q] = 0;
    setBigUint64$1(p, t - 8, BigInt(this.length * 8), l), this.process(p, 0);
    const b = createView$2(A), k = this.outputLen;
    if (k % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const C = k / 4, B = this.get();
    if (C > B.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let Q = 0; Q < C; Q++)
      b.setUint32(4 * Q, B[Q], l);
  }
  digest() {
    const { buffer: A, outputLen: u } = this;
    this.digestInto(A);
    const p = A.slice(0, u);
    return this.destroy(), p;
  }
  _cloneInto(A) {
    A || (A = new this.constructor()), A.set(...this.get());
    const { blockLen: u, buffer: p, length: t, finished: l, destroyed: m, pos: b } = this;
    return A.length = t, A.pos = b, A.finished = l, A.destroyed = m, t % u && A.buffer.set(p), A;
  }
};
const Rho = /* @__PURE__ */ new Uint8Array([7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8]), Id = /* @__PURE__ */ new Uint8Array(new Array(16).fill(0).map((s, A) => A)), Pi = /* @__PURE__ */ Id.map((s) => (9 * s + 5) % 16);
let idxL$1 = [Id], idxR$1 = [Pi];
for (let s = 0; s < 4; s++)
  for (let A of [idxL$1, idxR$1])
    A.push(A[s].map((u) => Rho[u]));
const shifts = /* @__PURE__ */ [
  [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
  [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
  [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
  [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
  [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
].map((s) => new Uint8Array(s)), shiftsL = /* @__PURE__ */ idxL$1.map((s, A) => s.map((u) => shifts[A][u])), shiftsR = /* @__PURE__ */ idxR$1.map((s, A) => s.map((u) => shifts[A][u])), Kl = /* @__PURE__ */ new Uint32Array([
  0,
  1518500249,
  1859775393,
  2400959708,
  2840853838
]), Kr = /* @__PURE__ */ new Uint32Array([
  1352829926,
  1548603684,
  1836072691,
  2053994217,
  0
]);
function f(s, A, u, p) {
  return s === 0 ? A ^ u ^ p : s === 1 ? A & u | ~A & p : s === 2 ? (A | ~u) ^ p : s === 3 ? A & p | u & ~p : A ^ (u | ~p);
}
const R_BUF = /* @__PURE__ */ new Uint32Array(16);
let RIPEMD160$1 = class extends HashMD$1 {
  constructor() {
    super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
  }
  get() {
    const { h0: A, h1: u, h2: p, h3: t, h4: l } = this;
    return [A, u, p, t, l];
  }
  set(A, u, p, t, l) {
    this.h0 = A | 0, this.h1 = u | 0, this.h2 = p | 0, this.h3 = t | 0, this.h4 = l | 0;
  }
  process(A, u) {
    for (let x = 0; x < 16; x++, u += 4)
      R_BUF[x] = A.getUint32(u, !0);
    let p = this.h0 | 0, t = p, l = this.h1 | 0, m = l, b = this.h2 | 0, k = b, C = this.h3 | 0, B = C, Q = this.h4 | 0, P = Q;
    for (let x = 0; x < 5; x++) {
      const M = 4 - x, F = Kl[x], le = Kr[x], ge = idxL$1[x], pe = idxR$1[x], Ie = shiftsL[x], be = shiftsR[x];
      for (let Pe = 0; Pe < 16; Pe++) {
        const Te = rotl$1(p + f(x, l, b, C) + R_BUF[ge[Pe]] + F, Ie[Pe]) + Q | 0;
        p = Q, Q = C, C = rotl$1(b, 10) | 0, b = l, l = Te;
      }
      for (let Pe = 0; Pe < 16; Pe++) {
        const Te = rotl$1(t + f(M, m, k, B) + R_BUF[pe[Pe]] + le, be[Pe]) + P | 0;
        t = P, P = B, B = rotl$1(k, 10) | 0, k = m, m = Te;
      }
    }
    this.set(this.h1 + b + B | 0, this.h2 + C + P | 0, this.h3 + Q + t | 0, this.h4 + p + m | 0, this.h0 + l + k | 0);
  }
  roundClean() {
    R_BUF.fill(0);
  }
  destroy() {
    this.destroyed = !0, this.buffer.fill(0), this.set(0, 0, 0, 0, 0);
  }
};
const ripemd160$2 = /* @__PURE__ */ wrapConstructor(() => new RIPEMD160$1()), SHA256_K$1 = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), SHA256_IV$1 = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), SHA256_W$1 = /* @__PURE__ */ new Uint32Array(64);
let SHA256$1 = class extends HashMD$1 {
  constructor() {
    super(64, 32, 8, !1), this.A = SHA256_IV$1[0] | 0, this.B = SHA256_IV$1[1] | 0, this.C = SHA256_IV$1[2] | 0, this.D = SHA256_IV$1[3] | 0, this.E = SHA256_IV$1[4] | 0, this.F = SHA256_IV$1[5] | 0, this.G = SHA256_IV$1[6] | 0, this.H = SHA256_IV$1[7] | 0;
  }
  get() {
    const { A, B: u, C: p, D: t, E: l, F: m, G: b, H: k } = this;
    return [A, u, p, t, l, m, b, k];
  }
  // prettier-ignore
  set(A, u, p, t, l, m, b, k) {
    this.A = A | 0, this.B = u | 0, this.C = p | 0, this.D = t | 0, this.E = l | 0, this.F = m | 0, this.G = b | 0, this.H = k | 0;
  }
  process(A, u) {
    for (let Q = 0; Q < 16; Q++, u += 4)
      SHA256_W$1[Q] = A.getUint32(u, !1);
    for (let Q = 16; Q < 64; Q++) {
      const P = SHA256_W$1[Q - 15], x = SHA256_W$1[Q - 2], M = rotr$1(P, 7) ^ rotr$1(P, 18) ^ P >>> 3, F = rotr$1(x, 17) ^ rotr$1(x, 19) ^ x >>> 10;
      SHA256_W$1[Q] = F + SHA256_W$1[Q - 7] + M + SHA256_W$1[Q - 16] | 0;
    }
    let { A: p, B: t, C: l, D: m, E: b, F: k, G: C, H: B } = this;
    for (let Q = 0; Q < 64; Q++) {
      const P = rotr$1(b, 6) ^ rotr$1(b, 11) ^ rotr$1(b, 25), x = B + P + Chi$1(b, k, C) + SHA256_K$1[Q] + SHA256_W$1[Q] | 0, F = (rotr$1(p, 2) ^ rotr$1(p, 13) ^ rotr$1(p, 22)) + Maj$1(p, t, l) | 0;
      B = C, C = k, k = b, b = m + x | 0, m = l, l = t, t = p, p = x + F | 0;
    }
    p = p + this.A | 0, t = t + this.B | 0, l = l + this.C | 0, m = m + this.D | 0, b = b + this.E | 0, k = k + this.F | 0, C = C + this.G | 0, B = B + this.H | 0, this.set(p, t, l, m, b, k, C, B);
  }
  roundClean() {
    SHA256_W$1.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
};
const sha256$5 = /* @__PURE__ */ wrapConstructor(() => new SHA256$1()), U32_MASK64$1 = /* @__PURE__ */ BigInt(2 ** 32 - 1), _32n$1 = /* @__PURE__ */ BigInt(32);
function fromBig$1(s, A = !1) {
  return A ? { h: Number(s & U32_MASK64$1), l: Number(s >> _32n$1 & U32_MASK64$1) } : { h: Number(s >> _32n$1 & U32_MASK64$1) | 0, l: Number(s & U32_MASK64$1) | 0 };
}
function split$1(s, A = !1) {
  let u = new Uint32Array(s.length), p = new Uint32Array(s.length);
  for (let t = 0; t < s.length; t++) {
    const { h: l, l: m } = fromBig$1(s[t], A);
    [u[t], p[t]] = [l, m];
  }
  return [u, p];
}
const toBig = (s, A) => BigInt(s >>> 0) << _32n$1 | BigInt(A >>> 0), shrSH = (s, A, u) => s >>> u, shrSL = (s, A, u) => s << 32 - u | A >>> u, rotrSH = (s, A, u) => s >>> u | A << 32 - u, rotrSL = (s, A, u) => s << 32 - u | A >>> u, rotrBH = (s, A, u) => s << 64 - u | A >>> u - 32, rotrBL = (s, A, u) => s >>> u - 32 | A << 64 - u, rotr32H = (s, A) => A, rotr32L = (s, A) => s, rotlSH$1 = (s, A, u) => s << u | A >>> 32 - u, rotlSL$1 = (s, A, u) => A << u | s >>> 32 - u, rotlBH$1 = (s, A, u) => A << u - 32 | s >>> 64 - u, rotlBL$1 = (s, A, u) => s << u - 32 | A >>> 64 - u;
function add(s, A, u, p) {
  const t = (A >>> 0) + (p >>> 0);
  return { h: s + u + (t / 2 ** 32 | 0) | 0, l: t | 0 };
}
const add3L = (s, A, u) => (s >>> 0) + (A >>> 0) + (u >>> 0), add3H = (s, A, u, p) => A + u + p + (s / 2 ** 32 | 0) | 0, add4L = (s, A, u, p) => (s >>> 0) + (A >>> 0) + (u >>> 0) + (p >>> 0), add4H = (s, A, u, p, t) => A + u + p + t + (s / 2 ** 32 | 0) | 0, add5L = (s, A, u, p, t) => (s >>> 0) + (A >>> 0) + (u >>> 0) + (p >>> 0) + (t >>> 0), add5H = (s, A, u, p, t, l) => A + u + p + t + l + (s / 2 ** 32 | 0) | 0, u64 = {
  fromBig: fromBig$1,
  split: split$1,
  toBig,
  shrSH,
  shrSL,
  rotrSH,
  rotrSL,
  rotrBH,
  rotrBL,
  rotr32H,
  rotr32L,
  rotlSH: rotlSH$1,
  rotlSL: rotlSL$1,
  rotlBH: rotlBH$1,
  rotlBL: rotlBL$1,
  add,
  add3L,
  add3H,
  add4L,
  add4H,
  add5H,
  add5L
}, [SHA512_Kh, SHA512_Kl] = u64.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((s) => BigInt(s))), SHA512_W_H = /* @__PURE__ */ new Uint32Array(80), SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class SHA512 extends HashMD$1 {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: A, Al: u, Bh: p, Bl: t, Ch: l, Cl: m, Dh: b, Dl: k, Eh: C, El: B, Fh: Q, Fl: P, Gh: x, Gl: M, Hh: F, Hl: le } = this;
    return [A, u, p, t, l, m, b, k, C, B, Q, P, x, M, F, le];
  }
  // prettier-ignore
  set(A, u, p, t, l, m, b, k, C, B, Q, P, x, M, F, le) {
    this.Ah = A | 0, this.Al = u | 0, this.Bh = p | 0, this.Bl = t | 0, this.Ch = l | 0, this.Cl = m | 0, this.Dh = b | 0, this.Dl = k | 0, this.Eh = C | 0, this.El = B | 0, this.Fh = Q | 0, this.Fl = P | 0, this.Gh = x | 0, this.Gl = M | 0, this.Hh = F | 0, this.Hl = le | 0;
  }
  process(A, u) {
    for (let Ie = 0; Ie < 16; Ie++, u += 4)
      SHA512_W_H[Ie] = A.getUint32(u), SHA512_W_L[Ie] = A.getUint32(u += 4);
    for (let Ie = 16; Ie < 80; Ie++) {
      const be = SHA512_W_H[Ie - 15] | 0, Pe = SHA512_W_L[Ie - 15] | 0, Te = u64.rotrSH(be, Pe, 1) ^ u64.rotrSH(be, Pe, 8) ^ u64.shrSH(be, Pe, 7), Qe = u64.rotrSL(be, Pe, 1) ^ u64.rotrSL(be, Pe, 8) ^ u64.shrSL(be, Pe, 7), xe = SHA512_W_H[Ie - 2] | 0, Ee = SHA512_W_L[Ie - 2] | 0, He = u64.rotrSH(xe, Ee, 19) ^ u64.rotrBH(xe, Ee, 61) ^ u64.shrSH(xe, Ee, 6), ve = u64.rotrSL(xe, Ee, 19) ^ u64.rotrBL(xe, Ee, 61) ^ u64.shrSL(xe, Ee, 6), we = u64.add4L(Qe, ve, SHA512_W_L[Ie - 7], SHA512_W_L[Ie - 16]), Ce = u64.add4H(we, Te, He, SHA512_W_H[Ie - 7], SHA512_W_H[Ie - 16]);
      SHA512_W_H[Ie] = Ce | 0, SHA512_W_L[Ie] = we | 0;
    }
    let { Ah: p, Al: t, Bh: l, Bl: m, Ch: b, Cl: k, Dh: C, Dl: B, Eh: Q, El: P, Fh: x, Fl: M, Gh: F, Gl: le, Hh: ge, Hl: pe } = this;
    for (let Ie = 0; Ie < 80; Ie++) {
      const be = u64.rotrSH(Q, P, 14) ^ u64.rotrSH(Q, P, 18) ^ u64.rotrBH(Q, P, 41), Pe = u64.rotrSL(Q, P, 14) ^ u64.rotrSL(Q, P, 18) ^ u64.rotrBL(Q, P, 41), Te = Q & x ^ ~Q & F, Qe = P & M ^ ~P & le, xe = u64.add5L(pe, Pe, Qe, SHA512_Kl[Ie], SHA512_W_L[Ie]), Ee = u64.add5H(xe, ge, be, Te, SHA512_Kh[Ie], SHA512_W_H[Ie]), He = xe | 0, ve = u64.rotrSH(p, t, 28) ^ u64.rotrBH(p, t, 34) ^ u64.rotrBH(p, t, 39), we = u64.rotrSL(p, t, 28) ^ u64.rotrBL(p, t, 34) ^ u64.rotrBL(p, t, 39), Ce = p & l ^ p & b ^ l & b, Se = t & m ^ t & k ^ m & k;
      ge = F | 0, pe = le | 0, F = x | 0, le = M | 0, x = Q | 0, M = P | 0, { h: Q, l: P } = u64.add(C | 0, B | 0, Ee | 0, He | 0), C = b | 0, B = k | 0, b = l | 0, k = m | 0, l = p | 0, m = t | 0;
      const Ne = u64.add3L(He, we, Se);
      p = u64.add3H(Ne, Ee, ve, Ce), t = Ne | 0;
    }
    ({ h: p, l: t } = u64.add(this.Ah | 0, this.Al | 0, p | 0, t | 0)), { h: l, l: m } = u64.add(this.Bh | 0, this.Bl | 0, l | 0, m | 0), { h: b, l: k } = u64.add(this.Ch | 0, this.Cl | 0, b | 0, k | 0), { h: C, l: B } = u64.add(this.Dh | 0, this.Dl | 0, C | 0, B | 0), { h: Q, l: P } = u64.add(this.Eh | 0, this.El | 0, Q | 0, P | 0), { h: x, l: M } = u64.add(this.Fh | 0, this.Fl | 0, x | 0, M | 0), { h: F, l: le } = u64.add(this.Gh | 0, this.Gl | 0, F | 0, le | 0), { h: ge, l: pe } = u64.add(this.Hh | 0, this.Hl | 0, ge | 0, pe | 0), this.set(p, t, l, m, b, k, C, B, Q, P, x, M, F, le, ge, pe);
  }
  roundClean() {
    SHA512_W_H.fill(0), SHA512_W_L.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
const sha512$2 = /* @__PURE__ */ wrapConstructor(() => new SHA512());
const _0n$9 = /* @__PURE__ */ BigInt(0), _1n$a = /* @__PURE__ */ BigInt(1), _2n$6 = /* @__PURE__ */ BigInt(2);
function isBytes$5(s) {
  return s instanceof Uint8Array || s != null && typeof s == "object" && s.constructor.name === "Uint8Array";
}
function abytes$2(s) {
  if (!isBytes$5(s))
    throw new Error("Uint8Array expected");
}
const hexes$2 = /* @__PURE__ */ Array.from({ length: 256 }, (s, A) => A.toString(16).padStart(2, "0"));
function bytesToHex$2(s) {
  abytes$2(s);
  let A = "";
  for (let u = 0; u < s.length; u++)
    A += hexes$2[s[u]];
  return A;
}
function numberToHexUnpadded$1(s) {
  const A = s.toString(16);
  return A.length & 1 ? `0${A}` : A;
}
function hexToNumber$2(s) {
  if (typeof s != "string")
    throw new Error("hex string expected, got " + typeof s);
  return BigInt(s === "" ? "0" : `0x${s}`);
}
const asciis$1 = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
function asciiToBase16$1(s) {
  if (s >= asciis$1._0 && s <= asciis$1._9)
    return s - asciis$1._0;
  if (s >= asciis$1._A && s <= asciis$1._F)
    return s - (asciis$1._A - 10);
  if (s >= asciis$1._a && s <= asciis$1._f)
    return s - (asciis$1._a - 10);
}
function hexToBytes$2(s) {
  if (typeof s != "string")
    throw new Error("hex string expected, got " + typeof s);
  const A = s.length, u = A / 2;
  if (A % 2)
    throw new Error("padded hex string expected, got unpadded hex of length " + A);
  const p = new Uint8Array(u);
  for (let t = 0, l = 0; t < u; t++, l += 2) {
    const m = asciiToBase16$1(s.charCodeAt(l)), b = asciiToBase16$1(s.charCodeAt(l + 1));
    if (m === void 0 || b === void 0) {
      const k = s[l] + s[l + 1];
      throw new Error('hex string expected, got non-hex character "' + k + '" at index ' + l);
    }
    p[t] = m * 16 + b;
  }
  return p;
}
function bytesToNumberBE$1(s) {
  return hexToNumber$2(bytesToHex$2(s));
}
function bytesToNumberLE$1(s) {
  return abytes$2(s), hexToNumber$2(bytesToHex$2(Uint8Array.from(s).reverse()));
}
function numberToBytesBE$1(s, A) {
  return hexToBytes$2(s.toString(16).padStart(A * 2, "0"));
}
function numberToBytesLE$1(s, A) {
  return numberToBytesBE$1(s, A).reverse();
}
function numberToVarBytesBE(s) {
  return hexToBytes$2(numberToHexUnpadded$1(s));
}
function ensureBytes$1(s, A, u) {
  let p;
  if (typeof A == "string")
    try {
      p = hexToBytes$2(A);
    } catch (l) {
      throw new Error(`${s} must be valid hex string, got "${A}". Cause: ${l}`);
    }
  else if (isBytes$5(A))
    p = Uint8Array.from(A);
  else
    throw new Error(`${s} must be hex string or Uint8Array`);
  const t = p.length;
  if (typeof u == "number" && t !== u)
    throw new Error(`${s} expected ${u} bytes, got ${t}`);
  return p;
}
function concatBytes$4(...s) {
  let A = 0;
  for (let p = 0; p < s.length; p++) {
    const t = s[p];
    abytes$2(t), A += t.length;
  }
  const u = new Uint8Array(A);
  for (let p = 0, t = 0; p < s.length; p++) {
    const l = s[p];
    u.set(l, t), t += l.length;
  }
  return u;
}
function equalBytes$2(s, A) {
  if (s.length !== A.length)
    return !1;
  let u = 0;
  for (let p = 0; p < s.length; p++)
    u |= s[p] ^ A[p];
  return u === 0;
}
function utf8ToBytes$1(s) {
  if (typeof s != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof s}`);
  return new Uint8Array(new TextEncoder().encode(s));
}
function bitLen$1(s) {
  let A;
  for (A = 0; s > _0n$9; s >>= _1n$a, A += 1)
    ;
  return A;
}
function bitGet(s, A) {
  return s >> BigInt(A) & _1n$a;
}
function bitSet(s, A, u) {
  return s | (u ? _1n$a : _0n$9) << BigInt(A);
}
const bitMask$1 = (s) => (_2n$6 << BigInt(s - 1)) - _1n$a, u8n = (s) => new Uint8Array(s), u8fr = (s) => Uint8Array.from(s);
function createHmacDrbg$1(s, A, u) {
  if (typeof s != "number" || s < 2)
    throw new Error("hashLen must be a number");
  if (typeof A != "number" || A < 2)
    throw new Error("qByteLen must be a number");
  if (typeof u != "function")
    throw new Error("hmacFn must be a function");
  let p = u8n(s), t = u8n(s), l = 0;
  const m = () => {
    p.fill(1), t.fill(0), l = 0;
  }, b = (...Q) => u(t, p, ...Q), k = (Q = u8n()) => {
    t = b(u8fr([0]), Q), p = b(), Q.length !== 0 && (t = b(u8fr([1]), Q), p = b());
  }, C = () => {
    if (l++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let Q = 0;
    const P = [];
    for (; Q < A; ) {
      p = b();
      const x = p.slice();
      P.push(x), Q += p.length;
    }
    return concatBytes$4(...P);
  };
  return (Q, P) => {
    m(), k(Q);
    let x;
    for (; !(x = P(C())); )
      k();
    return m(), x;
  };
}
const validatorFns = {
  bigint: (s) => typeof s == "bigint",
  function: (s) => typeof s == "function",
  boolean: (s) => typeof s == "boolean",
  string: (s) => typeof s == "string",
  stringOrUint8Array: (s) => typeof s == "string" || isBytes$5(s),
  isSafeInteger: (s) => Number.isSafeInteger(s),
  array: (s) => Array.isArray(s),
  field: (s, A) => A.Fp.isValid(s),
  hash: (s) => typeof s == "function" && Number.isSafeInteger(s.outputLen)
};
function validateObject(s, A, u = {}) {
  const p = (t, l, m) => {
    const b = validatorFns[l];
    if (typeof b != "function")
      throw new Error(`Invalid validator "${l}", expected function`);
    const k = s[t];
    if (!(m && k === void 0) && !b(k, s))
      throw new Error(`Invalid param ${String(t)}=${k} (${typeof k}), expected ${l}`);
  };
  for (const [t, l] of Object.entries(A))
    p(t, l, !1);
  for (const [t, l] of Object.entries(u))
    p(t, l, !0);
  return s;
}
const ut$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  abytes: abytes$2,
  bitGet,
  bitLen: bitLen$1,
  bitMask: bitMask$1,
  bitSet,
  bytesToHex: bytesToHex$2,
  bytesToNumberBE: bytesToNumberBE$1,
  bytesToNumberLE: bytesToNumberLE$1,
  concatBytes: concatBytes$4,
  createHmacDrbg: createHmacDrbg$1,
  ensureBytes: ensureBytes$1,
  equalBytes: equalBytes$2,
  hexToBytes: hexToBytes$2,
  hexToNumber: hexToNumber$2,
  isBytes: isBytes$5,
  numberToBytesBE: numberToBytesBE$1,
  numberToBytesLE: numberToBytesLE$1,
  numberToHexUnpadded: numberToHexUnpadded$1,
  numberToVarBytesBE,
  utf8ToBytes: utf8ToBytes$1,
  validateObject
}, Symbol.toStringTag, { value: "Module" }));
const _0n$8 = BigInt(0), _1n$9 = BigInt(1), _2n$5 = BigInt(2), _3n$3 = BigInt(3), _4n$2 = BigInt(4), _5n$1 = BigInt(5), _8n$1 = BigInt(8);
BigInt(9);
BigInt(16);
function mod$1(s, A) {
  const u = s % A;
  return u >= _0n$8 ? u : A + u;
}
function pow(s, A, u) {
  if (u <= _0n$8 || A < _0n$8)
    throw new Error("Expected power/modulo > 0");
  if (u === _1n$9)
    return _0n$8;
  let p = _1n$9;
  for (; A > _0n$8; )
    A & _1n$9 && (p = p * s % u), s = s * s % u, A >>= _1n$9;
  return p;
}
function pow2$1(s, A, u) {
  let p = s;
  for (; A-- > _0n$8; )
    p *= p, p %= u;
  return p;
}
function invert$1(s, A) {
  if (s === _0n$8 || A <= _0n$8)
    throw new Error(`invert: expected positive integers, got n=${s} mod=${A}`);
  let u = mod$1(s, A), p = A, t = _0n$8, l = _1n$9;
  for (; u !== _0n$8; ) {
    const b = p / u, k = p % u, C = t - l * b;
    p = u, u = k, t = l, l = C;
  }
  if (p !== _1n$9)
    throw new Error("invert: does not exist");
  return mod$1(t, A);
}
function tonelliShanks$1(s) {
  const A = (s - _1n$9) / _2n$5;
  let u, p, t;
  for (u = s - _1n$9, p = 0; u % _2n$5 === _0n$8; u /= _2n$5, p++)
    ;
  for (t = _2n$5; t < s && pow(t, A, s) !== s - _1n$9; t++)
    ;
  if (p === 1) {
    const m = (s + _1n$9) / _4n$2;
    return function(k, C) {
      const B = k.pow(C, m);
      if (!k.eql(k.sqr(B), C))
        throw new Error("Cannot find square root");
      return B;
    };
  }
  const l = (u + _1n$9) / _2n$5;
  return function(b, k) {
    if (b.pow(k, A) === b.neg(b.ONE))
      throw new Error("Cannot find square root");
    let C = p, B = b.pow(b.mul(b.ONE, t), u), Q = b.pow(k, l), P = b.pow(k, u);
    for (; !b.eql(P, b.ONE); ) {
      if (b.eql(P, b.ZERO))
        return b.ZERO;
      let x = 1;
      for (let F = b.sqr(P); x < C && !b.eql(F, b.ONE); x++)
        F = b.sqr(F);
      const M = b.pow(B, _1n$9 << BigInt(C - x - 1));
      B = b.sqr(M), Q = b.mul(Q, M), P = b.mul(P, B), C = x;
    }
    return Q;
  };
}
function FpSqrt$1(s) {
  if (s % _4n$2 === _3n$3) {
    const A = (s + _1n$9) / _4n$2;
    return function(p, t) {
      const l = p.pow(t, A);
      if (!p.eql(p.sqr(l), t))
        throw new Error("Cannot find square root");
      return l;
    };
  }
  if (s % _8n$1 === _5n$1) {
    const A = (s - _5n$1) / _8n$1;
    return function(p, t) {
      const l = p.mul(t, _2n$5), m = p.pow(l, A), b = p.mul(t, m), k = p.mul(p.mul(b, _2n$5), m), C = p.mul(b, p.sub(k, p.ONE));
      if (!p.eql(p.sqr(C), t))
        throw new Error("Cannot find square root");
      return C;
    };
  }
  return tonelliShanks$1(s);
}
const FIELD_FIELDS$1 = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function validateField$1(s) {
  const A = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, u = FIELD_FIELDS$1.reduce((p, t) => (p[t] = "function", p), A);
  return validateObject(s, u);
}
function FpPow$1(s, A, u) {
  if (u < _0n$8)
    throw new Error("Expected power > 0");
  if (u === _0n$8)
    return s.ONE;
  if (u === _1n$9)
    return A;
  let p = s.ONE, t = A;
  for (; u > _0n$8; )
    u & _1n$9 && (p = s.mul(p, t)), t = s.sqr(t), u >>= _1n$9;
  return p;
}
function FpInvertBatch$1(s, A) {
  const u = new Array(A.length), p = A.reduce((l, m, b) => s.is0(m) ? l : (u[b] = l, s.mul(l, m)), s.ONE), t = s.inv(p);
  return A.reduceRight((l, m, b) => s.is0(m) ? l : (u[b] = s.mul(l, u[b]), s.mul(l, m)), t), u;
}
function nLength$1(s, A) {
  const u = A !== void 0 ? A : s.toString(2).length, p = Math.ceil(u / 8);
  return { nBitLength: u, nByteLength: p };
}
function Field$1(s, A, u = !1, p = {}) {
  if (s <= _0n$8)
    throw new Error(`Expected Field ORDER > 0, got ${s}`);
  const { nBitLength: t, nByteLength: l } = nLength$1(s, A);
  if (l > 2048)
    throw new Error("Field lengths over 2048 bytes are not supported");
  const m = FpSqrt$1(s), b = Object.freeze({
    ORDER: s,
    BITS: t,
    BYTES: l,
    MASK: bitMask$1(t),
    ZERO: _0n$8,
    ONE: _1n$9,
    create: (k) => mod$1(k, s),
    isValid: (k) => {
      if (typeof k != "bigint")
        throw new Error(`Invalid field element: expected bigint, got ${typeof k}`);
      return _0n$8 <= k && k < s;
    },
    is0: (k) => k === _0n$8,
    isOdd: (k) => (k & _1n$9) === _1n$9,
    neg: (k) => mod$1(-k, s),
    eql: (k, C) => k === C,
    sqr: (k) => mod$1(k * k, s),
    add: (k, C) => mod$1(k + C, s),
    sub: (k, C) => mod$1(k - C, s),
    mul: (k, C) => mod$1(k * C, s),
    pow: (k, C) => FpPow$1(b, k, C),
    div: (k, C) => mod$1(k * invert$1(C, s), s),
    // Same as above, but doesn't normalize
    sqrN: (k) => k * k,
    addN: (k, C) => k + C,
    subN: (k, C) => k - C,
    mulN: (k, C) => k * C,
    inv: (k) => invert$1(k, s),
    sqrt: p.sqrt || ((k) => m(b, k)),
    invertBatch: (k) => FpInvertBatch$1(b, k),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (k, C, B) => B ? C : k,
    toBytes: (k) => u ? numberToBytesLE$1(k, l) : numberToBytesBE$1(k, l),
    fromBytes: (k) => {
      if (k.length !== l)
        throw new Error(`Fp.fromBytes: expected ${l}, got ${k.length}`);
      return u ? bytesToNumberLE$1(k) : bytesToNumberBE$1(k);
    }
  });
  return Object.freeze(b);
}
function getFieldBytesLength$1(s) {
  if (typeof s != "bigint")
    throw new Error("field order must be bigint");
  const A = s.toString(2).length;
  return Math.ceil(A / 8);
}
function getMinHashLength$1(s) {
  const A = getFieldBytesLength$1(s);
  return A + Math.ceil(A / 2);
}
function mapHashToField$1(s, A, u = !1) {
  const p = s.length, t = getFieldBytesLength$1(A), l = getMinHashLength$1(A);
  if (p < 16 || p < l || p > 1024)
    throw new Error(`expected ${l}-1024 bytes of input, got ${p}`);
  const m = u ? bytesToNumberBE$1(s) : bytesToNumberLE$1(s), b = mod$1(m, A - _1n$9) + _1n$9;
  return u ? numberToBytesLE$1(b, t) : numberToBytesBE$1(b, t);
}
const _0n$7 = BigInt(0), _1n$8 = BigInt(1);
function wNAF$1(s, A) {
  const u = (t, l) => {
    const m = l.negate();
    return t ? m : l;
  }, p = (t) => {
    const l = Math.ceil(A / t) + 1, m = 2 ** (t - 1);
    return { windows: l, windowSize: m };
  };
  return {
    constTimeNegate: u,
    // non-const time multiplication ladder
    unsafeLadder(t, l) {
      let m = s.ZERO, b = t;
      for (; l > _0n$7; )
        l & _1n$8 && (m = m.add(b)), b = b.double(), l >>= _1n$8;
      return m;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(t, l) {
      const { windows: m, windowSize: b } = p(l), k = [];
      let C = t, B = C;
      for (let Q = 0; Q < m; Q++) {
        B = C, k.push(B);
        for (let P = 1; P < b; P++)
          B = B.add(C), k.push(B);
        C = B.double();
      }
      return k;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(t, l, m) {
      const { windows: b, windowSize: k } = p(t);
      let C = s.ZERO, B = s.BASE;
      const Q = BigInt(2 ** t - 1), P = 2 ** t, x = BigInt(t);
      for (let M = 0; M < b; M++) {
        const F = M * k;
        let le = Number(m & Q);
        m >>= x, le > k && (le -= P, m += _1n$8);
        const ge = F, pe = F + Math.abs(le) - 1, Ie = M % 2 !== 0, be = le < 0;
        le === 0 ? B = B.add(u(Ie, l[ge])) : C = C.add(u(be, l[pe]));
      }
      return { p: C, f: B };
    },
    wNAFCached(t, l, m, b) {
      const k = t._WINDOW_SIZE || 1;
      let C = l.get(t);
      return C || (C = this.precomputeWindow(t, k), k !== 1 && l.set(t, b(C))), this.wNAF(k, C, m);
    }
  };
}
function validateBasic(s) {
  return validateField$1(s.Fp), validateObject(s, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...nLength$1(s.n, s.nBitLength),
    ...s,
    p: s.Fp.ORDER
  });
}
function validatePointOpts(s) {
  const A = validateBasic(s);
  validateObject(A, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: u, Fp: p, a: t } = A;
  if (u) {
    if (!p.eql(t, p.ZERO))
      throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
    if (typeof u != "object" || typeof u.beta != "bigint" || typeof u.splitScalar != "function")
      throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...A });
}
const { bytesToNumberBE: b2n, hexToBytes: h2b } = ut$1, DER$1 = {
  // asn.1 DER encoding utils
  Err: class extends Error {
    constructor(A = "") {
      super(A);
    }
  },
  _parseInt(s) {
    const { Err: A } = DER$1;
    if (s.length < 2 || s[0] !== 2)
      throw new A("Invalid signature integer tag");
    const u = s[1], p = s.subarray(2, u + 2);
    if (!u || p.length !== u)
      throw new A("Invalid signature integer: wrong length");
    if (p[0] & 128)
      throw new A("Invalid signature integer: negative");
    if (p[0] === 0 && !(p[1] & 128))
      throw new A("Invalid signature integer: unnecessary leading zero");
    return { d: b2n(p), l: s.subarray(u + 2) };
  },
  toSig(s) {
    const { Err: A } = DER$1, u = typeof s == "string" ? h2b(s) : s;
    abytes$2(u);
    let p = u.length;
    if (p < 2 || u[0] != 48)
      throw new A("Invalid signature tag");
    if (u[1] !== p - 2)
      throw new A("Invalid signature: incorrect length");
    const { d: t, l } = DER$1._parseInt(u.subarray(2)), { d: m, l: b } = DER$1._parseInt(l);
    if (b.length)
      throw new A("Invalid signature: left bytes after parsing");
    return { r: t, s: m };
  },
  hexFromSig(s) {
    const A = (C) => Number.parseInt(C[0], 16) & 8 ? "00" + C : C, u = (C) => {
      const B = C.toString(16);
      return B.length & 1 ? `0${B}` : B;
    }, p = A(u(s.s)), t = A(u(s.r)), l = p.length / 2, m = t.length / 2, b = u(l), k = u(m);
    return `30${u(m + l + 4)}02${k}${t}02${b}${p}`;
  }
}, _0n$6 = BigInt(0), _1n$7 = BigInt(1);
BigInt(2);
const _3n$2 = BigInt(3);
BigInt(4);
function weierstrassPoints(s) {
  const A = validatePointOpts(s), { Fp: u } = A, p = A.toBytes || ((M, F, le) => {
    const ge = F.toAffine();
    return concatBytes$4(Uint8Array.from([4]), u.toBytes(ge.x), u.toBytes(ge.y));
  }), t = A.fromBytes || ((M) => {
    const F = M.subarray(1), le = u.fromBytes(F.subarray(0, u.BYTES)), ge = u.fromBytes(F.subarray(u.BYTES, 2 * u.BYTES));
    return { x: le, y: ge };
  });
  function l(M) {
    const { a: F, b: le } = A, ge = u.sqr(M), pe = u.mul(ge, M);
    return u.add(u.add(pe, u.mul(M, F)), le);
  }
  if (!u.eql(u.sqr(A.Gy), l(A.Gx)))
    throw new Error("bad generator point: equation left != right");
  function m(M) {
    return typeof M == "bigint" && _0n$6 < M && M < A.n;
  }
  function b(M) {
    if (!m(M))
      throw new Error("Expected valid bigint: 0 < bigint < curve.n");
  }
  function k(M) {
    const { allowedPrivateKeyLengths: F, nByteLength: le, wrapPrivateKey: ge, n: pe } = A;
    if (F && typeof M != "bigint") {
      if (isBytes$5(M) && (M = bytesToHex$2(M)), typeof M != "string" || !F.includes(M.length))
        throw new Error("Invalid key");
      M = M.padStart(le * 2, "0");
    }
    let Ie;
    try {
      Ie = typeof M == "bigint" ? M : bytesToNumberBE$1(ensureBytes$1("private key", M, le));
    } catch {
      throw new Error(`private key must be ${le} bytes, hex or bigint, not ${typeof M}`);
    }
    return ge && (Ie = mod$1(Ie, pe)), b(Ie), Ie;
  }
  const C = /* @__PURE__ */ new Map();
  function B(M) {
    if (!(M instanceof Q))
      throw new Error("ProjectivePoint expected");
  }
  class Q {
    constructor(F, le, ge) {
      if (this.px = F, this.py = le, this.pz = ge, F == null || !u.isValid(F))
        throw new Error("x required");
      if (le == null || !u.isValid(le))
        throw new Error("y required");
      if (ge == null || !u.isValid(ge))
        throw new Error("z required");
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(F) {
      const { x: le, y: ge } = F || {};
      if (!F || !u.isValid(le) || !u.isValid(ge))
        throw new Error("invalid affine point");
      if (F instanceof Q)
        throw new Error("projective point not allowed");
      const pe = (Ie) => u.eql(Ie, u.ZERO);
      return pe(le) && pe(ge) ? Q.ZERO : new Q(le, ge, u.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(F) {
      const le = u.invertBatch(F.map((ge) => ge.pz));
      return F.map((ge, pe) => ge.toAffine(le[pe])).map(Q.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(F) {
      const le = Q.fromAffine(t(ensureBytes$1("pointHex", F)));
      return le.assertValidity(), le;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(F) {
      return Q.BASE.multiply(k(F));
    }
    // "Private method", don't use it directly
    _setWindowSize(F) {
      this._WINDOW_SIZE = F, C.delete(this);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      if (this.is0()) {
        if (A.allowInfinityPoint && !u.is0(this.py))
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: F, y: le } = this.toAffine();
      if (!u.isValid(F) || !u.isValid(le))
        throw new Error("bad point: x or y not FE");
      const ge = u.sqr(le), pe = l(F);
      if (!u.eql(ge, pe))
        throw new Error("bad point: equation left != right");
      if (!this.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
    }
    hasEvenY() {
      const { y: F } = this.toAffine();
      if (u.isOdd)
        return !u.isOdd(F);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(F) {
      B(F);
      const { px: le, py: ge, pz: pe } = this, { px: Ie, py: be, pz: Pe } = F, Te = u.eql(u.mul(le, Pe), u.mul(Ie, pe)), Qe = u.eql(u.mul(ge, Pe), u.mul(be, pe));
      return Te && Qe;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new Q(this.px, u.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: F, b: le } = A, ge = u.mul(le, _3n$2), { px: pe, py: Ie, pz: be } = this;
      let Pe = u.ZERO, Te = u.ZERO, Qe = u.ZERO, xe = u.mul(pe, pe), Ee = u.mul(Ie, Ie), He = u.mul(be, be), ve = u.mul(pe, Ie);
      return ve = u.add(ve, ve), Qe = u.mul(pe, be), Qe = u.add(Qe, Qe), Pe = u.mul(F, Qe), Te = u.mul(ge, He), Te = u.add(Pe, Te), Pe = u.sub(Ee, Te), Te = u.add(Ee, Te), Te = u.mul(Pe, Te), Pe = u.mul(ve, Pe), Qe = u.mul(ge, Qe), He = u.mul(F, He), ve = u.sub(xe, He), ve = u.mul(F, ve), ve = u.add(ve, Qe), Qe = u.add(xe, xe), xe = u.add(Qe, xe), xe = u.add(xe, He), xe = u.mul(xe, ve), Te = u.add(Te, xe), He = u.mul(Ie, be), He = u.add(He, He), xe = u.mul(He, ve), Pe = u.sub(Pe, xe), Qe = u.mul(He, Ee), Qe = u.add(Qe, Qe), Qe = u.add(Qe, Qe), new Q(Pe, Te, Qe);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(F) {
      B(F);
      const { px: le, py: ge, pz: pe } = this, { px: Ie, py: be, pz: Pe } = F;
      let Te = u.ZERO, Qe = u.ZERO, xe = u.ZERO;
      const Ee = A.a, He = u.mul(A.b, _3n$2);
      let ve = u.mul(le, Ie), we = u.mul(ge, be), Ce = u.mul(pe, Pe), Se = u.add(le, ge), Ne = u.add(Ie, be);
      Se = u.mul(Se, Ne), Ne = u.add(ve, we), Se = u.sub(Se, Ne), Ne = u.add(le, pe);
      let rr = u.add(Ie, Pe);
      return Ne = u.mul(Ne, rr), rr = u.add(ve, Ce), Ne = u.sub(Ne, rr), rr = u.add(ge, pe), Te = u.add(be, Pe), rr = u.mul(rr, Te), Te = u.add(we, Ce), rr = u.sub(rr, Te), xe = u.mul(Ee, Ne), Te = u.mul(He, Ce), xe = u.add(Te, xe), Te = u.sub(we, xe), xe = u.add(we, xe), Qe = u.mul(Te, xe), we = u.add(ve, ve), we = u.add(we, ve), Ce = u.mul(Ee, Ce), Ne = u.mul(He, Ne), we = u.add(we, Ce), Ce = u.sub(ve, Ce), Ce = u.mul(Ee, Ce), Ne = u.add(Ne, Ce), ve = u.mul(we, Ne), Qe = u.add(Qe, ve), ve = u.mul(rr, Ne), Te = u.mul(Se, Te), Te = u.sub(Te, ve), ve = u.mul(Se, we), xe = u.mul(rr, xe), xe = u.add(xe, ve), new Q(Te, Qe, xe);
    }
    subtract(F) {
      return this.add(F.negate());
    }
    is0() {
      return this.equals(Q.ZERO);
    }
    wNAF(F) {
      return x.wNAFCached(this, C, F, (le) => {
        const ge = u.invertBatch(le.map((pe) => pe.pz));
        return le.map((pe, Ie) => pe.toAffine(ge[Ie])).map(Q.fromAffine);
      });
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(F) {
      const le = Q.ZERO;
      if (F === _0n$6)
        return le;
      if (b(F), F === _1n$7)
        return this;
      const { endo: ge } = A;
      if (!ge)
        return x.unsafeLadder(this, F);
      let { k1neg: pe, k1: Ie, k2neg: be, k2: Pe } = ge.splitScalar(F), Te = le, Qe = le, xe = this;
      for (; Ie > _0n$6 || Pe > _0n$6; )
        Ie & _1n$7 && (Te = Te.add(xe)), Pe & _1n$7 && (Qe = Qe.add(xe)), xe = xe.double(), Ie >>= _1n$7, Pe >>= _1n$7;
      return pe && (Te = Te.negate()), be && (Qe = Qe.negate()), Qe = new Q(u.mul(Qe.px, ge.beta), Qe.py, Qe.pz), Te.add(Qe);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(F) {
      b(F);
      let le = F, ge, pe;
      const { endo: Ie } = A;
      if (Ie) {
        const { k1neg: be, k1: Pe, k2neg: Te, k2: Qe } = Ie.splitScalar(le);
        let { p: xe, f: Ee } = this.wNAF(Pe), { p: He, f: ve } = this.wNAF(Qe);
        xe = x.constTimeNegate(be, xe), He = x.constTimeNegate(Te, He), He = new Q(u.mul(He.px, Ie.beta), He.py, He.pz), ge = xe.add(He), pe = Ee.add(ve);
      } else {
        const { p: be, f: Pe } = this.wNAF(le);
        ge = be, pe = Pe;
      }
      return Q.normalizeZ([ge, pe])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(F, le, ge) {
      const pe = Q.BASE, Ie = (Pe, Te) => Te === _0n$6 || Te === _1n$7 || !Pe.equals(pe) ? Pe.multiplyUnsafe(Te) : Pe.multiply(Te), be = Ie(this, le).add(Ie(F, ge));
      return be.is0() ? void 0 : be;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(F) {
      const { px: le, py: ge, pz: pe } = this, Ie = this.is0();
      F == null && (F = Ie ? u.ONE : u.inv(pe));
      const be = u.mul(le, F), Pe = u.mul(ge, F), Te = u.mul(pe, F);
      if (Ie)
        return { x: u.ZERO, y: u.ZERO };
      if (!u.eql(Te, u.ONE))
        throw new Error("invZ was invalid");
      return { x: be, y: Pe };
    }
    isTorsionFree() {
      const { h: F, isTorsionFree: le } = A;
      if (F === _1n$7)
        return !0;
      if (le)
        return le(Q, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: F, clearCofactor: le } = A;
      return F === _1n$7 ? this : le ? le(Q, this) : this.multiplyUnsafe(A.h);
    }
    toRawBytes(F = !0) {
      return this.assertValidity(), p(Q, this, F);
    }
    toHex(F = !0) {
      return bytesToHex$2(this.toRawBytes(F));
    }
  }
  Q.BASE = new Q(A.Gx, A.Gy, u.ONE), Q.ZERO = new Q(u.ZERO, u.ONE, u.ZERO);
  const P = A.nBitLength, x = wNAF$1(Q, A.endo ? Math.ceil(P / 2) : P);
  return {
    CURVE: A,
    ProjectivePoint: Q,
    normPrivateKeyToScalar: k,
    weierstrassEquation: l,
    isWithinCurveOrder: m
  };
}
function validateOpts$1(s) {
  const A = validateBasic(s);
  return validateObject(A, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...A });
}
function weierstrass$1(s) {
  const A = validateOpts$1(s), { Fp: u, n: p } = A, t = u.BYTES + 1, l = 2 * u.BYTES + 1;
  function m(Ne) {
    return _0n$6 < Ne && Ne < u.ORDER;
  }
  function b(Ne) {
    return mod$1(Ne, p);
  }
  function k(Ne) {
    return invert$1(Ne, p);
  }
  const { ProjectivePoint: C, normPrivateKeyToScalar: B, weierstrassEquation: Q, isWithinCurveOrder: P } = weierstrassPoints({
    ...A,
    toBytes(Ne, rr, er) {
      const ir = rr.toAffine(), sr = u.toBytes(ir.x), nr = concatBytes$4;
      return er ? nr(Uint8Array.from([rr.hasEvenY() ? 2 : 3]), sr) : nr(Uint8Array.from([4]), sr, u.toBytes(ir.y));
    },
    fromBytes(Ne) {
      const rr = Ne.length, er = Ne[0], ir = Ne.subarray(1);
      if (rr === t && (er === 2 || er === 3)) {
        const sr = bytesToNumberBE$1(ir);
        if (!m(sr))
          throw new Error("Point is not on curve");
        const nr = Q(sr);
        let fr;
        try {
          fr = u.sqrt(nr);
        } catch (Br) {
          const Fr = Br instanceof Error ? ": " + Br.message : "";
          throw new Error("Point is not on curve" + Fr);
        }
        const lr = (fr & _1n$7) === _1n$7;
        return (er & 1) === 1 !== lr && (fr = u.neg(fr)), { x: sr, y: fr };
      } else if (rr === l && er === 4) {
        const sr = u.fromBytes(ir.subarray(0, u.BYTES)), nr = u.fromBytes(ir.subarray(u.BYTES, 2 * u.BYTES));
        return { x: sr, y: nr };
      } else
        throw new Error(`Point of length ${rr} was invalid. Expected ${t} compressed bytes or ${l} uncompressed bytes`);
    }
  }), x = (Ne) => bytesToHex$2(numberToBytesBE$1(Ne, A.nByteLength));
  function M(Ne) {
    const rr = p >> _1n$7;
    return Ne > rr;
  }
  function F(Ne) {
    return M(Ne) ? b(-Ne) : Ne;
  }
  const le = (Ne, rr, er) => bytesToNumberBE$1(Ne.slice(rr, er));
  class ge {
    constructor(rr, er, ir) {
      this.r = rr, this.s = er, this.recovery = ir, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(rr) {
      const er = A.nByteLength;
      return rr = ensureBytes$1("compactSignature", rr, er * 2), new ge(le(rr, 0, er), le(rr, er, 2 * er));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(rr) {
      const { r: er, s: ir } = DER$1.toSig(ensureBytes$1("DER", rr));
      return new ge(er, ir);
    }
    assertValidity() {
      if (!P(this.r))
        throw new Error("r must be 0 < r < CURVE.n");
      if (!P(this.s))
        throw new Error("s must be 0 < s < CURVE.n");
    }
    addRecoveryBit(rr) {
      return new ge(this.r, this.s, rr);
    }
    recoverPublicKey(rr) {
      const { r: er, s: ir, recovery: sr } = this, nr = Qe(ensureBytes$1("msgHash", rr));
      if (sr == null || ![0, 1, 2, 3].includes(sr))
        throw new Error("recovery id invalid");
      const fr = sr === 2 || sr === 3 ? er + A.n : er;
      if (fr >= u.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const lr = (sr & 1) === 0 ? "02" : "03", br = C.fromHex(lr + x(fr)), Br = k(fr), Fr = b(-nr * Br), Gr = b(ir * Br), qr = C.BASE.multiplyAndAddUnsafe(br, Fr, Gr);
      if (!qr)
        throw new Error("point at infinify");
      return qr.assertValidity(), qr;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return M(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new ge(this.r, b(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return hexToBytes$2(this.toDERHex());
    }
    toDERHex() {
      return DER$1.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return hexToBytes$2(this.toCompactHex());
    }
    toCompactHex() {
      return x(this.r) + x(this.s);
    }
  }
  const pe = {
    isValidPrivateKey(Ne) {
      try {
        return B(Ne), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: B,
    /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    randomPrivateKey: () => {
      const Ne = getMinHashLength$1(A.n);
      return mapHashToField$1(A.randomBytes(Ne), A.n);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(Ne = 8, rr = C.BASE) {
      return rr._setWindowSize(Ne), rr.multiply(BigInt(3)), rr;
    }
  };
  function Ie(Ne, rr = !0) {
    return C.fromPrivateKey(Ne).toRawBytes(rr);
  }
  function be(Ne) {
    const rr = isBytes$5(Ne), er = typeof Ne == "string", ir = (rr || er) && Ne.length;
    return rr ? ir === t || ir === l : er ? ir === 2 * t || ir === 2 * l : Ne instanceof C;
  }
  function Pe(Ne, rr, er = !0) {
    if (be(Ne))
      throw new Error("first arg must be private key");
    if (!be(rr))
      throw new Error("second arg must be public key");
    return C.fromHex(rr).multiply(B(Ne)).toRawBytes(er);
  }
  const Te = A.bits2int || function(Ne) {
    const rr = bytesToNumberBE$1(Ne), er = Ne.length * 8 - A.nBitLength;
    return er > 0 ? rr >> BigInt(er) : rr;
  }, Qe = A.bits2int_modN || function(Ne) {
    return b(Te(Ne));
  }, xe = bitMask$1(A.nBitLength);
  function Ee(Ne) {
    if (typeof Ne != "bigint")
      throw new Error("bigint expected");
    if (!(_0n$6 <= Ne && Ne < xe))
      throw new Error(`bigint expected < 2^${A.nBitLength}`);
    return numberToBytesBE$1(Ne, A.nByteLength);
  }
  function He(Ne, rr, er = ve) {
    if (["recovered", "canonical"].some((un) => un in er))
      throw new Error("sign() legacy options not supported");
    const { hash: ir, randomBytes: sr } = A;
    let { lowS: nr, prehash: fr, extraEntropy: lr } = er;
    nr == null && (nr = !0), Ne = ensureBytes$1("msgHash", Ne), fr && (Ne = ensureBytes$1("prehashed msgHash", ir(Ne)));
    const br = Qe(Ne), Br = B(rr), Fr = [Ee(Br), Ee(br)];
    if (lr != null && lr !== !1) {
      const un = lr === !0 ? sr(u.BYTES) : lr;
      Fr.push(ensureBytes$1("extraEntropy", un));
    }
    const Gr = concatBytes$4(...Fr), qr = br;
    function Hr(un) {
      const Dr = Te(un);
      if (!P(Dr))
        return;
      const wr = k(Dr), yr = C.BASE.multiply(Dr).toAffine(), Qr = b(yr.x);
      if (Qr === _0n$6)
        return;
      const _r = b(wr * b(qr + Qr * Br));
      if (_r === _0n$6)
        return;
      let Jr = (yr.x === Qr ? 0 : 2) | Number(yr.y & _1n$7), fn = _r;
      return nr && M(_r) && (fn = F(_r), Jr ^= 1), new ge(Qr, fn, Jr);
    }
    return { seed: Gr, k2sig: Hr };
  }
  const ve = { lowS: A.lowS, prehash: !1 }, we = { lowS: A.lowS, prehash: !1 };
  function Ce(Ne, rr, er = ve) {
    const { seed: ir, k2sig: sr } = He(Ne, rr, er), nr = A;
    return createHmacDrbg$1(nr.hash.outputLen, nr.nByteLength, nr.hmac)(ir, sr);
  }
  C.BASE._setWindowSize(8);
  function Se(Ne, rr, er, ir = we) {
    var yr;
    const sr = Ne;
    if (rr = ensureBytes$1("msgHash", rr), er = ensureBytes$1("publicKey", er), "strict" in ir)
      throw new Error("options.strict was renamed to lowS");
    const { lowS: nr, prehash: fr } = ir;
    let lr, br;
    try {
      if (typeof sr == "string" || isBytes$5(sr))
        try {
          lr = ge.fromDER(sr);
        } catch (Qr) {
          if (!(Qr instanceof DER$1.Err))
            throw Qr;
          lr = ge.fromCompact(sr);
        }
      else if (typeof sr == "object" && typeof sr.r == "bigint" && typeof sr.s == "bigint") {
        const { r: Qr, s: _r } = sr;
        lr = new ge(Qr, _r);
      } else
        throw new Error("PARSE");
      br = C.fromHex(er);
    } catch (Qr) {
      if (Qr.message === "PARSE")
        throw new Error("signature must be Signature instance, Uint8Array or hex string");
      return !1;
    }
    if (nr && lr.hasHighS())
      return !1;
    fr && (rr = A.hash(rr));
    const { r: Br, s: Fr } = lr, Gr = Qe(rr), qr = k(Fr), Hr = b(Gr * qr), un = b(Br * qr), Dr = (yr = C.BASE.multiplyAndAddUnsafe(br, Hr, un)) == null ? void 0 : yr.toAffine();
    return Dr ? b(Dr.x) === Br : !1;
  }
  return {
    CURVE: A,
    getPublicKey: Ie,
    getSharedSecret: Pe,
    sign: Ce,
    verify: Se,
    ProjectivePoint: C,
    Signature: ge,
    utils: pe
  };
}
function getHash(s) {
  return {
    hash: s,
    hmac: (A, ...u) => hmac$2(s, A, concatBytes$5(...u)),
    randomBytes: randomBytes$1
  };
}
function createCurve$1(s, A) {
  const u = (p) => weierstrass$1({ ...s, ...getHash(p) });
  return Object.freeze({ ...u(A), create: u });
}
const secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), _1n$6 = BigInt(1), _2n$4 = BigInt(2), divNearest$1 = (s, A) => (s + A / _2n$4) / A;
function sqrtMod$1(s) {
  const A = secp256k1P, u = BigInt(3), p = BigInt(6), t = BigInt(11), l = BigInt(22), m = BigInt(23), b = BigInt(44), k = BigInt(88), C = s * s * s % A, B = C * C * s % A, Q = pow2$1(B, u, A) * B % A, P = pow2$1(Q, u, A) * B % A, x = pow2$1(P, _2n$4, A) * C % A, M = pow2$1(x, t, A) * x % A, F = pow2$1(M, l, A) * M % A, le = pow2$1(F, b, A) * F % A, ge = pow2$1(le, k, A) * le % A, pe = pow2$1(ge, b, A) * F % A, Ie = pow2$1(pe, u, A) * B % A, be = pow2$1(Ie, m, A) * M % A, Pe = pow2$1(be, p, A) * C % A, Te = pow2$1(Pe, _2n$4, A);
  if (!Fp.eql(Fp.sqr(Te), s))
    throw new Error("Cannot find square root");
  return Te;
}
const Fp = Field$1(secp256k1P, void 0, void 0, { sqrt: sqrtMod$1 }), secp256k1$3 = createCurve$1({
  a: BigInt(0),
  // equation params: a, b
  b: BigInt(7),
  // Seem to be rigid: bitcointalk.org/index.php?topic=289795.msg3183975#msg3183975
  Fp,
  // Field's prime: 2n**256n - 2n**32n - 2n**9n - 2n**8n - 2n**7n - 2n**6n - 2n**4n - 1n
  n: secp256k1N,
  // Curve order, total count of valid points in the field
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  // Cofactor
  lowS: !0,
  // Allow only low-S signatures by default in sign() and verify()
  /**
   * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
   * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
   * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
   * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
   */
  endo: {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (s) => {
      const A = secp256k1N, u = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), p = -_1n$6 * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), t = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), l = u, m = BigInt("0x100000000000000000000000000000000"), b = divNearest$1(l * s, A), k = divNearest$1(-p * s, A);
      let C = mod$1(s - b * u - k * t, A), B = mod$1(-b * p - k * l, A);
      const Q = C > m, P = B > m;
      if (Q && (C = A - C), P && (B = A - B), C > m || B > m)
        throw new Error("splitScalar: Endomorphism failed, k=" + s);
      return { k1neg: Q, k1: C, k2neg: P, k2: B };
    }
  }
}, sha256$5);
BigInt(0);
secp256k1$3.ProjectivePoint;
function isBytes$4(s) {
  return s instanceof Uint8Array || s != null && typeof s == "object" && s.constructor.name === "Uint8Array";
}
// @__NO_SIDE_EFFECTS__
function chain$1(...s) {
  const A = (l) => l, u = (l, m) => (b) => l(m(b)), p = s.map((l) => l.encode).reduceRight(u, A), t = s.map((l) => l.decode).reduce(u, A);
  return { encode: p, decode: t };
}
// @__NO_SIDE_EFFECTS__
function alphabet$1(s) {
  return {
    encode: (A) => {
      if (!Array.isArray(A) || A.length && typeof A[0] != "number")
        throw new Error("alphabet.encode input should be an array of numbers");
      return A.map((u) => {
        if (u < 0 || u >= s.length)
          throw new Error(`Digit index outside alphabet: ${u} (alphabet: ${s.length})`);
        return s[u];
      });
    },
    decode: (A) => {
      if (!Array.isArray(A) || A.length && typeof A[0] != "string")
        throw new Error("alphabet.decode input should be array of strings");
      return A.map((u) => {
        if (typeof u != "string")
          throw new Error(`alphabet.decode: not string element=${u}`);
        const p = s.indexOf(u);
        if (p === -1)
          throw new Error(`Unknown letter: "${u}". Allowed: ${s}`);
        return p;
      });
    }
  };
}
// @__NO_SIDE_EFFECTS__
function join$1(s = "") {
  if (typeof s != "string")
    throw new Error("join separator should be string");
  return {
    encode: (A) => {
      if (!Array.isArray(A) || A.length && typeof A[0] != "string")
        throw new Error("join.encode input should be array of strings");
      for (let u of A)
        if (typeof u != "string")
          throw new Error(`join.encode: non-string input=${u}`);
      return A.join(s);
    },
    decode: (A) => {
      if (typeof A != "string")
        throw new Error("join.decode input should be string");
      return A.split(s);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function convertRadix$1(s, A, u) {
  if (A < 2)
    throw new Error(`convertRadix: wrong from=${A}, base cannot be less than 2`);
  if (u < 2)
    throw new Error(`convertRadix: wrong to=${u}, base cannot be less than 2`);
  if (!Array.isArray(s))
    throw new Error("convertRadix: data should be array");
  if (!s.length)
    return [];
  let p = 0;
  const t = [], l = Array.from(s);
  for (l.forEach((m) => {
    if (m < 0 || m >= A)
      throw new Error(`Wrong integer: ${m}`);
  }); ; ) {
    let m = 0, b = !0;
    for (let k = p; k < l.length; k++) {
      const C = l[k], B = A * m + C;
      if (!Number.isSafeInteger(B) || A * m / A !== m || B - C !== A * m)
        throw new Error("convertRadix: carry overflow");
      m = B % u;
      const Q = Math.floor(B / u);
      if (l[k] = Q, !Number.isSafeInteger(Q) || Q * u + m !== B)
        throw new Error("convertRadix: carry overflow");
      if (b)
        Q ? b = !1 : p = k;
      else continue;
    }
    if (t.push(m), b)
      break;
  }
  for (let m = 0; m < s.length - 1 && s[m] === 0; m++)
    t.push(0);
  return t.reverse();
}
// @__NO_SIDE_EFFECTS__
function radix$1(s) {
  return {
    encode: (A) => {
      if (!isBytes$4(A))
        throw new Error("radix.encode input should be Uint8Array");
      return /* @__PURE__ */ convertRadix$1(Array.from(A), 2 ** 8, s);
    },
    decode: (A) => {
      if (!Array.isArray(A) || A.length && typeof A[0] != "number")
        throw new Error("radix.decode input should be array of numbers");
      return Uint8Array.from(/* @__PURE__ */ convertRadix$1(A, s, 2 ** 8));
    }
  };
}
// @__NO_SIDE_EFFECTS__
function checksum$2(s, A) {
  if (typeof A != "function")
    throw new Error("checksum fn should be function");
  return {
    encode(u) {
      if (!isBytes$4(u))
        throw new Error("checksum.encode: input should be Uint8Array");
      const p = A(u).slice(0, s), t = new Uint8Array(u.length + s);
      return t.set(u), t.set(p, u.length), t;
    },
    decode(u) {
      if (!isBytes$4(u))
        throw new Error("checksum.decode: input should be Uint8Array");
      const p = u.slice(0, -s), t = A(p).slice(0, s), l = u.slice(-s);
      for (let m = 0; m < s; m++)
        if (t[m] !== l[m])
          throw new Error("Invalid checksum");
      return p;
    }
  };
}
const genBase58$1 = (s) => /* @__PURE__ */ chain$1(/* @__PURE__ */ radix$1(58), /* @__PURE__ */ alphabet$1(s), /* @__PURE__ */ join$1("")), base58$1 = /* @__PURE__ */ genBase58$1("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"), createBase58check$1 = (s) => /* @__PURE__ */ chain$1(/* @__PURE__ */ checksum$2(4, (A) => s(s(A))), base58$1);
const Point$1 = secp256k1$3.ProjectivePoint, base58check$1 = createBase58check$1(sha256$5);
function bytesToNumber$1(s) {
  return BigInt(`0x${bytesToHex$3(s)}`);
}
function numberToBytes$1(s) {
  return hexToBytes$3(s.toString(16).padStart(64, "0"));
}
const MASTER_SECRET = utf8ToBytes$2("Bitcoin seed"), BITCOIN_VERSIONS = { private: 76066276, public: 76067358 }, HARDENED_OFFSET = 2147483648, hash160$1 = (s) => ripemd160$2(sha256$5(s)), fromU32 = (s) => createView$2(s).getUint32(0, !1), toU32 = (s) => {
  if (!Number.isSafeInteger(s) || s < 0 || s > 2 ** 32 - 1)
    throw new Error(`Invalid number=${s}. Should be from 0 to 2 ** 32 - 1`);
  const A = new Uint8Array(4);
  return createView$2(A).setUint32(0, s, !1), A;
};
class HDKey {
  get fingerprint() {
    if (!this.pubHash)
      throw new Error("No publicKey set!");
    return fromU32(this.pubHash);
  }
  get identifier() {
    return this.pubHash;
  }
  get pubKeyHash() {
    return this.pubHash;
  }
  get privateKey() {
    return this.privKeyBytes || null;
  }
  get publicKey() {
    return this.pubKey || null;
  }
  get privateExtendedKey() {
    const A = this.privateKey;
    if (!A)
      throw new Error("No private key");
    return base58check$1.encode(this.serialize(this.versions.private, concatBytes$5(new Uint8Array([0]), A)));
  }
  get publicExtendedKey() {
    if (!this.pubKey)
      throw new Error("No public key");
    return base58check$1.encode(this.serialize(this.versions.public, this.pubKey));
  }
  static fromMasterSeed(A, u = BITCOIN_VERSIONS) {
    if (bytes(A), 8 * A.length < 128 || 8 * A.length > 512)
      throw new Error(`HDKey: wrong seed length=${A.length}. Should be between 128 and 512 bits; 256 bits is advised)`);
    const p = hmac$2(sha512$2, MASTER_SECRET, A);
    return new HDKey({
      versions: u,
      chainCode: p.slice(32),
      privateKey: p.slice(0, 32)
    });
  }
  static fromExtendedKey(A, u = BITCOIN_VERSIONS) {
    const p = base58check$1.decode(A), t = createView$2(p), l = t.getUint32(0, !1), m = {
      versions: u,
      depth: p[4],
      parentFingerprint: t.getUint32(5, !1),
      index: t.getUint32(9, !1),
      chainCode: p.slice(13, 45)
    }, b = p.slice(45), k = b[0] === 0;
    if (l !== u[k ? "private" : "public"])
      throw new Error("Version mismatch");
    return k ? new HDKey({ ...m, privateKey: b.slice(1) }) : new HDKey({ ...m, publicKey: b });
  }
  static fromJSON(A) {
    return HDKey.fromExtendedKey(A.xpriv);
  }
  constructor(A) {
    if (this.depth = 0, this.index = 0, this.chainCode = null, this.parentFingerprint = 0, !A || typeof A != "object")
      throw new Error("HDKey.constructor must not be called directly");
    if (this.versions = A.versions || BITCOIN_VERSIONS, this.depth = A.depth || 0, this.chainCode = A.chainCode || null, this.index = A.index || 0, this.parentFingerprint = A.parentFingerprint || 0, !this.depth && (this.parentFingerprint || this.index))
      throw new Error("HDKey: zero depth with non-zero index/parent fingerprint");
    if (A.publicKey && A.privateKey)
      throw new Error("HDKey: publicKey and privateKey at same time.");
    if (A.privateKey) {
      if (!secp256k1$3.utils.isValidPrivateKey(A.privateKey))
        throw new Error("Invalid private key");
      this.privKey = typeof A.privateKey == "bigint" ? A.privateKey : bytesToNumber$1(A.privateKey), this.privKeyBytes = numberToBytes$1(this.privKey), this.pubKey = secp256k1$3.getPublicKey(A.privateKey, !0);
    } else if (A.publicKey)
      this.pubKey = Point$1.fromHex(A.publicKey).toRawBytes(!0);
    else
      throw new Error("HDKey: no public or private key provided");
    this.pubHash = hash160$1(this.pubKey);
  }
  derive(A) {
    if (!/^[mM]'?/.test(A))
      throw new Error('Path must start with "m" or "M"');
    if (/^[mM]'?$/.test(A))
      return this;
    const u = A.replace(/^[mM]'?\//, "").split("/");
    let p = this;
    for (const t of u) {
      const l = /^(\d+)('?)$/.exec(t), m = l && l[1];
      if (!l || l.length !== 3 || typeof m != "string")
        throw new Error(`Invalid child index: ${t}`);
      let b = +m;
      if (!Number.isSafeInteger(b) || b >= HARDENED_OFFSET)
        throw new Error("Invalid index");
      l[2] === "'" && (b += HARDENED_OFFSET), p = p.deriveChild(b);
    }
    return p;
  }
  deriveChild(A) {
    if (!this.pubKey || !this.chainCode)
      throw new Error("No publicKey or chainCode set");
    let u = toU32(A);
    if (A >= HARDENED_OFFSET) {
      const b = this.privateKey;
      if (!b)
        throw new Error("Could not derive hardened child key");
      u = concatBytes$5(new Uint8Array([0]), b, u);
    } else
      u = concatBytes$5(this.pubKey, u);
    const p = hmac$2(sha512$2, this.chainCode, u), t = bytesToNumber$1(p.slice(0, 32)), l = p.slice(32);
    if (!secp256k1$3.utils.isValidPrivateKey(t))
      throw new Error("Tweak bigger than curve order");
    const m = {
      versions: this.versions,
      chainCode: l,
      depth: this.depth + 1,
      parentFingerprint: this.fingerprint,
      index: A
    };
    try {
      if (this.privateKey) {
        const b = mod$1(this.privKey + t, secp256k1$3.CURVE.n);
        if (!secp256k1$3.utils.isValidPrivateKey(b))
          throw new Error("The tweak was out of range or the resulted private key is invalid");
        m.privateKey = b;
      } else {
        const b = Point$1.fromHex(this.pubKey).add(Point$1.fromPrivateKey(t));
        if (b.equals(Point$1.ZERO))
          throw new Error("The tweak was equal to negative P, which made the result key invalid");
        m.publicKey = b.toRawBytes(!0);
      }
      return new HDKey(m);
    } catch {
      return this.deriveChild(A + 1);
    }
  }
  sign(A) {
    if (!this.privateKey)
      throw new Error("No privateKey set!");
    return bytes(A, 32), secp256k1$3.sign(A, this.privKey).toCompactRawBytes();
  }
  verify(A, u) {
    if (bytes(A, 32), bytes(u, 64), !this.publicKey)
      throw new Error("No publicKey set!");
    let p;
    try {
      p = secp256k1$3.Signature.fromCompact(u);
    } catch {
      return !1;
    }
    return secp256k1$3.verify(p, A, this.publicKey);
  }
  wipePrivateData() {
    return this.privKey = void 0, this.privKeyBytes && (this.privKeyBytes.fill(0), this.privKeyBytes = void 0), this;
  }
  toJSON() {
    return {
      xpriv: this.privateExtendedKey,
      xpub: this.publicExtendedKey
    };
  }
  serialize(A, u) {
    if (!this.chainCode)
      throw new Error("No chainCode set");
    return bytes(u, 33), concatBytes$5(toU32(A), new Uint8Array([this.depth]), toU32(this.parentFingerprint), toU32(this.index), this.chainCode, u);
  }
}
var bip341Exports = requireBip341(), bip371Exports = requireBip371(), psbtutilsExports = requirePsbtutils(), build$6 = {}, keplr$1 = {}, build$5 = {}, currency = {}, hasRequiredCurrency;
function requireCurrency() {
  return hasRequiredCurrency || (hasRequiredCurrency = 1, Object.defineProperty(currency, "__esModule", { value: !0 })), currency;
}
var bech32$4 = {}, hasRequiredBech32$3;
function requireBech32$3() {
  return hasRequiredBech32$3 || (hasRequiredBech32$3 = 1, Object.defineProperty(bech32$4, "__esModule", { value: !0 })), bech32$4;
}
var bip44 = {}, hasRequiredBip44;
function requireBip44() {
  return hasRequiredBip44 || (hasRequiredBip44 = 1, Object.defineProperty(bip44, "__esModule", { value: !0 })), bip44;
}
var chainInfo = {}, hasRequiredChainInfo;
function requireChainInfo() {
  return hasRequiredChainInfo || (hasRequiredChainInfo = 1, Object.defineProperty(chainInfo, "__esModule", { value: !0 })), chainInfo;
}
var wallet = {}, keplr = {}, hasRequiredKeplr$1;
function requireKeplr$1() {
  return hasRequiredKeplr$1 || (hasRequiredKeplr$1 = 1, Object.defineProperty(keplr, "__esModule", { value: !0 })), keplr;
}
var eip6963 = {}, hasRequiredEip6963;
function requireEip6963() {
  return hasRequiredEip6963 || (hasRequiredEip6963 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.EIP6963EventNames = void 0, function(A) {
      A.Announce = "eip6963:announceProvider", A.Request = "eip6963:requestProvider";
    }(s.EIP6963EventNames || (s.EIP6963EventNames = {}));
  }(eip6963)), eip6963;
}
var ethereum$1 = {}, hasRequiredEthereum$1;
function requireEthereum$1() {
  return hasRequiredEthereum$1 || (hasRequiredEthereum$1 = 1, Object.defineProperty(ethereum$1, "__esModule", { value: !0 })), ethereum$1;
}
var starknet = {}, hasRequiredStarknet;
function requireStarknet() {
  return hasRequiredStarknet || (hasRequiredStarknet = 1, Object.defineProperty(starknet, "__esModule", { value: !0 })), starknet;
}
var bitcoin = {}, hasRequiredBitcoin;
function requireBitcoin() {
  return hasRequiredBitcoin || (hasRequiredBitcoin = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.CHAIN_TYPE_TO_GENESIS_HASH = s.GENESIS_HASH_TO_CHAIN_TYPE = s.NETWORK_TO_GENESIS_HASH = s.GENESIS_HASH_TO_NETWORK = s.ChainType = s.Network = s.GenesisHash = s.BitcoinSignMessageType = void 0, function(t) {
      t.ECDSA = "ecdsa", t.BIP322_SIMPLE = "bip322-simple";
    }(s.BitcoinSignMessageType || (s.BitcoinSignMessageType = {}));
    var A;
    (function(t) {
      t.MAINNET = "000000000019d6689c085ae165831e934ff763ae46a2a6c172b3f1b60a8ce26f", t.TESTNET = "000000000933ea01ad0ee984209779baaec3ced90fa3f408719526f8d77f4943", t.SIGNET = "00000008819873e925422c1ff0f99f7cc9bbb232af63a077a480a3633bee1ef6";
    })(A = s.GenesisHash || (s.GenesisHash = {}));
    var u;
    (function(t) {
      t.MAINNET = "mainnet", t.LIVENET = "livenet", t.TESTNET = "testnet", t.SIGNET = "signet";
    })(u = s.Network || (s.Network = {}));
    var p;
    (function(t) {
      t.BITCOIN_MAINNET = "BITCOIN_MAINNET", t.BITCOIN_TESTNET = "BITCOIN_TESTNET", t.BITCOIN_SIGNET = "BITCOIN_SIGNET";
    })(p = s.ChainType || (s.ChainType = {})), s.GENESIS_HASH_TO_NETWORK = {
      [A.MAINNET]: u.MAINNET,
      [A.TESTNET]: u.TESTNET,
      [A.SIGNET]: u.SIGNET
    }, s.NETWORK_TO_GENESIS_HASH = {
      [u.MAINNET]: A.MAINNET,
      [u.LIVENET]: A.MAINNET,
      [u.TESTNET]: A.TESTNET,
      [u.SIGNET]: A.SIGNET
    }, s.GENESIS_HASH_TO_CHAIN_TYPE = {
      [A.MAINNET]: p.BITCOIN_MAINNET,
      [A.TESTNET]: p.BITCOIN_TESTNET,
      [A.SIGNET]: p.BITCOIN_SIGNET
    }, s.CHAIN_TYPE_TO_GENESIS_HASH = {
      [p.BITCOIN_MAINNET]: A.MAINNET,
      [p.BITCOIN_TESTNET]: A.TESTNET,
      [p.BITCOIN_SIGNET]: A.SIGNET
    };
  }(bitcoin)), bitcoin;
}
var hasRequiredWallet;
function requireWallet() {
  return hasRequiredWallet || (hasRequiredWallet = 1, function(s) {
    var A = wallet && wallet.__createBinding || (Object.create ? function(p, t, l, m) {
      m === void 0 && (m = l);
      var b = Object.getOwnPropertyDescriptor(t, l);
      (!b || ("get" in b ? !t.__esModule : b.writable || b.configurable)) && (b = { enumerable: !0, get: function() {
        return t[l];
      } }), Object.defineProperty(p, m, b);
    } : function(p, t, l, m) {
      m === void 0 && (m = l), p[m] = t[l];
    }), u = wallet && wallet.__exportStar || function(p, t) {
      for (var l in p) l !== "default" && !Object.prototype.hasOwnProperty.call(t, l) && A(t, p, l);
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), u(requireKeplr$1(), s), u(requireEip6963(), s), u(requireEthereum$1(), s), u(requireStarknet(), s), u(requireBitcoin(), s);
  }(wallet)), wallet;
}
var window$1 = {}, hasRequiredWindow;
function requireWindow() {
  return hasRequiredWindow || (hasRequiredWindow = 1, Object.defineProperty(window$1, "__esModule", { value: !0 })), window$1;
}
var ethereum = {}, hasRequiredEthereum;
function requireEthereum() {
  return hasRequiredEthereum || (hasRequiredEthereum = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.EthTxStatus = s.EthSignType = void 0, function(A) {
      A.MESSAGE = "message", A.TRANSACTION = "transaction", A.EIP712 = "eip-712";
    }(s.EthSignType || (s.EthSignType = {})), function(A) {
      A.Success = "0x1", A.Failure = "0x0";
    }(s.EthTxStatus || (s.EthTxStatus = {}));
  }(ethereum)), ethereum;
}
var cosmjs$1 = {}, hasRequiredCosmjs$1;
function requireCosmjs$1() {
  return hasRequiredCosmjs$1 || (hasRequiredCosmjs$1 = 1, Object.defineProperty(cosmjs$1, "__esModule", { value: !0 })), cosmjs$1;
}
var cosmjsAlt = {}, hasRequiredCosmjsAlt;
function requireCosmjsAlt() {
  return hasRequiredCosmjsAlt || (hasRequiredCosmjsAlt = 1, Object.defineProperty(cosmjsAlt, "__esModule", { value: !0 })), cosmjsAlt;
}
var secretjs = {}, hasRequiredSecretjs;
function requireSecretjs() {
  return hasRequiredSecretjs || (hasRequiredSecretjs = 1, Object.defineProperty(secretjs, "__esModule", { value: !0 })), secretjs;
}
var settled = {}, hasRequiredSettled;
function requireSettled() {
  return hasRequiredSettled || (hasRequiredSettled = 1, Object.defineProperty(settled, "__esModule", { value: !0 })), settled;
}
var hasRequiredBuild$6;
function requireBuild$6() {
  return hasRequiredBuild$6 || (hasRequiredBuild$6 = 1, function(s) {
    var A = build$5 && build$5.__createBinding || (Object.create ? function(p, t, l, m) {
      m === void 0 && (m = l);
      var b = Object.getOwnPropertyDescriptor(t, l);
      (!b || ("get" in b ? !t.__esModule : b.writable || b.configurable)) && (b = { enumerable: !0, get: function() {
        return t[l];
      } }), Object.defineProperty(p, m, b);
    } : function(p, t, l, m) {
      m === void 0 && (m = l), p[m] = t[l];
    }), u = build$5 && build$5.__exportStar || function(p, t) {
      for (var l in p) l !== "default" && !Object.prototype.hasOwnProperty.call(t, l) && A(t, p, l);
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), u(requireCurrency(), s), u(requireBech32$3(), s), u(requireBip44(), s), u(requireChainInfo(), s), u(requireWallet(), s), u(requireWindow(), s), u(requireEthereum(), s), u(requireCosmjs$1(), s), u(requireCosmjsAlt(), s), u(requireSecretjs(), s), u(requireSettled(), s);
  }(build$5)), build$5;
}
var uint8Array = {}, hex$3 = {}, hasRequiredHex$2;
function requireHex$2() {
  if (hasRequiredHex$2) return hex$3;
  hasRequiredHex$2 = 1, Object.defineProperty(hex$3, "__esModule", { value: !0 }), hex$3.fromHex = hex$3.toHex = void 0;
  function s(u) {
    let p = "";
    for (const t of u)
      p += ("0" + t.toString(16)).slice(-2);
    return p;
  }
  hex$3.toHex = s;
  function A(u) {
    if (u.length % 2 !== 0)
      throw new Error("hex string length must be a multiple of 2");
    const p = [];
    for (let t = 0; t < u.length; t += 2) {
      const l = u.substr(t, 2);
      if (!l.match(/[0-9a-f]{2}/i))
        throw new Error("hex string contains invalid characters");
      p.push(parseInt(l, 16));
    }
    return new Uint8Array(p);
  }
  return hex$3.fromHex = A, hex$3;
}
var hasRequiredUint8Array;
function requireUint8Array() {
  if (hasRequiredUint8Array) return uint8Array;
  hasRequiredUint8Array = 1, Object.defineProperty(uint8Array, "__esModule", { value: !0 }), uint8Array.JSONUint8Array = void 0;
  const s = requireHex$2();
  class A {
    static parse(p) {
      return JSON.parse(p, (t, l) => {
        if (t === "__proto__")
          throw new Error("__proto__ is disallowed");
        return l && typeof l == "string" && l.startsWith("__uint8array__") ? (0, s.fromHex)(l.replace("__uint8array__", "")) : typeof BigInt < "u" && l && typeof l == "string" && l.startsWith("__bigint__") ? BigInt(l.replace("__bigint__", "")) : l;
      });
    }
    static stringify(p) {
      return JSON.stringify(p, (t, l) => {
        if (t === "__proto__")
          throw new Error("__proto__ is disallowed");
        if (l && (l instanceof Uint8Array || typeof l == "object" && "type" in l && "data" in l && l.type === "Buffer" && Array.isArray(l.data))) {
          const m = l instanceof Uint8Array ? l : new Uint8Array(l.data);
          return `__uint8array__${(0, s.toHex)(m)}`;
        }
        return typeof l == "bigint" ? `__bigint__${l.toString()}` : l;
      });
    }
    static wrap(p) {
      if (p !== void 0)
        return JSON.parse(A.stringify(p));
    }
    static unwrap(p) {
      if (p !== void 0)
        return A.parse(A.stringify(p));
    }
  }
  return uint8Array.JSONUint8Array = A, uint8Array;
}
var cjs$2, hasRequiredCjs$2;
function requireCjs$2() {
  if (hasRequiredCjs$2) return cjs$2;
  hasRequiredCjs$2 = 1;
  var s = function(pe) {
    return A(pe) && !u(pe);
  };
  function A(ge) {
    return !!ge && typeof ge == "object";
  }
  function u(ge) {
    var pe = Object.prototype.toString.call(ge);
    return pe === "[object RegExp]" || pe === "[object Date]" || l(ge);
  }
  var p = typeof Symbol == "function" && Symbol.for, t = p ? Symbol.for("react.element") : 60103;
  function l(ge) {
    return ge.$$typeof === t;
  }
  function m(ge) {
    return Array.isArray(ge) ? [] : {};
  }
  function b(ge, pe) {
    return pe.clone !== !1 && pe.isMergeableObject(ge) ? F(m(ge), ge, pe) : ge;
  }
  function k(ge, pe, Ie) {
    return ge.concat(pe).map(function(be) {
      return b(be, Ie);
    });
  }
  function C(ge, pe) {
    if (!pe.customMerge)
      return F;
    var Ie = pe.customMerge(ge);
    return typeof Ie == "function" ? Ie : F;
  }
  function B(ge) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(ge).filter(function(pe) {
      return Object.propertyIsEnumerable.call(ge, pe);
    }) : [];
  }
  function Q(ge) {
    return Object.keys(ge).concat(B(ge));
  }
  function P(ge, pe) {
    try {
      return pe in ge;
    } catch {
      return !1;
    }
  }
  function x(ge, pe) {
    return P(ge, pe) && !(Object.hasOwnProperty.call(ge, pe) && Object.propertyIsEnumerable.call(ge, pe));
  }
  function M(ge, pe, Ie) {
    var be = {};
    return Ie.isMergeableObject(ge) && Q(ge).forEach(function(Pe) {
      be[Pe] = b(ge[Pe], Ie);
    }), Q(pe).forEach(function(Pe) {
      x(ge, Pe) || (P(ge, Pe) && Ie.isMergeableObject(pe[Pe]) ? be[Pe] = C(Pe, Ie)(ge[Pe], pe[Pe], Ie) : be[Pe] = b(pe[Pe], Ie));
    }), be;
  }
  function F(ge, pe, Ie) {
    Ie = Ie || {}, Ie.arrayMerge = Ie.arrayMerge || k, Ie.isMergeableObject = Ie.isMergeableObject || s, Ie.cloneUnlessOtherwiseSpecified = b;
    var be = Array.isArray(pe), Pe = Array.isArray(ge), Te = be === Pe;
    return Te ? be ? Ie.arrayMerge(ge, pe, Ie) : M(ge, pe, Ie) : b(pe, Ie);
  }
  F.all = function(pe, Ie) {
    if (!Array.isArray(pe))
      throw new Error("first argument should be an array");
    return pe.reduce(function(be, Pe) {
      return F(be, Pe, Ie);
    }, {});
  };
  var le = F;
  return cjs$2 = le, cjs$2;
}
var long, hasRequiredLong;
function requireLong() {
  if (hasRequiredLong) return long;
  hasRequiredLong = 1, long = A;
  var s = null;
  try {
    s = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
      0,
      97,
      115,
      109,
      1,
      0,
      0,
      0,
      1,
      13,
      2,
      96,
      0,
      1,
      127,
      96,
      4,
      127,
      127,
      127,
      127,
      1,
      127,
      3,
      7,
      6,
      0,
      1,
      1,
      1,
      1,
      1,
      6,
      6,
      1,
      127,
      1,
      65,
      0,
      11,
      7,
      50,
      6,
      3,
      109,
      117,
      108,
      0,
      1,
      5,
      100,
      105,
      118,
      95,
      115,
      0,
      2,
      5,
      100,
      105,
      118,
      95,
      117,
      0,
      3,
      5,
      114,
      101,
      109,
      95,
      115,
      0,
      4,
      5,
      114,
      101,
      109,
      95,
      117,
      0,
      5,
      8,
      103,
      101,
      116,
      95,
      104,
      105,
      103,
      104,
      0,
      0,
      10,
      191,
      1,
      6,
      4,
      0,
      35,
      0,
      11,
      36,
      1,
      1,
      126,
      32,
      0,
      173,
      32,
      1,
      173,
      66,
      32,
      134,
      132,
      32,
      2,
      173,
      32,
      3,
      173,
      66,
      32,
      134,
      132,
      126,
      34,
      4,
      66,
      32,
      135,
      167,
      36,
      0,
      32,
      4,
      167,
      11,
      36,
      1,
      1,
      126,
      32,
      0,
      173,
      32,
      1,
      173,
      66,
      32,
      134,
      132,
      32,
      2,
      173,
      32,
      3,
      173,
      66,
      32,
      134,
      132,
      127,
      34,
      4,
      66,
      32,
      135,
      167,
      36,
      0,
      32,
      4,
      167,
      11,
      36,
      1,
      1,
      126,
      32,
      0,
      173,
      32,
      1,
      173,
      66,
      32,
      134,
      132,
      32,
      2,
      173,
      32,
      3,
      173,
      66,
      32,
      134,
      132,
      128,
      34,
      4,
      66,
      32,
      135,
      167,
      36,
      0,
      32,
      4,
      167,
      11,
      36,
      1,
      1,
      126,
      32,
      0,
      173,
      32,
      1,
      173,
      66,
      32,
      134,
      132,
      32,
      2,
      173,
      32,
      3,
      173,
      66,
      32,
      134,
      132,
      129,
      34,
      4,
      66,
      32,
      135,
      167,
      36,
      0,
      32,
      4,
      167,
      11,
      36,
      1,
      1,
      126,
      32,
      0,
      173,
      32,
      1,
      173,
      66,
      32,
      134,
      132,
      32,
      2,
      173,
      32,
      3,
      173,
      66,
      32,
      134,
      132,
      130,
      34,
      4,
      66,
      32,
      135,
      167,
      36,
      0,
      32,
      4,
      167,
      11
    ])), {}).exports;
  } catch {
  }
  function A(He, ve, we) {
    this.low = He | 0, this.high = ve | 0, this.unsigned = !!we;
  }
  A.prototype.__isLong__, Object.defineProperty(A.prototype, "__isLong__", { value: !0 });
  function u(He) {
    return (He && He.__isLong__) === !0;
  }
  A.isLong = u;
  var p = {}, t = {};
  function l(He, ve) {
    var we, Ce, Se;
    return ve ? (He >>>= 0, (Se = 0 <= He && He < 256) && (Ce = t[He], Ce) ? Ce : (we = b(He, (He | 0) < 0 ? -1 : 0, !0), Se && (t[He] = we), we)) : (He |= 0, (Se = -128 <= He && He < 128) && (Ce = p[He], Ce) ? Ce : (we = b(He, He < 0 ? -1 : 0, !1), Se && (p[He] = we), we));
  }
  A.fromInt = l;
  function m(He, ve) {
    if (isNaN(He))
      return ve ? pe : ge;
    if (ve) {
      if (He < 0)
        return pe;
      if (He >= M)
        return Qe;
    } else {
      if (He <= -F)
        return xe;
      if (He + 1 >= F)
        return Te;
    }
    return He < 0 ? m(-He, ve).neg() : b(He % x | 0, He / x | 0, ve);
  }
  A.fromNumber = m;
  function b(He, ve, we) {
    return new A(He, ve, we);
  }
  A.fromBits = b;
  var k = Math.pow;
  function C(He, ve, we) {
    if (He.length === 0)
      throw Error("empty string");
    if (He === "NaN" || He === "Infinity" || He === "+Infinity" || He === "-Infinity")
      return ge;
    if (typeof ve == "number" ? (we = ve, ve = !1) : ve = !!ve, we = we || 10, we < 2 || 36 < we)
      throw RangeError("radix");
    var Ce;
    if ((Ce = He.indexOf("-")) > 0)
      throw Error("interior hyphen");
    if (Ce === 0)
      return C(He.substring(1), ve, we).neg();
    for (var Se = m(k(we, 8)), Ne = ge, rr = 0; rr < He.length; rr += 8) {
      var er = Math.min(8, He.length - rr), ir = parseInt(He.substring(rr, rr + er), we);
      if (er < 8) {
        var sr = m(k(we, er));
        Ne = Ne.mul(sr).add(m(ir));
      } else
        Ne = Ne.mul(Se), Ne = Ne.add(m(ir));
    }
    return Ne.unsigned = ve, Ne;
  }
  A.fromString = C;
  function B(He, ve) {
    return typeof He == "number" ? m(He, ve) : typeof He == "string" ? C(He, ve) : b(He.low, He.high, typeof ve == "boolean" ? ve : He.unsigned);
  }
  A.fromValue = B;
  var Q = 65536, P = 1 << 24, x = Q * Q, M = x * x, F = M / 2, le = l(P), ge = l(0);
  A.ZERO = ge;
  var pe = l(0, !0);
  A.UZERO = pe;
  var Ie = l(1);
  A.ONE = Ie;
  var be = l(1, !0);
  A.UONE = be;
  var Pe = l(-1);
  A.NEG_ONE = Pe;
  var Te = b(-1, 2147483647, !1);
  A.MAX_VALUE = Te;
  var Qe = b(-1, -1, !0);
  A.MAX_UNSIGNED_VALUE = Qe;
  var xe = b(0, -2147483648, !1);
  A.MIN_VALUE = xe;
  var Ee = A.prototype;
  return Ee.toInt = function() {
    return this.unsigned ? this.low >>> 0 : this.low;
  }, Ee.toNumber = function() {
    return this.unsigned ? (this.high >>> 0) * x + (this.low >>> 0) : this.high * x + (this.low >>> 0);
  }, Ee.toString = function(ve) {
    if (ve = ve || 10, ve < 2 || 36 < ve)
      throw RangeError("radix");
    if (this.isZero())
      return "0";
    if (this.isNegative())
      if (this.eq(xe)) {
        var we = m(ve), Ce = this.div(we), Se = Ce.mul(we).sub(this);
        return Ce.toString(ve) + Se.toInt().toString(ve);
      } else
        return "-" + this.neg().toString(ve);
    for (var Ne = m(k(ve, 6), this.unsigned), rr = this, er = ""; ; ) {
      var ir = rr.div(Ne), sr = rr.sub(ir.mul(Ne)).toInt() >>> 0, nr = sr.toString(ve);
      if (rr = ir, rr.isZero())
        return nr + er;
      for (; nr.length < 6; )
        nr = "0" + nr;
      er = "" + nr + er;
    }
  }, Ee.getHighBits = function() {
    return this.high;
  }, Ee.getHighBitsUnsigned = function() {
    return this.high >>> 0;
  }, Ee.getLowBits = function() {
    return this.low;
  }, Ee.getLowBitsUnsigned = function() {
    return this.low >>> 0;
  }, Ee.getNumBitsAbs = function() {
    if (this.isNegative())
      return this.eq(xe) ? 64 : this.neg().getNumBitsAbs();
    for (var ve = this.high != 0 ? this.high : this.low, we = 31; we > 0 && (ve & 1 << we) == 0; we--)
      ;
    return this.high != 0 ? we + 33 : we + 1;
  }, Ee.isZero = function() {
    return this.high === 0 && this.low === 0;
  }, Ee.eqz = Ee.isZero, Ee.isNegative = function() {
    return !this.unsigned && this.high < 0;
  }, Ee.isPositive = function() {
    return this.unsigned || this.high >= 0;
  }, Ee.isOdd = function() {
    return (this.low & 1) === 1;
  }, Ee.isEven = function() {
    return (this.low & 1) === 0;
  }, Ee.equals = function(ve) {
    return u(ve) || (ve = B(ve)), this.unsigned !== ve.unsigned && this.high >>> 31 === 1 && ve.high >>> 31 === 1 ? !1 : this.high === ve.high && this.low === ve.low;
  }, Ee.eq = Ee.equals, Ee.notEquals = function(ve) {
    return !this.eq(
      /* validates */
      ve
    );
  }, Ee.neq = Ee.notEquals, Ee.ne = Ee.notEquals, Ee.lessThan = function(ve) {
    return this.comp(
      /* validates */
      ve
    ) < 0;
  }, Ee.lt = Ee.lessThan, Ee.lessThanOrEqual = function(ve) {
    return this.comp(
      /* validates */
      ve
    ) <= 0;
  }, Ee.lte = Ee.lessThanOrEqual, Ee.le = Ee.lessThanOrEqual, Ee.greaterThan = function(ve) {
    return this.comp(
      /* validates */
      ve
    ) > 0;
  }, Ee.gt = Ee.greaterThan, Ee.greaterThanOrEqual = function(ve) {
    return this.comp(
      /* validates */
      ve
    ) >= 0;
  }, Ee.gte = Ee.greaterThanOrEqual, Ee.ge = Ee.greaterThanOrEqual, Ee.compare = function(ve) {
    if (u(ve) || (ve = B(ve)), this.eq(ve))
      return 0;
    var we = this.isNegative(), Ce = ve.isNegative();
    return we && !Ce ? -1 : !we && Ce ? 1 : this.unsigned ? ve.high >>> 0 > this.high >>> 0 || ve.high === this.high && ve.low >>> 0 > this.low >>> 0 ? -1 : 1 : this.sub(ve).isNegative() ? -1 : 1;
  }, Ee.comp = Ee.compare, Ee.negate = function() {
    return !this.unsigned && this.eq(xe) ? xe : this.not().add(Ie);
  }, Ee.neg = Ee.negate, Ee.add = function(ve) {
    u(ve) || (ve = B(ve));
    var we = this.high >>> 16, Ce = this.high & 65535, Se = this.low >>> 16, Ne = this.low & 65535, rr = ve.high >>> 16, er = ve.high & 65535, ir = ve.low >>> 16, sr = ve.low & 65535, nr = 0, fr = 0, lr = 0, br = 0;
    return br += Ne + sr, lr += br >>> 16, br &= 65535, lr += Se + ir, fr += lr >>> 16, lr &= 65535, fr += Ce + er, nr += fr >>> 16, fr &= 65535, nr += we + rr, nr &= 65535, b(lr << 16 | br, nr << 16 | fr, this.unsigned);
  }, Ee.subtract = function(ve) {
    return u(ve) || (ve = B(ve)), this.add(ve.neg());
  }, Ee.sub = Ee.subtract, Ee.multiply = function(ve) {
    if (this.isZero())
      return ge;
    if (u(ve) || (ve = B(ve)), s) {
      var we = s.mul(
        this.low,
        this.high,
        ve.low,
        ve.high
      );
      return b(we, s.get_high(), this.unsigned);
    }
    if (ve.isZero())
      return ge;
    if (this.eq(xe))
      return ve.isOdd() ? xe : ge;
    if (ve.eq(xe))
      return this.isOdd() ? xe : ge;
    if (this.isNegative())
      return ve.isNegative() ? this.neg().mul(ve.neg()) : this.neg().mul(ve).neg();
    if (ve.isNegative())
      return this.mul(ve.neg()).neg();
    if (this.lt(le) && ve.lt(le))
      return m(this.toNumber() * ve.toNumber(), this.unsigned);
    var Ce = this.high >>> 16, Se = this.high & 65535, Ne = this.low >>> 16, rr = this.low & 65535, er = ve.high >>> 16, ir = ve.high & 65535, sr = ve.low >>> 16, nr = ve.low & 65535, fr = 0, lr = 0, br = 0, Br = 0;
    return Br += rr * nr, br += Br >>> 16, Br &= 65535, br += Ne * nr, lr += br >>> 16, br &= 65535, br += rr * sr, lr += br >>> 16, br &= 65535, lr += Se * nr, fr += lr >>> 16, lr &= 65535, lr += Ne * sr, fr += lr >>> 16, lr &= 65535, lr += rr * ir, fr += lr >>> 16, lr &= 65535, fr += Ce * nr + Se * sr + Ne * ir + rr * er, fr &= 65535, b(br << 16 | Br, fr << 16 | lr, this.unsigned);
  }, Ee.mul = Ee.multiply, Ee.divide = function(ve) {
    if (u(ve) || (ve = B(ve)), ve.isZero())
      throw Error("division by zero");
    if (s) {
      if (!this.unsigned && this.high === -2147483648 && ve.low === -1 && ve.high === -1)
        return this;
      var we = (this.unsigned ? s.div_u : s.div_s)(
        this.low,
        this.high,
        ve.low,
        ve.high
      );
      return b(we, s.get_high(), this.unsigned);
    }
    if (this.isZero())
      return this.unsigned ? pe : ge;
    var Ce, Se, Ne;
    if (this.unsigned) {
      if (ve.unsigned || (ve = ve.toUnsigned()), ve.gt(this))
        return pe;
      if (ve.gt(this.shru(1)))
        return be;
      Ne = pe;
    } else {
      if (this.eq(xe)) {
        if (ve.eq(Ie) || ve.eq(Pe))
          return xe;
        if (ve.eq(xe))
          return Ie;
        var rr = this.shr(1);
        return Ce = rr.div(ve).shl(1), Ce.eq(ge) ? ve.isNegative() ? Ie : Pe : (Se = this.sub(ve.mul(Ce)), Ne = Ce.add(Se.div(ve)), Ne);
      } else if (ve.eq(xe))
        return this.unsigned ? pe : ge;
      if (this.isNegative())
        return ve.isNegative() ? this.neg().div(ve.neg()) : this.neg().div(ve).neg();
      if (ve.isNegative())
        return this.div(ve.neg()).neg();
      Ne = ge;
    }
    for (Se = this; Se.gte(ve); ) {
      Ce = Math.max(1, Math.floor(Se.toNumber() / ve.toNumber()));
      for (var er = Math.ceil(Math.log(Ce) / Math.LN2), ir = er <= 48 ? 1 : k(2, er - 48), sr = m(Ce), nr = sr.mul(ve); nr.isNegative() || nr.gt(Se); )
        Ce -= ir, sr = m(Ce, this.unsigned), nr = sr.mul(ve);
      sr.isZero() && (sr = Ie), Ne = Ne.add(sr), Se = Se.sub(nr);
    }
    return Ne;
  }, Ee.div = Ee.divide, Ee.modulo = function(ve) {
    if (u(ve) || (ve = B(ve)), s) {
      var we = (this.unsigned ? s.rem_u : s.rem_s)(
        this.low,
        this.high,
        ve.low,
        ve.high
      );
      return b(we, s.get_high(), this.unsigned);
    }
    return this.sub(this.div(ve).mul(ve));
  }, Ee.mod = Ee.modulo, Ee.rem = Ee.modulo, Ee.not = function() {
    return b(~this.low, ~this.high, this.unsigned);
  }, Ee.and = function(ve) {
    return u(ve) || (ve = B(ve)), b(this.low & ve.low, this.high & ve.high, this.unsigned);
  }, Ee.or = function(ve) {
    return u(ve) || (ve = B(ve)), b(this.low | ve.low, this.high | ve.high, this.unsigned);
  }, Ee.xor = function(ve) {
    return u(ve) || (ve = B(ve)), b(this.low ^ ve.low, this.high ^ ve.high, this.unsigned);
  }, Ee.shiftLeft = function(ve) {
    return u(ve) && (ve = ve.toInt()), (ve &= 63) === 0 ? this : ve < 32 ? b(this.low << ve, this.high << ve | this.low >>> 32 - ve, this.unsigned) : b(0, this.low << ve - 32, this.unsigned);
  }, Ee.shl = Ee.shiftLeft, Ee.shiftRight = function(ve) {
    return u(ve) && (ve = ve.toInt()), (ve &= 63) === 0 ? this : ve < 32 ? b(this.low >>> ve | this.high << 32 - ve, this.high >> ve, this.unsigned) : b(this.high >> ve - 32, this.high >= 0 ? 0 : -1, this.unsigned);
  }, Ee.shr = Ee.shiftRight, Ee.shiftRightUnsigned = function(ve) {
    if (u(ve) && (ve = ve.toInt()), ve &= 63, ve === 0)
      return this;
    var we = this.high;
    if (ve < 32) {
      var Ce = this.low;
      return b(Ce >>> ve | we << 32 - ve, we >>> ve, this.unsigned);
    } else return ve === 32 ? b(we, 0, this.unsigned) : b(we >>> ve - 32, 0, this.unsigned);
  }, Ee.shru = Ee.shiftRightUnsigned, Ee.shr_u = Ee.shiftRightUnsigned, Ee.toSigned = function() {
    return this.unsigned ? b(this.low, this.high, !1) : this;
  }, Ee.toUnsigned = function() {
    return this.unsigned ? this : b(this.low, this.high, !0);
  }, Ee.toBytes = function(ve) {
    return ve ? this.toBytesLE() : this.toBytesBE();
  }, Ee.toBytesLE = function() {
    var ve = this.high, we = this.low;
    return [
      we & 255,
      we >>> 8 & 255,
      we >>> 16 & 255,
      we >>> 24,
      ve & 255,
      ve >>> 8 & 255,
      ve >>> 16 & 255,
      ve >>> 24
    ];
  }, Ee.toBytesBE = function() {
    var ve = this.high, we = this.low;
    return [
      ve >>> 24,
      ve >>> 16 & 255,
      ve >>> 8 & 255,
      ve & 255,
      we >>> 24,
      we >>> 16 & 255,
      we >>> 8 & 255,
      we & 255
    ];
  }, A.fromBytes = function(ve, we, Ce) {
    return Ce ? A.fromBytesLE(ve, we) : A.fromBytesBE(ve, we);
  }, A.fromBytesLE = function(ve, we) {
    return new A(
      ve[0] | ve[1] << 8 | ve[2] << 16 | ve[3] << 24,
      ve[4] | ve[5] << 8 | ve[6] << 16 | ve[7] << 24,
      we
    );
  }, A.fromBytesBE = function(ve, we) {
    return new A(
      ve[4] << 24 | ve[5] << 16 | ve[6] << 8 | ve[7],
      ve[0] << 24 | ve[1] << 16 | ve[2] << 8 | ve[3],
      we
    );
  }, long;
}
var cosmjs = {}, hasRequiredCosmjs;
function requireCosmjs() {
  if (hasRequiredCosmjs) return cosmjs;
  hasRequiredCosmjs = 1;
  var s = cosmjs && cosmjs.__awaiter || function(p, t, l, m) {
    function b(k) {
      return k instanceof l ? k : new l(function(C) {
        C(k);
      });
    }
    return new (l || (l = Promise))(function(k, C) {
      function B(x) {
        try {
          P(m.next(x));
        } catch (M) {
          C(M);
        }
      }
      function Q(x) {
        try {
          P(m.throw(x));
        } catch (M) {
          C(M);
        }
      }
      function P(x) {
        x.done ? k(x.value) : b(x.value).then(B, Q);
      }
      P((m = m.apply(p, t || [])).next());
    });
  };
  Object.defineProperty(cosmjs, "__esModule", { value: !0 }), cosmjs.CosmJSOfflineSigner = cosmjs.CosmJSOfflineSignerOnlyAmino = void 0;
  class A {
    constructor(t, l, m) {
      this.chainId = t, this.keplr = l, this.signOptions = m;
    }
    getAccounts() {
      return s(this, void 0, void 0, function* () {
        const t = yield this.keplr.getKey(this.chainId);
        return [
          {
            address: t.bech32Address,
            // Currently, only secp256k1 is supported.
            algo: "secp256k1",
            pubkey: t.pubKey
          }
        ];
      });
    }
    signAmino(t, l) {
      return s(this, void 0, void 0, function* () {
        if (this.chainId !== l.chain_id)
          throw new Error("Unmatched chain id with the offline signer");
        if ((yield this.keplr.getKey(l.chain_id)).bech32Address !== t)
          throw new Error("Unknown signer address");
        return yield this.keplr.signAmino(this.chainId, t, l, this.signOptions);
      });
    }
    // Fallback function for the legacy cosmjs implementation before the stargate.
    sign(t, l) {
      return s(this, void 0, void 0, function* () {
        return yield this.signAmino(t, l);
      });
    }
  }
  cosmjs.CosmJSOfflineSignerOnlyAmino = A;
  class u extends A {
    constructor(t, l, m) {
      super(t, l, m);
    }
    signDirect(t, l) {
      return s(this, void 0, void 0, function* () {
        if (this.chainId !== l.chainId)
          throw new Error("Unmatched chain id with the offline signer");
        if ((yield this.keplr.getKey(l.chainId)).bech32Address !== t)
          throw new Error("Unknown signer address");
        return yield this.keplr.signDirect(this.chainId, t, l, this.signOptions);
      });
    }
  }
  return cosmjs.CosmJSOfflineSigner = u, cosmjs;
}
var enigma = {}, hasRequiredEnigma;
function requireEnigma() {
  if (hasRequiredEnigma) return enigma;
  hasRequiredEnigma = 1;
  var s = enigma && enigma.__awaiter || function(u, p, t, l) {
    function m(b) {
      return b instanceof t ? b : new t(function(k) {
        k(b);
      });
    }
    return new (t || (t = Promise))(function(b, k) {
      function C(P) {
        try {
          Q(l.next(P));
        } catch (x) {
          k(x);
        }
      }
      function B(P) {
        try {
          Q(l.throw(P));
        } catch (x) {
          k(x);
        }
      }
      function Q(P) {
        P.done ? b(P.value) : m(P.value).then(C, B);
      }
      Q((l = l.apply(u, p || [])).next());
    });
  };
  Object.defineProperty(enigma, "__esModule", { value: !0 }), enigma.KeplrEnigmaUtils = void 0;
  class A {
    constructor(p, t) {
      this.chainId = p, this.keplr = t;
    }
    getPubkey() {
      return s(this, void 0, void 0, function* () {
        return yield this.keplr.getEnigmaPubKey(this.chainId);
      });
    }
    getTxEncryptionKey(p) {
      return s(this, void 0, void 0, function* () {
        return yield this.keplr.getEnigmaTxEncryptionKey(this.chainId, p);
      });
    }
    encrypt(p, t) {
      return s(this, void 0, void 0, function* () {
        return yield this.keplr.enigmaEncrypt(this.chainId, p, t);
      });
    }
    decrypt(p, t) {
      return s(this, void 0, void 0, function* () {
        return yield this.keplr.enigmaDecrypt(this.chainId, p, t);
      });
    }
  }
  return enigma.KeplrEnigmaUtils = A, enigma;
}
var version$5 = {}, hasRequiredVersion$1;
function requireVersion$1() {
  return hasRequiredVersion$1 || (hasRequiredVersion$1 = 1, Object.defineProperty(version$5, "__esModule", { value: !0 }), version$5.BUILD_VERSION = void 0, version$5.BUILD_VERSION = "0.12.272"), version$5;
}
var constants$1 = {}, hasRequiredConstants$1;
function requireConstants$1() {
  return hasRequiredConstants$1 || (hasRequiredConstants$1 = 1, Object.defineProperty(constants$1, "__esModule", { value: !0 }), constants$1.metaId = constants$1.KeplrLogoBase64 = void 0, constants$1.KeplrLogoBase64 = "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", constants$1.metaId = "d_2hxd99brRo"), constants$1;
}
var cjsBrowser = {}, max = {}, hasRequiredMax;
function requireMax() {
  return hasRequiredMax || (hasRequiredMax = 1, Object.defineProperty(max, "__esModule", { value: !0 }), max.default = "ffffffff-ffff-ffff-ffff-ffffffffffff"), max;
}
var nil = {}, hasRequiredNil;
function requireNil() {
  return hasRequiredNil || (hasRequiredNil = 1, Object.defineProperty(nil, "__esModule", { value: !0 }), nil.default = "00000000-0000-0000-0000-000000000000"), nil;
}
var parse = {}, validate$1 = {}, regex = {}, hasRequiredRegex;
function requireRegex() {
  return hasRequiredRegex || (hasRequiredRegex = 1, Object.defineProperty(regex, "__esModule", { value: !0 }), regex.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i), regex;
}
var hasRequiredValidate;
function requireValidate() {
  if (hasRequiredValidate) return validate$1;
  hasRequiredValidate = 1, Object.defineProperty(validate$1, "__esModule", { value: !0 });
  const s = requireRegex();
  function A(u) {
    return typeof u == "string" && s.default.test(u);
  }
  return validate$1.default = A, validate$1;
}
var hasRequiredParse$1;
function requireParse$1() {
  if (hasRequiredParse$1) return parse;
  hasRequiredParse$1 = 1, Object.defineProperty(parse, "__esModule", { value: !0 });
  const s = requireValidate();
  function A(u) {
    if (!(0, s.default)(u))
      throw TypeError("Invalid UUID");
    let p;
    return Uint8Array.of((p = parseInt(u.slice(0, 8), 16)) >>> 24, p >>> 16 & 255, p >>> 8 & 255, p & 255, (p = parseInt(u.slice(9, 13), 16)) >>> 8, p & 255, (p = parseInt(u.slice(14, 18), 16)) >>> 8, p & 255, (p = parseInt(u.slice(19, 23), 16)) >>> 8, p & 255, (p = parseInt(u.slice(24, 36), 16)) / 1099511627776 & 255, p / 4294967296 & 255, p >>> 24 & 255, p >>> 16 & 255, p >>> 8 & 255, p & 255);
  }
  return parse.default = A, parse;
}
var stringify$1 = {}, hasRequiredStringify;
function requireStringify() {
  if (hasRequiredStringify) return stringify$1;
  hasRequiredStringify = 1, Object.defineProperty(stringify$1, "__esModule", { value: !0 }), stringify$1.unsafeStringify = void 0;
  const s = requireValidate(), A = [];
  for (let t = 0; t < 256; ++t)
    A.push((t + 256).toString(16).slice(1));
  function u(t, l = 0) {
    return (A[t[l + 0]] + A[t[l + 1]] + A[t[l + 2]] + A[t[l + 3]] + "-" + A[t[l + 4]] + A[t[l + 5]] + "-" + A[t[l + 6]] + A[t[l + 7]] + "-" + A[t[l + 8]] + A[t[l + 9]] + "-" + A[t[l + 10]] + A[t[l + 11]] + A[t[l + 12]] + A[t[l + 13]] + A[t[l + 14]] + A[t[l + 15]]).toLowerCase();
  }
  stringify$1.unsafeStringify = u;
  function p(t, l = 0) {
    const m = u(t, l);
    if (!(0, s.default)(m))
      throw TypeError("Stringified UUID is invalid");
    return m;
  }
  return stringify$1.default = p, stringify$1;
}
var v1 = {}, rng$1 = {}, hasRequiredRng;
function requireRng() {
  if (hasRequiredRng) return rng$1;
  hasRequiredRng = 1, Object.defineProperty(rng$1, "__esModule", { value: !0 });
  let s;
  const A = new Uint8Array(16);
  function u() {
    if (!s) {
      if (typeof crypto > "u" || !crypto.getRandomValues)
        throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
      s = crypto.getRandomValues.bind(crypto);
    }
    return s(A);
  }
  return rng$1.default = u, rng$1;
}
var hasRequiredV1;
function requireV1() {
  if (hasRequiredV1) return v1;
  hasRequiredV1 = 1, Object.defineProperty(v1, "__esModule", { value: !0 }), v1.updateV1State = void 0;
  const s = requireRng(), A = requireStringify(), u = {};
  function p(m, b, k) {
    var Q;
    let C;
    const B = (m == null ? void 0 : m._v6) ?? !1;
    if (m) {
      const P = Object.keys(m);
      P.length === 1 && P[0] === "_v6" && (m = void 0);
    }
    if (m)
      C = l(m.random ?? ((Q = m.rng) == null ? void 0 : Q.call(m)) ?? (0, s.default)(), m.msecs, m.nsecs, m.clockseq, m.node, b, k);
    else {
      const P = Date.now(), x = (0, s.default)();
      t(u, P, x), C = l(x, u.msecs, u.nsecs, B ? void 0 : u.clockseq, B ? void 0 : u.node, b, k);
    }
    return b ?? (0, A.unsafeStringify)(C);
  }
  function t(m, b, k) {
    return m.msecs ?? (m.msecs = -1 / 0), m.nsecs ?? (m.nsecs = 0), b === m.msecs ? (m.nsecs++, m.nsecs >= 1e4 && (m.node = void 0, m.nsecs = 0)) : b > m.msecs ? m.nsecs = 0 : b < m.msecs && (m.node = void 0), m.node || (m.node = k.slice(10, 16), m.node[0] |= 1, m.clockseq = (k[8] << 8 | k[9]) & 16383), m.msecs = b, m;
  }
  v1.updateV1State = t;
  function l(m, b, k, C, B, Q, P = 0) {
    if (m.length < 16)
      throw new Error("Random bytes length must be >= 16");
    if (!Q)
      Q = new Uint8Array(16), P = 0;
    else if (P < 0 || P + 16 > Q.length)
      throw new RangeError(`UUID byte range ${P}:${P + 15} is out of buffer bounds`);
    b ?? (b = Date.now()), k ?? (k = 0), C ?? (C = (m[8] << 8 | m[9]) & 16383), B ?? (B = m.slice(10, 16)), b += 122192928e5;
    const x = ((b & 268435455) * 1e4 + k) % 4294967296;
    Q[P++] = x >>> 24 & 255, Q[P++] = x >>> 16 & 255, Q[P++] = x >>> 8 & 255, Q[P++] = x & 255;
    const M = b / 4294967296 * 1e4 & 268435455;
    Q[P++] = M >>> 8 & 255, Q[P++] = M & 255, Q[P++] = M >>> 24 & 15 | 16, Q[P++] = M >>> 16 & 255, Q[P++] = C >>> 8 | 128, Q[P++] = C & 255;
    for (let F = 0; F < 6; ++F)
      Q[P++] = B[F];
    return Q;
  }
  return v1.default = p, v1;
}
var v1ToV6 = {}, hasRequiredV1ToV6;
function requireV1ToV6() {
  if (hasRequiredV1ToV6) return v1ToV6;
  hasRequiredV1ToV6 = 1, Object.defineProperty(v1ToV6, "__esModule", { value: !0 });
  const s = requireParse$1(), A = requireStringify();
  function u(t) {
    const l = typeof t == "string" ? (0, s.default)(t) : t, m = p(l);
    return typeof t == "string" ? (0, A.unsafeStringify)(m) : m;
  }
  v1ToV6.default = u;
  function p(t) {
    return Uint8Array.of((t[6] & 15) << 4 | t[7] >> 4 & 15, (t[7] & 15) << 4 | (t[4] & 240) >> 4, (t[4] & 15) << 4 | (t[5] & 240) >> 4, (t[5] & 15) << 4 | (t[0] & 240) >> 4, (t[0] & 15) << 4 | (t[1] & 240) >> 4, (t[1] & 15) << 4 | (t[2] & 240) >> 4, 96 | t[2] & 15, t[3], t[8], t[9], t[10], t[11], t[12], t[13], t[14], t[15]);
  }
  return v1ToV6;
}
var v3 = {}, md5$1 = {}, hasRequiredMd5;
function requireMd5() {
  if (hasRequiredMd5) return md5$1;
  hasRequiredMd5 = 1, Object.defineProperty(md5$1, "__esModule", { value: !0 });
  function s(P) {
    const x = t(P), M = p(x, P.length * 8);
    return A(M);
  }
  function A(P) {
    const x = new Uint8Array(P.length * 4);
    for (let M = 0; M < P.length * 4; M++)
      x[M] = P[M >> 2] >>> M % 4 * 8 & 255;
    return x;
  }
  function u(P) {
    return (P + 64 >>> 9 << 4) + 14 + 1;
  }
  function p(P, x) {
    const M = new Uint32Array(u(x)).fill(0);
    M.set(P), M[x >> 5] |= 128 << x % 32, M[M.length - 1] = x, P = M;
    let F = 1732584193, le = -271733879, ge = -1732584194, pe = 271733878;
    for (let Ie = 0; Ie < P.length; Ie += 16) {
      const be = F, Pe = le, Te = ge, Qe = pe;
      F = k(F, le, ge, pe, P[Ie], 7, -680876936), pe = k(pe, F, le, ge, P[Ie + 1], 12, -389564586), ge = k(ge, pe, F, le, P[Ie + 2], 17, 606105819), le = k(le, ge, pe, F, P[Ie + 3], 22, -1044525330), F = k(F, le, ge, pe, P[Ie + 4], 7, -176418897), pe = k(pe, F, le, ge, P[Ie + 5], 12, 1200080426), ge = k(ge, pe, F, le, P[Ie + 6], 17, -1473231341), le = k(le, ge, pe, F, P[Ie + 7], 22, -45705983), F = k(F, le, ge, pe, P[Ie + 8], 7, 1770035416), pe = k(pe, F, le, ge, P[Ie + 9], 12, -1958414417), ge = k(ge, pe, F, le, P[Ie + 10], 17, -42063), le = k(le, ge, pe, F, P[Ie + 11], 22, -1990404162), F = k(F, le, ge, pe, P[Ie + 12], 7, 1804603682), pe = k(pe, F, le, ge, P[Ie + 13], 12, -40341101), ge = k(ge, pe, F, le, P[Ie + 14], 17, -1502002290), le = k(le, ge, pe, F, P[Ie + 15], 22, 1236535329), F = C(F, le, ge, pe, P[Ie + 1], 5, -165796510), pe = C(pe, F, le, ge, P[Ie + 6], 9, -1069501632), ge = C(ge, pe, F, le, P[Ie + 11], 14, 643717713), le = C(le, ge, pe, F, P[Ie], 20, -373897302), F = C(F, le, ge, pe, P[Ie + 5], 5, -701558691), pe = C(pe, F, le, ge, P[Ie + 10], 9, 38016083), ge = C(ge, pe, F, le, P[Ie + 15], 14, -660478335), le = C(le, ge, pe, F, P[Ie + 4], 20, -405537848), F = C(F, le, ge, pe, P[Ie + 9], 5, 568446438), pe = C(pe, F, le, ge, P[Ie + 14], 9, -1019803690), ge = C(ge, pe, F, le, P[Ie + 3], 14, -187363961), le = C(le, ge, pe, F, P[Ie + 8], 20, 1163531501), F = C(F, le, ge, pe, P[Ie + 13], 5, -1444681467), pe = C(pe, F, le, ge, P[Ie + 2], 9, -51403784), ge = C(ge, pe, F, le, P[Ie + 7], 14, 1735328473), le = C(le, ge, pe, F, P[Ie + 12], 20, -1926607734), F = B(F, le, ge, pe, P[Ie + 5], 4, -378558), pe = B(pe, F, le, ge, P[Ie + 8], 11, -2022574463), ge = B(ge, pe, F, le, P[Ie + 11], 16, 1839030562), le = B(le, ge, pe, F, P[Ie + 14], 23, -35309556), F = B(F, le, ge, pe, P[Ie + 1], 4, -1530992060), pe = B(pe, F, le, ge, P[Ie + 4], 11, 1272893353), ge = B(ge, pe, F, le, P[Ie + 7], 16, -155497632), le = B(le, ge, pe, F, P[Ie + 10], 23, -1094730640), F = B(F, le, ge, pe, P[Ie + 13], 4, 681279174), pe = B(pe, F, le, ge, P[Ie], 11, -358537222), ge = B(ge, pe, F, le, P[Ie + 3], 16, -722521979), le = B(le, ge, pe, F, P[Ie + 6], 23, 76029189), F = B(F, le, ge, pe, P[Ie + 9], 4, -640364487), pe = B(pe, F, le, ge, P[Ie + 12], 11, -421815835), ge = B(ge, pe, F, le, P[Ie + 15], 16, 530742520), le = B(le, ge, pe, F, P[Ie + 2], 23, -995338651), F = Q(F, le, ge, pe, P[Ie], 6, -198630844), pe = Q(pe, F, le, ge, P[Ie + 7], 10, 1126891415), ge = Q(ge, pe, F, le, P[Ie + 14], 15, -1416354905), le = Q(le, ge, pe, F, P[Ie + 5], 21, -57434055), F = Q(F, le, ge, pe, P[Ie + 12], 6, 1700485571), pe = Q(pe, F, le, ge, P[Ie + 3], 10, -1894986606), ge = Q(ge, pe, F, le, P[Ie + 10], 15, -1051523), le = Q(le, ge, pe, F, P[Ie + 1], 21, -2054922799), F = Q(F, le, ge, pe, P[Ie + 8], 6, 1873313359), pe = Q(pe, F, le, ge, P[Ie + 15], 10, -30611744), ge = Q(ge, pe, F, le, P[Ie + 6], 15, -1560198380), le = Q(le, ge, pe, F, P[Ie + 13], 21, 1309151649), F = Q(F, le, ge, pe, P[Ie + 4], 6, -145523070), pe = Q(pe, F, le, ge, P[Ie + 11], 10, -1120210379), ge = Q(ge, pe, F, le, P[Ie + 2], 15, 718787259), le = Q(le, ge, pe, F, P[Ie + 9], 21, -343485551), F = l(F, be), le = l(le, Pe), ge = l(ge, Te), pe = l(pe, Qe);
    }
    return Uint32Array.of(F, le, ge, pe);
  }
  function t(P) {
    if (P.length === 0)
      return new Uint32Array();
    const x = new Uint32Array(u(P.length * 8)).fill(0);
    for (let M = 0; M < P.length; M++)
      x[M >> 2] |= (P[M] & 255) << M % 4 * 8;
    return x;
  }
  function l(P, x) {
    const M = (P & 65535) + (x & 65535);
    return (P >> 16) + (x >> 16) + (M >> 16) << 16 | M & 65535;
  }
  function m(P, x) {
    return P << x | P >>> 32 - x;
  }
  function b(P, x, M, F, le, ge) {
    return l(m(l(l(x, P), l(F, ge)), le), M);
  }
  function k(P, x, M, F, le, ge, pe) {
    return b(x & M | ~x & F, P, x, le, ge, pe);
  }
  function C(P, x, M, F, le, ge, pe) {
    return b(x & F | M & ~F, P, x, le, ge, pe);
  }
  function B(P, x, M, F, le, ge, pe) {
    return b(x ^ M ^ F, P, x, le, ge, pe);
  }
  function Q(P, x, M, F, le, ge, pe) {
    return b(M ^ (x | ~F), P, x, le, ge, pe);
  }
  return md5$1.default = s, md5$1;
}
var v35 = {}, hasRequiredV35;
function requireV35() {
  if (hasRequiredV35) return v35;
  hasRequiredV35 = 1, Object.defineProperty(v35, "__esModule", { value: !0 }), v35.URL = v35.DNS = v35.stringToBytes = void 0;
  const s = requireParse$1(), A = requireStringify();
  function u(t) {
    t = unescape(encodeURIComponent(t));
    const l = new Uint8Array(t.length);
    for (let m = 0; m < t.length; ++m)
      l[m] = t.charCodeAt(m);
    return l;
  }
  v35.stringToBytes = u, v35.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", v35.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
  function p(t, l, m, b, k, C) {
    const B = typeof m == "string" ? u(m) : m, Q = typeof b == "string" ? (0, s.default)(b) : b;
    if (typeof b == "string" && (b = (0, s.default)(b)), (b == null ? void 0 : b.length) !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    let P = new Uint8Array(16 + B.length);
    if (P.set(Q), P.set(B, Q.length), P = l(P), P[6] = P[6] & 15 | t, P[8] = P[8] & 63 | 128, k) {
      C = C || 0;
      for (let x = 0; x < 16; ++x)
        k[C + x] = P[x];
      return k;
    }
    return (0, A.unsafeStringify)(P);
  }
  return v35.default = p, v35;
}
var hasRequiredV3;
function requireV3() {
  return hasRequiredV3 || (hasRequiredV3 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.URL = s.DNS = void 0;
    const A = requireMd5(), u = requireV35();
    var p = requireV35();
    Object.defineProperty(s, "DNS", { enumerable: !0, get: function() {
      return p.DNS;
    } }), Object.defineProperty(s, "URL", { enumerable: !0, get: function() {
      return p.URL;
    } });
    function t(l, m, b, k) {
      return (0, u.default)(48, A.default, l, m, b, k);
    }
    t.DNS = u.DNS, t.URL = u.URL, s.default = t;
  }(v3)), v3;
}
var v4$1 = {}, native$1 = {}, hasRequiredNative;
function requireNative() {
  if (hasRequiredNative) return native$1;
  hasRequiredNative = 1, Object.defineProperty(native$1, "__esModule", { value: !0 });
  const s = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
  return native$1.default = { randomUUID: s }, native$1;
}
var hasRequiredV4;
function requireV4() {
  if (hasRequiredV4) return v4$1;
  hasRequiredV4 = 1, Object.defineProperty(v4$1, "__esModule", { value: !0 });
  const s = requireNative(), A = requireRng(), u = requireStringify();
  function p(t, l, m) {
    var k;
    if (s.default.randomUUID && !l && !t)
      return s.default.randomUUID();
    t = t || {};
    const b = t.random ?? ((k = t.rng) == null ? void 0 : k.call(t)) ?? (0, A.default)();
    if (b.length < 16)
      throw new Error("Random bytes length must be >= 16");
    if (b[6] = b[6] & 15 | 64, b[8] = b[8] & 63 | 128, l) {
      if (m = m || 0, m < 0 || m + 16 > l.length)
        throw new RangeError(`UUID byte range ${m}:${m + 15} is out of buffer bounds`);
      for (let C = 0; C < 16; ++C)
        l[m + C] = b[C];
      return l;
    }
    return (0, u.unsafeStringify)(b);
  }
  return v4$1.default = p, v4$1;
}
var v5 = {}, sha1$1 = {}, hasRequiredSha1;
function requireSha1() {
  if (hasRequiredSha1) return sha1$1;
  hasRequiredSha1 = 1, Object.defineProperty(sha1$1, "__esModule", { value: !0 });
  function s(p, t, l, m) {
    switch (p) {
      case 0:
        return t & l ^ ~t & m;
      case 1:
        return t ^ l ^ m;
      case 2:
        return t & l ^ t & m ^ l & m;
      case 3:
        return t ^ l ^ m;
    }
  }
  function A(p, t) {
    return p << t | p >>> 32 - t;
  }
  function u(p) {
    const t = [1518500249, 1859775393, 2400959708, 3395469782], l = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], m = new Uint8Array(p.length + 1);
    m.set(p), m[p.length] = 128, p = m;
    const b = p.length / 4 + 2, k = Math.ceil(b / 16), C = new Array(k);
    for (let B = 0; B < k; ++B) {
      const Q = new Uint32Array(16);
      for (let P = 0; P < 16; ++P)
        Q[P] = p[B * 64 + P * 4] << 24 | p[B * 64 + P * 4 + 1] << 16 | p[B * 64 + P * 4 + 2] << 8 | p[B * 64 + P * 4 + 3];
      C[B] = Q;
    }
    C[k - 1][14] = (p.length - 1) * 8 / Math.pow(2, 32), C[k - 1][14] = Math.floor(C[k - 1][14]), C[k - 1][15] = (p.length - 1) * 8 & 4294967295;
    for (let B = 0; B < k; ++B) {
      const Q = new Uint32Array(80);
      for (let ge = 0; ge < 16; ++ge)
        Q[ge] = C[B][ge];
      for (let ge = 16; ge < 80; ++ge)
        Q[ge] = A(Q[ge - 3] ^ Q[ge - 8] ^ Q[ge - 14] ^ Q[ge - 16], 1);
      let P = l[0], x = l[1], M = l[2], F = l[3], le = l[4];
      for (let ge = 0; ge < 80; ++ge) {
        const pe = Math.floor(ge / 20), Ie = A(P, 5) + s(pe, x, M, F) + le + t[pe] + Q[ge] >>> 0;
        le = F, F = M, M = A(x, 30) >>> 0, x = P, P = Ie;
      }
      l[0] = l[0] + P >>> 0, l[1] = l[1] + x >>> 0, l[2] = l[2] + M >>> 0, l[3] = l[3] + F >>> 0, l[4] = l[4] + le >>> 0;
    }
    return Uint8Array.of(l[0] >> 24, l[0] >> 16, l[0] >> 8, l[0], l[1] >> 24, l[1] >> 16, l[1] >> 8, l[1], l[2] >> 24, l[2] >> 16, l[2] >> 8, l[2], l[3] >> 24, l[3] >> 16, l[3] >> 8, l[3], l[4] >> 24, l[4] >> 16, l[4] >> 8, l[4]);
  }
  return sha1$1.default = u, sha1$1;
}
var hasRequiredV5;
function requireV5() {
  return hasRequiredV5 || (hasRequiredV5 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.URL = s.DNS = void 0;
    const A = requireSha1(), u = requireV35();
    var p = requireV35();
    Object.defineProperty(s, "DNS", { enumerable: !0, get: function() {
      return p.DNS;
    } }), Object.defineProperty(s, "URL", { enumerable: !0, get: function() {
      return p.URL;
    } });
    function t(l, m, b, k) {
      return (0, u.default)(80, A.default, l, m, b, k);
    }
    t.DNS = u.DNS, t.URL = u.URL, s.default = t;
  }(v5)), v5;
}
var v6 = {}, hasRequiredV6;
function requireV6() {
  if (hasRequiredV6) return v6;
  hasRequiredV6 = 1, Object.defineProperty(v6, "__esModule", { value: !0 });
  const s = requireStringify(), A = requireV1(), u = requireV1ToV6();
  function p(t, l, m) {
    t ?? (t = {}), m ?? (m = 0);
    let b = (0, A.default)({ ...t, _v6: !0 }, new Uint8Array(16));
    if (b = (0, u.default)(b), l) {
      for (let k = 0; k < 16; k++)
        l[m + k] = b[k];
      return l;
    }
    return (0, s.unsafeStringify)(b);
  }
  return v6.default = p, v6;
}
var v6ToV1 = {}, hasRequiredV6ToV1;
function requireV6ToV1() {
  if (hasRequiredV6ToV1) return v6ToV1;
  hasRequiredV6ToV1 = 1, Object.defineProperty(v6ToV1, "__esModule", { value: !0 });
  const s = requireParse$1(), A = requireStringify();
  function u(t) {
    const l = typeof t == "string" ? (0, s.default)(t) : t, m = p(l);
    return typeof t == "string" ? (0, A.unsafeStringify)(m) : m;
  }
  v6ToV1.default = u;
  function p(t) {
    return Uint8Array.of((t[3] & 15) << 4 | t[4] >> 4 & 15, (t[4] & 15) << 4 | (t[5] & 240) >> 4, (t[5] & 15) << 4 | t[6] & 15, t[7], (t[1] & 15) << 4 | (t[2] & 240) >> 4, (t[2] & 15) << 4 | (t[3] & 240) >> 4, 16 | (t[0] & 240) >> 4, (t[0] & 15) << 4 | (t[1] & 240) >> 4, t[8], t[9], t[10], t[11], t[12], t[13], t[14], t[15]);
  }
  return v6ToV1;
}
var v7 = {}, hasRequiredV7;
function requireV7() {
  if (hasRequiredV7) return v7;
  hasRequiredV7 = 1, Object.defineProperty(v7, "__esModule", { value: !0 }), v7.updateV7State = void 0;
  const s = requireRng(), A = requireStringify(), u = {};
  function p(m, b, k) {
    var B;
    let C;
    if (m)
      C = l(m.random ?? ((B = m.rng) == null ? void 0 : B.call(m)) ?? (0, s.default)(), m.msecs, m.seq, b, k);
    else {
      const Q = Date.now(), P = (0, s.default)();
      t(u, Q, P), C = l(P, u.msecs, u.seq, b, k);
    }
    return b ?? (0, A.unsafeStringify)(C);
  }
  function t(m, b, k) {
    return m.msecs ?? (m.msecs = -1 / 0), m.seq ?? (m.seq = 0), b > m.msecs ? (m.seq = k[6] << 23 | k[7] << 16 | k[8] << 8 | k[9], m.msecs = b) : (m.seq = m.seq + 1 | 0, m.seq === 0 && m.msecs++), m;
  }
  v7.updateV7State = t;
  function l(m, b, k, C, B = 0) {
    if (m.length < 16)
      throw new Error("Random bytes length must be >= 16");
    if (!C)
      C = new Uint8Array(16), B = 0;
    else if (B < 0 || B + 16 > C.length)
      throw new RangeError(`UUID byte range ${B}:${B + 15} is out of buffer bounds`);
    return b ?? (b = Date.now()), k ?? (k = m[6] * 127 << 24 | m[7] << 16 | m[8] << 8 | m[9]), C[B++] = b / 1099511627776 & 255, C[B++] = b / 4294967296 & 255, C[B++] = b / 16777216 & 255, C[B++] = b / 65536 & 255, C[B++] = b / 256 & 255, C[B++] = b & 255, C[B++] = 112 | k >>> 28 & 15, C[B++] = k >>> 20 & 255, C[B++] = 128 | k >>> 14 & 63, C[B++] = k >>> 6 & 255, C[B++] = k << 2 & 255 | m[10] & 3, C[B++] = m[11], C[B++] = m[12], C[B++] = m[13], C[B++] = m[14], C[B++] = m[15], C;
  }
  return v7.default = p, v7;
}
var version$4 = {}, hasRequiredVersion;
function requireVersion() {
  if (hasRequiredVersion) return version$4;
  hasRequiredVersion = 1, Object.defineProperty(version$4, "__esModule", { value: !0 });
  const s = requireValidate();
  function A(u) {
    if (!(0, s.default)(u))
      throw TypeError("Invalid UUID");
    return parseInt(u.slice(14, 15), 16);
  }
  return version$4.default = A, version$4;
}
var hasRequiredCjsBrowser;
function requireCjsBrowser() {
  return hasRequiredCjsBrowser || (hasRequiredCjsBrowser = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.version = s.validate = s.v7 = s.v6ToV1 = s.v6 = s.v5 = s.v4 = s.v3 = s.v1ToV6 = s.v1 = s.stringify = s.parse = s.NIL = s.MAX = void 0;
    var A = requireMax();
    Object.defineProperty(s, "MAX", { enumerable: !0, get: function() {
      return A.default;
    } });
    var u = requireNil();
    Object.defineProperty(s, "NIL", { enumerable: !0, get: function() {
      return u.default;
    } });
    var p = requireParse$1();
    Object.defineProperty(s, "parse", { enumerable: !0, get: function() {
      return p.default;
    } });
    var t = requireStringify();
    Object.defineProperty(s, "stringify", { enumerable: !0, get: function() {
      return t.default;
    } });
    var l = requireV1();
    Object.defineProperty(s, "v1", { enumerable: !0, get: function() {
      return l.default;
    } });
    var m = requireV1ToV6();
    Object.defineProperty(s, "v1ToV6", { enumerable: !0, get: function() {
      return m.default;
    } });
    var b = requireV3();
    Object.defineProperty(s, "v3", { enumerable: !0, get: function() {
      return b.default;
    } });
    var k = requireV4();
    Object.defineProperty(s, "v4", { enumerable: !0, get: function() {
      return k.default;
    } });
    var C = requireV5();
    Object.defineProperty(s, "v5", { enumerable: !0, get: function() {
      return C.default;
    } });
    var B = requireV6();
    Object.defineProperty(s, "v6", { enumerable: !0, get: function() {
      return B.default;
    } });
    var Q = requireV6ToV1();
    Object.defineProperty(s, "v6ToV1", { enumerable: !0, get: function() {
      return Q.default;
    } });
    var P = requireV7();
    Object.defineProperty(s, "v7", { enumerable: !0, get: function() {
      return P.default;
    } });
    var x = requireValidate();
    Object.defineProperty(s, "validate", { enumerable: !0, get: function() {
      return x.default;
    } });
    var M = requireVersion();
    Object.defineProperty(s, "version", { enumerable: !0, get: function() {
      return M.default;
    } });
  }(cjsBrowser)), cjsBrowser;
}
var hasRequiredKeplr;
function requireKeplr() {
  if (hasRequiredKeplr) return keplr$1;
  hasRequiredKeplr = 1;
  var s = keplr$1 && keplr$1.__awaiter || function(ge, pe, Ie, be) {
    function Pe(Te) {
      return Te instanceof Ie ? Te : new Ie(function(Qe) {
        Qe(Te);
      });
    }
    return new (Ie || (Ie = Promise))(function(Te, Qe) {
      function xe(ve) {
        try {
          He(be.next(ve));
        } catch (we) {
          Qe(we);
        }
      }
      function Ee(ve) {
        try {
          He(be.throw(ve));
        } catch (we) {
          Qe(we);
        }
      }
      function He(ve) {
        ve.done ? Te(ve.value) : Pe(ve.value).then(xe, Ee);
      }
      He((be = be.apply(ge, pe || [])).next());
    });
  }, A = keplr$1 && keplr$1.__importDefault || function(ge) {
    return ge && ge.__esModule ? ge : { default: ge };
  };
  Object.defineProperty(keplr$1, "__esModule", { value: !0 }), keplr$1.BitcoinProvider = keplr$1.Keplr = keplr$1.EthereumProviderRpcError = void 0;
  const u = requireBuild$6(), p = requireUint8Array(), t = A(requireCjs$2()), l = A(requireLong()), m = requireCosmjs(), b = requireEnigma(), k = requireVersion$1(), C = A(requireEvents()), B = requireConstants$1(), Q = /* @__PURE__ */ requireCjsBrowser();
  class P extends Error {
    constructor(pe, Ie, be) {
      super(Ie), this.code = pe, this.data = be, Object.setPrototypeOf(this, P.prototype);
    }
  }
  keplr$1.EthereumProviderRpcError = P;
  class x {
    constructor() {
      this.enigmaUtils = /* @__PURE__ */ new Map(), this.version = k.BUILD_VERSION, this.mode = "extension", this.defaultOptions = {}, this.ethereum = new F(this), this.starknet = void 0, this.bitcoin = new le(this);
    }
    static staticRequestMethod(pe, Ie) {
      const be = "ReactNativeWebView" in window, Pe = be ? (ve) => {
        window.ReactNativeWebView.postMessage(JSON.stringify(ve));
      } : (ve) => {
        window.postMessage(ve, window.location.origin);
      }, Te = be ? (ve) => {
        if (ve && typeof ve == "string")
          try {
            return JSON.parse(ve);
          } catch {
          }
        return ve;
      } : (ve) => ve, Qe = new Uint8Array(8), xe = Array.from(crypto.getRandomValues(Qe)).map((ve) => ve.toString(16)).join(""), He = {
        type: window.keplrRequestMetaIdSupport ? `proxy-request${B.metaId ? `-${B.metaId}` : ""}` : "proxy-request",
        id: xe,
        method: pe,
        args: p.JSONUint8Array.wrap(Ie)
      };
      return new Promise((ve, we) => {
        const Ce = (Se) => {
          const Ne = Te(Se.data);
          if (!Ne || Ne.type !== "proxy-request-response" || Ne.id !== xe)
            return;
          window.removeEventListener("message", Ce);
          const rr = p.JSONUint8Array.unwrap(Ne.result);
          if (!rr) {
            we(new Error("Result is null"));
            return;
          }
          if (rr.error) {
            we(new Error(rr.error));
            return;
          }
          ve(rr.return);
        };
        window.addEventListener("message", Ce), Pe(He);
      });
    }
    requestMethod(pe, Ie) {
      return x.staticRequestMethod(pe, Ie);
    }
    static getKeplr(pe = 1500) {
      return s(this, void 0, void 0, function* () {
        yield M();
        const Ie = "ReactNativeWebView" in window, be = typeof navigator < "u" && "userAgent" in navigator ? navigator.userAgent.includes("Firefox") : !1;
        if (!(!Ie && !be && window.keplrRequestMetaIdSupport == null))
          return new Promise((Pe, Te) => {
            const Qe = setTimeout(() => {
              Pe(void 0);
            }, pe);
            x.staticRequestMethod("ping", []).then(() => {
              clearTimeout(Qe), Pe(new x());
            }).catch((xe) => {
              var Ee;
              !((Ee = xe == null ? void 0 : xe.message) === null || Ee === void 0) && Ee.includes("Invalid method: ping") ? (clearTimeout(Qe), Pe(new x())) : Te(xe);
            });
          });
      });
    }
    ping() {
      return s(this, void 0, void 0, function* () {
        yield this.requestMethod("ping", []);
      });
    }
    enable(pe) {
      return s(this, void 0, void 0, function* () {
        yield this.requestMethod("enable", [pe]);
      });
    }
    disable(pe) {
      return s(this, void 0, void 0, function* () {
        yield this.requestMethod("disable", [pe]);
      });
    }
    experimentalSuggestChain(pe) {
      var Ie, be;
      return s(this, void 0, void 0, function* () {
        if (pe.hideInUI)
          throw new Error("hideInUI is not allowed");
        (!((Ie = pe.features) === null || Ie === void 0) && Ie.includes("stargate") || !((be = pe.features) === null || be === void 0) && be.includes("no-legacy-stdTx")) && console.warn("“stargate”, “no-legacy-stdTx” feature has been deprecated. The launchpad is no longer supported, thus works without the two features. We would keep the aforementioned two feature for a while, but the upcoming update would potentially cause errors. Remove the two feature."), yield this.requestMethod("experimentalSuggestChain", [pe]);
      });
    }
    getKey(pe) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("getKey", [pe]);
      });
    }
    getKeysSettled(pe) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("getKeysSettled", [pe]);
      });
    }
    sendTx(pe, Ie, be) {
      return s(this, void 0, void 0, function* () {
        return "length" in Ie || console.warn("Do not send legacy std tx via `sendTx` API. We now only support protobuf tx. The usage of legeacy std tx would throw an error in the near future."), yield this.requestMethod("sendTx", [pe, Ie, be]);
      });
    }
    signAmino(pe, Ie, be, Pe = {}) {
      var Te;
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("signAmino", [
          pe,
          Ie,
          be,
          (0, t.default)((Te = this.defaultOptions.sign) !== null && Te !== void 0 ? Te : {}, Pe)
        ]);
      });
    }
    signDirect(pe, Ie, be, Pe = {}) {
      var Te;
      return s(this, void 0, void 0, function* () {
        const Qe = yield this.requestMethod("signDirect", [
          pe,
          Ie,
          // We can't send the `Long` with remaing the type.
          // Receiver should change the `string` to `Long`.
          {
            bodyBytes: be.bodyBytes,
            authInfoBytes: be.authInfoBytes,
            chainId: be.chainId,
            accountNumber: be.accountNumber ? be.accountNumber.toString() : null
          },
          (0, t.default)((Te = this.defaultOptions.sign) !== null && Te !== void 0 ? Te : {}, Pe)
        ]), xe = Qe.signed;
        return {
          signed: {
            bodyBytes: xe.bodyBytes,
            authInfoBytes: xe.authInfoBytes,
            chainId: xe.chainId,
            // We can't send the `Long` with remaing the type.
            // Sender should change the `Long` to `string`.
            accountNumber: l.default.fromString(xe.accountNumber)
          },
          signature: Qe.signature
        };
      });
    }
    signDirectAux(pe, Ie, be, Pe = {}) {
      var Te;
      return s(this, void 0, void 0, function* () {
        const Qe = yield this.requestMethod("signDirectAux", [
          pe,
          Ie,
          // We can't send the `Long` with remaing the type.
          // Receiver should change the `string` to `Long`.
          {
            bodyBytes: be.bodyBytes,
            publicKey: be.publicKey,
            chainId: be.chainId,
            accountNumber: be.accountNumber ? be.accountNumber.toString() : null,
            sequence: be.sequence ? be.sequence.toString() : null
          },
          (0, t.default)({
            preferNoSetMemo: (Te = this.defaultOptions.sign) === null || Te === void 0 ? void 0 : Te.preferNoSetMemo
          }, Pe)
        ]), xe = Qe.signed;
        return {
          signed: {
            bodyBytes: xe.bodyBytes,
            publicKey: xe.publicKey || void 0,
            chainId: xe.chainId,
            // We can't send the `Long` with remaing the type.
            // Sender should change the `Long` to `string`.
            accountNumber: l.default.fromString(xe.accountNumber),
            sequence: l.default.fromString(xe.sequence)
          },
          signature: Qe.signature
        };
      });
    }
    signArbitrary(pe, Ie, be) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("signArbitrary", [pe, Ie, be]);
      });
    }
    signICNSAdr36(pe, Ie, be, Pe, Te) {
      return this.requestMethod("signICNSAdr36", [
        pe,
        Ie,
        be,
        Pe,
        Te
      ]);
    }
    verifyArbitrary(pe, Ie, be, Pe) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("verifyArbitrary", [
          pe,
          Ie,
          be,
          Pe
        ]);
      });
    }
    signEthereum(pe, Ie, be, Pe) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("signEthereum", [
          pe,
          Ie,
          be,
          Pe
        ]);
      });
    }
    getOfflineSigner(pe, Ie) {
      return new m.CosmJSOfflineSigner(pe, this, Ie);
    }
    getOfflineSignerOnlyAmino(pe, Ie) {
      return new m.CosmJSOfflineSignerOnlyAmino(pe, this, Ie);
    }
    getOfflineSignerAuto(pe, Ie) {
      return s(this, void 0, void 0, function* () {
        return (yield this.getKey(pe)).isNanoLedger ? new m.CosmJSOfflineSignerOnlyAmino(pe, this, Ie) : new m.CosmJSOfflineSigner(pe, this, Ie);
      });
    }
    suggestToken(pe, Ie, be) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("suggestToken", [
          pe,
          Ie,
          be
        ]);
      });
    }
    getSecret20ViewingKey(pe, Ie) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("getSecret20ViewingKey", [
          pe,
          Ie
        ]);
      });
    }
    getEnigmaPubKey(pe) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("getEnigmaPubKey", [pe]);
      });
    }
    getEnigmaTxEncryptionKey(pe, Ie) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("getEnigmaTxEncryptionKey", [
          pe,
          Ie
        ]);
      });
    }
    enigmaEncrypt(pe, Ie, be) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("enigmaEncrypt", [
          pe,
          Ie,
          be
        ]);
      });
    }
    enigmaDecrypt(pe, Ie, be) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("enigmaDecrypt", [
          pe,
          Ie,
          be
        ]);
      });
    }
    getEnigmaUtils(pe) {
      if (this.enigmaUtils.has(pe))
        return this.enigmaUtils.get(pe);
      const Ie = new b.KeplrEnigmaUtils(pe, this);
      return this.enigmaUtils.set(pe, Ie), Ie;
    }
    experimentalSignEIP712CosmosTx_v0(pe, Ie, be, Pe, Te = {}) {
      var Qe;
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("experimentalSignEIP712CosmosTx_v0", [
          pe,
          Ie,
          be,
          Pe,
          (0, t.default)((Qe = this.defaultOptions.sign) !== null && Qe !== void 0 ? Qe : {}, Te)
        ]);
      });
    }
    getChainInfosWithoutEndpoints() {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("getChainInfosWithoutEndpoints", []);
      });
    }
    changeKeyRingName({ defaultName: pe, editable: Ie = !0 }) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("changeKeyRingName", [
          { defaultName: pe, editable: Ie }
        ]);
      });
    }
    sendEthereumTx(pe, Ie) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("sendEthereumTx", [pe, Ie]);
      });
    }
    suggestERC20(pe, Ie) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("suggestERC20", [pe, Ie]);
      });
    }
    getChainInfoWithoutEndpoints(pe) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("getChainInfoWithoutEndpoints", [pe]);
      });
    }
    getStarknetKey(pe) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("getStarknetKey", [pe]);
      });
    }
    getStarknetKeysSettled(pe) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("getStarknetKeysSettled", [pe]);
      });
    }
    signStarknetTx(pe, Ie, be) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("signStarknetTx", [
          pe,
          Ie,
          be
        ]);
      });
    }
    signStarknetDeployAccountTransaction(pe, Ie) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("signStarknetDeployAccountTransaction", [
          pe,
          Ie
        ]);
      });
    }
    getBitcoinKey(pe) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("getBitcoinKey", [pe]);
      });
    }
    getBitcoinKeysSettled(pe) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("getBitcoinKeysSettled", [pe]);
      });
    }
    signPsbt(pe, Ie, be) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("signPsbt", [pe, Ie, be]);
      });
    }
    signPsbts(pe, Ie, be) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("signPsbts", [
          pe,
          Ie,
          be
        ]);
      });
    }
    __core__getAnalyticsId() {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("__core__getAnalyticsId", []);
      });
    }
    __core__privilageSignAminoWithdrawRewards(pe, Ie, be) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("__core__privilageSignAminoWithdrawRewards", [pe, Ie, be]);
      });
    }
    __core__privilageSignAminoDelegate(pe, Ie, be) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("__core__privilageSignAminoDelegate", [pe, Ie, be]);
      });
    }
    __core__privilageSignAminoExecuteCosmWasm(pe, Ie, be) {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("__core__privilageSignAminoExecuteCosmWasm", [pe, Ie, be]);
      });
    }
    __core__webpageClosed() {
      return s(this, void 0, void 0, function* () {
        return yield this.requestMethod("__core__webpageClosed", []);
      });
    }
  }
  keplr$1.Keplr = x;
  const M = () => document.readyState === "complete" ? Promise.resolve() : new Promise((ge) => {
    const pe = (Ie) => {
      Ie.target && Ie.target.readyState === "complete" && (ge(), document.removeEventListener("readystatechange", pe));
    };
    document.addEventListener("readystatechange", pe);
  });
  class F extends C.default {
    constructor(pe) {
      if (super(), this.keplr = pe, this.eip6963ProviderInfo = {
        uuid: (0, Q.v4)(),
        name: "Keplr",
        rdns: "app.keplr",
        icon: `data:image/png;base64,${B.KeplrLogoBase64}`
      }, this.chainId = null, this.networkVersion = null, this.selectedAddress = null, this.isKeplr = !0, this.isMetaMask = !0, this._isConnected = !1, this._currentChainId = null, window.addEventListener("keplr_keystorechange", () => s(this, void 0, void 0, function* () {
        if (this._currentChainId && (yield pe.getChainInfoWithoutEndpoints(this._currentChainId))) {
          const be = (yield pe.getKey(this._currentChainId)).ethereumHexAddress;
          this.handleAccountsChanged(be);
        }
      })), window.addEventListener("keplr_chainChanged", (Ie) => {
        if (Ie.detail.origin === window.location.origin) {
          const Pe = Ie.detail.evmChainId;
          this.handleChainChanged(Pe);
        }
      }), window.addEventListener("keplr_ethSubscription", (Ie) => {
        var be;
        const Pe = Ie.detail.origin, Te = Ie.detail.providerId;
        if (Pe === window.location.origin && Te === ((be = this.eip6963ProviderInfo) === null || be === void 0 ? void 0 : be.uuid)) {
          const Qe = Ie.detail.data;
          this.emit("message", {
            type: "eth_subscription",
            data: Qe
          });
        }
      }), this.eip6963ProviderInfo) {
        const Ie = new CustomEvent(u.EIP6963EventNames.Announce, {
          detail: Object.freeze({
            info: this.eip6963ProviderInfo,
            provider: this
          })
        });
        window.addEventListener(u.EIP6963EventNames.Request, () => window.dispatchEvent(Ie)), window.dispatchEvent(Ie);
      }
    }
    static requestMethod(pe, Ie) {
      return s(this, void 0, void 0, function* () {
        const be = "ReactNativeWebView" in window, Pe = be ? (ve) => {
          window.ReactNativeWebView.postMessage(JSON.stringify(ve));
        } : (ve) => {
          window.postMessage(ve, window.location.origin);
        }, Te = be ? (ve) => {
          if (ve && typeof ve == "string")
            try {
              return JSON.parse(ve);
            } catch {
            }
          return ve;
        } : (ve) => ve, Qe = new Uint8Array(8), xe = Array.from(crypto.getRandomValues(Qe)).map((ve) => ve.toString(16)).join(""), He = {
          type: window.keplrRequestMetaIdSupport ? `proxy-request${B.metaId ? `-${B.metaId}` : ""}` : "proxy-request",
          id: xe,
          method: "ethereum",
          args: p.JSONUint8Array.wrap(Ie),
          ethereumProviderMethod: pe
        };
        return new Promise((ve, we) => {
          const Ce = (Se) => {
            const Ne = Te(Se.data);
            if (!Ne || Ne.type !== "proxy-request-response" || Ne.id !== xe)
              return;
            window.removeEventListener("message", Ce);
            const rr = p.JSONUint8Array.unwrap(Ne.result);
            if (!rr) {
              we(new Error("Result is null"));
              return;
            }
            if (rr.error) {
              const er = rr.error;
              we(er.code && !er.module ? new P(er.code, er.message, er.data) : new Error(er));
              return;
            }
            ve(rr.return);
          };
          window.addEventListener("message", Ce), Pe(He);
        });
      });
    }
    handleConnect(pe) {
      return s(this, void 0, void 0, function* () {
        if (!this._isConnected) {
          const { currentEvmChainId: Ie, currentChainId: be, selectedAddress: Pe } = yield F.requestMethod("request", Object.assign({ method: "keplr_connect" }, pe && { params: [pe] }));
          this._isConnected = !0, this._currentChainId = be, this.chainId = `0x${Ie.toString(16)}`, this.networkVersion = Ie.toString(10), this.selectedAddress = Pe, this.emit("connect", { chainId: this.chainId });
        }
      });
    }
    handleDisconnect() {
      return s(this, void 0, void 0, function* () {
        this._isConnected && (yield F.requestMethod("request", {
          method: "keplr_disconnect"
        }), this._isConnected = !1, this.chainId = null, this.selectedAddress = null, this.networkVersion = null, this.emit("disconnect"));
      });
    }
    handleChainChanged(pe) {
      return s(this, void 0, void 0, function* () {
        yield this.handleConnect(pe);
        const Ie = `0x${pe.toString(16)}`;
        this.emit("chainChanged", Ie);
      });
    }
    handleAccountsChanged(pe) {
      return s(this, void 0, void 0, function* () {
        this._isConnected && (this.selectedAddress = pe, this.emit("accountsChanged", [pe]));
      });
    }
    isConnected() {
      return this._isConnected;
    }
    request({ method: pe, params: Ie, chainId: be }) {
      var Pe;
      return s(this, void 0, void 0, function* () {
        if (!this._isConnected) {
          if (pe === "eth_accounts")
            return [];
          yield this.handleConnect();
        }
        return yield F.requestMethod("request", {
          method: pe,
          params: Ie,
          providerId: (Pe = this.eip6963ProviderInfo) === null || Pe === void 0 ? void 0 : Pe.uuid,
          chainId: be
        });
      });
    }
    enable() {
      return s(this, void 0, void 0, function* () {
        return yield F.requestMethod("request", {
          method: "eth_requestAccounts"
        });
      });
    }
    net_version() {
      return s(this, void 0, void 0, function* () {
        return yield F.requestMethod("request", {
          method: "net_version"
        });
      });
    }
  }
  class le extends C.default {
    constructor(pe) {
      super(), this.keplr = pe;
    }
    static _requestMethod(pe, Ie) {
      return s(this, void 0, void 0, function* () {
        const be = "ReactNativeWebView" in window, Pe = be ? (ve) => {
          window.ReactNativeWebView.postMessage(JSON.stringify(ve));
        } : (ve) => {
          window.postMessage(ve, window.location.origin);
        }, Te = be ? (ve) => {
          if (ve && typeof ve == "string")
            try {
              return JSON.parse(ve);
            } catch {
            }
          return ve;
        } : (ve) => ve, Qe = new Uint8Array(8), xe = Array.from(crypto.getRandomValues(Qe)).map((ve) => ve.toString(16)).join(""), He = {
          type: window.keplrRequestMetaIdSupport ? `proxy-request${B.metaId ? `-${B.metaId}` : ""}` : "proxy-request",
          id: xe,
          method: "bitcoin",
          args: p.JSONUint8Array.wrap(Ie),
          bitcoinProviderMethod: pe
        };
        return new Promise((ve, we) => {
          const Ce = (Se) => {
            const Ne = Te(Se.data);
            if (!Ne || Ne.type !== "proxy-request-response" || Ne.id !== xe)
              return;
            window.removeEventListener("message", Ce);
            const rr = p.JSONUint8Array.unwrap(Ne.result);
            if (!rr) {
              we(new Error("Result is null"));
              return;
            }
            if (rr.error) {
              we(new Error(rr.error));
              return;
            }
            ve(rr.return);
          };
          window.addEventListener("message", Ce), Pe(He);
        });
      });
    }
    getAccounts() {
      return le._requestMethod("getAccounts", []);
    }
    requestAccounts() {
      return s(this, void 0, void 0, function* () {
        return le._requestMethod("requestAccounts", []);
      });
    }
    disconnect() {
      return s(this, void 0, void 0, function* () {
        return le._requestMethod("disconnect", []);
      });
    }
    getNetwork() {
      return s(this, void 0, void 0, function* () {
        return le._requestMethod("getNetwork", []);
      });
    }
    switchNetwork(pe) {
      return s(this, void 0, void 0, function* () {
        return le._requestMethod("switchNetwork", [pe]);
      });
    }
    getChain() {
      return s(this, void 0, void 0, function* () {
        return le._requestMethod("getChain", []);
      });
    }
    switchChain(pe) {
      return s(this, void 0, void 0, function* () {
        return le._requestMethod("switchChain", [pe]);
      });
    }
    getPublicKey() {
      return s(this, void 0, void 0, function* () {
        return le._requestMethod("getPublicKey", []);
      });
    }
    getBalance() {
      return s(this, void 0, void 0, function* () {
        return le._requestMethod("getBalance", []);
      });
    }
    getInscriptions(pe, Ie) {
      return s(this, void 0, void 0, function* () {
        return le._requestMethod("getInscriptions", [pe, Ie]);
      });
    }
    signMessage(pe, Ie) {
      return s(this, void 0, void 0, function* () {
        return le._requestMethod("signMessage", [pe, Ie]);
      });
    }
    sendBitcoin(pe, Ie) {
      return s(this, void 0, void 0, function* () {
        return le._requestMethod("sendBitcoin", [pe, Ie]);
      });
    }
    pushTx(pe) {
      return s(this, void 0, void 0, function* () {
        return le._requestMethod("pushTx", [pe]);
      });
    }
    pushPsbt(pe) {
      return s(this, void 0, void 0, function* () {
        return le._requestMethod("pushPsbt", [pe]);
      });
    }
    signPsbt(pe, Ie) {
      return s(this, void 0, void 0, function* () {
        return le._requestMethod("signPsbt", [pe, Ie]);
      });
    }
    signPsbts(pe, Ie) {
      return s(this, void 0, void 0, function* () {
        return le._requestMethod("signPsbts", [pe, Ie]);
      });
    }
    getAddress() {
      return s(this, void 0, void 0, function* () {
        return (yield this.getAccounts())[0];
      });
    }
    connectWallet() {
      return s(this, void 0, void 0, function* () {
        return this.requestAccounts();
      });
    }
  }
  return keplr$1.BitcoinProvider = le, keplr$1;
}
var keplrFallback = {}, hasRequiredKeplrFallback;
function requireKeplrFallback() {
  if (hasRequiredKeplrFallback) return keplrFallback;
  hasRequiredKeplrFallback = 1;
  var s = keplrFallback && keplrFallback.__awaiter || function(p, t, l, m) {
    function b(k) {
      return k instanceof l ? k : new l(function(C) {
        C(k);
      });
    }
    return new (l || (l = Promise))(function(k, C) {
      function B(x) {
        try {
          P(m.next(x));
        } catch (M) {
          C(M);
        }
      }
      function Q(x) {
        try {
          P(m.throw(x));
        } catch (M) {
          C(M);
        }
      }
      function P(x) {
        x.done ? k(x.value) : b(x.value).then(B, Q);
      }
      P((m = m.apply(p, t || [])).next());
    });
  };
  Object.defineProperty(keplrFallback, "__esModule", { value: !0 }), keplrFallback.KeplrFallback = void 0;
  const A = requireKeplr();
  class u extends A.Keplr {
    constructor(t) {
      super(), this.onKeplrNotDetected = t, this.isKeplrDetected = null, this.onKeplrNotDetected && A.Keplr.getKeplr(500).then((l) => {
        var m;
        l || (m = this.onKeplrNotDetected) === null || m === void 0 || m.call(this);
      });
    }
    requestMethod(t, l) {
      return s(this, void 0, void 0, function* () {
        if (this.isKeplrDetected == null && ((yield A.Keplr.getKeplr(500)) ? this.isKeplrDetected = !0 : this.isKeplrDetected = !1), this.isKeplrDetected)
          return A.Keplr.staticRequestMethod(t, l);
        {
          const m = window.keplr;
          if (m)
            return m[t](...l);
          throw new Error("Can't detect keplr fallback");
        }
      });
    }
  }
  return keplrFallback.KeplrFallback = u, keplrFallback;
}
var hasRequiredBuild$5;
function requireBuild$5() {
  return hasRequiredBuild$5 || (hasRequiredBuild$5 = 1, function(s) {
    var A = build$6 && build$6.__createBinding || (Object.create ? function(p, t, l, m) {
      m === void 0 && (m = l);
      var b = Object.getOwnPropertyDescriptor(t, l);
      (!b || ("get" in b ? !t.__esModule : b.writable || b.configurable)) && (b = { enumerable: !0, get: function() {
        return t[l];
      } }), Object.defineProperty(p, m, b);
    } : function(p, t, l, m) {
      m === void 0 && (m = l), p[m] = t[l];
    }), u = build$6 && build$6.__exportStar || function(p, t) {
      for (var l in p) l !== "default" && !Object.prototype.hasOwnProperty.call(t, l) && A(t, p, l);
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), u(requireKeplr(), s), u(requireKeplrFallback(), s);
  }(build$6)), build$6;
}
var buildExports$1 = requireBuild$5(), lib$4 = {}, signer = {}, base64Url = {}, base64Js = {}, hasRequiredBase64Js;
function requireBase64Js() {
  if (hasRequiredBase64Js) return base64Js;
  hasRequiredBase64Js = 1, base64Js.byteLength = b, base64Js.toByteArray = C, base64Js.fromByteArray = P;
  for (var s = [], A = [], u = typeof Uint8Array < "u" ? Uint8Array : Array, p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", t = 0, l = p.length; t < l; ++t)
    s[t] = p[t], A[p.charCodeAt(t)] = t;
  A[45] = 62, A[95] = 63;
  function m(x) {
    var M = x.length;
    if (M % 4 > 0)
      throw new Error("Invalid string. Length must be a multiple of 4");
    var F = x.indexOf("=");
    F === -1 && (F = M);
    var le = F === M ? 0 : 4 - F % 4;
    return [F, le];
  }
  function b(x) {
    var M = m(x), F = M[0], le = M[1];
    return (F + le) * 3 / 4 - le;
  }
  function k(x, M, F) {
    return (M + F) * 3 / 4 - F;
  }
  function C(x) {
    var M, F = m(x), le = F[0], ge = F[1], pe = new u(k(x, le, ge)), Ie = 0, be = ge > 0 ? le - 4 : le, Pe;
    for (Pe = 0; Pe < be; Pe += 4)
      M = A[x.charCodeAt(Pe)] << 18 | A[x.charCodeAt(Pe + 1)] << 12 | A[x.charCodeAt(Pe + 2)] << 6 | A[x.charCodeAt(Pe + 3)], pe[Ie++] = M >> 16 & 255, pe[Ie++] = M >> 8 & 255, pe[Ie++] = M & 255;
    return ge === 2 && (M = A[x.charCodeAt(Pe)] << 2 | A[x.charCodeAt(Pe + 1)] >> 4, pe[Ie++] = M & 255), ge === 1 && (M = A[x.charCodeAt(Pe)] << 10 | A[x.charCodeAt(Pe + 1)] << 4 | A[x.charCodeAt(Pe + 2)] >> 2, pe[Ie++] = M >> 8 & 255, pe[Ie++] = M & 255), pe;
  }
  function B(x) {
    return s[x >> 18 & 63] + s[x >> 12 & 63] + s[x >> 6 & 63] + s[x & 63];
  }
  function Q(x, M, F) {
    for (var le, ge = [], pe = M; pe < F; pe += 3)
      le = (x[pe] << 16 & 16711680) + (x[pe + 1] << 8 & 65280) + (x[pe + 2] & 255), ge.push(B(le));
    return ge.join("");
  }
  function P(x) {
    for (var M, F = x.length, le = F % 3, ge = [], pe = 16383, Ie = 0, be = F - le; Ie < be; Ie += pe)
      ge.push(Q(x, Ie, Ie + pe > be ? be : Ie + pe));
    return le === 1 ? (M = x[F - 1], ge.push(
      s[M >> 2] + s[M << 4 & 63] + "=="
    )) : le === 2 && (M = (x[F - 2] << 8) + x[F - 1], ge.push(
      s[M >> 10] + s[M >> 4 & 63] + s[M << 2 & 63] + "="
    )), ge.join("");
  }
  return base64Js;
}
var hasRequiredBase64Url;
function requireBase64Url() {
  if (hasRequiredBase64Url) return base64Url;
  hasRequiredBase64Url = 1, Object.defineProperty(base64Url, "__esModule", { value: !0 }), base64Url.decode = base64Url.encode = base64Url.unescape = base64Url.escape = base64Url.pad = void 0;
  const s = requireBase64Js();
  function A(m) {
    return `${m}${"=".repeat(4 - (m.length % 4 || 4))}`;
  }
  base64Url.pad = A;
  function u(m) {
    return m.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
  }
  base64Url.escape = u;
  function p(m) {
    return A(m).replace(/-/g, "+").replace(/_/g, "/");
  }
  base64Url.unescape = p;
  function t(m) {
    return u((0, s.fromByteArray)(new TextEncoder().encode(m)));
  }
  base64Url.encode = t;
  function l(m) {
    return new TextDecoder().decode((0, s.toByteArray)(A(p(m))));
  }
  return base64Url.decode = l, base64Url;
}
var cryptoClients = {}, secp256k1$2 = {}, lib$3 = {}, hasRequiredLib$4;
function requireLib$4() {
  return hasRequiredLib$4 || (hasRequiredLib$4 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.utils = s.schnorr = s.verify = s.signSync = s.sign = s.getSharedSecret = s.recoverPublicKey = s.getPublicKey = s.hexToBytes = s.bytesToHex = s.Signature = s.Point = s.CURVE = void 0;
    const A = requireCryptoBrowserify(), u = BigInt(0), p = BigInt(1), t = BigInt(2), l = BigInt(3), m = BigInt(8), b = Object.freeze({
      a: u,
      b: BigInt(7),
      P: BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"),
      n: BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"),
      h: p,
      Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
      Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
      beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee")
    });
    s.CURVE = b;
    const k = (vr, Cr) => (vr + Cr / t) / Cr, C = {
      beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
      splitScalar(vr) {
        const { n: Cr } = b, yn = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), Pn = -p * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), $n = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), ui = yn, Ei = BigInt("0x100000000000000000000000000000000"), zi = k(ui * vr, Cr), Gi = k(-Pn * vr, Cr);
        let Vi = qr(vr - zi * yn - Gi * $n, Cr), Ur = qr(-zi * Pn - Gi * ui, Cr);
        const $i = Vi > Ei, Es = Ur > Ei;
        if ($i && (Vi = Cr - Vi), Es && (Ur = Cr - Ur), Vi > Ei || Ur > Ei)
          throw new Error("splitScalarEndo: Endomorphism failed, k=" + vr);
        return { k1neg: $i, k1: Vi, k2neg: Es, k2: Ur };
      }
    }, B = 32, Q = 32, P = 32, x = B + 1, M = 2 * B + 1;
    function F(vr) {
      const { a: Cr, b: yn } = b, Pn = qr(vr * vr), $n = qr(Pn * vr);
      return qr($n + Cr * vr + yn);
    }
    const le = b.a === u;
    class ge extends Error {
      constructor(Cr) {
        super(Cr);
      }
    }
    function pe(vr) {
      if (!(vr instanceof Ie))
        throw new TypeError("JacobianPoint expected");
    }
    class Ie {
      constructor(Cr, yn, Pn) {
        this.x = Cr, this.y = yn, this.z = Pn;
      }
      static fromAffine(Cr) {
        if (!(Cr instanceof Te))
          throw new TypeError("JacobianPoint#fromAffine: expected Point");
        return Cr.equals(Te.ZERO) ? Ie.ZERO : new Ie(Cr.x, Cr.y, p);
      }
      static toAffineBatch(Cr) {
        const yn = wr(Cr.map((Pn) => Pn.z));
        return Cr.map((Pn, $n) => Pn.toAffine(yn[$n]));
      }
      static normalizeZ(Cr) {
        return Ie.toAffineBatch(Cr).map(Ie.fromAffine);
      }
      equals(Cr) {
        pe(Cr);
        const { x: yn, y: Pn, z: $n } = this, { x: ui, y: Ei, z: zi } = Cr, Gi = qr($n * $n), Vi = qr(zi * zi), Ur = qr(yn * Vi), $i = qr(ui * Gi), Es = qr(qr(Pn * zi) * Vi), pn = qr(qr(Ei * $n) * Gi);
        return Ur === $i && Es === pn;
      }
      negate() {
        return new Ie(this.x, qr(-this.y), this.z);
      }
      double() {
        const { x: Cr, y: yn, z: Pn } = this, $n = qr(Cr * Cr), ui = qr(yn * yn), Ei = qr(ui * ui), zi = Cr + ui, Gi = qr(t * (qr(zi * zi) - $n - Ei)), Vi = qr(l * $n), Ur = qr(Vi * Vi), $i = qr(Ur - t * Gi), Es = qr(Vi * (Gi - $i) - m * Ei), pn = qr(t * yn * Pn);
        return new Ie($i, Es, pn);
      }
      add(Cr) {
        pe(Cr);
        const { x: yn, y: Pn, z: $n } = this, { x: ui, y: Ei, z: zi } = Cr;
        if (ui === u || Ei === u)
          return this;
        if (yn === u || Pn === u)
          return Cr;
        const Gi = qr($n * $n), Vi = qr(zi * zi), Ur = qr(yn * Vi), $i = qr(ui * Gi), Es = qr(qr(Pn * zi) * Vi), pn = qr(qr(Ei * $n) * Gi), Nr = qr($i - Ur), Qn = qr(pn - Es);
        if (Nr === u)
          return Qn === u ? this.double() : Ie.ZERO;
        const zn = qr(Nr * Nr), ti = qr(Nr * zn), v = qr(Ur * zn), d = qr(Qn * Qn - ti - t * v), I = qr(Qn * (v - d) - Es * ti), n = qr($n * zi * Nr);
        return new Ie(d, I, n);
      }
      subtract(Cr) {
        return this.add(Cr.negate());
      }
      multiplyUnsafe(Cr) {
        const yn = Ie.ZERO;
        if (typeof Cr == "bigint" && Cr === u)
          return yn;
        let Pn = Gr(Cr);
        if (Pn === p)
          return this;
        if (!le) {
          let $i = yn, Es = this;
          for (; Pn > u; )
            Pn & p && ($i = $i.add(Es)), Es = Es.double(), Pn >>= p;
          return $i;
        }
        let { k1neg: $n, k1: ui, k2neg: Ei, k2: zi } = C.splitScalar(Pn), Gi = yn, Vi = yn, Ur = this;
        for (; ui > u || zi > u; )
          ui & p && (Gi = Gi.add(Ur)), zi & p && (Vi = Vi.add(Ur)), Ur = Ur.double(), ui >>= p, zi >>= p;
        return $n && (Gi = Gi.negate()), Ei && (Vi = Vi.negate()), Vi = new Ie(qr(Vi.x * C.beta), Vi.y, Vi.z), Gi.add(Vi);
      }
      precomputeWindow(Cr) {
        const yn = le ? 128 / Cr + 1 : 256 / Cr + 1, Pn = [];
        let $n = this, ui = $n;
        for (let Ei = 0; Ei < yn; Ei++) {
          ui = $n, Pn.push(ui);
          for (let zi = 1; zi < 2 ** (Cr - 1); zi++)
            ui = ui.add($n), Pn.push(ui);
          $n = ui.double();
        }
        return Pn;
      }
      wNAF(Cr, yn) {
        !yn && this.equals(Ie.BASE) && (yn = Te.BASE);
        const Pn = yn && yn._WINDOW_SIZE || 1;
        if (256 % Pn)
          throw new Error("Point#wNAF: Invalid precomputation window, must be power of 2");
        let $n = yn && Pe.get(yn);
        $n || ($n = this.precomputeWindow(Pn), yn && Pn !== 1 && ($n = Ie.normalizeZ($n), Pe.set(yn, $n)));
        let ui = Ie.ZERO, Ei = Ie.BASE;
        const zi = 1 + (le ? 128 / Pn : 256 / Pn), Gi = 2 ** (Pn - 1), Vi = BigInt(2 ** Pn - 1), Ur = 2 ** Pn, $i = BigInt(Pn);
        for (let Es = 0; Es < zi; Es++) {
          const pn = Es * Gi;
          let Nr = Number(Cr & Vi);
          Cr >>= $i, Nr > Gi && (Nr -= Ur, Cr += p);
          const Qn = pn, zn = pn + Math.abs(Nr) - 1, ti = Es % 2 !== 0, v = Nr < 0;
          Nr === 0 ? Ei = Ei.add(be(ti, $n[Qn])) : ui = ui.add(be(v, $n[zn]));
        }
        return { p: ui, f: Ei };
      }
      multiply(Cr, yn) {
        let Pn = Gr(Cr), $n, ui;
        if (le) {
          const { k1neg: Ei, k1: zi, k2neg: Gi, k2: Vi } = C.splitScalar(Pn);
          let { p: Ur, f: $i } = this.wNAF(zi, yn), { p: Es, f: pn } = this.wNAF(Vi, yn);
          Ur = be(Ei, Ur), Es = be(Gi, Es), Es = new Ie(qr(Es.x * C.beta), Es.y, Es.z), $n = Ur.add(Es), ui = $i.add(pn);
        } else {
          const { p: Ei, f: zi } = this.wNAF(Pn, yn);
          $n = Ei, ui = zi;
        }
        return Ie.normalizeZ([$n, ui])[0];
      }
      toAffine(Cr) {
        const { x: yn, y: Pn, z: $n } = this, ui = this.equals(Ie.ZERO);
        Cr == null && (Cr = ui ? m : Dr($n));
        const Ei = Cr, zi = qr(Ei * Ei), Gi = qr(zi * Ei), Vi = qr(yn * zi), Ur = qr(Pn * Gi), $i = qr($n * Ei);
        if (ui)
          return Te.ZERO;
        if ($i !== p)
          throw new Error("invZ was invalid");
        return new Te(Vi, Ur);
      }
    }
    Ie.BASE = new Ie(b.Gx, b.Gy, p), Ie.ZERO = new Ie(u, p, u);
    function be(vr, Cr) {
      const yn = Cr.negate();
      return vr ? yn : Cr;
    }
    const Pe = /* @__PURE__ */ new WeakMap();
    class Te {
      constructor(Cr, yn) {
        this.x = Cr, this.y = yn;
      }
      _setWindowSize(Cr) {
        this._WINDOW_SIZE = Cr, Pe.delete(this);
      }
      hasEvenY() {
        return this.y % t === u;
      }
      static fromCompressedHex(Cr) {
        const yn = Cr.length === 32, Pn = Br(yn ? Cr : Cr.subarray(1));
        if (!dn(Pn))
          throw new Error("Point is not on curve");
        const $n = F(Pn);
        let ui = un($n);
        const Ei = (ui & p) === p;
        yn ? Ei && (ui = qr(-ui)) : (Cr[0] & 1) === 1 !== Ei && (ui = qr(-ui));
        const zi = new Te(Pn, ui);
        return zi.assertValidity(), zi;
      }
      static fromUncompressedHex(Cr) {
        const yn = Br(Cr.subarray(1, B + 1)), Pn = Br(Cr.subarray(B + 1, B * 2 + 1)), $n = new Te(yn, Pn);
        return $n.assertValidity(), $n;
      }
      static fromHex(Cr) {
        const yn = Fr(Cr), Pn = yn.length, $n = yn[0];
        if (Pn === B)
          return this.fromCompressedHex(yn);
        if (Pn === x && ($n === 2 || $n === 3))
          return this.fromCompressedHex(yn);
        if (Pn === M && $n === 4)
          return this.fromUncompressedHex(yn);
        throw new Error(`Point.fromHex: received invalid point. Expected 32-${x} compressed bytes or ${M} uncompressed bytes, not ${Pn}`);
      }
      static fromPrivateKey(Cr) {
        return Te.BASE.multiply(Yn(Cr));
      }
      static fromSignature(Cr, yn, Pn) {
        const { r: $n, s: ui } = vn(yn);
        if (![0, 1, 2, 3].includes(Pn))
          throw new Error("Cannot recover: invalid recovery bit");
        const Ei = Qr(Fr(Cr)), { n: zi } = b, Gi = Pn === 2 || Pn === 3 ? $n + zi : $n, Vi = Dr(Gi, zi), Ur = qr(-Ei * Vi, zi), $i = qr(ui * Vi, zi), Es = Pn & 1 ? "03" : "02", pn = Te.fromHex(Es + nr(Gi)), Nr = Te.BASE.multiplyAndAddUnsafe(pn, Ur, $i);
        if (!Nr)
          throw new Error("Cannot recover signature: point at infinify");
        return Nr.assertValidity(), Nr;
      }
      toRawBytes(Cr = !1) {
        return ir(this.toHex(Cr));
      }
      toHex(Cr = !1) {
        const yn = nr(this.x);
        return Cr ? `${this.hasEvenY() ? "02" : "03"}${yn}` : `04${yn}${nr(this.y)}`;
      }
      toHexX() {
        return this.toHex(!0).slice(2);
      }
      toRawX() {
        return this.toRawBytes(!0).slice(1);
      }
      assertValidity() {
        const Cr = "Point is not on elliptic curve", { x: yn, y: Pn } = this;
        if (!dn(yn) || !dn(Pn))
          throw new Error(Cr);
        const $n = qr(Pn * Pn), ui = F(yn);
        if (qr($n - ui) !== u)
          throw new Error(Cr);
      }
      equals(Cr) {
        return this.x === Cr.x && this.y === Cr.y;
      }
      negate() {
        return new Te(this.x, qr(-this.y));
      }
      double() {
        return Ie.fromAffine(this).double().toAffine();
      }
      add(Cr) {
        return Ie.fromAffine(this).add(Ie.fromAffine(Cr)).toAffine();
      }
      subtract(Cr) {
        return this.add(Cr.negate());
      }
      multiply(Cr) {
        return Ie.fromAffine(this).multiply(Cr, this).toAffine();
      }
      multiplyAndAddUnsafe(Cr, yn, Pn) {
        const $n = Ie.fromAffine(this), ui = yn === u || yn === p || this !== Te.BASE ? $n.multiplyUnsafe(yn) : $n.multiply(yn), Ei = Ie.fromAffine(Cr).multiplyUnsafe(Pn), zi = ui.add(Ei);
        return zi.equals(Ie.ZERO) ? void 0 : zi.toAffine();
      }
    }
    s.Point = Te, Te.BASE = new Te(b.Gx, b.Gy), Te.ZERO = new Te(u, u);
    function Qe(vr) {
      return Number.parseInt(vr[0], 16) >= 8 ? "00" + vr : vr;
    }
    function xe(vr) {
      if (vr.length < 2 || vr[0] !== 2)
        throw new Error(`Invalid signature integer tag: ${Ne(vr)}`);
      const Cr = vr[1], yn = vr.subarray(2, Cr + 2);
      if (!Cr || yn.length !== Cr)
        throw new Error("Invalid signature integer: wrong length");
      if (yn[0] === 0 && yn[1] <= 127)
        throw new Error("Invalid signature integer: trailing length");
      return { data: Br(yn), left: vr.subarray(Cr + 2) };
    }
    function Ee(vr) {
      if (vr.length < 2 || vr[0] != 48)
        throw new Error(`Invalid signature tag: ${Ne(vr)}`);
      if (vr[1] !== vr.length - 2)
        throw new Error("Invalid signature: incorrect length");
      const { data: Cr, left: yn } = xe(vr.subarray(2)), { data: Pn, left: $n } = xe(yn);
      if ($n.length)
        throw new Error(`Invalid signature: left bytes after parsing: ${Ne($n)}`);
      return { r: Cr, s: Pn };
    }
    class He {
      constructor(Cr, yn) {
        this.r = Cr, this.s = yn, this.assertValidity();
      }
      static fromCompact(Cr) {
        const yn = ve(Cr), Pn = "Signature.fromCompact";
        if (typeof Cr != "string" && !yn)
          throw new TypeError(`${Pn}: Expected string or Uint8Array`);
        const $n = yn ? Ne(Cr) : Cr;
        if ($n.length !== 128)
          throw new Error(`${Pn}: Expected 64-byte hex`);
        return new He(br($n.slice(0, 64)), br($n.slice(64, 128)));
      }
      static fromDER(Cr) {
        const yn = ve(Cr);
        if (typeof Cr != "string" && !yn)
          throw new TypeError("Signature.fromDER: Expected string or Uint8Array");
        const { r: Pn, s: $n } = Ee(yn ? Cr : ir(Cr));
        return new He(Pn, $n);
      }
      static fromHex(Cr) {
        return this.fromDER(Cr);
      }
      assertValidity() {
        const { r: Cr, s: yn } = this;
        if (!jr(Cr))
          throw new Error("Invalid Signature: r must be 0 < r < n");
        if (!jr(yn))
          throw new Error("Invalid Signature: s must be 0 < s < n");
      }
      hasHighS() {
        const Cr = b.n >> p;
        return this.s > Cr;
      }
      normalizeS() {
        return this.hasHighS() ? new He(this.r, qr(-this.s, b.n)) : this;
      }
      toDERRawBytes() {
        return ir(this.toDERHex());
      }
      toDERHex() {
        const Cr = Qe(lr(this.s)), yn = Qe(lr(this.r)), Pn = Cr.length / 2, $n = yn.length / 2, ui = lr(Pn), Ei = lr($n);
        return `30${lr($n + Pn + 4)}02${Ei}${yn}02${ui}${Cr}`;
      }
      toRawBytes() {
        return this.toDERRawBytes();
      }
      toHex() {
        return this.toDERHex();
      }
      toCompactRawBytes() {
        return ir(this.toCompactHex());
      }
      toCompactHex() {
        return nr(this.r) + nr(this.s);
      }
    }
    s.Signature = He;
    function ve(vr) {
      return vr instanceof Uint8Array || ArrayBuffer.isView(vr) && vr.constructor.name === "Uint8Array";
    }
    function we(vr) {
      if (!ve(vr))
        throw new Error("Uint8Array expected");
    }
    function Ce(...vr) {
      if (vr.every(we), vr.length === 1)
        return vr[0];
      const Cr = vr.reduce((Pn, $n) => Pn + $n.length, 0), yn = new Uint8Array(Cr);
      for (let Pn = 0, $n = 0; Pn < vr.length; Pn++) {
        const ui = vr[Pn];
        yn.set(ui, $n), $n += ui.length;
      }
      return yn;
    }
    const Se = Array.from({ length: 256 }, (vr, Cr) => Cr.toString(16).padStart(2, "0"));
    function Ne(vr) {
      we(vr);
      let Cr = "";
      for (let yn = 0; yn < vr.length; yn++)
        Cr += Se[vr[yn]];
      return Cr;
    }
    s.bytesToHex = Ne;
    const rr = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
    function er(vr) {
      if (vr >= rr._0 && vr <= rr._9)
        return vr - rr._0;
      if (vr >= rr.A && vr <= rr.F)
        return vr - (rr.A - 10);
      if (vr >= rr.a && vr <= rr.f)
        return vr - (rr.a - 10);
    }
    function ir(vr) {
      if (typeof vr != "string")
        throw new Error("hex string expected, got " + typeof vr);
      const Cr = vr.length, yn = Cr / 2;
      if (Cr % 2)
        throw new Error("hex string expected, got unpadded hex of length " + Cr);
      const Pn = new Uint8Array(yn);
      for (let $n = 0, ui = 0; $n < yn; $n++, ui += 2) {
        const Ei = er(vr.charCodeAt(ui)), zi = er(vr.charCodeAt(ui + 1));
        if (Ei === void 0 || zi === void 0) {
          const Gi = vr[ui] + vr[ui + 1];
          throw new Error('hex string expected, got non-hex character "' + Gi + '" at index ' + ui);
        }
        Pn[$n] = Ei * 16 + zi;
      }
      return Pn;
    }
    s.hexToBytes = ir;
    const sr = BigInt("0x10000000000000000000000000000000000000000000000000000000000000000");
    function nr(vr) {
      if (typeof vr != "bigint")
        throw new Error("Expected bigint");
      if (!(u <= vr && vr < sr))
        throw new Error("Expected number 0 <= n < 2^256");
      return vr.toString(16).padStart(64, "0");
    }
    function fr(vr) {
      const Cr = ir(nr(vr));
      if (Cr.length !== 32)
        throw new Error("Error: expected 32 bytes");
      return Cr;
    }
    function lr(vr) {
      const Cr = vr.toString(16);
      return Cr.length & 1 ? `0${Cr}` : Cr;
    }
    function br(vr) {
      if (typeof vr != "string")
        throw new TypeError("hexToNumber: expected string, got " + typeof vr);
      return BigInt(`0x${vr}`);
    }
    function Br(vr) {
      return br(Ne(vr));
    }
    function Fr(vr) {
      return ve(vr) ? Uint8Array.from(vr) : ir(vr);
    }
    function Gr(vr) {
      if (typeof vr == "number" && Number.isSafeInteger(vr) && vr > 0)
        return BigInt(vr);
      if (typeof vr == "bigint" && jr(vr))
        return vr;
      throw new TypeError("Expected valid private scalar: 0 < scalar < curve.n");
    }
    function qr(vr, Cr = b.P) {
      const yn = vr % Cr;
      return yn >= u ? yn : Cr + yn;
    }
    function Hr(vr, Cr) {
      const { P: yn } = b;
      let Pn = vr;
      for (; Cr-- > u; )
        Pn *= Pn, Pn %= yn;
      return Pn;
    }
    function un(vr) {
      const { P: Cr } = b, yn = BigInt(6), Pn = BigInt(11), $n = BigInt(22), ui = BigInt(23), Ei = BigInt(44), zi = BigInt(88), Gi = vr * vr * vr % Cr, Vi = Gi * Gi * vr % Cr, Ur = Hr(Vi, l) * Vi % Cr, $i = Hr(Ur, l) * Vi % Cr, Es = Hr($i, t) * Gi % Cr, pn = Hr(Es, Pn) * Es % Cr, Nr = Hr(pn, $n) * pn % Cr, Qn = Hr(Nr, Ei) * Nr % Cr, zn = Hr(Qn, zi) * Qn % Cr, ti = Hr(zn, Ei) * Nr % Cr, v = Hr(ti, l) * Vi % Cr, d = Hr(v, ui) * pn % Cr, I = Hr(d, yn) * Gi % Cr, n = Hr(I, t);
      if (n * n % Cr !== vr)
        throw new Error("Cannot find square root");
      return n;
    }
    function Dr(vr, Cr = b.P) {
      if (vr === u || Cr <= u)
        throw new Error(`invert: expected positive integers, got n=${vr} mod=${Cr}`);
      let yn = qr(vr, Cr), Pn = Cr, $n = u, ui = p;
      for (; yn !== u; ) {
        const zi = Pn / yn, Gi = Pn % yn, Vi = $n - ui * zi;
        Pn = yn, yn = Gi, $n = ui, ui = Vi;
      }
      if (Pn !== p)
        throw new Error("invert: does not exist");
      return qr($n, Cr);
    }
    function wr(vr, Cr = b.P) {
      const yn = new Array(vr.length), Pn = vr.reduce((ui, Ei, zi) => Ei === u ? ui : (yn[zi] = ui, qr(ui * Ei, Cr)), p), $n = Dr(Pn, Cr);
      return vr.reduceRight((ui, Ei, zi) => Ei === u ? ui : (yn[zi] = qr(ui * yn[zi], Cr), qr(ui * Ei, Cr)), $n), yn;
    }
    function yr(vr) {
      const Cr = vr.length * 8 - Q * 8, yn = Br(vr);
      return Cr > 0 ? yn >> BigInt(Cr) : yn;
    }
    function Qr(vr, Cr = !1) {
      const yn = yr(vr);
      if (Cr)
        return yn;
      const { n: Pn } = b;
      return yn >= Pn ? yn - Pn : yn;
    }
    let _r, Jr;
    class fn {
      constructor(Cr, yn) {
        if (this.hashLen = Cr, this.qByteLen = yn, typeof Cr != "number" || Cr < 2)
          throw new Error("hashLen must be a number");
        if (typeof yn != "number" || yn < 2)
          throw new Error("qByteLen must be a number");
        this.v = new Uint8Array(Cr).fill(1), this.k = new Uint8Array(Cr).fill(0), this.counter = 0;
      }
      hmac(...Cr) {
        return s.utils.hmacSha256(this.k, ...Cr);
      }
      hmacSync(...Cr) {
        return Jr(this.k, ...Cr);
      }
      checkSync() {
        if (typeof Jr != "function")
          throw new ge("hmacSha256Sync needs to be set");
      }
      incr() {
        if (this.counter >= 1e3)
          throw new Error("Tried 1,000 k values for sign(), all were invalid");
        this.counter += 1;
      }
      async reseed(Cr = new Uint8Array()) {
        this.k = await this.hmac(this.v, Uint8Array.from([0]), Cr), this.v = await this.hmac(this.v), Cr.length !== 0 && (this.k = await this.hmac(this.v, Uint8Array.from([1]), Cr), this.v = await this.hmac(this.v));
      }
      reseedSync(Cr = new Uint8Array()) {
        this.checkSync(), this.k = this.hmacSync(this.v, Uint8Array.from([0]), Cr), this.v = this.hmacSync(this.v), Cr.length !== 0 && (this.k = this.hmacSync(this.v, Uint8Array.from([1]), Cr), this.v = this.hmacSync(this.v));
      }
      async generate() {
        this.incr();
        let Cr = 0;
        const yn = [];
        for (; Cr < this.qByteLen; ) {
          this.v = await this.hmac(this.v);
          const Pn = this.v.slice();
          yn.push(Pn), Cr += this.v.length;
        }
        return Ce(...yn);
      }
      generateSync() {
        this.checkSync(), this.incr();
        let Cr = 0;
        const yn = [];
        for (; Cr < this.qByteLen; ) {
          this.v = this.hmacSync(this.v);
          const Pn = this.v.slice();
          yn.push(Pn), Cr += this.v.length;
        }
        return Ce(...yn);
      }
    }
    function jr(vr) {
      return u < vr && vr < b.n;
    }
    function dn(vr) {
      return u < vr && vr < b.P;
    }
    function Tn(vr, Cr, yn, Pn = !0) {
      const { n: $n } = b, ui = Qr(vr, !0);
      if (!jr(ui))
        return;
      const Ei = Dr(ui, $n), zi = Te.BASE.multiply(ui), Gi = qr(zi.x, $n);
      if (Gi === u)
        return;
      const Vi = qr(Ei * qr(Cr + yn * Gi, $n), $n);
      if (Vi === u)
        return;
      let Ur = new He(Gi, Vi), $i = (zi.x === Ur.r ? 0 : 2) | Number(zi.y & p);
      return Pn && Ur.hasHighS() && (Ur = Ur.normalizeS(), $i ^= 1), { sig: Ur, recovery: $i };
    }
    function Yn(vr) {
      let Cr;
      if (typeof vr == "bigint")
        Cr = vr;
      else if (typeof vr == "number" && Number.isSafeInteger(vr) && vr > 0)
        Cr = BigInt(vr);
      else if (typeof vr == "string") {
        if (vr.length !== 2 * Q)
          throw new Error("Expected 32 bytes of private key");
        Cr = br(vr);
      } else if (ve(vr)) {
        if (vr.length !== Q)
          throw new Error("Expected 32 bytes of private key");
        Cr = Br(vr);
      } else
        throw new TypeError("Expected valid private key");
      if (!jr(Cr))
        throw new Error("Expected private key: 0 < key < n");
      return Cr;
    }
    function si(vr) {
      return vr instanceof Te ? (vr.assertValidity(), vr) : Te.fromHex(vr);
    }
    function vn(vr) {
      if (vr instanceof He)
        return vr.assertValidity(), vr;
      try {
        return He.fromDER(vr);
      } catch {
        return He.fromCompact(vr);
      }
    }
    function Cn(vr, Cr = !1) {
      return Te.fromPrivateKey(vr).toRawBytes(Cr);
    }
    s.getPublicKey = Cn;
    function Xr(vr, Cr, yn, Pn = !1) {
      return Te.fromSignature(vr, Cr, yn).toRawBytes(Pn);
    }
    s.recoverPublicKey = Xr;
    function In(vr) {
      const Cr = ve(vr), yn = typeof vr == "string", Pn = (Cr || yn) && vr.length;
      return Cr ? Pn === x || Pn === M : yn ? Pn === x * 2 || Pn === M * 2 : vr instanceof Te;
    }
    function zr(vr, Cr, yn = !1) {
      if (In(vr))
        throw new TypeError("getSharedSecret: first arg must be private key");
      if (!In(Cr))
        throw new TypeError("getSharedSecret: second arg must be public key");
      const Pn = si(Cr);
      return Pn.assertValidity(), Pn.multiply(Yn(vr)).toRawBytes(yn);
    }
    s.getSharedSecret = zr;
    function En(vr) {
      const Cr = vr.length > B ? vr.slice(0, B) : vr;
      return Br(Cr);
    }
    function Zr(vr) {
      const Cr = En(vr), yn = qr(Cr, b.n);
      return kr(yn < u ? Cr : yn);
    }
    function kr(vr) {
      return fr(vr);
    }
    function Rr(vr, Cr, yn) {
      if (vr == null)
        throw new Error(`sign: expected valid message hash, not "${vr}"`);
      const Pn = Fr(vr), $n = Yn(Cr), ui = [kr($n), Zr(Pn)];
      if (yn != null) {
        yn === !0 && (yn = s.utils.randomBytes(B));
        const Gi = Fr(yn);
        if (Gi.length !== B)
          throw new Error(`sign: Expected ${B} bytes of extra data`);
        ui.push(Gi);
      }
      const Ei = Ce(...ui), zi = En(Pn);
      return { seed: Ei, m: zi, d: $n };
    }
    function Er(vr, Cr) {
      const { sig: yn, recovery: Pn } = vr, { der: $n, recovered: ui } = Object.assign({ canonical: !0, der: !0 }, Cr), Ei = $n ? yn.toDERRawBytes() : yn.toCompactRawBytes();
      return ui ? [Ei, Pn] : Ei;
    }
    async function Or(vr, Cr, yn = {}) {
      const { seed: Pn, m: $n, d: ui } = Rr(vr, Cr, yn.extraEntropy), Ei = new fn(P, Q);
      await Ei.reseed(Pn);
      let zi;
      for (; !(zi = Tn(await Ei.generate(), $n, ui, yn.canonical)); )
        await Ei.reseed();
      return Er(zi, yn);
    }
    s.sign = Or;
    function wn(vr, Cr, yn = {}) {
      const { seed: Pn, m: $n, d: ui } = Rr(vr, Cr, yn.extraEntropy), Ei = new fn(P, Q);
      Ei.reseedSync(Pn);
      let zi;
      for (; !(zi = Tn(Ei.generateSync(), $n, ui, yn.canonical)); )
        Ei.reseedSync();
      return Er(zi, yn);
    }
    s.signSync = wn;
    const Kn = { strict: !0 };
    function Ln(vr, Cr, yn, Pn = Kn) {
      let $n;
      try {
        $n = vn(vr), Cr = Fr(Cr);
      } catch {
        return !1;
      }
      const { r: ui, s: Ei } = $n;
      if (Pn.strict && $n.hasHighS())
        return !1;
      const zi = Qr(Cr);
      let Gi;
      try {
        Gi = si(yn);
      } catch {
        return !1;
      }
      const { n: Vi } = b, Ur = Dr(Ei, Vi), $i = qr(zi * Ur, Vi), Es = qr(ui * Ur, Vi), pn = Te.BASE.multiplyAndAddUnsafe(Gi, $i, Es);
      return pn ? qr(pn.x, Vi) === ui : !1;
    }
    s.verify = Ln;
    function Wn(vr) {
      return qr(Br(vr), b.n);
    }
    class Sn {
      constructor(Cr, yn) {
        this.r = Cr, this.s = yn, this.assertValidity();
      }
      static fromHex(Cr) {
        const yn = Fr(Cr);
        if (yn.length !== 64)
          throw new TypeError(`SchnorrSignature.fromHex: expected 64 bytes, not ${yn.length}`);
        const Pn = Br(yn.subarray(0, 32)), $n = Br(yn.subarray(32, 64));
        return new Sn(Pn, $n);
      }
      assertValidity() {
        const { r: Cr, s: yn } = this;
        if (!dn(Cr) || !jr(yn))
          throw new Error("Invalid signature");
      }
      toHex() {
        return nr(this.r) + nr(this.s);
      }
      toRawBytes() {
        return ir(this.toHex());
      }
    }
    function hi(vr) {
      return Te.fromPrivateKey(vr).toRawX();
    }
    class ki {
      constructor(Cr, yn, Pn = s.utils.randomBytes()) {
        if (Cr == null)
          throw new TypeError(`sign: Expected valid message, not "${Cr}"`);
        this.m = Fr(Cr);
        const { x: $n, scalar: ui } = this.getScalar(Yn(yn));
        if (this.px = $n, this.d = ui, this.rand = Fr(Pn), this.rand.length !== 32)
          throw new TypeError("sign: Expected 32 bytes of aux randomness");
      }
      getScalar(Cr) {
        const yn = Te.fromPrivateKey(Cr), Pn = yn.hasEvenY() ? Cr : b.n - Cr;
        return { point: yn, scalar: Pn, x: yn.toRawX() };
      }
      initNonce(Cr, yn) {
        return fr(Cr ^ Br(yn));
      }
      finalizeNonce(Cr) {
        const yn = qr(Br(Cr), b.n);
        if (yn === u)
          throw new Error("sign: Creation of signature failed. k is zero");
        const { point: Pn, x: $n, scalar: ui } = this.getScalar(yn);
        return { R: Pn, rx: $n, k: ui };
      }
      finalizeSig(Cr, yn, Pn, $n) {
        return new Sn(Cr.x, qr(yn + Pn * $n, b.n)).toRawBytes();
      }
      error() {
        throw new Error("sign: Invalid signature produced");
      }
      async calc() {
        const { m: Cr, d: yn, px: Pn, rand: $n } = this, ui = s.utils.taggedHash, Ei = this.initNonce(yn, await ui(Ds.aux, $n)), { R: zi, rx: Gi, k: Vi } = this.finalizeNonce(await ui(Ds.nonce, Ei, Pn, Cr)), Ur = Wn(await ui(Ds.challenge, Gi, Pn, Cr)), $i = this.finalizeSig(zi, Vi, Ur, yn);
        return await Ui($i, Cr, Pn) || this.error(), $i;
      }
      calcSync() {
        const { m: Cr, d: yn, px: Pn, rand: $n } = this, ui = s.utils.taggedHashSync, Ei = this.initNonce(yn, ui(Ds.aux, $n)), { R: zi, rx: Gi, k: Vi } = this.finalizeNonce(ui(Ds.nonce, Ei, Pn, Cr)), Ur = Wn(ui(Ds.challenge, Gi, Pn, Cr)), $i = this.finalizeSig(zi, Vi, Ur, yn);
        return Mi($i, Cr, Pn) || this.error(), $i;
      }
    }
    async function xi(vr, Cr, yn) {
      return new ki(vr, Cr, yn).calc();
    }
    function _i(vr, Cr, yn) {
      return new ki(vr, Cr, yn).calcSync();
    }
    function Li(vr, Cr, yn) {
      const Pn = vr instanceof Sn, $n = Pn ? vr : Sn.fromHex(vr);
      return Pn && $n.assertValidity(), {
        ...$n,
        m: Fr(Cr),
        P: si(yn)
      };
    }
    function ms(vr, Cr, yn, Pn) {
      const $n = Te.BASE.multiplyAndAddUnsafe(Cr, Yn(yn), qr(-Pn, b.n));
      return !(!$n || !$n.hasEvenY() || $n.x !== vr);
    }
    async function Ui(vr, Cr, yn) {
      try {
        const { r: Pn, s: $n, m: ui, P: Ei } = Li(vr, Cr, yn), zi = Wn(await s.utils.taggedHash(Ds.challenge, fr(Pn), Ei.toRawX(), ui));
        return ms(Pn, Ei, $n, zi);
      } catch {
        return !1;
      }
    }
    function Mi(vr, Cr, yn) {
      try {
        const { r: Pn, s: $n, m: ui, P: Ei } = Li(vr, Cr, yn), zi = Wn(s.utils.taggedHashSync(Ds.challenge, fr(Pn), Ei.toRawX(), ui));
        return ms(Pn, Ei, $n, zi);
      } catch (Pn) {
        if (Pn instanceof ge)
          throw Pn;
        return !1;
      }
    }
    s.schnorr = {
      Signature: Sn,
      getPublicKey: hi,
      sign: xi,
      verify: Ui,
      signSync: _i,
      verifySync: Mi
    }, Te.BASE._setWindowSize(8);
    const Ls = {
      node: A,
      web: typeof self == "object" && "crypto" in self ? self.crypto : void 0
    }, Ds = {
      challenge: "BIP0340/challenge",
      aux: "BIP0340/aux",
      nonce: "BIP0340/nonce"
    }, Pr = {};
    s.utils = {
      bytesToHex: Ne,
      hexToBytes: ir,
      concatBytes: Ce,
      mod: qr,
      invert: Dr,
      isValidPrivateKey(vr) {
        try {
          return Yn(vr), !0;
        } catch {
          return !1;
        }
      },
      _bigintTo32Bytes: fr,
      _normalizePrivateKey: Yn,
      hashToPrivateKey: (vr) => {
        vr = Fr(vr);
        const Cr = Q + 8;
        if (vr.length < Cr || vr.length > 1024)
          throw new Error("Expected valid bytes of private key as per FIPS 186");
        const yn = qr(Br(vr), b.n - p) + p;
        return fr(yn);
      },
      randomBytes: (vr = 32) => {
        if (Ls.web)
          return Ls.web.getRandomValues(new Uint8Array(vr));
        if (Ls.node) {
          const { randomBytes: Cr } = Ls.node;
          return Uint8Array.from(Cr(vr));
        } else
          throw new Error("The environment doesn't have randomBytes function");
      },
      randomPrivateKey: () => s.utils.hashToPrivateKey(s.utils.randomBytes(Q + 8)),
      precompute(vr = 8, Cr = Te.BASE) {
        const yn = Cr === Te.BASE ? Cr : new Te(Cr.x, Cr.y);
        return yn._setWindowSize(vr), yn.multiply(l), yn;
      },
      sha256: async (...vr) => {
        if (Ls.web) {
          const Cr = await Ls.web.subtle.digest("SHA-256", Ce(...vr));
          return new Uint8Array(Cr);
        } else if (Ls.node) {
          const { createHash: Cr } = Ls.node, yn = Cr("sha256");
          return vr.forEach((Pn) => yn.update(Pn)), Uint8Array.from(yn.digest());
        } else
          throw new Error("The environment doesn't have sha256 function");
      },
      hmacSha256: async (vr, ...Cr) => {
        if (Ls.web) {
          const yn = await Ls.web.subtle.importKey("raw", vr, { name: "HMAC", hash: { name: "SHA-256" } }, !1, ["sign"]), Pn = Ce(...Cr), $n = await Ls.web.subtle.sign("HMAC", yn, Pn);
          return new Uint8Array($n);
        } else if (Ls.node) {
          const { createHmac: yn } = Ls.node, Pn = yn("sha256", vr);
          return Cr.forEach(($n) => Pn.update($n)), Uint8Array.from(Pn.digest());
        } else
          throw new Error("The environment doesn't have hmac-sha256 function");
      },
      sha256Sync: void 0,
      hmacSha256Sync: void 0,
      taggedHash: async (vr, ...Cr) => {
        let yn = Pr[vr];
        if (yn === void 0) {
          const Pn = await s.utils.sha256(Uint8Array.from(vr, ($n) => $n.charCodeAt(0)));
          yn = Ce(Pn, Pn), Pr[vr] = yn;
        }
        return s.utils.sha256(yn, ...Cr);
      },
      taggedHashSync: (vr, ...Cr) => {
        if (typeof _r != "function")
          throw new ge("sha256Sync is undefined, you need to set it");
        let yn = Pr[vr];
        if (yn === void 0) {
          const Pn = _r(Uint8Array.from(vr, ($n) => $n.charCodeAt(0)));
          yn = Ce(Pn, Pn), Pr[vr] = yn;
        }
        return _r(yn, ...Cr);
      },
      _JacobianPoint: Ie
    }, Object.defineProperties(s.utils, {
      sha256Sync: {
        configurable: !1,
        get() {
          return _r;
        },
        set(vr) {
          _r || (_r = vr);
        }
      },
      hmacSha256Sync: {
        configurable: !1,
        get() {
          return Jr;
        },
        set(vr) {
          Jr || (Jr = vr);
        }
      }
    });
  }(lib$3)), lib$3;
}
var ecdsaSigFormatter = {}, hasRequiredEcdsaSigFormatter;
function requireEcdsaSigFormatter() {
  if (hasRequiredEcdsaSigFormatter) return ecdsaSigFormatter;
  hasRequiredEcdsaSigFormatter = 1, Object.defineProperty(ecdsaSigFormatter, "__esModule", { value: !0 }), ecdsaSigFormatter.joseToDer = ecdsaSigFormatter.derToJose = void 0;
  const s = requireBase64Js(), A = requireBase64Url();
  function u(le) {
    return (le / 8 | 0) + (le % 8 === 0 ? 0 : 1);
  }
  const p = {
    ES256: u(256),
    ES384: u(384),
    ES512: u(521)
  };
  function t(le) {
    const ge = p[le];
    if (ge)
      return ge;
    throw new Error(`Unknown algorithm "${le}"`);
  }
  const l = 128, m = 0, b = 32, k = 16, C = 2, B = k | b | m << 6, Q = C | m << 6;
  function P(le) {
    if (le instanceof Uint8Array)
      return le;
    if (typeof le == "string")
      return (0, s.toByteArray)((0, A.pad)(le));
    throw new TypeError("ECDSA signature must be a Base64 string or a Uint8Array");
  }
  function x(le, ge) {
    const pe = P(le), Ie = t(ge), be = Ie + 1, Pe = pe.length;
    let Te = 0;
    if (pe[Te++] !== B)
      throw new Error('Could not find expected "seq"');
    let Qe = pe[Te++];
    if (Qe === (l | 1) && (Qe = pe[Te++]), Pe - Te < Qe)
      throw new Error(`"seq" specified length of "${Qe}", only "${Pe - Te}" remaining`);
    if (pe[Te++] !== Q)
      throw new Error('Could not find expected "int" for "r"');
    const xe = pe[Te++];
    if (Pe - Te - 2 < xe)
      throw new Error(`"r" specified length of "${xe}", only "${Pe - Te - 2}" available`);
    if (be < xe)
      throw new Error(`"r" specified length of "${xe}", max of "${be}" is acceptable`);
    const Ee = Te;
    if (Te += xe, pe[Te++] !== Q)
      throw new Error('Could not find expected "int" for "s"');
    const He = pe[Te++];
    if (Pe - Te !== He)
      throw new Error(`"s" specified length of "${He}", expected "${Pe - Te}"`);
    if (be < He)
      throw new Error(`"s" specified length of "${He}", max of "${be}" is acceptable`);
    const ve = Te;
    if (Te += He, Te !== Pe)
      throw new Error(`Expected to consume entire array, but "${Pe - Te}" bytes remain`);
    const we = Ie - xe, Ce = Ie - He, Se = new Uint8Array(we + xe + Ce + He);
    for (Te = 0; Te < we; ++Te)
      Se[Te] = 0;
    Se.set(pe.subarray(Ee + Math.max(-we, 0), Ee + xe), Te), Te = Ie;
    for (const Ne = Te; Te < Ne + Ce; ++Te)
      Se[Te] = 0;
    return Se.set(pe.subarray(ve + Math.max(-Ce, 0), ve + He), Te), (0, A.escape)((0, s.fromByteArray)(Se));
  }
  ecdsaSigFormatter.derToJose = x;
  function M(le, ge, pe) {
    let Ie = 0;
    for (; ge + Ie < pe && le[ge + Ie] === 0; )
      ++Ie;
    return le[ge + Ie] >= l && --Ie, Ie;
  }
  function F(le, ge) {
    le = P(le);
    const pe = t(ge), Ie = le.length;
    if (Ie !== pe * 2)
      throw new TypeError(`"${ge}" signatures must be "${pe * 2}" bytes, saw "${Ie}"`);
    const be = M(le, 0, pe), Pe = M(le, pe, le.length), Te = pe - be, Qe = pe - Pe, xe = 2 + Te + 1 + 1 + Qe, Ee = xe < l, He = new Uint8Array((Ee ? 2 : 3) + xe);
    let ve = 0;
    return He[ve++] = B, Ee ? He[ve++] = xe : (He[ve++] = l | 1, He[ve++] = xe & 255), He[ve++] = Q, He[ve++] = Te, be < 0 ? (He[ve++] = 0, He.set(le.subarray(0, pe), ve), ve += pe) : (He.set(le.subarray(be, pe), ve), ve += pe - be), He[ve++] = Q, He[ve++] = Qe, Pe < 0 ? (He[ve++] = 0, He.set(le.subarray(pe), ve)) : He.set(le.subarray(pe + Pe), ve), He;
  }
  return ecdsaSigFormatter.joseToDer = F, ecdsaSigFormatter;
}
var errors = {}, hasRequiredErrors;
function requireErrors() {
  if (hasRequiredErrors) return errors;
  hasRequiredErrors = 1, Object.defineProperty(errors, "__esModule", { value: !0 }), errors.InvalidTokenError = errors.MissingParametersError = void 0;
  class s extends Error {
    constructor(p) {
      super(), this.name = "MissingParametersError", this.message = p || "";
    }
  }
  errors.MissingParametersError = s;
  class A extends Error {
    constructor(p) {
      super(), this.name = "InvalidTokenError", this.message = p || "";
    }
  }
  return errors.InvalidTokenError = A, errors;
}
var hasRequiredSecp256k1$1;
function requireSecp256k1$1() {
  if (hasRequiredSecp256k1$1) return secp256k1$2;
  hasRequiredSecp256k1$1 = 1, Object.defineProperty(secp256k1$2, "__esModule", { value: !0 }), secp256k1$2.SECP256K1Client = void 0;
  const s = /* @__PURE__ */ requireHmac$3(), A = /* @__PURE__ */ requireSha256$4(), u = requireLib$4(), p = requireEcdsaSigFormatter(), t = requireErrors(), l = /* @__PURE__ */ requireUtils$j();
  u.utils.hmacSha256Sync = (b, ...k) => {
    const C = s.hmac.create(A.sha256, b);
    return k.forEach((B) => C.update(B)), C.digest();
  };
  class m {
    static derivePublicKey(k, C = !0) {
      return k.length === 66 && (k = k.slice(0, 64)), k.length < 64 && (k = k.padStart(64, "0")), (0, l.bytesToHex)(u.getPublicKey(k, C));
    }
    static signHash(k, C, B = "jose") {
      if (!k || !C)
        throw new t.MissingParametersError("a signing input hash and private key are all required");
      const Q = u.signSync(k, C.slice(0, 64), {
        der: !0,
        canonical: !1
      });
      if (B === "der")
        return (0, l.bytesToHex)(Q);
      if (B === "jose")
        return (0, p.derToJose)(Q, "ES256");
      throw Error("Invalid signature format");
    }
    static loadSignature(k) {
      return (0, p.joseToDer)(k, "ES256");
    }
    static verifyHash(k, C, B) {
      if (!k || !C || !B)
        throw new t.MissingParametersError("a signing input hash, der signature, and public key are all required");
      return u.verify(C, k, B, { strict: !1 });
    }
  }
  return secp256k1$2.SECP256K1Client = m, m.algorithmName = "ES256K", secp256k1$2;
}
var hasRequiredCryptoClients;
function requireCryptoClients() {
  return hasRequiredCryptoClients || (hasRequiredCryptoClients = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.cryptoClients = s.SECP256K1Client = void 0;
    const A = requireSecp256k1$1();
    Object.defineProperty(s, "SECP256K1Client", { enumerable: !0, get: function() {
      return A.SECP256K1Client;
    } });
    const u = {
      ES256K: A.SECP256K1Client
    };
    s.cryptoClients = u;
  }(cryptoClients)), cryptoClients;
}
var sha256$4 = {}, hasRequiredSha256;
function requireSha256() {
  if (hasRequiredSha256) return sha256$4;
  hasRequiredSha256 = 1;
  var s = sha256$4 && sha256$4.__awaiter || function(t, l, m, b) {
    function k(C) {
      return C instanceof m ? C : new m(function(B) {
        B(C);
      });
    }
    return new (m || (m = Promise))(function(C, B) {
      function Q(M) {
        try {
          x(b.next(M));
        } catch (F) {
          B(F);
        }
      }
      function P(M) {
        try {
          x(b.throw(M));
        } catch (F) {
          B(F);
        }
      }
      function x(M) {
        M.done ? C(M.value) : k(M.value).then(Q, P);
      }
      x((b = b.apply(t, l || [])).next());
    });
  };
  Object.defineProperty(sha256$4, "__esModule", { value: !0 }), sha256$4.hashSha256Async = sha256$4.hashSha256 = void 0;
  const A = /* @__PURE__ */ requireSha256$4();
  function u(t) {
    return (0, A.sha256)(t);
  }
  sha256$4.hashSha256 = u;
  function p(t) {
    return s(this, void 0, void 0, function* () {
      try {
        if (typeof crypto < "u" && typeof crypto.subtle < "u") {
          const m = typeof t == "string" ? new TextEncoder().encode(t) : t, b = yield crypto.subtle.digest("SHA-256", m);
          return new Uint8Array(b);
        } else {
          const m = requireCryptoBrowserify();
          if (!m.createHash)
            throw new Error("`crypto` module does not contain `createHash`");
          return Promise.resolve(m.createHash("sha256").update(t).digest());
        }
      } catch (l) {
        return console.log(l), console.log('Crypto lib not found. Neither the global `crypto.subtle` Web Crypto API, nor the or the Node.js `require("crypto").createHash` module is available. Falling back to JS implementation.'), Promise.resolve(u(t));
      }
    });
  }
  return sha256$4.hashSha256Async = p, sha256$4;
}
var hasRequiredSigner;
function requireSigner() {
  if (hasRequiredSigner) return signer;
  hasRequiredSigner = 1;
  var s = signer && signer.__awaiter || function(k, C, B, Q) {
    function P(x) {
      return x instanceof B ? x : new B(function(M) {
        M(x);
      });
    }
    return new (B || (B = Promise))(function(x, M) {
      function F(pe) {
        try {
          ge(Q.next(pe));
        } catch (Ie) {
          M(Ie);
        }
      }
      function le(pe) {
        try {
          ge(Q.throw(pe));
        } catch (Ie) {
          M(Ie);
        }
      }
      function ge(pe) {
        pe.done ? x(pe.value) : P(pe.value).then(F, le);
      }
      ge((Q = Q.apply(k, C || [])).next());
    });
  };
  Object.defineProperty(signer, "__esModule", { value: !0 }), signer.TokenSigner = signer.createUnsecuredToken = void 0;
  const A = requireBase64Url(), u = requireCryptoClients(), p = requireErrors(), t = requireSha256();
  function l(k, C) {
    const B = [], Q = A.encode(JSON.stringify(C));
    B.push(Q);
    const P = A.encode(JSON.stringify(k));
    return B.push(P), B.join(".");
  }
  function m(k) {
    return l(k, { typ: "JWT", alg: "none" }) + ".";
  }
  signer.createUnsecuredToken = m;
  class b {
    constructor(C, B) {
      if (!(C && B))
        throw new p.MissingParametersError("a signing algorithm and private key are required");
      if (typeof C != "string")
        throw new Error("signing algorithm parameter must be a string");
      if (C = C.toUpperCase(), !u.cryptoClients.hasOwnProperty(C))
        throw new Error("invalid signing algorithm");
      this.tokenType = "JWT", this.cryptoClient = u.cryptoClients[C], this.rawPrivateKey = B;
    }
    header(C = {}) {
      const B = { typ: this.tokenType, alg: this.cryptoClient.algorithmName };
      return Object.assign({}, B, C);
    }
    sign(C, B = !1, Q = {}) {
      const P = this.header(Q), x = l(C, P), M = (0, t.hashSha256)(x);
      return this.createWithSignedHash(C, B, P, x, M);
    }
    signAsync(C, B = !1, Q = {}) {
      return s(this, void 0, void 0, function* () {
        const P = this.header(Q), x = l(C, P), M = yield (0, t.hashSha256Async)(x);
        return this.createWithSignedHash(C, B, P, x, M);
      });
    }
    createWithSignedHash(C, B, Q, P, x) {
      const M = this.cryptoClient.signHash(x, this.rawPrivateKey);
      return B ? {
        header: [A.encode(JSON.stringify(Q))],
        payload: JSON.stringify(C),
        signature: [M]
      } : [P, M].join(".");
    }
  }
  return signer.TokenSigner = b, signer;
}
var verifier = {}, hasRequiredVerifier;
function requireVerifier() {
  if (hasRequiredVerifier) return verifier;
  hasRequiredVerifier = 1, Object.defineProperty(verifier, "__esModule", { value: !0 }), verifier.TokenVerifier = void 0;
  const s = requireBase64Url(), A = requireCryptoClients(), u = requireErrors(), p = requireSha256();
  class t {
    constructor(m, b) {
      if (!(m && b))
        throw new u.MissingParametersError("a signing algorithm and public key are required");
      if (typeof m != "string")
        throw "signing algorithm parameter must be a string";
      if (m = m.toUpperCase(), !A.cryptoClients.hasOwnProperty(m))
        throw "invalid signing algorithm";
      this.tokenType = "JWT", this.cryptoClient = A.cryptoClients[m], this.rawPublicKey = b;
    }
    verify(m) {
      return typeof m == "string" ? this.verifyCompact(m, !1) : typeof m == "object" ? this.verifyExpanded(m, !1) : !1;
    }
    verifyAsync(m) {
      return typeof m == "string" ? this.verifyCompact(m, !0) : typeof m == "object" ? this.verifyExpanded(m, !0) : Promise.resolve(!1);
    }
    verifyCompact(m, b) {
      const k = m.split("."), C = k[0] + "." + k[1], B = (Q) => {
        const P = this.cryptoClient.loadSignature(k[2]);
        return this.cryptoClient.verifyHash(Q, P, this.rawPublicKey);
      };
      if (b)
        return (0, p.hashSha256Async)(C).then((Q) => B(Q));
      {
        const Q = (0, p.hashSha256)(C);
        return B(Q);
      }
    }
    verifyExpanded(m, b) {
      const k = [m.header.join("."), s.encode(m.payload)].join(".");
      let C = !0;
      const B = (Q) => (m.signature.map((P) => {
        const x = this.cryptoClient.loadSignature(P);
        this.cryptoClient.verifyHash(Q, x, this.rawPublicKey) || (C = !1);
      }), C);
      if (b)
        return (0, p.hashSha256Async)(k).then((Q) => B(Q));
      {
        const Q = (0, p.hashSha256)(k);
        return B(Q);
      }
    }
  }
  return verifier.TokenVerifier = t, verifier;
}
var decode = {}, hasRequiredDecode;
function requireDecode() {
  if (hasRequiredDecode) return decode;
  hasRequiredDecode = 1, Object.defineProperty(decode, "__esModule", { value: !0 }), decode.decodeToken = void 0;
  const s = requireBase64Url();
  function A(u) {
    if (typeof u == "string") {
      const p = u.split("."), t = JSON.parse(s.decode(p[0])), l = JSON.parse(s.decode(p[1])), m = p[2];
      return {
        header: t,
        payload: l,
        signature: m
      };
    } else if (typeof u == "object") {
      if (typeof u.payload != "string")
        throw new Error("Expected token payload to be a base64 or json string");
      let p = u.payload;
      u.payload[0] !== "{" && (p = s.decode(p));
      const t = [];
      return u.header.map((l) => {
        const m = JSON.parse(s.decode(l));
        t.push(m);
      }), {
        header: t,
        payload: JSON.parse(p),
        signature: u.signature
      };
    }
  }
  return decode.decodeToken = A, decode;
}
var hasRequiredLib$3;
function requireLib$3() {
  return hasRequiredLib$3 || (hasRequiredLib$3 = 1, function(s) {
    var A = lib$4 && lib$4.__createBinding || (Object.create ? function(p, t, l, m) {
      m === void 0 && (m = l);
      var b = Object.getOwnPropertyDescriptor(t, l);
      (!b || ("get" in b ? !t.__esModule : b.writable || b.configurable)) && (b = { enumerable: !0, get: function() {
        return t[l];
      } }), Object.defineProperty(p, m, b);
    } : function(p, t, l, m) {
      m === void 0 && (m = l), p[m] = t[l];
    }), u = lib$4 && lib$4.__exportStar || function(p, t) {
      for (var l in p) l !== "default" && !Object.prototype.hasOwnProperty.call(t, l) && A(t, p, l);
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), u(requireSigner(), s), u(requireVerifier(), s), u(requireDecode(), s), u(requireErrors(), s), u(requireCryptoClients(), s);
  }(lib$4)), lib$4;
}
var libExports = requireLib$3(), build$4 = {}, bip39 = {}, build$3 = {}, ascii$1 = {}, hasRequiredAscii$1;
function requireAscii$1() {
  if (hasRequiredAscii$1) return ascii$1;
  hasRequiredAscii$1 = 1, Object.defineProperty(ascii$1, "__esModule", { value: !0 }), ascii$1.toAscii = s, ascii$1.fromAscii = A;
  function s(u) {
    const p = (t) => t.split("").map((l) => {
      const m = l.charCodeAt(0);
      if (m < 32 || m > 126)
        throw new Error(`Cannot encode character that is out of printable ASCII range: ${m}`);
      return m;
    });
    return Uint8Array.from(p(u));
  }
  function A(u) {
    return ((t) => t.map((l) => {
      if (l < 32 || l > 126)
        throw new Error(`Cannot decode character that is out of printable ASCII range: ${l}`);
      return String.fromCharCode(l);
    }))(Array.from(u)).join("");
  }
  return ascii$1;
}
var base64$2 = {}, hasRequiredBase64$2;
function requireBase64$2() {
  if (hasRequiredBase64$2) return base64$2;
  hasRequiredBase64$2 = 1;
  var s = base64$2 && base64$2.__createBinding || (Object.create ? function(m, b, k, C) {
    C === void 0 && (C = k);
    var B = Object.getOwnPropertyDescriptor(b, k);
    (!B || ("get" in B ? !b.__esModule : B.writable || B.configurable)) && (B = { enumerable: !0, get: function() {
      return b[k];
    } }), Object.defineProperty(m, C, B);
  } : function(m, b, k, C) {
    C === void 0 && (C = k), m[C] = b[k];
  }), A = base64$2 && base64$2.__setModuleDefault || (Object.create ? function(m, b) {
    Object.defineProperty(m, "default", { enumerable: !0, value: b });
  } : function(m, b) {
    m.default = b;
  }), u = base64$2 && base64$2.__importStar || /* @__PURE__ */ function() {
    var m = function(b) {
      return m = Object.getOwnPropertyNames || function(k) {
        var C = [];
        for (var B in k) Object.prototype.hasOwnProperty.call(k, B) && (C[C.length] = B);
        return C;
      }, m(b);
    };
    return function(b) {
      if (b && b.__esModule) return b;
      var k = {};
      if (b != null) for (var C = m(b), B = 0; B < C.length; B++) C[B] !== "default" && s(k, b, C[B]);
      return A(k, b), k;
    };
  }();
  Object.defineProperty(base64$2, "__esModule", { value: !0 }), base64$2.toBase64 = t, base64$2.fromBase64 = l;
  const p = u(requireBase64Js());
  function t(m) {
    return p.fromByteArray(m);
  }
  function l(m) {
    if (!m.match(/^[a-zA-Z0-9+/]*={0,2}$/))
      throw new Error("Invalid base64 string format");
    return p.toByteArray(m);
  }
  return base64$2;
}
var bech32$3 = {}, bech32$2, hasRequiredBech32$2;
function requireBech32$2() {
  if (hasRequiredBech32$2) return bech32$2;
  hasRequiredBech32$2 = 1;
  for (var s = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", A = {}, u = 0; u < s.length; u++) {
    var p = s.charAt(u);
    if (A[p] !== void 0) throw new TypeError(p + " is ambiguous");
    A[p] = u;
  }
  function t(F) {
    var le = F >> 25;
    return (F & 33554431) << 5 ^ -(le >> 0 & 1) & 996825010 ^ -(le >> 1 & 1) & 642813549 ^ -(le >> 2 & 1) & 513874426 ^ -(le >> 3 & 1) & 1027748829 ^ -(le >> 4 & 1) & 705979059;
  }
  function l(F) {
    for (var le = 1, ge = 0; ge < F.length; ++ge) {
      var pe = F.charCodeAt(ge);
      if (pe < 33 || pe > 126) return "Invalid prefix (" + F + ")";
      le = t(le) ^ pe >> 5;
    }
    for (le = t(le), ge = 0; ge < F.length; ++ge) {
      var Ie = F.charCodeAt(ge);
      le = t(le) ^ Ie & 31;
    }
    return le;
  }
  function m(F, le, ge) {
    if (ge = ge || 90, F.length + 7 + le.length > ge) throw new TypeError("Exceeds length limit");
    F = F.toLowerCase();
    var pe = l(F);
    if (typeof pe == "string") throw new Error(pe);
    for (var Ie = F + "1", be = 0; be < le.length; ++be) {
      var Pe = le[be];
      if (Pe >> 5 !== 0) throw new Error("Non 5-bit word");
      pe = t(pe) ^ Pe, Ie += s.charAt(Pe);
    }
    for (be = 0; be < 6; ++be)
      pe = t(pe);
    for (pe ^= 1, be = 0; be < 6; ++be) {
      var Te = pe >> (5 - be) * 5 & 31;
      Ie += s.charAt(Te);
    }
    return Ie;
  }
  function b(F, le) {
    if (le = le || 90, F.length < 8) return F + " too short";
    if (F.length > le) return "Exceeds length limit";
    var ge = F.toLowerCase(), pe = F.toUpperCase();
    if (F !== ge && F !== pe) return "Mixed-case string " + F;
    F = ge;
    var Ie = F.lastIndexOf("1");
    if (Ie === -1) return "No separator character for " + F;
    if (Ie === 0) return "Missing prefix for " + F;
    var be = F.slice(0, Ie), Pe = F.slice(Ie + 1);
    if (Pe.length < 6) return "Data too short";
    var Te = l(be);
    if (typeof Te == "string") return Te;
    for (var Qe = [], xe = 0; xe < Pe.length; ++xe) {
      var Ee = Pe.charAt(xe), He = A[Ee];
      if (He === void 0) return "Unknown character " + Ee;
      Te = t(Te) ^ He, !(xe + 6 >= Pe.length) && Qe.push(He);
    }
    return Te !== 1 ? "Invalid checksum for " + F : { prefix: be, words: Qe };
  }
  function k() {
    var F = b.apply(null, arguments);
    if (typeof F == "object") return F;
  }
  function C(F) {
    var le = b.apply(null, arguments);
    if (typeof le == "object") return le;
    throw new Error(le);
  }
  function B(F, le, ge, pe) {
    for (var Ie = 0, be = 0, Pe = (1 << ge) - 1, Te = [], Qe = 0; Qe < F.length; ++Qe)
      for (Ie = Ie << le | F[Qe], be += le; be >= ge; )
        be -= ge, Te.push(Ie >> be & Pe);
    if (pe)
      be > 0 && Te.push(Ie << ge - be & Pe);
    else {
      if (be >= le) return "Excess padding";
      if (Ie << ge - be & Pe) return "Non-zero padding";
    }
    return Te;
  }
  function Q(F) {
    var le = B(F, 8, 5, !0);
    if (Array.isArray(le)) return le;
  }
  function P(F) {
    var le = B(F, 8, 5, !0);
    if (Array.isArray(le)) return le;
    throw new Error(le);
  }
  function x(F) {
    var le = B(F, 5, 8, !1);
    if (Array.isArray(le)) return le;
  }
  function M(F) {
    var le = B(F, 5, 8, !1);
    if (Array.isArray(le)) return le;
    throw new Error(le);
  }
  return bech32$2 = {
    decodeUnsafe: k,
    decode: C,
    encode: m,
    toWordsUnsafe: Q,
    toWords: P,
    fromWordsUnsafe: x,
    fromWords: M
  }, bech32$2;
}
var hasRequiredBech32$1;
function requireBech32$1() {
  if (hasRequiredBech32$1) return bech32$3;
  hasRequiredBech32$1 = 1;
  var s = bech32$3 && bech32$3.__createBinding || (Object.create ? function(b, k, C, B) {
    B === void 0 && (B = C);
    var Q = Object.getOwnPropertyDescriptor(k, C);
    (!Q || ("get" in Q ? !k.__esModule : Q.writable || Q.configurable)) && (Q = { enumerable: !0, get: function() {
      return k[C];
    } }), Object.defineProperty(b, B, Q);
  } : function(b, k, C, B) {
    B === void 0 && (B = C), b[B] = k[C];
  }), A = bech32$3 && bech32$3.__setModuleDefault || (Object.create ? function(b, k) {
    Object.defineProperty(b, "default", { enumerable: !0, value: k });
  } : function(b, k) {
    b.default = k;
  }), u = bech32$3 && bech32$3.__importStar || /* @__PURE__ */ function() {
    var b = function(k) {
      return b = Object.getOwnPropertyNames || function(C) {
        var B = [];
        for (var Q in C) Object.prototype.hasOwnProperty.call(C, Q) && (B[B.length] = Q);
        return B;
      }, b(k);
    };
    return function(k) {
      if (k && k.__esModule) return k;
      var C = {};
      if (k != null) for (var B = b(k), Q = 0; Q < B.length; Q++) B[Q] !== "default" && s(C, k, B[Q]);
      return A(C, k), C;
    };
  }();
  Object.defineProperty(bech32$3, "__esModule", { value: !0 }), bech32$3.toBech32 = t, bech32$3.fromBech32 = l, bech32$3.normalizeBech32 = m;
  const p = u(requireBech32$2());
  function t(b, k, C) {
    return p.encode(b, p.toWords(k), C);
  }
  function l(b, k = 1 / 0) {
    const C = p.decode(b, k);
    return {
      prefix: C.prefix,
      data: new Uint8Array(p.fromWords(C.words))
    };
  }
  function m(b) {
    const { prefix: k, data: C } = l(b);
    return t(k, C);
  }
  return bech32$3;
}
var hex$2 = {}, hasRequiredHex$1;
function requireHex$1() {
  if (hasRequiredHex$1) return hex$2;
  hasRequiredHex$1 = 1, Object.defineProperty(hex$2, "__esModule", { value: !0 }), hex$2.toHex = s, hex$2.fromHex = A;
  function s(u) {
    let p = "";
    for (const t of u)
      p += ("0" + t.toString(16)).slice(-2);
    return p;
  }
  function A(u) {
    if (u.length % 2 !== 0)
      throw new Error("hex string length must be a multiple of 2");
    const p = new Uint8Array(u.length / 2);
    for (let t = 0; t < p.length; t++) {
      const l = 2 * t, m = u.slice(l, l + 2);
      if (!m.match(/[0-9a-f]{2}/i))
        throw new Error("hex string contains invalid characters");
      p[t] = parseInt(m, 16);
    }
    return p;
  }
  return hex$2;
}
var rfc3339$1 = {}, hasRequiredRfc3339$1;
function requireRfc3339$1() {
  if (hasRequiredRfc3339$1) return rfc3339$1;
  hasRequiredRfc3339$1 = 1, Object.defineProperty(rfc3339$1, "__esModule", { value: !0 }), rfc3339$1.fromRfc3339 = u, rfc3339$1.toRfc3339 = p;
  const s = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
  function A(t, l = 2) {
    return t.toString().padStart(l, "0");
  }
  function u(t) {
    const l = s.exec(t);
    if (!l)
      throw new Error("Date string is not in RFC3339 format");
    const m = +l[1], b = +l[2], k = +l[3], C = +l[4], B = +l[5], Q = +l[6], P = l[7] ? Math.floor(+l[7] * 1e3) : 0;
    let x, M, F;
    l[8] === "Z" ? (x = 1, M = 0, F = 0) : (x = l[8].substring(0, 1) === "-" ? -1 : 1, M = +l[8].substring(1, 3), F = +l[8].substring(4, 6));
    const le = x * (M * 60 + F) * 60, ge = /* @__PURE__ */ new Date();
    return ge.setUTCFullYear(m, b - 1, k), ge.setUTCHours(C, B, Q, P), new Date(ge.getTime() - le * 1e3);
  }
  function p(t) {
    const l = t.getUTCFullYear(), m = A(t.getUTCMonth() + 1), b = A(t.getUTCDate()), k = A(t.getUTCHours()), C = A(t.getUTCMinutes()), B = A(t.getUTCSeconds()), Q = A(t.getUTCMilliseconds(), 3);
    return `${l}-${m}-${b}T${k}:${C}:${B}.${Q}Z`;
  }
  return rfc3339$1;
}
var utf8$3 = {}, hasRequiredUtf8$2;
function requireUtf8$2() {
  if (hasRequiredUtf8$2) return utf8$3;
  hasRequiredUtf8$2 = 1, Object.defineProperty(utf8$3, "__esModule", { value: !0 }), utf8$3.toUtf8 = s, utf8$3.fromUtf8 = A;
  function s(u) {
    return new TextEncoder().encode(u);
  }
  function A(u, p = !1) {
    const t = !p;
    return new TextDecoder("utf-8", { fatal: t }).decode(u);
  }
  return utf8$3;
}
var hasRequiredBuild$4;
function requireBuild$4() {
  return hasRequiredBuild$4 || (hasRequiredBuild$4 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.toUtf8 = s.fromUtf8 = s.toRfc3339 = s.fromRfc3339 = s.toHex = s.fromHex = s.toBech32 = s.normalizeBech32 = s.fromBech32 = s.toBase64 = s.fromBase64 = s.toAscii = s.fromAscii = void 0;
    var A = requireAscii$1();
    Object.defineProperty(s, "fromAscii", { enumerable: !0, get: function() {
      return A.fromAscii;
    } }), Object.defineProperty(s, "toAscii", { enumerable: !0, get: function() {
      return A.toAscii;
    } });
    var u = requireBase64$2();
    Object.defineProperty(s, "fromBase64", { enumerable: !0, get: function() {
      return u.fromBase64;
    } }), Object.defineProperty(s, "toBase64", { enumerable: !0, get: function() {
      return u.toBase64;
    } });
    var p = requireBech32$1();
    Object.defineProperty(s, "fromBech32", { enumerable: !0, get: function() {
      return p.fromBech32;
    } }), Object.defineProperty(s, "normalizeBech32", { enumerable: !0, get: function() {
      return p.normalizeBech32;
    } }), Object.defineProperty(s, "toBech32", { enumerable: !0, get: function() {
      return p.toBech32;
    } });
    var t = requireHex$1();
    Object.defineProperty(s, "fromHex", { enumerable: !0, get: function() {
      return t.fromHex;
    } }), Object.defineProperty(s, "toHex", { enumerable: !0, get: function() {
      return t.toHex;
    } });
    var l = requireRfc3339$1();
    Object.defineProperty(s, "fromRfc3339", { enumerable: !0, get: function() {
      return l.fromRfc3339;
    } }), Object.defineProperty(s, "toRfc3339", { enumerable: !0, get: function() {
      return l.toRfc3339;
    } });
    var m = requireUtf8$2();
    Object.defineProperty(s, "fromUtf8", { enumerable: !0, get: function() {
      return m.fromUtf8;
    } }), Object.defineProperty(s, "toUtf8", { enumerable: !0, get: function() {
      return m.toUtf8;
    } });
  }(build$3)), build$3;
}
var pbkdf2$2 = {}, build$2 = {}, arrays = {}, hasRequiredArrays;
function requireArrays() {
  if (hasRequiredArrays) return arrays;
  hasRequiredArrays = 1, Object.defineProperty(arrays, "__esModule", { value: !0 }), arrays.arrayContentEquals = s, arrays.arrayContentStartsWith = A;
  function s(u, p) {
    if (u.length !== p.length)
      return !1;
    for (let t = 0; t < u.length; ++t)
      if (u[t] !== p[t])
        return !1;
    return !0;
  }
  function A(u, p) {
    if (u.length < p.length)
      return !1;
    for (let t = 0; t < p.length; ++t)
      if (u[t] !== p[t])
        return !1;
    return !0;
  }
  return arrays;
}
var assert = {}, hasRequiredAssert;
function requireAssert() {
  if (hasRequiredAssert) return assert;
  hasRequiredAssert = 1, Object.defineProperty(assert, "__esModule", { value: !0 }), assert.assert = s, assert.assertDefined = A, assert.assertDefinedAndNotNull = u;
  function s(p, t) {
    if (!p)
      throw new Error(t || "condition is not truthy");
  }
  function A(p, t) {
    if (p === void 0)
      throw new Error(t ?? "value is undefined");
  }
  function u(p, t) {
    if (p == null)
      throw new Error(t ?? "value is undefined or null");
  }
  return assert;
}
var sleep = {}, hasRequiredSleep;
function requireSleep() {
  if (hasRequiredSleep) return sleep;
  hasRequiredSleep = 1, Object.defineProperty(sleep, "__esModule", { value: !0 }), sleep.sleep = s;
  async function s(A) {
    return new Promise((u) => setTimeout(u, A));
  }
  return sleep;
}
var typechecks = {}, hasRequiredTypechecks;
function requireTypechecks() {
  if (hasRequiredTypechecks) return typechecks;
  hasRequiredTypechecks = 1, Object.defineProperty(typechecks, "__esModule", { value: !0 }), typechecks.isNonNullObject = s, typechecks.isUint8Array = A, typechecks.isDefined = u;
  function s(p) {
    return typeof p == "object" && p !== null;
  }
  function A(p) {
    return !(!s(p) || Object.prototype.toString.call(p) !== "[object Uint8Array]" || typeof Buffer < "u" && typeof Buffer.isBuffer < "u" && Buffer.isBuffer(p));
  }
  function u(p) {
    return p !== void 0;
  }
  return typechecks;
}
var hasRequiredBuild$3;
function requireBuild$3() {
  return hasRequiredBuild$3 || (hasRequiredBuild$3 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.isUint8Array = s.isNonNullObject = s.isDefined = s.sleep = s.assertDefinedAndNotNull = s.assertDefined = s.assert = s.arrayContentStartsWith = s.arrayContentEquals = void 0;
    var A = requireArrays();
    Object.defineProperty(s, "arrayContentEquals", { enumerable: !0, get: function() {
      return A.arrayContentEquals;
    } }), Object.defineProperty(s, "arrayContentStartsWith", { enumerable: !0, get: function() {
      return A.arrayContentStartsWith;
    } });
    var u = requireAssert();
    Object.defineProperty(s, "assert", { enumerable: !0, get: function() {
      return u.assert;
    } }), Object.defineProperty(s, "assertDefined", { enumerable: !0, get: function() {
      return u.assertDefined;
    } }), Object.defineProperty(s, "assertDefinedAndNotNull", { enumerable: !0, get: function() {
      return u.assertDefinedAndNotNull;
    } });
    var p = requireSleep();
    Object.defineProperty(s, "sleep", { enumerable: !0, get: function() {
      return p.sleep;
    } });
    var t = requireTypechecks();
    Object.defineProperty(s, "isDefined", { enumerable: !0, get: function() {
      return t.isDefined;
    } }), Object.defineProperty(s, "isNonNullObject", { enumerable: !0, get: function() {
      return t.isNonNullObject;
    } }), Object.defineProperty(s, "isUint8Array", { enumerable: !0, get: function() {
      return t.isUint8Array;
    } });
  }(build$2)), build$2;
}
var pbkdf2$1 = {}, hasRequiredPbkdf2$1;
function requirePbkdf2$1() {
  if (hasRequiredPbkdf2$1) return pbkdf2$1;
  hasRequiredPbkdf2$1 = 1, Object.defineProperty(pbkdf2$1, "__esModule", { value: !0 }), pbkdf2$1.pbkdf2 = t, pbkdf2$1.pbkdf2Async = l;
  const s = /* @__PURE__ */ requireHmac$3(), A = /* @__PURE__ */ requireUtils$j();
  function u(m, b, k, C) {
    (0, A.ahash)(m);
    const B = (0, A.checkOpts)({ dkLen: 32, asyncTick: 10 }, C), { c: Q, dkLen: P, asyncTick: x } = B;
    if ((0, A.anumber)(Q), (0, A.anumber)(P), (0, A.anumber)(x), Q < 1)
      throw new Error("iterations (c) should be >= 1");
    const M = (0, A.kdfInputToBytes)(b), F = (0, A.kdfInputToBytes)(k), le = new Uint8Array(P), ge = s.hmac.create(m, M), pe = ge._cloneInto().update(F);
    return { c: Q, dkLen: P, asyncTick: x, DK: le, PRF: ge, PRFSalt: pe };
  }
  function p(m, b, k, C, B) {
    return m.destroy(), b.destroy(), C && C.destroy(), (0, A.clean)(B), k;
  }
  function t(m, b, k, C) {
    const { c: B, dkLen: Q, DK: P, PRF: x, PRFSalt: M } = u(m, b, k, C);
    let F;
    const le = new Uint8Array(4), ge = (0, A.createView)(le), pe = new Uint8Array(x.outputLen);
    for (let Ie = 1, be = 0; be < Q; Ie++, be += x.outputLen) {
      const Pe = P.subarray(be, be + x.outputLen);
      ge.setInt32(0, Ie, !1), (F = M._cloneInto(F)).update(le).digestInto(pe), Pe.set(pe.subarray(0, Pe.length));
      for (let Te = 1; Te < B; Te++) {
        x._cloneInto(F).update(pe).digestInto(pe);
        for (let Qe = 0; Qe < Pe.length; Qe++)
          Pe[Qe] ^= pe[Qe];
      }
    }
    return p(x, M, P, F, pe);
  }
  async function l(m, b, k, C) {
    const { c: B, dkLen: Q, asyncTick: P, DK: x, PRF: M, PRFSalt: F } = u(m, b, k, C);
    let le;
    const ge = new Uint8Array(4), pe = (0, A.createView)(ge), Ie = new Uint8Array(M.outputLen);
    for (let be = 1, Pe = 0; Pe < Q; be++, Pe += M.outputLen) {
      const Te = x.subarray(Pe, Pe + M.outputLen);
      pe.setInt32(0, be, !1), (le = F._cloneInto(le)).update(ge).digestInto(Ie), Te.set(Ie.subarray(0, Te.length)), await (0, A.asyncLoop)(B - 1, P, () => {
        M._cloneInto(le).update(Ie).digestInto(Ie);
        for (let Qe = 0; Qe < Te.length; Qe++)
          Te[Qe] ^= Ie[Qe];
      });
    }
    return p(M, F, x, le, Ie);
  }
  return pbkdf2$1;
}
var hasRequiredPbkdf2;
function requirePbkdf2() {
  if (hasRequiredPbkdf2) return pbkdf2$2;
  hasRequiredPbkdf2 = 1, Object.defineProperty(pbkdf2$2, "__esModule", { value: !0 }), pbkdf2$2.getSubtle = p, pbkdf2$2.pbkdf2Sha512Subtle = t, pbkdf2$2.pbkdf2Sha512Noble = l, pbkdf2$2.pbkdf2Sha512 = m;
  const s = requireBuild$3(), A = /* @__PURE__ */ requirePbkdf2$1(), u = /* @__PURE__ */ requireSha2();
  async function p() {
    var b;
    return (b = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : b.subtle;
  }
  async function t(b, k, C, B, Q) {
    return (0, s.assert)(b, "Argument subtle is falsy"), (0, s.assert)(typeof b == "object", "Argument subtle is not of type object"), (0, s.assert)(typeof b.importKey == "function", "subtle.importKey is not a function"), (0, s.assert)(typeof b.deriveBits == "function", "subtle.deriveBits is not a function"), b.importKey("raw", k, { name: "PBKDF2" }, !1, ["deriveBits"]).then((P) => b.deriveBits({
      name: "PBKDF2",
      salt: C,
      iterations: B,
      hash: { name: "SHA-512" }
    }, P, Q * 8).then((x) => new Uint8Array(x)));
  }
  async function l(b, k, C, B) {
    return (0, A.pbkdf2Async)(u.sha512, b, k, { c: C, dkLen: B });
  }
  async function m(b, k, C, B) {
    const Q = await p();
    return Q ? t(Q, b, k, C, B) : l(b, k, C, B);
  }
  return pbkdf2$2;
}
var sha = {}, utils$4 = {}, hasRequiredUtils$3;
function requireUtils$3() {
  if (hasRequiredUtils$3) return utils$4;
  hasRequiredUtils$3 = 1, Object.defineProperty(utils$4, "__esModule", { value: !0 }), utils$4.toRealUint8Array = s;
  function s(A) {
    return A instanceof Uint8Array ? A : Uint8Array.from(A);
  }
  return utils$4;
}
var hasRequiredSha;
function requireSha() {
  if (hasRequiredSha) return sha;
  hasRequiredSha = 1, Object.defineProperty(sha, "__esModule", { value: !0 }), sha.Sha512 = sha.Sha256 = void 0, sha.sha256 = p, sha.sha512 = l;
  const s = /* @__PURE__ */ requireSha2(), A = requireUtils$3();
  class u {
    constructor(b) {
      Ci(this, "blockSize", 512 / 8);
      Ci(this, "impl", s.sha256.create());
      b && this.update(b);
    }
    update(b) {
      return this.impl.update((0, A.toRealUint8Array)(b)), this;
    }
    digest() {
      return this.impl.digest();
    }
  }
  sha.Sha256 = u;
  function p(m) {
    return new u(m).digest();
  }
  class t {
    constructor(b) {
      Ci(this, "blockSize", 1024 / 8);
      Ci(this, "impl", s.sha512.create());
      b && this.update(b);
    }
    update(b) {
      return this.impl.update((0, A.toRealUint8Array)(b)), this;
    }
    digest() {
      return this.impl.digest();
    }
  }
  sha.Sha512 = t;
  function l(m) {
    return new t(m).digest();
  }
  return sha;
}
var hasRequiredBip39;
function requireBip39() {
  if (hasRequiredBip39) return bip39;
  hasRequiredBip39 = 1, Object.defineProperty(bip39, "__esModule", { value: !0 }), bip39.Bip39 = bip39.EnglishMnemonic = void 0, bip39.entropyToMnemonic = C, bip39.mnemonicToEntropy = F;
  const s = requireBuild$4(), A = requirePbkdf2(), u = requireSha(), p = [
    "abandon",
    "ability",
    "able",
    "about",
    "above",
    "absent",
    "absorb",
    "abstract",
    "absurd",
    "abuse",
    "access",
    "accident",
    "account",
    "accuse",
    "achieve",
    "acid",
    "acoustic",
    "acquire",
    "across",
    "act",
    "action",
    "actor",
    "actress",
    "actual",
    "adapt",
    "add",
    "addict",
    "address",
    "adjust",
    "admit",
    "adult",
    "advance",
    "advice",
    "aerobic",
    "affair",
    "afford",
    "afraid",
    "again",
    "age",
    "agent",
    "agree",
    "ahead",
    "aim",
    "air",
    "airport",
    "aisle",
    "alarm",
    "album",
    "alcohol",
    "alert",
    "alien",
    "all",
    "alley",
    "allow",
    "almost",
    "alone",
    "alpha",
    "already",
    "also",
    "alter",
    "always",
    "amateur",
    "amazing",
    "among",
    "amount",
    "amused",
    "analyst",
    "anchor",
    "ancient",
    "anger",
    "angle",
    "angry",
    "animal",
    "ankle",
    "announce",
    "annual",
    "another",
    "answer",
    "antenna",
    "antique",
    "anxiety",
    "any",
    "apart",
    "apology",
    "appear",
    "apple",
    "approve",
    "april",
    "arch",
    "arctic",
    "area",
    "arena",
    "argue",
    "arm",
    "armed",
    "armor",
    "army",
    "around",
    "arrange",
    "arrest",
    "arrive",
    "arrow",
    "art",
    "artefact",
    "artist",
    "artwork",
    "ask",
    "aspect",
    "assault",
    "asset",
    "assist",
    "assume",
    "asthma",
    "athlete",
    "atom",
    "attack",
    "attend",
    "attitude",
    "attract",
    "auction",
    "audit",
    "august",
    "aunt",
    "author",
    "auto",
    "autumn",
    "average",
    "avocado",
    "avoid",
    "awake",
    "aware",
    "away",
    "awesome",
    "awful",
    "awkward",
    "axis",
    "baby",
    "bachelor",
    "bacon",
    "badge",
    "bag",
    "balance",
    "balcony",
    "ball",
    "bamboo",
    "banana",
    "banner",
    "bar",
    "barely",
    "bargain",
    "barrel",
    "base",
    "basic",
    "basket",
    "battle",
    "beach",
    "bean",
    "beauty",
    "because",
    "become",
    "beef",
    "before",
    "begin",
    "behave",
    "behind",
    "believe",
    "below",
    "belt",
    "bench",
    "benefit",
    "best",
    "betray",
    "better",
    "between",
    "beyond",
    "bicycle",
    "bid",
    "bike",
    "bind",
    "biology",
    "bird",
    "birth",
    "bitter",
    "black",
    "blade",
    "blame",
    "blanket",
    "blast",
    "bleak",
    "bless",
    "blind",
    "blood",
    "blossom",
    "blouse",
    "blue",
    "blur",
    "blush",
    "board",
    "boat",
    "body",
    "boil",
    "bomb",
    "bone",
    "bonus",
    "book",
    "boost",
    "border",
    "boring",
    "borrow",
    "boss",
    "bottom",
    "bounce",
    "box",
    "boy",
    "bracket",
    "brain",
    "brand",
    "brass",
    "brave",
    "bread",
    "breeze",
    "brick",
    "bridge",
    "brief",
    "bright",
    "bring",
    "brisk",
    "broccoli",
    "broken",
    "bronze",
    "broom",
    "brother",
    "brown",
    "brush",
    "bubble",
    "buddy",
    "budget",
    "buffalo",
    "build",
    "bulb",
    "bulk",
    "bullet",
    "bundle",
    "bunker",
    "burden",
    "burger",
    "burst",
    "bus",
    "business",
    "busy",
    "butter",
    "buyer",
    "buzz",
    "cabbage",
    "cabin",
    "cable",
    "cactus",
    "cage",
    "cake",
    "call",
    "calm",
    "camera",
    "camp",
    "can",
    "canal",
    "cancel",
    "candy",
    "cannon",
    "canoe",
    "canvas",
    "canyon",
    "capable",
    "capital",
    "captain",
    "car",
    "carbon",
    "card",
    "cargo",
    "carpet",
    "carry",
    "cart",
    "case",
    "cash",
    "casino",
    "castle",
    "casual",
    "cat",
    "catalog",
    "catch",
    "category",
    "cattle",
    "caught",
    "cause",
    "caution",
    "cave",
    "ceiling",
    "celery",
    "cement",
    "census",
    "century",
    "cereal",
    "certain",
    "chair",
    "chalk",
    "champion",
    "change",
    "chaos",
    "chapter",
    "charge",
    "chase",
    "chat",
    "cheap",
    "check",
    "cheese",
    "chef",
    "cherry",
    "chest",
    "chicken",
    "chief",
    "child",
    "chimney",
    "choice",
    "choose",
    "chronic",
    "chuckle",
    "chunk",
    "churn",
    "cigar",
    "cinnamon",
    "circle",
    "citizen",
    "city",
    "civil",
    "claim",
    "clap",
    "clarify",
    "claw",
    "clay",
    "clean",
    "clerk",
    "clever",
    "click",
    "client",
    "cliff",
    "climb",
    "clinic",
    "clip",
    "clock",
    "clog",
    "close",
    "cloth",
    "cloud",
    "clown",
    "club",
    "clump",
    "cluster",
    "clutch",
    "coach",
    "coast",
    "coconut",
    "code",
    "coffee",
    "coil",
    "coin",
    "collect",
    "color",
    "column",
    "combine",
    "come",
    "comfort",
    "comic",
    "common",
    "company",
    "concert",
    "conduct",
    "confirm",
    "congress",
    "connect",
    "consider",
    "control",
    "convince",
    "cook",
    "cool",
    "copper",
    "copy",
    "coral",
    "core",
    "corn",
    "correct",
    "cost",
    "cotton",
    "couch",
    "country",
    "couple",
    "course",
    "cousin",
    "cover",
    "coyote",
    "crack",
    "cradle",
    "craft",
    "cram",
    "crane",
    "crash",
    "crater",
    "crawl",
    "crazy",
    "cream",
    "credit",
    "creek",
    "crew",
    "cricket",
    "crime",
    "crisp",
    "critic",
    "crop",
    "cross",
    "crouch",
    "crowd",
    "crucial",
    "cruel",
    "cruise",
    "crumble",
    "crunch",
    "crush",
    "cry",
    "crystal",
    "cube",
    "culture",
    "cup",
    "cupboard",
    "curious",
    "current",
    "curtain",
    "curve",
    "cushion",
    "custom",
    "cute",
    "cycle",
    "dad",
    "damage",
    "damp",
    "dance",
    "danger",
    "daring",
    "dash",
    "daughter",
    "dawn",
    "day",
    "deal",
    "debate",
    "debris",
    "decade",
    "december",
    "decide",
    "decline",
    "decorate",
    "decrease",
    "deer",
    "defense",
    "define",
    "defy",
    "degree",
    "delay",
    "deliver",
    "demand",
    "demise",
    "denial",
    "dentist",
    "deny",
    "depart",
    "depend",
    "deposit",
    "depth",
    "deputy",
    "derive",
    "describe",
    "desert",
    "design",
    "desk",
    "despair",
    "destroy",
    "detail",
    "detect",
    "develop",
    "device",
    "devote",
    "diagram",
    "dial",
    "diamond",
    "diary",
    "dice",
    "diesel",
    "diet",
    "differ",
    "digital",
    "dignity",
    "dilemma",
    "dinner",
    "dinosaur",
    "direct",
    "dirt",
    "disagree",
    "discover",
    "disease",
    "dish",
    "dismiss",
    "disorder",
    "display",
    "distance",
    "divert",
    "divide",
    "divorce",
    "dizzy",
    "doctor",
    "document",
    "dog",
    "doll",
    "dolphin",
    "domain",
    "donate",
    "donkey",
    "donor",
    "door",
    "dose",
    "double",
    "dove",
    "draft",
    "dragon",
    "drama",
    "drastic",
    "draw",
    "dream",
    "dress",
    "drift",
    "drill",
    "drink",
    "drip",
    "drive",
    "drop",
    "drum",
    "dry",
    "duck",
    "dumb",
    "dune",
    "during",
    "dust",
    "dutch",
    "duty",
    "dwarf",
    "dynamic",
    "eager",
    "eagle",
    "early",
    "earn",
    "earth",
    "easily",
    "east",
    "easy",
    "echo",
    "ecology",
    "economy",
    "edge",
    "edit",
    "educate",
    "effort",
    "egg",
    "eight",
    "either",
    "elbow",
    "elder",
    "electric",
    "elegant",
    "element",
    "elephant",
    "elevator",
    "elite",
    "else",
    "embark",
    "embody",
    "embrace",
    "emerge",
    "emotion",
    "employ",
    "empower",
    "empty",
    "enable",
    "enact",
    "end",
    "endless",
    "endorse",
    "enemy",
    "energy",
    "enforce",
    "engage",
    "engine",
    "enhance",
    "enjoy",
    "enlist",
    "enough",
    "enrich",
    "enroll",
    "ensure",
    "enter",
    "entire",
    "entry",
    "envelope",
    "episode",
    "equal",
    "equip",
    "era",
    "erase",
    "erode",
    "erosion",
    "error",
    "erupt",
    "escape",
    "essay",
    "essence",
    "estate",
    "eternal",
    "ethics",
    "evidence",
    "evil",
    "evoke",
    "evolve",
    "exact",
    "example",
    "excess",
    "exchange",
    "excite",
    "exclude",
    "excuse",
    "execute",
    "exercise",
    "exhaust",
    "exhibit",
    "exile",
    "exist",
    "exit",
    "exotic",
    "expand",
    "expect",
    "expire",
    "explain",
    "expose",
    "express",
    "extend",
    "extra",
    "eye",
    "eyebrow",
    "fabric",
    "face",
    "faculty",
    "fade",
    "faint",
    "faith",
    "fall",
    "false",
    "fame",
    "family",
    "famous",
    "fan",
    "fancy",
    "fantasy",
    "farm",
    "fashion",
    "fat",
    "fatal",
    "father",
    "fatigue",
    "fault",
    "favorite",
    "feature",
    "february",
    "federal",
    "fee",
    "feed",
    "feel",
    "female",
    "fence",
    "festival",
    "fetch",
    "fever",
    "few",
    "fiber",
    "fiction",
    "field",
    "figure",
    "file",
    "film",
    "filter",
    "final",
    "find",
    "fine",
    "finger",
    "finish",
    "fire",
    "firm",
    "first",
    "fiscal",
    "fish",
    "fit",
    "fitness",
    "fix",
    "flag",
    "flame",
    "flash",
    "flat",
    "flavor",
    "flee",
    "flight",
    "flip",
    "float",
    "flock",
    "floor",
    "flower",
    "fluid",
    "flush",
    "fly",
    "foam",
    "focus",
    "fog",
    "foil",
    "fold",
    "follow",
    "food",
    "foot",
    "force",
    "forest",
    "forget",
    "fork",
    "fortune",
    "forum",
    "forward",
    "fossil",
    "foster",
    "found",
    "fox",
    "fragile",
    "frame",
    "frequent",
    "fresh",
    "friend",
    "fringe",
    "frog",
    "front",
    "frost",
    "frown",
    "frozen",
    "fruit",
    "fuel",
    "fun",
    "funny",
    "furnace",
    "fury",
    "future",
    "gadget",
    "gain",
    "galaxy",
    "gallery",
    "game",
    "gap",
    "garage",
    "garbage",
    "garden",
    "garlic",
    "garment",
    "gas",
    "gasp",
    "gate",
    "gather",
    "gauge",
    "gaze",
    "general",
    "genius",
    "genre",
    "gentle",
    "genuine",
    "gesture",
    "ghost",
    "giant",
    "gift",
    "giggle",
    "ginger",
    "giraffe",
    "girl",
    "give",
    "glad",
    "glance",
    "glare",
    "glass",
    "glide",
    "glimpse",
    "globe",
    "gloom",
    "glory",
    "glove",
    "glow",
    "glue",
    "goat",
    "goddess",
    "gold",
    "good",
    "goose",
    "gorilla",
    "gospel",
    "gossip",
    "govern",
    "gown",
    "grab",
    "grace",
    "grain",
    "grant",
    "grape",
    "grass",
    "gravity",
    "great",
    "green",
    "grid",
    "grief",
    "grit",
    "grocery",
    "group",
    "grow",
    "grunt",
    "guard",
    "guess",
    "guide",
    "guilt",
    "guitar",
    "gun",
    "gym",
    "habit",
    "hair",
    "half",
    "hammer",
    "hamster",
    "hand",
    "happy",
    "harbor",
    "hard",
    "harsh",
    "harvest",
    "hat",
    "have",
    "hawk",
    "hazard",
    "head",
    "health",
    "heart",
    "heavy",
    "hedgehog",
    "height",
    "hello",
    "helmet",
    "help",
    "hen",
    "hero",
    "hidden",
    "high",
    "hill",
    "hint",
    "hip",
    "hire",
    "history",
    "hobby",
    "hockey",
    "hold",
    "hole",
    "holiday",
    "hollow",
    "home",
    "honey",
    "hood",
    "hope",
    "horn",
    "horror",
    "horse",
    "hospital",
    "host",
    "hotel",
    "hour",
    "hover",
    "hub",
    "huge",
    "human",
    "humble",
    "humor",
    "hundred",
    "hungry",
    "hunt",
    "hurdle",
    "hurry",
    "hurt",
    "husband",
    "hybrid",
    "ice",
    "icon",
    "idea",
    "identify",
    "idle",
    "ignore",
    "ill",
    "illegal",
    "illness",
    "image",
    "imitate",
    "immense",
    "immune",
    "impact",
    "impose",
    "improve",
    "impulse",
    "inch",
    "include",
    "income",
    "increase",
    "index",
    "indicate",
    "indoor",
    "industry",
    "infant",
    "inflict",
    "inform",
    "inhale",
    "inherit",
    "initial",
    "inject",
    "injury",
    "inmate",
    "inner",
    "innocent",
    "input",
    "inquiry",
    "insane",
    "insect",
    "inside",
    "inspire",
    "install",
    "intact",
    "interest",
    "into",
    "invest",
    "invite",
    "involve",
    "iron",
    "island",
    "isolate",
    "issue",
    "item",
    "ivory",
    "jacket",
    "jaguar",
    "jar",
    "jazz",
    "jealous",
    "jeans",
    "jelly",
    "jewel",
    "job",
    "join",
    "joke",
    "journey",
    "joy",
    "judge",
    "juice",
    "jump",
    "jungle",
    "junior",
    "junk",
    "just",
    "kangaroo",
    "keen",
    "keep",
    "ketchup",
    "key",
    "kick",
    "kid",
    "kidney",
    "kind",
    "kingdom",
    "kiss",
    "kit",
    "kitchen",
    "kite",
    "kitten",
    "kiwi",
    "knee",
    "knife",
    "knock",
    "know",
    "lab",
    "label",
    "labor",
    "ladder",
    "lady",
    "lake",
    "lamp",
    "language",
    "laptop",
    "large",
    "later",
    "latin",
    "laugh",
    "laundry",
    "lava",
    "law",
    "lawn",
    "lawsuit",
    "layer",
    "lazy",
    "leader",
    "leaf",
    "learn",
    "leave",
    "lecture",
    "left",
    "leg",
    "legal",
    "legend",
    "leisure",
    "lemon",
    "lend",
    "length",
    "lens",
    "leopard",
    "lesson",
    "letter",
    "level",
    "liar",
    "liberty",
    "library",
    "license",
    "life",
    "lift",
    "light",
    "like",
    "limb",
    "limit",
    "link",
    "lion",
    "liquid",
    "list",
    "little",
    "live",
    "lizard",
    "load",
    "loan",
    "lobster",
    "local",
    "lock",
    "logic",
    "lonely",
    "long",
    "loop",
    "lottery",
    "loud",
    "lounge",
    "love",
    "loyal",
    "lucky",
    "luggage",
    "lumber",
    "lunar",
    "lunch",
    "luxury",
    "lyrics",
    "machine",
    "mad",
    "magic",
    "magnet",
    "maid",
    "mail",
    "main",
    "major",
    "make",
    "mammal",
    "man",
    "manage",
    "mandate",
    "mango",
    "mansion",
    "manual",
    "maple",
    "marble",
    "march",
    "margin",
    "marine",
    "market",
    "marriage",
    "mask",
    "mass",
    "master",
    "match",
    "material",
    "math",
    "matrix",
    "matter",
    "maximum",
    "maze",
    "meadow",
    "mean",
    "measure",
    "meat",
    "mechanic",
    "medal",
    "media",
    "melody",
    "melt",
    "member",
    "memory",
    "mention",
    "menu",
    "mercy",
    "merge",
    "merit",
    "merry",
    "mesh",
    "message",
    "metal",
    "method",
    "middle",
    "midnight",
    "milk",
    "million",
    "mimic",
    "mind",
    "minimum",
    "minor",
    "minute",
    "miracle",
    "mirror",
    "misery",
    "miss",
    "mistake",
    "mix",
    "mixed",
    "mixture",
    "mobile",
    "model",
    "modify",
    "mom",
    "moment",
    "monitor",
    "monkey",
    "monster",
    "month",
    "moon",
    "moral",
    "more",
    "morning",
    "mosquito",
    "mother",
    "motion",
    "motor",
    "mountain",
    "mouse",
    "move",
    "movie",
    "much",
    "muffin",
    "mule",
    "multiply",
    "muscle",
    "museum",
    "mushroom",
    "music",
    "must",
    "mutual",
    "myself",
    "mystery",
    "myth",
    "naive",
    "name",
    "napkin",
    "narrow",
    "nasty",
    "nation",
    "nature",
    "near",
    "neck",
    "need",
    "negative",
    "neglect",
    "neither",
    "nephew",
    "nerve",
    "nest",
    "net",
    "network",
    "neutral",
    "never",
    "news",
    "next",
    "nice",
    "night",
    "noble",
    "noise",
    "nominee",
    "noodle",
    "normal",
    "north",
    "nose",
    "notable",
    "note",
    "nothing",
    "notice",
    "novel",
    "now",
    "nuclear",
    "number",
    "nurse",
    "nut",
    "oak",
    "obey",
    "object",
    "oblige",
    "obscure",
    "observe",
    "obtain",
    "obvious",
    "occur",
    "ocean",
    "october",
    "odor",
    "off",
    "offer",
    "office",
    "often",
    "oil",
    "okay",
    "old",
    "olive",
    "olympic",
    "omit",
    "once",
    "one",
    "onion",
    "online",
    "only",
    "open",
    "opera",
    "opinion",
    "oppose",
    "option",
    "orange",
    "orbit",
    "orchard",
    "order",
    "ordinary",
    "organ",
    "orient",
    "original",
    "orphan",
    "ostrich",
    "other",
    "outdoor",
    "outer",
    "output",
    "outside",
    "oval",
    "oven",
    "over",
    "own",
    "owner",
    "oxygen",
    "oyster",
    "ozone",
    "pact",
    "paddle",
    "page",
    "pair",
    "palace",
    "palm",
    "panda",
    "panel",
    "panic",
    "panther",
    "paper",
    "parade",
    "parent",
    "park",
    "parrot",
    "party",
    "pass",
    "patch",
    "path",
    "patient",
    "patrol",
    "pattern",
    "pause",
    "pave",
    "payment",
    "peace",
    "peanut",
    "pear",
    "peasant",
    "pelican",
    "pen",
    "penalty",
    "pencil",
    "people",
    "pepper",
    "perfect",
    "permit",
    "person",
    "pet",
    "phone",
    "photo",
    "phrase",
    "physical",
    "piano",
    "picnic",
    "picture",
    "piece",
    "pig",
    "pigeon",
    "pill",
    "pilot",
    "pink",
    "pioneer",
    "pipe",
    "pistol",
    "pitch",
    "pizza",
    "place",
    "planet",
    "plastic",
    "plate",
    "play",
    "please",
    "pledge",
    "pluck",
    "plug",
    "plunge",
    "poem",
    "poet",
    "point",
    "polar",
    "pole",
    "police",
    "pond",
    "pony",
    "pool",
    "popular",
    "portion",
    "position",
    "possible",
    "post",
    "potato",
    "pottery",
    "poverty",
    "powder",
    "power",
    "practice",
    "praise",
    "predict",
    "prefer",
    "prepare",
    "present",
    "pretty",
    "prevent",
    "price",
    "pride",
    "primary",
    "print",
    "priority",
    "prison",
    "private",
    "prize",
    "problem",
    "process",
    "produce",
    "profit",
    "program",
    "project",
    "promote",
    "proof",
    "property",
    "prosper",
    "protect",
    "proud",
    "provide",
    "public",
    "pudding",
    "pull",
    "pulp",
    "pulse",
    "pumpkin",
    "punch",
    "pupil",
    "puppy",
    "purchase",
    "purity",
    "purpose",
    "purse",
    "push",
    "put",
    "puzzle",
    "pyramid",
    "quality",
    "quantum",
    "quarter",
    "question",
    "quick",
    "quit",
    "quiz",
    "quote",
    "rabbit",
    "raccoon",
    "race",
    "rack",
    "radar",
    "radio",
    "rail",
    "rain",
    "raise",
    "rally",
    "ramp",
    "ranch",
    "random",
    "range",
    "rapid",
    "rare",
    "rate",
    "rather",
    "raven",
    "raw",
    "razor",
    "ready",
    "real",
    "reason",
    "rebel",
    "rebuild",
    "recall",
    "receive",
    "recipe",
    "record",
    "recycle",
    "reduce",
    "reflect",
    "reform",
    "refuse",
    "region",
    "regret",
    "regular",
    "reject",
    "relax",
    "release",
    "relief",
    "rely",
    "remain",
    "remember",
    "remind",
    "remove",
    "render",
    "renew",
    "rent",
    "reopen",
    "repair",
    "repeat",
    "replace",
    "report",
    "require",
    "rescue",
    "resemble",
    "resist",
    "resource",
    "response",
    "result",
    "retire",
    "retreat",
    "return",
    "reunion",
    "reveal",
    "review",
    "reward",
    "rhythm",
    "rib",
    "ribbon",
    "rice",
    "rich",
    "ride",
    "ridge",
    "rifle",
    "right",
    "rigid",
    "ring",
    "riot",
    "ripple",
    "risk",
    "ritual",
    "rival",
    "river",
    "road",
    "roast",
    "robot",
    "robust",
    "rocket",
    "romance",
    "roof",
    "rookie",
    "room",
    "rose",
    "rotate",
    "rough",
    "round",
    "route",
    "royal",
    "rubber",
    "rude",
    "rug",
    "rule",
    "run",
    "runway",
    "rural",
    "sad",
    "saddle",
    "sadness",
    "safe",
    "sail",
    "salad",
    "salmon",
    "salon",
    "salt",
    "salute",
    "same",
    "sample",
    "sand",
    "satisfy",
    "satoshi",
    "sauce",
    "sausage",
    "save",
    "say",
    "scale",
    "scan",
    "scare",
    "scatter",
    "scene",
    "scheme",
    "school",
    "science",
    "scissors",
    "scorpion",
    "scout",
    "scrap",
    "screen",
    "script",
    "scrub",
    "sea",
    "search",
    "season",
    "seat",
    "second",
    "secret",
    "section",
    "security",
    "seed",
    "seek",
    "segment",
    "select",
    "sell",
    "seminar",
    "senior",
    "sense",
    "sentence",
    "series",
    "service",
    "session",
    "settle",
    "setup",
    "seven",
    "shadow",
    "shaft",
    "shallow",
    "share",
    "shed",
    "shell",
    "sheriff",
    "shield",
    "shift",
    "shine",
    "ship",
    "shiver",
    "shock",
    "shoe",
    "shoot",
    "shop",
    "short",
    "shoulder",
    "shove",
    "shrimp",
    "shrug",
    "shuffle",
    "shy",
    "sibling",
    "sick",
    "side",
    "siege",
    "sight",
    "sign",
    "silent",
    "silk",
    "silly",
    "silver",
    "similar",
    "simple",
    "since",
    "sing",
    "siren",
    "sister",
    "situate",
    "six",
    "size",
    "skate",
    "sketch",
    "ski",
    "skill",
    "skin",
    "skirt",
    "skull",
    "slab",
    "slam",
    "sleep",
    "slender",
    "slice",
    "slide",
    "slight",
    "slim",
    "slogan",
    "slot",
    "slow",
    "slush",
    "small",
    "smart",
    "smile",
    "smoke",
    "smooth",
    "snack",
    "snake",
    "snap",
    "sniff",
    "snow",
    "soap",
    "soccer",
    "social",
    "sock",
    "soda",
    "soft",
    "solar",
    "soldier",
    "solid",
    "solution",
    "solve",
    "someone",
    "song",
    "soon",
    "sorry",
    "sort",
    "soul",
    "sound",
    "soup",
    "source",
    "south",
    "space",
    "spare",
    "spatial",
    "spawn",
    "speak",
    "special",
    "speed",
    "spell",
    "spend",
    "sphere",
    "spice",
    "spider",
    "spike",
    "spin",
    "spirit",
    "split",
    "spoil",
    "sponsor",
    "spoon",
    "sport",
    "spot",
    "spray",
    "spread",
    "spring",
    "spy",
    "square",
    "squeeze",
    "squirrel",
    "stable",
    "stadium",
    "staff",
    "stage",
    "stairs",
    "stamp",
    "stand",
    "start",
    "state",
    "stay",
    "steak",
    "steel",
    "stem",
    "step",
    "stereo",
    "stick",
    "still",
    "sting",
    "stock",
    "stomach",
    "stone",
    "stool",
    "story",
    "stove",
    "strategy",
    "street",
    "strike",
    "strong",
    "struggle",
    "student",
    "stuff",
    "stumble",
    "style",
    "subject",
    "submit",
    "subway",
    "success",
    "such",
    "sudden",
    "suffer",
    "sugar",
    "suggest",
    "suit",
    "summer",
    "sun",
    "sunny",
    "sunset",
    "super",
    "supply",
    "supreme",
    "sure",
    "surface",
    "surge",
    "surprise",
    "surround",
    "survey",
    "suspect",
    "sustain",
    "swallow",
    "swamp",
    "swap",
    "swarm",
    "swear",
    "sweet",
    "swift",
    "swim",
    "swing",
    "switch",
    "sword",
    "symbol",
    "symptom",
    "syrup",
    "system",
    "table",
    "tackle",
    "tag",
    "tail",
    "talent",
    "talk",
    "tank",
    "tape",
    "target",
    "task",
    "taste",
    "tattoo",
    "taxi",
    "teach",
    "team",
    "tell",
    "ten",
    "tenant",
    "tennis",
    "tent",
    "term",
    "test",
    "text",
    "thank",
    "that",
    "theme",
    "then",
    "theory",
    "there",
    "they",
    "thing",
    "this",
    "thought",
    "three",
    "thrive",
    "throw",
    "thumb",
    "thunder",
    "ticket",
    "tide",
    "tiger",
    "tilt",
    "timber",
    "time",
    "tiny",
    "tip",
    "tired",
    "tissue",
    "title",
    "toast",
    "tobacco",
    "today",
    "toddler",
    "toe",
    "together",
    "toilet",
    "token",
    "tomato",
    "tomorrow",
    "tone",
    "tongue",
    "tonight",
    "tool",
    "tooth",
    "top",
    "topic",
    "topple",
    "torch",
    "tornado",
    "tortoise",
    "toss",
    "total",
    "tourist",
    "toward",
    "tower",
    "town",
    "toy",
    "track",
    "trade",
    "traffic",
    "tragic",
    "train",
    "transfer",
    "trap",
    "trash",
    "travel",
    "tray",
    "treat",
    "tree",
    "trend",
    "trial",
    "tribe",
    "trick",
    "trigger",
    "trim",
    "trip",
    "trophy",
    "trouble",
    "truck",
    "true",
    "truly",
    "trumpet",
    "trust",
    "truth",
    "try",
    "tube",
    "tuition",
    "tumble",
    "tuna",
    "tunnel",
    "turkey",
    "turn",
    "turtle",
    "twelve",
    "twenty",
    "twice",
    "twin",
    "twist",
    "two",
    "type",
    "typical",
    "ugly",
    "umbrella",
    "unable",
    "unaware",
    "uncle",
    "uncover",
    "under",
    "undo",
    "unfair",
    "unfold",
    "unhappy",
    "uniform",
    "unique",
    "unit",
    "universe",
    "unknown",
    "unlock",
    "until",
    "unusual",
    "unveil",
    "update",
    "upgrade",
    "uphold",
    "upon",
    "upper",
    "upset",
    "urban",
    "urge",
    "usage",
    "use",
    "used",
    "useful",
    "useless",
    "usual",
    "utility",
    "vacant",
    "vacuum",
    "vague",
    "valid",
    "valley",
    "valve",
    "van",
    "vanish",
    "vapor",
    "various",
    "vast",
    "vault",
    "vehicle",
    "velvet",
    "vendor",
    "venture",
    "venue",
    "verb",
    "verify",
    "version",
    "very",
    "vessel",
    "veteran",
    "viable",
    "vibrant",
    "vicious",
    "victory",
    "video",
    "view",
    "village",
    "vintage",
    "violin",
    "virtual",
    "virus",
    "visa",
    "visit",
    "visual",
    "vital",
    "vivid",
    "vocal",
    "voice",
    "void",
    "volcano",
    "volume",
    "vote",
    "voyage",
    "wage",
    "wagon",
    "wait",
    "walk",
    "wall",
    "walnut",
    "want",
    "warfare",
    "warm",
    "warrior",
    "wash",
    "wasp",
    "waste",
    "water",
    "wave",
    "way",
    "wealth",
    "weapon",
    "wear",
    "weasel",
    "weather",
    "web",
    "wedding",
    "weekend",
    "weird",
    "welcome",
    "west",
    "wet",
    "whale",
    "what",
    "wheat",
    "wheel",
    "when",
    "where",
    "whip",
    "whisper",
    "wide",
    "width",
    "wife",
    "wild",
    "will",
    "win",
    "window",
    "wine",
    "wing",
    "wink",
    "winner",
    "winter",
    "wire",
    "wisdom",
    "wise",
    "wish",
    "witness",
    "wolf",
    "woman",
    "wonder",
    "wood",
    "wool",
    "word",
    "work",
    "world",
    "worry",
    "worth",
    "wrap",
    "wreck",
    "wrestle",
    "wrist",
    "write",
    "wrong",
    "yard",
    "year",
    "yellow",
    "you",
    "young",
    "youth",
    "zebra",
    "zero",
    "zone",
    "zoo"
  ];
  function t(Ie) {
    return Array.from(Ie).map((be) => be.toString(2).padStart(8, "0")).join("");
  }
  function l(Ie) {
    const Pe = Ie.length * 8 / 32, Te = (0, u.sha256)(Ie);
    return t(Te).slice(0, Pe);
  }
  function m(Ie) {
    return parseInt(Ie, 2);
  }
  const b = [16, 20, 24, 28, 32], k = [12, 15, 18, 21, 24];
  function C(Ie) {
    if (b.indexOf(Ie.length) === -1)
      throw new Error("invalid input length");
    const be = t(Ie), Pe = l(Ie);
    return (be + Pe).match(/(.{11})/g).map((Ee) => {
      const He = m(Ee);
      return p[He];
    }).join(" ");
  }
  const B = "Invalid number of words", Q = "Found word that is not in the wordlist", P = "Invalid entropy", x = "Invalid mnemonic checksum";
  function M(Ie) {
    return Ie.normalize("NFKD");
  }
  function F(Ie) {
    const be = M(Ie).split(" ");
    if (!k.includes(be.length))
      throw new Error(B);
    const Pe = be.map((we) => {
      const Ce = p.indexOf(we);
      if (Ce === -1)
        throw new Error(Q);
      return Ce.toString(2).padStart(11, "0");
    }).join(""), Te = Math.floor(Pe.length / 33) * 32, Qe = Pe.slice(0, Te), xe = Pe.slice(Te), Ee = Qe.match(/(.{1,8})/g).map(m);
    if (Ee.length < 16 || Ee.length > 32 || Ee.length % 4 !== 0)
      throw new Error(P);
    const He = Uint8Array.from(Ee);
    if (l(He) !== xe)
      throw new Error(x);
    return He;
  }
  const pe = class pe {
    constructor(be) {
      Ci(this, "data");
      if (!pe.mnemonicMatcher.test(be))
        throw new Error("Invalid mnemonic format");
      const Pe = be.split(" "), Te = [12, 15, 18, 21, 24];
      if (Te.indexOf(Pe.length) === -1)
        throw new Error(`Invalid word count in mnemonic (allowed: ${Te} got: ${Pe.length})`);
      for (const Qe of Pe)
        if (pe.wordlist.indexOf(Qe) === -1)
          throw new Error("Mnemonic contains invalid word");
      F(be), this.data = be;
    }
    toString() {
      return this.data;
    }
  };
  Ci(pe, "wordlist", p), // list of space separated lower case words (1 or more)
  Ci(pe, "mnemonicMatcher", /^[a-z]+( [a-z]+)*$/);
  let le = pe;
  bip39.EnglishMnemonic = le;
  class ge {
    /**
     * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
     *
     * | Entropy            | Words |
     * |--------------------|-------|
     * | 128 bit (16 bytes) |    12 |
     * | 160 bit (20 bytes) |    15 |
     * | 192 bit (24 bytes) |    18 |
     * | 224 bit (28 bytes) |    21 |
     * | 256 bit (32 bytes) |    24 |
     *
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
     * @param entropy The entropy to be encoded. This must be cryptographically secure.
     */
    static encode(be) {
      return new le(C(be));
    }
    static decode(be) {
      return F(be.toString());
    }
    static async mnemonicToSeed(be, Pe) {
      const Te = (0, s.toUtf8)(M(be.toString())), Qe = "mnemonic" + (Pe ? M(Pe) : ""), xe = (0, s.toUtf8)(Qe);
      return (0, A.pbkdf2Sha512)(Te, xe, 2048, 64);
    }
  }
  return bip39.Bip39 = ge, bip39;
}
var hmac$1 = {}, hasRequiredHmac;
function requireHmac() {
  if (hasRequiredHmac) return hmac$1;
  hasRequiredHmac = 1, Object.defineProperty(hmac$1, "__esModule", { value: !0 }), hmac$1.Hmac = void 0;
  class s {
    constructor(u, p) {
      Ci(this, "blockSize");
      Ci(this, "messageHasher");
      Ci(this, "oKeyPad");
      Ci(this, "iKeyPad");
      Ci(this, "hash");
      const t = new u().blockSize;
      this.hash = (m) => new u().update(m).digest();
      let l = p;
      if (l.length > t && (l = this.hash(l)), l.length < t) {
        const m = new Uint8Array(t - l.length);
        l = new Uint8Array([...l, ...m]);
      }
      this.oKeyPad = l.map((m) => m ^ 92), this.iKeyPad = l.map((m) => m ^ 54), this.messageHasher = new u(), this.blockSize = t, this.update(this.iKeyPad);
    }
    update(u) {
      return this.messageHasher.update(u), this;
    }
    digest() {
      const u = this.messageHasher.digest();
      return this.hash(new Uint8Array([...this.oKeyPad, ...u]));
    }
  }
  return hmac$1.Hmac = s, hmac$1;
}
var keccak$1 = {}, sha3$1 = {}, hasRequiredSha3;
function requireSha3() {
  if (hasRequiredSha3) return sha3$1;
  hasRequiredSha3 = 1, Object.defineProperty(sha3$1, "__esModule", { value: !0 }), sha3$1.shake256 = sha3$1.shake128 = sha3$1.keccak_512 = sha3$1.keccak_384 = sha3$1.keccak_256 = sha3$1.keccak_224 = sha3$1.sha3_512 = sha3$1.sha3_384 = sha3$1.sha3_256 = sha3$1.sha3_224 = sha3$1.Keccak = void 0, sha3$1.keccakP = le;
  const s = /* @__PURE__ */ require_u64$1(), A = /* @__PURE__ */ requireUtils$j(), u = BigInt(0), p = BigInt(1), t = BigInt(2), l = BigInt(7), m = BigInt(256), b = BigInt(113), k = [], C = [], B = [];
  for (let be = 0, Pe = p, Te = 1, Qe = 0; be < 24; be++) {
    [Te, Qe] = [Qe, (2 * Te + 3 * Qe) % 5], k.push(2 * (5 * Qe + Te)), C.push((be + 1) * (be + 2) / 2 % 64);
    let xe = u;
    for (let Ee = 0; Ee < 7; Ee++)
      Pe = (Pe << p ^ (Pe >> l) * b) % m, Pe & t && (xe ^= p << (p << /* @__PURE__ */ BigInt(Ee)) - p);
    B.push(xe);
  }
  const Q = (0, s.split)(B, !0), P = Q[0], x = Q[1], M = (be, Pe, Te) => Te > 32 ? (0, s.rotlBH)(be, Pe, Te) : (0, s.rotlSH)(be, Pe, Te), F = (be, Pe, Te) => Te > 32 ? (0, s.rotlBL)(be, Pe, Te) : (0, s.rotlSL)(be, Pe, Te);
  function le(be, Pe = 24) {
    const Te = new Uint32Array(10);
    for (let Qe = 24 - Pe; Qe < 24; Qe++) {
      for (let He = 0; He < 10; He++)
        Te[He] = be[He] ^ be[He + 10] ^ be[He + 20] ^ be[He + 30] ^ be[He + 40];
      for (let He = 0; He < 10; He += 2) {
        const ve = (He + 8) % 10, we = (He + 2) % 10, Ce = Te[we], Se = Te[we + 1], Ne = M(Ce, Se, 1) ^ Te[ve], rr = F(Ce, Se, 1) ^ Te[ve + 1];
        for (let er = 0; er < 50; er += 10)
          be[He + er] ^= Ne, be[He + er + 1] ^= rr;
      }
      let xe = be[2], Ee = be[3];
      for (let He = 0; He < 24; He++) {
        const ve = C[He], we = M(xe, Ee, ve), Ce = F(xe, Ee, ve), Se = k[He];
        xe = be[Se], Ee = be[Se + 1], be[Se] = we, be[Se + 1] = Ce;
      }
      for (let He = 0; He < 50; He += 10) {
        for (let ve = 0; ve < 10; ve++)
          Te[ve] = be[He + ve];
        for (let ve = 0; ve < 10; ve++)
          be[He + ve] ^= ~Te[(ve + 2) % 10] & Te[(ve + 4) % 10];
      }
      be[0] ^= P[Qe], be[1] ^= x[Qe];
    }
    (0, A.clean)(Te);
  }
  class ge extends A.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(Pe, Te, Qe, xe = !1, Ee = 24) {
      if (super(), this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, this.enableXOF = !1, this.blockLen = Pe, this.suffix = Te, this.outputLen = Qe, this.enableXOF = xe, this.rounds = Ee, (0, A.anumber)(Qe), !(0 < Pe && Pe < 200))
        throw new Error("only keccak-f1600 function is supported");
      this.state = new Uint8Array(200), this.state32 = (0, A.u32)(this.state);
    }
    clone() {
      return this._cloneInto();
    }
    keccak() {
      (0, A.swap32IfBE)(this.state32), le(this.state32, this.rounds), (0, A.swap32IfBE)(this.state32), this.posOut = 0, this.pos = 0;
    }
    update(Pe) {
      (0, A.aexists)(this), Pe = (0, A.toBytes)(Pe), (0, A.abytes)(Pe);
      const { blockLen: Te, state: Qe } = this, xe = Pe.length;
      for (let Ee = 0; Ee < xe; ) {
        const He = Math.min(Te - this.pos, xe - Ee);
        for (let ve = 0; ve < He; ve++)
          Qe[this.pos++] ^= Pe[Ee++];
        this.pos === Te && this.keccak();
      }
      return this;
    }
    finish() {
      if (this.finished)
        return;
      this.finished = !0;
      const { state: Pe, suffix: Te, pos: Qe, blockLen: xe } = this;
      Pe[Qe] ^= Te, (Te & 128) !== 0 && Qe === xe - 1 && this.keccak(), Pe[xe - 1] ^= 128, this.keccak();
    }
    writeInto(Pe) {
      (0, A.aexists)(this, !1), (0, A.abytes)(Pe), this.finish();
      const Te = this.state, { blockLen: Qe } = this;
      for (let xe = 0, Ee = Pe.length; xe < Ee; ) {
        this.posOut >= Qe && this.keccak();
        const He = Math.min(Qe - this.posOut, Ee - xe);
        Pe.set(Te.subarray(this.posOut, this.posOut + He), xe), this.posOut += He, xe += He;
      }
      return Pe;
    }
    xofInto(Pe) {
      if (!this.enableXOF)
        throw new Error("XOF is not possible for this instance");
      return this.writeInto(Pe);
    }
    xof(Pe) {
      return (0, A.anumber)(Pe), this.xofInto(new Uint8Array(Pe));
    }
    digestInto(Pe) {
      if ((0, A.aoutput)(Pe, this), this.finished)
        throw new Error("digest() was already called");
      return this.writeInto(Pe), this.destroy(), Pe;
    }
    digest() {
      return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
      this.destroyed = !0, (0, A.clean)(this.state);
    }
    _cloneInto(Pe) {
      const { blockLen: Te, suffix: Qe, outputLen: xe, rounds: Ee, enableXOF: He } = this;
      return Pe || (Pe = new ge(Te, Qe, xe, He, Ee)), Pe.state32.set(this.state32), Pe.pos = this.pos, Pe.posOut = this.posOut, Pe.finished = this.finished, Pe.rounds = Ee, Pe.suffix = Qe, Pe.outputLen = xe, Pe.enableXOF = He, Pe.destroyed = this.destroyed, Pe;
    }
  }
  sha3$1.Keccak = ge;
  const pe = (be, Pe, Te) => (0, A.createHasher)(() => new ge(Pe, be, Te));
  sha3$1.sha3_224 = pe(6, 144, 224 / 8), sha3$1.sha3_256 = pe(6, 136, 256 / 8), sha3$1.sha3_384 = pe(6, 104, 384 / 8), sha3$1.sha3_512 = pe(6, 72, 512 / 8), sha3$1.keccak_224 = pe(1, 144, 224 / 8), sha3$1.keccak_256 = pe(1, 136, 256 / 8), sha3$1.keccak_384 = pe(1, 104, 384 / 8), sha3$1.keccak_512 = pe(1, 72, 512 / 8);
  const Ie = (be, Pe, Te) => (0, A.createXOFer)((Qe = {}) => new ge(Pe, be, Qe.dkLen === void 0 ? Te : Qe.dkLen, !0));
  return sha3$1.shake128 = Ie(31, 168, 128 / 8), sha3$1.shake256 = Ie(31, 136, 256 / 8), sha3$1;
}
var hasRequiredKeccak;
function requireKeccak() {
  if (hasRequiredKeccak) return keccak$1;
  hasRequiredKeccak = 1, Object.defineProperty(keccak$1, "__esModule", { value: !0 }), keccak$1.Keccak256 = void 0, keccak$1.keccak256 = p;
  const s = /* @__PURE__ */ requireSha3(), A = requireUtils$3();
  class u {
    constructor(l) {
      Ci(this, "blockSize", 512 / 8);
      Ci(this, "impl", s.keccak_256.create());
      l && this.update(l);
    }
    update(l) {
      return this.impl.update((0, A.toRealUint8Array)(l)), this;
    }
    digest() {
      return this.impl.digest();
    }
  }
  keccak$1.Keccak256 = u;
  function p(t) {
    return new u(t).digest();
  }
  return keccak$1;
}
var libsodium = {}, chacha = {}, _arx = {}, utils$3 = {}, hasRequiredUtils$2;
function requireUtils$2() {
  return hasRequiredUtils$2 || (hasRequiredUtils$2 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.wrapCipher = s.Hash = s.nextTick = s.isLE = void 0, s.isBytes = A, s.abool = u, s.anumber = p, s.abytes = t, s.ahash = l, s.aexists = m, s.aoutput = b, s.u8 = k, s.u32 = C, s.clean = B, s.createView = Q, s.bytesToHex = M, s.hexToBytes = ge, s.hexToNumber = pe, s.bytesToNumberBE = Ie, s.numberToBytesBE = be, s.utf8ToBytes = Te, s.bytesToUtf8 = Qe, s.toBytes = xe, s.overlapBytes = Ee, s.complexOverlapBytes = He, s.concatBytes = ve, s.checkOpts = we, s.equalBytes = Ce, s.getOutput = rr, s.setBigUint64 = er, s.u64Lengths = ir, s.isAligned32 = sr, s.copyBytes = nr;
    function A(fr) {
      return fr instanceof Uint8Array || ArrayBuffer.isView(fr) && fr.constructor.name === "Uint8Array";
    }
    function u(fr) {
      if (typeof fr != "boolean")
        throw new Error(`boolean expected, not ${fr}`);
    }
    function p(fr) {
      if (!Number.isSafeInteger(fr) || fr < 0)
        throw new Error("positive integer expected, got " + fr);
    }
    function t(fr, ...lr) {
      if (!A(fr))
        throw new Error("Uint8Array expected");
      if (lr.length > 0 && !lr.includes(fr.length))
        throw new Error("Uint8Array expected of length " + lr + ", got length=" + fr.length);
    }
    function l(fr) {
      if (typeof fr != "function" || typeof fr.create != "function")
        throw new Error("Hash should be wrapped by utils.createHasher");
      p(fr.outputLen), p(fr.blockLen);
    }
    function m(fr, lr = !0) {
      if (fr.destroyed)
        throw new Error("Hash instance has been destroyed");
      if (lr && fr.finished)
        throw new Error("Hash#digest() has already been called");
    }
    function b(fr, lr) {
      t(fr);
      const br = lr.outputLen;
      if (fr.length < br)
        throw new Error("digestInto() expects output buffer of length at least " + br);
    }
    function k(fr) {
      return new Uint8Array(fr.buffer, fr.byteOffset, fr.byteLength);
    }
    function C(fr) {
      return new Uint32Array(fr.buffer, fr.byteOffset, Math.floor(fr.byteLength / 4));
    }
    function B(...fr) {
      for (let lr = 0; lr < fr.length; lr++)
        fr[lr].fill(0);
    }
    function Q(fr) {
      return new DataView(fr.buffer, fr.byteOffset, fr.byteLength);
    }
    s.isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
    const P = /* @ts-ignore */ typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function", x = /* @__PURE__ */ Array.from({ length: 256 }, (fr, lr) => lr.toString(16).padStart(2, "0"));
    function M(fr) {
      if (t(fr), P)
        return fr.toHex();
      let lr = "";
      for (let br = 0; br < fr.length; br++)
        lr += x[fr[br]];
      return lr;
    }
    const F = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
    function le(fr) {
      if (fr >= F._0 && fr <= F._9)
        return fr - F._0;
      if (fr >= F.A && fr <= F.F)
        return fr - (F.A - 10);
      if (fr >= F.a && fr <= F.f)
        return fr - (F.a - 10);
    }
    function ge(fr) {
      if (typeof fr != "string")
        throw new Error("hex string expected, got " + typeof fr);
      if (P)
        return Uint8Array.fromHex(fr);
      const lr = fr.length, br = lr / 2;
      if (lr % 2)
        throw new Error("hex string expected, got unpadded hex of length " + lr);
      const Br = new Uint8Array(br);
      for (let Fr = 0, Gr = 0; Fr < br; Fr++, Gr += 2) {
        const qr = le(fr.charCodeAt(Gr)), Hr = le(fr.charCodeAt(Gr + 1));
        if (qr === void 0 || Hr === void 0) {
          const un = fr[Gr] + fr[Gr + 1];
          throw new Error('hex string expected, got non-hex character "' + un + '" at index ' + Gr);
        }
        Br[Fr] = qr * 16 + Hr;
      }
      return Br;
    }
    function pe(fr) {
      if (typeof fr != "string")
        throw new Error("hex string expected, got " + typeof fr);
      return BigInt(fr === "" ? "0" : "0x" + fr);
    }
    function Ie(fr) {
      return pe(M(fr));
    }
    function be(fr, lr) {
      return ge(fr.toString(16).padStart(lr * 2, "0"));
    }
    const Pe = async () => {
    };
    s.nextTick = Pe;
    function Te(fr) {
      if (typeof fr != "string")
        throw new Error("string expected");
      return new Uint8Array(new TextEncoder().encode(fr));
    }
    function Qe(fr) {
      return new TextDecoder().decode(fr);
    }
    function xe(fr) {
      if (typeof fr == "string")
        fr = Te(fr);
      else if (A(fr))
        fr = nr(fr);
      else
        throw new Error("Uint8Array expected, got " + typeof fr);
      return fr;
    }
    function Ee(fr, lr) {
      return fr.buffer === lr.buffer && // best we can do, may fail with an obscure Proxy
      fr.byteOffset < lr.byteOffset + lr.byteLength && // a starts before b end
      lr.byteOffset < fr.byteOffset + fr.byteLength;
    }
    function He(fr, lr) {
      if (Ee(fr, lr) && fr.byteOffset < lr.byteOffset)
        throw new Error("complex overlap of input and output is not supported");
    }
    function ve(...fr) {
      let lr = 0;
      for (let Br = 0; Br < fr.length; Br++) {
        const Fr = fr[Br];
        t(Fr), lr += Fr.length;
      }
      const br = new Uint8Array(lr);
      for (let Br = 0, Fr = 0; Br < fr.length; Br++) {
        const Gr = fr[Br];
        br.set(Gr, Fr), Fr += Gr.length;
      }
      return br;
    }
    function we(fr, lr) {
      if (lr == null || typeof lr != "object")
        throw new Error("options must be defined");
      return Object.assign(fr, lr);
    }
    function Ce(fr, lr) {
      if (fr.length !== lr.length)
        return !1;
      let br = 0;
      for (let Br = 0; Br < fr.length; Br++)
        br |= fr[Br] ^ lr[Br];
      return br === 0;
    }
    class Se {
    }
    s.Hash = Se;
    const Ne = /* @__NO_SIDE_EFFECTS__ */ (fr, lr) => {
      function br(Br, ...Fr) {
        if (t(Br), !s.isLE)
          throw new Error("Non little-endian hardware is not yet supported");
        if (fr.nonceLength !== void 0) {
          const wr = Fr[0];
          if (!wr)
            throw new Error("nonce / iv required");
          fr.varSizeNonce ? t(wr) : t(wr, fr.nonceLength);
        }
        const Gr = fr.tagLength;
        Gr && Fr[1] !== void 0 && t(Fr[1]);
        const qr = lr(Br, ...Fr), Hr = (wr, yr) => {
          if (yr !== void 0) {
            if (wr !== 2)
              throw new Error("cipher output not supported");
            t(yr);
          }
        };
        let un = !1;
        return {
          encrypt(wr, yr) {
            if (un)
              throw new Error("cannot encrypt() twice with same key + nonce");
            return un = !0, t(wr), Hr(qr.encrypt.length, yr), qr.encrypt(wr, yr);
          },
          decrypt(wr, yr) {
            if (t(wr), Gr && wr.length < Gr)
              throw new Error("invalid ciphertext length: smaller than tagLength=" + Gr);
            return Hr(qr.decrypt.length, yr), qr.decrypt(wr, yr);
          }
        };
      }
      return Object.assign(br, fr), br;
    };
    s.wrapCipher = Ne;
    function rr(fr, lr, br = !0) {
      if (lr === void 0)
        return new Uint8Array(fr);
      if (lr.length !== fr)
        throw new Error("invalid output length, expected " + fr + ", got: " + lr.length);
      if (br && !sr(lr))
        throw new Error("invalid output, must be aligned");
      return lr;
    }
    function er(fr, lr, br, Br) {
      if (typeof fr.setBigUint64 == "function")
        return fr.setBigUint64(lr, br, Br);
      const Fr = BigInt(32), Gr = BigInt(4294967295), qr = Number(br >> Fr & Gr), Hr = Number(br & Gr), un = Br ? 4 : 0, Dr = Br ? 0 : 4;
      fr.setUint32(lr + un, qr, Br), fr.setUint32(lr + Dr, Hr, Br);
    }
    function ir(fr, lr, br) {
      u(br);
      const Br = new Uint8Array(16), Fr = Q(Br);
      return er(Fr, 0, BigInt(lr), br), er(Fr, 8, BigInt(fr), br), Br;
    }
    function sr(fr) {
      return fr.byteOffset % 4 === 0;
    }
    function nr(fr) {
      return Uint8Array.from(fr);
    }
  }(utils$3)), utils$3;
}
var hasRequired_arx;
function require_arx() {
  if (hasRequired_arx) return _arx;
  hasRequired_arx = 1, Object.defineProperty(_arx, "__esModule", { value: !0 }), _arx.rotl = m, _arx.createCipher = x;
  const s = /* @__PURE__ */ requireUtils$2(), A = (M) => Uint8Array.from(M.split("").map((F) => F.charCodeAt(0))), u = A("expand 16-byte k"), p = A("expand 32-byte k"), t = (0, s.u32)(u), l = (0, s.u32)(p);
  function m(M, F) {
    return M << F | M >>> 32 - F;
  }
  function b(M) {
    return M.byteOffset % 4 === 0;
  }
  const k = 64, C = 16, B = 2 ** 32 - 1, Q = new Uint32Array();
  function P(M, F, le, ge, pe, Ie, be, Pe) {
    const Te = pe.length, Qe = new Uint8Array(k), xe = (0, s.u32)(Qe), Ee = b(pe) && b(Ie), He = Ee ? (0, s.u32)(pe) : Q, ve = Ee ? (0, s.u32)(Ie) : Q;
    for (let we = 0; we < Te; be++) {
      if (M(F, le, ge, xe, be, Pe), be >= B)
        throw new Error("arx: counter overflow");
      const Ce = Math.min(k, Te - we);
      if (Ee && Ce === k) {
        const Se = we / 4;
        if (we % 4 !== 0)
          throw new Error("arx: invalid block position");
        for (let Ne = 0, rr; Ne < C; Ne++)
          rr = Se + Ne, ve[rr] = He[rr] ^ xe[Ne];
        we += k;
        continue;
      }
      for (let Se = 0, Ne; Se < Ce; Se++)
        Ne = we + Se, Ie[Ne] = pe[Ne] ^ Qe[Se];
      we += Ce;
    }
  }
  function x(M, F) {
    const { allowShortKeys: le, extendNonceFn: ge, counterLength: pe, counterRight: Ie, rounds: be } = (0, s.checkOpts)({ allowShortKeys: !1, counterLength: 8, counterRight: !1, rounds: 20 }, F);
    if (typeof M != "function")
      throw new Error("core must be a function");
    return (0, s.anumber)(pe), (0, s.anumber)(be), (0, s.abool)(Ie), (0, s.abool)(le), (Pe, Te, Qe, xe, Ee = 0) => {
      (0, s.abytes)(Pe), (0, s.abytes)(Te), (0, s.abytes)(Qe);
      const He = Qe.length;
      if (xe === void 0 && (xe = new Uint8Array(He)), (0, s.abytes)(xe), (0, s.anumber)(Ee), Ee < 0 || Ee >= B)
        throw new Error("arx: counter overflow");
      if (xe.length < He)
        throw new Error(`arx: output (${xe.length}) is shorter than data (${He})`);
      const ve = [];
      let we = Pe.length, Ce, Se;
      if (we === 32)
        ve.push(Ce = (0, s.copyBytes)(Pe)), Se = l;
      else if (we === 16 && le)
        Ce = new Uint8Array(32), Ce.set(Pe), Ce.set(Pe, 16), Se = t, ve.push(Ce);
      else
        throw new Error(`arx: invalid 32-byte key, got length=${we}`);
      b(Te) || ve.push(Te = (0, s.copyBytes)(Te));
      const Ne = (0, s.u32)(Ce);
      if (ge) {
        if (Te.length !== 24)
          throw new Error("arx: extended nonce must be 24 bytes");
        ge(Se, Ne, (0, s.u32)(Te.subarray(0, 16)), Ne), Te = Te.subarray(16);
      }
      const rr = 16 - pe;
      if (rr !== Te.length)
        throw new Error(`arx: nonce must be ${rr} or 16 bytes`);
      if (rr !== 12) {
        const ir = new Uint8Array(12);
        ir.set(Te, Ie ? 0 : 12 - Te.length), Te = ir, ve.push(Te);
      }
      const er = (0, s.u32)(Te);
      return P(M, Se, Ne, er, Qe, xe, Ee, be), (0, s.clean)(...ve), xe;
    };
  }
  return _arx;
}
var _poly1305 = {}, hasRequired_poly1305;
function require_poly1305() {
  if (hasRequired_poly1305) return _poly1305;
  hasRequired_poly1305 = 1, Object.defineProperty(_poly1305, "__esModule", { value: !0 }), _poly1305.poly1305 = void 0, _poly1305.wrapConstructorWithKey = p;
  const s = /* @__PURE__ */ requireUtils$2(), A = (t, l) => t[l++] & 255 | (t[l++] & 255) << 8;
  class u {
    constructor(l) {
      this.blockLen = 16, this.outputLen = 16, this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.pos = 0, this.finished = !1, l = (0, s.toBytes)(l), (0, s.abytes)(l, 32);
      const m = A(l, 0), b = A(l, 2), k = A(l, 4), C = A(l, 6), B = A(l, 8), Q = A(l, 10), P = A(l, 12), x = A(l, 14);
      this.r[0] = m & 8191, this.r[1] = (m >>> 13 | b << 3) & 8191, this.r[2] = (b >>> 10 | k << 6) & 7939, this.r[3] = (k >>> 7 | C << 9) & 8191, this.r[4] = (C >>> 4 | B << 12) & 255, this.r[5] = B >>> 1 & 8190, this.r[6] = (B >>> 14 | Q << 2) & 8191, this.r[7] = (Q >>> 11 | P << 5) & 8065, this.r[8] = (P >>> 8 | x << 8) & 8191, this.r[9] = x >>> 5 & 127;
      for (let M = 0; M < 8; M++)
        this.pad[M] = A(l, 16 + 2 * M);
    }
    process(l, m, b = !1) {
      const k = b ? 0 : 2048, { h: C, r: B } = this, Q = B[0], P = B[1], x = B[2], M = B[3], F = B[4], le = B[5], ge = B[6], pe = B[7], Ie = B[8], be = B[9], Pe = A(l, m + 0), Te = A(l, m + 2), Qe = A(l, m + 4), xe = A(l, m + 6), Ee = A(l, m + 8), He = A(l, m + 10), ve = A(l, m + 12), we = A(l, m + 14);
      let Ce = C[0] + (Pe & 8191), Se = C[1] + ((Pe >>> 13 | Te << 3) & 8191), Ne = C[2] + ((Te >>> 10 | Qe << 6) & 8191), rr = C[3] + ((Qe >>> 7 | xe << 9) & 8191), er = C[4] + ((xe >>> 4 | Ee << 12) & 8191), ir = C[5] + (Ee >>> 1 & 8191), sr = C[6] + ((Ee >>> 14 | He << 2) & 8191), nr = C[7] + ((He >>> 11 | ve << 5) & 8191), fr = C[8] + ((ve >>> 8 | we << 8) & 8191), lr = C[9] + (we >>> 5 | k), br = 0, Br = br + Ce * Q + Se * (5 * be) + Ne * (5 * Ie) + rr * (5 * pe) + er * (5 * ge);
      br = Br >>> 13, Br &= 8191, Br += ir * (5 * le) + sr * (5 * F) + nr * (5 * M) + fr * (5 * x) + lr * (5 * P), br += Br >>> 13, Br &= 8191;
      let Fr = br + Ce * P + Se * Q + Ne * (5 * be) + rr * (5 * Ie) + er * (5 * pe);
      br = Fr >>> 13, Fr &= 8191, Fr += ir * (5 * ge) + sr * (5 * le) + nr * (5 * F) + fr * (5 * M) + lr * (5 * x), br += Fr >>> 13, Fr &= 8191;
      let Gr = br + Ce * x + Se * P + Ne * Q + rr * (5 * be) + er * (5 * Ie);
      br = Gr >>> 13, Gr &= 8191, Gr += ir * (5 * pe) + sr * (5 * ge) + nr * (5 * le) + fr * (5 * F) + lr * (5 * M), br += Gr >>> 13, Gr &= 8191;
      let qr = br + Ce * M + Se * x + Ne * P + rr * Q + er * (5 * be);
      br = qr >>> 13, qr &= 8191, qr += ir * (5 * Ie) + sr * (5 * pe) + nr * (5 * ge) + fr * (5 * le) + lr * (5 * F), br += qr >>> 13, qr &= 8191;
      let Hr = br + Ce * F + Se * M + Ne * x + rr * P + er * Q;
      br = Hr >>> 13, Hr &= 8191, Hr += ir * (5 * be) + sr * (5 * Ie) + nr * (5 * pe) + fr * (5 * ge) + lr * (5 * le), br += Hr >>> 13, Hr &= 8191;
      let un = br + Ce * le + Se * F + Ne * M + rr * x + er * P;
      br = un >>> 13, un &= 8191, un += ir * Q + sr * (5 * be) + nr * (5 * Ie) + fr * (5 * pe) + lr * (5 * ge), br += un >>> 13, un &= 8191;
      let Dr = br + Ce * ge + Se * le + Ne * F + rr * M + er * x;
      br = Dr >>> 13, Dr &= 8191, Dr += ir * P + sr * Q + nr * (5 * be) + fr * (5 * Ie) + lr * (5 * pe), br += Dr >>> 13, Dr &= 8191;
      let wr = br + Ce * pe + Se * ge + Ne * le + rr * F + er * M;
      br = wr >>> 13, wr &= 8191, wr += ir * x + sr * P + nr * Q + fr * (5 * be) + lr * (5 * Ie), br += wr >>> 13, wr &= 8191;
      let yr = br + Ce * Ie + Se * pe + Ne * ge + rr * le + er * F;
      br = yr >>> 13, yr &= 8191, yr += ir * M + sr * x + nr * P + fr * Q + lr * (5 * be), br += yr >>> 13, yr &= 8191;
      let Qr = br + Ce * be + Se * Ie + Ne * pe + rr * ge + er * le;
      br = Qr >>> 13, Qr &= 8191, Qr += ir * F + sr * M + nr * x + fr * P + lr * Q, br += Qr >>> 13, Qr &= 8191, br = (br << 2) + br | 0, br = br + Br | 0, Br = br & 8191, br = br >>> 13, Fr += br, C[0] = Br, C[1] = Fr, C[2] = Gr, C[3] = qr, C[4] = Hr, C[5] = un, C[6] = Dr, C[7] = wr, C[8] = yr, C[9] = Qr;
    }
    finalize() {
      const { h: l, pad: m } = this, b = new Uint16Array(10);
      let k = l[1] >>> 13;
      l[1] &= 8191;
      for (let Q = 2; Q < 10; Q++)
        l[Q] += k, k = l[Q] >>> 13, l[Q] &= 8191;
      l[0] += k * 5, k = l[0] >>> 13, l[0] &= 8191, l[1] += k, k = l[1] >>> 13, l[1] &= 8191, l[2] += k, b[0] = l[0] + 5, k = b[0] >>> 13, b[0] &= 8191;
      for (let Q = 1; Q < 10; Q++)
        b[Q] = l[Q] + k, k = b[Q] >>> 13, b[Q] &= 8191;
      b[9] -= 8192;
      let C = (k ^ 1) - 1;
      for (let Q = 0; Q < 10; Q++)
        b[Q] &= C;
      C = ~C;
      for (let Q = 0; Q < 10; Q++)
        l[Q] = l[Q] & C | b[Q];
      l[0] = (l[0] | l[1] << 13) & 65535, l[1] = (l[1] >>> 3 | l[2] << 10) & 65535, l[2] = (l[2] >>> 6 | l[3] << 7) & 65535, l[3] = (l[3] >>> 9 | l[4] << 4) & 65535, l[4] = (l[4] >>> 12 | l[5] << 1 | l[6] << 14) & 65535, l[5] = (l[6] >>> 2 | l[7] << 11) & 65535, l[6] = (l[7] >>> 5 | l[8] << 8) & 65535, l[7] = (l[8] >>> 8 | l[9] << 5) & 65535;
      let B = l[0] + m[0];
      l[0] = B & 65535;
      for (let Q = 1; Q < 8; Q++)
        B = (l[Q] + m[Q] | 0) + (B >>> 16) | 0, l[Q] = B & 65535;
      (0, s.clean)(b);
    }
    update(l) {
      (0, s.aexists)(this), l = (0, s.toBytes)(l), (0, s.abytes)(l);
      const { buffer: m, blockLen: b } = this, k = l.length;
      for (let C = 0; C < k; ) {
        const B = Math.min(b - this.pos, k - C);
        if (B === b) {
          for (; b <= k - C; C += b)
            this.process(l, C);
          continue;
        }
        m.set(l.subarray(C, C + B), this.pos), this.pos += B, C += B, this.pos === b && (this.process(m, 0, !1), this.pos = 0);
      }
      return this;
    }
    destroy() {
      (0, s.clean)(this.h, this.r, this.buffer, this.pad);
    }
    digestInto(l) {
      (0, s.aexists)(this), (0, s.aoutput)(l, this), this.finished = !0;
      const { buffer: m, h: b } = this;
      let { pos: k } = this;
      if (k) {
        for (m[k++] = 1; k < 16; k++)
          m[k] = 0;
        this.process(m, 0, !0);
      }
      this.finalize();
      let C = 0;
      for (let B = 0; B < 8; B++)
        l[C++] = b[B] >>> 0, l[C++] = b[B] >>> 8;
      return l;
    }
    digest() {
      const { buffer: l, outputLen: m } = this;
      this.digestInto(l);
      const b = l.slice(0, m);
      return this.destroy(), b;
    }
  }
  function p(t) {
    const l = (b, k) => t(k).update((0, s.toBytes)(b)).digest(), m = t(new Uint8Array(32));
    return l.outputLen = m.outputLen, l.blockLen = m.blockLen, l.create = (b) => t(b), l;
  }
  return _poly1305.poly1305 = p((t) => new u(t)), _poly1305;
}
var hasRequiredChacha;
function requireChacha() {
  return hasRequiredChacha || (hasRequiredChacha = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.xchacha20poly1305 = s.chacha20poly1305 = s._poly1305_aead = s.chacha12 = s.chacha8 = s.xchacha20 = s.chacha20 = s.chacha20orig = void 0, s.hchacha = l;
    const A = /* @__PURE__ */ require_arx(), u = /* @__PURE__ */ require_poly1305(), p = /* @__PURE__ */ requireUtils$2();
    function t(Q, P, x, M, F, le = 20) {
      let ge = Q[0], pe = Q[1], Ie = Q[2], be = Q[3], Pe = P[0], Te = P[1], Qe = P[2], xe = P[3], Ee = P[4], He = P[5], ve = P[6], we = P[7], Ce = F, Se = x[0], Ne = x[1], rr = x[2], er = ge, ir = pe, sr = Ie, nr = be, fr = Pe, lr = Te, br = Qe, Br = xe, Fr = Ee, Gr = He, qr = ve, Hr = we, un = Ce, Dr = Se, wr = Ne, yr = rr;
      for (let _r = 0; _r < le; _r += 2)
        er = er + fr | 0, un = (0, A.rotl)(un ^ er, 16), Fr = Fr + un | 0, fr = (0, A.rotl)(fr ^ Fr, 12), er = er + fr | 0, un = (0, A.rotl)(un ^ er, 8), Fr = Fr + un | 0, fr = (0, A.rotl)(fr ^ Fr, 7), ir = ir + lr | 0, Dr = (0, A.rotl)(Dr ^ ir, 16), Gr = Gr + Dr | 0, lr = (0, A.rotl)(lr ^ Gr, 12), ir = ir + lr | 0, Dr = (0, A.rotl)(Dr ^ ir, 8), Gr = Gr + Dr | 0, lr = (0, A.rotl)(lr ^ Gr, 7), sr = sr + br | 0, wr = (0, A.rotl)(wr ^ sr, 16), qr = qr + wr | 0, br = (0, A.rotl)(br ^ qr, 12), sr = sr + br | 0, wr = (0, A.rotl)(wr ^ sr, 8), qr = qr + wr | 0, br = (0, A.rotl)(br ^ qr, 7), nr = nr + Br | 0, yr = (0, A.rotl)(yr ^ nr, 16), Hr = Hr + yr | 0, Br = (0, A.rotl)(Br ^ Hr, 12), nr = nr + Br | 0, yr = (0, A.rotl)(yr ^ nr, 8), Hr = Hr + yr | 0, Br = (0, A.rotl)(Br ^ Hr, 7), er = er + lr | 0, yr = (0, A.rotl)(yr ^ er, 16), qr = qr + yr | 0, lr = (0, A.rotl)(lr ^ qr, 12), er = er + lr | 0, yr = (0, A.rotl)(yr ^ er, 8), qr = qr + yr | 0, lr = (0, A.rotl)(lr ^ qr, 7), ir = ir + br | 0, un = (0, A.rotl)(un ^ ir, 16), Hr = Hr + un | 0, br = (0, A.rotl)(br ^ Hr, 12), ir = ir + br | 0, un = (0, A.rotl)(un ^ ir, 8), Hr = Hr + un | 0, br = (0, A.rotl)(br ^ Hr, 7), sr = sr + Br | 0, Dr = (0, A.rotl)(Dr ^ sr, 16), Fr = Fr + Dr | 0, Br = (0, A.rotl)(Br ^ Fr, 12), sr = sr + Br | 0, Dr = (0, A.rotl)(Dr ^ sr, 8), Fr = Fr + Dr | 0, Br = (0, A.rotl)(Br ^ Fr, 7), nr = nr + fr | 0, wr = (0, A.rotl)(wr ^ nr, 16), Gr = Gr + wr | 0, fr = (0, A.rotl)(fr ^ Gr, 12), nr = nr + fr | 0, wr = (0, A.rotl)(wr ^ nr, 8), Gr = Gr + wr | 0, fr = (0, A.rotl)(fr ^ Gr, 7);
      let Qr = 0;
      M[Qr++] = ge + er | 0, M[Qr++] = pe + ir | 0, M[Qr++] = Ie + sr | 0, M[Qr++] = be + nr | 0, M[Qr++] = Pe + fr | 0, M[Qr++] = Te + lr | 0, M[Qr++] = Qe + br | 0, M[Qr++] = xe + Br | 0, M[Qr++] = Ee + Fr | 0, M[Qr++] = He + Gr | 0, M[Qr++] = ve + qr | 0, M[Qr++] = we + Hr | 0, M[Qr++] = Ce + un | 0, M[Qr++] = Se + Dr | 0, M[Qr++] = Ne + wr | 0, M[Qr++] = rr + yr | 0;
    }
    function l(Q, P, x, M) {
      let F = Q[0], le = Q[1], ge = Q[2], pe = Q[3], Ie = P[0], be = P[1], Pe = P[2], Te = P[3], Qe = P[4], xe = P[5], Ee = P[6], He = P[7], ve = x[0], we = x[1], Ce = x[2], Se = x[3];
      for (let rr = 0; rr < 20; rr += 2)
        F = F + Ie | 0, ve = (0, A.rotl)(ve ^ F, 16), Qe = Qe + ve | 0, Ie = (0, A.rotl)(Ie ^ Qe, 12), F = F + Ie | 0, ve = (0, A.rotl)(ve ^ F, 8), Qe = Qe + ve | 0, Ie = (0, A.rotl)(Ie ^ Qe, 7), le = le + be | 0, we = (0, A.rotl)(we ^ le, 16), xe = xe + we | 0, be = (0, A.rotl)(be ^ xe, 12), le = le + be | 0, we = (0, A.rotl)(we ^ le, 8), xe = xe + we | 0, be = (0, A.rotl)(be ^ xe, 7), ge = ge + Pe | 0, Ce = (0, A.rotl)(Ce ^ ge, 16), Ee = Ee + Ce | 0, Pe = (0, A.rotl)(Pe ^ Ee, 12), ge = ge + Pe | 0, Ce = (0, A.rotl)(Ce ^ ge, 8), Ee = Ee + Ce | 0, Pe = (0, A.rotl)(Pe ^ Ee, 7), pe = pe + Te | 0, Se = (0, A.rotl)(Se ^ pe, 16), He = He + Se | 0, Te = (0, A.rotl)(Te ^ He, 12), pe = pe + Te | 0, Se = (0, A.rotl)(Se ^ pe, 8), He = He + Se | 0, Te = (0, A.rotl)(Te ^ He, 7), F = F + be | 0, Se = (0, A.rotl)(Se ^ F, 16), Ee = Ee + Se | 0, be = (0, A.rotl)(be ^ Ee, 12), F = F + be | 0, Se = (0, A.rotl)(Se ^ F, 8), Ee = Ee + Se | 0, be = (0, A.rotl)(be ^ Ee, 7), le = le + Pe | 0, ve = (0, A.rotl)(ve ^ le, 16), He = He + ve | 0, Pe = (0, A.rotl)(Pe ^ He, 12), le = le + Pe | 0, ve = (0, A.rotl)(ve ^ le, 8), He = He + ve | 0, Pe = (0, A.rotl)(Pe ^ He, 7), ge = ge + Te | 0, we = (0, A.rotl)(we ^ ge, 16), Qe = Qe + we | 0, Te = (0, A.rotl)(Te ^ Qe, 12), ge = ge + Te | 0, we = (0, A.rotl)(we ^ ge, 8), Qe = Qe + we | 0, Te = (0, A.rotl)(Te ^ Qe, 7), pe = pe + Ie | 0, Ce = (0, A.rotl)(Ce ^ pe, 16), xe = xe + Ce | 0, Ie = (0, A.rotl)(Ie ^ xe, 12), pe = pe + Ie | 0, Ce = (0, A.rotl)(Ce ^ pe, 8), xe = xe + Ce | 0, Ie = (0, A.rotl)(Ie ^ xe, 7);
      let Ne = 0;
      M[Ne++] = F, M[Ne++] = le, M[Ne++] = ge, M[Ne++] = pe, M[Ne++] = ve, M[Ne++] = we, M[Ne++] = Ce, M[Ne++] = Se;
    }
    s.chacha20orig = (0, A.createCipher)(t, {
      counterRight: !1,
      counterLength: 8,
      allowShortKeys: !0
    }), s.chacha20 = (0, A.createCipher)(t, {
      counterRight: !1,
      counterLength: 4,
      allowShortKeys: !1
    }), s.xchacha20 = (0, A.createCipher)(t, {
      counterRight: !1,
      counterLength: 8,
      extendNonceFn: l,
      allowShortKeys: !1
    }), s.chacha8 = (0, A.createCipher)(t, {
      counterRight: !1,
      counterLength: 4,
      rounds: 8
    }), s.chacha12 = (0, A.createCipher)(t, {
      counterRight: !1,
      counterLength: 4,
      rounds: 12
    });
    const m = /* @__PURE__ */ new Uint8Array(16), b = (Q, P) => {
      Q.update(P);
      const x = P.length % 16;
      x && Q.update(m.subarray(x));
    }, k = /* @__PURE__ */ new Uint8Array(32);
    function C(Q, P, x, M, F) {
      const le = Q(P, x, k), ge = u.poly1305.create(le);
      F && b(ge, F), b(ge, M);
      const pe = (0, p.u64Lengths)(M.length, F ? F.length : 0, !0);
      ge.update(pe);
      const Ie = ge.digest();
      return (0, p.clean)(le, pe), Ie;
    }
    const B = (Q) => (P, x, M) => ({
      encrypt(le, ge) {
        const pe = le.length;
        ge = (0, p.getOutput)(pe + 16, ge, !1), ge.set(le);
        const Ie = ge.subarray(0, -16);
        Q(P, x, Ie, Ie, 1);
        const be = C(Q, P, x, Ie, M);
        return ge.set(be, pe), (0, p.clean)(be), ge;
      },
      decrypt(le, ge) {
        ge = (0, p.getOutput)(le.length - 16, ge, !1);
        const pe = le.subarray(0, -16), Ie = le.subarray(-16), be = C(Q, P, x, pe, M);
        if (!(0, p.equalBytes)(Ie, be))
          throw new Error("invalid tag");
        return ge.set(le.subarray(0, -16)), Q(P, x, ge, ge, 1), (0, p.clean)(be), ge;
      }
    });
    s._poly1305_aead = B, s.chacha20poly1305 = (0, p.wrapCipher)({ blockSize: 64, nonceLength: 12, tagLength: 16 }, (0, s._poly1305_aead)(s.chacha20)), s.xchacha20poly1305 = (0, p.wrapCipher)({ blockSize: 64, nonceLength: 24, tagLength: 16 }, (0, s._poly1305_aead)(s.xchacha20));
  }(chacha)), chacha;
}
var ed25519 = {}, edwards = {}, hasRequiredEdwards;
function requireEdwards() {
  if (hasRequiredEdwards) return edwards;
  hasRequiredEdwards = 1, Object.defineProperty(edwards, "__esModule", { value: !0 }), edwards.PrimeEdwardsPoint = void 0, edwards.edwards = k, edwards.eddsa = B, edwards.twistedEdwards = x;
  const s = /* @__PURE__ */ requireUtils$h(), A = /* @__PURE__ */ requireCurve$2(), u = /* @__PURE__ */ requireModular$1(), p = BigInt(0), t = BigInt(1), l = BigInt(2), m = BigInt(8);
  function b(M, F, le, ge) {
    const pe = M.sqr(le), Ie = M.sqr(ge), be = M.add(M.mul(F.a, pe), Ie), Pe = M.add(M.ONE, M.mul(F.d, M.mul(pe, Ie)));
    return M.eql(be, Pe);
  }
  function k(M, F = {}) {
    const le = (0, A._createCurveFields)("edwards", M, F, F.FpFnLE), { Fp: ge, Fn: pe } = le;
    let Ie = le.CURVE;
    const { h: be } = Ie;
    (0, s._validateObject)(F, {}, { uvRatio: "function" });
    const Pe = l << BigInt(pe.BYTES * 8) - t, Te = (Se) => ge.create(Se), Qe = F.uvRatio || ((Se, Ne) => {
      try {
        return { isValid: !0, value: ge.sqrt(ge.div(Se, Ne)) };
      } catch {
        return { isValid: !1, value: p };
      }
    });
    if (!b(ge, Ie, Ie.Gx, Ie.Gy))
      throw new Error("bad curve params: generator point");
    function xe(Se, Ne, rr = !1) {
      const er = rr ? t : p;
      return (0, s.aInRange)("coordinate " + Se, Ne, er, Pe), Ne;
    }
    function Ee(Se) {
      if (!(Se instanceof we))
        throw new Error("ExtendedPoint expected");
    }
    const He = (0, s.memoized)((Se, Ne) => {
      const { X: rr, Y: er, Z: ir } = Se, sr = Se.is0();
      Ne == null && (Ne = sr ? m : ge.inv(ir));
      const nr = Te(rr * Ne), fr = Te(er * Ne), lr = ge.mul(ir, Ne);
      if (sr)
        return { x: p, y: t };
      if (lr !== t)
        throw new Error("invZ was invalid");
      return { x: nr, y: fr };
    }), ve = (0, s.memoized)((Se) => {
      const { a: Ne, d: rr } = Ie;
      if (Se.is0())
        throw new Error("bad point: ZERO");
      const { X: er, Y: ir, Z: sr, T: nr } = Se, fr = Te(er * er), lr = Te(ir * ir), br = Te(sr * sr), Br = Te(br * br), Fr = Te(fr * Ne), Gr = Te(br * Te(Fr + lr)), qr = Te(Br + Te(rr * Te(fr * lr)));
      if (Gr !== qr)
        throw new Error("bad point: equation left != right (1)");
      const Hr = Te(er * ir), un = Te(sr * nr);
      if (Hr !== un)
        throw new Error("bad point: equation left != right (2)");
      return !0;
    });
    class we {
      constructor(Ne, rr, er, ir) {
        this.X = xe("x", Ne), this.Y = xe("y", rr), this.Z = xe("z", er, !0), this.T = xe("t", ir), Object.freeze(this);
      }
      static CURVE() {
        return Ie;
      }
      static fromAffine(Ne) {
        if (Ne instanceof we)
          throw new Error("extended point not allowed");
        const { x: rr, y: er } = Ne || {};
        return xe("x", rr), xe("y", er), new we(rr, er, t, Te(rr * er));
      }
      // Uses algo from RFC8032 5.1.3.
      static fromBytes(Ne, rr = !1) {
        const er = ge.BYTES, { a: ir, d: sr } = Ie;
        Ne = (0, s.copyBytes)((0, s._abytes2)(Ne, er, "point")), (0, s._abool2)(rr, "zip215");
        const nr = (0, s.copyBytes)(Ne), fr = Ne[er - 1];
        nr[er - 1] = fr & -129;
        const lr = (0, s.bytesToNumberLE)(nr), br = rr ? Pe : ge.ORDER;
        (0, s.aInRange)("point.y", lr, p, br);
        const Br = Te(lr * lr), Fr = Te(Br - t), Gr = Te(sr * Br - ir);
        let { isValid: qr, value: Hr } = Qe(Fr, Gr);
        if (!qr)
          throw new Error("bad point: invalid y coordinate");
        const un = (Hr & t) === t, Dr = (fr & 128) !== 0;
        if (!rr && Hr === p && Dr)
          throw new Error("bad point: x=0 and x_0=1");
        return Dr !== un && (Hr = Te(-Hr)), we.fromAffine({ x: Hr, y: lr });
      }
      static fromHex(Ne, rr = !1) {
        return we.fromBytes((0, s.ensureBytes)("point", Ne), rr);
      }
      get x() {
        return this.toAffine().x;
      }
      get y() {
        return this.toAffine().y;
      }
      precompute(Ne = 8, rr = !0) {
        return Ce.createCache(this, Ne), rr || this.multiply(l), this;
      }
      // Useful in fromAffine() - not for fromBytes(), which always created valid points.
      assertValidity() {
        ve(this);
      }
      // Compare one point to another.
      equals(Ne) {
        Ee(Ne);
        const { X: rr, Y: er, Z: ir } = this, { X: sr, Y: nr, Z: fr } = Ne, lr = Te(rr * fr), br = Te(sr * ir), Br = Te(er * fr), Fr = Te(nr * ir);
        return lr === br && Br === Fr;
      }
      is0() {
        return this.equals(we.ZERO);
      }
      negate() {
        return new we(Te(-this.X), this.Y, this.Z, Te(-this.T));
      }
      // Fast algo for doubling Extended Point.
      // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
      // Cost: 4M + 4S + 1*a + 6add + 1*2.
      double() {
        const { a: Ne } = Ie, { X: rr, Y: er, Z: ir } = this, sr = Te(rr * rr), nr = Te(er * er), fr = Te(l * Te(ir * ir)), lr = Te(Ne * sr), br = rr + er, Br = Te(Te(br * br) - sr - nr), Fr = lr + nr, Gr = Fr - fr, qr = lr - nr, Hr = Te(Br * Gr), un = Te(Fr * qr), Dr = Te(Br * qr), wr = Te(Gr * Fr);
        return new we(Hr, un, wr, Dr);
      }
      // Fast algo for adding 2 Extended Points.
      // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
      // Cost: 9M + 1*a + 1*d + 7add.
      add(Ne) {
        Ee(Ne);
        const { a: rr, d: er } = Ie, { X: ir, Y: sr, Z: nr, T: fr } = this, { X: lr, Y: br, Z: Br, T: Fr } = Ne, Gr = Te(ir * lr), qr = Te(sr * br), Hr = Te(fr * er * Fr), un = Te(nr * Br), Dr = Te((ir + sr) * (lr + br) - Gr - qr), wr = un - Hr, yr = un + Hr, Qr = Te(qr - rr * Gr), _r = Te(Dr * wr), Jr = Te(yr * Qr), fn = Te(Dr * Qr), jr = Te(wr * yr);
        return new we(_r, Jr, jr, fn);
      }
      subtract(Ne) {
        return this.add(Ne.negate());
      }
      // Constant-time multiplication.
      multiply(Ne) {
        if (!pe.isValidNot0(Ne))
          throw new Error("invalid scalar: expected 1 <= sc < curve.n");
        const { p: rr, f: er } = Ce.cached(this, Ne, (ir) => (0, A.normalizeZ)(we, ir));
        return (0, A.normalizeZ)(we, [rr, er])[0];
      }
      // Non-constant-time multiplication. Uses double-and-add algorithm.
      // It's faster, but should only be used when you don't care about
      // an exposed private key e.g. sig verification.
      // Does NOT allow scalars higher than CURVE.n.
      // Accepts optional accumulator to merge with multiply (important for sparse scalars)
      multiplyUnsafe(Ne, rr = we.ZERO) {
        if (!pe.isValid(Ne))
          throw new Error("invalid scalar: expected 0 <= sc < curve.n");
        return Ne === p ? we.ZERO : this.is0() || Ne === t ? this : Ce.unsafe(this, Ne, (er) => (0, A.normalizeZ)(we, er), rr);
      }
      // Checks if point is of small order.
      // If you add something to small order point, you will have "dirty"
      // point with torsion component.
      // Multiplies point by cofactor and checks if the result is 0.
      isSmallOrder() {
        return this.multiplyUnsafe(be).is0();
      }
      // Multiplies point by curve order and checks if the result is 0.
      // Returns `false` is the point is dirty.
      isTorsionFree() {
        return Ce.unsafe(this, Ie.n).is0();
      }
      // Converts Extended point to default (x, y) coordinates.
      // Can accept precomputed Z^-1 - for example, from invertBatch.
      toAffine(Ne) {
        return He(this, Ne);
      }
      clearCofactor() {
        return be === t ? this : this.multiplyUnsafe(be);
      }
      toBytes() {
        const { x: Ne, y: rr } = this.toAffine(), er = ge.toBytes(rr);
        return er[er.length - 1] |= Ne & t ? 128 : 0, er;
      }
      toHex() {
        return (0, s.bytesToHex)(this.toBytes());
      }
      toString() {
        return `<Point ${this.is0() ? "ZERO" : this.toHex()}>`;
      }
      // TODO: remove
      get ex() {
        return this.X;
      }
      get ey() {
        return this.Y;
      }
      get ez() {
        return this.Z;
      }
      get et() {
        return this.T;
      }
      static normalizeZ(Ne) {
        return (0, A.normalizeZ)(we, Ne);
      }
      static msm(Ne, rr) {
        return (0, A.pippenger)(we, pe, Ne, rr);
      }
      _setWindowSize(Ne) {
        this.precompute(Ne);
      }
      toRawBytes() {
        return this.toBytes();
      }
    }
    we.BASE = new we(Ie.Gx, Ie.Gy, t, Te(Ie.Gx * Ie.Gy)), we.ZERO = new we(p, t, t, p), we.Fp = ge, we.Fn = pe;
    const Ce = new A.wNAF(we, pe.BITS);
    return we.BASE.precompute(8), we;
  }
  class C {
    constructor(F) {
      this.ep = F;
    }
    // Static methods that must be implemented by subclasses
    static fromBytes(F) {
      (0, s.notImplemented)();
    }
    static fromHex(F) {
      (0, s.notImplemented)();
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    // Common implementations
    clearCofactor() {
      return this;
    }
    assertValidity() {
      this.ep.assertValidity();
    }
    toAffine(F) {
      return this.ep.toAffine(F);
    }
    toHex() {
      return (0, s.bytesToHex)(this.toBytes());
    }
    toString() {
      return this.toHex();
    }
    isTorsionFree() {
      return !0;
    }
    isSmallOrder() {
      return !1;
    }
    add(F) {
      return this.assertSame(F), this.init(this.ep.add(F.ep));
    }
    subtract(F) {
      return this.assertSame(F), this.init(this.ep.subtract(F.ep));
    }
    multiply(F) {
      return this.init(this.ep.multiply(F));
    }
    multiplyUnsafe(F) {
      return this.init(this.ep.multiplyUnsafe(F));
    }
    double() {
      return this.init(this.ep.double());
    }
    negate() {
      return this.init(this.ep.negate());
    }
    precompute(F, le) {
      return this.init(this.ep.precompute(F, le));
    }
    /** @deprecated use `toBytes` */
    toRawBytes() {
      return this.toBytes();
    }
  }
  edwards.PrimeEdwardsPoint = C;
  function B(M, F, le = {}) {
    if (typeof F != "function")
      throw new Error('"hash" function param is required');
    (0, s._validateObject)(le, {}, {
      adjustScalarBytes: "function",
      randomBytes: "function",
      domain: "function",
      prehash: "function",
      mapToCurve: "function"
    });
    const { prehash: ge } = le, { BASE: pe, Fp: Ie, Fn: be } = M, Pe = le.randomBytes || s.randomBytes, Te = le.adjustScalarBytes || ((br) => br), Qe = le.domain || ((br, Br, Fr) => {
      if ((0, s._abool2)(Fr, "phflag"), Br.length || Fr)
        throw new Error("Contexts/pre-hash are not supported");
      return br;
    });
    function xe(br) {
      return be.create((0, s.bytesToNumberLE)(br));
    }
    function Ee(br) {
      const Br = er.secretKey;
      br = (0, s.ensureBytes)("private key", br, Br);
      const Fr = (0, s.ensureBytes)("hashed private key", F(br), 2 * Br), Gr = Te(Fr.slice(0, Br)), qr = Fr.slice(Br, 2 * Br), Hr = xe(Gr);
      return { head: Gr, prefix: qr, scalar: Hr };
    }
    function He(br) {
      const { head: Br, prefix: Fr, scalar: Gr } = Ee(br), qr = pe.multiply(Gr), Hr = qr.toBytes();
      return { head: Br, prefix: Fr, scalar: Gr, point: qr, pointBytes: Hr };
    }
    function ve(br) {
      return He(br).pointBytes;
    }
    function we(br = Uint8Array.of(), ...Br) {
      const Fr = (0, s.concatBytes)(...Br);
      return xe(F(Qe(Fr, (0, s.ensureBytes)("context", br), !!ge)));
    }
    function Ce(br, Br, Fr = {}) {
      br = (0, s.ensureBytes)("message", br), ge && (br = ge(br));
      const { prefix: Gr, scalar: qr, pointBytes: Hr } = He(Br), un = we(Fr.context, Gr, br), Dr = pe.multiply(un).toBytes(), wr = we(Fr.context, Dr, Hr, br), yr = be.create(un + wr * qr);
      if (!be.isValid(yr))
        throw new Error("sign failed: invalid s");
      const Qr = (0, s.concatBytes)(Dr, be.toBytes(yr));
      return (0, s._abytes2)(Qr, er.signature, "result");
    }
    const Se = { zip215: !0 };
    function Ne(br, Br, Fr, Gr = Se) {
      const { context: qr, zip215: Hr } = Gr, un = er.signature;
      br = (0, s.ensureBytes)("signature", br, un), Br = (0, s.ensureBytes)("message", Br), Fr = (0, s.ensureBytes)("publicKey", Fr, er.publicKey), Hr !== void 0 && (0, s._abool2)(Hr, "zip215"), ge && (Br = ge(Br));
      const Dr = un / 2, wr = br.subarray(0, Dr), yr = (0, s.bytesToNumberLE)(br.subarray(Dr, un));
      let Qr, _r, Jr;
      try {
        Qr = M.fromBytes(Fr, Hr), _r = M.fromBytes(wr, Hr), Jr = pe.multiplyUnsafe(yr);
      } catch {
        return !1;
      }
      if (!Hr && Qr.isSmallOrder())
        return !1;
      const fn = we(qr, _r.toBytes(), Qr.toBytes(), Br);
      return _r.add(Qr.multiplyUnsafe(fn)).subtract(Jr).clearCofactor().is0();
    }
    const rr = Ie.BYTES, er = {
      secretKey: rr,
      publicKey: rr,
      signature: 2 * rr,
      seed: rr
    };
    function ir(br = Pe(er.seed)) {
      return (0, s._abytes2)(br, er.seed, "seed");
    }
    function sr(br) {
      const Br = lr.randomSecretKey(br);
      return { secretKey: Br, publicKey: ve(Br) };
    }
    function nr(br) {
      return (0, s.isBytes)(br) && br.length === be.BYTES;
    }
    function fr(br, Br) {
      try {
        return !!M.fromBytes(br, Br);
      } catch {
        return !1;
      }
    }
    const lr = {
      getExtendedPublicKey: He,
      randomSecretKey: ir,
      isValidSecretKey: nr,
      isValidPublicKey: fr,
      /**
       * Converts ed public key to x public key. Uses formula:
       * - ed25519:
       *   - `(u, v) = ((1+y)/(1-y), sqrt(-486664)*u/x)`
       *   - `(x, y) = (sqrt(-486664)*u/v, (u-1)/(u+1))`
       * - ed448:
       *   - `(u, v) = ((y-1)/(y+1), sqrt(156324)*u/x)`
       *   - `(x, y) = (sqrt(156324)*u/v, (1+u)/(1-u))`
       */
      toMontgomery(br) {
        const { y: Br } = M.fromBytes(br), Fr = er.publicKey, Gr = Fr === 32;
        if (!Gr && Fr !== 57)
          throw new Error("only defined for 25519 and 448");
        const qr = Gr ? Ie.div(t + Br, t - Br) : Ie.div(Br - t, Br + t);
        return Ie.toBytes(qr);
      },
      toMontgomerySecret(br) {
        const Br = er.secretKey;
        (0, s._abytes2)(br, Br);
        const Fr = F(br.subarray(0, Br));
        return Te(Fr).subarray(0, Br);
      },
      /** @deprecated */
      randomPrivateKey: ir,
      /** @deprecated */
      precompute(br = 8, Br = M.BASE) {
        return Br.precompute(br, !1);
      }
    };
    return Object.freeze({
      keygen: sr,
      getPublicKey: ve,
      sign: Ce,
      verify: Ne,
      utils: lr,
      Point: M,
      lengths: er
    });
  }
  function Q(M) {
    const F = {
      a: M.a,
      d: M.d,
      p: M.Fp.ORDER,
      n: M.n,
      h: M.h,
      Gx: M.Gx,
      Gy: M.Gy
    }, le = M.Fp, ge = (0, u.Field)(F.n, M.nBitLength, !0), pe = { Fp: le, Fn: ge, uvRatio: M.uvRatio }, Ie = {
      randomBytes: M.randomBytes,
      adjustScalarBytes: M.adjustScalarBytes,
      domain: M.domain,
      prehash: M.prehash,
      mapToCurve: M.mapToCurve
    };
    return { CURVE: F, curveOpts: pe, hash: M.hash, eddsaOpts: Ie };
  }
  function P(M, F) {
    const le = F.Point;
    return Object.assign({}, F, {
      ExtendedPoint: le,
      CURVE: M,
      nBitLength: le.Fn.BITS,
      nByteLength: le.Fn.BYTES
    });
  }
  function x(M) {
    const { CURVE: F, curveOpts: le, hash: ge, eddsaOpts: pe } = Q(M), Ie = k(F, le), be = B(Ie, ge, pe);
    return P(M, be);
  }
  return edwards;
}
var montgomery = {}, hasRequiredMontgomery;
function requireMontgomery() {
  if (hasRequiredMontgomery) return montgomery;
  hasRequiredMontgomery = 1, Object.defineProperty(montgomery, "__esModule", { value: !0 }), montgomery.montgomery = m;
  const s = /* @__PURE__ */ requireUtils$h(), A = /* @__PURE__ */ requireModular$1(), u = BigInt(0), p = BigInt(1), t = BigInt(2);
  function l(b) {
    return (0, s._validateObject)(b, {
      adjustScalarBytes: "function",
      powPminus2: "function"
    }), Object.freeze({ ...b });
  }
  function m(b) {
    const k = l(b), { P: C, type: B, adjustScalarBytes: Q, powPminus2: P, randomBytes: x } = k, M = B === "x25519";
    if (!M && B !== "x448")
      throw new Error("invalid type");
    const F = x || s.randomBytes, le = M ? 255 : 448, ge = M ? 32 : 56, pe = BigInt(M ? 9 : 5), Ie = BigInt(M ? 121665 : 39081), be = M ? t ** BigInt(254) : t ** BigInt(447), Pe = M ? BigInt(8) * t ** BigInt(251) - p : BigInt(4) * t ** BigInt(445) - p, Te = be + Pe + p, Qe = (nr) => (0, A.mod)(nr, C), xe = Ee(pe);
    function Ee(nr) {
      return (0, s.numberToBytesLE)(Qe(nr), ge);
    }
    function He(nr) {
      const fr = (0, s.ensureBytes)("u coordinate", nr, ge);
      return M && (fr[31] &= 127), Qe((0, s.bytesToNumberLE)(fr));
    }
    function ve(nr) {
      return (0, s.bytesToNumberLE)(Q((0, s.ensureBytes)("scalar", nr, ge)));
    }
    function we(nr, fr) {
      const lr = Ne(He(fr), ve(nr));
      if (lr === u)
        throw new Error("invalid private or public key received");
      return Ee(lr);
    }
    function Ce(nr) {
      return we(nr, xe);
    }
    function Se(nr, fr, lr) {
      const br = Qe(nr * (fr - lr));
      return fr = Qe(fr - br), lr = Qe(lr + br), { x_2: fr, x_3: lr };
    }
    function Ne(nr, fr) {
      (0, s.aInRange)("u", nr, u, C), (0, s.aInRange)("scalar", fr, be, Te);
      const lr = fr, br = nr;
      let Br = p, Fr = u, Gr = nr, qr = p, Hr = u;
      for (let Dr = BigInt(le - 1); Dr >= u; Dr--) {
        const wr = lr >> Dr & p;
        Hr ^= wr, { x_2: Br, x_3: Gr } = Se(Hr, Br, Gr), { x_2: Fr, x_3: qr } = Se(Hr, Fr, qr), Hr = wr;
        const yr = Br + Fr, Qr = Qe(yr * yr), _r = Br - Fr, Jr = Qe(_r * _r), fn = Qr - Jr, jr = Gr + qr, dn = Gr - qr, Tn = Qe(dn * yr), Yn = Qe(jr * _r), si = Tn + Yn, vn = Tn - Yn;
        Gr = Qe(si * si), qr = Qe(br * Qe(vn * vn)), Br = Qe(Qr * Jr), Fr = Qe(fn * (Qr + Qe(Ie * fn)));
      }
      ({ x_2: Br, x_3: Gr } = Se(Hr, Br, Gr)), { x_2: Fr, x_3: qr } = Se(Hr, Fr, qr);
      const un = P(Fr);
      return Qe(Br * un);
    }
    const rr = {
      secretKey: ge,
      publicKey: ge,
      seed: ge
    }, er = (nr = F(ge)) => ((0, s.abytes)(nr, rr.seed), nr);
    function ir(nr) {
      const fr = er(nr);
      return { secretKey: fr, publicKey: Ce(fr) };
    }
    return {
      keygen: ir,
      getSharedSecret: (nr, fr) => we(nr, fr),
      getPublicKey: (nr) => Ce(nr),
      scalarMult: we,
      scalarMultBase: Ce,
      utils: {
        randomSecretKey: er,
        randomPrivateKey: er
      },
      GuBytes: xe.slice(),
      lengths: rr
    };
  }
  return montgomery;
}
var hasRequiredEd25519;
function requireEd25519() {
  return hasRequiredEd25519 || (hasRequiredEd25519 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.hash_to_ristretto255 = s.hashToRistretto255 = s.encodeToCurve = s.hashToCurve = s.RistrettoPoint = s.edwardsToMontgomery = s.ED25519_TORSION_SUBGROUP = s.ristretto255_hasher = s.ristretto255 = s.ed25519_hasher = s.x25519 = s.ed25519ph = s.ed25519ctx = s.ed25519 = void 0, s.edwardsToMontgomeryPub = Gr, s.edwardsToMontgomeryPriv = qr;
    const A = /* @__PURE__ */ requireSha2(), u = /* @__PURE__ */ requireUtils$j(), p = /* @__PURE__ */ requireCurve$2(), t = /* @__PURE__ */ requireEdwards(), l = /* @__PURE__ */ requireHashToCurve$1(), m = /* @__PURE__ */ requireModular$1(), b = /* @__PURE__ */ requireMontgomery(), k = /* @__PURE__ */ requireUtils$h(), C = /* @__PURE__ */ BigInt(0), B = BigInt(1), Q = BigInt(2), P = BigInt(3), x = BigInt(5), M = BigInt(8), F = BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffed"), le = {
      p: F,
      n: BigInt("0x1000000000000000000000000000000014def9dea2f79cd65812631a5cf5d3ed"),
      h: M,
      a: BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffec"),
      d: BigInt("0x52036cee2b6ffe738cc740797779e89800700a4d4141d8ab75eb4dca135978a3"),
      Gx: BigInt("0x216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a"),
      Gy: BigInt("0x6666666666666666666666666666666666666666666666666666666666666658")
    };
    function ge(Hr) {
      const un = BigInt(10), Dr = BigInt(20), wr = BigInt(40), yr = BigInt(80), Qr = F, Jr = Hr * Hr % Qr * Hr % Qr, fn = (0, m.pow2)(Jr, Q, Qr) * Jr % Qr, jr = (0, m.pow2)(fn, B, Qr) * Hr % Qr, dn = (0, m.pow2)(jr, x, Qr) * jr % Qr, Tn = (0, m.pow2)(dn, un, Qr) * dn % Qr, Yn = (0, m.pow2)(Tn, Dr, Qr) * Tn % Qr, si = (0, m.pow2)(Yn, wr, Qr) * Yn % Qr, vn = (0, m.pow2)(si, yr, Qr) * si % Qr, Cn = (0, m.pow2)(vn, yr, Qr) * si % Qr, Xr = (0, m.pow2)(Cn, un, Qr) * dn % Qr;
      return { pow_p_5_8: (0, m.pow2)(Xr, Q, Qr) * Hr % Qr, b2: Jr };
    }
    function pe(Hr) {
      return Hr[0] &= 248, Hr[31] &= 127, Hr[31] |= 64, Hr;
    }
    const Ie = /* @__PURE__ */ BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
    function be(Hr, un) {
      const Dr = F, wr = (0, m.mod)(un * un * un, Dr), yr = (0, m.mod)(wr * wr * un, Dr), Qr = ge(Hr * yr).pow_p_5_8;
      let _r = (0, m.mod)(Hr * wr * Qr, Dr);
      const Jr = (0, m.mod)(un * _r * _r, Dr), fn = _r, jr = (0, m.mod)(_r * Ie, Dr), dn = Jr === Hr, Tn = Jr === (0, m.mod)(-Hr, Dr), Yn = Jr === (0, m.mod)(-Hr * Ie, Dr);
      return dn && (_r = fn), (Tn || Yn) && (_r = jr), (0, m.isNegativeLE)(_r, Dr) && (_r = (0, m.mod)(-_r, Dr)), { isValid: dn || Tn, value: _r };
    }
    const Pe = (0, m.Field)(le.p, { isLE: !0 }), Te = (0, m.Field)(le.n, { isLE: !0 }), Qe = {
      ...le,
      Fp: Pe,
      hash: A.sha512,
      adjustScalarBytes: pe,
      // dom2
      // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
      // Constant-time, u/√v
      uvRatio: be
    };
    s.ed25519 = (0, t.twistedEdwards)(Qe);
    function xe(Hr, un, Dr) {
      if (un.length > 255)
        throw new Error("Context is too big");
      return (0, u.concatBytes)((0, u.utf8ToBytes)("SigEd25519 no Ed25519 collisions"), new Uint8Array([Dr ? 1 : 0, un.length]), un, Hr);
    }
    s.ed25519ctx = (0, t.twistedEdwards)({
      ...Qe,
      domain: xe
    }), s.ed25519ph = (0, t.twistedEdwards)(Object.assign({}, Qe, {
      domain: xe,
      prehash: A.sha512
    })), s.x25519 = (() => {
      const Hr = Pe.ORDER;
      return (0, b.montgomery)({
        P: Hr,
        type: "x25519",
        powPminus2: (un) => {
          const { pow_p_5_8: Dr, b2: wr } = ge(un);
          return (0, m.mod)((0, m.pow2)(Dr, P, Hr) * wr, Hr);
        },
        adjustScalarBytes: pe
      });
    })();
    const Ee = (F + P) / M, He = Pe.pow(Q, Ee), ve = Pe.sqrt(Pe.neg(Pe.ONE));
    function we(Hr) {
      const un = (F - x) / M, Dr = BigInt(486662);
      let wr = Pe.sqr(Hr);
      wr = Pe.mul(wr, Q);
      let yr = Pe.add(wr, Pe.ONE), Qr = Pe.neg(Dr), _r = Pe.sqr(yr), Jr = Pe.mul(_r, yr), fn = Pe.mul(wr, Dr);
      fn = Pe.mul(fn, Qr), fn = Pe.add(fn, _r), fn = Pe.mul(fn, Qr);
      let jr = Pe.sqr(Jr);
      _r = Pe.sqr(jr), jr = Pe.mul(jr, Jr), jr = Pe.mul(jr, fn), _r = Pe.mul(_r, jr);
      let dn = Pe.pow(_r, un);
      dn = Pe.mul(dn, jr);
      let Tn = Pe.mul(dn, ve);
      _r = Pe.sqr(dn), _r = Pe.mul(_r, Jr);
      let Yn = Pe.eql(_r, fn), si = Pe.cmov(Tn, dn, Yn), vn = Pe.mul(Qr, wr), Cn = Pe.mul(dn, Hr);
      Cn = Pe.mul(Cn, He);
      let Xr = Pe.mul(Cn, ve), In = Pe.mul(fn, wr);
      _r = Pe.sqr(Cn), _r = Pe.mul(_r, Jr);
      let zr = Pe.eql(_r, In), En = Pe.cmov(Xr, Cn, zr);
      _r = Pe.sqr(si), _r = Pe.mul(_r, Jr);
      let Zr = Pe.eql(_r, fn), kr = Pe.cmov(vn, Qr, Zr), Rr = Pe.cmov(En, si, Zr), Er = Pe.isOdd(Rr);
      return Rr = Pe.cmov(Rr, Pe.neg(Rr), Zr !== Er), { xMn: kr, xMd: yr, yMn: Rr, yMd: B };
    }
    const Ce = (0, m.FpSqrtEven)(Pe, Pe.neg(BigInt(486664)));
    function Se(Hr) {
      const { xMn: un, xMd: Dr, yMn: wr, yMd: yr } = we(Hr);
      let Qr = Pe.mul(un, yr);
      Qr = Pe.mul(Qr, Ce);
      let _r = Pe.mul(Dr, wr), Jr = Pe.sub(un, Dr), fn = Pe.add(un, Dr), jr = Pe.mul(_r, fn), dn = Pe.eql(jr, Pe.ZERO);
      Qr = Pe.cmov(Qr, Pe.ZERO, dn), _r = Pe.cmov(_r, Pe.ONE, dn), Jr = Pe.cmov(Jr, Pe.ONE, dn), fn = Pe.cmov(fn, Pe.ONE, dn);
      const [Tn, Yn] = (0, m.FpInvertBatch)(Pe, [_r, fn], !0);
      return { x: Pe.mul(Qr, Tn), y: Pe.mul(Jr, Yn) };
    }
    s.ed25519_hasher = (0, l.createHasher)(s.ed25519.Point, (Hr) => Se(Hr[0]), {
      DST: "edwards25519_XMD:SHA-512_ELL2_RO_",
      encodeDST: "edwards25519_XMD:SHA-512_ELL2_NU_",
      p: F,
      m: 1,
      k: 128,
      expand: "xmd",
      hash: A.sha512
    });
    const Ne = Ie, rr = /* @__PURE__ */ BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235"), er = /* @__PURE__ */ BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578"), ir = /* @__PURE__ */ BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838"), sr = /* @__PURE__ */ BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952"), nr = (Hr) => be(B, Hr), fr = /* @__PURE__ */ BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), lr = (Hr) => s.ed25519.Point.Fp.create((0, k.bytesToNumberLE)(Hr) & fr);
    function br(Hr) {
      const { d: un } = le, Dr = F, wr = (In) => Pe.create(In), yr = wr(Ne * Hr * Hr), Qr = wr((yr + B) * ir);
      let _r = BigInt(-1);
      const Jr = wr((_r - un * yr) * wr(yr + un));
      let { isValid: fn, value: jr } = be(Qr, Jr), dn = wr(jr * Hr);
      (0, m.isNegativeLE)(dn, Dr) || (dn = wr(-dn)), fn || (jr = dn), fn || (_r = yr);
      const Tn = wr(_r * (yr - B) * sr - Jr), Yn = jr * jr, si = wr((jr + jr) * Jr), vn = wr(Tn * rr), Cn = wr(B - Yn), Xr = wr(B + Yn);
      return new s.ed25519.Point(wr(si * Xr), wr(Cn * vn), wr(vn * Xr), wr(si * Cn));
    }
    function Br(Hr) {
      (0, u.abytes)(Hr, 64);
      const un = lr(Hr.subarray(0, 32)), Dr = br(un), wr = lr(Hr.subarray(32, 64)), yr = br(wr);
      return new Fr(Dr.add(yr));
    }
    class Fr extends t.PrimeEdwardsPoint {
      constructor(un) {
        super(un);
      }
      static fromAffine(un) {
        return new Fr(s.ed25519.Point.fromAffine(un));
      }
      assertSame(un) {
        if (!(un instanceof Fr))
          throw new Error("RistrettoPoint expected");
      }
      init(un) {
        return new Fr(un);
      }
      /** @deprecated use `import { ristretto255_hasher } from '@noble/curves/ed25519.js';` */
      static hashToCurve(un) {
        return Br((0, k.ensureBytes)("ristrettoHash", un, 64));
      }
      static fromBytes(un) {
        (0, u.abytes)(un, 32);
        const { a: Dr, d: wr } = le, yr = F, Qr = (Zr) => Pe.create(Zr), _r = lr(un);
        if (!(0, k.equalBytes)(Pe.toBytes(_r), un) || (0, m.isNegativeLE)(_r, yr))
          throw new Error("invalid ristretto255 encoding 1");
        const Jr = Qr(_r * _r), fn = Qr(B + Dr * Jr), jr = Qr(B - Dr * Jr), dn = Qr(fn * fn), Tn = Qr(jr * jr), Yn = Qr(Dr * wr * dn - Tn), { isValid: si, value: vn } = nr(Qr(Yn * Tn)), Cn = Qr(vn * jr), Xr = Qr(vn * Cn * Yn);
        let In = Qr((_r + _r) * Cn);
        (0, m.isNegativeLE)(In, yr) && (In = Qr(-In));
        const zr = Qr(fn * Xr), En = Qr(In * zr);
        if (!si || (0, m.isNegativeLE)(En, yr) || zr === C)
          throw new Error("invalid ristretto255 encoding 2");
        return new Fr(new s.ed25519.Point(In, zr, B, En));
      }
      /**
       * Converts ristretto-encoded string to ristretto point.
       * Described in [RFC9496](https://www.rfc-editor.org/rfc/rfc9496#name-decode).
       * @param hex Ristretto-encoded 32 bytes. Not every 32-byte string is valid ristretto encoding
       */
      static fromHex(un) {
        return Fr.fromBytes((0, k.ensureBytes)("ristrettoHex", un, 32));
      }
      static msm(un, Dr) {
        return (0, p.pippenger)(Fr, s.ed25519.Point.Fn, un, Dr);
      }
      /**
       * Encodes ristretto point to Uint8Array.
       * Described in [RFC9496](https://www.rfc-editor.org/rfc/rfc9496#name-encode).
       */
      toBytes() {
        let { X: un, Y: Dr, Z: wr, T: yr } = this.ep;
        const Qr = F, _r = (Xr) => Pe.create(Xr), Jr = _r(_r(wr + Dr) * _r(wr - Dr)), fn = _r(un * Dr), jr = _r(fn * fn), { value: dn } = nr(_r(Jr * jr)), Tn = _r(dn * Jr), Yn = _r(dn * fn), si = _r(Tn * Yn * yr);
        let vn;
        if ((0, m.isNegativeLE)(yr * si, Qr)) {
          let Xr = _r(Dr * Ne), In = _r(un * Ne);
          un = Xr, Dr = In, vn = _r(Tn * er);
        } else
          vn = Yn;
        (0, m.isNegativeLE)(un * si, Qr) && (Dr = _r(-Dr));
        let Cn = _r((wr - Dr) * vn);
        return (0, m.isNegativeLE)(Cn, Qr) && (Cn = _r(-Cn)), Pe.toBytes(Cn);
      }
      /**
       * Compares two Ristretto points.
       * Described in [RFC9496](https://www.rfc-editor.org/rfc/rfc9496#name-equals).
       */
      equals(un) {
        this.assertSame(un);
        const { X: Dr, Y: wr } = this.ep, { X: yr, Y: Qr } = un.ep, _r = (jr) => Pe.create(jr), Jr = _r(Dr * Qr) === _r(wr * yr), fn = _r(wr * Qr) === _r(Dr * yr);
        return Jr || fn;
      }
      is0() {
        return this.equals(Fr.ZERO);
      }
    }
    Fr.BASE = new Fr(s.ed25519.Point.BASE), Fr.ZERO = new Fr(s.ed25519.Point.ZERO), Fr.Fp = Pe, Fr.Fn = Te, s.ristretto255 = { Point: Fr }, s.ristretto255_hasher = {
      hashToCurve(Hr, un) {
        const Dr = (un == null ? void 0 : un.DST) || "ristretto255_XMD:SHA-512_R255MAP_RO_", wr = (0, l.expand_message_xmd)(Hr, Dr, 64, A.sha512);
        return Br(wr);
      },
      hashToScalar(Hr, un = { DST: l._DST_scalar }) {
        const Dr = (0, l.expand_message_xmd)(Hr, un.DST, 64, A.sha512);
        return Te.create((0, k.bytesToNumberLE)(Dr));
      }
    }, s.ED25519_TORSION_SUBGROUP = [
      "0100000000000000000000000000000000000000000000000000000000000000",
      "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac037a",
      "0000000000000000000000000000000000000000000000000000000000000080",
      "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc05",
      "ecffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff7f",
      "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc85",
      "0000000000000000000000000000000000000000000000000000000000000000",
      "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac03fa"
    ];
    function Gr(Hr) {
      return s.ed25519.utils.toMontgomery((0, k.ensureBytes)("pub", Hr));
    }
    s.edwardsToMontgomery = Gr;
    function qr(Hr) {
      return s.ed25519.utils.toMontgomerySecret((0, k.ensureBytes)("pub", Hr));
    }
    s.RistrettoPoint = Fr, s.hashToCurve = s.ed25519_hasher.hashToCurve, s.encodeToCurve = s.ed25519_hasher.encodeToCurve, s.hashToRistretto255 = s.ristretto255_hasher.hashToCurve, s.hash_to_ristretto255 = s.ristretto255_hasher.hashToCurve;
  }(ed25519)), ed25519;
}
const global$1 = globalThis || void 0 || self;
var name$l = "adler32", data$l = "AGFzbQEAAAABDANgAAF/YAAAYAF/AAMHBgABAgEAAgUEAQECAgYOAn8BQYCJBQt/AEGACAsHcAgGbWVtb3J5AgAOSGFzaF9HZXRCdWZmZXIAAAlIYXNoX0luaXQAAQtIYXNoX1VwZGF0ZQACCkhhc2hfRmluYWwAAw1IYXNoX0dldFN0YXRlAAQOSGFzaF9DYWxjdWxhdGUABQpTVEFURV9TSVpFAwEK6wkGBQBBgAkLCgBBAEEBNgKECAvjCAEHf0EAKAKECCIBQf//A3EhAiABQRB2IQMCQAJAIABBAUcNACACQQAtAIAJaiIBQY+AfGogASABQfD/A0sbIgEgA2oiBEEQdCIFQYCAPGogBSAEQfD/A0sbIAFyIQEMAQsCQAJAAkACQAJAIABBEEkNAEGACSEGIABBsCtJDQFBgAkhBgNAQQAhBQNAIAYgBWoiASgCACIEQf8BcSACaiICIANqIAIgBEEIdkH/AXFqIgJqIAIgBEEQdkH/AXFqIgJqIAIgBEEYdmoiAmogAiABQQRqKAIAIgRB/wFxaiICaiACIARBCHZB/wFxaiICaiACIARBEHZB/wFxaiICaiACIARBGHZqIgJqIAIgAUEIaigCACIEQf8BcWoiAmogAiAEQQh2Qf8BcWoiAmogAiAEQRB2Qf8BcWoiAmogAiAEQRh2aiIEaiAEIAFBDGooAgAiAUH/AXFqIgRqIAQgAUEIdkH/AXFqIgRqIAQgAUEQdkH/AXFqIgRqIAQgAUEYdmoiAmohAyAFQRBqIgVBsCtHDQALIANB8f8DcCEDIAJB8f8DcCECIAZBsCtqIQYgAEHQVGoiAEGvK0sNAAsgAEUNBCAAQQ9LDQEMAgsCQCAARQ0AAkACQCAAQQNxIgUNAEGACSEBIAAhBAwBCyAAQXxxIQRBACEBA0AgAiABQYAJai0AAGoiAiADaiEDIAUgAUEBaiIBRw0ACyAFQYAJaiEBCyAAQQRJDQADQCACIAEtAABqIgUgAS0AAWoiBiABLQACaiIAIAFBA2otAABqIgIgACAGIAUgA2pqamohAyABQQRqIQEgBEF8aiIEDQALCyACQY+AfGogAiACQfD/A0sbIANB8f8DcEEQdHIhAQwECwNAIAYoAgAiAUH/AXEgAmoiBCADaiAEIAFBCHZB/wFxaiIEaiAEIAFBEHZB/wFxaiIEaiAEIAFBGHZqIgRqIAQgBkEEaigCACIBQf8BcWoiBGogBCABQQh2Qf8BcWoiBGogBCABQRB2Qf8BcWoiBGogBCABQRh2aiIEaiAEIAZBCGooAgAiAUH/AXFqIgRqIAQgAUEIdkH/AXFqIgRqIAQgAUEQdkH/AXFqIgRqIAQgAUEYdmoiBGogBCAGQQxqKAIAIgFB/wFxaiIEaiAEIAFBCHZB/wFxaiIEaiAEIAFBEHZB/wFxaiIEaiAEIAFBGHZqIgJqIQMgBkEQaiEGIABBcGoiAEEPSw0ACyAARQ0BCyAAQX9qIQcCQCAAQQNxIgVFDQAgAEF8cSEAIAUhBCAGIQEDQCACIAEtAABqIgIgA2ohAyABQQFqIQEgBEF/aiIEDQALIAYgBWohBgsgB0EDSQ0AA0AgAiAGLQAAaiIBIAYtAAFqIgQgBi0AAmoiBSAGQQNqLQAAaiICIAUgBCABIANqampqIQMgBkEEaiEGIABBfGoiAA0ACwsgA0Hx/wNwIQMgAkHx/wNwIQILIAIgA0EQdHIhAQtBACABNgKECAsxAQF/QQBBACgChAgiAEEYdCAAQYD+A3FBCHRyIABBCHZBgP4DcSAAQRh2cnI2AoAJCwUAQYQICzsAQQBBATYChAggABACQQBBACgChAgiAEEYdCAAQYD+A3FBCHRyIABBCHZBgP4DcSAAQRh2cnI2AoAJCwsVAgBBgAgLBAQAAAAAQYQICwQBAAAA", hash$l = "02ddbd17", wasmJson$l = {
  name: name$l,
  data: data$l,
  hash: hash$l
};
function __awaiter(s, A, u, p) {
  function t(l) {
    return l instanceof u ? l : new u(function(m) {
      m(l);
    });
  }
  return new (u || (u = Promise))(function(l, m) {
    function b(B) {
      try {
        C(p.next(B));
      } catch (Q) {
        m(Q);
      }
    }
    function k(B) {
      try {
        C(p.throw(B));
      } catch (Q) {
        m(Q);
      }
    }
    function C(B) {
      B.done ? l(B.value) : t(B.value).then(b, k);
    }
    C((p = p.apply(s, [])).next());
  });
}
typeof SuppressedError == "function" && SuppressedError;
class Mutex {
  constructor() {
    this.mutex = Promise.resolve();
  }
  lock() {
    let A = () => {
    };
    return this.mutex = this.mutex.then(() => new Promise(A)), new Promise((u) => {
      A = u;
    });
  }
  dispatch(A) {
    return __awaiter(this, void 0, void 0, function* () {
      const u = yield this.lock();
      try {
        return yield Promise.resolve(A());
      } finally {
        u();
      }
    });
  }
}
var _a;
function getGlobal() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global$1;
}
const globalObject = getGlobal(), nodeBuffer = (_a = globalObject.Buffer) !== null && _a !== void 0 ? _a : null, textEncoder = globalObject.TextEncoder ? new globalObject.TextEncoder() : null;
function intArrayToString(s, A) {
  return String.fromCharCode(...s.subarray(0, A));
}
function hexCharCodesToInt(s, A) {
  return (s & 15) + (s >> 6 | s >> 3 & 8) << 4 | (A & 15) + (A >> 6 | A >> 3 & 8);
}
function writeHexToUInt8(s, A) {
  const u = A.length >> 1;
  for (let p = 0; p < u; p++) {
    const t = p << 1;
    s[p] = hexCharCodesToInt(A.charCodeAt(t), A.charCodeAt(t + 1));
  }
}
function hexStringEqualsUInt8(s, A) {
  if (s.length !== A.length * 2)
    return !1;
  for (let u = 0; u < A.length; u++) {
    const p = u << 1;
    if (A[u] !== hexCharCodesToInt(s.charCodeAt(p), s.charCodeAt(p + 1)))
      return !1;
  }
  return !0;
}
const alpha = 87, digit = 48;
function getDigestHex(s, A, u) {
  let p = 0;
  for (let t = 0; t < u; t++) {
    let l = A[t] >>> 4;
    s[p++] = l > 9 ? l + alpha : l + digit, l = A[t] & 15, s[p++] = l > 9 ? l + alpha : l + digit;
  }
  return String.fromCharCode.apply(null, s);
}
const getUInt8Buffer = nodeBuffer !== null ? (s) => {
  if (typeof s == "string") {
    const A = nodeBuffer.from(s, "utf8");
    return new Uint8Array(A.buffer, A.byteOffset, A.length);
  }
  if (nodeBuffer.isBuffer(s))
    return new Uint8Array(s.buffer, s.byteOffset, s.length);
  if (ArrayBuffer.isView(s))
    return new Uint8Array(s.buffer, s.byteOffset, s.byteLength);
  throw new Error("Invalid data type!");
} : (s) => {
  if (typeof s == "string")
    return textEncoder.encode(s);
  if (ArrayBuffer.isView(s))
    return new Uint8Array(s.buffer, s.byteOffset, s.byteLength);
  throw new Error("Invalid data type!");
}, base64Chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", base64Lookup = new Uint8Array(256);
for (let s = 0; s < base64Chars.length; s++)
  base64Lookup[base64Chars.charCodeAt(s)] = s;
function encodeBase64(s, A = !0) {
  const u = s.length, p = u % 3, t = [], l = u - p;
  for (let m = 0; m < l; m += 3) {
    const b = (s[m] << 16 & 16711680) + (s[m + 1] << 8 & 65280) + (s[m + 2] & 255), k = base64Chars.charAt(b >> 18 & 63) + base64Chars.charAt(b >> 12 & 63) + base64Chars.charAt(b >> 6 & 63) + base64Chars.charAt(b & 63);
    t.push(k);
  }
  if (p === 1) {
    const m = s[u - 1], b = base64Chars.charAt(m >> 2), k = base64Chars.charAt(m << 4 & 63);
    t.push(`${b}${k}`), A && t.push("==");
  } else if (p === 2) {
    const m = (s[u - 2] << 8) + s[u - 1], b = base64Chars.charAt(m >> 10), k = base64Chars.charAt(m >> 4 & 63), C = base64Chars.charAt(m << 2 & 63);
    t.push(`${b}${k}${C}`), A && t.push("=");
  }
  return t.join("");
}
function getDecodeBase64Length(s) {
  let A = Math.floor(s.length * 0.75);
  const u = s.length;
  return s[u - 1] === "=" && (A -= 1, s[u - 2] === "=" && (A -= 1)), A;
}
function decodeBase64(s) {
  const A = getDecodeBase64Length(s), u = s.length, p = new Uint8Array(A);
  let t = 0;
  for (let l = 0; l < u; l += 4) {
    const m = base64Lookup[s.charCodeAt(l)], b = base64Lookup[s.charCodeAt(l + 1)], k = base64Lookup[s.charCodeAt(l + 2)], C = base64Lookup[s.charCodeAt(l + 3)];
    p[t] = m << 2 | b >> 4, t += 1, p[t] = (b & 15) << 4 | k >> 2, t += 1, p[t] = (k & 3) << 6 | C & 63, t += 1;
  }
  return p;
}
const MAX_HEAP = 16 * 1024, WASM_FUNC_HASH_LENGTH = 4, wasmMutex = new Mutex(), wasmModuleCache = /* @__PURE__ */ new Map();
function WASMInterface(s, A) {
  return __awaiter(this, void 0, void 0, function* () {
    let u = null, p = null, t = !1;
    if (typeof WebAssembly > "u")
      throw new Error("WebAssembly is not supported in this environment!");
    const l = (Te, Qe = 0) => {
      p.set(Te, Qe);
    }, m = () => p, b = () => u.exports, k = (Te) => {
      u.exports.Hash_SetMemorySize(Te);
      const Qe = u.exports.Hash_GetBuffer(), xe = u.exports.memory.buffer;
      p = new Uint8Array(xe, Qe, Te);
    }, C = () => new DataView(u.exports.memory.buffer).getUint32(u.exports.STATE_SIZE, !0), B = wasmMutex.dispatch(() => __awaiter(this, void 0, void 0, function* () {
      if (!wasmModuleCache.has(s.name)) {
        const Qe = decodeBase64(s.data), xe = WebAssembly.compile(Qe);
        wasmModuleCache.set(s.name, xe);
      }
      const Te = yield wasmModuleCache.get(s.name);
      u = yield WebAssembly.instantiate(Te, {
        // env: {
        //   emscripten_memcpy_big: (dest, src, num) => {
        //     const memoryBuffer = wasmInstance.exports.memory.buffer;
        //     const memView = new Uint8Array(memoryBuffer, 0);
        //     memView.set(memView.subarray(src, src + num), dest);
        //   },
        //   print_memory: (offset, len) => {
        //     const memoryBuffer = wasmInstance.exports.memory.buffer;
        //     const memView = new Uint8Array(memoryBuffer, 0);
        //     console.log('print_int32', memView.subarray(offset, offset + len));
        //   },
        // },
      });
    })), Q = () => __awaiter(this, void 0, void 0, function* () {
      u || (yield B);
      const Te = u.exports.Hash_GetBuffer(), Qe = u.exports.memory.buffer;
      p = new Uint8Array(Qe, Te, MAX_HEAP);
    }), P = (Te = null) => {
      t = !0, u.exports.Hash_Init(Te);
    }, x = (Te) => {
      let Qe = 0;
      for (; Qe < Te.length; ) {
        const xe = Te.subarray(Qe, Qe + MAX_HEAP);
        Qe += xe.length, p.set(xe), u.exports.Hash_Update(xe.length);
      }
    }, M = (Te) => {
      if (!t)
        throw new Error("update() called before init()");
      const Qe = getUInt8Buffer(Te);
      x(Qe);
    }, F = new Uint8Array(A * 2), le = (Te, Qe = null) => {
      if (!t)
        throw new Error("digest() called before init()");
      return t = !1, u.exports.Hash_Final(Qe), Te === "binary" ? p.slice(0, A) : getDigestHex(F, p, A);
    }, ge = () => {
      if (!t)
        throw new Error("save() can only be called after init() and before digest()");
      const Te = u.exports.Hash_GetState(), Qe = C(), xe = u.exports.memory.buffer, Ee = new Uint8Array(xe, Te, Qe), He = new Uint8Array(WASM_FUNC_HASH_LENGTH + Qe);
      return writeHexToUInt8(He, s.hash), He.set(Ee, WASM_FUNC_HASH_LENGTH), He;
    }, pe = (Te) => {
      if (!(Te instanceof Uint8Array))
        throw new Error("load() expects an Uint8Array generated by save()");
      const Qe = u.exports.Hash_GetState(), xe = C(), Ee = WASM_FUNC_HASH_LENGTH + xe, He = u.exports.memory.buffer;
      if (Te.length !== Ee)
        throw new Error(`Bad state length (expected ${Ee} bytes, got ${Te.length})`);
      if (!hexStringEqualsUInt8(s.hash, Te.subarray(0, WASM_FUNC_HASH_LENGTH)))
        throw new Error("This state was written by an incompatible hash implementation");
      const ve = Te.subarray(WASM_FUNC_HASH_LENGTH);
      new Uint8Array(He, Qe, xe).set(ve), t = !0;
    }, Ie = (Te) => typeof Te == "string" ? Te.length < MAX_HEAP / 4 : Te.byteLength < MAX_HEAP;
    let be = Ie;
    switch (s.name) {
      case "argon2":
      case "scrypt":
        be = () => !0;
        break;
      case "blake2b":
      case "blake2s":
        be = (Te, Qe) => Qe <= 512 && Ie(Te);
        break;
      case "blake3":
        be = (Te, Qe) => Qe === 0 && Ie(Te);
        break;
      case "xxhash64":
      // cannot simplify
      case "xxhash3":
      case "xxhash128":
      case "crc64":
        be = () => !1;
        break;
    }
    const Pe = (Te, Qe = null, xe = null) => {
      if (!be(Te, Qe))
        return P(Qe), M(Te), le("hex", xe);
      const Ee = getUInt8Buffer(Te);
      return p.set(Ee), u.exports.Hash_Calculate(Ee.length, Qe, xe), getDigestHex(F, p, A);
    };
    return yield Q(), {
      getMemory: m,
      writeMemory: l,
      getExports: b,
      setMemorySize: k,
      init: P,
      update: M,
      digest: le,
      save: ge,
      load: pe,
      calculate: Pe,
      hashLength: A
    };
  });
}
function lockedCreate(s, A, u) {
  return __awaiter(this, void 0, void 0, function* () {
    const p = yield s.lock(), t = yield WASMInterface(A, u);
    return p(), t;
  });
}
const mutex$l = new Mutex();
let wasmCache$l = null;
function adler32(s) {
  if (wasmCache$l === null)
    return lockedCreate(mutex$l, wasmJson$l, 4).then((A) => (wasmCache$l = A, wasmCache$l.calculate(s)));
  try {
    const A = wasmCache$l.calculate(s);
    return Promise.resolve(A);
  } catch (A) {
    return Promise.reject(A);
  }
}
function createAdler32() {
  return WASMInterface(wasmJson$l, 4).then((s) => {
    s.init();
    const A = {
      init: () => (s.init(), A),
      update: (u) => (s.update(u), A),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (u) => s.digest(u),
      save: () => s.save(),
      load: (u) => (s.load(u), A),
      blockSize: 4,
      digestSize: 4
    };
    return A;
  });
}
var name$k = "argon2", data$k = "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", hash$k = "e4cdc523", wasmJson$k = {
  name: name$k,
  data: data$k,
  hash: hash$k
}, name$j = "blake2b", data$j = "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", hash$j = "c6f286e6", wasmJson$j = {
  name: name$j,
  data: data$j,
  hash: hash$j
};
const mutex$k = new Mutex();
let wasmCache$k = null;
function validateBits$4(s) {
  return !Number.isInteger(s) || s < 8 || s > 512 || s % 8 !== 0 ? new Error("Invalid variant! Valid values: 8, 16, ..., 512") : null;
}
function getInitParam$1(s, A) {
  return s | A << 16;
}
function blake2b(s, A = 512, u = null) {
  if (validateBits$4(A))
    return Promise.reject(validateBits$4(A));
  let p = null, t = A;
  if (u !== null) {
    if (p = getUInt8Buffer(u), p.length > 64)
      return Promise.reject(new Error("Max key length is 64 bytes"));
    t = getInitParam$1(A, p.length);
  }
  const l = A / 8;
  if (wasmCache$k === null || wasmCache$k.hashLength !== l)
    return lockedCreate(mutex$k, wasmJson$j, l).then((m) => (wasmCache$k = m, t > 512 && wasmCache$k.writeMemory(p), wasmCache$k.calculate(s, t)));
  try {
    t > 512 && wasmCache$k.writeMemory(p);
    const m = wasmCache$k.calculate(s, t);
    return Promise.resolve(m);
  } catch (m) {
    return Promise.reject(m);
  }
}
function createBLAKE2b(s = 512, A = null) {
  if (validateBits$4(s))
    return Promise.reject(validateBits$4(s));
  let u = null, p = s;
  if (A !== null) {
    if (u = getUInt8Buffer(A), u.length > 64)
      return Promise.reject(new Error("Max key length is 64 bytes"));
    p = getInitParam$1(s, u.length);
  }
  const t = s / 8;
  return WASMInterface(wasmJson$j, t).then((l) => {
    p > 512 && l.writeMemory(u), l.init(p);
    const m = {
      init: p > 512 ? () => (l.writeMemory(u), l.init(p), m) : () => (l.init(p), m),
      update: (b) => (l.update(b), m),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (b) => l.digest(b),
      save: () => l.save(),
      load: (b) => (l.load(b), m),
      blockSize: 128,
      digestSize: t
    };
    return m;
  });
}
function encodeResult(s, A, u) {
  const p = [
    `m=${A.memorySize}`,
    `t=${A.iterations}`,
    `p=${A.parallelism}`
  ].join(",");
  return `$argon2${A.hashType}$v=19$${p}$${encodeBase64(s, !1)}$${encodeBase64(u, !1)}`;
}
const uint32View = new DataView(new ArrayBuffer(4));
function int32LE(s) {
  return uint32View.setInt32(0, s, !0), new Uint8Array(uint32View.buffer);
}
function hashFunc(s, A, u) {
  return __awaiter(this, void 0, void 0, function* () {
    if (u <= 64) {
      const k = yield createBLAKE2b(u * 8);
      return k.update(int32LE(u)), k.update(A), k.digest("binary");
    }
    const p = Math.ceil(u / 32) - 2, t = new Uint8Array(u);
    s.init(), s.update(int32LE(u)), s.update(A);
    let l = s.digest("binary");
    t.set(l.subarray(0, 32), 0);
    for (let k = 1; k < p; k++)
      s.init(), s.update(l), l = s.digest("binary"), t.set(l.subarray(0, 32), k * 32);
    const m = u - 32 * p;
    let b;
    return m === 64 ? (b = s, b.init()) : b = yield createBLAKE2b(m * 8), b.update(l), l = b.digest("binary"), t.set(l.subarray(0, m), p * 32), t;
  });
}
function getHashType(s) {
  switch (s) {
    case "d":
      return 0;
    case "i":
      return 1;
    default:
      return 2;
  }
}
function argon2Internal(s) {
  return __awaiter(this, void 0, void 0, function* () {
    var A;
    const { parallelism: u, iterations: p, hashLength: t } = s, l = getUInt8Buffer(s.password), m = getUInt8Buffer(s.salt), b = 19, k = getHashType(s.hashType), { memorySize: C } = s, B = getUInt8Buffer((A = s.secret) !== null && A !== void 0 ? A : ""), [Q, P] = yield Promise.all([
      WASMInterface(wasmJson$k, 1024),
      createBLAKE2b(512)
    ]);
    Q.setMemorySize(C * 1024 + 1024);
    const x = new Uint8Array(24), M = new DataView(x.buffer);
    M.setInt32(0, u, !0), M.setInt32(4, t, !0), M.setInt32(8, C, !0), M.setInt32(12, p, !0), M.setInt32(16, b, !0), M.setInt32(20, k, !0), Q.writeMemory(x, C * 1024), P.init(), P.update(x), P.update(int32LE(l.length)), P.update(l), P.update(int32LE(m.length)), P.update(m), P.update(int32LE(B.length)), P.update(B), P.update(int32LE(0));
    const le = Math.floor(C / (u * 4)) * 4, ge = new Uint8Array(72), pe = P.digest("binary");
    ge.set(pe);
    for (let Pe = 0; Pe < u; Pe++) {
      ge.set(int32LE(0), 64), ge.set(int32LE(Pe), 68);
      let Te = Pe * le, Qe = yield hashFunc(P, ge, 1024);
      Q.writeMemory(Qe, Te * 1024), Te += 1, ge.set(int32LE(1), 64), Qe = yield hashFunc(P, ge, 1024), Q.writeMemory(Qe, Te * 1024);
    }
    const Ie = new Uint8Array(1024);
    writeHexToUInt8(Ie, Q.calculate(new Uint8Array([]), C));
    const be = yield hashFunc(P, Ie, t);
    if (s.outputType === "hex") {
      const Pe = new Uint8Array(t * 2);
      return getDigestHex(Pe, be, t);
    }
    return s.outputType === "encoded" ? encodeResult(m, s, be) : be;
  });
}
const validateOptions$3 = (s) => {
  var A;
  if (!s || typeof s != "object")
    throw new Error("Invalid options parameter. It requires an object.");
  if (!s.password)
    throw new Error("Password must be specified");
  if (s.password = getUInt8Buffer(s.password), s.password.length < 1)
    throw new Error("Password must be specified");
  if (!s.salt)
    throw new Error("Salt must be specified");
  if (s.salt = getUInt8Buffer(s.salt), s.salt.length < 8)
    throw new Error("Salt should be at least 8 bytes long");
  if (s.secret = getUInt8Buffer((A = s.secret) !== null && A !== void 0 ? A : ""), !Number.isInteger(s.iterations) || s.iterations < 1)
    throw new Error("Iterations should be a positive number");
  if (!Number.isInteger(s.parallelism) || s.parallelism < 1)
    throw new Error("Parallelism should be a positive number");
  if (!Number.isInteger(s.hashLength) || s.hashLength < 4)
    throw new Error("Hash length should be at least 4 bytes.");
  if (!Number.isInteger(s.memorySize))
    throw new Error("Memory size should be specified.");
  if (s.memorySize < 8 * s.parallelism)
    throw new Error("Memory size should be at least 8 * parallelism.");
  if (s.outputType === void 0 && (s.outputType = "hex"), !["hex", "binary", "encoded"].includes(s.outputType))
    throw new Error(`Insupported output type ${s.outputType}. Valid values: ['hex', 'binary', 'encoded']`);
};
function argon2i(s) {
  return __awaiter(this, void 0, void 0, function* () {
    return validateOptions$3(s), argon2Internal(Object.assign(Object.assign({}, s), { hashType: "i" }));
  });
}
function argon2id(s) {
  return __awaiter(this, void 0, void 0, function* () {
    return validateOptions$3(s), argon2Internal(Object.assign(Object.assign({}, s), { hashType: "id" }));
  });
}
function argon2d(s) {
  return __awaiter(this, void 0, void 0, function* () {
    return validateOptions$3(s), argon2Internal(Object.assign(Object.assign({}, s), { hashType: "d" }));
  });
}
const getHashParameters = (s, A, u) => {
  const p = /^\$argon2(id|i|d)\$v=([0-9]+)\$((?:[mtp]=[0-9]+,){2}[mtp]=[0-9]+)\$([A-Za-z0-9+/]+)\$([A-Za-z0-9+/]+)$/, t = A.match(p);
  if (!t)
    throw new Error("Invalid hash");
  const [, l, m, b, k, C] = t;
  if (m !== "19")
    throw new Error(`Unsupported version: ${m}`);
  const B = {}, Q = { m: "memorySize", p: "parallelism", t: "iterations" };
  for (const P of b.split(",")) {
    const [x, M] = P.split("=");
    B[Q[x]] = Number(M);
  }
  return Object.assign(Object.assign({}, B), {
    password: s,
    secret: u,
    hashType: l,
    salt: decodeBase64(k),
    hashLength: getDecodeBase64Length(C),
    outputType: "encoded"
  });
}, validateVerifyOptions$1 = (s) => {
  if (!s || typeof s != "object")
    throw new Error("Invalid options parameter. It requires an object.");
  if (s.hash === void 0 || typeof s.hash != "string")
    throw new Error("Hash should be specified");
};
function argon2Verify(s) {
  return __awaiter(this, void 0, void 0, function* () {
    validateVerifyOptions$1(s);
    const A = getHashParameters(s.password, s.hash, s.secret);
    validateOptions$3(A);
    const u = s.hash.lastIndexOf("$") + 1;
    return (yield argon2Internal(A)).substring(u) === s.hash.substring(u);
  });
}
var name$i = "blake2s", data$i = "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", hash$i = "5c0ff166", wasmJson$i = {
  name: name$i,
  data: data$i,
  hash: hash$i
};
const mutex$j = new Mutex();
let wasmCache$j = null;
function validateBits$3(s) {
  return !Number.isInteger(s) || s < 8 || s > 256 || s % 8 !== 0 ? new Error("Invalid variant! Valid values: 8, 16, ..., 256") : null;
}
function getInitParam(s, A) {
  return s | A << 16;
}
function blake2s(s, A = 256, u = null) {
  if (validateBits$3(A))
    return Promise.reject(validateBits$3(A));
  let p = null, t = A;
  if (u !== null) {
    if (p = getUInt8Buffer(u), p.length > 32)
      return Promise.reject(new Error("Max key length is 32 bytes"));
    t = getInitParam(A, p.length);
  }
  const l = A / 8;
  if (wasmCache$j === null || wasmCache$j.hashLength !== l)
    return lockedCreate(mutex$j, wasmJson$i, l).then((m) => (wasmCache$j = m, t > 512 && wasmCache$j.writeMemory(p), wasmCache$j.calculate(s, t)));
  try {
    t > 512 && wasmCache$j.writeMemory(p);
    const m = wasmCache$j.calculate(s, t);
    return Promise.resolve(m);
  } catch (m) {
    return Promise.reject(m);
  }
}
function createBLAKE2s(s = 256, A = null) {
  if (validateBits$3(s))
    return Promise.reject(validateBits$3(s));
  let u = null, p = s;
  if (A !== null) {
    if (u = getUInt8Buffer(A), u.length > 32)
      return Promise.reject(new Error("Max key length is 32 bytes"));
    p = getInitParam(s, u.length);
  }
  const t = s / 8;
  return WASMInterface(wasmJson$i, t).then((l) => {
    p > 512 && l.writeMemory(u), l.init(p);
    const m = {
      init: p > 512 ? () => (l.writeMemory(u), l.init(p), m) : () => (l.init(p), m),
      update: (b) => (l.update(b), m),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (b) => l.digest(b),
      save: () => l.save(),
      load: (b) => (l.load(b), m),
      blockSize: 64,
      digestSize: t
    };
    return m;
  });
}
var name$h = "blake3", data$h = "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", hash$h = "215d875f", wasmJson$h = {
  name: name$h,
  data: data$h,
  hash: hash$h
};
const mutex$i = new Mutex();
let wasmCache$i = null;
function validateBits$2(s) {
  return !Number.isInteger(s) || s < 8 || s % 8 !== 0 ? new Error("Invalid variant! Valid values: 8, 16, ...") : null;
}
function blake3(s, A = 256, u = null) {
  if (validateBits$2(A))
    return Promise.reject(validateBits$2(A));
  let p = null, t = 0;
  if (u !== null) {
    if (p = getUInt8Buffer(u), p.length !== 32)
      return Promise.reject(new Error("Key length must be exactly 32 bytes"));
    t = 32;
  }
  const l = A / 8, m = l;
  if (wasmCache$i === null || wasmCache$i.hashLength !== l)
    return lockedCreate(mutex$i, wasmJson$h, l).then((b) => (wasmCache$i = b, t === 32 && wasmCache$i.writeMemory(p), wasmCache$i.calculate(s, t, m)));
  try {
    t === 32 && wasmCache$i.writeMemory(p);
    const b = wasmCache$i.calculate(s, t, m);
    return Promise.resolve(b);
  } catch (b) {
    return Promise.reject(b);
  }
}
function createBLAKE3(s = 256, A = null) {
  if (validateBits$2(s))
    return Promise.reject(validateBits$2(s));
  let u = null, p = 0;
  if (A !== null) {
    if (u = getUInt8Buffer(A), u.length !== 32)
      return Promise.reject(new Error("Key length must be exactly 32 bytes"));
    p = 32;
  }
  const t = s / 8, l = t;
  return WASMInterface(wasmJson$h, t).then((m) => {
    p === 32 && m.writeMemory(u), m.init(p);
    const b = {
      init: p === 32 ? () => (m.writeMemory(u), m.init(p), b) : () => (m.init(p), b),
      update: (k) => (m.update(k), b),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (k) => m.digest(k, l),
      save: () => m.save(),
      load: (k) => (m.load(k), b),
      blockSize: 64,
      digestSize: t
    };
    return b;
  });
}
var name$g = "crc32", data$g = "AGFzbQEAAAABEQRgAAF/YAF/AGAAAGACf38AAwgHAAEBAQIAAwUEAQECAgYOAn8BQZDJBQt/AEGACAsHcAgGbWVtb3J5AgAOSGFzaF9HZXRCdWZmZXIAAAlIYXNoX0luaXQAAgtIYXNoX1VwZGF0ZQADCkhhc2hfRmluYWwABA1IYXNoX0dldFN0YXRlAAUOSGFzaF9DYWxjdWxhdGUABgpTVEFURV9TSVpFAwEKkggHBQBBgAkLwwMBA39BgIkBIQFBACECA0AgAUEAQQBBAEEAQQBBAEEAQQAgAkEBcWsgAHEgAkEBdnMiA0EBcWsgAHEgA0EBdnMiA0EBcWsgAHEgA0EBdnMiA0EBcWsgAHEgA0EBdnMiA0EBcWsgAHEgA0EBdnMiA0EBcWsgAHEgA0EBdnMiA0EBcWsgAHEgA0EBdnMiA0EBcWsgAHEgA0EBdnM2AgAgAUEEaiEBIAJBAWoiAkGAAkcNAAtBACEAA0AgAEGEkQFqIABBhIkBaigCACICQf8BcUECdEGAiQFqKAIAIAJBCHZzIgI2AgAgAEGEmQFqIAJB/wFxQQJ0QYCJAWooAgAgAkEIdnMiAjYCACAAQYShAWogAkH/AXFBAnRBgIkBaigCACACQQh2cyICNgIAIABBhKkBaiACQf8BcUECdEGAiQFqKAIAIAJBCHZzIgI2AgAgAEGEsQFqIAJB/wFxQQJ0QYCJAWooAgAgAkEIdnMiAjYCACAAQYS5AWogAkH/AXFBAnRBgIkBaigCACACQQh2cyICNgIAIABBhMEBaiACQf8BcUECdEGAiQFqKAIAIAJBCHZzNgIAIABBBGoiAEH8B0cNAAsLJwACQEEAKAKAyQEgAEYNACAAEAFBACAANgKAyQELQQBBADYChMkBC4gDAQN/QQAoAoTJAUF/cyEBQYAJIQICQCAAQQhJDQBBgAkhAgNAIAJBBGooAgAiA0EOdkH8B3FBgJEBaigCACADQRZ2QfwHcUGAiQFqKAIAcyADQQZ2QfwHcUGAmQFqKAIAcyADQf8BcUECdEGAoQFqKAIAcyACKAIAIAFzIgFBFnZB/AdxQYCpAWooAgBzIAFBDnZB/AdxQYCxAWooAgBzIAFBBnZB/AdxQYC5AWooAgBzIAFB/wFxQQJ0QYDBAWooAgBzIQEgAkEIaiECIABBeGoiAEEHSw0ACwsCQCAARQ0AAkACQCAAQQFxDQAgACEDDAELIAFB/wFxIAItAABzQQJ0QYCJAWooAgAgAUEIdnMhASACQQFqIQIgAEF/aiEDCyAAQQFGDQADQCABQf8BcSACLQAAc0ECdEGAiQFqKAIAIAFBCHZzIgFB/wFxIAJBAWotAABzQQJ0QYCJAWooAgAgAUEIdnMhASACQQJqIQIgA0F+aiIDDQALC0EAIAFBf3M2AoTJAQsyAQF/QQBBACgChMkBIgBBGHQgAEGA/gNxQQh0ciAAQQh2QYD+A3EgAEEYdnJyNgKACQsGAEGEyQELWQACQEEAKAKAyQEgAUYNACABEAFBACABNgKAyQELQQBBADYChMkBIAAQA0EAQQAoAoTJASIBQRh0IAFBgP4DcUEIdHIgAUEIdkGA/gNxIAFBGHZycjYCgAkLCwsBAEGACAsEBAAAAA==", hash$g = "d2eba587", wasmJson$g = {
  name: name$g,
  data: data$g,
  hash: hash$g
};
const mutex$h = new Mutex();
let wasmCache$h = null;
function validatePoly(s) {
  return !Number.isInteger(s) || s < 0 || s > 4294967295 ? new Error("Polynomial must be a valid 32-bit long unsigned integer") : null;
}
function crc32(s, A = 3988292384) {
  if (validatePoly(A))
    return Promise.reject(validatePoly(A));
  if (wasmCache$h === null)
    return lockedCreate(mutex$h, wasmJson$g, 4).then((u) => (wasmCache$h = u, wasmCache$h.calculate(s, A)));
  try {
    const u = wasmCache$h.calculate(s, A);
    return Promise.resolve(u);
  } catch (u) {
    return Promise.reject(u);
  }
}
function createCRC32(s = 3988292384) {
  return validatePoly(s) ? Promise.reject(validatePoly(s)) : WASMInterface(wasmJson$g, 4).then((A) => {
    A.init(s);
    const u = {
      init: () => (A.init(s), u),
      update: (p) => (A.update(p), u),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (p) => A.digest(p),
      save: () => A.save(),
      load: (p) => (A.load(p), u),
      blockSize: 4,
      digestSize: 4
    };
    return u;
  });
}
var name$f = "crc64", data$f = "AGFzbQEAAAABDANgAAF/YAAAYAF/AAMHBgABAgEAAQUEAQECAgYOAn8BQZCJBgt/AEGACAsHcAgGbWVtb3J5AgAOSGFzaF9HZXRCdWZmZXIAAAlIYXNoX0luaXQAAQtIYXNoX1VwZGF0ZQACCkhhc2hfRmluYWwAAw1IYXNoX0dldFN0YXRlAAQOSGFzaF9DYWxjdWxhdGUABQpTVEFURV9TSVpFAwEKgwgGBQBBgAkL9QMDAX4BfwJ+AkBBACkDgIkCQQApA4AJIgBRDQBBgIkBIQFCACECA0AgAUIAQgBCAEIAQgBCAEIAQgAgAkIBg30gAIMgAkIBiIUiA0IBg30gAIMgA0IBiIUiA0IBg30gAIMgA0IBiIUiA0IBg30gAIMgA0IBiIUiA0IBg30gAIMgA0IBiIUiA0IBg30gAIMgA0IBiIUiA0IBg30gAIMgA0IBiIUiA0IBg30gAIMgA0IBiIU3AwAgAUEIaiEBIAJCAXwiAkKAAlINAAtBACEBA0AgAUGImQFqIAFBiIkBaikDACICp0H/AXFBA3RBgIkBaikDACACQgiIhSICNwMAIAFBiKkBaiACp0H/AXFBA3RBgIkBaikDACACQgiIhSICNwMAIAFBiLkBaiACp0H/AXFBA3RBgIkBaikDACACQgiIhSICNwMAIAFBiMkBaiACp0H/AXFBA3RBgIkBaikDACACQgiIhSICNwMAIAFBiNkBaiACp0H/AXFBA3RBgIkBaikDACACQgiIhSICNwMAIAFBiOkBaiACp0H/AXFBA3RBgIkBaikDACACQgiIhSICNwMAIAFBiPkBaiACp0H/AXFBA3RBgIkBaikDACACQgiIhTcDACABQQhqIgFB+A9HDQALQQAgADcDgIkCC0EAQgA3A4iJAguUAwIBfgJ/QQApA4iJAkJ/hSEBQYAJIQICQCAAQQhJDQBBgAkhAgNAIAIpAwAgAYUiAUIwiKdB/wFxQQN0QYCZAWopAwAgAUI4iKdBA3RBgIkBaikDAIUgAUIoiKdB/wFxQQN0QYCpAWopAwCFIAFCIIinQf8BcUEDdEGAuQFqKQMAhSABpyIDQRV2QfgPcUGAyQFqKQMAhSADQQ12QfgPcUGA2QFqKQMAhSADQQV2QfgPcUGA6QFqKQMAhSADQf8BcUEDdEGA+QFqKQMAhSEBIAJBCGohAiAAQXhqIgBBB0sNAAsLAkAgAEUNAAJAAkAgAEEBcQ0AIAAhAwwBCyABQv8BgyACMQAAhadBA3RBgIkBaikDACABQgiIhSEBIAJBAWohAiAAQX9qIQMLIABBAUYNAANAIAFC/wGDIAIxAACFp0EDdEGAiQFqKQMAIAFCCIiFIgFC/wGDIAJBAWoxAACFp0EDdEGAiQFqKQMAIAFCCIiFIQEgAkECaiECIANBfmoiAw0ACwtBACABQn+FNwOIiQILZAEBfkEAQQApA4iJAiIAQjiGIABCgP4Dg0IohoQgAEKAgPwHg0IYhiAAQoCAgPgPg0IIhoSEIABCCIhCgICA+A+DIABCGIhCgID8B4OEIABCKIhCgP4DgyAAQjiIhISENwOACQsGAEGIiQILAgALCwsBAEGACAsECAAAAA==", hash$f = "c5ac6c16", wasmJson$f = {
  name: name$f,
  data: data$f,
  hash: hash$f
};
const mutex$g = new Mutex();
let wasmCache$g = null;
const polyBuffer = new Uint8Array(8);
function parsePoly(s) {
  const A = "Polynomial must be provided as a 16 char long hex string";
  if (typeof s != "string" || s.length !== 16)
    return { hi: 0, lo: 0, err: new Error(A) };
  const u = +`0x${s.slice(0, 8)}`, p = +`0x${s.slice(8)}`;
  return Number.isNaN(u) || Number.isNaN(p) ? { hi: u, lo: p, err: new Error(A) } : { hi: u, lo: p, err: null };
}
function writePoly(s, A, u) {
  const p = new DataView(s);
  p.setUint32(0, A, !0), p.setUint32(4, u, !0);
}
function crc64(s, A = "c96c5795d7870f42") {
  const { hi: u, lo: p, err: t } = parsePoly(A);
  if (t !== null)
    return Promise.reject(t);
  if (wasmCache$g === null)
    return lockedCreate(mutex$g, wasmJson$f, 8).then((l) => (wasmCache$g = l, writePoly(polyBuffer.buffer, p, u), wasmCache$g.writeMemory(polyBuffer), wasmCache$g.calculate(s)));
  try {
    writePoly(polyBuffer.buffer, p, u), wasmCache$g.writeMemory(polyBuffer);
    const l = wasmCache$g.calculate(s);
    return Promise.resolve(l);
  } catch (l) {
    return Promise.reject(l);
  }
}
function createCRC64(s = "c96c5795d7870f42") {
  const { hi: A, lo: u, err: p } = parsePoly(s);
  return p !== null ? Promise.reject(p) : WASMInterface(wasmJson$f, 8).then((t) => {
    const l = new Uint8Array(8);
    writePoly(l.buffer, u, A), t.writeMemory(l), t.init();
    const m = {
      init: () => (t.writeMemory(l), t.init(), m),
      update: (b) => (t.update(b), m),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (b) => t.digest(b),
      save: () => t.save(),
      load: (b) => (t.load(b), m),
      blockSize: 8,
      digestSize: 8
    };
    return m;
  });
}
var name$e = "md4", data$e = "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", hash$e = "bd8ce7c7", wasmJson$e = {
  name: name$e,
  data: data$e,
  hash: hash$e
};
const mutex$f = new Mutex();
let wasmCache$f = null;
function md4(s) {
  if (wasmCache$f === null)
    return lockedCreate(mutex$f, wasmJson$e, 16).then((A) => (wasmCache$f = A, wasmCache$f.calculate(s)));
  try {
    const A = wasmCache$f.calculate(s);
    return Promise.resolve(A);
  } catch (A) {
    return Promise.reject(A);
  }
}
function createMD4() {
  return WASMInterface(wasmJson$e, 16).then((s) => {
    s.init();
    const A = {
      init: () => (s.init(), A),
      update: (u) => (s.update(u), A),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (u) => s.digest(u),
      save: () => s.save(),
      load: (u) => (s.load(u), A),
      blockSize: 64,
      digestSize: 16
    };
    return A;
  });
}
var name$d = "md5", data$d = "AGFzbQEAAAABEgRgAAF/YAAAYAF/AGACf38BfwMIBwABAgMBAAIFBAEBAgIGDgJ/AUGgigULfwBBgAgLB3AIBm1lbW9yeQIADkhhc2hfR2V0QnVmZmVyAAAJSGFzaF9Jbml0AAELSGFzaF9VcGRhdGUAAgpIYXNoX0ZpbmFsAAQNSGFzaF9HZXRTdGF0ZQAFDkhhc2hfQ2FsY3VsYXRlAAYKU1RBVEVfU0laRQMBCoMaBwUAQYAJCy0AQQBC/rnrxemOlZkQNwKQiQFBAEKBxpS6lvHq5m83AoiJAUEAQgA3AoCJAQu+BQEHf0EAQQAoAoCJASIBIABqQf////8BcSICNgKAiQFBAEEAKAKEiQEgAiABSWogAEEddmo2AoSJAQJAAkACQAJAAkACQCABQT9xIgMNAEGACSEEDAELIABBwAAgA2siBUkNASAFQQNxIQZBACEBAkAgA0E/c0EDSQ0AIANBgIkBaiEEIAVB/ABxIQdBACEBA0AgBCABaiICQRhqIAFBgAlqLQAAOgAAIAJBGWogAUGBCWotAAA6AAAgAkEaaiABQYIJai0AADoAACACQRtqIAFBgwlqLQAAOgAAIAcgAUEEaiIBRw0ACwsCQCAGRQ0AIANBmIkBaiECA0AgAiABaiABQYAJai0AADoAACABQQFqIQEgBkF/aiIGDQALC0GYiQFBwAAQAxogACAFayEAIAVBgAlqIQQLIABBwABPDQEgACECDAILIABFDQIgAEEDcSEGQQAhAQJAIABBBEkNACADQYCJAWohBCAAQXxxIQBBACEBA0AgBCABaiICQRhqIAFBgAlqLQAAOgAAIAJBGWogAUGBCWotAAA6AAAgAkEaaiABQYIJai0AADoAACACQRtqIAFBgwlqLQAAOgAAIAAgAUEEaiIBRw0ACwsgBkUNAiADQZiJAWohAgNAIAIgAWogAUGACWotAAA6AAAgAUEBaiEBIAZBf2oiBg0ADAMLCyAAQT9xIQIgBCAAQUBxEAMhBAsgAkUNACACQQNxIQZBACEBAkAgAkEESQ0AIAJBPHEhAEEAIQEDQCABQZiJAWogBCABaiICLQAAOgAAIAFBmYkBaiACQQFqLQAAOgAAIAFBmokBaiACQQJqLQAAOgAAIAFBm4kBaiACQQNqLQAAOgAAIAAgAUEEaiIBRw0ACwsgBkUNAANAIAFBmIkBaiAEIAFqLQAAOgAAIAFBAWohASAGQX9qIgYNAAsLC4cQARl/QQAoApSJASECQQAoApCJASEDQQAoAoyJASEEQQAoAoiJASEFA0AgACgCCCIGIAAoAhgiByAAKAIoIgggACgCOCIJIAAoAjwiCiAAKAIMIgsgACgCHCIMIAAoAiwiDSAMIAsgCiANIAkgCCAHIAMgBmogAiAAKAIEIg5qIAUgBCACIANzcSACc2ogACgCACIPakH4yKq7fWpBB3cgBGoiECAEIANzcSADc2pB1u6exn5qQQx3IBBqIhEgECAEc3EgBHNqQdvhgaECakERdyARaiISaiAAKAIUIhMgEWogACgCECIUIBBqIAQgC2ogEiARIBBzcSAQc2pB7p33jXxqQRZ3IBJqIhAgEiARc3EgEXNqQa+f8Kt/akEHdyAQaiIRIBAgEnNxIBJzakGqjJ+8BGpBDHcgEWoiEiARIBBzcSAQc2pBk4zBwXpqQRF3IBJqIhVqIAAoAiQiFiASaiAAKAIgIhcgEWogDCAQaiAVIBIgEXNxIBFzakGBqppqakEWdyAVaiIQIBUgEnNxIBJzakHYsYLMBmpBB3cgEGoiESAQIBVzcSAVc2pBr++T2nhqQQx3IBFqIhIgESAQc3EgEHNqQbG3fWpBEXcgEmoiFWogACgCNCIYIBJqIAAoAjAiGSARaiANIBBqIBUgEiARc3EgEXNqQb6v88p4akEWdyAVaiIQIBUgEnNxIBJzakGiosDcBmpBB3cgEGoiESAQIBVzcSAVc2pBk+PhbGpBDHcgEWoiFSARIBBzcSAQc2pBjofls3pqQRF3IBVqIhJqIAcgFWogDiARaiAKIBBqIBIgFSARc3EgEXNqQaGQ0M0EakEWdyASaiIQIBJzIBVxIBJzakHiyviwf2pBBXcgEGoiESAQcyAScSAQc2pBwOaCgnxqQQl3IBFqIhIgEXMgEHEgEXNqQdG0+bICakEOdyASaiIVaiAIIBJqIBMgEWogDyAQaiAVIBJzIBFxIBJzakGqj9vNfmpBFHcgFWoiECAVcyAScSAVc2pB3aC8sX1qQQV3IBBqIhEgEHMgFXEgEHNqQdOokBJqQQl3IBFqIhIgEXMgEHEgEXNqQYHNh8V9akEOdyASaiIVaiAJIBJqIBYgEWogFCAQaiAVIBJzIBFxIBJzakHI98++fmpBFHcgFWoiECAVcyAScSAVc2pB5puHjwJqQQV3IBBqIhEgEHMgFXEgEHNqQdaP3Jl8akEJdyARaiISIBFzIBBxIBFzakGHm9Smf2pBDncgEmoiFWogBiASaiAYIBFqIBcgEGogFSAScyARcSASc2pB7anoqgRqQRR3IBVqIhAgFXMgEnEgFXNqQYXSj896akEFdyAQaiIRIBBzIBVxIBBzakH4x75nakEJdyARaiISIBFzIBBxIBFzakHZhby7BmpBDncgEmoiFWogFyASaiATIBFqIBkgEGogFSAScyARcSASc2pBipmp6XhqQRR3IBVqIhAgFXMiFSASc2pBwvJoakEEdyAQaiIRIBVzakGB7ce7eGpBC3cgEWoiEiARcyIaIBBzakGiwvXsBmpBEHcgEmoiFWogFCASaiAOIBFqIAkgEGogFSAac2pBjPCUb2pBF3cgFWoiECAVcyIVIBJzakHE1PulempBBHcgEGoiESAVc2pBqZ/73gRqQQt3IBFqIhIgEXMiCSAQc2pB4JbttX9qQRB3IBJqIhVqIA8gEmogGCARaiAIIBBqIBUgCXNqQfD4/vV7akEXdyAVaiIQIBVzIhUgEnNqQcb97cQCakEEdyAQaiIRIBVzakH6z4TVfmpBC3cgEWoiEiARcyIIIBBzakGF4bynfWpBEHcgEmoiFWogGSASaiAWIBFqIAcgEGogFSAIc2pBhbqgJGpBF3cgFWoiESAVcyIQIBJzakG5oNPOfWpBBHcgEWoiEiAQc2pB5bPutn5qQQt3IBJqIhUgEnMiByARc2pB+PmJ/QFqQRB3IBVqIhBqIAwgFWogDyASaiAGIBFqIBAgB3NqQeWssaV8akEXdyAQaiIRIBVBf3NyIBBzakHExKShf2pBBncgEWoiEiAQQX9zciARc2pBl/+rmQRqQQp3IBJqIhAgEUF/c3IgEnNqQafH0Nx6akEPdyAQaiIVaiALIBBqIBkgEmogEyARaiAVIBJBf3NyIBBzakG5wM5kakEVdyAVaiIRIBBBf3NyIBVzakHDs+2qBmpBBncgEWoiECAVQX9zciARc2pBkpmz+HhqQQp3IBBqIhIgEUF/c3IgEHNqQf3ov39qQQ93IBJqIhVqIAogEmogFyAQaiAOIBFqIBUgEEF/c3IgEnNqQdG7kax4akEVdyAVaiIQIBJBf3NyIBVzakHP/KH9BmpBBncgEGoiESAVQX9zciAQc2pB4M2zcWpBCncgEWoiEiAQQX9zciARc2pBlIaFmHpqQQ93IBJqIhVqIA0gEmogFCARaiAYIBBqIBUgEUF/c3IgEnNqQaGjoPAEakEVdyAVaiIQIBJBf3NyIBVzakGC/c26f2pBBncgEGoiESAVQX9zciAQc2pBteTr6XtqQQp3IBFqIhIgEEF/c3IgEXNqQbul39YCakEPdyASaiIVIARqIBYgEGogFSARQX9zciASc2pBkaeb3H5qQRV3aiEEIBUgA2ohAyASIAJqIQIgESAFaiEFIABBwABqIQAgAUFAaiIBDQALQQAgAjYClIkBQQAgAzYCkIkBQQAgBDYCjIkBQQAgBTYCiIkBIAALyAMBBX9BACgCgIkBQT9xIgBBmIkBakGAAToAACAAQQFqIQECQAJAAkACQCAAQT9zIgJBB0sNACACRQ0BIAFBmIkBakEAOgAAIAJBAUYNASAAQZqJAWpBADoAACACQQJGDQEgAEGbiQFqQQA6AAAgAkEDRg0BIABBnIkBakEAOgAAIAJBBEYNASAAQZ2JAWpBADoAACACQQVGDQEgAEGeiQFqQQA6AAAgAkEGRg0BIABBn4kBakEAOgAADAELIAJBCEYNAkE2IABrIgMhBAJAIAJBA3EiAEUNAEEAIABrIQRBACEAA0AgAEHPiQFqQQA6AAAgBCAAQX9qIgBHDQALIAMgAGohBAsgA0EDSQ0CDAELQZiJAUHAABADGkEAIQFBNyEECyABQYCJAWohAEF/IQIDQCAAIARqQRVqQQA2AAAgAEF8aiEAIAQgAkEEaiICRw0ACwtBAEEAKAKEiQE2AtSJAUEAQQAoAoCJASIAQRV2OgDTiQFBACAAQQ12OgDSiQFBACAAQQV2OgDRiQFBACAAQQN0IgA6ANCJAUEAIAA2AoCJAUGYiQFBwAAQAxpBAEEAKQKIiQE3A4AJQQBBACkCkIkBNwOICQsGAEGAiQELMwBBAEL+uevF6Y6VmRA3ApCJAUEAQoHGlLqW8ermbzcCiIkBQQBCADcCgIkBIAAQAhAECwsLAQBBgAgLBJgAAAA=", hash$d = "e6508e4b", wasmJson$d = {
  name: name$d,
  data: data$d,
  hash: hash$d
};
const mutex$e = new Mutex();
let wasmCache$e = null;
function md5(s) {
  if (wasmCache$e === null)
    return lockedCreate(mutex$e, wasmJson$d, 16).then((A) => (wasmCache$e = A, wasmCache$e.calculate(s)));
  try {
    const A = wasmCache$e.calculate(s);
    return Promise.resolve(A);
  } catch (A) {
    return Promise.reject(A);
  }
}
function createMD5() {
  return WASMInterface(wasmJson$d, 16).then((s) => {
    s.init();
    const A = {
      init: () => (s.init(), A),
      update: (u) => (s.update(u), A),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (u) => s.digest(u),
      save: () => s.save(),
      load: (u) => (s.load(u), A),
      blockSize: 64,
      digestSize: 16
    };
    return A;
  });
}
var name$c = "sha1", data$c = "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", hash$c = "6b530c24", wasmJson$c = {
  name: name$c,
  data: data$c,
  hash: hash$c
};
const mutex$d = new Mutex();
let wasmCache$d = null;
function sha1(s) {
  if (wasmCache$d === null)
    return lockedCreate(mutex$d, wasmJson$c, 20).then((A) => (wasmCache$d = A, wasmCache$d.calculate(s)));
  try {
    const A = wasmCache$d.calculate(s);
    return Promise.resolve(A);
  } catch (A) {
    return Promise.reject(A);
  }
}
function createSHA1() {
  return WASMInterface(wasmJson$c, 20).then((s) => {
    s.init();
    const A = {
      init: () => (s.init(), A),
      update: (u) => (s.update(u), A),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (u) => s.digest(u),
      save: () => s.save(),
      load: (u) => (s.load(u), A),
      blockSize: 64,
      digestSize: 20
    };
    return A;
  });
}
var name$b = "sha3", data$b = "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", hash$b = "fb24e536", wasmJson$b = {
  name: name$b,
  data: data$b,
  hash: hash$b
};
const mutex$c = new Mutex();
let wasmCache$c = null;
function validateBits$1(s) {
  return [224, 256, 384, 512].includes(s) ? null : new Error("Invalid variant! Valid values: 224, 256, 384, 512");
}
function sha3(s, A = 512) {
  if (validateBits$1(A))
    return Promise.reject(validateBits$1(A));
  const u = A / 8;
  if (wasmCache$c === null || wasmCache$c.hashLength !== u)
    return lockedCreate(mutex$c, wasmJson$b, u).then((p) => (wasmCache$c = p, wasmCache$c.calculate(s, A, 6)));
  try {
    const p = wasmCache$c.calculate(s, A, 6);
    return Promise.resolve(p);
  } catch (p) {
    return Promise.reject(p);
  }
}
function createSHA3(s = 512) {
  if (validateBits$1(s))
    return Promise.reject(validateBits$1(s));
  const A = s / 8;
  return WASMInterface(wasmJson$b, A).then((u) => {
    u.init(s);
    const p = {
      init: () => (u.init(s), p),
      update: (t) => (u.update(t), p),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (t) => u.digest(t, 6),
      save: () => u.save(),
      load: (t) => (u.load(t), p),
      blockSize: 200 - 2 * A,
      digestSize: A
    };
    return p;
  });
}
const mutex$b = new Mutex();
let wasmCache$b = null;
function validateBits(s) {
  return [224, 256, 384, 512].includes(s) ? null : new Error("Invalid variant! Valid values: 224, 256, 384, 512");
}
function keccak(s, A = 512) {
  if (validateBits(A))
    return Promise.reject(validateBits(A));
  const u = A / 8;
  if (wasmCache$b === null || wasmCache$b.hashLength !== u)
    return lockedCreate(mutex$b, wasmJson$b, u).then((p) => (wasmCache$b = p, wasmCache$b.calculate(s, A, 1)));
  try {
    const p = wasmCache$b.calculate(s, A, 1);
    return Promise.resolve(p);
  } catch (p) {
    return Promise.reject(p);
  }
}
function createKeccak(s = 512) {
  if (validateBits(s))
    return Promise.reject(validateBits(s));
  const A = s / 8;
  return WASMInterface(wasmJson$b, A).then((u) => {
    u.init(s);
    const p = {
      init: () => (u.init(s), p),
      update: (t) => (u.update(t), p),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (t) => u.digest(t, 1),
      save: () => u.save(),
      load: (t) => (u.load(t), p),
      blockSize: 200 - 2 * A,
      digestSize: A
    };
    return p;
  });
}
var name$a = "sha256", data$a = "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", hash$a = "8c18dd94", wasmJson$a = {
  name: name$a,
  data: data$a,
  hash: hash$a
};
const mutex$a = new Mutex();
let wasmCache$a = null;
function sha224(s) {
  if (wasmCache$a === null)
    return lockedCreate(mutex$a, wasmJson$a, 28).then((A) => (wasmCache$a = A, wasmCache$a.calculate(s, 224)));
  try {
    const A = wasmCache$a.calculate(s, 224);
    return Promise.resolve(A);
  } catch (A) {
    return Promise.reject(A);
  }
}
function createSHA224() {
  return WASMInterface(wasmJson$a, 28).then((s) => {
    s.init(224);
    const A = {
      init: () => (s.init(224), A),
      update: (u) => (s.update(u), A),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (u) => s.digest(u),
      save: () => s.save(),
      load: (u) => (s.load(u), A),
      blockSize: 64,
      digestSize: 28
    };
    return A;
  });
}
const mutex$9 = new Mutex();
let wasmCache$9 = null;
function sha256$3(s) {
  if (wasmCache$9 === null)
    return lockedCreate(mutex$9, wasmJson$a, 32).then((A) => (wasmCache$9 = A, wasmCache$9.calculate(s, 256)));
  try {
    const A = wasmCache$9.calculate(s, 256);
    return Promise.resolve(A);
  } catch (A) {
    return Promise.reject(A);
  }
}
function createSHA256() {
  return WASMInterface(wasmJson$a, 32).then((s) => {
    s.init(256);
    const A = {
      init: () => (s.init(256), A),
      update: (u) => (s.update(u), A),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (u) => s.digest(u),
      save: () => s.save(),
      load: (u) => (s.load(u), A),
      blockSize: 64,
      digestSize: 32
    };
    return A;
  });
}
var name$9 = "sha512", data$9 = "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", hash$9 = "f2e40eb1", wasmJson$9 = {
  name: name$9,
  data: data$9,
  hash: hash$9
};
const mutex$8 = new Mutex();
let wasmCache$8 = null;
function sha384(s) {
  if (wasmCache$8 === null)
    return lockedCreate(mutex$8, wasmJson$9, 48).then((A) => (wasmCache$8 = A, wasmCache$8.calculate(s, 384)));
  try {
    const A = wasmCache$8.calculate(s, 384);
    return Promise.resolve(A);
  } catch (A) {
    return Promise.reject(A);
  }
}
function createSHA384() {
  return WASMInterface(wasmJson$9, 48).then((s) => {
    s.init(384);
    const A = {
      init: () => (s.init(384), A),
      update: (u) => (s.update(u), A),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (u) => s.digest(u),
      save: () => s.save(),
      load: (u) => (s.load(u), A),
      blockSize: 128,
      digestSize: 48
    };
    return A;
  });
}
const mutex$7 = new Mutex();
let wasmCache$7 = null;
function sha512$1(s) {
  if (wasmCache$7 === null)
    return lockedCreate(mutex$7, wasmJson$9, 64).then((A) => (wasmCache$7 = A, wasmCache$7.calculate(s, 512)));
  try {
    const A = wasmCache$7.calculate(s, 512);
    return Promise.resolve(A);
  } catch (A) {
    return Promise.reject(A);
  }
}
function createSHA512() {
  return WASMInterface(wasmJson$9, 64).then((s) => {
    s.init(512);
    const A = {
      init: () => (s.init(512), A),
      update: (u) => (s.update(u), A),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (u) => s.digest(u),
      save: () => s.save(),
      load: (u) => (s.load(u), A),
      blockSize: 128,
      digestSize: 64
    };
    return A;
  });
}
var name$8 = "xxhash32", data$8 = "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", hash$8 = "4bb12485", wasmJson$8 = {
  name: name$8,
  data: data$8,
  hash: hash$8
};
const mutex$6 = new Mutex();
let wasmCache$6 = null;
function validateSeed$3(s) {
  return !Number.isInteger(s) || s < 0 || s > 4294967295 ? new Error("Seed must be a valid 32-bit long unsigned integer.") : null;
}
function xxhash32(s, A = 0) {
  if (validateSeed$3(A))
    return Promise.reject(validateSeed$3(A));
  if (wasmCache$6 === null)
    return lockedCreate(mutex$6, wasmJson$8, 4).then((u) => (wasmCache$6 = u, wasmCache$6.calculate(s, A)));
  try {
    const u = wasmCache$6.calculate(s, A);
    return Promise.resolve(u);
  } catch (u) {
    return Promise.reject(u);
  }
}
function createXXHash32(s = 0) {
  return validateSeed$3(s) ? Promise.reject(validateSeed$3(s)) : WASMInterface(wasmJson$8, 4).then((A) => {
    A.init(s);
    const u = {
      init: () => (A.init(s), u),
      update: (p) => (A.update(p), u),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (p) => A.digest(p),
      save: () => A.save(),
      load: (p) => (A.load(p), u),
      blockSize: 16,
      digestSize: 4
    };
    return u;
  });
}
var name$7 = "xxhash64", data$7 = "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", hash$7 = "177fbfa3", wasmJson$7 = {
  name: name$7,
  data: data$7,
  hash: hash$7
};
const mutex$5 = new Mutex();
let wasmCache$5 = null;
const seedBuffer$2 = new Uint8Array(8);
function validateSeed$2(s) {
  return !Number.isInteger(s) || s < 0 || s > 4294967295 ? new Error("Seed must be given as two valid 32-bit long unsigned integers (lo + high).") : null;
}
function writeSeed$2(s, A, u) {
  const p = new DataView(s);
  p.setUint32(0, A, !0), p.setUint32(4, u, !0);
}
function xxhash64(s, A = 0, u = 0) {
  if (validateSeed$2(A))
    return Promise.reject(validateSeed$2(A));
  if (validateSeed$2(u))
    return Promise.reject(validateSeed$2(u));
  if (wasmCache$5 === null)
    return lockedCreate(mutex$5, wasmJson$7, 8).then((p) => (wasmCache$5 = p, writeSeed$2(seedBuffer$2.buffer, A, u), wasmCache$5.writeMemory(seedBuffer$2), wasmCache$5.calculate(s)));
  try {
    writeSeed$2(seedBuffer$2.buffer, A, u), wasmCache$5.writeMemory(seedBuffer$2);
    const p = wasmCache$5.calculate(s);
    return Promise.resolve(p);
  } catch (p) {
    return Promise.reject(p);
  }
}
function createXXHash64(s = 0, A = 0) {
  return validateSeed$2(s) ? Promise.reject(validateSeed$2(s)) : validateSeed$2(A) ? Promise.reject(validateSeed$2(A)) : WASMInterface(wasmJson$7, 8).then((u) => {
    const p = new Uint8Array(8);
    writeSeed$2(p.buffer, s, A), u.writeMemory(p), u.init();
    const t = {
      init: () => (u.writeMemory(p), u.init(), t),
      update: (l) => (u.update(l), t),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (l) => u.digest(l),
      save: () => u.save(),
      load: (l) => (u.load(l), t),
      blockSize: 32,
      digestSize: 8
    };
    return t;
  });
}
var name$6 = "xxhash3", data$6 = "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", hash$6 = "5a2fbdbb", wasmJson$6 = {
  name: name$6,
  data: data$6,
  hash: hash$6
};
const mutex$4 = new Mutex();
let wasmCache$4 = null;
const seedBuffer$1 = new Uint8Array(8);
function validateSeed$1(s) {
  return !Number.isInteger(s) || s < 0 || s > 4294967295 ? new Error("Seed must be given as two valid 32-bit long unsigned integers (lo + high).") : null;
}
function writeSeed$1(s, A, u) {
  const p = new DataView(s);
  p.setUint32(0, A, !0), p.setUint32(4, u, !0);
}
function xxhash3(s, A = 0, u = 0) {
  if (validateSeed$1(A))
    return Promise.reject(validateSeed$1(A));
  if (validateSeed$1(u))
    return Promise.reject(validateSeed$1(u));
  if (wasmCache$4 === null)
    return lockedCreate(mutex$4, wasmJson$6, 8).then((p) => (wasmCache$4 = p, writeSeed$1(seedBuffer$1.buffer, A, u), wasmCache$4.writeMemory(seedBuffer$1), wasmCache$4.calculate(s)));
  try {
    writeSeed$1(seedBuffer$1.buffer, A, u), wasmCache$4.writeMemory(seedBuffer$1);
    const p = wasmCache$4.calculate(s);
    return Promise.resolve(p);
  } catch (p) {
    return Promise.reject(p);
  }
}
function createXXHash3(s = 0, A = 0) {
  return validateSeed$1(s) ? Promise.reject(validateSeed$1(s)) : validateSeed$1(A) ? Promise.reject(validateSeed$1(A)) : WASMInterface(wasmJson$6, 8).then((u) => {
    const p = new Uint8Array(8);
    writeSeed$1(p.buffer, s, A), u.writeMemory(p), u.init();
    const t = {
      init: () => (u.writeMemory(p), u.init(), t),
      update: (l) => (u.update(l), t),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (l) => u.digest(l),
      save: () => u.save(),
      load: (l) => (u.load(l), t),
      blockSize: 512,
      digestSize: 8
    };
    return t;
  });
}
var name$5 = "xxhash128", data$5 = "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", hash$5 = "b9ab74e2", wasmJson$5 = {
  name: name$5,
  data: data$5,
  hash: hash$5
};
const mutex$3 = new Mutex();
let wasmCache$3 = null;
const seedBuffer = new Uint8Array(8);
function validateSeed(s) {
  return !Number.isInteger(s) || s < 0 || s > 4294967295 ? new Error("Seed must be given as two valid 32-bit long unsigned integers (lo + high).") : null;
}
function writeSeed(s, A, u) {
  const p = new DataView(s);
  p.setUint32(0, A, !0), p.setUint32(4, u, !0);
}
function xxhash128(s, A = 0, u = 0) {
  if (validateSeed(A))
    return Promise.reject(validateSeed(A));
  if (validateSeed(u))
    return Promise.reject(validateSeed(u));
  if (wasmCache$3 === null)
    return lockedCreate(mutex$3, wasmJson$5, 16).then((p) => (wasmCache$3 = p, writeSeed(seedBuffer.buffer, A, u), wasmCache$3.writeMemory(seedBuffer), wasmCache$3.calculate(s)));
  try {
    writeSeed(seedBuffer.buffer, A, u), wasmCache$3.writeMemory(seedBuffer);
    const p = wasmCache$3.calculate(s);
    return Promise.resolve(p);
  } catch (p) {
    return Promise.reject(p);
  }
}
function createXXHash128(s = 0, A = 0) {
  return validateSeed(s) ? Promise.reject(validateSeed(s)) : validateSeed(A) ? Promise.reject(validateSeed(A)) : WASMInterface(wasmJson$5, 16).then((u) => {
    const p = new Uint8Array(8);
    writeSeed(p.buffer, s, A), u.writeMemory(p), u.init();
    const t = {
      init: () => (u.writeMemory(p), u.init(), t),
      update: (l) => (u.update(l), t),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (l) => u.digest(l),
      save: () => u.save(),
      load: (l) => (u.load(l), t),
      blockSize: 512,
      digestSize: 16
    };
    return t;
  });
}
var name$4 = "ripemd160", data$4 = "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", hash$4 = "6abbce74", wasmJson$4 = {
  name: name$4,
  data: data$4,
  hash: hash$4
};
const mutex$2 = new Mutex();
let wasmCache$2 = null;
function ripemd160$1(s) {
  if (wasmCache$2 === null)
    return lockedCreate(mutex$2, wasmJson$4, 20).then((A) => (wasmCache$2 = A, wasmCache$2.calculate(s)));
  try {
    const A = wasmCache$2.calculate(s);
    return Promise.resolve(A);
  } catch (A) {
    return Promise.reject(A);
  }
}
function createRIPEMD160() {
  return WASMInterface(wasmJson$4, 20).then((s) => {
    s.init();
    const A = {
      init: () => (s.init(), A),
      update: (u) => (s.update(u), A),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (u) => s.digest(u),
      save: () => s.save(),
      load: (u) => (s.load(u), A),
      blockSize: 64,
      digestSize: 20
    };
    return A;
  });
}
function calculateKeyBuffer(s, A) {
  const { blockSize: u } = s, p = getUInt8Buffer(A);
  if (p.length > u) {
    s.update(p);
    const t = s.digest("binary");
    return s.init(), t;
  }
  return new Uint8Array(p.buffer, p.byteOffset, p.length);
}
function calculateHmac(s, A) {
  s.init();
  const { blockSize: u } = s, p = calculateKeyBuffer(s, A), t = new Uint8Array(u);
  t.set(p);
  const l = new Uint8Array(u);
  for (let b = 0; b < u; b++) {
    const k = t[b];
    l[b] = k ^ 92, t[b] = k ^ 54;
  }
  s.update(t);
  const m = {
    init: () => (s.init(), s.update(t), m),
    update: (b) => (s.update(b), m),
    digest: (b) => {
      const k = s.digest("binary");
      return s.init(), s.update(l), s.update(k), s.digest(b);
    },
    save: () => {
      throw new Error("save() not supported");
    },
    load: () => {
      throw new Error("load() not supported");
    },
    blockSize: s.blockSize,
    digestSize: s.digestSize
  };
  return m;
}
function createHMAC(s, A) {
  if (!s || !s.then)
    throw new Error('Invalid hash function is provided! Usage: createHMAC(createMD5(), "key").');
  return s.then((u) => calculateHmac(u, A));
}
function calculatePBKDF2(s, A, u, p, t) {
  return __awaiter(this, void 0, void 0, function* () {
    const l = new Uint8Array(p), m = new Uint8Array(A.length + 4), b = new DataView(m.buffer), k = getUInt8Buffer(A), C = new Uint8Array(k.buffer, k.byteOffset, k.length);
    m.set(C);
    let B = 0;
    const Q = s.digestSize, P = Math.ceil(p / Q);
    let x = null, M = null;
    for (let le = 1; le <= P; le++) {
      b.setUint32(A.length, le), s.init(), s.update(m), x = s.digest("binary"), M = x.slice();
      for (let ge = 1; ge < u; ge++) {
        s.init(), s.update(M), M = s.digest("binary");
        for (let pe = 0; pe < Q; pe++)
          x[pe] ^= M[pe];
      }
      l.set(x.subarray(0, p - B), B), B += Q;
    }
    if (t === "binary")
      return l;
    const F = new Uint8Array(p * 2);
    return getDigestHex(F, l, p);
  });
}
const validateOptions$2 = (s) => {
  if (!s || typeof s != "object")
    throw new Error("Invalid options parameter. It requires an object.");
  if (!s.hashFunction || !s.hashFunction.then)
    throw new Error('Invalid hash function is provided! Usage: pbkdf2("password", "salt", 1000, 32, createSHA1()).');
  if (!Number.isInteger(s.iterations) || s.iterations < 1)
    throw new Error("Iterations should be a positive number");
  if (!Number.isInteger(s.hashLength) || s.hashLength < 1)
    throw new Error("Hash length should be a positive number");
  if (s.outputType === void 0 && (s.outputType = "hex"), !["hex", "binary"].includes(s.outputType))
    throw new Error(`Insupported output type ${s.outputType}. Valid values: ['hex', 'binary']`);
};
function pbkdf2(s) {
  return __awaiter(this, void 0, void 0, function* () {
    validateOptions$2(s);
    const A = yield createHMAC(s.hashFunction, s.password);
    return calculatePBKDF2(A, s.salt, s.iterations, s.hashLength, s.outputType);
  });
}
var name$3 = "scrypt", data$3 = "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", hash$3 = "b32721f8", wasmJson$3 = {
  name: name$3,
  data: data$3,
  hash: hash$3
};
function scryptInternal(s) {
  return __awaiter(this, void 0, void 0, function* () {
    const { costFactor: A, blockSize: u, parallelism: p, hashLength: t } = s, l = createSHA256(), m = yield pbkdf2({
      password: s.password,
      salt: s.salt,
      iterations: 1,
      hashLength: 128 * u * p,
      hashFunction: l,
      outputType: "binary"
    }), b = yield WASMInterface(wasmJson$3, 0), k = 128 * u * A, C = 256 * u;
    b.setMemorySize(m.length + k + C), b.writeMemory(m, 0), b.getExports().scrypt(u, A, p);
    const B = b.getMemory().subarray(0, 128 * u * p), Q = yield pbkdf2({
      password: s.password,
      salt: B,
      iterations: 1,
      hashLength: t,
      hashFunction: l,
      outputType: "binary"
    });
    if (s.outputType === "hex") {
      const P = new Uint8Array(t * 2);
      return getDigestHex(P, Q, t);
    }
    return Q;
  });
}
const isPowerOfTwo = (s) => s && !(s & s - 1), validateOptions$1 = (s) => {
  if (!s || typeof s != "object")
    throw new Error("Invalid options parameter. It requires an object.");
  if (!Number.isInteger(s.blockSize) || s.blockSize < 1)
    throw new Error("Block size should be a positive number");
  if (!Number.isInteger(s.costFactor) || s.costFactor < 2 || !isPowerOfTwo(s.costFactor))
    throw new Error("Cost factor should be a power of 2, greater than 1");
  if (!Number.isInteger(s.parallelism) || s.parallelism < 1)
    throw new Error("Parallelism should be a positive number");
  if (!Number.isInteger(s.hashLength) || s.hashLength < 1)
    throw new Error("Hash length should be a positive number.");
  if (s.outputType === void 0 && (s.outputType = "hex"), !["hex", "binary"].includes(s.outputType))
    throw new Error(`Insupported output type ${s.outputType}. Valid values: ['hex', 'binary']`);
};
function scrypt(s) {
  return __awaiter(this, void 0, void 0, function* () {
    return validateOptions$1(s), scryptInternal(s);
  });
}
var name$2 = "bcrypt", data$2 = "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", hash$2 = "8bd8822d", wasmJson$2 = {
  name: name$2,
  data: data$2,
  hash: hash$2
};
function bcryptInternal(s) {
  return __awaiter(this, void 0, void 0, function* () {
    const { costFactor: A, password: u, salt: p } = s, t = yield WASMInterface(wasmJson$2, 0);
    t.writeMemory(getUInt8Buffer(p), 0);
    const l = getUInt8Buffer(u);
    t.writeMemory(l, 16);
    const m = s.outputType === "encoded" ? 1 : 0;
    t.getExports().bcrypt(l.length, A, m);
    const b = t.getMemory();
    if (s.outputType === "encoded")
      return intArrayToString(b, 60);
    if (s.outputType === "hex") {
      const k = new Uint8Array(48);
      return getDigestHex(k, b, 24);
    }
    return b.slice(0, 24);
  });
}
const validateOptions = (s) => {
  if (!s || typeof s != "object")
    throw new Error("Invalid options parameter. It requires an object.");
  if (!Number.isInteger(s.costFactor) || s.costFactor < 4 || s.costFactor > 31)
    throw new Error("Cost factor should be a number between 4 and 31");
  if (s.password = getUInt8Buffer(s.password), s.password.length < 1)
    throw new Error("Password should be at least 1 byte long");
  if (s.password.length > 72)
    throw new Error("Password should be at most 72 bytes long");
  if (s.salt = getUInt8Buffer(s.salt), s.salt.length !== 16)
    throw new Error("Salt should be 16 bytes long");
  if (s.outputType === void 0 && (s.outputType = "encoded"), !["hex", "binary", "encoded"].includes(s.outputType))
    throw new Error(`Insupported output type ${s.outputType}. Valid values: ['hex', 'binary', 'encoded']`);
};
function bcrypt(s) {
  return __awaiter(this, void 0, void 0, function* () {
    return validateOptions(s), bcryptInternal(s);
  });
}
const validateHashCharacters = (s) => !(!/^\$2[axyb]\$[0-3][0-9]\$[./A-Za-z0-9]{53}$/.test(s) || s[4] === "0" && Number(s[5]) < 4 || s[4] === "3" && Number(s[5]) > 1), validateVerifyOptions = (s) => {
  if (!s || typeof s != "object")
    throw new Error("Invalid options parameter. It requires an object.");
  if (s.hash === void 0 || typeof s.hash != "string")
    throw new Error("Hash should be specified");
  if (s.hash.length !== 60)
    throw new Error("Hash should be 60 bytes long");
  if (!validateHashCharacters(s.hash))
    throw new Error("Invalid hash");
  if (s.password = getUInt8Buffer(s.password), s.password.length < 1)
    throw new Error("Password should be at least 1 byte long");
  if (s.password.length > 72)
    throw new Error("Password should be at most 72 bytes long");
};
function bcryptVerify(s) {
  return __awaiter(this, void 0, void 0, function* () {
    validateVerifyOptions(s);
    const { hash: A, password: u } = s, p = yield WASMInterface(wasmJson$2, 0);
    p.writeMemory(getUInt8Buffer(A), 0);
    const t = getUInt8Buffer(u);
    return p.writeMemory(t, 60), !!p.getExports().bcrypt_verify(t.length);
  });
}
var name$1 = "whirlpool", data$1 = "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", hash$1 = "8d8f6035", wasmJson$1 = {
  name: name$1,
  data: data$1,
  hash: hash$1
};
const mutex$1 = new Mutex();
let wasmCache$1 = null;
function whirlpool(s) {
  if (wasmCache$1 === null)
    return lockedCreate(mutex$1, wasmJson$1, 64).then((A) => (wasmCache$1 = A, wasmCache$1.calculate(s)));
  try {
    const A = wasmCache$1.calculate(s);
    return Promise.resolve(A);
  } catch (A) {
    return Promise.reject(A);
  }
}
function createWhirlpool() {
  return WASMInterface(wasmJson$1, 64).then((s) => {
    s.init();
    const A = {
      init: () => (s.init(), A),
      update: (u) => (s.update(u), A),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (u) => s.digest(u),
      save: () => s.save(),
      load: (u) => (s.load(u), A),
      blockSize: 64,
      digestSize: 64
    };
    return A;
  });
}
var name = "sm3", data$m = "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", hash$m = "b6fb4b8e", wasmJson = {
  name,
  data: data$m,
  hash: hash$m
};
const mutex = new Mutex();
let wasmCache = null;
function sm3(s) {
  if (wasmCache === null)
    return lockedCreate(mutex, wasmJson, 32).then((A) => (wasmCache = A, wasmCache.calculate(s)));
  try {
    const A = wasmCache.calculate(s);
    return Promise.resolve(A);
  } catch (A) {
    return Promise.reject(A);
  }
}
function createSM3() {
  return WASMInterface(wasmJson, 32).then((s) => {
    s.init();
    const A = {
      init: () => (s.init(), A),
      update: (u) => (s.update(u), A),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (u) => s.digest(u),
      save: () => s.save(),
      load: (u) => (s.load(u), A),
      blockSize: 64,
      digestSize: 32
    };
    return A;
  });
}
const index_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  adler32,
  argon2Verify,
  argon2d,
  argon2i,
  argon2id,
  bcrypt,
  bcryptVerify,
  blake2b,
  blake2s,
  blake3,
  crc32,
  crc64,
  createAdler32,
  createBLAKE2b,
  createBLAKE2s,
  createBLAKE3,
  createCRC32,
  createCRC64,
  createHMAC,
  createKeccak,
  createMD4,
  createMD5,
  createRIPEMD160,
  createSHA1,
  createSHA224,
  createSHA256,
  createSHA3,
  createSHA384,
  createSHA512,
  createSM3,
  createWhirlpool,
  createXXHash128,
  createXXHash3,
  createXXHash32,
  createXXHash64,
  keccak,
  md4,
  md5,
  pbkdf2,
  ripemd160: ripemd160$1,
  scrypt,
  sha1,
  sha224,
  sha256: sha256$3,
  sha3,
  sha384,
  sha512: sha512$1,
  sm3,
  whirlpool,
  xxhash128,
  xxhash3,
  xxhash32,
  xxhash64
}, Symbol.toStringTag, { value: "Module" })), require$$3 = /* @__PURE__ */ getAugmentedNamespace(index_esm);
var hasRequiredLibsodium;
function requireLibsodium() {
  if (hasRequiredLibsodium) return libsodium;
  hasRequiredLibsodium = 1, Object.defineProperty(libsodium, "__esModule", { value: !0 }), libsodium.Xchacha20poly1305Ietf = libsodium.xchacha20NonceLength = libsodium.Ed25519 = libsodium.Ed25519Keypair = libsodium.Argon2id = void 0, libsodium.isArgon2idOptions = t;
  const s = requireBuild$3(), A = /* @__PURE__ */ requireChacha(), u = /* @__PURE__ */ requireEd25519(), p = require$$3;
  function t(C) {
    return !(!(0, s.isNonNullObject)(C) || typeof C.outputLength != "number" || typeof C.opsLimit != "number" || typeof C.memLimitKib != "number");
  }
  class l {
    static async execute(B, Q, P) {
      const x = {
        password: B,
        salt: Q,
        outputType: "binary",
        iterations: P.opsLimit,
        memorySize: P.memLimitKib,
        parallelism: 1,
        // no parallelism allowed, just like libsodium
        hashLength: P.outputLength
      };
      if (Q.length !== 16)
        throw new Error(`Got invalid salt length ${Q.length}. Must be 16.`);
      const M = await (0, p.argon2id)(x);
      return (0, s.assert)(typeof M != "string"), M;
    }
  }
  libsodium.Argon2id = l;
  class m {
    constructor(B, Q) {
      Ci(this, "privkey");
      Ci(this, "pubkey");
      this.privkey = B, this.pubkey = Q;
    }
    // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
    static fromLibsodiumPrivkey(B) {
      if (B.length !== 64)
        throw new Error(`Unexpected key length ${B.length}. Must be 64.`);
      return new m(B.slice(0, 32), B.slice(32, 64));
    }
    toLibsodiumPrivkey() {
      return new Uint8Array([...this.privkey, ...this.pubkey]);
    }
  }
  libsodium.Ed25519Keypair = m;
  class b {
    /**
     * Generates a keypair deterministically from a given 32 bytes seed.
     *
     * This seed equals the Ed25519 private key.
     * For implementation details see crypto_sign_seed_keypair in
     * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
     * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
     */
    static async makeKeypair(B) {
      const Q = u.ed25519.getPublicKey(B);
      return new m(B, Q);
    }
    static async createSignature(B, Q) {
      return u.ed25519.sign(B, Q.privkey);
    }
    static async verifySignature(B, Q, P) {
      return u.ed25519.verify(B, Q, P);
    }
  }
  libsodium.Ed25519 = b, libsodium.xchacha20NonceLength = 24;
  class k {
    static async encrypt(B, Q, P) {
      return (0, A.xchacha20poly1305)(Q, P, void 0).encrypt(B);
    }
    static async decrypt(B, Q, P) {
      return (0, A.xchacha20poly1305)(Q, P, void 0).decrypt(B);
    }
  }
  return libsodium.Xchacha20poly1305Ietf = k, libsodium;
}
var random = {}, hasRequiredRandom;
function requireRandom() {
  if (hasRequiredRandom) return random;
  hasRequiredRandom = 1, Object.defineProperty(random, "__esModule", { value: !0 }), random.Random = void 0;
  class s {
    /**
     * Returns `count` cryptographically secure random bytes
     */
    static getBytes(u) {
      const p = new Uint8Array(u);
      return globalThis.crypto.getRandomValues(p), p;
    }
  }
  return random.Random = s, random;
}
var ripemd = {}, hasRequiredRipemd;
function requireRipemd() {
  if (hasRequiredRipemd) return ripemd;
  hasRequiredRipemd = 1, Object.defineProperty(ripemd, "__esModule", { value: !0 }), ripemd.Ripemd160 = void 0, ripemd.ripemd160 = p;
  const s = /* @__PURE__ */ requireLegacy$1(), A = requireUtils$3();
  class u {
    constructor(l) {
      Ci(this, "blockSize", 512 / 8);
      Ci(this, "impl", s.ripemd160.create());
      l && this.update(l);
    }
    update(l) {
      return this.impl.update((0, A.toRealUint8Array)(l)), this;
    }
    digest() {
      return this.impl.digest();
    }
  }
  ripemd.Ripemd160 = u;
  function p(t) {
    return new u(t).digest();
  }
  return ripemd;
}
var secp256k1$1 = {}, secp256k1signature = {}, hasRequiredSecp256k1signature;
function requireSecp256k1signature() {
  if (hasRequiredSecp256k1signature) return secp256k1signature;
  hasRequiredSecp256k1signature = 1, Object.defineProperty(secp256k1signature, "__esModule", { value: !0 }), secp256k1signature.ExtendedSecp256k1Signature = secp256k1signature.Secp256k1Signature = void 0;
  function s(t) {
    let l = 0;
    for (const m of t)
      if (m === 0)
        l++;
      else
        break;
    return t.slice(l);
  }
  const A = 2;
  class u {
    constructor(l, m) {
      Ci(this, "data");
      if (l.length > 32 || l.length === 0 || l[0] === 0)
        throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
      if (m.length > 32 || m.length === 0 || m[0] === 0)
        throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
      this.data = {
        r: l,
        s: m
      };
    }
    /**
     * Takes the pair of integers (r, s) as 2x32 byte of binary data.
     *
     * Note: This is the format Cosmos SDK uses natively.
     *
     * @param data a 64 byte value containing integers r and s.
     */
    static fromFixedLength(l) {
      if (l.length !== 64)
        throw new Error(`Got invalid data length: ${l.length}. Expected 2x 32 bytes for the pair (r, s)`);
      return new u(s(l.slice(0, 32)), s(l.slice(32, 64)));
    }
    static fromDer(l) {
      let m = 0;
      if (l[m++] !== 48)
        throw new Error("Prefix 0x30 expected");
      const b = l[m++];
      if (l.length - m !== b)
        throw new Error("Data length mismatch detected");
      if (l[m++] !== A)
        throw new Error("INTEGER tag expected");
      const C = l[m++];
      if (C >= 128)
        throw new Error("Decoding length values above 127 not supported");
      const B = l.slice(m, m + C);
      if (m += C, l[m++] !== A)
        throw new Error("INTEGER tag expected");
      const P = l[m++];
      if (P >= 128)
        throw new Error("Decoding length values above 127 not supported");
      const x = l.slice(m, m + P);
      return m += P, new u(
        // r/s data can contain leading 0 bytes to express integers being non-negative in DER
        s(B),
        s(x)
      );
    }
    r(l) {
      if (l === void 0)
        return this.data.r;
      {
        const m = l - this.data.r.length;
        if (m < 0)
          throw new Error("Length too small to hold parameter r");
        const b = new Uint8Array(m);
        return new Uint8Array([...b, ...this.data.r]);
      }
    }
    s(l) {
      if (l === void 0)
        return this.data.s;
      {
        const m = l - this.data.s.length;
        if (m < 0)
          throw new Error("Length too small to hold parameter s");
        const b = new Uint8Array(m);
        return new Uint8Array([...b, ...this.data.s]);
      }
    }
    toFixedLength() {
      return new Uint8Array([...this.r(32), ...this.s(32)]);
    }
    toDer() {
      const l = this.data.r[0] >= 128 ? new Uint8Array([0, ...this.data.r]) : this.data.r, m = this.data.s[0] >= 128 ? new Uint8Array([0, ...this.data.s]) : this.data.s, b = l.length, k = m.length, C = new Uint8Array([A, b, ...l, A, k, ...m]);
      return new Uint8Array([48, C.length, ...C]);
    }
  }
  secp256k1signature.Secp256k1Signature = u;
  class p extends u {
    constructor(m, b, k) {
      super(m, b);
      Ci(this, "recovery");
      if (!Number.isInteger(k))
        throw new Error("The recovery parameter must be an integer.");
      if (k < 0 || k > 4)
        throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
      this.recovery = k;
    }
    /**
     * Decode extended signature from the simple fixed length encoding
     * described in toFixedLength().
     */
    static fromFixedLength(m) {
      if (m.length !== 65)
        throw new Error(`Got invalid data length ${m.length}. Expected 32 + 32 + 1`);
      return new p(s(m.slice(0, 32)), s(m.slice(32, 64)), m[64]);
    }
    /**
     * A simple custom encoding that encodes the extended signature as
     * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
     * where | denotes concatenation of bonary data.
     */
    toFixedLength() {
      return new Uint8Array([...this.r(32), ...this.s(32), this.recovery]);
    }
  }
  return secp256k1signature.ExtendedSecp256k1Signature = p, secp256k1signature;
}
var hasRequiredSecp256k1;
function requireSecp256k1() {
  if (hasRequiredSecp256k1) return secp256k1$1;
  hasRequiredSecp256k1 = 1, Object.defineProperty(secp256k1$1, "__esModule", { value: !0 }), secp256k1$1.Secp256k1 = void 0;
  const s = requireBuild$4(), A = requireBuild$3(), u = /* @__PURE__ */ requireSecp256k1$5(), p = requireSecp256k1signature();
  function t(b) {
    (0, A.assert)(b >= 0n);
    let k = b.toString(16);
    return k.length % 2 && (k = "0" + k), (0, s.fromHex)(k);
  }
  function l(b) {
    return BigInt("0x" + (0, s.toHex)(b));
  }
  class m {
    /**
     * Takes a 32 byte private key and returns a privkey/pubkey pair.
     *
     * The resulting pubkey is uncompressed. For the use in Cosmos it should
     * be compressed first using `Secp256k1.compressPubkey`.
     */
    static async makeKeypair(k) {
      if (k.length !== 32)
        throw new Error("input data is not a valid secp256k1 private key");
      if (!u.secp256k1.utils.isValidPrivateKey(k))
        throw new Error("input data is not a valid secp256k1 private key");
      return {
        privkey: k,
        // encodes uncompressed as
        // - 1-byte prefix "04"
        // - 32-byte x coordinate
        // - 32-byte y coordinate
        pubkey: u.secp256k1.getPublicKey(k, !1)
      };
    }
    /**
     * Creates a signature that is
     * - deterministic (RFC 6979)
     * - lowS signature
     * - DER encoded
     */
    static async createSignature(k, C) {
      if (k.length === 0)
        throw new Error("Message hash must not be empty");
      if (k.length > 32)
        throw new Error("Message hash length must not exceed 32 bytes");
      const { recovery: B, r: Q, s: P } = u.secp256k1.sign(k, C, {
        lowS: !0
      });
      if (typeof B != "number")
        throw new Error("Recovery param missing");
      return new p.ExtendedSecp256k1Signature(t(Q), t(P), B);
    }
    static async verifySignature(k, C, B) {
      if (C.length === 0)
        throw new Error("Message hash must not be empty");
      if (C.length > 32)
        throw new Error("Message hash length must not exceed 32 bytes");
      const Q = u.secp256k1.Signature.fromDER(k.toDer());
      return u.secp256k1.verify(Q, C, B, { lowS: !1 });
    }
    static recoverPubkey(k, C) {
      return new u.secp256k1.Signature(l(k.r()), l(k.s()), k.recovery).recoverPublicKey(C).toBytes(!1);
    }
    /**
     * Takes a compressed or uncompressed pubkey and return a compressed one.
     *
     * This function is idempotent.
     */
    static compressPubkey(k) {
      switch (k.length) {
        case 33:
          return k;
        case 65:
          return u.secp256k1.Point.fromBytes(k).toBytes(!0);
        default:
          throw new Error("Invalid pubkey length");
      }
    }
    /**
     * Takes a compressed or uncompressed pubkey and returns an uncompressed one.
     *
     * This function is idempotent.
     */
    static uncompressPubkey(k) {
      switch (k.length) {
        case 33:
          return u.secp256k1.Point.fromBytes(k).toBytes(!1);
        case 65:
          return k;
        default:
          throw new Error("Invalid pubkey length");
      }
    }
    static trimRecoveryByte(k) {
      switch (k.length) {
        case 64:
          return k;
        case 65:
          return k.slice(0, 64);
        default:
          throw new Error("Invalid signature length");
      }
    }
  }
  return secp256k1$1.Secp256k1 = m, secp256k1$1;
}
var slip10 = {}, build$1 = {}, decimal$1 = {}, hasRequiredDecimal;
function requireDecimal() {
  if (hasRequiredDecimal) return decimal$1;
  hasRequiredDecimal = 1, Object.defineProperty(decimal$1, "__esModule", { value: !0 }), decimal$1.Decimal = void 0;
  const s = 100;
  class A {
    constructor(p, t) {
      Ci(this, "data");
      if (!p.match(/^[0-9]+$/))
        throw new Error("Invalid string format. Only non-negative integers in decimal representation supported.");
      this.data = {
        atomics: BigInt(p),
        fractionalDigits: t
      };
    }
    static fromUserInput(p, t) {
      A.verifyFractionalDigits(t);
      const l = p.match(/[^0-9.]/);
      if (l)
        throw new Error(`Invalid character at position ${l.index + 1}`);
      let m, b;
      if (p === "")
        m = "0", b = "";
      else if (p.search(/\./) === -1)
        m = p, b = "";
      else {
        const C = p.split(".");
        switch (C.length) {
          case 0:
          case 1:
            throw new Error("Fewer than two elements in split result. This must not happen here.");
          case 2:
            if (!C[1])
              throw new Error("Fractional part missing");
            m = C[0], b = C[1].replace(/0+$/, "");
            break;
          default:
            throw new Error("More than one separator found");
        }
      }
      if (b.length > t)
        throw new Error("Got more fractional digits than supported");
      const k = `${m}${b.padEnd(t, "0")}`;
      return new A(k, t);
    }
    static fromAtomics(p, t) {
      return A.verifyFractionalDigits(t), new A(p, t);
    }
    /**
     * Creates a Decimal with value 0.0 and the given number of fractional digits.
     *
     * Fractional digits are not relevant for the value but needed to be able
     * to perform arithmetic operations with other decimals.
     */
    static zero(p) {
      return A.verifyFractionalDigits(p), new A("0", p);
    }
    /**
     * Creates a Decimal with value 1.0 and the given number of fractional digits.
     *
     * Fractional digits are not relevant for the value but needed to be able
     * to perform arithmetic operations with other decimals.
     */
    static one(p) {
      return A.verifyFractionalDigits(p), new A("1" + "0".repeat(p), p);
    }
    static verifyFractionalDigits(p) {
      if (!Number.isInteger(p))
        throw new Error("Fractional digits is not an integer");
      if (p < 0)
        throw new Error("Fractional digits must not be negative");
      if (p > s)
        throw new Error(`Fractional digits must not exceed ${s}`);
    }
    static compare(p, t) {
      if (p.fractionalDigits !== t.fractionalDigits)
        throw new Error("Fractional digits do not match");
      const l = p.data.atomics - t.data.atomics;
      return l < 0n ? -1 : l > 0n ? 1 : 0;
    }
    get atomics() {
      return this.data.atomics.toString();
    }
    get fractionalDigits() {
      return this.data.fractionalDigits;
    }
    /** Creates a new instance with the same value */
    clone() {
      return new A(this.atomics, this.fractionalDigits);
    }
    /** Returns the greatest decimal <= this which has no fractional part (rounding down) */
    floor() {
      const p = 10n ** BigInt(this.data.fractionalDigits), t = this.data.atomics / p;
      return this.data.atomics % p === 0n ? this.clone() : A.fromAtomics((t * p).toString(), this.fractionalDigits);
    }
    /** Returns the smallest decimal >= this which has no fractional part (rounding up) */
    ceil() {
      const p = 10n ** BigInt(this.data.fractionalDigits), t = this.data.atomics / p;
      return this.data.atomics % p === 0n ? this.clone() : A.fromAtomics(((t + 1n) * p).toString(), this.fractionalDigits);
    }
    toString() {
      const p = 10n ** BigInt(this.data.fractionalDigits), t = this.data.atomics / p, l = this.data.atomics % p;
      if (l === 0n)
        return t.toString();
      {
        const b = l.toString().padStart(this.data.fractionalDigits, "0").replace(/0+$/, "");
        return `${t.toString()}.${b}`;
      }
    }
    /**
     * Returns an approximation as a float type. Only use this if no
     * exact calculation is required.
     */
    toFloatApproximation() {
      const p = Number(this.toString());
      if (Number.isNaN(p))
        throw new Error("Conversion to number failed");
      return p;
    }
    /**
     * a.plus(b) returns a+b.
     *
     * Both values need to have the same fractional digits.
     */
    plus(p) {
      if (this.fractionalDigits !== p.fractionalDigits)
        throw new Error("Fractional digits do not match");
      const t = this.data.atomics + p.data.atomics;
      return new A(t.toString(), this.fractionalDigits);
    }
    /**
     * a.minus(b) returns a-b.
     *
     * Both values need to have the same fractional digits.
     * The resulting difference needs to be non-negative.
     */
    minus(p) {
      if (this.fractionalDigits !== p.fractionalDigits)
        throw new Error("Fractional digits do not match");
      const t = this.data.atomics - p.data.atomics;
      if (t < 0n)
        throw new Error("Difference must not be negative");
      return new A(t.toString(), this.fractionalDigits);
    }
    /**
     * a.multiply(b) returns a*b.
     *
     * We only allow multiplication by unsigned integers to avoid rounding errors.
     */
    multiply(p) {
      const t = this.data.atomics * p.toBigInt();
      return new A(t.toString(), this.fractionalDigits);
    }
    equals(p) {
      return A.compare(this, p) === 0;
    }
    isLessThan(p) {
      return A.compare(this, p) < 0;
    }
    isLessThanOrEqual(p) {
      return A.compare(this, p) <= 0;
    }
    isGreaterThan(p) {
      return A.compare(this, p) > 0;
    }
    isGreaterThanOrEqual(p) {
      return A.compare(this, p) >= 0;
    }
  }
  return decimal$1.Decimal = A, decimal$1;
}
var integers = {}, hasRequiredIntegers;
function requireIntegers() {
  if (hasRequiredIntegers) return integers;
  hasRequiredIntegers = 1, Object.defineProperty(integers, "__esModule", { value: !0 }), integers.Uint64 = integers.Uint53 = integers.Int53 = integers.Uint32 = void 0;
  const s = 18446744073709551615n;
  class A {
    constructor(m) {
      Ci(this, "data");
      if (Number.isNaN(m))
        throw new Error("Input is not a number");
      if (!Number.isInteger(m))
        throw new Error("Input is not an integer");
      if (m < 0 || m > 4294967295)
        throw new Error("Input not in uint32 range: " + m.toString());
      this.data = m;
    }
    /** @deprecated use Uint32.fromBytes */
    static fromBigEndianBytes(m) {
      return A.fromBytes(m);
    }
    /**
     * Creates a Uint32 from a fixed length byte array.
     *
     * @param bytes a list of exactly 4 bytes
     * @param endianness defaults to big endian
     */
    static fromBytes(m, b = "be") {
      if (m.length !== 4)
        throw new Error("Invalid input length. Expected 4 bytes.");
      for (let C = 0; C < m.length; ++C)
        if (!Number.isInteger(m[C]) || m[C] > 255 || m[C] < 0)
          throw new Error(`Invalid value in byte. Found: ${m[C]}`);
      const k = b === "be" ? m : Array.from(m).reverse();
      return new A(k[0] * 2 ** 24 + k[1] * 2 ** 16 + k[2] * 2 ** 8 + k[3]);
    }
    static fromString(m) {
      if (!m.match(/^[0-9]+$/))
        throw new Error("Invalid string format");
      return new A(Number.parseInt(m, 10));
    }
    toBytesBigEndian() {
      return new Uint8Array([
        Math.floor(this.data / 2 ** 24) & 255,
        Math.floor(this.data / 2 ** 16) & 255,
        Math.floor(this.data / 2 ** 8) & 255,
        Math.floor(this.data / 2 ** 0) & 255
      ]);
    }
    toBytesLittleEndian() {
      return new Uint8Array([
        Math.floor(this.data / 2 ** 0) & 255,
        Math.floor(this.data / 2 ** 8) & 255,
        Math.floor(this.data / 2 ** 16) & 255,
        Math.floor(this.data / 2 ** 24) & 255
      ]);
    }
    toNumber() {
      return this.data;
    }
    toBigInt() {
      return BigInt(this.toNumber());
    }
    toString() {
      return this.data.toString();
    }
  }
  integers.Uint32 = A;
  class u {
    constructor(m) {
      Ci(this, "data");
      if (Number.isNaN(m))
        throw new Error("Input is not a number");
      if (!Number.isInteger(m))
        throw new Error("Input is not an integer");
      if (m < Number.MIN_SAFE_INTEGER || m > Number.MAX_SAFE_INTEGER)
        throw new Error("Input not in int53 range: " + m.toString());
      this.data = m;
    }
    static fromString(m) {
      if (!m.match(/^-?[0-9]+$/))
        throw new Error("Invalid string format");
      return new u(Number.parseInt(m, 10));
    }
    toNumber() {
      return this.data;
    }
    toBigInt() {
      return BigInt(this.toNumber());
    }
    toString() {
      return this.data.toString();
    }
  }
  integers.Int53 = u;
  class p {
    constructor(m) {
      Ci(this, "data");
      const b = new u(m);
      if (b.toNumber() < 0)
        throw new Error("Input is negative");
      this.data = b;
    }
    static fromString(m) {
      const b = u.fromString(m);
      return new p(b.toNumber());
    }
    toNumber() {
      return this.data.toNumber();
    }
    toBigInt() {
      return BigInt(this.toNumber());
    }
    toString() {
      return this.data.toString();
    }
  }
  integers.Uint53 = p;
  class t {
    constructor(m) {
      Ci(this, "data");
      if (m < 0n)
        throw new Error("Input is negative");
      if (m > s)
        throw new Error("Input exceeds uint64 range");
      this.data = m;
    }
    /** @deprecated use Uint64.fromBytes */
    static fromBytesBigEndian(m) {
      return t.fromBytes(m);
    }
    /**
     * Creates a Uint64 from a fixed length byte array.
     *
     * @param bytes a list of exactly 8 bytes
     * @param endianness defaults to big endian
     */
    static fromBytes(m, b = "be") {
      if (m.length !== 8)
        throw new Error("Invalid input length. Expected 8 bytes.");
      const k = b === "be" ? Array.from(m) : Array.from(m).reverse();
      let C = 0n;
      for (const B of k) {
        if (C *= 256n, !Number.isInteger(B) || B > 255 || B < 0)
          throw new Error(`Invalid value in byte. Found: ${B}`);
        C += BigInt(B);
      }
      return new t(C);
    }
    static fromString(m) {
      if (!m.match(/^[0-9]+$/))
        throw new Error("Invalid string format");
      return new t(BigInt(m));
    }
    static fromNumber(m) {
      if (Number.isNaN(m))
        throw new Error("Input is not a number");
      if (!Number.isInteger(m))
        throw new Error("Input is not an integer");
      if (!Number.isSafeInteger(m))
        throw new Error("Input is not a safe integer");
      const b = BigInt(m);
      return new t(b);
    }
    toBytesBigEndian() {
      return this.toBytesLittleEndian().reverse();
    }
    toBytesLittleEndian() {
      const m = new Uint8Array(8);
      let b = this.data;
      for (let k = 0; k < m.length; k++)
        m[k] = Number(b % 256n), b /= 256n;
      return m;
    }
    toString() {
      return this.data.toString(10);
    }
    toBigInt() {
      return this.data;
    }
    toNumber() {
      if (this.data > BigInt(Number.MAX_SAFE_INTEGER))
        throw new Error("number can only safely store up to 53 bits");
      return Number(this.data);
    }
  }
  return integers.Uint64 = t, integers;
}
var hasRequiredBuild$2;
function requireBuild$2() {
  return hasRequiredBuild$2 || (hasRequiredBuild$2 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.Uint64 = s.Uint53 = s.Uint32 = s.Int53 = s.Decimal = void 0;
    var A = requireDecimal();
    Object.defineProperty(s, "Decimal", { enumerable: !0, get: function() {
      return A.Decimal;
    } });
    var u = requireIntegers();
    Object.defineProperty(s, "Int53", { enumerable: !0, get: function() {
      return u.Int53;
    } }), Object.defineProperty(s, "Uint32", { enumerable: !0, get: function() {
      return u.Uint32;
    } }), Object.defineProperty(s, "Uint53", { enumerable: !0, get: function() {
      return u.Uint53;
    } }), Object.defineProperty(s, "Uint64", { enumerable: !0, get: function() {
      return u.Uint64;
    } });
  }(build$1)), build$1;
}
var hasRequiredSlip10;
function requireSlip10() {
  if (hasRequiredSlip10) return slip10;
  hasRequiredSlip10 = 1, Object.defineProperty(slip10, "__esModule", { value: !0 }), slip10.Slip10 = slip10.Slip10RawIndex = slip10.Slip10Curve = void 0, slip10.slip10CurveFromString = C, slip10.pathToString = P, slip10.stringToPath = x;
  const s = requireBuild$4(), A = requireBuild$2(), u = requireBuild$3(), p = /* @__PURE__ */ requireSecp256k1$5(), t = requireHmac(), l = requireSha();
  var m;
  (function(M) {
    M.Secp256k1 = "Bitcoin seed", M.Ed25519 = "ed25519 seed";
  })(m || (slip10.Slip10Curve = m = {}));
  function b(M) {
    return BigInt("0x" + (0, s.toHex)(M));
  }
  function k(M) {
    (0, u.assert)(M >= 0n), (0, u.assert)(M < 2n ** (32n * 8n));
    const F = M.toString(16).padStart(64, "0");
    return (0, s.fromHex)(F);
  }
  function C(M) {
    switch (M) {
      case m.Ed25519:
        return m.Ed25519;
      case m.Secp256k1:
        return m.Secp256k1;
      default:
        throw new Error(`Unknown curve string: '${M}'`);
    }
  }
  class B extends A.Uint32 {
    static hardened(F) {
      return new B(F + 2 ** 31);
    }
    static normal(F) {
      return new B(F);
    }
    isHardened() {
      return this.data >= 2 ** 31;
    }
  }
  slip10.Slip10RawIndex = B;
  class Q {
    static derivePath(F, le, ge) {
      let pe = this.master(F, le);
      for (const Ie of ge)
        pe = this.child(F, pe.privkey, pe.chainCode, Ie);
      return pe;
    }
    static master(F, le) {
      const ge = new t.Hmac(l.Sha512, (0, s.toAscii)(F)).update(le).digest(), pe = ge.slice(0, 32), Ie = ge.slice(32, 64);
      return F !== m.Ed25519 && (this.isZero(pe) || this.isGteN(F, pe)) ? this.master(F, ge) : {
        chainCode: Ie,
        privkey: pe
      };
    }
    static child(F, le, ge, pe) {
      let Ie;
      if (pe.isHardened()) {
        const be = new Uint8Array([0, ...le, ...pe.toBytesBigEndian()]);
        Ie = new t.Hmac(l.Sha512, ge).update(be).digest();
      } else {
        if (F === m.Ed25519)
          throw new Error("Normal keys are not allowed with ed25519");
        {
          const be = new Uint8Array([
            ...Q.serializedPoint(F, b(le)),
            ...pe.toBytesBigEndian()
          ]);
          Ie = new t.Hmac(l.Sha512, ge).update(be).digest();
        }
      }
      return this.childImpl(F, le, ge, pe, Ie);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */
    static serializedPoint(F, le) {
      switch (F) {
        case m.Secp256k1:
          return p.secp256k1.Point.BASE.multiply(le).toBytes(!0);
        default:
          throw new Error("curve not supported");
      }
    }
    static childImpl(F, le, ge, pe, Ie) {
      const be = Ie.slice(0, 32), Pe = Ie.slice(32, 64), Te = Pe;
      if (F === m.Ed25519)
        return {
          chainCode: Te,
          privkey: be
        };
      const Qe = this.n(F), xe = (b(be) + b(le)) % Qe, Ee = k(xe);
      if (this.isGteN(F, be) || this.isZero(Ee)) {
        const He = new t.Hmac(l.Sha512, ge).update(new Uint8Array([1, ...Pe, ...pe.toBytesBigEndian()])).digest();
        return this.childImpl(F, le, ge, pe, He);
      }
      return {
        chainCode: Te,
        privkey: Ee
      };
    }
    static isZero(F) {
      return F.every((le) => le === 0);
    }
    static isGteN(F, le) {
      return b(le) >= this.n(F);
    }
    static n(F) {
      switch (F) {
        case m.Secp256k1:
          return 0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141n;
        default:
          throw new Error("curve not supported");
      }
    }
  }
  slip10.Slip10 = Q;
  function P(M) {
    return M.reduce((F, le) => {
      const ge = le.isHardened() ? `${le.toNumber() - 2147483648}'` : le.toString();
      return F + "/" + ge;
    }, "m");
  }
  function x(M) {
    if (!M.startsWith("m"))
      throw new Error("Path string must start with 'm'");
    let F = M.slice(1);
    const le = new Array();
    for (; F; ) {
      const ge = F.match(/^\/([0-9]+)('?)/);
      if (!ge)
        throw new Error("Syntax error while reading path component");
      const [pe, Ie, be] = ge, Pe = A.Uint53.fromString(Ie).toNumber();
      if (Pe >= 2 ** 31)
        throw new Error("Component value too high. Must not exceed 2**31-1.");
      be ? le.push(B.hardened(Pe)) : le.push(B.normal(Pe)), F = F.slice(pe.length);
    }
    return le;
  }
  return slip10;
}
var hasRequiredBuild$1;
function requireBuild$1() {
  return hasRequiredBuild$1 || (hasRequiredBuild$1 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.stringToPath = s.Slip10RawIndex = s.slip10CurveFromString = s.Slip10Curve = s.Slip10 = s.pathToString = s.sha512 = s.Sha512 = s.sha256 = s.Sha256 = s.Secp256k1Signature = s.ExtendedSecp256k1Signature = s.Secp256k1 = s.ripemd160 = s.Ripemd160 = s.Random = s.Xchacha20poly1305Ietf = s.xchacha20NonceLength = s.isArgon2idOptions = s.Ed25519Keypair = s.Ed25519 = s.Argon2id = s.keccak256 = s.Keccak256 = s.Hmac = s.EnglishMnemonic = s.Bip39 = void 0;
    var A = requireBip39();
    Object.defineProperty(s, "Bip39", { enumerable: !0, get: function() {
      return A.Bip39;
    } }), Object.defineProperty(s, "EnglishMnemonic", { enumerable: !0, get: function() {
      return A.EnglishMnemonic;
    } });
    var u = requireHmac();
    Object.defineProperty(s, "Hmac", { enumerable: !0, get: function() {
      return u.Hmac;
    } });
    var p = requireKeccak();
    Object.defineProperty(s, "Keccak256", { enumerable: !0, get: function() {
      return p.Keccak256;
    } }), Object.defineProperty(s, "keccak256", { enumerable: !0, get: function() {
      return p.keccak256;
    } });
    var t = requireLibsodium();
    Object.defineProperty(s, "Argon2id", { enumerable: !0, get: function() {
      return t.Argon2id;
    } }), Object.defineProperty(s, "Ed25519", { enumerable: !0, get: function() {
      return t.Ed25519;
    } }), Object.defineProperty(s, "Ed25519Keypair", { enumerable: !0, get: function() {
      return t.Ed25519Keypair;
    } }), Object.defineProperty(s, "isArgon2idOptions", { enumerable: !0, get: function() {
      return t.isArgon2idOptions;
    } }), Object.defineProperty(s, "xchacha20NonceLength", { enumerable: !0, get: function() {
      return t.xchacha20NonceLength;
    } }), Object.defineProperty(s, "Xchacha20poly1305Ietf", { enumerable: !0, get: function() {
      return t.Xchacha20poly1305Ietf;
    } });
    var l = requireRandom();
    Object.defineProperty(s, "Random", { enumerable: !0, get: function() {
      return l.Random;
    } });
    var m = requireRipemd();
    Object.defineProperty(s, "Ripemd160", { enumerable: !0, get: function() {
      return m.Ripemd160;
    } }), Object.defineProperty(s, "ripemd160", { enumerable: !0, get: function() {
      return m.ripemd160;
    } });
    var b = requireSecp256k1();
    Object.defineProperty(s, "Secp256k1", { enumerable: !0, get: function() {
      return b.Secp256k1;
    } });
    var k = requireSecp256k1signature();
    Object.defineProperty(s, "ExtendedSecp256k1Signature", { enumerable: !0, get: function() {
      return k.ExtendedSecp256k1Signature;
    } }), Object.defineProperty(s, "Secp256k1Signature", { enumerable: !0, get: function() {
      return k.Secp256k1Signature;
    } });
    var C = requireSha();
    Object.defineProperty(s, "Sha256", { enumerable: !0, get: function() {
      return C.Sha256;
    } }), Object.defineProperty(s, "sha256", { enumerable: !0, get: function() {
      return C.sha256;
    } }), Object.defineProperty(s, "Sha512", { enumerable: !0, get: function() {
      return C.Sha512;
    } }), Object.defineProperty(s, "sha512", { enumerable: !0, get: function() {
      return C.sha512;
    } });
    var B = requireSlip10();
    Object.defineProperty(s, "pathToString", { enumerable: !0, get: function() {
      return B.pathToString;
    } }), Object.defineProperty(s, "Slip10", { enumerable: !0, get: function() {
      return B.Slip10;
    } }), Object.defineProperty(s, "Slip10Curve", { enumerable: !0, get: function() {
      return B.Slip10Curve;
    } }), Object.defineProperty(s, "slip10CurveFromString", { enumerable: !0, get: function() {
      return B.slip10CurveFromString;
    } }), Object.defineProperty(s, "Slip10RawIndex", { enumerable: !0, get: function() {
      return B.Slip10RawIndex;
    } }), Object.defineProperty(s, "stringToPath", { enumerable: !0, get: function() {
      return B.stringToPath;
    } });
  }(build$4)), build$4;
}
var buildExports = requireBuild$1(), tx = {}, indexMinimal = {}, minimal$1 = {}, aspromise, hasRequiredAspromise;
function requireAspromise() {
  if (hasRequiredAspromise) return aspromise;
  hasRequiredAspromise = 1, aspromise = s;
  function s(A, u) {
    for (var p = new Array(arguments.length - 1), t = 0, l = 2, m = !0; l < arguments.length; )
      p[t++] = arguments[l++];
    return new Promise(function(k, C) {
      p[t] = function(Q) {
        if (m)
          if (m = !1, Q)
            C(Q);
          else {
            for (var P = new Array(arguments.length - 1), x = 0; x < P.length; )
              P[x++] = arguments[x];
            k.apply(null, P);
          }
      };
      try {
        A.apply(u || null, p);
      } catch (B) {
        m && (m = !1, C(B));
      }
    });
  }
  return aspromise;
}
var base64$1 = {}, hasRequiredBase64$1;
function requireBase64$1() {
  return hasRequiredBase64$1 || (hasRequiredBase64$1 = 1, function(s) {
    var A = s;
    A.length = function(b) {
      var k = b.length;
      if (!k)
        return 0;
      for (var C = 0; --k % 4 > 1 && b.charAt(k) === "="; )
        ++C;
      return Math.ceil(b.length * 3) / 4 - C;
    };
    for (var u = new Array(64), p = new Array(123), t = 0; t < 64; )
      p[u[t] = t < 26 ? t + 65 : t < 52 ? t + 71 : t < 62 ? t - 4 : t - 59 | 43] = t++;
    A.encode = function(b, k, C) {
      for (var B = null, Q = [], P = 0, x = 0, M; k < C; ) {
        var F = b[k++];
        switch (x) {
          case 0:
            Q[P++] = u[F >> 2], M = (F & 3) << 4, x = 1;
            break;
          case 1:
            Q[P++] = u[M | F >> 4], M = (F & 15) << 2, x = 2;
            break;
          case 2:
            Q[P++] = u[M | F >> 6], Q[P++] = u[F & 63], x = 0;
            break;
        }
        P > 8191 && ((B || (B = [])).push(String.fromCharCode.apply(String, Q)), P = 0);
      }
      return x && (Q[P++] = u[M], Q[P++] = 61, x === 1 && (Q[P++] = 61)), B ? (P && B.push(String.fromCharCode.apply(String, Q.slice(0, P))), B.join("")) : String.fromCharCode.apply(String, Q.slice(0, P));
    };
    var l = "invalid encoding";
    A.decode = function(b, k, C) {
      for (var B = C, Q = 0, P, x = 0; x < b.length; ) {
        var M = b.charCodeAt(x++);
        if (M === 61 && Q > 1)
          break;
        if ((M = p[M]) === void 0)
          throw Error(l);
        switch (Q) {
          case 0:
            P = M, Q = 1;
            break;
          case 1:
            k[C++] = P << 2 | (M & 48) >> 4, P = M, Q = 2;
            break;
          case 2:
            k[C++] = (P & 15) << 4 | (M & 60) >> 2, P = M, Q = 3;
            break;
          case 3:
            k[C++] = (P & 3) << 6 | M, Q = 0;
            break;
        }
      }
      if (Q === 1)
        throw Error(l);
      return C - B;
    }, A.test = function(b) {
      return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(b);
    };
  }(base64$1)), base64$1;
}
var eventemitter, hasRequiredEventemitter;
function requireEventemitter() {
  if (hasRequiredEventemitter) return eventemitter;
  hasRequiredEventemitter = 1, eventemitter = s;
  function s() {
    this._listeners = {};
  }
  return s.prototype.on = function(u, p, t) {
    return (this._listeners[u] || (this._listeners[u] = [])).push({
      fn: p,
      ctx: t || this
    }), this;
  }, s.prototype.off = function(u, p) {
    if (u === void 0)
      this._listeners = {};
    else if (p === void 0)
      this._listeners[u] = [];
    else
      for (var t = this._listeners[u], l = 0; l < t.length; )
        t[l].fn === p ? t.splice(l, 1) : ++l;
    return this;
  }, s.prototype.emit = function(u) {
    var p = this._listeners[u];
    if (p) {
      for (var t = [], l = 1; l < arguments.length; )
        t.push(arguments[l++]);
      for (l = 0; l < p.length; )
        p[l].fn.apply(p[l++].ctx, t);
    }
    return this;
  }, eventemitter;
}
var float, hasRequiredFloat;
function requireFloat() {
  if (hasRequiredFloat) return float;
  hasRequiredFloat = 1, float = s(s);
  function s(l) {
    return typeof Float32Array < "u" ? function() {
      var m = new Float32Array([-0]), b = new Uint8Array(m.buffer), k = b[3] === 128;
      function C(x, M, F) {
        m[0] = x, M[F] = b[0], M[F + 1] = b[1], M[F + 2] = b[2], M[F + 3] = b[3];
      }
      function B(x, M, F) {
        m[0] = x, M[F] = b[3], M[F + 1] = b[2], M[F + 2] = b[1], M[F + 3] = b[0];
      }
      l.writeFloatLE = k ? C : B, l.writeFloatBE = k ? B : C;
      function Q(x, M) {
        return b[0] = x[M], b[1] = x[M + 1], b[2] = x[M + 2], b[3] = x[M + 3], m[0];
      }
      function P(x, M) {
        return b[3] = x[M], b[2] = x[M + 1], b[1] = x[M + 2], b[0] = x[M + 3], m[0];
      }
      l.readFloatLE = k ? Q : P, l.readFloatBE = k ? P : Q;
    }() : function() {
      function m(k, C, B, Q) {
        var P = C < 0 ? 1 : 0;
        if (P && (C = -C), C === 0)
          k(1 / C > 0 ? (
            /* positive */
            0
          ) : (
            /* negative 0 */
            2147483648
          ), B, Q);
        else if (isNaN(C))
          k(2143289344, B, Q);
        else if (C > 34028234663852886e22)
          k((P << 31 | 2139095040) >>> 0, B, Q);
        else if (C < 11754943508222875e-54)
          k((P << 31 | Math.round(C / 1401298464324817e-60)) >>> 0, B, Q);
        else {
          var x = Math.floor(Math.log(C) / Math.LN2), M = Math.round(C * Math.pow(2, -x) * 8388608) & 8388607;
          k((P << 31 | x + 127 << 23 | M) >>> 0, B, Q);
        }
      }
      l.writeFloatLE = m.bind(null, A), l.writeFloatBE = m.bind(null, u);
      function b(k, C, B) {
        var Q = k(C, B), P = (Q >> 31) * 2 + 1, x = Q >>> 23 & 255, M = Q & 8388607;
        return x === 255 ? M ? NaN : P * (1 / 0) : x === 0 ? P * 1401298464324817e-60 * M : P * Math.pow(2, x - 150) * (M + 8388608);
      }
      l.readFloatLE = b.bind(null, p), l.readFloatBE = b.bind(null, t);
    }(), typeof Float64Array < "u" ? function() {
      var m = new Float64Array([-0]), b = new Uint8Array(m.buffer), k = b[7] === 128;
      function C(x, M, F) {
        m[0] = x, M[F] = b[0], M[F + 1] = b[1], M[F + 2] = b[2], M[F + 3] = b[3], M[F + 4] = b[4], M[F + 5] = b[5], M[F + 6] = b[6], M[F + 7] = b[7];
      }
      function B(x, M, F) {
        m[0] = x, M[F] = b[7], M[F + 1] = b[6], M[F + 2] = b[5], M[F + 3] = b[4], M[F + 4] = b[3], M[F + 5] = b[2], M[F + 6] = b[1], M[F + 7] = b[0];
      }
      l.writeDoubleLE = k ? C : B, l.writeDoubleBE = k ? B : C;
      function Q(x, M) {
        return b[0] = x[M], b[1] = x[M + 1], b[2] = x[M + 2], b[3] = x[M + 3], b[4] = x[M + 4], b[5] = x[M + 5], b[6] = x[M + 6], b[7] = x[M + 7], m[0];
      }
      function P(x, M) {
        return b[7] = x[M], b[6] = x[M + 1], b[5] = x[M + 2], b[4] = x[M + 3], b[3] = x[M + 4], b[2] = x[M + 5], b[1] = x[M + 6], b[0] = x[M + 7], m[0];
      }
      l.readDoubleLE = k ? Q : P, l.readDoubleBE = k ? P : Q;
    }() : function() {
      function m(k, C, B, Q, P, x) {
        var M = Q < 0 ? 1 : 0;
        if (M && (Q = -Q), Q === 0)
          k(0, P, x + C), k(1 / Q > 0 ? (
            /* positive */
            0
          ) : (
            /* negative 0 */
            2147483648
          ), P, x + B);
        else if (isNaN(Q))
          k(0, P, x + C), k(2146959360, P, x + B);
        else if (Q > 17976931348623157e292)
          k(0, P, x + C), k((M << 31 | 2146435072) >>> 0, P, x + B);
        else {
          var F;
          if (Q < 22250738585072014e-324)
            F = Q / 5e-324, k(F >>> 0, P, x + C), k((M << 31 | F / 4294967296) >>> 0, P, x + B);
          else {
            var le = Math.floor(Math.log(Q) / Math.LN2);
            le === 1024 && (le = 1023), F = Q * Math.pow(2, -le), k(F * 4503599627370496 >>> 0, P, x + C), k((M << 31 | le + 1023 << 20 | F * 1048576 & 1048575) >>> 0, P, x + B);
          }
        }
      }
      l.writeDoubleLE = m.bind(null, A, 0, 4), l.writeDoubleBE = m.bind(null, u, 4, 0);
      function b(k, C, B, Q, P) {
        var x = k(Q, P + C), M = k(Q, P + B), F = (M >> 31) * 2 + 1, le = M >>> 20 & 2047, ge = 4294967296 * (M & 1048575) + x;
        return le === 2047 ? ge ? NaN : F * (1 / 0) : le === 0 ? F * 5e-324 * ge : F * Math.pow(2, le - 1075) * (ge + 4503599627370496);
      }
      l.readDoubleLE = b.bind(null, p, 0, 4), l.readDoubleBE = b.bind(null, t, 4, 0);
    }(), l;
  }
  function A(l, m, b) {
    m[b] = l & 255, m[b + 1] = l >>> 8 & 255, m[b + 2] = l >>> 16 & 255, m[b + 3] = l >>> 24;
  }
  function u(l, m, b) {
    m[b] = l >>> 24, m[b + 1] = l >>> 16 & 255, m[b + 2] = l >>> 8 & 255, m[b + 3] = l & 255;
  }
  function p(l, m) {
    return (l[m] | l[m + 1] << 8 | l[m + 2] << 16 | l[m + 3] << 24) >>> 0;
  }
  function t(l, m) {
    return (l[m] << 24 | l[m + 1] << 16 | l[m + 2] << 8 | l[m + 3]) >>> 0;
  }
  return float;
}
var inquire_1, hasRequiredInquire;
function requireInquire() {
  if (hasRequiredInquire) return inquire_1;
  hasRequiredInquire = 1, inquire_1 = inquire;
  function inquire(moduleName) {
    try {
      var mod = eval("quire".replace(/^/, "re"))(moduleName);
      if (mod && (mod.length || Object.keys(mod).length))
        return mod;
    } catch (s) {
    }
    return null;
  }
  return inquire_1;
}
var utf8$2 = {}, hasRequiredUtf8$1;
function requireUtf8$1() {
  return hasRequiredUtf8$1 || (hasRequiredUtf8$1 = 1, function(s) {
    var A = s;
    A.length = function(p) {
      for (var t = 0, l = 0, m = 0; m < p.length; ++m)
        l = p.charCodeAt(m), l < 128 ? t += 1 : l < 2048 ? t += 2 : (l & 64512) === 55296 && (p.charCodeAt(m + 1) & 64512) === 56320 ? (++m, t += 4) : t += 3;
      return t;
    }, A.read = function(p, t, l) {
      var m = l - t;
      if (m < 1)
        return "";
      for (var b = null, k = [], C = 0, B; t < l; )
        B = p[t++], B < 128 ? k[C++] = B : B > 191 && B < 224 ? k[C++] = (B & 31) << 6 | p[t++] & 63 : B > 239 && B < 365 ? (B = ((B & 7) << 18 | (p[t++] & 63) << 12 | (p[t++] & 63) << 6 | p[t++] & 63) - 65536, k[C++] = 55296 + (B >> 10), k[C++] = 56320 + (B & 1023)) : k[C++] = (B & 15) << 12 | (p[t++] & 63) << 6 | p[t++] & 63, C > 8191 && ((b || (b = [])).push(String.fromCharCode.apply(String, k)), C = 0);
      return b ? (C && b.push(String.fromCharCode.apply(String, k.slice(0, C))), b.join("")) : String.fromCharCode.apply(String, k.slice(0, C));
    }, A.write = function(p, t, l) {
      for (var m = l, b, k, C = 0; C < p.length; ++C)
        b = p.charCodeAt(C), b < 128 ? t[l++] = b : b < 2048 ? (t[l++] = b >> 6 | 192, t[l++] = b & 63 | 128) : (b & 64512) === 55296 && ((k = p.charCodeAt(C + 1)) & 64512) === 56320 ? (b = 65536 + ((b & 1023) << 10) + (k & 1023), ++C, t[l++] = b >> 18 | 240, t[l++] = b >> 12 & 63 | 128, t[l++] = b >> 6 & 63 | 128, t[l++] = b & 63 | 128) : (t[l++] = b >> 12 | 224, t[l++] = b >> 6 & 63 | 128, t[l++] = b & 63 | 128);
      return l - m;
    };
  }(utf8$2)), utf8$2;
}
var pool_1, hasRequiredPool;
function requirePool() {
  if (hasRequiredPool) return pool_1;
  hasRequiredPool = 1, pool_1 = s;
  function s(A, u, p) {
    var t = p || 8192, l = t >>> 1, m = null, b = t;
    return function(C) {
      if (C < 1 || C > l)
        return A(C);
      b + C > t && (m = A(t), b = 0);
      var B = u.call(m, b, b += C);
      return b & 7 && (b = (b | 7) + 1), B;
    };
  }
  return pool_1;
}
var longbits, hasRequiredLongbits;
function requireLongbits() {
  if (hasRequiredLongbits) return longbits;
  hasRequiredLongbits = 1, longbits = A;
  var s = requireMinimal$1();
  function A(l, m) {
    this.lo = l >>> 0, this.hi = m >>> 0;
  }
  var u = A.zero = new A(0, 0);
  u.toNumber = function() {
    return 0;
  }, u.zzEncode = u.zzDecode = function() {
    return this;
  }, u.length = function() {
    return 1;
  };
  var p = A.zeroHash = "\0\0\0\0\0\0\0\0";
  A.fromNumber = function(m) {
    if (m === 0)
      return u;
    var b = m < 0;
    b && (m = -m);
    var k = m >>> 0, C = (m - k) / 4294967296 >>> 0;
    return b && (C = ~C >>> 0, k = ~k >>> 0, ++k > 4294967295 && (k = 0, ++C > 4294967295 && (C = 0))), new A(k, C);
  }, A.from = function(m) {
    if (typeof m == "number")
      return A.fromNumber(m);
    if (s.isString(m))
      if (s.Long)
        m = s.Long.fromString(m);
      else
        return A.fromNumber(parseInt(m, 10));
    return m.low || m.high ? new A(m.low >>> 0, m.high >>> 0) : u;
  }, A.prototype.toNumber = function(m) {
    if (!m && this.hi >>> 31) {
      var b = ~this.lo + 1 >>> 0, k = ~this.hi >>> 0;
      return b || (k = k + 1 >>> 0), -(b + k * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, A.prototype.toLong = function(m) {
    return s.Long ? new s.Long(this.lo | 0, this.hi | 0, !!m) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!m };
  };
  var t = String.prototype.charCodeAt;
  return A.fromHash = function(m) {
    return m === p ? u : new A(
      (t.call(m, 0) | t.call(m, 1) << 8 | t.call(m, 2) << 16 | t.call(m, 3) << 24) >>> 0,
      (t.call(m, 4) | t.call(m, 5) << 8 | t.call(m, 6) << 16 | t.call(m, 7) << 24) >>> 0
    );
  }, A.prototype.toHash = function() {
    return String.fromCharCode(
      this.lo & 255,
      this.lo >>> 8 & 255,
      this.lo >>> 16 & 255,
      this.lo >>> 24,
      this.hi & 255,
      this.hi >>> 8 & 255,
      this.hi >>> 16 & 255,
      this.hi >>> 24
    );
  }, A.prototype.zzEncode = function() {
    var m = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ m) >>> 0, this.lo = (this.lo << 1 ^ m) >>> 0, this;
  }, A.prototype.zzDecode = function() {
    var m = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ m) >>> 0, this.hi = (this.hi >>> 1 ^ m) >>> 0, this;
  }, A.prototype.length = function() {
    var m = this.lo, b = (this.lo >>> 28 | this.hi << 4) >>> 0, k = this.hi >>> 24;
    return k === 0 ? b === 0 ? m < 16384 ? m < 128 ? 1 : 2 : m < 2097152 ? 3 : 4 : b < 16384 ? b < 128 ? 5 : 6 : b < 2097152 ? 7 : 8 : k < 128 ? 9 : 10;
  }, longbits;
}
var hasRequiredMinimal$1;
function requireMinimal$1() {
  return hasRequiredMinimal$1 || (hasRequiredMinimal$1 = 1, function(s) {
    var A = s;
    A.asPromise = requireAspromise(), A.base64 = requireBase64$1(), A.EventEmitter = requireEventemitter(), A.float = requireFloat(), A.inquire = requireInquire(), A.utf8 = requireUtf8$1(), A.pool = requirePool(), A.LongBits = requireLongbits(), A.isNode = !!(typeof commonjsGlobal < "u" && commonjsGlobal && commonjsGlobal.process && commonjsGlobal.process.versions && commonjsGlobal.process.versions.node), A.global = A.isNode && commonjsGlobal || typeof window < "u" && window || typeof self < "u" && self || minimal$1, A.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), A.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), A.isInteger = Number.isInteger || /* istanbul ignore next */
    function(l) {
      return typeof l == "number" && isFinite(l) && Math.floor(l) === l;
    }, A.isString = function(l) {
      return typeof l == "string" || l instanceof String;
    }, A.isObject = function(l) {
      return l && typeof l == "object";
    }, A.isset = /**
     * Checks if a property on a message is considered to be present.
     * @param {Object} obj Plain object or message instance
     * @param {string} prop Property name
     * @returns {boolean} `true` if considered to be present, otherwise `false`
     */
    A.isSet = function(l, m) {
      var b = l[m];
      return b != null && l.hasOwnProperty(m) ? typeof b != "object" || (Array.isArray(b) ? b.length : Object.keys(b).length) > 0 : !1;
    }, A.Buffer = function() {
      try {
        var t = A.inquire("buffer").Buffer;
        return t.prototype.utf8Write ? t : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    }(), A._Buffer_from = null, A._Buffer_allocUnsafe = null, A.newBuffer = function(l) {
      return typeof l == "number" ? A.Buffer ? A._Buffer_allocUnsafe(l) : new A.Array(l) : A.Buffer ? A._Buffer_from(l) : typeof Uint8Array > "u" ? l : new Uint8Array(l);
    }, A.Array = typeof Uint8Array < "u" ? Uint8Array : Array, A.Long = /* istanbul ignore next */
    A.global.dcodeIO && /* istanbul ignore next */
    A.global.dcodeIO.Long || /* istanbul ignore next */
    A.global.Long || A.inquire("long"), A.key2Re = /^true|false|0|1$/, A.key32Re = /^-?(?:0|[1-9][0-9]*)$/, A.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, A.longToHash = function(l) {
      return l ? A.LongBits.from(l).toHash() : A.LongBits.zeroHash;
    }, A.longFromHash = function(l, m) {
      var b = A.LongBits.fromHash(l);
      return A.Long ? A.Long.fromBits(b.lo, b.hi, m) : b.toNumber(!!m);
    };
    function u(t, l, m) {
      for (var b = Object.keys(l), k = 0; k < b.length; ++k)
        (t[b[k]] === void 0 || !m) && (t[b[k]] = l[b[k]]);
      return t;
    }
    A.merge = u, A.lcFirst = function(l) {
      return l.charAt(0).toLowerCase() + l.substring(1);
    };
    function p(t) {
      function l(m, b) {
        if (!(this instanceof l))
          return new l(m, b);
        Object.defineProperty(this, "message", { get: function() {
          return m;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, l) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), b && u(this, b);
      }
      return (l.prototype = Object.create(Error.prototype)).constructor = l, Object.defineProperty(l.prototype, "name", { get: function() {
        return t;
      } }), l.prototype.toString = function() {
        return this.name + ": " + this.message;
      }, l;
    }
    A.newError = p, A.ProtocolError = p("ProtocolError"), A.oneOfGetter = function(l) {
      for (var m = {}, b = 0; b < l.length; ++b)
        m[l[b]] = 1;
      return function() {
        for (var k = Object.keys(this), C = k.length - 1; C > -1; --C)
          if (m[k[C]] === 1 && this[k[C]] !== void 0 && this[k[C]] !== null)
            return k[C];
      };
    }, A.oneOfSetter = function(l) {
      return function(m) {
        for (var b = 0; b < l.length; ++b)
          l[b] !== m && delete this[l[b]];
      };
    }, A.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, A._configure = function() {
      var t = A.Buffer;
      if (!t) {
        A._Buffer_from = A._Buffer_allocUnsafe = null;
        return;
      }
      A._Buffer_from = t.from !== Uint8Array.from && t.from || /* istanbul ignore next */
      function(m, b) {
        return new t(m, b);
      }, A._Buffer_allocUnsafe = t.allocUnsafe || /* istanbul ignore next */
      function(m) {
        return new t(m);
      };
    };
  }(minimal$1)), minimal$1;
}
var writer, hasRequiredWriter;
function requireWriter() {
  if (hasRequiredWriter) return writer;
  hasRequiredWriter = 1, writer = k;
  var s = requireMinimal$1(), A, u = s.LongBits, p = s.base64, t = s.utf8;
  function l(le, ge, pe) {
    this.fn = le, this.len = ge, this.next = void 0, this.val = pe;
  }
  function m() {
  }
  function b(le) {
    this.head = le.head, this.tail = le.tail, this.len = le.len, this.next = le.states;
  }
  function k() {
    this.len = 0, this.head = new l(m, 0, 0), this.tail = this.head, this.states = null;
  }
  var C = function() {
    return s.Buffer ? function() {
      return (k.create = function() {
        return new A();
      })();
    } : function() {
      return new k();
    };
  };
  k.create = C(), k.alloc = function(ge) {
    return new s.Array(ge);
  }, s.Array !== Array && (k.alloc = s.pool(k.alloc, s.Array.prototype.subarray)), k.prototype._push = function(ge, pe, Ie) {
    return this.tail = this.tail.next = new l(ge, pe, Ie), this.len += pe, this;
  };
  function B(le, ge, pe) {
    ge[pe] = le & 255;
  }
  function Q(le, ge, pe) {
    for (; le > 127; )
      ge[pe++] = le & 127 | 128, le >>>= 7;
    ge[pe] = le;
  }
  function P(le, ge) {
    this.len = le, this.next = void 0, this.val = ge;
  }
  P.prototype = Object.create(l.prototype), P.prototype.fn = Q, k.prototype.uint32 = function(ge) {
    return this.len += (this.tail = this.tail.next = new P(
      (ge = ge >>> 0) < 128 ? 1 : ge < 16384 ? 2 : ge < 2097152 ? 3 : ge < 268435456 ? 4 : 5,
      ge
    )).len, this;
  }, k.prototype.int32 = function(ge) {
    return ge < 0 ? this._push(x, 10, u.fromNumber(ge)) : this.uint32(ge);
  }, k.prototype.sint32 = function(ge) {
    return this.uint32((ge << 1 ^ ge >> 31) >>> 0);
  };
  function x(le, ge, pe) {
    for (; le.hi; )
      ge[pe++] = le.lo & 127 | 128, le.lo = (le.lo >>> 7 | le.hi << 25) >>> 0, le.hi >>>= 7;
    for (; le.lo > 127; )
      ge[pe++] = le.lo & 127 | 128, le.lo = le.lo >>> 7;
    ge[pe++] = le.lo;
  }
  k.prototype.uint64 = function(ge) {
    var pe = u.from(ge);
    return this._push(x, pe.length(), pe);
  }, k.prototype.int64 = k.prototype.uint64, k.prototype.sint64 = function(ge) {
    var pe = u.from(ge).zzEncode();
    return this._push(x, pe.length(), pe);
  }, k.prototype.bool = function(ge) {
    return this._push(B, 1, ge ? 1 : 0);
  };
  function M(le, ge, pe) {
    ge[pe] = le & 255, ge[pe + 1] = le >>> 8 & 255, ge[pe + 2] = le >>> 16 & 255, ge[pe + 3] = le >>> 24;
  }
  k.prototype.fixed32 = function(ge) {
    return this._push(M, 4, ge >>> 0);
  }, k.prototype.sfixed32 = k.prototype.fixed32, k.prototype.fixed64 = function(ge) {
    var pe = u.from(ge);
    return this._push(M, 4, pe.lo)._push(M, 4, pe.hi);
  }, k.prototype.sfixed64 = k.prototype.fixed64, k.prototype.float = function(ge) {
    return this._push(s.float.writeFloatLE, 4, ge);
  }, k.prototype.double = function(ge) {
    return this._push(s.float.writeDoubleLE, 8, ge);
  };
  var F = s.Array.prototype.set ? function(ge, pe, Ie) {
    pe.set(ge, Ie);
  } : function(ge, pe, Ie) {
    for (var be = 0; be < ge.length; ++be)
      pe[Ie + be] = ge[be];
  };
  return k.prototype.bytes = function(ge) {
    var pe = ge.length >>> 0;
    if (!pe)
      return this._push(B, 1, 0);
    if (s.isString(ge)) {
      var Ie = k.alloc(pe = p.length(ge));
      p.decode(ge, Ie, 0), ge = Ie;
    }
    return this.uint32(pe)._push(F, pe, ge);
  }, k.prototype.string = function(ge) {
    var pe = t.length(ge);
    return pe ? this.uint32(pe)._push(t.write, pe, ge) : this._push(B, 1, 0);
  }, k.prototype.fork = function() {
    return this.states = new b(this), this.head = this.tail = new l(m, 0, 0), this.len = 0, this;
  }, k.prototype.reset = function() {
    return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new l(m, 0, 0), this.len = 0), this;
  }, k.prototype.ldelim = function() {
    var ge = this.head, pe = this.tail, Ie = this.len;
    return this.reset().uint32(Ie), Ie && (this.tail.next = ge.next, this.tail = pe, this.len += Ie), this;
  }, k.prototype.finish = function() {
    for (var ge = this.head.next, pe = this.constructor.alloc(this.len), Ie = 0; ge; )
      ge.fn(ge.val, pe, Ie), Ie += ge.len, ge = ge.next;
    return pe;
  }, k._configure = function(le) {
    A = le, k.create = C(), A._configure();
  }, writer;
}
var writer_buffer, hasRequiredWriter_buffer;
function requireWriter_buffer() {
  if (hasRequiredWriter_buffer) return writer_buffer;
  hasRequiredWriter_buffer = 1, writer_buffer = u;
  var s = requireWriter();
  (u.prototype = Object.create(s.prototype)).constructor = u;
  var A = requireMinimal$1();
  function u() {
    s.call(this);
  }
  u._configure = function() {
    u.alloc = A._Buffer_allocUnsafe, u.writeBytesBuffer = A.Buffer && A.Buffer.prototype instanceof Uint8Array && A.Buffer.prototype.set.name === "set" ? function(l, m, b) {
      m.set(l, b);
    } : function(l, m, b) {
      if (l.copy)
        l.copy(m, b, 0, l.length);
      else for (var k = 0; k < l.length; )
        m[b++] = l[k++];
    };
  }, u.prototype.bytes = function(l) {
    A.isString(l) && (l = A._Buffer_from(l, "base64"));
    var m = l.length >>> 0;
    return this.uint32(m), m && this._push(u.writeBytesBuffer, m, l), this;
  };
  function p(t, l, m) {
    t.length < 40 ? A.utf8.write(t, l, m) : l.utf8Write ? l.utf8Write(t, m) : l.write(t, m);
  }
  return u.prototype.string = function(l) {
    var m = A.Buffer.byteLength(l);
    return this.uint32(m), m && this._push(p, m, l), this;
  }, u._configure(), writer_buffer;
}
var reader, hasRequiredReader;
function requireReader() {
  if (hasRequiredReader) return reader;
  hasRequiredReader = 1, reader = l;
  var s = requireMinimal$1(), A, u = s.LongBits, p = s.utf8;
  function t(Q, P) {
    return RangeError("index out of range: " + Q.pos + " + " + (P || 1) + " > " + Q.len);
  }
  function l(Q) {
    this.buf = Q, this.pos = 0, this.len = Q.length;
  }
  var m = typeof Uint8Array < "u" ? function(P) {
    if (P instanceof Uint8Array || Array.isArray(P))
      return new l(P);
    throw Error("illegal buffer");
  } : function(P) {
    if (Array.isArray(P))
      return new l(P);
    throw Error("illegal buffer");
  }, b = function() {
    return s.Buffer ? function(x) {
      return (l.create = function(F) {
        return s.Buffer.isBuffer(F) ? new A(F) : m(F);
      })(x);
    } : m;
  };
  l.create = b(), l.prototype._slice = s.Array.prototype.subarray || /* istanbul ignore next */
  s.Array.prototype.slice, l.prototype.uint32 = /* @__PURE__ */ function() {
    var P = 4294967295;
    return function() {
      if (P = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (P = (P | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (P = (P | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (P = (P | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (P = (P | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128)) return P;
      if ((this.pos += 5) > this.len)
        throw this.pos = this.len, t(this, 10);
      return P;
    };
  }(), l.prototype.int32 = function() {
    return this.uint32() | 0;
  }, l.prototype.sint32 = function() {
    var P = this.uint32();
    return P >>> 1 ^ -(P & 1) | 0;
  };
  function k() {
    var Q = new u(0, 0), P = 0;
    if (this.len - this.pos > 4) {
      for (; P < 4; ++P)
        if (Q.lo = (Q.lo | (this.buf[this.pos] & 127) << P * 7) >>> 0, this.buf[this.pos++] < 128)
          return Q;
      if (Q.lo = (Q.lo | (this.buf[this.pos] & 127) << 28) >>> 0, Q.hi = (Q.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128)
        return Q;
      P = 0;
    } else {
      for (; P < 3; ++P) {
        if (this.pos >= this.len)
          throw t(this);
        if (Q.lo = (Q.lo | (this.buf[this.pos] & 127) << P * 7) >>> 0, this.buf[this.pos++] < 128)
          return Q;
      }
      return Q.lo = (Q.lo | (this.buf[this.pos++] & 127) << P * 7) >>> 0, Q;
    }
    if (this.len - this.pos > 4) {
      for (; P < 5; ++P)
        if (Q.hi = (Q.hi | (this.buf[this.pos] & 127) << P * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
          return Q;
    } else
      for (; P < 5; ++P) {
        if (this.pos >= this.len)
          throw t(this);
        if (Q.hi = (Q.hi | (this.buf[this.pos] & 127) << P * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
          return Q;
      }
    throw Error("invalid varint encoding");
  }
  l.prototype.bool = function() {
    return this.uint32() !== 0;
  };
  function C(Q, P) {
    return (Q[P - 4] | Q[P - 3] << 8 | Q[P - 2] << 16 | Q[P - 1] << 24) >>> 0;
  }
  l.prototype.fixed32 = function() {
    if (this.pos + 4 > this.len)
      throw t(this, 4);
    return C(this.buf, this.pos += 4);
  }, l.prototype.sfixed32 = function() {
    if (this.pos + 4 > this.len)
      throw t(this, 4);
    return C(this.buf, this.pos += 4) | 0;
  };
  function B() {
    if (this.pos + 8 > this.len)
      throw t(this, 8);
    return new u(C(this.buf, this.pos += 4), C(this.buf, this.pos += 4));
  }
  return l.prototype.float = function() {
    if (this.pos + 4 > this.len)
      throw t(this, 4);
    var P = s.float.readFloatLE(this.buf, this.pos);
    return this.pos += 4, P;
  }, l.prototype.double = function() {
    if (this.pos + 8 > this.len)
      throw t(this, 4);
    var P = s.float.readDoubleLE(this.buf, this.pos);
    return this.pos += 8, P;
  }, l.prototype.bytes = function() {
    var P = this.uint32(), x = this.pos, M = this.pos + P;
    if (M > this.len)
      throw t(this, P);
    return this.pos += P, Array.isArray(this.buf) ? this.buf.slice(x, M) : x === M ? new this.buf.constructor(0) : this._slice.call(this.buf, x, M);
  }, l.prototype.string = function() {
    var P = this.bytes();
    return p.read(P, 0, P.length);
  }, l.prototype.skip = function(P) {
    if (typeof P == "number") {
      if (this.pos + P > this.len)
        throw t(this, P);
      this.pos += P;
    } else
      do
        if (this.pos >= this.len)
          throw t(this);
      while (this.buf[this.pos++] & 128);
    return this;
  }, l.prototype.skipType = function(Q) {
    switch (Q) {
      case 0:
        this.skip();
        break;
      case 1:
        this.skip(8);
        break;
      case 2:
        this.skip(this.uint32());
        break;
      case 3:
        for (; (Q = this.uint32() & 7) !== 4; )
          this.skipType(Q);
        break;
      case 5:
        this.skip(4);
        break;
      /* istanbul ignore next */
      default:
        throw Error("invalid wire type " + Q + " at offset " + this.pos);
    }
    return this;
  }, l._configure = function(Q) {
    A = Q, l.create = b(), A._configure();
    var P = s.Long ? "toLong" : (
      /* istanbul ignore next */
      "toNumber"
    );
    s.merge(l.prototype, {
      int64: function() {
        return k.call(this)[P](!1);
      },
      uint64: function() {
        return k.call(this)[P](!0);
      },
      sint64: function() {
        return k.call(this).zzDecode()[P](!1);
      },
      fixed64: function() {
        return B.call(this)[P](!0);
      },
      sfixed64: function() {
        return B.call(this)[P](!1);
      }
    });
  }, reader;
}
var reader_buffer, hasRequiredReader_buffer;
function requireReader_buffer() {
  if (hasRequiredReader_buffer) return reader_buffer;
  hasRequiredReader_buffer = 1, reader_buffer = u;
  var s = requireReader();
  (u.prototype = Object.create(s.prototype)).constructor = u;
  var A = requireMinimal$1();
  function u(p) {
    s.call(this, p);
  }
  return u._configure = function() {
    A.Buffer && (u.prototype._slice = A.Buffer.prototype.slice);
  }, u.prototype.string = function() {
    var t = this.uint32();
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + t, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + t, this.len));
  }, u._configure(), reader_buffer;
}
var rpc = {}, service, hasRequiredService;
function requireService() {
  if (hasRequiredService) return service;
  hasRequiredService = 1, service = A;
  var s = requireMinimal$1();
  (A.prototype = Object.create(s.EventEmitter.prototype)).constructor = A;
  function A(u, p, t) {
    if (typeof u != "function")
      throw TypeError("rpcImpl must be a function");
    s.EventEmitter.call(this), this.rpcImpl = u, this.requestDelimited = !!p, this.responseDelimited = !!t;
  }
  return A.prototype.rpcCall = function u(p, t, l, m, b) {
    if (!m)
      throw TypeError("request must be specified");
    var k = this;
    if (!b)
      return s.asPromise(u, k, p, t, l, m);
    if (!k.rpcImpl) {
      setTimeout(function() {
        b(Error("already ended"));
      }, 0);
      return;
    }
    try {
      return k.rpcImpl(
        p,
        t[k.requestDelimited ? "encodeDelimited" : "encode"](m).finish(),
        function(B, Q) {
          if (B)
            return k.emit("error", B, p), b(B);
          if (Q === null) {
            k.end(
              /* endedByRPC */
              !0
            );
            return;
          }
          if (!(Q instanceof l))
            try {
              Q = l[k.responseDelimited ? "decodeDelimited" : "decode"](Q);
            } catch (P) {
              return k.emit("error", P, p), b(P);
            }
          return k.emit("data", Q, p), b(null, Q);
        }
      );
    } catch (C) {
      k.emit("error", C, p), setTimeout(function() {
        b(C);
      }, 0);
      return;
    }
  }, A.prototype.end = function(p) {
    return this.rpcImpl && (p || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
  }, service;
}
var hasRequiredRpc;
function requireRpc() {
  return hasRequiredRpc || (hasRequiredRpc = 1, function(s) {
    var A = s;
    A.Service = requireService();
  }(rpc)), rpc;
}
var roots, hasRequiredRoots;
function requireRoots() {
  return hasRequiredRoots || (hasRequiredRoots = 1, roots = {}), roots;
}
var hasRequiredIndexMinimal;
function requireIndexMinimal() {
  return hasRequiredIndexMinimal || (hasRequiredIndexMinimal = 1, function(s) {
    var A = s;
    A.build = "minimal", A.Writer = requireWriter(), A.BufferWriter = requireWriter_buffer(), A.Reader = requireReader(), A.BufferReader = requireReader_buffer(), A.util = requireMinimal$1(), A.rpc = requireRpc(), A.roots = requireRoots(), A.configure = u;
    function u() {
      A.util._configure(), A.Writer._configure(A.BufferWriter), A.Reader._configure(A.BufferReader);
    }
    u();
  }(indexMinimal)), indexMinimal;
}
var minimal, hasRequiredMinimal;
function requireMinimal() {
  return hasRequiredMinimal || (hasRequiredMinimal = 1, minimal = requireIndexMinimal()), minimal;
}
var signing = {}, any = {}, hasRequiredAny;
function requireAny() {
  if (hasRequiredAny) return any;
  hasRequiredAny = 1;
  var s = any && any.__importDefault || function(B) {
    return B && B.__esModule ? B : { default: B };
  };
  Object.defineProperty(any, "__esModule", { value: !0 }), any.Any = any.protobufPackage = void 0;
  const A = s(requireLong()), u = s(requireMinimal());
  any.protobufPackage = "google.protobuf";
  function p() {
    return { typeUrl: "", value: new Uint8Array() };
  }
  any.Any = {
    encode(B, Q = u.default.Writer.create()) {
      return B.typeUrl !== "" && Q.uint32(10).string(B.typeUrl), B.value.length !== 0 && Q.uint32(18).bytes(B.value), Q;
    },
    decode(B, Q) {
      const P = B instanceof u.default.Reader ? B : new u.default.Reader(B);
      let x = Q === void 0 ? P.len : P.pos + Q;
      const M = p();
      for (; P.pos < x; ) {
        const F = P.uint32();
        switch (F >>> 3) {
          case 1:
            M.typeUrl = P.string();
            break;
          case 2:
            M.value = P.bytes();
            break;
          default:
            P.skipType(F & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(B) {
      return {
        typeUrl: C(B.typeUrl) ? String(B.typeUrl) : "",
        value: C(B.value) ? m(B.value) : new Uint8Array()
      };
    },
    toJSON(B) {
      const Q = {};
      return B.typeUrl !== void 0 && (Q.typeUrl = B.typeUrl), B.value !== void 0 && (Q.value = k(B.value !== void 0 ? B.value : new Uint8Array())), Q;
    },
    fromPartial(B) {
      var Q, P;
      const x = p();
      return x.typeUrl = (Q = B.typeUrl) !== null && Q !== void 0 ? Q : "", x.value = (P = B.value) !== null && P !== void 0 ? P : new Uint8Array(), x;
    }
  };
  var t = (() => {
    if (typeof t < "u")
      return t;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal < "u")
      return commonjsGlobal;
    throw "Unable to locate global object";
  })();
  const l = t.atob || ((B) => t.Buffer.from(B, "base64").toString("binary"));
  function m(B) {
    const Q = l(B), P = new Uint8Array(Q.length);
    for (let x = 0; x < Q.length; ++x)
      P[x] = Q.charCodeAt(x);
    return P;
  }
  const b = t.btoa || ((B) => t.Buffer.from(B, "binary").toString("base64"));
  function k(B) {
    const Q = [];
    for (const P of B)
      Q.push(String.fromCharCode(P));
    return b(Q.join(""));
  }
  u.default.util.Long !== A.default && (u.default.util.Long = A.default, u.default.configure());
  function C(B) {
    return B != null;
  }
  return any;
}
var multisig = {}, hasRequiredMultisig;
function requireMultisig() {
  if (hasRequiredMultisig) return multisig;
  hasRequiredMultisig = 1;
  var s = multisig && multisig.__importDefault || function(Q) {
    return Q && Q.__esModule ? Q : { default: Q };
  };
  Object.defineProperty(multisig, "__esModule", { value: !0 }), multisig.CompactBitArray = multisig.MultiSignature = multisig.protobufPackage = void 0;
  const A = s(requireLong()), u = s(requireMinimal());
  multisig.protobufPackage = "cosmos.crypto.multisig.v1beta1";
  function p() {
    return { signatures: [] };
  }
  multisig.MultiSignature = {
    encode(Q, P = u.default.Writer.create()) {
      for (const x of Q.signatures)
        P.uint32(10).bytes(x);
      return P;
    },
    decode(Q, P) {
      const x = Q instanceof u.default.Reader ? Q : new u.default.Reader(Q);
      let M = P === void 0 ? x.len : x.pos + P;
      const F = p();
      for (; x.pos < M; ) {
        const le = x.uint32();
        switch (le >>> 3) {
          case 1:
            F.signatures.push(x.bytes());
            break;
          default:
            x.skipType(le & 7);
            break;
        }
      }
      return F;
    },
    fromJSON(Q) {
      return {
        signatures: Array.isArray(Q == null ? void 0 : Q.signatures) ? Q.signatures.map((P) => b(P)) : []
      };
    },
    toJSON(Q) {
      const P = {};
      return Q.signatures ? P.signatures = Q.signatures.map((x) => C(x !== void 0 ? x : new Uint8Array())) : P.signatures = [], P;
    },
    fromPartial(Q) {
      var P;
      const x = p();
      return x.signatures = ((P = Q.signatures) === null || P === void 0 ? void 0 : P.map((M) => M)) || [], x;
    }
  };
  function t() {
    return { extraBitsStored: 0, elems: new Uint8Array() };
  }
  multisig.CompactBitArray = {
    encode(Q, P = u.default.Writer.create()) {
      return Q.extraBitsStored !== 0 && P.uint32(8).uint32(Q.extraBitsStored), Q.elems.length !== 0 && P.uint32(18).bytes(Q.elems), P;
    },
    decode(Q, P) {
      const x = Q instanceof u.default.Reader ? Q : new u.default.Reader(Q);
      let M = P === void 0 ? x.len : x.pos + P;
      const F = t();
      for (; x.pos < M; ) {
        const le = x.uint32();
        switch (le >>> 3) {
          case 1:
            F.extraBitsStored = x.uint32();
            break;
          case 2:
            F.elems = x.bytes();
            break;
          default:
            x.skipType(le & 7);
            break;
        }
      }
      return F;
    },
    fromJSON(Q) {
      return {
        extraBitsStored: B(Q.extraBitsStored) ? Number(Q.extraBitsStored) : 0,
        elems: B(Q.elems) ? b(Q.elems) : new Uint8Array()
      };
    },
    toJSON(Q) {
      const P = {};
      return Q.extraBitsStored !== void 0 && (P.extraBitsStored = Math.round(Q.extraBitsStored)), Q.elems !== void 0 && (P.elems = C(Q.elems !== void 0 ? Q.elems : new Uint8Array())), P;
    },
    fromPartial(Q) {
      var P, x;
      const M = t();
      return M.extraBitsStored = (P = Q.extraBitsStored) !== null && P !== void 0 ? P : 0, M.elems = (x = Q.elems) !== null && x !== void 0 ? x : new Uint8Array(), M;
    }
  };
  var l = (() => {
    if (typeof l < "u")
      return l;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal < "u")
      return commonjsGlobal;
    throw "Unable to locate global object";
  })();
  const m = l.atob || ((Q) => l.Buffer.from(Q, "base64").toString("binary"));
  function b(Q) {
    const P = m(Q), x = new Uint8Array(P.length);
    for (let M = 0; M < P.length; ++M)
      x[M] = P.charCodeAt(M);
    return x;
  }
  const k = l.btoa || ((Q) => l.Buffer.from(Q, "binary").toString("base64"));
  function C(Q) {
    const P = [];
    for (const x of Q)
      P.push(String.fromCharCode(x));
    return k(P.join(""));
  }
  u.default.util.Long !== A.default && (u.default.util.Long = A.default, u.default.configure());
  function B(Q) {
    return Q != null;
  }
  return multisig;
}
var hasRequiredSigning;
function requireSigning() {
  return hasRequiredSigning || (hasRequiredSigning = 1, function(s) {
    var A = signing && signing.__importDefault || function(Pe) {
      return Pe && Pe.__esModule ? Pe : { default: Pe };
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), s.SignatureDescriptor_Data_Multi = s.SignatureDescriptor_Data_Single = s.SignatureDescriptor_Data = s.SignatureDescriptor = s.SignatureDescriptors = s.signModeToJSON = s.signModeFromJSON = s.SignMode = s.protobufPackage = void 0;
    const u = A(requireLong()), p = A(requireMinimal()), t = requireAny(), l = requireMultisig();
    s.protobufPackage = "cosmos.tx.signing.v1beta1";
    var m;
    (function(Pe) {
      Pe[Pe.SIGN_MODE_UNSPECIFIED = 0] = "SIGN_MODE_UNSPECIFIED", Pe[Pe.SIGN_MODE_DIRECT = 1] = "SIGN_MODE_DIRECT", Pe[Pe.SIGN_MODE_TEXTUAL = 2] = "SIGN_MODE_TEXTUAL", Pe[Pe.SIGN_MODE_DIRECT_AUX = 3] = "SIGN_MODE_DIRECT_AUX", Pe[Pe.SIGN_MODE_LEGACY_AMINO_JSON = 127] = "SIGN_MODE_LEGACY_AMINO_JSON", Pe[Pe.SIGN_MODE_EIP_191 = 191] = "SIGN_MODE_EIP_191", Pe[Pe.UNRECOGNIZED = -1] = "UNRECOGNIZED";
    })(m = s.SignMode || (s.SignMode = {}));
    function b(Pe) {
      switch (Pe) {
        case 0:
        case "SIGN_MODE_UNSPECIFIED":
          return m.SIGN_MODE_UNSPECIFIED;
        case 1:
        case "SIGN_MODE_DIRECT":
          return m.SIGN_MODE_DIRECT;
        case 2:
        case "SIGN_MODE_TEXTUAL":
          return m.SIGN_MODE_TEXTUAL;
        case 3:
        case "SIGN_MODE_DIRECT_AUX":
          return m.SIGN_MODE_DIRECT_AUX;
        case 127:
        case "SIGN_MODE_LEGACY_AMINO_JSON":
          return m.SIGN_MODE_LEGACY_AMINO_JSON;
        case 191:
        case "SIGN_MODE_EIP_191":
          return m.SIGN_MODE_EIP_191;
        case -1:
        case "UNRECOGNIZED":
        default:
          return m.UNRECOGNIZED;
      }
    }
    s.signModeFromJSON = b;
    function k(Pe) {
      switch (Pe) {
        case m.SIGN_MODE_UNSPECIFIED:
          return "SIGN_MODE_UNSPECIFIED";
        case m.SIGN_MODE_DIRECT:
          return "SIGN_MODE_DIRECT";
        case m.SIGN_MODE_TEXTUAL:
          return "SIGN_MODE_TEXTUAL";
        case m.SIGN_MODE_DIRECT_AUX:
          return "SIGN_MODE_DIRECT_AUX";
        case m.SIGN_MODE_LEGACY_AMINO_JSON:
          return "SIGN_MODE_LEGACY_AMINO_JSON";
        case m.SIGN_MODE_EIP_191:
          return "SIGN_MODE_EIP_191";
        default:
          return "UNKNOWN";
      }
    }
    s.signModeToJSON = k;
    function C() {
      return { signatures: [] };
    }
    s.SignatureDescriptors = {
      encode(Pe, Te = p.default.Writer.create()) {
        for (const Qe of Pe.signatures)
          s.SignatureDescriptor.encode(Qe, Te.uint32(10).fork()).ldelim();
        return Te;
      },
      decode(Pe, Te) {
        const Qe = Pe instanceof p.default.Reader ? Pe : new p.default.Reader(Pe);
        let xe = Te === void 0 ? Qe.len : Qe.pos + Te;
        const Ee = C();
        for (; Qe.pos < xe; ) {
          const He = Qe.uint32();
          switch (He >>> 3) {
            case 1:
              Ee.signatures.push(s.SignatureDescriptor.decode(Qe, Qe.uint32()));
              break;
            default:
              Qe.skipType(He & 7);
              break;
          }
        }
        return Ee;
      },
      fromJSON(Pe) {
        return {
          signatures: Array.isArray(Pe == null ? void 0 : Pe.signatures) ? Pe.signatures.map((Te) => s.SignatureDescriptor.fromJSON(Te)) : []
        };
      },
      toJSON(Pe) {
        const Te = {};
        return Pe.signatures ? Te.signatures = Pe.signatures.map((Qe) => Qe ? s.SignatureDescriptor.toJSON(Qe) : void 0) : Te.signatures = [], Te;
      },
      fromPartial(Pe) {
        var Te;
        const Qe = C();
        return Qe.signatures = ((Te = Pe.signatures) === null || Te === void 0 ? void 0 : Te.map((xe) => s.SignatureDescriptor.fromPartial(xe))) || [], Qe;
      }
    };
    function B() {
      return { publicKey: void 0, data: void 0, sequence: "0" };
    }
    s.SignatureDescriptor = {
      encode(Pe, Te = p.default.Writer.create()) {
        return Pe.publicKey !== void 0 && t.Any.encode(Pe.publicKey, Te.uint32(10).fork()).ldelim(), Pe.data !== void 0 && s.SignatureDescriptor_Data.encode(Pe.data, Te.uint32(18).fork()).ldelim(), Pe.sequence !== "0" && Te.uint32(24).uint64(Pe.sequence), Te;
      },
      decode(Pe, Te) {
        const Qe = Pe instanceof p.default.Reader ? Pe : new p.default.Reader(Pe);
        let xe = Te === void 0 ? Qe.len : Qe.pos + Te;
        const Ee = B();
        for (; Qe.pos < xe; ) {
          const He = Qe.uint32();
          switch (He >>> 3) {
            case 1:
              Ee.publicKey = t.Any.decode(Qe, Qe.uint32());
              break;
            case 2:
              Ee.data = s.SignatureDescriptor_Data.decode(Qe, Qe.uint32());
              break;
            case 3:
              Ee.sequence = Ie(Qe.uint64());
              break;
            default:
              Qe.skipType(He & 7);
              break;
          }
        }
        return Ee;
      },
      fromJSON(Pe) {
        return {
          publicKey: be(Pe.publicKey) ? t.Any.fromJSON(Pe.publicKey) : void 0,
          data: be(Pe.data) ? s.SignatureDescriptor_Data.fromJSON(Pe.data) : void 0,
          sequence: be(Pe.sequence) ? String(Pe.sequence) : "0"
        };
      },
      toJSON(Pe) {
        const Te = {};
        return Pe.publicKey !== void 0 && (Te.publicKey = Pe.publicKey ? t.Any.toJSON(Pe.publicKey) : void 0), Pe.data !== void 0 && (Te.data = Pe.data ? s.SignatureDescriptor_Data.toJSON(Pe.data) : void 0), Pe.sequence !== void 0 && (Te.sequence = Pe.sequence), Te;
      },
      fromPartial(Pe) {
        var Te;
        const Qe = B();
        return Qe.publicKey = Pe.publicKey !== void 0 && Pe.publicKey !== null ? t.Any.fromPartial(Pe.publicKey) : void 0, Qe.data = Pe.data !== void 0 && Pe.data !== null ? s.SignatureDescriptor_Data.fromPartial(Pe.data) : void 0, Qe.sequence = (Te = Pe.sequence) !== null && Te !== void 0 ? Te : "0", Qe;
      }
    };
    function Q() {
      return { single: void 0, multi: void 0 };
    }
    s.SignatureDescriptor_Data = {
      encode(Pe, Te = p.default.Writer.create()) {
        return Pe.single !== void 0 && s.SignatureDescriptor_Data_Single.encode(Pe.single, Te.uint32(10).fork()).ldelim(), Pe.multi !== void 0 && s.SignatureDescriptor_Data_Multi.encode(Pe.multi, Te.uint32(18).fork()).ldelim(), Te;
      },
      decode(Pe, Te) {
        const Qe = Pe instanceof p.default.Reader ? Pe : new p.default.Reader(Pe);
        let xe = Te === void 0 ? Qe.len : Qe.pos + Te;
        const Ee = Q();
        for (; Qe.pos < xe; ) {
          const He = Qe.uint32();
          switch (He >>> 3) {
            case 1:
              Ee.single = s.SignatureDescriptor_Data_Single.decode(Qe, Qe.uint32());
              break;
            case 2:
              Ee.multi = s.SignatureDescriptor_Data_Multi.decode(Qe, Qe.uint32());
              break;
            default:
              Qe.skipType(He & 7);
              break;
          }
        }
        return Ee;
      },
      fromJSON(Pe) {
        return {
          single: be(Pe.single) ? s.SignatureDescriptor_Data_Single.fromJSON(Pe.single) : void 0,
          multi: be(Pe.multi) ? s.SignatureDescriptor_Data_Multi.fromJSON(Pe.multi) : void 0
        };
      },
      toJSON(Pe) {
        const Te = {};
        return Pe.single !== void 0 && (Te.single = Pe.single ? s.SignatureDescriptor_Data_Single.toJSON(Pe.single) : void 0), Pe.multi !== void 0 && (Te.multi = Pe.multi ? s.SignatureDescriptor_Data_Multi.toJSON(Pe.multi) : void 0), Te;
      },
      fromPartial(Pe) {
        const Te = Q();
        return Te.single = Pe.single !== void 0 && Pe.single !== null ? s.SignatureDescriptor_Data_Single.fromPartial(Pe.single) : void 0, Te.multi = Pe.multi !== void 0 && Pe.multi !== null ? s.SignatureDescriptor_Data_Multi.fromPartial(Pe.multi) : void 0, Te;
      }
    };
    function P() {
      return { mode: 0, signature: new Uint8Array() };
    }
    s.SignatureDescriptor_Data_Single = {
      encode(Pe, Te = p.default.Writer.create()) {
        return Pe.mode !== 0 && Te.uint32(8).int32(Pe.mode), Pe.signature.length !== 0 && Te.uint32(18).bytes(Pe.signature), Te;
      },
      decode(Pe, Te) {
        const Qe = Pe instanceof p.default.Reader ? Pe : new p.default.Reader(Pe);
        let xe = Te === void 0 ? Qe.len : Qe.pos + Te;
        const Ee = P();
        for (; Qe.pos < xe; ) {
          const He = Qe.uint32();
          switch (He >>> 3) {
            case 1:
              Ee.mode = Qe.int32();
              break;
            case 2:
              Ee.signature = Qe.bytes();
              break;
            default:
              Qe.skipType(He & 7);
              break;
          }
        }
        return Ee;
      },
      fromJSON(Pe) {
        return {
          mode: be(Pe.mode) ? b(Pe.mode) : 0,
          signature: be(Pe.signature) ? le(Pe.signature) : new Uint8Array()
        };
      },
      toJSON(Pe) {
        const Te = {};
        return Pe.mode !== void 0 && (Te.mode = k(Pe.mode)), Pe.signature !== void 0 && (Te.signature = pe(Pe.signature !== void 0 ? Pe.signature : new Uint8Array())), Te;
      },
      fromPartial(Pe) {
        var Te, Qe;
        const xe = P();
        return xe.mode = (Te = Pe.mode) !== null && Te !== void 0 ? Te : 0, xe.signature = (Qe = Pe.signature) !== null && Qe !== void 0 ? Qe : new Uint8Array(), xe;
      }
    };
    function x() {
      return { bitarray: void 0, signatures: [] };
    }
    s.SignatureDescriptor_Data_Multi = {
      encode(Pe, Te = p.default.Writer.create()) {
        Pe.bitarray !== void 0 && l.CompactBitArray.encode(Pe.bitarray, Te.uint32(10).fork()).ldelim();
        for (const Qe of Pe.signatures)
          s.SignatureDescriptor_Data.encode(Qe, Te.uint32(18).fork()).ldelim();
        return Te;
      },
      decode(Pe, Te) {
        const Qe = Pe instanceof p.default.Reader ? Pe : new p.default.Reader(Pe);
        let xe = Te === void 0 ? Qe.len : Qe.pos + Te;
        const Ee = x();
        for (; Qe.pos < xe; ) {
          const He = Qe.uint32();
          switch (He >>> 3) {
            case 1:
              Ee.bitarray = l.CompactBitArray.decode(Qe, Qe.uint32());
              break;
            case 2:
              Ee.signatures.push(s.SignatureDescriptor_Data.decode(Qe, Qe.uint32()));
              break;
            default:
              Qe.skipType(He & 7);
              break;
          }
        }
        return Ee;
      },
      fromJSON(Pe) {
        return {
          bitarray: be(Pe.bitarray) ? l.CompactBitArray.fromJSON(Pe.bitarray) : void 0,
          signatures: Array.isArray(Pe == null ? void 0 : Pe.signatures) ? Pe.signatures.map((Te) => s.SignatureDescriptor_Data.fromJSON(Te)) : []
        };
      },
      toJSON(Pe) {
        const Te = {};
        return Pe.bitarray !== void 0 && (Te.bitarray = Pe.bitarray ? l.CompactBitArray.toJSON(Pe.bitarray) : void 0), Pe.signatures ? Te.signatures = Pe.signatures.map((Qe) => Qe ? s.SignatureDescriptor_Data.toJSON(Qe) : void 0) : Te.signatures = [], Te;
      },
      fromPartial(Pe) {
        var Te;
        const Qe = x();
        return Qe.bitarray = Pe.bitarray !== void 0 && Pe.bitarray !== null ? l.CompactBitArray.fromPartial(Pe.bitarray) : void 0, Qe.signatures = ((Te = Pe.signatures) === null || Te === void 0 ? void 0 : Te.map((xe) => s.SignatureDescriptor_Data.fromPartial(xe))) || [], Qe;
      }
    };
    var M = (() => {
      if (typeof M < "u")
        return M;
      if (typeof self < "u")
        return self;
      if (typeof window < "u")
        return window;
      if (typeof commonjsGlobal < "u")
        return commonjsGlobal;
      throw "Unable to locate global object";
    })();
    const F = M.atob || ((Pe) => M.Buffer.from(Pe, "base64").toString("binary"));
    function le(Pe) {
      const Te = F(Pe), Qe = new Uint8Array(Te.length);
      for (let xe = 0; xe < Te.length; ++xe)
        Qe[xe] = Te.charCodeAt(xe);
      return Qe;
    }
    const ge = M.btoa || ((Pe) => M.Buffer.from(Pe, "binary").toString("base64"));
    function pe(Pe) {
      const Te = [];
      for (const Qe of Pe)
        Te.push(String.fromCharCode(Qe));
      return ge(Te.join(""));
    }
    function Ie(Pe) {
      return Pe.toString();
    }
    p.default.util.Long !== u.default && (p.default.util.Long = u.default, p.default.configure());
    function be(Pe) {
      return Pe != null;
    }
  }(signing)), signing;
}
var coin = {}, hasRequiredCoin;
function requireCoin() {
  if (hasRequiredCoin) return coin;
  hasRequiredCoin = 1;
  var s = coin && coin.__importDefault || function(k) {
    return k && k.__esModule ? k : { default: k };
  };
  Object.defineProperty(coin, "__esModule", { value: !0 }), coin.DecProto = coin.IntProto = coin.DecCoin = coin.Coin = coin.protobufPackage = void 0;
  const A = s(requireLong()), u = s(requireMinimal());
  coin.protobufPackage = "cosmos.base.v1beta1";
  function p() {
    return { denom: "", amount: "" };
  }
  coin.Coin = {
    encode(k, C = u.default.Writer.create()) {
      return k.denom !== "" && C.uint32(10).string(k.denom), k.amount !== "" && C.uint32(18).string(k.amount), C;
    },
    decode(k, C) {
      const B = k instanceof u.default.Reader ? k : new u.default.Reader(k);
      let Q = C === void 0 ? B.len : B.pos + C;
      const P = p();
      for (; B.pos < Q; ) {
        const x = B.uint32();
        switch (x >>> 3) {
          case 1:
            P.denom = B.string();
            break;
          case 2:
            P.amount = B.string();
            break;
          default:
            B.skipType(x & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(k) {
      return {
        denom: b(k.denom) ? String(k.denom) : "",
        amount: b(k.amount) ? String(k.amount) : ""
      };
    },
    toJSON(k) {
      const C = {};
      return k.denom !== void 0 && (C.denom = k.denom), k.amount !== void 0 && (C.amount = k.amount), C;
    },
    fromPartial(k) {
      var C, B;
      const Q = p();
      return Q.denom = (C = k.denom) !== null && C !== void 0 ? C : "", Q.amount = (B = k.amount) !== null && B !== void 0 ? B : "", Q;
    }
  };
  function t() {
    return { denom: "", amount: "" };
  }
  coin.DecCoin = {
    encode(k, C = u.default.Writer.create()) {
      return k.denom !== "" && C.uint32(10).string(k.denom), k.amount !== "" && C.uint32(18).string(k.amount), C;
    },
    decode(k, C) {
      const B = k instanceof u.default.Reader ? k : new u.default.Reader(k);
      let Q = C === void 0 ? B.len : B.pos + C;
      const P = t();
      for (; B.pos < Q; ) {
        const x = B.uint32();
        switch (x >>> 3) {
          case 1:
            P.denom = B.string();
            break;
          case 2:
            P.amount = B.string();
            break;
          default:
            B.skipType(x & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(k) {
      return {
        denom: b(k.denom) ? String(k.denom) : "",
        amount: b(k.amount) ? String(k.amount) : ""
      };
    },
    toJSON(k) {
      const C = {};
      return k.denom !== void 0 && (C.denom = k.denom), k.amount !== void 0 && (C.amount = k.amount), C;
    },
    fromPartial(k) {
      var C, B;
      const Q = t();
      return Q.denom = (C = k.denom) !== null && C !== void 0 ? C : "", Q.amount = (B = k.amount) !== null && B !== void 0 ? B : "", Q;
    }
  };
  function l() {
    return { int: "" };
  }
  coin.IntProto = {
    encode(k, C = u.default.Writer.create()) {
      return k.int !== "" && C.uint32(10).string(k.int), C;
    },
    decode(k, C) {
      const B = k instanceof u.default.Reader ? k : new u.default.Reader(k);
      let Q = C === void 0 ? B.len : B.pos + C;
      const P = l();
      for (; B.pos < Q; ) {
        const x = B.uint32();
        switch (x >>> 3) {
          case 1:
            P.int = B.string();
            break;
          default:
            B.skipType(x & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(k) {
      return {
        int: b(k.int) ? String(k.int) : ""
      };
    },
    toJSON(k) {
      const C = {};
      return k.int !== void 0 && (C.int = k.int), C;
    },
    fromPartial(k) {
      var C;
      const B = l();
      return B.int = (C = k.int) !== null && C !== void 0 ? C : "", B;
    }
  };
  function m() {
    return { dec: "" };
  }
  coin.DecProto = {
    encode(k, C = u.default.Writer.create()) {
      return k.dec !== "" && C.uint32(10).string(k.dec), C;
    },
    decode(k, C) {
      const B = k instanceof u.default.Reader ? k : new u.default.Reader(k);
      let Q = C === void 0 ? B.len : B.pos + C;
      const P = m();
      for (; B.pos < Q; ) {
        const x = B.uint32();
        switch (x >>> 3) {
          case 1:
            P.dec = B.string();
            break;
          default:
            B.skipType(x & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(k) {
      return {
        dec: b(k.dec) ? String(k.dec) : ""
      };
    },
    toJSON(k) {
      const C = {};
      return k.dec !== void 0 && (C.dec = k.dec), C;
    },
    fromPartial(k) {
      var C;
      const B = m();
      return B.dec = (C = k.dec) !== null && C !== void 0 ? C : "", B;
    }
  }, u.default.util.Long !== A.default && (u.default.util.Long = A.default, u.default.configure());
  function b(k) {
    return k != null;
  }
  return coin;
}
var hasRequiredTx;
function requireTx() {
  return hasRequiredTx || (hasRequiredTx = 1, function(s) {
    var A = tx && tx.__importDefault || function(ve) {
      return ve && ve.__esModule ? ve : { default: ve };
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), s.AuxSignerData = s.Fee = s.ModeInfo_Multi = s.ModeInfo_Single = s.ModeInfo = s.SignerInfo = s.AuthInfo = s.TxBody = s.SignDocDirectAux = s.SignDoc = s.TxRaw = s.Tx = s.protobufPackage = void 0;
    const u = A(requireLong()), p = A(requireMinimal()), t = requireSigning(), l = requireAny(), m = requireMultisig(), b = requireCoin();
    s.protobufPackage = "cosmos.tx.v1beta1";
    function k() {
      return { body: void 0, authInfo: void 0, signatures: [] };
    }
    s.Tx = {
      encode(ve, we = p.default.Writer.create()) {
        ve.body !== void 0 && s.TxBody.encode(ve.body, we.uint32(10).fork()).ldelim(), ve.authInfo !== void 0 && s.AuthInfo.encode(ve.authInfo, we.uint32(18).fork()).ldelim();
        for (const Ce of ve.signatures)
          we.uint32(26).bytes(Ce);
        return we;
      },
      decode(ve, we) {
        const Ce = ve instanceof p.default.Reader ? ve : new p.default.Reader(ve);
        let Se = we === void 0 ? Ce.len : Ce.pos + we;
        const Ne = k();
        for (; Ce.pos < Se; ) {
          const rr = Ce.uint32();
          switch (rr >>> 3) {
            case 1:
              Ne.body = s.TxBody.decode(Ce, Ce.uint32());
              break;
            case 2:
              Ne.authInfo = s.AuthInfo.decode(Ce, Ce.uint32());
              break;
            case 3:
              Ne.signatures.push(Ce.bytes());
              break;
            default:
              Ce.skipType(rr & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(ve) {
        return {
          body: He(ve.body) ? s.TxBody.fromJSON(ve.body) : void 0,
          authInfo: He(ve.authInfo) ? s.AuthInfo.fromJSON(ve.authInfo) : void 0,
          signatures: Array.isArray(ve == null ? void 0 : ve.signatures) ? ve.signatures.map((we) => Te(we)) : []
        };
      },
      toJSON(ve) {
        const we = {};
        return ve.body !== void 0 && (we.body = ve.body ? s.TxBody.toJSON(ve.body) : void 0), ve.authInfo !== void 0 && (we.authInfo = ve.authInfo ? s.AuthInfo.toJSON(ve.authInfo) : void 0), ve.signatures ? we.signatures = ve.signatures.map((Ce) => xe(Ce !== void 0 ? Ce : new Uint8Array())) : we.signatures = [], we;
      },
      fromPartial(ve) {
        var we;
        const Ce = k();
        return Ce.body = ve.body !== void 0 && ve.body !== null ? s.TxBody.fromPartial(ve.body) : void 0, Ce.authInfo = ve.authInfo !== void 0 && ve.authInfo !== null ? s.AuthInfo.fromPartial(ve.authInfo) : void 0, Ce.signatures = ((we = ve.signatures) === null || we === void 0 ? void 0 : we.map((Se) => Se)) || [], Ce;
      }
    };
    function C() {
      return {
        bodyBytes: new Uint8Array(),
        authInfoBytes: new Uint8Array(),
        signatures: []
      };
    }
    s.TxRaw = {
      encode(ve, we = p.default.Writer.create()) {
        ve.bodyBytes.length !== 0 && we.uint32(10).bytes(ve.bodyBytes), ve.authInfoBytes.length !== 0 && we.uint32(18).bytes(ve.authInfoBytes);
        for (const Ce of ve.signatures)
          we.uint32(26).bytes(Ce);
        return we;
      },
      decode(ve, we) {
        const Ce = ve instanceof p.default.Reader ? ve : new p.default.Reader(ve);
        let Se = we === void 0 ? Ce.len : Ce.pos + we;
        const Ne = C();
        for (; Ce.pos < Se; ) {
          const rr = Ce.uint32();
          switch (rr >>> 3) {
            case 1:
              Ne.bodyBytes = Ce.bytes();
              break;
            case 2:
              Ne.authInfoBytes = Ce.bytes();
              break;
            case 3:
              Ne.signatures.push(Ce.bytes());
              break;
            default:
              Ce.skipType(rr & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(ve) {
        return {
          bodyBytes: He(ve.bodyBytes) ? Te(ve.bodyBytes) : new Uint8Array(),
          authInfoBytes: He(ve.authInfoBytes) ? Te(ve.authInfoBytes) : new Uint8Array(),
          signatures: Array.isArray(ve == null ? void 0 : ve.signatures) ? ve.signatures.map((we) => Te(we)) : []
        };
      },
      toJSON(ve) {
        const we = {};
        return ve.bodyBytes !== void 0 && (we.bodyBytes = xe(ve.bodyBytes !== void 0 ? ve.bodyBytes : new Uint8Array())), ve.authInfoBytes !== void 0 && (we.authInfoBytes = xe(ve.authInfoBytes !== void 0 ? ve.authInfoBytes : new Uint8Array())), ve.signatures ? we.signatures = ve.signatures.map((Ce) => xe(Ce !== void 0 ? Ce : new Uint8Array())) : we.signatures = [], we;
      },
      fromPartial(ve) {
        var we, Ce, Se;
        const Ne = C();
        return Ne.bodyBytes = (we = ve.bodyBytes) !== null && we !== void 0 ? we : new Uint8Array(), Ne.authInfoBytes = (Ce = ve.authInfoBytes) !== null && Ce !== void 0 ? Ce : new Uint8Array(), Ne.signatures = ((Se = ve.signatures) === null || Se === void 0 ? void 0 : Se.map((rr) => rr)) || [], Ne;
      }
    };
    function B() {
      return {
        bodyBytes: new Uint8Array(),
        authInfoBytes: new Uint8Array(),
        chainId: "",
        accountNumber: "0"
      };
    }
    s.SignDoc = {
      encode(ve, we = p.default.Writer.create()) {
        return ve.bodyBytes.length !== 0 && we.uint32(10).bytes(ve.bodyBytes), ve.authInfoBytes.length !== 0 && we.uint32(18).bytes(ve.authInfoBytes), ve.chainId !== "" && we.uint32(26).string(ve.chainId), ve.accountNumber !== "0" && we.uint32(32).uint64(ve.accountNumber), we;
      },
      decode(ve, we) {
        const Ce = ve instanceof p.default.Reader ? ve : new p.default.Reader(ve);
        let Se = we === void 0 ? Ce.len : Ce.pos + we;
        const Ne = B();
        for (; Ce.pos < Se; ) {
          const rr = Ce.uint32();
          switch (rr >>> 3) {
            case 1:
              Ne.bodyBytes = Ce.bytes();
              break;
            case 2:
              Ne.authInfoBytes = Ce.bytes();
              break;
            case 3:
              Ne.chainId = Ce.string();
              break;
            case 4:
              Ne.accountNumber = Ee(Ce.uint64());
              break;
            default:
              Ce.skipType(rr & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(ve) {
        return {
          bodyBytes: He(ve.bodyBytes) ? Te(ve.bodyBytes) : new Uint8Array(),
          authInfoBytes: He(ve.authInfoBytes) ? Te(ve.authInfoBytes) : new Uint8Array(),
          chainId: He(ve.chainId) ? String(ve.chainId) : "",
          accountNumber: He(ve.accountNumber) ? String(ve.accountNumber) : "0"
        };
      },
      toJSON(ve) {
        const we = {};
        return ve.bodyBytes !== void 0 && (we.bodyBytes = xe(ve.bodyBytes !== void 0 ? ve.bodyBytes : new Uint8Array())), ve.authInfoBytes !== void 0 && (we.authInfoBytes = xe(ve.authInfoBytes !== void 0 ? ve.authInfoBytes : new Uint8Array())), ve.chainId !== void 0 && (we.chainId = ve.chainId), ve.accountNumber !== void 0 && (we.accountNumber = ve.accountNumber), we;
      },
      fromPartial(ve) {
        var we, Ce, Se, Ne;
        const rr = B();
        return rr.bodyBytes = (we = ve.bodyBytes) !== null && we !== void 0 ? we : new Uint8Array(), rr.authInfoBytes = (Ce = ve.authInfoBytes) !== null && Ce !== void 0 ? Ce : new Uint8Array(), rr.chainId = (Se = ve.chainId) !== null && Se !== void 0 ? Se : "", rr.accountNumber = (Ne = ve.accountNumber) !== null && Ne !== void 0 ? Ne : "0", rr;
      }
    };
    function Q() {
      return {
        bodyBytes: new Uint8Array(),
        publicKey: void 0,
        chainId: "",
        accountNumber: "0",
        sequence: "0"
      };
    }
    s.SignDocDirectAux = {
      encode(ve, we = p.default.Writer.create()) {
        return ve.bodyBytes.length !== 0 && we.uint32(10).bytes(ve.bodyBytes), ve.publicKey !== void 0 && l.Any.encode(ve.publicKey, we.uint32(18).fork()).ldelim(), ve.chainId !== "" && we.uint32(26).string(ve.chainId), ve.accountNumber !== "0" && we.uint32(32).uint64(ve.accountNumber), ve.sequence !== "0" && we.uint32(40).uint64(ve.sequence), we;
      },
      decode(ve, we) {
        const Ce = ve instanceof p.default.Reader ? ve : new p.default.Reader(ve);
        let Se = we === void 0 ? Ce.len : Ce.pos + we;
        const Ne = Q();
        for (; Ce.pos < Se; ) {
          const rr = Ce.uint32();
          switch (rr >>> 3) {
            case 1:
              Ne.bodyBytes = Ce.bytes();
              break;
            case 2:
              Ne.publicKey = l.Any.decode(Ce, Ce.uint32());
              break;
            case 3:
              Ne.chainId = Ce.string();
              break;
            case 4:
              Ne.accountNumber = Ee(Ce.uint64());
              break;
            case 5:
              Ne.sequence = Ee(Ce.uint64());
              break;
            default:
              Ce.skipType(rr & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(ve) {
        return {
          bodyBytes: He(ve.bodyBytes) ? Te(ve.bodyBytes) : new Uint8Array(),
          publicKey: He(ve.publicKey) ? l.Any.fromJSON(ve.publicKey) : void 0,
          chainId: He(ve.chainId) ? String(ve.chainId) : "",
          accountNumber: He(ve.accountNumber) ? String(ve.accountNumber) : "0",
          sequence: He(ve.sequence) ? String(ve.sequence) : "0"
        };
      },
      toJSON(ve) {
        const we = {};
        return ve.bodyBytes !== void 0 && (we.bodyBytes = xe(ve.bodyBytes !== void 0 ? ve.bodyBytes : new Uint8Array())), ve.publicKey !== void 0 && (we.publicKey = ve.publicKey ? l.Any.toJSON(ve.publicKey) : void 0), ve.chainId !== void 0 && (we.chainId = ve.chainId), ve.accountNumber !== void 0 && (we.accountNumber = ve.accountNumber), ve.sequence !== void 0 && (we.sequence = ve.sequence), we;
      },
      fromPartial(ve) {
        var we, Ce, Se, Ne;
        const rr = Q();
        return rr.bodyBytes = (we = ve.bodyBytes) !== null && we !== void 0 ? we : new Uint8Array(), rr.publicKey = ve.publicKey !== void 0 && ve.publicKey !== null ? l.Any.fromPartial(ve.publicKey) : void 0, rr.chainId = (Ce = ve.chainId) !== null && Ce !== void 0 ? Ce : "", rr.accountNumber = (Se = ve.accountNumber) !== null && Se !== void 0 ? Se : "0", rr.sequence = (Ne = ve.sequence) !== null && Ne !== void 0 ? Ne : "0", rr;
      }
    };
    function P() {
      return {
        messages: [],
        memo: "",
        timeoutHeight: "0",
        extensionOptions: [],
        nonCriticalExtensionOptions: []
      };
    }
    s.TxBody = {
      encode(ve, we = p.default.Writer.create()) {
        for (const Ce of ve.messages)
          l.Any.encode(Ce, we.uint32(10).fork()).ldelim();
        ve.memo !== "" && we.uint32(18).string(ve.memo), ve.timeoutHeight !== "0" && we.uint32(24).uint64(ve.timeoutHeight);
        for (const Ce of ve.extensionOptions)
          l.Any.encode(Ce, we.uint32(8186).fork()).ldelim();
        for (const Ce of ve.nonCriticalExtensionOptions)
          l.Any.encode(Ce, we.uint32(16378).fork()).ldelim();
        return we;
      },
      decode(ve, we) {
        const Ce = ve instanceof p.default.Reader ? ve : new p.default.Reader(ve);
        let Se = we === void 0 ? Ce.len : Ce.pos + we;
        const Ne = P();
        for (; Ce.pos < Se; ) {
          const rr = Ce.uint32();
          switch (rr >>> 3) {
            case 1:
              Ne.messages.push(l.Any.decode(Ce, Ce.uint32()));
              break;
            case 2:
              Ne.memo = Ce.string();
              break;
            case 3:
              Ne.timeoutHeight = Ee(Ce.uint64());
              break;
            case 1023:
              Ne.extensionOptions.push(l.Any.decode(Ce, Ce.uint32()));
              break;
            case 2047:
              Ne.nonCriticalExtensionOptions.push(l.Any.decode(Ce, Ce.uint32()));
              break;
            default:
              Ce.skipType(rr & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(ve) {
        return {
          messages: Array.isArray(ve == null ? void 0 : ve.messages) ? ve.messages.map((we) => l.Any.fromJSON(we)) : [],
          memo: He(ve.memo) ? String(ve.memo) : "",
          timeoutHeight: He(ve.timeoutHeight) ? String(ve.timeoutHeight) : "0",
          extensionOptions: Array.isArray(ve == null ? void 0 : ve.extensionOptions) ? ve.extensionOptions.map((we) => l.Any.fromJSON(we)) : [],
          nonCriticalExtensionOptions: Array.isArray(ve == null ? void 0 : ve.nonCriticalExtensionOptions) ? ve.nonCriticalExtensionOptions.map((we) => l.Any.fromJSON(we)) : []
        };
      },
      toJSON(ve) {
        const we = {};
        return ve.messages ? we.messages = ve.messages.map((Ce) => Ce ? l.Any.toJSON(Ce) : void 0) : we.messages = [], ve.memo !== void 0 && (we.memo = ve.memo), ve.timeoutHeight !== void 0 && (we.timeoutHeight = ve.timeoutHeight), ve.extensionOptions ? we.extensionOptions = ve.extensionOptions.map((Ce) => Ce ? l.Any.toJSON(Ce) : void 0) : we.extensionOptions = [], ve.nonCriticalExtensionOptions ? we.nonCriticalExtensionOptions = ve.nonCriticalExtensionOptions.map((Ce) => Ce ? l.Any.toJSON(Ce) : void 0) : we.nonCriticalExtensionOptions = [], we;
      },
      fromPartial(ve) {
        var we, Ce, Se, Ne, rr;
        const er = P();
        return er.messages = ((we = ve.messages) === null || we === void 0 ? void 0 : we.map((ir) => l.Any.fromPartial(ir))) || [], er.memo = (Ce = ve.memo) !== null && Ce !== void 0 ? Ce : "", er.timeoutHeight = (Se = ve.timeoutHeight) !== null && Se !== void 0 ? Se : "0", er.extensionOptions = ((Ne = ve.extensionOptions) === null || Ne === void 0 ? void 0 : Ne.map((ir) => l.Any.fromPartial(ir))) || [], er.nonCriticalExtensionOptions = ((rr = ve.nonCriticalExtensionOptions) === null || rr === void 0 ? void 0 : rr.map((ir) => l.Any.fromPartial(ir))) || [], er;
      }
    };
    function x() {
      return { signerInfos: [], fee: void 0 };
    }
    s.AuthInfo = {
      encode(ve, we = p.default.Writer.create()) {
        for (const Ce of ve.signerInfos)
          s.SignerInfo.encode(Ce, we.uint32(10).fork()).ldelim();
        return ve.fee !== void 0 && s.Fee.encode(ve.fee, we.uint32(18).fork()).ldelim(), we;
      },
      decode(ve, we) {
        const Ce = ve instanceof p.default.Reader ? ve : new p.default.Reader(ve);
        let Se = we === void 0 ? Ce.len : Ce.pos + we;
        const Ne = x();
        for (; Ce.pos < Se; ) {
          const rr = Ce.uint32();
          switch (rr >>> 3) {
            case 1:
              Ne.signerInfos.push(s.SignerInfo.decode(Ce, Ce.uint32()));
              break;
            case 2:
              Ne.fee = s.Fee.decode(Ce, Ce.uint32());
              break;
            default:
              Ce.skipType(rr & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(ve) {
        return {
          signerInfos: Array.isArray(ve == null ? void 0 : ve.signerInfos) ? ve.signerInfos.map((we) => s.SignerInfo.fromJSON(we)) : [],
          fee: He(ve.fee) ? s.Fee.fromJSON(ve.fee) : void 0
        };
      },
      toJSON(ve) {
        const we = {};
        return ve.signerInfos ? we.signerInfos = ve.signerInfos.map((Ce) => Ce ? s.SignerInfo.toJSON(Ce) : void 0) : we.signerInfos = [], ve.fee !== void 0 && (we.fee = ve.fee ? s.Fee.toJSON(ve.fee) : void 0), we;
      },
      fromPartial(ve) {
        var we;
        const Ce = x();
        return Ce.signerInfos = ((we = ve.signerInfos) === null || we === void 0 ? void 0 : we.map((Se) => s.SignerInfo.fromPartial(Se))) || [], Ce.fee = ve.fee !== void 0 && ve.fee !== null ? s.Fee.fromPartial(ve.fee) : void 0, Ce;
      }
    };
    function M() {
      return { publicKey: void 0, modeInfo: void 0, sequence: "0" };
    }
    s.SignerInfo = {
      encode(ve, we = p.default.Writer.create()) {
        return ve.publicKey !== void 0 && l.Any.encode(ve.publicKey, we.uint32(10).fork()).ldelim(), ve.modeInfo !== void 0 && s.ModeInfo.encode(ve.modeInfo, we.uint32(18).fork()).ldelim(), ve.sequence !== "0" && we.uint32(24).uint64(ve.sequence), we;
      },
      decode(ve, we) {
        const Ce = ve instanceof p.default.Reader ? ve : new p.default.Reader(ve);
        let Se = we === void 0 ? Ce.len : Ce.pos + we;
        const Ne = M();
        for (; Ce.pos < Se; ) {
          const rr = Ce.uint32();
          switch (rr >>> 3) {
            case 1:
              Ne.publicKey = l.Any.decode(Ce, Ce.uint32());
              break;
            case 2:
              Ne.modeInfo = s.ModeInfo.decode(Ce, Ce.uint32());
              break;
            case 3:
              Ne.sequence = Ee(Ce.uint64());
              break;
            default:
              Ce.skipType(rr & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(ve) {
        return {
          publicKey: He(ve.publicKey) ? l.Any.fromJSON(ve.publicKey) : void 0,
          modeInfo: He(ve.modeInfo) ? s.ModeInfo.fromJSON(ve.modeInfo) : void 0,
          sequence: He(ve.sequence) ? String(ve.sequence) : "0"
        };
      },
      toJSON(ve) {
        const we = {};
        return ve.publicKey !== void 0 && (we.publicKey = ve.publicKey ? l.Any.toJSON(ve.publicKey) : void 0), ve.modeInfo !== void 0 && (we.modeInfo = ve.modeInfo ? s.ModeInfo.toJSON(ve.modeInfo) : void 0), ve.sequence !== void 0 && (we.sequence = ve.sequence), we;
      },
      fromPartial(ve) {
        var we;
        const Ce = M();
        return Ce.publicKey = ve.publicKey !== void 0 && ve.publicKey !== null ? l.Any.fromPartial(ve.publicKey) : void 0, Ce.modeInfo = ve.modeInfo !== void 0 && ve.modeInfo !== null ? s.ModeInfo.fromPartial(ve.modeInfo) : void 0, Ce.sequence = (we = ve.sequence) !== null && we !== void 0 ? we : "0", Ce;
      }
    };
    function F() {
      return { single: void 0, multi: void 0 };
    }
    s.ModeInfo = {
      encode(ve, we = p.default.Writer.create()) {
        return ve.single !== void 0 && s.ModeInfo_Single.encode(ve.single, we.uint32(10).fork()).ldelim(), ve.multi !== void 0 && s.ModeInfo_Multi.encode(ve.multi, we.uint32(18).fork()).ldelim(), we;
      },
      decode(ve, we) {
        const Ce = ve instanceof p.default.Reader ? ve : new p.default.Reader(ve);
        let Se = we === void 0 ? Ce.len : Ce.pos + we;
        const Ne = F();
        for (; Ce.pos < Se; ) {
          const rr = Ce.uint32();
          switch (rr >>> 3) {
            case 1:
              Ne.single = s.ModeInfo_Single.decode(Ce, Ce.uint32());
              break;
            case 2:
              Ne.multi = s.ModeInfo_Multi.decode(Ce, Ce.uint32());
              break;
            default:
              Ce.skipType(rr & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(ve) {
        return {
          single: He(ve.single) ? s.ModeInfo_Single.fromJSON(ve.single) : void 0,
          multi: He(ve.multi) ? s.ModeInfo_Multi.fromJSON(ve.multi) : void 0
        };
      },
      toJSON(ve) {
        const we = {};
        return ve.single !== void 0 && (we.single = ve.single ? s.ModeInfo_Single.toJSON(ve.single) : void 0), ve.multi !== void 0 && (we.multi = ve.multi ? s.ModeInfo_Multi.toJSON(ve.multi) : void 0), we;
      },
      fromPartial(ve) {
        const we = F();
        return we.single = ve.single !== void 0 && ve.single !== null ? s.ModeInfo_Single.fromPartial(ve.single) : void 0, we.multi = ve.multi !== void 0 && ve.multi !== null ? s.ModeInfo_Multi.fromPartial(ve.multi) : void 0, we;
      }
    };
    function le() {
      return { mode: 0 };
    }
    s.ModeInfo_Single = {
      encode(ve, we = p.default.Writer.create()) {
        return ve.mode !== 0 && we.uint32(8).int32(ve.mode), we;
      },
      decode(ve, we) {
        const Ce = ve instanceof p.default.Reader ? ve : new p.default.Reader(ve);
        let Se = we === void 0 ? Ce.len : Ce.pos + we;
        const Ne = le();
        for (; Ce.pos < Se; ) {
          const rr = Ce.uint32();
          switch (rr >>> 3) {
            case 1:
              Ne.mode = Ce.int32();
              break;
            default:
              Ce.skipType(rr & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(ve) {
        return {
          mode: He(ve.mode) ? (0, t.signModeFromJSON)(ve.mode) : 0
        };
      },
      toJSON(ve) {
        const we = {};
        return ve.mode !== void 0 && (we.mode = (0, t.signModeToJSON)(ve.mode)), we;
      },
      fromPartial(ve) {
        var we;
        const Ce = le();
        return Ce.mode = (we = ve.mode) !== null && we !== void 0 ? we : 0, Ce;
      }
    };
    function ge() {
      return { bitarray: void 0, modeInfos: [] };
    }
    s.ModeInfo_Multi = {
      encode(ve, we = p.default.Writer.create()) {
        ve.bitarray !== void 0 && m.CompactBitArray.encode(ve.bitarray, we.uint32(10).fork()).ldelim();
        for (const Ce of ve.modeInfos)
          s.ModeInfo.encode(Ce, we.uint32(18).fork()).ldelim();
        return we;
      },
      decode(ve, we) {
        const Ce = ve instanceof p.default.Reader ? ve : new p.default.Reader(ve);
        let Se = we === void 0 ? Ce.len : Ce.pos + we;
        const Ne = ge();
        for (; Ce.pos < Se; ) {
          const rr = Ce.uint32();
          switch (rr >>> 3) {
            case 1:
              Ne.bitarray = m.CompactBitArray.decode(Ce, Ce.uint32());
              break;
            case 2:
              Ne.modeInfos.push(s.ModeInfo.decode(Ce, Ce.uint32()));
              break;
            default:
              Ce.skipType(rr & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(ve) {
        return {
          bitarray: He(ve.bitarray) ? m.CompactBitArray.fromJSON(ve.bitarray) : void 0,
          modeInfos: Array.isArray(ve == null ? void 0 : ve.modeInfos) ? ve.modeInfos.map((we) => s.ModeInfo.fromJSON(we)) : []
        };
      },
      toJSON(ve) {
        const we = {};
        return ve.bitarray !== void 0 && (we.bitarray = ve.bitarray ? m.CompactBitArray.toJSON(ve.bitarray) : void 0), ve.modeInfos ? we.modeInfos = ve.modeInfos.map((Ce) => Ce ? s.ModeInfo.toJSON(Ce) : void 0) : we.modeInfos = [], we;
      },
      fromPartial(ve) {
        var we;
        const Ce = ge();
        return Ce.bitarray = ve.bitarray !== void 0 && ve.bitarray !== null ? m.CompactBitArray.fromPartial(ve.bitarray) : void 0, Ce.modeInfos = ((we = ve.modeInfos) === null || we === void 0 ? void 0 : we.map((Se) => s.ModeInfo.fromPartial(Se))) || [], Ce;
      }
    };
    function pe() {
      return { amount: [], gasLimit: "0", payer: "", granter: "" };
    }
    s.Fee = {
      encode(ve, we = p.default.Writer.create()) {
        for (const Ce of ve.amount)
          b.Coin.encode(Ce, we.uint32(10).fork()).ldelim();
        return ve.gasLimit !== "0" && we.uint32(16).uint64(ve.gasLimit), ve.payer !== "" && we.uint32(26).string(ve.payer), ve.granter !== "" && we.uint32(34).string(ve.granter), we;
      },
      decode(ve, we) {
        const Ce = ve instanceof p.default.Reader ? ve : new p.default.Reader(ve);
        let Se = we === void 0 ? Ce.len : Ce.pos + we;
        const Ne = pe();
        for (; Ce.pos < Se; ) {
          const rr = Ce.uint32();
          switch (rr >>> 3) {
            case 1:
              Ne.amount.push(b.Coin.decode(Ce, Ce.uint32()));
              break;
            case 2:
              Ne.gasLimit = Ee(Ce.uint64());
              break;
            case 3:
              Ne.payer = Ce.string();
              break;
            case 4:
              Ne.granter = Ce.string();
              break;
            default:
              Ce.skipType(rr & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(ve) {
        return {
          amount: Array.isArray(ve == null ? void 0 : ve.amount) ? ve.amount.map((we) => b.Coin.fromJSON(we)) : [],
          gasLimit: He(ve.gasLimit) ? String(ve.gasLimit) : "0",
          payer: He(ve.payer) ? String(ve.payer) : "",
          granter: He(ve.granter) ? String(ve.granter) : ""
        };
      },
      toJSON(ve) {
        const we = {};
        return ve.amount ? we.amount = ve.amount.map((Ce) => Ce ? b.Coin.toJSON(Ce) : void 0) : we.amount = [], ve.gasLimit !== void 0 && (we.gasLimit = ve.gasLimit), ve.payer !== void 0 && (we.payer = ve.payer), ve.granter !== void 0 && (we.granter = ve.granter), we;
      },
      fromPartial(ve) {
        var we, Ce, Se, Ne;
        const rr = pe();
        return rr.amount = ((we = ve.amount) === null || we === void 0 ? void 0 : we.map((er) => b.Coin.fromPartial(er))) || [], rr.gasLimit = (Ce = ve.gasLimit) !== null && Ce !== void 0 ? Ce : "0", rr.payer = (Se = ve.payer) !== null && Se !== void 0 ? Se : "", rr.granter = (Ne = ve.granter) !== null && Ne !== void 0 ? Ne : "", rr;
      }
    };
    function Ie() {
      return { address: "", signDoc: void 0, mode: 0, sig: new Uint8Array() };
    }
    s.AuxSignerData = {
      encode(ve, we = p.default.Writer.create()) {
        return ve.address !== "" && we.uint32(10).string(ve.address), ve.signDoc !== void 0 && s.SignDocDirectAux.encode(ve.signDoc, we.uint32(18).fork()).ldelim(), ve.mode !== 0 && we.uint32(24).int32(ve.mode), ve.sig.length !== 0 && we.uint32(34).bytes(ve.sig), we;
      },
      decode(ve, we) {
        const Ce = ve instanceof p.default.Reader ? ve : new p.default.Reader(ve);
        let Se = we === void 0 ? Ce.len : Ce.pos + we;
        const Ne = Ie();
        for (; Ce.pos < Se; ) {
          const rr = Ce.uint32();
          switch (rr >>> 3) {
            case 1:
              Ne.address = Ce.string();
              break;
            case 2:
              Ne.signDoc = s.SignDocDirectAux.decode(Ce, Ce.uint32());
              break;
            case 3:
              Ne.mode = Ce.int32();
              break;
            case 4:
              Ne.sig = Ce.bytes();
              break;
            default:
              Ce.skipType(rr & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(ve) {
        return {
          address: He(ve.address) ? String(ve.address) : "",
          signDoc: He(ve.signDoc) ? s.SignDocDirectAux.fromJSON(ve.signDoc) : void 0,
          mode: He(ve.mode) ? (0, t.signModeFromJSON)(ve.mode) : 0,
          sig: He(ve.sig) ? Te(ve.sig) : new Uint8Array()
        };
      },
      toJSON(ve) {
        const we = {};
        return ve.address !== void 0 && (we.address = ve.address), ve.signDoc !== void 0 && (we.signDoc = ve.signDoc ? s.SignDocDirectAux.toJSON(ve.signDoc) : void 0), ve.mode !== void 0 && (we.mode = (0, t.signModeToJSON)(ve.mode)), ve.sig !== void 0 && (we.sig = xe(ve.sig !== void 0 ? ve.sig : new Uint8Array())), we;
      },
      fromPartial(ve) {
        var we, Ce, Se;
        const Ne = Ie();
        return Ne.address = (we = ve.address) !== null && we !== void 0 ? we : "", Ne.signDoc = ve.signDoc !== void 0 && ve.signDoc !== null ? s.SignDocDirectAux.fromPartial(ve.signDoc) : void 0, Ne.mode = (Ce = ve.mode) !== null && Ce !== void 0 ? Ce : 0, Ne.sig = (Se = ve.sig) !== null && Se !== void 0 ? Se : new Uint8Array(), Ne;
      }
    };
    var be = (() => {
      if (typeof be < "u")
        return be;
      if (typeof self < "u")
        return self;
      if (typeof window < "u")
        return window;
      if (typeof commonjsGlobal < "u")
        return commonjsGlobal;
      throw "Unable to locate global object";
    })();
    const Pe = be.atob || ((ve) => be.Buffer.from(ve, "base64").toString("binary"));
    function Te(ve) {
      const we = Pe(ve), Ce = new Uint8Array(we.length);
      for (let Se = 0; Se < we.length; ++Se)
        Ce[Se] = we.charCodeAt(Se);
      return Ce;
    }
    const Qe = be.btoa || ((ve) => be.Buffer.from(ve, "binary").toString("base64"));
    function xe(ve) {
      const we = [];
      for (const Ce of ve)
        we.push(String.fromCharCode(Ce));
      return Qe(we.join(""));
    }
    function Ee(ve) {
      return ve.toString();
    }
    p.default.util.Long !== u.default && (p.default.util.Long = u.default, p.default.configure());
    function He(ve) {
      return ve != null;
    }
  }(tx)), tx;
}
var txExports = requireTx();
var wasm$1 = null;
try {
  wasm$1 = new WebAssembly.Instance(
    new WebAssembly.Module(
      new Uint8Array([
        // \0asm
        0,
        97,
        115,
        109,
        // version 1
        1,
        0,
        0,
        0,
        // section "type"
        1,
        13,
        2,
        // 0, () => i32
        96,
        0,
        1,
        127,
        // 1, (i32, i32, i32, i32) => i32
        96,
        4,
        127,
        127,
        127,
        127,
        1,
        127,
        // section "function"
        3,
        7,
        6,
        // 0, type 0
        0,
        // 1, type 1
        1,
        // 2, type 1
        1,
        // 3, type 1
        1,
        // 4, type 1
        1,
        // 5, type 1
        1,
        // section "global"
        6,
        6,
        1,
        // 0, "high", mutable i32
        127,
        1,
        65,
        0,
        11,
        // section "export"
        7,
        50,
        6,
        // 0, "mul"
        3,
        109,
        117,
        108,
        0,
        1,
        // 1, "div_s"
        5,
        100,
        105,
        118,
        95,
        115,
        0,
        2,
        // 2, "div_u"
        5,
        100,
        105,
        118,
        95,
        117,
        0,
        3,
        // 3, "rem_s"
        5,
        114,
        101,
        109,
        95,
        115,
        0,
        4,
        // 4, "rem_u"
        5,
        114,
        101,
        109,
        95,
        117,
        0,
        5,
        // 5, "get_high"
        8,
        103,
        101,
        116,
        95,
        104,
        105,
        103,
        104,
        0,
        0,
        // section "code"
        10,
        191,
        1,
        6,
        // 0, "get_high"
        4,
        0,
        35,
        0,
        11,
        // 1, "mul"
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        126,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        // 2, "div_s"
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        127,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        // 3, "div_u"
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        128,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        // 4, "rem_s"
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        129,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        // 5, "rem_u"
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        130,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11
      ])
    ),
    {}
  ).exports;
} catch {
}
function Long(s, A, u) {
  this.low = s | 0, this.high = A | 0, this.unsigned = !!u;
}
Long.prototype.__isLong__;
Object.defineProperty(Long.prototype, "__isLong__", { value: !0 });
function isLong(s) {
  return (s && s.__isLong__) === !0;
}
function ctz32(s) {
  var A = Math.clz32(s & -s);
  return s ? 31 - A : A;
}
Long.isLong = isLong;
var INT_CACHE = {}, UINT_CACHE = {};
function fromInt(s, A) {
  var u, p, t;
  return A ? (s >>>= 0, (t = 0 <= s && s < 256) && (p = UINT_CACHE[s], p) ? p : (u = fromBits(s, 0, !0), t && (UINT_CACHE[s] = u), u)) : (s |= 0, (t = -128 <= s && s < 128) && (p = INT_CACHE[s], p) ? p : (u = fromBits(s, s < 0 ? -1 : 0, !1), t && (INT_CACHE[s] = u), u));
}
Long.fromInt = fromInt;
function fromNumber$1(s, A) {
  if (isNaN(s)) return A ? UZERO : ZERO;
  if (A) {
    if (s < 0) return UZERO;
    if (s >= TWO_PWR_64_DBL) return MAX_UNSIGNED_VALUE;
  } else {
    if (s <= -TWO_PWR_63_DBL) return MIN_VALUE;
    if (s + 1 >= TWO_PWR_63_DBL) return MAX_VALUE;
  }
  return s < 0 ? fromNumber$1(-s, A).neg() : fromBits(
    s % TWO_PWR_32_DBL | 0,
    s / TWO_PWR_32_DBL | 0,
    A
  );
}
Long.fromNumber = fromNumber$1;
function fromBits(s, A, u) {
  return new Long(s, A, u);
}
Long.fromBits = fromBits;
var pow_dbl = Math.pow;
function fromString(s, A, u) {
  if (s.length === 0) throw Error("empty string");
  if (typeof A == "number" ? (u = A, A = !1) : A = !!A, s === "NaN" || s === "Infinity" || s === "+Infinity" || s === "-Infinity")
    return A ? UZERO : ZERO;
  if (u = u || 10, u < 2 || 36 < u) throw RangeError("radix");
  var p;
  if ((p = s.indexOf("-")) > 0) throw Error("interior hyphen");
  if (p === 0)
    return fromString(s.substring(1), A, u).neg();
  for (var t = fromNumber$1(pow_dbl(u, 8)), l = ZERO, m = 0; m < s.length; m += 8) {
    var b = Math.min(8, s.length - m), k = parseInt(s.substring(m, m + b), u);
    if (b < 8) {
      var C = fromNumber$1(pow_dbl(u, b));
      l = l.mul(C).add(fromNumber$1(k));
    } else
      l = l.mul(t), l = l.add(fromNumber$1(k));
  }
  return l.unsigned = A, l;
}
Long.fromString = fromString;
function fromValue(s, A) {
  return typeof s == "number" ? fromNumber$1(s, A) : typeof s == "string" ? fromString(s, A) : fromBits(
    s.low,
    s.high,
    typeof A == "boolean" ? A : s.unsigned
  );
}
Long.fromValue = fromValue;
var TWO_PWR_16_DBL = 65536, TWO_PWR_24_DBL = 1 << 24, TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL, TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL, TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2, TWO_PWR_24 = fromInt(TWO_PWR_24_DBL), ZERO = fromInt(0);
Long.ZERO = ZERO;
var UZERO = fromInt(0, !0);
Long.UZERO = UZERO;
var ONE = fromInt(1);
Long.ONE = ONE;
var UONE = fromInt(1, !0);
Long.UONE = UONE;
var NEG_ONE = fromInt(-1);
Long.NEG_ONE = NEG_ONE;
var MAX_VALUE = fromBits(-1, 2147483647, !1);
Long.MAX_VALUE = MAX_VALUE;
var MAX_UNSIGNED_VALUE = fromBits(-1, -1, !0);
Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;
var MIN_VALUE = fromBits(0, -2147483648, !1);
Long.MIN_VALUE = MIN_VALUE;
var LongPrototype = Long.prototype;
LongPrototype.toInt = function s() {
  return this.unsigned ? this.low >>> 0 : this.low;
};
LongPrototype.toNumber = function s() {
  return this.unsigned ? (this.high >>> 0) * TWO_PWR_32_DBL + (this.low >>> 0) : this.high * TWO_PWR_32_DBL + (this.low >>> 0);
};
LongPrototype.toString = function s(A) {
  if (A = A || 10, A < 2 || 36 < A) throw RangeError("radix");
  if (this.isZero()) return "0";
  if (this.isNegative())
    if (this.eq(MIN_VALUE)) {
      var u = fromNumber$1(A), p = this.div(u), t = p.mul(u).sub(this);
      return p.toString(A) + t.toInt().toString(A);
    } else return "-" + this.neg().toString(A);
  for (var l = fromNumber$1(pow_dbl(A, 6), this.unsigned), m = this, b = ""; ; ) {
    var k = m.div(l), C = m.sub(k.mul(l)).toInt() >>> 0, B = C.toString(A);
    if (m = k, m.isZero()) return B + b;
    for (; B.length < 6; ) B = "0" + B;
    b = "" + B + b;
  }
};
LongPrototype.getHighBits = function s() {
  return this.high;
};
LongPrototype.getHighBitsUnsigned = function s() {
  return this.high >>> 0;
};
LongPrototype.getLowBits = function s() {
  return this.low;
};
LongPrototype.getLowBitsUnsigned = function s() {
  return this.low >>> 0;
};
LongPrototype.getNumBitsAbs = function s() {
  if (this.isNegative())
    return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
  for (var A = this.high != 0 ? this.high : this.low, u = 31; u > 0 && (A & 1 << u) == 0; u--) ;
  return this.high != 0 ? u + 33 : u + 1;
};
LongPrototype.isSafeInteger = function s() {
  var A = this.high >> 21;
  return A ? this.unsigned ? !1 : A === -1 && !(this.low === 0 && this.high === -2097152) : !0;
};
LongPrototype.isZero = function s() {
  return this.high === 0 && this.low === 0;
};
LongPrototype.eqz = LongPrototype.isZero;
LongPrototype.isNegative = function s() {
  return !this.unsigned && this.high < 0;
};
LongPrototype.isPositive = function s() {
  return this.unsigned || this.high >= 0;
};
LongPrototype.isOdd = function s() {
  return (this.low & 1) === 1;
};
LongPrototype.isEven = function s() {
  return (this.low & 1) === 0;
};
LongPrototype.equals = function s(A) {
  return isLong(A) || (A = fromValue(A)), this.unsigned !== A.unsigned && this.high >>> 31 === 1 && A.high >>> 31 === 1 ? !1 : this.high === A.high && this.low === A.low;
};
LongPrototype.eq = LongPrototype.equals;
LongPrototype.notEquals = function s(A) {
  return !this.eq(
    /* validates */
    A
  );
};
LongPrototype.neq = LongPrototype.notEquals;
LongPrototype.ne = LongPrototype.notEquals;
LongPrototype.lessThan = function s(A) {
  return this.comp(
    /* validates */
    A
  ) < 0;
};
LongPrototype.lt = LongPrototype.lessThan;
LongPrototype.lessThanOrEqual = function s(A) {
  return this.comp(
    /* validates */
    A
  ) <= 0;
};
LongPrototype.lte = LongPrototype.lessThanOrEqual;
LongPrototype.le = LongPrototype.lessThanOrEqual;
LongPrototype.greaterThan = function s(A) {
  return this.comp(
    /* validates */
    A
  ) > 0;
};
LongPrototype.gt = LongPrototype.greaterThan;
LongPrototype.greaterThanOrEqual = function s(A) {
  return this.comp(
    /* validates */
    A
  ) >= 0;
};
LongPrototype.gte = LongPrototype.greaterThanOrEqual;
LongPrototype.ge = LongPrototype.greaterThanOrEqual;
LongPrototype.compare = function s(A) {
  if (isLong(A) || (A = fromValue(A)), this.eq(A)) return 0;
  var u = this.isNegative(), p = A.isNegative();
  return u && !p ? -1 : !u && p ? 1 : this.unsigned ? A.high >>> 0 > this.high >>> 0 || A.high === this.high && A.low >>> 0 > this.low >>> 0 ? -1 : 1 : this.sub(A).isNegative() ? -1 : 1;
};
LongPrototype.comp = LongPrototype.compare;
LongPrototype.negate = function s() {
  return !this.unsigned && this.eq(MIN_VALUE) ? MIN_VALUE : this.not().add(ONE);
};
LongPrototype.neg = LongPrototype.negate;
LongPrototype.add = function s(A) {
  isLong(A) || (A = fromValue(A));
  var u = this.high >>> 16, p = this.high & 65535, t = this.low >>> 16, l = this.low & 65535, m = A.high >>> 16, b = A.high & 65535, k = A.low >>> 16, C = A.low & 65535, B = 0, Q = 0, P = 0, x = 0;
  return x += l + C, P += x >>> 16, x &= 65535, P += t + k, Q += P >>> 16, P &= 65535, Q += p + b, B += Q >>> 16, Q &= 65535, B += u + m, B &= 65535, fromBits(P << 16 | x, B << 16 | Q, this.unsigned);
};
LongPrototype.subtract = function s(A) {
  return isLong(A) || (A = fromValue(A)), this.add(A.neg());
};
LongPrototype.sub = LongPrototype.subtract;
LongPrototype.multiply = function s(A) {
  if (this.isZero()) return this;
  if (isLong(A) || (A = fromValue(A)), wasm$1) {
    var u = wasm$1.mul(this.low, this.high, A.low, A.high);
    return fromBits(u, wasm$1.get_high(), this.unsigned);
  }
  if (A.isZero()) return this.unsigned ? UZERO : ZERO;
  if (this.eq(MIN_VALUE)) return A.isOdd() ? MIN_VALUE : ZERO;
  if (A.eq(MIN_VALUE)) return this.isOdd() ? MIN_VALUE : ZERO;
  if (this.isNegative())
    return A.isNegative() ? this.neg().mul(A.neg()) : this.neg().mul(A).neg();
  if (A.isNegative()) return this.mul(A.neg()).neg();
  if (this.lt(TWO_PWR_24) && A.lt(TWO_PWR_24))
    return fromNumber$1(this.toNumber() * A.toNumber(), this.unsigned);
  var p = this.high >>> 16, t = this.high & 65535, l = this.low >>> 16, m = this.low & 65535, b = A.high >>> 16, k = A.high & 65535, C = A.low >>> 16, B = A.low & 65535, Q = 0, P = 0, x = 0, M = 0;
  return M += m * B, x += M >>> 16, M &= 65535, x += l * B, P += x >>> 16, x &= 65535, x += m * C, P += x >>> 16, x &= 65535, P += t * B, Q += P >>> 16, P &= 65535, P += l * C, Q += P >>> 16, P &= 65535, P += m * k, Q += P >>> 16, P &= 65535, Q += p * B + t * C + l * k + m * b, Q &= 65535, fromBits(x << 16 | M, Q << 16 | P, this.unsigned);
};
LongPrototype.mul = LongPrototype.multiply;
LongPrototype.divide = function s(A) {
  if (isLong(A) || (A = fromValue(A)), A.isZero()) throw Error("division by zero");
  if (wasm$1) {
    if (!this.unsigned && this.high === -2147483648 && A.low === -1 && A.high === -1)
      return this;
    var u = (this.unsigned ? wasm$1.div_u : wasm$1.div_s)(
      this.low,
      this.high,
      A.low,
      A.high
    );
    return fromBits(u, wasm$1.get_high(), this.unsigned);
  }
  if (this.isZero()) return this.unsigned ? UZERO : ZERO;
  var p, t, l;
  if (this.unsigned) {
    if (A.unsigned || (A = A.toUnsigned()), A.gt(this)) return UZERO;
    if (A.gt(this.shru(1)))
      return UONE;
    l = UZERO;
  } else {
    if (this.eq(MIN_VALUE)) {
      if (A.eq(ONE) || A.eq(NEG_ONE))
        return MIN_VALUE;
      if (A.eq(MIN_VALUE)) return ONE;
      var m = this.shr(1);
      return p = m.div(A).shl(1), p.eq(ZERO) ? A.isNegative() ? ONE : NEG_ONE : (t = this.sub(A.mul(p)), l = p.add(t.div(A)), l);
    } else if (A.eq(MIN_VALUE)) return this.unsigned ? UZERO : ZERO;
    if (this.isNegative())
      return A.isNegative() ? this.neg().div(A.neg()) : this.neg().div(A).neg();
    if (A.isNegative()) return this.div(A.neg()).neg();
    l = ZERO;
  }
  for (t = this; t.gte(A); ) {
    p = Math.max(1, Math.floor(t.toNumber() / A.toNumber()));
    for (var b = Math.ceil(Math.log(p) / Math.LN2), k = b <= 48 ? 1 : pow_dbl(2, b - 48), C = fromNumber$1(p), B = C.mul(A); B.isNegative() || B.gt(t); )
      p -= k, C = fromNumber$1(p, this.unsigned), B = C.mul(A);
    C.isZero() && (C = ONE), l = l.add(C), t = t.sub(B);
  }
  return l;
};
LongPrototype.div = LongPrototype.divide;
LongPrototype.modulo = function s(A) {
  if (isLong(A) || (A = fromValue(A)), wasm$1) {
    var u = (this.unsigned ? wasm$1.rem_u : wasm$1.rem_s)(
      this.low,
      this.high,
      A.low,
      A.high
    );
    return fromBits(u, wasm$1.get_high(), this.unsigned);
  }
  return this.sub(this.div(A).mul(A));
};
LongPrototype.mod = LongPrototype.modulo;
LongPrototype.rem = LongPrototype.modulo;
LongPrototype.not = function s() {
  return fromBits(~this.low, ~this.high, this.unsigned);
};
LongPrototype.countLeadingZeros = function s() {
  return this.high ? Math.clz32(this.high) : Math.clz32(this.low) + 32;
};
LongPrototype.clz = LongPrototype.countLeadingZeros;
LongPrototype.countTrailingZeros = function s() {
  return this.low ? ctz32(this.low) : ctz32(this.high) + 32;
};
LongPrototype.ctz = LongPrototype.countTrailingZeros;
LongPrototype.and = function s(A) {
  return isLong(A) || (A = fromValue(A)), fromBits(this.low & A.low, this.high & A.high, this.unsigned);
};
LongPrototype.or = function s(A) {
  return isLong(A) || (A = fromValue(A)), fromBits(this.low | A.low, this.high | A.high, this.unsigned);
};
LongPrototype.xor = function s(A) {
  return isLong(A) || (A = fromValue(A)), fromBits(this.low ^ A.low, this.high ^ A.high, this.unsigned);
};
LongPrototype.shiftLeft = function s(A) {
  return isLong(A) && (A = A.toInt()), (A &= 63) === 0 ? this : A < 32 ? fromBits(
    this.low << A,
    this.high << A | this.low >>> 32 - A,
    this.unsigned
  ) : fromBits(0, this.low << A - 32, this.unsigned);
};
LongPrototype.shl = LongPrototype.shiftLeft;
LongPrototype.shiftRight = function s(A) {
  return isLong(A) && (A = A.toInt()), (A &= 63) === 0 ? this : A < 32 ? fromBits(
    this.low >>> A | this.high << 32 - A,
    this.high >> A,
    this.unsigned
  ) : fromBits(
    this.high >> A - 32,
    this.high >= 0 ? 0 : -1,
    this.unsigned
  );
};
LongPrototype.shr = LongPrototype.shiftRight;
LongPrototype.shiftRightUnsigned = function s(A) {
  return isLong(A) && (A = A.toInt()), (A &= 63) === 0 ? this : A < 32 ? fromBits(
    this.low >>> A | this.high << 32 - A,
    this.high >>> A,
    this.unsigned
  ) : A === 32 ? fromBits(this.high, 0, this.unsigned) : fromBits(this.high >>> A - 32, 0, this.unsigned);
};
LongPrototype.shru = LongPrototype.shiftRightUnsigned;
LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;
LongPrototype.rotateLeft = function s(A) {
  var u;
  return isLong(A) && (A = A.toInt()), (A &= 63) === 0 ? this : A === 32 ? fromBits(this.high, this.low, this.unsigned) : A < 32 ? (u = 32 - A, fromBits(
    this.low << A | this.high >>> u,
    this.high << A | this.low >>> u,
    this.unsigned
  )) : (A -= 32, u = 32 - A, fromBits(
    this.high << A | this.low >>> u,
    this.low << A | this.high >>> u,
    this.unsigned
  ));
};
LongPrototype.rotl = LongPrototype.rotateLeft;
LongPrototype.rotateRight = function s(A) {
  var u;
  return isLong(A) && (A = A.toInt()), (A &= 63) === 0 ? this : A === 32 ? fromBits(this.high, this.low, this.unsigned) : A < 32 ? (u = 32 - A, fromBits(
    this.high << u | this.low >>> A,
    this.low << u | this.high >>> A,
    this.unsigned
  )) : (A -= 32, u = 32 - A, fromBits(
    this.low << u | this.high >>> A,
    this.high << u | this.low >>> A,
    this.unsigned
  ));
};
LongPrototype.rotr = LongPrototype.rotateRight;
LongPrototype.toSigned = function s() {
  return this.unsigned ? fromBits(this.low, this.high, !1) : this;
};
LongPrototype.toUnsigned = function s() {
  return this.unsigned ? this : fromBits(this.low, this.high, !0);
};
LongPrototype.toBytes = function s(A) {
  return A ? this.toBytesLE() : this.toBytesBE();
};
LongPrototype.toBytesLE = function s() {
  var A = this.high, u = this.low;
  return [
    u & 255,
    u >>> 8 & 255,
    u >>> 16 & 255,
    u >>> 24,
    A & 255,
    A >>> 8 & 255,
    A >>> 16 & 255,
    A >>> 24
  ];
};
LongPrototype.toBytesBE = function s() {
  var A = this.high, u = this.low;
  return [
    A >>> 24,
    A >>> 16 & 255,
    A >>> 8 & 255,
    A & 255,
    u >>> 24,
    u >>> 16 & 255,
    u >>> 8 & 255,
    u & 255
  ];
};
Long.fromBytes = function s(A, u, p) {
  return p ? Long.fromBytesLE(A, u) : Long.fromBytesBE(A, u);
};
Long.fromBytesLE = function s(A, u) {
  return new Long(
    A[0] | A[1] << 8 | A[2] << 16 | A[3] << 24,
    A[4] | A[5] << 8 | A[6] << 16 | A[7] << 24,
    u
  );
};
Long.fromBytesBE = function s(A, u) {
  return new Long(
    A[4] << 24 | A[5] << 16 | A[6] << 8 | A[7],
    A[0] << 24 | A[1] << 16 | A[2] << 8 | A[3],
    u
  );
};
typeof BigInt == "function" && (Long.fromBigInt = function(A, u) {
  var p = Number(BigInt.asIntN(32, A)), t = Number(BigInt.asIntN(32, A >> BigInt(32)));
  return fromBits(p, t, u);
}, Long.fromValue = function(A, u) {
  return typeof A == "bigint" ? Long.fromBigInt(A, u) : fromValue(A, u);
}, LongPrototype.toBigInt = function() {
  var A = BigInt(this.low >>> 0), u = BigInt(this.unsigned ? this.high >>> 0 : this.high);
  return u << BigInt(32) | A;
});
var classnames = { exports: {} };
var hasRequiredClassnames;
function requireClassnames() {
  return hasRequiredClassnames || (hasRequiredClassnames = 1, function(s) {
    (function() {
      var A = {}.hasOwnProperty;
      function u() {
        for (var l = "", m = 0; m < arguments.length; m++) {
          var b = arguments[m];
          b && (l = t(l, p(b)));
        }
        return l;
      }
      function p(l) {
        if (typeof l == "string" || typeof l == "number")
          return l;
        if (typeof l != "object")
          return "";
        if (Array.isArray(l))
          return u.apply(null, l);
        if (l.toString !== Object.prototype.toString && !l.toString.toString().includes("[native code]"))
          return l.toString();
        var m = "";
        for (var b in l)
          A.call(l, b) && l[b] && (m = t(m, b));
        return m;
      }
      function t(l, m) {
        return m ? l ? l + " " + m : l + m : l;
      }
      s.exports ? (u.default = u, s.exports = u) : window.classNames = u;
    })();
  }(classnames)), classnames.exports;
}
var classnamesExports = requireClassnames();
const cA = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports);
var ue = Object.defineProperty, fe = (s, A, u) => A in s ? ue(s, A, { enumerable: !0, configurable: !0, writable: !0, value: u }) : s[A] = u, iA = (s, A, u) => fe(s, typeof A != "symbol" ? A + "" : A, u);
const K = {};
let Le = 0;
function W(s, A) {
  const u = `atom${++Le}`, p = {
    toString() {
      return (K ? "production" : void 0) !== "production" && this.debugLabel ? u + ":" + this.debugLabel : u;
    }
  };
  return typeof s == "function" ? p.read = s : (p.init = s, p.read = We, p.write = ze), A && (p.write = A), p;
}
function We(s) {
  return s(this);
}
function ze(s, A, u) {
  return A(
    this,
    typeof u == "function" ? u(s(this)) : u
  );
}
const g2 = (s, A) => s.unstable_is ? s.unstable_is(A) : A === s, mA = (s) => "init" in s, yA = (s) => !!s.write, gA = /* @__PURE__ */ new WeakMap(), IA = (s) => {
  var A;
  return kA(s) && !((A = gA.get(s)) != null && A[1]);
}, Ke = (s, A) => {
  const u = gA.get(s);
  if (u)
    u[1] = !0, u[0].forEach((p) => p(A));
  else if ((K ? "production" : void 0) !== "production")
    throw new Error("[Bug] cancelable promise not found");
}, Ue = (s) => {
  if (gA.has(s))
    return;
  const A = [/* @__PURE__ */ new Set(), !1];
  gA.set(s, A);
  const u = () => {
    A[1] = !0;
  };
  s.then(u, u), s.onCancel = (p) => {
    A[0].add(p);
  };
}, kA = (s) => typeof (s == null ? void 0 : s.then) == "function", u2 = (s) => "v" in s || "e" in s, oA = (s) => {
  if ("e" in s)
    throw s.e;
  if ((K ? "production" : void 0) !== "production" && !("v" in s))
    throw new Error("[Bug] atom state is not initialized");
  return s.v;
}, F2 = (s, A, u) => {
  u.p.has(s) || (u.p.add(s), A.then(
    () => {
      u.p.delete(s);
    },
    () => {
      u.p.delete(s);
    }
  ));
}, f2 = (s, A, u, p, t) => {
  var l;
  if ((K ? "production" : void 0) !== "production" && p === A)
    throw new Error("[Bug] atom cannot depend on itself");
  u.d.set(p, t.n), IA(u.v) && F2(A, u.v, t), (l = t.m) == null || l.t.add(A), s && Xe(s, p, A);
}, j = () => [/* @__PURE__ */ new Map(), /* @__PURE__ */ new Map(), /* @__PURE__ */ new Set()], CA = (s, A, u) => {
  s[0].has(A) || s[0].set(A, /* @__PURE__ */ new Set()), s[1].set(A, u);
}, Xe = (s, A, u) => {
  const p = s[0].get(A);
  p && p.add(u);
}, Ge = (s, A) => s[0].get(A), w2 = (s, A) => {
  s[2].add(A);
}, Z = (s) => {
  for (; s[1].size || s[2].size; ) {
    s[0].clear();
    const A = new Set(s[1].values());
    s[1].clear();
    const u = new Set(s[2]);
    s[2].clear(), A.forEach((p) => {
      var t;
      return (t = p.m) == null ? void 0 : t.l.forEach((l) => l());
    }), u.forEach((p) => p());
  }
}, H2 = (s) => {
  let A;
  (K ? "production" : void 0) !== "production" && (A = /* @__PURE__ */ new Set());
  const u = (x, M, F) => {
    const le = "v" in M, ge = M.v, pe = IA(M.v) ? M.v : null;
    if (kA(F)) {
      Ue(F);
      for (const Ie of M.d.keys())
        F2(
          x,
          F,
          s(Ie, M)
        );
      M.v = F, delete M.e;
    } else
      M.v = F, delete M.e;
    (!le || !Object.is(ge, M.v)) && (++M.n, pe && Ke(pe, F));
  }, p = (x, M, F, le) => {
    var ge;
    if (u2(F) && (F.m && !(le != null && le.has(M)) || Array.from(F.d).every(
      ([Qe, xe]) => (
        // Recursively, read the atom state of the dependency, and
        // check if the atom epoch number is unchanged
        p(x, Qe, s(Qe, F), le).n === xe
      )
    )))
      return F;
    F.d.clear();
    let pe = !0;
    const Ie = (Qe) => {
      if (g2(M, Qe)) {
        const Ee = s(Qe, F);
        if (!u2(Ee))
          if (mA(Qe))
            u(Qe, Ee, Qe.init);
          else
            throw new Error("no atom init");
        return oA(Ee);
      }
      const xe = p(
        x,
        Qe,
        s(Qe, F),
        le
      );
      if (pe)
        f2(x, M, F, Qe, xe);
      else {
        const Ee = j();
        f2(Ee, M, F, Qe, xe), C(Ee, M, F), Z(Ee);
      }
      return oA(xe);
    };
    let be, Pe;
    const Te = {
      get signal() {
        return be || (be = new AbortController()), be.signal;
      },
      get setSelf() {
        return (K ? "production" : void 0) !== "production" && !yA(M) && console.warn("setSelf function cannot be used with read-only atom"), !Pe && yA(M) && (Pe = (...Qe) => {
          if ((K ? "production" : void 0) !== "production" && pe && console.warn("setSelf function cannot be called in sync"), !pe)
            return k(M, ...Qe);
        }), Pe;
      }
    };
    try {
      const Qe = M.read(Ie, Te);
      if (u(M, F, Qe), kA(Qe)) {
        (ge = Qe.onCancel) == null || ge.call(Qe, () => be == null ? void 0 : be.abort());
        const xe = () => {
          if (F.m) {
            const Ee = j();
            C(Ee, M, F), Z(Ee);
          }
        };
        Qe.then(xe, xe);
      }
      return F;
    } catch (Qe) {
      return delete F.v, F.e = Qe, ++F.n, F;
    } finally {
      pe = !1;
    }
  }, t = (x) => oA(p(void 0, x, s(x))), l = (x, M, F) => {
    var le, ge;
    const pe = /* @__PURE__ */ new Map();
    for (const Ie of ((le = F.m) == null ? void 0 : le.t) || [])
      pe.set(Ie, s(Ie, F));
    for (const Ie of F.p)
      pe.set(
        Ie,
        s(Ie, F)
      );
    return (ge = Ge(x, M)) == null || ge.forEach((Ie) => {
      pe.set(Ie, s(Ie, F));
    }), pe;
  }, m = (x, M, F) => {
    const le = [], ge = /* @__PURE__ */ new Set(), pe = (be, Pe) => {
      if (!ge.has(be)) {
        ge.add(be);
        for (const [Te, Qe] of l(x, be, Pe))
          be !== Te && pe(Te, Qe);
        le.push([be, Pe, Pe.n]);
      }
    };
    pe(M, F);
    const Ie = /* @__PURE__ */ new Set([M]);
    for (let be = le.length - 1; be >= 0; --be) {
      const [Pe, Te, Qe] = le[be];
      let xe = !1;
      for (const Ee of Te.d.keys())
        if (Ee !== Pe && Ie.has(Ee)) {
          xe = !0;
          break;
        }
      xe && (p(x, Pe, Te, ge), C(x, Pe, Te), Qe !== Te.n && (CA(x, Pe, Te), Ie.add(Pe))), ge.delete(Pe);
    }
  }, b = (x, M, F, ...le) => {
    const ge = (Ie) => oA(p(x, Ie, s(Ie, F))), pe = (Ie, ...be) => {
      const Pe = s(Ie, F);
      let Te;
      if (g2(M, Ie)) {
        if (!mA(Ie))
          throw new Error("atom not writable");
        const Qe = "v" in Pe, xe = Pe.v, Ee = be[0];
        u(Ie, Pe, Ee), C(x, Ie, Pe), (!Qe || !Object.is(xe, Pe.v)) && (CA(x, Ie, Pe), m(x, Ie, Pe));
      } else
        Te = b(x, Ie, Pe, ...be);
      return Z(x), Te;
    };
    return M.write(ge, pe, ...le);
  }, k = (x, ...M) => {
    const F = j(), le = b(F, x, s(x), ...M);
    return Z(F), le;
  }, C = (x, M, F) => {
    if (F.m && !IA(F.v)) {
      for (const le of F.d.keys())
        F.m.d.has(le) || (B(x, le, s(le, F)).t.add(M), F.m.d.add(le));
      for (const le of F.m.d || [])
        if (!F.d.has(le)) {
          F.m.d.delete(le);
          const ge = Q(x, le, s(le, F));
          ge == null || ge.t.delete(M);
        }
    }
  }, B = (x, M, F) => {
    if (!F.m) {
      p(x, M, F);
      for (const le of F.d.keys())
        B(x, le, s(le, F)).t.add(M);
      if (F.m = {
        l: /* @__PURE__ */ new Set(),
        d: new Set(F.d.keys()),
        t: /* @__PURE__ */ new Set()
      }, (K ? "production" : void 0) !== "production" && A.add(M), yA(M) && M.onMount) {
        const le = F.m, { onMount: ge } = M;
        w2(x, () => {
          const pe = ge(
            (...Ie) => b(x, M, F, ...Ie)
          );
          pe && (le.u = pe);
        });
      }
    }
    return F.m;
  }, Q = (x, M, F) => {
    if (F.m && !F.m.l.size && !Array.from(F.m.t).some(
      (le) => {
        var ge;
        return (ge = s(le, F).m) == null ? void 0 : ge.d.has(M);
      }
    )) {
      const le = F.m.u;
      le && w2(x, le), delete F.m, (K ? "production" : void 0) !== "production" && A.delete(M);
      for (const ge of F.d.keys()) {
        const pe = Q(x, ge, s(ge, F));
        pe == null || pe.t.delete(M);
      }
      return;
    }
    return F.m;
  }, P = {
    get: t,
    set: k,
    sub: (x, M) => {
      const F = j(), le = s(x), ge = B(F, x, le);
      Z(F);
      const pe = ge.l;
      return pe.add(M), () => {
        pe.delete(M);
        const Ie = j();
        Q(Ie, x, le), Z(Ie);
      };
    },
    unstable_derive: (x) => H2(...x(s))
  };
  return (K ? "production" : void 0) !== "production" && Object.assign(P, {
    // store dev methods (these are tentative and subject to change without notice)
    dev4_get_internal_weak_map: () => ({
      get: (x) => {
        const M = s(x);
        if (M.n !== 0)
          return M;
      }
    }),
    dev4_get_mounted_atoms: () => A,
    dev4_restore_atoms: (x) => {
      const M = j();
      for (const [F, le] of x)
        if (mA(F)) {
          const ge = s(F), pe = "v" in ge, Ie = ge.v;
          u(F, ge, le), C(M, F, ge), (!pe || !Object.is(Ie, ge.v)) && (CA(M, F, ge), m(M, F, ge));
        }
      Z(M);
    }
  }), P;
}, M2 = () => {
  const s = /* @__PURE__ */ new WeakMap();
  return H2((A) => {
    let u = s.get(A);
    return u || (u = { d: /* @__PURE__ */ new Map(), p: /* @__PURE__ */ new Set(), n: 0 }, s.set(A, u)), u;
  });
};
let nA;
const Ye = () => (nA || (nA = M2(), (K ? "production" : void 0) !== "production" && (globalThis.__JOTAI_DEFAULT_STORE__ || (globalThis.__JOTAI_DEFAULT_STORE__ = nA), globalThis.__JOTAI_DEFAULT_STORE__ !== nA && console.warn(
  "Detected multiple Jotai instances. It may cause unexpected behavior with the default store. https://github.com/pmndrs/jotai/discussions/2044"
))), nA), J2 = {}, Q2 = createContext(
  void 0
), T2 = (s) => useContext(Q2) || Ye(), Re = ({
  children: s,
  store: A
}) => {
  const u = useRef();
  return !A && !u.current && (u.current = M2()), createElement(
    Q2.Provider,
    {
      value: A || u.current
    },
    s
  );
}, L2 = (s) => typeof (s == null ? void 0 : s.then) == "function", Oe = (s) => {
  s.status = "pending", s.then(
    (A) => {
      s.status = "fulfilled", s.value = A;
    },
    (A) => {
      s.status = "rejected", s.reason = A;
    }
  );
}, Ze = De.use || ((s) => {
  if (s.status === "pending")
    throw s;
  if (s.status === "fulfilled")
    return s.value;
  throw s.status === "rejected" ? s.reason : (Oe(s), s);
}), vA = /* @__PURE__ */ new WeakMap(), Ve = (s) => {
  let A = vA.get(s);
  return A || (A = new Promise((u, p) => {
    let t = s;
    const l = (k) => (C) => {
      t === k && u(C);
    }, m = (k) => (C) => {
      t === k && p(C);
    }, b = (k) => {
      "onCancel" in k && typeof k.onCancel == "function" && k.onCancel((C) => {
        if ((J2 ? "production" : void 0) !== "production" && C === k)
          throw new Error("[Bug] p is not updated even after cancelation");
        L2(C) ? (vA.set(C, A), t = C, C.then(l(C), m(C)), b(C)) : u(C);
      });
    };
    s.then(l(s), m(s)), b(s);
  }), vA.set(s, A)), A;
};
function H(s, A) {
  const u = T2(), [[p, t, l], m] = useReducer(
    (k) => {
      const C = u.get(s);
      return Object.is(k[0], C) && k[1] === u && k[2] === s ? k : [C, u, s];
    },
    void 0,
    () => [u.get(s), u, s]
  );
  let b = p;
  if ((t !== u || l !== s) && (m(), b = u.get(s)), useEffect(() => {
    const k = u.sub(s, () => {
      m();
    });
    return m(), k;
  }, [u, s, void 0]), useDebugValue(b), L2(b)) {
    const k = Ve(b);
    return Ze(k);
  }
  return b;
}
function R(s, A) {
  const u = T2();
  return useCallback(
    (...p) => {
      if ((J2 ? "production" : void 0) !== "production" && !("write" in s))
        throw new Error("not writable atom");
      return u.set(s, ...p);
    },
    [u, s]
  );
}
function je(s, A) {
  return [
    H(s),
    // We do wrong type assertion here, which results in throwing an error.
    R(s)
  ];
}
var qe = Object.defineProperty, _e = (s, A, u) => A in s ? qe(s, A, { enumerable: !0, configurable: !0, writable: !0, value: u }) : s[A] = u, w = (s, A, u) => _e(s, typeof A != "symbol" ? A + "" : A, u), N;
(function(s) {
  s.MAINNET = "mainnet", s.TESTNET = "testnet", s.SIGNET = "signet";
})(N || (N = {}));
class W2 {
  constructor(A) {
    w(this, "chains"), w(this, "option"), this.chains = A.chains, this.option = A;
  }
  // If constructor or init throws an exception, the wallet will be considered not installed.
  // This method is used to handle asynchronous initialization
  init() {
    return Promise.resolve();
  }
}
function D(s) {
  return s != null && s.getWindow ? s.getWindow() : window;
}
let SA;
function $e(s) {
  SA = s;
}
let z2;
function At(s) {
  z2 = s;
}
const tA = (s) => {
  if (SA)
    return SA + "/";
  if (s === N.MAINNET)
    return "https://mempool.space/api/";
  if (s === N.TESTNET)
    return "https://mempool.space/testnet/api/";
  if (s === N.SIGNET)
    return "https://mempool.space/signet/api/";
};
function et(s) {
  const A = Object.keys(s);
  return A.length ? "?" + A.map((u) => encodeURIComponent(u) + "=" + (s[u] ? encodeURIComponent(s[u]) : "")).join("&") : "";
}
function tt(s, A) {
  return new URL(tA(s) + "address/" + A);
}
function h2(s) {
  return new URL(tA(s) + "tx");
}
function nt(s, A) {
  return new URL(tA(s) + "address/" + A + "/utxo");
}
function rt(s) {
  return new URL(tA(s) + "v1/fees/recommended");
}
function st(s) {
  return new URL(tA(s) + "blocks/tip/height");
}
async function it(s, A) {
  const u = await fetch(h2(s), {
    method: "POST",
    body: A
  });
  if (u.ok)
    return await u.text();
  try {
    const p = await u.text();
    alert(`Error: ${p} ${s} ${h2(s)}`);
    const t = p.split('"message":"')[1].split('"}')[0];
    throw p.includes("error") || p.includes("message") ? new Error(t) : new Error("Error broadcasting transaction. Please try again");
  } catch (p) {
    throw new Error((p == null ? void 0 : p.message) || p);
  }
}
async function ot(s, A) {
  const u = await fetch(tt(s, A));
  if (u.ok) {
    const p = await u.json();
    return p.chain_stats.funded_txo_sum - p.chain_stats.spent_txo_sum;
  } else {
    const p = await u.text();
    throw new Error(p);
  }
}
async function ct(s) {
  const A = await fetch(rt(s));
  if (A.ok)
    return await A.json();
  {
    const u = await A.text();
    throw new Error(u);
  }
}
async function at(s) {
  const A = await fetch(st(s)), u = await A.text();
  if (!A.ok)
    throw new Error(u);
  const p = Number(u);
  if (Number.isNaN(p))
    throw new Error("Invalid result returned");
  return p;
}
function dt(s, A) {
  return new URL(tA(s) + "v1/validate-address/" + A);
}
async function lt(s, A, u) {
  let p = null;
  try {
    p = await (await fetch(nt(s, A))).json();
  } catch (Q) {
    throw new Error((Q == null ? void 0 : Q.message) || Q);
  }
  const t = p.filter((Q) => Q.status.confirmed).sort((Q, P) => P.value - Q.value);
  let l = t;
  if (u) {
    for (var m = 0, b = 0; b < t.length && (m += t[b].value, !(m > u)); ++b)
      ;
    if (m < u)
      return [];
    l = t.slice(0, b + 1);
  }
  const k = await (await fetch(dt(s, A))).json(), { isvalid: C, scriptPubKey: B } = k;
  if (!C)
    throw new Error("Invalid address");
  return l.map((Q) => ({
    txid: Q.txid,
    vout: Q.vout,
    value: Q.value,
    scriptPubKey: B
  }));
}
async function gt(s) {
  const A = await fetch(`${z2 || "https://apps-prod.unyx.tech/api"}/openapi/bitcoin/inscriptions${et(s)}`);
  if (A.ok)
    return (await A.json()).result;
  {
    const u = await A.text();
    throw new Error(u);
  }
}
let p2 = !1;
function o2() {
  p2 || (p2 = !0, srcExports.initEccLib(me));
}
class J extends W2 {
  constructor(A, u) {
    var p, t, l, m, b, k;
    super(A), w(this, "bitcoinNetworkProvider"), this.bitcoinNetworkProvider = u, o2(), $e((l = (t = (p = this.chains) == null ? void 0 : p[0]) == null ? void 0 : t.backendUrls) == null ? void 0 : l.mempoolUrl), At((k = (b = (m = this.chains) == null ? void 0 : m[0]) == null ? void 0 : b.backendUrls) == null ? void 0 : k.inscriptionUrl);
  }
  /**
   * Gets the address of the connected wallet.
   * @returns A promise that resolves to the address of the connected wallet.
   */
  async getAddress() {
    const A = await this.bitcoinNetworkProvider.getAccounts() || [];
    if (!(A != null && A[0]))
      throw new Error("Wallet not connected");
    return A[0];
  }
  /**
   * Gets the public key of the connected wallet.
   * @returns A promise that resolves to the public key of the connected wallet.
   */
  async getPublicKeyHex() {
    return await this.bitcoinNetworkProvider.getPublicKey();
  }
  /**
   * Signs the given PSBT in hex format.
   * @param psbtHex - The hex string of the unsigned PSBT to sign.
   * @param options - Optional parameters for signing the PSBT.
   * @returns A promise that resolves to the hex string of the signed PSBT.
   */
  async signPsbt(A, u) {
    return await this.bitcoinNetworkProvider.signPsbt(A, u);
  }
  /**
   * Signs multiple PSBTs in hex format.
   * @param psbtsHexes - The hex strings of the unsigned PSBTs to sign.
   * @param options - Optional parameters for signing the PSBTs.
   * @returns A promise that resolves to an array of hex strings, each representing a signed PSBT.
   */
  async signPsbts(A, u) {
    return await this.bitcoinNetworkProvider.signPsbts(A, u);
  }
  /**
   * Gets the network of the current account.
   * @returns A promise that resolves to the network of the current account.
   */
  async getNetwork() {
    return (await this.bitcoinNetworkProvider.getNetwork()).replace("livenet", "mainnet");
  }
  /**
   * Signs a message using BIP-322 simple.
   * @param message - The message to sign.
   * @returns A promise that resolves to the signed message.
   */
  async signMessageBIP322(A) {
    return await this.signMessage(A, "bip322-simple");
  }
  async signMessage(A, u = "ecdsa") {
    return await this.bitcoinNetworkProvider.signMessage(A, u);
  }
  /**
   * Registers an event listener for the specified event.
   * At the moment, only the "accountChanged" event is supported.
   * @param eventName - The name of the event to listen for.
   * @param callBack - The callback function to be executed when the event occurs.
   */
  on(A, u) {
    var p, t;
    (t = (p = this.bitcoinNetworkProvider) == null ? void 0 : p.on) == null || t.call(p, A, u);
  }
  off(A, u) {
    var p, t;
    (t = (p = this.bitcoinNetworkProvider) == null ? void 0 : p.off) == null || t.call(p, A, u);
  }
  async switchNetwork(A) {
    await this.bitcoinNetworkProvider.switchNetwork(A);
  }
  async sendBitcoin(A, u) {
    return await this.bitcoinNetworkProvider.sendBitcoin(A, Number(u));
  }
  /**
   * Retrieves the inscriptions for the connected wallet.
   * @returns A promise that resolves to an array of inscriptions.
   */
  async getInscriptions(A, u) {
    return await gt({
      address: await this.getAddress(),
      // @ts-ignore
      networkType: (await this.getNetwork()).toUpperCase(),
      cursor: A,
      size: u
    });
  }
  /**
   * Retrieves the network fees.
   * @returns A promise that resolves to the network fees.
   */
  async getNetworkFees() {
    return await ct(await this.getNetwork());
  }
  /**
   * Pushes a transaction to the network.
   * @param txHex - The hexadecimal representation of the transaction.
   * @returns A promise that resolves to a string representing the transaction ID.
   */
  async pushTx(A) {
    return await it(await this.getNetwork(), A);
  }
  /**
   * Retrieves the unspent transaction outputs (UTXOs) for a given address and amount.
   *
   * If the amount is provided, it will return UTXOs that cover the specified amount.
   * If the amount is not provided, it will return all available UTXOs for the address.
   *
   * @param address - The address to retrieve UTXOs for.
   * @param amount - Optional amount of funds required.
   * @returns A promise that resolves to an array of UTXOs.
   */
  async getUtxos(A, u) {
    return await lt(await this.getNetwork(), A, u);
  }
  /**
   * Retrieves the tip height of the BTC chain.
   * @returns A promise that resolves to the block height.
   */
  async getBTCTipHeight() {
    return await at(await this.getNetwork());
  }
  /**
   * Gets the balance for the connected wallet address.
   * By default, this method will return the mempool balance if not implemented by the child class.
   * @returns A promise that resolves to the balance of the wallet.
   */
  async getBalance() {
    return await ot(await this.getNetwork(), await this.getAddress());
  }
}
const K2 = "data:image/svg+xml,%3csvg%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3crect%20width='28'%20height='28'%20fill='url(%23pattern0_260_7740)'/%3e%3cdefs%3e%3cpattern%20id='pattern0_260_7740'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image0_260_7740'%20transform='scale(0.0208333)'/%3e%3c/pattern%3e%3cimage%20id='image0_260_7740'%20width='48'%20height='48'%20xlink:href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAACsUlEQVRoBe1avY7aQBBeW0aAAOGKhsaRgAYQLigoED9PEOUJcm9CHiV5goQngOvo8LU05xRQ0MQIEP/yzUQyuvPv+m5t2TqvtAIv45lvvtn1aDxwxGYMBgPxer1+hykfDgf5eDyKuq5LNqKBLaVSKRVsaoVCQU2n03/O5/PjbDZTPQ32er1RpVL5VywWdRCOxMzlcnqtVtMRm6MDwLrUbrfnKBwV4GYcmUxGR4ydTkeyOII/QKgiC95wxnDijQMYmjiAN5zAXdLtdn+gExxundVq9bxYLPA6NqNarWrlcvkLf7vdBsvlMjbADaDr9Vq8XC4PPDyevu73e2M9Np+bzYbAY77F73Y7KTaoTUAhP8kCrImmddtLWZaJKLqLTqdT23vNi6x0nU4nkWCCAAOuEw46JEXvAcBc9aAdlroQO29m5yPXXhHyo5tWF1MH/ABkJZs4wIrJ9+pJIvBe5ljd9zkioGkaK8IIS10ICjOx51AUhQyHQ1c5BNbv98loNHKVG4/HVLrQJtWgycSgyDPDosxkMvFM1yhDq89LjnkmBoOhj89xiEOn1YfBJAI+yApENIlAILT6UEqVyFAfTRmIScproAyNLtryNCkpXzNOWwa+vsfpO62u5BA7MRjWehKBsJh2spNEwImZsNapIsCyDGSpC0kSeJ5X4VOC6ThoS0qaMpClLuxkklarNQfkzMq8MHXV6/U5D72xJ0fqI/5DPp//y0MYFOgJRxyqFR40+giQ/xsd+Fkqldi9+LHaCmQFGnwEu/f/lWPLMsoNbgD55oxir9hos97ZiWuj+54H4EB8azabCuyru1NR+4L7vtFoKIDV+TUhhgbfeEVpS+EfT/APKJZtAwxzdixj9x4b4NhD3m63Esdx2FSW7GSDWgObKux1LZvNKoIg4PwFZablYfMCcyEt0t7W+RoAAAAASUVORK5CYII='/%3e%3c/defs%3e%3c/svg%3e";
class ut extends J {
  constructor(A) {
    const u = D(A).okxwallet, p = u == null ? void 0 : u.bitcoin;
    if (!p)
      throw new Error("OKX Wallet extension not found");
    super(A, p), w(this, "okxWalletInfo"), w(this, "okxWallet"), w(this, "networkEnv", N.MAINNET), w(this, "getAddress", async () => await this.bitcoinNetworkProvider.getSelectedAddress()), w(this, "getNetwork", async () => {
      if (!this.networkEnv)
        throw new Error("Network not set");
      return this.networkEnv;
    }), w(this, "getPublicKeyHex", async () => {
      if (!this.okxWalletInfo)
        throw new Error("OKX Wallet not connected");
      return this.okxWalletInfo.publicKeyHex;
    }), w(this, "getBalance", async () => (await this.bitcoinNetworkProvider.getBalance()).confirmed), w(this, "pushTx", async (t) => await this.bitcoinNetworkProvider.pushTx(t)), this.okxWallet = u;
  }
  async connectWallet() {
    var A;
    try {
      await this.okxWallet.enable();
    } catch (l) {
      throw (A = l == null ? void 0 : l.message) != null && A.includes("rejected") ? new Error("Connection to OKX Wallet was rejected") : new Error(l == null ? void 0 : l.message);
    }
    let u = null;
    try {
      u = await this.bitcoinNetworkProvider.connect();
    } catch {
      throw new Error(`BTC ${this.networkEnv} is not enabled in OKX Wallet`);
    }
    const { address: p, compressedPublicKey: t } = u;
    if (t && p)
      return this.okxWalletInfo = {
        publicKeyHex: t,
        address: p
      }, this;
    throw new Error("Could not connect to OKX Wallet");
  }
  async switchNetwork(A) {
    switch (A) {
      case N.MAINNET:
        this.bitcoinNetworkProvider = this.okxWallet.bitcoin;
        break;
      case N.TESTNET:
        this.bitcoinNetworkProvider = this.okxWallet.bitcoinTestnet;
        break;
      case N.SIGNET:
        this.bitcoinNetworkProvider = this.okxWallet.bitcoinSignet;
        break;
      default:
        throw new Error("Unsupported network");
    }
    this.networkEnv = A, await this.connectWallet();
  }
  async sendBitcoin(A, u) {
    return await this.bitcoinNetworkProvider.sendBitcoin(
      A,
      // @ts-ignore
      BigInt(u)
    );
  }
  async getInscriptions(A, u) {
    return await this.bitcoinNetworkProvider.getInscriptions(A, u);
  }
  getWalletProviderIcon() {
    return Promise.resolve(xA.img);
  }
  getWalletProviderName() {
    return Promise.resolve(xA.name);
  }
}
const xA = {
  id: "bitcoin_okx",
  img: K2,
  name: "OKX",
  chainType: "bitcoin",
  connectProvider: ut,
  type: "extension"
}, U2 = "data:image/svg+xml,%3csvg%20width='42'%20height='42'%20viewBox='0%200%2042%2042'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_6_1029)'%3e%3cg%20clip-path='url(%23clip1_6_1029)'%3e%3cg%20clip-path='url(%23clip2_6_1029)'%3e%3cpath%20d='M28.0078%203.74221L36.5506%2012.201C37.2772%2012.9192%2037.6342%2013.6458%2037.6216%2014.3808C37.609%2015.1116%2037.2982%2015.7836%2036.685%2016.3884C36.0466%2017.0226%2035.3578%2017.346%2034.6186%2017.3586C33.8794%2017.3712%2033.1486%2017.0142%2032.4178%2016.296L23.6818%207.64401C22.6906%206.66121%2021.733%205.96401%2020.809%205.55661C19.8892%205.14921%2018.919%205.08621%2017.9026%205.36341C16.8862%205.64061%2015.7942%206.35881%2014.6266%207.51801C13.0138%209.11401%2012.2452%2010.6134%2012.325%2012.0162C12.4048%2013.419%2013.2028%2014.868%2014.7232%2016.3758L23.5306%2025.0992C24.2656%2025.8258%2024.6268%2026.5524%2024.6142%2027.2748C24.6016%2027.9972%2024.2866%2028.6692%2023.665%2029.2824C23.0434%2029.8956%2022.363%2030.219%2021.6154%2030.2442C20.872%2030.2694%2020.1328%2029.9166%2019.3978%2029.19L10.8634%2020.7312C9.4732%2019.3536%208.4694%2018.0516%207.852%2016.8252C7.2346%2015.5988%207.0036%2014.2086%207.1632%2012.6588C7.306%2011.3316%207.7344%2010.0464%208.44%208.79901C9.1498%207.55161%2010.162%206.27901%2011.4766%204.97281C13.0432%203.41881%2014.5384%202.23021%2015.9664%201.40281C17.3944%200.575413%2018.772%200.113413%2020.1034%200.0168127C21.4348%20-0.0797873%2022.7494%200.184813%2024.0514%200.810613C25.3492%201.43641%2026.668%202.41081%2028.012%203.74221H28.0078Z'%20fill='url(%23paint0_linear_6_1029)'/%3e%3cpath%20d='M14.6141%2037.8798L6.07132%2029.421C5.34472%2028.7028%204.98772%2027.9762%205.00032%2027.2412C5.01292%2026.5062%205.32372%2025.8384%205.93692%2025.2336C6.57532%2024.5994%207.26412%2024.276%208.00332%2024.2634C8.74252%2024.2508%209.47332%2024.6036%2010.2041%2025.326L18.9401%2033.978C19.9355%2034.9608%2020.8889%2035.658%2021.8129%2036.0654C22.7369%2036.4728%2023.7029%2036.5358%2024.7193%2036.2586C25.7357%2035.9814%2026.8277%2035.2632%2027.9953%2034.104C29.6081%2032.508%2030.3767%2031.0086%2030.2969%2029.6058C30.2171%2028.203%2029.4191%2026.7498%2027.8987%2025.2462L23.2073%2020.6388C22.4723%2019.9122%2022.1111%2019.1856%2022.1237%2018.4632C22.1363%2017.7408%2022.4513%2017.0688%2023.0729%2016.4556C23.6945%2015.8424%2024.3749%2015.519%2025.1225%2015.4938C25.8659%2015.4686%2026.6051%2015.8214%2027.3401%2016.548L31.7627%2020.8908C33.1529%2022.2684%2034.1567%2023.5704%2034.7741%2024.7968C35.3915%2026.0232%2035.6225%2027.4134%2035.4629%2028.9632C35.3201%2030.2904%2034.8917%2031.5756%2034.1861%2032.823C33.4763%2034.0704%2032.4641%2035.343%2031.1495%2036.6492C29.5829%2038.2032%2028.0877%2039.3918%2026.6597%2040.2192C25.2317%2041.0466%2023.8541%2041.5086%2022.5227%2041.6052C21.1913%2041.7018%2019.8767%2041.4372%2018.5747%2040.8114C17.2769%2040.1856%2015.9539%2039.2112%2014.6141%2037.8798Z'%20fill='url(%23paint1_linear_6_1029)'/%3e%3cpath%20d='M19.9401%2016.0524C21.6729%2016.0524%2023.0775%2014.6477%2023.0775%2012.915C23.0775%2011.1822%2021.6729%209.77759%2019.9401%209.77759C18.2074%209.77759%2016.8027%2011.1822%2016.8027%2012.915C16.8027%2014.6477%2018.2074%2016.0524%2019.9401%2016.0524Z'%20fill='url(%23paint2_radial_6_1029)'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_6_1029'%20x1='35.1508'%20y1='8.6366'%20x2='8.6783'%20y2='20.4003'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23070100'/%3e%3cstop%20offset='0.36'%20stop-color='%2377390D'/%3e%3cstop%20offset='0.67'%20stop-color='%23EA8101'/%3e%3cstop%20offset='1'%20stop-color='%23F4B852'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_6_1029'%20x1='8.20796'%20y1='33.2636'%20x2='38.8824'%20y2='24.1302'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23070100'/%3e%3cstop%20offset='0.37'%20stop-color='%2377390D'/%3e%3cstop%20offset='0.67'%20stop-color='%23EA8101'/%3e%3cstop%20offset='1'%20stop-color='%23F4FB52'/%3e%3c/linearGradient%3e%3cradialGradient%20id='paint2_radial_6_1029'%20cx='0'%20cy='0'%20r='1'%20gradientUnits='userSpaceOnUse'%20gradientTransform='translate(19.9359%2012.9192)%20scale(3.1374)'%3e%3cstop%20stop-color='%23F4B852'/%3e%3cstop%20offset='0.33'%20stop-color='%23EA8101'/%3e%3cstop%20offset='0.64'%20stop-color='%2377390D'/%3e%3cstop%20offset='1'%20stop-color='%23070100'/%3e%3c/radialGradient%3e%3cclipPath%20id='clip0_6_1029'%3e%3crect%20width='42'%20height='42'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip1_6_1029'%3e%3crect%20width='42'%20height='42'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip2_6_1029'%3e%3crect%20width='42'%20height='42'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
class ft extends J {
  constructor(A) {
    const u = D(A).unisat_wallet;
    if (!u)
      throw new Error("UniSat Wallet extension not found");
    super(A, u), w(this, "connectWallet", async () => {
      const p = this.bitcoinNetworkProvider;
      try {
        const t = await p.requestAccounts(), l = await p.getPublicKey();
        if (!t || !l)
          throw new Error("Could not connect to unisat wallet");
        return this;
      } catch {
        throw new Error("Failed to connect to unisat wallet");
      }
    }), w(this, "getBalance", async () => (await this.bitcoinNetworkProvider.getBalance()).confirmed), w(this, "pushTx", async (p) => await this.bitcoinNetworkProvider.pushTx(p)), w(this, "signPsbt", async (p, t) => {
      const l = {
        curNetwork: await this.getNetwork(),
        curAddress: await this.getAddress(),
        curPublicKey: await this.getPublicKeyHex()
      };
      if (!l.curAddress)
        throw new Error("Unisat Wallet not connected");
      if (!p)
        throw new Error("psbt hex is required");
      try {
        const m = {
          ...this.getSignPsbtDefaultOptions(p, l),
          ...t
        };
        return await this.bitcoinNetworkProvider.signPsbt(
          p,
          // @ts-ignore
          m
        );
      } catch (m) {
        throw new Error((m == null ? void 0 : m.message) || m);
      }
    }), w(this, "signPsbts", async (p, t) => {
      const l = {
        curNetwork: await this.getNetwork(),
        curAddress: await this.getAddress(),
        curPublicKey: await this.getPublicKeyHex()
      };
      if (!l.curAddress)
        throw new Error("Unisat Wallet not connected");
      if (!p && !Array.isArray(p))
        throw new Error("psbts hexes are required");
      try {
        const m = p.map((k) => this.getSignPsbtDefaultOptions(k, l)), b = t == null ? void 0 : t.map((k, C) => ({
          ...m[C],
          ...k
        }));
        return await this.bitcoinNetworkProvider.signPsbts(
          p,
          // @ts-ignore
          b
        );
      } catch (m) {
        throw new Error((m == null ? void 0 : m.message) || m);
      }
    });
  }
  async switchNetwork(A) {
    return await this.bitcoinNetworkProvider.switchNetwork(A.replace("mainnet", "livenet"));
  }
  async getNetwork() {
    return (await this.bitcoinNetworkProvider.getNetwork()).replace("livenet", "mainnet").replace("unknown", "signet");
  }
  async sendBitcoin(A, u) {
    return await this.bitcoinNetworkProvider.sendBitcoin(A, u);
  }
  getSignPsbtDefaultOptions(A, u) {
    const p = [], t = srcExports.Psbt.fromHex(A), { curNetwork: l, curPublicKey: m, curAddress: b } = u;
    return t.data.inputs.forEach((k, C) => {
      let B = !1;
      if (k.witnessUtxo && k.witnessUtxo.script) {
        let Q = srcExports.networks.bitcoin;
        (l === N.TESTNET || l === N.SIGNET) && (Q = srcExports.networks.testnet);
        let P;
        try {
          P = srcExports.address.fromOutputScript(k.witnessUtxo.script, Q);
        } catch (x) {
          if (x instanceof Error && x.message.toLowerCase().includes("has no matching address"))
            P = srcExports.address.fromOutputScript(k.witnessUtxo.script, Q);
          else
            throw new Error(x);
        }
        (P.indexOf("tb1p") === 0 || P.indexOf("bc1p") === 0) && P === b && (B = !0);
      }
      k.finalScriptSig || k.finalScriptWitness || p.push({
        index: C,
        publicKey: m,
        sighashTypes: void 0,
        useTweakedSigner: B
      });
    }), {
      autoFinalized: !0,
      toSignInputs: p
    };
  }
  async getInscriptions(A, u) {
    return await this.bitcoinNetworkProvider.getInscriptions(A, u);
  }
  getWalletProviderName() {
    return Promise.resolve(EA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(EA.img);
  }
}
const EA = {
  id: "bitcoin_unisat",
  img: U2,
  name: "Unisat",
  chainType: "bitcoin",
  connectProvider: ft,
  type: "extension"
}, X2 = "data:image/png;base64,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", wt = "tomo_btc";
class ht extends J {
  constructor(A) {
    const u = D(A)[wt];
    if (!u)
      throw new Error("Tomo Wallet extension not found");
    super(A, u), w(this, "connectWallet", async () => {
      const p = "1.2.0";
      if (!this.bitcoinNetworkProvider)
        throw new Error("Tomo Wallet extension not found");
      if (this.bitcoinNetworkProvider.getVersion && await this.bitcoinNetworkProvider.getVersion() < p)
        throw new Error("Please update Tomo Wallet to the latest version");
      let t = null, l = null;
      try {
        if (t = await this.bitcoinNetworkProvider.connectWallet(), l = await this.bitcoinNetworkProvider.getPublicKey(), !t || t.length === 0 || !l)
          throw new Error("BTC is not enabled in Tomo Wallet");
      } catch {
        throw new Error("BTC is not enabled in Tomo Wallet");
      }
      return this;
    }), w(this, "getBalance", async () => await this.bitcoinNetworkProvider.getBalance()), w(this, "pushTx", async (p) => await this.bitcoinNetworkProvider.pushTx(p));
  }
  getWalletProviderName() {
    return Promise.resolve(NA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(NA.img);
  }
}
const NA = {
  id: "bitcoin_tomo",
  img: X2,
  name: "Tomo",
  chainType: "bitcoin",
  connectProvider: ht,
  type: "extension"
}, G2 = "data:image/png;base64,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", pt = {
  [N.MAINNET]: "livenet",
  [N.TESTNET]: "testnet",
  [N.SIGNET]: "signet"
}, mt = "bitkeep";
class yt extends J {
  constructor(A) {
    var u;
    const p = (
      // @ts-ignore
      (u = D(A)[mt]) == null ? void 0 : u.unisat
    );
    if (!p)
      throw new Error("Bitget Wallet extension not found");
    super(A, p), w(this, "connectWallet", async () => {
      var t;
      try {
        await this.bitcoinNetworkProvider.requestAccounts();
      } catch (b) {
        throw (t = b == null ? void 0 : b.message) != null && t.includes("rejected") ? new Error("Connection to Bitget Wallet was rejected") : new Error(b == null ? void 0 : b.message);
      }
      const l = await this.getAddress(), m = await this.getPublicKeyHex();
      if (!l || !m)
        throw new Error("Could not connect to Bitget Wallet");
      return this;
    }), w(this, "signPsbt", async (t, l) => {
      const m = {
        method: "signPsbt",
        params: {
          // @ts-ignore
          from: this.bitcoinNetworkProvider.selectedAddress,
          __internalFunc: "__signPsbt_babylon",
          psbtHex: t,
          options: l || {
            autoFinalized: !0
          }
        }
      }, b = await this.bitcoinNetworkProvider.request("dappsSign", m), k = srcExports.Psbt.fromHex(b);
      return k.data.inputs.every((C) => C.finalScriptWitness || C.finalScriptSig) || k.finalizeAllInputs(), k.toHex();
    }), w(this, "signPsbts", async (t, l) => {
      if (!t && !Array.isArray(t))
        throw new Error("params error");
      const m = l || t.map((k) => ({
        autoFinalized: !0
      })), b = {
        method: "signPsbt",
        params: {
          // @ts-ignore
          from: this.bitcoinNetworkProvider.selectedAddress,
          __internalFunc: "__signPsbts_babylon",
          psbtHex: "_",
          psbtHexs: t,
          options: m
        }
      };
      try {
        let k = await this.bitcoinNetworkProvider.request("dappsSign", b);
        return k = k.split(","), k.map((C) => {
          const B = srcExports.Psbt.fromHex(C);
          return B.data.inputs.every((Q) => Q.finalScriptWitness || Q.finalScriptSig) || B.finalizeAllInputs(), B.toHex();
        });
      } catch (k) {
        throw new Error(k == null ? void 0 : k.message);
      }
    });
  }
  async switchNetwork(A) {
    return await this.bitcoinNetworkProvider.switchNetwork(pt[A]);
  }
  async getInscriptions(A, u) {
    var p, t;
    return await ((t = (p = this.bitcoinNetworkProvider) == null ? void 0 : p.getInscriptions) == null ? void 0 : t.call(p, A, u));
  }
  getWalletProviderName() {
    return Promise.resolve(DA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(DA.img);
  }
}
const DA = {
  id: "bitcoin_bitget",
  img: G2,
  name: "Bitget Wallet",
  chainType: "bitcoin",
  connectProvider: yt,
  type: "extension"
}, Y2 = "data:image/svg+xml,%3csvg%20width='128'%20height='128'%20viewBox='0%200%20128%20128'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_45922_88)'%3e%3cpath%20d='M127.61%2063.8049C127.61%20107.853%20107.853%20127.61%2063.8049%20127.61C19.7568%20127.61%200%20107.853%200%2063.8049C0%2019.7568%2019.7568%200%2063.8049%200C107.853%200%20127.61%2019.7568%20127.61%2063.8049Z'%20fill='%233BD23D'/%3e%3cpath%20d='M69.5699%2027.0557L51.8197%2027.0557L48.7056%2036.4719H58.5645L58.5645%2056.3063H69.5699V27.0557Z'%20fill='black'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M84.0486%2080.3111C84.0486%2091.4912%2074.9854%20100.554%2063.8053%20100.554C52.6253%20100.554%2043.5621%2091.4912%2043.5621%2080.3111C43.5621%2069.1311%2052.6253%2060.0678%2063.8053%2060.0678C74.9854%2060.0678%2084.0486%2069.1311%2084.0486%2080.3111ZM74.8584%2080.3111C74.8584%2086.4155%2069.9097%2091.3641%2063.8053%2091.3641C57.7008%2091.3641%2052.7522%2086.4155%2052.7522%2080.3111C52.7522%2074.2066%2057.7008%2069.258%2063.8053%2069.258C69.9097%2069.258%2074.8584%2074.2066%2074.8584%2080.3111Z'%20fill='black'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_45922_88'%3e%3crect%20width='128'%20height='128'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Ct = "$onekey", vt = {
  [N.MAINNET]: "livenet",
  [N.TESTNET]: "testnet",
  [N.SIGNET]: "signet"
};
class Bt extends J {
  constructor(A) {
    var u;
    const p = (u = D(A)[Ct]) == null ? void 0 : u.btcwallet;
    if (!p)
      throw new Error("OneKey Wallet extension not found");
    super(A, p), w(this, "getBalance", async () => await this.getNetwork() === N.MAINNET ? await this.bitcoinNetworkProvider.getBalance() : await super.getBalance()), w(this, "pushTx", async (t) => await this.bitcoinNetworkProvider.pushTx(t));
  }
  async connectWallet() {
    return await this.bitcoinNetworkProvider.connectWallet();
  }
  async switchNetwork(A) {
    return await this.bitcoinNetworkProvider.switchNetwork(vt[A]);
  }
  getWalletProviderName() {
    return Promise.resolve(FA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(FA.img);
  }
}
const FA = {
  id: "bitcoin_onekey",
  img: Y2,
  name: "OneKey",
  chainType: "bitcoin",
  connectProvider: Bt,
  type: "extension"
};
N.MAINNET;
const uA = (s) => {
  switch (s) {
    case N.MAINNET:
      return srcExports.networks.bitcoin;
    case N.TESTNET:
    case N.SIGNET:
      return srcExports.networks.testnet;
    default:
      throw new Error("Unsupported network");
  }
}, bt = "data:image/svg+xml,%3csvg%20width='513'%20height='512'%20viewBox='0%200%20513%20512'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_893_2592)'%3e%3cmask%20id='mask0_893_2592'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='0'%20y='0'%20width='513'%20height='512'%3e%3cpath%20d='M512.319%200H0.319336V512H512.319V0Z'%20fill='white'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_893_2592)'%3e%3cpath%20d='M256.319%20512C397.704%20512%20512.319%20397.385%20512.319%20256C512.319%20114.615%20397.704%200%20256.319%200C114.934%200%200.319336%20114.615%200.319336%20256C0.319336%20397.385%20114.934%20512%20256.319%20512Z'%20fill='url(%23paint0_linear_893_2592)'/%3e%3cpath%20d='M417.436%20158.291C428.084%20302.507%20335.382%20370.67%20252.277%20377.939C175.014%20384.696%20102.287%20337.221%2095.9067%20264.279C90.6436%20204.017%20127.889%20178.361%20157.152%20175.804C187.249%20173.165%20212.542%20193.921%20214.736%20219.052C216.849%20243.213%20201.773%20254.211%20191.288%20255.126C182.996%20255.853%20172.564%20250.819%20171.622%20240.01C170.814%20230.722%20174.341%20229.457%20173.479%20219.59C171.945%20202.024%20156.627%20199.978%20148.241%20200.705C138.092%20201.594%20119.678%20213.439%20122.262%20242.944C124.86%20272.705%20153.396%20296.221%20190.803%20292.95C231.171%20289.423%20259.276%20257.993%20261.39%20213.91C261.37%20211.575%20261.862%20209.264%20262.83%20207.139L262.843%20207.086C263.278%20206.162%20263.787%20205.275%20264.364%20204.434C265.226%20203.142%20266.33%20201.715%20267.756%20200.153C267.77%20200.113%20267.77%20200.113%20267.797%20200.113C268.833%20198.942%20270.085%20197.677%20271.498%20196.317C289.132%20179.68%20352.638%20140.443%20412.698%20152.867C413.968%20153.139%20415.115%20153.814%20415.969%20154.792C416.823%20155.77%20417.337%20156.997%20417.436%20158.291Z'%20fill='white'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_893_2592'%20x1='512.013'%20y1='86.519'%20x2='17.5951'%20y2='279.502'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%230CC5FF'/%3e%3cstop%20offset='1'%20stop-color='%23007FFF'/%3e%3c/linearGradient%3e%3cclipPath%20id='clip0_893_2592'%3e%3crect%20width='513'%20height='512'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Pt = "bitcoin";
class It extends J {
  constructor(A) {
    var u;
    const p = (u = D(A)) == null ? void 0 : u[Pt];
    if (!p)
      throw new Error("imToken Wallet not found");
    super(A, p), w(this, "walletInfo"), w(this, "connectWallet", async () => {
      const t = (await this.bitcoinNetworkProvider.request({
        method: "btc_requestAccounts"
      }))[0], l = await this.bitcoinNetworkProvider.request({
        method: "btc_getPublicKey"
      });
      if (!t || !l)
        throw new Error("Could not connect to imToken Wallet");
      return this.walletInfo = {
        publicKeyHex: l,
        address: t
      }, this;
    }), w(this, "getAddress", async () => (await this.bitcoinNetworkProvider.request({
      method: "btc_requestAccounts"
    }))[0]), w(this, "getPublicKeyHex", async () => {
      if (!this.walletInfo)
        throw new Error("imToken Wallet not connected");
      return this.walletInfo.publicKeyHex;
    }), w(this, "signPsbt", async (t, l) => await this.bitcoinNetworkProvider.request({
      method: "btc_signPsbt",
      params: [t, l]
    })), w(this, "signPsbts", async (t, l) => {
      if (!t && !Array.isArray(t))
        throw new Error("params error");
      return await this.bitcoinNetworkProvider.request({
        method: "btc_signPsbts",
        params: [t, l]
      });
    }), w(this, "getNetwork", async () => await this.bitcoinNetworkProvider.request({
      method: "btc_getNetwork",
      params: []
    })), w(this, "on", (t, l) => {
      var m, b, k, C;
      return t === "accountChanged" ? (b = (m = this.bitcoinNetworkProvider) == null ? void 0 : m.on) == null ? void 0 : b.call(m, "accountsChanged", l) : (C = (k = this.bitcoinNetworkProvider) == null ? void 0 : k.on) == null ? void 0 : C.call(k, t, l);
    }), w(this, "off", (t, l) => {
      var m, b, k, C;
      return t === "accountChanged" ? (b = (m = this.bitcoinNetworkProvider) == null ? void 0 : m.off) == null ? void 0 : b.call(m, "accountsChanged", l) : (C = (k = this.bitcoinNetworkProvider) == null ? void 0 : k.off) == null ? void 0 : C.call(k, t, l);
    }), w(this, "getBalance", async () => {
      var t;
      return await this.getNetwork() === N.MAINNET ? await this.bitcoinNetworkProvider.request({
        method: "btc_getBalance",
        params: [(t = this.walletInfo) == null ? void 0 : t.address]
      }) : await super.getBalance();
    });
  }
  async signMessage(A, u = "ecdsa") {
    return await this.bitcoinNetworkProvider.request({
      method: "btc_signMessage",
      params: [A, u]
    });
  }
  async sendBitcoin(A, u) {
    try {
      const p = await this.getAddress(), t = await this.getUtxos(p);
      t.sort((x, M) => x.value - M.value);
      let l = 0;
      const m = [], b = (await this.getNetworkFees()).fastestFee;
      let k = 0;
      for (const x of t)
        if (m.push({
          hash: x.txid,
          index: x.vout,
          witnessUtxo: {
            script: Buffer.from(x.scriptPubKey, "hex"),
            value: x.value
          }
        }), l += x.value, k = (m.length * 180 + 68 + 10) * b, l >= u + k)
          break;
      if (l < u + k)
        throw new Error("1Insufficient funds for the transaction.");
      if (m.length === 0)
        throw new Error("No inputs available for the transaction.");
      const C = l - u - k, B = new srcExports.Psbt({ network: uA(await this.getNetwork()) });
      for (const x of m)
        B.addInput(x);
      if (B.addOutput({
        address: A,
        value: u
      }), C > 0) {
        const x = await this.getAddress();
        B.addOutput({
          address: x,
          value: C
        });
      }
      const Q = await this.signPsbt(B.toHex()), P = srcExports.Psbt.fromHex(Q).extractTransaction();
      return await this.pushTx(P.toHex());
    } catch (p) {
      throw p;
    }
  }
  async switchNetwork(A) {
    throw new Error("Method not implemented.");
  }
  getWalletProviderName() {
    return Promise.resolve(HA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(HA.img);
  }
}
const HA = {
  id: "bitcoin_imtoken",
  img: bt,
  name: "imToken",
  chainType: "bitcoin",
  connectProvider: It,
  type: "injected"
};
class aA {
  /**
   * Compute the message hash as specified in the BIP-322.
   * The standard is specified in BIP-340 as:
   *      The function hashtag(x) where tag is a UTF-8 encoded tag name and x is a byte array returns the 32-byte hash SHA256(SHA256(tag) || SHA256(tag) || x).
   * @param message Message to be hashed
   * @returns Hashed message
   */
  static hashMessage(A) {
    const { sha256: u } = srcExports.crypto, p = u(this.TAG);
    return u(Buffer.concat([p, p, Buffer.from(A)]));
  }
  /**
   * Build a to_spend transaction using simple signature in accordance to the BIP-322.
   * @param message Message to be signed using BIP-322
   * @param scriptPublicKey The script public key for the signing wallet
   * @returns Bitcoin transaction that correspond to the to_spend transaction
   */
  static buildToSpendTx(A, u) {
    const p = new srcExports.Psbt();
    p.setVersion(0), p.setLocktime(0);
    const t = this.hashMessage(A), l = 0, m = 32, b = new Uint8Array([l, m]), k = new Uint8Array(b.length + t.length);
    return k.set(b), k.set(t, b.length), p.addInput({
      hash: "0".repeat(64),
      // vin[0].prevout.hash = 0000...000
      index: 4294967295,
      // vin[0].prevout.n = 0xFFFFFFFF
      sequence: 0,
      // vin[0].nSequence = 0
      finalScriptSig: Buffer.from(k),
      // vin[0].scriptSig = OP_0 PUSH32[ message_hash ]
      witnessScript: Buffer.from([])
      // vin[0].scriptWitness = []
    }), p.addOutput({
      value: 0,
      // vout[0].nValue = 0
      script: u
      // vout[0].scriptPubKey = message_challenge
    }), p.extractTransaction();
  }
  /**
   * Build a to_sign transaction using simple signature in accordance to the BIP-322.
   * @param toSpendTxId Transaction ID of the to_spend transaction as constructed by buildToSpendTx
   * @param witnessScript The script public key for the signing wallet, or the redeemScript for P2SH-P2WPKH address
   * @param isRedeemScript Set to true if the provided witnessScript is a redeemScript for P2SH-P2WPKH address, default to false
   * @param tapInternalKey Used to set the taproot internal public key of a taproot signing address when provided, default to undefined
   * @returns Ready-to-be-signed bitcoinjs.Psbt transaction
   */
  static buildToSignTx(A, u, p = !1, t) {
    const l = new srcExports.Psbt();
    return l.setVersion(0), l.setLocktime(0), l.addInput({
      hash: A,
      // vin[0].prevout.hash = to_spend.txid
      index: 0,
      // vin[0].prevout.n = 0
      sequence: 0,
      // vin[0].nSequence = 0
      witnessUtxo: {
        script: u,
        value: 0
      }
    }), p && l.updateInput(0, {
      redeemScript: u
    }), t && l.updateInput(0, {
      tapInternalKey: t
    }), l.addOutput({
      value: 0,
      // vout[0].nValue = 0
      script: Buffer.from([106])
      // vout[0].scriptPubKey = OP_RETURN
    }), l;
  }
  /**
   * Encode witness stack in a signed BIP-322 PSBT into its base-64 encoded format.
   * @param signedPsbt Signed PSBT
   * @returns Base-64 encoded witness data
   */
  static encodeWitness(A) {
    const u = A.data.inputs[0].finalScriptWitness;
    if (!u)
      throw new Error("Cannot encode empty witness stack.");
    return u.toString("base64");
  }
}
w(aA, "TAG", Buffer.from("BIP0322-signed-message"));
const R2 = "data:image/svg+xml,%3csvg%20width='160'%20height='160'%20viewBox='0%200%20160%20160'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M30%2025H90L50%20110H20L30%2025Z'%20fill='black'/%3e%3cpath%20d='M130%20135L70%20135L110%2050L140%2050L130%20135Z'%20fill='%23F5870A'/%3e%3c/svg%3e", m2 = _.default ? _.default : _;
var y2;
const kt = (y2 = q) != null && y2.default ? q.default : q;
class St extends J {
  constructor(A) {
    super(A, {}), w(this, "keystoneWaleltInfo"), w(this, "viewSDK"), w(this, "dataSdk"), w(this, "networkEnv"), w(this, "connectWallet", async () => {
      const u = await (await this.viewSDK.getSdk()).read([SupportedResult.UR_CRYPTO_ACCOUNT], {
        title: "Sync Keystone with Babylon Staking App",
        description: "Please scan the QR code displayed on your Keystone, Currently only the first Taproot Address will be used",
        renderInitial: {
          walletMode: "btc",
          link: "",
          description: [
            "1. Turn on your Keystone 3 with Multi-Coin firmware or BTC only firmware.",
            '2. Click "Connect Software Wallet" and choose "Babylon" or "Sparrow" for connection.',
            '3. Press the "Sync Keystone" button and scan the QR Code displayed on your Keystone hardware wallet',
            "4. The first Taproot address will be used for staking."
          ]
        },
        URTypeErrorMessage: "The scanned QR code is not the sync code from the Keystone hardware wallet. Please verify the code and try again."
      });
      if (u.status === ReadStatus.canceled)
        throw new Error("Connection to Keystone was canceled");
      if (u.status !== ReadStatus.success)
        throw new Error("Error reading QR code, Please try again.");
      const p = this.dataSdk.parseAccount(u.result), t = 3, l = p.keys[t].extendedPublicKey;
      if (this.keystoneWaleltInfo = {
        mfp: p.masterFingerprint,
        extendedPublicKey: l,
        path: p.keys[t].path,
        address: void 0,
        publicKeyHex: void 0,
        scriptPubKeyHex: void 0
      }, !this.keystoneWaleltInfo.extendedPublicKey)
        throw new Error("Could not retrieve the extended public key");
      const m = await this.getNetwork();
      return await this.switchNetwork(m), this;
    }), w(this, "getAddress", async () => {
      var u, p;
      if ((u = this.keystoneWaleltInfo) != null && u.address)
        return (p = this.keystoneWaleltInfo) == null ? void 0 : p.address;
      throw new Error("Could not retrieve the address");
    }), w(this, "getPublicKeyHex", async () => {
      var u, p;
      if ((u = this.keystoneWaleltInfo) != null && u.publicKeyHex)
        return (p = this.keystoneWaleltInfo) == null ? void 0 : p.publicKeyHex;
      throw new Error("Could not retrieve the BTC public key");
    }), w(this, "signPsbt", async (u, p) => {
      var t, l;
      if (!((t = this.keystoneWaleltInfo) != null && t.address) || !((l = this.keystoneWaleltInfo) != null && l.publicKeyHex))
        throw new Error("Keystone Wallet not connected");
      if (!u)
        throw new Error("psbt hex is required");
      let m = srcExports.Psbt.fromHex(u);
      m = this.enhancePsbt(m);
      const b = m.toHex();
      return (await this.sign(b)).toHex();
    }), w(this, "signPsbts", async (u, p) => {
      var t, l;
      if (!((t = this.keystoneWaleltInfo) != null && t.address) || !((l = this.keystoneWaleltInfo) != null && l.publicKeyHex))
        throw new Error("Keystone Wallet not connected");
      if (!u && !Array.isArray(u))
        throw new Error("psbts hexes are required");
      const m = [];
      for (const b of u) {
        const k = await this.signPsbt(b);
        m.push(k);
      }
      return m;
    }), w(this, "getNetwork", async () => {
      if (!this.networkEnv)
        throw new Error("Network not set");
      return this.networkEnv;
    }), w(this, "signMessageBIP322", async (u) => {
      const p = Buffer.from(this.keystoneWaleltInfo.scriptPubKeyHex, "hex"), t = aA.buildToSpendTx(u, p), l = bip371Exports.toXOnly(Buffer.from(this.keystoneWaleltInfo.publicKeyHex, "hex"));
      let m = aA.buildToSignTx(t.getId(), p, !1, l);
      m.updateInput(0, {
        sighashType: srcExports.Transaction.SIGHASH_ALL
      }), m = this.enhancePsbt(m);
      const b = await this.sign(m.toHex());
      return aA.encodeWitness(b);
    }), w(this, "signMessageECDSA", async (u) => {
      if (!this.keystoneWaleltInfo)
        throw new Error("Keystone Wallet not connected");
      const p = this.dataSdk.btc.generateSignRequest({
        requestId: "7afd5e09-9267-43fb-a02e-08c4a09417ec",
        signData: Buffer.from(u, "utf-8").toString("hex"),
        dataType: distExports.KeystoneBitcoinSDK.DataType.message,
        accounts: [
          {
            path: `${this.keystoneWaleltInfo.path}/0/0`,
            xfp: `${this.keystoneWaleltInfo.mfp}`,
            address: this.keystoneWaleltInfo.address
          }
        ],
        origin: "babylon staking app"
      }), t = C2(SupportedResult.UR_BTC_SIGNATURE), l = await this.viewSDK.getSdk(), m = await t(l, p), b = this.dataSdk.btc.parseSignature(m);
      return Buffer.from(b.signature, "hex").toString("base64");
    }), w(this, "sign", async (u) => {
      if (!u)
        throw new Error("psbt hex is required");
      const p = this.dataSdk.btc.generatePSBT(Buffer.from(u, "hex")), t = C2(SupportedResult.UR_PSBT), l = await this.viewSDK.getSdk(), m = await t(l, p), b = this.dataSdk.btc.parsePSBT(m), k = srcExports.Psbt.fromHex(b);
      return k.finalizeAllInputs(), k;
    }), w(this, "enhancePsbt", (u) => {
      var p, t, l, m;
      if (!((p = this.keystoneWaleltInfo) != null && p.scriptPubKeyHex) || !((t = this.keystoneWaleltInfo) != null && t.publicKeyHex) || !((l = this.keystoneWaleltInfo) != null && l.mfp) || !((m = this.keystoneWaleltInfo) != null && m.path))
        throw new Error("Keystone Wallet not connected");
      const b = {
        masterFingerprint: Buffer.from(this.keystoneWaleltInfo.mfp, "hex"),
        path: `${this.keystoneWaleltInfo.path}/0/0`,
        pubkey: Buffer.from(this.keystoneWaleltInfo.publicKeyHex, "hex")
      };
      return u.data.inputs.forEach((k) => {
        k.tapBip32Derivation = [
          {
            ...b,
            pubkey: bip371Exports.toXOnly(b.pubkey),
            leafHashes: Et(k, b.pubkey)
          }
        ];
      }), u;
    }), w(this, "on", () => {
    }), w(this, "off", () => {
    }), o2(), m2.bootstrap(), this.viewSDK = m2, this.dataSdk = new kt({
      origin: ""
    }), this.networkEnv = N.MAINNET, this.keystoneWaleltInfo = {};
  }
  async signMessage(A, u = "ecdsa") {
    if (u === "bip322-simple")
      return await this.signMessageBIP322(A);
    if (u === "ecdsa")
      return await this.signMessageECDSA(A);
    throw new Error("Unsupported message signing type");
  }
  async switchNetwork(A) {
    this.networkEnv = A;
    const { address: u, pubkeyHex: p, scriptPubKeyHex: t } = xt(
      // @ts-ignore
      this.keystoneWaleltInfo.extendedPublicKey,
      "M/0/0",
      uA(A)
    );
    this.keystoneWaleltInfo.address = u, this.keystoneWaleltInfo.publicKeyHex = p, this.keystoneWaleltInfo.scriptPubKeyHex = t;
  }
  async sendBitcoin(A, u) {
    const p = await this.getAddress(), t = await this.getUtxos(p);
    t.sort((x, M) => x.value - M.value);
    let l = 0;
    const m = [], b = (await this.getNetworkFees()).fastestFee;
    let k = 0;
    for (const x of t)
      if (m.push({
        hash: x.txid,
        index: x.vout,
        witnessUtxo: {
          script: Buffer.from(x.scriptPubKey, "hex"),
          value: x.value
        }
      }), l += x.value, k = (m.length * 180 + 68 + 10) * b, l >= u + k)
        break;
    if (l < u + k)
      throw new Error("1Insufficient funds for the transaction.");
    if (m.length === 0)
      throw new Error("No inputs available for the transaction.");
    const C = l - u - k, B = new srcExports.Psbt({ network: uA(await this.getNetwork()) });
    for (const x of m)
      B.addInput(x);
    if (B.addOutput({
      address: A,
      value: u
    }), C > 0) {
      const x = await this.getAddress();
      B.addOutput({
        address: x,
        value: C
      });
    }
    const Q = await this.signPsbt(B.toHex()), P = srcExports.Psbt.fromHex(Q).extractTransaction();
    return await this.pushTx(P.toHex());
  }
  getWalletProviderName() {
    return Promise.resolve(MA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(MA.img);
  }
}
const MA = {
  id: "bitcoin_keystone",
  img: R2,
  name: "Keystone",
  chainType: "bitcoin",
  connectProvider: St,
  type: "qrcode"
}, C2 = (s) => async (A, u) => {
  if (await A.play(u, {
    title: "Scan the QR Code",
    description: "Please scan the QR code with your Keystone device."
  }) !== PlayStatus.success)
    throw new Error("Could not generate the QR code, please try again.");
  const p = await A.read([s], {
    title: "Get the Signature from Keystone",
    description: "Please scan the QR code displayed on your Keystone",
    URTypeErrorMessage: "The scanned QR code can't be read. please verify and try again."
  });
  if (p.status !== ReadStatus.success)
    throw new Error("Could not extract the signature, please try again.");
  return p.result;
}, xt = (s, A, u) => {
  const p = HDKey.fromExtendedKey(s).derive(A), t = Buffer.from(p.publicKey), l = bip371Exports.toXOnly(t), { address: m, output: b } = srcExports.payments.p2tr({
    internalPubkey: l,
    network: u
  });
  return {
    address: m,
    pubkeyHex: t.toString("hex"),
    scriptPubKeyHex: b.toString("hex")
  };
}, Et = (s, A) => s.tapInternalKey && !s.tapLeafScript ? [] : (s.tapLeafScript || []).filter((u) => psbtutilsExports.pubkeyInScript(A, u.script)).map((u) => {
  const p = bip341Exports.tapleafHash({
    output: u.script,
    version: u.leafVersion
  });
  return Object.assign({ hash: p }, u);
}).map((u) => u.hash), Nt$1 = "data:image/webp;base64,UklGRmIEAABXRUJQVlA4TFUEAAAvL8ALABrJ2ravUzK6old2S8PWbj2p7tYjobtjujvAE/r/flPkev7md13U9ydGPovuticEkgCAZaTM2raND+zevN33eeyZ5yza8byhjFU4jCTbtBUF8PX2XONdnGd8q/8MJEmSMdXlZnbxirRZ9FbIQAMd7bVXPQYda+Y2ufDvyzB0qE74a1f/7WjWNkHHmb5ODvRpUz+3+P5ccqAvQkeZuUMO+Paor1t8BEbDGTsEHaQdvjzy7eJvji9iHDrC9A2ywadbvpz85cWH1SgEb8Yu2eDDJZ8O/nTwh5M/Y7E3ArGt2cxdgqC1BDenuNvZneFWj6k4wykeEkFwpm+S9IMb3+vkef8j/dnkBrAizUJQ2+Zgd4irjV0Z7cntSSbJwDnS188NYfAXBZ4dAKdvhBXvdrHb2G5jGyK2JdfHmVYGzkSRP+3JFRHHxx1it+Lt/J2QAQRaKVOQgUulOTj1ZqWrJFnZ6ok3JstmTJIkp9rqBgMkTyCwShwD0YQMnCrN3qFWC13innh9lIkiUSh1CkTi1FI83lfd7bcSRkC0GUAhAFHSOCKVVu/QK+cEwASXvk+RxFEQAfg/Cce2YCHjs3IQWWr6/LQYmJEKiytaHFkgEp8UQ+2QmeKjnLfSMf+SwG8jvT9Y+OiKZ3ZvSARm6W+16elduVlFISCmTELwYca74ilqCMa8c/IdTN+Dzu/MvDfSft0ZD0+KDogxIZb8Zpse1tdtaiizspg0Bn4ODzLuy/r6N73fZR4S+PKSQTq/mjgbCAs4ou5V0wERpU4BysxkVcxGsVDRSRBmPqu60cVFI+FFE+NflwxCH3XZoF8mVg2kCtgj9qpyK1kUs1FYJFf2k1c5ImajGPp12RBIPpK+C42XjazoSemzRfVxwXrvlJitWZW+PrMsZZ1W5L8e3E+b5b6+qNrLx7aBvk8c34XaSwaWrVF5VDAgHOWaisVmNMm8XdqJItc1TAT3MmbMwLPKTQdWgES+s6LH6UnJsEZQ2grPqoZLWSdW9CMwZyoHAYSHwYOc0aG0exYY2H+SPAko/LFGGS1hfJhXQLQNsEkEd9PKGkajiKVtxwWQ/LPNtv8bZdDiMBV6kFNAFA4zQ1Na7I0ilLQtywQFROoUsODXGKRXYydgDv29rOR6wp20nGGj0Atf0jEYpgDZCXDillSB1VCrxpZhCt3dtETmIDcISQ3t+UdCChQ8vge5ozVEq5BmGLW5kxaIt9MCuCGoiVZ4Ou8agUuEhzfgFaPW19/EbMjL3EsEIxEeWEeLI9VEKpFkaJj8yj1JRaTclTkXCE4i3L+GZkeoiFAg4YP5VldknyFYiXD3HJpsUhKSQ8ghbckRCcgRFIRaHDq+h+Alwj0raLQbBW5aYcPR12Q3x/bQERLh3lXwkePm37F9dIxEuGseDfZZjs8t8Bxab7TPR7bRURLhgQ002KdWfBxutE9su+NyZBeNzmGD2ZE5b2ChYyVCpF4KAgA=";
class Dt extends J {
  constructor(A) {
    var u, p;
    const t = (p = (u = D(A)) == null ? void 0 : u.binancew3w) == null ? void 0 : p.bitcoin;
    if (!t)
      throw new Error("Binance Wallet not found");
    super(A, t), w(this, "connectWallet", async () => {
      const l = (await this.bitcoinNetworkProvider.requestAccounts())[0], m = await this.getPublicKeyHex();
      if (!l || !m)
        throw new Error("Could not connect to imToken Wallet");
      return this;
    }), w(this, "signPsbts", async (l) => {
      throw new Error('Method "signPsbts" not implemented.');
    }), w(this, "on", (l, m) => {
      var b, k, C, B;
      return l === "accountChanged" ? (k = (b = this.bitcoinNetworkProvider) == null ? void 0 : b.on) == null ? void 0 : k.call(b, "accountsChanged", m) : (B = (C = this.bitcoinNetworkProvider) == null ? void 0 : C.on) == null ? void 0 : B.call(C, l, m);
    }), w(this, "off", (l, m) => {
      var b, k;
      return l === "accountChanged" ? (b = this.bitcoinNetworkProvider) == null ? void 0 : b.removeListener("accountsChanged", m) : (k = this.bitcoinNetworkProvider) == null ? void 0 : k.removeListener(l, m);
    }), w(this, "getBalance", async () => await this.bitcoinNetworkProvider.getBalance(await this.getAddress())), o2();
  }
  async sendBitcoin(A, u) {
    const p = await this.getAddress(), t = await this.getUtxos(p);
    t.sort((x, M) => x.value - M.value);
    let l = 0;
    const m = [], b = (await this.getNetworkFees()).fastestFee;
    let k = 0;
    for (const x of t)
      if (m.push({
        hash: x.txid,
        index: x.vout,
        witnessUtxo: {
          script: Buffer.from(x.scriptPubKey, "hex"),
          value: x.value
        }
      }), l += x.value, k = (m.length * 180 + 68 + 10) * b, l >= u + k)
        break;
    if (l < u + k)
      throw new Error("1Insufficient funds for the transaction.");
    if (m.length === 0)
      throw new Error("No inputs available for the transaction.");
    const C = l - u - k, B = new srcExports.Psbt({ network: uA(await this.getNetwork()) });
    for (const x of m)
      B.addInput(x);
    if (B.addOutput({
      address: A,
      value: u
    }), C > 0) {
      const x = await this.getAddress();
      B.addOutput({
        address: x,
        value: C
      });
    }
    const Q = await this.signPsbt(B.toHex()), P = srcExports.Psbt.fromHex(Q).extractTransaction();
    return await this.pushTx(P.toHex());
  }
  async switchNetwork(A) {
    await this.bitcoinNetworkProvider.switchNetwork(
      // @ts-ignore
      A.replace("mainnet", "livenet")
    );
  }
  getWalletProviderName() {
    return Promise.resolve(JA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(JA.img);
  }
}
const JA = {
  id: "bitcoin_binance",
  img: Nt$1,
  name: "Binance",
  chainType: "bitcoin",
  connectProvider: Dt,
  type: "injected"
}, Ft = "https://cosmoshub.validator.network:443";
class z extends W2 {
  constructor(A, u) {
    super(A), w(this, "provider"), w(this, "offlineSigner"), w(this, "clientPromise"), this.provider = u;
  }
  async connectWallet() {
    const A = await this.getNetwork();
    return await this.provider.enable(A), this.offlineSigner = this.provider.getOfflineSigner(A), await this.getAddress(), this;
  }
  initSigningStargateClient(A) {
    this.clientPromise = Promise.resolve(A);
  }
  /**
   * get @cosmjs/stargate SigningStargateClient
   */
  async getSigningStargateClient(A) {
    return this.clientPromise || (this.clientPromise = this.createSigningStargateClient(A)), await this.clientPromise;
  }
  async createSigningStargateClient(A) {
    var u, p, t;
    const l = ((t = (p = (u = this.chains) == null ? void 0 : u[0]) == null ? void 0 : p.backendUrls) == null ? void 0 : t.rpcUrl) || Ft;
    if (!this.offlineSigner)
      throw new Error("Offline signer is not initialized");
    return await SigningStargateClient.connectWithSigner(l, this.offlineSigner, A);
  }
  async getBalance(A) {
    const u = await this.getSigningStargateClient();
    return BigInt((await u.getBalance(await this.getAddress(), A)).amount);
  }
  /**
   * Gets the bech32Address of the connected wallet.
   * @returns A promise that resolves to the address of the connected wallet.
   */
  async getAddress() {
    const A = await this.getNetwork();
    return (await this.provider.getKey(A)).bech32Address;
  }
  /**
   * get the chainId of the connected wallet
   */
  async getNetwork() {
    var A, u;
    return (u = (A = this.chains) == null ? void 0 : A[0]) == null ? void 0 : u.network;
  }
  async signAmino(A, u, p) {
    const t = await this.getNetwork();
    if (t !== u.chain_id)
      throw new Error("Unmatched chain id with the offline signer");
    if (await this.getAddress() !== A)
      throw new Error("Unknown signer address");
    return await this.provider.signAmino(t, A, u, p);
  }
  async signArbitrary(A, u) {
    const p = await this.getNetwork();
    return await this.provider.signArbitrary(p, A, u);
  }
  async broadcastTx(A, u, p) {
    return await (await this.getSigningStargateClient()).broadcastTx(A, u, p);
  }
  async getPublicKeyHex() {
    const A = await this.getNetwork(), u = await this.provider.getKey(A);
    return Buffer$1.from(u.pubKey).toString("hex");
  }
  async getOfflineSigner() {
    const A = await this.getNetwork();
    return this.provider.getOfflineSigner(A);
  }
  /**
   * Registers an event listener for the specified event.
   * At the moment, only the "accountChanged" event is supported.
   * @param eventName - The name of the event to listen for.
   * @param callBack - The callback function to be executed when the event occurs.
   */
  on(A, u) {
  }
  /**
   * Unregisters an event listener for the specified event.
   * @param eventName - The name of the event to listen for.
   * @param callBack - The callback function to be executed when the event occurs.
   */
  off(A, u) {
  }
}
const O2 = "data:image/png;base64,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", Ht = "keplr";
class Mt extends z {
  constructor(A) {
    const u = D(A)[Ht];
    if (!u)
      throw new Error("Keplr Wallet extension not found");
    super(A, u);
  }
  async init() {
    const A = await buildExports$1.Keplr.getKeplr();
    if (!A)
      throw new Error("Keplr Wallet extension not found");
    this.provider = A;
  }
  getWalletProviderName() {
    return Promise.resolve(QA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(QA.img);
  }
  on(A, u) {
    A === "accountChanged" && window.addEventListener("keplr_keystorechange", u);
  }
  off(A, u) {
    A === "accountChanged" && window.removeEventListener("keplr_keystorechange", u);
  }
}
const QA = {
  id: "cosmos_keplr",
  img: O2,
  name: "Keplr",
  chainType: "cosmos",
  connectProvider: Mt,
  type: "extension"
};
class Jt extends z {
  constructor(A) {
    var u;
    const p = (u = D(A).okxwallet) == null ? void 0 : u.keplr;
    if (!p)
      throw new Error("OKX Wallet extension not found");
    super(A, p);
  }
  getWalletProviderName() {
    return Promise.resolve(TA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(TA.img);
  }
  on(A, u) {
    A === "accountChanged" && window.addEventListener("okx_keystorechange", u);
  }
  off(A, u) {
    A === "accountChanged" && window.removeEventListener("okx_keystorechange", u);
  }
}
const TA = {
  id: "cosmos_okx",
  img: K2,
  name: "OKX",
  chainType: "cosmos",
  connectProvider: Jt,
  type: "extension"
}, Z2 = "data:image/x-icon;base64,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";
class Qt extends z {
  constructor(A) {
    var u, p;
    const t = (p = (u = D(A).cosmostation) == null ? void 0 : u.providers) == null ? void 0 : p.keplr;
    if (!t)
      throw new Error("Cosmostation Wallet extension not found");
    super(A, t);
  }
  getWalletProviderName() {
    return Promise.resolve(LA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(LA.img);
  }
  on(A, u) {
    A === "accountChanged" && window.addEventListener("cosmostation_keystorechange", u);
  }
  off(A, u) {
    A === "accountChanged" && window.removeEventListener("cosmostation_keystorechange", u);
  }
}
const LA = {
  id: "cosmos_cosmostation",
  img: Z2,
  name: "Cosmostation",
  chainType: "cosmos",
  connectProvider: Qt,
  type: "extension"
}, V2 = "data:image/png;base64,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";
class Tt extends z {
  constructor(A) {
    const u = D(A).leap;
    if (!u)
      throw new Error("OKX Wallet extension not found");
    super(A, u);
  }
  getWalletProviderName() {
    return Promise.resolve(WA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(WA.img);
  }
  on(A, u) {
    A === "accountChanged" && window.addEventListener("leap_keystorechange", u);
  }
  off(A, u) {
    A === "accountChanged" && window.removeEventListener("leap_keystorechange", u);
  }
}
const WA = {
  id: "cosmos_leap",
  img: V2,
  name: "Leap",
  chainType: "cosmos",
  connectProvider: Tt,
  type: "extension"
};
class Lt extends z {
  constructor(A) {
    var u;
    const p = (u = D(A).$onekey) == null ? void 0 : u.cosmos;
    if (!p)
      throw new Error("OneKey Wallet extension not found");
    super(A, p);
  }
  getWalletProviderName() {
    return Promise.resolve(zA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(zA.img);
  }
  on(A, u) {
    A === "accountChanged" && window.addEventListener("keplr_keystorechange", u);
  }
  off(A, u) {
    A === "accountChanged" && window.removeEventListener("keplr_keystorechange", u);
  }
}
const zA = {
  id: "cosmos_onekey",
  img: Y2,
  name: "OneKey",
  chainType: "cosmos",
  connectProvider: Lt,
  type: "extension"
}, Wt = "data:image/svg+xml,%3csvg%20width='57'%20height='54'%20viewBox='0%200%2018%2017'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cmask%20id='mask0_2982_13847'%20maskUnits='userSpaceOnUse'%20x='0'%20y='0'%20width='18'%20height='17'%20style='mask-type:%20luminance;'%3e%3cpath%20d='M18%200H0V17H18V0Z'%20fill='white'%3e%3c/path%3e%3c/mask%3e%3cg%20mask='url(%23mask0_2982_13847)'%3e%3cpath%20d='M4.07466%205.38463C3.65195%206.2559%203.70642%207.22272%204.16617%207.79598C4.07015%207.05094%204.19885%206.29317%204.53441%205.62804C4.85575%204.95394%205.3666%204.39837%205.99864%204.03564H5.91802C5.20769%204.04247%204.47122%204.58616%204.07466%205.38463Z'%20fill='%23075CEE'%3e%3c/path%3e%3cpath%20d='M15.4461%209.60666C15.4701%208.54658%2015.0343%207.58886%2014.215%207.14754L13.6115%206.82451L9.68944%204.74984L8.15113%203.93317C7.6609%203.68664%207.10087%203.63723%206.57796%203.7944L4.33585%202.60693C3.33791%202.08144%202.02622%202.7002%201.40523%203.97184C0.784235%205.24349%201.08928%206.72669%202.07851%207.25218C2.09022%207.25958%202.10264%207.26567%202.11555%207.27038L4.32714%208.45331C4.51535%208.98189%204.88716%209.41716%205.36866%209.67263C5.37775%209.67657%205.38792%209.67657%205.39699%209.67263L11.4282%2012.8574C12.254%2013.2988%2013.252%2013.1008%2014.0429%2012.4434L14.86%2012.8756L16.2523%2010.0048L15.4352%209.59074L15.4461%209.60666Z'%20fill='%23075CEE'%3e%3c/path%3e%3cpath%20d='M2.49267%2012.1887L6.34935%2014.3316L3.89589%2016.9545C3.88034%2016.9745%203.85892%2016.9887%203.83493%2016.9949C3.81094%2017.001%203.78566%2016.9988%203.76298%2016.9886H3.75209L0.0653596%2015.014C0.0358593%2014.9971%200.0138623%2014.9689%200.00408632%2014.9353C-0.00568966%2014.9017%20-0.00246613%2014.8655%200.0130656%2014.8343C0.0185887%2014.823%200.0251569%2014.8124%200.0326759%2014.8025L2.49267%2012.1887ZM5.61288%208.87191C5.62844%208.85187%205.64983%208.83768%205.67384%208.83151C5.69783%208.82537%205.72311%208.82755%205.74579%208.83779H5.75669L9.44123%2010.7987C9.45644%2010.8064%209.46999%2010.8172%209.48106%2010.8306C9.4921%2010.8439%209.50045%2010.8595%209.50555%2010.8763C9.51065%2010.8931%209.51241%2010.9109%209.51071%2010.9284C9.50901%2010.946%209.50392%2010.963%209.4957%2010.9784L9.48045%2011.0035V11.0148L6.61954%2014.0654L2.75414%2011.9157L5.61288%208.87191ZM14.6902%2011.0103C15.0759%2010.2141%2015.7797%209.77958%2016.2699%2010.0366C16.7602%2010.2937%2016.8386%2011.149%2016.453%2011.943C16.0673%2012.7369%2015.3635%2013.1737%2014.8733%2012.9166C14.383%2012.6595%2014.3024%2011.7974%2014.6902%2011.0035V11.0103ZM5.91793%203.65794C6.14198%203.65435%206.36441%203.69846%206.5716%203.78761C6.39258%203.84141%206.21894%203.91302%206.05302%204.00145L5.99637%204.0333H5.91575C5.20542%204.0333%204.46895%204.58609%204.07239%205.38456C3.64968%206.25583%203.70415%207.22264%204.1639%207.79591C4.19667%208.01341%204.25071%208.22683%204.32514%208.43287C3.41653%207.86188%203.16596%206.45374%203.75862%205.21395C4.22709%204.24941%205.08994%203.65794%205.91793%203.65794ZM11.2584%203.07558L15.1129%205.23214L13.6117%206.82454L9.68962%204.74988L11.2584%203.07558ZM14.0976%200.0431891C14.1119%200.021571%2014.1328%200.00558169%2014.1569%20-0.00224709C14.181%20-0.0100758%2014.2069%20-0.00929676%2014.2305%20-3.31039e-05L17.9281%201.97682C17.9583%201.99296%2017.9815%202.02058%2017.9928%202.054C18.0042%202.08742%2018.0029%202.12411%2017.9891%202.15653C17.9836%202.16779%2017.977%202.17846%2017.9695%202.18838L15.3831%204.94324L11.5177%202.7935L14.0976%200.0431891Z'%20fill='%2388B2FB'%3e%3c/path%3e%3c/g%3e%3c/svg%3e";
class zt extends z {
  constructor(A) {
    var u;
    const p = (u = D(A).station) == null ? void 0 : u.keplr;
    if (!p)
      throw new Error("Station Wallet extension not found");
    super(A, p);
  }
  getWalletProviderName() {
    return Promise.resolve(KA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(KA.img);
  }
}
const KA = {
  id: "cosmos_station",
  img: Wt,
  name: "Station",
  chainType: "cosmos",
  connectProvider: zt,
  type: "extension"
}, j2 = "data:image/svg+xml,%3csvg%20width='44'%20height='44'%20viewBox='0%200%2044%2044'%20fill='%233173FA'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M22.01376%200c11.54538.00706%2021.00722%208.90338%2021.91609%2020.21383a.30206.30206%200%2001-.2706.32468l-.03146.00154h-1.25892c-.1564%200-.28503-.11886-.3005-.27117l-.00156-.03089v-1.66267c0-.06673-.04868-.12209-.11247-.13249l-.02178-.00176h-1.57004c-.06672%200-.12208.04869-.13249.11248l-.00175.02177V20.238c0%20.1564-.11886.28503-.27118.3005l-.03088.00156h-.91826c-.1564%200-.28504-.11886-.3005-.27117l-.00156-.03089v-1.66267c0-.06673-.04869-.12209-.11248-.13249l-.02177-.00176h-1.57071c-.06673%200-.12209.04869-.1325.11248l-.00175.02177V20.238c0%20.1564-.11886.28503-.27118.3005l-.03088.00156H30.1207c-.53353-.00063-1.00676-.3427-1.17468-.84912-.96357-2.8991-3.69184-4.99305-6.91146-5.00714-1.94706-.01596-3.8196.74761-5.2003%202.12056s-2.1548%203.24115-2.1498%205.18827c-.00404%204.04424%203.2733%207.32394%207.31654%207.32394%203.23103%200%205.97272-2.09428%206.942-4.99942.16138-.49215.60957-.8311%201.1231-.85575l.05527-.00143h13.50507a.30206.30206%200%2001.30206.3269C43.01897%2035.10132%2033.54874%2044%2022%2044%209.84982%2044%200%2034.14615%200%2022.00034%200%209.85453%209.86795-.00738%2022.01376%200z'%3e%3c/path%3e%3c/svg%3e";
class Kt extends J {
  constructor(A) {
    const u = D(A).cactuslink;
    if (!u)
      throw new Error("Cactus Link Wallet extension not found");
    super(A, u), w(this, "signPsbt", async (p, t) => await this.bitcoinNetworkProvider.signPsbt(p, t || {
      autoFinalized: !0
    })), w(this, "signPsbts", async (p, t) => {
      const l = t || p.map((m) => ({
        autoFinalized: !0
      }));
      return await this.bitcoinNetworkProvider.signPsbts(p, l);
    }), w(this, "on", (p, t) => {
      var l, m, b, k;
      return p === "accountChanged" ? (m = (l = this.bitcoinNetworkProvider) == null ? void 0 : l.on) == null ? void 0 : m.call(l, "accountsChanged", t) : (k = (b = this.bitcoinNetworkProvider) == null ? void 0 : b.on) == null ? void 0 : k.call(b, p, t);
    }), w(this, "off", (p, t) => {
      var l, m, b, k;
      return p === "accountChanged" ? (m = (l = this.bitcoinNetworkProvider) == null ? void 0 : l.off) == null ? void 0 : m.call(l, "accountsChanged", t) : (k = (b = this.bitcoinNetworkProvider) == null ? void 0 : b.off) == null ? void 0 : k.call(b, p, t);
    });
  }
  async connectWallet() {
    var A;
    await this.getNetwork();
    try {
      await this.bitcoinNetworkProvider.requestAccounts();
    } catch (t) {
      throw (A = t == null ? void 0 : t.message) != null && A.includes("rejected") ? new Error("Connection to Cactus Link Wallet was rejected") : new Error(t == null ? void 0 : t.message);
    }
    const u = await this.getAddress(), p = await this.getPublicKeyHex();
    if (!u || !p)
      throw new Error("Could not connect to Cactus Link Wallet");
    return this;
  }
  getWalletProviderName() {
    return Promise.resolve(UA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(UA.img);
  }
}
const UA = {
  id: "bitcoin_cactuslink",
  img: j2,
  name: "Cactus Link",
  chainType: "bitcoin",
  connectProvider: Kt,
  type: "extension"
}, Ut = "leapBitcoin";
class Xt extends J {
  constructor(A) {
    var u;
    const p = (u = D(A)) == null ? void 0 : u[Ut];
    if (!p)
      throw new Error("Leap Wallet extension not found");
    super(A, p), w(this, "connectWallet", async () => {
      const t = (await this.bitcoinNetworkProvider.requestAccounts())[0], l = await this.getPublicKeyHex();
      if (!t || !l)
        throw new Error("Could not connect to Leap Wallet");
      return this;
    });
  }
  getWalletProviderIcon() {
    return Promise.resolve(XA.img);
  }
  getWalletProviderName() {
    return Promise.resolve(XA.name);
  }
}
const XA = {
  id: "bitcoin_leap",
  img: V2,
  name: "Leap",
  chainType: "bitcoin",
  connectProvider: Xt,
  type: "extension"
};
class Gt extends J {
  constructor(A) {
    var u;
    const p = (u = D(A).cosmostation) == null ? void 0 : u.bitcoin;
    if (!p)
      throw new Error("Cosmostation Wallet extension not found");
    super(A, p), w(this, "connectWallet", async () => {
      if (!this.bitcoinNetworkProvider)
        throw new Error("Cosmostation Wallet extension not found");
      let t = null, l = null;
      try {
        if (t = await this.bitcoinNetworkProvider.connectWallet(), l = await this.bitcoinNetworkProvider.getPublicKey(), !t || t.length === 0 || !l)
          throw new Error("BTC is not enabled in Cosmostation Wallet");
        return this;
      } catch {
        throw new Error("BTC is not enabled in Cosmostation Wallet");
      }
    }), w(this, "getBalance", async () => await this.bitcoinNetworkProvider.getBalance()), w(this, "pushTx", async (t) => await this.bitcoinNetworkProvider.pushTx(t)), w(this, "getNetwork", async () => await this.bitcoinNetworkProvider.getNetwork());
  }
  async switchNetwork(A) {
    return await this.bitcoinNetworkProvider.switchNetwork(A);
  }
  async getPublicKeyHex() {
    return await this.bitcoinNetworkProvider.getPublicKey();
  }
  getWalletProviderName() {
    return Promise.resolve(GA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(GA.img);
  }
}
const GA = {
  id: "bitcoin_cosmostation",
  img: Z2,
  name: "Cosmostation",
  chainType: "bitcoin",
  connectProvider: Gt,
  type: "extension"
};
class Yt extends z {
  constructor(A) {
    var u;
    const p = (u = D(A).bitkeep) == null ? void 0 : u.keplr;
    if (!p)
      throw new Error("Bitget Wallet extension not found");
    super(A, p);
  }
  getWalletProviderName() {
    return Promise.resolve(YA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(YA.img);
  }
  on(A, u) {
    A === "accountChanged" && window.addEventListener("bitget_keystorechange", u);
  }
  off(A, u) {
    A === "accountChanged" && window.removeEventListener("bitget_keystorechange", u);
  }
}
const YA = {
  id: "cosmos_bitget",
  img: G2,
  name: "Bitget Wallet",
  chainType: "cosmos",
  connectProvider: Yt,
  type: "extension"
};
class Rt extends z {
  constructor(A) {
    var u, p;
    const t = (p = (u = D(A)) == null ? void 0 : u.unisat_wallet) == null ? void 0 : p.keplr;
    if (!t)
      throw new Error("UniSat Wallet extension not found");
    super(A, t);
  }
  getWalletProviderName() {
    return Promise.resolve(RA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(RA.img);
  }
  on(A, u) {
    var p, t;
    if (A === "accountChanged") {
      const l = (p = D(this.option)) == null ? void 0 : p.unisat;
      (t = l == null ? void 0 : l.on) == null || t.call(l, "accountsChanged", u);
    }
  }
  off(A, u) {
    var p, t;
    if (A === "accountChanged") {
      const l = (p = D(this.option)) == null ? void 0 : p.unisat;
      (t = l == null ? void 0 : l.on) == null || t.call(l, "accountsChanged", u);
    }
  }
}
const RA = {
  id: "cosmos_unisat",
  img: U2,
  name: "Unisat",
  chainType: "cosmos",
  connectProvider: Rt,
  type: "extension"
}, Ot = "data:image/png;base64,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";
class Zt extends J {
  constructor(A) {
    var u;
    const p = D(A), t = (u = p == null ? void 0 : p.XverseProviders) == null ? void 0 : u.BitcoinProvider;
    if (!t)
      throw new Error("Xverse Wallet extension not found");
    super(A, t), w(this, "getConnectionInfo", async () => {
      var l;
      const m = await this.request("getAddresses", {
        purposes: ["ordinals"]
      });
      if (!((l = m.addresses) != null && l.length))
        throw new Error("Failed to connect to Xverse Wallet");
      return m.addresses[0];
    }), w(this, "connectWallet", async () => {
      var l;
      try {
        if (!(await this.request("wallet_getCurrentPermissions")).length)
          throw new Error("No permissions found.");
        return this;
      } catch {
        const m = await this.request("wallet_connect");
        if (!((l = m.addresses) != null && l.length) || !m.addresses.some((b) => b.purpose === "ordinals"))
          throw new Error("Failed to connect to Xverse Wallet");
        return this;
      }
    }), w(this, "getBalance", async () => (await this.request("getBalance", void 0)).confirmed), w(this, "signPsbt", async (l, m) => {
      if (!l)
        throw new Error("psbt hex is required");
      const b = {
        curNetwork: await this.getNetwork(),
        curAddress: await this.getAddress(),
        curPublicKey: await this.getPublicKeyHex()
      };
      if (!b.curAddress)
        throw new Error("Wallet not connected");
      try {
        const { psbtBase64: k, toSignInputs: C } = this.getSignPsbtDefaultOptions(l, b), B = await this.request("signPsbt", {
          psbt: k,
          signInputs: C
        }), Q = srcExports.Psbt.fromBase64(B.psbt);
        return Q.finalizeAllInputs(), Q.toHex();
      } catch (k) {
        throw console.error("signPsbt error", k), k;
      }
    }), w(this, "signPsbts", async (l, m) => {
      if (!l && !Array.isArray(l))
        throw new Error("psbts hexes are required");
      const b = {
        curNetwork: await this.getNetwork(),
        curAddress: await this.getAddress(),
        curPublicKey: await this.getPublicKeyHex()
      };
      if (!b.curAddress)
        throw new Error("Unisat Wallet not connected");
      try {
        const k = l.map((C) => {
          const { psbtBase64: B, toSignInputs: Q } = this.getSignPsbtDefaultOptions(C, b);
          return {
            psbtBase64: B,
            signingIndexes: Q
            // sigHash: btc.SignatureHash.SINGLE
          };
        });
        return await this.bitcoinNetworkProvider.signMultipleTransactions(libExports.createUnsecuredToken({
          payload: {
            network: {
              type: b.curNetwork
            },
            message: "Sign Transaction",
            psbts: k
          }
        }));
      } catch (k) {
        throw console.error("signPsbts error", k), k;
      }
    });
  }
  // async requestAccounts() {
  //   await this.connectWallet()
  //   return await this.getAccounts()
  // }
  //
  // async getAccounts() {
  //   return [await this.getAddress()]
  // }
  // async getPublicKey() {
  //   return this.getPublicKeyHex()
  // }
  async request(A, u) {
    var p;
    const t = await this.bitcoinNetworkProvider.request(A, u || null);
    if (t.error)
      throw new Error((p = t.error) == null ? void 0 : p.message);
    if (t.result === void 0)
      throw new Error("Received unknown response from provider.");
    return t.result;
  }
  async getAddress() {
    return (await this.getConnectionInfo()).address;
  }
  async getPublicKeyHex() {
    const A = (await this.getConnectionInfo()).publicKey;
    return A.length === 64 ? "03" + A : A;
  }
  async switchNetwork(A) {
    throw new Error(`please use the Xverse wallet extension to switch networks: ${A}`);
  }
  async getNetwork() {
    const A = await this.getAddress();
    if (A.startsWith("bc1"))
      return N.MAINNET;
    if (A.startsWith("tb1"))
      return N.SIGNET;
    throw new Error("Unknown network");
  }
  async sendBitcoin(A, u) {
    const p = await this.request("sendTransfer", {
      recipients: [
        {
          address: A,
          amount: u
        }
      ]
    });
    return p == null ? void 0 : p.txid;
  }
  async signMessage(A, u = "ecdsa") {
    return (await this.request("signMessage", {
      address: await this.getAddress(),
      message: A,
      protocol: u === "bip322-simple" ? "BIP322" : "ECDSA"
    })).signature;
  }
  getSignPsbtDefaultOptions(A, u) {
    const p = srcExports.Psbt.fromHex(A), { curNetwork: t, curPublicKey: l, curAddress: m } = u, b = {
      [m]: []
    };
    return p.data.inputs.forEach((k, C) => {
      if (k.witnessUtxo && k.witnessUtxo.script) {
        let B = srcExports.networks.bitcoin;
        (t === N.TESTNET || t === N.SIGNET) && (B = srcExports.networks.testnet);
        let Q;
        try {
          Q = srcExports.address.fromOutputScript(k.witnessUtxo.script, B);
        } catch (P) {
          if (P instanceof Error && P.message.toLowerCase().includes("has no matching address"))
            Q = srcExports.address.fromOutputScript(k.witnessUtxo.script, B);
          else
            throw new Error(P);
        }
        Q.indexOf("tb1p") === 0 || Q.indexOf("bc1p");
      }
      k.finalScriptSig || k.finalScriptWitness || b[m].push(C);
    }), {
      psbtBase64: p.toBase64(),
      toSignInputs: b
    };
  }
  getWalletProviderName() {
    return Promise.resolve(OA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(OA.img);
  }
}
const OA = {
  id: "bitcoin_xverse",
  img: Ot,
  name: "Xverse",
  chainType: "bitcoin",
  connectProvider: Zt,
  type: "extension"
}, Vt = "bitcoin_keplr";
class jt extends J {
  constructor(A) {
    var u;
    const p = (u = D(A)) == null ? void 0 : u[Vt];
    if (!p)
      throw new Error("Keplr Wallet extension not found");
    super(A, p), w(this, "connectWallet", async () => {
      if (!this.bitcoinNetworkProvider)
        throw new Error("Keplr Wallet extension not found");
      let t = null, l = null;
      try {
        if (t = await this.bitcoinNetworkProvider.connectWallet(), l = await this.bitcoinNetworkProvider.getPublicKey(), !t || t.length === 0 || !l)
          throw new Error("BTC is not enabled in Keplr Wallet");
      } catch {
        throw new Error("BTC is not enabled in Keplr Wallet");
      }
      return this;
    }), w(this, "getBalance", async () => (await this.bitcoinNetworkProvider.getBalance()).confirmed), w(this, "pushTx", async (t) => await this.bitcoinNetworkProvider.pushTx(t));
  }
  async switchNetwork(A) {
    return await this.bitcoinNetworkProvider.switchNetwork(A.replace("mainnet", "livenet"));
  }
  async getNetwork() {
    return (await this.bitcoinNetworkProvider.getNetwork()).replace("livenet", "mainnet");
  }
  getWalletProviderName() {
    return Promise.resolve(ZA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(ZA.img);
  }
}
const ZA = {
  id: "bitcoin_keplr",
  img: O2,
  name: "Keplr",
  chainType: "bitcoin",
  connectProvider: jt,
  type: "extension"
};
var rA = {};
Object.defineProperty(rA, "__esModule", { value: !0 });
rA.bech32m = VA = rA.bech32 = void 0;
const fA = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", q2 = {};
for (let s = 0; s < fA.length; s++) {
  const A = fA.charAt(s);
  q2[A] = s;
}
function AA(s) {
  const A = s >> 25;
  return (s & 33554431) << 5 ^ -(A >> 0 & 1) & 996825010 ^ -(A >> 1 & 1) & 642813549 ^ -(A >> 2 & 1) & 513874426 ^ -(A >> 3 & 1) & 1027748829 ^ -(A >> 4 & 1) & 705979059;
}
function v2(s) {
  let A = 1;
  for (let u = 0; u < s.length; ++u) {
    const p = s.charCodeAt(u);
    if (p < 33 || p > 126)
      return "Invalid prefix (" + s + ")";
    A = AA(A) ^ p >> 5;
  }
  A = AA(A);
  for (let u = 0; u < s.length; ++u) {
    const p = s.charCodeAt(u);
    A = AA(A) ^ p & 31;
  }
  return A;
}
function c2(s, A, u, p) {
  let t = 0, l = 0;
  const m = (1 << u) - 1, b = [];
  for (let k = 0; k < s.length; ++k)
    for (t = t << A | s[k], l += A; l >= u; )
      l -= u, b.push(t >> l & m);
  if (p)
    l > 0 && b.push(t << u - l & m);
  else {
    if (l >= A)
      return "Excess padding";
    if (t << u - l & m)
      return "Non-zero padding";
  }
  return b;
}
function qt(s) {
  return c2(s, 8, 5, !0);
}
function _t(s) {
  const A = c2(s, 5, 8, !1);
  if (Array.isArray(A))
    return A;
}
function $t(s) {
  const A = c2(s, 5, 8, !1);
  if (Array.isArray(A))
    return A;
  throw new Error(A);
}
function _2(s) {
  let A;
  s === "bech32" ? A = 1 : A = 734539939;
  function u(m, b, k) {
    if (k = k || 90, m.length + 7 + b.length > k)
      throw new TypeError("Exceeds length limit");
    m = m.toLowerCase();
    let C = v2(m);
    if (typeof C == "string")
      throw new Error(C);
    let B = m + "1";
    for (let Q = 0; Q < b.length; ++Q) {
      const P = b[Q];
      if (P >> 5)
        throw new Error("Non 5-bit word");
      C = AA(C) ^ P, B += fA.charAt(P);
    }
    for (let Q = 0; Q < 6; ++Q)
      C = AA(C);
    C ^= A;
    for (let Q = 0; Q < 6; ++Q) {
      const P = C >> (5 - Q) * 5 & 31;
      B += fA.charAt(P);
    }
    return B;
  }
  function p(m, b) {
    if (b = b || 90, m.length < 8)
      return m + " too short";
    if (m.length > b)
      return "Exceeds length limit";
    const k = m.toLowerCase(), C = m.toUpperCase();
    if (m !== k && m !== C)
      return "Mixed-case string " + m;
    m = k;
    const B = m.lastIndexOf("1");
    if (B === -1)
      return "No separator character for " + m;
    if (B === 0)
      return "Missing prefix for " + m;
    const Q = m.slice(0, B), P = m.slice(B + 1);
    if (P.length < 6)
      return "Data too short";
    let x = v2(Q);
    if (typeof x == "string")
      return x;
    const M = [];
    for (let F = 0; F < P.length; ++F) {
      const le = P.charAt(F), ge = q2[le];
      if (ge === void 0)
        return "Unknown character " + le;
      x = AA(x) ^ ge, !(F + 6 >= P.length) && M.push(ge);
    }
    return x !== A ? "Invalid checksum for " + m : { prefix: Q, words: M };
  }
  function t(m, b) {
    const k = p(m, b);
    if (typeof k == "object")
      return k;
  }
  function l(m, b) {
    const k = p(m, b);
    if (typeof k == "object")
      return k;
    throw new Error(k);
  }
  return {
    decodeUnsafe: t,
    decode: l,
    encode: u,
    toWords: qt,
    fromWordsUnsafe: _t,
    fromWords: $t
  };
}
var VA = rA.bech32 = _2("bech32");
rA.bech32m = _2("bech32m");
const A0 = _.default ? _.default : _;
var B2;
const e0 = (B2 = q) != null && B2.default ? q.default : q;
class t0 {
  constructor(A) {
    w(this, "viewSDK"), w(this, "dataSdk"), w(this, "account"), w(this, "publicKey"), w(this, "chains"), w(this, "xfp"), this.chains = A, this.viewSDK = A0, this.dataSdk = new e0({
      origin: ""
    });
  }
  async enable(A) {
    const u = Array.isArray(A) ? A[0] : A;
    if (!this.chains.find((b) => b.network === u))
      throw new Error(`ChainId ${u} not found`);
    const p = await (await this.viewSDK.getSdk()).read([SupportedResult.UR_CRYPTO_MULTI_ACCOUNTS], {
      title: "Sync Keystone with Babylon Staking App",
      description: "Please scan the QR code displayed on your Keystone",
      renderInitial: {
        walletMode: "cosmos",
        link: "",
        description: [
          "1. Version M-9.0 (Multi-Coin) or newer running on your Keystone Essential or Pro. ",
          '2. Click connect software wallet and use "Keplr" for connection.',
          '3. Press the "Sync Keystone" button and scan the QR Code displayed on your Keystone hardware wallet'
        ]
      },
      URTypeErrorMessage: "The scanned QR code can't be read. please verify and try again."
    }), t = this.dataSdk.parseMultiAccounts(p.result), l = t.keys.find((b) => b.chain === "ATOM");
    if (!l)
      throw new Error("Keystone does not support the Cosmos network.");
    const m = Buffer.from(l.publicKey, "hex");
    this.account = l, this.publicKey = m, this.xfp = t.masterFingerprint;
  }
  async getKey(A) {
    var u, p;
    if (!this.publicKey)
      throw new Error("Keystone Wallet not connected");
    const t = this.chains.find((b) => b.network === A);
    if (!t)
      throw new Error(`ChainId ${A} not found`);
    const l = (p = (u = t.modularData) == null ? void 0 : u.bech32Config) == null ? void 0 : p.bech32PrefixAccAddr;
    if (!l)
      throw new Error("chain.modularData.Bech32Config not specified");
    const m = VA.encode(l, VA.toWords(this.getRipemd160()));
    return {
      name: "Keystone",
      algo: "secp256k1",
      address: this.getRipemd160(),
      pubKey: new Uint8Array(this.publicKey),
      bech32Address: m,
      isNanoLedger: !1,
      isKeystone: !0
    };
  }
  getRipemd160() {
    if (!this.publicKey)
      throw new Error("Keystone Wallet not connected");
    const A = buildExports.sha256(this.publicKey);
    return buildExports.ripemd160(A);
  }
  getOfflineSigner(A, u) {
    return {
      getAccounts: async () => [await this.getKey(A)].map((p) => ({
        address: p.bech32Address,
        pubkey: p.pubKey,
        algo: p.algo
      })),
      signAmino: this.signAmino.bind(this, A),
      signDirect: async (p, t) => {
        var l, m;
        if (!this.publicKey)
          throw new Error("Keystone Wallet not connected");
        const b = {
          ...t,
          accountNumber: t.accountNumber.toString()
        }, k = {
          requestId: "7AFD5E09-9267-43FB-A02E-08C4A09417EC",
          signData: Buffer.from(i0(b)).toString("hex"),
          dataType: distExports.KeystoneCosmosSDK.DataType.direct,
          accounts: [
            {
              path: (l = this.account) == null ? void 0 : l.path,
              xfp: this.xfp,
              address: (await this.getKey(A)).bech32Address
            }
          ]
        }, C = this.dataSdk.cosmos.generateSignRequest(k), B = b2(SupportedResult.UR_COSMOS_SIGNATURE), Q = await this.viewSDK.getSdk(), P = await B(Q, C), x = this.dataSdk.cosmos.parseSignature(P);
        if (x.publicKey !== ((m = this.publicKey) == null ? void 0 : m.toString("hex")))
          throw new Error("Public key mismatch");
        return {
          signed: {
            ...t,
            accountNumber: new Long(Number(t.accountNumber))
          },
          signature: P2(this.publicKey, Buffer.from(x.signature, "hex"))
        };
      }
    };
  }
  async signAmino(A, u, p, t) {
    var l;
    if (!this.publicKey)
      throw new Error("Keystone Wallet not connected");
    const m = Buffer.from(s0(p)).toString("hex"), b = this.dataSdk.cosmos.generateSignRequest({
      requestId: "7AFD5E09-9267-43FB-A02E-08C4A09417EC",
      signData: m,
      dataType: distExports.KeystoneCosmosSDK.DataType.amino,
      accounts: [
        {
          path: this.account.path,
          xfp: this.xfp,
          address: (await this.getKey(A)).bech32Address
        }
      ]
    }), k = b2(SupportedResult.UR_COSMOS_SIGNATURE), C = await this.viewSDK.getSdk(), B = await k(C, b), Q = this.dataSdk.cosmos.parseSignature(B);
    if (Q.publicKey !== ((l = this.publicKey) == null ? void 0 : l.toString("hex")))
      throw new Error("Public key mismatch");
    return {
      signed: p,
      signature: P2(this.publicKey, Buffer.from(Q.signature, "hex"))
    };
  }
  async signArbitrary(A, u, p) {
    throw new Error("signArbitrary not supported yet");
  }
  async sendTx(A, u, p) {
    throw new Error("sendTx not implemented");
  }
}
function jA(s) {
  if (typeof s != "object" || s === null)
    return s;
  if (Array.isArray(s))
    return s.map(jA);
  const A = Object.keys(s).sort(), u = {};
  return A.forEach((p) => {
    u[p] = jA(s[p]);
  }), u;
}
function n0(s) {
  return JSON.stringify(jA(s));
}
function r0(s) {
  return s.replace(/</g, "\\u003c").replace(/>/g, "\\u003e").replace(/&/g, "\\u0026");
}
function s0(s) {
  return Buffer.from(r0(n0(s)));
}
const b2 = (s) => async (A, u) => {
  if (await A.play(u, {
    title: "Scan the QR Code",
    description: "Please scan the QR code with your Keystone device."
  }) !== PlayStatus.success)
    throw new Error("Could not generate the QR code, please try again.");
  const p = await A.read([s], {
    title: "Get the Signature from Keystone",
    description: "Please scan the QR code displayed on your Keystone",
    URTypeErrorMessage: "The scanned QR code can't be read. please verify and try again."
  });
  if (p.status !== ReadStatus.success)
    throw new Error("Could not extract the signature, please try again.");
  return p.result;
};
function i0(s) {
  return "authInfoBytes" in s ? txExports.SignDoc.encode(s).finish() : txExports.SignDocDirectAux.encode(s).finish();
}
function P2(s, A) {
  if (A.length !== 64)
    throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
  return {
    pub_key: o0(s),
    signature: Buffer.from(A).toString("base64")
  };
}
function o0(s) {
  if (s.length !== 33 || s[0] !== 2 && s[0] !== 3)
    throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
  return {
    type: "tendermint/PubKeySecp256k1",
    value: Buffer.from(s).toString("base64")
  };
}
class c0 extends z {
  constructor(A) {
    const u = new t0(A.chains);
    super(A, u);
  }
  getWalletProviderName() {
    return Promise.resolve(qA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(qA.img);
  }
}
const qA = {
  id: "cosmos_keystone",
  img: R2,
  name: "Keystone",
  chainType: "cosmos",
  connectProvider: c0,
  type: "qrcode"
}, a0 = "tomo_cosmos";
class d0 extends z {
  constructor(A) {
    const u = D(A)[a0];
    if (!u)
      throw new Error("Tomo Wallet extension not found");
    super(A, u);
  }
  getWalletProviderName() {
    return Promise.resolve(_A.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(_A.img);
  }
  on(A, u) {
    var p, t;
    (t = (p = D(this.option).tomo_btc) == null ? void 0 : p.on) == null || t.call(p, A, u);
  }
  off(A, u) {
    var p, t;
    (t = (p = D(this.option).tomo_btc) == null ? void 0 : p.off) == null || t.call(p, A, u);
  }
}
const _A = {
  id: "cosmos_tomo",
  img: X2,
  name: "Tomo",
  chainType: "cosmos",
  connectProvider: d0,
  type: "extension"
};
class l0 extends z {
  constructor(A) {
    const u = D(A).cactuslink_cosmos;
    if (!u)
      throw new Error("CactusLink Wallet extension not found");
    super(A, u);
  }
  getWalletProviderName() {
    return Promise.resolve($A.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve($A.img);
  }
}
const $A = {
  id: "cosmos_cactuslink",
  img: j2,
  name: "Cactus Link",
  chainType: "cosmos",
  connectProvider: l0,
  type: "extension"
}, g0 = [
  xA,
  DA,
  EA,
  NA,
  FA,
  UA,
  HA,
  JA,
  MA,
  XA,
  GA,
  OA,
  ZA
], u0 = [
  QA,
  TA,
  YA,
  RA,
  _A,
  LA,
  WA,
  zA,
  KA,
  qA,
  $A
];
class f0 extends J {
  constructor(A) {
    var u;
    const p = (u = D(A)) == null ? void 0 : u.injectedTomo, t = p == null ? void 0 : p.bitcoin;
    if (!t)
      throw new Error("Injected Tomo Wallet not found");
    super(A, t), iA(this, "injectedTomo"), iA(this, "connectWallet", async () => {
      var l;
      const m = (await ((l = this.bitcoinNetworkProvider) == null ? void 0 : l.requestAccounts()))[0], b = await this.getPublicKeyHex();
      if (!m || !b)
        throw new Error("Could not connect to injected Wallet");
      return this;
    }), A2.img = p.info.logo, A2.name = p.info.name, this.injectedTomo = p;
  }
  getWalletProviderName() {
    var A, u;
    return Promise.resolve((u = (A = this.injectedTomo) == null ? void 0 : A.info) == null ? void 0 : u.name);
  }
  getWalletProviderIcon() {
    var A, u;
    return Promise.resolve((u = (A = this.injectedTomo) == null ? void 0 : A.info) == null ? void 0 : u.logo);
  }
}
class w0 extends z {
  constructor(A) {
    var u;
    const p = (u = D(A)) == null ? void 0 : u.injectedTomo, t = p == null ? void 0 : p.cosmos;
    if (!t)
      throw new Error("Injected Tomo Wallet not found");
    super(A, t), iA(this, "injectedTomo"), e2.img = p.info.logo, e2.name = p.info.name, this.injectedTomo = p;
  }
  getWalletProviderName() {
    var A, u;
    return Promise.resolve((u = (A = this.injectedTomo) == null ? void 0 : A.info) == null ? void 0 : u.name);
  }
  getWalletProviderIcon() {
    var A, u;
    return Promise.resolve((u = (A = this.injectedTomo) == null ? void 0 : A.info) == null ? void 0 : u.logo);
  }
}
const A2 = {
  id: "bitcoin_tomo_auto",
  img: "",
  name: "Tomo Injected",
  chainType: "bitcoin",
  connectProvider: f0,
  type: "injected"
}, e2 = {
  id: "cosmos_tomo_auto",
  img: "",
  name: "Tomo Injected",
  chainType: "cosmos",
  connectProvider: w0,
  type: "injected"
}, $2 = [
  A2,
  e2,
  ...g0,
  ...u0
], h0 = $2.reduce((s, A) => (s[A.id] = A, s), {}), Ae = $2.map((s) => s.id);
function t2(s, A) {
  var u;
  return ((u = A.additionalWallets) == null ? void 0 : u.find((p) => p.id === s)) || h0[s];
}
function ee(s) {
  let A = (s.indexWallets || []).map((u) => t2(u, s)).filter((u) => !!u);
  return (!s.indexWallets || s.indexWallets === Ae) && s.additionalWallets && (A = [
    ...A.filter((u) => {
      var p;
      return (p = s.additionalWallets) == null ? void 0 : p.every((t) => t.id !== u.id);
    }),
    ...s.additionalWallets
  ]), A;
}
const p0 = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Token'%3e%3cpath%20id='Network%20Icon%20Background'%20d='M16%2032C24.8366%2032%2032%2024.8366%2032%2016C32%207.16344%2024.8366%200%2016%200C7.16344%200%200%207.16344%200%2016C0%2024.8366%207.16344%2032%2016%2032Z'%20fill='%23F7931A'/%3e%3cpath%20id='Vector'%20d='M23.3198%2014.1189C23.6398%2012.1016%2022.0122%2011.0169%2019.7884%2010.2932L20.51%207.55978L18.7489%207.14593L18.0457%209.80711C17.583%209.69739%2017.1081%209.59537%2016.6342%209.49335L17.3425%206.81484L15.5814%206.40002L14.8599%209.13243C14.4767%209.04966%2014.0996%208.96882%2013.7347%208.88219L13.7368%208.87353L11.3071%208.30087L10.8383%2010.0776C10.8383%2010.0776%2012.1459%2010.3605%2012.1184%2010.3778C12.8318%2010.5463%2012.9602%2010.9919%2012.9388%2011.3461L12.1173%2014.4596C12.1663%2014.4712%2012.2295%2014.4885%2012.3008%2014.5145L12.1143%2014.4712L10.9627%2018.833C10.875%2019.037%2010.6539%2019.3441%2010.1545%2019.2276C10.1728%2019.2517%208.87443%2018.9264%208.87443%2018.9264L8%2020.8301L10.2931%2021.37C10.7191%2021.4711%2011.1369%2021.577%2011.5476%2021.6761L10.819%2024.4403L12.579%2024.8541L13.3006%2022.1208C13.7816%2022.243%2014.2484%2022.3566%2014.705%2022.4643L13.9854%2025.1862L15.7465%2025.6L16.4752%2022.8416C19.4796%2023.3787%2021.7381%2023.1621%2022.6889%2020.5962C23.4553%2018.5308%2022.6512%2017.3383%2021.0705%2016.5616C22.2222%2016.3114%2023.0884%2015.5963%2023.3198%2014.1189ZM19.2942%2019.449C18.751%2021.5154%2015.0667%2020.398%2013.8723%2020.1179L14.8405%2016.4557C16.0349%2016.7377%2019.8639%2017.295%2019.2942%2019.449ZM19.8394%2014.0891C19.3431%2015.9687%2016.2775%2015.013%2015.2838%2014.7792L16.1603%2011.4587C17.154%2011.6926%2020.3571%2012.1286%2019.8394%2014.0891Z'%20fill='white'/%3e%3c/g%3e%3c/svg%3e", m0 = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M20%2040C31.0457%2040%2040%2031.0457%2040%2020C40%208.9543%2031.0457%200%2020%200C8.9543%200%200%208.9543%200%2020C0%2031.0457%208.9543%2040%2020%2040Z'%20fill='%23AE219E'/%3e%3cpath%20d='M29.1497%2017.6486C29.5497%2015.127%2027.5153%2013.7711%2024.7356%2012.8664L25.6375%209.4497L23.4361%208.93238L22.5571%2012.2589C21.9788%2012.1217%2021.3851%2011.9942%2020.7927%2011.8667L21.6781%208.51852L19.4768%208L18.5748%2011.4155C18.0958%2011.312%2017.6245%2011.211%2017.1684%2011.1027L17.171%2011.0919L14.1339%2010.3761L13.5479%2012.5969C13.5479%2012.5969%2015.1824%2012.9506%2015.148%2012.9723C16.0397%2013.1828%2016.2002%2013.7398%2016.1735%2014.1826L15.1467%2018.0745C15.2078%2018.0889%2015.2868%2018.1106%2015.376%2018.1431L15.1429%2018.0889L13.7033%2023.5412C13.5938%2023.7963%2013.3173%2024.1801%2012.6931%2024.0345C12.716%2024.0646%2011.093%2023.6579%2011.093%2023.6579L10%2026.0376L12.8663%2026.7125C13.3988%2026.8388%2013.9212%2026.9712%2014.4346%2027.0951L13.5237%2030.5503L15.7238%2031.0676L16.6257%2027.6509C17.227%2027.8037%2017.8105%2027.9457%2018.3812%2028.0804L17.4818%2031.4827L19.6831%2032L20.594%2028.552C24.3496%2029.2233%2027.1726%2028.9526%2028.3612%2025.7453C29.3192%2023.1635%2028.314%2021.6729%2026.3382%2020.702C27.7777%2020.3892%2028.8605%2019.4953%2029.1497%2017.6486V17.6486ZM24.1177%2024.3112C23.4387%2026.8942%2018.8334%2025.4974%2017.3404%2025.1473L18.5506%2020.5697C20.0437%2020.9222%2024.8298%2021.6187%2024.1177%2024.3112ZM24.7993%2017.6113C24.1788%2019.9609%2020.3469%2018.7663%2019.1048%2018.4739L20.2004%2014.3233C21.4424%2014.6157%2025.4464%2015.1607%2024.7993%2017.6113Z'%20fill='white'/%3e%3c/svg%3e", y0 = "data:image/svg+xml,%3csvg%20width='1024'%20height='1024'%20viewBox='0%200%201024%201024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='512'%20cy='512'%20r='512'%20fill='url(%23paint0_radial)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M559.489%20834.999C575.149%20766.673%20586.037%20671.007%20588.667%20562.846L612.66%20563.429C610.005%20672.632%20599.01%20769.997%20582.883%20840.361C574.842%20875.446%20565.383%20904.46%20554.695%20924.986C549.359%20935.233%20543.415%20943.961%20536.702%20950.27C529.942%20956.624%20521.636%20961.2%20512%20961.2C500.94%20961.2%20491.681%20955.206%20484.372%20947.318C477.039%20939.402%20470.522%20928.41%20464.667%20915.38C452.92%20889.241%20442.683%20852.265%20434.371%20807.75L457.963%20803.345C466.127%20847.065%20475.94%20881.915%20486.558%20905.543C491.885%20917.397%20497.13%20925.774%20501.978%20931.006C506.851%20936.266%20510.194%20937.2%20512%20937.2C513.589%20937.2%20516.306%20936.503%20520.265%20932.783C524.27%20929.017%20528.739%20922.868%20533.408%20913.902C542.727%20896.005%20551.637%20869.259%20559.489%20834.999Z'%20fill='url(%23paint1_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M472.024%20159.599C457.662%20209.824%20446.256%20281.346%20440%20365.329L416.066%20363.546C422.388%20278.678%20433.97%20205.382%20448.949%20153.001C456.413%20126.9%20464.908%20105.31%20474.426%2089.9811C483.479%2075.4018%20495.808%2062.8003%20511.998%2062.8003C521.634%2062.8003%20529.94%2067.3757%20536.7%2073.7298C543.412%2080.0394%20549.357%2088.7673%20554.692%2099.0135C565.381%20119.54%20574.839%20148.554%20582.881%20183.639C599.008%20254.003%20610.003%20351.368%20612.657%20460.571L588.665%20461.154C586.035%20352.993%20575.147%20257.327%20559.487%20189.001C551.635%20154.741%20542.725%20127.995%20533.405%20110.098C528.737%20101.132%20524.268%2094.9826%20520.262%2091.2174C516.304%2087.4967%20513.586%2086.8003%20511.998%2086.8003C509.194%2086.8003%20503.102%2089.2971%20494.815%20102.642C486.994%20115.237%20479.231%20134.397%20472.024%20159.599Z'%20fill='url(%23paint2_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M440.002%20365.329C436.591%20411.12%20434.719%20460.503%20434.719%20512C434.719%20624.426%20443.64%20726.638%20457.963%20803.345L434.37%20807.75C419.716%20729.271%20410.719%20625.538%20410.719%20512C410.719%20459.931%20412.611%20409.952%20416.068%20363.546L440.002%20365.329Z'%20fill='url(%23paint3_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M428.801%20552.768C350.948%20505.24%20283.687%20457.047%20233.733%20414.458L218.162%20432.722C269.286%20476.307%20337.624%20525.225%20416.296%20573.252L428.801%20552.768Z'%20fill='url(%23paint4_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M767.494%20714.63C700.498%20694.032%20612.212%20655.633%20517.234%20603.835L505.743%20624.905C601.636%20677.202%20691.446%20716.357%20760.441%20737.57C794.843%20748.147%20824.697%20754.462%20847.816%20755.468C859.356%20755.97%20869.886%20755.186%20878.706%20752.527C887.588%20749.849%20895.703%20744.944%20900.521%20736.6C908.648%20722.523%20903.832%20705.465%20895.658%20690.267C887.059%20674.28%20872.482%20656.027%20853.448%20636.401C815.251%20597.014%20757.103%20550.07%20686.25%20501.935L672.763%20521.787C742.879%20569.422%20799.58%20615.329%20836.219%20653.109C854.604%20672.066%20867.443%20688.477%20874.521%20701.636C882.024%20715.585%20881.146%20722.158%20879.736%20724.6C878.942%20725.975%20876.98%20727.98%20871.779%20729.548C866.516%20731.135%20858.957%20731.93%20848.859%20731.491C828.702%20730.613%20801.087%20724.958%20767.494%20714.63Z'%20fill='url(%23paint5_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M550.142%20445.073C594.052%20470.424%20635.28%20496.323%20672.762%20521.787L686.249%20501.935C648.265%20476.13%20606.54%20449.922%20562.142%20424.288C457.09%20363.637%20356.566%20317.459%20278.943%20291.673C240.225%20278.812%20206.608%20270.82%20180.71%20268.863C167.793%20267.887%20156.102%20268.352%20146.399%20270.883C136.678%20273.419%20127.677%20278.403%20122.483%20287.4C116.91%20297.053%20117.522%20308.162%20120.767%20318.51C124.025%20328.902%20130.394%20340.143%20138.889%20351.844C155.934%20375.32%20183.256%20402.964%20218.161%20432.722L233.731%20414.459C199.44%20385.224%20173.744%20359%20158.31%20337.744C150.567%20327.079%20145.833%20318.237%20143.667%20311.33C141.488%20304.381%20142.358%20300.976%20143.267%20299.4C144.118%20297.927%20146.344%20295.701%20152.457%20294.106C158.588%20292.507%20167.34%20291.921%20178.901%20292.795C201.959%20294.537%20233.439%20301.847%20271.377%20314.45C347.064%20339.592%20446.084%20384.995%20550.142%20445.073Z'%20fill='url(%23paint6_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M520.48%20418.94C601.097%20375.105%20676.844%20340.946%20738.738%20319.198L730.782%20296.555C667.411%20318.822%20590.478%20353.561%20509.016%20397.855L520.48%20418.94Z'%20fill='url(%23paint7_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M208.476%20632.887C259.443%20585.405%20336.327%20528.414%20428.139%20472.245L415.614%20451.773C322.917%20508.484%20244.615%20566.418%20192.116%20615.326C165.939%20639.713%20145.692%20662.301%20133.359%20681.732C127.202%20691.432%20122.654%20700.906%20120.571%20709.841C118.473%20718.842%20118.68%20728.286%20123.48%20736.6C131.596%20750.657%20148.739%20755.021%20165.952%20755.552C184.057%20756.111%20207.098%20752.635%20233.547%20745.995C286.627%20732.669%20356.187%20705.881%20433.135%20668.71L422.696%20647.099C346.549%20683.883%20278.611%20709.937%20227.704%20722.717C202.16%20729.13%20181.585%20732.023%20166.692%20731.564C150.909%20731.077%20145.672%20727.037%20144.265%20724.6C143.473%20723.229%20142.72%20720.542%20143.945%20715.29C145.184%20709.973%20148.241%20703.07%20153.622%20694.593C164.363%20677.669%20182.919%20656.695%20208.476%20632.887Z'%20fill='url(%23paint8_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M551.138%20578.927C506.978%20604.423%20463.696%20627.293%20422.695%20647.099L433.135%20668.709C474.685%20648.638%20518.488%20625.491%20563.138%20599.711C668.19%20539.06%20758.443%20475.093%20819.586%20420.762C850.083%20393.662%20873.812%20368.545%20888.456%20347.094C895.76%20336.397%20901.203%20326.039%20903.862%20316.37C906.527%20306.684%20906.711%20296.397%20901.516%20287.4C896.007%20277.858%20886.239%20272.837%20875.802%20270.442C865.332%20268.039%20852.623%20267.871%20838.494%20269.285C810.15%20272.121%20773.234%20281.637%20730.78%20296.555L738.736%20319.197C780.427%20304.548%20815.286%20295.727%20840.884%20293.166C853.726%20291.881%20863.531%20292.25%20870.433%20293.834C877.369%20295.426%20879.832%20297.842%20880.732%20299.4C881.582%20300.873%20882.398%20303.914%20880.722%20310.005C879.041%20316.115%20875.173%20323.986%20868.635%20333.562C855.597%20352.659%20833.527%20376.267%20803.644%20402.821C744.026%20455.797%20655.196%20518.849%20551.138%20578.927Z'%20fill='url(%23paint9_linear)'/%3e%3ccircle%20cx='449.975'%20cy='804.495'%20r='31.3505'%20fill='white'/%3e%3ccircle%20r='31.3505'%20transform='matrix(0.5%20-0.866025%20-0.866025%20-0.5%20227.181%20419.466)'%20fill='white'/%3e%3ccircle%20r='31.3505'%20transform='matrix(0.5%200.866025%200.866025%20-0.5%20734.794%20312.039)'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M512.012%20457.433C542.156%20457.433%20566.592%20481.869%20566.592%20512.012C566.592%20542.156%20542.156%20566.592%20512.012%20566.592C481.869%20566.592%20457.433%20542.156%20457.433%20512.012C457.433%20481.869%20481.869%20457.433%20512.012%20457.433Z'%20fill='white'/%3e%3cdefs%3e%3cradialGradient%20id='paint0_radial'%20cx='0'%20cy='0'%20r='1'%20gradientUnits='userSpaceOnUse'%20gradientTransform='translate(512%20512)%20rotate(90)%20scale(512)'%3e%3cstop%20offset='0.0909055'%20stop-color='%237C7C7C'/%3e%3cstop%20offset='0.233848'%20stop-color='%233E3E3E'/%3e%3cstop%20offset='0.817221'/%3e%3c/radialGradient%3e%3clinearGradient%20id='paint1_linear'%20x1='523.515'%20y1='961.2'%20x2='639.469'%20y2='570.809'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.377307'%20stop-color='white'%20stop-opacity='0.6'/%3e%3cstop%20offset='0.992239'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint2_linear'%20x1='514.362'%20y1='62.8003'%20x2='663.926'%20y2='441'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.634963'%20stop-color='white'%20stop-opacity='0.81'/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint3_linear'%20x1='457.499'%20y1='363.546'%20x2='457.499'%20y2='808.261'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'%20stop-opacity='0.81'/%3e%3cstop%20offset='0.646422'%20stop-color='white'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint4_linear'%20x1='234.384'%20y1='411.354'%20x2='430.501'%20y2='549.696'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'%20stop-opacity='0.6'/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint5_linear'%20x1='923.391'%20y1='735.037'%20x2='488.534'%20y2='662.67'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.60731'%20stop-color='white'%20stop-opacity='0.81'/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint6_linear'%20x1='674.619'%20y1='497.805'%20x2='110.127'%20y2='288.499'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'%20stop-opacity='0.81'/%3e%3cstop%20offset='0.478389'%20stop-color='white'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint7_linear'%20x1='743.225'%20y1='320.878'%20x2='508.048'%20y2='430.154'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'%20stop-opacity='0.6'/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint8_linear'%20x1='110.421'%20y1='738.194'%20x2='404.819'%20y2='431.181'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.54518'%20stop-color='white'%20stop-opacity='0.81'/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint9_linear'%20x1='913.606'%20y1='276.28'%20x2='438.264'%20y2='671.645'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.518582'%20stop-color='white'/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0.81'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", C0 = {
  id: 1,
  name: "Bitcoin",
  network: "mainnet",
  type: "bitcoin",
  logo: p0
}, v0 = {
  id: 2,
  name: "Bitcoin Signet",
  type: "bitcoin",
  network: "signet",
  logo: m0
}, B0 = {
  id: 1,
  name: "Cosmos",
  type: "cosmos",
  network: "cosmoshub-4",
  logo: y0
}, b0 = [C0, v0], P0 = [B0];
typeof window < "u" && (window.Buffer = Buffer$1);
const a2 = [];
function I0(s, A) {
  if (typeof window > "u")
    return W(A);
  const u = localStorage.getItem(s), p = W(u === "undefined" || u === null ? A : JSON.parse(u));
  return W((t) => t(p), (t, l, m) => {
    let b = m;
    return typeof m == "function" && (b = m(t(p))), localStorage.setItem(s, JSON.stringify(b)), l(p, b), b;
  });
}
const te = [
  // 'evm',
  "bitcoin",
  "cosmos"
  // 'solana',
  // 'ton',
  // 'tron'
], ne = {
  isConnected: !1,
  bitcoin: {
    connected: !1,
    chainType: "bitcoin"
  },
  cosmos: {
    connected: !1,
    chainType: "cosmos"
  }
  // btcAddressType: 'P2TR'
}, U = I0("tomo_wallet_state", ne), O = W({
  state: 0
}), I2 = W(a2), d2 = W([]);
W((s) => s(d2).findLast((A) => A.type === "page"));
const k0 = {
  bitcoinChains: b0,
  cosmosChains: P0,
  // @ts-ignore
  chainTypes: te,
  socialTypes: [],
  indexWallets: Ae,
  onlySocial: !1,
  useServerSettings: !1
}, X = W(k0);
W(void 0);
const n2 = W({
  open: !1,
  chainType: "bitcoin"
}), re$2 = W(a2), se = W({
  theme: "light"
});
function Y(s, A) {
  const u = useMemo(
    () => W(null, (p, t, ...l) => s(p, t, ...l)),
    [s]
  );
  return R(u);
}
function S0(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
var r2 = { exports: {} };
(function(s, A) {
  Object.defineProperty(A, "__esModule", { value: !0 });
  function u(Qe) {
    return typeof Qe == "object" && !("toString" in Qe) ? Object.prototype.toString.call(Qe).slice(8, -1) : Qe;
  }
  var p = typeof process$1 == "object" && process$1.env.NODE_ENV === "production";
  function t(Qe, xe) {
    if (!Qe)
      throw p ? new Error("Invariant failed") : new Error(xe());
  }
  A.invariant = t;
  var l = Object.prototype.hasOwnProperty, m = Array.prototype.splice, b = Object.prototype.toString;
  function k(Qe) {
    return b.call(Qe).slice(8, -1);
  }
  var C = Object.assign || /* istanbul ignore next */
  function(Qe, xe) {
    return B(xe).forEach(function(Ee) {
      l.call(xe, Ee) && (Qe[Ee] = xe[Ee]);
    }), Qe;
  }, B = typeof Object.getOwnPropertySymbols == "function" ? function(Qe) {
    return Object.keys(Qe).concat(Object.getOwnPropertySymbols(Qe));
  } : function(Qe) {
    return Object.keys(Qe);
  };
  function Q(Qe) {
    return Array.isArray(Qe) ? C(Qe.constructor(Qe.length), Qe) : k(Qe) === "Map" ? new Map(Qe) : k(Qe) === "Set" ? new Set(Qe) : Qe && typeof Qe == "object" ? C(Object.create(Object.getPrototypeOf(Qe)), Qe) : Qe;
  }
  var P = (
    /** @class */
    function() {
      function Qe() {
        this.commands = C({}, x), this.update = this.update.bind(this), this.update.extend = this.extend = this.extend.bind(this), this.update.isEquals = function(xe, Ee) {
          return xe === Ee;
        }, this.update.newContext = function() {
          return new Qe().update;
        };
      }
      return Object.defineProperty(Qe.prototype, "isEquals", {
        get: function() {
          return this.update.isEquals;
        },
        set: function(xe) {
          this.update.isEquals = xe;
        },
        enumerable: !0,
        configurable: !0
      }), Qe.prototype.extend = function(xe, Ee) {
        this.commands[xe] = Ee;
      }, Qe.prototype.update = function(xe, Ee) {
        var He = this, ve = typeof Ee == "function" ? { $apply: Ee } : Ee;
        Array.isArray(xe) && Array.isArray(ve) || t(!Array.isArray(ve), function() {
          return "update(): You provided an invalid spec to update(). The spec may not contain an array except as the value of $set, $push, $unshift, $splice or any custom command allowing an array value.";
        }), t(typeof ve == "object" && ve !== null, function() {
          return "update(): You provided an invalid spec to update(). The spec and every included key path must be plain objects containing one of the " + ("following commands: " + Object.keys(He.commands).join(", ") + ".");
        });
        var we = xe;
        return B(ve).forEach(function(Ce) {
          if (l.call(He.commands, Ce)) {
            var Se = xe === we;
            we = He.commands[Ce](ve[Ce], we, ve, xe), Se && He.isEquals(we, xe) && (we = xe);
          } else {
            var Ne = k(xe) === "Map" ? He.update(xe.get(Ce), ve[Ce]) : He.update(xe[Ce], ve[Ce]), rr = k(we) === "Map" ? we.get(Ce) : we[Ce];
            (!He.isEquals(Ne, rr) || typeof Ne > "u" && !l.call(xe, Ce)) && (we === xe && (we = Q(xe)), k(we) === "Map" ? we.set(Ce, Ne) : we[Ce] = Ne);
          }
        }), we;
      }, Qe;
    }()
  );
  A.Context = P;
  var x = {
    $push: function(Qe, xe, Ee) {
      return F(xe, Ee, "$push"), Qe.length ? xe.concat(Qe) : xe;
    },
    $unshift: function(Qe, xe, Ee) {
      return F(xe, Ee, "$unshift"), Qe.length ? Qe.concat(xe) : xe;
    },
    $splice: function(Qe, xe, Ee, He) {
      return ge(xe, Ee), Qe.forEach(function(ve) {
        pe(ve), xe === He && ve.length && (xe = Q(He)), m.apply(xe, ve);
      }), xe;
    },
    $set: function(Qe, xe, Ee) {
      return be(Ee), Qe;
    },
    $toggle: function(Qe, xe) {
      le(Qe, "$toggle");
      var Ee = Qe.length ? Q(xe) : xe;
      return Qe.forEach(function(He) {
        Ee[He] = !xe[He];
      }), Ee;
    },
    $unset: function(Qe, xe, Ee, He) {
      return le(Qe, "$unset"), Qe.forEach(function(ve) {
        Object.hasOwnProperty.call(xe, ve) && (xe === He && (xe = Q(He)), delete xe[ve]);
      }), xe;
    },
    $add: function(Qe, xe, Ee, He) {
      return Te(xe, "$add"), le(Qe, "$add"), k(xe) === "Map" ? Qe.forEach(function(ve) {
        var we = ve[0], Ce = ve[1];
        xe === He && xe.get(we) !== Ce && (xe = Q(He)), xe.set(we, Ce);
      }) : Qe.forEach(function(ve) {
        xe === He && !xe.has(ve) && (xe = Q(He)), xe.add(ve);
      }), xe;
    },
    $remove: function(Qe, xe, Ee, He) {
      return Te(xe, "$remove"), le(Qe, "$remove"), Qe.forEach(function(ve) {
        xe === He && xe.has(ve) && (xe = Q(He)), xe.delete(ve);
      }), xe;
    },
    $merge: function(Qe, xe, Ee, He) {
      return Pe(xe, Qe), B(Qe).forEach(function(ve) {
        Qe[ve] !== xe[ve] && (xe === He && (xe = Q(He)), xe[ve] = Qe[ve]);
      }), xe;
    },
    $apply: function(Qe, xe) {
      return Ie(Qe), Qe(xe);
    }
  }, M = new P();
  A.isEquals = M.update.isEquals, A.extend = M.extend, A.default = M.update, A.default.default = s.exports = C(A.default, A);
  function F(Qe, xe, Ee) {
    t(Array.isArray(Qe), function() {
      return "update(): expected target of " + u(Ee) + " to be an array; got " + u(Qe) + ".";
    }), le(xe[Ee], Ee);
  }
  function le(Qe, xe) {
    t(Array.isArray(Qe), function() {
      return "update(): expected spec of " + u(xe) + " to be an array; got " + u(Qe) + ". Did you forget to wrap your parameter in an array?";
    });
  }
  function ge(Qe, xe) {
    t(Array.isArray(Qe), function() {
      return "Expected $splice target to be an array; got " + u(Qe);
    }), pe(xe.$splice);
  }
  function pe(Qe) {
    t(Array.isArray(Qe), function() {
      return "update(): expected spec of $splice to be an array of arrays; got " + u(Qe) + ". Did you forget to wrap your parameters in an array?";
    });
  }
  function Ie(Qe) {
    t(typeof Qe == "function", function() {
      return "update(): expected spec of $apply to be a function; got " + u(Qe) + ".";
    });
  }
  function be(Qe) {
    t(Object.keys(Qe).length === 1, function() {
      return "Cannot have more than one key in an object with $set";
    });
  }
  function Pe(Qe, xe) {
    t(xe && typeof xe == "object", function() {
      return "update(): $merge expects a spec of type 'object'; got " + u(xe);
    }), t(Qe && typeof Qe == "object", function() {
      return "update(): $merge expects a target of type 'object'; got " + u(Qe);
    });
  }
  function Te(Qe, xe) {
    var Ee = k(Qe);
    t(Ee === "Map" || Ee === "Set", function() {
      return "update(): " + u(xe) + " expects a target of type Set or Map; got " + u(Ee);
    });
  }
})(r2, r2.exports);
var x0 = r2.exports;
const V = /* @__PURE__ */ S0(x0), E0 = [
  {
    wallet: "cosmos_keplr",
    messageRegex: /There is no modular chain info for/
  },
  {
    wallet: "cosmos_leap",
    messageRegex: /Invalid chain id/
  },
  {
    wallet: "cosmos_cosmostation",
    messageRegex: /There is no chain info for/
  }
];
function N0(s, A) {
  return s[A + "Chains"];
}
function hA() {
  const s = R(U), A = R(O), u = Y(useCallback(async (m, b, k) => {
    const { chainType: C } = k, B = await m(O)[`${C}Provider`].getAddress();
    s((Q) => V(Q, {
      [C]: {
        address: {
          $set: B
        }
      }
    }));
  }, [])), p = Y(useCallback(async (m, b, k, C = {}) => {
    var B;
    const Q = m(O), P = m(X), x = m(U);
    try {
      const M = Q[`${k}Provider`];
      if (!M)
        throw new Error(`Unsupported Chain: ${k}`);
      try {
        await M.connectWallet();
      } catch (ge) {
        if (k !== "cosmos" || // @ts-ignore
        !((B = M == null ? void 0 : M.provider) != null && B.experimentalSuggestChain))
          throw ge;
        const pe = E0.find((be) => {
          var Pe;
          return be.wallet === ((Pe = x.cosmos) == null ? void 0 : Pe.walletId);
        });
        if (!pe || !pe.messageRegex.test(ge.message || ""))
          throw ge;
        const Ie = P.cosmosChains[0].modularData;
        if (!Ie)
          throw ge;
        await M.provider.experimentalSuggestChain(Ie), await M.connectWallet();
      }
      const F = await M.getNetwork();
      let le = P[`${k}Chains`].find((ge) => ge.network === F);
      if (!le) {
        const ge = N0(P, k);
        if (!(ge != null && ge.length))
          throw new Error("Unsupported network");
        le = ge[0], await t(le);
        return;
      }
      await u({ chainType: k }), s((ge) => V(ge, {
        [k]: {
          $merge: {
            network: F,
            chainId: le.id
          }
        }
      }));
    } catch (M) {
      throw M;
    }
  }, [])), t = Y(useCallback(async (m, b, k) => {
    const C = m(O)[`${k.type}Provider`];
    if (!C || !C.switchNetwork)
      throw new Error(`switchNetwork error: ${k.type}`);
    await C.switchNetwork(k.network);
    const B = await (C == null ? void 0 : C.getAddress()), Q = await (C == null ? void 0 : C.getNetwork());
    s((P) => V(P, {
      [k.type]: {
        $merge: {
          network: Q,
          chainId: k.id,
          address: B
        }
      }
    }));
  }, [])), l = Y(useCallback(async (m, b, k) => {
    const C = m(X), B = {}, Q = t2(k, C);
    if (!Q)
      throw new Error("Wallet does not exist");
    const P = B[`${Q.chainType}Provider`] = new Q.connectProvider(
      // @ts-ignore
      {
        chains: C[`${Q.chainType}Chains`],
        ...C.providerOptions
      }
    );
    return await P.init(), A((x) => ({
      ...x,
      ...B
    })), P;
  }, []));
  return {
    initProvider: l,
    switchChainType: p,
    switchChain: t,
    reloadAddress: u,
    disconnect: Y(useCallback(async (m, b) => {
      const k = m(X);
      s(ie(ne, k));
    }, [])),
    connect: Y(useCallback(async (m, b, k) => {
      var C;
      const B = m(X);
      for (const P of k) {
        const x = t2(P, B);
        if (!x)
          throw new Error("Wallet does not exist");
        s((M) => V(M, {
          [x.chainType]: {
            $merge: {
              walletId: P
            }
          }
        })), await l(P), await p(x.chainType), s((M) => V(M, {
          [x.chainType]: {
            $merge: {
              connected: !0
            }
          }
        }));
      }
      const Q = m(U);
      (C = B.chainTypes) != null && C.every((P) => Q[P].connected) && s((P) => ({
        ...P,
        isConnected: !0
      }));
    }, []))
  };
}
const D0 = (s) => {
  if (window.ethereum) {
    let A = [];
    const u = (p) => {
      const t = [p.detail];
      A = A.concat(t), s(A || []);
    };
    window.addEventListener("eip6963:announceProvider", u), window.dispatchEvent(new Event("eip6963:requestProvider")), window.removeEventListener("eip6963:announceProvider", u);
  } else
    s([]);
};
function F0(s) {
  return s ? s == null ? void 0 : s.map((A) => A) : [];
}
function ie(s, A) {
  let u = s;
  return A.chainTypes.forEach((p) => {
    u[p] || (u = {
      ...u,
      [p]: {
        connected: !1,
        chainType: p
      }
    });
  }), u;
}
function H0(s) {
  const A = H(I2), u = hA(), p = R(I2);
  useEffect(() => {
    D0(p);
  }, []);
  const t = Y(useCallback(async (l, m) => {
    var b;
    const k = {
      ...l(X),
      ...s
    };
    te.forEach((Q) => {
      k[`${Q}Chains`] = F0(
        // @ts-ignore
        k[`${Q}Chains`]
      );
    }), m(U, (Q) => ie(Q, k)), m(X, k);
    const C = () => {
      m(U, (Q) => {
        var P;
        return (P = k.chainTypes) == null || P.forEach((x) => {
          Q = V(Q, {
            [x]: {
              connected: {
                $set: !1
              }
            }
          });
        }), {
          ...Q,
          isConnected: !1
        };
      });
    }, B = l(U);
    if (B.isConnected && k.autoReconnect !== !1)
      try {
        if ((b = k.chainTypes) != null && b.some((P) => !B[P].connected))
          throw new Error("chain not connected");
        const Q = k.chainTypes;
        for (const P of Q) {
          const x = B[P].walletId;
          await u.initProvider(x), await u.switchChainType(P, {
            type: "init"
          });
        }
      } catch {
        m(U, (Q) => ({
          ...Q,
          isConnected: !1
        })), C();
      }
    else
      C();
    m(O, (Q) => ({
      ...Q,
      state: 1
    }));
  }, []));
  return useEffect(() => {
    A !== a2 && t();
  }, [A]), null;
}
function M0() {
  const s = H(O), A = hA(), u = H(U);
  useEffect(() => {
    var p, t;
    if (!u.bitcoin.connected)
      return;
    const l = async () => {
      await A.reloadAddress({ chainType: "bitcoin" });
    };
    return (t = (p = s.bitcoinProvider) == null ? void 0 : p.on) == null || t.call(p, "accountsChanged", l), () => {
      var m, b;
      (b = (m = s.bitcoinProvider) == null ? void 0 : m.off) == null || b.call(m, "accountsChanged", l);
    };
  }, [s.bitcoinProvider, u.bitcoin.connected]), useEffect(() => {
    var p, t;
    if (!u.cosmos.connected)
      return;
    const l = async () => {
      await A.reloadAddress({ chainType: "cosmos" });
    };
    return (t = (p = s.cosmosProvider) == null ? void 0 : p.on) == null || t.call(p, "accountChanged", l), () => {
      var m, b;
      (b = (m = s.cosmosProvider) == null ? void 0 : m.off) == null || b.call(m, "accountChanged", l);
    };
  }, [s.cosmosProvider, u.cosmos.connected]);
}
function J0(s) {
  return jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", ...s, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.41425 6.00025L11.7072 1.70725C12.0982 1.31625 12.0982 0.68425 11.7072 0.29325C11.3162 -0.09775 10.6842 -0.09775 10.2933 0.29325L6.00025 4.58625L1.70725 0.29325C1.31625 -0.09775 0.68425 -0.09775 0.29325 0.29325C-0.09775 0.68425 -0.09775 1.31625 0.29325 1.70725L4.58625 6.00025L0.29325 10.2933C-0.09775 10.6842 -0.09775 11.3162 0.29325 11.7072C0.48825 11.9022 0.74425 12.0002 1.00025 12.0002C1.25625 12.0002 1.51225 11.9022 1.70725 11.7072L6.00025 7.41425L10.2933 11.7072C10.4882 11.9022 10.7443 12.0002 11.0002 12.0002C11.2562 12.0002 11.5122 11.9022 11.7072 11.7072C12.0982 11.3162 12.0982 10.6842 11.7072 10.2933L7.41425 6.00025Z", fill: "currentColor", fillOpacity: "0.4" }) });
}
function oe(s) {
  return jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", ...s, children: [jsx("g", { clipPath: "url(#clip0_1_1460)", children: jsx("path", { d: "M14.6672 7.33284C14.2985 7.33284 14.0001 7.63127 14.0001 8.00002C14.0001 11.3078 11.3079 14 8.00005 14C6.59849 14 5.2813 13.525 4.22661 12.6672H5.33442C5.70317 12.6672 6.00161 12.3688 6.00161 12C6.00161 11.6313 5.70317 11.3328 5.33442 11.3328H2.66724C2.66099 11.3328 2.65474 11.3344 2.64849 11.3344C2.62661 11.3344 2.60474 11.3375 2.58442 11.3406C2.56255 11.3438 2.54067 11.3453 2.5188 11.35C2.50005 11.3547 2.4813 11.361 2.46255 11.3672C2.43911 11.375 2.41724 11.3813 2.39536 11.3922C2.37974 11.4 2.36411 11.4094 2.34849 11.4172C2.32505 11.4297 2.30317 11.4422 2.2813 11.4578C2.27661 11.461 2.27192 11.4625 2.2688 11.4656C2.25786 11.4735 2.25005 11.4844 2.23911 11.4922C2.22036 11.5078 2.20161 11.525 2.18442 11.5422C2.17036 11.5578 2.15786 11.5735 2.1438 11.5906C2.12974 11.6078 2.11724 11.625 2.1063 11.6438C2.0938 11.6625 2.08442 11.6813 2.07505 11.7016C2.06567 11.7203 2.0563 11.7391 2.04849 11.7594C2.04067 11.7813 2.03442 11.8031 2.02817 11.825C2.02349 11.8438 2.01724 11.8625 2.01411 11.8828C2.00942 11.9078 2.00786 11.9344 2.0063 11.961C2.0063 11.9735 2.00317 11.986 2.00317 11.9985V14.6656C2.00317 15.0344 2.30161 15.3328 2.67036 15.3328C3.03911 15.3328 3.33755 15.0344 3.33755 14.6656V13.6594C4.63599 14.736 6.26724 15.3313 8.00474 15.3313C12.0485 15.3313 15.3376 12.0422 15.3376 7.99846C15.3329 7.63127 15.0344 7.33284 14.6672 7.33284ZM8.00005 2.00002C9.40161 2.00002 10.7188 2.47502 11.7735 3.33284H10.6657C10.2969 3.33284 9.99849 3.63127 9.99849 4.00002C9.99849 4.36877 10.2969 4.66721 10.6657 4.66721H13.3329C13.3391 4.66721 13.3438 4.66565 13.3501 4.66565C13.3735 4.66565 13.3954 4.66096 13.4188 4.6594C13.4391 4.65627 13.461 4.65471 13.4813 4.65002C13.5016 4.64534 13.5204 4.63752 13.5407 4.63127C13.5625 4.62346 13.5844 4.61721 13.6063 4.60784C13.6235 4.60002 13.6391 4.59065 13.6547 4.58127C13.6766 4.56877 13.7 4.55627 13.7204 4.54221C13.725 4.53909 13.7297 4.53752 13.7344 4.5344C13.7454 4.52502 13.7547 4.51565 13.7657 4.50627C13.7844 4.49065 13.8016 4.47502 13.8188 4.45784C13.8344 4.44221 13.8469 4.42502 13.8594 4.40784C13.8719 4.39065 13.886 4.37502 13.8969 4.35627C13.9094 4.33752 13.9188 4.31721 13.9282 4.2969C13.9376 4.27815 13.9469 4.2594 13.9532 4.24065C13.961 4.21877 13.9672 4.1969 13.9735 4.17502C13.9782 4.15627 13.9844 4.13752 13.9876 4.11877C13.9922 4.09221 13.9938 4.06565 13.9954 4.04065C13.9954 4.02815 13.9985 4.01721 13.9985 4.00315V1.33284C13.9985 0.964087 13.7001 0.665649 13.3313 0.665649C12.9626 0.665649 12.6641 0.964087 12.6641 1.33284V2.33909C11.3657 1.26252 9.73442 0.667212 7.99692 0.667212C3.9563 0.667212 0.667236 3.95627 0.667236 8.00002C0.667236 8.36877 0.965674 8.66721 1.33442 8.66721C1.70317 8.66721 2.00005 8.36877 2.00005 8.00002C2.00005 4.69221 4.69224 2.00002 8.00005 2.00002Z", fill: "currentColor" }) }), jsx("defs", { children: jsx("clipPath", { id: "clip0_1_1460", children: jsx("rect", { width: "16", height: "16", fill: "white" }) }) })] });
}
function Q0(s) {
  return jsx("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "check-circle", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", ...s, children: jsx("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" }) });
}
function T0(s) {
  return jsx("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "exclamation-circle", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", ...s, children: jsx("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" }) });
}
function L0(s) {
  return jsx("svg", { fillRule: "evenodd", viewBox: "64 64 896 896", focusable: "false", "data-icon": "close-circle", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", ...s, children: jsx("path", { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" }) });
}
let W0 = 1;
function ce() {
  const s = R(d2), A = useContext(s2);
  return {
    open: (u, p) => {
      const { type: t = "page", showClose: l = !0, ...m } = p || {}, b = W0++, k = new Promise((C) => {
        s((B) => [
          ...B,
          {
            jsx: u,
            resolve: C,
            type: t,
            showClose: l,
            openPageId: t === "drawer" ? A.page.type === "drawer" ? A.page.openPageId : A.id : void 0,
            id: b,
            opt: m
          }
        ]);
      });
      return k._pageId = b, k;
    },
    close: (u, p) => {
      s((t) => {
        const l = t.find((m) => m.id === u);
        return l && l.resolve(p), t.filter((m) => m.id !== u);
      });
    }
  };
}
const s2 = createContext({ id: 0, page: {} }), k2 = {
  getNextState(s, A) {
    return (!s || typeof s == "boolean") && (s = 0), s + A;
  },
  createFn(s) {
    return async function(A) {
      if (typeof A == "boolean") {
        s(A ? 1 : -1);
        return;
      }
      s(1);
      let u;
      try {
        typeof A == "function" ? u = await A() : u = await A;
      } catch (p) {
        throw s(-1), p;
      }
      return s(-1), u;
    };
  }
};
function z0(s = !1) {
  const [A, u] = useState(s);
  return [
    !!A,
    k2.createFn((p) => {
      u((t) => k2.getNextState(t, p));
    })
  ];
}
function K0(s) {
  const A = ce();
  useEffect(() => {
    if (s) {
      const u = A.open(jsx(ae, {}), {
        type: "drawer",
        noBg: !0,
        full: !0,
        animate: !1
      });
      return () => {
        A.close(u._pageId);
      };
    }
  }, [s]);
}
function ae() {
  return jsx("div", { className: "tm-flex tm-h-full tm-w-full tm-items-center tm-justify-center", children: jsx("div", { className: "tm-flex tm-size-16 tm-items-center tm-justify-center tm-rounded-lg tm-bg-white dark:tm-bg-white-dark", children: jsx(oe, { className: "tm-size-7 tm-animate-spin tm-text-tc1 dark:tm-text-tc1-dark" }) }) });
}
const U0 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='38'%20height='16'%20viewBox='0%200%2038%2016'%20fill='none'%3e%3crect%20width='37.0683'%20height='16.0002'%20rx='1.11164'%20fill='%23666666'/%3e%3cpath%20d='M19.946%207.50648C19.5159%207.50648%2019.1206%207.40657%2018.7601%207.20674C18.4039%207.00692%2018.1194%206.72891%2017.9065%206.37271C17.698%206.01216%2017.5938%205.60817%2017.5938%205.16075C17.5938%204.71332%2017.698%204.31151%2017.9065%203.9553C18.1194%203.5991%2018.4039%203.32109%2018.7601%203.12127C19.1206%202.92144%2019.5159%202.82153%2019.946%202.82153C20.376%202.82153%2020.7692%202.92144%2021.1254%203.12127C21.4859%203.32109%2021.7683%203.5991%2021.9724%203.9553C22.181%204.31151%2022.2852%204.71332%2022.2852%205.16075C22.2852%205.60817%2022.181%206.01216%2021.9724%206.37271C21.7639%206.72891%2021.4816%207.00692%2021.1254%207.20674C20.7692%207.40657%2020.376%207.50648%2019.946%207.50648ZM19.946%206.48999C20.3109%206.48999%2020.6019%206.36836%2020.8191%206.1251C21.0407%205.88184%2021.1514%205.56039%2021.1514%205.16075C21.1514%204.75676%2021.0407%204.43531%2020.8191%204.19639C20.6019%203.95313%2020.3109%203.8315%2019.946%203.8315C19.5768%203.8315%2019.2814%203.95096%2019.0598%204.18988C18.8426%204.42879%2018.734%204.75242%2018.734%205.16075C18.734%205.56473%2018.8426%205.88836%2019.0598%206.13162C19.2814%206.37054%2019.5768%206.48999%2019.946%206.48999Z'%20fill='%23121212'/%3e%3cpath%20d='M16.9809%202.88672V7.46089H15.8667V4.71769L14.8437%207.46089H13.9445L12.915%204.71118V7.46089H11.8008V2.88672H13.117L14.4006%206.05345L15.6712%202.88672H16.9809Z'%20fill='%23121212'/%3e%3cpath%20d='M8.84248%207.50648C8.41243%207.50648%208.01713%207.40657%207.65658%207.20674C7.30038%207.00692%207.01585%206.72891%206.803%206.37271C6.59449%206.01216%206.49023%205.60817%206.49023%205.16075C6.49023%204.71332%206.59449%204.31151%206.803%203.9553C7.01585%203.5991%207.30038%203.32109%207.65658%203.12127C8.01713%202.92144%208.41243%202.82153%208.84248%202.82153C9.27253%202.82153%209.66566%202.92144%2010.0219%203.12127C10.3824%203.32109%2010.6648%203.5991%2010.8689%203.9553C11.0774%204.31151%2011.1817%204.71332%2011.1817%205.16075C11.1817%205.60817%2011.0774%206.01216%2010.8689%206.37271C10.6604%206.72891%2010.3781%207.00692%2010.0219%207.20674C9.66566%207.40657%209.27253%207.50648%208.84248%207.50648ZM8.84248%206.48999C9.20737%206.48999%209.49842%206.36836%209.71561%206.1251C9.93715%205.88184%2010.0479%205.56039%2010.0479%205.16075C10.0479%204.75676%209.93715%204.43531%209.71561%204.19639C9.49842%203.95313%209.20737%203.8315%208.84248%203.8315C8.47324%203.8315%208.17786%203.95096%207.95632%204.18988C7.73912%204.42879%207.63052%204.75242%207.63052%205.16075C7.63052%205.56473%207.73912%205.88836%207.95632%206.13162C8.17786%206.37054%208.47324%206.48999%208.84248%206.48999Z'%20fill='%23121212'/%3e%3cpath%20d='M6.12017%202.88672V3.7794H4.90821V7.46089H3.79399V3.7794H2.58203V2.88672H6.12017Z'%20fill='%23121212'/%3e%3cpath%20d='M34.4932%209.06519V9.95787H33.2813V13.6394H32.167V9.95787H30.9551V9.06519H34.4932Z'%20fill='%23121212'/%3e%3cpath%20d='M26.0508%2011.3458C26.0508%2010.894%2026.1485%2010.4922%2026.344%2010.1403C26.5395%209.78411%2026.811%209.50827%2027.1585%209.31279C27.5103%209.11297%2027.9078%209.01306%2028.3509%209.01306C28.8939%209.01306%2029.3587%209.15641%2029.7453%209.44311C30.1319%209.72981%2030.3904%2010.1208%2030.5207%2010.616H29.2957C29.2045%2010.4248%2029.0742%2010.2793%2028.9048%2010.1794C28.7397%2010.0795%2028.5507%2010.0295%2028.3379%2010.0295C27.9947%2010.0295%2027.7167%2010.149%2027.5038%2010.3879C27.291%2010.6268%2027.1846%2010.9461%2027.1846%2011.3458C27.1846%2011.7454%2027.291%2012.0647%2027.5038%2012.3036C27.7167%2012.5425%2027.9947%2012.662%2028.3379%2012.662C28.5507%2012.662%2028.7397%2012.612%2028.9048%2012.5121C29.0742%2012.4122%2029.2045%2012.2667%2029.2957%2012.0755H30.5207C30.3904%2012.5708%2030.1319%2012.9617%2029.7453%2013.2484C29.3587%2013.5308%2028.8939%2013.6719%2028.3509%2013.6719C27.9078%2013.6719%2027.5103%2013.5742%2027.1585%2013.3787C26.811%2013.1789%2026.5395%2012.9031%2026.344%2012.5512C26.1485%2012.1993%2026.0508%2011.7975%2026.0508%2011.3458Z'%20fill='%23121212'/%3e%3cpath%20d='M23.8291%209.95787V10.8831H25.3212V11.7432H23.8291V12.7467H25.5167V13.6394H22.7148V9.06519H25.5167V9.95787H23.8291Z'%20fill='%23121212'/%3e%3cpath%20d='M21.9064%2013.6394H20.7922L18.9287%2010.818V13.6394H17.8145V9.06519H18.9287L20.7922%2011.8996V9.06519H21.9064V13.6394Z'%20fill='%23121212'/%3e%3cpath%20d='M17.008%2013.6394H15.8938L14.0302%2010.818V13.6394H12.916V9.06519H14.0302L15.8938%2011.8996V9.06519H17.008V13.6394Z'%20fill='%23121212'/%3e%3cpath%20d='M9.95576%2013.6849C9.52571%2013.6849%209.13041%2013.585%208.76986%2013.3852C8.41366%2013.1854%208.12913%2012.9074%207.91628%2012.5512C7.70777%2012.1906%207.60352%2011.7866%207.60352%2011.3392C7.60352%2010.8918%207.70777%2010.49%207.91628%2010.1338C8.12913%209.77757%208.41366%209.49955%208.76986%209.29973C9.13041%209.09991%209.52571%209%209.95576%209C10.3858%209%2010.7789%209.09991%2011.1351%209.29973C11.4957%209.49955%2011.778%209.77757%2011.9822%2010.1338C12.1907%2010.49%2012.295%2010.8918%2012.295%2011.3392C12.295%2011.7866%2012.1907%2012.1906%2011.9822%2012.5512C11.7737%2012.9074%2011.4913%2013.1854%2011.1351%2013.3852C10.7789%2013.585%2010.3858%2013.6849%209.95576%2013.6849ZM9.95576%2012.6685C10.3207%2012.6685%2010.6117%2012.5468%2010.8289%2012.3036C11.0504%2012.0603%2011.1612%2011.7389%2011.1612%2011.3392C11.1612%2010.9352%2011.0504%2010.6138%2010.8289%2010.3749C10.6117%2010.1316%2010.3207%2010.01%209.95576%2010.01C9.58653%2010.01%209.29114%2010.1294%209.0696%2010.3683C8.8524%2010.6073%208.7438%2010.9309%208.7438%2011.3392C8.7438%2011.7432%208.8524%2012.0668%209.0696%2012.3101C9.29114%2012.549%209.58653%2012.6685%209.95576%2012.6685Z'%20fill='%23121212'/%3e%3cpath%20d='M2.64062%2011.3458C2.64062%2010.894%202.73836%2010.4922%202.93384%2010.1403C3.12932%209.78411%203.40082%209.50827%203.74833%209.31279C4.10019%209.11297%204.49766%209.01306%204.94074%209.01306C5.48374%209.01306%205.94854%209.15641%206.33515%209.44311C6.72176%209.72981%206.98022%2010.1208%207.11054%2010.616H5.88555C5.79433%2010.4248%205.66401%2010.2793%205.4946%2010.1794C5.32953%2010.0795%205.14056%2010.0295%204.92771%2010.0295C4.58454%2010.0295%204.30653%2010.149%204.09367%2010.3879C3.88082%2010.6268%203.77439%2010.9461%203.77439%2011.3458C3.77439%2011.7454%203.88082%2012.0647%204.09367%2012.3036C4.30653%2012.5425%204.58454%2012.662%204.92771%2012.662C5.14056%2012.662%205.32953%2012.612%205.4946%2012.5121C5.66401%2012.4122%205.79433%2012.2667%205.88555%2012.0755H7.11054C6.98022%2012.5708%206.72176%2012.9617%206.33515%2013.2484C5.94854%2013.5308%205.48374%2013.6719%204.94074%2013.6719C4.49766%2013.6719%204.10019%2013.5742%203.74833%2013.3787C3.40082%2013.1789%203.12932%2012.9031%202.93384%2012.5512C2.73836%2012.1993%202.64062%2011.7975%202.64062%2011.3458Z'%20fill='%23121212'/%3e%3c/svg%3e", X0 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='38'%20height='16'%20viewBox='0%200%2038%2016'%20fill='none'%3e%3crect%20width='37.0683'%20height='16.0002'%20rx='1.11164'%20fill='black'/%3e%3cpath%20d='M19.946%207.50648C19.5159%207.50648%2019.1206%207.40657%2018.7601%207.20674C18.4039%207.00692%2018.1194%206.72891%2017.9065%206.37271C17.698%206.01216%2017.5938%205.60817%2017.5938%205.16075C17.5938%204.71332%2017.698%204.31151%2017.9065%203.9553C18.1194%203.5991%2018.4039%203.32109%2018.7601%203.12127C19.1206%202.92144%2019.5159%202.82153%2019.946%202.82153C20.376%202.82153%2020.7692%202.92144%2021.1254%203.12127C21.4859%203.32109%2021.7683%203.5991%2021.9724%203.9553C22.181%204.31151%2022.2852%204.71332%2022.2852%205.16075C22.2852%205.60817%2022.181%206.01216%2021.9724%206.37271C21.7639%206.72891%2021.4816%207.00692%2021.1254%207.20674C20.7692%207.40657%2020.376%207.50648%2019.946%207.50648ZM19.946%206.48999C20.3109%206.48999%2020.6019%206.36836%2020.8191%206.1251C21.0407%205.88184%2021.1514%205.56039%2021.1514%205.16075C21.1514%204.75676%2021.0407%204.43531%2020.8191%204.19639C20.6019%203.95313%2020.3109%203.8315%2019.946%203.8315C19.5768%203.8315%2019.2814%203.95096%2019.0598%204.18988C18.8426%204.42879%2018.734%204.75242%2018.734%205.16075C18.734%205.56473%2018.8426%205.88836%2019.0598%206.13162C19.2814%206.37054%2019.5768%206.48999%2019.946%206.48999Z'%20fill='white'/%3e%3cpath%20d='M16.9809%202.88672V7.46089H15.8667V4.71769L14.8437%207.46089H13.9445L12.915%204.71118V7.46089H11.8008V2.88672H13.117L14.4006%206.05345L15.6712%202.88672H16.9809Z'%20fill='white'/%3e%3cpath%20d='M8.84248%207.50648C8.41243%207.50648%208.01713%207.40657%207.65658%207.20674C7.30038%207.00692%207.01585%206.72891%206.803%206.37271C6.59449%206.01216%206.49023%205.60817%206.49023%205.16075C6.49023%204.71332%206.59449%204.31151%206.803%203.9553C7.01585%203.5991%207.30038%203.32109%207.65658%203.12127C8.01713%202.92144%208.41243%202.82153%208.84248%202.82153C9.27253%202.82153%209.66566%202.92144%2010.0219%203.12127C10.3824%203.32109%2010.6648%203.5991%2010.8689%203.9553C11.0774%204.31151%2011.1817%204.71332%2011.1817%205.16075C11.1817%205.60817%2011.0774%206.01216%2010.8689%206.37271C10.6604%206.72891%2010.3781%207.00692%2010.0219%207.20674C9.66566%207.40657%209.27253%207.50648%208.84248%207.50648ZM8.84248%206.48999C9.20737%206.48999%209.49842%206.36836%209.71561%206.1251C9.93715%205.88184%2010.0479%205.56039%2010.0479%205.16075C10.0479%204.75676%209.93715%204.43531%209.71561%204.19639C9.49842%203.95313%209.20737%203.8315%208.84248%203.8315C8.47324%203.8315%208.17786%203.95096%207.95632%204.18988C7.73912%204.42879%207.63052%204.75242%207.63052%205.16075C7.63052%205.56473%207.73912%205.88836%207.95632%206.13162C8.17786%206.37054%208.47324%206.48999%208.84248%206.48999Z'%20fill='white'/%3e%3cpath%20d='M6.12017%202.88672V3.7794H4.90821V7.46089H3.79399V3.7794H2.58203V2.88672H6.12017Z'%20fill='white'/%3e%3cpath%20d='M34.4932%209.06519V9.95787H33.2813V13.6394H32.167V9.95787H30.9551V9.06519H34.4932Z'%20fill='white'/%3e%3cpath%20d='M26.0508%2011.3458C26.0508%2010.894%2026.1485%2010.4922%2026.344%2010.1403C26.5395%209.78411%2026.811%209.50827%2027.1585%209.31279C27.5103%209.11297%2027.9078%209.01306%2028.3509%209.01306C28.8939%209.01306%2029.3587%209.15641%2029.7453%209.44311C30.1319%209.72981%2030.3904%2010.1208%2030.5207%2010.616H29.2957C29.2045%2010.4248%2029.0742%2010.2793%2028.9048%2010.1794C28.7397%2010.0795%2028.5507%2010.0295%2028.3379%2010.0295C27.9947%2010.0295%2027.7167%2010.149%2027.5038%2010.3879C27.291%2010.6268%2027.1846%2010.9461%2027.1846%2011.3458C27.1846%2011.7454%2027.291%2012.0647%2027.5038%2012.3036C27.7167%2012.5425%2027.9947%2012.662%2028.3379%2012.662C28.5507%2012.662%2028.7397%2012.612%2028.9048%2012.5121C29.0742%2012.4122%2029.2045%2012.2667%2029.2957%2012.0755H30.5207C30.3904%2012.5708%2030.1319%2012.9617%2029.7453%2013.2484C29.3587%2013.5308%2028.8939%2013.6719%2028.3509%2013.6719C27.9078%2013.6719%2027.5103%2013.5742%2027.1585%2013.3787C26.811%2013.1789%2026.5395%2012.9031%2026.344%2012.5512C26.1485%2012.1993%2026.0508%2011.7975%2026.0508%2011.3458Z'%20fill='white'/%3e%3cpath%20d='M23.8291%209.95787V10.8831H25.3212V11.7432H23.8291V12.7467H25.5167V13.6394H22.7148V9.06519H25.5167V9.95787H23.8291Z'%20fill='white'/%3e%3cpath%20d='M21.9064%2013.6394H20.7922L18.9287%2010.818V13.6394H17.8145V9.06519H18.9287L20.7922%2011.8996V9.06519H21.9064V13.6394Z'%20fill='white'/%3e%3cpath%20d='M17.008%2013.6394H15.8938L14.0302%2010.818V13.6394H12.916V9.06519H14.0302L15.8938%2011.8996V9.06519H17.008V13.6394Z'%20fill='white'/%3e%3cpath%20d='M9.95576%2013.6849C9.52571%2013.6849%209.13041%2013.585%208.76986%2013.3852C8.41366%2013.1854%208.12913%2012.9074%207.91628%2012.5512C7.70777%2012.1906%207.60352%2011.7866%207.60352%2011.3392C7.60352%2010.8918%207.70777%2010.49%207.91628%2010.1338C8.12913%209.77757%208.41366%209.49955%208.76986%209.29973C9.13041%209.09991%209.52571%209%209.95576%209C10.3858%209%2010.7789%209.09991%2011.1351%209.29973C11.4957%209.49955%2011.778%209.77757%2011.9822%2010.1338C12.1907%2010.49%2012.295%2010.8918%2012.295%2011.3392C12.295%2011.7866%2012.1907%2012.1906%2011.9822%2012.5512C11.7737%2012.9074%2011.4913%2013.1854%2011.1351%2013.3852C10.7789%2013.585%2010.3858%2013.6849%209.95576%2013.6849ZM9.95576%2012.6685C10.3207%2012.6685%2010.6117%2012.5468%2010.8289%2012.3036C11.0504%2012.0603%2011.1612%2011.7389%2011.1612%2011.3392C11.1612%2010.9352%2011.0504%2010.6138%2010.8289%2010.3749C10.6117%2010.1316%2010.3207%2010.01%209.95576%2010.01C9.58653%2010.01%209.29114%2010.1294%209.0696%2010.3683C8.8524%2010.6073%208.7438%2010.9309%208.7438%2011.3392C8.7438%2011.7432%208.8524%2012.0668%209.0696%2012.3101C9.29114%2012.549%209.58653%2012.6685%209.95576%2012.6685Z'%20fill='white'/%3e%3cpath%20d='M2.64062%2011.3458C2.64062%2010.894%202.73836%2010.4922%202.93384%2010.1403C3.12932%209.78411%203.40082%209.50827%203.74833%209.31279C4.10019%209.11297%204.49766%209.01306%204.94074%209.01306C5.48374%209.01306%205.94854%209.15641%206.33515%209.44311C6.72176%209.72981%206.98022%2010.1208%207.11054%2010.616H5.88555C5.79433%2010.4248%205.66401%2010.2793%205.4946%2010.1794C5.32953%2010.0795%205.14056%2010.0295%204.92771%2010.0295C4.58454%2010.0295%204.30653%2010.149%204.09367%2010.3879C3.88082%2010.6268%203.77439%2010.9461%203.77439%2011.3458C3.77439%2011.7454%203.88082%2012.0647%204.09367%2012.3036C4.30653%2012.5425%204.58454%2012.662%204.92771%2012.662C5.14056%2012.662%205.32953%2012.612%205.4946%2012.5121C5.66401%2012.4122%205.79433%2012.2667%205.88555%2012.0755H7.11054C6.98022%2012.5708%206.72176%2012.9617%206.33515%2013.2484C5.94854%2013.5308%205.48374%2013.6719%204.94074%2013.6719C4.49766%2013.6719%204.10019%2013.5742%203.74833%2013.3787C3.40082%2013.1789%203.12932%2012.9031%202.93384%2012.5512C2.73836%2012.1993%202.64062%2011.7975%202.64062%2011.3458Z'%20fill='white'/%3e%3c/svg%3e";
function G0() {
  const { theme: s } = H(se);
  return jsxs("div", { className: "tm-flex tm-gap-2 tm-pb-2.5 tm-text-xs tm-text-tc4 dark:tm-text-tc4-dark", children: [jsx("div", { children: "Powered by" }), jsx("img", { alt: "tomo", src: s === "dark" ? U0 : X0 })] });
}
function Y0() {
  const s = H(re$2);
  return jsx("div", { className: "tm-pointer-events-none tm-absolute tm-bottom-20 tm-flex tm-w-full tm-flex-col tm-items-center tm-gap-4", children: [...s].reverse().map((A) => jsx(O0, { msg: A }, A.id)) });
}
const R0 = {
  success: jsx(Q0, { className: "tm-size-4 tm-text-success" }),
  error: jsx(L0, { className: "tm-size-4 tm-text-danger" }),
  warning: jsx(T0, { className: "tm-size-4 tm-text-warning" })
};
function O0({ msg: s }) {
  const [A, u] = useState(!0), p = de();
  return useEffect(() => {
    if (A) {
      const t = setTimeout(() => {
        p.remove(s.id);
      }, s.duration);
      return () => clearTimeout(t);
    }
  }, [A]), jsxs("div", { className: "tm-pointer-events-auto tm-flex tm-max-w-[80%] tm-items-center tm-gap-2 tm-overflow-hidden tm-rounded-lg tm-bg-white tm-px-4 tm-py-2 tm-text-sm dark:tm-bg-white-dark animate__animated animate__fadeInUp animate__faster", onMouseOver: () => {
    u(!1);
  }, onMouseLeave: () => {
    u(!0);
  }, style: {
    // boxShadow: '0px 0px 4px 0px rgba(213, 213, 213, 0.25)',
    boxShadow: "0 6px 16px 0 rgba(0, 0, 0, 0.08),0 3px 6px -4px rgba(0, 0, 0, 0.12),0 9px 28px 8px rgba(0, 0, 0, 0.05)"
  }, children: [R0[s.type || ""], jsx("div", { className: "tm-flex-1 tm-overflow-hidden", children: s.title })] }, s.id);
}
let Z0 = 1;
function de() {
  const s = R(re$2);
  return useMemo(() => ({
    remove: (A) => {
      s((u) => u.filter((p) => p.id !== A));
    },
    removeSameMsg: (A) => {
      s((u) => u.filter((p) => p.title !== A));
    },
    show: (A) => {
      s((u) => [...u, { type: "success", ...A, id: Z0++ }]);
    }
  }), []);
}
function V0() {
  const s = (p) => (t) => {
    typeof t == "string" ? t = {
      duration: 3e3,
      title: t,
      type: p
    } : t = { ...t, type: p }, A.show(t);
  }, A = de(), u = (p) => {
    typeof p == "string" && (p = {
      duration: 3e3,
      title: p
    }), A.show(p);
  };
  return u.success = s("success"), u.warning = s("warning"), u.error = s("error"), u;
}
function j0() {
  const s = navigator.userAgent;
  return /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(s) ? "tablet" : /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(s) ? "mobile" : "desktop";
}
function q0({ chainType: s }) {
  return jsx(An, { type: "connect", chainType: s });
}
function _0() {
  const s = hA(), A = H(X);
  return async (u) => {
    try {
      await new u.connectProvider({
        chains: [],
        ...A.providerOptions
      }).init();
    } catch {
      throw new Error("Wallet not installed");
    }
    await s.connect([u.id]);
  };
}
function Nn(s) {
  const A = H(X);
  return useMemo(() => ee(A).filter((u) => s ? u.chainType === s : !0), [A, s]);
}
function $0(s) {
  const A = H(X), [u, p] = useState(() => ee(A).map((m) => ({
    ...m,
    isInstall: !1
  }))), t = useMemo(() => {
    let m = !1;
    const b = j0() === "desktop";
    return u.filter((k) => {
      const C = s ? k.chainType === s : !0;
      if (C && k.type === "injected" && !b)
        if (k.isInstall)
          m = !0;
        else
          return !1;
      return C;
    }).filter((k) => b ? k.isInstall || k.type !== "injected" : k.isInstall || !m);
  }, [u, s]), l = async () => {
    u.filter((m) => s ? m.chainType === s : !0).forEach(async (m) => {
      if (!m.isInstall)
        try {
          await new m.connectProvider({
            chains: [],
            ...A.providerOptions
          }).init(), p((b) => V(b, {
            [b.findIndex((k) => m.id === k.id)]: {
              isInstall: { $set: !0 }
            }
          }));
        } catch {
        }
    });
  };
  return useEffect(() => {
    l();
  }, [A, s]), t;
}
function An(s) {
  const { chainType: A, type: u } = s, [p, t] = z0();
  K0(p);
  const l = _0(), m = V0(), b = $0(A) || [];
  return jsxs("div", { className: "tm-relative tm-flex tm-h-[700px] tm-w-[660px] tm-max-w-full tm-max-w-full tm-flex-col tm-justify-start tm-gap-5 tm-overflow-hidden tm-bg-white tm-pt-9 tm-text-tc1 dark:tm-bg-mbg-dark dark:tm-text-tc1-dark", children: [jsxs("div", { className: "tm-flex tm-flex-col tm-gap-5 tm-px-6 tm-pb-9", children: [jsx("div", { className: "tm-text-[24px]", children: "Select your wallet" }), jsxs("div", { children: ["Connect a ", jsx("span", { className: "tm-capitalize", children: A }), " Wallet"] })] }), jsx("div", { className: "tm-box-border tm-w-full tm-flex-1 tm-gap-5 tm-overflow-y-auto tm-pb-6 tm-pt-2", children: jsx("div", { className: "tm-grid tm-w-full tm-flex-1 tm-grid-cols-1 sm:tm-grid-cols-2 tm-gap-6 tm-px-6", children: b.map((k) => jsx(en, { wallet: k, onClick: () => {
    t(async () => {
      try {
        await l(k);
      } catch (C) {
        m.error((C == null ? void 0 : C.message) || "Failed");
      }
    });
  } }, `some-${k.id}`)) }) }), jsx("div", { className: "tm-bg-red tm-flex tm-flex-row tm-items-center tm-justify-center tm-text-center", children: jsx(G0, {}) })] });
}
function en({ wallet: s, ...A }) {
  const { onClick: u, checked: p } = A, t = () => {
    u && u();
  };
  return jsxs("div", { className: cA("tm-flex tm-h-[58px] tm-cursor-pointer tm-justify-between tm-rounded-lg tm-bg-white dark:tm-bg-[#282828] tm-px-2 hover:tm-bg-tc1/5 dark:hover:tm-bg-opacity-60 tm-border tm-border-[rgba(94,96,97,0.30)] tm-transition", {
    "tm-border tm-border-primary": p
  }), onClick: t, children: [jsxs("div", { className: "tm-flex tm-items-center tm-gap-3.5 ", children: [jsx("div", { className: "tm-size-[34px]", children: jsx("img", { src: s == null ? void 0 : s.img, alt: s == null ? void 0 : s.name, className: "tm-h-full tm-w-full tm-rounded-lg" }) }), jsx("div", { className: "tm-text-sm", children: s.name })] }), jsxs("div", { className: "tm-flex tm-items-center tm-gap-2", children: [s.type === "extension" && s.isInstall && jsx(BA, { children: "Installed" }), s.type === "qrcode" && jsx(BA, { children: "QR code" }), s.type === "injected" && jsx(BA, { children: "Injected" })] })] });
}
function BA({ children: s }) {
  return jsx("div", { className: "tm-rounded-full tm-bg-[#f6f7f3] tm-px-2.5 tm-py-1 tm-text-[10px] tm-text-[#666] dark:tm-bg-[#444] dark:tm-text-white", children: s });
}
function tn({ className: s, isModal: A, chainType: u }) {
  var p;
  const t = H(d2), l = ce(), m = t.filter((B) => B.type === "page").length, b = t.filter((B) => B.type === "page"), k = ((p = b[b.length - 1]) == null ? void 0 : p.id) || 0, C = t.filter((B) => B.type === "drawer");
  return jsxs("div", { className: cA("tomo-social tm-relative tm-flex tm-max-w-full tm-justify-start tm-overflow-hidden tm-rounded-3xl tm-bg-mbg dark:tm-bg-mbg-dark tm-text-tc1 dark:tm-text-tc1-dark", {
    "tm-rounded-b-none": A
  }, s), style: {
    filter: "drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.20))"
  }, children: [jsxs("div", { className: "tm-flex tm-max-w-full", style: {
    transform: `translateX(-${m / (m + 1) * 100}%)`
  }, children: [jsx("div", { className: "tm-h-fit tm-max-w-full tm-overflow-hidden", children: jsx(nn, { chainType: u }) }), b.map((B) => jsx("div", { className: "tm-relative tm-overflow-hidden", children: jsx(Suspense, { fallback: jsx(ae, {}), children: jsx(s2.Provider, { value: { id: B.id, page: B }, children: B.jsx }) }) }, B.id))] }), C.map((B) => {
    var Q, P, x, M;
    const F = k !== B.openPageId;
    return jsx("div", { className: cA("tm-absolute tm-bottom-0 tm-left-0 tm-h-full tm-w-full tm-bg-tc1/70", {
      "tm-hidden": F,
      "animate__animated animate__fadeIn animate__faster": ((Q = B.opt) == null ? void 0 : Q.animate) !== !1
    }), onClick: () => {
      var le;
      ((le = B.opt) == null ? void 0 : le.maskClosable) !== !1 && l.close(B.id);
    }, children: jsx("div", { onClick: (le) => {
      le.stopPropagation();
    }, className: cA("tm-absolute tm-bottom-0 tm-left-0 tm-max-h-full tm-w-full tm-overflow-hidden", {
      "tm-bg-white dark:tm-bg-white-dark": !((P = B.opt) != null && P.noBg),
      "tm-h-full": (x = B.opt) == null ? void 0 : x.full,
      "animate__animated animate__fadeInUp animate__faster": ((M = B.opt) == null ? void 0 : M.animate) !== !1
    }), children: jsx(s2.Provider, { value: { id: B.id, page: B }, children: B.jsx }) }) }, B.id);
  }), jsx(Y0, {})] });
}
function nn({ chainType: s }) {
  return H(O).state ? jsx(q0, { chainType: s }) : (
    // eslint-disable-next-line tailwindcss/no-custom-classname
    jsx("div", { className: "tm-flex tm-h-[700px] tm-w-[660px] tm-items-center tm-justify-center", children: jsx(oe, { className: "tm-size-6 tm-animate-spin tm-text-tc1 dark:tm-text-tc1-dark" }) })
  );
}
function rn() {
  const s = H(U), A = H(n2), u = sn(), { connected: p } = s[A.chainType] || { connected: !1 };
  return useEffect(() => {
    p && u.close({
      walletState: s
    });
  }, [p, A.open]), A.open ? createPortal(jsx("div", { className: "tomo-social tm-fixed tm-left-0 tm-top-0 tm-z-40 tm-box-border tm-flex tm-h-screen tm-w-screen tm-overflow-auto tm-bg-tc1/30  tm-font-poppins", onClick: () => {
    u.close(void 0);
  }, children: jsxs("div", {
    // className={'tm-relative tm-m-auto tm-overflow-hidden tm-rounded-3xl'}
    className: "tm-absolute sm:tm-relative sm:tm-m-auto sm:tm-w-auto tm-bottom-0 tm-left-0 tm-w-full tm-overflow-hidden tm-rounded-t-3xl sm:tm-rounded-b-3xl animate__animated animate__fadeInUp animate__faster sm:tm-animate-none",
    style: {
      filter: "drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.30))",
      animationDuration: "0.3s"
    },
    onClick: (t) => t.stopPropagation(),
    children: [p ? null : jsx("div", { className: "tm-absolute tm-right-0 tm-top-3 tm-z-10 tm-cursor-pointer tm-p-4 tm-text-tc1 dark:tm-text-tc1-dark hover:tm-text-opacity-70", onClick: () => {
      u.close(void 0);
    }, children: jsx(J0, {}) }), jsx(tn, { isModal: !0, chainType: A.chainType })]
  }) }), document.body) : null;
}
function sn() {
  const s = R(n2);
  return {
    open: Y(useCallback((A, u, p) => {
      if (!A(U)[p].connected)
        return new Promise((t) => {
          s({ open: !0, resolve: t, chainType: p });
        });
    }, [])),
    close: Y(useCallback((A, u, p) => {
      var t;
      const l = A(n2);
      (t = l.resolve) == null || t.call(l, p), s((m) => ({ ...m, open: !1 }));
    }, []))
  };
}
const S2 = {
  rounded: "medium",
  theme: "light",
  primaryColor: "#121212"
}, bA = {
  rounded: {
    sizeList: [
      ["--tms-rounded", 4],
      ["--tms-rounded-md", 6],
      ["--tms-rounded-lg", 8],
      ["--tms-rounded-xl", 12],
      ["--tms-rounded-2xl", 16],
      ["--tms-rounded-3xl", 24],
      ["--tms-rounded-full", 9999]
    ],
    scale: {
      none: 0,
      small: 0.5,
      medium: 1,
      large: 2
    }
  }
};
function on(s) {
  const [A, u] = je(X), p = R(se), t = {
    ...S2,
    ...s.style
  }, l = s.uiOptions;
  useEffect(() => {
    u((m) => ({ ...m, uiOptions: l }));
  }, [JSON.stringify(l)]), useEffect(() => {
    bA.rounded.sizeList.forEach(([m, b]) => {
      let k = bA.rounded.scale[t == null ? void 0 : t.rounded];
      isNaN(k) && (k = bA.rounded.scale.medium), document.documentElement.style.setProperty(m, `${b * k}px`);
    });
  }, [t == null ? void 0 : t.rounded]), useEffect(() => {
    (t == null ? void 0 : t.theme) === "dark" ? document.documentElement.classList.add("tm-dark") : document.documentElement.classList.remove("tm-dark"), p({ theme: (t == null ? void 0 : t.theme) === "dark" ? "dark" : "light" });
  }, [t == null ? void 0 : t.theme]), useEffect(() => {
    const m = !(t != null && t.primaryColor) || (t == null ? void 0 : t.primaryColor.toLowerCase()) === S2.primaryColor;
    document.documentElement.style.setProperty("--tms-colors-primary-btn-text-dark", m ? "#121212" : "#ffffff"), document.documentElement.style.setProperty("--tms-colors-primary", cn(m ? "#121212" : t.primaryColor)), document.documentElement.style.setProperty("--tms-colors-primary-dark", m ? "#ffffffe9" : t.primaryColor);
  }, [t == null ? void 0 : t.primaryColor]);
}
function cn(s) {
  if (!/^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/.test(s))
    throw new Error("Invalid hex color format");
  s = s.replace(/^#/, "");
  let A = parseInt(s, 16), u = A >> 16 & 255, p = A >> 8 & 255, t = A & 255;
  return `${u} ${p} ${t}`;
}
function Dn({ children: s, ...A }) {
  return jsxs(Re, { children: [jsx(an, { otherProps: A }), jsx(rn, {}), s] });
}
function an({ otherProps: s }) {
  return H0(s), M0(), on(s), null;
}
function Fn() {
  return H(U);
}
function Hn() {
  return H(O);
}
function Jn() {
  const s = hA();
  return {
    switchChainType: s.switchChainType,
    disconnect: s.disconnect,
    switchChain: s.switchChain
  };
}
const ExternalWallets = ({ chainName: s, onError: A }) => {
  const u = _0(), p = $0(s), t = async (l) => {
    try {
      await u(l);
    } catch (m) {
      A == null || A(m);
    }
  };
  return /* @__PURE__ */ jsxs("div", { className: "pt-10 text-accent-primary", children: [
    /* @__PURE__ */ jsx(Text, { className: "mb-4", children: "More wallets with Tomo Connect" }),
    /* @__PURE__ */ jsx("div", { className: "grid grid-cols-3 items-center justify-between gap-6 rounded border border-secondary-strokeLight p-6 md:grid-cols-7", children: (p || []).map((l) => {
      var m;
      return /* @__PURE__ */ jsxs(
        "button",
        {
          disabled: !l.isInstall,
          className: twJoin("flex flex-col items-center gap-2.5", l.isInstall ? "opacity-100" : "opacity-50"),
          onClick: () => t(l),
          "data-testid": `tomo-wallet-option-${s}_${(m = l.name) == null ? void 0 : m.toLowerCase()}`,
          children: [
            /* @__PURE__ */ jsx("img", { className: "size-10 object-contain", src: l.img, alt: l.name }),
            /* @__PURE__ */ jsx(Text, { className: "whitespace-nowrap leading-none", variant: "body2", children: l.name })
          ]
        },
        l.id
      );
    }) })
  ] });
};
class Wallet {
  constructor({ id: A, origin: u, name: p, icon: t, docs: l, networks: m, provider: b, label: k }) {
    Ci(this, "id");
    Ci(this, "origin");
    Ci(this, "name");
    Ci(this, "icon");
    Ci(this, "docs");
    Ci(this, "networks");
    Ci(this, "provider", null);
    Ci(this, "_label");
    Ci(this, "account", null);
    this.id = A, this.origin = u, this.name = p, this.icon = t, this.docs = l, this.networks = m, this.provider = b, this._label = k;
  }
  get installed() {
    return !!this.provider;
  }
  get label() {
    return this._label ?? (this.installed ? "Installed" : "");
  }
  async connect() {
    if (!this.provider)
      throw Error("Provider not found");
    await this.provider.connectWallet();
    const [A, u] = await Promise.all([this.provider.getAddress(), this.provider.getPublicKeyHex()]);
    return this.account = { address: A, publicKeyHex: u }, this;
  }
  clone() {
    return new Wallet({
      id: this.id,
      origin: this.origin,
      name: this.name,
      icon: this.icon,
      docs: this.docs,
      networks: this.networks,
      provider: this.provider
    });
  }
}
let createNanoEvents = () => ({
  emit(s, ...A) {
    for (let u = this.events[s] || [], p = 0, t = u.length; p < t; p++)
      u[p](...A);
  },
  events: {},
  on(s, A) {
    var u;
    return ((u = this.events)[s] || (u[s] = [])).push(A), () => {
      var p;
      this.events[s] = (p = this.events[s]) == null ? void 0 : p.filter((t) => A !== t);
    };
  }
});
const ERROR_CODES = {
  // ===== General/Common Errors =====
  UNKNOWN_ERROR: "UNKNOWN_ERROR",
  // Fallback
  INVALID_PARAMS: "INVALID_PARAMS",
  // Validation error
  CONNECTION_FAILED: "CONNECTION_FAILED",
  // Connection error
  METHOD_NOT_IMPLEMENTED: "METHOD_NOT_IMPLEMENTED",
  // Unimplemented feature
  MAX_ITERATION_EXCEEDED: "MAX_ITERATION_EXCEEDED",
  // Exceeded allowed iterations
  // ===== Wallet Extension/Provider =====
  EXTENSION_NOT_FOUND: "EXTENSION_NOT_FOUND",
  // Extension missing
  EXTENSION_CONTEXT_INVALIDATED: "EXTENSION_CONTEXT_INVALIDATED",
  // Context invalidated
  CONNECTION_REJECTED: "CONNECTION_REJECTED",
  // User rejected
  CONNECTION_CANCELED: "CONNECTION_CANCELED",
  // User canceled
  CHAIN_ID_NOT_INITIALIZED: "CHAIN_ID_NOT_INITIALIZED",
  // Chain ID missing
  RPC_URL_NOT_INITIALIZED: "RPC_URL_NOT_INITIALIZED",
  // RPC URL missing
  FAILED_TO_ADD_CHAIN: "FAILED_TO_ADD_CHAIN",
  // Add chain failed
  FAILED_TO_GET_KEY: "FAILED_TO_GET_KEY",
  // Key fetch failed
  WALLET_INITIALIZATION_FAILED: "WALLET_INITIALIZATION_FAILED",
  // Wallet initialization failed
  WALLET_NOT_CONNECTED: "WALLET_NOT_CONNECTED",
  // Not connected
  INCOMPATIBLE_WALLET_VERSION: "INCOMPATIBLE_WALLET_VERSION",
  // Version mismatch
  NETWORK_NOT_ENABLED_IN_WALLET: "NETWORK_NOT_ENABLED_IN_WALLET",
  // Network not enabled
  // ===== Bitcoin/PSBT/Address =====
  INVALID_PUBLIC_KEY: "INVALID_PUBLIC_KEY",
  // Invalid public key
  ADDRESS_GENERATION_FAILED: "ADDRESS_GENERATION_FAILED",
  // Address generation failed
  UNSUPPORTED_NETWORK: "UNSUPPORTED_NETWORK",
  // Network unsupported
  INVALID_ADDRESS_PREFIX: "INVALID_ADDRESS_PREFIX",
  // Address prefix invalid
  MISSING_PSBT_HEX: "MISSING_PSBT_HEX",
  // PSBT hex missing
  PSBT_HEX_REQUIRED: "PSBT_HEX_REQUIRED",
  // PSBT hex required
  PSBTS_HEXES_REQUIRED: "PSBTS_HEXES_REQUIRED",
  // Multiple PSBT hexes required
  SIGNATURE_EXTRACT_ERROR: "SIGNATURE_EXTRACT_ERROR",
  // Signature extraction failed
  GENERATION_ERROR: "GENERATION_ERROR",
  // General generation error
  ADDRESS_NOT_FOUND: "ADDRESS_NOT_FOUND",
  // Address not found
  PUBLIC_KEY_NOT_FOUND: "PUBLIC_KEY_NOT_FOUND",
  // Public key not found
  EMPTY_WITNESS_STACK: "EMPTY_WITNESS_STACK",
  // Witness stack is empty
  // ===== QR/Hardware Wallet =====
  QR_READ_ERROR: "QR_READ_ERROR",
  // QR read failed
  QR_SCAN_ERROR: "QR_SCAN_ERROR",
  // QR scan failed
  // ===== Inscriptions/Network =====
  INSCRIPTIONS_UNSUPPORTED_NETWORK: "INSCRIPTIONS_UNSUPPORTED_NETWORK",
  // Inscriptions unsupported
  INSCRIPTION_FETCH_ERROR: "INSCRIPTION_FETCH_ERROR"
  // Inscription fetch failed
};
class WalletError extends Error {
  constructor({ code: u, message: p, wallet: t, version: l, chainId: m }, b) {
    super(p, b);
    Ci(this, "code");
    Ci(this, "wallet");
    Ci(this, "version");
    Ci(this, "chainId");
    this.code = u, this.wallet = t, this.version = l, this.chainId = m;
  }
}
class WalletConnector {
  constructor(A, u, p, t, l) {
    Ci(this, "_connectedWallet", null);
    Ci(this, "_ee", createNanoEvents());
    this.id = A, this.name = u, this.icon = p, this.wallets = t, this.config = l;
  }
  get connectedWallet() {
    return this._connectedWallet;
  }
  async connect(A) {
    try {
      const u = typeof A == "string" ? this.wallets.find((p) => p.id === A) : A;
      if (!u)
        throw new WalletError({
          code: ERROR_CODES.EXTENSION_NOT_FOUND,
          message: "Wallet not found"
        });
      return this._ee.emit("connecting", `Connecting ${u.name}`), await u.connect(), this._connectedWallet = u, this._ee.emit("connect", this._connectedWallet), this.connectedWallet;
    } catch (u) {
      return this._ee.emit("error", u), null;
    }
  }
  async disconnect() {
    if (this._connectedWallet) {
      const A = this._connectedWallet.provider;
      if (A != null && A.disconnect && typeof A.disconnect == "function")
        try {
          await A.disconnect();
        } catch {
        }
      this._ee.emit("disconnect", this._connectedWallet), this._connectedWallet = null;
    }
  }
  clone() {
    return new WalletConnector(this.id, this.name, this.icon, this.wallets, this.config);
  }
  on(A, u) {
    return this._ee.on(A, u);
  }
}
var Network = /* @__PURE__ */ ((s) => (s.MAINNET = "mainnet", s.TESTNET = "testnet", s.SIGNET = "signet", s))(Network || {});
const defaultWalletGetter = (s) => (A) => A[s], createWallet = async ({ metadata: s, context: A, config: u }) => {
  const {
    id: p,
    wallet: t,
    name: l,
    icon: m,
    docs: b = "",
    networks: k = [],
    createProvider: C,
    label: B
  } = s, Q = {
    id: p,
    name: "",
    icon: "",
    origin: null,
    provider: null,
    docs: b,
    networks: k,
    label: B
  };
  if (t) {
    const P = typeof t == "string" ? defaultWalletGetter(t) : t;
    Q.origin = await P(A, u) ?? null, Q.provider = Q.origin ? C(Q.origin, u) : null;
  } else
    Q.origin = null, Q.provider = C(null, u);
  return typeof l == "string" ? Q.name = l ?? "" : Q.name = Q.origin ? await l(Q.origin, u) : "", typeof m == "string" ? Q.icon = m ?? "" : Q.icon = Q.origin ? await m(Q.origin, u) : "", new Wallet(Q);
}, createExternalWallet = ({ id: s, name: A, icon: u, provider: p }) => new Wallet({
  id: s,
  origin: null,
  name: A,
  icon: u,
  docs: "",
  networks: [Network.MAINNET, Network.SIGNET],
  provider: p
}), createWalletConnector = async ({
  persistent: s,
  metadata: A,
  context: u,
  config: p,
  accountStorage: t,
  disabledWallets: l
}) => {
  const m = [], b = s ? t.get(A.chain) : void 0;
  for (const P of A.wallets)
    l != null && l.includes(P.id) || m.push(
      await createWallet({
        metadata: P,
        context: u,
        config: p
      })
    );
  const k = m.find((P) => P.id === "injectable" && P.installed), C = m.filter(
    (P) => P.name.toLowerCase() !== (k == null ? void 0 : k.name.toLowerCase()) || P.id === "injectable"
  ), B = new WalletConnector(A.chain, A.name, A.icon, C, p);
  if (A.chain !== "ETH" && b && m.some((P) => P.id === b))
    try {
      await B.connect(b);
    } catch (P) {
      console.error({ error: P });
    }
  return B;
}, icon$3 = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20id='Layer_1'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20800%20800'%3e%3cdefs%3e%3cstyle%3e.cls-1{fill:%23ce6533;fill-rule:evenodd;}%3c/style%3e%3c/defs%3e%3cpath%20class='cls-1'%20d='M66.5,198.56c-3.27-8.85-1.09-18.79,5.58-25.47l90.82-90.82c6.67-6.67,16.62-8.85,25.46-5.59l193.65,71.14c4.76,1.75,7.92,6.28,7.92,11.35v42.4c0,3.21-1.27,6.28-3.54,8.55l-47.14,47.13c-3.33,3.34-8.3,4.43-12.73,2.79l-52.02-19.18-57.16-21.09c-4.83-1.79-9.55,2.92-7.76,7.76l40.27,109.18c1.63,4.43,.55,9.4-2.79,12.73l-41.91,41.89c-4.72,4.72-4.72,12.38,0,17.1l42.13,42.13c3.34,3.34,4.43,8.31,2.79,12.73l-40.27,109.17c-1.79,4.84,2.92,9.55,7.76,7.76l109.18-40.28c4.43-1.63,9.4-.54,12.73,2.79l46.91,46.91c2.27,2.27,3.54,5.34,3.54,8.55v42.41c0,5.06-3.15,9.59-7.9,11.34l-193.42,71.36c-8.85,3.27-18.8,1.08-25.47-5.59l-90.83-90.83c-6.67-6.67-8.85-16.61-5.58-25.47l71.11-192.77c1.99-5.4,1.99-11.34,0-16.74L66.5,198.56Z'/%3e%3cpath%20class='cls-1'%20d='M733.5,601.44c3.27,8.85,1.09,18.79-5.58,25.47l-90.82,90.83c-6.67,6.67-16.61,8.85-25.46,5.59l-193.65-71.14c-4.76-1.75-7.92-6.28-7.92-11.35v-42.4c0-3.21,1.27-6.28,3.54-8.55l47.14-47.13c3.33-3.34,8.3-4.43,12.73-2.79l52.02,19.18,57.16,21.09c4.83,1.79,9.54-2.92,7.76-7.76l-40.27-109.18c-1.63-4.43-.55-9.4,2.79-12.73l41.91-41.89c4.72-4.72,4.72-12.38,0-17.1l-42.13-42.13c-3.34-3.34-4.43-8.31-2.79-12.73l40.27-109.17c1.79-4.84-2.92-9.55-7.76-7.76l-109.18,40.28c-4.43,1.63-9.4,.54-12.73-2.79l-46.91-46.91c-2.27-2.27-3.54-5.34-3.54-8.55v-42.41c0-5.06,3.15-9.59,7.9-11.34l193.42-71.36c8.85-3.27,18.79-1.08,25.47,5.59l90.82,90.83c6.68,6.67,8.86,16.61,5.59,25.47l-71.11,192.77c-2,5.4-2,11.34,0,16.74l71.34,193.37h0Z'/%3e%3c/svg%3e", metadata$g = {
  id: "injectable",
  name: (s) => {
    var A;
    return (A = s.getWalletProviderName) == null ? void 0 : A.call(s);
  },
  icon: (s) => {
    var A;
    return (A = s.getWalletProviderIcon) == null ? void 0 : A.call(s);
  },
  docs: "",
  wallet: "bbnwallet",
  createProvider: (s) => s,
  networks: [Network.MAINNET, Network.SIGNET],
  label: "Injectable"
}, logo$8 = "data:image/svg+xml,%3csvg%20width='100'%20height='101'%20viewBox='0%200%20100%20101'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_408_204)'%3e%3cpath%20d='M0%2050.5C0%2032.9984%200%2024.2475%203.40605%2017.5628C6.40209%2011.6827%2011.1827%206.90209%2017.0628%203.90605C23.7475%200.5%2032.4984%200.5%2050%200.5C67.5016%200.5%2076.2525%200.5%2082.9372%203.90605C88.8173%206.90209%2093.5979%2011.6827%2096.594%2017.5628C100%2024.2475%20100%2032.9984%20100%2050.5C100%2068.0016%20100%2076.7525%2096.594%2083.4372C93.5979%2089.3173%2088.8173%2094.0979%2082.9372%2097.094C76.2525%20100.5%2067.5016%20100.5%2050%20100.5C32.4984%20100.5%2023.7475%20100.5%2017.0628%2097.094C11.1827%2094.0979%206.40209%2089.3173%203.40605%2083.4372C0%2076.7525%200%2068.0016%200%2050.5Z'%20fill='%2314AFEB'/%3e%3cpath%20d='M52.0838%2032.7979C52.6512%2038.5974%2052.9348%2041.4973%2054.4549%2043.6237C55.1062%2044.5349%2055.9095%2045.3275%2056.8295%2045.9663C58.9765%2047.4571%2061.88%2047.7013%2067.6865%2048.1896L70.1416%2048.3958V52.6003L67.6865%2052.8064C61.88%2053.2947%2058.9765%2053.539%2056.8295%2055.0298C55.9095%2055.6686%2055.1062%2056.461%2054.4549%2057.3722C52.9348%2059.4986%2052.6512%2062.3986%2052.0838%2068.1981H47.9162C47.3488%2062.3986%2047.0652%2059.4986%2045.5451%2057.3722C44.8938%2056.461%2044.0905%2055.6686%2043.1705%2055.0298C41.0235%2053.539%2038.12%2053.2947%2032.3135%2052.8064L29.8584%2052.6003V48.3958L32.3135%2048.1896C38.12%2047.7013%2041.0235%2047.4571%2043.1705%2045.9663C44.0905%2045.3275%2044.8938%2044.5349%2045.5451%2043.6237C47.0652%2041.4973%2047.3488%2038.5974%2047.9162%2032.7979H52.0838Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M50%2011.4355C82.168%2011.4355%2089.0625%2018.3301%2089.0625%2050.498C89.0625%2082.666%2082.168%2089.5605%2050%2089.5605C17.832%2089.5605%2010.9375%2082.666%2010.9375%2050.498C10.9375%2018.3301%2017.832%2011.4355%2050%2011.4355ZM75.5299%2024.9354C66.0693%2015.475%2046.9628%2019.243%2032.8541%2033.3516C18.7454%2047.4603%2014.9774%2066.5673%2024.438%2076.0279C33.8986%2085.4883%2053.005%2081.7204%2067.1137%2067.6117C81.2224%2053.503%2084.9904%2034.396%2075.5299%2024.9354Z'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_408_204'%3e%3crect%20width='100'%20height='101'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", WALLET_PROVIDER_NAME$a = "Keplr";
class KeplrProvider {
  constructor(A, u) {
    Ci(this, "walletInfo");
    Ci(this, "chainId");
    Ci(this, "rpc");
    Ci(this, "chainData");
    Ci(this, "on", (A, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$a
        });
      A === "accountChanged" && window.addEventListener("keplr_keystorechange", u);
    });
    Ci(this, "off", (A, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$a
        });
      A === "accountChanged" && window.removeEventListener("keplr_keystorechange", u);
    });
    if (this.keplr = A, !A)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "Keplr extension not found",
        wallet: WALLET_PROVIDER_NAME$a
      });
    this.chainId = u.chainId, this.rpc = u.rpc, this.chainData = u.chainData;
  }
  async connectWallet() {
    if (!this.chainId || !this.rpc || !this.keplr)
      throw new WalletError({
        code: ERROR_CODES.WALLET_INITIALIZATION_FAILED,
        message: `Keplr provider initialization failed: Missing ${this.chainId ? this.rpc ? "Keplr extension" : "RPC URL" : "Chain ID"}`,
        wallet: WALLET_PROVIDER_NAME$a
      });
    try {
      await this.keplr.enable(this.chainId);
    } catch (t) {
      if (t != null && t.message.includes(this.chainId))
        try {
          await this.keplr.experimentalSuggestChain(this.chainData), await this.keplr.enable(this.chainId);
        } catch {
          throw new WalletError({
            code: ERROR_CODES.FAILED_TO_ADD_CHAIN,
            message: "Failed to add BBN chain",
            wallet: WALLET_PROVIDER_NAME$a
          });
        }
      else
        throw t != null && t.message.includes("rejected") ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "Keplr wallet connection request rejected",
          wallet: WALLET_PROVIDER_NAME$a
        }) : t != null && t.message.includes("context invalidated") ? new WalletError({
          code: ERROR_CODES.EXTENSION_CONTEXT_INVALIDATED,
          message: "Keplr extension context invalidated",
          wallet: WALLET_PROVIDER_NAME$a
        }) : new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: (t == null ? void 0 : t.message) || "Failed to connect to Keplr",
          wallet: WALLET_PROVIDER_NAME$a
        });
    }
    const A = await this.keplr.getKey(this.chainId);
    if (!A)
      throw new WalletError({
        code: ERROR_CODES.WALLET_INITIALIZATION_FAILED,
        message: "Failed to get Keplr key",
        wallet: WALLET_PROVIDER_NAME$a
      });
    const { bech32Address: u, pubKey: p } = A;
    if (u && p)
      this.walletInfo = {
        publicKeyHex: Buffer$1.from(A.pubKey).toString("hex"),
        address: u
      };
    else
      throw new WalletError({
        code: ERROR_CODES.CONNECTION_FAILED,
        message: "Could not connect to Keplr",
        wallet: WALLET_PROVIDER_NAME$a
      });
  }
  async getAddress() {
    if (!this.walletInfo)
      throw new WalletError({
        code: ERROR_CODES.WALLET_NOT_CONNECTED,
        message: "Wallet not connected",
        wallet: WALLET_PROVIDER_NAME$a
      });
    return this.walletInfo.address;
  }
  async getPublicKeyHex() {
    if (!this.walletInfo)
      throw new WalletError({
        code: ERROR_CODES.WALLET_NOT_CONNECTED,
        message: "Wallet not connected",
        wallet: WALLET_PROVIDER_NAME$a
      });
    return this.walletInfo.publicKeyHex;
  }
  async getWalletProviderName() {
    return WALLET_PROVIDER_NAME$a;
  }
  async getWalletProviderIcon() {
    return logo$8;
  }
  async getOfflineSigner() {
    if (!this.keplr || !this.chainId)
      throw new WalletError({
        code: ERROR_CODES.WALLET_INITIALIZATION_FAILED,
        message: this.keplr ? "Chain ID is not initialized" : "Keplr extension not found",
        wallet: WALLET_PROVIDER_NAME$a
      });
    try {
      return this.keplr.getOfflineSigner(this.chainId);
    } catch {
      throw new WalletError({
        code: ERROR_CODES.WALLET_INITIALIZATION_FAILED,
        message: "Failed to get offline signer",
        wallet: WALLET_PROVIDER_NAME$a
      });
    }
  }
  async getOfflineSignerAuto() {
    if (!this.keplr || !this.chainId)
      throw new WalletError({
        code: ERROR_CODES.WALLET_INITIALIZATION_FAILED,
        message: this.keplr ? "Chain ID is not initialized" : "Keplr extension not found",
        wallet: WALLET_PROVIDER_NAME$a
      });
    try {
      return this.keplr.getOfflineSignerAuto(this.chainId);
    } catch {
      throw new WalletError({
        code: ERROR_CODES.UNKNOWN_ERROR,
        // Or a more specific one if available
        message: "Failed to get offline signer auto",
        wallet: WALLET_PROVIDER_NAME$a
      });
    }
  }
}
const metadata$f = {
  id: "keplr",
  name: WALLET_PROVIDER_NAME$a,
  icon: logo$8,
  docs: "https://www.keplr.app/",
  wallet: () => buildExports$1.Keplr.getKeplr(),
  createProvider: (s, A) => new KeplrProvider(s, A),
  networks: [Network.MAINNET, Network.SIGNET]
}, logo$7 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='58'%20height='58'%3e%3cg%20fill='none'%20fill-rule='nonzero'%3e%3cpath%20fill='%2324A95A'%20stroke='%23138D3E'%20stroke-width='.039'%20d='M51.466%2036.118c0%204.001-2.44%206.816-6.403%208.631-3.963%201.816-9.446%202.631-15.522%202.631-6.077%200-11.595-.815-15.594-2.63-3.999-1.816-6.474-4.631-6.474-8.632%200-4.002%202.46-7.625%206.44-10.248%203.982-2.623%209.482-4.245%2015.556-4.245%206.075%200%2011.575%201.626%2015.556%204.25%203.981%202.625%206.441%206.248%206.441%2010.243Z'/%3e%3cpath%20fill='%2332DA6D'%20stroke='%23138D3E'%20stroke-width='.039'%20d='m35.608%2013.791.012.003.007-.009A7.686%207.686%200%200%201%2041.555%2011c4.236%200%207.675%203.421%207.675%207.634%200%201.385-.37%202.671-1.009%203.788l-.005.009.004.01a9.644%209.644%200%200%201%20.94%204.13c0%203.711-2.198%207.072-5.753%209.505-3.555%202.434-8.468%203.939-13.893%203.939-5.426%200-10.339-1.505-13.894-3.939-3.555-2.433-5.752-5.794-5.752-9.506%200-1.442.327-2.829.939-4.13l.004-.009-.005-.009a7.583%207.583%200%200%201-1.01-3.788c0-4.213%203.44-7.634%207.676-7.634a7.73%207.73%200%200%201%205.928%202.785l.007.01.012-.004a27.43%2027.43%200%200%201%206.095-.665c2.121%200%204.172.24%206.094.665Z'/%3e%3cpath%20fill='%23FFF'%20d='M16.845%2022.88c2.597%200%204.703-2.094%204.703-4.677%200-2.583-2.106-4.677-4.703-4.677-2.597%200-4.702%202.094-4.702%204.677%200%202.583%202.105%204.677%204.702%204.677ZM41.932%2022.88c2.597%200%204.702-2.094%204.702-4.677%200-2.583-2.105-4.677-4.702-4.677-2.598%200-4.703%202.094-4.703%204.677%200%202.583%202.105%204.677%204.703%204.677Z'/%3e%3cpath%20fill='%2332DA6D'%20stroke='%23138D3E'%20stroke-width='.039'%20d='M4.032%2044.13a.163.163%200%200%200%20.018-.008l-.002-.004-.004-.01-.017-.046-.066-.174a70.962%2070.962%200%200%201-1.02-2.947c-.6-1.87-1.295-4.301-1.669-6.54-.187-1.12-.293-2.192-.268-3.122.025-.93.181-1.716.52-2.266.337-.55.855-.865%201.608-.856.754.01%201.746.347%203.027%201.108%207.702%204.573%209.453%2012.176%209.866%2015.688.113.98-.676%201.85-1.676%201.85H2.308c-.794%200-1.084-1.037-.39-1.438l2.123-1.219.015-.008-.006-.016-.018.007ZM54.276%2044.123l.018.006a.481.481%200%200%201-.018-.006v-.001l.002-.003.003-.011.016-.045a44.607%2044.607%200%200%200%20.276-.83c.183-.56.433-1.356.705-2.291.543-1.871%201.17-4.302%201.507-6.541.169-1.12.265-2.192.242-3.122-.023-.93-.165-1.716-.47-2.267a1.677%201.677%200%200%200-.587-.637%201.587%201.587%200%200%200-.867-.218c-.681.01-1.577.346-2.736%201.107-6.946%204.573-8.541%2012.19-8.897%2015.69-.1.982.606%201.849%201.505%201.849h10.887c.352%200%20.596-.258.672-.569.077-.31-.014-.67-.326-.87l-1.932-1.241Zm0%200-.005.014.013.009%201.924%201.218-1.932-1.241Z'/%3e%3cpath%20fill='%23092511'%20d='M16.893%2021.02a2.805%202.805%200%201%200%200-5.61%202.805%202.805%200%200%200%200%205.61ZM41.98%2021.02a2.805%202.805%200%201%200%200-5.61%202.805%202.805%200%200%200%200%205.61ZM36.998%2029.488a7.536%207.536%200%200%201-10.976%206.042%207.534%207.534%200%200%201-4.037-7.334l7.507.646%207.506.646Z'/%3e%3c/g%3e%3c/svg%3e", WALLET_PROVIDER_NAME$9 = "Leap";
class LeapProvider {
  constructor(A, u) {
    Ci(this, "walletInfo");
    Ci(this, "chainId");
    Ci(this, "rpc");
    Ci(this, "chainData");
    Ci(this, "on", (A, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$9
        });
      A === "accountChanged" && window.addEventListener("leap_keystorechange", u);
    });
    Ci(this, "off", (A, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$9
        });
      A === "accountChanged" && window.removeEventListener("leap_keystorechange", u);
    });
    if (this.wallet = A, !A)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "Leap extension not found",
        wallet: WALLET_PROVIDER_NAME$9
      });
    this.chainId = u.chainId, this.rpc = u.rpc, this.chainData = u.chainData;
  }
  async connectWallet() {
    if (!this.chainId)
      throw new WalletError({
        code: ERROR_CODES.CHAIN_ID_NOT_INITIALIZED,
        message: "Chain ID is not initialized",
        wallet: WALLET_PROVIDER_NAME$9
      });
    if (!this.rpc)
      throw new WalletError({
        code: ERROR_CODES.RPC_URL_NOT_INITIALIZED,
        message: "RPC URL is not initialized",
        wallet: WALLET_PROVIDER_NAME$9
      });
    if (!this.wallet)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "Leap extension not found",
        wallet: WALLET_PROVIDER_NAME$9
      });
    try {
      await this.wallet.enable(this.chainId);
    } catch (t) {
      if (t != null && t.message.includes(this.chainId) || t != null && t.message.includes("chain id"))
        try {
          await this.wallet.experimentalSuggestChain(this.chainData), await this.wallet.enable(this.chainId);
        } catch {
          throw new WalletError({
            code: ERROR_CODES.FAILED_TO_ADD_CHAIN,
            message: "Failed to add BBN chain",
            wallet: WALLET_PROVIDER_NAME$9
          });
        }
      else
        throw t != null && t.message.includes("rejected") ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "Leap wallet connection request rejected",
          wallet: WALLET_PROVIDER_NAME$9
        }) : t != null && t.message.includes("context invalidated") ? new WalletError({
          code: ERROR_CODES.EXTENSION_CONTEXT_INVALIDATED,
          message: "Leap extension context invalidated",
          wallet: WALLET_PROVIDER_NAME$9
        }) : new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: (t == null ? void 0 : t.message) || "Failed to connect to Leap",
          wallet: WALLET_PROVIDER_NAME$9
        });
    }
    const A = await this.wallet.getKey(this.chainId);
    if (!A)
      throw new WalletError({
        code: ERROR_CODES.FAILED_TO_GET_KEY,
        message: "Failed to get Leap key",
        wallet: WALLET_PROVIDER_NAME$9
      });
    const { bech32Address: u, pubKey: p } = A;
    if (u && p)
      this.walletInfo = {
        publicKeyHex: Buffer$1.from(A.pubKey).toString("hex"),
        address: u
      };
    else
      throw new WalletError({
        code: ERROR_CODES.CONNECTION_FAILED,
        message: "Could not connect to Leap",
        wallet: WALLET_PROVIDER_NAME$9
      });
  }
  async getAddress() {
    if (!this.walletInfo)
      throw new WalletError({
        code: ERROR_CODES.WALLET_NOT_CONNECTED,
        message: "Wallet not connected",
        wallet: WALLET_PROVIDER_NAME$9
      });
    return this.walletInfo.address;
  }
  async getPublicKeyHex() {
    if (!this.walletInfo)
      throw new WalletError({
        code: ERROR_CODES.WALLET_NOT_CONNECTED,
        message: "Wallet not connected",
        wallet: WALLET_PROVIDER_NAME$9
      });
    return this.walletInfo.publicKeyHex;
  }
  async getWalletProviderName() {
    return WALLET_PROVIDER_NAME$9;
  }
  async getWalletProviderIcon() {
    return logo$7;
  }
  async getOfflineSigner() {
    if (!this.wallet)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "Leap extension not found",
        wallet: WALLET_PROVIDER_NAME$9
      });
    if (!this.chainId)
      throw new WalletError({
        code: ERROR_CODES.CHAIN_ID_NOT_INITIALIZED,
        message: "Chain ID is not initialized",
        wallet: WALLET_PROVIDER_NAME$9
      });
    try {
      return this.wallet.getOfflineSigner(this.chainId);
    } catch {
      throw new WalletError({
        code: ERROR_CODES.UNKNOWN_ERROR,
        message: "Failed to get offline signer",
        wallet: WALLET_PROVIDER_NAME$9
      });
    }
  }
  async getOfflineSignerAuto() {
    if (!this.wallet)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "Leap extension not found",
        wallet: WALLET_PROVIDER_NAME$9
      });
    if (!this.chainId)
      throw new WalletError({
        code: ERROR_CODES.CHAIN_ID_NOT_INITIALIZED,
        message: "Chain ID is not initialized",
        wallet: WALLET_PROVIDER_NAME$9
      });
    try {
      return this.wallet.getOfflineSignerAuto(this.chainId);
    } catch {
      throw new WalletError({
        code: ERROR_CODES.UNKNOWN_ERROR,
        message: "Failed to get offline signer auto",
        wallet: WALLET_PROVIDER_NAME$9
      });
    }
  }
}
const metadata$e = {
  id: "leap",
  name: WALLET_PROVIDER_NAME$9,
  icon: logo$7,
  docs: "https://www.leapwallet.io/",
  wallet: "leap",
  createProvider: (s, A) => new LeapProvider(s, A),
  networks: [Network.MAINNET, Network.SIGNET]
}, logo$6 = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20width='225px'%20height='224px'%20viewBox='0%200%20225%20224'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3ctitle%3eokx%3c/title%3e%3cg%20id='Page-1'%20stroke='none'%20strokeWidth='1'%20fill='none'%20fill-rule='evenodd'%3e%3cg%20id='okx'%20transform='translate(0.401000,%200.006000)'%20fill='%23000000'%20fill-rule='nonzero'%3e%3cpath%20d='M144.382,74.667%20L79.673,74.667%20C76.924,74.667%2074.695,76.895%2074.695,79.644%20L74.695,144.354%20C74.695,147.103%2076.924,149.332%2079.673,149.332%20L144.382,149.332%20C147.131,149.332%20149.36,147.103%20149.36,144.354%20L149.36,79.644%20C149.36,76.895%20147.131,74.667%20144.382,74.667%20Z'%20id='Path'%3e%3c/path%3e%3cpath%20d='M69.687,0%20L4.978,0%20C2.229,0%200,2.228%200,4.978%20L0,69.687%20C0,72.436%202.229,74.665%204.978,74.665%20L69.687,74.665%20C72.437,74.665%2074.665,72.436%2074.665,69.687%20L74.665,4.978%20C74.665,2.228%2072.437,0%2069.687,0%20Z'%20id='Path'%3e%3c/path%3e%3cpath%20d='M219.017,0%20L154.307,0%20C151.558,0%20149.329,2.228%20149.329,4.978%20L149.329,69.687%20C149.329,72.436%20151.558,74.665%20154.307,74.665%20L219.017,74.665%20C221.766,74.665%20223.994,72.436%20223.994,69.687%20L223.994,4.978%20C223.994,2.228%20221.766,0%20219.017,0%20Z'%20id='Path'%3e%3c/path%3e%3cpath%20d='M69.687,149.328%20L4.978,149.328%20C2.229,149.328%200,151.556%200,154.305%20L0,219.015%20C0,221.764%202.229,223.993%204.978,223.993%20L69.687,223.993%20C72.437,223.993%2074.665,221.764%2074.665,219.015%20L74.665,154.305%20C74.665,151.556%2072.437,149.328%2069.687,149.328%20Z'%20id='Path'%3e%3c/path%3e%3cpath%20d='M219.017,149.328%20L154.307,149.328%20C151.558,149.328%20149.329,151.556%20149.329,154.305%20L149.329,219.015%20C149.329,221.764%20151.558,223.993%20154.307,223.993%20L219.017,223.993%20C221.766,223.993%20223.994,221.764%20223.994,219.015%20L223.994,154.305%20C223.994,151.556%20221.766,149.328%20219.017,149.328%20Z'%20id='Path'%3e%3c/path%3e%3c/g%3e%3c/g%3e%3c/svg%3e", WALLET_PROVIDER_NAME$8 = "OKX";
class OKXBabylonProvider {
  constructor(A, u) {
    Ci(this, "walletInfo");
    Ci(this, "chainId");
    Ci(this, "rpc");
    Ci(this, "chainData");
    Ci(this, "on", (A, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$8
        });
      A === "accountChanged" && window.addEventListener("okx_keystorechange", u);
    });
    Ci(this, "off", (A, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$8
        });
      A === "accountChanged" && window.removeEventListener("okx_keystorechange", u);
    });
    if (this.wallet = A, !A || !A.keplr)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "OKX Wallet extension not found",
        wallet: WALLET_PROVIDER_NAME$8
      });
    this.chainId = u.chainId, this.rpc = u.rpc, this.chainData = u.chainData;
  }
  async connectWallet() {
    if (!this.chainId)
      throw new WalletError({
        code: ERROR_CODES.CHAIN_ID_NOT_INITIALIZED,
        message: "Chain ID is not initialized",
        wallet: WALLET_PROVIDER_NAME$8
      });
    if (!this.rpc)
      throw new WalletError({
        code: ERROR_CODES.RPC_URL_NOT_INITIALIZED,
        message: "RPC URL is not initialized",
        wallet: WALLET_PROVIDER_NAME$8
      });
    if (!this.wallet.keplr)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "OKX Wallet extension not found",
        wallet: WALLET_PROVIDER_NAME$8
      });
    try {
      await this.wallet.keplr.enable(this.chainId);
    } catch (t) {
      if (t != null && t.message.includes(this.chainId))
        try {
          await this.wallet.keplr.experimentalSuggestChain(this.chainData), await this.wallet.keplr.enable(this.chainId);
        } catch {
          throw new WalletError({
            code: ERROR_CODES.FAILED_TO_ADD_CHAIN,
            message: "Failed to add BBN chain",
            wallet: WALLET_PROVIDER_NAME$8
          });
        }
      else
        throw t != null && t.message.includes("rejected") ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "OKX Wallet connection request rejected",
          wallet: WALLET_PROVIDER_NAME$8
        }) : t != null && t.message.includes("context invalidated") ? new WalletError({
          code: ERROR_CODES.EXTENSION_CONTEXT_INVALIDATED,
          message: "OKX Wallet extension context invalidated",
          wallet: WALLET_PROVIDER_NAME$8
        }) : new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: (t == null ? void 0 : t.message) || "Failed to connect to OKX Wallet",
          wallet: WALLET_PROVIDER_NAME$8
        });
    }
    const A = await this.wallet.keplr.getKey(this.chainId);
    if (!A)
      throw new WalletError({
        code: ERROR_CODES.FAILED_TO_GET_KEY,
        message: "Failed to get OKX Wallet key",
        wallet: WALLET_PROVIDER_NAME$8
      });
    const { bech32Address: u, pubKey: p } = A;
    if (u && p)
      this.walletInfo = {
        publicKeyHex: Buffer$1.from(A.pubKey).toString("hex"),
        address: u
      };
    else
      throw new WalletError({
        code: ERROR_CODES.CONNECTION_FAILED,
        message: "Could not connect to OKX Wallet",
        wallet: WALLET_PROVIDER_NAME$8
      });
  }
  async getAddress() {
    if (!this.walletInfo)
      throw new WalletError({
        code: ERROR_CODES.WALLET_NOT_CONNECTED,
        message: "Wallet not connected",
        wallet: WALLET_PROVIDER_NAME$8
      });
    return this.walletInfo.address;
  }
  async getPublicKeyHex() {
    if (!this.walletInfo)
      throw new WalletError({
        code: ERROR_CODES.WALLET_NOT_CONNECTED,
        message: "Wallet not connected",
        wallet: WALLET_PROVIDER_NAME$8
      });
    return this.walletInfo.publicKeyHex;
  }
  async getWalletProviderName() {
    return WALLET_PROVIDER_NAME$8;
  }
  async getWalletProviderIcon() {
    return logo$6;
  }
  async getOfflineSigner() {
    if (!this.wallet.keplr)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "OKX Wallet extension not found",
        wallet: WALLET_PROVIDER_NAME$8
      });
    if (!this.chainId)
      throw new WalletError({
        code: ERROR_CODES.CHAIN_ID_NOT_INITIALIZED,
        message: "Chain ID is not initialized",
        wallet: WALLET_PROVIDER_NAME$8
      });
    try {
      return this.wallet.keplr.getOfflineSigner(this.chainId);
    } catch {
      throw new WalletError({
        code: ERROR_CODES.UNKNOWN_ERROR,
        message: "Failed to get offline signer",
        wallet: WALLET_PROVIDER_NAME$8
      });
    }
  }
  async getOfflineSignerAuto() {
    if (!this.wallet.keplr)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "OKX Wallet extension not found",
        wallet: WALLET_PROVIDER_NAME$8
      });
    if (!this.chainId)
      throw new WalletError({
        code: ERROR_CODES.CHAIN_ID_NOT_INITIALIZED,
        message: "Chain ID is not initialized",
        wallet: WALLET_PROVIDER_NAME$8
      });
    try {
      return this.wallet.keplr.getOfflineSignerAuto(this.chainId);
    } catch {
      throw new WalletError({
        code: ERROR_CODES.UNKNOWN_ERROR,
        message: "Failed to get offline signer auto",
        wallet: WALLET_PROVIDER_NAME$8
      });
    }
  }
  getVersion() {
    return this.wallet.getVersion();
  }
}
const metadata$d = {
  id: "okx",
  name: WALLET_PROVIDER_NAME$8,
  icon: logo$6,
  docs: "https://www.okx.com/web3",
  wallet: "okxwallet",
  createProvider: (s, A) => new OKXBabylonProvider(s, A),
  networks: [Network.MAINNET, Network.SIGNET]
}, metadata$c = {
  chain: "BBN",
  name: "Babylon Chain",
  icon: icon$3,
  wallets: [metadata$d, metadata$g, metadata$f, metadata$e]
}, icon$2 = "data:image/svg+xml,%3csvg%20width='48'%20height='48'%20viewBox='0%200%2048%2048'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='48'%20height='48'%20rx='14'%20fill='%23FF573B'/%3e%3cpath%20d='M10%2029H38V33C38%2034.1046%2037.0714%2035%2035.9259%2035H12.0741C10.9286%2035%2010%2034.1046%2010%2033V29Z'%20fill='white'/%3e%3cpath%20d='M10%2021H38V27H10V21Z'%20fill='white'/%3e%3cpath%20d='M10%2015C10%2013.8954%2010.9286%2013%2012.0741%2013H35.9259C37.0714%2013%2038%2013.8954%2038%2015V19H10V15Z'%20fill='white'/%3e%3c/svg%3e", APPKIT_OPEN_EVENT = "babylon:open-appkit", APPKIT_BTC_CONNECTED_EVENT = "babylon:appkit-btc-connected";
let sharedBtcAppKitConfig = null;
function setSharedBtcAppKitConfig(s) {
  sharedBtcAppKitConfig = s;
}
function getSharedBtcAppKitConfig() {
  if (!sharedBtcAppKitConfig)
    throw new Error(
      "Shared BTC AppKit config not initialized. Make sure to call setSharedBtcAppKitConfig() in your app before using AppKit BTC."
    );
  return sharedBtcAppKitConfig;
}
function hasSharedBtcAppKitConfig() {
  return sharedBtcAppKitConfig !== null;
}
class AppKitBTCProvider {
  constructor(A) {
    Ci(this, "config");
    Ci(this, "address");
    Ci(this, "publicKey");
    Ci(this, "eventHandlers", /* @__PURE__ */ new Map());
    this.config = A;
  }
  /**
   * Get the shared AppKit config
   */
  getAppKitConfig() {
    if (!hasSharedBtcAppKitConfig())
      throw new Error(
        "AppKit BTC not initialized. Ensure AppKit modal is initialized at application startup by calling initializeAppKitModal() with btc config in your app's entry point."
      );
    return getSharedBtcAppKitConfig();
  }
  async connectWallet() {
    try {
      if (typeof window < "u") {
        window.dispatchEvent(new CustomEvent(APPKIT_OPEN_EVENT)), await new Promise((u, p) => {
          const t = setTimeout(() => {
            console.error("[AppKit Provider] Connection timeout after 60 seconds"), m(), p(new Error("Connection timeout"));
          }, 6e4), l = (b) => {
            var k;
            (k = b.detail) != null && k.address ? (m(), this.address = b.detail.address, this.publicKey = b.detail.publicKey, u()) : console.warn("[AppKit Provider] Event received but no address in detail");
          }, m = () => {
            clearTimeout(t), window.removeEventListener(APPKIT_BTC_CONNECTED_EVENT, l);
          };
          window.addEventListener(APPKIT_BTC_CONNECTED_EVENT, l);
        });
        return;
      }
      throw new Error("Window not available for AppKit modal");
    } catch (A) {
      throw console.error("[AppKit Provider] Failed to connect Bitcoin wallet:", A), new Error(`Failed to connect Bitcoin wallet: ${A instanceof Error ? A.message : "Unknown error"}`);
    }
  }
  async disconnect() {
    try {
      const { modal: A } = this.getAppKitConfig();
      await A.disconnect();
    } finally {
      this.address = void 0, this.publicKey = void 0;
    }
  }
  async getAddress() {
    var A;
    if (this.address)
      return this.address;
    if (hasSharedBtcAppKitConfig()) {
      const { adapter: u } = this.getAppKitConfig(), p = u.connections || [];
      if (p.length > 0 && ((A = p[0].account) != null && A.address) && (this.address = p[0].account.address, this.address))
        return this.address;
    }
    throw new Error("Bitcoin wallet not connected");
  }
  async getPublicKeyHex() {
    var A;
    if (this.publicKey)
      return this.publicKey;
    if (hasSharedBtcAppKitConfig()) {
      const { adapter: u } = this.getAppKitConfig(), p = u.connections || [];
      if (p.length > 0 && ((A = p[0].account) != null && A.publicKey) && (this.publicKey = p[0].account.publicKey, this.publicKey))
        return this.publicKey;
    }
    throw new Error("Bitcoin wallet not connected or public key not available");
  }
  async signPsbt(A, u) {
    try {
      const { modal: p } = this.getAppKitConfig(), t = await this.getAddress(), l = p.getProvider("bip122");
      if (!l)
        throw new Error("No wallet provider found for bip122 namespace");
      if (!l.signPSBT)
        throw new Error("Connected wallet does not support PSBT signing");
      const b = {
        psbt: srcExports.Psbt.fromHex(A).toBase64(),
        // ✅ Base64 format for AppKit
        signInputs: u != null && u.autoFinalized ? void 0 : {
          address: t,
          signingIndexes: [0]
          // Sign all inputs by default
        },
        broadcast: !1
      }, k = await l.signPSBT(b), C = typeof k == "string" ? k : (k == null ? void 0 : k.psbt) || k;
      return srcExports.Psbt.fromBase64(C).toHex();
    } catch (p) {
      throw console.error("[AppKit Provider] signPsbt failed:", p), new Error(`Failed to sign PSBT: ${p instanceof Error ? p.message : "Unknown error"}`);
    }
  }
  async signPsbts(A, u) {
    const p = [];
    for (let t = 0; t < A.length; t++) {
      const l = await this.signPsbt(A[t], u == null ? void 0 : u[t]);
      p.push(l);
    }
    return p;
  }
  async getNetwork() {
    return this.config.network;
  }
  async signMessage(A, u) {
    try {
      const { modal: p } = this.getAppKitConfig(), t = await this.getAddress(), l = p.getProvider("bip122");
      if (!l)
        throw new Error("No wallet provider found for bip122 namespace");
      if (!l.signMessage)
        throw new Error("Connected wallet does not support message signing");
      const b = {
        message: A,
        address: t,
        protocol: u === "bip322-simple" ? "bip322" : "ecdsa"
      };
      return await l.signMessage(b);
    } catch (p) {
      throw console.error("[AppKit Provider] signMessage failed:", p), new Error(`Failed to sign message: ${p instanceof Error ? p.message : "Unknown error"}`);
    }
  }
  on(A, u) {
    this.eventHandlers.has(A) || this.eventHandlers.set(A, /* @__PURE__ */ new Set()), this.eventHandlers.get(A).add(u);
  }
  off(A, u) {
    const p = this.eventHandlers.get(A);
    p && p.delete(u);
  }
  async getWalletProviderName() {
    return "AppKit Bitcoin";
  }
  async getWalletProviderIcon() {
    return icon$2;
  }
  async getInscriptions() {
    return [];
  }
  // Cleanup method for proper resource management
  destroy() {
    this.eventHandlers.clear();
  }
}
const WALLET_PROVIDER_NAME$7 = "AppKit", APPKIT_BTC_CONNECTOR_ID = "appkit-btc-connector", metadata$b = {
  id: APPKIT_BTC_CONNECTOR_ID,
  name: WALLET_PROVIDER_NAME$7,
  icon: icon$2,
  docs: "https://docs.reown.com/appkit/networks/bitcoin",
  // Don't check for browser global - AppKit is modal-based, not extension-based
  wallet: void 0,
  createProvider: (s, A) => new AppKitBTCProvider(A),
  networks: [Network.MAINNET, Network.SIGNET],
  label: "Connect BTC Wallet"
}, icon$1 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='64'%20height='64'%3e%3cpath%20fill='%23f7931a'%20d='M63.04%2039.741c-4.275%2017.143-21.638%2027.576-38.783%2023.301C7.12%2058.768-3.313%2041.404.962%2024.262%205.234%207.117%2022.597-3.317%2039.737.957c17.144%204.274%2027.576%2021.64%2023.302%2038.784z'/%3e%3cpath%20fill='%23FFF'%20d='M46.11%2027.441c.636-4.258-2.606-6.547-7.039-8.074l1.438-5.768-3.51-.875-1.4%205.616c-.924-.23-1.872-.447-2.814-.662l1.41-5.653-3.509-.875-1.439%205.766c-.764-.174-1.514-.346-2.242-.527l.004-.018-4.842-1.209-.934%203.75s2.605.597%202.55.634c1.422.355%201.68%201.296%201.636%202.042l-1.638%206.571c.098.025.225.061.365.117l-.37-.092-2.297%209.205c-.174.432-.615%201.08-1.609.834.035.051-2.552-.637-2.552-.637l-1.743%204.019%204.57%201.139c.85.213%201.682.436%202.502.646l-1.453%205.834%203.507.875%201.44-5.772c.957.26%201.887.5%202.797.726l-1.434%205.745%203.511.875%201.453-5.823c5.987%201.133%2010.49.676%2012.384-4.739%201.527-4.36-.076-6.875-3.226-8.515%202.294-.529%204.022-2.038%204.483-5.155zM38.086%2038.69c-1.085%204.36-8.426%202.003-10.806%201.412l1.928-7.729c2.38.594%2010.012%201.77%208.878%206.317zm1.086-11.312c-.99%203.966-7.1%201.951-9.082%201.457l1.748-7.01c1.982.494%208.365%201.416%207.334%205.553z'/%3e%3c/svg%3e", metadata$a = {
  id: "injectable",
  name: (s) => {
    var A;
    return (A = s.getWalletProviderName) == null ? void 0 : A.call(s);
  },
  icon: (s) => {
    var A;
    return (A = s.getWalletProviderIcon) == null ? void 0 : A.call(s);
  },
  docs: "",
  wallet: "btcwallet",
  createProvider: (s) => s,
  networks: [Network.MAINNET, Network.SIGNET],
  label: "Injectable"
}, logo$5 = "data:image/svg+xml,%3csvg%20width='160'%20height='160'%20viewBox='0%200%20160%20160'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M30%2025H90L50%20110H20L30%2025Z'%20fill='black'/%3e%3cpath%20d='M130%20135L70%20135L110%2050L140%2050L130%20135Z'%20fill='%23F5870A'/%3e%3c/svg%3e", byteToHex = [];
for (let s = 0; s < 256; ++s)
  byteToHex.push((s + 256).toString(16).slice(1));
function unsafeStringify(s, A = 0) {
  return (byteToHex[s[A + 0]] + byteToHex[s[A + 1]] + byteToHex[s[A + 2]] + byteToHex[s[A + 3]] + "-" + byteToHex[s[A + 4]] + byteToHex[s[A + 5]] + "-" + byteToHex[s[A + 6]] + byteToHex[s[A + 7]] + "-" + byteToHex[s[A + 8]] + byteToHex[s[A + 9]] + "-" + byteToHex[s[A + 10]] + byteToHex[s[A + 11]] + byteToHex[s[A + 12]] + byteToHex[s[A + 13]] + byteToHex[s[A + 14]] + byteToHex[s[A + 15]]).toLowerCase();
}
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    getRandomValues = crypto.getRandomValues.bind(crypto);
  }
  return getRandomValues(rnds8);
}
const randomUUID = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), native = { randomUUID };
function v4(s, A, u) {
  var t;
  if (native.randomUUID && !s)
    return native.randomUUID();
  s = s || {};
  const p = s.random ?? ((t = s.rng) == null ? void 0 : t.call(s)) ?? rng();
  if (p.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return p[6] = p[6] & 15 | 64, p[8] = p[8] & 63 | 128, unsafeStringify(p);
}
class BIP322 {
  /**
   * Compute the message hash as specified in the BIP-322.
   * The standard is specified in BIP-340 as:
   *      The function hashtag(x) where tag is a UTF-8 encoded tag name and x is a byte array returns the 32-byte hash SHA256(SHA256(tag) || SHA256(tag) || x).
   * @param message Message to be hashed
   * @returns Hashed message
   */
  static hashMessage(A) {
    const { sha256: u } = srcExports.crypto, p = u(this.TAG);
    return u(Buffer.concat([p, p, Buffer.from(A)]));
  }
  /**
   * Build a to_spend transaction using simple signature in accordance to the BIP-322.
   * @param message Message to be signed using BIP-322
   * @param scriptPublicKey The script public key for the signing wallet
   * @returns Bitcoin transaction that correspond to the to_spend transaction
   */
  static buildToSpendTx(A, u) {
    const p = new srcExports.Psbt();
    p.setVersion(0), p.setLocktime(0);
    const t = this.hashMessage(A), l = 0, m = 32, b = new Uint8Array([l, m]), k = new Uint8Array(b.length + t.length);
    return k.set(b), k.set(t, b.length), p.addInput({
      hash: "0".repeat(64),
      // vin[0].prevout.hash = 0000...000
      index: 4294967295,
      // vin[0].prevout.n = 0xFFFFFFFF
      sequence: 0,
      // vin[0].nSequence = 0
      finalScriptSig: Buffer.from(k),
      // vin[0].scriptSig = OP_0 PUSH32[ message_hash ]
      witnessScript: Buffer.from([])
      // vin[0].scriptWitness = []
    }), p.addOutput({
      value: 0,
      // vout[0].nValue = 0
      script: u
      // vout[0].scriptPubKey = message_challenge
    }), p.extractTransaction();
  }
  /**
   * Build a to_sign transaction using simple signature in accordance to the BIP-322.
   * @param toSpendTxId Transaction ID of the to_spend transaction as constructed by buildToSpendTx
   * @param witnessScript The script public key for the signing wallet, or the redeemScript for P2SH-P2WPKH address
   * @param isRedeemScript Set to true if the provided witnessScript is a redeemScript for P2SH-P2WPKH address, default to false
   * @param tapInternalKey Used to set the taproot internal public key of a taproot signing address when provided, default to undefined
   * @returns Ready-to-be-signed bitcoinjs.Psbt transaction
   */
  static buildToSignTx(A, u, p = !1, t) {
    const l = new srcExports.Psbt();
    return l.setVersion(0), l.setLocktime(0), l.addInput({
      hash: A,
      // vin[0].prevout.hash = to_spend.txid
      index: 0,
      // vin[0].prevout.n = 0
      sequence: 0,
      // vin[0].nSequence = 0
      witnessUtxo: {
        script: u,
        value: 0
      }
    }), p && l.updateInput(0, {
      redeemScript: u
    }), t && l.updateInput(0, {
      tapInternalKey: t
    }), l.addOutput({
      value: 0,
      // vout[0].nValue = 0
      script: Buffer.from([106])
      // vout[0].scriptPubKey = OP_RETURN
    }), l;
  }
  /**
   * Encode witness stack in a signed BIP-322 PSBT into its base-64 encoded format.
   * @param signedPsbt Signed PSBT
   * @returns Base-64 encoded witness data
   */
  static encodeWitness(A) {
    const u = A.data.inputs[0].finalScriptWitness;
    if (!u)
      throw new WalletError({
        code: ERROR_CODES.EMPTY_WITNESS_STACK,
        message: "Cannot encode empty witness stack."
      });
    return u.toString("base64");
  }
}
// BIP322 message tag
Ci(BIP322, "TAG", Buffer.from("BIP0322-signed-message"));
const HEX_STRINGS = "0123456789abcdefABCDEF";
HEX_STRINGS.split("").map((s) => s.codePointAt(0));
Array(256).fill(!0).map((s, A) => {
  const u = String.fromCodePoint(A), p = HEX_STRINGS.indexOf(u);
  return p < 0 ? void 0 : p < 16 ? p : p - 6;
});
new TextEncoder();
new TextDecoder("ascii");
function compare(s, A) {
  const u = Math.min(s.length, A.length);
  for (let p = 0; p < u; ++p)
    if (s[p] !== A[p])
      return s[p] < A[p] ? -1 : 1;
  return s.length === A.length ? 0 : s.length > A.length ? 1 : -1;
}
const ERROR_BAD_PRIVATE = 0, ERROR_BAD_POINT = 1, ERROR_BAD_TWEAK = 2, ERROR_BAD_HASH = 3, ERROR_BAD_SIGNATURE = 4, ERROR_BAD_EXTRA_DATA = 5, ERROR_BAD_PARITY = 6, ERROR_BAD_RECOVERY_ID = 7, ERRORS_MESSAGES = {
  [ERROR_BAD_PRIVATE.toString()]: "Expected Private",
  [ERROR_BAD_POINT.toString()]: "Expected Point",
  [ERROR_BAD_TWEAK.toString()]: "Expected Tweak",
  [ERROR_BAD_HASH.toString()]: "Expected Hash",
  [ERROR_BAD_SIGNATURE.toString()]: "Expected Signature",
  [ERROR_BAD_EXTRA_DATA.toString()]: "Expected Extra Data (32 bytes)",
  [ERROR_BAD_PARITY.toString()]: "Expected Parity (1 | 0)",
  [ERROR_BAD_RECOVERY_ID.toString()]: "Bad Recovery Id"
};
function throwError(s) {
  const A = ERRORS_MESSAGES[s.toString()] || `Unknow error code: ${s}`;
  throw new TypeError(A);
}
const $_validate_error_js = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ERROR_BAD_EXTRA_DATA,
  ERROR_BAD_HASH,
  ERROR_BAD_PARITY,
  ERROR_BAD_POINT,
  ERROR_BAD_PRIVATE,
  ERROR_BAD_RECOVERY_ID,
  ERROR_BAD_SIGNATURE,
  ERROR_BAD_TWEAK,
  throwError
}, Symbol.toStringTag, { value: "Module" })), PRIVATE_KEY_SIZE = 32, PUBLIC_KEY_COMPRESSED_SIZE = 33, PUBLIC_KEY_UNCOMPRESSED_SIZE = 65, X_ONLY_PUBLIC_KEY_SIZE = 32, TWEAK_SIZE = 32, HASH_SIZE = 32, EXTRA_DATA_SIZE = 32, SIGNATURE_SIZE = 64, BN32_ZERO = new Uint8Array(32), BN32_N = new Uint8Array([
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  254,
  186,
  174,
  220,
  230,
  175,
  72,
  160,
  59,
  191,
  210,
  94,
  140,
  208,
  54,
  65,
  65
]), BN32_P_MINUS_N = new Uint8Array([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  69,
  81,
  35,
  25,
  80,
  183,
  95,
  196,
  64,
  45,
  161,
  114,
  47,
  201,
  186,
  238
]);
function isUint8Array(s) {
  return s instanceof Uint8Array;
}
function cmpBN32(s, A) {
  for (let u = 0; u < 32; ++u)
    if (s[u] !== A[u])
      return s[u] < A[u] ? -1 : 1;
  return 0;
}
function isZero(s) {
  return cmpBN32(s, BN32_ZERO) === 0;
}
function isPrivate$1(s) {
  return isUint8Array(s) && s.length === PRIVATE_KEY_SIZE && cmpBN32(s, BN32_ZERO) > 0 && cmpBN32(s, BN32_N) < 0;
}
function isPoint$2(s) {
  return isUint8Array(s) && (s.length === PUBLIC_KEY_COMPRESSED_SIZE || s.length === PUBLIC_KEY_UNCOMPRESSED_SIZE || s.length === X_ONLY_PUBLIC_KEY_SIZE);
}
function isXOnlyPoint$1(s) {
  return isUint8Array(s) && s.length === X_ONLY_PUBLIC_KEY_SIZE;
}
function isDERPoint(s) {
  return isUint8Array(s) && (s.length === PUBLIC_KEY_COMPRESSED_SIZE || s.length === PUBLIC_KEY_UNCOMPRESSED_SIZE);
}
function isPointCompressed$1(s) {
  return isUint8Array(s) && s.length === PUBLIC_KEY_COMPRESSED_SIZE;
}
function isTweak(s) {
  return isUint8Array(s) && s.length === TWEAK_SIZE && cmpBN32(s, BN32_N) < 0;
}
function isHash(s) {
  return isUint8Array(s) && s.length === HASH_SIZE;
}
function isExtraData(s) {
  return s === void 0 || isUint8Array(s) && s.length === EXTRA_DATA_SIZE;
}
function isSignature(s) {
  return isUint8Array(s) && s.length === 64 && cmpBN32(s.subarray(0, 32), BN32_N) < 0 && cmpBN32(s.subarray(32, 64), BN32_N) < 0;
}
function isSigrLessThanPMinusN(s) {
  return isUint8Array(s) && s.length === 64 && cmpBN32(s.subarray(0, 32), BN32_P_MINUS_N) < 0;
}
function validateParity(s) {
  s !== 0 && s !== 1 && throwError(ERROR_BAD_PARITY);
}
function validatePrivate(s) {
  isPrivate$1(s) || throwError(ERROR_BAD_PRIVATE);
}
function validatePoint(s) {
  isPoint$2(s) || throwError(ERROR_BAD_POINT);
}
function validateXOnlyPoint(s) {
  isXOnlyPoint$1(s) || throwError(ERROR_BAD_POINT);
}
function validateTweak(s) {
  isTweak(s) || throwError(ERROR_BAD_TWEAK);
}
function validateHash(s) {
  isHash(s) || throwError(ERROR_BAD_HASH);
}
function validateExtraData(s) {
  isExtraData(s) || throwError(ERROR_BAD_EXTRA_DATA);
}
function validateSignature(s) {
  isSignature(s) || throwError(ERROR_BAD_SIGNATURE);
}
function validateSignatureCustom(s) {
  s() || throwError(ERROR_BAD_SIGNATURE);
}
function validateSignatureNonzeroRS(s) {
  isZero(s.subarray(0, 32)) && throwError(ERROR_BAD_SIGNATURE), isZero(s.subarray(32, 64)) && throwError(ERROR_BAD_SIGNATURE);
}
function validateSigrPMinusN(s) {
  isSigrLessThanPMinusN(s) || throwError(ERROR_BAD_RECOVERY_ID);
}
function get4RandomBytes() {
  const s = new Uint8Array(4);
  if (typeof crypto > "u")
    throw new Error("The crypto object is unavailable. This may occur if your environment does not support the Web Cryptography API.");
  return crypto.getRandomValues(s), s;
}
function generateInt32() {
  const s = get4RandomBytes();
  return (s[0] << 24) + (s[1] << 16) + (s[2] << 8) + s[3];
}
const $_rand_js = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generateInt32
}, Symbol.toStringTag, { value: "Module" }));
var bufferView, base64ReverseLookup = new Uint8Array(
  123
  /*'z'+1*/
);
for (var i = 25; i >= 0; --i)
  base64ReverseLookup[48 + i] = 52 + i, base64ReverseLookup[65 + i] = i, base64ReverseLookup[97 + i] = 26 + i;
base64ReverseLookup[43] = 62;
base64ReverseLookup[47] = 63;
function base64DecodeToExistingUint8Array(s, A, u) {
  for (var p, t, l = 0, m = A, b = u.length, k = A + (b * 3 >> 2) - (u[b - 2] == "=") - (u[b - 1] == "="); l < b; l += 4)
    p = base64ReverseLookup[u.charCodeAt(l + 1)], t = base64ReverseLookup[u.charCodeAt(l + 2)], s[m++] = base64ReverseLookup[u.charCodeAt(l)] << 2 | p >> 4, m < k && (s[m++] = p << 4 | t >> 2), m < k && (s[m++] = t << 6 | base64ReverseLookup[u.charCodeAt(l + 3)]);
}
function initActiveSegments(s) {
  base64DecodeToExistingUint8Array(bufferView, 655360, "AQAAAAQAAAAEAAAAAgAAAAEAAAAEAAAABAAAAAM="), base64DecodeToExistingUint8Array(bufferView, 655716, "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"), base64DecodeToExistingUint8Array(bufferView, 689368, "BgAAAAAAAAAG"), base64DecodeToExistingUint8Array(bufferView, 689392, "BgAAAAAAAAByZXQASW52YWxpZCBmbGFncwBzZWxmIHRlc3QgZmFpbGVkAEZvciB0aGlzIHNhbXBsZSwgdGhpcyA2My1ieXRlIHN0cmluZyB3aWxsIGJlIHVzZWQgYXMgaW5wdXQgZGF0YQAoZmxhZ3MgJiBTRUNQMjU2SzFfRkxBR1NfVFlQRV9NQVNLKSA9PSBTRUNQMjU2SzFfRkxBR1NfVFlQRV9DT01QUkVTU0lPTgBzZWNrZXkgIT0gTlVMTAB4b25seV9wdWJrZXkgIT0gTlVMTABvdXRwdXRfcHVia2V5ICE9IE5VTEwAaW50ZXJuYWxfcHVia2V5ICE9IE5VTEwAb3V0cHV0ICE9IE5VTEwAaW5wdXQgIT0gTlVMTABwdWJub25jZXMgIT0gTlVMTABrZXlwYWlyICE9IE5VTEwAc2lnaW4gIT0gTlVMTABvdXRwdXRsZW4gIT0gTlVMTABzaWcgIT0gTlVMTABzaWduYXR1cmUgIT0gTlVMTABwdWJub25jZSAhPSBOVUxMAHJlY2lkICE9IE5VTEwAcHVibm9uY2VzW2ldICE9IE5VTEwAb3V0cHV0NjQgIT0gTlVMTABpbnB1dDY0ICE9IE5VTEwAc2lnNjQgIT0gTlVMTABzZWNrZXkzMiAhPSBOVUxMAHR3ZWFrZWRfcHVia2V5MzIgIT0gTlVMTABvdXRwdXQzMiAhPSBOVUxMAGlucHV0MzIgIT0gTlVMTAB0d2VhazMyICE9IE5VTEwAbXNnaGFzaDMyICE9IE5VTEwAcmVjaWQgPj0gMCAmJiByZWNpZCA8PSAzAG4gPj0gMQBtc2cgIT0gTlVMTCB8fCBtc2dsZW4gPT0gMABydXN0c2VjcDI1NmsxX3YwXzhfMV9lY211bHRfZ2VuX2NvbnRleHRfaXNfYnVpbHQoJmN0eC0+ZWNtdWx0X2dlbl9jdHgpACFydXN0c2VjcDI1NmsxX3YwXzhfMV9mZV9pc196ZXJvKCZnZS0+eCkAKm91dHB1dGxlbiA+PSAoKGZsYWdzICYgU0VDUDI1NksxX0ZMQUdTX0JJVF9DT01QUkVTU0lPTikgPyAzM3UgOiA2NXUpAAAAAAAABgAAAAAAAAAEAAAAAAAAAAE="), base64DecodeToExistingUint8Array(bufferView, 690288, "8Ip4y7ruCCsFKuBwjzL6HlDFxCGqdyul27QGoupr40JBQTbQjF7SP+6AIr2ac7sq6/////////8="), base64DecodeToExistingUint8Array(bufferView, 690353, "AQAAAAAAAMFOd6qZAPI0AAEAAAAAAACYF/gWW4ECAJ+VjeLcsg0A/JsCBwuHDgBcKQZaxboLANz5fma+eQAAuNQQ+4/QBwDEmUFVaIoEALQX/agIEQ4AwL9P2lVGDACjJnfaOkg="), base64DecodeToExistingUint8Array(bufferView, 690464, "L/z///7///8="), base64DecodeToExistingUint8Array(bufferView, 690497, "AQAAAAAAAM/K2i3i9scngA=="), base64DecodeToExistingUint8Array(bufferView, 690576, "w+S/Cql/VG8oiA4B1n5D5A=="), base64DecodeToExistingUint8Array(bufferView, 690608, "LFaxPajNZddtNHQHxQooiv7///////////////////8xsNtFmiCT6H/K6HEUiqo9FeuEkuSQbOjNa9SnIdKGMHF/xIqutHEVxgb1nawIEiLE5L8KqX9UbyiIDgHWfkPkcr0jG3yWAt94ZoEg6iIuElpkEogCHCal4DBcwEytY1NCSVAwMzQwL25vbmNl"), base64DecodeToExistingUint8Array(bufferView, 690752, "MIQK");
}
function wasm2js_trap() {
  throw new Error("abort");
}
function asmFunc(s) {
  var A = new ArrayBuffer(720896), u = new Int8Array(A), p = new Int16Array(A), t = new Int32Array(A), l = new Uint8Array(A), m = new Uint16Array(A), b = Math.imul, k = Math.clz32, C = s["./rand.js"], B = C.generateInt32, Q = s["./validate_error.js"], P = Q.throwError, x = 655360, M = 690820, F = 655584, le = 690949, ge = 690885, pe = 690917, Ie = 690788, be = 655649, Pe = 655681, Te = 690981, Qe = 691052, xe = 691056, Ee = 0;
  function He(v, d) {
    v = v | 0, d = d | 0;
    var I = 0, n = 0, a = 0;
    a = x - 128 | 0, x = a, v = t[v >> 2];
    e: {
      t: {
        r: {
          n: {
            if (I = t[d + 24 >> 2], !(I & 16)) {
              if (I & 32)
                break n;
              v = t[v >> 2], I = (v | 0) >= 0, v = ve(I ? v : 0 - v | 0, I ? 0 : 0 - ((v >> 31) + ((v | 0) != 0) | 0) | 0, I, d);
              break r;
            }
            for (v = t[v >> 2], I = 0; n = v & 15, u[(I + a | 0) + 127 | 0] = n + (n >>> 0 < 10 ? 48 : 87), I = I - 1 | 0, n = v >>> 0 > 15, v = v >>> 4 | 0, !!n; )
              ;
            if (I + 128 >>> 0 >= 129)
              break t;
            v = we(d, 1, 2, (I + a | 0) + 128 | 0, 0 - I | 0);
            break r;
          }
          for (v = t[v >> 2], I = 0; n = v & 15, u[(I + a | 0) + 127 | 0] = n + (n >>> 0 < 10 ? 48 : 55), I = I - 1 | 0, n = v >>> 0 > 15, v = v >>> 4 | 0, !!n; )
            ;
          if (I + 128 >>> 0 >= 129)
            break e;
          v = we(d, 1, 2, (I + a | 0) + 128 | 0, 0 - I | 0);
        }
        return x = a + 128 | 0, v | 0;
      }
      wasm2js_trap();
    }
    wasm2js_trap();
  }
  function ve(v, d, I, n) {
    var a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0;
    if (Me = x - 48 | 0, x = Me, L = 39, !(!d & v >>> 0 < 1e4))
      for (; ; ) {
        cr = (Me + 9 | 0) + L | 0, dr = cr - 4 | 0, E = v, Be = 0, tr = 0;
        e: {
          t: {
            if (!d) {
              v = (E >>> 0) / 1e4 | 0;
              break t;
            }
            if (T = 51 - k(d) | 0, a = 0 - T | 0, he = T & 63, v = he & 31, he >>> 0 >= 32 ? he = d >>> v | 0 : (Be = d >>> v | 0, he = ((1 << v) - 1 & d) << 32 - v | E >>> v), a = a & 63, v = a & 31, a >>> 0 >= 32 ? (a = E << v, v = 0) : (a = (1 << v) - 1 & E >>> 32 - v | d << v, v = E << v), T)
              for (; gr = Be << 1 | he >>> 31, or = he << 1 | a >>> 31, Ir = 0 - (gr + (or >>> 0 > 9999) | 0) >> 31, Be = Ir & 1e4, he = or - Be | 0, Be = gr - (Be >>> 0 > or >>> 0) | 0, a = a << 1 | v >>> 31, v = v << 1 | tr, tr = Ir & 1, T = T - 1 | 0, !!T; )
                ;
            Ee = a << 1 | v >>> 31, v = v << 1 | tr;
            break e;
          }
          Ee = 0;
        }
        if (he = Ee, a = pn(v, he, 55536, 0) + E | 0, Be = ((a & 65535) >>> 0) / 100 | 0, T = (Be << 1) + 655718 | 0, T = l[T | 0] | l[T + 1 | 0] << 8, u[dr | 0] = T, u[dr + 1 | 0] = T >>> 8, T = cr - 2 | 0, a = ((b(Be, -100) + a & 65535) << 1) + 655718 | 0, a = l[a | 0] | l[a + 1 | 0] << 8, u[T | 0] = a, u[T + 1 | 0] = a >>> 8, L = L - 4 | 0, E = !d & E >>> 0 > 99999999 | (d | 0) != 0, d = he, !E)
          break;
      }
    v >>> 0 > 99 && (L = L - 2 | 0, d = L + (Me + 9 | 0) | 0, he = v, v = ((v & 65535) >>> 0) / 100 | 0, E = ((he + b(v, -100) & 65535) << 1) + 655718 | 0, E = l[E | 0] | l[E + 1 | 0] << 8, u[d | 0] = E, u[d + 1 | 0] = E >>> 8);
    e: {
      if (v >>> 0 >= 10) {
        L = L - 2 | 0, d = L + (Me + 9 | 0) | 0, v = (v << 1) + 655718 | 0, v = l[v | 0] | l[v + 1 | 0] << 8, u[d | 0] = v, u[d + 1 | 0] = v >>> 8;
        break e;
      }
      L = L - 1 | 0, u[L + (Me + 9 | 0) | 0] = v + 48;
    }
    return v = we(n, I, 0, (Me + 9 | 0) + L | 0, 39 - L | 0), x = Me + 48 | 0, v;
  }
  function we(v, d, I, n, a) {
    var E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0;
    Be = 655716;
    e: {
      if (d) {
        E = t[v + 24 >> 2], d = E & 1, Me = d ? 43 : 1114112, T = d + a | 0;
        break e;
      }
      E = t[v + 24 >> 2], Me = 45, T = a + 1 | 0;
    }
    e: {
      if (!(E & 4)) {
        Be = 0;
        break e;
      }
      t: {
        if (!I || (L = I & 3, !L))
          break t;
        for (d = 655716; he = he + (u[d | 0] > -65) | 0, d = d + 1 | 0, L = L - 1 | 0, !!L; )
          ;
      }
      T = T + he | 0;
    }
    e: {
      t: {
        if (!t[v + 8 >> 2]) {
          if (d = 1, T = t[v >> 2], v = t[v + 4 >> 2], jr(T, v, Me, Be, I))
            break t;
          break e;
        }
        r: {
          n: {
            i: {
              s: {
                if (L = t[v + 12 >> 2], L >>> 0 > T >>> 0) {
                  if (E & 8)
                    break r;
                  switch (E = L - T | 0, T = E, d = l[v + 32 | 0], d = (d | 0) == 3 ? 1 : d, d - 1 | 0) {
                    case 1:
                      break i;
                    case 0:
                      break s;
                    default:
                      break n;
                  }
                }
                if (d = 1, T = t[v >> 2], v = t[v + 4 >> 2], jr(T, v, Me, Be, I))
                  break t;
                break e;
              }
              T = 0, d = E;
              break n;
            }
            d = E >>> 1 | 0, T = E + 1 >>> 1 | 0;
          }
          d = d + 1 | 0, E = t[v + 4 >> 2], he = t[v + 28 >> 2], L = t[v >> 2];
          n: {
            for (; ; ) {
              if (d = d - 1 | 0, !d)
                break n;
              if (Qn[t[E + 16 >> 2]](L, he) | 0)
                break;
            }
            return 1;
          }
          if (d = 1, (he | 0) == 1114112 || jr(L, E, Me, Be, I) || Qn[t[E + 12 >> 2]](L, n, a) | 0)
            break t;
          d = 0;
          n: {
            for (; ; ) {
              if (v = T, (v | 0) == (d | 0))
                break n;
              if (d = d + 1 | 0, !!(Qn[t[E + 16 >> 2]](L, he) | 0))
                break;
            }
            v = d - 1 | 0;
          }
          d = v >>> 0 < T >>> 0;
          break t;
        }
        if (tr = t[v + 28 >> 2], t[v + 28 >> 2] = 48, or = l[v + 32 | 0], d = 1, u[v + 32 | 0] = 1, E = t[v >> 2], he = t[v + 4 >> 2], jr(E, he, Me, Be, I))
          break t;
        d = (L - T | 0) + 1 | 0;
        r: {
          for (; ; ) {
            if (d = d - 1 | 0, !d)
              break r;
            if (Qn[t[he + 16 >> 2]](E, 48) | 0)
              break;
          }
          return 1;
        }
        if (d = 1, Qn[t[he + 12 >> 2]](E, n, a) | 0)
          break t;
        return u[v + 32 | 0] = or, t[v + 28 >> 2] = tr, 0;
      }
      return d;
    }
    return Qn[t[v + 12 >> 2]](T, n, a) | 0;
  }
  function Ce(v, d) {
    v = v | 0, d = d | 0;
    var I = 0, n = 0, a = 0;
    a = x - 128 | 0, x = a, v = t[v >> 2];
    e: {
      t: {
        r: {
          n: {
            if (I = t[d + 24 >> 2], !(I & 16)) {
              if (I & 32)
                break n;
              v = ve(t[v >> 2], 0, 1, d);
              break r;
            }
            for (v = t[v >> 2], I = 0; n = v & 15, u[(I + a | 0) + 127 | 0] = n + (n >>> 0 < 10 ? 48 : 87), I = I - 1 | 0, n = v >>> 0 > 15, v = v >>> 4 | 0, !!n; )
              ;
            if (I + 128 >>> 0 >= 129)
              break t;
            v = we(d, 1, 2, (I + a | 0) + 128 | 0, 0 - I | 0);
            break r;
          }
          for (v = t[v >> 2], I = 0; n = v & 15, u[(I + a | 0) + 127 | 0] = n + (n >>> 0 < 10 ? 48 : 55), I = I - 1 | 0, n = v >>> 0 > 15, v = v >>> 4 | 0, !!n; )
            ;
          if (I + 128 >>> 0 >= 129)
            break e;
          v = we(d, 1, 2, (I + a | 0) + 128 | 0, 0 - I | 0);
        }
        return x = a + 128 | 0, v | 0;
      }
      wasm2js_trap();
    }
    wasm2js_trap();
  }
  function Se(v) {
  }
  function Ne(v) {
    var d = 0, I = 0, n = 0, a = 0, E = 0;
    n = x - 32 | 0, x = n, d = v + 16 | 0, a = t[d + 4 >> 2], I = n + 8 | 0, E = I + 16 | 0, t[E >> 2] = t[d >> 2], t[E + 4 >> 2] = a, d = v + 8 | 0, a = t[d + 4 >> 2], I = I + 8 | 0, t[I >> 2] = t[d >> 2], t[I + 4 >> 2] = a, d = t[v + 4 >> 2], t[n + 8 >> 2] = t[v >> 2], t[n + 12 >> 2] = d, wasm2js_trap();
  }
  function rr() {
    var v = 0, d = 0, I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0, Xn = 0, Zn = 0, ni = 0, ai = 0, fi = 0, Ai = 0, yi = 0, Ii = 0, wi = 0, Bi = 0, Ti = 0, Oi = 0, Hi = 0, Xi = 0, Zi = 0, ts = 0, us = 0, hs = 0, ws = 0, ks = 0, Bs = 0, gs = 0, ps = 0;
    Ai = x - 32 | 0, x = Ai;
    e: {
      if (l[690756]) {
        ks = t[172762];
        break e;
      }
      for (t[Ai >> 2] = 192, t[Ai + 4 >> 2] = 192, v = x - 144 | 0, x = v, t[v + 104 >> 2] = 0, t[v + 108 >> 2] = 0, t[v + 32 >> 2] = 528734635, t[v + 36 >> 2] = 1541459225, t[v + 24 >> 2] = 1359893119, t[v + 28 >> 2] = -1694144372, t[v + 16 >> 2] = 1013904242, t[v + 20 >> 2] = -1521486534, t[v + 8 >> 2] = 1779033703, t[v + 12 >> 2] = -1150833019, d = v + 8 | 0, Tn(d, 689435, 63), Yn(d, v + 112 | 0); a = l[(v + 112 | 0) + n | 0] - l[n + 690288 | 0] | 0, !!(!a && (d = (n | 0) != 31, n = n + 1 | 0, d)); )
        ;
      a && dn(689418, 0), t[163880] = 0, t[163881] = 0, t[163878] = 1, t[163879] = 0, d = t[172349], t[163892] = t[172348], t[163893] = d, d = t[172559], t[163890] = t[172558], t[163891] = d, d = t[172595], t[163858] = t[172594], t[163859] = d, d = t[172597], t[163860] = t[172596], t[163861] = d, d = t[172599], t[163862] = t[172598], t[163863] = d, d = t[172601], t[163864] = t[172600], t[163865] = d, d = t[172603], t[163866] = t[172602], t[163867] = d, t[163882] = 0, t[163883] = 0, t[163884] = 0, t[163885] = 0, t[163886] = 0, t[163887] = 0, t[163888] = 0, t[163876] = 629725529, t[163877] = 243653, t[163874] = 632307772, t[163875] = 3389866, t[163872] = 1459808328, t[163873] = 3272439, t[163870] = -1430362568, t[163871] = 3896727, t[163868] = 82779140, t[163869] = 3682156, t[163856] = 0, t[163857] = 0, t[163850] = 1, t[163851] = 0, t[163854] = 0, t[163855] = 0, t[163852] = 0, t[163853] = 0, t[163894] = 0, t[163848] = 1, x = v + 144 | 0, ks = 655392, gs = 690756, ps = B() | 0, t[gs >> 2] = ps, gs = 690760, ps = B() | 0, t[gs >> 2] = ps, gs = 690764, ps = B() | 0, t[gs >> 2] = ps, gs = 690768, ps = B() | 0, t[gs >> 2] = ps, gs = 690772, ps = B() | 0, t[gs >> 2] = ps, gs = 690776, ps = B() | 0, t[gs >> 2] = ps, gs = 690780, ps = B() | 0, t[gs >> 2] = ps, gs = 690784, ps = B() | 0, t[gs >> 2] = ps, dr = x - 720 | 0, x = dr, t[163848] && (v = l[690760] | l[690761] << 8 | (l[690762] << 16 | l[690763] << 24), or = dr + 336 | 0, cr = or + 32 | 0, t[cr >> 2] = l[690756] | l[690757] << 8 | (l[690758] << 16 | l[690759] << 24), t[cr + 4 >> 2] = v, v = l[690768] | l[690769] << 8 | (l[690770] << 16 | l[690771] << 24), Me = or + 40 | 0, t[Me >> 2] = l[690764] | l[690765] << 8 | (l[690766] << 16 | l[690767] << 24), t[Me + 4 >> 2] = v, v = l[690776] | l[690777] << 8 | (l[690778] << 16 | l[690779] << 24), L = dr + 384 | 0, t[L >> 2] = l[690772] | l[690773] << 8 | (l[690774] << 16 | l[690775] << 24), t[L + 4 >> 2] = v, v = l[690784] | l[690785] << 8 | (l[690786] << 16 | l[690787] << 24), he = dr + 392 | 0, t[he >> 2] = l[690780] | l[690781] << 8 | (l[690782] << 16 | l[690783] << 24), t[he + 4 >> 2] = v, a = t[163850], E = a << 8 & 16711680 | a << 24, I = a >>> 8 | 0, d = t[163851], n = (I | d << 24) & 65280, a = a >>> 24 | 0, E = E | (n | (a | d << 8) & 255), v = d, n = (I | (v & 255) << 24) & -16777216, n = n | (a | (v & 16777215) << 8) & 16711680, Be = or + 24 | 0, t[Be >> 2] = v >>> 8 & 65280 | v >>> 24 | n, t[Be + 4 >> 2] = E, a = t[163852], E = a << 8 & 16711680 | a << 24, d = t[163853], n = (d << 24 | a >>> 8) & 65280, E = E | (n | (d << 8 | a >>> 24) & 255), v = d, n = ((v & 255) << 24 | a >>> 8) & -16777216, n = n | ((v & 16777215) << 8 | a >>> 24) & 16711680, tr = or + 16 | 0, t[tr >> 2] = v >>> 8 & 65280 | v >>> 24 | n, t[tr + 4 >> 2] = E, a = t[163856], E = a << 8 & 16711680 | a << 24, d = t[163857], n = (d << 24 | a >>> 8) & 65280, E = E | (n | (d << 8 | a >>> 24) & 255), v = d, n = ((v & 255) << 24 | a >>> 8) & -16777216, n = n | ((v & 16777215) << 8 | a >>> 24) & 16711680, I = dr, t[I + 336 >> 2] = v >>> 8 & 65280 | v >>> 24 | n, t[I + 340 >> 2] = E, a = t[163854], E = a << 8 & 16711680 | a << 24, d = t[163855], n = (d << 24 | a >>> 8) & 65280, E = E | (n | (d << 8 | a >>> 24) & 255), v = d, n = ((v & 255) << 24 | a >>> 8) & -16777216, n = n | ((v & 16777215) << 8 | a >>> 24) & 16711680, t[I + 344 >> 2] = v >>> 8 & 65280 | v >>> 24 | n, t[I + 348 >> 2] = E, Oi = I + 408 | 0, Ln(Oi, or, 64), t[he >> 2] = 0, t[he + 4 >> 2] = 0, t[L >> 2] = 0, t[L + 4 >> 2] = 0, t[Me >> 2] = 0, t[Me + 4 >> 2] = 0, t[cr >> 2] = 0, t[cr + 4 >> 2] = 0, t[Be >> 2] = 0, t[Be + 4 >> 2] = 0, t[tr >> 2] = 0, t[tr + 4 >> 2] = 0, t[I + 344 >> 2] = 0, t[I + 348 >> 2] = 0, t[I + 336 >> 2] = 0, t[I + 340 >> 2] = 0, yi = I + 480 | 0, Wn(Oi, yi), d = l[I + 497 | 0], v = d >>> 24 | 0, n = l[I + 498 | 0] | d << 8, d = v, hs = yi + 16 | 0, a = l[hs | 0], v = a >>> 16 | 0, n = a << 16 | n, a = v | d, d = l[I + 495 | 0], v = d >>> 8 | 0, n = n | d << 24, tr = l[I + 492 | 0], a = l[I + 494 | 0] | (v | a) | l[I + 493 | 0] << 8 | (tr & 15) << 16, d = l[I + 484 | 0], v = d >>> 24 | 0, T = l[I + 485 | 0] | d << 8, d = v, E = l[I + 483 | 0], v = E >>> 16 | 0, T = E << 16 | T, E = v | d, d = l[I + 482 | 0], v = d >>> 8 | 0, or = d << 24 | T, cr = l[I + 481 | 0] | (v | E) | l[I + 480 | 0] << 8, d = l[I + 491 | 0], v = d >>> 28 | 0, T = d << 4 | tr >>> 4, d = v, E = l[I + 490 | 0], v = E >>> 20 | 0, T = E << 12 | T, E = v | d, d = l[I + 489 | 0], v = d >>> 12 | 0, T = d << 20 | T, E = v | E, d = l[I + 488 | 0], v = d >>> 4 | 0, Me = d << 28 | T, L = v | E | l[I + 487 | 0] << 4 | l[I + 486 | 0] << 12, ws = yi + 24 | 0, d = l[ws | 0], v = d >>> 28 | 0, he = l[I + 505 | 0], T = d << 4 | he >>> 4, d = v, E = l[I + 503 | 0], v = E >>> 20 | 0, T = E << 12 | T, E = v | d, d = l[I + 502 | 0], v = d >>> 12 | 0, T = d << 20 | T, E = v | E, d = l[I + 501 | 0], v = d >>> 4 | 0, Be = d << 28 | T, $r = v | E | l[I + 500 | 0] << 4 | l[I + 499 | 0] << 12, tr = $r, d = l[I + 510 | 0], v = d >>> 24 | 0, T = l[I + 511 | 0] | d << 8, d = v, E = l[I + 509 | 0], v = E >>> 16 | 0, T = E << 16 | T, E = v | d, d = l[I + 508 | 0], v = d >>> 8 | 0, Zn = I + 520 | 0, Hi = Zn + 32 | 0, d = T | d << 24, he = l[I + 507 | 0] | (v | E) | l[I + 506 | 0] << 8 | (he & 15) << 16, v = !(or | (Me | (n | (d | Be))) | (cr | (L | (a | (he | tr))))) | (n & Be & Me) == -1 & (a & tr & L) == 1048575 & ((or | 0) == -1 & (cr | 0) == 65535) & ((he | 0) == 1048574 & d >>> 0 > 4294966318 | he >>> 0 > 1048574), E = v - 1 | 0, tr = E & or, t[Hi >> 2] = tr, T = cr, cr = 0 - !v | 0, T = T & cr, t[Hi + 4 >> 2] = T, Xi = Zn + 24 | 0, kn = E & Me, t[Xi >> 2] = kn, xn = L & cr, t[Xi + 4 >> 2] = xn, Zi = Zn + 16 | 0, Mr = n & E, t[Zi >> 2] = Mr, gr = a & cr, t[Zi + 4 >> 2] = gr, ts = Zn + 8 | 0, gn = E & Be, t[ts >> 2] = gn, Ir = cr & $r, t[ts + 4 >> 2] = Ir, E = d & E | v, t[I + 520 >> 2] = E, v = he & cr, $r = v, t[I + 524 >> 2] = v, or = I + 128 | 0, ni = E << 1, Un = v << 1 | E >>> 31, Ur(or, ni, Un, 0, 0, kn, xn, 0, 0), cr = I + 192 | 0, a = gn << 1, n = Ir << 1 | gn >>> 31, Ur(cr, a, n, 0, 0, Mr, gr, 0, 0), L = I + 320 | 0, Ur(L, tr, T, 0, 0, tr, T, 0, 0), he = I + 304 | 0, Ur(he, t[I + 320 >> 2], t[I + 324 >> 2], 0, 0, 15632, 16, 0, 0), d = tr, v = T << 1 | d >>> 31, Ii = I + 80 | 0, us = d << 1, Gn = v, Ur(Ii, us, v, 0, 0, E, $r, 0, 0), wi = I + 176 | 0, Ur(wi, a, n, 0, 0, kn, xn, 0, 0), Bi = I + 240 | 0, Ur(Bi, Mr, gr, 0, 0, Mr, gr, 0, 0), Me = I + 288 | 0, v = L + 8 | 0, Ur(Me, t[v >> 2], t[v + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ur(I, E, $r, 0, 0, E, $r, 0, 0), Bs = I + 160 | 0, Ur(Bs, us, Gn, 0, 0, gn, Ir, 0, 0), ai = I + 208 | 0, Ur(ai, Mr << 1, gr << 1 | Mr >>> 31, 0, 0, kn, xn, 0, 0), L = t[I + 132 >> 2], v = L + t[I + 196 >> 2] | 0, E = t[I + 128 >> 2], a = t[I + 192 >> 2], d = E + a | 0, n = t[I + 304 >> 2], $r = d + n | 0, a = d >>> 0 < a >>> 0 ? v + 1 | 0 : v, v = a + t[I + 308 >> 2] | 0, n = n >>> 0 > $r >>> 0 ? v + 1 | 0 : v, Be = (a | 0) == (n | 0) & d >>> 0 > $r >>> 0 | n >>> 0 < a >>> 0, v = he + 8 | 0, tr = t[v >> 2], T = t[v + 4 >> 2], E = (a | 0) == (L | 0) & d >>> 0 < E >>> 0 | a >>> 0 < L >>> 0, a = cr + 8 | 0, d = t[a >> 2], v = or + 8 | 0, he = d + t[v >> 2] | 0, v = t[v + 4 >> 2] + t[a + 4 >> 2] | 0, v = d >>> 0 > he >>> 0 ? v + 1 | 0 : v, d = E + he | 0, v = (d >>> 0 < he >>> 0 ? v + 1 | 0 : v) + T | 0, a = d, d = d + tr | 0, v = a >>> 0 > d >>> 0 ? v + 1 | 0 : v, a = d, d = d + Be | 0, v = a >>> 0 > d >>> 0 ? v + 1 | 0 : v, or = n, tr = d << 12 | n >>> 20, a = v, E = v << 12 | d >>> 20, Ti = t[I + 176 >> 2], d = t[I + 240 >> 2], Be = Ti + d | 0, fi = t[I + 180 >> 2], v = fi + t[I + 244 >> 2] | 0, v = d >>> 0 > Be >>> 0 ? v + 1 | 0 : v, d = t[I + 80 >> 2], T = d + Be | 0, L = v, v = v + t[I + 84 >> 2] | 0, v = d >>> 0 > T >>> 0 ? v + 1 | 0 : v, d = t[I + 288 >> 2], n = d + T | 0, he = v, v = v + t[I + 292 >> 2] | 0, d = d >>> 0 > n >>> 0 ? v + 1 | 0 : v, v = d + E | 0, jn = I + 16 | 0, tr = n + tr | 0, E = tr >>> 0 < n >>> 0 ? v + 1 | 0 : v, Bn = (d | 0) == (E | 0) & n >>> 0 > tr >>> 0 | d >>> 0 > E >>> 0, Xn = (d | 0) == (he | 0) & T >>> 0 > n >>> 0 | d >>> 0 < he >>> 0, v = Me + 8 | 0, xr = t[v >> 2], Wr = t[v + 4 >> 2], cr = (L | 0) == (he | 0) & T >>> 0 < Be >>> 0 | L >>> 0 > he >>> 0, v = Ii + 8 | 0, Me = t[v >> 2], he = t[v + 4 >> 2], T = (L | 0) == (fi | 0) & Be >>> 0 < Ti >>> 0 | L >>> 0 < fi >>> 0, n = Bi + 8 | 0, d = t[n >> 2], v = wi + 8 | 0, Be = d + t[v >> 2] | 0, v = t[v + 4 >> 2] + t[n + 4 >> 2] | 0, v = d >>> 0 > Be >>> 0 ? v + 1 | 0 : v, d = T + Be | 0, v = (d >>> 0 < Be >>> 0 ? v + 1 | 0 : v) + he | 0, n = d, d = d + Me | 0, v = n >>> 0 > d >>> 0 ? v + 1 | 0 : v, n = d, d = d + cr | 0, v = (n >>> 0 > d >>> 0 ? v + 1 | 0 : v) + Wr | 0, n = d, d = d + xr | 0, v = n >>> 0 > d >>> 0 ? v + 1 | 0 : v, n = d + Xn | 0, v = n >>> 0 < d >>> 0 ? v + 1 | 0 : v, a = a >>> 20 | 0, d = n + a | 0, v = a >>> 0 > d >>> 0 ? v + 1 | 0 : v, a = d, d = d + Bn | 0, v = a >>> 0 > d >>> 0 ? v + 1 | 0 : v, a = E, T = d << 12 | a >>> 20, n = v, Be = v << 12 | d >>> 20, xr = t[I + 164 >> 2], v = xr + t[I + 212 >> 2] | 0, Me = t[I + 160 >> 2], d = t[I + 208 >> 2], E = Me + d | 0, he = E, T = E + T | 0, d = d >>> 0 > E >>> 0 ? v + 1 | 0 : v, v = d + Be | 0, L = T << 4 & -16, E = T >>> 0 < E >>> 0 ? v + 1 | 0 : v, Be = (E << 4 | T >>> 28) & 16777215, cr = a, Ur(jn, L | a >>> 16 & 15, Be, 0, 0, 977, 1, 0, 0), Bn = t[I + 20 >> 2], v = Bn + t[I + 4 >> 2] | 0, Xn = t[I + 16 >> 2], a = t[I >> 2], Be = Xn + a | 0, t[I + 560 >> 2] = Be, a = a >>> 0 > Be >>> 0 ? v + 1 | 0 : v, t[I + 564 >> 2] = a & 1048575, Ii = I + 112 | 0, Ur(Ii, ni, Un, 0, 0, gn, Ir, 0, 0), wi = I + 224 | 0, Ur(wi, us, Gn, 0, 0, Mr, gr, 0, 0), Bi = I + 272 | 0, Ur(Bi, kn, xn, 0, 0, kn, xn, 0, 0), Ti = I - -64 | 0, Wr = Ti, L = (d | 0) == (E | 0) & T >>> 0 < he >>> 0 | d >>> 0 > E >>> 0, he = (d | 0) == (xr | 0) & he >>> 0 < Me >>> 0 | d >>> 0 < xr >>> 0, T = ai + 8 | 0, d = t[T >> 2], v = Bs + 8 | 0, Me = d + t[v >> 2] | 0, v = t[v + 4 >> 2] + t[T + 4 >> 2] | 0, v = d >>> 0 > Me >>> 0 ? v + 1 | 0 : v, T = he + Me | 0, v = T >>> 0 < Me >>> 0 ? v + 1 | 0 : v, n = n >>> 20 | 0, d = T + n | 0, v = n >>> 0 > d >>> 0 ? v + 1 | 0 : v, n = d, d = d + L | 0, v = n >>> 0 > d >>> 0 ? v + 1 | 0 : v, he = d << 12 | E >>> 20, T = v, E = v << 12 | d >>> 20, fi = t[I + 224 >> 2], d = t[I + 272 >> 2], xr = fi + d | 0, ai = t[I + 228 >> 2], v = ai + t[I + 276 >> 2] | 0, n = d >>> 0 > xr >>> 0 ? v + 1 | 0 : v, v = n + E | 0, Me = he + xr | 0, v = Me >>> 0 < xr >>> 0 ? v + 1 | 0 : v, he = v, Ur(Wr, Me, v & 1048575, 0, 0, 15632, 16, 0, 0), Be = (a | 0) == (Bn | 0) & Be >>> 0 < Xn >>> 0 | a >>> 0 < Bn >>> 0, E = I + 8 | 0, d = t[E >> 2], v = jn + 8 | 0, L = d + t[v >> 2] | 0, v = t[v + 4 >> 2] + t[E + 4 >> 2] | 0, v = d >>> 0 > L >>> 0 ? v + 1 | 0 : v, d = L + Be | 0, v = d >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = d << 12 | a >>> 20, E = v, Be = v << 12 | d >>> 20, Bn = t[I + 64 >> 2], d = t[I + 112 >> 2], Wr = Bn + d | 0, jn = t[I + 68 >> 2], v = jn + t[I + 116 >> 2] | 0, a = d >>> 0 > Wr >>> 0 ? v + 1 | 0 : v, v = a + Be | 0, L = L + Wr | 0, v = L >>> 0 < Wr >>> 0 ? v + 1 | 0 : v, t[I + 568 >> 2] = L, Be = v, t[I + 572 >> 2] = v & 1048575, Xn = I + 96 | 0, Ur(Xn, ni, Un, 0, 0, Mr, gr, 0, 0), ni = I + 144 | 0, Ur(ni, gn, Ir, 0, 0, gn, Ir, 0, 0), gn = I + 256 | 0, Ur(gn, us, Gn, 0, 0, kn, xn, 0, 0), Mr = I + 48 | 0, gr = (n | 0) == (he | 0) & Me >>> 0 < xr >>> 0 | n >>> 0 > he >>> 0, Me = (n | 0) == (ai | 0) & xr >>> 0 < fi >>> 0 | n >>> 0 < ai >>> 0, n = Bi + 8 | 0, d = t[n >> 2], v = wi + 8 | 0, Ir = d + t[v >> 2] | 0, v = t[v + 4 >> 2] + t[n + 4 >> 2] | 0, v = d >>> 0 > Ir >>> 0 ? v + 1 | 0 : v, n = Me + Ir | 0, v = n >>> 0 < Ir >>> 0 ? v + 1 | 0 : v, T = T >>> 20 | 0, d = T + n | 0, v = T >>> 0 > d >>> 0 ? v + 1 | 0 : v, n = d, d = d + gr | 0, v = n >>> 0 > d >>> 0 ? v + 1 | 0 : v, Ir = d << 12 | he >>> 20, T = t[I + 256 >> 2], he = Ir + T | 0, n = v, Un = v << 12 | d >>> 20, v = Un + t[I + 260 >> 2] | 0, Me = T >>> 0 > he >>> 0 ? v + 1 | 0 : v, Ur(Mr, he, Me, 0, 0, 15632, 16, 0, 0), T = I, L = (a | 0) == (Be | 0) & L >>> 0 < Wr >>> 0 | a >>> 0 > Be >>> 0, I = (a | 0) == (jn | 0) & Wr >>> 0 < Bn >>> 0 | a >>> 0 < jn >>> 0, a = Ii + 8 | 0, d = t[a >> 2], v = Ti + 8 | 0, gr = d + t[v >> 2] | 0, v = t[v + 4 >> 2] + t[a + 4 >> 2] | 0, v = d >>> 0 > gr >>> 0 ? v + 1 | 0 : v, a = I + gr | 0, v = a >>> 0 < gr >>> 0 ? v + 1 | 0 : v, E = E >>> 20 | 0, d = E + a | 0, v = E >>> 0 > d >>> 0 ? v + 1 | 0 : v, a = d, d = d + L | 0, v = a >>> 0 > d >>> 0 ? v + 1 | 0 : v, I = d << 12 | Be >>> 20, a = v, E = v << 12 | d >>> 20, xr = t[T + 96 >> 2], d = t[T + 144 >> 2], L = xr + d | 0, Gn = t[T + 100 >> 2], v = Gn + t[T + 148 >> 2] | 0, v = d >>> 0 > L >>> 0 ? v + 1 | 0 : v, d = t[T + 48 >> 2], Be = d + L | 0, gr = v, v = v + t[T + 52 >> 2] | 0, d = d >>> 0 > Be >>> 0 ? v + 1 | 0 : v, v = d + E | 0, I = I + Be | 0, v = I >>> 0 < Be >>> 0 ? v + 1 | 0 : v, t[T + 576 >> 2] = I, E = v, t[T + 580 >> 2] = v & 1048575, Wr = T + 32 | 0, Ir = (Me | 0) == (Un | 0) & he >>> 0 < Ir >>> 0 | Me >>> 0 < Un >>> 0, v = gn + 8 | 0, Me = t[v >> 2], v = t[v + 4 >> 2], n = n >>> 20 | 0, he = n, n = n + Me | 0, v = he >>> 0 > n >>> 0 ? v + 1 | 0 : v, he = n, n = n + Ir | 0, v = he >>> 0 > n >>> 0 ? v + 1 | 0 : v, Ur(Wr, n, v, 0, 0, 64028672, 65536, 0, 0), n = T, Ir = (d | 0) == (E | 0) & I >>> 0 < Be >>> 0 | d >>> 0 > E >>> 0, Me = (d | 0) == (gr | 0) & L >>> 0 > Be >>> 0 | d >>> 0 < gr >>> 0, v = Mr + 8 | 0, he = t[v >> 2], Be = t[v + 4 >> 2], I = (gr | 0) == (Gn | 0) & L >>> 0 < xr >>> 0 | gr >>> 0 < Gn >>> 0, T = ni + 8 | 0, d = t[T >> 2], v = Xn + 8 | 0, L = d + t[v >> 2] | 0, v = t[v + 4 >> 2] + t[T + 4 >> 2] | 0, v = d >>> 0 > L >>> 0 ? v + 1 | 0 : v, d = I + L | 0, v = (d >>> 0 < L >>> 0 ? v + 1 | 0 : v) + Be | 0, T = d, d = d + he | 0, v = T >>> 0 > d >>> 0 ? v + 1 | 0 : v, T = d + Me | 0, v = T >>> 0 < d >>> 0 ? v + 1 | 0 : v, a = a >>> 20 | 0, d = T + a | 0, v = a >>> 0 > d >>> 0 ? v + 1 | 0 : v, a = d, d = d + Ir | 0, v = a >>> 0 > d >>> 0 ? v + 1 | 0 : v, Be = d << 12 | E >>> 20, a = v, E = v << 12 | d >>> 20, L = t[n + 32 >> 2], d = $r & -2, T = L + d | 0, Me = t[n + 36 >> 2], v = Me + (or & 1048575) | 0, I = d >>> 0 > T >>> 0 ? v + 1 | 0 : v, v = I + E | 0, E = T + Be | 0, v = E >>> 0 < T >>> 0 ? v + 1 | 0 : v, t[n + 584 >> 2] = E, d = v, t[n + 588 >> 2] = v & 1048575, he = cr & 65535, Be = (v | 0) == (I | 0) & T >>> 0 > E >>> 0 | v >>> 0 < I >>> 0, n = (I | 0) == (Me | 0) & T >>> 0 < L >>> 0 | I >>> 0 < Me >>> 0, v = Wr + 8 | 0, E = n + t[v >> 2] | 0, v = t[v + 4 >> 2], v = n >>> 0 > E >>> 0 ? v + 1 | 0 : v, a = a >>> 20 | 0, n = a, a = E + a | 0, v = n >>> 0 > a >>> 0 ? v + 1 | 0 : v, n = a, a = a + Be | 0, v = n >>> 0 > a >>> 0 ? v + 1 | 0 : v, d = a << 12 | d >>> 20, n = d + tr | 0, v = he + (v << 12 | a >>> 20) | 0, t[dr + 592 >> 2] = n, t[dr + 596 >> 2] = d >>> 0 > n >>> 0 ? v + 1 | 0 : v, Mr = dr + 560 | 0, Xr(655432, 655432, Mr), Xr(655472, 655472, Mr), Xr(655472, 655472, Zn), Xr(655512, 655512, Zn), t[ts >> 2] = 0, t[ts + 4 >> 2] = 0, t[Zi >> 2] = 0, t[Zi + 4 >> 2] = 0, t[Xi >> 2] = 0, t[Xi + 4 >> 2] = 0, t[Hi >> 2] = 0, t[Hi + 4 >> 2] = 0, t[dr + 520 >> 2] = 0, t[dr + 524 >> 2] = 0, Wn(Oi, yi), xr = dr + 688 | 0, Zr(xr, yi, 0), d = xr + 24 | 0, L = t[d >> 2], a = xr + 16 | 0, Me = t[a >> 2], n = xr + 8 | 0, or = t[n >> 2], cr = t[dr + 688 >> 2], he = L | (Me | (or | cr)), T = t[d + 4 >> 2], tr = t[a + 4 >> 2], Be = t[n + 4 >> 2], I = t[dr + 692 >> 2], E = T | (tr | (Be | I)), v = he | E ? -1 : 0, Wr = v & L, t[d >> 2] = Wr, Ir = v & T, t[d + 4 >> 2] = Ir, gr = v & Me, t[a >> 2] = gr, $r = v & tr, t[a + 4 >> 2] = $r, or = v & or, t[n >> 2] = or, Me = v & Be, t[n + 4 >> 2] = Me, E = !(E | he) | v & cr, t[dr + 688 >> 2] = E, T = v & I, t[dr + 692 >> 2] = T, Vi(Oi, 68), t[ws >> 2] = 0, t[ws + 4 >> 2] = 0, t[hs >> 2] = 0, t[hs + 4 >> 2] = 0, t[dr + 488 >> 2] = 0, t[dr + 492 >> 2] = 0, t[dr + 480 >> 2] = 0, t[dr + 484 >> 2] = 0, hi(655392, Mr, xr), v = or | gr | Wr | E | (Me | $r | Ir | T) ? -1 : 0, L = E ^ -1, I = L - 801750718 | 0, E = v, tr = T ^ -1, T = tr - ((L >>> 0 < 801750718) + 1076732275 | 0) | 0, v = v & T, he = v, Be = I & E, t[163850] = Be, t[163851] = v, Me = Me ^ -1, v = Me, cr = or ^ -1, or = cr + ((T | 0) == (tr | 0) & I >>> 0 < L >>> 0 | T >>> 0 < tr >>> 0) | 0, I = or - 1354194885 | 0, tr = I & E, t[n >> 2] = tr, v = or >>> 0 < cr >>> 0 ? v + 1 | 0 : v, L = v - ((or >>> 0 < 1354194885) + 1162945305 | 0) | 0, T = L & E, t[n + 4 >> 2] = T, t[163852] = tr, t[163853] = T, T = (v | 0) == (L | 0) & I >>> 0 < or >>> 0 | v >>> 0 > L >>> 0, tr = T + ((v | 0) == (Me | 0) & or >>> 0 < cr >>> 0 | v >>> 0 < Me >>> 0) | 0, cr = gr ^ -1, or = cr + tr | 0, Me = $r ^ -1, v = Me + (T >>> 0 > tr >>> 0) | 0, I = or - 2 | 0, tr = I & E, t[a >> 2] = tr, v = or >>> 0 < cr >>> 0 ? v + 1 | 0 : v, L = v - (or >>> 0 < 2) | 0, T = L & E, t[a + 4 >> 2] = T, t[163854] = tr, t[163855] = T, T = (v | 0) == (L | 0) & I >>> 0 < or >>> 0 | v >>> 0 > L >>> 0, I = T + ((v | 0) == (Me | 0) & or >>> 0 < cr >>> 0 | v >>> 0 < Me >>> 0) | 0, v = I >>> 0 < T >>> 0, tr = I - Wr | 0, T = tr - 2 & E, t[d >> 2] = T, v = (v - ((I >>> 0 < Wr >>> 0) + Ir | 0) | 0) - (tr >>> 0 < 2) & E, t[d + 4 >> 2] = v, t[163856] = T, t[163857] = v, t[dr + 688 >> 2] = Be, t[dr + 692 >> 2] = he, $i(655432, Mr, 128), t[d >> 2] = 0, t[d + 4 >> 2] = 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, t[dr + 688 >> 2] = 0, t[dr + 692 >> 2] = 0, Vi(Mr, 124)), x = dr + 720 | 0, u[690757] = 0, u[690758] = 0, u[690759] = 0, u[690760] = 0, u[690761] = 0, u[690762] = 0, u[690763] = 0, u[690764] = 0, u[690756] = 1, u[690765] = 0, u[690766] = 0, u[690767] = 0, u[690768] = 0, u[690769] = 0, u[690770] = 0, u[690771] = 0, u[690772] = 0, u[690773] = 0, u[690774] = 0, u[690775] = 0, u[690776] = 0, u[690777] = 0, u[690778] = 0, u[690779] = 0, u[690780] = 0, u[690780] = 0, u[690781] = 0, u[690782] = 0, u[690783] = 0, u[690784] = 0, u[690785] = 0, u[690786] = 0, u[690787] = 0, t[Ai + 4 >> 2] = 1, t[172762] = 655392;
    }
    return x = Ai + 32 | 0, ks;
  }
  function er() {
    rr();
  }
  function ir(v) {
    v = v | 0;
    var d = 0, I = 0;
    d = x + -64 | 0, x = d;
    e: {
      if ((v | 0) != 32) {
        I = d + 56 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = d + 48 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = d + 40 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = d + 32 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = d + 24 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = d + 16 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = d + 8 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, v = si(t[172688], d, 690820, v);
        break e;
      }
      v = d + 56 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = d + 48 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = d + 40 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = d + 32 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = d + 24 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = d + 16 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = d + 8 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, v = Ds(t[172688], d, 690820);
    }
    return x = d - -64 | 0, (v | 0) == 1 | 0;
  }
  function sr(v, d, I) {
    v = v | 0, d = d | 0, I = I | 0;
    var n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0;
    E = x - 272 | 0, x = E, n = E + 200 | 0, Gn = n + 56 | 0, t[Gn >> 2] = 0, t[Gn + 4 >> 2] = 0, Be = n + 48 | 0, t[Be >> 2] = 0, t[Be + 4 >> 2] = 0, Ir = n + 40 | 0, t[Ir >> 2] = 0, t[Ir + 4 >> 2] = 0, Mr = n + 32 | 0, t[Mr >> 2] = 0, t[Mr + 4 >> 2] = 0, xr = n + 24 | 0, t[xr >> 2] = 0, t[xr + 4 >> 2] = 0, Wr = n + 16 | 0, t[Wr >> 2] = 0, t[Wr + 4 >> 2] = 0, Un = n + 8 | 0, t[Un >> 2] = 0, t[Un + 4 >> 2] = 0, t[E + 200 >> 2] = 0, t[E + 204 >> 2] = 0;
    e: {
      t: {
        if ((si(t[172688], n, 690820, v) | 0) == 1) {
          if ($r = E + 200 | 0, dr = $r + 15 | 0, n = dr, v = l[n + 4 | 0] | l[n + 5 | 0] << 8 | (l[n + 6 | 0] << 16 | l[n + 7 | 0] << 24), Me = E - -64 | 0, Bn = Me + 8 | 0, t[Bn >> 2] = l[n | 0] | l[n + 1 | 0] << 8 | (l[n + 2 | 0] << 16 | l[n + 3 | 0] << 24), t[Bn + 4 >> 2] = v, cr = $r + 23 | 0, n = cr, v = l[n + 4 | 0] | l[n + 5 | 0] << 8 | (l[n + 6 | 0] << 16 | l[n + 7 | 0] << 24), kn = Me + 16 | 0, t[kn >> 2] = l[n | 0] | l[n + 1 | 0] << 8 | (l[n + 2 | 0] << 16 | l[n + 3 | 0] << 24), t[kn + 4 >> 2] = v, tr = $r + 31 | 0, n = tr, v = l[n + 4 | 0] | l[n + 5 | 0] << 8 | (l[n + 6 | 0] << 16 | l[n + 7 | 0] << 24), xn = Me + 24 | 0, t[xn >> 2] = l[n | 0] | l[n + 1 | 0] << 8 | (l[n + 2 | 0] << 16 | l[n + 3 | 0] << 24), t[xn + 4 >> 2] = v, or = $r + 39 | 0, n = or, v = l[n + 4 | 0] | l[n + 5 | 0] << 8 | (l[n + 6 | 0] << 16 | l[n + 7 | 0] << 24), jn = Me + 32 | 0, t[jn >> 2] = l[n | 0] | l[n + 1 | 0] << 8 | (l[n + 2 | 0] << 16 | l[n + 3 | 0] << 24), t[jn + 4 >> 2] = v, T = $r + 47 | 0, n = T, v = l[n + 4 | 0] | l[n + 5 | 0] << 8 | (l[n + 6 | 0] << 16 | l[n + 7 | 0] << 24), a = Me + 40 | 0, t[a >> 2] = l[n | 0] | l[n + 1 | 0] << 8 | (l[n + 2 | 0] << 16 | l[n + 3 | 0] << 24), t[a + 4 >> 2] = v, n = $r + 55 | 0, v = l[n + 4 | 0] | l[n + 5 | 0] << 8 | (l[n + 6 | 0] << 16 | l[n + 7 | 0] << 24), L = Me + 48 | 0, t[L >> 2] = l[n | 0] | l[n + 1 | 0] << 8 | (l[n + 2 | 0] << 16 | l[n + 3 | 0] << 24), t[L + 4 >> 2] = v, he = Me + 56 | 0, Me = $r + 63 | 0, u[he | 0] = l[Me | 0], u[E + 2 | 0] = l[E + 202 | 0], p[E >> 1] = m[E + 200 >> 1], v = l[E + 211 | 0] | l[E + 212 | 0] << 8 | (l[E + 213 | 0] << 16 | l[E + 214 | 0] << 24), t[E + 64 >> 2] = l[E + 207 | 0] | l[E + 208 | 0] << 8 | (l[E + 209 | 0] << 16 | l[E + 210 | 0] << 24), t[E + 68 >> 2] = v, v = l[E + 203 | 0] | l[E + 204 | 0] << 8 | (l[E + 205 | 0] << 16 | l[E + 206 | 0] << 24), u[E + 63 | 0] = l[he | 0], gr = t[L + 4 >> 2], gn = E + 55 | 0, he = t[L >> 2], u[gn | 0] = he, u[gn + 1 | 0] = he >>> 8, u[gn + 2 | 0] = he >>> 16, u[gn + 3 | 0] = he >>> 24, u[gn + 4 | 0] = gr, u[gn + 5 | 0] = gr >>> 8, u[gn + 6 | 0] = gr >>> 16, u[gn + 7 | 0] = gr >>> 24, L = t[a + 4 >> 2], gr = E + 47 | 0, he = t[a >> 2], u[gr | 0] = he, u[gr + 1 | 0] = he >>> 8, u[gr + 2 | 0] = he >>> 16, u[gr + 3 | 0] = he >>> 24, u[gr + 4 | 0] = L, u[gr + 5 | 0] = L >>> 8, u[gr + 6 | 0] = L >>> 16, u[gr + 7 | 0] = L >>> 24, L = t[jn + 4 >> 2], a = E + 39 | 0, he = t[jn >> 2], u[a | 0] = he, u[a + 1 | 0] = he >>> 8, u[a + 2 | 0] = he >>> 16, u[a + 3 | 0] = he >>> 24, u[a + 4 | 0] = L, u[a + 5 | 0] = L >>> 8, u[a + 6 | 0] = L >>> 16, u[a + 7 | 0] = L >>> 24, L = t[xn + 4 >> 2], a = E + 31 | 0, he = t[xn >> 2], u[a | 0] = he, u[a + 1 | 0] = he >>> 8, u[a + 2 | 0] = he >>> 16, u[a + 3 | 0] = he >>> 24, u[a + 4 | 0] = L, u[a + 5 | 0] = L >>> 8, u[a + 6 | 0] = L >>> 16, u[a + 7 | 0] = L >>> 24, L = t[kn + 4 >> 2], a = E + 23 | 0, he = t[kn >> 2], u[a | 0] = he, u[a + 1 | 0] = he >>> 8, u[a + 2 | 0] = he >>> 16, u[a + 3 | 0] = he >>> 24, u[a + 4 | 0] = L, u[a + 5 | 0] = L >>> 8, u[a + 6 | 0] = L >>> 16, u[a + 7 | 0] = L >>> 24, L = t[Bn + 4 >> 2], a = E + 15 | 0, he = t[Bn >> 2], u[a | 0] = he, u[a + 1 | 0] = he >>> 8, u[a + 2 | 0] = he >>> 16, u[a + 3 | 0] = he >>> 24, u[a + 4 | 0] = L, u[a + 5 | 0] = L >>> 8, u[a + 6 | 0] = L >>> 16, u[a + 7 | 0] = L >>> 24, u[E + 3 | 0] = v, u[E + 4 | 0] = v >>> 8, u[E + 5 | 0] = v >>> 16, u[E + 6 | 0] = v >>> 24, he = t[E + 68 >> 2], v = t[E + 64 >> 2], u[E + 7 | 0] = v, u[E + 8 | 0] = v >>> 8, u[E + 9 | 0] = v >>> 16, u[E + 10 | 0] = v >>> 24, u[E + 11 | 0] = he, u[E + 12 | 0] = he >>> 8, u[E + 13 | 0] = he >>> 16, u[E + 14 | 0] = he >>> 24, t[Gn >> 2] = 0, t[Gn + 4 >> 2] = 0, t[Be >> 2] = 0, t[Be + 4 >> 2] = 0, t[Ir >> 2] = 0, t[Ir + 4 >> 2] = 0, t[Mr >> 2] = 0, t[Mr + 4 >> 2] = 0, t[xr >> 2] = 0, t[xr + 4 >> 2] = 0, t[Wr >> 2] = 0, t[Wr + 4 >> 2] = 0, t[Un >> 2] = 0, t[Un + 4 >> 2] = 0, t[E + 200 >> 2] = 0, t[E + 204 >> 2] = 0, gr = 0, (si(t[172688], $r, 655584, d) | 0) == 1) {
            v = l[dr + 4 | 0] | l[dr + 5 | 0] << 8 | (l[dr + 6 | 0] << 16 | l[dr + 7 | 0] << 24), d = E + 128 | 0, he = d + 8 | 0, t[he >> 2] = l[dr | 0] | l[dr + 1 | 0] << 8 | (l[dr + 2 | 0] << 16 | l[dr + 3 | 0] << 24), t[he + 4 >> 2] = v, v = l[cr + 4 | 0] | l[cr + 5 | 0] << 8 | (l[cr + 6 | 0] << 16 | l[cr + 7 | 0] << 24), dr = d + 16 | 0, t[dr >> 2] = l[cr | 0] | l[cr + 1 | 0] << 8 | (l[cr + 2 | 0] << 16 | l[cr + 3 | 0] << 24), t[dr + 4 >> 2] = v, v = l[tr + 4 | 0] | l[tr + 5 | 0] << 8 | (l[tr + 6 | 0] << 16 | l[tr + 7 | 0] << 24), cr = d + 24 | 0, t[cr >> 2] = l[tr | 0] | l[tr + 1 | 0] << 8 | (l[tr + 2 | 0] << 16 | l[tr + 3 | 0] << 24), t[cr + 4 >> 2] = v, v = l[or + 4 | 0] | l[or + 5 | 0] << 8 | (l[or + 6 | 0] << 16 | l[or + 7 | 0] << 24), tr = d + 32 | 0, t[tr >> 2] = l[or | 0] | l[or + 1 | 0] << 8 | (l[or + 2 | 0] << 16 | l[or + 3 | 0] << 24), t[tr + 4 >> 2] = v, v = l[T + 4 | 0] | l[T + 5 | 0] << 8 | (l[T + 6 | 0] << 16 | l[T + 7 | 0] << 24), or = d + 40 | 0, t[or >> 2] = l[T | 0] | l[T + 1 | 0] << 8 | (l[T + 2 | 0] << 16 | l[T + 3 | 0] << 24), t[or + 4 >> 2] = v, v = l[n + 4 | 0] | l[n + 5 | 0] << 8 | (l[n + 6 | 0] << 16 | l[n + 7 | 0] << 24), T = d + 48 | 0, t[T >> 2] = l[n | 0] | l[n + 1 | 0] << 8 | (l[n + 2 | 0] << 16 | l[n + 3 | 0] << 24), t[T + 4 >> 2] = v, d = d + 56 | 0, u[d | 0] = l[Me | 0], u[E + 66 | 0] = l[E + 202 | 0], p[E + 64 >> 1] = m[E + 200 >> 1], v = l[E + 211 | 0] | l[E + 212 | 0] << 8 | (l[E + 213 | 0] << 16 | l[E + 214 | 0] << 24), t[E + 128 >> 2] = l[E + 207 | 0] | l[E + 208 | 0] << 8 | (l[E + 209 | 0] << 16 | l[E + 210 | 0] << 24), t[E + 132 >> 2] = v, v = l[E + 203 | 0] | l[E + 204 | 0] << 8 | (l[E + 205 | 0] << 16 | l[E + 206 | 0] << 24), L = E - -64 | 0, u[L + 63 | 0] = l[d | 0], n = t[T + 4 >> 2], Me = L + 55 | 0, d = t[T >> 2], u[Me | 0] = d, u[Me + 1 | 0] = d >>> 8, u[Me + 2 | 0] = d >>> 16, u[Me + 3 | 0] = d >>> 24, u[Me + 4 | 0] = n, u[Me + 5 | 0] = n >>> 8, u[Me + 6 | 0] = n >>> 16, u[Me + 7 | 0] = n >>> 24, n = t[or + 4 >> 2], T = L + 47 | 0, d = t[or >> 2], u[T | 0] = d, u[T + 1 | 0] = d >>> 8, u[T + 2 | 0] = d >>> 16, u[T + 3 | 0] = d >>> 24, u[T + 4 | 0] = n, u[T + 5 | 0] = n >>> 8, u[T + 6 | 0] = n >>> 16, u[T + 7 | 0] = n >>> 24, n = t[tr + 4 >> 2], T = L + 39 | 0, d = t[tr >> 2], u[T | 0] = d, u[T + 1 | 0] = d >>> 8, u[T + 2 | 0] = d >>> 16, u[T + 3 | 0] = d >>> 24, u[T + 4 | 0] = n, u[T + 5 | 0] = n >>> 8, u[T + 6 | 0] = n >>> 16, u[T + 7 | 0] = n >>> 24, n = t[cr + 4 >> 2], T = L + 31 | 0, d = t[cr >> 2], u[T | 0] = d, u[T + 1 | 0] = d >>> 8, u[T + 2 | 0] = d >>> 16, u[T + 3 | 0] = d >>> 24, u[T + 4 | 0] = n, u[T + 5 | 0] = n >>> 8, u[T + 6 | 0] = n >>> 16, u[T + 7 | 0] = n >>> 24, n = t[dr + 4 >> 2], T = L + 23 | 0, d = t[dr >> 2], u[T | 0] = d, u[T + 1 | 0] = d >>> 8, u[T + 2 | 0] = d >>> 16, u[T + 3 | 0] = d >>> 24, u[T + 4 | 0] = n, u[T + 5 | 0] = n >>> 8, u[T + 6 | 0] = n >>> 16, u[T + 7 | 0] = n >>> 24, n = t[he + 4 >> 2], T = L + 15 | 0, d = t[he >> 2], u[T | 0] = d, u[T + 1 | 0] = d >>> 8, u[T + 2 | 0] = d >>> 16, u[T + 3 | 0] = d >>> 24, u[T + 4 | 0] = n, u[T + 5 | 0] = n >>> 8, u[T + 6 | 0] = n >>> 16, u[T + 7 | 0] = n >>> 24, u[E + 67 | 0] = v, u[E + 68 | 0] = v >>> 8, u[E + 69 | 0] = v >>> 16, u[E + 70 | 0] = v >>> 24, d = t[E + 132 >> 2], v = t[E + 128 >> 2], u[E + 71 | 0] = v, u[E + 72 | 0] = v >>> 8, u[E + 73 | 0] = v >>> 16, u[E + 74 | 0] = v >>> 24, u[E + 75 | 0] = d, u[E + 76 | 0] = d >>> 8, u[E + 77 | 0] = d >>> 16, u[E + 78 | 0] = d >>> 24, Be = E + 200 | 0, v = Be + 56 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = Be + 48 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = Be + 40 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = Be + 32 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = Be + 24 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = Be + 16 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = Be + 8 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, t[E + 200 >> 2] = 0, t[E + 204 >> 2] = 0, t[E + 196 >> 2] = L, t[E + 192 >> 2] = E, Ir = t[172688], xr = E + 192 | 0, Wr = 2, L = x - 224 | 0, x = L;
            r: {
              if (!Be) {
                Qn[t[Ir + 168 >> 2]](689778, t[Ir + 172 >> 2]), v = 0;
                break r;
              }
              if (u[Be | 0] = 0, u[Be + 1 | 0] = 0, u[Be + 2 | 0] = 0, u[Be + 3 | 0] = 0, u[Be + 4 | 0] = 0, u[Be + 5 | 0] = 0, u[Be + 6 | 0] = 0, u[Be + 7 | 0] = 0, v = Be + 56 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = Be + 48 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = Be + 40 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = Be + 32 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = Be + 24 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = Be + 16 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = Be + 8 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, !xr) {
                Qn[t[Ir + 168 >> 2]](689682, t[Ir + 172 >> 2]), v = 0;
                break r;
              }
              for (t[L + 216 >> 2] = 1, Vi(L + 96 | 0, 120), Un = Ir + 172 | 0; ; ) {
                if (a = t[xr >> 2], !a) {
                  Qn[t[Ir + 168 >> 2]](689809, t[Ir + 172 >> 2]), v = 0;
                  break r;
                }
                if (t[L + 88 >> 2] = 0, d = l[a + 60 | 0] | l[a + 61 | 0] << 8 | (l[a + 62 | 0] << 16 | l[a + 63 | 0] << 24), tr = d >>> 16 | 0, v = L, n = l[a + 56 | 0] | l[a + 57 | 0] << 8 | (l[a + 58 | 0] << 16 | l[a + 59 | 0] << 24), t[v + 80 >> 2] = (d & 65535) << 16 | n >>> 16, t[v + 84 >> 2] = tr, T = l[a + 36 | 0] | l[a + 37 | 0] << 8 | (l[a + 38 | 0] << 16 | l[a + 39 | 0] << 24), t[v + 48 >> 2] = l[a + 32 | 0] | l[a + 33 | 0] << 8 | (l[a + 34 | 0] << 16 | l[a + 35 | 0] << 24), t[v + 52 >> 2] = T & 1048575, tr = n << 4 & 1048560, d = l[a + 52 | 0] | l[a + 53 | 0] << 8 | (l[a + 54 | 0] << 16 | l[a + 55 | 0] << 24), he = d >>> 28 | 0, n = l[a + 48 | 0] | l[a + 49 | 0] << 8 | (l[a + 50 | 0] << 16 | l[a + 51 | 0] << 24), t[v + 72 >> 2] = (d & 268435455) << 4 | n >>> 28, t[v + 76 >> 2] = he | tr, tr = d << 24 | n >>> 8, cr = n << 24 & -16777216, n = l[a + 40 | 0] | l[a + 41 | 0] << 8 | (l[a + 42 | 0] << 16 | l[a + 43 | 0] << 24), d = l[a + 44 | 0] | l[a + 45 | 0] << 8 | (l[a + 46 | 0] << 16 | l[a + 47 | 0] << 24), t[v + 64 >> 2] = d >>> 8 | cr, t[v + 68 >> 2] = tr & 1048575, Mr = d << 12 | n >>> 20, t[v + 56 >> 2] = n << 12 & -4096 | T >>> 20, t[v + 60 >> 2] = Mr & 1048575, n = l[a + 12 | 0] | l[a + 13 | 0] << 8 | (l[a + 14 | 0] << 16 | l[a + 15 | 0] << 24), Me = n, d = l[a + 8 | 0] | l[a + 9 | 0] << 8 | (l[a + 10 | 0] << 16 | l[a + 11 | 0] << 24), Mr = n << 12 | d >>> 20, or = d << 12 & -4096, dr = l[a | 0] | l[a + 1 | 0] << 8 | (l[a + 2 | 0] << 16 | l[a + 3 | 0] << 24), d = l[a + 4 | 0] | l[a + 5 | 0] << 8 | (l[a + 6 | 0] << 16 | l[a + 7 | 0] << 24), n = d, Bn = n >>> 20 | or, t[v + 16 >> 2] = Bn, kn = Mr & 1048575, t[v + 20 >> 2] = kn, t[v + 8 >> 2] = dr, xn = n & 1048575, t[v + 12 >> 2] = xn, d = l[a + 24 | 0] | l[a + 25 | 0] << 8 | (l[a + 26 | 0] << 16 | l[a + 27 | 0] << 24), cr = d, n = l[a + 28 | 0] | l[a + 29 | 0] << 8 | (l[a + 30 | 0] << 16 | l[a + 31 | 0] << 24), T = (n & 65535) << 16 | d >>> 16, t[v + 40 >> 2] = T, or = n >>> 16 | 0, t[v + 44 >> 2] = or, d = l[a + 16 | 0] | l[a + 17 | 0] << 8 | (l[a + 18 | 0] << 16 | l[a + 19 | 0] << 24), n = l[a + 20 | 0] | l[a + 21 | 0] << 8 | (l[a + 22 | 0] << 16 | l[a + 23 | 0] << 24), he = n << 24 | d >>> 8, a = d << 24 & -16777216 | Me >>> 8, t[v + 24 >> 2] = a, Me = he & 1048575, t[v + 28 >> 2] = Me, tr = cr << 4 & 1048560, d = (n & 268435455) << 4 | d >>> 28, t[v + 32 >> 2] = d, v = n >>> 28 | tr, t[L + 36 >> 2] = v, dr | Bn | T | a | d | (kn | xn | or | Me | v) || Qn[t[Ir + 168 >> 2]](690116, t[Un >> 2]), xr = xr + 4 | 0, v = L + 96 | 0, ms(v, v, L + 8 | 0), Wr = Wr - 1 | 0, !Wr)
                  break;
              }
              if (v = 0, t[L + 216 >> 2])
                break r;
              v = L + 8 | 0, ki(v, L + 96 | 0), In(Be, v), v = 1;
            }
            if (x = L + 224 | 0, !v)
              break e;
            if (t[E + 264 >> 2] = I, v = zr(t[172688], E + 264 | 0, E + 200 | 0, (I | 0) == 33 ? 258 : 2), t[E + 268 >> 2] = v, (v | 0) != 1)
              break t;
            gr = 1;
            break e;
          }
          P(1);
          break e;
        }
        P(1);
        break e;
      }
      t[E + 136 >> 2] = 0, Ne(E + 128 | 0), wasm2js_trap();
    }
    return x = E + 272 | 0, gr | 0;
  }
  function nr(v, d) {
    v = v | 0, d = d | 0;
    var I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0;
    T = x - 208 | 0, x = T, I = T + 136 | 0, n = I + 56 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = I + 48 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = I + 40 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = I + 32 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = I + 24 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = I + 16 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = I + 8 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, t[T + 136 >> 2] = 0, t[T + 140 >> 2] = 0;
    e: {
      if ((si(t[172688], I, 690820, v) | 0) == 1) {
        Be = T + 136 | 0, I = Be + 15 | 0, v = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), n = T + 72 | 0, cr = n + 8 | 0, t[cr >> 2] = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), t[cr + 4 >> 2] = v, I = Be + 23 | 0, v = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), tr = n + 16 | 0, t[tr >> 2] = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), t[tr + 4 >> 2] = v, I = Be + 31 | 0, v = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), or = n + 24 | 0, t[or >> 2] = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), t[or + 4 >> 2] = v, I = Be + 39 | 0, v = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), Me = n + 32 | 0, t[Me >> 2] = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), t[Me + 4 >> 2] = v, I = Be + 47 | 0, v = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), L = n + 40 | 0, t[L >> 2] = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), t[L + 4 >> 2] = v, he = Be + 55 | 0, v = l[he + 4 | 0] | l[he + 5 | 0] << 8 | (l[he + 6 | 0] << 16 | l[he + 7 | 0] << 24), I = n + 48 | 0, t[I >> 2] = l[he | 0] | l[he + 1 | 0] << 8 | (l[he + 2 | 0] << 16 | l[he + 3 | 0] << 24), t[I + 4 >> 2] = v, n = n + 56 | 0, u[n | 0] = l[Be + 63 | 0], u[T + 10 | 0] = l[T + 138 | 0], p[T + 8 >> 1] = m[T + 136 >> 1], v = l[T + 147 | 0] | l[T + 148 | 0] << 8 | (l[T + 149 | 0] << 16 | l[T + 150 | 0] << 24), t[T + 72 >> 2] = l[T + 143 | 0] | l[T + 144 | 0] << 8 | (l[T + 145 | 0] << 16 | l[T + 146 | 0] << 24), t[T + 76 >> 2] = v, Be = l[T + 139 | 0] | l[T + 140 | 0] << 8 | (l[T + 141 | 0] << 16 | l[T + 142 | 0] << 24), a = T + 8 | 0, u[a + 63 | 0] = l[n | 0], n = t[I + 4 >> 2], he = a + 55 | 0, v = t[I >> 2], u[he | 0] = v, u[he + 1 | 0] = v >>> 8, u[he + 2 | 0] = v >>> 16, u[he + 3 | 0] = v >>> 24, u[he + 4 | 0] = n, u[he + 5 | 0] = n >>> 8, u[he + 6 | 0] = n >>> 16, u[he + 7 | 0] = n >>> 24, n = t[L + 4 >> 2], I = a + 47 | 0, v = t[L >> 2], u[I | 0] = v, u[I + 1 | 0] = v >>> 8, u[I + 2 | 0] = v >>> 16, u[I + 3 | 0] = v >>> 24, u[I + 4 | 0] = n, u[I + 5 | 0] = n >>> 8, u[I + 6 | 0] = n >>> 16, u[I + 7 | 0] = n >>> 24, n = t[Me + 4 >> 2], I = a + 39 | 0, v = t[Me >> 2], u[I | 0] = v, u[I + 1 | 0] = v >>> 8, u[I + 2 | 0] = v >>> 16, u[I + 3 | 0] = v >>> 24, u[I + 4 | 0] = n, u[I + 5 | 0] = n >>> 8, u[I + 6 | 0] = n >>> 16, u[I + 7 | 0] = n >>> 24, n = t[or + 4 >> 2], I = a + 31 | 0, v = t[or >> 2], u[I | 0] = v, u[I + 1 | 0] = v >>> 8, u[I + 2 | 0] = v >>> 16, u[I + 3 | 0] = v >>> 24, u[I + 4 | 0] = n, u[I + 5 | 0] = n >>> 8, u[I + 6 | 0] = n >>> 16, u[I + 7 | 0] = n >>> 24, n = t[tr + 4 >> 2], I = a + 23 | 0, v = t[tr >> 2], u[I | 0] = v, u[I + 1 | 0] = v >>> 8, u[I + 2 | 0] = v >>> 16, u[I + 3 | 0] = v >>> 24, u[I + 4 | 0] = n, u[I + 5 | 0] = n >>> 8, u[I + 6 | 0] = n >>> 16, u[I + 7 | 0] = n >>> 24, n = t[cr + 4 >> 2], I = a + 15 | 0, v = t[cr >> 2], u[I | 0] = v, u[I + 1 | 0] = v >>> 8, u[I + 2 | 0] = v >>> 16, u[I + 3 | 0] = v >>> 24, u[I + 4 | 0] = n, u[I + 5 | 0] = n >>> 8, u[I + 6 | 0] = n >>> 16, u[I + 7 | 0] = n >>> 24, u[T + 11 | 0] = Be, u[T + 12 | 0] = Be >>> 8, u[T + 13 | 0] = Be >>> 16, u[T + 14 | 0] = Be >>> 24, n = t[T + 76 >> 2], v = t[T + 72 >> 2], u[T + 15 | 0] = v, u[T + 16 | 0] = v >>> 8, u[T + 17 | 0] = v >>> 16, u[T + 18 | 0] = v >>> 24, u[T + 19 | 0] = n, u[T + 20 | 0] = n >>> 8, u[T + 21 | 0] = n >>> 16, u[T + 22 | 0] = n >>> 24, dr = rr(), E = x - 288 | 0, x = E;
        t: {
          if (!a) {
            Qn[t[dr + 168 >> 2]](689638, t[dr + 172 >> 2]);
            break t;
          }
          if (v = l[a + 60 | 0] | l[a + 61 | 0] << 8 | (l[a + 62 | 0] << 16 | l[a + 63 | 0] << 24), tr = v >>> 16 | 0, L = E + 72 | 0, n = l[a + 56 | 0] | l[a + 57 | 0] << 8 | (l[a + 58 | 0] << 16 | l[a + 59 | 0] << 24), t[L >> 2] = (v & 65535) << 16 | n >>> 16, t[L + 4 >> 2] = tr, L = n << 4 & 1048560, v = l[a + 52 | 0] | l[a + 53 | 0] << 8 | (l[a + 54 | 0] << 16 | l[a + 55 | 0] << 24), he = v >>> 28 | 0, Me = E - -64 | 0, n = l[a + 48 | 0] | l[a + 49 | 0] << 8 | (l[a + 50 | 0] << 16 | l[a + 51 | 0] << 24), t[Me >> 2] = (v & 268435455) << 4 | n >>> 28, t[Me + 4 >> 2] = L | he, tr = v << 24 | n >>> 8, Me = n << 24 & -16777216, n = l[a + 40 | 0] | l[a + 41 | 0] << 8 | (l[a + 42 | 0] << 16 | l[a + 43 | 0] << 24), or = E + 56 | 0, v = l[a + 44 | 0] | l[a + 45 | 0] << 8 | (l[a + 46 | 0] << 16 | l[a + 47 | 0] << 24), t[or >> 2] = v >>> 8 | Me, t[or + 4 >> 2] = tr & 1048575, tr = v << 12 | n >>> 20, Me = n << 12 & -4096, I = l[a + 32 | 0] | l[a + 33 | 0] << 8 | (l[a + 34 | 0] << 16 | l[a + 35 | 0] << 24), v = l[a + 36 | 0] | l[a + 37 | 0] << 8 | (l[a + 38 | 0] << 16 | l[a + 39 | 0] << 24), or = E + 48 | 0, t[or >> 2] = v >>> 20 | Me, t[or + 4 >> 2] = tr & 1048575, t[E + 80 >> 2] = 0, t[E + 40 >> 2] = I, t[E + 44 >> 2] = v & 1048575, I = l[a + 12 | 0] | l[a + 13 | 0] << 8 | (l[a + 14 | 0] << 16 | l[a + 15 | 0] << 24), Be = I, n = l[a + 8 | 0] | l[a + 9 | 0] << 8 | (l[a + 10 | 0] << 16 | l[a + 11 | 0] << 24), tr = I << 12 | n >>> 20, Me = n << 12 & -4096, cr = l[a | 0] | l[a + 1 | 0] << 8 | (l[a + 2 | 0] << 16 | l[a + 3 | 0] << 24), n = l[a + 4 | 0] | l[a + 5 | 0] << 8 | (l[a + 6 | 0] << 16 | l[a + 7 | 0] << 24), I = n, v = E, gr = I >>> 20 | Me, t[v + 8 >> 2] = gr, Ir = tr & 1048575, t[v + 12 >> 2] = Ir, t[v >> 2] = cr, xr = I & 1048575, t[v + 4 >> 2] = xr, n = l[a + 24 | 0] | l[a + 25 | 0] << 8 | (l[a + 26 | 0] << 16 | l[a + 27 | 0] << 24), tr = n, I = l[a + 28 | 0] | l[a + 29 | 0] << 8 | (l[a + 30 | 0] << 16 | l[a + 31 | 0] << 24), L = (I & 65535) << 16 | n >>> 16, t[v + 32 >> 2] = L, Me = I >>> 16 | 0, t[v + 36 >> 2] = Me, n = l[a + 16 | 0] | l[a + 17 | 0] << 8 | (l[a + 18 | 0] << 16 | l[a + 19 | 0] << 24), I = l[a + 20 | 0] | l[a + 21 | 0] << 8 | (l[a + 22 | 0] << 16 | l[a + 23 | 0] << 24), he = I << 24 | n >>> 8, Mr = n << 24 & -16777216 | Be >>> 8, t[v + 16 >> 2] = Mr, Be = he & 1048575, t[v + 20 >> 2] = Be, or = tr << 4 & 1048560, n = (I & 268435455) << 4 | n >>> 28, t[v + 24 >> 2] = n, v = I >>> 28 | or, t[E + 28 >> 2] = v, !(cr | gr | L | Mr | n | (Ir | xr | Me | Be | v))) {
            Qn[t[dr + 168 >> 2]](690116, t[dr + 172 >> 2]), v = a + 56 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = a + 48 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = a + 40 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = a + 32 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = a + 24 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = a + 16 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = a + 8 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, u[a | 0] = 0, u[a + 1 | 0] = 0, u[a + 2 | 0] = 0, u[a + 3 | 0] = 0, u[a + 4 | 0] = 0, u[a + 5 | 0] = 0, u[a + 6 | 0] = 0, u[a + 7 | 0] = 0;
            break t;
          }
          if (u[a | 0] = 0, u[a + 1 | 0] = 0, u[a + 2 | 0] = 0, u[a + 3 | 0] = 0, u[a + 4 | 0] = 0, u[a + 5 | 0] = 0, u[a + 6 | 0] = 0, u[a + 7 | 0] = 0, v = a + 56 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = a + 48 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = a + 40 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = a + 32 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = a + 24 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = a + 16 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = a + 8 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, t[E + 92 >> 2] = 0, Zr(E + 96 | 0, 690949, E + 92 | 0), t[E + 92 >> 2] || (I = E + 8 | 0, n = t[I + 4 >> 2], L = E + 160 | 0, v = L + 8 | 0, t[v >> 2] = t[I >> 2], t[v + 4 >> 2] = n, I = E + 16 | 0, n = t[I + 4 >> 2], v = L + 16 | 0, t[v >> 2] = t[I >> 2], t[v + 4 >> 2] = n, I = E + 24 | 0, n = t[I + 4 >> 2], v = L + 24 | 0, t[v >> 2] = t[I >> 2], t[v + 4 >> 2] = n, I = E + 32 | 0, n = t[I + 4 >> 2], v = L + 32 | 0, t[v >> 2] = t[I >> 2], t[v + 4 >> 2] = n, I = E + 48 | 0, n = t[I + 4 >> 2], v = L + 48 | 0, t[v >> 2] = t[I >> 2], t[v + 4 >> 2] = n, I = E + 56 | 0, n = t[I + 4 >> 2], v = L + 56 | 0, t[v >> 2] = t[I >> 2], t[v + 4 >> 2] = n, I = E - -64 | 0, n = t[I + 4 >> 2], v = L - -64 | 0, t[v >> 2] = t[I >> 2], t[v + 4 >> 2] = n, I = E + 72 | 0, n = t[I + 4 >> 2], v = L + 72 | 0, t[v >> 2] = t[I >> 2], t[v + 4 >> 2] = n, t[E + 280 >> 2] = 0, v = t[E + 4 >> 2], t[E + 160 >> 2] = t[E >> 2], t[E + 164 >> 2] = v, v = t[E + 44 >> 2], t[E + 200 >> 2] = t[E + 40 >> 2], t[E + 204 >> 2] = v, v = E + 248 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = E + 256 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = E + 264 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = E + 272 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, n = E + 128 | 0, v = n + 16 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = n + 24 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, t[E + 240 >> 2] = 1, t[E + 244 >> 2] = 0, t[E + 136 >> 2] = 0, t[E + 140 >> 2] = 0, t[E + 128 >> 2] = 1, t[E + 132 >> 2] = 0, Or(L, L, n, E + 96 | 0), t[E + 280 >> 2]))
            break t;
          ki(E, E + 160 | 0), In(a, E), Wr = 1;
        }
        if (x = E + 288 | 0, !Wr || (t[T + 204 >> 2] = d, v = zr(t[172688], T + 204 | 0, T + 8 | 0, (d | 0) == 33 ? 258 : 2), t[T + 72 >> 2] = v, $r = 1, (v | 0) == 1))
          break e;
        t[T + 144 >> 2] = 0, Ne(T + 136 | 0), wasm2js_trap();
      }
      P(1);
    }
    return x = T + 208 | 0, $r | 0;
  }
  function fr() {
    var v = 0, d = 0, I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0;
    T = x - 208 | 0, x = T, I = T + 136 | 0, Ir = I + 56 | 0, t[Ir >> 2] = 0, t[Ir + 4 >> 2] = 0, xr = I + 48 | 0, t[xr >> 2] = 0, t[xr + 4 >> 2] = 0, or = I + 40 | 0, t[or >> 2] = 0, t[or + 4 >> 2] = 0, Mr = I + 32 | 0, t[Mr >> 2] = 0, t[Mr + 4 >> 2] = 0, E = I + 24 | 0, t[E >> 2] = 0, t[E + 4 >> 2] = 0, gr = I + 16 | 0, t[gr >> 2] = 0, t[gr + 4 >> 2] = 0, dr = I + 8 | 0, t[dr >> 2] = 0, t[dr + 4 >> 2] = 0, t[T + 136 >> 2] = 0, t[T + 140 >> 2] = 0;
    e: {
      t: {
        if ((Ds(t[172688], I, 690885) | 0) == 1) {
          he = T + 136 | 0, d = he + 15 | 0, v = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), I = T + 72 | 0, Wr = I + 8 | 0, t[Wr >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[Wr + 4 >> 2] = v, d = he + 23 | 0, v = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), Me = I + 16 | 0, t[Me >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[Me + 4 >> 2] = v, d = he + 31 | 0, v = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), tr = I + 24 | 0, t[tr >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[tr + 4 >> 2] = v, d = he + 39 | 0, v = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), Be = I + 32 | 0, t[Be >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[Be + 4 >> 2] = v, d = he + 47 | 0, v = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), a = I + 40 | 0, t[a >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[a + 4 >> 2] = v, L = he + 55 | 0, v = l[L + 4 | 0] | l[L + 5 | 0] << 8 | (l[L + 6 | 0] << 16 | l[L + 7 | 0] << 24), d = I + 48 | 0, t[d >> 2] = l[L | 0] | l[L + 1 | 0] << 8 | (l[L + 2 | 0] << 16 | l[L + 3 | 0] << 24), t[d + 4 >> 2] = v, I = I + 56 | 0, u[I | 0] = l[he + 63 | 0], u[T + 10 | 0] = l[T + 138 | 0], p[T + 8 >> 1] = m[T + 136 >> 1], v = l[T + 147 | 0] | l[T + 148 | 0] << 8 | (l[T + 149 | 0] << 16 | l[T + 150 | 0] << 24), t[T + 72 >> 2] = l[T + 143 | 0] | l[T + 144 | 0] << 8 | (l[T + 145 | 0] << 16 | l[T + 146 | 0] << 24), t[T + 76 >> 2] = v, v = l[T + 139 | 0] | l[T + 140 | 0] << 8 | (l[T + 141 | 0] << 16 | l[T + 142 | 0] << 24), n = T + 8 | 0, u[n + 63 | 0] = l[I | 0], L = t[d + 4 >> 2], cr = n + 55 | 0, I = t[d >> 2], u[cr | 0] = I, u[cr + 1 | 0] = I >>> 8, u[cr + 2 | 0] = I >>> 16, u[cr + 3 | 0] = I >>> 24, u[cr + 4 | 0] = L, u[cr + 5 | 0] = L >>> 8, u[cr + 6 | 0] = L >>> 16, u[cr + 7 | 0] = L >>> 24, d = t[a + 4 >> 2], L = n + 47 | 0, I = t[a >> 2], u[L | 0] = I, u[L + 1 | 0] = I >>> 8, u[L + 2 | 0] = I >>> 16, u[L + 3 | 0] = I >>> 24, u[L + 4 | 0] = d, u[L + 5 | 0] = d >>> 8, u[L + 6 | 0] = d >>> 16, u[L + 7 | 0] = d >>> 24, d = t[Be + 4 >> 2], a = n + 39 | 0, I = t[Be >> 2], u[a | 0] = I, u[a + 1 | 0] = I >>> 8, u[a + 2 | 0] = I >>> 16, u[a + 3 | 0] = I >>> 24, u[a + 4 | 0] = d, u[a + 5 | 0] = d >>> 8, u[a + 6 | 0] = d >>> 16, u[a + 7 | 0] = d >>> 24, d = t[tr + 4 >> 2], a = n + 31 | 0, I = t[tr >> 2], u[a | 0] = I, u[a + 1 | 0] = I >>> 8, u[a + 2 | 0] = I >>> 16, u[a + 3 | 0] = I >>> 24, u[a + 4 | 0] = d, u[a + 5 | 0] = d >>> 8, u[a + 6 | 0] = d >>> 16, u[a + 7 | 0] = d >>> 24, d = t[Me + 4 >> 2], a = n + 23 | 0, I = t[Me >> 2], u[a | 0] = I, u[a + 1 | 0] = I >>> 8, u[a + 2 | 0] = I >>> 16, u[a + 3 | 0] = I >>> 24, u[a + 4 | 0] = d, u[a + 5 | 0] = d >>> 8, u[a + 6 | 0] = d >>> 16, u[a + 7 | 0] = d >>> 24, d = t[Wr + 4 >> 2], a = n + 15 | 0, I = t[Wr >> 2], u[a | 0] = I, u[a + 1 | 0] = I >>> 8, u[a + 2 | 0] = I >>> 16, u[a + 3 | 0] = I >>> 24, u[a + 4 | 0] = d, u[a + 5 | 0] = d >>> 8, u[a + 6 | 0] = d >>> 16, u[a + 7 | 0] = d >>> 24, u[T + 11 | 0] = v, u[T + 12 | 0] = v >>> 8, u[T + 13 | 0] = v >>> 16, u[T + 14 | 0] = v >>> 24, I = t[T + 76 >> 2], v = t[T + 72 >> 2], u[T + 15 | 0] = v, u[T + 16 | 0] = v >>> 8, u[T + 17 | 0] = v >>> 16, u[T + 18 | 0] = v >>> 24, u[T + 19 | 0] = I, u[T + 20 | 0] = I >>> 8, u[T + 21 | 0] = I >>> 16, u[T + 22 | 0] = I >>> 24, t[Ir >> 2] = 0, t[Ir + 4 >> 2] = 0, t[xr >> 2] = 0, t[xr + 4 >> 2] = 0, t[or >> 2] = 0, t[or + 4 >> 2] = 0, t[Mr >> 2] = 0, t[Mr + 4 >> 2] = 0, t[E >> 2] = 0, t[E + 4 >> 2] = 0, t[gr >> 2] = 0, t[gr + 4 >> 2] = 0, t[dr >> 2] = 0, t[dr + 4 >> 2] = 0, t[T + 136 >> 2] = 0, t[T + 140 >> 2] = 0, or = rr(), cr = 0, E = x - 288 | 0, x = E;
          r: {
            if (!he) {
              Qn[t[or + 168 >> 2]](689607, t[or + 172 >> 2]);
              break r;
            }
            if (u[he | 0] = 0, u[he + 1 | 0] = 0, u[he + 2 | 0] = 0, u[he + 3 | 0] = 0, u[he + 4 | 0] = 0, u[he + 5 | 0] = 0, u[he + 6 | 0] = 0, u[he + 7 | 0] = 0, v = he + 56 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = he + 48 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = he + 40 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = he + 32 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = he + 24 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = he + 16 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = he + 8 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, !n) {
              Qn[t[or + 168 >> 2]](689629, t[or + 172 >> 2]);
              break r;
            }
            if (v = l[n + 60 | 0] | l[n + 61 | 0] << 8 | (l[n + 62 | 0] << 16 | l[n + 63 | 0] << 24), Me = v >>> 16 | 0, a = E + 72 | 0, I = l[n + 56 | 0] | l[n + 57 | 0] << 8 | (l[n + 58 | 0] << 16 | l[n + 59 | 0] << 24), t[a >> 2] = (v & 65535) << 16 | I >>> 16, t[a + 4 >> 2] = Me, a = I << 4 & 1048560, v = l[n + 52 | 0] | l[n + 53 | 0] << 8 | (l[n + 54 | 0] << 16 | l[n + 55 | 0] << 24), gr = v >>> 28 | 0, Be = E - -64 | 0, I = l[n + 48 | 0] | l[n + 49 | 0] << 8 | (l[n + 50 | 0] << 16 | l[n + 51 | 0] << 24), t[Be >> 2] = (v & 268435455) << 4 | I >>> 28, t[Be + 4 >> 2] = a | gr, Me = v << 24 | I >>> 8, Be = I << 24 & -16777216, I = l[n + 40 | 0] | l[n + 41 | 0] << 8 | (l[n + 42 | 0] << 16 | l[n + 43 | 0] << 24), tr = E + 56 | 0, v = l[n + 44 | 0] | l[n + 45 | 0] << 8 | (l[n + 46 | 0] << 16 | l[n + 47 | 0] << 24), t[tr >> 2] = v >>> 8 | Be, t[tr + 4 >> 2] = Me & 1048575, Me = v << 12 | I >>> 20, Be = I << 12 & -4096, d = l[n + 32 | 0] | l[n + 33 | 0] << 8 | (l[n + 34 | 0] << 16 | l[n + 35 | 0] << 24), v = l[n + 36 | 0] | l[n + 37 | 0] << 8 | (l[n + 38 | 0] << 16 | l[n + 39 | 0] << 24), tr = E + 48 | 0, t[tr >> 2] = v >>> 20 | Be, t[tr + 4 >> 2] = Me & 1048575, t[E + 80 >> 2] = 0, t[E + 40 >> 2] = d, t[E + 44 >> 2] = v & 1048575, d = l[n + 12 | 0] | l[n + 13 | 0] << 8 | (l[n + 14 | 0] << 16 | l[n + 15 | 0] << 24), dr = d, I = l[n + 8 | 0] | l[n + 9 | 0] << 8 | (l[n + 10 | 0] << 16 | l[n + 11 | 0] << 24), Me = d << 12 | I >>> 20, Be = I << 12 & -4096, Wr = l[n | 0] | l[n + 1 | 0] << 8 | (l[n + 2 | 0] << 16 | l[n + 3 | 0] << 24), I = l[n + 4 | 0] | l[n + 5 | 0] << 8 | (l[n + 6 | 0] << 16 | l[n + 7 | 0] << 24), d = I, v = E, L = d >>> 20 | Be, t[v + 8 >> 2] = L, Ir = Me & 1048575, t[v + 12 >> 2] = Ir, t[v >> 2] = Wr, xr = d & 1048575, t[v + 4 >> 2] = xr, I = l[n + 24 | 0] | l[n + 25 | 0] << 8 | (l[n + 26 | 0] << 16 | l[n + 27 | 0] << 24), Me = I, d = l[n + 28 | 0] | l[n + 29 | 0] << 8 | (l[n + 30 | 0] << 16 | l[n + 31 | 0] << 24), a = (d & 65535) << 16 | I >>> 16, t[v + 32 >> 2] = a, Be = d >>> 16 | 0, t[v + 36 >> 2] = Be, I = l[n + 16 | 0] | l[n + 17 | 0] << 8 | (l[n + 18 | 0] << 16 | l[n + 19 | 0] << 24), d = l[n + 20 | 0] | l[n + 21 | 0] << 8 | (l[n + 22 | 0] << 16 | l[n + 23 | 0] << 24), gr = d << 24 | I >>> 8, Mr = I << 24 & -16777216 | dr >>> 8, t[v + 16 >> 2] = Mr, dr = gr & 1048575, t[v + 20 >> 2] = dr, tr = Me << 4 & 1048560, I = (d & 268435455) << 4 | I >>> 28, t[v + 24 >> 2] = I, v = d >>> 28 | tr, t[E + 28 >> 2] = v, !(L | Wr | a | Mr | I | (Ir | xr | Be | dr | v))) {
              Qn[t[or + 168 >> 2]](690116, t[or + 172 >> 2]);
              break r;
            }
            if (t[E + 92 >> 2] = 0, Zr(E + 96 | 0, 690949, E + 92 | 0), t[E + 92 >> 2] || (d = E + 8 | 0, I = t[d + 4 >> 2], a = E + 160 | 0, v = a + 8 | 0, t[v >> 2] = t[d >> 2], t[v + 4 >> 2] = I, d = E + 16 | 0, I = t[d + 4 >> 2], v = a + 16 | 0, t[v >> 2] = t[d >> 2], t[v + 4 >> 2] = I, d = E + 24 | 0, I = t[d + 4 >> 2], v = a + 24 | 0, t[v >> 2] = t[d >> 2], t[v + 4 >> 2] = I, d = E + 32 | 0, I = t[d + 4 >> 2], v = a + 32 | 0, t[v >> 2] = t[d >> 2], t[v + 4 >> 2] = I, d = E + 48 | 0, I = t[d + 4 >> 2], v = a + 48 | 0, t[v >> 2] = t[d >> 2], t[v + 4 >> 2] = I, d = E + 56 | 0, I = t[d + 4 >> 2], v = a + 56 | 0, t[v >> 2] = t[d >> 2], t[v + 4 >> 2] = I, d = E - -64 | 0, I = t[d + 4 >> 2], v = a - -64 | 0, t[v >> 2] = t[d >> 2], t[v + 4 >> 2] = I, d = E + 72 | 0, I = t[d + 4 >> 2], v = a + 72 | 0, t[v >> 2] = t[d >> 2], t[v + 4 >> 2] = I, t[E + 280 >> 2] = 0, v = t[E + 4 >> 2], t[E + 160 >> 2] = t[E >> 2], t[E + 164 >> 2] = v, v = t[E + 44 >> 2], t[E + 200 >> 2] = t[E + 40 >> 2], t[E + 204 >> 2] = v, v = E + 248 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = E + 256 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = E + 264 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = E + 272 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, I = E + 128 | 0, v = I + 16 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = I + 24 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, t[E + 240 >> 2] = 1, t[E + 244 >> 2] = 0, t[E + 136 >> 2] = 0, t[E + 140 >> 2] = 0, t[E + 128 >> 2] = 1, t[E + 132 >> 2] = 0, Or(a, a, I, E + 96 | 0), t[E + 280 >> 2]))
              break r;
            ki(E, E + 160 | 0), In(he, E), cr = 1;
          }
          if (x = E + 288 | 0, cr) {
            if (t[T + 132 >> 2] = 0, v = vr(rr(), T + 8 | 0, T + 132 | 0, T + 136 | 0), t[T + 204 >> 2] = v, (v | 0) != 1 || (v = Pr(t[172688], T + 8 | 0), t[T + 204 >> 2] = v, (v | 0) != 1))
              break e;
            v = t[T + 132 >> 2];
            break t;
          }
          v = -1;
          break t;
        }
        P(1);
      }
      return x = T + 208 | 0, v | 0;
    }
    t[T + 80 >> 2] = 0, Ne(T + 72 | 0), wasm2js_trap();
  }
  function lr(v) {
    v = v | 0;
    var d = 0, I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0;
    n = x - 192 | 0, x = n, I = n + 128 | 0, Be = I + 56 | 0, t[Be >> 2] = 0, t[Be + 4 >> 2] = 0, Me = I + 48 | 0, t[Me >> 2] = 0, t[Me + 4 >> 2] = 0, L = I + 40 | 0, t[L >> 2] = 0, t[L + 4 >> 2] = 0, cr = I + 32 | 0, t[cr >> 2] = 0, t[cr + 4 >> 2] = 0, Mr = I + 24 | 0, t[Mr >> 2] = 0, t[Mr + 4 >> 2] = 0, Wr = I + 16 | 0, t[Wr >> 2] = 0, t[Wr + 4 >> 2] = 0, xr = I + 8 | 0, t[xr >> 2] = 0, t[xr + 4 >> 2] = 0, t[n + 128 >> 2] = 0, t[n + 132 >> 2] = 0;
    e: {
      if ((Ds(t[172688], I, 690885) | 0) == 1) {
        if (I = n + 128 | 0, d = I + 15 | 0, a = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), E = n - -64 | 0, tr = E + 8 | 0, t[tr >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[tr + 4 >> 2] = a, d = I + 23 | 0, a = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), dr = E + 16 | 0, t[dr >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[dr + 4 >> 2] = a, d = I + 31 | 0, a = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), or = E + 24 | 0, t[or >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[or + 4 >> 2] = a, d = I + 39 | 0, a = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), gr = E + 32 | 0, t[gr >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[gr + 4 >> 2] = a, d = I + 47 | 0, a = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), Ir = E + 40 | 0, t[Ir >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[Ir + 4 >> 2] = a, d = I + 55 | 0, a = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), he = E + 48 | 0, t[he >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[he + 4 >> 2] = a, d = E + 56 | 0, u[d | 0] = l[I + 63 | 0], u[n + 2 | 0] = l[n + 130 | 0], p[n >> 1] = m[n + 128 >> 1], E = l[n + 139 | 0] | l[n + 140 | 0] << 8 | (l[n + 141 | 0] << 16 | l[n + 142 | 0] << 24), t[n + 64 >> 2] = l[n + 135 | 0] | l[n + 136 | 0] << 8 | (l[n + 137 | 0] << 16 | l[n + 138 | 0] << 24), t[n + 68 >> 2] = E, E = l[n + 131 | 0] | l[n + 132 | 0] << 8 | (l[n + 133 | 0] << 16 | l[n + 134 | 0] << 24), u[n + 63 | 0] = l[d | 0], a = t[he + 4 >> 2], d = n + 55 | 0, he = t[he >> 2], u[d | 0] = he, u[d + 1 | 0] = he >>> 8, u[d + 2 | 0] = he >>> 16, u[d + 3 | 0] = he >>> 24, u[d + 4 | 0] = a, u[d + 5 | 0] = a >>> 8, u[d + 6 | 0] = a >>> 16, u[d + 7 | 0] = a >>> 24, a = t[Ir + 4 >> 2], d = n + 47 | 0, Ir = t[Ir >> 2], u[d | 0] = Ir, u[d + 1 | 0] = Ir >>> 8, u[d + 2 | 0] = Ir >>> 16, u[d + 3 | 0] = Ir >>> 24, u[d + 4 | 0] = a, u[d + 5 | 0] = a >>> 8, u[d + 6 | 0] = a >>> 16, u[d + 7 | 0] = a >>> 24, a = t[gr + 4 >> 2], d = n + 39 | 0, gr = t[gr >> 2], u[d | 0] = gr, u[d + 1 | 0] = gr >>> 8, u[d + 2 | 0] = gr >>> 16, u[d + 3 | 0] = gr >>> 24, u[d + 4 | 0] = a, u[d + 5 | 0] = a >>> 8, u[d + 6 | 0] = a >>> 16, u[d + 7 | 0] = a >>> 24, a = t[or + 4 >> 2], d = n + 31 | 0, or = t[or >> 2], u[d | 0] = or, u[d + 1 | 0] = or >>> 8, u[d + 2 | 0] = or >>> 16, u[d + 3 | 0] = or >>> 24, u[d + 4 | 0] = a, u[d + 5 | 0] = a >>> 8, u[d + 6 | 0] = a >>> 16, u[d + 7 | 0] = a >>> 24, a = t[dr + 4 >> 2], d = n + 23 | 0, dr = t[dr >> 2], u[d | 0] = dr, u[d + 1 | 0] = dr >>> 8, u[d + 2 | 0] = dr >>> 16, u[d + 3 | 0] = dr >>> 24, u[d + 4 | 0] = a, u[d + 5 | 0] = a >>> 8, u[d + 6 | 0] = a >>> 16, u[d + 7 | 0] = a >>> 24, a = t[tr + 4 >> 2], d = n + 15 | 0, tr = t[tr >> 2], u[d | 0] = tr, u[d + 1 | 0] = tr >>> 8, u[d + 2 | 0] = tr >>> 16, u[d + 3 | 0] = tr >>> 24, u[d + 4 | 0] = a, u[d + 5 | 0] = a >>> 8, u[d + 6 | 0] = a >>> 16, u[d + 7 | 0] = a >>> 24, u[n + 3 | 0] = E, u[n + 4 | 0] = E >>> 8, u[n + 5 | 0] = E >>> 16, u[n + 6 | 0] = E >>> 24, d = t[n + 68 >> 2], E = t[n + 64 >> 2], u[n + 7 | 0] = E, u[n + 8 | 0] = E >>> 8, u[n + 9 | 0] = E >>> 16, u[n + 10 | 0] = E >>> 24, u[n + 11 | 0] = d, u[n + 12 | 0] = d >>> 8, u[n + 13 | 0] = d >>> 16, u[n + 14 | 0] = d >>> 24, t[Be >> 2] = 0, t[Be + 4 >> 2] = 0, t[Me >> 2] = 0, t[Me + 4 >> 2] = 0, t[L >> 2] = 0, t[L + 4 >> 2] = 0, t[cr >> 2] = 0, t[cr + 4 >> 2] = 0, t[Mr >> 2] = 0, t[Mr + 4 >> 2] = 0, t[Wr >> 2] = 0, t[Wr + 4 >> 2] = 0, t[xr >> 2] = 0, t[xr + 4 >> 2] = 0, t[n + 128 >> 2] = 0, t[n + 132 >> 2] = 0, (Ds(t[172688], I, 690917) | 0) == 1) {
          xr = rr(), T = x - 288 | 0, x = T;
          t: {
            if (!n) {
              Qn[t[xr + 168 >> 2]](689629, t[xr + 172 >> 2]);
              break t;
            }
            if (E = l[n + 60 | 0] | l[n + 61 | 0] << 8 | (l[n + 62 | 0] << 16 | l[n + 63 | 0] << 24), I = E >>> 16 | 0, a = T + 72 | 0, d = l[n + 56 | 0] | l[n + 57 | 0] << 8 | (l[n + 58 | 0] << 16 | l[n + 59 | 0] << 24), t[a >> 2] = (E & 65535) << 16 | d >>> 16, t[a + 4 >> 2] = I, Be = d << 4 & 1048560, E = l[n + 52 | 0] | l[n + 53 | 0] << 8 | (l[n + 54 | 0] << 16 | l[n + 55 | 0] << 24), I = E >>> 28 | 0, a = T - -64 | 0, d = l[n + 48 | 0] | l[n + 49 | 0] << 8 | (l[n + 50 | 0] << 16 | l[n + 51 | 0] << 24), t[a >> 2] = (E & 268435455) << 4 | d >>> 28, t[a + 4 >> 2] = I | Be, I = E << 24 | d >>> 8, Be = d << 24 & -16777216, d = l[n + 40 | 0] | l[n + 41 | 0] << 8 | (l[n + 42 | 0] << 16 | l[n + 43 | 0] << 24), a = T + 56 | 0, E = l[n + 44 | 0] | l[n + 45 | 0] << 8 | (l[n + 46 | 0] << 16 | l[n + 47 | 0] << 24), t[a >> 2] = E >>> 8 | Be, t[a + 4 >> 2] = I & 1048575, E = (E << 12 | d >>> 20) & 1048575, Be = l[n + 32 | 0] | l[n + 33 | 0] << 8 | (l[n + 34 | 0] << 16 | l[n + 35 | 0] << 24), a = T + 48 | 0, Me = l[n + 36 | 0] | l[n + 37 | 0] << 8 | (l[n + 38 | 0] << 16 | l[n + 39 | 0] << 24), t[a >> 2] = d << 12 & -4096 | Me >>> 20, t[a + 4 >> 2] = E, t[T + 40 >> 2] = Be, t[T + 44 >> 2] = Me & 1048575, I = l[n + 12 | 0] | l[n + 13 | 0] << 8 | (l[n + 14 | 0] << 16 | l[n + 15 | 0] << 24), a = I, E = l[n + 8 | 0] | l[n + 9 | 0] << 8 | (l[n + 10 | 0] << 16 | l[n + 11 | 0] << 24), I = I << 12 | E >>> 20, Be = E << 12 & -4096, E = l[n | 0] | l[n + 1 | 0] << 8 | (l[n + 2 | 0] << 16 | l[n + 3 | 0] << 24), d = T, L = l[n + 4 | 0] | l[n + 5 | 0] << 8 | (l[n + 6 | 0] << 16 | l[n + 7 | 0] << 24), tr = L >>> 20 | Be, t[d + 8 >> 2] = tr, dr = I & 1048575, t[d + 12 >> 2] = dr, Be = E, t[d >> 2] = E, or = L & 1048575, t[d + 4 >> 2] = or, E = l[n + 28 | 0] | l[n + 29 | 0] << 8 | (l[n + 30 | 0] << 16 | l[n + 31 | 0] << 24), I = E >>> 16 | 0, Me = l[n + 24 | 0] | l[n + 25 | 0] << 8 | (l[n + 26 | 0] << 16 | l[n + 27 | 0] << 24), Mr = (E & 65535) << 16 | Me >>> 16, t[d + 32 >> 2] = Mr, cr = I, t[d + 36 >> 2] = I, I = l[n + 20 | 0] | l[n + 21 | 0] << 8 | (l[n + 22 | 0] << 16 | l[n + 23 | 0] << 24), E = l[n + 16 | 0] | l[n + 17 | 0] << 8 | (l[n + 18 | 0] << 16 | l[n + 19 | 0] << 24), Ir = (I << 24 | E >>> 8) & 1048575, a = E << 24 & -16777216 | a >>> 8, t[d + 16 >> 2] = a, gr = Ir, t[d + 20 >> 2] = gr, Me = Me << 4 & 1048560, d = I, I = d >>> 28 | 0, d = (d & 268435455) << 4 | E >>> 28, t[T + 24 >> 2] = d, I = I | Me, t[T + 28 >> 2] = I, !(Be | tr | Mr | a | d | (dr | or | cr | gr | I))) {
              Qn[t[xr + 168 >> 2]](690116, t[xr + 172 >> 2]);
              break t;
            }
            if (t[T + 92 >> 2] = 0, Zr(T + 96 | 0, 690949, T + 92 | 0), t[T + 92 >> 2] || (d = T + 8 | 0, E = t[d + 4 >> 2], I = T + 160 | 0, a = I + 8 | 0, t[a >> 2] = t[d >> 2], t[a + 4 >> 2] = E, d = T + 16 | 0, E = t[d + 4 >> 2], a = I + 16 | 0, t[a >> 2] = t[d >> 2], t[a + 4 >> 2] = E, d = T + 24 | 0, E = t[d + 4 >> 2], a = I + 24 | 0, t[a >> 2] = t[d >> 2], t[a + 4 >> 2] = E, d = T + 32 | 0, E = t[d + 4 >> 2], a = I + 32 | 0, t[a >> 2] = t[d >> 2], t[a + 4 >> 2] = E, d = T + 48 | 0, E = t[d + 4 >> 2], a = I + 48 | 0, t[a >> 2] = t[d >> 2], t[a + 4 >> 2] = E, d = T + 56 | 0, E = t[d + 4 >> 2], a = I + 56 | 0, t[a >> 2] = t[d >> 2], t[a + 4 >> 2] = E, d = T - -64 | 0, E = t[d + 4 >> 2], a = I - -64 | 0, t[a >> 2] = t[d >> 2], t[a + 4 >> 2] = E, d = T + 72 | 0, E = t[d + 4 >> 2], a = I + 72 | 0, t[a >> 2] = t[d >> 2], t[a + 4 >> 2] = E, t[T + 280 >> 2] = 0, d = t[T + 4 >> 2], t[T + 160 >> 2] = t[T >> 2], t[T + 164 >> 2] = d, d = t[T + 44 >> 2], t[T + 200 >> 2] = t[T + 40 >> 2], t[T + 204 >> 2] = d, d = T + 248 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = T + 256 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = T + 264 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = T + 272 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = T + 128 | 0, E = d + 16 | 0, t[E >> 2] = 0, t[E + 4 >> 2] = 0, E = d + 24 | 0, t[E >> 2] = 0, t[E + 4 >> 2] = 0, t[T + 240 >> 2] = 1, t[T + 244 >> 2] = 0, t[T + 136 >> 2] = 0, t[T + 140 >> 2] = 0, t[T + 128 >> 2] = 1, t[T + 132 >> 2] = 0, Or(I, I, d, T + 96 | 0), t[T + 280 >> 2]) || (ki(T, T + 160 | 0), E = t[T + 8 >> 2], a = t[T + 12 >> 2], Be = t[T + 4 >> 2], L = t[T + 32 >> 2], Me = t[T + 36 >> 2], Mr = Me, I = t[T >> 2], d = pn(Me >>> 16 | 0, 0, 977, 1), gr = I + d | 0, I = Be + Ee | 0, cr = d >>> 0 > gr >>> 0 ? I + 1 | 0 : I, I = a, d = cr >>> 20 | 0, a = d, d = d + E | 0, a = a >>> 0 > d >>> 0 ? I + 1 | 0 : I, xr = a & 1048575, Wr = t[T + 24 >> 2], tr = t[T + 28 >> 2], I = t[T + 20 >> 2], E = a >>> 20 | 0, Me = E + t[T + 16 >> 2] | 0, Be = E >>> 0 > Me >>> 0 ? I + 1 | 0 : I, I = tr, E = Be >>> 20 | 0, he = E, E = E + Wr | 0, I = he >>> 0 > E >>> 0 ? I + 1 | 0 : I, tr = I & 1048575, Be = Be & 1048575, Wr = (d & Me & E) == -1 & (a & Be & I) == 1048575, a = I, I = Mr & 65535, a = a >>> 20 | 0, or = a + L | 0, I = a >>> 0 > or >>> 0 ? I + 1 | 0 : I, a = I, dr = cr & 1048575, Wr & ((or | 0) == -1 & (I | 0) == 65535) & ((dr | 0) == 1048574 & gr >>> 0 > 4294966318 | dr >>> 0 > 1048574) | I >>> 16 && (I = dr + 1 | 0, gr = gr + 977 | 0, I = gr >>> 0 < 977 ? I + 1 | 0 : I, dr = I & 1048575, L = I, I = xr, L = L >>> 20 | 0, d = d + L | 0, I = L >>> 0 > d >>> 0 ? I + 1 | 0 : I, xr = I & 1048575, L = I, I = Be, L = L >>> 20 | 0, Me = L + Me | 0, I = L >>> 0 > Me >>> 0 ? I + 1 | 0 : I, Be = I & 1048575, L = I, I = tr, L = L >>> 20 | 0, E = E + L | 0, I = L >>> 0 > E >>> 0 ? I + 1 | 0 : I, tr = I & 1048575, L = I, I = a, a = or, or = (L >>> 20 | 0) + or | 0, a = (a >>> 0 > or >>> 0 ? I + 1 | 0 : I) & 65535), t[T + 32 >> 2] = or, t[T + 36 >> 2] = a, t[T + 24 >> 2] = E, t[T + 28 >> 2] = tr, t[T + 16 >> 2] = Me, t[T + 20 >> 2] = Be, t[T + 8 >> 2] = d, t[T + 12 >> 2] = xr, t[T >> 2] = gr, t[T + 4 >> 2] = dr, Mr = t[T + 48 >> 2], Wr = t[T + 52 >> 2], he = t[T + 44 >> 2], L = t[T + 72 >> 2], Ir = t[T + 76 >> 2], kn = Ir, I = t[T + 40 >> 2], cr = pn(Ir >>> 16 | 0, 0, 977, 1), Ir = I + cr | 0, I = he + Ee | 0, gn = cr >>> 0 > Ir >>> 0 ? I + 1 | 0 : I, I = Wr, cr = gn >>> 20 | 0, Mr = cr + Mr | 0, he = cr >>> 0 > Mr >>> 0 ? I + 1 | 0 : I, xn = he & 1048575, Bn = L, Un = kn & 65535, cr = t[T + 64 >> 2], $r = t[T + 68 >> 2], I = t[T + 60 >> 2], L = he >>> 20 | 0, Wr = L + t[T + 56 >> 2] | 0, kn = L >>> 0 > Wr >>> 0 ? I + 1 | 0 : I, I = $r, L = kn >>> 20 | 0, $r = L, L = L + cr | 0, cr = $r >>> 0 > L >>> 0 ? I + 1 | 0 : I, I = Un, $r = cr >>> 20 | 0, Un = $r, $r = Bn + $r | 0, I = Un >>> 0 > $r >>> 0 ? I + 1 | 0 : I, Bn = kn & 1048575, gn = gn & 1048575, (Wr & Mr & L) == -1 & (he & Bn & cr) == 1048575 & (($r | 0) == -1 & (I | 0) == 65535) & ((gn | 0) == 1048574 & Ir >>> 0 > 4294966318 | gn >>> 0 > 1048574) | I >>> 16 && (I = gn + 1 | 0, Ir = Ir + 977 | 0, I = Ir >>> 0 < 977 ? I + 1 | 0 : I, gn = I & 1048575, he = I, I = xn, he = he >>> 20 | 0, Mr = he + Mr | 0, I = he >>> 0 > Mr >>> 0 ? I + 1 | 0 : I, xn = I & 1048575, he = I, I = Bn, he = he >>> 20 | 0, Wr = he + Wr | 0, I = he >>> 0 > Wr >>> 0 ? I + 1 | 0 : I, Bn = I & 1048575, he = I, I = cr, he = he >>> 20 | 0, L = L + he | 0, cr = he >>> 0 > L >>> 0 ? I + 1 | 0 : I), t[T + 56 >> 2] = Wr, t[T + 60 >> 2] = Bn, t[T + 48 >> 2] = Mr, t[T + 52 >> 2] = xn, t[T + 40 >> 2] = Ir, t[T + 44 >> 2] = gn, t[T + 64 >> 2] = L, t[T + 68 >> 2] = cr & 1048575, l[690917] != (a >>> 8 & 255)) || l[690918] != (a & 255) || l[690919] != (((a & 16777215) << 8 | or >>> 24) & 255) || l[690920] != (((a & 65535) << 16 | or >>> 16) & 255) || l[690921] != (((a & 255) << 24 | or >>> 8) & 255) || l[690922] != (or & 255) || l[690923] != (tr >>> 12 | 0) || l[690924] != (tr >>> 4 & 255) || l[690925] != (((tr & 268435455) << 4 | E >>> 28) & 255) || l[690926] != (((tr & 1048575) << 12 | E >>> 20) & 255) || l[690927] != (((tr & 4095) << 20 | E >>> 12) & 255) || l[690928] != (((tr & 15) << 28 | E >>> 4) & 255) || l[690929] != ((E << 4 | Be >>> 16) & 255) || (I = Be, l[690930] != (I >>> 8 & 255)) || l[690931] != (I & 255) || l[690932] != (((Be & 16777215) << 8 | Me >>> 24) & 255) || l[690933] != (((Be & 65535) << 16 | Me >>> 16) & 255) || l[690934] != (((Be & 255) << 24 | Me >>> 8) & 255) || l[690935] != (Me & 255) || l[690936] != (xr >>> 12 | 0) || l[690937] != (xr >>> 4 & 255) || l[690938] != (((xr & 268435455) << 4 | d >>> 28) & 255) || l[690939] != (((xr & 1048575) << 12 | d >>> 20) & 255) || l[690940] != (((xr & 4095) << 20 | d >>> 12) & 255) || l[690941] != (((xr & 15) << 28 | d >>> 4) & 255) || l[690942] != ((d << 4 | dr >>> 16) & 255) || (I = dr, l[690943] != (I >>> 8 & 255)) || l[690944] != (I & 255) || l[690945] != (((dr & 16777215) << 8 | gr >>> 24) & 255) || l[690946] != (((dr & 65535) << 16 | gr >>> 16) & 255) || l[690947] != (((dr & 255) << 24 | gr >>> 8) & 255) || l[690948] != (gr & 255))
              break t;
            Gn = (Ir & 1) == (v | 0);
          }
          x = T + 288 | 0;
          break e;
        }
        P(1);
        break e;
      }
      P(1);
    }
    return x = n + 192 | 0, Gn | 0;
  }
  function br(v, d) {
    v = v | 0, d = d | 0;
    var I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0;
    n = x - 208 | 0, x = n, I = n + 136 | 0, E = I + 56 | 0, t[E >> 2] = 0, t[E + 4 >> 2] = 0, E = I + 48 | 0, t[E >> 2] = 0, t[E + 4 >> 2] = 0, E = I + 40 | 0, t[E >> 2] = 0, t[E + 4 >> 2] = 0, E = I + 32 | 0, t[E >> 2] = 0, t[E + 4 >> 2] = 0, E = I + 24 | 0, t[E >> 2] = 0, t[E + 4 >> 2] = 0, E = I + 16 | 0, t[E >> 2] = 0, t[E + 4 >> 2] = 0, E = I + 8 | 0, t[E >> 2] = 0, t[E + 4 >> 2] = 0, t[n + 136 >> 2] = 0, t[n + 140 >> 2] = 0;
    e: {
      if ((si(t[172688], I, 690820, v) | 0) == 1) {
        if (I = n + 136 | 0, v = I + 15 | 0, a = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), E = n + 72 | 0, T = E + 8 | 0, t[T >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[T + 4 >> 2] = a, v = I + 23 | 0, a = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), L = E + 16 | 0, t[L >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[L + 4 >> 2] = a, v = I + 31 | 0, a = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), he = E + 24 | 0, t[he >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[he + 4 >> 2] = a, v = I + 39 | 0, a = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), Be = E + 32 | 0, t[Be >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[Be + 4 >> 2] = a, v = I + 47 | 0, a = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), Me = E + 40 | 0, t[Me >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[Me + 4 >> 2] = a, v = I + 55 | 0, a = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), tr = E + 48 | 0, t[tr >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[tr + 4 >> 2] = a, a = E + 56 | 0, u[a | 0] = l[I + 63 | 0], u[n + 10 | 0] = l[n + 138 | 0], p[n + 8 >> 1] = m[n + 136 >> 1], v = l[n + 147 | 0] | l[n + 148 | 0] << 8 | (l[n + 149 | 0] << 16 | l[n + 150 | 0] << 24), t[n + 72 >> 2] = l[n + 143 | 0] | l[n + 144 | 0] << 8 | (l[n + 145 | 0] << 16 | l[n + 146 | 0] << 24), t[n + 76 >> 2] = v, E = l[n + 139 | 0] | l[n + 140 | 0] << 8 | (l[n + 141 | 0] << 16 | l[n + 142 | 0] << 24), v = n + 8 | 0, u[v + 63 | 0] = l[a | 0], a = t[tr + 4 >> 2], I = v + 55 | 0, tr = t[tr >> 2], u[I | 0] = tr, u[I + 1 | 0] = tr >>> 8, u[I + 2 | 0] = tr >>> 16, u[I + 3 | 0] = tr >>> 24, u[I + 4 | 0] = a, u[I + 5 | 0] = a >>> 8, u[I + 6 | 0] = a >>> 16, u[I + 7 | 0] = a >>> 24, a = t[Me + 4 >> 2], I = v + 47 | 0, Me = t[Me >> 2], u[I | 0] = Me, u[I + 1 | 0] = Me >>> 8, u[I + 2 | 0] = Me >>> 16, u[I + 3 | 0] = Me >>> 24, u[I + 4 | 0] = a, u[I + 5 | 0] = a >>> 8, u[I + 6 | 0] = a >>> 16, u[I + 7 | 0] = a >>> 24, a = t[Be + 4 >> 2], I = v + 39 | 0, Be = t[Be >> 2], u[I | 0] = Be, u[I + 1 | 0] = Be >>> 8, u[I + 2 | 0] = Be >>> 16, u[I + 3 | 0] = Be >>> 24, u[I + 4 | 0] = a, u[I + 5 | 0] = a >>> 8, u[I + 6 | 0] = a >>> 16, u[I + 7 | 0] = a >>> 24, a = t[he + 4 >> 2], I = v + 31 | 0, he = t[he >> 2], u[I | 0] = he, u[I + 1 | 0] = he >>> 8, u[I + 2 | 0] = he >>> 16, u[I + 3 | 0] = he >>> 24, u[I + 4 | 0] = a, u[I + 5 | 0] = a >>> 8, u[I + 6 | 0] = a >>> 16, u[I + 7 | 0] = a >>> 24, a = t[L + 4 >> 2], I = v + 23 | 0, L = t[L >> 2], u[I | 0] = L, u[I + 1 | 0] = L >>> 8, u[I + 2 | 0] = L >>> 16, u[I + 3 | 0] = L >>> 24, u[I + 4 | 0] = a, u[I + 5 | 0] = a >>> 8, u[I + 6 | 0] = a >>> 16, u[I + 7 | 0] = a >>> 24, a = t[T + 4 >> 2], I = v + 15 | 0, T = t[T >> 2], u[I | 0] = T, u[I + 1 | 0] = T >>> 8, u[I + 2 | 0] = T >>> 16, u[I + 3 | 0] = T >>> 24, u[I + 4 | 0] = a, u[I + 5 | 0] = a >>> 8, u[I + 6 | 0] = a >>> 16, u[I + 7 | 0] = a >>> 24, u[n + 11 | 0] = E, u[n + 12 | 0] = E >>> 8, u[n + 13 | 0] = E >>> 16, u[n + 14 | 0] = E >>> 24, I = t[n + 76 >> 2], E = t[n + 72 >> 2], u[n + 15 | 0] = E, u[n + 16 | 0] = E >>> 8, u[n + 17 | 0] = E >>> 16, u[n + 18 | 0] = E >>> 24, u[n + 19 | 0] = I, u[n + 20 | 0] = I >>> 8, u[n + 21 | 0] = I >>> 16, u[n + 22 | 0] = I >>> 24, t[n + 204 >> 2] = d, v = zr(t[172688], n + 204 | 0, v, (d | 0) == 33 ? 258 : 2), t[n + 72 >> 2] = v, (v | 0) == 1)
          break e;
        t[n + 144 >> 2] = 0, Ne(n + 136 | 0), wasm2js_trap();
      }
      P(1);
    }
    x = n + 208 | 0;
  }
  function Br(v) {
    v = v | 0;
    var d = 0, I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0;
    I = x - 96 | 0, x = I, d = I + 56 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = I + 48 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = I + 40 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = I + 32 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = I + 24 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = I + 16 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = I + 8 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, a = rr(), n = x - 256 | 0, x = n;
    e: {
      if (!I) {
        Qn[t[a + 168 >> 2]](689638, t[a + 172 >> 2]), d = 0;
        break e;
      }
      if (u[I | 0] = 0, u[I + 1 | 0] = 0, u[I + 2 | 0] = 0, u[I + 3 | 0] = 0, u[I + 4 | 0] = 0, u[I + 5 | 0] = 0, u[I + 6 | 0] = 0, u[I + 7 | 0] = 0, d = I + 56 | 0, u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, d = I + 48 | 0, u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, d = I + 40 | 0, u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, d = I + 32 | 0, u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, d = I + 24 | 0, u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, d = I + 16 | 0, u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, d = I + 8 | 0, u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, !t[a >> 2]) {
        Qn[t[a + 168 >> 2]](690045, t[a + 172 >> 2]), d = 0;
        break e;
      }
      he = n + 8 | 0, T = n + 128 | 0, Zr(he, 690788, T), Be = t[n + 32 >> 2], Me = t[n + 24 >> 2], E = t[n + 16 >> 2], tr = t[n + 8 >> 2], or = t[n + 36 >> 2], cr = t[n + 28 >> 2], dr = t[n + 20 >> 2], gr = t[n + 12 >> 2], L = t[n + 128 >> 2] | !(Be | (Me | (E | tr)) | (or | (cr | (dr | gr)))), d = L ? 0 : -1, t[n + 32 >> 2] = d & Be, t[n + 36 >> 2] = d & or, t[n + 24 >> 2] = d & Me, t[n + 28 >> 2] = d & cr, t[n + 16 >> 2] = d & E, t[n + 20 >> 2] = d & dr, E = (L | 0) != 0, t[n + 8 >> 2] = E | d & tr, t[n + 12 >> 2] = d & gr, hi(a, T, he), d = n + 40 | 0, ki(d, T), In(I, d), t[n + 128 >> 2] = E, d = t[n + 128 >> 2] - 1 | 0, u[I | 0] = d & l[I | 0], u[I + 1 | 0] = l[I + 1 | 0] & d, u[I + 2 | 0] = l[I + 2 | 0] & d, u[I + 3 | 0] = l[I + 3 | 0] & d, u[I + 4 | 0] = l[I + 4 | 0] & d, u[I + 5 | 0] = l[I + 5 | 0] & d, u[I + 6 | 0] = l[I + 6 | 0] & d, u[I + 7 | 0] = l[I + 7 | 0] & d, u[I + 8 | 0] = l[I + 8 | 0] & d, u[I + 9 | 0] = l[I + 9 | 0] & d, u[I + 10 | 0] = l[I + 10 | 0] & d, u[I + 11 | 0] = l[I + 11 | 0] & d, u[I + 12 | 0] = l[I + 12 | 0] & d, u[I + 13 | 0] = l[I + 13 | 0] & d, u[I + 14 | 0] = l[I + 14 | 0] & d, u[I + 15 | 0] = l[I + 15 | 0] & d, u[I + 16 | 0] = l[I + 16 | 0] & d, u[I + 17 | 0] = l[I + 17 | 0] & d, u[I + 18 | 0] = l[I + 18 | 0] & d, u[I + 19 | 0] = l[I + 19 | 0] & d, u[I + 20 | 0] = l[I + 20 | 0] & d, u[I + 21 | 0] = l[I + 21 | 0] & d, u[I + 22 | 0] = l[I + 22 | 0] & d, u[I + 23 | 0] = l[I + 23 | 0] & d, u[I + 24 | 0] = l[I + 24 | 0] & d, u[I + 25 | 0] = l[I + 25 | 0] & d, u[I + 26 | 0] = l[I + 26 | 0] & d, u[I + 27 | 0] = l[I + 27 | 0] & d, u[I + 28 | 0] = l[I + 28 | 0] & d, u[I + 29 | 0] = l[I + 29 | 0] & d, u[I + 30 | 0] = l[I + 30 | 0] & d, u[I + 31 | 0] = l[I + 31 | 0] & d, u[I + 32 | 0] = l[I + 32 | 0] & d, u[I + 33 | 0] = l[I + 33 | 0] & d, u[I + 34 | 0] = l[I + 34 | 0] & d, u[I + 35 | 0] = l[I + 35 | 0] & d, u[I + 36 | 0] = l[I + 36 | 0] & d, u[I + 37 | 0] = l[I + 37 | 0] & d, u[I + 38 | 0] = l[I + 38 | 0] & d, u[I + 39 | 0] = l[I + 39 | 0] & d, u[I + 40 | 0] = l[I + 40 | 0] & d, u[I + 41 | 0] = l[I + 41 | 0] & d, u[I + 42 | 0] = l[I + 42 | 0] & d, u[I + 43 | 0] = l[I + 43 | 0] & d, u[I + 44 | 0] = l[I + 44 | 0] & d, u[I + 45 | 0] = l[I + 45 | 0] & d, u[I + 46 | 0] = l[I + 46 | 0] & d, u[I + 47 | 0] = l[I + 47 | 0] & d, u[I + 48 | 0] = l[I + 48 | 0] & d, u[I + 49 | 0] = l[I + 49 | 0] & d, u[I + 50 | 0] = l[I + 50 | 0] & d, u[I + 51 | 0] = l[I + 51 | 0] & d, u[I + 52 | 0] = l[I + 52 | 0] & d, u[I + 53 | 0] = l[I + 53 | 0] & d, u[I + 54 | 0] = l[I + 54 | 0] & d, u[I + 55 | 0] = l[I + 55 | 0] & d, u[I + 56 | 0] = l[I + 56 | 0] & d, u[I + 57 | 0] = l[I + 57 | 0] & d, u[I + 58 | 0] = l[I + 58 | 0] & d, u[I + 59 | 0] = l[I + 59 | 0] & d, u[I + 60 | 0] = l[I + 60 | 0] & d, u[I + 61 | 0] = l[I + 61 | 0] & d, u[I + 62 | 0] = l[I + 62 | 0] & d, u[I + 63 | 0] = l[I + 63 | 0] & d, d = !L;
    }
    x = n + 256 | 0;
    e: {
      if (d) {
        if (t[I + 64 >> 2] = v, v = zr(t[172688], I - -64 | 0, I, (v | 0) == 33 ? 258 : 2), t[I + 68 >> 2] = v, (v | 0) != 1)
          break e;
        Ir = 1;
      }
      return x = I + 96 | 0, Ir | 0;
    }
    t[I + 80 >> 2] = 0, Ne(I + 72 | 0), wasm2js_trap();
  }
  function Fr() {
    var v = 0, d = 0, I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0;
    n = x - 304 | 0, x = n, I = n + 200 | 0, Vi(I, 96);
    e: {
      t: {
        r: {
          if ((Cr(rr(), I) | 0) == 1) {
            u[n + 10 | 0] = l[n + 202 | 0], p[n + 8 >> 1] = m[n + 200 >> 1], I = l[n + 203 | 0] | l[n + 204 | 0] << 8 | (l[n + 205 | 0] << 16 | l[n + 206 | 0] << 24), v = n + 104 | 0, E = n + 200 | 0, $i(v, E | 7, 89), d = n + 8 | 0, $i(d | 7, v, 89), u[n + 11 | 0] = I, u[n + 12 | 0] = I >>> 8, u[n + 13 | 0] = I >>> 16, u[n + 14 | 0] = I >>> 24, I = n + 256 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = n + 248 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = n + 240 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = n + 232 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = n + 224 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = n + 216 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = n + 208 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, t[n + 200 >> 2] = 0, t[n + 204 >> 2] = 0, t[n + 196 >> 2] = 0, Me = rr(), gr = n + 196 | 0, I = x - 96 | 0, x = I;
            n: {
              if (!E) {
                Qn[t[Me + 168 >> 2]](689638, t[Me + 172 >> 2]), v = 0;
                break n;
              }
              if (u[E | 0] = 0, u[E + 1 | 0] = 0, u[E + 2 | 0] = 0, u[E + 3 | 0] = 0, u[E + 4 | 0] = 0, u[E + 5 | 0] = 0, u[E + 6 | 0] = 0, u[E + 7 | 0] = 0, v = E + 56 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = E + 48 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = E + 40 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = E + 32 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = E + 24 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = E + 16 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = E + 8 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, !d) {
                Qn[t[Me + 168 >> 2]](689700, t[Me + 172 >> 2]), v = 0;
                break n;
              }
              if (tr = l[d + 92 | 0] | l[d + 93 | 0] << 8 | (l[d + 94 | 0] << 16 | l[d + 95 | 0] << 24), v = tr >>> 16 | 0, T = I + 80 | 0, L = l[d + 88 | 0] | l[d + 89 | 0] << 8 | (l[d + 90 | 0] << 16 | l[d + 91 | 0] << 24), tr = (tr & 65535) << 16 | L >>> 16, t[T >> 2] = tr, xn = v, t[T + 4 >> 2] = v, Be = L << 4 & 1048560, a = l[d + 84 | 0] | l[d + 85 | 0] << 8 | (l[d + 86 | 0] << 16 | l[d + 87 | 0] << 24), v = a >>> 28 | 0, T = I + 72 | 0, L = l[d + 80 | 0] | l[d + 81 | 0] << 8 | (l[d + 82 | 0] << 16 | l[d + 83 | 0] << 24), or = (a & 268435455) << 4 | L >>> 28, t[T >> 2] = or, Ir = v | Be, t[T + 4 >> 2] = Ir, v = a << 24 | L >>> 8, he = L << 24 & -16777216, L = l[d + 72 | 0] | l[d + 73 | 0] << 8 | (l[d + 74 | 0] << 16 | l[d + 75 | 0] << 24), Be = I + 8 | 0, T = Be + 56 | 0, a = l[d + 76 | 0] | l[d + 77 | 0] << 8 | (l[d + 78 | 0] << 16 | l[d + 79 | 0] << 24), cr = a >>> 8 | he, t[T >> 2] = cr, xr = v & 1048575, t[T + 4 >> 2] = xr, v = L, a = a << 12 | v >>> 20, L = l[d + 64 | 0] | l[d + 65 | 0] << 8 | (l[d + 66 | 0] << 16 | l[d + 67 | 0] << 24), T = Be + 48 | 0, he = l[d + 68 | 0] | l[d + 69 | 0] << 8 | (l[d + 70 | 0] << 16 | l[d + 71 | 0] << 24), dr = v << 12 & -4096 | he >>> 20, t[T >> 2] = dr, Mr = a & 1048575, t[T + 4 >> 2] = Mr, t[I + 88 >> 2] = 0, t[I + 48 >> 2] = L, Wr = he & 1048575, t[I + 52 >> 2] = Wr, v = l[d + 44 | 0] | l[d + 45 | 0] << 8 | (l[d + 46 | 0] << 16 | l[d + 47 | 0] << 24), T = v, a = l[d + 40 | 0] | l[d + 41 | 0] << 8 | (l[d + 42 | 0] << 16 | l[d + 43 | 0] << 24), he = (v << 12 | a >>> 20) & 1048575, v = l[d + 32 | 0] | l[d + 33 | 0] << 8 | (l[d + 34 | 0] << 16 | l[d + 35 | 0] << 24), Be = a << 12 & -4096, a = l[d + 36 | 0] | l[d + 37 | 0] << 8 | (l[d + 38 | 0] << 16 | l[d + 39 | 0] << 24), $r = Be | a >>> 20, t[I + 16 >> 2] = $r, Un = he, t[I + 20 >> 2] = he, Be = v, t[I + 8 >> 2] = v, gn = a & 1048575, t[I + 12 >> 2] = gn, a = l[d + 60 | 0] | l[d + 61 | 0] << 8 | (l[d + 62 | 0] << 16 | l[d + 63 | 0] << 24), v = a >>> 16 | 0, he = l[d + 56 | 0] | l[d + 57 | 0] << 8 | (l[d + 58 | 0] << 16 | l[d + 59 | 0] << 24), Bn = (a & 65535) << 16 | he >>> 16, t[I + 40 >> 2] = Bn, Gn = v, t[I + 44 >> 2] = v, a = l[d + 48 | 0] | l[d + 49 | 0] << 8 | (l[d + 50 | 0] << 16 | l[d + 51 | 0] << 24), v = l[d + 52 | 0] | l[d + 53 | 0] << 8 | (l[d + 54 | 0] << 16 | l[d + 55 | 0] << 24), d = v, kn = (v << 24 | a >>> 8) & 1048575, T = a << 24 & -16777216 | T >>> 8, t[I + 24 >> 2] = T, t[I + 28 >> 2] = kn, he = he << 4 & 1048560, v = v >>> 28 | 0, a = (d & 268435455) << 4 | a >>> 28, t[I + 32 >> 2] = a, v = v | he, t[I + 36 >> 2] = v, !(Be | $r | Bn | T | a | (Un | gn | Gn | kn | v))) {
                Qn[t[Me + 168 >> 2]](690116, t[Me + 172 >> 2]), v = 0;
                break n;
              }
              L & 1 && (t[I + 80 >> 2] = -4 - tr, t[I + 84 >> 2] = 262143 - ((tr >>> 0 > 4294967292) + xn | 0), t[I + 72 >> 2] = -4 - or, t[I + 76 >> 2] = 4194303 - ((or >>> 0 > 4294967292) + Ir | 0), t[I + 64 >> 2] = -4 - cr, t[I + 68 >> 2] = 4194303 - ((cr >>> 0 > 4294967292) + xr | 0), t[I + 56 >> 2] = -4 - dr, t[I + 60 >> 2] = 4194303 - ((dr >>> 0 > 4294967292) + Mr | 0), t[I + 48 >> 2] = -3908 - L, t[I + 52 >> 2] = 4194299 - ((L >>> 0 > 4294963388) + Wr | 0), jn = 1), gr && (t[gr >> 2] = jn), In(E, I + 8 | 0), v = 1;
            }
            if (x = I + 96 | 0, t[n + 300 >> 2] = v, (v | 0) == 1)
              break r;
            break e;
          }
          P(0);
          break t;
        }
        if (I = Pr(t[172688], n + 200 | 0), t[n + 300 >> 2] = I, v = 1, (I | 0) == 1)
          break t;
        break e;
      }
      return x = n + 304 | 0, v | 0;
    }
    t[n + 112 >> 2] = 0, Ne(n + 104 | 0), wasm2js_trap();
  }
  function Gr(v) {
    v = v | 0;
    var d = 0, I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0;
    n = x - 272 | 0, x = n, d = n + 8 | 0, a = d + 56 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, I = d + 48 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, E = d + 40 | 0, t[E >> 2] = 0, t[E + 4 >> 2] = 0, T = d + 32 | 0, t[T >> 2] = 0, t[T + 4 >> 2] = 0, L = d + 24 | 0, t[L >> 2] = 0, t[L + 4 >> 2] = 0, he = d + 16 | 0, t[he >> 2] = 0, t[he + 4 >> 2] = 0, Be = d + 8 | 0, t[Be >> 2] = 0, t[Be + 4 >> 2] = 0, t[n + 8 >> 2] = 0, t[n + 12 >> 2] = 0, t[n + 76 >> 2] = 0, d = n + 208 | 0, Me = d + 56 | 0, t[Me >> 2] = 0, t[Me + 4 >> 2] = 0, tr = d + 48 | 0, t[tr >> 2] = 0, t[tr + 4 >> 2] = 0, or = d + 40 | 0, t[or >> 2] = 0, t[or + 4 >> 2] = 0, cr = d + 32 | 0, t[cr >> 2] = 0, t[cr + 4 >> 2] = 0, dr = d + 24 | 0, t[dr >> 2] = 0, t[dr + 4 >> 2] = 0, gr = d + 16 | 0, t[gr >> 2] = 0, t[gr + 4 >> 2] = 0, Ir = d + 8 | 0, t[Ir >> 2] = 0, t[Ir + 4 >> 2] = 0, t[n + 208 >> 2] = 0, t[n + 212 >> 2] = 0;
    e: {
      t: {
        if ((si(t[172688], d, 690820, v) | 0) == 1) {
          if (d = n + 208 | 0, v = d + 15 | 0, I = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), a = n + 144 | 0, E = a + 8 | 0, t[E >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[E + 4 >> 2] = I, v = d + 23 | 0, I = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), T = a + 16 | 0, t[T >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[T + 4 >> 2] = I, v = d + 31 | 0, I = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), L = a + 24 | 0, t[L >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[L + 4 >> 2] = I, v = d + 39 | 0, I = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), he = a + 32 | 0, t[he >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[he + 4 >> 2] = I, v = d + 47 | 0, I = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), Be = a + 40 | 0, t[Be >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[Be + 4 >> 2] = I, v = d + 55 | 0, I = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), Me = a + 48 | 0, t[Me >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[Me + 4 >> 2] = I, I = a + 56 | 0, u[I | 0] = l[d + 63 | 0], u[n + 82 | 0] = l[n + 210 | 0], p[n + 80 >> 1] = m[n + 208 >> 1], v = l[n + 219 | 0] | l[n + 220 | 0] << 8 | (l[n + 221 | 0] << 16 | l[n + 222 | 0] << 24), t[n + 144 >> 2] = l[n + 215 | 0] | l[n + 216 | 0] << 8 | (l[n + 217 | 0] << 16 | l[n + 218 | 0] << 24), t[n + 148 >> 2] = v, a = l[n + 211 | 0] | l[n + 212 | 0] << 8 | (l[n + 213 | 0] << 16 | l[n + 214 | 0] << 24), v = n + 80 | 0, u[v + 63 | 0] = l[I | 0], I = t[Me + 4 >> 2], d = v + 55 | 0, Me = t[Me >> 2], u[d | 0] = Me, u[d + 1 | 0] = Me >>> 8, u[d + 2 | 0] = Me >>> 16, u[d + 3 | 0] = Me >>> 24, u[d + 4 | 0] = I, u[d + 5 | 0] = I >>> 8, u[d + 6 | 0] = I >>> 16, u[d + 7 | 0] = I >>> 24, I = t[Be + 4 >> 2], d = v + 47 | 0, Be = t[Be >> 2], u[d | 0] = Be, u[d + 1 | 0] = Be >>> 8, u[d + 2 | 0] = Be >>> 16, u[d + 3 | 0] = Be >>> 24, u[d + 4 | 0] = I, u[d + 5 | 0] = I >>> 8, u[d + 6 | 0] = I >>> 16, u[d + 7 | 0] = I >>> 24, I = t[he + 4 >> 2], d = v + 39 | 0, he = t[he >> 2], u[d | 0] = he, u[d + 1 | 0] = he >>> 8, u[d + 2 | 0] = he >>> 16, u[d + 3 | 0] = he >>> 24, u[d + 4 | 0] = I, u[d + 5 | 0] = I >>> 8, u[d + 6 | 0] = I >>> 16, u[d + 7 | 0] = I >>> 24, I = t[L + 4 >> 2], d = v + 31 | 0, L = t[L >> 2], u[d | 0] = L, u[d + 1 | 0] = L >>> 8, u[d + 2 | 0] = L >>> 16, u[d + 3 | 0] = L >>> 24, u[d + 4 | 0] = I, u[d + 5 | 0] = I >>> 8, u[d + 6 | 0] = I >>> 16, u[d + 7 | 0] = I >>> 24, I = t[T + 4 >> 2], d = v + 23 | 0, T = t[T >> 2], u[d | 0] = T, u[d + 1 | 0] = T >>> 8, u[d + 2 | 0] = T >>> 16, u[d + 3 | 0] = T >>> 24, u[d + 4 | 0] = I, u[d + 5 | 0] = I >>> 8, u[d + 6 | 0] = I >>> 16, u[d + 7 | 0] = I >>> 24, I = t[E + 4 >> 2], d = v + 15 | 0, E = t[E >> 2], u[d | 0] = E, u[d + 1 | 0] = E >>> 8, u[d + 2 | 0] = E >>> 16, u[d + 3 | 0] = E >>> 24, u[d + 4 | 0] = I, u[d + 5 | 0] = I >>> 8, u[d + 6 | 0] = I >>> 16, u[d + 7 | 0] = I >>> 24, u[n + 83 | 0] = a, u[n + 84 | 0] = a >>> 8, u[n + 85 | 0] = a >>> 16, u[n + 86 | 0] = a >>> 24, d = t[n + 148 >> 2], a = t[n + 144 >> 2], u[n + 87 | 0] = a, u[n + 88 | 0] = a >>> 8, u[n + 89 | 0] = a >>> 16, u[n + 90 | 0] = a >>> 24, u[n + 91 | 0] = d, u[n + 92 | 0] = d >>> 8, u[n + 93 | 0] = d >>> 16, u[n + 94 | 0] = d >>> 24, v = vr(rr(), n + 8 | 0, n + 76 | 0, v), t[n + 144 >> 2] = v, (v | 0) != 1)
            break e;
          v = n + 8 | 0, a = v + 8 | 0, I = t[a + 4 >> 2], d = n + 208 | 0, E = d + 8 | 0, t[E >> 2] = t[a >> 2], t[E + 4 >> 2] = I, a = v + 16 | 0, I = t[a + 4 >> 2], E = d + 16 | 0, t[E >> 2] = t[a >> 2], t[E + 4 >> 2] = I, a = v + 24 | 0, I = t[a + 4 >> 2], E = d + 24 | 0, t[E >> 2] = t[a >> 2], t[E + 4 >> 2] = I, a = v + 32 | 0, I = t[a + 4 >> 2], E = d + 32 | 0, t[E >> 2] = t[a >> 2], t[E + 4 >> 2] = I, a = v + 40 | 0, I = t[a + 4 >> 2], E = d + 40 | 0, t[E >> 2] = t[a >> 2], t[E + 4 >> 2] = I, a = v + 48 | 0, I = t[a + 4 >> 2], E = d + 48 | 0, t[E >> 2] = t[a >> 2], t[E + 4 >> 2] = I, v = v + 56 | 0, a = t[v + 4 >> 2], d = d + 56 | 0, t[d >> 2] = t[v >> 2], t[d + 4 >> 2] = a;
          break t;
        }
        P(1), v = t[a + 4 >> 2], t[Me >> 2] = t[a >> 2], t[Me + 4 >> 2] = v, v = t[I + 4 >> 2], t[tr >> 2] = t[I >> 2], t[tr + 4 >> 2] = v, v = t[E + 4 >> 2], t[or >> 2] = t[E >> 2], t[or + 4 >> 2] = v, v = t[T + 4 >> 2], t[cr >> 2] = t[T >> 2], t[cr + 4 >> 2] = v, v = t[L + 4 >> 2], t[dr >> 2] = t[L >> 2], t[dr + 4 >> 2] = v, v = t[he + 4 >> 2], t[gr >> 2] = t[he >> 2], t[gr + 4 >> 2] = v, v = t[Be + 4 >> 2], t[Ir >> 2] = t[Be >> 2], t[Ir + 4 >> 2] = v;
      }
      if (v = t[n + 12 >> 2], t[n + 208 >> 2] = t[n + 8 >> 2], t[n + 212 >> 2] = v, d = n + 208 | 0, a = d + 56 | 0, I = t[a + 4 >> 2], v = n + 80 | 0, E = v + 56 | 0, t[E >> 2] = t[a >> 2], t[E + 4 >> 2] = I, a = d + 48 | 0, I = t[a + 4 >> 2], E = v + 48 | 0, t[E >> 2] = t[a >> 2], t[E + 4 >> 2] = I, a = d + 40 | 0, I = t[a + 4 >> 2], E = v + 40 | 0, t[E >> 2] = t[a >> 2], t[E + 4 >> 2] = I, a = d + 32 | 0, I = t[a + 4 >> 2], E = v + 32 | 0, t[E >> 2] = t[a >> 2], t[E + 4 >> 2] = I, a = d + 24 | 0, I = t[a + 4 >> 2], E = v + 24 | 0, t[E >> 2] = t[a >> 2], t[E + 4 >> 2] = I, a = d + 16 | 0, I = t[a + 4 >> 2], E = v + 16 | 0, t[E >> 2] = t[a >> 2], t[E + 4 >> 2] = I, d = d + 8 | 0, a = t[d + 4 >> 2], I = v + 8 | 0, t[I >> 2] = t[d >> 2], t[I + 4 >> 2] = a, d = t[n + 212 >> 2], t[n + 80 >> 2] = t[n + 208 >> 2], t[n + 84 >> 2] = d, v = Pr(t[172688], v), t[n + 8 >> 2] = v, (v | 0) != 1)
        break e;
      return x = n + 272 | 0, 1;
    }
    t[n + 216 >> 2] = 0, Ne(n + 208 | 0), wasm2js_trap();
  }
  function qr(v, d) {
    v = v | 0, d = d | 0;
    var I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0;
    E = x - 208 | 0, x = E, I = E + 136 | 0, a = I + 56 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = I + 48 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = I + 40 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = I + 32 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = I + 24 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = I + 16 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = I + 8 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, t[E + 136 >> 2] = 0, t[E + 140 >> 2] = 0;
    e: {
      if ((si(t[172688], I, 690820, v) | 0) == 1) {
        Me = E + 136 | 0, I = Me + 15 | 0, v = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), a = E + 72 | 0, cr = a + 8 | 0, t[cr >> 2] = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), t[cr + 4 >> 2] = v, I = Me + 23 | 0, v = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), or = a + 16 | 0, t[or >> 2] = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), t[or + 4 >> 2] = v, I = Me + 31 | 0, v = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), Be = a + 24 | 0, t[Be >> 2] = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), t[Be + 4 >> 2] = v, I = Me + 39 | 0, v = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), L = a + 32 | 0, t[L >> 2] = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), t[L + 4 >> 2] = v, I = Me + 47 | 0, v = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), tr = a + 40 | 0, t[tr >> 2] = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), t[tr + 4 >> 2] = v, he = Me + 55 | 0, v = l[he + 4 | 0] | l[he + 5 | 0] << 8 | (l[he + 6 | 0] << 16 | l[he + 7 | 0] << 24), I = a + 48 | 0, t[I >> 2] = l[he | 0] | l[he + 1 | 0] << 8 | (l[he + 2 | 0] << 16 | l[he + 3 | 0] << 24), t[I + 4 >> 2] = v, a = a + 56 | 0, u[a | 0] = l[Me + 63 | 0], u[E + 10 | 0] = l[E + 138 | 0], p[E + 8 >> 1] = m[E + 136 >> 1], v = l[E + 147 | 0] | l[E + 148 | 0] << 8 | (l[E + 149 | 0] << 16 | l[E + 150 | 0] << 24), t[E + 72 >> 2] = l[E + 143 | 0] | l[E + 144 | 0] << 8 | (l[E + 145 | 0] << 16 | l[E + 146 | 0] << 24), t[E + 76 >> 2] = v, Me = l[E + 139 | 0] | l[E + 140 | 0] << 8 | (l[E + 141 | 0] << 16 | l[E + 142 | 0] << 24), n = E + 8 | 0, u[n + 63 | 0] = l[a | 0], a = t[I + 4 >> 2], he = n + 55 | 0, v = t[I >> 2], u[he | 0] = v, u[he + 1 | 0] = v >>> 8, u[he + 2 | 0] = v >>> 16, u[he + 3 | 0] = v >>> 24, u[he + 4 | 0] = a, u[he + 5 | 0] = a >>> 8, u[he + 6 | 0] = a >>> 16, u[he + 7 | 0] = a >>> 24, a = t[tr + 4 >> 2], I = n + 47 | 0, v = t[tr >> 2], u[I | 0] = v, u[I + 1 | 0] = v >>> 8, u[I + 2 | 0] = v >>> 16, u[I + 3 | 0] = v >>> 24, u[I + 4 | 0] = a, u[I + 5 | 0] = a >>> 8, u[I + 6 | 0] = a >>> 16, u[I + 7 | 0] = a >>> 24, a = t[L + 4 >> 2], I = n + 39 | 0, v = t[L >> 2], u[I | 0] = v, u[I + 1 | 0] = v >>> 8, u[I + 2 | 0] = v >>> 16, u[I + 3 | 0] = v >>> 24, u[I + 4 | 0] = a, u[I + 5 | 0] = a >>> 8, u[I + 6 | 0] = a >>> 16, u[I + 7 | 0] = a >>> 24, a = t[Be + 4 >> 2], I = n + 31 | 0, v = t[Be >> 2], u[I | 0] = v, u[I + 1 | 0] = v >>> 8, u[I + 2 | 0] = v >>> 16, u[I + 3 | 0] = v >>> 24, u[I + 4 | 0] = a, u[I + 5 | 0] = a >>> 8, u[I + 6 | 0] = a >>> 16, u[I + 7 | 0] = a >>> 24, a = t[or + 4 >> 2], I = n + 23 | 0, v = t[or >> 2], u[I | 0] = v, u[I + 1 | 0] = v >>> 8, u[I + 2 | 0] = v >>> 16, u[I + 3 | 0] = v >>> 24, u[I + 4 | 0] = a, u[I + 5 | 0] = a >>> 8, u[I + 6 | 0] = a >>> 16, u[I + 7 | 0] = a >>> 24, a = t[cr + 4 >> 2], I = n + 15 | 0, v = t[cr >> 2], u[I | 0] = v, u[I + 1 | 0] = v >>> 8, u[I + 2 | 0] = v >>> 16, u[I + 3 | 0] = v >>> 24, u[I + 4 | 0] = a, u[I + 5 | 0] = a >>> 8, u[I + 6 | 0] = a >>> 16, u[I + 7 | 0] = a >>> 24, u[E + 11 | 0] = Me, u[E + 12 | 0] = Me >>> 8, u[E + 13 | 0] = Me >>> 16, u[E + 14 | 0] = Me >>> 24, a = t[E + 76 >> 2], v = t[E + 72 >> 2], u[E + 15 | 0] = v, u[E + 16 | 0] = v >>> 8, u[E + 17 | 0] = v >>> 16, u[E + 18 | 0] = v >>> 24, u[E + 19 | 0] = a, u[E + 20 | 0] = a >>> 8, u[E + 21 | 0] = a >>> 16, u[E + 22 | 0] = a >>> 24, dr = rr(), T = x - 288 | 0, x = T, t[T + 4 >> 2] = 0;
        t: {
          if (!n) {
            Qn[t[dr + 168 >> 2]](689638, t[dr + 172 >> 2]);
            break t;
          }
          if (Zr(T + 8 | 0, 690949, T + 4 | 0), t[T + 4 >> 2]) {
            u[n | 0] = 0, u[n + 1 | 0] = 0, u[n + 2 | 0] = 0, u[n + 3 | 0] = 0, u[n + 4 | 0] = 0, u[n + 5 | 0] = 0, u[n + 6 | 0] = 0, u[n + 7 | 0] = 0, v = n + 56 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = n + 48 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = n + 40 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = n + 32 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = n + 24 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = n + 16 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = n + 8 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0;
            break t;
          }
          if (v = l[n + 60 | 0] | l[n + 61 | 0] << 8 | (l[n + 62 | 0] << 16 | l[n + 63 | 0] << 24), he = v >>> 16 | 0, tr = T + 112 | 0, a = l[n + 56 | 0] | l[n + 57 | 0] << 8 | (l[n + 58 | 0] << 16 | l[n + 59 | 0] << 24), t[tr >> 2] = (v & 65535) << 16 | a >>> 16, t[tr + 4 >> 2] = he, tr = a << 4 & 1048560, v = l[n + 52 | 0] | l[n + 53 | 0] << 8 | (l[n + 54 | 0] << 16 | l[n + 55 | 0] << 24), he = v >>> 28 | 0, L = T + 104 | 0, a = l[n + 48 | 0] | l[n + 49 | 0] << 8 | (l[n + 50 | 0] << 16 | l[n + 51 | 0] << 24), t[L >> 2] = (v & 268435455) << 4 | a >>> 28, t[L + 4 >> 2] = he | tr, he = v << 24 | a >>> 8, L = a << 24 & -16777216, a = l[n + 40 | 0] | l[n + 41 | 0] << 8 | (l[n + 42 | 0] << 16 | l[n + 43 | 0] << 24), Be = T + 40 | 0, or = Be + 56 | 0, v = l[n + 44 | 0] | l[n + 45 | 0] << 8 | (l[n + 46 | 0] << 16 | l[n + 47 | 0] << 24), t[or >> 2] = v >>> 8 | L, t[or + 4 >> 2] = he & 1048575, or = v << 12 | a >>> 20, L = a << 12 & -4096, I = l[n + 32 | 0] | l[n + 33 | 0] << 8 | (l[n + 34 | 0] << 16 | l[n + 35 | 0] << 24), v = l[n + 36 | 0] | l[n + 37 | 0] << 8 | (l[n + 38 | 0] << 16 | l[n + 39 | 0] << 24), Be = Be + 48 | 0, t[Be >> 2] = v >>> 20 | L, t[Be + 4 >> 2] = or & 1048575, t[T + 120 >> 2] = 0, t[T + 80 >> 2] = I, t[T + 84 >> 2] = v & 1048575, I = l[n + 12 | 0] | l[n + 13 | 0] << 8 | (l[n + 14 | 0] << 16 | l[n + 15 | 0] << 24), Me = I, a = l[n + 8 | 0] | l[n + 9 | 0] << 8 | (l[n + 10 | 0] << 16 | l[n + 11 | 0] << 24), he = I << 12 | a >>> 20, L = a << 12 & -4096, cr = l[n | 0] | l[n + 1 | 0] << 8 | (l[n + 2 | 0] << 16 | l[n + 3 | 0] << 24), a = l[n + 4 | 0] | l[n + 5 | 0] << 8 | (l[n + 6 | 0] << 16 | l[n + 7 | 0] << 24), I = a, v = T, gr = I >>> 20 | L, t[v + 48 >> 2] = gr, Ir = he & 1048575, t[v + 52 >> 2] = Ir, t[v + 40 >> 2] = cr, xr = I & 1048575, t[v + 44 >> 2] = xr, a = l[n + 24 | 0] | l[n + 25 | 0] << 8 | (l[n + 26 | 0] << 16 | l[n + 27 | 0] << 24), or = a, I = l[n + 28 | 0] | l[n + 29 | 0] << 8 | (l[n + 30 | 0] << 16 | l[n + 31 | 0] << 24), tr = (I & 65535) << 16 | a >>> 16, t[v + 72 >> 2] = tr, L = I >>> 16 | 0, t[v + 76 >> 2] = L, a = l[n + 16 | 0] | l[n + 17 | 0] << 8 | (l[n + 18 | 0] << 16 | l[n + 19 | 0] << 24), I = l[n + 20 | 0] | l[n + 21 | 0] << 8 | (l[n + 22 | 0] << 16 | l[n + 23 | 0] << 24), he = I << 24 | a >>> 8, Mr = a << 24 & -16777216 | Me >>> 8, t[v + 56 >> 2] = Mr, Me = he & 1048575, t[v + 60 >> 2] = Me, Be = or << 4 & 1048560, a = (I & 268435455) << 4 | a >>> 28, t[v + 64 >> 2] = a, v = I >>> 28 | Be, t[T + 68 >> 2] = v, !(cr | gr | tr | Mr | a | (Ir | xr | L | Me | v))) {
            Qn[t[dr + 168 >> 2]](690116, t[dr + 172 >> 2]), v = n + 56 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = n + 48 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = n + 40 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = n + 32 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = n + 24 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = n + 16 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = n + 8 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, u[n | 0] = 0, u[n + 1 | 0] = 0, u[n + 2 | 0] = 0, u[n + 3 | 0] = 0, u[n + 4 | 0] = 0, u[n + 5 | 0] = 0, u[n + 6 | 0] = 0, u[n + 7 | 0] = 0;
            break t;
          }
          if (u[n | 0] = 0, u[n + 1 | 0] = 0, u[n + 2 | 0] = 0, u[n + 3 | 0] = 0, u[n + 4 | 0] = 0, u[n + 5 | 0] = 0, u[n + 6 | 0] = 0, u[n + 7 | 0] = 0, v = n + 56 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = n + 48 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = n + 40 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = n + 32 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = n + 24 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = n + 16 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, v = n + 8 | 0, u[v | 0] = 0, u[v + 1 | 0] = 0, u[v + 2 | 0] = 0, u[v + 3 | 0] = 0, u[v + 4 | 0] = 0, u[v + 5 | 0] = 0, u[v + 6 | 0] = 0, u[v + 7 | 0] = 0, !(t[T + 32 >> 2] | (t[T + 24 >> 2] | (t[T + 16 >> 2] | t[T + 8 >> 2])) | (t[T + 36 >> 2] | (t[T + 28 >> 2] | (t[T + 20 >> 2] | t[T + 12 >> 2])))))
            break t;
          tr = T + 256 | 0, v = tr + 24 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = tr + 16 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = tr + 8 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, L = T + 40 | 0, I = L + 8 | 0, a = t[I + 4 >> 2], Be = T + 128 | 0, v = Be + 8 | 0, t[v >> 2] = t[I >> 2], t[v + 4 >> 2] = a, I = L + 16 | 0, a = t[I + 4 >> 2], v = Be + 16 | 0, t[v >> 2] = t[I >> 2], t[v + 4 >> 2] = a, I = L + 24 | 0, a = t[I + 4 >> 2], v = Be + 24 | 0, t[v >> 2] = t[I >> 2], t[v + 4 >> 2] = a, I = L + 32 | 0, a = t[I + 4 >> 2], v = Be + 32 | 0, t[v >> 2] = t[I >> 2], t[v + 4 >> 2] = a, I = L + 48 | 0, a = t[I + 4 >> 2], v = Be + 48 | 0, t[v >> 2] = t[I >> 2], t[v + 4 >> 2] = a, I = L + 56 | 0, a = t[I + 4 >> 2], v = Be + 56 | 0, t[v >> 2] = t[I >> 2], t[v + 4 >> 2] = a, I = L - -64 | 0, a = t[I + 4 >> 2], v = Be - -64 | 0, t[v >> 2] = t[I >> 2], t[v + 4 >> 2] = a, I = L + 72 | 0, a = t[I + 4 >> 2], v = Be + 72 | 0, t[v >> 2] = t[I >> 2], t[v + 4 >> 2] = a, t[T + 256 >> 2] = 0, t[T + 260 >> 2] = 0, t[T + 248 >> 2] = 0, v = t[T + 44 >> 2], t[T + 128 >> 2] = t[T + 40 >> 2], t[T + 132 >> 2] = v, v = t[T + 84 >> 2], t[T + 168 >> 2] = t[T + 80 >> 2], t[T + 172 >> 2] = v, v = T + 240 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = T + 232 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = T + 224 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = T + 216 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, t[T + 208 >> 2] = 1, t[T + 212 >> 2] = 0, Or(Be, Be, T + 8 | 0, tr), ki(L, Be), In(n, L), Wr = 1;
        }
        if (x = T + 288 | 0, !Wr || (t[E + 204 >> 2] = d, v = zr(t[172688], E + 204 | 0, E + 8 | 0, (d | 0) == 33 ? 258 : 2), t[E + 72 >> 2] = v, $r = 1, (v | 0) == 1))
          break e;
        t[E + 144 >> 2] = 0, Ne(E + 136 | 0), wasm2js_trap();
      }
      P(1);
    }
    return x = E + 208 | 0, $r | 0;
  }
  function Hr() {
    return (Li() | 0) == 1 | 0;
  }
  function un() {
    var v = 0, d = 0;
    if (v = x - 32 | 0, x = v, d = _i(t[172688], 690949), t[v + 4 >> 2] = d, (d | 0) == 1)
      return d = Li(), x = v + 32 | 0, (d | 0) == 1 | 0;
    t[v + 16 >> 2] = 0, Ne(v + 8 | 0), wasm2js_trap();
  }
  function Dr() {
    var v = 0, d = 0;
    if (v = x - 32 | 0, x = v, d = _i(t[172688], 690788), t[v + 4 >> 2] = d, (d | 0) == 1) {
      x = v + 32 | 0;
      return;
    }
    t[v + 16 >> 2] = 0, Ne(v + 8 | 0), wasm2js_trap();
  }
  function wr(v) {
    v = v | 0;
    var d = 0, I = 0, n = 0, a = 0, E = 0, T = 0;
    n = x - 96 | 0, x = n, d = n + 56 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = n + 48 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = n + 40 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = n + 32 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = n + 24 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = n + 16 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = n + 8 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, I = rr(), E = t[172560], v = v ? 655681 : 0, d = x + -64 | 0, x = d;
    e: {
      if (!t[I >> 2]) {
        Qn[t[I + 168 >> 2]](690045, t[I + 172 >> 2]), v = 0;
        break e;
      }
      if (!n) {
        Qn[t[I + 168 >> 2]](689760, t[I + 172 >> 2]), v = 0;
        break e;
      }
      a = d + 32 | 0, v = Sn(I, a, d, 0, E, v), T = a + 24 | 0, E = t[T + 4 >> 2], I = n + 24 | 0, T = t[T >> 2], u[I | 0] = T, u[I + 1 | 0] = T >>> 8, u[I + 2 | 0] = T >>> 16, u[I + 3 | 0] = T >>> 24, u[I + 4 | 0] = E, u[I + 5 | 0] = E >>> 8, u[I + 6 | 0] = E >>> 16, u[I + 7 | 0] = E >>> 24, T = a + 16 | 0, E = t[T + 4 >> 2], I = n + 16 | 0, T = t[T >> 2], u[I | 0] = T, u[I + 1 | 0] = T >>> 8, u[I + 2 | 0] = T >>> 16, u[I + 3 | 0] = T >>> 24, u[I + 4 | 0] = E, u[I + 5 | 0] = E >>> 8, u[I + 6 | 0] = E >>> 16, u[I + 7 | 0] = E >>> 24, a = a + 8 | 0, E = t[a + 4 >> 2], I = n + 8 | 0, a = t[a >> 2], u[I | 0] = a, u[I + 1 | 0] = a >>> 8, u[I + 2 | 0] = a >>> 16, u[I + 3 | 0] = a >>> 24, u[I + 4 | 0] = E, u[I + 5 | 0] = E >>> 8, u[I + 6 | 0] = E >>> 16, u[I + 7 | 0] = E >>> 24, I = t[d + 36 >> 2], E = t[d + 32 >> 2], u[n | 0] = E, u[n + 1 | 0] = E >>> 8, u[n + 2 | 0] = E >>> 16, u[n + 3 | 0] = E >>> 24, u[n + 4 | 0] = I, u[n + 5 | 0] = I >>> 8, u[n + 6 | 0] = I >>> 16, u[n + 7 | 0] = I >>> 24, I = t[d + 4 >> 2], E = t[d >> 2], u[n + 32 | 0] = E, u[n + 33 | 0] = E >>> 8, u[n + 34 | 0] = E >>> 16, u[n + 35 | 0] = E >>> 24, u[n + 36 | 0] = I, u[n + 37 | 0] = I >>> 8, u[n + 38 | 0] = I >>> 16, u[n + 39 | 0] = I >>> 24, a = d + 8 | 0, E = t[a + 4 >> 2], I = n + 40 | 0, a = t[a >> 2], u[I | 0] = a, u[I + 1 | 0] = a >>> 8, u[I + 2 | 0] = a >>> 16, u[I + 3 | 0] = a >>> 24, u[I + 4 | 0] = E, u[I + 5 | 0] = E >>> 8, u[I + 6 | 0] = E >>> 16, u[I + 7 | 0] = E >>> 24, a = d + 16 | 0, E = t[a + 4 >> 2], I = n + 48 | 0, a = t[a >> 2], u[I | 0] = a, u[I + 1 | 0] = a >>> 8, u[I + 2 | 0] = a >>> 16, u[I + 3 | 0] = a >>> 24, u[I + 4 | 0] = E, u[I + 5 | 0] = E >>> 8, u[I + 6 | 0] = E >>> 16, u[I + 7 | 0] = E >>> 24, a = d + 24 | 0, E = t[a + 4 >> 2], I = n + 56 | 0, a = t[a >> 2], u[I | 0] = a, u[I + 1 | 0] = a >>> 8, u[I + 2 | 0] = a >>> 16, u[I + 3 | 0] = a >>> 24, u[I + 4 | 0] = E, u[I + 5 | 0] = E >>> 8, u[I + 6 | 0] = E >>> 16, u[I + 7 | 0] = E >>> 24;
    }
    x = d - -64 | 0, t[n + 68 >> 2] = v;
    e: {
      t: {
        if ((v | 0) == 1) {
          d = t[172688], v = x + -64 | 0, x = v;
          r: {
            if (!n) {
              Qn[t[d + 168 >> 2]](689748, t[d + 172 >> 2]), d = 0;
              break r;
            }
            d = n + 24 | 0, E = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), I = v + 32 | 0, a = I + 24 | 0, t[a >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[a + 4 >> 2] = E, d = n + 16 | 0, E = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), a = I + 16 | 0, t[a >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[a + 4 >> 2] = E, d = n + 8 | 0, E = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), a = I + 8 | 0, t[a >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[a + 4 >> 2] = E, d = n + 40 | 0, E = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), a = v + 8 | 0, t[a >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[a + 4 >> 2] = E, d = n + 48 | 0, E = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), a = v + 16 | 0, t[a >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[a + 4 >> 2] = E, d = n + 56 | 0, E = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), a = v + 24 | 0, t[a >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[a + 4 >> 2] = E, d = l[n + 4 | 0] | l[n + 5 | 0] << 8 | (l[n + 6 | 0] << 16 | l[n + 7 | 0] << 24), t[v + 32 >> 2] = l[n | 0] | l[n + 1 | 0] << 8 | (l[n + 2 | 0] << 16 | l[n + 3 | 0] << 24), t[v + 36 >> 2] = d, d = l[n + 36 | 0] | l[n + 37 | 0] << 8 | (l[n + 38 | 0] << 16 | l[n + 39 | 0] << 24), t[v >> 2] = l[n + 32 | 0] | l[n + 33 | 0] << 8 | (l[n + 34 | 0] << 16 | l[n + 35 | 0] << 24), t[v + 4 >> 2] = d, kr(690981, I), kr(691013, v), d = 1;
          }
          if (x = v - -64 | 0, t[n + 68 >> 2] = d, (d | 0) == 1)
            break t;
          break e;
        }
        break e;
      }
      x = n + 96 | 0;
      return;
    }
    t[n + 80 >> 2] = 0, Ne(n + 72 | 0), wasm2js_trap();
  }
  function yr(v) {
    v = v | 0;
    var d = 0, I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0;
    he = x - 112 | 0, x = he, E = he + 16 | 0, Vi(E, 65), d = rr(), n = t[172560], v = v ? 655681 : 0, I = x - 80 | 0, x = I;
    e: {
      if (!t[d >> 2]) {
        Qn[t[d + 168 >> 2]](690045, t[d + 172 >> 2]), v = 0;
        break e;
      }
      if (!E) {
        Qn[t[d + 168 >> 2]](689760, t[d + 172 >> 2]), v = 0;
        break e;
      }
      a = I + 48 | 0, L = I + 16 | 0, v = Sn(d, a, L, I + 12 | 0, n, v), d = t[I + 52 >> 2], n = t[I + 48 >> 2], u[E | 0] = n, u[E + 1 | 0] = n >>> 8, u[E + 2 | 0] = n >>> 16, u[E + 3 | 0] = n >>> 24, u[E + 4 | 0] = d, u[E + 5 | 0] = d >>> 8, u[E + 6 | 0] = d >>> 16, u[E + 7 | 0] = d >>> 24, T = a + 8 | 0, n = t[T + 4 >> 2], d = E + 8 | 0, T = t[T >> 2], u[d | 0] = T, u[d + 1 | 0] = T >>> 8, u[d + 2 | 0] = T >>> 16, u[d + 3 | 0] = T >>> 24, u[d + 4 | 0] = n, u[d + 5 | 0] = n >>> 8, u[d + 6 | 0] = n >>> 16, u[d + 7 | 0] = n >>> 24, T = a + 16 | 0, n = t[T + 4 >> 2], d = E + 16 | 0, T = t[T >> 2], u[d | 0] = T, u[d + 1 | 0] = T >>> 8, u[d + 2 | 0] = T >>> 16, u[d + 3 | 0] = T >>> 24, u[d + 4 | 0] = n, u[d + 5 | 0] = n >>> 8, u[d + 6 | 0] = n >>> 16, u[d + 7 | 0] = n >>> 24, a = a + 24 | 0, n = t[a + 4 >> 2], d = E + 24 | 0, a = t[a >> 2], u[d | 0] = a, u[d + 1 | 0] = a >>> 8, u[d + 2 | 0] = a >>> 16, u[d + 3 | 0] = a >>> 24, u[d + 4 | 0] = n, u[d + 5 | 0] = n >>> 8, u[d + 6 | 0] = n >>> 16, u[d + 7 | 0] = n >>> 24, d = t[I + 20 >> 2], n = t[I + 16 >> 2], u[E + 32 | 0] = n, u[E + 33 | 0] = n >>> 8, u[E + 34 | 0] = n >>> 16, u[E + 35 | 0] = n >>> 24, u[E + 36 | 0] = d, u[E + 37 | 0] = d >>> 8, u[E + 38 | 0] = d >>> 16, u[E + 39 | 0] = d >>> 24, a = L + 8 | 0, n = t[a + 4 >> 2], d = E + 40 | 0, a = t[a >> 2], u[d | 0] = a, u[d + 1 | 0] = a >>> 8, u[d + 2 | 0] = a >>> 16, u[d + 3 | 0] = a >>> 24, u[d + 4 | 0] = n, u[d + 5 | 0] = n >>> 8, u[d + 6 | 0] = n >>> 16, u[d + 7 | 0] = n >>> 24, a = L + 16 | 0, n = t[a + 4 >> 2], d = E + 48 | 0, a = t[a >> 2], u[d | 0] = a, u[d + 1 | 0] = a >>> 8, u[d + 2 | 0] = a >>> 16, u[d + 3 | 0] = a >>> 24, u[d + 4 | 0] = n, u[d + 5 | 0] = n >>> 8, u[d + 6 | 0] = n >>> 16, u[d + 7 | 0] = n >>> 24, a = L + 24 | 0, n = t[a + 4 >> 2], d = E + 56 | 0, a = t[a >> 2], u[d | 0] = a, u[d + 1 | 0] = a >>> 8, u[d + 2 | 0] = a >>> 16, u[d + 3 | 0] = a >>> 24, u[d + 4 | 0] = n, u[d + 5 | 0] = n >>> 8, u[d + 6 | 0] = n >>> 16, u[d + 7 | 0] = n >>> 24, u[E + 64 | 0] = t[I + 12 >> 2];
    }
    if (x = I + 80 | 0, t[he + 84 >> 2] = v, (v | 0) == 1) {
      t[he + 12 >> 2] = 0, I = t[172688], n = he + 12 | 0, E = x + -64 | 0, x = E, v = he + 16 | 0;
      e: {
        if (!v) {
          Qn[t[I + 168 >> 2]](689748, t[I + 172 >> 2]);
          break e;
        }
        if (!n) {
          Qn[t[I + 168 >> 2]](689795, t[I + 172 >> 2]);
          break e;
        }
        I = v + 24 | 0, a = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), d = E + 32 | 0, L = d + 24 | 0, t[L >> 2] = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), t[L + 4 >> 2] = a, I = v + 16 | 0, a = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), L = d + 16 | 0, t[L >> 2] = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), t[L + 4 >> 2] = a, I = v + 8 | 0, a = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), L = d + 8 | 0, t[L >> 2] = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), t[L + 4 >> 2] = a, I = v + 56 | 0, a = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), L = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), I = v + 48 | 0, T = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), Be = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), I = v + 40 | 0, Me = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), I = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), tr = l[v + 32 | 0] | l[v + 33 | 0] << 8 | (l[v + 34 | 0] << 16 | l[v + 35 | 0] << 24), or = l[v + 36 | 0] | l[v + 37 | 0] << 8 | (l[v + 38 | 0] << 16 | l[v + 39 | 0] << 24), cr = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), dr = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), t[n >> 2] = l[v + 64 | 0], v = E + 8 | 0, t[v >> 2] = Me, t[v + 4 >> 2] = I, v = E + 16 | 0, t[v >> 2] = T, t[v + 4 >> 2] = Be, v = E + 24 | 0, t[v >> 2] = a, t[v + 4 >> 2] = L, t[E + 32 >> 2] = cr, t[E + 36 >> 2] = dr, t[E >> 2] = tr, t[E + 4 >> 2] = or, kr(690981, d), kr(691013, E);
      }
      return x = E - -64 | 0, x = he + 112 | 0, t[he + 12 >> 2];
    }
    t[he + 96 >> 2] = 0, Ne(he + 88 | 0), wasm2js_trap();
  }
  function Qr(v) {
    v = v | 0;
    var d = 0, I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0;
    I = x - 128 | 0, x = I, L = Vi(I, 96), I = Cr(rr(), L), t[L + 100 >> 2] = I;
    e: {
      t: {
        if ((I | 0) == 1) {
          gr = rr(), Gn = v ? 655681 : 0, d = x - 640 | 0, x = d, v = d + 88 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = d + 80 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, t[d + 72 >> 2] = 0, t[d + 76 >> 2] = 0, t[d + 64 >> 2] = 0, t[d + 68 >> 2] = 0;
          r: {
            if (!t[gr >> 2]) {
              Qn[t[gr + 168 >> 2]](690045, t[gr + 172 >> 2]);
              break r;
            }
            if (!L) {
              Qn[t[gr + 168 >> 2]](689700, t[gr + 172 >> 2]);
              break r;
            }
            xr = d + 472 | 0, kn = x - 16 | 0, x = kn, Mr = l[L + 40 | 0] | l[L + 41 | 0] << 8 | (l[L + 42 | 0] << 16 | l[L + 43 | 0] << 24), T = l[L + 44 | 0] | l[L + 45 | 0] << 8 | (l[L + 46 | 0] << 16 | l[L + 47 | 0] << 24), Me = l[L + 48 | 0] | l[L + 49 | 0] << 8 | (l[L + 50 | 0] << 16 | l[L + 51 | 0] << 24), E = l[L + 52 | 0] | l[L + 53 | 0] << 8 | (l[L + 54 | 0] << 16 | l[L + 55 | 0] << 24), Wr = l[L + 72 | 0] | l[L + 73 | 0] << 8 | (l[L + 74 | 0] << 16 | l[L + 75 | 0] << 24), or = l[L + 76 | 0] | l[L + 77 | 0] << 8 | (l[L + 78 | 0] << 16 | l[L + 79 | 0] << 24), he = l[L + 80 | 0] | l[L + 81 | 0] << 8 | (l[L + 82 | 0] << 16 | l[L + 83 | 0] << 24), n = l[L + 84 | 0] | l[L + 85 | 0] << 8 | (l[L + 86 | 0] << 16 | l[L + 87 | 0] << 24), Ir = l[L + 32 | 0] | l[L + 33 | 0] << 8 | (l[L + 34 | 0] << 16 | l[L + 35 | 0] << 24), cr = l[L + 36 | 0] | l[L + 37 | 0] << 8 | (l[L + 38 | 0] << 16 | l[L + 39 | 0] << 24), tr = l[L + 56 | 0] | l[L + 57 | 0] << 8 | (l[L + 58 | 0] << 16 | l[L + 59 | 0] << 24), a = l[L + 60 | 0] | l[L + 61 | 0] << 8 | (l[L + 62 | 0] << 16 | l[L + 63 | 0] << 24), Bn = l[L + 64 | 0] | l[L + 65 | 0] << 8 | (l[L + 66 | 0] << 16 | l[L + 67 | 0] << 24), dr = l[L + 68 | 0] | l[L + 69 | 0] << 8 | (l[L + 70 | 0] << 16 | l[L + 71 | 0] << 24), Be = l[L + 88 | 0] | l[L + 89 | 0] << 8 | (l[L + 90 | 0] << 16 | l[L + 91 | 0] << 24), $r = l[L + 92 | 0] | l[L + 93 | 0] << 8 | (l[L + 94 | 0] << 16 | l[L + 95 | 0] << 24), I = d + 192 | 0, t[I + 80 >> 2] = 0, gn = I + 72 | 0, t[gn >> 2] = ($r & 65535) << 16 | Be >>> 16, t[gn + 4 >> 2] = $r >>> 16, t[I + 40 >> 2] = Bn, t[I + 44 >> 2] = dr & 1048575, gn = (a & 65535) << 16 | tr >>> 16, t[I + 32 >> 2] = gn, Bn = a >>> 16 | 0, t[I + 36 >> 2] = Bn, t[I >> 2] = Ir, $r = cr & 1048575, t[I + 4 >> 2] = $r, xn = I - -64 | 0, t[xn >> 2] = (n & 268435455) << 4 | he >>> 28, t[xn + 4 >> 2] = Be << 4 & 1048560 | n >>> 28, v = n << 24 | he >>> 8, Be = I + 56 | 0, n = or, t[Be >> 2] = he << 24 & -16777216 | n >>> 8, t[Be + 4 >> 2] = v & 1048575, v = n << 12, n = Wr, he = (v | n >>> 20) & 1048575, or = I + 48 | 0, t[or >> 2] = n << 12 & -4096 | dr >>> 20, t[or + 4 >> 2] = he, n = tr << 4 & 1048560, a = E, v = a >>> 28 | 0, E = (a & 268435455) << 4 | Me >>> 28, t[I + 24 >> 2] = E, n = v | n, t[I + 28 >> 2] = n, v = a << 24 | Me >>> 8, a = T, T = Me << 24 & -16777216 | a >>> 8, t[I + 16 >> 2] = T, Me = v & 1048575, t[I + 20 >> 2] = Me, v = a << 12, a = Mr, or = (v | a >>> 20) & 1048575, a = a << 12 & -4096 | cr >>> 20, t[I + 8 >> 2] = a, v = or, t[I + 12 >> 2] = v;
            n: {
              i: {
                if (!(a | Ir | gn | T | E | (v | $r | Bn | Me | n))) {
                  if (Qn[t[gr + 168 >> 2]](690116, t[gr + 172 >> 2]), $i(I, 690376, 88), xr)
                    break i;
                  break n;
                }
                if (Un = 1, !xr || (Zr(xr, L, kn + 12 | 0), !(t[kn + 12 >> 2] | !(t[xr + 24 >> 2] | (t[xr + 16 >> 2] | (t[xr + 8 >> 2] | t[xr >> 2])) | (t[xr + 28 >> 2] | (t[xr + 20 >> 2] | (t[xr + 12 >> 2] | t[xr + 4 >> 2])))))))
                  break n;
                Qn[t[gr + 168 >> 2]](689400, t[gr + 172 >> 2]), $i(I, 690376, 88);
              }
              Un = 0, v = t[172569], I = xr + 24 | 0, t[I >> 2] = t[172568], t[I + 4 >> 2] = v, v = t[172567], I = xr + 16 | 0, t[I >> 2] = t[172566], t[I + 4 >> 2] = v, v = t[172565], I = xr + 8 | 0, t[I >> 2] = t[172564], t[I + 4 >> 2] = v, v = t[172563], t[xr >> 2] = t[172562], t[xr + 4 >> 2] = v;
            }
            x = kn + 16 | 0;
            n: {
              if (!(u[d + 232 | 0] & 1)) {
                Mr = t[d + 472 >> 2], or = t[d + 476 >> 2], he = t[d + 480 >> 2], I = t[d + 484 >> 2], n = t[d + 488 >> 2], E = t[d + 492 >> 2], Wr = t[d + 496 >> 2], Me = t[d + 500 >> 2];
                break n;
              }
              cr = t[d + 496 >> 2], dr = t[d + 488 >> 2], n = t[d + 480 >> 2], v = t[d + 472 >> 2], Ir = t[d + 500 >> 2], Wr = t[d + 492 >> 2], E = t[d + 484 >> 2], I = t[d + 476 >> 2], T = cr | (dr | (n | v)) | (Ir | (Wr | (E | I))) ? -1 : 0, v = v ^ -1, Me = v - 801750718 | 0, Mr = T & Me, t[d + 472 >> 2] = Mr, I = I ^ -1, a = I - ((v >>> 0 < 801750718) + 1076732275 | 0) | 0, or = a & T, t[d + 476 >> 2] = or, v = (I | 0) == (a | 0) & v >>> 0 > Me >>> 0 | I >>> 0 > a >>> 0, Me = n ^ -1, n = v + Me | 0, E = E ^ -1, v = E, Be = n - 1354194885 | 0, he = Be & T, t[d + 480 >> 2] = he, v = n >>> 0 < Me >>> 0 ? v + 1 | 0 : v, tr = v - ((n >>> 0 < 1354194885) + 1162945305 | 0) | 0, I = tr & T, t[d + 484 >> 2] = I, a = (v | 0) == (E | 0) & n >>> 0 < Me >>> 0 | v >>> 0 < E >>> 0, Me = (v | 0) == (tr | 0) & n >>> 0 > Be >>> 0 | v >>> 0 > tr >>> 0, n = a + Me | 0, v = n >>> 0 < Me >>> 0, tr = dr ^ -1, Me = tr + n | 0, dr = Wr ^ -1, v = dr + v | 0, Be = Me - 2 | 0, n = Be & T, t[d + 488 >> 2] = n, v = Me >>> 0 < tr >>> 0 ? v + 1 | 0 : v, Wr = v - (Me >>> 0 < 2) | 0, E = Wr & T, t[d + 492 >> 2] = E, a = (v | 0) == (dr | 0) & Me >>> 0 < tr >>> 0 | v >>> 0 < dr >>> 0, Me = (v | 0) == (Wr | 0) & Be >>> 0 < Me >>> 0 | v >>> 0 > Wr >>> 0, a = a + Me | 0, v = a >>> 0 < Me >>> 0, Me = a - cr | 0, Wr = Me - 2 & T, t[d + 496 >> 2] = Wr, Me = (v - ((a >>> 0 < cr >>> 0) + Ir | 0) | 0) - (Me >>> 0 < 2) & T, t[d + 500 >> 2] = Me;
            }
            u[d + 31 | 0] = Mr, u[d + 30 | 0] = (or & 255) << 24 | Mr >>> 8, u[d + 29 | 0] = (or & 65535) << 16 | Mr >>> 16, u[d + 28 | 0] = (or & 16777215) << 8 | Mr >>> 24, u[d + 27 | 0] = or, u[d + 26 | 0] = or >>> 8, u[d + 25 | 0] = or >>> 16, u[d + 24 | 0] = or >>> 24, u[d + 23 | 0] = he, u[d + 22 | 0] = (I & 255) << 24 | he >>> 8, u[d + 21 | 0] = (I & 65535) << 16 | he >>> 16, u[d + 20 | 0] = (I & 16777215) << 8 | he >>> 24, u[d + 19 | 0] = I, u[d + 18 | 0] = I >>> 8, u[d + 17 | 0] = I >>> 16, u[d + 16 | 0] = I >>> 24, u[d + 15 | 0] = n, u[d + 14 | 0] = (E & 255) << 24 | n >>> 8, u[d + 13 | 0] = (E & 65535) << 16 | n >>> 16, u[d + 12 | 0] = (E & 16777215) << 8 | n >>> 24, u[d + 11 | 0] = E, u[d + 10 | 0] = E >>> 8, u[d + 9 | 0] = E >>> 16, u[d + 8 | 0] = E >>> 24, u[d + 7 | 0] = Wr, u[d + 6 | 0] = (Me & 255) << 24 | Wr >>> 8, u[d + 5 | 0] = (Me & 65535) << 16 | Wr >>> 16, u[d + 4 | 0] = (Me & 16777215) << 8 | Wr >>> 24, u[d + 3 | 0] = Me, u[d + 2 | 0] = Me >>> 8, u[d + 1 | 0] = Me >>> 16, u[d | 0] = Me >>> 24, I = t[d + 228 >> 2], a = t[d + 224 >> 2], u[d + 37 | 0] = a, v = t[d + 212 >> 2], n = t[d + 208 >> 2], u[d + 50 | 0] = n, u[d + 36 | 0] = (I & 255) << 24 | a >>> 8, u[d + 35 | 0] = (I & 65535) << 16 | a >>> 16, u[d + 34 | 0] = (I & 16777215) << 8 | a >>> 24, u[d + 33 | 0] = I, u[d + 32 | 0] = I >>> 8, I = t[d + 220 >> 2], a = t[d + 216 >> 2], u[d + 43 | 0] = (I & 15) << 28 | a >>> 4, u[d + 42 | 0] = (I & 4095) << 20 | a >>> 12, u[d + 41 | 0] = (I & 1048575) << 12 | a >>> 20, u[d + 40 | 0] = (I & 268435455) << 4 | a >>> 28, u[d + 39 | 0] = I >>> 4, u[d + 38 | 0] = I >>> 12, u[d + 49 | 0] = (v & 255) << 24 | n >>> 8, u[d + 48 | 0] = (v & 65535) << 16 | n >>> 16, u[d + 47 | 0] = (v & 16777215) << 8 | n >>> 24, u[d + 46 | 0] = v, u[d + 45 | 0] = v >>> 8, u[d + 44 | 0] = v >>> 16 & 15 | a << 4, v = t[d + 196 >> 2], n = t[d + 192 >> 2], u[d + 63 | 0] = n, I = t[d + 204 >> 2], a = t[d + 200 >> 2], u[d + 56 | 0] = (I & 15) << 28 | a >>> 4, u[d + 55 | 0] = (I & 4095) << 20 | a >>> 12, u[d + 54 | 0] = (I & 1048575) << 12 | a >>> 20, u[d + 53 | 0] = (I & 268435455) << 4 | a >>> 28, u[d + 52 | 0] = I >>> 4, u[d + 51 | 0] = I >>> 12, u[d + 62 | 0] = (v & 255) << 24 | n >>> 8, u[d + 61 | 0] = (v & 65535) << 16 | n >>> 16, u[d + 60 | 0] = (v & 16777215) << 8 | n >>> 24, u[d + 59 | 0] = v, u[d + 58 | 0] = v >>> 8, u[d + 57 | 0] = v >>> 16 & 15 | a << 4, v = d - -64 | 0, I = yn(v, 655649, 32, d, d + 32 | 0, 690736, 13, Gn), a = d + 408 | 0, Zr(a, v, 0), v = Un & (I | 0) != 0, I = t[d + 432 >> 2], E = t[d + 424 >> 2], n = t[d + 416 >> 2], T = t[d + 408 >> 2], Me = t[d + 436 >> 2], cr = t[d + 428 >> 2], or = t[d + 420 >> 2], he = t[d + 412 >> 2], xn = v & (I | (E | (n | T)) | (Me | (cr | (or | he)))) != 0, kn = !xn, v = kn - 1 | 0, Wr = v & I, t[d + 432 >> 2] = Wr, I = 0 - !kn | 0, Me = I & Me, t[d + 436 >> 2] = Me, $r = v & E, t[d + 424 >> 2] = $r, Bn = I & cr, t[d + 428 >> 2] = Bn, gn = v & n, t[d + 416 >> 2] = gn, xr = I & or, t[d + 420 >> 2] = xr, Mr = v & T | kn, t[d + 408 >> 2] = Mr, or = I & he, t[d + 412 >> 2] = or, v = d + 280 | 0, hi(gr, v, a), ki(d + 104 | 0, v), v = d + 152 | 0, a = t[v >> 2], T = t[v + 4 >> 2], E = t[d + 148 >> 2], v = d + 176 | 0, he = t[v >> 2], n = t[v + 4 >> 2], dr = n, v = t[d + 144 >> 2], I = pn(n >>> 16 | 0, 0, 977, 1), n = v + I | 0, v = E + Ee | 0, Be = I >>> 0 > n >>> 0 ? v + 1 | 0 : v, v = T, I = Be >>> 20 | 0, E = I, I = I + a | 0, E = E >>> 0 > I >>> 0 ? v + 1 | 0 : v, cr = E & 1048575, v = d + 168 | 0, Ir = t[v >> 2], gr = t[v + 4 >> 2], v = d + 160 | 0, T = t[v >> 2], v = t[v + 4 >> 2], a = E >>> 20 | 0, tr = a, a = a + T | 0, tr = tr >>> 0 > a >>> 0 ? v + 1 | 0 : v, v = gr, T = tr >>> 20 | 0, gr = T, T = T + Ir | 0, v = gr >>> 0 > T >>> 0 ? v + 1 | 0 : v, Ir = v & 1048575, tr = tr & 1048575, gr = (I & a & T) == -1 & (E & tr & v) == 1048575, E = v, v = dr & 65535, E = E >>> 20 | 0, dr = E + he | 0, v = E >>> 0 > dr >>> 0 ? v + 1 | 0 : v, he = v, E = Be & 1048575, gr & ((dr | 0) == -1 & (v | 0) == 65535) & ((E | 0) == 1048574 & n >>> 0 > 4294966318 | E >>> 0 > 1048574) | v >>> 16 && (v = E + 1 | 0, n = n + 977 | 0, v = n >>> 0 < 977 ? v + 1 | 0 : v, E = v & 1048575, Be = v, v = cr, Be = Be >>> 20 | 0, I = I + Be | 0, v = Be >>> 0 > I >>> 0 ? v + 1 | 0 : v, cr = v & 1048575, Be = v, v = tr, Be = Be >>> 20 | 0, a = a + Be | 0, v = Be >>> 0 > a >>> 0 ? v + 1 | 0 : v, tr = v & 1048575, Be = v, v = Ir, Be = Be >>> 20 | 0, T = T + Be | 0, v = Be >>> 0 > T >>> 0 ? v + 1 | 0 : v, Ir = v & 1048575, Be = v, v = he, he = dr, dr = (Be >>> 20 | 0) + dr | 0, he = (he >>> 0 > dr >>> 0 ? v + 1 | 0 : v) & 65535), t[d + 176 >> 2] = dr, t[d + 180 >> 2] = he, t[d + 168 >> 2] = T, t[d + 172 >> 2] = Ir, t[d + 160 >> 2] = a, t[d + 164 >> 2] = tr, t[d + 152 >> 2] = I, t[d + 156 >> 2] = cr, t[d + 144 >> 2] = n, t[d + 148 >> 2] = E, n & 1 && (a = Mr | gn | $r | Wr | (or | xr | Bn | Me) ? -1 : 0, v = Mr ^ -1, T = v - 801750718 | 0, Mr = a & T, t[d + 408 >> 2] = Mr, I = or ^ -1, n = I - ((v >>> 0 < 801750718) + 1076732275 | 0) | 0, or = n & a, t[d + 412 >> 2] = or, v = (I | 0) == (n | 0) & v >>> 0 > T >>> 0 | I >>> 0 > n >>> 0, T = gn ^ -1, n = v + T | 0, E = xr ^ -1, v = E, cr = n - 1354194885 | 0, gn = cr & a, t[d + 416 >> 2] = gn, v = n >>> 0 < T >>> 0 ? v + 1 | 0 : v, he = v - ((n >>> 0 < 1354194885) + 1162945305 | 0) | 0, xr = he & a, t[d + 420 >> 2] = xr, I = (v | 0) == (E | 0) & n >>> 0 < T >>> 0 | v >>> 0 < E >>> 0, T = (v | 0) == (he | 0) & n >>> 0 > cr >>> 0 | v >>> 0 > he >>> 0, n = I + T | 0, E = Bn ^ -1, v = E + (n >>> 0 < T >>> 0) | 0, T = $r ^ -1, n = T + n | 0, cr = n - 2 | 0, $r = cr & a, t[d + 424 >> 2] = $r, v = n >>> 0 < T >>> 0 ? v + 1 | 0 : v, he = v - (n >>> 0 < 2) | 0, Bn = he & a, t[d + 428 >> 2] = Bn, I = (v | 0) == (E | 0) & n >>> 0 < T >>> 0 | v >>> 0 < E >>> 0, n = (v | 0) == (he | 0) & n >>> 0 > cr >>> 0 | v >>> 0 > he >>> 0, I = I + n | 0, v = I >>> 0 < n >>> 0, n = I - Wr | 0, T = n - 2 | 0, Me = (v - ((I >>> 0 < Wr >>> 0) + Me | 0) | 0) - (n >>> 0 < 2) & a, Wr = a & T, t[d + 432 >> 2] = Wr, t[d + 436 >> 2] = Me), a = t[d + 112 >> 2], n = t[d + 116 >> 2], E = t[d + 108 >> 2], dr = t[d + 136 >> 2], T = t[d + 140 >> 2], Be = T, v = t[d + 104 >> 2], I = pn(T >>> 16 | 0, 0, 977, 1), T = v + I | 0, v = E + Ee | 0, Ir = I >>> 0 > T >>> 0 ? v + 1 | 0 : v, v = n, I = Ir >>> 20 | 0, n = I + a | 0, he = I >>> 0 > n >>> 0 ? v + 1 | 0 : v, E = he & 1048575, cr = t[d + 128 >> 2], gr = t[d + 132 >> 2], v = t[d + 124 >> 2], I = he >>> 20 | 0, a = I + t[d + 120 >> 2] | 0, tr = I >>> 0 > a >>> 0 ? v + 1 | 0 : v, v = gr, I = tr >>> 20 | 0, gr = I, I = I + cr | 0, v = gr >>> 0 > I >>> 0 ? v + 1 | 0 : v, cr = v & 1048575, tr = tr & 1048575, gr = (n & a & I) == -1 & (he & tr & v) == 1048575, he = v, v = Be & 65535, he = he >>> 20 | 0, dr = he + dr | 0, v = he >>> 0 > dr >>> 0 ? v + 1 | 0 : v, he = v, Ir = Ir & 1048575, gr & ((dr | 0) == -1 & (v | 0) == 65535) & ((Ir | 0) == 1048574 & T >>> 0 > 4294966318 | Ir >>> 0 > 1048574) | v >>> 16 && (v = Ir + 1 | 0, T = T + 977 | 0, v = T >>> 0 < 977 ? v + 1 | 0 : v, Ir = v & 1048575, Be = v, v = E, Be = Be >>> 20 | 0, n = n + Be | 0, v = Be >>> 0 > n >>> 0 ? v + 1 | 0 : v, E = v & 1048575, Be = v, v = tr, Be = Be >>> 20 | 0, a = a + Be | 0, v = Be >>> 0 > a >>> 0 ? v + 1 | 0 : v, tr = v & 1048575, Be = v, v = cr, Be = Be >>> 20 | 0, I = I + Be | 0, v = Be >>> 0 > I >>> 0 ? v + 1 | 0 : v, cr = v & 1048575, Be = v, v = he, he = dr, dr = (Be >>> 20 | 0) + dr | 0, he = (he >>> 0 > dr >>> 0 ? v + 1 | 0 : v) & 65535), t[d + 136 >> 2] = dr, t[d + 140 >> 2] = he, t[d + 128 >> 2] = I, t[d + 132 >> 2] = cr, t[d + 120 >> 2] = a, t[d + 124 >> 2] = tr, t[d + 112 >> 2] = n, t[d + 116 >> 2] = E, t[d + 104 >> 2] = T, t[d + 108 >> 2] = Ir, En(690981, d + 104 | 0), t[d + 600 >> 2] = 64, t[d + 604 >> 2] = 0, t[d + 528 >> 2] = -1862921884, t[d + 532 >> 2] = 870954602, t[d + 520 >> 2] = -1748470448, t[d + 524 >> 2] = 3983205, t[d + 512 >> 2] = 292000018, t[d + 516 >> 2] = -782074353, t[d + 504 >> 2] = -1662207471, t[d + 508 >> 2] = 596792193, v = d + 504 | 0, Tn(v, 690981, 32), Tn(v, d + 32 | 0, 32), Tn(v, 655649, 32), I = v, v = d + 608 | 0, Yn(I, v), Be = d + 440 | 0, Zr(Be, v, 0), gr = d + 472 | 0, Er(Be, Be, gr), I = t[d + 440 >> 2], he = I + Mr | 0, v = or + t[d + 444 >> 2] | 0, E = I >>> 0 > he >>> 0 ? v + 1 | 0 : v, n = (or | 0) == (E | 0) & he >>> 0 < Mr >>> 0 | E >>> 0 < or >>> 0, I = t[d + 448 >> 2], a = n + I | 0, v = t[d + 452 >> 2], I = I >>> 0 > a >>> 0 ? v + 1 | 0 : v, v = I + xr | 0, n = !I & n >>> 0 > a >>> 0, or = a + gn | 0, T = or >>> 0 < gn >>> 0 ? v + 1 | 0 : v, a = (I | 0) == (T | 0) & a >>> 0 > or >>> 0 | I >>> 0 > T >>> 0, I = n + a | 0, v = I >>> 0 < a >>> 0, tr = I, I = t[d + 456 >> 2], a = tr + I | 0, n = v, v = v + t[d + 460 >> 2] | 0, I = I >>> 0 > a >>> 0 ? v + 1 | 0 : v, v = I + Bn | 0, cr = a, dr = a + $r | 0, v = dr >>> 0 < $r >>> 0 ? v + 1 | 0 : v, Mr = Me, tr = (I | 0) == (n | 0) & a >>> 0 < tr >>> 0 | I >>> 0 < n >>> 0, a = v, Me = dr, n = (I | 0) == (v | 0) & Me >>> 0 < cr >>> 0 | v >>> 0 < I >>> 0, I = tr + n | 0, v = I >>> 0 < n >>> 0, Ir = I, n = t[d + 464 >> 2], I = I + n | 0, cr = v, v = v + t[d + 468 >> 2] | 0, n = I >>> 0 < n >>> 0 ? v + 1 | 0 : v, v = n + Mr | 0, tr = I, I = I + Wr | 0, Mr = tr >>> 0 > I >>> 0 ? v + 1 | 0 : v, dr = I, Ir = ((n | 0) == (Mr | 0) & tr >>> 0 > I >>> 0 | n >>> 0 > Mr >>> 0) + ((n | 0) == (cr | 0) & tr >>> 0 < Ir >>> 0 | n >>> 0 < cr >>> 0) | 0, n = (a | 0) == -1, cr = n & Me >>> 0 < 4294967294 | (a | 0) != -1 | (I & Mr) != -1, v = (T | 0) == -1162945306, tr = (cr | (v & or >>> 0 < 2940772411 | T >>> 0 < 3132021990)) ^ -1, cr = Ir + (tr & ((E | 0) == -1076732276 & he >>> 0 > 3493216576 | E >>> 0 > 3218235020) | (tr & (v & or >>> 0 > 2940772411 | T >>> 0 > 3132021990) | (Me | 0) == -1 & n & (cr ^ -1))) | 0, n = pn(cr, 0, 801750719, 1076732275), tr = n + he | 0, v = E + Ee | 0, t[d + 440 >> 2] = tr, v = n >>> 0 > tr >>> 0 ? v + 1 | 0 : v, t[d + 444 >> 2] = v, he = (v | 0) == (E | 0) & he >>> 0 > tr >>> 0 | v >>> 0 < E >>> 0, E = pn(cr, 0, 1354194884, 1162945305), I = E + or | 0, v = T + Ee | 0, v = I >>> 0 < E >>> 0 ? v + 1 | 0 : v, E = I, I = v, he = E + he | 0, v = he >>> 0 < E >>> 0 ? v + 1 | 0 : v, t[d + 448 >> 2] = he, t[d + 452 >> 2] = v, n = (I | 0) == (T | 0) & E >>> 0 < or >>> 0 | I >>> 0 < T >>> 0, T = (v | 0) == (I | 0) & E >>> 0 > he >>> 0 | v >>> 0 < I >>> 0, I = n + T | 0, E = I, T = I >>> 0 < T >>> 0, v = a, or = Me + cr | 0, I = or >>> 0 < cr >>> 0 ? v + 1 | 0 : v, v = I + T | 0, T = or, E = E + T | 0, v = T >>> 0 > E >>> 0 ? v + 1 | 0 : v, t[d + 456 >> 2] = E, t[d + 460 >> 2] = v, n = (I | 0) == (a | 0) & T >>> 0 < Me >>> 0 | I >>> 0 < a >>> 0, a = (v | 0) == (I | 0) & E >>> 0 < T >>> 0 | v >>> 0 < I >>> 0, I = n + a | 0, v = Mr + (I >>> 0 < a >>> 0) | 0, I = I + dr | 0, v = I >>> 0 < dr >>> 0 ? v + 1 | 0 : v, t[d + 464 >> 2] = I, t[d + 468 >> 2] = v, kr(691013, Be), t[d + 504 >> 2] = kn, v = t[d + 504 >> 2] - 1 | 0, u[690981] = v & l[690981], u[690982] = l[690982] & v, u[690983] = l[690983] & v, u[690984] = l[690984] & v, u[690985] = l[690985] & v, u[690986] = l[690986] & v, u[690987] = l[690987] & v, u[690988] = l[690988] & v, u[690989] = l[690989] & v, u[690990] = l[690990] & v, u[690991] = l[690991] & v, u[690992] = l[690992] & v, u[690993] = l[690993] & v, u[690994] = l[690994] & v, u[690995] = l[690995] & v, u[690996] = l[690996] & v, u[690997] = l[690997] & v, u[690998] = l[690998] & v, u[690999] = l[690999] & v, u[691e3] = l[691e3] & v, u[691001] = l[691001] & v, u[691002] = l[691002] & v, u[691003] = l[691003] & v, u[691004] = l[691004] & v, u[691005] = l[691005] & v, u[691006] = l[691006] & v, u[691007] = l[691007] & v, u[691008] = l[691008] & v, u[691009] = l[691009] & v, u[691010] = l[691010] & v, u[691011] = l[691011] & v, u[691012] = l[691012] & v, u[691013] = l[691013] & v, u[691014] = l[691014] & v, u[691015] = l[691015] & v, u[691016] = l[691016] & v, u[691017] = l[691017] & v, u[691018] = l[691018] & v, u[691019] = l[691019] & v, u[691020] = l[691020] & v, u[691021] = l[691021] & v, u[691022] = l[691022] & v, u[691023] = l[691023] & v, u[691024] = l[691024] & v, u[691025] = l[691025] & v, u[691026] = l[691026] & v, u[691027] = l[691027] & v, u[691028] = l[691028] & v, u[691029] = l[691029] & v, u[691030] = l[691030] & v, u[691031] = l[691031] & v, u[691032] = l[691032] & v, u[691033] = l[691033] & v, u[691034] = l[691034] & v, u[691035] = l[691035] & v, u[691036] = l[691036] & v, u[691037] = l[691037] & v, u[691038] = l[691038] & v, u[691039] = l[691039] & v, u[691040] = l[691040] & v, u[691041] = l[691041] & v, u[691042] = l[691042] & v, u[691043] = l[691043] & v, u[691044] = l[691044] & v, v = d + 408 | 0, I = v + 24 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = v + 16 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, v = v + 8 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, t[d + 408 >> 2] = 0, t[d + 412 >> 2] = 0, v = gr + 24 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = gr + 16 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = gr + 8 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, t[d + 472 >> 2] = 0, t[d + 476 >> 2] = 0, v = d + 24 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = d + 16 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, t[d + 8 >> 2] = 0, t[d + 12 >> 2] = 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0;
          }
          if (x = d + 640 | 0, t[L + 100 >> 2] = xn, xn)
            break t;
          break e;
        }
        break e;
      }
      x = L + 128 | 0;
      return;
    }
    t[L + 112 >> 2] = 0, Ne(L + 104 | 0), wasm2js_trap();
  }
  function _r(v, d) {
    v = v | 0, d = d | 0;
    var I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0, Xn = 0, Zn = 0, ni = 0, ai = 0, fi = 0, Ai = 0, yi = 0, Ii = 0, wi = 0, Bi = 0;
    E = x - 192 | 0, x = E, a = E + 128 | 0, T = a + 56 | 0, t[T >> 2] = 0, t[T + 4 >> 2] = 0, L = a + 48 | 0, t[L >> 2] = 0, t[L + 4 >> 2] = 0, he = a + 40 | 0, t[he >> 2] = 0, t[he + 4 >> 2] = 0, or = a + 32 | 0, t[or >> 2] = 0, t[or + 4 >> 2] = 0, Be = a + 24 | 0, t[Be >> 2] = 0, t[Be + 4 >> 2] = 0, tr = a + 16 | 0, t[tr >> 2] = 0, t[tr + 4 >> 2] = 0, xr = a + 8 | 0, t[xr >> 2] = 0, t[xr + 4 >> 2] = 0, t[E + 128 >> 2] = 0, t[E + 132 >> 2] = 0;
    e: {
      if ((si(t[172688], a, 690820, v) | 0) == 1) {
        a = E + 128 | 0, v = a + 15 | 0, I = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), n = E - -64 | 0, Me = n + 8 | 0, t[Me >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[Me + 4 >> 2] = I, v = a + 23 | 0, I = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), dr = n + 16 | 0, t[dr >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[dr + 4 >> 2] = I, v = a + 31 | 0, I = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), Ir = n + 24 | 0, t[Ir >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[Ir + 4 >> 2] = I, v = a + 39 | 0, I = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), gr = n + 32 | 0, t[gr >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[gr + 4 >> 2] = I, v = a + 47 | 0, I = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), cr = n + 40 | 0, t[cr >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[cr + 4 >> 2] = I, v = a + 55 | 0, I = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), Mr = n + 48 | 0, t[Mr >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[Mr + 4 >> 2] = I, n = n + 56 | 0, u[n | 0] = l[a + 63 | 0], u[E + 2 | 0] = l[E + 130 | 0], p[E >> 1] = m[E + 128 >> 1], v = l[E + 139 | 0] | l[E + 140 | 0] << 8 | (l[E + 141 | 0] << 16 | l[E + 142 | 0] << 24), t[E + 64 >> 2] = l[E + 135 | 0] | l[E + 136 | 0] << 8 | (l[E + 137 | 0] << 16 | l[E + 138 | 0] << 24), t[E + 68 >> 2] = v, v = l[E + 131 | 0] | l[E + 132 | 0] << 8 | (l[E + 133 | 0] << 16 | l[E + 134 | 0] << 24), u[E + 63 | 0] = l[n | 0], I = t[Mr + 4 >> 2], n = E + 55 | 0, Mr = t[Mr >> 2], u[n | 0] = Mr, u[n + 1 | 0] = Mr >>> 8, u[n + 2 | 0] = Mr >>> 16, u[n + 3 | 0] = Mr >>> 24, u[n + 4 | 0] = I, u[n + 5 | 0] = I >>> 8, u[n + 6 | 0] = I >>> 16, u[n + 7 | 0] = I >>> 24, I = t[cr + 4 >> 2], n = E + 47 | 0, cr = t[cr >> 2], u[n | 0] = cr, u[n + 1 | 0] = cr >>> 8, u[n + 2 | 0] = cr >>> 16, u[n + 3 | 0] = cr >>> 24, u[n + 4 | 0] = I, u[n + 5 | 0] = I >>> 8, u[n + 6 | 0] = I >>> 16, u[n + 7 | 0] = I >>> 24, I = t[gr + 4 >> 2], n = E + 39 | 0, gr = t[gr >> 2], u[n | 0] = gr, u[n + 1 | 0] = gr >>> 8, u[n + 2 | 0] = gr >>> 16, u[n + 3 | 0] = gr >>> 24, u[n + 4 | 0] = I, u[n + 5 | 0] = I >>> 8, u[n + 6 | 0] = I >>> 16, u[n + 7 | 0] = I >>> 24, I = t[Ir + 4 >> 2], n = E + 31 | 0, Ir = t[Ir >> 2], u[n | 0] = Ir, u[n + 1 | 0] = Ir >>> 8, u[n + 2 | 0] = Ir >>> 16, u[n + 3 | 0] = Ir >>> 24, u[n + 4 | 0] = I, u[n + 5 | 0] = I >>> 8, u[n + 6 | 0] = I >>> 16, u[n + 7 | 0] = I >>> 24, I = t[dr + 4 >> 2], n = E + 23 | 0, dr = t[dr >> 2], u[n | 0] = dr, u[n + 1 | 0] = dr >>> 8, u[n + 2 | 0] = dr >>> 16, u[n + 3 | 0] = dr >>> 24, u[n + 4 | 0] = I, u[n + 5 | 0] = I >>> 8, u[n + 6 | 0] = I >>> 16, u[n + 7 | 0] = I >>> 24, I = t[Me + 4 >> 2], n = E + 15 | 0, Me = t[Me >> 2], u[n | 0] = Me, u[n + 1 | 0] = Me >>> 8, u[n + 2 | 0] = Me >>> 16, u[n + 3 | 0] = Me >>> 24, u[n + 4 | 0] = I, u[n + 5 | 0] = I >>> 8, u[n + 6 | 0] = I >>> 16, u[n + 7 | 0] = I >>> 24, u[E + 3 | 0] = v, u[E + 4 | 0] = v >>> 8, u[E + 5 | 0] = v >>> 16, u[E + 6 | 0] = v >>> 24, v = t[E + 68 >> 2], n = t[E + 64 >> 2], u[E + 7 | 0] = n, u[E + 8 | 0] = n >>> 8, u[E + 9 | 0] = n >>> 16, u[E + 10 | 0] = n >>> 24, u[E + 11 | 0] = v, u[E + 12 | 0] = v >>> 8, u[E + 13 | 0] = v >>> 16, u[E + 14 | 0] = v >>> 24, t[T >> 2] = 0, t[T + 4 >> 2] = 0, t[L >> 2] = 0, t[L + 4 >> 2] = 0, t[he >> 2] = 0, t[he + 4 >> 2] = 0, t[or >> 2] = 0, t[or + 4 >> 2] = 0, t[Be >> 2] = 0, t[Be + 4 >> 2] = 0, t[tr >> 2] = 0, t[tr + 4 >> 2] = 0, t[xr >> 2] = 0, t[xr + 4 >> 2] = 0, t[E + 128 >> 2] = 0, t[E + 132 >> 2] = 0, n = 0, T = t[172688], I = 0, v = x - 80 | 0, x = v, t[v + 12 >> 2] = 0;
        t: {
          if (!a) {
            Qn[t[T + 168 >> 2]](689748, t[T + 172 >> 2]);
            break t;
          }
          if (I = v + 12 | 0, Zr(v + 48 | 0, 690981, I), T = t[v + 12 >> 2], Zr(v + 16 | 0, 691013, I), !(T | t[v + 12 >> 2])) {
            I = t[v + 52 >> 2], T = t[v + 48 >> 2], u[a | 0] = T, u[a + 1 | 0] = T >>> 8, u[a + 2 | 0] = T >>> 16, u[a + 3 | 0] = T >>> 24, u[a + 4 | 0] = I, u[a + 5 | 0] = I >>> 8, u[a + 6 | 0] = I >>> 16, u[a + 7 | 0] = I >>> 24, I = t[v + 20 >> 2], T = t[v + 16 >> 2], u[a + 32 | 0] = T, u[a + 33 | 0] = T >>> 8, u[a + 34 | 0] = T >>> 16, u[a + 35 | 0] = T >>> 24, u[a + 36 | 0] = I, u[a + 37 | 0] = I >>> 8, u[a + 38 | 0] = I >>> 16, u[a + 39 | 0] = I >>> 24, he = v + 48 | 0, L = he + 24 | 0, T = t[L + 4 >> 2], I = a + 24 | 0, L = t[L >> 2], u[I | 0] = L, u[I + 1 | 0] = L >>> 8, u[I + 2 | 0] = L >>> 16, u[I + 3 | 0] = L >>> 24, u[I + 4 | 0] = T, u[I + 5 | 0] = T >>> 8, u[I + 6 | 0] = T >>> 16, u[I + 7 | 0] = T >>> 24, L = he + 16 | 0, T = t[L + 4 >> 2], I = a + 16 | 0, L = t[L >> 2], u[I | 0] = L, u[I + 1 | 0] = L >>> 8, u[I + 2 | 0] = L >>> 16, u[I + 3 | 0] = L >>> 24, u[I + 4 | 0] = T, u[I + 5 | 0] = T >>> 8, u[I + 6 | 0] = T >>> 16, u[I + 7 | 0] = T >>> 24, L = he + 8 | 0, T = t[L + 4 >> 2], I = a + 8 | 0, L = t[L >> 2], u[I | 0] = L, u[I + 1 | 0] = L >>> 8, u[I + 2 | 0] = L >>> 16, u[I + 3 | 0] = L >>> 24, u[I + 4 | 0] = T, u[I + 5 | 0] = T >>> 8, u[I + 6 | 0] = T >>> 16, u[I + 7 | 0] = T >>> 24, he = v + 16 | 0, L = he + 8 | 0, T = t[L + 4 >> 2], I = a + 40 | 0, L = t[L >> 2], u[I | 0] = L, u[I + 1 | 0] = L >>> 8, u[I + 2 | 0] = L >>> 16, u[I + 3 | 0] = L >>> 24, u[I + 4 | 0] = T, u[I + 5 | 0] = T >>> 8, u[I + 6 | 0] = T >>> 16, u[I + 7 | 0] = T >>> 24, L = he + 16 | 0, T = t[L + 4 >> 2], I = a + 48 | 0, L = t[L >> 2], u[I | 0] = L, u[I + 1 | 0] = L >>> 8, u[I + 2 | 0] = L >>> 16, u[I + 3 | 0] = L >>> 24, u[I + 4 | 0] = T, u[I + 5 | 0] = T >>> 8, u[I + 6 | 0] = T >>> 16, u[I + 7 | 0] = T >>> 24, T = he + 24 | 0, I = t[T + 4 >> 2], a = a + 56 | 0, T = t[T >> 2], u[a | 0] = T, u[a + 1 | 0] = T >>> 8, u[a + 2 | 0] = T >>> 16, u[a + 3 | 0] = T >>> 24, u[a + 4 | 0] = I, u[a + 5 | 0] = I >>> 8, u[a + 6 | 0] = I >>> 16, u[a + 7 | 0] = I >>> 24, I = 1;
            break t;
          }
          u[a | 0] = 0, u[a + 1 | 0] = 0, u[a + 2 | 0] = 0, u[a + 3 | 0] = 0, u[a + 4 | 0] = 0, u[a + 5 | 0] = 0, u[a + 6 | 0] = 0, u[a + 7 | 0] = 0, I = a + 56 | 0, u[I | 0] = 0, u[I + 1 | 0] = 0, u[I + 2 | 0] = 0, u[I + 3 | 0] = 0, u[I + 4 | 0] = 0, u[I + 5 | 0] = 0, u[I + 6 | 0] = 0, u[I + 7 | 0] = 0, I = a + 48 | 0, u[I | 0] = 0, u[I + 1 | 0] = 0, u[I + 2 | 0] = 0, u[I + 3 | 0] = 0, u[I + 4 | 0] = 0, u[I + 5 | 0] = 0, u[I + 6 | 0] = 0, u[I + 7 | 0] = 0, I = a + 40 | 0, u[I | 0] = 0, u[I + 1 | 0] = 0, u[I + 2 | 0] = 0, u[I + 3 | 0] = 0, u[I + 4 | 0] = 0, u[I + 5 | 0] = 0, u[I + 6 | 0] = 0, u[I + 7 | 0] = 0, I = a + 32 | 0, u[I | 0] = 0, u[I + 1 | 0] = 0, u[I + 2 | 0] = 0, u[I + 3 | 0] = 0, u[I + 4 | 0] = 0, u[I + 5 | 0] = 0, u[I + 6 | 0] = 0, u[I + 7 | 0] = 0, I = a + 24 | 0, u[I | 0] = 0, u[I + 1 | 0] = 0, u[I + 2 | 0] = 0, u[I + 3 | 0] = 0, u[I + 4 | 0] = 0, u[I + 5 | 0] = 0, u[I + 6 | 0] = 0, u[I + 7 | 0] = 0, I = a + 16 | 0, u[I | 0] = 0, u[I + 1 | 0] = 0, u[I + 2 | 0] = 0, u[I + 3 | 0] = 0, u[I + 4 | 0] = 0, u[I + 5 | 0] = 0, u[I + 6 | 0] = 0, u[I + 7 | 0] = 0, a = a + 8 | 0, u[a | 0] = 0, u[a + 1 | 0] = 0, u[a + 2 | 0] = 0, u[a + 3 | 0] = 0, u[a + 4 | 0] = 0, u[a + 5 | 0] = 0, u[a + 6 | 0] = 0, u[a + 7 | 0] = 0, I = 0;
        }
        if (x = v + 80 | 0, !I) {
          P(4);
          break e;
        }
        if (!d)
          t: {
            if (v = t[172688], I = E + 128 | 0, !I) {
              Qn[t[v + 168 >> 2]](689716, t[v + 172 >> 2]);
              break t;
            }
            d = l[I + 60 | 0] | l[I + 61 | 0] << 8 | (l[I + 62 | 0] << 16 | l[I + 63 | 0] << 24), or = d, d = d >>> 31 | 0, n = d ^ -1, Be = l[I + 44 | 0] | l[I + 45 | 0] << 8 | (l[I + 46 | 0] << 16 | l[I + 47 | 0] << 24), a = (Be | 0) == 1566010995, tr = l[I + 40 | 0] | l[I + 41 | 0] << 8 | (l[I + 42 | 0] << 16 | l[I + 43 | 0] << 24), Me = l[I + 48 | 0] | l[I + 49 | 0] << 8 | (l[I + 50 | 0] << 16 | l[I + 51 | 0] << 24), dr = l[I + 52 | 0] | l[I + 53 | 0] << 8 | (l[I + 54 | 0] << 16 | l[I + 55 | 0] << 24), v = l[I + 56 | 0] | l[I + 57 | 0] << 8 | (l[I + 58 | 0] << 16 | l[I + 59 | 0] << 24), n = (n & (a & tr >>> 0 < 1470386205 | Be >>> 0 < 1566010995) | (n & (Me & dr) != -1 | ((or | 0) == 2147483647 & (v | 0) != -1 | or >>> 0 < 2147483647))) ^ -1, xr = l[I + 36 | 0] | l[I + 37 | 0] << 8 | (l[I + 38 | 0] << 16 | l[I + 39 | 0] << 24), Ir = l[I + 32 | 0] | l[I + 33 | 0] << 8 | (l[I + 34 | 0] << 16 | l[I + 35 | 0] << 24), d = n & ((xr | 0) == -538366138 & Ir >>> 0 > 1746608288 | xr >>> 0 > 3756601158) | (n & (a & tr >>> 0 > 1470386205 | Be >>> 0 > 1566010995) | d), I && (d && (d = Ir ^ -1, a = d - 801750718 | 0, cr = a, n = xr ^ -1, L = n - ((d >>> 0 < 801750718) + 1076732275 | 0) | 0, a = (n | 0) == (L | 0) & d >>> 0 > a >>> 0 | n >>> 0 > L >>> 0, gr = tr ^ -1, d = a + gr | 0, n = Be ^ -1, T = d >>> 0 < a >>> 0 ? n + 1 | 0 : n, a = d - 1354194885 | 0, Mr = a, Wr = Me ^ -1, n = (n | 0) == (T | 0) & d >>> 0 < gr >>> 0 | n >>> 0 > T >>> 0, gr = T - ((d >>> 0 < 1354194885) + 1162945305 | 0) | 0, a = (gr | 0) == (T | 0) & d >>> 0 > a >>> 0 | T >>> 0 > gr >>> 0, d = n + a | 0, he = dr ^ -1, n = he + (d >>> 0 < a >>> 0) | 0, a = d + Wr | 0, n = a >>> 0 < d >>> 0 ? n + 1 | 0 : n, T = a - 2 | 0, $r = T, d = tr | Ir | Me | v | (Be | xr | dr | or) ? -1 : 0, dr = (n | 0) == (he | 0) & a >>> 0 < Wr >>> 0 | n >>> 0 < he >>> 0, he = n - (a >>> 0 < 2) | 0, n = (he | 0) == (n | 0) & a >>> 0 > T >>> 0 | n >>> 0 > he >>> 0, a = dr + n | 0, T = n >>> 0 > a >>> 0, n = v, Be = a - n | 0, v = Be - 2 & d, or = d & (T - ((n >>> 0 > a >>> 0) + or | 0) | 0) - (Be >>> 0 < 2), n = d, Me = n & $r, dr = n & he, Ir = n & cr, xr = n & L, tr = n & Mr, Be = n & gr), T = I + 8 | 0, gr = l[T | 0] | l[T + 1 | 0] << 8 | (l[T + 2 | 0] << 16 | l[T + 3 | 0] << 24), n = l[T + 4 | 0] | l[T + 5 | 0] << 8 | (l[T + 6 | 0] << 16 | l[T + 7 | 0] << 24), L = I + 16 | 0, cr = l[L | 0] | l[L + 1 | 0] << 8 | (l[L + 2 | 0] << 16 | l[L + 3 | 0] << 24), d = l[L + 4 | 0] | l[L + 5 | 0] << 8 | (l[L + 6 | 0] << 16 | l[L + 7 | 0] << 24), Mr = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), a = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), he = I + 24 | 0, Wr = l[he + 4 | 0] | l[he + 5 | 0] << 8 | (l[he + 6 | 0] << 16 | l[he + 7 | 0] << 24), $r = l[he | 0] | l[he + 1 | 0] << 8 | (l[he + 2 | 0] << 16 | l[he + 3 | 0] << 24), u[he | 0] = $r, u[he + 1 | 0] = $r >>> 8, u[he + 2 | 0] = $r >>> 16, u[he + 3 | 0] = $r >>> 24, u[he + 4 | 0] = Wr, u[he + 5 | 0] = Wr >>> 8, u[he + 6 | 0] = Wr >>> 16, u[he + 7 | 0] = Wr >>> 24, u[L | 0] = cr, u[L + 1 | 0] = cr >>> 8, u[L + 2 | 0] = cr >>> 16, u[L + 3 | 0] = cr >>> 24, u[L + 4 | 0] = d, u[L + 5 | 0] = d >>> 8, u[L + 6 | 0] = d >>> 16, u[L + 7 | 0] = d >>> 24, u[T | 0] = gr, u[T + 1 | 0] = gr >>> 8, u[T + 2 | 0] = gr >>> 16, u[T + 3 | 0] = gr >>> 24, u[T + 4 | 0] = n, u[T + 5 | 0] = n >>> 8, u[T + 6 | 0] = n >>> 16, u[T + 7 | 0] = n >>> 24, u[I | 0] = Mr, u[I + 1 | 0] = Mr >>> 8, u[I + 2 | 0] = Mr >>> 16, u[I + 3 | 0] = Mr >>> 24, u[I + 4 | 0] = a, u[I + 5 | 0] = a >>> 8, u[I + 6 | 0] = a >>> 16, u[I + 7 | 0] = a >>> 24, u[I + 56 | 0] = v, u[I + 57 | 0] = v >>> 8, u[I + 58 | 0] = v >>> 16, u[I + 59 | 0] = v >>> 24, u[I + 60 | 0] = or, u[I + 61 | 0] = or >>> 8, u[I + 62 | 0] = or >>> 16, u[I + 63 | 0] = or >>> 24, u[I + 48 | 0] = Me, u[I + 49 | 0] = Me >>> 8, u[I + 50 | 0] = Me >>> 16, u[I + 51 | 0] = Me >>> 24, u[I + 52 | 0] = dr, u[I + 53 | 0] = dr >>> 8, u[I + 54 | 0] = dr >>> 16, u[I + 55 | 0] = dr >>> 24, u[I + 40 | 0] = tr, u[I + 41 | 0] = tr >>> 8, u[I + 42 | 0] = tr >>> 16, u[I + 43 | 0] = tr >>> 24, u[I + 44 | 0] = Be, u[I + 45 | 0] = Be >>> 8, u[I + 46 | 0] = Be >>> 16, u[I + 47 | 0] = Be >>> 24, u[I + 32 | 0] = Ir, u[I + 33 | 0] = Ir >>> 8, u[I + 34 | 0] = Ir >>> 16, u[I + 35 | 0] = Ir >>> 24, u[I + 36 | 0] = xr, u[I + 37 | 0] = xr >>> 8, u[I + 38 | 0] = xr >>> 16, u[I + 39 | 0] = xr >>> 24);
          }
        cr = rr(), v = 0, d = x - 464 | 0, x = d, n = E + 128 | 0;
        t: {
          if (!n) {
            Qn[t[cr + 168 >> 2]](689748, t[cr + 172 >> 2]);
            break t;
          }
          if (!E) {
            Qn[t[cr + 168 >> 2]](689638, t[cr + 172 >> 2]);
            break t;
          }
          if (Zr(d + 8 | 0, 655649, 0), a = n + 24 | 0, T = l[a + 4 | 0] | l[a + 5 | 0] << 8 | (l[a + 6 | 0] << 16 | l[a + 7 | 0] << 24), I = d + 40 | 0, L = I + 24 | 0, t[L >> 2] = l[a | 0] | l[a + 1 | 0] << 8 | (l[a + 2 | 0] << 16 | l[a + 3 | 0] << 24), t[L + 4 >> 2] = T, a = n + 16 | 0, T = l[a + 4 | 0] | l[a + 5 | 0] << 8 | (l[a + 6 | 0] << 16 | l[a + 7 | 0] << 24), L = I + 16 | 0, t[L >> 2] = l[a | 0] | l[a + 1 | 0] << 8 | (l[a + 2 | 0] << 16 | l[a + 3 | 0] << 24), t[L + 4 >> 2] = T, a = n + 8 | 0, T = l[a + 4 | 0] | l[a + 5 | 0] << 8 | (l[a + 6 | 0] << 16 | l[a + 7 | 0] << 24), I = I + 8 | 0, t[I >> 2] = l[a | 0] | l[a + 1 | 0] << 8 | (l[a + 2 | 0] << 16 | l[a + 3 | 0] << 24), t[I + 4 >> 2] = T, a = l[n + 4 | 0] | l[n + 5 | 0] << 8 | (l[n + 6 | 0] << 16 | l[n + 7 | 0] << 24), t[d + 40 >> 2] = l[n | 0] | l[n + 1 | 0] << 8 | (l[n + 2 | 0] << 16 | l[n + 3 | 0] << 24), t[d + 44 >> 2] = a, T = l[n + 36 | 0] | l[n + 37 | 0] << 8 | (l[n + 38 | 0] << 16 | l[n + 39 | 0] << 24), gn = l[n + 32 | 0] | l[n + 33 | 0] << 8 | (l[n + 34 | 0] << 16 | l[n + 35 | 0] << 24), a = l[n + 60 | 0] | l[n + 61 | 0] << 8 | (l[n + 62 | 0] << 16 | l[n + 63 | 0] << 24), he = a >>> 31 | 0, Me = he ^ -1, I = l[n + 44 | 0] | l[n + 45 | 0] << 8 | (l[n + 46 | 0] << 16 | l[n + 47 | 0] << 24), tr = (I | 0) == 1566010995, L = l[n + 40 | 0] | l[n + 41 | 0] << 8 | (l[n + 42 | 0] << 16 | l[n + 43 | 0] << 24), xr = l[n + 48 | 0] | l[n + 49 | 0] << 8 | (l[n + 50 | 0] << 16 | l[n + 51 | 0] << 24), Be = l[n + 52 | 0] | l[n + 53 | 0] << 8 | (l[n + 54 | 0] << 16 | l[n + 55 | 0] << 24), or = l[n + 56 | 0] | l[n + 57 | 0] << 8 | (l[n + 58 | 0] << 16 | l[n + 59 | 0] << 24), n = (Me & (tr & L >>> 0 < 1470386205 | I >>> 0 < 1566010995) | (Me & (xr & Be) != -1 | ((a | 0) == 2147483647 & (or | 0) != -1 | a >>> 0 < 2147483647))) ^ -1, ((T | 0) == -538366138 & gn >>> 0 > 1746608288 | T >>> 0 > 3756601158) & n | (n & (tr & L >>> 0 > 1470386205 | I >>> 0 > 1566010995) | he))
            break t;
          if (n = l[E + 12 | 0] | l[E + 13 | 0] << 8 | (l[E + 14 | 0] << 16 | l[E + 15 | 0] << 24), tr = n, he = l[E + 8 | 0] | l[E + 9 | 0] << 8 | (l[E + 10 | 0] << 16 | l[E + 11 | 0] << 24), Me = (n << 12 | he >>> 20) & 1048575, dr = l[E + 4 | 0] | l[E + 5 | 0] << 8 | (l[E + 6 | 0] << 16 | l[E + 7 | 0] << 24), Mr = dr, Bn = he << 12 & -4096 | dr >>> 20, kn = Me, he = l[E + 16 | 0] | l[E + 17 | 0] << 8 | (l[E + 18 | 0] << 16 | l[E + 19 | 0] << 24), Wr = he, n = l[E + 20 | 0] | l[E + 21 | 0] << 8 | (l[E + 22 | 0] << 16 | l[E + 23 | 0] << 24), gr = n, Me = (n << 24 | he >>> 8) & 1048575, xn = he << 24 & -16777216 | tr >>> 8, Un = Me, tr = l[E + 28 | 0] | l[E + 29 | 0] << 8 | (l[E + 30 | 0] << 16 | l[E + 31 | 0] << 24), n = tr >>> 16 | 0, he = l[E + 24 | 0] | l[E + 25 | 0] << 8 | (l[E + 26 | 0] << 16 | l[E + 27 | 0] << 24), Me = (tr & 65535) << 16 | he >>> 16, dr = n, tr = he << 4 & 1048560, he = gr, n = he >>> 28 | 0, Gn = (he & 268435455) << 4 | Wr >>> 28, jn = l[E | 0] | l[E + 1 | 0] << 8 | (l[E + 2 | 0] << 16 | l[E + 3 | 0] << 24), Xn = n | tr, Zn = Mr & 1048575, !(Gn | (xn | (Me | (Bn | jn))) | (Xn | (Un | (dr | (kn | Zn)))))) {
            Qn[t[cr + 168 >> 2]](690116, t[cr + 172 >> 2]);
            break t;
          }
          if (tr = t[d + 64 >> 2], Ir = t[d + 56 >> 2], ni = t[d + 48 >> 2], ai = t[d + 40 >> 2], he = t[d + 68 >> 2], Mr = t[d + 60 >> 2], gr = t[d + 52 >> 2], cr = t[d + 44 >> 2], !(tr | (Ir | (ni | ai)) | (he | (Mr | (gr | cr)))) || !(L | gn | xr | or | (I | T | Be | a)) || (Wr = l[E + 48 | 0] | l[E + 49 | 0] << 8 | (l[E + 50 | 0] << 16 | l[E + 51 | 0] << 24), $r = l[E + 52 | 0] | l[E + 53 | 0] << 8 | (l[E + 54 | 0] << 16 | l[E + 55 | 0] << 24), fi = l[E + 56 | 0] | l[E + 57 | 0] << 8 | (l[E + 58 | 0] << 16 | l[E + 59 | 0] << 24), yi = l[E + 60 | 0] | l[E + 61 | 0] << 8 | (l[E + 62 | 0] << 16 | l[E + 63 | 0] << 24), Ii = l[E + 40 | 0] | l[E + 41 | 0] << 8 | (l[E + 42 | 0] << 16 | l[E + 43 | 0] << 24), wi = l[E + 44 | 0] | l[E + 45 | 0] << 8 | (l[E + 46 | 0] << 16 | l[E + 47 | 0] << 24), Bi = l[E + 32 | 0] | l[E + 33 | 0] << 8 | (l[E + 34 | 0] << 16 | l[E + 35 | 0] << 24), Ai = l[E + 36 | 0] | l[E + 37 | 0] << 8 | (l[E + 38 | 0] << 16 | l[E + 39 | 0] << 24), t[d + 232 >> 2] = a >>> 24, t[d + 236 >> 2] = 0, t[d + 200 >> 2] = gn, t[d + 204 >> 2] = T & 1073741823, n = a << 6 | or >>> 26, a = Be, t[d + 224 >> 2] = or << 6 | a >>> 26, t[d + 228 >> 2] = n & 1073741823, n = a << 4 | xr >>> 28, t[d + 216 >> 2] = xr << 4 | I >>> 28, t[d + 220 >> 2] = n & 1073741823, I = I << 2 | L >>> 30, t[d + 208 >> 2] = L << 2 | T >>> 30, t[d + 212 >> 2] = I & 1073741823, or = d + 200 | 0, Rr(or, 690320), I = t[d + 232 >> 2] << 24, L = t[d + 228 >> 2], n = L >>> 6 | 0, T = t[d + 224 >> 2], t[d + 456 >> 2] = (L & 63) << 26 | T >>> 6, t[d + 460 >> 2] = I | n, I = T << 26, L = t[d + 220 >> 2], n = L >>> 4 | 0, T = t[d + 216 >> 2], t[d + 448 >> 2] = (L & 15) << 28 | T >>> 4, t[d + 452 >> 2] = I | n, I = T << 28, L = t[d + 212 >> 2], n = L >>> 2 | 0, T = t[d + 208 >> 2], t[d + 440 >> 2] = (L & 3) << 30 | T >>> 2, t[d + 444 >> 2] = I | n, I = t[d + 204 >> 2], n = T << 30, t[d + 432 >> 2] = t[d + 200 >> 2], t[d + 436 >> 2] = I | n, T = d + 400 | 0, n = d + 432 | 0, Er(T, n, d + 8 | 0), L = d + 368 | 0, Er(L, n, d + 40 | 0), n = d + 288 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, a = yi, n = a >>> 16 | 0, I = d + 272 | 0, t[I >> 2] = (a & 65535) << 16 | fi >>> 16, t[I + 4 >> 2] = n, Be = fi << 4 & 1048560, a = $r, n = a >>> 28 | 0, I = d + 264 | 0, t[I >> 2] = (a & 268435455) << 4 | Wr >>> 28, t[I + 4 >> 2] = n | Be, n = a << 24 | Wr >>> 8, I = d + 256 | 0, a = wi, t[I >> 2] = Wr << 24 & -16777216 | a >>> 8, t[I + 4 >> 2] = n & 1048575, n = a << 12, a = Ii, Be = (n | a >>> 20) & 1048575, I = d + 248 | 0, t[I >> 2] = a << 12 & -4096 | Ai >>> 20, t[I + 4 >> 2] = Be, n = d + 296 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = d + 304 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = d + 312 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, t[d + 280 >> 2] = 1, t[d + 284 >> 2] = 0, t[d + 240 >> 2] = Bi, t[d + 244 >> 2] = Ai & 1048575, t[d + 232 >> 2] = Me, t[d + 236 >> 2] = dr, t[d + 224 >> 2] = Gn, t[d + 228 >> 2] = Xn, t[d + 216 >> 2] = xn, t[d + 220 >> 2] = Un, t[d + 208 >> 2] = Bn, t[d + 212 >> 2] = kn, t[d + 200 >> 2] = jn, t[d + 204 >> 2] = Zn, t[d + 320 >> 2] = 0, Or(d + 72 | 0, or, L, T), t[d + 192 >> 2]) || (v = he, n = v >>> 16 | 0, t[d + 360 >> 2] = (v & 65535) << 16 | tr >>> 16, t[d + 364 >> 2] = n, a = ai, t[d + 328 >> 2] = a, he = cr & 1048575, t[d + 332 >> 2] = he, I = v, v = Mr, n = tr << 4 & 1048560 | v >>> 28, xr = n, Me = (v & 268435455) << 4 | Ir >>> 28, t[d + 352 >> 2] = Me, t[d + 356 >> 2] = n, n = v << 24 | Ir >>> 8, v = gr, or = Ir << 24 & -16777216 | v >>> 8, t[d + 344 >> 2] = or, T = n & 1048575, t[d + 348 >> 2] = T, n = v << 12, v = ni, L = (n | v >>> 20) & 1048575, Be = v << 12 & -4096 | cr >>> 20, t[d + 336 >> 2] = Be, t[d + 340 >> 2] = L, v = 1, wn(d + 328 | 0, d + 72 | 0)))
            break t;
          if (I | !I & tr >>> 0 > 65535) {
            v = 0;
            break t;
          }
          if (Me | xr) {
            v = 0;
            break t;
          }
          if (T | !T & or >>> 0 > 21319971) {
            v = 0;
            break t;
          }
          r: {
            if (T | (or | 0) != 21319971)
              break r;
            if ((L | 0) == 103691 & Be >>> 0 > 1979466754 | L >>> 0 > 103691) {
              v = 0;
              break t;
            }
            if ((Be | 0) != 1979466754 | (L | 0) != 103691)
              break r;
            if (v = 0, (he | 0) == 893298 & a >>> 0 > 801749741 | he >>> 0 > 893298)
              break t;
          }
          t[d + 360 >> 2] = -1, t[d + 364 >> 2] = 65535, t[d + 352 >> 2] = -1, t[d + 356 >> 2] = 1048575, n = T + 1048575 | 0, v = or - 21319972 | 0, n = v >>> 0 < 4273647324 ? n + 1 | 0 : n, t[d + 344 >> 2] = v, t[d + 348 >> 2] = n, n = L + 944884 | 0, I = Be - 1979466755 | 0, n = I >>> 0 < 2315500541 ? n + 1 | 0 : n, t[d + 336 >> 2] = I, t[d + 340 >> 2] = n, T = he + 155276 | 0, v = a - 801750719 | 0, T = v >>> 0 < 3493216577 ? T + 1 | 0 : T, t[d + 328 >> 2] = v, t[d + 332 >> 2] = T, v = (wn(d + 328 | 0, d + 72 | 0) | 0) != 0;
        }
        x = d + 464 | 0, n = v;
        break e;
      }
      P(1);
    }
    return x = E + 192 | 0, n | 0;
  }
  function Jr(v, d) {
    v = v | 0, d = d | 0;
    var I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0;
    Me = x - 176 | 0, x = Me, L = Me + 8 | 0, Vi(L, 65), I = t[172688], E = x - 80 | 0, x = E, t[E + 12 >> 2] = 0;
    e: {
      if (!L) {
        Qn[t[I + 168 >> 2]](689748, t[I + 172 >> 2]);
        break e;
      }
      if (d >>> 0 >= 4) {
        Qn[t[I + 168 >> 2]](689986, t[I + 172 >> 2]);
        break e;
      }
      if (I = E + 12 | 0, Zr(E + 48 | 0, 690981, I), n = t[E + 12 >> 2], Zr(E + 16 | 0, 691013, I), !(n | t[E + 12 >> 2])) {
        I = t[E + 52 >> 2], n = t[E + 48 >> 2], u[L | 0] = n, u[L + 1 | 0] = n >>> 8, u[L + 2 | 0] = n >>> 16, u[L + 3 | 0] = n >>> 24, u[L + 4 | 0] = I, u[L + 5 | 0] = I >>> 8, u[L + 6 | 0] = I >>> 16, u[L + 7 | 0] = I >>> 24, I = t[E + 20 >> 2], n = t[E + 16 >> 2], u[L + 32 | 0] = n, u[L + 33 | 0] = n >>> 8, u[L + 34 | 0] = n >>> 16, u[L + 35 | 0] = n >>> 24, u[L + 36 | 0] = I, u[L + 37 | 0] = I >>> 8, u[L + 38 | 0] = I >>> 16, u[L + 39 | 0] = I >>> 24, u[L + 64 | 0] = d, n = E + 48 | 0, d = n + 24 | 0, I = t[d + 4 >> 2], a = L + 24 | 0, d = t[d >> 2], u[a | 0] = d, u[a + 1 | 0] = d >>> 8, u[a + 2 | 0] = d >>> 16, u[a + 3 | 0] = d >>> 24, u[a + 4 | 0] = I, u[a + 5 | 0] = I >>> 8, u[a + 6 | 0] = I >>> 16, u[a + 7 | 0] = I >>> 24, d = n + 16 | 0, I = t[d + 4 >> 2], a = L + 16 | 0, d = t[d >> 2], u[a | 0] = d, u[a + 1 | 0] = d >>> 8, u[a + 2 | 0] = d >>> 16, u[a + 3 | 0] = d >>> 24, u[a + 4 | 0] = I, u[a + 5 | 0] = I >>> 8, u[a + 6 | 0] = I >>> 16, u[a + 7 | 0] = I >>> 24, d = n + 8 | 0, n = t[d + 4 >> 2], I = L + 8 | 0, d = t[d >> 2], u[I | 0] = d, u[I + 1 | 0] = d >>> 8, u[I + 2 | 0] = d >>> 16, u[I + 3 | 0] = d >>> 24, u[I + 4 | 0] = n, u[I + 5 | 0] = n >>> 8, u[I + 6 | 0] = n >>> 16, u[I + 7 | 0] = n >>> 24, n = E + 16 | 0, d = n + 8 | 0, I = t[d + 4 >> 2], a = L + 40 | 0, d = t[d >> 2], u[a | 0] = d, u[a + 1 | 0] = d >>> 8, u[a + 2 | 0] = d >>> 16, u[a + 3 | 0] = d >>> 24, u[a + 4 | 0] = I, u[a + 5 | 0] = I >>> 8, u[a + 6 | 0] = I >>> 16, u[a + 7 | 0] = I >>> 24, d = n + 16 | 0, I = t[d + 4 >> 2], a = L + 48 | 0, d = t[d >> 2], u[a | 0] = d, u[a + 1 | 0] = d >>> 8, u[a + 2 | 0] = d >>> 16, u[a + 3 | 0] = d >>> 24, u[a + 4 | 0] = I, u[a + 5 | 0] = I >>> 8, u[a + 6 | 0] = I >>> 16, u[a + 7 | 0] = I >>> 24, d = n + 24 | 0, n = t[d + 4 >> 2], I = L + 56 | 0, d = t[d >> 2], u[I | 0] = d, u[I + 1 | 0] = d >>> 8, u[I + 2 | 0] = d >>> 16, u[I + 3 | 0] = d >>> 24, u[I + 4 | 0] = n, u[I + 5 | 0] = n >>> 8, u[I + 6 | 0] = n >>> 16, u[I + 7 | 0] = n >>> 24, n = 1;
        break e;
      }
      n = 0, Vi(L, 65);
    }
    x = E + 80 | 0;
    e: {
      t: {
        if (!n) {
          P(4);
          break t;
        }
        d = Me + 136 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = Me + 128 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = Me + 120 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = Me + 112 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = Me + 104 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = Me + 96 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = Me + 88 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, t[Me + 80 >> 2] = 0, t[Me + 84 >> 2] = 0, I = rr(), or = Me + 80 | 0, n = x - 640 | 0, x = n, d = Me + 8 | 0;
        r: {
          n: {
            if (!d) {
              Qn[t[I + 168 >> 2]](689760, t[I + 172 >> 2]);
              break n;
            }
            if (!or) {
              Qn[t[I + 168 >> 2]](689638, t[I + 172 >> 2]);
              break n;
            }
            E = d + 40 | 0, a = l[E + 4 | 0] | l[E + 5 | 0] << 8 | (l[E + 6 | 0] << 16 | l[E + 7 | 0] << 24), I = n + 48 | 0, t[I >> 2] = l[E | 0] | l[E + 1 | 0] << 8 | (l[E + 2 | 0] << 16 | l[E + 3 | 0] << 24), t[I + 4 >> 2] = a, E = d + 48 | 0, a = l[E + 4 | 0] | l[E + 5 | 0] << 8 | (l[E + 6 | 0] << 16 | l[E + 7 | 0] << 24), I = n + 56 | 0, t[I >> 2] = l[E | 0] | l[E + 1 | 0] << 8 | (l[E + 2 | 0] << 16 | l[E + 3 | 0] << 24), t[I + 4 >> 2] = a, E = d + 56 | 0, a = l[E + 4 | 0] | l[E + 5 | 0] << 8 | (l[E + 6 | 0] << 16 | l[E + 7 | 0] << 24), I = n - -64 | 0, t[I >> 2] = l[E | 0] | l[E + 1 | 0] << 8 | (l[E + 2 | 0] << 16 | l[E + 3 | 0] << 24), t[I + 4 >> 2] = a, I = l[d + 36 | 0] | l[d + 37 | 0] << 8 | (l[d + 38 | 0] << 16 | l[d + 39 | 0] << 24), t[n + 40 >> 2] = l[d + 32 | 0] | l[d + 33 | 0] << 8 | (l[d + 34 | 0] << 16 | l[d + 35 | 0] << 24), t[n + 44 >> 2] = I, xr = l[d + 64 | 0], tr = l[d + 24 | 0] | l[d + 25 | 0] << 8 | (l[d + 26 | 0] << 16 | l[d + 27 | 0] << 24), I = l[d + 28 | 0] | l[d + 29 | 0] << 8 | (l[d + 30 | 0] << 16 | l[d + 31 | 0] << 24), dr = l[d + 16 | 0] | l[d + 17 | 0] << 8 | (l[d + 18 | 0] << 16 | l[d + 19 | 0] << 24), L = l[d + 20 | 0] | l[d + 21 | 0] << 8 | (l[d + 22 | 0] << 16 | l[d + 23 | 0] << 24), Mr = l[d + 8 | 0] | l[d + 9 | 0] << 8 | (l[d + 10 | 0] << 16 | l[d + 11 | 0] << 24), E = l[d + 12 | 0] | l[d + 13 | 0] << 8 | (l[d + 14 | 0] << 16 | l[d + 15 | 0] << 24), Wr = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), a = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), Zr(n + 8 | 0, 655649, 0);
            i: {
              if (!(tr | (dr | (Mr | Wr)) | (I | (L | (a | E)))) || !(t[n + 64 >> 2] | (t[n + 56 >> 2] | (t[n + 48 >> 2] | t[n + 40 >> 2])) | (t[n + 68 >> 2] | (t[n + 60 >> 2] | (t[n + 52 >> 2] | t[n + 44 >> 2])))))
                break i;
              if (d = n, t[d + 632 >> 2] = (I & 65535) << 16 | tr >>> 16, t[d + 636 >> 2] = I >>> 16, t[d + 600 >> 2] = Wr, kn = a & 1048575, t[d + 604 >> 2] = kn, gr = tr << 4, Be = gr & 1044480, T = Be | (gr & 4080 | L >>> 28), xn = T, gn = (L & 268435455) << 4 | dr >>> 28, t[d + 624 >> 2] = gn, t[d + 628 >> 2] = T, gr = L << 24 | dr >>> 8, $r = gr & 983040, Ir = gr & 65280, cr = dr << 24 & -16777216 | E >>> 8, t[d + 616 >> 2] = cr, Bn = $r | (Ir | gr & 255), t[d + 620 >> 2] = Bn, T = E << 12 | Mr >>> 20, $r = T & 1044480, Ir = T & 4080, d = Mr << 12, gr = d & -268435456, Be = T & 15, he = d & 267386880, he = gr | (he | (d & 1044480 | a >>> 20)), t[n + 608 >> 2] = he, Be = $r | (Be | Ir), t[n + 612 >> 2] = Be, xr & 2) {
                if (I | !I & tr >>> 0 > 65535 || xn | gn || Bn | !Bn & cr >>> 0 > 21319971)
                  break i;
                s: {
                  if (Bn | (cr | 0) != 21319971)
                    break s;
                  if ((Be | 0) == 103691 & he >>> 0 > 1979466754 | Be >>> 0 > 103691)
                    break i;
                  if ((he | 0) != 1979466754 | (Be | 0) != 103691)
                    break s;
                  if ((kn | 0) == 893298 & Wr >>> 0 > 801749741 | kn >>> 0 > 893298)
                    break i;
                }
                t[n + 632 >> 2] = -1, t[n + 636 >> 2] = 65535, t[n + 624 >> 2] = -1, t[n + 628 >> 2] = 1048575, T = Bn + 1048575 | 0, d = cr - 21319972 | 0, T = d >>> 0 < 4273647324 ? T + 1 | 0 : T, t[n + 616 >> 2] = d, t[n + 620 >> 2] = T, d = Be + 944884 | 0, he = he - 1979466755 | 0, d = he >>> 0 < 2315500541 ? d + 1 | 0 : d, t[n + 608 >> 2] = he, t[n + 612 >> 2] = d, T = kn + 155276 | 0, d = Wr - 801750719 | 0, T = d >>> 0 < 3493216577 ? T + 1 | 0 : T, t[n + 600 >> 2] = d, t[n + 604 >> 2] = T;
              }
              if (!Cn(n + 512 | 0, n + 600 | 0, xr & 1) || (Be = n + 512 | 0, he = Be + 8 | 0, T = t[he + 4 >> 2], cr = n + 384 | 0, d = cr + 8 | 0, t[d >> 2] = t[he >> 2], t[d + 4 >> 2] = T, he = Be + 16 | 0, T = t[he + 4 >> 2], d = cr + 16 | 0, t[d >> 2] = t[he >> 2], t[d + 4 >> 2] = T, he = Be + 24 | 0, T = t[he + 4 >> 2], d = cr + 24 | 0, t[d >> 2] = t[he >> 2], t[d + 4 >> 2] = T, he = Be + 32 | 0, T = t[he + 4 >> 2], d = cr + 32 | 0, t[d >> 2] = t[he >> 2], t[d + 4 >> 2] = T, he = Be + 48 | 0, T = t[he + 4 >> 2], d = cr + 48 | 0, t[d >> 2] = t[he >> 2], t[d + 4 >> 2] = T, he = Be + 56 | 0, T = t[he + 4 >> 2], d = cr + 56 | 0, t[d >> 2] = t[he >> 2], t[d + 4 >> 2] = T, he = Be - -64 | 0, T = t[he + 4 >> 2], d = cr - -64 | 0, t[d >> 2] = t[he >> 2], t[d + 4 >> 2] = T, he = Be + 72 | 0, T = t[he + 4 >> 2], d = cr + 72 | 0, t[d >> 2] = t[he >> 2], t[d + 4 >> 2] = T, t[n + 504 >> 2] = t[n + 592 >> 2], d = t[n + 516 >> 2], t[n + 384 >> 2] = t[n + 512 >> 2], t[n + 388 >> 2] = d, d = t[n + 556 >> 2], t[n + 424 >> 2] = t[n + 552 >> 2], t[n + 428 >> 2] = d, d = n + 472 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = n + 480 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = n + 488 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = n + 496 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, t[n + 464 >> 2] = 1, t[n + 468 >> 2] = 0, t[n + 104 >> 2] = I >>> 24, t[n + 108 >> 2] = 0, I = I << 6 | tr >>> 26, d = L, t[n + 96 >> 2] = tr << 6 | d >>> 26, t[n + 100 >> 2] = I & 1073741823, L = d << 4 | dr >>> 28, I = n, d = E, t[I + 88 >> 2] = dr << 4 | d >>> 28, t[I + 92 >> 2] = L & 1073741823, t[I + 80 >> 2] = Mr << 2 | a >>> 30, t[I + 84 >> 2] = (d << 2 | Mr >>> 30) & 1073741823, t[I + 72 >> 2] = Wr, t[I + 76 >> 2] = a & 1073741823, gr = I + 72 | 0, Rr(gr, 690320), L = t[I + 104 >> 2] << 24, a = t[I + 100 >> 2], d = a >>> 6 | 0, E = t[I + 96 >> 2], t[I + 376 >> 2] = (a & 63) << 26 | E >>> 6, t[I + 380 >> 2] = d | L, E = E << 26, d = t[I + 92 >> 2], T = d >>> 4 | 0, a = t[I + 88 >> 2], t[I + 368 >> 2] = (d & 15) << 28 | a >>> 4, t[I + 372 >> 2] = T | E, L = a << 28, a = t[I + 84 >> 2], d = a >>> 2 | 0, E = t[I + 80 >> 2], t[I + 360 >> 2] = (a & 3) << 30 | E >>> 2, t[I + 364 >> 2] = d | L, L = t[I + 76 >> 2], T = E << 30, t[I + 352 >> 2] = t[I + 72 >> 2], t[I + 356 >> 2] = T | L, Be = I + 320 | 0, he = I + 352 | 0, Er(Be, he, I + 8 | 0), gn = t[I + 344 >> 2], Wr = t[I + 336 >> 2], tr = t[I + 328 >> 2], a = t[I + 320 >> 2], Mr = t[I + 348 >> 2], dr = t[I + 340 >> 2], T = t[I + 332 >> 2], L = t[I + 324 >> 2], d = gn | (Wr | (tr | a)) | (Mr | (dr | (T | L))) ? -1 : 0, Ir = a ^ -1, E = Ir - 801750718 | 0, t[I + 320 >> 2] = d & E, a = d, L = L ^ -1, d = L - ((Ir >>> 0 < 801750718) + 1076732275 | 0) | 0, t[I + 324 >> 2] = a & d, d = (d | 0) == (L | 0) & E >>> 0 < Ir >>> 0 | d >>> 0 < L >>> 0, tr = tr ^ -1, xr = d + tr | 0, $r = T ^ -1, T = $r, T = d >>> 0 > xr >>> 0 ? T + 1 | 0 : T, d = xr - 1354194885 | 0, t[I + 328 >> 2] = d & a, Ir = T - ((xr >>> 0 < 1354194885) + 1162945305 | 0) | 0, t[I + 332 >> 2] = Ir & a, L = Wr ^ -1, d = (T | 0) == (Ir | 0) & d >>> 0 < xr >>> 0 | T >>> 0 > Ir >>> 0, tr = d + ((T | 0) == ($r | 0) & tr >>> 0 > xr >>> 0 | T >>> 0 < $r >>> 0) | 0, dr = dr ^ -1, d = dr + (d >>> 0 > tr >>> 0) | 0, T = L + tr | 0, d = T >>> 0 < tr >>> 0 ? d + 1 | 0 : d, E = T - 2 | 0, t[I + 336 >> 2] = E & a, tr = d - (T >>> 0 < 2) | 0, t[I + 340 >> 2] = tr & a, xn = (d | 0) == (dr | 0) & T >>> 0 < L >>> 0 | d >>> 0 < dr >>> 0, d = (d | 0) == (tr | 0) & T >>> 0 > E >>> 0 | d >>> 0 > tr >>> 0, I = xn + d | 0, T = d >>> 0 > I >>> 0, d = I - gn | 0, t[n + 344 >> 2] = d - 2 & a, t[n + 348 >> 2] = (T - ((I >>> 0 < gn >>> 0) + Mr | 0) | 0) - (d >>> 0 < 2) & a, I = n + 288 | 0, Er(I, he, n + 40 | 0), d = n + 160 | 0, Or(d, cr, I, Be), Ls(gr, d), t[n + 280 >> 2]))
                break i;
              In(or, n + 72 | 0), d = 1;
              break r;
            }
            u[or | 0] = 0, u[or + 1 | 0] = 0, u[or + 2 | 0] = 0, u[or + 3 | 0] = 0, u[or + 4 | 0] = 0, u[or + 5 | 0] = 0, u[or + 6 | 0] = 0, u[or + 7 | 0] = 0, d = or + 56 | 0, u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, d = or + 48 | 0, u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, d = or + 40 | 0, u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, d = or + 32 | 0, u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, d = or + 24 | 0, u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, d = or + 16 | 0, u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, d = or + 8 | 0, u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0;
          }
          d = 0;
        }
        if (x = n + 640 | 0, !d)
          break t;
        if (t[Me + 144 >> 2] = v, v = zr(t[172688], Me + 144 | 0, Me + 80 | 0, (v | 0) == 33 ? 258 : 2), t[Me + 148 >> 2] = v, (v | 0) != 1)
          break e;
        Un = 1;
      }
      return x = Me + 176 | 0, Un | 0;
    }
    t[Me + 160 >> 2] = 0, Ne(Me + 152 | 0), wasm2js_trap();
  }
  function fn() {
    var v = 0, d = 0, I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0, Xn = 0, Zn = 0, ni = 0, ai = 0, fi = 0, Ai = 0, yi = 0;
    n = x - 192 | 0, x = n, v = n + 128 | 0, I = v + 56 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = v + 48 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = v + 40 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = v + 32 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = v + 24 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = v + 16 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = v + 8 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, t[n + 128 >> 2] = 0, t[n + 132 >> 2] = 0;
    e: {
      if ((Ds(t[172688], v, 690885) | 0) == 1) {
        I = n + 128 | 0, v = I + 15 | 0, T = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), a = n - -64 | 0, E = a + 8 | 0, t[E >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[E + 4 >> 2] = T, v = I + 23 | 0, d = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), T = a + 16 | 0, t[T >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[T + 4 >> 2] = d, v = I + 31 | 0, Be = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), d = a + 24 | 0, t[d >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[d + 4 >> 2] = Be, v = I + 39 | 0, L = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), Be = a + 32 | 0, t[Be >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[Be + 4 >> 2] = L, v = I + 47 | 0, tr = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), L = a + 40 | 0, t[L >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[L + 4 >> 2] = tr, v = I + 55 | 0, Me = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), tr = a + 48 | 0, t[tr >> 2] = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), t[tr + 4 >> 2] = Me, v = a + 56 | 0, u[v | 0] = l[I + 63 | 0], u[n + 2 | 0] = l[n + 130 | 0], p[n >> 1] = m[n + 128 >> 1], I = l[n + 139 | 0] | l[n + 140 | 0] << 8 | (l[n + 141 | 0] << 16 | l[n + 142 | 0] << 24), t[n + 64 >> 2] = l[n + 135 | 0] | l[n + 136 | 0] << 8 | (l[n + 137 | 0] << 16 | l[n + 138 | 0] << 24), t[n + 68 >> 2] = I, I = l[n + 131 | 0] | l[n + 132 | 0] << 8 | (l[n + 133 | 0] << 16 | l[n + 134 | 0] << 24), u[n + 63 | 0] = l[v | 0], a = t[tr + 4 >> 2], v = n + 55 | 0, tr = t[tr >> 2], u[v | 0] = tr, u[v + 1 | 0] = tr >>> 8, u[v + 2 | 0] = tr >>> 16, u[v + 3 | 0] = tr >>> 24, u[v + 4 | 0] = a, u[v + 5 | 0] = a >>> 8, u[v + 6 | 0] = a >>> 16, u[v + 7 | 0] = a >>> 24, a = t[L + 4 >> 2], v = n + 47 | 0, L = t[L >> 2], u[v | 0] = L, u[v + 1 | 0] = L >>> 8, u[v + 2 | 0] = L >>> 16, u[v + 3 | 0] = L >>> 24, u[v + 4 | 0] = a, u[v + 5 | 0] = a >>> 8, u[v + 6 | 0] = a >>> 16, u[v + 7 | 0] = a >>> 24, a = t[Be + 4 >> 2], v = n + 39 | 0, Be = t[Be >> 2], u[v | 0] = Be, u[v + 1 | 0] = Be >>> 8, u[v + 2 | 0] = Be >>> 16, u[v + 3 | 0] = Be >>> 24, u[v + 4 | 0] = a, u[v + 5 | 0] = a >>> 8, u[v + 6 | 0] = a >>> 16, u[v + 7 | 0] = a >>> 24, a = t[d + 4 >> 2], v = n + 31 | 0, d = t[d >> 2], u[v | 0] = d, u[v + 1 | 0] = d >>> 8, u[v + 2 | 0] = d >>> 16, u[v + 3 | 0] = d >>> 24, u[v + 4 | 0] = a, u[v + 5 | 0] = a >>> 8, u[v + 6 | 0] = a >>> 16, u[v + 7 | 0] = a >>> 24, a = t[T + 4 >> 2], v = n + 23 | 0, T = t[T >> 2], u[v | 0] = T, u[v + 1 | 0] = T >>> 8, u[v + 2 | 0] = T >>> 16, u[v + 3 | 0] = T >>> 24, u[v + 4 | 0] = a, u[v + 5 | 0] = a >>> 8, u[v + 6 | 0] = a >>> 16, u[v + 7 | 0] = a >>> 24, a = t[E + 4 >> 2], v = n + 15 | 0, E = t[E >> 2], u[v | 0] = E, u[v + 1 | 0] = E >>> 8, u[v + 2 | 0] = E >>> 16, u[v + 3 | 0] = E >>> 24, u[v + 4 | 0] = a, u[v + 5 | 0] = a >>> 8, u[v + 6 | 0] = a >>> 16, u[v + 7 | 0] = a >>> 24, u[n + 3 | 0] = I, u[n + 4 | 0] = I >>> 8, u[n + 5 | 0] = I >>> 16, u[n + 6 | 0] = I >>> 24, v = t[n + 68 >> 2], I = t[n + 64 >> 2], u[n + 7 | 0] = I, u[n + 8 | 0] = I >>> 8, u[n + 9 | 0] = I >>> 16, u[n + 10 | 0] = I >>> 24, u[n + 11 | 0] = v, u[n + 12 | 0] = v >>> 8, u[n + 13 | 0] = v >>> 16, u[n + 14 | 0] = v >>> 24, Ir = rr(), d = x - 496 | 0, x = d;
        t: {
          if (!n) {
            Qn[t[Ir + 168 >> 2]](689638, t[Ir + 172 >> 2]);
            break t;
          }
          if (!vn(d + 136 | 0, 690981) || (Zr(d + 464 | 0, 691013, d + 12 | 0), t[d + 12 >> 2]))
            break t;
          if (I = l[n + 4 | 0] | l[n + 5 | 0] << 8 | (l[n + 6 | 0] << 16 | l[n + 7 | 0] << 24), T = I, Me = I >>> 20 | 0, E = Me, v = l[n + 12 | 0] | l[n + 13 | 0] << 8 | (l[n + 14 | 0] << 16 | l[n + 15 | 0] << 24), or = v, Bn = l[n + 8 | 0] | l[n + 9 | 0] << 8 | (l[n + 10 | 0] << 16 | l[n + 11 | 0] << 24), I = Bn, v = v << 12 | I >>> 20, xr = I << 12, kn = E | xr & -4096, tr = v, xn = v & 1048575, Un = or >>> 8 | 0, Be = Un, v = l[n + 20 | 0] | l[n + 21 | 0] << 8 | (l[n + 22 | 0] << 16 | l[n + 23 | 0] << 24), L = v, $r = l[n + 16 | 0] | l[n + 17 | 0] << 8 | (l[n + 18 | 0] << 16 | l[n + 19 | 0] << 24), I = $r, v = v << 24 | I >>> 8, Gn = Be | I << 24 & -16777216, I = v, jn = v & 1048575, E = l[n + 28 | 0] | l[n + 29 | 0] << 8 | (l[n + 30 | 0] << 16 | l[n + 31 | 0] << 24), Be = E, dr = l[n + 24 | 0] | l[n + 25 | 0] << 8 | (l[n + 26 | 0] << 16 | l[n + 27 | 0] << 24), Mr = (E & 65535) << 16 | dr >>> 16, gr = E >>> 16 | 0, E = L >>> 28 | 0, he = (L & 268435455) << 4 | $r >>> 28, Wr = l[n | 0] | l[n + 1 | 0] << 8 | (l[n + 2 | 0] << 16 | l[n + 3 | 0] << 24), a = dr, v = a << 4, Xn = E | v & 1048560, cr = T & 1048575, !(he | (Gn | (Mr | (Wr | kn))) | (Xn | (jn | (gr | (cr | xn)))))) {
            Qn[t[Ir + 168 >> 2]](690116, t[Ir + 172 >> 2]);
            break t;
          }
          if (dr = l[n + 56 | 0] | l[n + 57 | 0] << 8 | (l[n + 58 | 0] << 16 | l[n + 59 | 0] << 24), Ir = l[n + 60 | 0] | l[n + 61 | 0] << 8 | (l[n + 62 | 0] << 16 | l[n + 63 | 0] << 24), gn = l[n + 48 | 0] | l[n + 49 | 0] << 8 | (l[n + 50 | 0] << 16 | l[n + 51 | 0] << 24), ni = l[n + 52 | 0] | l[n + 53 | 0] << 8 | (l[n + 54 | 0] << 16 | l[n + 55 | 0] << 24), ai = l[n + 40 | 0] | l[n + 41 | 0] << 8 | (l[n + 42 | 0] << 16 | l[n + 43 | 0] << 24), fi = l[n + 44 | 0] | l[n + 45 | 0] << 8 | (l[n + 46 | 0] << 16 | l[n + 47 | 0] << 24), Ai = l[n + 32 | 0] | l[n + 33 | 0] << 8 | (l[n + 34 | 0] << 16 | l[n + 35 | 0] << 24), Zn = l[n + 36 | 0] | l[n + 37 | 0] << 8 | (l[n + 38 | 0] << 16 | l[n + 39 | 0] << 24), u[d + 34 | 0] = Un, u[d + 21 | 0] = Mr, u[d + 38 | 0] = (tr & 1048575) << 12 | xr >>> 20, u[d + 37 | 0] = (tr & 268435455) << 4 | xr >>> 28, u[d + 36 | 0] = tr >>> 4, u[d + 35 | 0] = tr >>> 12, u[d + 30 | 0] = I, u[d + 29 | 0] = I >>> 8, u[d + 22 | 0] = v >>> 12, u[d + 47 | 0] = Wr, u[d + 46 | 0] = (T & 255) << 24 | Wr >>> 8, u[d + 45 | 0] = (T & 65535) << 16 | Wr >>> 16, u[d + 44 | 0] = (T & 16777215) << 8 | Wr >>> 24, u[d + 43 | 0] = T, u[d + 42 | 0] = T >>> 8, u[d + 41 | 0] = Me << 4 | cr >>> 16, u[d + 40 | 0] = T >>> 24, u[d + 39 | 0] = Bn, u[d + 33 | 0] = or >>> 16, u[d + 32 | 0] = or >>> 24, u[d + 31 | 0] = $r, v = L, u[d + 27 | 0] = v, u[d + 26 | 0] = v >>> 8, u[d + 25 | 0] = v >>> 16, u[d + 24 | 0] = v >>> 24, u[d + 23 | 0] = a, v = Be, u[d + 20 | 0] = (v & 16777215) << 8 | a >>> 24, u[d + 19 | 0] = v, u[d + 18 | 0] = v >>> 8, u[d + 17 | 0] = v >>> 16, u[d + 16 | 0] = v >>> 24, u[d + 28 | 0] = I >>> 16 & 15 | he << 4, t[d + 400 >> 2] = 64, t[d + 404 >> 2] = 0, t[d + 328 >> 2] = -1862921884, t[d + 332 >> 2] = 870954602, t[d + 320 >> 2] = -1748470448, t[d + 324 >> 2] = 3983205, t[d + 312 >> 2] = 292000018, t[d + 316 >> 2] = -782074353, t[d + 304 >> 2] = -1662207471, t[d + 308 >> 2] = 596792193, T = d + 304 | 0, Tn(T, 690981, 32), Tn(T, d + 16 | 0, 32), Tn(T, 655649, 32), L = d + 48 | 0, Yn(T, L), xr = d + 432 | 0, Zr(xr, L, 0), I = Ir, v = I >>> 16 | 0, Be = d + 176 | 0, a = Be + 72 | 0, t[a >> 2] = (I & 65535) << 16 | dr >>> 16, t[a + 4 >> 2] = v, E = dr << 4 & 1048560, I = ni, v = I >>> 28 | 0, a = Be - -64 | 0, t[a >> 2] = (I & 268435455) << 4 | gn >>> 28, t[a + 4 >> 2] = v | E, v = I << 24 | gn >>> 8, a = Be + 56 | 0, I = fi, t[a >> 2] = gn << 24 & -16777216 | I >>> 8, t[a + 4 >> 2] = v & 1048575, v = I << 12, I = ai, E = (v | I >>> 20) & 1048575, a = Be + 48 | 0, t[a >> 2] = I << 12 & -4096 | Zn >>> 20, t[a + 4 >> 2] = E, t[d + 296 >> 2] = 0, t[d + 256 >> 2] = 1, t[d + 260 >> 2] = 0, t[d + 216 >> 2] = Ai, t[d + 220 >> 2] = Zn & 1048575, t[d + 208 >> 2] = Mr, t[d + 212 >> 2] = gr, t[d + 200 >> 2] = he, t[d + 204 >> 2] = Xn, t[d + 192 >> 2] = Gn, t[d + 196 >> 2] = jn, t[d + 184 >> 2] = kn, t[d + 188 >> 2] = xn, t[d + 176 >> 2] = Wr, t[d + 180 >> 2] = cr, tr = t[d + 456 >> 2], cr = t[d + 448 >> 2], or = t[d + 440 >> 2], v = t[d + 432 >> 2], Mr = t[d + 460 >> 2], dr = t[d + 452 >> 2], he = t[d + 444 >> 2], I = t[d + 436 >> 2], a = tr | (cr | (or | v)) | (Mr | (dr | (he | I))) ? -1 : 0, v = v ^ -1, gr = v - 801750718 | 0, t[d + 432 >> 2] = a & gr, E = I ^ -1, Me = E - ((v >>> 0 < 801750718) + 1076732275 | 0) | 0, t[d + 436 >> 2] = Me & a, v = (E | 0) == (Me | 0) & v >>> 0 > gr >>> 0 | E >>> 0 > Me >>> 0, Me = or ^ -1, E = v + Me | 0, or = he ^ -1, v = or, gr = E - 1354194885 | 0, t[d + 440 >> 2] = gr & a, v = E >>> 0 < Me >>> 0 ? v + 1 | 0 : v, he = v - ((E >>> 0 < 1354194885) + 1162945305 | 0) | 0, t[d + 444 >> 2] = he & a, Ir = cr ^ -1, I = (v | 0) == (or | 0) & E >>> 0 < Me >>> 0 | v >>> 0 < or >>> 0, Me = (v | 0) == (he | 0) & E >>> 0 > gr >>> 0 | v >>> 0 > he >>> 0, E = I + Me | 0, cr = dr ^ -1, v = cr + (E >>> 0 < Me >>> 0) | 0, I = E, E = E + Ir | 0, v = I >>> 0 > E >>> 0 ? v + 1 | 0 : v, or = E - 2 | 0, t[d + 448 >> 2] = or & a, Me = v - (E >>> 0 < 2) | 0, t[d + 452 >> 2] = Me & a, I = (v | 0) == (cr | 0) & E >>> 0 < Ir >>> 0 | v >>> 0 < cr >>> 0, E = (v | 0) == (Me | 0) & E >>> 0 > or >>> 0 | v >>> 0 > Me >>> 0, I = I + E | 0, v = I >>> 0 < E >>> 0, E = I - tr | 0, t[d + 456 >> 2] = E - 2 & a, t[d + 460 >> 2] = (v - ((I >>> 0 < tr >>> 0) + Mr | 0) | 0) - (E >>> 0 < 2) & a, v = d + 288 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = d + 280 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = d + 272 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = d + 264 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, Or(T, Be, xr, d + 464 | 0), Ls(L, T), t[d + 128 >> 2] || (E = t[d + 92 >> 2], a = d + 48 | 0, v = a + 72 | 0, he = t[v >> 2], T = t[v + 4 >> 2], cr = T, v = t[d + 88 >> 2], I = pn(T >>> 16 | 0, 0, 977, 1), Be = v + I | 0, v = E + Ee | 0, L = I >>> 0 > Be >>> 0 ? v + 1 | 0 : v, v = a + 48 | 0, E = t[v >> 2], v = t[v + 4 >> 2], I = L >>> 20 | 0, T = I, I = I + E | 0, T = T >>> 0 > I >>> 0 ? v + 1 | 0 : v, tr = T & 1048575, v = a - -64 | 0, Me = t[v >> 2], dr = t[v + 4 >> 2], v = a + 56 | 0, E = t[v >> 2], v = t[v + 4 >> 2], a = T >>> 20 | 0, E = a + E | 0, or = a >>> 0 > E >>> 0 ? v + 1 | 0 : v, v = dr, a = or >>> 20 | 0, dr = a, a = a + Me | 0, v = dr >>> 0 > a >>> 0 ? v + 1 | 0 : v, Me = v & 1048575, or = or & 1048575, dr = (I & E & a) == -1 & (T & or & v) == 1048575, T = v, v = cr & 65535, T = T >>> 20 | 0, he = T + he | 0, T = T >>> 0 > he >>> 0 ? v + 1 | 0 : v, v = L & 1048575, cr = v, L = he, dr & ((L | 0) == -1 & (T | 0) == 65535) & ((v | 0) == 1048574 & Be >>> 0 > 4294966318 | v >>> 0 > 1048574) | T >>> 16 && (v = cr + 1 | 0, Be = Be + 977 | 0, v = Be >>> 0 < 977 ? v + 1 | 0 : v, cr = v & 1048575, he = v, v = tr, he = he >>> 20 | 0, I = I + he | 0, v = he >>> 0 > I >>> 0 ? v + 1 | 0 : v, tr = v & 1048575, he = v, v = or, he = he >>> 20 | 0, E = E + he | 0, v = he >>> 0 > E >>> 0 ? v + 1 | 0 : v, or = v & 1048575, he = v, v = Me, he = he >>> 20 | 0, a = a + he | 0, v = he >>> 0 > a >>> 0 ? v + 1 | 0 : v, Me = v & 1048575, he = v, v = T, T = L, L = (he >>> 20 | 0) + L | 0, T = (T >>> 0 > L >>> 0 ? v + 1 | 0 : v) & 65535), t[d + 120 >> 2] = L, t[d + 124 >> 2] = T, t[d + 112 >> 2] = a, t[d + 116 >> 2] = Me, t[d + 104 >> 2] = E, t[d + 108 >> 2] = or, t[d + 96 >> 2] = I, t[d + 100 >> 2] = tr, t[d + 88 >> 2] = Be, t[d + 92 >> 2] = cr, Be & 1) || (v = t[d + 48 >> 2], I = t[d + 136 >> 2], a = v - I | 0, T = t[d + 52 >> 2] - (t[d + 140 >> 2] + (v >>> 0 < I >>> 0) | 0) | 0, v = t[d + 80 >> 2], E = t[d + 168 >> 2], I = (v - E | 0) - 4 | 0, v = (t[d + 84 >> 2] - (t[d + 172 >> 2] + (v >>> 0 < E >>> 0) | 0) | 0) + 262143 | 0, E = I >>> 0 < 4294967292 ? v + 1 | 0 : v, Be = pn(E >>> 16 | 0, 0, 977, 1), a = Be + a | 0, v = T + Ee | 0, v = (a >>> 0 < Be >>> 0 ? v + 1 | 0 : v) + 4194299 | 0, a = a - 3908 | 0, v = a >>> 0 < 4294963388 ? v + 1 | 0 : v, T = v & 1048575, cr = T, or = a ^ 976, dr = T ^ 1, ((or | 0) != -1 | (dr | 0) != 1048575) & (a | T) != 0))
            break t;
          Me = I, Mr = E & 65535, I = t[d + 72 >> 2], E = t[d + 160 >> 2], tr = I - E | 0, he = t[d + 76 >> 2] - (t[d + 164 >> 2] + (I >>> 0 < E >>> 0) | 0) | 0, I = t[d + 64 >> 2], E = t[d + 152 >> 2], Be = I - E | 0, L = t[d + 68 >> 2] - (t[d + 156 >> 2] + (I >>> 0 < E >>> 0) | 0) | 0, I = v >>> 20 | 0, xr = t[d + 144 >> 2], gr = I - xr | 0, E = gr + t[d + 56 >> 2] | 0, v = t[d + 60 >> 2] - (t[d + 148 >> 2] + (I >>> 0 < xr >>> 0) | 0) | 0, v = (E >>> 0 < gr >>> 0 ? v + 1 | 0 : v) + 4194303 | 0, I = E - 4 | 0, E = I >>> 0 < 4294967292 ? v + 1 | 0 : v, v = L, T = E >>> 20 | 0, L = T, T = T + Be | 0, v = (L >>> 0 > T >>> 0 ? v + 1 | 0 : v) + 4194303 | 0, T = T - 4 | 0, Be = T >>> 0 < 4294967292 ? v + 1 | 0 : v, v = he, L = Be >>> 20 | 0, he = L, L = L + tr | 0, v = (he >>> 0 > L >>> 0 ? v + 1 | 0 : v) + 4194303 | 0, L = L - 4 | 0, tr = L >>> 0 < 4294967292 ? v + 1 | 0 : v, v = Mr, he = tr >>> 20 | 0, Me = he + Me | 0, v = he >>> 0 > Me >>> 0 ? v + 1 | 0 : v, (I & or & T & L & Me) == -1 ? he = (E & dr & Be & tr & (v ^ 983040)) == 1048575 : he = 0, he ? (I = 0, v = 0) : (I = L | (T | (I | a)) | Me, v = tr & 1048575 | (Be & 1048575 | (E & 1048575 | cr)) | v), yi = !(v | I);
        }
        x = d + 496 | 0;
        break e;
      }
      P(1);
    }
    return x = n + 192 | 0, yi | 0;
  }
  function jr(v, d, I, n, a) {
    var E = 0;
    e: {
      t: {
        if ((I | 0) != 1114112 && (E = 1, Qn[t[d + 16 >> 2]](v, I) | 0))
          break t;
        if (n)
          break e;
        E = 0;
      }
      return E;
    }
    return Qn[t[d + 12 >> 2]](v, n, a) | 0;
  }
  function dn(v, d) {
    v = v | 0, d = d | 0;
    var I = 0;
    if (l[v | 0])
      for (d = v + 1 | 0, v = 0; I = v + d | 0, v = v + 1 | 0, !!l[I | 0]; )
        ;
    wasm2js_trap();
  }
  function Tn(v, d, I) {
    var n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0, Xn = 0, Zn = 0, ni = 0, ai = 0, fi = 0, Ai = 0, yi = 0, Ii = 0, wi = 0, Bi = 0, Ti = 0, Oi = 0, Hi = 0, Xi = 0, Zi = 0, ts = 0, us = 0, hs = 0, ws = 0, ks = 0, Bs = 0, gs = 0, ps = 0, zs = 0, Gs = 0, to = 0, ro = 0, $s = 0, Xs = 0, Ao = 0, co = 0, Co = 0, wo = 0, fo = 0, pi = 0, bi = 0, Ni = 0, Wi = 0, ns = 0, ji = 0, rs = 0, Is = 0, ds = 0, bo = 0, Uo = 0, Ho = 0, Ro = 0, vo = 0, js = 0;
    if (n = t[v + 100 >> 2], a = t[v + 96 >> 2], L = a + I | 0, n = L >>> 0 < I >>> 0 ? n + 1 | 0 : n, t[v + 96 >> 2] = L, t[v + 100 >> 2] = n, n = a & 63, fo = 64 - n | 0, fo >>> 0 <= I >>> 0)
      for (Ro = v + 32 | 0; $i(n + Ro | 0, d, fo), a = l[v + 67 | 0], n = l[v + 65 | 0] << 16 | l[v + 64 | 0] << 24, Ti = a | (n | l[v + 66 | 0] << 8), Be = l[v + 39 | 0], L = l[v + 37 | 0] << 16 | l[v + 36 | 0] << 24, tr = Be | (L | l[v + 38 | 0] << 8), Bn = l[v + 59 | 0], kn = l[v + 57 | 0] << 16 | l[v + 56 | 0] << 24, $r = Bn | (kn | l[v + 58 | 0] << 8), T = l[v + 51 | 0], xr = l[v + 49 | 0] << 16 | l[v + 48 | 0] << 24, dr = T | (xr | l[v + 50 | 0] << 8), or = l[v + 43 | 0], Me = l[v + 41 | 0] << 16 | l[v + 40 | 0] << 24, cr = or | (Me | l[v + 42 | 0] << 8), Co = (a << 25 | Ti >>> 7) ^ (Ti << 14 | n >>> 18) ^ Ti >>> 3, gr = l[v + 63 | 0], a = l[v + 61 | 0] << 16 | l[v + 60 | 0] << 24, gn = gr | (a | l[v + 62 | 0] << 8), Wr = l[v + 71 | 0], Ir = l[v + 69 | 0] << 16 | l[v + 68 | 0] << 24, ts = Wr | (Ir | l[v + 70 | 0] << 8), n = l[v + 32 | 0] | l[v + 33 | 0] << 8 | (l[v + 34 | 0] << 16 | l[v + 35 | 0] << 24), Gs = n << 8 & 16711680 | n << 24 | (n >>> 8 & 65280 | n >>> 24), he = ts + (Gs + ((Be << 25 | tr >>> 7) ^ (tr << 14 | L >>> 18) ^ tr >>> 3) | 0) | 0, L = l[v + 89 | 0] << 16 | l[v + 88 | 0] << 24, n = L | l[v + 90 | 0] << 8, xn = l[v + 91 | 0], Gn = n | xn, E = he + ((Gn << 15 | L >>> 17) ^ ((Gn << 13 | L >>> 19) ^ n >>> 10)) | 0, to = (Bn << 25 | $r >>> 7) ^ ($r << 14 | kn >>> 18) ^ $r >>> 3, Bn = l[v + 55 | 0], kn = l[v + 53 | 0] << 16 | l[v + 52 | 0] << 24, Mr = Bn | (kn | l[v + 54 | 0] << 8), Ai = l[v + 83 | 0], Xn = l[v + 81 | 0] << 16 | l[v + 80 | 0] << 24, us = Ai | (Xn | l[v + 82 | 0] << 8), he = (T << 25 | dr >>> 7) ^ (dr << 14 | xr >>> 18) ^ dr >>> 3, Un = l[v + 47 | 0], xr = l[v + 45 | 0] << 16 | l[v + 44 | 0] << 24, ro = Un | (xr | l[v + 46 | 0] << 8), yi = l[v + 75 | 0], Ii = l[v + 73 | 0] << 16 | l[v + 72 | 0] << 24, hs = yi | (Ii | l[v + 74 | 0] << 8), wi = l[v + 95 | 0], Be = l[v + 93 | 0] << 16 | l[v + 92 | 0] << 24, n = Be | l[v + 94 | 0] << 8, jn = wi | n, T = (hs + (((or << 25 | cr >>> 7) ^ (cr << 14 | Me >>> 18) ^ cr >>> 3) + tr | 0) | 0) + ((jn << 15 | Be >>> 17) ^ ((jn << 13 | Be >>> 19) ^ n >>> 10)) | 0, Me = (us + (he + ro | 0) | 0) + (Nr(T, 15) ^ Nr(T, 13) ^ T >>> 10) | 0, or = ((to + Mr | 0) + Gn | 0) + (Nr(Me, 15) ^ Nr(Me, 13) ^ Me >>> 10) | 0, n = ((Co + gn | 0) + E | 0) + (Nr(or, 15) ^ Nr(or, 13) ^ or >>> 10) | 0, Is = (((Wr << 25 | ts >>> 7) ^ (ts << 14 | Ir >>> 18) ^ ts >>> 3) + Ti | 0) + T | 0, Co = (((gr << 25 | gn >>> 7) ^ (gn << 14 | a >>> 18) ^ gn >>> 3) + $r | 0) + jn | 0, to = ((Bn << 25 | Mr >>> 7) ^ (Mr << 14 | kn >>> 18) ^ Mr >>> 3) + dr | 0, Bn = l[v + 87 | 0], kn = l[v + 85 | 0] << 16 | l[v + 84 | 0] << 24, wo = Bn | (kn | l[v + 86 | 0] << 8), he = ((Un << 25 | ro >>> 7) ^ (ro << 14 | xr >>> 18) ^ ro >>> 3) + cr | 0, Bi = l[v + 79 | 0], xr = l[v + 77 | 0] << 16 | l[v + 76 | 0] << 24, ws = Bi | (xr | l[v + 78 | 0] << 8), gr = (he + ws | 0) + (Nr(E, 15) ^ Nr(E, 13) ^ E >>> 10) | 0, Ir = (to + wo | 0) + (Nr(gr, 15) ^ Nr(gr, 13) ^ gr >>> 10) | 0, Wr = Co + (Nr(Ir, 15) ^ Nr(Ir, 13) ^ Ir >>> 10) | 0, a = Is + (Nr(Wr, 15) ^ Nr(Wr, 13) ^ Wr >>> 10) | 0, Zn = a + ((Nr(E, 25) ^ Nr(E, 14) ^ E >>> 3) + jn | 0) | 0, he = (((xn << 25 | Gn >>> 7) ^ (Gn << 14 | L >>> 18) ^ Gn >>> 3) + wo | 0) + Wr | 0, xn = ((((yi << 25 | hs >>> 7) ^ (hs << 14 | Ii >>> 18) ^ hs >>> 3) + ts | 0) + gr | 0) + (Nr(n, 15) ^ Nr(n, 13) ^ n >>> 10) | 0, Un = ((((Ai << 25 | us >>> 7) ^ (us << 14 | Xn >>> 18) ^ us >>> 3) + ws | 0) + Ir | 0) + (Nr(xn, 15) ^ Nr(xn, 13) ^ xn >>> 10) | 0, Xn = he + (Nr(Un, 15) ^ Nr(Un, 13) ^ Un >>> 10) | 0, L = Zn + (Nr(Xn, 15) ^ Nr(Xn, 13) ^ Xn >>> 10) | 0, Oi = L + ((Nr(n, 25) ^ Nr(n, 14) ^ n >>> 3) + Wr | 0) | 0, Zn = ((Nr(or, 25) ^ Nr(or, 14) ^ or >>> 3) + Ir | 0) + Xn | 0, ni = ((Nr(Me, 25) ^ Nr(Me, 14) ^ Me >>> 3) + gr | 0) + Un | 0, ai = ((Nr(T, 25) ^ Nr(T, 14) ^ T >>> 3) + E | 0) + xn | 0, Ai = ((((Bi << 25 | ws >>> 7) ^ (ws << 14 | xr >>> 18) ^ ws >>> 3) + hs | 0) + Me | 0) + (Nr(a, 15) ^ Nr(a, 13) ^ a >>> 10) | 0, Ii = ((((Bn << 25 | wo >>> 7) ^ (wo << 14 | kn >>> 18) ^ wo >>> 3) + us | 0) + or | 0) + (Nr(Ai, 15) ^ Nr(Ai, 13) ^ Ai >>> 10) | 0, yi = ((((wi << 25 | jn >>> 7) ^ (jn << 14 | Be >>> 18) ^ jn >>> 3) + Gn | 0) + n | 0) + (Nr(Ii, 15) ^ Nr(Ii, 13) ^ Ii >>> 10) | 0, wi = ai + (Nr(yi, 15) ^ Nr(yi, 13) ^ yi >>> 10) | 0, Bi = ni + (Nr(wi, 15) ^ Nr(wi, 13) ^ wi >>> 10) | 0, Zn = Zn + (Nr(Bi, 15) ^ Nr(Bi, 13) ^ Bi >>> 10) | 0, Be = Oi + (Nr(Zn, 15) ^ Nr(Zn, 13) ^ Zn >>> 10) | 0, kn = Be + ((Nr(yi, 25) ^ Nr(yi, 14) ^ yi >>> 3) + Xn | 0) | 0, Bn = ((Nr(Ii, 25) ^ Nr(Ii, 14) ^ Ii >>> 3) + Un | 0) + Zn | 0, xr = ((Nr(Ai, 25) ^ Nr(Ai, 14) ^ Ai >>> 3) + xn | 0) + Bi | 0, Hi = ((Nr(a, 25) ^ Nr(a, 14) ^ a >>> 3) + n | 0) + wi | 0, ai = ((Nr(Wr, 25) ^ Nr(Wr, 14) ^ Wr >>> 3) + or | 0) + yi | 0, ni = ((Nr(Ir, 25) ^ Nr(Ir, 14) ^ Ir >>> 3) + Me | 0) + Ii | 0, Oi = (((Nr(gr, 25) ^ Nr(gr, 14) ^ gr >>> 3) + T | 0) + Ai | 0) + (Nr(L, 15) ^ Nr(L, 13) ^ L >>> 10) | 0, ni = ni + (Nr(Oi, 15) ^ Nr(Oi, 13) ^ Oi >>> 10) | 0, ai = ai + (Nr(ni, 15) ^ Nr(ni, 13) ^ ni >>> 10) | 0, Hi = Hi + (Nr(ai, 15) ^ Nr(ai, 13) ^ ai >>> 10) | 0, ks = xr + (Nr(Hi, 15) ^ Nr(Hi, 13) ^ Hi >>> 10) | 0, Bs = Bn + (Nr(ks, 15) ^ Nr(ks, 13) ^ ks >>> 10) | 0, kn = kn + (Nr(Bs, 15) ^ Nr(Bs, 13) ^ Bs >>> 10) | 0, Bn = ((Nr(L, 25) ^ Nr(L, 14) ^ L >>> 3) + yi | 0) + Hi | 0, xr = ((Nr(Xn, 25) ^ Nr(Xn, 14) ^ Xn >>> 3) + Ii | 0) + ai | 0, Xi = ((Nr(Un, 25) ^ Nr(Un, 14) ^ Un >>> 3) + Ai | 0) + ni | 0, gs = (((Nr(xn, 25) ^ Nr(xn, 14) ^ xn >>> 3) + a | 0) + Oi | 0) + (Nr(Be, 15) ^ Nr(Be, 13) ^ Be >>> 10) | 0, Xi = Xi + (Nr(gs, 15) ^ Nr(gs, 13) ^ gs >>> 10) | 0, ps = xr + (Nr(Xi, 15) ^ Nr(Xi, 13) ^ Xi >>> 10) | 0, Bn = Bn + (Nr(ps, 15) ^ Nr(ps, 13) ^ ps >>> 10) | 0, xr = Bn + ((Nr(Be, 25) ^ Nr(Be, 14) ^ Be >>> 3) + ai | 0) | 0, fi = ((Nr(Zn, 25) ^ Nr(Zn, 14) ^ Zn >>> 3) + ni | 0) + ps | 0, Zi = ((Nr(Bi, 25) ^ Nr(Bi, 14) ^ Bi >>> 3) + Oi | 0) + Xi | 0, zs = (((Nr(wi, 25) ^ Nr(wi, 14) ^ wi >>> 3) + L | 0) + gs | 0) + (Nr(kn, 15) ^ Nr(kn, 13) ^ kn >>> 10) | 0, pi = Zi + (Nr(zs, 15) ^ Nr(zs, 13) ^ zs >>> 10) | 0, bi = fi + (Nr(pi, 15) ^ Nr(pi, 13) ^ pi >>> 10) | 0, Ni = xr + (Nr(bi, 15) ^ Nr(bi, 13) ^ bi >>> 10) | 0, xr = Ni + ((Nr(kn, 25) ^ Nr(kn, 14) ^ kn >>> 3) + ps | 0) | 0, fi = ((Nr(Bs, 25) ^ Nr(Bs, 14) ^ Bs >>> 3) + Xi | 0) + bi | 0, $s = ((Nr(ks, 25) ^ Nr(ks, 14) ^ ks >>> 3) + gs | 0) + pi | 0, Xs = ((Nr(Hi, 25) ^ Nr(Hi, 14) ^ Hi >>> 3) + Be | 0) + zs | 0, Ao = ((Nr(ai, 25) ^ Nr(ai, 14) ^ ai >>> 3) + Zn | 0) + kn | 0, co = ((Nr(ni, 25) ^ Nr(ni, 14) ^ ni >>> 3) + Bi | 0) + Bs | 0, Zi = (((Nr(Oi, 25) ^ Nr(Oi, 14) ^ Oi >>> 3) + wi | 0) + ks | 0) + (Nr(Bn, 15) ^ Nr(Bn, 13) ^ Bn >>> 10) | 0, co = co + (Nr(Zi, 15) ^ Nr(Zi, 13) ^ Zi >>> 10) | 0, Ao = Ao + (Nr(co, 15) ^ Nr(co, 13) ^ co >>> 10) | 0, Xs = Xs + (Nr(Ao, 15) ^ Nr(Ao, 13) ^ Ao >>> 10) | 0, $s = $s + (Nr(Xs, 15) ^ Nr(Xs, 13) ^ Xs >>> 10) | 0, ds = fi + (Nr($s, 15) ^ Nr($s, 13) ^ $s >>> 10) | 0, bo = xr + (Nr(ds, 15) ^ Nr(ds, 13) ^ ds >>> 10) | 0, Is = t[v + 12 >> 2], Co = t[v + 28 >> 2], fi = t[v + 16 >> 2], xr = Co + (Nr(fi, 26) ^ Nr(fi, 21) ^ Nr(fi, 7)) | 0, Wi = t[v + 20 >> 2], Uo = t[v + 24 >> 2], ns = (Gs + (xr + ((Wi ^ Uo) & fi ^ Uo) | 0) | 0) + 1116352408 | 0, xr = ns + Is | 0, Gs = t[v + 4 >> 2], he = cr + Wi | 0, Ho = t[v + 8 >> 2], ji = (((Uo + (xr & (fi ^ Wi) ^ Wi) | 0) + tr | 0) + (Nr(xr, 26) ^ Nr(xr, 21) ^ Nr(xr, 7)) | 0) + 1899447441 | 0, cr = Ho + ji | 0, rs = ((he + (cr & (xr ^ fi) ^ fi) | 0) + (Nr(cr, 26) ^ Nr(cr, 21) ^ Nr(cr, 7)) | 0) - 1245643825 | 0, tr = Gs + rs | 0, he = dr + xr | 0, to = (((fi + ro | 0) + (tr & (cr ^ xr) ^ xr) | 0) + (Nr(tr, 26) ^ Nr(tr, 21) ^ Nr(tr, 7)) | 0) - 373957723 | 0, xr = t[v >> 2], dr = to + xr | 0, ro = ((he + (dr & (tr ^ cr) ^ cr) | 0) + (Nr(dr, 26) ^ Nr(dr, 21) ^ Nr(dr, 7)) | 0) + 961987163 | 0, he = cr + Mr | 0, cr = ((Ho & (xr | Gs) | xr & Gs) + (Nr(xr, 30) ^ Nr(xr, 19) ^ Nr(xr, 10)) | 0) + ns | 0, Mr = cr + ro | 0, ns = ((he + (Mr & (tr ^ dr) ^ tr) | 0) + (Nr(Mr, 26) ^ Nr(Mr, 21) ^ Nr(Mr, 7)) | 0) + 1508970993 | 0, he = tr + $r | 0, tr = (((cr | xr) & Gs | cr & xr) + (Nr(cr, 30) ^ Nr(cr, 19) ^ Nr(cr, 10)) | 0) + ji | 0, $r = tr + ns | 0, ji = ((he + ($r & (dr ^ Mr) ^ dr) | 0) + (Nr($r, 26) ^ Nr($r, 21) ^ Nr($r, 7)) | 0) - 1841331548 | 0, he = dr + gn | 0, dr = (((tr | cr) & xr | tr & cr) + (Nr(tr, 30) ^ Nr(tr, 19) ^ Nr(tr, 10)) | 0) + rs | 0, gn = dr + ji | 0, rs = ((he + (gn & (Mr ^ $r) ^ Mr) | 0) + (Nr(gn, 26) ^ Nr(gn, 21) ^ Nr(gn, 7)) | 0) - 1424204075 | 0, he = Mr + Ti | 0, cr = (((tr | dr) & cr | tr & dr) + (Nr(dr, 30) ^ Nr(dr, 19) ^ Nr(dr, 10)) | 0) + to | 0, Mr = cr + rs | 0, Ti = ((he + (Mr & ($r ^ gn) ^ $r) | 0) + (Nr(Mr, 26) ^ Nr(Mr, 21) ^ Nr(Mr, 7)) | 0) - 670586216 | 0, he = $r + ts | 0, tr = (((cr | dr) & tr | cr & dr) + (Nr(cr, 30) ^ Nr(cr, 19) ^ Nr(cr, 10)) | 0) + ro | 0, $r = tr + Ti | 0, ts = ((he + ($r & (Mr ^ gn) ^ gn) | 0) + (Nr($r, 26) ^ Nr($r, 21) ^ Nr($r, 7)) | 0) + 310598401 | 0, he = gn + hs | 0, dr = (((tr | cr) & dr | tr & cr) + (Nr(tr, 30) ^ Nr(tr, 19) ^ Nr(tr, 10)) | 0) + ns | 0, gn = dr + ts | 0, hs = ((he + (gn & (Mr ^ $r) ^ Mr) | 0) + (Nr(gn, 26) ^ Nr(gn, 21) ^ Nr(gn, 7)) | 0) + 607225278 | 0, he = Mr + ws | 0, cr = (((tr | dr) & cr | tr & dr) + (Nr(dr, 30) ^ Nr(dr, 19) ^ Nr(dr, 10)) | 0) + ji | 0, Mr = cr + hs | 0, ws = ((he + (Mr & ($r ^ gn) ^ $r) | 0) + (Nr(Mr, 26) ^ Nr(Mr, 21) ^ Nr(Mr, 7)) | 0) + 1426881987 | 0, he = $r + us | 0, tr = (((cr | dr) & tr | cr & dr) + (Nr(cr, 30) ^ Nr(cr, 19) ^ Nr(cr, 10)) | 0) + rs | 0, $r = tr + ws | 0, us = ((he + ($r & (Mr ^ gn) ^ gn) | 0) + (Nr($r, 26) ^ Nr($r, 21) ^ Nr($r, 7)) | 0) + 1925078388 | 0, he = gn + wo | 0, dr = (((tr | cr) & dr | tr & cr) + (Nr(tr, 30) ^ Nr(tr, 19) ^ Nr(tr, 10)) | 0) + Ti | 0, gn = dr + us | 0, Ti = ((he + (gn & (Mr ^ $r) ^ Mr) | 0) + (Nr(gn, 26) ^ Nr(gn, 21) ^ Nr(gn, 7)) | 0) - 2132889090 | 0, he = Mr + Gn | 0, cr = (((tr | dr) & cr | tr & dr) + (Nr(dr, 30) ^ Nr(dr, 19) ^ Nr(dr, 10)) | 0) + ts | 0, Gn = cr + Ti | 0, Mr = ((he + (Gn & ($r ^ gn) ^ $r) | 0) + (Nr(Gn, 26) ^ Nr(Gn, 21) ^ Nr(Gn, 7)) | 0) - 1680079193 | 0, he = $r + jn | 0, tr = (((cr | dr) & tr | cr & dr) + (Nr(cr, 30) ^ Nr(cr, 19) ^ Nr(cr, 10)) | 0) + hs | 0, jn = tr + Mr | 0, $r = ((he + (jn & (gn ^ Gn) ^ gn) | 0) + (Nr(jn, 26) ^ Nr(jn, 21) ^ Nr(jn, 7)) | 0) - 1046744716 | 0, he = E + gn | 0, E = (((tr | cr) & dr | tr & cr) + (Nr(tr, 30) ^ Nr(tr, 19) ^ Nr(tr, 10)) | 0) + ws | 0, dr = E + $r | 0, gn = ((he + (dr & (Gn ^ jn) ^ Gn) | 0) + (Nr(dr, 26) ^ Nr(dr, 21) ^ Nr(dr, 7)) | 0) - 459576895 | 0, he = T + Gn | 0, T = (((E | tr) & cr | E & tr) + (Nr(E, 30) ^ Nr(E, 19) ^ Nr(E, 10)) | 0) + us | 0, cr = T + gn | 0, Gn = ((he + (cr & (dr ^ jn) ^ jn) | 0) + (Nr(cr, 26) ^ Nr(cr, 21) ^ Nr(cr, 7)) | 0) - 272742522 | 0, he = gr + jn | 0, gr = (((E | T) & tr | E & T) + (Nr(T, 30) ^ Nr(T, 19) ^ Nr(T, 10)) | 0) + Ti | 0, tr = gr + Gn | 0, jn = ((he + (tr & (cr ^ dr) ^ dr) | 0) + (Nr(tr, 26) ^ Nr(tr, 21) ^ Nr(tr, 7)) | 0) + 264347078 | 0, he = Me + dr | 0, E = (((T | gr) & E | T & gr) + (Nr(gr, 30) ^ Nr(gr, 19) ^ Nr(gr, 10)) | 0) + Mr | 0, dr = E + jn | 0, Mr = ((he + (dr & (tr ^ cr) ^ cr) | 0) + (Nr(dr, 26) ^ Nr(dr, 21) ^ Nr(dr, 7)) | 0) + 604807628 | 0, he = cr + Ir | 0, T = (((E | gr) & T | E & gr) + (Nr(E, 30) ^ Nr(E, 19) ^ Nr(E, 10)) | 0) + $r | 0, Ir = T + Mr | 0, cr = ((he + (Ir & (tr ^ dr) ^ tr) | 0) + (Nr(Ir, 26) ^ Nr(Ir, 21) ^ Nr(Ir, 7)) | 0) + 770255983 | 0, he = tr + or | 0, Me = (((E | T) & gr | E & T) + (Nr(T, 30) ^ Nr(T, 19) ^ Nr(T, 10)) | 0) + gn | 0, or = Me + cr | 0, tr = ((he + (or & (dr ^ Ir) ^ dr) | 0) + (Nr(or, 26) ^ Nr(or, 21) ^ Nr(or, 7)) | 0) + 1249150122 | 0, E = (((T | Me) & E | T & Me) + (Nr(Me, 30) ^ Nr(Me, 19) ^ Nr(Me, 10)) | 0) + Gn | 0, gr = E + tr | 0, Wr = (((dr + Wr | 0) + (gr & (or ^ Ir) ^ Ir) | 0) + (Nr(gr, 26) ^ Nr(gr, 21) ^ Nr(gr, 7)) | 0) + 1555081692 | 0, he = n + Ir | 0, n = (((E | Me) & T | E & Me) + (Nr(E, 30) ^ Nr(E, 19) ^ Nr(E, 10)) | 0) + jn | 0, T = n + Wr | 0, Ir = ((he + (T & (or ^ gr) ^ or) | 0) + (Nr(T, 26) ^ Nr(T, 21) ^ Nr(T, 7)) | 0) + 1996064986 | 0, he = a + or | 0, a = (((n | E) & Me | n & E) + (Nr(n, 30) ^ Nr(n, 19) ^ Nr(n, 10)) | 0) + Mr | 0, Me = a + Ir | 0, dr = ((he + (Me & (T ^ gr) ^ gr) | 0) + (Nr(Me, 26) ^ Nr(Me, 21) ^ Nr(Me, 7)) | 0) - 1740746414 | 0, E = (((n | a) & E | n & a) + (Nr(a, 30) ^ Nr(a, 19) ^ Nr(a, 10)) | 0) + cr | 0, or = E + dr | 0, gr = (((gr + xn | 0) + (or & (T ^ Me) ^ T) | 0) + (Nr(or, 26) ^ Nr(or, 21) ^ Nr(or, 7)) | 0) - 1473132947 | 0, he = T + Ai | 0, n = (((a | E) & n | a & E) + (Nr(E, 30) ^ Nr(E, 19) ^ Nr(E, 10)) | 0) + tr | 0, T = n + gr | 0, xn = ((he + (T & (Me ^ or) ^ Me) | 0) + (Nr(T, 26) ^ Nr(T, 21) ^ Nr(T, 7)) | 0) - 1341970488 | 0, he = Me + Un | 0, a = (((n | E) & a | n & E) + (Nr(n, 30) ^ Nr(n, 19) ^ Nr(n, 10)) | 0) + Wr | 0, Me = a + xn | 0, Wr = ((he + (Me & (T ^ or) ^ or) | 0) + (Nr(Me, 26) ^ Nr(Me, 21) ^ Nr(Me, 7)) | 0) - 1084653625 | 0, he = or + Ii | 0, E = (((n | a) & E | n & a) + (Nr(a, 30) ^ Nr(a, 19) ^ Nr(a, 10)) | 0) + Ir | 0, or = E + Wr | 0, Ir = ((he + (or & (T ^ Me) ^ T) | 0) + (Nr(or, 26) ^ Nr(or, 21) ^ Nr(or, 7)) | 0) - 958395405 | 0, he = T + Xn | 0, n = (((a | E) & n | a & E) + (Nr(E, 30) ^ Nr(E, 19) ^ Nr(E, 10)) | 0) + dr | 0, T = n + Ir | 0, Un = ((he + (T & (Me ^ or) ^ Me) | 0) + (Nr(T, 26) ^ Nr(T, 21) ^ Nr(T, 7)) | 0) - 710438585 | 0, he = Me + yi | 0, a = (((n | E) & a | n & E) + (Nr(n, 30) ^ Nr(n, 19) ^ Nr(n, 10)) | 0) + gr | 0, Me = a + Un | 0, gr = ((he + (Me & (T ^ or) ^ or) | 0) + (Nr(Me, 26) ^ Nr(Me, 21) ^ Nr(Me, 7)) | 0) + 113926993 | 0, he = L + or | 0, L = (((n | a) & E | n & a) + (Nr(a, 30) ^ Nr(a, 19) ^ Nr(a, 10)) | 0) + xn | 0, E = L + gr | 0, or = ((he + (E & (T ^ Me) ^ T) | 0) + (Nr(E, 26) ^ Nr(E, 21) ^ Nr(E, 7)) | 0) + 338241895 | 0, he = T + wi | 0, n = (((a | L) & n | a & L) + (Nr(L, 30) ^ Nr(L, 19) ^ Nr(L, 10)) | 0) + Wr | 0, T = n + or | 0, Wr = ((he + (T & (E ^ Me) ^ Me) | 0) + (Nr(T, 26) ^ Nr(T, 21) ^ Nr(T, 7)) | 0) + 666307205 | 0, he = Me + Oi | 0, a = (((n | L) & a | n & L) + (Nr(n, 30) ^ Nr(n, 19) ^ Nr(n, 10)) | 0) + Ir | 0, Me = a + Wr | 0, Ir = ((he + (Me & (E ^ T) ^ E) | 0) + (Nr(Me, 26) ^ Nr(Me, 21) ^ Nr(Me, 7)) | 0) + 773529912 | 0, he = E + Bi | 0, L = (((n | a) & L | n & a) + (Nr(a, 30) ^ Nr(a, 19) ^ Nr(a, 10)) | 0) + Un | 0, E = L + Ir | 0, xn = ((he + (E & (T ^ Me) ^ T) | 0) + (Nr(E, 26) ^ Nr(E, 21) ^ Nr(E, 7)) | 0) + 1294757372 | 0, he = T + ni | 0, n = (((a | L) & n | a & L) + (Nr(L, 30) ^ Nr(L, 19) ^ Nr(L, 10)) | 0) + gr | 0, T = n + xn | 0, gr = ((he + (T & (E ^ Me) ^ Me) | 0) + (Nr(T, 26) ^ Nr(T, 21) ^ Nr(T, 7)) | 0) + 1396182291 | 0, he = Me + Zn | 0, a = (((n | L) & a | n & L) + (Nr(n, 30) ^ Nr(n, 19) ^ Nr(n, 10)) | 0) + or | 0, Me = a + gr | 0, or = ((he + (Me & (E ^ T) ^ E) | 0) + (Nr(Me, 26) ^ Nr(Me, 21) ^ Nr(Me, 7)) | 0) + 1695183700 | 0, he = E + ai | 0, L = (((n | a) & L | n & a) + (Nr(a, 30) ^ Nr(a, 19) ^ Nr(a, 10)) | 0) + Wr | 0, E = L + or | 0, Wr = ((he + (E & (T ^ Me) ^ T) | 0) + (Nr(E, 26) ^ Nr(E, 21) ^ Nr(E, 7)) | 0) + 1986661051 | 0, he = T + Be | 0, n = (((a | L) & n | a & L) + (Nr(L, 30) ^ Nr(L, 19) ^ Nr(L, 10)) | 0) + Ir | 0, Be = n + Wr | 0, Ir = ((he + (Be & (E ^ Me) ^ Me) | 0) + (Nr(Be, 26) ^ Nr(Be, 21) ^ Nr(Be, 7)) | 0) - 2117940946 | 0, a = (((n | L) & a | n & L) + (Nr(n, 30) ^ Nr(n, 19) ^ Nr(n, 10)) | 0) + xn | 0, T = a + Ir | 0, Me = (((Me + Hi | 0) + (T & (E ^ Be) ^ E) | 0) + (Nr(T, 26) ^ Nr(T, 21) ^ Nr(T, 7)) | 0) - 1838011259 | 0, he = E + gs | 0, L = (((n | a) & L | n & a) + (Nr(a, 30) ^ Nr(a, 19) ^ Nr(a, 10)) | 0) + gr | 0, E = L + Me | 0, gr = ((he + (E & (T ^ Be) ^ Be) | 0) + (Nr(E, 26) ^ Nr(E, 21) ^ Nr(E, 7)) | 0) - 1564481375 | 0, he = Be + ks | 0, n = (((a | L) & n | a & L) + (Nr(L, 30) ^ Nr(L, 19) ^ Nr(L, 10)) | 0) + or | 0, Be = n + gr | 0, or = ((he + (Be & (E ^ T) ^ T) | 0) + (Nr(Be, 26) ^ Nr(Be, 21) ^ Nr(Be, 7)) | 0) - 1474664885 | 0, he = T + Xi | 0, a = (((n | L) & a | n & L) + (Nr(n, 30) ^ Nr(n, 19) ^ Nr(n, 10)) | 0) + Wr | 0, T = a + or | 0, Wr = ((he + (T & (E ^ Be) ^ E) | 0) + (Nr(T, 26) ^ Nr(T, 21) ^ Nr(T, 7)) | 0) - 1035236496 | 0, he = E + Bs | 0, L = (((n | a) & L | n & a) + (Nr(a, 30) ^ Nr(a, 19) ^ Nr(a, 10)) | 0) + Ir | 0, E = L + Wr | 0, Ir = ((he + (E & (T ^ Be) ^ Be) | 0) + (Nr(E, 26) ^ Nr(E, 21) ^ Nr(E, 7)) | 0) - 949202525 | 0, he = Be + ps | 0, n = (((a | L) & n | a & L) + (Nr(L, 30) ^ Nr(L, 19) ^ Nr(L, 10)) | 0) + Me | 0, Be = n + Ir | 0, Me = ((he + (Be & (E ^ T) ^ T) | 0) + (Nr(Be, 26) ^ Nr(Be, 21) ^ Nr(Be, 7)) | 0) - 778901479 | 0, he = T + kn | 0, a = (((n | L) & a | n & L) + (Nr(n, 30) ^ Nr(n, 19) ^ Nr(n, 10)) | 0) + gr | 0, T = a + Me | 0, gr = ((he + (T & (E ^ Be) ^ E) | 0) + (Nr(T, 26) ^ Nr(T, 21) ^ Nr(T, 7)) | 0) - 694614492 | 0, he = E + Bn | 0, L = (((n | a) & L | n & a) + (Nr(a, 30) ^ Nr(a, 19) ^ Nr(a, 10)) | 0) + or | 0, E = L + gr | 0, or = ((he + (E & (T ^ Be) ^ Be) | 0) + (Nr(E, 26) ^ Nr(E, 21) ^ Nr(E, 7)) | 0) - 200395387 | 0, he = Be + zs | 0, n = (((a | L) & n | a & L) + (Nr(L, 30) ^ Nr(L, 19) ^ Nr(L, 10)) | 0) + Wr | 0, Be = n + or | 0, Wr = ((he + (Be & (E ^ T) ^ T) | 0) + (Nr(Be, 26) ^ Nr(Be, 21) ^ Nr(Be, 7)) | 0) + 275423344 | 0, he = T + Zi | 0, a = (((n | L) & a | n & L) + (Nr(n, 30) ^ Nr(n, 19) ^ Nr(n, 10)) | 0) + Ir | 0, T = a + Wr | 0, Ir = ((he + (T & (E ^ Be) ^ E) | 0) + (Nr(T, 26) ^ Nr(T, 21) ^ Nr(T, 7)) | 0) + 430227734 | 0, he = E + pi | 0, L = (((n | a) & L | n & a) + (Nr(a, 30) ^ Nr(a, 19) ^ Nr(a, 10)) | 0) + Me | 0, E = L + Ir | 0, Me = ((he + (E & (T ^ Be) ^ Be) | 0) + (Nr(E, 26) ^ Nr(E, 21) ^ Nr(E, 7)) | 0) + 506948616 | 0, he = Be + co | 0, n = (((a | L) & n | a & L) + (Nr(L, 30) ^ Nr(L, 19) ^ Nr(L, 10)) | 0) + gr | 0, Be = n + Me | 0, xn = ((he + (Be & (E ^ T) ^ T) | 0) + (Nr(Be, 26) ^ Nr(Be, 21) ^ Nr(Be, 7)) | 0) + 659060556 | 0, he = T + bi | 0, a = (((n | L) & a | n & L) + (Nr(n, 30) ^ Nr(n, 19) ^ Nr(n, 10)) | 0) + or | 0, T = a + xn | 0, or = ((he + (T & (E ^ Be) ^ E) | 0) + (Nr(T, 26) ^ Nr(T, 21) ^ Nr(T, 7)) | 0) + 883997877 | 0, he = E + Ao | 0, L = (((n | a) & L | n & a) + (Nr(a, 30) ^ Nr(a, 19) ^ Nr(a, 10)) | 0) + Wr | 0, E = L + or | 0, Wr = ((he + (E & (T ^ Be) ^ Be) | 0) + (Nr(E, 26) ^ Nr(E, 21) ^ Nr(E, 7)) | 0) + 958139571 | 0, he = Be + Ni | 0, n = (((a | L) & n | a & L) + (Nr(L, 30) ^ Nr(L, 19) ^ Nr(L, 10)) | 0) + Ir | 0, Be = n + Wr | 0, Un = ((he + (Be & (E ^ T) ^ T) | 0) + (Nr(Be, 26) ^ Nr(Be, 21) ^ Nr(Be, 7)) | 0) + 1322822218 | 0, he = T + Xs | 0, a = (((n | L) & a | n & L) + (Nr(n, 30) ^ Nr(n, 19) ^ Nr(n, 10)) | 0) + Me | 0, T = a + Un | 0, Xn = ((he + (T & (E ^ Be) ^ E) | 0) + (Nr(T, 26) ^ Nr(T, 21) ^ Nr(T, 7)) | 0) + 1537002063 | 0, gr = (((Nr(gs, 25) ^ Nr(gs, 14) ^ gs >>> 3) + Hi | 0) + Zi | 0) + (Nr(Ni, 15) ^ Nr(Ni, 13) ^ Ni >>> 10) | 0, he = gr + E | 0, L = (((n | a) & L | n & a) + (Nr(a, 30) ^ Nr(a, 19) ^ Nr(a, 10)) | 0) + xn | 0, E = L + Xn | 0, xn = ((he + (E & (T ^ Be) ^ Be) | 0) + (Nr(E, 26) ^ Nr(E, 21) ^ Nr(E, 7)) | 0) + 1747873779 | 0, he = Be + $s | 0, n = (((a | L) & n | a & L) + (Nr(L, 30) ^ Nr(L, 19) ^ Nr(L, 10)) | 0) + or | 0, Be = n + xn | 0, or = ((he + (Be & (E ^ T) ^ T) | 0) + (Nr(Be, 26) ^ Nr(Be, 21) ^ Nr(Be, 7)) | 0) + 1955562222 | 0, Ir = ((Nr(ps, 25) ^ Nr(ps, 14) ^ ps >>> 3) + Bs | 0) + Ao | 0, Me = (((Nr(Xi, 25) ^ Nr(Xi, 14) ^ Xi >>> 3) + ks | 0) + co | 0) + (Nr(gr, 15) ^ Nr(gr, 13) ^ gr >>> 10) | 0, Ir = Ir + (Nr(Me, 15) ^ Nr(Me, 13) ^ Me >>> 10) | 0, he = T + Me | 0, a = (((n | L) & a | n & L) + (Nr(n, 30) ^ Nr(n, 19) ^ Nr(n, 10)) | 0) + Wr | 0, T = a + or | 0, Wr = ((he + (T & (E ^ Be) ^ E) | 0) + (Nr(T, 26) ^ Nr(T, 21) ^ Nr(T, 7)) | 0) + 2024104815 | 0, he = E + ds | 0, L = (((n | a) & L | n & a) + (Nr(a, 30) ^ Nr(a, 19) ^ Nr(a, 10)) | 0) + Un | 0, E = L + Wr | 0, Un = ((he + (E & (T ^ Be) ^ Be) | 0) + (Nr(E, 26) ^ Nr(E, 21) ^ Nr(E, 7)) | 0) - 2067236844 | 0, n = (((a | L) & n | a & L) + (Nr(L, 30) ^ Nr(L, 19) ^ Nr(L, 10)) | 0) + Xn | 0, Me = n + Un | 0, Xn = (((Be + Ir | 0) + (Me & (E ^ T) ^ T) | 0) + (Nr(Me, 26) ^ Nr(Me, 21) ^ Nr(Me, 7)) | 0) - 1933114872 | 0, he = T + bo | 0, a = (((n | L) & a | n & L) + (Nr(n, 30) ^ Nr(n, 19) ^ Nr(n, 10)) | 0) + xn | 0, T = a + Xn | 0, xn = ((he + (T & (E ^ Me) ^ E) | 0) + (Nr(T, 26) ^ Nr(T, 21) ^ Nr(T, 7)) | 0) - 1866530822 | 0, L = (((n | a) & L | n & a) + (Nr(a, 30) ^ Nr(a, 19) ^ Nr(a, 10)) | 0) + or | 0, or = xn + L | 0, t[v + 28 >> 2] = or + Co, Be = (((a | L) & n | a & L) + (Nr(L, 30) ^ Nr(L, 19) ^ Nr(L, 10)) | 0) + Wr | 0, n = ((a & (Be | L) | L & Be) + (Nr(Be, 30) ^ Nr(Be, 19) ^ Nr(Be, 10)) | 0) + Un | 0, a = (((n | Be) & L | n & Be) + (Nr(n, 30) ^ Nr(n, 19) ^ Nr(n, 10)) | 0) + Xn | 0, L = (((a | n) & Be | n & a) + (Nr(a, 30) ^ Nr(a, 19) ^ Nr(a, 10)) | 0) + xn | 0, t[v + 12 >> 2] = L + Is, to = Be, he = E, E = (((Nr(Bn, 25) ^ Nr(Bn, 14) ^ Bn >>> 3) + kn | 0) + Xs | 0) + (Nr(Ir, 15) ^ Nr(Ir, 13) ^ Ir >>> 10) | 0, Be = (((he + E | 0) + (or & (T ^ Me) ^ Me) | 0) + (Nr(or, 26) ^ Nr(or, 21) ^ Nr(or, 7)) | 0) - 1538233109 | 0, kn = to + Be | 0, t[v + 24 >> 2] = kn + Uo, Be = (((a | L) & n | a & L) + (Nr(L, 30) ^ Nr(L, 19) ^ Nr(L, 10)) | 0) + Be | 0, t[v + 8 >> 2] = Be + Ho, he = n, n = ((((((Bn + (Nr(zs, 25) ^ Nr(zs, 14) ^ zs >>> 3) | 0) + gr | 0) + (Nr(bo, 15) ^ Nr(bo, 13) ^ bo >>> 10) | 0) + Me | 0) + (kn & (T ^ or) ^ T) | 0) + (Nr(kn, 26) ^ Nr(kn, 21) ^ Nr(kn, 7)) | 0) - 1090935817 | 0, Bn = he + n | 0, t[v + 20 >> 2] = Bn + Wi, n = (((L | Be) & a | L & Be) + (Nr(Be, 30) ^ Nr(Be, 19) ^ Nr(Be, 10)) | 0) + n | 0, t[v + 4 >> 2] = n + Gs, he = a + fi | 0, a = ((((((zs + (Nr(Zi, 25) ^ Nr(Zi, 14) ^ Zi >>> 3) | 0) + $s | 0) + (Nr(E, 15) ^ Nr(E, 13) ^ E >>> 10) | 0) + T | 0) + (Bn & (or ^ kn) ^ or) | 0) + (Nr(Bn, 26) ^ Nr(Bn, 21) ^ Nr(Bn, 7)) | 0) - 965641998 | 0, t[v + 16 >> 2] = he + a, vo = v, js = ((xr + ((n | Be) & L | n & Be) | 0) + (Nr(n, 30) ^ Nr(n, 19) ^ Nr(n, 10)) | 0) + a | 0, t[vo >> 2] = js, d = d + fo | 0, I = I - fo | 0, fo = 64, n = 0, I >>> 0 > 63; )
        ;
    I && $i((v + n | 0) + 32 | 0, d, I);
  }
  function Yn(v, d) {
    var I = 0, n = 0, a = 0;
    n = x - 16 | 0, x = n, I = t[v + 100 >> 2], a = t[v + 96 >> 2], u[n + 11 | 0] = (I & 536870911) << 3 | a >>> 29, u[n + 10 | 0] = I >>> 5, u[n + 9 | 0] = I >>> 13, u[n + 8 | 0] = I >>> 21, u[n + 15 | 0] = a << 3, u[n + 14 | 0] = a >>> 5, u[n + 13 | 0] = a >>> 13, u[n + 12 | 0] = a >>> 21, Tn(v, 690512, (55 - a & 63) + 1 | 0), Tn(v, n + 8 | 0, 8), I = t[v >> 2], I = I << 8 & 16711680 | I << 24 | (I >>> 8 & 65280 | I >>> 24), u[d | 0] = I, u[d + 1 | 0] = I >>> 8, u[d + 2 | 0] = I >>> 16, u[d + 3 | 0] = I >>> 24, t[v >> 2] = 0, I = t[v + 4 >> 2], I = I << 8 & 16711680 | I << 24 | (I >>> 8 & 65280 | I >>> 24), u[d + 4 | 0] = I, u[d + 5 | 0] = I >>> 8, u[d + 6 | 0] = I >>> 16, u[d + 7 | 0] = I >>> 24, t[v + 4 >> 2] = 0, I = t[v + 8 >> 2], I = I << 8 & 16711680 | I << 24 | (I >>> 8 & 65280 | I >>> 24), u[d + 8 | 0] = I, u[d + 9 | 0] = I >>> 8, u[d + 10 | 0] = I >>> 16, u[d + 11 | 0] = I >>> 24, t[v + 8 >> 2] = 0, I = t[v + 12 >> 2], I = I << 8 & 16711680 | I << 24 | (I >>> 8 & 65280 | I >>> 24), u[d + 12 | 0] = I, u[d + 13 | 0] = I >>> 8, u[d + 14 | 0] = I >>> 16, u[d + 15 | 0] = I >>> 24, t[v + 12 >> 2] = 0, I = t[v + 16 >> 2], I = I << 8 & 16711680 | I << 24 | (I >>> 8 & 65280 | I >>> 24), u[d + 16 | 0] = I, u[d + 17 | 0] = I >>> 8, u[d + 18 | 0] = I >>> 16, u[d + 19 | 0] = I >>> 24, t[v + 16 >> 2] = 0, I = t[v + 20 >> 2], I = I << 8 & 16711680 | I << 24 | (I >>> 8 & 65280 | I >>> 24), u[d + 20 | 0] = I, u[d + 21 | 0] = I >>> 8, u[d + 22 | 0] = I >>> 16, u[d + 23 | 0] = I >>> 24, t[v + 20 >> 2] = 0, I = t[v + 24 >> 2], I = I << 8 & 16711680 | I << 24 | (I >>> 8 & 65280 | I >>> 24), u[d + 24 | 0] = I, u[d + 25 | 0] = I >>> 8, u[d + 26 | 0] = I >>> 16, u[d + 27 | 0] = I >>> 24, t[v + 24 >> 2] = 0, I = t[v + 28 >> 2], I = I << 8 & 16711680 | I << 24 | (I >>> 8 & 65280 | I >>> 24), u[d + 28 | 0] = I, u[d + 29 | 0] = I >>> 8, u[d + 30 | 0] = I >>> 16, u[d + 31 | 0] = I >>> 24, t[v + 28 >> 2] = 0, x = n + 16 | 0;
  }
  function si(v, d, I, n) {
    var a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0, Xn = 0, Zn = 0, ni = 0, ai = 0, fi = 0, Ai = 0, yi = 0, Ii = 0, wi = 0, Bi = 0, Ti = 0, Oi = 0, Hi = 0, Xi = 0, Zi = 0, ts = 0, us = 0, hs = 0, ws = 0, ks = 0, Bs = 0, gs = 0, ps = 0;
    T = x - 880 | 0, x = T;
    e: {
      if (!d) {
        Qn[t[v + 168 >> 2]](689638, t[v + 172 >> 2]), v = 0;
        break e;
      }
      if (u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, a = d + 56 | 0, u[a | 0] = 0, u[a + 1 | 0] = 0, u[a + 2 | 0] = 0, u[a + 3 | 0] = 0, u[a + 4 | 0] = 0, u[a + 5 | 0] = 0, u[a + 6 | 0] = 0, u[a + 7 | 0] = 0, a = d + 48 | 0, u[a | 0] = 0, u[a + 1 | 0] = 0, u[a + 2 | 0] = 0, u[a + 3 | 0] = 0, u[a + 4 | 0] = 0, u[a + 5 | 0] = 0, u[a + 6 | 0] = 0, u[a + 7 | 0] = 0, a = d + 40 | 0, u[a | 0] = 0, u[a + 1 | 0] = 0, u[a + 2 | 0] = 0, u[a + 3 | 0] = 0, u[a + 4 | 0] = 0, u[a + 5 | 0] = 0, u[a + 6 | 0] = 0, u[a + 7 | 0] = 0, a = d + 32 | 0, u[a | 0] = 0, u[a + 1 | 0] = 0, u[a + 2 | 0] = 0, u[a + 3 | 0] = 0, u[a + 4 | 0] = 0, u[a + 5 | 0] = 0, u[a + 6 | 0] = 0, u[a + 7 | 0] = 0, a = d + 24 | 0, u[a | 0] = 0, u[a + 1 | 0] = 0, u[a + 2 | 0] = 0, u[a + 3 | 0] = 0, u[a + 4 | 0] = 0, u[a + 5 | 0] = 0, u[a + 6 | 0] = 0, u[a + 7 | 0] = 0, a = d + 16 | 0, u[a | 0] = 0, u[a + 1 | 0] = 0, u[a + 2 | 0] = 0, u[a + 3 | 0] = 0, u[a + 4 | 0] = 0, u[a + 5 | 0] = 0, u[a + 6 | 0] = 0, u[a + 7 | 0] = 0, a = d + 8 | 0, u[a | 0] = 0, u[a + 1 | 0] = 0, u[a + 2 | 0] = 0, u[a + 3 | 0] = 0, u[a + 4 | 0] = 0, u[a + 5 | 0] = 0, u[a + 6 | 0] = 0, u[a + 7 | 0] = 0, !I) {
        Qn[t[v + 168 >> 2]](689668, t[v + 172 >> 2]), v = 0;
        break e;
      }
      v = 0;
      t: {
        if ((n | 0) != 65) {
          if ((n | 0) != 33 || (l[I | 0] & 254) != 2)
            break e;
          if (!vn(T + 840 | 0, I + 1 | 0)) {
            n = 0;
            break t;
          }
          n = (Cn(T + 672 | 0, T + 840 | 0, l[I | 0] == 3) | 0) != 0;
          break t;
        }
        if (n = l[I | 0], n >>> 0 > 7 || !(1 << n & 208))
          break e;
        if (n = 0, !vn(T + 800 | 0, I + 1 | 0) || !vn(T + 760 | 0, I + 33 | 0) || (L = T + 800 | 0, E = L + 8 | 0, a = t[E + 4 >> 2], he = T + 672 | 0, n = he + 8 | 0, t[n >> 2] = t[E >> 2], t[n + 4 >> 2] = a, E = L + 16 | 0, a = t[E + 4 >> 2], n = he + 16 | 0, t[n >> 2] = t[E >> 2], t[n + 4 >> 2] = a, E = L + 24 | 0, a = t[E + 4 >> 2], n = he + 24 | 0, t[n >> 2] = t[E >> 2], t[n + 4 >> 2] = a, E = L + 32 | 0, a = t[E + 4 >> 2], n = he + 32 | 0, t[n >> 2] = t[E >> 2], t[n + 4 >> 2] = a, E = T + 760 | 0, a = E + 8 | 0, n = t[a + 4 >> 2], Wr = T + 720 | 0, t[Wr >> 2] = t[a >> 2], t[Wr + 4 >> 2] = n, a = E + 16 | 0, n = t[a + 4 >> 2], dr = T + 728 | 0, t[dr >> 2] = t[a >> 2], t[dr + 4 >> 2] = n, a = E + 24 | 0, n = t[a + 4 >> 2], L = T + 736 | 0, t[L >> 2] = t[a >> 2], t[L + 4 >> 2] = n, a = E + 32 | 0, n = t[a + 4 >> 2], kn = T + 744 | 0, t[kn >> 2] = t[a >> 2], t[kn + 4 >> 2] = n, t[T + 752 >> 2] = 0, n = t[T + 804 >> 2], t[T + 672 >> 2] = t[T + 800 >> 2], t[T + 676 >> 2] = n, n = t[T + 764 >> 2], t[T + 712 >> 2] = t[T + 760 >> 2], t[T + 716 >> 2] = n, I = l[I | 0], (I & 254) == 6 && (n = 0, (u[T + 760 | 0] & 1) == ((I | 0) != 7 | 0))))
          break t;
        I = t[T + 716 >> 2], Xn = I, Be = t[T + 712 >> 2], n = Be, I = I << 1 | n >>> 31, gr = T + 96 | 0, Me = t[L >> 2], tr = t[L + 4 >> 2], xn = n << 1, ni = I, Ur(gr, Me, tr, 0, 0, xn, I, 0, 0), I = t[Wr + 4 >> 2], Un = I, Gn = t[Wr >> 2], a = Gn, I = I << 1 | a >>> 31, or = T + 160 | 0, cr = t[dr >> 2], dr = t[dr + 4 >> 2], a = a << 1, E = I, Ur(or, cr, dr, 0, 0, a, I, 0, 0), Wr = T + 288 | 0, n = t[kn >> 2], I = t[kn + 4 >> 2], Ur(Wr, n, I, 0, 0, n, I, 0, 0), L = T + 272 | 0, Ur(L, t[T + 288 >> 2], t[T + 292 >> 2], 0, 0, 15632, 16, 0, 0), I = I << 1 | n >>> 31, Ai = T + 128 | 0, xr = n << 1, kn = I, Ur(Ai, xr, I, 0, 0, Be, Xn, 0, 0), yi = T + 144 | 0, Ur(yi, Me, tr, 0, 0, a, E, 0, 0), Ii = T + 224 | 0, Ur(Ii, cr, dr, 0, 0, cr, dr, 0, 0), Ir = T + 256 | 0, I = Wr + 8 | 0, Ur(Ir, t[I >> 2], t[I + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), ts = T + 112 | 0, Ur(ts, Be, Xn, 0, 0, Be, Xn, 0, 0), ai = T + 192 | 0, Ur(ai, xr, kn, 0, 0, Gn, Un, 0, 0), Ti = T + 240 | 0, Ur(Ti, Me, tr, 0, 0, cr << 1, dr << 1 | cr >>> 31, 0, 0), Xn = t[T + 100 >> 2], I = Xn + t[T + 164 >> 2] | 0, he = t[T + 96 >> 2], n = t[T + 160 >> 2], E = he + n | 0, a = t[T + 272 >> 2], Oi = E + a | 0, n = n >>> 0 > E >>> 0 ? I + 1 | 0 : I, I = n + t[T + 276 >> 2] | 0, a = a >>> 0 > Oi >>> 0 ? I + 1 | 0 : I, Be = (n | 0) == (a | 0) & E >>> 0 > Oi >>> 0 | n >>> 0 > a >>> 0, I = L + 8 | 0, Wr = t[I >> 2], L = t[I + 4 >> 2], he = (n | 0) == (Xn | 0) & E >>> 0 < he >>> 0 | n >>> 0 < Xn >>> 0, E = or + 8 | 0, n = t[E >> 2], I = gr + 8 | 0, or = n + t[I >> 2] | 0, I = t[I + 4 >> 2] + t[E + 4 >> 2] | 0, I = n >>> 0 > or >>> 0 ? I + 1 | 0 : I, n = he + or | 0, I = (n >>> 0 < or >>> 0 ? I + 1 | 0 : I) + L | 0, E = n, n = n + Wr | 0, I = E >>> 0 > n >>> 0 ? I + 1 | 0 : I, E = n, n = n + Be | 0, I = E >>> 0 > n >>> 0 ? I + 1 | 0 : I, Hi = a, Wr = n << 12 | a >>> 20, E = I, he = I << 12 | n >>> 20, gn = t[T + 144 >> 2], n = t[T + 224 >> 2], or = gn + n | 0, fi = t[T + 148 >> 2], I = fi + t[T + 228 >> 2] | 0, I = n >>> 0 > or >>> 0 ? I + 1 | 0 : I, n = t[T + 128 >> 2], Be = n + or | 0, gr = I, I = I + t[T + 132 >> 2] | 0, I = n >>> 0 > Be >>> 0 ? I + 1 | 0 : I, n = t[T + 256 >> 2], L = n + Be | 0, a = I, I = I + t[T + 260 >> 2] | 0, n = n >>> 0 > L >>> 0 ? I + 1 | 0 : I, I = n + he | 0, us = T + 32 | 0, Zn = us, Wr = L + Wr | 0, he = Wr >>> 0 < L >>> 0 ? I + 1 | 0 : I, jn = (n | 0) == (he | 0) & L >>> 0 > Wr >>> 0 | n >>> 0 > he >>> 0, Bn = (n | 0) == (a | 0) & L >>> 0 < Be >>> 0 | n >>> 0 < a >>> 0, I = Ir + 8 | 0, Mr = t[I >> 2], $r = t[I + 4 >> 2], Xn = (a | 0) == (gr | 0) & Be >>> 0 < or >>> 0 | a >>> 0 < gr >>> 0, I = Ai + 8 | 0, Ir = t[I >> 2], Be = t[I + 4 >> 2], L = (gr | 0) == (fi | 0) & or >>> 0 < gn >>> 0 | gr >>> 0 < fi >>> 0, a = Ii + 8 | 0, n = t[a >> 2], I = yi + 8 | 0, or = n + t[I >> 2] | 0, I = t[I + 4 >> 2] + t[a + 4 >> 2] | 0, I = n >>> 0 > or >>> 0 ? I + 1 | 0 : I, n = L + or | 0, I = (n >>> 0 < or >>> 0 ? I + 1 | 0 : I) + Be | 0, a = n, n = n + Ir | 0, I = a >>> 0 > n >>> 0 ? I + 1 | 0 : I, a = n, n = n + Xn | 0, I = (a >>> 0 > n >>> 0 ? I + 1 | 0 : I) + $r | 0, a = n, n = n + Mr | 0, I = a >>> 0 > n >>> 0 ? I + 1 | 0 : I, a = n + Bn | 0, I = a >>> 0 < n >>> 0 ? I + 1 | 0 : I, E = E >>> 20 | 0, n = a + E | 0, I = E >>> 0 > n >>> 0 ? I + 1 | 0 : I, E = n, n = n + jn | 0, I = E >>> 0 > n >>> 0 ? I + 1 | 0 : I, a = he, L = n << 12 | a >>> 20, E = I, he = I << 12 | n >>> 20, Mr = t[T + 192 >> 2], n = t[T + 240 >> 2], Be = Mr + n | 0, Bn = t[T + 196 >> 2], I = Bn + t[T + 244 >> 2] | 0, n = n >>> 0 > Be >>> 0 ? I + 1 | 0 : I, I = n + he | 0, L = L + Be | 0, I = L >>> 0 < Be >>> 0 ? I + 1 | 0 : I, gr = L << 4 & -16, he = I, or = (I << 4 | L >>> 28) & 16777215, Xn = a, Ur(Zn, gr | a >>> 16 & 15, or, 0, 0, 977, 1, 0, 0), hs = T + 16 | 0, Ur(hs, Gn, Un, 0, 0, xn, ni, 0, 0), $r = T + 208 | 0, Ur($r, xr, kn, 0, 0, cr, dr, 0, 0), Ir = T + 320 | 0, Ur(Ir, Me, tr, 0, 0, Me, tr, 0, 0), ws = T + 80 | 0, gr = ws, or = (n | 0) == (I | 0) & L >>> 0 < Be >>> 0 | n >>> 0 > I >>> 0, L = (n | 0) == (Bn | 0) & Be >>> 0 < Mr >>> 0 | n >>> 0 < Bn >>> 0, a = Ti + 8 | 0, n = t[a >> 2], I = ai + 8 | 0, Be = n + t[I >> 2] | 0, I = t[I + 4 >> 2] + t[a + 4 >> 2] | 0, I = n >>> 0 > Be >>> 0 ? I + 1 | 0 : I, a = L + Be | 0, I = a >>> 0 < Be >>> 0 ? I + 1 | 0 : I, E = E >>> 20 | 0, n = a + E | 0, I = E >>> 0 > n >>> 0 ? I + 1 | 0 : I, E = n, n = n + or | 0, I = E >>> 0 > n >>> 0 ? I + 1 | 0 : I, he = n << 12 | he >>> 20, a = I, Be = I << 12 | n >>> 20, Mr = t[T + 212 >> 2], I = Mr + t[T + 324 >> 2] | 0, or = t[T + 208 >> 2], n = t[T + 320 >> 2], E = or + n | 0, L = E, he = E + he | 0, n = n >>> 0 > E >>> 0 ? I + 1 | 0 : I, I = n + Be | 0, E = E >>> 0 > he >>> 0 ? I + 1 | 0 : I, Ur(gr, he, E & 1048575, 0, 0, 15632, 16, 0, 0), Ur(T, cr, dr, 0, 0, xn, ni, 0, 0), ks = T + 176 | 0, Ur(ks, Gn, Un, 0, 0, Gn, Un, 0, 0), Be = T + 304 | 0, Ur(Be, xr, kn, 0, 0, Me, tr, 0, 0), Bs = T - -64 | 0, tr = Bs, dr = (n | 0) == (E | 0) & L >>> 0 > he >>> 0 | n >>> 0 > E >>> 0, L = (n | 0) == (Mr | 0) & L >>> 0 < or >>> 0 | n >>> 0 < Mr >>> 0, he = Ir + 8 | 0, n = t[he >> 2], I = $r + 8 | 0, Me = n + t[I >> 2] | 0, I = t[I + 4 >> 2] + t[he + 4 >> 2] | 0, I = n >>> 0 > Me >>> 0 ? I + 1 | 0 : I, he = L + Me | 0, I = he >>> 0 < Me >>> 0 ? I + 1 | 0 : I, a = a >>> 20 | 0, n = a + he | 0, I = a >>> 0 > n >>> 0 ? I + 1 | 0 : I, a = n, n = n + dr | 0, I = a >>> 0 > n >>> 0 ? I + 1 | 0 : I, he = n << 12 | E >>> 20, E = t[T + 304 >> 2], dr = he + E | 0, a = I, n = I << 12 | n >>> 20, I = n + t[T + 308 >> 2] | 0, I = E >>> 0 > dr >>> 0 ? I + 1 | 0 : I, Ur(tr, dr, I, 0, 0, 15632, 16, 0, 0), gs = T + 48 | 0, L = gs, he = (I | 0) == (n | 0) & he >>> 0 > dr >>> 0 | I >>> 0 < n >>> 0, I = Be + 8 | 0, E = t[I >> 2], I = t[I + 4 >> 2], a = a >>> 20 | 0, n = a + E | 0, I = a >>> 0 > n >>> 0 ? I + 1 | 0 : I, E = n, n = n + he | 0, I = E >>> 0 > n >>> 0 ? I + 1 | 0 : I, Ur(L, n, I, 0, 0, 64028672, 65536, 0, 0), I = t[T + 676 >> 2], cr = I, tr = t[T + 672 >> 2], n = tr, I = I << 1 | n >>> 31, Be = T + 432 | 0, Ir = t[T + 696 >> 2], gr = t[T + 700 >> 2], jn = n << 1, Zn = I, Ur(Be, Ir, gr, 0, 0, jn, I, 0, 0), I = t[T + 684 >> 2], Zi = I, Xi = t[T + 680 >> 2], a = Xi, I = I << 1 | a >>> 31, Me = T + 496 | 0, Mr = t[T + 688 >> 2], xr = t[T + 692 >> 2], a = a << 1, E = I, Ur(Me, Mr, xr, 0, 0, a, I, 0, 0), dr = T + 624 | 0, n = t[T + 704 >> 2], I = t[T + 708 >> 2], Ur(dr, n, I, 0, 0, n, I, 0, 0), L = T + 608 | 0, Ur(L, t[T + 624 >> 2], t[T + 628 >> 2], 0, 0, 15632, 16, 0, 0), I = I << 1 | n >>> 31, Gn = T + 464 | 0, Ti = n << 1, Bn = I, Ur(Gn, Ti, I, 0, 0, tr, cr, 0, 0), fi = T + 480 | 0, Ur(fi, Ir, gr, 0, 0, a, E, 0, 0), Ai = T + 560 | 0, Ur(Ai, Mr, xr, 0, 0, Mr, xr, 0, 0), or = T + 592 | 0, I = dr + 8 | 0, Ur(or, t[I >> 2], t[I + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), ps = T + 448 | 0, Ur(ps, tr, cr, 0, 0, tr, cr, 0, 0), wi = T + 528 | 0, Ur(wi, Ti, Bn, 0, 0, Xi, Zi, 0, 0), Bi = T + 576 | 0, Ur(Bi, Ir, gr, 0, 0, Mr << 1, xr << 1 | Mr >>> 31, 0, 0), cr = t[T + 436 >> 2], I = cr + t[T + 500 >> 2] | 0, he = t[T + 432 >> 2], n = t[T + 496 >> 2], a = he + n | 0, E = t[T + 608 >> 2], ni = a + E | 0, n = n >>> 0 > a >>> 0 ? I + 1 | 0 : I, I = n + t[T + 612 >> 2] | 0, E = E >>> 0 > ni >>> 0 ? I + 1 | 0 : I, tr = (n | 0) == (E | 0) & a >>> 0 > ni >>> 0 | n >>> 0 > E >>> 0, I = L + 8 | 0, dr = t[I >> 2], L = t[I + 4 >> 2], he = (n | 0) == (cr | 0) & a >>> 0 < he >>> 0 | n >>> 0 < cr >>> 0, a = Me + 8 | 0, n = t[a >> 2], I = Be + 8 | 0, Me = n + t[I >> 2] | 0, I = t[I + 4 >> 2] + t[a + 4 >> 2] | 0, I = n >>> 0 > Me >>> 0 ? I + 1 | 0 : I, n = he + Me | 0, I = (n >>> 0 < Me >>> 0 ? I + 1 | 0 : I) + L | 0, a = n, n = n + dr | 0, I = a >>> 0 > n >>> 0 ? I + 1 | 0 : I, a = n, n = n + tr | 0, I = a >>> 0 > n >>> 0 ? I + 1 | 0 : I, xn = E, dr = n << 12 | E >>> 20, a = I, he = I << 12 | n >>> 20, yi = t[T + 480 >> 2], n = t[T + 560 >> 2], tr = yi + n | 0, Un = t[T + 484 >> 2], I = Un + t[T + 564 >> 2] | 0, I = n >>> 0 > tr >>> 0 ? I + 1 | 0 : I, n = t[T + 464 >> 2], L = n + tr | 0, Be = I, I = I + t[T + 468 >> 2] | 0, I = n >>> 0 > L >>> 0 ? I + 1 | 0 : I, n = t[T + 592 >> 2], E = n + L | 0, Me = I, I = I + t[T + 596 >> 2] | 0, n = n >>> 0 > E >>> 0 ? I + 1 | 0 : I, I = n + he | 0, Ii = T + 368 | 0, dr = E + dr | 0, he = dr >>> 0 < E >>> 0 ? I + 1 | 0 : I, ai = (n | 0) == (he | 0) & E >>> 0 > dr >>> 0 | n >>> 0 > he >>> 0, gn = (n | 0) == (Me | 0) & E >>> 0 < L >>> 0 | n >>> 0 < Me >>> 0, I = or + 8 | 0, $r = t[I >> 2], kn = t[I + 4 >> 2], cr = (Be | 0) == (Me | 0) & L >>> 0 < tr >>> 0 | Be >>> 0 > Me >>> 0, I = Gn + 8 | 0, or = t[I >> 2], Me = t[I + 4 >> 2], L = (Be | 0) == (Un | 0) & tr >>> 0 < yi >>> 0 | Be >>> 0 < Un >>> 0, E = Ai + 8 | 0, n = t[E >> 2], I = fi + 8 | 0, tr = n + t[I >> 2] | 0, I = t[I + 4 >> 2] + t[E + 4 >> 2] | 0, I = n >>> 0 > tr >>> 0 ? I + 1 | 0 : I, n = L + tr | 0, I = (n >>> 0 < tr >>> 0 ? I + 1 | 0 : I) + Me | 0, E = n, n = n + or | 0, I = E >>> 0 > n >>> 0 ? I + 1 | 0 : I, E = n, n = n + cr | 0, I = (E >>> 0 > n >>> 0 ? I + 1 | 0 : I) + kn | 0, E = n, n = n + $r | 0, I = E >>> 0 > n >>> 0 ? I + 1 | 0 : I, E = n + gn | 0, I = E >>> 0 < n >>> 0 ? I + 1 | 0 : I, a = a >>> 20 | 0, n = a + E | 0, I = a >>> 0 > n >>> 0 ? I + 1 | 0 : I, E = n, n = n + ai | 0, I = E >>> 0 > n >>> 0 ? I + 1 | 0 : I, a = he, L = n << 12 | a >>> 20, E = I, tr = I << 12 | n >>> 20, gn = t[T + 532 >> 2], I = gn + t[T + 580 >> 2] | 0, cr = t[T + 528 >> 2], n = t[T + 576 >> 2], he = cr + n | 0, Be = he, L = he + L | 0, n = n >>> 0 > he >>> 0 ? I + 1 | 0 : I, I = n + tr | 0, Me = L << 4 & -16, he = L >>> 0 < he >>> 0 ? I + 1 | 0 : I, tr = (he << 4 | L >>> 28) & 16777215, kn = a, Ur(Ii, Me | a >>> 16 & 15, tr, 0, 0, 977, 1, 0, 0), tr = t[T + 372 >> 2], I = tr + t[T + 452 >> 2] | 0, ai = t[T + 368 >> 2], a = t[T + 448 >> 2], Me = ai + a | 0, t[T + 840 >> 2] = Me, a = a >>> 0 > Me >>> 0 ? I + 1 | 0 : I, t[T + 844 >> 2] = a & 1048575, Un = T + 352 | 0, Ur(Un, Xi, Zi, 0, 0, jn, Zn, 0, 0), Gn = T + 544 | 0, Ur(Gn, Ti, Bn, 0, 0, Mr, xr, 0, 0), fi = T + 656 | 0, Ur(fi, Ir, gr, 0, 0, Ir, gr, 0, 0), Ai = T + 416 | 0, $r = Ai, or = (n | 0) == (he | 0) & L >>> 0 < Be >>> 0 | n >>> 0 > he >>> 0, Be = (n | 0) == (gn | 0) & Be >>> 0 < cr >>> 0 | n >>> 0 < gn >>> 0, L = Bi + 8 | 0, n = t[L >> 2], I = wi + 8 | 0, cr = n + t[I >> 2] | 0, I = t[I + 4 >> 2] + t[L + 4 >> 2] | 0, I = n >>> 0 > cr >>> 0 ? I + 1 | 0 : I, L = Be + cr | 0, I = L >>> 0 < cr >>> 0 ? I + 1 | 0 : I, E = E >>> 20 | 0, n = E + L | 0, I = E >>> 0 > n >>> 0 ? I + 1 | 0 : I, E = n, n = n + or | 0, I = E >>> 0 > n >>> 0 ? I + 1 | 0 : I, Be = n << 12 | he >>> 20, L = I, he = I << 12 | n >>> 20, wi = t[T + 548 >> 2], I = wi + t[T + 660 >> 2] | 0, yi = t[T + 544 >> 2], E = t[T + 656 >> 2], n = yi + E | 0, gn = n, cr = n + Be | 0, E = n >>> 0 < E >>> 0 ? I + 1 | 0 : I, I = E + he | 0, Be = cr >>> 0 < n >>> 0 ? I + 1 | 0 : I, Ur($r, cr, Be & 1048575, 0, 0, 15632, 16, 0, 0), Me = (a | 0) == (tr | 0) & Me >>> 0 < ai >>> 0 | a >>> 0 < tr >>> 0, he = ps + 8 | 0, n = t[he >> 2], I = Ii + 8 | 0, or = n + t[I >> 2] | 0, I = t[I + 4 >> 2] + t[he + 4 >> 2] | 0, I = n >>> 0 > or >>> 0 ? I + 1 | 0 : I, n = Me + or | 0, I = n >>> 0 < or >>> 0 ? I + 1 | 0 : I, or = n << 12 | a >>> 20, he = I, Me = I << 12 | n >>> 20, Ii = t[T + 416 >> 2], n = t[T + 352 >> 2], $r = Ii + n | 0, Bi = t[T + 420 >> 2], I = Bi + t[T + 356 >> 2] | 0, a = n >>> 0 > $r >>> 0 ? I + 1 | 0 : I, I = a + Me | 0, or = or + $r | 0, I = or >>> 0 < $r >>> 0 ? I + 1 | 0 : I, t[T + 848 >> 2] = or, Me = I, t[T + 852 >> 2] = I & 1048575, ai = T + 336 | 0, Ur(ai, Mr, xr, 0, 0, jn, Zn, 0, 0), Zn = T + 512 | 0, Ur(Zn, Xi, Zi, 0, 0, Xi, Zi, 0, 0), jn = T + 640 | 0, Ur(jn, Ti, Bn, 0, 0, Ir, gr, 0, 0), Mr = T + 400 | 0, Ir = Mr, xr = (E | 0) == (Be | 0) & cr >>> 0 < gn >>> 0 | E >>> 0 > Be >>> 0, cr = (E | 0) == (wi | 0) & gn >>> 0 < yi >>> 0 | E >>> 0 < wi >>> 0, E = fi + 8 | 0, n = t[E >> 2], I = Gn + 8 | 0, gr = n + t[I >> 2] | 0, I = t[I + 4 >> 2] + t[E + 4 >> 2] | 0, I = n >>> 0 > gr >>> 0 ? I + 1 | 0 : I, E = cr + gr | 0, I = E >>> 0 < gr >>> 0 ? I + 1 | 0 : I, L = L >>> 20 | 0, n = E + L | 0, I = L >>> 0 > n >>> 0 ? I + 1 | 0 : I, E = n, n = n + xr | 0, I = E >>> 0 > n >>> 0 ? I + 1 | 0 : I, gr = n << 12 | Be >>> 20, L = t[T + 640 >> 2], Be = gr + L | 0, E = I, gn = I << 12 | n >>> 20, I = gn + t[T + 644 >> 2] | 0, cr = L >>> 0 > Be >>> 0 ? I + 1 | 0 : I, Ur(Ir, Be, cr, 0, 0, 15632, 16, 0, 0), or = (a | 0) == (Me | 0) & or >>> 0 < $r >>> 0 | a >>> 0 > Me >>> 0, tr = (a | 0) == (Bi | 0) & $r >>> 0 < Ii >>> 0 | a >>> 0 < Bi >>> 0, a = Un + 8 | 0, n = t[a >> 2], I = Ai + 8 | 0, xr = n + t[I >> 2] | 0, I = t[I + 4 >> 2] + t[a + 4 >> 2] | 0, I = n >>> 0 > xr >>> 0 ? I + 1 | 0 : I, a = tr + xr | 0, I = a >>> 0 < xr >>> 0 ? I + 1 | 0 : I, he = he >>> 20 | 0, n = a + he | 0, I = he >>> 0 > n >>> 0 ? I + 1 | 0 : I, a = n, n = n + or | 0, I = a >>> 0 > n >>> 0 ? I + 1 | 0 : I, tr = n << 12 | Me >>> 20, a = I, he = I << 12 | n >>> 20, $r = t[T + 336 >> 2], n = t[T + 512 >> 2], or = $r + n | 0, Bn = t[T + 340 >> 2], I = Bn + t[T + 516 >> 2] | 0, I = n >>> 0 > or >>> 0 ? I + 1 | 0 : I, n = t[T + 400 >> 2], Me = n + or | 0, xr = I, I = I + t[T + 404 >> 2] | 0, n = n >>> 0 > Me >>> 0 ? I + 1 | 0 : I, I = n + he | 0, tr = tr + Me | 0, I = tr >>> 0 < Me >>> 0 ? I + 1 | 0 : I, t[T + 856 >> 2] = tr, he = I, t[T + 860 >> 2] = I & 1048575, Ir = T + 384 | 0, gr = (cr | 0) == (gn | 0) & Be >>> 0 < gr >>> 0 | cr >>> 0 < gn >>> 0, I = jn + 8 | 0, cr = t[I >> 2], I = t[I + 4 >> 2], E = E >>> 20 | 0, L = E, E = E + cr | 0, I = L >>> 0 > E >>> 0 ? I + 1 | 0 : I, L = E, E = E + gr | 0, I = L >>> 0 > E >>> 0 ? I + 1 | 0 : I, Ur(Ir, E, I, 0, 0, 64028672, 65536, 0, 0), gr = (n | 0) == (he | 0) & tr >>> 0 < Me >>> 0 | n >>> 0 > he >>> 0, cr = (n | 0) == (xr | 0) & Me >>> 0 < or >>> 0 | n >>> 0 < xr >>> 0, I = Mr + 8 | 0, Be = t[I >> 2], Me = t[I + 4 >> 2], tr = (xr | 0) == (Bn | 0) & or >>> 0 < $r >>> 0 | xr >>> 0 < Bn >>> 0, L = Zn + 8 | 0, n = t[L >> 2], I = ai + 8 | 0, or = n + t[I >> 2] | 0, I = t[I + 4 >> 2] + t[L + 4 >> 2] | 0, I = n >>> 0 > or >>> 0 ? I + 1 | 0 : I, n = tr + or | 0, I = (n >>> 0 < or >>> 0 ? I + 1 | 0 : I) + Me | 0, E = n, n = n + Be | 0, I = E >>> 0 > n >>> 0 ? I + 1 | 0 : I, L = n + cr | 0, I = L >>> 0 < n >>> 0 ? I + 1 | 0 : I, a = a >>> 20 | 0, n = a + L | 0, I = a >>> 0 > n >>> 0 ? I + 1 | 0 : I, E = n, n = n + gr | 0, I = E >>> 0 > n >>> 0 ? I + 1 | 0 : I, L = n << 12 | he >>> 20, a = I, Me = I << 12 | n >>> 20, or = t[T + 384 >> 2], he = ni & -2, n = or + he | 0, cr = t[T + 388 >> 2], I = cr + (xn & 1048575) | 0, tr = n >>> 0 < he >>> 0 ? I + 1 | 0 : I, I = tr + Me | 0, E = L, L = n, he = E + n | 0, t[T + 864 >> 2] = he, n = n >>> 0 > he >>> 0 ? I + 1 | 0 : I, t[T + 868 >> 2] = n & 1048575, Be = kn & 65535, Me = (n | 0) == (tr | 0) & L >>> 0 > he >>> 0 | n >>> 0 < tr >>> 0, E = (tr | 0) == (cr | 0) & L >>> 0 < or >>> 0 | tr >>> 0 < cr >>> 0, I = Ir + 8 | 0, he = E + t[I >> 2] | 0, I = t[I + 4 >> 2], I = E >>> 0 > he >>> 0 ? I + 1 | 0 : I, a = a >>> 20 | 0, E = a, a = a + he | 0, I = E >>> 0 > a >>> 0 ? I + 1 | 0 : I, E = a, a = a + Me | 0, I = E >>> 0 > a >>> 0 ? I + 1 | 0 : I, n = a << 12 | n >>> 20, E = n + dr | 0, I = Be + (I << 12 | a >>> 20) | 0, t[T + 872 >> 2] = E, t[T + 876 >> 2] = n >>> 0 > E >>> 0 ? I + 1 | 0 : I, I = ts + 8 | 0, L = t[I >> 2], he = t[I + 4 >> 2], I = us + 8 | 0, fi = t[I >> 2], a = t[I + 4 >> 2], E = t[T + 112 >> 2], n = t[T + 116 >> 2], cr = t[T + 32 >> 2], wi = t[T + 36 >> 2], I = hs + 8 | 0, $r = t[I >> 2], Ir = t[I + 4 >> 2], I = ws + 8 | 0, Ai = t[I >> 2], xn = t[I + 4 >> 2], Mr = t[T + 16 >> 2], or = t[T + 20 >> 2], yi = t[T + 80 >> 2], Bi = t[T + 84 >> 2], I = ks + 8 | 0, gr = t[I >> 2], xr = t[I + 4 >> 2], I = T + 8 | 0, Ii = t[I >> 2], ni = t[I + 4 >> 2], gn = t[T + 176 >> 2], Be = t[T + 180 >> 2], Zn = t[T >> 2], Un = t[T + 4 >> 2], I = Bs + 8 | 0, tr = t[I >> 2], dr = t[I + 4 >> 2], jn = t[T + 64 >> 2], Me = t[T + 68 >> 2], ai = t[T + 48 >> 2], Gn = t[T + 52 >> 2], I = gs + 8 | 0, Ti = t[I >> 2], kn = t[I + 4 >> 2], I = T + 840 | 0, Xr(I, I, T + 672 | 0), I = n + wi | 0, n = E + cr | 0, E = n >>> 0 < E >>> 0 ? I + 1 | 0 : I, Bn = n, n = (wi | 0) == (E | 0) & n >>> 0 < cr >>> 0 | E >>> 0 < wi >>> 0, I = a + he | 0, a = L + fi | 0, I = a >>> 0 < fi >>> 0 ? I + 1 | 0 : I, n = n + a | 0, I = n >>> 0 < a >>> 0 ? I + 1 | 0 : I, cr = E, L = n << 12 | E >>> 20, a = I, he = I << 12 | n >>> 20, I = or + Bi | 0, E = Mr + yi | 0, n = E >>> 0 < Mr >>> 0 ? I + 1 | 0 : I, I = n + he | 0, Mr = E + L | 0, he = Mr >>> 0 < E >>> 0 ? I + 1 | 0 : I, L = (n | 0) == (he | 0) & E >>> 0 > Mr >>> 0 | n >>> 0 > he >>> 0, n = (n | 0) == (Bi | 0) & E >>> 0 < yi >>> 0 | n >>> 0 < Bi >>> 0, I = Ir + xn | 0, E = $r + Ai | 0, I = E >>> 0 < Ai >>> 0 ? I + 1 | 0 : I, $r = E, E = n + E | 0, I = $r >>> 0 > E >>> 0 ? I + 1 | 0 : I, a = a >>> 20 | 0, n = a + E | 0, I = a >>> 0 > n >>> 0 ? I + 1 | 0 : I, E = n, n = n + L | 0, I = E >>> 0 > n >>> 0 ? I + 1 | 0 : I, or = he, xn = n << 12 | he >>> 20, E = I, L = I << 12 | n >>> 20, I = Be + Un | 0, n = gn + Zn | 0, a = n >>> 0 < gn >>> 0 ? I + 1 | 0 : I, I = Me + a | 0, Me = n, he = n + jn | 0, n = he >>> 0 < jn >>> 0 ? I + 1 | 0 : I, I = n + L | 0, Be = he, L = he + xn | 0, he = he >>> 0 > L >>> 0 ? I + 1 | 0 : I, $r = L, xn = (n | 0) == (he | 0) & L >>> 0 < Be >>> 0 | n >>> 0 > he >>> 0, I = a, Be = (I | 0) == (n | 0) & Be >>> 0 < Me >>> 0 | I >>> 0 > n >>> 0, a = tr, n = dr, L = (I | 0) == (Un | 0) & Me >>> 0 < Zn >>> 0 | I >>> 0 < Un >>> 0, I = xr + ni | 0, dr = gr + Ii | 0, I = dr >>> 0 < Ii >>> 0 ? I + 1 | 0 : I, L = L + dr | 0, I = (L >>> 0 < dr >>> 0 ? I + 1 | 0 : I) + n | 0, n = a + L | 0, I = n >>> 0 < L >>> 0 ? I + 1 | 0 : I, a = n + Be | 0, I = a >>> 0 < n >>> 0 ? I + 1 | 0 : I, E = E >>> 20 | 0, n = a + E | 0, I = E >>> 0 > n >>> 0 ? I + 1 | 0 : I, E = n, n = n + xn | 0, I = E >>> 0 > n >>> 0 ? I + 1 | 0 : I, Be = he, he = n << 12 | he >>> 20, a = I, E = I << 12 | n >>> 20, n = Oi & -2, Ir = n + ai | 0, I = Gn + (Hi & 1048575) | 0, n = n >>> 0 > Ir >>> 0 ? I + 1 | 0 : I, I = n + E | 0, E = he + Ir | 0, I = E >>> 0 < Ir >>> 0 ? I + 1 | 0 : I, Hi = E, he = I, gn = t[T + 864 >> 2], Zn = t[T + 868 >> 2], jn = t[T + 856 >> 2], ni = t[T + 860 >> 2], xn = t[T + 848 >> 2], Me = t[T + 852 >> 2], L = t[T + 844 >> 2], dr = t[T + 872 >> 2], E = t[T + 876 >> 2], Oi = E, I = t[T + 840 >> 2], E = pn(E >>> 16 | 0, 0, 977, 1), tr = I + E | 0, I = L + Ee | 0, I = E >>> 0 > tr >>> 0 ? I + 1 | 0 : I, E = tr + 7 | 0, I = E >>> 0 < 7 ? I + 1 | 0 : I, gr = E, L = I, I = Me, E = L >>> 20 | 0, Me = E, E = E + xn | 0, I = Me >>> 0 > E >>> 0 ? I + 1 | 0 : I, xr = E, Me = I, I = ni, E = Me >>> 20 | 0, tr = E, E = E + jn | 0, I = tr >>> 0 > E >>> 0 ? I + 1 | 0 : I, ni = E, tr = I, I = Zn, E = tr >>> 20 | 0, Zn = E, E = E + gn | 0, I = Zn >>> 0 > E >>> 0 ? I + 1 | 0 : I, xn = E, E = I, jn = gr - Bn | 0, Bn = (L & 1048575) - ((cr & 1048575) + (gr >>> 0 < Bn >>> 0) | 0) | 0, Oi = Oi & 65535, gr = Xn & 65535, cr = (n | 0) == (he | 0) & Ir >>> 0 > Hi >>> 0 | n >>> 0 > he >>> 0, n = (n | 0) == (Gn | 0) & Ir >>> 0 < ai >>> 0 | n >>> 0 < Gn >>> 0, L = n + Ti | 0, I = kn, I = n >>> 0 > L >>> 0 ? I + 1 | 0 : I, a = a >>> 20 | 0, n = a + L | 0, I = a >>> 0 > n >>> 0 ? I + 1 | 0 : I, a = n, n = n + cr | 0, I = a >>> 0 > n >>> 0 ? I + 1 | 0 : I, a = n << 12 | he >>> 20, L = a + Wr | 0, I = gr + (I << 12 | n >>> 20) | 0, I = a >>> 0 > L >>> 0 ? I + 1 | 0 : I, a = dr - L | 0, I = Oi - ((L >>> 0 > dr >>> 0) + I | 0) | 0, L = E >>> 20 | 0, n = a + L | 0, I = (L >>> 0 > n >>> 0 ? I + 1 | 0 : I) + 262143 | 0, n = n - 4 | 0, dr = n >>> 0 < 4294967292 ? I + 1 | 0 : I, a = pn(dr >>> 16 | 0, 0, 977, 1), L = a + jn | 0, I = Bn + Ee | 0, I = (a >>> 0 > L >>> 0 ? I + 1 | 0 : I) + 4194299 | 0, a = L - 3908 | 0, I = a >>> 0 < 4294963388 ? I + 1 | 0 : I, Xn = a ^ 976, L = I & 1048575, Ir = L ^ 1, ((Xn | 0) != -1 | (Ir | 0) != 1048575) & (a | L) != 0 ? n = 0 : (gr = xn - Hi | 0, kn = (E & 1048575) - ((he & 1048575) + (xn >>> 0 < Hi >>> 0) | 0) | 0, cr = ni - $r | 0, Wr = (tr & 1048575) - ((Be & 1048575) + ($r >>> 0 > ni >>> 0) | 0) | 0, a = I, I = (Me & 1048575) - ((or & 1048575) + (xr >>> 0 < Mr >>> 0) | 0) | 0, a = a >>> 20 | 0, E = a, a = a + (xr - Mr | 0) | 0, I = (E >>> 0 > a >>> 0 ? I + 1 | 0 : I) + 4194303 | 0, L = a - 4 | 0, he = L >>> 0 < 4294967292 ? I + 1 | 0 : I, I = Wr, a = he >>> 20 | 0, E = a, a = a + cr | 0, I = (E >>> 0 > a >>> 0 ? I + 1 | 0 : I) + 4194303 | 0, E = a - 4 | 0, a = E >>> 0 < 4294967292 ? I + 1 | 0 : I, I = kn, Wr = a >>> 20 | 0, Be = Wr, Wr = gr + Wr | 0, I = (Be >>> 0 > Wr >>> 0 ? I + 1 | 0 : I) + 4194303 | 0, Wr = Wr - 4 | 0, I = Wr >>> 0 < 4294967292 ? I + 1 | 0 : I, L = Wr & (L & Xn & E), he = I & (he & Ir & a), a = n, n = I, I = dr & 65535, n = n >>> 20 | 0, E = n, n = n + a | 0, I = E >>> 0 > n >>> 0 ? I + 1 | 0 : I, n = (n & L) == -1 & (he & (I ^ 983040)) == 1048575);
      }
      if (!n)
        break e;
      In(d, T + 672 | 0), v = 1;
    }
    return x = T + 880 | 0, v;
  }
  function vn(v, d) {
    var I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0;
    return a = v, I = l[d + 30 | 0], v = I >>> 24 | 0, n = l[d + 31 | 0] | I << 8, I = v, E = l[d + 29 | 0], v = E >>> 16 | 0, E = E << 16 | n, n = v | I, I = l[d + 28 | 0], v = I >>> 8 | 0, I = I << 24 | E, v = l[d + 27 | 0] | (v | n) | l[d + 26 | 0] << 8 | (l[d + 25 | 0] & 15) << 16, E = v, cr = I, t[a >> 2] = I, t[a + 4 >> 2] = v, I = l[d + 24 | 0], v = I >>> 28 | 0, T = I << 4 | l[d + 25 | 0] >>> 4, I = v, n = l[d + 23 | 0], v = n >>> 20 | 0, n = n << 12 | T, T = v | I, I = l[d + 22 | 0], v = I >>> 12 | 0, n = I << 20 | n, T = v | T, I = l[d + 21 | 0], v = I >>> 4 | 0, I = I << 28 | n, n = v | T | l[d + 20 | 0] << 4, v = l[d + 19 | 0] << 12, T = I, t[a + 8 >> 2] = I, Me = v | n, t[a + 12 >> 2] = Me, I = l[d + 17 | 0], v = I >>> 24 | 0, he = l[d + 18 | 0] | I << 8, I = v, n = l[d + 16 | 0], v = n >>> 16 | 0, n = n << 16 | he, he = v | I, I = l[d + 15 | 0], v = I >>> 8 | 0, I = I << 24 | n, n = l[d + 14 | 0] | (v | he) | l[d + 13 | 0] << 8, v = (l[d + 12 | 0] & 15) << 16, he = I, t[a + 16 >> 2] = I, tr = v | n, t[a + 20 >> 2] = tr, I = l[d + 11 | 0], v = I >>> 28 | 0, L = I << 4 | l[d + 12 | 0] >>> 4, I = v, n = l[d + 10 | 0], v = n >>> 20 | 0, n = n << 12 | L, L = v | I, I = l[d + 9 | 0], v = I >>> 12 | 0, n = I << 20 | n, L = v | L, I = l[d + 8 | 0], v = I >>> 4 | 0, I = I << 28 | n, n = v | L | l[d + 7 | 0] << 4, v = l[d + 6 | 0] << 12, L = I, t[a + 24 >> 2] = I, or = v | n, t[a + 28 >> 2] = or, I = l[d + 4 | 0], v = I >>> 24 | 0, Be = l[d + 5 | 0] | I << 8, I = v, n = l[d + 3 | 0], v = n >>> 16 | 0, n = n << 16 | Be, Be = v | I, I = l[d + 2 | 0], v = I >>> 8 | 0, I = I << 24 | n, n = l[d + 1 | 0] | (v | Be), v = l[d | 0] << 8, t[a + 32 >> 2] = I, v = v | n, t[a + 36 >> 2] = v, (T & he & L) != -1 | (Me & tr & or) != 1048575 | ((I | 0) != -1 | (v | 0) != 65535) | ((E | 0) == 1048574 & cr >>> 0 < 4294966319 | E >>> 0 < 1048574);
  }
  function Cn(v, d, I) {
    var n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0, Xn = 0, Zn = 0, ni = 0, ai = 0, fi = 0, Ai = 0, yi = 0, Ii = 0, wi = 0, Bi = 0, Ti = 0, Oi = 0, Hi = 0, Xi = 0, Zi = 0, ts = 0, us = 0;
    for (T = x - 7616 | 0, x = T, E = d + 32 | 0, a = t[E + 4 >> 2], n = v + 32 | 0, t[n >> 2] = t[E >> 2], t[n + 4 >> 2] = a, E = d + 24 | 0, a = t[E + 4 >> 2], n = v + 24 | 0, t[n >> 2] = t[E >> 2], t[n + 4 >> 2] = a, E = d + 16 | 0, a = t[E + 4 >> 2], n = v + 16 | 0, t[n >> 2] = t[E >> 2], t[n + 4 >> 2] = a, E = d + 8 | 0, a = t[E + 4 >> 2], n = v + 8 | 0, t[n >> 2] = t[E >> 2], t[n + 4 >> 2] = a, n = t[d + 4 >> 2], t[v >> 2] = t[d >> 2], t[v + 4 >> 2] = n, n = T + 7096 | 0, Ui(n, d), Xi = T + 7056 | 0, Xr(Xi, d, n), t[v + 80 >> 2] = 0, n = t[T + 7060 >> 2], a = t[T + 7056 >> 2] + 7 | 0, d = a >>> 0 < 7 ? n + 1 | 0 : n, n = a, t[T + 7056 >> 2] = n, t[T + 7060 >> 2] = d, cr = T + 6848 | 0, gn = t[T + 7080 >> 2], xr = t[T + 7084 >> 2], Xn = n << 1, L = n, Bn = d << 1 | n >>> 31, Ur(cr, gn, xr, 0, 0, Xn, Bn, 0, 0), n = t[T + 7068 >> 2], Hi = n, Ai = t[T + 7064 >> 2], E = Ai, n = n << 1 | E >>> 31, or = T + 6880 | 0, xn = t[T + 7072 >> 2], Mr = t[T + 7076 >> 2], E = E << 1, he = n, Ur(or, xn, Mr, 0, 0, E, n, 0, 0), Be = T + 7008 | 0, a = t[T + 7088 >> 2], n = t[T + 7092 >> 2], Ur(Be, a, n, 0, 0, a, n, 0, 0), Me = T + 6992 | 0, Ur(Me, t[T + 7008 >> 2], t[T + 7012 >> 2], 0, 0, 15632, 16, 0, 0), n = n << 1 | a >>> 31, ai = T + 6800 | 0, kn = a << 1, $r = n, Ur(ai, kn, n, 0, 0, L, d, 0, 0), Bi = T + 6864 | 0, Ur(Bi, gn, xr, 0, 0, E, he, 0, 0), ni = T + 6944 | 0, Ur(ni, xn, Mr, 0, 0, xn, Mr, 0, 0), dr = T + 6976 | 0, n = Be + 8 | 0, Ur(dr, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Oi = T + 6720 | 0, Ur(Oi, L, d, 0, 0, L, d, 0, 0), Ti = T + 6912 | 0, Ur(Ti, kn, $r, 0, 0, Ai, Hi, 0, 0), Ii = T + 6960 | 0, Ur(Ii, gn, xr, 0, 0, xn << 1, Mr << 1 | xn >>> 31, 0, 0), Ir = t[T + 6852 >> 2], n = Ir + t[T + 6884 >> 2] | 0, he = t[T + 6848 >> 2], a = t[T + 6880 >> 2], d = he + a | 0, E = t[T + 6992 >> 2], gr = d + E | 0, a = d >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = a + t[T + 6996 >> 2] | 0, E = E >>> 0 > gr >>> 0 ? n + 1 | 0 : n, Be = (a | 0) == (E | 0) & d >>> 0 > gr >>> 0 | a >>> 0 > E >>> 0, n = Me + 8 | 0, tr = t[n >> 2], L = t[n + 4 >> 2], he = (a | 0) == (Ir | 0) & d >>> 0 < he >>> 0 | a >>> 0 < Ir >>> 0, n = or + 8 | 0, a = t[n >> 2], d = cr + 8 | 0, Me = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, d = he + Me | 0, n = (d >>> 0 < Me >>> 0 ? n + 1 | 0 : n) + L | 0, a = d, d = d + tr | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Be | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Ir = E, tr = d << 12 | E >>> 20, a = n, he = n << 12 | d >>> 20, fi = t[T + 6864 >> 2], d = t[T + 6944 >> 2], Be = fi + d | 0, yi = t[T + 6868 >> 2], n = yi + t[T + 6948 >> 2] | 0, n = d >>> 0 > Be >>> 0 ? n + 1 | 0 : n, d = t[T + 6800 >> 2], L = d + Be | 0, or = n, n = n + t[T + 6804 >> 2] | 0, n = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, d = t[T + 6976 >> 2], E = d + L | 0, Me = n, n = n + t[T + 6980 >> 2] | 0, d = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, n = d + he | 0, wi = T + 6736 | 0, Zn = wi, tr = E + tr | 0, he = tr >>> 0 < E >>> 0 ? n + 1 | 0 : n, jn = (d | 0) == (he | 0) & E >>> 0 > tr >>> 0 | d >>> 0 > he >>> 0, Un = (d | 0) == (Me | 0) & E >>> 0 < L >>> 0 | d >>> 0 < Me >>> 0, d = dr + 8 | 0, Wr = t[d >> 2], Gn = t[d + 4 >> 2], cr = (Me | 0) == (or | 0) & L >>> 0 < Be >>> 0 | Me >>> 0 < or >>> 0, d = ai + 8 | 0, dr = t[d >> 2], Me = t[d + 4 >> 2], L = (or | 0) == (yi | 0) & Be >>> 0 < fi >>> 0 | or >>> 0 < yi >>> 0, n = ni + 8 | 0, E = t[n >> 2], d = Bi + 8 | 0, Be = E + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = E >>> 0 > Be >>> 0 ? n + 1 | 0 : n, d = L + Be | 0, n = (d >>> 0 < Be >>> 0 ? n + 1 | 0 : n) + Me | 0, E = d, d = d + dr | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d, d = d + cr | 0, n = (E >>> 0 > d >>> 0 ? n + 1 | 0 : n) + Gn | 0, E = d, d = d + Wr | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d + Un | 0, n = E >>> 0 < d >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + E | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + jn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = he, L = d << 12 | a >>> 20, E = n, he = n << 12 | d >>> 20, dr = t[T + 6912 >> 2], d = t[T + 6960 >> 2], Me = dr + d | 0, Wr = t[T + 6916 >> 2], n = Wr + t[T + 6964 >> 2] | 0, d = d >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = d + he | 0, L = L + Me | 0, n = L >>> 0 < Me >>> 0 ? n + 1 | 0 : n, or = L << 4 & -16, he = n, Be = (n << 4 | L >>> 28) & 16777215, cr = a, Ur(Zn, or | a >>> 16 & 15, Be, 0, 0, 977, 1, 0, 0), jn = t[T + 6740 >> 2], n = jn + t[T + 6724 >> 2] | 0, Un = t[T + 6736 >> 2], a = t[T + 6720 >> 2], Be = Un + a | 0, t[T + 7576 >> 2] = Be, a = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, t[T + 7580 >> 2] = a & 1048575, ai = T + 6832 | 0, Ur(ai, Ai, Hi, 0, 0, Xn, Bn, 0, 0), Bi = T + 6928 | 0, Ur(Bi, kn, $r, 0, 0, xn, Mr, 0, 0), ni = T + 7040 | 0, Ur(ni, gn, xr, 0, 0, gn, xr, 0, 0), fi = T + 6784 | 0, Gn = fi, or = (d | 0) == (he | 0) & L >>> 0 < Me >>> 0 | d >>> 0 > he >>> 0, Me = (d | 0) == (Wr | 0) & Me >>> 0 < dr >>> 0 | d >>> 0 < Wr >>> 0, n = Ii + 8 | 0, L = t[n >> 2], d = Ti + 8 | 0, dr = L + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = L >>> 0 > dr >>> 0 ? n + 1 | 0 : n, L = Me + dr | 0, n = L >>> 0 < dr >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, d = E + L | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d, d = d + or | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, Me = d << 12 | he >>> 20, L = n, he = n << 12 | d >>> 20, Ii = t[T + 6932 >> 2], n = Ii + t[T + 7044 >> 2] | 0, Zn = t[T + 6928 >> 2], E = t[T + 7040 >> 2], d = Zn + E | 0, Wr = d, dr = d + Me | 0, E = d >>> 0 < E >>> 0 ? n + 1 | 0 : n, n = E + he | 0, Me = dr >>> 0 < d >>> 0 ? n + 1 | 0 : n, Ur(Gn, dr, Me & 1048575, 0, 0, 15632, 16, 0, 0), Be = (a | 0) == (jn | 0) & Be >>> 0 < Un >>> 0 | a >>> 0 < jn >>> 0, n = Oi + 8 | 0, he = t[n >> 2], d = wi + 8 | 0, or = he + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = he >>> 0 > or >>> 0 ? n + 1 | 0 : n, d = Be + or | 0, n = d >>> 0 < or >>> 0 ? n + 1 | 0 : n, or = d << 12 | a >>> 20, he = n, Be = n << 12 | d >>> 20, jn = t[T + 6784 >> 2], d = t[T + 6832 >> 2], Gn = jn + d | 0, wi = t[T + 6788 >> 2], n = wi + t[T + 6836 >> 2] | 0, a = d >>> 0 > Gn >>> 0 ? n + 1 | 0 : n, n = a + Be | 0, or = or + Gn | 0, n = or >>> 0 < Gn >>> 0 ? n + 1 | 0 : n, t[T + 7584 >> 2] = or, Be = n, t[T + 7588 >> 2] = n & 1048575, Un = T + 6816 | 0, Ur(Un, xn, Mr, 0, 0, Xn, Bn, 0, 0), Bn = T + 6896 | 0, Ur(Bn, Ai, Hi, 0, 0, Ai, Hi, 0, 0), Xn = T + 7024 | 0, Ur(Xn, kn, $r, 0, 0, gn, xr, 0, 0), xn = T + 6768 | 0, gn = xn, Mr = (E | 0) == (Me | 0) & dr >>> 0 < Wr >>> 0 | E >>> 0 > Me >>> 0, dr = (E | 0) == (Ii | 0) & Wr >>> 0 < Zn >>> 0 | E >>> 0 < Ii >>> 0, n = ni + 8 | 0, E = t[n >> 2], d = Bi + 8 | 0, xr = E + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = E >>> 0 > xr >>> 0 ? n + 1 | 0 : n, E = dr + xr | 0, n = E >>> 0 < xr >>> 0 ? n + 1 | 0 : n, L = L >>> 20 | 0, d = E + L | 0, n = L >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d, d = d + Mr | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, xr = d << 12 | Me >>> 20, L = t[T + 7024 >> 2], Me = xr + L | 0, E = n, Wr = n << 12 | d >>> 20, n = Wr + t[T + 7028 >> 2] | 0, dr = L >>> 0 > Me >>> 0 ? n + 1 | 0 : n, Ur(gn, Me, dr, 0, 0, 15632, 16, 0, 0), or = (a | 0) == (Be | 0) & or >>> 0 < Gn >>> 0 | a >>> 0 > Be >>> 0, L = (a | 0) == (wi | 0) & Gn >>> 0 < jn >>> 0 | a >>> 0 < wi >>> 0, n = ai + 8 | 0, a = t[n >> 2], d = fi + 8 | 0, Mr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Mr >>> 0 ? n + 1 | 0 : n, a = L + Mr | 0, n = a >>> 0 < Mr >>> 0 ? n + 1 | 0 : n, he = he >>> 20 | 0, d = a + he | 0, n = he >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + or | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d << 12 | Be >>> 20, a = n, he = n << 12 | d >>> 20, Gn = t[T + 6816 >> 2], d = t[T + 6896 >> 2], or = Gn + d | 0, $r = t[T + 6820 >> 2], n = $r + t[T + 6900 >> 2] | 0, n = d >>> 0 > or >>> 0 ? n + 1 | 0 : n, d = t[T + 6768 >> 2], Be = d + or | 0, Mr = n, n = n + t[T + 6772 >> 2] | 0, d = d >>> 0 > Be >>> 0 ? n + 1 | 0 : n, n = d + he | 0, L = L + Be | 0, n = L >>> 0 < Be >>> 0 ? n + 1 | 0 : n, t[T + 7592 >> 2] = L, he = n, t[T + 7596 >> 2] = n & 1048575, gn = T + 6752 | 0, xr = (dr | 0) == (Wr | 0) & Me >>> 0 < xr >>> 0 | dr >>> 0 < Wr >>> 0, n = Xn + 8 | 0, dr = t[n >> 2], n = t[n + 4 >> 2], E = E >>> 20 | 0, Me = E, E = E + dr | 0, n = Me >>> 0 > E >>> 0 ? n + 1 | 0 : n, Me = E, E = E + xr | 0, n = Me >>> 0 > E >>> 0 ? n + 1 | 0 : n, Ur(gn, E, n, 0, 0, 64028672, 65536, 0, 0), xr = (d | 0) == (he | 0) & L >>> 0 < Be >>> 0 | d >>> 0 > he >>> 0, dr = (d | 0) == (Mr | 0) & Be >>> 0 < or >>> 0 | d >>> 0 < Mr >>> 0, d = xn + 8 | 0, Me = t[d >> 2], Be = t[d + 4 >> 2], L = (Mr | 0) == ($r | 0) & or >>> 0 < Gn >>> 0 | Mr >>> 0 < $r >>> 0, n = Bn + 8 | 0, E = t[n >> 2], d = Un + 8 | 0, or = E + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = E >>> 0 > or >>> 0 ? n + 1 | 0 : n, d = L + or | 0, n = (d >>> 0 < or >>> 0 ? n + 1 | 0 : n) + Be | 0, E = d, d = d + Me | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d + dr | 0, n = E >>> 0 < d >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + E | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + xr | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Be = d << 12 | he >>> 20, a = n, E = n << 12 | d >>> 20, or = t[T + 6752 >> 2], d = gr & -2, he = or + d | 0, dr = t[T + 6756 >> 2], n = dr + (Ir & 1048575) | 0, L = d >>> 0 > he >>> 0 ? n + 1 | 0 : n, n = L + E | 0, E = he + Be | 0, n = E >>> 0 < he >>> 0 ? n + 1 | 0 : n, t[T + 7600 >> 2] = E, d = n, t[T + 7604 >> 2] = n & 1048575, Me = cr & 65535, Be = (n | 0) == (L | 0) & E >>> 0 < he >>> 0 | n >>> 0 < L >>> 0, E = (L | 0) == (dr | 0) & he >>> 0 < or >>> 0 | L >>> 0 < dr >>> 0, n = gn + 8 | 0, he = E + t[n >> 2] | 0, n = t[n + 4 >> 2], n = E >>> 0 > he >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, E = a, a = a + he | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Be | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, d = a << 12 | d >>> 20, E = d + tr | 0, n = Me + (n << 12 | a >>> 20) | 0, t[T + 7608 >> 2] = E, t[T + 7612 >> 2] = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, Hi = T + 7576 | 0, Xr(Hi, Hi, Xi), d = t[T + 7580 >> 2], Ir = d, cr = t[T + 7576 >> 2], L = cr, n = d << 1 | L >>> 31, or = T + 6448 | 0, xn = t[T + 7600 >> 2], Gn = t[T + 7604 >> 2], Wr = L << 1, kn = n, Ur(or, xn, Gn, 0, 0, Wr, n, 0, 0), d = t[T + 7588 >> 2], us = d, ts = t[T + 7584 >> 2], a = ts, n = d << 1 | a >>> 31, Me = T + 6656 | 0, Xn = t[T + 7592 >> 2], gn = t[T + 7596 >> 2], a = a << 1, E = n, Ur(Me, Xn, gn, 0, 0, a, n, 0, 0), Be = T + 6608 | 0, he = t[T + 7608 >> 2], d = t[T + 7612 >> 2], Ur(Be, he, d, 0, 0, he, d, 0, 0), tr = T + 6592 | 0, Ur(tr, t[T + 6608 >> 2], t[T + 6612 >> 2], 0, 0, 15632, 16, 0, 0), n = d << 1 | he >>> 31, wi = T + 6560 | 0, jn = he << 1, Bn = n, Ur(wi, jn, n, 0, 0, L, Ir, 0, 0), ai = T + 6464 | 0, Ur(ai, xn, Gn, 0, 0, a, E, 0, 0), Bi = T + 6640 | 0, Ur(Bi, Xn, gn, 0, 0, Xn, gn, 0, 0), dr = T + 6576 | 0, d = Be + 8 | 0, Ur(dr, t[d >> 2], t[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Oi = T + 6704 | 0, Ur(Oi, L, Ir, 0, 0, L, Ir, 0, 0), Ti = T + 6544 | 0, Ur(Ti, jn, n, 0, 0, ts, us, 0, 0), ni = T + 6480 | 0, Ur(ni, xn, Gn, 0, 0, Xn << 1, gn << 1 | Xn >>> 31, 0, 0), cr = t[T + 6452 >> 2], n = cr + t[T + 6660 >> 2] | 0, he = t[T + 6448 >> 2], a = t[T + 6656 >> 2], d = he + a | 0, E = t[T + 6592 >> 2], xr = d + E | 0, a = d >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = a + t[T + 6596 >> 2] | 0, E = E >>> 0 > xr >>> 0 ? n + 1 | 0 : n, Be = (a | 0) == (E | 0) & d >>> 0 > xr >>> 0 | a >>> 0 > E >>> 0, n = tr + 8 | 0, tr = t[n >> 2], L = t[n + 4 >> 2], he = (a | 0) == (cr | 0) & d >>> 0 < he >>> 0 | a >>> 0 < cr >>> 0, n = Me + 8 | 0, a = t[n >> 2], d = or + 8 | 0, Me = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, d = he + Me | 0, n = (d >>> 0 < Me >>> 0 ? n + 1 | 0 : n) + L | 0, a = d, d = d + tr | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Be | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Mr = E, tr = d << 12 | E >>> 20, a = n, he = n << 12 | d >>> 20, fi = t[T + 6464 >> 2], d = t[T + 6640 >> 2], Be = fi + d | 0, Ii = t[T + 6468 >> 2], n = Ii + t[T + 6644 >> 2] | 0, n = d >>> 0 > Be >>> 0 ? n + 1 | 0 : n, d = t[T + 6560 >> 2], L = d + Be | 0, or = n, n = n + t[T + 6564 >> 2] | 0, n = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, d = t[T + 6576 >> 2], E = d + L | 0, Me = n, n = n + t[T + 6580 >> 2] | 0, d = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, n = d + he | 0, Zn = T + 6384 | 0, tr = E + tr | 0, he = tr >>> 0 < E >>> 0 ? n + 1 | 0 : n, Un = (d | 0) == (he | 0) & E >>> 0 > tr >>> 0 | d >>> 0 > he >>> 0, $r = (d | 0) == (Me | 0) & E >>> 0 < L >>> 0 | d >>> 0 < Me >>> 0, d = dr + 8 | 0, gr = t[d >> 2], Ir = t[d + 4 >> 2], cr = (Me | 0) == (or | 0) & L >>> 0 < Be >>> 0 | Me >>> 0 < or >>> 0, d = wi + 8 | 0, dr = t[d >> 2], Me = t[d + 4 >> 2], L = (or | 0) == (Ii | 0) & Be >>> 0 < fi >>> 0 | or >>> 0 < Ii >>> 0, n = Bi + 8 | 0, E = t[n >> 2], d = ai + 8 | 0, Be = E + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = E >>> 0 > Be >>> 0 ? n + 1 | 0 : n, d = L + Be | 0, n = (d >>> 0 < Be >>> 0 ? n + 1 | 0 : n) + Me | 0, E = d, d = d + dr | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d, d = d + cr | 0, n = (E >>> 0 > d >>> 0 ? n + 1 | 0 : n) + Ir | 0, E = d, d = d + gr | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d + $r | 0, n = E >>> 0 < d >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + E | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Un | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = he, L = d << 12 | a >>> 20, E = n, he = n << 12 | d >>> 20, dr = t[T + 6544 >> 2], d = t[T + 6480 >> 2], Be = dr + d | 0, cr = t[T + 6548 >> 2], n = cr + t[T + 6484 >> 2] | 0, d = d >>> 0 > Be >>> 0 ? n + 1 | 0 : n, n = d + he | 0, L = L + Be | 0, n = L >>> 0 < Be >>> 0 ? n + 1 | 0 : n, or = L << 4 & -16, he = n, Me = (n << 4 | L >>> 28) & 16777215, gr = a, Ur(Zn, or | a >>> 16 & 15, Me, 0, 0, 977, 1, 0, 0), Ii = T + 6688 | 0, Ur(Ii, ts, us, 0, 0, Wr, kn, 0, 0), wi = T + 6528 | 0, Ur(wi, jn, Bn, 0, 0, Xn, gn, 0, 0), ai = T + 6496 | 0, Ur(ai, xn, Gn, 0, 0, xn, Gn, 0, 0), Bi = T + 6432 | 0, or = Bi, Me = (d | 0) == (n | 0) & L >>> 0 < Be >>> 0 | d >>> 0 > n >>> 0, L = (d | 0) == (cr | 0) & Be >>> 0 < dr >>> 0 | d >>> 0 < cr >>> 0, n = ni + 8 | 0, a = t[n >> 2], d = Ti + 8 | 0, Be = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, a = L + Be | 0, n = a >>> 0 < Be >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, d = a + E | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Me | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | he >>> 20, L = n, a = n << 12 | d >>> 20, ni = t[T + 6528 >> 2], d = t[T + 6496 >> 2], $r = ni + d | 0, Ai = t[T + 6532 >> 2], n = Ai + t[T + 6500 >> 2] | 0, E = d >>> 0 > $r >>> 0 ? n + 1 | 0 : n, n = E + a | 0, Ir = he + $r | 0, n = Ir >>> 0 < $r >>> 0 ? n + 1 | 0 : n, Me = n, Ur(or, Ir, n & 1048575, 0, 0, 15632, 16, 0, 0), he = t[T + 6384 >> 2], d = t[T + 6704 >> 2], cr = he + d | 0, Be = t[T + 6388 >> 2], n = Be + t[T + 6708 >> 2] | 0, Zi = T + 7536 | 0, yi = Zi + 8 | 0, a = d >>> 0 > cr >>> 0 ? n + 1 | 0 : n, Be = (Be | 0) == (a | 0) & he >>> 0 > cr >>> 0 | a >>> 0 < Be >>> 0, n = Oi + 8 | 0, he = t[n >> 2], d = Zn + 8 | 0, or = he + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = he >>> 0 > or >>> 0 ? n + 1 | 0 : n, d = Be + or | 0, n = d >>> 0 < or >>> 0 ? n + 1 | 0 : n, dr = a, or = d << 12 | a >>> 20, he = n, Be = n << 12 | d >>> 20, Ti = t[T + 6436 >> 2], n = Ti + t[T + 6692 >> 2] | 0, fi = t[T + 6432 >> 2], a = t[T + 6688 >> 2], d = fi + a | 0, Un = d, or = d + or | 0, a = d >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = a + Be | 0, t[yi >> 2] = or, Be = or >>> 0 < d >>> 0 ? n + 1 | 0 : n, t[yi + 4 >> 2] = Be & 1048575, Zn = T + 6624 | 0, Ur(Zn, Xn, gn, 0, 0, Wr, kn, 0, 0), kn = T + 6672 | 0, Ur(kn, ts, us, 0, 0, ts, us, 0, 0), Wr = T + 6512 | 0, Ur(Wr, jn, Bn, 0, 0, xn, Gn, 0, 0), Bn = T + 6416 | 0, gn = (E | 0) == (Me | 0) & Ir >>> 0 < $r >>> 0 | E >>> 0 > Me >>> 0, Ir = (E | 0) == (Ai | 0) & $r >>> 0 < ni >>> 0 | E >>> 0 < Ai >>> 0, n = ai + 8 | 0, E = t[n >> 2], d = wi + 8 | 0, xn = E + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = E >>> 0 > xn >>> 0 ? n + 1 | 0 : n, E = Ir + xn | 0, n = E >>> 0 < xn >>> 0 ? n + 1 | 0 : n, L = L >>> 20 | 0, d = E + L | 0, n = L >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d, d = d + gn | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, Xn = d << 12 | Me >>> 20, L = t[T + 6512 >> 2], Me = Xn + L | 0, E = n, ni = n << 12 | d >>> 20, n = ni + t[T + 6516 >> 2] | 0, Ir = L >>> 0 > Me >>> 0 ? n + 1 | 0 : n, Ur(Bn, Me, Ir, 0, 0, 15632, 16, 0, 0), jn = Zi + 16 | 0, xn = jn, or = (a | 0) == (Be | 0) & or >>> 0 < Un >>> 0 | a >>> 0 > Be >>> 0, L = (a | 0) == (Ti | 0) & Un >>> 0 < fi >>> 0 | a >>> 0 < Ti >>> 0, n = Ii + 8 | 0, a = t[n >> 2], d = Bi + 8 | 0, gn = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > gn >>> 0 ? n + 1 | 0 : n, a = L + gn | 0, n = a >>> 0 < gn >>> 0 ? n + 1 | 0 : n, he = he >>> 20 | 0, d = a + he | 0, n = he >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + or | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d << 12 | Be >>> 20, a = n, Gn = n << 12 | d >>> 20, $r = t[T + 6624 >> 2], d = t[T + 6672 >> 2], Be = $r + d | 0, Un = t[T + 6628 >> 2], n = Un + t[T + 6676 >> 2] | 0, gn = d >>> 0 > Be >>> 0 ? n + 1 | 0 : n, n = gn + t[T + 6420 >> 2] | 0, d = t[T + 6416 >> 2], he = d + Be | 0, or = he, L = he + L | 0, d = d >>> 0 > he >>> 0 ? n + 1 | 0 : n, n = d + Gn | 0, t[xn >> 2] = L, he = L >>> 0 < he >>> 0 ? n + 1 | 0 : n, t[xn + 4 >> 2] = he & 1048575, xn = T + 6400 | 0, Gn = (Ir | 0) == (ni | 0) & Me >>> 0 < Xn >>> 0 | Ir >>> 0 < ni >>> 0, n = Wr + 8 | 0, Ir = t[n >> 2], n = t[n + 4 >> 2], E = E >>> 20 | 0, Me = E, E = E + Ir | 0, n = Me >>> 0 > E >>> 0 ? n + 1 | 0 : n, Ir = E, E = E + Gn | 0, n = Ir >>> 0 > E >>> 0 ? n + 1 | 0 : n, Ur(xn, E, n, 0, 0, 64028672, 65536, 0, 0), Xn = Zi + 24 | 0, Gn = (d | 0) == (he | 0) & L >>> 0 < or >>> 0 | d >>> 0 > he >>> 0, Ir = (d | 0) == (gn | 0) & Be >>> 0 > or >>> 0 | d >>> 0 < gn >>> 0, d = Bn + 8 | 0, or = t[d >> 2], Me = t[d + 4 >> 2], L = (gn | 0) == (Un | 0) & Be >>> 0 < $r >>> 0 | gn >>> 0 < Un >>> 0, n = kn + 8 | 0, E = t[n >> 2], d = Zn + 8 | 0, Be = E + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = E >>> 0 > Be >>> 0 ? n + 1 | 0 : n, d = L + Be | 0, n = (d >>> 0 < Be >>> 0 ? n + 1 | 0 : n) + Me | 0, E = d, d = d + or | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d + Ir | 0, n = E >>> 0 < d >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + E | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Gn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | he >>> 20, a = n, Be = n << 12 | d >>> 20, or = t[T + 6400 >> 2], E = xr & -2, d = or + E | 0, xr = t[T + 6404 >> 2], n = xr + (Mr & 1048575) | 0, L = d >>> 0 < E >>> 0 ? n + 1 | 0 : n, n = L + Be | 0, E = he, he = d, E = E + d | 0, t[Xn >> 2] = E, d = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, t[Xn + 4 >> 2] = d & 1048575, Mr = Zi + 32 | 0, Ir = Mr, Me = gr & 65535, Be = (d | 0) == (L | 0) & E >>> 0 < he >>> 0 | d >>> 0 < L >>> 0, E = (L | 0) == (xr | 0) & he >>> 0 < or >>> 0 | L >>> 0 < xr >>> 0, n = xn + 8 | 0, he = E + t[n >> 2] | 0, n = t[n + 4 >> 2], n = E >>> 0 > he >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, E = a, a = a + he | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Be | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, d = a << 12 | d >>> 20, E = d + tr | 0, n = Me + (n << 12 | a >>> 20) | 0, t[Ir >> 2] = E, t[Ir + 4 >> 2] = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, t[T + 7536 >> 2] = cr, t[T + 7540 >> 2] = dr & 1048575, Xr(Zi, Zi, Xi), d = t[T + 7540 >> 2], Bn = d, $r = t[T + 7536 >> 2], L = $r, n = d << 1 | L >>> 31, gr = T + 6224 | 0, or = t[Xn >> 2], Me = t[Xn + 4 >> 2], gn = L << 1, Gn = n, Ur(gr, or, Me, 0, 0, gn, n, 0, 0), d = t[yi + 4 >> 2], Xi = d, Ai = t[yi >> 2], a = Ai, n = d << 1 | a >>> 31, Ir = T + 6320 | 0, cr = t[jn >> 2], Be = t[jn + 4 >> 2], a = a << 1, E = n, Ur(Ir, cr, Be, 0, 0, a, n, 0, 0), dr = T + 6208 | 0, he = t[Mr >> 2], d = t[Mr + 4 >> 2], Ur(dr, he, d, 0, 0, he, d, 0, 0), tr = T + 6192 | 0, Ur(tr, t[T + 6208 >> 2], t[T + 6212 >> 2], 0, 0, 15632, 16, 0, 0), n = d << 1 | he >>> 31, Oi = T + 6160 | 0, xn = he << 1, xr = n, Ur(Oi, xn, n, 0, 0, L, Bn, 0, 0), Ti = T + 6240 | 0, Ur(Ti, or, Me, 0, 0, a, E, 0, 0), Ii = T + 6304 | 0, Ur(Ii, cr, Be, 0, 0, cr, Be, 0, 0), Xn = T + 6176 | 0, d = dr + 8 | 0, Ur(Xn, t[d >> 2], t[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), wi = T + 6368 | 0, Ur(wi, L, Bn, 0, 0, L, Bn, 0, 0), ai = T + 6144 | 0, Ur(ai, xn, n, 0, 0, Ai, Xi, 0, 0), Bi = T + 6256 | 0, Ur(Bi, or, Me, 0, 0, cr << 1, Be << 1 | cr >>> 31, 0, 0), $r = t[T + 6228 >> 2], n = $r + t[T + 6324 >> 2] | 0, he = t[T + 6224 >> 2], a = t[T + 6320 >> 2], d = he + a | 0, E = t[T + 6192 >> 2], Mr = d + E | 0, a = d >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = a + t[T + 6196 >> 2] | 0, E = E >>> 0 > Mr >>> 0 ? n + 1 | 0 : n, dr = (a | 0) == (E | 0) & d >>> 0 > Mr >>> 0 | a >>> 0 > E >>> 0, n = tr + 8 | 0, tr = t[n >> 2], L = t[n + 4 >> 2], he = (a | 0) == ($r | 0) & d >>> 0 < he >>> 0 | a >>> 0 < $r >>> 0, n = Ir + 8 | 0, a = t[n >> 2], d = gr + 8 | 0, Ir = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, d = he + Ir | 0, n = (d >>> 0 < Ir >>> 0 ? n + 1 | 0 : n) + L | 0, a = d, d = d + tr | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + dr | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, gr = E, tr = d << 12 | E >>> 20, a = n, he = n << 12 | d >>> 20, ni = t[T + 6240 >> 2], d = t[T + 6304 >> 2], dr = ni + d | 0, yi = t[T + 6244 >> 2], n = yi + t[T + 6308 >> 2] | 0, n = d >>> 0 > dr >>> 0 ? n + 1 | 0 : n, d = t[T + 6160 >> 2], L = d + dr | 0, $r = n, n = n + t[T + 6164 >> 2] | 0, n = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, d = t[T + 6176 >> 2], E = d + L | 0, Ir = n, n = n + t[T + 6180 >> 2] | 0, d = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, n = d + he | 0, fi = T + 6128 | 0, Zn = fi, tr = E + tr | 0, he = tr >>> 0 < E >>> 0 ? n + 1 | 0 : n, jn = (d | 0) == (he | 0) & E >>> 0 > tr >>> 0 | d >>> 0 > he >>> 0, Un = (d | 0) == (Ir | 0) & E >>> 0 < L >>> 0 | d >>> 0 < Ir >>> 0, d = Xn + 8 | 0, kn = t[d >> 2], Wr = t[d + 4 >> 2], Bn = (Ir | 0) == ($r | 0) & L >>> 0 < dr >>> 0 | Ir >>> 0 < $r >>> 0, d = Oi + 8 | 0, Xn = t[d >> 2], Ir = t[d + 4 >> 2], L = ($r | 0) == (yi | 0) & dr >>> 0 < ni >>> 0 | $r >>> 0 < yi >>> 0, n = Ii + 8 | 0, E = t[n >> 2], d = Ti + 8 | 0, dr = E + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = E >>> 0 > dr >>> 0 ? n + 1 | 0 : n, d = L + dr | 0, n = (d >>> 0 < dr >>> 0 ? n + 1 | 0 : n) + Ir | 0, E = d, d = d + Xn | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d, d = d + Bn | 0, n = (E >>> 0 > d >>> 0 ? n + 1 | 0 : n) + Wr | 0, E = d, d = d + kn | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d + Un | 0, n = E >>> 0 < d >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + E | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + jn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = he, L = d << 12 | a >>> 20, E = n, Ir = n << 12 | d >>> 20, kn = t[T + 6148 >> 2], n = kn + t[T + 6260 >> 2] | 0, Wr = t[T + 6144 >> 2], d = t[T + 6256 >> 2], he = Wr + d | 0, dr = he, L = he + L | 0, d = d >>> 0 > he >>> 0 ? n + 1 | 0 : n, n = d + Ir | 0, Xn = L << 4 & -16, he = L >>> 0 < he >>> 0 ? n + 1 | 0 : n, $r = (he << 4 | L >>> 28) & 16777215, Ir = a, Ur(Zn, Xn | a >>> 16 & 15, $r, 0, 0, 977, 1, 0, 0), Zn = T + 6352 | 0, Ur(Zn, Ai, Xi, 0, 0, gn, Gn, 0, 0), Un = T + 6096 | 0, Ur(Un, xn, xr, 0, 0, cr, Be, 0, 0), Bn = T + 6272 | 0, Ur(Bn, or, Me, 0, 0, or, Me, 0, 0), Xn = T + 6080 | 0, $r = (d | 0) == (he | 0) & L >>> 0 < dr >>> 0 | d >>> 0 > he >>> 0, L = (d | 0) == (kn | 0) & dr >>> 0 < Wr >>> 0 | d >>> 0 < kn >>> 0, n = Bi + 8 | 0, a = t[n >> 2], d = ai + 8 | 0, dr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > dr >>> 0 ? n + 1 | 0 : n, a = L + dr | 0, n = a >>> 0 < dr >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, d = a + E | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + $r | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | he >>> 20, a = n, E = n << 12 | d >>> 20, $r = t[T + 6096 >> 2], d = t[T + 6272 >> 2], L = $r + d | 0, jn = t[T + 6100 >> 2], n = jn + t[T + 6276 >> 2] | 0, d = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, n = d + E | 0, he = L + he | 0, n = he >>> 0 < L >>> 0 ? n + 1 | 0 : n, E = n, Ur(Xn, he, n & 1048575, 0, 0, 15632, 16, 0, 0), kn = T + 6288 | 0, Ur(kn, cr, Be, 0, 0, gn, Gn, 0, 0), Wr = T + 6336 | 0, Ur(Wr, Ai, Xi, 0, 0, Ai, Xi, 0, 0), dr = T + 6032 | 0, Ur(dr, xn, xr, 0, 0, or, Me, 0, 0), gn = T + 6016 | 0, Me = gn, Be = (d | 0) == (n | 0) & L >>> 0 > he >>> 0 | d >>> 0 > n >>> 0, L = (d | 0) == (jn | 0) & L >>> 0 < $r >>> 0 | d >>> 0 < jn >>> 0, n = Bn + 8 | 0, he = t[n >> 2], d = Un + 8 | 0, or = he + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = he >>> 0 > or >>> 0 ? n + 1 | 0 : n, he = L + or | 0, n = he >>> 0 < or >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + he | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Be | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | E >>> 20, E = t[T + 6032 >> 2], Be = he + E | 0, a = n, d = n << 12 | d >>> 20, n = d + t[T + 6036 >> 2] | 0, n = E >>> 0 > Be >>> 0 ? n + 1 | 0 : n, Ur(Me, Be, n, 0, 0, 15632, 16, 0, 0), jn = T + 5952 | 0, L = jn, he = (d | 0) == (n | 0) & he >>> 0 > Be >>> 0 | d >>> 0 > n >>> 0, d = dr + 8 | 0, E = t[d >> 2], n = t[d + 4 >> 2], a = a >>> 20 | 0, d = a + E | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + he | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Ur(L, d, n, 0, 0, 64028672, 65536, 0, 0), a = t[T + 6128 >> 2], d = t[T + 6368 >> 2], L = a + d | 0, he = t[T + 6132 >> 2], n = he + t[T + 6372 >> 2] | 0, E = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, he = (he | 0) == (E | 0) & a >>> 0 > L >>> 0 | E >>> 0 < he >>> 0, n = wi + 8 | 0, a = t[n >> 2], d = fi + 8 | 0, Be = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, d = he + Be | 0, n = d >>> 0 < Be >>> 0 ? n + 1 | 0 : n, cr = E, he = d << 12 | E >>> 20, a = n, E = n << 12 | d >>> 20, Me = t[T + 6080 >> 2], d = t[T + 6352 >> 2], Be = Me + d | 0, dr = t[T + 6084 >> 2], n = dr + t[T + 6356 >> 2] | 0, d = d >>> 0 > Be >>> 0 ? n + 1 | 0 : n, n = d + E | 0, he = he + Be | 0, E = he >>> 0 < Be >>> 0 ? n + 1 | 0 : n, or = (d | 0) == (E | 0) & he >>> 0 < Be >>> 0 | d >>> 0 > E >>> 0, Me = (d | 0) == (dr | 0) & Be >>> 0 < Me >>> 0 | d >>> 0 < dr >>> 0, n = Zn + 8 | 0, Be = t[n >> 2], d = Xn + 8 | 0, dr = Be + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = Be >>> 0 > dr >>> 0 ? n + 1 | 0 : n, Be = Me + dr | 0, n = Be >>> 0 < dr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + Be | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + or | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, dr = E, Be = d << 12 | E >>> 20, a = n, E = n << 12 | d >>> 20, Bn = t[T + 6288 >> 2], d = t[T + 6336 >> 2], or = Bn + d | 0, Zn = t[T + 6292 >> 2], n = Zn + t[T + 6340 >> 2] | 0, n = d >>> 0 > or >>> 0 ? n + 1 | 0 : n, d = t[T + 6016 >> 2], Me = d + or | 0, xr = n, n = n + t[T + 6020 >> 2] | 0, d = d >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = d + E | 0, Un = T + 5936 | 0, Xn = Un, E = Be + Me | 0, Be = E >>> 0 < Me >>> 0 ? n + 1 | 0 : n, $r = (d | 0) == (Be | 0) & E >>> 0 < Me >>> 0 | d >>> 0 > Be >>> 0, xn = (d | 0) == (xr | 0) & Me >>> 0 < or >>> 0 | d >>> 0 < xr >>> 0, d = gn + 8 | 0, Gn = t[d >> 2], gn = t[d + 4 >> 2], or = (xr | 0) == (Zn | 0) & or >>> 0 < Bn >>> 0 | xr >>> 0 < Zn >>> 0, n = Wr + 8 | 0, Me = t[n >> 2], d = kn + 8 | 0, xr = Me + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = Me >>> 0 > xr >>> 0 ? n + 1 | 0 : n, d = or + xr | 0, n = (d >>> 0 < xr >>> 0 ? n + 1 | 0 : n) + gn | 0, or = d, d = d + Gn | 0, n = or >>> 0 > d >>> 0 ? n + 1 | 0 : n, Me = d + xn | 0, n = Me >>> 0 < d >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + Me | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + $r | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Me = Be, or = d << 12 | Be >>> 20, a = n, xr = n << 12 | d >>> 20, Zn = t[T + 5956 >> 2], n = Zn + (gr & 1048575) | 0, Bn = t[T + 5952 >> 2], d = Mr & -2, Be = Bn + d | 0, gr = Be, or = Be + or | 0, d = d >>> 0 > Be >>> 0 ? n + 1 | 0 : n, n = d + xr | 0, Be = or >>> 0 < Be >>> 0 ? n + 1 | 0 : n, xr = Be & 1048575, n = cr & 1048575, fi = n, cr = L, n = n << 1 | L >>> 31, Gn = L << 1, xn = n, Ur(Xn, or, xr, 0, 0, Gn, n, 0, 0), n = dr & 1048575, Ai = n, kn = T + 5968 | 0, Mr = Me & 1048575, L = he << 1, Xn = he, Me = n << 1 | he >>> 31, Ur(kn, E, Mr, 0, 0, L, Me, 0, 0), Wr = T + 5872 | 0, $r = Wr, gn = Ir & 65535, Ir = (d | 0) == (Be | 0) & or >>> 0 < gr >>> 0 | d >>> 0 > Be >>> 0, dr = (d | 0) == (Zn | 0) & gr >>> 0 < Bn >>> 0 | d >>> 0 < Zn >>> 0, d = jn + 8 | 0, he = dr + t[d >> 2] | 0, n = t[d + 4 >> 2], n = he >>> 0 < dr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + he | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Ir | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | Be >>> 20, a = he + tr | 0, n = gn + (n << 12 | d >>> 20) | 0, n = a >>> 0 < he >>> 0 ? n + 1 | 0 : n, Ur($r, a, n, 0, 0, a, n, 0, 0), tr = T + 5856 | 0, Ur(tr, t[T + 5872 >> 2], t[T + 5876 >> 2], 0, 0, 15632, 16, 0, 0), d = a, n = n << 1 | d >>> 31, Oi = T + 5824 | 0, $r = d << 1, gn = n, Ur(Oi, $r, n, 0, 0, cr, fi, 0, 0), Ti = T + 5920 | 0, Ur(Ti, or, xr, 0, 0, L, Me, 0, 0), Ii = T + 5984 | 0, Ur(Ii, E, Mr, 0, 0, E, Mr, 0, 0), Bn = T + 5840 | 0, d = Wr + 8 | 0, Ur(Bn, t[d >> 2], t[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), wi = T + 6112 | 0, Ur(wi, cr, fi, 0, 0, cr, fi, 0, 0), ai = T + 5808 | 0, Ur(ai, $r, n, 0, 0, Xn, Ai, 0, 0), Bi = T + 5888 | 0, Me = xr, Be = Mr, xr = E, Ur(Bi, or, Me, 0, 0, E << 1, Be << 1 | E >>> 31, 0, 0), he = t[T + 5936 >> 2], a = t[T + 5968 >> 2], d = he + a | 0, cr = t[T + 5940 >> 2], n = cr + t[T + 5972 >> 2] | 0, n = d >>> 0 < a >>> 0 ? n + 1 | 0 : n, a = t[T + 5856 >> 2], Mr = a + d | 0, E = n, n = n + t[T + 5860 >> 2] | 0, a = a >>> 0 > Mr >>> 0 ? n + 1 | 0 : n, dr = (E | 0) == (a | 0) & d >>> 0 > Mr >>> 0 | a >>> 0 < E >>> 0, n = tr + 8 | 0, tr = t[n >> 2], L = t[n + 4 >> 2], he = (E | 0) == (cr | 0) & d >>> 0 < he >>> 0 | E >>> 0 < cr >>> 0, n = kn + 8 | 0, E = t[n >> 2], d = Un + 8 | 0, cr = E + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = E >>> 0 > cr >>> 0 ? n + 1 | 0 : n, d = he + cr | 0, n = (d >>> 0 < cr >>> 0 ? n + 1 | 0 : n) + L | 0, E = d, d = d + tr | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d, d = d + dr | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, gr = a, tr = d << 12 | a >>> 20, E = n, he = n << 12 | d >>> 20, ni = t[T + 5920 >> 2], d = t[T + 5984 >> 2], cr = ni + d | 0, yi = t[T + 5924 >> 2], n = yi + t[T + 5988 >> 2] | 0, n = d >>> 0 > cr >>> 0 ? n + 1 | 0 : n, d = t[T + 5824 >> 2], dr = d + cr | 0, a = n, n = n + t[T + 5828 >> 2] | 0, n = d >>> 0 > dr >>> 0 ? n + 1 | 0 : n, d = t[T + 5840 >> 2], L = d + dr | 0, Ir = n, n = n + t[T + 5844 >> 2] | 0, d = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, n = d + he | 0, fi = T + 5712 | 0, Zn = fi, tr = L + tr | 0, he = tr >>> 0 < L >>> 0 ? n + 1 | 0 : n, jn = (d | 0) == (he | 0) & L >>> 0 > tr >>> 0 | d >>> 0 > he >>> 0, Un = (d | 0) == (Ir | 0) & L >>> 0 < dr >>> 0 | d >>> 0 < Ir >>> 0, d = Bn + 8 | 0, kn = t[d >> 2], Wr = t[d + 4 >> 2], Bn = (a | 0) == (Ir | 0) & cr >>> 0 > dr >>> 0 | a >>> 0 > Ir >>> 0, d = Oi + 8 | 0, Ir = t[d >> 2], dr = t[d + 4 >> 2], L = (a | 0) == (yi | 0) & cr >>> 0 < ni >>> 0 | a >>> 0 < yi >>> 0, n = Ii + 8 | 0, a = t[n >> 2], d = Ti + 8 | 0, cr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > cr >>> 0 ? n + 1 | 0 : n, d = L + cr | 0, n = (d >>> 0 < cr >>> 0 ? n + 1 | 0 : n) + dr | 0, a = d, d = d + Ir | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Bn | 0, n = (a >>> 0 > d >>> 0 ? n + 1 | 0 : n) + Wr | 0, a = d, d = d + kn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d + Un | 0, n = a >>> 0 < d >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, d = a + E | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + jn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = he, L = d << 12 | a >>> 20, E = n, he = n << 12 | d >>> 20, Wr = t[T + 5808 >> 2], d = t[T + 5888 >> 2], dr = Wr + d | 0, kn = t[T + 5812 >> 2], n = kn + t[T + 5892 >> 2] | 0, d = d >>> 0 > dr >>> 0 ? n + 1 | 0 : n, n = d + he | 0, L = L + dr | 0, n = L >>> 0 < dr >>> 0 ? n + 1 | 0 : n, Bn = L << 4 & -16, he = n, cr = (n << 4 | L >>> 28) & 16777215, Ir = a, Ur(Zn, Bn | a >>> 16 & 15, cr, 0, 0, 977, 1, 0, 0), Zn = T + 6048 | 0, Ur(Zn, Xn, Ai, 0, 0, Gn, xn, 0, 0), jn = T + 5792 | 0, Ur(jn, $r, gn, 0, 0, xr, Be, 0, 0), Un = T + 5904 | 0, Ur(Un, or, Me, 0, 0, or, Me, 0, 0), Bn = T + 5776 | 0, cr = (d | 0) == (n | 0) & L >>> 0 < dr >>> 0 | d >>> 0 > n >>> 0, L = (d | 0) == (kn | 0) & dr >>> 0 < Wr >>> 0 | d >>> 0 < kn >>> 0, n = Bi + 8 | 0, a = t[n >> 2], d = ai + 8 | 0, dr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > dr >>> 0 ? n + 1 | 0 : n, a = L + dr | 0, n = a >>> 0 < dr >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, d = a + E | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + cr | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | he >>> 20, a = n, E = n << 12 | d >>> 20, cr = t[T + 5792 >> 2], d = t[T + 5904 >> 2], L = cr + d | 0, ni = t[T + 5796 >> 2], n = ni + t[T + 5908 >> 2] | 0, d = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, n = d + E | 0, he = L + he | 0, n = he >>> 0 < L >>> 0 ? n + 1 | 0 : n, E = n, Ur(Bn, he, n & 1048575, 0, 0, 15632, 16, 0, 0), kn = T + 6e3 | 0, Ur(kn, xr, Be, 0, 0, Gn, xn, 0, 0), Wr = T + 6064 | 0, Ur(Wr, Xn, Ai, 0, 0, Xn, Ai, 0, 0), dr = T + 5760 | 0, Ur(dr, or, Me, 0, 0, $r, gn, 0, 0), gn = T + 5744 | 0, Me = gn, Be = (d | 0) == (n | 0) & L >>> 0 > he >>> 0 | d >>> 0 > n >>> 0, L = (d | 0) == (ni | 0) & L >>> 0 < cr >>> 0 | d >>> 0 < ni >>> 0, n = Un + 8 | 0, he = t[n >> 2], d = jn + 8 | 0, or = he + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = he >>> 0 > or >>> 0 ? n + 1 | 0 : n, he = L + or | 0, n = he >>> 0 < or >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + he | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Be | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | E >>> 20, E = t[T + 5760 >> 2], Be = he + E | 0, a = n, d = n << 12 | d >>> 20, n = d + t[T + 5764 >> 2] | 0, n = E >>> 0 > Be >>> 0 ? n + 1 | 0 : n, Ur(Me, Be, n, 0, 0, 15632, 16, 0, 0), jn = T + 5728 | 0, L = jn, he = (d | 0) == (n | 0) & he >>> 0 > Be >>> 0 | d >>> 0 > n >>> 0, d = dr + 8 | 0, E = t[d >> 2], n = t[d + 4 >> 2], a = a >>> 20 | 0, d = a + E | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + he | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Ur(L, d, n, 0, 0, 64028672, 65536, 0, 0), a = t[T + 5712 >> 2], d = t[T + 6112 >> 2], L = a + d | 0, he = t[T + 5716 >> 2], n = he + t[T + 6116 >> 2] | 0, E = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, he = (he | 0) == (E | 0) & a >>> 0 > L >>> 0 | E >>> 0 < he >>> 0, n = wi + 8 | 0, a = t[n >> 2], d = fi + 8 | 0, Be = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, d = he + Be | 0, n = d >>> 0 < Be >>> 0 ? n + 1 | 0 : n, cr = E, he = d << 12 | E >>> 20, a = n, E = n << 12 | d >>> 20, Me = t[T + 5776 >> 2], d = t[T + 6048 >> 2], Be = Me + d | 0, dr = t[T + 5780 >> 2], n = dr + t[T + 6052 >> 2] | 0, d = d >>> 0 > Be >>> 0 ? n + 1 | 0 : n, n = d + E | 0, he = he + Be | 0, E = he >>> 0 < Be >>> 0 ? n + 1 | 0 : n, or = (d | 0) == (E | 0) & he >>> 0 < Be >>> 0 | d >>> 0 > E >>> 0, Me = (d | 0) == (dr | 0) & Be >>> 0 < Me >>> 0 | d >>> 0 < dr >>> 0, n = Zn + 8 | 0, Be = t[n >> 2], d = Bn + 8 | 0, dr = Be + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = Be >>> 0 > dr >>> 0 ? n + 1 | 0 : n, Be = Me + dr | 0, n = Be >>> 0 < dr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + Be | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + or | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, dr = E, Be = d << 12 | E >>> 20, a = n, E = n << 12 | d >>> 20, Bn = t[T + 6e3 >> 2], d = t[T + 6064 >> 2], or = Bn + d | 0, Zn = t[T + 6004 >> 2], n = Zn + t[T + 6068 >> 2] | 0, n = d >>> 0 > or >>> 0 ? n + 1 | 0 : n, d = t[T + 5744 >> 2], Me = d + or | 0, xr = n, n = n + t[T + 5748 >> 2] | 0, d = d >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = d + E | 0, Un = T + 5632 | 0, Xn = Un, E = Be + Me | 0, Be = E >>> 0 < Me >>> 0 ? n + 1 | 0 : n, $r = (d | 0) == (Be | 0) & E >>> 0 < Me >>> 0 | d >>> 0 > Be >>> 0, xn = (d | 0) == (xr | 0) & Me >>> 0 < or >>> 0 | d >>> 0 < xr >>> 0, d = gn + 8 | 0, Gn = t[d >> 2], gn = t[d + 4 >> 2], or = (xr | 0) == (Zn | 0) & or >>> 0 < Bn >>> 0 | xr >>> 0 < Zn >>> 0, n = Wr + 8 | 0, Me = t[n >> 2], d = kn + 8 | 0, xr = Me + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = Me >>> 0 > xr >>> 0 ? n + 1 | 0 : n, d = or + xr | 0, n = (d >>> 0 < xr >>> 0 ? n + 1 | 0 : n) + gn | 0, or = d, d = d + Gn | 0, n = or >>> 0 > d >>> 0 ? n + 1 | 0 : n, Me = d + xn | 0, n = Me >>> 0 < d >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + Me | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + $r | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Me = Be, or = d << 12 | Be >>> 20, a = n, xr = n << 12 | d >>> 20, Zn = t[T + 5732 >> 2], n = Zn + (gr & 1048575) | 0, Bn = t[T + 5728 >> 2], d = Mr & -2, Be = Bn + d | 0, gr = Be, or = Be + or | 0, d = d >>> 0 > Be >>> 0 ? n + 1 | 0 : n, n = d + xr | 0, Be = or >>> 0 < Be >>> 0 ? n + 1 | 0 : n, $r = Be & 1048575, Mr = $r, n = cr & 1048575, fi = n, cr = L, n = n << 1 | L >>> 31, gn = L << 1, Gn = n, Ur(Xn, or, Mr, 0, 0, gn, n, 0, 0), n = dr & 1048575, Ai = n, kn = T + 5584 | 0, Mr = Me & 1048575, L = he << 1, Xn = he, Me = n << 1 | he >>> 31, Ur(kn, E, Mr, 0, 0, L, Me, 0, 0), Wr = T + 5536 | 0, xr = Ir & 65535, Ir = (d | 0) == (Be | 0) & or >>> 0 < gr >>> 0 | d >>> 0 > Be >>> 0, dr = (d | 0) == (Zn | 0) & gr >>> 0 < Bn >>> 0 | d >>> 0 < Zn >>> 0, d = jn + 8 | 0, he = dr + t[d >> 2] | 0, n = t[d + 4 >> 2], n = he >>> 0 < dr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + he | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Ir | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | Be >>> 20, a = he + tr | 0, n = xr + (n << 12 | d >>> 20) | 0, n = a >>> 0 < he >>> 0 ? n + 1 | 0 : n, Ur(Wr, a, n, 0, 0, a, n, 0, 0), tr = T + 5520 | 0, Ur(tr, t[T + 5536 >> 2], t[T + 5540 >> 2], 0, 0, 15632, 16, 0, 0), d = a, n = n << 1 | d >>> 31, Oi = T + 5488 | 0, xn = d << 1, xr = n, Ur(Oi, xn, n, 0, 0, cr, fi, 0, 0), Ti = T + 5568 | 0, Ur(Ti, or, $r, 0, 0, L, Me, 0, 0), Ii = T + 5680 | 0, Ur(Ii, E, Mr, 0, 0, E, Mr, 0, 0), Bn = T + 5504 | 0, d = Wr + 8 | 0, Ur(Bn, t[d >> 2], t[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), wi = T + 5648 | 0, Ur(wi, cr, fi, 0, 0, cr, fi, 0, 0), ai = T + 5472 | 0, Ur(ai, xn, n, 0, 0, Xn, Ai, 0, 0), Bi = T + 5552 | 0, Ir = or, cr = $r, Be = Mr, Mr = E, Ur(Bi, or, cr, 0, 0, E << 1, Be << 1 | E >>> 31, 0, 0), he = t[T + 5632 >> 2], a = t[T + 5584 >> 2], d = he + a | 0, or = t[T + 5636 >> 2], n = or + t[T + 5588 >> 2] | 0, n = d >>> 0 < a >>> 0 ? n + 1 | 0 : n, a = t[T + 5520 >> 2], dr = a + d | 0, E = n, n = n + t[T + 5524 >> 2] | 0, a = a >>> 0 > dr >>> 0 ? n + 1 | 0 : n, Me = (E | 0) == (a | 0) & d >>> 0 > dr >>> 0 | a >>> 0 < E >>> 0, n = tr + 8 | 0, tr = t[n >> 2], L = t[n + 4 >> 2], he = (E | 0) == (or | 0) & d >>> 0 < he >>> 0 | E >>> 0 < or >>> 0, n = kn + 8 | 0, E = t[n >> 2], d = Un + 8 | 0, or = E + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = E >>> 0 > or >>> 0 ? n + 1 | 0 : n, d = he + or | 0, n = (d >>> 0 < or >>> 0 ? n + 1 | 0 : n) + L | 0, E = d, d = d + tr | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d, d = d + Me | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, or = a, L = d << 12 | a >>> 20, E = n, he = n << 12 | d >>> 20, ni = t[T + 5568 >> 2], d = t[T + 5680 >> 2], gr = ni + d | 0, yi = t[T + 5572 >> 2], n = yi + t[T + 5684 >> 2] | 0, n = d >>> 0 > gr >>> 0 ? n + 1 | 0 : n, d = t[T + 5488 >> 2], Me = d + gr | 0, a = n, n = n + t[T + 5492 >> 2] | 0, n = d >>> 0 > Me >>> 0 ? n + 1 | 0 : n, d = t[T + 5504 >> 2], tr = d + Me | 0, $r = n, n = n + t[T + 5508 >> 2] | 0, d = d >>> 0 > tr >>> 0 ? n + 1 | 0 : n, n = d + he | 0, fi = T + 5376 | 0, Zn = fi, he = L + tr | 0, L = he >>> 0 < tr >>> 0 ? n + 1 | 0 : n, jn = (d | 0) == (L | 0) & he >>> 0 < tr >>> 0 | d >>> 0 > L >>> 0, Un = (d | 0) == ($r | 0) & Me >>> 0 > tr >>> 0 | d >>> 0 < $r >>> 0, d = Bn + 8 | 0, kn = t[d >> 2], Wr = t[d + 4 >> 2], Bn = (a | 0) == ($r | 0) & Me >>> 0 < gr >>> 0 | a >>> 0 > $r >>> 0, d = Oi + 8 | 0, $r = t[d >> 2], Me = t[d + 4 >> 2], tr = (a | 0) == (yi | 0) & gr >>> 0 < ni >>> 0 | a >>> 0 < yi >>> 0, n = Ii + 8 | 0, a = t[n >> 2], d = Ti + 8 | 0, gr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, d = tr + gr | 0, n = (d >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + Me | 0, a = d, d = d + $r | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Bn | 0, n = (a >>> 0 > d >>> 0 ? n + 1 | 0 : n) + Wr | 0, a = d, d = d + kn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d + Un | 0, n = a >>> 0 < d >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, d = a + E | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + jn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = L, tr = d << 12 | a >>> 20, E = n, L = n << 12 | d >>> 20, Wr = t[T + 5472 >> 2], d = t[T + 5552 >> 2], gr = Wr + d | 0, ni = t[T + 5476 >> 2], n = ni + t[T + 5556 >> 2] | 0, d = d >>> 0 > gr >>> 0 ? n + 1 | 0 : n, n = d + L | 0, tr = tr + gr | 0, n = tr >>> 0 < gr >>> 0 ? n + 1 | 0 : n, Bn = tr << 4 & -16, L = n, $r = (n << 4 | tr >>> 28) & 16777215, Me = a, Ur(Zn, Bn | a >>> 16 & 15, $r, 0, 0, 977, 1, 0, 0), Zn = T + 5616 | 0, Ur(Zn, Xn, Ai, 0, 0, gn, Gn, 0, 0), jn = T + 5456 | 0, Ur(jn, xn, xr, 0, 0, Mr, Be, 0, 0), Un = T + 5696 | 0, Ur(Un, Ir, cr, 0, 0, Ir, cr, 0, 0), kn = T + 5440 | 0, Bn = kn, $r = (d | 0) == (n | 0) & tr >>> 0 < gr >>> 0 | d >>> 0 > n >>> 0, tr = (d | 0) == (ni | 0) & gr >>> 0 < Wr >>> 0 | d >>> 0 < ni >>> 0, n = Bi + 8 | 0, a = t[n >> 2], d = ai + 8 | 0, gr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = tr + gr | 0, n = a >>> 0 < gr >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, d = a + E | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + $r | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d << 12 | L >>> 20, a = n, E = n << 12 | d >>> 20, $r = t[T + 5456 >> 2], d = t[T + 5696 >> 2], tr = $r + d | 0, ni = t[T + 5460 >> 2], n = ni + t[T + 5700 >> 2] | 0, d = d >>> 0 > tr >>> 0 ? n + 1 | 0 : n, n = d + E | 0, L = L + tr | 0, n = L >>> 0 < tr >>> 0 ? n + 1 | 0 : n, E = n, Ur(Bn, L, n & 1048575, 0, 0, 15632, 16, 0, 0), Wr = T + 5600 | 0, Ur(Wr, Mr, Be, 0, 0, gn, Gn, 0, 0), Bn = T + 5664 | 0, Ur(Bn, Xn, Ai, 0, 0, Xn, Ai, 0, 0), gr = T + 5424 | 0, Ur(gr, Ir, cr, 0, 0, xn, xr, 0, 0), Mr = T + 5408 | 0, cr = Mr, Be = (d | 0) == (n | 0) & L >>> 0 < tr >>> 0 | d >>> 0 > n >>> 0, tr = (d | 0) == (ni | 0) & tr >>> 0 < $r >>> 0 | d >>> 0 < ni >>> 0, n = Un + 8 | 0, L = t[n >> 2], d = jn + 8 | 0, Ir = L + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = L >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, L = tr + Ir | 0, n = L >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + L | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Be | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d << 12 | E >>> 20, E = t[T + 5424 >> 2], Be = L + E | 0, a = n, d = n << 12 | d >>> 20, n = d + t[T + 5428 >> 2] | 0, n = E >>> 0 > Be >>> 0 ? n + 1 | 0 : n, Ur(cr, Be, n, 0, 0, 15632, 16, 0, 0), $r = T + 5392 | 0, tr = $r, L = (d | 0) == (n | 0) & L >>> 0 > Be >>> 0 | d >>> 0 > n >>> 0, d = gr + 8 | 0, E = t[d >> 2], n = t[d + 4 >> 2], a = a >>> 20 | 0, d = a + E | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + L | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Ur(tr, d, n, 0, 0, 64028672, 65536, 0, 0), a = t[T + 5376 >> 2], d = t[T + 5648 >> 2], Be = a + d | 0, L = t[T + 5380 >> 2], n = L + t[T + 5652 >> 2] | 0, ni = T + 7496 | 0, jn = ni + 8 | 0, Ir = jn, E = d >>> 0 > Be >>> 0 ? n + 1 | 0 : n, L = (L | 0) == (E | 0) & a >>> 0 > Be >>> 0 | E >>> 0 < L >>> 0, n = wi + 8 | 0, a = t[n >> 2], d = fi + 8 | 0, tr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, d = L + tr | 0, n = d >>> 0 < tr >>> 0 ? n + 1 | 0 : n, tr = E, L = d << 12 | E >>> 20, a = n, E = n << 12 | d >>> 20, gr = t[T + 5440 >> 2], d = t[T + 5616 >> 2], cr = gr + d | 0, gn = t[T + 5444 >> 2], n = gn + t[T + 5620 >> 2] | 0, d = d >>> 0 > cr >>> 0 ? n + 1 | 0 : n, n = d + E | 0, L = L + cr | 0, n = L >>> 0 < cr >>> 0 ? n + 1 | 0 : n, t[Ir >> 2] = L, E = n, t[Ir + 4 >> 2] = n & 1048575, Un = ni + 16 | 0, xr = Un, Ir = (d | 0) == (n | 0) & L >>> 0 < cr >>> 0 | d >>> 0 > n >>> 0, cr = (d | 0) == (gn | 0) & cr >>> 0 < gr >>> 0 | d >>> 0 < gn >>> 0, n = Zn + 8 | 0, L = t[n >> 2], d = kn + 8 | 0, gr = L + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = L >>> 0 > gr >>> 0 ? n + 1 | 0 : n, L = cr + gr | 0, n = L >>> 0 < gr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + L | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Ir | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d << 12 | E >>> 20, a = n, E = n << 12 | d >>> 20, xn = t[T + 5600 >> 2], d = t[T + 5664 >> 2], Ir = xn + d | 0, kn = t[T + 5604 >> 2], n = kn + t[T + 5668 >> 2] | 0, n = d >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, d = t[T + 5408 >> 2], cr = d + Ir | 0, gr = n, n = n + t[T + 5412 >> 2] | 0, d = d >>> 0 > cr >>> 0 ? n + 1 | 0 : n, n = d + E | 0, L = L + cr | 0, n = L >>> 0 < cr >>> 0 ? n + 1 | 0 : n, t[xr >> 2] = L, E = n, t[xr + 4 >> 2] = n & 1048575, Xn = ni + 24 | 0, Gn = (d | 0) == (n | 0) & L >>> 0 < cr >>> 0 | d >>> 0 > n >>> 0, gn = (d | 0) == (gr | 0) & cr >>> 0 < Ir >>> 0 | d >>> 0 < gr >>> 0, d = Mr + 8 | 0, xr = t[d >> 2], Mr = t[d + 4 >> 2], cr = (gr | 0) == (kn | 0) & Ir >>> 0 < xn >>> 0 | gr >>> 0 < kn >>> 0, n = Bn + 8 | 0, L = t[n >> 2], d = Wr + 8 | 0, Ir = L + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = L >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, d = cr + Ir | 0, n = (d >>> 0 < Ir >>> 0 ? n + 1 | 0 : n) + Mr | 0, L = d, d = d + xr | 0, n = L >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d + gn | 0, n = L >>> 0 < d >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + L | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Gn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, cr = d << 12 | E >>> 20, a = n, L = n << 12 | d >>> 20, Ir = t[T + 5392 >> 2], E = dr & -2, d = Ir + E | 0, xr = t[T + 5396 >> 2], n = xr + (or & 1048575) | 0, dr = d >>> 0 < E >>> 0 ? n + 1 | 0 : n, n = dr + L | 0, or = d, E = d + cr | 0, t[Xn >> 2] = E, d = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, t[Xn + 4 >> 2] = d & 1048575, Mr = ni + 32 | 0, gr = Mr, L = he, cr = Me & 65535, Me = (d | 0) == (dr | 0) & E >>> 0 < or >>> 0 | d >>> 0 < dr >>> 0, E = (dr | 0) == (xr | 0) & or >>> 0 < Ir >>> 0 | dr >>> 0 < xr >>> 0, n = $r + 8 | 0, he = E + t[n >> 2] | 0, n = t[n + 4 >> 2], n = E >>> 0 > he >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, E = a, a = a + he | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, d = a << 12 | d >>> 20, E = d + L | 0, n = cr + (n << 12 | a >>> 20) | 0, t[gr >> 2] = E, t[gr + 4 >> 2] = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, t[T + 7496 >> 2] = Be, t[T + 7500 >> 2] = tr & 1048575, Xr(ni, ni, Zi), d = t[T + 7500 >> 2], Bn = d, $r = t[T + 7496 >> 2], L = $r, n = d << 1 | L >>> 31, gr = T + 5216 | 0, or = t[Xn >> 2], Me = t[Xn + 4 >> 2], gn = L << 1, Gn = n, Ur(gr, or, Me, 0, 0, gn, n, 0, 0), d = t[jn + 4 >> 2], Xi = d, Ai = t[jn >> 2], a = Ai, n = d << 1 | a >>> 31, Ir = T + 5312 | 0, cr = t[Un >> 2], Be = t[Un + 4 >> 2], a = a << 1, E = n, Ur(Ir, cr, Be, 0, 0, a, n, 0, 0), dr = T + 5200 | 0, he = t[Mr >> 2], d = t[Mr + 4 >> 2], Ur(dr, he, d, 0, 0, he, d, 0, 0), tr = T + 5184 | 0, Ur(tr, t[T + 5200 >> 2], t[T + 5204 >> 2], 0, 0, 15632, 16, 0, 0), n = d << 1 | he >>> 31, Oi = T + 5152 | 0, xn = he << 1, xr = n, Ur(Oi, xn, n, 0, 0, L, Bn, 0, 0), Ti = T + 5232 | 0, Ur(Ti, or, Me, 0, 0, a, E, 0, 0), Ii = T + 5296 | 0, Ur(Ii, cr, Be, 0, 0, cr, Be, 0, 0), Xn = T + 5168 | 0, d = dr + 8 | 0, Ur(Xn, t[d >> 2], t[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), wi = T + 5360 | 0, Ur(wi, L, Bn, 0, 0, L, Bn, 0, 0), ai = T + 5136 | 0, Ur(ai, xn, n, 0, 0, Ai, Xi, 0, 0), Bi = T + 5248 | 0, Ur(Bi, or, Me, 0, 0, cr << 1, Be << 1 | cr >>> 31, 0, 0), $r = t[T + 5220 >> 2], n = $r + t[T + 5316 >> 2] | 0, he = t[T + 5216 >> 2], a = t[T + 5312 >> 2], d = he + a | 0, E = t[T + 5184 >> 2], Mr = d + E | 0, a = d >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = a + t[T + 5188 >> 2] | 0, E = E >>> 0 > Mr >>> 0 ? n + 1 | 0 : n, dr = (a | 0) == (E | 0) & d >>> 0 > Mr >>> 0 | a >>> 0 > E >>> 0, n = tr + 8 | 0, tr = t[n >> 2], L = t[n + 4 >> 2], he = (a | 0) == ($r | 0) & d >>> 0 < he >>> 0 | a >>> 0 < $r >>> 0, n = Ir + 8 | 0, a = t[n >> 2], d = gr + 8 | 0, Ir = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, d = he + Ir | 0, n = (d >>> 0 < Ir >>> 0 ? n + 1 | 0 : n) + L | 0, a = d, d = d + tr | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + dr | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, gr = E, tr = d << 12 | E >>> 20, a = n, he = n << 12 | d >>> 20, ni = t[T + 5232 >> 2], d = t[T + 5296 >> 2], dr = ni + d | 0, yi = t[T + 5236 >> 2], n = yi + t[T + 5300 >> 2] | 0, n = d >>> 0 > dr >>> 0 ? n + 1 | 0 : n, d = t[T + 5152 >> 2], L = d + dr | 0, $r = n, n = n + t[T + 5156 >> 2] | 0, n = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, d = t[T + 5168 >> 2], E = d + L | 0, Ir = n, n = n + t[T + 5172 >> 2] | 0, d = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, n = d + he | 0, fi = T + 5120 | 0, Zn = fi, tr = E + tr | 0, he = tr >>> 0 < E >>> 0 ? n + 1 | 0 : n, jn = (d | 0) == (he | 0) & E >>> 0 > tr >>> 0 | d >>> 0 > he >>> 0, Un = (d | 0) == (Ir | 0) & E >>> 0 < L >>> 0 | d >>> 0 < Ir >>> 0, d = Xn + 8 | 0, kn = t[d >> 2], Wr = t[d + 4 >> 2], Bn = (Ir | 0) == ($r | 0) & L >>> 0 < dr >>> 0 | Ir >>> 0 < $r >>> 0, d = Oi + 8 | 0, Xn = t[d >> 2], Ir = t[d + 4 >> 2], L = ($r | 0) == (yi | 0) & dr >>> 0 < ni >>> 0 | $r >>> 0 < yi >>> 0, n = Ii + 8 | 0, E = t[n >> 2], d = Ti + 8 | 0, dr = E + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = E >>> 0 > dr >>> 0 ? n + 1 | 0 : n, d = L + dr | 0, n = (d >>> 0 < dr >>> 0 ? n + 1 | 0 : n) + Ir | 0, E = d, d = d + Xn | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d, d = d + Bn | 0, n = (E >>> 0 > d >>> 0 ? n + 1 | 0 : n) + Wr | 0, E = d, d = d + kn | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d + Un | 0, n = E >>> 0 < d >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + E | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + jn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = he, L = d << 12 | a >>> 20, E = n, he = n << 12 | d >>> 20, Wr = t[T + 5136 >> 2], d = t[T + 5248 >> 2], dr = Wr + d | 0, kn = t[T + 5140 >> 2], n = kn + t[T + 5252 >> 2] | 0, d = d >>> 0 > dr >>> 0 ? n + 1 | 0 : n, n = d + he | 0, L = L + dr | 0, n = L >>> 0 < dr >>> 0 ? n + 1 | 0 : n, Xn = L << 4 & -16, he = n, $r = (n << 4 | L >>> 28) & 16777215, Ir = a, Ur(Zn, Xn | a >>> 16 & 15, $r, 0, 0, 977, 1, 0, 0), Zn = T + 5344 | 0, Ur(Zn, Ai, Xi, 0, 0, gn, Gn, 0, 0), Un = T + 5088 | 0, Ur(Un, xn, xr, 0, 0, cr, Be, 0, 0), Bn = T + 5264 | 0, Ur(Bn, or, Me, 0, 0, or, Me, 0, 0), Xn = T + 5072 | 0, $r = (d | 0) == (n | 0) & L >>> 0 < dr >>> 0 | d >>> 0 > n >>> 0, L = (d | 0) == (kn | 0) & dr >>> 0 < Wr >>> 0 | d >>> 0 < kn >>> 0, n = Bi + 8 | 0, a = t[n >> 2], d = ai + 8 | 0, dr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > dr >>> 0 ? n + 1 | 0 : n, a = L + dr | 0, n = a >>> 0 < dr >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, d = a + E | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + $r | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | he >>> 20, a = n, E = n << 12 | d >>> 20, $r = t[T + 5088 >> 2], d = t[T + 5264 >> 2], L = $r + d | 0, jn = t[T + 5092 >> 2], n = jn + t[T + 5268 >> 2] | 0, d = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, n = d + E | 0, he = L + he | 0, n = he >>> 0 < L >>> 0 ? n + 1 | 0 : n, E = n, Ur(Xn, he, n & 1048575, 0, 0, 15632, 16, 0, 0), kn = T + 5280 | 0, Ur(kn, cr, Be, 0, 0, gn, Gn, 0, 0), Wr = T + 5328 | 0, Ur(Wr, Ai, Xi, 0, 0, Ai, Xi, 0, 0), dr = T + 5024 | 0, Ur(dr, xn, xr, 0, 0, or, Me, 0, 0), gn = T + 5008 | 0, Me = gn, Be = (d | 0) == (n | 0) & L >>> 0 > he >>> 0 | d >>> 0 > n >>> 0, L = (d | 0) == (jn | 0) & L >>> 0 < $r >>> 0 | d >>> 0 < jn >>> 0, n = Bn + 8 | 0, he = t[n >> 2], d = Un + 8 | 0, or = he + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = he >>> 0 > or >>> 0 ? n + 1 | 0 : n, he = L + or | 0, n = he >>> 0 < or >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + he | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Be | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | E >>> 20, E = t[T + 5024 >> 2], Be = he + E | 0, a = n, d = n << 12 | d >>> 20, n = d + t[T + 5028 >> 2] | 0, n = E >>> 0 > Be >>> 0 ? n + 1 | 0 : n, Ur(Me, Be, n, 0, 0, 15632, 16, 0, 0), jn = T + 4944 | 0, L = jn, he = (d | 0) == (n | 0) & he >>> 0 > Be >>> 0 | d >>> 0 > n >>> 0, d = dr + 8 | 0, E = t[d >> 2], n = t[d + 4 >> 2], a = a >>> 20 | 0, d = a + E | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + he | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Ur(L, d, n, 0, 0, 64028672, 65536, 0, 0), a = t[T + 5120 >> 2], d = t[T + 5360 >> 2], L = a + d | 0, he = t[T + 5124 >> 2], n = he + t[T + 5364 >> 2] | 0, E = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, he = (he | 0) == (E | 0) & a >>> 0 > L >>> 0 | E >>> 0 < he >>> 0, n = wi + 8 | 0, a = t[n >> 2], d = fi + 8 | 0, Be = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, d = he + Be | 0, n = d >>> 0 < Be >>> 0 ? n + 1 | 0 : n, cr = E, he = d << 12 | E >>> 20, a = n, E = n << 12 | d >>> 20, Me = t[T + 5072 >> 2], d = t[T + 5344 >> 2], Be = Me + d | 0, dr = t[T + 5076 >> 2], n = dr + t[T + 5348 >> 2] | 0, d = d >>> 0 > Be >>> 0 ? n + 1 | 0 : n, n = d + E | 0, he = he + Be | 0, E = he >>> 0 < Be >>> 0 ? n + 1 | 0 : n, or = (d | 0) == (E | 0) & he >>> 0 < Be >>> 0 | d >>> 0 > E >>> 0, Me = (d | 0) == (dr | 0) & Be >>> 0 < Me >>> 0 | d >>> 0 < dr >>> 0, n = Zn + 8 | 0, Be = t[n >> 2], d = Xn + 8 | 0, dr = Be + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = Be >>> 0 > dr >>> 0 ? n + 1 | 0 : n, Be = Me + dr | 0, n = Be >>> 0 < dr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + Be | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + or | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, dr = E, Be = d << 12 | E >>> 20, a = n, E = n << 12 | d >>> 20, Bn = t[T + 5280 >> 2], d = t[T + 5328 >> 2], or = Bn + d | 0, Zn = t[T + 5284 >> 2], n = Zn + t[T + 5332 >> 2] | 0, n = d >>> 0 > or >>> 0 ? n + 1 | 0 : n, d = t[T + 5008 >> 2], Me = d + or | 0, xr = n, n = n + t[T + 5012 >> 2] | 0, d = d >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = d + E | 0, Un = T + 4928 | 0, Xn = Un, E = Be + Me | 0, Be = E >>> 0 < Me >>> 0 ? n + 1 | 0 : n, $r = (d | 0) == (Be | 0) & E >>> 0 < Me >>> 0 | d >>> 0 > Be >>> 0, xn = (d | 0) == (xr | 0) & Me >>> 0 < or >>> 0 | d >>> 0 < xr >>> 0, d = gn + 8 | 0, Gn = t[d >> 2], gn = t[d + 4 >> 2], or = (xr | 0) == (Zn | 0) & or >>> 0 < Bn >>> 0 | xr >>> 0 < Zn >>> 0, n = Wr + 8 | 0, Me = t[n >> 2], d = kn + 8 | 0, xr = Me + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = Me >>> 0 > xr >>> 0 ? n + 1 | 0 : n, d = or + xr | 0, n = (d >>> 0 < xr >>> 0 ? n + 1 | 0 : n) + gn | 0, or = d, d = d + Gn | 0, n = or >>> 0 > d >>> 0 ? n + 1 | 0 : n, Me = d + xn | 0, n = Me >>> 0 < d >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + Me | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + $r | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Me = Be, or = d << 12 | Be >>> 20, a = n, xr = n << 12 | d >>> 20, Zn = t[T + 4948 >> 2], n = Zn + (gr & 1048575) | 0, Bn = t[T + 4944 >> 2], d = Mr & -2, Be = Bn + d | 0, gr = Be, or = Be + or | 0, d = d >>> 0 > Be >>> 0 ? n + 1 | 0 : n, n = d + xr | 0, Be = or >>> 0 < Be >>> 0 ? n + 1 | 0 : n, xr = Be & 1048575, n = cr & 1048575, fi = n, cr = L, n = n << 1 | L >>> 31, Gn = L << 1, xn = n, Ur(Xn, or, xr, 0, 0, Gn, n, 0, 0), n = dr & 1048575, Ai = n, kn = T + 4960 | 0, Mr = Me & 1048575, L = he << 1, Xn = he, Me = n << 1 | he >>> 31, Ur(kn, E, Mr, 0, 0, L, Me, 0, 0), Wr = T + 4864 | 0, $r = Wr, gn = Ir & 65535, Ir = (d | 0) == (Be | 0) & or >>> 0 < gr >>> 0 | d >>> 0 > Be >>> 0, dr = (d | 0) == (Zn | 0) & gr >>> 0 < Bn >>> 0 | d >>> 0 < Zn >>> 0, d = jn + 8 | 0, he = dr + t[d >> 2] | 0, n = t[d + 4 >> 2], n = he >>> 0 < dr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + he | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Ir | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | Be >>> 20, a = he + tr | 0, n = gn + (n << 12 | d >>> 20) | 0, n = a >>> 0 < he >>> 0 ? n + 1 | 0 : n, Ur($r, a, n, 0, 0, a, n, 0, 0), tr = T + 4848 | 0, Ur(tr, t[T + 4864 >> 2], t[T + 4868 >> 2], 0, 0, 15632, 16, 0, 0), d = a, n = n << 1 | d >>> 31, Oi = T + 4816 | 0, $r = d << 1, gn = n, Ur(Oi, $r, n, 0, 0, cr, fi, 0, 0), Ti = T + 4912 | 0, Ur(Ti, or, xr, 0, 0, L, Me, 0, 0), Ii = T + 4976 | 0, Ur(Ii, E, Mr, 0, 0, E, Mr, 0, 0), Bn = T + 4832 | 0, d = Wr + 8 | 0, Ur(Bn, t[d >> 2], t[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), wi = T + 5104 | 0, Ur(wi, cr, fi, 0, 0, cr, fi, 0, 0), ai = T + 4800 | 0, Ur(ai, $r, n, 0, 0, Xn, Ai, 0, 0), Bi = T + 4880 | 0, Me = xr, Be = Mr, xr = E, Ur(Bi, or, Me, 0, 0, E << 1, Be << 1 | E >>> 31, 0, 0), he = t[T + 4928 >> 2], a = t[T + 4960 >> 2], d = he + a | 0, cr = t[T + 4932 >> 2], n = cr + t[T + 4964 >> 2] | 0, n = d >>> 0 < a >>> 0 ? n + 1 | 0 : n, a = t[T + 4848 >> 2], Mr = a + d | 0, E = n, n = n + t[T + 4852 >> 2] | 0, a = a >>> 0 > Mr >>> 0 ? n + 1 | 0 : n, dr = (E | 0) == (a | 0) & d >>> 0 > Mr >>> 0 | a >>> 0 < E >>> 0, n = tr + 8 | 0, tr = t[n >> 2], L = t[n + 4 >> 2], he = (E | 0) == (cr | 0) & d >>> 0 < he >>> 0 | E >>> 0 < cr >>> 0, n = kn + 8 | 0, E = t[n >> 2], d = Un + 8 | 0, cr = E + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = E >>> 0 > cr >>> 0 ? n + 1 | 0 : n, d = he + cr | 0, n = (d >>> 0 < cr >>> 0 ? n + 1 | 0 : n) + L | 0, E = d, d = d + tr | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d, d = d + dr | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, gr = a, tr = d << 12 | a >>> 20, E = n, he = n << 12 | d >>> 20, ni = t[T + 4912 >> 2], d = t[T + 4976 >> 2], cr = ni + d | 0, yi = t[T + 4916 >> 2], n = yi + t[T + 4980 >> 2] | 0, n = d >>> 0 > cr >>> 0 ? n + 1 | 0 : n, d = t[T + 4816 >> 2], dr = d + cr | 0, a = n, n = n + t[T + 4820 >> 2] | 0, n = d >>> 0 > dr >>> 0 ? n + 1 | 0 : n, d = t[T + 4832 >> 2], L = d + dr | 0, Ir = n, n = n + t[T + 4836 >> 2] | 0, d = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, n = d + he | 0, fi = T + 4704 | 0, Zn = fi, tr = L + tr | 0, he = tr >>> 0 < L >>> 0 ? n + 1 | 0 : n, jn = (d | 0) == (he | 0) & L >>> 0 > tr >>> 0 | d >>> 0 > he >>> 0, Un = (d | 0) == (Ir | 0) & L >>> 0 < dr >>> 0 | d >>> 0 < Ir >>> 0, d = Bn + 8 | 0, kn = t[d >> 2], Wr = t[d + 4 >> 2], Bn = (a | 0) == (Ir | 0) & cr >>> 0 > dr >>> 0 | a >>> 0 > Ir >>> 0, d = Oi + 8 | 0, Ir = t[d >> 2], dr = t[d + 4 >> 2], L = (a | 0) == (yi | 0) & cr >>> 0 < ni >>> 0 | a >>> 0 < yi >>> 0, n = Ii + 8 | 0, a = t[n >> 2], d = Ti + 8 | 0, cr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > cr >>> 0 ? n + 1 | 0 : n, d = L + cr | 0, n = (d >>> 0 < cr >>> 0 ? n + 1 | 0 : n) + dr | 0, a = d, d = d + Ir | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Bn | 0, n = (a >>> 0 > d >>> 0 ? n + 1 | 0 : n) + Wr | 0, a = d, d = d + kn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d + Un | 0, n = a >>> 0 < d >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, d = a + E | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + jn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = he, L = d << 12 | a >>> 20, E = n, he = n << 12 | d >>> 20, Wr = t[T + 4800 >> 2], d = t[T + 4880 >> 2], dr = Wr + d | 0, kn = t[T + 4804 >> 2], n = kn + t[T + 4884 >> 2] | 0, d = d >>> 0 > dr >>> 0 ? n + 1 | 0 : n, n = d + he | 0, L = L + dr | 0, n = L >>> 0 < dr >>> 0 ? n + 1 | 0 : n, Bn = L << 4 & -16, he = n, cr = (n << 4 | L >>> 28) & 16777215, Ir = a, Ur(Zn, Bn | a >>> 16 & 15, cr, 0, 0, 977, 1, 0, 0), Zn = T + 5040 | 0, Ur(Zn, Xn, Ai, 0, 0, Gn, xn, 0, 0), jn = T + 4784 | 0, Ur(jn, $r, gn, 0, 0, xr, Be, 0, 0), Un = T + 4896 | 0, Ur(Un, or, Me, 0, 0, or, Me, 0, 0), Bn = T + 4768 | 0, cr = (d | 0) == (n | 0) & L >>> 0 < dr >>> 0 | d >>> 0 > n >>> 0, L = (d | 0) == (kn | 0) & dr >>> 0 < Wr >>> 0 | d >>> 0 < kn >>> 0, n = Bi + 8 | 0, a = t[n >> 2], d = ai + 8 | 0, dr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > dr >>> 0 ? n + 1 | 0 : n, a = L + dr | 0, n = a >>> 0 < dr >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, d = a + E | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + cr | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | he >>> 20, a = n, E = n << 12 | d >>> 20, cr = t[T + 4784 >> 2], d = t[T + 4896 >> 2], L = cr + d | 0, ni = t[T + 4788 >> 2], n = ni + t[T + 4900 >> 2] | 0, d = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, n = d + E | 0, he = L + he | 0, n = he >>> 0 < L >>> 0 ? n + 1 | 0 : n, E = n, Ur(Bn, he, n & 1048575, 0, 0, 15632, 16, 0, 0), kn = T + 4992 | 0, Ur(kn, xr, Be, 0, 0, Gn, xn, 0, 0), Wr = T + 5056 | 0, Ur(Wr, Xn, Ai, 0, 0, Xn, Ai, 0, 0), dr = T + 4752 | 0, Ur(dr, or, Me, 0, 0, $r, gn, 0, 0), gn = T + 4736 | 0, Me = gn, Be = (d | 0) == (n | 0) & L >>> 0 > he >>> 0 | d >>> 0 > n >>> 0, L = (d | 0) == (ni | 0) & L >>> 0 < cr >>> 0 | d >>> 0 < ni >>> 0, n = Un + 8 | 0, he = t[n >> 2], d = jn + 8 | 0, or = he + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = he >>> 0 > or >>> 0 ? n + 1 | 0 : n, he = L + or | 0, n = he >>> 0 < or >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + he | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Be | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | E >>> 20, E = t[T + 4752 >> 2], Be = he + E | 0, a = n, d = n << 12 | d >>> 20, n = d + t[T + 4756 >> 2] | 0, n = E >>> 0 > Be >>> 0 ? n + 1 | 0 : n, Ur(Me, Be, n, 0, 0, 15632, 16, 0, 0), jn = T + 4720 | 0, L = jn, he = (d | 0) == (n | 0) & he >>> 0 > Be >>> 0 | d >>> 0 > n >>> 0, d = dr + 8 | 0, E = t[d >> 2], n = t[d + 4 >> 2], a = a >>> 20 | 0, d = a + E | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + he | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Ur(L, d, n, 0, 0, 64028672, 65536, 0, 0), a = t[T + 4704 >> 2], d = t[T + 5104 >> 2], L = a + d | 0, he = t[T + 4708 >> 2], n = he + t[T + 5108 >> 2] | 0, E = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, he = (he | 0) == (E | 0) & a >>> 0 > L >>> 0 | E >>> 0 < he >>> 0, n = wi + 8 | 0, a = t[n >> 2], d = fi + 8 | 0, Be = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, d = he + Be | 0, n = d >>> 0 < Be >>> 0 ? n + 1 | 0 : n, cr = E, he = d << 12 | E >>> 20, a = n, or = n << 12 | d >>> 20, dr = t[T + 4772 >> 2], n = dr + t[T + 5044 >> 2] | 0, Me = t[T + 4768 >> 2], d = t[T + 5040 >> 2], E = Me + d | 0, Be = E, he = E + he | 0, d = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, n = d + or | 0, E = he >>> 0 < E >>> 0 ? n + 1 | 0 : n, or = (d | 0) == (E | 0) & he >>> 0 < Be >>> 0 | d >>> 0 > E >>> 0, Me = (d | 0) == (dr | 0) & Be >>> 0 < Me >>> 0 | d >>> 0 < dr >>> 0, n = Zn + 8 | 0, Be = t[n >> 2], d = Bn + 8 | 0, dr = Be + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = Be >>> 0 > dr >>> 0 ? n + 1 | 0 : n, Be = Me + dr | 0, n = Be >>> 0 < dr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + Be | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + or | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, dr = E, Be = d << 12 | E >>> 20, a = n, E = n << 12 | d >>> 20, Bn = t[T + 4992 >> 2], d = t[T + 5056 >> 2], or = Bn + d | 0, Zn = t[T + 4996 >> 2], n = Zn + t[T + 5060 >> 2] | 0, n = d >>> 0 > or >>> 0 ? n + 1 | 0 : n, d = t[T + 4736 >> 2], Me = d + or | 0, xr = n, n = n + t[T + 4740 >> 2] | 0, d = d >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = d + E | 0, Un = T + 4624 | 0, Xn = Un, E = Be + Me | 0, Be = E >>> 0 < Me >>> 0 ? n + 1 | 0 : n, $r = (d | 0) == (Be | 0) & E >>> 0 < Me >>> 0 | d >>> 0 > Be >>> 0, xn = (d | 0) == (xr | 0) & Me >>> 0 < or >>> 0 | d >>> 0 < xr >>> 0, d = gn + 8 | 0, Gn = t[d >> 2], gn = t[d + 4 >> 2], or = (xr | 0) == (Zn | 0) & or >>> 0 < Bn >>> 0 | xr >>> 0 < Zn >>> 0, n = Wr + 8 | 0, Me = t[n >> 2], d = kn + 8 | 0, xr = Me + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = Me >>> 0 > xr >>> 0 ? n + 1 | 0 : n, d = or + xr | 0, n = (d >>> 0 < xr >>> 0 ? n + 1 | 0 : n) + gn | 0, or = d, d = d + Gn | 0, n = or >>> 0 > d >>> 0 ? n + 1 | 0 : n, Me = d + xn | 0, n = Me >>> 0 < d >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + Me | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + $r | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Me = Be, xr = d << 12 | Be >>> 20, a = n, or = n << 12 | d >>> 20, Zn = t[T + 4724 >> 2], n = Zn + (gr & 1048575) | 0, Bn = t[T + 4720 >> 2], Be = Mr & -2, d = Bn + Be | 0, gr = d, d = d >>> 0 < Be >>> 0 ? n + 1 | 0 : n, n = d + or | 0, or = gr + xr | 0, Be = or >>> 0 < gr >>> 0 ? n + 1 | 0 : n, $r = Be & 1048575, Mr = $r, n = cr & 1048575, fi = n, cr = L, n = n << 1 | L >>> 31, gn = L << 1, Gn = n, Ur(Xn, or, Mr, 0, 0, gn, n, 0, 0), n = dr & 1048575, Ai = n, kn = T + 4576 | 0, Mr = Me & 1048575, L = he << 1, Xn = he, Me = n << 1 | he >>> 31, Ur(kn, E, Mr, 0, 0, L, Me, 0, 0), Wr = T + 4528 | 0, xr = Ir & 65535, Ir = (d | 0) == (Be | 0) & or >>> 0 < gr >>> 0 | d >>> 0 > Be >>> 0, dr = (d | 0) == (Zn | 0) & gr >>> 0 < Bn >>> 0 | d >>> 0 < Zn >>> 0, d = jn + 8 | 0, he = dr + t[d >> 2] | 0, n = t[d + 4 >> 2], n = he >>> 0 < dr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + he | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Ir | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | Be >>> 20, a = he + tr | 0, n = xr + (n << 12 | d >>> 20) | 0, n = a >>> 0 < he >>> 0 ? n + 1 | 0 : n, Ur(Wr, a, n, 0, 0, a, n, 0, 0), tr = T + 4512 | 0, Ur(tr, t[T + 4528 >> 2], t[T + 4532 >> 2], 0, 0, 15632, 16, 0, 0), d = a, n = n << 1 | d >>> 31, Oi = T + 4480 | 0, xn = d << 1, xr = n, Ur(Oi, xn, n, 0, 0, cr, fi, 0, 0), Ti = T + 4560 | 0, Ur(Ti, or, $r, 0, 0, L, Me, 0, 0), Ii = T + 4672 | 0, Ur(Ii, E, Mr, 0, 0, E, Mr, 0, 0), Bn = T + 4496 | 0, d = Wr + 8 | 0, Ur(Bn, t[d >> 2], t[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), wi = T + 4640 | 0, Ur(wi, cr, fi, 0, 0, cr, fi, 0, 0), ai = T + 4464 | 0, Ur(ai, xn, n, 0, 0, Xn, Ai, 0, 0), Bi = T + 4544 | 0, Ir = or, cr = $r, Be = Mr, Mr = E, Ur(Bi, or, cr, 0, 0, E << 1, Be << 1 | E >>> 31, 0, 0), he = t[T + 4624 >> 2], a = t[T + 4576 >> 2], d = he + a | 0, or = t[T + 4628 >> 2], n = or + t[T + 4580 >> 2] | 0, n = d >>> 0 < a >>> 0 ? n + 1 | 0 : n, a = t[T + 4512 >> 2], dr = a + d | 0, E = n, n = n + t[T + 4516 >> 2] | 0, a = a >>> 0 > dr >>> 0 ? n + 1 | 0 : n, Me = (E | 0) == (a | 0) & d >>> 0 > dr >>> 0 | a >>> 0 < E >>> 0, n = tr + 8 | 0, tr = t[n >> 2], L = t[n + 4 >> 2], he = (E | 0) == (or | 0) & d >>> 0 < he >>> 0 | E >>> 0 < or >>> 0, n = kn + 8 | 0, E = t[n >> 2], d = Un + 8 | 0, or = E + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = E >>> 0 > or >>> 0 ? n + 1 | 0 : n, d = he + or | 0, n = (d >>> 0 < or >>> 0 ? n + 1 | 0 : n) + L | 0, E = d, d = d + tr | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d, d = d + Me | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, or = a, L = d << 12 | a >>> 20, E = n, he = n << 12 | d >>> 20, ni = t[T + 4560 >> 2], d = t[T + 4672 >> 2], gr = ni + d | 0, yi = t[T + 4564 >> 2], n = yi + t[T + 4676 >> 2] | 0, n = d >>> 0 > gr >>> 0 ? n + 1 | 0 : n, d = t[T + 4480 >> 2], Me = d + gr | 0, a = n, n = n + t[T + 4484 >> 2] | 0, n = d >>> 0 > Me >>> 0 ? n + 1 | 0 : n, d = t[T + 4496 >> 2], tr = d + Me | 0, $r = n, n = n + t[T + 4500 >> 2] | 0, d = d >>> 0 > tr >>> 0 ? n + 1 | 0 : n, n = d + he | 0, fi = T + 4368 | 0, Zn = fi, he = L + tr | 0, L = he >>> 0 < tr >>> 0 ? n + 1 | 0 : n, jn = (d | 0) == (L | 0) & he >>> 0 < tr >>> 0 | d >>> 0 > L >>> 0, Un = (d | 0) == ($r | 0) & Me >>> 0 > tr >>> 0 | d >>> 0 < $r >>> 0, d = Bn + 8 | 0, kn = t[d >> 2], Wr = t[d + 4 >> 2], Bn = (a | 0) == ($r | 0) & Me >>> 0 < gr >>> 0 | a >>> 0 > $r >>> 0, d = Oi + 8 | 0, $r = t[d >> 2], Me = t[d + 4 >> 2], tr = (a | 0) == (yi | 0) & gr >>> 0 < ni >>> 0 | a >>> 0 < yi >>> 0, n = Ii + 8 | 0, a = t[n >> 2], d = Ti + 8 | 0, gr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, d = tr + gr | 0, n = (d >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + Me | 0, a = d, d = d + $r | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Bn | 0, n = (a >>> 0 > d >>> 0 ? n + 1 | 0 : n) + Wr | 0, a = d, d = d + kn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d + Un | 0, n = a >>> 0 < d >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, d = a + E | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + jn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = L, tr = d << 12 | a >>> 20, E = n, L = n << 12 | d >>> 20, Wr = t[T + 4464 >> 2], d = t[T + 4544 >> 2], gr = Wr + d | 0, ni = t[T + 4468 >> 2], n = ni + t[T + 4548 >> 2] | 0, d = d >>> 0 > gr >>> 0 ? n + 1 | 0 : n, n = d + L | 0, tr = tr + gr | 0, n = tr >>> 0 < gr >>> 0 ? n + 1 | 0 : n, Bn = tr << 4 & -16, L = n, $r = (n << 4 | tr >>> 28) & 16777215, Me = a, Ur(Zn, Bn | a >>> 16 & 15, $r, 0, 0, 977, 1, 0, 0), Zn = T + 4608 | 0, Ur(Zn, Xn, Ai, 0, 0, gn, Gn, 0, 0), jn = T + 4448 | 0, Ur(jn, xn, xr, 0, 0, Mr, Be, 0, 0), Un = T + 4688 | 0, Ur(Un, Ir, cr, 0, 0, Ir, cr, 0, 0), kn = T + 4432 | 0, Bn = kn, $r = (d | 0) == (n | 0) & tr >>> 0 < gr >>> 0 | d >>> 0 > n >>> 0, tr = (d | 0) == (ni | 0) & gr >>> 0 < Wr >>> 0 | d >>> 0 < ni >>> 0, n = Bi + 8 | 0, a = t[n >> 2], d = ai + 8 | 0, gr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = tr + gr | 0, n = a >>> 0 < gr >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, d = a + E | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + $r | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d << 12 | L >>> 20, a = n, E = n << 12 | d >>> 20, $r = t[T + 4448 >> 2], d = t[T + 4688 >> 2], tr = $r + d | 0, ni = t[T + 4452 >> 2], n = ni + t[T + 4692 >> 2] | 0, d = d >>> 0 > tr >>> 0 ? n + 1 | 0 : n, n = d + E | 0, L = L + tr | 0, n = L >>> 0 < tr >>> 0 ? n + 1 | 0 : n, E = n, Ur(Bn, L, n & 1048575, 0, 0, 15632, 16, 0, 0), Wr = T + 4592 | 0, Ur(Wr, Mr, Be, 0, 0, gn, Gn, 0, 0), Bn = T + 4656 | 0, Ur(Bn, Xn, Ai, 0, 0, Xn, Ai, 0, 0), gr = T + 4416 | 0, Ur(gr, Ir, cr, 0, 0, xn, xr, 0, 0), Mr = T + 4400 | 0, cr = Mr, Be = (d | 0) == (n | 0) & L >>> 0 < tr >>> 0 | d >>> 0 > n >>> 0, tr = (d | 0) == (ni | 0) & tr >>> 0 < $r >>> 0 | d >>> 0 < ni >>> 0, n = Un + 8 | 0, L = t[n >> 2], d = jn + 8 | 0, Ir = L + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = L >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, L = tr + Ir | 0, n = L >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + L | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Be | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d << 12 | E >>> 20, E = t[T + 4416 >> 2], Be = L + E | 0, a = n, d = n << 12 | d >>> 20, n = d + t[T + 4420 >> 2] | 0, n = E >>> 0 > Be >>> 0 ? n + 1 | 0 : n, Ur(cr, Be, n, 0, 0, 15632, 16, 0, 0), $r = T + 4384 | 0, tr = $r, L = (d | 0) == (n | 0) & L >>> 0 > Be >>> 0 | d >>> 0 > n >>> 0, d = gr + 8 | 0, E = t[d >> 2], n = t[d + 4 >> 2], a = a >>> 20 | 0, d = a + E | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + L | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Ur(tr, d, n, 0, 0, 64028672, 65536, 0, 0), a = t[T + 4368 >> 2], d = t[T + 4640 >> 2], Be = a + d | 0, L = t[T + 4372 >> 2], n = L + t[T + 4644 >> 2] | 0, ni = T + 7456 | 0, jn = ni + 8 | 0, xr = jn, E = d >>> 0 > Be >>> 0 ? n + 1 | 0 : n, L = (L | 0) == (E | 0) & a >>> 0 > Be >>> 0 | E >>> 0 < L >>> 0, n = wi + 8 | 0, a = t[n >> 2], d = fi + 8 | 0, tr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, d = L + tr | 0, n = d >>> 0 < tr >>> 0 ? n + 1 | 0 : n, tr = E, L = d << 12 | E >>> 20, a = n, Ir = n << 12 | d >>> 20, gn = t[T + 4436 >> 2], n = gn + t[T + 4612 >> 2] | 0, gr = t[T + 4432 >> 2], d = t[T + 4608 >> 2], E = gr + d | 0, cr = E, L = E + L | 0, d = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, n = d + Ir | 0, t[xr >> 2] = L, E = L >>> 0 < E >>> 0 ? n + 1 | 0 : n, t[xr + 4 >> 2] = E & 1048575, Un = ni + 16 | 0, xr = Un, Ir = (d | 0) == (E | 0) & L >>> 0 < cr >>> 0 | d >>> 0 > E >>> 0, cr = (d | 0) == (gn | 0) & cr >>> 0 < gr >>> 0 | d >>> 0 < gn >>> 0, n = Zn + 8 | 0, L = t[n >> 2], d = kn + 8 | 0, gr = L + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = L >>> 0 > gr >>> 0 ? n + 1 | 0 : n, L = cr + gr | 0, n = L >>> 0 < gr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + L | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Ir | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d << 12 | E >>> 20, a = n, E = n << 12 | d >>> 20, xn = t[T + 4592 >> 2], d = t[T + 4656 >> 2], Ir = xn + d | 0, kn = t[T + 4596 >> 2], n = kn + t[T + 4660 >> 2] | 0, n = d >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, d = t[T + 4400 >> 2], cr = d + Ir | 0, gr = n, n = n + t[T + 4404 >> 2] | 0, d = d >>> 0 > cr >>> 0 ? n + 1 | 0 : n, n = d + E | 0, L = L + cr | 0, n = L >>> 0 < cr >>> 0 ? n + 1 | 0 : n, t[xr >> 2] = L, E = n, t[xr + 4 >> 2] = n & 1048575, Xn = ni + 24 | 0, Gn = (d | 0) == (n | 0) & L >>> 0 < cr >>> 0 | d >>> 0 > n >>> 0, gn = (d | 0) == (gr | 0) & cr >>> 0 < Ir >>> 0 | d >>> 0 < gr >>> 0, d = Mr + 8 | 0, xr = t[d >> 2], Mr = t[d + 4 >> 2], cr = (gr | 0) == (kn | 0) & Ir >>> 0 < xn >>> 0 | gr >>> 0 < kn >>> 0, n = Bn + 8 | 0, L = t[n >> 2], d = Wr + 8 | 0, Ir = L + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = L >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, d = cr + Ir | 0, n = (d >>> 0 < Ir >>> 0 ? n + 1 | 0 : n) + Mr | 0, L = d, d = d + xr | 0, n = L >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d + gn | 0, n = L >>> 0 < d >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + L | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Gn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, cr = d << 12 | E >>> 20, a = n, L = n << 12 | d >>> 20, Ir = t[T + 4384 >> 2], E = dr & -2, d = Ir + E | 0, xr = t[T + 4388 >> 2], n = xr + (or & 1048575) | 0, dr = d >>> 0 < E >>> 0 ? n + 1 | 0 : n, n = dr + L | 0, or = d, E = d + cr | 0, t[Xn >> 2] = E, d = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, t[Xn + 4 >> 2] = d & 1048575, Mr = ni + 32 | 0, gr = Mr, L = he, cr = Me & 65535, Me = (d | 0) == (dr | 0) & E >>> 0 < or >>> 0 | d >>> 0 < dr >>> 0, E = (dr | 0) == (xr | 0) & or >>> 0 < Ir >>> 0 | dr >>> 0 < xr >>> 0, n = $r + 8 | 0, he = E + t[n >> 2] | 0, n = t[n + 4 >> 2], n = E >>> 0 > he >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, E = a, a = a + he | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, d = a << 12 | d >>> 20, E = d + L | 0, n = cr + (n << 12 | a >>> 20) | 0, t[gr >> 2] = E, t[gr + 4 >> 2] = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, t[T + 7456 >> 2] = Be, t[T + 7460 >> 2] = tr & 1048575, Xr(ni, ni, Zi), d = t[T + 7460 >> 2], Bn = d, $r = t[T + 7456 >> 2], L = $r, n = d << 1 | L >>> 31, gr = T + 4208 | 0, or = t[Xn >> 2], Me = t[Xn + 4 >> 2], gn = L << 1, Gn = n, Ur(gr, or, Me, 0, 0, gn, n, 0, 0), d = t[jn + 4 >> 2], Xi = d, Ai = t[jn >> 2], a = Ai, n = d << 1 | a >>> 31, Ir = T + 4304 | 0, cr = t[Un >> 2], Be = t[Un + 4 >> 2], a = a << 1, E = n, Ur(Ir, cr, Be, 0, 0, a, n, 0, 0), dr = T + 4192 | 0, he = t[Mr >> 2], d = t[Mr + 4 >> 2], Ur(dr, he, d, 0, 0, he, d, 0, 0), tr = T + 4176 | 0, Ur(tr, t[T + 4192 >> 2], t[T + 4196 >> 2], 0, 0, 15632, 16, 0, 0), n = d << 1 | he >>> 31, Oi = T + 4144 | 0, xn = he << 1, xr = n, Ur(Oi, xn, n, 0, 0, L, Bn, 0, 0), Ti = T + 4224 | 0, Ur(Ti, or, Me, 0, 0, a, E, 0, 0), Ii = T + 4288 | 0, Ur(Ii, cr, Be, 0, 0, cr, Be, 0, 0), Xn = T + 4160 | 0, d = dr + 8 | 0, Ur(Xn, t[d >> 2], t[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), wi = T + 4352 | 0, Ur(wi, L, Bn, 0, 0, L, Bn, 0, 0), ai = T + 4128 | 0, Ur(ai, xn, n, 0, 0, Ai, Xi, 0, 0), Bi = T + 4240 | 0, Ur(Bi, or, Me, 0, 0, cr << 1, Be << 1 | cr >>> 31, 0, 0), $r = t[T + 4212 >> 2], n = $r + t[T + 4308 >> 2] | 0, he = t[T + 4208 >> 2], a = t[T + 4304 >> 2], d = he + a | 0, E = t[T + 4176 >> 2], Mr = d + E | 0, a = d >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = a + t[T + 4180 >> 2] | 0, E = E >>> 0 > Mr >>> 0 ? n + 1 | 0 : n, dr = (a | 0) == (E | 0) & d >>> 0 > Mr >>> 0 | a >>> 0 > E >>> 0, n = tr + 8 | 0, tr = t[n >> 2], L = t[n + 4 >> 2], he = (a | 0) == ($r | 0) & d >>> 0 < he >>> 0 | a >>> 0 < $r >>> 0, n = Ir + 8 | 0, a = t[n >> 2], d = gr + 8 | 0, Ir = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, d = he + Ir | 0, n = (d >>> 0 < Ir >>> 0 ? n + 1 | 0 : n) + L | 0, a = d, d = d + tr | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + dr | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, gr = E, tr = d << 12 | E >>> 20, a = n, he = n << 12 | d >>> 20, ni = t[T + 4224 >> 2], d = t[T + 4288 >> 2], dr = ni + d | 0, yi = t[T + 4228 >> 2], n = yi + t[T + 4292 >> 2] | 0, n = d >>> 0 > dr >>> 0 ? n + 1 | 0 : n, d = t[T + 4144 >> 2], L = d + dr | 0, $r = n, n = n + t[T + 4148 >> 2] | 0, n = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, d = t[T + 4160 >> 2], E = d + L | 0, Ir = n, n = n + t[T + 4164 >> 2] | 0, d = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, n = d + he | 0, fi = T + 4112 | 0, Zn = fi, tr = E + tr | 0, he = tr >>> 0 < E >>> 0 ? n + 1 | 0 : n, jn = (d | 0) == (he | 0) & E >>> 0 > tr >>> 0 | d >>> 0 > he >>> 0, Un = (d | 0) == (Ir | 0) & E >>> 0 < L >>> 0 | d >>> 0 < Ir >>> 0, d = Xn + 8 | 0, kn = t[d >> 2], Wr = t[d + 4 >> 2], Bn = (Ir | 0) == ($r | 0) & L >>> 0 < dr >>> 0 | Ir >>> 0 < $r >>> 0, d = Oi + 8 | 0, Xn = t[d >> 2], Ir = t[d + 4 >> 2], L = ($r | 0) == (yi | 0) & dr >>> 0 < ni >>> 0 | $r >>> 0 < yi >>> 0, n = Ii + 8 | 0, E = t[n >> 2], d = Ti + 8 | 0, dr = E + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = E >>> 0 > dr >>> 0 ? n + 1 | 0 : n, d = L + dr | 0, n = (d >>> 0 < dr >>> 0 ? n + 1 | 0 : n) + Ir | 0, E = d, d = d + Xn | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d, d = d + Bn | 0, n = (E >>> 0 > d >>> 0 ? n + 1 | 0 : n) + Wr | 0, E = d, d = d + kn | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d + Un | 0, n = E >>> 0 < d >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + E | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + jn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = he, L = d << 12 | a >>> 20, E = n, he = n << 12 | d >>> 20, Wr = t[T + 4128 >> 2], d = t[T + 4240 >> 2], dr = Wr + d | 0, kn = t[T + 4132 >> 2], n = kn + t[T + 4244 >> 2] | 0, d = d >>> 0 > dr >>> 0 ? n + 1 | 0 : n, n = d + he | 0, L = L + dr | 0, n = L >>> 0 < dr >>> 0 ? n + 1 | 0 : n, Xn = L << 4 & -16, he = n, $r = (n << 4 | L >>> 28) & 16777215, Ir = a, Ur(Zn, Xn | a >>> 16 & 15, $r, 0, 0, 977, 1, 0, 0), Zn = T + 4336 | 0, Ur(Zn, Ai, Xi, 0, 0, gn, Gn, 0, 0), Un = T + 4080 | 0, Ur(Un, xn, xr, 0, 0, cr, Be, 0, 0), Bn = T + 4256 | 0, Ur(Bn, or, Me, 0, 0, or, Me, 0, 0), Xn = T + 4064 | 0, $r = (d | 0) == (n | 0) & L >>> 0 < dr >>> 0 | d >>> 0 > n >>> 0, L = (d | 0) == (kn | 0) & dr >>> 0 < Wr >>> 0 | d >>> 0 < kn >>> 0, n = Bi + 8 | 0, a = t[n >> 2], d = ai + 8 | 0, dr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > dr >>> 0 ? n + 1 | 0 : n, a = L + dr | 0, n = a >>> 0 < dr >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, d = a + E | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + $r | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | he >>> 20, a = n, E = n << 12 | d >>> 20, $r = t[T + 4080 >> 2], d = t[T + 4256 >> 2], L = $r + d | 0, jn = t[T + 4084 >> 2], n = jn + t[T + 4260 >> 2] | 0, d = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, n = d + E | 0, he = L + he | 0, n = he >>> 0 < L >>> 0 ? n + 1 | 0 : n, E = n, Ur(Xn, he, n & 1048575, 0, 0, 15632, 16, 0, 0), kn = T + 4272 | 0, Ur(kn, cr, Be, 0, 0, gn, Gn, 0, 0), Wr = T + 4320 | 0, Ur(Wr, Ai, Xi, 0, 0, Ai, Xi, 0, 0), dr = T + 4016 | 0, Ur(dr, xn, xr, 0, 0, or, Me, 0, 0), gn = T + 4e3 | 0, Me = gn, Be = (d | 0) == (n | 0) & L >>> 0 > he >>> 0 | d >>> 0 > n >>> 0, L = (d | 0) == (jn | 0) & L >>> 0 < $r >>> 0 | d >>> 0 < jn >>> 0, n = Bn + 8 | 0, he = t[n >> 2], d = Un + 8 | 0, or = he + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = he >>> 0 > or >>> 0 ? n + 1 | 0 : n, he = L + or | 0, n = he >>> 0 < or >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + he | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Be | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | E >>> 20, E = t[T + 4016 >> 2], Be = he + E | 0, a = n, d = n << 12 | d >>> 20, n = d + t[T + 4020 >> 2] | 0, n = E >>> 0 > Be >>> 0 ? n + 1 | 0 : n, Ur(Me, Be, n, 0, 0, 15632, 16, 0, 0), jn = T + 3936 | 0, L = jn, he = (d | 0) == (n | 0) & he >>> 0 > Be >>> 0 | d >>> 0 > n >>> 0, d = dr + 8 | 0, E = t[d >> 2], n = t[d + 4 >> 2], a = a >>> 20 | 0, d = a + E | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + he | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Ur(L, d, n, 0, 0, 64028672, 65536, 0, 0), a = t[T + 4112 >> 2], d = t[T + 4352 >> 2], L = a + d | 0, he = t[T + 4116 >> 2], n = he + t[T + 4356 >> 2] | 0, E = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, he = (he | 0) == (E | 0) & a >>> 0 > L >>> 0 | E >>> 0 < he >>> 0, n = wi + 8 | 0, a = t[n >> 2], d = fi + 8 | 0, Be = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, d = he + Be | 0, n = d >>> 0 < Be >>> 0 ? n + 1 | 0 : n, cr = E, he = d << 12 | E >>> 20, a = n, E = n << 12 | d >>> 20, Me = t[T + 4064 >> 2], d = t[T + 4336 >> 2], Be = Me + d | 0, dr = t[T + 4068 >> 2], n = dr + t[T + 4340 >> 2] | 0, d = d >>> 0 > Be >>> 0 ? n + 1 | 0 : n, n = d + E | 0, he = he + Be | 0, E = he >>> 0 < Be >>> 0 ? n + 1 | 0 : n, or = (d | 0) == (E | 0) & he >>> 0 < Be >>> 0 | d >>> 0 > E >>> 0, Me = (d | 0) == (dr | 0) & Be >>> 0 < Me >>> 0 | d >>> 0 < dr >>> 0, n = Zn + 8 | 0, Be = t[n >> 2], d = Xn + 8 | 0, dr = Be + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = Be >>> 0 > dr >>> 0 ? n + 1 | 0 : n, Be = Me + dr | 0, n = Be >>> 0 < dr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + Be | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + or | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, dr = E, Be = d << 12 | E >>> 20, a = n, E = n << 12 | d >>> 20, Bn = t[T + 4272 >> 2], d = t[T + 4320 >> 2], or = Bn + d | 0, Zn = t[T + 4276 >> 2], n = Zn + t[T + 4324 >> 2] | 0, n = d >>> 0 > or >>> 0 ? n + 1 | 0 : n, d = t[T + 4e3 >> 2], Me = d + or | 0, xr = n, n = n + t[T + 4004 >> 2] | 0, d = d >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = d + E | 0, Un = T + 3920 | 0, Xn = Un, E = Be + Me | 0, Be = E >>> 0 < Me >>> 0 ? n + 1 | 0 : n, $r = (d | 0) == (Be | 0) & E >>> 0 < Me >>> 0 | d >>> 0 > Be >>> 0, xn = (d | 0) == (xr | 0) & Me >>> 0 < or >>> 0 | d >>> 0 < xr >>> 0, d = gn + 8 | 0, Gn = t[d >> 2], gn = t[d + 4 >> 2], or = (xr | 0) == (Zn | 0) & or >>> 0 < Bn >>> 0 | xr >>> 0 < Zn >>> 0, n = Wr + 8 | 0, Me = t[n >> 2], d = kn + 8 | 0, xr = Me + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = Me >>> 0 > xr >>> 0 ? n + 1 | 0 : n, d = or + xr | 0, n = (d >>> 0 < xr >>> 0 ? n + 1 | 0 : n) + gn | 0, or = d, d = d + Gn | 0, n = or >>> 0 > d >>> 0 ? n + 1 | 0 : n, Me = d + xn | 0, n = Me >>> 0 < d >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + Me | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + $r | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Me = Be, or = d << 12 | Be >>> 20, a = n, xr = n << 12 | d >>> 20, Zn = t[T + 3940 >> 2], n = Zn + (gr & 1048575) | 0, Bn = t[T + 3936 >> 2], d = Mr & -2, Be = Bn + d | 0, gr = Be, or = Be + or | 0, d = d >>> 0 > Be >>> 0 ? n + 1 | 0 : n, n = d + xr | 0, Be = or >>> 0 < Be >>> 0 ? n + 1 | 0 : n, $r = Be & 1048575, Mr = $r, n = cr & 1048575, fi = n, cr = L, n = n << 1 | L >>> 31, gn = L << 1, Gn = n, Ur(Xn, or, Mr, 0, 0, gn, n, 0, 0), n = dr & 1048575, Ai = n, kn = T + 3952 | 0, Mr = Me & 1048575, L = he << 1, Xn = he, Me = n << 1 | he >>> 31, Ur(kn, E, Mr, 0, 0, L, Me, 0, 0), Wr = T + 3856 | 0, xr = Ir & 65535, Ir = (d | 0) == (Be | 0) & or >>> 0 < gr >>> 0 | d >>> 0 > Be >>> 0, dr = (d | 0) == (Zn | 0) & gr >>> 0 < Bn >>> 0 | d >>> 0 < Zn >>> 0, d = jn + 8 | 0, he = dr + t[d >> 2] | 0, n = t[d + 4 >> 2], n = he >>> 0 < dr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + he | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Ir | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | Be >>> 20, a = he + tr | 0, n = xr + (n << 12 | d >>> 20) | 0, n = a >>> 0 < he >>> 0 ? n + 1 | 0 : n, Ur(Wr, a, n, 0, 0, a, n, 0, 0), tr = T + 3840 | 0, Ur(tr, t[T + 3856 >> 2], t[T + 3860 >> 2], 0, 0, 15632, 16, 0, 0), d = a, n = n << 1 | d >>> 31, Oi = T + 3808 | 0, xn = d << 1, xr = n, Ur(Oi, xn, n, 0, 0, cr, fi, 0, 0), Ti = T + 3904 | 0, Ur(Ti, or, $r, 0, 0, L, Me, 0, 0), Ii = T + 3968 | 0, Ur(Ii, E, Mr, 0, 0, E, Mr, 0, 0), Bn = T + 3824 | 0, d = Wr + 8 | 0, Ur(Bn, t[d >> 2], t[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), wi = T + 4096 | 0, Ur(wi, cr, fi, 0, 0, cr, fi, 0, 0), ai = T + 3792 | 0, Ur(ai, xn, n, 0, 0, Xn, Ai, 0, 0), Bi = T + 3872 | 0, Ir = or, cr = $r, Be = Mr, Mr = E, Ur(Bi, or, cr, 0, 0, E << 1, Be << 1 | E >>> 31, 0, 0), he = t[T + 3920 >> 2], a = t[T + 3952 >> 2], d = he + a | 0, or = t[T + 3924 >> 2], n = or + t[T + 3956 >> 2] | 0, n = d >>> 0 < a >>> 0 ? n + 1 | 0 : n, a = t[T + 3840 >> 2], dr = a + d | 0, E = n, n = n + t[T + 3844 >> 2] | 0, a = a >>> 0 > dr >>> 0 ? n + 1 | 0 : n, Me = (E | 0) == (a | 0) & d >>> 0 > dr >>> 0 | a >>> 0 < E >>> 0, n = tr + 8 | 0, tr = t[n >> 2], L = t[n + 4 >> 2], he = (E | 0) == (or | 0) & d >>> 0 < he >>> 0 | E >>> 0 < or >>> 0, n = kn + 8 | 0, E = t[n >> 2], d = Un + 8 | 0, or = E + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = E >>> 0 > or >>> 0 ? n + 1 | 0 : n, d = he + or | 0, n = (d >>> 0 < or >>> 0 ? n + 1 | 0 : n) + L | 0, E = d, d = d + tr | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d, d = d + Me | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, or = a, L = d << 12 | a >>> 20, E = n, he = n << 12 | d >>> 20, ni = t[T + 3904 >> 2], d = t[T + 3968 >> 2], gr = ni + d | 0, yi = t[T + 3908 >> 2], n = yi + t[T + 3972 >> 2] | 0, n = d >>> 0 > gr >>> 0 ? n + 1 | 0 : n, d = t[T + 3808 >> 2], Me = d + gr | 0, a = n, n = n + t[T + 3812 >> 2] | 0, n = d >>> 0 > Me >>> 0 ? n + 1 | 0 : n, d = t[T + 3824 >> 2], tr = d + Me | 0, $r = n, n = n + t[T + 3828 >> 2] | 0, d = d >>> 0 > tr >>> 0 ? n + 1 | 0 : n, n = d + he | 0, fi = T + 3696 | 0, Zn = fi, he = L + tr | 0, L = he >>> 0 < tr >>> 0 ? n + 1 | 0 : n, jn = (d | 0) == (L | 0) & he >>> 0 < tr >>> 0 | d >>> 0 > L >>> 0, Un = (d | 0) == ($r | 0) & Me >>> 0 > tr >>> 0 | d >>> 0 < $r >>> 0, d = Bn + 8 | 0, kn = t[d >> 2], Wr = t[d + 4 >> 2], Bn = (a | 0) == ($r | 0) & Me >>> 0 < gr >>> 0 | a >>> 0 > $r >>> 0, d = Oi + 8 | 0, $r = t[d >> 2], Me = t[d + 4 >> 2], tr = (a | 0) == (yi | 0) & gr >>> 0 < ni >>> 0 | a >>> 0 < yi >>> 0, n = Ii + 8 | 0, a = t[n >> 2], d = Ti + 8 | 0, gr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, d = tr + gr | 0, n = (d >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + Me | 0, a = d, d = d + $r | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Bn | 0, n = (a >>> 0 > d >>> 0 ? n + 1 | 0 : n) + Wr | 0, a = d, d = d + kn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d + Un | 0, n = a >>> 0 < d >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, d = a + E | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + jn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = L, tr = d << 12 | a >>> 20, E = n, L = n << 12 | d >>> 20, Wr = t[T + 3792 >> 2], d = t[T + 3872 >> 2], gr = Wr + d | 0, ni = t[T + 3796 >> 2], n = ni + t[T + 3876 >> 2] | 0, d = d >>> 0 > gr >>> 0 ? n + 1 | 0 : n, n = d + L | 0, tr = tr + gr | 0, n = tr >>> 0 < gr >>> 0 ? n + 1 | 0 : n, Bn = tr << 4 & -16, L = n, $r = (n << 4 | tr >>> 28) & 16777215, Me = a, Ur(Zn, Bn | a >>> 16 & 15, $r, 0, 0, 977, 1, 0, 0), Zn = T + 4032 | 0, Ur(Zn, Xn, Ai, 0, 0, gn, Gn, 0, 0), jn = T + 3776 | 0, Ur(jn, xn, xr, 0, 0, Mr, Be, 0, 0), Un = T + 3888 | 0, Ur(Un, Ir, cr, 0, 0, Ir, cr, 0, 0), kn = T + 3760 | 0, Bn = kn, $r = (d | 0) == (n | 0) & tr >>> 0 < gr >>> 0 | d >>> 0 > n >>> 0, tr = (d | 0) == (ni | 0) & gr >>> 0 < Wr >>> 0 | d >>> 0 < ni >>> 0, n = Bi + 8 | 0, a = t[n >> 2], d = ai + 8 | 0, gr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = tr + gr | 0, n = a >>> 0 < gr >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, d = a + E | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + $r | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d << 12 | L >>> 20, a = n, E = n << 12 | d >>> 20, $r = t[T + 3776 >> 2], d = t[T + 3888 >> 2], tr = $r + d | 0, ni = t[T + 3780 >> 2], n = ni + t[T + 3892 >> 2] | 0, d = d >>> 0 > tr >>> 0 ? n + 1 | 0 : n, n = d + E | 0, L = L + tr | 0, n = L >>> 0 < tr >>> 0 ? n + 1 | 0 : n, E = n, Ur(Bn, L, n & 1048575, 0, 0, 15632, 16, 0, 0), Wr = T + 3984 | 0, Ur(Wr, Mr, Be, 0, 0, gn, Gn, 0, 0), Bn = T + 4048 | 0, Ur(Bn, Xn, Ai, 0, 0, Xn, Ai, 0, 0), gr = T + 3744 | 0, Ur(gr, Ir, cr, 0, 0, xn, xr, 0, 0), Mr = T + 3728 | 0, cr = Mr, Be = (d | 0) == (n | 0) & L >>> 0 < tr >>> 0 | d >>> 0 > n >>> 0, tr = (d | 0) == (ni | 0) & tr >>> 0 < $r >>> 0 | d >>> 0 < ni >>> 0, n = Un + 8 | 0, L = t[n >> 2], d = jn + 8 | 0, Ir = L + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = L >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, L = tr + Ir | 0, n = L >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + L | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Be | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d << 12 | E >>> 20, E = t[T + 3744 >> 2], Be = L + E | 0, a = n, d = n << 12 | d >>> 20, n = d + t[T + 3748 >> 2] | 0, n = E >>> 0 > Be >>> 0 ? n + 1 | 0 : n, Ur(cr, Be, n, 0, 0, 15632, 16, 0, 0), $r = T + 3712 | 0, tr = $r, L = (d | 0) == (n | 0) & L >>> 0 > Be >>> 0 | d >>> 0 > n >>> 0, d = gr + 8 | 0, E = t[d >> 2], n = t[d + 4 >> 2], a = a >>> 20 | 0, d = a + E | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + L | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Ur(tr, d, n, 0, 0, 64028672, 65536, 0, 0), a = t[T + 3696 >> 2], d = t[T + 4096 >> 2], Be = a + d | 0, L = t[T + 3700 >> 2], n = L + t[T + 4100 >> 2] | 0, ni = T + 7416 | 0, jn = ni + 8 | 0, xr = jn, E = d >>> 0 > Be >>> 0 ? n + 1 | 0 : n, L = (L | 0) == (E | 0) & a >>> 0 > Be >>> 0 | E >>> 0 < L >>> 0, n = wi + 8 | 0, a = t[n >> 2], d = fi + 8 | 0, tr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, d = L + tr | 0, n = d >>> 0 < tr >>> 0 ? n + 1 | 0 : n, tr = E, L = d << 12 | E >>> 20, a = n, Ir = n << 12 | d >>> 20, gn = t[T + 3764 >> 2], n = gn + t[T + 4036 >> 2] | 0, gr = t[T + 3760 >> 2], d = t[T + 4032 >> 2], E = gr + d | 0, cr = E, L = E + L | 0, d = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, n = d + Ir | 0, t[xr >> 2] = L, E = L >>> 0 < E >>> 0 ? n + 1 | 0 : n, t[xr + 4 >> 2] = E & 1048575, Un = ni + 16 | 0, xr = Un, Ir = (d | 0) == (E | 0) & L >>> 0 < cr >>> 0 | d >>> 0 > E >>> 0, cr = (d | 0) == (gn | 0) & cr >>> 0 < gr >>> 0 | d >>> 0 < gn >>> 0, n = Zn + 8 | 0, L = t[n >> 2], d = kn + 8 | 0, gr = L + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = L >>> 0 > gr >>> 0 ? n + 1 | 0 : n, L = cr + gr | 0, n = L >>> 0 < gr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + L | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Ir | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d << 12 | E >>> 20, a = n, E = n << 12 | d >>> 20, xn = t[T + 3984 >> 2], d = t[T + 4048 >> 2], Ir = xn + d | 0, kn = t[T + 3988 >> 2], n = kn + t[T + 4052 >> 2] | 0, n = d >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, d = t[T + 3728 >> 2], cr = d + Ir | 0, gr = n, n = n + t[T + 3732 >> 2] | 0, d = d >>> 0 > cr >>> 0 ? n + 1 | 0 : n, n = d + E | 0, L = L + cr | 0, n = L >>> 0 < cr >>> 0 ? n + 1 | 0 : n, t[xr >> 2] = L, E = n, t[xr + 4 >> 2] = n & 1048575, Xn = ni + 24 | 0, Gn = (d | 0) == (n | 0) & L >>> 0 < cr >>> 0 | d >>> 0 > n >>> 0, gn = (d | 0) == (gr | 0) & cr >>> 0 < Ir >>> 0 | d >>> 0 < gr >>> 0, d = Mr + 8 | 0, xr = t[d >> 2], Mr = t[d + 4 >> 2], cr = (gr | 0) == (kn | 0) & Ir >>> 0 < xn >>> 0 | gr >>> 0 < kn >>> 0, n = Bn + 8 | 0, L = t[n >> 2], d = Wr + 8 | 0, Ir = L + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = L >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, d = cr + Ir | 0, n = (d >>> 0 < Ir >>> 0 ? n + 1 | 0 : n) + Mr | 0, L = d, d = d + xr | 0, n = L >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d + gn | 0, n = L >>> 0 < d >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + L | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Gn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, cr = d << 12 | E >>> 20, a = n, L = n << 12 | d >>> 20, Ir = t[T + 3712 >> 2], E = dr & -2, d = Ir + E | 0, Mr = t[T + 3716 >> 2], n = Mr + (or & 1048575) | 0, dr = d >>> 0 < E >>> 0 ? n + 1 | 0 : n, n = dr + L | 0, or = d, E = d + cr | 0, t[Xn >> 2] = E, d = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, t[Xn + 4 >> 2] = d & 1048575, gr = ni + 32 | 0, L = he, cr = Me & 65535, Me = (d | 0) == (dr | 0) & E >>> 0 < or >>> 0 | d >>> 0 < dr >>> 0, E = (dr | 0) == (Mr | 0) & or >>> 0 < Ir >>> 0 | dr >>> 0 < Mr >>> 0, n = $r + 8 | 0, he = E + t[n >> 2] | 0, n = t[n + 4 >> 2], n = E >>> 0 > he >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, E = a, a = a + he | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, d = a << 12 | d >>> 20, E = d + L | 0, n = cr + (n << 12 | a >>> 20) | 0, t[gr >> 2] = E, t[gr + 4 >> 2] = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, t[T + 7416 >> 2] = Be, t[T + 7420 >> 2] = tr & 1048575, Xr(ni, ni, Hi), Be = t[gr + 4 >> 2], n = T + 7376 | 0, d = n + 32 | 0, a = t[gr >> 2], t[d >> 2] = a, t[d + 4 >> 2] = Be, Me = t[Xn + 4 >> 2], d = n + 24 | 0, tr = t[Xn >> 2], t[d >> 2] = tr, t[d + 4 >> 2] = Me, cr = t[Un + 4 >> 2], d = n + 16 | 0, L = t[Un >> 2], t[d >> 2] = L, t[d + 4 >> 2] = cr, dr = t[jn + 4 >> 2], d = n + 8 | 0, he = t[jn >> 2], t[d >> 2] = he, t[d + 4 >> 2] = dr, or = t[T + 7420 >> 2], E = t[T + 7416 >> 2], t[T + 7376 >> 2] = E, t[T + 7380 >> 2] = or, d = 11; gr = E, n = or << 1 | E >>> 31, Un = T + 3664 | 0, $r = E << 1, Xn = n, Ur(Un, tr, Me, 0, 0, $r, n, 0, 0), Wr = T + 3584 | 0, E = he << 1, Ir = dr, xn = he, he = dr << 1 | he >>> 31, Ur(Wr, L, cr, 0, 0, E, he, 0, 0), xr = T + 3520 | 0, Ur(xr, a, Be, 0, 0, a, Be, 0, 0), Mr = T + 3504 | 0, Ur(Mr, t[T + 3520 >> 2], t[T + 3524 >> 2], 0, 0, 15632, 16, 0, 0), n = Be << 1 | a >>> 31, Ai = T + 3472 | 0, Bn = a << 1, Gn = n, Ur(Ai, Bn, n, 0, 0, gr, or, 0, 0), yi = T + 3632 | 0, Ur(yi, tr, Me, 0, 0, E, he, 0, 0), Oi = T + 3568 | 0, Ur(Oi, L, cr, 0, 0, L, cr, 0, 0), kn = T + 3488 | 0, n = xr + 8 | 0, Ur(kn, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ti = T + 3680 | 0, Ur(Ti, gr, or, 0, 0, gr, or, 0, 0), Ii = T + 3456 | 0, Ur(Ii, Bn, Gn, 0, 0, xn, dr, 0, 0), wi = T + 3536 | 0, or = tr, gn = L, Ur(wi, tr, Me, 0, 0, L << 1, cr << 1 | L >>> 31, 0, 0), gr = t[T + 3668 >> 2], n = gr + t[T + 3588 >> 2] | 0, L = t[T + 3664 >> 2], E = t[T + 3584 >> 2], a = L + E | 0, he = t[T + 3504 >> 2], xr = a + he | 0, E = a >>> 0 < E >>> 0 ? n + 1 | 0 : n, n = E + t[T + 3508 >> 2] | 0, he = he >>> 0 > xr >>> 0 ? n + 1 | 0 : n, dr = (E | 0) == (he | 0) & a >>> 0 > xr >>> 0 | E >>> 0 > he >>> 0, n = Mr + 8 | 0, Be = t[n >> 2], tr = t[n + 4 >> 2], L = (E | 0) == (gr | 0) & a >>> 0 < L >>> 0 | E >>> 0 < gr >>> 0, E = Wr + 8 | 0, a = t[E >> 2], n = Un + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = L + gr | 0, n = (a >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + tr | 0, E = a, a = a + Be | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + dr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, dr = he, Be = a << 12 | he >>> 20, E = n, L = n << 12 | a >>> 20, ai = t[T + 3632 >> 2], a = t[T + 3568 >> 2], gr = ai + a | 0, Hi = t[T + 3636 >> 2], n = Hi + t[T + 3572 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = t[T + 3472 >> 2], tr = a + gr | 0, Wr = n, n = n + t[T + 3476 >> 2] | 0, n = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, a = t[T + 3488 >> 2], he = a + tr | 0, Mr = n, n = n + t[T + 3492 >> 2] | 0, a = a >>> 0 > he >>> 0 ? n + 1 | 0 : n, n = a + L | 0, Bi = T + 3440 | 0, Be = he + Be | 0, L = Be >>> 0 < he >>> 0 ? n + 1 | 0 : n, ni = (a | 0) == (L | 0) & he >>> 0 > Be >>> 0 | a >>> 0 > L >>> 0, fi = (a | 0) == (Mr | 0) & he >>> 0 < tr >>> 0 | a >>> 0 < Mr >>> 0, n = kn + 8 | 0, Zn = t[n >> 2], jn = t[n + 4 >> 2], Un = (Mr | 0) == (Wr | 0) & tr >>> 0 < gr >>> 0 | Mr >>> 0 < Wr >>> 0, n = Ai + 8 | 0, kn = t[n >> 2], Mr = t[n + 4 >> 2], tr = (Wr | 0) == (Hi | 0) & gr >>> 0 < ai >>> 0 | Wr >>> 0 < Hi >>> 0, he = Oi + 8 | 0, a = t[he >> 2], n = yi + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[he + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = tr + gr | 0, n = (a >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + Mr | 0, he = a, a = a + kn | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, he = a, a = a + Un | 0, n = (he >>> 0 > a >>> 0 ? n + 1 | 0 : n) + jn | 0, he = a, a = a + Zn | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, he = a + fi | 0, n = he >>> 0 < a >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + he | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + ni | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = L, tr = a << 12 | E >>> 20, he = n, Mr = n << 12 | a >>> 20, ai = t[T + 3460 >> 2], n = ai + t[T + 3540 >> 2] | 0, Un = t[T + 3456 >> 2], a = t[T + 3536 >> 2], L = Un + a | 0, gr = L, tr = L + tr | 0, a = a >>> 0 > L >>> 0 ? n + 1 | 0 : n, n = a + Mr | 0, kn = tr << 4 & -16, L = tr >>> 0 < L >>> 0 ? n + 1 | 0 : n, Wr = (L << 4 | tr >>> 28) & 16777215, Mr = E, Ur(Bi, kn | E >>> 16 & 15, Wr, 0, 0, 977, 1, 0, 0), ni = T + 3616 | 0, Ur(ni, xn, Ir, 0, 0, $r, Xn, 0, 0), fi = T + 3424 | 0, Ur(fi, Bn, Gn, 0, 0, gn, cr, 0, 0), Zn = T + 3648 | 0, Ur(Zn, or, Me, 0, 0, or, Me, 0, 0), jn = T + 3408 | 0, kn = jn, Wr = (a | 0) == (L | 0) & tr >>> 0 < gr >>> 0 | a >>> 0 > L >>> 0, tr = (a | 0) == (ai | 0) & gr >>> 0 < Un >>> 0 | a >>> 0 < ai >>> 0, E = wi + 8 | 0, a = t[E >> 2], n = Ii + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, E = tr + gr | 0, n = E >>> 0 < gr >>> 0 ? n + 1 | 0 : n, he = he >>> 20 | 0, a = E + he | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Wr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, L = a << 12 | L >>> 20, E = n, Wr = n << 12 | a >>> 20, ai = t[T + 3428 >> 2], n = ai + t[T + 3652 >> 2] | 0, gr = t[T + 3424 >> 2], a = t[T + 3648 >> 2], he = gr + a | 0, tr = he, L = he + L | 0, a = a >>> 0 > he >>> 0 ? n + 1 | 0 : n, n = a + Wr | 0, he = L >>> 0 < he >>> 0 ? n + 1 | 0 : n, Ur(kn, L, he & 1048575, 0, 0, 15632, 16, 0, 0), Un = T + 3552 | 0, Ur(Un, gn, cr, 0, 0, $r, Xn, 0, 0), kn = T + 3600 | 0, Ur(kn, xn, Ir, 0, 0, xn, Ir, 0, 0), cr = T + 3392 | 0, Ur(cr, Bn, Gn, 0, 0, or, Me, 0, 0), Gn = T + 3376 | 0, or = Gn, Me = (a | 0) == (he | 0) & L >>> 0 < tr >>> 0 | a >>> 0 > he >>> 0, tr = (a | 0) == (ai | 0) & tr >>> 0 < gr >>> 0 | a >>> 0 < ai >>> 0, L = Zn + 8 | 0, a = t[L >> 2], n = fi + 8 | 0, Ir = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[L + 4 >> 2] | 0, n = a >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, L = tr + Ir | 0, n = L >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + L | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, L = a << 12 | he >>> 20, he = t[T + 3392 >> 2], Me = L + he | 0, E = n, a = n << 12 | a >>> 20, n = a + t[T + 3396 >> 2] | 0, n = he >>> 0 > Me >>> 0 ? n + 1 | 0 : n, Ur(or, Me, n, 0, 0, 15632, 16, 0, 0), Wr = T + 3360 | 0, tr = Wr, L = (n | 0) == (a | 0) & L >>> 0 > Me >>> 0 | n >>> 0 < a >>> 0, n = cr + 8 | 0, he = t[n >> 2], n = t[n + 4 >> 2], E = E >>> 20 | 0, a = E + he | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + L | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ur(tr, a, n, 0, 0, 64028672, 65536, 0, 0), E = t[T + 3440 >> 2], a = t[T + 3680 >> 2], or = E + a | 0, L = t[T + 3444 >> 2], n = L + t[T + 3684 >> 2] | 0, he = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, L = (L | 0) == (he | 0) & E >>> 0 > or >>> 0 | L >>> 0 > he >>> 0, E = Ti + 8 | 0, a = t[E >> 2], n = Bi + 8 | 0, tr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, a = L + tr | 0, n = a >>> 0 < tr >>> 0 ? n + 1 | 0 : n, gr = he, L = a << 12 | he >>> 20, E = n, he = n << 12 | a >>> 20, Me = t[T + 3408 >> 2], a = t[T + 3616 >> 2], tr = Me + a | 0, Ir = t[T + 3412 >> 2], n = Ir + t[T + 3620 >> 2] | 0, a = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, n = a + he | 0, he = L + tr | 0, L = he >>> 0 < tr >>> 0 ? n + 1 | 0 : n, cr = (a | 0) == (L | 0) & he >>> 0 < tr >>> 0 | a >>> 0 > L >>> 0, Me = (a | 0) == (Ir | 0) & Me >>> 0 > tr >>> 0 | a >>> 0 < Ir >>> 0, tr = ni + 8 | 0, a = t[tr >> 2], n = jn + 8 | 0, Ir = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[tr + 4 >> 2] | 0, n = a >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, tr = Me + Ir | 0, n = tr >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + tr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + cr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ir = L, tr = a << 12 | L >>> 20, E = n, L = n << 12 | a >>> 20, Bn = t[T + 3552 >> 2], a = t[T + 3600 >> 2], cr = Bn + a | 0, jn = t[T + 3556 >> 2], n = jn + t[T + 3604 >> 2] | 0, n = a >>> 0 > cr >>> 0 ? n + 1 | 0 : n, a = t[T + 3376 >> 2], Me = a + cr | 0, gn = n, n = n + t[T + 3380 >> 2] | 0, a = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = a + L | 0, L = Me + tr | 0, tr = L >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Xn = (a | 0) == (tr | 0) & L >>> 0 < Me >>> 0 | a >>> 0 > tr >>> 0, $r = (a | 0) == (gn | 0) & Me >>> 0 < cr >>> 0 | a >>> 0 < gn >>> 0, n = Gn + 8 | 0, xn = t[n >> 2], Gn = t[n + 4 >> 2], cr = (gn | 0) == (jn | 0) & cr >>> 0 < Bn >>> 0 | gn >>> 0 < jn >>> 0, Me = kn + 8 | 0, a = t[Me >> 2], n = Un + 8 | 0, gn = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Me + 4 >> 2] | 0, n = a >>> 0 > gn >>> 0 ? n + 1 | 0 : n, a = cr + gn | 0, n = (a >>> 0 < gn >>> 0 ? n + 1 | 0 : n) + Gn | 0, cr = a, a = a + xn | 0, n = cr >>> 0 > a >>> 0 ? n + 1 | 0 : n, Me = a + $r | 0, n = Me >>> 0 < a >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Xn | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, cr = tr, gn = a << 12 | tr >>> 20, E = n, Me = n << 12 | a >>> 20, xn = t[T + 3360 >> 2], tr = xn + (xr & -2) | 0, Gn = t[T + 3364 >> 2], n = Gn + (dr & 1048575) | 0, n = tr >>> 0 < xn >>> 0 ? n + 1 | 0 : n, xr = tr, tr = tr + gn | 0, a = n, n = n + Me | 0, dr = Be, gn = Mr & 65535, Me = tr >>> 0 < xr >>> 0 ? n + 1 | 0 : n, Mr = (a | 0) == (Me | 0) & tr >>> 0 < xr >>> 0 | a >>> 0 > Me >>> 0, a = (a | 0) == (Gn | 0) & xr >>> 0 < xn >>> 0 | a >>> 0 < Gn >>> 0, n = Wr + 8 | 0, Be = a + t[n >> 2] | 0, n = t[n + 4 >> 2], n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + Be | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Mr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, Be = a << 12 | Me >>> 20, E = Be + dr | 0, n = gn + (n << 12 | a >>> 20) | 0, a = E, Be = a >>> 0 < Be >>> 0 ? n + 1 | 0 : n, Me = Me & 1048575, cr = cr & 1048575, dr = Ir & 1048575, E = or, or = gr & 1048575, d = d - 1 | 0, !!d; )
      ;
    for (d = T + 7376 | 0, xr = d + 32 | 0, t[xr >> 2] = a, t[xr + 4 >> 2] = Be, Mr = d + 24 | 0, t[Mr >> 2] = tr, t[Mr + 4 >> 2] = Me, gr = d + 16 | 0, t[gr >> 2] = L, t[gr + 4 >> 2] = cr, Ir = d + 8 | 0, t[Ir >> 2] = he, t[Ir + 4 >> 2] = dr, t[T + 7376 >> 2] = E, t[T + 7380 >> 2] = or, Xr(d, d, T + 7416 | 0), Be = t[xr + 4 >> 2], n = T + 7336 | 0, d = n + 32 | 0, a = t[xr >> 2], t[d >> 2] = a, t[d + 4 >> 2] = Be, Me = t[Mr + 4 >> 2], d = n + 24 | 0, tr = t[Mr >> 2], t[d >> 2] = tr, t[d + 4 >> 2] = Me, cr = t[gr + 4 >> 2], d = n + 16 | 0, L = t[gr >> 2], t[d >> 2] = L, t[d + 4 >> 2] = cr, dr = t[Ir + 4 >> 2], d = n + 8 | 0, he = t[Ir >> 2], t[d >> 2] = he, t[d + 4 >> 2] = dr, or = t[T + 7380 >> 2], E = t[T + 7376 >> 2], t[T + 7336 >> 2] = E, t[T + 7340 >> 2] = or, d = 22; gr = E, n = or << 1 | E >>> 31, Un = T + 3328 | 0, $r = E << 1, Xn = n, Ur(Un, tr, Me, 0, 0, $r, n, 0, 0), Wr = T + 3248 | 0, E = he << 1, Ir = dr, xn = he, he = dr << 1 | he >>> 31, Ur(Wr, L, cr, 0, 0, E, he, 0, 0), xr = T + 3184 | 0, Ur(xr, a, Be, 0, 0, a, Be, 0, 0), Mr = T + 3168 | 0, Ur(Mr, t[T + 3184 >> 2], t[T + 3188 >> 2], 0, 0, 15632, 16, 0, 0), n = Be << 1 | a >>> 31, Ai = T + 3136 | 0, Bn = a << 1, Gn = n, Ur(Ai, Bn, n, 0, 0, gr, or, 0, 0), yi = T + 3296 | 0, Ur(yi, tr, Me, 0, 0, E, he, 0, 0), Oi = T + 3232 | 0, Ur(Oi, L, cr, 0, 0, L, cr, 0, 0), kn = T + 3152 | 0, n = xr + 8 | 0, Ur(kn, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ti = T + 3344 | 0, Ur(Ti, gr, or, 0, 0, gr, or, 0, 0), Ii = T + 3120 | 0, Ur(Ii, Bn, Gn, 0, 0, xn, dr, 0, 0), wi = T + 3200 | 0, or = tr, gn = L, Ur(wi, tr, Me, 0, 0, L << 1, cr << 1 | L >>> 31, 0, 0), gr = t[T + 3332 >> 2], n = gr + t[T + 3252 >> 2] | 0, L = t[T + 3328 >> 2], E = t[T + 3248 >> 2], a = L + E | 0, he = t[T + 3168 >> 2], xr = a + he | 0, E = a >>> 0 < E >>> 0 ? n + 1 | 0 : n, n = E + t[T + 3172 >> 2] | 0, he = he >>> 0 > xr >>> 0 ? n + 1 | 0 : n, dr = (E | 0) == (he | 0) & a >>> 0 > xr >>> 0 | E >>> 0 > he >>> 0, n = Mr + 8 | 0, Be = t[n >> 2], tr = t[n + 4 >> 2], L = (E | 0) == (gr | 0) & a >>> 0 < L >>> 0 | E >>> 0 < gr >>> 0, E = Wr + 8 | 0, a = t[E >> 2], n = Un + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = L + gr | 0, n = (a >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + tr | 0, E = a, a = a + Be | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + dr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, dr = he, tr = a << 12 | he >>> 20, E = n, L = n << 12 | a >>> 20, ai = t[T + 3296 >> 2], a = t[T + 3232 >> 2], gr = ai + a | 0, Hi = t[T + 3300 >> 2], n = Hi + t[T + 3236 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = t[T + 3136 >> 2], Be = a + gr | 0, Wr = n, n = n + t[T + 3140 >> 2] | 0, n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, a = t[T + 3152 >> 2], he = a + Be | 0, Mr = n, n = n + t[T + 3156 >> 2] | 0, a = a >>> 0 > he >>> 0 ? n + 1 | 0 : n, n = a + L | 0, Bi = T + 3104 | 0, tr = he + tr | 0, L = tr >>> 0 < he >>> 0 ? n + 1 | 0 : n, ni = (a | 0) == (L | 0) & he >>> 0 > tr >>> 0 | a >>> 0 > L >>> 0, fi = (a | 0) == (Mr | 0) & he >>> 0 < Be >>> 0 | a >>> 0 < Mr >>> 0, n = kn + 8 | 0, Zn = t[n >> 2], jn = t[n + 4 >> 2], Un = (Mr | 0) == (Wr | 0) & Be >>> 0 < gr >>> 0 | Mr >>> 0 < Wr >>> 0, n = Ai + 8 | 0, kn = t[n >> 2], Mr = t[n + 4 >> 2], Be = (Wr | 0) == (Hi | 0) & gr >>> 0 < ai >>> 0 | Wr >>> 0 < Hi >>> 0, he = Oi + 8 | 0, a = t[he >> 2], n = yi + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[he + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = Be + gr | 0, n = (a >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + Mr | 0, he = a, a = a + kn | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, he = a, a = a + Un | 0, n = (he >>> 0 > a >>> 0 ? n + 1 | 0 : n) + jn | 0, he = a, a = a + Zn | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, he = a + fi | 0, n = he >>> 0 < a >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + he | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + ni | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = L, Be = a << 12 | E >>> 20, he = n, Mr = n << 12 | a >>> 20, ai = t[T + 3124 >> 2], n = ai + t[T + 3204 >> 2] | 0, Un = t[T + 3120 >> 2], a = t[T + 3200 >> 2], L = Un + a | 0, gr = L, Be = L + Be | 0, a = a >>> 0 > L >>> 0 ? n + 1 | 0 : n, n = a + Mr | 0, kn = Be << 4 & -16, L = Be >>> 0 < L >>> 0 ? n + 1 | 0 : n, Wr = (L << 4 | Be >>> 28) & 16777215, Mr = E, Ur(Bi, kn | E >>> 16 & 15, Wr, 0, 0, 977, 1, 0, 0), ni = T + 3280 | 0, Ur(ni, xn, Ir, 0, 0, $r, Xn, 0, 0), fi = T + 3088 | 0, Ur(fi, Bn, Gn, 0, 0, gn, cr, 0, 0), Zn = T + 3312 | 0, Ur(Zn, or, Me, 0, 0, or, Me, 0, 0), jn = T + 3072 | 0, kn = jn, Wr = (a | 0) == (L | 0) & Be >>> 0 < gr >>> 0 | a >>> 0 > L >>> 0, Be = (a | 0) == (ai | 0) & gr >>> 0 < Un >>> 0 | a >>> 0 < ai >>> 0, E = wi + 8 | 0, a = t[E >> 2], n = Ii + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, E = Be + gr | 0, n = E >>> 0 < gr >>> 0 ? n + 1 | 0 : n, he = he >>> 20 | 0, a = E + he | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Wr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, L = a << 12 | L >>> 20, E = n, Wr = n << 12 | a >>> 20, ai = t[T + 3092 >> 2], n = ai + t[T + 3316 >> 2] | 0, gr = t[T + 3088 >> 2], a = t[T + 3312 >> 2], he = gr + a | 0, Be = he, L = he + L | 0, a = a >>> 0 > he >>> 0 ? n + 1 | 0 : n, n = a + Wr | 0, he = L >>> 0 < he >>> 0 ? n + 1 | 0 : n, Ur(kn, L, he & 1048575, 0, 0, 15632, 16, 0, 0), Un = T + 3216 | 0, Ur(Un, gn, cr, 0, 0, $r, Xn, 0, 0), kn = T + 3264 | 0, Ur(kn, xn, Ir, 0, 0, xn, Ir, 0, 0), cr = T + 3056 | 0, Ur(cr, Bn, Gn, 0, 0, or, Me, 0, 0), Gn = T + 3040 | 0, or = Gn, Me = (a | 0) == (he | 0) & L >>> 0 < Be >>> 0 | a >>> 0 > he >>> 0, Be = (a | 0) == (ai | 0) & Be >>> 0 < gr >>> 0 | a >>> 0 < ai >>> 0, L = Zn + 8 | 0, a = t[L >> 2], n = fi + 8 | 0, Ir = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[L + 4 >> 2] | 0, n = a >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, L = Be + Ir | 0, n = L >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + L | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, L = a << 12 | he >>> 20, he = t[T + 3056 >> 2], Me = L + he | 0, E = n, a = n << 12 | a >>> 20, n = a + t[T + 3060 >> 2] | 0, n = he >>> 0 > Me >>> 0 ? n + 1 | 0 : n, Ur(or, Me, n, 0, 0, 15632, 16, 0, 0), Wr = T + 3024 | 0, Be = Wr, L = (n | 0) == (a | 0) & L >>> 0 > Me >>> 0 | n >>> 0 < a >>> 0, n = cr + 8 | 0, he = t[n >> 2], n = t[n + 4 >> 2], E = E >>> 20 | 0, a = E + he | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + L | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ur(Be, a, n, 0, 0, 64028672, 65536, 0, 0), E = t[T + 3104 >> 2], a = t[T + 3344 >> 2], or = E + a | 0, L = t[T + 3108 >> 2], n = L + t[T + 3348 >> 2] | 0, he = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, L = (L | 0) == (he | 0) & E >>> 0 > or >>> 0 | L >>> 0 > he >>> 0, E = Ti + 8 | 0, a = t[E >> 2], n = Bi + 8 | 0, Be = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, a = L + Be | 0, n = a >>> 0 < Be >>> 0 ? n + 1 | 0 : n, gr = he, Be = a << 12 | he >>> 20, E = n, L = n << 12 | a >>> 20, Me = t[T + 3072 >> 2], a = t[T + 3280 >> 2], he = Me + a | 0, Ir = t[T + 3076 >> 2], n = Ir + t[T + 3284 >> 2] | 0, n = a >>> 0 > he >>> 0 ? n + 1 | 0 : n, a = Be, Be = he, he = a + he | 0, a = n, n = n + L | 0, L = he >>> 0 < Be >>> 0 ? n + 1 | 0 : n, cr = (a | 0) == (L | 0) & he >>> 0 < Be >>> 0 | a >>> 0 > L >>> 0, Me = (a | 0) == (Ir | 0) & Be >>> 0 < Me >>> 0 | a >>> 0 < Ir >>> 0, Be = ni + 8 | 0, a = t[Be >> 2], n = jn + 8 | 0, Ir = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Be + 4 >> 2] | 0, n = a >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, Be = Me + Ir | 0, n = Be >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + Be | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + cr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ir = L, Be = a << 12 | L >>> 20, E = n, L = n << 12 | a >>> 20, Bn = t[T + 3216 >> 2], a = t[T + 3264 >> 2], cr = Bn + a | 0, jn = t[T + 3220 >> 2], n = jn + t[T + 3268 >> 2] | 0, n = a >>> 0 > cr >>> 0 ? n + 1 | 0 : n, a = t[T + 3040 >> 2], Me = a + cr | 0, gn = n, n = n + t[T + 3044 >> 2] | 0, a = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = a + L | 0, L = Be + Me | 0, Be = L >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Xn = (a | 0) == (Be | 0) & L >>> 0 < Me >>> 0 | a >>> 0 > Be >>> 0, $r = (a | 0) == (gn | 0) & Me >>> 0 < cr >>> 0 | a >>> 0 < gn >>> 0, n = Gn + 8 | 0, xn = t[n >> 2], Gn = t[n + 4 >> 2], cr = (gn | 0) == (jn | 0) & cr >>> 0 < Bn >>> 0 | gn >>> 0 < jn >>> 0, Me = kn + 8 | 0, a = t[Me >> 2], n = Un + 8 | 0, gn = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Me + 4 >> 2] | 0, n = a >>> 0 > gn >>> 0 ? n + 1 | 0 : n, a = cr + gn | 0, n = (a >>> 0 < gn >>> 0 ? n + 1 | 0 : n) + Gn | 0, cr = a, a = a + xn | 0, n = cr >>> 0 > a >>> 0 ? n + 1 | 0 : n, Me = a + $r | 0, n = Me >>> 0 < a >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Xn | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, cr = Be, Me = a << 12 | Be >>> 20, E = n, Be = n << 12 | a >>> 20, xn = t[T + 3024 >> 2], xr = xn + (xr & -2) | 0, Gn = t[T + 3028 >> 2], n = Gn + (dr & 1048575) | 0, a = xr >>> 0 < xn >>> 0 ? n + 1 | 0 : n, n = a + Be | 0, dr = tr, gn = Mr & 65535, Me = Me + xr | 0, Be = Me >>> 0 < xr >>> 0 ? n + 1 | 0 : n, tr = Me, Mr = (a | 0) == (Be | 0) & Me >>> 0 < xr >>> 0 | a >>> 0 > Be >>> 0, a = (a | 0) == (Gn | 0) & xr >>> 0 < xn >>> 0 | a >>> 0 < Gn >>> 0, n = Wr + 8 | 0, Me = a + t[n >> 2] | 0, n = t[n + 4 >> 2], n = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Mr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = Be, Me = a << 12 | E >>> 20, Be = Me + dr | 0, n = gn + (n << 12 | a >>> 20) | 0, a = Be, Be = a >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Me = E & 1048575, cr = cr & 1048575, dr = Ir & 1048575, E = or, or = gr & 1048575, d = d - 1 | 0, !!d; )
      ;
    for (d = T + 7336 | 0, xr = d + 32 | 0, t[xr >> 2] = a, t[xr + 4 >> 2] = Be, Mr = d + 24 | 0, t[Mr >> 2] = tr, t[Mr + 4 >> 2] = Me, gr = d + 16 | 0, t[gr >> 2] = L, t[gr + 4 >> 2] = cr, Ir = d + 8 | 0, t[Ir >> 2] = he, t[Ir + 4 >> 2] = dr, t[T + 7336 >> 2] = E, t[T + 7340 >> 2] = or, Xr(d, d, T + 7376 | 0), Be = t[xr + 4 >> 2], n = T + 7296 | 0, d = n + 32 | 0, a = t[xr >> 2], t[d >> 2] = a, t[d + 4 >> 2] = Be, Me = t[Mr + 4 >> 2], d = n + 24 | 0, tr = t[Mr >> 2], t[d >> 2] = tr, t[d + 4 >> 2] = Me, cr = t[gr + 4 >> 2], d = n + 16 | 0, L = t[gr >> 2], t[d >> 2] = L, t[d + 4 >> 2] = cr, dr = t[Ir + 4 >> 2], d = n + 8 | 0, he = t[Ir >> 2], t[d >> 2] = he, t[d + 4 >> 2] = dr, or = t[T + 7340 >> 2], E = t[T + 7336 >> 2], t[T + 7296 >> 2] = E, t[T + 7300 >> 2] = or, d = 44; gr = E, n = or << 1 | E >>> 31, Un = T + 2992 | 0, $r = E << 1, Xn = n, Ur(Un, tr, Me, 0, 0, $r, n, 0, 0), Wr = T + 2912 | 0, E = he << 1, Ir = dr, xn = he, he = dr << 1 | he >>> 31, Ur(Wr, L, cr, 0, 0, E, he, 0, 0), xr = T + 2848 | 0, Ur(xr, a, Be, 0, 0, a, Be, 0, 0), Mr = T + 2832 | 0, Ur(Mr, t[T + 2848 >> 2], t[T + 2852 >> 2], 0, 0, 15632, 16, 0, 0), n = Be << 1 | a >>> 31, Ai = T + 2800 | 0, Bn = a << 1, Gn = n, Ur(Ai, Bn, n, 0, 0, gr, or, 0, 0), yi = T + 2960 | 0, Ur(yi, tr, Me, 0, 0, E, he, 0, 0), Oi = T + 2896 | 0, Ur(Oi, L, cr, 0, 0, L, cr, 0, 0), kn = T + 2816 | 0, n = xr + 8 | 0, Ur(kn, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ti = T + 3008 | 0, Ur(Ti, gr, or, 0, 0, gr, or, 0, 0), Ii = T + 2784 | 0, Ur(Ii, Bn, Gn, 0, 0, xn, dr, 0, 0), wi = T + 2864 | 0, or = tr, gn = L, Ur(wi, tr, Me, 0, 0, L << 1, cr << 1 | L >>> 31, 0, 0), gr = t[T + 2996 >> 2], n = gr + t[T + 2916 >> 2] | 0, L = t[T + 2992 >> 2], E = t[T + 2912 >> 2], a = L + E | 0, he = t[T + 2832 >> 2], xr = a + he | 0, E = a >>> 0 < E >>> 0 ? n + 1 | 0 : n, n = E + t[T + 2836 >> 2] | 0, he = he >>> 0 > xr >>> 0 ? n + 1 | 0 : n, dr = (E | 0) == (he | 0) & a >>> 0 > xr >>> 0 | E >>> 0 > he >>> 0, n = Mr + 8 | 0, Be = t[n >> 2], tr = t[n + 4 >> 2], L = (E | 0) == (gr | 0) & a >>> 0 < L >>> 0 | E >>> 0 < gr >>> 0, E = Wr + 8 | 0, a = t[E >> 2], n = Un + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = L + gr | 0, n = (a >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + tr | 0, E = a, a = a + Be | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + dr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, dr = he, Be = a << 12 | he >>> 20, E = n, L = n << 12 | a >>> 20, ai = t[T + 2960 >> 2], a = t[T + 2896 >> 2], gr = ai + a | 0, Hi = t[T + 2964 >> 2], n = Hi + t[T + 2900 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = t[T + 2800 >> 2], tr = a + gr | 0, Wr = n, n = n + t[T + 2804 >> 2] | 0, n = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, a = t[T + 2816 >> 2], he = a + tr | 0, Mr = n, n = n + t[T + 2820 >> 2] | 0, a = a >>> 0 > he >>> 0 ? n + 1 | 0 : n, n = a + L | 0, Bi = T + 2768 | 0, Be = he + Be | 0, L = Be >>> 0 < he >>> 0 ? n + 1 | 0 : n, ni = (a | 0) == (L | 0) & he >>> 0 > Be >>> 0 | a >>> 0 > L >>> 0, fi = (a | 0) == (Mr | 0) & he >>> 0 < tr >>> 0 | a >>> 0 < Mr >>> 0, n = kn + 8 | 0, Zn = t[n >> 2], jn = t[n + 4 >> 2], Un = (Mr | 0) == (Wr | 0) & tr >>> 0 < gr >>> 0 | Mr >>> 0 < Wr >>> 0, n = Ai + 8 | 0, kn = t[n >> 2], Mr = t[n + 4 >> 2], tr = (Wr | 0) == (Hi | 0) & gr >>> 0 < ai >>> 0 | Wr >>> 0 < Hi >>> 0, he = Oi + 8 | 0, a = t[he >> 2], n = yi + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[he + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = tr + gr | 0, n = (a >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + Mr | 0, he = a, a = a + kn | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, he = a, a = a + Un | 0, n = (he >>> 0 > a >>> 0 ? n + 1 | 0 : n) + jn | 0, he = a, a = a + Zn | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, he = a + fi | 0, n = he >>> 0 < a >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + he | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + ni | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = L, tr = a << 12 | E >>> 20, he = n, Mr = n << 12 | a >>> 20, ai = t[T + 2788 >> 2], n = ai + t[T + 2868 >> 2] | 0, Un = t[T + 2784 >> 2], a = t[T + 2864 >> 2], L = Un + a | 0, gr = L, tr = L + tr | 0, a = a >>> 0 > L >>> 0 ? n + 1 | 0 : n, n = a + Mr | 0, kn = tr << 4 & -16, L = tr >>> 0 < L >>> 0 ? n + 1 | 0 : n, Wr = (L << 4 | tr >>> 28) & 16777215, Mr = E, Ur(Bi, kn | E >>> 16 & 15, Wr, 0, 0, 977, 1, 0, 0), ni = T + 2944 | 0, Ur(ni, xn, Ir, 0, 0, $r, Xn, 0, 0), fi = T + 2752 | 0, Ur(fi, Bn, Gn, 0, 0, gn, cr, 0, 0), Zn = T + 2976 | 0, Ur(Zn, or, Me, 0, 0, or, Me, 0, 0), jn = T + 2736 | 0, kn = jn, Wr = (a | 0) == (L | 0) & tr >>> 0 < gr >>> 0 | a >>> 0 > L >>> 0, tr = (a | 0) == (ai | 0) & gr >>> 0 < Un >>> 0 | a >>> 0 < ai >>> 0, E = wi + 8 | 0, a = t[E >> 2], n = Ii + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, E = tr + gr | 0, n = E >>> 0 < gr >>> 0 ? n + 1 | 0 : n, he = he >>> 20 | 0, a = E + he | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Wr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, L = a << 12 | L >>> 20, E = n, Wr = n << 12 | a >>> 20, ai = t[T + 2756 >> 2], n = ai + t[T + 2980 >> 2] | 0, gr = t[T + 2752 >> 2], a = t[T + 2976 >> 2], he = gr + a | 0, tr = he, L = he + L | 0, a = a >>> 0 > he >>> 0 ? n + 1 | 0 : n, n = a + Wr | 0, he = L >>> 0 < he >>> 0 ? n + 1 | 0 : n, Ur(kn, L, he & 1048575, 0, 0, 15632, 16, 0, 0), Un = T + 2880 | 0, Ur(Un, gn, cr, 0, 0, $r, Xn, 0, 0), kn = T + 2928 | 0, Ur(kn, xn, Ir, 0, 0, xn, Ir, 0, 0), cr = T + 2720 | 0, Ur(cr, Bn, Gn, 0, 0, or, Me, 0, 0), Gn = T + 2704 | 0, or = Gn, Me = (a | 0) == (he | 0) & L >>> 0 < tr >>> 0 | a >>> 0 > he >>> 0, tr = (a | 0) == (ai | 0) & tr >>> 0 < gr >>> 0 | a >>> 0 < ai >>> 0, L = Zn + 8 | 0, a = t[L >> 2], n = fi + 8 | 0, Ir = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[L + 4 >> 2] | 0, n = a >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, L = tr + Ir | 0, n = L >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + L | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, L = a << 12 | he >>> 20, he = t[T + 2720 >> 2], Me = L + he | 0, E = n, a = n << 12 | a >>> 20, n = a + t[T + 2724 >> 2] | 0, n = he >>> 0 > Me >>> 0 ? n + 1 | 0 : n, Ur(or, Me, n, 0, 0, 15632, 16, 0, 0), Wr = T + 2688 | 0, tr = Wr, L = (n | 0) == (a | 0) & L >>> 0 > Me >>> 0 | n >>> 0 < a >>> 0, n = cr + 8 | 0, he = t[n >> 2], n = t[n + 4 >> 2], E = E >>> 20 | 0, a = E + he | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + L | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ur(tr, a, n, 0, 0, 64028672, 65536, 0, 0), E = t[T + 2768 >> 2], a = t[T + 3008 >> 2], or = E + a | 0, L = t[T + 2772 >> 2], n = L + t[T + 3012 >> 2] | 0, he = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, L = (L | 0) == (he | 0) & E >>> 0 > or >>> 0 | L >>> 0 > he >>> 0, E = Ti + 8 | 0, a = t[E >> 2], n = Bi + 8 | 0, tr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, a = L + tr | 0, n = a >>> 0 < tr >>> 0 ? n + 1 | 0 : n, gr = he, L = a << 12 | he >>> 20, E = n, he = n << 12 | a >>> 20, Me = t[T + 2736 >> 2], a = t[T + 2944 >> 2], tr = Me + a | 0, Ir = t[T + 2740 >> 2], n = Ir + t[T + 2948 >> 2] | 0, a = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, n = a + he | 0, he = L + tr | 0, L = he >>> 0 < tr >>> 0 ? n + 1 | 0 : n, cr = (a | 0) == (L | 0) & he >>> 0 < tr >>> 0 | a >>> 0 > L >>> 0, Me = (a | 0) == (Ir | 0) & Me >>> 0 > tr >>> 0 | a >>> 0 < Ir >>> 0, tr = ni + 8 | 0, a = t[tr >> 2], n = jn + 8 | 0, Ir = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[tr + 4 >> 2] | 0, n = a >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, tr = Me + Ir | 0, n = tr >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + tr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + cr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ir = L, tr = a << 12 | L >>> 20, E = n, L = n << 12 | a >>> 20, Bn = t[T + 2880 >> 2], a = t[T + 2928 >> 2], cr = Bn + a | 0, jn = t[T + 2884 >> 2], n = jn + t[T + 2932 >> 2] | 0, n = a >>> 0 > cr >>> 0 ? n + 1 | 0 : n, a = t[T + 2704 >> 2], Me = a + cr | 0, gn = n, n = n + t[T + 2708 >> 2] | 0, a = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = a + L | 0, L = Me + tr | 0, tr = L >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Xn = (a | 0) == (tr | 0) & L >>> 0 < Me >>> 0 | a >>> 0 > tr >>> 0, $r = (a | 0) == (gn | 0) & Me >>> 0 < cr >>> 0 | a >>> 0 < gn >>> 0, n = Gn + 8 | 0, xn = t[n >> 2], Gn = t[n + 4 >> 2], cr = (gn | 0) == (jn | 0) & cr >>> 0 < Bn >>> 0 | gn >>> 0 < jn >>> 0, Me = kn + 8 | 0, a = t[Me >> 2], n = Un + 8 | 0, gn = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Me + 4 >> 2] | 0, n = a >>> 0 > gn >>> 0 ? n + 1 | 0 : n, a = cr + gn | 0, n = (a >>> 0 < gn >>> 0 ? n + 1 | 0 : n) + Gn | 0, cr = a, a = a + xn | 0, n = cr >>> 0 > a >>> 0 ? n + 1 | 0 : n, Me = a + $r | 0, n = Me >>> 0 < a >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Xn | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, cr = tr, gn = a << 12 | tr >>> 20, E = n, Me = n << 12 | a >>> 20, xn = t[T + 2688 >> 2], tr = xn + (xr & -2) | 0, Gn = t[T + 2692 >> 2], n = Gn + (dr & 1048575) | 0, n = tr >>> 0 < xn >>> 0 ? n + 1 | 0 : n, xr = tr, tr = tr + gn | 0, a = n, n = n + Me | 0, dr = Be, gn = Mr & 65535, Me = tr >>> 0 < xr >>> 0 ? n + 1 | 0 : n, Mr = (a | 0) == (Me | 0) & tr >>> 0 < xr >>> 0 | a >>> 0 > Me >>> 0, a = (a | 0) == (Gn | 0) & xr >>> 0 < xn >>> 0 | a >>> 0 < Gn >>> 0, n = Wr + 8 | 0, Be = a + t[n >> 2] | 0, n = t[n + 4 >> 2], n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + Be | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Mr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, Be = a << 12 | Me >>> 20, E = Be + dr | 0, n = gn + (n << 12 | a >>> 20) | 0, a = E, Be = a >>> 0 < Be >>> 0 ? n + 1 | 0 : n, Me = Me & 1048575, cr = cr & 1048575, dr = Ir & 1048575, E = or, or = gr & 1048575, d = d - 1 | 0, !!d; )
      ;
    for (d = T + 7296 | 0, xr = d + 32 | 0, t[xr >> 2] = a, t[xr + 4 >> 2] = Be, Mr = d + 24 | 0, t[Mr >> 2] = tr, t[Mr + 4 >> 2] = Me, gr = d + 16 | 0, t[gr >> 2] = L, t[gr + 4 >> 2] = cr, Ir = d + 8 | 0, t[Ir >> 2] = he, t[Ir + 4 >> 2] = dr, t[T + 7296 >> 2] = E, t[T + 7300 >> 2] = or, Xr(d, d, T + 7336 | 0), Be = t[xr + 4 >> 2], n = T + 7256 | 0, d = n + 32 | 0, a = t[xr >> 2], t[d >> 2] = a, t[d + 4 >> 2] = Be, Me = t[Mr + 4 >> 2], d = n + 24 | 0, tr = t[Mr >> 2], t[d >> 2] = tr, t[d + 4 >> 2] = Me, cr = t[gr + 4 >> 2], d = n + 16 | 0, L = t[gr >> 2], t[d >> 2] = L, t[d + 4 >> 2] = cr, dr = t[Ir + 4 >> 2], d = n + 8 | 0, he = t[Ir >> 2], t[d >> 2] = he, t[d + 4 >> 2] = dr, or = t[T + 7300 >> 2], E = t[T + 7296 >> 2], t[T + 7256 >> 2] = E, t[T + 7260 >> 2] = or, d = 88; gr = E, n = or << 1 | E >>> 31, Un = T + 2656 | 0, $r = E << 1, Xn = n, Ur(Un, tr, Me, 0, 0, $r, n, 0, 0), Wr = T + 2576 | 0, E = he << 1, Ir = dr, xn = he, he = dr << 1 | he >>> 31, Ur(Wr, L, cr, 0, 0, E, he, 0, 0), xr = T + 2512 | 0, Ur(xr, a, Be, 0, 0, a, Be, 0, 0), Mr = T + 2496 | 0, Ur(Mr, t[T + 2512 >> 2], t[T + 2516 >> 2], 0, 0, 15632, 16, 0, 0), n = Be << 1 | a >>> 31, Ai = T + 2464 | 0, Bn = a << 1, Gn = n, Ur(Ai, Bn, n, 0, 0, gr, or, 0, 0), yi = T + 2624 | 0, Ur(yi, tr, Me, 0, 0, E, he, 0, 0), Oi = T + 2560 | 0, Ur(Oi, L, cr, 0, 0, L, cr, 0, 0), kn = T + 2480 | 0, n = xr + 8 | 0, Ur(kn, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ti = T + 2672 | 0, Ur(Ti, gr, or, 0, 0, gr, or, 0, 0), Ii = T + 2448 | 0, Ur(Ii, Bn, Gn, 0, 0, xn, dr, 0, 0), wi = T + 2528 | 0, or = tr, gn = L, Ur(wi, tr, Me, 0, 0, L << 1, cr << 1 | L >>> 31, 0, 0), gr = t[T + 2660 >> 2], n = gr + t[T + 2580 >> 2] | 0, L = t[T + 2656 >> 2], E = t[T + 2576 >> 2], a = L + E | 0, he = t[T + 2496 >> 2], xr = a + he | 0, E = a >>> 0 < E >>> 0 ? n + 1 | 0 : n, n = E + t[T + 2500 >> 2] | 0, he = he >>> 0 > xr >>> 0 ? n + 1 | 0 : n, dr = (E | 0) == (he | 0) & a >>> 0 > xr >>> 0 | E >>> 0 > he >>> 0, n = Mr + 8 | 0, Be = t[n >> 2], tr = t[n + 4 >> 2], L = (E | 0) == (gr | 0) & a >>> 0 < L >>> 0 | E >>> 0 < gr >>> 0, E = Wr + 8 | 0, a = t[E >> 2], n = Un + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = L + gr | 0, n = (a >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + tr | 0, E = a, a = a + Be | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + dr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, dr = he, tr = a << 12 | he >>> 20, E = n, L = n << 12 | a >>> 20, ai = t[T + 2624 >> 2], a = t[T + 2560 >> 2], gr = ai + a | 0, Hi = t[T + 2628 >> 2], n = Hi + t[T + 2564 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = t[T + 2464 >> 2], Be = a + gr | 0, Wr = n, n = n + t[T + 2468 >> 2] | 0, n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, a = t[T + 2480 >> 2], he = a + Be | 0, Mr = n, n = n + t[T + 2484 >> 2] | 0, a = a >>> 0 > he >>> 0 ? n + 1 | 0 : n, n = a + L | 0, Bi = T + 2432 | 0, tr = he + tr | 0, L = tr >>> 0 < he >>> 0 ? n + 1 | 0 : n, ni = (a | 0) == (L | 0) & he >>> 0 > tr >>> 0 | a >>> 0 > L >>> 0, fi = (a | 0) == (Mr | 0) & he >>> 0 < Be >>> 0 | a >>> 0 < Mr >>> 0, n = kn + 8 | 0, Zn = t[n >> 2], jn = t[n + 4 >> 2], Un = (Mr | 0) == (Wr | 0) & Be >>> 0 < gr >>> 0 | Mr >>> 0 < Wr >>> 0, n = Ai + 8 | 0, kn = t[n >> 2], Mr = t[n + 4 >> 2], Be = (Wr | 0) == (Hi | 0) & gr >>> 0 < ai >>> 0 | Wr >>> 0 < Hi >>> 0, he = Oi + 8 | 0, a = t[he >> 2], n = yi + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[he + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = Be + gr | 0, n = (a >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + Mr | 0, he = a, a = a + kn | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, he = a, a = a + Un | 0, n = (he >>> 0 > a >>> 0 ? n + 1 | 0 : n) + jn | 0, he = a, a = a + Zn | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, he = a + fi | 0, n = he >>> 0 < a >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + he | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + ni | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = L, Be = a << 12 | E >>> 20, he = n, Mr = n << 12 | a >>> 20, ai = t[T + 2452 >> 2], n = ai + t[T + 2532 >> 2] | 0, Un = t[T + 2448 >> 2], a = t[T + 2528 >> 2], L = Un + a | 0, gr = L, Be = L + Be | 0, a = a >>> 0 > L >>> 0 ? n + 1 | 0 : n, n = a + Mr | 0, kn = Be << 4 & -16, L = Be >>> 0 < L >>> 0 ? n + 1 | 0 : n, Wr = (L << 4 | Be >>> 28) & 16777215, Mr = E, Ur(Bi, kn | E >>> 16 & 15, Wr, 0, 0, 977, 1, 0, 0), ni = T + 2608 | 0, Ur(ni, xn, Ir, 0, 0, $r, Xn, 0, 0), fi = T + 2416 | 0, Ur(fi, Bn, Gn, 0, 0, gn, cr, 0, 0), Zn = T + 2640 | 0, Ur(Zn, or, Me, 0, 0, or, Me, 0, 0), jn = T + 2400 | 0, kn = jn, Wr = (a | 0) == (L | 0) & Be >>> 0 < gr >>> 0 | a >>> 0 > L >>> 0, Be = (a | 0) == (ai | 0) & gr >>> 0 < Un >>> 0 | a >>> 0 < ai >>> 0, E = wi + 8 | 0, a = t[E >> 2], n = Ii + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, E = Be + gr | 0, n = E >>> 0 < gr >>> 0 ? n + 1 | 0 : n, he = he >>> 20 | 0, a = E + he | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Wr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, L = a << 12 | L >>> 20, E = n, Wr = n << 12 | a >>> 20, ai = t[T + 2420 >> 2], n = ai + t[T + 2644 >> 2] | 0, gr = t[T + 2416 >> 2], a = t[T + 2640 >> 2], he = gr + a | 0, Be = he, L = he + L | 0, a = a >>> 0 > he >>> 0 ? n + 1 | 0 : n, n = a + Wr | 0, he = L >>> 0 < he >>> 0 ? n + 1 | 0 : n, Ur(kn, L, he & 1048575, 0, 0, 15632, 16, 0, 0), Un = T + 2544 | 0, Ur(Un, gn, cr, 0, 0, $r, Xn, 0, 0), kn = T + 2592 | 0, Ur(kn, xn, Ir, 0, 0, xn, Ir, 0, 0), cr = T + 2384 | 0, Ur(cr, Bn, Gn, 0, 0, or, Me, 0, 0), Gn = T + 2368 | 0, or = Gn, Me = (a | 0) == (he | 0) & L >>> 0 < Be >>> 0 | a >>> 0 > he >>> 0, Be = (a | 0) == (ai | 0) & Be >>> 0 < gr >>> 0 | a >>> 0 < ai >>> 0, L = Zn + 8 | 0, a = t[L >> 2], n = fi + 8 | 0, Ir = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[L + 4 >> 2] | 0, n = a >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, L = Be + Ir | 0, n = L >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + L | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, L = a << 12 | he >>> 20, he = t[T + 2384 >> 2], Me = L + he | 0, E = n, a = n << 12 | a >>> 20, n = a + t[T + 2388 >> 2] | 0, n = he >>> 0 > Me >>> 0 ? n + 1 | 0 : n, Ur(or, Me, n, 0, 0, 15632, 16, 0, 0), Wr = T + 2352 | 0, Be = Wr, L = (n | 0) == (a | 0) & L >>> 0 > Me >>> 0 | n >>> 0 < a >>> 0, n = cr + 8 | 0, he = t[n >> 2], n = t[n + 4 >> 2], E = E >>> 20 | 0, a = E + he | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + L | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ur(Be, a, n, 0, 0, 64028672, 65536, 0, 0), E = t[T + 2432 >> 2], a = t[T + 2672 >> 2], or = E + a | 0, L = t[T + 2436 >> 2], n = L + t[T + 2676 >> 2] | 0, he = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, L = (L | 0) == (he | 0) & E >>> 0 > or >>> 0 | L >>> 0 > he >>> 0, E = Ti + 8 | 0, a = t[E >> 2], n = Bi + 8 | 0, Be = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, a = L + Be | 0, n = a >>> 0 < Be >>> 0 ? n + 1 | 0 : n, gr = he, Be = a << 12 | he >>> 20, E = n, L = n << 12 | a >>> 20, Me = t[T + 2400 >> 2], a = t[T + 2608 >> 2], he = Me + a | 0, Ir = t[T + 2404 >> 2], n = Ir + t[T + 2612 >> 2] | 0, n = a >>> 0 > he >>> 0 ? n + 1 | 0 : n, a = Be, Be = he, he = a + he | 0, a = n, n = n + L | 0, L = he >>> 0 < Be >>> 0 ? n + 1 | 0 : n, cr = (a | 0) == (L | 0) & he >>> 0 < Be >>> 0 | a >>> 0 > L >>> 0, Me = (a | 0) == (Ir | 0) & Be >>> 0 < Me >>> 0 | a >>> 0 < Ir >>> 0, Be = ni + 8 | 0, a = t[Be >> 2], n = jn + 8 | 0, Ir = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Be + 4 >> 2] | 0, n = a >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, Be = Me + Ir | 0, n = Be >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + Be | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + cr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ir = L, Be = a << 12 | L >>> 20, E = n, L = n << 12 | a >>> 20, Bn = t[T + 2544 >> 2], a = t[T + 2592 >> 2], cr = Bn + a | 0, jn = t[T + 2548 >> 2], n = jn + t[T + 2596 >> 2] | 0, n = a >>> 0 > cr >>> 0 ? n + 1 | 0 : n, a = t[T + 2368 >> 2], Me = a + cr | 0, gn = n, n = n + t[T + 2372 >> 2] | 0, a = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = a + L | 0, L = Be + Me | 0, Be = L >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Xn = (a | 0) == (Be | 0) & L >>> 0 < Me >>> 0 | a >>> 0 > Be >>> 0, $r = (a | 0) == (gn | 0) & Me >>> 0 < cr >>> 0 | a >>> 0 < gn >>> 0, n = Gn + 8 | 0, xn = t[n >> 2], Gn = t[n + 4 >> 2], cr = (gn | 0) == (jn | 0) & cr >>> 0 < Bn >>> 0 | gn >>> 0 < jn >>> 0, Me = kn + 8 | 0, a = t[Me >> 2], n = Un + 8 | 0, gn = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Me + 4 >> 2] | 0, n = a >>> 0 > gn >>> 0 ? n + 1 | 0 : n, a = cr + gn | 0, n = (a >>> 0 < gn >>> 0 ? n + 1 | 0 : n) + Gn | 0, cr = a, a = a + xn | 0, n = cr >>> 0 > a >>> 0 ? n + 1 | 0 : n, Me = a + $r | 0, n = Me >>> 0 < a >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Xn | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, cr = Be, Me = a << 12 | Be >>> 20, E = n, Be = n << 12 | a >>> 20, xn = t[T + 2352 >> 2], xr = xn + (xr & -2) | 0, Gn = t[T + 2356 >> 2], n = Gn + (dr & 1048575) | 0, a = xr >>> 0 < xn >>> 0 ? n + 1 | 0 : n, n = a + Be | 0, dr = tr, gn = Mr & 65535, Me = Me + xr | 0, Be = Me >>> 0 < xr >>> 0 ? n + 1 | 0 : n, tr = Me, Mr = (a | 0) == (Be | 0) & Me >>> 0 < xr >>> 0 | a >>> 0 > Be >>> 0, a = (a | 0) == (Gn | 0) & xr >>> 0 < xn >>> 0 | a >>> 0 < Gn >>> 0, n = Wr + 8 | 0, Me = a + t[n >> 2] | 0, n = t[n + 4 >> 2], n = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Mr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = Be, Me = a << 12 | E >>> 20, Be = Me + dr | 0, n = gn + (n << 12 | a >>> 20) | 0, a = Be, Be = a >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Me = E & 1048575, cr = cr & 1048575, dr = Ir & 1048575, E = or, or = gr & 1048575, d = d - 1 | 0, !!d; )
      ;
    for (d = T + 7256 | 0, xr = d + 32 | 0, t[xr >> 2] = a, t[xr + 4 >> 2] = Be, Mr = d + 24 | 0, t[Mr >> 2] = tr, t[Mr + 4 >> 2] = Me, gr = d + 16 | 0, t[gr >> 2] = L, t[gr + 4 >> 2] = cr, Ir = d + 8 | 0, t[Ir >> 2] = he, t[Ir + 4 >> 2] = dr, t[T + 7256 >> 2] = E, t[T + 7260 >> 2] = or, Xr(d, d, T + 7296 | 0), Be = t[xr + 4 >> 2], n = T + 7216 | 0, d = n + 32 | 0, a = t[xr >> 2], t[d >> 2] = a, t[d + 4 >> 2] = Be, Me = t[Mr + 4 >> 2], d = n + 24 | 0, tr = t[Mr >> 2], t[d >> 2] = tr, t[d + 4 >> 2] = Me, cr = t[gr + 4 >> 2], d = n + 16 | 0, L = t[gr >> 2], t[d >> 2] = L, t[d + 4 >> 2] = cr, dr = t[Ir + 4 >> 2], d = n + 8 | 0, he = t[Ir >> 2], t[d >> 2] = he, t[d + 4 >> 2] = dr, or = t[T + 7260 >> 2], E = t[T + 7256 >> 2], t[T + 7216 >> 2] = E, t[T + 7220 >> 2] = or, d = 44; gr = E, n = or << 1 | E >>> 31, Un = T + 2320 | 0, $r = E << 1, Xn = n, Ur(Un, tr, Me, 0, 0, $r, n, 0, 0), Wr = T + 2240 | 0, E = he << 1, Ir = dr, xn = he, he = dr << 1 | he >>> 31, Ur(Wr, L, cr, 0, 0, E, he, 0, 0), xr = T + 2176 | 0, Ur(xr, a, Be, 0, 0, a, Be, 0, 0), Mr = T + 2160 | 0, Ur(Mr, t[T + 2176 >> 2], t[T + 2180 >> 2], 0, 0, 15632, 16, 0, 0), n = Be << 1 | a >>> 31, Ai = T + 2128 | 0, Bn = a << 1, Gn = n, Ur(Ai, Bn, n, 0, 0, gr, or, 0, 0), yi = T + 2288 | 0, Ur(yi, tr, Me, 0, 0, E, he, 0, 0), Oi = T + 2224 | 0, Ur(Oi, L, cr, 0, 0, L, cr, 0, 0), kn = T + 2144 | 0, n = xr + 8 | 0, Ur(kn, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ti = T + 2336 | 0, Ur(Ti, gr, or, 0, 0, gr, or, 0, 0), Ii = T + 2112 | 0, Ur(Ii, Bn, Gn, 0, 0, xn, dr, 0, 0), wi = T + 2192 | 0, or = tr, gn = L, Ur(wi, tr, Me, 0, 0, L << 1, cr << 1 | L >>> 31, 0, 0), gr = t[T + 2324 >> 2], n = gr + t[T + 2244 >> 2] | 0, L = t[T + 2320 >> 2], E = t[T + 2240 >> 2], a = L + E | 0, he = t[T + 2160 >> 2], xr = a + he | 0, E = a >>> 0 < E >>> 0 ? n + 1 | 0 : n, n = E + t[T + 2164 >> 2] | 0, he = he >>> 0 > xr >>> 0 ? n + 1 | 0 : n, dr = (E | 0) == (he | 0) & a >>> 0 > xr >>> 0 | E >>> 0 > he >>> 0, n = Mr + 8 | 0, Be = t[n >> 2], tr = t[n + 4 >> 2], L = (E | 0) == (gr | 0) & a >>> 0 < L >>> 0 | E >>> 0 < gr >>> 0, E = Wr + 8 | 0, a = t[E >> 2], n = Un + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = L + gr | 0, n = (a >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + tr | 0, E = a, a = a + Be | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + dr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, dr = he, Be = a << 12 | he >>> 20, E = n, L = n << 12 | a >>> 20, ai = t[T + 2288 >> 2], a = t[T + 2224 >> 2], gr = ai + a | 0, Hi = t[T + 2292 >> 2], n = Hi + t[T + 2228 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = t[T + 2128 >> 2], tr = a + gr | 0, Wr = n, n = n + t[T + 2132 >> 2] | 0, n = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, a = t[T + 2144 >> 2], he = a + tr | 0, Mr = n, n = n + t[T + 2148 >> 2] | 0, a = a >>> 0 > he >>> 0 ? n + 1 | 0 : n, n = a + L | 0, Bi = T + 2096 | 0, Be = he + Be | 0, L = Be >>> 0 < he >>> 0 ? n + 1 | 0 : n, ni = (a | 0) == (L | 0) & he >>> 0 > Be >>> 0 | a >>> 0 > L >>> 0, fi = (a | 0) == (Mr | 0) & he >>> 0 < tr >>> 0 | a >>> 0 < Mr >>> 0, n = kn + 8 | 0, Zn = t[n >> 2], jn = t[n + 4 >> 2], Un = (Mr | 0) == (Wr | 0) & tr >>> 0 < gr >>> 0 | Mr >>> 0 < Wr >>> 0, n = Ai + 8 | 0, kn = t[n >> 2], Mr = t[n + 4 >> 2], tr = (Wr | 0) == (Hi | 0) & gr >>> 0 < ai >>> 0 | Wr >>> 0 < Hi >>> 0, he = Oi + 8 | 0, a = t[he >> 2], n = yi + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[he + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = tr + gr | 0, n = (a >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + Mr | 0, he = a, a = a + kn | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, he = a, a = a + Un | 0, n = (he >>> 0 > a >>> 0 ? n + 1 | 0 : n) + jn | 0, he = a, a = a + Zn | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, he = a + fi | 0, n = he >>> 0 < a >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + he | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + ni | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = L, tr = a << 12 | E >>> 20, he = n, Mr = n << 12 | a >>> 20, ai = t[T + 2116 >> 2], n = ai + t[T + 2196 >> 2] | 0, Un = t[T + 2112 >> 2], a = t[T + 2192 >> 2], L = Un + a | 0, gr = L, tr = L + tr | 0, a = a >>> 0 > L >>> 0 ? n + 1 | 0 : n, n = a + Mr | 0, kn = tr << 4 & -16, L = tr >>> 0 < L >>> 0 ? n + 1 | 0 : n, Wr = (L << 4 | tr >>> 28) & 16777215, Mr = E, Ur(Bi, kn | E >>> 16 & 15, Wr, 0, 0, 977, 1, 0, 0), ni = T + 2272 | 0, Ur(ni, xn, Ir, 0, 0, $r, Xn, 0, 0), fi = T + 2080 | 0, Ur(fi, Bn, Gn, 0, 0, gn, cr, 0, 0), Zn = T + 2304 | 0, Ur(Zn, or, Me, 0, 0, or, Me, 0, 0), jn = T + 2064 | 0, kn = jn, Wr = (a | 0) == (L | 0) & tr >>> 0 < gr >>> 0 | a >>> 0 > L >>> 0, tr = (a | 0) == (ai | 0) & gr >>> 0 < Un >>> 0 | a >>> 0 < ai >>> 0, E = wi + 8 | 0, a = t[E >> 2], n = Ii + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, E = tr + gr | 0, n = E >>> 0 < gr >>> 0 ? n + 1 | 0 : n, he = he >>> 20 | 0, a = E + he | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Wr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, L = a << 12 | L >>> 20, E = n, Wr = n << 12 | a >>> 20, ai = t[T + 2084 >> 2], n = ai + t[T + 2308 >> 2] | 0, gr = t[T + 2080 >> 2], a = t[T + 2304 >> 2], he = gr + a | 0, tr = he, L = he + L | 0, a = a >>> 0 > he >>> 0 ? n + 1 | 0 : n, n = a + Wr | 0, he = L >>> 0 < he >>> 0 ? n + 1 | 0 : n, Ur(kn, L, he & 1048575, 0, 0, 15632, 16, 0, 0), Un = T + 2208 | 0, Ur(Un, gn, cr, 0, 0, $r, Xn, 0, 0), kn = T + 2256 | 0, Ur(kn, xn, Ir, 0, 0, xn, Ir, 0, 0), cr = T + 2048 | 0, Ur(cr, Bn, Gn, 0, 0, or, Me, 0, 0), Gn = T + 2032 | 0, or = Gn, Me = (a | 0) == (he | 0) & L >>> 0 < tr >>> 0 | a >>> 0 > he >>> 0, tr = (a | 0) == (ai | 0) & tr >>> 0 < gr >>> 0 | a >>> 0 < ai >>> 0, L = Zn + 8 | 0, a = t[L >> 2], n = fi + 8 | 0, Ir = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[L + 4 >> 2] | 0, n = a >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, L = tr + Ir | 0, n = L >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + L | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, L = a << 12 | he >>> 20, he = t[T + 2048 >> 2], Me = L + he | 0, E = n, a = n << 12 | a >>> 20, n = a + t[T + 2052 >> 2] | 0, n = he >>> 0 > Me >>> 0 ? n + 1 | 0 : n, Ur(or, Me, n, 0, 0, 15632, 16, 0, 0), Wr = T + 2016 | 0, tr = Wr, L = (n | 0) == (a | 0) & L >>> 0 > Me >>> 0 | n >>> 0 < a >>> 0, n = cr + 8 | 0, he = t[n >> 2], n = t[n + 4 >> 2], E = E >>> 20 | 0, a = E + he | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + L | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ur(tr, a, n, 0, 0, 64028672, 65536, 0, 0), E = t[T + 2096 >> 2], a = t[T + 2336 >> 2], or = E + a | 0, L = t[T + 2100 >> 2], n = L + t[T + 2340 >> 2] | 0, he = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, L = (L | 0) == (he | 0) & E >>> 0 > or >>> 0 | L >>> 0 > he >>> 0, E = Ti + 8 | 0, a = t[E >> 2], n = Bi + 8 | 0, tr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, a = L + tr | 0, n = a >>> 0 < tr >>> 0 ? n + 1 | 0 : n, gr = he, L = a << 12 | he >>> 20, E = n, he = n << 12 | a >>> 20, Me = t[T + 2064 >> 2], a = t[T + 2272 >> 2], tr = Me + a | 0, Ir = t[T + 2068 >> 2], n = Ir + t[T + 2276 >> 2] | 0, a = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, n = a + he | 0, he = L + tr | 0, L = he >>> 0 < tr >>> 0 ? n + 1 | 0 : n, cr = (a | 0) == (L | 0) & he >>> 0 < tr >>> 0 | a >>> 0 > L >>> 0, Me = (a | 0) == (Ir | 0) & Me >>> 0 > tr >>> 0 | a >>> 0 < Ir >>> 0, tr = ni + 8 | 0, a = t[tr >> 2], n = jn + 8 | 0, Ir = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[tr + 4 >> 2] | 0, n = a >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, tr = Me + Ir | 0, n = tr >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + tr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + cr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ir = L, tr = a << 12 | L >>> 20, E = n, L = n << 12 | a >>> 20, Bn = t[T + 2208 >> 2], a = t[T + 2256 >> 2], cr = Bn + a | 0, jn = t[T + 2212 >> 2], n = jn + t[T + 2260 >> 2] | 0, n = a >>> 0 > cr >>> 0 ? n + 1 | 0 : n, a = t[T + 2032 >> 2], Me = a + cr | 0, gn = n, n = n + t[T + 2036 >> 2] | 0, a = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = a + L | 0, L = Me + tr | 0, tr = L >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Xn = (a | 0) == (tr | 0) & L >>> 0 < Me >>> 0 | a >>> 0 > tr >>> 0, $r = (a | 0) == (gn | 0) & Me >>> 0 < cr >>> 0 | a >>> 0 < gn >>> 0, n = Gn + 8 | 0, xn = t[n >> 2], Gn = t[n + 4 >> 2], cr = (gn | 0) == (jn | 0) & cr >>> 0 < Bn >>> 0 | gn >>> 0 < jn >>> 0, Me = kn + 8 | 0, a = t[Me >> 2], n = Un + 8 | 0, gn = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Me + 4 >> 2] | 0, n = a >>> 0 > gn >>> 0 ? n + 1 | 0 : n, a = cr + gn | 0, n = (a >>> 0 < gn >>> 0 ? n + 1 | 0 : n) + Gn | 0, cr = a, a = a + xn | 0, n = cr >>> 0 > a >>> 0 ? n + 1 | 0 : n, Me = a + $r | 0, n = Me >>> 0 < a >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Xn | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, cr = tr, gn = a << 12 | tr >>> 20, E = n, Me = n << 12 | a >>> 20, xn = t[T + 2016 >> 2], tr = xn + (xr & -2) | 0, Gn = t[T + 2020 >> 2], n = Gn + (dr & 1048575) | 0, n = tr >>> 0 < xn >>> 0 ? n + 1 | 0 : n, xr = tr, tr = tr + gn | 0, a = n, n = n + Me | 0, dr = Be, gn = Mr & 65535, Me = tr >>> 0 < xr >>> 0 ? n + 1 | 0 : n, Mr = (a | 0) == (Me | 0) & tr >>> 0 < xr >>> 0 | a >>> 0 > Me >>> 0, a = (a | 0) == (Gn | 0) & xr >>> 0 < xn >>> 0 | a >>> 0 < Gn >>> 0, n = Wr + 8 | 0, Be = a + t[n >> 2] | 0, n = t[n + 4 >> 2], n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + Be | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Mr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, Be = a << 12 | Me >>> 20, E = Be + dr | 0, n = gn + (n << 12 | a >>> 20) | 0, a = E, Be = a >>> 0 < Be >>> 0 ? n + 1 | 0 : n, Me = Me & 1048575, cr = cr & 1048575, dr = Ir & 1048575, E = or, or = gr & 1048575, d = d - 1 | 0, !!d; )
      ;
    for (n = T + 7216 | 0, xn = n + 32 | 0, t[xn >> 2] = a, t[xn + 4 >> 2] = Be, d = n + 24 | 0, t[d >> 2] = tr, t[d + 4 >> 2] = Me, Be = n + 16 | 0, t[Be >> 2] = L, t[Be + 4 >> 2] = cr, xr = n + 8 | 0, t[xr >> 2] = he, t[xr + 4 >> 2] = dr, t[T + 7216 >> 2] = E, t[T + 7220 >> 2] = or, Xr(n, n, T + 7336 | 0), or = t[d >> 2], E = or, Me = t[d + 4 >> 2], a = Me, d = t[T + 7220 >> 2], $r = d, Mr = t[T + 7216 >> 2], L = Mr, n = d << 1 | L >>> 31, gr = T + 1856 | 0, gn = L << 1, Gn = n, Ur(gr, E, a, 0, 0, gn, n, 0, 0), d = t[xr + 4 >> 2], Hi = d, Ai = t[xr >> 2], a = Ai, n = d << 1 | a >>> 31, Ir = T + 1952 | 0, cr = t[Be >> 2], Be = t[Be + 4 >> 2], a = a << 1, E = n, Ur(Ir, cr, Be, 0, 0, a, n, 0, 0), dr = T + 1840 | 0, he = t[xn >> 2], d = t[xn + 4 >> 2], Ur(dr, he, d, 0, 0, he, d, 0, 0), tr = T + 1824 | 0, Ur(tr, t[T + 1840 >> 2], t[T + 1844 >> 2], 0, 0, 15632, 16, 0, 0), n = d << 1 | he >>> 31, Oi = T + 1792 | 0, xn = he << 1, xr = n, Ur(Oi, xn, n, 0, 0, L, $r, 0, 0), Ti = T + 1872 | 0, Ur(Ti, or, Me, 0, 0, a, E, 0, 0), Ii = T + 1936 | 0, Ur(Ii, cr, Be, 0, 0, cr, Be, 0, 0), Xn = T + 1808 | 0, d = dr + 8 | 0, Ur(Xn, t[d >> 2], t[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), wi = T + 2e3 | 0, Ur(wi, L, $r, 0, 0, L, $r, 0, 0), ai = T + 1776 | 0, Ur(ai, xn, n, 0, 0, Ai, Hi, 0, 0), Bi = T + 1888 | 0, Ur(Bi, or, Me, 0, 0, cr << 1, Be << 1 | cr >>> 31, 0, 0), $r = t[T + 1860 >> 2], n = $r + t[T + 1956 >> 2] | 0, he = t[T + 1856 >> 2], a = t[T + 1952 >> 2], d = he + a | 0, E = t[T + 1824 >> 2], Mr = d + E | 0, a = d >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = a + t[T + 1828 >> 2] | 0, E = E >>> 0 > Mr >>> 0 ? n + 1 | 0 : n, dr = (a | 0) == (E | 0) & d >>> 0 > Mr >>> 0 | a >>> 0 > E >>> 0, n = tr + 8 | 0, tr = t[n >> 2], L = t[n + 4 >> 2], he = (a | 0) == ($r | 0) & d >>> 0 < he >>> 0 | a >>> 0 < $r >>> 0, n = Ir + 8 | 0, a = t[n >> 2], d = gr + 8 | 0, Ir = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, d = he + Ir | 0, n = (d >>> 0 < Ir >>> 0 ? n + 1 | 0 : n) + L | 0, a = d, d = d + tr | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + dr | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, gr = E, tr = d << 12 | E >>> 20, a = n, he = n << 12 | d >>> 20, ni = t[T + 1872 >> 2], d = t[T + 1936 >> 2], dr = ni + d | 0, yi = t[T + 1876 >> 2], n = yi + t[T + 1940 >> 2] | 0, n = d >>> 0 > dr >>> 0 ? n + 1 | 0 : n, d = t[T + 1792 >> 2], L = d + dr | 0, $r = n, n = n + t[T + 1796 >> 2] | 0, n = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, d = t[T + 1808 >> 2], E = d + L | 0, Ir = n, n = n + t[T + 1812 >> 2] | 0, d = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, n = d + he | 0, fi = T + 1760 | 0, Zn = fi, tr = E + tr | 0, he = tr >>> 0 < E >>> 0 ? n + 1 | 0 : n, jn = (d | 0) == (he | 0) & E >>> 0 > tr >>> 0 | d >>> 0 > he >>> 0, Un = (d | 0) == (Ir | 0) & E >>> 0 < L >>> 0 | d >>> 0 < Ir >>> 0, d = Xn + 8 | 0, kn = t[d >> 2], Wr = t[d + 4 >> 2], Bn = (Ir | 0) == ($r | 0) & L >>> 0 < dr >>> 0 | Ir >>> 0 < $r >>> 0, d = Oi + 8 | 0, Xn = t[d >> 2], Ir = t[d + 4 >> 2], L = ($r | 0) == (yi | 0) & dr >>> 0 < ni >>> 0 | $r >>> 0 < yi >>> 0, n = Ii + 8 | 0, E = t[n >> 2], d = Ti + 8 | 0, dr = E + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = E >>> 0 > dr >>> 0 ? n + 1 | 0 : n, d = L + dr | 0, n = (d >>> 0 < dr >>> 0 ? n + 1 | 0 : n) + Ir | 0, E = d, d = d + Xn | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d, d = d + Bn | 0, n = (E >>> 0 > d >>> 0 ? n + 1 | 0 : n) + Wr | 0, E = d, d = d + kn | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d + Un | 0, n = E >>> 0 < d >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + E | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + jn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = he, L = d << 12 | a >>> 20, E = n, he = n << 12 | d >>> 20, Wr = t[T + 1776 >> 2], d = t[T + 1888 >> 2], dr = Wr + d | 0, kn = t[T + 1780 >> 2], n = kn + t[T + 1892 >> 2] | 0, d = d >>> 0 > dr >>> 0 ? n + 1 | 0 : n, n = d + he | 0, L = L + dr | 0, n = L >>> 0 < dr >>> 0 ? n + 1 | 0 : n, Xn = L << 4 & -16, he = n, $r = (n << 4 | L >>> 28) & 16777215, Ir = a, Ur(Zn, Xn | a >>> 16 & 15, $r, 0, 0, 977, 1, 0, 0), Zn = T + 1984 | 0, Ur(Zn, Ai, Hi, 0, 0, gn, Gn, 0, 0), Un = T + 1728 | 0, Ur(Un, xn, xr, 0, 0, cr, Be, 0, 0), Bn = T + 1904 | 0, Ur(Bn, or, Me, 0, 0, or, Me, 0, 0), Xn = T + 1712 | 0, $r = (d | 0) == (n | 0) & L >>> 0 < dr >>> 0 | d >>> 0 > n >>> 0, L = (d | 0) == (kn | 0) & dr >>> 0 < Wr >>> 0 | d >>> 0 < kn >>> 0, n = Bi + 8 | 0, a = t[n >> 2], d = ai + 8 | 0, dr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > dr >>> 0 ? n + 1 | 0 : n, a = L + dr | 0, n = a >>> 0 < dr >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, d = a + E | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + $r | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | he >>> 20, a = n, dr = n << 12 | d >>> 20, jn = t[T + 1732 >> 2], n = jn + t[T + 1908 >> 2] | 0, $r = t[T + 1728 >> 2], d = t[T + 1904 >> 2], E = $r + d | 0, L = E, he = E + he | 0, d = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, n = d + dr | 0, E = E >>> 0 > he >>> 0 ? n + 1 | 0 : n, Ur(Xn, he, E & 1048575, 0, 0, 15632, 16, 0, 0), kn = T + 1920 | 0, Ur(kn, cr, Be, 0, 0, gn, Gn, 0, 0), Wr = T + 1968 | 0, Ur(Wr, Ai, Hi, 0, 0, Ai, Hi, 0, 0), dr = T + 1664 | 0, Ur(dr, xn, xr, 0, 0, or, Me, 0, 0), gn = T + 1648 | 0, Me = gn, Be = (d | 0) == (E | 0) & L >>> 0 > he >>> 0 | d >>> 0 > E >>> 0, L = (d | 0) == (jn | 0) & L >>> 0 < $r >>> 0 | d >>> 0 < jn >>> 0, n = Bn + 8 | 0, he = t[n >> 2], d = Un + 8 | 0, or = he + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = he >>> 0 > or >>> 0 ? n + 1 | 0 : n, he = L + or | 0, n = he >>> 0 < or >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + he | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Be | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | E >>> 20, E = t[T + 1664 >> 2], Be = he + E | 0, a = n, d = n << 12 | d >>> 20, n = d + t[T + 1668 >> 2] | 0, n = E >>> 0 > Be >>> 0 ? n + 1 | 0 : n, Ur(Me, Be, n, 0, 0, 15632, 16, 0, 0), jn = T + 1584 | 0, L = jn, he = (d | 0) == (n | 0) & he >>> 0 > Be >>> 0 | d >>> 0 > n >>> 0, d = dr + 8 | 0, E = t[d >> 2], n = t[d + 4 >> 2], a = a >>> 20 | 0, d = a + E | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + he | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Ur(L, d, n, 0, 0, 64028672, 65536, 0, 0), a = t[T + 1760 >> 2], d = t[T + 2e3 >> 2], L = a + d | 0, he = t[T + 1764 >> 2], n = he + t[T + 2004 >> 2] | 0, E = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, he = (he | 0) == (E | 0) & a >>> 0 > L >>> 0 | E >>> 0 < he >>> 0, n = wi + 8 | 0, a = t[n >> 2], d = fi + 8 | 0, Be = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, d = he + Be | 0, n = d >>> 0 < Be >>> 0 ? n + 1 | 0 : n, cr = E, he = d << 12 | E >>> 20, a = n, or = n << 12 | d >>> 20, dr = t[T + 1716 >> 2], n = dr + t[T + 1988 >> 2] | 0, Me = t[T + 1712 >> 2], d = t[T + 1984 >> 2], E = Me + d | 0, Be = E, he = E + he | 0, d = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, n = d + or | 0, E = he >>> 0 < E >>> 0 ? n + 1 | 0 : n, or = (d | 0) == (E | 0) & he >>> 0 < Be >>> 0 | d >>> 0 > E >>> 0, Me = (d | 0) == (dr | 0) & Be >>> 0 < Me >>> 0 | d >>> 0 < dr >>> 0, n = Zn + 8 | 0, Be = t[n >> 2], d = Xn + 8 | 0, dr = Be + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = Be >>> 0 > dr >>> 0 ? n + 1 | 0 : n, Be = Me + dr | 0, n = Be >>> 0 < dr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + Be | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + or | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, dr = E, Be = d << 12 | E >>> 20, a = n, E = n << 12 | d >>> 20, Bn = t[T + 1920 >> 2], d = t[T + 1968 >> 2], or = Bn + d | 0, Zn = t[T + 1924 >> 2], n = Zn + t[T + 1972 >> 2] | 0, n = d >>> 0 > or >>> 0 ? n + 1 | 0 : n, d = t[T + 1648 >> 2], Me = d + or | 0, xr = n, n = n + t[T + 1652 >> 2] | 0, d = d >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = d + E | 0, Un = T + 1568 | 0, E = Be + Me | 0, Be = E >>> 0 < Me >>> 0 ? n + 1 | 0 : n, $r = (d | 0) == (Be | 0) & E >>> 0 < Me >>> 0 | d >>> 0 > Be >>> 0, xn = (d | 0) == (xr | 0) & Me >>> 0 < or >>> 0 | d >>> 0 < xr >>> 0, d = gn + 8 | 0, Gn = t[d >> 2], gn = t[d + 4 >> 2], or = (xr | 0) == (Zn | 0) & or >>> 0 < Bn >>> 0 | xr >>> 0 < Zn >>> 0, n = Wr + 8 | 0, Me = t[n >> 2], d = kn + 8 | 0, xr = Me + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = Me >>> 0 > xr >>> 0 ? n + 1 | 0 : n, d = or + xr | 0, n = (d >>> 0 < xr >>> 0 ? n + 1 | 0 : n) + gn | 0, or = d, d = d + Gn | 0, n = or >>> 0 > d >>> 0 ? n + 1 | 0 : n, Me = d + xn | 0, n = Me >>> 0 < d >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + Me | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + $r | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Me = Be, xr = d << 12 | Be >>> 20, a = n, or = n << 12 | d >>> 20, Zn = t[T + 1588 >> 2], n = Zn + (gr & 1048575) | 0, Bn = t[T + 1584 >> 2], Be = Mr & -2, d = Bn + Be | 0, gr = d, d = d >>> 0 < Be >>> 0 ? n + 1 | 0 : n, n = d + or | 0, or = gr + xr | 0, Be = or >>> 0 < gr >>> 0 ? n + 1 | 0 : n, xr = Be & 1048575, n = cr & 1048575, fi = n, cr = L, n = n << 1 | L >>> 31, Gn = L << 1, xn = n, Ur(Un, or, xr, 0, 0, Gn, n, 0, 0), n = dr & 1048575, Ai = n, kn = T + 1600 | 0, Mr = Me & 1048575, L = he << 1, Xn = he, Me = n << 1 | he >>> 31, Ur(kn, E, Mr, 0, 0, L, Me, 0, 0), Wr = T + 1504 | 0, gn = Ir & 65535, Ir = (d | 0) == (Be | 0) & or >>> 0 < gr >>> 0 | d >>> 0 > Be >>> 0, dr = (d | 0) == (Zn | 0) & gr >>> 0 < Bn >>> 0 | d >>> 0 < Zn >>> 0, d = jn + 8 | 0, he = dr + t[d >> 2] | 0, n = t[d + 4 >> 2], n = he >>> 0 < dr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + he | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Ir | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | Be >>> 20, a = he + tr | 0, n = gn + (n << 12 | d >>> 20) | 0, n = a >>> 0 < he >>> 0 ? n + 1 | 0 : n, Ur(Wr, a, n, 0, 0, a, n, 0, 0), tr = T + 1488 | 0, Ur(tr, t[T + 1504 >> 2], t[T + 1508 >> 2], 0, 0, 15632, 16, 0, 0), d = a, n = n << 1 | d >>> 31, Oi = T + 1456 | 0, $r = d << 1, gn = n, Ur(Oi, $r, n, 0, 0, cr, fi, 0, 0), Ti = T + 1552 | 0, Ur(Ti, or, xr, 0, 0, L, Me, 0, 0), Ii = T + 1616 | 0, Ur(Ii, E, Mr, 0, 0, E, Mr, 0, 0), Bn = T + 1472 | 0, d = Wr + 8 | 0, Ur(Bn, t[d >> 2], t[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), wi = T + 1744 | 0, Ur(wi, cr, fi, 0, 0, cr, fi, 0, 0), ai = T + 1440 | 0, Ur(ai, $r, n, 0, 0, Xn, Ai, 0, 0), Bi = T + 1520 | 0, Me = xr, Be = Mr, xr = E, Ur(Bi, or, Me, 0, 0, E << 1, Be << 1 | E >>> 31, 0, 0), he = t[T + 1568 >> 2], a = t[T + 1600 >> 2], d = he + a | 0, cr = t[T + 1572 >> 2], n = cr + t[T + 1604 >> 2] | 0, n = d >>> 0 < a >>> 0 ? n + 1 | 0 : n, a = t[T + 1488 >> 2], Mr = a + d | 0, E = n, n = n + t[T + 1492 >> 2] | 0, a = a >>> 0 > Mr >>> 0 ? n + 1 | 0 : n, dr = (E | 0) == (a | 0) & d >>> 0 > Mr >>> 0 | a >>> 0 < E >>> 0, n = tr + 8 | 0, tr = t[n >> 2], L = t[n + 4 >> 2], he = (E | 0) == (cr | 0) & d >>> 0 < he >>> 0 | E >>> 0 < cr >>> 0, n = kn + 8 | 0, E = t[n >> 2], d = Un + 8 | 0, cr = E + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = E >>> 0 > cr >>> 0 ? n + 1 | 0 : n, d = he + cr | 0, n = (d >>> 0 < cr >>> 0 ? n + 1 | 0 : n) + L | 0, E = d, d = d + tr | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d, d = d + dr | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, gr = a, tr = d << 12 | a >>> 20, E = n, he = n << 12 | d >>> 20, ni = t[T + 1552 >> 2], d = t[T + 1616 >> 2], cr = ni + d | 0, yi = t[T + 1556 >> 2], n = yi + t[T + 1620 >> 2] | 0, n = d >>> 0 > cr >>> 0 ? n + 1 | 0 : n, d = t[T + 1456 >> 2], dr = d + cr | 0, a = n, n = n + t[T + 1460 >> 2] | 0, n = d >>> 0 > dr >>> 0 ? n + 1 | 0 : n, d = t[T + 1472 >> 2], L = d + dr | 0, Ir = n, n = n + t[T + 1476 >> 2] | 0, d = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, n = d + he | 0, fi = T + 1344 | 0, Zn = fi, tr = L + tr | 0, he = tr >>> 0 < L >>> 0 ? n + 1 | 0 : n, jn = (d | 0) == (he | 0) & L >>> 0 > tr >>> 0 | d >>> 0 > he >>> 0, Un = (d | 0) == (Ir | 0) & L >>> 0 < dr >>> 0 | d >>> 0 < Ir >>> 0, d = Bn + 8 | 0, kn = t[d >> 2], Wr = t[d + 4 >> 2], Bn = (a | 0) == (Ir | 0) & cr >>> 0 > dr >>> 0 | a >>> 0 > Ir >>> 0, d = Oi + 8 | 0, Ir = t[d >> 2], dr = t[d + 4 >> 2], L = (a | 0) == (yi | 0) & cr >>> 0 < ni >>> 0 | a >>> 0 < yi >>> 0, n = Ii + 8 | 0, a = t[n >> 2], d = Ti + 8 | 0, cr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > cr >>> 0 ? n + 1 | 0 : n, d = L + cr | 0, n = (d >>> 0 < cr >>> 0 ? n + 1 | 0 : n) + dr | 0, a = d, d = d + Ir | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Bn | 0, n = (a >>> 0 > d >>> 0 ? n + 1 | 0 : n) + Wr | 0, a = d, d = d + kn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d + Un | 0, n = a >>> 0 < d >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, d = a + E | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + jn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = he, L = d << 12 | a >>> 20, E = n, he = n << 12 | d >>> 20, Wr = t[T + 1440 >> 2], d = t[T + 1520 >> 2], dr = Wr + d | 0, kn = t[T + 1444 >> 2], n = kn + t[T + 1524 >> 2] | 0, d = d >>> 0 > dr >>> 0 ? n + 1 | 0 : n, n = d + he | 0, L = L + dr | 0, n = L >>> 0 < dr >>> 0 ? n + 1 | 0 : n, Bn = L << 4 & -16, he = n, cr = (n << 4 | L >>> 28) & 16777215, Ir = a, Ur(Zn, Bn | a >>> 16 & 15, cr, 0, 0, 977, 1, 0, 0), Zn = T + 1680 | 0, Ur(Zn, Xn, Ai, 0, 0, Gn, xn, 0, 0), jn = T + 1424 | 0, Ur(jn, $r, gn, 0, 0, xr, Be, 0, 0), Un = T + 1536 | 0, Ur(Un, or, Me, 0, 0, or, Me, 0, 0), Bn = T + 1408 | 0, cr = (d | 0) == (n | 0) & L >>> 0 < dr >>> 0 | d >>> 0 > n >>> 0, L = (d | 0) == (kn | 0) & dr >>> 0 < Wr >>> 0 | d >>> 0 < kn >>> 0, n = Bi + 8 | 0, a = t[n >> 2], d = ai + 8 | 0, dr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > dr >>> 0 ? n + 1 | 0 : n, a = L + dr | 0, n = a >>> 0 < dr >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, d = a + E | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + cr | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | he >>> 20, a = n, E = n << 12 | d >>> 20, cr = t[T + 1424 >> 2], d = t[T + 1536 >> 2], L = cr + d | 0, ni = t[T + 1428 >> 2], n = ni + t[T + 1540 >> 2] | 0, d = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, n = d + E | 0, he = L + he | 0, n = he >>> 0 < L >>> 0 ? n + 1 | 0 : n, E = n, Ur(Bn, he, n & 1048575, 0, 0, 15632, 16, 0, 0), kn = T + 1632 | 0, Ur(kn, xr, Be, 0, 0, Gn, xn, 0, 0), Wr = T + 1696 | 0, Ur(Wr, Xn, Ai, 0, 0, Xn, Ai, 0, 0), dr = T + 1392 | 0, Ur(dr, or, Me, 0, 0, $r, gn, 0, 0), gn = T + 1376 | 0, Me = gn, Be = (d | 0) == (n | 0) & L >>> 0 > he >>> 0 | d >>> 0 > n >>> 0, L = (d | 0) == (ni | 0) & L >>> 0 < cr >>> 0 | d >>> 0 < ni >>> 0, n = Un + 8 | 0, he = t[n >> 2], d = jn + 8 | 0, or = he + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = he >>> 0 > or >>> 0 ? n + 1 | 0 : n, he = L + or | 0, n = he >>> 0 < or >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + he | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Be | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | E >>> 20, E = t[T + 1392 >> 2], Be = he + E | 0, a = n, d = n << 12 | d >>> 20, n = d + t[T + 1396 >> 2] | 0, n = E >>> 0 > Be >>> 0 ? n + 1 | 0 : n, Ur(Me, Be, n, 0, 0, 15632, 16, 0, 0), jn = T + 1360 | 0, L = jn, he = (d | 0) == (n | 0) & he >>> 0 > Be >>> 0 | d >>> 0 > n >>> 0, d = dr + 8 | 0, E = t[d >> 2], n = t[d + 4 >> 2], a = a >>> 20 | 0, d = a + E | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + he | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Ur(L, d, n, 0, 0, 64028672, 65536, 0, 0), a = t[T + 1344 >> 2], d = t[T + 1744 >> 2], L = a + d | 0, he = t[T + 1348 >> 2], n = he + t[T + 1748 >> 2] | 0, E = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, he = (he | 0) == (E | 0) & a >>> 0 > L >>> 0 | E >>> 0 < he >>> 0, n = wi + 8 | 0, a = t[n >> 2], d = fi + 8 | 0, Be = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, d = he + Be | 0, n = d >>> 0 < Be >>> 0 ? n + 1 | 0 : n, cr = E, he = d << 12 | E >>> 20, a = n, E = n << 12 | d >>> 20, Me = t[T + 1408 >> 2], d = t[T + 1680 >> 2], Be = Me + d | 0, dr = t[T + 1412 >> 2], n = dr + t[T + 1684 >> 2] | 0, d = d >>> 0 > Be >>> 0 ? n + 1 | 0 : n, n = d + E | 0, he = he + Be | 0, E = he >>> 0 < Be >>> 0 ? n + 1 | 0 : n, or = (d | 0) == (E | 0) & he >>> 0 < Be >>> 0 | d >>> 0 > E >>> 0, Me = (d | 0) == (dr | 0) & Be >>> 0 < Me >>> 0 | d >>> 0 < dr >>> 0, n = Zn + 8 | 0, Be = t[n >> 2], d = Bn + 8 | 0, dr = Be + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = Be >>> 0 > dr >>> 0 ? n + 1 | 0 : n, Be = Me + dr | 0, n = Be >>> 0 < dr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + Be | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + or | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, dr = E, Be = d << 12 | E >>> 20, a = n, E = n << 12 | d >>> 20, Bn = t[T + 1632 >> 2], d = t[T + 1696 >> 2], or = Bn + d | 0, Zn = t[T + 1636 >> 2], n = Zn + t[T + 1700 >> 2] | 0, n = d >>> 0 > or >>> 0 ? n + 1 | 0 : n, d = t[T + 1376 >> 2], Me = d + or | 0, xr = n, n = n + t[T + 1380 >> 2] | 0, d = d >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = d + E | 0, Un = T + 1264 | 0, E = Be + Me | 0, Be = E >>> 0 < Me >>> 0 ? n + 1 | 0 : n, $r = (d | 0) == (Be | 0) & E >>> 0 < Me >>> 0 | d >>> 0 > Be >>> 0, xn = (d | 0) == (xr | 0) & Me >>> 0 < or >>> 0 | d >>> 0 < xr >>> 0, d = gn + 8 | 0, Gn = t[d >> 2], gn = t[d + 4 >> 2], or = (xr | 0) == (Zn | 0) & or >>> 0 < Bn >>> 0 | xr >>> 0 < Zn >>> 0, n = Wr + 8 | 0, Me = t[n >> 2], d = kn + 8 | 0, xr = Me + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = Me >>> 0 > xr >>> 0 ? n + 1 | 0 : n, d = or + xr | 0, n = (d >>> 0 < xr >>> 0 ? n + 1 | 0 : n) + gn | 0, or = d, d = d + Gn | 0, n = or >>> 0 > d >>> 0 ? n + 1 | 0 : n, Me = d + xn | 0, n = Me >>> 0 < d >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + Me | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + $r | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Me = Be, or = d << 12 | Be >>> 20, a = n, xr = n << 12 | d >>> 20, Zn = t[T + 1364 >> 2], n = Zn + (gr & 1048575) | 0, Bn = t[T + 1360 >> 2], d = Mr & -2, Be = Bn + d | 0, gr = Be, or = Be + or | 0, d = d >>> 0 > Be >>> 0 ? n + 1 | 0 : n, n = d + xr | 0, Be = or >>> 0 < Be >>> 0 ? n + 1 | 0 : n, $r = Be & 1048575, Mr = $r, n = cr & 1048575, fi = n, cr = L, n = n << 1 | L >>> 31, gn = L << 1, Gn = n, Ur(Un, or, Mr, 0, 0, gn, n, 0, 0), n = dr & 1048575, Ai = n, kn = T + 1216 | 0, Mr = Me & 1048575, L = he << 1, Xn = he, Me = n << 1 | he >>> 31, Ur(kn, E, Mr, 0, 0, L, Me, 0, 0), Wr = T + 1168 | 0, xr = Ir & 65535, Ir = (d | 0) == (Be | 0) & or >>> 0 < gr >>> 0 | d >>> 0 > Be >>> 0, dr = (d | 0) == (Zn | 0) & gr >>> 0 < Bn >>> 0 | d >>> 0 < Zn >>> 0, d = jn + 8 | 0, he = dr + t[d >> 2] | 0, n = t[d + 4 >> 2], n = he >>> 0 < dr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + he | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Ir | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | Be >>> 20, a = he + tr | 0, n = xr + (n << 12 | d >>> 20) | 0, n = a >>> 0 < he >>> 0 ? n + 1 | 0 : n, Ur(Wr, a, n, 0, 0, a, n, 0, 0), tr = T + 1152 | 0, Ur(tr, t[T + 1168 >> 2], t[T + 1172 >> 2], 0, 0, 15632, 16, 0, 0), d = a, n = n << 1 | d >>> 31, Oi = T + 1120 | 0, xn = d << 1, xr = n, Ur(Oi, xn, n, 0, 0, cr, fi, 0, 0), Ti = T + 1200 | 0, Ur(Ti, or, $r, 0, 0, L, Me, 0, 0), Ii = T + 1312 | 0, Ur(Ii, E, Mr, 0, 0, E, Mr, 0, 0), Bn = T + 1136 | 0, d = Wr + 8 | 0, Ur(Bn, t[d >> 2], t[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), wi = T + 1280 | 0, Ur(wi, cr, fi, 0, 0, cr, fi, 0, 0), ai = T + 1104 | 0, Ur(ai, xn, n, 0, 0, Xn, Ai, 0, 0), Bi = T + 1184 | 0, Ir = or, cr = $r, Be = Mr, Mr = E, Ur(Bi, or, cr, 0, 0, E << 1, Be << 1 | E >>> 31, 0, 0), he = t[T + 1264 >> 2], a = t[T + 1216 >> 2], d = he + a | 0, or = t[T + 1268 >> 2], n = or + t[T + 1220 >> 2] | 0, n = d >>> 0 < a >>> 0 ? n + 1 | 0 : n, a = t[T + 1152 >> 2], dr = a + d | 0, E = n, n = n + t[T + 1156 >> 2] | 0, a = a >>> 0 > dr >>> 0 ? n + 1 | 0 : n, Me = (E | 0) == (a | 0) & d >>> 0 > dr >>> 0 | a >>> 0 < E >>> 0, n = tr + 8 | 0, tr = t[n >> 2], L = t[n + 4 >> 2], he = (E | 0) == (or | 0) & d >>> 0 < he >>> 0 | E >>> 0 < or >>> 0, n = kn + 8 | 0, E = t[n >> 2], d = Un + 8 | 0, or = E + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = E >>> 0 > or >>> 0 ? n + 1 | 0 : n, d = he + or | 0, n = (d >>> 0 < or >>> 0 ? n + 1 | 0 : n) + L | 0, E = d, d = d + tr | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d, d = d + Me | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, or = a, L = d << 12 | a >>> 20, E = n, he = n << 12 | d >>> 20, ni = t[T + 1200 >> 2], d = t[T + 1312 >> 2], gr = ni + d | 0, yi = t[T + 1204 >> 2], n = yi + t[T + 1316 >> 2] | 0, n = d >>> 0 > gr >>> 0 ? n + 1 | 0 : n, d = t[T + 1120 >> 2], Me = d + gr | 0, a = n, n = n + t[T + 1124 >> 2] | 0, n = d >>> 0 > Me >>> 0 ? n + 1 | 0 : n, d = t[T + 1136 >> 2], tr = d + Me | 0, $r = n, n = n + t[T + 1140 >> 2] | 0, d = d >>> 0 > tr >>> 0 ? n + 1 | 0 : n, n = d + he | 0, fi = T + 1008 | 0, Zn = fi, he = L + tr | 0, L = he >>> 0 < tr >>> 0 ? n + 1 | 0 : n, jn = (d | 0) == (L | 0) & he >>> 0 < tr >>> 0 | d >>> 0 > L >>> 0, Un = (d | 0) == ($r | 0) & Me >>> 0 > tr >>> 0 | d >>> 0 < $r >>> 0, d = Bn + 8 | 0, kn = t[d >> 2], Wr = t[d + 4 >> 2], Bn = (a | 0) == ($r | 0) & Me >>> 0 < gr >>> 0 | a >>> 0 > $r >>> 0, d = Oi + 8 | 0, $r = t[d >> 2], Me = t[d + 4 >> 2], tr = (a | 0) == (yi | 0) & gr >>> 0 < ni >>> 0 | a >>> 0 < yi >>> 0, n = Ii + 8 | 0, a = t[n >> 2], d = Ti + 8 | 0, gr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, d = tr + gr | 0, n = (d >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + Me | 0, a = d, d = d + $r | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Bn | 0, n = (a >>> 0 > d >>> 0 ? n + 1 | 0 : n) + Wr | 0, a = d, d = d + kn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d + Un | 0, n = a >>> 0 < d >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, d = a + E | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + jn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = L, tr = d << 12 | a >>> 20, E = n, L = n << 12 | d >>> 20, Wr = t[T + 1104 >> 2], d = t[T + 1184 >> 2], gr = Wr + d | 0, ni = t[T + 1108 >> 2], n = ni + t[T + 1188 >> 2] | 0, d = d >>> 0 > gr >>> 0 ? n + 1 | 0 : n, n = d + L | 0, tr = tr + gr | 0, n = tr >>> 0 < gr >>> 0 ? n + 1 | 0 : n, Bn = tr << 4 & -16, L = n, $r = (n << 4 | tr >>> 28) & 16777215, Me = a, Ur(Zn, Bn | a >>> 16 & 15, $r, 0, 0, 977, 1, 0, 0), Zn = T + 1248 | 0, Ur(Zn, Xn, Ai, 0, 0, gn, Gn, 0, 0), jn = T + 1088 | 0, Ur(jn, xn, xr, 0, 0, Mr, Be, 0, 0), Un = T + 1328 | 0, Ur(Un, Ir, cr, 0, 0, Ir, cr, 0, 0), kn = T + 1072 | 0, Bn = kn, $r = (d | 0) == (n | 0) & tr >>> 0 < gr >>> 0 | d >>> 0 > n >>> 0, tr = (d | 0) == (ni | 0) & gr >>> 0 < Wr >>> 0 | d >>> 0 < ni >>> 0, n = Bi + 8 | 0, a = t[n >> 2], d = ai + 8 | 0, gr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = tr + gr | 0, n = a >>> 0 < gr >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, d = a + E | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + $r | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d << 12 | L >>> 20, a = n, E = n << 12 | d >>> 20, $r = t[T + 1088 >> 2], d = t[T + 1328 >> 2], tr = $r + d | 0, ni = t[T + 1092 >> 2], n = ni + t[T + 1332 >> 2] | 0, d = d >>> 0 > tr >>> 0 ? n + 1 | 0 : n, n = d + E | 0, L = L + tr | 0, n = L >>> 0 < tr >>> 0 ? n + 1 | 0 : n, E = n, Ur(Bn, L, n & 1048575, 0, 0, 15632, 16, 0, 0), Wr = T + 1232 | 0, Ur(Wr, Mr, Be, 0, 0, gn, Gn, 0, 0), Bn = T + 1296 | 0, Ur(Bn, Xn, Ai, 0, 0, Xn, Ai, 0, 0), gr = T + 1056 | 0, Ur(gr, Ir, cr, 0, 0, xn, xr, 0, 0), Mr = T + 1040 | 0, cr = Mr, Be = (d | 0) == (n | 0) & L >>> 0 < tr >>> 0 | d >>> 0 > n >>> 0, tr = (d | 0) == (ni | 0) & tr >>> 0 < $r >>> 0 | d >>> 0 < ni >>> 0, n = Un + 8 | 0, L = t[n >> 2], d = jn + 8 | 0, Ir = L + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = L >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, L = tr + Ir | 0, n = L >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + L | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Be | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d << 12 | E >>> 20, E = t[T + 1056 >> 2], Be = L + E | 0, a = n, d = n << 12 | d >>> 20, n = d + t[T + 1060 >> 2] | 0, n = E >>> 0 > Be >>> 0 ? n + 1 | 0 : n, Ur(cr, Be, n, 0, 0, 15632, 16, 0, 0), $r = T + 1024 | 0, tr = $r, L = (d | 0) == (n | 0) & L >>> 0 > Be >>> 0 | d >>> 0 > n >>> 0, d = gr + 8 | 0, E = t[d >> 2], n = t[d + 4 >> 2], a = a >>> 20 | 0, d = a + E | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + L | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Ur(tr, d, n, 0, 0, 64028672, 65536, 0, 0), a = t[T + 1008 >> 2], d = t[T + 1280 >> 2], Be = a + d | 0, L = t[T + 1012 >> 2], n = L + t[T + 1284 >> 2] | 0, ni = T + 7176 | 0, jn = ni + 8 | 0, Ir = jn, E = d >>> 0 > Be >>> 0 ? n + 1 | 0 : n, L = (L | 0) == (E | 0) & a >>> 0 > Be >>> 0 | E >>> 0 < L >>> 0, n = wi + 8 | 0, a = t[n >> 2], d = fi + 8 | 0, tr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, d = L + tr | 0, n = d >>> 0 < tr >>> 0 ? n + 1 | 0 : n, tr = E, L = d << 12 | E >>> 20, a = n, E = n << 12 | d >>> 20, gr = t[T + 1072 >> 2], d = t[T + 1248 >> 2], cr = gr + d | 0, gn = t[T + 1076 >> 2], n = gn + t[T + 1252 >> 2] | 0, d = d >>> 0 > cr >>> 0 ? n + 1 | 0 : n, n = d + E | 0, L = L + cr | 0, n = L >>> 0 < cr >>> 0 ? n + 1 | 0 : n, t[Ir >> 2] = L, E = n, t[Ir + 4 >> 2] = n & 1048575, Un = ni + 16 | 0, xr = Un, Ir = (d | 0) == (n | 0) & L >>> 0 < cr >>> 0 | d >>> 0 > n >>> 0, cr = (d | 0) == (gn | 0) & cr >>> 0 < gr >>> 0 | d >>> 0 < gn >>> 0, n = Zn + 8 | 0, L = t[n >> 2], d = kn + 8 | 0, gr = L + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = L >>> 0 > gr >>> 0 ? n + 1 | 0 : n, L = cr + gr | 0, n = L >>> 0 < gr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + L | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Ir | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d << 12 | E >>> 20, a = n, E = n << 12 | d >>> 20, xn = t[T + 1232 >> 2], d = t[T + 1296 >> 2], Ir = xn + d | 0, kn = t[T + 1236 >> 2], n = kn + t[T + 1300 >> 2] | 0, n = d >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, d = t[T + 1040 >> 2], cr = d + Ir | 0, gr = n, n = n + t[T + 1044 >> 2] | 0, d = d >>> 0 > cr >>> 0 ? n + 1 | 0 : n, n = d + E | 0, L = L + cr | 0, n = L >>> 0 < cr >>> 0 ? n + 1 | 0 : n, t[xr >> 2] = L, E = n, t[xr + 4 >> 2] = n & 1048575, Xn = ni + 24 | 0, Gn = (d | 0) == (n | 0) & L >>> 0 < cr >>> 0 | d >>> 0 > n >>> 0, gn = (d | 0) == (gr | 0) & cr >>> 0 < Ir >>> 0 | d >>> 0 < gr >>> 0, d = Mr + 8 | 0, xr = t[d >> 2], Mr = t[d + 4 >> 2], cr = (gr | 0) == (kn | 0) & Ir >>> 0 < xn >>> 0 | gr >>> 0 < kn >>> 0, n = Bn + 8 | 0, L = t[n >> 2], d = Wr + 8 | 0, Ir = L + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = L >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, d = cr + Ir | 0, n = (d >>> 0 < Ir >>> 0 ? n + 1 | 0 : n) + Mr | 0, L = d, d = d + xr | 0, n = L >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d + gn | 0, n = L >>> 0 < d >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + L | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Gn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, cr = d << 12 | E >>> 20, a = n, L = n << 12 | d >>> 20, Ir = t[T + 1024 >> 2], E = dr & -2, d = Ir + E | 0, Mr = t[T + 1028 >> 2], n = Mr + (or & 1048575) | 0, dr = d >>> 0 < E >>> 0 ? n + 1 | 0 : n, n = dr + L | 0, or = d, E = d + cr | 0, n = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, t[Xn >> 2] = E, d = n, t[Xn + 4 >> 2] = n & 1048575, gr = ni + 32 | 0, L = he, cr = Me & 65535, Me = (n | 0) == (dr | 0) & E >>> 0 < or >>> 0 | n >>> 0 < dr >>> 0, E = (dr | 0) == (Mr | 0) & or >>> 0 < Ir >>> 0 | dr >>> 0 < Mr >>> 0, n = $r + 8 | 0, he = E + t[n >> 2] | 0, n = t[n + 4 >> 2], n = E >>> 0 > he >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, E = a, a = a + he | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, d = a << 12 | d >>> 20, E = d + L | 0, n = cr + (n << 12 | a >>> 20) | 0, t[gr >> 2] = E, t[gr + 4 >> 2] = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, t[T + 7176 >> 2] = Be, t[T + 7180 >> 2] = tr & 1048575, Xr(ni, ni, T + 7536 | 0), Be = t[gr + 4 >> 2], n = T + 7136 | 0, d = n + 32 | 0, a = t[gr >> 2], t[d >> 2] = a, t[d + 4 >> 2] = Be, Me = t[Xn + 4 >> 2], d = n + 24 | 0, tr = t[Xn >> 2], t[d >> 2] = tr, t[d + 4 >> 2] = Me, cr = t[Un + 4 >> 2], d = n + 16 | 0, L = t[Un >> 2], t[d >> 2] = L, t[d + 4 >> 2] = cr, dr = t[jn + 4 >> 2], d = n + 8 | 0, he = t[jn >> 2], t[d >> 2] = he, t[d + 4 >> 2] = dr, or = t[T + 7180 >> 2], E = t[T + 7176 >> 2], t[T + 7136 >> 2] = E, t[T + 7140 >> 2] = or, d = 23; gr = E, n = or << 1 | E >>> 31, Un = T + 976 | 0, $r = E << 1, Xn = n, Ur(Un, tr, Me, 0, 0, $r, n, 0, 0), Wr = T + 896 | 0, E = he << 1, Ir = dr, xn = he, he = dr << 1 | he >>> 31, Ur(Wr, L, cr, 0, 0, E, he, 0, 0), xr = T + 832 | 0, Ur(xr, a, Be, 0, 0, a, Be, 0, 0), Mr = T + 816 | 0, Ur(Mr, t[T + 832 >> 2], t[T + 836 >> 2], 0, 0, 15632, 16, 0, 0), n = Be << 1 | a >>> 31, Ai = T + 784 | 0, Bn = a << 1, Gn = n, Ur(Ai, Bn, n, 0, 0, gr, or, 0, 0), yi = T + 944 | 0, Ur(yi, tr, Me, 0, 0, E, he, 0, 0), Oi = T + 880 | 0, Ur(Oi, L, cr, 0, 0, L, cr, 0, 0), kn = T + 800 | 0, n = xr + 8 | 0, Ur(kn, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ti = T + 992 | 0, Ur(Ti, gr, or, 0, 0, gr, or, 0, 0), Ii = T + 768 | 0, Ur(Ii, Bn, Gn, 0, 0, xn, dr, 0, 0), wi = T + 848 | 0, or = tr, gn = L, Ur(wi, tr, Me, 0, 0, L << 1, cr << 1 | L >>> 31, 0, 0), gr = t[T + 980 >> 2], n = gr + t[T + 900 >> 2] | 0, L = t[T + 976 >> 2], E = t[T + 896 >> 2], a = L + E | 0, he = t[T + 816 >> 2], xr = a + he | 0, E = a >>> 0 < E >>> 0 ? n + 1 | 0 : n, n = E + t[T + 820 >> 2] | 0, he = he >>> 0 > xr >>> 0 ? n + 1 | 0 : n, dr = (E | 0) == (he | 0) & a >>> 0 > xr >>> 0 | E >>> 0 > he >>> 0, n = Mr + 8 | 0, Be = t[n >> 2], tr = t[n + 4 >> 2], L = (E | 0) == (gr | 0) & a >>> 0 < L >>> 0 | E >>> 0 < gr >>> 0, E = Wr + 8 | 0, a = t[E >> 2], n = Un + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = L + gr | 0, n = (a >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + tr | 0, E = a, a = a + Be | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + dr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, dr = he, tr = a << 12 | he >>> 20, E = n, L = n << 12 | a >>> 20, ai = t[T + 944 >> 2], a = t[T + 880 >> 2], gr = ai + a | 0, Hi = t[T + 948 >> 2], n = Hi + t[T + 884 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = t[T + 784 >> 2], Be = a + gr | 0, Wr = n, n = n + t[T + 788 >> 2] | 0, n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, a = t[T + 800 >> 2], he = a + Be | 0, Mr = n, n = n + t[T + 804 >> 2] | 0, a = a >>> 0 > he >>> 0 ? n + 1 | 0 : n, n = a + L | 0, Bi = T + 752 | 0, tr = he + tr | 0, L = tr >>> 0 < he >>> 0 ? n + 1 | 0 : n, ni = (a | 0) == (L | 0) & he >>> 0 > tr >>> 0 | a >>> 0 > L >>> 0, fi = (a | 0) == (Mr | 0) & he >>> 0 < Be >>> 0 | a >>> 0 < Mr >>> 0, n = kn + 8 | 0, Zn = t[n >> 2], jn = t[n + 4 >> 2], Un = (Mr | 0) == (Wr | 0) & Be >>> 0 < gr >>> 0 | Mr >>> 0 < Wr >>> 0, n = Ai + 8 | 0, kn = t[n >> 2], Mr = t[n + 4 >> 2], Be = (Wr | 0) == (Hi | 0) & gr >>> 0 < ai >>> 0 | Wr >>> 0 < Hi >>> 0, he = Oi + 8 | 0, a = t[he >> 2], n = yi + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[he + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = Be + gr | 0, n = (a >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + Mr | 0, he = a, a = a + kn | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, he = a, a = a + Un | 0, n = (he >>> 0 > a >>> 0 ? n + 1 | 0 : n) + jn | 0, he = a, a = a + Zn | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, he = a + fi | 0, n = he >>> 0 < a >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + he | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + ni | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = L, Be = a << 12 | E >>> 20, he = n, Mr = n << 12 | a >>> 20, ai = t[T + 772 >> 2], n = ai + t[T + 852 >> 2] | 0, Un = t[T + 768 >> 2], a = t[T + 848 >> 2], L = Un + a | 0, gr = L, Be = L + Be | 0, a = a >>> 0 > L >>> 0 ? n + 1 | 0 : n, n = a + Mr | 0, kn = Be << 4 & -16, L = Be >>> 0 < L >>> 0 ? n + 1 | 0 : n, Wr = (L << 4 | Be >>> 28) & 16777215, Mr = E, Ur(Bi, kn | E >>> 16 & 15, Wr, 0, 0, 977, 1, 0, 0), ni = T + 928 | 0, Ur(ni, xn, Ir, 0, 0, $r, Xn, 0, 0), fi = T + 736 | 0, Ur(fi, Bn, Gn, 0, 0, gn, cr, 0, 0), Zn = T + 960 | 0, Ur(Zn, or, Me, 0, 0, or, Me, 0, 0), jn = T + 720 | 0, kn = jn, Wr = (a | 0) == (L | 0) & Be >>> 0 < gr >>> 0 | a >>> 0 > L >>> 0, Be = (a | 0) == (ai | 0) & gr >>> 0 < Un >>> 0 | a >>> 0 < ai >>> 0, E = wi + 8 | 0, a = t[E >> 2], n = Ii + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, E = Be + gr | 0, n = E >>> 0 < gr >>> 0 ? n + 1 | 0 : n, he = he >>> 20 | 0, a = E + he | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Wr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, L = a << 12 | L >>> 20, E = n, he = n << 12 | a >>> 20, gr = t[T + 736 >> 2], a = t[T + 960 >> 2], Be = gr + a | 0, Wr = t[T + 740 >> 2], n = Wr + t[T + 964 >> 2] | 0, a = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, n = a + he | 0, L = L + Be | 0, n = L >>> 0 < Be >>> 0 ? n + 1 | 0 : n, he = n, Ur(kn, L, n & 1048575, 0, 0, 15632, 16, 0, 0), Un = T + 864 | 0, Ur(Un, gn, cr, 0, 0, $r, Xn, 0, 0), kn = T + 912 | 0, Ur(kn, xn, Ir, 0, 0, xn, Ir, 0, 0), cr = T + 704 | 0, Ur(cr, Bn, Gn, 0, 0, or, Me, 0, 0), Gn = T + 688 | 0, or = Gn, Me = (n | 0) == (a | 0) & L >>> 0 < Be >>> 0 | n >>> 0 < a >>> 0, Be = (a | 0) == (Wr | 0) & Be >>> 0 < gr >>> 0 | a >>> 0 < Wr >>> 0, L = Zn + 8 | 0, a = t[L >> 2], n = fi + 8 | 0, Ir = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[L + 4 >> 2] | 0, n = a >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, L = Be + Ir | 0, n = L >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + L | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, L = a << 12 | he >>> 20, he = t[T + 704 >> 2], Me = L + he | 0, E = n, a = n << 12 | a >>> 20, n = a + t[T + 708 >> 2] | 0, n = he >>> 0 > Me >>> 0 ? n + 1 | 0 : n, Ur(or, Me, n, 0, 0, 15632, 16, 0, 0), Wr = T + 672 | 0, Be = Wr, L = (n | 0) == (a | 0) & L >>> 0 > Me >>> 0 | n >>> 0 < a >>> 0, n = cr + 8 | 0, he = t[n >> 2], n = t[n + 4 >> 2], E = E >>> 20 | 0, a = E + he | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + L | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ur(Be, a, n, 0, 0, 64028672, 65536, 0, 0), E = t[T + 752 >> 2], a = t[T + 992 >> 2], or = E + a | 0, L = t[T + 756 >> 2], n = L + t[T + 996 >> 2] | 0, he = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, L = (L | 0) == (he | 0) & E >>> 0 > or >>> 0 | L >>> 0 > he >>> 0, E = Ti + 8 | 0, a = t[E >> 2], n = Bi + 8 | 0, Be = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, a = L + Be | 0, n = a >>> 0 < Be >>> 0 ? n + 1 | 0 : n, gr = he, Be = a << 12 | he >>> 20, E = n, L = n << 12 | a >>> 20, Me = t[T + 720 >> 2], a = t[T + 928 >> 2], he = Me + a | 0, Ir = t[T + 724 >> 2], n = Ir + t[T + 932 >> 2] | 0, n = a >>> 0 > he >>> 0 ? n + 1 | 0 : n, a = Be, Be = he, he = a + he | 0, a = n, n = n + L | 0, L = he >>> 0 < Be >>> 0 ? n + 1 | 0 : n, cr = (a | 0) == (L | 0) & he >>> 0 < Be >>> 0 | a >>> 0 > L >>> 0, Me = (a | 0) == (Ir | 0) & Be >>> 0 < Me >>> 0 | a >>> 0 < Ir >>> 0, Be = ni + 8 | 0, a = t[Be >> 2], n = jn + 8 | 0, Ir = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Be + 4 >> 2] | 0, n = a >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, Be = Me + Ir | 0, n = Be >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + Be | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + cr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ir = L, Be = a << 12 | L >>> 20, E = n, L = n << 12 | a >>> 20, Bn = t[T + 864 >> 2], a = t[T + 912 >> 2], cr = Bn + a | 0, jn = t[T + 868 >> 2], n = jn + t[T + 916 >> 2] | 0, n = a >>> 0 > cr >>> 0 ? n + 1 | 0 : n, a = t[T + 688 >> 2], Me = a + cr | 0, gn = n, n = n + t[T + 692 >> 2] | 0, a = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = a + L | 0, L = Be + Me | 0, Be = L >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Xn = (a | 0) == (Be | 0) & L >>> 0 < Me >>> 0 | a >>> 0 > Be >>> 0, $r = (a | 0) == (gn | 0) & Me >>> 0 < cr >>> 0 | a >>> 0 < gn >>> 0, n = Gn + 8 | 0, xn = t[n >> 2], Gn = t[n + 4 >> 2], cr = (gn | 0) == (jn | 0) & cr >>> 0 < Bn >>> 0 | gn >>> 0 < jn >>> 0, Me = kn + 8 | 0, a = t[Me >> 2], n = Un + 8 | 0, gn = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Me + 4 >> 2] | 0, n = a >>> 0 > gn >>> 0 ? n + 1 | 0 : n, a = cr + gn | 0, n = (a >>> 0 < gn >>> 0 ? n + 1 | 0 : n) + Gn | 0, cr = a, a = a + xn | 0, n = cr >>> 0 > a >>> 0 ? n + 1 | 0 : n, Me = a + $r | 0, n = Me >>> 0 < a >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Xn | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, cr = Be, Me = a << 12 | Be >>> 20, E = n, Be = n << 12 | a >>> 20, xn = t[T + 672 >> 2], xr = xn + (xr & -2) | 0, Gn = t[T + 676 >> 2], n = Gn + (dr & 1048575) | 0, a = xr >>> 0 < xn >>> 0 ? n + 1 | 0 : n, n = a + Be | 0, dr = tr, gn = Mr & 65535, Me = Me + xr | 0, Be = Me >>> 0 < xr >>> 0 ? n + 1 | 0 : n, tr = Me, Mr = (a | 0) == (Be | 0) & Me >>> 0 < xr >>> 0 | a >>> 0 > Be >>> 0, a = (a | 0) == (Gn | 0) & xr >>> 0 < xn >>> 0 | a >>> 0 < Gn >>> 0, n = Wr + 8 | 0, Me = a + t[n >> 2] | 0, n = t[n + 4 >> 2], n = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Mr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = Be, Me = a << 12 | E >>> 20, Be = Me + dr | 0, n = gn + (n << 12 | a >>> 20) | 0, a = Be, Be = a >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Me = E & 1048575, cr = cr & 1048575, dr = Ir & 1048575, E = or, or = gr & 1048575, d = d - 1 | 0, !!d; )
      ;
    for (t[T + 7168 >> 2] = a, t[T + 7172 >> 2] = Be, t[T + 7160 >> 2] = tr, t[T + 7164 >> 2] = Me, t[T + 7152 >> 2] = L, t[T + 7156 >> 2] = cr, t[T + 7144 >> 2] = he, t[T + 7148 >> 2] = dr, t[T + 7136 >> 2] = E, t[T + 7140 >> 2] = or, d = T + 7136 | 0, Xr(d, d, T + 7376 | 0), d = 6, a = t[T + 7168 >> 2], Be = t[T + 7172 >> 2], tr = t[T + 7160 >> 2], Me = t[T + 7164 >> 2], L = t[T + 7152 >> 2], cr = t[T + 7156 >> 2], he = t[T + 7144 >> 2], dr = t[T + 7148 >> 2], E = t[T + 7136 >> 2], or = t[T + 7140 >> 2]; gr = E, n = or << 1 | E >>> 31, Un = T + 640 | 0, $r = E << 1, Xn = n, Ur(Un, tr, Me, 0, 0, $r, n, 0, 0), Wr = T + 560 | 0, E = he << 1, Ir = dr, xn = he, he = dr << 1 | he >>> 31, Ur(Wr, L, cr, 0, 0, E, he, 0, 0), xr = T + 496 | 0, Ur(xr, a, Be, 0, 0, a, Be, 0, 0), Mr = T + 480 | 0, Ur(Mr, t[T + 496 >> 2], t[T + 500 >> 2], 0, 0, 15632, 16, 0, 0), n = Be << 1 | a >>> 31, Ai = T + 448 | 0, Bn = a << 1, Gn = n, Ur(Ai, Bn, n, 0, 0, gr, or, 0, 0), yi = T + 608 | 0, Ur(yi, tr, Me, 0, 0, E, he, 0, 0), Oi = T + 544 | 0, Ur(Oi, L, cr, 0, 0, L, cr, 0, 0), kn = T + 464 | 0, n = xr + 8 | 0, Ur(kn, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ti = T + 656 | 0, Ur(Ti, gr, or, 0, 0, gr, or, 0, 0), Ii = T + 432 | 0, Ur(Ii, Bn, Gn, 0, 0, xn, dr, 0, 0), wi = T + 512 | 0, or = tr, gn = L, Ur(wi, tr, Me, 0, 0, L << 1, cr << 1 | L >>> 31, 0, 0), gr = t[T + 644 >> 2], n = gr + t[T + 564 >> 2] | 0, L = t[T + 640 >> 2], E = t[T + 560 >> 2], a = L + E | 0, he = t[T + 480 >> 2], xr = a + he | 0, E = a >>> 0 < E >>> 0 ? n + 1 | 0 : n, n = E + t[T + 484 >> 2] | 0, he = he >>> 0 > xr >>> 0 ? n + 1 | 0 : n, dr = (E | 0) == (he | 0) & a >>> 0 > xr >>> 0 | E >>> 0 > he >>> 0, n = Mr + 8 | 0, Be = t[n >> 2], tr = t[n + 4 >> 2], L = (E | 0) == (gr | 0) & a >>> 0 < L >>> 0 | E >>> 0 < gr >>> 0, E = Wr + 8 | 0, a = t[E >> 2], n = Un + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = L + gr | 0, n = (a >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + tr | 0, E = a, a = a + Be | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + dr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, dr = he, tr = a << 12 | he >>> 20, E = n, L = n << 12 | a >>> 20, ai = t[T + 608 >> 2], a = t[T + 544 >> 2], gr = ai + a | 0, Hi = t[T + 612 >> 2], n = Hi + t[T + 548 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = t[T + 448 >> 2], Be = a + gr | 0, Wr = n, n = n + t[T + 452 >> 2] | 0, n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, a = t[T + 464 >> 2], he = a + Be | 0, Mr = n, n = n + t[T + 468 >> 2] | 0, a = a >>> 0 > he >>> 0 ? n + 1 | 0 : n, n = a + L | 0, Bi = T + 416 | 0, tr = he + tr | 0, L = tr >>> 0 < he >>> 0 ? n + 1 | 0 : n, ni = (a | 0) == (L | 0) & he >>> 0 > tr >>> 0 | a >>> 0 > L >>> 0, fi = (a | 0) == (Mr | 0) & he >>> 0 < Be >>> 0 | a >>> 0 < Mr >>> 0, n = kn + 8 | 0, Zn = t[n >> 2], jn = t[n + 4 >> 2], Un = (Mr | 0) == (Wr | 0) & Be >>> 0 < gr >>> 0 | Mr >>> 0 < Wr >>> 0, n = Ai + 8 | 0, kn = t[n >> 2], Mr = t[n + 4 >> 2], Be = (Wr | 0) == (Hi | 0) & gr >>> 0 < ai >>> 0 | Wr >>> 0 < Hi >>> 0, he = Oi + 8 | 0, a = t[he >> 2], n = yi + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[he + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = Be + gr | 0, n = (a >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + Mr | 0, he = a, a = a + kn | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, he = a, a = a + Un | 0, n = (he >>> 0 > a >>> 0 ? n + 1 | 0 : n) + jn | 0, he = a, a = a + Zn | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, he = a + fi | 0, n = he >>> 0 < a >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + he | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + ni | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = L, Be = a << 12 | E >>> 20, he = n, L = n << 12 | a >>> 20, Un = t[T + 432 >> 2], a = t[T + 512 >> 2], gr = Un + a | 0, ai = t[T + 436 >> 2], n = ai + t[T + 516 >> 2] | 0, a = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, n = a + L | 0, Be = Be + gr | 0, n = Be >>> 0 < gr >>> 0 ? n + 1 | 0 : n, kn = Be << 4 & -16, L = n, Wr = (n << 4 | Be >>> 28) & 16777215, Mr = E, Ur(Bi, kn | E >>> 16 & 15, Wr, 0, 0, 977, 1, 0, 0), ni = T + 592 | 0, Ur(ni, xn, Ir, 0, 0, $r, Xn, 0, 0), fi = T + 400 | 0, Ur(fi, Bn, Gn, 0, 0, gn, cr, 0, 0), Zn = T + 624 | 0, Ur(Zn, or, Me, 0, 0, or, Me, 0, 0), jn = T + 384 | 0, kn = jn, Wr = (a | 0) == (n | 0) & Be >>> 0 < gr >>> 0 | a >>> 0 > n >>> 0, Be = (a | 0) == (ai | 0) & gr >>> 0 < Un >>> 0 | a >>> 0 < ai >>> 0, E = wi + 8 | 0, a = t[E >> 2], n = Ii + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, E = Be + gr | 0, n = E >>> 0 < gr >>> 0 ? n + 1 | 0 : n, he = he >>> 20 | 0, a = E + he | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Wr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, L = a << 12 | L >>> 20, E = n, Wr = n << 12 | a >>> 20, ai = t[T + 404 >> 2], n = ai + t[T + 628 >> 2] | 0, gr = t[T + 400 >> 2], a = t[T + 624 >> 2], he = gr + a | 0, Be = he, L = he + L | 0, a = a >>> 0 > he >>> 0 ? n + 1 | 0 : n, n = a + Wr | 0, he = L >>> 0 < he >>> 0 ? n + 1 | 0 : n, Ur(kn, L, he & 1048575, 0, 0, 15632, 16, 0, 0), Un = T + 528 | 0, Ur(Un, gn, cr, 0, 0, $r, Xn, 0, 0), kn = T + 576 | 0, Ur(kn, xn, Ir, 0, 0, xn, Ir, 0, 0), cr = T + 368 | 0, Ur(cr, Bn, Gn, 0, 0, or, Me, 0, 0), Gn = T + 352 | 0, or = Gn, Me = (a | 0) == (he | 0) & L >>> 0 < Be >>> 0 | a >>> 0 > he >>> 0, Be = (a | 0) == (ai | 0) & Be >>> 0 < gr >>> 0 | a >>> 0 < ai >>> 0, L = Zn + 8 | 0, a = t[L >> 2], n = fi + 8 | 0, Ir = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[L + 4 >> 2] | 0, n = a >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, L = Be + Ir | 0, n = L >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + L | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, L = a << 12 | he >>> 20, he = t[T + 368 >> 2], Me = L + he | 0, E = n, a = n << 12 | a >>> 20, n = a + t[T + 372 >> 2] | 0, n = he >>> 0 > Me >>> 0 ? n + 1 | 0 : n, Ur(or, Me, n, 0, 0, 15632, 16, 0, 0), Wr = T + 336 | 0, Be = Wr, L = (n | 0) == (a | 0) & L >>> 0 > Me >>> 0 | n >>> 0 < a >>> 0, n = cr + 8 | 0, he = t[n >> 2], n = t[n + 4 >> 2], E = E >>> 20 | 0, a = E + he | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + L | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ur(Be, a, n, 0, 0, 64028672, 65536, 0, 0), E = t[T + 416 >> 2], a = t[T + 656 >> 2], or = E + a | 0, L = t[T + 420 >> 2], n = L + t[T + 660 >> 2] | 0, he = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, L = (L | 0) == (he | 0) & E >>> 0 > or >>> 0 | L >>> 0 > he >>> 0, E = Ti + 8 | 0, a = t[E >> 2], n = Bi + 8 | 0, Be = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, a = L + Be | 0, n = a >>> 0 < Be >>> 0 ? n + 1 | 0 : n, gr = he, Be = a << 12 | he >>> 20, E = n, L = n << 12 | a >>> 20, Me = t[T + 384 >> 2], a = t[T + 592 >> 2], he = Me + a | 0, Ir = t[T + 388 >> 2], n = Ir + t[T + 596 >> 2] | 0, n = a >>> 0 > he >>> 0 ? n + 1 | 0 : n, a = Be, Be = he, he = a + he | 0, a = n, n = n + L | 0, L = he >>> 0 < Be >>> 0 ? n + 1 | 0 : n, cr = (a | 0) == (L | 0) & he >>> 0 < Be >>> 0 | a >>> 0 > L >>> 0, Me = (a | 0) == (Ir | 0) & Be >>> 0 < Me >>> 0 | a >>> 0 < Ir >>> 0, Be = ni + 8 | 0, a = t[Be >> 2], n = jn + 8 | 0, Ir = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Be + 4 >> 2] | 0, n = a >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, Be = Me + Ir | 0, n = Be >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + Be | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + cr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ir = L, Be = a << 12 | L >>> 20, E = n, L = n << 12 | a >>> 20, Bn = t[T + 528 >> 2], a = t[T + 576 >> 2], cr = Bn + a | 0, jn = t[T + 532 >> 2], n = jn + t[T + 580 >> 2] | 0, n = a >>> 0 > cr >>> 0 ? n + 1 | 0 : n, a = t[T + 352 >> 2], Me = a + cr | 0, gn = n, n = n + t[T + 356 >> 2] | 0, a = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = a + L | 0, L = Be + Me | 0, Be = L >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Xn = (a | 0) == (Be | 0) & L >>> 0 < Me >>> 0 | a >>> 0 > Be >>> 0, $r = (a | 0) == (gn | 0) & Me >>> 0 < cr >>> 0 | a >>> 0 < gn >>> 0, n = Gn + 8 | 0, xn = t[n >> 2], Gn = t[n + 4 >> 2], cr = (gn | 0) == (jn | 0) & cr >>> 0 < Bn >>> 0 | gn >>> 0 < jn >>> 0, Me = kn + 8 | 0, a = t[Me >> 2], n = Un + 8 | 0, gn = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Me + 4 >> 2] | 0, n = a >>> 0 > gn >>> 0 ? n + 1 | 0 : n, a = cr + gn | 0, n = (a >>> 0 < gn >>> 0 ? n + 1 | 0 : n) + Gn | 0, cr = a, a = a + xn | 0, n = cr >>> 0 > a >>> 0 ? n + 1 | 0 : n, Me = a + $r | 0, n = Me >>> 0 < a >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Xn | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, cr = Be, Me = a << 12 | Be >>> 20, E = n, Be = n << 12 | a >>> 20, xn = t[T + 336 >> 2], xr = xn + (xr & -2) | 0, Gn = t[T + 340 >> 2], n = Gn + (dr & 1048575) | 0, a = xr >>> 0 < xn >>> 0 ? n + 1 | 0 : n, n = a + Be | 0, dr = tr, gn = Mr & 65535, Me = Me + xr | 0, Be = Me >>> 0 < xr >>> 0 ? n + 1 | 0 : n, tr = Me, Mr = (a | 0) == (Be | 0) & Me >>> 0 < xr >>> 0 | a >>> 0 > Be >>> 0, a = (a | 0) == (Gn | 0) & xr >>> 0 < xn >>> 0 | a >>> 0 < Gn >>> 0, n = Wr + 8 | 0, Me = a + t[n >> 2] | 0, n = t[n + 4 >> 2], n = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Mr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = Be, Me = a << 12 | E >>> 20, Be = Me + dr | 0, n = gn + (n << 12 | a >>> 20) | 0, a = Be, Be = a >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Me = E & 1048575, cr = cr & 1048575, dr = Ir & 1048575, E = or, or = gr & 1048575, d = d - 1 | 0, !!d; )
      ;
    t[T + 7168 >> 2] = a, t[T + 7172 >> 2] = Be, t[T + 7160 >> 2] = tr, t[T + 7164 >> 2] = Me, t[T + 7152 >> 2] = L, t[T + 7156 >> 2] = cr, t[T + 7144 >> 2] = he, t[T + 7148 >> 2] = dr, t[T + 7136 >> 2] = E, t[T + 7140 >> 2] = or, Oi = T + 7136 | 0, Xr(Oi, Oi, T + 7576 | 0), d = t[T + 7140 >> 2], Ir = d, dr = t[T + 7136 >> 2], L = dr, n = d << 1 | L >>> 31, or = T - -64 | 0, gn = t[T + 7160 >> 2], xr = t[T + 7164 >> 2], Xn = L << 1, Bn = n, Ur(or, gn, xr, 0, 0, Xn, n, 0, 0), d = t[T + 7148 >> 2], Ai = d, yi = t[T + 7144 >> 2], a = yi, n = d << 1 | a >>> 31, Me = T + 272 | 0, xn = t[T + 7152 >> 2], Mr = t[T + 7156 >> 2], a = a << 1, E = n, Ur(Me, xn, Mr, 0, 0, a, n, 0, 0), Be = T + 224 | 0, he = t[T + 7168 >> 2], d = t[T + 7172 >> 2], Ur(Be, he, d, 0, 0, he, d, 0, 0), tr = T + 208 | 0, Ur(tr, t[T + 224 >> 2], t[T + 228 >> 2], 0, 0, 15632, 16, 0, 0), n = d << 1 | he >>> 31, Bi = T + 176 | 0, kn = he << 1, $r = n, Ur(Bi, kn, n, 0, 0, L, Ir, 0, 0), ni = T + 80 | 0, Ur(ni, gn, xr, 0, 0, a, E, 0, 0), fi = T + 256 | 0, Ur(fi, xn, Mr, 0, 0, xn, Mr, 0, 0), cr = T + 192 | 0, d = Be + 8 | 0, Ur(cr, t[d >> 2], t[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ti = T + 320 | 0, Ur(Ti, L, Ir, 0, 0, L, Ir, 0, 0), Ii = T + 160 | 0, Ur(Ii, kn, n, 0, 0, yi, Ai, 0, 0), wi = T + 96 | 0, Ur(wi, gn, xr, 0, 0, xn << 1, Mr << 1 | xn >>> 31, 0, 0), dr = t[T + 68 >> 2], n = dr + t[T + 276 >> 2] | 0, he = t[T + 64 >> 2], a = t[T + 272 >> 2], d = he + a | 0, E = t[T + 208 >> 2], gr = d + E | 0, a = d >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = a + t[T + 212 >> 2] | 0, E = E >>> 0 > gr >>> 0 ? n + 1 | 0 : n, Be = (a | 0) == (E | 0) & d >>> 0 > gr >>> 0 | a >>> 0 > E >>> 0, n = tr + 8 | 0, tr = t[n >> 2], L = t[n + 4 >> 2], he = (a | 0) == (dr | 0) & d >>> 0 < he >>> 0 | a >>> 0 < dr >>> 0, n = Me + 8 | 0, a = t[n >> 2], d = or + 8 | 0, Me = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, d = he + Me | 0, n = (d >>> 0 < Me >>> 0 ? n + 1 | 0 : n) + L | 0, a = d, d = d + tr | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + Be | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Ir = E, L = d << 12 | E >>> 20, a = n, he = n << 12 | d >>> 20, Zn = t[T + 80 >> 2], d = t[T + 256 >> 2], Me = Zn + d | 0, ai = t[T + 84 >> 2], n = ai + t[T + 260 >> 2] | 0, n = d >>> 0 > Me >>> 0 ? n + 1 | 0 : n, d = t[T + 176 >> 2], Be = d + Me | 0, dr = n, n = n + t[T + 180 >> 2] | 0, n = d >>> 0 > Be >>> 0 ? n + 1 | 0 : n, d = t[T + 192 >> 2], E = d + Be | 0, or = n, n = n + t[T + 196 >> 2] | 0, d = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, n = d + he | 0, he = T, tr = E + L | 0, L = tr >>> 0 < E >>> 0 ? n + 1 | 0 : n, jn = (d | 0) == (L | 0) & E >>> 0 > tr >>> 0 | d >>> 0 > L >>> 0, Un = (d | 0) == (or | 0) & E >>> 0 < Be >>> 0 | d >>> 0 < or >>> 0, d = cr + 8 | 0, Wr = t[d >> 2], Gn = t[d + 4 >> 2], T = (or | 0) == (dr | 0) & Be >>> 0 < Me >>> 0 | or >>> 0 < dr >>> 0, d = Bi + 8 | 0, cr = t[d >> 2], or = t[d + 4 >> 2], Be = (dr | 0) == (ai | 0) & Me >>> 0 < Zn >>> 0 | dr >>> 0 < ai >>> 0, n = fi + 8 | 0, E = t[n >> 2], d = ni + 8 | 0, Me = E + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = E >>> 0 > Me >>> 0 ? n + 1 | 0 : n, d = Be + Me | 0, n = (d >>> 0 < Me >>> 0 ? n + 1 | 0 : n) + or | 0, E = d, d = d + cr | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d, d = d + T | 0, n = (E >>> 0 > d >>> 0 ? n + 1 | 0 : n) + Gn | 0, E = d, d = d + Wr | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d + Un | 0, n = E >>> 0 < d >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + E | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + jn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = L, Me = d << 12 | a >>> 20, E = n, Be = n << 12 | d >>> 20, cr = t[he + 160 >> 2], d = t[he + 96 >> 2], L = cr + d | 0, Wr = t[he + 164 >> 2], n = Wr + t[he + 100 >> 2] | 0, d = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, n = d + Be | 0, or = L, L = L + Me | 0, dr = L << 4 & -16, Be = L >>> 0 < or >>> 0 ? n + 1 | 0 : n, Me = (Be << 4 | L >>> 28) & 16777215, T = a, Ur(he, dr | a >>> 16 & 15, Me, 0, 0, 977, 1, 0, 0), jn = t[he + 4 >> 2], n = jn + t[he + 324 >> 2] | 0, Un = t[he >> 2], a = t[he + 320 >> 2], Me = Un + a | 0, t[he + 7136 >> 2] = Me, a = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, t[he + 7140 >> 2] = a & 1048575, ai = he + 304 | 0, Ur(ai, yi, Ai, 0, 0, Xn, Bn, 0, 0), Bi = he + 144 | 0, Ur(Bi, kn, $r, 0, 0, xn, Mr, 0, 0), ni = he + 112 | 0, Ur(ni, gn, xr, 0, 0, gn, xr, 0, 0), fi = he + 48 | 0, Gn = fi, dr = (d | 0) == (Be | 0) & L >>> 0 < or >>> 0 | d >>> 0 > Be >>> 0, or = (d | 0) == (Wr | 0) & or >>> 0 < cr >>> 0 | d >>> 0 < Wr >>> 0, n = wi + 8 | 0, L = t[n >> 2], d = Ii + 8 | 0, cr = L + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = L >>> 0 > cr >>> 0 ? n + 1 | 0 : n, L = or + cr | 0, n = L >>> 0 < cr >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, d = E + L | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d, d = d + dr | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, or = d << 12 | Be >>> 20, L = n, Be = n << 12 | d >>> 20, Ii = t[he + 148 >> 2], n = Ii + t[he + 116 >> 2] | 0, Zn = t[he + 144 >> 2], E = t[he + 112 >> 2], d = Zn + E | 0, Wr = d, cr = d + or | 0, E = d >>> 0 < E >>> 0 ? n + 1 | 0 : n, n = E + Be | 0, or = cr >>> 0 < d >>> 0 ? n + 1 | 0 : n, Ur(Gn, cr, or & 1048575, 0, 0, 15632, 16, 0, 0), Be = he, Me = (a | 0) == (jn | 0) & Me >>> 0 < Un >>> 0 | a >>> 0 < jn >>> 0, n = Ti + 8 | 0, he = t[n >> 2], d = Be + 8 | 0, dr = he + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = he >>> 0 > dr >>> 0 ? n + 1 | 0 : n, d = Me + dr | 0, n = d >>> 0 < dr >>> 0 ? n + 1 | 0 : n, dr = d << 12 | a >>> 20, he = n, Me = n << 12 | d >>> 20, jn = t[Be + 48 >> 2], d = t[Be + 304 >> 2], Gn = jn + d | 0, wi = t[Be + 52 >> 2], n = wi + t[Be + 308 >> 2] | 0, a = d >>> 0 > Gn >>> 0 ? n + 1 | 0 : n, n = a + Me | 0, dr = dr + Gn | 0, n = dr >>> 0 < Gn >>> 0 ? n + 1 | 0 : n, t[Be + 7144 >> 2] = dr, Me = n, t[Be + 7148 >> 2] = n & 1048575, Un = Be + 240 | 0, Ur(Un, xn, Mr, 0, 0, Xn, Bn, 0, 0), Bn = Be + 288 | 0, Ur(Bn, yi, Ai, 0, 0, yi, Ai, 0, 0), Xn = Be + 128 | 0, Ur(Xn, kn, $r, 0, 0, gn, xr, 0, 0), xn = Be + 32 | 0, gn = xn, Mr = (E | 0) == (or | 0) & cr >>> 0 < Wr >>> 0 | E >>> 0 > or >>> 0, cr = (E | 0) == (Ii | 0) & Wr >>> 0 < Zn >>> 0 | E >>> 0 < Ii >>> 0, n = ni + 8 | 0, E = t[n >> 2], d = Bi + 8 | 0, xr = E + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = E >>> 0 > xr >>> 0 ? n + 1 | 0 : n, E = cr + xr | 0, n = E >>> 0 < xr >>> 0 ? n + 1 | 0 : n, L = L >>> 20 | 0, d = E + L | 0, n = L >>> 0 > d >>> 0 ? n + 1 | 0 : n, E = d, d = d + Mr | 0, n = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, xr = d << 12 | or >>> 20, L = t[Be + 128 >> 2], or = xr + L | 0, E = n, Wr = n << 12 | d >>> 20, n = Wr + t[Be + 132 >> 2] | 0, cr = L >>> 0 > or >>> 0 ? n + 1 | 0 : n, Ur(gn, or, cr, 0, 0, 15632, 16, 0, 0), L = Be, dr = (a | 0) == (Me | 0) & dr >>> 0 < Gn >>> 0 | a >>> 0 > Me >>> 0, Be = (a | 0) == (wi | 0) & Gn >>> 0 < jn >>> 0 | a >>> 0 < wi >>> 0, n = ai + 8 | 0, a = t[n >> 2], d = fi + 8 | 0, Mr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Mr >>> 0 ? n + 1 | 0 : n, a = Be + Mr | 0, n = a >>> 0 < Mr >>> 0 ? n + 1 | 0 : n, he = he >>> 20 | 0, d = a + he | 0, n = he >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + dr | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, Be = d << 12 | Me >>> 20, a = n, he = n << 12 | d >>> 20, Gn = t[L + 240 >> 2], d = t[L + 288 >> 2], dr = Gn + d | 0, $r = t[L + 244 >> 2], n = $r + t[L + 292 >> 2] | 0, n = d >>> 0 > dr >>> 0 ? n + 1 | 0 : n, d = t[L + 32 >> 2], Me = d + dr | 0, Mr = n, n = n + t[L + 36 >> 2] | 0, d = d >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = d + he | 0, Be = Be + Me | 0, n = Be >>> 0 < Me >>> 0 ? n + 1 | 0 : n, t[L + 7152 >> 2] = Be, he = n, t[L + 7156 >> 2] = n & 1048575, gn = L + 16 | 0, xr = (cr | 0) == (Wr | 0) & or >>> 0 < xr >>> 0 | cr >>> 0 < Wr >>> 0, n = Xn + 8 | 0, cr = t[n >> 2], n = t[n + 4 >> 2], E = E >>> 20 | 0, or = E, E = E + cr | 0, n = or >>> 0 > E >>> 0 ? n + 1 | 0 : n, or = E, E = E + xr | 0, n = or >>> 0 > E >>> 0 ? n + 1 | 0 : n, Ur(gn, E, n, 0, 0, 64028672, 65536, 0, 0), E = L, xr = (d | 0) == (he | 0) & Be >>> 0 < Me >>> 0 | d >>> 0 > he >>> 0, cr = (d | 0) == (Mr | 0) & Me >>> 0 < dr >>> 0 | d >>> 0 < Mr >>> 0, d = xn + 8 | 0, or = t[d >> 2], Me = t[d + 4 >> 2], Be = (Mr | 0) == ($r | 0) & dr >>> 0 < Gn >>> 0 | Mr >>> 0 < $r >>> 0, n = Bn + 8 | 0, L = t[n >> 2], d = Un + 8 | 0, dr = L + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = L >>> 0 > dr >>> 0 ? n + 1 | 0 : n, d = Be + dr | 0, n = (d >>> 0 < dr >>> 0 ? n + 1 | 0 : n) + Me | 0, L = d, d = d + or | 0, n = L >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d + cr | 0, n = L >>> 0 < d >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = a + L | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + xr | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d << 12 | he >>> 20, a = n, Me = n << 12 | d >>> 20, dr = t[E + 16 >> 2], he = gr & -2, d = dr + he | 0, cr = t[E + 20 >> 2], n = cr + (Ir & 1048575) | 0, Be = d >>> 0 < he >>> 0 ? n + 1 | 0 : n, n = Be + Me | 0, he = L, L = d, he = he + d | 0, t[E + 7160 >> 2] = he, d = d >>> 0 > he >>> 0 ? n + 1 | 0 : n, t[E + 7164 >> 2] = d & 1048575, Ir = E, or = T & 65535, Me = (d | 0) == (Be | 0) & L >>> 0 > he >>> 0 | d >>> 0 < Be >>> 0, E = (Be | 0) == (cr | 0) & L >>> 0 < dr >>> 0 | Be >>> 0 < cr >>> 0, n = gn + 8 | 0, he = E + t[n >> 2] | 0, n = t[n + 4 >> 2], n = E >>> 0 > he >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, E = a, a = a + he | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, d = a << 12 | d >>> 20, E = d + tr | 0, n = or + (n << 12 | a >>> 20) | 0, t[Ir + 7168 >> 2] = E, t[Ir + 7172 >> 2] = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, d = v + 40 | 0, Ui(d, Oi), Ui(Oi, d), n = t[Ir + 7080 >> 2], d = t[Ir + 7160 >> 2], Mr = n - d | 0, gr = t[Ir + 7084 >> 2] - (t[Ir + 7164 >> 2] + (d >>> 0 > n >>> 0) | 0) | 0, n = t[Ir + 7072 >> 2], d = t[Ir + 7152 >> 2], T = n - d | 0, cr = t[Ir + 7076 >> 2] - (t[Ir + 7156 >> 2] + (d >>> 0 > n >>> 0) | 0) | 0, n = t[Ir + 7064 >> 2], d = t[Ir + 7144 >> 2], Be = n - d | 0, tr = t[Ir + 7068 >> 2] - (t[Ir + 7148 >> 2] + (d >>> 0 > n >>> 0) | 0) | 0, n = t[Ir + 7056 >> 2], d = t[Ir + 7136 >> 2], L = n - d | 0, E = t[Ir + 7060 >> 2] - (t[Ir + 7140 >> 2] + (d >>> 0 > n >>> 0) | 0) | 0, a = t[Ir + 7088 >> 2], n = t[Ir + 7168 >> 2], d = (a - n | 0) - 4 | 0, n = (t[Ir + 7092 >> 2] - (t[Ir + 7172 >> 2] + (n >>> 0 > a >>> 0) | 0) | 0) + 262143 | 0, he = d >>> 0 < 4294967292 ? n + 1 | 0 : n, a = pn(he >>> 16 | 0, 0, 977, 1), L = a + L | 0, n = E + Ee | 0, n = (a >>> 0 > L >>> 0 ? n + 1 | 0 : n) + 4194299 | 0, a = L - 3908 | 0, n = a >>> 0 < 4294963388 ? n + 1 | 0 : n, dr = a, or = n, n = tr, a = or >>> 20 | 0, E = a, a = a + Be | 0, n = (E >>> 0 > a >>> 0 ? n + 1 | 0 : n) + 4194303 | 0, a = a - 4 | 0, n = a >>> 0 < 4294967292 ? n + 1 | 0 : n, Me = a, Be = n, n = cr, a = Be >>> 20 | 0, E = a, a = a + T | 0, n = (E >>> 0 > a >>> 0 ? n + 1 | 0 : n) + 4194303 | 0, a = a - 4 | 0, n = a >>> 0 < 4294967292 ? n + 1 | 0 : n, tr = a, L = n, n = gr, a = L >>> 20 | 0, E = a, a = a + Mr | 0, n = (E >>> 0 > a >>> 0 ? n + 1 | 0 : n) + 4194303 | 0, E = a - 4 | 0, a = E >>> 0 < 4294967292 ? n + 1 | 0 : n, cr = he & 65535, he = E, n = cr, E = a >>> 20 | 0, gr = E, E = d + E | 0, n = gr >>> 0 > E >>> 0 ? n + 1 | 0 : n;
    e: {
      if (E | (he | (Me | dr | tr)) | (n | (Be | or | L | a) & 1048575) && (d = 0, (Me & (dr ^ 976) & tr & he & E) != -1 ? n = 1 : n = (Be & (or ^ 1) & L & a & (n ^ 983040)) != 1048575, n) || (d = v + 48 | 0, tr = t[d >> 2], he = t[d + 4 >> 2], a = t[v + 44 >> 2], d = v + 72 | 0, Me = t[d >> 2], d = t[d + 4 >> 2], gr = d, n = t[v + 40 >> 2], d = pn(d >>> 16 | 0, 0, 977, 1), L = n + d | 0, n = a + Ee | 0, cr = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, n = he, d = cr >>> 20 | 0, he = d + tr | 0, d = d >>> 0 > he >>> 0 ? n + 1 | 0 : n, dr = d & 1048575, n = v - -64 | 0, or = t[n >> 2], Be = t[n + 4 >> 2], n = v + 56 | 0, E = t[n >> 2], n = t[n + 4 >> 2], tr = d >>> 20 | 0, a = E + tr | 0, tr = tr >>> 0 > a >>> 0 ? n + 1 | 0 : n, n = Be, E = tr >>> 20 | 0, Be = E, E = E + or | 0, n = Be >>> 0 > E >>> 0 ? n + 1 | 0 : n, or = n & 1048575, Be = tr & 1048575, T = (a & he & E) == -1 & (d & Be & n) == 1048575, d = n, n = gr & 65535, d = d >>> 20 | 0, tr = d + Me | 0, n = d >>> 0 > tr >>> 0 ? n + 1 | 0 : n, Me = n, cr = cr & 1048575, T & ((tr | 0) == -1 & (n | 0) == 65535) & ((cr | 0) == 1048574 & L >>> 0 > 4294966318 | cr >>> 0 > 1048574) | n >>> 16 && (n = cr + 1 | 0, L = L + 977 | 0, n = L >>> 0 < 977 ? n + 1 | 0 : n, cr = n & 1048575, d = n, n = dr, d = d >>> 20 | 0, he = d + he | 0, n = d >>> 0 > he >>> 0 ? n + 1 | 0 : n, dr = n & 1048575, d = n, n = Be, d = d >>> 20 | 0, a = d + a | 0, n = d >>> 0 > a >>> 0 ? n + 1 | 0 : n, Be = n & 1048575, d = n, n = or, d = d >>> 20 | 0, E = d + E | 0, n = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, or = n & 1048575, d = n, n = Me, gr = tr, tr = (d >>> 20 | 0) + tr | 0, Me = (gr >>> 0 > tr >>> 0 ? n + 1 | 0 : n) & 65535), t[v + 72 >> 2] = tr, t[v + 76 >> 2] = Me, t[v + 64 >> 2] = E, t[v + 68 >> 2] = or, t[v + 56 >> 2] = a, t[v + 60 >> 2] = Be, t[v + 48 >> 2] = he, t[v + 52 >> 2] = dr, t[v + 40 >> 2] = L, t[v + 44 >> 2] = cr, d = 1, (L & 1) == (I | 0)))
        break e;
      t[v + 72 >> 2] = -4 - tr, t[v + 76 >> 2] = 262143 - ((tr >>> 0 > 4294967292) + Me | 0), t[v + 64 >> 2] = -4 - E, t[v + 68 >> 2] = 4194303 - ((E >>> 0 > 4294967292) + or | 0), t[v + 56 >> 2] = -4 - a, t[v + 60 >> 2] = 4194303 - ((a >>> 0 > 4294967292) + Be | 0), t[v + 48 >> 2] = -4 - he, t[v + 52 >> 2] = 4194303 - ((he >>> 0 > 4294967292) + dr | 0), t[v + 40 >> 2] = -3908 - L, t[v + 44 >> 2] = 4194299 - ((L >>> 0 > 4294963388) + cr | 0);
    }
    return x = Ir + 7616 | 0, d;
  }
  function Xr(v, d, I) {
    var n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0, Xn = 0, Zn = 0, ni = 0, ai = 0, fi = 0, Ai = 0, yi = 0, Ii = 0, wi = 0, Bi = 0, Ti = 0, Oi = 0, Hi = 0, Xi = 0, Zi = 0, ts = 0, us = 0, hs = 0, ws = 0, ks = 0, Bs = 0, gs = 0, ps = 0, zs = 0, Gs = 0, to = 0, ro = 0, $s = 0, Xs = 0, Ao = 0, co = 0, Co = 0, wo = 0, fo = 0, pi = 0, bi = 0, Ni = 0;
    n = x - 496 | 0, x = n, Wr = n - -64 | 0, ai = t[I + 24 >> 2], fi = t[I + 28 >> 2], Ai = t[d >> 2], yi = t[d + 4 >> 2], Ur(Wr, ai, fi, 0, 0, Ai, yi, 0, 0), gn = n + 208 | 0, Ii = t[I + 16 >> 2], wi = t[I + 20 >> 2], Bi = t[d + 8 >> 2], Ti = t[d + 12 >> 2], Ur(gn, Ii, wi, 0, 0, Bi, Ti, 0, 0), Ir = n + 320 | 0, Oi = t[I + 8 >> 2], Hi = t[I + 12 >> 2], Xi = t[d + 16 >> 2], Zi = t[d + 20 >> 2], Ur(Ir, Oi, Hi, 0, 0, Xi, Zi, 0, 0), Me = n + 400 | 0, ts = t[I >> 2], us = t[I + 4 >> 2], hs = t[d + 24 >> 2], ws = t[d + 28 >> 2], Ur(Me, ts, us, 0, 0, hs, ws, 0, 0), a = n + 480 | 0, ks = t[I + 32 >> 2], Bs = t[I + 36 >> 2], gs = t[d + 32 >> 2], xn = t[d + 36 >> 2], Ur(a, ks, Bs, 0, 0, gs, xn, 0, 0), Be = n + 464 | 0, Ur(Be, t[n + 480 >> 2], t[n + 484 >> 2], 0, 0, 15632, 16, 0, 0), $r = n + 80 | 0, Ur($r, ks, Bs, 0, 0, Ai, yi, 0, 0), ps = n + 144 | 0, Ur(ps, ai, fi, 0, 0, Bi, Ti, 0, 0), zs = n + 272 | 0, Ur(zs, Ii, wi, 0, 0, Xi, Zi, 0, 0), Gs = n + 368 | 0, Ur(Gs, Oi, Hi, 0, 0, hs, ws, 0, 0), Gn = n + 432 | 0, Ur(Gn, ts, us, 0, 0, gs, xn, 0, 0), gr = n + 448 | 0, d = a + 8 | 0, Ur(gr, t[d >> 2], t[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), to = n + 96 | 0, Ur(to, ts, us, 0, 0, Ai, yi, 0, 0), ro = n + 224 | 0, Ur(ro, ks, Bs, 0, 0, Bi, Ti, 0, 0), $s = n + 160 | 0, Ur($s, ai, fi, 0, 0, Xi, Zi, 0, 0), Xs = n + 288 | 0, Ur(Xs, Ii, wi, 0, 0, hs, ws, 0, 0), Xn = n + 384 | 0, Ur(Xn, Oi, Hi, 0, 0, gs, xn, 0, 0), dr = t[n + 208 >> 2], I = t[n + 64 >> 2], Mr = dr + I | 0, xr = t[n + 212 >> 2], d = xr + t[n + 68 >> 2] | 0, d = I >>> 0 > Mr >>> 0 ? d + 1 | 0 : d, I = t[n + 320 >> 2], he = I + Mr | 0, a = d, d = d + t[n + 324 >> 2] | 0, L = I >>> 0 > he >>> 0 ? d + 1 | 0 : d, d = L + t[n + 404 >> 2] | 0, I = t[n + 400 >> 2], T = I + he | 0, E = t[n + 464 >> 2], Ao = T + E | 0, I = I >>> 0 > T >>> 0 ? d + 1 | 0 : d, d = I + t[n + 468 >> 2] | 0, E = E >>> 0 > Ao >>> 0 ? d + 1 | 0 : d, or = (I | 0) == (E | 0) & T >>> 0 > Ao >>> 0 | I >>> 0 > E >>> 0, d = Be + 8 | 0, co = t[d >> 2], jn = t[d + 4 >> 2], tr = (I | 0) == (L | 0) & he >>> 0 > T >>> 0 | I >>> 0 < L >>> 0, d = Me + 8 | 0, cr = t[d >> 2], Me = t[d + 4 >> 2], Be = (a | 0) == (L | 0) & he >>> 0 < Mr >>> 0 | a >>> 0 > L >>> 0, d = Ir + 8 | 0, L = t[d >> 2], he = t[d + 4 >> 2], T = (a | 0) == (xr | 0) & dr >>> 0 > Mr >>> 0 | a >>> 0 < xr >>> 0, a = Wr + 8 | 0, I = t[a >> 2], d = gn + 8 | 0, Mr = I + t[d >> 2] | 0, d = t[d + 4 >> 2] + t[a + 4 >> 2] | 0, d = I >>> 0 > Mr >>> 0 ? d + 1 | 0 : d, I = T + Mr | 0, d = (I >>> 0 < Mr >>> 0 ? d + 1 | 0 : d) + he | 0, a = I, I = I + L | 0, d = a >>> 0 > I >>> 0 ? d + 1 | 0 : d, a = I, I = I + Be | 0, d = (a >>> 0 > I >>> 0 ? d + 1 | 0 : d) + Me | 0, a = I, I = I + cr | 0, d = a >>> 0 > I >>> 0 ? d + 1 | 0 : d, a = I, I = I + tr | 0, d = (a >>> 0 > I >>> 0 ? d + 1 | 0 : d) + jn | 0, a = I, I = I + co | 0, d = a >>> 0 > I >>> 0 ? d + 1 | 0 : d, a = I, I = I + or | 0, d = a >>> 0 > I >>> 0 ? d + 1 | 0 : d, co = E, Mr = I << 12 | E >>> 20, a = d, T = d << 12 | I >>> 20, Bn = t[n + 272 >> 2], I = t[n + 144 >> 2], Me = Bn + I | 0, Zn = t[n + 276 >> 2], d = Zn + t[n + 148 >> 2] | 0, d = I >>> 0 > Me >>> 0 ? d + 1 | 0 : d, I = t[n + 368 >> 2], Be = I + Me | 0, or = d, d = d + t[n + 372 >> 2] | 0, d = I >>> 0 > Be >>> 0 ? d + 1 | 0 : d, I = t[n + 432 >> 2], L = I + Be | 0, jn = d, d = d + t[n + 436 >> 2] | 0, d = I >>> 0 > L >>> 0 ? d + 1 | 0 : d, I = t[n + 80 >> 2], he = I + L | 0, tr = d, d = d + t[n + 84 >> 2] | 0, d = I >>> 0 > he >>> 0 ? d + 1 | 0 : d, I = t[n + 448 >> 2], E = I + he | 0, cr = d, d = d + t[n + 452 >> 2] | 0, I = I >>> 0 > E >>> 0 ? d + 1 | 0 : d, d = I + T | 0, Mr = E + Mr | 0, T = Mr >>> 0 < E >>> 0 ? d + 1 | 0 : d, Un = (I | 0) == (T | 0) & E >>> 0 > Mr >>> 0 | I >>> 0 > T >>> 0, kn = (I | 0) == (cr | 0) & E >>> 0 < he >>> 0 | I >>> 0 < cr >>> 0, d = gr + 8 | 0, xr = t[d >> 2], Wr = t[d + 4 >> 2], gn = (tr | 0) == (cr | 0) & he >>> 0 < L >>> 0 | tr >>> 0 > cr >>> 0, d = $r + 8 | 0, Ir = t[d >> 2], $r = t[d + 4 >> 2], gr = (tr | 0) == (jn | 0) & L >>> 0 < Be >>> 0 | tr >>> 0 < jn >>> 0, d = Gn + 8 | 0, dr = t[d >> 2], tr = t[d + 4 >> 2], cr = (or | 0) == (jn | 0) & Me >>> 0 > Be >>> 0 | or >>> 0 > jn >>> 0, d = Gs + 8 | 0, Be = t[d >> 2], L = t[d + 4 >> 2], he = (or | 0) == (Zn | 0) & Me >>> 0 < Bn >>> 0 | or >>> 0 < Zn >>> 0, E = ps + 8 | 0, I = t[E >> 2], d = zs + 8 | 0, Me = I + t[d >> 2] | 0, d = t[d + 4 >> 2] + t[E + 4 >> 2] | 0, d = I >>> 0 > Me >>> 0 ? d + 1 | 0 : d, I = he + Me | 0, d = (I >>> 0 < Me >>> 0 ? d + 1 | 0 : d) + L | 0, E = I, I = I + Be | 0, d = E >>> 0 > I >>> 0 ? d + 1 | 0 : d, E = I, I = I + cr | 0, d = (E >>> 0 > I >>> 0 ? d + 1 | 0 : d) + tr | 0, E = I, I = I + dr | 0, d = E >>> 0 > I >>> 0 ? d + 1 | 0 : d, E = I, I = I + gr | 0, d = (E >>> 0 > I >>> 0 ? d + 1 | 0 : d) + $r | 0, E = I, I = I + Ir | 0, d = E >>> 0 > I >>> 0 ? d + 1 | 0 : d, E = I, I = I + gn | 0, d = (E >>> 0 > I >>> 0 ? d + 1 | 0 : d) + Wr | 0, E = I, I = I + xr | 0, d = E >>> 0 > I >>> 0 ? d + 1 | 0 : d, E = I + kn | 0, d = E >>> 0 < I >>> 0 ? d + 1 | 0 : d, a = a >>> 20 | 0, I = a + E | 0, d = a >>> 0 > I >>> 0 ? d + 1 | 0 : d, a = I, I = I + Un | 0, d = a >>> 0 > I >>> 0 ? d + 1 | 0 : d, a = T, he = I << 12 | a >>> 20, E = d, T = d << 12 | I >>> 20, kn = t[n + 288 >> 2], I = t[n + 160 >> 2], tr = kn + I | 0, Bn = t[n + 292 >> 2], d = Bn + t[n + 164 >> 2] | 0, d = I >>> 0 > tr >>> 0 ? d + 1 | 0 : d, I = t[n + 384 >> 2], cr = I + tr | 0, dr = d, d = d + t[n + 388 >> 2] | 0, d = I >>> 0 > cr >>> 0 ? d + 1 | 0 : d, I = t[n + 224 >> 2], Me = I + cr | 0, or = d, d = d + t[n + 228 >> 2] | 0, I = I >>> 0 > Me >>> 0 ? d + 1 | 0 : d, d = I + T | 0, he = he + Me | 0, d = he >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Be = he << 4 & -16, T = d, L = (d << 4 | he >>> 28) & 16777215, jn = a, Ur(n, Be | a >>> 16 & 15, L, 0, 0, 977, 1, 0, 0), Un = t[n + 4 >> 2], d = Un + t[n + 100 >> 2] | 0, L = v, xr = t[n >> 2], v = t[n + 96 >> 2], Be = xr + v | 0, t[L >> 2] = Be, a = v >>> 0 > Be >>> 0 ? d + 1 | 0 : d, t[L + 4 >> 2] = a & 1048575, fo = n + 112 | 0, Ur(fo, Oi, Hi, 0, 0, Ai, yi, 0, 0), pi = n + 240 | 0, Ur(pi, ts, us, 0, 0, Bi, Ti, 0, 0), bi = n + 336 | 0, Ur(bi, ks, Bs, 0, 0, Xi, Zi, 0, 0), ni = n + 176 | 0, Ur(ni, ai, fi, 0, 0, hs, ws, 0, 0), Gn = n + 304 | 0, Ur(Gn, Ii, wi, 0, 0, gs, xn, 0, 0), Ni = n + 48 | 0, Wr = Ni, gn = (I | 0) == (T | 0) & he >>> 0 < Me >>> 0 | I >>> 0 > T >>> 0, Ir = (I | 0) == (or | 0) & Me >>> 0 < cr >>> 0 | I >>> 0 < or >>> 0, v = ro + 8 | 0, $r = t[v >> 2], gr = t[v + 4 >> 2], or = (or | 0) == (dr | 0) & tr >>> 0 > cr >>> 0 | or >>> 0 < dr >>> 0, v = Xn + 8 | 0, cr = t[v >> 2], Me = t[v + 4 >> 2], he = (dr | 0) == (Bn | 0) & tr >>> 0 < kn >>> 0 | dr >>> 0 < Bn >>> 0, d = $s + 8 | 0, I = t[d >> 2], v = Xs + 8 | 0, tr = I + t[v >> 2] | 0, d = t[v + 4 >> 2] + t[d + 4 >> 2] | 0, d = I >>> 0 > tr >>> 0 ? d + 1 | 0 : d, v = he + tr | 0, d = (v >>> 0 < tr >>> 0 ? d + 1 | 0 : d) + Me | 0, I = v, v = v + cr | 0, d = I >>> 0 > v >>> 0 ? d + 1 | 0 : d, I = v, v = v + or | 0, d = (I >>> 0 > v >>> 0 ? d + 1 | 0 : d) + gr | 0, I = v, v = v + $r | 0, d = I >>> 0 > v >>> 0 ? d + 1 | 0 : d, I = v + Ir | 0, d = I >>> 0 < v >>> 0 ? d + 1 | 0 : d, E = E >>> 20 | 0, v = I + E | 0, d = E >>> 0 > v >>> 0 ? d + 1 | 0 : d, I = v, v = v + gn | 0, d = I >>> 0 > v >>> 0 ? d + 1 | 0 : d, E = v << 12 | T >>> 20, he = d, I = d << 12 | v >>> 20, Xn = t[n + 304 >> 2], v = t[n + 176 >> 2], dr = Xn + v | 0, Co = t[n + 308 >> 2], d = Co + t[n + 180 >> 2] | 0, d = v >>> 0 > dr >>> 0 ? d + 1 | 0 : d, v = t[n + 336 >> 2], or = v + dr | 0, gr = d, d = d + t[n + 340 >> 2] | 0, T = v >>> 0 > or >>> 0 ? d + 1 | 0 : d, d = T + I | 0, tr = E + or | 0, d = tr >>> 0 < or >>> 0 ? d + 1 | 0 : d, Me = d, Ur(Wr, tr, d & 1048575, 0, 0, 15632, 16, 0, 0), E = (a | 0) == (Un | 0) & Be >>> 0 < xr >>> 0 | a >>> 0 < Un >>> 0, d = to + 8 | 0, I = t[d >> 2], v = n + 8 | 0, Be = I + t[v >> 2] | 0, d = t[v + 4 >> 2] + t[d + 4 >> 2] | 0, d = I >>> 0 > Be >>> 0 ? d + 1 | 0 : d, v = E + Be | 0, d = v >>> 0 < Be >>> 0 ? d + 1 | 0 : d, cr = v << 12 | a >>> 20, E = d, Be = d << 12 | v >>> 20, Zn = t[n + 240 >> 2], v = t[n + 112 >> 2], Ir = Zn + v | 0, wo = t[n + 244 >> 2], d = wo + t[n + 116 >> 2] | 0, kn = v >>> 0 > Ir >>> 0 ? d + 1 | 0 : d, d = kn + t[n + 52 >> 2] | 0, I = t[n + 48 >> 2], v = I + Ir | 0, gn = v, cr = v + cr | 0, a = v >>> 0 < I >>> 0 ? d + 1 | 0 : d, d = a + Be | 0, t[L + 8 >> 2] = cr, Be = cr >>> 0 < v >>> 0 ? d + 1 | 0 : d, t[L + 12 >> 2] = Be & 1048575, ps = n + 128 | 0, Ur(ps, Ii, wi, 0, 0, Ai, yi, 0, 0), zs = n + 256 | 0, Ur(zs, Oi, Hi, 0, 0, Bi, Ti, 0, 0), Gs = n + 352 | 0, Ur(Gs, ts, us, 0, 0, Xi, Zi, 0, 0), to = n + 416 | 0, Ur(to, ks, Bs, 0, 0, hs, ws, 0, 0), ro = n + 192 | 0, Ur(ro, ai, fi, 0, 0, gs, xn, 0, 0), $s = n + 32 | 0, Bn = $s, Xs = t[n + 416 >> 2], v = t[n + 192 >> 2], $r = Xs + v | 0, xn = t[n + 420 >> 2], d = xn + t[n + 196 >> 2] | 0, I = v >>> 0 > $r >>> 0 ? d + 1 | 0 : d, Un = (T | 0) == (Me | 0) & tr >>> 0 < or >>> 0 | T >>> 0 > Me >>> 0, xr = (T | 0) == (gr | 0) & or >>> 0 < dr >>> 0 | T >>> 0 < gr >>> 0, v = bi + 8 | 0, Wr = t[v >> 2], or = t[v + 4 >> 2], tr = (gr | 0) == (Co | 0) & dr >>> 0 < Xn >>> 0 | gr >>> 0 < Co >>> 0, d = ni + 8 | 0, T = t[d >> 2], v = Gn + 8 | 0, dr = T + t[v >> 2] | 0, d = t[v + 4 >> 2] + t[d + 4 >> 2] | 0, d = T >>> 0 > dr >>> 0 ? d + 1 | 0 : d, v = tr + dr | 0, d = (v >>> 0 < dr >>> 0 ? d + 1 | 0 : d) + or | 0, T = v, v = v + Wr | 0, d = T >>> 0 > v >>> 0 ? d + 1 | 0 : d, T = v + xr | 0, d = T >>> 0 < v >>> 0 ? d + 1 | 0 : d, he = he >>> 20 | 0, v = he + T | 0, d = he >>> 0 > v >>> 0 ? d + 1 | 0 : d, T = v, v = v + Un | 0, d = T >>> 0 > v >>> 0 ? d + 1 | 0 : d, he = v << 12 | Me >>> 20, Me = he + $r | 0, T = d, d = I + (d << 12 | v >>> 20) | 0, gr = he >>> 0 > Me >>> 0 ? d + 1 | 0 : d, Ur(Bn, Me, gr, 0, 0, 15632, 16, 0, 0), he = L, Gn = t[n + 256 >> 2], v = t[n + 128 >> 2], dr = Gn + v | 0, ni = t[n + 260 >> 2], d = ni + t[n + 132 >> 2] | 0, d = v >>> 0 > dr >>> 0 ? d + 1 | 0 : d, v = t[n + 352 >> 2], or = v + dr | 0, xr = d, d = d + t[n + 356 >> 2] | 0, d = v >>> 0 > or >>> 0 ? d + 1 | 0 : d, v = t[n + 32 >> 2], tr = v + or | 0, Wr = d, d = d + t[n + 36 >> 2] | 0, v = v >>> 0 > tr >>> 0 ? d + 1 | 0 : d, Xn = (a | 0) == (Be | 0) & cr >>> 0 < gn >>> 0 | a >>> 0 > Be >>> 0, Bn = (a | 0) == (kn | 0) & Ir >>> 0 > gn >>> 0 | a >>> 0 < kn >>> 0, d = Ni + 8 | 0, Un = t[d >> 2], gn = t[d + 4 >> 2], cr = (kn | 0) == (wo | 0) & Ir >>> 0 < Zn >>> 0 | kn >>> 0 < wo >>> 0, L = fo + 8 | 0, a = t[L >> 2], d = pi + 8 | 0, Ir = a + t[d >> 2] | 0, d = t[d + 4 >> 2] + t[L + 4 >> 2] | 0, d = a >>> 0 > Ir >>> 0 ? d + 1 | 0 : d, a = cr + Ir | 0, d = (a >>> 0 < Ir >>> 0 ? d + 1 | 0 : d) + gn | 0, L = a, a = a + Un | 0, d = L >>> 0 > a >>> 0 ? d + 1 | 0 : d, L = a + Bn | 0, d = L >>> 0 < a >>> 0 ? d + 1 | 0 : d, E = E >>> 20 | 0, a = E + L | 0, d = E >>> 0 > a >>> 0 ? d + 1 | 0 : d, E = a, a = a + Xn | 0, d = E >>> 0 > a >>> 0 ? d + 1 | 0 : d, L = a << 12 | Be >>> 20, Be = L + tr | 0, E = d, d = v + (d << 12 | a >>> 20) | 0, t[he + 16 >> 2] = Be, L = L >>> 0 > Be >>> 0 ? d + 1 | 0 : d, t[he + 20 >> 2] = L & 1048575, Ir = n + 16 | 0, cr = (I | 0) == (gr | 0) & Me >>> 0 < $r >>> 0 | I >>> 0 > gr >>> 0, Me = (I | 0) == (xn | 0) & $r >>> 0 < Xs >>> 0 | I >>> 0 < xn >>> 0, a = ro + 8 | 0, I = t[a >> 2], d = to + 8 | 0, gr = I + t[d >> 2] | 0, d = t[d + 4 >> 2] + t[a + 4 >> 2] | 0, d = I >>> 0 > gr >>> 0 ? d + 1 | 0 : d, a = Me + gr | 0, d = a >>> 0 < gr >>> 0 ? d + 1 | 0 : d, T = T >>> 20 | 0, I = a + T | 0, d = T >>> 0 > I >>> 0 ? d + 1 | 0 : d, a = I, I = I + cr | 0, d = a >>> 0 > I >>> 0 ? d + 1 | 0 : d, Ur(Ir, I, d, 0, 0, 64028672, 65536, 0, 0), a = he, $r = (v | 0) == (L | 0) & Be >>> 0 < tr >>> 0 | v >>> 0 > L >>> 0, gr = (v | 0) == (Wr | 0) & tr >>> 0 < or >>> 0 | v >>> 0 < Wr >>> 0, v = $s + 8 | 0, tr = t[v >> 2], cr = t[v + 4 >> 2], Me = (xr | 0) == (Wr | 0) & or >>> 0 < dr >>> 0 | xr >>> 0 > Wr >>> 0, v = Gs + 8 | 0, Be = t[v >> 2], he = t[v + 4 >> 2], T = (xr | 0) == (ni | 0) & dr >>> 0 < Gn >>> 0 | xr >>> 0 < ni >>> 0, d = ps + 8 | 0, I = t[d >> 2], v = zs + 8 | 0, or = I + t[v >> 2] | 0, d = t[v + 4 >> 2] + t[d + 4 >> 2] | 0, d = I >>> 0 > or >>> 0 ? d + 1 | 0 : d, v = T + or | 0, d = (v >>> 0 < or >>> 0 ? d + 1 | 0 : d) + he | 0, I = v, v = v + Be | 0, d = I >>> 0 > v >>> 0 ? d + 1 | 0 : d, I = v, v = v + Me | 0, d = (I >>> 0 > v >>> 0 ? d + 1 | 0 : d) + cr | 0, I = v, v = v + tr | 0, d = I >>> 0 > v >>> 0 ? d + 1 | 0 : d, I = v + gr | 0, d = I >>> 0 < v >>> 0 ? d + 1 | 0 : d, E = E >>> 20 | 0, v = I + E | 0, d = E >>> 0 > v >>> 0 ? d + 1 | 0 : d, I = v, v = v + $r | 0, d = I >>> 0 > v >>> 0 ? d + 1 | 0 : d, E = v << 12 | L >>> 20, I = d, T = d << 12 | v >>> 20, tr = t[n + 20 >> 2], d = tr + (co & 1048575) | 0, cr = t[n + 16 >> 2], v = Ao + cr | 0, L = v >>> 0 < Ao >>> 0 ? d + 1 | 0 : d, d = L + T | 0, he = v, E = v + E | 0, t[a + 24 >> 2] = E, v = v >>> 0 > E >>> 0 ? d + 1 | 0 : d, t[a + 28 >> 2] = v & 1048575, T = a, Me = jn & 65535, Be = (v | 0) == (L | 0) & E >>> 0 < he >>> 0 | v >>> 0 < L >>> 0, a = (L | 0) == (tr | 0) & he >>> 0 < cr >>> 0 | L >>> 0 < tr >>> 0, d = Ir + 8 | 0, E = a + t[d >> 2] | 0, d = t[d + 4 >> 2], d = a >>> 0 > E >>> 0 ? d + 1 | 0 : d, I = I >>> 20 | 0, a = I, I = I + E | 0, d = a >>> 0 > I >>> 0 ? d + 1 | 0 : d, a = I, I = I + Be | 0, d = a >>> 0 > I >>> 0 ? d + 1 | 0 : d, v = I << 12 | v >>> 20, a = v + Mr | 0, d = Me + (d << 12 | I >>> 20) | 0, t[T + 32 >> 2] = a, t[T + 36 >> 2] = v >>> 0 > a >>> 0 ? d + 1 | 0 : d, x = n + 496 | 0;
  }
  function In(v, d) {
    var I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0;
    n = d - -64 | 0, tr = t[n >> 2], he = t[n + 4 >> 2], n = d + 56 | 0, T = t[n >> 2], xr = t[n + 4 >> 2], n = d + 48 | 0, Mr = t[n >> 2], or = t[n + 4 >> 2], n = d + 72 | 0, dr = t[n >> 2], E = t[n + 4 >> 2], $r = t[d + 40 >> 2], Bn = t[d + 44 >> 2], Wr = t[d + 24 >> 2], cr = t[d + 28 >> 2], L = t[d + 16 >> 2], Ir = t[d + 20 >> 2], I = t[d + 8 >> 2], Be = t[d + 12 >> 2], Me = t[d + 4 >> 2], gn = t[d + 32 >> 2], a = t[d + 36 >> 2], xn = a, d = t[d >> 2], n = pn(a >>> 16 | 0, 0, 977, 1), a = d + n | 0, d = Me + Ee | 0, Me = n >>> 0 > a >>> 0 ? d + 1 | 0 : d, d = Be, n = Me >>> 20 | 0, Be = n, n = I + n | 0, Be = Be >>> 0 > n >>> 0 ? d + 1 | 0 : d, d = Ir, I = Be >>> 20 | 0, gr = I, I = I + L | 0, Ir = gr >>> 0 > I >>> 0 ? d + 1 | 0 : d, d = cr, L = Ir >>> 20 | 0, cr = L, L = L + Wr | 0, Wr = cr >>> 0 > L >>> 0 ? d + 1 | 0 : d, Un = Be & 1048575, d = Me & 1048575, gr = d, cr = n, Me = I, kn = Ir & 1048575, I = (n & I & L) == -1 & (kn & Be & Wr) == 1048575, d = xn & 65535, n = Wr >>> 20 | 0, Be = n, n = n + gn | 0, d = Be >>> 0 > n >>> 0 ? d + 1 | 0 : d, gn = n, Be = d, n = pn(I & ((n | 0) == -1 & (d | 0) == 65535) & ((gr | 0) == 1048574 & a >>> 0 > 4294966318 | gr >>> 0 > 1048574) | d >>> 16, 0, 977, 1), a = n + a | 0, d = gr + Ee | 0, I = n >>> 0 > a >>> 0 ? d + 1 | 0 : d, d = Un, n = I >>> 20 | 0, Ir = n + cr | 0, n = n >>> 0 > Ir >>> 0 ? d + 1 | 0 : d, u[v | 0] = a, u[v + 1 | 0] = a >>> 8, u[v + 2 | 0] = a >>> 16, u[v + 3 | 0] = a >>> 24, d = I & 1048575 | Ir << 20, u[v + 4 | 0] = d, u[v + 5 | 0] = d >>> 8, u[v + 6 | 0] = d >>> 16, u[v + 7 | 0] = d >>> 24, cr = dr, gr = E & 65535, dr = tr, tr = T, I = pn(E >>> 16 | 0, 0, 977, 1), a = I + $r | 0, d = Bn + Ee | 0, $r = I >>> 0 > a >>> 0 ? d + 1 | 0 : d, d = or, I = $r >>> 20 | 0, E = I, I = I + Mr | 0, T = E >>> 0 > I >>> 0 ? d + 1 | 0 : d, d = xr, E = T >>> 20 | 0, tr = E + tr | 0, or = E >>> 0 > tr >>> 0 ? d + 1 | 0 : d, d = he, E = or >>> 20 | 0, he = E, E = E + dr | 0, xr = he >>> 0 > E >>> 0 ? d + 1 | 0 : d, d = gr, he = xr >>> 20 | 0, dr = he, he = he + cr | 0, d = dr >>> 0 > he >>> 0 ? d + 1 | 0 : d, Mr = he, he = d, Bn = T & 1048575, d = $r & 1048575, gr = a, dr = I, cr = or & 1048575, a = pn((tr & I & E) == -1 & (cr & T & xr) == 1048575 & ((Mr | 0) == -1 & (he | 0) == 65535) & ((d | 0) == 1048574 & a >>> 0 > 4294966318 | d >>> 0 > 1048574) | he >>> 16, 0, 977, 1), I = gr + a | 0, d = d + Ee | 0, T = I >>> 0 < a >>> 0 ? d + 1 | 0 : d, d = Bn, a = T >>> 20 | 0, or = a + dr | 0, a = a >>> 0 > or >>> 0 ? d + 1 | 0 : d, u[v + 32 | 0] = I, u[v + 33 | 0] = I >>> 8, u[v + 34 | 0] = I >>> 16, u[v + 35 | 0] = I >>> 24, d = T & 1048575 | or << 20, u[v + 36 | 0] = d, u[v + 37 | 0] = d >>> 8, u[v + 38 | 0] = d >>> 16, u[v + 39 | 0] = d >>> 24, T = (n & 4095) << 20 | Ir >>> 12, dr = n >>> 12 & 255, d = kn, I = (n >>> 20 | 0) + Me | 0, n = I >>> 0 < Me >>> 0 ? d + 1 | 0 : d, Me = I, d = I << 8, I = v, u[I + 8 | 0] = T, u[I + 9 | 0] = T >>> 8, u[I + 10 | 0] = T >>> 16, u[I + 11 | 0] = T >>> 24, d = d | dr, u[I + 12 | 0] = d, u[I + 13 | 0] = d >>> 8, u[I + 14 | 0] = d >>> 16, u[I + 15 | 0] = d >>> 24, T = (a & 4095) << 20 | or >>> 12, or = a >>> 12 & 255, d = cr, I = (a >>> 20 | 0) + tr | 0, a = I >>> 0 < tr >>> 0 ? d + 1 | 0 : d, tr = I, d = I << 8, I = v, u[I + 40 | 0] = T, u[I + 41 | 0] = T >>> 8, u[I + 42 | 0] = T >>> 16, u[I + 43 | 0] = T >>> 24, d = d | or, u[I + 44 | 0] = d, u[I + 45 | 0] = d >>> 8, u[I + 46 | 0] = d >>> 16, u[I + 47 | 0] = d >>> 24, Me = ((n & 16777215) << 8 | Me >>> 24) & 268435455, d = Wr & 1048575, n = n >>> 20 | 0, I = n + L | 0, n = n >>> 0 > I >>> 0 ? d + 1 | 0 : d, d = n << 28 | I >>> 4, L = I << 28, I = v, L = L | Me, u[I + 16 | 0] = L, u[I + 17 | 0] = L >>> 8, u[I + 18 | 0] = L >>> 16, u[I + 19 | 0] = L >>> 24, u[I + 20 | 0] = d, u[I + 21 | 0] = d >>> 8, u[I + 22 | 0] = d >>> 16, u[I + 23 | 0] = d >>> 24, L = ((a & 16777215) << 8 | tr >>> 24) & 268435455, d = xr & 1048575, a = a >>> 20 | 0, I = a + E | 0, a = a >>> 0 > I >>> 0 ? d + 1 | 0 : d, d = a << 28 | I >>> 4, E = I << 28, I = v, E = E | L, u[I + 48 | 0] = E, u[I + 49 | 0] = E >>> 8, u[I + 50 | 0] = E >>> 16, u[I + 51 | 0] = E >>> 24, u[I + 52 | 0] = d, u[I + 53 | 0] = d >>> 8, u[I + 54 | 0] = d >>> 16, u[I + 55 | 0] = d >>> 24, I = n >>> 4 & 65535, d = Be, n = (n >>> 20 | 0) + gn | 0, d = (n >>> 0 < gn >>> 0 ? d + 1 | 0 : d) << 16 | n >>> 16, E = n << 16, n = v, I = I | E, u[n + 24 | 0] = I, u[n + 25 | 0] = I >>> 8, u[n + 26 | 0] = I >>> 16, u[n + 27 | 0] = I >>> 24, u[n + 28 | 0] = d, u[n + 29 | 0] = d >>> 8, u[n + 30 | 0] = d >>> 16, u[n + 31 | 0] = d >>> 24, I = a >>> 4 & 65535, d = he, n = (a >>> 20 | 0) + Mr | 0, d = (n >>> 0 < Mr >>> 0 ? d + 1 | 0 : d) << 16 | n >>> 16, n = n << 16 | I, u[v + 56 | 0] = n, u[v + 57 | 0] = n >>> 8, u[v + 58 | 0] = n >>> 16, u[v + 59 | 0] = n >>> 24, u[v + 60 | 0] = d, u[v + 61 | 0] = d >>> 8, u[v + 62 | 0] = d >>> 16, u[v + 63 | 0] = d >>> 24;
  }
  function zr(v, d, I, n) {
    var a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0, Xn = 0, Zn = 0, ni = 0;
    he = x - 96 | 0, x = he;
    e: {
      if (!d) {
        Qn[t[v + 168 >> 2]](689730, t[v + 172 >> 2]);
        break e;
      }
      if (E = t[d >> 2], Gn = n & 256, E >>> 0 < (Gn ? 33 : 65) >>> 0) {
        Qn[t[v + 168 >> 2]](690157, t[v + 172 >> 2]);
        break e;
      }
      if (t[d >> 2] = 0, Bn = Vi(690820, E), !I) {
        Qn[t[v + 168 >> 2]](689638, t[v + 172 >> 2]);
        break e;
      }
      if ((n & 255) != 2) {
        Qn[t[v + 168 >> 2]](689499, t[v + 172 >> 2]);
        break e;
      }
      if (t[he + 88 >> 2] = 0, n = l[I + 12 | 0] | l[I + 13 | 0] << 8 | (l[I + 14 | 0] << 16 | l[I + 15 | 0] << 24), T = n, E = l[I + 8 | 0] | l[I + 9 | 0] << 8 | (l[I + 10 | 0] << 16 | l[I + 11 | 0] << 24), L = (n << 12 | E >>> 20) & 1048575, Be = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), a = Be, E = E << 12 & -4096 | a >>> 20, $r = L, L = l[I + 16 | 0] | l[I + 17 | 0] << 8 | (l[I + 18 | 0] << 16 | l[I + 19 | 0] << 24), tr = L, n = l[I + 20 | 0] | l[I + 21 | 0] << 8 | (l[I + 22 | 0] << 16 | l[I + 23 | 0] << 24), Be = n, or = (n << 24 | L >>> 8) & 1048575, Ir = L << 24 & -16777216 | T >>> 8, kn = or, Me = or, L = l[I + 28 | 0] | l[I + 29 | 0] << 8 | (l[I + 30 | 0] << 16 | l[I + 31 | 0] << 24), n = L >>> 16 | 0, T = l[I + 24 | 0] | l[I + 25 | 0] << 8 | (l[I + 26 | 0] << 16 | l[I + 27 | 0] << 24), L = (L & 65535) << 16 | T >>> 16, xr = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), gr = Ir | (L | (xr | E)), xn = n, Mr = a & 1048575, a = Me | (n | (Mr | $r)), Me = T << 4 & 1048560, T = Be, n = T >>> 28 | 0, or = (T & 268435455) << 4 | tr >>> 28, Be = gr | or, gr = n | Me, !(Be | (a | gr))) {
        Qn[t[v + 168 >> 2]](690116, t[v + 172 >> 2]);
        break e;
      }
      T = l[I + 52 | 0] | l[I + 53 | 0] << 8 | (l[I + 54 | 0] << 16 | l[I + 55 | 0] << 24), n = T >>> 28 | 0, v = l[I + 48 | 0] | l[I + 49 | 0] << 8 | (l[I + 50 | 0] << 16 | l[I + 51 | 0] << 24), Be = (T & 268435455) << 4 | v >>> 28, tr = n, n = l[I + 56 | 0] | l[I + 57 | 0] << 8 | (l[I + 58 | 0] << 16 | l[I + 59 | 0] << 24), jn = n, cr = l[I + 60 | 0] | l[I + 61 | 0] << 8 | (l[I + 62 | 0] << 16 | l[I + 63 | 0] << 24), Xn = n << 4 & 1048560, a = l[I + 40 | 0] | l[I + 41 | 0] << 8 | (l[I + 42 | 0] << 16 | l[I + 43 | 0] << 24), Me = l[I + 44 | 0] | l[I + 45 | 0] << 8 | (l[I + 46 | 0] << 16 | l[I + 47 | 0] << 24), Wr = Me >>> 8 | 0, n = T << 24 | v >>> 8, Zn = v << 24 & -16777216, ni = n & 1048575, T = l[I + 32 | 0] | l[I + 33 | 0] << 8 | (l[I + 34 | 0] << 16 | l[I + 35 | 0] << 24), v = l[I + 36 | 0] | l[I + 37 | 0] << 8 | (l[I + 38 | 0] << 16 | l[I + 39 | 0] << 24), dr = v, I = v >>> 20 | 0, v = a, n = Me << 12 | v >>> 20, Me = v << 12 & -4096, Un = n & 1048575, gn = dr & 1048575;
      t: {
        if ((Mr | 0) == 1048574 & xr >>> 0 < 4294966319 | Mr >>> 0 < 1048574 || (E & Ir & or) != -1 | ($r & kn & gr) != 1048575 || (L | 0) != -1 | (xn | 0) != 65535)
          break t;
        v = Mr + 1 | 0, xr = xr + 977 | 0, v = xr >>> 0 < 977 ? v + 1 | 0 : v, Mr = v & 1048575, a = v >>> 20 | 0, v = $r, E = a + E | 0, v = E >>> 0 < a >>> 0 ? v + 1 | 0 : v, $r = v & 1048575, n = kn, v = v >>> 20 | 0, Ir = v + Ir | 0, n = v >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, kn = n & 1048575, a = n >>> 20 | 0, v = gr, or = a + or | 0, v = or >>> 0 < a >>> 0 ? v + 1 | 0 : v, gr = v & 1048575, a = v >>> 20 | 0, v = xn, n = L, L = a + L | 0, xn = (n >>> 0 > L >>> 0 ? v + 1 | 0 : v) & 65535;
      }
      a = Be, dr = tr | Xn, tr = Wr | Zn, Wr = ni, Me = I | Me, v = cr, n = v >>> 16 | 0, Be = (v & 65535) << 16 | jn >>> 16, cr = n, I = he, t[I + 40 >> 2] = L, t[I + 44 >> 2] = xn, t[I + 32 >> 2] = or, t[I + 36 >> 2] = gr, t[I + 24 >> 2] = Ir, t[I + 28 >> 2] = kn, t[I + 16 >> 2] = E, t[I + 20 >> 2] = $r, t[I + 8 >> 2] = xr, t[I + 12 >> 2] = Mr;
      t: {
        if ((gn | 0) == 1048574 & T >>> 0 < 4294966319 | gn >>> 0 < 1048574 || (Me & tr & a) != -1 | (Un & Wr & dr) != 1048575 || (Be | 0) != -1 | (cr | 0) != 65535)
          break t;
        n = gn + 1 | 0, T = T + 977 | 0, n = T >>> 0 < 977 ? n + 1 | 0 : n, gn = n & 1048575, v = Un, n = n >>> 20 | 0, Me = n + Me | 0, v = n >>> 0 > Me >>> 0 ? v + 1 | 0 : v, Un = v & 1048575, E = v >>> 20 | 0, n = Wr, tr = E + tr | 0, n = tr >>> 0 < E >>> 0 ? n + 1 | 0 : n, Wr = n & 1048575, E = n >>> 20 | 0, n = dr, a = a + E | 0, n = a >>> 0 < E >>> 0 ? n + 1 | 0 : n, dr = n & 1048575, v = cr, cr = Be, Be = (n >>> 20 | 0) + Be | 0, cr = (cr >>> 0 > Be >>> 0 ? v + 1 | 0 : v) & 65535;
      }
      t[I + 80 >> 2] = Be, t[he + 84 >> 2] = cr, t[he + 72 >> 2] = a, t[he + 76 >> 2] = dr, t[he + 64 >> 2] = tr, t[he + 68 >> 2] = Wr, t[he + 56 >> 2] = Me, t[he + 60 >> 2] = Un, t[he + 48 >> 2] = T, t[he + 52 >> 2] = gn, En(Bn + 1 | 0, he + 8 | 0);
      t: {
        if (Gn) {
          u[Bn | 0] = T & 1 ? 3 : 2, v = 33;
          break t;
        }
        u[Bn | 0] = 4, En(Bn + 33 | 0, he + 48 | 0), v = 65;
      }
      t[d >> 2] = v, dr = 1;
    }
    return x = he + 96 | 0, dr;
  }
  function En(v, d) {
    u[v | 0] = t[d + 36 >> 2] >>> 8, u[v + 1 | 0] = t[d + 36 >> 2], u[v + 2 | 0] = (t[d + 36 >> 2] & 16777215) << 8 | t[d + 32 >> 2] >>> 24, u[v + 3 | 0] = (t[d + 36 >> 2] & 65535) << 16 | t[d + 32 >> 2] >>> 16, u[v + 4 | 0] = (t[d + 36 >> 2] & 255) << 24 | t[d + 32 >> 2] >>> 8, u[v + 5 | 0] = t[d + 32 >> 2], u[v + 6 | 0] = t[d + 28 >> 2] >>> 12, u[v + 7 | 0] = t[d + 28 >> 2] >>> 4, u[v + 8 | 0] = (t[d + 28 >> 2] & 268435455) << 4 | t[d + 24 >> 2] >>> 28, u[v + 9 | 0] = (t[d + 28 >> 2] & 1048575) << 12 | t[d + 24 >> 2] >>> 20, u[v + 10 | 0] = (t[d + 28 >> 2] & 4095) << 20 | t[d + 24 >> 2] >>> 12, u[v + 11 | 0] = (t[d + 28 >> 2] & 15) << 28 | t[d + 24 >> 2] >>> 4, u[v + 12 | 0] = m[d + 22 >> 1] & 15 | t[d + 24 >> 2] << 4, u[v + 13 | 0] = t[d + 20 >> 2] >>> 8, u[v + 14 | 0] = t[d + 20 >> 2], u[v + 15 | 0] = (t[d + 20 >> 2] & 16777215) << 8 | t[d + 16 >> 2] >>> 24, u[v + 16 | 0] = (t[d + 20 >> 2] & 65535) << 16 | t[d + 16 >> 2] >>> 16, u[v + 17 | 0] = (t[d + 20 >> 2] & 255) << 24 | t[d + 16 >> 2] >>> 8, u[v + 18 | 0] = t[d + 16 >> 2], u[v + 19 | 0] = t[d + 12 >> 2] >>> 12, u[v + 20 | 0] = t[d + 12 >> 2] >>> 4, u[v + 21 | 0] = (t[d + 12 >> 2] & 268435455) << 4 | t[d + 8 >> 2] >>> 28, u[v + 22 | 0] = (t[d + 12 >> 2] & 1048575) << 12 | t[d + 8 >> 2] >>> 20, u[v + 23 | 0] = (t[d + 12 >> 2] & 4095) << 20 | t[d + 8 >> 2] >>> 12, u[v + 24 | 0] = (t[d + 12 >> 2] & 15) << 28 | t[d + 8 >> 2] >>> 4, u[v + 25 | 0] = m[d + 6 >> 1] & 15 | t[d + 8 >> 2] << 4, u[v + 26 | 0] = t[d + 4 >> 2] >>> 8, u[v + 27 | 0] = t[d + 4 >> 2], u[v + 28 | 0] = (t[d + 4 >> 2] & 16777215) << 8 | t[d >> 2] >>> 24, u[v + 29 | 0] = (t[d + 4 >> 2] & 65535) << 16 | t[d >> 2] >>> 16, u[v + 30 | 0] = (t[d + 4 >> 2] & 255) << 24 | t[d >> 2] >>> 8, u[v + 31 | 0] = t[d >> 2];
  }
  function Zr(v, d, I) {
    var n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0;
    T = v, n = d, d = l[n + 24 | 0] | l[n + 25 | 0] << 8 | (l[n + 26 | 0] << 16 | l[n + 27 | 0] << 24), E = d << 8 & 16711680, or = d << 24 | E, a = d >>> 8 | 0, v = l[n + 28 | 0] | l[n + 29 | 0] << 8 | (l[n + 30 | 0] << 16 | l[n + 31 | 0] << 24), E = (a | v << 24) & 65280, d = d >>> 24 | 0, E = or | (E | (d | v << 8) & 255), a = (d | (v & 16777215) << 8) & 16711680 | (a | (v & 255) << 24) & -16777216, he = v >>> 8 & 65280 | v >>> 24 | a, t[T >> 2] = he, t[T + 4 >> 2] = E, d = l[n + 16 | 0] | l[n + 17 | 0] << 8 | (l[n + 18 | 0] << 16 | l[n + 19 | 0] << 24), L = d << 8 & 16711680 | d << 24, v = l[n + 20 | 0] | l[n + 21 | 0] << 8 | (l[n + 22 | 0] << 16 | l[n + 23 | 0] << 24), a = (v << 24 | d >>> 8) & 65280, or = L | (a | (v << 8 | d >>> 24) & 255), a = ((v & 255) << 24 | d >>> 8) & -16777216, L = a | ((v & 16777215) << 8 | d >>> 24) & 16711680, gr = v >>> 8 & 65280 | v >>> 24 | L, t[T + 8 >> 2] = gr, Be = or, t[T + 12 >> 2] = Be, d = l[n + 8 | 0] | l[n + 9 | 0] << 8 | (l[n + 10 | 0] << 16 | l[n + 11 | 0] << 24), L = d << 8 & 16711680, cr = d << 24 | L, v = l[n + 12 | 0] | l[n + 13 | 0] << 8 | (l[n + 14 | 0] << 16 | l[n + 15 | 0] << 24), L = (v << 24 | d >>> 8) & 65280, L = cr | (L | (v << 8 | d >>> 24) & 255), a = ((v & 255) << 24 | d >>> 8) & -16777216, a = a | ((v & 16777215) << 8 | d >>> 24) & 16711680, dr = v >>> 8 & 65280 | v >>> 24 | a, t[T + 16 >> 2] = dr, cr = L, t[T + 20 >> 2] = L, v = l[n + 4 | 0] | l[n + 5 | 0] << 8 | (l[n + 6 | 0] << 16 | l[n + 7 | 0] << 24), d = l[n | 0] | l[n + 1 | 0] << 8 | (l[n + 2 | 0] << 16 | l[n + 3 | 0] << 24), L = d << 8 & 16711680 | d << 24, or = L | ((v << 8 | d >>> 24) & 255 | (v << 24 | d >>> 8) & 65280), n = ((v & 255) << 24 | d >>> 8) & -16777216, Me = n | ((v & 16777215) << 8 | d >>> 24) & 16711680, L = v >>> 8 & 65280, d = v >>> 24 | 0, v = or, n = (cr | 0) == -1, L = d | L | Me, d = n & dr >>> 0 < 4294967294 | (cr | 0) != -1 | (v & L) != -1, a = (Be | 0) == -1162945306, v = (d | (a & gr >>> 0 < 2940772411 | Be >>> 0 < 3132021990)) ^ -1, Me = v & ((E | 0) == -1076732276 & he >>> 0 > 3493216576 | E >>> 0 > 3218235020) | (v & (a & gr >>> 0 > 2940772411 | Be >>> 0 > 3132021990) | (dr | 0) == -1 & n & (d ^ -1)), tr = pn(Me, 0, 801750719, 1076732275), a = Ee, n = a + E | 0, v = he + tr | 0, n = v >>> 0 < tr >>> 0 ? n + 1 | 0 : n, t[T >> 2] = v, t[T + 4 >> 2] = n, d = T, n = (n | 0) == (a | 0) & v >>> 0 < tr >>> 0 | n >>> 0 < a >>> 0, tr = pn(Me, 0, 1354194884, 1162945305), E = Ee, he = E + Be | 0, T = tr + gr | 0, v = T >>> 0 < tr >>> 0 ? he + 1 | 0 : he, n = n + T | 0, a = n >>> 0 < T >>> 0 ? v + 1 | 0 : v, t[d + 8 >> 2] = n, t[d + 12 >> 2] = a, Be = (v | 0) == (E | 0) & T >>> 0 < tr >>> 0 | v >>> 0 < E >>> 0, v = (v | 0) == (a | 0) & n >>> 0 < T >>> 0 | v >>> 0 > a >>> 0, E = Be + v | 0, a = cr, n = v >>> 0 > E >>> 0, T = Me + dr | 0, v = T >>> 0 < dr >>> 0 ? a + 1 | 0 : a, he = n + v | 0, a = T, E = a + E | 0, he = a >>> 0 > E >>> 0 ? he + 1 | 0 : he, t[d + 16 >> 2] = E, t[d + 20 >> 2] = he, n = d, T = L, d = !v & a >>> 0 < Me >>> 0, v = (v | 0) == (he | 0) & a >>> 0 > E >>> 0 | v >>> 0 > he >>> 0, E = d + v | 0, d = (v >>> 0 > E >>> 0) + or | 0, v = E + T | 0, d = v >>> 0 < E >>> 0 ? d + 1 | 0 : d, t[n + 24 >> 2] = v, t[n + 28 >> 2] = d, I && (t[I >> 2] = Me);
  }
  function kr(v, d) {
    u[v | 0] = l[d + 31 | 0], u[v + 1 | 0] = m[d + 30 >> 1], u[v + 2 | 0] = t[d + 28 >> 2] >>> 8, u[v + 3 | 0] = t[d + 28 >> 2], u[v + 4 | 0] = (t[d + 28 >> 2] & 16777215) << 8 | t[d + 24 >> 2] >>> 24, u[v + 5 | 0] = (t[d + 28 >> 2] & 65535) << 16 | t[d + 24 >> 2] >>> 16, u[v + 6 | 0] = (t[d + 28 >> 2] & 255) << 24 | t[d + 24 >> 2] >>> 8, u[v + 7 | 0] = t[d + 24 >> 2], u[v + 8 | 0] = l[d + 23 | 0], u[v + 9 | 0] = m[d + 22 >> 1], u[v + 10 | 0] = t[d + 20 >> 2] >>> 8, u[v + 11 | 0] = t[d + 20 >> 2], u[v + 12 | 0] = (t[d + 20 >> 2] & 16777215) << 8 | t[d + 16 >> 2] >>> 24, u[v + 13 | 0] = (t[d + 20 >> 2] & 65535) << 16 | t[d + 16 >> 2] >>> 16, u[v + 14 | 0] = (t[d + 20 >> 2] & 255) << 24 | t[d + 16 >> 2] >>> 8, u[v + 15 | 0] = t[d + 16 >> 2], u[v + 16 | 0] = l[d + 15 | 0], u[v + 17 | 0] = m[d + 14 >> 1], u[v + 18 | 0] = t[d + 12 >> 2] >>> 8, u[v + 19 | 0] = t[d + 12 >> 2], u[v + 20 | 0] = (t[d + 12 >> 2] & 16777215) << 8 | t[d + 8 >> 2] >>> 24, u[v + 21 | 0] = (t[d + 12 >> 2] & 65535) << 16 | t[d + 8 >> 2] >>> 16, u[v + 22 | 0] = (t[d + 12 >> 2] & 255) << 24 | t[d + 8 >> 2] >>> 8, u[v + 23 | 0] = t[d + 8 >> 2], u[v + 24 | 0] = l[d + 7 | 0], u[v + 25 | 0] = m[d + 6 >> 1], u[v + 26 | 0] = t[d + 4 >> 2] >>> 8, u[v + 27 | 0] = t[d + 4 >> 2], u[v + 28 | 0] = (t[d + 4 >> 2] & 16777215) << 8 | t[d >> 2] >>> 24, u[v + 29 | 0] = (t[d + 4 >> 2] & 65535) << 16 | t[d >> 2] >>> 16, u[v + 30 | 0] = (t[d + 4 >> 2] & 255) << 24 | t[d >> 2] >>> 8, u[v + 31 | 0] = t[d >> 2];
  }
  function Rr(v, d) {
    var I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0, Xn = 0, Zn = 0, ni = 0, ai = 0, fi = 0, Ai = 0, yi = 0, Ii = 0, wi = 0, Bi = 0, Ti = 0, Oi = 0, Hi = 0, Xi = 0, Zi = 0, ts = 0, us = 0;
    for (T = x - 320 | 0, x = T, I = T + 280 | 0, n = I + 32 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = I + 24 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = I + 16 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, I = I + 8 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, t[T + 280 >> 2] = 0, t[T + 284 >> 2] = 0, I = T + 240 | 0, n = I + 32 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = I + 24 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, I = I + 16 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, t[T + 248 >> 2] = 0, t[T + 252 >> 2] = 0, t[T + 240 >> 2] = 1, t[T + 244 >> 2] = 0, n = d + 32 | 0, a = t[n + 4 >> 2], I = T + 200 | 0, E = I + 32 | 0, t[E >> 2] = t[n >> 2], t[E + 4 >> 2] = a, n = d + 24 | 0, a = t[n + 4 >> 2], E = I + 24 | 0, t[E >> 2] = t[n >> 2], t[E + 4 >> 2] = a, n = d + 16 | 0, a = t[n + 4 >> 2], E = I + 16 | 0, t[E >> 2] = t[n >> 2], t[E + 4 >> 2] = a, n = d + 8 | 0, a = t[n + 4 >> 2], I = I + 8 | 0, t[I >> 2] = t[n >> 2], t[I + 4 >> 2] = a, I = t[d + 4 >> 2], t[T + 200 >> 2] = t[d >> 2], t[T + 204 >> 2] = I, n = v + 32 | 0, a = t[n + 4 >> 2], I = T + 160 | 0, ni = I + 32 | 0, t[ni >> 2] = t[n >> 2], t[ni + 4 >> 2] = a, n = v + 24 | 0, a = t[n + 4 >> 2], E = I + 24 | 0, t[E >> 2] = t[n >> 2], t[E + 4 >> 2] = a, n = v + 16 | 0, a = t[n + 4 >> 2], E = I + 16 | 0, t[E >> 2] = t[n >> 2], t[E + 4 >> 2] = a, n = v + 8 | 0, a = t[n + 4 >> 2], I = I + 8 | 0, t[I >> 2] = t[n >> 2], t[I + 4 >> 2] = a, I = t[v + 4 >> 2], t[T + 160 >> 2] = t[v >> 2], t[T + 164 >> 2] = I, xn = 5, Bn = -1, Un = -1; ; ) {
      I = Bn, $r = t[T + 160 >> 2], Ir = t[T + 164 >> 2], n = Es($r, Ir | -1073741824), Bn = I - n | 0, Un = Un - (Ee + (I >>> 0 < n >>> 0) | 0) | 0, I = n & 31, (n & 63) >>> 0 >= 32 ? (he = 0, dr = 1 << I) : (he = 1 << I, dr = he - 1 & 1 >>> 32 - I), Xn = t[T + 200 >> 2], Gn = t[T + 204 >> 2], E = n;
      e: {
        if ((n | 0) == 62) {
          L = 0, E = 0, cr = 1, tr = 0, gn = 0, Mr = 0;
          break e;
        }
        for (n = E & 31, (E & 63) >>> 0 >= 32 ? (a = Ir >>> n | 0, n = 0) : (a = ((1 << n) - 1 & Ir) << 32 - n | $r >>> n, n = Ir >>> n | 0), or = 62 - E | 0, cr = 1, tr = 0, gn = 0, Mr = 0, Me = Xn, Be = Gn, L = 0, E = 0; ; ) {
          t: {
            if ((Un | 0) < 0) {
              I = pn(a, n, a, n), xr = I - 2 | 0, kn = Ee - (I >>> 0 < 2) | 0, Wr = 0 - Me | 0, I = 0 - (((Me | 0) != 0) + Be | 0) | 0, Me = pn(xr, kn, pn(Wr, I, a, n), Ee), Un = 0 - (((Bn | 0) != 0) + Un | 0) | 0, Bn = 0 - Bn | 0, Be = Bn + 1 | 0, gr = 64 - ((Be | 0) > (or | 0) ? or : Be) | 0, Be = gr & 31, (gr & 63) >>> 0 >= 32 ? Be = -1 >>> Be | 0 : Be = (1 << Be) - 1 << 32 - Be | -1 >>> Be, ai = Be & Me & 63, gr = 0 - gn | 0, xr = 0 - (((gn | 0) != 0) + Mr | 0) | 0, kn = 0 - he | 0, Ai = 0 - (((he | 0) != 0) + dr | 0) | 0, Me = a, Be = n;
              break t;
            }
            gr = (Me << 1) + 2 | 0, I = Be, xr = gr & 8, gr = xr + Me | 0, gr = 0 - pn(gr, gr >>> 0 < xr >>> 0 ? I + 1 | 0 : I, a, n) | 0, I = Bn + 1 | 0, xr = 64 - ((I | 0) > (or | 0) ? or : I) | 0, I = xr & 31, (xr & 63) >>> 0 >= 32 ? I = -1 >>> I | 0 : I = (1 << I) - 1 << 32 - I | -1 >>> I, ai = I & gr & 15, kn = L, Ai = E, gr = cr, xr = tr, Wr = a, I = n, L = he, E = dr, cr = gn, tr = Mr;
          }
          if (he = Bn, n = pn(Me, Be, ai, 0) + Wr | 0, I = Ee + I | 0, a = n >>> 0 < Wr >>> 0 ? I + 1 | 0 : I, I = or & 31, (or & 63) >>> 0 >= 32 ? (dr = 0, I = -1 << I) : (dr = -1 << I, I = dr | (1 << I) - 1 & -1 >>> 32 - I), Wr = Es(n | dr, I | a), Bn = he - Wr | 0, Un = Un - (Ee + (he >>> 0 < Wr >>> 0) | 0) | 0, he = Wr & 31, (Wr & 63) >>> 0 >= 32 ? (gn = 0, Mr = cr << he) : (gn = cr << he, Mr = (1 << he) - 1 & cr >>> 32 - he | tr << he), he = Wr & 31, (Wr & 63) >>> 0 >= 32 ? (I = L << he, he = 0) : (I = (1 << he) - 1 & L >>> 32 - he | E << he, he = L << he), dr = I, Zn = Wr & 31, (Wr & 63) >>> 0 >= 32 ? (I = 0, a = a >>> Zn | 0) : (I = a >>> Zn | 0, a = ((1 << Zn) - 1 & a) << 32 - Zn | n >>> Zn), n = I, cr = pn(cr, tr, ai, 0) + gr | 0, I = Ee + xr | 0, tr = cr >>> 0 < gr >>> 0 ? I + 1 | 0 : I, L = pn(L, E, ai, 0) + kn | 0, I = Ee + Ai | 0, E = L >>> 0 < kn >>> 0 ? I + 1 | 0 : I, or = or - Wr | 0, !or)
            break;
        }
      }
      if (t[T + 152 >> 2] = cr, t[T + 156 >> 2] = tr, t[T + 144 >> 2] = L, t[T + 148 >> 2] = E, t[T + 136 >> 2] = gn, t[T + 140 >> 2] = Mr, t[T + 128 >> 2] = he, t[T + 132 >> 2] = dr, Gi(T + 280 | 0, T + 240 | 0, T + 128 | 0, d), kn = dr, I = dr >> 31, dr = I, Me = I, I = Gn >> 31, Be = T + 112 | 0, Wr = he, n = I, Ur(Be, he, kn, Me, Me, Xn, Gn, I, I), Ai = gn, I = Mr >> 31, gn = I, he = I, I = Ir >> 31, Me = T + 80 | 0, Zn = Mr, a = I, Ur(Me, Ai, Mr, he, he, $r, Ir, I, I), I = E >> 31, he = T + 96 | 0, ai = L, Zi = E, wi = I, Ur(he, L, E, I, I, Xn, Gn, n, n), I = tr >> 31, or = T - -64 | 0, Xn = cr, Gn = tr, Bi = I, Ur(or, cr, tr, I, I, $r, Ir, a, a), L = t[T + 80 >> 2], a = t[T + 112 >> 2], n = L + a | 0, E = t[T + 84 >> 2], I = E + t[T + 116 >> 2] | 0, I = n >>> 0 < a >>> 0 ? I + 1 | 0 : I, a = n, n = I, E = (E | 0) == (I | 0) & a >>> 0 < L >>> 0 | I >>> 0 < E >>> 0, I = Be + 8 | 0, L = t[I >> 2], Be = Me + 8 | 0, a = L + t[Be >> 2] | 0, I = t[Be + 4 >> 2] + t[I + 4 >> 2] | 0, I = a >>> 0 < L >>> 0 ? I + 1 | 0 : I, L = a, a = a + E | 0, E = L >>> 0 > a >>> 0 ? I + 1 | 0 : I, L = E << 2 | a >>> 30, a = a << 2 | n >>> 30, n = L, tr = t[T + 64 >> 2], Be = t[T + 96 >> 2], L = tr + Be | 0, Me = t[T + 68 >> 2], I = Me + t[T + 100 >> 2] | 0, I = L >>> 0 < Be >>> 0 ? I + 1 | 0 : I, Be = L, L = I, Me = (Me | 0) == (I | 0) & Be >>> 0 < tr >>> 0 | I >>> 0 < Me >>> 0, I = he + 8 | 0, tr = t[I >> 2], he = or + 8 | 0, Be = tr + t[he >> 2] | 0, I = t[he + 4 >> 2] + t[I + 4 >> 2] | 0, I = Be >>> 0 < tr >>> 0 ? I + 1 | 0 : I, he = Be, Be = Me + Be | 0, tr = he >>> 0 > Be >>> 0 ? I + 1 | 0 : I, he = tr << 2 | Be >>> 30, Me = Be << 2 | L >>> 30, Be = he, Ti = (xn | 0) < 2, !Ti)
        for (I = E >> 31, E = E >> 30, he = I, gr = tr >> 30, xr = tr >> 31, jn = xn - 1 | 0, or = T + 160 | 0, tr = T + 200 | 0; cr = tr + 8 | 0, Ir = t[cr >> 2], I = t[cr + 4 >> 2], $r = I, I = I >> 31, L = I, Ur(T, Ir, $r, I, I, Wr, kn, dr, dr), Oi = T + 32 | 0, Mr = or + 8 | 0, yi = t[Mr >> 2], I = t[Mr + 4 >> 2], fi = I, I = I >> 31, Ur(Oi, yi, fi, I, I, Ai, Zn, gn, gn), Hi = T + 16 | 0, Ur(Hi, Ir, $r, L, L, ai, Zi, wi, wi), Xi = T + 48 | 0, Ur(Xi, yi, fi, I, I, Xn, Gn, Bi, Bi), L = t[T >> 2], ts = L, fi = t[T + 4 >> 2], I = fi + n | 0, Ir = a + L | 0, a = Ir >>> 0 < a >>> 0 ? I + 1 | 0 : I, I = a + t[T + 36 >> 2] | 0, n = t[T + 32 >> 2], L = n + Ir | 0, $r = L, t[tr >> 2] = L, n = n >>> 0 > L >>> 0 ? I + 1 | 0 : I, t[tr + 4 >> 2] = n & 1073741823, L = t[T + 16 >> 2], us = L, Ii = t[T + 20 >> 2], I = Ii + Be | 0, tr = L + Me | 0, Me = tr >>> 0 < Me >>> 0 ? I + 1 | 0 : I, I = Me + t[T + 52 >> 2] | 0, L = t[T + 48 >> 2], Be = L + tr | 0, yi = Be, t[or >> 2] = Be, L = L >>> 0 > Be >>> 0 ? I + 1 | 0 : I, t[or + 4 >> 2] = L & 1073741823, Be = (n | 0) == (a | 0) & Ir >>> 0 > $r >>> 0 | n >>> 0 < a >>> 0, I = Oi + 8 | 0, or = t[I >> 2], $r = t[I + 4 >> 2], Ir = (a | 0) == (fi | 0) & Ir >>> 0 < ts >>> 0 | a >>> 0 < fi >>> 0, I = T + 8 | 0, a = t[I >> 2] + E | 0, I = t[I + 4 >> 2] + he | 0, I = a >>> 0 < E >>> 0 ? I + 1 | 0 : I, he = a, a = a + Ir | 0, I = (he >>> 0 > a >>> 0 ? I + 1 | 0 : I) + $r | 0, he = a, a = a + or | 0, I = he >>> 0 > a >>> 0 ? I + 1 | 0 : I, he = a, a = a + Be | 0, Be = he >>> 0 > a >>> 0 ? I + 1 | 0 : I, I = Be >> 31, E = Be >> 30, he = I, or = (L | 0) == (Me | 0) & tr >>> 0 > yi >>> 0 | L >>> 0 < Me >>> 0, I = Xi + 8 | 0, Ir = t[I >> 2], $r = t[I + 4 >> 2], tr = (Me | 0) == (Ii | 0) & tr >>> 0 < us >>> 0 | Me >>> 0 < Ii >>> 0, I = Hi + 8 | 0, Me = t[I >> 2] + gr | 0, I = t[I + 4 >> 2] + xr | 0, I = Me >>> 0 < gr >>> 0 ? I + 1 | 0 : I, xr = Me, Me = Me + tr | 0, I = (xr >>> 0 > Me >>> 0 ? I + 1 | 0 : I) + $r | 0, tr = Me, Me = Me + Ir | 0, I = tr >>> 0 > Me >>> 0 ? I + 1 | 0 : I, tr = Me, Me = Me + or | 0, tr = tr >>> 0 > Me >>> 0 ? I + 1 | 0 : I, I = tr >> 31, gr = tr >> 30, xr = I, Be = Be << 2 | a >>> 30, a = a << 2 | n >>> 30, n = Be, tr = tr << 2 | Me >>> 30, Me = Me << 2 | L >>> 30, Be = tr, tr = cr, or = Mr, jn = jn - 1 | 0, !!jn; )
          ;
      he = xn - 1 | 0, I = he << 3, E = I + (T + 160 | 0) | 0, t[E >> 2] = Me, t[E + 4 >> 2] = Be, I = (T + 200 | 0) + I | 0, t[I >> 2] = a, t[I + 4 >> 2] = n;
      e: {
        if (!(t[T + 164 >> 2] | t[T + 160 >> 2])) {
          if (Ti)
            break e;
          tr = he & 3;
          t: {
            if (xn - 2 >>> 0 < 3) {
              L = 0, E = 0, I = 1;
              break t;
            }
            for (I = he & -4, jn = 0, L = 0, E = 0, or = ni; dr = or - 8 | 0, cr = or - 16 | 0, gn = or - 24 | 0, L = t[or >> 2] | (t[dr >> 2] | (t[cr >> 2] | (t[gn >> 2] | L))), E = t[or + 4 >> 2] | (t[dr + 4 >> 2] | (t[cr + 4 >> 2] | (t[gn + 4 >> 2] | E))), or = or + 32 | 0, jn = jn + 4 | 0, (I | 0) != (jn | 0); )
              ;
            I = jn + 1 | 0;
          }
          if (tr)
            for (or = (T + 160 | 0) + (I << 3) | 0; L = t[or >> 2] | L, E = t[or + 4 >> 2] | E, or = or + 8 | 0, tr = tr - 1 | 0, !!tr; )
              ;
          if (!(E | L))
            break e;
        }
        if (I = Be >> 31, E = I ^ Me, L = I ^ Be, I = (xn >> 31) - (xn >>> 0 < 2) >> 31, E = I | E, L = I | L, I = n >> 31, E | I ^ a | (L | I ^ n))
          continue;
        L = (xn << 3) - 16 | 0, I = L + (T + 200 | 0) | 0, dr = t[I + 4 >> 2], t[I >> 2] = t[I >> 2], t[I + 4 >> 2] = a << 30 | dr, I = (T + 160 | 0) + L | 0, E = t[I + 4 >> 2], t[I >> 2] = t[I >> 2], t[I + 4 >> 2] = Me << 30 | E, xn = he;
        continue;
      }
      break;
    }
    I = n >> 31, n = I, tr = T + 280 | 0, I = tr + 32 | 0, he = t[I >> 2], I = t[I + 4 >> 2], dr = I, I = I >> 31, a = I, Be = t[d >> 2], cr = I & Be, E = cr + t[T + 280 >> 2] | 0, Me = t[d + 4 >> 2], I = t[T + 284 >> 2] + (Me & I) | 0, I = E >>> 0 < cr >>> 0 ? I + 1 | 0 : I, E = n ^ E, Un = E - n | 0, E = (I ^ n) - ((n >>> 0 > E >>> 0) + n | 0) | 0, L = v, or = Be, gn = Me, v = t[d + 32 >> 2], Ir = v, Be = v & a, v = Be + he | 0, $r = t[d + 36 >> 2], I = dr + ($r & a) | 0, I = v >>> 0 < Be >>> 0 ? I + 1 | 0 : I, v = v ^ n, cr = v - n | 0, Bn = (I ^ n) - ((v >>> 0 < n >>> 0) + n | 0) | 0, v = t[d + 24 >> 2], Xn = v, Me = v & a, Be = tr + 24 | 0, v = Me + t[Be >> 2] | 0, Gn = t[d + 28 >> 2], I = t[Be + 4 >> 2] + (Gn & a) | 0, I = v >>> 0 < Me >>> 0 ? I + 1 | 0 : I, v = v ^ n, dr = v - n | 0, xr = (I ^ n) - ((v >>> 0 < n >>> 0) + n | 0) | 0, v = t[d + 16 >> 2], xn = v, he = v & a, Me = tr + 16 | 0, v = he + t[Me >> 2] | 0, Wr = t[d + 20 >> 2], I = t[Me + 4 >> 2] + (Wr & a) | 0, I = v >>> 0 < he >>> 0 ? I + 1 | 0 : I, v = v ^ n, he = v - n | 0, gr = (I ^ n) - ((v >>> 0 < n >>> 0) + n | 0) | 0, kn = t[d + 8 >> 2], Mr = kn & a, tr = tr + 8 | 0, v = Mr + t[tr >> 2] | 0, ni = t[d + 12 >> 2], I = t[tr + 4 >> 2] + (ni & a) | 0, I = v >>> 0 < Mr >>> 0 ? I + 1 | 0 : I, v = v ^ n, d = v - n | 0, I = ((I ^ n) - ((v >>> 0 < n >>> 0) + n | 0) | 0) + (E >> 31) | 0, v = E >> 30, a = v + d | 0, Mr = v >>> 0 > a >>> 0 ? I + 1 | 0 : I, I = (Mr >> 31) + gr | 0, v = Mr >> 30, he = v + he | 0, gr = v >>> 0 > he >>> 0 ? I + 1 | 0 : I, I = (gr >> 31) + xr | 0, v = gr >> 30, dr = v + dr | 0, xr = v >>> 0 > dr >>> 0 ? I + 1 | 0 : I, I = (xr >> 31) + Bn | 0, v = xr >> 30, cr = v + cr | 0, Bn = v >>> 0 > cr >>> 0 ? I + 1 | 0 : I, v = Bn >> 31, I = (v & gn) + (E & 1073741823) | 0, n = v, d = (n & or) + Un | 0, v = d >>> 0 < Un >>> 0 ? I + 1 | 0 : I, I = v & 1073741823, or = I, t[L >> 2] = d, t[L + 4 >> 2] = I, I = (n & ni) + (Mr & 1073741823) | 0, E = a, a = (n & kn) + a | 0, I = (v >> 31) + (E >>> 0 > a >>> 0 ? I + 1 | 0 : I) | 0, v = v >> 30, E = v, v = v + a | 0, I = E >>> 0 > v >>> 0 ? I + 1 | 0 : I, a = v, t[tr >> 2] = a, v = I, I = I & 1073741823, t[tr + 4 >> 2] = I, E = L + 8 | 0, t[E >> 2] = a, t[E + 4 >> 2] = I, I = (n & Wr) + (gr & 1073741823) | 0, a = (n & xn) + he | 0, I = (v >> 31) + (a >>> 0 < he >>> 0 ? I + 1 | 0 : I) | 0, v = v >> 30, he = v, v = v + a | 0, I = he >>> 0 > v >>> 0 ? I + 1 | 0 : I, a = v, t[Me >> 2] = a, v = I, I = I & 1073741823, t[Me + 4 >> 2] = I, E = L + 16 | 0, t[E >> 2] = a, t[E + 4 >> 2] = I, I = (n & Gn) + (xr & 1073741823) | 0, a = (n & Xn) + dr | 0, I = (v >> 31) + (a >>> 0 < dr >>> 0 ? I + 1 | 0 : I) | 0, v = v >> 30, he = v, v = v + a | 0, I = he >>> 0 > v >>> 0 ? I + 1 | 0 : I, a = v, t[Be >> 2] = a, v = I, I = I & 1073741823, t[Be + 4 >> 2] = I, E = L + 24 | 0, t[E >> 2] = a, t[E + 4 >> 2] = I, E = L + 32 | 0, I = (n & $r) + Bn | 0, n = (n & Ir) + cr | 0, I = (v >> 31) + (n >>> 0 < cr >>> 0 ? I + 1 | 0 : I) | 0, v = v >> 30, a = v, v = v + n | 0, I = a >>> 0 > v >>> 0 ? I + 1 | 0 : I, t[E >> 2] = v, t[E + 4 >> 2] = I, t[T + 280 >> 2] = d, t[T + 284 >> 2] = or, x = T + 320 | 0;
  }
  function Er(v, d, I) {
    var n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0, Xn = 0, Zn = 0, ni = 0, ai = 0;
    E = x - 288 | 0, x = E, zi(E + 224 | 0, d, I), n = E + 208 | 0, Bn = t[E + 256 >> 2], xr = t[E + 260 >> 2], Ur(n, Bn, xr, 0, 0, 801750719, 1076732275, 0, 0), Mr = E + 176 | 0, Zn = t[E + 264 >> 2], xn = t[E + 268 >> 2], Ur(Mr, Zn, xn, 0, 0, 801750719, 1076732275, 0, 0), tr = E + 192 | 0, Ur(tr, Bn, xr, 0, 0, 1354194884, 1162945305, 0, 0), gn = E + 144 | 0, ni = t[E + 272 >> 2], Gn = t[E + 276 >> 2], Ur(gn, ni, Gn, 0, 0, 801750719, 1076732275, 0, 0), Ir = E + 160 | 0, Ur(Ir, Zn, xn, 0, 0, 1354194884, 1162945305, 0, 0), jn = E + 112 | 0, kn = t[E + 280 >> 2], Xn = t[E + 284 >> 2], Ur(jn, kn, Xn, 0, 0, 801750719, 1076732275, 0, 0), Un = E + 128 | 0, Ur(Un, ni, Gn, 0, 0, 1354194884, 1162945305, 0, 0), ai = E + 96 | 0, Ur(ai, kn, Xn, 0, 0, 1354194884, 1162945305, 0, 0), a = t[E + 224 >> 2], I = t[E + 208 >> 2], cr = a + I | 0, he = t[E + 228 >> 2], d = he + t[E + 212 >> 2] | 0, Wr = I >>> 0 > cr >>> 0 ? d + 1 | 0 : d, a = (he | 0) == (Wr | 0) & a >>> 0 > cr >>> 0 | he >>> 0 > Wr >>> 0, Me = t[E + 232 >> 2], d = n + 8 | 0, I = t[d >> 2], n = Me + I | 0, or = t[E + 236 >> 2], d = or + t[d + 4 >> 2] | 0, d = I >>> 0 > n >>> 0 ? d + 1 | 0 : d, I = n + a | 0, a = I >>> 0 < n >>> 0 ? d + 1 | 0 : d, d = a + t[E + 180 >> 2] | 0, he = I, I = t[E + 176 >> 2], n = he + I | 0, T = t[E + 192 >> 2], dr = n + T | 0, I = I >>> 0 > n >>> 0 ? d + 1 | 0 : d, d = I + t[E + 196 >> 2] | 0, gr = T >>> 0 > dr >>> 0 ? d + 1 | 0 : d, Be = (I | 0) == (gr | 0) & n >>> 0 > dr >>> 0 | I >>> 0 > gr >>> 0, L = (I | 0) == (a | 0) & n >>> 0 < he >>> 0 | I >>> 0 < a >>> 0, T = (a | 0) == (or | 0) & he >>> 0 < Me >>> 0 | a >>> 0 < or >>> 0, I = t[E + 240 >> 2], or = I, n = tr + 8 | 0, a = t[n >> 2], d = Mr + 8 | 0, Me = a + t[d >> 2] | 0, d = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, $r = t[E + 244 >> 2], d = $r + (a >>> 0 > Me >>> 0 ? d + 1 | 0 : d) | 0, I = I + Me | 0, d = I >>> 0 < Me >>> 0 ? d + 1 | 0 : d, n = I, I = I + T | 0, d = n >>> 0 > I >>> 0 ? d + 1 | 0 : d, n = I, I = I + L | 0, d = n >>> 0 > I >>> 0 ? d + 1 | 0 : d, n = I, I = I + Be | 0, d = n >>> 0 > I >>> 0 ? d + 1 | 0 : d, Be = I, I = t[E + 144 >> 2], L = Be + I | 0, n = d, d = d + t[E + 148 >> 2] | 0, d = I >>> 0 > L >>> 0 ? d + 1 | 0 : d, I = t[E + 160 >> 2], T = I + L | 0, a = d, d = d + t[E + 164 >> 2] | 0, I = I >>> 0 > T >>> 0 ? d + 1 | 0 : d, d = xr + I | 0, he = T + Bn | 0, xr = he >>> 0 < Bn >>> 0 ? d + 1 | 0 : d, Mr = he, tr = (I | 0) == (xr | 0) & he >>> 0 < T >>> 0 | I >>> 0 > xr >>> 0, Me = (I | 0) == (a | 0) & T >>> 0 < L >>> 0 | I >>> 0 < a >>> 0, L = (n | 0) == (a | 0) & L >>> 0 < Be >>> 0 | n >>> 0 > a >>> 0, T = (n | 0) == ($r | 0) & Be >>> 0 < or >>> 0 | n >>> 0 < $r >>> 0, I = t[E + 248 >> 2], $r = I, n = Ir + 8 | 0, a = t[n >> 2], d = gn + 8 | 0, Be = a + t[d >> 2] | 0, d = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, Bn = t[E + 252 >> 2], d = Bn + (a >>> 0 > Be >>> 0 ? d + 1 | 0 : d) | 0, I = I + Be | 0, d = I >>> 0 < Be >>> 0 ? d + 1 | 0 : d, n = I, I = I + T | 0, d = n >>> 0 > I >>> 0 ? d + 1 | 0 : d, n = I, I = I + L | 0, d = n >>> 0 > I >>> 0 ? d + 1 | 0 : d, n = I, I = I + Me | 0, d = n >>> 0 > I >>> 0 ? d + 1 | 0 : d, n = I, I = I + tr | 0, d = n >>> 0 > I >>> 0 ? d + 1 | 0 : d, Be = I, I = t[E + 112 >> 2], L = Be + I | 0, n = d, d = d + t[E + 116 >> 2] | 0, d = I >>> 0 > L >>> 0 ? d + 1 | 0 : d, I = t[E + 128 >> 2], T = I + L | 0, a = d, d = d + t[E + 132 >> 2] | 0, I = I >>> 0 > T >>> 0 ? d + 1 | 0 : d, d = xn + I | 0, xn = E + 80 | 0, Ir = xn, he = T + Zn | 0, gn = he >>> 0 < Zn >>> 0 ? d + 1 | 0 : d, tr = he, or = (I | 0) == (gn | 0) & he >>> 0 < T >>> 0 | I >>> 0 > gn >>> 0, Me = (I | 0) == (a | 0) & T >>> 0 < L >>> 0 | I >>> 0 < a >>> 0, T = (n | 0) == (a | 0) & L >>> 0 < Be >>> 0 | n >>> 0 > a >>> 0, he = (n | 0) == (Bn | 0) & Be >>> 0 < $r >>> 0 | n >>> 0 < Bn >>> 0, d = jn + 8 | 0, n = t[d >> 2], a = t[d + 4 >> 2], L = t[E + 96 >> 2], d = Un + 8 | 0, I = t[d >> 2], $r = L + I | 0, Be = t[E + 100 >> 2], d = Be + t[d + 4 >> 2] | 0, d = (I >>> 0 > $r >>> 0 ? d + 1 | 0 : d) + a | 0, I = n + $r | 0, d = I >>> 0 < $r >>> 0 ? d + 1 | 0 : d, n = I, I = I + he | 0, d = n >>> 0 > I >>> 0 ? d + 1 | 0 : d, n = I, I = I + T | 0, d = n >>> 0 > I >>> 0 ? d + 1 | 0 : d, n = I, I = I + Me | 0, d = n >>> 0 > I >>> 0 ? d + 1 | 0 : d, a = I + or | 0, I = a >>> 0 < I >>> 0 ? d + 1 | 0 : d, d = Gn + I | 0, n = a, a = n + ni | 0, d = a >>> 0 < ni >>> 0 ? d + 1 | 0 : d, Un = a, Me = d, Ur(Ir, a, d, 0, 0, 801750719, 1076732275, 0, 0), Gn = E + 48 | 0, T = Gn, he = (d | 0) == (I | 0) & n >>> 0 > a >>> 0 | d >>> 0 < I >>> 0, a = (I | 0) == (Be | 0) & n >>> 0 < L >>> 0 | I >>> 0 < Be >>> 0, d = ai + 8 | 0, I = t[d >> 2], n = I + kn | 0, d = Xn + t[d + 4 >> 2] | 0, d = I >>> 0 > n >>> 0 ? d + 1 | 0 : d, I = n + a | 0, d = I >>> 0 < n >>> 0 ? d + 1 | 0 : d, n = I, I = I + he | 0, d = n >>> 0 > I >>> 0 ? d + 1 | 0 : d, $r = I, Ir = d, Ur(T, I, d, 0, 0, 801750719, 1076732275, 0, 0), Bn = E - -64 | 0, Ur(Bn, Un, Me, 0, 0, 1354194884, 1162945305, 0, 0), jn = E + 32 | 0, Ur(jn, I, d, 0, 0, 1354194884, 1162945305, 0, 0), I = t[E + 80 >> 2], or = I + cr | 0, d = Wr + t[E + 84 >> 2] | 0, he = I >>> 0 > or >>> 0 ? d + 1 | 0 : d, a = (Wr | 0) == (he | 0) & or >>> 0 < cr >>> 0 | he >>> 0 < Wr >>> 0, d = xn + 8 | 0, I = t[d >> 2], n = I + dr | 0, d = gr + t[d + 4 >> 2] | 0, d = I >>> 0 > n >>> 0 ? d + 1 | 0 : d, I = n + a | 0, a = I >>> 0 < n >>> 0 ? d + 1 | 0 : d, d = a + t[E + 52 >> 2] | 0, L = I, I = t[E + 48 >> 2], n = L + I | 0, T = t[E + 64 >> 2], cr = n + T | 0, I = I >>> 0 > n >>> 0 ? d + 1 | 0 : d, d = I + t[E + 68 >> 2] | 0, kn = (Ir | 0) == (Xn | 0) & $r >>> 0 < kn >>> 0 | Ir >>> 0 < Xn >>> 0, ai = kn ? 801750719 : 0, xn = kn ? 1076732275 : 0, T = T >>> 0 > cr >>> 0 ? d + 1 | 0 : d, Wr = (I | 0) == (T | 0) & n >>> 0 > cr >>> 0 | I >>> 0 > T >>> 0, Be = (I | 0) == (a | 0) & n >>> 0 < L >>> 0 | I >>> 0 < a >>> 0, L = (a | 0) == (gr | 0) & L >>> 0 < dr >>> 0 | a >>> 0 < gr >>> 0, d = Gn + 8 | 0, n = t[d >> 2], a = t[d + 4 >> 2], d = Bn + 8 | 0, I = t[d >> 2], dr = I + Mr | 0, d = xr + t[d + 4 >> 2] | 0, d = (I >>> 0 > dr >>> 0 ? d + 1 | 0 : d) + a | 0, I = n + dr | 0, d = I >>> 0 < dr >>> 0 ? d + 1 | 0 : d, n = I, I = I + L | 0, d = n >>> 0 > I >>> 0 ? d + 1 | 0 : d, n = I, I = I + Be | 0, d = n >>> 0 > I >>> 0 ? d + 1 | 0 : d, n = I, I = I + Wr | 0, n = n >>> 0 > I >>> 0 ? d + 1 | 0 : d, d = n + xn | 0, gr = I, I = I + ai | 0, d = gr >>> 0 > I >>> 0 ? d + 1 | 0 : d, Be = I, I = t[E + 32 >> 2], L = Be + I | 0, a = d, d = d + t[E + 36 >> 2] | 0, I = I >>> 0 > L >>> 0 ? d + 1 | 0 : d, d = Me + I | 0, dr = L + Un | 0, Me = dr >>> 0 < Un >>> 0 ? d + 1 | 0 : d, Un = (I | 0) == (Me | 0) & L >>> 0 > dr >>> 0 | I >>> 0 > Me >>> 0, Wr = (I | 0) == (a | 0) & L >>> 0 < Be >>> 0 | I >>> 0 < a >>> 0, L = (n | 0) == (a | 0) & Be >>> 0 < gr >>> 0 | n >>> 0 > a >>> 0, a = (n | 0) == (xr | 0) & gr >>> 0 < Mr >>> 0 | n >>> 0 < xr >>> 0, d = jn + 8 | 0, I = t[d >> 2], n = I + tr | 0, d = gn + t[d + 4 >> 2] | 0, d = I >>> 0 > n >>> 0 ? d + 1 | 0 : d, I = n + a | 0, d = I >>> 0 < n >>> 0 ? d + 1 | 0 : d, n = I, I = I + L | 0, d = n >>> 0 > I >>> 0 ? d + 1 | 0 : d, n = I, I = I + Wr | 0, d = n >>> 0 > I >>> 0 ? d + 1 | 0 : d, n = I, I = I + Un | 0, d = n >>> 0 > I >>> 0 ? d + 1 | 0 : d, L = I, I = kn ? 1354194884 : 0, n = L + I | 0, a = d, d = d + (kn ? 1162945305 : 0) | 0, I = I >>> 0 > n >>> 0 ? d + 1 | 0 : d, d = Ir + I | 0, xr = E + 16 | 0, Mr = n + $r | 0, Be = Mr >>> 0 < $r >>> 0 ? d + 1 | 0 : d, gr = (I | 0) == (Be | 0) & n >>> 0 > Mr >>> 0 | I >>> 0 > Be >>> 0, I = (I | 0) == (a | 0) & n >>> 0 < L >>> 0 | I >>> 0 < a >>> 0, a = kn + ((a | 0) == (gn | 0) & L >>> 0 < tr >>> 0 | a >>> 0 < gn >>> 0) | 0, d = kn >>> 0 > a >>> 0, I = I + a | 0, d = I >>> 0 < a >>> 0 ? d + 1 | 0 : d, tr = I + gr | 0, d = tr >>> 0 < I >>> 0 ? d + 1 | 0 : d, gr = d, Ur(xr, tr, d, 0, 0, 801750719, 1076732275, 0, 0), Ur(E, tr, d, 0, 0, 1354194884, 1162945305, 0, 0), I = t[E + 16 >> 2], Ir = I, Wr = t[E + 20 >> 2], d = Wr + he | 0, a = I + or | 0, he = a >>> 0 < or >>> 0 ? d + 1 | 0 : d, I = t[E >> 2], L = I, gn = t[E + 4 >> 2], d = gn + T | 0, n = I + cr | 0, I = n >>> 0 < cr >>> 0 ? d + 1 | 0 : d, T = n, n = (he | 0) == (Wr | 0) & a >>> 0 < Ir >>> 0 | he >>> 0 < Wr >>> 0, d = xr + 8 | 0, cr = n + t[d >> 2] | 0, d = t[d + 4 >> 2], d = (n >>> 0 > cr >>> 0 ? d + 1 | 0 : d) + I | 0, n = T + cr | 0, or = n >>> 0 < cr >>> 0 ? d + 1 | 0 : d, cr = n, n = (I | 0) == (or | 0) & n >>> 0 < T >>> 0 | I >>> 0 > or >>> 0, I = (I | 0) == (gn | 0) & T >>> 0 < L >>> 0 | I >>> 0 < gn >>> 0, d = E + 8 | 0, T = I + t[d >> 2] | 0, d = t[d + 4 >> 2], d = I >>> 0 > T >>> 0 ? d + 1 | 0 : d, L = n + T | 0, T = L >>> 0 < T >>> 0 ? d + 1 | 0 : d, d = Me + gr | 0, n = tr + dr | 0, I = n >>> 0 < dr >>> 0 ? d + 1 | 0 : d, d = I + T | 0, Ir = (I | 0) == (gr | 0) & n >>> 0 < tr >>> 0 | I >>> 0 < gr >>> 0, Me = n, L = n + L | 0, n = L >>> 0 < n >>> 0 ? d + 1 | 0 : d, d = Me, Me = L, T = (I | 0) == (n | 0) & d >>> 0 > L >>> 0 | I >>> 0 > n >>> 0, I = Ir + T | 0, T = I >>> 0 < T >>> 0, d = Be + T | 0, Be = I + Mr | 0, d = Be >>> 0 < Mr >>> 0 ? d + 1 | 0 : d, Mr = (n | 0) == -1, L = d, tr = Mr & Me >>> 0 < 4294967294 | (n | 0) != -1 | (d & Be) != -1, dr = (or | 0) == -1162945306, d = (tr | (dr & cr >>> 0 < 2940772411 | or >>> 0 < 3132021990)) ^ -1, tr = (d & ((he | 0) == -1076732276 & a >>> 0 > 3493216576 | he >>> 0 > 3218235020) | (d & (dr & cr >>> 0 > 2940772411 | or >>> 0 > 3132021990) | (Me | 0) == -1 & Mr & (tr ^ -1))) + ((T | 0) == (L | 0) & I >>> 0 > Be >>> 0 | T >>> 0 > L >>> 0) | 0, I = pn(tr, 0, 801750719, 1076732275), T = I + a | 0, d = he + Ee | 0, t[v >> 2] = T, d = I >>> 0 > T >>> 0 ? d + 1 | 0 : d, t[v + 4 >> 2] = d, I = v, he = (d | 0) == (he | 0) & a >>> 0 > T >>> 0 | d >>> 0 < he >>> 0, v = pn(tr, 0, 1354194884, 1162945305), a = v + cr | 0, d = or + Ee | 0, d = v >>> 0 > a >>> 0 ? d + 1 | 0 : d, v = d, he = a + he | 0, d = he >>> 0 < a >>> 0 ? d + 1 | 0 : d, t[I + 8 >> 2] = he, t[I + 12 >> 2] = d, Ir = (v | 0) == (or | 0) & a >>> 0 < cr >>> 0 | v >>> 0 < or >>> 0, v = (v | 0) == (d | 0) & a >>> 0 > he >>> 0 | v >>> 0 > d >>> 0, T = Ir + v | 0, he = v >>> 0 > T >>> 0, d = n, a = Me + tr | 0, v = a >>> 0 < tr >>> 0 ? d + 1 | 0 : d, d = v + he | 0, he = a + T | 0, d = he >>> 0 < a >>> 0 ? d + 1 | 0 : d, t[I + 16 >> 2] = he, t[I + 20 >> 2] = d, n = (v | 0) == (n | 0) & a >>> 0 < Me >>> 0 | v >>> 0 < n >>> 0, v = (v | 0) == (d | 0) & a >>> 0 > he >>> 0 | v >>> 0 > d >>> 0, a = n + v | 0, d = L + (v >>> 0 > a >>> 0) | 0, v = a + Be | 0, d = v >>> 0 < Be >>> 0 ? d + 1 | 0 : d, t[I + 24 >> 2] = v, t[I + 28 >> 2] = d, x = E + 288 | 0;
  }
  function Or(v, d, I, n) {
    var a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0, Xn = 0, Zn = 0, ni = 0, ai = 0, fi = 0, Ai = 0, yi = 0, Ii = 0, wi = 0, Bi = 0, Ti = 0, Oi = 0, Hi = 0, Xi = 0, Zi = 0, ts = 0, us = 0, hs = 0, ws = 0, ks = 0, Bs = 0, gs = 0, ps = 0, zs = 0, Gs = 0, to = 0, ro = 0, $s = 0, Xs = 0, Ao = 0, co = 0, Co = 0, wo = 0, fo = 0, pi = 0, bi = 0, Ni = 0;
    Me = x - 3808 | 0, x = Me, a = Me + 3696 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = Me + 3704 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = Me + 3712 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, t[Me + 3688 >> 2] = 0, t[Me + 3692 >> 2] = 0, t[Me + 3680 >> 2] = 1, t[Me + 3684 >> 2] = 0;
    e: {
      if (!(!t[d + 120 >> 2] && t[I + 24 >> 2] | (t[I + 16 >> 2] | (t[I + 8 >> 2] | t[I >> 2])) | (t[I + 28 >> 2] | (t[I + 20 >> 2] | (t[I + 12 >> 2] | t[I + 4 >> 2]))))) {
        I = 0, d = 0;
        break e;
      }
      E = x - 128 | 0, x = E, L = E - -64 | 0, zi(L, I, 690640), t[E + 56 >> 2] = 0, t[E + 60 >> 2] = 0, he = ((t[E + 108 >> 2] >>> 31 | 0) - 1 >>> 8 ^ -1) & 1, T = t[E + 112 >> 2], cr = he + T | 0, a = t[E + 116 >> 2], t[E + 32 >> 2] = cr, a = T >>> 0 > cr >>> 0 ? a + 1 | 0 : a, t[E + 36 >> 2] = a, he = !a & he >>> 0 > cr >>> 0, T = t[E + 120 >> 2], cr = he + T | 0, a = t[E + 124 >> 2], t[E + 40 >> 2] = cr, a = T >>> 0 > cr >>> 0 ? a + 1 | 0 : a, t[E + 44 >> 2] = a, t[E + 48 >> 2] = !a & he >>> 0 > cr >>> 0, t[E + 52 >> 2] = 0, zi(L, I, 690672), t[E + 24 >> 2] = 0, t[E + 28 >> 2] = 0, he = ((t[E + 108 >> 2] >>> 31 | 0) - 1 >>> 8 ^ -1) & 1, T = t[E + 112 >> 2], L = he + T | 0, a = t[E + 116 >> 2], t[E >> 2] = L, a = T >>> 0 > L >>> 0 ? a + 1 | 0 : a, t[E + 4 >> 2] = a, T = !a & L >>> 0 < he >>> 0, Mr = E, E = t[E + 120 >> 2], he = T + E | 0, a = t[Mr + 124 >> 2], t[Mr + 8 >> 2] = he, a = E >>> 0 > he >>> 0 ? a + 1 | 0 : a, t[Mr + 12 >> 2] = a, t[Mr + 16 >> 2] = !a & T >>> 0 > he >>> 0, t[Mr + 20 >> 2] = 0, a = Mr + 32 | 0, Er(a, a, 690576), Er(Mr, Mr, 690608), he = t[Mr >> 2], T = t[Mr + 32 >> 2], E = he + T | 0, L = t[Mr + 4 >> 2], a = L + t[Mr + 36 >> 2] | 0, Wr = E >>> 0 < T >>> 0 ? a + 1 | 0 : a, or = E, cr = (L | 0) == (Wr | 0) & E >>> 0 < he >>> 0 | L >>> 0 > Wr >>> 0, E = t[Mr + 40 >> 2], he = cr + E | 0, a = t[Mr + 44 >> 2], L = t[Mr + 8 >> 2], T = L + he | 0, E = E >>> 0 > he >>> 0 ? a + 1 | 0 : a, a = E + t[Mr + 12 >> 2] | 0, Be = !E & he >>> 0 < cr >>> 0, xr = T >>> 0 < L >>> 0 ? a + 1 | 0 : a, Ir = T, E = (E | 0) == (xr | 0) & he >>> 0 > T >>> 0 | E >>> 0 > xr >>> 0, T = Be + E | 0, Be = E >>> 0 > T >>> 0, a = Be + t[Mr + 52 >> 2] | 0, E = t[Mr + 48 >> 2], cr = E + T | 0, L = t[Mr + 16 >> 2], he = cr + L | 0, E = E >>> 0 > cr >>> 0 ? a + 1 | 0 : a, a = E + t[Mr + 20 >> 2] | 0, T = (E | 0) == (Be | 0) & T >>> 0 > cr >>> 0 | E >>> 0 < Be >>> 0, L = L >>> 0 > he >>> 0 ? a + 1 | 0 : a, $r = he, E = (E | 0) == (L | 0) & cr >>> 0 > he >>> 0 | E >>> 0 > L >>> 0, T = T + E | 0, cr = E >>> 0 > T >>> 0, a = cr + t[Mr + 60 >> 2] | 0, E = t[Mr + 56 >> 2], he = E + T | 0, Be = t[Mr + 24 >> 2], dr = he + Be | 0, E = E >>> 0 > he >>> 0 ? a + 1 | 0 : a, a = E + t[Mr + 28 >> 2] | 0, gr = Be >>> 0 > dr >>> 0 ? a + 1 | 0 : a, Be = ((E | 0) == (cr | 0) & T >>> 0 > he >>> 0 | E >>> 0 < cr >>> 0) + ((E | 0) == (gr | 0) & he >>> 0 > dr >>> 0 | E >>> 0 > gr >>> 0) | 0, T = (L | 0) == -1, E = T & $r >>> 0 < 4294967294 | (L | 0) != -1 | (dr & gr) != -1, he = (xr | 0) == -1162945306, a = (E | (he & Ir >>> 0 < 2940772411 | xr >>> 0 < 3132021990)) ^ -1, kn = Be + (a & ((Wr | 0) == -1076732276 & or >>> 0 > 3493216576 | Wr >>> 0 > 3218235020) | (a & (he & Ir >>> 0 > 2940772411 | xr >>> 0 > 3132021990) | ($r | 0) == -1 & T & (E ^ -1))) | 0, T = pn(kn, 0, 801750719, 1076732275), E = T + or | 0, a = Wr + Ee | 0, Be = Me + 3720 | 0, t[Be >> 2] = E, cr = E >>> 0 < T >>> 0 ? a + 1 | 0 : a, t[Be + 4 >> 2] = cr, he = Be, T = pn(kn, 0, 1354194884, 1162945305), tr = T + Ir | 0, a = xr + Ee | 0, E = (cr | 0) == (Wr | 0) & E >>> 0 < or >>> 0 | cr >>> 0 < Wr >>> 0, Be = tr + E | 0, a = T >>> 0 > tr >>> 0 ? a + 1 | 0 : a, T = a, t[he + 8 >> 2] = Be, or = E >>> 0 > Be >>> 0 ? a + 1 | 0 : a, t[he + 12 >> 2] = or, a = L, cr = $r + kn | 0, E = cr >>> 0 < $r >>> 0 ? a + 1 | 0 : a, a = (T | 0) == (xr | 0) & tr >>> 0 < Ir >>> 0 | T >>> 0 < xr >>> 0, T = (T | 0) == (or | 0) & Be >>> 0 < tr >>> 0 | T >>> 0 > or >>> 0, Be = a + T | 0, a = (T >>> 0 > Be >>> 0) + E | 0, T = Be + cr | 0, a = T >>> 0 < Be >>> 0 ? a + 1 | 0 : a, t[he + 16 >> 2] = T, t[he + 20 >> 2] = a, Ir = he, L = (E | 0) == (L | 0) & cr >>> 0 < $r >>> 0 | E >>> 0 < L >>> 0, E = (a | 0) == (E | 0) & T >>> 0 < cr >>> 0 | a >>> 0 < E >>> 0, T = L + E | 0, a = gr + (E >>> 0 > T >>> 0) | 0, E = T + dr | 0, a = E >>> 0 < dr >>> 0 ? a + 1 | 0 : a, t[he + 24 >> 2] = E, t[he + 28 >> 2] = a, he = Me + 2560 | 0, Er(he, Ir, 690704), xn = t[he + 24 >> 2], dr = t[he + 16 >> 2], cr = t[he + 8 >> 2], E = t[he >> 2], or = t[he + 28 >> 2], Be = t[he + 20 >> 2], tr = t[he + 12 >> 2], L = t[he + 4 >> 2], a = xn | (dr | (cr | E)) | (or | (Be | (tr | L))) ? -1 : 0, $r = E ^ -1, T = $r - 801750718 | 0, kn = a & T, t[he >> 2] = kn, E = a, L = L ^ -1, a = L - (($r >>> 0 < 801750718) + 1076732275 | 0) | 0, gr = E & a, t[he + 4 >> 2] = gr, T = (a | 0) == (L | 0) & T >>> 0 < $r >>> 0 | a >>> 0 < L >>> 0, cr = cr ^ -1, Wr = T + cr | 0, $r = tr ^ -1, a = $r, L = Wr - 1354194885 | 0, xr = L & E, t[he + 8 >> 2] = xr, a = T >>> 0 > Wr >>> 0 ? a + 1 | 0 : a, tr = a - ((Wr >>> 0 < 1354194885) + 1162945305 | 0) | 0, T = tr & E, t[he + 12 >> 2] = T, L = (a | 0) == (tr | 0) & L >>> 0 < Wr >>> 0 | a >>> 0 > tr >>> 0, cr = L + ((a | 0) == ($r | 0) & cr >>> 0 > Wr >>> 0 | a >>> 0 < $r >>> 0) | 0, $r = dr ^ -1, ni = $r + cr | 0, dr = Be ^ -1, a = dr + (L >>> 0 > cr >>> 0) | 0, a = $r >>> 0 > ni >>> 0 ? a + 1 | 0 : a, tr = a - (ni >>> 0 < 2) | 0, cr = tr & E, Wr = cr, L = ni - 2 | 0, Be = L & E, t[he + 16 >> 2] = Be, t[he + 20 >> 2] = cr, L = (a | 0) == (tr | 0) & L >>> 0 < ni >>> 0 | a >>> 0 > tr >>> 0, cr = L + ((a | 0) == (dr | 0) & $r >>> 0 > ni >>> 0 | a >>> 0 < dr >>> 0) | 0, a = L >>> 0 > cr >>> 0, L = cr - xn | 0, ni = L - 2 & E, t[he + 24 >> 2] = ni, tr = (a - ((cr >>> 0 < xn >>> 0) + or | 0) | 0) - (L >>> 0 < 2) & E, t[he + 28 >> 2] = tr, E = t[I >> 2], L = E, cr = t[I + 4 >> 2], a = cr + gr | 0, E = E + kn | 0, a = E >>> 0 < kn >>> 0 ? a + 1 | 0 : a, gr = E, t[he >> 2] = E, $r = a, t[he + 4 >> 2] = a, a = T, or = (cr | 0) == ($r | 0) & E >>> 0 < L >>> 0 | cr >>> 0 > $r >>> 0, E = or + xr | 0, T = E >>> 0 < xr >>> 0 ? a + 1 | 0 : a, a = T + t[I + 12 >> 2] | 0, L = E, cr = t[I + 8 >> 2], E = E + cr | 0, dr = E, t[he + 8 >> 2] = E, xr = E >>> 0 < cr >>> 0 ? a + 1 | 0 : a, t[he + 12 >> 2] = xr, Un = t[I + 16 >> 2], Be = Un + Be | 0, xn = t[I + 20 >> 2], a = xn + Wr | 0, E = Be >>> 0 < Un >>> 0 ? a + 1 | 0 : a, a = !T & L >>> 0 < or >>> 0, T = (T | 0) == (xr | 0) & L >>> 0 > dr >>> 0 | T >>> 0 > xr >>> 0, L = a + T | 0, a = (T >>> 0 > L >>> 0) + E | 0, T = L + Be | 0, a = T >>> 0 < L >>> 0 ? a + 1 | 0 : a, Wr = T, t[he + 16 >> 2] = T, L = a, t[he + 20 >> 2] = a, T = t[I + 24 >> 2], or = T, kn = t[I + 28 >> 2], a = kn + tr | 0, T = T + ni | 0, I = T >>> 0 < ni >>> 0 ? a + 1 | 0 : a, cr = T, a = (E | 0) == (xn | 0) & Be >>> 0 < Un >>> 0 | E >>> 0 < xn >>> 0, E = (E | 0) == (L | 0) & Be >>> 0 > Wr >>> 0 | E >>> 0 > L >>> 0, Be = a + E | 0, a = (E >>> 0 > Be >>> 0) + I | 0, tr = T + Be | 0, a = tr >>> 0 < Be >>> 0 ? a + 1 | 0 : a, T = he, Be = a, cr = ((I | 0) == (kn | 0) & or >>> 0 > cr >>> 0 | I >>> 0 < kn >>> 0) + ((I | 0) == (a | 0) & tr >>> 0 < cr >>> 0 | I >>> 0 > a >>> 0) | 0, E = (L | 0) == -1, a = E & Wr >>> 0 < 4294967294 | (L | 0) != -1 | (a & tr) != -1, he = (xr | 0) == -1162945306, I = (a | (he & dr >>> 0 < 2940772411 | xr >>> 0 < 3132021990)) ^ -1, kn = cr + (I & (($r | 0) == -1076732276 & gr >>> 0 > 3493216576 | $r >>> 0 > 3218235020) | (I & (he & dr >>> 0 > 2940772411 | xr >>> 0 > 3132021990) | (Wr | 0) == -1 & E & (a ^ -1))) | 0, E = pn(kn, 0, 801750719, 1076732275), I = E + gr | 0, a = $r + Ee | 0, t[T >> 2] = I, he = I >>> 0 < E >>> 0 ? a + 1 | 0 : a, t[T + 4 >> 2] = he, E = pn(kn, 0, 1354194884, 1162945305), or = E + dr | 0, a = xr + Ee | 0, I = (he | 0) == ($r | 0) & I >>> 0 < gr >>> 0 | he >>> 0 < $r >>> 0, cr = or + I | 0, a = E >>> 0 > or >>> 0 ? a + 1 | 0 : a, E = a, t[T + 8 >> 2] = cr, gr = I >>> 0 > cr >>> 0 ? a + 1 | 0 : a, t[T + 12 >> 2] = gr, a = L, he = Wr + kn | 0, I = he >>> 0 < Wr >>> 0 ? a + 1 | 0 : a, a = (E | 0) == (xr | 0) & dr >>> 0 > or >>> 0 | E >>> 0 < xr >>> 0, E = (E | 0) == (gr | 0) & or >>> 0 > cr >>> 0 | E >>> 0 > gr >>> 0, cr = a + E | 0, a = (E >>> 0 > cr >>> 0) + I | 0, E = he + cr | 0, a = E >>> 0 < cr >>> 0 ? a + 1 | 0 : a, t[T + 16 >> 2] = E, t[T + 20 >> 2] = a, L = (I | 0) == (L | 0) & he >>> 0 < Wr >>> 0 | I >>> 0 < L >>> 0, I = (I | 0) == (a | 0) & E >>> 0 < he >>> 0 | I >>> 0 > a >>> 0, E = L + I | 0, a = Be + (I >>> 0 > E >>> 0) | 0, I = E + tr | 0, a = I >>> 0 < tr >>> 0 ? a + 1 | 0 : a, t[T + 24 >> 2] = I, t[T + 28 >> 2] = a, x = Mr + 128 | 0, bi = Me, Ni = Pn(Me + 496 | 0, T, 5), t[bi + 1528 >> 2] = Ni, pi = Pn(Me + 1012 | 0, Ir, 5), t[Me + 1532 >> 2] = pi, Gs = t[Me + 1528 >> 2], Oi = Me + 3088 | 0, $i(Oi, d, 128), I = Me + 1536 | 0, ws = Me + 2240 | 0, zs = Me + 3680 | 0, or = 0, gr = 0, tr = 0, L = 0, xr = x - 720 | 0, x = xr;
      t: {
        if (t[Oi + 120 >> 2]) {
          t[xr + 672 >> 2] = 1, Vi(xr + 552 | 0, 120), he = 0, T = 0;
          break t;
        }
        Mi(xr + 552 | 0, Oi), d = xr + 664 | 0, tr = t[d >> 2], L = t[d + 4 >> 2], d = xr + 648 | 0, Bn = t[d >> 2], gn = t[d + 4 >> 2], d = xr + 640 | 0, jn = t[d >> 2], Gn = t[d + 4 >> 2], or = t[xr + 632 >> 2], gr = t[xr + 636 >> 2], d = xr + 656 | 0, he = t[d >> 2], T = t[d + 4 >> 2];
      }
      for (fi = xr + 552 | 0, E = fi + 8 | 0, a = t[E + 4 >> 2], hs = xr + 336 | 0, d = hs + 8 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = fi + 16 | 0, a = t[E + 4 >> 2], d = hs + 16 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = fi + 24 | 0, a = t[E + 4 >> 2], d = hs + 24 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = fi + 32 | 0, a = t[E + 4 >> 2], d = hs + 32 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = fi + 48 | 0, a = t[E + 4 >> 2], d = hs + 48 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = fi + 56 | 0, a = t[E + 4 >> 2], d = hs + 56 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = fi - -64 | 0, a = t[E + 4 >> 2], d = hs - -64 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = fi + 72 | 0, a = t[E + 4 >> 2], d = hs + 72 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, t[xr + 416 >> 2] = 0, d = t[xr + 556 >> 2], t[xr + 336 >> 2] = t[xr + 552 >> 2], t[xr + 340 >> 2] = d, d = t[xr + 596 >> 2], t[xr + 376 >> 2] = t[xr + 592 >> 2], t[xr + 380 >> 2] = d, Zn = xr + 304 | 0, ai = or << 1, Ii = gr << 1 | or >>> 31, Ur(Zn, he, T, 0, 0, ai, Ii, 0, 0), Xn = xr + 224 | 0, E = Bn, d = gn, cr = jn << 1, Be = Gn << 1 | jn >>> 31, Ur(Xn, E, d, 0, 0, cr, Be, 0, 0), dr = xr + 160 | 0, a = L, Ur(dr, tr, a, 0, 0, tr, a, 0, 0), $r = xr + 144 | 0, Ur($r, t[xr + 160 >> 2], t[xr + 164 >> 2], 0, 0, 15632, 16, 0, 0), L = tr, a = a << 1 | L >>> 31, Zi = xr + 112 | 0, ts = L << 1, ni = a, Ur(Zi, ts, a, 0, 0, or, gr, 0, 0), us = xr + 272 | 0, Ur(us, he, T, 0, 0, cr, Be, 0, 0), wi = xr + 208 | 0, Ur(wi, E, d, 0, 0, E, d, 0, 0), kn = xr + 128 | 0, a = dr + 8 | 0, Ur(kn, t[a >> 2], t[a + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), ps = xr + 320 | 0, Ur(ps, or, gr, 0, 0, or, gr, 0, 0), ks = xr + 96 | 0, Ur(ks, ts, ni, 0, 0, jn, Gn, 0, 0), Wr = d, Un = E, a = d << 1 | E >>> 31, Bs = xr + 176 | 0, Bn = he, gn = T, Ur(Bs, he, T, 0, 0, E << 1, a, 0, 0), Be = t[xr + 304 >> 2], E = t[xr + 224 >> 2], d = Be + E | 0, Ai = t[xr + 308 >> 2], a = Ai + t[xr + 228 >> 2] | 0, a = d >>> 0 < E >>> 0 ? a + 1 | 0 : a, E = t[xr + 144 >> 2], xn = E + d | 0, T = a, a = a + t[xr + 148 >> 2] | 0, cr = E >>> 0 > xn >>> 0 ? a + 1 | 0 : a, Hi = t[xr + 272 >> 2], E = t[xr + 208 >> 2], dr = Hi + E | 0, Xi = t[xr + 276 >> 2], a = Xi + t[xr + 212 >> 2] | 0, a = E >>> 0 > dr >>> 0 ? a + 1 | 0 : a, E = t[xr + 112 >> 2], Ir = E + dr | 0, L = a, a = a + t[xr + 116 >> 2] | 0, a = E >>> 0 > Ir >>> 0 ? a + 1 | 0 : a, E = t[xr + 128 >> 2], or = E + Ir | 0, he = a, a = a + t[xr + 132 >> 2] | 0, E = E >>> 0 > or >>> 0 ? a + 1 | 0 : a, Mr = (T | 0) == (cr | 0) & d >>> 0 > xn >>> 0 | T >>> 0 > cr >>> 0, a = $r + 8 | 0, tr = t[a >> 2], gr = t[a + 4 >> 2], Be = (T | 0) == (Ai | 0) & d >>> 0 < Be >>> 0 | T >>> 0 < Ai >>> 0, a = Xn + 8 | 0, T = t[a >> 2], d = Zn + 8 | 0, $r = T + t[d >> 2] | 0, a = t[d + 4 >> 2] + t[a + 4 >> 2] | 0, a = T >>> 0 > $r >>> 0 ? a + 1 | 0 : a, d = Be + $r | 0, a = (d >>> 0 < $r >>> 0 ? a + 1 | 0 : a) + gr | 0, T = d, d = d + tr | 0, a = T >>> 0 > d >>> 0 ? a + 1 | 0 : a, T = d, d = d + Mr | 0, a = T >>> 0 > d >>> 0 ? a + 1 | 0 : a, $r = cr, cr = d << 12 | cr >>> 20, gr = cr + or | 0, T = a, a = E + (a << 12 | d >>> 20) | 0, cr = gr >>> 0 < cr >>> 0 ? a + 1 | 0 : a, gs = xr + 80 | 0, Ai = gs, Bi = t[xr + 96 >> 2], d = t[xr + 176 >> 2], tr = Bi + d | 0, yi = t[xr + 100 >> 2], a = yi + t[xr + 180 >> 2] | 0, d = d >>> 0 > tr >>> 0 ? a + 1 | 0 : a, Zn = (E | 0) == (cr | 0) & or >>> 0 > gr >>> 0 | E >>> 0 > cr >>> 0, Xn = (E | 0) == (he | 0) & or >>> 0 < Ir >>> 0 | E >>> 0 < he >>> 0, a = kn + 8 | 0, kn = t[a >> 2], Mr = t[a + 4 >> 2], Ir = (L | 0) == (he | 0) & dr >>> 0 > Ir >>> 0 | L >>> 0 > he >>> 0, a = Zi + 8 | 0, or = t[a >> 2], Be = t[a + 4 >> 2], L = (L | 0) == (Xi | 0) & dr >>> 0 < Hi >>> 0 | L >>> 0 < Xi >>> 0, he = wi + 8 | 0, E = t[he >> 2], a = us + 8 | 0, dr = E + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[he + 4 >> 2] | 0, a = E >>> 0 > dr >>> 0 ? a + 1 | 0 : a, E = L + dr | 0, a = (E >>> 0 < dr >>> 0 ? a + 1 | 0 : a) + Be | 0, L = E, E = E + or | 0, a = L >>> 0 > E >>> 0 ? a + 1 | 0 : a, L = E, E = E + Ir | 0, a = (L >>> 0 > E >>> 0 ? a + 1 | 0 : a) + Mr | 0, L = E, E = E + kn | 0, a = L >>> 0 > E >>> 0 ? a + 1 | 0 : a, he = E + Xn | 0, a = he >>> 0 < E >>> 0 ? a + 1 | 0 : a, T = T >>> 20 | 0, E = T + he | 0, a = T >>> 0 > E >>> 0 ? a + 1 | 0 : a, T = E, E = E + Zn | 0, T = T >>> 0 > E >>> 0 ? a + 1 | 0 : a, he = T << 12 | E >>> 20, a = E << 12, E = cr, cr = a | E >>> 20, L = cr + tr | 0, a = d + he | 0, cr = L >>> 0 < cr >>> 0 ? a + 1 | 0 : a, he = L, a = cr << 4 | he >>> 28, Be = he << 4 & -16, L = a & 16777215, Mr = E, Ur(Ai, Be | E >>> 16 & 15, L, 0, 0, 977, 1, 0, 0), Be = xr, Xn = t[Be + 80 >> 2], E = t[Be + 320 >> 2], or = Xn + E | 0, Ti = t[Be + 84 >> 2], a = Ti + t[Be + 324 >> 2] | 0, t[Be + 424 >> 2] = or, L = E >>> 0 > or >>> 0 ? a + 1 | 0 : a, t[Be + 428 >> 2] = L & 1048575, Zi = Be + 256 | 0, Ur(Zi, jn, Gn, 0, 0, ai, Ii, 0, 0), us = Be - -64 | 0, Ur(us, ts, ni, 0, 0, Un, Wr, 0, 0), wi = Be + 288 | 0, Ur(wi, Bn, gn, 0, 0, Bn, gn, 0, 0), Hi = Be + 48 | 0, xr = Hi, Ai = t[Be + 64 >> 2], E = t[Be + 288 >> 2], kn = Ai + E | 0, Xi = t[Be + 68 >> 2], a = Xi + t[Be + 292 >> 2] | 0, E = E >>> 0 > kn >>> 0 ? a + 1 | 0 : a, dr = kn, Ir = (d | 0) == (cr | 0) & he >>> 0 < tr >>> 0 | d >>> 0 > cr >>> 0, tr = (d | 0) == (yi | 0) & tr >>> 0 < Bi >>> 0 | d >>> 0 < yi >>> 0, a = Bs + 8 | 0, he = t[a >> 2], d = ks + 8 | 0, Zn = he + t[d >> 2] | 0, a = t[d + 4 >> 2] + t[a + 4 >> 2] | 0, a = he >>> 0 > Zn >>> 0 ? a + 1 | 0 : a, he = tr + Zn | 0, a = he >>> 0 < Zn >>> 0 ? a + 1 | 0 : a, T = T >>> 20 | 0, d = T + he | 0, a = T >>> 0 > d >>> 0 ? a + 1 | 0 : a, T = d, d = d + Ir | 0, a = T >>> 0 > d >>> 0 ? a + 1 | 0 : a, T = d << 12 | cr >>> 20, dr = T + dr | 0, he = a, a = E + (a << 12 | d >>> 20) | 0, tr = T >>> 0 > dr >>> 0 ? a + 1 | 0 : a, Ur(xr, dr, tr & 1048575, 0, 0, 15632, 16, 0, 0), Zn = t[Be + 48 >> 2], d = t[Be + 256 >> 2], xr = Zn + d | 0, Bi = t[Be + 52 >> 2], a = Bi + t[Be + 260 >> 2] | 0, d = d >>> 0 > xr >>> 0 ? a + 1 | 0 : a, Ir = xr, or = (L | 0) == (Ti | 0) & or >>> 0 < Xn >>> 0 | L >>> 0 < Ti >>> 0, cr = ps + 8 | 0, T = t[cr >> 2], a = gs + 8 | 0, Xn = T + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[cr + 4 >> 2] | 0, a = T >>> 0 > Xn >>> 0 ? a + 1 | 0 : a, T = or + Xn | 0, a = T >>> 0 < Xn >>> 0 ? a + 1 | 0 : a, L = T << 12 | L >>> 20, Ir = L + Ir | 0, cr = a, a = d + (a << 12 | T >>> 20) | 0, t[Be + 432 >> 2] = Ir, or = L >>> 0 > Ir >>> 0 ? a + 1 | 0 : a, t[Be + 436 >> 2] = or & 1048575, Xn = Be + 192 | 0, Ur(Xn, Un, Wr, 0, 0, ai, Ii, 0, 0), ai = Be + 240 | 0, Ur(ai, jn, Gn, 0, 0, jn, Gn, 0, 0), jn = Be + 32 | 0, Ur(jn, ts, ni, 0, 0, Bn, gn, 0, 0), Un = Be + 16 | 0, Wr = Un, dr = (E | 0) == (tr | 0) & dr >>> 0 < kn >>> 0 | E >>> 0 > tr >>> 0, L = (E | 0) == (Xi | 0) & kn >>> 0 < Ai >>> 0 | E >>> 0 < Xi >>> 0, T = wi + 8 | 0, E = t[T >> 2], a = us + 8 | 0, gn = E + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[T + 4 >> 2] | 0, a = E >>> 0 > gn >>> 0 ? a + 1 | 0 : a, T = L + gn | 0, a = T >>> 0 < gn >>> 0 ? a + 1 | 0 : a, he = he >>> 20 | 0, E = T + he | 0, a = he >>> 0 > E >>> 0 ? a + 1 | 0 : a, T = E, E = E + dr | 0, a = T >>> 0 > E >>> 0 ? a + 1 | 0 : a, kn = E << 12 | tr >>> 20, T = t[Be + 32 >> 2], tr = kn + T | 0, L = a, Ii = a << 12 | E >>> 20, a = Ii + t[Be + 36 >> 2] | 0, gn = T >>> 0 > tr >>> 0 ? a + 1 | 0 : a, Ur(Wr, tr, gn, 0, 0, 15632, 16, 0, 0), Gn = t[Be + 192 >> 2], E = t[Be + 240 >> 2], Wr = Gn + E | 0, ni = t[Be + 196 >> 2], a = ni + t[Be + 244 >> 2] | 0, a = E >>> 0 > Wr >>> 0 ? a + 1 | 0 : a, E = t[Be + 16 >> 2], dr = E + Wr | 0, he = a, a = a + t[Be + 20 >> 2] | 0, E = E >>> 0 > dr >>> 0 ? a + 1 | 0 : a, Bn = (d | 0) == (or | 0) & Ir >>> 0 < xr >>> 0 | d >>> 0 > or >>> 0, Ir = (d | 0) == (Bi | 0) & xr >>> 0 < Zn >>> 0 | d >>> 0 < Bi >>> 0, a = Zi + 8 | 0, T = t[a >> 2], d = Hi + 8 | 0, xr = T + t[d >> 2] | 0, a = t[d + 4 >> 2] + t[a + 4 >> 2] | 0, a = T >>> 0 > xr >>> 0 ? a + 1 | 0 : a, T = Ir + xr | 0, a = T >>> 0 < xr >>> 0 ? a + 1 | 0 : a, cr = cr >>> 20 | 0, d = T + cr | 0, a = cr >>> 0 > d >>> 0 ? a + 1 | 0 : a, T = d, d = d + Bn | 0, a = T >>> 0 > d >>> 0 ? a + 1 | 0 : a, cr = d << 12 | or >>> 20, or = cr + dr | 0, T = a, a = E + (a << 12 | d >>> 20) | 0, t[Be + 440 >> 2] = or, cr = or >>> 0 < cr >>> 0 ? a + 1 | 0 : a, t[Be + 444 >> 2] = cr & 1048575, d = Be, Ir = (gn | 0) == (Ii | 0) & tr >>> 0 < kn >>> 0 | gn >>> 0 < Ii >>> 0, a = jn + 8 | 0, tr = t[a >> 2], a = t[a + 4 >> 2], L = L >>> 20 | 0, Be = L, L = L + tr | 0, a = Be >>> 0 > L >>> 0 ? a + 1 | 0 : a, Be = L, L = L + Ir | 0, a = Be >>> 0 > L >>> 0 ? a + 1 | 0 : a, Ur(d, L, a, 0, 0, 64028672, 65536, 0, 0), L = d, gn = t[d >> 2], d = xn & -2, Be = gn + d | 0, Bn = t[L + 4 >> 2], a = Bn + ($r & 1048575) | 0, d = d >>> 0 > Be >>> 0 ? a + 1 | 0 : a, $r = (E | 0) == (cr | 0) & dr >>> 0 > or >>> 0 | E >>> 0 > cr >>> 0, dr = (E | 0) == (he | 0) & dr >>> 0 < Wr >>> 0 | E >>> 0 < he >>> 0, a = Un + 8 | 0, Ir = t[a >> 2], tr = t[a + 4 >> 2], or = (he | 0) == (ni | 0) & Wr >>> 0 < Gn >>> 0 | he >>> 0 < ni >>> 0, he = ai + 8 | 0, E = t[he >> 2], a = Xn + 8 | 0, Wr = E + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[he + 4 >> 2] | 0, a = E >>> 0 > Wr >>> 0 ? a + 1 | 0 : a, E = or + Wr | 0, a = (E >>> 0 < Wr >>> 0 ? a + 1 | 0 : a) + tr | 0, he = E, E = E + Ir | 0, a = he >>> 0 > E >>> 0 ? a + 1 | 0 : a, he = E + dr | 0, a = he >>> 0 < E >>> 0 ? a + 1 | 0 : a, T = T >>> 20 | 0, E = T + he | 0, a = T >>> 0 > E >>> 0 ? a + 1 | 0 : a, T = E, E = E + $r | 0, a = T >>> 0 > E >>> 0 ? a + 1 | 0 : a, cr = E << 12 | cr >>> 20, he = cr + Be | 0, T = a, a = d + (a << 12 | E >>> 20) | 0, t[L + 448 >> 2] = he, E = he >>> 0 < cr >>> 0 ? a + 1 | 0 : a, t[L + 452 >> 2] = E & 1048575, tr = Mr & 65535, or = (d | 0) == (E | 0) & Be >>> 0 > he >>> 0 | d >>> 0 > E >>> 0, cr = (d | 0) == (Bn | 0) & Be >>> 0 < gn >>> 0 | d >>> 0 < Bn >>> 0, d = L + 8 | 0, he = cr + t[d >> 2] | 0, a = t[d + 4 >> 2], a = he >>> 0 < cr >>> 0 ? a + 1 | 0 : a, T = T >>> 20 | 0, d = T + he | 0, a = T >>> 0 > d >>> 0 ? a + 1 | 0 : a, T = d, d = d + or | 0, a = T >>> 0 > d >>> 0 ? a + 1 | 0 : a, E = d << 12 | E >>> 20, T = E + gr | 0, a = tr + (a << 12 | d >>> 20) | 0, t[L + 456 >> 2] = T, t[L + 460 >> 2] = E >>> 0 > T >>> 0 ? a + 1 | 0 : a, d = L + 680 | 0, Wr = L + 424 | 0, cr = fi + 80 | 0, Xr(d, Wr, cr), Xr(I, Oi, Wr), Xr(I + 40 | 0, Oi + 40 | 0, d), E = t[Oi + 120 >> 2], t[I + 80 >> 2] = E, a = I + 8 | 0, d = t[a + 4 >> 2], $r = Wr + 8 | 0, t[$r >> 2] = t[a >> 2], t[$r + 4 >> 2] = d, a = I + 16 | 0, d = t[a + 4 >> 2], Mr = Wr + 16 | 0, t[Mr >> 2] = t[a >> 2], t[Mr + 4 >> 2] = d, a = I + 24 | 0, d = t[a + 4 >> 2], dr = Wr + 24 | 0, t[dr >> 2] = t[a >> 2], t[dr + 4 >> 2] = d, a = I + 32 | 0, d = t[a + 4 >> 2], Ir = Wr + 32 | 0, t[Ir >> 2] = t[a >> 2], t[Ir + 4 >> 2] = d, a = I + 48 | 0, d = t[a + 4 >> 2], tr = Wr + 48 | 0, t[tr >> 2] = t[a >> 2], t[tr + 4 >> 2] = d, a = I + 56 | 0, d = t[a + 4 >> 2], or = Wr + 56 | 0, t[or >> 2] = t[a >> 2], t[or + 4 >> 2] = d, a = I - -64 | 0, d = t[a + 4 >> 2], gr = Wr - -64 | 0, t[gr >> 2] = t[a >> 2], t[gr + 4 >> 2] = d, a = I + 72 | 0, d = t[a + 4 >> 2], Be = Wr + 72 | 0, t[Be >> 2] = t[a >> 2], t[Be + 4 >> 2] = d, t[L + 544 >> 2] = E, d = t[I + 4 >> 2], t[L + 424 >> 2] = t[I >> 2], t[L + 428 >> 2] = d, d = t[I + 44 >> 2], t[L + 464 >> 2] = t[I + 40 >> 2], t[L + 468 >> 2] = d, E = Oi + 112 | 0, a = t[E + 4 >> 2], d = Wr + 112 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = Oi + 104 | 0, a = t[E + 4 >> 2], d = Wr + 104 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = Oi + 96 | 0, a = t[E + 4 >> 2], d = Wr + 96 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = Oi + 88 | 0, a = t[E + 4 >> 2], d = Wr + 88 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, he = t[Oi + 80 >> 2], T = t[Oi + 84 >> 2], d = t[L + 636 >> 2], t[ws >> 2] = t[L + 632 >> 2], t[ws + 4 >> 2] = d, E = fi + 88 | 0, a = t[E + 4 >> 2], d = ws + 8 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = fi + 96 | 0, a = t[E + 4 >> 2], d = ws + 16 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = fi + 104 | 0, a = t[E + 4 >> 2], d = ws + 24 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = fi + 112 | 0, a = t[E + 4 >> 2], d = ws + 32 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, t[L + 504 >> 2] = he, t[L + 508 >> 2] = T, Ei(Wr, Wr, hs, ws + 40 | 0), t[I + 168 >> 2] = 0, d = t[L + 428 >> 2], t[I + 88 >> 2] = t[L + 424 >> 2], t[I + 92 >> 2] = d, a = t[$r + 4 >> 2], d = I + 96 | 0, t[d >> 2] = t[$r >> 2], t[d + 4 >> 2] = a, a = t[Mr + 4 >> 2], d = I + 104 | 0, t[d >> 2] = t[Mr >> 2], t[d + 4 >> 2] = a, a = t[dr + 4 >> 2], d = I + 112 | 0, t[d >> 2] = t[dr >> 2], t[d + 4 >> 2] = a, a = t[Ir + 4 >> 2], d = I + 120 | 0, t[d >> 2] = t[Ir >> 2], t[d + 4 >> 2] = a, a = t[L + 468 >> 2], d = I + 128 | 0, t[d >> 2] = t[L + 464 >> 2], t[d + 4 >> 2] = a, a = t[tr + 4 >> 2], d = I + 136 | 0, t[d >> 2] = t[tr >> 2], t[d + 4 >> 2] = a, a = t[or + 4 >> 2], d = I + 144 | 0, t[d >> 2] = t[or >> 2], t[d + 4 >> 2] = a, a = t[gr + 4 >> 2], d = I + 152 | 0, t[d >> 2] = t[gr >> 2], t[d + 4 >> 2] = a, a = t[Be + 4 >> 2], d = I + 160 | 0, t[d >> 2] = t[Be >> 2], t[d + 4 >> 2] = a, Ei(Wr, Wr, hs, ws + 80 | 0), t[I + 256 >> 2] = 0, d = t[L + 428 >> 2], t[I + 176 >> 2] = t[L + 424 >> 2], t[I + 180 >> 2] = d, a = t[$r + 4 >> 2], d = I + 184 | 0, t[d >> 2] = t[$r >> 2], t[d + 4 >> 2] = a, a = t[Mr + 4 >> 2], d = I + 192 | 0, t[d >> 2] = t[Mr >> 2], t[d + 4 >> 2] = a, a = t[dr + 4 >> 2], d = I + 200 | 0, t[d >> 2] = t[dr >> 2], t[d + 4 >> 2] = a, a = t[Ir + 4 >> 2], d = I + 208 | 0, t[d >> 2] = t[Ir >> 2], t[d + 4 >> 2] = a, a = t[L + 468 >> 2], d = I + 216 | 0, t[d >> 2] = t[L + 464 >> 2], t[d + 4 >> 2] = a, a = t[tr + 4 >> 2], d = I + 224 | 0, t[d >> 2] = t[tr >> 2], t[d + 4 >> 2] = a, a = t[or + 4 >> 2], d = I + 232 | 0, t[d >> 2] = t[or >> 2], t[d + 4 >> 2] = a, a = t[gr + 4 >> 2], d = I + 240 | 0, t[d >> 2] = t[gr >> 2], t[d + 4 >> 2] = a, a = t[Be + 4 >> 2], d = I + 248 | 0, t[d >> 2] = t[Be >> 2], t[d + 4 >> 2] = a, Ei(Wr, Wr, hs, ws + 120 | 0), t[I + 344 >> 2] = 0, d = t[L + 428 >> 2], t[I + 264 >> 2] = t[L + 424 >> 2], t[I + 268 >> 2] = d, a = t[$r + 4 >> 2], d = I + 272 | 0, t[d >> 2] = t[$r >> 2], t[d + 4 >> 2] = a, a = t[Mr + 4 >> 2], d = I + 280 | 0, t[d >> 2] = t[Mr >> 2], t[d + 4 >> 2] = a, a = t[dr + 4 >> 2], d = I + 288 | 0, t[d >> 2] = t[dr >> 2], t[d + 4 >> 2] = a, a = t[Ir + 4 >> 2], d = I + 296 | 0, t[d >> 2] = t[Ir >> 2], t[d + 4 >> 2] = a, a = t[L + 468 >> 2], d = I + 304 | 0, t[d >> 2] = t[L + 464 >> 2], t[d + 4 >> 2] = a, a = t[tr + 4 >> 2], d = I + 312 | 0, t[d >> 2] = t[tr >> 2], t[d + 4 >> 2] = a, a = t[or + 4 >> 2], d = I + 320 | 0, t[d >> 2] = t[or >> 2], t[d + 4 >> 2] = a, a = t[gr + 4 >> 2], d = I + 328 | 0, t[d >> 2] = t[gr >> 2], t[d + 4 >> 2] = a, a = t[Be + 4 >> 2], d = I + 336 | 0, t[d >> 2] = t[Be >> 2], t[d + 4 >> 2] = a, Ei(Wr, Wr, hs, ws + 160 | 0), t[I + 432 >> 2] = 0, d = t[L + 428 >> 2], t[I + 352 >> 2] = t[L + 424 >> 2], t[I + 356 >> 2] = d, a = t[$r + 4 >> 2], d = I + 360 | 0, t[d >> 2] = t[$r >> 2], t[d + 4 >> 2] = a, a = t[Mr + 4 >> 2], d = I + 368 | 0, t[d >> 2] = t[Mr >> 2], t[d + 4 >> 2] = a, a = t[dr + 4 >> 2], d = I + 376 | 0, t[d >> 2] = t[dr >> 2], t[d + 4 >> 2] = a, a = t[Ir + 4 >> 2], d = I + 384 | 0, t[d >> 2] = t[Ir >> 2], t[d + 4 >> 2] = a, a = t[L + 468 >> 2], d = I + 392 | 0, t[d >> 2] = t[L + 464 >> 2], t[d + 4 >> 2] = a, a = t[tr + 4 >> 2], d = I + 400 | 0, t[d >> 2] = t[tr >> 2], t[d + 4 >> 2] = a, a = t[or + 4 >> 2], d = I + 408 | 0, t[d >> 2] = t[or >> 2], t[d + 4 >> 2] = a, a = t[gr + 4 >> 2], d = I + 416 | 0, t[d >> 2] = t[gr >> 2], t[d + 4 >> 2] = a, a = t[Be + 4 >> 2], d = I + 424 | 0, t[d >> 2] = t[Be >> 2], t[d + 4 >> 2] = a, Ei(Wr, Wr, hs, ws + 200 | 0), t[I + 520 >> 2] = 0, d = t[L + 428 >> 2], t[I + 440 >> 2] = t[L + 424 >> 2], t[I + 444 >> 2] = d, a = t[$r + 4 >> 2], d = I + 448 | 0, t[d >> 2] = t[$r >> 2], t[d + 4 >> 2] = a, a = t[Mr + 4 >> 2], d = I + 456 | 0, t[d >> 2] = t[Mr >> 2], t[d + 4 >> 2] = a, a = t[dr + 4 >> 2], d = I + 464 | 0, t[d >> 2] = t[dr >> 2], t[d + 4 >> 2] = a, a = t[Ir + 4 >> 2], d = I + 472 | 0, t[d >> 2] = t[Ir >> 2], t[d + 4 >> 2] = a, a = t[L + 468 >> 2], d = I + 480 | 0, t[d >> 2] = t[L + 464 >> 2], t[d + 4 >> 2] = a, a = t[tr + 4 >> 2], d = I + 488 | 0, t[d >> 2] = t[tr >> 2], t[d + 4 >> 2] = a, a = t[or + 4 >> 2], d = I + 496 | 0, t[d >> 2] = t[or >> 2], t[d + 4 >> 2] = a, a = t[gr + 4 >> 2], d = I + 504 | 0, t[d >> 2] = t[gr >> 2], t[d + 4 >> 2] = a, a = t[Be + 4 >> 2], d = I + 512 | 0, t[d >> 2] = t[Be >> 2], t[d + 4 >> 2] = a, kn = ws + 240 | 0, Ei(Wr, Wr, hs, kn), t[I + 608 >> 2] = 0, d = t[L + 428 >> 2], t[I + 528 >> 2] = t[L + 424 >> 2], t[I + 532 >> 2] = d, a = t[$r + 4 >> 2], d = I + 536 | 0, t[d >> 2] = t[$r >> 2], t[d + 4 >> 2] = a, a = t[Mr + 4 >> 2], d = I + 544 | 0, t[d >> 2] = t[Mr >> 2], t[d + 4 >> 2] = a, a = t[dr + 4 >> 2], d = I + 552 | 0, t[d >> 2] = t[dr >> 2], t[d + 4 >> 2] = a, a = t[Ir + 4 >> 2], d = I + 560 | 0, t[d >> 2] = t[Ir >> 2], t[d + 4 >> 2] = a, a = t[L + 468 >> 2], d = I + 568 | 0, t[d >> 2] = t[L + 464 >> 2], t[d + 4 >> 2] = a, a = t[tr + 4 >> 2], d = I + 576 | 0, t[d >> 2] = t[tr >> 2], t[d + 4 >> 2] = a, a = t[or + 4 >> 2], d = I + 584 | 0, t[d >> 2] = t[or >> 2], t[d + 4 >> 2] = a, a = t[gr + 4 >> 2], d = I + 592 | 0, t[d >> 2] = t[gr >> 2], t[d + 4 >> 2] = a, a = t[Be + 4 >> 2], d = I + 600 | 0, t[d >> 2] = t[Be >> 2], t[d + 4 >> 2] = a, T = ws + 280 | 0, Ei(Wr, Wr, hs, T), t[I + 696 >> 2] = 0, d = t[L + 428 >> 2], t[I + 616 >> 2] = t[L + 424 >> 2], t[I + 620 >> 2] = d, a = t[$r + 4 >> 2], d = I + 624 | 0, t[d >> 2] = t[$r >> 2], t[d + 4 >> 2] = a, a = t[Mr + 4 >> 2], d = I + 632 | 0, t[d >> 2] = t[Mr >> 2], t[d + 4 >> 2] = a, a = t[dr + 4 >> 2], d = I + 640 | 0, t[d >> 2] = t[dr >> 2], t[d + 4 >> 2] = a, a = t[Ir + 4 >> 2], d = I + 648 | 0, t[d >> 2] = t[Ir >> 2], t[d + 4 >> 2] = a, a = t[L + 468 >> 2], d = I + 656 | 0, t[d >> 2] = t[L + 464 >> 2], t[d + 4 >> 2] = a, a = t[tr + 4 >> 2], d = I + 664 | 0, t[d >> 2] = t[tr >> 2], t[d + 4 >> 2] = a, a = t[or + 4 >> 2], d = I + 672 | 0, t[d >> 2] = t[or >> 2], t[d + 4 >> 2] = a, a = t[gr + 4 >> 2], d = I + 680 | 0, t[d >> 2] = t[gr >> 2], t[d + 4 >> 2] = a, a = t[Be + 4 >> 2], d = I + 688 | 0, t[d >> 2] = t[Be >> 2], t[d + 4 >> 2] = a, Xr(zs, Wr + 80 | 0, cr), x = L + 720 | 0, tr = x - 928 | 0, x = tr, he = I + 616 | 0, L = he + 72 | 0, E = t[L >> 2], cr = t[he + 44 >> 2], a = t[he + 40 >> 2], gr = t[L + 4 >> 2], d = pn(gr >>> 16 | 0, 0, 977, 1), Be = a + d | 0, a = cr + Ee | 0, t[he + 40 >> 2] = Be, a = d >>> 0 > Be >>> 0 ? a + 1 | 0 : a, t[he + 44 >> 2] = a & 1048575, or = he + 48 | 0, Be = t[or >> 2], d = a, a = t[or + 4 >> 2], d = d >>> 20 | 0, cr = d, d = d + Be | 0, a = cr >>> 0 > d >>> 0 ? a + 1 | 0 : a, t[or >> 2] = d, t[or + 4 >> 2] = a & 1048575, or = he + 56 | 0, Be = t[or >> 2], d = a, a = t[or + 4 >> 2], d = d >>> 20 | 0, cr = d, d = d + Be | 0, a = cr >>> 0 > d >>> 0 ? a + 1 | 0 : a, t[or >> 2] = d, t[or + 4 >> 2] = a & 1048575, Be = he - -64 | 0, cr = t[Be >> 2], d = a, a = t[Be + 4 >> 2], d = d >>> 20 | 0, he = d, d = d + cr | 0, a = he >>> 0 > d >>> 0 ? a + 1 | 0 : a, t[Be >> 2] = d, t[Be + 4 >> 2] = a & 1048575, he = L, d = a, a = gr & 65535, d = d >>> 20 | 0, L = d, d = d + E | 0, a = L >>> 0 > d >>> 0 ? a + 1 | 0 : a, t[he >> 2] = d, t[he + 4 >> 2] = a, E = T + 8 | 0, a = t[E + 4 >> 2], Xi = tr + 808 | 0, d = Xi + 8 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = T + 16 | 0, a = t[E + 4 >> 2], d = Xi + 16 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = T + 24 | 0, a = t[E + 4 >> 2], d = Xi + 24 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = T + 32 | 0, a = t[E + 4 >> 2], d = Xi + 32 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, d = t[T + 4 >> 2], t[tr + 808 >> 2] = t[T >> 2], t[tr + 812 >> 2] = d, zs = 6, yi = I + 528 | 0, E = yi + 8 | 0, a = t[E + 4 >> 2], Ti = tr + 680 | 0, d = Ti + 8 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = yi + 16 | 0, a = t[E + 4 >> 2], d = Ti + 16 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = yi + 24 | 0, a = t[E + 4 >> 2], d = Ti + 24 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = yi + 32 | 0, a = t[E + 4 >> 2], d = Ti + 32 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = yi + 48 | 0, a = t[E + 4 >> 2], d = Ti + 48 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = yi + 56 | 0, a = t[E + 4 >> 2], d = Ti + 56 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = yi - -64 | 0, a = t[E + 4 >> 2], d = Ti - -64 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = yi + 72 | 0, a = t[E + 4 >> 2], d = Ti + 72 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, d = t[yi + 4 >> 2], t[tr + 680 >> 2] = t[yi >> 2], t[tr + 684 >> 2] = d, d = t[yi + 44 >> 2], t[tr + 720 >> 2] = t[yi + 40 >> 2], t[tr + 724 >> 2] = d, Ir = t[tr + 840 >> 2], L = t[tr + 844 >> 2], E = t[tr + 824 >> 2], cr = t[tr + 828 >> 2], ai = t[tr + 816 >> 2], xr = t[tr + 820 >> 2], he = t[tr + 832 >> 2], T = t[tr + 836 >> 2], or = t[tr + 808 >> 2], gr = t[tr + 812 >> 2], t[tr + 800 >> 2] = 0, Un = tr + 440 | 0, Ii = or << 1, ts = gr << 1 | or >>> 31, Ur(Un, he, T, 0, 0, Ii, ts, 0, 0), xn = tr + 504 | 0, d = cr, cr = ai << 1, Be = xr << 1 | ai >>> 31, Ur(xn, E, d, 0, 0, cr, Be, 0, 0), $r = tr + 632 | 0, a = L, Ur($r, Ir, a, 0, 0, Ir, a, 0, 0), Mr = tr + 616 | 0, Ur(Mr, t[tr + 632 >> 2], t[tr + 636 >> 2], 0, 0, 15632, 16, 0, 0), L = Ir, a = a << 1 | L >>> 31, Zi = tr + 472 | 0, Xn = L << 1, jn = a, Ur(Zi, Xn, a, 0, 0, or, gr, 0, 0), us = tr + 488 | 0, Ur(us, he, T, 0, 0, cr, Be, 0, 0), wi = tr + 568 | 0, Ur(wi, E, d, 0, 0, E, d, 0, 0), Ir = tr + 600 | 0, a = $r + 8 | 0, Ur(Ir, t[a >> 2], t[a + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), ks = tr + 456 | 0, Ur(ks, or, gr, 0, 0, or, gr, 0, 0), Bs = tr + 536 | 0, Ur(Bs, Xn, jn, 0, 0, ai, xr, 0, 0), gn = d, ni = E, a = d << 1 | E >>> 31, gs = tr + 584 | 0, Gn = he, Bn = T, Ur(gs, he, T, 0, 0, E << 1, a, 0, 0), he = t[tr + 440 >> 2], E = t[tr + 504 >> 2], d = he + E | 0, gr = t[tr + 444 >> 2], a = gr + t[tr + 508 >> 2] | 0, a = d >>> 0 < E >>> 0 ? a + 1 | 0 : a, E = t[tr + 616 >> 2], Wr = E + d | 0, T = a, a = a + t[tr + 620 >> 2] | 0, E = E >>> 0 > Wr >>> 0 ? a + 1 | 0 : a, Be = (T | 0) == (E | 0) & d >>> 0 > Wr >>> 0 | E >>> 0 < T >>> 0, a = Mr + 8 | 0, cr = t[a >> 2], L = t[a + 4 >> 2], he = (T | 0) == (gr | 0) & d >>> 0 < he >>> 0 | T >>> 0 < gr >>> 0, a = xn + 8 | 0, T = t[a >> 2], d = Un + 8 | 0, gr = T + t[d >> 2] | 0, a = t[d + 4 >> 2] + t[a + 4 >> 2] | 0, a = T >>> 0 > gr >>> 0 ? a + 1 | 0 : a, d = he + gr | 0, a = (d >>> 0 < gr >>> 0 ? a + 1 | 0 : a) + L | 0, T = d, d = d + cr | 0, a = T >>> 0 > d >>> 0 ? a + 1 | 0 : a, T = d, d = d + Be | 0, a = T >>> 0 > d >>> 0 ? a + 1 | 0 : a, $r = E, cr = d << 12 | E >>> 20, he = a, L = a << 12 | d >>> 20, Hi = t[tr + 488 >> 2], d = t[tr + 568 >> 2], or = Hi + d | 0, Bi = t[tr + 492 >> 2], a = Bi + t[tr + 572 >> 2] | 0, a = d >>> 0 > or >>> 0 ? a + 1 | 0 : a, d = t[tr + 472 >> 2], gr = d + or | 0, T = a, a = a + t[tr + 476 >> 2] | 0, a = d >>> 0 > gr >>> 0 ? a + 1 | 0 : a, d = t[tr + 600 >> 2], Be = d + gr | 0, E = a, a = a + t[tr + 604 >> 2] | 0, d = d >>> 0 > Be >>> 0 ? a + 1 | 0 : a, a = d + L | 0, Ai = tr + 376 | 0, Zn = Ai, cr = Be + cr | 0, L = cr >>> 0 < Be >>> 0 ? a + 1 | 0 : a, Un = (d | 0) == (L | 0) & Be >>> 0 > cr >>> 0 | d >>> 0 > L >>> 0, xn = (d | 0) == (E | 0) & Be >>> 0 < gr >>> 0 | d >>> 0 < E >>> 0, d = Ir + 8 | 0, Mr = t[d >> 2], dr = t[d + 4 >> 2], Ir = (E | 0) == (T | 0) & or >>> 0 > gr >>> 0 | E >>> 0 < T >>> 0, d = Zi + 8 | 0, gr = t[d >> 2], Be = t[d + 4 >> 2], T = (T | 0) == (Bi | 0) & or >>> 0 < Hi >>> 0 | T >>> 0 < Bi >>> 0, a = wi + 8 | 0, E = t[a >> 2], d = us + 8 | 0, or = E + t[d >> 2] | 0, a = t[d + 4 >> 2] + t[a + 4 >> 2] | 0, a = E >>> 0 > or >>> 0 ? a + 1 | 0 : a, d = T + or | 0, a = (d >>> 0 < or >>> 0 ? a + 1 | 0 : a) + Be | 0, E = d, d = d + gr | 0, a = E >>> 0 > d >>> 0 ? a + 1 | 0 : a, E = d, d = d + Ir | 0, a = (E >>> 0 > d >>> 0 ? a + 1 | 0 : a) + dr | 0, E = d, d = d + Mr | 0, a = E >>> 0 > d >>> 0 ? a + 1 | 0 : a, E = d + xn | 0, a = E >>> 0 < d >>> 0 ? a + 1 | 0 : a, T = he >>> 20 | 0, d = E + T | 0, a = T >>> 0 > d >>> 0 ? a + 1 | 0 : a, E = d, d = d + Un | 0, a = E >>> 0 > d >>> 0 ? a + 1 | 0 : a, E = L, L = d << 12 | E >>> 20, T = a, Be = a << 12 | d >>> 20, Un = t[tr + 540 >> 2], a = Un + t[tr + 588 >> 2] | 0, dr = t[tr + 536 >> 2], d = t[tr + 584 >> 2], he = dr + d | 0, or = he, L = he + L | 0, d = d >>> 0 > he >>> 0 ? a + 1 | 0 : a, a = d + Be | 0, gr = L << 4 & -16, he = L >>> 0 < he >>> 0 ? a + 1 | 0 : a, Be = (he << 4 | L >>> 28) & 16777215, Mr = E, Ur(Zn, gr | E >>> 16 & 15, Be, 0, 0, 977, 1, 0, 0), Be = tr, Zn = t[Be + 376 >> 2], E = t[Be + 456 >> 2], gr = Zn + E | 0, ps = t[Be + 380 >> 2], a = ps + t[Be + 460 >> 2] | 0, t[Be + 888 >> 2] = gr, E = E >>> 0 > gr >>> 0 ? a + 1 | 0 : a, t[Be + 892 >> 2] = E & 1048575, Bi = Be + 360 | 0, Ur(Bi, ai, xr, 0, 0, Ii, ts, 0, 0), Zi = Be + 552 | 0, Ur(Zi, Xn, jn, 0, 0, ni, gn, 0, 0), us = Be + 664 | 0, Ur(us, Gn, Bn, 0, 0, Gn, Bn, 0, 0), wi = Be + 424 | 0, xn = wi, Ir = (d | 0) == (he | 0) & L >>> 0 < or >>> 0 | d >>> 0 > he >>> 0, or = (d | 0) == (Un | 0) & dr >>> 0 > or >>> 0 | d >>> 0 < Un >>> 0, a = gs + 8 | 0, L = t[a >> 2], d = Bs + 8 | 0, dr = L + t[d >> 2] | 0, a = t[d + 4 >> 2] + t[a + 4 >> 2] | 0, a = L >>> 0 > dr >>> 0 ? a + 1 | 0 : a, L = dr + or | 0, a = L >>> 0 < dr >>> 0 ? a + 1 | 0 : a, T = T >>> 20 | 0, d = T + L | 0, a = T >>> 0 > d >>> 0 ? a + 1 | 0 : a, T = d, d = d + Ir | 0, a = T >>> 0 > d >>> 0 ? a + 1 | 0 : a, or = d << 12 | he >>> 20, L = a, T = a << 12 | d >>> 20, Hi = t[Be + 552 >> 2], d = t[Be + 664 >> 2], Un = Hi + d | 0, Bs = t[Be + 556 >> 2], a = Bs + t[Be + 668 >> 2] | 0, he = d >>> 0 > Un >>> 0 ? a + 1 | 0 : a, a = he + T | 0, dr = or + Un | 0, a = dr >>> 0 < Un >>> 0 ? a + 1 | 0 : a, or = a, Ur(xn, dr, a & 1048575, 0, 0, 15632, 16, 0, 0), gr = (E | 0) == (ps | 0) & gr >>> 0 < Zn >>> 0 | E >>> 0 < ps >>> 0, a = ks + 8 | 0, T = t[a >> 2], d = Ai + 8 | 0, Ir = T + t[d >> 2] | 0, a = t[d + 4 >> 2] + t[a + 4 >> 2] | 0, a = T >>> 0 > Ir >>> 0 ? a + 1 | 0 : a, d = gr + Ir | 0, a = d >>> 0 < Ir >>> 0 ? a + 1 | 0 : a, Ir = d << 12 | E >>> 20, T = a, gr = a << 12 | d >>> 20, Ai = t[Be + 424 >> 2], d = t[Be + 360 >> 2], xn = Ai + d | 0, gs = t[Be + 428 >> 2], a = gs + t[Be + 364 >> 2] | 0, E = d >>> 0 > xn >>> 0 ? a + 1 | 0 : a, a = E + gr | 0, Ir = Ir + xn | 0, a = Ir >>> 0 < xn >>> 0 ? a + 1 | 0 : a, t[Be + 896 >> 2] = Ir, gr = a, t[Be + 900 >> 2] = a & 1048575, Zn = Be + 344 | 0, Ur(Zn, ni, gn, 0, 0, Ii, ts, 0, 0), Ii = Be + 520 | 0, Ur(Ii, ai, xr, 0, 0, ai, xr, 0, 0), ai = Be + 648 | 0, Ur(ai, Xn, jn, 0, 0, Gn, Bn, 0, 0), ni = Be + 408 | 0, Gn = ni, gn = (he | 0) == (or | 0) & dr >>> 0 < Un >>> 0 | he >>> 0 > or >>> 0, dr = (he | 0) == (Bs | 0) & Un >>> 0 < Hi >>> 0 | he >>> 0 < Bs >>> 0, a = us + 8 | 0, he = t[a >> 2], d = Zi + 8 | 0, Bn = he + t[d >> 2] | 0, a = t[d + 4 >> 2] + t[a + 4 >> 2] | 0, a = he >>> 0 > Bn >>> 0 ? a + 1 | 0 : a, he = dr + Bn | 0, a = he >>> 0 < Bn >>> 0 ? a + 1 | 0 : a, L = L >>> 20 | 0, d = L + he | 0, a = L >>> 0 > d >>> 0 ? a + 1 | 0 : a, L = d, d = d + gn | 0, a = L >>> 0 > d >>> 0 ? a + 1 | 0 : a, Bn = d << 12 | or >>> 20, L = t[Be + 648 >> 2], or = Bn + L | 0, he = a, Un = a << 12 | d >>> 20, a = Un + t[Be + 652 >> 2] | 0, gn = L >>> 0 > or >>> 0 ? a + 1 | 0 : a, Ur(Gn, or, gn, 0, 0, 15632, 16, 0, 0), L = Be, Ir = (E | 0) == (gr | 0) & Ir >>> 0 < xn >>> 0 | E >>> 0 > gr >>> 0, Be = (E | 0) == (gs | 0) & xn >>> 0 < Ai >>> 0 | E >>> 0 < gs >>> 0, a = Bi + 8 | 0, E = t[a >> 2], d = wi + 8 | 0, dr = E + t[d >> 2] | 0, a = t[d + 4 >> 2] + t[a + 4 >> 2] | 0, a = E >>> 0 > dr >>> 0 ? a + 1 | 0 : a, E = Be + dr | 0, a = E >>> 0 < dr >>> 0 ? a + 1 | 0 : a, T = T >>> 20 | 0, d = E + T | 0, a = T >>> 0 > d >>> 0 ? a + 1 | 0 : a, E = d, d = d + Ir | 0, a = E >>> 0 > d >>> 0 ? a + 1 | 0 : a, gr = d << 12 | gr >>> 20, T = a, Be = a << 12 | d >>> 20, xr = t[L + 344 >> 2], d = t[L + 520 >> 2], dr = xr + d | 0, xn = t[L + 348 >> 2], a = xn + t[L + 524 >> 2] | 0, a = d >>> 0 > dr >>> 0 ? a + 1 | 0 : a, d = t[L + 408 >> 2], Ir = d + dr | 0, E = a, a = a + t[L + 412 >> 2] | 0, d = d >>> 0 > Ir >>> 0 ? a + 1 | 0 : a, a = d + Be | 0, gr = gr + Ir | 0, a = gr >>> 0 < Ir >>> 0 ? a + 1 | 0 : a, t[L + 904 >> 2] = gr, Be = a, t[L + 908 >> 2] = a & 1048575, Gn = L + 392 | 0, Bn = (gn | 0) == (Un | 0) & or >>> 0 < Bn >>> 0 | gn >>> 0 < Un >>> 0, a = ai + 8 | 0, gn = t[a >> 2], a = t[a + 4 >> 2], he = he >>> 20 | 0, or = he, he = he + gn | 0, a = or >>> 0 > he >>> 0 ? a + 1 | 0 : a, or = he, he = he + Bn | 0, a = or >>> 0 > he >>> 0 ? a + 1 | 0 : a, Ur(Gn, he, a, 0, 0, 64028672, 65536, 0, 0), he = L, gn = (d | 0) == (Be | 0) & gr >>> 0 < Ir >>> 0 | d >>> 0 > Be >>> 0, Ir = (d | 0) == (E | 0) & dr >>> 0 > Ir >>> 0 | d >>> 0 < E >>> 0, d = ni + 8 | 0, or = t[d >> 2], gr = t[d + 4 >> 2], L = (E | 0) == (xn | 0) & dr >>> 0 < xr >>> 0 | E >>> 0 < xn >>> 0, a = Ii + 8 | 0, E = t[a >> 2], d = Zn + 8 | 0, dr = E + t[d >> 2] | 0, a = t[d + 4 >> 2] + t[a + 4 >> 2] | 0, a = E >>> 0 > dr >>> 0 ? a + 1 | 0 : a, d = L + dr | 0, a = (d >>> 0 < dr >>> 0 ? a + 1 | 0 : a) + gr | 0, E = d, d = d + or | 0, a = E >>> 0 > d >>> 0 ? a + 1 | 0 : a, E = d + Ir | 0, a = E >>> 0 < d >>> 0 ? a + 1 | 0 : a, T = T >>> 20 | 0, d = E + T | 0, a = T >>> 0 > d >>> 0 ? a + 1 | 0 : a, E = d, d = d + gn | 0, a = E >>> 0 > d >>> 0 ? a + 1 | 0 : a, L = d << 12 | Be >>> 20, T = a, gr = a << 12 | d >>> 20, Ir = t[he + 396 >> 2], a = Ir + ($r & 1048575) | 0, or = t[he + 392 >> 2], E = Wr & -2, d = or + E | 0, Be = d, L = d + L | 0, E = d >>> 0 < E >>> 0 ? a + 1 | 0 : a, a = E + gr | 0, t[he + 912 >> 2] = L, d = d >>> 0 > L >>> 0 ? a + 1 | 0 : a, t[he + 916 >> 2] = d & 1048575, gr = Mr & 65535, L = (d | 0) == (E | 0) & Be >>> 0 > L >>> 0 | d >>> 0 < E >>> 0, E = (E | 0) == (Ir | 0) & Be >>> 0 < or >>> 0 | E >>> 0 < Ir >>> 0, a = Gn + 8 | 0, he = E + t[a >> 2] | 0, a = t[a + 4 >> 2], a = E >>> 0 > he >>> 0 ? a + 1 | 0 : a, T = T >>> 20 | 0, E = T + he | 0, a = T >>> 0 > E >>> 0 ? a + 1 | 0 : a, T = E, E = E + L | 0, a = T >>> 0 > E >>> 0 ? a + 1 | 0 : a, d = E << 12 | d >>> 20, T = d + cr | 0, a = gr + (a << 12 | E >>> 20) | 0, t[tr + 920 >> 2] = T, t[tr + 924 >> 2] = d >>> 0 > T >>> 0 ? a + 1 | 0 : a, a = tr + 848 | 0, d = tr + 888 | 0, Xr(a, d, Xi), Xr(yi, Ti, d), Oi = Ti + 40 | 0, Xr(yi + 40 | 0, Oi, a), t[yi + 80 >> 2] = 0, Ii = kn, fi = I + 440 | 0; ps = tr + 808 | 0, Xr(ps, ps, Ii), E = fi + 32 | 0, a = t[E + 4 >> 2], yi = tr + 680 | 0, d = yi + 32 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = fi + 24 | 0, a = t[E + 4 >> 2], d = yi + 24 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = fi + 16 | 0, a = t[E + 4 >> 2], d = yi + 16 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = fi + 8 | 0, a = t[E + 4 >> 2], d = yi + 8 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, ks = fi + 40 | 0, d = t[ks + 4 >> 2], t[Oi >> 2] = t[ks >> 2], t[Oi + 4 >> 2] = d, E = fi + 48 | 0, a = t[E + 4 >> 2], d = Oi + 8 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = fi + 56 | 0, a = t[E + 4 >> 2], d = Oi + 16 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = fi - -64 | 0, a = t[E + 4 >> 2], d = Oi + 24 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = fi + 72 | 0, a = t[E + 4 >> 2], d = Oi + 32 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, d = t[fi + 4 >> 2], t[tr + 680 >> 2] = t[fi >> 2], t[tr + 684 >> 2] = d, t[tr + 800 >> 2] = 0, d = t[tr + 812 >> 2], Mr = d, dr = t[tr + 808 >> 2], L = dr, a = d << 1 | L >>> 31, or = tr + 72 | 0, Gn = t[tr + 832 >> 2], Bn = t[tr + 836 >> 2], Un = L << 1, ni = a, Ur(or, Gn, Bn, 0, 0, Un, a, 0, 0), d = t[tr + 820 >> 2], Ti = d, Xi = t[tr + 816 >> 2], E = Xi, a = d << 1 | E >>> 31, gr = tr + 280 | 0, kn = t[tr + 824 >> 2], gn = t[tr + 828 >> 2], E = E << 1, T = a, Ur(gr, kn, gn, 0, 0, E, a, 0, 0), Be = tr + 232 | 0, he = t[tr + 840 >> 2], d = t[tr + 844 >> 2], Ur(Be, he, d, 0, 0, he, d, 0, 0), cr = tr + 216 | 0, Ur(cr, t[tr + 232 >> 2], t[tr + 236 >> 2], 0, 0, 15632, 16, 0, 0), a = d << 1 | he >>> 31, wi = tr + 184 | 0, ai = he << 1, xn = a, Ur(wi, ai, a, 0, 0, L, Mr, 0, 0), Hi = tr + 88 | 0, Ur(Hi, Gn, Bn, 0, 0, E, T, 0, 0), Ai = tr + 264 | 0, Ur(Ai, kn, gn, 0, 0, kn, gn, 0, 0), Ir = tr + 200 | 0, d = Be + 8 | 0, Ur(Ir, t[d >> 2], t[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), gs = tr + 328 | 0, Ur(gs, L, Mr, 0, 0, L, Mr, 0, 0), Bi = tr + 168 | 0, Ur(Bi, ai, a, 0, 0, Xi, Ti, 0, 0), Zi = tr + 104 | 0, Ur(Zi, Gn, Bn, 0, 0, kn << 1, gn << 1 | kn >>> 31, 0, 0), he = t[tr + 72 >> 2], E = t[tr + 280 >> 2], d = he + E | 0, dr = t[tr + 76 >> 2], a = dr + t[tr + 284 >> 2] | 0, a = d >>> 0 < E >>> 0 ? a + 1 | 0 : a, E = t[tr + 216 >> 2], Wr = E + d | 0, T = a, a = a + t[tr + 220 >> 2] | 0, E = E >>> 0 > Wr >>> 0 ? a + 1 | 0 : a, Be = (T | 0) == (E | 0) & d >>> 0 > Wr >>> 0 | E >>> 0 < T >>> 0, a = cr + 8 | 0, cr = t[a >> 2], L = t[a + 4 >> 2], he = (T | 0) == (dr | 0) & d >>> 0 < he >>> 0 | T >>> 0 < dr >>> 0, a = gr + 8 | 0, T = t[a >> 2], d = or + 8 | 0, gr = T + t[d >> 2] | 0, a = t[d + 4 >> 2] + t[a + 4 >> 2] | 0, a = T >>> 0 > gr >>> 0 ? a + 1 | 0 : a, d = he + gr | 0, a = (d >>> 0 < gr >>> 0 ? a + 1 | 0 : a) + L | 0, T = d, d = d + cr | 0, a = T >>> 0 > d >>> 0 ? a + 1 | 0 : a, T = d, d = d + Be | 0, a = T >>> 0 > d >>> 0 ? a + 1 | 0 : a, $r = E, cr = d << 12 | E >>> 20, he = a, L = a << 12 | d >>> 20, Zn = t[tr + 88 >> 2], d = t[tr + 264 >> 2], or = Zn + d | 0, us = t[tr + 92 >> 2], a = us + t[tr + 268 >> 2] | 0, a = d >>> 0 > or >>> 0 ? a + 1 | 0 : a, d = t[tr + 184 >> 2], gr = d + or | 0, T = a, a = a + t[tr + 188 >> 2] | 0, a = d >>> 0 > gr >>> 0 ? a + 1 | 0 : a, d = t[tr + 200 >> 2], Be = d + gr | 0, E = a, a = a + t[tr + 204 >> 2] | 0, d = d >>> 0 > Be >>> 0 ? a + 1 | 0 : a, a = d + L | 0, Xn = tr + 8 | 0, cr = Be + cr | 0, L = cr >>> 0 < Be >>> 0 ? a + 1 | 0 : a, jn = (d | 0) == (L | 0) & Be >>> 0 > cr >>> 0 | d >>> 0 > L >>> 0, xr = (d | 0) == (E | 0) & Be >>> 0 < gr >>> 0 | d >>> 0 < E >>> 0, d = Ir + 8 | 0, Mr = t[d >> 2], dr = t[d + 4 >> 2], Ir = (E | 0) == (T | 0) & or >>> 0 > gr >>> 0 | E >>> 0 < T >>> 0, d = wi + 8 | 0, gr = t[d >> 2], Be = t[d + 4 >> 2], T = (T | 0) == (us | 0) & or >>> 0 < Zn >>> 0 | T >>> 0 < us >>> 0, a = Ai + 8 | 0, E = t[a >> 2], d = Hi + 8 | 0, or = E + t[d >> 2] | 0, a = t[d + 4 >> 2] + t[a + 4 >> 2] | 0, a = E >>> 0 > or >>> 0 ? a + 1 | 0 : a, d = T + or | 0, a = (d >>> 0 < or >>> 0 ? a + 1 | 0 : a) + Be | 0, E = d, d = d + gr | 0, a = E >>> 0 > d >>> 0 ? a + 1 | 0 : a, E = d, d = d + Ir | 0, a = (E >>> 0 > d >>> 0 ? a + 1 | 0 : a) + dr | 0, E = d, d = d + Mr | 0, a = E >>> 0 > d >>> 0 ? a + 1 | 0 : a, E = d + xr | 0, a = E >>> 0 < d >>> 0 ? a + 1 | 0 : a, T = he >>> 20 | 0, d = E + T | 0, a = T >>> 0 > d >>> 0 ? a + 1 | 0 : a, E = d, d = d + jn | 0, a = E >>> 0 > d >>> 0 ? a + 1 | 0 : a, E = L, L = d << 12 | E >>> 20, T = a, Be = a << 12 | d >>> 20, jn = t[tr + 172 >> 2], a = jn + t[tr + 108 >> 2] | 0, dr = t[tr + 168 >> 2], d = t[tr + 104 >> 2], he = dr + d | 0, or = he, L = he + L | 0, d = d >>> 0 > he >>> 0 ? a + 1 | 0 : a, a = d + Be | 0, gr = L << 4 & -16, he = L >>> 0 < he >>> 0 ? a + 1 | 0 : a, Be = (he << 4 | L >>> 28) & 16777215, Mr = E, Ur(Xn, gr | E >>> 16 & 15, Be, 0, 0, 977, 1, 0, 0), Be = tr, ts = t[Be + 8 >> 2], E = t[Be + 328 >> 2], gr = ts + E | 0, Bs = t[Be + 12 >> 2], a = Bs + t[Be + 332 >> 2] | 0, t[Be + 888 >> 2] = gr, E = E >>> 0 > gr >>> 0 ? a + 1 | 0 : a, t[Be + 892 >> 2] = E & 1048575, us = Be + 312 | 0, Ur(us, Xi, Ti, 0, 0, Un, ni, 0, 0), wi = Be + 152 | 0, Ur(wi, ai, xn, 0, 0, kn, gn, 0, 0), Hi = Be + 120 | 0, Ur(Hi, Gn, Bn, 0, 0, Gn, Bn, 0, 0), Ai = Be + 56 | 0, xr = Ai, Ir = (d | 0) == (he | 0) & L >>> 0 < or >>> 0 | d >>> 0 > he >>> 0, or = (d | 0) == (jn | 0) & dr >>> 0 > or >>> 0 | d >>> 0 < jn >>> 0, a = Zi + 8 | 0, L = t[a >> 2], d = Bi + 8 | 0, dr = L + t[d >> 2] | 0, a = t[d + 4 >> 2] + t[a + 4 >> 2] | 0, a = L >>> 0 > dr >>> 0 ? a + 1 | 0 : a, L = dr + or | 0, a = L >>> 0 < dr >>> 0 ? a + 1 | 0 : a, T = T >>> 20 | 0, d = T + L | 0, a = T >>> 0 > d >>> 0 ? a + 1 | 0 : a, T = d, d = d + Ir | 0, a = T >>> 0 > d >>> 0 ? a + 1 | 0 : a, Ir = d << 12 | he >>> 20, L = a, or = a << 12 | d >>> 20, Bi = t[Be + 156 >> 2], a = Bi + t[Be + 124 >> 2] | 0, Zn = t[Be + 152 >> 2], T = t[Be + 120 >> 2], d = Zn + T | 0, jn = d, dr = d + Ir | 0, he = d >>> 0 < T >>> 0 ? a + 1 | 0 : a, a = he + or | 0, or = dr >>> 0 < d >>> 0 ? a + 1 | 0 : a, Ur(xr, dr, or & 1048575, 0, 0, 15632, 16, 0, 0), gr = (E | 0) == (Bs | 0) & gr >>> 0 < ts >>> 0 | E >>> 0 < Bs >>> 0, a = gs + 8 | 0, T = t[a >> 2], d = Xn + 8 | 0, Ir = T + t[d >> 2] | 0, a = t[d + 4 >> 2] + t[a + 4 >> 2] | 0, a = T >>> 0 > Ir >>> 0 ? a + 1 | 0 : a, d = gr + Ir | 0, a = d >>> 0 < Ir >>> 0 ? a + 1 | 0 : a, Ir = d << 12 | E >>> 20, T = a, gr = a << 12 | d >>> 20, Xn = t[Be + 56 >> 2], d = t[Be + 312 >> 2], xr = Xn + d | 0, Zi = t[Be + 60 >> 2], a = Zi + t[Be + 316 >> 2] | 0, E = d >>> 0 > xr >>> 0 ? a + 1 | 0 : a, a = E + gr | 0, Ir = Ir + xr | 0, a = Ir >>> 0 < xr >>> 0 ? a + 1 | 0 : a, t[Be + 896 >> 2] = Ir, gr = a, t[Be + 900 >> 2] = a & 1048575, ts = Be + 248 | 0, Ur(ts, kn, gn, 0, 0, Un, ni, 0, 0), ni = Be + 296 | 0, Ur(ni, Xi, Ti, 0, 0, Xi, Ti, 0, 0), Un = Be + 136 | 0, Ur(Un, ai, xn, 0, 0, Gn, Bn, 0, 0), kn = Be + 40 | 0, gn = (he | 0) == (or | 0) & dr >>> 0 < jn >>> 0 | he >>> 0 > or >>> 0, dr = (he | 0) == (Bi | 0) & jn >>> 0 < Zn >>> 0 | he >>> 0 < Bi >>> 0, a = Hi + 8 | 0, he = t[a >> 2], d = wi + 8 | 0, Bn = he + t[d >> 2] | 0, a = t[d + 4 >> 2] + t[a + 4 >> 2] | 0, a = he >>> 0 > Bn >>> 0 ? a + 1 | 0 : a, he = dr + Bn | 0, a = he >>> 0 < Bn >>> 0 ? a + 1 | 0 : a, L = L >>> 20 | 0, d = L + he | 0, a = L >>> 0 > d >>> 0 ? a + 1 | 0 : a, L = d, d = d + gn | 0, a = L >>> 0 > d >>> 0 ? a + 1 | 0 : a, Bn = d << 12 | or >>> 20, L = t[Be + 136 >> 2], or = Bn + L | 0, he = a, jn = a << 12 | d >>> 20, a = jn + t[Be + 140 >> 2] | 0, gn = L >>> 0 > or >>> 0 ? a + 1 | 0 : a, Ur(kn, or, gn, 0, 0, 15632, 16, 0, 0), L = Be, Ir = (E | 0) == (gr | 0) & Ir >>> 0 < xr >>> 0 | E >>> 0 > gr >>> 0, Be = (E | 0) == (Zi | 0) & xr >>> 0 < Xn >>> 0 | E >>> 0 < Zi >>> 0, a = us + 8 | 0, E = t[a >> 2], d = Ai + 8 | 0, dr = E + t[d >> 2] | 0, a = t[d + 4 >> 2] + t[a + 4 >> 2] | 0, a = E >>> 0 > dr >>> 0 ? a + 1 | 0 : a, E = Be + dr | 0, a = E >>> 0 < dr >>> 0 ? a + 1 | 0 : a, T = T >>> 20 | 0, d = E + T | 0, a = T >>> 0 > d >>> 0 ? a + 1 | 0 : a, E = d, d = d + Ir | 0, a = E >>> 0 > d >>> 0 ? a + 1 | 0 : a, gr = d << 12 | gr >>> 20, T = a, Be = a << 12 | d >>> 20, xr = t[L + 248 >> 2], d = t[L + 296 >> 2], dr = xr + d | 0, xn = t[L + 252 >> 2], a = xn + t[L + 300 >> 2] | 0, a = d >>> 0 > dr >>> 0 ? a + 1 | 0 : a, d = t[L + 40 >> 2], Ir = d + dr | 0, E = a, a = a + t[L + 44 >> 2] | 0, d = d >>> 0 > Ir >>> 0 ? a + 1 | 0 : a, a = d + Be | 0, gr = gr + Ir | 0, a = gr >>> 0 < Ir >>> 0 ? a + 1 | 0 : a, t[L + 904 >> 2] = gr, Be = a, t[L + 908 >> 2] = a & 1048575, Gn = L + 24 | 0, Bn = (gn | 0) == (jn | 0) & or >>> 0 < Bn >>> 0 | gn >>> 0 < jn >>> 0, a = Un + 8 | 0, gn = t[a >> 2], a = t[a + 4 >> 2], he = he >>> 20 | 0, or = he, he = he + gn | 0, a = or >>> 0 > he >>> 0 ? a + 1 | 0 : a, or = he, he = he + Bn | 0, a = or >>> 0 > he >>> 0 ? a + 1 | 0 : a, Ur(Gn, he, a, 0, 0, 64028672, 65536, 0, 0), he = L, gn = (d | 0) == (Be | 0) & gr >>> 0 < Ir >>> 0 | d >>> 0 > Be >>> 0, Ir = (d | 0) == (E | 0) & dr >>> 0 > Ir >>> 0 | d >>> 0 < E >>> 0, d = kn + 8 | 0, or = t[d >> 2], gr = t[d + 4 >> 2], L = (E | 0) == (xn | 0) & dr >>> 0 < xr >>> 0 | E >>> 0 < xn >>> 0, a = ni + 8 | 0, E = t[a >> 2], d = ts + 8 | 0, dr = E + t[d >> 2] | 0, a = t[d + 4 >> 2] + t[a + 4 >> 2] | 0, a = E >>> 0 > dr >>> 0 ? a + 1 | 0 : a, d = L + dr | 0, a = (d >>> 0 < dr >>> 0 ? a + 1 | 0 : a) + gr | 0, E = d, d = d + or | 0, a = E >>> 0 > d >>> 0 ? a + 1 | 0 : a, E = d + Ir | 0, a = E >>> 0 < d >>> 0 ? a + 1 | 0 : a, T = T >>> 20 | 0, d = E + T | 0, a = T >>> 0 > d >>> 0 ? a + 1 | 0 : a, E = d, d = d + gn | 0, a = E >>> 0 > d >>> 0 ? a + 1 | 0 : a, gr = d << 12 | Be >>> 20, T = a, L = a << 12 | d >>> 20, or = t[he + 24 >> 2], d = Wr & -2, Be = or + d | 0, Ir = t[he + 28 >> 2], a = Ir + ($r & 1048575) | 0, E = d >>> 0 > Be >>> 0 ? a + 1 | 0 : a, a = E + L | 0, L = Be + gr | 0, a = L >>> 0 < Be >>> 0 ? a + 1 | 0 : a, t[he + 912 >> 2] = L, d = a, t[he + 916 >> 2] = a & 1048575, gr = Mr & 65535, L = (a | 0) == (E | 0) & Be >>> 0 > L >>> 0 | a >>> 0 < E >>> 0, E = (E | 0) == (Ir | 0) & Be >>> 0 < or >>> 0 | E >>> 0 < Ir >>> 0, a = Gn + 8 | 0, he = E + t[a >> 2] | 0, a = t[a + 4 >> 2], a = E >>> 0 > he >>> 0 ? a + 1 | 0 : a, T = T >>> 20 | 0, E = T + he | 0, a = T >>> 0 > E >>> 0 ? a + 1 | 0 : a, T = E, E = E + L | 0, a = T >>> 0 > E >>> 0 ? a + 1 | 0 : a, d = E << 12 | d >>> 20, T = d + cr | 0, a = gr + (a << 12 | E >>> 20) | 0, t[tr + 920 >> 2] = T, t[tr + 924 >> 2] = d >>> 0 > T >>> 0 ? a + 1 | 0 : a, a = tr + 848 | 0, d = tr + 888 | 0, Xr(a, d, ps), Xr(fi, yi, d), Xr(ks, Oi, a), t[fi + 80 >> 2] = 0, fi = fi - 88 | 0, Ii = Ii - 40 | 0, zs = zs - 1 | 0, !!zs; )
        ;
      for (x = tr + 928 | 0, d = 0, fi = (Gs | 0) > 0 ? Gs : 0; Hi = Me - -64 | 0, to = t[I >> 2], ro = t[I + 4 >> 2], Ur(Hi, to, ro, 0, 0, -431719958, 28934, 0, 0), Ai = Me + 416 | 0, a = I + 8 | 0, $s = t[a >> 2], Xs = t[a + 4 >> 2], Ur(Ai, $s, Xs, 0, 0, -375590839, 799796, 0, 0), Zn = Me + 336 | 0, a = I + 16 | 0, Ao = t[a >> 2], co = t[a + 4 >> 2], Ur(Zn, Ao, co, 0, 0, 1486445587, 479535, 0, 0), Gn = Me + 256 | 0, a = I + 24 | 0, Co = t[a >> 2], wo = t[a + 4 >> 2], Ur(Gn, Co, wo, 0, 0, 1905590766, 617512, 0, 0), E = Me + 176 | 0, a = I + 32 | 0, fo = t[a >> 2], hs = t[a + 4 >> 2], Ur(E, fo, hs, 0, 0, 1781228924, 31465, 0, 0), Wr = Me + 160 | 0, Ur(Wr, t[Me + 176 >> 2] & -4, t[Me + 180 >> 2], 0, 0, 15632, 16, 0, 0), yi = Me + 80 | 0, Ur(yi, to, ro, 0, 0, 1781228924, 31465, 0, 0), zs = Me + 432 | 0, Ur(zs, $s, Xs, 0, 0, -431719958, 28934, 0, 0), ps = Me + 352 | 0, Ur(ps, Ao, co, 0, 0, -375590839, 799796, 0, 0), ks = Me + 272 | 0, Ur(ks, Co, wo, 0, 0, 1486445587, 479535, 0, 0), Bs = Me + 192 | 0, Ur(Bs, fo, hs, 0, 0, 1905590766, 617512, 0, 0), Xn = Me + 144 | 0, a = E + 8 | 0, Ur(Xn, t[a >> 2], t[a + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ti = Me + 96 | 0, Ur(Ti, to, ro, 0, 0, 1905590766, 617512, 0, 0), Xi = Me + 448 | 0, Ur(Xi, $s, Xs, 0, 0, 1781228924, 31465, 0, 0), gs = Me + 368 | 0, Ur(gs, Ao, co, 0, 0, -431719958, 28934, 0, 0), Bi = Me + 288 | 0, Ur(Bi, Co, wo, 0, 0, -375590839, 799796, 0, 0), Zi = Me + 208 | 0, Ur(Zi, fo, hs, 0, 0, 1486445587, 479535, 0, 0), us = t[Me + 432 >> 2], E = t[Me + 80 >> 2], kn = us + E | 0, Gs = t[Me + 436 >> 2], a = Gs + t[Me + 84 >> 2] | 0, a = E >>> 0 > kn >>> 0 ? a + 1 | 0 : a, E = t[Me + 352 >> 2], Bn = E + kn | 0, xn = a, a = a + t[Me + 356 >> 2] | 0, a = E >>> 0 > Bn >>> 0 ? a + 1 | 0 : a, E = t[Me + 272 >> 2], gn = E + Bn | 0, or = a, a = a + t[Me + 276 >> 2] | 0, a = E >>> 0 > gn >>> 0 ? a + 1 | 0 : a, E = t[Me + 192 >> 2], $r = E + gn | 0, gr = a, a = a + t[Me + 196 >> 2] | 0, a = E >>> 0 > $r >>> 0 ? a + 1 | 0 : a, E = t[Me + 144 >> 2], Mr = E + $r | 0, Be = a, a = a + t[Me + 148 >> 2] | 0, T = E >>> 0 > Mr >>> 0 ? a + 1 | 0 : a, ts = t[Me + 416 >> 2], E = t[Me + 64 >> 2], dr = ts + E | 0, wi = t[Me + 420 >> 2], a = wi + t[Me + 68 >> 2] | 0, a = E >>> 0 > dr >>> 0 ? a + 1 | 0 : a, E = t[Me + 336 >> 2], Ir = E + dr | 0, L = a, a = a + t[Me + 340 >> 2] | 0, he = E >>> 0 > Ir >>> 0 ? a + 1 | 0 : a, a = he + t[Me + 260 >> 2] | 0, E = t[Me + 256 >> 2], tr = E + Ir | 0, cr = t[Me + 160 >> 2], ni = tr + cr | 0, E = E >>> 0 > tr >>> 0 ? a + 1 | 0 : a, a = E + t[Me + 164 >> 2] | 0, cr = cr >>> 0 > ni >>> 0 ? a + 1 | 0 : a, Ii = (E | 0) == (cr | 0) & tr >>> 0 > ni >>> 0 | E >>> 0 > cr >>> 0, a = Wr + 8 | 0, ai = t[a >> 2], jn = t[a + 4 >> 2], Un = (E | 0) == (he | 0) & tr >>> 0 < Ir >>> 0 | E >>> 0 < he >>> 0, a = Gn + 8 | 0, xr = t[a >> 2], Gn = t[a + 4 >> 2], Wr = (L | 0) == (he | 0) & dr >>> 0 > Ir >>> 0 | L >>> 0 > he >>> 0, a = Zn + 8 | 0, Ir = t[a >> 2], tr = t[a + 4 >> 2], L = (L | 0) == (wi | 0) & dr >>> 0 < ts >>> 0 | L >>> 0 < wi >>> 0, he = Hi + 8 | 0, E = t[he >> 2], a = Ai + 8 | 0, dr = E + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[he + 4 >> 2] | 0, a = E >>> 0 > dr >>> 0 ? a + 1 | 0 : a, E = L + dr | 0, a = (E >>> 0 < dr >>> 0 ? a + 1 | 0 : a) + tr | 0, L = E, E = E + Ir | 0, a = L >>> 0 > E >>> 0 ? a + 1 | 0 : a, L = E, E = E + Wr | 0, a = (L >>> 0 > E >>> 0 ? a + 1 | 0 : a) + Gn | 0, L = E, E = E + xr | 0, a = L >>> 0 > E >>> 0 ? a + 1 | 0 : a, L = E, E = E + Un | 0, a = (L >>> 0 > E >>> 0 ? a + 1 | 0 : a) + jn | 0, L = E, E = E + ai | 0, a = L >>> 0 > E >>> 0 ? a + 1 | 0 : a, L = E, E = E + Ii | 0, a = L >>> 0 > E >>> 0 ? a + 1 | 0 : a, Wr = cr, L = E << 12 | cr >>> 20, tr = L + Mr | 0, he = a, a = T + (a << 12 | E >>> 20) | 0, Ir = L >>> 0 > tr >>> 0 ? a + 1 | 0 : a, wi = t[Me + 368 >> 2], E = t[Me + 448 >> 2], xr = wi + E | 0, Oi = t[Me + 372 >> 2], a = Oi + t[Me + 452 >> 2] | 0, a = E >>> 0 > xr >>> 0 ? a + 1 | 0 : a, E = t[Me + 288 >> 2], Gn = E + xr | 0, cr = a, a = a + t[Me + 292 >> 2] | 0, a = E >>> 0 > Gn >>> 0 ? a + 1 | 0 : a, E = t[Me + 208 >> 2], dr = E + Gn | 0, L = a, a = a + t[Me + 212 >> 2] | 0, E = E >>> 0 > dr >>> 0 ? a + 1 | 0 : a, Hi = (T | 0) == (Ir | 0) & tr >>> 0 < Mr >>> 0 | T >>> 0 > Ir >>> 0, Ai = (T | 0) == (Be | 0) & Mr >>> 0 < $r >>> 0 | T >>> 0 < Be >>> 0, a = Xn + 8 | 0, Zn = t[a >> 2], Xn = t[a + 4 >> 2], ts = (Be | 0) == (gr | 0) & $r >>> 0 < gn >>> 0 | Be >>> 0 < gr >>> 0, a = Bs + 8 | 0, Ii = t[a >> 2], ai = t[a + 4 >> 2], jn = (or | 0) == (gr | 0) & gn >>> 0 < Bn >>> 0 | or >>> 0 > gr >>> 0, a = ks + 8 | 0, Un = t[a >> 2], gn = t[a + 4 >> 2], $r = (or | 0) == (xn | 0) & Bn >>> 0 < kn >>> 0 | or >>> 0 < xn >>> 0, a = ps + 8 | 0, Mr = t[a >> 2], or = t[a + 4 >> 2], gr = (xn | 0) == (Gs | 0) & kn >>> 0 < us >>> 0 | xn >>> 0 < Gs >>> 0, Be = yi + 8 | 0, T = t[Be >> 2], a = zs + 8 | 0, Bn = T + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[Be + 4 >> 2] | 0, a = T >>> 0 > Bn >>> 0 ? a + 1 | 0 : a, T = gr + Bn | 0, a = (T >>> 0 < Bn >>> 0 ? a + 1 | 0 : a) + or | 0, Be = T, T = T + Mr | 0, a = Be >>> 0 > T >>> 0 ? a + 1 | 0 : a, Be = T, T = T + $r | 0, a = (Be >>> 0 > T >>> 0 ? a + 1 | 0 : a) + gn | 0, Be = T, T = T + Un | 0, a = Be >>> 0 > T >>> 0 ? a + 1 | 0 : a, Be = T, T = T + jn | 0, a = (Be >>> 0 > T >>> 0 ? a + 1 | 0 : a) + ai | 0, Be = T, T = T + Ii | 0, a = Be >>> 0 > T >>> 0 ? a + 1 | 0 : a, Be = T, T = T + ts | 0, a = (Be >>> 0 > T >>> 0 ? a + 1 | 0 : a) + Xn | 0, Be = T, T = T + Zn | 0, a = Be >>> 0 > T >>> 0 ? a + 1 | 0 : a, Be = T + Ai | 0, a = Be >>> 0 < T >>> 0 ? a + 1 | 0 : a, he = he >>> 20 | 0, T = Be + he | 0, a = he >>> 0 > T >>> 0 ? a + 1 | 0 : a, he = T, T = T + Hi | 0, he = he >>> 0 > T >>> 0 ? a + 1 | 0 : a, Be = he << 12 | T >>> 20, a = T << 12, T = Ir, gr = a | T >>> 20, Ir = gr + dr | 0, a = E + Be | 0, or = gr >>> 0 > Ir >>> 0 ? a + 1 | 0 : a, Be = Ir, a = or << 4 | Be >>> 28, gr = Be << 4 & -16, Be = a & 16777215, $r = T, Ur(Me, gr | T >>> 16 & 15, Be, 0, 0, 977, 1, 0, 0), Ai = t[Me + 4 >> 2], a = Ai + t[Me + 100 >> 2] | 0, ws = (Me + 2240 | 0) + d | 0, Be = ws, Zn = t[Me >> 2], T = t[Me + 96 >> 2], Mr = Zn + T | 0, t[Be >> 2] = Mr, gr = T >>> 0 > Mr >>> 0 ? a + 1 | 0 : a, t[Be + 4 >> 2] = gr & 1048575, zs = Me + 112 | 0, Ur(zs, to, ro, 0, 0, 1486445587, 479535, 0, 0), ps = Me + 464 | 0, Ur(ps, $s, Xs, 0, 0, 1905590766, 617512, 0, 0), ks = Me + 384 | 0, Ur(ks, Ao, co, 0, 0, 1781228924, 31465, 0, 0), Xn = Me + 304 | 0, Ur(Xn, Co, wo, 0, 0, -431719958, 28934, 0, 0), ts = Me + 224 | 0, Ur(ts, fo, hs, 0, 0, -375590839, 799796, 0, 0), Bs = Me + 48 | 0, ai = Bs, Ii = t[Me + 304 >> 2], T = t[Me + 384 >> 2], Bn = Ii + T | 0, Gs = t[Me + 308 >> 2], a = Gs + t[Me + 388 >> 2] | 0, a = T >>> 0 > Bn >>> 0 ? a + 1 | 0 : a, T = t[Me + 224 >> 2], gn = T + Bn | 0, Be = a, a = a + t[Me + 228 >> 2] | 0, T = T >>> 0 > gn >>> 0 ? a + 1 | 0 : a, jn = (E | 0) == (or | 0) & dr >>> 0 > Ir >>> 0 | E >>> 0 > or >>> 0, Un = (E | 0) == (L | 0) & dr >>> 0 < Gn >>> 0 | E >>> 0 < L >>> 0, a = Zi + 8 | 0, xn = t[a >> 2], kn = t[a + 4 >> 2], Gn = (L | 0) == (cr | 0) & xr >>> 0 > Gn >>> 0 | L >>> 0 < cr >>> 0, a = Bi + 8 | 0, dr = t[a >> 2], Ir = t[a + 4 >> 2], cr = (cr | 0) == (Oi | 0) & xr >>> 0 < wi >>> 0 | cr >>> 0 < Oi >>> 0, L = Xi + 8 | 0, E = t[L >> 2], a = gs + 8 | 0, xr = E + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[L + 4 >> 2] | 0, a = E >>> 0 > xr >>> 0 ? a + 1 | 0 : a, E = cr + xr | 0, a = (E >>> 0 < xr >>> 0 ? a + 1 | 0 : a) + Ir | 0, L = E, E = E + dr | 0, a = L >>> 0 > E >>> 0 ? a + 1 | 0 : a, L = E, E = E + Gn | 0, a = (L >>> 0 > E >>> 0 ? a + 1 | 0 : a) + kn | 0, L = E, E = E + xn | 0, a = L >>> 0 > E >>> 0 ? a + 1 | 0 : a, L = E + Un | 0, a = L >>> 0 < E >>> 0 ? a + 1 | 0 : a, he = he >>> 20 | 0, E = L + he | 0, a = he >>> 0 > E >>> 0 ? a + 1 | 0 : a, L = E, E = E + jn | 0, a = L >>> 0 > E >>> 0 ? a + 1 | 0 : a, he = E << 12 | or >>> 20, dr = he + gn | 0, cr = a, a = T + (a << 12 | E >>> 20) | 0, Ir = he >>> 0 > dr >>> 0 ? a + 1 | 0 : a, Ur(ai, dr, Ir & 1048575, 0, 0, 15632, 16, 0, 0), xr = ws + 8 | 0, gs = t[Me + 464 >> 2], E = t[Me + 112 >> 2], Un = gs + E | 0, yi = t[Me + 468 >> 2], a = yi + t[Me + 116 >> 2] | 0, a = E >>> 0 > Un >>> 0 ? a + 1 | 0 : a, E = t[Me + 48 >> 2], xn = E + Un | 0, jn = a, a = a + t[Me + 52 >> 2] | 0, he = E >>> 0 > xn >>> 0 ? a + 1 | 0 : a, or = (gr | 0) == (Ai | 0) & Mr >>> 0 < Zn >>> 0 | gr >>> 0 < Ai >>> 0, L = Ti + 8 | 0, E = t[L >> 2], a = Me + 8 | 0, Mr = E + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[L + 4 >> 2] | 0, a = E >>> 0 > Mr >>> 0 ? a + 1 | 0 : a, E = or + Mr | 0, a = E >>> 0 < Mr >>> 0 ? a + 1 | 0 : a, gr = E << 12 | gr >>> 20, Mr = gr + xn | 0, L = a, a = he + (a << 12 | E >>> 20) | 0, t[xr >> 2] = Mr, or = gr >>> 0 > Mr >>> 0 ? a + 1 | 0 : a, t[xr + 4 >> 2] = or & 1048575, Bi = Me + 128 | 0, Ur(Bi, to, ro, 0, 0, -375590839, 799796, 0, 0), Zi = Me + 480 | 0, Ur(Zi, $s, Xs, 0, 0, 1486445587, 479535, 0, 0), us = Me + 400 | 0, Ur(us, Ao, co, 0, 0, 1905590766, 617512, 0, 0), wi = Me + 320 | 0, Ur(wi, Co, wo, 0, 0, 1781228924, 31465, 0, 0), Hi = Me + 240 | 0, Ur(Hi, fo, hs, 0, 0, -431719958, 28934, 0, 0), Ai = Me + 32 | 0, ai = Ai, Zn = t[Me + 240 >> 2], E = t[Me + 320 >> 2], kn = Zn + E | 0, Ti = t[Me + 244 >> 2], a = Ti + t[Me + 324 >> 2] | 0, E = E >>> 0 > kn >>> 0 ? a + 1 | 0 : a, xr = (T | 0) == (Ir | 0) & dr >>> 0 < gn >>> 0 | T >>> 0 > Ir >>> 0, Gn = (T | 0) == (Be | 0) & gn >>> 0 < Bn >>> 0 | T >>> 0 < Be >>> 0, a = ts + 8 | 0, gn = t[a >> 2], dr = t[a + 4 >> 2], gr = (Be | 0) == (Gs | 0) & Bn >>> 0 < Ii >>> 0 | Be >>> 0 < Gs >>> 0, Be = ks + 8 | 0, T = t[Be >> 2], a = Xn + 8 | 0, Bn = T + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[Be + 4 >> 2] | 0, a = T >>> 0 > Bn >>> 0 ? a + 1 | 0 : a, T = gr + Bn | 0, a = (T >>> 0 < Bn >>> 0 ? a + 1 | 0 : a) + dr | 0, Be = T, T = T + gn | 0, a = Be >>> 0 > T >>> 0 ? a + 1 | 0 : a, Be = T + Gn | 0, a = Be >>> 0 < T >>> 0 ? a + 1 | 0 : a, cr = cr >>> 20 | 0, T = Be + cr | 0, a = cr >>> 0 > T >>> 0 ? a + 1 | 0 : a, Be = T, T = T + xr | 0, a = Be >>> 0 > T >>> 0 ? a + 1 | 0 : a, cr = T << 12 | Ir >>> 20, dr = cr + kn | 0, gr = a, a = E + (a << 12 | T >>> 20) | 0, xr = dr >>> 0 < cr >>> 0 ? a + 1 | 0 : a, Ur(ai, dr, xr, 0, 0, 15632, 16, 0, 0), Xi = ws + 16 | 0, Xn = t[Me + 480 >> 2], T = t[Me + 128 >> 2], Gn = Xn + T | 0, ks = t[Me + 484 >> 2], a = ks + t[Me + 132 >> 2] | 0, a = T >>> 0 > Gn >>> 0 ? a + 1 | 0 : a, T = t[Me + 400 >> 2], Bn = T + Gn | 0, Be = a, a = a + t[Me + 404 >> 2] | 0, a = T >>> 0 > Bn >>> 0 ? a + 1 | 0 : a, T = t[Me + 32 >> 2], gn = T + Bn | 0, cr = a, a = a + t[Me + 36 >> 2] | 0, T = T >>> 0 > gn >>> 0 ? a + 1 | 0 : a, ts = (he | 0) == (or | 0) & Mr >>> 0 < xn >>> 0 | he >>> 0 > or >>> 0, Ii = (he | 0) == (jn | 0) & Un >>> 0 > xn >>> 0 | he >>> 0 < jn >>> 0, a = Bs + 8 | 0, ai = t[a >> 2], xn = t[a + 4 >> 2], Mr = (jn | 0) == (yi | 0) & Un >>> 0 < gs >>> 0 | jn >>> 0 < yi >>> 0, Ir = zs + 8 | 0, he = t[Ir >> 2], a = ps + 8 | 0, Un = he + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[Ir + 4 >> 2] | 0, a = he >>> 0 > Un >>> 0 ? a + 1 | 0 : a, he = Mr + Un | 0, a = (he >>> 0 < Un >>> 0 ? a + 1 | 0 : a) + xn | 0, Ir = he, he = he + ai | 0, a = Ir >>> 0 > he >>> 0 ? a + 1 | 0 : a, Ir = he + Ii | 0, a = Ir >>> 0 < he >>> 0 ? a + 1 | 0 : a, L = L >>> 20 | 0, he = L + Ir | 0, a = L >>> 0 > he >>> 0 ? a + 1 | 0 : a, L = he, he = he + ts | 0, a = L >>> 0 > he >>> 0 ? a + 1 | 0 : a, or = he << 12 | or >>> 20, Ir = or + gn | 0, L = a, a = T + (a << 12 | he >>> 20) | 0, t[Xi >> 2] = Ir, or = or >>> 0 > Ir >>> 0 ? a + 1 | 0 : a, t[Xi + 4 >> 2] = or & 1048575, Un = Me + 16 | 0, xn = Un, Mr = (E | 0) == (xr | 0) & dr >>> 0 < kn >>> 0 | E >>> 0 > xr >>> 0, dr = (E | 0) == (Ti | 0) & kn >>> 0 < Zn >>> 0 | E >>> 0 < Ti >>> 0, he = wi + 8 | 0, E = t[he >> 2], a = Hi + 8 | 0, xr = E + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[he + 4 >> 2] | 0, a = E >>> 0 > xr >>> 0 ? a + 1 | 0 : a, he = dr + xr | 0, a = he >>> 0 < xr >>> 0 ? a + 1 | 0 : a, gr = gr >>> 20 | 0, E = he + gr | 0, a = gr >>> 0 > E >>> 0 ? a + 1 | 0 : a, he = E, E = E + Mr | 0, a = he >>> 0 > E >>> 0 ? a + 1 | 0 : a, Ur(xn, E, a, 0, 0, 64028672, 65536, 0, 0), ai = ws + 24 | 0, jn = t[Me + 20 >> 2], a = jn + (Wr & 1048575) | 0, xn = t[Me + 16 >> 2], he = ni + xn | 0, E = he >>> 0 < ni >>> 0 ? a + 1 | 0 : a, gr = he, kn = (T | 0) == (or | 0) & Ir >>> 0 < gn >>> 0 | T >>> 0 > or >>> 0, xr = (T | 0) == (cr | 0) & gn >>> 0 < Bn >>> 0 | T >>> 0 < cr >>> 0, a = Ai + 8 | 0, gn = t[a >> 2], Wr = t[a + 4 >> 2], Mr = (Be | 0) == (cr | 0) & Bn >>> 0 < Gn >>> 0 | Be >>> 0 > cr >>> 0, a = us + 8 | 0, dr = t[a >> 2], Ir = t[a + 4 >> 2], cr = (Be | 0) == (ks | 0) & Gn >>> 0 < Xn >>> 0 | Be >>> 0 < ks >>> 0, he = Bi + 8 | 0, T = t[he >> 2], a = Zi + 8 | 0, Be = T + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[he + 4 >> 2] | 0, a = T >>> 0 > Be >>> 0 ? a + 1 | 0 : a, T = Be + cr | 0, a = (T >>> 0 < Be >>> 0 ? a + 1 | 0 : a) + Ir | 0, he = T, T = T + dr | 0, a = he >>> 0 > T >>> 0 ? a + 1 | 0 : a, he = T, T = T + Mr | 0, a = (he >>> 0 > T >>> 0 ? a + 1 | 0 : a) + Wr | 0, he = T, T = T + gn | 0, a = he >>> 0 > T >>> 0 ? a + 1 | 0 : a, he = T + xr | 0, a = he >>> 0 < T >>> 0 ? a + 1 | 0 : a, L = L >>> 20 | 0, T = L + he | 0, a = L >>> 0 > T >>> 0 ? a + 1 | 0 : a, L = T, T = T + kn | 0, a = L >>> 0 > T >>> 0 ? a + 1 | 0 : a, cr = T << 12 | or >>> 20, L = cr + gr | 0, he = a, a = E + (a << 12 | T >>> 20) | 0, t[ai >> 2] = L, T = L >>> 0 < cr >>> 0 ? a + 1 | 0 : a, t[ai + 4 >> 2] = T & 1048575, or = ws + 32 | 0, Be = $r & 65535, cr = (E | 0) == (T | 0) & L >>> 0 < gr >>> 0 | E >>> 0 > T >>> 0, E = (E | 0) == (jn | 0) & gr >>> 0 < xn >>> 0 | E >>> 0 < jn >>> 0, a = Un + 8 | 0, L = E + t[a >> 2] | 0, a = t[a + 4 >> 2], a = E >>> 0 > L >>> 0 ? a + 1 | 0 : a, he = he >>> 20 | 0, E = L + he | 0, a = he >>> 0 > E >>> 0 ? a + 1 | 0 : a, L = E, E = E + cr | 0, a = L >>> 0 > E >>> 0 ? a + 1 | 0 : a, T = E << 12 | T >>> 20, he = T + tr | 0, a = Be + (a << 12 | E >>> 20) | 0, t[or >> 2] = he, t[or + 4 >> 2] = T >>> 0 > he >>> 0 ? a + 1 | 0 : a, I = I + 88 | 0, d = d + 40 | 0, (d | 0) != 320; )
        ;
      I = (fi | 0) < (pi | 0) ? pi : fi, d = 1;
    }
    e: {
      if (!n) {
        or = 0, cr = 0;
        break e;
      }
      T = Me + 3648 | 0, a = T + 24 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, E = Me + 3616 | 0, a = E + 24 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, t[Me + 3664 >> 2] = 0, t[Me + 3668 >> 2] = 0, t[Me + 3632 >> 2] = 0, t[Me + 3636 >> 2] = 0, a = t[n + 4 >> 2], t[Me + 3648 >> 2] = t[n >> 2], t[Me + 3652 >> 2] = a, a = t[n + 12 >> 2], t[Me + 3656 >> 2] = t[n + 8 >> 2], t[Me + 3660 >> 2] = a, a = t[n + 20 >> 2], t[Me + 3616 >> 2] = t[n + 16 >> 2], t[Me + 3620 >> 2] = a, a = t[n + 28 >> 2], t[Me + 3624 >> 2] = t[n + 24 >> 2], t[Me + 3628 >> 2] = a, or = Pn(Me + 3088 | 0, T, 4), cr = Pn(Me + 2560 | 0, E, 4), I = (I | 0) < (or | 0) ? or : I, I = (I | 0) < (cr | 0) ? cr : I;
    }
    t[v + 120 >> 2] = 1, dr = Vi(v, 120);
    e: {
      if ((I | 0) <= 0)
        break e;
      v = I - 1 | 0;
      t: {
        if (!d)
          for (v = v << 2, n = v + (Me + 3088 | 0) | 0, v = (Me + 2560 | 0) + v | 0, tr = 1; ; ) {
            r: {
              if (tr) {
                t[dr + 120 >> 2] = 1, Vi(dr, 120);
                break r;
              }
              Mi(dr, dr);
            }
            r: {
              if ((I | 0) > (or | 0) || (a = t[n >> 2], !a))
                break r;
              d = Me + 3720 | 0, $n(d, 655920, a), ui(dr, dr, d, Me + 3680 | 0);
            }
            d = I - 1 | 0;
            r: {
              if ((I | 0) > (cr | 0) || (a = t[v >> 2], !a))
                break r;
              I = Me + 3720 | 0, $n(I, 656176, a), ui(dr, dr, I, Me + 3680 | 0);
            }
            if ((d | 0) <= 0)
              break t;
            n = n - 4 | 0, v = v - 4 | 0, tr = t[dr + 120 >> 2], I = d;
          }
        for (Ir = Me + 3760 | 0, n = ((I << 2) + Me | 0) + 1008 | 0, d = v << 2, v = d + (Me + 3088 | 0) | 0, tr = (Me + 2560 | 0) + d | 0, L = t[Me + 1532 >> 2], he = t[Me + 1528 >> 2], a = 1; ; ) {
          r: {
            if (a) {
              t[dr + 120 >> 2] = 1, Vi(dr, 120);
              break r;
            }
            Mi(dr, dr);
          }
          r: {
            if ((I | 0) > (he | 0) || (d = t[n - 516 >> 2], !d))
              break r;
            n: {
              if ((d | 0) <= 0) {
                $i(Me + 3720 | 0, (Me + 1536 | 0) + b((d ^ -1) / 2 | 0, 88) | 0, 88), d = t[Me + 3760 >> 2], a = -3908 - d | 0, d = 4194299 - (t[Me + 3764 >> 2] + (d >>> 0 > 4294963388) | 0) | 0, t[Me + 3760 >> 2] = a, t[Me + 3764 >> 2] = d, d = t[Me + 3768 >> 2], a = -4 - d | 0, d = 4194303 - (t[Me + 3772 >> 2] + (d >>> 0 > 4294967292) | 0) | 0, t[Me + 3768 >> 2] = a, t[Me + 3772 >> 2] = d, d = t[Me + 3776 >> 2], a = -4 - d | 0, d = 4194303 - (t[Me + 3780 >> 2] + (d >>> 0 > 4294967292) | 0) | 0, t[Me + 3776 >> 2] = a, t[Me + 3780 >> 2] = d, d = t[Me + 3784 >> 2], a = -4 - d | 0, d = 4194303 - (t[Me + 3788 >> 2] + (d >>> 0 > 4294967292) | 0) | 0, t[Me + 3784 >> 2] = a, t[Me + 3788 >> 2] = d, d = t[Me + 3792 >> 2], a = -4 - d | 0, d = 262143 - (t[Me + 3796 >> 2] + (d >>> 0 > 4294967292) | 0) | 0, t[Me + 3792 >> 2] = a, t[Me + 3796 >> 2] = d;
                break n;
              }
              $i(Me + 3720 | 0, (Me + 1536 | 0) + b(d - 1 >>> 1 | 0, 88) | 0, 88);
            }
            Ei(dr, dr, Me + 3720 | 0, 0);
          }
          r: {
            if ((I | 0) > (L | 0) || (d = t[n >> 2], !d))
              break r;
            n: {
              if ((d | 0) <= 0) {
                T = (d ^ -1) / 2 | 0, Be = (Me + 1536 | 0) + b(T, 88) | 0, d = t[Be + 44 >> 2], t[Ir >> 2] = t[Be + 40 >> 2], t[Ir + 4 >> 2] = d, E = Be + 48 | 0, a = t[E + 4 >> 2], d = Ir + 8 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = Be + 56 | 0, a = t[E + 4 >> 2], d = Ir + 16 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = Be - -64 | 0, a = t[E + 4 >> 2], d = Ir + 24 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = Be + 72 | 0, a = t[E + 4 >> 2], d = Ir + 32 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, Be = (Me + 2240 | 0) + b(T, 40) | 0, E = Be + 8 | 0, a = t[E + 4 >> 2], T = Me + 3720 | 0, d = T + 8 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = Be + 16 | 0, a = t[E + 4 >> 2], d = T + 16 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = Be + 24 | 0, a = t[E + 4 >> 2], d = T + 24 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = Be + 32 | 0, a = t[E + 4 >> 2], d = T + 32 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, t[Me + 3800 >> 2] = 0, d = t[Be + 4 >> 2], t[Me + 3720 >> 2] = t[Be >> 2], t[Me + 3724 >> 2] = d, d = t[Me + 3760 >> 2], a = -3908 - d | 0, d = 4194299 - (t[Me + 3764 >> 2] + (d >>> 0 > 4294963388) | 0) | 0, t[Me + 3760 >> 2] = a, t[Me + 3764 >> 2] = d, d = t[Me + 3768 >> 2], a = -4 - d | 0, d = 4194303 - (t[Me + 3772 >> 2] + (d >>> 0 > 4294967292) | 0) | 0, t[Me + 3768 >> 2] = a, t[Me + 3772 >> 2] = d, d = t[Me + 3776 >> 2], a = -4 - d | 0, d = 4194303 - (t[Me + 3780 >> 2] + (d >>> 0 > 4294967292) | 0) | 0, t[Me + 3776 >> 2] = a, t[Me + 3780 >> 2] = d, d = t[Me + 3784 >> 2], a = -4 - d | 0, d = 4194303 - (t[Me + 3788 >> 2] + (d >>> 0 > 4294967292) | 0) | 0, t[Me + 3784 >> 2] = a, t[Me + 3788 >> 2] = d, d = t[Me + 3792 >> 2], a = -4 - d | 0, d = 262143 - (t[Me + 3796 >> 2] + (d >>> 0 > 4294967292) | 0) | 0, t[Me + 3792 >> 2] = a, t[Me + 3796 >> 2] = d;
                break n;
              }
              a = d - 1 >>> 1 | 0, gr = (Me + 1536 | 0) + b(a, 88) | 0, d = t[gr + 44 >> 2], t[Ir >> 2] = t[gr + 40 >> 2], t[Ir + 4 >> 2] = d, Be = (Me + 2240 | 0) + b(a, 40) | 0, E = Be + 8 | 0, a = t[E + 4 >> 2], T = Me + 3720 | 0, d = T + 8 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = Be + 16 | 0, a = t[E + 4 >> 2], d = T + 16 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = Be + 24 | 0, a = t[E + 4 >> 2], d = T + 24 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = Be + 32 | 0, a = t[E + 4 >> 2], d = T + 32 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = gr + 48 | 0, a = t[E + 4 >> 2], d = Ir + 8 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = gr + 56 | 0, a = t[E + 4 >> 2], d = Ir + 16 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = gr - -64 | 0, a = t[E + 4 >> 2], d = Ir + 24 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, E = gr + 72 | 0, a = t[E + 4 >> 2], d = Ir + 32 | 0, t[d >> 2] = t[E >> 2], t[d + 4 >> 2] = a, t[Me + 3800 >> 2] = 0, d = t[Be + 4 >> 2], t[Me + 3720 >> 2] = t[Be >> 2], t[Me + 3724 >> 2] = d;
            }
            Ei(dr, dr, Me + 3720 | 0, 0);
          }
          r: {
            if ((I | 0) > (or | 0) || (a = t[v >> 2], !a))
              break r;
            d = Me + 3720 | 0, $n(d, 655920, a), ui(dr, dr, d, Me + 3680 | 0);
          }
          d = I - 1 | 0;
          r: {
            if ((I | 0) > (cr | 0) || (a = t[tr >> 2], !a))
              break r;
            I = Me + 3720 | 0, $n(I, 656176, a), ui(dr, dr, I, Me + 3680 | 0);
          }
          if ((d | 0) <= 0)
            break t;
          v = v - 4 | 0, tr = tr - 4 | 0, n = n - 4 | 0, a = t[dr + 120 >> 2], I = d;
        }
      }
      if (t[dr + 120 >> 2])
        break e;
      v = dr + 80 | 0, Xr(v, v, Me + 3680 | 0);
    }
    x = Me + 3808 | 0;
  }
  function wn(v, d) {
    var I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0;
    he = x - 48 | 0, x = he, n = he + 8 | 0, Ui(n, d + 80 | 0), Xr(n, n, v), E = t[d + 24 >> 2], a = t[d + 28 >> 2], Be = t[d + 16 >> 2], T = t[d + 20 >> 2], n = t[d + 8 >> 2], tr = t[d + 12 >> 2], I = t[d >> 2], L = t[d + 4 >> 2], or = t[d + 32 >> 2], d = t[d + 36 >> 2], cr = d, v = I, I = pn(d >>> 16 | 0, 0, 977, 1), d = v + I | 0, v = L + Ee | 0, v = d >>> 0 < I >>> 0 ? v + 1 | 0 : v, I = d, L = v, v = tr, d = L >>> 20 | 0, Me = d, d = d + n | 0, tr = Me >>> 0 > d >>> 0 ? v + 1 | 0 : v, v = T, n = tr >>> 20 | 0, Be = n + Be | 0, T = n >>> 0 > Be >>> 0 ? v + 1 | 0 : v, v = a, n = T >>> 20 | 0, E = n + E | 0, n = n >>> 0 > E >>> 0 ? v + 1 | 0 : v, v = t[he + 8 >> 2], a = I - v | 0, dr = (L & 1048575) - (t[he + 12 >> 2] + (v >>> 0 > I >>> 0) | 0) | 0, v = t[he + 40 >> 2], L = or - v | 0, v = (cr & 65535) - (t[he + 44 >> 2] + (v >>> 0 > or >>> 0) | 0) | 0, I = n >>> 20 | 0, Me = I, I = I + L | 0, v = (Me >>> 0 > I >>> 0 ? v + 1 | 0 : v) + 262143 | 0, Me = a, I = I - 4 | 0, or = I >>> 0 < 4294967292 ? v + 1 | 0 : v, a = pn(or >>> 16 | 0, 0, 977, 1), L = Me + a | 0, v = dr + Ee | 0, v = (L >>> 0 < a >>> 0 ? v + 1 | 0 : v) + 4194299 | 0, L = L - 3908 | 0, v = L >>> 0 < 4294963388 ? v + 1 | 0 : v, a = v & 1048575, gr = a, cr = L ^ 976, dr = a ^ 1, x = he + 48 | 0;
    e: {
      if (L | a && (a = 0, (cr | 0) != -1 | (dr | 0) != 1048575))
        break e;
      a = I, or = or & 65535, I = t[he + 32 >> 2], Ir = E - I | 0, Me = (n & 1048575) - (t[he + 36 >> 2] + (I >>> 0 > E >>> 0) | 0) | 0, n = t[he + 24 >> 2], E = Be - n | 0, Be = (T & 1048575) - (t[he + 28 >> 2] + (n >>> 0 > Be >>> 0) | 0) | 0, n = v, v = tr & 1048575, n = n >>> 20 | 0, I = n, n = d + n | 0, v = I >>> 0 > n >>> 0 ? v + 1 | 0 : v, I = t[he + 16 >> 2], d = (n - I | 0) - 4 | 0, v = (v - (t[he + 20 >> 2] + (n >>> 0 < I >>> 0) | 0) | 0) + 4194303 | 0, n = d >>> 0 < 4294967292 ? v + 1 | 0 : v, v = Be, I = n >>> 20 | 0, T = I, I = I + E | 0, v = (T >>> 0 > I >>> 0 ? v + 1 | 0 : v) + 4194303 | 0, I = I - 4 | 0, Be = I >>> 0 < 4294967292 ? v + 1 | 0 : v, v = Me, E = Be >>> 20 | 0, T = E, E = E + Ir | 0, v = (T >>> 0 > E >>> 0 ? v + 1 | 0 : v) + 4194303 | 0, E = E - 4 | 0, tr = E >>> 0 < 4294967292 ? v + 1 | 0 : v, v = or, T = tr >>> 20 | 0, Me = T, T = a + T | 0, v = Me >>> 0 > T >>> 0 ? v + 1 | 0 : v, (d & cr & I & E & T) == -1 ? a = (n & dr & Be & tr & (v ^ 983040)) == 1048575 : a = 0, a ? (d = 0, v = 0) : (d = E | (I | (d | L)) | T, v = tr & 1048575 | (Be & 1048575 | (n & 1048575 | gr)) | v), a = !(v | d);
    }
    return a;
  }
  function Kn(v, d, I, n, a, E) {
    v = v | 0, d = d | 0, I = I | 0, n = n | 0, a = a | 0, E = E | 0;
    var T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0;
    for (T = x - 224 | 0, x = T, Zr(T + 8 | 0, d, 0), d = I + 16 | 0, L = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), he = T + 112 | 0, Be = he + 16 | 0, t[Be >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[Be + 4 >> 2] = L, d = I + 24 | 0, L = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), he = he + 24 | 0, t[he >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[he + 4 >> 2] = L, d = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), t[T + 112 >> 2] = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), t[T + 116 >> 2] = d, d = I + 8 | 0, I = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), t[T + 120 >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[T + 124 >> 2] = I, d = t[T + 12 >> 2], Be = t[T + 8 >> 2], u[T + 175 | 0] = Be, I = t[T + 20 >> 2], Me = t[T + 16 >> 2], u[T + 167 | 0] = Me, L = t[T + 28 >> 2], tr = t[T + 24 >> 2], u[T + 159 | 0] = tr, he = t[T + 36 >> 2], or = t[T + 32 >> 2], u[T + 151 | 0] = or, u[T + 174 | 0] = (d & 255) << 24 | Be >>> 8, u[T + 173 | 0] = (d & 65535) << 16 | Be >>> 16, u[T + 172 | 0] = (d & 16777215) << 8 | Be >>> 24, u[T + 171 | 0] = d, u[T + 170 | 0] = d >>> 8, u[T + 169 | 0] = d >>> 16, u[T + 168 | 0] = d >>> 24, u[T + 166 | 0] = (I & 255) << 24 | Me >>> 8, u[T + 165 | 0] = (I & 65535) << 16 | Me >>> 16, u[T + 164 | 0] = (I & 16777215) << 8 | Me >>> 24, u[T + 163 | 0] = I, u[T + 162 | 0] = I >>> 8, u[T + 161 | 0] = I >>> 16, u[T + 160 | 0] = I >>> 24, u[T + 158 | 0] = (L & 255) << 24 | tr >>> 8, u[T + 157 | 0] = (L & 65535) << 16 | tr >>> 16, u[T + 156 | 0] = (L & 16777215) << 8 | tr >>> 24, u[T + 155 | 0] = L, u[T + 154 | 0] = L >>> 8, u[T + 153 | 0] = L >>> 16, u[T + 152 | 0] = L >>> 24, u[T + 150 | 0] = (he & 255) << 24 | or >>> 8, u[T + 149 | 0] = (he & 65535) << 16 | or >>> 16, u[T + 148 | 0] = (he & 16777215) << 8 | or >>> 24, u[T + 147 | 0] = he, u[T + 146 | 0] = he >>> 8, u[T + 145 | 0] = he >>> 16, u[T + 144 | 0] = he >>> 24, a ? (d = a + 24 | 0, I = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), L = T + 200 | 0, t[L >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[L + 4 >> 2] = I, d = a + 16 | 0, I = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), L = T + 192 | 0, t[L >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[L + 4 >> 2] = I, d = a + 8 | 0, I = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), L = T + 184 | 0, t[L >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[L + 4 >> 2] = I, d = l[a + 4 | 0] | l[a + 5 | 0] << 8 | (l[a + 6 | 0] << 16 | l[a + 7 | 0] << 24), t[T + 176 >> 2] = l[a | 0] | l[a + 1 | 0] << 8 | (l[a + 2 | 0] << 16 | l[a + 3 | 0] << 24), t[T + 180 >> 2] = d, I = 96) : I = 64, n && (a = l[n + 4 | 0] | l[n + 5 | 0] << 8 | (l[n + 6 | 0] << 16 | l[n + 7 | 0] << 24), d = (T + 112 | 0) + I | 0, L = l[n | 0] | l[n + 1 | 0] << 8 | (l[n + 2 | 0] << 16 | l[n + 3 | 0] << 24), u[d | 0] = L, u[d + 1 | 0] = L >>> 8, u[d + 2 | 0] = L >>> 16, u[d + 3 | 0] = L >>> 24, u[d + 4 | 0] = a, u[d + 5 | 0] = a >>> 8, u[d + 6 | 0] = a >>> 16, u[d + 7 | 0] = a >>> 24, n = n + 8 | 0, a = l[n + 4 | 0] | l[n + 5 | 0] << 8 | (l[n + 6 | 0] << 16 | l[n + 7 | 0] << 24), d = d + 8 | 0, n = l[n | 0] | l[n + 1 | 0] << 8 | (l[n + 2 | 0] << 16 | l[n + 3 | 0] << 24), u[d | 0] = n, u[d + 1 | 0] = n >>> 8, u[d + 2 | 0] = n >>> 16, u[d + 3 | 0] = n >>> 24, u[d + 4 | 0] = a, u[d + 5 | 0] = a >>> 8, u[d + 6 | 0] = a >>> 16, u[d + 7 | 0] = a >>> 24, I = I | 16), d = T + 112 | 0, Ln(T + 40 | 0, d, I), I = 0, Vi(d, 112); Wn(T + 40 | 0, v), I = I + 1 | 0, E >>> 0 >= I >>> 0; )
      ;
    return x = T + 224 | 0, 1;
  }
  function Ln(v, d, I) {
    var n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0;
    for (n = x - 272 | 0, x = n, t[v >> 2] = 16843009, t[v + 4 >> 2] = 16843009, t[v + 32 >> 2] = 0, t[v + 36 >> 2] = 0, T = v + 24 | 0, t[T >> 2] = 16843009, t[T + 4 >> 2] = 16843009, T = v + 16 | 0, t[T >> 2] = 16843009, t[T + 4 >> 2] = 16843009, T = v + 8 | 0, t[T >> 2] = 16843009, t[T + 4 >> 2] = 16843009, T = v + 40 | 0, t[T >> 2] = 0, t[T + 4 >> 2] = 0, T = v + 48 | 0, t[T >> 2] = 0, t[T + 4 >> 2] = 0, T = v + 56 | 0, t[T >> 2] = 0, t[T + 4 >> 2] = 0, T = n + 128 | 0, t[T >> 2] = 528734635, t[T + 4 >> 2] = 1541459225, T = n + 120 | 0, t[T >> 2] = 1359893119, t[T + 4 >> 2] = -1694144372, T = n + 112 | 0, t[T >> 2] = 1013904242, t[T + 4 >> 2] = -1521486534, T = n + 200 | 0, t[T >> 2] = 0, t[T + 4 >> 2] = 0, T = n + 208 | 0, a = T + 56 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = T + 48 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = T + 40 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = T + 32 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = T + 24 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, T = T + 16 | 0, t[T >> 2] = 0, t[T + 4 >> 2] = 0, t[n + 104 >> 2] = 1779033703, t[n + 108 >> 2] = -1150833019, t[n + 216 >> 2] = 0, t[n + 220 >> 2] = 0, t[n + 208 >> 2] = 0, t[n + 212 >> 2] = 0, T = v + 32 | 0, he = n + 104 | 0, a = 0; E = (n + 208 | 0) + a | 0, u[E | 0] = l[E | 0] ^ 92, L = E + 1 | 0, u[L | 0] = l[L | 0] ^ 92, L = E + 2 | 0, u[L | 0] = l[L | 0] ^ 92, E = E + 3 | 0, u[E | 0] = l[E | 0] ^ 92, a = a + 4 | 0, (a | 0) != 64; )
      ;
    for (Tn(he, n + 208 | 0, 64), t[n + 96 >> 2] = 0, t[n + 100 >> 2] = 0, t[n + 24 >> 2] = 528734635, t[n + 28 >> 2] = 1541459225, t[n + 16 >> 2] = 1359893119, t[n + 20 >> 2] = -1694144372, t[n + 8 >> 2] = 1013904242, t[n + 12 >> 2] = -1521486534, t[n >> 2] = 1779033703, t[n + 4 >> 2] = -1150833019, a = 0; E = (n + 208 | 0) + a | 0, u[E | 0] = l[E | 0] ^ 106, L = E + 1 | 0, u[L | 0] = l[L | 0] ^ 106, L = E + 2 | 0, u[L | 0] = l[L | 0] ^ 106, E = E + 3 | 0, u[E | 0] = l[E | 0] ^ 106, a = a + 4 | 0, (a | 0) != 64; )
      ;
    for (E = n + 208 | 0, Tn(n, E, 64), Tn(n, v, 32), Tn(n, 690368, 1), Tn(n, d, I), Yn(n, E), Tn(he, E, 32), Yn(he, T), a = n + 248 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = n + 256 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = n + 264 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = T + 24 | 0, L = l[a + 4 | 0] | l[a + 5 | 0] << 8 | (l[a + 6 | 0] << 16 | l[a + 7 | 0] << 24), Be = E + 24 | 0, t[Be >> 2] = l[a | 0] | l[a + 1 | 0] << 8 | (l[a + 2 | 0] << 16 | l[a + 3 | 0] << 24), t[Be + 4 >> 2] = L, a = T + 16 | 0, L = l[a + 4 | 0] | l[a + 5 | 0] << 8 | (l[a + 6 | 0] << 16 | l[a + 7 | 0] << 24), E = E + 16 | 0, t[E >> 2] = l[a | 0] | l[a + 1 | 0] << 8 | (l[a + 2 | 0] << 16 | l[a + 3 | 0] << 24), t[E + 4 >> 2] = L, t[n + 200 >> 2] = 0, t[n + 204 >> 2] = 0, t[n + 128 >> 2] = 528734635, t[n + 132 >> 2] = 1541459225, t[n + 120 >> 2] = 1359893119, t[n + 124 >> 2] = -1694144372, t[n + 112 >> 2] = 1013904242, t[n + 116 >> 2] = -1521486534, t[n + 104 >> 2] = 1779033703, t[n + 108 >> 2] = -1150833019, t[n + 240 >> 2] = 0, t[n + 244 >> 2] = 0, a = T + 8 | 0, E = l[a + 4 | 0] | l[a + 5 | 0] << 8 | (l[a + 6 | 0] << 16 | l[a + 7 | 0] << 24), t[n + 216 >> 2] = l[a | 0] | l[a + 1 | 0] << 8 | (l[a + 2 | 0] << 16 | l[a + 3 | 0] << 24), t[n + 220 >> 2] = E, a = l[T + 4 | 0] | l[T + 5 | 0] << 8 | (l[T + 6 | 0] << 16 | l[T + 7 | 0] << 24), t[n + 208 >> 2] = l[T | 0] | l[T + 1 | 0] << 8 | (l[T + 2 | 0] << 16 | l[T + 3 | 0] << 24), t[n + 212 >> 2] = a, a = 0; E = (n + 208 | 0) + a | 0, u[E | 0] = l[E | 0] ^ 92, L = E + 1 | 0, u[L | 0] = l[L | 0] ^ 92, L = E + 2 | 0, u[L | 0] = l[L | 0] ^ 92, E = E + 3 | 0, u[E | 0] = l[E | 0] ^ 92, a = a + 4 | 0, (a | 0) != 64; )
      ;
    for (Tn(he, n + 208 | 0, 64), t[n + 96 >> 2] = 0, t[n + 100 >> 2] = 0, t[n + 24 >> 2] = 528734635, t[n + 28 >> 2] = 1541459225, t[n + 16 >> 2] = 1359893119, t[n + 20 >> 2] = -1694144372, t[n + 8 >> 2] = 1013904242, t[n + 12 >> 2] = -1521486534, t[n >> 2] = 1779033703, t[n + 4 >> 2] = -1150833019, a = 0; E = (n + 208 | 0) + a | 0, u[E | 0] = l[E | 0] ^ 106, L = E + 1 | 0, u[L | 0] = l[L | 0] ^ 106, L = E + 2 | 0, u[L | 0] = l[L | 0] ^ 106, E = E + 3 | 0, u[E | 0] = l[E | 0] ^ 106, a = a + 4 | 0, (a | 0) != 64; )
      ;
    for (E = n + 208 | 0, Tn(n, E, 64), Tn(n, v, 32), Yn(n, E), Tn(he, E, 32), Yn(he, v), a = n + 248 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = n + 256 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = n + 264 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = T + 24 | 0, L = l[a + 4 | 0] | l[a + 5 | 0] << 8 | (l[a + 6 | 0] << 16 | l[a + 7 | 0] << 24), Be = E + 24 | 0, t[Be >> 2] = l[a | 0] | l[a + 1 | 0] << 8 | (l[a + 2 | 0] << 16 | l[a + 3 | 0] << 24), t[Be + 4 >> 2] = L, a = T + 16 | 0, L = l[a + 4 | 0] | l[a + 5 | 0] << 8 | (l[a + 6 | 0] << 16 | l[a + 7 | 0] << 24), E = E + 16 | 0, t[E >> 2] = l[a | 0] | l[a + 1 | 0] << 8 | (l[a + 2 | 0] << 16 | l[a + 3 | 0] << 24), t[E + 4 >> 2] = L, t[n + 200 >> 2] = 0, t[n + 204 >> 2] = 0, t[n + 128 >> 2] = 528734635, t[n + 132 >> 2] = 1541459225, t[n + 120 >> 2] = 1359893119, t[n + 124 >> 2] = -1694144372, t[n + 112 >> 2] = 1013904242, t[n + 116 >> 2] = -1521486534, t[n + 104 >> 2] = 1779033703, t[n + 108 >> 2] = -1150833019, t[n + 240 >> 2] = 0, t[n + 244 >> 2] = 0, a = T + 8 | 0, E = l[a + 4 | 0] | l[a + 5 | 0] << 8 | (l[a + 6 | 0] << 16 | l[a + 7 | 0] << 24), t[n + 216 >> 2] = l[a | 0] | l[a + 1 | 0] << 8 | (l[a + 2 | 0] << 16 | l[a + 3 | 0] << 24), t[n + 220 >> 2] = E, a = l[T + 4 | 0] | l[T + 5 | 0] << 8 | (l[T + 6 | 0] << 16 | l[T + 7 | 0] << 24), t[n + 208 >> 2] = l[T | 0] | l[T + 1 | 0] << 8 | (l[T + 2 | 0] << 16 | l[T + 3 | 0] << 24), t[n + 212 >> 2] = a, a = 0; E = (n + 208 | 0) + a | 0, u[E | 0] = l[E | 0] ^ 92, L = E + 1 | 0, u[L | 0] = l[L | 0] ^ 92, L = E + 2 | 0, u[L | 0] = l[L | 0] ^ 92, E = E + 3 | 0, u[E | 0] = l[E | 0] ^ 92, a = a + 4 | 0, (a | 0) != 64; )
      ;
    for (Tn(he, n + 208 | 0, 64), t[n + 96 >> 2] = 0, t[n + 100 >> 2] = 0, t[n + 24 >> 2] = 528734635, t[n + 28 >> 2] = 1541459225, t[n + 16 >> 2] = 1359893119, t[n + 20 >> 2] = -1694144372, t[n + 8 >> 2] = 1013904242, t[n + 12 >> 2] = -1521486534, t[n >> 2] = 1779033703, t[n + 4 >> 2] = -1150833019, a = 0; E = (n + 208 | 0) + a | 0, u[E | 0] = l[E | 0] ^ 106, L = E + 1 | 0, u[L | 0] = l[L | 0] ^ 106, L = E + 2 | 0, u[L | 0] = l[L | 0] ^ 106, E = E + 3 | 0, u[E | 0] = l[E | 0] ^ 106, a = a + 4 | 0, (a | 0) != 64; )
      ;
    for (a = n + 208 | 0, Tn(n, a, 64), Tn(n, v, 32), Tn(n, 690369, 1), Tn(n, d, I), Yn(n, a), Tn(he, a, 32), Yn(he, T), d = n + 248 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = n + 256 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = n + 264 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = T + 24 | 0, I = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), E = a + 24 | 0, t[E >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[E + 4 >> 2] = I, d = T + 16 | 0, I = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), a = a + 16 | 0, t[a >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[a + 4 >> 2] = I, t[n + 200 >> 2] = 0, t[n + 204 >> 2] = 0, t[n + 128 >> 2] = 528734635, t[n + 132 >> 2] = 1541459225, t[n + 120 >> 2] = 1359893119, t[n + 124 >> 2] = -1694144372, t[n + 112 >> 2] = 1013904242, t[n + 116 >> 2] = -1521486534, t[n + 104 >> 2] = 1779033703, t[n + 108 >> 2] = -1150833019, t[n + 240 >> 2] = 0, t[n + 244 >> 2] = 0, d = T + 8 | 0, I = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), t[n + 216 >> 2] = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), t[n + 220 >> 2] = I, d = l[T + 4 | 0] | l[T + 5 | 0] << 8 | (l[T + 6 | 0] << 16 | l[T + 7 | 0] << 24), t[n + 208 >> 2] = l[T | 0] | l[T + 1 | 0] << 8 | (l[T + 2 | 0] << 16 | l[T + 3 | 0] << 24), t[n + 212 >> 2] = d, a = 0; d = (n + 208 | 0) + a | 0, u[d | 0] = l[d | 0] ^ 92, I = d + 1 | 0, u[I | 0] = l[I | 0] ^ 92, I = d + 2 | 0, u[I | 0] = l[I | 0] ^ 92, d = d + 3 | 0, u[d | 0] = l[d | 0] ^ 92, a = a + 4 | 0, (a | 0) != 64; )
      ;
    for (Tn(he, n + 208 | 0, 64), t[n + 96 >> 2] = 0, t[n + 100 >> 2] = 0, t[n + 24 >> 2] = 528734635, t[n + 28 >> 2] = 1541459225, t[n + 16 >> 2] = 1359893119, t[n + 20 >> 2] = -1694144372, t[n + 8 >> 2] = 1013904242, t[n + 12 >> 2] = -1521486534, t[n >> 2] = 1779033703, t[n + 4 >> 2] = -1150833019, a = 0; d = (n + 208 | 0) + a | 0, u[d | 0] = l[d | 0] ^ 106, I = d + 1 | 0, u[I | 0] = l[I | 0] ^ 106, I = d + 2 | 0, u[I | 0] = l[I | 0] ^ 106, d = d + 3 | 0, u[d | 0] = l[d | 0] ^ 106, a = a + 4 | 0, (a | 0) != 64; )
      ;
    d = n + 208 | 0, Tn(n, d, 64), Tn(n, v, 32), Yn(n, d), Tn(he, d, 32), Yn(he, v), t[v + 64 >> 2] = 0, x = n + 272 | 0;
  }
  function Wn(v, d) {
    var I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0;
    if (a = x - 272 | 0, x = a, t[v + 64 >> 2]) {
      for (I = a + 208 | 0, n = I + 40 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = I + 48 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, I = I + 56 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = a + 200 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = a + 128 | 0, t[I >> 2] = 528734635, t[I + 4 >> 2] = 1541459225, I = a + 120 | 0, t[I >> 2] = 1359893119, t[I + 4 >> 2] = -1694144372, I = a + 112 | 0, t[I >> 2] = 1013904242, t[I + 4 >> 2] = -1521486534, I = v + 56 | 0, n = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), T = a + 232 | 0, t[T >> 2] = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), t[T + 4 >> 2] = n, I = v + 48 | 0, n = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), T = a + 224 | 0, t[T >> 2] = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), t[T + 4 >> 2] = n, t[a + 104 >> 2] = 1779033703, t[a + 108 >> 2] = -1150833019, t[a + 240 >> 2] = 0, t[a + 244 >> 2] = 0, I = v + 40 | 0, n = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), t[a + 216 >> 2] = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), t[a + 220 >> 2] = n, I = l[v + 36 | 0] | l[v + 37 | 0] << 8 | (l[v + 38 | 0] << 16 | l[v + 39 | 0] << 24), t[a + 208 >> 2] = l[v + 32 | 0] | l[v + 33 | 0] << 8 | (l[v + 34 | 0] << 16 | l[v + 35 | 0] << 24), t[a + 212 >> 2] = I, I = v + 32 | 0, T = a + 104 | 0, n = 0; E = (a + 208 | 0) + n | 0, u[E | 0] = l[E | 0] ^ 92, L = E + 1 | 0, u[L | 0] = l[L | 0] ^ 92, L = E + 2 | 0, u[L | 0] = l[L | 0] ^ 92, E = E + 3 | 0, u[E | 0] = l[E | 0] ^ 92, n = n + 4 | 0, (n | 0) != 64; )
        ;
      for (Tn(T, a + 208 | 0, 64), t[a + 96 >> 2] = 0, t[a + 100 >> 2] = 0, t[a + 24 >> 2] = 528734635, t[a + 28 >> 2] = 1541459225, t[a + 16 >> 2] = 1359893119, t[a + 20 >> 2] = -1694144372, t[a + 8 >> 2] = 1013904242, t[a + 12 >> 2] = -1521486534, t[a >> 2] = 1779033703, t[a + 4 >> 2] = -1150833019, n = 0; E = (a + 208 | 0) + n | 0, u[E | 0] = l[E | 0] ^ 106, L = E + 1 | 0, u[L | 0] = l[L | 0] ^ 106, L = E + 2 | 0, u[L | 0] = l[L | 0] ^ 106, E = E + 3 | 0, u[E | 0] = l[E | 0] ^ 106, n = n + 4 | 0, (n | 0) != 64; )
        ;
      for (E = a + 208 | 0, Tn(a, E, 64), Tn(a, v, 32), Tn(a, 690370, 1), Yn(a, E), Tn(T, E, 32), Yn(T, I), n = a + 248 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = a + 256 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = a + 264 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = I + 24 | 0, L = l[n + 4 | 0] | l[n + 5 | 0] << 8 | (l[n + 6 | 0] << 16 | l[n + 7 | 0] << 24), he = E + 24 | 0, t[he >> 2] = l[n | 0] | l[n + 1 | 0] << 8 | (l[n + 2 | 0] << 16 | l[n + 3 | 0] << 24), t[he + 4 >> 2] = L, n = I + 16 | 0, L = l[n + 4 | 0] | l[n + 5 | 0] << 8 | (l[n + 6 | 0] << 16 | l[n + 7 | 0] << 24), E = E + 16 | 0, t[E >> 2] = l[n | 0] | l[n + 1 | 0] << 8 | (l[n + 2 | 0] << 16 | l[n + 3 | 0] << 24), t[E + 4 >> 2] = L, t[a + 200 >> 2] = 0, t[a + 204 >> 2] = 0, t[a + 128 >> 2] = 528734635, t[a + 132 >> 2] = 1541459225, t[a + 120 >> 2] = 1359893119, t[a + 124 >> 2] = -1694144372, t[a + 112 >> 2] = 1013904242, t[a + 116 >> 2] = -1521486534, t[a + 104 >> 2] = 1779033703, t[a + 108 >> 2] = -1150833019, t[a + 240 >> 2] = 0, t[a + 244 >> 2] = 0, n = I + 8 | 0, E = l[n + 4 | 0] | l[n + 5 | 0] << 8 | (l[n + 6 | 0] << 16 | l[n + 7 | 0] << 24), t[a + 216 >> 2] = l[n | 0] | l[n + 1 | 0] << 8 | (l[n + 2 | 0] << 16 | l[n + 3 | 0] << 24), t[a + 220 >> 2] = E, n = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), t[a + 208 >> 2] = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), t[a + 212 >> 2] = n, n = 0; I = (a + 208 | 0) + n | 0, u[I | 0] = l[I | 0] ^ 92, E = I + 1 | 0, u[E | 0] = l[E | 0] ^ 92, E = I + 2 | 0, u[E | 0] = l[E | 0] ^ 92, I = I + 3 | 0, u[I | 0] = l[I | 0] ^ 92, n = n + 4 | 0, (n | 0) != 64; )
        ;
      for (Tn(T, a + 208 | 0, 64), t[a + 96 >> 2] = 0, t[a + 100 >> 2] = 0, t[a + 24 >> 2] = 528734635, t[a + 28 >> 2] = 1541459225, t[a + 16 >> 2] = 1359893119, t[a + 20 >> 2] = -1694144372, t[a + 8 >> 2] = 1013904242, t[a + 12 >> 2] = -1521486534, t[a >> 2] = 1779033703, t[a + 4 >> 2] = -1150833019, n = 0; I = (a + 208 | 0) + n | 0, u[I | 0] = l[I | 0] ^ 106, E = I + 1 | 0, u[E | 0] = l[E | 0] ^ 106, E = I + 2 | 0, u[E | 0] = l[E | 0] ^ 106, I = I + 3 | 0, u[I | 0] = l[I | 0] ^ 106, n = n + 4 | 0, (n | 0) != 64; )
        ;
      I = a + 208 | 0, Tn(a, I, 64), Tn(a, v, 32), Yn(a, I), Tn(T, I, 32), Yn(T, v);
    }
    for (I = a + 208 | 0, n = I + 40 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = I + 48 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, I = I + 56 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = a + 200 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = a + 128 | 0, t[I >> 2] = 528734635, t[I + 4 >> 2] = 1541459225, I = a + 120 | 0, t[I >> 2] = 1359893119, t[I + 4 >> 2] = -1694144372, I = a + 112 | 0, t[I >> 2] = 1013904242, t[I + 4 >> 2] = -1521486534, I = v + 56 | 0, n = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), T = a + 232 | 0, t[T >> 2] = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), t[T + 4 >> 2] = n, I = v + 48 | 0, n = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), T = a + 224 | 0, t[T >> 2] = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), t[T + 4 >> 2] = n, t[a + 104 >> 2] = 1779033703, t[a + 108 >> 2] = -1150833019, t[a + 240 >> 2] = 0, t[a + 244 >> 2] = 0, I = v + 40 | 0, n = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), t[a + 216 >> 2] = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), t[a + 220 >> 2] = n, I = l[v + 36 | 0] | l[v + 37 | 0] << 8 | (l[v + 38 | 0] << 16 | l[v + 39 | 0] << 24), t[a + 208 >> 2] = l[v + 32 | 0] | l[v + 33 | 0] << 8 | (l[v + 34 | 0] << 16 | l[v + 35 | 0] << 24), t[a + 212 >> 2] = I, T = a + 104 | 0, n = 0; I = (a + 208 | 0) + n | 0, u[I | 0] = l[I | 0] ^ 92, E = I + 1 | 0, u[E | 0] = l[E | 0] ^ 92, E = I + 2 | 0, u[E | 0] = l[E | 0] ^ 92, I = I + 3 | 0, u[I | 0] = l[I | 0] ^ 92, n = n + 4 | 0, (n | 0) != 64; )
      ;
    for (Tn(T, a + 208 | 0, 64), t[a + 96 >> 2] = 0, t[a + 100 >> 2] = 0, t[a + 24 >> 2] = 528734635, t[a + 28 >> 2] = 1541459225, t[a + 16 >> 2] = 1359893119, t[a + 20 >> 2] = -1694144372, t[a + 8 >> 2] = 1013904242, t[a + 12 >> 2] = -1521486534, t[a >> 2] = 1779033703, t[a + 4 >> 2] = -1150833019, n = 0; I = (a + 208 | 0) + n | 0, u[I | 0] = l[I | 0] ^ 106, E = I + 1 | 0, u[E | 0] = l[E | 0] ^ 106, E = I + 2 | 0, u[E | 0] = l[E | 0] ^ 106, I = I + 3 | 0, u[I | 0] = l[I | 0] ^ 106, n = n + 4 | 0, (n | 0) != 64; )
      ;
    I = a + 208 | 0, Tn(a, I, 64), Tn(a, v, 32), Yn(a, I), Tn(T, I, 32), Yn(T, v), I = v + 24 | 0, T = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), n = d + 24 | 0, I = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), u[n | 0] = I, u[n + 1 | 0] = I >>> 8, u[n + 2 | 0] = I >>> 16, u[n + 3 | 0] = I >>> 24, u[n + 4 | 0] = T, u[n + 5 | 0] = T >>> 8, u[n + 6 | 0] = T >>> 16, u[n + 7 | 0] = T >>> 24, I = v + 16 | 0, T = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), n = d + 16 | 0, I = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), u[n | 0] = I, u[n + 1 | 0] = I >>> 8, u[n + 2 | 0] = I >>> 16, u[n + 3 | 0] = I >>> 24, u[n + 4 | 0] = T, u[n + 5 | 0] = T >>> 8, u[n + 6 | 0] = T >>> 16, u[n + 7 | 0] = T >>> 24, I = v + 8 | 0, T = l[I + 4 | 0] | l[I + 5 | 0] << 8 | (l[I + 6 | 0] << 16 | l[I + 7 | 0] << 24), n = d + 8 | 0, I = l[I | 0] | l[I + 1 | 0] << 8 | (l[I + 2 | 0] << 16 | l[I + 3 | 0] << 24), u[n | 0] = I, u[n + 1 | 0] = I >>> 8, u[n + 2 | 0] = I >>> 16, u[n + 3 | 0] = I >>> 24, u[n + 4 | 0] = T, u[n + 5 | 0] = T >>> 8, u[n + 6 | 0] = T >>> 16, u[n + 7 | 0] = T >>> 24, I = l[v + 4 | 0] | l[v + 5 | 0] << 8 | (l[v + 6 | 0] << 16 | l[v + 7 | 0] << 24), n = l[v | 0] | l[v + 1 | 0] << 8 | (l[v + 2 | 0] << 16 | l[v + 3 | 0] << 24), u[d | 0] = n, u[d + 1 | 0] = n >>> 8, u[d + 2 | 0] = n >>> 16, u[d + 3 | 0] = n >>> 24, u[d + 4 | 0] = I, u[d + 5 | 0] = I >>> 8, u[d + 6 | 0] = I >>> 16, u[d + 7 | 0] = I >>> 24, t[v + 64 >> 2] = 1, x = a + 272 | 0;
  }
  function Sn(v, d, I, n, a, E) {
    var T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0, Xn = 0, Zn = 0, ni = 0, ai = 0, fi = 0;
    tr = x - 464 | 0, x = tr, T = d + 24 | 0, t[T >> 2] = 0, t[T + 4 >> 2] = 0, T = d + 16 | 0, t[T >> 2] = 0, t[T + 4 >> 2] = 0, T = d + 8 | 0, t[T >> 2] = 0, t[T + 4 >> 2] = 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, T = I + 24 | 0, t[T >> 2] = 0, t[T + 4 >> 2] = 0, T = I + 16 | 0, t[T >> 2] = 0, t[T + 4 >> 2] = 0, T = I + 8 | 0, t[T >> 2] = 0, t[T + 4 >> 2] = 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, n && (t[n >> 2] = 0), Zr(tr + 96 | 0, 690788, tr + 256 | 0), dr = t[tr + 120 >> 2], cr = t[tr + 112 >> 2], Me = t[tr + 104 >> 2], or = t[tr + 96 >> 2], Mr = t[tr + 124 >> 2], Ir = t[tr + 116 >> 2], he = t[tr + 108 >> 2], gr = t[tr + 100 >> 2], L = t[tr + 256 >> 2] | !(dr | (cr | (Me | or)) | (Mr | (Ir | (he | gr)))), T = L ? 0 : -1, t[tr + 120 >> 2] = T & dr, t[tr + 124 >> 2] = T & Mr, t[tr + 112 >> 2] = T & cr, t[tr + 116 >> 2] = T & Ir, t[tr + 104 >> 2] = T & Me, t[tr + 108 >> 2] = T & he, t[tr + 96 >> 2] = T & or | (L | 0) != 0, t[tr + 100 >> 2] = T & gr, Zr(tr + 32 | 0, 655649, 0), ai = !L, Xn = a || 4;
    e: {
      if (!(Qn[Xn | 0](tr, 655649, 690788, 0, E, 0) | 0))
        break e;
      for (a = 1; ; ) {
        Zn = a, Zr(tr - -64 | 0, tr, tr + 256 | 0);
        t: {
          if (t[tr + 256 >> 2] | !(t[tr + 88 >> 2] | (t[tr + 80 >> 2] | (t[tr + 72 >> 2] | t[tr + 64 >> 2])) | (t[tr + 92 >> 2] | (t[tr + 84 >> 2] | (t[tr + 76 >> 2] | t[tr + 68 >> 2])))) || (t[tr + 132 >> 2] = 0, a = tr + 256 | 0, hi(v, a, tr - -64 | 0), ki(tr + 168 | 0, a), T = tr, Ir = t[T + 232 >> 2], Mr = t[T + 236 >> 2], dr = t[T + 224 >> 2], gr = t[T + 228 >> 2], Me = t[T + 216 >> 2], he = t[T + 220 >> 2], Be = t[T + 212 >> 2], or = t[T + 240 >> 2], cr = t[T + 244 >> 2], $r = cr, a = t[T + 208 >> 2], cr = pn(cr >>> 16 | 0, 0, 977, 1), L = a + cr | 0, a = Be + Ee | 0, cr = L >>> 0 < cr >>> 0 ? a + 1 | 0 : a, a = he, Be = cr >>> 20 | 0, xr = Be, Be = Me + Be | 0, he = xr >>> 0 > Be >>> 0 ? a + 1 | 0 : a, a = gr, Me = he >>> 20 | 0, gr = Me, Me = Me + dr | 0, dr = gr >>> 0 > Me >>> 0 ? a + 1 | 0 : a, a = Mr, gr = dr >>> 20 | 0, xr = gr, gr = Ir + gr | 0, a = xr >>> 0 > gr >>> 0 ? a + 1 | 0 : a, gn = Me, Ir = a, ni = dr & 1048575, dr = (gr & (Me & Be)) == -1 & (a & (ni & he)) == 1048575, a = $r & 65535, Me = Ir >>> 20 | 0, xr = Me, Me = Me + or | 0, Mr = xr >>> 0 > Me >>> 0 ? a + 1 | 0 : a, a = cr & 1048575, Bn = Me, Me = pn(dr & ((Me | 0) == -1 & (Mr | 0) == 65535) & ((a | 0) == 1048574 & L >>> 0 > 4294966318 | a >>> 0 > 1048574) | Mr >>> 16, 0, 977, 1) + L | 0, a = Ee + a | 0, jn = Me, t[T + 208 >> 2] = Me, dr = L >>> 0 > Me >>> 0 ? a + 1 | 0 : a, t[T + 212 >> 2] = dr & 1048575, $r = t[T + 192 >> 2], xr = t[T + 196 >> 2], cr = t[T + 184 >> 2], kn = t[T + 188 >> 2], or = t[T + 176 >> 2], Wr = t[T + 180 >> 2], Un = t[T + 172 >> 2], Gn = t[T + 200 >> 2], Me = t[T + 204 >> 2], fi = Me, a = t[T + 168 >> 2], L = pn(Me >>> 16 | 0, 0, 977, 1), Me = a + L | 0, a = Un + Ee | 0, Un = L >>> 0 > Me >>> 0 ? a + 1 | 0 : a, a = Wr, L = Un >>> 20 | 0, Wr = L, L = L + or | 0, Wr = Wr >>> 0 > L >>> 0 ? a + 1 | 0 : a, a = kn, or = Wr >>> 20 | 0, kn = or, or = or + cr | 0, xn = kn >>> 0 > or >>> 0 ? a + 1 | 0 : a, a = xr, cr = xn >>> 20 | 0, $r = cr + $r | 0, a = cr >>> 0 > $r >>> 0 ? a + 1 | 0 : a, cr = Wr & 1048575, kn = or, xr = a, xn = xn & 1048575, or = (L & or & $r) == -1 & (a & (Wr & xn)) == 1048575, a = fi & 65535, T = xr >>> 20 | 0, Wr = T, T = T + Gn | 0, Wr = Wr >>> 0 > T >>> 0 ? a + 1 | 0 : a, a = Un & 1048575, Gn = T, T = pn(or & ((T | 0) == -1 & (Wr | 0) == 65535) & ((a | 0) == 1048574 & Me >>> 0 > 4294966318 | a >>> 0 > 1048574) | Wr >>> 16, 0, 977, 1) + Me | 0, a = Ee + a | 0, a = T >>> 0 < Me >>> 0 ? a + 1 | 0 : a, Me = T, T = a, a = cr, or = T >>> 20 | 0, cr = or, or = L + or | 0, a = cr >>> 0 > or >>> 0 ? a + 1 | 0 : a, t[tr + 176 >> 2] = or, L = a, t[tr + 180 >> 2] = a & 1048575, a = he & 1048575, dr = dr >>> 20 | 0, Be = Be + dr | 0, a = dr >>> 0 > Be >>> 0 ? a + 1 | 0 : a, t[tr + 216 >> 2] = Be, t[tr + 220 >> 2] = a & 1048575, Be = a, a = ni, Be = (Be >>> 20 | 0) + gn | 0, a = Be >>> 0 < gn >>> 0 ? a + 1 | 0 : a, t[tr + 224 >> 2] = Be, gn = a, t[tr + 228 >> 2] = a & 1048575, he = tr, Be = $r, xr = xr & 1048575, a = xn, $r = L, cr = (L >>> 20 | 0) + kn | 0, L = cr >>> 0 < kn >>> 0 ? a + 1 | 0 : a, a = xr, dr = L >>> 20 | 0, xr = dr, dr = Be + dr | 0, a = xr >>> 0 > dr >>> 0 ? a + 1 | 0 : a, t[he + 192 >> 2] = dr, Be = a, t[he + 196 >> 2] = a & 1048575, a = Ir & 1048575, Ir = gn >>> 20 | 0, gr = Ir + gr | 0, a = Ir >>> 0 > gr >>> 0 ? a + 1 | 0 : a, t[he + 232 >> 2] = gr, gr = a, t[he + 236 >> 2] = a & 1048575, a = Wr, Ir = Be, xr = (Be >>> 20 | 0) + Gn | 0, a = xr >>> 0 < Gn >>> 0 ? a + 1 | 0 : a, t[he + 200 >> 2] = xr, Be = a, t[he + 204 >> 2] = a & 65535, a = Mr, gr = (gr >>> 20 | 0) + Bn | 0, a = gr >>> 0 < Bn >>> 0 ? a + 1 | 0 : a, t[he + 240 >> 2] = gr, t[he + 244 >> 2] = a & 65535, gr = cr, t[he + 184 >> 2] = cr, a = L & 1048575, t[he + 188 >> 2] = a, t[he + 168 >> 2] = Me, cr = T & 1048575, t[he + 172 >> 2] = cr, u[he + 415 | 0] = Me, u[he + 414 | 0] = (T & 255) << 24 | Me >>> 8, u[he + 413 | 0] = (T & 65535) << 16 | Me >>> 16, u[he + 412 | 0] = (T & 16777215) << 8 | Me >>> 24, u[he + 411 | 0] = T, u[he + 410 | 0] = T >>> 8, T = or >>> 28 | 0, u[he + 409 | 0] = or << 4 | cr >>> 16, u[he + 408 | 0] = ($r & 15) << 28 | or >>> 4, u[he + 407 | 0] = ($r & 4095) << 20 | or >>> 12, u[he + 406 | 0] = ($r & 1048575) << 12 | or >>> 20, u[he + 405 | 0] = T | ($r & 268435455) << 4, u[he + 404 | 0] = $r >>> 4, u[he + 403 | 0] = $r >>> 12, u[he + 402 | 0] = gr, u[he + 401 | 0] = (L & 255) << 24 | gr >>> 8, u[he + 400 | 0] = (L & 65535) << 16 | gr >>> 16, u[he + 399 | 0] = (L & 16777215) << 8 | gr >>> 24, u[he + 398 | 0] = L, u[he + 397 | 0] = L >>> 8, T = dr >>> 28 | 0, u[he + 396 | 0] = dr << 4 | a >>> 16, u[he + 395 | 0] = (Ir & 15) << 28 | dr >>> 4, u[he + 394 | 0] = (Ir & 4095) << 20 | dr >>> 12, u[he + 393 | 0] = (Ir & 1048575) << 12 | dr >>> 20, u[he + 392 | 0] = T | (Ir & 268435455) << 4, u[he + 391 | 0] = Ir >>> 4, u[he + 390 | 0] = Ir >>> 12, u[he + 389 | 0] = xr, u[he + 388 | 0] = (Be & 255) << 24 | xr >>> 8, u[he + 387 | 0] = (Be & 65535) << 16 | xr >>> 16, u[he + 386 | 0] = (Be & 16777215) << 8 | xr >>> 24, u[he + 385 | 0] = Be, u[he + 384 | 0] = Be >>> 8, Zr(d, he + 384 | 0, he + 132 | 0), n && (t[n >> 2] = jn & 1 | t[he + 132 >> 2] << 1), gn = he + 136 | 0, Er(gn, d, he + 96 | 0), L = t[he + 32 >> 2], Be = t[he + 136 >> 2], gr = L + Be | 0, T = t[he + 36 >> 2], a = T + t[he + 140 >> 2] | 0, Me = Be >>> 0 > gr >>> 0 ? a + 1 | 0 : a, Mr = (T | 0) == (Me | 0) & L >>> 0 > gr >>> 0 | T >>> 0 > Me >>> 0, L = t[he + 144 >> 2], T = Mr + L | 0, a = t[he + 148 >> 2], a = T >>> 0 < L >>> 0 ? a + 1 | 0 : a, Be = T, T = t[he + 40 >> 2], cr = Be + T | 0, L = a, a = a + t[he + 44 >> 2] | 0, or = T >>> 0 > cr >>> 0 ? a + 1 | 0 : a, Wr = t[he + 48 >> 2], T = t[he + 152 >> 2], dr = Wr + T | 0, $r = t[he + 52 >> 2], a = $r + t[he + 156 >> 2] | 0, T = T >>> 0 > dr >>> 0 ? a + 1 | 0 : a, Ir = dr, a = !L & Be >>> 0 < Mr >>> 0, Be = (L | 0) == (or | 0) & Be >>> 0 > cr >>> 0 | L >>> 0 > or >>> 0, L = a + Be | 0, a = (L >>> 0 < Be >>> 0) + T | 0, dr = L + dr | 0, Be = dr >>> 0 < L >>> 0 ? a + 1 | 0 : a, Bn = t[he + 56 >> 2], L = t[he + 160 >> 2], Mr = Bn + L | 0, xr = t[he + 60 >> 2], a = xr + t[he + 164 >> 2] | 0, L = L >>> 0 > Mr >>> 0 ? a + 1 | 0 : a, a = (T | 0) == ($r | 0) & Ir >>> 0 < Wr >>> 0 | T >>> 0 < $r >>> 0, Ir = (T | 0) == (Be | 0) & dr >>> 0 < Ir >>> 0 | T >>> 0 > Be >>> 0, T = a + Ir | 0, a = (T >>> 0 < Ir >>> 0) + L | 0, Ir = T, T = T + Mr | 0, a = Ir >>> 0 > T >>> 0 ? a + 1 | 0 : a, Ir = T, T = he, $r = a, xr = ((L | 0) == (xr | 0) & Mr >>> 0 < Bn >>> 0 | L >>> 0 < xr >>> 0) + ((L | 0) == (a | 0) & Ir >>> 0 < Mr >>> 0 | a >>> 0 < L >>> 0) | 0, L = (Be | 0) == -1, he = L & dr >>> 0 < 4294967294 | (Be | 0) != -1 | (Ir & a) != -1, a = (or | 0) == -1162945306, Mr = (he | (a & cr >>> 0 < 2940772411 | or >>> 0 < 3132021990)) ^ -1, Wr = xr + (Mr & ((Me | 0) == -1076732276 & gr >>> 0 > 3493216576 | Me >>> 0 > 3218235020) | (Mr & (a & cr >>> 0 > 2940772411 | or >>> 0 > 3132021990) | (dr | 0) == -1 & L & (he ^ -1))) | 0, he = pn(Wr, 0, 801750719, 1076732275), L = he + gr | 0, a = Me + Ee | 0, xr = L, t[T + 136 >> 2] = L, he = L >>> 0 < he >>> 0 ? a + 1 | 0 : a, t[T + 140 >> 2] = he, L = T, T = pn(Wr, 0, 1354194884, 1162945305), Mr = T + cr | 0, a = or + Ee | 0, he = (he | 0) == (Me | 0) & gr >>> 0 > xr >>> 0 | he >>> 0 < Me >>> 0, Me = Mr + he | 0, a = T >>> 0 > Mr >>> 0 ? a + 1 | 0 : a, T = a, xr = Me, t[L + 144 >> 2] = Me, he = he >>> 0 > Me >>> 0 ? a + 1 | 0 : a, t[L + 148 >> 2] = he, Me = L, a = Be, gr = dr + Wr | 0, L = gr >>> 0 < Wr >>> 0 ? a + 1 | 0 : a, a = (T | 0) == (or | 0) & cr >>> 0 > Mr >>> 0 | T >>> 0 < or >>> 0, or = (T | 0) == (he | 0) & Mr >>> 0 > xr >>> 0 | T >>> 0 > he >>> 0, T = a + or | 0, a = (T >>> 0 < or >>> 0) + L | 0, xr = T, T = T + gr | 0, a = xr >>> 0 > T >>> 0 ? a + 1 | 0 : a, t[Me + 152 >> 2] = T, t[Me + 156 >> 2] = a, Be = (L | 0) == (Be | 0) & dr >>> 0 > gr >>> 0 | L >>> 0 < Be >>> 0, L = (a | 0) == (L | 0) & T >>> 0 < gr >>> 0 | a >>> 0 < L >>> 0, T = Be + L | 0, a = $r + (T >>> 0 < L >>> 0) | 0, T = T + Ir | 0, a = T >>> 0 < Ir >>> 0 ? a + 1 | 0 : a, t[Me + 160 >> 2] = T, t[Me + 164 >> 2] = a, T = t[Me + 88 >> 2], L = t[Me + 92 >> 2], t[Me + 456 >> 2] = L >>> 24, t[Me + 460 >> 2] = 0, L = L << 6 | T >>> 26, Be = t[Me + 80 >> 2], or = t[Me + 84 >> 2], t[Me + 448 >> 2] = T << 6 | or >>> 26, t[Me + 452 >> 2] = L & 1073741823, T = Be, L = or << 4 | T >>> 28, Be = t[Me + 72 >> 2], or = t[Me + 76 >> 2], t[Me + 440 >> 2] = T << 4 | or >>> 28, t[Me + 444 >> 2] = L & 1073741823, T = Be, L = or << 2 | T >>> 30, Be = t[tr + 64 >> 2], Me = t[tr + 68 >> 2], t[tr + 432 >> 2] = T << 2 | Me >>> 30, t[tr + 436 >> 2] = L & 1073741823, t[tr + 424 >> 2] = Be, t[tr + 428 >> 2] = Me & 1073741823, xi(tr + 424 | 0, 690320), L = t[tr + 456 >> 2] << 24, Me = t[tr + 452 >> 2], a = Me >>> 6 | 0, Be = t[tr + 448 >> 2], t[I + 24 >> 2] = (Me & 63) << 26 | Be >>> 6, t[I + 28 >> 2] = a | L, L = Be << 26, Me = t[tr + 444 >> 2], a = Me >>> 4 | 0, Be = t[tr + 440 >> 2], t[I + 16 >> 2] = (Me & 15) << 28 | Be >>> 4, t[I + 20 >> 2] = a | L, L = Be << 28, Me = t[tr + 436 >> 2], a = Me >>> 2 | 0, Be = t[tr + 432 >> 2], t[I + 8 >> 2] = (Me & 3) << 30 | Be >>> 2, t[I + 12 >> 2] = a | L, L = t[tr + 428 >> 2], a = Be << 30, t[I >> 2] = t[tr + 424 >> 2], t[I + 4 >> 2] = a | L, Er(I, I, gn), a = t[I + 28 >> 2], Mr = a, a = a >>> 31 | 0, T = a ^ -1, he = t[I + 12 >> 2], Be = (he | 0) == 1566010995, cr = t[I + 8 >> 2], xr = t[I + 16 >> 2], Wr = t[I + 20 >> 2], $r = t[I + 24 >> 2], T = (T & (Be & cr >>> 0 < 1470386205 | he >>> 0 < 1566010995) | ((xr & Wr) != -1 & T | ((Mr | 0) == 2147483647 & ($r | 0) != -1 | Mr >>> 0 < 2147483647))) ^ -1, L = t[I + 4 >> 2], or = t[I >> 2], Ir = T & ((L | 0) == -538366138 & or >>> 0 > 1746608288 | L >>> 0 > 3756601158) | (T & (Be & cr >>> 0 > 1470386205 | he >>> 0 > 1566010995) | a), gr = Ir ? -801750718 : 0, Me = Ir ? -1 : 0, Be = Me ^ or, T = gr + Be | 0, gn = Ir ? -1076732276 : 0, a = gn + (L ^ Me) | 0, or = xr | $r | cr | or | (Mr | Wr | he | L) ? -1 : 0, kn = T & or, t[I >> 2] = kn, Be = T >>> 0 < Be >>> 0 ? a + 1 | 0 : a, Gn = or & Be, t[I + 4 >> 2] = Gn, L = I, Bn = Ir ? -1162945306 : 0, a = Bn + (he ^ Me) | 0, dr = (Be | 0) == (gn | 0) & T >>> 0 < gr >>> 0 | Be >>> 0 < gn >>> 0, jn = Ir ? -1354194885 : 0, T = Me ^ cr, cr = jn + T | 0, Be = dr + cr | 0, a = T >>> 0 > cr >>> 0 ? a + 1 | 0 : a, T = a, gr = Be, gn = Be & or, t[L + 8 >> 2] = gn, dr = Be >>> 0 < dr >>> 0 ? a + 1 | 0 : a, Un = or & dr, t[L + 12 >> 2] = Un, Be = L, xn = Ir ? -2 : 0, L = Me ^ xr, he = xn + L | 0, xr = Ir ? -1 : 0, a = xr + (Me ^ Wr) | 0, L = L >>> 0 > he >>> 0 ? a + 1 | 0 : a, a = (T | 0) == (Bn | 0) & cr >>> 0 < jn >>> 0 | T >>> 0 < Bn >>> 0, cr = (T | 0) == (dr | 0) & cr >>> 0 > gr >>> 0 | T >>> 0 > dr >>> 0, T = a + cr | 0, a = (T >>> 0 < cr >>> 0) + L | 0, gr = T, T = T + he | 0, a = gr >>> 0 > T >>> 0 ? a + 1 | 0 : a, cr = T & or, t[Be + 16 >> 2] = cr, dr = a & or, t[Be + 20 >> 2] = dr, Be = (L | 0) == (xr | 0) & he >>> 0 < xn >>> 0 | L >>> 0 < xr >>> 0, L = (a | 0) == (L | 0) & T >>> 0 < he >>> 0 | a >>> 0 < L >>> 0, T = Be + L | 0, a = T >>> 0 < L >>> 0, L = Me ^ $r, Be = L - Ir | 0, T = Be + T | 0, a = a + ((Me ^ Mr) - (L >>> 0 < Ir >>> 0) | 0) | 0, a = T >>> 0 < Be >>> 0 ? a + 1 | 0 : a, T = T & or, t[I + 24 >> 2] = T, a = a & or, t[I + 28 >> 2] = a, n && (t[n >> 2] = t[n >> 2] ^ Ir), !(gn | kn | cr | T | (Un | Gn | dr | a))) || !(t[d + 24 >> 2] | (t[d + 16 >> 2] | (t[d + 8 >> 2] | t[d >> 2])) | (t[d + 28 >> 2] | (t[d + 20 >> 2] | (t[d + 12 >> 2] | t[d + 4 >> 2])))))
            break t;
          Be = 1;
          break e;
        }
        if (a = Zn + 1 | 0, Be = 0, !(Qn[Xn | 0](tr, 655649, 690788, 0, E, Zn) | 0))
          break;
      }
    }
    return T = Be & ai, E = !T, v = E - 1 | 0, a = 0 - !E | 0, L = a & t[d + 4 >> 2], t[d >> 2] = v & t[d >> 2], t[d + 4 >> 2] = L, L = t[d + 12 >> 2] & a, t[d + 8 >> 2] = t[d + 8 >> 2] & v, t[d + 12 >> 2] = L, L = t[d + 20 >> 2] & a, t[d + 16 >> 2] = t[d + 16 >> 2] & v, t[d + 20 >> 2] = L, L = t[d + 28 >> 2] & a, t[d + 24 >> 2] = t[d + 24 >> 2] & v, t[d + 28 >> 2] = L, d = t[I + 4 >> 2] & a, t[I >> 2] = t[I >> 2] & v, t[I + 4 >> 2] = d, d = t[I + 12 >> 2] & a, t[I + 8 >> 2] = t[I + 8 >> 2] & v, t[I + 12 >> 2] = d, d = t[I + 20 >> 2] & a, t[I + 16 >> 2] = t[I + 16 >> 2] & v, t[I + 20 >> 2] = d, d = t[I + 28 >> 2] & a, t[I + 24 >> 2] = t[I + 24 >> 2] & v, t[I + 28 >> 2] = d, n && (t[tr + 256 >> 2] = E, t[n >> 2] = t[n >> 2] & t[tr + 256 >> 2] - 1), x = tr + 464 | 0, T;
  }
  function hi(v, d, I) {
    var n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0, Xn = 0, Zn = 0, ni = 0;
    for (E = x - 128 | 0, x = E, Gn = $i(d, v + 40 | 0, 128), T = t[v + 8 >> 2], Be = t[I >> 2], $r = T + Be | 0, d = t[v + 12 >> 2], n = d + t[I + 4 >> 2] | 0, L = Be >>> 0 > $r >>> 0 ? n + 1 | 0 : n, he = (d | 0) == (L | 0) & T >>> 0 > $r >>> 0 | d >>> 0 > L >>> 0, T = t[I + 8 >> 2], n = he + T | 0, d = t[I + 12 >> 2], d = n >>> 0 < T >>> 0 ? d + 1 | 0 : d, T = n, n = v + 16 | 0, Be = t[n >> 2], Wr = T + Be | 0, n = d + t[n + 4 >> 2] | 0, he = !d & T >>> 0 < he >>> 0, Be = Be >>> 0 > Wr >>> 0 ? n + 1 | 0 : n, T = (d | 0) == (Be | 0) & T >>> 0 > Wr >>> 0 | d >>> 0 > Be >>> 0, n = he + T | 0, d = n >>> 0 < T >>> 0, cr = n, n = t[I + 16 >> 2], he = cr + n | 0, T = d, d = d + t[I + 20 >> 2] | 0, n = n >>> 0 > he >>> 0 ? d + 1 | 0 : d, d = v + 24 | 0, xr = t[d >> 2], tr = xr + he | 0, d = n + t[d + 4 >> 2] | 0, cr = (n | 0) == (T | 0) & he >>> 0 < cr >>> 0 | n >>> 0 < T >>> 0, T = tr >>> 0 < xr >>> 0 ? d + 1 | 0 : d, d = he, he = tr, tr = (n | 0) == (T | 0) & d >>> 0 > he >>> 0 | n >>> 0 > T >>> 0, n = cr + tr | 0, d = n >>> 0 < tr >>> 0, xr = n, cr = t[I + 24 >> 2], tr = n + cr | 0, n = d, d = d + t[I + 28 >> 2] | 0, d = tr >>> 0 < cr >>> 0 ? d + 1 | 0 : d, v = v + 32 | 0, cr = t[v >> 2], I = cr + tr | 0, v = d + t[v + 4 >> 2] | 0, gn = I >>> 0 < cr >>> 0 ? v + 1 | 0 : v, cr = I, xr = ((d | 0) == (n | 0) & tr >>> 0 < xr >>> 0 | d >>> 0 < n >>> 0) + ((d | 0) == (gn | 0) & I >>> 0 < tr >>> 0 | d >>> 0 > gn >>> 0) | 0, d = (T | 0) == -1, I = d & he >>> 0 < 4294967294 | (T | 0) != -1 | (I & gn) != -1, v = (Be | 0) == -1162945306, n = (I | (v & Wr >>> 0 < 2940772411 | Be >>> 0 < 3132021990)) ^ -1, tr = xr + (n & ((L | 0) == -1076732276 & $r >>> 0 > 3493216576 | L >>> 0 > 3218235020) | (n & (v & Wr >>> 0 > 2940772411 | Be >>> 0 > 3132021990) | (he | 0) == -1 & d & (I ^ -1))) | 0, v = pn(tr, 0, 801750719, 1076732275), I = v + $r | 0, d = L + Ee | 0, t[E + 8 >> 2] = I, d = v >>> 0 > I >>> 0 ? d + 1 | 0 : d, t[E + 12 >> 2] = d, v = E, L = (d | 0) == (L | 0) & I >>> 0 < $r >>> 0 | d >>> 0 < L >>> 0, n = pn(tr, 0, 1354194884, 1162945305), I = n + Wr | 0, d = Be + Ee | 0, d = I >>> 0 < n >>> 0 ? d + 1 | 0 : d, L = I + L | 0, n = L >>> 0 < I >>> 0 ? d + 1 | 0 : d, t[v + 16 >> 2] = L, t[v + 20 >> 2] = n, n = (d | 0) == (n | 0) & I >>> 0 > L >>> 0 | d >>> 0 > n >>> 0, I = n + ((d | 0) == (Be | 0) & I >>> 0 < Wr >>> 0 | d >>> 0 < Be >>> 0) | 0, d = I >>> 0 < n >>> 0, n = I, Be = d, d = T, L = he + tr | 0, I = L >>> 0 < he >>> 0 ? d + 1 | 0 : d, d = I + Be | 0, xr = n, n = L, L = xr + n | 0, t[v + 24 >> 2] = L, d = n >>> 0 > L >>> 0 ? d + 1 | 0 : d, t[v + 28 >> 2] = d, v = (I | 0) == (T | 0) & n >>> 0 < he >>> 0 | I >>> 0 < T >>> 0, I = (d | 0) == (I | 0) & n >>> 0 > L >>> 0 | d >>> 0 < I >>> 0, d = v + I | 0, n = gn + (d >>> 0 < I >>> 0) | 0, v = d + cr | 0, n = v >>> 0 < cr >>> 0 ? n + 1 | 0 : n, t[E + 32 >> 2] = v, t[E + 36 >> 2] = n, I = 0, Wr = 0, T = 0, $r = 0, tr = 0, cr = 0, Be = 0, L = 0, xr = 0, he = 0, gn = 0; t[E + 120 >> 2] = 0, d = (E + 8 | 0) + (jn >>> 2 & 1073741816) | 0, v = t[d >> 2], n = t[d + 4 >> 2], a = Xn & 62, d = a & 31, a >>> 0 >= 32 ? v = n >>> d | 0 : v = ((1 << d) - 1 & n) << 32 - d | v >>> d, or = v & 3, dr = (or | 0) == 1, a = Bn + 656432 | 0, v = a + 248 | 0, d = a + 184 | 0, n = a + 120 | 0, Me = a + 56 | 0, gr = (or | 0) == 2, Ir = (or | 0) == 3, I = Ir ? t[v >> 2] : gr ? t[d >> 2] : dr ? t[n >> 2] : or ? I : t[Me >> 2], d = Ir ? t[v + 4 >> 2] : gr ? t[d + 4 >> 2] : dr ? t[n + 4 >> 2] : or ? Wr : t[Me + 4 >> 2], Wr = d, v = d >>> 16 | 0, t[E + 112 >> 2] = (d & 65535) << 16 | I >>> 16, t[E + 116 >> 2] = v, v = a + 224 | 0, d = a + 160 | 0, n = a + 96 | 0, Me = a + 32 | 0, Zn = Ir ? t[v >> 2] : gr ? t[d >> 2] : dr ? t[n >> 2] : or ? Zn : t[Me >> 2], Be = Ir ? t[v + 4 >> 2] : gr ? t[d + 4 >> 2] : dr ? t[n + 4 >> 2] : or ? Be : t[Me + 4 >> 2], t[E + 80 >> 2] = Zn, t[E + 84 >> 2] = Be & 1048575, v = a + 216 | 0, d = a + 152 | 0, n = a + 88 | 0, Me = a + 24 | 0, L = Ir ? t[v >> 2] : gr ? t[d >> 2] : dr ? t[n >> 2] : or ? L : t[Me >> 2], v = Ir ? t[v + 4 >> 2] : gr ? t[d + 4 >> 2] : dr ? t[n + 4 >> 2] : or ? xr : t[Me + 4 >> 2], xr = v, n = v >>> 16 | 0, t[E + 72 >> 2] = (v & 65535) << 16 | L >>> 16, t[E + 76 >> 2] = n, v = a + 192 | 0, d = a + 128 | 0, n = a - -64 | 0, ni = Ir ? t[v >> 2] : gr ? t[d >> 2] : dr ? t[n >> 2] : or ? ni : t[a >> 2], kn = Ir ? t[v + 4 >> 2] : gr ? t[d + 4 >> 2] : dr ? t[n + 4 >> 2] : or ? kn : t[a + 4 >> 2], t[E + 40 >> 2] = ni, t[E + 44 >> 2] = kn & 1048575, n = I << 4 & 1048560, v = a + 240 | 0, d = a + 176 | 0, Me = a + 112 | 0, Mr = a + 48 | 0, T = Ir ? t[v >> 2] : gr ? t[d >> 2] : dr ? t[Me >> 2] : or ? T : t[Mr >> 2], d = Ir ? t[v + 4 >> 2] : gr ? t[d + 4 >> 2] : dr ? t[Me + 4 >> 2] : or ? $r : t[Mr + 4 >> 2], $r = d, v = d >>> 28 | 0, t[E + 104 >> 2] = (d & 268435455) << 4 | T >>> 28, t[E + 108 >> 2] = v | n, n = a + 232 | 0, Me = a + 168 | 0, Mr = a + 104 | 0, v = a + 40 | 0, tr = Ir ? t[n >> 2] : gr ? t[Me >> 2] : dr ? t[Mr >> 2] : or ? tr : t[v >> 2], cr = Ir ? t[n + 4 >> 2] : gr ? t[Me + 4 >> 2] : dr ? t[Mr + 4 >> 2] : or ? cr : t[v + 4 >> 2], t[E + 96 >> 2] = T << 24 & -16777216 | cr >>> 8, t[E + 100 >> 2] = (d << 24 | T >>> 8) & 1048575, t[E + 88 >> 2] = tr << 12 & -4096 | Be >>> 20, t[E + 92 >> 2] = (cr << 12 | tr >>> 20) & 1048575, v = a + 208 | 0, d = a + 144 | 0, Me = a + 80 | 0, Mr = a + 16 | 0, he = Ir ? t[v >> 2] : gr ? t[d >> 2] : dr ? t[Me >> 2] : or ? he : t[Mr >> 2], v = Ir ? t[v + 4 >> 2] : gr ? t[d + 4 >> 2] : dr ? t[Me + 4 >> 2] : or ? gn : t[Mr + 4 >> 2], gn = v, d = v >>> 28 | 0, t[E + 64 >> 2] = (v & 268435455) << 4 | he >>> 28, t[E + 68 >> 2] = d | L << 4 & 1048560, d = he << 24 & -16777216, v = a + 200 | 0, Me = a + 136 | 0, Mr = a + 72 | 0, a = a + 8 | 0, xn = Ir ? t[v >> 2] : gr ? t[Me >> 2] : dr ? t[Mr >> 2] : or ? xn : t[a >> 2], Un = Ir ? t[v + 4 >> 2] : gr ? t[Me + 4 >> 2] : dr ? t[Mr + 4 >> 2] : or ? Un : t[a + 4 >> 2], t[E + 56 >> 2] = Un >>> 8 | d, t[E + 60 >> 2] = (gn << 24 | he >>> 8) & 1048575, t[E + 48 >> 2] = xn << 12 & -4096 | kn >>> 20, t[E + 52 >> 2] = (Un << 12 | xn >>> 20) & 1048575, ms(Gn, Gn, E + 40 | 0), Xn = Xn + 2 | 0, jn = jn + 1 | 0, Bn = Bn + 256 | 0, (Bn | 0) != 32768; )
      ;
    x = E + 128 | 0;
  }
  function ki(v, d) {
    var I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0;
    T = x - 80 | 0, x = T, t[v + 80 >> 2] = t[d + 120 >> 2], cr = d + 104 | 0, tr = t[cr >> 2], or = t[cr + 4 >> 2], dr = d + 96 | 0, L = t[dr >> 2], Me = t[dr + 4 >> 2], gr = d + 88 | 0, E = t[gr >> 2], he = t[gr + 4 >> 2], Be = t[d + 84 >> 2], Ir = d + 112 | 0, xr = t[Ir >> 2], a = t[Ir + 4 >> 2], gn = a, I = t[d + 80 >> 2], n = pn(a >>> 16 | 0, 0, 977, 1), a = I + n | 0, I = Be + Ee | 0, Be = n >>> 0 > a >>> 0 ? I + 1 | 0 : I, I = he, n = Be >>> 20 | 0, he = n, n = n + E | 0, he = he >>> 0 > n >>> 0 ? I + 1 | 0 : I, I = Me, E = he >>> 20 | 0, Me = E, E = E + L | 0, Me = Me >>> 0 > E >>> 0 ? I + 1 | 0 : I, I = or, L = Me >>> 20 | 0, or = L, L = L + tr | 0, tr = or >>> 0 > L >>> 0 ? I + 1 | 0 : I, Bn = he & 1048575, I = Be & 1048575, Wr = a, Mr = I, or = n, Be = E, $r = Me & 1048575, E = (n & E & L) == -1 & ($r & he & tr) == 1048575, I = gn & 65535, n = tr >>> 20 | 0, a = n, n = n + xr | 0, I = a >>> 0 > n >>> 0 ? I + 1 | 0 : I, he = n, a = I, E = pn(E & ((n | 0) == -1 & (I | 0) == 65535) & ((Mr | 0) == 1048574 & Wr >>> 0 > 4294966318 | Mr >>> 0 > 1048574) | I >>> 16, 0, 977, 1), n = E + Wr | 0, I = Mr + Ee | 0, I = n >>> 0 < E >>> 0 ? I + 1 | 0 : I, E = n, xr = I, I = Bn, n = xr >>> 20 | 0, Me = n + or | 0, n = n >>> 0 > Me >>> 0 ? I + 1 | 0 : I, t[T + 40 >> 2] = E, t[T + 44 >> 2] = Me << 20 & 1072693248 | xr & 1048575, I = $r, or = Be, E = n, Be = (n >>> 20 | 0) + Be | 0, n = or >>> 0 > Be >>> 0 ? I + 1 | 0 : I, xr = Be << 10 & 1073740800, I = E >>> 10 | 0, t[T + 48 >> 2] = (E & 1023) << 22 | Me >>> 10, t[T + 52 >> 2] = xr | I & 1023, I = tr & 1048575, E = n, n = n >>> 20 | 0, L = n + L | 0, n = n >>> 0 > L >>> 0 ? I + 1 | 0 : I, t[T + 56 >> 2] = (E & 1048575) << 12 | Be >>> 20, t[T + 60 >> 2] = L & 1073741823, I = a, a = (n >>> 20 | 0) + he | 0, I = a >>> 0 < he >>> 0 ? I + 1 | 0 : I, t[T + 72 >> 2] = I >>> 8 & 255, t[T + 76 >> 2] = 0, I = I << 22 | a >>> 10, t[T + 64 >> 2] = ((n & 1073741823) << 2 | L >>> 30) & 4194303 | a << 22 & -4194304, t[T + 68 >> 2] = I & 1073741823, he = T + 40 | 0, xi(he, 690464), n = t[T + 44 >> 2], a = n, t[d + 80 >> 2] = t[T + 40 >> 2], t[d + 84 >> 2] = n & 1048575, E = t[T + 72 >> 2] << 8, tr = t[T + 68 >> 2], I = tr >>> 22 | 0, L = t[T + 64 >> 2], t[Ir >> 2] = (tr & 4194303) << 10 | L >>> 22, t[Ir + 4 >> 2] = I | E, n = L, I = tr << 30 | n >>> 2, L = n << 30 & -1073741824, n = t[T + 56 >> 2], E = t[T + 60 >> 2], t[cr >> 2] = E | L, t[cr + 4 >> 2] = I & 1048575, I = E << 20 | n >>> 12, L = n << 20 & -1048576, n = t[T + 48 >> 2], E = t[T + 52 >> 2], t[dr >> 2] = E >>> 10 | L, t[dr + 4 >> 2] = I & 1048575, E = (E << 10 | n >>> 22) & 1048575, t[gr >> 2] = n << 10 & -1024 | a >>> 20, t[gr + 4 >> 2] = E, I = d + 80 | 0, Ui(he, I), Xr(T, I, he), Xr(d, d, he), I = d + 40 | 0, Xr(I, I, T), t[Ir >> 2] = 0, t[Ir + 4 >> 2] = 0, t[cr >> 2] = 0, t[cr + 4 >> 2] = 0, t[dr >> 2] = 0, t[dr + 4 >> 2] = 0, t[gr >> 2] = 0, t[gr + 4 >> 2] = 0, t[d + 80 >> 2] = 1, t[d + 84 >> 2] = 0, I = t[d + 4 >> 2], t[v >> 2] = t[d >> 2], t[v + 4 >> 2] = I, I = d + 8 | 0, n = t[I + 4 >> 2], a = v + 8 | 0, t[a >> 2] = t[I >> 2], t[a + 4 >> 2] = n, I = d + 16 | 0, n = t[I + 4 >> 2], a = v + 16 | 0, t[a >> 2] = t[I >> 2], t[a + 4 >> 2] = n, I = d + 24 | 0, n = t[I + 4 >> 2], a = v + 24 | 0, t[a >> 2] = t[I >> 2], t[a + 4 >> 2] = n, I = d + 32 | 0, n = t[I + 4 >> 2], a = v + 32 | 0, t[a >> 2] = t[I >> 2], t[a + 4 >> 2] = n, I = t[d + 44 >> 2], t[v + 40 >> 2] = t[d + 40 >> 2], t[v + 44 >> 2] = I, I = d + 48 | 0, n = t[I + 4 >> 2], a = v + 48 | 0, t[a >> 2] = t[I >> 2], t[a + 4 >> 2] = n, I = d + 56 | 0, n = t[I + 4 >> 2], a = v + 56 | 0, t[a >> 2] = t[I >> 2], t[a + 4 >> 2] = n, I = d - -64 | 0, n = t[I + 4 >> 2], a = v - -64 | 0, t[a >> 2] = t[I >> 2], t[a + 4 >> 2] = n, d = d + 72 | 0, I = t[d + 4 >> 2], v = v + 72 | 0, t[v >> 2] = t[d >> 2], t[v + 4 >> 2] = I, x = T + 80 | 0;
  }
  function xi(v, d) {
    var I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0, Xn = 0, Zn = 0, ni = 0, ai = 0, fi = 0, Ai = 0, yi = 0, Ii = 0, wi = 0, Bi = 0, Ti = 0, Oi = 0, Hi = 0, Xi = 0, Zi = 0, ts = 0, us = 0, hs = 0;
    for (L = x - 432 | 0, x = L, n = L + 392 | 0, I = n + 32 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = n + 24 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = n + 16 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, n = n + 8 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, t[L + 392 >> 2] = 0, t[L + 396 >> 2] = 0, n = L + 352 | 0, I = n + 32 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = n + 24 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, n = n + 16 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, t[L + 360 >> 2] = 0, t[L + 364 >> 2] = 0, t[L + 352 >> 2] = 1, t[L + 356 >> 2] = 0, yi = v, Xi = t[v + 32 >> 2], ts = t[v + 36 >> 2], $r = t[v + 24 >> 2], Oi = t[v + 28 >> 2], Gn = t[v + 16 >> 2], Zn = t[v + 20 >> 2], Bn = t[v + 8 >> 2], Ii = t[v + 12 >> 2], n = t[v >> 2], Be = t[v + 4 >> 2], Zi = t[d + 32 >> 2], kn = t[d + 36 >> 2], ni = t[d + 24 >> 2], ai = t[d + 28 >> 2], jn = t[d + 16 >> 2], fi = t[d + 20 >> 2], xn = t[d + 8 >> 2], Ai = t[d + 12 >> 2], I = t[d >> 2], tr = t[d + 4 >> 2], us = -1, gn = -1; ; ) {
      for (E = 8, a = 0, wi = 59, T = 0, dr = 0, he = n, v = Be, or = I, Wr = tr, Me = 0, gr = 0, Ir = 8, cr = 0; Mr = v, v = he & 1, Xn = 0 - v | 0, Bi = 0 - v | 0, Un = Bi, Ti = gn, v = gn >> 31, xr = v, v = v ^ or, gn = v - xr & Xn, he = gn + he | 0, v = Mr + (Un & (xr ^ Wr) - ((v >>> 0 < xr >>> 0) + xr | 0)) | 0, Hi = he, he = he >>> 0 < gn >>> 0 ? v + 1 | 0 : v, Mr = xr & Un, v = (he & Mr) + Wr | 0, Wr = or, gn = xr & Xn, or = (gn & Hi) + or | 0, Wr = Wr >>> 0 > or >>> 0 ? v + 1 | 0 : v, v = T ^ xr, Un = v - xr & Xn, Ir = Un + Ir | 0, v = cr + ((dr ^ xr) - ((v >>> 0 < xr >>> 0) + xr | 0) & Bi) | 0, cr = Ir >>> 0 < Un >>> 0 ? v + 1 | 0 : v, v = (cr & Mr) + dr | 0, dr = T, T = (Ir & gn) + T | 0, v = (dr >>> 0 > T >>> 0 ? v + 1 | 0 : v) << 1 | T >>> 31, T = T << 1, dr = v, Un = gn, v = E ^ xr, gn = (v - xr & Xn) + Me | 0, v = ((a ^ xr) - ((v >>> 0 < xr >>> 0) + xr | 0) & Bi) + gr | 0, gr = Me >>> 0 > gn >>> 0 ? v + 1 | 0 : v, v = (gr & Mr) + a | 0, a = E, Me = gn, E = (Un & Me) + E | 0, v = (a >>> 0 > E >>> 0 ? v + 1 | 0 : v) << 1 | E >>> 31, E = E << 1, a = v, v = Un ^ us, us = v - 1 | 0, gn = (Mr ^ Ti) - !v | 0, v = he >>> 1 | 0, he = (he & 1) << 31 | Hi >>> 1, wi = wi - 1 | 0, !!wi; )
        ;
      if (t[L + 344 >> 2] = Ir, t[L + 348 >> 2] = cr, t[L + 336 >> 2] = Me, t[L + 340 >> 2] = gr, t[L + 328 >> 2] = T, t[L + 332 >> 2] = dr, t[L + 320 >> 2] = E, t[L + 324 >> 2] = a, Gi(L + 392 | 0, L + 352 | 0, L + 320 | 0, d), v = tr >> 31, Hi = L + 304 | 0, he = a >> 31, or = I, Wr = v, Ur(Hi, E, a, he, he, I, tr, v, v), v = Be >> 31, Un = L + 272 | 0, I = dr >> 31, Mr = n, xr = v, Ur(Un, T, dr, I, I, n, Be, v, v), v = gr >> 31, Xn = L + 288 | 0, Ti = Me, n = v, Ur(Xn, Me, gr, v, v, or, tr, Wr, Wr), v = cr >> 31, tr = L + 256 | 0, Me = v, Ur(tr, Ir, cr, v, v, Mr, Be, xr, xr), v = Ai >> 31, or = L + 240 | 0, Be = v, Ur(or, E, a, he, he, xn, Ai, v, v), Wr = L + 208 | 0, Mr = Ii, v = Mr >> 31, Ur(Wr, T, dr, I, I, Bn, Mr, v, v), Mr = L + 224 | 0, Ur(Mr, Ti, gr, n, n, xn, Ai, Be, Be), xr = L + 192 | 0, Ur(xr, Ir, cr, Me, Me, Bn, Ii, v, v), v = fi >> 31, Bn = L + 176 | 0, Be = v, Ur(Bn, E, a, he, he, jn, fi, v, v), Ii = L + 144 | 0, v = Zn >> 31, Ur(Ii, T, dr, I, I, Gn, Zn, v, v), Ai = L + 160 | 0, Ur(Ai, Ti, gr, n, n, jn, fi, Be, Be), fi = L + 128 | 0, Ur(fi, Ir, cr, Me, Me, Gn, Zn, v, v), v = ai >> 31, Gn = L + 112 | 0, Be = v, Ur(Gn, E, a, he, he, ni, ai, v, v), Zn = L + 80 | 0, xn = Oi, v = xn >> 31, Ur(Zn, T, dr, I, I, $r, xn, v, v), Bi = L + 96 | 0, Ur(Bi, Ti, gr, n, n, ni, ai, Be, Be), ai = L - -64 | 0, Ur(ai, Ir, cr, Me, Me, $r, xn, v, v), v = kn >> 31, $r = L + 48 | 0, Be = he, he = v, Ur($r, E, a, Be, Be, Zi, kn, v, v), Oi = L + 16 | 0, a = ts, v = a >> 31, Ur(Oi, T, dr, I, I, Xi, a, v, v), wi = L + 32 | 0, Ur(wi, Ti, gr, n, n, Zi, kn, he, he), Ur(L, Ir, cr, Me, Me, Xi, a, v, v), E = t[L + 272 >> 2], I = t[L + 304 >> 2], n = E + I | 0, he = t[L + 276 >> 2], v = he + t[L + 308 >> 2] | 0, v = I >>> 0 > n >>> 0 ? v + 1 | 0 : v, I = n, n = v, he = (he | 0) == (v | 0) & I >>> 0 < E >>> 0 | v >>> 0 < he >>> 0, v = Hi + 8 | 0, E = t[v >> 2], a = Un + 8 | 0, I = E + t[a >> 2] | 0, v = t[a + 4 >> 2] + t[v + 4 >> 2] | 0, v = I >>> 0 < E >>> 0 ? v + 1 | 0 : v, he = I + he | 0, I = he >>> 0 < I >>> 0 ? v + 1 | 0 : v, E = I << 2 | he >>> 30, a = he << 2 | n >>> 30, Me = t[L + 208 >> 2], he = t[L + 240 >> 2], n = Me + he | 0, T = t[L + 212 >> 2], v = T + t[L + 244 >> 2] | 0, he = n >>> 0 < he >>> 0 ? v + 1 | 0 : v, v = he + E | 0, E = n, a = n + a | 0, n = n >>> 0 > a >>> 0 ? v + 1 | 0 : v, v = he, he = a, dr = (n | 0) == (v | 0) & a >>> 0 < E >>> 0 | v >>> 0 > n >>> 0, a = (v | 0) == (T | 0) & E >>> 0 < Me >>> 0 | v >>> 0 < T >>> 0, v = or + 8 | 0, T = t[v >> 2], Me = Wr + 8 | 0, E = T + t[Me >> 2] | 0, v = t[Me + 4 >> 2] + t[v + 4 >> 2] | 0, v = E >>> 0 < T >>> 0 ? v + 1 | 0 : v, T = E, E = a + E | 0, v = (I >> 31) + (T >>> 0 > E >>> 0 ? v + 1 | 0 : v) | 0, I = I >> 30, a = I, I = I + E | 0, v = a >>> 0 > I >>> 0 ? v + 1 | 0 : v, E = I + dr | 0, I = E >>> 0 < I >>> 0 ? v + 1 | 0 : v, a = I << 2 | E >>> 30, dr = n, Me = E << 2 | n >>> 30, cr = t[L + 144 >> 2], E = t[L + 176 >> 2], n = cr + E | 0, T = t[L + 148 >> 2], v = T + t[L + 180 >> 2] | 0, E = n >>> 0 < E >>> 0 ? v + 1 | 0 : v, v = E + a | 0, a = n, xn = n + Me | 0, n = n >>> 0 > xn >>> 0 ? v + 1 | 0 : v, Me = (E | 0) == (n | 0) & a >>> 0 > xn >>> 0 | n >>> 0 < E >>> 0, a = (E | 0) == (T | 0) & a >>> 0 < cr >>> 0 | E >>> 0 < T >>> 0, v = Bn + 8 | 0, T = t[v >> 2], gr = Ii + 8 | 0, E = T + t[gr >> 2] | 0, v = t[gr + 4 >> 2] + t[v + 4 >> 2] | 0, v = E >>> 0 < T >>> 0 ? v + 1 | 0 : v, T = E, E = a + E | 0, v = (I >> 31) + (T >>> 0 > E >>> 0 ? v + 1 | 0 : v) | 0, I = I >> 30, a = I, I = I + E | 0, v = a >>> 0 > I >>> 0 ? v + 1 | 0 : v, E = I + Me | 0, I = E >>> 0 < I >>> 0 ? v + 1 | 0 : v, a = I << 2 | E >>> 30, Me = n, gr = E << 2 | n >>> 30, Ir = t[L + 80 >> 2], E = t[L + 112 >> 2], n = Ir + E | 0, T = t[L + 84 >> 2], v = T + t[L + 116 >> 2] | 0, E = n >>> 0 < E >>> 0 ? v + 1 | 0 : v, v = E + a | 0, a = n, jn = n + gr | 0, n = n >>> 0 > jn >>> 0 ? v + 1 | 0 : v, gr = (E | 0) == (n | 0) & a >>> 0 > jn >>> 0 | n >>> 0 < E >>> 0, a = (E | 0) == (T | 0) & a >>> 0 < Ir >>> 0 | E >>> 0 < T >>> 0, v = Gn + 8 | 0, T = t[v >> 2], cr = Zn + 8 | 0, E = T + t[cr >> 2] | 0, v = t[cr + 4 >> 2] + t[v + 4 >> 2] | 0, v = E >>> 0 < T >>> 0 ? v + 1 | 0 : v, T = E, E = a + E | 0, v = (I >> 31) + (T >>> 0 > E >>> 0 ? v + 1 | 0 : v) | 0, I = I >> 30, a = I, I = I + E | 0, v = a >>> 0 > I >>> 0 ? v + 1 | 0 : v, E = I + gr | 0, I = E >>> 0 < I >>> 0 ? v + 1 | 0 : v, a = I << 2 | E >>> 30, gr = n, cr = E << 2 | n >>> 30, Be = t[L + 16 >> 2], E = t[L + 48 >> 2], n = Be + E | 0, T = t[L + 20 >> 2], v = T + t[L + 52 >> 2] | 0, E = n >>> 0 < E >>> 0 ? v + 1 | 0 : v, v = E + a | 0, a = n, ni = n + cr | 0, n = n >>> 0 > ni >>> 0 ? v + 1 | 0 : v, cr = (E | 0) == (n | 0) & a >>> 0 > ni >>> 0 | n >>> 0 < E >>> 0, a = (E | 0) == (T | 0) & a >>> 0 < Be >>> 0 | E >>> 0 < T >>> 0, v = $r + 8 | 0, T = t[v >> 2], Ir = Oi + 8 | 0, E = T + t[Ir >> 2] | 0, v = t[Ir + 4 >> 2] + t[v + 4 >> 2] | 0, v = E >>> 0 < T >>> 0 ? v + 1 | 0 : v, T = E, E = a + E | 0, v = (I >> 31) + (T >>> 0 > E >>> 0 ? v + 1 | 0 : v) | 0, I = I >> 30, a = I, I = I + E | 0, v = a >>> 0 > I >>> 0 ? v + 1 | 0 : v, a = I, I = I + cr | 0, E = (a >>> 0 > I >>> 0 ? v + 1 | 0 : v) << 2 | I >>> 30, cr = n, Zi = I << 2 | n >>> 30, kn = E, a = t[L + 256 >> 2], I = t[L + 288 >> 2], n = a + I | 0, E = t[L + 260 >> 2], v = E + t[L + 292 >> 2] | 0, v = I >>> 0 > n >>> 0 ? v + 1 | 0 : v, I = n, n = v, E = (E | 0) == (v | 0) & I >>> 0 < a >>> 0 | v >>> 0 < E >>> 0, v = Xn + 8 | 0, a = t[v >> 2], T = tr + 8 | 0, I = a + t[T >> 2] | 0, v = t[T + 4 >> 2] + t[v + 4 >> 2] | 0, v = I >>> 0 < a >>> 0 ? v + 1 | 0 : v, E = I + E | 0, I = E >>> 0 < I >>> 0 ? v + 1 | 0 : v, a = I << 2 | E >>> 30, T = E << 2 | n >>> 30, tr = t[L + 192 >> 2], E = t[L + 224 >> 2], n = tr + E | 0, Ir = t[L + 196 >> 2], v = Ir + t[L + 228 >> 2] | 0, E = n >>> 0 < E >>> 0 ? v + 1 | 0 : v, v = E + a | 0, a = n, T = n + T | 0, n = n >>> 0 > T >>> 0 ? v + 1 | 0 : v, v = E, E = T, Be = (n | 0) == (v | 0) & a >>> 0 > E >>> 0 | v >>> 0 > n >>> 0, T = (v | 0) == (Ir | 0) & a >>> 0 < tr >>> 0 | v >>> 0 < Ir >>> 0, v = Mr + 8 | 0, Ir = t[v >> 2], tr = xr + 8 | 0, a = Ir + t[tr >> 2] | 0, v = t[tr + 4 >> 2] + t[v + 4 >> 2] | 0, v = a >>> 0 < Ir >>> 0 ? v + 1 | 0 : v, Wr = a, a = a + T | 0, v = (I >> 31) + (Wr >>> 0 > a >>> 0 ? v + 1 | 0 : v) | 0, I = I >> 30, T = I, I = I + a | 0, v = T >>> 0 > I >>> 0 ? v + 1 | 0 : v, a = I + Be | 0, I = a >>> 0 < I >>> 0 ? v + 1 | 0 : v, T = I << 2 | a >>> 30, Ir = n, tr = a << 2 | n >>> 30, $r = t[L + 128 >> 2], a = t[L + 160 >> 2], n = $r + a | 0, Be = t[L + 132 >> 2], v = Be + t[L + 164 >> 2] | 0, a = n >>> 0 < a >>> 0 ? v + 1 | 0 : v, v = a + T | 0, T = n, Bn = n + tr | 0, n = n >>> 0 > Bn >>> 0 ? v + 1 | 0 : v, tr = (a | 0) == (n | 0) & T >>> 0 > Bn >>> 0 | n >>> 0 < a >>> 0, T = (a | 0) == (Be | 0) & T >>> 0 < $r >>> 0 | a >>> 0 < Be >>> 0, v = Ai + 8 | 0, Be = t[v >> 2], or = fi + 8 | 0, a = Be + t[or >> 2] | 0, v = t[or + 4 >> 2] + t[v + 4 >> 2] | 0, v = a >>> 0 < Be >>> 0 ? v + 1 | 0 : v, Be = a, a = a + T | 0, v = (I >> 31) + (Be >>> 0 > a >>> 0 ? v + 1 | 0 : v) | 0, I = I >> 30, T = I, I = I + a | 0, v = T >>> 0 > I >>> 0 ? v + 1 | 0 : v, a = I + tr | 0, I = a >>> 0 < I >>> 0 ? v + 1 | 0 : v, T = I << 2 | a >>> 30, Be = n, or = a << 2 | n >>> 30, Wr = t[L + 64 >> 2], a = t[L + 96 >> 2], n = Wr + a | 0, tr = t[L + 68 >> 2], v = tr + t[L + 100 >> 2] | 0, a = n >>> 0 < a >>> 0 ? v + 1 | 0 : v, v = a + T | 0, T = n, Gn = n + or | 0, n = n >>> 0 > Gn >>> 0 ? v + 1 | 0 : v, or = (a | 0) == (n | 0) & T >>> 0 > Gn >>> 0 | n >>> 0 < a >>> 0, T = (a | 0) == (tr | 0) & T >>> 0 < Wr >>> 0 | a >>> 0 < tr >>> 0, v = Bi + 8 | 0, tr = t[v >> 2], $r = ai + 8 | 0, a = tr + t[$r >> 2] | 0, v = t[$r + 4 >> 2] + t[v + 4 >> 2] | 0, v = a >>> 0 < tr >>> 0 ? v + 1 | 0 : v, Wr = a, a = a + T | 0, v = (I >> 31) + (Wr >>> 0 > a >>> 0 ? v + 1 | 0 : v) | 0, I = I >> 30, T = I, I = I + a | 0, v = T >>> 0 > I >>> 0 ? v + 1 | 0 : v, a = I + or | 0, I = a >>> 0 < I >>> 0 ? v + 1 | 0 : v, T = I << 2 | a >>> 30, tr = n, $r = a << 2 | n >>> 30, Mr = t[L >> 2], a = t[L + 32 >> 2], n = Mr + a | 0, or = t[L + 4 >> 2], v = or + t[L + 36 >> 2] | 0, a = n >>> 0 < a >>> 0 ? v + 1 | 0 : v, v = a + T | 0, T = n, $r = n + $r | 0, n = n >>> 0 > $r >>> 0 ? v + 1 | 0 : v, Wr = (a | 0) == (n | 0) & T >>> 0 > $r >>> 0 | n >>> 0 < a >>> 0, T = (a | 0) == (or | 0) & T >>> 0 < Mr >>> 0 | a >>> 0 < or >>> 0, v = wi + 8 | 0, or = t[v >> 2], Mr = L + 8 | 0, a = or + t[Mr >> 2] | 0, v = t[Mr + 4 >> 2] + t[v + 4 >> 2] | 0, v = a >>> 0 < or >>> 0 ? v + 1 | 0 : v, or = a, a = a + T | 0, v = (I >> 31) + (or >>> 0 > a >>> 0 ? v + 1 | 0 : v) | 0, I = I >> 30, T = I, I = I + a | 0, v = T >>> 0 > I >>> 0 ? v + 1 | 0 : v, a = I, I = I + Wr | 0, a = (a >>> 0 > I >>> 0 ? v + 1 | 0 : v) << 2 | I >>> 30, Xi = I << 2 | n >>> 30, ts = a, Oi = n & 1073741823, ai = cr & 1073741823, Zn = tr & 1073741823, fi = gr & 1073741823, Ii = Be & 1073741823, Ai = Me & 1073741823, n = E, Be = Ir & 1073741823, I = he, tr = dr & 1073741823, hs = hs + 1 | 0, (hs | 0) == 10)
        break;
    }
    v = kn >> 31, n = v, dr = L + 392 | 0, he = dr + 32 | 0, gr = t[he >> 2], v = t[he + 4 >> 2], Be = v, v = v >> 31, I = v, a = t[d >> 2], cr = v & a, E = cr + t[L + 392 >> 2] | 0, T = t[d + 4 >> 2], v = t[L + 396 >> 2] + (T & v) | 0, v = E >>> 0 < cr >>> 0 ? v + 1 | 0 : v, E = n ^ E, $r = E - n | 0, E = (v ^ n) - ((n >>> 0 > E >>> 0) + n | 0) | 0, cr = a, Ir = T, v = t[d + 32 >> 2], Gn = v, T = v & I, a = T + gr | 0, Bn = t[d + 36 >> 2], v = Be + (Bn & I) | 0, v = a >>> 0 < T >>> 0 ? v + 1 | 0 : v, a = n ^ a, gr = a - n | 0, or = (v ^ n) - ((n >>> 0 > a >>> 0) + n | 0) | 0, v = t[d + 24 >> 2], ni = v, Me = v & I, a = dr + 24 | 0, T = Me + t[a >> 2] | 0, jn = t[d + 28 >> 2], v = t[a + 4 >> 2] + (jn & I) | 0, v = T >>> 0 < Me >>> 0 ? v + 1 | 0 : v, T = n ^ T, tr = T - n | 0, xn = (v ^ n) - ((n >>> 0 > T >>> 0) + n | 0) | 0, v = t[d + 16 >> 2], Wr = v, Be = v & I, T = dr + 16 | 0, Me = Be + t[T >> 2] | 0, gn = t[d + 20 >> 2], v = t[T + 4 >> 2] + (gn & I) | 0, v = Be >>> 0 > Me >>> 0 ? v + 1 | 0 : v, Me = n ^ Me, kn = Me - n | 0, Me = (v ^ n) - ((n >>> 0 > Me >>> 0) + n | 0) | 0, Mr = t[d + 8 >> 2], Be = Mr & I, v = dr + 8 | 0, dr = Be + t[v >> 2] | 0, xr = t[d + 12 >> 2], v = t[v + 4 >> 2] + (xr & I) | 0, d = n ^ dr, I = d - n | 0, v = ((n ^ (Be >>> 0 > dr >>> 0 ? v + 1 | 0 : v)) - ((d >>> 0 < n >>> 0) + n | 0) | 0) + (E >> 31) | 0, d = E >> 30, I = d + I | 0, Be = d >>> 0 > I >>> 0 ? v + 1 | 0 : v, v = (Be >> 31) + Me | 0, d = Be >> 30, dr = d + kn | 0, kn = d >>> 0 > dr >>> 0 ? v + 1 | 0 : v, v = (kn >> 31) + xn | 0, d = kn >> 30, Me = d + tr | 0, tr = d >>> 0 > Me >>> 0 ? v + 1 | 0 : v, v = (tr >> 31) + or | 0, d = tr >> 30, gr = d + gr | 0, or = d >>> 0 > gr >>> 0 ? v + 1 | 0 : v, d = or >> 31, v = (d & Ir) + (E & 1073741823) | 0, n = d, d = (n & cr) + $r | 0, v = d >>> 0 < $r >>> 0 ? v + 1 | 0 : v, t[yi >> 2] = d, d = v, t[yi + 4 >> 2] = v & 1073741823, cr = yi + 8 | 0, v = (n & xr) + (Be & 1073741823) | 0, E = I, I = (n & Mr) + I | 0, v = (d >> 31) + (E >>> 0 > I >>> 0 ? v + 1 | 0 : v) | 0, d = d >> 30, E = d, d = d + I | 0, v = E >>> 0 > d >>> 0 ? v + 1 | 0 : v, t[cr >> 2] = d, d = v, t[cr + 4 >> 2] = v & 1073741823, v = (n & gn) + (kn & 1073741823) | 0, I = (n & Wr) + dr | 0, v = (d >> 31) + (I >>> 0 < dr >>> 0 ? v + 1 | 0 : v) | 0, d = d >> 30, E = d, d = d + I | 0, v = E >>> 0 > d >>> 0 ? v + 1 | 0 : v, I = d, t[T >> 2] = I, d = v, v = v & 1073741823, t[T + 4 >> 2] = v, E = yi + 16 | 0, t[E >> 2] = I, t[E + 4 >> 2] = v, v = (n & jn) + (tr & 1073741823) | 0, I = (n & ni) + Me | 0, v = (d >> 31) + (I >>> 0 < Me >>> 0 ? v + 1 | 0 : v) | 0, d = d >> 30, E = d, d = d + I | 0, v = E >>> 0 > d >>> 0 ? v + 1 | 0 : v, I = d, t[a >> 2] = I, d = v, v = v & 1073741823, t[a + 4 >> 2] = v, E = yi + 24 | 0, t[E >> 2] = I, t[E + 4 >> 2] = v, v = (n & Bn) + or | 0, n = (n & Gn) + gr | 0, v = (d >> 31) + (n >>> 0 < gr >>> 0 ? v + 1 | 0 : v) | 0, d = d >> 30, I = d, d = d + n | 0, v = I >>> 0 > d >>> 0 ? v + 1 | 0 : v, t[he >> 2] = d, t[he + 4 >> 2] = v, n = yi + 32 | 0, t[n >> 2] = d, t[n + 4 >> 2] = v, x = L + 432 | 0;
  }
  function _i(v, d) {
    var I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0;
    a = x - 48 | 0, x = a;
    e: {
      if (!d) {
        Qn[t[v + 168 >> 2]](689571, t[v + 172 >> 2]), v = 0;
        break e;
      }
      dr = a + 8 | 0, Zr(dr, d, a + 44 | 0), he = t[a + 32 >> 2], I = t[a + 24 >> 2], L = t[a + 16 >> 2], n = t[a + 8 >> 2], tr = t[a + 36 >> 2], Be = t[a + 28 >> 2], E = t[a + 20 >> 2], T = t[a + 12 >> 2], gr = t[a + 44 >> 2] | !(he | (I | (L | n)) | (tr | (Be | (E | T)))), v = gr ? 0 : -1, he = v & he, or = v & I, Me = v & L, n = v & n, tr = v & tr, Ir = v & Be, cr = v & E, I = v & T, L = he | (or | (Me | n)) | (tr | (Ir | (cr | I))) ? -1 : 0, n = n ^ -1, T = n - 801750718 | 0, t[a + 8 >> 2] = L & T, I = I ^ -1, E = I - ((n >>> 0 < 801750718) + 1076732275 | 0) | 0, t[a + 12 >> 2] = E & L, v = (I | 0) == (E | 0) & n >>> 0 > T >>> 0 | I >>> 0 > E >>> 0, E = Me ^ -1, n = v + E | 0, T = cr ^ -1, I = T, cr = n - 1354194885 | 0, t[a + 16 >> 2] = cr & L, I = n >>> 0 < E >>> 0 ? I + 1 | 0 : I, Be = I - ((n >>> 0 < 1354194885) + 1162945305 | 0) | 0, t[a + 20 >> 2] = Be & L, or = or ^ -1, v = (I | 0) == (T | 0) & n >>> 0 < E >>> 0 | I >>> 0 < T >>> 0, E = (I | 0) == (Be | 0) & n >>> 0 > cr >>> 0 | I >>> 0 > Be >>> 0, I = v + E | 0, Me = Ir ^ -1, n = Me + (I >>> 0 < E >>> 0) | 0, v = I, I = I + or | 0, n = v >>> 0 > I >>> 0 ? n + 1 | 0 : n, T = I - 2 | 0, t[a + 24 >> 2] = T & L, E = n - (I >>> 0 < 2) | 0, t[a + 28 >> 2] = E & L, v = (n | 0) == (Me | 0) & I >>> 0 < or >>> 0 | n >>> 0 < Me >>> 0, I = (n | 0) == (E | 0) & I >>> 0 > T >>> 0 | n >>> 0 > E >>> 0, v = v + I | 0, n = v >>> 0 < I >>> 0, I = v - he | 0, t[a + 32 >> 2] = I - 2 & L, t[a + 36 >> 2] = (n - ((v >>> 0 < he >>> 0) + tr | 0) | 0) - (I >>> 0 < 2) & L, kr(d, dr), v = !gr;
    }
    return x = a + 48 | 0, v;
  }
  function Li() {
    var v = 0, d = 0, I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0, Xn = 0, Zn = 0;
    return a = x - 80 | 0, x = a, xn = a + 8 | 0, v = a + 48 | 0, Zr(xn, 690788, v), Zn = t[a + 48 >> 2], $r = t[a + 32 >> 2], Un = t[a + 36 >> 2], gn = t[a + 24 >> 2], Gn = t[a + 28 >> 2], Bn = t[a + 8 >> 2], jn = t[a + 12 >> 2], kn = t[a + 16 >> 2], Xn = t[a + 20 >> 2], t[a + 44 >> 2] = 0, Zr(v, 690949, a + 44 | 0), n = t[a + 52 >> 2], v = n + jn | 0, I = t[a + 48 >> 2], Mr = I + Bn | 0, gr = Mr >>> 0 < Bn >>> 0 ? v + 1 | 0 : v, E = t[a + 60 >> 2], v = E + Xn | 0, Be = v + 1 | 0, Me = v, v = t[a + 56 >> 2], d = v + kn | 0, T = d >>> 0 < kn >>> 0 ? Be : Me, E = (T | 0) == (E | 0) & v >>> 0 > d >>> 0 | T >>> 0 < E >>> 0, v = (n | 0) == (gr | 0) & I >>> 0 > Mr >>> 0 | n >>> 0 > gr >>> 0, xr = v + d | 0, cr = xr >>> 0 < v >>> 0 ? T + 1 | 0 : T, I = (cr | 0) == (T | 0) & d >>> 0 > xr >>> 0 | T >>> 0 > cr >>> 0, E = E + I | 0, d = t[a + 68 >> 2], v = d + Gn | 0, Be = v + 1 | 0, Me = v, v = t[a + 64 >> 2], T = v + gn | 0, L = T >>> 0 < gn >>> 0 ? Be : Me, I = L + (I >>> 0 > E >>> 0) | 0, Ir = T + E | 0, E = Ir >>> 0 < E >>> 0 ? I + 1 | 0 : I, n = (E | 0) == (L | 0) & T >>> 0 > Ir >>> 0 | E >>> 0 < L >>> 0, he = n + ((d | 0) == (L | 0) & v >>> 0 > T >>> 0 | d >>> 0 > L >>> 0) | 0, v = E, T = (v | 0) == -1, dr = t[a + 76 >> 2], I = dr + Un | 0, d = t[a + 72 >> 2], or = d + $r | 0, tr = or >>> 0 < $r >>> 0 ? I + 1 | 0 : I, I = tr + (n >>> 0 > he >>> 0) | 0, Be = I + 1 | 0, Me = I, I = he + or | 0, Wr = I >>> 0 < he >>> 0 ? Be : Me, n = T & Ir >>> 0 < 4294967294 | (v | 0) != -1 | (Wr & I) != -1, L = (cr | 0) == -1162945306, he = (n | (L & xr >>> 0 < 2940772411 | cr >>> 0 < 3132021990)) ^ -1, n = (((tr | 0) == (dr | 0) & d >>> 0 > or >>> 0 | tr >>> 0 < dr >>> 0) + ((tr | 0) == (Wr | 0) & I >>> 0 < or >>> 0 | tr >>> 0 > Wr >>> 0) | 0) + (he & ((gr | 0) == -1076732276 & Mr >>> 0 > 3493216576 | gr >>> 0 > 3218235020) | (he & (L & xr >>> 0 > 2940772411 | cr >>> 0 > 3132021990) | (Ir | 0) == -1 & T & (n ^ -1))) | 0, or = n + Ir | 0, or >>> 0 < Ir >>> 0 && (v = v + 1 | 0), L = pn(n, 0, 1354194884, 1162945305), T = cr + Ee | 0, d = pn(n, 0, 801750719, 1076732275), Be = d + Mr | 0, dr = L + xr | 0, n = gr + Ee | 0, he = d >>> 0 > Be >>> 0 ? n + 1 | 0 : n, n = (he | 0) == (gr | 0) & Mr >>> 0 > Be >>> 0 | he >>> 0 < gr >>> 0, tr = dr + n | 0, d = L >>> 0 > dr >>> 0 ? T + 1 | 0 : T, L = n >>> 0 > tr >>> 0 ? d + 1 | 0 : d, n = (d | 0) == (L | 0) & tr >>> 0 < dr >>> 0 | d >>> 0 > L >>> 0, d = n + ((d | 0) == (cr | 0) & dr >>> 0 < xr >>> 0 | d >>> 0 < cr >>> 0) | 0, Me = (v | 0) == (E | 0) & or >>> 0 < Ir >>> 0 | v >>> 0 < E >>> 0, n = (d >>> 0 < n >>> 0) + v | 0, E = d, d = d + or | 0, T = E >>> 0 > d >>> 0 ? n + 1 | 0 : n, v = (T | 0) == (v | 0) & d >>> 0 < or >>> 0 | v >>> 0 > T >>> 0, E = Me + v | 0, v = Wr + (v >>> 0 > E >>> 0) | 0, E = I + E | 0, n = E >>> 0 < I >>> 0 ? v + 1 | 0 : v, v = a, E | (tr | Be | d) | (n | (L | he | T)) ? Me = t[v + 44 >> 2] | (Zn | !($r | (gn | (Bn | kn)) | (Un | (Gn | (jn | Xn))))) : Me = 1, a = !Me, I = 0 - a | 0, t[v + 32 >> 2] = E & I, t[v + 36 >> 2] = I & n, t[v + 24 >> 2] = d & I, t[v + 28 >> 2] = I & T, t[v + 16 >> 2] = I & tr, t[v + 20 >> 2] = I & L, t[v + 8 >> 2] = I & Be, t[v + 12 >> 2] = I & he, kr(690788, xn), x = v + 80 | 0, a;
  }
  function ms(v, d, I) {
    var n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0, Xn = 0, Zn = 0, ni = 0, ai = 0, fi = 0, Ai = 0, yi = 0, Ii = 0, wi = 0, Bi = 0, Ti = 0, Oi = 0, Hi = 0, Xi = 0, Zi = 0, ts = 0, us = 0, hs = 0, ws = 0, ks = 0, Bs = 0, gs = 0, ps = 0, zs = 0, Gs = 0, to = 0, ro = 0, $s = 0, Xs = 0, Ao = 0, co = 0, Co = 0, wo = 0, fo = 0, pi = 0, bi = 0, Ni = 0, Wi = 0, ns = 0, ji = 0, rs = 0, Is = 0, ds = 0, bo = 0, Uo = 0, Ho = 0, Ro = 0, vo = 0, js = 0, jo = 0, za = 0, ya = 0;
    E = x - 1744 | 0, x = E, gr = E + 1704 | 0, Is = d + 80 | 0, Ui(gr, Is), Ii = E + 1664 | 0, $r = Ii + 8 | 0, T = $r, n = d + 8 | 0, jn = t[n >> 2], Wr = t[n + 4 >> 2], L = t[d + 4 >> 2], n = d + 32 | 0, tr = t[n >> 2], Be = t[n + 4 >> 2], he = Be, a = t[d >> 2], Be = pn(he >>> 16 | 0, 0, 977, 1), a = a + Be | 0, n = L + Ee | 0, L = a >>> 0 < Be >>> 0 ? n + 1 | 0 : n, n = Wr, Be = L >>> 20 | 0, xn = Be + jn | 0, n = Be >>> 0 > xn >>> 0 ? n + 1 | 0 : n, t[T >> 2] = xn, bo = n & 1048575, t[T + 4 >> 2] = bo, jn = Ii + 16 | 0, Be = jn, T = d + 16 | 0, Wr = t[T >> 2], cr = t[T + 4 >> 2], T = n, n = cr, T = T >>> 20 | 0, Un = T + Wr | 0, n = T >>> 0 > Un >>> 0 ? n + 1 | 0 : n, t[Be >> 2] = Un, Uo = n & 1048575, t[Be + 4 >> 2] = Uo, Wr = Ii + 24 | 0, Be = Wr, T = d + 24 | 0, cr = t[T >> 2], ks = t[T + 4 >> 2], T = n, n = ks, T = T >>> 20 | 0, Xn = T + cr | 0, n = T >>> 0 > Xn >>> 0 ? n + 1 | 0 : n, t[Be >> 2] = Xn, Ho = n & 1048575, t[Be + 4 >> 2] = Ho, cr = Ii + 32 | 0, Be = cr, T = n, n = he & 65535, T = T >>> 20 | 0, hs = T + tr | 0, n = T >>> 0 > hs >>> 0 ? n + 1 | 0 : n, t[Be >> 2] = hs, Ao = n, t[Be + 4 >> 2] = n, ro = a, t[E + 1664 >> 2] = a, Ro = L & 1048575, t[E + 1668 >> 2] = Ro, Xr(E + 1624 | 0, I, gr), n = d - -64 | 0, Bn = t[n >> 2], Ir = t[n + 4 >> 2], n = d + 56 | 0, gn = t[n >> 2], Ai = t[n + 4 >> 2], n = d + 48 | 0, Ti = t[n >> 2], Zi = t[n + 4 >> 2], n = d + 72 | 0, us = t[n >> 2], ks = t[n + 4 >> 2], wi = t[d + 40 >> 2], Gn = t[d + 44 >> 2], n = E + 1584 | 0, Xr(n, I + 40 | 0, gr), Xr(n, n, Is), yi = t[E + 1636 >> 2], n = yi + t[$r + 4 >> 2] | 0, bi = E + 1544 | 0, Wi = bi + 8 | 0, a = Wi, co = t[E + 1632 >> 2], tr = t[$r >> 2], Be = co + tr | 0, t[a >> 2] = Be, gr = Be >>> 0 < tr >>> 0 ? n + 1 | 0 : n, t[a + 4 >> 2] = gr, ai = t[E + 1644 >> 2], n = ai + t[jn + 4 >> 2] | 0, ns = bi + 16 | 0, L = ns, Co = t[E + 1640 >> 2], a = t[jn >> 2], tr = Co + a | 0, t[L >> 2] = tr, a = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, t[L + 4 >> 2] = a, fi = t[E + 1652 >> 2], n = fi + t[Wr + 4 >> 2] | 0, ji = bi + 24 | 0, $r = ji, Oi = t[E + 1648 >> 2], L = t[Wr >> 2], T = Oi + L | 0, t[$r >> 2] = T, L = T >>> 0 < L >>> 0 ? n + 1 | 0 : n, t[$r + 4 >> 2] = L, Bs = t[E + 1660 >> 2], n = Bs + t[cr + 4 >> 2] | 0, fo = bi + 32 | 0, jn = fo, Bi = t[E + 1656 >> 2], Wr = t[cr >> 2], $r = Bi + Wr | 0, t[jn >> 2] = $r, cr = Wr >>> 0 > $r >>> 0 ? n + 1 | 0 : n, t[jn + 4 >> 2] = cr, zs = t[E + 1628 >> 2], n = zs + t[E + 1668 >> 2] | 0, ni = t[E + 1624 >> 2], Wr = t[E + 1664 >> 2], jn = ni + Wr | 0, t[E + 1544 >> 2] = jn, Wr = Wr >>> 0 > jn >>> 0 ? n + 1 | 0 : n, t[E + 1548 >> 2] = Wr, Xs = E + 1232 | 0, or = jn << 1, Me = Wr << 1 | jn >>> 31, Ur(Xs, T, L, 0, 0, or, Me, 0, 0), Hi = E + 1312 | 0, kn = Be << 1, xr = gr, dr = Be, gr = gr << 1 | Be >>> 31, Ur(Hi, tr, a, 0, 0, kn, gr, 0, 0), Mr = E + 1168 | 0, n = cr, Ur(Mr, $r, n, 0, 0, $r, n, 0, 0), Gs = E + 1152 | 0, Ur(Gs, t[E + 1168 >> 2], t[E + 1172 >> 2], 0, 0, 15632, 16, 0, 0), ts = E + 1120 | 0, Be = $r << 1, cr = n << 1 | $r >>> 31, Ur(ts, Be, cr, 0, 0, jn, Wr, 0, 0), ws = E + 1216 | 0, Ur(ws, T, L, 0, 0, kn, gr, 0, 0), to = E + 1328 | 0, Ur(to, tr, a, 0, 0, tr, a, 0, 0), gs = E + 1136 | 0, n = Mr + 8 | 0, Ur(gs, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), wo = E + 1248 | 0, Ur(wo, jn, Wr, 0, 0, jn, Wr, 0, 0), ps = E + 1104 | 0, Ur(ps, Be, cr, 0, 0, dr, xr, 0, 0), Xi = a, jn = tr, n = a << 1 | tr >>> 31, $s = E + 1200 | 0, kn = T, Mr = L, Ur($s, T, L, 0, 0, tr << 1, n, 0, 0), gr = t[E + 1232 >> 2], a = t[E + 1312 >> 2], tr = gr + a | 0, T = t[E + 1236 >> 2], n = T + t[E + 1316 >> 2] | 0, a = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, n = a + t[E + 1156 >> 2] | 0, L = tr, $r = t[E + 1152 >> 2], tr = L + $r | 0, Zn = tr, tr = tr >>> 0 < $r >>> 0 ? n + 1 | 0 : n, $r = (a | 0) == (tr | 0) & L >>> 0 > Zn >>> 0 | a >>> 0 > tr >>> 0, n = Gs + 8 | 0, Wr = t[n >> 2], he = t[n + 4 >> 2], T = (a | 0) == (T | 0) & L >>> 0 < gr >>> 0 | a >>> 0 < T >>> 0, n = Hi + 8 | 0, gr = t[n >> 2], a = Xs + 8 | 0, L = gr + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[n + 4 >> 2] | 0, n = L >>> 0 < gr >>> 0 ? a + 1 | 0 : a, a = T + L | 0, n = (a >>> 0 < L >>> 0 ? n + 1 | 0 : n) + he | 0, T = a, a = a + Wr | 0, n = T >>> 0 > a >>> 0 ? n + 1 | 0 : n, T = a, a = a + $r | 0, L = T >>> 0 > a >>> 0 ? n + 1 | 0 : n, T = L << 12 | a >>> 20, Hi = tr, tr = a << 12 | tr >>> 20, Xs = T, pi = t[E + 1216 >> 2], T = t[E + 1328 >> 2], a = pi + T | 0, Gs = t[E + 1220 >> 2], n = Gs + t[E + 1332 >> 2] | 0, T = a >>> 0 < T >>> 0 ? n + 1 | 0 : n, $r = a, gr = t[E + 1120 >> 2], n = a + gr | 0, a = T + t[E + 1124 >> 2] | 0, gr = n >>> 0 < gr >>> 0 ? a + 1 | 0 : a, Wr = n, he = t[E + 1136 >> 2], a = n + he | 0, n = gr + t[E + 1140 >> 2] | 0, n = a >>> 0 < he >>> 0 ? n + 1 | 0 : n, he = a, a = n, n = n + Xs | 0, rs = E + 1088 | 0, Xs = he + tr | 0, tr = Xs >>> 0 < he >>> 0 ? n + 1 | 0 : n, Ni = (a | 0) == (tr | 0) & he >>> 0 > Xs >>> 0 | a >>> 0 > tr >>> 0, he = (a | 0) == (gr | 0) & he >>> 0 < Wr >>> 0 | a >>> 0 < gr >>> 0, n = gs + 8 | 0, gs = t[n >> 2], ds = t[n + 4 >> 2], gr = (T | 0) == (gr | 0) & Wr >>> 0 < $r >>> 0 | T >>> 0 > gr >>> 0, n = ts + 8 | 0, Wr = t[n >> 2], ts = t[n + 4 >> 2], $r = (T | 0) == (Gs | 0) & $r >>> 0 < pi >>> 0 | T >>> 0 < Gs >>> 0, n = to + 8 | 0, Gs = t[n >> 2], a = ws + 8 | 0, T = Gs + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[n + 4 >> 2] | 0, n = T >>> 0 < Gs >>> 0 ? a + 1 | 0 : a, a = T + $r | 0, n = (a >>> 0 < T >>> 0 ? n + 1 | 0 : n) + ts | 0, T = a, a = a + Wr | 0, n = T >>> 0 > a >>> 0 ? n + 1 | 0 : n, T = a, a = a + gr | 0, n = (T >>> 0 > a >>> 0 ? n + 1 | 0 : n) + ds | 0, T = a + gs | 0, a = T >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = T + he | 0, a = n >>> 0 < T >>> 0 ? a + 1 | 0 : a, T = n, n = a, L = L >>> 20 | 0, a = T + L | 0, n = L >>> 0 > a >>> 0 ? n + 1 | 0 : n, T = a, a = a + Ni | 0, L = T >>> 0 > a >>> 0 ? n + 1 | 0 : n, gr = L << 12 | a >>> 20, T = tr, a = a << 12 | T >>> 20, tr = gr, he = t[E + 1104 >> 2], gr = t[E + 1200 >> 2], $r = he + gr | 0, Wr = t[E + 1108 >> 2], n = Wr + t[E + 1204 >> 2] | 0, gr = gr >>> 0 > $r >>> 0 ? n + 1 | 0 : n, n = a + $r | 0, a = tr + gr | 0, tr = n >>> 0 < $r >>> 0 ? a + 1 | 0 : a, a = n, n = tr << 4 | n >>> 28, ts = a << 4 & -16, Gs = T, Ur(rs, ts | T >>> 16 & 15, n & 16777215, 0, 0, 977, 1, 0, 0), ts = E + 1280 | 0, Ur(ts, dr, xr, 0, 0, or, Me, 0, 0), ws = E + 1072 | 0, Ur(ws, Be, cr, 0, 0, jn, Xi, 0, 0), to = E + 1184 | 0, Ur(to, kn, Mr, 0, 0, kn, Mr, 0, 0), Ni = E + 1056 | 0, gs = Ni, pi = (tr | 0) == (gr | 0) & a >>> 0 < $r >>> 0 | tr >>> 0 < gr >>> 0, T = (gr | 0) == (Wr | 0) & he >>> 0 > $r >>> 0 | gr >>> 0 < Wr >>> 0, n = $s + 8 | 0, gr = t[n >> 2], $r = ps + 8 | 0, a = gr + t[$r >> 2] | 0, n = t[$r + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 < gr >>> 0 ? n + 1 | 0 : n, he = a, a = a + T | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, L = L >>> 20 | 0, T = L, L = a + L | 0, a = T >>> 0 > L >>> 0 ? n + 1 | 0 : n, n = L + pi | 0, a = n >>> 0 < L >>> 0 ? a + 1 | 0 : a, T = a << 12 | n >>> 20, L = n << 12 | tr >>> 20, gr = T, Wr = t[E + 1072 >> 2], T = t[E + 1184 >> 2], tr = Wr + T | 0, $r = t[E + 1076 >> 2], n = $r + t[E + 1188 >> 2] | 0, n = T >>> 0 > tr >>> 0 ? n + 1 | 0 : n, T = tr, tr = n, n = n + gr | 0, L = T + L | 0, n = L >>> 0 < T >>> 0 ? n + 1 | 0 : n, gr = L, L = n, Ur(gs, gr, n & 1048575, 0, 0, 15632, 16, 0, 0), he = E + 1264 | 0, Ur(he, jn, Xi, 0, 0, or, Me, 0, 0), Me = E + 1296 | 0, Ur(Me, dr, xr, 0, 0, dr, xr, 0, 0), jn = E + 1040 | 0, Ur(jn, Be, cr, 0, 0, kn, Mr, 0, 0), or = E + 1024 | 0, Be = or, gr = (n | 0) == (tr | 0) & T >>> 0 > gr >>> 0 | n >>> 0 < tr >>> 0, T = (tr | 0) == ($r | 0) & T >>> 0 < Wr >>> 0 | tr >>> 0 < $r >>> 0, n = to + 8 | 0, $r = t[n >> 2], Wr = ws + 8 | 0, tr = $r + t[Wr >> 2] | 0, n = t[Wr + 4 >> 2] + t[n + 4 >> 2] | 0, n = tr >>> 0 < $r >>> 0 ? n + 1 | 0 : n, cr = tr, tr = T + tr | 0, n = cr >>> 0 > tr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, T = a, a = a + tr | 0, n = T >>> 0 > a >>> 0 ? n + 1 | 0 : n, tr = a + gr | 0, a = tr >>> 0 < a >>> 0 ? n + 1 | 0 : n, T = a << 12 | tr >>> 20, gr = tr << 12 | L >>> 20, $r = t[E + 1040 >> 2], tr = gr + $r | 0, L = T, n = T + t[E + 1044 >> 2] | 0, n = tr >>> 0 < $r >>> 0 ? n + 1 | 0 : n, Ur(Be, tr, n, 0, 0, 15632, 16, 0, 0), dr = E + 1008 | 0, T = dr, tr = (n | 0) == (L | 0) & tr >>> 0 < gr >>> 0 | n >>> 0 < L >>> 0, n = jn + 8 | 0, L = t[n >> 2], n = t[n + 4 >> 2], a = a >>> 20 | 0, Be = a, a = a + L | 0, n = Be >>> 0 > a >>> 0 ? n + 1 | 0 : n, L = a, a = a + tr | 0, n = L >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ur(T, a, n, 0, 0, 64028672, 65536, 0, 0), gs = t[E + 1608 >> 2], to = t[E + 1612 >> 2], ps = t[E + 1600 >> 2], ds = t[E + 1604 >> 2], pi = t[E + 1584 >> 2], vo = t[E + 1588 >> 2], jn = t[E + 1616 >> 2], Wr = t[E + 1620 >> 2], $s = t[E + 1592 >> 2], js = t[E + 1596 >> 2], t[E + 1416 >> 2] = -4 - Bi, t[E + 1420 >> 2] = 262143 - ((Bi >>> 0 > 4294967292) + Bs | 0), t[E + 1408 >> 2] = -4 - Oi, t[E + 1412 >> 2] = 4194303 - ((Oi >>> 0 > 4294967292) + fi | 0), t[E + 1400 >> 2] = -4 - Co, t[E + 1404 >> 2] = 4194303 - ((Co >>> 0 > 4294967292) + ai | 0), t[E + 1392 >> 2] = -4 - co, t[E + 1396 >> 2] = 4194303 - ((co >>> 0 > 4294967292) + yi | 0), t[E + 1384 >> 2] = -3908 - ni, t[E + 1388 >> 2] = 4194299 - ((ni >>> 0 > 4294963388) + zs | 0), n = wo + 8 | 0, xr = t[n >> 2], kn = t[n + 4 >> 2], n = rs + 8 | 0, L = t[n >> 2], Oi = t[n + 4 >> 2], tr = t[E + 1248 >> 2], n = t[E + 1252 >> 2], T = t[E + 1088 >> 2], a = t[E + 1092 >> 2], gr = ts + 8 | 0, Bi = t[gr >> 2], ni = t[gr + 4 >> 2], gr = Ni + 8 | 0, Be = t[gr >> 2], yi = t[gr + 4 >> 2], $r = t[E + 1280 >> 2], ai = t[E + 1284 >> 2], cr = t[E + 1056 >> 2], gr = t[E + 1060 >> 2], Me = Me + 8 | 0, wo = t[Me >> 2], rs = t[Me + 4 >> 2], he = he + 8 | 0, zs = t[he >> 2], Ni = t[he + 4 >> 2], he = t[E + 1296 >> 2], jo = t[E + 1300 >> 2], ts = t[E + 1264 >> 2], fi = t[E + 1268 >> 2], Me = or + 8 | 0, Xi = t[Me >> 2], co = t[Me + 4 >> 2], Me = t[E + 1024 >> 2], or = t[E + 1028 >> 2], ws = t[E + 1008 >> 2], Bs = t[E + 1012 >> 2], dr = dr + 8 | 0, za = t[dr >> 2], Co = t[dr + 4 >> 2], ya = E + 1384 | 0, Xr(E + 1504 | 0, Ii, ya), n = n + a | 0, Mr = T + tr | 0, tr = Mr >>> 0 < tr >>> 0 ? n + 1 | 0 : n, T = (a | 0) == (tr | 0) & T >>> 0 > Mr >>> 0 | a >>> 0 > tr >>> 0, a = kn + Oi | 0, n = L, L = L + xr | 0, n = n >>> 0 > L >>> 0 ? a + 1 | 0 : a, a = T + L | 0, L = a >>> 0 < L >>> 0 ? n + 1 | 0 : n, n = L << 12 | a >>> 20, Ii = tr, tr = a << 12 | tr >>> 20, dr = n, n = gr + ai | 0, T = cr + $r | 0, a = T >>> 0 < $r >>> 0 ? n + 1 | 0 : n, n = a + dr | 0, kn = T + tr | 0, tr = kn >>> 0 < T >>> 0 ? n + 1 | 0 : n, $r = (a | 0) == (tr | 0) & T >>> 0 > kn >>> 0 | a >>> 0 > tr >>> 0, gr = (a | 0) == (gr | 0) & T >>> 0 < cr >>> 0 | a >>> 0 < gr >>> 0, n = ni + yi | 0, T = Be + Bi | 0, a = T >>> 0 < Be >>> 0 ? n + 1 | 0 : n, n = T + gr | 0, a = n >>> 0 < T >>> 0 ? a + 1 | 0 : a, T = n, n = a, L = L >>> 20 | 0, a = T + L | 0, n = L >>> 0 > a >>> 0 ? n + 1 | 0 : n, T = a, a = a + $r | 0, gr = T >>> 0 > a >>> 0 ? n + 1 | 0 : n, L = gr << 12 | a >>> 20, Oi = tr, tr = a << 12 | tr >>> 20, n = fi + jo | 0, dr = he + ts | 0, Be = dr >>> 0 < he >>> 0 ? n + 1 | 0 : n, a = Be + or | 0, or = Me + dr | 0, $r = or >>> 0 < Me >>> 0 ? a + 1 | 0 : a, n = $r + L | 0, xr = tr + or | 0, tr = xr >>> 0 < or >>> 0 ? n + 1 | 0 : n, L = jn, T = Wr, Me = us, us = ks & 65535, a = pn(ks >>> 16 | 0, 0, 977, 1), Wr = a + wi | 0, n = Gn + Ee | 0, Bi = a >>> 0 > Wr >>> 0 ? n + 1 | 0 : n, n = Zi, a = Bi >>> 20 | 0, jn = a + Ti | 0, ni = a >>> 0 > jn >>> 0 ? n + 1 | 0 : n, n = Ai, a = ni >>> 20 | 0, cr = a + gn | 0, yi = a >>> 0 > cr >>> 0 ? n + 1 | 0 : n, a = Ir, n = us, he = yi >>> 20 | 0, Ir = he, he = he + Bn | 0, ai = Ir >>> 0 > he >>> 0 ? a + 1 | 0 : a, a = ai >>> 20 | 0, ks = a + Me | 0, Me = a >>> 0 > ks >>> 0 ? n + 1 | 0 : n, n = Me + T | 0, T = L + ks | 0, L = T >>> 0 < ks >>> 0 ? n + 1 | 0 : n, Ir = t[E + 1528 >> 2], gn = t[E + 1532 >> 2], Bn = (tr | 0) == ($r | 0) & or >>> 0 > xr >>> 0 | tr >>> 0 < $r >>> 0, $r = (Be | 0) == ($r | 0) & or >>> 0 < dr >>> 0 | Be >>> 0 > $r >>> 0, or = (Be | 0) == (fi | 0) & dr >>> 0 < ts >>> 0 | Be >>> 0 < fi >>> 0, n = Ni + rs | 0, Be = zs + wo | 0, a = Be >>> 0 < zs >>> 0 ? n + 1 | 0 : n, n = Be, Be = Be + or | 0, n = (n >>> 0 > Be >>> 0 ? a + 1 | 0 : a) + co | 0, a = Be + Xi | 0, n = a >>> 0 < Be >>> 0 ? n + 1 | 0 : n, Be = a, a = a + $r | 0, n = Be >>> 0 > a >>> 0 ? n + 1 | 0 : n, gr = gr >>> 20 | 0, a = a + gr | 0, n = gr >>> 0 > a >>> 0 ? n + 1 | 0 : n, Be = a, a = a + Bn | 0, gr = Be >>> 0 > a >>> 0 ? n + 1 | 0 : n, n = a, a = gr << 12 | n >>> 20, Bn = tr, tr = n << 12 | tr >>> 20, or = a, Be = Zn & -2, a = Be + ws | 0, n = Bs + (Hi & 1048575) | 0, Be = a >>> 0 < Be >>> 0 ? n + 1 | 0 : n, n = Be + or | 0, $r = a, Ai = a + tr | 0, tr = a >>> 0 > Ai >>> 0 ? n + 1 | 0 : n, n = gn + (tr & 1048575) | 0, or = Ir + Ai | 0, dr = or >>> 0 < Ai >>> 0 ? n + 1 | 0 : n, n = t[E + 1524 >> 2] + (Bn & 1048575) | 0, a = xr, xr = t[E + 1520 >> 2] + xr | 0, Bn = a >>> 0 > xr >>> 0 ? n + 1 | 0 : n, n = t[E + 1516 >> 2] + (Oi & 1048575) | 0, a = kn, kn = t[E + 1512 >> 2] + kn | 0, Ir = a >>> 0 > kn >>> 0 ? n + 1 | 0 : n, a = t[E + 1508 >> 2] + (Ii & 1048575) | 0, n = Mr, Mr = t[E + 1504 >> 2] + Mr | 0, gn = n >>> 0 > Mr >>> 0 ? a + 1 | 0 : a, n = t[E + 1540 >> 2] + (Gs & 65535) | 0, a = t[E + 1536 >> 2] + Xs | 0, n = a >>> 0 < Xs >>> 0 ? n + 1 | 0 : n, Xs = a, Ti = n, Ai = (Be | 0) == (tr | 0) & $r >>> 0 > Ai >>> 0 | Be >>> 0 > tr >>> 0, Be = (Be | 0) == (Bs | 0) & $r >>> 0 < ws >>> 0 | Be >>> 0 < Bs >>> 0, a = Be + za | 0, n = Co, n = a >>> 0 < Be >>> 0 ? n + 1 | 0 : n, gr = gr >>> 20 | 0, Be = gr, gr = a + gr | 0, a = Be >>> 0 > gr >>> 0 ? n + 1 | 0 : n, n = gr, gr = gr + Ai | 0, n = (n >>> 0 > gr >>> 0 ? a + 1 | 0 : a) << 12 | gr >>> 20, a = gr << 12 | tr >>> 20, tr = a + Xs | 0, n = n + Ti | 0, gr = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, Be = pn(gr >>> 16 | 0, 0, 977, 1), a = Be + Mr | 0, n = gn + Ee | 0, Ai = a, Ti = a >>> 0 < Be >>> 0 ? n + 1 | 0 : n, n = Ir, a = Ti >>> 20 | 0, Zi = a + kn | 0, us = a >>> 0 > Zi >>> 0 ? n + 1 | 0 : n, a = Bn, n = dr, Be = us >>> 20 | 0, wi = Be + xr | 0, Gn = Be >>> 0 > wi >>> 0 ? a + 1 | 0 : a, a = Gn >>> 20 | 0, Xi = a + or | 0, Be = a >>> 0 > Xi >>> 0 ? n + 1 | 0 : n, n = gr & 65535, a = Be >>> 20 | 0, Zn = a + tr | 0, Hi = a >>> 0 > Zn >>> 0 ? n + 1 | 0 : n, Bs = ks << 1, zs = Me << 1 | ks >>> 31, ts = tr, ws = gr, ks = T, wo = L & 65535, a = to, to = ai & 1048575, n = a + to | 0, Gs = he + gs | 0, gr = Gs >>> 0 < gs >>> 0 ? n + 1 | 0 : n, gs = yi & 1048575, n = gs + ds | 0, co = cr + ps | 0, $r = co >>> 0 < ps >>> 0 ? n + 1 | 0 : n, ps = ni & 1048575, a = ps + js | 0, T = jn, Co = T + $s | 0, jn = Co >>> 0 < $s >>> 0 ? a + 1 | 0 : a, $s = Bi & 1048575, n = $s + vo | 0, Me = Wr, Wr = Me + pi | 0, tr = Wr >>> 0 < pi >>> 0 ? n + 1 | 0 : n, Xs = L, L = pn(L >>> 16 | 0, 0, 977, 1), a = L + Wr | 0, n = tr + Ee | 0, n = a >>> 0 < L >>> 0 ? n + 1 | 0 : n, L = a, Ii = n, n = jn, a = Ii >>> 20 | 0, Oi = a + Co | 0, Bi = a >>> 0 > Oi >>> 0 ? n + 1 | 0 : n, n = $r, a = Bi >>> 20 | 0, ni = a + co | 0, yi = a >>> 0 > ni >>> 0 ? n + 1 | 0 : n, a = gr, n = wo, ai = yi >>> 20 | 0, fi = ai, ai = ai + Gs | 0, a = fi >>> 0 > ai >>> 0 ? a + 1 | 0 : a, fi = a >>> 20 | 0, wo = fi, fi = fi + ks | 0, n = wo >>> 0 > fi >>> 0 ? n + 1 | 0 : n, fi | (ai | (L | Oi | ni)) | (n | (Ii | Bi | yi | a) & 1048575) ? (Oi & (L ^ 976) & ni & ai & fi) == -1 ? a = (Bi & (Ii ^ 1) & yi & a & (n ^ 983040)) == 1048575 : a = 0 : a = 1, n = a, Xi | (Ai | Zi | wi) | Zn | ((us | Ti | Gn | Be) & 1048575 | Hi) ? (Zi & (Ai ^ 976) & wi & Xi & Zn) == -1 ? a = (us & (Ti ^ 1) & Gn & Be & (Hi ^ 983040)) == 1048575 : a = 0 : a = 1, Zn = n & a, t[E + 1376 >> 2] = Zn ? Bs : ts, t[E + 1380 >> 2] = Zn ? zs : ws, t[E + 1368 >> 2] = Zn ? he << 1 : or, t[E + 1372 >> 2] = Zn ? to << 1 | he >>> 31 : dr, t[E + 1360 >> 2] = Zn ? cr << 1 : xr, t[E + 1364 >> 2] = Zn ? gs << 1 | cr >>> 31 : Bn, t[E + 1352 >> 2] = Zn ? T << 1 : kn, t[E + 1356 >> 2] = Zn ? ps << 1 | T >>> 31 : Ir, t[E + 1344 >> 2] = Zn ? Me << 1 : Mr, t[E + 1348 >> 2] = Zn ? $s << 1 | Me >>> 31 : gn, n = t[E + 1420 >> 2] + Ao | 0, a = t[E + 1416 >> 2] + hs | 0, n = a >>> 0 < hs >>> 0 ? n + 1 | 0 : n, he = Zn ? a : ks, t[E + 1416 >> 2] = he, Me = Zn ? n : Xs, t[E + 1420 >> 2] = Me, n = t[E + 1412 >> 2] + Ho | 0, a = t[E + 1408 >> 2] + Xn | 0, n = a >>> 0 < Xn >>> 0 ? n + 1 | 0 : n, Xi = Zn ? a : Gs, t[E + 1408 >> 2] = Xi, Hi = Zn ? n : gr, t[E + 1412 >> 2] = Hi, n = t[E + 1404 >> 2] + Uo | 0, a = t[E + 1400 >> 2] + Un | 0, n = a >>> 0 < Un >>> 0 ? n + 1 | 0 : n, L = Zn ? a : co, t[E + 1400 >> 2] = L, T = Zn ? n : $r, t[E + 1404 >> 2] = T, n = t[E + 1396 >> 2] + bo | 0, a = t[E + 1392 >> 2] + xn | 0, n = a >>> 0 < xn >>> 0 ? n + 1 | 0 : n, a = Zn ? a : Co, t[E + 1392 >> 2] = a, Be = Zn ? n : jn, t[E + 1396 >> 2] = Be, n = t[E + 1388 >> 2] + Ro | 0, cr = t[E + 1384 >> 2] + ro | 0, n = cr >>> 0 < ro >>> 0 ? n + 1 | 0 : n, cr = Zn ? cr : Wr, t[E + 1384 >> 2] = cr, n = Zn ? n : tr, or = n, t[E + 1388 >> 2] = n, dr = E + 896 | 0, Un = cr << 1, xn = n << 1 | cr >>> 31, Ur(dr, Un, xn, 0, 0, Xi, Hi, 0, 0), Ai = Be, Xn = a, a = Be << 1 | a >>> 31, xr = E + 944 | 0, Be = Xn << 1, Ur(xr, Be, a, 0, 0, L, T, 0, 0), Bn = E + 832 | 0, Ur(Bn, he, Me, 0, 0, he, Me, 0, 0), kn = E + 816 | 0, Ur(kn, t[E + 832 >> 2], t[E + 836 >> 2], 0, 0, 15632, 16, 0, 0), Mr = E + 784 | 0, Ir = he << 1, hs = Me << 1 | he >>> 31, Ur(Mr, Ir, hs, 0, 0, cr, n, 0, 0), gn = E + 880 | 0, Ur(gn, Be, a, 0, 0, Xi, Hi, 0, 0), wi = E + 928 | 0, Ur(wi, L, T, 0, 0, L, T, 0, 0), Gn = E + 800 | 0, n = Bn + 8 | 0, Ur(Gn, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Oi = E + 992 | 0, Ur(Oi, cr, or, 0, 0, cr, or, 0, 0), Ii = E + 768 | 0, Ur(Ii, Ir, hs, 0, 0, Xn, Ai, 0, 0), Ti = T, ro = L, a = T << 1 | L >>> 31, Bi = E + 864 | 0, Ur(Bi, L << 1, a, 0, 0, Xi, Hi, 0, 0), cr = t[E + 896 >> 2], L = t[E + 944 >> 2], a = cr + L | 0, Be = t[E + 900 >> 2], n = Be + t[E + 948 >> 2] | 0, L = a >>> 0 < L >>> 0 ? n + 1 | 0 : n, n = L + t[E + 820 >> 2] | 0, T = a, he = t[E + 816 >> 2], a = a + he | 0, Zi = a, a = a >>> 0 < he >>> 0 ? n + 1 | 0 : n, he = (L | 0) == (a | 0) & T >>> 0 > Zi >>> 0 | a >>> 0 < L >>> 0, n = kn + 8 | 0, Me = t[n >> 2], or = t[n + 4 >> 2], T = (L | 0) == (Be | 0) & T >>> 0 < cr >>> 0 | L >>> 0 < Be >>> 0, n = xr + 8 | 0, Be = t[n >> 2], cr = dr + 8 | 0, L = Be + t[cr >> 2] | 0, n = t[cr + 4 >> 2] + t[n + 4 >> 2] | 0, n = L >>> 0 < Be >>> 0 ? n + 1 | 0 : n, Be = L, L = T + L | 0, n = (Be >>> 0 > L >>> 0 ? n + 1 | 0 : n) + or | 0, T = L, L = L + Me | 0, n = T >>> 0 > L >>> 0 ? n + 1 | 0 : n, T = L, L = L + he | 0, T = T >>> 0 > L >>> 0 ? n + 1 | 0 : n, Be = T << 12 | L >>> 20, us = a, L = L << 12 | a >>> 20, cr = Be, Bn = t[E + 880 >> 2], Be = t[E + 928 >> 2], n = Bn + Be | 0, xr = t[E + 884 >> 2], a = xr + t[E + 932 >> 2] | 0, he = n >>> 0 < Be >>> 0 ? a + 1 | 0 : a, Me = n, Be = t[E + 784 >> 2], a = n + Be | 0, n = he + t[E + 788 >> 2] | 0, n = a >>> 0 < Be >>> 0 ? n + 1 | 0 : n, or = a, dr = t[E + 800 >> 2], a = a + dr | 0, Be = n, n = n + t[E + 804 >> 2] | 0, n = a >>> 0 < dr >>> 0 ? n + 1 | 0 : n, dr = a, a = n + cr | 0, ni = E + 752 | 0, kn = ni, cr = L + dr | 0, L = cr >>> 0 < dr >>> 0 ? a + 1 | 0 : a, yi = (n | 0) == (L | 0) & cr >>> 0 < dr >>> 0 | n >>> 0 > L >>> 0, dr = (n | 0) == (Be | 0) & or >>> 0 > dr >>> 0 | n >>> 0 < Be >>> 0, n = Gn + 8 | 0, Gn = t[n >> 2], ai = t[n + 4 >> 2], Be = (he | 0) == (Be | 0) & Me >>> 0 > or >>> 0 | he >>> 0 > Be >>> 0, n = Mr + 8 | 0, or = t[n >> 2], Mr = t[n + 4 >> 2], he = (he | 0) == (xr | 0) & Me >>> 0 < Bn >>> 0 | he >>> 0 < xr >>> 0, n = wi + 8 | 0, Me = t[n >> 2], xr = gn + 8 | 0, a = Me + t[xr >> 2] | 0, n = t[xr + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Me = a, a = a + he | 0, n = (Me >>> 0 > a >>> 0 ? n + 1 | 0 : n) + Mr | 0, he = a, a = a + or | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, Be = a + Be | 0, a = (Be >>> 0 < a >>> 0 ? n + 1 | 0 : n) + ai | 0, n = Be, Be = Be + Gn | 0, n = n >>> 0 > Be >>> 0 ? a + 1 | 0 : a, a = Be + dr | 0, n = a >>> 0 < Be >>> 0 ? n + 1 | 0 : n, T = T >>> 20 | 0, a = a + T | 0, n = T >>> 0 > a >>> 0 ? n + 1 | 0 : n, T = a, a = a + yi | 0, T = T >>> 0 > a >>> 0 ? n + 1 | 0 : n, Be = T << 12 | a >>> 20, Me = a << 12 | L >>> 20, n = Be, Mr = t[E + 768 >> 2], Be = t[E + 864 >> 2], he = Mr + Be | 0, dr = t[E + 772 >> 2], a = dr + t[E + 868 >> 2] | 0, Be = he >>> 0 < Be >>> 0 ? a + 1 | 0 : a, n = Be + n | 0, Me = he + Me | 0, a = Me >>> 0 < he >>> 0 ? n + 1 | 0 : n, or = Me, n = a << 4 | Me >>> 28, wi = L, Ur(kn, L >>> 16 & 15 | Me << 4 & -16, n & 16777215, 0, 0, 977, 1, 0, 0), xr = t[E + 756 >> 2], n = xr + t[E + 996 >> 2] | 0, gn = t[E + 752 >> 2], L = t[E + 992 >> 2], Me = gn + L | 0, Bn = Me, t[E + 1464 >> 2] = Me, L = L >>> 0 > Me >>> 0 ? n + 1 | 0 : n, kn = L & 1048575, t[E + 1468 >> 2] = kn, yi = E + 976 | 0, Ur(yi, Un, xn, 0, 0, Xn, Ai, 0, 0), ai = E + 720 | 0, Ur(ai, Ir, hs, 0, 0, ro, Ti, 0, 0), fi = E + 848 | 0, Ur(fi, Xi, Hi, 0, 0, Xi, Hi, 0, 0), Ao = E + 704 | 0, or = (a | 0) == (Be | 0) & he >>> 0 > or >>> 0 | a >>> 0 < Be >>> 0, he = (Be | 0) == (dr | 0) & he >>> 0 < Mr >>> 0 | Be >>> 0 < dr >>> 0, n = Bi + 8 | 0, dr = t[n >> 2], Mr = Ii + 8 | 0, Be = dr + t[Mr >> 2] | 0, n = t[Mr + 4 >> 2] + t[n + 4 >> 2] | 0, n = Be >>> 0 < dr >>> 0 ? n + 1 | 0 : n, dr = Be, Be = he + Be | 0, n = dr >>> 0 > Be >>> 0 ? n + 1 | 0 : n, T = T >>> 20 | 0, he = T, T = T + Be | 0, n = he >>> 0 > T >>> 0 ? n + 1 | 0 : n, Be = T, T = T + or | 0, Be = Be >>> 0 > T >>> 0 ? n + 1 | 0 : n, he = Be << 12 | T >>> 20, a = T << 12 | a >>> 20, T = he, Bi = t[E + 720 >> 2], he = t[E + 848 >> 2], Mr = Bi + he | 0, Ii = t[E + 724 >> 2], n = Ii + t[E + 852 >> 2] | 0, he = he >>> 0 > Mr >>> 0 ? n + 1 | 0 : n, n = he + T | 0, a = a + Mr | 0, n = a >>> 0 < Mr >>> 0 ? n + 1 | 0 : n, Gn = a, T = n, Ur(Ao, a, n & 1048575, 0, 0, 15632, 16, 0, 0), Me = (L | 0) == (xr | 0) & Me >>> 0 < gn >>> 0 | L >>> 0 < xr >>> 0, n = Oi + 8 | 0, or = t[n >> 2], dr = ni + 8 | 0, a = or + t[dr >> 2] | 0, n = t[dr + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 < or >>> 0 ? n + 1 | 0 : n, or = a, a = a + Me | 0, Me = or >>> 0 > a >>> 0 ? n + 1 | 0 : n, or = Me << 12 | a >>> 20, L = a << 12 | L >>> 20, n = or, ni = t[E + 704 >> 2], or = t[E + 976 >> 2], gn = ni + or | 0, Oi = t[E + 708 >> 2], a = Oi + t[E + 980 >> 2] | 0, or = or >>> 0 > gn >>> 0 ? a + 1 | 0 : a, n = or + n | 0, a = L + gn | 0, n = a >>> 0 < gn >>> 0 ? n + 1 | 0 : n, dr = a, t[E + 1472 >> 2] = a, L = n, xr = n & 1048575, t[E + 1476 >> 2] = xr, Bs = E + 912 | 0, Ur(Bs, Un, xn, 0, 0, ro, Ti, 0, 0), ro = E + 960 | 0, Ur(ro, Xn, Ai, 0, 0, Xn, Ai, 0, 0), Ai = E + 656 | 0, Ur(Ai, Ir, hs, 0, 0, Xi, Hi, 0, 0), hs = E + 640 | 0, Ir = hs, xn = (T | 0) == (he | 0) & Mr >>> 0 > Gn >>> 0 | T >>> 0 < he >>> 0, he = (he | 0) == (Ii | 0) & Mr >>> 0 < Bi >>> 0 | he >>> 0 < Ii >>> 0, n = fi + 8 | 0, Mr = t[n >> 2], Un = ai + 8 | 0, a = Mr + t[Un >> 2] | 0, n = t[Un + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 < Mr >>> 0 ? n + 1 | 0 : n, Mr = a, a = a + he | 0, n = Mr >>> 0 > a >>> 0 ? n + 1 | 0 : n, he = a, Be = Be >>> 20 | 0, a = Be, Be = he + Be | 0, n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, a = Be + xn | 0, Be = a >>> 0 < Be >>> 0 ? n + 1 | 0 : n, n = Be << 12 | a >>> 20, Ti = a << 12 | T >>> 20, he = t[E + 656 >> 2], T = Ti + he | 0, Un = n, n = n + t[E + 660 >> 2] | 0, xn = T, Mr = T >>> 0 < he >>> 0 ? n + 1 | 0 : n, Ur(Ir, T, Mr, 0, 0, 15632, 16, 0, 0), Ir = (L | 0) == (or | 0) & dr >>> 0 < gn >>> 0 | L >>> 0 < or >>> 0, T = (or | 0) == (Oi | 0) & gn >>> 0 < ni >>> 0 | or >>> 0 < Oi >>> 0, n = yi + 8 | 0, he = t[n >> 2], or = Ao + 8 | 0, a = he + t[or >> 2] | 0, n = t[or + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 < he >>> 0 ? n + 1 | 0 : n, he = a, a = a + T | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, T = a, he = Me >>> 20 | 0, T = T + he | 0, n = he >>> 0 > T >>> 0 ? n + 1 | 0 : n, a = T + Ir | 0, T = a >>> 0 < T >>> 0 ? n + 1 | 0 : n, n = T << 12 | a >>> 20, L = a << 12 | L >>> 20, Me = n, Gn = t[E + 912 >> 2], he = t[E + 960 >> 2], a = Gn + he | 0, Xn = t[E + 916 >> 2], n = Xn + t[E + 964 >> 2] | 0, n = a >>> 0 < he >>> 0 ? n + 1 | 0 : n, gn = a, a = t[E + 640 >> 2], Ir = gn + a | 0, or = n, n = n + t[E + 644 >> 2] | 0, a = a >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, n = a + Me | 0, he = L + Ir | 0, n = he >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, t[E + 1480 >> 2] = he, L = n, Me = n & 1048575, t[E + 1484 >> 2] = Me, Xi = E + 576 | 0, Mr = (Mr | 0) == (Un | 0) & xn >>> 0 < Ti >>> 0 | Mr >>> 0 < Un >>> 0, n = Ai + 8 | 0, xn = t[n >> 2], n = t[n + 4 >> 2], Be = Be >>> 20 | 0, Un = Be, Be = Be + xn | 0, n = Un >>> 0 > Be >>> 0 ? n + 1 | 0 : n, xn = Be, Be = Be + Mr | 0, n = xn >>> 0 > Be >>> 0 ? n + 1 | 0 : n, Ur(Xi, Be, n, 0, 0, 64028672, 65536, 0, 0), Mr = (a | 0) == (L | 0) & he >>> 0 < Ir >>> 0 | a >>> 0 > L >>> 0, Ir = (a | 0) == (or | 0) & Ir >>> 0 < gn >>> 0 | a >>> 0 < or >>> 0, n = hs + 8 | 0, xn = t[n >> 2], Un = t[n + 4 >> 2], or = (or | 0) == (Xn | 0) & gn >>> 0 < Gn >>> 0 | or >>> 0 < Xn >>> 0, n = ro + 8 | 0, a = t[n >> 2], gn = Bs + 8 | 0, Be = a + t[gn >> 2] | 0, n = t[gn + 4 >> 2] + t[n + 4 >> 2] | 0, a = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, n = Be, Be = Be + or | 0, n = (n >>> 0 > Be >>> 0 ? a + 1 | 0 : a) + Un | 0, a = Be + xn | 0, n = a >>> 0 < Be >>> 0 ? n + 1 | 0 : n, Be = a, a = a + Ir | 0, n = Be >>> 0 > a >>> 0 ? n + 1 | 0 : n, T = T >>> 20 | 0, a = T + a | 0, n = T >>> 0 > a >>> 0 ? n + 1 | 0 : n, T = a, a = a + Mr | 0, T = T >>> 0 > a >>> 0 ? n + 1 | 0 : n, n = a, a = T << 12 | n >>> 20, L = n << 12 | L >>> 20, Be = a, Mr = t[E + 576 >> 2], Ir = Mr + (Zi & -2) | 0, gn = t[E + 580 >> 2], n = gn + (us & 1048575) | 0, a = Ir >>> 0 < Mr >>> 0 ? n + 1 | 0 : n, n = a + Be | 0, L = L + Ir | 0, n = L >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, t[E + 1488 >> 2] = L, Be = n, or = n & 1048575, t[E + 1492 >> 2] = or, xn = wi & 65535, Un = (n | 0) == (a | 0) & L >>> 0 < Ir >>> 0 | n >>> 0 < a >>> 0, Ir = (a | 0) == (gn | 0) & Ir >>> 0 < Mr >>> 0 | a >>> 0 < gn >>> 0, a = Xi + 8 | 0, n = Ir + t[a >> 2] | 0, a = t[a + 4 >> 2], a = n >>> 0 < Ir >>> 0 ? a + 1 | 0 : a, Ir = n, n = a, T = T >>> 20 | 0, a = T + Ir | 0, n = T >>> 0 > a >>> 0 ? n + 1 | 0 : n, T = a, a = a + Un | 0, n = xn + ((T >>> 0 > a >>> 0 ? n + 1 | 0 : n) << 12 | a >>> 20) | 0, a = a << 12 | Be >>> 20, T = a + cr | 0, t[E + 1496 >> 2] = T, a = a >>> 0 > T >>> 0 ? n + 1 | 0 : n, t[E + 1500 >> 2] = a, n = t[E + 1544 >> 2], Be = -5862 - n | 0, n = 6291449 - (t[E + 1548 >> 2] + (n >>> 0 > 4294961434) | 0) | 0, t[E + 1424 >> 2] = Be, t[E + 1428 >> 2] = n, n = t[Wi >> 2], Be = -6 - n | 0, n = 6291455 - (t[Wi + 4 >> 2] + (n >>> 0 > 4294967290) | 0) | 0, t[E + 1432 >> 2] = Be, t[E + 1436 >> 2] = n, n = t[ns >> 2], Be = -6 - n | 0, n = 6291455 - (t[ns + 4 >> 2] + (n >>> 0 > 4294967290) | 0) | 0, t[E + 1440 >> 2] = Be, t[E + 1444 >> 2] = n, n = t[ji >> 2], Be = -6 - n | 0, n = 6291455 - (t[ji + 4 >> 2] + (n >>> 0 > 4294967290) | 0) | 0, t[E + 1448 >> 2] = Be, t[E + 1452 >> 2] = n, n = t[fo >> 2], Be = -6 - n | 0, n = 393215 - (t[fo + 4 >> 2] + (n >>> 0 > 4294967290) | 0) | 0, t[E + 1456 >> 2] = Be, t[E + 1460 >> 2] = n, Ir = kn, n = Ir << 1 | Bn >>> 31, ro = E + 528 | 0, Be = or, kn = Bn << 1, or = n, Ur(ro, L, Be, 0, 0, kn, n, 0, 0), Ai = E + 592 | 0, cr = he, he = Me, xn = dr << 1, gn = xr, Mr = xr << 1 | dr >>> 31, Ur(Ai, cr, he, 0, 0, xn, Mr, 0, 0), Un = E + 496 | 0, Ur(Un, T, a, 0, 0, T, a, 0, 0), Ti = E + 480 | 0, Ur(Ti, t[E + 496 >> 2], t[E + 500 >> 2], 0, 0, 15632, 16, 0, 0), Zi = E + 448 | 0, Me = T << 1, xr = a << 1 | T >>> 31, Ur(Zi, Me, xr, 0, 0, Bn, Ir, 0, 0), us = E + 544 | 0, Ur(us, L, Be, 0, 0, xn, Mr, 0, 0), wi = E + 608 | 0, Ur(wi, cr, he, 0, 0, cr, he, 0, 0), Gn = E + 464 | 0, n = Un + 8 | 0, Ur(Gn, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Xi = E + 736 | 0, Ur(Xi, Bn, Ir, 0, 0, Bn, Ir, 0, 0), Hi = E + 432 | 0, Ur(Hi, Me, xr, 0, 0, dr, gn, 0, 0), Ii = E + 512 | 0, xn = L, Un = Be, Xn = he, Bn = cr, Ur(Ii, L, Be, 0, 0, cr << 1, he << 1 | cr >>> 31, 0, 0), cr = t[E + 528 >> 2], L = t[E + 592 >> 2], a = cr + L | 0, Be = t[E + 532 >> 2], n = Be + t[E + 596 >> 2] | 0, n = a >>> 0 < L >>> 0 ? n + 1 | 0 : n, T = a, he = t[E + 480 >> 2], L = a + he | 0, a = n + t[E + 484 >> 2] | 0, hs = L, L = L >>> 0 < he >>> 0 ? a + 1 | 0 : a, he = (n | 0) == (L | 0) & T >>> 0 > hs >>> 0 | n >>> 0 > L >>> 0, a = Ti + 8 | 0, Ir = t[a >> 2], Mr = t[a + 4 >> 2], T = (n | 0) == (Be | 0) & T >>> 0 < cr >>> 0 | n >>> 0 < Be >>> 0, n = Ai + 8 | 0, Be = t[n >> 2], cr = ro + 8 | 0, a = Be + t[cr >> 2] | 0, n = t[cr + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 < Be >>> 0 ? n + 1 | 0 : n, T = a + T | 0, a = (T >>> 0 < a >>> 0 ? n + 1 | 0 : n) + Mr | 0, n = T, T = T + Ir | 0, n = n >>> 0 > T >>> 0 ? a + 1 | 0 : a, a = T + he | 0, T = a >>> 0 < T >>> 0 ? n + 1 | 0 : n, n = T << 12 | a >>> 20, ro = L, Ai = a << 12 | L >>> 20, Oi = n, Bi = t[E + 544 >> 2], L = t[E + 608 >> 2], a = Bi + L | 0, Ti = t[E + 548 >> 2], n = Ti + t[E + 612 >> 2] | 0, n = a >>> 0 < L >>> 0 ? n + 1 | 0 : n, he = a, a = t[E + 448 >> 2], L = he + a | 0, cr = n, n = n + t[E + 452 >> 2] | 0, n = a >>> 0 > L >>> 0 ? n + 1 | 0 : n, Ir = L, Be = t[E + 464 >> 2], L = L + Be | 0, a = n, n = n + t[E + 468 >> 2] | 0, Be = L >>> 0 < Be >>> 0 ? n + 1 | 0 : n, n = Be + Oi | 0, Oi = E + 416 | 0, Mr = L, Ai = L + Ai | 0, L = L >>> 0 > Ai >>> 0 ? n + 1 | 0 : n, n = Be, Be = Ai, Ai = (L | 0) == (n | 0) & Mr >>> 0 > Be >>> 0 | n >>> 0 > L >>> 0, Mr = (n | 0) == (a | 0) & Ir >>> 0 > Mr >>> 0 | n >>> 0 < a >>> 0, n = Gn + 8 | 0, Gn = t[n >> 2], ni = t[n + 4 >> 2], Ir = (a | 0) == (cr | 0) & he >>> 0 > Ir >>> 0 | a >>> 0 < cr >>> 0, n = Zi + 8 | 0, Zi = t[n >> 2], yi = t[n + 4 >> 2], he = (cr | 0) == (Ti | 0) & he >>> 0 < Bi >>> 0 | cr >>> 0 < Ti >>> 0, n = wi + 8 | 0, a = t[n >> 2], Ti = us + 8 | 0, cr = a + t[Ti >> 2] | 0, n = t[Ti + 4 >> 2] + t[n + 4 >> 2] | 0, a = a >>> 0 > cr >>> 0 ? n + 1 | 0 : n, n = cr, cr = he + cr | 0, n = (n >>> 0 > cr >>> 0 ? a + 1 | 0 : a) + yi | 0, a = cr + Zi | 0, n = a >>> 0 < cr >>> 0 ? n + 1 | 0 : n, he = a, a = a + Ir | 0, n = (he >>> 0 > a >>> 0 ? n + 1 | 0 : n) + ni | 0, he = a, a = a + Gn | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, he = a, a = a + Mr | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, cr = a, T = T >>> 20 | 0, a = T, T = T + cr | 0, n = a >>> 0 > T >>> 0 ? n + 1 | 0 : n, a = T + Ai | 0, T = a >>> 0 < T >>> 0 ? n + 1 | 0 : n, n = T << 12 | a >>> 20, cr = L, L = a << 12 | L >>> 20, Ai = n, Ti = t[E + 432 >> 2], a = t[E + 512 >> 2], he = Ti + a | 0, Mr = t[E + 436 >> 2], n = Mr + t[E + 516 >> 2] | 0, a = a >>> 0 > he >>> 0 ? n + 1 | 0 : n, n = a + Ai | 0, Ir = L + he | 0, n = Ir >>> 0 < he >>> 0 ? n + 1 | 0 : n, Zi = Ir << 4 & -16, Ai = cr, L = n, Ur(Oi, Zi | cr >>> 16 & 15, (n << 4 | Ir >>> 28) & 16777215, 0, 0, 977, 1, 0, 0), Bi = E + 672 | 0, Ur(Bi, dr, gn, 0, 0, kn, or, 0, 0), Zi = E + 400 | 0, Ur(Zi, Me, xr, 0, 0, Bn, Xn, 0, 0), us = E + 560 | 0, Ur(us, xn, Un, 0, 0, xn, Un, 0, 0), Ao = E + 384 | 0, wi = Ao, Ir = (a | 0) == (n | 0) & he >>> 0 > Ir >>> 0 | a >>> 0 > n >>> 0, he = (a | 0) == (Mr | 0) & he >>> 0 < Ti >>> 0 | a >>> 0 < Mr >>> 0, n = Ii + 8 | 0, a = t[n >> 2], Mr = Hi + 8 | 0, cr = a + t[Mr >> 2] | 0, n = t[Mr + 4 >> 2] + t[n + 4 >> 2] | 0, a = a >>> 0 > cr >>> 0 ? n + 1 | 0 : n, n = he + cr | 0, a = n >>> 0 < cr >>> 0 ? a + 1 | 0 : a, cr = n, n = a, T = T >>> 20 | 0, a = T + cr | 0, n = T >>> 0 > a >>> 0 ? n + 1 | 0 : n, T = a, a = a + Ir | 0, T = T >>> 0 > a >>> 0 ? n + 1 | 0 : n, cr = T << 12 | a >>> 20, L = a << 12 | L >>> 20, he = cr, Mr = t[E + 400 >> 2], cr = t[E + 560 >> 2], a = Mr + cr | 0, Ir = t[E + 404 >> 2], n = Ir + t[E + 564 >> 2] | 0, n = a >>> 0 < cr >>> 0 ? n + 1 | 0 : n, cr = a, a = n + he | 0, L = L + cr | 0, a = L >>> 0 < cr >>> 0 ? a + 1 | 0 : a, he = L, L = a, Ur(wi, he, a & 1048575, 0, 0, 15632, 16, 0, 0), Hi = E + 624 | 0, Ur(Hi, Bn, Xn, 0, 0, kn, or, 0, 0), Ii = E + 688 | 0, Ur(Ii, dr, gn, 0, 0, dr, gn, 0, 0), or = E + 368 | 0, Ur(or, Me, xr, 0, 0, xn, Un, 0, 0), Bs = E + 352 | 0, Me = Bs, he = (n | 0) == (a | 0) & he >>> 0 < cr >>> 0 | n >>> 0 > a >>> 0, cr = (n | 0) == (Ir | 0) & cr >>> 0 < Mr >>> 0 | n >>> 0 < Ir >>> 0, n = us + 8 | 0, dr = t[n >> 2], xr = Zi + 8 | 0, a = dr + t[xr >> 2] | 0, n = t[xr + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 < dr >>> 0 ? n + 1 | 0 : n, dr = a, a = a + cr | 0, n = dr >>> 0 > a >>> 0 ? n + 1 | 0 : n, cr = a, T = T >>> 20 | 0, a = T, T = T + cr | 0, n = a >>> 0 > T >>> 0 ? n + 1 | 0 : n, a = T + he | 0, T = a >>> 0 < T >>> 0 ? n + 1 | 0 : n, n = T << 12 | a >>> 20, cr = a << 12 | L >>> 20, he = t[E + 368 >> 2], L = cr + he | 0, a = n, n = n + t[E + 372 >> 2] | 0, n = L >>> 0 < he >>> 0 ? n + 1 | 0 : n, Ur(Me, L, n, 0, 0, 15632, 16, 0, 0), ps = E + 336 | 0, he = ps, cr = (n | 0) == (a | 0) & L >>> 0 < cr >>> 0 | n >>> 0 < a >>> 0, n = or + 8 | 0, Me = t[n >> 2], n = t[n + 4 >> 2], L = T >>> 20 | 0, a = L + Me | 0, n = L >>> 0 > a >>> 0 ? n + 1 | 0 : n, T = a, a = a + cr | 0, n = T >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ur(he, a, n, 0, 0, 64028672, 65536, 0, 0), n = E + 1424 | 0, Xr(n, n, E + 1464 | 0), n = t[E + 1348 >> 2], Ir = n, Mr = t[E + 1344 >> 2], T = Mr, n = n << 1 | T >>> 31, gn = E - -64 | 0, a = t[E + 1368 >> 2], L = t[E + 1372 >> 2], xr = T << 1, dr = n, Ur(gn, a, L, 0, 0, xr, n, 0, 0), n = t[E + 1356 >> 2], us = n, wi = t[E + 1352 >> 2], he = wi, n = n << 1 | he >>> 31, Zi = E + 272 | 0, T = t[E + 1360 >> 2], cr = t[E + 1364 >> 2], kn = he << 1, Me = n, Ur(Zi, T, cr, 0, 0, kn, n, 0, 0), xn = E + 224 | 0, n = t[E + 1376 >> 2], he = t[E + 1380 >> 2], Ur(xn, n, he, 0, 0, n, he, 0, 0), Gn = E + 208 | 0, Ur(Gn, t[E + 224 >> 2], t[E + 228 >> 2], 0, 0, 15632, 16, 0, 0), or = he << 1, he = n, n = or | n >>> 31, ni = E + 176 | 0, or = he << 1, Bn = n, Ur(ni, or, n, 0, 0, Mr, Ir, 0, 0), yi = E + 80 | 0, Ur(yi, a, L, 0, 0, kn, Me, 0, 0), ai = E + 256 | 0, Ur(ai, T, cr, 0, 0, T, cr, 0, 0), fi = E + 192 | 0, n = xn + 8 | 0, Ur(fi, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), zs = E + 320 | 0, Ur(zs, Mr, Ir, 0, 0, Mr, Ir, 0, 0), ts = E + 160 | 0, Ur(ts, or, Bn, 0, 0, wi, us, 0, 0), ws = E + 96 | 0, xn = a, Un = L, Xn = cr, kn = T, Ur(ws, a, L, 0, 0, T << 1, cr << 1 | T >>> 31, 0, 0), Me = t[E + 64 >> 2], L = t[E + 272 >> 2], a = Me + L | 0, he = t[E + 68 >> 2], n = he + t[E + 276 >> 2] | 0, n = a >>> 0 < L >>> 0 ? n + 1 | 0 : n, T = a, a = t[E + 208 >> 2], cr = T + a | 0, L = n, n = n + t[E + 212 >> 2] | 0, a = a >>> 0 > cr >>> 0 ? n + 1 | 0 : n, Ti = cr, cr = (L | 0) == (a | 0) & cr >>> 0 < T >>> 0 | a >>> 0 < L >>> 0, n = Gn + 8 | 0, Ir = t[n >> 2], Mr = t[n + 4 >> 2], T = (L | 0) == (he | 0) & T >>> 0 < Me >>> 0 | L >>> 0 < he >>> 0, n = Zi + 8 | 0, he = t[n >> 2], Me = gn + 8 | 0, L = he + t[Me >> 2] | 0, n = t[Me + 4 >> 2] + t[n + 4 >> 2] | 0, n = L >>> 0 < he >>> 0 ? n + 1 | 0 : n, he = L, L = T + L | 0, n = (he >>> 0 > L >>> 0 ? n + 1 | 0 : n) + Mr | 0, T = L, L = L + Ir | 0, n = T >>> 0 > L >>> 0 ? n + 1 | 0 : n, T = L, L = L + cr | 0, T = T >>> 0 > L >>> 0 ? n + 1 | 0 : n, cr = T << 12 | L >>> 20, Zi = a, L = L << 12 | a >>> 20, to = t[E + 80 >> 2], he = t[E + 256 >> 2], a = to + he | 0, Gn = t[E + 84 >> 2], n = Gn + t[E + 260 >> 2] | 0, n = a >>> 0 < he >>> 0 ? n + 1 | 0 : n, Ir = a, Me = t[E + 176 >> 2], a = a + Me | 0, he = n, n = n + t[E + 180 >> 2] | 0, n = a >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Mr = a, gn = t[E + 192 >> 2], a = a + gn | 0, Me = n, n = n + t[E + 196 >> 2] | 0, n = a >>> 0 < gn >>> 0 ? n + 1 | 0 : n, gn = a, a = n, n = n + cr | 0, cr = L + gn | 0, L = cr >>> 0 < gn >>> 0 ? n + 1 | 0 : n, gs = (a | 0) == (L | 0) & cr >>> 0 < gn >>> 0 | a >>> 0 > L >>> 0, gn = (a | 0) == (Me | 0) & Mr >>> 0 > gn >>> 0 | a >>> 0 < Me >>> 0, n = fi + 8 | 0, fi = t[n >> 2], $s = t[n + 4 >> 2], Me = (he | 0) == (Me | 0) & Ir >>> 0 > Mr >>> 0 | he >>> 0 > Me >>> 0, n = ni + 8 | 0, Mr = t[n >> 2], ni = t[n + 4 >> 2], he = (he | 0) == (Gn | 0) & Ir >>> 0 < to >>> 0 | he >>> 0 < Gn >>> 0, n = ai + 8 | 0, Ir = t[n >> 2], Gn = yi + 8 | 0, a = Ir + t[Gn >> 2] | 0, n = t[Gn + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, Ir = a, a = a + he | 0, n = (Ir >>> 0 > a >>> 0 ? n + 1 | 0 : n) + ni | 0, he = a + Mr | 0, a = he >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = he, he = he + Me | 0, n = (n >>> 0 > he >>> 0 ? a + 1 | 0 : a) + $s | 0, a = he + fi | 0, n = a >>> 0 < he >>> 0 ? n + 1 | 0 : n, he = a, a = a + gn | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, T = T >>> 20 | 0, a = T + a | 0, n = T >>> 0 > a >>> 0 ? n + 1 | 0 : n, T = a, a = a + gs | 0, T = T >>> 0 > a >>> 0 ? n + 1 | 0 : n, n = a, Me = T << 12 | n >>> 20, a = L, Ir = n << 12 | a >>> 20, Gn = t[E + 160 >> 2], he = t[E + 96 >> 2], L = Gn + he | 0, gn = t[E + 164 >> 2], n = gn + t[E + 100 >> 2] | 0, he = L >>> 0 < he >>> 0 ? n + 1 | 0 : n, n = he + Me | 0, Me = L, Ir = L + Ir | 0, n = L >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, ni = Ir << 4 & -16, Mr = a, L = n, Ur(E, ni | a >>> 16 & 15, (n << 4 | Ir >>> 28) & 16777215, 0, 0, 977, 1, 0, 0), ai = E + 304 | 0, Ur(ai, wi, us, 0, 0, xr, dr, 0, 0), ni = E + 144 | 0, Ur(ni, or, Bn, 0, 0, kn, Xn, 0, 0), yi = E + 112 | 0, Ur(yi, xn, Un, 0, 0, xn, Un, 0, 0), fi = E + 48 | 0, Ir = (n | 0) == (he | 0) & Me >>> 0 > Ir >>> 0 | n >>> 0 < he >>> 0, Me = (he | 0) == (gn | 0) & Me >>> 0 < Gn >>> 0 | he >>> 0 < gn >>> 0, n = ws + 8 | 0, gn = t[n >> 2], a = ts + 8 | 0, he = gn + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[n + 4 >> 2] | 0, n = he >>> 0 < gn >>> 0 ? a + 1 | 0 : a, a = he + Me | 0, n = a >>> 0 < he >>> 0 ? n + 1 | 0 : n, T = T >>> 20 | 0, a = a + T | 0, n = T >>> 0 > a >>> 0 ? n + 1 | 0 : n, T = a, a = a + Ir | 0, T = T >>> 0 > a >>> 0 ? n + 1 | 0 : n, he = T << 12 | a >>> 20, L = a << 12 | L >>> 20, n = he, gn = t[E + 144 >> 2], Me = t[E + 112 >> 2], he = gn + Me | 0, Ir = t[E + 148 >> 2], a = Ir + t[E + 116 >> 2] | 0, a = he >>> 0 < Me >>> 0 ? a + 1 | 0 : a, n = a + n | 0, L = L + he | 0, n = L >>> 0 < he >>> 0 ? n + 1 | 0 : n, Me = L, L = n, Ur(fi, Me, n & 1048575, 0, 0, 15632, 16, 0, 0), Gn = E + 240 | 0, Ur(Gn, kn, Xn, 0, 0, xr, dr, 0, 0), ts = E + 288 | 0, Ur(ts, wi, us, 0, 0, wi, us, 0, 0), dr = E + 128 | 0, Ur(dr, or, Bn, 0, 0, xn, Un, 0, 0), wi = E + 32 | 0, or = wi, Me = (n | 0) == (a | 0) & he >>> 0 > Me >>> 0 | n >>> 0 < a >>> 0, he = (a | 0) == (Ir | 0) & he >>> 0 < gn >>> 0 | a >>> 0 < Ir >>> 0, n = yi + 8 | 0, xr = t[n >> 2], Bn = ni + 8 | 0, a = xr + t[Bn >> 2] | 0, n = t[Bn + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 < xr >>> 0 ? n + 1 | 0 : n, Ir = a, a = a + he | 0, n = Ir >>> 0 > a >>> 0 ? n + 1 | 0 : n, T = T >>> 20 | 0, he = T, T = a + T | 0, a = he >>> 0 > T >>> 0 ? n + 1 | 0 : n, n = T + Me | 0, a = n >>> 0 < T >>> 0 ? a + 1 | 0 : a, he = a << 12 | n >>> 20, Me = n << 12 | L >>> 20, xr = t[E + 128 >> 2], L = Me + xr | 0, T = he, n = T + t[E + 132 >> 2] | 0, n = L >>> 0 < xr >>> 0 ? n + 1 | 0 : n, Ur(or, L, n, 0, 0, 15632, 16, 0, 0), ws = E + 16 | 0, he = ws, T = (n | 0) == (T | 0) & L >>> 0 < Me >>> 0 | n >>> 0 < T >>> 0, n = dr + 8 | 0, L = t[n >> 2], n = t[n + 4 >> 2], a = a >>> 20 | 0, L = a + L | 0, a = a >>> 0 > L >>> 0 ? n + 1 | 0 : n, n = T + L | 0, a = n >>> 0 < L >>> 0 ? a + 1 | 0 : a, Ur(he, n, a, 0, 0, 64028672, 65536, 0, 0), Xr(v + 80 | 0, Is, ya), Is = t[d + 120 >> 2], L = v, v = t[E + 1424 >> 2], Ir = v, n = t[E + 1428 >> 2], gn = n, T = v, he = n, dr = t[E >> 2], v = t[E + 320 >> 2], a = dr + v | 0, or = t[E + 4 >> 2], n = or + t[E + 324 >> 2] | 0, v = v >>> 0 > a >>> 0 ? n + 1 | 0 : n, n = he + (v & 1048575) | 0, T = a + T | 0, n = T >>> 0 < a >>> 0 ? n + 1 | 0 : n, t[L >> 2] = T, he = n, t[L + 4 >> 2] = n, ni = L + 8 | 0, xn = ni, n = t[E + 1432 >> 2], Bn = n, Me = t[E + 1436 >> 2], kn = Me, Me = (v | 0) == (or | 0) & a >>> 0 < dr >>> 0 | v >>> 0 < or >>> 0, n = zs + 8 | 0, or = t[n >> 2], dr = E + 8 | 0, a = or + t[dr >> 2] | 0, n = t[dr + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 < or >>> 0 ? n + 1 | 0 : n, or = a, a = a + Me | 0, Me = or >>> 0 > a >>> 0 ? n + 1 | 0 : n, or = Me << 12 | a >>> 20, v = a << 12 | v >>> 20, a = or, zs = t[E + 48 >> 2], or = t[E + 304 >> 2], dr = zs + or | 0, Xn = t[E + 52 >> 2], n = Xn + t[E + 308 >> 2] | 0, or = or >>> 0 > dr >>> 0 ? n + 1 | 0 : n, a = or + a | 0, n = v + dr | 0, v = n >>> 0 < dr >>> 0 ? a + 1 | 0 : a, xr = n, a = Bn + n | 0, n = kn + (v & 1048575) | 0, t[xn >> 2] = a, n = a >>> 0 < xr >>> 0 ? n + 1 | 0 : n, t[xn + 4 >> 2] = n, xn = n << 1, n = a, a = xn | n >>> 31, xn = n << 1, n = a + kn | 0, a = Bn + xn | 0, n = a >>> 0 < xn >>> 0 ? n + 1 | 0 : n, t[Wi >> 2] = a, t[Wi + 4 >> 2] = n, yi = L + 16 | 0, n = t[E + 1440 >> 2], xn = n, a = t[E + 1444 >> 2], Un = a, xr = (v | 0) == (or | 0) & dr >>> 0 > xr >>> 0 | v >>> 0 < or >>> 0, or = (or | 0) == (Xn | 0) & dr >>> 0 < zs >>> 0 | or >>> 0 < Xn >>> 0, n = ai + 8 | 0, dr = t[n >> 2], Bn = fi + 8 | 0, a = dr + t[Bn >> 2] | 0, n = t[Bn + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 < dr >>> 0 ? n + 1 | 0 : n, dr = a, a = a + or | 0, n = dr >>> 0 > a >>> 0 ? n + 1 | 0 : n, or = a, Me = Me >>> 20 | 0, a = Me, Me = Me + or | 0, n = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, a = Me + xr | 0, Me = a >>> 0 < Me >>> 0 ? n + 1 | 0 : n, n = Me << 12 | a >>> 20, dr = a << 12 | v >>> 20, ai = n, fi = t[E + 240 >> 2], a = t[E + 288 >> 2], v = fi + a | 0, Xn = t[E + 244 >> 2], n = Xn + t[E + 292 >> 2] | 0, n = v >>> 0 < a >>> 0 ? n + 1 | 0 : n, xr = v, a = t[E + 32 >> 2], v = v + a | 0, or = n, n = n + t[E + 36 >> 2] | 0, a = v >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = a + ai | 0, Bn = v, dr = v + dr | 0, v = v >>> 0 > dr >>> 0 ? n + 1 | 0 : n, n = Un + (v & 1048575) | 0, kn = dr, dr = xn + dr | 0, t[yi >> 2] = dr, n = dr >>> 0 < kn >>> 0 ? n + 1 | 0 : n, t[yi + 4 >> 2] = n, n = (n << 1 | dr >>> 31) + Un | 0, dr = dr << 1, Un = dr, dr = dr + xn | 0, n = Un >>> 0 > dr >>> 0 ? n + 1 | 0 : n, t[ns >> 2] = dr, t[ns + 4 >> 2] = n, ai = L + 24 | 0, n = t[E + 1448 >> 2], dr = t[E + 1452 >> 2], xn = n, Un = dr, dr = (v | 0) == (a | 0) & Bn >>> 0 > kn >>> 0 | v >>> 0 < a >>> 0, Bn = (a | 0) == (or | 0) & xr >>> 0 > Bn >>> 0 | a >>> 0 < or >>> 0, n = wi + 8 | 0, kn = t[n >> 2], wi = t[n + 4 >> 2], xr = (or | 0) == (Xn | 0) & xr >>> 0 < fi >>> 0 | or >>> 0 < Xn >>> 0, n = ts + 8 | 0, a = t[n >> 2], Xn = Gn + 8 | 0, or = a + t[Xn >> 2] | 0, n = t[Xn + 4 >> 2] + t[n + 4 >> 2] | 0, a = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, n = or, or = or + xr | 0, n = (n >>> 0 > or >>> 0 ? a + 1 | 0 : a) + wi | 0, a = or + kn | 0, n = a >>> 0 < or >>> 0 ? n + 1 | 0 : n, or = a, a = a + Bn | 0, n = or >>> 0 > a >>> 0 ? n + 1 | 0 : n, Me = Me >>> 20 | 0, a = Me + a | 0, n = Me >>> 0 > a >>> 0 ? n + 1 | 0 : n, Me = a, a = a + dr | 0, Me = Me >>> 0 > a >>> 0 ? n + 1 | 0 : n, n = a, a = Me << 12 | n >>> 20, xr = n << 12 | v >>> 20, wi = t[E + 16 >> 2], or = Ti & -2, v = wi + or | 0, Xn = t[E + 20 >> 2], n = Xn + (Zi & 1048575) | 0, or = v >>> 0 < or >>> 0 ? n + 1 | 0 : n, n = or + a | 0, dr = v, xr = v + xr | 0, v = v >>> 0 > xr >>> 0 ? n + 1 | 0 : n, n = Un + (v & 1048575) | 0, a = xr + xn | 0, n = a >>> 0 < xr >>> 0 ? n + 1 | 0 : n, t[ai >> 2] = a, t[ai + 4 >> 2] = n, Bn = a << 1, a = (n << 1 | a >>> 31) + Un | 0, n = Bn + xn | 0, a = n >>> 0 < Bn >>> 0 ? a + 1 | 0 : a, t[ji >> 2] = n, t[ji + 4 >> 2] = a, fi = L + 32 | 0, Un = fi, n = t[E + 1456 >> 2], a = t[E + 1460 >> 2], Bn = n, kn = a, xn = cr, Mr = Mr & 65535, xr = (v | 0) == (or | 0) & dr >>> 0 > xr >>> 0 | v >>> 0 < or >>> 0, cr = (or | 0) == (Xn | 0) & dr >>> 0 < wi >>> 0 | or >>> 0 < Xn >>> 0, n = ws + 8 | 0, a = cr + t[n >> 2] | 0, n = t[n + 4 >> 2], n = a >>> 0 < cr >>> 0 ? n + 1 | 0 : n, Me = Me >>> 20 | 0, cr = a + Me | 0, a = Me >>> 0 > cr >>> 0 ? n + 1 | 0 : n, n = cr, cr = cr + xr | 0, n = (n >>> 0 > cr >>> 0 ? a + 1 | 0 : a) << 12 | cr >>> 20, a = cr << 12 | v >>> 20, v = a + xn | 0, n = n + Mr | 0, n = (v >>> 0 < a >>> 0 ? n + 1 | 0 : n) + kn | 0, a = v, v = v + Bn | 0, n = a >>> 0 > v >>> 0 ? n + 1 | 0 : n, t[Un >> 2] = v, t[Un + 4 >> 2] = n, n = (n << 1 | v >>> 31) + kn | 0, v = v << 1, a = v, v = v + Bn | 0, n = a >>> 0 > v >>> 0 ? n + 1 | 0 : n, t[fo >> 2] = v, t[fo + 4 >> 2] = n, cr = E, n = (he << 1 | T >>> 31) + gn | 0, v = T << 1, a = v, v = v + Ir | 0, n = a >>> 0 > v >>> 0 ? n + 1 | 0 : n, t[E + 1544 >> 2] = v, t[E + 1548 >> 2] = n, v = Xi + 8 | 0, or = t[v >> 2], pi = t[v + 4 >> 2], v = Oi + 8 | 0, bo = t[v >> 2], Uo = t[v + 4 >> 2], v = t[E + 736 >> 2], n = t[E + 740 >> 2], dr = t[E + 416 >> 2], T = t[E + 420 >> 2], a = Bi + 8 | 0, Ho = t[a >> 2], Ro = t[a + 4 >> 2], a = Ao + 8 | 0, xr = t[a >> 2], wo = t[a + 4 >> 2], Gn = t[E + 672 >> 2], rs = t[E + 676 >> 2], Xi = t[E + 384 >> 2], E = t[E + 388 >> 2], a = Ii + 8 | 0, Ni = t[a >> 2], ds = t[a + 4 >> 2], a = Hi + 8 | 0, zs = t[a >> 2], vo = t[a + 4 >> 2], ts = t[cr + 688 >> 2], js = t[cr + 692 >> 2], ws = t[cr + 624 >> 2], Ao = t[cr + 628 >> 2], a = Bs + 8 | 0, Bn = t[a >> 2], kn = t[a + 4 >> 2], to = t[cr + 352 >> 2], jo = t[cr + 356 >> 2], gs = t[cr + 336 >> 2], Bs = t[cr + 340 >> 2], a = ps + 8 | 0, za = t[a >> 2], Ir = t[a + 4 >> 2], Hi = L + 104 | 0, Mr = t[Hi >> 2], gn = t[Hi + 4 >> 2], Ii = L + 96 | 0, xn = t[Ii >> 2], Un = t[Ii + 4 >> 2], Oi = L + 88 | 0, Xn = t[Oi >> 2], Ti = t[Oi + 4 >> 2], Bi = L + 112 | 0, Zi = t[Bi >> 2], he = t[Bi + 4 >> 2], us = t[L + 80 >> 2], wi = t[L + 84 >> 2], Xr(bi, bi, cr + 1344 | 0), Me = t[cr + 1544 >> 2], ps = t[cr + 1548 >> 2], n = n + T | 0, a = v + dr | 0, v = a >>> 0 < v >>> 0 ? n + 1 | 0 : n, $s = Me, n = a, Me = Zn ? Wr : n, Wr = $s + Me | 0, a = ps + (Zn ? tr : v & 1048575) | 0, bi = 8388599 - ((Wr >>> 0 > 4294959480) + (Me >>> 0 > Wr >>> 0 ? a + 1 | 0 : a) | 0) | 0, ps = -7816 - Wr | 0, a = ps & 1, $s = 0 - a | 0, Me = 0 - a | 0, T = (v | 0) == (T | 0) & n >>> 0 < dr >>> 0 | v >>> 0 < T >>> 0, n = pi + Uo | 0, tr = or + bo | 0, a = tr >>> 0 < or >>> 0 ? n + 1 | 0 : n, n = T + tr | 0, a = n >>> 0 < tr >>> 0 ? a + 1 | 0 : a, T = a << 12 | n >>> 20, v = n << 12 | v >>> 20, Wr = T, n = E + rs | 0, T = Gn + Xi | 0, tr = T >>> 0 < Gn >>> 0 ? n + 1 | 0 : n, n = tr + Wr | 0, Wr = v + T | 0, v = Wr >>> 0 < T >>> 0 ? n + 1 | 0 : n, Gn = Wr, Wr = (tr | 0) == (v | 0) & Wr >>> 0 < T >>> 0 | v >>> 0 < tr >>> 0, T = (E | 0) == (tr | 0) & T >>> 0 < Xi >>> 0 | E >>> 0 > tr >>> 0, n = wo + Ro | 0, tr = xr + Ho | 0, n = tr >>> 0 < xr >>> 0 ? n + 1 | 0 : n, or = tr, tr = T + tr | 0, n = or >>> 0 > tr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, tr = a + tr | 0, a = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, n = tr + Wr | 0, T = n >>> 0 < tr >>> 0 ? a + 1 | 0 : a, tr = T << 12 | n >>> 20, Xi = v, v = n << 12 | v >>> 20, n = Ao + js | 0, or = ts + ws | 0, a = or >>> 0 < ts >>> 0 ? n + 1 | 0 : n, n = jo + a | 0, E = or + to | 0, Wr = E >>> 0 < to >>> 0 ? n + 1 | 0 : n, n = Wr + tr | 0, dr = v + E | 0, tr = dr >>> 0 < E >>> 0 ? n + 1 | 0 : n, v = hs & -2, xr = v + gs | 0, n = Bs + (ro & 1048575) | 0, v = v >>> 0 > xr >>> 0 ? n + 1 | 0 : n, hs = (tr | 0) == (Wr | 0) & E >>> 0 > dr >>> 0 | tr >>> 0 < Wr >>> 0, E = (a | 0) == (Wr | 0) & E >>> 0 < or >>> 0 | a >>> 0 > Wr >>> 0, or = (a | 0) == (Ao | 0) & or >>> 0 < ws >>> 0 | a >>> 0 < Ao >>> 0, a = ds + vo | 0, Wr = zs + Ni | 0, n = Wr >>> 0 < zs >>> 0 ? a + 1 | 0 : a, a = or + Wr | 0, n = (a >>> 0 < Wr >>> 0 ? n + 1 | 0 : n) + kn | 0, or = a, a = a + Bn | 0, n = or >>> 0 > a >>> 0 ? n + 1 | 0 : n, or = a, a = a + E | 0, n = or >>> 0 > a >>> 0 ? n + 1 | 0 : n, T = T >>> 20 | 0, or = T, T = a + T | 0, a = or >>> 0 > T >>> 0 ? n + 1 | 0 : n, n = T + hs | 0, a = n >>> 0 < T >>> 0 ? a + 1 | 0 : a, T = n, n = v + (a << 12 | n >>> 20) | 0, or = tr, T = T << 12 | tr >>> 20, tr = T + xr | 0, Wr = tr, tr = T >>> 0 > tr >>> 0 ? n + 1 | 0 : n, Bn = L + 72 | 0, T = Me, n = T >>> 16 | 0, E = (T & 65535) << 16 | $s >>> 16, Me = n, kn = t[fo >> 2], fo = t[fo + 4 >> 2], hs = Ai & 65535, ro = (v | 0) == (tr | 0) & xr >>> 0 > Wr >>> 0 | v >>> 0 > tr >>> 0, xr = (v | 0) == (Bs | 0) & xr >>> 0 < gs >>> 0 | v >>> 0 < Bs >>> 0, v = za + xr | 0, n = Ir, n = v >>> 0 < xr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, v = v + a | 0, a = a >>> 0 > v >>> 0 ? n + 1 | 0 : n, n = v, v = v + ro | 0, a = (n >>> 0 > v >>> 0 ? a + 1 | 0 : a) << 12 | v >>> 20, xr = tr, tr = v << 12 | tr >>> 20, v = tr + Be | 0, n = a + hs | 0, n = v >>> 0 < tr >>> 0 ? n + 1 | 0 : n, a = Zn ? ks : v, v = a + kn | 0, n = fo + (Zn ? Xs : n) | 0, n = (Me - ((v >>> 0 > E >>> 0) + (v >>> 0 < a >>> 0 ? n + 1 | 0 : n) | 0) | 0) + 524287 | 0, v = (E - v | 0) - 8 | 0, a = v >>> 0 < 4294967288 ? n + 1 | 0 : n, n = a >>> 1 | 0, E = (a & 1) << 31 | v >>> 1, t[Bn >> 2] = E, Be = n, t[Bn + 4 >> 2] = n, kn = L - -64 | 0, Me = kn, ks = v << 19 & 524288, tr = (T & 4095) << 20 | $s >>> 12, v = T >>> 12 | 0, T = Zn ? Gs : Wr, a = T + t[ji >> 2] | 0, n = t[ji + 4 >> 2] + (Zn ? gr : xr & 1048575) | 0, n = (v - ((a >>> 0 > tr >>> 0) + (a >>> 0 < T >>> 0 ? n + 1 | 0 : n) | 0) | 0) + 8388607 | 0, T = (tr - a | 0) - 8 | 0, gr = T >>> 0 < 4294967288 ? n + 1 | 0 : n, a = (gr >>> 1 | 0) + ks | 0, Wr = (gr & 1) << 31 | T >>> 1, n = Wr, a = n >>> 0 > n >>> 0 ? a + 1 | 0 : a, t[Me >> 2] = n, ks = a, t[Me + 4 >> 2] = a, xr = L + 56 | 0, Me = xr, Ir = T << 19 & 524288, T = Zn ? co : dr, a = T + t[ns >> 2] | 0, n = t[ns + 4 >> 2] + (Zn ? $r : or & 1048575) | 0, n = (v - ((a >>> 0 > tr >>> 0) + (a >>> 0 < T >>> 0 ? n + 1 | 0 : n) | 0) | 0) + 8388607 | 0, a = (tr - a | 0) - 8 | 0, T = a >>> 0 < 4294967288 ? n + 1 | 0 : n, n = (T >>> 1 | 0) + Ir | 0, gr = (T & 1) << 31 | a >>> 1, n = gr >>> 0 > gr >>> 0 ? n + 1 | 0 : n, t[Me >> 2] = gr, $r = n, t[Me + 4 >> 2] = n, dr = L + 48 | 0, or = a << 19 & 524288, T = tr, Me = v, n = Zn ? Co : Gn, v = n + t[Wi >> 2] | 0, a = t[Wi + 4 >> 2] + (Zn ? jn : Xi & 1048575) | 0, n = (Me - ((v >>> 0 > T >>> 0) + (v >>> 0 < n >>> 0 ? a + 1 | 0 : a) | 0) | 0) + 8388607 | 0, v = (T - v | 0) - 8 | 0, tr = v >>> 0 < 4294967288 ? n + 1 | 0 : n, n = (tr >>> 1 | 0) + or | 0, jn = (tr & 1) << 31 | v >>> 1, a = jn, n = a >>> 0 > a >>> 0 ? n + 1 | 0 : n, t[dr >> 2] = a, or = n, t[dr + 4 >> 2] = n, tr = v << 19 & 524288, n = (Me & 1048574) + bi | 0, v = (T & -977) + ps | 0, n = v >>> 0 < ps >>> 0 ? n + 1 | 0 : n, v = (n & 1) << 31 | v >>> 1, n = (n >>> 1 | 0) + tr | 0, tr = v, n = v >>> 0 < v >>> 0 ? n + 1 | 0 : n, t[L + 40 >> 2] = v, t[L + 44 >> 2] = n, d = t[d + 120 >> 2], T = d >> 31, v = d - 1 | 0, Ir = v, a = 0 - (((d | 0) != 0) + T | 0) | 0, Me = T - !d | 0, T = a & t[I + 4 >> 2] | Me & t[L + 4 >> 2], d = 0 - d | 0, t[L >> 2] = d & t[I >> 2] | v & t[L >> 2], t[L + 4 >> 2] = T, T = t[I + 12 >> 2] & a | t[ni + 4 >> 2] & Me, t[ni >> 2] = t[I + 8 >> 2] & d | t[ni >> 2] & v, t[ni + 4 >> 2] = T, T = t[I + 20 >> 2] & a | t[yi + 4 >> 2] & Me, t[yi >> 2] = t[I + 16 >> 2] & d | t[yi >> 2] & v, t[yi + 4 >> 2] = T, T = t[I + 28 >> 2] & a | t[ai + 4 >> 2] & Me, t[ai >> 2] = t[I + 24 >> 2] & d | t[ai >> 2] & v, t[ai + 4 >> 2] = T, T = t[I + 36 >> 2] & a | t[fi + 4 >> 2] & Me, t[fi >> 2] = t[I + 32 >> 2] & d | t[fi >> 2] & v, t[fi + 4 >> 2] = T, n = t[I + 44 >> 2] & a | n & Me, t[L + 40 >> 2] = t[I + 40 >> 2] & d | v & tr, t[L + 44 >> 2] = n, n = I + 48 | 0, tr = t[n >> 2], n = t[n + 4 >> 2] & a | Me & or, t[dr >> 2] = d & tr | v & jn, t[dr + 4 >> 2] = n, n = I + 56 | 0, tr = t[n >> 2], n = t[n + 4 >> 2] & a | Me & $r, t[xr >> 2] = d & tr | v & gr, t[xr + 4 >> 2] = n, n = I - -64 | 0, tr = t[n >> 2], n = t[n + 4 >> 2] & a | Me & ks, t[kn >> 2] = d & tr | v & Wr, t[kn + 4 >> 2] = n, I = I + 72 | 0, n = t[I >> 2], I = t[I + 4 >> 2] & a | Be & Me, t[Bn >> 2] = d & n | v & E, t[Bn + 4 >> 2] = I, I = Me & t[L + 84 >> 2], t[L + 80 >> 2] = t[L + 80 >> 2] & v | d & 1, t[L + 84 >> 2] = I, d = t[Oi + 4 >> 2] & Me, t[Oi >> 2] = t[Oi >> 2] & v, t[Oi + 4 >> 2] = d, d = t[Ii + 4 >> 2] & Me, t[Ii >> 2] = t[Ii >> 2] & v, t[Ii + 4 >> 2] = d, d = t[Hi + 4 >> 2] & Me, t[Hi >> 2] = t[Hi >> 2] & v, t[Hi + 4 >> 2] = d, Wr = t[Bi >> 2], E = t[Bi + 4 >> 2], $r = L, or = he & 65535, d = pn(he >>> 16 | 0, 0, 977, 1), v = d + us | 0, n = wi + Ee | 0, d = v >>> 0 < d >>> 0 ? n + 1 | 0 : n, I = d >>> 20 | 0, n = Ti, a = I, I = I + Xn | 0, tr = a >>> 0 > I >>> 0 ? n + 1 | 0 : n, n = Un, a = tr >>> 20 | 0, L = a + xn | 0, T = a >>> 0 > L >>> 0 ? n + 1 | 0 : n, n = gn, a = T >>> 20 | 0, gr = a + Mr | 0, Be = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, a = or, jn = Be >>> 20 | 0, n = jn + Zi | 0, a = jn >>> 0 > n >>> 0 ? a + 1 | 0 : a, n | (gr | (v | I | L)) | (a | (d | tr | T | Be) & 1048575) ? (I & (v ^ 976) & L & gr & n) == -1 ? v = (tr & (d ^ 1) & T & Be & (a ^ 983040)) == 1048575 : v = 0 : v = 1, t[$r + 120 >> 2] = v & (Is ^ -1), t[Bi >> 2] = Ir & Wr, t[Bi + 4 >> 2] = E & Me, x = cr + 1744 | 0;
  }
  function Ui(v, d) {
    var I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0, Xn = 0, Zn = 0, ni = 0, ai = 0, fi = 0, Ai = 0, yi = 0, Ii = 0, wi = 0, Bi = 0;
    a = x - 336 | 0, x = a, I = t[d + 4 >> 2], Wr = I, gr = t[d >> 2], n = gr, I = I << 1 | n >>> 31, Me = a - -64 | 0, dr = t[d + 24 >> 2], cr = t[d + 28 >> 2], Un = n << 1, Zn = I, Ur(Me, dr, cr, 0, 0, Un, I, 0, 0), I = t[d + 12 >> 2], Ii = I, ni = t[d + 8 >> 2], n = ni, I = I << 1 | n >>> 31, he = a + 272 | 0, Mr = t[d + 16 >> 2], or = t[d + 20 >> 2], n = n << 1, E = I, Ur(he, Mr, or, 0, 0, n, I, 0, 0), L = a + 224 | 0, T = t[d + 32 >> 2], d = t[d + 36 >> 2], Ur(L, T, d, 0, 0, T, d, 0, 0), Be = a + 208 | 0, Ur(Be, t[a + 224 >> 2], t[a + 228 >> 2], 0, 0, 15632, 16, 0, 0), I = d << 1 | T >>> 31, ai = a + 176 | 0, gn = T << 1, fi = I, Ur(ai, gn, I, 0, 0, gr, Wr, 0, 0), Ai = a + 80 | 0, Ur(Ai, dr, cr, 0, 0, n, E, 0, 0), yi = a + 256 | 0, Ur(yi, Mr, or, 0, 0, Mr, or, 0, 0), tr = a + 192 | 0, d = L + 8 | 0, Ur(tr, t[d >> 2], t[d + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Bi = a + 320 | 0, Ur(Bi, gr, Wr, 0, 0, gr, Wr, 0, 0), Gn = a + 160 | 0, Ur(Gn, gn, I, 0, 0, ni, Ii, 0, 0), jn = a + 96 | 0, Ur(jn, dr, cr, 0, 0, Mr << 1, or << 1 | Mr >>> 31, 0, 0), gr = t[a + 68 >> 2], I = gr + t[a + 276 >> 2] | 0, T = t[a + 64 >> 2], d = t[a + 272 >> 2], n = T + d | 0, E = t[a + 208 >> 2], wi = n + E | 0, d = d >>> 0 > n >>> 0 ? I + 1 | 0 : I, I = d + t[a + 212 >> 2] | 0, E = E >>> 0 > wi >>> 0 ? I + 1 | 0 : I, L = (d | 0) == (E | 0) & n >>> 0 > wi >>> 0 | d >>> 0 > E >>> 0, I = Be + 8 | 0, Be = t[I >> 2], kn = t[I + 4 >> 2], T = (d | 0) == (gr | 0) & n >>> 0 < T >>> 0 | d >>> 0 < gr >>> 0, I = he + 8 | 0, n = t[I >> 2], d = Me + 8 | 0, he = n + t[d >> 2] | 0, I = t[d + 4 >> 2] + t[I + 4 >> 2] | 0, I = n >>> 0 > he >>> 0 ? I + 1 | 0 : I, d = T + he | 0, I = (d >>> 0 < he >>> 0 ? I + 1 | 0 : I) + kn | 0, n = d, d = d + Be | 0, I = n >>> 0 > d >>> 0 ? I + 1 | 0 : I, n = d, d = d + L | 0, I = n >>> 0 > d >>> 0 ? I + 1 | 0 : I, Wr = E, kn = d << 12 | E >>> 20, n = I, T = I << 12 | d >>> 20, $r = t[a + 80 >> 2], d = t[a + 256 >> 2], L = $r + d | 0, Xn = t[a + 84 >> 2], I = Xn + t[a + 260 >> 2] | 0, I = d >>> 0 > L >>> 0 ? I + 1 | 0 : I, d = t[a + 176 >> 2], Be = d + L | 0, Me = I, I = I + t[a + 180 >> 2] | 0, I = d >>> 0 > Be >>> 0 ? I + 1 | 0 : I, d = t[a + 192 >> 2], E = d + Be | 0, he = I, I = I + t[a + 196 >> 2] | 0, d = d >>> 0 > E >>> 0 ? I + 1 | 0 : I, I = d + T | 0, kn = E + kn | 0, T = kn >>> 0 < E >>> 0 ? I + 1 | 0 : I, Bn = (d | 0) == (T | 0) & E >>> 0 > kn >>> 0 | d >>> 0 > T >>> 0, xn = (d | 0) == (he | 0) & E >>> 0 < Be >>> 0 | d >>> 0 < he >>> 0, d = tr + 8 | 0, xr = t[d >> 2], Ir = t[d + 4 >> 2], gr = (he | 0) == (Me | 0) & L >>> 0 > Be >>> 0 | he >>> 0 < Me >>> 0, d = ai + 8 | 0, tr = t[d >> 2], he = t[d + 4 >> 2], Be = (Me | 0) == (Xn | 0) & L >>> 0 < $r >>> 0 | Me >>> 0 < Xn >>> 0, I = yi + 8 | 0, E = t[I >> 2], d = Ai + 8 | 0, L = E + t[d >> 2] | 0, I = t[d + 4 >> 2] + t[I + 4 >> 2] | 0, I = E >>> 0 > L >>> 0 ? I + 1 | 0 : I, d = L + Be | 0, I = (d >>> 0 < L >>> 0 ? I + 1 | 0 : I) + he | 0, E = d, d = d + tr | 0, I = E >>> 0 > d >>> 0 ? I + 1 | 0 : I, E = d, d = d + gr | 0, I = (E >>> 0 > d >>> 0 ? I + 1 | 0 : I) + Ir | 0, E = d, d = d + xr | 0, I = E >>> 0 > d >>> 0 ? I + 1 | 0 : I, E = d + xn | 0, I = E >>> 0 < d >>> 0 ? I + 1 | 0 : I, n = n >>> 20 | 0, d = n + E | 0, I = n >>> 0 > d >>> 0 ? I + 1 | 0 : I, n = d, d = d + Bn | 0, I = n >>> 0 > d >>> 0 ? I + 1 | 0 : I, n = T, L = d << 12 | n >>> 20, E = I, Be = I << 12 | d >>> 20, xr = t[a + 160 >> 2], d = t[a + 96 >> 2], T = xr + d | 0, $r = t[a + 164 >> 2], I = $r + t[a + 100 >> 2] | 0, d = d >>> 0 > T >>> 0 ? I + 1 | 0 : I, I = d + Be | 0, tr = T, T = T + L | 0, L = T << 4 & -16, he = T >>> 0 < tr >>> 0 ? I + 1 | 0 : I, Be = (he << 4 | T >>> 28) & 16777215, gr = n, Ur(a, L | n >>> 16 & 15, Be, 0, 0, 977, 1, 0, 0), Bn = t[a + 4 >> 2], I = Bn + t[a + 324 >> 2] | 0, Be = v, xn = t[a >> 2], v = t[a + 320 >> 2], Me = xn + v | 0, t[Be >> 2] = Me, L = v >>> 0 > Me >>> 0 ? I + 1 | 0 : I, t[Be + 4 >> 2] = L & 1048575, Xn = a + 304 | 0, Ur(Xn, ni, Ii, 0, 0, Un, Zn, 0, 0), ai = a + 144 | 0, Ur(ai, gn, fi, 0, 0, Mr, or, 0, 0), Ai = a + 112 | 0, Ur(Ai, dr, cr, 0, 0, dr, cr, 0, 0), yi = a + 48 | 0, Ir = yi, T = (d | 0) == (he | 0) & T >>> 0 < tr >>> 0 | d >>> 0 > he >>> 0, n = (d | 0) == ($r | 0) & tr >>> 0 < xr >>> 0 | d >>> 0 < $r >>> 0, I = jn + 8 | 0, d = t[I >> 2], v = Gn + 8 | 0, tr = d + t[v >> 2] | 0, I = t[v + 4 >> 2] + t[I + 4 >> 2] | 0, I = d >>> 0 > tr >>> 0 ? I + 1 | 0 : I, d = n + tr | 0, I = d >>> 0 < tr >>> 0 ? I + 1 | 0 : I, n = E >>> 20 | 0, v = d + n | 0, I = n >>> 0 > v >>> 0 ? I + 1 | 0 : I, d = v, v = v + T | 0, I = d >>> 0 > v >>> 0 ? I + 1 | 0 : I, he = v << 12 | he >>> 20, T = I, E = I << 12 | v >>> 20, Gn = t[a + 148 >> 2], I = Gn + t[a + 116 >> 2] | 0, $r = t[a + 144 >> 2], d = t[a + 112 >> 2], v = $r + d | 0, xr = v, tr = v + he | 0, n = v >>> 0 < d >>> 0 ? I + 1 | 0 : I, I = n + E | 0, he = tr >>> 0 < v >>> 0 ? I + 1 | 0 : I, Ur(Ir, tr, he & 1048575, 0, 0, 15632, 16, 0, 0), E = (L | 0) == (Bn | 0) & Me >>> 0 < xn >>> 0 | L >>> 0 < Bn >>> 0, I = Bi + 8 | 0, d = t[I >> 2], v = a + 8 | 0, Me = d + t[v >> 2] | 0, I = t[v + 4 >> 2] + t[I + 4 >> 2] | 0, I = d >>> 0 > Me >>> 0 ? I + 1 | 0 : I, v = E + Me | 0, I = v >>> 0 < Me >>> 0 ? I + 1 | 0 : I, Me = v << 12 | L >>> 20, E = I, L = I << 12 | v >>> 20, Bn = t[a + 48 >> 2], v = t[a + 304 >> 2], Ir = Bn + v | 0, jn = t[a + 52 >> 2], I = jn + t[a + 308 >> 2] | 0, d = v >>> 0 > Ir >>> 0 ? I + 1 | 0 : I, I = d + L | 0, Me = Me + Ir | 0, I = Me >>> 0 < Ir >>> 0 ? I + 1 | 0 : I, t[Be + 8 >> 2] = Me, L = I, t[Be + 12 >> 2] = I & 1048575, xn = a + 240 | 0, Ur(xn, Mr, or, 0, 0, Un, Zn, 0, 0), Zn = a + 288 | 0, Ur(Zn, ni, Ii, 0, 0, ni, Ii, 0, 0), Un = a + 128 | 0, Ur(Un, gn, fi, 0, 0, dr, cr, 0, 0), fi = a + 32 | 0, cr = fi, or = (n | 0) == (he | 0) & tr >>> 0 < xr >>> 0 | n >>> 0 > he >>> 0, tr = (n | 0) == (Gn | 0) & xr >>> 0 < $r >>> 0 | n >>> 0 < Gn >>> 0, I = Ai + 8 | 0, n = t[I >> 2], v = ai + 8 | 0, dr = n + t[v >> 2] | 0, I = t[v + 4 >> 2] + t[I + 4 >> 2] | 0, I = n >>> 0 > dr >>> 0 ? I + 1 | 0 : I, n = tr + dr | 0, I = n >>> 0 < dr >>> 0 ? I + 1 | 0 : I, T = T >>> 20 | 0, v = n + T | 0, I = T >>> 0 > v >>> 0 ? I + 1 | 0 : I, n = v, v = v + or | 0, I = n >>> 0 > v >>> 0 ? I + 1 | 0 : I, Mr = v << 12 | he >>> 20, T = t[a + 128 >> 2], he = Mr + T | 0, n = I, gn = I << 12 | v >>> 20, I = gn + t[a + 132 >> 2] | 0, tr = T >>> 0 > he >>> 0 ? I + 1 | 0 : I, Ur(cr, he, tr, 0, 0, 15632, 16, 0, 0), T = Be, Me = (d | 0) == (L | 0) & Me >>> 0 < Ir >>> 0 | d >>> 0 > L >>> 0, Be = (d | 0) == (jn | 0) & Ir >>> 0 < Bn >>> 0 | d >>> 0 < jn >>> 0, I = Xn + 8 | 0, d = t[I >> 2], v = yi + 8 | 0, or = d + t[v >> 2] | 0, I = t[v + 4 >> 2] + t[I + 4 >> 2] | 0, I = d >>> 0 > or >>> 0 ? I + 1 | 0 : I, d = Be + or | 0, I = d >>> 0 < or >>> 0 ? I + 1 | 0 : I, E = E >>> 20 | 0, v = d + E | 0, I = E >>> 0 > v >>> 0 ? I + 1 | 0 : I, d = v, v = v + Me | 0, I = d >>> 0 > v >>> 0 ? I + 1 | 0 : I, Be = v << 12 | L >>> 20, d = I, cr = I << 12 | v >>> 20, Ir = t[a + 240 >> 2], v = t[a + 288 >> 2], L = Ir + v | 0, xr = t[a + 244 >> 2], I = xr + t[a + 292 >> 2] | 0, or = v >>> 0 > L >>> 0 ? I + 1 | 0 : I, I = or + t[a + 36 >> 2] | 0, v = t[a + 32 >> 2], E = v + L | 0, Me = E, Be = E + Be | 0, v = v >>> 0 > E >>> 0 ? I + 1 | 0 : I, I = v + cr | 0, t[T + 16 >> 2] = Be, E = Be >>> 0 < E >>> 0 ? I + 1 | 0 : I, t[T + 20 >> 2] = E & 1048575, dr = a + 16 | 0, cr = (tr | 0) == (gn | 0) & he >>> 0 < Mr >>> 0 | tr >>> 0 < gn >>> 0, I = Un + 8 | 0, tr = t[I >> 2], I = t[I + 4 >> 2], n = n >>> 20 | 0, he = n, n = n + tr | 0, I = he >>> 0 > n >>> 0 ? I + 1 | 0 : I, he = n, n = n + cr | 0, I = he >>> 0 > n >>> 0 ? I + 1 | 0 : I, Ur(dr, n, I, 0, 0, 64028672, 65536, 0, 0), n = T, cr = (v | 0) == (E | 0) & Be >>> 0 < Me >>> 0 | v >>> 0 > E >>> 0, tr = (v | 0) == (or | 0) & L >>> 0 > Me >>> 0 | v >>> 0 < or >>> 0, v = fi + 8 | 0, Me = t[v >> 2], he = t[v + 4 >> 2], Be = (or | 0) == (xr | 0) & L >>> 0 < Ir >>> 0 | or >>> 0 < xr >>> 0, I = Zn + 8 | 0, T = t[I >> 2], v = xn + 8 | 0, L = T + t[v >> 2] | 0, I = t[v + 4 >> 2] + t[I + 4 >> 2] | 0, I = L >>> 0 < T >>> 0 ? I + 1 | 0 : I, v = L + Be | 0, I = (v >>> 0 < L >>> 0 ? I + 1 | 0 : I) + he | 0, T = v, v = v + Me | 0, I = T >>> 0 > v >>> 0 ? I + 1 | 0 : I, T = v + tr | 0, I = T >>> 0 < v >>> 0 ? I + 1 | 0 : I, d = d >>> 20 | 0, v = d + T | 0, I = d >>> 0 > v >>> 0 ? I + 1 | 0 : I, d = v, v = v + cr | 0, I = d >>> 0 > v >>> 0 ? I + 1 | 0 : I, T = v << 12 | E >>> 20, d = I, E = I << 12 | v >>> 20, tr = t[a + 16 >> 2], v = wi & -2, Be = tr + v | 0, I = Wr & 1048575, Wr = t[a + 20 >> 2], I = I + Wr | 0, L = v >>> 0 > Be >>> 0 ? I + 1 | 0 : I, I = L + E | 0, E = T + Be | 0, I = E >>> 0 < Be >>> 0 ? I + 1 | 0 : I, t[n + 24 >> 2] = E, v = I, t[n + 28 >> 2] = I & 1048575, T = n, Me = gr & 65535, he = (I | 0) == (L | 0) & E >>> 0 < Be >>> 0 | I >>> 0 < L >>> 0, n = (L | 0) == (Wr | 0) & Be >>> 0 < tr >>> 0 | L >>> 0 < Wr >>> 0, I = dr + 8 | 0, E = n + t[I >> 2] | 0, I = t[I + 4 >> 2], I = n >>> 0 > E >>> 0 ? I + 1 | 0 : I, d = d >>> 20 | 0, n = d, d = d + E | 0, I = n >>> 0 > d >>> 0 ? I + 1 | 0 : I, n = d, d = d + he | 0, I = n >>> 0 > d >>> 0 ? I + 1 | 0 : I, v = d << 12 | v >>> 20, n = v + kn | 0, I = Me + (I << 12 | d >>> 20) | 0, t[T + 32 >> 2] = n, t[T + 36 >> 2] = v >>> 0 > n >>> 0 ? I + 1 | 0 : I, x = a + 336 | 0;
  }
  function Mi(v, d) {
    var I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0, Xn = 0, Zn = 0, ni = 0, ai = 0, fi = 0, Ai = 0, yi = 0, Ii = 0, wi = 0, Bi = 0, Ti = 0, Oi = 0, Hi = 0, Xi = 0, Zi = 0, ts = 0, us = 0, hs = 0, ws = 0, ks = 0, Bs = 0, gs = 0, ps = 0, zs = 0, Gs = 0, to = 0, ro = 0, $s = 0, Xs = 0, Ao = 0, co = 0, Co = 0, wo = 0;
    a = x - 464 | 0, x = a, t[v + 120 >> 2] = t[d + 120 >> 2], I = d + 40 | 0, Xr(v + 80 | 0, d + 80 | 0, I), Ui(a + 384 | 0, I), Ai = a + 424 | 0, Ui(Ai, d), gr = t[a + 388 >> 2], Ir = t[a + 384 >> 2], t[a + 344 >> 2] = -3908 - Ir, t[a + 348 >> 2] = 4194299 - ((Ir >>> 0 > 4294963388) + gr | 0), cr = t[a + 396 >> 2], Wr = t[a + 392 >> 2], t[a + 352 >> 2] = -4 - Wr, t[a + 356 >> 2] = 4194303 - ((Wr >>> 0 > 4294967292) + cr | 0), gn = t[a + 404 >> 2], Mr = t[a + 400 >> 2], t[a + 360 >> 2] = -4 - Mr, t[a + 364 >> 2] = 4194303 - ((Mr >>> 0 > 4294967292) + gn | 0), Me = t[a + 412 >> 2], L = t[a + 408 >> 2], t[a + 368 >> 2] = -4 - L, t[a + 372 >> 2] = 4194303 - ((L >>> 0 > 4294967292) + Me | 0), T = pn(t[a + 456 >> 2], t[a + 460 >> 2], 3, 0), E = Ee, $r = pn(t[a + 424 >> 2], t[a + 428 >> 2], 3, 0), Be = Ee, I = $r & 1, n = 0 - I | 0, or = n, tr = 0 - I | 0, I = (tr >>> 16 | 0) + E | 0, n = (tr & 65535) << 16 | n >>> 16, E = n + T | 0, I = n >>> 0 > E >>> 0 ? I + 1 | 0 : I, t[a + 456 >> 2] = (I & 1) << 31 | E >>> 1, t[a + 460 >> 2] = I >>> 1, he = E << 19 & 524288, T = tr >>> 12 | 0, or = (tr & 4095) << 20 | or >>> 12, n = pn(t[a + 448 >> 2], t[a + 452 >> 2], 3, 0), E = or + n | 0, I = T + Ee | 0, n = n >>> 0 > E >>> 0 ? I + 1 | 0 : I, I = (n >>> 1 | 0) + he | 0, tr = (n & 1) << 31 | E >>> 1, I = tr >>> 0 > tr >>> 0 ? I + 1 | 0 : I, t[a + 448 >> 2] = tr, t[a + 452 >> 2] = I, tr = E << 19 & 524288, E = pn(t[a + 440 >> 2], t[a + 444 >> 2], 3, 0) + or | 0, n = Ee + T | 0, n = E >>> 0 < or >>> 0 ? n + 1 | 0 : n, I = (n >>> 1 | 0) + tr | 0, he = (n & 1) << 31 | E >>> 1, I = he >>> 0 > he >>> 0 ? I + 1 | 0 : I, t[a + 440 >> 2] = he, t[a + 444 >> 2] = I, he = E << 19 & 524288, n = pn(t[a + 432 >> 2], t[a + 436 >> 2], 3, 0), tr = n + or | 0, I = T + Ee | 0, E = n >>> 0 > tr >>> 0 ? I + 1 | 0 : I, I = (E >>> 1 | 0) + he | 0, Bn = (E & 1) << 31 | tr >>> 1, n = Bn, I = n >>> 0 > n >>> 0 ? I + 1 | 0 : I, t[a + 432 >> 2] = n, t[a + 436 >> 2] = I, tr = tr << 19 & 524288, I = (T & 1048574) + Be | 0, E = (or & -977) + $r | 0, I = E >>> 0 < $r >>> 0 ? I + 1 | 0 : I, E = (I & 1) << 31 | E >>> 1, I = (I >>> 1 | 0) + tr | 0, n = E, I = n >>> 0 < n >>> 0 ? I + 1 | 0 : I, t[a + 424 >> 2] = n, t[a + 428 >> 2] = I, Be = t[a + 420 >> 2], he = t[a + 416 >> 2], t[a + 376 >> 2] = -4 - he, t[a + 380 >> 2] = 262143 - ((he >>> 0 > 4294967292) + Be | 0), yi = a + 344 | 0, Xr(yi, yi, d), Ui(v, Ai), d = t[a + 376 >> 2], zs = d, I = t[a + 380 >> 2], Gs = I, I = t[v + 36 >> 2] + (I << 1 | d >>> 31) | 0, d = d << 1, n = d, d = d + t[v + 32 >> 2] | 0, I = n >>> 0 > d >>> 0 ? I + 1 | 0 : I, Ti = d, t[v + 32 >> 2] = d, Zn = I, t[v + 36 >> 2] = I, T = v, E = t[v + 24 >> 2], v = t[a + 368 >> 2], to = v, d = t[a + 372 >> 2], ro = d, I = t[T + 28 >> 2] + (d << 1 | v >>> 31) | 0, v = v << 1, d = v, v = v + E | 0, I = d >>> 0 > v >>> 0 ? I + 1 | 0 : I, Oi = v, t[T + 24 >> 2] = v, Ii = I, t[T + 28 >> 2] = I, v = t[a + 360 >> 2], $s = v, d = t[a + 364 >> 2], Xs = d, I = t[T + 20 >> 2] + (d << 1 | v >>> 31) | 0, v = v << 1, d = v, v = v + t[T + 16 >> 2] | 0, I = d >>> 0 > v >>> 0 ? I + 1 | 0 : I, Hi = v, t[T + 16 >> 2] = v, wi = I, t[T + 20 >> 2] = I, v = t[a + 352 >> 2], Ao = v, d = t[a + 356 >> 2], co = d, n = t[T + 12 >> 2] + (d << 1 | v >>> 31) | 0, v = v << 1, d = v, v = v + t[T + 8 >> 2] | 0, n = d >>> 0 > v >>> 0 ? n + 1 | 0 : n, Xi = v, t[T + 8 >> 2] = v, $r = n, t[T + 12 >> 2] = n, v = t[a + 344 >> 2], Co = v, d = t[a + 348 >> 2], wo = d, I = t[T + 4 >> 2] + (d << 1 | v >>> 31) | 0, v = v << 1, d = v, v = v + t[T >> 2] | 0, I = d >>> 0 > v >>> 0 ? I + 1 | 0 : I, Zi = v, t[T >> 2] = v, Bn = I, t[T + 4 >> 2] = I, xn = a + 104 | 0, tr = L, E = Me, jn = Ir << 1, Un = gr << 1 | Ir >>> 31, Ur(xn, L, E, 0, 0, jn, Un, 0, 0), xr = a + 168 | 0, d = Mr, v = gn, or = Wr << 1, L = cr << 1 | Wr >>> 31, Ur(xr, d, v, 0, 0, or, L, 0, 0), Mr = a + 328 | 0, Ur(Mr, he, Be, 0, 0, he, Be, 0, 0), dr = a + 312 | 0, Ur(dr, t[a + 328 >> 2], t[a + 332 >> 2], 0, 0, 15632, 16, 0, 0), n = he, I = Be << 1 | n >>> 31, ts = a + 136 | 0, ni = n << 1, gn = I, Ur(ts, ni, I, 0, 0, Ir, gr, 0, 0), us = a + 152 | 0, Ur(us, tr, E, 0, 0, or, L, 0, 0), hs = a + 232 | 0, Ur(hs, d, v, 0, 0, d, v, 0, 0), Gn = a + 296 | 0, I = Mr + 8 | 0, Ur(Gn, t[I >> 2], t[I + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), ws = a + 120 | 0, Ur(ws, Ir, gr, 0, 0, Ir, gr, 0, 0), ks = a + 200 | 0, Ur(ks, ni, gn, 0, 0, Wr, cr, 0, 0), he = v, Mr = d, I = v << 1 | d >>> 31, Bs = a + 248 | 0, Me = tr, Be = E, Ur(Bs, Me, E, 0, 0, d << 1, I, 0, 0), gr = t[a + 108 >> 2], I = gr + t[a + 172 >> 2] | 0, E = t[a + 104 >> 2], v = t[a + 168 >> 2], n = E + v | 0, d = t[a + 312 >> 2], Ir = n + d | 0, v = v >>> 0 > n >>> 0 ? I + 1 | 0 : I, I = v + t[a + 316 >> 2] | 0, d = d >>> 0 > Ir >>> 0 ? I + 1 | 0 : I, L = (v | 0) == (d | 0) & n >>> 0 > Ir >>> 0 | v >>> 0 > d >>> 0, I = dr + 8 | 0, or = t[I >> 2], tr = t[I + 4 >> 2], E = (v | 0) == (gr | 0) & n >>> 0 < E >>> 0 | v >>> 0 < gr >>> 0, I = xr + 8 | 0, n = t[I >> 2], v = xn + 8 | 0, gr = n + t[v >> 2] | 0, I = t[v + 4 >> 2] + t[I + 4 >> 2] | 0, I = n >>> 0 > gr >>> 0 ? I + 1 | 0 : I, v = E + gr | 0, I = (v >>> 0 < gr >>> 0 ? I + 1 | 0 : I) + tr | 0, n = v, v = v + or | 0, n = n >>> 0 > v >>> 0 ? I + 1 | 0 : I, I = v, v = v + L | 0, n = I >>> 0 > v >>> 0 ? n + 1 | 0 : n, gr = d, tr = v << 12 | d >>> 20, d = n << 12 | v >>> 20, gs = t[a + 152 >> 2], v = t[a + 232 >> 2], L = gs + v | 0, Bi = t[a + 156 >> 2], I = Bi + t[a + 236 >> 2] | 0, I = v >>> 0 > L >>> 0 ? I + 1 | 0 : I, v = t[a + 136 >> 2], or = v + L | 0, xr = I, I = I + t[a + 140 >> 2] | 0, I = v >>> 0 > or >>> 0 ? I + 1 | 0 : I, v = t[a + 296 >> 2], E = v + or | 0, dr = I, I = I + t[a + 300 >> 2] | 0, v = v >>> 0 > E >>> 0 ? I + 1 | 0 : I, I = v + d | 0, ps = a + 40 | 0, tr = E + tr | 0, d = tr >>> 0 < E >>> 0 ? I + 1 | 0 : I, Xn = (v | 0) == (d | 0) & E >>> 0 > tr >>> 0 | v >>> 0 > d >>> 0, kn = (v | 0) == (dr | 0) & E >>> 0 < or >>> 0 | v >>> 0 < dr >>> 0, v = Gn + 8 | 0, ai = t[v >> 2], fi = t[v + 4 >> 2], xn = (dr | 0) == (xr | 0) & L >>> 0 > or >>> 0 | dr >>> 0 < xr >>> 0, v = ts + 8 | 0, Gn = t[v >> 2], dr = t[v + 4 >> 2], or = (xr | 0) == (Bi | 0) & L >>> 0 < gs >>> 0 | xr >>> 0 < Bi >>> 0, I = hs + 8 | 0, E = t[I >> 2], v = us + 8 | 0, L = E + t[v >> 2] | 0, I = t[v + 4 >> 2] + t[I + 4 >> 2] | 0, I = E >>> 0 > L >>> 0 ? I + 1 | 0 : I, v = L + or | 0, I = (v >>> 0 < L >>> 0 ? I + 1 | 0 : I) + dr | 0, E = v, v = v + Gn | 0, I = E >>> 0 > v >>> 0 ? I + 1 | 0 : I, E = v, v = v + xn | 0, I = (E >>> 0 > v >>> 0 ? I + 1 | 0 : I) + fi | 0, E = v, v = v + ai | 0, I = E >>> 0 > v >>> 0 ? I + 1 | 0 : I, E = v + kn | 0, I = E >>> 0 < v >>> 0 ? I + 1 | 0 : I, n = n >>> 20 | 0, v = n + E | 0, I = n >>> 0 > v >>> 0 ? I + 1 | 0 : I, n = v, v = v + Xn | 0, I = n >>> 0 > v >>> 0 ? I + 1 | 0 : I, L = v << 12 | d >>> 20, n = I, or = I << 12 | v >>> 20, Xn = t[a + 204 >> 2], I = Xn + t[a + 252 >> 2] | 0, kn = t[a + 200 >> 2], v = t[a + 248 >> 2], E = kn + v | 0, dr = E, L = E + L | 0, v = v >>> 0 > E >>> 0 ? I + 1 | 0 : I, I = v + or | 0, E = L >>> 0 < E >>> 0 ? I + 1 | 0 : I, I = E << 4 | L >>> 28, xr = L << 4 & -16, or = d, Ur(ps, xr | d >>> 16 & 15, I & 16777215, 0, 0, 977, 1, 0, 0), ai = a + 24 | 0, Ur(ai, Wr, cr, 0, 0, jn, Un, 0, 0), fi = a + 216 | 0, Ur(fi, ni, gn, 0, 0, Mr, he, 0, 0), xn = a + 280 | 0, Ur(xn, Me, Be, 0, 0, Me, Be, 0, 0), Gn = a + 88 | 0, xr = (v | 0) == (E | 0) & L >>> 0 < dr >>> 0 | v >>> 0 > E >>> 0, L = (v | 0) == (Xn | 0) & dr >>> 0 < kn >>> 0 | v >>> 0 < Xn >>> 0, I = Bs + 8 | 0, d = t[I >> 2], v = ks + 8 | 0, dr = d + t[v >> 2] | 0, I = t[v + 4 >> 2] + t[I + 4 >> 2] | 0, I = d >>> 0 > dr >>> 0 ? I + 1 | 0 : I, v = n, d = L + dr | 0, I = d >>> 0 < dr >>> 0 ? I + 1 | 0 : I, v = v >>> 20 | 0, n = v, v = v + d | 0, I = n >>> 0 > v >>> 0 ? I + 1 | 0 : I, d = v, v = v + xr | 0, d = d >>> 0 > v >>> 0 ? I + 1 | 0 : I, n = d << 12 | v >>> 20, L = v << 12 | E >>> 20, E = n, xr = t[a + 216 >> 2], v = t[a + 280 >> 2], n = xr + v | 0, kn = t[a + 220 >> 2], I = kn + t[a + 284 >> 2] | 0, v = v >>> 0 > n >>> 0 ? I + 1 | 0 : I, I = v + E | 0, E = L, L = n, n = E + n | 0, E = n >>> 0 < L >>> 0 ? I + 1 | 0 : I, Ur(Gn, n, E & 1048575, 0, 0, 15632, 16, 0, 0), dr = a + 8 | 0, Ur(dr, Mr, he, 0, 0, jn, Un, 0, 0), jn = a + 184 | 0, Ur(jn, Wr, cr, 0, 0, Wr, cr, 0, 0), cr = a + 264 | 0, Ur(cr, ni, gn, 0, 0, Me, Be, 0, 0), gn = a + 72 | 0, Be = gn, he = (v | 0) == (E | 0) & n >>> 0 < L >>> 0 | v >>> 0 > E >>> 0, L = (v | 0) == (kn | 0) & L >>> 0 < xr >>> 0 | v >>> 0 < kn >>> 0, n = xn + 8 | 0, I = t[n >> 2], v = fi + 8 | 0, Me = I + t[v >> 2] | 0, n = t[v + 4 >> 2] + t[n + 4 >> 2] | 0, I = I >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = L + Me | 0, I = n >>> 0 < Me >>> 0 ? I + 1 | 0 : I, d = d >>> 20 | 0, v = d + n | 0, I = d >>> 0 > v >>> 0 ? I + 1 | 0 : I, d = v, v = v + he | 0, I = d >>> 0 > v >>> 0 ? I + 1 | 0 : I, he = v << 12 | E >>> 20, E = t[a + 264 >> 2], Me = he + E | 0, d = I, v = I << 12 | v >>> 20, n = v + t[a + 268 >> 2] | 0, n = E >>> 0 > Me >>> 0 ? n + 1 | 0 : n, Ur(Be, Me, n, 0, 0, 15632, 16, 0, 0), Mr = a + 56 | 0, L = Mr, E = (v | 0) == (n | 0) & he >>> 0 > Me >>> 0 | v >>> 0 > n >>> 0, v = cr + 8 | 0, n = t[v >> 2], I = t[v + 4 >> 2], d = d >>> 20 | 0, v = d + n | 0, I = d >>> 0 > v >>> 0 ? I + 1 | 0 : I, d = v, v = v + E | 0, I = d >>> 0 > v >>> 0 ? I + 1 | 0 : I, Ur(L, v, I, 0, 0, 64028672, 65536, 0, 0), v = a, n = Zn + Gs | 0, d = Ti + zs | 0, n = d >>> 0 < Ti >>> 0 ? n + 1 | 0 : n, t[v + 376 >> 2] = d, t[v + 380 >> 2] = n, I = Ii + ro | 0, d = Oi + to | 0, I = d >>> 0 < Oi >>> 0 ? I + 1 | 0 : I, t[v + 368 >> 2] = d, t[v + 372 >> 2] = I, I = wi + Xs | 0, d = Hi + $s | 0, I = d >>> 0 < Hi >>> 0 ? I + 1 | 0 : I, t[v + 360 >> 2] = d, t[v + 364 >> 2] = I, I = $r + co | 0, d = Xi + Ao | 0, I = d >>> 0 < Xi >>> 0 ? I + 1 | 0 : I, t[v + 352 >> 2] = d, t[v + 356 >> 2] = I, he = v, I = Bn + wo | 0, v = Zi + Co | 0, I = v >>> 0 < Zi >>> 0 ? I + 1 | 0 : I, t[a + 344 >> 2] = v, t[a + 348 >> 2] = I, Xr(T + 40 | 0, yi, Ai), L = T, T = t[T + 40 >> 2], I = t[L + 44 >> 2], E = t[a + 40 >> 2], d = t[a + 120 >> 2], v = E + d | 0, Be = t[a + 44 >> 2], n = Be + t[a + 124 >> 2] | 0, d = v >>> 0 < d >>> 0 ? n + 1 | 0 : n, I = I + (d & 1048575) | 0, n = v + T | 0, I = n >>> 0 < v >>> 0 ? I + 1 | 0 : I, t[L + 40 >> 2] = -5862 - n, t[L + 44 >> 2] = 6291449 - ((n >>> 0 > 4294961434) + I | 0), I = L + 48 | 0, cr = I, Me = t[I >> 2], a = t[I + 4 >> 2], E = (d | 0) == (Be | 0) & v >>> 0 < E >>> 0 | d >>> 0 < Be >>> 0, I = ws + 8 | 0, n = t[I >> 2], v = ps + 8 | 0, T = n + t[v >> 2] | 0, I = t[v + 4 >> 2] + t[I + 4 >> 2] | 0, n = n >>> 0 > T >>> 0 ? I + 1 | 0 : I, v = E + T | 0, n = v >>> 0 < T >>> 0 ? n + 1 | 0 : n, T = v << 12 | d >>> 20, E = n << 12 | v >>> 20, Be = t[he + 88 >> 2], v = t[he + 24 >> 2], d = Be + v | 0, $r = t[he + 92 >> 2], I = $r + t[he + 28 >> 2] | 0, I = v >>> 0 > d >>> 0 ? I + 1 | 0 : I, v = T, T = d, d = v + d | 0, v = I, I = I + E | 0, E = d >>> 0 < T >>> 0 ? I + 1 | 0 : I, I = a + (E & 1048575) | 0, Me = d + Me | 0, I = Me >>> 0 < d >>> 0 ? I + 1 | 0 : I, t[cr >> 2] = -6 - Me, t[cr + 4 >> 2] = 6291455 - ((Me >>> 0 > 4294967290) + I | 0), I = L + 56 | 0, Bn = I, cr = t[I >> 2], Me = t[I + 4 >> 2], a = (v | 0) == (E | 0) & d >>> 0 < T >>> 0 | v >>> 0 > E >>> 0, T = (v | 0) == ($r | 0) & T >>> 0 < Be >>> 0 | v >>> 0 < $r >>> 0, I = ai + 8 | 0, d = t[I >> 2], v = Gn + 8 | 0, Be = d + t[v >> 2] | 0, I = t[v + 4 >> 2] + t[I + 4 >> 2] | 0, I = d >>> 0 > Be >>> 0 ? I + 1 | 0 : I, d = T + Be | 0, I = d >>> 0 < Be >>> 0 ? I + 1 | 0 : I, n = n >>> 20 | 0, v = d + n | 0, I = n >>> 0 > v >>> 0 ? I + 1 | 0 : I, d = v, v = v + a | 0, I = d >>> 0 > v >>> 0 ? I + 1 | 0 : I, E = v << 12 | E >>> 20, d = I, n = I << 12 | v >>> 20, Zn = t[he + 8 >> 2], v = t[he + 184 >> 2], a = Zn + v | 0, Un = t[he + 12 >> 2], I = Un + t[he + 188 >> 2] | 0, I = v >>> 0 > a >>> 0 ? I + 1 | 0 : I, v = t[he + 72 >> 2], T = v + a | 0, Be = I, I = I + t[he + 76 >> 2] | 0, v = v >>> 0 > T >>> 0 ? I + 1 | 0 : I, I = v + n | 0, E = E + T | 0, n = E >>> 0 < T >>> 0 ? I + 1 | 0 : I, I = Me + (n & 1048575) | 0, cr = E + cr | 0, I = cr >>> 0 < E >>> 0 ? I + 1 | 0 : I, t[Bn >> 2] = -6 - cr, t[Bn + 4 >> 2] = 6291455 - ((cr >>> 0 > 4294967290) + I | 0), I = L - -64 | 0, Wr = I, Ii = t[I >> 2], wi = t[I + 4 >> 2], $r = (v | 0) == (n | 0) & E >>> 0 < T >>> 0 | v >>> 0 > n >>> 0, Bn = (v | 0) == (Be | 0) & a >>> 0 > T >>> 0 | v >>> 0 < Be >>> 0, v = gn + 8 | 0, cr = t[v >> 2], Me = t[v + 4 >> 2], T = (Be | 0) == (Un | 0) & a >>> 0 < Zn >>> 0 | Be >>> 0 < Un >>> 0, I = jn + 8 | 0, E = t[I >> 2], v = dr + 8 | 0, a = E + t[v >> 2] | 0, I = t[v + 4 >> 2] + t[I + 4 >> 2] | 0, I = a >>> 0 < E >>> 0 ? I + 1 | 0 : I, v = a + T | 0, I = (v >>> 0 < a >>> 0 ? I + 1 | 0 : I) + Me | 0, E = v, v = v + cr | 0, I = E >>> 0 > v >>> 0 ? I + 1 | 0 : I, E = v + Bn | 0, I = E >>> 0 < v >>> 0 ? I + 1 | 0 : I, d = d >>> 20 | 0, v = d + E | 0, I = d >>> 0 > v >>> 0 ? I + 1 | 0 : I, d = v, v = v + $r | 0, I = d >>> 0 > v >>> 0 ? I + 1 | 0 : I, E = v << 12 | n >>> 20, d = I, a = I << 12 | v >>> 20, Be = t[he + 56 >> 2], n = Ir & -2, v = Be + n | 0, Me = t[he + 60 >> 2], I = Me + (gr & 1048575) | 0, T = v >>> 0 < n >>> 0 ? I + 1 | 0 : I, I = T + a | 0, n = E, E = v, n = n + v | 0, v = n >>> 0 < v >>> 0 ? I + 1 | 0 : I, I = wi + (v & 1048575) | 0, a = n + Ii | 0, I = a >>> 0 < n >>> 0 ? I + 1 | 0 : I, t[Wr >> 2] = -6 - a, t[Wr + 4 >> 2] = 6291455 - ((a >>> 0 > 4294967290) + I | 0), I = L + 72 | 0, Ir = I, gr = t[I >> 2], L = t[I + 4 >> 2], or = or & 65535, a = (v | 0) == (T | 0) & n >>> 0 < E >>> 0 | v >>> 0 < T >>> 0, n = (T | 0) == (Me | 0) & E >>> 0 < Be >>> 0 | T >>> 0 < Me >>> 0, I = Mr + 8 | 0, E = n + t[I >> 2] | 0, I = t[I + 4 >> 2], I = n >>> 0 > E >>> 0 ? I + 1 | 0 : I, d = d >>> 20 | 0, n = d, d = d + E | 0, I = n >>> 0 > d >>> 0 ? I + 1 | 0 : I, n = d, d = d + a | 0, I = n >>> 0 > d >>> 0 ? I + 1 | 0 : I, v = d << 12 | v >>> 20, E = v + tr | 0, n = or + (I << 12 | d >>> 20) | 0, I = (v >>> 0 > E >>> 0 ? n + 1 | 0 : n) + L | 0, v = E + gr | 0, I = v >>> 0 < E >>> 0 ? I + 1 | 0 : I, t[Ir >> 2] = -6 - v, t[Ir + 4 >> 2] = 393215 - ((v >>> 0 > 4294967290) + I | 0), x = he + 464 | 0;
  }
  function Ls(v, d) {
    var I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0;
    L = x - 80 | 0, x = L;
    e: {
      if (t[d + 120 >> 2]) {
        t[v + 80 >> 2] = 1, Vi(v, 80);
        break e;
      }
      tr = d + 88 | 0, a = t[tr >> 2], T = t[tr + 4 >> 2], E = t[d + 84 >> 2], n = d + 112 | 0, dr = t[n >> 2], he = t[n + 4 >> 2], gr = he, n = t[d + 80 >> 2], I = pn(he >>> 16 | 0, 0, 977, 1), Me = n + I | 0, E = E + Ee | 0, n = T, Be = I >>> 0 > Me >>> 0 ? E + 1 | 0 : E, I = Be >>> 20 | 0, T = I, I = I + a | 0, T = T >>> 0 > I >>> 0 ? n + 1 | 0 : n, Ir = T & 1048575, E = d + 104 | 0, cr = t[E >> 2], xr = t[E + 4 >> 2], E = d + 96 | 0, he = t[E >> 2], a = t[E + 4 >> 2], E = T >>> 20 | 0, he = E + he | 0, a = E >>> 0 > he >>> 0 ? a + 1 | 0 : a, n = xr, or = a, a = a >>> 20 | 0, E = a + cr | 0, n = a >>> 0 > E >>> 0 ? n + 1 | 0 : n, cr = n & 1048575, xr = d + 80 | 0, a = he, or = or & 1048575, Mr = (I & a & E) == -1 & (T & or & n) == 1048575, T = n >>> 20 | 0, n = gr & 65535, he = T + dr | 0, T = he >>> 0 < T >>> 0 ? n + 1 | 0 : n, n = Be & 1048575, dr = n, Mr & ((he | 0) == -1 & (T | 0) == 65535) & ((n | 0) == 1048574 & Me >>> 0 > 4294966318 | n >>> 0 > 1048574) | T >>> 16 && (n = dr + 1 | 0, Me = Me + 977 | 0, n = Me >>> 0 < 977 ? n + 1 | 0 : n, dr = n & 1048575, Be = n, n = Ir, Be = Be >>> 20 | 0, I = I + Be | 0, n = Be >>> 0 > I >>> 0 ? n + 1 | 0 : n, Ir = n & 1048575, Be = a, gr = n >>> 20 | 0, a = or, n = Be + gr | 0, a = n >>> 0 < gr >>> 0 ? a + 1 | 0 : a, or = a & 1048575, Be = a, a = n, n = cr, Be = Be >>> 20 | 0, E = E + Be | 0, n = Be >>> 0 > E >>> 0 ? n + 1 | 0 : n, cr = n & 1048575, Be = n, n = T, T = he, he = (Be >>> 20 | 0) + he | 0, T = (T >>> 0 > he >>> 0 ? n + 1 | 0 : n) & 65535), t[L + 72 >> 2] = T >>> 8, t[L + 76 >> 2] = 0, n = T << 22 | he >>> 10, t[L + 64 >> 2] = he << 22 & -4194304 | ((cr & 1073741823) << 2 | E >>> 30), t[L + 68 >> 2] = n & 1073741823 | cr >>> 30, t[L + 56 >> 2] = (or & 1048575) << 12 | a >>> 20, t[L + 60 >> 2] = E & 1073741823 | or >>> 20, a = a << 10 & 1073740800, t[L + 48 >> 2] = (Ir & 1023) << 22 | I >>> 10, t[L + 52 >> 2] = Ir >>> 10 | a, t[L + 40 >> 2] = Me, t[L + 44 >> 2] = dr | I << 20 & 1072693248, Me = L + 40 | 0, Rr(Me, 690464), E = t[L + 44 >> 2], a = E, t[d + 80 >> 2] = t[L + 40 >> 2], t[d + 84 >> 2] = a & 1048575, E = t[L + 72 >> 2] << 8, he = t[L + 68 >> 2], n = he >>> 22 | 0, T = t[L + 64 >> 2], t[d + 112 >> 2] = (he & 4194303) << 10 | T >>> 22, t[d + 116 >> 2] = n | E, I = T, n = he << 30 | I >>> 2, T = I << 30 & -1073741824, I = t[L + 56 >> 2], E = t[L + 60 >> 2], t[d + 104 >> 2] = E | T, t[d + 108 >> 2] = n & 1048575, E = E << 20 | I >>> 12, T = I << 20 & -1048576, he = E & 1048575, I = t[L + 48 >> 2], E = t[L + 52 >> 2], t[d + 96 >> 2] = E >>> 10 | T, t[d + 100 >> 2] = he, n = E << 10 | I >>> 22, t[d + 88 >> 2] = I << 10 & -1024 | a >>> 20, t[d + 92 >> 2] = n & 1048575, Ui(Me, xr), Xr(L, xr, Me), Xr(d, d, Me), I = d + 40 | 0, Xr(I, I, L), t[tr >> 2] = 0, t[tr + 4 >> 2] = 0, I = tr + 8 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = tr + 16 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = tr + 24 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, t[v + 80 >> 2] = 0, t[d + 80 >> 2] = 1, t[d + 84 >> 2] = 0, I = t[d + 4 >> 2], t[v >> 2] = t[d >> 2], t[v + 4 >> 2] = I, I = d + 8 | 0, E = t[I + 4 >> 2], a = v + 8 | 0, t[a >> 2] = t[I >> 2], t[a + 4 >> 2] = E, I = d + 16 | 0, E = t[I + 4 >> 2], a = v + 16 | 0, t[a >> 2] = t[I >> 2], t[a + 4 >> 2] = E, I = d + 24 | 0, E = t[I + 4 >> 2], a = v + 24 | 0, t[a >> 2] = t[I >> 2], t[a + 4 >> 2] = E, I = d + 32 | 0, E = t[I + 4 >> 2], a = v + 32 | 0, t[a >> 2] = t[I >> 2], t[a + 4 >> 2] = E, I = d + 72 | 0, E = t[I + 4 >> 2], a = v + 72 | 0, t[a >> 2] = t[I >> 2], t[a + 4 >> 2] = E, I = d - -64 | 0, E = t[I + 4 >> 2], a = v - -64 | 0, t[a >> 2] = t[I >> 2], t[a + 4 >> 2] = E, I = d + 56 | 0, E = t[I + 4 >> 2], a = v + 56 | 0, t[a >> 2] = t[I >> 2], t[a + 4 >> 2] = E, I = d + 48 | 0, E = t[I + 4 >> 2], a = v + 48 | 0, t[a >> 2] = t[I >> 2], t[a + 4 >> 2] = E, I = t[d + 44 >> 2], t[v + 40 >> 2] = t[d + 40 >> 2], t[v + 44 >> 2] = I;
    }
    x = L + 80 | 0;
  }
  function Ds(v, d, I) {
    var n = 0, a = 0;
    a = x - 128 | 0, x = a;
    e: {
      if (!d) {
        Qn[t[v + 168 >> 2]](689638, t[v + 172 >> 2]), v = 0;
        break e;
      }
      if (u[d | 0] = 0, u[d + 1 | 0] = 0, u[d + 2 | 0] = 0, u[d + 3 | 0] = 0, u[d + 4 | 0] = 0, u[d + 5 | 0] = 0, u[d + 6 | 0] = 0, u[d + 7 | 0] = 0, n = d + 56 | 0, u[n | 0] = 0, u[n + 1 | 0] = 0, u[n + 2 | 0] = 0, u[n + 3 | 0] = 0, u[n + 4 | 0] = 0, u[n + 5 | 0] = 0, u[n + 6 | 0] = 0, u[n + 7 | 0] = 0, n = d + 48 | 0, u[n | 0] = 0, u[n + 1 | 0] = 0, u[n + 2 | 0] = 0, u[n + 3 | 0] = 0, u[n + 4 | 0] = 0, u[n + 5 | 0] = 0, u[n + 6 | 0] = 0, u[n + 7 | 0] = 0, n = d + 40 | 0, u[n | 0] = 0, u[n + 1 | 0] = 0, u[n + 2 | 0] = 0, u[n + 3 | 0] = 0, u[n + 4 | 0] = 0, u[n + 5 | 0] = 0, u[n + 6 | 0] = 0, u[n + 7 | 0] = 0, n = d + 32 | 0, u[n | 0] = 0, u[n + 1 | 0] = 0, u[n + 2 | 0] = 0, u[n + 3 | 0] = 0, u[n + 4 | 0] = 0, u[n + 5 | 0] = 0, u[n + 6 | 0] = 0, u[n + 7 | 0] = 0, n = d + 24 | 0, u[n | 0] = 0, u[n + 1 | 0] = 0, u[n + 2 | 0] = 0, u[n + 3 | 0] = 0, u[n + 4 | 0] = 0, u[n + 5 | 0] = 0, u[n + 6 | 0] = 0, u[n + 7 | 0] = 0, n = d + 16 | 0, u[n | 0] = 0, u[n + 1 | 0] = 0, u[n + 2 | 0] = 0, u[n + 3 | 0] = 0, u[n + 4 | 0] = 0, u[n + 5 | 0] = 0, u[n + 6 | 0] = 0, u[n + 7 | 0] = 0, n = d + 8 | 0, u[n | 0] = 0, u[n + 1 | 0] = 0, u[n + 2 | 0] = 0, u[n + 3 | 0] = 0, u[n + 4 | 0] = 0, u[n + 5 | 0] = 0, u[n + 6 | 0] = 0, u[n + 7 | 0] = 0, !I) {
        Qn[t[v + 168 >> 2]](689936, t[v + 172 >> 2]), v = 0;
        break e;
      }
      if (v = 0, !vn(a, I) || (v = 0, !Cn(a + 40 | 0, a, 0)))
        break e;
      In(d, a + 40 | 0), v = 1;
    }
    return x = a + 128 | 0, v;
  }
  function Pr(v, d) {
    var I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0;
    n = x - 96 | 0, x = n, u[690885] = 0, u[690886] = 0, u[690887] = 0, u[690888] = 0, u[690889] = 0, u[690890] = 0, u[690891] = 0, u[690892] = 0, u[690909] = 0, u[690910] = 0, u[690911] = 0, u[690912] = 0, u[690913] = 0, u[690914] = 0, u[690915] = 0, u[690916] = 0, u[690901] = 0, u[690902] = 0, u[690903] = 0, u[690904] = 0, u[690905] = 0, u[690906] = 0, u[690907] = 0, u[690908] = 0, u[690893] = 0, u[690894] = 0, u[690895] = 0, u[690896] = 0, u[690897] = 0, u[690898] = 0, u[690899] = 0, u[690900] = 0;
    e: {
      if (!d) {
        Qn[t[v + 168 >> 2]](689638, t[v + 172 >> 2]);
        break e;
      }
      if (E = l[d + 60 | 0] | l[d + 61 | 0] << 8 | (l[d + 62 | 0] << 16 | l[d + 63 | 0] << 24), he = E >>> 16 | 0, a = n + 80 | 0, I = l[d + 56 | 0] | l[d + 57 | 0] << 8 | (l[d + 58 | 0] << 16 | l[d + 59 | 0] << 24), t[a >> 2] = (E & 65535) << 16 | I >>> 16, t[a + 4 >> 2] = he, L = I << 4 & 1048560, a = l[d + 52 | 0] | l[d + 53 | 0] << 8 | (l[d + 54 | 0] << 16 | l[d + 55 | 0] << 24), I = a >>> 28 | 0, T = n + 72 | 0, E = l[d + 48 | 0] | l[d + 49 | 0] << 8 | (l[d + 50 | 0] << 16 | l[d + 51 | 0] << 24), t[T >> 2] = (a & 268435455) << 4 | E >>> 28, t[T + 4 >> 2] = I | L, I = E, he = a << 24 | I >>> 8, E = l[d + 40 | 0] | l[d + 41 | 0] << 8 | (l[d + 42 | 0] << 16 | l[d + 43 | 0] << 24), L = n - -64 | 0, a = l[d + 44 | 0] | l[d + 45 | 0] << 8 | (l[d + 46 | 0] << 16 | l[d + 47 | 0] << 24), t[L >> 2] = I << 24 & -16777216 | a >>> 8, t[L + 4 >> 2] = he & 1048575, I = E, a = (a << 12 | I >>> 20) & 1048575, L = l[d + 32 | 0] | l[d + 33 | 0] << 8 | (l[d + 34 | 0] << 16 | l[d + 35 | 0] << 24), T = n + 56 | 0, Be = l[d + 36 | 0] | l[d + 37 | 0] << 8 | (l[d + 38 | 0] << 16 | l[d + 39 | 0] << 24), t[T >> 2] = I << 12 & -4096 | Be >>> 20, t[T + 4 >> 2] = a, t[n + 88 >> 2] = 0, t[n + 48 >> 2] = L, t[n + 52 >> 2] = Be & 1048575, E = l[d + 12 | 0] | l[d + 13 | 0] << 8 | (l[d + 14 | 0] << 16 | l[d + 15 | 0] << 24), I = l[d + 8 | 0] | l[d + 9 | 0] << 8 | (l[d + 10 | 0] << 16 | l[d + 11 | 0] << 24), he = E << 12 | I >>> 20, a = I << 12 & -4096, I = l[d | 0] | l[d + 1 | 0] << 8 | (l[d + 2 | 0] << 16 | l[d + 3 | 0] << 24), Be = l[d + 4 | 0] | l[d + 5 | 0] << 8 | (l[d + 6 | 0] << 16 | l[d + 7 | 0] << 24), Me = Be >>> 20 | a, t[n + 16 >> 2] = Me, tr = he & 1048575, t[n + 20 >> 2] = tr, a = I, t[n + 8 >> 2] = I, or = Be & 1048575, t[n + 12 >> 2] = or, T = l[d + 28 | 0] | l[d + 29 | 0] << 8 | (l[d + 30 | 0] << 16 | l[d + 31 | 0] << 24), I = T >>> 16 | 0, L = l[d + 24 | 0] | l[d + 25 | 0] << 8 | (l[d + 26 | 0] << 16 | l[d + 27 | 0] << 24), Be = (T & 65535) << 16 | L >>> 16, t[n + 40 >> 2] = Be, T = I, t[n + 44 >> 2] = I, I = l[d + 16 | 0] | l[d + 17 | 0] << 8 | (l[d + 18 | 0] << 16 | l[d + 19 | 0] << 24), dr = I, cr = l[d + 20 | 0] | l[d + 21 | 0] << 8 | (l[d + 22 | 0] << 16 | l[d + 23 | 0] << 24), d = I, I = cr << 24 | d >>> 8, E = d << 24 & -16777216 | E >>> 8, t[n + 24 >> 2] = E, he = I & 1048575, t[n + 28 >> 2] = he, d = cr, I = d >>> 28 | 0, d = (d & 268435455) << 4 | dr >>> 28, t[n + 32 >> 2] = d, I = I | L << 4 & 1048560, t[n + 36 >> 2] = I, !(a | Me | Be | E | d | (tr | or | T | he | I))) {
        Qn[t[v + 168 >> 2]](690116, t[v + 172 >> 2]);
        break e;
      }
      En(690885, n + 8 | 0), gr = 1;
    }
    return x = n + 96 | 0, gr;
  }
  function vr(v, d, I, n) {
    var a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0;
    a = x - 96 | 0, x = a;
    e: {
      if (!d) {
        Qn[t[v + 168 >> 2]](689586, t[v + 172 >> 2]), v = 0;
        break e;
      }
      if (!n) {
        Qn[t[v + 168 >> 2]](689638, t[v + 172 >> 2]), v = 0;
        break e;
      }
      if (tr = l[n + 60 | 0] | l[n + 61 | 0] << 8 | (l[n + 62 | 0] << 16 | l[n + 63 | 0] << 24), E = tr >>> 16 | 0, T = a + 80 | 0, L = l[n + 56 | 0] | l[n + 57 | 0] << 8 | (l[n + 58 | 0] << 16 | l[n + 59 | 0] << 24), tr = (tr & 65535) << 16 | L >>> 16, t[T >> 2] = tr, xn = E, t[T + 4 >> 2] = E, Me = L << 4 & 1048560, he = l[n + 52 | 0] | l[n + 53 | 0] << 8 | (l[n + 54 | 0] << 16 | l[n + 55 | 0] << 24), E = he >>> 28 | 0, T = a + 72 | 0, L = l[n + 48 | 0] | l[n + 49 | 0] << 8 | (l[n + 50 | 0] << 16 | l[n + 51 | 0] << 24), cr = (he & 268435455) << 4 | L >>> 28, t[T >> 2] = cr, Ir = E | Me, t[T + 4 >> 2] = Ir, E = he << 24 | L >>> 8, Me = L << 24 & -16777216, L = l[n + 40 | 0] | l[n + 41 | 0] << 8 | (l[n + 42 | 0] << 16 | l[n + 43 | 0] << 24), T = a - -64 | 0, he = l[n + 44 | 0] | l[n + 45 | 0] << 8 | (l[n + 46 | 0] << 16 | l[n + 47 | 0] << 24), dr = he >>> 8 | Me, t[T >> 2] = dr, xr = E & 1048575, t[T + 4 >> 2] = xr, E = L, Me = he << 12 | E >>> 20, L = l[n + 32 | 0] | l[n + 33 | 0] << 8 | (l[n + 34 | 0] << 16 | l[n + 35 | 0] << 24), T = a + 56 | 0, Be = l[n + 36 | 0] | l[n + 37 | 0] << 8 | (l[n + 38 | 0] << 16 | l[n + 39 | 0] << 24), gr = E << 12 & -4096 | Be >>> 20, t[T >> 2] = gr, Mr = Me & 1048575, t[T + 4 >> 2] = Mr, t[a + 88 >> 2] = 0, t[a + 48 >> 2] = L, Wr = Be & 1048575, t[a + 52 >> 2] = Wr, E = l[n + 12 | 0] | l[n + 13 | 0] << 8 | (l[n + 14 | 0] << 16 | l[n + 15 | 0] << 24), T = E, he = l[n + 8 | 0] | l[n + 9 | 0] << 8 | (l[n + 10 | 0] << 16 | l[n + 11 | 0] << 24), Be = (E << 12 | he >>> 20) & 1048575, E = l[n | 0] | l[n + 1 | 0] << 8 | (l[n + 2 | 0] << 16 | l[n + 3 | 0] << 24), or = l[n + 4 | 0] | l[n + 5 | 0] << 8 | (l[n + 6 | 0] << 16 | l[n + 7 | 0] << 24), $r = he << 12 & -4096 | or >>> 20, t[a + 16 >> 2] = $r, Un = Be, t[a + 20 >> 2] = Be, he = E, t[a + 8 >> 2] = E, gn = or & 1048575, t[a + 12 >> 2] = gn, Be = l[n + 28 | 0] | l[n + 29 | 0] << 8 | (l[n + 30 | 0] << 16 | l[n + 31 | 0] << 24), E = Be >>> 16 | 0, Me = l[n + 24 | 0] | l[n + 25 | 0] << 8 | (l[n + 26 | 0] << 16 | l[n + 27 | 0] << 24), or = (Be & 65535) << 16 | Me >>> 16, t[a + 40 >> 2] = or, Be = E, t[a + 44 >> 2] = E, E = l[n + 16 | 0] | l[n + 17 | 0] << 8 | (l[n + 18 | 0] << 16 | l[n + 19 | 0] << 24), Gn = E, Bn = l[n + 20 | 0] | l[n + 21 | 0] << 8 | (l[n + 22 | 0] << 16 | l[n + 23 | 0] << 24), n = E, kn = (Bn << 24 | n >>> 8) & 1048575, T = n << 24 & -16777216 | T >>> 8, t[a + 24 >> 2] = T, t[a + 28 >> 2] = kn, n = Bn, E = n >>> 28 | 0, n = (n & 268435455) << 4 | Gn >>> 28, t[a + 32 >> 2] = n, E = E | Me << 4 & 1048560, t[a + 36 >> 2] = E, !(he | $r | or | T | n | (Un | gn | Be | kn | E))) {
        Qn[t[v + 168 >> 2]](690116, t[v + 172 >> 2]), v = 0;
        break e;
      }
      L & 1 && (t[a + 80 >> 2] = -4 - tr, t[a + 84 >> 2] = 262143 - ((tr >>> 0 > 4294967292) + xn | 0), t[a + 72 >> 2] = -4 - cr, t[a + 76 >> 2] = 4194303 - ((cr >>> 0 > 4294967292) + Ir | 0), t[a + 64 >> 2] = -4 - dr, t[a + 68 >> 2] = 4194303 - ((dr >>> 0 > 4294967292) + xr | 0), t[a + 56 >> 2] = -4 - gr, t[a + 60 >> 2] = 4194303 - ((gr >>> 0 > 4294967292) + Mr | 0), t[a + 48 >> 2] = -3908 - L, t[a + 52 >> 2] = 4194299 - ((L >>> 0 > 4294963388) + Wr | 0), jn = 1), I && (t[I >> 2] = jn), In(d, a + 8 | 0), v = 1;
    }
    return x = a + 96 | 0, v;
  }
  function Cr(v, d) {
    var I = 0, n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0;
    I = x - 256 | 0, x = I;
    e: {
      if (!d) {
        Qn[t[v + 168 >> 2]](689700, t[v + 172 >> 2]);
        break e;
      }
      if (T = Vi(d, 96), !t[v >> 2]) {
        Qn[t[v + 168 >> 2]](690045, t[v + 172 >> 2]);
        break e;
      }
      for (n = I + 96 | 0, L = I + 128 | 0, Zr(n, 690788, L), Be = t[I + 120 >> 2], Me = t[I + 112 >> 2], a = t[I + 104 >> 2], tr = t[I + 96 >> 2], or = t[I + 124 >> 2], cr = t[I + 116 >> 2], dr = t[I + 108 >> 2], gr = t[I + 100 >> 2], he = t[I + 128 >> 2] | !(Be | (Me | (a | tr)) | (or | (cr | (dr | gr)))), d = he ? 0 : -1, t[I + 120 >> 2] = d & Be, t[I + 124 >> 2] = d & or, t[I + 112 >> 2] = d & Me, t[I + 116 >> 2] = d & cr, t[I + 104 >> 2] = d & a, t[I + 108 >> 2] = d & dr, a = (he | 0) != 0, t[I + 96 >> 2] = a | d & tr, t[I + 100 >> 2] = d & gr, hi(v, L, n), v = I + 8 | 0, ki(v, L), kr(T, n), In(T + 32 | 0, v), t[I + 128 >> 2] = a, v = t[I + 128 >> 2] - 1 | 0; d = E + T | 0, u[d | 0] = l[d | 0] & v, n = d + 1 | 0, u[n | 0] = l[n | 0] & v, n = d + 2 | 0, u[n | 0] = l[n | 0] & v, n = d + 3 | 0, u[n | 0] = l[n | 0] & v, n = d + 4 | 0, u[n | 0] = l[n | 0] & v, d = d + 5 | 0, u[d | 0] = l[d | 0] & v, E = E + 6 | 0, (E | 0) != 96; )
        ;
      E = !he;
    }
    return x = I + 256 | 0, E;
  }
  function yn(v, d, I, n, a, E, T, L) {
    v = v | 0, d = d | 0, I = I | 0, n = n | 0, a = a | 0, E = E | 0, T = T | 0, L = L | 0;
    var he = 0, Be = 0;
    if (he = x - 176 | 0, x = he, E) {
      e: {
        if (!L) {
          u[he | 0] = l[n | 0] ^ 84, u[he + 1 | 0] = l[n + 1 | 0] ^ 241, u[he + 2 | 0] = l[n + 2 | 0] ^ 105, u[he + 3 | 0] = l[n + 3 | 0] ^ 207, u[he + 4 | 0] = l[n + 4 | 0] ^ 201, u[he + 5 | 0] = l[n + 5 | 0] ^ 226, u[he + 6 | 0] = l[n + 6 | 0] ^ 229, u[he + 7 | 0] = l[n + 7 | 0] ^ 114, u[he + 8 | 0] = l[n + 8 | 0] ^ 116, u[he + 9 | 0] = l[n + 9 | 0] ^ 128, u[he + 10 | 0] = l[n + 10 | 0] ^ 68, u[he + 11 | 0] = l[n + 11 | 0] ^ 31, u[he + 12 | 0] = l[n + 12 | 0] ^ 144, u[he + 13 | 0] = l[n + 13 | 0] ^ 186, u[he + 14 | 0] = l[n + 14 | 0] ^ 37, u[he + 15 | 0] = l[n + 15 | 0] ^ 196, u[he + 16 | 0] = l[n + 16 | 0] ^ 136, u[he + 17 | 0] = l[n + 17 | 0] ^ 244, u[he + 18 | 0] = l[n + 18 | 0] ^ 97, u[he + 19 | 0] = l[n + 19 | 0] ^ 199, u[he + 20 | 0] = l[n + 20 | 0] ^ 11, u[he + 21 | 0] = l[n + 21 | 0] ^ 94, u[he + 22 | 0] = l[n + 22 | 0] ^ 165, u[he + 23 | 0] = l[n + 23 | 0] ^ 220, u[he + 24 | 0] = l[n + 24 | 0] ^ 170, u[he + 25 | 0] = l[n + 25 | 0] ^ 247, u[he + 26 | 0] = l[n + 26 | 0] ^ 175, u[he + 27 | 0] = l[n + 27 | 0] ^ 105, u[he + 28 | 0] = l[n + 28 | 0] ^ 39, u[he + 29 | 0] = l[n + 29 | 0] ^ 10, u[he + 30 | 0] = l[n + 30 | 0] ^ 165, u[he + 31 | 0] = l[n + 31 | 0] ^ 20;
          break e;
        }
        t[he + 136 >> 2] = 64, t[he + 140 >> 2] = 0, t[he + 64 >> 2] = 1252796217, t[he + 68 >> 2] = 614368522, t[he + 56 >> 2] = 989586609, t[he + 60 >> 2] = 1279582103, t[he + 48 >> 2] = -904942663, t[he + 52 >> 2] = 262346349, t[he + 40 >> 2] = 618476057, t[he + 44 >> 2] = 1320844912, Be = he + 40 | 0, Tn(Be, L, 32), Yn(Be, he), u[he | 0] = l[he | 0] ^ l[n | 0], u[he + 1 | 0] = l[he + 1 | 0] ^ l[n + 1 | 0], u[he + 2 | 0] = l[he + 2 | 0] ^ l[n + 2 | 0], u[he + 3 | 0] = l[he + 3 | 0] ^ l[n + 3 | 0], u[he + 4 | 0] = l[he + 4 | 0] ^ l[n + 4 | 0], u[he + 5 | 0] = l[he + 5 | 0] ^ l[n + 5 | 0], u[he + 6 | 0] = l[he + 6 | 0] ^ l[n + 6 | 0], u[he + 7 | 0] = l[he + 7 | 0] ^ l[n + 7 | 0], u[he + 8 | 0] = l[he + 8 | 0] ^ l[n + 8 | 0], u[he + 9 | 0] = l[he + 9 | 0] ^ l[n + 9 | 0], u[he + 10 | 0] = l[he + 10 | 0] ^ l[n + 10 | 0], u[he + 11 | 0] = l[he + 11 | 0] ^ l[n + 11 | 0], u[he + 12 | 0] = l[he + 12 | 0] ^ l[n + 12 | 0], u[he + 13 | 0] = l[he + 13 | 0] ^ l[n + 13 | 0], u[he + 14 | 0] = l[he + 14 | 0] ^ l[n + 14 | 0], u[he + 15 | 0] = l[he + 15 | 0] ^ l[n + 15 | 0], u[he + 16 | 0] = l[he + 16 | 0] ^ l[n + 16 | 0], u[he + 17 | 0] = l[he + 17 | 0] ^ l[n + 17 | 0], u[he + 18 | 0] = l[he + 18 | 0] ^ l[n + 18 | 0], u[he + 19 | 0] = l[he + 19 | 0] ^ l[n + 19 | 0], u[he + 20 | 0] = l[he + 20 | 0] ^ l[n + 20 | 0], u[he + 21 | 0] = l[he + 21 | 0] ^ l[n + 21 | 0], u[he + 22 | 0] = l[he + 22 | 0] ^ l[n + 22 | 0], u[he + 23 | 0] = l[he + 23 | 0] ^ l[n + 23 | 0], u[he + 24 | 0] = l[he + 24 | 0] ^ l[n + 24 | 0], u[he + 25 | 0] = l[he + 25 | 0] ^ l[n + 25 | 0], u[he + 26 | 0] = l[he + 26 | 0] ^ l[n + 26 | 0], u[he + 27 | 0] = l[he + 27 | 0] ^ l[n + 27 | 0], u[he + 28 | 0] = l[he + 28 | 0] ^ l[n + 28 | 0], u[he + 29 | 0] = l[he + 29 | 0] ^ l[n + 29 | 0], u[he + 30 | 0] = l[he + 30 | 0] ^ l[n + 30 | 0], u[he + 31 | 0] = l[he + 31 | 0] ^ l[n + 31 | 0];
      }
      e: {
        if ((T | 0) == 13) {
          t: {
            if (l[E | 0] != 66 || l[E + 1 | 0] != 73 || l[E + 2 | 0] != 80 || l[E + 3 | 0] != 48 || l[E + 4 | 0] != 51 || l[E + 5 | 0] != 52 || l[E + 6 | 0] != 48 || l[E + 7 | 0] != 47 || l[E + 8 | 0] != 110 || l[E + 9 | 0] != 111 || l[E + 10 | 0] != 110 || l[E + 11 | 0] != 99 || l[E + 12 | 0] != 101)
              break t;
            t[he + 136 >> 2] = 64, t[he + 140 >> 2] = 0, t[he + 64 >> 2] = 564305492, t[he + 68 >> 2] = 1756396364, t[he + 56 >> 2] = 1612804480, t[he + 60 >> 2] = 1463125601, t[he + 48 >> 2] = -1618098575, t[he + 52 >> 2] = -2090698061, t[he + 40 >> 2] = 1180785461, t[he + 44 >> 2] = -188760073;
            break e;
          }
          t[he + 136 >> 2] = 0, t[he + 140 >> 2] = 0, t[he + 64 >> 2] = 528734635, t[he + 68 >> 2] = 1541459225, t[he + 56 >> 2] = 1359893119, t[he + 60 >> 2] = -1694144372, t[he + 48 >> 2] = 1013904242, t[he + 52 >> 2] = -1521486534, t[he + 40 >> 2] = 1779033703, t[he + 44 >> 2] = -1150833019, n = he + 40 | 0, Tn(n, E, 13), E = he + 144 | 0, Yn(n, E), t[he + 136 >> 2] = 0, t[he + 140 >> 2] = 0, t[he + 64 >> 2] = 528734635, t[he + 68 >> 2] = 1541459225, t[he + 56 >> 2] = 1359893119, t[he + 60 >> 2] = -1694144372, t[he + 48 >> 2] = 1013904242, t[he + 52 >> 2] = -1521486534, t[he + 40 >> 2] = 1779033703, t[he + 44 >> 2] = -1150833019, Tn(n, E, 32), Tn(n, E, 32);
          break e;
        }
        t[he + 136 >> 2] = 0, t[he + 140 >> 2] = 0, t[he + 64 >> 2] = 528734635, t[he + 68 >> 2] = 1541459225, t[he + 56 >> 2] = 1359893119, t[he + 60 >> 2] = -1694144372, t[he + 48 >> 2] = 1013904242, t[he + 52 >> 2] = -1521486534, t[he + 40 >> 2] = 1779033703, t[he + 44 >> 2] = -1150833019, n = he + 40 | 0, Tn(n, E, T), E = he + 144 | 0, Yn(n, E), t[he + 136 >> 2] = 0, t[he + 140 >> 2] = 0, t[he + 64 >> 2] = 528734635, t[he + 68 >> 2] = 1541459225, t[he + 56 >> 2] = 1359893119, t[he + 60 >> 2] = -1694144372, t[he + 48 >> 2] = 1013904242, t[he + 52 >> 2] = -1521486534, t[he + 40 >> 2] = 1779033703, t[he + 44 >> 2] = -1150833019, Tn(n, E, 32), Tn(n, E, 32);
      }
      n = he + 40 | 0, Tn(n, he, 32), Tn(n, a, 32), Tn(n, d, I), Yn(n, v), v = 1;
    } else
      v = 0;
    return x = he + 176 | 0, v | 0;
  }
  function Pn(v, d, I) {
    var n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0;
    for (L = x - 32 | 0, x = L, cr = Vi(v, 516), v = d + 24 | 0, Me = t[v >> 2], v = t[v + 4 >> 2], a = L + 24 | 0, t[a >> 2] = Me, t[a + 4 >> 2] = v, a = d + 16 | 0, n = t[a + 4 >> 2], E = L + 16 | 0, t[E >> 2] = t[a >> 2], t[E + 4 >> 2] = n, a = d + 8 | 0, n = t[a + 4 >> 2], E = L + 8 | 0, t[E >> 2] = t[a >> 2], t[E + 4 >> 2] = n, a = t[d + 4 >> 2], t[L >> 2] = t[d >> 2], t[L + 4 >> 2] = a, he = 1, a = v, (v | 0) < 0 && (n = t[L >> 2] ^ -1, E = n - 801750718 | 0, T = t[L + 4 >> 2] ^ -1, d = T - ((n >>> 0 < 801750718) + 1076732275 | 0) | 0, t[L >> 2] = E, t[L + 4 >> 2] = d, d = (d | 0) == (T | 0) & n >>> 0 > E >>> 0 | d >>> 0 < T >>> 0, v = L, E = t[v + 8 >> 2] ^ -1, d = d + E | 0, T = t[v + 12 >> 2] ^ -1, n = T, Be = d - 1354194885 | 0, t[v + 8 >> 2] = Be, n = d >>> 0 < E >>> 0 ? n + 1 | 0 : n, he = n - ((d >>> 0 < 1354194885) + 1162945305 | 0) | 0, t[v + 12 >> 2] = he, T = (n | 0) == (T | 0) & d >>> 0 < E >>> 0 | n >>> 0 < T >>> 0, E = (n | 0) == (he | 0) & d >>> 0 > Be >>> 0 | n >>> 0 > he >>> 0, d = T + E | 0, T = t[v + 20 >> 2] ^ -1, n = T + (d >>> 0 < E >>> 0) | 0, E = t[v + 16 >> 2] ^ -1, d = E + d | 0, Be = d - 2 | 0, t[v + 16 >> 2] = Be, n = d >>> 0 < E >>> 0 ? n + 1 | 0 : n, he = n - (d >>> 0 < 2) | 0, t[v + 20 >> 2] = he, v = (n | 0) == (T | 0) & d >>> 0 < E >>> 0 | n >>> 0 < T >>> 0, n = (n | 0) == (he | 0) & d >>> 0 > Be >>> 0 | n >>> 0 > he >>> 0, v = v + n | 0, d = v >>> 0 < n >>> 0, n = v - Me | 0, t[L + 24 >> 2] = n - 2, t[L + 28 >> 2] = (d - ((v >>> 0 < Me >>> 0) + a | 0) | 0) - (n >>> 0 < 2), he = -1), dr = I - 1 | 0, Me = -1, d = 0; ; ) {
      n = d >>> 6 | 0, or = n << 3, a = or + L | 0, v = t[a >> 2], E = t[a + 4 >> 2], T = d & 63, a = T & 31, T >>> 0 >= 32 ? a = E >>> a | 0 : a = ((1 << a) - 1 & E) << 32 - a | v >>> a;
      e: {
        if ((tr | 0) == (a & 1)) {
          v = d + 1 | 0;
          break e;
        }
        v = 129 - d | 0, Be = (v | 0) < (I | 0) ? v : I, v = Be + d | 0, (n | 0) != (v - 1 >>> 6 | 0) && (n = (L + or | 0) + 8 | 0, Me = t[n >> 2], n = 64 - T | 0, T = n & 31, a = ((n & 63) >>> 0 < 32 ? Me << T : 0) | a), n = Be & 31, a = tr + (a & (((Be & 63) >>> 0 < 32 ? -1 << n : 0) ^ -1)) | 0, tr = a >>> dr & 1, t[cr + (d << 2) >> 2] = b(a - (tr << I) | 0, he), Me = d;
      }
      if (d = v, !((d | 0) < 129))
        break;
    }
    return x = L + 32 | 0, Me + 1 | 0;
  }
  function $n(v, d, I) {
    var n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0;
    e: {
      if ((I | 0) > 0) {
        n = d + ((I << 5) - 32 & -64) | 0, d = t[n >> 2], I = t[n + 4 >> 2] & 1048575, t[v >> 2] = d, t[v + 4 >> 2] = I, d = t[n + 8 >> 2], I = t[n + 12 >> 2] << 12 | d >>> 20, t[v + 8 >> 2] = d << 12 & -4096 | t[n + 4 >> 2] >>> 20, t[v + 12 >> 2] = I & 1048575, d = t[n + 16 >> 2], I = t[n + 20 >> 2] << 24 | d >>> 8, t[v + 16 >> 2] = d << 24 & -16777216 | t[n + 12 >> 2] >>> 8, t[v + 20 >> 2] = I & 1048575, a = t[n + 24 >> 2] << 4 & 1048560, I = t[n + 20 >> 2], d = I >>> 28 | 0, t[v + 24 >> 2] = (I & 268435455) << 4 | t[n + 16 >> 2] >>> 28, t[v + 28 >> 2] = d | a, d = t[n + 28 >> 2], I = d >>> 16 | 0, t[v + 32 >> 2] = (d & 65535) << 16 | t[n + 24 >> 2] >>> 16, t[v + 36 >> 2] = I, d = t[n + 36 >> 2] & 1048575, t[v + 40 >> 2] = t[n + 32 >> 2], t[v + 44 >> 2] = d, a = n + 40 | 0, d = t[a >> 2], I = t[a + 4 >> 2] << 12 | d >>> 20, E = v + 48 | 0, t[E >> 2] = d << 12 & -4096 | t[n + 36 >> 2] >>> 20, t[E + 4 >> 2] = I & 1048575, E = n + 48 | 0, d = t[E >> 2], I = t[E + 4 >> 2] << 24 | d >>> 8, T = v + 56 | 0, t[T >> 2] = d << 24 & -16777216 | t[a + 4 >> 2] >>> 8, t[T + 4 >> 2] = I & 1048575, n = n + 56 | 0, d = t[n >> 2], T = d << 4 & 1048560, I = t[E + 4 >> 2], d = I >>> 28 | 0, a = v - -64 | 0, t[a >> 2] = (I & 268435455) << 4 | t[E >> 2] >>> 28, t[a + 4 >> 2] = d | T, d = v + 72 | 0, a = t[n + 4 >> 2], t[d >> 2] = (a & 65535) << 16 | t[n >> 2] >>> 16, t[d + 4 >> 2] = a >>> 16;
        break e;
      }
      n = d + ((I ^ -1) / 2 << 6) | 0, d = t[n >> 2], I = t[n + 4 >> 2] & 1048575, t[v >> 2] = d, t[v + 4 >> 2] = I, d = t[n + 8 >> 2], I = t[n + 12 >> 2] << 12 | d >>> 20, t[v + 8 >> 2] = d << 12 & -4096 | t[n + 4 >> 2] >>> 20, t[v + 12 >> 2] = I & 1048575, d = t[n + 16 >> 2], I = t[n + 20 >> 2] << 24 | d >>> 8, t[v + 16 >> 2] = d << 24 & -16777216 | t[n + 12 >> 2] >>> 8, t[v + 20 >> 2] = I & 1048575, a = t[n + 24 >> 2] << 4 & 1048560, I = t[n + 20 >> 2], d = I >>> 28 | 0, t[v + 24 >> 2] = (I & 268435455) << 4 | t[n + 16 >> 2] >>> 28, t[v + 28 >> 2] = d | a, d = t[n + 28 >> 2], I = d >>> 16 | 0, t[v + 32 >> 2] = (d & 65535) << 16 | t[n + 24 >> 2] >>> 16, t[v + 36 >> 2] = I, T = t[n + 36 >> 2] & 1048575, Be = t[n + 32 >> 2], t[v + 40 >> 2] = Be, t[v + 44 >> 2] = T, a = n + 40 | 0, d = t[a >> 2], I = t[a + 4 >> 2] << 12 | d >>> 20, Me = v + 48 | 0, E = Me, tr = d << 12 & -4096 | t[n + 36 >> 2] >>> 20, t[E >> 2] = tr, cr = I & 1048575, t[E + 4 >> 2] = cr, E = n + 48 | 0, d = t[E >> 2], I = t[E + 4 >> 2] << 24 | d >>> 8, L = v + 56 | 0, a = d << 24 & -16777216 | t[a + 4 >> 2] >>> 8, t[L >> 2] = a, dr = I & 1048575, t[L + 4 >> 2] = dr, n = n + 56 | 0, d = t[n >> 2], or = d << 4 & 1048560, I = t[E + 4 >> 2], d = I >>> 28 | 0, he = v - -64 | 0, I = (I & 268435455) << 4 | t[E >> 2] >>> 28, t[he >> 2] = I, E = d | or, t[he + 4 >> 2] = E, or = t[n >> 2], d = t[n + 4 >> 2], t[he >> 2] = -4 - I, t[he + 4 >> 2] = 4194303 - ((I >>> 0 > 4294967292) + E | 0), t[L >> 2] = -4 - a, t[L + 4 >> 2] = 4194303 - ((a >>> 0 > 4294967292) + dr | 0), t[Me >> 2] = -4 - tr, t[Me + 4 >> 2] = 4194303 - ((tr >>> 0 > 4294967292) + cr | 0), t[v + 40 >> 2] = -3908 - Be, t[v + 44 >> 2] = 4194299 - ((Be >>> 0 > 4294963388) + T | 0), n = d >>> 16 | 0, I = v + 72 | 0, d = (d & 65535) << 16 | or >>> 16, t[I >> 2] = -4 - d, t[I + 4 >> 2] = 262143 - ((d >>> 0 > 4294967292) + n | 0);
    }
    t[v + 80 >> 2] = 0;
  }
  function ui(v, d, I, n) {
    var a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0, Xn = 0, Zn = 0, ni = 0, ai = 0, fi = 0, Ai = 0, yi = 0, Ii = 0, wi = 0, Bi = 0, Ti = 0, Oi = 0, Hi = 0, Xi = 0, Zi = 0, ts = 0, us = 0, hs = 0, ws = 0;
    T = x - 1120 | 0, x = T;
    e: {
      if (t[d + 120 >> 2]) {
        t[v + 120 >> 2] = t[I + 80 >> 2], a = T + 1080 | 0, Ui(a, n), d = T + 1040 | 0, Xr(d, a, n), Xr(v, I, a), Xr(v + 40 | 0, I + 40 | 0, d), d = v + 88 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, t[v + 80 >> 2] = 1, t[v + 84 >> 2] = 0, d = v + 96 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = v + 104 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, v = v + 112 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0;
        break e;
      }
      if (t[I + 80 >> 2]) {
        $i(v, d, 128);
        break e;
      }
      us = T + 1080 | 0, hs = d + 80 | 0, Xr(us, hs, n), n = t[T + 1084 >> 2], gr = n, or = t[T + 1080 >> 2], a = or, n = n << 1 | a >>> 31, cr = T + 408 | 0, gn = t[T + 1104 >> 2], Wr = t[T + 1108 >> 2], Bn = a << 1, jn = n, Ur(cr, gn, Wr, 0, 0, Bn, n, 0, 0), n = t[T + 1092 >> 2], Zi = n, Xi = t[T + 1088 >> 2], E = Xi, n = n << 1 | E >>> 31, Be = T + 616 | 0, Mr = t[T + 1096 >> 2], xr = t[T + 1100 >> 2], E = E << 1, he = n, Ur(Be, Mr, xr, 0, 0, E, n, 0, 0), dr = T + 568 | 0, a = t[T + 1112 >> 2], n = t[T + 1116 >> 2], Ur(dr, a, n, 0, 0, a, n, 0, 0), Me = T + 552 | 0, Ur(Me, t[T + 568 >> 2], t[T + 572 >> 2], 0, 0, 15632, 16, 0, 0), n = n << 1 | a >>> 31, Bi = T + 520 | 0, Xn = a << 1, $r = n, Ur(Bi, Xn, n, 0, 0, or, gr, 0, 0), fi = T + 424 | 0, Ur(fi, gn, Wr, 0, 0, E, he, 0, 0), ni = T + 600 | 0, Ur(ni, Mr, xr, 0, 0, Mr, xr, 0, 0), tr = T + 536 | 0, n = dr + 8 | 0, Ur(tr, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Oi = T + 664 | 0, Ur(Oi, or, gr, 0, 0, or, gr, 0, 0), Ti = T + 504 | 0, Ur(Ti, Xn, $r, 0, 0, Xi, Zi, 0, 0), Ii = T + 440 | 0, Ur(Ii, gn, Wr, 0, 0, Mr << 1, xr << 1 | Mr >>> 31, 0, 0), gr = t[T + 412 >> 2], n = gr + t[T + 620 >> 2] | 0, L = t[T + 408 >> 2], E = t[T + 616 >> 2], a = L + E | 0, he = t[T + 552 >> 2], Un = a + he | 0, E = a >>> 0 < E >>> 0 ? n + 1 | 0 : n, n = E + t[T + 556 >> 2] | 0, he = he >>> 0 > Un >>> 0 ? n + 1 | 0 : n, or = (E | 0) == (he | 0) & a >>> 0 > Un >>> 0 | E >>> 0 > he >>> 0, n = Me + 8 | 0, dr = t[n >> 2], Me = t[n + 4 >> 2], L = (E | 0) == (gr | 0) & a >>> 0 < L >>> 0 | E >>> 0 < gr >>> 0, E = Be + 8 | 0, a = t[E >> 2], n = cr + 8 | 0, Be = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, a = L + Be | 0, n = (a >>> 0 < Be >>> 0 ? n + 1 | 0 : n) + Me | 0, E = a, a = a + dr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + or | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ai = he, dr = a << 12 | he >>> 20, E = n, L = n << 12 | a >>> 20, Zn = t[T + 424 >> 2], a = t[T + 600 >> 2], or = Zn + a | 0, wi = t[T + 428 >> 2], n = wi + t[T + 604 >> 2] | 0, n = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, a = t[T + 520 >> 2], Me = a + or | 0, cr = n, n = n + t[T + 524 >> 2] | 0, n = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, a = t[T + 536 >> 2], he = a + Me | 0, Be = n, n = n + t[T + 540 >> 2] | 0, a = a >>> 0 > he >>> 0 ? n + 1 | 0 : n, n = a + L | 0, yi = T + 344 | 0, ai = yi, dr = he + dr | 0, L = dr >>> 0 < he >>> 0 ? n + 1 | 0 : n, Gn = (a | 0) == (L | 0) & he >>> 0 > dr >>> 0 | a >>> 0 > L >>> 0, kn = (a | 0) == (Be | 0) & he >>> 0 < Me >>> 0 | a >>> 0 < Be >>> 0, n = tr + 8 | 0, xn = t[n >> 2], Ir = t[n + 4 >> 2], gr = (Be | 0) == (cr | 0) & or >>> 0 > Me >>> 0 | Be >>> 0 < cr >>> 0, n = Bi + 8 | 0, tr = t[n >> 2], Be = t[n + 4 >> 2], Me = (cr | 0) == (wi | 0) & or >>> 0 < Zn >>> 0 | cr >>> 0 < wi >>> 0, he = ni + 8 | 0, a = t[he >> 2], n = fi + 8 | 0, or = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[he + 4 >> 2] | 0, n = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, a = or + Me | 0, n = (a >>> 0 < or >>> 0 ? n + 1 | 0 : n) + Be | 0, he = a, a = a + tr | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, he = a, a = a + gr | 0, n = (he >>> 0 > a >>> 0 ? n + 1 | 0 : n) + Ir | 0, he = a, a = a + xn | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, he = a + kn | 0, n = he >>> 0 < a >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + he | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Gn | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = L, Me = a << 12 | E >>> 20, he = n, L = n << 12 | a >>> 20, gr = t[T + 504 >> 2], a = t[T + 440 >> 2], cr = gr + a | 0, kn = t[T + 508 >> 2], n = kn + t[T + 444 >> 2] | 0, a = a >>> 0 > cr >>> 0 ? n + 1 | 0 : n, n = a + L | 0, Me = Me + cr | 0, n = Me >>> 0 < cr >>> 0 ? n + 1 | 0 : n, Be = Me << 4 & -16, L = n, or = (n << 4 | Me >>> 28) & 16777215, Ir = E, Ur(ai, Be | E >>> 16 & 15, or, 0, 0, 977, 1, 0, 0), E = d + 8 | 0, n = t[E + 4 >> 2], or = T + 1e3 | 0, ni = or + 8 | 0, t[ni >> 2] = t[E >> 2], t[ni + 4 >> 2] = n, E = d + 16 | 0, n = t[E + 4 >> 2], Zn = or + 16 | 0, t[Zn >> 2] = t[E >> 2], t[Zn + 4 >> 2] = n, E = d + 24 | 0, n = t[E + 4 >> 2], ai = or + 24 | 0, t[ai >> 2] = t[E >> 2], t[ai + 4 >> 2] = n, E = d + 32 | 0, n = t[E + 4 >> 2], Gn = or + 32 | 0, t[Gn >> 2] = t[E >> 2], t[Gn + 4 >> 2] = n, n = t[d + 4 >> 2], t[T + 1e3 >> 2] = t[d >> 2], t[T + 1004 >> 2] = n, ts = t[T + 348 >> 2], n = ts + t[T + 668 >> 2] | 0, fi = t[T + 344 >> 2], E = t[T + 664 >> 2], Be = fi + E | 0, t[T + 1040 >> 2] = Be, E = E >>> 0 > Be >>> 0 ? n + 1 | 0 : n, t[T + 1044 >> 2] = E & 1048575, ws = T + 648 | 0, Ur(ws, Xi, Zi, 0, 0, Bn, jn, 0, 0), Hi = T + 488 | 0, Ur(Hi, Xn, $r, 0, 0, Mr, xr, 0, 0), wi = T + 456 | 0, Ur(wi, gn, Wr, 0, 0, gn, Wr, 0, 0), Bi = T + 392 | 0, xn = Bi, tr = (a | 0) == (L | 0) & Me >>> 0 < cr >>> 0 | a >>> 0 > L >>> 0, cr = (a | 0) == (kn | 0) & cr >>> 0 < gr >>> 0 | a >>> 0 < kn >>> 0, Me = Ii + 8 | 0, a = t[Me >> 2], n = Ti + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Me + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, Me = cr + gr | 0, n = Me >>> 0 < gr >>> 0 ? n + 1 | 0 : n, he = he >>> 20 | 0, a = he + Me | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, he = a, a = a + tr | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, cr = a << 12 | L >>> 20, Me = n, L = n << 12 | a >>> 20, or = t[T + 492 >> 2], n = or + t[T + 460 >> 2] | 0, Ti = t[T + 488 >> 2], he = t[T + 456 >> 2], a = Ti + he | 0, kn = a, gr = a + cr | 0, he = a >>> 0 < he >>> 0 ? n + 1 | 0 : n, n = he + L | 0, cr = gr >>> 0 < a >>> 0 ? n + 1 | 0 : n, Ur(xn, gr, cr & 1048575, 0, 0, 15632, 16, 0, 0), Be = (E | 0) == (ts | 0) & Be >>> 0 < fi >>> 0 | E >>> 0 < ts >>> 0, L = Oi + 8 | 0, a = t[L >> 2], n = yi + 8 | 0, tr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[L + 4 >> 2] | 0, n = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, a = Be + tr | 0, n = a >>> 0 < tr >>> 0 ? n + 1 | 0 : n, tr = a << 12 | E >>> 20, L = n, Be = n << 12 | a >>> 20, Oi = t[T + 396 >> 2], n = Oi + t[T + 652 >> 2] | 0, Ii = t[T + 392 >> 2], E = t[T + 648 >> 2], a = Ii + E | 0, xn = a, tr = a + tr | 0, E = a >>> 0 < E >>> 0 ? n + 1 | 0 : n, n = E + Be | 0, t[T + 1048 >> 2] = tr, Be = tr >>> 0 < a >>> 0 ? n + 1 | 0 : n, t[T + 1052 >> 2] = Be & 1048575, yi = T + 584 | 0, Ur(yi, Mr, xr, 0, 0, Bn, jn, 0, 0), fi = T + 632 | 0, Ur(fi, Xi, Zi, 0, 0, Xi, Zi, 0, 0), jn = T + 472 | 0, Ur(jn, Xn, $r, 0, 0, gn, Wr, 0, 0), Bn = T + 376 | 0, Wr = Bn, xr = (he | 0) == (cr | 0) & gr >>> 0 < kn >>> 0 | he >>> 0 > cr >>> 0, gr = (he | 0) == (or | 0) & kn >>> 0 < Ti >>> 0 | he >>> 0 < or >>> 0, he = wi + 8 | 0, a = t[he >> 2], n = Hi + 8 | 0, gn = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[he + 4 >> 2] | 0, n = a >>> 0 > gn >>> 0 ? n + 1 | 0 : n, he = gr + gn | 0, n = he >>> 0 < gn >>> 0 ? n + 1 | 0 : n, Me = Me >>> 20 | 0, a = he + Me | 0, n = Me >>> 0 > a >>> 0 ? n + 1 | 0 : n, he = a, a = a + xr | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, $r = a << 12 | cr >>> 20, Me = t[T + 472 >> 2], cr = $r + Me | 0, he = n, kn = n << 12 | a >>> 20, n = kn + t[T + 476 >> 2] | 0, gr = Me >>> 0 > cr >>> 0 ? n + 1 | 0 : n, Ur(Wr, cr, gr, 0, 0, 15632, 16, 0, 0), tr = (E | 0) == (Be | 0) & tr >>> 0 < xn >>> 0 | E >>> 0 > Be >>> 0, or = (E | 0) == (Oi | 0) & xn >>> 0 < Ii >>> 0 | E >>> 0 < Oi >>> 0, E = ws + 8 | 0, a = t[E >> 2], n = Bi + 8 | 0, xr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[E + 4 >> 2] | 0, n = a >>> 0 > xr >>> 0 ? n + 1 | 0 : n, E = or + xr | 0, n = E >>> 0 < xr >>> 0 ? n + 1 | 0 : n, L = L >>> 20 | 0, a = E + L | 0, n = L >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + tr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, or = a << 12 | Be >>> 20, E = n, Wr = n << 12 | a >>> 20, Mr = t[T + 584 >> 2], a = t[T + 632 >> 2], Be = Mr + a | 0, xn = t[T + 588 >> 2], n = xn + t[T + 636 >> 2] | 0, xr = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, n = xr + t[T + 380 >> 2] | 0, a = t[T + 376 >> 2], L = a + Be | 0, tr = L, or = L + or | 0, a = a >>> 0 > L >>> 0 ? n + 1 | 0 : n, n = a + Wr | 0, t[T + 1056 >> 2] = or, L = or >>> 0 < L >>> 0 ? n + 1 | 0 : n, t[T + 1060 >> 2] = L & 1048575, gn = T + 360 | 0, Wr = (gr | 0) == (kn | 0) & cr >>> 0 < $r >>> 0 | gr >>> 0 < kn >>> 0, n = jn + 8 | 0, gr = t[n >> 2], n = t[n + 4 >> 2], he = he >>> 20 | 0, Me = he, he = he + gr | 0, n = Me >>> 0 > he >>> 0 ? n + 1 | 0 : n, Me = he, he = he + Wr | 0, n = Me >>> 0 > he >>> 0 ? n + 1 | 0 : n, Ur(gn, he, n, 0, 0, 64028672, 65536, 0, 0), Wr = (a | 0) == (L | 0) & or >>> 0 < tr >>> 0 | a >>> 0 > L >>> 0, gr = (a | 0) == (xr | 0) & Be >>> 0 > tr >>> 0 | a >>> 0 < xr >>> 0, n = Bn + 8 | 0, tr = t[n >> 2], cr = t[n + 4 >> 2], or = (xr | 0) == (xn | 0) & Be >>> 0 < Mr >>> 0 | xr >>> 0 < xn >>> 0, Me = fi + 8 | 0, a = t[Me >> 2], n = yi + 8 | 0, Be = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Me + 4 >> 2] | 0, n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, a = Be + or | 0, n = (a >>> 0 < Be >>> 0 ? n + 1 | 0 : n) + cr | 0, he = a, a = a + tr | 0, n = he >>> 0 > a >>> 0 ? n + 1 | 0 : n, Me = a + gr | 0, n = Me >>> 0 < a >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, a = E + Me | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, E = a, a = a + Wr | 0, n = E >>> 0 > a >>> 0 ? n + 1 | 0 : n, Me = a << 12 | L >>> 20, E = n, Be = n << 12 | a >>> 20, tr = t[T + 360 >> 2], L = Un & -2, a = tr + L | 0, gr = t[T + 364 >> 2], n = gr + (Ai & 1048575) | 0, or = a >>> 0 < L >>> 0 ? n + 1 | 0 : n, n = or + Be | 0, he = Me, Me = a, L = he + a | 0, t[T + 1064 >> 2] = L, a = a >>> 0 > L >>> 0 ? n + 1 | 0 : n, t[T + 1068 >> 2] = a & 1048575, cr = Ir & 65535, Be = (a | 0) == (or | 0) & L >>> 0 < Me >>> 0 | a >>> 0 < or >>> 0, L = (or | 0) == (gr | 0) & Me >>> 0 < tr >>> 0 | or >>> 0 < gr >>> 0, n = gn + 8 | 0, Me = L + t[n >> 2] | 0, n = t[n + 4 >> 2], n = L >>> 0 > Me >>> 0 ? n + 1 | 0 : n, E = E >>> 20 | 0, he = E, E = E + Me | 0, n = he >>> 0 > E >>> 0 ? n + 1 | 0 : n, he = E, E = E + Be | 0, n = he >>> 0 > E >>> 0 ? n + 1 | 0 : n, a = E << 12 | a >>> 20, L = a + dr | 0, n = cr + (n << 12 | E >>> 20) | 0, t[T + 1072 >> 2] = L, t[T + 1076 >> 2] = a >>> 0 > L >>> 0 ? n + 1 | 0 : n, dr = ni, Be = t[dr >> 2], or = t[dr + 4 >> 2], Me = t[T + 1004 >> 2], L = t[Gn >> 2], a = t[Gn + 4 >> 2], tr = a, n = t[T + 1e3 >> 2], E = pn(a >>> 16 | 0, 0, 977, 1), a = n + E | 0, n = Me + Ee | 0, Me = a >>> 0 < E >>> 0 ? n + 1 | 0 : n, n = or, E = Me >>> 20 | 0, he = E, E = E + Be | 0, n = he >>> 0 > E >>> 0 ? n + 1 | 0 : n, gr = E, t[dr >> 2] = E, ni = n & 1048575, t[dr + 4 >> 2] = ni, dr = Zn, Be = t[dr >> 2], E = n, n = t[dr + 4 >> 2], E = E >>> 20 | 0, he = E, E = E + Be | 0, n = he >>> 0 > E >>> 0 ? n + 1 | 0 : n, cr = E, t[dr >> 2] = E, Zn = n & 1048575, t[dr + 4 >> 2] = Zn, dr = ai, Be = t[dr >> 2], E = n, n = t[dr + 4 >> 2], E = E >>> 20 | 0, he = E, E = E + Be | 0, n = he >>> 0 > E >>> 0 ? n + 1 | 0 : n, Be = E, t[dr >> 2] = E, ai = n & 1048575, t[dr + 4 >> 2] = ai, dr = Gn, E = n, n = tr & 65535, E = E >>> 20 | 0, he = E, E = E + L | 0, n = he >>> 0 > E >>> 0 ? n + 1 | 0 : n, gn = E, t[dr >> 2] = E, Ai = n, t[dr + 4 >> 2] = n, dr = a, t[T + 1e3 >> 2] = a, Gn = Me & 1048575, t[T + 1004 >> 2] = Gn, Xn = T + 1040 | 0, Xr(T + 960 | 0, I, Xn), xr = T + 920 | 0, Un = xr + 8 | 0, n = d + 48 | 0, tr = t[n >> 2], or = t[n + 4 >> 2], Me = t[d + 44 >> 2], n = d + 72 | 0, L = t[n >> 2], a = t[n + 4 >> 2], Ir = a, n = t[d + 40 >> 2], E = pn(a >>> 16 | 0, 0, 977, 1), a = n + E | 0, n = Me + Ee | 0, Me = a >>> 0 < E >>> 0 ? n + 1 | 0 : n, n = or, E = Me >>> 20 | 0, he = E, E = E + tr | 0, n = he >>> 0 > E >>> 0 ? n + 1 | 0 : n, $r = E, t[Un >> 2] = E, kn = n & 1048575, t[Un + 4 >> 2] = kn, Un = xr + 16 | 0, E = d + 56 | 0, tr = t[E >> 2], or = t[E + 4 >> 2], E = n, n = or, E = E >>> 20 | 0, he = E, E = E + tr | 0, n = he >>> 0 > E >>> 0 ? n + 1 | 0 : n, Mr = E, t[Un >> 2] = E, xn = n & 1048575, t[Un + 4 >> 2] = xn, Un = xr + 24 | 0, E = d - -64 | 0, tr = t[E >> 2], or = t[E + 4 >> 2], E = n, n = or, E = E >>> 20 | 0, he = E, E = E + tr | 0, n = he >>> 0 > E >>> 0 ? n + 1 | 0 : n, Wr = E, t[Un >> 2] = E, jn = n & 1048575, t[Un + 4 >> 2] = jn, tr = xr + 32 | 0, E = n, n = Ir & 65535, E = E >>> 20 | 0, L = E + L | 0, n = E >>> 0 > L >>> 0 ? n + 1 | 0 : n, xr = L, t[tr >> 2] = L, E = n, t[tr + 4 >> 2] = n, Un = a, t[T + 920 >> 2] = a, Bn = Me & 1048575, t[T + 924 >> 2] = Bn, n = T + 880 | 0, Xr(n, I + 40 | 0, Xn), Xr(n, n, us), a = T, I = t[a + 960 >> 2], or = (I - dr | 0) - 3908 | 0, n = (t[a + 964 >> 2] - ((I >>> 0 < dr >>> 0) + Gn | 0) | 0) + 4194299 | 0, t[a + 840 >> 2] = or, Me = or >>> 0 < 4294963388 ? n + 1 | 0 : n, t[a + 844 >> 2] = Me, I = t[a + 968 >> 2], tr = (I - gr | 0) - 4 | 0, n = (t[a + 972 >> 2] - ((I >>> 0 < gr >>> 0) + ni | 0) | 0) + 4194303 | 0, t[a + 848 >> 2] = tr, dr = tr >>> 0 < 4294967292 ? n + 1 | 0 : n, t[a + 852 >> 2] = dr, I = t[a + 976 >> 2], Ir = (I - cr | 0) - 4 | 0, n = (t[a + 980 >> 2] - ((I >>> 0 < cr >>> 0) + Zn | 0) | 0) + 4194303 | 0, t[a + 856 >> 2] = Ir, cr = Ir >>> 0 < 4294967292 ? n + 1 | 0 : n, t[a + 860 >> 2] = cr, I = t[a + 984 >> 2], gr = (I - Be | 0) - 4 | 0, n = (t[a + 988 >> 2] - ((I >>> 0 < Be >>> 0) + ai | 0) | 0) + 4194303 | 0, t[a + 864 >> 2] = gr, Be = gr >>> 0 < 4294967292 ? n + 1 | 0 : n, t[a + 868 >> 2] = Be, n = t[a + 992 >> 2], I = (n - gn | 0) - 4 | 0, n = (t[a + 996 >> 2] - ((n >>> 0 < gn >>> 0) + Ai | 0) | 0) + 262143 | 0, t[a + 872 >> 2] = I, L = I >>> 0 < 4294967292 ? n + 1 | 0 : n, t[a + 876 >> 2] = L, n = t[a + 912 >> 2], Ai = (xr - n | 0) - 4 | 0, n = (E - (t[a + 916 >> 2] + (n >>> 0 > xr >>> 0) | 0) | 0) + 262143 | 0, E = Ai, t[a + 832 >> 2] = E, he = E >>> 0 < 4294967292 ? n + 1 | 0 : n, t[a + 836 >> 2] = he, n = t[a + 904 >> 2], Zn = (Wr - n | 0) - 4 | 0, n = (jn - (t[a + 908 >> 2] + (n >>> 0 > Wr >>> 0) | 0) | 0) + 4194303 | 0, t[a + 824 >> 2] = Zn, gn = Zn >>> 0 < 4294967292 ? n + 1 | 0 : n, t[a + 828 >> 2] = gn, n = t[a + 896 >> 2], ai = (Mr - n | 0) - 4 | 0, n = (xn - (t[a + 900 >> 2] + (n >>> 0 > Mr >>> 0) | 0) | 0) + 4194303 | 0, t[a + 816 >> 2] = ai, Wr = ai >>> 0 < 4294967292 ? n + 1 | 0 : n, t[a + 820 >> 2] = Wr, n = t[a + 888 >> 2], Gn = ($r - n | 0) - 4 | 0, n = (kn - (t[a + 892 >> 2] + (n >>> 0 > $r >>> 0) | 0) | 0) + 4194303 | 0, t[a + 808 >> 2] = Gn, xr = Gn >>> 0 < 4294967292 ? n + 1 | 0 : n, t[a + 812 >> 2] = xr, n = t[a + 880 >> 2], Xn = (Un - n | 0) - 3908 | 0, n = (Bn - (t[a + 884 >> 2] + (n >>> 0 > Un >>> 0) | 0) | 0) + 4194299 | 0, t[a + 800 >> 2] = Xn, Un = Xn >>> 0 < 4294963388 ? n + 1 | 0 : n, t[a + 804 >> 2] = Un, a = pn(L >>> 16 | 0, 0, 977, 1) + or | 0, n = Ee + Me | 0, n = a >>> 0 < or >>> 0 ? n + 1 | 0 : n, Mr = n & 1048575, Ii = Mr;
      t: {
        if (Ai = a, yi = a ^ 976, fi = Mr ^ 1, ((yi | 0) != -1 | (fi | 0) != 1048575) & (a | Mr) != 0 || (ni = L & 65535, a = n, n = dr, a = (a >>> 20 | 0) + tr | 0, n = a >>> 0 < tr >>> 0 ? n + 1 | 0 : n, kn = a, xn = n, n = cr, a = (xn >>> 20 | 0) + Ir | 0, n = a >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, jn = a, Bn = n, n = Be, a = (Bn >>> 20 | 0) + gr | 0, n = a >>> 0 < gr >>> 0 ? n + 1 | 0 : n, $r = a, Mr = n, n = ni, a = Mr >>> 20 | 0, ni = a, a = I + a | 0, n = ni >>> 0 > a >>> 0 ? n + 1 | 0 : n, a | ($r | (jn | (kn | Ai))) | (n | (Mr & 1048575 | (Bn & 1048575 | (xn & 1048575 | Ii)))) && ((kn & yi & jn & $r & a) != -1 ? n = 1 : n = (xn & fi & Bn & Mr & (n ^ 983040)) != 1048575, n)))
          break t;
        I = pn(he >>> 16 | 0, 0, 977, 1) + Xn | 0, n = Ee + Un | 0, n = I >>> 0 < Xn >>> 0 ? n + 1 | 0 : n, L = n & 1048575, Ir = L;
        r: {
          if (a = I, gr = a ^ 976, tr = L ^ 1, ((gr | 0) != -1 | (tr | 0) != 1048575) & (a | L) != 0 || (cr = he & 65535, I = n, n = xr, I = (I >>> 20 | 0) + Gn | 0, n = I >>> 0 < Gn >>> 0 ? n + 1 | 0 : n, Be = I, or = n, n = Wr, I = (or >>> 20 | 0) + ai | 0, n = I >>> 0 < ai >>> 0 ? n + 1 | 0 : n, dr = I, Me = n, n = gn, I = (Me >>> 20 | 0) + Zn | 0, n = I >>> 0 < Zn >>> 0 ? n + 1 | 0 : n, L = I, he = n, n = cr, I = he >>> 20 | 0, cr = I, I = I + E | 0, n = cr >>> 0 > I >>> 0 ? n + 1 | 0 : n, I | (L | (dr | (a | Be))) | (n | (he & 1048575 | (Me & 1048575 | (or & 1048575 | Ir)))) && ((Be & gr & dr & L & I) != -1 ? I = 1 : I = (or & tr & Me & he & (n ^ 983040)) != 1048575, I)))
            break r;
          if (t[d + 120 >> 2]) {
            t[v + 120 >> 2] = 1, Vi(v, 120);
            break e;
          }
          Mi(v, d);
          break e;
        }
        t[v + 120 >> 2] = 1, Vi(v, 120);
        break e;
      }
      t[v + 120 >> 2] = 0, wi = T + 840 | 0, Xr(v + 80 | 0, hs, wi), jn = T + 312 | 0, he = gr, E = Be, Wr = or << 1, Be = Me, gn = Be << 1 | or >>> 31, Ur(jn, he, E, 0, 0, Wr, gn, 0, 0), $r = T + 232 | 0, a = Ir, d = cr, Me = tr << 1, gr = dr, xr = tr, dr = dr << 1 | tr >>> 31, Ur($r, a, d, 0, 0, Me, dr, 0, 0), tr = T + 168 | 0, Ur(tr, I, L, 0, 0, I, L, 0, 0), Ir = T + 152 | 0, Ur(Ir, t[T + 168 >> 2], t[T + 172 >> 2], 0, 0, 15632, 16, 0, 0), n = L << 1 | I >>> 31, Bi = T + 120 | 0, Mr = I << 1, Un = n, Ur(Bi, Mr, n, 0, 0, or, Be, 0, 0), Ti = T + 280 | 0, Ur(Ti, he, E, 0, 0, Me, dr, 0, 0), Ii = T + 216 | 0, Ur(Ii, a, d, 0, 0, a, d, 0, 0), Bn = T + 136 | 0, I = tr + 8 | 0, Ur(Bn, t[I >> 2], t[I + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), yi = T + 328 | 0, Ur(yi, or, Be, 0, 0, or, Be, 0, 0), fi = T + 104 | 0, Ur(fi, Mr, n, 0, 0, xr, gr, 0, 0), Be = d, Ai = a, n = d << 1 | a >>> 31, ni = T + 184 | 0, tr = he, cr = E, Ur(ni, he, E, 0, 0, a << 1, n, 0, 0), dr = t[T + 316 >> 2], n = dr + t[T + 236 >> 2] | 0, E = t[T + 312 >> 2], I = t[T + 232 >> 2], d = E + I | 0, a = t[T + 152 >> 2], or = d + a | 0, I = d >>> 0 < I >>> 0 ? n + 1 | 0 : n, n = I + t[T + 156 >> 2] | 0, a = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, Me = (I | 0) == (a | 0) & d >>> 0 > or >>> 0 | I >>> 0 > a >>> 0, n = Ir + 8 | 0, L = t[n >> 2], he = t[n + 4 >> 2], E = (I | 0) == (dr | 0) & d >>> 0 < E >>> 0 | I >>> 0 < dr >>> 0, n = $r + 8 | 0, I = t[n >> 2], d = jn + 8 | 0, dr = I + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = I >>> 0 > dr >>> 0 ? n + 1 | 0 : n, d = E + dr | 0, n = (d >>> 0 < dr >>> 0 ? n + 1 | 0 : n) + he | 0, I = d, d = d + L | 0, n = I >>> 0 > d >>> 0 ? n + 1 | 0 : n, I = d, d = d + Me | 0, n = I >>> 0 > d >>> 0 ? n + 1 | 0 : n, Me = a, he = d << 12 | a >>> 20, I = n, E = n << 12 | d >>> 20, Zn = t[T + 280 >> 2], d = t[T + 216 >> 2], dr = Zn + d | 0, Hi = t[T + 284 >> 2], n = Hi + t[T + 220 >> 2] | 0, n = d >>> 0 > dr >>> 0 ? n + 1 | 0 : n, d = t[T + 120 >> 2], L = d + dr | 0, $r = n, n = n + t[T + 124 >> 2] | 0, n = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, d = t[T + 136 >> 2], a = d + L | 0, Ir = n, n = n + t[T + 140 >> 2] | 0, d = d >>> 0 > a >>> 0 ? n + 1 | 0 : n, n = d + E | 0, ai = T + 88 | 0, E = a + he | 0, he = E >>> 0 < a >>> 0 ? n + 1 | 0 : n, Gn = (d | 0) == (he | 0) & a >>> 0 > E >>> 0 | d >>> 0 > he >>> 0, Xn = (d | 0) == (Ir | 0) & a >>> 0 < L >>> 0 | d >>> 0 < Ir >>> 0, d = Bn + 8 | 0, kn = t[d >> 2], xn = t[d + 4 >> 2], jn = (Ir | 0) == ($r | 0) & L >>> 0 < dr >>> 0 | Ir >>> 0 < $r >>> 0, d = Bi + 8 | 0, Bn = t[d >> 2], Ir = t[d + 4 >> 2], L = ($r | 0) == (Hi | 0) & dr >>> 0 < Zn >>> 0 | $r >>> 0 < Hi >>> 0, n = Ii + 8 | 0, a = t[n >> 2], d = Ti + 8 | 0, dr = a + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > dr >>> 0 ? n + 1 | 0 : n, d = L + dr | 0, n = (d >>> 0 < dr >>> 0 ? n + 1 | 0 : n) + Ir | 0, a = d, d = d + Bn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d, d = d + jn | 0, n = (a >>> 0 > d >>> 0 ? n + 1 | 0 : n) + xn | 0, a = d, d = d + kn | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, a = d + Xn | 0, n = a >>> 0 < d >>> 0 ? n + 1 | 0 : n, I = I >>> 20 | 0, d = I + a | 0, n = I >>> 0 > d >>> 0 ? n + 1 | 0 : n, I = d, d = d + Gn | 0, n = I >>> 0 > d >>> 0 ? n + 1 | 0 : n, I = he, L = d << 12 | I >>> 20, a = n, he = n << 12 | d >>> 20, Bn = t[T + 104 >> 2], d = t[T + 184 >> 2], Ir = Bn + d | 0, Gn = t[T + 108 >> 2], n = Gn + t[T + 188 >> 2] | 0, d = d >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, n = d + he | 0, L = L + Ir | 0, n = L >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, $r = L << 4 & -16, dr = I, he = n, Ur(ai, $r | I >>> 16 & 15, (n << 4 | L >>> 28) & 16777215, 0, 0, 977, 1, 0, 0), Xn = T + 264 | 0, Ur(Xn, xr, gr, 0, 0, Wr, gn, 0, 0), kn = T + 72 | 0, Ur(kn, Mr, Un, 0, 0, Ai, Be, 0, 0), xn = T + 296 | 0, Ur(xn, tr, cr, 0, 0, tr, cr, 0, 0), jn = T + 56 | 0, $r = (d | 0) == (n | 0) & L >>> 0 < Ir >>> 0 | d >>> 0 > n >>> 0, L = (d | 0) == (Gn | 0) & Ir >>> 0 < Bn >>> 0 | d >>> 0 < Gn >>> 0, n = ni + 8 | 0, I = t[n >> 2], d = fi + 8 | 0, Ir = I + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = I >>> 0 > Ir >>> 0 ? n + 1 | 0 : n, I = L + Ir | 0, n = I >>> 0 < Ir >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, d = I + a | 0, n = a >>> 0 > d >>> 0 ? n + 1 | 0 : n, I = d, d = d + $r | 0, n = I >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | he >>> 20, I = n, a = n << 12 | d >>> 20, Bn = t[T + 72 >> 2], d = t[T + 296 >> 2], L = Bn + d | 0, Gn = t[T + 76 >> 2], n = Gn + t[T + 300 >> 2] | 0, d = d >>> 0 > L >>> 0 ? n + 1 | 0 : n, n = d + a | 0, he = he + L | 0, n = he >>> 0 < L >>> 0 ? n + 1 | 0 : n, a = n, Ur(jn, he, n & 1048575, 0, 0, 15632, 16, 0, 0), $r = T + 200 | 0, Ur($r, Ai, Be, 0, 0, Wr, gn, 0, 0), gn = T + 248 | 0, Ur(gn, xr, gr, 0, 0, xr, gr, 0, 0), Ir = T + 40 | 0, Ur(Ir, Mr, Un, 0, 0, tr, cr, 0, 0), gr = T + 24 | 0, cr = gr, Be = (d | 0) == (n | 0) & he >>> 0 < L >>> 0 | d >>> 0 > n >>> 0, L = (d | 0) == (Gn | 0) & L >>> 0 < Bn >>> 0 | d >>> 0 < Gn >>> 0, n = xn + 8 | 0, he = t[n >> 2], d = kn + 8 | 0, tr = he + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = he >>> 0 > tr >>> 0 ? n + 1 | 0 : n, he = L + tr | 0, n = he >>> 0 < tr >>> 0 ? n + 1 | 0 : n, I = I >>> 20 | 0, d = I + he | 0, n = I >>> 0 > d >>> 0 ? n + 1 | 0 : n, I = d, d = d + Be | 0, n = I >>> 0 > d >>> 0 ? n + 1 | 0 : n, he = d << 12 | a >>> 20, a = t[T + 40 >> 2], Be = he + a | 0, I = n, d = n << 12 | d >>> 20, n = d + t[T + 44 >> 2] | 0, n = a >>> 0 > Be >>> 0 ? n + 1 | 0 : n, Ur(cr, Be, n, 0, 0, 15632, 16, 0, 0), Wr = T + 8 | 0, L = Wr, he = (d | 0) == (n | 0) & he >>> 0 > Be >>> 0 | d >>> 0 > n >>> 0, d = Ir + 8 | 0, a = t[d >> 2], n = t[d + 4 >> 2], I = I >>> 20 | 0, d = I + a | 0, n = I >>> 0 > d >>> 0 ? n + 1 | 0 : n, I = d, d = d + he | 0, n = I >>> 0 > d >>> 0 ? n + 1 | 0 : n, Ur(L, d, n, 0, 0, 64028672, 65536, 0, 0), Be = t[T + 92 >> 2], n = Be + t[T + 332 >> 2] | 0, L = t[T + 88 >> 2], I = t[T + 328 >> 2], d = L + I | 0, t[T + 760 >> 2] = -3908 - d, a = d >>> 0 < I >>> 0 ? n + 1 | 0 : n, t[T + 764 >> 2] = 4194299 - ((a & 1048575) + (d >>> 0 > 4294963388) | 0), L = (a | 0) == (Be | 0) & d >>> 0 < L >>> 0 | a >>> 0 < Be >>> 0, n = yi + 8 | 0, I = t[n >> 2], d = ai + 8 | 0, Be = I + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = I >>> 0 > Be >>> 0 ? n + 1 | 0 : n, d = L + Be | 0, n = d >>> 0 < Be >>> 0 ? n + 1 | 0 : n, L = d << 12 | a >>> 20, I = n, cr = n << 12 | d >>> 20, Ir = t[T + 60 >> 2], n = Ir + t[T + 268 >> 2] | 0, tr = t[T + 56 >> 2], d = t[T + 264 >> 2], a = tr + d | 0, Be = a, L = a + L | 0, d = d >>> 0 > a >>> 0 ? n + 1 | 0 : n, n = d + cr | 0, a = L >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = L, t[T + 768 >> 2] = -4 - n, t[T + 772 >> 2] = 4194303 - ((a & 1048575) + (n >>> 0 > 4294967292) | 0), cr = (d | 0) == (a | 0) & n >>> 0 < Be >>> 0 | d >>> 0 > a >>> 0, Be = (d | 0) == (Ir | 0) & Be >>> 0 < tr >>> 0 | d >>> 0 < Ir >>> 0, n = Xn + 8 | 0, L = t[n >> 2], d = jn + 8 | 0, tr = L + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = L >>> 0 > tr >>> 0 ? n + 1 | 0 : n, L = Be + tr | 0, n = L >>> 0 < tr >>> 0 ? n + 1 | 0 : n, I = I >>> 20 | 0, d = I + L | 0, n = I >>> 0 > d >>> 0 ? n + 1 | 0 : n, I = d, d = d + cr | 0, n = I >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d << 12 | a >>> 20, I = n, a = n << 12 | d >>> 20, xr = t[T + 200 >> 2], d = t[T + 248 >> 2], cr = xr + d | 0, Mr = t[T + 204 >> 2], n = Mr + t[T + 252 >> 2] | 0, n = d >>> 0 > cr >>> 0 ? n + 1 | 0 : n, d = t[T + 24 >> 2], Be = d + cr | 0, tr = n, n = n + t[T + 28 >> 2] | 0, d = d >>> 0 > Be >>> 0 ? n + 1 | 0 : n, n = d + a | 0, L = L + Be | 0, n = L >>> 0 < Be >>> 0 ? n + 1 | 0 : n, t[T + 776 >> 2] = -4 - L, a = n, t[T + 780 >> 2] = 4194303 - ((n & 1048575) + (L >>> 0 > 4294967292) | 0), Un = (d | 0) == (n | 0) & L >>> 0 < Be >>> 0 | d >>> 0 > n >>> 0, Ai = (d | 0) == (tr | 0) & Be >>> 0 < cr >>> 0 | d >>> 0 < tr >>> 0, d = gr + 8 | 0, Ir = t[d >> 2], gr = t[d + 4 >> 2], Be = (tr | 0) == (Mr | 0) & cr >>> 0 < xr >>> 0 | tr >>> 0 < Mr >>> 0, n = gn + 8 | 0, L = t[n >> 2], d = $r + 8 | 0, cr = L + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[n + 4 >> 2] | 0, n = L >>> 0 > cr >>> 0 ? n + 1 | 0 : n, d = Be + cr | 0, n = (d >>> 0 < cr >>> 0 ? n + 1 | 0 : n) + gr | 0, he = d, d = d + Ir | 0, n = he >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d + Ai | 0, n = L >>> 0 < d >>> 0 ? n + 1 | 0 : n, I = I >>> 20 | 0, d = I + L | 0, n = I >>> 0 > d >>> 0 ? n + 1 | 0 : n, I = d, d = d + Un | 0, n = I >>> 0 > d >>> 0 ? n + 1 | 0 : n, L = d << 12 | a >>> 20, I = n, tr = n << 12 | d >>> 20, gr = t[T + 12 >> 2], n = gr + (Me & 1048575) | 0, cr = t[T + 8 >> 2], a = or & -2, d = cr + a | 0, or = d, L = d + L | 0, Be = d >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = Be + tr | 0, t[T + 784 >> 2] = -4 - L, d = L >>> 0 < d >>> 0 ? n + 1 | 0 : n, t[T + 788 >> 2] = 4194303 - ((d & 1048575) + (L >>> 0 > 4294967292) | 0), a = T, Me = E, dr = dr & 65535, L = (d | 0) == (Be | 0) & L >>> 0 < or >>> 0 | d >>> 0 < Be >>> 0, E = (Be | 0) == (gr | 0) & or >>> 0 < cr >>> 0 | Be >>> 0 < gr >>> 0, n = Wr + 8 | 0, he = E + t[n >> 2] | 0, n = t[n + 4 >> 2], n = E >>> 0 > he >>> 0 ? n + 1 | 0 : n, I = I >>> 20 | 0, E = I, I = I + he | 0, n = E >>> 0 > I >>> 0 ? n + 1 | 0 : n, E = I, I = I + L | 0, n = E >>> 0 > I >>> 0 ? n + 1 | 0 : n, d = I << 12 | d >>> 20, E = d + Me | 0, n = dr + (n << 12 | I >>> 20) | 0, t[a + 792 >> 2] = -4 - E, t[a + 796 >> 2] = 262143 - ((E >>> 0 > 4294967292) + (d >>> 0 > E >>> 0 ? n + 1 | 0 : n) | 0), kn = a + 720 | 0, d = a + 760 | 0, Xr(kn, d, wi), jn = a + 680 | 0, Xr(jn, a + 1e3 | 0, d), Bn = a + 800 | 0, Ui(v, Bn), d = t[a + 752 >> 2], E = d + t[v + 32 >> 2] | 0, n = t[v + 36 >> 2] + t[a + 756 >> 2] | 0, I = d >>> 0 > E >>> 0 ? n + 1 | 0 : n, d = t[a + 712 >> 2], $r = d, n = t[a + 716 >> 2], Mr = n, n = (n << 1 | d >>> 31) + I | 0, d = d << 1, I = d, d = d + E | 0, n = I >>> 0 > d >>> 0 ? n + 1 | 0 : n, tr = d, t[v + 32 >> 2] = d, or = n, t[v + 36 >> 2] = n, d = v, v = t[a + 744 >> 2], E = v + t[d + 24 >> 2] | 0, n = t[d + 28 >> 2] + t[a + 748 >> 2] | 0, I = v >>> 0 > E >>> 0 ? n + 1 | 0 : n, v = t[a + 704 >> 2], gn = v, n = t[a + 708 >> 2], Wr = n, n = (n << 1 | v >>> 31) + I | 0, v = v << 1, I = v, v = v + E | 0, n = I >>> 0 > v >>> 0 ? n + 1 | 0 : n, cr = v, t[d + 24 >> 2] = v, dr = n, t[d + 28 >> 2] = n, v = t[a + 736 >> 2], E = v + t[d + 16 >> 2] | 0, n = t[d + 20 >> 2] + t[a + 740 >> 2] | 0, I = v >>> 0 > E >>> 0 ? n + 1 | 0 : n, v = t[a + 696 >> 2], xr = v, n = t[a + 700 >> 2], Un = n, n = (n << 1 | v >>> 31) + I | 0, v = v << 1, I = v, v = v + E | 0, n = I >>> 0 > v >>> 0 ? n + 1 | 0 : n, Be = v, t[d + 16 >> 2] = v, Me = n, t[d + 20 >> 2] = n, v = t[a + 728 >> 2], I = v + t[d + 8 >> 2] | 0, n = t[d + 12 >> 2] + t[a + 732 >> 2] | 0, v = v >>> 0 > I >>> 0 ? n + 1 | 0 : n, n = t[a + 692 >> 2], Ai = n, xn = t[a + 688 >> 2], E = xn, n = (n << 1 | E >>> 31) + v | 0, E = E << 1, L = I + E | 0, n = E >>> 0 > L >>> 0 ? n + 1 | 0 : n, t[d + 8 >> 2] = L, he = n, t[d + 12 >> 2] = n, v = t[a + 720 >> 2], E = v + t[d >> 2] | 0, n = t[d + 4 >> 2] + t[a + 724 >> 2] | 0, I = v >>> 0 > E >>> 0 ? n + 1 | 0 : n, v = t[a + 680 >> 2], Ir = v, n = t[a + 684 >> 2], gr = n, n = (n << 1 | v >>> 31) + I | 0, v = v << 1, I = v, v = v + E | 0, n = I >>> 0 > v >>> 0 ? n + 1 | 0 : n, E = v, t[d >> 2] = E, I = n, t[d + 4 >> 2] = n, n = or + Mr | 0, a = tr + $r | 0, n = a >>> 0 < tr >>> 0 ? n + 1 | 0 : n, t[T + 712 >> 2] = a, t[T + 716 >> 2] = n, n = dr + Wr | 0, a = cr + gn | 0, n = a >>> 0 < cr >>> 0 ? n + 1 | 0 : n, t[T + 704 >> 2] = a, t[T + 708 >> 2] = n, n = Me + Un | 0, a = Be + xr | 0, n = a >>> 0 < Be >>> 0 ? n + 1 | 0 : n, t[T + 696 >> 2] = a, t[T + 700 >> 2] = n, n = he + Ai | 0, a = L + xn | 0, n = a >>> 0 < xn >>> 0 ? n + 1 | 0 : n, t[T + 688 >> 2] = a, t[T + 692 >> 2] = n, n = I + gr | 0, v = E + Ir | 0, n = v >>> 0 < E >>> 0 ? n + 1 | 0 : n, t[T + 680 >> 2] = v, t[T + 684 >> 2] = n, Xr(d + 40 | 0, jn, Bn), Xr(kn, kn, T + 920 | 0), n = t[d + 44 >> 2] + t[T + 724 >> 2] | 0, v = t[T + 720 >> 2], I = v + t[d + 40 >> 2] | 0, t[d + 40 >> 2] = I, t[d + 44 >> 2] = v >>> 0 > I >>> 0 ? n + 1 | 0 : n, n = d + 48 | 0, a = n, v = t[T + 728 >> 2], I = v + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[T + 732 >> 2] | 0, t[a >> 2] = I, t[a + 4 >> 2] = v >>> 0 > I >>> 0 ? n + 1 | 0 : n, n = d + 56 | 0, a = n, v = t[T + 736 >> 2], I = v + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[T + 740 >> 2] | 0, t[a >> 2] = I, t[a + 4 >> 2] = v >>> 0 > I >>> 0 ? n + 1 | 0 : n, n = d - -64 | 0, a = n, v = t[T + 744 >> 2], I = v + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[T + 748 >> 2] | 0, t[a >> 2] = I, t[a + 4 >> 2] = v >>> 0 > I >>> 0 ? n + 1 | 0 : n, v = t[T + 752 >> 2], I = d + 72 | 0, d = v + t[I >> 2] | 0, n = t[I + 4 >> 2] + t[T + 756 >> 2] | 0, t[I >> 2] = d, t[I + 4 >> 2] = v >>> 0 > d >>> 0 ? n + 1 | 0 : n;
    }
    x = T + 1120 | 0;
  }
  function Ei(v, d, I, n) {
    var a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0, Xn = 0, Zn = 0, ni = 0, ai = 0, fi = 0, Ai = 0, yi = 0, Ii = 0, wi = 0, Bi = 0;
    he = x - 736 | 0, x = he, a = t[I + 80 >> 2];
    e: {
      if (t[d + 120 >> 2]) {
        t[v + 120 >> 2] = a, d = t[I + 4 >> 2], t[v >> 2] = t[I >> 2], t[v + 4 >> 2] = d, d = I + 8 | 0, n = t[d + 4 >> 2], a = v + 8 | 0, t[a >> 2] = t[d >> 2], t[a + 4 >> 2] = n, d = I + 16 | 0, n = t[d + 4 >> 2], a = v + 16 | 0, t[a >> 2] = t[d >> 2], t[a + 4 >> 2] = n, d = I + 24 | 0, n = t[d + 4 >> 2], a = v + 24 | 0, t[a >> 2] = t[d >> 2], t[a + 4 >> 2] = n, d = I + 32 | 0, n = t[d + 4 >> 2], a = v + 32 | 0, t[a >> 2] = t[d >> 2], t[a + 4 >> 2] = n, d = t[I + 44 >> 2], t[v + 40 >> 2] = t[I + 40 >> 2], t[v + 44 >> 2] = d, d = I + 48 | 0, n = t[d + 4 >> 2], a = v + 48 | 0, t[a >> 2] = t[d >> 2], t[a + 4 >> 2] = n, d = I + 56 | 0, n = t[d + 4 >> 2], a = v + 56 | 0, t[a >> 2] = t[d >> 2], t[a + 4 >> 2] = n, d = I - -64 | 0, n = t[d + 4 >> 2], a = v - -64 | 0, t[a >> 2] = t[d >> 2], t[a + 4 >> 2] = n, d = I + 72 | 0, I = t[d + 4 >> 2], n = v + 72 | 0, t[n >> 2] = t[d >> 2], t[n + 4 >> 2] = I, d = v + 88 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, t[v + 80 >> 2] = 1, t[v + 84 >> 2] = 0, d = v + 96 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = v + 104 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, v = v + 112 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0;
        break e;
      }
      if (a) {
        n && (t[n + 8 >> 2] = 0, t[n + 12 >> 2] = 0, t[n >> 2] = 1, t[n + 4 >> 2] = 0, I = n + 16 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = n + 24 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0, I = n + 32 | 0, t[I >> 2] = 0, t[I + 4 >> 2] = 0), $i(v, d, 128);
        break e;
      }
      Mr = he + 696 | 0, ni = d + 80 | 0, Ui(Mr, ni), dr = he + 656 | 0, Me = dr + 8 | 0, a = d + 8 | 0, L = t[a >> 2], or = t[a + 4 >> 2], T = t[d + 4 >> 2], a = d + 32 | 0, tr = t[a >> 2], Be = t[a + 4 >> 2], xr = Be, a = t[d >> 2], Be = pn(Be >>> 16 | 0, 0, 977, 1), E = a + Be | 0, a = T + Ee | 0, Be = E >>> 0 < Be >>> 0 ? a + 1 | 0 : a, a = or, T = Be >>> 20 | 0, or = T, T = T + L | 0, a = or >>> 0 > T >>> 0 ? a + 1 | 0 : a, t[Me >> 2] = T, Wr = a & 1048575, t[Me + 4 >> 2] = Wr, L = dr + 16 | 0, Me = d + 16 | 0, or = t[Me >> 2], gr = t[Me + 4 >> 2], Me = a, a = gr, Me = Me >>> 20 | 0, cr = Me, Me = Me + or | 0, a = cr >>> 0 > Me >>> 0 ? a + 1 | 0 : a, t[L >> 2] = Me, Xn = a & 1048575, t[L + 4 >> 2] = Xn, or = dr + 24 | 0, L = d + 24 | 0, gr = t[L >> 2], cr = t[L + 4 >> 2], L = a, a = cr, L = L >>> 20 | 0, cr = L, L = L + gr | 0, a = cr >>> 0 > L >>> 0 ? a + 1 | 0 : a, t[or >> 2] = L, xn = a & 1048575, t[or + 4 >> 2] = xn, or = dr + 32 | 0, dr = a, a = xr & 65535, dr = dr >>> 20 | 0, xr = tr + dr | 0, a = dr >>> 0 > xr >>> 0 ? a + 1 | 0 : a, t[or >> 2] = xr, gn = a, t[or + 4 >> 2] = a, tr = E, t[he + 656 >> 2] = E, $r = Be & 1048575, t[he + 660 >> 2] = $r, Xr(he + 616 | 0, I, Mr), gr = he + 576 | 0, or = gr + 8 | 0, a = d + 48 | 0, Ir = t[a >> 2], Bn = t[a + 4 >> 2], dr = t[d + 44 >> 2], a = d + 72 | 0, Be = t[a >> 2], cr = t[a + 4 >> 2], kn = cr, a = t[d + 40 >> 2], cr = pn(cr >>> 16 | 0, 0, 977, 1), E = a + cr | 0, a = dr + Ee | 0, dr = E >>> 0 < cr >>> 0 ? a + 1 | 0 : a, a = Bn, cr = dr >>> 20 | 0, Bn = cr + Ir | 0, a = cr >>> 0 > Bn >>> 0 ? a + 1 | 0 : a, t[or >> 2] = Bn, ai = a & 1048575, t[or + 4 >> 2] = ai, cr = gr + 16 | 0, or = d + 56 | 0, Ir = t[or >> 2], Un = t[or + 4 >> 2], or = a, a = Un, or = or >>> 20 | 0, Un = or + Ir | 0, a = or >>> 0 > Un >>> 0 ? a + 1 | 0 : a, t[cr >> 2] = Un, jn = a & 1048575, t[cr + 4 >> 2] = jn, cr = gr + 24 | 0, or = d - -64 | 0, Ir = t[or >> 2], Gn = t[or + 4 >> 2], or = a, a = Gn, or = or >>> 20 | 0, Gn = or + Ir | 0, a = or >>> 0 > Gn >>> 0 ? a + 1 | 0 : a, t[cr >> 2] = Gn, Zn = a & 1048575, t[cr + 4 >> 2] = Zn, gr = gr + 32 | 0, or = a, a = kn & 65535, or = or >>> 20 | 0, cr = Be + or | 0, a = or >>> 0 > cr >>> 0 ? a + 1 | 0 : a, t[gr >> 2] = cr, Ir = a, t[gr + 4 >> 2] = a, kn = E, t[he + 576 >> 2] = E, fi = dr & 1048575, t[he + 580 >> 2] = fi, a = he + 536 | 0, Xr(a, I + 40 | 0, Mr), Xr(a, a, ni), I = t[he + 616 >> 2], Be = (I - tr | 0) - 3908 | 0, a = (t[he + 620 >> 2] - ((I >>> 0 < tr >>> 0) + $r | 0) | 0) + 4194299 | 0, t[he + 496 >> 2] = Be, or = Be >>> 0 < 4294963388 ? a + 1 | 0 : a, t[he + 500 >> 2] = or, I = he, a = t[I + 624 >> 2], tr = (a - T | 0) - 4 | 0, a = (t[I + 628 >> 2] - ((a >>> 0 < T >>> 0) + Wr | 0) | 0) + 4194303 | 0, t[I + 504 >> 2] = tr, dr = tr >>> 0 < 4294967292 ? a + 1 | 0 : a, t[I + 508 >> 2] = dr, a = t[I + 632 >> 2], E = (a - Me | 0) - 4 | 0, a = (t[I + 636 >> 2] - ((a >>> 0 < Me >>> 0) + Xn | 0) | 0) + 4194303 | 0, t[I + 512 >> 2] = E, Me = E >>> 0 < 4294967292 ? a + 1 | 0 : a, t[I + 516 >> 2] = Me, a = t[I + 640 >> 2], T = (a - L | 0) - 4 | 0, a = (t[I + 644 >> 2] - ((a >>> 0 < L >>> 0) + xn | 0) | 0) + 4194303 | 0, t[I + 520 >> 2] = T, L = T >>> 0 < 4294967292 ? a + 1 | 0 : a, t[I + 524 >> 2] = L, a = t[I + 648 >> 2], I = (a - xr | 0) - 4 | 0, a = (t[he + 652 >> 2] - ((a >>> 0 < xr >>> 0) + gn | 0) | 0) + 262143 | 0, t[he + 528 >> 2] = I, xr = I >>> 0 < 4294967292 ? a + 1 | 0 : a, t[he + 532 >> 2] = xr, a = t[he + 568 >> 2], gn = (cr - a | 0) - 4 | 0, a = (Ir - (t[he + 572 >> 2] + (a >>> 0 > cr >>> 0) | 0) | 0) + 262143 | 0, t[he + 488 >> 2] = gn, cr = gn >>> 0 < 4294967292 ? a + 1 | 0 : a, t[he + 492 >> 2] = cr, a = t[he + 560 >> 2], Ir = (Gn - a | 0) - 4 | 0, a = (Zn - (t[he + 564 >> 2] + (a >>> 0 > Gn >>> 0) | 0) | 0) + 4194303 | 0, Gn = Ir, t[he + 480 >> 2] = Ir, Zn = Ir >>> 0 < 4294967292 ? a + 1 | 0 : a, t[he + 484 >> 2] = Zn, a = t[he + 552 >> 2], Ir = (Un - a | 0) - 4 | 0, a = (jn - (t[he + 556 >> 2] + (a >>> 0 > Un >>> 0) | 0) | 0) + 4194303 | 0, Un = Ir, t[he + 472 >> 2] = Ir, jn = Ir >>> 0 < 4294967292 ? a + 1 | 0 : a, t[he + 476 >> 2] = jn, a = t[he + 544 >> 2], Ir = (Bn - a | 0) - 4 | 0, a = (ai - (t[he + 548 >> 2] + (a >>> 0 > Bn >>> 0) | 0) | 0) + 4194303 | 0, t[he + 464 >> 2] = Ir, ai = Ir >>> 0 < 4294967292 ? a + 1 | 0 : a, t[he + 468 >> 2] = ai, a = t[he + 536 >> 2], gr = (kn - a | 0) - 3908 | 0, a = (fi - (t[he + 540 >> 2] + (a >>> 0 > kn >>> 0) | 0) | 0) + 4194299 | 0, Bn = gr, t[he + 456 >> 2] = gr, fi = gr >>> 0 < 4294963388 ? a + 1 | 0 : a, t[he + 460 >> 2] = fi, gr = pn(xr >>> 16 | 0, 0, 977, 1) + Be | 0, a = Ee + or | 0, a = Be >>> 0 > gr >>> 0 ? a + 1 | 0 : a, kn = a & 1048575, Ai = kn;
      t: {
        if (yi = gr, Ii = gr ^ 976, wi = kn ^ 1, ((Ii | 0) != -1 | (wi | 0) != 1048575) & (gr | kn) != 0 || ($r = xr & 65535, gr = a, a = dr, gr = (gr >>> 20 | 0) + tr | 0, kn = gr >>> 0 < tr >>> 0 ? a + 1 | 0 : a, a = Me, Mr = (kn >>> 20 | 0) + E | 0, Wr = Mr >>> 0 < E >>> 0 ? a + 1 | 0 : a, a = L, Xn = (Wr >>> 20 | 0) + T | 0, xn = Xn >>> 0 < T >>> 0 ? a + 1 | 0 : a, a = $r, $r = xn >>> 20 | 0, Bi = $r, $r = I + $r | 0, a = Bi >>> 0 > $r >>> 0 ? a + 1 | 0 : a, $r | (Xn | (Mr | (gr | yi))) | (a | (xn & 1048575 | (Wr & 1048575 | (kn & 1048575 | Ai)))) && ((gr & Ii & Mr & Xn & $r) != -1 ? a = 1 : a = (kn & wi & Wr & xn & (a ^ 983040)) != 1048575, a)))
          break t;
        I = pn(cr >>> 16 | 0, 0, 977, 1) + Bn | 0, a = Ee + fi | 0, a = I >>> 0 < Bn >>> 0 ? a + 1 | 0 : a, E = a & 1048575, or = E;
        r: {
          if (dr = I, xr = I ^ 976, gr = E ^ 1, ((xr | 0) != -1 | (gr | 0) != 1048575) & (I | E) != 0 || (cr = cr & 65535, I = a, a = ai, I = (I >>> 20 | 0) + Ir | 0, E = I >>> 0 < Ir >>> 0 ? a + 1 | 0 : a, a = jn, T = (E >>> 20 | 0) + Un | 0, tr = T >>> 0 < Un >>> 0 ? a + 1 | 0 : a, a = Zn, Me = (tr >>> 20 | 0) + Gn | 0, L = Me >>> 0 < Gn >>> 0 ? a + 1 | 0 : a, a = cr, Be = L >>> 20 | 0, cr = Be, Be = Be + gn | 0, a = cr >>> 0 > Be >>> 0 ? a + 1 | 0 : a, Be | (Me | (T | (I | dr))) | (a | (L & 1048575 | (tr & 1048575 | (E & 1048575 | or)))) && ((I & xr & T & Me & Be) != -1 ? I = 1 : I = (E & gr & tr & L & (a ^ 983040)) != 1048575, I)))
            break r;
          if (t[d + 120 >> 2]) {
            if (t[v + 120 >> 2] = 1, Vi(v, 120), !n)
              break e;
            t[n + 8 >> 2] = 0, t[n + 12 >> 2] = 0, t[n >> 2] = 1, t[n + 4 >> 2] = 0, v = n + 16 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = n + 24 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0, v = n + 32 | 0, t[v >> 2] = 0, t[v + 4 >> 2] = 0;
            break e;
          }
          n && (I = d + 40 | 0, a = t[I >> 2], E = t[I + 4 >> 2], t[n >> 2] = a, t[n + 4 >> 2] = E, T = I + 8 | 0, tr = t[T >> 2], dr = tr, Me = t[T + 4 >> 2], or = Me, T = n + 8 | 0, t[T >> 2] = tr, t[T + 4 >> 2] = Me, tr = I + 16 | 0, Me = t[tr >> 2], xr = Me, L = t[tr + 4 >> 2], gr = L, tr = n + 16 | 0, t[tr >> 2] = Me, t[tr + 4 >> 2] = L, Me = I + 24 | 0, L = t[Me >> 2], cr = L, Be = t[Me + 4 >> 2], gn = Be, Me = n + 24 | 0, t[Me >> 2] = L, t[Me + 4 >> 2] = Be, I = I + 32 | 0, L = t[I >> 2], I = t[I + 4 >> 2], Be = n + 32 | 0, t[Be >> 2] = L, t[Be + 4 >> 2] = I, Bn = pn(I >>> 16 | 0, 0, 977, 1), Ir = Bn + a | 0, a = E + Ee | 0, t[n >> 2] = Ir, a = Ir >>> 0 < Bn >>> 0 ? a + 1 | 0 : a, t[n + 4 >> 2] = a & 1048575, n = a, a = or, n = n >>> 20 | 0, E = n, n = n + dr | 0, a = E >>> 0 > n >>> 0 ? a + 1 | 0 : a, t[T >> 2] = n, t[T + 4 >> 2] = a & 1048575, n = a, a = gr, n = n >>> 20 | 0, E = n, n = n + xr | 0, a = E >>> 0 > n >>> 0 ? a + 1 | 0 : a, t[tr >> 2] = n, t[tr + 4 >> 2] = a & 1048575, n = a, a = gn, n = n >>> 20 | 0, E = n, n = n + cr | 0, a = E >>> 0 > n >>> 0 ? a + 1 | 0 : a, t[Me >> 2] = n, t[Me + 4 >> 2] = a & 1048575, n = I & 65535, I = a, a = n, I = I >>> 20 | 0, n = I, I = I + L | 0, a = n >>> 0 > I >>> 0 ? a + 1 | 0 : a, t[Be >> 2] = I, t[Be + 4 >> 2] = a), Mi(v, d);
          break e;
        }
        n && (t[n >> 2] = 0, t[n + 4 >> 2] = 0, d = n + 32 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = n + 24 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = n + 16 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0, d = n + 8 | 0, t[d >> 2] = 0, t[d + 4 >> 2] = 0), t[v + 120 >> 2] = 1, Vi(v, 120);
        break e;
      }
      t[v + 120 >> 2] = 0, n && (d = t[he + 500 >> 2], t[n >> 2] = t[he + 496 >> 2], t[n + 4 >> 2] = d, d = he + 496 | 0, a = d + 32 | 0, gr = t[a + 4 >> 2], cr = n + 32 | 0, t[cr >> 2] = t[a >> 2], t[cr + 4 >> 2] = gr, a = d + 24 | 0, gr = t[a + 4 >> 2], cr = n + 24 | 0, t[cr >> 2] = t[a >> 2], t[cr + 4 >> 2] = gr, a = d + 16 | 0, gr = t[a + 4 >> 2], cr = n + 16 | 0, t[cr >> 2] = t[a >> 2], t[cr + 4 >> 2] = gr, d = d + 8 | 0, a = t[d + 4 >> 2], n = n + 8 | 0, t[n >> 2] = t[d >> 2], t[n + 4 >> 2] = a), Xn = he + 496 | 0, Xr(v + 80 | 0, ni, Xn), kn = he + 304 | 0, gr = Be << 1, d = or, or = d << 1 | Be >>> 31, Ur(kn, T, L, 0, 0, gr, or, 0, 0), Mr = he + 224 | 0, n = tr << 1, gn = dr, dr = tr, cr = gn << 1 | tr >>> 31, Ur(Mr, E, Me, 0, 0, n, cr, 0, 0), Ir = he + 160 | 0, Ur(Ir, I, xr, 0, 0, I, xr, 0, 0), Wr = he + 144 | 0, Ur(Wr, t[he + 160 >> 2], t[he + 164 >> 2], 0, 0, 15632, 16, 0, 0), xn = he + 112 | 0, tr = I << 1, xr = xr << 1 | I >>> 31, Ur(xn, tr, xr, 0, 0, Be, d, 0, 0), $r = he + 272 | 0, Ur($r, T, L, 0, 0, n, cr, 0, 0), Zn = he + 208 | 0, Ur(Zn, E, Me, 0, 0, E, Me, 0, 0), jn = he + 128 | 0, I = Ir + 8 | 0, Ur(jn, t[I >> 2], t[I + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), ai = he + 320 | 0, Ur(ai, Be, d, 0, 0, Be, d, 0, 0), fi = he + 96 | 0, Ur(fi, tr, xr, 0, 0, dr, gn, 0, 0), yi = he + 176 | 0, Ir = T, Bn = L, Un = Me, Me = E, Ur(yi, T, L, 0, 0, E << 1, Un << 1 | E >>> 31, 0, 0), T = t[he + 304 >> 2], I = t[he + 224 >> 2], d = T + I | 0, E = t[he + 308 >> 2], a = E + t[he + 228 >> 2] | 0, I = d >>> 0 < I >>> 0 ? a + 1 | 0 : a, a = I + t[he + 148 >> 2] | 0, n = d, L = t[he + 144 >> 2], d = d + L | 0, Gn = d, d = d >>> 0 < L >>> 0 ? a + 1 | 0 : a, L = (I | 0) == (d | 0) & n >>> 0 > Gn >>> 0 | d >>> 0 < I >>> 0, a = Wr + 8 | 0, Be = t[a >> 2], cr = t[a + 4 >> 2], n = (I | 0) == (E | 0) & n >>> 0 < T >>> 0 | I >>> 0 < E >>> 0, a = Mr + 8 | 0, E = t[a >> 2], T = kn + 8 | 0, I = E + t[T >> 2] | 0, a = t[T + 4 >> 2] + t[a + 4 >> 2] | 0, a = I >>> 0 < E >>> 0 ? a + 1 | 0 : a, E = I, I = I + n | 0, a = (E >>> 0 > I >>> 0 ? a + 1 | 0 : a) + cr | 0, n = I, I = I + Be | 0, a = n >>> 0 > I >>> 0 ? a + 1 | 0 : a, n = I + L | 0, I = n >>> 0 < I >>> 0 ? a + 1 | 0 : a, E = I << 12 | n >>> 20, kn = d, Mr = n << 12 | d >>> 20, ni = E, Ai = t[he + 272 >> 2], n = t[he + 208 >> 2], d = Ai + n | 0, Wr = t[he + 276 >> 2], a = Wr + t[he + 212 >> 2] | 0, a = d >>> 0 < n >>> 0 ? a + 1 | 0 : a, L = d, n = t[he + 112 >> 2], d = d + n | 0, E = a, a = a + t[he + 116 >> 2] | 0, a = d >>> 0 < n >>> 0 ? a + 1 | 0 : a, Be = d, n = t[he + 128 >> 2], d = d + n | 0, T = a, a = a + t[he + 132 >> 2] | 0, n = d >>> 0 < n >>> 0 ? a + 1 | 0 : a, a = n + ni | 0, ni = he + 80 | 0, cr = d, Mr = d + Mr | 0, d = d >>> 0 > Mr >>> 0 ? a + 1 | 0 : a, a = n, n = Mr, Mr = (d | 0) == (a | 0) & n >>> 0 < cr >>> 0 | d >>> 0 < a >>> 0, cr = (a | 0) == (T | 0) & Be >>> 0 > cr >>> 0 | a >>> 0 < T >>> 0, a = jn + 8 | 0, jn = t[a >> 2], Ii = t[a + 4 >> 2], T = (E | 0) == (T | 0) & Be >>> 0 < L >>> 0 | E >>> 0 > T >>> 0, a = xn + 8 | 0, Be = t[a >> 2], xn = t[a + 4 >> 2], L = (E | 0) == (Wr | 0) & L >>> 0 < Ai >>> 0 | E >>> 0 < Wr >>> 0, a = Zn + 8 | 0, Wr = t[a >> 2], $r = $r + 8 | 0, E = Wr + t[$r >> 2] | 0, a = t[$r + 4 >> 2] + t[a + 4 >> 2] | 0, a = E >>> 0 < Wr >>> 0 ? a + 1 | 0 : a, $r = E, E = E + L | 0, a = ($r >>> 0 > E >>> 0 ? a + 1 | 0 : a) + xn | 0, L = E, E = E + Be | 0, a = L >>> 0 > E >>> 0 ? a + 1 | 0 : a, L = E, E = E + T | 0, a = (L >>> 0 > E >>> 0 ? a + 1 | 0 : a) + Ii | 0, L = E, E = E + jn | 0, a = L >>> 0 > E >>> 0 ? a + 1 | 0 : a, L = E, E = E + cr | 0, a = L >>> 0 > E >>> 0 ? a + 1 | 0 : a, I = I >>> 20 | 0, L = I, I = I + E | 0, a = L >>> 0 > I >>> 0 ? a + 1 | 0 : a, E = I + Mr | 0, I = E >>> 0 < I >>> 0 ? a + 1 | 0 : a, a = I << 12 | E >>> 20, L = E << 12, E = d, Be = L | d >>> 20, cr = a, Wr = t[he + 96 >> 2], T = t[he + 176 >> 2], d = Wr + T | 0, Mr = t[he + 100 >> 2], a = Mr + t[he + 180 >> 2] | 0, T = d >>> 0 < T >>> 0 ? a + 1 | 0 : a, a = T + cr | 0, L = d, Be = d + Be | 0, a = d >>> 0 > Be >>> 0 ? a + 1 | 0 : a, xn = Be << 4 & -16, cr = E, d = a, Ur(ni, xn | E >>> 16 & 15, (a << 4 | Be >>> 28) & 16777215, 0, 0, 977, 1, 0, 0), xn = he + 256 | 0, Ur(xn, dr, gn, 0, 0, gr, or, 0, 0), $r = he - -64 | 0, Ur($r, tr, xr, 0, 0, Me, Un, 0, 0), Zn = he + 288 | 0, Ur(Zn, Ir, Bn, 0, 0, Ir, Bn, 0, 0), jn = he + 48 | 0, Be = (a | 0) == (T | 0) & Be >>> 0 < L >>> 0 | a >>> 0 < T >>> 0, T = (T | 0) == (Mr | 0) & L >>> 0 < Wr >>> 0 | T >>> 0 < Mr >>> 0, a = yi + 8 | 0, L = t[a >> 2], Mr = fi + 8 | 0, E = L + t[Mr >> 2] | 0, a = t[Mr + 4 >> 2] + t[a + 4 >> 2] | 0, a = E >>> 0 < L >>> 0 ? a + 1 | 0 : a, L = E, E = E + T | 0, a = L >>> 0 > E >>> 0 ? a + 1 | 0 : a, I = I >>> 20 | 0, L = I, I = I + E | 0, a = L >>> 0 > I >>> 0 ? a + 1 | 0 : a, E = I + Be | 0, I = E >>> 0 < I >>> 0 ? a + 1 | 0 : a, T = I << 12 | E >>> 20, E = E << 12 | d >>> 20, L = T, Mr = t[he + 64 >> 2], T = t[he + 288 >> 2], d = Mr + T | 0, Be = t[he + 68 >> 2], a = Be + t[he + 292 >> 2] | 0, a = d >>> 0 < T >>> 0 ? a + 1 | 0 : a, T = d, d = a, a = a + L | 0, E = E + T | 0, a = E >>> 0 < T >>> 0 ? a + 1 | 0 : a, L = E, E = a, Ur(jn, L, a & 1048575, 0, 0, 15632, 16, 0, 0), Wr = he + 192 | 0, Ur(Wr, Me, Un, 0, 0, gr, or, 0, 0), or = he + 240 | 0, Ur(or, dr, gn, 0, 0, dr, gn, 0, 0), Me = he + 32 | 0, Ur(Me, tr, xr, 0, 0, Ir, Bn, 0, 0), xr = he + 16 | 0, tr = xr, L = (d | 0) == (a | 0) & T >>> 0 > L >>> 0 | d >>> 0 > a >>> 0, T = (d | 0) == (Be | 0) & T >>> 0 < Mr >>> 0 | d >>> 0 < Be >>> 0, a = Zn + 8 | 0, Be = t[a >> 2], dr = $r + 8 | 0, d = Be + t[dr >> 2] | 0, a = t[dr + 4 >> 2] + t[a + 4 >> 2] | 0, a = d >>> 0 < Be >>> 0 ? a + 1 | 0 : a, dr = d, d = d + T | 0, a = dr >>> 0 > d >>> 0 ? a + 1 | 0 : a, I = I >>> 20 | 0, d = d + I | 0, a = I >>> 0 > d >>> 0 ? a + 1 | 0 : a, I = d + L | 0, d = I >>> 0 < d >>> 0 ? a + 1 | 0 : a, T = d << 12 | I >>> 20, L = I << 12 | E >>> 20, Be = t[he + 32 >> 2], I = L + Be | 0, E = T, a = E + t[he + 36 >> 2] | 0, a = I >>> 0 < Be >>> 0 ? a + 1 | 0 : a, Ur(tr, I, a, 0, 0, 15632, 16, 0, 0), I = (a | 0) == (E | 0) & I >>> 0 < L >>> 0 | a >>> 0 < E >>> 0, a = Me + 8 | 0, E = t[a >> 2], a = t[a + 4 >> 2], d = d >>> 20 | 0, L = d, d = d + E | 0, a = L >>> 0 > d >>> 0 ? a + 1 | 0 : a, E = d, d = d + I | 0, a = E >>> 0 > d >>> 0 ? a + 1 | 0 : a, Ur(he, d, a, 0, 0, 64028672, 65536, 0, 0), d = he, tr = t[d + 80 >> 2], I = t[d + 320 >> 2], E = tr + I | 0, T = t[d + 84 >> 2], a = T + t[d + 324 >> 2] | 0, t[d + 416 >> 2] = -3908 - E, I = I >>> 0 > E >>> 0 ? a + 1 | 0 : a, t[d + 420 >> 2] = 4194299 - ((I & 1048575) + (E >>> 0 > 4294963388) | 0), T = (I | 0) == (T | 0) & E >>> 0 < tr >>> 0 | I >>> 0 < T >>> 0, a = ai + 8 | 0, tr = t[a >> 2], Me = ni + 8 | 0, E = tr + t[Me >> 2] | 0, a = t[Me + 4 >> 2] + t[a + 4 >> 2] | 0, a = E >>> 0 < tr >>> 0 ? a + 1 | 0 : a, T = E + T | 0, E = T >>> 0 < E >>> 0 ? a + 1 | 0 : a, tr = E << 12 | T >>> 20, T = T << 12 | I >>> 20, Me = tr, Be = t[d + 48 >> 2], tr = t[d + 256 >> 2], I = Be + tr | 0, L = t[d + 52 >> 2], a = L + t[d + 260 >> 2] | 0, a = I >>> 0 < tr >>> 0 ? a + 1 | 0 : a, tr = I, I = a, a = a + Me | 0, T = T + tr | 0, a = T >>> 0 < tr >>> 0 ? a + 1 | 0 : a, Me = T, t[d + 424 >> 2] = -4 - T, T = a, t[d + 428 >> 2] = 4194303 - ((a & 1048575) + (Me >>> 0 > 4294967292) | 0), Me = (I | 0) == (a | 0) & Me >>> 0 < tr >>> 0 | I >>> 0 > a >>> 0, tr = (I | 0) == (L | 0) & Be >>> 0 > tr >>> 0 | I >>> 0 < L >>> 0, a = xn + 8 | 0, L = t[a >> 2], Be = jn + 8 | 0, I = L + t[Be >> 2] | 0, a = t[Be + 4 >> 2] + t[a + 4 >> 2] | 0, a = I >>> 0 < L >>> 0 ? a + 1 | 0 : a, L = I, I = I + tr | 0, a = L >>> 0 > I >>> 0 ? a + 1 | 0 : a, E = E >>> 20 | 0, I = I + E | 0, a = E >>> 0 > I >>> 0 ? a + 1 | 0 : a, E = I + Me | 0, I = E >>> 0 < I >>> 0 ? a + 1 | 0 : a, tr = I << 12 | E >>> 20, Be = E << 12 | T >>> 20, gn = t[d + 192 >> 2], E = t[d + 240 >> 2], T = gn + E | 0, dr = t[d + 196 >> 2], a = dr + t[d + 244 >> 2] | 0, a = E >>> 0 > T >>> 0 ? a + 1 | 0 : a, L = T, T = t[d + 16 >> 2], Me = L + T | 0, E = a, a = a + t[d + 20 >> 2] | 0, T = T >>> 0 > Me >>> 0 ? a + 1 | 0 : a, a = T + tr | 0, tr = Be + Me | 0, a = tr >>> 0 < Me >>> 0 ? a + 1 | 0 : a, Be = tr, t[d + 432 >> 2] = -4 - Be, tr = a, t[d + 436 >> 2] = 4194303 - ((a & 1048575) + (Be >>> 0 > 4294967292) | 0), Be = (a | 0) == (T | 0) & Be >>> 0 < Me >>> 0 | a >>> 0 < T >>> 0, T = (E | 0) == (T | 0) & L >>> 0 > Me >>> 0 | E >>> 0 > T >>> 0, a = xr + 8 | 0, Me = t[a >> 2], xr = t[a + 4 >> 2], L = (E | 0) == (dr | 0) & L >>> 0 < gn >>> 0 | E >>> 0 < dr >>> 0, a = or + 8 | 0, dr = t[a >> 2], or = Wr + 8 | 0, E = dr + t[or >> 2] | 0, a = t[or + 4 >> 2] + t[a + 4 >> 2] | 0, a = E >>> 0 < dr >>> 0 ? a + 1 | 0 : a, or = E, E = E + L | 0, a = (or >>> 0 > E >>> 0 ? a + 1 | 0 : a) + xr | 0, L = E, E = E + Me | 0, a = L >>> 0 > E >>> 0 ? a + 1 | 0 : a, L = E, E = E + T | 0, a = L >>> 0 > E >>> 0 ? a + 1 | 0 : a, I = I >>> 20 | 0, L = I, I = I + E | 0, a = L >>> 0 > I >>> 0 ? a + 1 | 0 : a, E = I + Be | 0, I = E >>> 0 < I >>> 0 ? a + 1 | 0 : a, T = I << 12 | E >>> 20, Me = E << 12 | tr >>> 20, dr = t[d >> 2], E = Gn & -2, tr = dr + E | 0, Be = t[d + 4 >> 2], a = Be + (kn & 1048575) | 0, E = E >>> 0 > tr >>> 0 ? a + 1 | 0 : a, a = E + T | 0, Me = Me + tr | 0, a = Me >>> 0 < tr >>> 0 ? a + 1 | 0 : a, t[d + 440 >> 2] = -4 - Me, T = a, t[d + 444 >> 2] = 4194303 - ((a & 1048575) + (Me >>> 0 > 4294967292) | 0), L = n, or = cr & 65535, Me = (a | 0) == (E | 0) & Me >>> 0 < tr >>> 0 | a >>> 0 < E >>> 0, E = (E | 0) == (Be | 0) & tr >>> 0 < dr >>> 0 | E >>> 0 < Be >>> 0, a = d + 8 | 0, n = E + t[a >> 2] | 0, a = t[a + 4 >> 2], a = n >>> 0 < E >>> 0 ? a + 1 | 0 : a, I = I >>> 20 | 0, E = I, I = I + n | 0, a = E >>> 0 > I >>> 0 ? a + 1 | 0 : a, n = I, I = I + Me | 0, a = or + ((n >>> 0 > I >>> 0 ? a + 1 | 0 : a) << 12 | I >>> 20) | 0, E = I << 12 | T >>> 20, I = E + L | 0, t[d + 448 >> 2] = -4 - I, t[d + 452 >> 2] = 262143 - ((I >>> 0 > 4294967292) + (I >>> 0 < E >>> 0 ? a + 1 | 0 : a) | 0), gr = d + 376 | 0, I = d + 416 | 0, Xr(gr, I, Xn), Ir = d + 336 | 0, Xr(Ir, d + 656 | 0, I), Bn = d + 456 | 0, Ui(v, Bn), n = t[d + 408 >> 2], I = n + t[v + 32 >> 2] | 0, a = t[v + 36 >> 2] + t[d + 412 >> 2] | 0, n = I >>> 0 < n >>> 0 ? a + 1 | 0 : a, a = t[d + 372 >> 2], Un = a, cr = t[d + 368 >> 2], E = cr, a = (a << 1 | E >>> 31) + n | 0, E = E << 1, I = I + E | 0, a = E >>> 0 > I >>> 0 ? a + 1 | 0 : a, T = I, t[v + 32 >> 2] = I, tr = a, t[v + 36 >> 2] = a, n = t[d + 400 >> 2], I = n + t[v + 24 >> 2] | 0, a = t[v + 28 >> 2] + t[d + 404 >> 2] | 0, a = I >>> 0 < n >>> 0 ? a + 1 | 0 : a, n = I, E = a, I = t[d + 360 >> 2], Gn = I, a = t[d + 364 >> 2], kn = a, a = (a << 1 | I >>> 31) + E | 0, I = I << 1, E = I, I = I + n | 0, a = E >>> 0 > I >>> 0 ? a + 1 | 0 : a, t[v + 24 >> 2] = I, Me = a, t[v + 28 >> 2] = a, E = t[d + 392 >> 2], n = E + t[v + 16 >> 2] | 0, a = t[v + 20 >> 2] + t[d + 396 >> 2] | 0, a = n >>> 0 < E >>> 0 ? a + 1 | 0 : a, E = n, L = a, n = t[d + 352 >> 2], Mr = n, a = t[d + 356 >> 2], Wr = a, a = (a << 1 | n >>> 31) + L | 0, n = n << 1, L = n, n = n + E | 0, a = L >>> 0 > n >>> 0 ? a + 1 | 0 : a, t[v + 16 >> 2] = n, L = a, t[v + 20 >> 2] = a, Be = t[d + 384 >> 2], E = Be + t[v + 8 >> 2] | 0, a = t[v + 12 >> 2] + t[d + 388 >> 2] | 0, Be = E >>> 0 < Be >>> 0 ? a + 1 | 0 : a, a = t[d + 348 >> 2], Xn = a, gn = t[d + 344 >> 2], dr = gn, a = (a << 1 | dr >>> 31) + Be | 0, dr = dr << 1, E = E + dr | 0, a = dr >>> 0 > E >>> 0 ? a + 1 | 0 : a, Be = E, t[v + 8 >> 2] = E, dr = a, t[v + 12 >> 2] = a, or = t[d + 376 >> 2], E = or + t[v >> 2] | 0, a = t[v + 4 >> 2] + t[d + 380 >> 2] | 0, a = E >>> 0 < or >>> 0 ? a + 1 | 0 : a, or = E, xr = a, E = t[d + 336 >> 2], xn = E, a = t[d + 340 >> 2], $r = a, a = (a << 1 | E >>> 31) + xr | 0, E = E << 1, xr = E, E = E + or | 0, a = xr >>> 0 > E >>> 0 ? a + 1 | 0 : a, t[v >> 2] = E, or = a, t[v + 4 >> 2] = a, a = tr + Un | 0, T = T + cr | 0, a = T >>> 0 < cr >>> 0 ? a + 1 | 0 : a, t[d + 368 >> 2] = T, t[d + 372 >> 2] = a, a = Me + kn | 0, T = I, I = I + Gn | 0, a = T >>> 0 > I >>> 0 ? a + 1 | 0 : a, t[d + 360 >> 2] = I, t[d + 364 >> 2] = a, a = L + Wr | 0, I = n + Mr | 0, a = I >>> 0 < n >>> 0 ? a + 1 | 0 : a, t[d + 352 >> 2] = I, t[d + 356 >> 2] = a, a = dr + Xn | 0, I = Be + gn | 0, a = I >>> 0 < gn >>> 0 ? a + 1 | 0 : a, t[d + 344 >> 2] = I, t[d + 348 >> 2] = a, a = or + $r | 0, d = E + xn | 0, a = d >>> 0 < E >>> 0 ? a + 1 | 0 : a, t[he + 336 >> 2] = d, t[he + 340 >> 2] = a, Xr(v + 40 | 0, Ir, Bn), Xr(gr, gr, he + 576 | 0), a = t[v + 44 >> 2] + t[he + 380 >> 2] | 0, I = t[he + 376 >> 2], d = I + t[v + 40 >> 2] | 0, t[v + 40 >> 2] = d, t[v + 44 >> 2] = d >>> 0 < I >>> 0 ? a + 1 | 0 : a, n = t[he + 384 >> 2], d = v + 48 | 0, I = n + t[d >> 2] | 0, a = t[d + 4 >> 2] + t[he + 388 >> 2] | 0, t[d >> 2] = I, t[d + 4 >> 2] = I >>> 0 < n >>> 0 ? a + 1 | 0 : a, n = t[he + 392 >> 2], d = v + 56 | 0, I = n + t[d >> 2] | 0, a = t[d + 4 >> 2] + t[he + 396 >> 2] | 0, t[d >> 2] = I, t[d + 4 >> 2] = I >>> 0 < n >>> 0 ? a + 1 | 0 : a, n = t[he + 400 >> 2], d = v - -64 | 0, I = n + t[d >> 2] | 0, a = t[d + 4 >> 2] + t[he + 404 >> 2] | 0, t[d >> 2] = I, t[d + 4 >> 2] = I >>> 0 < n >>> 0 ? a + 1 | 0 : a, I = t[he + 408 >> 2], v = v + 72 | 0, d = I + t[v >> 2] | 0, a = t[v + 4 >> 2] + t[he + 412 >> 2] | 0, t[v >> 2] = d, t[v + 4 >> 2] = d >>> 0 < I >>> 0 ? a + 1 | 0 : a;
    }
    x = he + 736 | 0;
  }
  function zi(v, d, I) {
    var n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0, Xn = 0;
    T = x - 256 | 0, x = T, he = T + 240 | 0, Ur(he, t[I >> 2], t[I + 4 >> 2], 0, 0, t[d >> 2], t[d + 4 >> 2], 0, 0), n = t[T + 244 >> 2], t[v >> 2] = t[T + 240 >> 2], t[v + 4 >> 2] = n, Me = T + 208 | 0, Ur(Me, t[I + 8 >> 2], t[I + 12 >> 2], 0, 0, t[d >> 2], t[d + 4 >> 2], 0, 0), L = T + 224 | 0, Ur(L, t[I >> 2], t[I + 4 >> 2], 0, 0, t[d + 8 >> 2], t[d + 12 >> 2], 0, 0), dr = v, a = t[T + 208 >> 2], v = he + 8 | 0, n = t[v >> 2], cr = a + n | 0, tr = t[T + 212 >> 2], v = tr + t[v + 4 >> 2] | 0, Be = n >>> 0 > cr >>> 0 ? v + 1 | 0 : v, v = Be + t[T + 228 >> 2] | 0, n = t[T + 224 >> 2], he = n + cr | 0, t[dr + 8 >> 2] = he, E = n >>> 0 > he >>> 0 ? v + 1 | 0 : v, t[dr + 12 >> 2] = E, xr = T + 160 | 0, Ur(xr, t[I + 16 >> 2], t[I + 20 >> 2], 0, 0, t[d >> 2], t[d + 4 >> 2], 0, 0), $r = T + 176 | 0, Ur($r, t[I + 8 >> 2], t[I + 12 >> 2], 0, 0, t[d + 8 >> 2], t[d + 12 >> 2], 0, 0), Mr = T + 192 | 0, Ur(Mr, t[I >> 2], t[I + 4 >> 2], 0, 0, t[d + 16 >> 2], t[d + 20 >> 2], 0, 0), a = (Be | 0) == (tr | 0) & a >>> 0 > cr >>> 0 | Be >>> 0 < tr >>> 0, v = Me + 8 | 0, n = a + t[v >> 2] | 0, v = t[v + 4 >> 2], a = n >>> 0 < a >>> 0 ? v + 1 | 0 : v, he = (E | 0) == (Be | 0) & he >>> 0 < cr >>> 0 | E >>> 0 < Be >>> 0, v = L + 8 | 0, E = he + t[v >> 2] | 0, v = t[v + 4 >> 2], v = (E >>> 0 < he >>> 0 ? v + 1 | 0 : v) + a | 0, he = n + E | 0, v = he >>> 0 < E >>> 0 ? v + 1 | 0 : v, tr = he, he = t[T + 160 >> 2], E = tr + he | 0, gr = v, v = v + t[T + 164 >> 2] | 0, v = E >>> 0 < he >>> 0 ? v + 1 | 0 : v, he = t[T + 176 >> 2], Me = he + E | 0, Ir = v, v = v + t[T + 180 >> 2] | 0, or = he >>> 0 > Me >>> 0 ? v + 1 | 0 : v, v = or + t[T + 196 >> 2] | 0, he = t[T + 192 >> 2], Be = he + Me | 0, t[dr + 16 >> 2] = Be, L = Be >>> 0 < he >>> 0 ? v + 1 | 0 : v, t[dr + 20 >> 2] = L, Un = T + 96 | 0, Ur(Un, t[I + 24 >> 2], t[I + 28 >> 2], 0, 0, t[d >> 2], t[d + 4 >> 2], 0, 0), kn = T + 112 | 0, Ur(kn, t[I + 16 >> 2], t[I + 20 >> 2], 0, 0, t[d + 8 >> 2], t[d + 12 >> 2], 0, 0), xn = T + 128 | 0, Ur(xn, t[I + 8 >> 2], t[I + 12 >> 2], 0, 0, t[d + 16 >> 2], t[d + 20 >> 2], 0, 0), Bn = T + 144 | 0, Ur(Bn, t[I >> 2], t[I + 4 >> 2], 0, 0, t[d + 24 >> 2], t[d + 28 >> 2], 0, 0), he = (gr | 0) == (Ir | 0) & E >>> 0 < tr >>> 0 | gr >>> 0 > Ir >>> 0, v = xr + 8 | 0, cr = he + t[v >> 2] | 0, v = t[v + 4 >> 2], n = (a | 0) == (gr | 0) & n >>> 0 > tr >>> 0 | a >>> 0 > gr >>> 0, xr = cr + n | 0, v = he >>> 0 > cr >>> 0 ? v + 1 | 0 : v, he = v, a = n >>> 0 > xr >>> 0 ? v + 1 | 0 : v, tr = xr, n = (or | 0) == (Ir | 0) & E >>> 0 > Me >>> 0 | or >>> 0 < Ir >>> 0, v = $r + 8 | 0, E = n + t[v >> 2] | 0, v = t[v + 4 >> 2], v = (n >>> 0 > E >>> 0 ? v + 1 | 0 : v) + a | 0, gn = E, E = E + tr | 0, n = gn >>> 0 > E >>> 0 ? v + 1 | 0 : v, $r = E, tr = E, E = (L | 0) == (or | 0) & Be >>> 0 < Me >>> 0 | L >>> 0 < or >>> 0, v = Mr + 8 | 0, Be = E + t[v >> 2] | 0, v = t[v + 4 >> 2], v = (E >>> 0 > Be >>> 0 ? v + 1 | 0 : v) + n | 0, E = Be + tr | 0, v = E >>> 0 < Be >>> 0 ? v + 1 | 0 : v, gr = E, E = t[T + 96 >> 2], Ir = gr + E | 0, Mr = v, v = v + t[T + 100 >> 2] | 0, v = E >>> 0 > Ir >>> 0 ? v + 1 | 0 : v, E = t[T + 112 >> 2], or = E + Ir | 0, Wr = v, v = v + t[T + 116 >> 2] | 0, v = E >>> 0 > or >>> 0 ? v + 1 | 0 : v, E = t[T + 128 >> 2], L = E + or | 0, gn = v, v = v + t[T + 132 >> 2] | 0, Me = E >>> 0 > L >>> 0 ? v + 1 | 0 : v, v = Me + t[T + 148 >> 2] | 0, E = t[T + 144 >> 2], Be = E + L | 0, t[dr + 24 >> 2] = Be, v = E >>> 0 > Be >>> 0 ? v + 1 | 0 : v, t[dr + 28 >> 2] = v, Gn = T + 48 | 0, Ur(Gn, t[I + 24 >> 2], t[I + 28 >> 2], 0, 0, t[d + 8 >> 2], t[d + 12 >> 2], 0, 0), jn = T - -64 | 0, Ur(jn, t[I + 16 >> 2], t[I + 20 >> 2], 0, 0, t[d + 16 >> 2], t[d + 20 >> 2], 0, 0), Xn = T + 80 | 0, Ur(Xn, t[I + 8 >> 2], t[I + 12 >> 2], 0, 0, t[d + 24 >> 2], t[d + 28 >> 2], 0, 0), Be = (v | 0) == (Me | 0) & L >>> 0 > Be >>> 0 | v >>> 0 < Me >>> 0, v = Bn + 8 | 0, E = Be + t[v >> 2] | 0, v = t[v + 4 >> 2], Be = E >>> 0 < Be >>> 0 ? v + 1 | 0 : v, L = (Me | 0) == (gn | 0) & L >>> 0 < or >>> 0 | Me >>> 0 < gn >>> 0, v = xn + 8 | 0, tr = L + t[v >> 2] | 0, v = t[v + 4 >> 2], Me = L >>> 0 > tr >>> 0 ? v + 1 | 0 : v, L = (n | 0) == (Mr | 0) & gr >>> 0 < $r >>> 0 | n >>> 0 > Mr >>> 0, v = (n | 0) == (a | 0) & xr >>> 0 > $r >>> 0 | n >>> 0 < a >>> 0, n = (a | 0) == (he | 0) & cr >>> 0 > xr >>> 0 | a >>> 0 < he >>> 0, a = v + n | 0, v = n >>> 0 > a >>> 0, he = a + L | 0, cr = he >>> 0 < a >>> 0 ? v + 1 | 0 : v, n = (Mr | 0) == (Wr | 0) & gr >>> 0 > Ir >>> 0 | Mr >>> 0 > Wr >>> 0, v = Un + 8 | 0, a = n + t[v >> 2] | 0, v = t[v + 4 >> 2], v = (n >>> 0 > a >>> 0 ? v + 1 | 0 : v) + cr | 0, L = a, a = a + he | 0, n = L >>> 0 > a >>> 0 ? v + 1 | 0 : v, Mr = a, L = a, a = (Wr | 0) == (gn | 0) & or >>> 0 < Ir >>> 0 | Wr >>> 0 > gn >>> 0, v = kn + 8 | 0, or = a + t[v >> 2] | 0, v = t[v + 4 >> 2], v = (a >>> 0 > or >>> 0 ? v + 1 | 0 : v) + n | 0, L = L + or | 0, a = L >>> 0 < or >>> 0 ? v + 1 | 0 : v, v = a + Me | 0, gn = L, Ir = L + tr | 0, xr = L >>> 0 > Ir >>> 0 ? v + 1 | 0 : v, v = xr + Be | 0, L = E + Ir | 0, v = L >>> 0 < Ir >>> 0 ? v + 1 | 0 : v, $r = L, L = t[T + 48 >> 2], gr = $r + L | 0, Bn = v, v = v + t[T + 52 >> 2] | 0, Wr = L >>> 0 > gr >>> 0 ? v + 1 | 0 : v, v = Wr + t[T + 68 >> 2] | 0, Me = t[T + 64 >> 2], L = Me + gr | 0, tr = t[T + 80 >> 2], or = L + tr | 0, Me = L >>> 0 < Me >>> 0 ? v + 1 | 0 : v, v = Me + t[T + 84 >> 2] | 0, t[dr + 32 >> 2] = or, v = or >>> 0 < tr >>> 0 ? v + 1 | 0 : v, t[dr + 36 >> 2] = v, kn = T + 16 | 0, Ur(kn, t[I + 24 >> 2], t[I + 28 >> 2], 0, 0, t[d + 16 >> 2], t[d + 20 >> 2], 0, 0), xn = T + 32 | 0, Ur(xn, t[I + 16 >> 2], t[I + 20 >> 2], 0, 0, t[d + 24 >> 2], t[d + 28 >> 2], 0, 0), tr = (v | 0) == (Me | 0) & L >>> 0 > or >>> 0 | v >>> 0 < Me >>> 0, v = Xn + 8 | 0, or = tr + t[v >> 2] | 0, v = t[v + 4 >> 2], tr = or >>> 0 < tr >>> 0 ? v + 1 | 0 : v, L = (Me | 0) == (Wr | 0) & L >>> 0 < gr >>> 0 | Me >>> 0 < Wr >>> 0, v = jn + 8 | 0, Me = L + t[v >> 2] | 0, v = t[v + 4 >> 2], L = L >>> 0 > Me >>> 0 ? v + 1 | 0 : v, Be = (Be | 0) == (Bn | 0) & E >>> 0 > $r >>> 0 | Be >>> 0 > Bn >>> 0, E = (a | 0) == (xr | 0) & Ir >>> 0 < gn >>> 0 | a >>> 0 > xr >>> 0, v = (n | 0) == (a | 0) & Mr >>> 0 > gn >>> 0 | n >>> 0 > a >>> 0, n = (n | 0) == (cr | 0) & he >>> 0 > Mr >>> 0 | n >>> 0 < cr >>> 0, a = v + n | 0, v = n >>> 0 > a >>> 0, n = a + E | 0, v = n >>> 0 < a >>> 0 ? v + 1 | 0 : v, he = n + Be | 0, E = he >>> 0 < n >>> 0 ? v + 1 | 0 : v, n = (Wr | 0) == (Bn | 0) & gr >>> 0 < $r >>> 0 | Wr >>> 0 < Bn >>> 0, v = Gn + 8 | 0, a = n + t[v >> 2] | 0, v = t[v + 4 >> 2], v = (n >>> 0 > a >>> 0 ? v + 1 | 0 : v) + E | 0, n = a + he | 0, a = n >>> 0 < a >>> 0 ? v + 1 | 0 : v, v = a + L | 0, L = or, Ir = n, cr = n + Me | 0, or = cr, Be = L + or | 0, n = n >>> 0 > or >>> 0 ? v + 1 | 0 : v, v = n + tr | 0, cr = t[T + 16 >> 2], Me = cr + Be | 0, gr = Be >>> 0 < or >>> 0 ? v + 1 | 0 : v, v = gr + t[T + 20 >> 2] | 0, tr = Me >>> 0 < cr >>> 0 ? v + 1 | 0 : v, v = tr + t[T + 36 >> 2] | 0, L = t[T + 32 >> 2], cr = L + Me | 0, t[dr + 40 >> 2] = cr, L = L >>> 0 > cr >>> 0 ? v + 1 | 0 : v, t[dr + 44 >> 2] = L, Ur(T, t[I + 24 >> 2], t[I + 28 >> 2], 0, 0, t[d + 24 >> 2], t[d + 28 >> 2], 0, 0), I = dr, d = (tr | 0) == (gr | 0) & Be >>> 0 > Me >>> 0 | tr >>> 0 < gr >>> 0, v = kn + 8 | 0, dr = d + t[v >> 2] | 0, v = t[v + 4 >> 2], d = d >>> 0 > dr >>> 0 ? v + 1 | 0 : v, Be = (n | 0) == (gr | 0) & Be >>> 0 < or >>> 0 | n >>> 0 > gr >>> 0, v = (n | 0) == (a | 0) & or >>> 0 < Ir >>> 0 | n >>> 0 < a >>> 0, n = (a | 0) == (E | 0) & he >>> 0 > Ir >>> 0 | a >>> 0 < E >>> 0, a = v + n | 0, v = n >>> 0 > a >>> 0, he = a + Be | 0, Be = he >>> 0 < a >>> 0 ? v + 1 | 0 : v, v = Be + d | 0, d = he + dr | 0, n = d >>> 0 < he >>> 0 ? v + 1 | 0 : v, E = d, a = d, d = (L | 0) == (tr | 0) & Me >>> 0 > cr >>> 0 | L >>> 0 < tr >>> 0, v = xn + 8 | 0, dr = d + t[v >> 2] | 0, v = t[v + 4 >> 2], v = (d >>> 0 > dr >>> 0 ? v + 1 | 0 : v) + n | 0, a = a + dr | 0, d = a >>> 0 < dr >>> 0 ? v + 1 | 0 : v, v = d + t[T + 4 >> 2] | 0, dr = t[T >> 2], cr = dr + a | 0, t[I + 48 >> 2] = cr, v = dr >>> 0 > cr >>> 0 ? v + 1 | 0 : v, t[I + 52 >> 2] = v, dr = (v | 0) == (d | 0) & a >>> 0 > cr >>> 0 | v >>> 0 < d >>> 0, a = (d | 0) == (n | 0) & a >>> 0 < E >>> 0 | d >>> 0 < n >>> 0, d = (n | 0) == (Be | 0) & E >>> 0 < he >>> 0 | n >>> 0 < Be >>> 0, v = T + 8 | 0, n = d + t[v >> 2] | 0, v = t[v + 4 >> 2], v = d >>> 0 > n >>> 0 ? v + 1 | 0 : v, d = n + a | 0, v = d >>> 0 < n >>> 0 ? v + 1 | 0 : v, E = d, d = d + dr | 0, v = E >>> 0 > d >>> 0 ? v + 1 | 0 : v, t[I + 56 >> 2] = d, t[I + 60 >> 2] = v, x = T + 256 | 0;
  }
  function Gi(v, d, I, n) {
    var a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0, Ir = 0, xr = 0, Mr = 0, Wr = 0, $r = 0, gn = 0, Bn = 0, kn = 0, xn = 0, Un = 0, Gn = 0, jn = 0, Xn = 0, Zn = 0, ni = 0, ai = 0, fi = 0, Ai = 0, yi = 0, Ii = 0, wi = 0, Bi = 0, Ti = 0, Oi = 0, Hi = 0, Xi = 0, Zi = 0, ts = 0, us = 0, hs = 0, ws = 0, ks = 0, Bs = 0, gs = 0, ps = 0;
    L = x - 480 | 0, x = L, a = t[I + 4 >> 2], ni = a, Me = a >> 31, a = t[v + 4 >> 2], or = a, a = a >> 31, Ii = L + 352 | 0, Xn = t[I >> 2], T = t[v >> 2], E = a, Ur(Ii, Xn, ni, Me, Me, T, or, a, a), a = t[I + 12 >> 2], ai = a, cr = a >> 31, a = t[d + 4 >> 2], tr = a, a = a >> 31, Ti = L + 384 | 0, Ir = t[I + 8 >> 2], gr = t[d >> 2], Be = a, Ur(Ti, Ir, ai, cr, cr, gr, tr, a, a), a = t[I + 20 >> 2], xr = a, a = a >> 31, wi = L + 368 | 0, fi = t[I + 16 >> 2], kn = a, Ur(wi, fi, xr, a, a, T, or, E, E), Bi = t[I + 24 >> 2], I = t[I + 28 >> 2], Mr = I, I = I >> 31, Ai = L + 400 | 0, jn = I, Ur(Ai, Bi, Mr, I, I, gr, tr, Be, Be), ts = t[d + 32 >> 2], I = t[d + 36 >> 2], ps = I, I = I >> 31, Be = I, E = I & Ir, us = t[v + 32 >> 2], I = t[v + 36 >> 2], hs = I, I = I >> 31, a = E, or = I, E = I & Xn, I = a + E | 0, a = (or & ni) + (Be & ai) | 0, E = I >>> 0 < E >>> 0 ? a + 1 | 0 : a, a = t[n + 40 >> 2], he = a, gn = t[L + 388 >> 2], a = gn + t[L + 356 >> 2] | 0, xn = t[n + 44 >> 2], Bn = t[L + 384 >> 2], T = t[L + 352 >> 2], tr = Bn + T | 0, T = T >>> 0 > tr >>> 0 ? a + 1 | 0 : a, Un = pn(he, xn, tr, T), gr = Un + I | 0, a = E + Ee | 0, Zn = I - gr | 0, I = E - (((gr >>> 0 < Un >>> 0 ? a + 1 | 0 : a) & 1073741823) + (I >>> 0 < gr >>> 0) | 0) | 0, Un = I, dr = I >> 31, I = t[n + 4 >> 2], Wr = I, I = I >> 31, Oi = L + 320 | 0, $r = t[n >> 2], gr = I, Ur(Oi, Zn, Un, dr, dr, $r, Wr, I, I), E = or & fi, I = E + (Be & Bi) | 0, a = (Be & Mr) + (or & xr) | 0, E = I >>> 0 < E >>> 0 ? a + 1 | 0 : a, Gn = t[L + 404 >> 2], a = Gn + t[L + 372 >> 2] | 0, Hi = t[L + 400 >> 2], Be = t[L + 368 >> 2], or = Hi + Be | 0, Be = Be >>> 0 > or >>> 0 ? a + 1 | 0 : a, xn = pn(or, Be, he, xn), he = xn + I | 0, a = E + Ee | 0, yi = I - he | 0, I = E - (((he >>> 0 < xn >>> 0 ? a + 1 | 0 : a) & 1073741823) + (I >>> 0 < he >>> 0) | 0) | 0, xn = I, I = I >> 31, Xi = L + 336 | 0, Zi = I, Ur(Xi, yi, xn, I, I, $r, Wr, gr, gr), I = t[v + 12 >> 2], he = I, I = I >> 31, ws = L + 416 | 0, gr = t[v + 8 >> 2], E = I, Ur(ws, Xn, ni, Me, Me, gr, he, I, I), I = t[d + 12 >> 2], Wr = I, I = I >> 31, a = I, ks = L + 448 | 0, $r = t[d + 8 >> 2], Ur(ks, Ir, ai, cr, cr, $r, Wr, a, a), Bs = L + 432 | 0, Ur(Bs, fi, xr, kn, kn, gr, he, E, E), gs = L + 464 | 0, Ur(gs, Bi, Mr, jn, jn, $r, Wr, a, a), I = t[L + 336 >> 2], he = I, gr = t[L + 340 >> 2], a = gr + Be | 0, I = I + or | 0, a = I >>> 0 < or >>> 0 ? a + 1 | 0 : a, E = I, I = a, gr = (gr | 0) == (a | 0) & E >>> 0 < he >>> 0 | a >>> 0 < gr >>> 0, a = Xi + 8 | 0, he = t[a >> 2], $r = t[a + 4 >> 2], Be = (Be | 0) == (Gn | 0) & or >>> 0 < Hi >>> 0 | Be >>> 0 < Gn >>> 0, a = wi + 8 | 0, or = t[a >> 2], Wr = Ai + 8 | 0, E = or + t[Wr >> 2] | 0, a = t[Wr + 4 >> 2] + t[a + 4 >> 2] | 0, a = E >>> 0 < or >>> 0 ? a + 1 | 0 : a, or = E, E = E + Be | 0, a = (or >>> 0 > E >>> 0 ? a + 1 | 0 : a) + $r | 0, Be = E, E = E + he | 0, a = Be >>> 0 > E >>> 0 ? a + 1 | 0 : a, Be = E + gr | 0, E = Be >>> 0 < E >>> 0 ? a + 1 | 0 : a, or = E << 2 | Be >>> 30, gr = Be << 2 | I >>> 30, Wr = t[L + 464 >> 2], I = t[L + 432 >> 2], Be = Wr + I | 0, he = t[L + 468 >> 2], a = he + t[L + 436 >> 2] | 0, I = I >>> 0 > Be >>> 0 ? a + 1 | 0 : a, a = I + or | 0, or = Be + gr | 0, gr = or >>> 0 < Be >>> 0 ? a + 1 | 0 : a, $r = (I | 0) == (gr | 0) & Be >>> 0 > or >>> 0 | I >>> 0 > gr >>> 0, Be = (I | 0) == (he | 0) & Be >>> 0 < Wr >>> 0 | I >>> 0 < he >>> 0, a = Bs + 8 | 0, he = t[a >> 2], Wr = gs + 8 | 0, I = he + t[Wr >> 2] | 0, a = t[Wr + 4 >> 2] + t[a + 4 >> 2] | 0, a = I >>> 0 < he >>> 0 ? a + 1 | 0 : a, he = I, I = I + Be | 0, a = (E >> 31) + (he >>> 0 > I >>> 0 ? a + 1 | 0 : a) | 0, E = E >> 30, I = I + E | 0, a = E >>> 0 > I >>> 0 ? a + 1 | 0 : a, Be = I + $r | 0, I = Be >>> 0 < I >>> 0 ? a + 1 | 0 : a, E = t[L + 320 >> 2], Wr = E, $r = t[L + 324 >> 2], a = $r + T | 0, E = E + tr | 0, a = E >>> 0 < tr >>> 0 ? a + 1 | 0 : a, he = E, E = a, he = ($r | 0) == (a | 0) & he >>> 0 < Wr >>> 0 | a >>> 0 < $r >>> 0, a = Oi + 8 | 0, $r = t[a >> 2], Wr = t[a + 4 >> 2], tr = (T | 0) == (gn | 0) & tr >>> 0 < Bn >>> 0 | T >>> 0 < gn >>> 0, a = Ii + 8 | 0, gn = t[a >> 2], Gn = Ti + 8 | 0, T = gn + t[Gn >> 2] | 0, a = t[Gn + 4 >> 2] + t[a + 4 >> 2] | 0, a = T >>> 0 < gn >>> 0 ? a + 1 | 0 : a, Bn = T, T = T + tr | 0, a = (Bn >>> 0 > T >>> 0 ? a + 1 | 0 : a) + Wr | 0, tr = T, T = T + $r | 0, a = tr >>> 0 > T >>> 0 ? a + 1 | 0 : a, tr = T + he | 0, T = tr >>> 0 < T >>> 0 ? a + 1 | 0 : a, he = T << 2 | tr >>> 30, tr = tr << 2 | E >>> 30, Wr = t[L + 448 >> 2], gn = t[L + 416 >> 2], E = Wr + gn | 0, $r = t[L + 452 >> 2], a = $r + t[L + 420 >> 2] | 0, a = E >>> 0 < gn >>> 0 ? a + 1 | 0 : a, gn = E, E = a, a = a + he | 0, he = tr + gn | 0, tr = he >>> 0 < gn >>> 0 ? a + 1 | 0 : a, Gn = (E | 0) == (tr | 0) & he >>> 0 < gn >>> 0 | E >>> 0 > tr >>> 0, gn = (E | 0) == ($r | 0) & Wr >>> 0 > gn >>> 0 | E >>> 0 < $r >>> 0, a = ws + 8 | 0, $r = t[a >> 2], Wr = ks + 8 | 0, E = $r + t[Wr >> 2] | 0, a = t[Wr + 4 >> 2] + t[a + 4 >> 2] | 0, a = E >>> 0 < $r >>> 0 ? a + 1 | 0 : a, Wr = E, E = E + gn | 0, a = (T >> 31) + (Wr >>> 0 > E >>> 0 ? a + 1 | 0 : a) | 0, T = T >> 30, E = E + T | 0, a = T >>> 0 > E >>> 0 ? a + 1 | 0 : a, T = E + Gn | 0, E = T >>> 0 < E >>> 0 ? a + 1 | 0 : a, gn = t[d + 24 >> 2], $r = t[d + 28 >> 2], Wr = t[d + 16 >> 2], Gn = t[d + 20 >> 2], Ii = t[v + 24 >> 2], Ti = t[v + 28 >> 2], wi = t[v + 16 >> 2], Ai = t[v + 20 >> 2], a = t[n + 8 >> 2], Bn = t[n + 12 >> 2], a | Bn && (Xi = L + 304 | 0, Hi = a, a = Bn >> 31, Ur(Xi, Zn, Un, dr, dr, Hi, Bn, a, a), Oi = L + 288 | 0, Ur(Oi, yi, xn, Zi, Zi, Hi, Bn, a, a), dr = gr, Bn = or, gr = t[L + 288 >> 2], or = or + gr | 0, a = dr + t[L + 292 >> 2] | 0, gr = or >>> 0 < gr >>> 0 ? a + 1 | 0 : a, dr = (dr | 0) == (gr | 0) & or >>> 0 < Bn >>> 0 | dr >>> 0 > gr >>> 0, a = Oi + 8 | 0, Bn = t[a >> 2], Be = Bn + Be | 0, a = I + t[a + 4 >> 2] | 0, a = Be >>> 0 < Bn >>> 0 ? a + 1 | 0 : a, I = Be, Be = Be + dr | 0, I = I >>> 0 > Be >>> 0 ? a + 1 | 0 : a, dr = tr, Bn = he, tr = t[L + 304 >> 2], he = he + tr | 0, a = dr + t[L + 308 >> 2] | 0, tr = he >>> 0 < tr >>> 0 ? a + 1 | 0 : a, dr = (dr | 0) == (tr | 0) & he >>> 0 < Bn >>> 0 | tr >>> 0 < dr >>> 0, a = Xi + 8 | 0, Bn = t[a >> 2], T = Bn + T | 0, a = E + t[a + 4 >> 2] | 0, a = T >>> 0 < Bn >>> 0 ? a + 1 | 0 : a, E = T, T = T + dr | 0, E = E >>> 0 > T >>> 0 ? a + 1 | 0 : a), t[v >> 2] = he, t[v + 4 >> 2] = tr & 1073741823, t[d >> 2] = or, t[d + 4 >> 2] = gr & 1073741823, a = Ai >> 31, he = a, Bn = L + 272 | 0, dr = Xn, Ur(Bn, dr, ni, Me, Me, wi, Ai, a, a), Zi = L + 240 | 0, Xn = Ir, Me = cr, Ir = Gn, a = Ir >> 31, Ur(Zi, Xn, ai, Me, Me, Wr, Ir, a, a), cr = L + 256 | 0, Ur(cr, fi, xr, kn, kn, wi, Ai, he, he), Ir = L + 224 | 0, Ur(Ir, Bi, Mr, jn, jn, Wr, Gn, a, a), kn = t[L + 224 >> 2], he = t[L + 256 >> 2], or = kn + he | 0, Me = t[L + 228 >> 2], a = Me + t[L + 260 >> 2] | 0, he = he >>> 0 > or >>> 0 ? a + 1 | 0 : a, kn = (Me | 0) == (he | 0) & or >>> 0 < kn >>> 0 | he >>> 0 < Me >>> 0, a = cr + 8 | 0, cr = t[a >> 2], Ir = Ir + 8 | 0, Me = cr + t[Ir >> 2] | 0, a = t[Ir + 4 >> 2] + t[a + 4 >> 2] | 0, a = Me >>> 0 < cr >>> 0 ? a + 1 | 0 : a, cr = Me, Me = Me + kn | 0, a = (I >> 31) + (cr >>> 0 > Me >>> 0 ? a + 1 | 0 : a) | 0, Ir = I >> 30, Me = Me + Ir | 0, a = Ir >>> 0 > Me >>> 0 ? a + 1 | 0 : a, cr = Me, Me = a, a = I << 2 | Be >>> 30, I = Be << 2 | gr >>> 30, Be = I + or | 0, a = a + he | 0, I = I >>> 0 > Be >>> 0 ? a + 1 | 0 : a, gr = (he | 0) == (I | 0) & Be >>> 0 < or >>> 0 | I >>> 0 < he >>> 0, or = gr + cr | 0, a = Me, gr = or >>> 0 < gr >>> 0 ? a + 1 | 0 : a, Ir = t[L + 240 >> 2], Me = t[L + 272 >> 2], he = Ir + Me | 0, cr = t[L + 244 >> 2], a = cr + t[L + 276 >> 2] | 0, Me = he >>> 0 < Me >>> 0 ? a + 1 | 0 : a, Ir = (cr | 0) == (Me | 0) & he >>> 0 < Ir >>> 0 | Me >>> 0 < cr >>> 0, a = Bn + 8 | 0, kn = t[a >> 2], jn = Zi + 8 | 0, cr = kn + t[jn >> 2] | 0, a = t[jn + 4 >> 2] + t[a + 4 >> 2] | 0, a = cr >>> 0 < kn >>> 0 ? a + 1 | 0 : a, Wr = cr, cr = cr + Ir | 0, a = (E >> 31) + (Wr >>> 0 > cr >>> 0 ? a + 1 | 0 : a) | 0, kn = E >> 30, cr = cr + kn | 0, a = kn >>> 0 > cr >>> 0 ? a + 1 | 0 : a, Ir = cr, cr = a, a = E << 2 | T >>> 30, E = T << 2 | tr >>> 30, T = E + he | 0, a = a + Me | 0, E = E >>> 0 > T >>> 0 ? a + 1 | 0 : a, he = (Me | 0) == (E | 0) & T >>> 0 < he >>> 0 | E >>> 0 < Me >>> 0, tr = he + Ir | 0, a = cr, he = he >>> 0 > tr >>> 0 ? a + 1 | 0 : a, cr = t[n + 16 >> 2], Ir = t[n + 20 >> 2], cr | Ir && (a = Ir >> 31, kn = L + 208 | 0, Me = a, a = Un >> 31, Ur(kn, cr, Ir, Me, Me, Zn, Un, a, a), jn = L + 192 | 0, a = xn >> 31, Ur(jn, cr, Ir, Me, Me, yi, xn, a, a), Me = t[L + 196 >> 2], a = Me + I | 0, I = Be, cr = t[L + 192 >> 2], Be = cr + Be | 0, I = I >>> 0 > Be >>> 0 ? a + 1 | 0 : a, cr = (Me | 0) == (I | 0) & Be >>> 0 < cr >>> 0 | I >>> 0 < Me >>> 0, a = jn + 8 | 0, Me = t[a >> 2] + or | 0, a = t[a + 4 >> 2] + gr | 0, a = or >>> 0 > Me >>> 0 ? a + 1 | 0 : a, or = Me + cr | 0, gr = or >>> 0 < Me >>> 0 ? a + 1 | 0 : a, Me = t[L + 212 >> 2], a = Me + E | 0, E = T, cr = t[L + 208 >> 2], T = cr + T | 0, E = E >>> 0 > T >>> 0 ? a + 1 | 0 : a, cr = (Me | 0) == (E | 0) & T >>> 0 < cr >>> 0 | E >>> 0 < Me >>> 0, a = kn + 8 | 0, Me = t[a >> 2] + tr | 0, a = t[a + 4 >> 2] + he | 0, a = tr >>> 0 > Me >>> 0 ? a + 1 | 0 : a, tr = Me + cr | 0, he = tr >>> 0 < Me >>> 0 ? a + 1 | 0 : a), t[v + 8 >> 2] = T, t[v + 12 >> 2] = E & 1073741823, t[d + 8 >> 2] = Be, t[d + 12 >> 2] = I & 1073741823, a = ni >> 31, Me = a, a = Ti >> 31, wi = L + 176 | 0, Ir = dr, Be = a, Ur(wi, dr, ni, Me, Me, Ii, Ti, a, a), a = ai >> 31, cr = a, a = $r >> 31, Ai = L + 144 | 0, T = a, Ur(Ai, Xn, ai, cr, cr, gn, $r, a, a), a = xr, kn = a, a = a >> 31, Bn = L + 160 | 0, jn = a, Ur(Bn, fi, xr, a, a, Ii, Ti, Be, Be), a = Mr, Wr = a, a = a >> 31, Ii = L + 128 | 0, Gn = a, Ur(Ii, Bi, Mr, a, a, gn, $r, T, T), Mr = t[L + 128 >> 2], Be = t[L + 160 >> 2], T = Mr + Be | 0, xr = t[L + 132 >> 2], a = xr + t[L + 164 >> 2] | 0, Be = T >>> 0 < Be >>> 0 ? a + 1 | 0 : a, dr = gr << 2 | or >>> 30, I = or << 2 | I >>> 30, or = I + T | 0, a = Be + dr | 0, I = I >>> 0 > or >>> 0 ? a + 1 | 0 : a, a = Be, Be = or, dr = (I | 0) == (a | 0) & T >>> 0 > Be >>> 0 | I >>> 0 < a >>> 0, or = (a | 0) == (xr | 0) & T >>> 0 < Mr >>> 0 | a >>> 0 < xr >>> 0, a = Bn + 8 | 0, xr = t[a >> 2], Mr = Ii + 8 | 0, T = xr + t[Mr >> 2] | 0, a = t[Mr + 4 >> 2] + t[a + 4 >> 2] | 0, a = T >>> 0 < xr >>> 0 ? a + 1 | 0 : a, Mr = T, T = T + or | 0, a = (gr >> 31) + (Mr >>> 0 > T >>> 0 ? a + 1 | 0 : a) | 0, gr = gr >> 30, T = T + gr | 0, a = gr >>> 0 > T >>> 0 ? a + 1 | 0 : a, or = T + dr | 0, gr = or >>> 0 < T >>> 0 ? a + 1 | 0 : a, gn = t[L + 144 >> 2], T = t[L + 176 >> 2], dr = gn + T | 0, Mr = t[L + 148 >> 2], a = Mr + t[L + 180 >> 2] | 0, T = T >>> 0 > dr >>> 0 ? a + 1 | 0 : a, xr = he << 2 | tr >>> 30, E = tr << 2 | E >>> 30, tr = E + dr | 0, a = T + xr | 0, E = E >>> 0 > tr >>> 0 ? a + 1 | 0 : a, a = T, T = tr, xr = (E | 0) == (a | 0) & dr >>> 0 > T >>> 0 | a >>> 0 > E >>> 0, dr = (a | 0) == (Mr | 0) & dr >>> 0 < gn >>> 0 | a >>> 0 < Mr >>> 0, a = wi + 8 | 0, Mr = t[a >> 2], gn = Ai + 8 | 0, tr = Mr + t[gn >> 2] | 0, a = t[gn + 4 >> 2] + t[a + 4 >> 2] | 0, a = tr >>> 0 < Mr >>> 0 ? a + 1 | 0 : a, Mr = tr, tr = tr + dr | 0, a = (he >> 31) + (Mr >>> 0 > tr >>> 0 ? a + 1 | 0 : a) | 0, he = he >> 30, tr = he + tr | 0, a = he >>> 0 > tr >>> 0 ? a + 1 | 0 : a, he = tr, tr = tr + xr | 0, he = he >>> 0 > tr >>> 0 ? a + 1 | 0 : a, xr = t[n + 24 >> 2], Mr = t[n + 28 >> 2], xr | Mr && (a = Mr >> 31, gn = L + 112 | 0, dr = a, a = Un >> 31, Ur(gn, xr, Mr, dr, dr, Zn, Un, a, a), $r = L + 96 | 0, a = xn >> 31, Ur($r, xr, Mr, dr, dr, yi, xn, a, a), dr = t[L + 100 >> 2], a = dr + I | 0, I = Be, xr = t[L + 96 >> 2], Be = xr + Be | 0, I = I >>> 0 > Be >>> 0 ? a + 1 | 0 : a, xr = (dr | 0) == (I | 0) & Be >>> 0 < xr >>> 0 | I >>> 0 < dr >>> 0, a = $r + 8 | 0, dr = t[a >> 2] + or | 0, a = t[a + 4 >> 2] + gr | 0, a = or >>> 0 > dr >>> 0 ? a + 1 | 0 : a, or = dr + xr | 0, gr = or >>> 0 < dr >>> 0 ? a + 1 | 0 : a, dr = t[L + 116 >> 2], a = dr + E | 0, E = T, xr = t[L + 112 >> 2], T = xr + T | 0, E = E >>> 0 > T >>> 0 ? a + 1 | 0 : a, xr = (dr | 0) == (E | 0) & T >>> 0 < xr >>> 0 | E >>> 0 < dr >>> 0, a = gn + 8 | 0, dr = t[a >> 2] + tr | 0, a = t[a + 4 >> 2] + he | 0, a = tr >>> 0 > dr >>> 0 ? a + 1 | 0 : a, tr = dr + xr | 0, he = tr >>> 0 < dr >>> 0 ? a + 1 | 0 : a), t[v + 16 >> 2] = T, t[v + 20 >> 2] = E & 1073741823, t[d + 16 >> 2] = Be, t[d + 20 >> 2] = I & 1073741823, a = hs >> 31, T = a, xr = L + 80 | 0, Mr = hs, Ur(xr, Ir, ni, Me, Me, us, Mr, a, a), ni = L + 48 | 0, Me = cr, Ir = ps, a = Ir >> 31, Ur(ni, Xn, ai, Me, Me, ts, Ir, a, a), Xn = L - -64 | 0, Ur(Xn, fi, kn, jn, jn, us, Mr, T, T), ai = L + 32 | 0, Ur(ai, Bi, Wr, Gn, Gn, ts, Ir, a, a), Be = t[n + 32 >> 2], n = t[n + 36 >> 2], T = n, n = T >> 31, a = Un >> 31, Ur(L, Be, T, n, n, Zn, Un, a, a), Ir = L + 16 | 0, a = xn >> 31, Ur(Ir, Be, T, n, n, yi, xn, a, a), Be = v, Mr = t[L + 48 >> 2], v = t[L + 80 >> 2], n = Mr + v | 0, cr = t[L + 52 >> 2], a = cr + t[L + 84 >> 2] | 0, v = v >>> 0 > n >>> 0 ? a + 1 | 0 : a, Un = n, E = tr << 2 | E >>> 30, n = n + E | 0, a = v + (he << 2 | tr >>> 30) | 0, T = n >>> 0 < E >>> 0 ? a + 1 | 0 : a, a = T + t[L + 4 >> 2] | 0, Zn = n, n = t[L >> 2], E = Zn + n | 0, Me = E, t[Be + 24 >> 2] = E, n = n >>> 0 > E >>> 0 ? a + 1 | 0 : a, t[Be + 28 >> 2] = n & 1073741823, E = d, d = or << 2 | I >>> 30, or = gr << 2 | or >>> 30, fi = t[L + 32 >> 2], I = t[L + 64 >> 2], tr = fi + I | 0, dr = t[L + 36 >> 2], a = dr + t[L + 68 >> 2] | 0, I = I >>> 0 > tr >>> 0 ? a + 1 | 0 : a, a = I + or | 0, d = d + tr | 0, or = d >>> 0 < tr >>> 0 ? a + 1 | 0 : a, a = or + t[L + 20 >> 2] | 0, xn = d, d = t[L + 16 >> 2], yi = xn + d | 0, t[E + 24 >> 2] = yi, d = d >>> 0 > yi >>> 0 ? a + 1 | 0 : a, t[E + 28 >> 2] = d & 1073741823, Me = (n | 0) == (T | 0) & Me >>> 0 < Zn >>> 0 | n >>> 0 < T >>> 0, a = L + 8 | 0, Bi = t[a >> 2], kn = t[a + 4 >> 2], Zn = (v | 0) == (T | 0) & Un >>> 0 > Zn >>> 0 | v >>> 0 > T >>> 0, T = (v | 0) == (cr | 0) & Mr >>> 0 > Un >>> 0 | v >>> 0 < cr >>> 0, a = xr + 8 | 0, Un = t[a >> 2], cr = ni + 8 | 0, v = Un + t[cr >> 2] | 0, a = t[cr + 4 >> 2] + t[a + 4 >> 2] | 0, a = v >>> 0 < Un >>> 0 ? a + 1 | 0 : a, cr = v, v = v + T | 0, a = (he >> 31) + (cr >>> 0 > v >>> 0 ? a + 1 | 0 : a) | 0, he = he >> 30, v = v + he | 0, a = he >>> 0 > v >>> 0 ? a + 1 | 0 : a, T = v, v = v + Zn | 0, a = (T >>> 0 > v >>> 0 ? a + 1 | 0 : a) + kn | 0, T = v, v = v + Bi | 0, a = T >>> 0 > v >>> 0 ? a + 1 | 0 : a, T = v, v = v + Me | 0, T = (T >>> 0 > v >>> 0 ? a + 1 | 0 : a) << 2 | v >>> 30, t[Be + 32 >> 2] = v << 2 | n >>> 30, t[Be + 36 >> 2] = T, Be = (d | 0) == (or | 0) & xn >>> 0 > yi >>> 0 | d >>> 0 < or >>> 0, v = Ir + 8 | 0, T = t[v >> 2], he = t[v + 4 >> 2], or = (I | 0) == (or | 0) & tr >>> 0 > xn >>> 0 | I >>> 0 > or >>> 0, I = (I | 0) == (dr | 0) & tr >>> 0 < fi >>> 0 | I >>> 0 < dr >>> 0, n = Xn + 8 | 0, tr = t[n >> 2], a = ai + 8 | 0, v = tr + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[n + 4 >> 2] | 0, a = v >>> 0 < tr >>> 0 ? a + 1 | 0 : a, n = v, v = v + I | 0, a = (gr >> 31) + (n >>> 0 > v >>> 0 ? a + 1 | 0 : a) | 0, n = gr >> 30, v = v + n | 0, a = n >>> 0 > v >>> 0 ? a + 1 | 0 : a, I = v, v = v + or | 0, a = (I >>> 0 > v >>> 0 ? a + 1 | 0 : a) + he | 0, I = v, v = v + T | 0, a = I >>> 0 > v >>> 0 ? a + 1 | 0 : a, I = v, v = v + Be | 0, I = (I >>> 0 > v >>> 0 ? a + 1 | 0 : a) << 2 | v >>> 30, t[E + 32 >> 2] = v << 2 | d >>> 30, t[E + 36 >> 2] = I, x = L + 480 | 0;
  }
  function Vi(v, d) {
    var I = 0, n = 0, a = 0;
    I = d;
    e: {
      if (d >>> 0 <= 15) {
        d = v;
        break e;
      }
      if (n = 0 - v & 3, a = n + v | 0, n)
        for (d = v; u[d | 0] = 0, d = d + 1 | 0, a >>> 0 > d >>> 0; )
          ;
      if (I = I - n | 0, n = I & -4, d = n + a | 0, (n | 0) > 0)
        for (; t[a >> 2] = 0, a = a + 4 | 0, a >>> 0 < d >>> 0; )
          ;
      I = I & 3;
    }
    if (I)
      for (I = d + I | 0; u[d | 0] = 0, d = d + 1 | 0, I >>> 0 > d >>> 0; )
        ;
    return v;
  }
  function Ur(v, d, I, n, a, E, T, L, he) {
    var Be = 0, Me = 0, tr = 0, or = 0, cr = 0, dr = 0, gr = 0;
    Be = pn(E, 0, d, 0), or = v, Me = Ee, gr = d, d = pn(d, 0, T, 0), tr = Ee, cr = pn(E, 0, I, 0), dr = Ee, v = tr + dr | 0, tr = d + cr | 0, d = tr >>> 0 < cr >>> 0 ? v + 1 | 0 : v, v = Me + tr | 0, v = 0 > Be >>> 0 ? v + 1 | 0 : v, t[or >> 2] = Be, t[or + 4 >> 2] = v, Me = (v | 0) == (Me | 0) & Be >>> 0 < Be >>> 0 | v >>> 0 < Me >>> 0, v = (d | 0) == (dr | 0) & tr >>> 0 < cr >>> 0 | d >>> 0 < dr >>> 0, Be = d, d = d + pn(I, 0, T, 0) | 0, v = Ee + v | 0, v = d >>> 0 < Be >>> 0 ? v + 1 | 0 : v, Be = d, d = d + Me | 0, Be = Be >>> 0 > d >>> 0 ? v + 1 | 0 : v, v = pn(gr, I, L, he), L = Ee, n = pn(n, a, E, T), I = n + v | 0, v = L + Ee | 0, v = (I >>> 0 < n >>> 0 ? v + 1 | 0 : v) + Be | 0, d = d + I | 0, v = d >>> 0 < I >>> 0 ? v + 1 | 0 : v, t[or + 8 >> 2] = d, t[or + 12 >> 2] = v;
  }
  function $i(v, d, I) {
    var n = 0, a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0, Me = 0;
    T = I;
    e: {
      if (I >>> 0 <= 15) {
        I = v;
        break e;
      }
      if (E = 0 - v & 3, a = E + v | 0, E)
        for (I = v, n = d; u[I | 0] = l[n | 0], n = n + 1 | 0, I = I + 1 | 0, a >>> 0 > I >>> 0; )
          ;
      T = T - E | 0, L = T & -4, I = L + a | 0, E = d + E | 0, n = E & 3;
      t: {
        if (n) {
          if ((L | 0) <= 0)
            break t;
          for (he = E & -4, d = he + 4 | 0, Be = n << 3, Me = 0 - Be & 24, n = t[he >> 2]; he = n >>> Be | 0, n = t[d >> 2], t[a >> 2] = he | n << Me, d = d + 4 | 0, a = a + 4 | 0, a >>> 0 < I >>> 0; )
            ;
          break t;
        }
        if ((L | 0) <= 0)
          break t;
        for (d = E; t[a >> 2] = t[d >> 2], d = d + 4 | 0, a = a + 4 | 0, a >>> 0 < I >>> 0; )
          ;
      }
      T = T & 3, d = E + L | 0;
    }
    if (T)
      for (n = I + T | 0; u[I | 0] = l[d | 0], d = d + 1 | 0, I = I + 1 | 0, n >>> 0 > I >>> 0; )
        ;
    return v;
  }
  function Es(v, d) {
    var I = 0, n = 0;
    return v | d ? (I = d - 1 | 0, n = v - 1 | 0, I = (n | 0) != -1 ? I + 1 | 0 : I, n = v ^ n, v = k(d ^ I), (v | 0) == 32 && (v = k(n) + 32 | 0), Ee = 0 - (v >>> 0 > 63) | 0, 63 - v | 0) : (Ee = 0, 64);
  }
  function pn(v, d, I, n) {
    var a = 0, E = 0, T = 0, L = 0, he = 0, Be = 0;
    return a = I & 65535, E = v & 65535, T = b(a, E), L = I >>> 16 | 0, Be = b(E, L), he = v >>> 16 | 0, E = b(a, he) + (T >>> 16 | 0) | 0, a = Be + (E & 65535) | 0, Ee = (b(d, I) + b(L, he) | 0) + b(v, n) + (E >>> 16) + (a >>> 16) | 0, T & 65535 | a << 16;
  }
  function Nr(v, d) {
    var I = 0, n = 0;
    return I = d & 31, n = (-1 >>> I & v) << I, I = v, v = 0 - d & 31, n | (I & -1 << v) >>> v;
  }
  bufferView = l, initActiveSegments();
  var Qn = [null, Se, He, Ce, Kn, yn, dn];
  function zn() {
    return A.byteLength / 65536 | 0;
  }
  function ti(v) {
    v = v | 0;
    var d = zn() | 0, I = d + v | 0;
    if (d < I && I < 65536) {
      var n = new ArrayBuffer(b(I, 65536)), a = new Int8Array(n);
      a.set(u), u = new Int8Array(n), p = new Int16Array(n), t = new Int32Array(n), l = new Uint8Array(n), m = new Uint16Array(n), A = n, bufferView = l;
    }
    return d;
  }
  return {
    memory: Object.create(Object.prototype, {
      grow: {
        value: ti
      },
      buffer: {
        get: function() {
          return A;
        }
      }
    }),
    initializeContext: er,
    isPoint: ir,
    PUBLIC_KEY_INPUT: {
      get value() {
        return M;
      },
      set value(v) {
        M = v;
      }
    },
    pointAdd: sr,
    PUBLIC_KEY_INPUT2: {
      get value() {
        return F;
      },
      set value(v) {
        F = v;
      }
    },
    pointAddScalar: nr,
    TWEAK_INPUT: {
      get value() {
        return le;
      },
      set value(v) {
        le = v;
      }
    },
    xOnlyPointAddTweak: fr,
    X_ONLY_PUBLIC_KEY_INPUT: {
      get value() {
        return ge;
      },
      set value(v) {
        ge = v;
      }
    },
    xOnlyPointAddTweakCheck: lr,
    X_ONLY_PUBLIC_KEY_INPUT2: {
      get value() {
        return pe;
      },
      set value(v) {
        pe = v;
      }
    },
    pointCompress: br,
    pointFromScalar: Br,
    PRIVATE_INPUT: {
      get value() {
        return Ie;
      },
      set value(v) {
        Ie = v;
      }
    },
    xOnlyPointFromScalar: Fr,
    xOnlyPointFromPoint: Gr,
    pointMultiply: qr,
    privateAdd: Hr,
    privateSub: un,
    privateNegate: Dr,
    sign: wr,
    HASH_INPUT: {
      get value() {
        return be;
      },
      set value(v) {
        be = v;
      }
    },
    EXTRA_DATA_INPUT: {
      get value() {
        return Pe;
      },
      set value(v) {
        Pe = v;
      }
    },
    SIGNATURE_INPUT: {
      get value() {
        return Te;
      },
      set value(v) {
        Te = v;
      }
    },
    signRecoverable: yr,
    signSchnorr: Qr,
    verify: _r,
    recover: Jr,
    verifySchnorr: fn,
    rustsecp256k1_v0_8_1_default_error_callback_fn: dn,
    rustsecp256k1_v0_8_1_default_illegal_callback_fn: dn,
    __data_end: {
      get value() {
        return Qe;
      },
      set value(v) {
        Qe = v;
      }
    },
    __heap_base: {
      get value() {
        return xe;
      },
      set value(v) {
        xe = v;
      }
    }
  };
}
var retasmFunc = asmFunc({
  "./rand.js": $_rand_js,
  "./validate_error.js": $_validate_error_js
}), memory = retasmFunc.memory, initializeContext = retasmFunc.initializeContext, isPoint$1 = retasmFunc.isPoint, PUBLIC_KEY_INPUT$1 = retasmFunc.PUBLIC_KEY_INPUT, pointAdd$1 = retasmFunc.pointAdd, PUBLIC_KEY_INPUT2$1 = retasmFunc.PUBLIC_KEY_INPUT2, pointAddScalar$1 = retasmFunc.pointAddScalar, TWEAK_INPUT$1 = retasmFunc.TWEAK_INPUT, xOnlyPointAddTweak$1 = retasmFunc.xOnlyPointAddTweak, X_ONLY_PUBLIC_KEY_INPUT$1 = retasmFunc.X_ONLY_PUBLIC_KEY_INPUT, xOnlyPointAddTweakCheck$1 = retasmFunc.xOnlyPointAddTweakCheck, X_ONLY_PUBLIC_KEY_INPUT2$1 = retasmFunc.X_ONLY_PUBLIC_KEY_INPUT2, pointCompress$1 = retasmFunc.pointCompress, pointFromScalar$1 = retasmFunc.pointFromScalar, PRIVATE_INPUT = retasmFunc.PRIVATE_INPUT, xOnlyPointFromScalar$1 = retasmFunc.xOnlyPointFromScalar, xOnlyPointFromPoint$1 = retasmFunc.xOnlyPointFromPoint, pointMultiply$1 = retasmFunc.pointMultiply, privateAdd$1 = retasmFunc.privateAdd, privateSub$1 = retasmFunc.privateSub, privateNegate$1 = retasmFunc.privateNegate, sign$1 = retasmFunc.sign, HASH_INPUT$1 = retasmFunc.HASH_INPUT, EXTRA_DATA_INPUT$1 = retasmFunc.EXTRA_DATA_INPUT, SIGNATURE_INPUT$1 = retasmFunc.SIGNATURE_INPUT, signRecoverable$1 = retasmFunc.signRecoverable, signSchnorr$2 = retasmFunc.signSchnorr, verify$1 = retasmFunc.verify, recover$1 = retasmFunc.recover, verifySchnorr$1 = retasmFunc.verifySchnorr, rustsecp256k1_v0_8_1_default_error_callback_fn = retasmFunc.rustsecp256k1_v0_8_1_default_error_callback_fn, rustsecp256k1_v0_8_1_default_illegal_callback_fn = retasmFunc.rustsecp256k1_v0_8_1_default_illegal_callback_fn, __data_end = retasmFunc.__data_end, __heap_base = retasmFunc.__heap_base;
const wasm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EXTRA_DATA_INPUT: EXTRA_DATA_INPUT$1,
  HASH_INPUT: HASH_INPUT$1,
  PRIVATE_INPUT,
  PUBLIC_KEY_INPUT: PUBLIC_KEY_INPUT$1,
  PUBLIC_KEY_INPUT2: PUBLIC_KEY_INPUT2$1,
  SIGNATURE_INPUT: SIGNATURE_INPUT$1,
  TWEAK_INPUT: TWEAK_INPUT$1,
  X_ONLY_PUBLIC_KEY_INPUT: X_ONLY_PUBLIC_KEY_INPUT$1,
  X_ONLY_PUBLIC_KEY_INPUT2: X_ONLY_PUBLIC_KEY_INPUT2$1,
  __data_end,
  __heap_base,
  initializeContext,
  isPoint: isPoint$1,
  memory,
  pointAdd: pointAdd$1,
  pointAddScalar: pointAddScalar$1,
  pointCompress: pointCompress$1,
  pointFromScalar: pointFromScalar$1,
  pointMultiply: pointMultiply$1,
  privateAdd: privateAdd$1,
  privateNegate: privateNegate$1,
  privateSub: privateSub$1,
  recover: recover$1,
  rustsecp256k1_v0_8_1_default_error_callback_fn,
  rustsecp256k1_v0_8_1_default_illegal_callback_fn,
  sign: sign$1,
  signRecoverable: signRecoverable$1,
  signSchnorr: signSchnorr$2,
  verify: verify$1,
  verifySchnorr: verifySchnorr$1,
  xOnlyPointAddTweak: xOnlyPointAddTweak$1,
  xOnlyPointAddTweakCheck: xOnlyPointAddTweakCheck$1,
  xOnlyPointFromPoint: xOnlyPointFromPoint$1,
  xOnlyPointFromScalar: xOnlyPointFromScalar$1
}, Symbol.toStringTag, { value: "Module" })), WASM_BUFFER = new Uint8Array(wasm.memory.buffer), WASM_PRIVATE_KEY_PTR = wasm.PRIVATE_INPUT.value, WASM_PUBLIC_KEY_INPUT_PTR = wasm.PUBLIC_KEY_INPUT.value, WASM_PUBLIC_KEY_INPUT_PTR2 = wasm.PUBLIC_KEY_INPUT2.value, WASM_X_ONLY_PUBLIC_KEY_INPUT_PTR = wasm.X_ONLY_PUBLIC_KEY_INPUT.value, WASM_X_ONLY_PUBLIC_KEY_INPUT2_PTR = wasm.X_ONLY_PUBLIC_KEY_INPUT2.value, WASM_TWEAK_INPUT_PTR = wasm.TWEAK_INPUT.value, WASM_HASH_INPUT_PTR = wasm.HASH_INPUT.value, WASM_EXTRA_DATA_INPUT_PTR = wasm.EXTRA_DATA_INPUT.value, WASM_SIGNATURE_INPUT_PTR = wasm.SIGNATURE_INPUT.value, PRIVATE_KEY_INPUT = WASM_BUFFER.subarray(WASM_PRIVATE_KEY_PTR, WASM_PRIVATE_KEY_PTR + PRIVATE_KEY_SIZE), PUBLIC_KEY_INPUT = WASM_BUFFER.subarray(WASM_PUBLIC_KEY_INPUT_PTR, WASM_PUBLIC_KEY_INPUT_PTR + PUBLIC_KEY_UNCOMPRESSED_SIZE), PUBLIC_KEY_INPUT2 = WASM_BUFFER.subarray(WASM_PUBLIC_KEY_INPUT_PTR2, WASM_PUBLIC_KEY_INPUT_PTR2 + PUBLIC_KEY_UNCOMPRESSED_SIZE), X_ONLY_PUBLIC_KEY_INPUT = WASM_BUFFER.subarray(WASM_X_ONLY_PUBLIC_KEY_INPUT_PTR, WASM_X_ONLY_PUBLIC_KEY_INPUT_PTR + X_ONLY_PUBLIC_KEY_SIZE), X_ONLY_PUBLIC_KEY_INPUT2 = WASM_BUFFER.subarray(WASM_X_ONLY_PUBLIC_KEY_INPUT2_PTR, WASM_X_ONLY_PUBLIC_KEY_INPUT2_PTR + X_ONLY_PUBLIC_KEY_SIZE), TWEAK_INPUT = WASM_BUFFER.subarray(WASM_TWEAK_INPUT_PTR, WASM_TWEAK_INPUT_PTR + TWEAK_SIZE), HASH_INPUT = WASM_BUFFER.subarray(WASM_HASH_INPUT_PTR, WASM_HASH_INPUT_PTR + HASH_SIZE), EXTRA_DATA_INPUT = WASM_BUFFER.subarray(WASM_EXTRA_DATA_INPUT_PTR, WASM_EXTRA_DATA_INPUT_PTR + EXTRA_DATA_SIZE), SIGNATURE_INPUT = WASM_BUFFER.subarray(WASM_SIGNATURE_INPUT_PTR, WASM_SIGNATURE_INPUT_PTR + SIGNATURE_SIZE);
function assumeCompression(s, A) {
  return s === void 0 ? A !== void 0 ? A.length : PUBLIC_KEY_COMPRESSED_SIZE : s ? PUBLIC_KEY_COMPRESSED_SIZE : PUBLIC_KEY_UNCOMPRESSED_SIZE;
}
function _isPoint(s) {
  try {
    return PUBLIC_KEY_INPUT.set(s), wasm.isPoint(s.length) === 1;
  } finally {
    PUBLIC_KEY_INPUT.fill(0);
  }
}
function __initializeContext() {
  wasm.initializeContext();
}
function isPoint(s) {
  return isDERPoint(s) && _isPoint(s);
}
function isPointCompressed(s) {
  return isPointCompressed$1(s) && _isPoint(s);
}
function isXOnlyPoint(s) {
  return isXOnlyPoint$1(s) && _isPoint(s);
}
function isPrivate(s) {
  return isPrivate$1(s);
}
function pointAdd(s, A, u) {
  validatePoint(s), validatePoint(A);
  const p = assumeCompression(u, s);
  try {
    return PUBLIC_KEY_INPUT.set(s), PUBLIC_KEY_INPUT2.set(A), wasm.pointAdd(s.length, A.length, p) === 1 ? PUBLIC_KEY_INPUT.slice(0, p) : null;
  } finally {
    PUBLIC_KEY_INPUT.fill(0), PUBLIC_KEY_INPUT2.fill(0);
  }
}
function pointAddScalar(s, A, u) {
  validatePoint(s), validateTweak(A);
  const p = assumeCompression(u, s);
  try {
    return PUBLIC_KEY_INPUT.set(s), TWEAK_INPUT.set(A), wasm.pointAddScalar(s.length, p) === 1 ? PUBLIC_KEY_INPUT.slice(0, p) : null;
  } finally {
    PUBLIC_KEY_INPUT.fill(0), TWEAK_INPUT.fill(0);
  }
}
function pointCompress(s, A) {
  validatePoint(s);
  const u = assumeCompression(A, s);
  try {
    return PUBLIC_KEY_INPUT.set(s), wasm.pointCompress(s.length, u), PUBLIC_KEY_INPUT.slice(0, u);
  } finally {
    PUBLIC_KEY_INPUT.fill(0);
  }
}
function pointFromScalar(s, A) {
  validatePrivate(s);
  const u = assumeCompression(A);
  try {
    return PRIVATE_KEY_INPUT.set(s), wasm.pointFromScalar(u) === 1 ? PUBLIC_KEY_INPUT.slice(0, u) : null;
  } finally {
    PRIVATE_KEY_INPUT.fill(0), PUBLIC_KEY_INPUT.fill(0);
  }
}
function xOnlyPointFromScalar(s) {
  validatePrivate(s);
  try {
    return PRIVATE_KEY_INPUT.set(s), wasm.xOnlyPointFromScalar(), X_ONLY_PUBLIC_KEY_INPUT.slice(0, X_ONLY_PUBLIC_KEY_SIZE);
  } finally {
    PRIVATE_KEY_INPUT.fill(0), X_ONLY_PUBLIC_KEY_INPUT.fill(0);
  }
}
function xOnlyPointFromPoint(s) {
  validatePoint(s);
  try {
    return PUBLIC_KEY_INPUT.set(s), wasm.xOnlyPointFromPoint(s.length), X_ONLY_PUBLIC_KEY_INPUT.slice(0, X_ONLY_PUBLIC_KEY_SIZE);
  } finally {
    PUBLIC_KEY_INPUT.fill(0), X_ONLY_PUBLIC_KEY_INPUT.fill(0);
  }
}
function pointMultiply(s, A, u) {
  validatePoint(s), validateTweak(A);
  const p = assumeCompression(u, s);
  try {
    return PUBLIC_KEY_INPUT.set(s), TWEAK_INPUT.set(A), wasm.pointMultiply(s.length, p) === 1 ? PUBLIC_KEY_INPUT.slice(0, p) : null;
  } finally {
    PUBLIC_KEY_INPUT.fill(0), TWEAK_INPUT.fill(0);
  }
}
function privateAdd(s, A) {
  validatePrivate(s), validateTweak(A);
  try {
    return PRIVATE_KEY_INPUT.set(s), TWEAK_INPUT.set(A), wasm.privateAdd() === 1 ? PRIVATE_KEY_INPUT.slice(0, PRIVATE_KEY_SIZE) : null;
  } finally {
    PRIVATE_KEY_INPUT.fill(0), TWEAK_INPUT.fill(0);
  }
}
function privateSub(s, A) {
  if (validatePrivate(s), validateTweak(A), isZero(A))
    return new Uint8Array(s);
  try {
    return PRIVATE_KEY_INPUT.set(s), TWEAK_INPUT.set(A), wasm.privateSub() === 1 ? PRIVATE_KEY_INPUT.slice(0, PRIVATE_KEY_SIZE) : null;
  } finally {
    PRIVATE_KEY_INPUT.fill(0), TWEAK_INPUT.fill(0);
  }
}
function privateNegate(s) {
  validatePrivate(s);
  try {
    return PRIVATE_KEY_INPUT.set(s), wasm.privateNegate(), PRIVATE_KEY_INPUT.slice(0, PRIVATE_KEY_SIZE);
  } finally {
    PRIVATE_KEY_INPUT.fill(0);
  }
}
function xOnlyPointAddTweak(s, A) {
  validateXOnlyPoint(s), validateTweak(A);
  try {
    X_ONLY_PUBLIC_KEY_INPUT.set(s), TWEAK_INPUT.set(A);
    const u = wasm.xOnlyPointAddTweak();
    return u !== -1 ? {
      parity: u,
      xOnlyPubkey: X_ONLY_PUBLIC_KEY_INPUT.slice(0, X_ONLY_PUBLIC_KEY_SIZE)
    } : null;
  } finally {
    X_ONLY_PUBLIC_KEY_INPUT.fill(0), TWEAK_INPUT.fill(0);
  }
}
function xOnlyPointAddTweakCheck(s, A, u, p) {
  validateXOnlyPoint(s), validateXOnlyPoint(u), validateTweak(A);
  const t = p !== void 0;
  t && validateParity(p);
  try {
    if (X_ONLY_PUBLIC_KEY_INPUT.set(s), X_ONLY_PUBLIC_KEY_INPUT2.set(u), TWEAK_INPUT.set(A), t)
      return wasm.xOnlyPointAddTweakCheck(p) === 1;
    {
      wasm.xOnlyPointAddTweak();
      const l = X_ONLY_PUBLIC_KEY_INPUT.slice(0, X_ONLY_PUBLIC_KEY_SIZE);
      return compare(l, u) === 0;
    }
  } finally {
    X_ONLY_PUBLIC_KEY_INPUT.fill(0), X_ONLY_PUBLIC_KEY_INPUT2.fill(0), TWEAK_INPUT.fill(0);
  }
}
function sign(s, A, u) {
  validateHash(s), validatePrivate(A), validateExtraData(u);
  try {
    return HASH_INPUT.set(s), PRIVATE_KEY_INPUT.set(A), u !== void 0 && EXTRA_DATA_INPUT.set(u), wasm.sign(u === void 0 ? 0 : 1), SIGNATURE_INPUT.slice(0, SIGNATURE_SIZE);
  } finally {
    HASH_INPUT.fill(0), PRIVATE_KEY_INPUT.fill(0), u !== void 0 && EXTRA_DATA_INPUT.fill(0), SIGNATURE_INPUT.fill(0);
  }
}
function signRecoverable(s, A, u) {
  validateHash(s), validatePrivate(A), validateExtraData(u);
  try {
    HASH_INPUT.set(s), PRIVATE_KEY_INPUT.set(A), u !== void 0 && EXTRA_DATA_INPUT.set(u);
    const p = wasm.signRecoverable(u === void 0 ? 0 : 1);
    return {
      signature: SIGNATURE_INPUT.slice(0, SIGNATURE_SIZE),
      recoveryId: p
    };
  } finally {
    HASH_INPUT.fill(0), PRIVATE_KEY_INPUT.fill(0), u !== void 0 && EXTRA_DATA_INPUT.fill(0), SIGNATURE_INPUT.fill(0);
  }
}
function signSchnorr$1(s, A, u) {
  validateHash(s), validatePrivate(A), validateExtraData(u);
  try {
    return HASH_INPUT.set(s), PRIVATE_KEY_INPUT.set(A), u !== void 0 && EXTRA_DATA_INPUT.set(u), wasm.signSchnorr(u === void 0 ? 0 : 1), SIGNATURE_INPUT.slice(0, SIGNATURE_SIZE);
  } finally {
    HASH_INPUT.fill(0), PRIVATE_KEY_INPUT.fill(0), u !== void 0 && EXTRA_DATA_INPUT.fill(0), SIGNATURE_INPUT.fill(0);
  }
}
function verify(s, A, u, p = !1) {
  validateHash(s), validatePoint(A), validateSignature(u);
  try {
    return HASH_INPUT.set(s), PUBLIC_KEY_INPUT.set(A), SIGNATURE_INPUT.set(u), wasm.verify(A.length, p === !0 ? 1 : 0) === 1;
  } finally {
    HASH_INPUT.fill(0), PUBLIC_KEY_INPUT.fill(0), SIGNATURE_INPUT.fill(0);
  }
}
function recover(s, A, u, p = !1) {
  validateHash(s), validateSignature(A), validateSignatureNonzeroRS(A), u & 2 && validateSigrPMinusN(A), validateSignatureCustom(() => isXOnlyPoint(A.subarray(0, 32)));
  const t = assumeCompression(p);
  try {
    return HASH_INPUT.set(s), SIGNATURE_INPUT.set(A), wasm.recover(t, u) === 1 ? PUBLIC_KEY_INPUT.slice(0, t) : null;
  } finally {
    HASH_INPUT.fill(0), SIGNATURE_INPUT.fill(0), PUBLIC_KEY_INPUT.fill(0);
  }
}
function verifySchnorr(s, A, u) {
  validateHash(s), validateXOnlyPoint(A), validateSignature(u);
  try {
    return HASH_INPUT.set(s), X_ONLY_PUBLIC_KEY_INPUT.set(A), SIGNATURE_INPUT.set(u), wasm.verifySchnorr() === 1;
  } finally {
    HASH_INPUT.fill(0), X_ONLY_PUBLIC_KEY_INPUT.fill(0), SIGNATURE_INPUT.fill(0);
  }
}
const ecc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __initializeContext,
  isPoint,
  isPointCompressed,
  isPrivate,
  isXOnlyPoint,
  pointAdd,
  pointAddScalar,
  pointCompress,
  pointFromScalar,
  pointMultiply,
  privateAdd,
  privateNegate,
  privateSub,
  recover,
  sign,
  signRecoverable,
  signSchnorr: signSchnorr$1,
  verify,
  verifySchnorr,
  xOnlyPointAddTweak,
  xOnlyPointAddTweakCheck,
  xOnlyPointFromPoint,
  xOnlyPointFromScalar
}, Symbol.toStringTag, { value: "Module" })), initBTCCurve = () => {
  srcExports.initEccLib(ecc);
}, COMPRESSED_PUBLIC_KEY_HEX_LENGTH = 66, NETWORKS = {
  [Network.MAINNET]: {
    name: "Mainnet",
    config: srcExports.networks.bitcoin,
    addressPrefix: {
      common: "bc1",
      nativeSegWit: "bc1q",
      taproot: "bc1p"
    }
  },
  [Network.TESTNET]: {
    name: "Testnet",
    config: srcExports.networks.testnet,
    addressPrefix: {
      common: "tb1",
      nativeSegWit: "tb1q",
      taproot: "tb1p"
    }
  },
  [Network.SIGNET]: {
    name: "Signet",
    config: srcExports.networks.testnet,
    addressPrefix: {
      common: "tb1",
      nativeSegWit: "tb1q",
      taproot: "tb1p"
    }
  }
}, getTaprootAddress = (s, A) => {
  s.length == COMPRESSED_PUBLIC_KEY_HEX_LENGTH && (s = s.slice(2));
  const u = Buffer.from(s, "hex"), { address: p, output: t } = srcExports.payments.p2tr({
    internalPubkey: bip371Exports.toXOnly(u),
    network: NETWORKS[A].config
  });
  if (!p || !t)
    throw new WalletError({
      code: ERROR_CODES.ADDRESS_GENERATION_FAILED,
      message: "Failed to generate taproot address or script from public key"
    });
  return p;
}, getNativeSegwitAddress = (s, A) => {
  if (s.length !== COMPRESSED_PUBLIC_KEY_HEX_LENGTH)
    throw new WalletError({
      code: ERROR_CODES.INVALID_PUBLIC_KEY,
      message: "Invalid public key length for generating native segwit address"
    });
  const u = Buffer.from(s, "hex"), { address: p, output: t } = srcExports.payments.p2wpkh({
    pubkey: u,
    network: NETWORKS[A].config
  });
  if (!p || !t)
    throw new WalletError({
      code: ERROR_CODES.ADDRESS_GENERATION_FAILED,
      message: "Failed to generate native segwit address or script from public key"
    });
  return p;
};
function validateAddressWithPK(s, A, u) {
  return s.startsWith(NETWORKS[u].addressPrefix.taproot) ? s === getTaprootAddress(A, u) : s.startsWith(NETWORKS[u].addressPrefix.nativeSegWit) ? s === getNativeSegwitAddress(A, u) : !1;
}
function validateAddress(s, A) {
  const { addressPrefix: u, name: p } = NETWORKS[s];
  if (!(s in NETWORKS))
    throw new WalletError({
      code: ERROR_CODES.UNSUPPORTED_NETWORK,
      message: `Unsupported network: ${s}. Please provide a valid network.`
    });
  if (!A.startsWith(u.common))
    throw new WalletError({
      code: ERROR_CODES.INVALID_ADDRESS_PREFIX,
      message: `Incorrect address prefix for ${p}. Expected address to start with '${u.common}'.`
    });
}
const toNetwork = (s) => NETWORKS[s].config, getPublicKeyFromXpub = (s, A, u) => {
  const t = HDKey.fromExtendedKey(s, u == null ? void 0 : u.bip32).derive(A);
  return Buffer.from(t.publicKey);
}, generateP2TRAddressFromXpub = (s, A, u) => {
  const p = getPublicKeyFromXpub(s, A), t = bip371Exports.toXOnly(p);
  let l, m;
  try {
    const b = srcExports.payments.p2tr({
      internalPubkey: t,
      network: u
    });
    l = b.address, m = b.output;
  } catch (b) {
    if (b instanceof Error && b.message.includes("ECC")) {
      initBTCCurve();
      const k = srcExports.payments.p2tr({
        internalPubkey: t,
        network: u
      });
      l = k.address, m = k.output;
    } else
      throw b;
  }
  return {
    address: l,
    publicKeyHex: p.toString("hex"),
    scriptPubKeyHex: m.toString("hex")
  };
}, WALLET_PROVIDER_NAME$6 = "Keystone";
class KeystoneProvider {
  constructor(A, u) {
    Ci(this, "keystoneWalletInfo");
    Ci(this, "viewSDK");
    Ci(this, "dataSdk");
    Ci(this, "config");
    /**
     * Connects the staking app to the Keystone device and retrieves the necessary information.
     * @returns A Promise that resolves to the current instance of the class.
     * @throws An error if there is an issue reading the QR code or retrieving the extended public key.
     */
    Ci(this, "connectWallet", async () => {
      const u = await (await this.viewSDK.getSdk()).read([SupportedResult.UR_CRYPTO_ACCOUNT], {
        title: "Sync Keystone with Babylon Staking App",
        description: "Please scan the QR code displayed on your Keystone, Currently only the first Taproot Address will be used",
        renderInitial: {
          walletMode: "btc",
          link: "",
          description: [
            "1. Turn on your Keystone 3 with BTC only firmware.",
            '2. Click connect software wallet and use "Sparrow" for connection.',
            '3. Press the "Sync Keystone" button and scan the QR Code displayed on your Keystone hardware wallet',
            "4. The first Taproot address will be used for staking."
          ]
        },
        URTypeErrorMessage: "The scanned QR code is not the sync code from the Keystone hardware wallet. Please verify the code and try again."
      });
      if (u.status === ReadStatus.canceled)
        throw new WalletError({
          code: ERROR_CODES.CONNECTION_CANCELED,
          message: "Connection to Keystone was canceled",
          wallet: WALLET_PROVIDER_NAME$6
        });
      if (u.status !== ReadStatus.success)
        throw new WalletError({
          code: ERROR_CODES.QR_READ_ERROR,
          message: "Error reading QR code, Please try again.",
          wallet: WALLET_PROVIDER_NAME$6
        });
      const p = this.dataSdk.parseAccount(u.result), t = 3, l = p.keys[t].extendedPublicKey;
      if (this.keystoneWalletInfo = {
        mfp: p.masterFingerprint,
        extendedPublicKey: l,
        path: p.keys[t].path,
        address: void 0,
        publicKeyHex: void 0,
        scriptPubKeyHex: void 0
      }, !this.keystoneWalletInfo.extendedPublicKey)
        throw new WalletError({
          code: ERROR_CODES.EXTENSION_NOT_FOUND,
          message: "Could not retrieve the extended public key",
          wallet: WALLET_PROVIDER_NAME$6
        });
      const { address: m, publicKeyHex: b, scriptPubKeyHex: k } = generateP2TRAddressFromXpub(
        this.keystoneWalletInfo.extendedPublicKey,
        "M/0/0",
        toNetwork(this.config.network)
      );
      this.keystoneWalletInfo.address = m, this.keystoneWalletInfo.publicKeyHex = b, this.keystoneWalletInfo.scriptPubKeyHex = k;
    });
    Ci(this, "getAddress", async () => {
      var A;
      if (!((A = this.keystoneWalletInfo) != null && A.address))
        throw new WalletError({
          code: ERROR_CODES.ADDRESS_NOT_FOUND,
          message: "Could not retrieve the address",
          wallet: WALLET_PROVIDER_NAME$6
        });
      return this.keystoneWalletInfo.address;
    });
    Ci(this, "getPublicKeyHex", async () => {
      var A;
      if (!((A = this.keystoneWalletInfo) != null && A.publicKeyHex))
        throw new WalletError({
          code: ERROR_CODES.PUBLIC_KEY_NOT_FOUND,
          message: "Could not retrieve the BTC public key",
          wallet: WALLET_PROVIDER_NAME$6
        });
      return this.keystoneWalletInfo.publicKeyHex;
    });
    Ci(this, "signPsbt", async (A, u) => {
      var b, k, C;
      if (!((b = this.keystoneWalletInfo) != null && b.address) || !((k = this.keystoneWalletInfo) != null && k.publicKeyHex))
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Keystone Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$6
        });
      if (!A)
        throw new WalletError({
          code: ERROR_CODES.PSBT_HEX_REQUIRED,
          message: "psbt hex is required",
          wallet: WALLET_PROVIDER_NAME$6
        });
      const p = (C = u == null ? void 0 : u.signInputs) == null ? void 0 : C.map((B) => B.index);
      let t = srcExports.Psbt.fromHex(A);
      t = this.enhancePsbt(t, p);
      const l = t.toHex();
      return (await this.sign(l)).toHex();
    });
    Ci(this, "signPsbts", async (A) => {
      var p, t;
      if (!((p = this.keystoneWalletInfo) != null && p.address) || !((t = this.keystoneWalletInfo) != null && t.publicKeyHex))
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Keystone Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$6
        });
      if (!A && !Array.isArray(A))
        throw new WalletError({
          code: ERROR_CODES.PSBTS_HEXES_REQUIRED,
          message: "psbts hexes are required",
          wallet: WALLET_PROVIDER_NAME$6
        });
      const u = [];
      for (const l of A) {
        const m = await this.signPsbt(l);
        u.push(m);
      }
      return u;
    });
    Ci(this, "getNetwork", async () => this.config.network);
    Ci(this, "signMessage", async (A, u) => u === "bip322-simple" ? this.signMessageBIP322(A) : this.signMessageECDSA(A));
    /**
     * https://github.com/bitcoin/bips/blob/master/bip-0322.mediawiki
     * signMessageBIP322 signs a message using the BIP322 standard.
     * @param message
     * @returns signature
     */
    Ci(this, "signMessageBIP322", async (A) => {
      var b, k;
      if (!((b = this.keystoneWalletInfo) != null && b.scriptPubKeyHex) || !((k = this.keystoneWalletInfo) != null && k.publicKeyHex))
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Keystone Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$6
        });
      const u = Buffer$1.from(this.keystoneWalletInfo.scriptPubKeyHex, "hex"), p = BIP322.buildToSpendTx(A, u), t = bip371Exports.toXOnly(Buffer$1.from(this.keystoneWalletInfo.publicKeyHex, "hex"));
      let l = BIP322.buildToSignTx(p.getId(), u, !1, t);
      l.updateInput(0, {
        sighashType: srcExports.Transaction.SIGHASH_ALL
      }), l = this.enhancePsbt(l);
      const m = await this.sign(l.toHex());
      return BIP322.encodeWitness(m);
    });
    Ci(this, "signMessageECDSA", async (A) => {
      var b, k;
      if (!((b = this.keystoneWalletInfo) != null && b.address) || !((k = this.keystoneWalletInfo) != null && k.publicKeyHex))
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Keystone Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$6
        });
      const u = this.dataSdk.btc.generateSignRequest({
        requestId: v4(),
        signData: Buffer$1.from(A, "utf-8").toString("hex"),
        dataType: distExports.KeystoneBitcoinSDK.DataType.message,
        accounts: [
          {
            path: `${this.keystoneWalletInfo.path}/0/0`,
            xfp: `${this.keystoneWalletInfo.mfp}`,
            address: this.keystoneWalletInfo.address
          }
        ],
        origin: "babylon staking app"
      }), p = composeQRProcess(SupportedResult.UR_BTC_SIGNATURE), t = await this.viewSDK.getSdk(), l = await p(t, u), m = this.dataSdk.btc.parseSignature(l);
      return Buffer$1.from(m.signature, "hex").toString("base64");
    });
    Ci(this, "getInscriptions", async () => {
      throw new WalletError({
        code: ERROR_CODES.METHOD_NOT_IMPLEMENTED,
        message: "Method not implemented.",
        wallet: WALLET_PROVIDER_NAME$6
      });
    });
    // Not implemented because of the Airgapped HW nature
    Ci(this, "on", () => {
    });
    Ci(this, "off", () => {
    });
    Ci(this, "getWalletProviderName", async () => WALLET_PROVIDER_NAME$6);
    Ci(this, "getWalletProviderIcon", async () => logo$5);
    /**
     * Sign the PSBT with the Keystone device.
     *
     * @param psbtHex - The PSBT in hex format.
     * @returns The signed PSBT in hex format.
     * */
    Ci(this, "sign", async (A) => {
      if (!A)
        throw new WalletError({
          code: ERROR_CODES.PSBT_HEX_REQUIRED,
          message: "psbt hex is required",
          wallet: WALLET_PROVIDER_NAME$6
        });
      const u = this.dataSdk.btc.generatePSBT(Buffer$1.from(A, "hex")), p = composeQRProcess(SupportedResult.UR_PSBT), t = await this.viewSDK.getSdk(), l = await p(t, u), m = this.dataSdk.btc.parsePSBT(l), b = srcExports.Psbt.fromHex(m);
      return b.finalizeAllInputs(), b;
    });
    /**
     * Add the BIP32 derivation information for each input.
     * The Keystone device is stateless, so it needs to know which key to use to sign the PSBT.
     * Therefore, add the Taproot BIP32 derivation information to the PSBT.
     * https://github.com/bitcoin/bips/blob/master/bip-0174.mediawiki#Specification
     * @param psbt - The PSBT object.
     * @param inputIndexes - Optional array of input indexes to enhance. If not provided, all inputs are enhanced.
     * @returns The PSBT object with the BIP32 derivation information added.
     */
    Ci(this, "enhancePsbt", (A, u) => {
      var t, l, m, b;
      if (!((t = this.keystoneWalletInfo) != null && t.scriptPubKeyHex) || !((l = this.keystoneWalletInfo) != null && l.publicKeyHex) || !((m = this.keystoneWalletInfo) != null && m.mfp) || !((b = this.keystoneWalletInfo) != null && b.path))
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Keystone Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$6
        });
      const p = {
        masterFingerprint: Buffer$1.from(this.keystoneWalletInfo.mfp, "hex"),
        path: `${this.keystoneWalletInfo.path}/0/0`,
        pubkey: Buffer$1.from(this.keystoneWalletInfo.publicKeyHex, "hex")
      };
      return A.data.inputs.forEach((k, C) => {
        u && !u.includes(C) || (k.tapBip32Derivation = [
          {
            ...p,
            pubkey: bip371Exports.toXOnly(p.pubkey),
            leafHashes: calculateTapLeafHash(k, p.pubkey)
          }
        ]);
      }), A;
    });
    this.config = u, viewSdk.bootstrap(), this.viewSDK = viewSdk, this.dataSdk = new distExports.KeystoneSDK({
      origin: "babylon staking app"
    });
  }
}
const composeQRProcess = (s) => async (A, u) => {
  if (await A.play(u, {
    title: "Scan the QR Code",
    description: "Please scan the QR code with your Keystone device."
  }) !== PlayStatus.success)
    throw new WalletError({
      code: ERROR_CODES.QR_SCAN_ERROR,
      message: "Could not generate the QR code, please try again.",
      wallet: WALLET_PROVIDER_NAME$6
    });
  const t = await A.read([s], {
    title: "Get the Signature from Keystone",
    description: "Please scan the QR code displayed on your Keystone",
    URTypeErrorMessage: "The scanned QR code can't be read. please verify and try again."
  });
  if (t.status !== ReadStatus.success)
    throw new WalletError({
      code: ERROR_CODES.SIGNATURE_EXTRACT_ERROR,
      message: "Could not extract the signature, please try again.",
      wallet: WALLET_PROVIDER_NAME$6
    });
  return t.result;
}, calculateTapLeafHash = (s, A) => s.tapInternalKey && !s.tapLeafScript ? [] : (s.tapLeafScript || []).filter((p) => psbtutilsExports.pubkeyInScript(A, p.script)).map((p) => {
  const t = bip341Exports.tapleafHash({
    output: p.script,
    version: p.leafVersion
  });
  return Object.assign({ hash: t }, p);
}).map((p) => p.hash), metadata$9 = {
  id: "keystone",
  name: WALLET_PROVIDER_NAME$6,
  icon: logo$5,
  docs: "https://www.keyst.one/btc-only",
  createProvider: (s, A) => new KeystoneProvider(s, A),
  networks: [Network.MAINNET, Network.SIGNET],
  label: "Hardware wallet"
}, logo$4 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='157'%20height='157'%3e%3cpath%20fill='%23000'%20fill-rule='nonzero'%20d='M5%20106.655V143h55.308v-8.06h-47.25v-28.285H5Zm138.98%200v28.285H96.731v8.058h55.308v-36.343h-8.059Zm-83.592-55.31v55.308h36.343v-7.269H68.446V51.345h-8.058ZM5%2015v36.345h8.058V23.058h47.25V15H5Zm91.731%200v8.058h47.249v28.287h8.059V15H96.731Z'/%3e%3c/svg%3e";
var eventsExports = requireEvents();
const Nt = /* @__PURE__ */ getDefaultExportFromCjs(eventsExports), errorClasses = {}, deserializers = {}, addCustomErrorDeserializer = (s, A) => {
  deserializers[s] = A;
}, createCustomErrorClass = (s) => {
  class A extends Error {
    constructor(t, l, m) {
      super(t || s, m);
      Ci(this, "cause");
      if (Object.setPrototypeOf(this, A.prototype), this.name = s, l)
        for (const b in l)
          this[b] = l[b];
      if (m && isObject(m) && "cause" in m && !this.cause) {
        const b = m.cause;
        this.cause = b, "stack" in b && (this.stack = this.stack + `
CAUSE: ` + b.stack);
      }
    }
  }
  return errorClasses[s] = A, A;
};
function isObject(s) {
  return typeof s == "object";
}
createCustomErrorClass("AccountNameRequired");
createCustomErrorClass("AccountNotSupported");
createCustomErrorClass("AccountAwaitingSendPendingOperations");
createCustomErrorClass("AmountRequired");
createCustomErrorClass("BluetoothRequired");
createCustomErrorClass("BtcUnmatchedApp");
createCustomErrorClass("CantOpenDevice");
createCustomErrorClass("CashAddrNotSupported");
createCustomErrorClass("ClaimRewardsFeesWarning");
createCustomErrorClass("CurrencyNotSupported");
createCustomErrorClass("DeviceAppVerifyNotSupported");
createCustomErrorClass("DeviceGenuineSocketEarlyClose");
createCustomErrorClass("DeviceNotGenuine");
createCustomErrorClass("DeviceOnDashboardExpected");
createCustomErrorClass("DeviceOnDashboardUnexpected");
createCustomErrorClass("DeviceInOSUExpected");
createCustomErrorClass("DeviceHalted");
createCustomErrorClass("DeviceNameInvalid");
createCustomErrorClass("DeviceSocketFail");
createCustomErrorClass("DeviceSocketNoBulkStatus");
createCustomErrorClass("DeviceSocketNoBulkStatus");
createCustomErrorClass("UnresponsiveDeviceError");
const DisconnectedDevice = createCustomErrorClass("DisconnectedDevice"), DisconnectedDeviceDuringOperation = createCustomErrorClass("DisconnectedDeviceDuringOperation");
createCustomErrorClass("DeviceExtractOnboardingStateError");
createCustomErrorClass("DeviceOnboardingStatePollingError");
createCustomErrorClass("EnpointConfig");
createCustomErrorClass("EthAppPleaseEnableContractData");
createCustomErrorClass("FeeEstimationFailed");
createCustomErrorClass("FirmwareNotRecognized");
createCustomErrorClass("HardResetFail");
createCustomErrorClass("InvalidXRPTag");
createCustomErrorClass("InvalidAddress");
createCustomErrorClass("InvalidNonce");
createCustomErrorClass("InvalidAddressBecauseDestinationIsAlsoSource");
createCustomErrorClass("LatestMCUInstalledError");
createCustomErrorClass("LatestFirmwareVersionRequired");
createCustomErrorClass("UnknownMCU");
createCustomErrorClass("LedgerAPIError");
createCustomErrorClass("LedgerAPIErrorWithMessage");
createCustomErrorClass("LedgerAPINotAvailable");
createCustomErrorClass("ManagerAppAlreadyInstalled");
createCustomErrorClass("ManagerAppRelyOnBTC");
createCustomErrorClass("ManagerAppDepInstallRequired");
createCustomErrorClass("ManagerAppDepUninstallRequired");
createCustomErrorClass("ManagerDeviceLocked");
createCustomErrorClass("ManagerFirmwareNotEnoughSpace");
createCustomErrorClass("ManagerNotEnoughSpace");
createCustomErrorClass("ManagerUninstallBTCDep");
createCustomErrorClass("NetworkDown");
createCustomErrorClass("NetworkError");
createCustomErrorClass("NoAddressesFound");
createCustomErrorClass("NotEnoughBalance");
createCustomErrorClass("NotEnoughBalanceFees");
createCustomErrorClass("NotEnoughBalanceSwap");
createCustomErrorClass("NotEnoughBalanceToDelegate");
createCustomErrorClass("UnstakeNotEnoughStakedBalanceLeft");
createCustomErrorClass("RestakeNotEnoughStakedBalanceLeft");
createCustomErrorClass("NotEnoughToRestake");
createCustomErrorClass("NotEnoughToUnstake");
createCustomErrorClass("NotEnoughBalanceInParentAccount");
createCustomErrorClass("NotEnoughSpendableBalance");
createCustomErrorClass("NotEnoughBalanceBecauseDestinationNotCreated");
createCustomErrorClass("NotEnoughToStake");
createCustomErrorClass("NoAccessToCamera");
createCustomErrorClass("NotEnoughGas");
createCustomErrorClass("NotEnoughGasSwap");
createCustomErrorClass("TronEmptyAccount");
createCustomErrorClass("MaybeKeepTronAccountAlive");
createCustomErrorClass("NotSupportedLegacyAddress");
createCustomErrorClass("GasLessThanEstimate");
createCustomErrorClass("PriorityFeeTooLow");
createCustomErrorClass("PriorityFeeTooHigh");
createCustomErrorClass("PriorityFeeHigherThanMaxFee");
createCustomErrorClass("MaxFeeTooLow");
createCustomErrorClass("PasswordsDontMatch");
createCustomErrorClass("PasswordIncorrect");
createCustomErrorClass("RecommendSubAccountsToEmpty");
createCustomErrorClass("RecommendUndelegation");
createCustomErrorClass("TimeoutTagged");
createCustomErrorClass("UnexpectedBootloader");
createCustomErrorClass("MCUNotGenuineToDashboard");
createCustomErrorClass("RecipientRequired");
createCustomErrorClass("UnavailableTezosOriginatedAccountReceive");
createCustomErrorClass("UnavailableTezosOriginatedAccountSend");
createCustomErrorClass("UpdateFetchFileFail");
createCustomErrorClass("UpdateIncorrectHash");
createCustomErrorClass("UpdateIncorrectSig");
createCustomErrorClass("UpdateYourApp");
createCustomErrorClass("UserRefusedDeviceNameChange");
createCustomErrorClass("UserRefusedAddress");
createCustomErrorClass("UserRefusedFirmwareUpdate");
createCustomErrorClass("UserRefusedAllowManager");
createCustomErrorClass("UserRefusedOnDevice");
createCustomErrorClass("PinNotSet");
createCustomErrorClass("ExpertModeRequired");
const TransportOpenUserCancelled = createCustomErrorClass("TransportOpenUserCancelled"), TransportInterfaceNotAvailable = createCustomErrorClass("TransportInterfaceNotAvailable"), TransportRaceCondition = createCustomErrorClass("TransportRaceCondition"), TransportWebUSBGestureRequired = createCustomErrorClass("TransportWebUSBGestureRequired");
createCustomErrorClass("TransactionHasBeenValidatedError");
createCustomErrorClass("TransportExchangeTimeoutError");
createCustomErrorClass("DeviceShouldStayInApp");
createCustomErrorClass("WebsocketConnectionError");
createCustomErrorClass("WebsocketConnectionFailed");
createCustomErrorClass("WrongDeviceForAccount");
createCustomErrorClass("WrongDeviceForAccountPayout");
createCustomErrorClass("MissingSwapPayloadParamaters");
createCustomErrorClass("WrongDeviceForAccountRefund");
createCustomErrorClass("WrongAppForCurrency");
createCustomErrorClass("ETHAddressNonEIP");
createCustomErrorClass("CantScanQRCode");
createCustomErrorClass("FeeNotLoaded");
createCustomErrorClass("FeeNotLoadedSwap");
createCustomErrorClass("FeeRequired");
createCustomErrorClass("FeeTooHigh");
createCustomErrorClass("PendingOperation");
createCustomErrorClass("SyncError");
createCustomErrorClass("PairingFailed");
createCustomErrorClass("PeerRemovedPairing");
createCustomErrorClass("GenuineCheckFailed");
createCustomErrorClass("LedgerAPI4xx");
createCustomErrorClass("LedgerAPI5xx");
createCustomErrorClass("FirmwareOrAppUpdateRequired");
createCustomErrorClass("ReplacementTransactionUnderpriced");
createCustomErrorClass("OpReturnSizeLimit");
createCustomErrorClass("DustLimit");
createCustomErrorClass("HederaInsufficientFundsForAssociation");
createCustomErrorClass("HederaRecipientTokenAssociationRequired");
createCustomErrorClass("HederaRecipientTokenAssociationUnverified");
createCustomErrorClass("LanguageNotFound");
createCustomErrorClass("NoDBPathGiven");
createCustomErrorClass("DBWrongPassword");
createCustomErrorClass("DBNotReset");
createCustomErrorClass("SequenceNumberError");
createCustomErrorClass("DisabledTransactionBroadcastError");
var HwTransportErrorType;
(function(s) {
  s.Unknown = "Unknown", s.LocationServicesDisabled = "LocationServicesDisabled", s.LocationServicesUnauthorized = "LocationServicesUnauthorized", s.BluetoothScanStartFailed = "BluetoothScanStartFailed";
})(HwTransportErrorType || (HwTransportErrorType = {}));
class TransportError extends Error {
  constructor(u, p) {
    const t = "TransportError";
    super(u || t);
    Ci(this, "id");
    this.name = t, this.message = u, this.stack = new Error(u).stack, this.id = p;
  }
}
addCustomErrorDeserializer("TransportError", (s) => new TransportError(s.message, s.id));
const StatusCodes = {
  ACCESS_CONDITION_NOT_FULFILLED: 38916,
  ALGORITHM_NOT_SUPPORTED: 38020,
  CLA_NOT_SUPPORTED: 28160,
  CODE_BLOCKED: 38976,
  CODE_NOT_INITIALIZED: 38914,
  COMMAND_INCOMPATIBLE_FILE_STRUCTURE: 27009,
  CONDITIONS_OF_USE_NOT_SATISFIED: 27013,
  CONTRADICTION_INVALIDATION: 38928,
  CONTRADICTION_SECRET_CODE_STATUS: 38920,
  DEVICE_IN_RECOVERY_MODE: 26159,
  CUSTOM_IMAGE_EMPTY: 26158,
  FILE_ALREADY_EXISTS: 27273,
  FILE_NOT_FOUND: 37892,
  GP_AUTH_FAILED: 25344,
  HALTED: 28586,
  INCONSISTENT_FILE: 37896,
  INCORRECT_DATA: 27264,
  INCORRECT_LENGTH: 26368,
  INCORRECT_P1_P2: 27392,
  INS_NOT_SUPPORTED: 27904,
  DEVICE_NOT_ONBOARDED: 27911,
  DEVICE_NOT_ONBOARDED_2: 26129,
  INVALID_KCV: 38021,
  INVALID_OFFSET: 37890,
  LICENSING: 28482,
  LOCKED_DEVICE: 21781,
  MAX_VALUE_REACHED: 38992,
  MEMORY_PROBLEM: 37440,
  MISSING_CRITICAL_PARAMETER: 26624,
  NO_EF_SELECTED: 37888,
  NOT_ENOUGH_MEMORY_SPACE: 27268,
  OK: 36864,
  PIN_REMAINING_ATTEMPTS: 25536,
  REFERENCED_DATA_NOT_FOUND: 27272,
  SECURITY_STATUS_NOT_SATISFIED: 27010,
  TECHNICAL_PROBLEM: 28416,
  UNKNOWN_APDU: 27906,
  USER_REFUSED_ON_DEVICE: 21761,
  NOT_ENOUGH_SPACE: 20738,
  APP_NOT_FOUND_OR_INVALID_CONTEXT: 20771,
  INVALID_APP_NAME_LENGTH: 26378,
  GEN_AES_KEY_FAILED: 21529,
  INTERNAL_CRYPTO_OPERATION_FAILED: 21530,
  INTERNAL_COMPUTE_AES_CMAC_FAILED: 21531,
  ENCRYPT_APP_STORAGE_FAILED: 21532,
  INVALID_BACKUP_STATE: 26178,
  PIN_NOT_SET: 21762,
  INVALID_BACKUP_LENGTH: 26419,
  INVALID_RESTORE_STATE: 26179,
  INVALID_CHUNK_LENGTH: 26420,
  INVALID_BACKUP_HEADER: 26698,
  // Not documented:
  TRUSTCHAIN_WRONG_SEED: 45063
};
function getAltStatusMessage(s) {
  switch (s) {
    // improve text of most common errors
    case 26368:
      return "Incorrect length";
    case 26624:
      return "Missing critical parameter";
    case 27010:
      return "Security not satisfied (dongle locked or have invalid access rights)";
    case 27013:
      return "Condition of use not satisfied (denied by the user?)";
    case 27264:
      return "Invalid data received";
    case 27392:
      return "Invalid parameter received";
    case 21781:
      return "Locked device";
  }
  if (28416 <= s && s <= 28671)
    return "Internal error, please report";
}
class TransportStatusError extends Error {
  /**
   * @param statusCode The error status code coming from a Transport implementation
   * @param options containing:
   *  - canBeMappedToChildError: enable the mapping of TransportStatusError to an error extending/inheriting from it
   *  . Ex: LockedDeviceError. Default to true.
   */
  constructor(u, { canBeMappedToChildError: p = !0 } = {}) {
    const t = Object.keys(StatusCodes).find((k) => StatusCodes[k] === u) || "UNKNOWN_ERROR", l = getAltStatusMessage(u) || t, m = u.toString(16), b = `Ledger device: ${l} (0x${m})`;
    super(b);
    Ci(this, "statusCode");
    Ci(this, "statusText");
    if (this.name = "TransportStatusError", this.statusCode = u, this.statusText = t, Object.setPrototypeOf(this, TransportStatusError.prototype), p && u === StatusCodes.LOCKED_DEVICE)
      return new LockedDeviceError(b);
  }
}
class LockedDeviceError extends TransportStatusError {
  constructor(A) {
    super(StatusCodes.LOCKED_DEVICE, { canBeMappedToChildError: !1 }), A && (this.message = A), this.name = "LockedDeviceError", Object.setPrototypeOf(this, LockedDeviceError.prototype);
  }
}
addCustomErrorDeserializer("TransportStatusError", (s) => new TransportStatusError(s.statusCode));
let id = 0;
const subscribers = [], log = (s, A, u) => {
  const p = {
    type: s,
    id: String(++id),
    date: /* @__PURE__ */ new Date()
  };
  A && (p.message = A), dispatch(p);
}, trace = ({ type: s, message: A, data: u, context: p }) => {
  const t = {
    type: s,
    id: String(++id),
    date: /* @__PURE__ */ new Date()
  };
  A && (t.message = A), u && (t.data = u), p && (t.context = p), dispatch(t);
};
class LocalTracer {
  constructor(A, u) {
    Ci(this, "type");
    Ci(this, "context");
    this.type = A, this.context = u;
  }
  trace(A, u) {
    trace({
      type: this.type,
      message: A,
      data: u,
      context: this.context
    });
  }
  getContext() {
    return this.context;
  }
  setContext(A) {
    this.context = A;
  }
  updateContext(A) {
    this.context = { ...this.context, ...A };
  }
  getType() {
    return this.type;
  }
  setType(A) {
    this.type = A;
  }
  /**
   * Create a new instance of the LocalTracer with an updated `type`
   *
   * It does not mutate the calling instance, but returns a new LocalTracer,
   * following a simple builder pattern.
   */
  withType(A) {
    return new LocalTracer(A, this.context);
  }
  /**
   * Create a new instance of the LocalTracer with a new `context`
   *
   * It does not mutate the calling instance, but returns a new LocalTracer,
   * following a simple builder pattern.
   *
   * @param context A TraceContext, that can undefined to reset the context
   */
  withContext(A) {
    return new LocalTracer(this.type, A);
  }
  /**
   * Create a new instance of the LocalTracer with an updated `context`,
   * on which an additional context is merged with the existing one.
   *
   * It does not mutate the calling instance, but returns a new LocalTracer,
   * following a simple builder pattern.
   */
  withUpdatedContext(A) {
    return new LocalTracer(this.type, { ...this.context, ...A });
  }
}
const listen = (s) => (subscribers.push(s), () => {
  const A = subscribers.indexOf(s);
  A !== -1 && (subscribers[A] = subscribers[subscribers.length - 1], subscribers.pop());
});
function dispatch(s) {
  for (let A = 0; A < subscribers.length; A++)
    try {
      subscribers[A](s);
    } catch (u) {
      console.error(u);
    }
}
typeof window < "u" && (window.__ledgerLogsListen = listen);
const DEFAULT_LOG_TYPE = "transport";
class Transport {
  constructor({ context: A, logType: u } = {}) {
    Ci(this, "exchangeTimeout", 3e4);
    Ci(this, "unresponsiveTimeout", 15e3);
    Ci(this, "deviceModel", null);
    Ci(this, "tracer");
    Ci(this, "_events", new Nt());
    /**
     * Send data to the device using the higher level API.
     *
     * @param {number} cla - The instruction class for the command.
     * @param {number} ins - The instruction code for the command.
     * @param {number} p1 - The first parameter for the instruction.
     * @param {number} p2 - The second parameter for the instruction.
     * @param {Buffer} data - The data to be sent. Defaults to an empty buffer.
     * @param {Array<number>} statusList - A list of acceptable status codes for the response. Defaults to [StatusCodes.OK].
     * @param {Object} options - Contains optional options for the exchange function
     *  - abortTimeoutMs: stop the send after a given timeout. Another timeout exists
     *    to detect unresponsive device (see `unresponsiveTimeout`). This timeout aborts the exchange.
     * @returns {Promise<Buffer>} A promise that resolves with the response data from the device.
     */
    Ci(this, "send", async (A, u, p, t, l = Buffer.alloc(0), m = [StatusCodes.OK], { abortTimeoutMs: b } = {}) => {
      const k = this.tracer.withUpdatedContext({ function: "send" });
      if (l.length >= 256)
        throw k.trace("data.length exceeded 256 bytes limit", { dataLength: l.length }), new TransportError("data.length exceed 256 bytes limit. Got: " + l.length, "DataLengthTooBig");
      k.trace("Starting an exchange", { abortTimeoutMs: b });
      const C = await this.exchange(
        // The size of the data is added in 1 byte just before `data`
        Buffer.concat([Buffer.from([A, u, p, t]), Buffer.from([l.length]), l]),
        { abortTimeoutMs: b }
      );
      k.trace("Received response from exchange");
      const B = C.readUInt16BE(C.length - 2);
      if (!m.some((Q) => Q === B))
        throw new TransportStatusError(B);
      return C;
    });
    // Blocks other exchange to happen concurrently
    Ci(this, "exchangeBusyPromise");
    Ci(this, "_appAPIlock", null);
    this.tracer = new LocalTracer(u ?? DEFAULT_LOG_TYPE, A);
  }
  /**
   * Send data to the device using a low level API.
   * It's recommended to use the "send" method for a higher level API.
   * @param {Buffer} apdu - The data to send.
   * @param {Object} options - Contains optional options for the exchange function
   *  - abortTimeoutMs: stop the exchange after a given timeout. Another timeout exists
   *    to detect unresponsive device (see `unresponsiveTimeout`). This timeout aborts the exchange.
   * @returns {Promise<Buffer>} A promise that resolves with the response data from the device.
   */
  exchange(A, { abortTimeoutMs: u } = {}) {
    throw new Error("exchange not implemented");
  }
  /**
   * Send apdus in batch to the device using a low level API.
   * The default implementation is to call exchange for each apdu.
   * @param {Array<Buffer>} apdus - array of apdus to send.
   * @param {Observer<Buffer>} observer - an observer that will receive the response of each apdu.
   * @returns {Subscription} A Subscription object on which you can call ".unsubscribe()" to stop sending apdus.
   */
  exchangeBulk(A, u) {
    let p = !1;
    const t = () => {
      p = !0;
    };
    return (async () => {
      if (!p)
        for (const m of A) {
          const b = await this.exchange(m);
          if (p)
            return;
          const k = b.readUInt16BE(b.length - 2);
          if (k !== StatusCodes.OK)
            throw new TransportStatusError(k);
          u.next(b);
        }
    })().then(() => !p && u.complete(), (m) => !p && u.error(m)), { unsubscribe: t };
  }
  /**
   * Set the "scramble key" for the next data exchanges with the device.
   * Each app can have a different scramble key and it is set internally during instantiation.
   * @param {string} key - The scramble key to set.
   * deprecated This method is no longer needed for modern transports and should be migrated away from.
   * no @ before deprecated as it breaks documentationjs on version 14.0.2
   * https://github.com/documentationjs/documentation/issues/1596
   */
  setScrambleKey(A) {
  }
  /**
   * Close the connection with the device.
   *
   * Note: for certain transports (hw-transport-node-hid-singleton for ex), once the promise resolved,
   * the transport instance is actually still cached, and the device is disconnected only after a defined timeout.
   * But for the consumer of the Transport, this does not matter and it can consider the transport to be closed.
   *
   * @returns {Promise<void>} A promise that resolves when the transport is closed.
   */
  close() {
    return Promise.resolve();
  }
  /**
   * Listen for an event on the transport instance.
   * Transport implementations may have specific events. Common events include:
   * "disconnect" : triggered when the transport is disconnected.
   * @param {string} eventName - The name of the event to listen for.
   * @param {(...args: Array<any>) => any} cb - The callback function to be invoked when the event occurs.
   */
  on(A, u) {
    this._events.on(A, u);
  }
  /**
   * Stop listening to an event on an instance of transport.
   */
  off(A, u) {
    this._events.removeListener(A, u);
  }
  emit(A, ...u) {
    this._events.emit(A, ...u);
  }
  /**
   * Enable or not logs of the binary exchange
   */
  setDebugMode() {
    console.warn("setDebugMode is deprecated. use @ledgerhq/logs instead. No logs are emitted in this anymore.");
  }
  /**
   * Set a timeout (in milliseconds) for the exchange call. Only some transport might implement it. (e.g. U2F)
   */
  setExchangeTimeout(A) {
    this.exchangeTimeout = A;
  }
  /**
   * Define the delay before emitting "unresponsive" on an exchange that does not respond
   */
  setExchangeUnresponsiveTimeout(A) {
    this.unresponsiveTimeout = A;
  }
  /**
   * create() allows to open the first descriptor available or
   * throw if there is none or if timeout is reached.
   * This is a light helper, alternative to using listen() and open() (that you may need for any more advanced usecase)
   * @example
  TransportFoo.create().then(transport => ...)
   */
  static create(A = 3e3, u) {
    return new Promise((p, t) => {
      let l = !1;
      const m = this.listen({
        next: (k) => {
          l = !0, m && m.unsubscribe(), b && clearTimeout(b), this.open(k.descriptor, A).then(p, t);
        },
        error: (k) => {
          b && clearTimeout(b), t(k);
        },
        complete: () => {
          b && clearTimeout(b), l || t(new TransportError(this.ErrorMessage_NoDeviceFound, "NoDeviceFound"));
        }
      }), b = u ? setTimeout(() => {
        m.unsubscribe(), t(new TransportError(this.ErrorMessage_ListenTimeout, "ListenTimeout"));
      }, u) : null;
    });
  }
  /**
   * Wrapper to make an exchange "atomic" (blocking any other exchange)
   *
   * It also handles "unresponsiveness" by emitting "unresponsive" and "responsive" events.
   *
   * @param f The exchange job, using the transport to run
   * @returns a Promise resolving with the output of the given job
   */
  async exchangeAtomicImpl(A) {
    const u = this.tracer.withUpdatedContext({
      function: "exchangeAtomicImpl",
      unresponsiveTimeout: this.unresponsiveTimeout
    });
    if (this.exchangeBusyPromise)
      throw u.trace("Atomic exchange is already busy"), new TransportRaceCondition("An action was already pending on the Ledger device. Please deny or reconnect.");
    let p;
    const t = new Promise((b) => {
      p = b;
    });
    this.exchangeBusyPromise = t;
    let l = !1;
    const m = setTimeout(() => {
      u.trace('Timeout reached, emitting Transport event "unresponsive"', {
        unresponsiveTimeout: this.unresponsiveTimeout
      }), l = !0, this.emit("unresponsive");
    }, this.unresponsiveTimeout);
    try {
      const b = await A();
      return l && (u.trace("Device was unresponsive, emitting responsive"), this.emit("responsive")), b;
    } finally {
      u.trace("Finalize, clearing busy guard"), clearTimeout(m), p && p(), this.exchangeBusyPromise = null;
    }
  }
  decorateAppAPIMethods(A, u, p) {
    for (const t of u)
      A[t] = this.decorateAppAPIMethod(t, A[t], A, p);
  }
  decorateAppAPIMethod(A, u, p, t) {
    return async (...l) => {
      const { _appAPIlock: m } = this;
      if (m)
        return Promise.reject(new TransportError("Ledger Device is busy (lock " + m + ")", "TransportLocked"));
      try {
        return this._appAPIlock = A, this.setScrambleKey(t), await u.apply(p, l);
      } finally {
        this._appAPIlock = null;
      }
    };
  }
  /**
   * Sets the context used by the logging/tracing mechanism
   *
   * Useful when re-using (cached) the same Transport instance,
   * but with a new tracing context.
   *
   * @param context A TraceContext, that can undefined to reset the context
   */
  setTraceContext(A) {
    this.tracer = this.tracer.withContext(A);
  }
  /**
   * Updates the context used by the logging/tracing mechanism
   *
   * The update only overrides the key-value that are already defined in the current context.
   *
   * @param contextToAdd A TraceContext that will be added to the current context
   */
  updateTraceContext(A) {
    this.tracer.updateContext(A);
  }
  /**
   * Gets the tracing context of the transport instance
   */
  getTraceContext() {
    return this.tracer.getContext();
  }
}
/**
 * Check if the transport is supported on the current platform/browser.
 * @returns {Promise<boolean>} A promise that resolves with a boolean indicating support.
 */
Ci(Transport, "isSupported"), /**
 * List all available descriptors for the transport.
 * For a better granularity, checkout `listen()`.
 *
 * @returns {Promise<Array<any>>} A promise that resolves with an array of descriptors.
 * @example
 * TransportFoo.list().then(descriptors => ...)
 */
Ci(Transport, "list"), /**
 * Listen for device events for the transport. The method takes an observer of DescriptorEvent and returns a Subscription.
 * A DescriptorEvent is an object containing a "descriptor" and a "type" field. The "type" field can be "add" or "remove", and the "descriptor" field can be passed to the "open" method.
 * The "listen" method will first emit all currently connected devices and then will emit events as they occur, such as when a USB device is plugged in or a Bluetooth device becomes discoverable.
 * @param {Observer<DescriptorEvent<any>>} observer - An object with "next", "error", and "complete" functions, following the observer pattern.
 * @returns {Subscription} A Subscription object on which you can call ".unsubscribe()" to stop listening to descriptors.
 * @example
const sub = TransportFoo.listen({
next: e => {
  if (e.type==="add") {
    sub.unsubscribe();
    const transport = await TransportFoo.open(e.descriptor);
    ...
  }
},
error: error => {},
complete: () => {}
})
 */
Ci(Transport, "listen"), /**
 * Attempt to create a Transport instance with a specific descriptor.
 * @param {any} descriptor - The descriptor to open the transport with.
 * @param {number} timeout - An optional timeout for the transport connection.
 * @param {TraceContext} context Optional tracing/log context
 * @returns {Promise<Transport>} A promise that resolves with a Transport instance.
 * @example
TransportFoo.open(descriptor).then(transport => ...)
 */
Ci(Transport, "open"), Ci(Transport, "ErrorMessage_ListenTimeout", "No Ledger device found (timeout)"), Ci(Transport, "ErrorMessage_NoDeviceFound", "No Ledger device found");
const Tag = 5;
function asUInt16BE(s) {
  const A = Buffer.alloc(2);
  return A.writeUInt16BE(s, 0), A;
}
const initialAcc = {
  data: Buffer.alloc(0),
  dataLength: 0,
  sequence: 0
}, createHIDframing = (s, A) => ({
  /**
   * Frames/encodes an APDU message into HID USB packets/frames
   *
   * @param apdu The APDU message to send, in a Buffer containing [cla, ins, p1, p2, data length, data(if not empty)]
   * @returns an array of HID USB frames ready to be sent
   */
  makeBlocks(u) {
    let p = Buffer.concat([asUInt16BE(u.length), u]);
    const t = A - 5, l = Math.ceil(p.length / t);
    p = Buffer.concat([p, Buffer.alloc(l * t - p.length + 1).fill(0)]);
    const m = [];
    for (let b = 0; b < l; b++) {
      const k = Buffer.alloc(5);
      k.writeUInt16BE(s, 0), k.writeUInt8(Tag, 2), k.writeUInt16BE(b, 3);
      const C = p.slice(b * t, (b + 1) * t);
      m.push(Buffer.concat([k, C]));
    }
    return m;
  },
  /**
   * Reduces HID USB packets/frames to one response.
   *
   * @param acc The value resulting from (accumulating) the previous call of reduceResponse.
   *   On first call initialized to `initialAcc`. The accumulator enables handling multi-frames messages.
   * @param chunk Current chunk to reduce into accumulator
   * @returns An accumulator value updated with the current chunk
   */
  reduceResponse(u, p) {
    let { data: t, dataLength: l, sequence: m } = u || initialAcc;
    if (p.readUInt16BE(0) !== s)
      throw new TransportError("Invalid channel", "InvalidChannel");
    if (p.readUInt8(2) !== Tag)
      throw new TransportError("Invalid tag", "InvalidTag");
    if (p.readUInt16BE(3) !== m)
      throw new TransportError("Invalid sequence", "InvalidSequence");
    u || (l = p.readUInt16BE(5)), m++;
    const b = p.slice(u ? 5 : 7);
    return t = Buffer.concat([t, b]), t.length > l && (t = t.slice(0, l)), {
      data: t,
      dataLength: l,
      sequence: m
    };
  },
  /**
   * Returns the response message that has been reduced from the HID USB frames
   *
   * @param acc The accumulator
   * @returns A Buffer containing the cleaned response message, or null if no response message, or undefined if the
   *   accumulator is incorrect (message length is not valid)
   */
  getReducedResult(u) {
    if (u && u.dataLength === u.data.length)
      return u.data;
  }
});
var re$1 = { exports: {} }, constants, hasRequiredConstants;
function requireConstants() {
  if (hasRequiredConstants) return constants;
  hasRequiredConstants = 1;
  const s = "2.0.0", A = 256, u = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
  9007199254740991, p = 16, t = A - 6;
  return constants = {
    MAX_LENGTH: A,
    MAX_SAFE_COMPONENT_LENGTH: p,
    MAX_SAFE_BUILD_LENGTH: t,
    MAX_SAFE_INTEGER: u,
    RELEASE_TYPES: [
      "major",
      "premajor",
      "minor",
      "preminor",
      "patch",
      "prepatch",
      "prerelease"
    ],
    SEMVER_SPEC_VERSION: s,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
  }, constants;
}
var debug_1, hasRequiredDebug;
function requireDebug() {
  return hasRequiredDebug || (hasRequiredDebug = 1, debug_1 = typeof process$1 == "object" && process$1.env && process$1.env.NODE_DEBUG && /\bsemver\b/i.test(process$1.env.NODE_DEBUG) ? (...A) => console.error("SEMVER", ...A) : () => {
  }), debug_1;
}
var hasRequiredRe$1;
function requireRe$1() {
  return hasRequiredRe$1 || (hasRequiredRe$1 = 1, function(s, A) {
    const {
      MAX_SAFE_COMPONENT_LENGTH: u,
      MAX_SAFE_BUILD_LENGTH: p,
      MAX_LENGTH: t
    } = requireConstants(), l = requireDebug();
    A = s.exports = {};
    const m = A.re = [], b = A.safeRe = [], k = A.src = [], C = A.safeSrc = [], B = A.t = {};
    let Q = 0;
    const P = "[a-zA-Z0-9-]", x = [
      ["\\s", 1],
      ["\\d", t],
      [P, p]
    ], M = (le) => {
      for (const [ge, pe] of x)
        le = le.split(`${ge}*`).join(`${ge}{0,${pe}}`).split(`${ge}+`).join(`${ge}{1,${pe}}`);
      return le;
    }, F = (le, ge, pe) => {
      const Ie = M(ge), be = Q++;
      l(le, be, ge), B[le] = be, k[be] = ge, C[be] = Ie, m[be] = new RegExp(ge, pe ? "g" : void 0), b[be] = new RegExp(Ie, pe ? "g" : void 0);
    };
    F("NUMERICIDENTIFIER", "0|[1-9]\\d*"), F("NUMERICIDENTIFIERLOOSE", "\\d+"), F("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${P}*`), F("MAINVERSION", `(${k[B.NUMERICIDENTIFIER]})\\.(${k[B.NUMERICIDENTIFIER]})\\.(${k[B.NUMERICIDENTIFIER]})`), F("MAINVERSIONLOOSE", `(${k[B.NUMERICIDENTIFIERLOOSE]})\\.(${k[B.NUMERICIDENTIFIERLOOSE]})\\.(${k[B.NUMERICIDENTIFIERLOOSE]})`), F("PRERELEASEIDENTIFIER", `(?:${k[B.NONNUMERICIDENTIFIER]}|${k[B.NUMERICIDENTIFIER]})`), F("PRERELEASEIDENTIFIERLOOSE", `(?:${k[B.NONNUMERICIDENTIFIER]}|${k[B.NUMERICIDENTIFIERLOOSE]})`), F("PRERELEASE", `(?:-(${k[B.PRERELEASEIDENTIFIER]}(?:\\.${k[B.PRERELEASEIDENTIFIER]})*))`), F("PRERELEASELOOSE", `(?:-?(${k[B.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${k[B.PRERELEASEIDENTIFIERLOOSE]})*))`), F("BUILDIDENTIFIER", `${P}+`), F("BUILD", `(?:\\+(${k[B.BUILDIDENTIFIER]}(?:\\.${k[B.BUILDIDENTIFIER]})*))`), F("FULLPLAIN", `v?${k[B.MAINVERSION]}${k[B.PRERELEASE]}?${k[B.BUILD]}?`), F("FULL", `^${k[B.FULLPLAIN]}$`), F("LOOSEPLAIN", `[v=\\s]*${k[B.MAINVERSIONLOOSE]}${k[B.PRERELEASELOOSE]}?${k[B.BUILD]}?`), F("LOOSE", `^${k[B.LOOSEPLAIN]}$`), F("GTLT", "((?:<|>)?=?)"), F("XRANGEIDENTIFIERLOOSE", `${k[B.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), F("XRANGEIDENTIFIER", `${k[B.NUMERICIDENTIFIER]}|x|X|\\*`), F("XRANGEPLAIN", `[v=\\s]*(${k[B.XRANGEIDENTIFIER]})(?:\\.(${k[B.XRANGEIDENTIFIER]})(?:\\.(${k[B.XRANGEIDENTIFIER]})(?:${k[B.PRERELEASE]})?${k[B.BUILD]}?)?)?`), F("XRANGEPLAINLOOSE", `[v=\\s]*(${k[B.XRANGEIDENTIFIERLOOSE]})(?:\\.(${k[B.XRANGEIDENTIFIERLOOSE]})(?:\\.(${k[B.XRANGEIDENTIFIERLOOSE]})(?:${k[B.PRERELEASELOOSE]})?${k[B.BUILD]}?)?)?`), F("XRANGE", `^${k[B.GTLT]}\\s*${k[B.XRANGEPLAIN]}$`), F("XRANGELOOSE", `^${k[B.GTLT]}\\s*${k[B.XRANGEPLAINLOOSE]}$`), F("COERCEPLAIN", `(^|[^\\d])(\\d{1,${u}})(?:\\.(\\d{1,${u}}))?(?:\\.(\\d{1,${u}}))?`), F("COERCE", `${k[B.COERCEPLAIN]}(?:$|[^\\d])`), F("COERCEFULL", k[B.COERCEPLAIN] + `(?:${k[B.PRERELEASE]})?(?:${k[B.BUILD]})?(?:$|[^\\d])`), F("COERCERTL", k[B.COERCE], !0), F("COERCERTLFULL", k[B.COERCEFULL], !0), F("LONETILDE", "(?:~>?)"), F("TILDETRIM", `(\\s*)${k[B.LONETILDE]}\\s+`, !0), A.tildeTrimReplace = "$1~", F("TILDE", `^${k[B.LONETILDE]}${k[B.XRANGEPLAIN]}$`), F("TILDELOOSE", `^${k[B.LONETILDE]}${k[B.XRANGEPLAINLOOSE]}$`), F("LONECARET", "(?:\\^)"), F("CARETTRIM", `(\\s*)${k[B.LONECARET]}\\s+`, !0), A.caretTrimReplace = "$1^", F("CARET", `^${k[B.LONECARET]}${k[B.XRANGEPLAIN]}$`), F("CARETLOOSE", `^${k[B.LONECARET]}${k[B.XRANGEPLAINLOOSE]}$`), F("COMPARATORLOOSE", `^${k[B.GTLT]}\\s*(${k[B.LOOSEPLAIN]})$|^$`), F("COMPARATOR", `^${k[B.GTLT]}\\s*(${k[B.FULLPLAIN]})$|^$`), F("COMPARATORTRIM", `(\\s*)${k[B.GTLT]}\\s*(${k[B.LOOSEPLAIN]}|${k[B.XRANGEPLAIN]})`, !0), A.comparatorTrimReplace = "$1$2$3", F("HYPHENRANGE", `^\\s*(${k[B.XRANGEPLAIN]})\\s+-\\s+(${k[B.XRANGEPLAIN]})\\s*$`), F("HYPHENRANGELOOSE", `^\\s*(${k[B.XRANGEPLAINLOOSE]})\\s+-\\s+(${k[B.XRANGEPLAINLOOSE]})\\s*$`), F("STAR", "(<|>)?=?\\s*\\*"), F("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), F("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
  }(re$1, re$1.exports)), re$1.exports;
}
var parseOptions_1, hasRequiredParseOptions;
function requireParseOptions() {
  if (hasRequiredParseOptions) return parseOptions_1;
  hasRequiredParseOptions = 1;
  const s = Object.freeze({ loose: !0 }), A = Object.freeze({});
  return parseOptions_1 = (p) => p ? typeof p != "object" ? s : p : A, parseOptions_1;
}
var identifiers, hasRequiredIdentifiers;
function requireIdentifiers() {
  if (hasRequiredIdentifiers) return identifiers;
  hasRequiredIdentifiers = 1;
  const s = /^[0-9]+$/, A = (p, t) => {
    const l = s.test(p), m = s.test(t);
    return l && m && (p = +p, t = +t), p === t ? 0 : l && !m ? -1 : m && !l ? 1 : p < t ? -1 : 1;
  };
  return identifiers = {
    compareIdentifiers: A,
    rcompareIdentifiers: (p, t) => A(t, p)
  }, identifiers;
}
var semver$2, hasRequiredSemver$1;
function requireSemver$1() {
  if (hasRequiredSemver$1) return semver$2;
  hasRequiredSemver$1 = 1;
  const s = requireDebug(), { MAX_LENGTH: A, MAX_SAFE_INTEGER: u } = requireConstants(), { safeRe: p, t } = requireRe$1(), l = requireParseOptions(), { compareIdentifiers: m } = requireIdentifiers();
  class b {
    constructor(C, B) {
      if (B = l(B), C instanceof b) {
        if (C.loose === !!B.loose && C.includePrerelease === !!B.includePrerelease)
          return C;
        C = C.version;
      } else if (typeof C != "string")
        throw new TypeError(`Invalid version. Must be a string. Got type "${typeof C}".`);
      if (C.length > A)
        throw new TypeError(
          `version is longer than ${A} characters`
        );
      s("SemVer", C, B), this.options = B, this.loose = !!B.loose, this.includePrerelease = !!B.includePrerelease;
      const Q = C.trim().match(B.loose ? p[t.LOOSE] : p[t.FULL]);
      if (!Q)
        throw new TypeError(`Invalid Version: ${C}`);
      if (this.raw = C, this.major = +Q[1], this.minor = +Q[2], this.patch = +Q[3], this.major > u || this.major < 0)
        throw new TypeError("Invalid major version");
      if (this.minor > u || this.minor < 0)
        throw new TypeError("Invalid minor version");
      if (this.patch > u || this.patch < 0)
        throw new TypeError("Invalid patch version");
      Q[4] ? this.prerelease = Q[4].split(".").map((P) => {
        if (/^[0-9]+$/.test(P)) {
          const x = +P;
          if (x >= 0 && x < u)
            return x;
        }
        return P;
      }) : this.prerelease = [], this.build = Q[5] ? Q[5].split(".") : [], this.format();
    }
    format() {
      return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
    }
    toString() {
      return this.version;
    }
    compare(C) {
      if (s("SemVer.compare", this.version, this.options, C), !(C instanceof b)) {
        if (typeof C == "string" && C === this.version)
          return 0;
        C = new b(C, this.options);
      }
      return C.version === this.version ? 0 : this.compareMain(C) || this.comparePre(C);
    }
    compareMain(C) {
      return C instanceof b || (C = new b(C, this.options)), m(this.major, C.major) || m(this.minor, C.minor) || m(this.patch, C.patch);
    }
    comparePre(C) {
      if (C instanceof b || (C = new b(C, this.options)), this.prerelease.length && !C.prerelease.length)
        return -1;
      if (!this.prerelease.length && C.prerelease.length)
        return 1;
      if (!this.prerelease.length && !C.prerelease.length)
        return 0;
      let B = 0;
      do {
        const Q = this.prerelease[B], P = C.prerelease[B];
        if (s("prerelease compare", B, Q, P), Q === void 0 && P === void 0)
          return 0;
        if (P === void 0)
          return 1;
        if (Q === void 0)
          return -1;
        if (Q === P)
          continue;
        return m(Q, P);
      } while (++B);
    }
    compareBuild(C) {
      C instanceof b || (C = new b(C, this.options));
      let B = 0;
      do {
        const Q = this.build[B], P = C.build[B];
        if (s("build compare", B, Q, P), Q === void 0 && P === void 0)
          return 0;
        if (P === void 0)
          return 1;
        if (Q === void 0)
          return -1;
        if (Q === P)
          continue;
        return m(Q, P);
      } while (++B);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(C, B, Q) {
      if (C.startsWith("pre")) {
        if (!B && Q === !1)
          throw new Error("invalid increment argument: identifier is empty");
        if (B) {
          const P = `-${B}`.match(this.options.loose ? p[t.PRERELEASELOOSE] : p[t.PRERELEASE]);
          if (!P || P[1] !== B)
            throw new Error(`invalid identifier: ${B}`);
        }
      }
      switch (C) {
        case "premajor":
          this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", B, Q);
          break;
        case "preminor":
          this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", B, Q);
          break;
        case "prepatch":
          this.prerelease.length = 0, this.inc("patch", B, Q), this.inc("pre", B, Q);
          break;
        // If the input is a non-prerelease version, this acts the same as
        // prepatch.
        case "prerelease":
          this.prerelease.length === 0 && this.inc("patch", B, Q), this.inc("pre", B, Q);
          break;
        case "release":
          if (this.prerelease.length === 0)
            throw new Error(`version ${this.raw} is not a prerelease`);
          this.prerelease.length = 0;
          break;
        case "major":
          (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
          break;
        case "minor":
          (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
          break;
        case "patch":
          this.prerelease.length === 0 && this.patch++, this.prerelease = [];
          break;
        // This probably shouldn't be used publicly.
        // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
        case "pre": {
          const P = Number(Q) ? 1 : 0;
          if (this.prerelease.length === 0)
            this.prerelease = [P];
          else {
            let x = this.prerelease.length;
            for (; --x >= 0; )
              typeof this.prerelease[x] == "number" && (this.prerelease[x]++, x = -2);
            if (x === -1) {
              if (B === this.prerelease.join(".") && Q === !1)
                throw new Error("invalid increment argument: identifier already exists");
              this.prerelease.push(P);
            }
          }
          if (B) {
            let x = [B, P];
            Q === !1 && (x = [B]), m(this.prerelease[0], B) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = x) : this.prerelease = x;
          }
          break;
        }
        default:
          throw new Error(`invalid increment argument: ${C}`);
      }
      return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(".")}`), this;
    }
  }
  return semver$2 = b, semver$2;
}
var parse_1, hasRequiredParse;
function requireParse() {
  if (hasRequiredParse) return parse_1;
  hasRequiredParse = 1;
  const s = requireSemver$1();
  return parse_1 = (u, p, t = !1) => {
    if (u instanceof s)
      return u;
    try {
      return new s(u, p);
    } catch (l) {
      if (!t)
        return null;
      throw l;
    }
  }, parse_1;
}
var valid_1, hasRequiredValid$1;
function requireValid$1() {
  if (hasRequiredValid$1) return valid_1;
  hasRequiredValid$1 = 1;
  const s = requireParse();
  return valid_1 = (u, p) => {
    const t = s(u, p);
    return t ? t.version : null;
  }, valid_1;
}
var clean_1, hasRequiredClean;
function requireClean() {
  if (hasRequiredClean) return clean_1;
  hasRequiredClean = 1;
  const s = requireParse();
  return clean_1 = (u, p) => {
    const t = s(u.trim().replace(/^[=v]+/, ""), p);
    return t ? t.version : null;
  }, clean_1;
}
var inc_1, hasRequiredInc;
function requireInc() {
  if (hasRequiredInc) return inc_1;
  hasRequiredInc = 1;
  const s = requireSemver$1();
  return inc_1 = (u, p, t, l, m) => {
    typeof t == "string" && (m = l, l = t, t = void 0);
    try {
      return new s(
        u instanceof s ? u.version : u,
        t
      ).inc(p, l, m).version;
    } catch {
      return null;
    }
  }, inc_1;
}
var diff_1, hasRequiredDiff;
function requireDiff() {
  if (hasRequiredDiff) return diff_1;
  hasRequiredDiff = 1;
  const s = requireParse();
  return diff_1 = (u, p) => {
    const t = s(u, null, !0), l = s(p, null, !0), m = t.compare(l);
    if (m === 0)
      return null;
    const b = m > 0, k = b ? t : l, C = b ? l : t, B = !!k.prerelease.length;
    if (!!C.prerelease.length && !B) {
      if (!C.patch && !C.minor)
        return "major";
      if (C.compareMain(k) === 0)
        return C.minor && !C.patch ? "minor" : "patch";
    }
    const P = B ? "pre" : "";
    return t.major !== l.major ? P + "major" : t.minor !== l.minor ? P + "minor" : t.patch !== l.patch ? P + "patch" : "prerelease";
  }, diff_1;
}
var major_1, hasRequiredMajor;
function requireMajor() {
  if (hasRequiredMajor) return major_1;
  hasRequiredMajor = 1;
  const s = requireSemver$1();
  return major_1 = (u, p) => new s(u, p).major, major_1;
}
var minor_1, hasRequiredMinor;
function requireMinor() {
  if (hasRequiredMinor) return minor_1;
  hasRequiredMinor = 1;
  const s = requireSemver$1();
  return minor_1 = (u, p) => new s(u, p).minor, minor_1;
}
var patch_1, hasRequiredPatch;
function requirePatch() {
  if (hasRequiredPatch) return patch_1;
  hasRequiredPatch = 1;
  const s = requireSemver$1();
  return patch_1 = (u, p) => new s(u, p).patch, patch_1;
}
var prerelease_1, hasRequiredPrerelease;
function requirePrerelease() {
  if (hasRequiredPrerelease) return prerelease_1;
  hasRequiredPrerelease = 1;
  const s = requireParse();
  return prerelease_1 = (u, p) => {
    const t = s(u, p);
    return t && t.prerelease.length ? t.prerelease : null;
  }, prerelease_1;
}
var compare_1, hasRequiredCompare;
function requireCompare() {
  if (hasRequiredCompare) return compare_1;
  hasRequiredCompare = 1;
  const s = requireSemver$1();
  return compare_1 = (u, p, t) => new s(u, t).compare(new s(p, t)), compare_1;
}
var rcompare_1, hasRequiredRcompare;
function requireRcompare() {
  if (hasRequiredRcompare) return rcompare_1;
  hasRequiredRcompare = 1;
  const s = requireCompare();
  return rcompare_1 = (u, p, t) => s(p, u, t), rcompare_1;
}
var compareLoose_1, hasRequiredCompareLoose;
function requireCompareLoose() {
  if (hasRequiredCompareLoose) return compareLoose_1;
  hasRequiredCompareLoose = 1;
  const s = requireCompare();
  return compareLoose_1 = (u, p) => s(u, p, !0), compareLoose_1;
}
var compareBuild_1, hasRequiredCompareBuild;
function requireCompareBuild() {
  if (hasRequiredCompareBuild) return compareBuild_1;
  hasRequiredCompareBuild = 1;
  const s = requireSemver$1();
  return compareBuild_1 = (u, p, t) => {
    const l = new s(u, t), m = new s(p, t);
    return l.compare(m) || l.compareBuild(m);
  }, compareBuild_1;
}
var sort_1, hasRequiredSort;
function requireSort() {
  if (hasRequiredSort) return sort_1;
  hasRequiredSort = 1;
  const s = requireCompareBuild();
  return sort_1 = (u, p) => u.sort((t, l) => s(t, l, p)), sort_1;
}
var rsort_1, hasRequiredRsort;
function requireRsort() {
  if (hasRequiredRsort) return rsort_1;
  hasRequiredRsort = 1;
  const s = requireCompareBuild();
  return rsort_1 = (u, p) => u.sort((t, l) => s(l, t, p)), rsort_1;
}
var gt_1, hasRequiredGt;
function requireGt() {
  if (hasRequiredGt) return gt_1;
  hasRequiredGt = 1;
  const s = requireCompare();
  return gt_1 = (u, p, t) => s(u, p, t) > 0, gt_1;
}
var lt_1, hasRequiredLt;
function requireLt() {
  if (hasRequiredLt) return lt_1;
  hasRequiredLt = 1;
  const s = requireCompare();
  return lt_1 = (u, p, t) => s(u, p, t) < 0, lt_1;
}
var eq_1, hasRequiredEq;
function requireEq() {
  if (hasRequiredEq) return eq_1;
  hasRequiredEq = 1;
  const s = requireCompare();
  return eq_1 = (u, p, t) => s(u, p, t) === 0, eq_1;
}
var neq_1, hasRequiredNeq;
function requireNeq() {
  if (hasRequiredNeq) return neq_1;
  hasRequiredNeq = 1;
  const s = requireCompare();
  return neq_1 = (u, p, t) => s(u, p, t) !== 0, neq_1;
}
var gte_1, hasRequiredGte;
function requireGte() {
  if (hasRequiredGte) return gte_1;
  hasRequiredGte = 1;
  const s = requireCompare();
  return gte_1 = (u, p, t) => s(u, p, t) >= 0, gte_1;
}
var lte_1, hasRequiredLte;
function requireLte() {
  if (hasRequiredLte) return lte_1;
  hasRequiredLte = 1;
  const s = requireCompare();
  return lte_1 = (u, p, t) => s(u, p, t) <= 0, lte_1;
}
var cmp_1, hasRequiredCmp;
function requireCmp() {
  if (hasRequiredCmp) return cmp_1;
  hasRequiredCmp = 1;
  const s = requireEq(), A = requireNeq(), u = requireGt(), p = requireGte(), t = requireLt(), l = requireLte();
  return cmp_1 = (b, k, C, B) => {
    switch (k) {
      case "===":
        return typeof b == "object" && (b = b.version), typeof C == "object" && (C = C.version), b === C;
      case "!==":
        return typeof b == "object" && (b = b.version), typeof C == "object" && (C = C.version), b !== C;
      case "":
      case "=":
      case "==":
        return s(b, C, B);
      case "!=":
        return A(b, C, B);
      case ">":
        return u(b, C, B);
      case ">=":
        return p(b, C, B);
      case "<":
        return t(b, C, B);
      case "<=":
        return l(b, C, B);
      default:
        throw new TypeError(`Invalid operator: ${k}`);
    }
  }, cmp_1;
}
var coerce_1, hasRequiredCoerce;
function requireCoerce() {
  if (hasRequiredCoerce) return coerce_1;
  hasRequiredCoerce = 1;
  const s = requireSemver$1(), A = requireParse(), { safeRe: u, t: p } = requireRe$1();
  return coerce_1 = (l, m) => {
    if (l instanceof s)
      return l;
    if (typeof l == "number" && (l = String(l)), typeof l != "string")
      return null;
    m = m || {};
    let b = null;
    if (!m.rtl)
      b = l.match(m.includePrerelease ? u[p.COERCEFULL] : u[p.COERCE]);
    else {
      const x = m.includePrerelease ? u[p.COERCERTLFULL] : u[p.COERCERTL];
      let M;
      for (; (M = x.exec(l)) && (!b || b.index + b[0].length !== l.length); )
        (!b || M.index + M[0].length !== b.index + b[0].length) && (b = M), x.lastIndex = M.index + M[1].length + M[2].length;
      x.lastIndex = -1;
    }
    if (b === null)
      return null;
    const k = b[2], C = b[3] || "0", B = b[4] || "0", Q = m.includePrerelease && b[5] ? `-${b[5]}` : "", P = m.includePrerelease && b[6] ? `+${b[6]}` : "";
    return A(`${k}.${C}.${B}${Q}${P}`, m);
  }, coerce_1;
}
var lrucache, hasRequiredLrucache;
function requireLrucache() {
  if (hasRequiredLrucache) return lrucache;
  hasRequiredLrucache = 1;
  class s {
    constructor() {
      this.max = 1e3, this.map = /* @__PURE__ */ new Map();
    }
    get(u) {
      const p = this.map.get(u);
      if (p !== void 0)
        return this.map.delete(u), this.map.set(u, p), p;
    }
    delete(u) {
      return this.map.delete(u);
    }
    set(u, p) {
      if (!this.delete(u) && p !== void 0) {
        if (this.map.size >= this.max) {
          const l = this.map.keys().next().value;
          this.delete(l);
        }
        this.map.set(u, p);
      }
      return this;
    }
  }
  return lrucache = s, lrucache;
}
var range, hasRequiredRange;
function requireRange() {
  if (hasRequiredRange) return range;
  hasRequiredRange = 1;
  const s = /\s+/g;
  class A {
    constructor(Ne, rr) {
      if (rr = t(rr), Ne instanceof A)
        return Ne.loose === !!rr.loose && Ne.includePrerelease === !!rr.includePrerelease ? Ne : new A(Ne.raw, rr);
      if (Ne instanceof l)
        return this.raw = Ne.value, this.set = [[Ne]], this.formatted = void 0, this;
      if (this.options = rr, this.loose = !!rr.loose, this.includePrerelease = !!rr.includePrerelease, this.raw = Ne.trim().replace(s, " "), this.set = this.raw.split("||").map((er) => this.parseRange(er.trim())).filter((er) => er.length), !this.set.length)
        throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
      if (this.set.length > 1) {
        const er = this.set[0];
        if (this.set = this.set.filter((ir) => !F(ir[0])), this.set.length === 0)
          this.set = [er];
        else if (this.set.length > 1) {
          for (const ir of this.set)
            if (ir.length === 1 && le(ir[0])) {
              this.set = [ir];
              break;
            }
        }
      }
      this.formatted = void 0;
    }
    get range() {
      if (this.formatted === void 0) {
        this.formatted = "";
        for (let Ne = 0; Ne < this.set.length; Ne++) {
          Ne > 0 && (this.formatted += "||");
          const rr = this.set[Ne];
          for (let er = 0; er < rr.length; er++)
            er > 0 && (this.formatted += " "), this.formatted += rr[er].toString().trim();
        }
      }
      return this.formatted;
    }
    format() {
      return this.range;
    }
    toString() {
      return this.range;
    }
    parseRange(Ne) {
      const er = ((this.options.includePrerelease && x) | (this.options.loose && M)) + ":" + Ne, ir = p.get(er);
      if (ir)
        return ir;
      const sr = this.options.loose, nr = sr ? k[C.HYPHENRANGELOOSE] : k[C.HYPHENRANGE];
      Ne = Ne.replace(nr, we(this.options.includePrerelease)), m("hyphen replace", Ne), Ne = Ne.replace(k[C.COMPARATORTRIM], B), m("comparator trim", Ne), Ne = Ne.replace(k[C.TILDETRIM], Q), m("tilde trim", Ne), Ne = Ne.replace(k[C.CARETTRIM], P), m("caret trim", Ne);
      let fr = Ne.split(" ").map((Fr) => pe(Fr, this.options)).join(" ").split(/\s+/).map((Fr) => ve(Fr, this.options));
      sr && (fr = fr.filter((Fr) => (m("loose invalid filter", Fr, this.options), !!Fr.match(k[C.COMPARATORLOOSE])))), m("range list", fr);
      const lr = /* @__PURE__ */ new Map(), br = fr.map((Fr) => new l(Fr, this.options));
      for (const Fr of br) {
        if (F(Fr))
          return [Fr];
        lr.set(Fr.value, Fr);
      }
      lr.size > 1 && lr.has("") && lr.delete("");
      const Br = [...lr.values()];
      return p.set(er, Br), Br;
    }
    intersects(Ne, rr) {
      if (!(Ne instanceof A))
        throw new TypeError("a Range is required");
      return this.set.some((er) => ge(er, rr) && Ne.set.some((ir) => ge(ir, rr) && er.every((sr) => ir.every((nr) => sr.intersects(nr, rr)))));
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(Ne) {
      if (!Ne)
        return !1;
      if (typeof Ne == "string")
        try {
          Ne = new b(Ne, this.options);
        } catch {
          return !1;
        }
      for (let rr = 0; rr < this.set.length; rr++)
        if (Ce(this.set[rr], Ne, this.options))
          return !0;
      return !1;
    }
  }
  range = A;
  const u = requireLrucache(), p = new u(), t = requireParseOptions(), l = requireComparator(), m = requireDebug(), b = requireSemver$1(), {
    safeRe: k,
    t: C,
    comparatorTrimReplace: B,
    tildeTrimReplace: Q,
    caretTrimReplace: P
  } = requireRe$1(), { FLAG_INCLUDE_PRERELEASE: x, FLAG_LOOSE: M } = requireConstants(), F = (Se) => Se.value === "<0.0.0-0", le = (Se) => Se.value === "", ge = (Se, Ne) => {
    let rr = !0;
    const er = Se.slice();
    let ir = er.pop();
    for (; rr && er.length; )
      rr = er.every((sr) => ir.intersects(sr, Ne)), ir = er.pop();
    return rr;
  }, pe = (Se, Ne) => (m("comp", Se, Ne), Se = Te(Se, Ne), m("caret", Se), Se = be(Se, Ne), m("tildes", Se), Se = xe(Se, Ne), m("xrange", Se), Se = He(Se, Ne), m("stars", Se), Se), Ie = (Se) => !Se || Se.toLowerCase() === "x" || Se === "*", be = (Se, Ne) => Se.trim().split(/\s+/).map((rr) => Pe(rr, Ne)).join(" "), Pe = (Se, Ne) => {
    const rr = Ne.loose ? k[C.TILDELOOSE] : k[C.TILDE];
    return Se.replace(rr, (er, ir, sr, nr, fr) => {
      m("tilde", Se, er, ir, sr, nr, fr);
      let lr;
      return Ie(ir) ? lr = "" : Ie(sr) ? lr = `>=${ir}.0.0 <${+ir + 1}.0.0-0` : Ie(nr) ? lr = `>=${ir}.${sr}.0 <${ir}.${+sr + 1}.0-0` : fr ? (m("replaceTilde pr", fr), lr = `>=${ir}.${sr}.${nr}-${fr} <${ir}.${+sr + 1}.0-0`) : lr = `>=${ir}.${sr}.${nr} <${ir}.${+sr + 1}.0-0`, m("tilde return", lr), lr;
    });
  }, Te = (Se, Ne) => Se.trim().split(/\s+/).map((rr) => Qe(rr, Ne)).join(" "), Qe = (Se, Ne) => {
    m("caret", Se, Ne);
    const rr = Ne.loose ? k[C.CARETLOOSE] : k[C.CARET], er = Ne.includePrerelease ? "-0" : "";
    return Se.replace(rr, (ir, sr, nr, fr, lr) => {
      m("caret", Se, ir, sr, nr, fr, lr);
      let br;
      return Ie(sr) ? br = "" : Ie(nr) ? br = `>=${sr}.0.0${er} <${+sr + 1}.0.0-0` : Ie(fr) ? sr === "0" ? br = `>=${sr}.${nr}.0${er} <${sr}.${+nr + 1}.0-0` : br = `>=${sr}.${nr}.0${er} <${+sr + 1}.0.0-0` : lr ? (m("replaceCaret pr", lr), sr === "0" ? nr === "0" ? br = `>=${sr}.${nr}.${fr}-${lr} <${sr}.${nr}.${+fr + 1}-0` : br = `>=${sr}.${nr}.${fr}-${lr} <${sr}.${+nr + 1}.0-0` : br = `>=${sr}.${nr}.${fr}-${lr} <${+sr + 1}.0.0-0`) : (m("no pr"), sr === "0" ? nr === "0" ? br = `>=${sr}.${nr}.${fr}${er} <${sr}.${nr}.${+fr + 1}-0` : br = `>=${sr}.${nr}.${fr}${er} <${sr}.${+nr + 1}.0-0` : br = `>=${sr}.${nr}.${fr} <${+sr + 1}.0.0-0`), m("caret return", br), br;
    });
  }, xe = (Se, Ne) => (m("replaceXRanges", Se, Ne), Se.split(/\s+/).map((rr) => Ee(rr, Ne)).join(" ")), Ee = (Se, Ne) => {
    Se = Se.trim();
    const rr = Ne.loose ? k[C.XRANGELOOSE] : k[C.XRANGE];
    return Se.replace(rr, (er, ir, sr, nr, fr, lr) => {
      m("xRange", Se, er, ir, sr, nr, fr, lr);
      const br = Ie(sr), Br = br || Ie(nr), Fr = Br || Ie(fr), Gr = Fr;
      return ir === "=" && Gr && (ir = ""), lr = Ne.includePrerelease ? "-0" : "", br ? ir === ">" || ir === "<" ? er = "<0.0.0-0" : er = "*" : ir && Gr ? (Br && (nr = 0), fr = 0, ir === ">" ? (ir = ">=", Br ? (sr = +sr + 1, nr = 0, fr = 0) : (nr = +nr + 1, fr = 0)) : ir === "<=" && (ir = "<", Br ? sr = +sr + 1 : nr = +nr + 1), ir === "<" && (lr = "-0"), er = `${ir + sr}.${nr}.${fr}${lr}`) : Br ? er = `>=${sr}.0.0${lr} <${+sr + 1}.0.0-0` : Fr && (er = `>=${sr}.${nr}.0${lr} <${sr}.${+nr + 1}.0-0`), m("xRange return", er), er;
    });
  }, He = (Se, Ne) => (m("replaceStars", Se, Ne), Se.trim().replace(k[C.STAR], "")), ve = (Se, Ne) => (m("replaceGTE0", Se, Ne), Se.trim().replace(k[Ne.includePrerelease ? C.GTE0PRE : C.GTE0], "")), we = (Se) => (Ne, rr, er, ir, sr, nr, fr, lr, br, Br, Fr, Gr) => (Ie(er) ? rr = "" : Ie(ir) ? rr = `>=${er}.0.0${Se ? "-0" : ""}` : Ie(sr) ? rr = `>=${er}.${ir}.0${Se ? "-0" : ""}` : nr ? rr = `>=${rr}` : rr = `>=${rr}${Se ? "-0" : ""}`, Ie(br) ? lr = "" : Ie(Br) ? lr = `<${+br + 1}.0.0-0` : Ie(Fr) ? lr = `<${br}.${+Br + 1}.0-0` : Gr ? lr = `<=${br}.${Br}.${Fr}-${Gr}` : Se ? lr = `<${br}.${Br}.${+Fr + 1}-0` : lr = `<=${lr}`, `${rr} ${lr}`.trim()), Ce = (Se, Ne, rr) => {
    for (let er = 0; er < Se.length; er++)
      if (!Se[er].test(Ne))
        return !1;
    if (Ne.prerelease.length && !rr.includePrerelease) {
      for (let er = 0; er < Se.length; er++)
        if (m(Se[er].semver), Se[er].semver !== l.ANY && Se[er].semver.prerelease.length > 0) {
          const ir = Se[er].semver;
          if (ir.major === Ne.major && ir.minor === Ne.minor && ir.patch === Ne.patch)
            return !0;
        }
      return !1;
    }
    return !0;
  };
  return range;
}
var comparator, hasRequiredComparator;
function requireComparator() {
  if (hasRequiredComparator) return comparator;
  hasRequiredComparator = 1;
  const s = Symbol("SemVer ANY");
  class A {
    static get ANY() {
      return s;
    }
    constructor(B, Q) {
      if (Q = u(Q), B instanceof A) {
        if (B.loose === !!Q.loose)
          return B;
        B = B.value;
      }
      B = B.trim().split(/\s+/).join(" "), m("comparator", B, Q), this.options = Q, this.loose = !!Q.loose, this.parse(B), this.semver === s ? this.value = "" : this.value = this.operator + this.semver.version, m("comp", this);
    }
    parse(B) {
      const Q = this.options.loose ? p[t.COMPARATORLOOSE] : p[t.COMPARATOR], P = B.match(Q);
      if (!P)
        throw new TypeError(`Invalid comparator: ${B}`);
      this.operator = P[1] !== void 0 ? P[1] : "", this.operator === "=" && (this.operator = ""), P[2] ? this.semver = new b(P[2], this.options.loose) : this.semver = s;
    }
    toString() {
      return this.value;
    }
    test(B) {
      if (m("Comparator.test", B, this.options.loose), this.semver === s || B === s)
        return !0;
      if (typeof B == "string")
        try {
          B = new b(B, this.options);
        } catch {
          return !1;
        }
      return l(B, this.operator, this.semver, this.options);
    }
    intersects(B, Q) {
      if (!(B instanceof A))
        throw new TypeError("a Comparator is required");
      return this.operator === "" ? this.value === "" ? !0 : new k(B.value, Q).test(this.value) : B.operator === "" ? B.value === "" ? !0 : new k(this.value, Q).test(B.semver) : (Q = u(Q), Q.includePrerelease && (this.value === "<0.0.0-0" || B.value === "<0.0.0-0") || !Q.includePrerelease && (this.value.startsWith("<0.0.0") || B.value.startsWith("<0.0.0")) ? !1 : !!(this.operator.startsWith(">") && B.operator.startsWith(">") || this.operator.startsWith("<") && B.operator.startsWith("<") || this.semver.version === B.semver.version && this.operator.includes("=") && B.operator.includes("=") || l(this.semver, "<", B.semver, Q) && this.operator.startsWith(">") && B.operator.startsWith("<") || l(this.semver, ">", B.semver, Q) && this.operator.startsWith("<") && B.operator.startsWith(">")));
    }
  }
  comparator = A;
  const u = requireParseOptions(), { safeRe: p, t } = requireRe$1(), l = requireCmp(), m = requireDebug(), b = requireSemver$1(), k = requireRange();
  return comparator;
}
var satisfies_1, hasRequiredSatisfies;
function requireSatisfies() {
  if (hasRequiredSatisfies) return satisfies_1;
  hasRequiredSatisfies = 1;
  const s = requireRange();
  return satisfies_1 = (u, p, t) => {
    try {
      p = new s(p, t);
    } catch {
      return !1;
    }
    return p.test(u);
  }, satisfies_1;
}
var toComparators_1, hasRequiredToComparators;
function requireToComparators() {
  if (hasRequiredToComparators) return toComparators_1;
  hasRequiredToComparators = 1;
  const s = requireRange();
  return toComparators_1 = (u, p) => new s(u, p).set.map((t) => t.map((l) => l.value).join(" ").trim().split(" ")), toComparators_1;
}
var maxSatisfying_1, hasRequiredMaxSatisfying;
function requireMaxSatisfying() {
  if (hasRequiredMaxSatisfying) return maxSatisfying_1;
  hasRequiredMaxSatisfying = 1;
  const s = requireSemver$1(), A = requireRange();
  return maxSatisfying_1 = (p, t, l) => {
    let m = null, b = null, k = null;
    try {
      k = new A(t, l);
    } catch {
      return null;
    }
    return p.forEach((C) => {
      k.test(C) && (!m || b.compare(C) === -1) && (m = C, b = new s(m, l));
    }), m;
  }, maxSatisfying_1;
}
var minSatisfying_1, hasRequiredMinSatisfying;
function requireMinSatisfying() {
  if (hasRequiredMinSatisfying) return minSatisfying_1;
  hasRequiredMinSatisfying = 1;
  const s = requireSemver$1(), A = requireRange();
  return minSatisfying_1 = (p, t, l) => {
    let m = null, b = null, k = null;
    try {
      k = new A(t, l);
    } catch {
      return null;
    }
    return p.forEach((C) => {
      k.test(C) && (!m || b.compare(C) === 1) && (m = C, b = new s(m, l));
    }), m;
  }, minSatisfying_1;
}
var minVersion_1, hasRequiredMinVersion;
function requireMinVersion() {
  if (hasRequiredMinVersion) return minVersion_1;
  hasRequiredMinVersion = 1;
  const s = requireSemver$1(), A = requireRange(), u = requireGt();
  return minVersion_1 = (t, l) => {
    t = new A(t, l);
    let m = new s("0.0.0");
    if (t.test(m) || (m = new s("0.0.0-0"), t.test(m)))
      return m;
    m = null;
    for (let b = 0; b < t.set.length; ++b) {
      const k = t.set[b];
      let C = null;
      k.forEach((B) => {
        const Q = new s(B.semver.version);
        switch (B.operator) {
          case ">":
            Q.prerelease.length === 0 ? Q.patch++ : Q.prerelease.push(0), Q.raw = Q.format();
          /* fallthrough */
          case "":
          case ">=":
            (!C || u(Q, C)) && (C = Q);
            break;
          case "<":
          case "<=":
            break;
          /* istanbul ignore next */
          default:
            throw new Error(`Unexpected operation: ${B.operator}`);
        }
      }), C && (!m || u(m, C)) && (m = C);
    }
    return m && t.test(m) ? m : null;
  }, minVersion_1;
}
var valid, hasRequiredValid;
function requireValid() {
  if (hasRequiredValid) return valid;
  hasRequiredValid = 1;
  const s = requireRange();
  return valid = (u, p) => {
    try {
      return new s(u, p).range || "*";
    } catch {
      return null;
    }
  }, valid;
}
var outside_1, hasRequiredOutside;
function requireOutside() {
  if (hasRequiredOutside) return outside_1;
  hasRequiredOutside = 1;
  const s = requireSemver$1(), A = requireComparator(), { ANY: u } = A, p = requireRange(), t = requireSatisfies(), l = requireGt(), m = requireLt(), b = requireLte(), k = requireGte();
  return outside_1 = (B, Q, P, x) => {
    B = new s(B, x), Q = new p(Q, x);
    let M, F, le, ge, pe;
    switch (P) {
      case ">":
        M = l, F = b, le = m, ge = ">", pe = ">=";
        break;
      case "<":
        M = m, F = k, le = l, ge = "<", pe = "<=";
        break;
      default:
        throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    if (t(B, Q, x))
      return !1;
    for (let Ie = 0; Ie < Q.set.length; ++Ie) {
      const be = Q.set[Ie];
      let Pe = null, Te = null;
      if (be.forEach((Qe) => {
        Qe.semver === u && (Qe = new A(">=0.0.0")), Pe = Pe || Qe, Te = Te || Qe, M(Qe.semver, Pe.semver, x) ? Pe = Qe : le(Qe.semver, Te.semver, x) && (Te = Qe);
      }), Pe.operator === ge || Pe.operator === pe || (!Te.operator || Te.operator === ge) && F(B, Te.semver))
        return !1;
      if (Te.operator === pe && le(B, Te.semver))
        return !1;
    }
    return !0;
  }, outside_1;
}
var gtr_1, hasRequiredGtr;
function requireGtr() {
  if (hasRequiredGtr) return gtr_1;
  hasRequiredGtr = 1;
  const s = requireOutside();
  return gtr_1 = (u, p, t) => s(u, p, ">", t), gtr_1;
}
var ltr_1, hasRequiredLtr;
function requireLtr() {
  if (hasRequiredLtr) return ltr_1;
  hasRequiredLtr = 1;
  const s = requireOutside();
  return ltr_1 = (u, p, t) => s(u, p, "<", t), ltr_1;
}
var intersects_1, hasRequiredIntersects;
function requireIntersects() {
  if (hasRequiredIntersects) return intersects_1;
  hasRequiredIntersects = 1;
  const s = requireRange();
  return intersects_1 = (u, p, t) => (u = new s(u, t), p = new s(p, t), u.intersects(p, t)), intersects_1;
}
var simplify, hasRequiredSimplify;
function requireSimplify() {
  if (hasRequiredSimplify) return simplify;
  hasRequiredSimplify = 1;
  const s = requireSatisfies(), A = requireCompare();
  return simplify = (u, p, t) => {
    const l = [];
    let m = null, b = null;
    const k = u.sort((P, x) => A(P, x, t));
    for (const P of k)
      s(P, p, t) ? (b = P, m || (m = P)) : (b && l.push([m, b]), b = null, m = null);
    m && l.push([m, null]);
    const C = [];
    for (const [P, x] of l)
      P === x ? C.push(P) : !x && P === k[0] ? C.push("*") : x ? P === k[0] ? C.push(`<=${x}`) : C.push(`${P} - ${x}`) : C.push(`>=${P}`);
    const B = C.join(" || "), Q = typeof p.raw == "string" ? p.raw : String(p);
    return B.length < Q.length ? B : p;
  }, simplify;
}
var subset_1, hasRequiredSubset;
function requireSubset() {
  if (hasRequiredSubset) return subset_1;
  hasRequiredSubset = 1;
  const s = requireRange(), A = requireComparator(), { ANY: u } = A, p = requireSatisfies(), t = requireCompare(), l = (Q, P, x = {}) => {
    if (Q === P)
      return !0;
    Q = new s(Q, x), P = new s(P, x);
    let M = !1;
    e: for (const F of Q.set) {
      for (const le of P.set) {
        const ge = k(F, le, x);
        if (M = M || ge !== null, ge)
          continue e;
      }
      if (M)
        return !1;
    }
    return !0;
  }, m = [new A(">=0.0.0-0")], b = [new A(">=0.0.0")], k = (Q, P, x) => {
    if (Q === P)
      return !0;
    if (Q.length === 1 && Q[0].semver === u) {
      if (P.length === 1 && P[0].semver === u)
        return !0;
      x.includePrerelease ? Q = m : Q = b;
    }
    if (P.length === 1 && P[0].semver === u) {
      if (x.includePrerelease)
        return !0;
      P = b;
    }
    const M = /* @__PURE__ */ new Set();
    let F, le;
    for (const xe of Q)
      xe.operator === ">" || xe.operator === ">=" ? F = C(F, xe, x) : xe.operator === "<" || xe.operator === "<=" ? le = B(le, xe, x) : M.add(xe.semver);
    if (M.size > 1)
      return null;
    let ge;
    if (F && le) {
      if (ge = t(F.semver, le.semver, x), ge > 0)
        return null;
      if (ge === 0 && (F.operator !== ">=" || le.operator !== "<="))
        return null;
    }
    for (const xe of M) {
      if (F && !p(xe, String(F), x) || le && !p(xe, String(le), x))
        return null;
      for (const Ee of P)
        if (!p(xe, String(Ee), x))
          return !1;
      return !0;
    }
    let pe, Ie, be, Pe, Te = le && !x.includePrerelease && le.semver.prerelease.length ? le.semver : !1, Qe = F && !x.includePrerelease && F.semver.prerelease.length ? F.semver : !1;
    Te && Te.prerelease.length === 1 && le.operator === "<" && Te.prerelease[0] === 0 && (Te = !1);
    for (const xe of P) {
      if (Pe = Pe || xe.operator === ">" || xe.operator === ">=", be = be || xe.operator === "<" || xe.operator === "<=", F) {
        if (Qe && xe.semver.prerelease && xe.semver.prerelease.length && xe.semver.major === Qe.major && xe.semver.minor === Qe.minor && xe.semver.patch === Qe.patch && (Qe = !1), xe.operator === ">" || xe.operator === ">=") {
          if (pe = C(F, xe, x), pe === xe && pe !== F)
            return !1;
        } else if (F.operator === ">=" && !p(F.semver, String(xe), x))
          return !1;
      }
      if (le) {
        if (Te && xe.semver.prerelease && xe.semver.prerelease.length && xe.semver.major === Te.major && xe.semver.minor === Te.minor && xe.semver.patch === Te.patch && (Te = !1), xe.operator === "<" || xe.operator === "<=") {
          if (Ie = B(le, xe, x), Ie === xe && Ie !== le)
            return !1;
        } else if (le.operator === "<=" && !p(le.semver, String(xe), x))
          return !1;
      }
      if (!xe.operator && (le || F) && ge !== 0)
        return !1;
    }
    return !(F && be && !le && ge !== 0 || le && Pe && !F && ge !== 0 || Qe || Te);
  }, C = (Q, P, x) => {
    if (!Q)
      return P;
    const M = t(Q.semver, P.semver, x);
    return M > 0 ? Q : M < 0 || P.operator === ">" && Q.operator === ">=" ? P : Q;
  }, B = (Q, P, x) => {
    if (!Q)
      return P;
    const M = t(Q.semver, P.semver, x);
    return M < 0 ? Q : M > 0 || P.operator === "<" && Q.operator === "<=" ? P : Q;
  };
  return subset_1 = l, subset_1;
}
var semver$1, hasRequiredSemver;
function requireSemver() {
  if (hasRequiredSemver) return semver$1;
  hasRequiredSemver = 1;
  const s = requireRe$1(), A = requireConstants(), u = requireSemver$1(), p = requireIdentifiers(), t = requireParse(), l = requireValid$1(), m = requireClean(), b = requireInc(), k = requireDiff(), C = requireMajor(), B = requireMinor(), Q = requirePatch(), P = requirePrerelease(), x = requireCompare(), M = requireRcompare(), F = requireCompareLoose(), le = requireCompareBuild(), ge = requireSort(), pe = requireRsort(), Ie = requireGt(), be = requireLt(), Pe = requireEq(), Te = requireNeq(), Qe = requireGte(), xe = requireLte(), Ee = requireCmp(), He = requireCoerce(), ve = requireComparator(), we = requireRange(), Ce = requireSatisfies(), Se = requireToComparators(), Ne = requireMaxSatisfying(), rr = requireMinSatisfying(), er = requireMinVersion(), ir = requireValid(), sr = requireOutside(), nr = requireGtr(), fr = requireLtr(), lr = requireIntersects(), br = requireSimplify(), Br = requireSubset();
  return semver$1 = {
    parse: t,
    valid: l,
    clean: m,
    inc: b,
    diff: k,
    major: C,
    minor: B,
    patch: Q,
    prerelease: P,
    compare: x,
    rcompare: M,
    compareLoose: F,
    compareBuild: le,
    sort: ge,
    rsort: pe,
    gt: Ie,
    lt: be,
    eq: Pe,
    neq: Te,
    gte: Qe,
    lte: xe,
    cmp: Ee,
    coerce: He,
    Comparator: ve,
    Range: we,
    satisfies: Ce,
    toComparators: Se,
    maxSatisfying: Ne,
    minSatisfying: rr,
    minVersion: er,
    validRange: ir,
    outside: sr,
    gtr: nr,
    ltr: fr,
    intersects: lr,
    simplifyRange: br,
    subset: Br,
    SemVer: u,
    re: s.re,
    src: s.src,
    tokens: s.t,
    SEMVER_SPEC_VERSION: A.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: A.RELEASE_TYPES,
    compareIdentifiers: p.compareIdentifiers,
    rcompareIdentifiers: p.rcompareIdentifiers
  }, semver$1;
}
var semverExports = requireSemver();
const semver = /* @__PURE__ */ getDefaultExportFromCjs(semverExports);
var DeviceModelId;
(function(s) {
  s.blue = "blue", s.nanoS = "nanoS", s.nanoSP = "nanoSP", s.nanoX = "nanoX", s.stax = "stax", s.europa = "europa", s.apex = "apex";
})(DeviceModelId || (DeviceModelId = {}));
const devices = {
  [DeviceModelId.blue]: {
    id: DeviceModelId.blue,
    productName: "Ledger Blue",
    productIdMM: 0,
    legacyUsbProductId: 0,
    usbOnly: !0,
    memorySize: 480 * 1024,
    masks: [822083584, 822149120],
    getBlockSize: (s) => 4 * 1024
  },
  [DeviceModelId.nanoS]: {
    id: DeviceModelId.nanoS,
    productName: "Ledger Nano S",
    productIdMM: 16,
    legacyUsbProductId: 1,
    usbOnly: !0,
    memorySize: 320 * 1024,
    masks: [823132160],
    getBlockSize: (s) => semver.lt(semver.coerce(s) ?? "", "2.0.0") ? 4 * 1024 : 2 * 1024
  },
  [DeviceModelId.nanoX]: {
    id: DeviceModelId.nanoX,
    productName: "Ledger Nano X",
    productIdMM: 64,
    legacyUsbProductId: 4,
    usbOnly: !1,
    memorySize: 2 * 1024 * 1024,
    masks: [855638016],
    getBlockSize: (s) => 4 * 1024,
    bluetoothSpec: [
      {
        serviceUuid: "13d63400-2c97-0004-0000-4c6564676572",
        notifyUuid: "13d63400-2c97-0004-0001-4c6564676572",
        writeUuid: "13d63400-2c97-0004-0002-4c6564676572",
        writeCmdUuid: "13d63400-2c97-0004-0003-4c6564676572"
      }
    ]
  },
  [DeviceModelId.nanoSP]: {
    id: DeviceModelId.nanoSP,
    productName: "Ledger Nano S Plus",
    productIdMM: 80,
    legacyUsbProductId: 5,
    usbOnly: !0,
    memorySize: 1533 * 1024,
    masks: [856686592],
    getBlockSize: (s) => 32
  },
  [DeviceModelId.apex]: {
    id: DeviceModelId.apex,
    productName: "Ledger Apex",
    productIdMM: 128,
    legacyUsbProductId: 8,
    usbOnly: !1,
    memorySize: 1533 * 1024,
    masks: [859832320],
    getBlockSize: (s) => 32,
    bluetoothSpec: [
      /**
       * 13D63400-2C97-6004-0001-4C6564676572, 13D63400-2C97-6004-0002-4C6564676572, and 13D63400-2C97-6004-0003-4C6564676572 Characteristics for Service 13D63400-2C97-6004-0000-4C6564676572
       */
      {
        serviceUuid: "13d63400-2c97-6004-0000-4c6564676572",
        // WILL CHANGE, for now same as Stax
        notifyUuid: "13d63400-2c97-6004-0001-4c6564676572",
        // WILL CHANGE, for now same as Stax
        writeUuid: "13d63400-2c97-6004-0002-4c6564676572",
        // WILL CHANGE, for now same as Stax
        writeCmdUuid: "13d63400-2c97-6004-0003-4c6564676572"
        // WILL CHANGE, for now same as Stax
      }
    ]
  },
  [DeviceModelId.stax]: {
    id: DeviceModelId.stax,
    productName: "Ledger Stax",
    productIdMM: 96,
    legacyUsbProductId: 6,
    usbOnly: !1,
    memorySize: 1533 * 1024,
    masks: [857735168],
    getBlockSize: (s) => 32,
    bluetoothSpec: [
      {
        serviceUuid: "13d63400-2c97-6004-0000-4c6564676572",
        notifyUuid: "13d63400-2c97-6004-0001-4c6564676572",
        writeUuid: "13d63400-2c97-6004-0002-4c6564676572",
        writeCmdUuid: "13d63400-2c97-6004-0003-4c6564676572"
      }
    ]
  },
  [DeviceModelId.europa]: {
    id: DeviceModelId.europa,
    productName: "Ledger Flex",
    productIdMM: 112,
    legacyUsbProductId: 7,
    usbOnly: !1,
    memorySize: 1533 * 1024,
    masks: [858783744],
    getBlockSize: (s) => 32,
    bluetoothSpec: [
      {
        serviceUuid: "13d63400-2c97-3004-0000-4c6564676572",
        notifyUuid: "13d63400-2c97-3004-0001-4c6564676572",
        writeUuid: "13d63400-2c97-3004-0002-4c6564676572",
        writeCmdUuid: "13d63400-2c97-3004-0003-4c6564676572"
      }
    ]
  }
};
DeviceModelId.blue, DeviceModelId.nanoS, DeviceModelId.nanoSP, DeviceModelId.nanoX, DeviceModelId.stax, DeviceModelId.europa;
const devicesList = Object.values(devices), ledgerUSBVendorId = 11415, identifyUSBProductId = (s) => {
  const A = devicesList.find((t) => t.legacyUsbProductId === s);
  if (A)
    return A;
  const u = s >> 8;
  return devicesList.find((t) => t.productIdMM === u);
}, bluetoothServices = [], serviceUuidToInfos = {};
for (const s in devices) {
  const A = devices[s], { bluetoothSpec: u } = A;
  if (u)
    for (let p = 0; p < u.length; p++) {
      const t = u[p];
      bluetoothServices.push(t.serviceUuid), serviceUuidToInfos[t.serviceUuid] = serviceUuidToInfos[t.serviceUuid.replace(/-/g, "")] = {
        deviceModel: A,
        ...t
      };
    }
}
const ledgerDevices$1 = [
  {
    vendorId: ledgerUSBVendorId
  }
], isSupported$1 = () => Promise.resolve(!!(window.navigator && window.navigator.hid)), getHID = () => {
  const { hid: s } = navigator;
  if (!s)
    throw new TransportError("navigator.hid is not supported", "HIDNotSupported");
  return s;
};
async function requestLedgerDevices() {
  const s = await getHID().requestDevice({
    filters: ledgerDevices$1
  });
  return Array.isArray(s) ? s : [s];
}
async function getLedgerDevices$1() {
  return (await getHID().getDevices()).filter((A) => A.vendorId === ledgerUSBVendorId);
}
async function getFirstLedgerDevice$1() {
  const s = await getLedgerDevices$1();
  return s.length > 0 ? s[0] : (await requestLedgerDevices())[0];
}
const Zc = class Zc extends Transport {
  constructor(u) {
    super();
    Ci(this, "device");
    Ci(this, "deviceModel");
    Ci(this, "channel", Math.floor(Math.random() * 65535));
    Ci(this, "packetSize", 64);
    Ci(this, "inputs", []);
    Ci(this, "inputCallback");
    Ci(this, "read", () => this.inputs.length ? Promise.resolve(this.inputs.shift()) : new Promise((u) => {
      this.inputCallback = u;
    }));
    Ci(this, "onInputReport", (u) => {
      const p = Buffer.from(u.data.buffer);
      this.inputCallback ? (this.inputCallback(p), this.inputCallback = null) : this.inputs.push(p);
    });
    Ci(this, "_disconnectEmitted", !1);
    Ci(this, "_emitDisconnect", (u) => {
      this._disconnectEmitted || (this._disconnectEmitted = !0, this.emit("disconnect", u));
    });
    /**
     * Exchange with the device using APDU protocol.
     * @param apdu
     * @returns a promise of apdu response
     */
    Ci(this, "exchange", async (u) => await this.exchangeAtomicImpl(async () => {
      const { channel: t, packetSize: l } = this;
      log("apdu", "=> " + u.toString("hex"));
      const m = createHIDframing(t, l), b = m.makeBlocks(u);
      for (let B = 0; B < b.length; B++)
        await this.device.sendReport(0, b[B]);
      let k, C;
      for (; !(k = m.getReducedResult(C)); )
        try {
          const B = await this.read();
          C = m.reduceResponse(C, B);
        } catch (B) {
          if (B instanceof TransportError && B.id === "InvalidChannel")
            continue;
          throw B;
        }
      return log("apdu", "<= " + k.toString("hex")), k;
    }).catch((t) => {
      throw t && t.message && t.message.includes("write") ? (this._emitDisconnect(t), new DisconnectedDeviceDuringOperation(t.message)) : t;
    }));
    this.device = u, this.deviceModel = typeof u.productId == "number" ? identifyUSBProductId(u.productId) : void 0, u.addEventListener("inputreport", this.onInputReport);
  }
  /**
   * Similar to create() except it will always display the device permission (even if some devices are already accepted).
   */
  static async request() {
    const [u] = await requestLedgerDevices();
    return Zc.open(u);
  }
  /**
   * Similar to create() except it will never display the device permission (it returns a Promise<?Transport>, null if it fails to find a device).
   */
  static async openConnected() {
    const u = await getLedgerDevices$1();
    return u.length === 0 ? null : Zc.open(u[0]);
  }
  /**
   * Create a Ledger transport with a HIDDevice
   */
  static async open(u) {
    await u.open();
    const p = new Zc(u), t = (l) => {
      u === l.device && (getHID().removeEventListener("disconnect", t), p._emitDisconnect(new DisconnectedDevice()));
    };
    return getHID().addEventListener("disconnect", t), p;
  }
  /**
   * Release the transport device
   */
  async close() {
    await this.exchangeBusyPromise, this.device.removeEventListener("inputreport", this.onInputReport), await this.device.close();
  }
  setScrambleKey() {
  }
};
/**
 * Check if WebUSB transport is supported.
 */
Ci(Zc, "isSupported", isSupported$1), /**
 * List the WebUSB devices that was previously authorized by the user.
 */
Ci(Zc, "list", getLedgerDevices$1), /**
 * Actively listen to WebUSB devices and emit ONE device
 * that was either accepted before, if not it will trigger the native permission UI.
 *
 * Important: it must be called in the context of a UI click!
 */
Ci(Zc, "listen", (u) => {
  let p = !1;
  getFirstLedgerDevice$1().then((l) => {
    if (!l)
      u.error(new TransportOpenUserCancelled("Access denied to use Ledger device"));
    else if (!p) {
      const m = typeof l.productId == "number" ? identifyUSBProductId(l.productId) : void 0;
      u.next({
        type: "add",
        descriptor: l,
        deviceModel: m
      }), u.complete();
    }
  }, (l) => {
    u.error(new TransportOpenUserCancelled(l.message));
  });
  function t() {
    p = !0;
  }
  return {
    unsubscribe: t
  };
});
let TransportWebHID = Zc;
const ledgerDevices = [
  {
    vendorId: ledgerUSBVendorId
  }
];
async function requestLedgerDevice() {
  return await navigator.usb.requestDevice({
    filters: ledgerDevices
  });
}
async function getLedgerDevices() {
  return (await navigator.usb.getDevices()).filter((A) => A.vendorId === ledgerUSBVendorId);
}
async function getFirstLedgerDevice() {
  const s = await getLedgerDevices();
  return s.length > 0 ? s[0] : requestLedgerDevice();
}
const isSupported = () => Promise.resolve(!!navigator && !!navigator.usb && typeof navigator.usb.getDevices == "function"), configurationValue = 1, endpointNumber = 3, $c = class $c extends Transport {
  constructor(u, p) {
    super();
    Ci(this, "device");
    Ci(this, "deviceModel");
    Ci(this, "channel", Math.floor(Math.random() * 65535));
    Ci(this, "packetSize", 64);
    Ci(this, "interfaceNumber");
    Ci(this, "_disconnectEmitted", !1);
    Ci(this, "_emitDisconnect", (u) => {
      this._disconnectEmitted || (this._disconnectEmitted = !0, this.emit("disconnect", u));
    });
    this.device = u, this.interfaceNumber = p, this.deviceModel = identifyUSBProductId(u.productId);
  }
  /**
   * Similar to create() except it will always display the device permission (even if some devices are already accepted).
   */
  static async request() {
    const u = await requestLedgerDevice();
    return $c.open(u);
  }
  /**
   * Similar to create() except it will never display the device permission (it returns a Promise<?Transport>, null if it fails to find a device).
   */
  static async openConnected() {
    const u = await getLedgerDevices();
    return u.length === 0 ? null : $c.open(u[0]);
  }
  /**
   * Create a Ledger transport with a USBDevice
   */
  static async open(u) {
    await u.open(), u.configuration === null && await u.selectConfiguration(configurationValue), await gracefullyResetDevice(u);
    const p = u.configurations[0].interfaces.find(({ alternates: b }) => b.some((k) => k.interfaceClass === 255));
    if (!p)
      throw new TransportInterfaceNotAvailable("No WebUSB interface found for your Ledger device. Please upgrade firmware or contact techsupport.");
    const t = p.interfaceNumber;
    try {
      await u.claimInterface(t);
    } catch (b) {
      throw await u.close(), new TransportInterfaceNotAvailable(b.message);
    }
    const l = new $c(u, t), m = (b) => {
      u === b.device && (navigator.usb.removeEventListener("disconnect", m), l._emitDisconnect(new DisconnectedDevice()));
    };
    return navigator.usb.addEventListener("disconnect", m), l;
  }
  /**
   * Release the transport device
   */
  async close() {
    await this.exchangeBusyPromise, await this.device.releaseInterface(this.interfaceNumber), await gracefullyResetDevice(this.device), await this.device.close();
  }
  /**
   * Exchange with the device using APDU protocol.
   * @param apdu
   * @returns a promise of apdu response
   */
  async exchange(u) {
    return await this.exchangeAtomicImpl(async () => {
      const { channel: t, packetSize: l } = this;
      log("apdu", "=> " + u.toString("hex"));
      const m = createHIDframing(t, l), b = m.makeBlocks(u);
      for (let B = 0; B < b.length; B++)
        await this.device.transferOut(endpointNumber, b[B]);
      let k, C;
      for (; !(k = m.getReducedResult(C)); ) {
        const B = await this.device.transferIn(endpointNumber, l), Q = Buffer.from(B.data.buffer);
        C = m.reduceResponse(C, Q);
      }
      return log("apdu", "<= " + k.toString("hex")), k;
    }).catch((t) => {
      throw t && t.message && t.message.includes("disconnected") ? (this._emitDisconnect(t), new DisconnectedDeviceDuringOperation(t.message)) : t;
    });
  }
  setScrambleKey() {
  }
};
/**
 * Check if WebUSB transport is supported.
 */
Ci($c, "isSupported", isSupported), /**
 * List the WebUSB devices that was previously authorized by the user.
 */
Ci($c, "list", getLedgerDevices), /**
 * Actively listen to WebUSB devices and emit ONE device
 * that was either accepted before, if not it will trigger the native permission UI.
 *
 * Important: it must be called in the context of a UI click!
 */
Ci($c, "listen", (u) => {
  let p = !1;
  getFirstLedgerDevice().then((l) => {
    if (!p) {
      const m = identifyUSBProductId(l.productId);
      u.next({
        type: "add",
        descriptor: l,
        deviceModel: m
      }), u.complete();
    }
  }, (l) => {
    window.DOMException && l instanceof window.DOMException && l.code === 18 ? u.error(new TransportWebUSBGestureRequired(l.message)) : u.error(new TransportOpenUserCancelled(l.message));
  });
  function t() {
    p = !0;
  }
  return {
    unsubscribe: t
  };
});
let TransportWebUSB = $c;
async function gracefullyResetDevice(s) {
  try {
    await s.reset();
  } catch (A) {
    console.warn(A);
  }
}
const crypto$2 = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
function isBytes$3(s) {
  return s instanceof Uint8Array || ArrayBuffer.isView(s) && s.constructor.name === "Uint8Array";
}
function anumber$1(s) {
  if (!Number.isSafeInteger(s) || s < 0)
    throw new Error("positive integer expected, got " + s);
}
function abytes$1(s, ...A) {
  if (!isBytes$3(s))
    throw new Error("Uint8Array expected");
  if (A.length > 0 && !A.includes(s.length))
    throw new Error("Uint8Array expected of length " + A + ", got length=" + s.length);
}
function ahash(s) {
  if (typeof s != "function" || typeof s.create != "function")
    throw new Error("Hash should be wrapped by utils.createHasher");
  anumber$1(s.outputLen), anumber$1(s.blockLen);
}
function aexists(s, A = !0) {
  if (s.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (A && s.finished)
    throw new Error("Hash#digest() has already been called");
}
function aoutput(s, A) {
  abytes$1(s);
  const u = A.outputLen;
  if (s.length < u)
    throw new Error("digestInto() expects output buffer of length at least " + u);
}
function u32(s) {
  return new Uint32Array(s.buffer, s.byteOffset, Math.floor(s.byteLength / 4));
}
function clean(...s) {
  for (let A = 0; A < s.length; A++)
    s[A].fill(0);
}
function createView$1(s) {
  return new DataView(s.buffer, s.byteOffset, s.byteLength);
}
function rotr(s, A) {
  return s << 32 - A | s >>> A;
}
function rotl(s, A) {
  return s << A | s >>> 32 - A >>> 0;
}
const isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
function byteSwap(s) {
  return s << 24 & 4278190080 | s << 8 & 16711680 | s >>> 8 & 65280 | s >>> 24 & 255;
}
function byteSwap32(s) {
  for (let A = 0; A < s.length; A++)
    s[A] = byteSwap(s[A]);
  return s;
}
const swap32IfBE = isLE ? (s) => s : byteSwap32, hasHexBuiltin$1 = /* @ts-ignore */ typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function", hexes$1 = /* @__PURE__ */ Array.from({ length: 256 }, (s, A) => A.toString(16).padStart(2, "0"));
function bytesToHex$1(s) {
  if (abytes$1(s), hasHexBuiltin$1)
    return s.toHex();
  let A = "";
  for (let u = 0; u < s.length; u++)
    A += hexes$1[s[u]];
  return A;
}
const asciis = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
function asciiToBase16(s) {
  if (s >= asciis._0 && s <= asciis._9)
    return s - asciis._0;
  if (s >= asciis.A && s <= asciis.F)
    return s - (asciis.A - 10);
  if (s >= asciis.a && s <= asciis.f)
    return s - (asciis.a - 10);
}
function hexToBytes$1(s) {
  if (typeof s != "string")
    throw new Error("hex string expected, got " + typeof s);
  if (hasHexBuiltin$1)
    return Uint8Array.fromHex(s);
  const A = s.length, u = A / 2;
  if (A % 2)
    throw new Error("hex string expected, got unpadded hex of length " + A);
  const p = new Uint8Array(u);
  for (let t = 0, l = 0; t < u; t++, l += 2) {
    const m = asciiToBase16(s.charCodeAt(l)), b = asciiToBase16(s.charCodeAt(l + 1));
    if (m === void 0 || b === void 0) {
      const k = s[l] + s[l + 1];
      throw new Error('hex string expected, got non-hex character "' + k + '" at index ' + l);
    }
    p[t] = m * 16 + b;
  }
  return p;
}
function utf8ToBytes(s) {
  if (typeof s != "string")
    throw new Error("string expected");
  return new Uint8Array(new TextEncoder().encode(s));
}
function toBytes$1(s) {
  return typeof s == "string" && (s = utf8ToBytes(s)), abytes$1(s), s;
}
function concatBytes$3(...s) {
  let A = 0;
  for (let p = 0; p < s.length; p++) {
    const t = s[p];
    abytes$1(t), A += t.length;
  }
  const u = new Uint8Array(A);
  for (let p = 0, t = 0; p < s.length; p++) {
    const l = s[p];
    u.set(l, t), t += l.length;
  }
  return u;
}
class Hash {
}
function createHasher(s) {
  const A = (p) => s().update(toBytes$1(p)).digest(), u = s();
  return A.outputLen = u.outputLen, A.blockLen = u.blockLen, A.create = () => s(), A;
}
function randomBytes(s = 32) {
  if (crypto$2 && typeof crypto$2.getRandomValues == "function")
    return crypto$2.getRandomValues(new Uint8Array(s));
  if (crypto$2 && typeof crypto$2.randomBytes == "function")
    return Uint8Array.from(crypto$2.randomBytes(s));
  throw new Error("crypto.getRandomValues must be defined");
}
function setBigUint64(s, A, u, p) {
  if (typeof s.setBigUint64 == "function")
    return s.setBigUint64(A, u, p);
  const t = BigInt(32), l = BigInt(4294967295), m = Number(u >> t & l), b = Number(u & l), k = p ? 4 : 0, C = p ? 0 : 4;
  s.setUint32(A + k, m, p), s.setUint32(A + C, b, p);
}
function Chi(s, A, u) {
  return s & A ^ ~s & u;
}
function Maj(s, A, u) {
  return s & A ^ s & u ^ A & u;
}
class HashMD extends Hash {
  constructor(A, u, p, t) {
    super(), this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.blockLen = A, this.outputLen = u, this.padOffset = p, this.isLE = t, this.buffer = new Uint8Array(A), this.view = createView$1(this.buffer);
  }
  update(A) {
    aexists(this), A = toBytes$1(A), abytes$1(A);
    const { view: u, buffer: p, blockLen: t } = this, l = A.length;
    for (let m = 0; m < l; ) {
      const b = Math.min(t - this.pos, l - m);
      if (b === t) {
        const k = createView$1(A);
        for (; t <= l - m; m += t)
          this.process(k, m);
        continue;
      }
      p.set(A.subarray(m, m + b), this.pos), this.pos += b, m += b, this.pos === t && (this.process(u, 0), this.pos = 0);
    }
    return this.length += A.length, this.roundClean(), this;
  }
  digestInto(A) {
    aexists(this), aoutput(A, this), this.finished = !0;
    const { buffer: u, view: p, blockLen: t, isLE: l } = this;
    let { pos: m } = this;
    u[m++] = 128, clean(this.buffer.subarray(m)), this.padOffset > t - m && (this.process(p, 0), m = 0);
    for (let Q = m; Q < t; Q++)
      u[Q] = 0;
    setBigUint64(p, t - 8, BigInt(this.length * 8), l), this.process(p, 0);
    const b = createView$1(A), k = this.outputLen;
    if (k % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const C = k / 4, B = this.get();
    if (C > B.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let Q = 0; Q < C; Q++)
      b.setUint32(4 * Q, B[Q], l);
  }
  digest() {
    const { buffer: A, outputLen: u } = this;
    this.digestInto(A);
    const p = A.slice(0, u);
    return this.destroy(), p;
  }
  _cloneInto(A) {
    A || (A = new this.constructor()), A.set(...this.get());
    const { blockLen: u, buffer: p, length: t, finished: l, destroyed: m, pos: b } = this;
    return A.destroyed = m, A.finished = l, A.length = t, A.pos = b, t % u && A.buffer.set(p), A;
  }
  clone() {
    return this._cloneInto();
  }
}
const SHA256_IV = /* @__PURE__ */ Uint32Array.from([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1), _32n = /* @__PURE__ */ BigInt(32);
function fromBig(s, A = !1) {
  return A ? { h: Number(s & U32_MASK64), l: Number(s >> _32n & U32_MASK64) } : { h: Number(s >> _32n & U32_MASK64) | 0, l: Number(s & U32_MASK64) | 0 };
}
function split(s, A = !1) {
  const u = s.length;
  let p = new Uint32Array(u), t = new Uint32Array(u);
  for (let l = 0; l < u; l++) {
    const { h: m, l: b } = fromBig(s[l], A);
    [p[l], t[l]] = [m, b];
  }
  return [p, t];
}
const rotlSH = (s, A, u) => s << u | A >>> 32 - u, rotlSL = (s, A, u) => A << u | s >>> 32 - u, rotlBH = (s, A, u) => A << u - 32 | s >>> 64 - u, rotlBL = (s, A, u) => s << u - 32 | A >>> 64 - u, SHA256_K = /* @__PURE__ */ Uint32Array.from([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class SHA256 extends HashMD {
  constructor(A = 32) {
    super(64, A, 8, !1), this.A = SHA256_IV[0] | 0, this.B = SHA256_IV[1] | 0, this.C = SHA256_IV[2] | 0, this.D = SHA256_IV[3] | 0, this.E = SHA256_IV[4] | 0, this.F = SHA256_IV[5] | 0, this.G = SHA256_IV[6] | 0, this.H = SHA256_IV[7] | 0;
  }
  get() {
    const { A, B: u, C: p, D: t, E: l, F: m, G: b, H: k } = this;
    return [A, u, p, t, l, m, b, k];
  }
  // prettier-ignore
  set(A, u, p, t, l, m, b, k) {
    this.A = A | 0, this.B = u | 0, this.C = p | 0, this.D = t | 0, this.E = l | 0, this.F = m | 0, this.G = b | 0, this.H = k | 0;
  }
  process(A, u) {
    for (let Q = 0; Q < 16; Q++, u += 4)
      SHA256_W[Q] = A.getUint32(u, !1);
    for (let Q = 16; Q < 64; Q++) {
      const P = SHA256_W[Q - 15], x = SHA256_W[Q - 2], M = rotr(P, 7) ^ rotr(P, 18) ^ P >>> 3, F = rotr(x, 17) ^ rotr(x, 19) ^ x >>> 10;
      SHA256_W[Q] = F + SHA256_W[Q - 7] + M + SHA256_W[Q - 16] | 0;
    }
    let { A: p, B: t, C: l, D: m, E: b, F: k, G: C, H: B } = this;
    for (let Q = 0; Q < 64; Q++) {
      const P = rotr(b, 6) ^ rotr(b, 11) ^ rotr(b, 25), x = B + P + Chi(b, k, C) + SHA256_K[Q] + SHA256_W[Q] | 0, F = (rotr(p, 2) ^ rotr(p, 13) ^ rotr(p, 22)) + Maj(p, t, l) | 0;
      B = C, C = k, k = b, b = m + x | 0, m = l, l = t, t = p, p = x + F | 0;
    }
    p = p + this.A | 0, t = t + this.B | 0, l = l + this.C | 0, m = m + this.D | 0, b = b + this.E | 0, k = k + this.F | 0, C = C + this.G | 0, B = B + this.H | 0, this.set(p, t, l, m, b, k, C, B);
  }
  roundClean() {
    clean(SHA256_W);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), clean(this.buffer);
  }
}
const sha256$2 = /* @__PURE__ */ createHasher(() => new SHA256());
class HMAC extends Hash {
  constructor(A, u) {
    super(), this.finished = !1, this.destroyed = !1, ahash(A);
    const p = toBytes$1(u);
    if (this.iHash = A.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const t = this.blockLen, l = new Uint8Array(t);
    l.set(p.length > t ? A.create().update(p).digest() : p);
    for (let m = 0; m < l.length; m++)
      l[m] ^= 54;
    this.iHash.update(l), this.oHash = A.create();
    for (let m = 0; m < l.length; m++)
      l[m] ^= 106;
    this.oHash.update(l), clean(l);
  }
  update(A) {
    return aexists(this), this.iHash.update(A), this;
  }
  digestInto(A) {
    aexists(this), abytes$1(A, this.outputLen), this.finished = !0, this.iHash.digestInto(A), this.oHash.update(A), this.oHash.digestInto(A), this.destroy();
  }
  digest() {
    const A = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(A), A;
  }
  _cloneInto(A) {
    A || (A = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: u, iHash: p, finished: t, destroyed: l, blockLen: m, outputLen: b } = this;
    return A = A, A.finished = t, A.destroyed = l, A.blockLen = m, A.outputLen = b, A.oHash = u._cloneInto(A.oHash), A.iHash = p._cloneInto(A.iHash), A;
  }
  clone() {
    return this._cloneInto();
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const hmac = (s, A, u) => new HMAC(s, A).update(u).digest();
hmac.create = (s, A) => new HMAC(s, A);
const _0n$5 = /* @__PURE__ */ BigInt(0), _1n$5 = /* @__PURE__ */ BigInt(1);
function _abool2(s, A = "") {
  if (typeof s != "boolean") {
    const u = A && `"${A}"`;
    throw new Error(u + "expected boolean, got type=" + typeof s);
  }
  return s;
}
function _abytes2(s, A, u = "") {
  const p = isBytes$3(s), t = s == null ? void 0 : s.length, l = A !== void 0;
  if (!p || l && t !== A) {
    const m = u && `"${u}" `, b = l ? ` of length ${A}` : "", k = p ? `length=${t}` : `type=${typeof s}`;
    throw new Error(m + "expected Uint8Array" + b + ", got " + k);
  }
  return s;
}
function numberToHexUnpadded(s) {
  const A = s.toString(16);
  return A.length & 1 ? "0" + A : A;
}
function hexToNumber$1(s) {
  if (typeof s != "string")
    throw new Error("hex string expected, got " + typeof s);
  return s === "" ? _0n$5 : BigInt("0x" + s);
}
function bytesToNumberBE(s) {
  return hexToNumber$1(bytesToHex$1(s));
}
function bytesToNumberLE(s) {
  return abytes$1(s), hexToNumber$1(bytesToHex$1(Uint8Array.from(s).reverse()));
}
function numberToBytesBE(s, A) {
  return hexToBytes$1(s.toString(16).padStart(A * 2, "0"));
}
function numberToBytesLE(s, A) {
  return numberToBytesBE(s, A).reverse();
}
function ensureBytes(s, A, u) {
  let p;
  if (typeof A == "string")
    try {
      p = hexToBytes$1(A);
    } catch (l) {
      throw new Error(s + " must be hex string or Uint8Array, cause: " + l);
    }
  else if (isBytes$3(A))
    p = Uint8Array.from(A);
  else
    throw new Error(s + " must be hex string or Uint8Array");
  const t = p.length;
  if (typeof u == "number" && t !== u)
    throw new Error(s + " of length " + u + " expected, got " + t);
  return p;
}
const isPosBig = (s) => typeof s == "bigint" && _0n$5 <= s;
function inRange(s, A, u) {
  return isPosBig(s) && isPosBig(A) && isPosBig(u) && A <= s && s < u;
}
function aInRange(s, A, u, p) {
  if (!inRange(A, u, p))
    throw new Error("expected valid " + s + ": " + u + " <= n < " + p + ", got " + A);
}
function bitLen(s) {
  let A;
  for (A = 0; s > _0n$5; s >>= _1n$5, A += 1)
    ;
  return A;
}
const bitMask = (s) => (_1n$5 << BigInt(s)) - _1n$5;
function createHmacDrbg(s, A, u) {
  if (typeof s != "number" || s < 2)
    throw new Error("hashLen must be a number");
  if (typeof A != "number" || A < 2)
    throw new Error("qByteLen must be a number");
  if (typeof u != "function")
    throw new Error("hmacFn must be a function");
  const p = (x) => new Uint8Array(x), t = (x) => Uint8Array.of(x);
  let l = p(s), m = p(s), b = 0;
  const k = () => {
    l.fill(1), m.fill(0), b = 0;
  }, C = (...x) => u(m, l, ...x), B = (x = p(0)) => {
    m = C(t(0), x), l = C(), x.length !== 0 && (m = C(t(1), x), l = C());
  }, Q = () => {
    if (b++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let x = 0;
    const M = [];
    for (; x < A; ) {
      l = C();
      const F = l.slice();
      M.push(F), x += l.length;
    }
    return concatBytes$3(...M);
  };
  return (x, M) => {
    k(), B(x);
    let F;
    for (; !(F = M(Q())); )
      B();
    return k(), F;
  };
}
function _validateObject(s, A, u = {}) {
  if (!s || typeof s != "object")
    throw new Error("expected valid options object");
  function p(t, l, m) {
    const b = s[t];
    if (m && b === void 0)
      return;
    const k = typeof b;
    if (k !== l || b === null)
      throw new Error(`param "${t}" is invalid: expected ${l}, got ${k}`);
  }
  Object.entries(A).forEach(([t, l]) => p(t, l, !1)), Object.entries(u).forEach(([t, l]) => p(t, l, !0));
}
function memoized(s) {
  const A = /* @__PURE__ */ new WeakMap();
  return (u, ...p) => {
    const t = A.get(u);
    if (t !== void 0)
      return t;
    const l = s(u, ...p);
    return A.set(u, l), l;
  };
}
const _0n$4 = BigInt(0), _1n$4 = BigInt(1), _2n$3 = /* @__PURE__ */ BigInt(2), _3n$1 = /* @__PURE__ */ BigInt(3), _4n$1 = /* @__PURE__ */ BigInt(4), _5n = /* @__PURE__ */ BigInt(5), _7n$1 = /* @__PURE__ */ BigInt(7), _8n = /* @__PURE__ */ BigInt(8), _9n = /* @__PURE__ */ BigInt(9), _16n = /* @__PURE__ */ BigInt(16);
function mod(s, A) {
  const u = s % A;
  return u >= _0n$4 ? u : A + u;
}
function pow2(s, A, u) {
  let p = s;
  for (; A-- > _0n$4; )
    p *= p, p %= u;
  return p;
}
function invert(s, A) {
  if (s === _0n$4)
    throw new Error("invert: expected non-zero number");
  if (A <= _0n$4)
    throw new Error("invert: expected positive modulus, got " + A);
  let u = mod(s, A), p = A, t = _0n$4, l = _1n$4;
  for (; u !== _0n$4; ) {
    const b = p / u, k = p % u, C = t - l * b;
    p = u, u = k, t = l, l = C;
  }
  if (p !== _1n$4)
    throw new Error("invert: does not exist");
  return mod(t, A);
}
function assertIsSquare(s, A, u) {
  if (!s.eql(s.sqr(A), u))
    throw new Error("Cannot find square root");
}
function sqrt3mod4(s, A) {
  const u = (s.ORDER + _1n$4) / _4n$1, p = s.pow(A, u);
  return assertIsSquare(s, p, A), p;
}
function sqrt5mod8(s, A) {
  const u = (s.ORDER - _5n) / _8n, p = s.mul(A, _2n$3), t = s.pow(p, u), l = s.mul(A, t), m = s.mul(s.mul(l, _2n$3), t), b = s.mul(l, s.sub(m, s.ONE));
  return assertIsSquare(s, b, A), b;
}
function sqrt9mod16(s) {
  const A = Field(s), u = tonelliShanks(s), p = u(A, A.neg(A.ONE)), t = u(A, p), l = u(A, A.neg(p)), m = (s + _7n$1) / _16n;
  return (b, k) => {
    let C = b.pow(k, m), B = b.mul(C, p);
    const Q = b.mul(C, t), P = b.mul(C, l), x = b.eql(b.sqr(B), k), M = b.eql(b.sqr(Q), k);
    C = b.cmov(C, B, x), B = b.cmov(P, Q, M);
    const F = b.eql(b.sqr(B), k), le = b.cmov(C, B, F);
    return assertIsSquare(b, le, k), le;
  };
}
function tonelliShanks(s) {
  if (s < _3n$1)
    throw new Error("sqrt is not defined for small field");
  let A = s - _1n$4, u = 0;
  for (; A % _2n$3 === _0n$4; )
    A /= _2n$3, u++;
  let p = _2n$3;
  const t = Field(s);
  for (; FpLegendre(t, p) === 1; )
    if (p++ > 1e3)
      throw new Error("Cannot find square root: probably non-prime P");
  if (u === 1)
    return sqrt3mod4;
  let l = t.pow(p, A);
  const m = (A + _1n$4) / _2n$3;
  return function(k, C) {
    if (k.is0(C))
      return C;
    if (FpLegendre(k, C) !== 1)
      throw new Error("Cannot find square root");
    let B = u, Q = k.mul(k.ONE, l), P = k.pow(C, A), x = k.pow(C, m);
    for (; !k.eql(P, k.ONE); ) {
      if (k.is0(P))
        return k.ZERO;
      let M = 1, F = k.sqr(P);
      for (; !k.eql(F, k.ONE); )
        if (M++, F = k.sqr(F), M === B)
          throw new Error("Cannot find square root");
      const le = _1n$4 << BigInt(B - M - 1), ge = k.pow(Q, le);
      B = M, Q = k.sqr(ge), P = k.mul(P, Q), x = k.mul(x, ge);
    }
    return x;
  };
}
function FpSqrt(s) {
  return s % _4n$1 === _3n$1 ? sqrt3mod4 : s % _8n === _5n ? sqrt5mod8 : s % _16n === _9n ? sqrt9mod16(s) : tonelliShanks(s);
}
const FIELD_FIELDS = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function validateField(s) {
  const A = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "number",
    BITS: "number"
  }, u = FIELD_FIELDS.reduce((p, t) => (p[t] = "function", p), A);
  return _validateObject(s, u), s;
}
function FpPow(s, A, u) {
  if (u < _0n$4)
    throw new Error("invalid exponent, negatives unsupported");
  if (u === _0n$4)
    return s.ONE;
  if (u === _1n$4)
    return A;
  let p = s.ONE, t = A;
  for (; u > _0n$4; )
    u & _1n$4 && (p = s.mul(p, t)), t = s.sqr(t), u >>= _1n$4;
  return p;
}
function FpInvertBatch(s, A, u = !1) {
  const p = new Array(A.length).fill(u ? s.ZERO : void 0), t = A.reduce((m, b, k) => s.is0(b) ? m : (p[k] = m, s.mul(m, b)), s.ONE), l = s.inv(t);
  return A.reduceRight((m, b, k) => s.is0(b) ? m : (p[k] = s.mul(m, p[k]), s.mul(m, b)), l), p;
}
function FpLegendre(s, A) {
  const u = (s.ORDER - _1n$4) / _2n$3, p = s.pow(A, u), t = s.eql(p, s.ONE), l = s.eql(p, s.ZERO), m = s.eql(p, s.neg(s.ONE));
  if (!t && !l && !m)
    throw new Error("invalid Legendre symbol result");
  return t ? 1 : l ? 0 : -1;
}
function nLength(s, A) {
  A !== void 0 && anumber$1(A);
  const u = A !== void 0 ? A : s.toString(2).length, p = Math.ceil(u / 8);
  return { nBitLength: u, nByteLength: p };
}
function Field(s, A, u = !1, p = {}) {
  if (s <= _0n$4)
    throw new Error("invalid field: expected ORDER > 0, got " + s);
  let t, l, m = !1, b;
  if (typeof A == "object" && A != null) {
    if (p.sqrt || u)
      throw new Error("cannot specify opts in two arguments");
    const P = A;
    P.BITS && (t = P.BITS), P.sqrt && (l = P.sqrt), typeof P.isLE == "boolean" && (u = P.isLE), typeof P.modFromBytes == "boolean" && (m = P.modFromBytes), b = P.allowedLengths;
  } else
    typeof A == "number" && (t = A), p.sqrt && (l = p.sqrt);
  const { nBitLength: k, nByteLength: C } = nLength(s, t);
  if (C > 2048)
    throw new Error("invalid field: expected ORDER of <= 2048 bytes");
  let B;
  const Q = Object.freeze({
    ORDER: s,
    isLE: u,
    BITS: k,
    BYTES: C,
    MASK: bitMask(k),
    ZERO: _0n$4,
    ONE: _1n$4,
    allowedLengths: b,
    create: (P) => mod(P, s),
    isValid: (P) => {
      if (typeof P != "bigint")
        throw new Error("invalid field element: expected bigint, got " + typeof P);
      return _0n$4 <= P && P < s;
    },
    is0: (P) => P === _0n$4,
    // is valid and invertible
    isValidNot0: (P) => !Q.is0(P) && Q.isValid(P),
    isOdd: (P) => (P & _1n$4) === _1n$4,
    neg: (P) => mod(-P, s),
    eql: (P, x) => P === x,
    sqr: (P) => mod(P * P, s),
    add: (P, x) => mod(P + x, s),
    sub: (P, x) => mod(P - x, s),
    mul: (P, x) => mod(P * x, s),
    pow: (P, x) => FpPow(Q, P, x),
    div: (P, x) => mod(P * invert(x, s), s),
    // Same as above, but doesn't normalize
    sqrN: (P) => P * P,
    addN: (P, x) => P + x,
    subN: (P, x) => P - x,
    mulN: (P, x) => P * x,
    inv: (P) => invert(P, s),
    sqrt: l || ((P) => (B || (B = FpSqrt(s)), B(Q, P))),
    toBytes: (P) => u ? numberToBytesLE(P, C) : numberToBytesBE(P, C),
    fromBytes: (P, x = !0) => {
      if (b) {
        if (!b.includes(P.length) || P.length > C)
          throw new Error("Field.fromBytes: expected " + b + " bytes, got " + P.length);
        const F = new Uint8Array(C);
        F.set(P, u ? 0 : F.length - P.length), P = F;
      }
      if (P.length !== C)
        throw new Error("Field.fromBytes: expected " + C + " bytes, got " + P.length);
      let M = u ? bytesToNumberLE(P) : bytesToNumberBE(P);
      if (m && (M = mod(M, s)), !x && !Q.isValid(M))
        throw new Error("invalid field element: outside of range 0..ORDER");
      return M;
    },
    // TODO: we don't need it here, move out to separate fn
    invertBatch: (P) => FpInvertBatch(Q, P),
    // We can't move this out because Fp6, Fp12 implement it
    // and it's unclear what to return in there.
    cmov: (P, x, M) => M ? x : P
  });
  return Object.freeze(Q);
}
function getFieldBytesLength(s) {
  if (typeof s != "bigint")
    throw new Error("field order must be bigint");
  const A = s.toString(2).length;
  return Math.ceil(A / 8);
}
function getMinHashLength(s) {
  const A = getFieldBytesLength(s);
  return A + Math.ceil(A / 2);
}
function mapHashToField(s, A, u = !1) {
  const p = s.length, t = getFieldBytesLength(A), l = getMinHashLength(A);
  if (p < 16 || p < l || p > 1024)
    throw new Error("expected " + l + "-1024 bytes of input, got " + p);
  const m = u ? bytesToNumberLE(s) : bytesToNumberBE(s), b = mod(m, A - _1n$4) + _1n$4;
  return u ? numberToBytesLE(b, t) : numberToBytesBE(b, t);
}
const _0n$3 = BigInt(0), _1n$3 = BigInt(1);
function negateCt(s, A) {
  const u = A.negate();
  return s ? u : A;
}
function normalizeZ(s, A) {
  const u = FpInvertBatch(s.Fp, A.map((p) => p.Z));
  return A.map((p, t) => s.fromAffine(p.toAffine(u[t])));
}
function validateW(s, A) {
  if (!Number.isSafeInteger(s) || s <= 0 || s > A)
    throw new Error("invalid window size, expected [1.." + A + "], got W=" + s);
}
function calcWOpts(s, A) {
  validateW(s, A);
  const u = Math.ceil(A / s) + 1, p = 2 ** (s - 1), t = 2 ** s, l = bitMask(s), m = BigInt(s);
  return { windows: u, windowSize: p, mask: l, maxNumber: t, shiftBy: m };
}
function calcOffsets(s, A, u) {
  const { windowSize: p, mask: t, maxNumber: l, shiftBy: m } = u;
  let b = Number(s & t), k = s >> m;
  b > p && (b -= l, k += _1n$3);
  const C = A * p, B = C + Math.abs(b) - 1, Q = b === 0, P = b < 0, x = A % 2 !== 0;
  return { nextN: k, offset: B, isZero: Q, isNeg: P, isNegF: x, offsetF: C };
}
function validateMSMPoints(s, A) {
  if (!Array.isArray(s))
    throw new Error("array expected");
  s.forEach((u, p) => {
    if (!(u instanceof A))
      throw new Error("invalid point at index " + p);
  });
}
function validateMSMScalars(s, A) {
  if (!Array.isArray(s))
    throw new Error("array of scalars expected");
  s.forEach((u, p) => {
    if (!A.isValid(u))
      throw new Error("invalid scalar at index " + p);
  });
}
const pointPrecomputes = /* @__PURE__ */ new WeakMap(), pointWindowSizes = /* @__PURE__ */ new WeakMap();
function getW(s) {
  return pointWindowSizes.get(s) || 1;
}
function assert0(s) {
  if (s !== _0n$3)
    throw new Error("invalid wNAF");
}
class wNAF {
  // Parametrized with a given Point class (not individual point)
  constructor(A, u) {
    this.BASE = A.BASE, this.ZERO = A.ZERO, this.Fn = A.Fn, this.bits = u;
  }
  // non-const time multiplication ladder
  _unsafeLadder(A, u, p = this.ZERO) {
    let t = A;
    for (; u > _0n$3; )
      u & _1n$3 && (p = p.add(t)), t = t.double(), u >>= _1n$3;
    return p;
  }
  /**
   * Creates a wNAF precomputation window. Used for caching.
   * Default window size is set by `utils.precompute()` and is equal to 8.
   * Number of precomputed points depends on the curve size:
   * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
   * - 𝑊 is the window size
   * - 𝑛 is the bitlength of the curve order.
   * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
   * @param point Point instance
   * @param W window size
   * @returns precomputed point tables flattened to a single array
   */
  precomputeWindow(A, u) {
    const { windows: p, windowSize: t } = calcWOpts(u, this.bits), l = [];
    let m = A, b = m;
    for (let k = 0; k < p; k++) {
      b = m, l.push(b);
      for (let C = 1; C < t; C++)
        b = b.add(m), l.push(b);
      m = b.double();
    }
    return l;
  }
  /**
   * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
   * More compact implementation:
   * https://github.com/paulmillr/noble-secp256k1/blob/47cb1669b6e506ad66b35fe7d76132ae97465da2/index.ts#L502-L541
   * @returns real and fake (for const-time) points
   */
  wNAF(A, u, p) {
    if (!this.Fn.isValid(p))
      throw new Error("invalid scalar");
    let t = this.ZERO, l = this.BASE;
    const m = calcWOpts(A, this.bits);
    for (let b = 0; b < m.windows; b++) {
      const { nextN: k, offset: C, isZero: B, isNeg: Q, isNegF: P, offsetF: x } = calcOffsets(p, b, m);
      p = k, B ? l = l.add(negateCt(P, u[x])) : t = t.add(negateCt(Q, u[C]));
    }
    return assert0(p), { p: t, f: l };
  }
  /**
   * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
   * @param acc accumulator point to add result of multiplication
   * @returns point
   */
  wNAFUnsafe(A, u, p, t = this.ZERO) {
    const l = calcWOpts(A, this.bits);
    for (let m = 0; m < l.windows && p !== _0n$3; m++) {
      const { nextN: b, offset: k, isZero: C, isNeg: B } = calcOffsets(p, m, l);
      if (p = b, !C) {
        const Q = u[k];
        t = t.add(B ? Q.negate() : Q);
      }
    }
    return assert0(p), t;
  }
  getPrecomputes(A, u, p) {
    let t = pointPrecomputes.get(u);
    return t || (t = this.precomputeWindow(u, A), A !== 1 && (typeof p == "function" && (t = p(t)), pointPrecomputes.set(u, t))), t;
  }
  cached(A, u, p) {
    const t = getW(A);
    return this.wNAF(t, this.getPrecomputes(t, A, p), u);
  }
  unsafe(A, u, p, t) {
    const l = getW(A);
    return l === 1 ? this._unsafeLadder(A, u, t) : this.wNAFUnsafe(l, this.getPrecomputes(l, A, p), u, t);
  }
  // We calculate precomputes for elliptic curve point multiplication
  // using windowed method. This specifies window size and
  // stores precomputed values. Usually only base point would be precomputed.
  createCache(A, u) {
    validateW(u, this.bits), pointWindowSizes.set(A, u), pointPrecomputes.delete(A);
  }
  hasCache(A) {
    return getW(A) !== 1;
  }
}
function mulEndoUnsafe(s, A, u, p) {
  let t = A, l = s.ZERO, m = s.ZERO;
  for (; u > _0n$3 || p > _0n$3; )
    u & _1n$3 && (l = l.add(t)), p & _1n$3 && (m = m.add(t)), t = t.double(), u >>= _1n$3, p >>= _1n$3;
  return { p1: l, p2: m };
}
function pippenger(s, A, u, p) {
  validateMSMPoints(u, s), validateMSMScalars(p, A);
  const t = u.length, l = p.length;
  if (t !== l)
    throw new Error("arrays of points and scalars must have equal length");
  const m = s.ZERO, b = bitLen(BigInt(t));
  let k = 1;
  b > 12 ? k = b - 3 : b > 4 ? k = b - 2 : b > 0 && (k = 2);
  const C = bitMask(k), B = new Array(Number(C) + 1).fill(m), Q = Math.floor((A.BITS - 1) / k) * k;
  let P = m;
  for (let x = Q; x >= 0; x -= k) {
    B.fill(m);
    for (let F = 0; F < l; F++) {
      const le = p[F], ge = Number(le >> BigInt(x) & C);
      B[ge] = B[ge].add(u[F]);
    }
    let M = m;
    for (let F = B.length - 1, le = m; F > 0; F--)
      le = le.add(B[F]), M = M.add(le);
    if (P = P.add(M), x !== 0)
      for (let F = 0; F < k; F++)
        P = P.double();
  }
  return P;
}
function createField(s, A, u) {
  if (A) {
    if (A.ORDER !== s)
      throw new Error("Field.ORDER must match order: Fp == p, Fn == n");
    return validateField(A), A;
  } else
    return Field(s, { isLE: u });
}
function _createCurveFields(s, A, u = {}, p) {
  if (p === void 0 && (p = s === "edwards"), !A || typeof A != "object")
    throw new Error(`expected valid ${s} CURVE object`);
  for (const k of ["p", "n", "h"]) {
    const C = A[k];
    if (!(typeof C == "bigint" && C > _0n$3))
      throw new Error(`CURVE.${k} must be positive bigint`);
  }
  const t = createField(A.p, u.Fp, p), l = createField(A.n, u.Fn, p), b = ["Gx", "Gy", "a", "b"];
  for (const k of b)
    if (!t.isValid(A[k]))
      throw new Error(`CURVE.${k} must be valid field element of CURVE.Fp`);
  return A = Object.freeze(Object.assign({}, A)), { CURVE: A, Fp: t, Fn: l };
}
const divNearest = (s, A) => (s + (s >= 0 ? A : -A) / _2n$2) / A;
function _splitEndoScalar(s, A, u) {
  const [[p, t], [l, m]] = A, b = divNearest(m * s, u), k = divNearest(-t * s, u);
  let C = s - b * p - k * l, B = -b * t - k * m;
  const Q = C < _0n$2, P = B < _0n$2;
  Q && (C = -C), P && (B = -B);
  const x = bitMask(Math.ceil(bitLen(u) / 2)) + _1n$2;
  if (C < _0n$2 || C >= x || B < _0n$2 || B >= x)
    throw new Error("splitScalar (endomorphism): failed, k=" + s);
  return { k1neg: Q, k1: C, k2neg: P, k2: B };
}
function validateSigFormat(s) {
  if (!["compact", "recovered", "der"].includes(s))
    throw new Error('Signature format must be "compact", "recovered", or "der"');
  return s;
}
function validateSigOpts(s, A) {
  const u = {};
  for (let p of Object.keys(A))
    u[p] = s[p] === void 0 ? A[p] : s[p];
  return _abool2(u.lowS, "lowS"), _abool2(u.prehash, "prehash"), u.format !== void 0 && validateSigFormat(u.format), u;
}
class DERErr extends Error {
  constructor(A = "") {
    super(A);
  }
}
const DER = {
  // asn.1 DER encoding utils
  Err: DERErr,
  // Basic building block is TLV (Tag-Length-Value)
  _tlv: {
    encode: (s, A) => {
      const { Err: u } = DER;
      if (s < 0 || s > 256)
        throw new u("tlv.encode: wrong tag");
      if (A.length & 1)
        throw new u("tlv.encode: unpadded data");
      const p = A.length / 2, t = numberToHexUnpadded(p);
      if (t.length / 2 & 128)
        throw new u("tlv.encode: long form length too big");
      const l = p > 127 ? numberToHexUnpadded(t.length / 2 | 128) : "";
      return numberToHexUnpadded(s) + l + t + A;
    },
    // v - value, l - left bytes (unparsed)
    decode(s, A) {
      const { Err: u } = DER;
      let p = 0;
      if (s < 0 || s > 256)
        throw new u("tlv.encode: wrong tag");
      if (A.length < 2 || A[p++] !== s)
        throw new u("tlv.decode: wrong tlv");
      const t = A[p++], l = !!(t & 128);
      let m = 0;
      if (!l)
        m = t;
      else {
        const k = t & 127;
        if (!k)
          throw new u("tlv.decode(long): indefinite length not supported");
        if (k > 4)
          throw new u("tlv.decode(long): byte length is too big");
        const C = A.subarray(p, p + k);
        if (C.length !== k)
          throw new u("tlv.decode: length bytes not complete");
        if (C[0] === 0)
          throw new u("tlv.decode(long): zero leftmost byte");
        for (const B of C)
          m = m << 8 | B;
        if (p += k, m < 128)
          throw new u("tlv.decode(long): not minimal encoding");
      }
      const b = A.subarray(p, p + m);
      if (b.length !== m)
        throw new u("tlv.decode: wrong value length");
      return { v: b, l: A.subarray(p + m) };
    }
  },
  // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
  // since we always use positive integers here. It must always be empty:
  // - add zero byte if exists
  // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
  _int: {
    encode(s) {
      const { Err: A } = DER;
      if (s < _0n$2)
        throw new A("integer: negative integers are not allowed");
      let u = numberToHexUnpadded(s);
      if (Number.parseInt(u[0], 16) & 8 && (u = "00" + u), u.length & 1)
        throw new A("unexpected DER parsing assertion: unpadded hex");
      return u;
    },
    decode(s) {
      const { Err: A } = DER;
      if (s[0] & 128)
        throw new A("invalid signature integer: negative");
      if (s[0] === 0 && !(s[1] & 128))
        throw new A("invalid signature integer: unnecessary leading zero");
      return bytesToNumberBE(s);
    }
  },
  toSig(s) {
    const { Err: A, _int: u, _tlv: p } = DER, t = ensureBytes("signature", s), { v: l, l: m } = p.decode(48, t);
    if (m.length)
      throw new A("invalid signature: left bytes after parsing");
    const { v: b, l: k } = p.decode(2, l), { v: C, l: B } = p.decode(2, k);
    if (B.length)
      throw new A("invalid signature: left bytes after parsing");
    return { r: u.decode(b), s: u.decode(C) };
  },
  hexFromSig(s) {
    const { _tlv: A, _int: u } = DER, p = A.encode(2, u.encode(s.r)), t = A.encode(2, u.encode(s.s)), l = p + t;
    return A.encode(48, l);
  }
}, _0n$2 = BigInt(0), _1n$2 = BigInt(1), _2n$2 = BigInt(2), _3n = BigInt(3), _4n = BigInt(4);
function _normFnElement(s, A) {
  const { BYTES: u } = s;
  let p;
  if (typeof A == "bigint")
    p = A;
  else {
    let t = ensureBytes("private key", A);
    try {
      p = s.fromBytes(t);
    } catch {
      throw new Error(`invalid private key: expected ui8a of size ${u}, got ${typeof A}`);
    }
  }
  if (!s.isValidNot0(p))
    throw new Error("invalid private key: out of range [1..N-1]");
  return p;
}
function weierstrassN(s, A = {}) {
  const u = _createCurveFields("weierstrass", s, A), { Fp: p, Fn: t } = u;
  let l = u.CURVE;
  const { h: m, n: b } = l;
  _validateObject(A, {}, {
    allowInfinityPoint: "boolean",
    clearCofactor: "function",
    isTorsionFree: "function",
    fromBytes: "function",
    toBytes: "function",
    endo: "object",
    wrapPrivateKey: "boolean"
  });
  const { endo: k } = A;
  if (k && (!p.is0(l.a) || typeof k.beta != "bigint" || !Array.isArray(k.basises)))
    throw new Error('invalid endo: expected "beta": bigint and "basises": array');
  const C = getWLengths(p, t);
  function B() {
    if (!p.isOdd)
      throw new Error("compression is not supported: Field does not have .isOdd()");
  }
  function Q(we, Ce, Se) {
    const { x: Ne, y: rr } = Ce.toAffine(), er = p.toBytes(Ne);
    if (_abool2(Se, "isCompressed"), Se) {
      B();
      const ir = !p.isOdd(rr);
      return concatBytes$3(pprefix(ir), er);
    } else
      return concatBytes$3(Uint8Array.of(4), er, p.toBytes(rr));
  }
  function P(we) {
    _abytes2(we, void 0, "Point");
    const { publicKey: Ce, publicKeyUncompressed: Se } = C, Ne = we.length, rr = we[0], er = we.subarray(1);
    if (Ne === Ce && (rr === 2 || rr === 3)) {
      const ir = p.fromBytes(er);
      if (!p.isValid(ir))
        throw new Error("bad point: is not on curve, wrong x");
      const sr = F(ir);
      let nr;
      try {
        nr = p.sqrt(sr);
      } catch (br) {
        const Br = br instanceof Error ? ": " + br.message : "";
        throw new Error("bad point: is not on curve, sqrt error" + Br);
      }
      B();
      const fr = p.isOdd(nr);
      return (rr & 1) === 1 !== fr && (nr = p.neg(nr)), { x: ir, y: nr };
    } else if (Ne === Se && rr === 4) {
      const ir = p.BYTES, sr = p.fromBytes(er.subarray(0, ir)), nr = p.fromBytes(er.subarray(ir, ir * 2));
      if (!le(sr, nr))
        throw new Error("bad point: is not on curve");
      return { x: sr, y: nr };
    } else
      throw new Error(`bad point: got length ${Ne}, expected compressed=${Ce} or uncompressed=${Se}`);
  }
  const x = A.toBytes || Q, M = A.fromBytes || P;
  function F(we) {
    const Ce = p.sqr(we), Se = p.mul(Ce, we);
    return p.add(p.add(Se, p.mul(we, l.a)), l.b);
  }
  function le(we, Ce) {
    const Se = p.sqr(Ce), Ne = F(we);
    return p.eql(Se, Ne);
  }
  if (!le(l.Gx, l.Gy))
    throw new Error("bad curve params: generator point");
  const ge = p.mul(p.pow(l.a, _3n), _4n), pe = p.mul(p.sqr(l.b), BigInt(27));
  if (p.is0(p.add(ge, pe)))
    throw new Error("bad curve params: a or b");
  function Ie(we, Ce, Se = !1) {
    if (!p.isValid(Ce) || Se && p.is0(Ce))
      throw new Error(`bad point coordinate ${we}`);
    return Ce;
  }
  function be(we) {
    if (!(we instanceof Ee))
      throw new Error("ProjectivePoint expected");
  }
  function Pe(we) {
    if (!k || !k.basises)
      throw new Error("no endo");
    return _splitEndoScalar(we, k.basises, t.ORDER);
  }
  const Te = memoized((we, Ce) => {
    const { X: Se, Y: Ne, Z: rr } = we;
    if (p.eql(rr, p.ONE))
      return { x: Se, y: Ne };
    const er = we.is0();
    Ce == null && (Ce = er ? p.ONE : p.inv(rr));
    const ir = p.mul(Se, Ce), sr = p.mul(Ne, Ce), nr = p.mul(rr, Ce);
    if (er)
      return { x: p.ZERO, y: p.ZERO };
    if (!p.eql(nr, p.ONE))
      throw new Error("invZ was invalid");
    return { x: ir, y: sr };
  }), Qe = memoized((we) => {
    if (we.is0()) {
      if (A.allowInfinityPoint && !p.is0(we.Y))
        return;
      throw new Error("bad point: ZERO");
    }
    const { x: Ce, y: Se } = we.toAffine();
    if (!p.isValid(Ce) || !p.isValid(Se))
      throw new Error("bad point: x or y not field elements");
    if (!le(Ce, Se))
      throw new Error("bad point: equation left != right");
    if (!we.isTorsionFree())
      throw new Error("bad point: not in prime-order subgroup");
    return !0;
  });
  function xe(we, Ce, Se, Ne, rr) {
    return Se = new Ee(p.mul(Se.X, we), Se.Y, Se.Z), Ce = negateCt(Ne, Ce), Se = negateCt(rr, Se), Ce.add(Se);
  }
  class Ee {
    /** Does NOT validate if the point is valid. Use `.assertValidity()`. */
    constructor(Ce, Se, Ne) {
      this.X = Ie("x", Ce), this.Y = Ie("y", Se, !0), this.Z = Ie("z", Ne), Object.freeze(this);
    }
    static CURVE() {
      return l;
    }
    /** Does NOT validate if the point is valid. Use `.assertValidity()`. */
    static fromAffine(Ce) {
      const { x: Se, y: Ne } = Ce || {};
      if (!Ce || !p.isValid(Se) || !p.isValid(Ne))
        throw new Error("invalid affine point");
      if (Ce instanceof Ee)
        throw new Error("projective point not allowed");
      return p.is0(Se) && p.is0(Ne) ? Ee.ZERO : new Ee(Se, Ne, p.ONE);
    }
    static fromBytes(Ce) {
      const Se = Ee.fromAffine(M(_abytes2(Ce, void 0, "point")));
      return Se.assertValidity(), Se;
    }
    static fromHex(Ce) {
      return Ee.fromBytes(ensureBytes("pointHex", Ce));
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     *
     * @param windowSize
     * @param isLazy true will defer table computation until the first multiplication
     * @returns
     */
    precompute(Ce = 8, Se = !0) {
      return ve.createCache(this, Ce), Se || this.multiply(_3n), this;
    }
    // TODO: return `this`
    /** A point on curve is valid if it conforms to equation. */
    assertValidity() {
      Qe(this);
    }
    hasEvenY() {
      const { y: Ce } = this.toAffine();
      if (!p.isOdd)
        throw new Error("Field doesn't support isOdd");
      return !p.isOdd(Ce);
    }
    /** Compare one point to another. */
    equals(Ce) {
      be(Ce);
      const { X: Se, Y: Ne, Z: rr } = this, { X: er, Y: ir, Z: sr } = Ce, nr = p.eql(p.mul(Se, sr), p.mul(er, rr)), fr = p.eql(p.mul(Ne, sr), p.mul(ir, rr));
      return nr && fr;
    }
    /** Flips point to one corresponding to (x, -y) in Affine coordinates. */
    negate() {
      return new Ee(this.X, p.neg(this.Y), this.Z);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: Ce, b: Se } = l, Ne = p.mul(Se, _3n), { X: rr, Y: er, Z: ir } = this;
      let sr = p.ZERO, nr = p.ZERO, fr = p.ZERO, lr = p.mul(rr, rr), br = p.mul(er, er), Br = p.mul(ir, ir), Fr = p.mul(rr, er);
      return Fr = p.add(Fr, Fr), fr = p.mul(rr, ir), fr = p.add(fr, fr), sr = p.mul(Ce, fr), nr = p.mul(Ne, Br), nr = p.add(sr, nr), sr = p.sub(br, nr), nr = p.add(br, nr), nr = p.mul(sr, nr), sr = p.mul(Fr, sr), fr = p.mul(Ne, fr), Br = p.mul(Ce, Br), Fr = p.sub(lr, Br), Fr = p.mul(Ce, Fr), Fr = p.add(Fr, fr), fr = p.add(lr, lr), lr = p.add(fr, lr), lr = p.add(lr, Br), lr = p.mul(lr, Fr), nr = p.add(nr, lr), Br = p.mul(er, ir), Br = p.add(Br, Br), lr = p.mul(Br, Fr), sr = p.sub(sr, lr), fr = p.mul(Br, br), fr = p.add(fr, fr), fr = p.add(fr, fr), new Ee(sr, nr, fr);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(Ce) {
      be(Ce);
      const { X: Se, Y: Ne, Z: rr } = this, { X: er, Y: ir, Z: sr } = Ce;
      let nr = p.ZERO, fr = p.ZERO, lr = p.ZERO;
      const br = l.a, Br = p.mul(l.b, _3n);
      let Fr = p.mul(Se, er), Gr = p.mul(Ne, ir), qr = p.mul(rr, sr), Hr = p.add(Se, Ne), un = p.add(er, ir);
      Hr = p.mul(Hr, un), un = p.add(Fr, Gr), Hr = p.sub(Hr, un), un = p.add(Se, rr);
      let Dr = p.add(er, sr);
      return un = p.mul(un, Dr), Dr = p.add(Fr, qr), un = p.sub(un, Dr), Dr = p.add(Ne, rr), nr = p.add(ir, sr), Dr = p.mul(Dr, nr), nr = p.add(Gr, qr), Dr = p.sub(Dr, nr), lr = p.mul(br, un), nr = p.mul(Br, qr), lr = p.add(nr, lr), nr = p.sub(Gr, lr), lr = p.add(Gr, lr), fr = p.mul(nr, lr), Gr = p.add(Fr, Fr), Gr = p.add(Gr, Fr), qr = p.mul(br, qr), un = p.mul(Br, un), Gr = p.add(Gr, qr), qr = p.sub(Fr, qr), qr = p.mul(br, qr), un = p.add(un, qr), Fr = p.mul(Gr, un), fr = p.add(fr, Fr), Fr = p.mul(Dr, un), nr = p.mul(Hr, nr), nr = p.sub(nr, Fr), Fr = p.mul(Hr, Gr), lr = p.mul(Dr, lr), lr = p.add(lr, Fr), new Ee(nr, fr, lr);
    }
    subtract(Ce) {
      return this.add(Ce.negate());
    }
    is0() {
      return this.equals(Ee.ZERO);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(Ce) {
      const { endo: Se } = A;
      if (!t.isValidNot0(Ce))
        throw new Error("invalid scalar: out of range");
      let Ne, rr;
      const er = (ir) => ve.cached(this, ir, (sr) => normalizeZ(Ee, sr));
      if (Se) {
        const { k1neg: ir, k1: sr, k2neg: nr, k2: fr } = Pe(Ce), { p: lr, f: br } = er(sr), { p: Br, f: Fr } = er(fr);
        rr = br.add(Fr), Ne = xe(Se.beta, lr, Br, ir, nr);
      } else {
        const { p: ir, f: sr } = er(Ce);
        Ne = ir, rr = sr;
      }
      return normalizeZ(Ee, [Ne, rr])[0];
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed secret key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(Ce) {
      const { endo: Se } = A, Ne = this;
      if (!t.isValid(Ce))
        throw new Error("invalid scalar: out of range");
      if (Ce === _0n$2 || Ne.is0())
        return Ee.ZERO;
      if (Ce === _1n$2)
        return Ne;
      if (ve.hasCache(this))
        return this.multiply(Ce);
      if (Se) {
        const { k1neg: rr, k1: er, k2neg: ir, k2: sr } = Pe(Ce), { p1: nr, p2: fr } = mulEndoUnsafe(Ee, Ne, er, sr);
        return xe(Se.beta, nr, fr, rr, ir);
      } else
        return ve.unsafe(Ne, Ce);
    }
    multiplyAndAddUnsafe(Ce, Se, Ne) {
      const rr = this.multiplyUnsafe(Se).add(Ce.multiplyUnsafe(Ne));
      return rr.is0() ? void 0 : rr;
    }
    /**
     * Converts Projective point to affine (x, y) coordinates.
     * @param invertedZ Z^-1 (inverted zero) - optional, precomputation is useful for invertBatch
     */
    toAffine(Ce) {
      return Te(this, Ce);
    }
    /**
     * Checks whether Point is free of torsion elements (is in prime subgroup).
     * Always torsion-free for cofactor=1 curves.
     */
    isTorsionFree() {
      const { isTorsionFree: Ce } = A;
      return m === _1n$2 ? !0 : Ce ? Ce(Ee, this) : ve.unsafe(this, b).is0();
    }
    clearCofactor() {
      const { clearCofactor: Ce } = A;
      return m === _1n$2 ? this : Ce ? Ce(Ee, this) : this.multiplyUnsafe(m);
    }
    isSmallOrder() {
      return this.multiplyUnsafe(m).is0();
    }
    toBytes(Ce = !0) {
      return _abool2(Ce, "isCompressed"), this.assertValidity(), x(Ee, this, Ce);
    }
    toHex(Ce = !0) {
      return bytesToHex$1(this.toBytes(Ce));
    }
    toString() {
      return `<Point ${this.is0() ? "ZERO" : this.toHex()}>`;
    }
    // TODO: remove
    get px() {
      return this.X;
    }
    get py() {
      return this.X;
    }
    get pz() {
      return this.Z;
    }
    toRawBytes(Ce = !0) {
      return this.toBytes(Ce);
    }
    _setWindowSize(Ce) {
      this.precompute(Ce);
    }
    static normalizeZ(Ce) {
      return normalizeZ(Ee, Ce);
    }
    static msm(Ce, Se) {
      return pippenger(Ee, t, Ce, Se);
    }
    static fromPrivateKey(Ce) {
      return Ee.BASE.multiply(_normFnElement(t, Ce));
    }
  }
  Ee.BASE = new Ee(l.Gx, l.Gy, p.ONE), Ee.ZERO = new Ee(p.ZERO, p.ONE, p.ZERO), Ee.Fp = p, Ee.Fn = t;
  const He = t.BITS, ve = new wNAF(Ee, A.endo ? Math.ceil(He / 2) : He);
  return Ee.BASE.precompute(8), Ee;
}
function pprefix(s) {
  return Uint8Array.of(s ? 2 : 3);
}
function getWLengths(s, A) {
  return {
    secretKey: A.BYTES,
    publicKey: 1 + s.BYTES,
    publicKeyUncompressed: 1 + 2 * s.BYTES,
    publicKeyHasPrefix: !0,
    signature: 2 * A.BYTES
  };
}
function ecdh(s, A = {}) {
  const { Fn: u } = s, p = A.randomBytes || randomBytes, t = Object.assign(getWLengths(s.Fp, u), { seed: getMinHashLength(u.ORDER) });
  function l(x) {
    try {
      return !!_normFnElement(u, x);
    } catch {
      return !1;
    }
  }
  function m(x, M) {
    const { publicKey: F, publicKeyUncompressed: le } = t;
    try {
      const ge = x.length;
      return M === !0 && ge !== F || M === !1 && ge !== le ? !1 : !!s.fromBytes(x);
    } catch {
      return !1;
    }
  }
  function b(x = p(t.seed)) {
    return mapHashToField(_abytes2(x, t.seed, "seed"), u.ORDER);
  }
  function k(x, M = !0) {
    return s.BASE.multiply(_normFnElement(u, x)).toBytes(M);
  }
  function C(x) {
    const M = b(x);
    return { secretKey: M, publicKey: k(M) };
  }
  function B(x) {
    if (typeof x == "bigint")
      return !1;
    if (x instanceof s)
      return !0;
    const { secretKey: M, publicKey: F, publicKeyUncompressed: le } = t;
    if (u.allowedLengths || M === F)
      return;
    const ge = ensureBytes("key", x).length;
    return ge === F || ge === le;
  }
  function Q(x, M, F = !0) {
    if (B(x) === !0)
      throw new Error("first arg must be private key");
    if (B(M) === !1)
      throw new Error("second arg must be public key");
    const le = _normFnElement(u, x);
    return s.fromHex(M).multiply(le).toBytes(F);
  }
  return Object.freeze({ getPublicKey: k, getSharedSecret: Q, keygen: C, Point: s, utils: {
    isValidSecretKey: l,
    isValidPublicKey: m,
    randomSecretKey: b,
    // TODO: remove
    isValidPrivateKey: l,
    randomPrivateKey: b,
    normPrivateKeyToScalar: (x) => _normFnElement(u, x),
    precompute(x = 8, M = s.BASE) {
      return M.precompute(x, !1);
    }
  }, lengths: t });
}
function ecdsa(s, A, u = {}) {
  ahash(A), _validateObject(u, {}, {
    hmac: "function",
    lowS: "boolean",
    randomBytes: "function",
    bits2int: "function",
    bits2int_modN: "function"
  });
  const p = u.randomBytes || randomBytes, t = u.hmac || ((Se, ...Ne) => hmac(A, Se, concatBytes$3(...Ne))), { Fp: l, Fn: m } = s, { ORDER: b, BITS: k } = m, { keygen: C, getPublicKey: B, getSharedSecret: Q, utils: P, lengths: x } = ecdh(s, u), M = {
    prehash: !1,
    lowS: typeof u.lowS == "boolean" ? u.lowS : !1,
    format: void 0,
    //'compact' as ECDSASigFormat,
    extraEntropy: !1
  }, F = "compact";
  function le(Se) {
    const Ne = b >> _1n$2;
    return Se > Ne;
  }
  function ge(Se, Ne) {
    if (!m.isValidNot0(Ne))
      throw new Error(`invalid signature ${Se}: out of range 1..Point.Fn.ORDER`);
    return Ne;
  }
  function pe(Se, Ne) {
    validateSigFormat(Ne);
    const rr = x.signature, er = Ne === "compact" ? rr : Ne === "recovered" ? rr + 1 : void 0;
    return _abytes2(Se, er, `${Ne} signature`);
  }
  class Ie {
    constructor(Ne, rr, er) {
      this.r = ge("r", Ne), this.s = ge("s", rr), er != null && (this.recovery = er), Object.freeze(this);
    }
    static fromBytes(Ne, rr = F) {
      pe(Ne, rr);
      let er;
      if (rr === "der") {
        const { r: fr, s: lr } = DER.toSig(_abytes2(Ne));
        return new Ie(fr, lr);
      }
      rr === "recovered" && (er = Ne[0], rr = "compact", Ne = Ne.subarray(1));
      const ir = m.BYTES, sr = Ne.subarray(0, ir), nr = Ne.subarray(ir, ir * 2);
      return new Ie(m.fromBytes(sr), m.fromBytes(nr), er);
    }
    static fromHex(Ne, rr) {
      return this.fromBytes(hexToBytes$1(Ne), rr);
    }
    addRecoveryBit(Ne) {
      return new Ie(this.r, this.s, Ne);
    }
    recoverPublicKey(Ne) {
      const rr = l.ORDER, { r: er, s: ir, recovery: sr } = this;
      if (sr == null || ![0, 1, 2, 3].includes(sr))
        throw new Error("recovery id invalid");
      if (b * _2n$2 < rr && sr > 1)
        throw new Error("recovery id is ambiguous for h>1 curve");
      const fr = sr === 2 || sr === 3 ? er + b : er;
      if (!l.isValid(fr))
        throw new Error("recovery id 2 or 3 invalid");
      const lr = l.toBytes(fr), br = s.fromBytes(concatBytes$3(pprefix((sr & 1) === 0), lr)), Br = m.inv(fr), Fr = Pe(ensureBytes("msgHash", Ne)), Gr = m.create(-Fr * Br), qr = m.create(ir * Br), Hr = s.BASE.multiplyUnsafe(Gr).add(br.multiplyUnsafe(qr));
      if (Hr.is0())
        throw new Error("point at infinify");
      return Hr.assertValidity(), Hr;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return le(this.s);
    }
    toBytes(Ne = F) {
      if (validateSigFormat(Ne), Ne === "der")
        return hexToBytes$1(DER.hexFromSig(this));
      const rr = m.toBytes(this.r), er = m.toBytes(this.s);
      if (Ne === "recovered") {
        if (this.recovery == null)
          throw new Error("recovery bit must be present");
        return concatBytes$3(Uint8Array.of(this.recovery), rr, er);
      }
      return concatBytes$3(rr, er);
    }
    toHex(Ne) {
      return bytesToHex$1(this.toBytes(Ne));
    }
    // TODO: remove
    assertValidity() {
    }
    static fromCompact(Ne) {
      return Ie.fromBytes(ensureBytes("sig", Ne), "compact");
    }
    static fromDER(Ne) {
      return Ie.fromBytes(ensureBytes("sig", Ne), "der");
    }
    normalizeS() {
      return this.hasHighS() ? new Ie(this.r, m.neg(this.s), this.recovery) : this;
    }
    toDERRawBytes() {
      return this.toBytes("der");
    }
    toDERHex() {
      return bytesToHex$1(this.toBytes("der"));
    }
    toCompactRawBytes() {
      return this.toBytes("compact");
    }
    toCompactHex() {
      return bytesToHex$1(this.toBytes("compact"));
    }
  }
  const be = u.bits2int || function(Ne) {
    if (Ne.length > 8192)
      throw new Error("input is too large");
    const rr = bytesToNumberBE(Ne), er = Ne.length * 8 - k;
    return er > 0 ? rr >> BigInt(er) : rr;
  }, Pe = u.bits2int_modN || function(Ne) {
    return m.create(be(Ne));
  }, Te = bitMask(k);
  function Qe(Se) {
    return aInRange("num < 2^" + k, Se, _0n$2, Te), m.toBytes(Se);
  }
  function xe(Se, Ne) {
    return _abytes2(Se, void 0, "message"), Ne ? _abytes2(A(Se), void 0, "prehashed message") : Se;
  }
  function Ee(Se, Ne, rr) {
    if (["recovered", "canonical"].some((Gr) => Gr in rr))
      throw new Error("sign() legacy options not supported");
    const { lowS: er, prehash: ir, extraEntropy: sr } = validateSigOpts(rr, M);
    Se = xe(Se, ir);
    const nr = Pe(Se), fr = _normFnElement(m, Ne), lr = [Qe(fr), Qe(nr)];
    if (sr != null && sr !== !1) {
      const Gr = sr === !0 ? p(x.secretKey) : sr;
      lr.push(ensureBytes("extraEntropy", Gr));
    }
    const br = concatBytes$3(...lr), Br = nr;
    function Fr(Gr) {
      const qr = be(Gr);
      if (!m.isValidNot0(qr))
        return;
      const Hr = m.inv(qr), un = s.BASE.multiply(qr).toAffine(), Dr = m.create(un.x);
      if (Dr === _0n$2)
        return;
      const wr = m.create(Hr * m.create(Br + Dr * fr));
      if (wr === _0n$2)
        return;
      let yr = (un.x === Dr ? 0 : 2) | Number(un.y & _1n$2), Qr = wr;
      return er && le(wr) && (Qr = m.neg(wr), yr ^= 1), new Ie(Dr, Qr, yr);
    }
    return { seed: br, k2sig: Fr };
  }
  function He(Se, Ne, rr = {}) {
    Se = ensureBytes("message", Se);
    const { seed: er, k2sig: ir } = Ee(Se, Ne, rr);
    return createHmacDrbg(A.outputLen, m.BYTES, t)(er, ir);
  }
  function ve(Se) {
    let Ne;
    const rr = typeof Se == "string" || isBytes$3(Se), er = !rr && Se !== null && typeof Se == "object" && typeof Se.r == "bigint" && typeof Se.s == "bigint";
    if (!rr && !er)
      throw new Error("invalid signature, expected Uint8Array, hex string or Signature instance");
    if (er)
      Ne = new Ie(Se.r, Se.s);
    else if (rr) {
      try {
        Ne = Ie.fromBytes(ensureBytes("sig", Se), "der");
      } catch (ir) {
        if (!(ir instanceof DER.Err))
          throw ir;
      }
      if (!Ne)
        try {
          Ne = Ie.fromBytes(ensureBytes("sig", Se), "compact");
        } catch {
          return !1;
        }
    }
    return Ne || !1;
  }
  function we(Se, Ne, rr, er = {}) {
    const { lowS: ir, prehash: sr, format: nr } = validateSigOpts(er, M);
    if (rr = ensureBytes("publicKey", rr), Ne = xe(ensureBytes("message", Ne), sr), "strict" in er)
      throw new Error("options.strict was renamed to lowS");
    const fr = nr === void 0 ? ve(Se) : Ie.fromBytes(ensureBytes("sig", Se), nr);
    if (fr === !1)
      return !1;
    try {
      const lr = s.fromBytes(rr);
      if (ir && fr.hasHighS())
        return !1;
      const { r: br, s: Br } = fr, Fr = Pe(Ne), Gr = m.inv(Br), qr = m.create(Fr * Gr), Hr = m.create(br * Gr), un = s.BASE.multiplyUnsafe(qr).add(lr.multiplyUnsafe(Hr));
      return un.is0() ? !1 : m.create(un.x) === br;
    } catch {
      return !1;
    }
  }
  function Ce(Se, Ne, rr = {}) {
    const { prehash: er } = validateSigOpts(rr, M);
    return Ne = xe(Ne, er), Ie.fromBytes(Se, "recovered").recoverPublicKey(Ne).toBytes();
  }
  return Object.freeze({
    keygen: C,
    getPublicKey: B,
    getSharedSecret: Q,
    utils: P,
    lengths: x,
    Point: s,
    sign: He,
    verify: we,
    recoverPublicKey: Ce,
    Signature: Ie,
    hash: A
  });
}
function _weierstrass_legacy_opts_to_new(s) {
  const A = {
    a: s.a,
    b: s.b,
    p: s.Fp.ORDER,
    n: s.n,
    h: s.h,
    Gx: s.Gx,
    Gy: s.Gy
  }, u = s.Fp;
  let p = s.allowedPrivateKeyLengths ? Array.from(new Set(s.allowedPrivateKeyLengths.map((m) => Math.ceil(m / 2)))) : void 0;
  const t = Field(A.n, {
    BITS: s.nBitLength,
    allowedLengths: p,
    modFromBytes: s.wrapPrivateKey
  }), l = {
    Fp: u,
    Fn: t,
    allowInfinityPoint: s.allowInfinityPoint,
    endo: s.endo,
    isTorsionFree: s.isTorsionFree,
    clearCofactor: s.clearCofactor,
    fromBytes: s.fromBytes,
    toBytes: s.toBytes
  };
  return { CURVE: A, curveOpts: l };
}
function _ecdsa_legacy_opts_to_new(s) {
  const { CURVE: A, curveOpts: u } = _weierstrass_legacy_opts_to_new(s), p = {
    hmac: s.hmac,
    randomBytes: s.randomBytes,
    lowS: s.lowS,
    bits2int: s.bits2int,
    bits2int_modN: s.bits2int_modN
  };
  return { CURVE: A, curveOpts: u, hash: s.hash, ecdsaOpts: p };
}
function _ecdsa_new_output_to_legacy(s, A) {
  const u = A.Point;
  return Object.assign({}, A, {
    ProjectivePoint: u,
    CURVE: Object.assign({}, s, nLength(u.Fn.ORDER, u.Fn.BITS))
  });
}
function weierstrass(s) {
  const { CURVE: A, curveOpts: u, hash: p, ecdsaOpts: t } = _ecdsa_legacy_opts_to_new(s), l = weierstrassN(A, u), m = ecdsa(l, p, t);
  return _ecdsa_new_output_to_legacy(s, m);
}
function createCurve(s, A) {
  const u = (p) => weierstrass({ ...s, hash: p });
  return { ...u(A), create: u };
}
const secp256k1_CURVE = {
  p: BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"),
  n: BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"),
  h: BigInt(1),
  a: BigInt(0),
  b: BigInt(7),
  Gx: BigInt("0x79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"),
  Gy: BigInt("0x483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8")
}, secp256k1_ENDO = {
  beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
  basises: [
    [BigInt("0x3086d221a7d46bcde86c90e49284eb15"), -BigInt("0xe4437ed6010e88286f547fa90abfe4c3")],
    [BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), BigInt("0x3086d221a7d46bcde86c90e49284eb15")]
  ]
}, _0n$1 = /* @__PURE__ */ BigInt(0), _1n$1 = /* @__PURE__ */ BigInt(1), _2n$1 = /* @__PURE__ */ BigInt(2);
function sqrtMod(s) {
  const A = secp256k1_CURVE.p, u = BigInt(3), p = BigInt(6), t = BigInt(11), l = BigInt(22), m = BigInt(23), b = BigInt(44), k = BigInt(88), C = s * s * s % A, B = C * C * s % A, Q = pow2(B, u, A) * B % A, P = pow2(Q, u, A) * B % A, x = pow2(P, _2n$1, A) * C % A, M = pow2(x, t, A) * x % A, F = pow2(M, l, A) * M % A, le = pow2(F, b, A) * F % A, ge = pow2(le, k, A) * le % A, pe = pow2(ge, b, A) * F % A, Ie = pow2(pe, u, A) * B % A, be = pow2(Ie, m, A) * M % A, Pe = pow2(be, p, A) * C % A, Te = pow2(Pe, _2n$1, A);
  if (!Fpk1.eql(Fpk1.sqr(Te), s))
    throw new Error("Cannot find square root");
  return Te;
}
const Fpk1 = Field(secp256k1_CURVE.p, { sqrt: sqrtMod }), secp256k1 = createCurve({ ...secp256k1_CURVE, Fp: Fpk1, lowS: !0, endo: secp256k1_ENDO }, sha256$2), TAGGED_HASH_PREFIXES = {};
function taggedHash(s, ...A) {
  let u = TAGGED_HASH_PREFIXES[s];
  if (u === void 0) {
    const p = sha256$2(utf8ToBytes(s));
    u = concatBytes$3(p, p), TAGGED_HASH_PREFIXES[s] = u;
  }
  return sha256$2(concatBytes$3(u, ...A));
}
const pointToBytes = (s) => s.toBytes(!0).slice(1), Pointk1 = secp256k1.Point, hasEven = (s) => s % _2n$1 === _0n$1;
function schnorrGetExtPubKey(s) {
  const { Fn: A, BASE: u } = Pointk1, p = _normFnElement(A, s), t = u.multiply(p);
  return { scalar: hasEven(t.y) ? p : A.neg(p), bytes: pointToBytes(t) };
}
function lift_x(s) {
  const A = Fpk1;
  if (!A.isValidNot0(s))
    throw new Error("invalid x: Fail if x ≥ p");
  const u = A.create(s * s), p = A.create(u * s + BigInt(7));
  let t = A.sqrt(p);
  hasEven(t) || (t = A.neg(t));
  const l = Pointk1.fromAffine({ x: s, y: t });
  return l.assertValidity(), l;
}
const num = bytesToNumberBE;
function challenge(...s) {
  return Pointk1.Fn.create(num(taggedHash("BIP0340/challenge", ...s)));
}
function schnorrGetPublicKey(s) {
  return schnorrGetExtPubKey(s).bytes;
}
function schnorrSign(s, A, u = randomBytes(32)) {
  const { Fn: p } = Pointk1, t = ensureBytes("message", s), { bytes: l, scalar: m } = schnorrGetExtPubKey(A), b = ensureBytes("auxRand", u, 32), k = p.toBytes(m ^ num(taggedHash("BIP0340/aux", b))), C = taggedHash("BIP0340/nonce", k, l, t), { bytes: B, scalar: Q } = schnorrGetExtPubKey(C), P = challenge(B, l, t), x = new Uint8Array(64);
  if (x.set(B, 0), x.set(p.toBytes(p.create(Q + P * m)), 32), !schnorrVerify(x, t, l))
    throw new Error("sign: Invalid signature produced");
  return x;
}
function schnorrVerify(s, A, u) {
  const { Fn: p, BASE: t } = Pointk1, l = ensureBytes("signature", s, 64), m = ensureBytes("message", A), b = ensureBytes("publicKey", u, 32);
  try {
    const k = lift_x(num(b)), C = num(l.subarray(0, 32));
    if (!inRange(C, _1n$1, secp256k1_CURVE.p))
      return !1;
    const B = num(l.subarray(32, 64));
    if (!inRange(B, _1n$1, secp256k1_CURVE.n))
      return !1;
    const Q = challenge(p.toBytes(C), pointToBytes(k), m), P = t.multiplyUnsafe(B).add(k.multiplyUnsafe(p.neg(Q))), { x, y: M } = P.toAffine();
    return !(P.is0() || !hasEven(M) || x !== C);
  } catch {
    return !1;
  }
}
const schnorr = /* @__PURE__ */ (() => {
  const u = (t = randomBytes(48)) => mapHashToField(t, secp256k1_CURVE.n);
  secp256k1.utils.randomSecretKey;
  function p(t) {
    const l = u(t);
    return { secretKey: l, publicKey: schnorrGetPublicKey(l) };
  }
  return {
    keygen: p,
    getPublicKey: schnorrGetPublicKey,
    sign: schnorrSign,
    verify: schnorrVerify,
    Point: Pointk1,
    utils: {
      randomSecretKey: u,
      randomPrivateKey: u,
      taggedHash,
      // TODO: remove
      lift_x,
      pointToBytes,
      numberToBytesBE,
      bytesToNumberBE,
      mod
    },
    lengths: {
      secretKey: 32,
      publicKey: 32,
      publicKeyHasPrefix: !1,
      signature: 64,
      seed: 48
    }
  };
})(), Rho160 = /* @__PURE__ */ Uint8Array.from([
  7,
  4,
  13,
  1,
  10,
  6,
  15,
  3,
  12,
  0,
  9,
  5,
  2,
  14,
  11,
  8
]), Id160 = Uint8Array.from(new Array(16).fill(0).map((s, A) => A)), Pi160 = Id160.map((s) => (9 * s + 5) % 16), idxLR = /* @__PURE__ */ (() => {
  const u = [[Id160], [Pi160]];
  for (let p = 0; p < 4; p++)
    for (let t of u)
      t.push(t[p].map((l) => Rho160[l]));
  return u;
})(), idxL = idxLR[0], idxR = idxLR[1], shifts160 = /* @__PURE__ */ [
  [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
  [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
  [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
  [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
  [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
].map((s) => Uint8Array.from(s)), shiftsL160 = /* @__PURE__ */ idxL.map((s, A) => s.map((u) => shifts160[A][u])), shiftsR160 = /* @__PURE__ */ idxR.map((s, A) => s.map((u) => shifts160[A][u])), Kl160 = /* @__PURE__ */ Uint32Array.from([
  0,
  1518500249,
  1859775393,
  2400959708,
  2840853838
]), Kr160 = /* @__PURE__ */ Uint32Array.from([
  1352829926,
  1548603684,
  1836072691,
  2053994217,
  0
]);
function ripemd_f(s, A, u, p) {
  return s === 0 ? A ^ u ^ p : s === 1 ? A & u | ~A & p : s === 2 ? (A | ~u) ^ p : s === 3 ? A & p | u & ~p : A ^ (u | ~p);
}
const BUF_160 = /* @__PURE__ */ new Uint32Array(16);
class RIPEMD160 extends HashMD {
  constructor() {
    super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
  }
  get() {
    const { h0: A, h1: u, h2: p, h3: t, h4: l } = this;
    return [A, u, p, t, l];
  }
  set(A, u, p, t, l) {
    this.h0 = A | 0, this.h1 = u | 0, this.h2 = p | 0, this.h3 = t | 0, this.h4 = l | 0;
  }
  process(A, u) {
    for (let x = 0; x < 16; x++, u += 4)
      BUF_160[x] = A.getUint32(u, !0);
    let p = this.h0 | 0, t = p, l = this.h1 | 0, m = l, b = this.h2 | 0, k = b, C = this.h3 | 0, B = C, Q = this.h4 | 0, P = Q;
    for (let x = 0; x < 5; x++) {
      const M = 4 - x, F = Kl160[x], le = Kr160[x], ge = idxL[x], pe = idxR[x], Ie = shiftsL160[x], be = shiftsR160[x];
      for (let Pe = 0; Pe < 16; Pe++) {
        const Te = rotl(p + ripemd_f(x, l, b, C) + BUF_160[ge[Pe]] + F, Ie[Pe]) + Q | 0;
        p = Q, Q = C, C = rotl(b, 10) | 0, b = l, l = Te;
      }
      for (let Pe = 0; Pe < 16; Pe++) {
        const Te = rotl(t + ripemd_f(M, m, k, B) + BUF_160[pe[Pe]] + le, be[Pe]) + P | 0;
        t = P, P = B, B = rotl(k, 10) | 0, k = m, m = Te;
      }
    }
    this.set(this.h1 + b + B | 0, this.h2 + C + P | 0, this.h3 + Q + t | 0, this.h4 + p + m | 0, this.h0 + l + k | 0);
  }
  roundClean() {
    clean(BUF_160);
  }
  destroy() {
    this.destroyed = !0, clean(this.buffer), this.set(0, 0, 0, 0, 0);
  }
}
const ripemd160 = /* @__PURE__ */ createHasher(() => new RIPEMD160());
function isBytes$2(s) {
  return s instanceof Uint8Array || ArrayBuffer.isView(s) && s.constructor.name === "Uint8Array";
}
function abytes(s, ...A) {
  if (!isBytes$2(s))
    throw new Error("Uint8Array expected");
  if (A.length > 0 && !A.includes(s.length))
    throw new Error("Uint8Array expected of length " + A + ", got length=" + s.length);
}
function isArrayOf(s, A) {
  return Array.isArray(A) ? A.length === 0 ? !0 : s ? A.every((u) => typeof u == "string") : A.every((u) => Number.isSafeInteger(u)) : !1;
}
function afn(s) {
  if (typeof s != "function")
    throw new Error("function expected");
  return !0;
}
function astr(s, A) {
  if (typeof A != "string")
    throw new Error(`${s}: string expected`);
  return !0;
}
function anumber(s) {
  if (!Number.isSafeInteger(s))
    throw new Error(`invalid integer: ${s}`);
}
function aArr(s) {
  if (!Array.isArray(s))
    throw new Error("array expected");
}
function astrArr(s, A) {
  if (!isArrayOf(!0, A))
    throw new Error(`${s}: array of strings expected`);
}
function anumArr(s, A) {
  if (!isArrayOf(!1, A))
    throw new Error(`${s}: array of numbers expected`);
}
// @__NO_SIDE_EFFECTS__
function chain(...s) {
  const A = (l) => l, u = (l, m) => (b) => l(m(b)), p = s.map((l) => l.encode).reduceRight(u, A), t = s.map((l) => l.decode).reduce(u, A);
  return { encode: p, decode: t };
}
// @__NO_SIDE_EFFECTS__
function alphabet(s) {
  const A = typeof s == "string" ? s.split("") : s, u = A.length;
  astrArr("alphabet", A);
  const p = new Map(A.map((t, l) => [t, l]));
  return {
    encode: (t) => (aArr(t), t.map((l) => {
      if (!Number.isSafeInteger(l) || l < 0 || l >= u)
        throw new Error(`alphabet.encode: digit index outside alphabet "${l}". Allowed: ${s}`);
      return A[l];
    })),
    decode: (t) => (aArr(t), t.map((l) => {
      astr("alphabet.decode", l);
      const m = p.get(l);
      if (m === void 0)
        throw new Error(`Unknown letter: "${l}". Allowed: ${s}`);
      return m;
    }))
  };
}
// @__NO_SIDE_EFFECTS__
function join(s = "") {
  return astr("join", s), {
    encode: (A) => (astrArr("join.decode", A), A.join(s)),
    decode: (A) => (astr("join.decode", A), A.split(s))
  };
}
// @__NO_SIDE_EFFECTS__
function normalize(s) {
  return afn(s), { encode: (A) => A, decode: (A) => s(A) };
}
function convertRadix(s, A, u) {
  if (A < 2)
    throw new Error(`convertRadix: invalid from=${A}, base cannot be less than 2`);
  if (u < 2)
    throw new Error(`convertRadix: invalid to=${u}, base cannot be less than 2`);
  if (aArr(s), !s.length)
    return [];
  let p = 0;
  const t = [], l = Array.from(s, (b) => {
    if (anumber(b), b < 0 || b >= A)
      throw new Error(`invalid integer: ${b}`);
    return b;
  }), m = l.length;
  for (; ; ) {
    let b = 0, k = !0;
    for (let C = p; C < m; C++) {
      const B = l[C], Q = A * b, P = Q + B;
      if (!Number.isSafeInteger(P) || Q / A !== b || P - B !== Q)
        throw new Error("convertRadix: carry overflow");
      const x = P / u;
      b = P % u;
      const M = Math.floor(x);
      if (l[C] = M, !Number.isSafeInteger(M) || M * u + b !== P)
        throw new Error("convertRadix: carry overflow");
      if (k)
        M ? k = !1 : p = C;
      else continue;
    }
    if (t.push(b), k)
      break;
  }
  for (let b = 0; b < s.length - 1 && s[b] === 0; b++)
    t.push(0);
  return t.reverse();
}
const gcd = (s, A) => A === 0 ? s : gcd(A, s % A), radix2carry = /* @__NO_SIDE_EFFECTS__ */ (s, A) => s + (A - gcd(s, A)), powers = /* @__PURE__ */ (() => {
  let s = [];
  for (let A = 0; A < 40; A++)
    s.push(2 ** A);
  return s;
})();
function convertRadix2(s, A, u, p) {
  if (aArr(s), A <= 0 || A > 32)
    throw new Error(`convertRadix2: wrong from=${A}`);
  if (u <= 0 || u > 32)
    throw new Error(`convertRadix2: wrong to=${u}`);
  if (/* @__PURE__ */ radix2carry(A, u) > 32)
    throw new Error(`convertRadix2: carry overflow from=${A} to=${u} carryBits=${/* @__PURE__ */ radix2carry(A, u)}`);
  let t = 0, l = 0;
  const m = powers[A], b = powers[u] - 1, k = [];
  for (const C of s) {
    if (anumber(C), C >= m)
      throw new Error(`convertRadix2: invalid data word=${C} from=${A}`);
    if (t = t << A | C, l + A > 32)
      throw new Error(`convertRadix2: carry overflow pos=${l} from=${A}`);
    for (l += A; l >= u; l -= u)
      k.push((t >> l - u & b) >>> 0);
    const B = powers[l];
    if (B === void 0)
      throw new Error("invalid carry");
    t &= B - 1;
  }
  if (t = t << u - l & b, !p && l >= A)
    throw new Error("Excess padding");
  if (!p && t > 0)
    throw new Error(`Non-zero padding: ${t}`);
  return p && l > 0 && k.push(t >>> 0), k;
}
// @__NO_SIDE_EFFECTS__
function radix(s) {
  anumber(s);
  const A = 2 ** 8;
  return {
    encode: (u) => {
      if (!isBytes$2(u))
        throw new Error("radix.encode input should be Uint8Array");
      return convertRadix(Array.from(u), A, s);
    },
    decode: (u) => (anumArr("radix.decode", u), Uint8Array.from(convertRadix(u, s, A)))
  };
}
// @__NO_SIDE_EFFECTS__
function radix2(s, A = !1) {
  if (anumber(s), s <= 0 || s > 32)
    throw new Error("radix2: bits should be in (0..32]");
  if (/* @__PURE__ */ radix2carry(8, s) > 32 || /* @__PURE__ */ radix2carry(s, 8) > 32)
    throw new Error("radix2: carry overflow");
  return {
    encode: (u) => {
      if (!isBytes$2(u))
        throw new Error("radix2.encode input should be Uint8Array");
      return convertRadix2(Array.from(u), 8, s, !A);
    },
    decode: (u) => (anumArr("radix2.decode", u), Uint8Array.from(convertRadix2(u, s, 8, A)))
  };
}
function unsafeWrapper(s) {
  return afn(s), function(...A) {
    try {
      return s.apply(null, A);
    } catch {
    }
  };
}
function checksum$1(s, A) {
  return anumber(s), afn(A), {
    encode(u) {
      if (!isBytes$2(u))
        throw new Error("checksum.encode: input should be Uint8Array");
      const p = A(u).slice(0, s), t = new Uint8Array(u.length + s);
      return t.set(u), t.set(p, u.length), t;
    },
    decode(u) {
      if (!isBytes$2(u))
        throw new Error("checksum.decode: input should be Uint8Array");
      const p = u.slice(0, -s), t = u.slice(-s), l = A(p).slice(0, s);
      for (let m = 0; m < s; m++)
        if (l[m] !== t[m])
          throw new Error("Invalid checksum");
      return p;
    }
  };
}
const genBase58 = /* @__NO_SIDE_EFFECTS__ */ (s) => /* @__PURE__ */ chain(/* @__PURE__ */ radix(58), /* @__PURE__ */ alphabet(s), /* @__PURE__ */ join("")), base58 = /* @__PURE__ */ genBase58("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"), createBase58check = (s) => /* @__PURE__ */ chain(checksum$1(4, (A) => s(s(A))), base58), BECH_ALPHABET = /* @__PURE__ */ chain(/* @__PURE__ */ alphabet("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), /* @__PURE__ */ join("")), POLYMOD_GENERATORS = [996825010, 642813549, 513874426, 1027748829, 705979059];
function bech32Polymod(s) {
  const A = s >> 25;
  let u = (s & 33554431) << 5;
  for (let p = 0; p < POLYMOD_GENERATORS.length; p++)
    (A >> p & 1) === 1 && (u ^= POLYMOD_GENERATORS[p]);
  return u;
}
function bechChecksum(s, A, u = 1) {
  const p = s.length;
  let t = 1;
  for (let l = 0; l < p; l++) {
    const m = s.charCodeAt(l);
    if (m < 33 || m > 126)
      throw new Error(`Invalid prefix (${s})`);
    t = bech32Polymod(t) ^ m >> 5;
  }
  t = bech32Polymod(t);
  for (let l = 0; l < p; l++)
    t = bech32Polymod(t) ^ s.charCodeAt(l) & 31;
  for (let l of A)
    t = bech32Polymod(t) ^ l;
  for (let l = 0; l < 6; l++)
    t = bech32Polymod(t);
  return t ^= u, BECH_ALPHABET.encode(convertRadix2([t % powers[30]], 30, 5, !1));
}
// @__NO_SIDE_EFFECTS__
function genBech32(s) {
  const A = s === "bech32" ? 1 : 734539939, u = /* @__PURE__ */ radix2(5), p = u.decode, t = u.encode, l = unsafeWrapper(p);
  function m(Q, P, x = 90) {
    astr("bech32.encode prefix", Q), isBytes$2(P) && (P = Array.from(P)), anumArr("bech32.encode", P);
    const M = Q.length;
    if (M === 0)
      throw new TypeError(`Invalid prefix length ${M}`);
    const F = M + 7 + P.length;
    if (x !== !1 && F > x)
      throw new TypeError(`Length ${F} exceeds limit ${x}`);
    const le = Q.toLowerCase(), ge = bechChecksum(le, P, A);
    return `${le}1${BECH_ALPHABET.encode(P)}${ge}`;
  }
  function b(Q, P = 90) {
    astr("bech32.decode input", Q);
    const x = Q.length;
    if (x < 8 || P !== !1 && x > P)
      throw new TypeError(`invalid string length: ${x} (${Q}). Expected (8..${P})`);
    const M = Q.toLowerCase();
    if (Q !== M && Q !== Q.toUpperCase())
      throw new Error("String must be lowercase or uppercase");
    const F = M.lastIndexOf("1");
    if (F === 0 || F === -1)
      throw new Error('Letter "1" must be present between prefix and data only');
    const le = M.slice(0, F), ge = M.slice(F + 1);
    if (ge.length < 6)
      throw new Error("Data must be at least 6 characters long");
    const pe = BECH_ALPHABET.decode(ge).slice(0, -6), Ie = bechChecksum(le, pe, A);
    if (!ge.endsWith(Ie))
      throw new Error(`Invalid checksum in ${Q}: expected "${Ie}"`);
    return { prefix: le, words: pe };
  }
  const k = unsafeWrapper(b);
  function C(Q) {
    const { prefix: P, words: x } = b(Q, !1);
    return { prefix: P, words: x, bytes: p(x) };
  }
  function B(Q, P) {
    return m(Q, t(P));
  }
  return {
    encode: m,
    decode: b,
    encodeFromBytes: B,
    decodeToBytes: C,
    decodeUnsafe: k,
    fromWords: p,
    fromWordsUnsafe: l,
    toWords: t
  };
}
const bech32$1 = /* @__PURE__ */ genBech32("bech32"), bech32m = /* @__PURE__ */ genBech32("bech32m"), utf8$1 = {
  encode: (s) => new TextDecoder().decode(s),
  decode: (s) => new TextEncoder().encode(s)
}, hasHexBuiltin = typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function", hexBuiltin = {
  encode(s) {
    return abytes(s), s.toHex();
  },
  decode(s) {
    return astr("hex", s), Uint8Array.fromHex(s);
  }
}, hex$1 = hasHexBuiltin ? hexBuiltin : /* @__PURE__ */ chain(/* @__PURE__ */ radix2(4), /* @__PURE__ */ alphabet("0123456789abcdef"), /* @__PURE__ */ join(""), /* @__PURE__ */ normalize((s) => {
  if (typeof s != "string" || s.length % 2 !== 0)
    throw new TypeError(`hex.decode: expected string, got ${typeof s} with length ${s.length}`);
  return s.toLowerCase();
})), EMPTY = /* @__PURE__ */ new Uint8Array(), NULL = /* @__PURE__ */ new Uint8Array([0]);
function equalBytes$1(s, A) {
  if (s.length !== A.length)
    return !1;
  for (let u = 0; u < s.length; u++)
    if (s[u] !== A[u])
      return !1;
  return !0;
}
function isBytes$1(s) {
  return s instanceof Uint8Array || ArrayBuffer.isView(s) && s.constructor.name === "Uint8Array";
}
function concatBytes$2(...s) {
  let A = 0;
  for (let p = 0; p < s.length; p++) {
    const t = s[p];
    if (!isBytes$1(t))
      throw new Error("Uint8Array expected");
    A += t.length;
  }
  const u = new Uint8Array(A);
  for (let p = 0, t = 0; p < s.length; p++) {
    const l = s[p];
    u.set(l, t), t += l.length;
  }
  return u;
}
const createView = (s) => new DataView(s.buffer, s.byteOffset, s.byteLength);
function isPlainObject(s) {
  return Object.prototype.toString.call(s) === "[object Object]";
}
function isNum(s) {
  return Number.isSafeInteger(s);
}
const utils$2 = {
  equalBytes: equalBytes$1,
  isBytes: isBytes$1,
  concatBytes: concatBytes$2
}, lengthCoder = (s) => {
  if (s !== null && typeof s != "string" && !isCoder(s) && !isBytes$1(s) && !isNum(s))
    throw new Error(`lengthCoder: expected null | number | Uint8Array | CoderType, got ${s} (${typeof s})`);
  return {
    encodeStream(A, u) {
      if (s === null)
        return;
      if (isCoder(s))
        return s.encodeStream(A, u);
      let p;
      if (typeof s == "number" ? p = s : typeof s == "string" && (p = Path.resolve(A.stack, s)), typeof p == "bigint" && (p = Number(p)), p === void 0 || p !== u)
        throw A.err(`Wrong length: ${p} len=${s} exp=${u} (${typeof u})`);
    },
    decodeStream(A) {
      let u;
      if (isCoder(s) ? u = Number(s.decodeStream(A)) : typeof s == "number" ? u = s : typeof s == "string" && (u = Path.resolve(A.stack, s)), typeof u == "bigint" && (u = Number(u)), typeof u != "number")
        throw A.err(`Wrong length: ${u}`);
      return u;
    }
  };
}, Bitset = {
  BITS: 32,
  FULL_MASK: -1 >>> 0,
  // 1<<32 will overflow
  len: (s) => Math.ceil(s / 32),
  create: (s) => new Uint32Array(Bitset.len(s)),
  clean: (s) => s.fill(0),
  debug: (s) => Array.from(s).map((A) => (A >>> 0).toString(2).padStart(32, "0")),
  checkLen: (s, A) => {
    if (Bitset.len(A) !== s.length)
      throw new Error(`wrong length=${s.length}. Expected: ${Bitset.len(A)}`);
  },
  chunkLen: (s, A, u) => {
    if (A < 0)
      throw new Error(`wrong pos=${A}`);
    if (A + u > s)
      throw new Error(`wrong range=${A}/${u} of ${s}`);
  },
  set: (s, A, u, p = !0) => !p && (s[A] & u) !== 0 ? !1 : (s[A] |= u, !0),
  pos: (s, A) => ({
    chunk: Math.floor((s + A) / 32),
    mask: 1 << 32 - (s + A) % 32 - 1
  }),
  indices: (s, A, u = !1) => {
    Bitset.checkLen(s, A);
    const { FULL_MASK: p, BITS: t } = Bitset, l = t - A % t, m = l ? p >>> l << l : p, b = [];
    for (let k = 0; k < s.length; k++) {
      let C = s[k];
      if (u && (C = ~C), k === s.length - 1 && (C &= m), C !== 0)
        for (let B = 0; B < t; B++) {
          const Q = 1 << t - B - 1;
          C & Q && b.push(k * t + B);
        }
    }
    return b;
  },
  range: (s) => {
    const A = [];
    let u;
    for (const p of s)
      u === void 0 || p !== u.pos + u.length ? A.push(u = { pos: p, length: 1 }) : u.length += 1;
    return A;
  },
  rangeDebug: (s, A, u = !1) => `[${Bitset.range(Bitset.indices(s, A, u)).map((p) => `(${p.pos}/${p.length})`).join(", ")}]`,
  setRange: (s, A, u, p, t = !0) => {
    Bitset.chunkLen(A, u, p);
    const { FULL_MASK: l, BITS: m } = Bitset, b = u % m ? Math.floor(u / m) : void 0, k = u + p, C = k % m ? Math.floor(k / m) : void 0;
    if (b !== void 0 && b === C)
      return Bitset.set(s, b, l >>> m - p << m - p - u, t);
    if (b !== void 0 && !Bitset.set(s, b, l >>> u % m, t))
      return !1;
    const B = b !== void 0 ? b + 1 : u / m, Q = C !== void 0 ? C : k / m;
    for (let P = B; P < Q; P++)
      if (!Bitset.set(s, P, l, t))
        return !1;
    return !(C !== void 0 && b !== C && !Bitset.set(s, C, l << m - k % m, t));
  }
}, Path = {
  /**
   * Internal method for handling stack of paths (debug, errors, dynamic fields via path)
   * This is looks ugly (callback), but allows us to force stack cleaning by construction (.pop always after function).
   * Also, this makes impossible:
   * - pushing field when stack is empty
   * - pushing field inside of field (real bug)
   * NOTE: we don't want to do '.pop' on error!
   */
  pushObj: (s, A, u) => {
    const p = { obj: A };
    s.push(p), u((t, l) => {
      p.field = t, l(), p.field = void 0;
    }), s.pop();
  },
  path: (s) => {
    const A = [];
    for (const u of s)
      u.field !== void 0 && A.push(u.field);
    return A.join("/");
  },
  err: (s, A, u) => {
    const p = new Error(`${s}(${Path.path(A)}): ${typeof u == "string" ? u : u.message}`);
    return u instanceof Error && u.stack && (p.stack = u.stack), p;
  },
  resolve: (s, A) => {
    const u = A.split("/"), p = s.map((m) => m.obj);
    let t = 0;
    for (; t < u.length && u[t] === ".."; t++)
      p.pop();
    let l = p.pop();
    for (; t < u.length; t++) {
      if (!l || l[u[t]] === void 0)
        return;
      l = l[u[t]];
    }
    return l;
  }
};
class _Reader {
  constructor(A, u = {}, p = [], t = void 0, l = 0) {
    this.pos = 0, this.bitBuf = 0, this.bitPos = 0, this.data = A, this.opts = u, this.stack = p, this.parent = t, this.parentOffset = l, this.view = createView(A);
  }
  /** Internal method for pointers. */
  _enablePointers() {
    if (this.parent)
      return this.parent._enablePointers();
    this.bs || (this.bs = Bitset.create(this.data.length), Bitset.setRange(this.bs, this.data.length, 0, this.pos, this.opts.allowMultipleReads));
  }
  markBytesBS(A, u) {
    return this.parent ? this.parent.markBytesBS(this.parentOffset + A, u) : !u || !this.bs ? !0 : Bitset.setRange(this.bs, this.data.length, A, u, !1);
  }
  markBytes(A) {
    const u = this.pos;
    this.pos += A;
    const p = this.markBytesBS(u, A);
    if (!this.opts.allowMultipleReads && !p)
      throw this.err(`multiple read pos=${this.pos} len=${A}`);
    return p;
  }
  pushObj(A, u) {
    return Path.pushObj(this.stack, A, u);
  }
  readView(A, u) {
    if (!Number.isFinite(A))
      throw this.err(`readView: wrong length=${A}`);
    if (this.pos + A > this.data.length)
      throw this.err("readView: Unexpected end of buffer");
    const p = u(this.view, this.pos);
    return this.markBytes(A), p;
  }
  // read bytes by absolute offset
  absBytes(A) {
    if (A > this.data.length)
      throw new Error("Unexpected end of buffer");
    return this.data.subarray(A);
  }
  finish() {
    if (!this.opts.allowUnreadBytes) {
      if (this.bitPos)
        throw this.err(`${this.bitPos} bits left after unpack: ${hex$1.encode(this.data.slice(this.pos))}`);
      if (this.bs && !this.parent) {
        const A = Bitset.indices(this.bs, this.data.length, !0);
        if (A.length) {
          const u = Bitset.range(A).map(({ pos: p, length: t }) => `(${p}/${t})[${hex$1.encode(this.data.subarray(p, p + t))}]`).join(", ");
          throw this.err(`unread byte ranges: ${u} (total=${this.data.length})`);
        } else
          return;
      }
      if (!this.isEnd())
        throw this.err(`${this.leftBytes} bytes ${this.bitPos} bits left after unpack: ${hex$1.encode(this.data.slice(this.pos))}`);
    }
  }
  // User methods
  err(A) {
    return Path.err("Reader", this.stack, A);
  }
  offsetReader(A) {
    if (A > this.data.length)
      throw this.err("offsetReader: Unexpected end of buffer");
    return new _Reader(this.absBytes(A), this.opts, this.stack, this, A);
  }
  bytes(A, u = !1) {
    if (this.bitPos)
      throw this.err("readBytes: bitPos not empty");
    if (!Number.isFinite(A))
      throw this.err(`readBytes: wrong length=${A}`);
    if (this.pos + A > this.data.length)
      throw this.err("readBytes: Unexpected end of buffer");
    const p = this.data.subarray(this.pos, this.pos + A);
    return u || this.markBytes(A), p;
  }
  byte(A = !1) {
    if (this.bitPos)
      throw this.err("readByte: bitPos not empty");
    if (this.pos + 1 > this.data.length)
      throw this.err("readBytes: Unexpected end of buffer");
    const u = this.data[this.pos];
    return A || this.markBytes(1), u;
  }
  get leftBytes() {
    return this.data.length - this.pos;
  }
  get totalBytes() {
    return this.data.length;
  }
  isEnd() {
    return this.pos >= this.data.length && !this.bitPos;
  }
  // bits are read in BE mode (left to right): (0b1000_0000).readBits(1) == 1
  bits(A) {
    if (A > 32)
      throw this.err("BitReader: cannot read more than 32 bits in single call");
    let u = 0;
    for (; A; ) {
      this.bitPos || (this.bitBuf = this.byte(), this.bitPos = 8);
      const p = Math.min(A, this.bitPos);
      this.bitPos -= p, u = u << p | this.bitBuf >> this.bitPos & 2 ** p - 1, this.bitBuf &= 2 ** this.bitPos - 1, A -= p;
    }
    return u >>> 0;
  }
  find(A, u = this.pos) {
    if (!isBytes$1(A))
      throw this.err(`find: needle is not bytes! ${A}`);
    if (this.bitPos)
      throw this.err("findByte: bitPos not empty");
    if (!A.length)
      throw this.err("find: needle is empty");
    for (let p = u; (p = this.data.indexOf(A[0], p)) !== -1; p++) {
      if (p === -1 || this.data.length - p < A.length)
        return;
      if (equalBytes$1(A, this.data.subarray(p, p + A.length)))
        return p;
    }
  }
}
class _Writer {
  constructor(A = []) {
    this.pos = 0, this.buffers = [], this.ptrs = [], this.bitBuf = 0, this.bitPos = 0, this.viewBuf = new Uint8Array(8), this.finished = !1, this.stack = A, this.view = createView(this.viewBuf);
  }
  pushObj(A, u) {
    return Path.pushObj(this.stack, A, u);
  }
  writeView(A, u) {
    if (this.finished)
      throw this.err("buffer: finished");
    if (!isNum(A) || A > 8)
      throw new Error(`wrong writeView length=${A}`);
    u(this.view), this.bytes(this.viewBuf.slice(0, A)), this.viewBuf.fill(0);
  }
  // User methods
  err(A) {
    if (this.finished)
      throw this.err("buffer: finished");
    return Path.err("Reader", this.stack, A);
  }
  bytes(A) {
    if (this.finished)
      throw this.err("buffer: finished");
    if (this.bitPos)
      throw this.err("writeBytes: ends with non-empty bit buffer");
    this.buffers.push(A), this.pos += A.length;
  }
  byte(A) {
    if (this.finished)
      throw this.err("buffer: finished");
    if (this.bitPos)
      throw this.err("writeByte: ends with non-empty bit buffer");
    this.buffers.push(new Uint8Array([A])), this.pos++;
  }
  finish(A = !0) {
    if (this.finished)
      throw this.err("buffer: finished");
    if (this.bitPos)
      throw this.err("buffer: ends with non-empty bit buffer");
    const u = this.buffers.concat(this.ptrs.map((l) => l.buffer)), p = u.map((l) => l.length).reduce((l, m) => l + m, 0), t = new Uint8Array(p);
    for (let l = 0, m = 0; l < u.length; l++) {
      const b = u[l];
      t.set(b, m), m += b.length;
    }
    for (let l = this.pos, m = 0; m < this.ptrs.length; m++) {
      const b = this.ptrs[m];
      t.set(b.ptr.encode(l), b.pos), l += b.buffer.length;
    }
    if (A) {
      this.buffers = [];
      for (const l of this.ptrs)
        l.buffer.fill(0);
      this.ptrs = [], this.finished = !0, this.bitBuf = 0;
    }
    return t;
  }
  bits(A, u) {
    if (u > 32)
      throw this.err("writeBits: cannot write more than 32 bits in single call");
    if (A >= 2 ** u)
      throw this.err(`writeBits: value (${A}) >= 2**bits (${u})`);
    for (; u; ) {
      const p = Math.min(u, 8 - this.bitPos);
      this.bitBuf = this.bitBuf << p | A >> u - p, this.bitPos += p, u -= p, A &= 2 ** u - 1, this.bitPos === 8 && (this.bitPos = 0, this.buffers.push(new Uint8Array([this.bitBuf])), this.pos++);
    }
  }
}
const swapEndianness = (s) => Uint8Array.from(s).reverse();
function checkBounds(s, A, u) {
  if (u) {
    const p = 2n ** (A - 1n);
    if (s < -p || s >= p)
      throw new Error(`value out of signed bounds. Expected ${-p} <= ${s} < ${p}`);
  } else if (0n > s || s >= 2n ** A)
    throw new Error(`value out of unsigned bounds. Expected 0 <= ${s} < ${2n ** A}`);
}
function _wrap(s) {
  return {
    // NOTE: we cannot export validate here, since it is likely mistake.
    encodeStream: s.encodeStream,
    decodeStream: s.decodeStream,
    size: s.size,
    encode: (A) => {
      const u = new _Writer();
      return s.encodeStream(u, A), u.finish();
    },
    decode: (A, u = {}) => {
      const p = new _Reader(A, u), t = s.decodeStream(p);
      return p.finish(), t;
    }
  };
}
function validate(s, A) {
  if (!isCoder(s))
    throw new Error(`validate: invalid inner value ${s}`);
  if (typeof A != "function")
    throw new Error("validate: fn should be function");
  return _wrap({
    size: s.size,
    encodeStream: (u, p) => {
      let t;
      try {
        t = A(p);
      } catch (l) {
        throw u.err(l);
      }
      s.encodeStream(u, t);
    },
    decodeStream: (u) => {
      const p = s.decodeStream(u);
      try {
        return A(p);
      } catch (t) {
        throw u.err(t);
      }
    }
  });
}
const wrap = (s) => {
  const A = _wrap(s);
  return s.validate ? validate(A, s.validate) : A;
}, isBaseCoder = (s) => isPlainObject(s) && typeof s.decode == "function" && typeof s.encode == "function";
function isCoder(s) {
  return isPlainObject(s) && isBaseCoder(s) && typeof s.encodeStream == "function" && typeof s.decodeStream == "function" && (s.size === void 0 || isNum(s.size));
}
function dict() {
  return {
    encode: (s) => {
      if (!Array.isArray(s))
        throw new Error("array expected");
      const A = {};
      for (const u of s) {
        if (!Array.isArray(u) || u.length !== 2)
          throw new Error("array of two elements expected");
        const p = u[0], t = u[1];
        if (A[p] !== void 0)
          throw new Error(`key(${p}) appears twice in struct`);
        A[p] = t;
      }
      return A;
    },
    decode: (s) => {
      if (!isPlainObject(s))
        throw new Error(`expected plain object, got ${s}`);
      return Object.entries(s);
    }
  };
}
const numberBigint = {
  encode: (s) => {
    if (typeof s != "bigint")
      throw new Error(`expected bigint, got ${typeof s}`);
    if (s > BigInt(Number.MAX_SAFE_INTEGER))
      throw new Error(`element bigger than MAX_SAFE_INTEGER=${s}`);
    return Number(s);
  },
  decode: (s) => {
    if (!isNum(s))
      throw new Error("element is not a safe integer");
    return BigInt(s);
  }
};
function tsEnum(s) {
  if (!isPlainObject(s))
    throw new Error("plain object expected");
  return {
    encode: (A) => {
      if (!isNum(A) || !(A in s))
        throw new Error(`wrong value ${A}`);
      return s[A];
    },
    decode: (A) => {
      if (typeof A != "string")
        throw new Error(`wrong value ${typeof A}`);
      return s[A];
    }
  };
}
function decimal(s, A = !1) {
  if (!isNum(s))
    throw new Error(`decimal/precision: wrong value ${s}`);
  if (typeof A != "boolean")
    throw new Error(`decimal/round: expected boolean, got ${typeof A}`);
  const u = 10n ** BigInt(s);
  return {
    encode: (p) => {
      if (typeof p != "bigint")
        throw new Error(`expected bigint, got ${typeof p}`);
      let t = (p < 0n ? -p : p).toString(10), l = t.length - s;
      l < 0 && (t = t.padStart(t.length - l, "0"), l = 0);
      let m = t.length - 1;
      for (; m >= l && t[m] === "0"; m--)
        ;
      let b = t.slice(0, l), k = t.slice(l, m + 1);
      return b || (b = "0"), p < 0n && (b = "-" + b), k ? `${b}.${k}` : b;
    },
    decode: (p) => {
      if (typeof p != "string")
        throw new Error(`expected string, got ${typeof p}`);
      if (p === "-0")
        throw new Error("negative zero is not allowed");
      let t = !1;
      if (p.startsWith("-") && (t = !0, p = p.slice(1)), !/^(0|[1-9]\d*)(\.\d+)?$/.test(p))
        throw new Error(`wrong string value=${p}`);
      let l = p.indexOf(".");
      l = l === -1 ? p.length : l;
      const m = p.slice(0, l), b = p.slice(l + 1).replace(/0+$/, ""), k = BigInt(m) * u;
      if (!A && b.length > s)
        throw new Error(`fractional part cannot be represented with this precision (num=${p}, prec=${s})`);
      const C = Math.min(b.length, s), B = BigInt(b.slice(0, C)) * 10n ** BigInt(s - C), Q = k + B;
      return t ? -Q : Q;
    }
  };
}
function match(s) {
  if (!Array.isArray(s))
    throw new Error(`expected array, got ${typeof s}`);
  for (const A of s)
    if (!isBaseCoder(A))
      throw new Error(`wrong base coder ${A}`);
  return {
    encode: (A) => {
      for (const u of s) {
        const p = u.encode(A);
        if (p !== void 0)
          return p;
      }
      throw new Error(`match/encode: cannot find match in ${A}`);
    },
    decode: (A) => {
      for (const u of s) {
        const p = u.decode(A);
        if (p !== void 0)
          return p;
      }
      throw new Error(`match/decode: cannot find match in ${A}`);
    }
  };
}
const reverse = (s) => {
  if (!isBaseCoder(s))
    throw new Error("BaseCoder expected");
  return { encode: s.decode, decode: s.encode };
}, coders = { dict, numberBigint, tsEnum, decimal, match, reverse }, bigint = (s, A = !1, u = !1, p = !0) => {
  if (!isNum(s))
    throw new Error(`bigint/size: wrong value ${s}`);
  if (typeof A != "boolean")
    throw new Error(`bigint/le: expected boolean, got ${typeof A}`);
  if (typeof u != "boolean")
    throw new Error(`bigint/signed: expected boolean, got ${typeof u}`);
  if (typeof p != "boolean")
    throw new Error(`bigint/sized: expected boolean, got ${typeof p}`);
  const t = BigInt(s), l = 2n ** (8n * t - 1n);
  return wrap({
    size: p ? s : void 0,
    encodeStream: (m, b) => {
      u && b < 0 && (b = b | l);
      const k = [];
      for (let B = 0; B < s; B++)
        k.push(Number(b & 255n)), b >>= 8n;
      let C = new Uint8Array(k).reverse();
      if (!p) {
        let B = 0;
        for (B = 0; B < C.length && C[B] === 0; B++)
          ;
        C = C.subarray(B);
      }
      m.bytes(A ? C.reverse() : C);
    },
    decodeStream: (m) => {
      const b = m.bytes(p ? s : Math.min(s, m.leftBytes)), k = A ? b : swapEndianness(b);
      let C = 0n;
      for (let B = 0; B < k.length; B++)
        C |= BigInt(k[B]) << 8n * BigInt(B);
      return u && C & l && (C = (C ^ l) - l), C;
    },
    validate: (m) => {
      if (typeof m != "bigint")
        throw new Error(`bigint: invalid value: ${m}`);
      return checkBounds(m, 8n * t, !!u), m;
    }
  });
}, U256BE = /* @__PURE__ */ bigint(32, !1), U64LE = /* @__PURE__ */ bigint(8, !0), I64LE = /* @__PURE__ */ bigint(8, !0, !0), view = (s, A) => wrap({
  size: s,
  encodeStream: (u, p) => u.writeView(s, (t) => A.write(t, p)),
  decodeStream: (u) => u.readView(s, A.read),
  validate: (u) => {
    if (typeof u != "number")
      throw new Error(`viewCoder: expected number, got ${typeof u}`);
    return A.validate && A.validate(u), u;
  }
}), intView = (s, A, u) => {
  const p = s * 8, t = 2 ** (p - 1), l = (k) => {
    if (!isNum(k))
      throw new Error(`sintView: value is not safe integer: ${k}`);
    if (k < -t || k >= t)
      throw new Error(`sintView: value out of bounds. Expected ${-t} <= ${k} < ${t}`);
  }, m = 2 ** p, b = (k) => {
    if (!isNum(k))
      throw new Error(`uintView: value is not safe integer: ${k}`);
    if (0 > k || k >= m)
      throw new Error(`uintView: value out of bounds. Expected 0 <= ${k} < ${m}`);
  };
  return view(s, {
    write: u.write,
    read: u.read,
    validate: A ? l : b
  });
}, U32LE = /* @__PURE__ */ intView(4, !1, {
  read: (s, A) => s.getUint32(A, !0),
  write: (s, A) => s.setUint32(0, A, !0)
}), U32BE = /* @__PURE__ */ intView(4, !1, {
  read: (s, A) => s.getUint32(A, !1),
  write: (s, A) => s.setUint32(0, A, !1)
}), I32LE = /* @__PURE__ */ intView(4, !0, {
  read: (s, A) => s.getInt32(A, !0),
  write: (s, A) => s.setInt32(0, A, !0)
}), U16LE = /* @__PURE__ */ intView(2, !1, {
  read: (s, A) => s.getUint16(A, !0),
  write: (s, A) => s.setUint16(0, A, !0)
}), U8 = /* @__PURE__ */ intView(1, !1, {
  read: (s, A) => s.getUint8(A),
  write: (s, A) => s.setUint8(0, A)
}), createBytes = (s, A = !1) => {
  if (typeof A != "boolean")
    throw new Error(`bytes/le: expected boolean, got ${typeof A}`);
  const u = lengthCoder(s), p = isBytes$1(s);
  return wrap({
    size: typeof s == "number" ? s : void 0,
    encodeStream: (t, l) => {
      p || u.encodeStream(t, l.length), t.bytes(A ? swapEndianness(l) : l), p && t.bytes(s);
    },
    decodeStream: (t) => {
      let l;
      if (p) {
        const m = t.find(s);
        if (!m)
          throw t.err("bytes: cannot find terminator");
        l = t.bytes(m - t.pos), t.bytes(s.length);
      } else
        l = t.bytes(s === null ? t.leftBytes : u.decodeStream(t));
      return A ? swapEndianness(l) : l;
    },
    validate: (t) => {
      if (!isBytes$1(t))
        throw new Error(`bytes: invalid value ${t}`);
      return t;
    }
  });
};
function prefix(s, A) {
  if (!isCoder(A))
    throw new Error(`prefix: invalid inner value ${A}`);
  return apply(createBytes(s), reverse(A));
}
const string = (s, A = !1) => validate(apply(createBytes(s, A), utf8$1), (u) => {
  if (typeof u != "string")
    throw new Error(`expected string, got ${typeof u}`);
  return u;
}), createHex = (s, A = { isLE: !1, with0x: !1 }) => {
  let u = apply(createBytes(s, A.isLE), hex$1);
  const p = A.with0x;
  if (typeof p != "boolean")
    throw new Error(`hex/with0x: expected boolean, got ${typeof p}`);
  return p && (u = apply(u, {
    encode: (t) => `0x${t}`,
    decode: (t) => {
      if (!t.startsWith("0x"))
        throw new Error("hex(with0x=true).encode input should start with 0x");
      return t.slice(2);
    }
  })), u;
};
function apply(s, A) {
  if (!isCoder(s))
    throw new Error(`apply: invalid inner value ${s}`);
  if (!isBaseCoder(A))
    throw new Error(`apply: invalid base value ${s}`);
  return wrap({
    size: s.size,
    encodeStream: (u, p) => {
      let t;
      try {
        t = A.decode(p);
      } catch (l) {
        throw u.err("" + l);
      }
      return s.encodeStream(u, t);
    },
    decodeStream: (u) => {
      const p = s.decodeStream(u);
      try {
        return A.encode(p);
      } catch (t) {
        throw u.err("" + t);
      }
    }
  });
}
const flag = (s, A = !1) => {
  if (!isBytes$1(s))
    throw new Error(`flag/flagValue: expected Uint8Array, got ${typeof s}`);
  if (typeof A != "boolean")
    throw new Error(`flag/xor: expected boolean, got ${typeof A}`);
  return wrap({
    size: s.length,
    encodeStream: (u, p) => {
      !!p !== A && u.bytes(s);
    },
    decodeStream: (u) => {
      let p = u.leftBytes >= s.length;
      return p && (p = equalBytes$1(u.bytes(s.length, !0), s), p && u.bytes(s.length)), p !== A;
    },
    validate: (u) => {
      if (u !== void 0 && typeof u != "boolean")
        throw new Error(`flag: expected boolean value or undefined, got ${typeof u}`);
      return u;
    }
  });
};
function flagged(s, A, u) {
  if (!isCoder(A))
    throw new Error(`flagged: invalid inner value ${A}`);
  return wrap({
    encodeStream: (p, t) => {
      Path.resolve(p.stack, s) && A.encodeStream(p, t);
    },
    decodeStream: (p) => {
      let t = !1;
      if (t = !!Path.resolve(p.stack, s), t)
        return A.decodeStream(p);
    }
  });
}
function magic(s, A, u = !0) {
  if (!isCoder(s))
    throw new Error(`magic: invalid inner value ${s}`);
  if (typeof u != "boolean")
    throw new Error(`magic: expected boolean, got ${typeof u}`);
  return wrap({
    size: s.size,
    encodeStream: (p, t) => s.encodeStream(p, A),
    decodeStream: (p) => {
      const t = s.decodeStream(p);
      if (u && typeof t != "object" && t !== A || isBytes$1(A) && !equalBytes$1(A, t))
        throw p.err(`magic: invalid value: ${t} !== ${A}`);
    },
    validate: (p) => {
      if (p !== void 0)
        throw new Error(`magic: wrong value=${typeof p}`);
      return p;
    }
  });
}
function sizeof(s) {
  let A = 0;
  for (const u of s) {
    if (u.size === void 0)
      return;
    if (!isNum(u.size))
      throw new Error(`sizeof: wrong element size=${A}`);
    A += u.size;
  }
  return A;
}
function struct(s) {
  if (!isPlainObject(s))
    throw new Error(`struct: expected plain object, got ${s}`);
  for (const A in s)
    if (!isCoder(s[A]))
      throw new Error(`struct: field ${A} is not CoderType`);
  return wrap({
    size: sizeof(Object.values(s)),
    encodeStream: (A, u) => {
      A.pushObj(u, (p) => {
        for (const t in s)
          p(t, () => s[t].encodeStream(A, u[t]));
      });
    },
    decodeStream: (A) => {
      const u = {};
      return A.pushObj(u, (p) => {
        for (const t in s)
          p(t, () => u[t] = s[t].decodeStream(A));
      }), u;
    },
    validate: (A) => {
      if (typeof A != "object" || A === null)
        throw new Error(`struct: invalid value ${A}`);
      return A;
    }
  });
}
function tuple(s) {
  if (!Array.isArray(s))
    throw new Error(`Packed.Tuple: got ${typeof s} instead of array`);
  for (let A = 0; A < s.length; A++)
    if (!isCoder(s[A]))
      throw new Error(`tuple: field ${A} is not CoderType`);
  return wrap({
    size: sizeof(s),
    encodeStream: (A, u) => {
      if (!Array.isArray(u))
        throw A.err(`tuple: invalid value ${u}`);
      A.pushObj(u, (p) => {
        for (let t = 0; t < s.length; t++)
          p(`${t}`, () => s[t].encodeStream(A, u[t]));
      });
    },
    decodeStream: (A) => {
      const u = [];
      return A.pushObj(u, (p) => {
        for (let t = 0; t < s.length; t++)
          p(`${t}`, () => u.push(s[t].decodeStream(A)));
      }), u;
    },
    validate: (A) => {
      if (!Array.isArray(A))
        throw new Error(`tuple: invalid value ${A}`);
      if (A.length !== s.length)
        throw new Error(`tuple: wrong length=${A.length}, expected ${s.length}`);
      return A;
    }
  });
}
function array(s, A) {
  if (!isCoder(A))
    throw new Error(`array: invalid inner value ${A}`);
  const u = lengthCoder(typeof s == "string" ? `../${s}` : s);
  return wrap({
    size: typeof s == "number" && A.size ? s * A.size : void 0,
    encodeStream: (p, t) => {
      const l = p;
      l.pushObj(t, (m) => {
        isBytes$1(s) || u.encodeStream(p, t.length);
        for (let b = 0; b < t.length; b++)
          m(`${b}`, () => {
            const k = t[b], C = p.pos;
            if (A.encodeStream(p, k), isBytes$1(s)) {
              if (s.length > l.pos - C)
                return;
              const B = l.finish(!1).subarray(C, l.pos);
              if (equalBytes$1(B.subarray(0, s.length), s))
                throw l.err(`array: inner element encoding same as separator. elm=${k} data=${B}`);
            }
          });
      }), isBytes$1(s) && p.bytes(s);
    },
    decodeStream: (p) => {
      const t = [];
      return p.pushObj(t, (l) => {
        if (s === null)
          for (let m = 0; !p.isEnd() && (l(`${m}`, () => t.push(A.decodeStream(p))), !(A.size && p.leftBytes < A.size)); m++)
            ;
        else if (isBytes$1(s))
          for (let m = 0; ; m++) {
            if (equalBytes$1(p.bytes(s.length, !0), s)) {
              p.bytes(s.length);
              break;
            }
            l(`${m}`, () => t.push(A.decodeStream(p)));
          }
        else {
          let m;
          l("arrayLen", () => m = u.decodeStream(p));
          for (let b = 0; b < m; b++)
            l(`${b}`, () => t.push(A.decodeStream(p)));
        }
      }), t;
    },
    validate: (p) => {
      if (!Array.isArray(p))
        throw new Error(`array: invalid value ${p}`);
      return p;
    }
  });
}
const Point = secp256k1.ProjectivePoint, CURVE_ORDER = secp256k1.CURVE.n, isBytes = utils$2.isBytes, concatBytes$1 = utils$2.concatBytes, equalBytes = utils$2.equalBytes, hash160 = (s) => ripemd160(sha256$2(s)), sha256x2 = (...s) => sha256$2(sha256$2(concatBytes$1(...s))), pubSchnorr = schnorr.getPublicKey, pubECDSA = secp256k1.getPublicKey, hasLowR = (s) => s.r < CURVE_ORDER / 2n;
function signECDSA(s, A, u = !1) {
  let p = secp256k1.sign(s, A);
  if (u && !hasLowR(p)) {
    const t = new Uint8Array(32);
    let l = 0;
    for (; !hasLowR(p); )
      if (t.set(U32LE.encode(l++)), p = secp256k1.sign(s, A, { extraEntropy: t }), l > 4294967295)
        throw new Error("lowR counter overflow: report the error");
  }
  return p.toDERRawBytes();
}
const signSchnorr = schnorr.sign, tagSchnorr = schnorr.utils.taggedHash;
var PubT;
(function(s) {
  s[s.ecdsa = 0] = "ecdsa", s[s.schnorr = 1] = "schnorr";
})(PubT || (PubT = {}));
function validatePubkey(s, A) {
  const u = s.length;
  if (A === PubT.ecdsa) {
    if (u === 32)
      throw new Error("Expected non-Schnorr key");
    return Point.fromHex(s), s;
  } else if (A === PubT.schnorr) {
    if (u !== 32)
      throw new Error("Expected 32-byte Schnorr key");
    return schnorr.utils.lift_x(schnorr.utils.bytesToNumberBE(s)), s;
  } else
    throw new Error("Unknown key type");
}
function tapTweak(s, A) {
  const u = schnorr.utils, p = u.taggedHash("TapTweak", s, A), t = u.bytesToNumberBE(p);
  if (t >= CURVE_ORDER)
    throw new Error("tweak higher than curve order");
  return t;
}
function taprootTweakPrivKey(s, A = Uint8Array.of()) {
  const u = schnorr.utils, p = u.bytesToNumberBE(s), t = Point.fromPrivateKey(p), l = t.hasEvenY() ? p : u.mod(-p, CURVE_ORDER), m = u.pointToBytes(t), b = tapTweak(m, A);
  return u.numberToBytesBE(u.mod(l + b, CURVE_ORDER), 32);
}
function taprootTweakPubkey(s, A) {
  const u = schnorr.utils, p = tapTweak(s, A), l = u.lift_x(u.bytesToNumberBE(s)).add(Point.fromPrivateKey(p)), m = l.hasEvenY() ? 0 : 1;
  return [u.pointToBytes(l), m];
}
sha256$2(Point.BASE.toRawBytes(!1));
const NETWORK = {
  bech32: "bc",
  pubKeyHash: 0,
  scriptHash: 5,
  wif: 128
};
function compareBytes(s, A) {
  if (!isBytes(s) || !isBytes(A))
    throw new Error(`cmp: wrong type a=${typeof s} b=${typeof A}`);
  const u = Math.min(s.length, A.length);
  for (let p = 0; p < u; p++)
    if (s[p] != A[p])
      return Math.sign(s[p] - A[p]);
  return Math.sign(s.length - A.length);
}
var OP;
(function(s) {
  s[s.OP_0 = 0] = "OP_0", s[s.PUSHDATA1 = 76] = "PUSHDATA1", s[s.PUSHDATA2 = 77] = "PUSHDATA2", s[s.PUSHDATA4 = 78] = "PUSHDATA4", s[s["1NEGATE"] = 79] = "1NEGATE", s[s.RESERVED = 80] = "RESERVED", s[s.OP_1 = 81] = "OP_1", s[s.OP_2 = 82] = "OP_2", s[s.OP_3 = 83] = "OP_3", s[s.OP_4 = 84] = "OP_4", s[s.OP_5 = 85] = "OP_5", s[s.OP_6 = 86] = "OP_6", s[s.OP_7 = 87] = "OP_7", s[s.OP_8 = 88] = "OP_8", s[s.OP_9 = 89] = "OP_9", s[s.OP_10 = 90] = "OP_10", s[s.OP_11 = 91] = "OP_11", s[s.OP_12 = 92] = "OP_12", s[s.OP_13 = 93] = "OP_13", s[s.OP_14 = 94] = "OP_14", s[s.OP_15 = 95] = "OP_15", s[s.OP_16 = 96] = "OP_16", s[s.NOP = 97] = "NOP", s[s.VER = 98] = "VER", s[s.IF = 99] = "IF", s[s.NOTIF = 100] = "NOTIF", s[s.VERIF = 101] = "VERIF", s[s.VERNOTIF = 102] = "VERNOTIF", s[s.ELSE = 103] = "ELSE", s[s.ENDIF = 104] = "ENDIF", s[s.VERIFY = 105] = "VERIFY", s[s.RETURN = 106] = "RETURN", s[s.TOALTSTACK = 107] = "TOALTSTACK", s[s.FROMALTSTACK = 108] = "FROMALTSTACK", s[s["2DROP"] = 109] = "2DROP", s[s["2DUP"] = 110] = "2DUP", s[s["3DUP"] = 111] = "3DUP", s[s["2OVER"] = 112] = "2OVER", s[s["2ROT"] = 113] = "2ROT", s[s["2SWAP"] = 114] = "2SWAP", s[s.IFDUP = 115] = "IFDUP", s[s.DEPTH = 116] = "DEPTH", s[s.DROP = 117] = "DROP", s[s.DUP = 118] = "DUP", s[s.NIP = 119] = "NIP", s[s.OVER = 120] = "OVER", s[s.PICK = 121] = "PICK", s[s.ROLL = 122] = "ROLL", s[s.ROT = 123] = "ROT", s[s.SWAP = 124] = "SWAP", s[s.TUCK = 125] = "TUCK", s[s.CAT = 126] = "CAT", s[s.SUBSTR = 127] = "SUBSTR", s[s.LEFT = 128] = "LEFT", s[s.RIGHT = 129] = "RIGHT", s[s.SIZE = 130] = "SIZE", s[s.INVERT = 131] = "INVERT", s[s.AND = 132] = "AND", s[s.OR = 133] = "OR", s[s.XOR = 134] = "XOR", s[s.EQUAL = 135] = "EQUAL", s[s.EQUALVERIFY = 136] = "EQUALVERIFY", s[s.RESERVED1 = 137] = "RESERVED1", s[s.RESERVED2 = 138] = "RESERVED2", s[s["1ADD"] = 139] = "1ADD", s[s["1SUB"] = 140] = "1SUB", s[s["2MUL"] = 141] = "2MUL", s[s["2DIV"] = 142] = "2DIV", s[s.NEGATE = 143] = "NEGATE", s[s.ABS = 144] = "ABS", s[s.NOT = 145] = "NOT", s[s["0NOTEQUAL"] = 146] = "0NOTEQUAL", s[s.ADD = 147] = "ADD", s[s.SUB = 148] = "SUB", s[s.MUL = 149] = "MUL", s[s.DIV = 150] = "DIV", s[s.MOD = 151] = "MOD", s[s.LSHIFT = 152] = "LSHIFT", s[s.RSHIFT = 153] = "RSHIFT", s[s.BOOLAND = 154] = "BOOLAND", s[s.BOOLOR = 155] = "BOOLOR", s[s.NUMEQUAL = 156] = "NUMEQUAL", s[s.NUMEQUALVERIFY = 157] = "NUMEQUALVERIFY", s[s.NUMNOTEQUAL = 158] = "NUMNOTEQUAL", s[s.LESSTHAN = 159] = "LESSTHAN", s[s.GREATERTHAN = 160] = "GREATERTHAN", s[s.LESSTHANOREQUAL = 161] = "LESSTHANOREQUAL", s[s.GREATERTHANOREQUAL = 162] = "GREATERTHANOREQUAL", s[s.MIN = 163] = "MIN", s[s.MAX = 164] = "MAX", s[s.WITHIN = 165] = "WITHIN", s[s.RIPEMD160 = 166] = "RIPEMD160", s[s.SHA1 = 167] = "SHA1", s[s.SHA256 = 168] = "SHA256", s[s.HASH160 = 169] = "HASH160", s[s.HASH256 = 170] = "HASH256", s[s.CODESEPARATOR = 171] = "CODESEPARATOR", s[s.CHECKSIG = 172] = "CHECKSIG", s[s.CHECKSIGVERIFY = 173] = "CHECKSIGVERIFY", s[s.CHECKMULTISIG = 174] = "CHECKMULTISIG", s[s.CHECKMULTISIGVERIFY = 175] = "CHECKMULTISIGVERIFY", s[s.NOP1 = 176] = "NOP1", s[s.CHECKLOCKTIMEVERIFY = 177] = "CHECKLOCKTIMEVERIFY", s[s.CHECKSEQUENCEVERIFY = 178] = "CHECKSEQUENCEVERIFY", s[s.NOP4 = 179] = "NOP4", s[s.NOP5 = 180] = "NOP5", s[s.NOP6 = 181] = "NOP6", s[s.NOP7 = 182] = "NOP7", s[s.NOP8 = 183] = "NOP8", s[s.NOP9 = 184] = "NOP9", s[s.NOP10 = 185] = "NOP10", s[s.CHECKSIGADD = 186] = "CHECKSIGADD", s[s.INVALID = 255] = "INVALID";
})(OP || (OP = {}));
function ScriptNum(s = 6, A = !1) {
  return wrap({
    encodeStream: (u, p) => {
      if (p === 0n)
        return;
      const t = p < 0, l = BigInt(p), m = [];
      for (let b = t ? -l : l; b; b >>= 8n)
        m.push(Number(b & 0xffn));
      m[m.length - 1] >= 128 ? m.push(t ? 128 : 0) : t && (m[m.length - 1] |= 128), u.bytes(new Uint8Array(m));
    },
    decodeStream: (u) => {
      const p = u.leftBytes;
      if (p > s)
        throw new Error(`ScriptNum: number (${p}) bigger than limit=${s}`);
      if (p === 0)
        return 0n;
      if (A) {
        const m = u.bytes(p, !0);
        if ((m[m.length - 1] & 127) === 0 && (p <= 1 || (m[m.length - 2] & 128) === 0))
          throw new Error("Non-minimally encoded ScriptNum");
      }
      let t = 0, l = 0n;
      for (let m = 0; m < p; ++m)
        t = u.byte(), l |= BigInt(t) << 8n * BigInt(m);
      return t >= 128 && (l &= 2n ** BigInt(p * 8) - 1n >> 1n, l = -l), l;
    }
  });
}
function OpToNum(s, A = 4, u = !0) {
  if (typeof s == "number")
    return s;
  if (isBytes(s))
    try {
      const p = ScriptNum(A, u).decode(s);
      return p > Number.MAX_SAFE_INTEGER ? void 0 : Number(p);
    } catch {
      return;
    }
}
const Script = wrap({
  encodeStream: (s, A) => {
    for (let u of A) {
      if (typeof u == "string") {
        if (OP[u] === void 0)
          throw new Error(`Unknown opcode=${u}`);
        s.byte(OP[u]);
        continue;
      } else if (typeof u == "number") {
        if (u === 0) {
          s.byte(0);
          continue;
        } else if (1 <= u && u <= 16) {
          s.byte(OP.OP_1 - 1 + u);
          continue;
        }
      }
      if (typeof u == "number" && (u = ScriptNum().encode(BigInt(u))), !isBytes(u))
        throw new Error(`Wrong Script OP=${u} (${typeof u})`);
      const p = u.length;
      p < OP.PUSHDATA1 ? s.byte(p) : p <= 255 ? (s.byte(OP.PUSHDATA1), s.byte(p)) : p <= 65535 ? (s.byte(OP.PUSHDATA2), s.bytes(U16LE.encode(p))) : (s.byte(OP.PUSHDATA4), s.bytes(U32LE.encode(p))), s.bytes(u);
    }
  },
  decodeStream: (s) => {
    const A = [];
    for (; !s.isEnd(); ) {
      const u = s.byte();
      if (OP.OP_0 < u && u <= OP.PUSHDATA4) {
        let p;
        if (u < OP.PUSHDATA1)
          p = u;
        else if (u === OP.PUSHDATA1)
          p = U8.decodeStream(s);
        else if (u === OP.PUSHDATA2)
          p = U16LE.decodeStream(s);
        else if (u === OP.PUSHDATA4)
          p = U32LE.decodeStream(s);
        else
          throw new Error("Should be not possible");
        A.push(s.bytes(p));
      } else if (u === 0)
        A.push(0);
      else if (OP.OP_1 <= u && u <= OP.OP_16)
        A.push(u - (OP.OP_1 - 1));
      else {
        const p = OP[u];
        if (p === void 0)
          throw new Error(`Unknown opcode=${u.toString(16)}`);
        A.push(p);
      }
    }
    return A;
  }
}), CSLimits = {
  253: [253, 2, 253n, 65535n],
  254: [254, 4, 65536n, 4294967295n],
  255: [255, 8, 4294967296n, 18446744073709551615n]
}, CompactSize = wrap({
  encodeStream: (s, A) => {
    if (typeof A == "number" && (A = BigInt(A)), 0n <= A && A <= 252n)
      return s.byte(Number(A));
    for (const [u, p, t, l] of Object.values(CSLimits))
      if (!(t > A || A > l)) {
        s.byte(u);
        for (let m = 0; m < p; m++)
          s.byte(Number(A >> 8n * BigInt(m) & 0xffn));
        return;
      }
    throw s.err(`VarInt too big: ${A}`);
  },
  decodeStream: (s) => {
    const A = s.byte();
    if (A <= 252)
      return BigInt(A);
    const [u, p, t] = CSLimits[A];
    let l = 0n;
    for (let m = 0; m < p; m++)
      l |= BigInt(s.byte()) << 8n * BigInt(m);
    if (l < t)
      throw s.err(`Wrong CompactSize(${8 * p})`);
    return l;
  }
}), CompactSizeLen = apply(CompactSize, coders.numberBigint), VarBytes = createBytes(CompactSize), RawWitness = array(CompactSizeLen, VarBytes), BTCArray = (s) => array(CompactSize, s), RawInput = struct({
  txid: createBytes(32, !0),
  // hash(prev_tx),
  index: U32LE,
  // output number of previous tx
  finalScriptSig: VarBytes,
  // btc merges input and output script, executes it. If ok = tx passes
  sequence: U32LE
  // ?
}), RawOutput = struct({ amount: U64LE, script: VarBytes }), _RawTx = struct({
  version: I32LE,
  segwitFlag: flag(new Uint8Array([0, 1])),
  inputs: BTCArray(RawInput),
  outputs: BTCArray(RawOutput),
  witnesses: flagged("segwitFlag", array("inputs/length", RawWitness)),
  // < 500000000	Block number at which this transaction is unlocked
  // >= 500000000	UNIX timestamp at which this transaction is unlocked
  // Handled as part of PSBTv2
  lockTime: U32LE
});
function validateRawTx(s) {
  if (s.segwitFlag && s.witnesses && !s.witnesses.length)
    throw new Error("Segwit flag with empty witnesses array");
  return s;
}
const RawTx = validate(_RawTx, validateRawTx), RawOldTx = struct({
  version: I32LE,
  inputs: BTCArray(RawInput),
  outputs: BTCArray(RawOutput),
  lockTime: U32LE
}), PubKeyECDSA = validate(createBytes(null), (s) => validatePubkey(s, PubT.ecdsa)), PubKeySchnorr = validate(createBytes(32), (s) => validatePubkey(s, PubT.schnorr)), SignatureSchnorr = validate(createBytes(null), (s) => {
  if (s.length !== 64 && s.length !== 65)
    throw new Error("Schnorr signature should be 64 or 65 bytes long");
  return s;
}), BIP32Der = struct({
  fingerprint: U32BE,
  path: array(null, U32LE)
}), TaprootBIP32Der = struct({
  hashes: array(CompactSizeLen, createBytes(32)),
  der: BIP32Der
}), GlobalXPUB = createBytes(78), tapScriptSigKey = struct({ pubKey: PubKeySchnorr, leafHash: createBytes(32) }), _TaprootControlBlock = struct({
  version: U8,
  // With parity :(
  internalKey: createBytes(32),
  merklePath: array(null, createBytes(32))
}), TaprootControlBlock = validate(_TaprootControlBlock, (s) => {
  if (s.merklePath.length > 128)
    throw new Error("TaprootControlBlock: merklePath should be of length 0..128 (inclusive)");
  return s;
}), tapTree = array(null, struct({
  depth: U8,
  version: U8,
  script: VarBytes
})), BytesInf = createBytes(null), Bytes20 = createBytes(20), Bytes32 = createBytes(32), PSBTGlobal = {
  unsignedTx: [0, !1, RawOldTx, [0], [0], !1],
  xpub: [1, GlobalXPUB, BIP32Der, [], [0, 2], !1],
  txVersion: [2, !1, U32LE, [2], [2], !1],
  fallbackLocktime: [3, !1, U32LE, [], [2], !1],
  inputCount: [4, !1, CompactSizeLen, [2], [2], !1],
  outputCount: [5, !1, CompactSizeLen, [2], [2], !1],
  txModifiable: [6, !1, U8, [], [2], !1],
  // TODO: bitfield
  version: [251, !1, U32LE, [], [0, 2], !1],
  proprietary: [252, BytesInf, BytesInf, [], [0, 2], !1]
}, PSBTInput = {
  nonWitnessUtxo: [0, !1, RawTx, [], [0, 2], !1],
  witnessUtxo: [1, !1, RawOutput, [], [0, 2], !1],
  partialSig: [2, PubKeyECDSA, BytesInf, [], [0, 2], !1],
  sighashType: [3, !1, U32LE, [], [0, 2], !1],
  redeemScript: [4, !1, BytesInf, [], [0, 2], !1],
  witnessScript: [5, !1, BytesInf, [], [0, 2], !1],
  bip32Derivation: [6, PubKeyECDSA, BIP32Der, [], [0, 2], !1],
  finalScriptSig: [7, !1, BytesInf, [], [0, 2], !1],
  finalScriptWitness: [8, !1, RawWitness, [], [0, 2], !1],
  porCommitment: [9, !1, BytesInf, [], [0, 2], !1],
  ripemd160: [10, Bytes20, BytesInf, [], [0, 2], !1],
  sha256: [11, Bytes32, BytesInf, [], [0, 2], !1],
  hash160: [12, Bytes20, BytesInf, [], [0, 2], !1],
  hash256: [13, Bytes32, BytesInf, [], [0, 2], !1],
  txid: [14, !1, Bytes32, [2], [2], !0],
  index: [15, !1, U32LE, [2], [2], !0],
  sequence: [16, !1, U32LE, [], [2], !0],
  requiredTimeLocktime: [17, !1, U32LE, [], [2], !1],
  requiredHeightLocktime: [18, !1, U32LE, [], [2], !1],
  tapKeySig: [19, !1, SignatureSchnorr, [], [0, 2], !1],
  tapScriptSig: [20, tapScriptSigKey, SignatureSchnorr, [], [0, 2], !1],
  tapLeafScript: [21, TaprootControlBlock, BytesInf, [], [0, 2], !1],
  tapBip32Derivation: [22, Bytes32, TaprootBIP32Der, [], [0, 2], !1],
  tapInternalKey: [23, !1, PubKeySchnorr, [], [0, 2], !1],
  tapMerkleRoot: [24, !1, Bytes32, [], [0, 2], !1],
  proprietary: [252, BytesInf, BytesInf, [], [0, 2], !1]
}, PSBTInputFinalKeys = [
  "txid",
  "sequence",
  "index",
  "witnessUtxo",
  "nonWitnessUtxo",
  "finalScriptSig",
  "finalScriptWitness",
  "unknown"
], PSBTInputUnsignedKeys = [
  "partialSig",
  "finalScriptSig",
  "finalScriptWitness",
  "tapKeySig",
  "tapScriptSig"
], PSBTOutput = {
  redeemScript: [0, !1, BytesInf, [], [0, 2], !1],
  witnessScript: [1, !1, BytesInf, [], [0, 2], !1],
  bip32Derivation: [2, PubKeyECDSA, BIP32Der, [], [0, 2], !1],
  amount: [3, !1, I64LE, [2], [2], !0],
  script: [4, !1, BytesInf, [2], [2], !0],
  tapInternalKey: [5, !1, PubKeySchnorr, [], [0, 2], !1],
  tapTree: [6, !1, tapTree, [], [0, 2], !1],
  tapBip32Derivation: [7, PubKeySchnorr, TaprootBIP32Der, [], [0, 2], !1],
  proprietary: [252, BytesInf, BytesInf, [], [0, 2], !1]
}, PSBTOutputUnsignedKeys = [], PSBTKeyPair = array(NULL, struct({
  //  <key> := <keylen> <keytype> <keydata> WHERE keylen = len(keytype)+len(keydata)
  key: prefix(CompactSizeLen, struct({ type: CompactSizeLen, key: createBytes(null) })),
  //  <value> := <valuelen> <valuedata>
  value: createBytes(CompactSizeLen)
}));
function PSBTKeyInfo(s) {
  const [A, u, p, t, l, m] = s;
  return { type: A, kc: u, vc: p, reqInc: t, allowInc: l, silentIgnore: m };
}
struct({ type: CompactSizeLen, key: createBytes(null) });
function PSBTKeyMap(s) {
  const A = {};
  for (const u in s) {
    const [p, t, l] = s[u];
    A[p] = [u, t, l];
  }
  return wrap({
    encodeStream: (u, p) => {
      let t = [];
      for (const l in s) {
        const m = p[l];
        if (m === void 0)
          continue;
        const [b, k, C] = s[l];
        if (!k)
          t.push({ key: { type: b, key: EMPTY }, value: C.encode(m) });
        else {
          const B = m.map(([Q, P]) => [
            k.encode(Q),
            C.encode(P)
          ]);
          B.sort((Q, P) => compareBytes(Q[0], P[0]));
          for (const [Q, P] of B)
            t.push({ key: { key: Q, type: b }, value: P });
        }
      }
      if (p.unknown) {
        p.unknown.sort((l, m) => compareBytes(l[0].key, m[0].key));
        for (const [l, m] of p.unknown)
          t.push({ key: l, value: m });
      }
      PSBTKeyPair.encodeStream(u, t);
    },
    decodeStream: (u) => {
      const p = PSBTKeyPair.decodeStream(u), t = {}, l = {};
      for (const m of p) {
        let b = "unknown", k = m.key.key, C = m.value;
        if (A[m.key.type]) {
          const [B, Q, P] = A[m.key.type];
          if (b = B, !Q && k.length)
            throw new Error(`PSBT: Non-empty key for ${b} (key=${hex$1.encode(k)} value=${hex$1.encode(C)}`);
          if (k = Q ? Q.decode(k) : void 0, C = P.decode(C), !Q) {
            if (t[b])
              throw new Error(`PSBT: Same keys: ${b} (key=${k} value=${C})`);
            t[b] = C, l[b] = !0;
            continue;
          }
        } else
          k = { type: m.key.type, key: m.key.key };
        if (l[b])
          throw new Error(`PSBT: Key type with empty key and no key=${b} val=${C}`);
        t[b] || (t[b] = []), t[b].push([k, C]);
      }
      return t;
    }
  });
}
const PSBTInputCoder = validate(PSBTKeyMap(PSBTInput), (s) => {
  if (s.finalScriptWitness && !s.finalScriptWitness.length)
    throw new Error("validateInput: empty finalScriptWitness");
  if (s.partialSig && !s.partialSig.length)
    throw new Error("Empty partialSig");
  if (s.partialSig)
    for (const [A] of s.partialSig)
      validatePubkey(A, PubT.ecdsa);
  if (s.bip32Derivation)
    for (const [A] of s.bip32Derivation)
      validatePubkey(A, PubT.ecdsa);
  if (s.requiredTimeLocktime !== void 0 && s.requiredTimeLocktime < 5e8)
    throw new Error(`validateInput: wrong timeLocktime=${s.requiredTimeLocktime}`);
  if (s.requiredHeightLocktime !== void 0 && (s.requiredHeightLocktime <= 0 || s.requiredHeightLocktime >= 5e8))
    throw new Error(`validateInput: wrong heighLocktime=${s.requiredHeightLocktime}`);
  if (s.tapLeafScript)
    for (const [A, u] of s.tapLeafScript) {
      if ((A.version & 254) !== u[u.length - 1])
        throw new Error("validateInput: tapLeafScript version mimatch");
      if (u[u.length - 1] & 1)
        throw new Error("validateInput: tapLeafScript version has parity bit!");
    }
  return s;
}), PSBTOutputCoder = validate(PSBTKeyMap(PSBTOutput), (s) => {
  if (s.bip32Derivation)
    for (const [A] of s.bip32Derivation)
      validatePubkey(A, PubT.ecdsa);
  return s;
}), PSBTGlobalCoder = validate(PSBTKeyMap(PSBTGlobal), (s) => {
  if ((s.version || 0) === 0) {
    if (!s.unsignedTx)
      throw new Error("PSBTv0: missing unsignedTx");
    for (const u of s.unsignedTx.inputs)
      if (u.finalScriptSig && u.finalScriptSig.length)
        throw new Error("PSBTv0: input scriptSig found in unsignedTx");
  }
  return s;
}), _RawPSBTV0 = struct({
  magic: magic(string(new Uint8Array([255])), "psbt"),
  global: PSBTGlobalCoder,
  inputs: array("global/unsignedTx/inputs/length", PSBTInputCoder),
  outputs: array(null, PSBTOutputCoder)
}), _RawPSBTV2 = struct({
  magic: magic(string(new Uint8Array([255])), "psbt"),
  global: PSBTGlobalCoder,
  inputs: array("global/inputCount", PSBTInputCoder),
  outputs: array("global/outputCount", PSBTOutputCoder)
});
struct({
  magic: magic(string(new Uint8Array([255])), "psbt"),
  items: array(null, apply(array(NULL, tuple([createHex(CompactSizeLen), createBytes(CompactSize)])), coders.dict()))
});
function validatePSBTFields(s, A, u) {
  for (const p in u) {
    if (p === "unknown" || !A[p])
      continue;
    const { allowInc: t } = PSBTKeyInfo(A[p]);
    if (!t.includes(s))
      throw new Error(`PSBTv${s}: field ${p} is not allowed`);
  }
  for (const p in A) {
    const { reqInc: t } = PSBTKeyInfo(A[p]);
    if (t.includes(s) && u[p] === void 0)
      throw new Error(`PSBTv${s}: missing required field ${p}`);
  }
}
function cleanPSBTFields(s, A, u) {
  const p = {};
  for (const t in u) {
    const l = t;
    if (l !== "unknown") {
      if (!A[l])
        continue;
      const { allowInc: m, silentIgnore: b } = PSBTKeyInfo(A[l]);
      if (!m.includes(s)) {
        if (b)
          continue;
        throw new Error(`Failed to serialize in PSBTv${s}: ${l} but versions allows inclusion=${m}`);
      }
    }
    p[l] = u[l];
  }
  return p;
}
function validatePSBT(s) {
  const A = s && s.global && s.global.version || 0;
  validatePSBTFields(A, PSBTGlobal, s.global);
  for (const m of s.inputs)
    validatePSBTFields(A, PSBTInput, m);
  for (const m of s.outputs)
    validatePSBTFields(A, PSBTOutput, m);
  const u = A ? s.global.inputCount : s.global.unsignedTx.inputs.length;
  if (s.inputs.length < u)
    throw new Error("Not enough inputs");
  const p = s.inputs.slice(u);
  if (p.length > 1 || p.length && Object.keys(p[0]).length)
    throw new Error(`Unexpected inputs left in tx=${p}`);
  const t = A ? s.global.outputCount : s.global.unsignedTx.outputs.length;
  if (s.outputs.length < t)
    throw new Error("Not outputs inputs");
  const l = s.outputs.slice(t);
  if (l.length > 1 || l.length && Object.keys(l[0]).length)
    throw new Error(`Unexpected outputs left in tx=${l}`);
  return s;
}
function mergeKeyMap(s, A, u, p, t) {
  const l = { ...u, ...A };
  for (const m in s) {
    const b = m, [k, C, B] = s[b], Q = p && !p.includes(m);
    if (A[m] === void 0 && m in A) {
      if (Q)
        throw new Error(`Cannot remove signed field=${m}`);
      delete l[m];
    } else if (C) {
      const P = u && u[m] ? u[m] : [];
      let x = A[b];
      if (x) {
        if (!Array.isArray(x))
          throw new Error(`keyMap(${m}): KV pairs should be [k, v][]`);
        x = x.map((le) => {
          if (le.length !== 2)
            throw new Error(`keyMap(${m}): KV pairs should be [k, v][]`);
          return [
            typeof le[0] == "string" ? C.decode(hex$1.decode(le[0])) : le[0],
            typeof le[1] == "string" ? B.decode(hex$1.decode(le[1])) : le[1]
          ];
        });
        const M = {}, F = (le, ge, pe) => {
          if (M[le] === void 0) {
            M[le] = [ge, pe];
            return;
          }
          const Ie = hex$1.encode(B.encode(M[le][1])), be = hex$1.encode(B.encode(pe));
          if (Ie !== be)
            throw new Error(`keyMap(${b}): same key=${le} oldVal=${Ie} newVal=${be}`);
        };
        for (const [le, ge] of P) {
          const pe = hex$1.encode(C.encode(le));
          F(pe, le, ge);
        }
        for (const [le, ge] of x) {
          const pe = hex$1.encode(C.encode(le));
          if (ge === void 0) {
            if (Q)
              throw new Error(`Cannot remove signed field=${b}/${le}`);
            delete M[pe];
          } else
            F(pe, le, ge);
        }
        l[b] = Object.values(M);
      }
    } else if (typeof l[m] == "string")
      l[m] = B.decode(hex$1.decode(l[m]));
    else if (Q && m in A && u && u[m] !== void 0 && !equalBytes(B.encode(A[m]), B.encode(u[m])))
      throw new Error(`Cannot change signed field=${m}`);
  }
  for (const m in l)
    if (!s[m]) {
      if (t && m === "unknown")
        continue;
      delete l[m];
    }
  return l;
}
const RawPSBTV0 = validate(_RawPSBTV0, validatePSBT), RawPSBTV2 = validate(_RawPSBTV2, validatePSBT), OutP2A = {
  encode(s) {
    if (!(s.length !== 2 || s[0] !== 1 || !isBytes(s[1]) || hex$1.encode(s[1]) !== "4e73"))
      return { type: "p2a", script: Script.encode(s) };
  },
  decode: (s) => {
    if (s.type === "p2a")
      return [1, hex$1.decode("4e73")];
  }
};
function isValidPubkey(s, A) {
  try {
    return validatePubkey(s, A), !0;
  } catch {
    return !1;
  }
}
const OutPK = {
  encode(s) {
    if (!(s.length !== 2 || !isBytes(s[0]) || !isValidPubkey(s[0], PubT.ecdsa) || s[1] !== "CHECKSIG"))
      return { type: "pk", pubkey: s[0] };
  },
  decode: (s) => s.type === "pk" ? [s.pubkey, "CHECKSIG"] : void 0
}, OutPKH = {
  encode(s) {
    if (!(s.length !== 5 || s[0] !== "DUP" || s[1] !== "HASH160" || !isBytes(s[2])) && !(s[3] !== "EQUALVERIFY" || s[4] !== "CHECKSIG"))
      return { type: "pkh", hash: s[2] };
  },
  decode: (s) => s.type === "pkh" ? ["DUP", "HASH160", s.hash, "EQUALVERIFY", "CHECKSIG"] : void 0
}, OutSH = {
  encode(s) {
    if (!(s.length !== 3 || s[0] !== "HASH160" || !isBytes(s[1]) || s[2] !== "EQUAL"))
      return { type: "sh", hash: s[1] };
  },
  decode: (s) => s.type === "sh" ? ["HASH160", s.hash, "EQUAL"] : void 0
}, OutWSH = {
  encode(s) {
    if (!(s.length !== 2 || s[0] !== 0 || !isBytes(s[1])) && s[1].length === 32)
      return { type: "wsh", hash: s[1] };
  },
  decode: (s) => s.type === "wsh" ? [0, s.hash] : void 0
}, OutWPKH = {
  encode(s) {
    if (!(s.length !== 2 || s[0] !== 0 || !isBytes(s[1])) && s[1].length === 20)
      return { type: "wpkh", hash: s[1] };
  },
  decode: (s) => s.type === "wpkh" ? [0, s.hash] : void 0
}, OutMS = {
  encode(s) {
    const A = s.length - 1;
    if (s[A] !== "CHECKMULTISIG")
      return;
    const u = s[0], p = s[A - 1];
    if (typeof u != "number" || typeof p != "number")
      return;
    const t = s.slice(1, -2);
    if (p === t.length) {
      for (const l of t)
        if (!isBytes(l))
          return;
      return { type: "ms", m: u, pubkeys: t };
    }
  },
  // checkmultisig(n, ..pubkeys, m)
  decode: (s) => s.type === "ms" ? [s.m, ...s.pubkeys, s.pubkeys.length, "CHECKMULTISIG"] : void 0
}, OutTR = {
  encode(s) {
    if (!(s.length !== 2 || s[0] !== 1 || !isBytes(s[1])))
      return { type: "tr", pubkey: s[1] };
  },
  decode: (s) => s.type === "tr" ? [1, s.pubkey] : void 0
}, OutTRNS = {
  encode(s) {
    const A = s.length - 1;
    if (s[A] !== "CHECKSIG")
      return;
    const u = [];
    for (let p = 0; p < A; p++) {
      const t = s[p];
      if (p & 1) {
        if (t !== "CHECKSIGVERIFY" || p === A - 1)
          return;
        continue;
      }
      if (!isBytes(t))
        return;
      u.push(t);
    }
    return { type: "tr_ns", pubkeys: u };
  },
  decode: (s) => {
    if (s.type !== "tr_ns")
      return;
    const A = [];
    for (let u = 0; u < s.pubkeys.length - 1; u++)
      A.push(s.pubkeys[u], "CHECKSIGVERIFY");
    return A.push(s.pubkeys[s.pubkeys.length - 1], "CHECKSIG"), A;
  }
}, OutTRMS = {
  encode(s) {
    const A = s.length - 1;
    if (s[A] !== "NUMEQUAL" || s[1] !== "CHECKSIG")
      return;
    const u = [], p = OpToNum(s[A - 1]);
    if (typeof p == "number") {
      for (let t = 0; t < A - 1; t++) {
        const l = s[t];
        if (t & 1) {
          if (l !== (t === 1 ? "CHECKSIG" : "CHECKSIGADD"))
            throw new Error("OutScript.encode/tr_ms: wrong element");
          continue;
        }
        if (!isBytes(l))
          throw new Error("OutScript.encode/tr_ms: wrong key element");
        u.push(l);
      }
      return { type: "tr_ms", pubkeys: u, m: p };
    }
  },
  decode: (s) => {
    if (s.type !== "tr_ms")
      return;
    const A = [s.pubkeys[0], "CHECKSIG"];
    for (let u = 1; u < s.pubkeys.length; u++)
      A.push(s.pubkeys[u], "CHECKSIGADD");
    return A.push(s.m, "NUMEQUAL"), A;
  }
}, OutUnknown = {
  encode(s) {
    return { type: "unknown", script: Script.encode(s) };
  },
  decode: (s) => s.type === "unknown" ? Script.decode(s.script) : void 0
}, OutScripts = [
  OutP2A,
  OutPK,
  OutPKH,
  OutSH,
  OutWSH,
  OutWPKH,
  OutMS,
  OutTR,
  OutTRNS,
  OutTRMS,
  OutUnknown
], _OutScript = apply(Script, coders.match(OutScripts)), OutScript = validate(_OutScript, (s) => {
  if (s.type === "pk" && !isValidPubkey(s.pubkey, PubT.ecdsa))
    throw new Error("OutScript/pk: wrong key");
  if ((s.type === "pkh" || s.type === "sh" || s.type === "wpkh") && (!isBytes(s.hash) || s.hash.length !== 20))
    throw new Error(`OutScript/${s.type}: wrong hash`);
  if (s.type === "wsh" && (!isBytes(s.hash) || s.hash.length !== 32))
    throw new Error("OutScript/wsh: wrong hash");
  if (s.type === "tr" && (!isBytes(s.pubkey) || !isValidPubkey(s.pubkey, PubT.schnorr)))
    throw new Error("OutScript/tr: wrong taproot public key");
  if ((s.type === "ms" || s.type === "tr_ns" || s.type === "tr_ms") && !Array.isArray(s.pubkeys))
    throw new Error("OutScript/multisig: wrong pubkeys array");
  if (s.type === "ms") {
    const A = s.pubkeys.length;
    for (const u of s.pubkeys)
      if (!isValidPubkey(u, PubT.ecdsa))
        throw new Error("OutScript/multisig: wrong pubkey");
    if (s.m <= 0 || A > 16 || s.m > A)
      throw new Error("OutScript/multisig: invalid params");
  }
  if (s.type === "tr_ns" || s.type === "tr_ms") {
    for (const A of s.pubkeys)
      if (!isValidPubkey(A, PubT.schnorr))
        throw new Error(`OutScript/${s.type}: wrong pubkey`);
  }
  if (s.type === "tr_ms") {
    const A = s.pubkeys.length;
    if (s.m <= 0 || A > 999 || s.m > A)
      throw new Error("OutScript/tr_ms: invalid params");
  }
  return s;
});
function checkWSH(s, A) {
  if (!equalBytes(s.hash, sha256$2(A)))
    throw new Error("checkScript: wsh wrong witnessScript hash");
  const u = OutScript.decode(A);
  if (u.type === "tr" || u.type === "tr_ns" || u.type === "tr_ms")
    throw new Error(`checkScript: P2${u.type} cannot be wrapped in P2SH`);
  if (u.type === "wpkh" || u.type === "sh")
    throw new Error(`checkScript: P2${u.type} cannot be wrapped in P2WSH`);
}
function checkScript(s, A, u) {
  if (s) {
    const p = OutScript.decode(s);
    if (p.type === "tr_ns" || p.type === "tr_ms" || p.type === "ms" || p.type == "pk")
      throw new Error(`checkScript: non-wrapped ${p.type}`);
    if (p.type === "sh" && A) {
      if (!equalBytes(p.hash, hash160(A)))
        throw new Error("checkScript: sh wrong redeemScript hash");
      const t = OutScript.decode(A);
      if (t.type === "tr" || t.type === "tr_ns" || t.type === "tr_ms")
        throw new Error(`checkScript: P2${t.type} cannot be wrapped in P2SH`);
      if (t.type === "sh")
        throw new Error("checkScript: P2SH cannot be wrapped in P2SH");
    }
    p.type === "wsh" && u && checkWSH(p, u);
  }
  if (A) {
    const p = OutScript.decode(A);
    p.type === "wsh" && u && checkWSH(p, u);
  }
}
const TAP_LEAF_VERSION = 192, tapLeafHash = (s, A = TAP_LEAF_VERSION) => tagSchnorr("TapLeaf", new Uint8Array([A]), VarBytes.encode(s)), base58check = createBase58check(sha256$2);
function validateWitness(s, A) {
  if (A.length < 2 || A.length > 40)
    throw new Error("Witness: invalid length");
  if (s > 16)
    throw new Error("Witness: invalid version");
  if (s === 0 && !(A.length === 20 || A.length === 32))
    throw new Error("Witness: invalid length for version");
}
function programToWitness(s, A, u = NETWORK) {
  validateWitness(s, A);
  const p = s === 0 ? bech32$1 : bech32m;
  return p.encode(u.bech32, [s].concat(p.toWords(A)));
}
function formatKey(s, A) {
  return base58check.encode(concatBytes$1(Uint8Array.from(A), s));
}
function Address(s = NETWORK) {
  return {
    encode(A) {
      const { type: u } = A;
      if (u === "wpkh")
        return programToWitness(0, A.hash, s);
      if (u === "wsh")
        return programToWitness(0, A.hash, s);
      if (u === "tr")
        return programToWitness(1, A.pubkey, s);
      if (u === "pkh")
        return formatKey(A.hash, [s.pubKeyHash]);
      if (u === "sh")
        return formatKey(A.hash, [s.scriptHash]);
      throw new Error(`Unknown address type=${u}`);
    },
    decode(A) {
      if (A.length < 14 || A.length > 74)
        throw new Error("Invalid address length");
      if (s.bech32 && A.toLowerCase().startsWith(`${s.bech32}1`)) {
        let p;
        try {
          if (p = bech32$1.decode(A), p.words[0] !== 0)
            throw new Error(`bech32: wrong version=${p.words[0]}`);
        } catch {
          if (p = bech32m.decode(A), p.words[0] === 0)
            throw new Error(`bech32m: wrong version=${p.words[0]}`);
        }
        if (p.prefix !== s.bech32)
          throw new Error(`wrong bech32 prefix=${p.prefix}`);
        const [t, ...l] = p.words, m = bech32$1.fromWords(l);
        if (validateWitness(t, m), t === 0 && m.length === 32)
          return { type: "wsh", hash: m };
        if (t === 0 && m.length === 20)
          return { type: "wpkh", hash: m };
        if (t === 1 && m.length === 32)
          return { type: "tr", pubkey: m };
        throw new Error("Unknown witness program");
      }
      const u = base58check.decode(A);
      if (u.length !== 21)
        throw new Error("Invalid base58 address");
      if (u[0] === s.pubKeyHash)
        return { type: "pkh", hash: u.slice(1) };
      if (u[0] === s.scriptHash)
        return {
          type: "sh",
          hash: u.slice(1)
        };
      throw new Error(`Invalid address prefix=${u[0]}`);
    }
  };
}
const EMPTY32 = new Uint8Array(32), EMPTY_OUTPUT = {
  amount: 0xffffffffffffffffn,
  script: EMPTY
}, toVsize = (s) => Math.ceil(s / 4), PRECISION = 8, DEFAULT_VERSION = 2, DEFAULT_LOCKTIME = 0, DEFAULT_SEQUENCE = 4294967295;
coders.decimal(PRECISION);
const def = (s, A) => s === void 0 ? A : s;
function cloneDeep(s) {
  if (Array.isArray(s))
    return s.map((A) => cloneDeep(A));
  if (isBytes(s))
    return Uint8Array.from(s);
  if (["number", "bigint", "boolean", "string", "undefined"].includes(typeof s))
    return s;
  if (s === null)
    return s;
  if (typeof s == "object")
    return Object.fromEntries(Object.entries(s).map(([A, u]) => [A, cloneDeep(u)]));
  throw new Error(`cloneDeep: unknown type=${s} (${typeof s})`);
}
var SignatureHash;
(function(s) {
  s[s.DEFAULT = 0] = "DEFAULT", s[s.ALL = 1] = "ALL", s[s.NONE = 2] = "NONE", s[s.SINGLE = 3] = "SINGLE", s[s.ANYONECANPAY = 128] = "ANYONECANPAY";
})(SignatureHash || (SignatureHash = {}));
var SigHash;
(function(s) {
  s[s.DEFAULT = 0] = "DEFAULT", s[s.ALL = 1] = "ALL", s[s.NONE = 2] = "NONE", s[s.SINGLE = 3] = "SINGLE", s[s.DEFAULT_ANYONECANPAY = 128] = "DEFAULT_ANYONECANPAY", s[s.ALL_ANYONECANPAY = 129] = "ALL_ANYONECANPAY", s[s.NONE_ANYONECANPAY = 130] = "NONE_ANYONECANPAY", s[s.SINGLE_ANYONECANPAY = 131] = "SINGLE_ANYONECANPAY";
})(SigHash || (SigHash = {}));
function getTaprootKeys(s, A, u, p = EMPTY) {
  return equalBytes(u, A) && (s = taprootTweakPrivKey(s, p), A = pubSchnorr(s)), { privKey: s, pubKey: A };
}
function outputBeforeSign(s) {
  if (s.script === void 0 || s.amount === void 0)
    throw new Error("Transaction/output: script and amount required");
  return { script: s.script, amount: s.amount };
}
function inputBeforeSign(s) {
  if (s.txid === void 0 || s.index === void 0)
    throw new Error("Transaction/input: txid and index required");
  return {
    txid: s.txid,
    index: s.index,
    sequence: def(s.sequence, DEFAULT_SEQUENCE),
    finalScriptSig: def(s.finalScriptSig, EMPTY)
  };
}
function cleanFinalInput(s) {
  for (const A in s) {
    const u = A;
    PSBTInputFinalKeys.includes(u) || delete s[u];
  }
}
const TxHashIdx = struct({ txid: createBytes(32, !0), index: U32LE });
function validateSigHash(s) {
  if (typeof s != "number" || typeof SigHash[s] != "string")
    throw new Error(`Invalid SigHash=${s}`);
  return s;
}
function unpackSighash(s) {
  const A = s & 31;
  return {
    isAny: !!(s & SignatureHash.ANYONECANPAY),
    isNone: A === SignatureHash.NONE,
    isSingle: A === SignatureHash.SINGLE
  };
}
function validateOpts(s) {
  if (s !== void 0 && {}.toString.call(s) !== "[object Object]")
    throw new Error(`Wrong object type for transaction options: ${s}`);
  const A = {
    ...s,
    // Defaults
    version: def(s.version, DEFAULT_VERSION),
    lockTime: def(s.lockTime, 0),
    PSBTVersion: def(s.PSBTVersion, 0)
  };
  if (typeof A.allowUnknowInput < "u" && (s.allowUnknownInputs = A.allowUnknowInput), typeof A.allowUnknowOutput < "u" && (s.allowUnknownOutputs = A.allowUnknowOutput), typeof A.lockTime != "number")
    throw new Error("Transaction lock time should be number");
  if (U32LE.encode(A.lockTime), A.PSBTVersion !== 0 && A.PSBTVersion !== 2)
    throw new Error(`Unknown PSBT version ${A.PSBTVersion}`);
  for (const u of [
    "allowUnknownVersion",
    "allowUnknownOutputs",
    "allowUnknownInputs",
    "disableScriptCheck",
    "bip174jsCompat",
    "allowLegacyWitnessUtxo",
    "lowR"
  ]) {
    const p = A[u];
    if (p !== void 0 && typeof p != "boolean")
      throw new Error(`Transation options wrong type: ${u}=${p} (${typeof p})`);
  }
  if (A.allowUnknownVersion ? typeof A.version == "number" : ![-1, 0, 1, 2, 3].includes(A.version))
    throw new Error(`Unknown version: ${A.version}`);
  if (A.customScripts !== void 0) {
    const u = A.customScripts;
    if (!Array.isArray(u))
      throw new Error(`wrong custom scripts type (expected array): customScripts=${u} (${typeof u})`);
    for (const p of u) {
      if (typeof p.encode != "function" || typeof p.decode != "function")
        throw new Error(`wrong script=${p} (${typeof p})`);
      if (p.finalizeTaproot !== void 0 && typeof p.finalizeTaproot != "function")
        throw new Error(`wrong script=${p} (${typeof p})`);
    }
  }
  return Object.freeze(A);
}
function validateInput(s) {
  if (s.nonWitnessUtxo && s.index !== void 0) {
    const A = s.nonWitnessUtxo.outputs.length - 1;
    if (s.index > A)
      throw new Error(`validateInput: index(${s.index}) not in nonWitnessUtxo`);
    const u = s.nonWitnessUtxo.outputs[s.index];
    if (s.witnessUtxo && (!equalBytes(s.witnessUtxo.script, u.script) || s.witnessUtxo.amount !== u.amount))
      throw new Error("validateInput: witnessUtxo different from nonWitnessUtxo");
    if (s.txid) {
      if (s.nonWitnessUtxo.outputs.length - 1 < s.index)
        throw new Error("nonWitnessUtxo: incorect output index");
      const t = Transaction.fromRaw(RawTx.encode(s.nonWitnessUtxo), {
        allowUnknownOutputs: !0,
        disableScriptCheck: !0,
        allowUnknownInputs: !0
      }), l = hex$1.encode(s.txid);
      if (t.isFinal && t.id !== l)
        throw new Error(`nonWitnessUtxo: wrong txid, exp=${l} got=${t.id}`);
    }
  }
  return s;
}
function getPrevOut(s) {
  if (s.nonWitnessUtxo) {
    if (s.index === void 0)
      throw new Error("Unknown input index");
    return s.nonWitnessUtxo.outputs[s.index];
  } else {
    if (s.witnessUtxo)
      return s.witnessUtxo;
    throw new Error("Cannot find previous output info");
  }
}
function normalizeInput(s, A, u, p = !1, t = !1) {
  let { nonWitnessUtxo: l, txid: m } = s;
  typeof l == "string" && (l = hex$1.decode(l)), isBytes(l) && (l = RawTx.decode(l)), !("nonWitnessUtxo" in s) && l === void 0 && (l = A == null ? void 0 : A.nonWitnessUtxo), typeof m == "string" && (m = hex$1.decode(m)), m === void 0 && (m = A == null ? void 0 : A.txid);
  let b = { ...A, ...s, nonWitnessUtxo: l, txid: m };
  !("nonWitnessUtxo" in s) && b.nonWitnessUtxo === void 0 && delete b.nonWitnessUtxo, b.sequence === void 0 && (b.sequence = DEFAULT_SEQUENCE), b.tapMerkleRoot === null && delete b.tapMerkleRoot, b = mergeKeyMap(PSBTInput, b, A, u, t), PSBTInputCoder.encode(b);
  let k;
  return b.nonWitnessUtxo && b.index !== void 0 ? k = b.nonWitnessUtxo.outputs[b.index] : b.witnessUtxo && (k = b.witnessUtxo), k && !p && checkScript(k && k.script, b.redeemScript, b.witnessScript), b;
}
function getInputType(s, A = !1) {
  let u = "legacy", p = SignatureHash.ALL;
  const t = getPrevOut(s), l = OutScript.decode(t.script);
  let m = l.type, b = l;
  const k = [l];
  if (l.type === "tr")
    return p = SignatureHash.DEFAULT, {
      txType: "taproot",
      type: "tr",
      last: l,
      lastScript: t.script,
      defaultSighash: p,
      sighash: s.sighashType || p
    };
  {
    if ((l.type === "wpkh" || l.type === "wsh") && (u = "segwit"), l.type === "sh") {
      if (!s.redeemScript)
        throw new Error("inputType: sh without redeemScript");
      let P = OutScript.decode(s.redeemScript);
      (P.type === "wpkh" || P.type === "wsh") && (u = "segwit"), k.push(P), b = P, m += `-${P.type}`;
    }
    if (b.type === "wsh") {
      if (!s.witnessScript)
        throw new Error("inputType: wsh without witnessScript");
      let P = OutScript.decode(s.witnessScript);
      P.type === "wsh" && (u = "segwit"), k.push(P), b = P, m += `-${P.type}`;
    }
    const C = k[k.length - 1];
    if (C.type === "sh" || C.type === "wsh")
      throw new Error("inputType: sh/wsh cannot be terminal type");
    const B = OutScript.encode(C), Q = {
      type: m,
      txType: u,
      last: C,
      lastScript: B,
      defaultSighash: p,
      sighash: s.sighashType || p
    };
    if (u === "legacy" && !A && !s.nonWitnessUtxo)
      throw new Error("Transaction/sign: legacy input without nonWitnessUtxo, can result in attack that forces paying higher fees. Pass allowLegacyWitnessUtxo=true, if you sure");
    return Q;
  }
}
class Transaction {
  constructor(A = {}) {
    this.global = {}, this.inputs = [], this.outputs = [];
    const u = this.opts = validateOpts(A);
    u.lockTime !== DEFAULT_LOCKTIME && (this.global.fallbackLocktime = u.lockTime), this.global.txVersion = u.version;
  }
  // Import
  static fromRaw(A, u = {}) {
    const p = RawTx.decode(A), t = new Transaction({ ...u, version: p.version, lockTime: p.lockTime });
    for (const l of p.outputs)
      t.addOutput(l);
    if (t.outputs = p.outputs, t.inputs = p.inputs, p.witnesses)
      for (let l = 0; l < p.witnesses.length; l++)
        t.inputs[l].finalScriptWitness = p.witnesses[l];
    return t;
  }
  // PSBT
  static fromPSBT(A, u = {}) {
    let p;
    try {
      p = RawPSBTV0.decode(A);
    } catch (Q) {
      try {
        p = RawPSBTV2.decode(A);
      } catch {
        throw Q;
      }
    }
    const t = p.global.version || 0;
    if (t !== 0 && t !== 2)
      throw new Error(`Wrong PSBT version=${t}`);
    const l = p.global.unsignedTx, m = t === 0 ? l == null ? void 0 : l.version : p.global.txVersion, b = t === 0 ? l == null ? void 0 : l.lockTime : p.global.fallbackLocktime, k = new Transaction({ ...u, version: m, lockTime: b, PSBTVersion: t }), C = t === 0 ? l == null ? void 0 : l.inputs.length : p.global.inputCount;
    k.inputs = p.inputs.slice(0, C).map((Q, P) => {
      var x;
      return validateInput({
        finalScriptSig: EMPTY,
        ...(x = p.global.unsignedTx) == null ? void 0 : x.inputs[P],
        ...Q
      });
    });
    const B = t === 0 ? l == null ? void 0 : l.outputs.length : p.global.outputCount;
    return k.outputs = p.outputs.slice(0, B).map((Q, P) => {
      var x;
      return {
        ...Q,
        ...(x = p.global.unsignedTx) == null ? void 0 : x.outputs[P]
      };
    }), k.global = { ...p.global, txVersion: m }, b !== DEFAULT_LOCKTIME && (k.global.fallbackLocktime = b), k;
  }
  toPSBT(A = this.opts.PSBTVersion) {
    if (A !== 0 && A !== 2)
      throw new Error(`Wrong PSBT version=${A}`);
    const u = this.inputs.map((l) => validateInput(cleanPSBTFields(A, PSBTInput, l)));
    for (const l of u)
      l.partialSig && !l.partialSig.length && delete l.partialSig, l.finalScriptSig && !l.finalScriptSig.length && delete l.finalScriptSig, l.finalScriptWitness && !l.finalScriptWitness.length && delete l.finalScriptWitness;
    const p = this.outputs.map((l) => cleanPSBTFields(A, PSBTOutput, l)), t = { ...this.global };
    return A === 0 ? (t.unsignedTx = RawOldTx.decode(RawOldTx.encode({
      version: this.version,
      lockTime: this.lockTime,
      inputs: this.inputs.map(inputBeforeSign).map((l) => ({
        ...l,
        finalScriptSig: EMPTY
      })),
      outputs: this.outputs.map(outputBeforeSign)
    })), delete t.fallbackLocktime, delete t.txVersion) : (t.version = A, t.txVersion = this.version, t.inputCount = this.inputs.length, t.outputCount = this.outputs.length, t.fallbackLocktime && t.fallbackLocktime === DEFAULT_LOCKTIME && delete t.fallbackLocktime), this.opts.bip174jsCompat && (u.length || u.push({}), p.length || p.push({})), (A === 0 ? RawPSBTV0 : RawPSBTV2).encode({
      global: t,
      inputs: u,
      outputs: p
    });
  }
  // BIP370 lockTime (https://github.com/bitcoin/bips/blob/master/bip-0370.mediawiki#determining-lock-time)
  get lockTime() {
    let A = DEFAULT_LOCKTIME, u = 0, p = DEFAULT_LOCKTIME, t = 0;
    for (const l of this.inputs)
      l.requiredHeightLocktime && (A = Math.max(A, l.requiredHeightLocktime), u++), l.requiredTimeLocktime && (p = Math.max(p, l.requiredTimeLocktime), t++);
    return u && u >= t ? A : p !== DEFAULT_LOCKTIME ? p : this.global.fallbackLocktime || DEFAULT_LOCKTIME;
  }
  get version() {
    if (this.global.txVersion === void 0)
      throw new Error("No global.txVersion");
    return this.global.txVersion;
  }
  inputStatus(A) {
    this.checkInputIdx(A);
    const u = this.inputs[A];
    return u.finalScriptSig && u.finalScriptSig.length || u.finalScriptWitness && u.finalScriptWitness.length ? "finalized" : u.tapKeySig || u.tapScriptSig && u.tapScriptSig.length || u.partialSig && u.partialSig.length ? "signed" : "unsigned";
  }
  // Cannot replace unpackSighash, tests rely on very generic implemenetation with signing inputs outside of range
  // We will lose some vectors -> smaller test coverage of preimages (very important!)
  inputSighash(A) {
    this.checkInputIdx(A);
    const u = this.inputs[A].sighashType, p = u === void 0 ? SignatureHash.DEFAULT : u, t = p === SignatureHash.DEFAULT ? SignatureHash.ALL : p & 3;
    return { sigInputs: p & SignatureHash.ANYONECANPAY, sigOutputs: t };
  }
  // Very nice for debug purposes, but slow. If there is too much inputs/outputs to add, will be quadratic.
  // Some cache will be nice, but there chance to have bugs with cache invalidation
  signStatus() {
    let A = !0, u = !0, p = [], t = [];
    for (let l = 0; l < this.inputs.length; l++) {
      if (this.inputStatus(l) === "unsigned")
        continue;
      const { sigInputs: b, sigOutputs: k } = this.inputSighash(l);
      if (b === SignatureHash.ANYONECANPAY ? p.push(l) : A = !1, k === SignatureHash.ALL)
        u = !1;
      else if (k === SignatureHash.SINGLE)
        t.push(l);
      else if (k !== SignatureHash.NONE) throw new Error(`Wrong signature hash output type: ${k}`);
    }
    return { addInput: A, addOutput: u, inputs: p, outputs: t };
  }
  get isFinal() {
    for (let A = 0; A < this.inputs.length; A++)
      if (this.inputStatus(A) !== "finalized")
        return !1;
    return !0;
  }
  // Info utils
  get hasWitnesses() {
    let A = !1;
    for (const u of this.inputs)
      u.finalScriptWitness && u.finalScriptWitness.length && (A = !0);
    return A;
  }
  // https://en.bitcoin.it/wiki/Weight_units
  get weight() {
    if (!this.isFinal)
      throw new Error("Transaction is not finalized");
    let A = 32;
    const u = this.outputs.map(outputBeforeSign);
    A += 4 * CompactSizeLen.encode(this.outputs.length).length;
    for (const p of u)
      A += 32 + 4 * VarBytes.encode(p.script).length;
    this.hasWitnesses && (A += 2), A += 4 * CompactSizeLen.encode(this.inputs.length).length;
    for (const p of this.inputs)
      A += 160 + 4 * VarBytes.encode(p.finalScriptSig || EMPTY).length, this.hasWitnesses && p.finalScriptWitness && (A += RawWitness.encode(p.finalScriptWitness).length);
    return A;
  }
  get vsize() {
    return toVsize(this.weight);
  }
  toBytes(A = !1, u = !1) {
    return RawTx.encode({
      version: this.version,
      lockTime: this.lockTime,
      inputs: this.inputs.map(inputBeforeSign).map((p) => ({
        ...p,
        finalScriptSig: A && p.finalScriptSig || EMPTY
      })),
      outputs: this.outputs.map(outputBeforeSign),
      witnesses: this.inputs.map((p) => p.finalScriptWitness || []),
      segwitFlag: u && this.hasWitnesses
    });
  }
  get unsignedTx() {
    return this.toBytes(!1, !1);
  }
  get hex() {
    return hex$1.encode(this.toBytes(!0, this.hasWitnesses));
  }
  get hash() {
    if (!this.isFinal)
      throw new Error("Transaction is not finalized");
    return hex$1.encode(sha256x2(this.toBytes(!0)));
  }
  get id() {
    if (!this.isFinal)
      throw new Error("Transaction is not finalized");
    return hex$1.encode(sha256x2(this.toBytes(!0)).reverse());
  }
  // Input stuff
  checkInputIdx(A) {
    if (!Number.isSafeInteger(A) || 0 > A || A >= this.inputs.length)
      throw new Error(`Wrong input index=${A}`);
  }
  getInput(A) {
    return this.checkInputIdx(A), cloneDeep(this.inputs[A]);
  }
  get inputsLength() {
    return this.inputs.length;
  }
  // Modification
  addInput(A, u = !1) {
    if (!u && !this.signStatus().addInput)
      throw new Error("Tx has signed inputs, cannot add new one");
    return this.inputs.push(normalizeInput(A, void 0, void 0, this.opts.disableScriptCheck)), this.inputs.length - 1;
  }
  updateInput(A, u, p = !1) {
    this.checkInputIdx(A);
    let t;
    if (!p) {
      const l = this.signStatus();
      (!l.addInput || l.inputs.includes(A)) && (t = PSBTInputUnsignedKeys);
    }
    this.inputs[A] = normalizeInput(u, this.inputs[A], t, this.opts.disableScriptCheck, this.opts.allowUnknown);
  }
  // Output stuff
  checkOutputIdx(A) {
    if (!Number.isSafeInteger(A) || 0 > A || A >= this.outputs.length)
      throw new Error(`Wrong output index=${A}`);
  }
  getOutput(A) {
    return this.checkOutputIdx(A), cloneDeep(this.outputs[A]);
  }
  getOutputAddress(A, u = NETWORK) {
    const p = this.getOutput(A);
    if (p.script)
      return Address(u).encode(OutScript.decode(p.script));
  }
  get outputsLength() {
    return this.outputs.length;
  }
  normalizeOutput(A, u, p) {
    let { amount: t, script: l } = A;
    if (t === void 0 && (t = u == null ? void 0 : u.amount), typeof t != "bigint")
      throw new Error(`Wrong amount type, should be of type bigint in sats, but got ${t} of type ${typeof t}`);
    typeof l == "string" && (l = hex$1.decode(l)), l === void 0 && (l = u == null ? void 0 : u.script);
    let m = { ...u, ...A, amount: t, script: l };
    if (m.amount === void 0 && delete m.amount, m = mergeKeyMap(PSBTOutput, m, u, p, this.opts.allowUnknown), PSBTOutputCoder.encode(m), m.script && !this.opts.allowUnknownOutputs && OutScript.decode(m.script).type === "unknown")
      throw new Error("Transaction/output: unknown output script type, there is a chance that input is unspendable. Pass allowUnknownOutputs=true, if you sure");
    return this.opts.disableScriptCheck || checkScript(m.script, m.redeemScript, m.witnessScript), m;
  }
  addOutput(A, u = !1) {
    if (!u && !this.signStatus().addOutput)
      throw new Error("Tx has signed outputs, cannot add new one");
    return this.outputs.push(this.normalizeOutput(A)), this.outputs.length - 1;
  }
  updateOutput(A, u, p = !1) {
    this.checkOutputIdx(A);
    let t;
    if (!p) {
      const l = this.signStatus();
      (!l.addOutput || l.outputs.includes(A)) && (t = PSBTOutputUnsignedKeys);
    }
    this.outputs[A] = this.normalizeOutput(u, this.outputs[A], t);
  }
  addOutputAddress(A, u, p = NETWORK) {
    return this.addOutput({ script: OutScript.encode(Address(p).decode(A)), amount: u });
  }
  // Utils
  get fee() {
    let A = 0n;
    for (const p of this.inputs) {
      const t = getPrevOut(p);
      if (!t)
        throw new Error("Empty input amount");
      A += t.amount;
    }
    const u = this.outputs.map(outputBeforeSign);
    for (const p of u)
      A -= p.amount;
    return A;
  }
  // Signing
  // Based on https://github.com/bitcoin/bitcoin/blob/5871b5b5ab57a0caf9b7514eb162c491c83281d5/test/functional/test_framework/script.py#L624
  // There is optimization opportunity to re-use hashes for multiple inputs for witness v0/v1,
  // but we are trying to be less complicated for audit purpose for now.
  preimageLegacy(A, u, p) {
    const { isAny: t, isNone: l, isSingle: m } = unpackSighash(p);
    if (A < 0 || !Number.isSafeInteger(A))
      throw new Error(`Invalid input idx=${A}`);
    if (m && A >= this.outputs.length || A >= this.inputs.length)
      return U256BE.encode(1n);
    u = Script.encode(Script.decode(u).filter((B) => B !== "CODESEPARATOR"));
    let b = this.inputs.map(inputBeforeSign).map((B, Q) => ({
      ...B,
      finalScriptSig: Q === A ? u : EMPTY
    }));
    t ? b = [b[A]] : (l || m) && (b = b.map((B, Q) => ({
      ...B,
      sequence: Q === A ? B.sequence : 0
    })));
    let k = this.outputs.map(outputBeforeSign);
    l ? k = [] : m && (k = k.slice(0, A).fill(EMPTY_OUTPUT).concat([k[A]]));
    const C = RawTx.encode({
      lockTime: this.lockTime,
      version: this.version,
      segwitFlag: !1,
      inputs: b,
      outputs: k
    });
    return sha256x2(C, I32LE.encode(p));
  }
  preimageWitnessV0(A, u, p, t) {
    const { isAny: l, isNone: m, isSingle: b } = unpackSighash(p);
    let k = EMPTY32, C = EMPTY32, B = EMPTY32;
    const Q = this.inputs.map(inputBeforeSign), P = this.outputs.map(outputBeforeSign);
    l || (k = sha256x2(...Q.map(TxHashIdx.encode))), !l && !b && !m && (C = sha256x2(...Q.map((M) => U32LE.encode(M.sequence)))), !b && !m ? B = sha256x2(...P.map(RawOutput.encode)) : b && A < P.length && (B = sha256x2(RawOutput.encode(P[A])));
    const x = Q[A];
    return sha256x2(I32LE.encode(this.version), k, C, createBytes(32, !0).encode(x.txid), U32LE.encode(x.index), VarBytes.encode(u), U64LE.encode(t), U32LE.encode(x.sequence), B, U32LE.encode(this.lockTime), U32LE.encode(p));
  }
  preimageWitnessV1(A, u, p, t, l = -1, m, b = 192, k) {
    if (!Array.isArray(t) || this.inputs.length !== t.length)
      throw new Error(`Invalid amounts array=${t}`);
    if (!Array.isArray(u) || this.inputs.length !== u.length)
      throw new Error(`Invalid prevOutScript array=${u}`);
    const C = [
      U8.encode(0),
      U8.encode(p),
      // U8 sigHash
      I32LE.encode(this.version),
      U32LE.encode(this.lockTime)
    ], B = p === SignatureHash.DEFAULT ? SignatureHash.ALL : p & 3, Q = p & SignatureHash.ANYONECANPAY, P = this.inputs.map(inputBeforeSign), x = this.outputs.map(outputBeforeSign);
    Q !== SignatureHash.ANYONECANPAY && C.push(...[
      P.map(TxHashIdx.encode),
      t.map(U64LE.encode),
      u.map(VarBytes.encode),
      P.map((F) => U32LE.encode(F.sequence))
    ].map((F) => sha256$2(concatBytes$1(...F)))), B === SignatureHash.ALL && C.push(sha256$2(concatBytes$1(...x.map(RawOutput.encode))));
    const M = (k ? 1 : 0) | (m ? 2 : 0);
    if (C.push(new Uint8Array([M])), Q === SignatureHash.ANYONECANPAY) {
      const F = P[A];
      C.push(TxHashIdx.encode(F), U64LE.encode(t[A]), VarBytes.encode(u[A]), U32LE.encode(F.sequence));
    } else
      C.push(U32LE.encode(A));
    return M & 1 && C.push(sha256$2(VarBytes.encode(k || EMPTY))), B === SignatureHash.SINGLE && C.push(A < x.length ? sha256$2(RawOutput.encode(x[A])) : EMPTY32), m && C.push(tapLeafHash(m, b), U8.encode(0), I32LE.encode(l)), tagSchnorr("TapSighash", ...C);
  }
  // Signer can be privateKey OR instance of bip32 HD stuff
  signIdx(A, u, p, t) {
    this.checkInputIdx(u);
    const l = this.inputs[u], m = getInputType(l, this.opts.allowLegacyWitnessUtxo);
    if (!isBytes(A)) {
      if (!l.bip32Derivation || !l.bip32Derivation.length)
        throw new Error("bip32Derivation: empty");
      const B = l.bip32Derivation.filter((P) => P[1].fingerprint == A.fingerprint).map(([P, { path: x }]) => {
        let M = A;
        for (const F of x)
          M = M.deriveChild(F);
        if (!equalBytes(M.publicKey, P))
          throw new Error("bip32Derivation: wrong pubKey");
        if (!M.privateKey)
          throw new Error("bip32Derivation: no privateKey");
        return M;
      });
      if (!B.length)
        throw new Error(`bip32Derivation: no items with fingerprint=${A.fingerprint}`);
      let Q = !1;
      for (const P of B)
        this.signIdx(P.privateKey, u) && (Q = !0);
      return Q;
    }
    p ? p.forEach(validateSigHash) : p = [m.defaultSighash];
    const b = m.sighash;
    if (!p.includes(b))
      throw new Error(`Input with not allowed sigHash=${b}. Allowed: ${p.join(", ")}`);
    const { sigOutputs: k } = this.inputSighash(u);
    if (k === SignatureHash.SINGLE && u >= this.outputs.length)
      throw new Error(`Input with sighash SINGLE, but there is no output with corresponding index=${u}`);
    const C = getPrevOut(l);
    if (m.txType === "taproot") {
      const B = this.inputs.map(getPrevOut), Q = B.map((le) => le.script), P = B.map((le) => le.amount);
      let x = !1, M = pubSchnorr(A), F = l.tapMerkleRoot || EMPTY;
      if (l.tapInternalKey) {
        const { pubKey: le, privKey: ge } = getTaprootKeys(A, M, l.tapInternalKey, F), [pe, Ie] = taprootTweakPubkey(l.tapInternalKey, F);
        if (equalBytes(pe, le)) {
          const be = this.preimageWitnessV1(u, Q, b, P), Pe = concatBytes$1(signSchnorr(be, ge, t), b !== SignatureHash.DEFAULT ? new Uint8Array([b]) : EMPTY);
          this.updateInput(u, { tapKeySig: Pe }, !0), x = !0;
        }
      }
      if (l.tapLeafScript) {
        l.tapScriptSig = l.tapScriptSig || [];
        for (const [le, ge] of l.tapLeafScript) {
          const pe = ge.subarray(0, -1), Ie = Script.decode(pe), be = ge[ge.length - 1], Pe = tapLeafHash(pe, be);
          if (Ie.findIndex((Ee) => isBytes(Ee) && equalBytes(Ee, M)) === -1)
            continue;
          const Qe = this.preimageWitnessV1(u, Q, b, P, void 0, pe, be), xe = concatBytes$1(signSchnorr(Qe, A, t), b !== SignatureHash.DEFAULT ? new Uint8Array([b]) : EMPTY);
          this.updateInput(u, { tapScriptSig: [[{ pubKey: M, leafHash: Pe }, xe]] }, !0), x = !0;
        }
      }
      if (!x)
        throw new Error("No taproot scripts signed");
      return !0;
    } else {
      const B = pubECDSA(A);
      let Q = !1;
      const P = hash160(B);
      for (const F of Script.decode(m.lastScript))
        isBytes(F) && (equalBytes(F, B) || equalBytes(F, P)) && (Q = !0);
      if (!Q)
        throw new Error(`Input script doesn't have pubKey: ${m.lastScript}`);
      let x;
      if (m.txType === "legacy")
        x = this.preimageLegacy(u, m.lastScript, b);
      else if (m.txType === "segwit") {
        let F = m.lastScript;
        m.last.type === "wpkh" && (F = OutScript.encode({ type: "pkh", hash: m.last.hash })), x = this.preimageWitnessV0(u, F, b, C.amount);
      } else
        throw new Error(`Transaction/sign: unknown tx type: ${m.txType}`);
      const M = signECDSA(x, A, this.opts.lowR);
      this.updateInput(u, {
        partialSig: [[B, concatBytes$1(M, new Uint8Array([b]))]]
      }, !0);
    }
    return !0;
  }
  // This is bad API. Will work if user creates and signs tx, but if
  // there is some complex workflow with exchanging PSBT and signing them,
  // then it is better to validate which output user signs. How could a better API look like?
  // Example: user adds input, sends to another party, then signs received input (mixer etc),
  // another user can add different input for same key and user will sign it.
  // Even worse: another user can add bip32 derivation, and spend money from different address.
  // Better api: signIdx
  sign(A, u, p) {
    let t = 0;
    for (let l = 0; l < this.inputs.length; l++)
      try {
        this.signIdx(A, l, u, p) && t++;
      } catch {
      }
    if (!t)
      throw new Error("No inputs signed");
    return t;
  }
  finalizeIdx(A) {
    if (this.checkInputIdx(A), this.fee < 0n)
      throw new Error("Outputs spends more than inputs amount");
    const u = this.inputs[A], p = getInputType(u, this.opts.allowLegacyWitnessUtxo);
    if (p.txType === "taproot") {
      if (u.tapKeySig)
        u.finalScriptWitness = [u.tapKeySig];
      else if (u.tapLeafScript && u.tapScriptSig) {
        const k = u.tapLeafScript.sort((C, B) => TaprootControlBlock.encode(C[0]).length - TaprootControlBlock.encode(B[0]).length);
        for (const [C, B] of k) {
          const Q = B.slice(0, -1), P = B[B.length - 1], x = OutScript.decode(Q), M = tapLeafHash(Q, P), F = u.tapScriptSig.filter((ge) => equalBytes(ge[0].leafHash, M));
          let le = [];
          if (x.type === "tr_ms") {
            const ge = x.m, pe = x.pubkeys;
            let Ie = 0;
            for (const be of pe) {
              const Pe = F.findIndex((Te) => equalBytes(Te[0].pubKey, be));
              if (Ie === ge || Pe === -1) {
                le.push(EMPTY);
                continue;
              }
              le.push(F[Pe][1]), Ie++;
            }
            if (Ie !== ge)
              continue;
          } else if (x.type === "tr_ns") {
            for (const ge of x.pubkeys) {
              const pe = F.findIndex((Ie) => equalBytes(Ie[0].pubKey, ge));
              pe !== -1 && le.push(F[pe][1]);
            }
            if (le.length !== x.pubkeys.length)
              continue;
          } else if (x.type === "unknown" && this.opts.allowUnknownInputs) {
            const ge = Script.decode(Q);
            if (le = F.map(([{ pubKey: pe }, Ie]) => {
              const be = ge.findIndex((Pe) => isBytes(Pe) && equalBytes(Pe, pe));
              if (be === -1)
                throw new Error("finalize/taproot: cannot find position of pubkey in script");
              return { signature: Ie, pos: be };
            }).sort((pe, Ie) => pe.pos - Ie.pos).map((pe) => pe.signature), !le.length)
              continue;
          } else {
            const ge = this.opts.customScripts;
            if (ge)
              for (const pe of ge) {
                if (!pe.finalizeTaproot)
                  continue;
                const Ie = Script.decode(Q), be = pe.encode(Ie);
                if (be === void 0)
                  continue;
                const Pe = pe.finalizeTaproot(Q, be, F);
                if (Pe) {
                  u.finalScriptWitness = Pe.concat(TaprootControlBlock.encode(C)), u.finalScriptSig = EMPTY, cleanFinalInput(u);
                  return;
                }
              }
            throw new Error("Finalize: Unknown tapLeafScript");
          }
          u.finalScriptWitness = le.reverse().concat([Q, TaprootControlBlock.encode(C)]);
          break;
        }
        if (!u.finalScriptWitness)
          throw new Error("finalize/taproot: empty witness");
      } else
        throw new Error("finalize/taproot: unknown input");
      u.finalScriptSig = EMPTY, cleanFinalInput(u);
      return;
    }
    if (!u.partialSig || !u.partialSig.length)
      throw new Error("Not enough partial sign");
    let t = EMPTY, l = [];
    if (p.last.type === "ms") {
      const k = p.last.m, C = p.last.pubkeys;
      let B = [];
      for (const Q of C) {
        const P = u.partialSig.find((x) => equalBytes(Q, x[0]));
        P && B.push(P[1]);
      }
      if (B = B.slice(0, k), B.length !== k)
        throw new Error(`Multisig: wrong signatures count, m=${k} n=${C.length} signatures=${B.length}`);
      t = Script.encode([0, ...B]);
    } else if (p.last.type === "pk")
      t = Script.encode([u.partialSig[0][1]]);
    else if (p.last.type === "pkh")
      t = Script.encode([u.partialSig[0][1], u.partialSig[0][0]]);
    else if (p.last.type === "wpkh")
      t = EMPTY, l = [u.partialSig[0][1], u.partialSig[0][0]];
    else if (p.last.type === "unknown" && !this.opts.allowUnknownInputs)
      throw new Error("Unknown inputs not allowed");
    let m, b;
    if (p.type.includes("wsh-") && (t.length && p.lastScript.length && (l = Script.decode(t).map((k) => {
      if (k === 0)
        return EMPTY;
      if (isBytes(k))
        return k;
      throw new Error(`Wrong witness op=${k}`);
    })), l = l.concat(p.lastScript)), p.txType === "segwit" && (b = l), p.type.startsWith("sh-wsh-") ? m = Script.encode([Script.encode([0, sha256$2(p.lastScript)])]) : p.type.startsWith("sh-") ? m = Script.encode([...Script.decode(t), p.lastScript]) : p.type.startsWith("wsh-") || p.txType !== "segwit" && (m = t), !m && !b)
      throw new Error("Unknown error finalizing input");
    m && (u.finalScriptSig = m), b && (u.finalScriptWitness = b), cleanFinalInput(u);
  }
  finalize() {
    for (let A = 0; A < this.inputs.length; A++)
      this.finalizeIdx(A);
  }
  extract() {
    if (!this.isFinal)
      throw new Error("Transaction has unfinalized inputs");
    if (!this.outputs.length)
      throw new Error("Transaction has no outputs");
    if (this.fee < 0n)
      throw new Error("Outputs spends more than inputs amount");
    return this.toBytes(!0, !0);
  }
  combine(A) {
    for (const t of ["PSBTVersion", "version", "lockTime"])
      if (this.opts[t] !== A.opts[t])
        throw new Error(`Transaction/combine: different ${t} this=${this.opts[t]} other=${A.opts[t]}`);
    for (const t of ["inputs", "outputs"])
      if (this[t].length !== A[t].length)
        throw new Error(`Transaction/combine: different ${t} length this=${this[t].length} other=${A[t].length}`);
    const u = this.global.unsignedTx ? RawOldTx.encode(this.global.unsignedTx) : EMPTY, p = A.global.unsignedTx ? RawOldTx.encode(A.global.unsignedTx) : EMPTY;
    if (!equalBytes(u, p))
      throw new Error("Transaction/combine: different unsigned tx");
    this.global = mergeKeyMap(PSBTGlobal, this.global, A.global, void 0, this.opts.allowUnknown);
    for (let t = 0; t < this.inputs.length; t++)
      this.updateInput(t, A.inputs[t], !0);
    for (let t = 0; t < this.outputs.length; t++)
      this.updateOutput(t, A.outputs[t], !0);
    return this;
  }
  clone() {
    return Transaction.fromPSBT(this.toPSBT(this.opts.PSBTVersion), this.opts);
  }
}
var main$3 = {}, appClient$2 = {}, dist$1 = {}, descriptors = {}, src$1 = {}, bip32$3 = {}, crypto$1 = {}, sha512 = {}, hasRequiredSha512;
function requireSha512() {
  if (hasRequiredSha512) return sha512;
  hasRequiredSha512 = 1, Object.defineProperty(sha512, "__esModule", { value: !0 }), sha512.sha512_256 = sha512.SHA512_256 = sha512.sha512_224 = sha512.SHA512_224 = sha512.sha384 = sha512.SHA384 = sha512.sha512 = sha512.SHA512 = void 0;
  const s = /* @__PURE__ */ requireSha2();
  return sha512.SHA512 = s.SHA512, sha512.sha512 = s.sha512, sha512.SHA384 = s.SHA384, sha512.sha384 = s.sha384, sha512.SHA512_224 = s.SHA512_224, sha512.sha512_224 = s.sha512_224, sha512.SHA512_256 = s.SHA512_256, sha512.sha512_256 = s.sha512_256, sha512;
}
var hasRequiredCrypto;
function requireCrypto() {
  if (hasRequiredCrypto) return crypto$1;
  hasRequiredCrypto = 1, Object.defineProperty(crypto$1, "__esModule", { value: !0 }), crypto$1.hmacSHA512 = crypto$1.hash160 = void 0;
  const s = /* @__PURE__ */ requireHmac$3(), A = /* @__PURE__ */ requireRipemd160$2(), u = /* @__PURE__ */ requireSha256$4(), p = /* @__PURE__ */ requireSha512();
  function t(m) {
    const b = (0, u.sha256)(Uint8Array.from(m));
    return Buffer.from((0, A.ripemd160)(b));
  }
  crypto$1.hash160 = t;
  function l(m, b) {
    return Buffer.from((0, s.hmac)(p.sha512, m, b));
  }
  return crypto$1.hmacSHA512 = l, crypto$1;
}
var testecc$1 = {}, hasRequiredTestecc$1;
function requireTestecc$1() {
  if (hasRequiredTestecc$1) return testecc$1;
  hasRequiredTestecc$1 = 1, Object.defineProperty(testecc$1, "__esModule", { value: !0 }), testecc$1.testEcc = void 0;
  const s = (p) => Buffer.from(p, "hex");
  function A(p) {
    if (u(p.isPoint(s("0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"))), u(!p.isPoint(s("030000000000000000000000000000000000000000000000000000000000000005"))), u(p.isPrivate(s("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"))), u(p.isPrivate(s("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140"))), u(!p.isPrivate(s("0000000000000000000000000000000000000000000000000000000000000000"))), u(!p.isPrivate(s("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"))), u(!p.isPrivate(s("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364142"))), u(Buffer.from(p.pointFromScalar(s("b1121e4088a66a28f5b6b0f5844943ecd9f610196d7bb83b25214b60452c09af"))).equals(s("02b07ba9dca9523b7ef4bd97703d43d20399eb698e194704791a25ce77a400df99"))), p.xOnlyPointAddTweak) {
      u(p.xOnlyPointAddTweak(s("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"), s("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")) === null);
      let t = p.xOnlyPointAddTweak(s("1617d38ed8d8657da4d4761e8057bc396ea9e4b9d29776d4be096016dbd2509b"), s("a8397a935f0dfceba6ba9618f6451ef4d80637abf4e6af2669fbc9de6a8fd2ac"));
      u(Buffer.from(t.xOnlyPubkey).equals(s("e478f99dab91052ab39a33ea35fd5e6e4933f4d28023cd597c9a1f6760346adf")) && t.parity === 1), t = p.xOnlyPointAddTweak(s("2c0b7cf95324a07d05398b240174dc0c2be444d96b159aa6c7f7b1e668680991"), s("823c3cd2142744b075a87eade7e1b8678ba308d566226a0056ca2b7a76f86b47"));
    }
    u(Buffer.from(p.pointAddScalar(s("0379be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"), s("0000000000000000000000000000000000000000000000000000000000000003"))).equals(s("02c6047f9441ed7d6d3045406e95c07cd85c778e4b8cef3ca7abac09b95c709ee5"))), u(Buffer.from(p.privateAdd(s("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd036413e"), s("0000000000000000000000000000000000000000000000000000000000000002"))).equals(s("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140"))), p.privateNegate && (u(Buffer.from(p.privateNegate(s("0000000000000000000000000000000000000000000000000000000000000001"))).equals(s("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140"))), u(Buffer.from(p.privateNegate(s("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd036413e"))).equals(s("0000000000000000000000000000000000000000000000000000000000000003"))), u(Buffer.from(p.privateNegate(s("b1121e4088a66a28f5b6b0f5844943ecd9f610196d7bb83b25214b60452c09af"))).equals(s("4eede1bf775995d70a494f0a7bb6bc11e0b8cccd41cce8009ab1132c8b0a3792")))), u(Buffer.from(p.sign(s("5e9f0a0d593efdcf78ac923bc3313e4e7d408d574354ee2b3288c0da9fbba6ed"), s("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140"))).equals(s("54c4a33c6423d689378f160a7ff8b61330444abb58fb470f96ea16d99d4a2fed07082304410efa6b2943111b6a4e0aaa7b7db55a07e9861d1fb3cb1f421044a5"))), u(p.verify(s("5e9f0a0d593efdcf78ac923bc3313e4e7d408d574354ee2b3288c0da9fbba6ed"), s("0379be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"), s("54c4a33c6423d689378f160a7ff8b61330444abb58fb470f96ea16d99d4a2fed07082304410efa6b2943111b6a4e0aaa7b7db55a07e9861d1fb3cb1f421044a5"))), p.signSchnorr && u(Buffer.from(p.signSchnorr(s("7e2d58d8b3bcdf1abadec7829054f90dda9805aab56c77333024b9d0a508b75c"), s("c90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b14e5c9"), s("c87aa53824b4d7ae2eb035a2b5bbbccc080e76cdc6d1692c4b0b62d798e6d906"))).equals(s("5831aaeed7b44bb74e5eab94ba9d4294c49bcf2a60728d8b4c200f50dd313c1bab745879a5ad954a72c45a91c3a51d3c7adea98d82f8481e0e1e03674a6f3fb7"))), p.verifySchnorr && u(p.verifySchnorr(s("7e2d58d8b3bcdf1abadec7829054f90dda9805aab56c77333024b9d0a508b75c"), s("dd308afec5777e13121fa72b9cc1b7cc0139715309b086c960e18fd969774eb8"), s("5831aaeed7b44bb74e5eab94ba9d4294c49bcf2a60728d8b4c200f50dd313c1bab745879a5ad954a72c45a91c3a51d3c7adea98d82f8481e0e1e03674a6f3fb7")));
  }
  testecc$1.testEcc = A;
  function u(p) {
    if (!p)
      throw new Error("ecc library invalid");
  }
  return testecc$1;
}
var lib$2 = {}, hasRequiredLib$2;
function requireLib$2() {
  return hasRequiredLib$2 || (hasRequiredLib$2 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.bytes = s.stringToBytes = s.str = s.bytesToString = s.hex = s.utf8 = s.bech32m = s.bech32 = s.base58check = s.createBase58check = s.base58xmr = s.base58xrp = s.base58flickr = s.base58 = s.base64urlnopad = s.base64url = s.base64nopad = s.base64 = s.base32crockford = s.base32hexnopad = s.base32hex = s.base32nopad = s.base32 = s.base16 = s.utils = void 0;
    function A(Br) {
      return Br instanceof Uint8Array || ArrayBuffer.isView(Br) && Br.constructor.name === "Uint8Array";
    }
    function u(Br, ...Fr) {
      if (!A(Br))
        throw new Error("Uint8Array expected");
      if (Fr.length > 0 && !Fr.includes(Br.length))
        throw new Error("Uint8Array expected of length " + Fr + ", got length=" + Br.length);
    }
    function p(Br, Fr) {
      return Array.isArray(Fr) ? Fr.length === 0 ? !0 : Br ? Fr.every((Gr) => typeof Gr == "string") : Fr.every((Gr) => Number.isSafeInteger(Gr)) : !1;
    }
    function t(Br) {
      if (typeof Br != "function")
        throw new Error("function expected");
      return !0;
    }
    function l(Br, Fr) {
      if (typeof Fr != "string")
        throw new Error(`${Br}: string expected`);
      return !0;
    }
    function m(Br) {
      if (!Number.isSafeInteger(Br))
        throw new Error(`invalid integer: ${Br}`);
    }
    function b(Br) {
      if (!Array.isArray(Br))
        throw new Error("array expected");
    }
    function k(Br, Fr) {
      if (!p(!0, Fr))
        throw new Error(`${Br}: array of strings expected`);
    }
    function C(Br, Fr) {
      if (!p(!1, Fr))
        throw new Error(`${Br}: array of numbers expected`);
    }
    // @__NO_SIDE_EFFECTS__
    function B(...Br) {
      const Fr = (un) => un, Gr = (un, Dr) => (wr) => un(Dr(wr)), qr = Br.map((un) => un.encode).reduceRight(Gr, Fr), Hr = Br.map((un) => un.decode).reduce(Gr, Fr);
      return { encode: qr, decode: Hr };
    }
    // @__NO_SIDE_EFFECTS__
    function Q(Br) {
      const Fr = typeof Br == "string" ? Br.split("") : Br, Gr = Fr.length;
      k("alphabet", Fr);
      const qr = new Map(Fr.map((Hr, un) => [Hr, un]));
      return {
        encode: (Hr) => (b(Hr), Hr.map((un) => {
          if (!Number.isSafeInteger(un) || un < 0 || un >= Gr)
            throw new Error(`alphabet.encode: digit index outside alphabet "${un}". Allowed: ${Br}`);
          return Fr[un];
        })),
        decode: (Hr) => (b(Hr), Hr.map((un) => {
          l("alphabet.decode", un);
          const Dr = qr.get(un);
          if (Dr === void 0)
            throw new Error(`Unknown letter: "${un}". Allowed: ${Br}`);
          return Dr;
        }))
      };
    }
    // @__NO_SIDE_EFFECTS__
    function P(Br = "") {
      return l("join", Br), {
        encode: (Fr) => (k("join.decode", Fr), Fr.join(Br)),
        decode: (Fr) => (l("join.decode", Fr), Fr.split(Br))
      };
    }
    // @__NO_SIDE_EFFECTS__
    function x(Br, Fr = "=") {
      return m(Br), l("padding", Fr), {
        encode(Gr) {
          for (k("padding.encode", Gr); Gr.length * Br % 8; )
            Gr.push(Fr);
          return Gr;
        },
        decode(Gr) {
          k("padding.decode", Gr);
          let qr = Gr.length;
          if (qr * Br % 8)
            throw new Error("padding: invalid, string should have whole number of bytes");
          for (; qr > 0 && Gr[qr - 1] === Fr; qr--)
            if ((qr - 1) * Br % 8 === 0)
              throw new Error("padding: invalid, string has too much padding");
          return Gr.slice(0, qr);
        }
      };
    }
    // @__NO_SIDE_EFFECTS__
    function M(Br) {
      return t(Br), { encode: (Fr) => Fr, decode: (Fr) => Br(Fr) };
    }
    function F(Br, Fr, Gr) {
      if (Fr < 2)
        throw new Error(`convertRadix: invalid from=${Fr}, base cannot be less than 2`);
      if (Gr < 2)
        throw new Error(`convertRadix: invalid to=${Gr}, base cannot be less than 2`);
      if (b(Br), !Br.length)
        return [];
      let qr = 0;
      const Hr = [], un = Array.from(Br, (wr) => {
        if (m(wr), wr < 0 || wr >= Fr)
          throw new Error(`invalid integer: ${wr}`);
        return wr;
      }), Dr = un.length;
      for (; ; ) {
        let wr = 0, yr = !0;
        for (let Qr = qr; Qr < Dr; Qr++) {
          const _r = un[Qr], Jr = Fr * wr, fn = Jr + _r;
          if (!Number.isSafeInteger(fn) || Jr / Fr !== wr || fn - _r !== Jr)
            throw new Error("convertRadix: carry overflow");
          const jr = fn / Gr;
          wr = fn % Gr;
          const dn = Math.floor(jr);
          if (un[Qr] = dn, !Number.isSafeInteger(dn) || dn * Gr + wr !== fn)
            throw new Error("convertRadix: carry overflow");
          if (yr)
            dn ? yr = !1 : qr = Qr;
          else continue;
        }
        if (Hr.push(wr), yr)
          break;
      }
      for (let wr = 0; wr < Br.length - 1 && Br[wr] === 0; wr++)
        Hr.push(0);
      return Hr.reverse();
    }
    const le = (Br, Fr) => Fr === 0 ? Br : le(Fr, Br % Fr), ge = /* @__NO_SIDE_EFFECTS__ */ (Br, Fr) => Br + (Fr - le(Br, Fr)), pe = /* @__PURE__ */ (() => {
      let Br = [];
      for (let Fr = 0; Fr < 40; Fr++)
        Br.push(2 ** Fr);
      return Br;
    })();
    function Ie(Br, Fr, Gr, qr) {
      if (b(Br), Fr <= 0 || Fr > 32)
        throw new Error(`convertRadix2: wrong from=${Fr}`);
      if (Gr <= 0 || Gr > 32)
        throw new Error(`convertRadix2: wrong to=${Gr}`);
      if (/* @__PURE__ */ ge(Fr, Gr) > 32)
        throw new Error(`convertRadix2: carry overflow from=${Fr} to=${Gr} carryBits=${/* @__PURE__ */ ge(Fr, Gr)}`);
      let Hr = 0, un = 0;
      const Dr = pe[Fr], wr = pe[Gr] - 1, yr = [];
      for (const Qr of Br) {
        if (m(Qr), Qr >= Dr)
          throw new Error(`convertRadix2: invalid data word=${Qr} from=${Fr}`);
        if (Hr = Hr << Fr | Qr, un + Fr > 32)
          throw new Error(`convertRadix2: carry overflow pos=${un} from=${Fr}`);
        for (un += Fr; un >= Gr; un -= Gr)
          yr.push((Hr >> un - Gr & wr) >>> 0);
        const _r = pe[un];
        if (_r === void 0)
          throw new Error("invalid carry");
        Hr &= _r - 1;
      }
      if (Hr = Hr << Gr - un & wr, !qr && un >= Fr)
        throw new Error("Excess padding");
      if (!qr && Hr > 0)
        throw new Error(`Non-zero padding: ${Hr}`);
      return qr && un > 0 && yr.push(Hr >>> 0), yr;
    }
    // @__NO_SIDE_EFFECTS__
    function be(Br) {
      m(Br);
      const Fr = 2 ** 8;
      return {
        encode: (Gr) => {
          if (!A(Gr))
            throw new Error("radix.encode input should be Uint8Array");
          return F(Array.from(Gr), Fr, Br);
        },
        decode: (Gr) => (C("radix.decode", Gr), Uint8Array.from(F(Gr, Br, Fr)))
      };
    }
    // @__NO_SIDE_EFFECTS__
    function Pe(Br, Fr = !1) {
      if (m(Br), Br <= 0 || Br > 32)
        throw new Error("radix2: bits should be in (0..32]");
      if (/* @__PURE__ */ ge(8, Br) > 32 || /* @__PURE__ */ ge(Br, 8) > 32)
        throw new Error("radix2: carry overflow");
      return {
        encode: (Gr) => {
          if (!A(Gr))
            throw new Error("radix2.encode input should be Uint8Array");
          return Ie(Array.from(Gr), 8, Br, !Fr);
        },
        decode: (Gr) => (C("radix2.decode", Gr), Uint8Array.from(Ie(Gr, Br, 8, Fr)))
      };
    }
    function Te(Br) {
      return t(Br), function(...Fr) {
        try {
          return Br.apply(null, Fr);
        } catch {
        }
      };
    }
    function Qe(Br, Fr) {
      return m(Br), t(Fr), {
        encode(Gr) {
          if (!A(Gr))
            throw new Error("checksum.encode: input should be Uint8Array");
          const qr = Fr(Gr).slice(0, Br), Hr = new Uint8Array(Gr.length + Br);
          return Hr.set(Gr), Hr.set(qr, Gr.length), Hr;
        },
        decode(Gr) {
          if (!A(Gr))
            throw new Error("checksum.decode: input should be Uint8Array");
          const qr = Gr.slice(0, -Br), Hr = Gr.slice(-Br), un = Fr(qr).slice(0, Br);
          for (let Dr = 0; Dr < Br; Dr++)
            if (un[Dr] !== Hr[Dr])
              throw new Error("Invalid checksum");
          return qr;
        }
      };
    }
    s.utils = {
      alphabet: Q,
      chain: B,
      checksum: Qe,
      convertRadix: F,
      convertRadix2: Ie,
      radix: be,
      radix2: Pe,
      join: P,
      padding: x
    }, s.base16 = /* @__PURE__ */ B(/* @__PURE__ */ Pe(4), /* @__PURE__ */ Q("0123456789ABCDEF"), /* @__PURE__ */ P("")), s.base32 = /* @__PURE__ */ B(/* @__PURE__ */ Pe(5), /* @__PURE__ */ Q("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), /* @__PURE__ */ x(5), /* @__PURE__ */ P("")), s.base32nopad = /* @__PURE__ */ B(/* @__PURE__ */ Pe(5), /* @__PURE__ */ Q("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), /* @__PURE__ */ P("")), s.base32hex = /* @__PURE__ */ B(/* @__PURE__ */ Pe(5), /* @__PURE__ */ Q("0123456789ABCDEFGHIJKLMNOPQRSTUV"), /* @__PURE__ */ x(5), /* @__PURE__ */ P("")), s.base32hexnopad = /* @__PURE__ */ B(/* @__PURE__ */ Pe(5), /* @__PURE__ */ Q("0123456789ABCDEFGHIJKLMNOPQRSTUV"), /* @__PURE__ */ P("")), s.base32crockford = /* @__PURE__ */ B(/* @__PURE__ */ Pe(5), /* @__PURE__ */ Q("0123456789ABCDEFGHJKMNPQRSTVWXYZ"), /* @__PURE__ */ P(""), /* @__PURE__ */ M((Br) => Br.toUpperCase().replace(/O/g, "0").replace(/[IL]/g, "1")));
    const xe = typeof Uint8Array.from([]).toBase64 == "function" && typeof Uint8Array.fromBase64 == "function", Ee = (Br, Fr) => {
      l("base64", Br);
      const Gr = Fr ? /^[A-Za-z0-9=_-]+$/ : /^[A-Za-z0-9=+/]+$/, qr = Fr ? "base64url" : "base64";
      if (Br.length > 0 && !Gr.test(Br))
        throw new Error("invalid base64");
      return Uint8Array.fromBase64(Br, { alphabet: qr, lastChunkHandling: "strict" });
    };
    s.base64 = xe ? {
      encode(Br) {
        return u(Br), Br.toBase64();
      },
      decode(Br) {
        return Ee(Br, !1);
      }
    } : /* @__PURE__ */ B(/* @__PURE__ */ Pe(6), /* @__PURE__ */ Q("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), /* @__PURE__ */ x(6), /* @__PURE__ */ P("")), s.base64nopad = /* @__PURE__ */ B(/* @__PURE__ */ Pe(6), /* @__PURE__ */ Q("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), /* @__PURE__ */ P("")), s.base64url = xe ? {
      encode(Br) {
        return u(Br), Br.toBase64({ alphabet: "base64url" });
      },
      decode(Br) {
        return Ee(Br, !0);
      }
    } : /* @__PURE__ */ B(/* @__PURE__ */ Pe(6), /* @__PURE__ */ Q("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), /* @__PURE__ */ x(6), /* @__PURE__ */ P("")), s.base64urlnopad = /* @__PURE__ */ B(/* @__PURE__ */ Pe(6), /* @__PURE__ */ Q("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), /* @__PURE__ */ P(""));
    const He = /* @__NO_SIDE_EFFECTS__ */ (Br) => /* @__PURE__ */ B(/* @__PURE__ */ be(58), /* @__PURE__ */ Q(Br), /* @__PURE__ */ P(""));
    s.base58 = /* @__PURE__ */ He("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"), s.base58flickr = /* @__PURE__ */ He("123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"), s.base58xrp = /* @__PURE__ */ He("rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz");
    const ve = [0, 2, 3, 5, 6, 7, 9, 10, 11];
    s.base58xmr = {
      encode(Br) {
        let Fr = "";
        for (let Gr = 0; Gr < Br.length; Gr += 8) {
          const qr = Br.subarray(Gr, Gr + 8);
          Fr += s.base58.encode(qr).padStart(ve[qr.length], "1");
        }
        return Fr;
      },
      decode(Br) {
        let Fr = [];
        for (let Gr = 0; Gr < Br.length; Gr += 11) {
          const qr = Br.slice(Gr, Gr + 11), Hr = ve.indexOf(qr.length), un = s.base58.decode(qr);
          for (let Dr = 0; Dr < un.length - Hr; Dr++)
            if (un[Dr] !== 0)
              throw new Error("base58xmr: wrong padding");
          Fr = Fr.concat(Array.from(un.slice(un.length - Hr)));
        }
        return Uint8Array.from(Fr);
      }
    };
    const we = (Br) => /* @__PURE__ */ B(Qe(4, (Fr) => Br(Br(Fr))), s.base58);
    s.createBase58check = we, s.base58check = s.createBase58check;
    const Ce = /* @__PURE__ */ B(/* @__PURE__ */ Q("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), /* @__PURE__ */ P("")), Se = [996825010, 642813549, 513874426, 1027748829, 705979059];
    function Ne(Br) {
      const Fr = Br >> 25;
      let Gr = (Br & 33554431) << 5;
      for (let qr = 0; qr < Se.length; qr++)
        (Fr >> qr & 1) === 1 && (Gr ^= Se[qr]);
      return Gr;
    }
    function rr(Br, Fr, Gr = 1) {
      const qr = Br.length;
      let Hr = 1;
      for (let un = 0; un < qr; un++) {
        const Dr = Br.charCodeAt(un);
        if (Dr < 33 || Dr > 126)
          throw new Error(`Invalid prefix (${Br})`);
        Hr = Ne(Hr) ^ Dr >> 5;
      }
      Hr = Ne(Hr);
      for (let un = 0; un < qr; un++)
        Hr = Ne(Hr) ^ Br.charCodeAt(un) & 31;
      for (let un of Fr)
        Hr = Ne(Hr) ^ un;
      for (let un = 0; un < 6; un++)
        Hr = Ne(Hr);
      return Hr ^= Gr, Ce.encode(Ie([Hr % pe[30]], 30, 5, !1));
    }
    // @__NO_SIDE_EFFECTS__
    function er(Br) {
      const Fr = Br === "bech32" ? 1 : 734539939, Gr = /* @__PURE__ */ Pe(5), qr = Gr.decode, Hr = Gr.encode, un = Te(qr);
      function Dr(Jr, fn, jr = 90) {
        l("bech32.encode prefix", Jr), A(fn) && (fn = Array.from(fn)), C("bech32.encode", fn);
        const dn = Jr.length;
        if (dn === 0)
          throw new TypeError(`Invalid prefix length ${dn}`);
        const Tn = dn + 7 + fn.length;
        if (jr !== !1 && Tn > jr)
          throw new TypeError(`Length ${Tn} exceeds limit ${jr}`);
        const Yn = Jr.toLowerCase(), si = rr(Yn, fn, Fr);
        return `${Yn}1${Ce.encode(fn)}${si}`;
      }
      function wr(Jr, fn = 90) {
        l("bech32.decode input", Jr);
        const jr = Jr.length;
        if (jr < 8 || fn !== !1 && jr > fn)
          throw new TypeError(`invalid string length: ${jr} (${Jr}). Expected (8..${fn})`);
        const dn = Jr.toLowerCase();
        if (Jr !== dn && Jr !== Jr.toUpperCase())
          throw new Error("String must be lowercase or uppercase");
        const Tn = dn.lastIndexOf("1");
        if (Tn === 0 || Tn === -1)
          throw new Error('Letter "1" must be present between prefix and data only');
        const Yn = dn.slice(0, Tn), si = dn.slice(Tn + 1);
        if (si.length < 6)
          throw new Error("Data must be at least 6 characters long");
        const vn = Ce.decode(si).slice(0, -6), Cn = rr(Yn, vn, Fr);
        if (!si.endsWith(Cn))
          throw new Error(`Invalid checksum in ${Jr}: expected "${Cn}"`);
        return { prefix: Yn, words: vn };
      }
      const yr = Te(wr);
      function Qr(Jr) {
        const { prefix: fn, words: jr } = wr(Jr, !1);
        return { prefix: fn, words: jr, bytes: qr(jr) };
      }
      function _r(Jr, fn) {
        return Dr(Jr, Hr(fn));
      }
      return {
        encode: Dr,
        decode: wr,
        encodeFromBytes: _r,
        decodeToBytes: Qr,
        decodeUnsafe: yr,
        fromWords: qr,
        fromWordsUnsafe: un,
        toWords: Hr
      };
    }
    s.bech32 = /* @__PURE__ */ er("bech32"), s.bech32m = /* @__PURE__ */ er("bech32m"), s.utf8 = {
      encode: (Br) => new TextDecoder().decode(Br),
      decode: (Br) => new TextEncoder().encode(Br)
    };
    const ir = typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function", sr = {
      encode(Br) {
        return u(Br), Br.toHex();
      },
      decode(Br) {
        return l("hex", Br), Uint8Array.fromHex(Br);
      }
    };
    s.hex = ir ? sr : /* @__PURE__ */ B(/* @__PURE__ */ Pe(4), /* @__PURE__ */ Q("0123456789abcdef"), /* @__PURE__ */ P(""), /* @__PURE__ */ M((Br) => {
      if (typeof Br != "string" || Br.length % 2 !== 0)
        throw new TypeError(`hex.decode: expected string, got ${typeof Br} with length ${Br.length}`);
      return Br.toLowerCase();
    }));
    const nr = {
      utf8: s.utf8,
      hex: s.hex,
      base16: s.base16,
      base32: s.base32,
      base64: s.base64,
      base64url: s.base64url,
      base58: s.base58,
      base58xmr: s.base58xmr
    }, fr = "Invalid encoding type. Available types: utf8, hex, base16, base32, base64, base64url, base58, base58xmr", lr = (Br, Fr) => {
      if (typeof Br != "string" || !nr.hasOwnProperty(Br))
        throw new TypeError(fr);
      if (!A(Fr))
        throw new TypeError("bytesToString() expects Uint8Array");
      return nr[Br].encode(Fr);
    };
    s.bytesToString = lr, s.str = s.bytesToString;
    const br = (Br, Fr) => {
      if (!nr.hasOwnProperty(Br))
        throw new TypeError(fr);
      if (typeof Fr != "string")
        throw new TypeError("stringToBytes() expects string");
      return nr[Br].decode(Fr);
    };
    s.stringToBytes = br, s.bytes = s.stringToBytes;
  }(lib$2)), lib$2;
}
var wif, hasRequiredWif;
function requireWif() {
  if (hasRequiredWif) return wif;
  hasRequiredWif = 1;
  var s = requireBs58check();
  function A(l, m) {
    if (m !== void 0 && l[0] !== m) throw new Error("Invalid network version");
    if (l.length === 33)
      return {
        version: l[0],
        privateKey: l.slice(1, 33),
        compressed: !1
      };
    if (l.length !== 34) throw new Error("Invalid WIF length");
    if (l[33] !== 1) throw new Error("Invalid compression flag");
    return {
      version: l[0],
      privateKey: l.slice(1, 33),
      compressed: !0
    };
  }
  function u(l, m, b) {
    var k = new Buffer(b ? 34 : 33);
    return k.writeUInt8(l, 0), m.copy(k, 1), b && (k[33] = 1), k;
  }
  function p(l, m) {
    return A(s.decode(l), m);
  }
  function t(l, m, b) {
    return typeof l == "number" ? s.encode(u(l, m, b)) : s.encode(
      u(
        l.version,
        l.privateKey,
        l.compressed
      )
    );
  }
  return wif = {
    decode: p,
    decodeRaw: A,
    encode: t,
    encodeRaw: u
  }, wif;
}
var hasRequiredBip32$3;
function requireBip32$3() {
  if (hasRequiredBip32$3) return bip32$3;
  hasRequiredBip32$3 = 1, Object.defineProperty(bip32$3, "__esModule", { value: !0 }), bip32$3.BIP32Factory = void 0;
  const s = requireCrypto(), A = requireTestecc$1(), u = /* @__PURE__ */ requireLib$2(), p = /* @__PURE__ */ requireSha256$4(), t = requireTypeforce(), l = requireWif(), m = (0, u.base58check)(p.sha256), b = {
    encode: (C) => m.encode(Uint8Array.from(C)),
    decode: (C) => Buffer.from(m.decode(C))
  };
  function k(C) {
    (0, A.testEcc)(C);
    const B = t.BufferN(32), Q = t.compile({
      wif: t.UInt8,
      bip32: {
        public: t.UInt32,
        private: t.UInt32
      }
    }), P = {
      messagePrefix: `Bitcoin Signed Message:
`,
      bech32: "bc",
      bip32: {
        public: 76067358,
        private: 76066276
      },
      pubKeyHash: 0,
      scriptHash: 5,
      wif: 128
    }, x = 2147483648, M = Math.pow(2, 31) - 1;
    function F(He) {
      return t.String(He) && He.match(/^(m\/)?(\d+'?\/)*\d+'?$/) !== null;
    }
    function le(He) {
      return t.UInt32(He) && He <= M;
    }
    function ge(He) {
      return He.length === 32 ? He : He.slice(1, 33);
    }
    class pe {
      constructor(ve, we) {
        this.__D = ve, this.__Q = we, this.lowR = !1;
      }
      get publicKey() {
        return this.__Q === void 0 && (this.__Q = Buffer.from(C.pointFromScalar(this.__D, !0))), this.__Q;
      }
      get privateKey() {
        return this.__D;
      }
      sign(ve, we) {
        if (!this.privateKey)
          throw new Error("Missing private key");
        if (we === void 0 && (we = this.lowR), we === !1)
          return Buffer.from(C.sign(ve, this.privateKey));
        {
          let Ce = Buffer.from(C.sign(ve, this.privateKey));
          const Se = Buffer.alloc(32, 0);
          let Ne = 0;
          for (; Ce[0] > 127; )
            Ne++, Se.writeUIntLE(Ne, 0, 6), Ce = Buffer.from(C.sign(ve, this.privateKey, Se));
          return Ce;
        }
      }
      signSchnorr(ve) {
        if (!this.privateKey)
          throw new Error("Missing private key");
        if (!C.signSchnorr)
          throw new Error("signSchnorr not supported by ecc library");
        return Buffer.from(C.signSchnorr(ve, this.privateKey));
      }
      verify(ve, we) {
        return C.verify(ve, this.publicKey, we);
      }
      verifySchnorr(ve, we) {
        if (!C.verifySchnorr)
          throw new Error("verifySchnorr not supported by ecc library");
        return C.verifySchnorr(ve, this.publicKey.subarray(1, 33), we);
      }
    }
    class Ie extends pe {
      constructor(ve, we, Ce, Se, Ne = 0, rr = 0, er = 0) {
        super(ve, we), this.chainCode = Ce, this.network = Se, this.__DEPTH = Ne, this.__INDEX = rr, this.__PARENT_FINGERPRINT = er, t(Q, Se);
      }
      get depth() {
        return this.__DEPTH;
      }
      get index() {
        return this.__INDEX;
      }
      get parentFingerprint() {
        return this.__PARENT_FINGERPRINT;
      }
      get identifier() {
        return s.hash160(this.publicKey);
      }
      get fingerprint() {
        return this.identifier.slice(0, 4);
      }
      get compressed() {
        return !0;
      }
      // Private === not neutered
      // Public === neutered
      isNeutered() {
        return this.__D === void 0;
      }
      neutered() {
        return xe(this.publicKey, this.chainCode, this.network, this.depth, this.index, this.parentFingerprint);
      }
      toBase58() {
        const ve = this.network, we = this.isNeutered() ? ve.bip32.public : ve.bip32.private, Ce = Buffer.allocUnsafe(78);
        return Ce.writeUInt32BE(we, 0), Ce.writeUInt8(this.depth, 4), Ce.writeUInt32BE(this.parentFingerprint, 5), Ce.writeUInt32BE(this.index, 9), this.chainCode.copy(Ce, 13), this.isNeutered() ? this.publicKey.copy(Ce, 45) : (Ce.writeUInt8(0, 45), this.privateKey.copy(Ce, 46)), b.encode(Ce);
      }
      toWIF() {
        if (!this.privateKey)
          throw new TypeError("Missing private key");
        return l.encode(this.network.wif, this.privateKey, !0);
      }
      // https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki#child-key-derivation-ckd-functions
      derive(ve) {
        t(t.UInt32, ve);
        const we = ve >= x, Ce = Buffer.allocUnsafe(37);
        if (we) {
          if (this.isNeutered())
            throw new TypeError("Missing private key for hardened child key");
          Ce[0] = 0, this.privateKey.copy(Ce, 1), Ce.writeUInt32BE(ve, 33);
        } else
          this.publicKey.copy(Ce, 0), Ce.writeUInt32BE(ve, 33);
        const Se = s.hmacSHA512(this.chainCode, Ce), Ne = Se.slice(0, 32), rr = Se.slice(32);
        if (!C.isPrivate(Ne))
          return this.derive(ve + 1);
        let er;
        if (this.isNeutered()) {
          const ir = Buffer.from(C.pointAddScalar(this.publicKey, Ne, !0));
          if (ir === null)
            return this.derive(ve + 1);
          er = xe(ir, rr, this.network, this.depth + 1, ve, this.fingerprint.readUInt32BE(0));
        } else {
          const ir = Buffer.from(C.privateAdd(this.privateKey, Ne));
          if (ir == null)
            return this.derive(ve + 1);
          er = Te(ir, rr, this.network, this.depth + 1, ve, this.fingerprint.readUInt32BE(0));
        }
        return er;
      }
      deriveHardened(ve) {
        return t(le, ve), this.derive(ve + x);
      }
      derivePath(ve) {
        t(F, ve);
        let we = ve.split("/");
        if (we[0] === "m") {
          if (this.parentFingerprint)
            throw new TypeError("Expected master, got child");
          we = we.slice(1);
        }
        return we.reduce((Ce, Se) => {
          let Ne;
          return Se.slice(-1) === "'" ? (Ne = parseInt(Se.slice(0, -1), 10), Ce.deriveHardened(Ne)) : (Ne = parseInt(Se, 10), Ce.derive(Ne));
        }, this);
      }
      tweak(ve) {
        return this.privateKey ? this.tweakFromPrivateKey(ve) : this.tweakFromPublicKey(ve);
      }
      tweakFromPublicKey(ve) {
        const we = ge(this.publicKey);
        if (!C.xOnlyPointAddTweak)
          throw new Error("xOnlyPointAddTweak not supported by ecc library");
        const Ce = C.xOnlyPointAddTweak(we, ve);
        if (!Ce || Ce.xOnlyPubkey === null)
          throw new Error("Cannot tweak public key!");
        const Se = Buffer.from([
          Ce.parity === 0 ? 2 : 3
        ]), Ne = Buffer.concat([
          Se,
          Ce.xOnlyPubkey
        ]);
        return new pe(void 0, Ne);
      }
      tweakFromPrivateKey(ve) {
        const we = this.publicKey[0] === 3 || this.publicKey[0] === 4 && (this.publicKey[64] & 1) === 1, Ce = (() => {
          if (we) {
            if (C.privateNegate)
              return C.privateNegate(this.privateKey);
            throw new Error("privateNegate not supported by ecc library");
          } else return this.privateKey;
        })(), Se = C.privateAdd(Ce, ve);
        if (!Se)
          throw new Error("Invalid tweaked private key!");
        return new pe(Buffer.from(Se), void 0);
      }
    }
    function be(He, ve) {
      const we = b.decode(He);
      if (we.length !== 78)
        throw new TypeError("Invalid buffer length");
      ve = ve || P;
      const Ce = we.readUInt32BE(0);
      if (Ce !== ve.bip32.private && Ce !== ve.bip32.public)
        throw new TypeError("Invalid network version");
      const Se = we[4], Ne = we.readUInt32BE(5);
      if (Se === 0 && Ne !== 0)
        throw new TypeError("Invalid parent fingerprint");
      const rr = we.readUInt32BE(9);
      if (Se === 0 && rr !== 0)
        throw new TypeError("Invalid index");
      const er = we.slice(13, 45);
      let ir;
      if (Ce === ve.bip32.private) {
        if (we.readUInt8(45) !== 0)
          throw new TypeError("Invalid private key");
        const sr = we.slice(46, 78);
        ir = Te(sr, er, ve, Se, rr, Ne);
      } else {
        const sr = we.slice(45, 78);
        ir = xe(sr, er, ve, Se, rr, Ne);
      }
      return ir;
    }
    function Pe(He, ve, we) {
      return Te(He, ve, we);
    }
    function Te(He, ve, we, Ce, Se, Ne) {
      if (t({
        privateKey: B,
        chainCode: B
      }, { privateKey: He, chainCode: ve }), we = we || P, !C.isPrivate(He))
        throw new TypeError("Private key not in range [1, n)");
      return new Ie(He, void 0, ve, we, Ce, Se, Ne);
    }
    function Qe(He, ve, we) {
      return xe(He, ve, we);
    }
    function xe(He, ve, we, Ce, Se, Ne) {
      if (t({
        publicKey: t.BufferN(33),
        chainCode: B
      }, { publicKey: He, chainCode: ve }), we = we || P, !C.isPoint(He))
        throw new TypeError("Point is not on the curve");
      return new Ie(void 0, He, ve, we, Ce, Se, Ne);
    }
    function Ee(He, ve) {
      if (t(t.Buffer, He), He.length < 16)
        throw new TypeError("Seed should be at least 128 bits");
      if (He.length > 64)
        throw new TypeError("Seed should be at most 512 bits");
      ve = ve || P;
      const we = s.hmacSHA512(Buffer.from("Bitcoin seed", "utf8"), He), Ce = we.slice(0, 32), Se = we.slice(32);
      return Pe(Ce, Se, ve);
    }
    return {
      fromSeed: Ee,
      fromBase58: be,
      fromPublicKey: Qe,
      fromPrivateKey: Pe
    };
  }
  return bip32$3.BIP32Factory = k, bip32$3;
}
var hasRequiredSrc$1;
function requireSrc$1() {
  return hasRequiredSrc$1 || (hasRequiredSrc$1 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.BIP32Factory = s.default = void 0;
    var A = requireBip32$3();
    Object.defineProperty(s, "default", { enumerable: !0, get: function() {
      return A.BIP32Factory;
    } }), Object.defineProperty(s, "BIP32Factory", { enumerable: !0, get: function() {
      return A.BIP32Factory;
    } });
  }(src$1)), src$1;
}
var src = {}, ecpair = {}, networks = {}, hasRequiredNetworks;
function requireNetworks() {
  return hasRequiredNetworks || (hasRequiredNetworks = 1, Object.defineProperty(networks, "__esModule", { value: !0 }), networks.testnet = networks.bitcoin = void 0, networks.bitcoin = {
    messagePrefix: `Bitcoin Signed Message:
`,
    bech32: "bc",
    bip32: {
      public: 76067358,
      private: 76066276
    },
    pubKeyHash: 0,
    scriptHash: 5,
    wif: 128
  }, networks.testnet = {
    messagePrefix: `Bitcoin Signed Message:
`,
    bech32: "tb",
    bip32: {
      public: 70617039,
      private: 70615956
    },
    pubKeyHash: 111,
    scriptHash: 196,
    wif: 239
  }), networks;
}
var types$2 = {}, hasRequiredTypes$2;
function requireTypes$2() {
  return hasRequiredTypes$2 || (hasRequiredTypes$2 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.maybe = s.Boolean = s.Array = s.Buffer256bit = s.Network = s.typeforce = void 0, s.typeforce = requireTypeforce(), s.Network = s.typeforce.compile({
      messagePrefix: s.typeforce.oneOf(
        s.typeforce.Buffer,
        s.typeforce.String
      ),
      bip32: {
        public: s.typeforce.UInt32,
        private: s.typeforce.UInt32
      },
      pubKeyHash: s.typeforce.UInt8,
      scriptHash: s.typeforce.UInt8,
      wif: s.typeforce.UInt8
    }), s.Buffer256bit = s.typeforce.BufferN(32), s.Array = s.typeforce.Array, s.Boolean = s.typeforce.Boolean, s.maybe = s.typeforce.maybe;
  }(types$2)), types$2;
}
var testecc = {}, hasRequiredTestecc;
function requireTestecc() {
  if (hasRequiredTestecc) return testecc;
  hasRequiredTestecc = 1, Object.defineProperty(testecc, "__esModule", { value: !0 }), testecc.testEcc = void 0;
  const s = (p) => Buffer.from(p, "hex");
  function A(p) {
    u(
      p.isPoint(
        s("0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798")
      )
    ), u(
      !p.isPoint(
        s("030000000000000000000000000000000000000000000000000000000000000005")
      )
    ), u(
      p.isPrivate(
        s("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798")
      )
    ), u(
      p.isPrivate(
        s("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")
      )
    ), u(
      !p.isPrivate(
        s("0000000000000000000000000000000000000000000000000000000000000000")
      )
    ), u(
      !p.isPrivate(
        s("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141")
      )
    ), u(
      !p.isPrivate(
        s("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364142")
      )
    ), u(
      Buffer.from(
        p.privateAdd(
          s("0000000000000000000000000000000000000000000000000000000000000001"),
          s("0000000000000000000000000000000000000000000000000000000000000000")
        )
      ).equals(
        s("0000000000000000000000000000000000000000000000000000000000000001")
      )
    ), u(
      p.privateAdd(
        s("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd036413e"),
        s("0000000000000000000000000000000000000000000000000000000000000003")
      ) === null
    ), u(
      Buffer.from(
        p.privateAdd(
          s("e211078564db65c3ce7704f08262b1f38f1ef412ad15b5ac2d76657a63b2c500"),
          s("b51fbb69051255d1becbd683de5848242a89c229348dd72896a87ada94ae8665")
        )
      ).equals(
        s("9730c2ee69edbb958d42db7460bafa18fef9d955325aec99044c81c8282b0a24")
      )
    ), u(
      Buffer.from(
        p.privateNegate(
          s("0000000000000000000000000000000000000000000000000000000000000001")
        )
      ).equals(
        s("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")
      )
    ), u(
      Buffer.from(
        p.privateNegate(
          s("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd036413e")
        )
      ).equals(
        s("0000000000000000000000000000000000000000000000000000000000000003")
      )
    ), u(
      Buffer.from(
        p.privateNegate(
          s("b1121e4088a66a28f5b6b0f5844943ecd9f610196d7bb83b25214b60452c09af")
        )
      ).equals(
        s("4eede1bf775995d70a494f0a7bb6bc11e0b8cccd41cce8009ab1132c8b0a3792")
      )
    ), u(
      Buffer.from(
        p.pointCompress(
          s(
            "0479be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8"
          ),
          !0
        )
      ).equals(
        s("0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798")
      )
    ), u(
      Buffer.from(
        p.pointCompress(
          s(
            "0479be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8"
          ),
          !1
        )
      ).equals(
        s(
          "0479be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8"
        )
      )
    ), u(
      Buffer.from(
        p.pointCompress(
          s("0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"),
          !0
        )
      ).equals(
        s("0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798")
      )
    ), u(
      Buffer.from(
        p.pointCompress(
          s("0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"),
          !1
        )
      ).equals(
        s(
          "0479be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8"
        )
      )
    ), u(
      Buffer.from(
        p.pointFromScalar(
          s("b1121e4088a66a28f5b6b0f5844943ecd9f610196d7bb83b25214b60452c09af")
        )
      ).equals(
        s("02b07ba9dca9523b7ef4bd97703d43d20399eb698e194704791a25ce77a400df99")
      )
    ), u(
      p.xOnlyPointAddTweak(
        s("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"),
        s("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")
      ) === null
    );
    let t = p.xOnlyPointAddTweak(
      s("1617d38ed8d8657da4d4761e8057bc396ea9e4b9d29776d4be096016dbd2509b"),
      s("a8397a935f0dfceba6ba9618f6451ef4d80637abf4e6af2669fbc9de6a8fd2ac")
    );
    u(
      Buffer.from(t.xOnlyPubkey).equals(
        s("e478f99dab91052ab39a33ea35fd5e6e4933f4d28023cd597c9a1f6760346adf")
      ) && t.parity === 1
    ), t = p.xOnlyPointAddTweak(
      s("2c0b7cf95324a07d05398b240174dc0c2be444d96b159aa6c7f7b1e668680991"),
      s("823c3cd2142744b075a87eade7e1b8678ba308d566226a0056ca2b7a76f86b47")
    ), u(
      Buffer.from(t.xOnlyPubkey).equals(
        s("9534f8dc8c6deda2dc007655981c78b49c5d96c778fbf363462a11ec9dfd948c")
      ) && t.parity === 0
    ), u(
      Buffer.from(
        p.sign(
          s("5e9f0a0d593efdcf78ac923bc3313e4e7d408d574354ee2b3288c0da9fbba6ed"),
          s("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")
        )
      ).equals(
        s(
          "54c4a33c6423d689378f160a7ff8b61330444abb58fb470f96ea16d99d4a2fed07082304410efa6b2943111b6a4e0aaa7b7db55a07e9861d1fb3cb1f421044a5"
        )
      )
    ), u(
      p.verify(
        s("5e9f0a0d593efdcf78ac923bc3313e4e7d408d574354ee2b3288c0da9fbba6ed"),
        s("0379be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"),
        s(
          "54c4a33c6423d689378f160a7ff8b61330444abb58fb470f96ea16d99d4a2fed07082304410efa6b2943111b6a4e0aaa7b7db55a07e9861d1fb3cb1f421044a5"
        )
      )
    ), p.signSchnorr && u(
      Buffer.from(
        p.signSchnorr(
          s("7e2d58d8b3bcdf1abadec7829054f90dda9805aab56c77333024b9d0a508b75c"),
          s("c90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b14e5c9"),
          s("c87aa53824b4d7ae2eb035a2b5bbbccc080e76cdc6d1692c4b0b62d798e6d906")
        )
      ).equals(
        s(
          "5831aaeed7b44bb74e5eab94ba9d4294c49bcf2a60728d8b4c200f50dd313c1bab745879a5ad954a72c45a91c3a51d3c7adea98d82f8481e0e1e03674a6f3fb7"
        )
      )
    ), p.verifySchnorr && u(
      p.verifySchnorr(
        s("7e2d58d8b3bcdf1abadec7829054f90dda9805aab56c77333024b9d0a508b75c"),
        s("dd308afec5777e13121fa72b9cc1b7cc0139715309b086c960e18fd969774eb8"),
        s(
          "5831aaeed7b44bb74e5eab94ba9d4294c49bcf2a60728d8b4c200f50dd313c1bab745879a5ad954a72c45a91c3a51d3c7adea98d82f8481e0e1e03674a6f3fb7"
        )
      )
    );
  }
  testecc.testEcc = A;
  function u(p) {
    if (!p) throw new Error("ecc library invalid");
  }
  return testecc;
}
var hasRequiredEcpair;
function requireEcpair() {
  if (hasRequiredEcpair) return ecpair;
  hasRequiredEcpair = 1, Object.defineProperty(ecpair, "__esModule", { value: !0 }), ecpair.ECPairFactory = ecpair.networks = void 0;
  const s = requireNetworks();
  ecpair.networks = s;
  const A = requireTypes$2(), u = requireBrowser$9(), p = requireWif(), t = requireTestecc(), l = A.typeforce.maybe(
    A.typeforce.compile({
      compressed: A.maybe(A.Boolean),
      network: A.maybe(A.Network)
    })
  ), m = (k) => k.length === 32 ? k : k.slice(1, 33);
  function b(k) {
    (0, t.testEcc)(k);
    function C(F) {
      return k.isPoint(F);
    }
    function B(F, le) {
      if (A.typeforce(A.Buffer256bit, F), !k.isPrivate(F))
        throw new TypeError("Private key not in range [1, n)");
      return A.typeforce(l, le), new M(F, void 0, le);
    }
    function Q(F, le) {
      return A.typeforce(k.isPoint, F), A.typeforce(l, le), new M(void 0, F, le);
    }
    function P(F, le) {
      const ge = p.decode(F), pe = ge.version;
      if (A.Array(le)) {
        if (le = le.filter((Ie) => pe === Ie.wif).pop(), !le) throw new Error("Unknown network version");
      } else if (le = le || s.bitcoin, pe !== le.wif) throw new Error("Invalid network version");
      return B(ge.privateKey, {
        compressed: ge.compressed,
        network: le
      });
    }
    function x(F) {
      A.typeforce(l, F), F === void 0 && (F = {});
      const le = F.rng || u;
      let ge;
      do
        ge = le(32), A.typeforce(A.Buffer256bit, ge);
      while (!k.isPrivate(ge));
      return B(ge, F);
    }
    class M {
      constructor(le, ge, pe) {
        Ci(this, "__D");
        Ci(this, "__Q");
        Ci(this, "compressed");
        Ci(this, "network");
        Ci(this, "lowR");
        this.__D = le, this.__Q = ge, this.lowR = !1, pe === void 0 && (pe = {}), this.compressed = pe.compressed === void 0 ? !0 : pe.compressed, this.network = pe.network || s.bitcoin, ge !== void 0 && (this.__Q = Buffer.from(k.pointCompress(ge, this.compressed)));
      }
      get privateKey() {
        return this.__D;
      }
      get publicKey() {
        if (!this.__Q) {
          const le = k.pointFromScalar(this.__D, this.compressed);
          this.__Q = Buffer.from(le);
        }
        return this.__Q;
      }
      toWIF() {
        if (!this.__D) throw new Error("Missing private key");
        return p.encode(this.network.wif, this.__D, this.compressed);
      }
      tweak(le) {
        return this.privateKey ? this.tweakFromPrivateKey(le) : this.tweakFromPublicKey(le);
      }
      sign(le, ge) {
        if (!this.__D) throw new Error("Missing private key");
        if (ge === void 0 && (ge = this.lowR), ge === !1)
          return Buffer.from(k.sign(le, this.__D));
        {
          let pe = k.sign(le, this.__D);
          const Ie = Buffer.alloc(32, 0);
          let be = 0;
          for (; pe[0] > 127; )
            be++, Ie.writeUIntLE(be, 0, 6), pe = k.sign(le, this.__D, Ie);
          return Buffer.from(pe);
        }
      }
      signSchnorr(le) {
        if (!this.privateKey) throw new Error("Missing private key");
        if (!k.signSchnorr)
          throw new Error("signSchnorr not supported by ecc library");
        return Buffer.from(k.signSchnorr(le, this.privateKey));
      }
      verify(le, ge) {
        return k.verify(le, this.publicKey, ge);
      }
      verifySchnorr(le, ge) {
        if (!k.verifySchnorr)
          throw new Error("verifySchnorr not supported by ecc library");
        return k.verifySchnorr(le, this.publicKey.subarray(1, 33), ge);
      }
      tweakFromPublicKey(le) {
        const ge = m(this.publicKey), pe = k.xOnlyPointAddTweak(ge, le);
        if (!pe || pe.xOnlyPubkey === null)
          throw new Error("Cannot tweak public key!");
        const Ie = Buffer.from([
          pe.parity === 0 ? 2 : 3
        ]);
        return Q(
          Buffer.concat([Ie, pe.xOnlyPubkey]),
          { network: this.network, compressed: this.compressed }
        );
      }
      tweakFromPrivateKey(le) {
        const pe = this.publicKey[0] === 3 || this.publicKey[0] === 4 && (this.publicKey[64] & 1) === 1 ? k.privateNegate(this.privateKey) : this.privateKey, Ie = k.privateAdd(pe, le);
        if (!Ie) throw new Error("Invalid tweaked private key!");
        return B(Buffer.from(Ie), {
          network: this.network,
          compressed: this.compressed
        });
      }
    }
    return {
      isPoint: C,
      fromPrivateKey: B,
      fromPublicKey: Q,
      fromWIF: P,
      makeRandom: x
    };
  }
  return ecpair.ECPairFactory = b, ecpair;
}
var hasRequiredSrc;
function requireSrc() {
  return hasRequiredSrc || (hasRequiredSrc = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.networks = s.ECPairFactory = s.default = void 0;
    var A = requireEcpair();
    Object.defineProperty(s, "default", {
      enumerable: !0,
      get: function() {
        return A.ECPairFactory;
      }
    }), Object.defineProperty(s, "ECPairFactory", {
      enumerable: !0,
      get: function() {
        return A.ECPairFactory;
      }
    }), Object.defineProperty(s, "networks", {
      enumerable: !0,
      get: function() {
        return A.networks;
      }
    });
  }(src)), src;
}
var psbt$2 = {}, hasRequiredPsbt$2;
function requirePsbt$2() {
  if (hasRequiredPsbt$2) return psbt$2;
  hasRequiredPsbt$2 = 1;
  var s = psbt$2 && psbt$2.__createBinding || (Object.create ? function(C, B, Q, P) {
    P === void 0 && (P = Q);
    var x = Object.getOwnPropertyDescriptor(B, Q);
    (!x || ("get" in x ? !B.__esModule : x.writable || x.configurable)) && (x = { enumerable: !0, get: function() {
      return B[Q];
    } }), Object.defineProperty(C, P, x);
  } : function(C, B, Q, P) {
    P === void 0 && (P = Q), C[P] = B[Q];
  }), A = psbt$2 && psbt$2.__setModuleDefault || (Object.create ? function(C, B) {
    Object.defineProperty(C, "default", { enumerable: !0, value: B });
  } : function(C, B) {
    C.default = B;
  }), u = psbt$2 && psbt$2.__importStar || function(C) {
    if (C && C.__esModule) return C;
    var B = {};
    if (C != null) for (var Q in C) Q !== "default" && Object.prototype.hasOwnProperty.call(C, Q) && s(B, C, Q);
    return A(B, C), B;
  };
  Object.defineProperty(psbt$2, "__esModule", { value: !0 }), psbt$2.updatePsbt = psbt$2.finalScriptsFuncFactory = void 0;
  const p = requireSrc$3(), t = u(requireVarint$4());
  function l(C) {
    if (C.length < 1)
      return C;
    let B = C.length - 1, Q = 0;
    for (let P = 0; P < C.length / 2; P++)
      Q = C[P], C[P] = C[B], C[B] = Q, B--;
    return C;
  }
  function m(C) {
    let B = Buffer.allocUnsafe(0);
    function Q(F) {
      B = Buffer.concat([B, Buffer.from(F)]);
    }
    function P(F) {
      const le = B.length, ge = t.encodingLength(F);
      B = Buffer.concat([B, Buffer.allocUnsafe(ge)]), t.encode(F, B, le);
    }
    function x(F) {
      P(F.length), Q(F);
    }
    function M(F) {
      P(F.length), F.forEach(x);
    }
    return M(C), B;
  }
  function b(C, B) {
    return (P, x, M, F, le, ge) => {
      let pe, Ie;
      if (F && !le) {
        const be = p.payments.p2wsh({
          redeem: { input: C, output: M },
          network: B
        });
        if (!be.witness)
          throw new Error("Error: p2wsh failed producing a witness");
        pe = m(be.witness);
      } else if (F && le) {
        const be = p.payments.p2sh({
          redeem: p.payments.p2wsh({
            redeem: { input: C, output: M },
            network: B
          }),
          network: B
        });
        if (!be.witness)
          throw new Error("Error: p2sh-p2wsh failed producing a witness");
        pe = m(be.witness), Ie = be.input;
      } else
        Ie = p.payments.p2sh({
          redeem: { input: C, output: M },
          network: B
        }).input;
      return {
        finalScriptWitness: pe,
        finalScriptSig: Ie
      };
    };
  }
  psbt$2.finalScriptsFuncFactory = b;
  function k({ psbt: C, vout: B, txHex: Q, txId: P, value: x, sequence: M, locktime: F, keysInfo: le, scriptPubKey: ge, isSegwit: pe, witnessScript: Ie, redeemScript: be }) {
    var Qe;
    if (!pe && Q === void 0)
      throw new Error("Error: txHex is mandatory for Non-Segwit inputs");
    if (pe && Q === void 0 && (P === void 0 || x === void 0))
      throw new Error("Error: pass txHex or txId+value for Segwit inputs");
    if (Q !== void 0) {
      const xe = p.Transaction.fromHex(Q), Ee = (Qe = xe == null ? void 0 : xe.outs) == null ? void 0 : Qe[B];
      if (!Ee)
        throw new Error(`Error: tx ${Q} does not have vout ${B}`);
      const He = Ee.script;
      if (!He)
        throw new Error(`Error: could not extract outputScript for txHex ${Q} and vout ${B}`);
      if (Buffer.compare(He, ge) !== 0)
        throw new Error(`Error: txHex ${Q} for vout ${B} does not correspond to scriptPubKey ${ge}`);
      if (P !== void 0) {
        if (xe.getId() !== P)
          throw new Error(`Error: txId for ${Q} and vout ${B} does not correspond to ${P}`);
      } else
        P = xe.getId();
      if (x !== void 0) {
        if (Ee.value !== x)
          throw new Error(`Error: value for ${Q} and vout ${B} does not correspond to ${x}`);
      } else
        x = Ee.value;
    }
    if (P === void 0 || !x)
      throw new Error("Error: txHex+vout required. Alternatively, but ONLY for Segwit inputs, txId+value can also be passed.");
    if (F) {
      if (C.locktime && C.locktime !== F)
        throw new Error(`Error: transaction locktime was already set with a different value: ${F} != ${C.locktime}`);
      if (M === void 0)
        M = 4294967294;
      else if (M > 4294967294)
        throw new Error(`Error: incompatible sequence: ${M} and locktime: ${F}`);
      C.setLocktime(F);
    }
    const Pe = {
      hash: l(Buffer.from(P, "hex")),
      index: B
    };
    Q !== void 0 && (Pe.nonWitnessUtxo = p.Transaction.fromHex(Q).toBuffer());
    const Te = le.filter((xe) => xe.pubkey && xe.masterFingerprint && xe.path).map((xe) => {
      const Ee = xe.pubkey;
      if (!Ee)
        throw new Error(`key ${xe.keyExpression} missing pubkey`);
      return {
        masterFingerprint: xe.masterFingerprint,
        pubkey: Ee,
        path: xe.path
      };
    });
    return Te.length && (Pe.bip32Derivation = Te), pe && Q !== void 0 && (Pe.witnessUtxo = { script: ge, value: x }), M !== void 0 && (Pe.sequence = M), Ie && (Pe.witnessScript = Ie), be && (Pe.redeemScript = be), C.addInput(Pe), C.data.inputs.length - 1;
  }
  return psbt$2.updatePsbt = k, psbt$2;
}
var checksum = {}, hasRequiredChecksum;
function requireChecksum() {
  return hasRequiredChecksum || (hasRequiredChecksum = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.DescriptorChecksum = s.CHECKSUM_CHARSET = void 0;
    const A = (p, t) => {
      const l = p >> 35n;
      return p = (p & 0x7ffffffffn) << 5n ^ t, l & 1n && (p ^= 0xf5dee51989n), l & 2n && (p ^= 0xa9fdca3312n), l & 4n && (p ^= 0x1bab10e32dn), l & 8n && (p ^= 0x3706b1677an), l & 16n && (p ^= 0x644d626ffdn), p;
    };
    s.CHECKSUM_CHARSET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
    const u = (p) => {
      const t = "0123456789()[],'/*abcdefgh@:$%{}IJKLMNOPQRSTUVWXYZ&+-.;<=>?!^_|~ijklmnopqrstuvwxyzABCDEFGH`#\"\\ ";
      let l = 1n, m = 0n, b = 0n;
      for (const C of p) {
        const B = BigInt(t.indexOf(C));
        if (B === -1n)
          return "";
        l = A(l, B & 31n), m = m * 3n + (B >> 5n), ++b === 3n && (l = A(l, m), m = 0n, b = 0n);
      }
      b > 0n && (l = A(l, m));
      for (let C = 0; C < 8; ++C)
        l = A(l, 0n);
      l ^= 1n;
      let k = "";
      for (let C = 0; C < 8; ++C) {
        const B = l >> 5n * (7n - BigInt(C)) & 31n;
        if (B < 0 || B > Number.MAX_SAFE_INTEGER)
          throw new Error(`Error: could not compute checksum, invalid index ${B}`);
        k += s.CHECKSUM_CHARSET[Number(B)];
      }
      return k;
    };
    s.DescriptorChecksum = u;
  }(checksum)), checksum;
}
var keyExpressions = {}, ledger = {}, re = {}, hasRequiredRe;
function requireRe() {
  return hasRequiredRe || (hasRequiredRe = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.reWshMiniscriptAnchored = s.reShWshMiniscriptAnchored = s.reShMiniscriptAnchored = s.reShWpkhAnchored = s.reWpkhAnchored = s.rePkhAnchored = s.reAddrAnchored = s.rePkAnchored = s.anchorStartAndEnd = s.reKeyExp = s.reXprvKey = s.reXpubKey = s.rePath = s.reXprv = s.reXpub = s.reWIF = s.rePubKey = s.reChecksum = s.reOrigin = s.reMasterFingerprint = s.reOriginPath = void 0;
    const A = requireChecksum(), u = String.raw`(['hH])`, p = String.raw`(\d+${u}?)`, t = String.raw`(${p}\/)`;
    s.reOriginPath = String.raw`(\/${t}*${p})`, s.reMasterFingerprint = String.raw`[0-9a-fA-F]{8}`, s.reOrigin = String.raw`(\[${s.reMasterFingerprint}(${s.reOriginPath})?\])`, s.reChecksum = String.raw`(#[${A.CHECKSUM_CHARSET}]{8})`;
    const l = String.raw`((02|03)[0-9a-fA-F]{64})`, m = String.raw`(04[0-9a-fA-F]{128})`;
    s.rePubKey = String.raw`(${l}|${m})`, s.reWIF = String.raw`([5KLc9][1-9A-HJ-NP-Za-km-z]{50,51})`, s.reXpub = String.raw`([xXtT]pub[1-9A-HJ-NP-Za-km-z]{79,108})`, s.reXprv = String.raw`([xXtT]prv[1-9A-HJ-NP-Za-km-z]{79,108})`;
    const b = String.raw`(\*(${u})?)`;
    s.rePath = String.raw`(\/(${t})*(${b}|${p}))`, s.reXpubKey = String.raw`(${s.reXpub})(${s.rePath})?`, s.reXprvKey = String.raw`(${s.reXprv})(${s.rePath})?`;
    const k = String.raw`(${s.reXpubKey}|${s.reXprvKey}|${s.rePubKey}|${s.reWIF})`;
    s.reKeyExp = String.raw`(${s.reOrigin})?(${k})`;
    const C = String.raw`pk\((.*?)\)`, B = String.raw`addr\((.*?)\)`, Q = String.raw`pkh\(${s.reKeyExp}\)`, P = String.raw`wpkh\(${s.reKeyExp}\)`, x = String.raw`sh\(wpkh\(${s.reKeyExp}\)\)`, M = String.raw`(.*?)`, F = (be) => String.raw`sh\(${be}\)`, le = (be) => String.raw`wsh\(${be}\)`, ge = (be) => F(le(be)), pe = (be) => String.raw`^${be}$`;
    s.anchorStartAndEnd = pe;
    const Ie = (be) => String.raw`${be}(${s.reChecksum})?`;
    s.rePkAnchored = (0, s.anchorStartAndEnd)(Ie(C)), s.reAddrAnchored = (0, s.anchorStartAndEnd)(Ie(B)), s.rePkhAnchored = (0, s.anchorStartAndEnd)(Ie(Q)), s.reWpkhAnchored = (0, s.anchorStartAndEnd)(Ie(P)), s.reShWpkhAnchored = (0, s.anchorStartAndEnd)(Ie(x)), s.reShMiniscriptAnchored = (0, s.anchorStartAndEnd)(Ie(F(M))), s.reShWshMiniscriptAnchored = (0, s.anchorStartAndEnd)(Ie(ge(M))), s.reWshMiniscriptAnchored = (0, s.anchorStartAndEnd)(Ie(le(M)));
  }(re)), re;
}
var main$2 = {}, appClient$1 = {}, bip32$2 = {}, bip32Path, hasRequiredBip32Path;
function requireBip32Path() {
  if (hasRequiredBip32Path) return bip32Path;
  hasRequiredBip32Path = 1;
  const s = 2147483648;
  var A = function(u) {
    if (!Array.isArray(u))
      throw new Error("Input must be an Array");
    if (u.length === 0)
      throw new Error("Path must contain at least one level");
    for (var p = 0; p < u.length; p++)
      if (typeof u[p] != "number")
        throw new Error("Path element is not a number");
    this.path = u;
  };
  return A.validatePathArray = function(u) {
    try {
      return A.fromPathArray(u), !0;
    } catch {
      return !1;
    }
  }, A.validateString = function(u, p) {
    try {
      return A.fromString(u, p), !0;
    } catch {
      return !1;
    }
  }, A.fromPathArray = function(u) {
    return new A(u);
  }, A.fromString = function(u, p) {
    if (/^m\//i.test(u))
      u = u.slice(2);
    else if (p)
      throw new Error("Root element is required");
    for (var t = u.split("/"), l = new Array(t.length), m = 0; m < t.length; m++) {
      var b = /(\d+)([hH\']?)/.exec(t[m]);
      if (b === null)
        throw new Error("Invalid input");
      if (l[m] = parseInt(b[1], 10), l[m] >= s)
        throw new Error("Invalid child index");
      if (b[2] === "h" || b[2] === "H" || b[2] === "'")
        l[m] += s;
      else if (b[2].length != 0)
        throw new Error("Invalid modifier");
    }
    return new A(l);
  }, A.prototype.toPathArray = function() {
    return this.path;
  }, A.prototype.toString = function(u, p) {
    for (var t = new Array(this.path.length), l = 0; l < this.path.length; l++) {
      var m = this.path[l];
      m & s ? t[l] = (m & ~s) + (p ? "h" : "'") : t[l] = m;
    }
    return (u ? "" : "m/") + t.join("/");
  }, A.prototype.inspect = function() {
    return "BIPPath <" + this.toString() + ">";
  }, bip32Path = A, bip32Path;
}
var hasRequiredBip32$2;
function requireBip32$2() {
  if (hasRequiredBip32$2) return bip32$2;
  hasRequiredBip32$2 = 1;
  var s = bip32$2 && bip32$2.__importDefault || function(B) {
    return B && B.__esModule ? B : { default: B };
  };
  Object.defineProperty(bip32$2, "__esModule", { value: !0 }), bip32$2.hardenedPathOf = bip32$2.getXpubComponents = bip32$2.pubkeyFromXpub = bip32$2.pathStringToArray = bip32$2.pathArrayToString = bip32$2.bip32asBuffer = bip32$2.pathElementsToBuffer = void 0;
  const A = s(requireBip32Path()), u = s(requireBs58check$1());
  function p(B) {
    const Q = Buffer.alloc(1 + B.length * 4);
    return Q[0] = B.length, B.forEach((P, x) => {
      Q.writeUInt32BE(P, 1 + 4 * x);
    }), Q;
  }
  bip32$2.pathElementsToBuffer = p;
  function t(B) {
    const Q = B ? m(B) : [];
    return p(Q);
  }
  bip32$2.bip32asBuffer = t;
  function l(B) {
    return B.length == 0 ? "m" : A.default.fromPathArray(B).toString();
  }
  bip32$2.pathArrayToString = l;
  function m(B) {
    return B == "m" || B == "" ? [] : A.default.fromString(B).toPathArray();
  }
  bip32$2.pathStringToArray = m;
  function b(B) {
    const Q = u.default.decode(B);
    return Q.slice(Q.length - 33);
  }
  bip32$2.pubkeyFromXpub = b;
  function k(B) {
    const Q = u.default.decode(B);
    return {
      chaincode: Q.slice(13, 45),
      pubkey: Q.slice(Q.length - 33),
      version: Q.readUInt32BE(0)
    };
  }
  bip32$2.getXpubComponents = k;
  function C(B) {
    for (let Q = B.length - 1; Q >= 0; Q--)
      if (B[Q] >= 2147483648)
        return B.slice(0, Q + 1);
    return [];
  }
  return bip32$2.hardenedPathOf = C, bip32$2;
}
var clientCommands$2 = {}, buffertools$2 = {}, varint$2 = {}, hasRequiredVarint$2;
function requireVarint$2() {
  if (hasRequiredVarint$2) return varint$2;
  hasRequiredVarint$2 = 1, Object.defineProperty(varint$2, "__esModule", { value: !0 }), varint$2.createVarint = varint$2.parseVarint = varint$2.sanitizeBigintToNumber = void 0;
  function s(m, b, k, C) {
    for (let B = 0; B < b; B++) {
      if (k[B + C] == null)
        throw Error("Buffer too small");
      k[B + C] = Number(m % BigInt(256)), m = m >> BigInt(8);
    }
  }
  function A(m, b, k) {
    let C = BigInt(0);
    for (let B = 0; B < k; B++) {
      if (m[B + b] == null)
        throw Error("Buffer too small");
      C += BigInt(m[B + b]) << BigInt(B * 8);
    }
    return C;
  }
  function u(m) {
    if (m < 0)
      throw RangeError("Negative bigint is not a valid varint");
    if (m > Number.MAX_SAFE_INTEGER)
      throw RangeError("Too large for a Number");
    return Number(m);
  }
  varint$2.sanitizeBigintToNumber = u;
  function p(m) {
    if (typeof m == "number" && (m = u(m)), m < BigInt(0))
      throw new RangeError("Negative numbers are not supported");
    if (m >= BigInt(1) << BigInt(64))
      throw new RangeError("Too large for a Bitcoin-style varint");
    return m < BigInt(253) ? 1 : m <= BigInt(65535) ? 3 : m <= BigInt(4294967295) ? 5 : 9;
  }
  function t(m, b) {
    if (b < 0)
      throw RangeError("Negative offset is invalid");
    if (m[b] == null)
      throw Error("Buffer too small");
    if (m[b] < 253)
      return [BigInt(m[b]), 1];
    {
      let k;
      return m[b] === 253 ? k = 2 : m[b] === 254 ? k = 4 : k = 8, [A(m, b + 1, k), k + 1];
    }
  }
  varint$2.parseVarint = t;
  function l(m) {
    typeof m == "number" && (m = u(m));
    const b = p(m);
    m = BigInt(m);
    const k = Buffer.alloc(b);
    return b == 1 ? k[0] = Number(m) : (b == 3 ? k[0] = 253 : b === 5 ? k[0] = 254 : k[0] = 255, s(m, b - 1, k, 1)), k;
  }
  return varint$2.createVarint = l, varint$2;
}
var hasRequiredBuffertools$2;
function requireBuffertools$2() {
  if (hasRequiredBuffertools$2) return buffertools$2;
  hasRequiredBuffertools$2 = 1, Object.defineProperty(buffertools$2, "__esModule", { value: !0 }), buffertools$2.BufferReader = buffertools$2.BufferWriter = buffertools$2.unsafeFrom64bitLE = buffertools$2.unsafeTo64bitLE = void 0;
  const s = requireVarint$2();
  function A(l) {
    if (l > Number.MAX_SAFE_INTEGER)
      throw new Error("Can't convert numbers > MAX_SAFE_INT");
    const m = Buffer.alloc(8, 0);
    for (let b = 0; b < m.length; b++) {
      const k = l & 255;
      m[b] = k, l = (l - k) / 256;
    }
    return m;
  }
  buffertools$2.unsafeTo64bitLE = A;
  function u(l) {
    let m = 0;
    if (l.length != 8)
      throw new Error("Expected Bufffer of lenght 8");
    if (l[7] != 0)
      throw new Error("Can't encode numbers > MAX_SAFE_INT");
    if (l[6] > 31)
      throw new Error("Can't encode numbers > MAX_SAFE_INT");
    for (let b = l.length - 1; b >= 0; b--)
      m = m * 256 + l[b];
    return m;
  }
  buffertools$2.unsafeFrom64bitLE = u;
  class p {
    constructor() {
      this.bufs = [];
    }
    write(m, b) {
      const k = Buffer.alloc(m);
      b(k), this.bufs.push(k);
    }
    writeUInt8(m) {
      this.write(1, (b) => b.writeUInt8(m, 0));
    }
    writeInt32(m) {
      this.write(4, (b) => b.writeInt32LE(m, 0));
    }
    writeUInt32(m) {
      this.write(4, (b) => b.writeUInt32LE(m, 0));
    }
    writeUInt64(m) {
      const b = A(m);
      this.writeSlice(b);
    }
    writeVarInt(m) {
      this.bufs.push((0, s.createVarint)(m));
    }
    writeSlice(m) {
      this.bufs.push(Buffer.from(m));
    }
    writeVarSlice(m) {
      this.writeVarInt(m.length), this.writeSlice(m);
    }
    buffer() {
      return Buffer.concat(this.bufs);
    }
  }
  buffertools$2.BufferWriter = p;
  class t {
    constructor(m, b = 0) {
      this.buffer = m, this.offset = b;
    }
    available() {
      return this.buffer.length - this.offset;
    }
    readUInt8() {
      const m = this.buffer.readUInt8(this.offset);
      return this.offset++, m;
    }
    readInt32() {
      const m = this.buffer.readInt32LE(this.offset);
      return this.offset += 4, m;
    }
    readUInt32() {
      const m = this.buffer.readUInt32LE(this.offset);
      return this.offset += 4, m;
    }
    readUInt64() {
      const m = this.readSlice(8);
      return u(m);
    }
    readVarInt() {
      const [m, b] = (0, s.parseVarint)(this.buffer, this.offset);
      return this.offset += b, m;
    }
    readSlice(m) {
      if (this.buffer.length < this.offset + m)
        throw new Error("Cannot read slice out of bounds");
      const b = this.buffer.slice(this.offset, this.offset + m);
      return this.offset += m, b;
    }
    readVarSlice() {
      const m = (0, s.sanitizeBigintToNumber)(this.readVarInt());
      return this.readSlice(m);
    }
    readVector() {
      const m = this.readVarInt(), b = [];
      for (let k = 0; k < m; k++)
        b.push(this.readVarSlice());
      return b;
    }
  }
  return buffertools$2.BufferReader = t, buffertools$2;
}
var merkle$2 = {}, hasRequiredMerkle$2;
function requireMerkle$2() {
  if (hasRequiredMerkle$2) return merkle$2;
  hasRequiredMerkle$2 = 1, Object.defineProperty(merkle$2, "__esModule", { value: !0 }), merkle$2.hashLeaf = merkle$2.Merkle = void 0;
  const s = requireSrc$3();
  class A {
    constructor(C, B = s.crypto.sha256) {
      this.leaves = C, this.h = B;
      const Q = this.calculateRoot(C);
      this.rootNode = Q.root, this.leafNodes = Q.leaves;
    }
    getRoot() {
      return this.rootNode.hash;
    }
    size() {
      return this.leaves.length;
    }
    getLeaves() {
      return this.leaves;
    }
    getLeafHash(C) {
      return this.leafNodes[C].hash;
    }
    getProof(C) {
      if (C >= this.leaves.length)
        throw Error("Index out of bounds");
      return l(this.leafNodes[C]);
    }
    calculateRoot(C) {
      const B = C.length;
      if (B == 0)
        return {
          root: new t(void 0, void 0, Buffer.alloc(32, 0)),
          leaves: []
        };
      if (B == 1) {
        const pe = new t(void 0, void 0, C[0]);
        return { root: pe, leaves: [pe] };
      }
      const Q = m(B), P = this.calculateRoot(C.slice(0, Q)), x = this.calculateRoot(C.slice(Q)), M = P.root, F = x.root, le = this.hashNode(M.hash, F.hash), ge = new t(M, F, le);
      return M.parent = ge, F.parent = ge, { root: ge, leaves: P.leaves.concat(x.leaves) };
    }
    hashNode(C, B) {
      return this.h(Buffer.concat([Buffer.from([1]), C, B]));
    }
  }
  merkle$2.Merkle = A;
  function u(k, C = s.crypto.sha256) {
    return p(Buffer.from([0]), k, C);
  }
  merkle$2.hashLeaf = u;
  function p(k, C, B) {
    return B(Buffer.concat([k, C]));
  }
  class t {
    constructor(C, B, Q) {
      this.leftChild = C, this.rightChild = B, this.hash = Q;
    }
    isLeaf() {
      return this.leftChild == null;
    }
  }
  function l(k) {
    if (!k.parent)
      return [];
    if (k.parent.leftChild == k) {
      if (!k.parent.rightChild)
        throw new Error("Expected right child to exist");
      return [k.parent.rightChild.hash, ...l(k.parent)];
    } else {
      if (!k.parent.leftChild)
        throw new Error("Expected left child to exist");
      return [k.parent.leftChild.hash, ...l(k.parent)];
    }
  }
  function m(k) {
    if (k < 2)
      throw Error("Expected n >= 2");
    return b(k) ? k / 2 : 1 << Math.floor(Math.log2(k));
  }
  function b(k) {
    return (k & k - 1) == 0;
  }
  return merkle$2;
}
var hasRequiredClientCommands$2;
function requireClientCommands$2() {
  if (hasRequiredClientCommands$2) return clientCommands$2;
  hasRequiredClientCommands$2 = 1, Object.defineProperty(clientCommands$2, "__esModule", { value: !0 }), clientCommands$2.ClientCommandInterpreter = clientCommands$2.GetMoreElementsCommand = clientCommands$2.GetMerkleLeafIndexCommand = clientCommands$2.GetMerkleLeafProofCommand = clientCommands$2.GetPreimageCommand = clientCommands$2.YieldCommand = void 0;
  const s = requireSrc$3(), A = requireBuffertools$2(), u = requireMerkle$2(), p = requireVarint$2();
  var t;
  (function(P) {
    P[P.YIELD = 16] = "YIELD", P[P.GET_PREIMAGE = 64] = "GET_PREIMAGE", P[P.GET_MERKLE_LEAF_PROOF = 65] = "GET_MERKLE_LEAF_PROOF", P[P.GET_MERKLE_LEAF_INDEX = 66] = "GET_MERKLE_LEAF_INDEX", P[P.GET_MORE_ELEMENTS = 160] = "GET_MORE_ELEMENTS";
  })(t || (t = {}));
  class l {
  }
  class m extends l {
    constructor(x, M) {
      super(), this.progressCallback = M, this.code = t.YIELD, this.results = x;
    }
    execute(x) {
      return this.results.push(Buffer.from(x.subarray(1))), this.progressCallback && this.progressCallback(), Buffer.from("");
    }
  }
  clientCommands$2.YieldCommand = m;
  class b extends l {
    constructor(x, M) {
      super(), this.code = t.GET_PREIMAGE, this.known_preimages = x, this.queue = M;
    }
    execute(x) {
      const M = Buffer.from(x.subarray(1));
      if (M.length != 33)
        throw new Error("Invalid request, unexpected trailing data");
      if (M[0] != 0)
        throw new Error("Unsupported request, the first byte should be 0");
      const F = Buffer.alloc(32);
      for (let pe = 0; pe < 32; pe++)
        F[pe] = M[1 + pe];
      const le = F.toString("hex"), ge = this.known_preimages.get(le);
      if (ge != null) {
        const pe = (0, p.createVarint)(ge.length), Ie = 255 - pe.length - 1, be = Math.min(Ie, ge.length);
        if (be < ge.length)
          for (let Pe = be; Pe < ge.length; Pe++)
            this.queue.push(Buffer.from([ge[Pe]]));
        return Buffer.concat([
          pe,
          Buffer.from([be]),
          Buffer.from(ge.subarray(0, be))
        ]);
      }
      throw Error(`Requested unknown preimage for: ${le}`);
    }
  }
  clientCommands$2.GetPreimageCommand = b;
  class k extends l {
    constructor(x, M) {
      super(), this.code = t.GET_MERKLE_LEAF_PROOF, this.known_trees = x, this.queue = M;
    }
    execute(x) {
      const M = Buffer.from(x.subarray(1));
      if (M.length < 34)
        throw new Error("Invalid request, expected at least 34 bytes");
      const F = new A.BufferReader(M), ge = F.readSlice(32).toString("hex");
      let pe, Ie;
      try {
        pe = (0, p.sanitizeBigintToNumber)(F.readVarInt()), Ie = (0, p.sanitizeBigintToNumber)(F.readVarInt());
      } catch {
        throw new Error("Invalid request, couldn't parse tree_size or leaf_index");
      }
      const be = this.known_trees.get(ge);
      if (!be)
        throw Error(`Requested Merkle leaf proof for unknown tree: ${ge}`);
      if (Ie >= pe || be.size() != pe)
        throw Error("Invalid index or tree size.");
      if (this.queue.length != 0)
        throw Error("This command should not execute when the queue is not empty.");
      const Pe = be.getProof(Ie), Te = Math.min(Math.floor(221 / 32), Pe.length), Qe = Pe.length - Te;
      return Qe > 0 && this.queue.push(...Pe.slice(-Qe)), Buffer.concat([
        be.getLeafHash(Ie),
        Buffer.from([Pe.length]),
        Buffer.from([Te]),
        ...Pe.slice(0, Te)
      ]);
    }
  }
  clientCommands$2.GetMerkleLeafProofCommand = k;
  class C extends l {
    constructor(x) {
      super(), this.code = t.GET_MERKLE_LEAF_INDEX, this.known_trees = x;
    }
    execute(x) {
      const M = Buffer.from(x.subarray(1));
      if (M.length != 64)
        throw new Error("Invalid request, unexpected trailing data");
      const F = Buffer.alloc(32);
      for (let Te = 0; Te < 32; Te++)
        F[Te] = M.readUInt8(Te);
      const le = F.toString("hex"), ge = Buffer.alloc(32);
      for (let Te = 0; Te < 32; Te++)
        ge[Te] = M.readUInt8(32 + Te);
      const pe = ge.toString("hex"), Ie = this.known_trees.get(le);
      if (!Ie)
        throw Error(`Requested Merkle leaf index for unknown root: ${le}`);
      let be = 0, Pe = 0;
      for (let Te = 0; Te < Ie.size(); Te++)
        if (Ie.getLeafHash(Te).toString("hex") == pe) {
          Pe = 1, be = Te;
          break;
        }
      return Buffer.concat([Buffer.from([Pe]), (0, p.createVarint)(be)]);
    }
  }
  clientCommands$2.GetMerkleLeafIndexCommand = C;
  class B extends l {
    constructor(x) {
      super(), this.code = t.GET_MORE_ELEMENTS, this.queue = x;
    }
    execute(x) {
      if (x.length != 1)
        throw new Error("Invalid request, unexpected trailing data");
      if (this.queue.length === 0)
        throw new Error("No elements to get");
      const M = this.queue[0].length;
      if (this.queue.some((pe) => pe.length != M))
        throw new Error("The queue contains elements with different byte length, which is not expected");
      const F = Math.floor(253 / M), le = Math.min(F, this.queue.length), ge = this.queue.splice(0, le);
      return Buffer.concat([
        Buffer.from([le]),
        Buffer.from([M]),
        ...ge
      ]);
    }
  }
  clientCommands$2.GetMoreElementsCommand = B;
  class Q {
    constructor(x) {
      this.roots = /* @__PURE__ */ new Map(), this.preimages = /* @__PURE__ */ new Map(), this.yielded = [], this.queue = [], this.commands = /* @__PURE__ */ new Map();
      const M = [
        new m(this.yielded, x),
        new b(this.preimages, this.queue),
        new C(this.roots),
        new k(this.roots, this.queue),
        new B(this.queue)
      ];
      for (const F of M) {
        if (this.commands.has(F.code))
          throw new Error(`Multiple commands with code ${F.code}`);
        this.commands.set(F.code, F);
      }
    }
    getYielded() {
      return this.yielded;
    }
    addKnownPreimage(x) {
      this.preimages.set(s.crypto.sha256(x).toString("hex"), x);
    }
    addKnownList(x) {
      for (const F of x) {
        const le = Buffer.concat([Buffer.from([0]), F]);
        this.addKnownPreimage(le);
      }
      const M = new u.Merkle(x.map((F) => (0, u.hashLeaf)(F)));
      this.roots.set(M.getRoot().toString("hex"), M);
    }
    addKnownMapping(x) {
      this.addKnownList(x.keys), this.addKnownList(x.values);
    }
    addKnownWalletPolicy(x) {
      this.addKnownPreimage(x.serialize()), this.addKnownList(x.keys.map((M) => Buffer.from(M, "ascii"))), this.addKnownPreimage(Buffer.from(x.descriptorTemplate));
    }
    execute(x) {
      if (x.length == 0)
        throw new Error("Unexpected empty command");
      const M = x[0], F = this.commands.get(M);
      if (!F)
        throw new Error(`Unexpected command code ${M}`);
      return F.execute(x);
    }
  }
  return clientCommands$2.ClientCommandInterpreter = Q, clientCommands$2;
}
var merkelizedPsbt$2 = {}, merkleMap$2 = {}, hasRequiredMerkleMap$2;
function requireMerkleMap$2() {
  if (hasRequiredMerkleMap$2) return merkleMap$2;
  hasRequiredMerkleMap$2 = 1, Object.defineProperty(merkleMap$2, "__esModule", { value: !0 }), merkleMap$2.MerkleMap = void 0;
  const s = requireMerkle$2(), A = requireVarint$2();
  class u {
    /**
     * @param keys Sorted list of (unhashed) keys
     * @param values values, in corresponding order as the keys, and of equal length
     */
    constructor(t, l) {
      if (t.length != l.length)
        throw new Error("keys and values should have the same length");
      for (let m = 0; m < t.length - 1; m++)
        if (t[m].toString("hex") >= t[m + 1].toString("hex"))
          throw new Error("keys must be in strictly increasing order");
      this.keys = t, this.keysTree = new s.Merkle(t.map((m) => (0, s.hashLeaf)(m))), this.values = l, this.valuesTree = new s.Merkle(l.map((m) => (0, s.hashLeaf)(m)));
    }
    commitment() {
      return Buffer.concat([
        (0, A.createVarint)(this.keys.length),
        this.keysTree.getRoot(),
        this.valuesTree.getRoot()
      ]);
    }
  }
  return merkleMap$2.MerkleMap = u, merkleMap$2;
}
var psbtv2$2 = {}, hasRequiredPsbtv2$2;
function requirePsbtv2$2() {
  return hasRequiredPsbtv2$2 || (hasRequiredPsbtv2$2 = 1, function(s) {
    var A = psbtv2$2 && psbtv2$2.__createBinding || (Object.create ? function(xe, Ee, He, ve) {
      ve === void 0 && (ve = He);
      var we = Object.getOwnPropertyDescriptor(Ee, He);
      (!we || ("get" in we ? !Ee.__esModule : we.writable || we.configurable)) && (we = { enumerable: !0, get: function() {
        return Ee[He];
      } }), Object.defineProperty(xe, ve, we);
    } : function(xe, Ee, He, ve) {
      ve === void 0 && (ve = He), xe[ve] = Ee[He];
    }), u = psbtv2$2 && psbtv2$2.__setModuleDefault || (Object.create ? function(xe, Ee) {
      Object.defineProperty(xe, "default", { enumerable: !0, value: Ee });
    } : function(xe, Ee) {
      xe.default = Ee;
    }), p = psbtv2$2 && psbtv2$2.__importStar || function(xe) {
      if (xe && xe.__esModule) return xe;
      var Ee = {};
      if (xe != null) for (var He in xe) He !== "default" && Object.prototype.hasOwnProperty.call(xe, He) && A(Ee, xe, He);
      return u(Ee, xe), Ee;
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), s.PsbtV2 = s.NoSuchEntry = s.psbtOut = s.psbtIn = s.psbtGlobal = void 0;
    const t = p(requireSrc$3()), l = requireBuffertools$2(), m = requireVarint$2();
    var b;
    (function(xe) {
      xe[xe.UNSIGNED_TX = 0] = "UNSIGNED_TX", xe[xe.XPUB = 1] = "XPUB", xe[xe.TX_VERSION = 2] = "TX_VERSION", xe[xe.FALLBACK_LOCKTIME = 3] = "FALLBACK_LOCKTIME", xe[xe.INPUT_COUNT = 4] = "INPUT_COUNT", xe[xe.OUTPUT_COUNT = 5] = "OUTPUT_COUNT", xe[xe.TX_MODIFIABLE = 6] = "TX_MODIFIABLE", xe[xe.VERSION = 251] = "VERSION";
    })(b = s.psbtGlobal || (s.psbtGlobal = {}));
    var k;
    (function(xe) {
      xe[xe.NON_WITNESS_UTXO = 0] = "NON_WITNESS_UTXO", xe[xe.WITNESS_UTXO = 1] = "WITNESS_UTXO", xe[xe.PARTIAL_SIG = 2] = "PARTIAL_SIG", xe[xe.SIGHASH_TYPE = 3] = "SIGHASH_TYPE", xe[xe.REDEEM_SCRIPT = 4] = "REDEEM_SCRIPT", xe[xe.WITNESS_SCRIPT = 5] = "WITNESS_SCRIPT", xe[xe.BIP32_DERIVATION = 6] = "BIP32_DERIVATION", xe[xe.FINAL_SCRIPTSIG = 7] = "FINAL_SCRIPTSIG", xe[xe.FINAL_SCRIPTWITNESS = 8] = "FINAL_SCRIPTWITNESS", xe[xe.PREVIOUS_TXID = 14] = "PREVIOUS_TXID", xe[xe.OUTPUT_INDEX = 15] = "OUTPUT_INDEX", xe[xe.SEQUENCE = 16] = "SEQUENCE", xe[xe.TAP_KEY_SIG = 19] = "TAP_KEY_SIG", xe[xe.TAP_BIP32_DERIVATION = 22] = "TAP_BIP32_DERIVATION";
    })(k = s.psbtIn || (s.psbtIn = {}));
    var C;
    (function(xe) {
      xe[xe.REDEEM_SCRIPT = 0] = "REDEEM_SCRIPT", xe[xe.WITNESS_SCRIPT = 1] = "WITNESS_SCRIPT", xe[xe.BIP_32_DERIVATION = 2] = "BIP_32_DERIVATION", xe[xe.AMOUNT = 3] = "AMOUNT", xe[xe.SCRIPT = 4] = "SCRIPT", xe[xe.TAP_BIP32_DERIVATION = 7] = "TAP_BIP32_DERIVATION";
    })(C = s.psbtOut || (s.psbtOut = {}));
    const B = Buffer.from([112, 115, 98, 116, 255]);
    class Q extends Error {
    }
    s.NoSuchEntry = Q;
    class P {
      constructor() {
        this.globalMap = /* @__PURE__ */ new Map(), this.inputMaps = [], this.outputMaps = [];
      }
      setGlobalTxVersion(Ee) {
        this.setGlobal(b.TX_VERSION, be(Ee));
      }
      getGlobalTxVersion() {
        return this.getGlobal(b.TX_VERSION).readUInt32LE(0);
      }
      setGlobalFallbackLocktime(Ee) {
        this.setGlobal(b.FALLBACK_LOCKTIME, be(Ee));
      }
      getGlobalFallbackLocktime() {
        var Ee;
        return (Ee = this.getGlobalOptional(b.FALLBACK_LOCKTIME)) === null || Ee === void 0 ? void 0 : Ee.readUInt32LE(0);
      }
      setGlobalInputCount(Ee) {
        this.setGlobal(b.INPUT_COUNT, Te(Ee));
      }
      getGlobalInputCount() {
        return Qe(this.getGlobal(b.INPUT_COUNT));
      }
      setGlobalOutputCount(Ee) {
        this.setGlobal(b.OUTPUT_COUNT, Te(Ee));
      }
      getGlobalOutputCount() {
        return Qe(this.getGlobal(b.OUTPUT_COUNT));
      }
      setGlobalTxModifiable(Ee) {
        this.setGlobal(b.TX_MODIFIABLE, Ee);
      }
      getGlobalTxModifiable() {
        return this.getGlobalOptional(b.TX_MODIFIABLE);
      }
      setGlobalPsbtVersion(Ee) {
        this.setGlobal(b.VERSION, be(Ee));
      }
      getGlobalPsbtVersion() {
        return this.getGlobal(b.VERSION).readUInt32LE(0);
      }
      setInputNonWitnessUtxo(Ee, He) {
        this.setInput(Ee, k.NON_WITNESS_UTXO, pe(), He);
      }
      getInputNonWitnessUtxo(Ee) {
        return this.getInputOptional(Ee, k.NON_WITNESS_UTXO, pe());
      }
      setInputWitnessUtxo(Ee, He, ve) {
        const we = new l.BufferWriter();
        we.writeSlice(Pe(He)), we.writeVarSlice(ve), this.setInput(Ee, k.WITNESS_UTXO, pe(), we.buffer());
      }
      getInputWitnessUtxo(Ee) {
        const He = this.getInputOptional(Ee, k.WITNESS_UTXO, pe());
        if (!He)
          return;
        const ve = new l.BufferReader(He);
        return {
          amount: (0, l.unsafeFrom64bitLE)(ve.readSlice(8)),
          scriptPubKey: ve.readVarSlice()
        };
      }
      setInputPartialSig(Ee, He, ve) {
        this.setInput(Ee, k.PARTIAL_SIG, He, ve);
      }
      getInputPartialSig(Ee, He) {
        return this.getInputOptional(Ee, k.PARTIAL_SIG, He);
      }
      setInputSighashType(Ee, He) {
        this.setInput(Ee, k.SIGHASH_TYPE, pe(), be(He));
      }
      getInputSighashType(Ee) {
        const He = this.getInputOptional(Ee, k.SIGHASH_TYPE, pe());
        if (He)
          return He.readUInt32LE(0);
      }
      setInputRedeemScript(Ee, He) {
        this.setInput(Ee, k.REDEEM_SCRIPT, pe(), He);
      }
      getInputRedeemScript(Ee) {
        return this.getInputOptional(Ee, k.REDEEM_SCRIPT, pe());
      }
      setInputWitnessScript(Ee, He) {
        this.setInput(Ee, k.WITNESS_SCRIPT, pe(), He);
      }
      getInputWitnessScript(Ee) {
        return this.getInputOptional(Ee, k.WITNESS_SCRIPT, pe());
      }
      setInputBip32Derivation(Ee, He, ve, we) {
        if (He.length != 33)
          throw new Error("Invalid pubkey length: " + He.length);
        this.setInput(Ee, k.BIP32_DERIVATION, He, this.encodeBip32Derivation(ve, we));
      }
      getInputBip32Derivation(Ee, He) {
        const ve = this.getInputOptional(Ee, k.BIP32_DERIVATION, He);
        if (ve)
          return this.decodeBip32Derivation(ve);
      }
      setInputFinalScriptsig(Ee, He) {
        this.setInput(Ee, k.FINAL_SCRIPTSIG, pe(), He);
      }
      getInputFinalScriptsig(Ee) {
        return this.getInputOptional(Ee, k.FINAL_SCRIPTSIG, pe());
      }
      setInputFinalScriptwitness(Ee, He) {
        this.setInput(Ee, k.FINAL_SCRIPTWITNESS, pe(), He);
      }
      getInputFinalScriptwitness(Ee) {
        return this.getInput(Ee, k.FINAL_SCRIPTWITNESS, pe());
      }
      setInputPreviousTxId(Ee, He) {
        this.setInput(Ee, k.PREVIOUS_TXID, pe(), He);
      }
      getInputPreviousTxid(Ee) {
        return this.getInput(Ee, k.PREVIOUS_TXID, pe());
      }
      setInputOutputIndex(Ee, He) {
        this.setInput(Ee, k.OUTPUT_INDEX, pe(), be(He));
      }
      getInputOutputIndex(Ee) {
        return this.getInput(Ee, k.OUTPUT_INDEX, pe()).readUInt32LE(0);
      }
      setInputSequence(Ee, He) {
        this.setInput(Ee, k.SEQUENCE, pe(), be(He));
      }
      getInputSequence(Ee) {
        var He, ve;
        return (ve = (He = this.getInputOptional(Ee, k.SEQUENCE, pe())) === null || He === void 0 ? void 0 : He.readUInt32LE(0)) !== null && ve !== void 0 ? ve : 4294967295;
      }
      setInputTapKeySig(Ee, He) {
        this.setInput(Ee, k.TAP_KEY_SIG, pe(), He);
      }
      getInputTapKeySig(Ee) {
        return this.getInputOptional(Ee, k.TAP_KEY_SIG, pe());
      }
      setInputTapBip32Derivation(Ee, He, ve, we, Ce) {
        if (He.length != 32)
          throw new Error("Invalid pubkey length: " + He.length);
        const Se = this.encodeTapBip32Derivation(ve, we, Ce);
        this.setInput(Ee, k.TAP_BIP32_DERIVATION, He, Se);
      }
      getInputTapBip32Derivation(Ee, He) {
        const ve = this.getInput(Ee, k.TAP_BIP32_DERIVATION, He);
        return this.decodeTapBip32Derivation(ve);
      }
      getInputKeyDatas(Ee, He) {
        return this.getKeyDatas(this.inputMaps[Ee], He);
      }
      setOutputRedeemScript(Ee, He) {
        this.setOutput(Ee, C.REDEEM_SCRIPT, pe(), He);
      }
      getOutputRedeemScript(Ee) {
        return this.getOutput(Ee, C.REDEEM_SCRIPT, pe());
      }
      setOutputBip32Derivation(Ee, He, ve, we) {
        this.setOutput(Ee, C.BIP_32_DERIVATION, He, this.encodeBip32Derivation(ve, we));
      }
      getOutputBip32Derivation(Ee, He) {
        const ve = this.getOutput(Ee, C.BIP_32_DERIVATION, He);
        return this.decodeBip32Derivation(ve);
      }
      setOutputAmount(Ee, He) {
        this.setOutput(Ee, C.AMOUNT, pe(), Pe(He));
      }
      getOutputAmount(Ee) {
        const He = this.getOutput(Ee, C.AMOUNT, pe());
        return (0, l.unsafeFrom64bitLE)(He);
      }
      setOutputScript(Ee, He) {
        this.setOutput(Ee, C.SCRIPT, pe(), He);
      }
      getOutputScript(Ee) {
        return this.getOutput(Ee, C.SCRIPT, pe());
      }
      setOutputTapBip32Derivation(Ee, He, ve, we, Ce) {
        const Se = this.encodeTapBip32Derivation(ve, we, Ce);
        this.setOutput(Ee, C.TAP_BIP32_DERIVATION, He, Se);
      }
      getOutputTapBip32Derivation(Ee, He) {
        const ve = this.getOutput(Ee, C.TAP_BIP32_DERIVATION, He);
        return this.decodeTapBip32Derivation(ve);
      }
      deleteInputEntries(Ee, He) {
        this.inputMaps[Ee].forEach((we, Ce, Se) => {
          this.isKeyType(Ce, He) && Se.delete(Ce);
        });
      }
      copy(Ee) {
        this.copyMap(this.globalMap, Ee.globalMap), this.copyMaps(this.inputMaps, Ee.inputMaps), this.copyMaps(this.outputMaps, Ee.outputMaps);
      }
      copyMaps(Ee, He) {
        Ee.forEach((ve, we) => {
          const Ce = /* @__PURE__ */ new Map();
          this.copyMap(ve, Ce), He[we] = Ce;
        });
      }
      copyMap(Ee, He) {
        Ee.forEach((ve, we) => He.set(we, Buffer.from(ve)));
      }
      serialize() {
        const Ee = new l.BufferWriter();
        return Ee.writeSlice(Buffer.from([112, 115, 98, 116, 255])), ge(Ee, this.globalMap), this.inputMaps.forEach((He) => {
          ge(Ee, He);
        }), this.outputMaps.forEach((He) => {
          ge(Ee, He);
        }), Ee.buffer();
      }
      deserialize(Ee) {
        const He = new l.BufferReader(Ee);
        if (!He.readSlice(5).equals(B))
          throw new Error("Invalid magic bytes");
        for (; this.readKeyPair(this.globalMap, He); )
          ;
        let ve;
        try {
          ve = this.getGlobalPsbtVersion();
        } catch {
          ve = 0;
        }
        if (ve !== 0 && ve !== 2)
          throw new Error("Only PSBTs of version 0 or 2 are supported");
        let we, Ce;
        if (ve == 0) {
          const Se = this.getGlobal(b.UNSIGNED_TX), Ne = t.Transaction.fromBuffer(Se);
          we = Ne.ins.length, Ce = Ne.outs.length;
        } else
          we = this.getGlobalInputCount(), Ce = this.getGlobalOutputCount();
        for (let Se = 0; Se < we; Se++)
          for (this.inputMaps[Se] = /* @__PURE__ */ new Map(); this.readKeyPair(this.inputMaps[Se], He); )
            ;
        for (let Se = 0; Se < Ce; Se++)
          for (this.outputMaps[Se] = /* @__PURE__ */ new Map(); this.readKeyPair(this.outputMaps[Se], He); )
            ;
        this.normalizeToV2();
      }
      normalizeToV2() {
        var Ee;
        const He = (Ee = this.getGlobalOptional(b.VERSION)) === null || Ee === void 0 ? void 0 : Ee.readInt32LE(0);
        if (He === 2)
          return;
        if (He !== void 0)
          throw new Error("Invalid or unsupported value for PSBT_GLOBAL_VERSION");
        const ve = this.getGlobal(b.UNSIGNED_TX), we = t.Transaction.fromBuffer(ve);
        this.setGlobalPsbtVersion(2), this.setGlobalTxVersion(we.version), this.setGlobalFallbackLocktime(we.locktime), this.setGlobalInputCount(we.ins.length), this.setGlobalOutputCount(we.outs.length);
        for (let Ce = 0; Ce < we.ins.length; Ce++)
          this.setInputPreviousTxId(Ce, we.ins[Ce].hash), this.setInputOutputIndex(Ce, we.ins[Ce].index), this.setInputSequence(Ce, we.ins[Ce].sequence);
        for (let Ce = 0; Ce < we.outs.length; Ce++)
          this.setOutputAmount(Ce, we.outs[Ce].value), this.setOutputScript(Ce, we.outs[Ce].script);
        this.globalMap.delete(b.UNSIGNED_TX.toString(16).padStart(2, "0"));
      }
      /**
       * Imports a BitcoinJS (bitcoinjs-lib) Psbt object.
       * https://github.com/bitcoinjs/bitcoinjs-lib/blob/master/ts_src/psbt.ts
       *
       * Prepares the fields required for signing a Psbt on a Ledger
       * device. It should be used exclusively before calling
       * `appClient.signPsbt()` and not as a general Psbt conversion method.
       *
       * Note: This method supports all the policies that the Ledger is able to
       * sign, with the exception of taproot: tr(@0).
       */
      fromBitcoinJS(Ee) {
        function He(ve) {
          let we;
          try {
            t.payments.p2tr({ output: ve.witnessUtxo.script }), we = !0;
          } catch {
            we = !1;
          }
          return ve && !!(ve.tapInternalKey || ve.tapMerkleRoot || ve.tapLeafScript && ve.tapLeafScript.length || ve.tapBip32Derivation && ve.tapBip32Derivation.length || we);
        }
        return this.setGlobalPsbtVersion(2), this.setGlobalTxVersion(Ee.version), this.setGlobalInputCount(Ee.data.inputs.length), this.setGlobalOutputCount(Ee.txOutputs.length), Ee.locktime !== void 0 && this.setGlobalFallbackLocktime(Ee.locktime), Ee.data.inputs.forEach((ve, we) => {
          if (He(ve))
            throw new Error("Taproot inputs not supported");
          this.setInputPreviousTxId(we, Ee.txInputs[we].hash), Ee.txInputs[we].sequence !== void 0 && this.setInputSequence(we, Ee.txInputs[we].sequence), this.setInputOutputIndex(we, Ee.txInputs[we].index), ve.sighashType !== void 0 && this.setInputSighashType(we, ve.sighashType), ve.nonWitnessUtxo && this.setInputNonWitnessUtxo(we, ve.nonWitnessUtxo), ve.witnessUtxo && this.setInputWitnessUtxo(we, ve.witnessUtxo.value, ve.witnessUtxo.script), ve.witnessScript && this.setInputWitnessScript(we, ve.witnessScript), ve.redeemScript && this.setInputRedeemScript(we, ve.redeemScript), Ee.data.inputs[we].bip32Derivation.forEach((Ce) => {
            if (!/^m\//i.test(Ce.path))
              throw new Error("Invalid input bip32 derivation");
            const Se = Ce.path.replace(/m\//i, "").split("/").map((Ne) => Ne.match(/['h]/i) ? parseInt(Ne) + 2147483648 : Number(Ne));
            this.setInputBip32Derivation(we, Ce.pubkey, Ce.masterFingerprint, Se);
          });
        }), Ee.txOutputs.forEach((ve, we) => {
          this.setOutputAmount(we, ve.value), this.setOutputScript(we, ve.script);
        }), this;
      }
      readKeyPair(Ee, He) {
        const ve = (0, m.sanitizeBigintToNumber)(He.readVarInt());
        if (ve == 0)
          return !1;
        const we = He.readUInt8(), Ce = He.readSlice(ve - 1), Se = He.readVarSlice();
        return Ie(Ee, we, Ce, Se), !0;
      }
      getKeyDatas(Ee, He) {
        const ve = [];
        return Ee.forEach((we, Ce) => {
          this.isKeyType(Ce, [He]) && ve.push(Buffer.from(Ce.substring(2), "hex"));
        }), ve;
      }
      isKeyType(Ee, He) {
        const ve = Buffer.from(Ee.substring(0, 2), "hex").readUInt8(0);
        return He.some((we) => we == ve);
      }
      setGlobal(Ee, He) {
        const ve = new M(Ee, Buffer.from([]));
        this.globalMap.set(ve.toString(), He);
      }
      getGlobal(Ee) {
        return x(this.globalMap, Ee, pe(), !1);
      }
      getGlobalOptional(Ee) {
        return x(this.globalMap, Ee, pe(), !0);
      }
      setInput(Ee, He, ve, we) {
        Ie(this.getMap(Ee, this.inputMaps), He, ve, we);
      }
      getInput(Ee, He, ve) {
        return x(this.inputMaps[Ee], He, ve, !1);
      }
      getInputOptional(Ee, He, ve) {
        return x(this.inputMaps[Ee], He, ve, !0);
      }
      setOutput(Ee, He, ve, we) {
        Ie(this.getMap(Ee, this.outputMaps), He, ve, we);
      }
      getOutput(Ee, He, ve) {
        return x(this.outputMaps[Ee], He, ve, !1);
      }
      getMap(Ee, He) {
        return He[Ee] ? He[Ee] : He[Ee] = /* @__PURE__ */ new Map();
      }
      encodeBip32Derivation(Ee, He) {
        const ve = new l.BufferWriter();
        return this.writeBip32Derivation(ve, Ee, He), ve.buffer();
      }
      decodeBip32Derivation(Ee) {
        const He = new l.BufferReader(Ee);
        return this.readBip32Derivation(He);
      }
      writeBip32Derivation(Ee, He, ve) {
        Ee.writeSlice(He), ve.forEach((we) => {
          Ee.writeUInt32(we);
        });
      }
      readBip32Derivation(Ee) {
        const He = Ee.readSlice(4), ve = [];
        for (; Ee.offset < Ee.buffer.length; )
          ve.push(Ee.readUInt32());
        return { masterFingerprint: He, path: ve };
      }
      encodeTapBip32Derivation(Ee, He, ve) {
        const we = new l.BufferWriter();
        return we.writeVarInt(Ee.length), Ee.forEach((Ce) => {
          we.writeSlice(Ce);
        }), this.writeBip32Derivation(we, He, ve), we.buffer();
      }
      decodeTapBip32Derivation(Ee) {
        const He = new l.BufferReader(Ee), ve = (0, m.sanitizeBigintToNumber)(He.readVarInt()), we = [];
        for (let Se = 0; Se < ve; Se++)
          we.push(He.readSlice(32));
        const Ce = this.readBip32Derivation(He);
        return Object.assign({ hashes: we }, Ce);
      }
    }
    s.PsbtV2 = P;
    function x(xe, Ee, He, ve) {
      if (!xe)
        throw Error("No such map");
      const we = new M(Ee, He), Ce = xe.get(we.toString());
      if (!Ce) {
        if (ve)
          return;
        throw new Q(we.toString());
      }
      return Buffer.from(Ce);
    }
    class M {
      constructor(Ee, He) {
        this.keyType = Ee, this.keyData = He;
      }
      toString() {
        const Ee = new l.BufferWriter();
        return this.toBuffer(Ee), Ee.buffer().toString("hex");
      }
      serialize(Ee) {
        Ee.writeVarInt(1 + this.keyData.length), this.toBuffer(Ee);
      }
      toBuffer(Ee) {
        Ee.writeUInt8(this.keyType), Ee.writeSlice(this.keyData);
      }
    }
    class F {
      constructor(Ee, He) {
        this.key = Ee, this.value = He;
      }
      serialize(Ee) {
        this.key.serialize(Ee), Ee.writeVarSlice(this.value);
      }
    }
    function le(xe) {
      return new M(xe.readUInt8(0), xe.slice(1));
    }
    function ge(xe, Ee) {
      for (let [He, ve] of [...Ee].sort(([we], [Ce]) => we.localeCompare(Ce)))
        new F(le(Buffer.from(He, "hex")), ve).serialize(xe);
      xe.writeUInt8(0);
    }
    function pe() {
      return Buffer.from([]);
    }
    function Ie(xe, Ee, He, ve) {
      const we = new M(Ee, He);
      xe.set(we.toString(), ve);
    }
    function be(xe) {
      const Ee = Buffer.alloc(4);
      return Ee.writeUInt32LE(xe, 0), Ee;
    }
    function Pe(xe) {
      return (0, l.unsafeTo64bitLE)(xe);
    }
    function Te(xe) {
      const Ee = new l.BufferWriter();
      return Ee.writeVarInt(xe), Ee.buffer();
    }
    function Qe(xe) {
      return (0, m.sanitizeBigintToNumber)(new l.BufferReader(xe).readVarInt());
    }
  }(psbtv2$2)), psbtv2$2;
}
var hasRequiredMerkelizedPsbt$2;
function requireMerkelizedPsbt$2() {
  if (hasRequiredMerkelizedPsbt$2) return merkelizedPsbt$2;
  hasRequiredMerkelizedPsbt$2 = 1, Object.defineProperty(merkelizedPsbt$2, "__esModule", { value: !0 }), merkelizedPsbt$2.MerkelizedPsbt = void 0;
  const s = requireMerkleMap$2(), A = requirePsbtv2$2();
  class u extends A.PsbtV2 {
    constructor(t) {
      super(), this.inputMerkleMaps = [], this.outputMerkleMaps = [], t.copy(this), this.globalMerkleMap = u.createMerkleMap(this.globalMap);
      for (let l = 0; l < this.getGlobalInputCount(); l++)
        this.inputMerkleMaps.push(u.createMerkleMap(this.inputMaps[l]));
      this.inputMapCommitments = [...this.inputMerkleMaps.values()].map((l) => l.commitment());
      for (let l = 0; l < this.getGlobalOutputCount(); l++)
        this.outputMerkleMaps.push(u.createMerkleMap(this.outputMaps[l]));
      this.outputMapCommitments = [...this.outputMerkleMaps.values()].map((l) => l.commitment());
    }
    // These public functions are for MerkelizedPsbt.
    getGlobalSize() {
      return this.globalMap.size;
    }
    getGlobalKeysValuesRoot() {
      return this.globalMerkleMap.commitment();
    }
    static createMerkleMap(t) {
      const l = [...t.keys()].sort(), m = l.map((k) => {
        const C = t.get(k);
        if (!C)
          throw new Error("No value for key " + k);
        return C;
      }), b = l.map((k) => Buffer.from(k, "hex"));
      return new s.MerkleMap(b, m);
    }
  }
  return merkelizedPsbt$2.MerkelizedPsbt = u, merkelizedPsbt$2;
}
var hasRequiredAppClient$2;
function requireAppClient$2() {
  if (hasRequiredAppClient$2) return appClient$1;
  hasRequiredAppClient$2 = 1, Object.defineProperty(appClient$1, "__esModule", { value: !0 }), appClient$1.AppClient = appClient$1.PartialSignature = void 0;
  const s = requireBip32$2(), A = requireClientCommands$2(), u = requireMerkelizedPsbt$2(), p = requireMerkle$2(), t = requirePsbtv2$2(), l = requireVarint$2(), m = 225, b = 248, k = 1;
  var C;
  (function(F) {
    F[F.GET_PUBKEY = 0] = "GET_PUBKEY", F[F.REGISTER_WALLET = 2] = "REGISTER_WALLET", F[F.GET_WALLET_ADDRESS = 3] = "GET_WALLET_ADDRESS", F[F.SIGN_PSBT = 4] = "SIGN_PSBT", F[F.GET_MASTER_FINGERPRINT = 5] = "GET_MASTER_FINGERPRINT", F[F.SIGN_MESSAGE = 16] = "SIGN_MESSAGE";
  })(C || (C = {}));
  var B;
  (function(F) {
    F[F.CONTINUE_INTERRUPTED = 1] = "CONTINUE_INTERRUPTED";
  })(B || (B = {}));
  class Q {
    constructor(le, ge, pe) {
      this.pubkey = le, this.signature = ge, this.tapleafHash = pe;
    }
  }
  appClient$1.PartialSignature = Q;
  function P(F, le) {
    if (F.length == 64)
      return new Q(F.slice(0, 32), le, F.slice(32, 64));
    if (F.length == 32 || F.length == 33)
      return new Q(F, le);
    throw new Error(`Invalid length for pubkeyAugm: ${F.length} bytes.`);
  }
  function x(F) {
    return (F.match(/[asctdvjnlu]+:/g) || []).some((ge) => ge.includes("a"));
  }
  class M {
    constructor(le) {
      this.transport = le;
    }
    async makeRequest(le, ge, pe) {
      let Ie = await this.transport.send(m, le, 0, k, ge, [36864, 57344]);
      for (; Ie.readUInt16BE(Ie.length - 2) === 57344; ) {
        if (!pe)
          throw new Error("Unexpected SW_INTERRUPTED_EXECUTION");
        const be = Ie.slice(0, -2), Pe = pe.execute(be);
        Ie = await this.transport.send(b, B.CONTINUE_INTERRUPTED, 0, 0, Pe, [36864, 57344]);
      }
      return Ie.slice(0, -2);
    }
    /**
     * Returns an object containing the currently running app's name, version and the device status flags.
     *
     * @returns an object with app name, version and device status flags.
     */
    async getAppAndVersion() {
      const le = await this.transport.send(176, 1, 0, 0);
      let ge = 0;
      if (le[ge++] !== 1)
        throw new Error("Unexpected response");
      const Ie = le[ge++], be = le.slice(ge, ge += Ie).toString("ascii"), Pe = le[ge++], Te = le.slice(ge, ge += Pe).toString("ascii"), Qe = le[ge++], xe = le.slice(ge, ge += Qe);
      return {
        name: be,
        version: Te,
        flags: xe
      };
    }
    /**
     * Requests the BIP-32 extended pubkey to the hardware wallet.
     * If `display` is `false`, only standard paths will be accepted; an error is returned if an unusual path is
     * requested.
     * If `display` is `true`, the requested path is shown on screen for user verification; unusual paths can be
     * requested, and a warning is shown to the user in that case.
     *
     * @param path the requested BIP-32 path as a string
     * @param display `false` to silently retrieve a pubkey for a standard path, `true` to display the path on screen
     * @returns the base58-encoded serialized extended pubkey (xpub)
     */
    async getExtendedPubkey(le, ge = !1) {
      const pe = (0, s.pathStringToArray)(le);
      if (pe.length > 6)
        throw new Error("Path too long. At most 6 levels allowed.");
      return (await this.makeRequest(C.GET_PUBKEY, Buffer.concat([
        Buffer.from(ge ? [1] : [0]),
        (0, s.pathElementsToBuffer)(pe)
      ]))).toString("ascii");
    }
    /**
     * Registers a `WalletPolicy`, after interactive verification from the user.
     * On success, after user's approval, this function returns the id (which is the same that can be computed with
     * `walletPolicy.getid()`), followed by the 32-byte hmac. The client should store the hmac to use it for future
     * requests to `getWalletAddress` or `signPsbt` using this `WalletPolicy`.
     *
     * @param walletPolicy the `WalletPolicy` to register
     * @returns a pair of two 32-byte arrays: the id of the Wallet Policy, followed by the policy hmac
     */
    async registerWallet(le) {
      await this.validatePolicy(le);
      const ge = new A.ClientCommandInterpreter();
      ge.addKnownWalletPolicy(le);
      const pe = le.serialize(), Ie = await this.makeRequest(C.REGISTER_WALLET, Buffer.concat([
        (0, l.createVarint)(pe.length),
        pe
      ]), ge);
      if (Ie.length != 64)
        throw Error(`Invalid response length. Expected 64 bytes, got ${Ie.length}`);
      return [Ie.subarray(0, 32), Ie.subarray(32)];
    }
    /**
     * Returns the address of `walletPolicy` for the given `change` and `addressIndex`.
     *
     * @param walletPolicy the `WalletPolicy` to use
     * @param walletHMAC the 32-byte hmac returned during wallet registration for a registered policy; otherwise
     * `null` for a standard policy
     * @param change `0` for a normal receive address, `1` for a change address
     * @param addressIndex the address index to retrieve
     * @param display `True` to show the address on screen, `False` to retrieve it silently
     * @returns the address, as an ascii string.
     */
    async getWalletAddress(le, ge, pe, Ie, be) {
      if (pe !== 0 && pe !== 1)
        throw new Error("Change can only be 0 or 1");
      if (Ie < 0 || !Number.isInteger(Ie))
        throw new Error("Invalid address index");
      if (ge != null && ge.length != 32)
        throw new Error("Invalid HMAC length");
      await this.validatePolicy(le);
      const Pe = new A.ClientCommandInterpreter();
      Pe.addKnownWalletPolicy(le);
      const Te = Buffer.alloc(4);
      return Te.writeUInt32BE(Ie, 0), (await this.makeRequest(C.GET_WALLET_ADDRESS, Buffer.concat([
        Buffer.from(be ? [1] : [0]),
        le.getId(),
        ge || Buffer.alloc(32, 0),
        Buffer.from([pe]),
        Te
      ]), Pe)).toString("ascii");
    }
    /**
     * Signs a psbt using a (standard or registered) `WalletPolicy`. This is an interactive command, as user validation
     * is necessary using the device's secure screen.
     * On success, a map of input indexes and signatures is returned.
     * @param psbt a base64-encoded string, or a psbt in a binary Buffer. Using the `PsbtV2` type is deprecated.
     * @param walletPolicy the `WalletPolicy` to use for signing
     * @param walletHMAC the 32-byte hmac obtained during wallet policy registration, or `null` for a standard policy
     * @param progressCallback optionally, a callback that will be called every time a signature is produced during
     * the signing process. The callback does not receive any argument, but can be used to track progress.
     * @returns an array of of tuples with 2 elements containing:
     *    - the index of the input being signed;
     *    - an instance of PartialSignature
     */
    async signPsbt(le, ge, pe, Ie) {
      if (await this.validatePolicy(ge), typeof le == "string" && (le = Buffer.from(le, "base64")), Buffer.isBuffer(le)) {
        const He = new t.PsbtV2();
        He.deserialize(le), le = He;
      }
      const be = new u.MerkelizedPsbt(le);
      if (pe != null && pe.length != 32)
        throw new Error("Invalid HMAC length");
      const Pe = new A.ClientCommandInterpreter(Ie);
      Pe.addKnownWalletPolicy(ge), Pe.addKnownMapping(be.globalMerkleMap);
      for (const He of be.inputMerkleMaps)
        Pe.addKnownMapping(He);
      for (const He of be.outputMerkleMaps)
        Pe.addKnownMapping(He);
      Pe.addKnownList(be.inputMapCommitments);
      const Te = new p.Merkle(be.inputMapCommitments.map((He) => (0, p.hashLeaf)(He))).getRoot();
      Pe.addKnownList(be.outputMapCommitments);
      const Qe = new p.Merkle(be.outputMapCommitments.map((He) => (0, p.hashLeaf)(He))).getRoot();
      await this.makeRequest(C.SIGN_PSBT, Buffer.concat([
        be.getGlobalKeysValuesRoot(),
        (0, l.createVarint)(be.getGlobalInputCount()),
        Te,
        (0, l.createVarint)(be.getGlobalOutputCount()),
        Qe,
        ge.getId(),
        pe || Buffer.alloc(32, 0)
      ]), Pe);
      const xe = Pe.getYielded(), Ee = [];
      for (const He of xe) {
        const [ve, we] = (0, l.parseVarint)(He, 0), Ce = He[we], Se = He.subarray(we + 1, we + 1 + Ce), Ne = He.subarray(we + 1 + Ce), rr = P(Se, Ne);
        Ee.push([Number(ve), rr]);
      }
      return Ee;
    }
    /**
     * Returns the fingerprint of the master public key, as per BIP-32 standard.
     * @returns the master key fingerprint as a string of 8 hexadecimal digits.
     */
    async getMasterFingerprint() {
      return (await this.makeRequest(C.GET_MASTER_FINGERPRINT, Buffer.from([]))).toString("hex");
    }
    /**
     * Signs a message using the legacy Bitcoin Message Signing standard. The signed message is
     * the double-sha256 hash of the concatenation of:
     * - "\x18Bitcoin Signed Message:\n";
     * - the length of `message`, encoded as a Bitcoin-style variable length integer;
     * - `message`.
     *
     * @param message the serialized message to sign
     * @param path the BIP-32 path of the key used to sign the message
     * @returns base64-encoded signature of the message.
     */
    async signMessage(le, ge) {
      const pe = (0, s.pathStringToArray)(ge), Ie = new A.ClientCommandInterpreter(), be = Math.ceil(le.length / 64), Pe = [];
      for (let xe = 0; xe < be; xe++)
        Pe.push(le.subarray(64 * xe, 64 * xe + 64));
      Ie.addKnownList(Pe);
      const Te = new p.Merkle(Pe.map((xe) => (0, p.hashLeaf)(xe))).getRoot();
      return (await this.makeRequest(C.SIGN_MESSAGE, Buffer.concat([
        (0, s.pathElementsToBuffer)(pe),
        (0, l.createVarint)(le.length),
        Te
      ]), Ie)).toString("base64");
    }
    /* Performs any additional checks on the policy before using it.*/
    async validatePolicy(le) {
      if (x(le.descriptorTemplate)) {
        const ge = await this.getAppAndVersion();
        if (["2.1.0", "2.1.1"].includes(ge.version))
          throw new Error("Please update your Ledger Bitcoin app.");
      }
    }
  }
  return appClient$1.AppClient = M, appClient$1.default = M, appClient$1;
}
var policy$2 = {}, hasRequiredPolicy$2;
function requirePolicy$2() {
  if (hasRequiredPolicy$2) return policy$2;
  hasRequiredPolicy$2 = 1, Object.defineProperty(policy$2, "__esModule", { value: !0 }), policy$2.DefaultWalletPolicy = policy$2.WalletPolicy = void 0;
  const s = requireSrc$3(), A = requireBuffertools$2(), u = requireMerkle$2(), p = 2;
  class t {
    /**
     * Creates and instance of a wallet policy.
     * @param name an ascii string, up to 16 bytes long; it must be an empty string for default wallet policies
     * @param descriptorTemplate the wallet policy template
     * @param keys and array of the keys, with the key derivation information
     */
    constructor(b, k, C) {
      this.name = b, this.descriptorTemplate = k, this.keys = C;
    }
    /**
     * Returns the unique 32-bytes id of this wallet policy.
     */
    getId() {
      return s.crypto.sha256(this.serialize());
    }
    /**
     * Serializes the wallet policy for transmission via the hardware wallet protocol.
     * @returns the serialized wallet policy
     */
    serialize() {
      const b = this.keys.map((B) => Buffer.from(B, "ascii")), k = new u.Merkle(b.map((B) => (0, u.hashLeaf)(B))), C = new A.BufferWriter();
      return C.writeUInt8(p), C.writeVarSlice(Buffer.from(this.name, "ascii")), C.writeVarInt(this.descriptorTemplate.length), C.writeSlice(s.crypto.sha256(Buffer.from(this.descriptorTemplate))), C.writeVarInt(this.keys.length), C.writeSlice(k.getRoot()), C.buffer();
    }
  }
  policy$2.WalletPolicy = t;
  class l extends t {
    constructor(b, k) {
      super("", b, [k]);
    }
  }
  return policy$2.DefaultWalletPolicy = l, policy$2;
}
var hasRequiredMain$3;
function requireMain$3() {
  return hasRequiredMain$3 || (hasRequiredMain$3 = 1, function(s) {
    var A = main$2 && main$2.__importDefault || function(l) {
      return l && l.__esModule ? l : { default: l };
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), s.WalletPolicy = s.DefaultWalletPolicy = s.PsbtV2 = s.AppClient = void 0;
    const u = A(requireAppClient$2());
    s.AppClient = u.default;
    const p = requirePolicy$2();
    Object.defineProperty(s, "DefaultWalletPolicy", { enumerable: !0, get: function() {
      return p.DefaultWalletPolicy;
    } }), Object.defineProperty(s, "WalletPolicy", { enumerable: !0, get: function() {
      return p.WalletPolicy;
    } });
    const t = requirePsbtv2$2();
    Object.defineProperty(s, "PsbtV2", { enumerable: !0, get: function() {
      return t.PsbtV2;
    } }), s.default = u.default;
  }(main$2)), main$2;
}
var hasRequiredLedger;
function requireLedger() {
  if (hasRequiredLedger) return ledger;
  hasRequiredLedger = 1, Object.defineProperty(ledger, "__esModule", { value: !0 }), ledger.ledgerPolicyFromState = ledger.comparePolicies = ledger.ledgerPolicyFromStandard = ledger.registerLedgerWallet = ledger.descriptorToLedgerFormat = ledger.getLedgerXpub = ledger.getLedgerMasterFingerPrint = ledger.assertLedgerApp = ledger.importAndValidateLedgerBitcoin = void 0;
  const s = requireSrc$3(), A = requireRe();
  async function u(M) {
    let F;
    try {
      F = requireMain$3();
    } catch {
      throw new Error('Could not import "ledger-bitcoin". This is a peer dependency and needs to be installed explicitly. Please run "npm install ledger-bitcoin" to use Ledger Hardware Wallet functionality.');
    }
    const { AppClient: le } = F;
    if (M !== void 0 && !(M instanceof le))
      throw new Error("Error: invalid AppClient instance");
    return F;
  }
  ledger.importAndValidateLedgerBitcoin = u;
  async function p(M) {
    const F = await M.send(176, 1, 0, 0);
    let le = 0;
    const ge = F[le++], pe = F[le++], Ie = F.slice(le, le += pe).toString("ascii"), be = F[le++], Pe = F.slice(le, le += be).toString("ascii"), Te = F[le++], Qe = F.slice(le, le += Te);
    return { name: Ie, version: Pe, flags: Qe, format: ge };
  }
  async function t({ transport: M, name: F, minVersion: le }) {
    const { name: ge, version: pe } = await p(M);
    if (ge !== F)
      throw new Error(`Open the ${F} app and try again`);
    {
      const [Ie, be, Pe] = le.split(".").map(Number), [Te, Qe, xe] = pe.split(".").map(Number);
      if (Ie === void 0 || be === void 0 || Pe === void 0)
        throw new Error("Pass a minVersion using semver notation: major.minor.patch");
      if (Te < Ie || Te === Ie && Qe < be || Te === Ie && Qe === be && xe < Pe)
        throw new Error(`Error: please upgrade ${F} to version ${le}`);
    }
  }
  ledger.assertLedgerApp = t;
  function l({ ledgerTemplate: M, keyRoots: F, network: le = s.networks.bitcoin }) {
    var pe, Ie;
    if (F.length !== 1)
      return !1;
    const ge = (Ie = (pe = F[0]) == null ? void 0 : pe.match(A.reOriginPath)) == null ? void 0 : Ie[1];
    return !ge || ge[5] !== (le === s.networks.bitcoin ? "0" : "1") ? !1 : !!(M === "pkh(@0/**)" && ge.match(/^\/44'\/[01]'\/(\d+)'$/) || M === "wpkh(@0/**)" && ge.match(/^\/84'\/[01]'\/(\d+)'$/) || M === "sh(wpkh(@0/**))" && ge.match(/^\/49'\/[01]'\/(\d+)'$/) || M === "tr(@0/**)" && ge.match(/^\/86'\/[01]'\/(\d+)'$/));
  }
  async function m({ ledgerClient: M, ledgerState: F }) {
    const { AppClient: le } = await u(M);
    if (!(M instanceof le))
      throw new Error("Error: pass a valid ledgerClient");
    let ge = F.masterFingerprint;
    return ge || (ge = Buffer.from(await M.getMasterFingerprint(), "hex"), F.masterFingerprint = ge), ge;
  }
  ledger.getLedgerMasterFingerPrint = m;
  async function b({ originPath: M, ledgerClient: F, ledgerState: le }) {
    const { AppClient: ge } = await u(F);
    if (!(F instanceof ge))
      throw new Error("Error: pass a valid ledgerClient");
    le.xpubs || (le.xpubs = {});
    let pe = le.xpubs[M];
    if (!pe) {
      try {
        pe = await F.getExtendedPubkey(`m${M}`, !1);
      } catch {
        pe = await F.getExtendedPubkey(`m${M}`, !0);
      }
      if (typeof pe != "string")
        throw new Error("Error: ledgerClient did not return a valid xpub");
      le.xpubs[M] = pe;
    }
    return pe;
  }
  ledger.getLedgerXpub = b;
  async function k({ descriptor: M, ledgerClient: F, ledgerState: le }) {
    const ge = M.expand().expandedExpression, pe = M.expand().expansionMap;
    if (!ge || !pe)
      throw new Error("Error: invalid descriptor");
    const Ie = await m({
      ledgerClient: F,
      ledgerState: le
    }), be = Object.keys(pe).sort(), Pe = be.filter((Ce) => {
      var Ne;
      const Se = (Ne = pe[Ce]) == null ? void 0 : Ne.masterFingerprint;
      return Se && Buffer.compare(Se, Ie) === 0;
    });
    if (Pe.length === 0)
      return null;
    if (Pe.length > 1)
      throw new Error(`Error: descriptor ${ge} does not contain exactly 1 ledger key`);
    const Te = Pe[0], Qe = pe[Te].masterFingerprint, xe = pe[Te].originPath, Ee = pe[Te].keyPath, He = pe[Te].bip32;
    if (!Qe || !xe || !Ee || !He)
      throw new Error(`Error: Ledger key expression must have a valid masterFingerprint: ${Qe}, originPath: ${xe}, keyPath: ${Ee} and a valid bip32 node`);
    if (!/^\/[01]\/\d+$/.test(Ee))
      throw new Error("Error: key paths must be /<1;0>/index, where change is 1 or 0 and index >= 0");
    const ve = [];
    let we = ge;
    return be.forEach((Ce) => {
      var Ne, rr, er;
      if (Ce !== Te) {
        const ir = pe[Ce];
        if (!ir.bip32)
          throw new Error("Error: ledger only allows xpub-type key expressions");
        if (ir.originPath && ir.originPath !== xe)
          throw new Error(`Error: all originPaths must be the same for Ledger being able to sign. On the other hand, you can leave the origin info empty for external keys: ${ir.originPath} !== ${xe}`);
        if (ir.keyPath !== Ee)
          throw new Error(`Error: all keyPaths must be the same for Ledger being able to sign: ${ir.keyPath} !== ${Ee}`);
      }
      we = we.replaceAll(Ce, `@${ve.length}/**`);
      const Se = pe[Ce];
      Se.masterFingerprint && Se.originPath ? ve.push(`[${(Ne = Se.masterFingerprint) == null ? void 0 : Ne.toString("hex")}${Se.originPath}]${(rr = Se == null ? void 0 : Se.bip32) == null ? void 0 : rr.neutered().toBase58()}`) : ve.push(`${(er = Se == null ? void 0 : Se.bip32) == null ? void 0 : er.neutered().toBase58()}`);
    }), { ledgerTemplate: we, keyRoots: ve };
  }
  ledger.descriptorToLedgerFormat = k;
  async function C({ descriptor: M, ledgerClient: F, ledgerState: le, policyName: ge }) {
    const { WalletPolicy: pe, AppClient: Ie } = await u(F);
    if (!(F instanceof Ie))
      throw new Error("Error: pass a valid ledgerClient");
    const be = await k({
      descriptor: M,
      ledgerClient: F,
      ledgerState: le
    });
    if (await B({ descriptor: M, ledgerClient: F, ledgerState: le }))
      return;
    if (!be)
      throw new Error("Error: descriptor does not have a ledger input");
    const { ledgerTemplate: Pe, keyRoots: Te } = be;
    le.policies || (le.policies = []);
    let Qe, xe;
    const Ee = await x({
      descriptor: M,
      ledgerClient: F,
      ledgerState: le
    });
    if (Ee) {
      if (Ee.policyName !== ge)
        throw new Error(`Error: policy was already registered with a different name: ${Ee.policyName}`);
    } else {
      Qe = new pe(ge, Pe, Te);
      let He;
      [He, xe] = await F.registerWallet(Qe);
      const ve = {
        policyName: ge,
        ledgerTemplate: Pe,
        keyRoots: Te,
        policyId: He,
        policyHmac: xe
      };
      le.policies.push(ve);
    }
  }
  ledger.registerLedgerWallet = C;
  async function B({ descriptor: M, ledgerClient: F, ledgerState: le }) {
    const ge = await k({
      descriptor: M,
      ledgerClient: F,
      ledgerState: le
    });
    if (!ge)
      throw new Error("Error: descriptor does not have a ledger input");
    const { ledgerTemplate: pe, keyRoots: Ie } = ge;
    return l({
      ledgerTemplate: pe,
      keyRoots: Ie,
      network: M.getNetwork()
    }) ? { ledgerTemplate: pe, keyRoots: Ie } : null;
  }
  ledger.ledgerPolicyFromStandard = B;
  function Q(M, F) {
    if (M.length !== F.length)
      return !1;
    for (let le = 0; le < M.length; le++)
      if (M[le] !== F[le])
        return !1;
    return !0;
  }
  function P(M, F) {
    return Q(M.keyRoots, F.keyRoots) && M.ledgerTemplate === F.ledgerTemplate;
  }
  ledger.comparePolicies = P;
  async function x({ descriptor: M, ledgerClient: F, ledgerState: le }) {
    const ge = await k({
      descriptor: M,
      ledgerClient: F,
      ledgerState: le
    });
    if (!ge)
      throw new Error("Error: descriptor does not have a ledger input");
    const { ledgerTemplate: pe, keyRoots: Ie } = ge;
    le.policies || (le.policies = []);
    const be = le.policies.filter((Pe) => P(Pe, { ledgerTemplate: pe, keyRoots: Ie }));
    if (be.length > 1)
      throw new Error("Error: duplicated policy");
    return be.length === 1 ? be[0] : null;
  }
  return ledger.ledgerPolicyFromState = x, ledger;
}
var hasRequiredKeyExpressions;
function requireKeyExpressions() {
  if (hasRequiredKeyExpressions) return keyExpressions;
  hasRequiredKeyExpressions = 1;
  var s = keyExpressions && keyExpressions.__createBinding || (Object.create ? function(Q, P, x, M) {
    M === void 0 && (M = x);
    var F = Object.getOwnPropertyDescriptor(P, x);
    (!F || ("get" in F ? !P.__esModule : F.writable || F.configurable)) && (F = { enumerable: !0, get: function() {
      return P[x];
    } }), Object.defineProperty(Q, M, F);
  } : function(Q, P, x, M) {
    M === void 0 && (M = x), Q[M] = P[x];
  }), A = keyExpressions && keyExpressions.__setModuleDefault || (Object.create ? function(Q, P) {
    Object.defineProperty(Q, "default", { enumerable: !0, value: P });
  } : function(Q, P) {
    Q.default = P;
  }), u = keyExpressions && keyExpressions.__importStar || function(Q) {
    if (Q && Q.__esModule) return Q;
    var P = {};
    if (Q != null) for (var x in Q) x !== "default" && Object.prototype.hasOwnProperty.call(Q, x) && s(P, Q, x);
    return A(P, Q), P;
  };
  Object.defineProperty(keyExpressions, "__esModule", { value: !0 }), keyExpressions.keyExpressionBIP32 = keyExpressions.keyExpressionLedger = keyExpressions.parseKeyExpression = void 0;
  const p = requireSrc$3(), t = requireLedger(), l = u(requireRe()), m = (Q, P) => {
    if (typeof P != "string")
      throw new Error(`Error: invalid derivation path ${P}`);
    const x = P.replaceAll("H", "'").replaceAll("h", "'").slice(1), M = x.split("/");
    for (const F of M) {
      const le = F.endsWith("'") ? F.slice(0, -1) : F;
      if (!Number.isInteger(Number(le)) || Number(le) >= 2147483648)
        throw new Error("Error: BIP 32 path element overflow");
    }
    return Q.derivePath(x);
  };
  function b({ keyExpression: Q, isSegwit: P, ECPair: x, BIP32: M, network: F = p.networks.bitcoin }) {
    var rr, er, ir, sr;
    let le, ge, pe, Ie, be, Pe, Te;
    const Qe = Q.indexOf("*") !== -1, xe = Q.match(l.reKeyExp);
    if (xe === null || xe[0] !== Q)
      throw new Error(`Error: expected a keyExpression but got ${Q}`);
    const Ee = RegExp(String.raw`^(${l.reOrigin})?`), He = Q.match(Ee);
    if (He) {
      const nr = He[0].replace(/[[\]]/g, ""), fr = String.raw`^(${l.reMasterFingerprint})`, lr = nr.match(fr), br = lr ? lr[0] : "";
      if (be = nr.replace(br, ""), br.length > 0) {
        if (br.length !== 8)
          throw new Error(`Error: masterFingerprint ${br} invalid for keyExpression: ${Q}`);
        Ie = Buffer.from(br, "hex");
      }
    }
    const ve = Q.replace(Ee, "");
    let we, Ce, Se, Ne;
    if ((we = ve.match(l.anchorStartAndEnd(l.rePubKey))) !== null) {
      if (le = Buffer.from(we[0], "hex"), ge = x.fromPublicKey(le, { network: F }), !x.isPoint(le) || !(le.length === 33 || le.length === 65))
        throw new Error("Error: invalid pubkey");
      if (typeof P == "boolean" && P && le.length !== 33)
        throw new Error("Error: invalid pubkey");
    } else if ((Ce = ve.match(l.anchorStartAndEnd(l.reWIF))) !== null)
      ge = x.fromWIF(Ce[0], F), le = ge.publicKey;
    else if ((Se = ve.match(l.anchorStartAndEnd(l.reXpubKey))) !== null) {
      const nr = Se[0], fr = (rr = nr.match(l.reXpub)) == null ? void 0 : rr[0];
      if (!fr)
        throw new Error("Error: xpub could not be matched");
      if (pe = M.fromBase58(fr, F), nr.match(l.rePath) !== null) {
        if (Pe = (er = nr.match(l.rePath)) == null ? void 0 : er[0], !Pe)
          throw new Error("Error: could not extract a path");
        Qe || (le = m(pe, Pe).publicKey);
      } else
        le = pe.publicKey;
    } else if ((Ne = ve.match(l.anchorStartAndEnd(l.reXprvKey))) !== null) {
      const nr = Ne[0], fr = (ir = nr.match(l.reXprv)) == null ? void 0 : ir[0];
      if (!fr)
        throw new Error("Error: xprv could not be matched");
      if (pe = M.fromBase58(fr, F), nr.match(l.rePath) !== null) {
        if (Pe = (sr = nr.match(l.rePath)) == null ? void 0 : sr[0], !Pe)
          throw new Error("Error: could not extract a path");
        Qe || (le = m(pe, Pe).publicKey);
      } else
        le = pe.publicKey;
    } else
      throw new Error(`Error: could not get pubkey for keyExpression ${Q}`);
    return (be || Pe) && (Te = `m${be ?? ""}${Pe ?? ""}`), {
      keyExpression: Q,
      ...le !== void 0 ? { pubkey: le } : {},
      ...ge !== void 0 ? { ecpair: ge } : {},
      ...pe !== void 0 ? { bip32: pe } : {},
      ...Ie !== void 0 ? { masterFingerprint: Ie } : {},
      ...be !== void 0 && be !== "" ? { originPath: be } : {},
      ...Pe !== void 0 && Pe !== "" ? { keyPath: Pe } : {},
      ...Te !== void 0 ? { path: Te } : {}
    };
  }
  keyExpressions.parseKeyExpression = b;
  function k({ change: Q, index: P, keyPath: x }) {
    if (!(Q === void 0 && P === void 0 || Q !== void 0 && P !== void 0))
      throw new Error("Error: Pass change and index or neither");
    if (Q !== void 0 == (x !== void 0))
      throw new Error("Error: Pass either change and index or a keyPath");
  }
  async function C({ ledgerClient: Q, ledgerState: P, originPath: x, keyPath: M, change: F, index: le }) {
    k({ change: F, index: le, keyPath: M });
    const pe = `[${(await (0, t.getLedgerMasterFingerPrint)({
      ledgerClient: Q,
      ledgerState: P
    })).toString("hex")}${x}]`, Ie = await (0, t.getLedgerXpub)({ originPath: x, ledgerClient: Q, ledgerState: P }), be = `${pe}${Ie}`;
    return M !== void 0 ? `${be}${M}` : `${be}/${F}/${le}`;
  }
  keyExpressions.keyExpressionLedger = C;
  function B({ masterNode: Q, originPath: P, keyPath: x, change: M, index: F, isPublic: le = !0 }) {
    k({ change: M, index: F, keyPath: x });
    const pe = `[${Q.fingerprint.toString("hex")}${P}]`, Ie = le ? Q.derivePath(`m${P}`).neutered().toBase58().toString() : Q.derivePath(`m${P}`).toBase58().toString(), be = `${pe}${Ie}`;
    return x !== void 0 ? `${be}${x}` : `${be}/${M}/${F}`;
  }
  return keyExpressions.keyExpressionBIP32 = B, keyExpressions;
}
var miniscript = {}, dist = {}, bip68, hasRequiredBip68;
function requireBip68() {
  if (hasRequiredBip68) return bip68;
  hasRequiredBip68 = 1;
  const s = 4294967295, A = 1 << 31, u = 9, p = 65535, t = 1 << 22, l = p, m = 1 << u, b = p << u;
  function k(B) {
    return B & A ? {} : B & t ? {
      seconds: (B & p) << u
    } : {
      blocks: B & p
    };
  }
  function C({ blocks: B, seconds: Q }) {
    if (B !== void 0 && Q !== void 0) throw new TypeError("Cannot encode blocks AND seconds");
    if (B === void 0 && Q === void 0) return s;
    if (Q !== void 0) {
      if (!Number.isFinite(Q)) throw new TypeError("Expected Number seconds");
      if (Q > b) throw new TypeError("Expected Number seconds <= " + b);
      if (Q % m !== 0) throw new TypeError("Expected Number seconds as a multiple of " + m);
      return t | Q >> u;
    }
    if (!Number.isFinite(B)) throw new TypeError("Expected Number blocks");
    if (B > p) throw new TypeError("Expected Number blocks <= " + l);
    return B;
  }
  return bip68 = { decode: k, encode: C }, bip68;
}
var hasRequiredDist$1;
function requireDist$1() {
  if (hasRequiredDist$1) return dist;
  hasRequiredDist$1 = 1;
  var s = requireBip68();
  const A = "ABSOLUTE", u = "RELATIVE";
  function p(Ie, be, Pe) {
    if (typeof Ie > "u" && typeof be > "u")
      return;
    if (typeof Pe > "u")
      throw new Error("lockType must be specified");
    if (Pe !== A && Pe !== u)
      throw new Error('lockType must be either "ABSOLUTE" or "RELATIVE"');
    function Te(Qe) {
      return !!(!isNaN(Qe) && !isNaN(parseFloat(Qe)) && Number.isInteger(Number(Qe)));
    }
    if (typeof Ie < "u") {
      if (Te(Ie) === !1)
        throw new Error("nSequence/nLockTime must be an integer: " + Ie);
      if (Ie = Number(Ie), Pe === u && !s.decode(Ie).hasOwnProperty("seconds") && !s.decode(Ie).hasOwnProperty("blocks"))
        throw new Error("Invalid bip68 encoded a value: " + Ie);
    }
    if (typeof be < "u") {
      if (Te(be) === !1)
        throw new Error("nSequence/nLockTime must be an integer: " + be);
      if (be = Number(be), Pe === u && !s.decode(be).hasOwnProperty("seconds") && !s.decode(be).hasOwnProperty("blocks"))
        throw new Error("Invalid bip68 encoded b value: " + be);
    }
    if (typeof Ie < "u" && typeof be < "u") {
      if (Pe === A) {
        if (Ie < 5e8 && be >= 5e8 || Ie >= 5e8 && be < 5e8)
          throw new Error(
            "nLockTime values must be either below 500000000 or both above or equal 500000000"
          );
      } else {
        const Qe = s.decode(Ie), xe = s.decode(be);
        if (Qe.hasOwnProperty("seconds") !== xe.hasOwnProperty("seconds"))
          throw new Error(
            "a and b must both be either represent seconds or block height"
          );
      }
      return Math.max(Ie, be);
    }
    if (typeof Ie < "u") return Ie;
    if (typeof be < "u") return be;
  }
  function t(Ie, be) {
    const Pe = /d?sat\(([^\(]*)\)/, Te = Ie.match(Pe);
    if (Te && Te.length) {
      const Qe = [], xe = Te[0], Ee = Ie.split(xe)[0], He = Ie.slice(xe.length + Ee.length), ve = Te[1], we = xe[0] === "d" ? "dsats" : "sats";
      if (typeof be[ve] != "object")
        throw new Error(
          `satisfactionsMap does not provide sats/dsats solutions for argument ${ve}, evaluating: ${Ie}`
        );
      const Ce = be[ve][we] || [];
      for (const Se of Ce)
        if (He.match(Pe)) {
          const Ne = t(He, be);
          for (const rr of Ne)
            Qe.push({
              nSequence: p(
                Se.nSequence,
                rr.nSequence,
                u
              ),
              nLockTime: p(
                Se.nLockTime,
                rr.nLockTime,
                A
              ),
              asm: `${Ee}${Se.asm}${rr.asm}`
            });
        } else
          Qe.push({
            ...Se,
            asm: `${Ee}${Se.asm}${He}`
          });
      return Qe;
    }
    throw new Error("Invalid solutionTemplate: " + Ie);
  }
  const l = {
    0: () => ({
      dsats: [{ asm: "" }]
    }),
    1: () => ({
      sats: [{ asm: "" }]
    }),
    pk_k: (Ie) => ({
      dsats: [{ asm: "0" }],
      sats: [{ asm: `<sig(${Ie})>` }]
    }),
    pk_h: (Ie) => ({
      dsats: [{ asm: `0 <${Ie}>` }],
      sats: [{ asm: `<sig(${Ie})> <${Ie}>` }]
    }),
    older: (Ie) => ({
      sats: [{ asm: "", nSequence: Ie }]
    }),
    after: (Ie) => ({
      sats: [{ asm: "", nLockTime: Ie }]
    }),
    sha256: (Ie) => ({
      sats: [{ asm: `<sha256_preimage(${Ie})>` }],
      dsats: [{ asm: "<random_preimage()>" }]
    }),
    ripemd160: (Ie) => ({
      sats: [{ asm: `<ripemd160_preimage(${Ie})>` }],
      dsats: [{ asm: "<random_preimage()>" }]
    }),
    hash256: (Ie) => ({
      sats: [{ asm: `<hash256_preimage(${Ie})>` }],
      dsats: [{ asm: "<random_preimage()>" }]
    }),
    hash160: (Ie) => ({
      sats: [{ asm: `<hash160_preimage(${Ie})>` }],
      dsats: [{ asm: "<random_preimage()>" }]
    }),
    andor: (Ie, be, Pe) => ({
      dsats: [
        ...t("dsat(Z) dsat(X)", { X: Ie, Y: be, Z: Pe }),
        ...t("dsat(Y) sat(X)", { X: Ie, Y: be, Z: Pe })
      ],
      sats: [
        ...t("sat(Y) sat(X)", { X: Ie, Y: be, Z: Pe }),
        ...t("sat(Z) dsat(X)", { X: Ie, Y: be, Z: Pe })
      ]
    }),
    and_v: (Ie, be) => ({
      dsats: [...t("dsat(Y) sat(X)", { X: Ie, Y: be })],
      sats: [...t("sat(Y) sat(X)", { X: Ie, Y: be })]
    }),
    and_b: (Ie, be) => ({
      dsats: [
        ...t("dsat(Y) dsat(X)", { X: Ie, Y: be }),
        //https://bitcoin.sipa.be/miniscript/
        //The non-canonical options for and_b, or_b, and thresh are always
        //overcomplete (reason 3), so instead use DONTUSE there
        ...t("sat(Y) dsat(X)", { X: Ie, Y: be }),
        ...t("dsat(Y) sat(X)", { X: Ie, Y: be })
      ],
      sats: [...t("sat(Y) sat(X)", { Y: be, X: Ie })]
    }),
    or_b: (Ie, be) => ({
      dsats: [...t("dsat(Z) dsat(X)", { X: Ie, Z: be })],
      sats: [
        ...t("dsat(Z) sat(X)", { X: Ie, Z: be }),
        ...t("sat(Z) dsat(X)", { X: Ie, Z: be }),
        //https://bitcoin.sipa.be/miniscript/
        //The non-canonical options for and_b, or_b, and thresh are always
        //overcomplete (reason 3), so instead use DONTUSE there
        ...t("sat(Z) sat(X)", { X: Ie, Z: be })
      ]
    }),
    or_c: (Ie, be) => ({
      sats: [
        ...t("sat(X)", { X: Ie, Z: be }),
        ...t("sat(Z) dsat(X)", { X: Ie, Z: be })
      ]
    }),
    or_d: (Ie, be) => ({
      dsats: [...t("dsat(Z) dsat(X)", { X: Ie, Z: be })],
      sats: [
        ...t("sat(X)", { X: Ie, Z: be }),
        ...t("sat(Z) dsat(X)", { X: Ie, Z: be })
      ]
    }),
    or_i: (Ie, be) => ({
      dsats: [
        ...t("dsat(X) 1", { X: Ie, Z: be }),
        ...t("dsat(Z) 0", { X: Ie, Z: be })
      ],
      sats: [...t("sat(X) 1", { X: Ie, Z: be }), ...t("sat(Z) 0", { X: Ie, Z: be })]
    }),
    /*
     * This is not entirely trivial from the docs
     * (https://bitcoin.sipa.be/miniscript/),
     *  but solution templates for thresh must be written in reverse order.
     *  For example the first dsat, which is "All dsats", corresponds to:
     *  "<DSAT_N> <DSAT_N-1> ... <DSAT_1>" (note the reverse order in N)
     *  While this is not entirely trivial by reading the document
     *  it can be deduced by analyzing the script:
     *  thresh(k,X1,...,Xn)	[X1] [X2] ADD ... [Xn] ADD ... <k> EQUAL
     */
    thresh: (Ie, ...be) => {
      if (Number.isInteger(Number(Ie)) && Number(Ie) > 0) Ie = Number(Ie);
      else throw new Error(`k must be positive number: ${Ie}`);
      const Pe = {}, Te = be.length;
      be.map((ve, we) => {
        Pe[we] = ve;
      });
      const Qe = [], xe = [];
      Qe.push(
        ...t(
          Object.keys(Pe).map((ve) => `dsat(${ve})`).reverse().join(" "),
          Pe
        )
      );
      const Ee = [], He = [];
      for (let ve = 1; ve < 1 << Te; ve++) {
        const we = [];
        let Ce = 0;
        for (let Se = 0; Se < Te; Se++)
          ve & 1 << Se && Ce++, we.push(ve & 1 << Se ? `sat(${Se})` : `dsat(${Se})`);
        Ce !== Ie ? Ee.push(we.reverse().join(" ")) : He.push(we.reverse().join(" "));
      }
      for (const ve of Ee)
        Qe.push(...t(ve, Pe));
      for (const ve of He)
        xe.push(...t(ve, Pe));
      return { dsats: Qe, sats: xe };
    },
    multi: (Ie, ...be) => {
      if (Number.isInteger(Number(Ie)) && Number(Ie) > 0) Ie = Number(Ie);
      else throw new Error(`k must be positive number: ${Ie}`);
      if (typeof Ie != "number") throw new Error("k must be a number:" + Ie);
      if (Ie === 0) throw new Error("k cannot be 0");
      const Pe = [{ asm: "0 ".repeat(Ie + 1).trim() }];
      function Te(He, ve) {
        if (ve === 0)
          return [[]];
        const we = [];
        for (let Ce = 0; Ce < He.length; Ce++) {
          const Se = He.slice(Ce + 1);
          Te(Se, ve - 1).forEach((rr) => {
            we.push([He[Ce], ...rr]);
          });
        }
        return we;
      }
      const Qe = [];
      Te(be, Ie).forEach((He) => {
        let ve = "0";
        He.forEach((we) => {
          ve += ` <sig(${we})>`;
        }), Qe.push(ve);
      });
      let xe = "0";
      for (let He = 0; He < Ie; He++)
        xe += ` <sig(${be[He]})>`;
      return { sats: Qe.map((He) => ({ asm: He })), dsats: Pe };
    },
    a: (Ie) => ({
      dsats: [...t("dsat(X)", { X: Ie })],
      sats: [...t("sat(X)", { X: Ie })]
    }),
    s: (Ie) => ({
      dsats: [...t("dsat(X)", { X: Ie })],
      sats: [...t("sat(X)", { X: Ie })]
    }),
    c: (Ie) => ({
      dsats: [...t("dsat(X)", { X: Ie })],
      sats: [...t("sat(X)", { X: Ie })]
    }),
    d: (Ie) => ({
      dsats: [{ asm: "0" }],
      sats: [...t("sat(X) 1", { X: Ie })]
    }),
    v: (Ie) => ({
      sats: [...t("sat(X)", { X: Ie })]
    }),
    /**
    	   * j:X corresponds to SIZE 0NOTEQUAL IF [X] ENDIF
    	   *
    	   * By definition, this: "dsat(X) X" produces a zero.
    	   *
    	   *
    	   * A dsat needs to make this "dsat(X) X" return zero.
    
    	   * The easiest dsat for j:X is using 0:
    	   * 0 SIZE 0NOTEQUAL IF [X] ENDIF
    	   * 0 0 0NOTEQUAL IF [X] ENDIF
    	   * 0 0 IF [X] ENDIF
    	   * 0
    
    	   * Now let's do the case where dsat(X) finishes with a 0: "... 0"
    	   * ... 0 SIZE 0NOTEQUAL IF [X] ENDIF
    	   * ... 0 0 0NOTEQUAL IF [X] ENDIF
    	   * ... 0 0 IF [X] ENDIF 
    	   * ... 0
    	   * DSAT(X)
    	   * The final expression is "DSAT(X)".
    	   * It should have either been "0" or "DSAT(X) X"
    	   * Thus, this is not a valid dsat.
    
    	   * Now let's do the case where dsat(X) is this: "... <nonzero>"
    	   * ... <nonzero> SIZE 0NOTEQUAL IF [X] ENDIF
    	   * ... <nonzero> <length_is_nonzero> 0NOTEQUAL IF [X] ENDIF
    	   * ... <nonzero> 1 IF [X] ENDIF
    	   * ... <nonzero> [X]
    	   * DSAT(X) [X]
    
    	   * DSAT(X) X is a good dsat
    	   */
    j: (Ie) => {
      const be = [];
      be.push({ asm: "0" });
      const Pe = Ie.dsats.filter(
        //The top stack corresponds to the last element pushed to the stack,
        //that is, the last element in the produced witness
        (Te) => Te.asm.trim().split(" ").pop() !== "0"
      );
      return be.push(...Pe), { dsats: be, sats: [...t("sat(X)", { X: Ie })] };
    },
    n: (Ie) => ({
      dsats: [...t("dsat(X)", { X: Ie })],
      sats: [...t("sat(X)", { X: Ie })]
    })
  };
  function m(Ie, be) {
    return be = { exports: {} }, Ie(be, be.exports), be.exports;
  }
  var b = m(function(Ie, be) {
    var Pe = (() => {
      var Te = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
      return function(Qe = {}) {
        var xe = Qe, Ee, He;
        xe.ready = new Promise((pi, bi) => {
          Ee = pi, He = bi;
        });
        var ve = Object.assign({}, xe), we = "./this.program", Ce = "";
        function Se(pi) {
          return xe.locateFile ? xe.locateFile(pi, Ce) : Ce + pi;
        }
        typeof document < "u" && document.currentScript && (Ce = document.currentScript.src), Te && (Ce = Te), Ce.indexOf("blob:") !== 0 ? Ce = Ce.substr(0, Ce.replace(/[?#].*/, "").lastIndexOf("/") + 1) : Ce = "", xe.print || console.log.bind(console);
        var Ne = xe.printErr || console.error.bind(console);
        Object.assign(xe, ve), ve = null, xe.arguments && xe.arguments, xe.thisProgram && (we = xe.thisProgram), xe.quit && xe.quit;
        var rr;
        xe.wasmBinary && (rr = xe.wasmBinary), xe.noExitRuntime;
        var er = { Memory: function(pi) {
          this.buffer = new ArrayBuffer(pi.initial * 65536);
        }, Module: function(pi) {
        }, Instance: function(pi, bi) {
          this.exports = // EMSCRIPTEN_START_ASM
          function(Wi) {
            function ns(qo) {
              return qo.set = function(Us, au) {
                this[Us] = au;
              }, qo.get = function(Us) {
                return this[Us];
              }, qo;
            }
            for (var ji, rs = new Uint8Array(123), Is = 25; Is >= 0; --Is)
              rs[48 + Is] = 52 + Is, rs[65 + Is] = Is, rs[97 + Is] = 26 + Is;
            rs[43] = 62, rs[47] = 63;
            function ds(qo, Us, au) {
              for (var Ja, $, Vs = 0, e = Us, ye = au.length, fa = Us + (ye * 3 >> 2) - (au[ye - 2] == "=") - (au[ye - 1] == "="); Vs < ye; Vs += 4)
                Ja = rs[au.charCodeAt(Vs + 1)], $ = rs[au.charCodeAt(Vs + 2)], qo[e++] = rs[au.charCodeAt(Vs)] << 2 | Ja >> 4, e < fa && (qo[e++] = Ja << 4 | $ >> 2), e < fa && (qo[e++] = $ << 6 | rs[au.charCodeAt(Vs + 3)]);
            }
            function bo(qo) {
              ds(ji, 1024, "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"), ds(ji, 5584, "////////////////////////////////////////////////////////////////AAECAwQFBgcICf////////8KCwwNDg///////////////////////////////////woLDA0OD/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////4QAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADEDwAAgw8AAFcPAADcDwAAtw0AAFQQAACtDwAAdA8AAGUPAABNDwAAQg8AABMPAAALDwAA+w4AALIQAADZDwAAoA8AAGcPAABkDwAATA8AAEEPAADFCwAAfAsAAB8NAAAlDQAAOg0AAC4NAABeDQAAQw0AADUKAADvCwAA0gwAAOAMAAC8CwAArAsAAKQLAACLCwAA/woAANsLAACbCwAA8AwAALQLAACUCwAAzAsAAIMLAADKDAAAWQwAAPgKAADTCwAAwgwAADMLAABKCwAAKwsAAA4LAABMDQAA7goAAKUNAABUCwAAWgsAAGgMAAA/CgAAtw8AAHYPAADKDQAA3w0AADYMAADmCgAAVA0AADoLAAAHCwAAgAwAAMMNAADYDQAALwwAAN8KAACeDQAAIQsAABcLAACsDQAAcgsAALYMAABOCgAAcQwAAA4MAAAaDAAAjQwAAKAMAAD5CwAA0goAAAAMAABzEAAA0Q8AADcPAABoEAAALA8AAGELAAD+DAAAYAoAAAoNAAByCgAArw8AAIkKAACgCgAATw8AAEQPAAAVDwAADQ8AAP0OAAC2DgAArBAAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAI0NAAAEXwAABF8AAARfAAAEXwAABF8AAARfAAAEXwAABF8AAARfAAAEXwAAFF8AACRfAAA0XwAARF8AAFRfAABkXwAAdF8AAIRfAACUXwAApF8AAMRfAAC0XwAA1F8AAORfAAAEXwAABF8="), ds(ji, 6976, "MDEyMzQ1Njc4OWFiY2RlZgAAAAAAAAAAJAEAACUBAAAmAQAAJwEAACgBAAAAAAAAGQAKABkZGQAAAAAFAAAAAAAACQAAAAALAAAAAAAAAAAZABEKGRkZAwoHAAEACQsYAAAJBgsAAAsABhkAAAAZGRk="), ds(ji, 7105, "DgAAAAAAAAAAGQAKDRkZGQANAAACAAkOAAAACQAOAAAO"), ds(ji, 7163, "DA=="), ds(ji, 7175, "EwAAAAATAAAAAAkMAAAAAAAMAAAM"), ds(ji, 7221, "EA=="), ds(ji, 7233, "DwAAAAQPAAAAAAkQAAAAAAAQAAAQ"), ds(ji, 7279, "Eg=="), ds(ji, 7291, "EQAAAAARAAAAAAkSAAAAAAASAAASAAAaAAAAGhoa"), ds(ji, 7346, "GgAAABoaGgAAAAAAAAk="), ds(ji, 7395, "FA=="), ds(ji, 7407, "FwAAAAAXAAAAAAkUAAAAAAAUAAAU"), ds(ji, 7453, "Fg=="), ds(ji, 7465, "FQAAAAAVAAAAAAkWAAAAAAAWAAAWAAAwMTIzNDU2Nzg5QUJDREVGAAAAAAIAAAADAAAABQAAAAcAAAALAAAADQAAABEAAAATAAAAFwAAAB0AAAAfAAAAJQAAACkAAAArAAAALwAAADUAAAA7AAAAPQAAAEMAAABHAAAASQAAAE8AAABTAAAAWQAAAGEAAABlAAAAZwAAAGsAAABtAAAAcQAAAH8AAACDAAAAiQAAAIsAAACVAAAAlwAAAJ0AAACjAAAApwAAAK0AAACzAAAAtQAAAL8AAADBAAAAxQAAAMcAAADTAAAAAQAAAAsAAAANAAAAEQAAABMAAAAXAAAAHQAAAB8AAAAlAAAAKQAAACsAAAAvAAAANQAAADsAAAA9AAAAQwAAAEcAAABJAAAATwAAAFMAAABZAAAAYQAAAGUAAABnAAAAawAAAG0AAABxAAAAeQAAAH8AAACDAAAAiQAAAIsAAACPAAAAlQAAAJcAAACdAAAAowAAAKcAAACpAAAArQAAALMAAAC1AAAAuwAAAL8AAADBAAAAxQAAAMcAAADRAAAAAAAAALwfAAApAQAAKgEAACsBAAAsAQAALQEAAC4BAAAvAQAAMAEAADEBAAAyAQAAMwEAADQBAAA1AQAANgEAAAAAAABQIAAANwEAADgBAAArAQAALAEAADkBAAA6AQAALwEAADABAAAxAQAAOwEAADMBAAA8AQAANQEAAD0BAABOU3QzX18yOWJhc2ljX2lvc0ljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRQAAACRZAABQHwAAXCEAAE5TdDNfXzIxNWJhc2ljX3N0cmVhbWJ1ZkljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRQAAAADkWAAAiB8AAE5TdDNfXzIxM2Jhc2ljX29zdHJlYW1JY05TXzExY2hhcl90cmFpdHNJY0VFRUUAAABXAADEHwAAAAAAAAEAAAB8HwAAA/T//05TdDNfXzIxNWJhc2ljX3N0cmluZ2J1ZkljTlNfMTFjaGFyX3RyYWl0c0ljRUVOU185YWxsb2NhdG9ySWNFRUVFAAAAJFkAAAwgAAC8HwAAOAAAAAAAAAD0IAAAPgEAAD8BAADI////yP////QgAABAAQAAQQEAADgAAAAAAAAA9B8AAEIBAABDAQAAyP///8j////0HwAARAEAAEUBAABOU3QzX18yMTliYXNpY19vc3RyaW5nc3RyZWFtSWNOU18xMWNoYXJfdHJhaXRzSWNFRU5TXzlhbGxvY2F0b3JJY0VFRUUAAAAkWQAArCAAAPQfAAAAAAAArCEAAEYBAABHAQAASAEAAEkBAABKAQAASwEAAEwBAAAAAAAAgCEAALEAAABNAQAATgEAAAAAAABcIQAATwEAAFABAABOU3QzX18yOGlvc19iYXNlRQAAAORYAABIIQAATlN0M19fMjhpb3NfYmFzZTdmYWlsdXJlRQAAACRZAABkIQAAlFUAAE5TdDNfXzIxOV9faW9zdHJlYW1fY2F0ZWdvcnlFAAAAJFkAAIwhAADkVQ=="), ds(ji, 8640, "/////////////////////////////////////////////////////////////////wABAgMEBQYHCAn/////////CgsMDQ4PEBESExQVFhcYGRobHB0eHyAhIiP///////8KCwwNDg8QERITFBUWFxgZGhscHR4fICEiI/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8AAQIEBwMGBQAAAAAAAADRdJ4AV529KoBwUg///z4nCgAAAGQAAADoAwAAECcAAKCGAQBAQg8AgJaYAADh9QUYAAAANQAAAHEAAABr////zvv//5K///8AAAAAAAAAAN4SBJUAAAAA////////////////"), ds(ji, 9024, "TENfQ1RZUEUAAAAATENfTlVNRVJJQwAATENfVElNRQAAAAAATENfQ09MTEFURQAATENfTU9ORVRBUlkATENfTUVTU0FHRVMAICMAABQAAABDLlVURi04"), ds(ji, 9652, "AQAAAAIAAAADAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAEAAAABEAAAASAAAAEwAAABQAAAAVAAAAFgAAABcAAAAYAAAAGQAAABoAAAAbAAAAHAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIgAAACMAAAAkAAAAJQAAACYAAAAnAAAAKAAAACkAAAAqAAAAKwAAACwAAAAtAAAALgAAAC8AAAAwAAAAMQAAADIAAAAzAAAANAAAADUAAAA2AAAANwAAADgAAAA5AAAAOgAAADsAAAA8AAAAPQAAAD4AAAA/AAAAQAAAAGEAAABiAAAAYwAAAGQAAABlAAAAZgAAAGcAAABoAAAAaQAAAGoAAABrAAAAbAAAAG0AAABuAAAAbwAAAHAAAABxAAAAcgAAAHMAAAB0AAAAdQAAAHYAAAB3AAAAeAAAAHkAAAB6AAAAWwAAAFwAAABdAAAAXgAAAF8AAABgAAAAYQAAAGIAAABjAAAAZAAAAGUAAABmAAAAZwAAAGgAAABpAAAAagAAAGsAAABsAAAAbQAAAG4AAABvAAAAcAAAAHEAAAByAAAAcwAAAHQAAAB1AAAAdgAAAHcAAAB4AAAAeQAAAHoAAAB7AAAAfAAAAH0AAAB+AAAAfw=="), ds(ji, 11188, "AQAAAAIAAAADAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAEAAAABEAAAASAAAAEwAAABQAAAAVAAAAFgAAABcAAAAYAAAAGQAAABoAAAAbAAAAHAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIgAAACMAAAAkAAAAJQAAACYAAAAnAAAAKAAAACkAAAAqAAAAKwAAACwAAAAtAAAALgAAAC8AAAAwAAAAMQAAADIAAAAzAAAANAAAADUAAAA2AAAANwAAADgAAAA5AAAAOgAAADsAAAA8AAAAPQAAAD4AAAA/AAAAQAAAAEEAAABCAAAAQwAAAEQAAABFAAAARgAAAEcAAABIAAAASQAAAEoAAABLAAAATAAAAE0AAABOAAAATwAAAFAAAABRAAAAUgAAAFMAAABUAAAAVQAAAFYAAABXAAAAWAAAAFkAAABaAAAAWwAAAFwAAABdAAAAXgAAAF8AAABgAAAAQQAAAEIAAABDAAAARAAAAEUAAABGAAAARwAAAEgAAABJAAAASgAAAEsAAABMAAAATQAAAE4AAABPAAAAUAAAAFEAAABSAAAAUwAAAFQAAABVAAAAVgAAAFcAAABYAAAAWQAAAFoAAAB7AAAAfAAAAH0AAAB+AAAAfw=="), ds(ji, 12208, "AgAAwAMAAMAEAADABQAAwAYAAMAHAADACAAAwAkAAMAKAADACwAAwAwAAMANAADADgAAwA8AAMAQAADAEQAAwBIAAMATAADAFAAAwBUAAMAWAADAFwAAwBgAAMAZAADAGgAAwBsAAMAcAADAHQAAwB4AAMAfAADAAAAAswEAAMMCAADDAwAAwwQAAMMFAADDBgAAwwcAAMMIAADDCQAAwwoAAMMLAADDDAAAww0AANMOAADDDwAAwwAADLsBAAzDAgAMwwMADMMEAAzbAAAAADAxMjM0NTY3ODlhYmNkZWZBQkNERUZ4WCstcFBpSW5OACVJOiVNOiVTICVwJUg6JU0="), ds(ji, 12480, "JQAAAG0AAAAvAAAAJQAAAGQAAAAvAAAAJQAAAHkAAAAlAAAAWQAAAC0AAAAlAAAAbQAAAC0AAAAlAAAAZAAAACUAAABJAAAAOgAAACUAAABNAAAAOgAAACUAAABTAAAAIAAAACUAAABwAAAAAAAAACUAAABIAAAAOgAAACUAAABN"), ds(ji, 12624, "JQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAAAAAAxDoAAFEBAABSAQAAUwEAAAAAAAAkOwAAVAEAAFUBAABTAQAAVgEAAFcBAABYAQAAWQEAAFoBAABbAQAAXAEAAF0B"), ds(ji, 12736, "BAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABQIAAAUAAAAFAAAABQAAAAUAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAADAgAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAQgEAAEIBAABCAQAAQgEAAEIBAABCAQAAQgEAAEIBAABCAQAAQgEAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAAAqAQAAKgEAACoBAAAqAQAAKgEAACoBAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAADIBAAAyAQAAMgEAADIBAAAyAQAAMgEAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAggAAAIIAAACCAAAAggAAAAQ="), ds(ji, 13764, "jDoAAF4BAABfAQAAUwEAAGABAABhAQAAYgEAAGMBAABkAQAAZQEAAGYBAAAAAAAAXDsAAGcBAABoAQAAUwEAAGkBAABqAQAAawEAAGwBAABtAQAAAAAAAIA7AABuAQAAbwEAAFMBAABwAQAAcQEAAHIBAABzAQAAdAEAAHQAAAByAAAAdQAAAGUAAAAAAAAAZgAAAGEAAABsAAAAcwAAAGUAAAAAAAAAJQAAAG0AAAAvAAAAJQAAAGQAAAAvAAAAJQAAAHkAAAAAAAAAJQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAAAAAAJQAAAGEAAAAgAAAAJQAAAGIAAAAgAAAAJQAAAGQAAAAgAAAAJQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAgAAAAJQAAAFkAAAAAAAAAJQAAAEkAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAgAAAAJQAAAHA="), ds(ji, 14140, "ZDcAAHUBAAB2AQAAUwEAAE5TdDNfXzI2bG9jYWxlNWZhY2V0RQAAACRZAABMNwAA3FUAAAAAAADkNwAAdQEAAHcBAABTAQAAeAEAAHkBAAB6AQAAewEAAHwBAAB9AQAAfgEAAH8BAACAAQAAgQEAAIIBAACDAQAATlN0M19fMjVjdHlwZUl3RUUATlN0M19fMjEwY3R5cGVfYmFzZUUAAORYAADGNwAAAFcAALQ3AAAAAAAAAgAAAGQ3AAACAAAA3DcAAAIAAAAAAAAAeDgAAHUBAACEAQAAUwEAAIUBAACGAQAAhwEAAIgBAACJAQAAigEAAIsBAABOU3QzX18yN2NvZGVjdnRJY2MxMV9fbWJzdGF0ZV90RUUATlN0M19fMjEyY29kZWN2dF9iYXNlRQAAAADkWAAAVjgAAABXAAA0OAAAAAAAAAIAAABkNwAAAgAAAHA4AAACAAAAAAAAAOw4AAB1AQAAjAEAAFMBAACNAQAAjgEAAI8BAACQAQAAkQEAAJIBAACTAQAATlN0M19fMjdjb2RlY3Z0SURzYzExX19tYnN0YXRlX3RFRQAAAFcAAMg4AAAAAAAAAgAAAGQ3AAACAAAAcDgAAAIAAAAAAAAAYDkAAHUBAACUAQAAUwEAAJUBAACWAQAAlwEAAJgBAACZAQAAmgEAAJsBAABOU3QzX18yN2NvZGVjdnRJRHNEdTExX19tYnN0YXRlX3RFRQAAVwAAPDkAAAAAAAACAAAAZDcAAAIAAABwOAAAAgAAAAAAAADUOQAAdQEAAJwBAABTAQAAnQEAAJ4BAACfAQAAoAEAAKEBAACiAQAAowEAAE5TdDNfXzI3Y29kZWN2dElEaWMxMV9fbWJzdGF0ZV90RUUAAABXAACwOQAAAAAAAAIAAABkNwAAAgAAAHA4AAACAAAAAAAAAEg6AAB1AQAApAEAAFMBAAClAQAApgEAAKcBAACoAQAAqQEAAKoBAACrAQAATlN0M19fMjdjb2RlY3Z0SURpRHUxMV9fbWJzdGF0ZV90RUUAAFcAACQ6AAAAAAAAAgAAAGQ3AAACAAAAcDgAAAIAAABOU3QzX18yN2NvZGVjdnRJd2MxMV9fbWJzdGF0ZV90RUUAAAAAVwAAaDoAAAAAAAACAAAAZDcAAAIAAABwOAAAAgAAAE5TdDNfXzI2bG9jYWxlNV9faW1wRQAAACRZAACsOgAAZDcAAE5TdDNfXzI3Y29sbGF0ZUljRUUAJFkAANA6AABkNwAATlN0M19fMjdjb2xsYXRlSXdFRQAkWQAA8DoAAGQ3AABOU3QzX18yNWN0eXBlSWNFRQAAAABXAAAQOwAAAAAAAAIAAABkNwAAAgAAANw3AAACAAAATlN0M19fMjhudW1wdW5jdEljRUUAAAAAJFkAAEQ7AABkNwAATlN0M19fMjhudW1wdW5jdEl3RUUAAAAAJFkAAGg7AABkNwAAAAAAAOQ6AACsAQAArQEAAFMBAACuAQAArwEAALABAAAAAAAABDsAALEBAACyAQAAUwEAALMBAAC0AQAAtQEAAAAAAACgPAAAdQEAALYBAABTAQAAtwEAALgBAAC5AQAAugEAALsBAAC8AQAAvQEAAL4BAAC/AQAAwAEAAMEBAABOU3QzX18yN251bV9nZXRJY05TXzE5aXN0cmVhbWJ1Zl9pdGVyYXRvckljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRUVFAE5TdDNfXzI5X19udW1fZ2V0SWNFRQBOU3QzX18yMTRfX251bV9nZXRfYmFzZUUAAORYAABmPAAAAFcAAFA8AAAAAAAAAQAAAIA8AAAAAAAAAFcAAAw8AAAAAAAAAgAAAGQ3AAACAAAAiDw="), ds(ji, 15556, "dD0AAHUBAADCAQAAUwEAAMMBAADEAQAAxQEAAMYBAADHAQAAyAEAAMkBAADKAQAAywEAAMwBAADNAQAATlN0M19fMjdudW1fZ2V0SXdOU18xOWlzdHJlYW1idWZfaXRlcmF0b3JJd05TXzExY2hhcl90cmFpdHNJd0VFRUVFRQBOU3QzX18yOV9fbnVtX2dldEl3RUUAAAAAVwAARD0AAAAAAAABAAAAgDwAAAAAAAAAVwAAAD0AAAAAAAACAAAAZDcAAAIAAABcPQ=="), ds(ji, 15768, "XD4AAHUBAADOAQAAUwEAAM8BAADQAQAA0QEAANIBAADTAQAA1AEAANUBAADWAQAATlN0M19fMjdudW1fcHV0SWNOU18xOW9zdHJlYW1idWZfaXRlcmF0b3JJY05TXzExY2hhcl90cmFpdHNJY0VFRUVFRQBOU3QzX18yOV9fbnVtX3B1dEljRUUATlN0M19fMjE0X19udW1fcHV0X2Jhc2VFAADkWAAAIj4AAABXAAAMPgAAAAAAAAEAAAA8PgAAAAAAAABXAADIPQAAAAAAAAIAAABkNwAAAgAAAEQ+"), ds(ji, 16e3, "JD8AAHUBAADXAQAAUwEAANgBAADZAQAA2gEAANsBAADcAQAA3QEAAN4BAADfAQAATlN0M19fMjdudW1fcHV0SXdOU18xOW9zdHJlYW1idWZfaXRlcmF0b3JJd05TXzExY2hhcl90cmFpdHNJd0VFRUVFRQBOU3QzX18yOV9fbnVtX3B1dEl3RUUAAAAAVwAA9D4AAAAAAAABAAAAPD4AAAAAAAAAVwAAsD4AAAAAAAACAAAAZDcAAAIAAAAMPw=="), ds(ji, 16200, "JEAAAOABAADhAQAAUwEAAOIBAADjAQAA5AEAAOUBAADmAQAA5wEAAOgBAAD4////JEAAAOkBAADqAQAA6wEAAOwBAADtAQAA7gEAAO8BAABOU3QzX18yOHRpbWVfZ2V0SWNOU18xOWlzdHJlYW1idWZfaXRlcmF0b3JJY05TXzExY2hhcl90cmFpdHNJY0VFRUVFRQBOU3QzX18yOXRpbWVfYmFzZUUA5FgAAN0/AABOU3QzX18yMjBfX3RpbWVfZ2V0X2Nfc3RvcmFnZUljRUUAAADkWAAA+D8AAABXAACYPwAAAAAAAAMAAABkNwAAAgAAAPA/AAACAAAAHEAAAAAIAAAAAAAAEEEAAPABAADxAQAAUwEAAPIBAADzAQAA9AEAAPUBAAD2AQAA9wEAAPgBAAD4////EEEAAPkBAAD6AQAA+wEAAPwBAAD9AQAA/gEAAP8BAABOU3QzX18yOHRpbWVfZ2V0SXdOU18xOWlzdHJlYW1idWZfaXRlcmF0b3JJd05TXzExY2hhcl90cmFpdHNJd0VFRUVFRQBOU3QzX18yMjBfX3RpbWVfZ2V0X2Nfc3RvcmFnZUl3RUUAAORYAADlQAAAAFcAAKBAAAAAAAAAAwAAAGQ3AAACAAAA8D8AAAIAAAAIQQAAAAgAAAAAAAC0QQAAAAIAAAECAABTAQAAAgIAAE5TdDNfXzI4dGltZV9wdXRJY05TXzE5b3N0cmVhbWJ1Zl9pdGVyYXRvckljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRUVFAE5TdDNfXzIxMF9fdGltZV9wdXRFAAAA5FgAAJVBAAAAVwAAUEEAAAAAAAACAAAAZDcAAAIAAACsQQAAAAgAAAAAAAA0QgAAAwIAAAQCAABTAQAABQIAAE5TdDNfXzI4dGltZV9wdXRJd05TXzE5b3N0cmVhbWJ1Zl9pdGVyYXRvckl3TlNfMTFjaGFyX3RyYWl0c0l3RUVFRUVFAAAAAABXAADsQQAAAAAAAAIAAABkNwAAAgAAAKxBAAAACAAAAAAAAMhCAAB1AQAABgIAAFMBAAAHAgAACAIAAAkCAAAKAgAACwIAAAwCAAANAgAADgIAAA8CAABOU3QzX18yMTBtb25leXB1bmN0SWNMYjBFRUUATlN0M19fMjEwbW9uZXlfYmFzZUUAAAAA5FgAAKhCAAAAVwAAjEIAAAAAAAACAAAAZDcAAAIAAADAQgAAAgAAAAAAAAA8QwAAdQEAABACAABTAQAAEQIAABICAAATAgAAFAIAABUCAAAWAgAAFwIAABgCAAAZAgAATlN0M19fMjEwbW9uZXlwdW5jdEljTGIxRUVFAABXAAAgQwAAAAAAAAIAAABkNwAAAgAAAMBCAAACAAAAAAAAALBDAAB1AQAAGgIAAFMBAAAbAgAAHAIAAB0CAAAeAgAAHwIAACACAAAhAgAAIgIAACMCAABOU3QzX18yMTBtb25leXB1bmN0SXdMYjBFRUUAAFcAAJRDAAAAAAAAAgAAAGQ3AAACAAAAwEIAAAIAAAAAAAAAJEQAAHUBAAAkAgAAUwEAACUCAAAmAgAAJwIAACgCAAApAgAAKgIAACsCAAAsAgAALQIAAE5TdDNfXzIxMG1vbmV5cHVuY3RJd0xiMUVFRQAAVwAACEQAAAAAAAACAAAAZDcAAAIAAADAQgAAAgAAAAAAAADIRAAAdQEAAC4CAABTAQAALwIAADACAABOU3QzX18yOW1vbmV5X2dldEljTlNfMTlpc3RyZWFtYnVmX2l0ZXJhdG9ySWNOU18xMWNoYXJfdHJhaXRzSWNFRUVFRUUATlN0M19fMjExX19tb25leV9nZXRJY0VFAADkWAAApkQAAABXAABgRAAAAAAAAAIAAABkNwAAAgAAAMBE"), ds(ji, 17644, "bEUAAHUBAAAxAgAAUwEAADICAAAzAgAATlN0M19fMjltb25leV9nZXRJd05TXzE5aXN0cmVhbWJ1Zl9pdGVyYXRvckl3TlNfMTFjaGFyX3RyYWl0c0l3RUVFRUVFAE5TdDNfXzIxMV9fbW9uZXlfZ2V0SXdFRQAA5FgAAEpFAAAAVwAABEUAAAAAAAACAAAAZDcAAAIAAABkRQ=="), ds(ji, 17808, "EEYAAHUBAAA0AgAAUwEAADUCAAA2AgAATlN0M19fMjltb25leV9wdXRJY05TXzE5b3N0cmVhbWJ1Zl9pdGVyYXRvckljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRUVFAE5TdDNfXzIxMV9fbW9uZXlfcHV0SWNFRQAA5FgAAO5FAAAAVwAAqEUAAAAAAAACAAAAZDcAAAIAAAAIRg=="), ds(ji, 17972, "tEYAAHUBAAA3AgAAUwEAADgCAAA5AgAATlN0M19fMjltb25leV9wdXRJd05TXzE5b3N0cmVhbWJ1Zl9pdGVyYXRvckl3TlNfMTFjaGFyX3RyYWl0c0l3RUVFRUVFAE5TdDNfXzIxMV9fbW9uZXlfcHV0SXdFRQAA5FgAAJJGAAAAVwAATEYAAAAAAAACAAAAZDcAAAIAAACsRg=="), ds(ji, 18136, "LEcAAHUBAAA6AgAAUwEAADsCAAA8AgAAPQIAAE5TdDNfXzI4bWVzc2FnZXNJY0VFAE5TdDNfXzIxM21lc3NhZ2VzX2Jhc2VFAAAAAORYAAAJRwAAAFcAAPRGAAAAAAAAAgAAAGQ3AAACAAAAJEcAAAIAAAAAAAAAhEcAAHUBAAA+AgAAUwEAAD8CAABAAgAAQQIAAE5TdDNfXzI4bWVzc2FnZXNJd0VFAAAAAABXAABsRwAAAAAAAAIAAABkNwAAAgAAACRHAAACAAAAUwAAAHUAAABuAAAAZAAAAGEAAAB5AAAAAAAAAE0AAABvAAAAbgAAAGQAAABhAAAAeQAAAAAAAABUAAAAdQAAAGUAAABzAAAAZAAAAGEAAAB5AAAAAAAAAFcAAABlAAAAZAAAAG4AAABlAAAAcwAAAGQAAABhAAAAeQAAAAAAAABUAAAAaAAAAHUAAAByAAAAcwAAAGQAAABhAAAAeQAAAAAAAABGAAAAcgAAAGkAAABkAAAAYQAAAHkAAAAAAAAAUwAAAGEAAAB0AAAAdQAAAHIAAABkAAAAYQAAAHkAAAAAAAAAUwAAAHUAAABuAAAAAAAAAE0AAABvAAAAbgAAAAAAAABUAAAAdQAAAGUAAAAAAAAAVwAAAGUAAABkAAAAAAAAAFQAAABoAAAAdQAAAAAAAABGAAAAcgAAAGkAAAAAAAAAUwAAAGEAAAB0AAAAAAAAAEoAAABhAAAAbgAAAHUAAABhAAAAcgAAAHkAAAAAAAAARgAAAGUAAABiAAAAcgAAAHUAAABhAAAAcgAAAHkAAAAAAAAATQAAAGEAAAByAAAAYwAAAGgAAAAAAAAAQQAAAHAAAAByAAAAaQAAAGwAAAAAAAAATQAAAGEAAAB5AAAAAAAAAEoAAAB1AAAAbgAAAGUAAAAAAAAASgAAAHUAAABsAAAAeQAAAAAAAABBAAAAdQAAAGcAAAB1AAAAcwAAAHQAAAAAAAAAUwAAAGUAAABwAAAAdAAAAGUAAABtAAAAYgAAAGUAAAByAAAAAAAAAE8AAABjAAAAdAAAAG8AAABiAAAAZQAAAHIAAAAAAAAATgAAAG8AAAB2AAAAZQAAAG0AAABiAAAAZQAAAHIAAAAAAAAARAAAAGUAAABjAAAAZQAAAG0AAABiAAAAZQAAAHIAAAAAAAAASgAAAGEAAABuAAAAAAAAAEYAAABlAAAAYgAAAAAAAABNAAAAYQAAAHIAAAAAAAAAQQAAAHAAAAByAAAAAAAAAEoAAAB1AAAAbgAAAAAAAABKAAAAdQAAAGwAAAAAAAAAQQAAAHUAAABnAAAAAAAAAFMAAABlAAAAcAAAAAAAAABPAAAAYwAAAHQAAAAAAAAATgAAAG8AAAB2AAAAAAAAAEQAAABlAAAAYwAAAAAAAABBAAAATQAAAAAAAABQAAAATQ=="), ds(ji, 19228, "HEAAAOkBAADqAQAA6wEAAOwBAADtAQAA7gEAAO8BAAAAAAAACEEAAPkBAAD6AQAA+wEAAPwBAAD9AQAA/gEAAP8BAABOU3QzX18yMTRfX3NoYXJlZF9jb3VudEU="), ds(ji, 19348, "iCM="), ds(ji, 19372, "Tm8gZXJyb3IgaW5mb3JtYXRpb24ASWxsZWdhbCBieXRlIHNlcXVlbmNlAERvbWFpbiBlcnJvcgBSZXN1bHQgbm90IHJlcHJlc2VudGFibGUATm90IGEgdHR5AFBlcm1pc3Npb24gZGVuaWVkAE9wZXJhdGlvbiBub3QgcGVybWl0dGVkAE5vIHN1Y2ggZmlsZSBvciBkaXJlY3RvcnkATm8gc3VjaCBwcm9jZXNzAEZpbGUgZXhpc3RzAFZhbHVlIHRvbyBsYXJnZSBmb3IgZGF0YSB0eXBlAE5vIHNwYWNlIGxlZnQgb24gZGV2aWNlAE91dCBvZiBtZW1vcnkAUmVzb3VyY2UgYnVzeQBJbnRlcnJ1cHRlZCBzeXN0ZW0gY2FsbABSZXNvdXJjZSB0ZW1wb3JhcmlseSB1bmF2YWlsYWJsZQBJbnZhbGlkIHNlZWsAQ3Jvc3MtZGV2aWNlIGxpbmsAUmVhZC1vbmx5IGZpbGUgc3lzdGVtAERpcmVjdG9yeSBub3QgZW1wdHkAQ29ubmVjdGlvbiByZXNldCBieSBwZWVyAE9wZXJhdGlvbiB0aW1lZCBvdXQAQ29ubmVjdGlvbiByZWZ1c2VkAEhvc3QgaXMgZG93bgBIb3N0IGlzIHVucmVhY2hhYmxlAEFkZHJlc3MgaW4gdXNlAEJyb2tlbiBwaXBlAEkvTyBlcnJvcgBObyBzdWNoIGRldmljZSBvciBhZGRyZXNzAEJsb2NrIGRldmljZSByZXF1aXJlZABObyBzdWNoIGRldmljZQBOb3QgYSBkaXJlY3RvcnkASXMgYSBkaXJlY3RvcnkAVGV4dCBmaWxlIGJ1c3kARXhlYyBmb3JtYXQgZXJyb3IASW52YWxpZCBhcmd1bWVudABBcmd1bWVudCBsaXN0IHRvbyBsb25nAFN5bWJvbGljIGxpbmsgbG9vcABGaWxlbmFtZSB0b28gbG9uZwBUb28gbWFueSBvcGVuIGZpbGVzIGluIHN5c3RlbQBObyBmaWxlIGRlc2NyaXB0b3JzIGF2YWlsYWJsZQBCYWQgZmlsZSBkZXNjcmlwdG9yAE5vIGNoaWxkIHByb2Nlc3MAQmFkIGFkZHJlc3MARmlsZSB0b28gbGFyZ2UAVG9vIG1hbnkgbGlua3MATm8gbG9ja3MgYXZhaWxhYmxlAFJlc291cmNlIGRlYWRsb2NrIHdvdWxkIG9jY3VyAFN0YXRlIG5vdCByZWNvdmVyYWJsZQBQcmV2aW91cyBvd25lciBkaWVkAE9wZXJhdGlvbiBjYW5jZWxlZABGdW5jdGlvbiBub3QgaW1wbGVtZW50ZWQATm8gbWVzc2FnZSBvZiBkZXNpcmVkIHR5cGUASWRlbnRpZmllciByZW1vdmVkAERldmljZSBub3QgYSBzdHJlYW0ATm8gZGF0YSBhdmFpbGFibGUARGV2aWNlIHRpbWVvdXQAT3V0IG9mIHN0cmVhbXMgcmVzb3VyY2VzAExpbmsgaGFzIGJlZW4gc2V2ZXJlZABQcm90b2NvbCBlcnJvcgBCYWQgbWVzc2FnZQBGaWxlIGRlc2NyaXB0b3IgaW4gYmFkIHN0YXRlAE5vdCBhIHNvY2tldABEZXN0aW5hdGlvbiBhZGRyZXNzIHJlcXVpcmVkAE1lc3NhZ2UgdG9vIGxhcmdlAFByb3RvY29sIHdyb25nIHR5cGUgZm9yIHNvY2tldABQcm90b2NvbCBub3QgYXZhaWxhYmxlAFByb3RvY29sIG5vdCBzdXBwb3J0ZWQAU29ja2V0IHR5cGUgbm90IHN1cHBvcnRlZABOb3Qgc3VwcG9ydGVkAFByb3RvY29sIGZhbWlseSBub3Qgc3VwcG9ydGVkAEFkZHJlc3MgZmFtaWx5IG5vdCBzdXBwb3J0ZWQgYnkgcHJvdG9jb2wAQWRkcmVzcyBub3QgYXZhaWxhYmxlAE5ldHdvcmsgaXMgZG93bgBOZXR3b3JrIHVucmVhY2hhYmxlAENvbm5lY3Rpb24gcmVzZXQgYnkgbmV0d29yawBDb25uZWN0aW9uIGFib3J0ZWQATm8gYnVmZmVyIHNwYWNlIGF2YWlsYWJsZQBTb2NrZXQgaXMgY29ubmVjdGVkAFNvY2tldCBub3QgY29ubmVjdGVkAENhbm5vdCBzZW5kIGFmdGVyIHNvY2tldCBzaHV0ZG93bgBPcGVyYXRpb24gYWxyZWFkeSBpbiBwcm9ncmVzcwBPcGVyYXRpb24gaW4gcHJvZ3Jlc3MAU3RhbGUgZmlsZSBoYW5kbGUAUmVtb3RlIEkvTyBlcnJvcgBRdW90YSBleGNlZWRlZABObyBtZWRpdW0gZm91bmQAV3JvbmcgbWVkaXVtIHR5cGUATXVsdGlob3AgYXR0ZW1wdGVkAFJlcXVpcmVkIGtleSBub3QgYXZhaWxhYmxlAEtleSBoYXMgZXhwaXJlZABLZXkgaGFzIGJlZW4gcmV2b2tlZABLZXkgd2FzIHJlamVjdGVkIGJ5IHNlcnZpY2U="), ds(ji, 21298, "pQJbAPABtQWMBSUBgwYdA5QE/wDHAzEDCwa8AY8BfwPKBCsA2gavAEIDTgPcAQ4EFQChBg0BlAILAjgGZAK8Av8CXQPnBAsHzwLLBe8F2wXhAh4GRQKFAIICbANvBPEA8wMYBdkA2gNMBlQCewGdA70EAABRABUCuwCzA20A/wGFBC8F+QQ4AGUBRgGfALcGqAFzAlMB"), ds(ji, 21496, "IQQAAAAAAAAAAC8C"), ds(ji, 21528, "NQRHBFYE"), ds(ji, 21550, "oAQ="), ds(ji, 21570, "RgVgBW4FYQYAAM8BAAAAAAAAAADJBukG+QYeBzkHSQdeBw=="), ds(ji, 21620, "CgAAAGQAAADoAwAAECcAAKCGAQBAQg8AgJaYAADh9QUAypo7AAAAAAAAAAAwMDAxMDIwMzA0MDUwNjA3MDgwOTEwMTExMjEzMTQxNTE2MTcxODE5MjAyMTIyMjMyNDI1MjYyNzI4MjkzMDMxMzIzMzM0MzUzNjM3MzgzOTQwNDE0MjQzNDQ0NTQ2NDc0ODQ5NTA1MTUyNTM1NDU1NTY1NzU4NTk2MDYxNjI2MzY0NjU2NjY3Njg2OTcwNzE3MjczNzQ3NTc2Nzc3ODc5ODA4MTgyODM4NDg1ODY4Nzg4ODk5MDkxOTI5Mzk0OTU5Njk3OTg5OQAAAACUVQAAQgIAAEMCAABOAQAATlN0M19fMjEyc3lzdGVtX2Vycm9yRQAAJFkAAHxVAACIWAAATlN0M19fMjE0ZXJyb3JfY2F0ZWdvcnlFAAAAAORYAACgVQAATlN0M19fMjEyX19kb19tZXNzYWdlRQAA5FgAAGBLAAAkWQAAxFUAALxVAAAAAAAA3FUAAEQCAABFAgAARgIAAE4xMF9fY3h4YWJpdjExNl9fc2hpbV90eXBlX2luZm9FAAAAACRZAAAEVgAAFFkAAE4xMF9fY3h4YWJpdjExN19fY2xhc3NfdHlwZV9pbmZvRQAAACRZAAA0VgAAKFYAAE4xMF9fY3h4YWJpdjExN19fcGJhc2VfdHlwZV9pbmZvRQAAACRZAABkVgAAKFYAAE4xMF9fY3h4YWJpdjExOV9fcG9pbnRlcl90eXBlX2luZm9FACRZAACUVgAAiFYAAE4xMF9fY3h4YWJpdjEyMF9fc2lfY2xhc3NfdHlwZV9pbmZvRQAAAAAkWQAAxFYAAFhWAAAAAAAASFcAAEgCAABJAgAASgIAAEsCAABMAgAATQIAAE4CAABPAgAATjEwX19jeHhhYml2MTIxX192bWlfY2xhc3NfdHlwZV9pbmZvRQAAACRZAAAgVwAAWFYAAAAAAACwVwAABQAAAFACAABRAgAAAAAAALxXAAAFAAAAUgIAAFMCAABTdDlleGNlcHRpb24AU3QyMGJhZF9hcnJheV9uZXdfbGVuZ3RoAFN0OWJhZF9hbGxvYwAAJFkAAKJXAABQWQAAJFkAAIlXAACwVwAAAAAAAABYAAAHAAAAVAIAAFUCAAAAAAAAiFgAAFwAAABWAgAATgEAAFN0MTFsb2dpY19lcnJvcgAkWQAA8FcAAFBZAAAAAAAANFgAAAcAAABXAgAAVQIAAFN0MTJsZW5ndGhfZXJyb3IAAAAAJFkAACBYAAAAWAAAAAAAAGhYAAAHAAAAWAIAAFUCAABTdDEyb3V0X29mX3JhbmdlAAAAACRZAABUWAAAAFgAAFN0MTNydW50aW1lX2Vycm9yAAAAJFkAAHRYAABQWQAAAAAAALxYAABcAAAAWQIAAE4BAABTdDE0b3ZlcmZsb3dfZXJyb3IAACRZAACoWAAAiFgAAAAAAABYWQAArQAAAFoCAABbAgAAAAAAAFhWAABIAgAAXAIAAEoCAABLAgAATAIAAF0CAABeAgAAXwIAAFN0OXR5cGVfaW5mbwAAAADkWAAABFkAAAAAAADsVgAASAIAAGACAABKAgAASwIAAEwCAABhAgAAYgIAAGMCAABTdDhiYWRfY2FzdADkWAAAfFcAACRZAABEWQAAUFkAAAAAAABQWQAABQAAAGQCAABlAg=="), ds(ji, 22904, "0GoBAAghAABHAg==");
            }
            var Uo = new ArrayBuffer(16), Ho = new Int32Array(Uo), Ro = new Float32Array(Uo), vo = new Float64Array(Uo);
            function js(qo) {
              return Ho[qo];
            }
            function jo(qo, Us) {
              Ho[qo] = Us;
            }
            function za() {
              return vo[0];
            }
            function ya(qo) {
              vo[0] = qo;
            }
            function ri() {
              throw new Error("abort");
            }
            function io() {
              return Ro[2];
            }
            function Vo(qo) {
              Ro[2] = qo;
            }
            function Sa(qo) {
              var Us = qo.a, au = Us.a, Ja = au.buffer, $ = new Int8Array(Ja), Vs = new Int16Array(Ja), e = new Int32Array(Ja), ye = new Uint8Array(Ja), fa = new Uint16Array(Ja), Ps = new Uint32Array(Ja), ef = new Float32Array(Ja), Fi = new Float64Array(Ja), vi = Math.imul, la = Math.fround, Fd = Math.abs, Do = Math.clz32, Ld = Math.ceil, Vr = Us.b, On = Us.c, ii = Us.d, di = Us.e, Si = Us.f, Ri = Us.g, Ki = Us.h, as = Us.i, Ts = Us.j, Qs = Us.k, ko = Us.l, da = Us.m, Ta = Us.n, Fa = Us.o, aa = Us.p, $a = Us.q, xa = Us.r, eu = Us.s, yu = Us.t, lc = Us.u, Wu = Us.v, Bc = Us.w, Uf = Us.x, tf = Us.y, rf = Us.z, vl = Us.A, Cl = Us.B, Mf = Us.C, Ff = Us.D, Hd = Us.E, Lf = Us.F, kl = Us.G, Kd = Us.H, Ou = Us.I, Qu = Us.J, B1 = Us.K, C1 = Us.L, Sl = Us.M, k1 = Us.N, Gd = Us.O, S1 = Us.P, T1 = Us.Q, x1 = Us.R, b4 = Us.S, Tl = Us.T, xl = Us.U, mu = Us.V, E4 = Us.W, R1 = Us.X, Yr = 92880, uo = 0, vs = 0;
              function D1(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0;
                y = Yr - 352 | 0, Yr = y, e[y + 328 >> 2] = 0, e[y + 320 >> 2] = 0, e[y + 324 >> 2] = 0, e[5996] = 0, e[y + 316 >> 2] = 0, e[y + 308 >> 2] = 0, e[y + 312 >> 2] = 0, g = ii(3, 24) | 0, h = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((h | 0) != 1) {
                        e[g + 8 >> 2] = -1, e[g + 12 >> 2] = -1, e[g >> 2] = 0, e[g + 16 >> 2] = -1, e[g + 20 >> 2] = -1, c = g + 24 | 0, e[y + 328 >> 2] = c, e[y + 320 >> 2] = g, Tr = y + 296 | 0;
                        n: {
                          i: {
                            s: {
                              a: {
                                o: {
                                  l: {
                                    f: {
                                      d: {
                                        c: {
                                          for (; ; ) {
                                            h = c - 24 | 0, S = e[h + 20 >> 2], e[Tr >> 2] = e[h + 16 >> 2], e[Tr + 4 >> 2] = S, S = e[h + 12 >> 2], e[y + 288 >> 2] = e[h + 8 >> 2], e[y + 292 >> 2] = S, G = e[h + 4 >> 2], S = e[h >> 2], e[y + 280 >> 2] = S, e[y + 284 >> 2] = G, e[y + 324 >> 2] = h, hr = 18;
                                            u: {
                                              g: {
                                                A: {
                                                  p: {
                                                    I: {
                                                      k: {
                                                        N: {
                                                          S: {
                                                            T: {
                                                              v: {
                                                                w: {
                                                                  b: {
                                                                    h: {
                                                                      x:
                                                                        switch (S | 0) {
                                                                          case 0:
                                                                            c = e[o + 4 >> 2];
                                                                            m: {
                                                                              if ((c | 0) < 2) {
                                                                                g = -1;
                                                                                break m;
                                                                              }
                                                                              for (S = e[o >> 2], g = 1; ; ) {
                                                                                if (G = ye[g + S | 0], (G | 0) == 58) {
                                                                                  hr = 0;
                                                                                  B: {
                                                                                    R: {
                                                                                      E: {
                                                                                        C: {
                                                                                          for (; ; ) {
                                                                                            y: {
                                                                                              D:
                                                                                                switch (ye[e[o >> 2] + hr | 0] - 97 | 0) {
                                                                                                  case 0:
                                                                                                    if (h = e[y + 324 >> 2], G = e[y + 328 >> 2], h >>> 0 < G >>> 0) {
                                                                                                      e[h + 8 >> 2] = -1, e[h + 12 >> 2] = -1, e[h >> 2] = 3, e[h + 16 >> 2] = -1, e[h + 20 >> 2] = -1, e[y + 324 >> 2] = h + 24;
                                                                                                      break y;
                                                                                                    }
                                                                                                    P: {
                                                                                                      q: {
                                                                                                        O: {
                                                                                                          S = e[y + 320 >> 2], Fe = (h - S | 0) / 24 | 0, c = Fe + 1 | 0;
                                                                                                          Q: {
                                                                                                            if (c >>> 0 >= 178956971) {
                                                                                                              if (e[5996] = 0, Ri(142), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                break Q;
                                                                                                              break e;
                                                                                                            }
                                                                                                            if (G = (G - S | 0) / 24 | 0, ke = G << 1, G = G >>> 0 >= 89478485 ? 178956970 : c >>> 0 < ke >>> 0 ? ke : c, !G) {
                                                                                                              ke = 0;
                                                                                                              break q;
                                                                                                            }
                                                                                                            if (G >>> 0 < 178956971)
                                                                                                              break O;
                                                                                                            if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                              break e;
                                                                                                          }
                                                                                                          o = Vr() | 0;
                                                                                                          break t;
                                                                                                        }
                                                                                                        if (e[5996] = 0, ke = ii(3, vi(G, 24) | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                                          break P;
                                                                                                      }
                                                                                                      if (c = vi(Fe, 24) + ke | 0, e[c + 8 >> 2] = -1, e[c + 12 >> 2] = -1, e[c >> 2] = 3, e[c + 16 >> 2] = -1, e[c + 20 >> 2] = -1, Fe = c + 24 | 0, (h | 0) != (S | 0)) {
                                                                                                        for (; h = h - 24 | 0, Ar = e[h + 4 >> 2], c = c - 24 | 0, e[c >> 2] = e[h >> 2], e[c + 4 >> 2] = Ar, Ar = e[h + 20 >> 2], e[c + 16 >> 2] = e[h + 16 >> 2], e[c + 20 >> 2] = Ar, Ar = e[h + 12 >> 2], e[c + 8 >> 2] = e[h + 8 >> 2], e[c + 12 >> 2] = Ar, (h | 0) != (S | 0); )
                                                                                                          ;
                                                                                                        h = S;
                                                                                                      }
                                                                                                      if (e[y + 328 >> 2] = vi(G, 24) + ke, e[y + 324 >> 2] = Fe, e[y + 320 >> 2] = c, !h)
                                                                                                        break y;
                                                                                                      Sr(h);
                                                                                                      break y;
                                                                                                    }
                                                                                                    o = Vr() | 0;
                                                                                                    break t;
                                                                                                  case 18:
                                                                                                    if (h = e[y + 324 >> 2], G = e[y + 328 >> 2], h >>> 0 < G >>> 0) {
                                                                                                      e[h + 8 >> 2] = -1, e[h + 12 >> 2] = -1, e[h >> 2] = 2, e[h + 16 >> 2] = -1, e[h + 20 >> 2] = -1, e[y + 324 >> 2] = h + 24;
                                                                                                      break y;
                                                                                                    }
                                                                                                    P: {
                                                                                                      q: {
                                                                                                        O: {
                                                                                                          S = e[y + 320 >> 2], Fe = (h - S | 0) / 24 | 0, c = Fe + 1 | 0;
                                                                                                          Q: {
                                                                                                            if (c >>> 0 >= 178956971) {
                                                                                                              e[5996] = 0, Ri(142);
                                                                                                              break Q;
                                                                                                            }
                                                                                                            if (G = (G - S | 0) / 24 | 0, ke = G << 1, G = G >>> 0 >= 89478485 ? 178956970 : c >>> 0 < ke >>> 0 ? ke : c, !G) {
                                                                                                              ke = 0;
                                                                                                              break q;
                                                                                                            }
                                                                                                            if (G >>> 0 < 178956971)
                                                                                                              break O;
                                                                                                            e[5996] = 0, Ri(35);
                                                                                                          }
                                                                                                          if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                            break e;
                                                                                                          o = Vr() | 0;
                                                                                                          break t;
                                                                                                        }
                                                                                                        if (e[5996] = 0, ke = ii(3, vi(G, 24) | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                                          break P;
                                                                                                      }
                                                                                                      if (c = vi(Fe, 24) + ke | 0, e[c + 8 >> 2] = -1, e[c + 12 >> 2] = -1, e[c >> 2] = 2, e[c + 16 >> 2] = -1, e[c + 20 >> 2] = -1, Fe = c + 24 | 0, (h | 0) != (S | 0)) {
                                                                                                        for (; h = h - 24 | 0, Ar = e[h + 4 >> 2], c = c - 24 | 0, e[c >> 2] = e[h >> 2], e[c + 4 >> 2] = Ar, Ar = e[h + 20 >> 2], e[c + 16 >> 2] = e[h + 16 >> 2], e[c + 20 >> 2] = Ar, Ar = e[h + 12 >> 2], e[c + 8 >> 2] = e[h + 8 >> 2], e[c + 12 >> 2] = Ar, (h | 0) != (S | 0); )
                                                                                                          ;
                                                                                                        h = S;
                                                                                                      }
                                                                                                      if (e[y + 328 >> 2] = vi(G, 24) + ke, e[y + 324 >> 2] = Fe, e[y + 320 >> 2] = c, !h)
                                                                                                        break y;
                                                                                                      Sr(h);
                                                                                                      break y;
                                                                                                    }
                                                                                                    o = Vr() | 0;
                                                                                                    break t;
                                                                                                  case 2:
                                                                                                    if (h = e[y + 324 >> 2], G = e[y + 328 >> 2], h >>> 0 < G >>> 0) {
                                                                                                      e[h + 8 >> 2] = -1, e[h + 12 >> 2] = -1, e[h >> 2] = 4, e[h + 16 >> 2] = -1, e[h + 20 >> 2] = -1, e[y + 324 >> 2] = h + 24;
                                                                                                      break y;
                                                                                                    }
                                                                                                    P: {
                                                                                                      q: {
                                                                                                        O: {
                                                                                                          S = e[y + 320 >> 2], Fe = (h - S | 0) / 24 | 0, c = Fe + 1 | 0;
                                                                                                          Q: {
                                                                                                            if (c >>> 0 >= 178956971) {
                                                                                                              e[5996] = 0, Ri(142);
                                                                                                              break Q;
                                                                                                            }
                                                                                                            if (G = (G - S | 0) / 24 | 0, ke = G << 1, G = G >>> 0 >= 89478485 ? 178956970 : c >>> 0 < ke >>> 0 ? ke : c, !G) {
                                                                                                              ke = 0;
                                                                                                              break q;
                                                                                                            }
                                                                                                            if (G >>> 0 < 178956971)
                                                                                                              break O;
                                                                                                            e[5996] = 0, Ri(35);
                                                                                                          }
                                                                                                          if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                            break e;
                                                                                                          o = Vr() | 0;
                                                                                                          break t;
                                                                                                        }
                                                                                                        if (e[5996] = 0, ke = ii(3, vi(G, 24) | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                                          break P;
                                                                                                      }
                                                                                                      if (c = vi(Fe, 24) + ke | 0, e[c + 8 >> 2] = -1, e[c + 12 >> 2] = -1, e[c >> 2] = 4, e[c + 16 >> 2] = -1, e[c + 20 >> 2] = -1, Fe = c + 24 | 0, (h | 0) != (S | 0)) {
                                                                                                        for (; h = h - 24 | 0, Ar = e[h + 4 >> 2], c = c - 24 | 0, e[c >> 2] = e[h >> 2], e[c + 4 >> 2] = Ar, Ar = e[h + 20 >> 2], e[c + 16 >> 2] = e[h + 16 >> 2], e[c + 20 >> 2] = Ar, Ar = e[h + 12 >> 2], e[c + 8 >> 2] = e[h + 8 >> 2], e[c + 12 >> 2] = Ar, (h | 0) != (S | 0); )
                                                                                                          ;
                                                                                                        h = S;
                                                                                                      }
                                                                                                      if (e[y + 328 >> 2] = vi(G, 24) + ke, e[y + 324 >> 2] = Fe, e[y + 320 >> 2] = c, !h)
                                                                                                        break y;
                                                                                                      Sr(h);
                                                                                                      break y;
                                                                                                    }
                                                                                                    o = Vr() | 0;
                                                                                                    break t;
                                                                                                  case 3:
                                                                                                    if (h = e[y + 324 >> 2], G = e[y + 328 >> 2], h >>> 0 < G >>> 0) {
                                                                                                      e[h + 8 >> 2] = -1, e[h + 12 >> 2] = -1, e[h >> 2] = 5, e[h + 16 >> 2] = -1, e[h + 20 >> 2] = -1, e[y + 324 >> 2] = h + 24;
                                                                                                      break y;
                                                                                                    }
                                                                                                    P: {
                                                                                                      q: {
                                                                                                        O: {
                                                                                                          S = e[y + 320 >> 2], Fe = (h - S | 0) / 24 | 0, c = Fe + 1 | 0;
                                                                                                          Q: {
                                                                                                            if (c >>> 0 >= 178956971) {
                                                                                                              e[5996] = 0, Ri(142);
                                                                                                              break Q;
                                                                                                            }
                                                                                                            if (G = (G - S | 0) / 24 | 0, ke = G << 1, G = G >>> 0 >= 89478485 ? 178956970 : c >>> 0 < ke >>> 0 ? ke : c, !G) {
                                                                                                              ke = 0;
                                                                                                              break q;
                                                                                                            }
                                                                                                            if (G >>> 0 < 178956971)
                                                                                                              break O;
                                                                                                            e[5996] = 0, Ri(35);
                                                                                                          }
                                                                                                          if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                            break e;
                                                                                                          o = Vr() | 0;
                                                                                                          break t;
                                                                                                        }
                                                                                                        if (e[5996] = 0, ke = ii(3, vi(G, 24) | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                                          break P;
                                                                                                      }
                                                                                                      if (c = vi(Fe, 24) + ke | 0, e[c + 8 >> 2] = -1, e[c + 12 >> 2] = -1, e[c >> 2] = 5, e[c + 16 >> 2] = -1, e[c + 20 >> 2] = -1, Fe = c + 24 | 0, (h | 0) != (S | 0)) {
                                                                                                        for (; h = h - 24 | 0, Ar = e[h + 4 >> 2], c = c - 24 | 0, e[c >> 2] = e[h >> 2], e[c + 4 >> 2] = Ar, Ar = e[h + 20 >> 2], e[c + 16 >> 2] = e[h + 16 >> 2], e[c + 20 >> 2] = Ar, Ar = e[h + 12 >> 2], e[c + 8 >> 2] = e[h + 8 >> 2], e[c + 12 >> 2] = Ar, (h | 0) != (S | 0); )
                                                                                                          ;
                                                                                                        h = S;
                                                                                                      }
                                                                                                      if (e[y + 328 >> 2] = vi(G, 24) + ke, e[y + 324 >> 2] = Fe, e[y + 320 >> 2] = c, !h)
                                                                                                        break y;
                                                                                                      Sr(h);
                                                                                                      break y;
                                                                                                    }
                                                                                                    o = Vr() | 0;
                                                                                                    break t;
                                                                                                  case 9:
                                                                                                    if (h = e[y + 324 >> 2], G = e[y + 328 >> 2], h >>> 0 < G >>> 0) {
                                                                                                      e[h + 8 >> 2] = -1, e[h + 12 >> 2] = -1, e[h >> 2] = 7, e[h + 16 >> 2] = -1, e[h + 20 >> 2] = -1, e[y + 324 >> 2] = h + 24;
                                                                                                      break y;
                                                                                                    }
                                                                                                    P: {
                                                                                                      q: {
                                                                                                        O: {
                                                                                                          S = e[y + 320 >> 2], Fe = (h - S | 0) / 24 | 0, c = Fe + 1 | 0;
                                                                                                          Q: {
                                                                                                            if (c >>> 0 >= 178956971) {
                                                                                                              e[5996] = 0, Ri(142);
                                                                                                              break Q;
                                                                                                            }
                                                                                                            if (G = (G - S | 0) / 24 | 0, ke = G << 1, G = G >>> 0 >= 89478485 ? 178956970 : c >>> 0 < ke >>> 0 ? ke : c, !G) {
                                                                                                              ke = 0;
                                                                                                              break q;
                                                                                                            }
                                                                                                            if (G >>> 0 < 178956971)
                                                                                                              break O;
                                                                                                            e[5996] = 0, Ri(35);
                                                                                                          }
                                                                                                          if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                            break e;
                                                                                                          o = Vr() | 0;
                                                                                                          break t;
                                                                                                        }
                                                                                                        if (e[5996] = 0, ke = ii(3, vi(G, 24) | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                                          break P;
                                                                                                      }
                                                                                                      if (c = vi(Fe, 24) + ke | 0, e[c + 8 >> 2] = -1, e[c + 12 >> 2] = -1, e[c >> 2] = 7, e[c + 16 >> 2] = -1, e[c + 20 >> 2] = -1, Fe = c + 24 | 0, (h | 0) != (S | 0)) {
                                                                                                        for (; h = h - 24 | 0, Ar = e[h + 4 >> 2], c = c - 24 | 0, e[c >> 2] = e[h >> 2], e[c + 4 >> 2] = Ar, Ar = e[h + 20 >> 2], e[c + 16 >> 2] = e[h + 16 >> 2], e[c + 20 >> 2] = Ar, Ar = e[h + 12 >> 2], e[c + 8 >> 2] = e[h + 8 >> 2], e[c + 12 >> 2] = Ar, (h | 0) != (S | 0); )
                                                                                                          ;
                                                                                                        h = S;
                                                                                                      }
                                                                                                      if (e[y + 328 >> 2] = vi(G, 24) + ke, e[y + 324 >> 2] = Fe, e[y + 320 >> 2] = c, !h)
                                                                                                        break y;
                                                                                                      Sr(h);
                                                                                                      break y;
                                                                                                    }
                                                                                                    o = Vr() | 0;
                                                                                                    break t;
                                                                                                  case 13:
                                                                                                    if (h = e[y + 324 >> 2], G = e[y + 328 >> 2], h >>> 0 < G >>> 0) {
                                                                                                      e[h + 8 >> 2] = -1, e[h + 12 >> 2] = -1, e[h >> 2] = 8, e[h + 16 >> 2] = -1, e[h + 20 >> 2] = -1, e[y + 324 >> 2] = h + 24;
                                                                                                      break y;
                                                                                                    }
                                                                                                    P: {
                                                                                                      q: {
                                                                                                        O: {
                                                                                                          S = e[y + 320 >> 2], Fe = (h - S | 0) / 24 | 0, c = Fe + 1 | 0;
                                                                                                          Q: {
                                                                                                            if (c >>> 0 >= 178956971) {
                                                                                                              e[5996] = 0, Ri(142);
                                                                                                              break Q;
                                                                                                            }
                                                                                                            if (G = (G - S | 0) / 24 | 0, ke = G << 1, G = G >>> 0 >= 89478485 ? 178956970 : c >>> 0 < ke >>> 0 ? ke : c, !G) {
                                                                                                              ke = 0;
                                                                                                              break q;
                                                                                                            }
                                                                                                            if (G >>> 0 < 178956971)
                                                                                                              break O;
                                                                                                            e[5996] = 0, Ri(35);
                                                                                                          }
                                                                                                          if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                            break e;
                                                                                                          o = Vr() | 0;
                                                                                                          break t;
                                                                                                        }
                                                                                                        if (e[5996] = 0, ke = ii(3, vi(G, 24) | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                                          break P;
                                                                                                      }
                                                                                                      if (c = vi(Fe, 24) + ke | 0, e[c + 8 >> 2] = -1, e[c + 12 >> 2] = -1, e[c >> 2] = 8, e[c + 16 >> 2] = -1, e[c + 20 >> 2] = -1, Fe = c + 24 | 0, (h | 0) != (S | 0)) {
                                                                                                        for (; h = h - 24 | 0, Ar = e[h + 4 >> 2], c = c - 24 | 0, e[c >> 2] = e[h >> 2], e[c + 4 >> 2] = Ar, Ar = e[h + 20 >> 2], e[c + 16 >> 2] = e[h + 16 >> 2], e[c + 20 >> 2] = Ar, Ar = e[h + 12 >> 2], e[c + 8 >> 2] = e[h + 8 >> 2], e[c + 12 >> 2] = Ar, (h | 0) != (S | 0); )
                                                                                                          ;
                                                                                                        h = S;
                                                                                                      }
                                                                                                      if (e[y + 328 >> 2] = vi(G, 24) + ke, e[y + 324 >> 2] = Fe, e[y + 320 >> 2] = c, !h)
                                                                                                        break y;
                                                                                                      Sr(h);
                                                                                                      break y;
                                                                                                    }
                                                                                                    o = Vr() | 0;
                                                                                                    break t;
                                                                                                  case 21:
                                                                                                    if (h = e[y + 324 >> 2], G = e[y + 328 >> 2], h >>> 0 < G >>> 0) {
                                                                                                      e[h + 8 >> 2] = -1, e[h + 12 >> 2] = -1, e[h >> 2] = 6, e[h + 16 >> 2] = -1, e[h + 20 >> 2] = -1, e[y + 324 >> 2] = h + 24;
                                                                                                      break y;
                                                                                                    }
                                                                                                    P: {
                                                                                                      q: {
                                                                                                        O: {
                                                                                                          S = e[y + 320 >> 2], Fe = (h - S | 0) / 24 | 0, c = Fe + 1 | 0;
                                                                                                          Q: {
                                                                                                            if (c >>> 0 >= 178956971) {
                                                                                                              e[5996] = 0, Ri(142);
                                                                                                              break Q;
                                                                                                            }
                                                                                                            if (G = (G - S | 0) / 24 | 0, ke = G << 1, G = G >>> 0 >= 89478485 ? 178956970 : c >>> 0 < ke >>> 0 ? ke : c, !G) {
                                                                                                              ke = 0;
                                                                                                              break q;
                                                                                                            }
                                                                                                            if (G >>> 0 < 178956971)
                                                                                                              break O;
                                                                                                            e[5996] = 0, Ri(35);
                                                                                                          }
                                                                                                          if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                            break e;
                                                                                                          o = Vr() | 0;
                                                                                                          break t;
                                                                                                        }
                                                                                                        if (e[5996] = 0, ke = ii(3, vi(G, 24) | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                                          break P;
                                                                                                      }
                                                                                                      if (c = vi(Fe, 24) + ke | 0, e[c + 8 >> 2] = -1, e[c + 12 >> 2] = -1, e[c >> 2] = 6, e[c + 16 >> 2] = -1, e[c + 20 >> 2] = -1, Fe = c + 24 | 0, (h | 0) != (S | 0)) {
                                                                                                        for (; h = h - 24 | 0, Ar = e[h + 4 >> 2], c = c - 24 | 0, e[c >> 2] = e[h >> 2], e[c + 4 >> 2] = Ar, Ar = e[h + 20 >> 2], e[c + 16 >> 2] = e[h + 16 >> 2], e[c + 20 >> 2] = Ar, Ar = e[h + 12 >> 2], e[c + 8 >> 2] = e[h + 8 >> 2], e[c + 12 >> 2] = Ar, (h | 0) != (S | 0); )
                                                                                                          ;
                                                                                                        h = S;
                                                                                                      }
                                                                                                      if (e[y + 328 >> 2] = vi(G, 24) + ke, e[y + 324 >> 2] = Fe, e[y + 320 >> 2] = c, !h)
                                                                                                        break y;
                                                                                                      Sr(h);
                                                                                                      break y;
                                                                                                    }
                                                                                                    o = Vr() | 0;
                                                                                                    break t;
                                                                                                  case 20:
                                                                                                    if (h = e[y + 324 >> 2], G = e[y + 328 >> 2], h >>> 0 < G >>> 0) {
                                                                                                      e[h + 8 >> 2] = -1, e[h + 12 >> 2] = -1, e[h >> 2] = 9, e[h + 16 >> 2] = -1, e[h + 20 >> 2] = -1, e[y + 324 >> 2] = h + 24;
                                                                                                      break y;
                                                                                                    }
                                                                                                    P: {
                                                                                                      q: {
                                                                                                        O: {
                                                                                                          S = e[y + 320 >> 2], Fe = (h - S | 0) / 24 | 0, c = Fe + 1 | 0;
                                                                                                          Q: {
                                                                                                            if (c >>> 0 >= 178956971) {
                                                                                                              e[5996] = 0, Ri(142);
                                                                                                              break Q;
                                                                                                            }
                                                                                                            if (G = (G - S | 0) / 24 | 0, ke = G << 1, G = G >>> 0 >= 89478485 ? 178956970 : c >>> 0 < ke >>> 0 ? ke : c, !G) {
                                                                                                              ke = 0;
                                                                                                              break q;
                                                                                                            }
                                                                                                            if (G >>> 0 < 178956971)
                                                                                                              break O;
                                                                                                            e[5996] = 0, Ri(35);
                                                                                                          }
                                                                                                          if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                            break e;
                                                                                                          o = Vr() | 0;
                                                                                                          break t;
                                                                                                        }
                                                                                                        if (e[5996] = 0, ke = ii(3, vi(G, 24) | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                                          break P;
                                                                                                      }
                                                                                                      if (c = vi(Fe, 24) + ke | 0, e[c + 8 >> 2] = -1, e[c + 12 >> 2] = -1, e[c >> 2] = 9, e[c + 16 >> 2] = -1, e[c + 20 >> 2] = -1, Fe = c + 24 | 0, (h | 0) != (S | 0)) {
                                                                                                        for (; h = h - 24 | 0, Ar = e[h + 4 >> 2], c = c - 24 | 0, e[c >> 2] = e[h >> 2], e[c + 4 >> 2] = Ar, Ar = e[h + 20 >> 2], e[c + 16 >> 2] = e[h + 16 >> 2], e[c + 20 >> 2] = Ar, Ar = e[h + 12 >> 2], e[c + 8 >> 2] = e[h + 8 >> 2], e[c + 12 >> 2] = Ar, (h | 0) != (S | 0); )
                                                                                                          ;
                                                                                                        h = S;
                                                                                                      }
                                                                                                      if (e[y + 328 >> 2] = vi(G, 24) + ke, e[y + 324 >> 2] = Fe, e[y + 320 >> 2] = c, !h)
                                                                                                        break y;
                                                                                                      Sr(h);
                                                                                                      break y;
                                                                                                    }
                                                                                                    o = Vr() | 0;
                                                                                                    break t;
                                                                                                  case 19:
                                                                                                    if (h = e[y + 324 >> 2], G = e[y + 328 >> 2], h >>> 0 < G >>> 0) {
                                                                                                      e[h + 8 >> 2] = -1, e[h + 12 >> 2] = -1, e[h >> 2] = 10, e[h + 16 >> 2] = -1, e[h + 20 >> 2] = -1, e[y + 324 >> 2] = h + 24;
                                                                                                      break y;
                                                                                                    }
                                                                                                    P: {
                                                                                                      q: {
                                                                                                        O: {
                                                                                                          S = e[y + 320 >> 2], Fe = (h - S | 0) / 24 | 0, c = Fe + 1 | 0;
                                                                                                          Q: {
                                                                                                            if (c >>> 0 >= 178956971) {
                                                                                                              e[5996] = 0, Ri(142);
                                                                                                              break Q;
                                                                                                            }
                                                                                                            if (G = (G - S | 0) / 24 | 0, ke = G << 1, G = G >>> 0 >= 89478485 ? 178956970 : c >>> 0 < ke >>> 0 ? ke : c, !G) {
                                                                                                              ke = 0;
                                                                                                              break q;
                                                                                                            }
                                                                                                            if (G >>> 0 < 178956971)
                                                                                                              break O;
                                                                                                            e[5996] = 0, Ri(35);
                                                                                                          }
                                                                                                          if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                            break e;
                                                                                                          o = Vr() | 0;
                                                                                                          break t;
                                                                                                        }
                                                                                                        if (e[5996] = 0, ke = ii(3, vi(G, 24) | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                                          break P;
                                                                                                      }
                                                                                                      if (c = vi(Fe, 24) + ke | 0, e[c + 8 >> 2] = -1, e[c + 12 >> 2] = -1, e[c >> 2] = 10, e[c + 16 >> 2] = -1, e[c + 20 >> 2] = -1, Fe = c + 24 | 0, (h | 0) != (S | 0)) {
                                                                                                        for (; h = h - 24 | 0, Ar = e[h + 4 >> 2], c = c - 24 | 0, e[c >> 2] = e[h >> 2], e[c + 4 >> 2] = Ar, Ar = e[h + 20 >> 2], e[c + 16 >> 2] = e[h + 16 >> 2], e[c + 20 >> 2] = Ar, Ar = e[h + 12 >> 2], e[c + 8 >> 2] = e[h + 8 >> 2], e[c + 12 >> 2] = Ar, (h | 0) != (S | 0); )
                                                                                                          ;
                                                                                                        h = S;
                                                                                                      }
                                                                                                      if (e[y + 328 >> 2] = vi(G, 24) + ke, e[y + 324 >> 2] = Fe, e[y + 320 >> 2] = c, !h)
                                                                                                        break y;
                                                                                                      Sr(h);
                                                                                                      break y;
                                                                                                    }
                                                                                                    o = Vr() | 0;
                                                                                                    break t;
                                                                                                  case 11:
                                                                                                    break D;
                                                                                                  default:
                                                                                                    break B;
                                                                                                }
                                                                                              if (e[5996] = 0, h = ii(3, 104) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                                break C;
                                                                                              if (e[h >> 2] = 7e3, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, S = Si(143, h + 12 | 0, 0, 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1) {
                                                                                                o = Vr() | 0, Sr(h);
                                                                                                break t;
                                                                                              }
                                                                                              e[y + 244 >> 2] = h, e[y + 240 >> 2] = S, c = e[y + 312 >> 2];
                                                                                              D: {
                                                                                                if (c >>> 0 < Ps[y + 316 >> 2]) {
                                                                                                  e[c + 4 >> 2] = h, e[c >> 2] = S, e[y + 312 >> 2] = c + 8;
                                                                                                  break D;
                                                                                                }
                                                                                                if (e[5996] = 0, di(144, y + 308 | 0, y + 240 | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                  break E;
                                                                                                if (h = e[y + 244 >> 2], !h || (c = e[h + 4 >> 2], e[h + 4 >> 2] = c - 1, c))
                                                                                                  break D;
                                                                                                _n[e[e[h >> 2] + 8 >> 2]](h), cs(h);
                                                                                              }
                                                                                              if (h = e[y + 324 >> 2], G = e[y + 328 >> 2], h >>> 0 < G >>> 0) {
                                                                                                e[h + 8 >> 2] = -1, e[h + 12 >> 2] = -1, e[h >> 2] = 18, e[h + 16 >> 2] = -1, e[h + 20 >> 2] = -1, e[y + 324 >> 2] = h + 24;
                                                                                                break y;
                                                                                              }
                                                                                              D: {
                                                                                                P: {
                                                                                                  S = e[y + 320 >> 2], Fe = (h - S | 0) / 24 | 0, c = Fe + 1 | 0;
                                                                                                  q: {
                                                                                                    if (c >>> 0 >= 178956971) {
                                                                                                      e[5996] = 0, Ri(142);
                                                                                                      break q;
                                                                                                    }
                                                                                                    if (G = (G - S | 0) / 24 | 0, ke = G << 1, G = G >>> 0 >= 89478485 ? 178956970 : c >>> 0 < ke >>> 0 ? ke : c, !G) {
                                                                                                      ke = 0;
                                                                                                      break D;
                                                                                                    }
                                                                                                    if (G >>> 0 < 178956971)
                                                                                                      break P;
                                                                                                    e[5996] = 0, Ri(35);
                                                                                                  }
                                                                                                  if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                    break e;
                                                                                                  o = Vr() | 0;
                                                                                                  break t;
                                                                                                }
                                                                                                if (e[5996] = 0, ke = ii(3, vi(G, 24) | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                                  break R;
                                                                                              }
                                                                                              if (c = vi(Fe, 24) + ke | 0, e[c + 8 >> 2] = -1, e[c + 12 >> 2] = -1, e[c >> 2] = 18, e[c + 16 >> 2] = -1, e[c + 20 >> 2] = -1, Fe = c + 24 | 0, (h | 0) != (S | 0)) {
                                                                                                for (; h = h - 24 | 0, Ar = e[h + 4 >> 2], c = c - 24 | 0, e[c >> 2] = e[h >> 2], e[c + 4 >> 2] = Ar, Ar = e[h + 20 >> 2], e[c + 16 >> 2] = e[h + 16 >> 2], e[c + 20 >> 2] = Ar, Ar = e[h + 12 >> 2], e[c + 8 >> 2] = e[h + 8 >> 2], e[c + 12 >> 2] = Ar, (h | 0) != (S | 0); )
                                                                                                  ;
                                                                                                h = S;
                                                                                              }
                                                                                              if (e[y + 328 >> 2] = vi(G, 24) + ke, e[y + 324 >> 2] = Fe, e[y + 320 >> 2] = c, !h)
                                                                                                break y;
                                                                                              Sr(h);
                                                                                            }
                                                                                            if (hr = hr + 1 | 0, (hr | 0) == (g | 0))
                                                                                              break;
                                                                                          }
                                                                                          h = e[y + 324 >> 2];
                                                                                          break m;
                                                                                        }
                                                                                        o = Vr() | 0;
                                                                                        break t;
                                                                                      }
                                                                                      o = Vr() | 0, No(y + 240 | 0);
                                                                                      break t;
                                                                                    }
                                                                                    o = Vr() | 0;
                                                                                    break t;
                                                                                  }
                                                                                  e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                                                  break c;
                                                                                }
                                                                                if ((G - 97 & 255) >>> 0 > 25) {
                                                                                  g = -1;
                                                                                  break m;
                                                                                }
                                                                                if (g = g + 1 | 0, !((c | 0) > (g | 0)))
                                                                                  break;
                                                                              }
                                                                              g = -1;
                                                                            }
                                                                            m: {
                                                                              G = e[y + 328 >> 2];
                                                                              B: {
                                                                                if (G >>> 0 > h >>> 0) {
                                                                                  e[h + 8 >> 2] = -1, e[h + 12 >> 2] = -1, e[h >> 2] = 1, e[h + 16 >> 2] = -1, e[h + 20 >> 2] = -1, e[y + 324 >> 2] = h + 24;
                                                                                  break B;
                                                                                }
                                                                                R: {
                                                                                  E: {
                                                                                    S = e[y + 320 >> 2], hr = (h - S | 0) / 24 | 0, c = hr + 1 | 0;
                                                                                    C: {
                                                                                      if (c >>> 0 >= 178956971) {
                                                                                        e[5996] = 0, Ri(142);
                                                                                        break C;
                                                                                      }
                                                                                      if (G = (G - S | 0) / 24 | 0, ke = G << 1, G = G >>> 0 >= 89478485 ? 178956970 : c >>> 0 < ke >>> 0 ? ke : c, !G) {
                                                                                        ke = 0;
                                                                                        break R;
                                                                                      }
                                                                                      if (G >>> 0 < 178956971)
                                                                                        break E;
                                                                                      e[5996] = 0, Ri(35);
                                                                                    }
                                                                                    if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                      break e;
                                                                                    o = Vr() | 0;
                                                                                    break t;
                                                                                  }
                                                                                  if (e[5996] = 0, ke = ii(3, vi(G, 24) | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                    break m;
                                                                                }
                                                                                if (c = vi(hr, 24) + ke | 0, e[c + 8 >> 2] = -1, e[c + 12 >> 2] = -1, e[c >> 2] = 1, e[c + 16 >> 2] = -1, e[c + 20 >> 2] = -1, hr = c + 24 | 0, (h | 0) != (S | 0)) {
                                                                                  for (; h = h - 24 | 0, Fe = e[h + 4 >> 2], c = c - 24 | 0, e[c >> 2] = e[h >> 2], e[c + 4 >> 2] = Fe, Fe = e[h + 20 >> 2], e[c + 16 >> 2] = e[h + 16 >> 2], e[c + 20 >> 2] = Fe, Fe = e[h + 12 >> 2], e[c + 8 >> 2] = e[h + 8 >> 2], e[c + 12 >> 2] = Fe, (h | 0) != (S | 0); )
                                                                                    ;
                                                                                  h = S;
                                                                                }
                                                                                if (e[y + 328 >> 2] = vi(G, 24) + ke, e[y + 324 >> 2] = hr, e[y + 320 >> 2] = c, !h)
                                                                                  break B;
                                                                                Sr(h);
                                                                              }
                                                                              h = g + 1 | 0, e[o + 4 >> 2] = e[o + 4 >> 2] - h, e[o >> 2] = h + e[o >> 2];
                                                                              break u;
                                                                            }
                                                                            o = Vr() | 0;
                                                                            break t;
                                                                          case 21:
                                                                            m: {
                                                                              if (h = e[o + 4 >> 2], h && (c = e[o >> 2], ye[c | 0] == 41))
                                                                                break m;
                                                                              e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                                              break c;
                                                                            }
                                                                            e[o + 4 >> 2] = h - 1, e[o >> 2] = c + 1;
                                                                            break u;
                                                                          case 20:
                                                                            m: {
                                                                              if (h = e[o + 4 >> 2], h && (c = e[o >> 2], ye[c | 0] == 44))
                                                                                break m;
                                                                              e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                                              break c;
                                                                            }
                                                                            e[o + 4 >> 2] = h - 1, e[o >> 2] = c + 1;
                                                                            break u;
                                                                          case 19:
                                                                            if (S = e[o + 4 >> 2], !S) {
                                                                              e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                                              break c;
                                                                            }
                                                                            m: {
                                                                              B: {
                                                                                R: {
                                                                                  E: {
                                                                                    C: {
                                                                                      y:
                                                                                        switch (G = e[o >> 2], ye[G | 0] - 41 | 0) {
                                                                                          case 0:
                                                                                            break C;
                                                                                          case 3:
                                                                                            break y;
                                                                                          default:
                                                                                            break E;
                                                                                        }
                                                                                      e[o + 4 >> 2] = S - 1, e[o >> 2] = G + 1, S = e[y + 292 >> 2], G = e[y + 288 >> 2] + 1 | 0, S = G ? S : S + 1 | 0;
                                                                                      y: {
                                                                                        D: {
                                                                                          ke = e[y + 328 >> 2];
                                                                                          P: {
                                                                                            if (ke >>> 0 > h >>> 0) {
                                                                                              e[h >> 2] = 19, e[h + 8 >> 2] = G, e[h + 12 >> 2] = S, g = e[y + 300 >> 2], e[h + 16 >> 2] = e[y + 296 >> 2], e[h + 20 >> 2] = g, e[y + 324 >> 2] = c;
                                                                                              break P;
                                                                                            }
                                                                                            q: {
                                                                                              O: {
                                                                                                hr = (h - g | 0) / 24 | 0, c = hr + 1 | 0;
                                                                                                Q: {
                                                                                                  if (c >>> 0 >= 178956971) {
                                                                                                    e[5996] = 0, Ri(142);
                                                                                                    break Q;
                                                                                                  }
                                                                                                  if (ke = (ke - g | 0) / 24 | 0, Fe = ke << 1, c = ke >>> 0 >= 89478485 ? 178956970 : c >>> 0 < Fe >>> 0 ? Fe : c, !c) {
                                                                                                    ke = 0;
                                                                                                    break q;
                                                                                                  }
                                                                                                  if (c >>> 0 < 178956971)
                                                                                                    break O;
                                                                                                  e[5996] = 0, Ri(35);
                                                                                                }
                                                                                                if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                  break e;
                                                                                                o = Vr() | 0;
                                                                                                break t;
                                                                                              }
                                                                                              if (e[5996] = 0, ke = ii(3, vi(c, 24) | 0) | 0, Fe = e[5996], e[5996] = 0, (Fe | 0) == 1)
                                                                                                break D;
                                                                                            }
                                                                                            hr = vi(hr, 24) + ke | 0, e[hr + 8 >> 2] = G, e[hr + 12 >> 2] = S, e[hr >> 2] = 19, S = e[y + 300 >> 2], e[hr + 16 >> 2] = e[y + 296 >> 2], e[hr + 20 >> 2] = S, ke = vi(c, 24) + ke | 0, c = hr + 24 | 0;
                                                                                            q: {
                                                                                              if ((h | 0) == (g | 0)) {
                                                                                                e[y + 328 >> 2] = ke, e[y + 324 >> 2] = c, e[y + 320 >> 2] = hr;
                                                                                                break q;
                                                                                              }
                                                                                              for (; h = h - 24 | 0, G = e[h + 4 >> 2], hr = hr - 24 | 0, S = hr, e[S >> 2] = e[h >> 2], e[S + 4 >> 2] = G, S = e[h + 20 >> 2], e[hr + 16 >> 2] = e[h + 16 >> 2], e[hr + 20 >> 2] = S, S = e[h + 12 >> 2], e[hr + 8 >> 2] = e[h + 8 >> 2], e[hr + 12 >> 2] = S, (h | 0) != (g | 0); )
                                                                                                ;
                                                                                              if (e[y + 328 >> 2] = ke, e[y + 324 >> 2] = c, e[y + 320 >> 2] = hr, !g)
                                                                                                break P;
                                                                                            }
                                                                                            Sr(g), ke = e[y + 328 >> 2], c = e[y + 324 >> 2];
                                                                                          }
                                                                                          if (c >>> 0 < ke >>> 0) {
                                                                                            e[c + 8 >> 2] = -1, e[c + 12 >> 2] = -1, e[c >> 2] = 0, e[c + 16 >> 2] = -1, e[c + 20 >> 2] = -1, e[y + 324 >> 2] = c + 24;
                                                                                            break u;
                                                                                          }
                                                                                          P: {
                                                                                            q: {
                                                                                              g = e[y + 320 >> 2], G = (c - g | 0) / 24 | 0, h = G + 1 | 0;
                                                                                              O: {
                                                                                                if (h >>> 0 >= 178956971) {
                                                                                                  e[5996] = 0, Ri(142);
                                                                                                  break O;
                                                                                                }
                                                                                                if (S = (ke - g | 0) / 24 | 0, ke = S << 1, S = S >>> 0 >= 89478485 ? 178956970 : h >>> 0 < ke >>> 0 ? ke : h, !S) {
                                                                                                  ke = 0;
                                                                                                  break P;
                                                                                                }
                                                                                                if (S >>> 0 < 178956971)
                                                                                                  break q;
                                                                                                e[5996] = 0, Ri(35);
                                                                                              }
                                                                                              if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                break e;
                                                                                              o = Vr() | 0;
                                                                                              break t;
                                                                                            }
                                                                                            if (e[5996] = 0, ke = ii(3, vi(S, 24) | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                              break y;
                                                                                          }
                                                                                          if (h = vi(G, 24) + ke | 0, e[h + 8 >> 2] = -1, e[h + 12 >> 2] = -1, e[h >> 2] = 0, e[h + 16 >> 2] = -1, e[h + 20 >> 2] = -1, G = h + 24 | 0, (c | 0) != (g | 0)) {
                                                                                            for (; c = c - 24 | 0, hr = e[c + 4 >> 2], h = h - 24 | 0, e[h >> 2] = e[c >> 2], e[h + 4 >> 2] = hr, hr = e[c + 20 >> 2], e[h + 16 >> 2] = e[c + 16 >> 2], e[h + 20 >> 2] = hr, hr = e[c + 12 >> 2], e[h + 8 >> 2] = e[c + 8 >> 2], e[h + 12 >> 2] = hr, (c | 0) != (g | 0); )
                                                                                              ;
                                                                                            c = g;
                                                                                          }
                                                                                          if (e[y + 328 >> 2] = vi(S, 24) + ke, e[y + 324 >> 2] = G, e[y + 320 >> 2] = h, !c)
                                                                                            break u;
                                                                                          Sr(c);
                                                                                          break u;
                                                                                        }
                                                                                        o = Vr() | 0;
                                                                                        break t;
                                                                                      }
                                                                                      o = Vr() | 0;
                                                                                      break t;
                                                                                    }
                                                                                    if (h = e[y + 288 >> 2], c = e[y + 292 >> 2], g = e[y + 300 >> 2], h >>> 0 < Ps[y + 296 >> 2] & (c | 0) <= (g | 0) | (c | 0) < (g | 0)) {
                                                                                      e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                                                      break c;
                                                                                    }
                                                                                    if (e[o + 4 >> 2] = S - 1, e[o >> 2] = G + 1, e[y + 340 >> 2] = 0, e[y + 332 >> 2] = 0, e[y + 336 >> 2] = 0, !h & (c | 0) <= 0 | (c | 0) < 0)
                                                                                      break B;
                                                                                    for (g = 0, c = 0, h = e[y + 312 >> 2]; ; ) {
                                                                                      C: {
                                                                                        S = h - 8 | 0, G = e[y + 336 >> 2];
                                                                                        y: {
                                                                                          if (G >>> 0 < Ps[y + 340 >> 2]) {
                                                                                            e[G >> 2] = e[S >> 2], ke = h - 4 | 0, e[G + 4 >> 2] = e[ke >> 2], e[S >> 2] = 0, e[ke >> 2] = 0, e[y + 336 >> 2] = G + 8;
                                                                                            break y;
                                                                                          }
                                                                                          if (e[5996] = 0, di(144, y + 332 | 0, S | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                            break C;
                                                                                          if (h = e[y + 312 >> 2], S = e[h - 4 >> 2], !S || (G = e[S + 4 >> 2], e[S + 4 >> 2] = G - 1, G))
                                                                                            break y;
                                                                                          _n[e[e[S >> 2] + 8 >> 2]](S), cs(S);
                                                                                        }
                                                                                        if (h = h - 8 | 0, e[y + 312 >> 2] = h, g = g + 1 | 0, c = g ? c : c + 1 | 0, S = e[y + 292 >> 2], Ps[y + 288 >> 2] > g >>> 0 & (S | 0) >= (c | 0) | (c | 0) < (S | 0))
                                                                                          continue;
                                                                                        break R;
                                                                                      }
                                                                                      break;
                                                                                    }
                                                                                    o = Vr() | 0;
                                                                                    break m;
                                                                                  }
                                                                                  e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                                                  break c;
                                                                                }
                                                                                if (h = e[y + 332 >> 2], g = e[y + 336 >> 2], (h | 0) == (g | 0) || (c = g - 8 | 0, c >>> 0 <= h >>> 0))
                                                                                  break B;
                                                                                for (; S = e[h >> 2], e[h >> 2] = e[c >> 2], e[c >> 2] = S, S = e[h + 4 >> 2], g = g - 4 | 0, e[h + 4 >> 2] = e[g >> 2], e[g >> 2] = S, g = c, h = h + 8 | 0, c = c - 8 | 0, h >>> 0 < c >>> 0; )
                                                                                  ;
                                                                              }
                                                                              e[5996] = 0, g = ii(3, 104) | 0, h = e[5996], e[5996] = 0;
                                                                              B: {
                                                                                R: {
                                                                                  if ((h | 0) != 1) {
                                                                                    if (e[g >> 2] = 7e3, e[g + 4 >> 2] = 0, e[g + 8 >> 2] = 0, e[5996] = 0, e[y + 240 >> 2] = e[y + 332 >> 2], h = e[y + 336 >> 2], c = e[y + 340 >> 2], e[y + 340 >> 2] = 0, e[y + 244 >> 2] = h, e[y + 248 >> 2] = c, e[y + 332 >> 2] = 0, e[y + 336 >> 2] = 0, G = da(64, g + 12 | 0, 24, y + 240 | 0, e[y + 296 >> 2]) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                      break B;
                                                                                    if (c = e[y + 240 >> 2], c) {
                                                                                      if (h = e[y + 244 >> 2], (c | 0) != (h | 0)) {
                                                                                        for (; ; ) {
                                                                                          h = h - 8 | 0, S = e[h + 4 >> 2];
                                                                                          E: {
                                                                                            if (!S || (ke = e[S + 4 >> 2], e[S + 4 >> 2] = ke - 1, ke))
                                                                                              break E;
                                                                                            _n[e[e[S >> 2] + 8 >> 2]](S), cs(S);
                                                                                          }
                                                                                          if ((c | 0) == (h | 0))
                                                                                            break;
                                                                                        }
                                                                                        c = e[y + 240 >> 2];
                                                                                      }
                                                                                      Sr(c);
                                                                                    }
                                                                                    e[y + 348 >> 2] = g, e[y + 344 >> 2] = G, h = e[y + 312 >> 2];
                                                                                    E: {
                                                                                      if (h >>> 0 < Ps[y + 316 >> 2]) {
                                                                                        e[h + 4 >> 2] = g, e[h >> 2] = G, e[y + 312 >> 2] = h + 8;
                                                                                        break E;
                                                                                      }
                                                                                      if (e[5996] = 0, di(144, y + 308 | 0, y + 344 | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                        break R;
                                                                                      if (h = e[y + 348 >> 2], !h || (c = e[h + 4 >> 2], e[h + 4 >> 2] = c - 1, c))
                                                                                        break E;
                                                                                      _n[e[e[h >> 2] + 8 >> 2]](h), cs(h);
                                                                                    }
                                                                                    if (c = e[y + 332 >> 2], !c)
                                                                                      break u;
                                                                                    if (h = e[y + 336 >> 2], (c | 0) != (h | 0)) {
                                                                                      for (; ; ) {
                                                                                        h = h - 8 | 0, g = e[h + 4 >> 2];
                                                                                        E: {
                                                                                          if (!g || (S = e[g + 4 >> 2], e[g + 4 >> 2] = S - 1, S))
                                                                                            break E;
                                                                                          _n[e[e[g >> 2] + 8 >> 2]](g), cs(g);
                                                                                        }
                                                                                        if ((c | 0) == (h | 0))
                                                                                          break;
                                                                                      }
                                                                                      c = e[y + 332 >> 2];
                                                                                    }
                                                                                    Sr(c);
                                                                                    break u;
                                                                                  }
                                                                                  o = Vr() | 0;
                                                                                  break m;
                                                                                }
                                                                                o = Vr() | 0, No(y + 344 | 0);
                                                                                break m;
                                                                              }
                                                                              o = Vr() | 0, xo(y + 240 | 0), Sr(g);
                                                                            }
                                                                            xo(y + 332 | 0);
                                                                            break t;
                                                                          case 14:
                                                                            c = e[y + 312 >> 2], h = c - 8 | 0, e[y + 332 >> 2] = e[h >> 2], e[y + 336 >> 2] = e[h + 4 >> 2], e[h >> 2] = 0, e[h + 4 >> 2] = 0, h = c - 16 | 0, e[y + 344 >> 2] = e[h >> 2], e[y + 348 >> 2] = e[h + 4 >> 2], e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[y + 312 >> 2] = h, e[5996] = 0, g = y + 240 | 0, Qs(145, g | 0, c - 24 | 0, y + 344 | 0, y + 332 | 0), h = e[5996], e[5996] = 0;
                                                                            m: {
                                                                              B: {
                                                                                R: {
                                                                                  if ((h | 0) != 1) {
                                                                                    if (e[5996] = 0, h = ii(3, 104) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                      break R;
                                                                                    if (e[5996] = 0, c = Si(146, h | 0, 23, g | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1) {
                                                                                      o = Vr() | 0, Sr(h);
                                                                                      break B;
                                                                                    }
                                                                                    g = e[y + 312 >> 2] - 8 | 0, e[g >> 2] = c + 12, h = e[g + 4 >> 2], e[g + 4 >> 2] = c;
                                                                                    E: {
                                                                                      if (!h || (c = e[h + 4 >> 2], e[h + 4 >> 2] = c - 1, c))
                                                                                        break E;
                                                                                      _n[e[e[h >> 2] + 8 >> 2]](h), cs(h);
                                                                                    }
                                                                                    if (g = e[y + 240 >> 2], g) {
                                                                                      if (h = e[y + 244 >> 2], c = g, (h | 0) != (c | 0)) {
                                                                                        for (; ; ) {
                                                                                          h = h - 8 | 0, c = e[h + 4 >> 2];
                                                                                          E: {
                                                                                            if (!c || (S = e[c + 4 >> 2], e[c + 4 >> 2] = S - 1, S))
                                                                                              break E;
                                                                                            _n[e[e[c >> 2] + 8 >> 2]](c), cs(c);
                                                                                          }
                                                                                          if ((h | 0) == (g | 0))
                                                                                            break;
                                                                                        }
                                                                                        c = e[y + 240 >> 2];
                                                                                      }
                                                                                      e[y + 244 >> 2] = g, Sr(c);
                                                                                    }
                                                                                    h = e[y + 348 >> 2];
                                                                                    E: {
                                                                                      if (!h || (c = e[h + 4 >> 2], e[h + 4 >> 2] = c - 1, c))
                                                                                        break E;
                                                                                      _n[e[e[h >> 2] + 8 >> 2]](h), cs(h);
                                                                                    }
                                                                                    if (h = e[y + 336 >> 2], !h || (c = e[h + 4 >> 2], e[h + 4 >> 2] = c - 1, c))
                                                                                      break u;
                                                                                    _n[e[e[h >> 2] + 8 >> 2]](h), cs(h);
                                                                                    break u;
                                                                                  }
                                                                                  o = Vr() | 0;
                                                                                  break m;
                                                                                }
                                                                                o = Vr() | 0;
                                                                              }
                                                                              xo(y + 240 | 0);
                                                                            }
                                                                            No(y + 344 | 0), No(y + 332 | 0);
                                                                            break t;
                                                                          case 18:
                                                                            hr = 22;
                                                                            break h;
                                                                          case 17:
                                                                            hr = 21;
                                                                            break h;
                                                                          case 16:
                                                                            hr = 20;
                                                                            break h;
                                                                          case 15:
                                                                            hr = 19;
                                                                            break h;
                                                                          case 1:
                                                                            break g;
                                                                          case 3:
                                                                            break A;
                                                                          case 2:
                                                                            break p;
                                                                          case 4:
                                                                            break I;
                                                                          case 5:
                                                                            break k;
                                                                          case 7:
                                                                            break N;
                                                                          case 8:
                                                                            break S;
                                                                          case 6:
                                                                            break T;
                                                                          case 9:
                                                                            break v;
                                                                          case 10:
                                                                            break w;
                                                                          case 11:
                                                                            break b;
                                                                          case 13:
                                                                            break h;
                                                                          case 12:
                                                                            break x;
                                                                          default:
                                                                            break u;
                                                                        }
                                                                      hr = 17;
                                                                    }
                                                                    g = e[y + 312 >> 2], c = g - 8 | 0, e[y + 344 >> 2] = e[c >> 2], e[y + 348 >> 2] = e[c + 4 >> 2], e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[y + 312 >> 2] = c, e[5996] = 0, e[y + 340 >> 2] = 0, e[y + 332 >> 2] = 0, e[y + 336 >> 2] = 0, h = ii(3, 16) | 0, S = e[5996], e[5996] = 0;
                                                                    h: {
                                                                      if ((S | 0) == 1) {
                                                                        o = Vr() | 0;
                                                                        break h;
                                                                      }
                                                                      if (e[y + 332 >> 2] = h, S = h + 16 | 0, e[y + 340 >> 2] = S, g = g - 16 | 0, e[h >> 2] = e[g >> 2], e[h + 4 >> 2] = e[g + 4 >> 2], e[g >> 2] = 0, e[g + 4 >> 2] = 0, e[h + 8 >> 2] = e[y + 344 >> 2], e[h + 12 >> 2] = e[y + 348 >> 2], e[y + 336 >> 2] = S, e[y + 344 >> 2] = 0, e[y + 348 >> 2] = 0, e[5996] = 0, g = ii(3, 104) | 0, G = e[5996], e[5996] = 0, (G | 0) != 1) {
                                                                        if (e[g >> 2] = 7e3, e[g + 4 >> 2] = 0, e[g + 8 >> 2] = 0, e[y + 244 >> 2] = S, e[y + 240 >> 2] = h, e[y + 332 >> 2] = 0, e[y + 336 >> 2] = 0, e[5996] = 0, h = e[y + 340 >> 2], e[y + 340 >> 2] = 0, e[y + 248 >> 2] = h, S = da(64, g + 12 | 0, hr | 0, y + 240 | 0, 0) | 0, h = e[5996], e[5996] = 0, (h | 0) != 1) {
                                                                          if (hr = e[y + 240 >> 2], hr) {
                                                                            if (h = e[y + 244 >> 2], (hr | 0) != (h | 0)) {
                                                                              for (; ; ) {
                                                                                h = h - 8 | 0, c = e[h + 4 >> 2];
                                                                                x: {
                                                                                  if (!c || (G = e[c + 4 >> 2], e[c + 4 >> 2] = G - 1, G))
                                                                                    break x;
                                                                                  _n[e[e[c >> 2] + 8 >> 2]](c), cs(c);
                                                                                }
                                                                                if ((h | 0) == (hr | 0))
                                                                                  break;
                                                                              }
                                                                              hr = e[y + 240 >> 2], c = e[y + 312 >> 2];
                                                                            }
                                                                            Sr(hr);
                                                                          }
                                                                          c = c - 8 | 0, e[c >> 2] = S, h = e[c + 4 >> 2], e[c + 4 >> 2] = g;
                                                                          x: {
                                                                            if (!h || (c = e[h + 4 >> 2], e[h + 4 >> 2] = c - 1, c))
                                                                              break x;
                                                                            _n[e[e[h >> 2] + 8 >> 2]](h), cs(h);
                                                                          }
                                                                          if (c = e[y + 332 >> 2], c) {
                                                                            if (h = e[y + 336 >> 2], (c | 0) != (h | 0)) {
                                                                              for (; ; ) {
                                                                                h = h - 8 | 0, g = e[h + 4 >> 2];
                                                                                x: {
                                                                                  if (!g || (S = e[g + 4 >> 2], e[g + 4 >> 2] = S - 1, S))
                                                                                    break x;
                                                                                  _n[e[e[g >> 2] + 8 >> 2]](g), cs(g);
                                                                                }
                                                                                if ((c | 0) == (h | 0))
                                                                                  break;
                                                                              }
                                                                              c = e[y + 332 >> 2];
                                                                            }
                                                                            Sr(c);
                                                                          }
                                                                          if (h = e[y + 348 >> 2], !h || (c = e[h + 4 >> 2], e[h + 4 >> 2] = c - 1, c))
                                                                            break u;
                                                                          _n[e[e[h >> 2] + 8 >> 2]](h), cs(h);
                                                                          break u;
                                                                        }
                                                                        o = Vr() | 0, xo(y + 240 | 0), Sr(g);
                                                                        break h;
                                                                      }
                                                                      o = Vr() | 0;
                                                                    }
                                                                    xo(y + 332 | 0), No(y + 344 | 0);
                                                                    break t;
                                                                  }
                                                                  c = e[y + 312 >> 2], h = c - 8 | 0, e[y + 332 >> 2] = e[h >> 2], e[y + 336 >> 2] = e[h + 4 >> 2], e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[y + 312 >> 2] = h, e[5996] = 0, h = ii(3, 104) | 0, g = e[5996], e[5996] = 0;
                                                                  b: {
                                                                    h: {
                                                                      x: {
                                                                        m: {
                                                                          B: {
                                                                            if ((g | 0) != 1) {
                                                                              if (e[h >> 2] = 7e3, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, g = Si(143, h + 12 | 0, 0, 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) {
                                                                                o = Vr() | 0, Sr(h);
                                                                                break b;
                                                                              }
                                                                              if (e[y + 348 >> 2] = h, e[y + 344 >> 2] = g, e[5996] = 0, g = y + 240 | 0, Qs(145, g | 0, c - 16 | 0, y + 332 | 0, y + 344 | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                break B;
                                                                              if (e[5996] = 0, h = ii(3, 104) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                break m;
                                                                              if (e[5996] = 0, c = Si(146, h | 0, 23, g | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1) {
                                                                                o = Vr() | 0, Sr(h);
                                                                                break x;
                                                                              }
                                                                              g = e[y + 312 >> 2] - 8 | 0, e[g >> 2] = c + 12, h = e[g + 4 >> 2], e[g + 4 >> 2] = c;
                                                                              R: {
                                                                                if (!h || (c = e[h + 4 >> 2], e[h + 4 >> 2] = c - 1, c))
                                                                                  break R;
                                                                                _n[e[e[h >> 2] + 8 >> 2]](h), cs(h);
                                                                              }
                                                                              if (g = e[y + 240 >> 2], g) {
                                                                                if (h = e[y + 244 >> 2], c = g, (h | 0) != (c | 0)) {
                                                                                  for (; ; ) {
                                                                                    h = h - 8 | 0, c = e[h + 4 >> 2];
                                                                                    R: {
                                                                                      if (!c || (S = e[c + 4 >> 2], e[c + 4 >> 2] = S - 1, S))
                                                                                        break R;
                                                                                      _n[e[e[c >> 2] + 8 >> 2]](c), cs(c);
                                                                                    }
                                                                                    if ((h | 0) == (g | 0))
                                                                                      break;
                                                                                  }
                                                                                  c = e[y + 240 >> 2];
                                                                                }
                                                                                e[y + 244 >> 2] = g, Sr(c);
                                                                              }
                                                                              h = e[y + 348 >> 2];
                                                                              R: {
                                                                                if (!h || (c = e[h + 4 >> 2], e[h + 4 >> 2] = c - 1, c))
                                                                                  break R;
                                                                                _n[e[e[h >> 2] + 8 >> 2]](h), cs(h);
                                                                              }
                                                                              if (h = e[y + 336 >> 2], !h || (c = e[h + 4 >> 2], e[h + 4 >> 2] = c - 1, c))
                                                                                break u;
                                                                              _n[e[e[h >> 2] + 8 >> 2]](h), cs(h);
                                                                              break u;
                                                                            }
                                                                            o = Vr() | 0;
                                                                            break b;
                                                                          }
                                                                          o = Vr() | 0;
                                                                          break h;
                                                                        }
                                                                        o = Vr() | 0;
                                                                      }
                                                                      xo(y + 240 | 0);
                                                                    }
                                                                    No(y + 344 | 0);
                                                                  }
                                                                  No(y + 332 | 0);
                                                                  break t;
                                                                }
                                                                e[5996] = 0, c = e[y + 312 >> 2], h = ii(3, 104) | 0, g = e[5996], e[5996] = 0;
                                                                w: {
                                                                  b: {
                                                                    if ((g | 0) != 1) {
                                                                      if (e[h >> 2] = 7e3, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, g = Si(143, h + 12 | 0, 1, 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) {
                                                                        o = Vr() | 0, Sr(h);
                                                                        break t;
                                                                      }
                                                                      if (e[y + 336 >> 2] = h, e[y + 332 >> 2] = g, e[y + 248 >> 2] = 0, e[y + 240 >> 2] = 0, e[y + 244 >> 2] = 0, e[5996] = 0, h = ii(3, 16) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1) {
                                                                        o = Vr() | 0;
                                                                        break w;
                                                                      }
                                                                      if (e[y + 240 >> 2] = h, S = h + 16 | 0, e[y + 248 >> 2] = S, g = c - 8 | 0, e[h >> 2] = e[g >> 2], c = c - 4 | 0, e[h + 4 >> 2] = e[c >> 2], e[g >> 2] = 0, e[c >> 2] = 0, e[h + 8 >> 2] = e[y + 332 >> 2], e[h + 12 >> 2] = e[y + 336 >> 2], e[y + 244 >> 2] = S, e[y + 332 >> 2] = 0, e[y + 336 >> 2] = 0, e[5996] = 0, h = ii(3, 104) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                        break b;
                                                                      if (e[5996] = 0, S = Si(146, h | 0, 17, y + 240 | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1) {
                                                                        o = Vr() | 0, Sr(h);
                                                                        break w;
                                                                      }
                                                                      e[g >> 2] = S + 12, h = e[c >> 2], e[c >> 2] = S;
                                                                      h: {
                                                                        if (!h || (c = e[h + 4 >> 2], e[h + 4 >> 2] = c - 1, c))
                                                                          break h;
                                                                        _n[e[e[h >> 2] + 8 >> 2]](h), cs(h);
                                                                      }
                                                                      if (g = e[y + 240 >> 2], g) {
                                                                        if (h = e[y + 244 >> 2], c = g, (h | 0) != (c | 0)) {
                                                                          for (; ; ) {
                                                                            h = h - 8 | 0, c = e[h + 4 >> 2];
                                                                            h: {
                                                                              if (!c || (S = e[c + 4 >> 2], e[c + 4 >> 2] = S - 1, S))
                                                                                break h;
                                                                              _n[e[e[c >> 2] + 8 >> 2]](c), cs(c);
                                                                            }
                                                                            if ((h | 0) == (g | 0))
                                                                              break;
                                                                          }
                                                                          c = e[y + 240 >> 2];
                                                                        }
                                                                        e[y + 244 >> 2] = g, Sr(c);
                                                                      }
                                                                      if (h = e[y + 336 >> 2], !h || (c = e[h + 4 >> 2], e[h + 4 >> 2] = c - 1, c))
                                                                        break u;
                                                                      _n[e[e[h >> 2] + 8 >> 2]](h), cs(h);
                                                                      break u;
                                                                    }
                                                                    o = Vr() | 0;
                                                                    break t;
                                                                  }
                                                                  o = Vr() | 0;
                                                                }
                                                                xo(y + 240 | 0), No(y + 332 | 0);
                                                                break t;
                                                              }
                                                              e[5996] = 0, c = e[y + 312 >> 2], h = ii(3, 104) | 0, g = e[5996], e[5996] = 0;
                                                              v: {
                                                                w: {
                                                                  if ((g | 0) != 1) {
                                                                    if (e[h >> 2] = 7e3, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, g = Si(143, h + 12 | 0, 0, 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) {
                                                                      o = Vr() | 0, Sr(h);
                                                                      break t;
                                                                    }
                                                                    if (e[y + 336 >> 2] = h, e[y + 332 >> 2] = g, e[y + 248 >> 2] = 0, e[y + 240 >> 2] = 0, e[y + 244 >> 2] = 0, e[5996] = 0, h = ii(3, 16) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1) {
                                                                      o = Vr() | 0;
                                                                      break v;
                                                                    }
                                                                    if (e[y + 240 >> 2] = h, S = h + 16 | 0, e[y + 248 >> 2] = S, g = c - 8 | 0, e[h >> 2] = e[g >> 2], c = c - 4 | 0, e[h + 4 >> 2] = e[c >> 2], e[g >> 2] = 0, e[c >> 2] = 0, e[h + 8 >> 2] = e[y + 332 >> 2], e[h + 12 >> 2] = e[y + 336 >> 2], e[y + 244 >> 2] = S, e[y + 332 >> 2] = 0, e[y + 336 >> 2] = 0, e[5996] = 0, h = ii(3, 104) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                      break w;
                                                                    if (e[5996] = 0, S = Si(146, h | 0, 22, y + 240 | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1) {
                                                                      o = Vr() | 0, Sr(h);
                                                                      break v;
                                                                    }
                                                                    e[g >> 2] = S + 12, h = e[c >> 2], e[c >> 2] = S;
                                                                    b: {
                                                                      if (!h || (c = e[h + 4 >> 2], e[h + 4 >> 2] = c - 1, c))
                                                                        break b;
                                                                      _n[e[e[h >> 2] + 8 >> 2]](h), cs(h);
                                                                    }
                                                                    if (g = e[y + 240 >> 2], g) {
                                                                      if (h = e[y + 244 >> 2], c = g, (h | 0) != (c | 0)) {
                                                                        for (; ; ) {
                                                                          h = h - 8 | 0, c = e[h + 4 >> 2];
                                                                          b: {
                                                                            if (!c || (S = e[c + 4 >> 2], e[c + 4 >> 2] = S - 1, S))
                                                                              break b;
                                                                            _n[e[e[c >> 2] + 8 >> 2]](c), cs(c);
                                                                          }
                                                                          if ((h | 0) == (g | 0))
                                                                            break;
                                                                        }
                                                                        c = e[y + 240 >> 2];
                                                                      }
                                                                      e[y + 244 >> 2] = g, Sr(c);
                                                                    }
                                                                    if (h = e[y + 336 >> 2], !h || (c = e[h + 4 >> 2], e[h + 4 >> 2] = c - 1, c))
                                                                      break u;
                                                                    _n[e[e[h >> 2] + 8 >> 2]](h), cs(h);
                                                                    break u;
                                                                  }
                                                                  o = Vr() | 0;
                                                                  break t;
                                                                }
                                                                o = Vr() | 0;
                                                              }
                                                              xo(y + 240 | 0), No(y + 332 | 0);
                                                              break t;
                                                            }
                                                            e[y + 248 >> 2] = 0, e[y + 240 >> 2] = 0, e[y + 244 >> 2] = 0, e[5996] = 0, h = e[y + 312 >> 2], c = ii(3, 8) | 0, g = e[5996], e[5996] = 0;
                                                            T: {
                                                              if ((g | 0) != 1) {
                                                                if (e[y + 240 >> 2] = c, g = c + 8 | 0, e[y + 248 >> 2] = g, h = h - 8 | 0, e[c >> 2] = e[h >> 2], e[c + 4 >> 2] = e[h + 4 >> 2], e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[5996] = 0, e[y + 244 >> 2] = g, c = ii(3, 104) | 0, g = e[5996], e[5996] = 0, (g | 0) != 1) {
                                                                  if (e[5996] = 0, g = Si(146, c | 0, 14, y + 240 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) {
                                                                    o = Vr() | 0, Sr(c);
                                                                    break T;
                                                                  }
                                                                  e[h >> 2] = g + 12, c = e[h + 4 >> 2], e[h + 4 >> 2] = g;
                                                                  v: {
                                                                    if (!c || (h = e[c + 4 >> 2], e[c + 4 >> 2] = h - 1, h))
                                                                      break v;
                                                                    _n[e[e[c >> 2] + 8 >> 2]](c), cs(c);
                                                                  }
                                                                  if (c = e[y + 240 >> 2], !c)
                                                                    break u;
                                                                  if (h = e[y + 244 >> 2], (c | 0) != (h | 0)) {
                                                                    for (; ; ) {
                                                                      h = h - 8 | 0, g = e[h + 4 >> 2];
                                                                      v: {
                                                                        if (!g || (S = e[g + 4 >> 2], e[g + 4 >> 2] = S - 1, S))
                                                                          break v;
                                                                        _n[e[e[g >> 2] + 8 >> 2]](g), cs(g);
                                                                      }
                                                                      if ((c | 0) == (h | 0))
                                                                        break;
                                                                    }
                                                                    c = e[y + 240 >> 2];
                                                                  }
                                                                  Sr(c);
                                                                  break u;
                                                                }
                                                                o = Vr() | 0;
                                                                break T;
                                                              }
                                                              o = Vr() | 0;
                                                            }
                                                            xo(y + 240 | 0);
                                                            break t;
                                                          }
                                                          e[y + 248 >> 2] = 0, e[y + 240 >> 2] = 0, e[y + 244 >> 2] = 0, e[5996] = 0, h = e[y + 312 >> 2], c = ii(3, 8) | 0, g = e[5996], e[5996] = 0;
                                                          S: {
                                                            if ((g | 0) != 1) {
                                                              if (e[y + 240 >> 2] = c, g = c + 8 | 0, e[y + 248 >> 2] = g, h = h - 8 | 0, e[c >> 2] = e[h >> 2], e[c + 4 >> 2] = e[h + 4 >> 2], e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[5996] = 0, e[y + 244 >> 2] = g, c = ii(3, 104) | 0, g = e[5996], e[5996] = 0, (g | 0) != 1) {
                                                                if (e[5996] = 0, g = Si(146, c | 0, 16, y + 240 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) {
                                                                  o = Vr() | 0, Sr(c);
                                                                  break S;
                                                                }
                                                                e[h >> 2] = g + 12, c = e[h + 4 >> 2], e[h + 4 >> 2] = g;
                                                                T: {
                                                                  if (!c || (h = e[c + 4 >> 2], e[c + 4 >> 2] = h - 1, h))
                                                                    break T;
                                                                  _n[e[e[c >> 2] + 8 >> 2]](c), cs(c);
                                                                }
                                                                if (c = e[y + 240 >> 2], !c)
                                                                  break u;
                                                                if (h = e[y + 244 >> 2], (c | 0) != (h | 0)) {
                                                                  for (; ; ) {
                                                                    h = h - 8 | 0, g = e[h + 4 >> 2];
                                                                    T: {
                                                                      if (!g || (S = e[g + 4 >> 2], e[g + 4 >> 2] = S - 1, S))
                                                                        break T;
                                                                      _n[e[e[g >> 2] + 8 >> 2]](g), cs(g);
                                                                    }
                                                                    if ((c | 0) == (h | 0))
                                                                      break;
                                                                  }
                                                                  c = e[y + 240 >> 2];
                                                                }
                                                                Sr(c);
                                                                break u;
                                                              }
                                                              o = Vr() | 0;
                                                              break S;
                                                            }
                                                            o = Vr() | 0;
                                                          }
                                                          xo(y + 240 | 0);
                                                          break t;
                                                        }
                                                        e[y + 248 >> 2] = 0, e[y + 240 >> 2] = 0, e[y + 244 >> 2] = 0, e[5996] = 0, h = e[y + 312 >> 2], c = ii(3, 8) | 0, g = e[5996], e[5996] = 0;
                                                        N: {
                                                          if ((g | 0) != 1) {
                                                            if (e[y + 240 >> 2] = c, g = c + 8 | 0, e[y + 248 >> 2] = g, h = h - 8 | 0, e[c >> 2] = e[h >> 2], e[c + 4 >> 2] = e[h + 4 >> 2], e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[5996] = 0, e[y + 244 >> 2] = g, c = ii(3, 104) | 0, g = e[5996], e[5996] = 0, (g | 0) != 1) {
                                                              if (e[5996] = 0, g = Si(146, c | 0, 15, y + 240 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) {
                                                                o = Vr() | 0, Sr(c);
                                                                break N;
                                                              }
                                                              e[h >> 2] = g + 12, c = e[h + 4 >> 2], e[h + 4 >> 2] = g;
                                                              S: {
                                                                if (!c || (h = e[c + 4 >> 2], e[c + 4 >> 2] = h - 1, h))
                                                                  break S;
                                                                _n[e[e[c >> 2] + 8 >> 2]](c), cs(c);
                                                              }
                                                              if (c = e[y + 240 >> 2], !c)
                                                                break u;
                                                              if (h = e[y + 244 >> 2], (c | 0) != (h | 0)) {
                                                                for (; ; ) {
                                                                  h = h - 8 | 0, g = e[h + 4 >> 2];
                                                                  S: {
                                                                    if (!g || (S = e[g + 4 >> 2], e[g + 4 >> 2] = S - 1, S))
                                                                      break S;
                                                                    _n[e[e[g >> 2] + 8 >> 2]](g), cs(g);
                                                                  }
                                                                  if ((c | 0) == (h | 0))
                                                                    break;
                                                                }
                                                                c = e[y + 240 >> 2];
                                                              }
                                                              Sr(c);
                                                              break u;
                                                            }
                                                            o = Vr() | 0;
                                                            break N;
                                                          }
                                                          o = Vr() | 0;
                                                        }
                                                        xo(y + 240 | 0);
                                                        break t;
                                                      }
                                                      e[y + 248 >> 2] = 0, e[y + 240 >> 2] = 0, e[y + 244 >> 2] = 0, e[5996] = 0, h = e[y + 312 >> 2], c = ii(3, 8) | 0, g = e[5996], e[5996] = 0;
                                                      k: {
                                                        if ((g | 0) != 1) {
                                                          if (e[y + 240 >> 2] = c, g = c + 8 | 0, e[y + 248 >> 2] = g, h = h - 8 | 0, e[c >> 2] = e[h >> 2], e[c + 4 >> 2] = e[h + 4 >> 2], e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[5996] = 0, e[y + 244 >> 2] = g, c = ii(3, 104) | 0, g = e[5996], e[5996] = 0, (g | 0) != 1) {
                                                            if (e[5996] = 0, g = Si(146, c | 0, 13, y + 240 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) {
                                                              o = Vr() | 0, Sr(c);
                                                              break k;
                                                            }
                                                            e[h >> 2] = g + 12, c = e[h + 4 >> 2], e[h + 4 >> 2] = g;
                                                            N: {
                                                              if (!c || (h = e[c + 4 >> 2], e[c + 4 >> 2] = h - 1, h))
                                                                break N;
                                                              _n[e[e[c >> 2] + 8 >> 2]](c), cs(c);
                                                            }
                                                            if (c = e[y + 240 >> 2], !c)
                                                              break u;
                                                            if (h = e[y + 244 >> 2], (c | 0) != (h | 0)) {
                                                              for (; ; ) {
                                                                h = h - 8 | 0, g = e[h + 4 >> 2];
                                                                N: {
                                                                  if (!g || (S = e[g + 4 >> 2], e[g + 4 >> 2] = S - 1, S))
                                                                    break N;
                                                                  _n[e[e[g >> 2] + 8 >> 2]](g), cs(g);
                                                                }
                                                                if ((c | 0) == (h | 0))
                                                                  break;
                                                              }
                                                              c = e[y + 240 >> 2];
                                                            }
                                                            Sr(c);
                                                            break u;
                                                          }
                                                          o = Vr() | 0;
                                                          break k;
                                                        }
                                                        o = Vr() | 0;
                                                      }
                                                      xo(y + 240 | 0);
                                                      break t;
                                                    }
                                                    e[y + 248 >> 2] = 0, e[y + 240 >> 2] = 0, e[y + 244 >> 2] = 0, e[5996] = 0, h = e[y + 312 >> 2], c = ii(3, 8) | 0, g = e[5996], e[5996] = 0;
                                                    I: {
                                                      if ((g | 0) != 1) {
                                                        if (e[y + 240 >> 2] = c, g = c + 8 | 0, e[y + 248 >> 2] = g, h = h - 8 | 0, e[c >> 2] = e[h >> 2], e[c + 4 >> 2] = e[h + 4 >> 2], e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[5996] = 0, e[y + 244 >> 2] = g, c = ii(3, 104) | 0, g = e[5996], e[5996] = 0, (g | 0) != 1) {
                                                          if (e[5996] = 0, g = Si(146, c | 0, 12, y + 240 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) {
                                                            o = Vr() | 0, Sr(c);
                                                            break I;
                                                          }
                                                          e[h >> 2] = g + 12, c = e[h + 4 >> 2], e[h + 4 >> 2] = g;
                                                          k: {
                                                            if (!c || (h = e[c + 4 >> 2], e[c + 4 >> 2] = h - 1, h))
                                                              break k;
                                                            _n[e[e[c >> 2] + 8 >> 2]](c), cs(c);
                                                          }
                                                          if (c = e[y + 240 >> 2], !c)
                                                            break u;
                                                          if (h = e[y + 244 >> 2], (c | 0) != (h | 0)) {
                                                            for (; ; ) {
                                                              h = h - 8 | 0, g = e[h + 4 >> 2];
                                                              k: {
                                                                if (!g || (S = e[g + 4 >> 2], e[g + 4 >> 2] = S - 1, S))
                                                                  break k;
                                                                _n[e[e[g >> 2] + 8 >> 2]](g), cs(g);
                                                              }
                                                              if ((c | 0) == (h | 0))
                                                                break;
                                                            }
                                                            c = e[y + 240 >> 2];
                                                          }
                                                          Sr(c);
                                                          break u;
                                                        }
                                                        o = Vr() | 0;
                                                        break I;
                                                      }
                                                      o = Vr() | 0;
                                                    }
                                                    xo(y + 240 | 0);
                                                    break t;
                                                  }
                                                  e[y + 248 >> 2] = 0, e[y + 240 >> 2] = 0, e[y + 244 >> 2] = 0, e[5996] = 0, h = e[y + 312 >> 2], c = ii(3, 8) | 0, g = e[5996], e[5996] = 0;
                                                  p: {
                                                    if ((g | 0) != 1) {
                                                      if (e[y + 240 >> 2] = c, g = c + 8 | 0, e[y + 248 >> 2] = g, h = h - 8 | 0, e[c >> 2] = e[h >> 2], e[c + 4 >> 2] = e[h + 4 >> 2], e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[5996] = 0, e[y + 244 >> 2] = g, c = ii(3, 104) | 0, g = e[5996], e[5996] = 0, (g | 0) != 1) {
                                                        if (e[5996] = 0, g = Si(146, c | 0, 11, y + 240 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) {
                                                          o = Vr() | 0, Sr(c);
                                                          break p;
                                                        }
                                                        e[h >> 2] = g + 12, c = e[h + 4 >> 2], e[h + 4 >> 2] = g;
                                                        I: {
                                                          if (!c || (h = e[c + 4 >> 2], e[c + 4 >> 2] = h - 1, h))
                                                            break I;
                                                          _n[e[e[c >> 2] + 8 >> 2]](c), cs(c);
                                                        }
                                                        if (c = e[y + 240 >> 2], !c)
                                                          break u;
                                                        if (h = e[y + 244 >> 2], (c | 0) != (h | 0)) {
                                                          for (; ; ) {
                                                            h = h - 8 | 0, g = e[h + 4 >> 2];
                                                            I: {
                                                              if (!g || (S = e[g + 4 >> 2], e[g + 4 >> 2] = S - 1, S))
                                                                break I;
                                                              _n[e[e[g >> 2] + 8 >> 2]](g), cs(g);
                                                            }
                                                            if ((c | 0) == (h | 0))
                                                              break;
                                                          }
                                                          c = e[y + 240 >> 2];
                                                        }
                                                        Sr(c);
                                                        break u;
                                                      }
                                                      o = Vr() | 0;
                                                      break p;
                                                    }
                                                    o = Vr() | 0;
                                                  }
                                                  xo(y + 240 | 0);
                                                  break t;
                                                }
                                                e[y + 248 >> 2] = 0, e[y + 240 >> 2] = 0, e[y + 244 >> 2] = 0, e[5996] = 0, h = e[y + 312 >> 2], c = ii(3, 8) | 0, g = e[5996], e[5996] = 0;
                                                A: {
                                                  if ((g | 0) != 1) {
                                                    if (e[y + 240 >> 2] = c, g = c + 8 | 0, e[y + 248 >> 2] = g, h = h - 8 | 0, e[c >> 2] = e[h >> 2], e[c + 4 >> 2] = e[h + 4 >> 2], e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[5996] = 0, e[y + 244 >> 2] = g, c = ii(3, 104) | 0, g = e[5996], e[5996] = 0, (g | 0) != 1) {
                                                      if (e[5996] = 0, g = Si(146, c | 0, 10, y + 240 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) {
                                                        o = Vr() | 0, Sr(c);
                                                        break A;
                                                      }
                                                      e[h >> 2] = g + 12, c = e[h + 4 >> 2], e[h + 4 >> 2] = g;
                                                      p: {
                                                        if (!c || (h = e[c + 4 >> 2], e[c + 4 >> 2] = h - 1, h))
                                                          break p;
                                                        _n[e[e[c >> 2] + 8 >> 2]](c), cs(c);
                                                      }
                                                      if (c = e[y + 240 >> 2], !c)
                                                        break u;
                                                      if (h = e[y + 244 >> 2], (c | 0) != (h | 0)) {
                                                        for (; ; ) {
                                                          h = h - 8 | 0, g = e[h + 4 >> 2];
                                                          p: {
                                                            if (!g || (S = e[g + 4 >> 2], e[g + 4 >> 2] = S - 1, S))
                                                              break p;
                                                            _n[e[e[g >> 2] + 8 >> 2]](g), cs(g);
                                                          }
                                                          if ((c | 0) == (h | 0))
                                                            break;
                                                        }
                                                        c = e[y + 240 >> 2];
                                                      }
                                                      Sr(c);
                                                      break u;
                                                    }
                                                    o = Vr() | 0;
                                                    break A;
                                                  }
                                                  o = Vr() | 0;
                                                }
                                                xo(y + 240 | 0);
                                                break t;
                                              }
                                              Vs[y + 240 >> 1] = 48, $[y + 251 | 0] = 1;
                                              g: {
                                                A: {
                                                  p: {
                                                    I: {
                                                      if (h = e[o + 4 >> 2], !h) {
                                                        $[y + 251 | 0] = 3, $[y + 243 | 0] = 0, Vs[y + 240 >> 1] = ye[5279] | ye[5280] << 8, $[y + 242 | 0] = ye[5281];
                                                        break I;
                                                      }
                                                      if (c = e[o >> 2], ye[y + 240 | 0] == ye[c | 0]) {
                                                        e[o + 4 >> 2] = h - 1, e[o >> 2] = c + 1, e[5996] = 0, h = ii(3, 104) | 0, c = e[5996], e[5996] = 0;
                                                        k: {
                                                          if ((c | 0) != 1) {
                                                            if (e[h >> 2] = 7e3, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, g = Si(143, h + 12 | 0, 0, 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1) {
                                                              o = Vr() | 0, Sr(h);
                                                              break t;
                                                            }
                                                            if (e[y + 244 >> 2] = h, e[y + 240 >> 2] = g, c = e[y + 312 >> 2], c >>> 0 < Ps[y + 316 >> 2]) {
                                                              e[c + 4 >> 2] = h, e[c >> 2] = g, e[y + 312 >> 2] = c + 8;
                                                              break u;
                                                            }
                                                            if (e[5996] = 0, di(144, y + 308 | 0, y + 240 | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                              break k;
                                                            if (h = e[y + 244 >> 2], !h || (c = e[h + 4 >> 2], e[h + 4 >> 2] = c - 1, c))
                                                              break u;
                                                            _n[e[e[h >> 2] + 8 >> 2]](h), cs(h);
                                                            break u;
                                                          }
                                                          o = Vr() | 0;
                                                          break t;
                                                        }
                                                        o = Vr() | 0, No(y + 240 | 0);
                                                        break t;
                                                      }
                                                      if ($[y + 251 | 0] = 1, Vs[y + 240 >> 1] = 49, c = e[o >> 2], ye[c | 0] == 49) {
                                                        e[o + 4 >> 2] = h - 1, e[o >> 2] = c + 1, e[5996] = 0, h = ii(3, 104) | 0, c = e[5996], e[5996] = 0;
                                                        k: {
                                                          if ((c | 0) != 1) {
                                                            if (e[h >> 2] = 7e3, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, g = Si(143, h + 12 | 0, 1, 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1) {
                                                              o = Vr() | 0, Sr(h);
                                                              break t;
                                                            }
                                                            if (e[y + 244 >> 2] = h, e[y + 240 >> 2] = g, c = e[y + 312 >> 2], c >>> 0 < Ps[y + 316 >> 2]) {
                                                              e[c + 4 >> 2] = h, e[c >> 2] = g, e[y + 312 >> 2] = c + 8;
                                                              break u;
                                                            }
                                                            if (e[5996] = 0, di(144, y + 308 | 0, y + 240 | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                              break k;
                                                            if (h = e[y + 244 >> 2], !h || (c = e[h + 4 >> 2], e[h + 4 >> 2] = c - 1, c))
                                                              break u;
                                                            _n[e[e[h >> 2] + 8 >> 2]](h), cs(h);
                                                            break u;
                                                          }
                                                          o = Vr() | 0;
                                                          break t;
                                                        }
                                                        o = Vr() | 0, No(y + 240 | 0);
                                                        break t;
                                                      }
                                                      if ($[y + 243 | 0] = 0, Vs[y + 240 >> 1] = ye[5279] | ye[5280] << 8, $[y + 242 | 0] = ye[5281], $[y + 251 | 0] = 3, h >>> 0 < 3)
                                                        break I;
                                                      k: {
                                                        N: {
                                                          S: {
                                                            T: {
                                                              v: {
                                                                w: {
                                                                  b: {
                                                                    h: {
                                                                      x: {
                                                                        m: {
                                                                          B: {
                                                                            R: {
                                                                              E: {
                                                                                if (c = e[o >> 2], !(ye[y + 240 | 0] != ye[c | 0] | ye[y + 241 | 0] != ye[c + 1 | 0] | ye[y + 242 | 0] != ye[c + 2 | 0])) {
                                                                                  if (S = h - 3 | 0, e[o + 4 >> 2] = S, e[o >> 2] = c + 3, (S | 0) <= 0)
                                                                                    break k;
                                                                                  for (g = e[o >> 2], c = e[o >> 2], h = 0; ; ) {
                                                                                    if (ye[c + h | 0] != 41) {
                                                                                      if (h = h + 1 | 0, (S | 0) != (h | 0))
                                                                                        continue;
                                                                                      break k;
                                                                                    }
                                                                                    break;
                                                                                  }
                                                                                  if (h - 18 >>> 0 < 4294967279)
                                                                                    break k;
                                                                                  C: {
                                                                                    if (h >>> 0 <= 10) {
                                                                                      $[y + 251 | 0] = h, c = y + 240 | 0;
                                                                                      break C;
                                                                                    }
                                                                                    if (e[5996] = 0, S = (h | 15) + 1 | 0, c = ii(3, S | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                                      break E;
                                                                                    e[y + 240 >> 2] = c, e[y + 244 >> 2] = h, e[y + 248 >> 2] = S | -2147483648;
                                                                                  }
                                                                                  if ($[_s(c, g, h) + h | 0] = 0, e[y + 272 >> 2] = e[y + 244 >> 2], c = ye[y + 247 | 0] | ye[y + 248 | 0] << 8 | (ye[y + 249 | 0] << 16 | ye[y + 250 | 0] << 24), $[y + 275 | 0] = c, $[y + 276 | 0] = c >>> 8, $[y + 277 | 0] = c >>> 16, $[y + 278 | 0] = c >>> 24, e[5996] = 0, g = e[y + 240 >> 2], S = $[y + 251 | 0], e[y + 340 >> 2] = 0, e[y + 332 >> 2] = 0, e[y + 336 >> 2] = 0, c = ii(3, 12) | 0, G = e[5996], e[5996] = 0, (G | 0) != 1) {
                                                                                    e[y + 332 >> 2] = c, G = c + 12 | 0, e[y + 340 >> 2] = G, e[c >> 2] = g, e[c + 4 >> 2] = e[y + 272 >> 2], g = ye[y + 275 | 0] | ye[y + 276 | 0] << 8 | (ye[y + 277 | 0] << 16 | ye[y + 278 | 0] << 24), $[c + 7 | 0] = g, $[c + 8 | 0] = g >>> 8, $[c + 9 | 0] = g >>> 16, $[c + 10 | 0] = g >>> 24, $[c + 11 | 0] = S, $[y + 275 | 0] = 0, $[y + 276 | 0] = 0, $[y + 277 | 0] = 0, $[y + 278 | 0] = 0, e[y + 272 >> 2] = 0, e[y + 336 >> 2] = G, e[5996] = 0, c = ii(3, 104) | 0, g = e[5996], e[5996] = 0;
                                                                                    C: {
                                                                                      y: {
                                                                                        if ((g | 0) != 1) {
                                                                                          if (e[5996] = 0, g = Si(147, c | 0, 2, y + 332 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) {
                                                                                            o = Vr() | 0, Sr(c);
                                                                                            break N;
                                                                                          }
                                                                                          if (e[y + 248 >> 2] = 0, e[y + 240 >> 2] = 0, e[y + 244 >> 2] = 0, e[5996] = 0, e[y + 268 >> 2] = g, S = g + 12 | 0, e[y + 264 >> 2] = S, c = ii(3, 8) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                                            break R;
                                                                                          if (e[y + 240 >> 2] = c, G = c + 8 | 0, e[y + 248 >> 2] = G, e[c + 4 >> 2] = g, e[c >> 2] = S, e[y + 244 >> 2] = G, e[y + 264 >> 2] = 0, e[y + 268 >> 2] = 0, e[5996] = 0, g = ii(3, 104) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                            break y;
                                                                                          if (e[5996] = 0, c = Si(146, g | 0, 12, y + 240 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) {
                                                                                            o = Vr() | 0, Sr(g);
                                                                                            break S;
                                                                                          }
                                                                                          e[y + 348 >> 2] = c, S = c + 12 | 0, e[y + 344 >> 2] = S, g = e[y + 312 >> 2];
                                                                                          D: {
                                                                                            if (g >>> 0 < Ps[y + 316 >> 2]) {
                                                                                              e[g + 4 >> 2] = c, e[g >> 2] = S, e[y + 312 >> 2] = g + 8, e[y + 344 >> 2] = 0, e[y + 348 >> 2] = 0;
                                                                                              break D;
                                                                                            }
                                                                                            if (e[5996] = 0, di(144, y + 308 | 0, y + 344 | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                              break C;
                                                                                            if (c = e[y + 348 >> 2], !c || (g = e[c + 4 >> 2], e[c + 4 >> 2] = g - 1, g))
                                                                                              break D;
                                                                                            _n[e[e[c >> 2] + 8 >> 2]](c), cs(c);
                                                                                          }
                                                                                          if (S = e[y + 240 >> 2], S) {
                                                                                            if (c = e[y + 244 >> 2], g = S, (c | 0) != (g | 0)) {
                                                                                              for (; ; ) {
                                                                                                c = c - 8 | 0, g = e[c + 4 >> 2];
                                                                                                D: {
                                                                                                  if (!g || (G = e[g + 4 >> 2], e[g + 4 >> 2] = G - 1, G))
                                                                                                    break D;
                                                                                                  _n[e[e[g >> 2] + 8 >> 2]](g), cs(g);
                                                                                                }
                                                                                                if ((c | 0) == (S | 0))
                                                                                                  break;
                                                                                              }
                                                                                              g = e[y + 240 >> 2];
                                                                                            }
                                                                                            e[y + 244 >> 2] = S, Sr(g);
                                                                                          }
                                                                                          c = e[y + 268 >> 2];
                                                                                          D: {
                                                                                            if (!c || (g = e[c + 4 >> 2], e[c + 4 >> 2] = g - 1, g))
                                                                                              break D;
                                                                                            _n[e[e[c >> 2] + 8 >> 2]](c), cs(c);
                                                                                          }
                                                                                          if (S = e[y + 332 >> 2], S) {
                                                                                            if (g = e[y + 336 >> 2], (S | 0) != (g | 0))
                                                                                              for (; c = g - 12 | 0, $[g - 1 | 0] < 0 && Sr(e[c >> 2]), g = c, (c | 0) != (S | 0); )
                                                                                                ;
                                                                                            e[y + 336 >> 2] = S, Sr(S);
                                                                                          }
                                                                                          h = h + 1 | 0, e[o + 4 >> 2] = e[o + 4 >> 2] - h, e[o >> 2] = h + e[o >> 2];
                                                                                          break u;
                                                                                        }
                                                                                        o = Vr() | 0;
                                                                                        break N;
                                                                                      }
                                                                                      o = Vr() | 0;
                                                                                      break S;
                                                                                    }
                                                                                    o = Vr() | 0, No(y + 344 | 0);
                                                                                    break S;
                                                                                  }
                                                                                  if (o = Vr() | 0, Wo(y + 332 | 0), (S | 0) >= 0)
                                                                                    break t;
                                                                                  Sr(g);
                                                                                  break t;
                                                                                }
                                                                                if ($[y + 244 | 0] = 0, e[y + 240 >> 2] = 677931888, $[y + 251 | 0] = 4, h >>> 0 < 4)
                                                                                  break p;
                                                                                if (c = e[o >> 2], !(ye[y + 240 | 0] != ye[c | 0] | ye[y + 241 | 0] != ye[c + 1 | 0] | (ye[y + 242 | 0] != ye[c + 2 | 0] | ye[y + 243 | 0] != ye[c + 3 | 0]))) {
                                                                                  if (S = h - 4 | 0, e[o + 4 >> 2] = S, e[o >> 2] = c + 4, (S | 0) <= 0)
                                                                                    break T;
                                                                                  for (g = e[o >> 2], c = e[o >> 2], h = 0; ; ) {
                                                                                    if (ye[c + h | 0] != 41) {
                                                                                      if (h = h + 1 | 0, (S | 0) != (h | 0))
                                                                                        continue;
                                                                                      break T;
                                                                                    }
                                                                                    break;
                                                                                  }
                                                                                  if (h - 18 >>> 0 < 4294967279)
                                                                                    break T;
                                                                                  C: {
                                                                                    if (h >>> 0 <= 10) {
                                                                                      $[y + 251 | 0] = h, c = y + 240 | 0;
                                                                                      break C;
                                                                                    }
                                                                                    if (e[5996] = 0, S = (h | 15) + 1 | 0, c = ii(3, S | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                                      break B;
                                                                                    e[y + 240 >> 2] = c, e[y + 244 >> 2] = h, e[y + 248 >> 2] = S | -2147483648;
                                                                                  }
                                                                                  if ($[_s(c, g, h) + h | 0] = 0, e[y + 272 >> 2] = e[y + 244 >> 2], c = ye[y + 247 | 0] | ye[y + 248 | 0] << 8 | (ye[y + 249 | 0] << 16 | ye[y + 250 | 0] << 24), $[y + 275 | 0] = c, $[y + 276 | 0] = c >>> 8, $[y + 277 | 0] = c >>> 16, $[y + 278 | 0] = c >>> 24, e[5996] = 0, g = e[y + 240 >> 2], S = $[y + 251 | 0], e[y + 340 >> 2] = 0, e[y + 332 >> 2] = 0, e[y + 336 >> 2] = 0, c = ii(3, 12) | 0, G = e[5996], e[5996] = 0, (G | 0) != 1) {
                                                                                    e[y + 332 >> 2] = c, G = c + 12 | 0, e[y + 340 >> 2] = G, e[c >> 2] = g, e[c + 4 >> 2] = e[y + 272 >> 2], g = ye[y + 275 | 0] | ye[y + 276 | 0] << 8 | (ye[y + 277 | 0] << 16 | ye[y + 278 | 0] << 24), $[c + 7 | 0] = g, $[c + 8 | 0] = g >>> 8, $[c + 9 | 0] = g >>> 16, $[c + 10 | 0] = g >>> 24, $[c + 11 | 0] = S, $[y + 275 | 0] = 0, $[y + 276 | 0] = 0, $[y + 277 | 0] = 0, $[y + 278 | 0] = 0, e[y + 272 >> 2] = 0, e[y + 336 >> 2] = G, e[5996] = 0, c = ii(3, 104) | 0, g = e[5996], e[5996] = 0;
                                                                                    C: {
                                                                                      y: {
                                                                                        if ((g | 0) != 1) {
                                                                                          if (e[5996] = 0, g = Si(147, c | 0, 3, y + 332 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) {
                                                                                            o = Vr() | 0, Sr(c);
                                                                                            break v;
                                                                                          }
                                                                                          if (e[y + 248 >> 2] = 0, e[y + 240 >> 2] = 0, e[y + 244 >> 2] = 0, e[5996] = 0, e[y + 268 >> 2] = g, S = g + 12 | 0, e[y + 264 >> 2] = S, c = ii(3, 8) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                                            break m;
                                                                                          if (e[y + 240 >> 2] = c, G = c + 8 | 0, e[y + 248 >> 2] = G, e[c + 4 >> 2] = g, e[c >> 2] = S, e[y + 244 >> 2] = G, e[y + 264 >> 2] = 0, e[y + 268 >> 2] = 0, e[5996] = 0, g = ii(3, 104) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                            break y;
                                                                                          if (e[5996] = 0, c = Si(146, g | 0, 12, y + 240 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) {
                                                                                            o = Vr() | 0, Sr(g);
                                                                                            break w;
                                                                                          }
                                                                                          e[y + 348 >> 2] = c, S = c + 12 | 0, e[y + 344 >> 2] = S, g = e[y + 312 >> 2];
                                                                                          D: {
                                                                                            if (g >>> 0 < Ps[y + 316 >> 2]) {
                                                                                              e[g + 4 >> 2] = c, e[g >> 2] = S, e[y + 312 >> 2] = g + 8, e[y + 344 >> 2] = 0, e[y + 348 >> 2] = 0;
                                                                                              break D;
                                                                                            }
                                                                                            if (e[5996] = 0, di(144, y + 308 | 0, y + 344 | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                              break C;
                                                                                            if (c = e[y + 348 >> 2], !c || (g = e[c + 4 >> 2], e[c + 4 >> 2] = g - 1, g))
                                                                                              break D;
                                                                                            _n[e[e[c >> 2] + 8 >> 2]](c), cs(c);
                                                                                          }
                                                                                          if (S = e[y + 240 >> 2], S) {
                                                                                            if (c = e[y + 244 >> 2], g = S, (c | 0) != (g | 0)) {
                                                                                              for (; ; ) {
                                                                                                c = c - 8 | 0, g = e[c + 4 >> 2];
                                                                                                D: {
                                                                                                  if (!g || (G = e[g + 4 >> 2], e[g + 4 >> 2] = G - 1, G))
                                                                                                    break D;
                                                                                                  _n[e[e[g >> 2] + 8 >> 2]](g), cs(g);
                                                                                                }
                                                                                                if ((c | 0) == (S | 0))
                                                                                                  break;
                                                                                              }
                                                                                              g = e[y + 240 >> 2];
                                                                                            }
                                                                                            e[y + 244 >> 2] = S, Sr(g);
                                                                                          }
                                                                                          c = e[y + 268 >> 2];
                                                                                          D: {
                                                                                            if (!c || (g = e[c + 4 >> 2], e[c + 4 >> 2] = g - 1, g))
                                                                                              break D;
                                                                                            _n[e[e[c >> 2] + 8 >> 2]](c), cs(c);
                                                                                          }
                                                                                          if (S = e[y + 332 >> 2], S) {
                                                                                            if (g = e[y + 336 >> 2], (S | 0) != (g | 0))
                                                                                              for (; c = g - 12 | 0, $[g - 1 | 0] < 0 && Sr(e[c >> 2]), g = c, (c | 0) != (S | 0); )
                                                                                                ;
                                                                                            e[y + 336 >> 2] = S, Sr(S);
                                                                                          }
                                                                                          h = h + 1 | 0, e[o + 4 >> 2] = e[o + 4 >> 2] - h, e[o >> 2] = h + e[o >> 2];
                                                                                          break u;
                                                                                        }
                                                                                        o = Vr() | 0;
                                                                                        break v;
                                                                                      }
                                                                                      o = Vr() | 0;
                                                                                      break w;
                                                                                    }
                                                                                    o = Vr() | 0, No(y + 344 | 0);
                                                                                    break w;
                                                                                  }
                                                                                  if (o = Vr() | 0, Wo(y + 332 | 0), (S | 0) >= 0)
                                                                                    break t;
                                                                                  Sr(g);
                                                                                  break t;
                                                                                }
                                                                                if ($[y + 245 | 0] = 0, $[y + 244 | 0] = ye[5287], e[y + 240 >> 2] = ye[5283] | ye[5284] << 8 | (ye[5285] << 16 | ye[5286] << 24), $[y + 251 | 0] = 5, h >>> 0 < 5)
                                                                                  break A;
                                                                                C: {
                                                                                  if (c = e[o >> 2], ye[y + 240 | 0] != ye[c | 0] | ye[y + 241 | 0] != ye[c + 1 | 0] | (ye[y + 242 | 0] != ye[c + 2 | 0] | ye[y + 243 | 0] != ye[c + 3 | 0]) || ye[y + 244 | 0] != ye[c + 4 | 0])
                                                                                    break C;
                                                                                  if (S = h - 5 | 0, e[o + 4 >> 2] = S, e[o >> 2] = c + 5, (S | 0) <= 0)
                                                                                    break b;
                                                                                  for (g = e[o >> 2], c = e[o >> 2], h = 0; ; ) {
                                                                                    if (ye[c + h | 0] != 41) {
                                                                                      if (h = h + 1 | 0, (S | 0) != (h | 0))
                                                                                        continue;
                                                                                      break b;
                                                                                    }
                                                                                    break;
                                                                                  }
                                                                                  if (h - 18 >>> 0 < 4294967279)
                                                                                    break b;
                                                                                  y: {
                                                                                    if (h >>> 0 <= 10) {
                                                                                      $[y + 251 | 0] = h, c = y + 240 | 0;
                                                                                      break y;
                                                                                    }
                                                                                    if (e[5996] = 0, S = (h | 15) + 1 | 0, c = ii(3, S | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                                      break x;
                                                                                    e[y + 240 >> 2] = c, e[y + 244 >> 2] = h, e[y + 248 >> 2] = S | -2147483648;
                                                                                  }
                                                                                  if ($[_s(c, g, h) + h | 0] = 0, e[y + 344 >> 2] = e[y + 244 >> 2], c = ye[y + 247 | 0] | ye[y + 248 | 0] << 8 | (ye[y + 249 | 0] << 16 | ye[y + 250 | 0] << 24), $[y + 347 | 0] = c, $[y + 348 | 0] = c >>> 8, $[y + 349 | 0] = c >>> 16, $[y + 350 | 0] = c >>> 24, e[5996] = 0, g = e[y + 240 >> 2], S = $[y + 251 | 0], e[y + 248 >> 2] = 0, e[y + 240 >> 2] = 0, e[y + 244 >> 2] = 0, c = ii(3, 12) | 0, G = e[5996], e[5996] = 0, (G | 0) != 1) {
                                                                                    e[y + 240 >> 2] = c, G = c + 12 | 0, e[y + 248 >> 2] = G, e[c >> 2] = g, e[c + 4 >> 2] = e[y + 344 >> 2], g = ye[y + 347 | 0] | ye[y + 348 | 0] << 8 | (ye[y + 349 | 0] << 16 | ye[y + 350 | 0] << 24), $[c + 7 | 0] = g, $[c + 8 | 0] = g >>> 8, $[c + 9 | 0] = g >>> 16, $[c + 10 | 0] = g >>> 24, $[c + 11 | 0] = S, $[y + 347 | 0] = 0, $[y + 348 | 0] = 0, $[y + 349 | 0] = 0, $[y + 350 | 0] = 0, e[y + 344 >> 2] = 0, e[y + 244 >> 2] = G, e[5996] = 0, g = ii(3, 104) | 0, c = e[5996], e[5996] = 0;
                                                                                    y: {
                                                                                      D: {
                                                                                        if ((c | 0) != 1) {
                                                                                          if (e[5996] = 0, c = Si(147, g | 0, 2, y + 240 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) {
                                                                                            o = Vr() | 0, Sr(g);
                                                                                            break y;
                                                                                          }
                                                                                          e[y + 336 >> 2] = c, S = c + 12 | 0, e[y + 332 >> 2] = S, g = e[y + 312 >> 2];
                                                                                          P: {
                                                                                            if (g >>> 0 < Ps[y + 316 >> 2]) {
                                                                                              e[g + 4 >> 2] = c, e[g >> 2] = S, e[y + 312 >> 2] = g + 8, e[y + 332 >> 2] = 0, e[y + 336 >> 2] = 0;
                                                                                              break P;
                                                                                            }
                                                                                            if (e[5996] = 0, di(144, y + 308 | 0, y + 332 | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                              break D;
                                                                                            if (c = e[y + 336 >> 2], !c || (g = e[c + 4 >> 2], e[c + 4 >> 2] = g - 1, g))
                                                                                              break P;
                                                                                            _n[e[e[c >> 2] + 8 >> 2]](c), cs(c);
                                                                                          }
                                                                                          if (S = e[y + 240 >> 2], S) {
                                                                                            if (g = e[y + 244 >> 2], (S | 0) != (g | 0))
                                                                                              for (; c = g - 12 | 0, $[g - 1 | 0] < 0 && Sr(e[c >> 2]), g = c, (c | 0) != (S | 0); )
                                                                                                ;
                                                                                            e[y + 244 >> 2] = S, Sr(S);
                                                                                          }
                                                                                          h = h + 1 | 0, e[o + 4 >> 2] = e[o + 4 >> 2] - h, e[o >> 2] = h + e[o >> 2];
                                                                                          break u;
                                                                                        }
                                                                                        o = Vr() | 0;
                                                                                        break y;
                                                                                      }
                                                                                      o = Vr() | 0, No(y + 332 | 0);
                                                                                    }
                                                                                    Wo(y + 240 | 0);
                                                                                    break t;
                                                                                  }
                                                                                  if (o = Vr() | 0, Wo(y + 240 | 0), (S | 0) >= 0)
                                                                                    break t;
                                                                                  Sr(g);
                                                                                  break t;
                                                                                }
                                                                                if ($[y + 245 | 0] = 0, $[y + 244 | 0] = ye[5319], $[y + 251 | 0] = 5, g = ye[5315] | ye[5316] << 8 | (ye[5317] << 16 | ye[5318] << 24), e[y + 240 >> 2] = g, c = e[o >> 2], ye[c | 0] != (g & 255) | ye[y + 241 | 0] != ye[c + 1 | 0] | (ye[y + 242 | 0] != ye[c + 2 | 0] | ye[y + 243 | 0] != ye[c + 3 | 0]) || ye[y + 244 | 0] != ye[c + 4 | 0])
                                                                                  break g;
                                                                                if (e[o + 4 >> 2] = h - 5, e[o >> 2] = c + 5, h = e[o >> 2], c = e[o + 4 >> 2], e[5996] = 0, g = y + 240 | 0, x1(148, g | 0, h | 0, c | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                  break h;
                                                                                C: {
                                                                                  y: {
                                                                                    D: {
                                                                                      P: {
                                                                                        q: {
                                                                                          if (ye[y + 256 | 0]) {
                                                                                            if (e[5996] = 0, h = y + 332 | 0, di(149, h | 0, g | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                              break q;
                                                                                            if (e[5996] = 0, c = y + 344 | 0, as(150, c | 0, 3, h | 0), g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                              break P;
                                                                                            if (e[5996] = 0, di(151, y + 308 | 0, c | 0), g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                              break D;
                                                                                            if (No(c), Wo(h), h = e[y + 252 >> 2] + 1 | 0, e[o + 4 >> 2] = e[o + 4 >> 2] - h, e[o >> 2] = h + e[o >> 2], !ye[y + 256 | 0] | $[y + 251 | 0] >= 0)
                                                                                              break u;
                                                                                            Sr(e[y + 240 >> 2]);
                                                                                            break u;
                                                                                          }
                                                                                          e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                                                          break c;
                                                                                        }
                                                                                        o = Vr() | 0;
                                                                                        break C;
                                                                                      }
                                                                                      o = Vr() | 0;
                                                                                      break y;
                                                                                    }
                                                                                    o = Vr() | 0, No(y + 344 | 0);
                                                                                  }
                                                                                  Wo(y + 332 | 0);
                                                                                }
                                                                                if (!ye[y + 256 | 0] | $[y + 251 | 0] >= 0)
                                                                                  break t;
                                                                                Sr(e[y + 240 >> 2]);
                                                                                break t;
                                                                              }
                                                                              o = Vr() | 0;
                                                                              break t;
                                                                            }
                                                                            o = Vr() | 0;
                                                                            break S;
                                                                          }
                                                                          o = Vr() | 0;
                                                                          break t;
                                                                        }
                                                                        o = Vr() | 0;
                                                                        break w;
                                                                      }
                                                                      o = Vr() | 0;
                                                                      break t;
                                                                    }
                                                                    o = Vr() | 0;
                                                                    break t;
                                                                  }
                                                                  e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                                  break c;
                                                                }
                                                                xo(y + 240 | 0), No(y + 264 | 0);
                                                              }
                                                              Wo(y + 332 | 0);
                                                              break t;
                                                            }
                                                            e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                            break c;
                                                          }
                                                          xo(y + 240 | 0), No(y + 264 | 0);
                                                        }
                                                        Wo(y + 332 | 0);
                                                        break t;
                                                      }
                                                      e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                      break c;
                                                    }
                                                    $[y + 244 | 0] = 0, e[y + 240 >> 2] = 677931888, $[y + 251 | 0] = 4;
                                                  }
                                                  $[y + 245 | 0] = 0, $[y + 244 | 0] = ye[5287], $[y + 251 | 0] = 5, e[y + 240 >> 2] = ye[5283] | ye[5284] << 8 | (ye[5285] << 16 | ye[5286] << 24);
                                                }
                                                $[y + 245 | 0] = 0, $[y + 244 | 0] = ye[5319], $[y + 251 | 0] = 5, e[y + 240 >> 2] = ye[5315] | ye[5316] << 8 | (ye[5317] << 16 | ye[5318] << 24);
                                              }
                                              e[5996] = 0, h = On(30, y + 228 | 0, 5355) | 0, c = e[5996], e[5996] = 0;
                                              g: {
                                                A: {
                                                  p: {
                                                    if ((c | 0) != 1) {
                                                      if (c = ga(h, o), $[y + 239 | 0] < 0 && Sr(e[h >> 2]), !c)
                                                        break g;
                                                      if (h = e[o >> 2], c = e[o + 4 >> 2], e[5996] = 0, m1(y + 240 | 0, h, c, 32), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                        break p;
                                                      if (ye[y + 256 | 0])
                                                        break A;
                                                      e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                      break c;
                                                    }
                                                    o = Vr() | 0;
                                                    break t;
                                                  }
                                                  o = Vr() | 0;
                                                  break t;
                                                }
                                                e[5996] = 0, h = y + 332 | 0, as(153, h | 0, 6, y + 240 | 0), c = e[5996], e[5996] = 0;
                                                A: {
                                                  p: {
                                                    if ((c | 0) != 1) {
                                                      if (e[5996] = 0, di(151, y + 308 | 0, h | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                        break p;
                                                      if (No(h), h = e[y + 252 >> 2] + 1 | 0, e[o + 4 >> 2] = e[o + 4 >> 2] - h, e[o >> 2] = h + e[o >> 2], !ye[y + 256 | 0] || (h = e[y + 240 >> 2], !h))
                                                        break u;
                                                      Sr(h);
                                                      break u;
                                                    }
                                                    o = Vr() | 0;
                                                    break A;
                                                  }
                                                  o = Vr() | 0, No(y + 332 | 0);
                                                }
                                                if (!ye[y + 256 | 0] || (r = e[y + 240 >> 2], !r))
                                                  break t;
                                                Sr(r);
                                                break t;
                                              }
                                              e[5996] = 0, h = On(30, y + 216 | 0, 5372) | 0, c = e[5996], e[5996] = 0;
                                              g: {
                                                A: {
                                                  p: {
                                                    if ((c | 0) != 1) {
                                                      if (c = ga(h, o), $[y + 227 | 0] < 0 && Sr(e[h >> 2]), !c)
                                                        break g;
                                                      if (h = e[o >> 2], c = e[o + 4 >> 2], e[5996] = 0, m1(y + 240 | 0, h, c, 20), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                        break p;
                                                      if (ye[y + 256 | 0])
                                                        break A;
                                                      e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                      break c;
                                                    }
                                                    o = Vr() | 0;
                                                    break t;
                                                  }
                                                  o = Vr() | 0;
                                                  break t;
                                                }
                                                e[5996] = 0, h = y + 332 | 0, as(153, h | 0, 8, y + 240 | 0), c = e[5996], e[5996] = 0;
                                                A: {
                                                  p: {
                                                    if ((c | 0) != 1) {
                                                      if (e[5996] = 0, di(151, y + 308 | 0, h | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                        break p;
                                                      if (No(h), h = e[y + 252 >> 2] + 1 | 0, e[o + 4 >> 2] = e[o + 4 >> 2] - h, e[o >> 2] = h + e[o >> 2], !ye[y + 256 | 0] || (h = e[y + 240 >> 2], !h))
                                                        break u;
                                                      Sr(h);
                                                      break u;
                                                    }
                                                    o = Vr() | 0;
                                                    break A;
                                                  }
                                                  o = Vr() | 0, No(y + 332 | 0);
                                                }
                                                if (!ye[y + 256 | 0] || (r = e[y + 240 >> 2], !r))
                                                  break t;
                                                Sr(r);
                                                break t;
                                              }
                                              e[5996] = 0, h = On(30, y + 204 | 0, 5346) | 0, c = e[5996], e[5996] = 0;
                                              g: {
                                                A: {
                                                  p: {
                                                    if ((c | 0) != 1) {
                                                      if (c = ga(h, o), $[y + 215 | 0] < 0 && Sr(e[h >> 2]), !c)
                                                        break g;
                                                      if (h = e[o >> 2], c = e[o + 4 >> 2], e[5996] = 0, m1(y + 240 | 0, h, c, 32), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                        break p;
                                                      if (ye[y + 256 | 0])
                                                        break A;
                                                      e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                      break c;
                                                    }
                                                    o = Vr() | 0;
                                                    break t;
                                                  }
                                                  o = Vr() | 0;
                                                  break t;
                                                }
                                                e[5996] = 0, h = y + 332 | 0, as(153, h | 0, 7, y + 240 | 0), c = e[5996], e[5996] = 0;
                                                A: {
                                                  p: {
                                                    if ((c | 0) != 1) {
                                                      if (e[5996] = 0, di(151, y + 308 | 0, h | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                        break p;
                                                      if (No(h), h = e[y + 252 >> 2] + 1 | 0, e[o + 4 >> 2] = e[o + 4 >> 2] - h, e[o >> 2] = h + e[o >> 2], !ye[y + 256 | 0] || (h = e[y + 240 >> 2], !h))
                                                        break u;
                                                      Sr(h);
                                                      break u;
                                                    }
                                                    o = Vr() | 0;
                                                    break A;
                                                  }
                                                  o = Vr() | 0, No(y + 332 | 0);
                                                }
                                                if (!ye[y + 256 | 0] || (r = e[y + 240 >> 2], !r))
                                                  break t;
                                                Sr(r);
                                                break t;
                                              }
                                              e[5996] = 0, h = On(30, y + 192 | 0, 5363) | 0, c = e[5996], e[5996] = 0;
                                              g: {
                                                A: {
                                                  p: {
                                                    if ((c | 0) != 1) {
                                                      if (c = ga(h, o), $[y + 203 | 0] < 0 && Sr(e[h >> 2]), !c)
                                                        break g;
                                                      if (h = e[o >> 2], c = e[o + 4 >> 2], e[5996] = 0, m1(y + 240 | 0, h, c, 20), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                        break p;
                                                      if (ye[y + 256 | 0])
                                                        break A;
                                                      e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                      break c;
                                                    }
                                                    o = Vr() | 0;
                                                    break t;
                                                  }
                                                  o = Vr() | 0;
                                                  break t;
                                                }
                                                e[5996] = 0, h = y + 332 | 0, as(153, h | 0, 9, y + 240 | 0), c = e[5996], e[5996] = 0;
                                                A: {
                                                  p: {
                                                    if ((c | 0) != 1) {
                                                      if (e[5996] = 0, di(151, y + 308 | 0, h | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                        break p;
                                                      if (No(h), h = e[y + 252 >> 2] + 1 | 0, e[o + 4 >> 2] = e[o + 4 >> 2] - h, e[o >> 2] = h + e[o >> 2], !ye[y + 256 | 0] || (h = e[y + 240 >> 2], !h))
                                                        break u;
                                                      Sr(h);
                                                      break u;
                                                    }
                                                    o = Vr() | 0;
                                                    break A;
                                                  }
                                                  o = Vr() | 0, No(y + 332 | 0);
                                                }
                                                if (!ye[y + 256 | 0] || (r = e[y + 240 >> 2], !r))
                                                  break t;
                                                Sr(r);
                                                break t;
                                              }
                                              e[5996] = 0, h = On(30, y + 180 | 0, 5258) | 0, c = e[5996], e[5996] = 0;
                                              g: {
                                                A: {
                                                  p: {
                                                    I: {
                                                      k: {
                                                        if ((c | 0) != 1) {
                                                          if (c = ga(h, o), $[y + 191 | 0] < 0 && Sr(e[h >> 2]), !c)
                                                            break I;
                                                          g = e[o + 4 >> 2];
                                                          N: {
                                                            if ((g | 0) <= 0)
                                                              break N;
                                                            for (c = e[o >> 2], h = 0; ; ) {
                                                              if (S = c + h | 0, ye[S | 0] != 41) {
                                                                if (h = h + 1 | 0, (g | 0) != (h | 0))
                                                                  continue;
                                                                break N;
                                                              }
                                                              break;
                                                            }
                                                            if (h)
                                                              break k;
                                                          }
                                                          e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                          break c;
                                                        }
                                                        o = Vr() | 0;
                                                        break t;
                                                      }
                                                      if (e[5996] = 0, c = Si(154, y + 168 | 0, c | 0, S | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                        break A;
                                                      if (g = yf(c, y + 240 | 0), $[y + 179 | 0] < 0 && Sr(e[c >> 2]), !g || (g = e[y + 244 >> 2], S = g, c = e[y + 240 >> 2], G = c - -2147483648 | 0, g = g - (c >>> 0 < 2147483648) | 0, (g | 0) == -1 & G >>> 0 < 2147483649 | (g | 0) != -1))
                                                        break p;
                                                      e[5996] = 0, g = y + 332 | 0, Z4(g, 5, c, S), c = e[5996], e[5996] = 0;
                                                      k: {
                                                        if ((c | 0) != 1) {
                                                          if (e[5996] = 0, di(151, y + 308 | 0, g | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                            break k;
                                                          No(g), h = h + 1 | 0, e[o + 4 >> 2] = e[o + 4 >> 2] - h, e[o >> 2] = h + e[o >> 2];
                                                          break u;
                                                        }
                                                        o = Vr() | 0;
                                                        break t;
                                                      }
                                                      o = Vr() | 0, No(y + 332 | 0);
                                                      break t;
                                                    }
                                                    e[5996] = 0, h = On(30, y + 156 | 0, 5265) | 0, c = e[5996], e[5996] = 0;
                                                    I: {
                                                      k: {
                                                        N: {
                                                          S: {
                                                            if ((c | 0) != 1) {
                                                              if (c = ga(h, o), $[y + 167 | 0] < 0 && Sr(e[h >> 2]), !c)
                                                                break N;
                                                              g = e[o + 4 >> 2];
                                                              T: {
                                                                if ((g | 0) <= 0)
                                                                  break T;
                                                                for (c = e[o >> 2], h = 0; ; ) {
                                                                  if (S = c + h | 0, ye[S | 0] != 41) {
                                                                    if (h = h + 1 | 0, (g | 0) != (h | 0))
                                                                      continue;
                                                                    break T;
                                                                  }
                                                                  break;
                                                                }
                                                                if (h)
                                                                  break S;
                                                              }
                                                              e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                              break c;
                                                            }
                                                            o = Vr() | 0;
                                                            break t;
                                                          }
                                                          if (e[5996] = 0, c = Si(154, y + 144 | 0, c | 0, S | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                            break I;
                                                          if (g = yf(c, y + 240 | 0), $[y + 155 | 0] < 0 && Sr(e[c >> 2]), !g || (g = e[y + 244 >> 2], S = g, c = e[y + 240 >> 2], G = c - -2147483648 | 0, g = g - (c >>> 0 < 2147483648) | 0, (g | 0) == -1 & G >>> 0 < 2147483649 | (g | 0) != -1))
                                                            break k;
                                                          e[5996] = 0, g = y + 332 | 0, Z4(g, 4, c, S), c = e[5996], e[5996] = 0;
                                                          S: {
                                                            if ((c | 0) != 1) {
                                                              if (e[5996] = 0, di(151, y + 308 | 0, g | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                break S;
                                                              No(g), h = h + 1 | 0, e[o + 4 >> 2] = e[o + 4 >> 2] - h, e[o >> 2] = h + e[o >> 2];
                                                              break u;
                                                            }
                                                            o = Vr() | 0;
                                                            break t;
                                                          }
                                                          o = Vr() | 0, No(y + 332 | 0);
                                                          break t;
                                                        }
                                                        e[5996] = 0, h = On(30, y + 132 | 0, 5289) | 0, c = e[5996], e[5996] = 0;
                                                        N: {
                                                          if ((c | 0) != 1) {
                                                            if (c = ga(h, o), $[y + 143 | 0] < 0 && Sr(e[h >> 2]), !c)
                                                              break g;
                                                            g = e[o + 4 >> 2];
                                                            S: {
                                                              if ((g | 0) <= 0)
                                                                break S;
                                                              for (c = e[o >> 2], h = 0; ; ) {
                                                                if (S = c + h | 0, G = ye[S | 0], (G | 0) != 44) {
                                                                  if ((G | 0) == 41)
                                                                    break S;
                                                                  if (h = h + 1 | 0, (g | 0) > (h | 0))
                                                                    continue;
                                                                  break S;
                                                                }
                                                                break;
                                                              }
                                                              if (h)
                                                                break N;
                                                            }
                                                            e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                            break c;
                                                          }
                                                          o = Vr() | 0;
                                                          break t;
                                                        }
                                                        e[5996] = 0, c = Si(154, y + 120 | 0, c | 0, S | 0) | 0, g = e[5996], e[5996] = 0;
                                                        N: {
                                                          if ((g | 0) != 1) {
                                                            if (g = yf(c, Tr), $[y + 131 | 0] < 0 && Sr(e[c >> 2]), g)
                                                              break N;
                                                            e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                            break c;
                                                          }
                                                          o = Vr() | 0;
                                                          break t;
                                                        }
                                                        h = h + 1 | 0, hr = e[o + 4 >> 2] - h | 0, e[o + 4 >> 2] = hr, g = h + e[o >> 2] | 0, e[o >> 2] = g, e[y + 340 >> 2] = 0, e[y + 332 >> 2] = 0, e[y + 336 >> 2] = 0;
                                                        N: {
                                                          S: {
                                                            T: {
                                                              v: {
                                                                w: {
                                                                  b: {
                                                                    for (; ; ) {
                                                                      if (h = 0, S = (hr | 0) <= 0, S)
                                                                        break v;
                                                                      h: {
                                                                        for (; ; ) {
                                                                          if (c = ye[h + g | 0], (c | 0) == 44) {
                                                                            c = h;
                                                                            break h;
                                                                          }
                                                                          if (!((c | 0) != 41 && (h = h + 1 | 0, (hr | 0) > (h | 0))))
                                                                            break;
                                                                        }
                                                                        if (c = 0, S)
                                                                          break v;
                                                                        for (; ; ) {
                                                                          if (ye[c + g | 0] == 41) {
                                                                            h = -1;
                                                                            break h;
                                                                          }
                                                                          if (c = c + 1 | 0, (hr | 0) == (c | 0))
                                                                            break;
                                                                        }
                                                                        break v;
                                                                      }
                                                                      if ((c | 0) <= 0)
                                                                        break v;
                                                                      if (e[5996] = 0, as(156, y + 240 | 0, g | 0, c + g | 0), g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                        break N;
                                                                      if (!ye[y + 252 | 0])
                                                                        break v;
                                                                      g = e[y + 336 >> 2];
                                                                      h: {
                                                                        if (g >>> 0 < Ps[y + 340 >> 2]) {
                                                                          S = e[y + 244 >> 2], e[g >> 2] = e[y + 240 >> 2], e[g + 4 >> 2] = S, e[g + 8 >> 2] = e[y + 248 >> 2], e[y + 248 >> 2] = 0, e[y + 240 >> 2] = 0, e[y + 244 >> 2] = 0, e[y + 336 >> 2] = g + 12, hr = 1, S = 0;
                                                                          break h;
                                                                        }
                                                                        if (e[5996] = 0, di(157, y + 332 | 0, y + 240 | 0), g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                          break b;
                                                                        hr = ye[y + 252 | 0], S = ye[y + 251 | 0];
                                                                      }
                                                                      if (c = c + 1 | 0, e[o + 4 >> 2] = e[o + 4 >> 2] - c, g = c + e[o >> 2] | 0, e[o >> 2] = g, !(hr & 255) | S << 24 >> 24 >= 0 || (Sr(e[y + 240 >> 2]), g = e[o >> 2]), (h | 0) != -1) {
                                                                        hr = e[o + 4 >> 2];
                                                                        continue;
                                                                      }
                                                                      break;
                                                                    }
                                                                    if (h = e[y + 336 >> 2], c = e[y + 332 >> 2], g = (h - c | 0) / 12 | 0, (c | 0) != (h | 0) & g >>> 0 < 21)
                                                                      break w;
                                                                    break v;
                                                                  }
                                                                  if (o = Vr() | 0, !ye[y + 252 | 0] | $[y + 251 | 0] >= 0)
                                                                    break r;
                                                                  Sr(e[y + 240 >> 2]);
                                                                  break r;
                                                                }
                                                                if (h = e[y + 296 >> 2], c = e[y + 300 >> 2], !((!!h & (c | 0) >= 0 | (c | 0) > 0) & (!c & h >>> 0 <= g >>> 0)))
                                                                  break v;
                                                                if (e[5996] = 0, g = y + 240 | 0, S = y + 332 | 0, Gd(158, g | 0, 25, S | 0, h | 0, c | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                  break T;
                                                                if (e[5996] = 0, di(151, y + 308 | 0, g | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                  break S;
                                                                No(g), Wo(S);
                                                                break u;
                                                              }
                                                              e[r >> 2] = 0, e[r + 4 >> 2] = 0, Wo(y + 332 | 0);
                                                              break c;
                                                            }
                                                            o = Vr() | 0;
                                                            break r;
                                                          }
                                                          o = Vr() | 0, No(y + 240 | 0);
                                                          break r;
                                                        }
                                                        o = Vr() | 0;
                                                        break r;
                                                      }
                                                      e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                      break c;
                                                    }
                                                    o = Vr() | 0;
                                                    break t;
                                                  }
                                                  e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                  break c;
                                                }
                                                o = Vr() | 0;
                                                break t;
                                              }
                                              e[5996] = 0, h = On(30, y + 108 | 0, 5302) | 0, c = e[5996], e[5996] = 0;
                                              g: {
                                                A: {
                                                  if ((c | 0) != 1) {
                                                    if (c = ga(h, o), $[y + 119 | 0] < 0 && Sr(e[h >> 2]), !c)
                                                      break g;
                                                    g = e[o + 4 >> 2];
                                                    p: {
                                                      if ((g | 0) <= 0)
                                                        break p;
                                                      for (c = e[o >> 2], h = 0; ; ) {
                                                        if (S = c + h | 0, G = ye[S | 0], (G | 0) != 44) {
                                                          if ((G | 0) == 41)
                                                            break p;
                                                          if (h = h + 1 | 0, (g | 0) > (h | 0))
                                                            continue;
                                                          break p;
                                                        }
                                                        break;
                                                      }
                                                      if (h)
                                                        break A;
                                                    }
                                                    e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                    break c;
                                                  }
                                                  o = Vr() | 0;
                                                  break t;
                                                }
                                                e[5996] = 0, c = Si(154, y + 96 | 0, c | 0, S | 0) | 0, g = e[5996], e[5996] = 0;
                                                A: {
                                                  if ((g | 0) != 1) {
                                                    if (g = yf(c, Tr), $[y + 107 | 0] < 0 && Sr(e[c >> 2]), g)
                                                      break A;
                                                    e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                    break c;
                                                  }
                                                  o = Vr() | 0;
                                                  break t;
                                                }
                                                if (c = e[y + 300 >> 2], !e[y + 296 >> 2] & (c | 0) <= 0 | (c | 0) < 0) {
                                                  e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                  break c;
                                                }
                                                if (h = h + 1 | 0, e[o + 4 >> 2] = e[o + 4 >> 2] - h, e[o >> 2] = h + e[o >> 2], e[5996] = 0, h = y + 320 | 0, Qs(159, h | 0, 19, 1, Tr | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                  break d;
                                                if (e[5996] = 0, Qs(160, h | 0, 0, -1, -1), h = e[5996], e[5996] = 0, (h | 0) != 1)
                                                  break u;
                                                o = Vr() | 0;
                                                break t;
                                              }
                                              e[5996] = 0, h = On(30, y + 84 | 0, 5251) | 0, c = e[5996], e[5996] = 0;
                                              g: {
                                                A: {
                                                  p: {
                                                    I: {
                                                      k: {
                                                        N: {
                                                          S: {
                                                            if ((c | 0) != 1) {
                                                              if (c = ga(h, o), $[y + 95 | 0] < 0 && Sr(e[h >> 2]), !c)
                                                                break g;
                                                              if (e[5996] = 0, h = y + 320 | 0, Qs(160, h | 0, 14, -1, -1), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                break S;
                                                              if (e[5996] = 0, Qs(160, h | 0, 21, -1, -1), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                break N;
                                                              if (e[5996] = 0, Qs(160, h | 0, 0, -1, -1), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                break k;
                                                              if (e[5996] = 0, Qs(160, h | 0, 20, -1, -1), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                break I;
                                                              if (e[5996] = 0, Qs(160, h | 0, 0, -1, -1), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                break p;
                                                              if (e[5996] = 0, Qs(160, h | 0, 20, -1, -1), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                break A;
                                                              if (e[5996] = 0, Qs(160, h | 0, 0, -1, -1), h = e[5996], e[5996] = 0, (h | 0) != 1)
                                                                break u;
                                                              o = Vr() | 0;
                                                              break t;
                                                            }
                                                            o = Vr() | 0;
                                                            break t;
                                                          }
                                                          o = Vr() | 0;
                                                          break t;
                                                        }
                                                        o = Vr() | 0;
                                                        break t;
                                                      }
                                                      o = Vr() | 0;
                                                      break t;
                                                    }
                                                    o = Vr() | 0;
                                                    break t;
                                                  }
                                                  o = Vr() | 0;
                                                  break t;
                                                }
                                                o = Vr() | 0;
                                                break t;
                                              }
                                              if (e[5996] = 0, h = On(30, y + 72 | 0, 5272) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                break f;
                                              c = ga(h, o), $[y + 83 | 0] < 0 && Sr(e[h >> 2]);
                                              g: {
                                                if (c) {
                                                  if (e[5996] = 0, Qs(160, y + 320 | 0, 11, -1, -1), h = e[5996], e[5996] = 0, (h | 0) != 1)
                                                    break g;
                                                  o = Vr() | 0;
                                                  break t;
                                                }
                                                if (e[5996] = 0, h = On(30, y + 60 | 0, 5339) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                  break l;
                                                if (c = ga(h, o), $[y + 71 | 0] < 0 && Sr(e[h >> 2]), c) {
                                                  if (e[5996] = 0, Qs(160, y + 320 | 0, 13, -1, -1), h = e[5996], e[5996] = 0, (h | 0) != 1)
                                                    break g;
                                                  o = Vr() | 0;
                                                  break t;
                                                }
                                                if (e[5996] = 0, h = On(30, y + 48 | 0, 5244) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                  break o;
                                                if (c = ga(h, o), $[y + 59 | 0] < 0 && Sr(e[h >> 2]), c) {
                                                  if (e[5996] = 0, Qs(160, y + 320 | 0, 12, -1, -1), h = e[5996], e[5996] = 0, (h | 0) != 1)
                                                    break g;
                                                  o = Vr() | 0;
                                                  break t;
                                                }
                                                if (e[5996] = 0, h = On(30, y + 36 | 0, 5333) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                  break a;
                                                if (c = ga(h, o), $[y + 47 | 0] < 0 && Sr(e[h >> 2]), c) {
                                                  if (e[5996] = 0, Qs(160, y + 320 | 0, 15, -1, -1), h = e[5996], e[5996] = 0, (h | 0) != 1)
                                                    break g;
                                                  o = Vr() | 0;
                                                  break t;
                                                }
                                                if (e[5996] = 0, h = On(30, y + 24 | 0, 5327) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                  break s;
                                                if (c = ga(h, o), $[y + 35 | 0] < 0 && Sr(e[h >> 2]), c) {
                                                  if (e[5996] = 0, Qs(160, y + 320 | 0, 16, -1, -1), h = e[5996], e[5996] = 0, (h | 0) != 1)
                                                    break g;
                                                  o = Vr() | 0;
                                                  break t;
                                                }
                                                if (e[5996] = 0, h = On(30, y + 12 | 0, 5321) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                  break i;
                                                if (c = ga(h, o), $[y + 23 | 0] < 0 && Sr(e[h >> 2]), c) {
                                                  if (e[5996] = 0, Qs(160, y + 320 | 0, 17, -1, -1), h = e[5996], e[5996] = 0, (h | 0) != 1)
                                                    break g;
                                                  o = Vr() | 0;
                                                  break t;
                                                }
                                                if (e[5996] = 0, h = On(30, y | 0, 5296) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                  break n;
                                                if (c = ga(h, o), $[y + 11 | 0] < 0 && Sr(e[h >> 2]), c) {
                                                  if (e[5996] = 0, Qs(160, y + 320 | 0, 18, -1, -1), h = e[5996], e[5996] = 0, (h | 0) != 1)
                                                    break g;
                                                  o = Vr() | 0;
                                                  break t;
                                                }
                                                e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                break c;
                                              }
                                              e[5996] = 0, h = y + 320 | 0, Qs(160, h | 0, 21, -1, -1), c = e[5996], e[5996] = 0;
                                              g: {
                                                A: {
                                                  if ((c | 0) != 1) {
                                                    if (e[5996] = 0, Qs(160, h | 0, 0, -1, -1), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                      break A;
                                                    if (e[5996] = 0, Qs(160, h | 0, 20, -1, -1), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                      break g;
                                                    if (e[5996] = 0, Qs(160, h | 0, 0, -1, -1), h = e[5996], e[5996] = 0, (h | 0) != 1)
                                                      break u;
                                                    o = Vr() | 0;
                                                    break t;
                                                  }
                                                  o = Vr() | 0;
                                                  break t;
                                                }
                                                o = Vr() | 0;
                                                break t;
                                              }
                                              o = Vr() | 0;
                                              break t;
                                            }
                                            if (c = e[y + 324 >> 2], g = e[y + 320 >> 2], (c | 0) == (g | 0))
                                              break;
                                          }
                                          if (h = e[y + 308 >> 2], (e[y + 312 >> 2] - h | 0) != 8) {
                                            if (e[5996] = 0, Qs(44, 4122, 2210, 1561, 2344), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                              break e;
                                            o = Vr() | 0;
                                            break t;
                                          }
                                          if (e[o + 4 >> 2]) {
                                            e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                            break c;
                                          }
                                          e[r >> 2] = e[h >> 2], e[r + 4 >> 2] = e[h + 4 >> 2], e[h >> 2] = 0, e[h + 4 >> 2] = 0;
                                        }
                                        if (r = e[y + 308 >> 2], r) {
                                          if (h = e[y + 312 >> 2], (r | 0) != (h | 0)) {
                                            for (; ; ) {
                                              h = h - 8 | 0, o = e[h + 4 >> 2];
                                              c: {
                                                if (!o || (c = e[o + 4 >> 2], e[o + 4 >> 2] = c - 1, c))
                                                  break c;
                                                _n[e[e[o >> 2] + 8 >> 2]](o), cs(o);
                                              }
                                              if ((r | 0) == (h | 0))
                                                break;
                                            }
                                            r = e[y + 308 >> 2];
                                          }
                                          Sr(r);
                                        }
                                        r = e[y + 320 >> 2], r && (e[y + 324 >> 2] = r, Sr(r)), Yr = y + 352 | 0;
                                        return;
                                      }
                                      o = Vr() | 0;
                                      break t;
                                    }
                                    o = Vr() | 0;
                                    break t;
                                  }
                                  o = Vr() | 0;
                                  break t;
                                }
                                o = Vr() | 0;
                                break t;
                              }
                              o = Vr() | 0;
                              break t;
                            }
                            o = Vr() | 0;
                            break t;
                          }
                          o = Vr() | 0;
                          break t;
                        }
                        o = Vr() | 0;
                        break t;
                      }
                      o = Vr() | 0;
                      break t;
                    }
                    Wo(y + 332 | 0);
                  }
                  xo(y + 308 | 0), r = e[y + 320 >> 2], r && (e[y + 324 >> 2] = r, Sr(r)), Ki(o | 0), ri();
                }
                ri();
              }
              function N1(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0;
                var g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0;
                g = Yr - 128 | 0, Yr = g, $[g + 127 | 0] = o, S = g + 116 | 0, _s(S, o ? 3764 : 5575, o), $[o | S] = 0;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  f: {
                                    d: {
                                      c: {
                                        u: {
                                          g: {
                                            A: {
                                              p: {
                                                I: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              b: {
                                                                h: {
                                                                  x: {
                                                                    m: {
                                                                      B: {
                                                                        R: {
                                                                          E:
                                                                            switch (e[c >> 2]) {
                                                                              case 10:
                                                                                if (e[5996] = 0, o = Si(99, h | 0, 0, 2553) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                  break T;
                                                                                h = e[o >> 2], e[g + 96 >> 2] = e[o + 4 >> 2], c = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 99 | 0] = c, $[g + 100 | 0] = c >>> 8, $[g + 101 | 0] = c >>> 16, $[g + 102 | 0] = c >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, c = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = h, e[r + 4 >> 2] = e[g + 96 >> 2], o = ye[g + 99 | 0] | ye[g + 100 | 0] << 8 | (ye[g + 101 | 0] << 16 | ye[g + 102 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = c;
                                                                                break t;
                                                                              case 11:
                                                                                if (e[5996] = 0, o = Si(99, h | 0, 0, 1681) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                                                                                  h = e[o >> 2], e[g + 96 >> 2] = e[o + 4 >> 2], c = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 99 | 0] = c, $[g + 100 | 0] = c >>> 8, $[g + 101 | 0] = c >>> 16, $[g + 102 | 0] = c >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, c = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = h, e[r + 4 >> 2] = e[g + 96 >> 2], o = ye[g + 99 | 0] | ye[g + 100 | 0] << 8 | (ye[g + 101 | 0] << 16 | ye[g + 102 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = c;
                                                                                  break t;
                                                                                }
                                                                                r = Vr() | 0;
                                                                                break e;
                                                                              case 12:
                                                                                C: {
                                                                                  y: {
                                                                                    D:
                                                                                      switch (o = e[e[c + 32 >> 2] >> 2], e[o >> 2] - 2 | 0) {
                                                                                        case 1:
                                                                                          break y;
                                                                                        case 0:
                                                                                          break D;
                                                                                        default:
                                                                                          break C;
                                                                                      }
                                                                                    if (o = e[o + 8 >> 2], $[o + 11 | 0] >= 0) {
                                                                                      e[g + 104 >> 2] = e[o + 8 >> 2], c = e[o + 4 >> 2], e[g + 96 >> 2] = e[o >> 2], e[g + 100 >> 2] = c;
                                                                                      break r;
                                                                                    }
                                                                                    if (c = e[o + 4 >> 2], o = e[o >> 2], e[5996] = 0, as(40, g + 96 | 0, o | 0, c | 0), o = e[5996], e[5996] = 0, (o | 0) != 1)
                                                                                      break r;
                                                                                    r = Vr() | 0;
                                                                                    break e;
                                                                                  }
                                                                                  if (o = e[o + 8 >> 2], $[o + 11 | 0] >= 0) {
                                                                                    e[g + 104 >> 2] = e[o + 8 >> 2], c = e[o + 4 >> 2], e[g + 96 >> 2] = e[o >> 2], e[g + 100 >> 2] = c;
                                                                                    break n;
                                                                                  }
                                                                                  if (c = e[o + 4 >> 2], o = e[o >> 2], e[5996] = 0, as(40, g + 96 | 0, o | 0, c | 0), o = e[5996], e[5996] = 0, (o | 0) != 1)
                                                                                    break n;
                                                                                  r = Vr() | 0;
                                                                                  break e;
                                                                                }
                                                                                if (e[5996] = 0, o = Si(99, h | 0, 0, 2541) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                                                                                  h = e[o >> 2], e[g + 96 >> 2] = e[o + 4 >> 2], c = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 99 | 0] = c, $[g + 100 | 0] = c >>> 8, $[g + 101 | 0] = c >>> 16, $[g + 102 | 0] = c >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, c = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = h, e[r + 4 >> 2] = e[g + 96 >> 2], o = ye[g + 99 | 0] | ye[g + 100 | 0] << 8 | (ye[g + 101 | 0] << 16 | ye[g + 102 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = c;
                                                                                  break t;
                                                                                }
                                                                                r = Vr() | 0;
                                                                                break e;
                                                                              case 13:
                                                                                if (e[5996] = 0, o = Si(99, h | 0, 0, 2522) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                                                                                  h = e[o >> 2], e[g + 96 >> 2] = e[o + 4 >> 2], c = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 99 | 0] = c, $[g + 100 | 0] = c >>> 8, $[g + 101 | 0] = c >>> 16, $[g + 102 | 0] = c >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, c = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = h, e[r + 4 >> 2] = e[g + 96 >> 2], o = ye[g + 99 | 0] | ye[g + 100 | 0] << 8 | (ye[g + 101 | 0] << 16 | ye[g + 102 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = c;
                                                                                  break t;
                                                                                }
                                                                                r = Vr() | 0;
                                                                                break e;
                                                                              case 14:
                                                                                if (e[5996] = 0, o = Si(99, h | 0, 0, 1271) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                                                                                  h = e[o >> 2], e[g + 96 >> 2] = e[o + 4 >> 2], c = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 99 | 0] = c, $[g + 100 | 0] = c >>> 8, $[g + 101 | 0] = c >>> 16, $[g + 102 | 0] = c >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, c = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = h, e[r + 4 >> 2] = e[g + 96 >> 2], o = ye[g + 99 | 0] | ye[g + 100 | 0] << 8 | (ye[g + 101 | 0] << 16 | ye[g + 102 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = c;
                                                                                  break t;
                                                                                }
                                                                                r = Vr() | 0;
                                                                                break e;
                                                                              case 15:
                                                                                if (e[5996] = 0, o = Si(99, h | 0, 0, 2170) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                                                                                  h = e[o >> 2], e[g + 96 >> 2] = e[o + 4 >> 2], c = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 99 | 0] = c, $[g + 100 | 0] = c >>> 8, $[g + 101 | 0] = c >>> 16, $[g + 102 | 0] = c >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, c = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = h, e[r + 4 >> 2] = e[g + 96 >> 2], o = ye[g + 99 | 0] | ye[g + 100 | 0] << 8 | (ye[g + 101 | 0] << 16 | ye[g + 102 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = c;
                                                                                  break t;
                                                                                }
                                                                                r = Vr() | 0;
                                                                                break e;
                                                                              case 16:
                                                                                if (e[5996] = 0, o = Si(99, h | 0, 0, 2029) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                                                                                  h = e[o >> 2], e[g + 96 >> 2] = e[o + 4 >> 2], c = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 99 | 0] = c, $[g + 100 | 0] = c >>> 8, $[g + 101 | 0] = c >>> 16, $[g + 102 | 0] = c >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, c = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = h, e[r + 4 >> 2] = e[g + 96 >> 2], o = ye[g + 99 | 0] | ye[g + 100 | 0] << 8 | (ye[g + 101 | 0] << 16 | ye[g + 102 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = c;
                                                                                  break t;
                                                                                }
                                                                                r = Vr() | 0;
                                                                                break e;
                                                                              case 17:
                                                                                if (e[e[e[c + 32 >> 2] + 8 >> 2] >> 2] != 1)
                                                                                  break R;
                                                                                if (e[5996] = 0, o = Si(99, h | 0, 0, 1392) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                                                                                  h = e[o >> 2], e[g + 96 >> 2] = e[o + 4 >> 2], c = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 99 | 0] = c, $[g + 100 | 0] = c >>> 8, $[g + 101 | 0] = c >>> 16, $[g + 102 | 0] = c >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, c = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = h, e[r + 4 >> 2] = e[g + 96 >> 2], o = ye[g + 99 | 0] | ye[g + 100 | 0] << 8 | (ye[g + 101 | 0] << 16 | ye[g + 102 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = c;
                                                                                  break t;
                                                                                }
                                                                                r = Vr() | 0;
                                                                                break e;
                                                                              case 22:
                                                                                if (o = e[c + 32 >> 2], !e[e[o >> 2] >> 2]) {
                                                                                  if (e[5996] = 0, o = Si(99, h + 12 | 0, 0, 2096) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                                                                                    y = e[o >> 2], c = ye[h + 19 | 0] | ye[h + 20 | 0] << 8 | (ye[h + 21 | 0] << 16 | ye[h + 22 | 0] << 24), $[g + 99 | 0] = c, $[g + 100 | 0] = c >>> 8, $[g + 101 | 0] = c >>> 16, $[g + 102 | 0] = c >>> 24, e[g + 96 >> 2] = e[h + 16 >> 2], c = ye[h + 23 | 0], e[o + 8 >> 2] = 0, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[r >> 2] = y, e[r + 4 >> 2] = e[g + 96 >> 2], o = ye[g + 99 | 0] | ye[g + 100 | 0] << 8 | (ye[g + 101 | 0] << 16 | ye[g + 102 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = c;
                                                                                    break t;
                                                                                  }
                                                                                  r = Vr() | 0;
                                                                                  break e;
                                                                                }
                                                                                if (e[e[o + 8 >> 2] >> 2])
                                                                                  break b;
                                                                                if (e[5996] = 0, o = Si(99, h | 0, 0, 1295) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                                                                                  h = e[o >> 2], e[g + 96 >> 2] = e[o + 4 >> 2], c = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 99 | 0] = c, $[g + 100 | 0] = c >>> 8, $[g + 101 | 0] = c >>> 16, $[g + 102 | 0] = c >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, c = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = h, e[r + 4 >> 2] = e[g + 96 >> 2], o = ye[g + 99 | 0] | ye[g + 100 | 0] << 8 | (ye[g + 101 | 0] << 16 | ye[g + 102 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = c;
                                                                                  break t;
                                                                                }
                                                                                r = Vr() | 0;
                                                                                break e;
                                                                              case 2:
                                                                                if (o = e[c + 8 >> 2], $[o + 11 | 0] >= 0) {
                                                                                  e[g + 104 >> 2] = e[o + 8 >> 2], c = e[o + 4 >> 2], e[g + 96 >> 2] = e[o >> 2], e[g + 100 >> 2] = c;
                                                                                  break i;
                                                                                }
                                                                                if (c = e[o + 4 >> 2], o = e[o >> 2], e[5996] = 0, as(40, g + 96 | 0, o | 0, c | 0), o = e[5996], e[5996] = 0, (o | 0) != 1)
                                                                                  break i;
                                                                                r = Vr() | 0;
                                                                                break e;
                                                                              case 3:
                                                                                if (o = e[c + 8 >> 2], $[o + 11 | 0] >= 0) {
                                                                                  e[g + 104 >> 2] = e[o + 8 >> 2], c = e[o + 4 >> 2], e[g + 96 >> 2] = e[o >> 2], e[g + 100 >> 2] = c;
                                                                                  break s;
                                                                                }
                                                                                if (c = e[o + 4 >> 2], o = e[o >> 2], e[5996] = 0, as(40, g + 96 | 0, o | 0, c | 0), o = e[5996], e[5996] = 0, (o | 0) != 1)
                                                                                  break s;
                                                                                r = Vr() | 0;
                                                                                break e;
                                                                              case 5:
                                                                                e[5996] = 0, o = On(97, g + 116 | 0, 5258) | 0, h = e[5996], e[5996] = 0;
                                                                                C: {
                                                                                  y: {
                                                                                    D: {
                                                                                      P: {
                                                                                        q: {
                                                                                          if ((h | 0) != 1) {
                                                                                            if (e[g + 88 >> 2] = e[o + 8 >> 2], h = e[o + 4 >> 2], e[g + 80 >> 2] = e[o >> 2], e[g + 84 >> 2] = h, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[5996] = 0, o = g - -64 | 0, di(119, o | 0, c + 4 | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                              break q;
                                                                                            if (e[5996] = 0, h = o, o = ye[g + 75 | 0], c = o << 24 >> 24 < 0, c = Si(100, g + 80 | 0, (c ? e[g + 64 >> 2] : h) | 0, (c ? e[g + 68 >> 2] : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                              break P;
                                                                                            if (e[g + 104 >> 2] = e[c + 8 >> 2], o = e[c + 4 >> 2], e[g + 96 >> 2] = e[c >> 2], e[g + 100 >> 2] = o, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, e[5996] = 0, o = On(97, g + 96 | 0, 5242) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                              break D;
                                                                                            if (y = e[o >> 2], e[g + 48 >> 2] = e[o + 4 >> 2], h = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 51 | 0] = h, $[g + 52 | 0] = h >>> 8, $[g + 53 | 0] = h >>> 16, $[g + 54 | 0] = h >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, h = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = y, e[r + 4 >> 2] = e[g + 48 >> 2], o = ye[g + 51 | 0] | ye[g + 52 | 0] << 8 | (ye[g + 53 | 0] << 16 | ye[g + 54 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = h, $[g + 75 | 0] < 0 && Sr(e[g + 64 >> 2]), $[c + 11 | 0] >= 0)
                                                                                              break t;
                                                                                            Sr(e[c >> 2]);
                                                                                            break t;
                                                                                          }
                                                                                          r = Vr() | 0;
                                                                                          break e;
                                                                                        }
                                                                                        r = Vr() | 0;
                                                                                        break C;
                                                                                      }
                                                                                      r = Vr() | 0;
                                                                                      break y;
                                                                                    }
                                                                                    if (r = Vr() | 0, $[g + 107 | 0] >= 0)
                                                                                      break y;
                                                                                    Sr(e[g + 96 >> 2]);
                                                                                  }
                                                                                  if ($[g + 75 | 0] >= 0)
                                                                                    break C;
                                                                                  Sr(e[g + 64 >> 2]);
                                                                                }
                                                                                if ($[g + 91 | 0] >= 0)
                                                                                  break e;
                                                                                Sr(e[g + 80 >> 2]);
                                                                                break e;
                                                                              case 4:
                                                                                e[5996] = 0, o = On(97, g + 116 | 0, 5265) | 0, h = e[5996], e[5996] = 0;
                                                                                C: {
                                                                                  y: {
                                                                                    D: {
                                                                                      P: {
                                                                                        q: {
                                                                                          if ((h | 0) != 1) {
                                                                                            if (e[g + 88 >> 2] = e[o + 8 >> 2], h = e[o + 4 >> 2], e[g + 80 >> 2] = e[o >> 2], e[g + 84 >> 2] = h, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[5996] = 0, o = g - -64 | 0, di(119, o | 0, c + 4 | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                              break q;
                                                                                            if (e[5996] = 0, h = o, o = ye[g + 75 | 0], c = o << 24 >> 24 < 0, c = Si(100, g + 80 | 0, (c ? e[g + 64 >> 2] : h) | 0, (c ? e[g + 68 >> 2] : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                              break P;
                                                                                            if (e[g + 104 >> 2] = e[c + 8 >> 2], o = e[c + 4 >> 2], e[g + 96 >> 2] = e[c >> 2], e[g + 100 >> 2] = o, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, e[5996] = 0, o = On(97, g + 96 | 0, 5242) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                              break D;
                                                                                            if (y = e[o >> 2], e[g + 48 >> 2] = e[o + 4 >> 2], h = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 51 | 0] = h, $[g + 52 | 0] = h >>> 8, $[g + 53 | 0] = h >>> 16, $[g + 54 | 0] = h >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, h = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = y, e[r + 4 >> 2] = e[g + 48 >> 2], o = ye[g + 51 | 0] | ye[g + 52 | 0] << 8 | (ye[g + 53 | 0] << 16 | ye[g + 54 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = h, $[g + 75 | 0] < 0 && Sr(e[g + 64 >> 2]), $[c + 11 | 0] >= 0)
                                                                                              break t;
                                                                                            Sr(e[c >> 2]);
                                                                                            break t;
                                                                                          }
                                                                                          r = Vr() | 0;
                                                                                          break e;
                                                                                        }
                                                                                        r = Vr() | 0;
                                                                                        break C;
                                                                                      }
                                                                                      r = Vr() | 0;
                                                                                      break y;
                                                                                    }
                                                                                    if (r = Vr() | 0, $[g + 107 | 0] >= 0)
                                                                                      break y;
                                                                                    Sr(e[g + 96 >> 2]);
                                                                                  }
                                                                                  if ($[g + 75 | 0] >= 0)
                                                                                    break C;
                                                                                  Sr(e[g + 64 >> 2]);
                                                                                }
                                                                                if ($[g + 91 | 0] >= 0)
                                                                                  break e;
                                                                                Sr(e[g + 80 >> 2]);
                                                                                break e;
                                                                              case 7:
                                                                                e[5996] = 0, o = On(97, g + 116 | 0, 5346) | 0, h = e[5996], e[5996] = 0;
                                                                                C: {
                                                                                  y: {
                                                                                    D: {
                                                                                      if ((h | 0) != 1) {
                                                                                        if (e[g + 88 >> 2] = e[o + 8 >> 2], h = e[o + 4 >> 2], e[g + 80 >> 2] = e[o >> 2], e[g + 84 >> 2] = h, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, h = e[c + 24 >> 2], o = e[c + 20 >> 2], e[g + 72 >> 2] = 0, e[g + 64 >> 2] = 0, e[g + 68 >> 2] = 0, e[5996] = 0, c = h - o | 0, di(101, g - -64 | 0, c << 1), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                          break o;
                                                                                        P: {
                                                                                          if (o >>> 0 < h >>> 0)
                                                                                            for (h = o + c | 0; ; ) {
                                                                                              if (c = ye[o | 0], e[5996] = 0, y = g - -64 | 0, di(98, y | 0, $[(c >>> 4 | 0) + 6976 | 0]), S = e[5996], e[5996] = 0, (S | 0) == 1 || (e[5996] = 0, di(98, y | 0, $[(c & 15) + 6976 | 0]), c = e[5996], e[5996] = 0, (c | 0) == 1))
                                                                                                break P;
                                                                                              if (o = o + 1 | 0, (h | 0) == (o | 0))
                                                                                                break;
                                                                                            }
                                                                                          if (e[5996] = 0, o = ye[g + 75 | 0], c = o << 24 >> 24 < 0, c = Si(100, g + 80 | 0, (c ? e[g + 64 >> 2] : g - -64 | 0) | 0, (c ? e[g + 68 >> 2] : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                            break D;
                                                                                          if (e[g + 104 >> 2] = e[c + 8 >> 2], o = e[c + 4 >> 2], e[g + 96 >> 2] = e[c >> 2], e[g + 100 >> 2] = o, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, e[5996] = 0, o = On(97, g + 96 | 0, 5242) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                            break y;
                                                                                          if (y = e[o >> 2], e[g + 48 >> 2] = e[o + 4 >> 2], h = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 51 | 0] = h, $[g + 52 | 0] = h >>> 8, $[g + 53 | 0] = h >>> 16, $[g + 54 | 0] = h >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, h = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = y, e[r + 4 >> 2] = e[g + 48 >> 2], o = ye[g + 51 | 0] | ye[g + 52 | 0] << 8 | (ye[g + 53 | 0] << 16 | ye[g + 54 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = h, $[g + 75 | 0] < 0 && Sr(e[g + 64 >> 2]), $[c + 11 | 0] >= 0)
                                                                                            break t;
                                                                                          Sr(e[c >> 2]);
                                                                                          break t;
                                                                                        }
                                                                                        break o;
                                                                                      }
                                                                                      r = Vr() | 0;
                                                                                      break e;
                                                                                    }
                                                                                    r = Vr() | 0;
                                                                                    break C;
                                                                                  }
                                                                                  if (r = Vr() | 0, $[g + 107 | 0] >= 0)
                                                                                    break C;
                                                                                  Sr(e[g + 96 >> 2]);
                                                                                }
                                                                                break a;
                                                                              case 9:
                                                                                e[5996] = 0, o = On(97, g + 116 | 0, 5363) | 0, h = e[5996], e[5996] = 0;
                                                                                C: {
                                                                                  y: {
                                                                                    D: {
                                                                                      if ((h | 0) != 1) {
                                                                                        if (e[g + 88 >> 2] = e[o + 8 >> 2], h = e[o + 4 >> 2], e[g + 80 >> 2] = e[o >> 2], e[g + 84 >> 2] = h, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, h = e[c + 24 >> 2], o = e[c + 20 >> 2], e[g + 72 >> 2] = 0, e[g + 64 >> 2] = 0, e[g + 68 >> 2] = 0, e[5996] = 0, c = h - o | 0, di(101, g - -64 | 0, c << 1), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                          break f;
                                                                                        P: {
                                                                                          if (o >>> 0 < h >>> 0)
                                                                                            for (h = o + c | 0; ; ) {
                                                                                              if (c = ye[o | 0], e[5996] = 0, y = g - -64 | 0, di(98, y | 0, $[(c >>> 4 | 0) + 6976 | 0]), S = e[5996], e[5996] = 0, (S | 0) == 1 || (e[5996] = 0, di(98, y | 0, $[(c & 15) + 6976 | 0]), c = e[5996], e[5996] = 0, (c | 0) == 1))
                                                                                                break P;
                                                                                              if (o = o + 1 | 0, (h | 0) == (o | 0))
                                                                                                break;
                                                                                            }
                                                                                          if (e[5996] = 0, o = ye[g + 75 | 0], c = o << 24 >> 24 < 0, c = Si(100, g + 80 | 0, (c ? e[g + 64 >> 2] : g - -64 | 0) | 0, (c ? e[g + 68 >> 2] : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                            break D;
                                                                                          if (e[g + 104 >> 2] = e[c + 8 >> 2], o = e[c + 4 >> 2], e[g + 96 >> 2] = e[c >> 2], e[g + 100 >> 2] = o, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, e[5996] = 0, o = On(97, g + 96 | 0, 5242) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                            break y;
                                                                                          if (y = e[o >> 2], e[g + 48 >> 2] = e[o + 4 >> 2], h = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 51 | 0] = h, $[g + 52 | 0] = h >>> 8, $[g + 53 | 0] = h >>> 16, $[g + 54 | 0] = h >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, h = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = y, e[r + 4 >> 2] = e[g + 48 >> 2], o = ye[g + 51 | 0] | ye[g + 52 | 0] << 8 | (ye[g + 53 | 0] << 16 | ye[g + 54 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = h, $[g + 75 | 0] < 0 && Sr(e[g + 64 >> 2]), $[c + 11 | 0] >= 0)
                                                                                            break t;
                                                                                          Sr(e[c >> 2]);
                                                                                          break t;
                                                                                        }
                                                                                        break f;
                                                                                      }
                                                                                      r = Vr() | 0;
                                                                                      break e;
                                                                                    }
                                                                                    r = Vr() | 0;
                                                                                    break C;
                                                                                  }
                                                                                  if (r = Vr() | 0, $[g + 107 | 0] >= 0)
                                                                                    break C;
                                                                                  Sr(e[g + 96 >> 2]);
                                                                                }
                                                                                break l;
                                                                              case 6:
                                                                                e[5996] = 0, o = On(97, g + 116 | 0, 5355) | 0, h = e[5996], e[5996] = 0;
                                                                                C: {
                                                                                  y: {
                                                                                    D: {
                                                                                      if ((h | 0) != 1) {
                                                                                        if (e[g + 88 >> 2] = e[o + 8 >> 2], h = e[o + 4 >> 2], e[g + 80 >> 2] = e[o >> 2], e[g + 84 >> 2] = h, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, h = e[c + 24 >> 2], o = e[c + 20 >> 2], e[g + 72 >> 2] = 0, e[g + 64 >> 2] = 0, e[g + 68 >> 2] = 0, e[5996] = 0, c = h - o | 0, di(101, g - -64 | 0, c << 1), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                          break c;
                                                                                        P: {
                                                                                          if (o >>> 0 < h >>> 0)
                                                                                            for (h = o + c | 0; ; ) {
                                                                                              if (c = ye[o | 0], e[5996] = 0, y = g - -64 | 0, di(98, y | 0, $[(c >>> 4 | 0) + 6976 | 0]), S = e[5996], e[5996] = 0, (S | 0) == 1 || (e[5996] = 0, di(98, y | 0, $[(c & 15) + 6976 | 0]), c = e[5996], e[5996] = 0, (c | 0) == 1))
                                                                                                break P;
                                                                                              if (o = o + 1 | 0, (h | 0) == (o | 0))
                                                                                                break;
                                                                                            }
                                                                                          if (e[5996] = 0, o = ye[g + 75 | 0], c = o << 24 >> 24 < 0, c = Si(100, g + 80 | 0, (c ? e[g + 64 >> 2] : g - -64 | 0) | 0, (c ? e[g + 68 >> 2] : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                            break D;
                                                                                          if (e[g + 104 >> 2] = e[c + 8 >> 2], o = e[c + 4 >> 2], e[g + 96 >> 2] = e[c >> 2], e[g + 100 >> 2] = o, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, e[5996] = 0, o = On(97, g + 96 | 0, 5242) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                            break y;
                                                                                          if (y = e[o >> 2], e[g + 48 >> 2] = e[o + 4 >> 2], h = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 51 | 0] = h, $[g + 52 | 0] = h >>> 8, $[g + 53 | 0] = h >>> 16, $[g + 54 | 0] = h >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, h = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = y, e[r + 4 >> 2] = e[g + 48 >> 2], o = ye[g + 51 | 0] | ye[g + 52 | 0] << 8 | (ye[g + 53 | 0] << 16 | ye[g + 54 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = h, $[g + 75 | 0] < 0 && Sr(e[g + 64 >> 2]), $[c + 11 | 0] >= 0)
                                                                                            break t;
                                                                                          Sr(e[c >> 2]);
                                                                                          break t;
                                                                                        }
                                                                                        break c;
                                                                                      }
                                                                                      r = Vr() | 0;
                                                                                      break e;
                                                                                    }
                                                                                    r = Vr() | 0;
                                                                                    break C;
                                                                                  }
                                                                                  if (r = Vr() | 0, $[g + 107 | 0] >= 0)
                                                                                    break C;
                                                                                  Sr(e[g + 96 >> 2]);
                                                                                }
                                                                                break d;
                                                                              case 8:
                                                                                e[5996] = 0, o = On(97, g + 116 | 0, 5372) | 0, h = e[5996], e[5996] = 0;
                                                                                C: {
                                                                                  y: {
                                                                                    D: {
                                                                                      if ((h | 0) != 1) {
                                                                                        if (e[g + 88 >> 2] = e[o + 8 >> 2], h = e[o + 4 >> 2], e[g + 80 >> 2] = e[o >> 2], e[g + 84 >> 2] = h, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, h = e[c + 24 >> 2], o = e[c + 20 >> 2], e[g + 72 >> 2] = 0, e[g + 64 >> 2] = 0, e[g + 68 >> 2] = 0, e[5996] = 0, c = h - o | 0, di(101, g - -64 | 0, c << 1), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                          break g;
                                                                                        P: {
                                                                                          if (o >>> 0 < h >>> 0)
                                                                                            for (h = o + c | 0; ; ) {
                                                                                              if (c = ye[o | 0], e[5996] = 0, y = g - -64 | 0, di(98, y | 0, $[(c >>> 4 | 0) + 6976 | 0]), S = e[5996], e[5996] = 0, (S | 0) == 1 || (e[5996] = 0, di(98, y | 0, $[(c & 15) + 6976 | 0]), c = e[5996], e[5996] = 0, (c | 0) == 1))
                                                                                                break P;
                                                                                              if (o = o + 1 | 0, (h | 0) == (o | 0))
                                                                                                break;
                                                                                            }
                                                                                          if (e[5996] = 0, o = ye[g + 75 | 0], c = o << 24 >> 24 < 0, c = Si(100, g + 80 | 0, (c ? e[g + 64 >> 2] : g - -64 | 0) | 0, (c ? e[g + 68 >> 2] : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                            break D;
                                                                                          if (e[g + 104 >> 2] = e[c + 8 >> 2], o = e[c + 4 >> 2], e[g + 96 >> 2] = e[c >> 2], e[g + 100 >> 2] = o, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, e[5996] = 0, o = On(97, g + 96 | 0, 5242) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                            break y;
                                                                                          if (y = e[o >> 2], e[g + 48 >> 2] = e[o + 4 >> 2], h = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 51 | 0] = h, $[g + 52 | 0] = h >>> 8, $[g + 53 | 0] = h >>> 16, $[g + 54 | 0] = h >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, h = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = y, e[r + 4 >> 2] = e[g + 48 >> 2], o = ye[g + 51 | 0] | ye[g + 52 | 0] << 8 | (ye[g + 53 | 0] << 16 | ye[g + 54 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = h, $[g + 75 | 0] < 0 && Sr(e[g + 64 >> 2]), $[c + 11 | 0] >= 0)
                                                                                            break t;
                                                                                          Sr(e[c >> 2]);
                                                                                          break t;
                                                                                        }
                                                                                        break g;
                                                                                      }
                                                                                      r = Vr() | 0;
                                                                                      break e;
                                                                                    }
                                                                                    r = Vr() | 0;
                                                                                    break C;
                                                                                  }
                                                                                  if (r = Vr() | 0, $[g + 107 | 0] >= 0)
                                                                                    break C;
                                                                                  Sr(e[g + 96 >> 2]);
                                                                                }
                                                                                break u;
                                                                              case 1:
                                                                                if (e[5996] = 0, o = On(97, g + 116 | 0, 4180) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                                                                                  h = e[o >> 2], e[g + 96 >> 2] = e[o + 4 >> 2], c = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 99 | 0] = c, $[g + 100 | 0] = c >>> 8, $[g + 101 | 0] = c >>> 16, $[g + 102 | 0] = c >>> 24, c = ye[g + 127 | 0], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[r >> 2] = h, e[r + 4 >> 2] = e[g + 96 >> 2], o = ye[g + 99 | 0] | ye[g + 100 | 0] << 8 | (ye[g + 101 | 0] << 16 | ye[g + 102 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = c;
                                                                                  break t;
                                                                                }
                                                                                r = Vr() | 0;
                                                                                break e;
                                                                              case 24:
                                                                                break N;
                                                                              case 25:
                                                                                break v;
                                                                              case 23:
                                                                                break w;
                                                                              case 20:
                                                                                break h;
                                                                              case 21:
                                                                                break x;
                                                                              case 19:
                                                                                break m;
                                                                              case 18:
                                                                                break B;
                                                                              case 0:
                                                                                break E;
                                                                              default:
                                                                                break S;
                                                                            }
                                                                          if (e[5996] = 0, o = On(97, g + 116 | 0, 4350) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                                                                            h = e[o >> 2], e[g + 96 >> 2] = e[o + 4 >> 2], c = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 99 | 0] = c, $[g + 100 | 0] = c >>> 8, $[g + 101 | 0] = c >>> 16, $[g + 102 | 0] = c >>> 24, c = ye[g + 127 | 0], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[r >> 2] = h, e[r + 4 >> 2] = e[g + 96 >> 2], o = ye[g + 99 | 0] | ye[g + 100 | 0] << 8 | (ye[g + 101 | 0] << 16 | ye[g + 102 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = c;
                                                                            break t;
                                                                          }
                                                                          r = Vr() | 0;
                                                                          break e;
                                                                        }
                                                                        e[5996] = 0, o = On(97, g + 116 | 0, 5244) | 0, c = e[5996], e[5996] = 0;
                                                                        R: {
                                                                          E: {
                                                                            C: {
                                                                              y: {
                                                                                D: {
                                                                                  P: {
                                                                                    q: {
                                                                                      if ((c | 0) != 1) {
                                                                                        if (e[g + 56 >> 2] = e[o + 8 >> 2], c = e[o + 4 >> 2], e[g + 48 >> 2] = e[o >> 2], e[g + 52 >> 2] = c, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, c = e[h >> 2], y = e[h + 4 >> 2], o = ye[h + 11 | 0], e[5996] = 0, G = c, c = o << 24 >> 24 < 0, c = Si(100, g + 48 | 0, (c ? G : h) | 0, (c ? y : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                          break q;
                                                                                        if (e[g + 72 >> 2] = e[c + 8 >> 2], o = e[c + 4 >> 2], e[g + 64 >> 2] = e[c >> 2], e[g + 68 >> 2] = o, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, e[5996] = 0, y = On(97, g - -64 | 0, 4354) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                          break P;
                                                                                        if (e[g + 88 >> 2] = e[y + 8 >> 2], o = e[y + 4 >> 2], e[g + 80 >> 2] = e[y >> 2], e[g + 84 >> 2] = o, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, S = e[h + 16 >> 2], G = e[h + 12 >> 2], o = ye[h + 23 | 0], e[5996] = 0, ke = h + 12 | 0, h = o << 24 >> 24 < 0, h = Si(100, g + 80 | 0, (h ? G : ke) | 0, (h ? S : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                          break D;
                                                                                        if (e[g + 104 >> 2] = e[h + 8 >> 2], o = e[h + 4 >> 2], e[g + 96 >> 2] = e[h >> 2], e[g + 100 >> 2] = o, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, o = On(97, g + 96 | 0, 5242) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                          break y;
                                                                                        if (G = e[o >> 2], e[g + 24 >> 2] = e[o + 4 >> 2], S = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 27 | 0] = S, $[g + 28 | 0] = S >>> 8, $[g + 29 | 0] = S >>> 16, $[g + 30 | 0] = S >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, S = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = G, e[r + 4 >> 2] = e[g + 24 >> 2], o = ye[g + 27 | 0] | ye[g + 28 | 0] << 8 | (ye[g + 29 | 0] << 16 | ye[g + 30 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = S, $[h + 11 | 0] < 0 && Sr(e[h >> 2]), $[y + 11 | 0] < 0 && Sr(e[y >> 2]), $[c + 11 | 0] >= 0)
                                                                                          break t;
                                                                                        Sr(e[c >> 2]);
                                                                                        break t;
                                                                                      }
                                                                                      r = Vr() | 0;
                                                                                      break e;
                                                                                    }
                                                                                    r = Vr() | 0;
                                                                                    break R;
                                                                                  }
                                                                                  r = Vr() | 0;
                                                                                  break E;
                                                                                }
                                                                                r = Vr() | 0;
                                                                                break C;
                                                                              }
                                                                              if (r = Vr() | 0, $[g + 107 | 0] >= 0)
                                                                                break C;
                                                                              Sr(e[g + 96 >> 2]);
                                                                            }
                                                                            if ($[g + 91 | 0] >= 0)
                                                                              break E;
                                                                            Sr(e[g + 80 >> 2]);
                                                                          }
                                                                          if ($[g + 75 | 0] >= 0)
                                                                            break R;
                                                                          Sr(e[g + 64 >> 2]);
                                                                        }
                                                                        if ($[g + 59 | 0] >= 0)
                                                                          break e;
                                                                        Sr(e[g + 48 >> 2]);
                                                                        break e;
                                                                      }
                                                                      e[5996] = 0, o = On(97, g + 116 | 0, 5339) | 0, c = e[5996], e[5996] = 0;
                                                                      B: {
                                                                        R: {
                                                                          E: {
                                                                            C: {
                                                                              y: {
                                                                                D: {
                                                                                  P: {
                                                                                    if ((c | 0) != 1) {
                                                                                      if (e[g + 56 >> 2] = e[o + 8 >> 2], c = e[o + 4 >> 2], e[g + 48 >> 2] = e[o >> 2], e[g + 52 >> 2] = c, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, c = e[h >> 2], y = e[h + 4 >> 2], o = ye[h + 11 | 0], e[5996] = 0, G = c, c = o << 24 >> 24 < 0, c = Si(100, g + 48 | 0, (c ? G : h) | 0, (c ? y : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                        break P;
                                                                                      if (e[g + 72 >> 2] = e[c + 8 >> 2], o = e[c + 4 >> 2], e[g + 64 >> 2] = e[c >> 2], e[g + 68 >> 2] = o, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, e[5996] = 0, y = On(97, g - -64 | 0, 4354) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                        break D;
                                                                                      if (e[g + 88 >> 2] = e[y + 8 >> 2], o = e[y + 4 >> 2], e[g + 80 >> 2] = e[y >> 2], e[g + 84 >> 2] = o, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, S = e[h + 16 >> 2], G = e[h + 12 >> 2], o = ye[h + 23 | 0], e[5996] = 0, ke = h + 12 | 0, h = o << 24 >> 24 < 0, h = Si(100, g + 80 | 0, (h ? G : ke) | 0, (h ? S : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                        break y;
                                                                                      if (e[g + 104 >> 2] = e[h + 8 >> 2], o = e[h + 4 >> 2], e[g + 96 >> 2] = e[h >> 2], e[g + 100 >> 2] = o, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, o = On(97, g + 96 | 0, 5242) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                        break C;
                                                                                      if (G = e[o >> 2], e[g + 24 >> 2] = e[o + 4 >> 2], S = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 27 | 0] = S, $[g + 28 | 0] = S >>> 8, $[g + 29 | 0] = S >>> 16, $[g + 30 | 0] = S >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, S = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = G, e[r + 4 >> 2] = e[g + 24 >> 2], o = ye[g + 27 | 0] | ye[g + 28 | 0] << 8 | (ye[g + 29 | 0] << 16 | ye[g + 30 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = S, $[h + 11 | 0] < 0 && Sr(e[h >> 2]), $[y + 11 | 0] < 0 && Sr(e[y >> 2]), $[c + 11 | 0] >= 0)
                                                                                        break t;
                                                                                      Sr(e[c >> 2]);
                                                                                      break t;
                                                                                    }
                                                                                    r = Vr() | 0;
                                                                                    break e;
                                                                                  }
                                                                                  r = Vr() | 0;
                                                                                  break B;
                                                                                }
                                                                                r = Vr() | 0;
                                                                                break R;
                                                                              }
                                                                              r = Vr() | 0;
                                                                              break E;
                                                                            }
                                                                            if (r = Vr() | 0, $[g + 107 | 0] >= 0)
                                                                              break E;
                                                                            Sr(e[g + 96 >> 2]);
                                                                          }
                                                                          if ($[g + 91 | 0] >= 0)
                                                                            break R;
                                                                          Sr(e[g + 80 >> 2]);
                                                                        }
                                                                        if ($[g + 75 | 0] >= 0)
                                                                          break B;
                                                                        Sr(e[g + 64 >> 2]);
                                                                      }
                                                                      if ($[g + 59 | 0] >= 0)
                                                                        break e;
                                                                      Sr(e[g + 48 >> 2]);
                                                                      break e;
                                                                    }
                                                                    e[5996] = 0, o = On(97, g + 116 | 0, 5333) | 0, c = e[5996], e[5996] = 0;
                                                                    m: {
                                                                      B: {
                                                                        R: {
                                                                          E: {
                                                                            C: {
                                                                              y: {
                                                                                D: {
                                                                                  if ((c | 0) != 1) {
                                                                                    if (e[g + 56 >> 2] = e[o + 8 >> 2], c = e[o + 4 >> 2], e[g + 48 >> 2] = e[o >> 2], e[g + 52 >> 2] = c, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, c = e[h >> 2], y = e[h + 4 >> 2], o = ye[h + 11 | 0], e[5996] = 0, G = c, c = o << 24 >> 24 < 0, c = Si(100, g + 48 | 0, (c ? G : h) | 0, (c ? y : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                      break D;
                                                                                    if (e[g + 72 >> 2] = e[c + 8 >> 2], o = e[c + 4 >> 2], e[g + 64 >> 2] = e[c >> 2], e[g + 68 >> 2] = o, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, e[5996] = 0, y = On(97, g - -64 | 0, 4354) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                      break y;
                                                                                    if (e[g + 88 >> 2] = e[y + 8 >> 2], o = e[y + 4 >> 2], e[g + 80 >> 2] = e[y >> 2], e[g + 84 >> 2] = o, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, S = e[h + 16 >> 2], G = e[h + 12 >> 2], o = ye[h + 23 | 0], e[5996] = 0, ke = h + 12 | 0, h = o << 24 >> 24 < 0, h = Si(100, g + 80 | 0, (h ? G : ke) | 0, (h ? S : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                      break C;
                                                                                    if (e[g + 104 >> 2] = e[h + 8 >> 2], o = e[h + 4 >> 2], e[g + 96 >> 2] = e[h >> 2], e[g + 100 >> 2] = o, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, o = On(97, g + 96 | 0, 5242) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                      break E;
                                                                                    if (G = e[o >> 2], e[g + 24 >> 2] = e[o + 4 >> 2], S = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 27 | 0] = S, $[g + 28 | 0] = S >>> 8, $[g + 29 | 0] = S >>> 16, $[g + 30 | 0] = S >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, S = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = G, e[r + 4 >> 2] = e[g + 24 >> 2], o = ye[g + 27 | 0] | ye[g + 28 | 0] << 8 | (ye[g + 29 | 0] << 16 | ye[g + 30 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = S, $[h + 11 | 0] < 0 && Sr(e[h >> 2]), $[y + 11 | 0] < 0 && Sr(e[y >> 2]), $[c + 11 | 0] >= 0)
                                                                                      break t;
                                                                                    Sr(e[c >> 2]);
                                                                                    break t;
                                                                                  }
                                                                                  r = Vr() | 0;
                                                                                  break e;
                                                                                }
                                                                                r = Vr() | 0;
                                                                                break m;
                                                                              }
                                                                              r = Vr() | 0;
                                                                              break B;
                                                                            }
                                                                            r = Vr() | 0;
                                                                            break R;
                                                                          }
                                                                          if (r = Vr() | 0, $[g + 107 | 0] >= 0)
                                                                            break R;
                                                                          Sr(e[g + 96 >> 2]);
                                                                        }
                                                                        if ($[g + 91 | 0] >= 0)
                                                                          break B;
                                                                        Sr(e[g + 80 >> 2]);
                                                                      }
                                                                      if ($[g + 75 | 0] >= 0)
                                                                        break m;
                                                                      Sr(e[g + 64 >> 2]);
                                                                    }
                                                                    if ($[g + 59 | 0] >= 0)
                                                                      break e;
                                                                    Sr(e[g + 48 >> 2]);
                                                                    break e;
                                                                  }
                                                                  e[5996] = 0, o = On(97, g + 116 | 0, 5321) | 0, c = e[5996], e[5996] = 0;
                                                                  x: {
                                                                    m: {
                                                                      B: {
                                                                        R: {
                                                                          E: {
                                                                            C: {
                                                                              y: {
                                                                                if ((c | 0) != 1) {
                                                                                  if (e[g + 56 >> 2] = e[o + 8 >> 2], c = e[o + 4 >> 2], e[g + 48 >> 2] = e[o >> 2], e[g + 52 >> 2] = c, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, c = e[h >> 2], y = e[h + 4 >> 2], o = ye[h + 11 | 0], e[5996] = 0, G = c, c = o << 24 >> 24 < 0, c = Si(100, g + 48 | 0, (c ? G : h) | 0, (c ? y : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                    break y;
                                                                                  if (e[g + 72 >> 2] = e[c + 8 >> 2], o = e[c + 4 >> 2], e[g + 64 >> 2] = e[c >> 2], e[g + 68 >> 2] = o, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, e[5996] = 0, y = On(97, g - -64 | 0, 4354) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                    break C;
                                                                                  if (e[g + 88 >> 2] = e[y + 8 >> 2], o = e[y + 4 >> 2], e[g + 80 >> 2] = e[y >> 2], e[g + 84 >> 2] = o, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, S = e[h + 16 >> 2], G = e[h + 12 >> 2], o = ye[h + 23 | 0], e[5996] = 0, ke = h + 12 | 0, h = o << 24 >> 24 < 0, h = Si(100, g + 80 | 0, (h ? G : ke) | 0, (h ? S : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                    break E;
                                                                                  if (e[g + 104 >> 2] = e[h + 8 >> 2], o = e[h + 4 >> 2], e[g + 96 >> 2] = e[h >> 2], e[g + 100 >> 2] = o, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, o = On(97, g + 96 | 0, 5242) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                    break R;
                                                                                  if (G = e[o >> 2], e[g + 24 >> 2] = e[o + 4 >> 2], S = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 27 | 0] = S, $[g + 28 | 0] = S >>> 8, $[g + 29 | 0] = S >>> 16, $[g + 30 | 0] = S >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, S = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = G, e[r + 4 >> 2] = e[g + 24 >> 2], o = ye[g + 27 | 0] | ye[g + 28 | 0] << 8 | (ye[g + 29 | 0] << 16 | ye[g + 30 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = S, $[h + 11 | 0] < 0 && Sr(e[h >> 2]), $[y + 11 | 0] < 0 && Sr(e[y >> 2]), $[c + 11 | 0] >= 0)
                                                                                    break t;
                                                                                  Sr(e[c >> 2]);
                                                                                  break t;
                                                                                }
                                                                                r = Vr() | 0;
                                                                                break e;
                                                                              }
                                                                              r = Vr() | 0;
                                                                              break x;
                                                                            }
                                                                            r = Vr() | 0;
                                                                            break m;
                                                                          }
                                                                          r = Vr() | 0;
                                                                          break B;
                                                                        }
                                                                        if (r = Vr() | 0, $[g + 107 | 0] >= 0)
                                                                          break B;
                                                                        Sr(e[g + 96 >> 2]);
                                                                      }
                                                                      if ($[g + 91 | 0] >= 0)
                                                                        break m;
                                                                      Sr(e[g + 80 >> 2]);
                                                                    }
                                                                    if ($[g + 75 | 0] >= 0)
                                                                      break x;
                                                                    Sr(e[g + 64 >> 2]);
                                                                  }
                                                                  if ($[g + 59 | 0] >= 0)
                                                                    break e;
                                                                  Sr(e[g + 48 >> 2]);
                                                                  break e;
                                                                }
                                                                e[5996] = 0, o = On(97, g + 116 | 0, 5327) | 0, c = e[5996], e[5996] = 0;
                                                                h: {
                                                                  x: {
                                                                    m: {
                                                                      B: {
                                                                        R: {
                                                                          E: {
                                                                            C: {
                                                                              if ((c | 0) != 1) {
                                                                                if (e[g + 56 >> 2] = e[o + 8 >> 2], c = e[o + 4 >> 2], e[g + 48 >> 2] = e[o >> 2], e[g + 52 >> 2] = c, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, c = e[h >> 2], y = e[h + 4 >> 2], o = ye[h + 11 | 0], e[5996] = 0, G = c, c = o << 24 >> 24 < 0, c = Si(100, g + 48 | 0, (c ? G : h) | 0, (c ? y : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                  break C;
                                                                                if (e[g + 72 >> 2] = e[c + 8 >> 2], o = e[c + 4 >> 2], e[g + 64 >> 2] = e[c >> 2], e[g + 68 >> 2] = o, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, e[5996] = 0, y = On(97, g - -64 | 0, 4354) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                  break E;
                                                                                if (e[g + 88 >> 2] = e[y + 8 >> 2], o = e[y + 4 >> 2], e[g + 80 >> 2] = e[y >> 2], e[g + 84 >> 2] = o, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, S = e[h + 16 >> 2], G = e[h + 12 >> 2], o = ye[h + 23 | 0], e[5996] = 0, ke = h + 12 | 0, h = o << 24 >> 24 < 0, h = Si(100, g + 80 | 0, (h ? G : ke) | 0, (h ? S : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                  break R;
                                                                                if (e[g + 104 >> 2] = e[h + 8 >> 2], o = e[h + 4 >> 2], e[g + 96 >> 2] = e[h >> 2], e[g + 100 >> 2] = o, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, o = On(97, g + 96 | 0, 5242) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                  break B;
                                                                                if (G = e[o >> 2], e[g + 24 >> 2] = e[o + 4 >> 2], S = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 27 | 0] = S, $[g + 28 | 0] = S >>> 8, $[g + 29 | 0] = S >>> 16, $[g + 30 | 0] = S >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, S = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = G, e[r + 4 >> 2] = e[g + 24 >> 2], o = ye[g + 27 | 0] | ye[g + 28 | 0] << 8 | (ye[g + 29 | 0] << 16 | ye[g + 30 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = S, $[h + 11 | 0] < 0 && Sr(e[h >> 2]), $[y + 11 | 0] < 0 && Sr(e[y >> 2]), $[c + 11 | 0] >= 0)
                                                                                  break t;
                                                                                Sr(e[c >> 2]);
                                                                                break t;
                                                                              }
                                                                              r = Vr() | 0;
                                                                              break e;
                                                                            }
                                                                            r = Vr() | 0;
                                                                            break h;
                                                                          }
                                                                          r = Vr() | 0;
                                                                          break x;
                                                                        }
                                                                        r = Vr() | 0;
                                                                        break m;
                                                                      }
                                                                      if (r = Vr() | 0, $[g + 107 | 0] >= 0)
                                                                        break m;
                                                                      Sr(e[g + 96 >> 2]);
                                                                    }
                                                                    if ($[g + 91 | 0] >= 0)
                                                                      break x;
                                                                    Sr(e[g + 80 >> 2]);
                                                                  }
                                                                  if ($[g + 75 | 0] >= 0)
                                                                    break h;
                                                                  Sr(e[g + 64 >> 2]);
                                                                }
                                                                if ($[g + 59 | 0] >= 0)
                                                                  break e;
                                                                Sr(e[g + 48 >> 2]);
                                                                break e;
                                                              }
                                                              e[5996] = 0, o = On(97, g + 116 | 0, 5296) | 0, c = e[5996], e[5996] = 0;
                                                              b: {
                                                                h: {
                                                                  x: {
                                                                    m: {
                                                                      B: {
                                                                        R: {
                                                                          E: {
                                                                            if ((c | 0) != 1) {
                                                                              if (e[g + 56 >> 2] = e[o + 8 >> 2], c = e[o + 4 >> 2], e[g + 48 >> 2] = e[o >> 2], e[g + 52 >> 2] = c, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, c = e[h >> 2], y = e[h + 4 >> 2], o = ye[h + 11 | 0], e[5996] = 0, G = c, c = o << 24 >> 24 < 0, c = Si(100, g + 48 | 0, (c ? G : h) | 0, (c ? y : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                break E;
                                                                              if (e[g + 72 >> 2] = e[c + 8 >> 2], o = e[c + 4 >> 2], e[g + 64 >> 2] = e[c >> 2], e[g + 68 >> 2] = o, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, e[5996] = 0, y = On(97, g - -64 | 0, 4354) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                break R;
                                                                              if (e[g + 88 >> 2] = e[y + 8 >> 2], o = e[y + 4 >> 2], e[g + 80 >> 2] = e[y >> 2], e[g + 84 >> 2] = o, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, S = e[h + 16 >> 2], G = e[h + 12 >> 2], o = ye[h + 23 | 0], e[5996] = 0, ke = h + 12 | 0, h = o << 24 >> 24 < 0, h = Si(100, g + 80 | 0, (h ? G : ke) | 0, (h ? S : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                break B;
                                                                              if (e[g + 104 >> 2] = e[h + 8 >> 2], o = e[h + 4 >> 2], e[g + 96 >> 2] = e[h >> 2], e[g + 100 >> 2] = o, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, o = On(97, g + 96 | 0, 5242) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                break m;
                                                                              if (G = e[o >> 2], e[g + 24 >> 2] = e[o + 4 >> 2], S = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 27 | 0] = S, $[g + 28 | 0] = S >>> 8, $[g + 29 | 0] = S >>> 16, $[g + 30 | 0] = S >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, S = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = G, e[r + 4 >> 2] = e[g + 24 >> 2], o = ye[g + 27 | 0] | ye[g + 28 | 0] << 8 | (ye[g + 29 | 0] << 16 | ye[g + 30 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = S, $[h + 11 | 0] < 0 && Sr(e[h >> 2]), $[y + 11 | 0] < 0 && Sr(e[y >> 2]), $[c + 11 | 0] >= 0)
                                                                                break t;
                                                                              Sr(e[c >> 2]);
                                                                              break t;
                                                                            }
                                                                            r = Vr() | 0;
                                                                            break e;
                                                                          }
                                                                          r = Vr() | 0;
                                                                          break b;
                                                                        }
                                                                        r = Vr() | 0;
                                                                        break h;
                                                                      }
                                                                      r = Vr() | 0;
                                                                      break x;
                                                                    }
                                                                    if (r = Vr() | 0, $[g + 107 | 0] >= 0)
                                                                      break x;
                                                                    Sr(e[g + 96 >> 2]);
                                                                  }
                                                                  if ($[g + 91 | 0] >= 0)
                                                                    break h;
                                                                  Sr(e[g + 80 >> 2]);
                                                                }
                                                                if ($[g + 75 | 0] >= 0)
                                                                  break b;
                                                                Sr(e[g + 64 >> 2]);
                                                              }
                                                              if ($[g + 59 | 0] >= 0)
                                                                break e;
                                                              Sr(e[g + 48 >> 2]);
                                                              break e;
                                                            }
                                                            if (!e[e[e[c + 32 >> 2] + 16 >> 2] >> 2]) {
                                                              e[5996] = 0, o = On(97, g + 116 | 0, 5272) | 0, c = e[5996], e[5996] = 0;
                                                              w: {
                                                                b: {
                                                                  h: {
                                                                    x: {
                                                                      m: {
                                                                        B: {
                                                                          R: {
                                                                            if ((c | 0) != 1) {
                                                                              if (e[g + 56 >> 2] = e[o + 8 >> 2], c = e[o + 4 >> 2], e[g + 48 >> 2] = e[o >> 2], e[g + 52 >> 2] = c, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, c = e[h >> 2], y = e[h + 4 >> 2], o = ye[h + 11 | 0], e[5996] = 0, G = c, c = o << 24 >> 24 < 0, c = Si(100, g + 48 | 0, (c ? G : h) | 0, (c ? y : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                break R;
                                                                              if (e[g + 72 >> 2] = e[c + 8 >> 2], o = e[c + 4 >> 2], e[g + 64 >> 2] = e[c >> 2], e[g + 68 >> 2] = o, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, e[5996] = 0, y = On(97, g - -64 | 0, 4354) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                break B;
                                                                              if (e[g + 88 >> 2] = e[y + 8 >> 2], o = e[y + 4 >> 2], e[g + 80 >> 2] = e[y >> 2], e[g + 84 >> 2] = o, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, S = e[h + 16 >> 2], G = e[h + 12 >> 2], o = ye[h + 23 | 0], e[5996] = 0, ke = h + 12 | 0, h = o << 24 >> 24 < 0, h = Si(100, g + 80 | 0, (h ? G : ke) | 0, (h ? S : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                break m;
                                                                              if (e[g + 104 >> 2] = e[h + 8 >> 2], o = e[h + 4 >> 2], e[g + 96 >> 2] = e[h >> 2], e[g + 100 >> 2] = o, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, o = On(97, g + 96 | 0, 5242) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                break x;
                                                                              if (G = e[o >> 2], e[g + 24 >> 2] = e[o + 4 >> 2], S = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 27 | 0] = S, $[g + 28 | 0] = S >>> 8, $[g + 29 | 0] = S >>> 16, $[g + 30 | 0] = S >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, S = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = G, e[r + 4 >> 2] = e[g + 24 >> 2], o = ye[g + 27 | 0] | ye[g + 28 | 0] << 8 | (ye[g + 29 | 0] << 16 | ye[g + 30 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = S, $[h + 11 | 0] < 0 && Sr(e[h >> 2]), $[y + 11 | 0] < 0 && Sr(e[y >> 2]), $[c + 11 | 0] >= 0)
                                                                                break t;
                                                                              Sr(e[c >> 2]);
                                                                              break t;
                                                                            }
                                                                            r = Vr() | 0;
                                                                            break e;
                                                                          }
                                                                          r = Vr() | 0;
                                                                          break w;
                                                                        }
                                                                        r = Vr() | 0;
                                                                        break b;
                                                                      }
                                                                      r = Vr() | 0;
                                                                      break h;
                                                                    }
                                                                    if (r = Vr() | 0, $[g + 107 | 0] >= 0)
                                                                      break h;
                                                                    Sr(e[g + 96 >> 2]);
                                                                  }
                                                                  if ($[g + 91 | 0] >= 0)
                                                                    break b;
                                                                  Sr(e[g + 80 >> 2]);
                                                                }
                                                                if ($[g + 75 | 0] >= 0)
                                                                  break w;
                                                                Sr(e[g + 64 >> 2]);
                                                              }
                                                              if ($[g + 59 | 0] >= 0)
                                                                break e;
                                                              Sr(e[g + 48 >> 2]);
                                                              break e;
                                                            }
                                                            e[5996] = 0, o = On(97, g + 116 | 0, 5251) | 0, c = e[5996], e[5996] = 0;
                                                            w: {
                                                              b: {
                                                                h: {
                                                                  x: {
                                                                    m: {
                                                                      B: {
                                                                        R: {
                                                                          E: {
                                                                            C: {
                                                                              y: {
                                                                                D: {
                                                                                  if ((c | 0) != 1) {
                                                                                    if (e[g + 16 >> 2] = e[o + 8 >> 2], c = e[o + 4 >> 2], e[g + 8 >> 2] = e[o >> 2], e[g + 12 >> 2] = c, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, c = e[h >> 2], y = e[h + 4 >> 2], o = ye[h + 11 | 0], e[5996] = 0, G = c, c = o << 24 >> 24 < 0, c = Si(100, g + 8 | 0, (c ? G : h) | 0, (c ? y : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                      break D;
                                                                                    if (e[g + 32 >> 2] = e[c + 8 >> 2], o = e[c + 4 >> 2], e[g + 24 >> 2] = e[c >> 2], e[g + 28 >> 2] = o, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, e[5996] = 0, y = On(97, g + 24 | 0, 4354) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                      break y;
                                                                                    if (e[g + 56 >> 2] = e[y + 8 >> 2], o = e[y + 4 >> 2], e[g + 48 >> 2] = e[y >> 2], e[g + 52 >> 2] = o, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, S = e[h + 16 >> 2], G = e[h + 12 >> 2], o = ye[h + 23 | 0], e[5996] = 0, ke = G, G = o << 24 >> 24 < 0, S = Si(100, g + 48 | 0, (G ? ke : h + 12 | 0) | 0, (G ? S : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                      break C;
                                                                                    if (e[g + 72 >> 2] = e[S + 8 >> 2], o = e[S + 4 >> 2], e[g + 64 >> 2] = e[S >> 2], e[g + 68 >> 2] = o, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, e[5996] = 0, G = On(97, g - -64 | 0, 4354) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                      break E;
                                                                                    if (e[g + 88 >> 2] = e[G + 8 >> 2], o = e[G + 4 >> 2], e[g + 80 >> 2] = e[G >> 2], e[g + 84 >> 2] = o, e[G >> 2] = 0, e[G + 4 >> 2] = 0, e[G + 8 >> 2] = 0, ke = e[h + 28 >> 2], Fe = e[h + 24 >> 2], o = ye[h + 35 | 0], e[5996] = 0, Ar = h + 24 | 0, h = o << 24 >> 24 < 0, h = Si(100, g + 80 | 0, (h ? Fe : Ar) | 0, (h ? ke : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                      break R;
                                                                                    if (e[g + 104 >> 2] = e[h + 8 >> 2], o = e[h + 4 >> 2], e[g + 96 >> 2] = e[h >> 2], e[g + 100 >> 2] = o, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, o = On(97, g + 96 | 0, 5242) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                      break B;
                                                                                    if (Fe = e[o >> 2], e[g + 40 >> 2] = e[o + 4 >> 2], ke = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 43 | 0] = ke, $[g + 44 | 0] = ke >>> 8, $[g + 45 | 0] = ke >>> 16, $[g + 46 | 0] = ke >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, ke = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = Fe, e[r + 4 >> 2] = e[g + 40 >> 2], o = ye[g + 43 | 0] | ye[g + 44 | 0] << 8 | (ye[g + 45 | 0] << 16 | ye[g + 46 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = ke, $[h + 11 | 0] < 0 && Sr(e[h >> 2]), $[G + 11 | 0] < 0 && Sr(e[G >> 2]), $[S + 11 | 0] < 0 && Sr(e[S >> 2]), $[y + 11 | 0] < 0 && Sr(e[y >> 2]), $[c + 11 | 0] >= 0)
                                                                                      break t;
                                                                                    Sr(e[c >> 2]);
                                                                                    break t;
                                                                                  }
                                                                                  r = Vr() | 0;
                                                                                  break e;
                                                                                }
                                                                                r = Vr() | 0;
                                                                                break w;
                                                                              }
                                                                              r = Vr() | 0;
                                                                              break b;
                                                                            }
                                                                            r = Vr() | 0;
                                                                            break h;
                                                                          }
                                                                          r = Vr() | 0;
                                                                          break x;
                                                                        }
                                                                        r = Vr() | 0;
                                                                        break m;
                                                                      }
                                                                      if (r = Vr() | 0, $[g + 107 | 0] >= 0)
                                                                        break m;
                                                                      Sr(e[g + 96 >> 2]);
                                                                    }
                                                                    if ($[g + 91 | 0] >= 0)
                                                                      break x;
                                                                    Sr(e[g + 80 >> 2]);
                                                                  }
                                                                  if ($[g + 75 | 0] >= 0)
                                                                    break h;
                                                                  Sr(e[g + 64 >> 2]);
                                                                }
                                                                if ($[g + 59 | 0] >= 0)
                                                                  break b;
                                                                Sr(e[g + 48 >> 2]);
                                                              }
                                                              if ($[g + 35 | 0] >= 0)
                                                                break w;
                                                              Sr(e[g + 24 >> 2]);
                                                            }
                                                            if ($[g + 19 | 0] >= 0)
                                                              break e;
                                                            Sr(e[g + 8 >> 2]);
                                                            break e;
                                                          }
                                                          if (e[5996] = 0, o = On(97, g + 116 | 0, 5289) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                            break A;
                                                          if (e[g + 72 >> 2] = e[o + 8 >> 2], h = e[o + 4 >> 2], e[g + 64 >> 2] = e[o >> 2], e[g + 68 >> 2] = h, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[5996] = 0, o = g + 96 | 0, di(119, o | 0, c + 4 | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                            break I;
                                                          if (e[5996] = 0, y = o, o = ye[g + 107 | 0], h = o << 24 >> 24 < 0, o = Si(100, g - -64 | 0, (h ? e[g + 96 >> 2] : y) | 0, (h ? e[g + 100 >> 2] : o) | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                            break k;
                                                          e[g + 88 >> 2] = e[o + 8 >> 2], h = e[o + 4 >> 2], e[g + 80 >> 2] = e[o >> 2], e[g + 84 >> 2] = h, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0;
                                                          v: {
                                                            if ($[g + 107 | 0] >= 0 || (Sr(e[g + 96 >> 2]), $[o + 11 | 0] >= 0))
                                                              break v;
                                                            Sr(e[o >> 2]);
                                                          }
                                                          v: {
                                                            w: {
                                                              b: {
                                                                h: {
                                                                  x: {
                                                                    if (o = e[c + 8 >> 2], h = e[c + 12 >> 2], (o | 0) != (h | 0))
                                                                      for (; ; ) {
                                                                        m: {
                                                                          if ($[o + 11 | 0] >= 0) {
                                                                            e[g + 104 >> 2] = e[o + 8 >> 2], c = e[o + 4 >> 2], e[g + 96 >> 2] = e[o >> 2], e[g + 100 >> 2] = c;
                                                                            break m;
                                                                          }
                                                                          if (c = e[o + 4 >> 2], y = e[o >> 2], e[5996] = 0, as(40, g + 96 | 0, y | 0, c | 0), c = e[5996], e[5996] = 0, (c | 0) != 1)
                                                                            break m;
                                                                          r = Vr() | 0;
                                                                          break w;
                                                                        }
                                                                        if (e[5996] = 0, $[g + 108 | 0] = 1, c = Si(99, g + 96 | 0, 0, 4354) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                          break x;
                                                                        if (e[g + 56 >> 2] = e[c + 8 >> 2], y = e[c + 4 >> 2], e[g + 48 >> 2] = e[c >> 2], e[g + 52 >> 2] = y, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, e[5996] = 0, y = ye[g + 59 | 0], S = y << 24 >> 24 < 0, Si(100, g + 80 | 0, (S ? e[g + 48 >> 2] : g + 48 | 0) | 0, (S ? e[g + 52 >> 2] : y) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                          break h;
                                                                        if ($[g + 59 | 0] < 0 && Sr(e[g + 48 >> 2]), !ye[g + 108 | 0] | $[g + 107 | 0] >= 0 || Sr(e[c >> 2]), o = o + 12 | 0, (h | 0) == (o | 0))
                                                                          break;
                                                                      }
                                                                    if (e[5996] = 0, o = On(97, g + 80 | 0, 5242) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1)
                                                                      break v;
                                                                    r = Vr() | 0;
                                                                    break w;
                                                                  }
                                                                  r = Vr() | 0;
                                                                  break b;
                                                                }
                                                                if (r = Vr() | 0, $[g + 59 | 0] >= 0)
                                                                  break b;
                                                                Sr(e[g + 48 >> 2]);
                                                              }
                                                              if (!ye[g + 108 | 0] | $[g + 107 | 0] >= 0)
                                                                break w;
                                                              Sr(e[g + 96 >> 2]);
                                                            }
                                                            if ($[g + 91 | 0] >= 0)
                                                              break e;
                                                            Sr(e[g + 80 >> 2]);
                                                            break e;
                                                          }
                                                          h = e[o >> 2], e[g + 48 >> 2] = e[o + 4 >> 2], c = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 51 | 0] = c, $[g + 52 | 0] = c >>> 8, $[g + 53 | 0] = c >>> 16, $[g + 54 | 0] = c >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, c = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = h, e[r + 4 >> 2] = e[g + 48 >> 2], o = ye[g + 51 | 0] | ye[g + 52 | 0] << 8 | (ye[g + 53 | 0] << 16 | ye[g + 54 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = c;
                                                          break t;
                                                        }
                                                        r = Vr() | 0;
                                                        break e;
                                                      }
                                                      if (e[5996] = 0, Qs(44, 2350, 2210, 725, 5107), r = e[5996], e[5996] = 0, (r | 0) == 1) {
                                                        r = Vr() | 0;
                                                        break e;
                                                      }
                                                      ri();
                                                    }
                                                    e[5996] = 0, o = On(97, g + 116 | 0, 5302) | 0, S = e[5996], e[5996] = 0;
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              b: {
                                                                h: {
                                                                  if ((S | 0) != 1) {
                                                                    if (e[g + 88 >> 2] = e[o + 8 >> 2], S = e[o + 4 >> 2], e[g + 80 >> 2] = e[o >> 2], e[g + 84 >> 2] = S, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[5996] = 0, o = g - -64 | 0, di(119, o | 0, c + 4 | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                      break h;
                                                                    if (e[5996] = 0, G = o, o = ye[g + 75 | 0], c = o << 24 >> 24 < 0, o = Si(100, g + 80 | 0, (c ? e[g + 64 >> 2] : G) | 0, (c ? e[g + 68 >> 2] : o) | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                      break b;
                                                                    e[g + 104 >> 2] = e[o + 8 >> 2], c = e[o + 4 >> 2], e[g + 96 >> 2] = e[o >> 2], e[g + 100 >> 2] = c, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0;
                                                                    x: {
                                                                      if ($[g + 75 | 0] >= 0 || (Sr(e[g + 64 >> 2]), $[o + 11 | 0] >= 0))
                                                                        break x;
                                                                      Sr(e[o >> 2]);
                                                                    }
                                                                    if (y)
                                                                      for (c = vi(y, 12) + h | 0; ; ) {
                                                                        if (e[5996] = 0, o = Si(99, h | 0, 0, 4354) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                          break v;
                                                                        if (e[g + 72 >> 2] = e[o + 8 >> 2], h = e[o + 4 >> 2], e[g + 64 >> 2] = e[o >> 2], e[g + 68 >> 2] = h, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[5996] = 0, h = ye[g + 75 | 0], y = h << 24 >> 24 < 0, Si(100, g + 96 | 0, (y ? e[g + 64 >> 2] : g - -64 | 0) | 0, (y ? e[g + 68 >> 2] : h) | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                          break T;
                                                                        if ($[g + 75 | 0] < 0 && Sr(e[g + 64 >> 2]), h = o + 12 | 0, (c | 0) == (h | 0))
                                                                          break;
                                                                      }
                                                                    if (e[5996] = 0, o = On(97, g + 96 | 0, 5242) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                      break S;
                                                                    h = e[o >> 2], e[g + 64 >> 2] = e[o + 4 >> 2], c = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 67 | 0] = c, $[g + 68 | 0] = c >>> 8, $[g + 69 | 0] = c >>> 16, $[g + 70 | 0] = c >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, c = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = h, e[r + 4 >> 2] = e[g + 64 >> 2], o = ye[g + 67 | 0] | ye[g + 68 | 0] << 8 | (ye[g + 69 | 0] << 16 | ye[g + 70 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = c;
                                                                    break t;
                                                                  }
                                                                  r = Vr() | 0;
                                                                  break e;
                                                                }
                                                                r = Vr() | 0;
                                                                break w;
                                                              }
                                                              if (r = Vr() | 0, $[g + 75 | 0] >= 0)
                                                                break w;
                                                              Sr(e[g + 64 >> 2]);
                                                            }
                                                            if ($[g + 91 | 0] >= 0)
                                                              break e;
                                                            Sr(e[g + 80 >> 2]);
                                                            break e;
                                                          }
                                                          r = Vr() | 0;
                                                          break N;
                                                        }
                                                        if (r = Vr() | 0, $[g + 75 | 0] >= 0)
                                                          break N;
                                                        Sr(e[g + 64 >> 2]);
                                                        break N;
                                                      }
                                                      r = Vr() | 0;
                                                    }
                                                    if ($[g + 107 | 0] >= 0)
                                                      break e;
                                                    Sr(e[g + 96 >> 2]);
                                                    break e;
                                                  }
                                                  if (r = Vr() | 0, $[g + 107 | 0] >= 0)
                                                    break p;
                                                  Sr(e[g + 96 >> 2]);
                                                  break p;
                                                }
                                                r = Vr() | 0;
                                              }
                                              if ($[g + 75 | 0] >= 0)
                                                break e;
                                              Sr(e[g + 64 >> 2]);
                                              break e;
                                            }
                                            r = Vr() | 0;
                                            break e;
                                          }
                                          r = Vr() | 0;
                                        }
                                        if ($[g + 75 | 0] < 0 && Sr(e[g + 64 >> 2]), $[g + 91 | 0] >= 0)
                                          break e;
                                        Sr(e[g + 80 >> 2]);
                                        break e;
                                      }
                                      r = Vr() | 0;
                                    }
                                    if ($[g + 75 | 0] < 0 && Sr(e[g + 64 >> 2]), $[g + 91 | 0] >= 0)
                                      break e;
                                    Sr(e[g + 80 >> 2]);
                                    break e;
                                  }
                                  r = Vr() | 0;
                                }
                                if ($[g + 75 | 0] < 0 && Sr(e[g + 64 >> 2]), $[g + 91 | 0] >= 0)
                                  break e;
                                Sr(e[g + 80 >> 2]);
                                break e;
                              }
                              r = Vr() | 0;
                            }
                            if ($[g + 75 | 0] < 0 && Sr(e[g + 64 >> 2]), $[g + 91 | 0] >= 0)
                              break e;
                            Sr(e[g + 80 >> 2]);
                            break e;
                          }
                          e[5996] = 0, $[g + 108 | 0] = 1, o = On(97, g + 116 | 0, 5315) | 0, c = e[5996], e[5996] = 0;
                          s: {
                            a: {
                              o: {
                                l: {
                                  if ((c | 0) != 1) {
                                    if (e[g + 72 >> 2] = e[o + 8 >> 2], c = e[o + 4 >> 2], e[g + 64 >> 2] = e[o >> 2], e[g + 68 >> 2] = c, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[5996] = 0, o = ye[g + 107 | 0], c = o << 24 >> 24 < 0, c = Si(100, g - -64 | 0, (c ? e[g + 96 >> 2] : g + 96 | 0) | 0, (c ? e[g + 100 >> 2] : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                      break l;
                                    if (e[g + 88 >> 2] = e[c + 8 >> 2], o = e[c + 4 >> 2], e[g + 80 >> 2] = e[c >> 2], e[g + 84 >> 2] = o, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, e[5996] = 0, o = On(97, g + 80 | 0, 5242) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                      break o;
                                    if (y = e[o >> 2], e[g + 48 >> 2] = e[o + 4 >> 2], h = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 51 | 0] = h, $[g + 52 | 0] = h >>> 8, $[g + 53 | 0] = h >>> 16, $[g + 54 | 0] = h >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, h = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = y, e[r + 4 >> 2] = e[g + 48 >> 2], o = ye[g + 51 | 0] | ye[g + 52 | 0] << 8 | (ye[g + 53 | 0] << 16 | ye[g + 54 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = h, $[c + 11 | 0] < 0 && Sr(e[c >> 2]), !ye[g + 108 | 0] | $[g + 107 | 0] >= 0)
                                      break t;
                                    Sr(e[g + 96 >> 2]);
                                    break t;
                                  }
                                  r = Vr() | 0;
                                  break s;
                                }
                                r = Vr() | 0;
                                break a;
                              }
                              if (r = Vr() | 0, $[g + 91 | 0] >= 0)
                                break a;
                              Sr(e[g + 80 >> 2]);
                            }
                            if ($[g + 75 | 0] >= 0)
                              break s;
                            Sr(e[g + 64 >> 2]);
                          }
                          if (!ye[g + 108 | 0] | $[g + 107 | 0] >= 0)
                            break e;
                          Sr(e[g + 96 >> 2]);
                          break e;
                        }
                        e[5996] = 0, $[g + 108 | 0] = 1, o = On(97, g + 116 | 0, 5283) | 0, c = e[5996], e[5996] = 0;
                        i: {
                          s: {
                            a: {
                              o: {
                                if ((c | 0) != 1) {
                                  if (e[g + 72 >> 2] = e[o + 8 >> 2], c = e[o + 4 >> 2], e[g + 64 >> 2] = e[o >> 2], e[g + 68 >> 2] = c, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[5996] = 0, o = ye[g + 107 | 0], c = o << 24 >> 24 < 0, c = Si(100, g - -64 | 0, (c ? e[g + 96 >> 2] : g + 96 | 0) | 0, (c ? e[g + 100 >> 2] : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                    break o;
                                  if (e[g + 88 >> 2] = e[c + 8 >> 2], o = e[c + 4 >> 2], e[g + 80 >> 2] = e[c >> 2], e[g + 84 >> 2] = o, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, e[5996] = 0, o = On(97, g + 80 | 0, 5242) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                    break a;
                                  if (y = e[o >> 2], e[g + 48 >> 2] = e[o + 4 >> 2], h = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 51 | 0] = h, $[g + 52 | 0] = h >>> 8, $[g + 53 | 0] = h >>> 16, $[g + 54 | 0] = h >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, h = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = y, e[r + 4 >> 2] = e[g + 48 >> 2], o = ye[g + 51 | 0] | ye[g + 52 | 0] << 8 | (ye[g + 53 | 0] << 16 | ye[g + 54 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = h, $[c + 11 | 0] < 0 && Sr(e[c >> 2]), !ye[g + 108 | 0] | $[g + 107 | 0] >= 0)
                                    break t;
                                  Sr(e[g + 96 >> 2]);
                                  break t;
                                }
                                r = Vr() | 0;
                                break i;
                              }
                              r = Vr() | 0;
                              break s;
                            }
                            if (r = Vr() | 0, $[g + 91 | 0] >= 0)
                              break s;
                            Sr(e[g + 80 >> 2]);
                          }
                          if ($[g + 75 | 0] >= 0)
                            break i;
                          Sr(e[g + 64 >> 2]);
                        }
                        if (!ye[g + 108 | 0] | $[g + 107 | 0] >= 0)
                          break e;
                        Sr(e[g + 96 >> 2]);
                        break e;
                      }
                      e[5996] = 0, $[g + 108 | 0] = 1, o = On(97, g + 116 | 0, 5310) | 0, c = e[5996], e[5996] = 0;
                      n: {
                        i: {
                          s: {
                            a: {
                              if ((c | 0) != 1) {
                                if (e[g + 72 >> 2] = e[o + 8 >> 2], c = e[o + 4 >> 2], e[g + 64 >> 2] = e[o >> 2], e[g + 68 >> 2] = c, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[5996] = 0, o = ye[g + 107 | 0], c = o << 24 >> 24 < 0, c = Si(100, g - -64 | 0, (c ? e[g + 96 >> 2] : g + 96 | 0) | 0, (c ? e[g + 100 >> 2] : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                  break a;
                                if (e[g + 88 >> 2] = e[c + 8 >> 2], o = e[c + 4 >> 2], e[g + 80 >> 2] = e[c >> 2], e[g + 84 >> 2] = o, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, e[5996] = 0, o = On(97, g + 80 | 0, 5242) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                  break s;
                                if (y = e[o >> 2], e[g + 48 >> 2] = e[o + 4 >> 2], h = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 51 | 0] = h, $[g + 52 | 0] = h >>> 8, $[g + 53 | 0] = h >>> 16, $[g + 54 | 0] = h >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, h = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = y, e[r + 4 >> 2] = e[g + 48 >> 2], o = ye[g + 51 | 0] | ye[g + 52 | 0] << 8 | (ye[g + 53 | 0] << 16 | ye[g + 54 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = h, $[c + 11 | 0] < 0 && Sr(e[c >> 2]), !ye[g + 108 | 0] | $[g + 107 | 0] >= 0)
                                  break t;
                                Sr(e[g + 96 >> 2]);
                                break t;
                              }
                              r = Vr() | 0;
                              break n;
                            }
                            r = Vr() | 0;
                            break i;
                          }
                          if (r = Vr() | 0, $[g + 91 | 0] >= 0)
                            break i;
                          Sr(e[g + 80 >> 2]);
                        }
                        if ($[g + 75 | 0] >= 0)
                          break n;
                        Sr(e[g + 64 >> 2]);
                      }
                      if (!ye[g + 108 | 0] | $[g + 107 | 0] >= 0)
                        break e;
                      Sr(e[g + 96 >> 2]);
                      break e;
                    }
                    e[5996] = 0, $[g + 108 | 0] = 1, o = On(97, g + 116 | 0, 5279) | 0, c = e[5996], e[5996] = 0;
                    r: {
                      n: {
                        i: {
                          s: {
                            if ((c | 0) != 1) {
                              if (e[g + 72 >> 2] = e[o + 8 >> 2], c = e[o + 4 >> 2], e[g + 64 >> 2] = e[o >> 2], e[g + 68 >> 2] = c, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[5996] = 0, o = ye[g + 107 | 0], c = o << 24 >> 24 < 0, c = Si(100, g - -64 | 0, (c ? e[g + 96 >> 2] : g + 96 | 0) | 0, (c ? e[g + 100 >> 2] : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                break s;
                              if (e[g + 88 >> 2] = e[c + 8 >> 2], o = e[c + 4 >> 2], e[g + 80 >> 2] = e[c >> 2], e[g + 84 >> 2] = o, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, e[5996] = 0, o = On(97, g + 80 | 0, 5242) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                break i;
                              if (y = e[o >> 2], e[g + 48 >> 2] = e[o + 4 >> 2], h = ye[o + 7 | 0] | ye[o + 8 | 0] << 8 | (ye[o + 9 | 0] << 16 | ye[o + 10 | 0] << 24), $[g + 51 | 0] = h, $[g + 52 | 0] = h >>> 8, $[g + 53 | 0] = h >>> 16, $[g + 54 | 0] = h >>> 24, e[o >> 2] = 0, e[o + 4 >> 2] = 0, h = ye[o + 11 | 0], e[o + 8 >> 2] = 0, e[r >> 2] = y, e[r + 4 >> 2] = e[g + 48 >> 2], o = ye[g + 51 | 0] | ye[g + 52 | 0] << 8 | (ye[g + 53 | 0] << 16 | ye[g + 54 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 12 | 0] = 1, $[r + 11 | 0] = h, $[c + 11 | 0] < 0 && Sr(e[c >> 2]), !ye[g + 108 | 0] | $[g + 107 | 0] >= 0)
                                break t;
                              Sr(e[g + 96 >> 2]);
                              break t;
                            }
                            r = Vr() | 0;
                            break r;
                          }
                          r = Vr() | 0;
                          break n;
                        }
                        if (r = Vr() | 0, $[g + 91 | 0] >= 0)
                          break n;
                        Sr(e[g + 80 >> 2]);
                      }
                      if ($[g + 75 | 0] >= 0)
                        break r;
                      Sr(e[g + 64 >> 2]);
                    }
                    if (!ye[g + 108 | 0] | $[g + 107 | 0] >= 0)
                      break e;
                    Sr(e[g + 96 >> 2]);
                    break e;
                  }
                  $[g + 127 | 0] < 0 && Sr(e[g + 116 >> 2]), Yr = g + 128 | 0;
                  return;
                }
                $[g + 127 | 0] < 0 && Sr(e[g + 116 >> 2]), Ki(r | 0), ri();
              }
              function P1(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0;
                var g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0;
                G = Yr - 112 | 0, Yr = G;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  f:
                                    switch (e[c >> 2]) {
                                      case 2:
                                        if (g = e[c + 8 >> 2], c = xs(4), e[G + 48 >> 2] = c, o = c + 4 | 0, e[G + 56 >> 2] = o, $[c | 0] = 2, $[c + 1 | 0] = 80, $[c + 2 | 0] = 75, $[c + 3 | 0] = 98, e[G + 52 >> 2] = o, e[5996] = 0, $[G + 16 | 0] = 0, h = G + 48 | 0, as(126, h | 0, 29, G + 16 | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                          break r;
                                        if (y = e[G + 48 >> 2], c = ye[g + 11 | 0], o = c << 24 >> 24 < 0, Ks(y + 4 | 0, o ? e[g >> 2] : g, o ? e[g + 4 >> 2] : c), $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, $[r | 0] = 0, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 4 | 0] = 0, $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, e[5996] = 0, On(19, r | 0, h | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1) {
                                          if (S = Vr() | 0, (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) >>> 0 >= 29 && (Sr(ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)), $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0), !y)
                                            break e;
                                          Sr(y);
                                          break e;
                                        }
                                        if (!y)
                                          break n;
                                        Sr(y);
                                        break n;
                                      case 3:
                                        if (h = e[c + 8 >> 2], c = xs(3), e[G + 48 >> 2] = c, o = c + 3 | 0, e[G + 56 >> 2] = o, $[c + 2 | 0] = 104, $[c | 0] = 80, $[c + 1 | 0] = 75, e[G + 52 >> 2] = o, e[5996] = 0, $[G + 16 | 0] = 0, as(126, G + 48 | 0, 17, G + 16 | 0), o = e[5996], e[5996] = 0, (o | 0) == 1) {
                                          if (S = Vr() | 0, r = e[G + 48 >> 2], !r)
                                            break e;
                                          Sr(r);
                                          break e;
                                        }
                                        if (g = e[G + 48 >> 2], c = ye[h + 11 | 0], o = c << 24 >> 24 < 0, Ks(g + 3 | 0, o ? e[h >> 2] : h, o ? e[h + 4 >> 2] : c), $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, $[r | 0] = 2, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 4 | 0] = 118, $[r + 5 | 0] = 169, e[5996] = 0, ke = On(19, r | 0, G + 48 | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)
                                          d: {
                                            if (S = ye[ke | 0] | ye[ke + 1 | 0] << 8 | (ye[ke + 2 | 0] << 16 | ye[ke + 3 | 0] << 24), y = S - 29 | 0, c = S >>> 0 < 29 ? S : y, o = c + 1 | 0, h = r + 4 | 0, o >>> 0 > (S >>> 0 <= 28 ? 28 : ye[h | 0] | ye[h + 1 | 0] << 8 | (ye[h + 2 | 0] << 16 | ye[h + 3 | 0] << 24)) >>> 0) {
                                              if (e[5996] = 0, di(124, ke | 0, o + (o >>> 1 | 0) | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                break d;
                                              S = ye[ke | 0] | ye[ke + 1 | 0] << 8 | (ye[ke + 2 | 0] << 16 | ye[ke + 3 | 0] << 24), y = S - 29 | 0;
                                            }
                                            if (o = ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24), r = S >>> 0 < 29, o = c + (r ? h : o) | 0, Ks(o + 1 | 0, o, (r ? S : y) - c | 0), r = (ye[ke | 0] | ye[ke + 1 | 0] << 8 | (ye[ke + 2 | 0] << 16 | ye[ke + 3 | 0] << 24)) + 1 | 0, $[ke | 0] = r, $[ke + 1 | 0] = r >>> 8, $[ke + 2 | 0] = r >>> 16, $[ke + 3 | 0] = r >>> 24, $[o | 0] = 136, !g)
                                              break n;
                                            Sr(g);
                                            break n;
                                          }
                                        if (S = Vr() | 0, (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) >>> 0 >= 29 && (Sr(ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)), $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0), !g)
                                          break e;
                                        Sr(g);
                                        break e;
                                      case 4:
                                        if ($[r | 0] = 0, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 4 | 0] = 0, $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, o = e[c + 4 >> 2], e[5996] = 0, y = zc(r, o, 0), o = e[5996], e[5996] = 0, (o | 0) != 1)
                                          d: {
                                            if (g = ye[y | 0] | ye[y + 1 | 0] << 8 | (ye[y + 2 | 0] << 16 | ye[y + 3 | 0] << 24), o = g - 29 | 0, h = g >>> 0 < 29 ? g : o, c = h + 1 | 0, c >>> 0 > (g >>> 0 <= 28 ? 28 : ye[y + 4 | 0] | ye[y + 5 | 0] << 8 | (ye[y + 6 | 0] << 16 | ye[y + 7 | 0] << 24)) >>> 0) {
                                              if (e[5996] = 0, di(124, y | 0, c + (c >>> 1 | 0) | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                break d;
                                              g = ye[y | 0] | ye[y + 1 | 0] << 8 | (ye[y + 2 | 0] << 16 | ye[y + 3 | 0] << 24), o = g - 29 | 0;
                                            }
                                            r = g >>> 0 < 29, c = h + (r ? y + 4 | 0 : ye[y + 8 | 0] | ye[y + 9 | 0] << 8 | (ye[y + 10 | 0] << 16 | ye[y + 11 | 0] << 24)) | 0, Ks(c + 1 | 0, c, (r ? g : o) - h | 0), r = (ye[y | 0] | ye[y + 1 | 0] << 8 | (ye[y + 2 | 0] << 16 | ye[y + 3 | 0] << 24)) + 1 | 0, $[y | 0] = r, $[y + 1 | 0] = r >>> 8, $[y + 2 | 0] = r >>> 16, $[y + 3 | 0] = r >>> 24, $[c | 0] = 178;
                                            break n;
                                          }
                                        break t;
                                      case 5:
                                        if ($[r | 0] = 0, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 4 | 0] = 0, $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, o = e[c + 4 >> 2], e[5996] = 0, y = zc(r, o, 0), o = e[5996], e[5996] = 0, (o | 0) != 1)
                                          d: {
                                            if (g = ye[y | 0] | ye[y + 1 | 0] << 8 | (ye[y + 2 | 0] << 16 | ye[y + 3 | 0] << 24), o = g - 29 | 0, h = g >>> 0 < 29 ? g : o, c = h + 1 | 0, c >>> 0 > (g >>> 0 <= 28 ? 28 : ye[y + 4 | 0] | ye[y + 5 | 0] << 8 | (ye[y + 6 | 0] << 16 | ye[y + 7 | 0] << 24)) >>> 0) {
                                              if (e[5996] = 0, di(124, y | 0, c + (c >>> 1 | 0) | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                break d;
                                              g = ye[y | 0] | ye[y + 1 | 0] << 8 | (ye[y + 2 | 0] << 16 | ye[y + 3 | 0] << 24), o = g - 29 | 0;
                                            }
                                            r = g >>> 0 < 29, c = h + (r ? y + 4 | 0 : ye[y + 8 | 0] | ye[y + 9 | 0] << 8 | (ye[y + 10 | 0] << 16 | ye[y + 11 | 0] << 24)) | 0, Ks(c + 1 | 0, c, (r ? g : o) - h | 0), r = (ye[y | 0] | ye[y + 1 | 0] << 8 | (ye[y + 2 | 0] << 16 | ye[y + 3 | 0] << 24)) + 1 | 0, $[y | 0] = r, $[y + 1 | 0] = r >>> 8, $[y + 2 | 0] = r >>> 16, $[y + 3 | 0] = r >>> 24, $[c | 0] = 177;
                                            break n;
                                          }
                                        break t;
                                      case 8:
                                        e[G + 48 >> 2] = 32, e[G + 16 >> 2] = 136, e[G + 80 >> 2] = 166, e[G + 4 >> 2] = o ? 136 : 135, Vf(r, G + 48 | 0, G + 16 | 0, G + 80 | 0, c + 20 | 0, G + 4 | 0);
                                        break n;
                                      case 7:
                                        e[G + 48 >> 2] = 32, e[G + 16 >> 2] = 136, e[G + 80 >> 2] = 170, e[G + 4 >> 2] = o ? 136 : 135, Vf(r, G + 48 | 0, G + 16 | 0, G + 80 | 0, c + 20 | 0, G + 4 | 0);
                                        break n;
                                      case 9:
                                        e[G + 48 >> 2] = 32, e[G + 16 >> 2] = 136, e[G + 80 >> 2] = 169, e[G + 4 >> 2] = o ? 136 : 135, Vf(r, G + 48 | 0, G + 16 | 0, G + 80 | 0, c + 20 | 0, G + 4 | 0);
                                        break n;
                                      case 10:
                                        $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 4 | 0] = 107, $[r | 0] = 1, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, c = ye[h + 8 | 0] | ye[h + 9 | 0] << 8 | (ye[h + 10 | 0] << 16 | ye[h + 11 | 0] << 24), y = -28, g = 1, o = ye[h | 0] | ye[h + 1 | 0] << 8 | (ye[h + 2 | 0] << 16 | ye[h + 3 | 0] << 24), hr = o >>> 0 < 29;
                                        d: {
                                          if (Fe = hr ? o : o - 29 | 0, o = Fe + 1 | 0, o >>> 0 >= 29) {
                                            if (e[5996] = 0, di(124, r | 0, o + (o >>> 1 | 0) | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                              break d;
                                            ln = ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24), g = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), y = g - 29 | 0;
                                          }
                                          ke = r + 4 | 0, o = g >>> 0 < 29, S = (o ? ke : ln) + 1 | 0, Ks(Fe + S | 0, S, (o ? g : y) - 1 | 0), o = Fe + (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) | 0, $[r | 0] = o, $[r + 1 | 0] = o >>> 8, $[r + 2 | 0] = o >>> 16, $[r + 3 | 0] = o >>> 24;
                                          c: {
                                            if (!Fe)
                                              break c;
                                            o = hr ? h + 4 | 0 : c, c = Fe & 7;
                                            u: {
                                              if (!c) {
                                                g = o;
                                                break u;
                                              }
                                              for (h = 0, g = o; $[S | 0] = ye[g | 0], g = g + 1 | 0, S = S + 1 | 0, h = h + 1 | 0, (c | 0) != (h | 0); )
                                                ;
                                            }
                                            if (Fe >>> 0 < 8)
                                              break c;
                                            for (o = o + Fe | 0; $[S | 0] = ye[g | 0], $[S + 1 | 0] = ye[g + 1 | 0], $[S + 2 | 0] = ye[g + 2 | 0], $[S + 3 | 0] = ye[g + 3 | 0], $[S + 4 | 0] = ye[g + 4 | 0], $[S + 5 | 0] = ye[g + 5 | 0], $[S + 6 | 0] = ye[g + 6 | 0], $[S + 7 | 0] = ye[g + 7 | 0], S = S + 8 | 0, g = g + 8 | 0, (o | 0) != (g | 0); )
                                              ;
                                          }
                                          if (S = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), ln = S - 29 | 0, h = S >>> 0 < 29 ? S : ln, o = h + 1 | 0, o >>> 0 > (S >>> 0 <= 28 ? 28 : ye[r + 4 | 0] | ye[r + 5 | 0] << 8 | (ye[r + 6 | 0] << 16 | ye[r + 7 | 0] << 24)) >>> 0) {
                                            if (e[5996] = 0, di(124, r | 0, o + (o >>> 1 | 0) | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                              break d;
                                            S = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), ln = S - 29 | 0;
                                          }
                                          o = S >>> 0 < 29, c = h + (o ? ke : ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)) | 0, Ks(c + 1 | 0, c, (o ? S : ln) - h | 0), o = (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) + 1 | 0, $[r | 0] = o, $[r + 1 | 0] = o >>> 8, $[r + 2 | 0] = o >>> 16, $[r + 3 | 0] = o >>> 24, $[c | 0] = 108;
                                          break n;
                                        }
                                        break t;
                                      case 11:
                                        $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 4 | 0] = 124, $[r | 0] = 1, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, c = ye[h + 8 | 0] | ye[h + 9 | 0] << 8 | (ye[h + 10 | 0] << 16 | ye[h + 11 | 0] << 24), y = -28, g = 1, o = ye[h | 0] | ye[h + 1 | 0] << 8 | (ye[h + 2 | 0] << 16 | ye[h + 3 | 0] << 24), ke = o >>> 0 < 29;
                                        d: {
                                          if (hr = ke ? o : o - 29 | 0, o = hr + 1 | 0, o >>> 0 >= 29) {
                                            if (e[5996] = 0, di(124, r | 0, o + (o >>> 1 | 0) | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                              break d;
                                            ln = ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24), g = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), y = g - 29 | 0;
                                          }
                                          if (o = g >>> 0 < 29, S = (o ? r + 4 | 0 : ln) + 1 | 0, Ks(hr + S | 0, S, (o ? g : y) - 1 | 0), o = hr + (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) | 0, $[r | 0] = o, $[r + 1 | 0] = o >>> 8, $[r + 2 | 0] = o >>> 16, $[r + 3 | 0] = o >>> 24, !hr)
                                            break n;
                                          r = ke ? h + 4 | 0 : c, o = hr & 7;
                                          c: {
                                            if (!o) {
                                              g = r;
                                              break c;
                                            }
                                            for (h = 0, g = r; $[S | 0] = ye[g | 0], g = g + 1 | 0, S = S + 1 | 0, h = h + 1 | 0, (o | 0) != (h | 0); )
                                              ;
                                          }
                                          if (hr >>> 0 < 8)
                                            break n;
                                          for (r = r + hr | 0; $[S | 0] = ye[g | 0], $[S + 1 | 0] = ye[g + 1 | 0], $[S + 2 | 0] = ye[g + 2 | 0], $[S + 3 | 0] = ye[g + 3 | 0], $[S + 4 | 0] = ye[g + 4 | 0], $[S + 5 | 0] = ye[g + 5 | 0], $[S + 6 | 0] = ye[g + 6 | 0], $[S + 7 | 0] = ye[g + 7 | 0], S = S + 8 | 0, g = g + 8 | 0, (r | 0) != (g | 0); )
                                            ;
                                          break n;
                                        }
                                        break t;
                                      case 12:
                                        e[G + 48 >> 2] = o ? 173 : 172, Fl(r, h, G + 48 | 0);
                                        break n;
                                      case 13:
                                        $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r | 0] = 2, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 4 | 0] = 118, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, $[r + 5 | 0] = 99, c = ye[h + 8 | 0] | ye[h + 9 | 0] << 8 | (ye[h + 10 | 0] << 16 | ye[h + 11 | 0] << 24), y = -27, g = 2, o = ye[h | 0] | ye[h + 1 | 0] << 8 | (ye[h + 2 | 0] << 16 | ye[h + 3 | 0] << 24), hr = o >>> 0 < 29;
                                        d: {
                                          if (Fe = hr ? o : o - 29 | 0, o = Fe + 2 | 0, o >>> 0 >= 29) {
                                            if (e[5996] = 0, di(124, r | 0, o + (o >>> 1 | 0) | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                              break d;
                                            ln = ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24), g = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), y = g - 29 | 0;
                                          }
                                          ke = r + 4 | 0, o = g >>> 0 < 29, S = (o ? ke : ln) + 2 | 0, Ks(Fe + S | 0, S, (o ? g : y) - 2 | 0), o = Fe + (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) | 0, $[r | 0] = o, $[r + 1 | 0] = o >>> 8, $[r + 2 | 0] = o >>> 16, $[r + 3 | 0] = o >>> 24;
                                          c: {
                                            if (!Fe)
                                              break c;
                                            o = hr ? h + 4 | 0 : c, c = Fe & 7;
                                            u: {
                                              if (!c) {
                                                g = o;
                                                break u;
                                              }
                                              for (h = 0, g = o; $[S | 0] = ye[g | 0], g = g + 1 | 0, S = S + 1 | 0, h = h + 1 | 0, (c | 0) != (h | 0); )
                                                ;
                                            }
                                            if (Fe >>> 0 < 8)
                                              break c;
                                            for (o = o + Fe | 0; $[S | 0] = ye[g | 0], $[S + 1 | 0] = ye[g + 1 | 0], $[S + 2 | 0] = ye[g + 2 | 0], $[S + 3 | 0] = ye[g + 3 | 0], $[S + 4 | 0] = ye[g + 4 | 0], $[S + 5 | 0] = ye[g + 5 | 0], $[S + 6 | 0] = ye[g + 6 | 0], $[S + 7 | 0] = ye[g + 7 | 0], S = S + 8 | 0, g = g + 8 | 0, (o | 0) != (g | 0); )
                                              ;
                                          }
                                          if (S = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), ln = S - 29 | 0, h = S >>> 0 < 29 ? S : ln, o = h + 1 | 0, o >>> 0 > (S >>> 0 <= 28 ? 28 : ye[r + 4 | 0] | ye[r + 5 | 0] << 8 | (ye[r + 6 | 0] << 16 | ye[r + 7 | 0] << 24)) >>> 0) {
                                            if (e[5996] = 0, di(124, r | 0, o + (o >>> 1 | 0) | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                              break d;
                                            S = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), ln = S - 29 | 0;
                                          }
                                          o = S >>> 0 < 29, c = h + (o ? ke : ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)) | 0, Ks(c + 1 | 0, c, (o ? S : ln) - h | 0), o = (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) + 1 | 0, $[r | 0] = o, $[r + 1 | 0] = o >>> 8, $[r + 2 | 0] = o >>> 16, $[r + 3 | 0] = o >>> 24, $[c | 0] = 104;
                                          break n;
                                        }
                                        break t;
                                      case 14:
                                        if (o = e[e[e[c + 32 >> 2] >> 2] + 80 >> 2], !(uu(1239, 1) & (o ^ -1))) {
                                          e[G + 48 >> 2] = 105, Fl(r, h, G + 48 | 0);
                                          break n;
                                        }
                                        $[r | 0] = 0, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 4 | 0] = 0, $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, e[G + 72 >> 2] = ye[r + 28 | 0] | ye[r + 29 | 0] << 8 | (ye[r + 30 | 0] << 16 | ye[r + 31 | 0] << 24), o = ye[r + 24 | 0] | ye[r + 25 | 0] << 8 | (ye[r + 26 | 0] << 16 | ye[r + 27 | 0] << 24), c = G - -64 | 0, e[c >> 2] = ye[r + 20 | 0] | ye[r + 21 | 0] << 8 | (ye[r + 22 | 0] << 16 | ye[r + 23 | 0] << 24), e[c + 4 >> 2] = o, o = ye[r + 16 | 0] | ye[r + 17 | 0] << 8 | (ye[r + 18 | 0] << 16 | ye[r + 19 | 0] << 24), e[G + 56 >> 2] = ye[r + 12 | 0] | ye[r + 13 | 0] << 8 | (ye[r + 14 | 0] << 16 | ye[r + 15 | 0] << 24), e[G + 60 >> 2] = o, o = ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24), e[G + 48 >> 2] = ye[r + 4 | 0] | ye[r + 5 | 0] << 8 | (ye[r + 6 | 0] << 16 | ye[r + 7 | 0] << 24), e[G + 52 >> 2] = o, o = ye[h + 28 | 0] | ye[h + 29 | 0] << 8 | (ye[h + 30 | 0] << 16 | ye[h + 31 | 0] << 24), $[r + 28 | 0] = o, $[r + 29 | 0] = o >>> 8, $[r + 30 | 0] = o >>> 16, $[r + 31 | 0] = o >>> 24, y = ye[h + 24 | 0] | ye[h + 25 | 0] << 8 | (ye[h + 26 | 0] << 16 | ye[h + 27 | 0] << 24), o = ye[h + 20 | 0] | ye[h + 21 | 0] << 8 | (ye[h + 22 | 0] << 16 | ye[h + 23 | 0] << 24), $[r + 20 | 0] = o, $[r + 21 | 0] = o >>> 8, $[r + 22 | 0] = o >>> 16, $[r + 23 | 0] = o >>> 24, $[r + 24 | 0] = y, $[r + 25 | 0] = y >>> 8, $[r + 26 | 0] = y >>> 16, $[r + 27 | 0] = y >>> 24, y = ye[h + 16 | 0] | ye[h + 17 | 0] << 8 | (ye[h + 18 | 0] << 16 | ye[h + 19 | 0] << 24), o = ye[h + 12 | 0] | ye[h + 13 | 0] << 8 | (ye[h + 14 | 0] << 16 | ye[h + 15 | 0] << 24), $[r + 12 | 0] = o, $[r + 13 | 0] = o >>> 8, $[r + 14 | 0] = o >>> 16, $[r + 15 | 0] = o >>> 24, $[r + 16 | 0] = y, $[r + 17 | 0] = y >>> 8, $[r + 18 | 0] = y >>> 16, $[r + 19 | 0] = y >>> 24, y = ye[h + 8 | 0] | ye[h + 9 | 0] << 8 | (ye[h + 10 | 0] << 16 | ye[h + 11 | 0] << 24), o = ye[h + 4 | 0] | ye[h + 5 | 0] << 8 | (ye[h + 6 | 0] << 16 | ye[h + 7 | 0] << 24), $[r + 4 | 0] = o, $[r + 5 | 0] = o >>> 8, $[r + 6 | 0] = o >>> 16, $[r + 7 | 0] = o >>> 24, $[r + 8 | 0] = y, $[r + 9 | 0] = y >>> 8, $[r + 10 | 0] = y >>> 16, $[r + 11 | 0] = y >>> 24, o = e[G + 72 >> 2], $[h + 28 | 0] = o, $[h + 29 | 0] = o >>> 8, $[h + 30 | 0] = o >>> 16, $[h + 31 | 0] = o >>> 24, y = e[c + 4 >> 2], o = e[c >> 2], $[h + 20 | 0] = o, $[h + 21 | 0] = o >>> 8, $[h + 22 | 0] = o >>> 16, $[h + 23 | 0] = o >>> 24, $[h + 24 | 0] = y, $[h + 25 | 0] = y >>> 8, $[h + 26 | 0] = y >>> 16, $[h + 27 | 0] = y >>> 24, c = e[G + 60 >> 2], o = e[G + 56 >> 2], $[h + 12 | 0] = o, $[h + 13 | 0] = o >>> 8, $[h + 14 | 0] = o >>> 16, $[h + 15 | 0] = o >>> 24, $[h + 16 | 0] = c, $[h + 17 | 0] = c >>> 8, $[h + 18 | 0] = c >>> 16, $[h + 19 | 0] = c >>> 24, c = e[G + 52 >> 2], o = e[G + 48 >> 2], $[h + 4 | 0] = o, $[h + 5 | 0] = o >>> 8, $[h + 6 | 0] = o >>> 16, $[h + 7 | 0] = o >>> 24, $[h + 8 | 0] = c, $[h + 9 | 0] = c >>> 8, $[h + 10 | 0] = c >>> 16, $[h + 11 | 0] = c >>> 24, e[r >> 2] = e[h >> 2], e[h >> 2] = 0;
                                        break n;
                                      case 15:
                                        if ($[r | 0] = 0, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 4 | 0] = 0, $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, e[5996] = 0, c = On(127, r | 0, 130) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)
                                          d: {
                                            if (e[5996] = 0, c = On(127, c | 0, 146) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1 || (e[5996] = 0, Ar = On(127, c | 0, 99) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1))
                                              break d;
                                            if (y = ye[h + 8 | 0] | ye[h + 9 | 0] << 8 | (ye[h + 10 | 0] << 16 | ye[h + 11 | 0] << 24), c = ye[h | 0] | ye[h + 1 | 0] << 8 | (ye[h + 2 | 0] << 16 | ye[h + 3 | 0] << 24), hr = c >>> 0 < 29, g = ye[Ar | 0] | ye[Ar + 1 | 0] << 8 | (ye[Ar + 2 | 0] << 16 | ye[Ar + 3 | 0] << 24), o = g - 29 | 0, Fe = hr ? c : c - 29 | 0, ke = g >>> 0 < 29 ? g : o, c = Fe + ke | 0, c >>> 0 > (g >>> 0 <= 28 ? 28 : ye[Ar + 4 | 0] | ye[Ar + 5 | 0] << 8 | (ye[Ar + 6 | 0] << 16 | ye[Ar + 7 | 0] << 24)) >>> 0) {
                                              if (e[5996] = 0, di(124, Ar | 0, c + (c >>> 1 | 0) | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                break d;
                                              g = ye[Ar | 0] | ye[Ar + 1 | 0] << 8 | (ye[Ar + 2 | 0] << 16 | ye[Ar + 3 | 0] << 24), o = g - 29 | 0;
                                            }
                                            c = g >>> 0 < 29, S = ke + (c ? Ar + 4 | 0 : ye[Ar + 8 | 0] | ye[Ar + 9 | 0] << 8 | (ye[Ar + 10 | 0] << 16 | ye[Ar + 11 | 0] << 24)) | 0, Ks(Fe + S | 0, S, (c ? g : o) - ke | 0), o = Fe + (ye[Ar | 0] | ye[Ar + 1 | 0] << 8 | (ye[Ar + 2 | 0] << 16 | ye[Ar + 3 | 0] << 24)) | 0, $[Ar | 0] = o, $[Ar + 1 | 0] = o >>> 8, $[Ar + 2 | 0] = o >>> 16, $[Ar + 3 | 0] = o >>> 24;
                                            c: {
                                              if (!Fe)
                                                break c;
                                              o = hr ? h + 4 | 0 : y, c = Fe & 7;
                                              u: {
                                                if (!c) {
                                                  g = o;
                                                  break u;
                                                }
                                                for (h = 0, g = o; $[S | 0] = ye[g | 0], g = g + 1 | 0, S = S + 1 | 0, h = h + 1 | 0, (c | 0) != (h | 0); )
                                                  ;
                                              }
                                              if (Fe >>> 0 < 8)
                                                break c;
                                              for (o = o + Fe | 0; $[S | 0] = ye[g | 0], $[S + 1 | 0] = ye[g + 1 | 0], $[S + 2 | 0] = ye[g + 2 | 0], $[S + 3 | 0] = ye[g + 3 | 0], $[S + 4 | 0] = ye[g + 4 | 0], $[S + 5 | 0] = ye[g + 5 | 0], $[S + 6 | 0] = ye[g + 6 | 0], $[S + 7 | 0] = ye[g + 7 | 0], S = S + 8 | 0, g = g + 8 | 0, (o | 0) != (g | 0); )
                                                ;
                                            }
                                            if (e[5996] = 0, On(127, Ar | 0, 104) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)
                                              break n;
                                          }
                                        break t;
                                      case 16:
                                        e[G + 48 >> 2] = 146, Fl(r, h, G + 48 | 0);
                                        break n;
                                      case 1:
                                        $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 4 | 0] = 81, $[r | 0] = 1, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0;
                                        break n;
                                      case 0:
                                        $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 4 | 0] = 0, $[r | 0] = 1, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0;
                                        break n;
                                      case 17:
                                        $[r | 0] = 0, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 4 | 0] = 0, $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, c = ye[h + 8 | 0] | ye[h + 9 | 0] << 8 | (ye[h + 10 | 0] << 16 | ye[h + 11 | 0] << 24), ln = -29, o = 0, ke = ye[h | 0] | ye[h + 1 | 0] << 8 | (ye[h + 2 | 0] << 16 | ye[h + 3 | 0] << 24), y = ke >>> 0 < 29;
                                        d: {
                                          if (hr = y ? ke : ke - 29 | 0, hr >>> 0 >= 29) {
                                            if (e[5996] = 0, di(124, r | 0, hr + (hr >>> 1 | 0) | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                              break d;
                                            g = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), ln = g - 29 | 0, o = ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24);
                                          }
                                          ke = r + 4 | 0, Ar = o, o = g >>> 0 < 29, S = o ? ke : Ar, Ks(hr + S | 0, S, o ? g : ln), o = hr + (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) | 0, $[r | 0] = o, $[r + 1 | 0] = o >>> 8, $[r + 2 | 0] = o >>> 16, $[r + 3 | 0] = o >>> 24;
                                          c: {
                                            if (!hr)
                                              break c;
                                            o = y ? h + 4 | 0 : c, c = hr & 7;
                                            u: {
                                              if (!c) {
                                                g = o;
                                                break u;
                                              }
                                              for (ln = 0, g = o; $[S | 0] = ye[g | 0], g = g + 1 | 0, S = S + 1 | 0, ln = ln + 1 | 0, (c | 0) != (ln | 0); )
                                                ;
                                            }
                                            if (hr >>> 0 < 8)
                                              break c;
                                            for (o = o + hr | 0; $[S | 0] = ye[g | 0], $[S + 1 | 0] = ye[g + 1 | 0], $[S + 2 | 0] = ye[g + 2 | 0], $[S + 3 | 0] = ye[g + 3 | 0], $[S + 4 | 0] = ye[g + 4 | 0], $[S + 5 | 0] = ye[g + 5 | 0], $[S + 6 | 0] = ye[g + 6 | 0], $[S + 7 | 0] = ye[g + 7 | 0], S = S + 8 | 0, g = g + 8 | 0, (o | 0) != (g | 0); )
                                              ;
                                          }
                                          if (c = ye[h + 40 | 0] | ye[h + 41 | 0] << 8 | (ye[h + 42 | 0] << 16 | ye[h + 43 | 0] << 24), o = ye[h + 32 | 0] | ye[h + 33 | 0] << 8 | (ye[h + 34 | 0] << 16 | ye[h + 35 | 0] << 24), Fe = o >>> 0 < 29, g = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), y = g - 29 | 0, Ar = Fe ? o : o - 29 | 0, hr = g >>> 0 < 29 ? g : y, o = Ar + hr | 0, o >>> 0 > (g >>> 0 <= 28 ? 28 : ye[r + 4 | 0] | ye[r + 5 | 0] << 8 | (ye[r + 6 | 0] << 16 | ye[r + 7 | 0] << 24)) >>> 0) {
                                            if (e[5996] = 0, di(124, r | 0, o + (o >>> 1 | 0) | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                              break d;
                                            g = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), y = g - 29 | 0;
                                          }
                                          if (o = g >>> 0 < 29, S = hr + (o ? ke : ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)) | 0, Ks(Ar + S | 0, S, (o ? g : y) - hr | 0), o = Ar + (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) | 0, $[r | 0] = o, $[r + 1 | 0] = o >>> 8, $[r + 2 | 0] = o >>> 16, $[r + 3 | 0] = o >>> 24, !Ar)
                                            break n;
                                          r = Fe ? h + 36 | 0 : c, o = Ar & 7;
                                          c: {
                                            if (!o) {
                                              g = r;
                                              break c;
                                            }
                                            for (h = 0, g = r; $[S | 0] = ye[g | 0], g = g + 1 | 0, S = S + 1 | 0, h = h + 1 | 0, (o | 0) != (h | 0); )
                                              ;
                                          }
                                          if (Ar >>> 0 < 8)
                                            break n;
                                          for (r = r + Ar | 0; $[S | 0] = ye[g | 0], $[S + 1 | 0] = ye[g + 1 | 0], $[S + 2 | 0] = ye[g + 2 | 0], $[S + 3 | 0] = ye[g + 3 | 0], $[S + 4 | 0] = ye[g + 4 | 0], $[S + 5 | 0] = ye[g + 5 | 0], $[S + 6 | 0] = ye[g + 6 | 0], $[S + 7 | 0] = ye[g + 7 | 0], S = S + 8 | 0, g = g + 8 | 0, (r | 0) != (g | 0); )
                                            ;
                                          break n;
                                        }
                                        break t;
                                      case 18:
                                        e[G + 48 >> 2] = 154, Hf(r, h, h + 32 | 0, G + 48 | 0);
                                        break n;
                                      case 19:
                                        e[G + 48 >> 2] = 155, Hf(r, h, h + 32 | 0, G + 48 | 0);
                                        break n;
                                      case 21:
                                        $[r | 0] = 0, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 4 | 0] = 0, $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, c = ye[h + 8 | 0] | ye[h + 9 | 0] << 8 | (ye[h + 10 | 0] << 16 | ye[h + 11 | 0] << 24), ln = -29, o = 0, ke = ye[h | 0] | ye[h + 1 | 0] << 8 | (ye[h + 2 | 0] << 16 | ye[h + 3 | 0] << 24), y = ke >>> 0 < 29, ke = y ? ke : ke - 29 | 0;
                                        d: {
                                          if (ke >>> 0 >= 29) {
                                            if (e[5996] = 0, di(124, r | 0, ke + (ke >>> 1 | 0) | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                              break d;
                                            g = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), ln = g - 29 | 0, o = ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24);
                                          }
                                          Fe = r + 4 | 0, Ar = o, o = g >>> 0 < 29, S = o ? Fe : Ar, Ks(ke + S | 0, S, o ? g : ln), o = ke + (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) | 0, $[r | 0] = o, $[r + 1 | 0] = o >>> 8, $[r + 2 | 0] = o >>> 16, $[r + 3 | 0] = o >>> 24;
                                          c: {
                                            if (!ke)
                                              break c;
                                            o = y ? h + 4 | 0 : c, c = ke & 7;
                                            u: {
                                              if (!c) {
                                                g = o;
                                                break u;
                                              }
                                              for (ln = 0, g = o; $[S | 0] = ye[g | 0], g = g + 1 | 0, S = S + 1 | 0, ln = ln + 1 | 0, (c | 0) != (ln | 0); )
                                                ;
                                            }
                                            if (ke >>> 0 < 8)
                                              break c;
                                            for (o = o + ke | 0; $[S | 0] = ye[g | 0], $[S + 1 | 0] = ye[g + 1 | 0], $[S + 2 | 0] = ye[g + 2 | 0], $[S + 3 | 0] = ye[g + 3 | 0], $[S + 4 | 0] = ye[g + 4 | 0], $[S + 5 | 0] = ye[g + 5 | 0], $[S + 6 | 0] = ye[g + 6 | 0], $[S + 7 | 0] = ye[g + 7 | 0], S = S + 8 | 0, g = g + 8 | 0, (o | 0) != (g | 0); )
                                              ;
                                          }
                                          if (e[5996] = 0, c = On(127, r | 0, 115) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1 || (e[5996] = 0, Tr = On(127, c | 0, 100) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1))
                                            break d;
                                          if (y = ye[h + 40 | 0] | ye[h + 41 | 0] << 8 | (ye[h + 42 | 0] << 16 | ye[h + 43 | 0] << 24), c = ye[h + 32 | 0] | ye[h + 33 | 0] << 8 | (ye[h + 34 | 0] << 16 | ye[h + 35 | 0] << 24), hr = c >>> 0 < 29, g = ye[Tr | 0] | ye[Tr + 1 | 0] << 8 | (ye[Tr + 2 | 0] << 16 | ye[Tr + 3 | 0] << 24), o = g - 29 | 0, Ar = hr ? c : c - 29 | 0, ke = g >>> 0 < 29 ? g : o, c = Ar + ke | 0, c >>> 0 > (g >>> 0 <= 28 ? 28 : ye[Fe | 0] | ye[Fe + 1 | 0] << 8 | (ye[Fe + 2 | 0] << 16 | ye[Fe + 3 | 0] << 24)) >>> 0) {
                                            if (e[5996] = 0, di(124, Tr | 0, c + (c >>> 1 | 0) | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                              break d;
                                            g = ye[Tr | 0] | ye[Tr + 1 | 0] << 8 | (ye[Tr + 2 | 0] << 16 | ye[Tr + 3 | 0] << 24), o = g - 29 | 0;
                                          }
                                          c = g >>> 0 < 29, S = ke + (c ? Fe : ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)) | 0, Ks(Ar + S | 0, S, (c ? g : o) - ke | 0), o = Ar + (ye[Tr | 0] | ye[Tr + 1 | 0] << 8 | (ye[Tr + 2 | 0] << 16 | ye[Tr + 3 | 0] << 24)) | 0, $[Tr | 0] = o, $[Tr + 1 | 0] = o >>> 8, $[Tr + 2 | 0] = o >>> 16, $[Tr + 3 | 0] = o >>> 24;
                                          c: {
                                            if (!Ar)
                                              break c;
                                            o = hr ? h + 36 | 0 : y, c = Ar & 7;
                                            u: {
                                              if (!c) {
                                                g = o;
                                                break u;
                                              }
                                              for (h = 0, g = o; $[S | 0] = ye[g | 0], g = g + 1 | 0, S = S + 1 | 0, h = h + 1 | 0, (c | 0) != (h | 0); )
                                                ;
                                            }
                                            if (Ar >>> 0 < 8)
                                              break c;
                                            for (o = o + Ar | 0; $[S | 0] = ye[g | 0], $[S + 1 | 0] = ye[g + 1 | 0], $[S + 2 | 0] = ye[g + 2 | 0], $[S + 3 | 0] = ye[g + 3 | 0], $[S + 4 | 0] = ye[g + 4 | 0], $[S + 5 | 0] = ye[g + 5 | 0], $[S + 6 | 0] = ye[g + 6 | 0], $[S + 7 | 0] = ye[g + 7 | 0], S = S + 8 | 0, g = g + 8 | 0, (o | 0) != (g | 0); )
                                              ;
                                          }
                                          if (e[5996] = 0, On(127, Tr | 0, 104) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)
                                            break n;
                                        }
                                        break t;
                                      case 20:
                                        $[r | 0] = 0, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 4 | 0] = 0, $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, c = ye[h + 8 | 0] | ye[h + 9 | 0] << 8 | (ye[h + 10 | 0] << 16 | ye[h + 11 | 0] << 24), ln = -29, o = 0, ke = ye[h | 0] | ye[h + 1 | 0] << 8 | (ye[h + 2 | 0] << 16 | ye[h + 3 | 0] << 24), y = ke >>> 0 < 29, ke = y ? ke : ke - 29 | 0;
                                        d: {
                                          if (ke >>> 0 >= 29) {
                                            if (e[5996] = 0, di(124, r | 0, ke + (ke >>> 1 | 0) | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                              break d;
                                            g = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), ln = g - 29 | 0, o = ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24);
                                          }
                                          Fe = r + 4 | 0, Ar = o, o = g >>> 0 < 29, S = o ? Fe : Ar, Ks(ke + S | 0, S, o ? g : ln), o = ke + (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) | 0, $[r | 0] = o, $[r + 1 | 0] = o >>> 8, $[r + 2 | 0] = o >>> 16, $[r + 3 | 0] = o >>> 24;
                                          c: {
                                            if (!ke)
                                              break c;
                                            o = y ? h + 4 | 0 : c, c = ke & 7;
                                            u: {
                                              if (!c) {
                                                g = o;
                                                break u;
                                              }
                                              for (ln = 0, g = o; $[S | 0] = ye[g | 0], g = g + 1 | 0, S = S + 1 | 0, ln = ln + 1 | 0, (c | 0) != (ln | 0); )
                                                ;
                                            }
                                            if (ke >>> 0 < 8)
                                              break c;
                                            for (o = o + ke | 0; $[S | 0] = ye[g | 0], $[S + 1 | 0] = ye[g + 1 | 0], $[S + 2 | 0] = ye[g + 2 | 0], $[S + 3 | 0] = ye[g + 3 | 0], $[S + 4 | 0] = ye[g + 4 | 0], $[S + 5 | 0] = ye[g + 5 | 0], $[S + 6 | 0] = ye[g + 6 | 0], $[S + 7 | 0] = ye[g + 7 | 0], S = S + 8 | 0, g = g + 8 | 0, (o | 0) != (g | 0); )
                                              ;
                                          }
                                          if (e[5996] = 0, Tr = On(127, r | 0, 100) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                            break d;
                                          if (y = ye[h + 40 | 0] | ye[h + 41 | 0] << 8 | (ye[h + 42 | 0] << 16 | ye[h + 43 | 0] << 24), c = ye[h + 32 | 0] | ye[h + 33 | 0] << 8 | (ye[h + 34 | 0] << 16 | ye[h + 35 | 0] << 24), hr = c >>> 0 < 29, g = ye[Tr | 0] | ye[Tr + 1 | 0] << 8 | (ye[Tr + 2 | 0] << 16 | ye[Tr + 3 | 0] << 24), o = g - 29 | 0, Ar = hr ? c : c - 29 | 0, ke = g >>> 0 < 29 ? g : o, c = Ar + ke | 0, c >>> 0 > (g >>> 0 <= 28 ? 28 : ye[Fe | 0] | ye[Fe + 1 | 0] << 8 | (ye[Fe + 2 | 0] << 16 | ye[Fe + 3 | 0] << 24)) >>> 0) {
                                            if (e[5996] = 0, di(124, Tr | 0, c + (c >>> 1 | 0) | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                              break d;
                                            g = ye[Tr | 0] | ye[Tr + 1 | 0] << 8 | (ye[Tr + 2 | 0] << 16 | ye[Tr + 3 | 0] << 24), o = g - 29 | 0;
                                          }
                                          c = g >>> 0 < 29, S = ke + (c ? Fe : ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)) | 0, Ks(Ar + S | 0, S, (c ? g : o) - ke | 0), o = Ar + (ye[Tr | 0] | ye[Tr + 1 | 0] << 8 | (ye[Tr + 2 | 0] << 16 | ye[Tr + 3 | 0] << 24)) | 0, $[Tr | 0] = o, $[Tr + 1 | 0] = o >>> 8, $[Tr + 2 | 0] = o >>> 16, $[Tr + 3 | 0] = o >>> 24;
                                          c: {
                                            if (!Ar)
                                              break c;
                                            o = hr ? h + 36 | 0 : y, c = Ar & 7;
                                            u: {
                                              if (!c) {
                                                g = o;
                                                break u;
                                              }
                                              for (h = 0, g = o; $[S | 0] = ye[g | 0], g = g + 1 | 0, S = S + 1 | 0, h = h + 1 | 0, (c | 0) != (h | 0); )
                                                ;
                                            }
                                            if (Ar >>> 0 < 8)
                                              break c;
                                            for (o = o + Ar | 0; $[S | 0] = ye[g | 0], $[S + 1 | 0] = ye[g + 1 | 0], $[S + 2 | 0] = ye[g + 2 | 0], $[S + 3 | 0] = ye[g + 3 | 0], $[S + 4 | 0] = ye[g + 4 | 0], $[S + 5 | 0] = ye[g + 5 | 0], $[S + 6 | 0] = ye[g + 6 | 0], $[S + 7 | 0] = ye[g + 7 | 0], S = S + 8 | 0, g = g + 8 | 0, (o | 0) != (g | 0); )
                                              ;
                                          }
                                          if (e[5996] = 0, On(127, Tr | 0, 104) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)
                                            break n;
                                        }
                                        break t;
                                      case 22:
                                        if ($[r | 0] = 0, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 4 | 0] = 0, $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, e[5996] = 0, Ar = On(127, r | 0, 99) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)
                                          d: {
                                            if (y = ye[h + 8 | 0] | ye[h + 9 | 0] << 8 | (ye[h + 10 | 0] << 16 | ye[h + 11 | 0] << 24), c = ye[h | 0] | ye[h + 1 | 0] << 8 | (ye[h + 2 | 0] << 16 | ye[h + 3 | 0] << 24), hr = c >>> 0 < 29, g = ye[Ar | 0] | ye[Ar + 1 | 0] << 8 | (ye[Ar + 2 | 0] << 16 | ye[Ar + 3 | 0] << 24), o = g - 29 | 0, Fe = hr ? c : c - 29 | 0, ke = g >>> 0 < 29 ? g : o, c = Fe + ke | 0, c >>> 0 > (g >>> 0 <= 28 ? 28 : ye[Ar + 4 | 0] | ye[Ar + 5 | 0] << 8 | (ye[Ar + 6 | 0] << 16 | ye[Ar + 7 | 0] << 24)) >>> 0) {
                                              if (e[5996] = 0, di(124, Ar | 0, c + (c >>> 1 | 0) | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                break d;
                                              g = ye[Ar | 0] | ye[Ar + 1 | 0] << 8 | (ye[Ar + 2 | 0] << 16 | ye[Ar + 3 | 0] << 24), o = g - 29 | 0;
                                            }
                                            c = g >>> 0 < 29, S = ke + (c ? Ar + 4 | 0 : ye[Ar + 8 | 0] | ye[Ar + 9 | 0] << 8 | (ye[Ar + 10 | 0] << 16 | ye[Ar + 11 | 0] << 24)) | 0, Ks(Fe + S | 0, S, (c ? g : o) - ke | 0), o = Fe + (ye[Ar | 0] | ye[Ar + 1 | 0] << 8 | (ye[Ar + 2 | 0] << 16 | ye[Ar + 3 | 0] << 24)) | 0, $[Ar | 0] = o, $[Ar + 1 | 0] = o >>> 8, $[Ar + 2 | 0] = o >>> 16, $[Ar + 3 | 0] = o >>> 24;
                                            c: {
                                              if (!Fe)
                                                break c;
                                              o = hr ? h + 4 | 0 : y, c = Fe & 7;
                                              u: {
                                                if (!c) {
                                                  g = o;
                                                  break u;
                                                }
                                                for (g = o; $[S | 0] = ye[g | 0], g = g + 1 | 0, S = S + 1 | 0, ln = ln + 1 | 0, (c | 0) != (ln | 0); )
                                                  ;
                                              }
                                              if (Fe >>> 0 < 8)
                                                break c;
                                              for (o = o + Fe | 0; $[S | 0] = ye[g | 0], $[S + 1 | 0] = ye[g + 1 | 0], $[S + 2 | 0] = ye[g + 2 | 0], $[S + 3 | 0] = ye[g + 3 | 0], $[S + 4 | 0] = ye[g + 4 | 0], $[S + 5 | 0] = ye[g + 5 | 0], $[S + 6 | 0] = ye[g + 6 | 0], $[S + 7 | 0] = ye[g + 7 | 0], S = S + 8 | 0, g = g + 8 | 0, (o | 0) != (g | 0); )
                                                ;
                                            }
                                            if (e[5996] = 0, Ar = On(127, Ar | 0, 103) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                              break d;
                                            if (y = ye[h + 40 | 0] | ye[h + 41 | 0] << 8 | (ye[h + 42 | 0] << 16 | ye[h + 43 | 0] << 24), c = ye[h + 32 | 0] | ye[h + 33 | 0] << 8 | (ye[h + 34 | 0] << 16 | ye[h + 35 | 0] << 24), hr = c >>> 0 < 29, g = ye[Ar | 0] | ye[Ar + 1 | 0] << 8 | (ye[Ar + 2 | 0] << 16 | ye[Ar + 3 | 0] << 24), o = g - 29 | 0, Fe = hr ? c : c - 29 | 0, ke = g >>> 0 < 29 ? g : o, c = Fe + ke | 0, c >>> 0 > (g >>> 0 <= 28 ? 28 : ye[Ar + 4 | 0] | ye[Ar + 5 | 0] << 8 | (ye[Ar + 6 | 0] << 16 | ye[Ar + 7 | 0] << 24)) >>> 0) {
                                              if (e[5996] = 0, di(124, Ar | 0, c + (c >>> 1 | 0) | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                break d;
                                              g = ye[Ar | 0] | ye[Ar + 1 | 0] << 8 | (ye[Ar + 2 | 0] << 16 | ye[Ar + 3 | 0] << 24), o = g - 29 | 0;
                                            }
                                            c = g >>> 0 < 29, S = ke + (c ? Ar + 4 | 0 : ye[Ar + 8 | 0] | ye[Ar + 9 | 0] << 8 | (ye[Ar + 10 | 0] << 16 | ye[Ar + 11 | 0] << 24)) | 0, Ks(Fe + S | 0, S, (c ? g : o) - ke | 0), o = Fe + (ye[Ar | 0] | ye[Ar + 1 | 0] << 8 | (ye[Ar + 2 | 0] << 16 | ye[Ar + 3 | 0] << 24)) | 0, $[Ar | 0] = o, $[Ar + 1 | 0] = o >>> 8, $[Ar + 2 | 0] = o >>> 16, $[Ar + 3 | 0] = o >>> 24;
                                            c: {
                                              if (!Fe)
                                                break c;
                                              o = hr ? h + 36 | 0 : y, c = Fe & 7;
                                              u: {
                                                if (!c) {
                                                  g = o;
                                                  break u;
                                                }
                                                for (h = 0, g = o; $[S | 0] = ye[g | 0], g = g + 1 | 0, S = S + 1 | 0, h = h + 1 | 0, (c | 0) != (h | 0); )
                                                  ;
                                              }
                                              if (Fe >>> 0 < 8)
                                                break c;
                                              for (o = o + Fe | 0; $[S | 0] = ye[g | 0], $[S + 1 | 0] = ye[g + 1 | 0], $[S + 2 | 0] = ye[g + 2 | 0], $[S + 3 | 0] = ye[g + 3 | 0], $[S + 4 | 0] = ye[g + 4 | 0], $[S + 5 | 0] = ye[g + 5 | 0], $[S + 6 | 0] = ye[g + 6 | 0], $[S + 7 | 0] = ye[g + 7 | 0], S = S + 8 | 0, g = g + 8 | 0, (o | 0) != (g | 0); )
                                                ;
                                            }
                                            if (e[5996] = 0, On(127, Ar | 0, 104) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)
                                              break n;
                                          }
                                        break t;
                                      case 23:
                                        $[r | 0] = 0, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 4 | 0] = 0, $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, c = ye[h + 8 | 0] | ye[h + 9 | 0] << 8 | (ye[h + 10 | 0] << 16 | ye[h + 11 | 0] << 24), ln = -29, o = 0, ke = ye[h | 0] | ye[h + 1 | 0] << 8 | (ye[h + 2 | 0] << 16 | ye[h + 3 | 0] << 24), y = ke >>> 0 < 29, ke = y ? ke : ke - 29 | 0;
                                        d: {
                                          if (ke >>> 0 >= 29) {
                                            if (e[5996] = 0, di(124, r | 0, ke + (ke >>> 1 | 0) | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                              break d;
                                            g = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), ln = g - 29 | 0, o = ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24);
                                          }
                                          Ar = r + 4 | 0, Tr = o, o = g >>> 0 < 29, S = o ? Ar : Tr, Ks(ke + S | 0, S, o ? g : ln), o = ke + (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) | 0, $[r | 0] = o, $[r + 1 | 0] = o >>> 8, $[r + 2 | 0] = o >>> 16, $[r + 3 | 0] = o >>> 24;
                                          c: {
                                            if (!ke)
                                              break c;
                                            o = y ? h + 4 | 0 : c, c = ke & 7;
                                            u: {
                                              if (!c) {
                                                g = o;
                                                break u;
                                              }
                                              for (ln = 0, g = o; $[S | 0] = ye[g | 0], g = g + 1 | 0, S = S + 1 | 0, ln = ln + 1 | 0, (c | 0) != (ln | 0); )
                                                ;
                                            }
                                            if (ke >>> 0 < 8)
                                              break c;
                                            for (o = o + ke | 0; $[S | 0] = ye[g | 0], $[S + 1 | 0] = ye[g + 1 | 0], $[S + 2 | 0] = ye[g + 2 | 0], $[S + 3 | 0] = ye[g + 3 | 0], $[S + 4 | 0] = ye[g + 4 | 0], $[S + 5 | 0] = ye[g + 5 | 0], $[S + 6 | 0] = ye[g + 6 | 0], $[S + 7 | 0] = ye[g + 7 | 0], S = S + 8 | 0, g = g + 8 | 0, (o | 0) != (g | 0); )
                                              ;
                                          }
                                          if (e[5996] = 0, Tr = On(127, r | 0, 100) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                            break d;
                                          if (y = ye[h + 72 | 0] | ye[h + 73 | 0] << 8 | (ye[h + 74 | 0] << 16 | ye[h + 75 | 0] << 24), c = ye[h + 64 | 0] | ye[h + 65 | 0] << 8 | (ye[h + 66 | 0] << 16 | ye[h + 67 | 0] << 24), hr = c >>> 0 < 29, g = ye[Tr | 0] | ye[Tr + 1 | 0] << 8 | (ye[Tr + 2 | 0] << 16 | ye[Tr + 3 | 0] << 24), o = g - 29 | 0, Fe = hr ? c : c - 29 | 0, ke = g >>> 0 < 29 ? g : o, c = Fe + ke | 0, c >>> 0 > (g >>> 0 <= 28 ? 28 : ye[Ar | 0] | ye[Ar + 1 | 0] << 8 | (ye[Ar + 2 | 0] << 16 | ye[Ar + 3 | 0] << 24)) >>> 0) {
                                            if (e[5996] = 0, di(124, Tr | 0, c + (c >>> 1 | 0) | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                              break d;
                                            g = ye[Tr | 0] | ye[Tr + 1 | 0] << 8 | (ye[Tr + 2 | 0] << 16 | ye[Tr + 3 | 0] << 24), o = g - 29 | 0;
                                          }
                                          c = g >>> 0 < 29, S = ke + (c ? Ar : ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)) | 0, Ks(Fe + S | 0, S, (c ? g : o) - ke | 0), o = Fe + (ye[Tr | 0] | ye[Tr + 1 | 0] << 8 | (ye[Tr + 2 | 0] << 16 | ye[Tr + 3 | 0] << 24)) | 0, $[Tr | 0] = o, $[Tr + 1 | 0] = o >>> 8, $[Tr + 2 | 0] = o >>> 16, $[Tr + 3 | 0] = o >>> 24;
                                          c: {
                                            if (!Fe)
                                              break c;
                                            o = hr ? h + 68 | 0 : y, c = Fe & 7;
                                            u: {
                                              if (!c) {
                                                g = o;
                                                break u;
                                              }
                                              for (ln = 0, g = o; $[S | 0] = ye[g | 0], g = g + 1 | 0, S = S + 1 | 0, ln = ln + 1 | 0, (c | 0) != (ln | 0); )
                                                ;
                                            }
                                            if (Fe >>> 0 < 8)
                                              break c;
                                            for (o = o + Fe | 0; $[S | 0] = ye[g | 0], $[S + 1 | 0] = ye[g + 1 | 0], $[S + 2 | 0] = ye[g + 2 | 0], $[S + 3 | 0] = ye[g + 3 | 0], $[S + 4 | 0] = ye[g + 4 | 0], $[S + 5 | 0] = ye[g + 5 | 0], $[S + 6 | 0] = ye[g + 6 | 0], $[S + 7 | 0] = ye[g + 7 | 0], S = S + 8 | 0, g = g + 8 | 0, (o | 0) != (g | 0); )
                                              ;
                                          }
                                          if (e[5996] = 0, Tr = On(127, Tr | 0, 103) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                            break d;
                                          if (y = ye[h + 40 | 0] | ye[h + 41 | 0] << 8 | (ye[h + 42 | 0] << 16 | ye[h + 43 | 0] << 24), c = ye[h + 32 | 0] | ye[h + 33 | 0] << 8 | (ye[h + 34 | 0] << 16 | ye[h + 35 | 0] << 24), hr = c >>> 0 < 29, g = ye[Tr | 0] | ye[Tr + 1 | 0] << 8 | (ye[Tr + 2 | 0] << 16 | ye[Tr + 3 | 0] << 24), o = g - 29 | 0, Fe = hr ? c : c - 29 | 0, ke = g >>> 0 < 29 ? g : o, c = Fe + ke | 0, c >>> 0 > (g >>> 0 <= 28 ? 28 : ye[Ar | 0] | ye[Ar + 1 | 0] << 8 | (ye[Ar + 2 | 0] << 16 | ye[Ar + 3 | 0] << 24)) >>> 0) {
                                            if (e[5996] = 0, di(124, Tr | 0, c + (c >>> 1 | 0) | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                              break d;
                                            g = ye[Tr | 0] | ye[Tr + 1 | 0] << 8 | (ye[Tr + 2 | 0] << 16 | ye[Tr + 3 | 0] << 24), o = g - 29 | 0;
                                          }
                                          c = g >>> 0 < 29, S = ke + (c ? Ar : ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)) | 0, Ks(Fe + S | 0, S, (c ? g : o) - ke | 0), o = Fe + (ye[Tr | 0] | ye[Tr + 1 | 0] << 8 | (ye[Tr + 2 | 0] << 16 | ye[Tr + 3 | 0] << 24)) | 0, $[Tr | 0] = o, $[Tr + 1 | 0] = o >>> 8, $[Tr + 2 | 0] = o >>> 16, $[Tr + 3 | 0] = o >>> 24;
                                          c: {
                                            if (!Fe)
                                              break c;
                                            o = hr ? h + 36 | 0 : y, c = Fe & 7;
                                            u: {
                                              if (!c) {
                                                g = o;
                                                break u;
                                              }
                                              for (h = 0, g = o; $[S | 0] = ye[g | 0], g = g + 1 | 0, S = S + 1 | 0, h = h + 1 | 0, (c | 0) != (h | 0); )
                                                ;
                                            }
                                            if (Fe >>> 0 < 8)
                                              break c;
                                            for (o = o + Fe | 0; $[S | 0] = ye[g | 0], $[S + 1 | 0] = ye[g + 1 | 0], $[S + 2 | 0] = ye[g + 2 | 0], $[S + 3 | 0] = ye[g + 3 | 0], $[S + 4 | 0] = ye[g + 4 | 0], $[S + 5 | 0] = ye[g + 5 | 0], $[S + 6 | 0] = ye[g + 6 | 0], $[S + 7 | 0] = ye[g + 7 | 0], S = S + 8 | 0, g = g + 8 | 0, (o | 0) != (g | 0); )
                                              ;
                                          }
                                          if (e[5996] = 0, On(127, Tr | 0, 104) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)
                                            break n;
                                        }
                                        break t;
                                      case 25:
                                        if (e[G + 72 >> 2] = 0, e[G + 76 >> 2] = 0, h = G - -64 | 0, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[G + 56 >> 2] = 0, e[G + 60 >> 2] = 0, e[G + 48 >> 2] = 0, e[G + 52 >> 2] = 0, h = e[c + 4 >> 2], e[5996] = 0, Rn = zc(G + 48 | 0, h, 0), h = e[5996], e[5996] = 0, (h | 0) == 1) {
                                          if (S = Vr() | 0, Ps[G + 48 >> 2] < 29)
                                            break e;
                                          Sr(e[G + 56 >> 2]);
                                          break e;
                                        }
                                        if (y = e[c + 8 >> 2], Tr = e[c + 12 >> 2], (y | 0) == (Tr | 0)) {
                                          c = y;
                                          break a;
                                        }
                                        for (hr = Rn + 4 | 0, ke = G + 20 | 0; ; ) {
                                          d: {
                                            if (e[5996] = 0, g = ii(3, 4) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                              break d;
                                            if (e[G + 4 >> 2] = g, h = g + 4 | 0, e[G + 12 >> 2] = h, $[g | 0] = 2, $[g + 1 | 0] = 80, $[g + 2 | 0] = 75, $[g + 3 | 0] = 98, e[G + 8 >> 2] = h, e[5996] = 0, $[G + 80 | 0] = 0, as(126, G + 4 | 0, 29, G + 80 | 0), h = e[5996], e[5996] = 0, (h | 0) == 1) {
                                              if (S = Vr() | 0, r = e[G + 4 >> 2], !r)
                                                break s;
                                              Sr(r);
                                              break s;
                                            }
                                            if (h = 0, Fe = ye[y + 11 | 0], g = Fe << 24 >> 24 < 0, Ks(e[G + 4 >> 2] + 4 | 0, g ? e[y >> 2] : y, g ? e[y + 4 >> 2] : Fe), e[G + 40 >> 2] = 0, e[G + 44 >> 2] = 0, e[G + 32 >> 2] = 0, e[G + 36 >> 2] = 0, e[G + 24 >> 2] = 0, e[G + 28 >> 2] = 0, e[G + 16 >> 2] = 0, e[G + 20 >> 2] = 0, ln = -29, Fe = e[Rn + 8 >> 2], g = 0, Mn = e[Rn >> 2], Ar = Mn >>> 0 < 29, Mn = Ar ? Mn : Mn - 29 | 0, Mn >>> 0 >= 29) {
                                              if (e[5996] = 0, di(124, G + 16 | 0, Mn + (Mn >>> 1 | 0) | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                break l;
                                              g = e[G + 16 >> 2], ln = g - 29 | 0, S = e[G + 24 >> 2];
                                            } else
                                              S = h;
                                            h = g >>> 0 < 29, S = h ? ke : S, Ks(S + Mn | 0, S, h ? g : ln), e[G + 16 >> 2] = Mn + e[G + 16 >> 2];
                                            c: {
                                              if (!Mn)
                                                break c;
                                              if (h = 0, Ar = Ar ? hr : Fe, g = Ar, Fe = Mn & 7, Fe)
                                                for (; $[S | 0] = ye[g | 0], g = g + 1 | 0, S = S + 1 | 0, h = h + 1 | 0, (Fe | 0) != (h | 0); )
                                                  ;
                                              if (Mn >>> 0 < 8)
                                                break c;
                                              for (h = Ar + Mn | 0; $[S | 0] = ye[g | 0], $[S + 1 | 0] = ye[g + 1 | 0], $[S + 2 | 0] = ye[g + 2 | 0], $[S + 3 | 0] = ye[g + 3 | 0], $[S + 4 | 0] = ye[g + 4 | 0], $[S + 5 | 0] = ye[g + 5 | 0], $[S + 6 | 0] = ye[g + 6 | 0], $[S + 7 | 0] = ye[g + 7 | 0], S = S + 8 | 0, g = g + 8 | 0, (h | 0) != (g | 0); )
                                                ;
                                            }
                                            if (e[5996] = 0, g = On(19, G + 16 | 0, G + 4 | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                              break l;
                                            if (e[G + 104 >> 2] = ye[hr + 24 | 0] | ye[hr + 25 | 0] << 8 | (ye[hr + 26 | 0] << 16 | ye[hr + 27 | 0] << 24), h = ye[hr + 20 | 0] | ye[hr + 21 | 0] << 8 | (ye[hr + 22 | 0] << 16 | ye[hr + 23 | 0] << 24), e[G + 96 >> 2] = ye[hr + 16 | 0] | ye[hr + 17 | 0] << 8 | (ye[hr + 18 | 0] << 16 | ye[hr + 19 | 0] << 24), e[G + 100 >> 2] = h, h = ye[hr + 12 | 0] | ye[hr + 13 | 0] << 8 | (ye[hr + 14 | 0] << 16 | ye[hr + 15 | 0] << 24), e[G + 88 >> 2] = ye[hr + 8 | 0] | ye[hr + 9 | 0] << 8 | (ye[hr + 10 | 0] << 16 | ye[hr + 11 | 0] << 24), e[G + 92 >> 2] = h, h = ye[hr + 4 | 0] | ye[hr + 5 | 0] << 8 | (ye[hr + 6 | 0] << 16 | ye[hr + 7 | 0] << 24), e[G + 80 >> 2] = ye[hr | 0] | ye[hr + 1 | 0] << 8 | (ye[hr + 2 | 0] << 16 | ye[hr + 3 | 0] << 24), e[G + 84 >> 2] = h, e[hr + 24 >> 2] = e[ke + 24 >> 2], h = e[ke + 20 >> 2], e[hr + 16 >> 2] = e[ke + 16 >> 2], e[hr + 20 >> 2] = h, h = e[ke + 12 >> 2], e[hr + 8 >> 2] = e[ke + 8 >> 2], e[hr + 12 >> 2] = h, h = e[ke + 4 >> 2], e[hr >> 2] = e[ke >> 2], e[hr + 4 >> 2] = h, h = e[G + 104 >> 2], $[ke + 24 | 0] = h, $[ke + 25 | 0] = h >>> 8, $[ke + 26 | 0] = h >>> 16, $[ke + 27 | 0] = h >>> 24, Fe = e[G + 100 >> 2], h = e[G + 96 >> 2], $[ke + 16 | 0] = h, $[ke + 17 | 0] = h >>> 8, $[ke + 18 | 0] = h >>> 16, $[ke + 19 | 0] = h >>> 24, $[ke + 20 | 0] = Fe, $[ke + 21 | 0] = Fe >>> 8, $[ke + 22 | 0] = Fe >>> 16, $[ke + 23 | 0] = Fe >>> 24, Fe = e[G + 92 >> 2], h = e[G + 88 >> 2], $[ke + 8 | 0] = h, $[ke + 9 | 0] = h >>> 8, $[ke + 10 | 0] = h >>> 16, $[ke + 11 | 0] = h >>> 24, $[ke + 12 | 0] = Fe, $[ke + 13 | 0] = Fe >>> 8, $[ke + 14 | 0] = Fe >>> 16, $[ke + 15 | 0] = Fe >>> 24, Fe = e[G + 84 >> 2], h = e[G + 80 >> 2], $[ke | 0] = h, $[ke + 1 | 0] = h >>> 8, $[ke + 2 | 0] = h >>> 16, $[ke + 3 | 0] = h >>> 24, $[ke + 4 | 0] = Fe, $[ke + 5 | 0] = Fe >>> 8, $[ke + 6 | 0] = Fe >>> 16, $[ke + 7 | 0] = Fe >>> 24, h = e[Rn >> 2], e[Rn >> 2] = e[g >> 2], e[g >> 2] = h, h >>> 0 >= 29 && (Sr(e[G + 24 >> 2]), e[G + 24 >> 2] = 0), h = e[G + 4 >> 2], h && Sr(h), y = y + 12 | 0, (Tr | 0) != (y | 0))
                                              continue;
                                            break o;
                                          }
                                          break;
                                        }
                                        S = Vr() | 0;
                                        break s;
                                      case 24:
                                        e[G + 72 >> 2] = 0, e[G + 76 >> 2] = 0, g = G - -64 | 0, e[g >> 2] = 0, e[g + 4 >> 2] = 0, e[G + 56 >> 2] = 0, e[G + 60 >> 2] = 0, e[G + 48 >> 2] = 0, e[G + 52 >> 2] = 0, ln = e[G + 76 >> 2], e[G + 40 >> 2] = ln, Ar = e[G + 72 >> 2], g = e[G + 68 >> 2], Tr = g, e[G + 32 >> 2] = g, e[G + 36 >> 2] = Ar, Fe = e[G + 64 >> 2], ke = e[G + 60 >> 2], e[G + 24 >> 2] = ke, e[G + 28 >> 2] = Fe, hr = e[G + 56 >> 2], g = e[G + 52 >> 2], e[G + 16 >> 2] = g, e[G + 20 >> 2] = hr, e[G + 76 >> 2] = ye[h + 28 | 0] | ye[h + 29 | 0] << 8 | (ye[h + 30 | 0] << 16 | ye[h + 31 | 0] << 24), Rn = ye[h + 24 | 0] | ye[h + 25 | 0] << 8 | (ye[h + 26 | 0] << 16 | ye[h + 27 | 0] << 24), e[G + 68 >> 2] = ye[h + 20 | 0] | ye[h + 21 | 0] << 8 | (ye[h + 22 | 0] << 16 | ye[h + 23 | 0] << 24), e[G + 72 >> 2] = Rn, Rn = ye[h + 16 | 0] | ye[h + 17 | 0] << 8 | (ye[h + 18 | 0] << 16 | ye[h + 19 | 0] << 24), e[G + 60 >> 2] = ye[h + 12 | 0] | ye[h + 13 | 0] << 8 | (ye[h + 14 | 0] << 16 | ye[h + 15 | 0] << 24), e[G + 64 >> 2] = Rn, Rn = ye[h + 8 | 0] | ye[h + 9 | 0] << 8 | (ye[h + 10 | 0] << 16 | ye[h + 11 | 0] << 24), e[G + 52 >> 2] = ye[h + 4 | 0] | ye[h + 5 | 0] << 8 | (ye[h + 6 | 0] << 16 | ye[h + 7 | 0] << 24), e[G + 56 >> 2] = Rn, $[h + 28 | 0] = ln, $[h + 29 | 0] = ln >>> 8, $[h + 30 | 0] = ln >>> 16, $[h + 31 | 0] = ln >>> 24, $[h + 20 | 0] = Tr, $[h + 21 | 0] = Tr >>> 8, $[h + 22 | 0] = Tr >>> 16, $[h + 23 | 0] = Tr >>> 24, $[h + 24 | 0] = Ar, $[h + 25 | 0] = Ar >>> 8, $[h + 26 | 0] = Ar >>> 16, $[h + 27 | 0] = Ar >>> 24, $[h + 12 | 0] = ke, $[h + 13 | 0] = ke >>> 8, $[h + 14 | 0] = ke >>> 16, $[h + 15 | 0] = ke >>> 24, $[h + 16 | 0] = Fe, $[h + 17 | 0] = Fe >>> 8, $[h + 18 | 0] = Fe >>> 16, $[h + 19 | 0] = Fe >>> 24, $[h + 4 | 0] = g, $[h + 5 | 0] = g >>> 8, $[h + 6 | 0] = g >>> 16, $[h + 7 | 0] = g >>> 24, $[h + 8 | 0] = hr, $[h + 9 | 0] = hr >>> 8, $[h + 10 | 0] = hr >>> 16, $[h + 11 | 0] = hr >>> 24, S = e[h >> 2], e[G + 48 >> 2] = S, e[h >> 2] = 0, Fe = G + 48 | 4;
                                        d: {
                                          c: {
                                            if (y >>> 0 >= 2) {
                                              for (ln = 1; ; ) {
                                                if (e[5996] = 0, e[G + 4 >> 2] = 147, Qs(128, G + 16 | 0, G + 48 | 0, (ln << 5) + h | 0, G + 4 | 0), g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                  break c;
                                                if (e[G + 104 >> 2] = ye[Fe + 24 | 0] | ye[Fe + 25 | 0] << 8 | (ye[Fe + 26 | 0] << 16 | ye[Fe + 27 | 0] << 24), g = ye[Fe + 20 | 0] | ye[Fe + 21 | 0] << 8 | (ye[Fe + 22 | 0] << 16 | ye[Fe + 23 | 0] << 24), e[G + 96 >> 2] = ye[Fe + 16 | 0] | ye[Fe + 17 | 0] << 8 | (ye[Fe + 18 | 0] << 16 | ye[Fe + 19 | 0] << 24), e[G + 100 >> 2] = g, g = ye[Fe + 12 | 0] | ye[Fe + 13 | 0] << 8 | (ye[Fe + 14 | 0] << 16 | ye[Fe + 15 | 0] << 24), e[G + 88 >> 2] = ye[Fe + 8 | 0] | ye[Fe + 9 | 0] << 8 | (ye[Fe + 10 | 0] << 16 | ye[Fe + 11 | 0] << 24), e[G + 92 >> 2] = g, g = ye[Fe + 4 | 0] | ye[Fe + 5 | 0] << 8 | (ye[Fe + 6 | 0] << 16 | ye[Fe + 7 | 0] << 24), e[G + 80 >> 2] = ye[Fe | 0] | ye[Fe + 1 | 0] << 8 | (ye[Fe + 2 | 0] << 16 | ye[Fe + 3 | 0] << 24), e[G + 84 >> 2] = g, e[Fe + 24 >> 2] = e[G + 44 >> 2], g = e[G + 40 >> 2], e[Fe + 16 >> 2] = e[G + 36 >> 2], e[Fe + 20 >> 2] = g, g = e[G + 32 >> 2], e[Fe + 8 >> 2] = e[G + 28 >> 2], e[Fe + 12 >> 2] = g, g = e[G + 24 >> 2], e[Fe >> 2] = e[G + 20 >> 2], e[Fe + 4 >> 2] = g, g = e[G + 104 >> 2], $[G + 44 | 0] = g, $[G + 45 | 0] = g >>> 8, $[G + 46 | 0] = g >>> 16, $[G + 47 | 0] = g >>> 24, ke = e[G + 100 >> 2], g = e[G + 96 >> 2], $[G + 36 | 0] = g, $[G + 37 | 0] = g >>> 8, $[G + 38 | 0] = g >>> 16, $[G + 39 | 0] = g >>> 24, $[G + 40 | 0] = ke, $[G + 41 | 0] = ke >>> 8, $[G + 42 | 0] = ke >>> 16, $[G + 43 | 0] = ke >>> 24, ke = e[G + 92 >> 2], g = e[G + 88 >> 2], $[G + 28 | 0] = g, $[G + 29 | 0] = g >>> 8, $[G + 30 | 0] = g >>> 16, $[G + 31 | 0] = g >>> 24, $[G + 32 | 0] = ke, $[G + 33 | 0] = ke >>> 8, $[G + 34 | 0] = ke >>> 16, $[G + 35 | 0] = ke >>> 24, ke = e[G + 84 >> 2], g = e[G + 80 >> 2], $[G + 20 | 0] = g, $[G + 21 | 0] = g >>> 8, $[G + 22 | 0] = g >>> 16, $[G + 23 | 0] = g >>> 24, $[G + 24 | 0] = ke, $[G + 25 | 0] = ke >>> 8, $[G + 26 | 0] = ke >>> 16, $[G + 27 | 0] = ke >>> 24, g = e[G + 48 >> 2], e[G + 48 >> 2] = e[G + 16 >> 2], e[G + 16 >> 2] = g, g >>> 0 >= 29 && Sr(e[G + 24 >> 2]), ln = ln + 1 | 0, (ln | 0) == (y | 0))
                                                  break;
                                              }
                                              S = e[G + 48 >> 2];
                                            }
                                            $[r | 0] = 0, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 4 | 0] = 0, $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, ln = -29, ke = e[G + 56 >> 2], h = 0;
                                            u: {
                                              Ar = r + 4 | 0, g = S >>> 0 < 29, hr = g ? S : S - 29 | 0;
                                              g: {
                                                if (hr >>> 0 >= 29) {
                                                  if (e[5996] = 0, di(124, r | 0, hr + (hr >>> 1 | 0) | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                    break g;
                                                  h = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), ln = h - 29 | 0, Mn = ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24);
                                                }
                                                y = h >>> 0 < 29, S = y ? Ar : Mn, Ks(S + hr | 0, S, y ? h : ln), h = hr + (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) | 0, $[r | 0] = h, $[r + 1 | 0] = h >>> 8, $[r + 2 | 0] = h >>> 16, $[r + 3 | 0] = h >>> 24;
                                                A: {
                                                  if (!hr)
                                                    break A;
                                                  y = g ? Fe : ke, ke = hr & 7;
                                                  p: {
                                                    if (!ke) {
                                                      g = y;
                                                      break p;
                                                    }
                                                    for (h = 0, g = y; $[S | 0] = ye[g | 0], g = g + 1 | 0, S = S + 1 | 0, h = h + 1 | 0, (ke | 0) != (h | 0); )
                                                      ;
                                                  }
                                                  if (hr >>> 0 < 8)
                                                    break A;
                                                  for (h = y + hr | 0; $[S | 0] = ye[g | 0], $[S + 1 | 0] = ye[g + 1 | 0], $[S + 2 | 0] = ye[g + 2 | 0], $[S + 3 | 0] = ye[g + 3 | 0], $[S + 4 | 0] = ye[g + 4 | 0], $[S + 5 | 0] = ye[g + 5 | 0], $[S + 6 | 0] = ye[g + 6 | 0], $[S + 7 | 0] = ye[g + 7 | 0], S = S + 8 | 0, g = g + 8 | 0, (h | 0) != (g | 0); )
                                                    ;
                                                }
                                                if (c = e[c + 4 >> 2], e[5996] = 0, h = zc(r, c, 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                  break g;
                                                if (e[5996] = 0, On(127, h | 0, (o ? 136 : 135) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)
                                                  break u;
                                              }
                                              if (S = Vr() | 0, (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) >>> 0 < 29)
                                                break d;
                                              Sr(ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)), $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0;
                                              break d;
                                            }
                                            if (Ps[G + 48 >> 2] < 29)
                                              break n;
                                            Sr(e[G + 56 >> 2]);
                                            break n;
                                          }
                                          S = Vr() | 0;
                                        }
                                        if (Ps[G + 48 >> 2] < 29)
                                          break e;
                                        Sr(e[G + 56 >> 2]);
                                        break e;
                                      default:
                                        aa(2350, 2210, 624, 5107), ri();
                                      case 6:
                                        break f;
                                    }
                                  e[G + 48 >> 2] = 32, e[G + 16 >> 2] = 136, e[G + 80 >> 2] = 168, e[G + 4 >> 2] = o ? 136 : 135, Vf(r, G + 48 | 0, G + 16 | 0, G + 80 | 0, c + 20 | 0, G + 4 | 0);
                                  break n;
                                }
                                if (S = Vr() | 0, Ps[G + 16 >> 2] >= 29 && (Sr(e[G + 24 >> 2]), e[G + 24 >> 2] = 0), r = e[G + 4 >> 2], !r)
                                  break s;
                                Sr(r);
                                break s;
                              }
                              y = e[c + 8 >> 2], c = e[c + 12 >> 2];
                            }
                            $[r | 0] = 0, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 4 | 0] = 0, $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, hr = e[Rn + 8 >> 2], h = -29, ke = (c - y | 0) / 12 | 0, ln = 0, g = 0, c = e[Rn >> 2], y = c >>> 0 < 29, Fe = y ? c : c - 29 | 0;
                            a: {
                              if (Fe >>> 0 >= 29) {
                                if (e[5996] = 0, di(124, r | 0, Fe + (Fe >>> 1 | 0) | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                  break a;
                                ln = ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24), g = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), h = g - 29 | 0;
                              }
                              c = g >>> 0 < 29, S = c ? r + 4 | 0 : ln, Ks(Fe + S | 0, S, c ? g : h), c = Fe + (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) | 0, $[r | 0] = c, $[r + 1 | 0] = c >>> 8, $[r + 2 | 0] = c >>> 16, $[r + 3 | 0] = c >>> 24;
                              o: {
                                if (!Fe)
                                  break o;
                                c = y ? Rn + 4 | 0 : hr, y = Fe & 7;
                                l: {
                                  if (!y) {
                                    g = c;
                                    break l;
                                  }
                                  for (h = 0, g = c; $[S | 0] = ye[g | 0], g = g + 1 | 0, S = S + 1 | 0, h = h + 1 | 0, (y | 0) != (h | 0); )
                                    ;
                                }
                                if (Fe >>> 0 < 8)
                                  break o;
                                for (c = c + Fe | 0; $[S | 0] = ye[g | 0], $[S + 1 | 0] = ye[g + 1 | 0], $[S + 2 | 0] = ye[g + 2 | 0], $[S + 3 | 0] = ye[g + 3 | 0], $[S + 4 | 0] = ye[g + 4 | 0], $[S + 5 | 0] = ye[g + 5 | 0], $[S + 6 | 0] = ye[g + 6 | 0], $[S + 7 | 0] = ye[g + 7 | 0], S = S + 8 | 0, g = g + 8 | 0, (c | 0) != (g | 0); )
                                  ;
                              }
                              if (e[5996] = 0, h = zc(r, ke, 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                break a;
                              if (e[5996] = 0, On(127, h | 0, (o ? 175 : 174) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)
                                break i;
                            }
                            if (S = Vr() | 0, (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) >>> 0 < 29)
                              break s;
                            Sr(ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)), $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0;
                          }
                          if (Ps[Rn >> 2] < 29)
                            break e;
                          Sr(e[Rn + 8 >> 2]);
                          break e;
                        }
                        if (Ps[Rn >> 2] < 29)
                          break n;
                        Sr(e[Rn + 8 >> 2]);
                      }
                      Yr = G + 112 | 0;
                      return;
                    }
                    if (S = Vr() | 0, r = e[G + 48 >> 2], !r)
                      break e;
                    Sr(r);
                    break e;
                  }
                  if (S = Vr() | 0, (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) >>> 0 < 29)
                    break e;
                  Sr(ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)), $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0;
                }
                Ki(S | 0), ri();
              }
              function q1(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0;
                c = Yr - 496 | 0, Yr = c;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  f: {
                                    d: {
                                      c: {
                                        u: {
                                          g: {
                                            A: {
                                              p: {
                                                I: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              b: {
                                                                h: {
                                                                  x: {
                                                                    m: {
                                                                      B: {
                                                                        R: {
                                                                          E: {
                                                                            C: {
                                                                              y: {
                                                                                D: {
                                                                                  P: {
                                                                                    q: {
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    K: {
                                                                                                      W: {
                                                                                                        G: {
                                                                                                          V: {
                                                                                                            z: {
                                                                                                              j: {
                                                                                                                X: {
                                                                                                                  Y: {
                                                                                                                    J:
                                                                                                                      switch (y = e[o >> 2], e[y >> 2] - 1 | 0) {
                                                                                                                        case 23:
                                                                                                                          break x;
                                                                                                                        case 22:
                                                                                                                          break m;
                                                                                                                        case 21:
                                                                                                                          break B;
                                                                                                                        case 20:
                                                                                                                          break R;
                                                                                                                        case 19:
                                                                                                                          break E;
                                                                                                                        case 18:
                                                                                                                          break C;
                                                                                                                        case 17:
                                                                                                                          break y;
                                                                                                                        case 16:
                                                                                                                          break D;
                                                                                                                        case 14:
                                                                                                                          break P;
                                                                                                                        case 15:
                                                                                                                          break q;
                                                                                                                        case 13:
                                                                                                                          break O;
                                                                                                                        case 12:
                                                                                                                          break Q;
                                                                                                                        case 11:
                                                                                                                          break U;
                                                                                                                        case 10:
                                                                                                                          break F;
                                                                                                                        case 9:
                                                                                                                          break M;
                                                                                                                        case 0:
                                                                                                                          break L;
                                                                                                                        case 8:
                                                                                                                          break K;
                                                                                                                        case 6:
                                                                                                                          break W;
                                                                                                                        case 7:
                                                                                                                          break G;
                                                                                                                        case 5:
                                                                                                                          break V;
                                                                                                                        case 3:
                                                                                                                          break z;
                                                                                                                        case 4:
                                                                                                                          break j;
                                                                                                                        case 24:
                                                                                                                          break X;
                                                                                                                        case 2:
                                                                                                                          break Y;
                                                                                                                        case 1:
                                                                                                                          break J;
                                                                                                                        default:
                                                                                                                          break H;
                                                                                                                      }
                                                                                                                    y = e[y + 8 >> 2];
                                                                                                                    J: {
                                                                                                                      if ($[y + 11 | 0] >= 0) {
                                                                                                                        e[c + 456 >> 2] = e[y + 8 >> 2], h = e[y + 4 >> 2], e[c + 448 >> 2] = e[y >> 2], e[c + 452 >> 2] = h;
                                                                                                                        break J;
                                                                                                                      }
                                                                                                                      il(c + 448 | 0, e[y >> 2], e[y + 4 >> 2]);
                                                                                                                    }
                                                                                                                    e[5996] = 0, $[c + 460 | 0] = 1, y = Si(99, c + 448 | 0, 0, 5283) | 0, h = e[5996], e[5996] = 0;
                                                                                                                    J: {
                                                                                                                      _: {
                                                                                                                        Z: {
                                                                                                                          $: {
                                                                                                                            if ((h | 0) != 1) {
                                                                                                                              if (e[c + 472 >> 2] = e[y + 8 >> 2], h = e[y + 4 >> 2], e[c + 464 >> 2] = e[y >> 2], e[c + 468 >> 2] = h, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, h = On(97, c + 464 | 0, 5242) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                                                                break $;
                                                                                                                              if (e[c + 488 >> 2] = e[h + 8 >> 2], g = e[h + 4 >> 2], e[c + 480 >> 2] = e[h >> 2], e[c + 484 >> 2] = g, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, as(161, r | 0, o | 0, c + 480 | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                                break Z;
                                                                                                                              if ($[c + 491 | 0] < 0 && Sr(e[c + 480 >> 2]), $[h + 11 | 0] < 0 && Sr(e[h >> 2]), !ye[c + 460 | 0] | $[y + 11 | 0] >= 0)
                                                                                                                                break h;
                                                                                                                              Sr(e[y >> 2]);
                                                                                                                              break h;
                                                                                                                            }
                                                                                                                            o = Vr() | 0;
                                                                                                                            break J;
                                                                                                                          }
                                                                                                                          o = Vr() | 0;
                                                                                                                          break _;
                                                                                                                        }
                                                                                                                        if (o = Vr() | 0, $[c + 491 | 0] >= 0)
                                                                                                                          break _;
                                                                                                                        Sr(e[c + 480 >> 2]);
                                                                                                                      }
                                                                                                                      if ($[c + 475 | 0] >= 0)
                                                                                                                        break J;
                                                                                                                      Sr(e[c + 464 >> 2]);
                                                                                                                    }
                                                                                                                    break r;
                                                                                                                  }
                                                                                                                  y = e[y + 8 >> 2];
                                                                                                                  Y: {
                                                                                                                    if ($[y + 11 | 0] >= 0) {
                                                                                                                      e[c + 456 >> 2] = e[y + 8 >> 2], h = e[y + 4 >> 2], e[c + 448 >> 2] = e[y >> 2], e[c + 452 >> 2] = h;
                                                                                                                      break Y;
                                                                                                                    }
                                                                                                                    il(c + 448 | 0, e[y >> 2], e[y + 4 >> 2]);
                                                                                                                  }
                                                                                                                  e[5996] = 0, $[c + 460 | 0] = 1, y = Si(99, c + 448 | 0, 0, 5315) | 0, h = e[5996], e[5996] = 0;
                                                                                                                  Y: {
                                                                                                                    J: {
                                                                                                                      _: {
                                                                                                                        Z: {
                                                                                                                          if ((h | 0) != 1) {
                                                                                                                            if (e[c + 472 >> 2] = e[y + 8 >> 2], h = e[y + 4 >> 2], e[c + 464 >> 2] = e[y >> 2], e[c + 468 >> 2] = h, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, h = On(97, c + 464 | 0, 5242) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                                                              break Z;
                                                                                                                            if (e[c + 440 >> 2] = e[h + 8 >> 2], g = e[h + 4 >> 2], e[c + 432 >> 2] = e[h >> 2], e[c + 436 >> 2] = g, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, as(161, r | 0, o | 0, c + 432 | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                              break _;
                                                                                                                            if ($[c + 443 | 0] < 0 && Sr(e[c + 432 >> 2]), $[h + 11 | 0] < 0 && Sr(e[h >> 2]), !ye[c + 460 | 0] | $[y + 11 | 0] >= 0)
                                                                                                                              break h;
                                                                                                                            Sr(e[y >> 2]);
                                                                                                                            break h;
                                                                                                                          }
                                                                                                                          o = Vr() | 0;
                                                                                                                          break Y;
                                                                                                                        }
                                                                                                                        o = Vr() | 0;
                                                                                                                        break J;
                                                                                                                      }
                                                                                                                      if (o = Vr() | 0, $[c + 443 | 0] >= 0)
                                                                                                                        break J;
                                                                                                                      Sr(e[c + 432 >> 2]);
                                                                                                                    }
                                                                                                                    if ($[c + 475 | 0] >= 0)
                                                                                                                      break Y;
                                                                                                                    Sr(e[c + 464 >> 2]);
                                                                                                                  }
                                                                                                                  break r;
                                                                                                                }
                                                                                                                h = c + 384 | 0, kc(h, e[y + 4 >> 2]), e[5996] = 0, y = Si(99, h | 0, 0, 5289) | 0, h = e[5996], e[5996] = 0;
                                                                                                                X: {
                                                                                                                  Y: {
                                                                                                                    J: {
                                                                                                                      _: {
                                                                                                                        Z: {
                                                                                                                          $: {
                                                                                                                            ee: {
                                                                                                                              te: {
                                                                                                                                re: {
                                                                                                                                  ne: {
                                                                                                                                    if ((h | 0) != 1) {
                                                                                                                                      if (e[c + 408 >> 2] = e[y + 8 >> 2], h = e[y + 4 >> 2], e[c + 400 >> 2] = e[y >> 2], e[c + 404 >> 2] = h, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, h = On(97, c + 400 | 0, 5417) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                                                                        break ne;
                                                                                                                                      if (e[c + 472 >> 2] = e[h + 8 >> 2], g = e[h + 4 >> 2], e[c + 464 >> 2] = e[h >> 2], e[c + 468 >> 2] = g, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, g = e[o >> 2], S = e[g + 12 >> 2], g = e[g + 8 >> 2], e[5996] = 0, G = c + 368 | 0, di(115, G | 0, (S - g | 0) / 12 | 0), g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                                                                        break re;
                                                                                                                                      if (e[5996] = 0, g = ye[c + 379 | 0], S = g << 24 >> 24 < 0, g = Si(100, c + 464 | 0, (S ? e[c + 368 >> 2] : G) | 0, (S ? e[c + 372 >> 2] : g) | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                                                        break te;
                                                                                                                                      if (e[c + 456 >> 2] = e[g + 8 >> 2], S = e[g + 4 >> 2], e[c + 448 >> 2] = e[g >> 2], e[c + 452 >> 2] = S, e[g >> 2] = 0, e[g + 4 >> 2] = 0, e[g + 8 >> 2] = 0, e[5996] = 0, S = On(97, c + 448 | 0, 5242) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                                                                                        break ee;
                                                                                                                                      if (e[c + 424 >> 2] = e[S + 8 >> 2], G = e[S + 4 >> 2], e[c + 416 >> 2] = e[S >> 2], e[c + 420 >> 2] = G, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, e[5996] = 0, as(161, r | 0, o | 0, c + 416 | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                                        break $;
                                                                                                                                      if ($[c + 427 | 0] < 0 && Sr(e[c + 416 >> 2]), $[S + 11 | 0] < 0 && Sr(e[S >> 2]), $[c + 379 | 0] < 0 && Sr(e[c + 368 >> 2]), $[g + 11 | 0] < 0 && Sr(e[g >> 2]), $[h + 11 | 0] < 0 && Sr(e[h >> 2]), $[y + 11 | 0] >= 0)
                                                                                                                                        break h;
                                                                                                                                      Sr(e[y >> 2]);
                                                                                                                                      break h;
                                                                                                                                    }
                                                                                                                                    o = Vr() | 0;
                                                                                                                                    break X;
                                                                                                                                  }
                                                                                                                                  o = Vr() | 0;
                                                                                                                                  break Y;
                                                                                                                                }
                                                                                                                                o = Vr() | 0;
                                                                                                                                break J;
                                                                                                                              }
                                                                                                                              o = Vr() | 0;
                                                                                                                              break _;
                                                                                                                            }
                                                                                                                            o = Vr() | 0;
                                                                                                                            break Z;
                                                                                                                          }
                                                                                                                          if (o = Vr() | 0, $[c + 427 | 0] >= 0)
                                                                                                                            break Z;
                                                                                                                          Sr(e[c + 416 >> 2]);
                                                                                                                        }
                                                                                                                        if ($[c + 459 | 0] >= 0)
                                                                                                                          break _;
                                                                                                                        Sr(e[c + 448 >> 2]);
                                                                                                                      }
                                                                                                                      if ($[c + 379 | 0] >= 0)
                                                                                                                        break J;
                                                                                                                      Sr(e[c + 368 >> 2]);
                                                                                                                    }
                                                                                                                    if ($[c + 475 | 0] >= 0)
                                                                                                                      break Y;
                                                                                                                    Sr(e[c + 464 >> 2]);
                                                                                                                  }
                                                                                                                  if ($[c + 411 | 0] >= 0)
                                                                                                                    break X;
                                                                                                                  Sr(e[c + 400 >> 2]);
                                                                                                                }
                                                                                                                if ($[c + 395 | 0] >= 0)
                                                                                                                  break e;
                                                                                                                Sr(e[c + 384 >> 2]);
                                                                                                                break e;
                                                                                                              }
                                                                                                              h = c + 464 | 0, kc(h, e[y + 4 >> 2]), e[5996] = 0, y = Si(99, h | 0, 0, 5258) | 0, h = e[5996], e[5996] = 0;
                                                                                                              j: {
                                                                                                                X: {
                                                                                                                  Y: {
                                                                                                                    J: {
                                                                                                                      if ((h | 0) != 1) {
                                                                                                                        if (e[c + 456 >> 2] = e[y + 8 >> 2], h = e[y + 4 >> 2], e[c + 448 >> 2] = e[y >> 2], e[c + 452 >> 2] = h, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, h = On(97, c + 448 | 0, 5242) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                                                          break J;
                                                                                                                        if (e[c + 360 >> 2] = e[h + 8 >> 2], g = e[h + 4 >> 2], e[c + 352 >> 2] = e[h >> 2], e[c + 356 >> 2] = g, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, as(161, r | 0, o | 0, c + 352 | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                          break Y;
                                                                                                                        if ($[c + 363 | 0] < 0 && Sr(e[c + 352 >> 2]), $[h + 11 | 0] < 0 && Sr(e[h >> 2]), $[y + 11 | 0] >= 0)
                                                                                                                          break h;
                                                                                                                        Sr(e[y >> 2]);
                                                                                                                        break h;
                                                                                                                      }
                                                                                                                      o = Vr() | 0;
                                                                                                                      break j;
                                                                                                                    }
                                                                                                                    o = Vr() | 0;
                                                                                                                    break X;
                                                                                                                  }
                                                                                                                  if (o = Vr() | 0, $[c + 363 | 0] >= 0)
                                                                                                                    break X;
                                                                                                                  Sr(e[c + 352 >> 2]);
                                                                                                                }
                                                                                                                if ($[c + 459 | 0] >= 0)
                                                                                                                  break j;
                                                                                                                Sr(e[c + 448 >> 2]);
                                                                                                              }
                                                                                                              break t;
                                                                                                            }
                                                                                                            h = c + 464 | 0, kc(h, e[y + 4 >> 2]), e[5996] = 0, y = Si(99, h | 0, 0, 5265) | 0, h = e[5996], e[5996] = 0;
                                                                                                            z: {
                                                                                                              j: {
                                                                                                                X: {
                                                                                                                  Y: {
                                                                                                                    if ((h | 0) != 1) {
                                                                                                                      if (e[c + 456 >> 2] = e[y + 8 >> 2], h = e[y + 4 >> 2], e[c + 448 >> 2] = e[y >> 2], e[c + 452 >> 2] = h, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, h = On(97, c + 448 | 0, 5242) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                                                        break Y;
                                                                                                                      if (e[c + 344 >> 2] = e[h + 8 >> 2], g = e[h + 4 >> 2], e[c + 336 >> 2] = e[h >> 2], e[c + 340 >> 2] = g, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, as(161, r | 0, o | 0, c + 336 | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                        break X;
                                                                                                                      if ($[c + 347 | 0] < 0 && Sr(e[c + 336 >> 2]), $[h + 11 | 0] < 0 && Sr(e[h >> 2]), $[y + 11 | 0] >= 0)
                                                                                                                        break h;
                                                                                                                      Sr(e[y >> 2]);
                                                                                                                      break h;
                                                                                                                    }
                                                                                                                    o = Vr() | 0;
                                                                                                                    break z;
                                                                                                                  }
                                                                                                                  o = Vr() | 0;
                                                                                                                  break j;
                                                                                                                }
                                                                                                                if (o = Vr() | 0, $[c + 347 | 0] >= 0)
                                                                                                                  break j;
                                                                                                                Sr(e[c + 336 >> 2]);
                                                                                                              }
                                                                                                              if ($[c + 459 | 0] >= 0)
                                                                                                                break z;
                                                                                                              Sr(e[c + 448 >> 2]);
                                                                                                            }
                                                                                                            break t;
                                                                                                          }
                                                                                                          if ($[c + 328 | 0] = 0, e[c + 320 >> 2] = 845244531, e[c + 324 >> 2] = 690501173, $[c + 331 | 0] = 8, e[5996] = 0, as(161, r | 0, o | 0, c + 320 | 0), r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                                                                                            if ($[c + 331 | 0] >= 0)
                                                                                                              break h;
                                                                                                            Sr(e[c + 320 >> 2]);
                                                                                                            break h;
                                                                                                          }
                                                                                                          if (o = Vr() | 0, $[c + 331 | 0] >= 0)
                                                                                                            break e;
                                                                                                          Sr(e[c + 320 >> 2]);
                                                                                                          break e;
                                                                                                        }
                                                                                                        if (y = xs(16), e[c + 308 >> 2] = y, e[c + 312 >> 2] = 11, e[c + 316 >> 2] = -2147483632, h = ye[5239] | ye[5240] << 8 | (ye[5241] << 16 | ye[5242] << 24), $[y + 7 | 0] = h, $[y + 8 | 0] = h >>> 8, $[y + 9 | 0] = h >>> 16, $[y + 10 | 0] = h >>> 24, h = ye[5236] | ye[5237] << 8 | (ye[5238] << 16 | ye[5239] << 24), g = ye[5232] | ye[5233] << 8 | (ye[5234] << 16 | ye[5235] << 24), $[y | 0] = g, $[y + 1 | 0] = g >>> 8, $[y + 2 | 0] = g >>> 16, $[y + 3 | 0] = g >>> 24, $[y + 4 | 0] = h, $[y + 5 | 0] = h >>> 8, $[y + 6 | 0] = h >>> 16, $[y + 7 | 0] = h >>> 24, $[y + 11 | 0] = 0, e[5996] = 0, as(161, r | 0, o | 0, c + 308 | 0), r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                                                                                          if ($[c + 319 | 0] >= 0)
                                                                                                            break h;
                                                                                                          Sr(e[c + 308 >> 2]);
                                                                                                          break h;
                                                                                                        }
                                                                                                        if (o = Vr() | 0, $[c + 319 | 0] >= 0)
                                                                                                          break e;
                                                                                                        Sr(e[c + 308 >> 2]);
                                                                                                        break e;
                                                                                                      }
                                                                                                      if ($[c + 304 | 0] = ye[5220], $[c + 307 | 0] = 9, $[c + 305 | 0] = 0, e[5996] = 0, y = ye[5216] | ye[5217] << 8 | (ye[5218] << 16 | ye[5219] << 24), e[c + 296 >> 2] = ye[5212] | ye[5213] << 8 | (ye[5214] << 16 | ye[5215] << 24), e[c + 300 >> 2] = y, as(161, r | 0, o | 0, c + 296 | 0), r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                                                                                        if ($[c + 307 | 0] >= 0)
                                                                                                          break h;
                                                                                                        Sr(e[c + 296 >> 2]);
                                                                                                        break h;
                                                                                                      }
                                                                                                      if (o = Vr() | 0, $[c + 307 | 0] >= 0)
                                                                                                        break e;
                                                                                                      Sr(e[c + 296 >> 2]);
                                                                                                      break e;
                                                                                                    }
                                                                                                    if ($[c + 288 | 0] = ye[5230], $[c + 291 | 0] = 9, $[c + 289 | 0] = 0, e[5996] = 0, y = ye[5226] | ye[5227] << 8 | (ye[5228] << 16 | ye[5229] << 24), e[c + 280 >> 2] = ye[5222] | ye[5223] << 8 | (ye[5224] << 16 | ye[5225] << 24), e[c + 284 >> 2] = y, as(161, r | 0, o | 0, c + 280 | 0), r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                                                                                      if ($[c + 291 | 0] >= 0)
                                                                                                        break h;
                                                                                                      Sr(e[c + 280 >> 2]);
                                                                                                      break h;
                                                                                                    }
                                                                                                    if (o = Vr() | 0, $[c + 291 | 0] >= 0)
                                                                                                      break e;
                                                                                                    Sr(e[c + 280 >> 2]);
                                                                                                    break e;
                                                                                                  }
                                                                                                  if ($[c + 272 | 0] = ye[2354], $[c + 279 | 0] = 5, $[c + 273 | 0] = 0, e[5996] = 0, e[c + 268 >> 2] = ye[2350] | ye[2351] << 8 | (ye[2352] << 16 | ye[2353] << 24), as(161, r | 0, o | 0, c + 268 | 0), r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                                                                                    if ($[c + 279 | 0] >= 0)
                                                                                                      break h;
                                                                                                    Sr(e[c + 268 >> 2]);
                                                                                                    break h;
                                                                                                  }
                                                                                                  if (o = Vr() | 0, $[c + 279 | 0] >= 0)
                                                                                                    break e;
                                                                                                  Sr(e[c + 268 >> 2]);
                                                                                                  break e;
                                                                                                }
                                                                                                if ($[c + 260 | 0] = 0, e[c + 256 >> 2] = 1702195828, $[c + 267 | 0] = 4, e[5996] = 0, as(161, r | 0, o | 0, c + 256 | 0), r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                                                                                  if ($[c + 267 | 0] >= 0)
                                                                                                    break h;
                                                                                                  Sr(e[c + 256 >> 2]);
                                                                                                  break h;
                                                                                                }
                                                                                                if (o = Vr() | 0, $[c + 267 | 0] >= 0)
                                                                                                  break e;
                                                                                                Sr(e[c + 256 >> 2]);
                                                                                                break e;
                                                                                              }
                                                                                              $[c + 255 | 0] = 2, $[c + 246 | 0] = 0, Vs[c + 244 >> 1] = 14945, e[5996] = 0, y = c + 464 | 0, as(161, y | 0, o | 0, c + 244 | 0), h = e[5996], e[5996] = 0;
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    K: {
                                                                                                      W: {
                                                                                                        G: {
                                                                                                          if ((h | 0) != 1) {
                                                                                                            if (e[5996] = 0, y = On(97, y | 0, 5574) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                              break G;
                                                                                                            if (e[c + 456 >> 2] = e[y + 8 >> 2], h = e[y + 4 >> 2], e[c + 448 >> 2] = e[y >> 2], e[c + 452 >> 2] = h, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, o = e[e[o >> 2] + 32 >> 2], e[5996] = 0, h = c + 400 | 0, di(141, h | 0, o | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                                              break W;
                                                                                                            if (e[5996] = 0, g = h, o = ye[c + 411 | 0], h = o << 24 >> 24 < 0, o = Si(100, c + 448 | 0, (h ? e[c + 400 >> 2] : g) | 0, (h ? e[c + 404 >> 2] : o) | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                              break K;
                                                                                                            h = e[o + 4 >> 2], e[r >> 2] = e[o >> 2], e[r + 4 >> 2] = h, e[r + 8 >> 2] = e[o + 8 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0;
                                                                                                            V: {
                                                                                                              if ($[c + 411 | 0] >= 0 || (Sr(e[c + 400 >> 2]), $[o + 11 | 0] >= 0))
                                                                                                                break V;
                                                                                                              Sr(e[o >> 2]);
                                                                                                            }
                                                                                                            if ($[y + 11 | 0] < 0 && Sr(e[y >> 2]), $[c + 255 | 0] >= 0)
                                                                                                              break h;
                                                                                                            Sr(e[c + 244 >> 2]);
                                                                                                            break h;
                                                                                                          }
                                                                                                          o = Vr() | 0;
                                                                                                          break M;
                                                                                                        }
                                                                                                        o = Vr() | 0;
                                                                                                        break L;
                                                                                                      }
                                                                                                      o = Vr() | 0;
                                                                                                      break H;
                                                                                                    }
                                                                                                    if (o = Vr() | 0, $[c + 411 | 0] >= 0)
                                                                                                      break H;
                                                                                                    Sr(e[c + 400 >> 2]);
                                                                                                  }
                                                                                                  if ($[c + 459 | 0] >= 0)
                                                                                                    break L;
                                                                                                  Sr(e[c + 448 >> 2]);
                                                                                                }
                                                                                                if ($[c + 475 | 0] >= 0)
                                                                                                  break M;
                                                                                                Sr(e[c + 464 >> 2]);
                                                                                              }
                                                                                              if ($[c + 255 | 0] >= 0)
                                                                                                break e;
                                                                                              Sr(e[c + 244 >> 2]);
                                                                                              break e;
                                                                                            }
                                                                                            $[c + 243 | 0] = 2, $[c + 234 | 0] = 0, Vs[c + 232 >> 1] = 14963, e[5996] = 0, y = c + 464 | 0, as(161, y | 0, o | 0, c + 232 | 0), h = e[5996], e[5996] = 0;
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    K: {
                                                                                                      W: {
                                                                                                        if ((h | 0) != 1) {
                                                                                                          if (e[5996] = 0, y = On(97, y | 0, 5574) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                            break W;
                                                                                                          if (e[c + 456 >> 2] = e[y + 8 >> 2], h = e[y + 4 >> 2], e[c + 448 >> 2] = e[y >> 2], e[c + 452 >> 2] = h, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, o = e[e[o >> 2] + 32 >> 2], e[5996] = 0, h = c + 400 | 0, di(141, h | 0, o | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                                            break K;
                                                                                                          if (e[5996] = 0, g = h, o = ye[c + 411 | 0], h = o << 24 >> 24 < 0, o = Si(100, c + 448 | 0, (h ? e[c + 400 >> 2] : g) | 0, (h ? e[c + 404 >> 2] : o) | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                            break H;
                                                                                                          h = e[o + 4 >> 2], e[r >> 2] = e[o >> 2], e[r + 4 >> 2] = h, e[r + 8 >> 2] = e[o + 8 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0;
                                                                                                          G: {
                                                                                                            if ($[c + 411 | 0] >= 0 || (Sr(e[c + 400 >> 2]), $[o + 11 | 0] >= 0))
                                                                                                              break G;
                                                                                                            Sr(e[o >> 2]);
                                                                                                          }
                                                                                                          if ($[y + 11 | 0] < 0 && Sr(e[y >> 2]), $[c + 243 | 0] >= 0)
                                                                                                            break h;
                                                                                                          Sr(e[c + 232 >> 2]);
                                                                                                          break h;
                                                                                                        }
                                                                                                        o = Vr() | 0;
                                                                                                        break F;
                                                                                                      }
                                                                                                      o = Vr() | 0;
                                                                                                      break M;
                                                                                                    }
                                                                                                    o = Vr() | 0;
                                                                                                    break L;
                                                                                                  }
                                                                                                  if (o = Vr() | 0, $[c + 411 | 0] >= 0)
                                                                                                    break L;
                                                                                                  Sr(e[c + 400 >> 2]);
                                                                                                }
                                                                                                if ($[c + 459 | 0] >= 0)
                                                                                                  break M;
                                                                                                Sr(e[c + 448 >> 2]);
                                                                                              }
                                                                                              if ($[c + 475 | 0] >= 0)
                                                                                                break F;
                                                                                              Sr(e[c + 464 >> 2]);
                                                                                            }
                                                                                            if ($[c + 243 | 0] >= 0)
                                                                                              break e;
                                                                                            Sr(e[c + 232 >> 2]);
                                                                                            break e;
                                                                                          }
                                                                                          $[c + 231 | 0] = 2, $[c + 222 | 0] = 0, Vs[c + 220 >> 1] = 14947, e[5996] = 0, y = c + 464 | 0, as(161, y | 0, o | 0, c + 220 | 0), h = e[5996], e[5996] = 0;
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    K: {
                                                                                                      if ((h | 0) != 1) {
                                                                                                        if (e[5996] = 0, y = On(97, y | 0, 5574) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                          break K;
                                                                                                        if (e[c + 456 >> 2] = e[y + 8 >> 2], h = e[y + 4 >> 2], e[c + 448 >> 2] = e[y >> 2], e[c + 452 >> 2] = h, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, o = e[e[o >> 2] + 32 >> 2], e[5996] = 0, h = c + 400 | 0, di(141, h | 0, o | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                                          break H;
                                                                                                        if (e[5996] = 0, g = h, o = ye[c + 411 | 0], h = o << 24 >> 24 < 0, o = Si(100, c + 448 | 0, (h ? e[c + 400 >> 2] : g) | 0, (h ? e[c + 404 >> 2] : o) | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                          break L;
                                                                                                        h = e[o + 4 >> 2], e[r >> 2] = e[o >> 2], e[r + 4 >> 2] = h, e[r + 8 >> 2] = e[o + 8 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0;
                                                                                                        W: {
                                                                                                          if ($[c + 411 | 0] >= 0 || (Sr(e[c + 400 >> 2]), $[o + 11 | 0] >= 0))
                                                                                                            break W;
                                                                                                          Sr(e[o >> 2]);
                                                                                                        }
                                                                                                        if ($[y + 11 | 0] < 0 && Sr(e[y >> 2]), $[c + 231 | 0] >= 0)
                                                                                                          break h;
                                                                                                        Sr(e[c + 220 >> 2]);
                                                                                                        break h;
                                                                                                      }
                                                                                                      o = Vr() | 0;
                                                                                                      break U;
                                                                                                    }
                                                                                                    o = Vr() | 0;
                                                                                                    break F;
                                                                                                  }
                                                                                                  o = Vr() | 0;
                                                                                                  break M;
                                                                                                }
                                                                                                if (o = Vr() | 0, $[c + 411 | 0] >= 0)
                                                                                                  break M;
                                                                                                Sr(e[c + 400 >> 2]);
                                                                                              }
                                                                                              if ($[c + 459 | 0] >= 0)
                                                                                                break F;
                                                                                              Sr(e[c + 448 >> 2]);
                                                                                            }
                                                                                            if ($[c + 475 | 0] >= 0)
                                                                                              break U;
                                                                                            Sr(e[c + 464 >> 2]);
                                                                                          }
                                                                                          if ($[c + 231 | 0] >= 0)
                                                                                            break e;
                                                                                          Sr(e[c + 220 >> 2]);
                                                                                          break e;
                                                                                        }
                                                                                        $[c + 219 | 0] = 2, $[c + 210 | 0] = 0, Vs[c + 208 >> 1] = 14948, e[5996] = 0, y = c + 464 | 0, as(161, y | 0, o | 0, c + 208 | 0), h = e[5996], e[5996] = 0;
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    if ((h | 0) != 1) {
                                                                                                      if (e[5996] = 0, y = On(97, y | 0, 5574) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                        break H;
                                                                                                      if (e[c + 456 >> 2] = e[y + 8 >> 2], h = e[y + 4 >> 2], e[c + 448 >> 2] = e[y >> 2], e[c + 452 >> 2] = h, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, o = e[e[o >> 2] + 32 >> 2], e[5996] = 0, h = c + 400 | 0, di(141, h | 0, o | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                                        break L;
                                                                                                      if (e[5996] = 0, g = h, o = ye[c + 411 | 0], h = o << 24 >> 24 < 0, o = Si(100, c + 448 | 0, (h ? e[c + 400 >> 2] : g) | 0, (h ? e[c + 404 >> 2] : o) | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                        break M;
                                                                                                      h = e[o + 4 >> 2], e[r >> 2] = e[o >> 2], e[r + 4 >> 2] = h, e[r + 8 >> 2] = e[o + 8 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0;
                                                                                                      K: {
                                                                                                        if ($[c + 411 | 0] >= 0 || (Sr(e[c + 400 >> 2]), $[o + 11 | 0] >= 0))
                                                                                                          break K;
                                                                                                        Sr(e[o >> 2]);
                                                                                                      }
                                                                                                      if ($[y + 11 | 0] < 0 && Sr(e[y >> 2]), $[c + 219 | 0] >= 0)
                                                                                                        break h;
                                                                                                      Sr(e[c + 208 >> 2]);
                                                                                                      break h;
                                                                                                    }
                                                                                                    o = Vr() | 0;
                                                                                                    break Q;
                                                                                                  }
                                                                                                  o = Vr() | 0;
                                                                                                  break U;
                                                                                                }
                                                                                                o = Vr() | 0;
                                                                                                break F;
                                                                                              }
                                                                                              if (o = Vr() | 0, $[c + 411 | 0] >= 0)
                                                                                                break F;
                                                                                              Sr(e[c + 400 >> 2]);
                                                                                            }
                                                                                            if ($[c + 459 | 0] >= 0)
                                                                                              break U;
                                                                                            Sr(e[c + 448 >> 2]);
                                                                                          }
                                                                                          if ($[c + 475 | 0] >= 0)
                                                                                            break Q;
                                                                                          Sr(e[c + 464 >> 2]);
                                                                                        }
                                                                                        if ($[c + 219 | 0] >= 0)
                                                                                          break e;
                                                                                        Sr(e[c + 208 >> 2]);
                                                                                        break e;
                                                                                      }
                                                                                      $[c + 207 | 0] = 2, $[c + 198 | 0] = 0, Vs[c + 196 >> 1] = 14966, e[5996] = 0, y = c + 464 | 0, as(161, y | 0, o | 0, c + 196 | 0), h = e[5996], e[5996] = 0;
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  if ((h | 0) != 1) {
                                                                                                    if (e[5996] = 0, y = On(97, y | 0, 5574) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                      break L;
                                                                                                    if (e[c + 456 >> 2] = e[y + 8 >> 2], h = e[y + 4 >> 2], e[c + 448 >> 2] = e[y >> 2], e[c + 452 >> 2] = h, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, o = e[e[o >> 2] + 32 >> 2], e[5996] = 0, h = c + 400 | 0, di(141, h | 0, o | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                                      break M;
                                                                                                    if (e[5996] = 0, g = h, o = ye[c + 411 | 0], h = o << 24 >> 24 < 0, o = Si(100, c + 448 | 0, (h ? e[c + 400 >> 2] : g) | 0, (h ? e[c + 404 >> 2] : o) | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                      break F;
                                                                                                    h = e[o + 4 >> 2], e[r >> 2] = e[o >> 2], e[r + 4 >> 2] = h, e[r + 8 >> 2] = e[o + 8 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0;
                                                                                                    H: {
                                                                                                      if ($[c + 411 | 0] >= 0 || (Sr(e[c + 400 >> 2]), $[o + 11 | 0] >= 0))
                                                                                                        break H;
                                                                                                      Sr(e[o >> 2]);
                                                                                                    }
                                                                                                    if ($[y + 11 | 0] < 0 && Sr(e[y >> 2]), $[c + 207 | 0] >= 0)
                                                                                                      break h;
                                                                                                    Sr(e[c + 196 >> 2]);
                                                                                                    break h;
                                                                                                  }
                                                                                                  o = Vr() | 0;
                                                                                                  break O;
                                                                                                }
                                                                                                o = Vr() | 0;
                                                                                                break Q;
                                                                                              }
                                                                                              o = Vr() | 0;
                                                                                              break U;
                                                                                            }
                                                                                            if (o = Vr() | 0, $[c + 411 | 0] >= 0)
                                                                                              break U;
                                                                                            Sr(e[c + 400 >> 2]);
                                                                                          }
                                                                                          if ($[c + 459 | 0] >= 0)
                                                                                            break Q;
                                                                                          Sr(e[c + 448 >> 2]);
                                                                                        }
                                                                                        if ($[c + 475 | 0] >= 0)
                                                                                          break O;
                                                                                        Sr(e[c + 464 >> 2]);
                                                                                      }
                                                                                      if ($[c + 207 | 0] >= 0)
                                                                                        break e;
                                                                                      Sr(e[c + 196 >> 2]);
                                                                                      break e;
                                                                                    }
                                                                                    $[c + 195 | 0] = 2, $[c + 186 | 0] = 0, Vs[c + 184 >> 1] = 14958, e[5996] = 0, y = c + 464 | 0, as(161, y | 0, o | 0, c + 184 | 0), h = e[5996], e[5996] = 0;
                                                                                    q: {
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                if ((h | 0) != 1) {
                                                                                                  if (e[5996] = 0, y = On(97, y | 0, 5574) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                    break M;
                                                                                                  if (e[c + 456 >> 2] = e[y + 8 >> 2], h = e[y + 4 >> 2], e[c + 448 >> 2] = e[y >> 2], e[c + 452 >> 2] = h, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, o = e[e[o >> 2] + 32 >> 2], e[5996] = 0, h = c + 400 | 0, di(141, h | 0, o | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                                    break F;
                                                                                                  if (e[5996] = 0, g = h, o = ye[c + 411 | 0], h = o << 24 >> 24 < 0, o = Si(100, c + 448 | 0, (h ? e[c + 400 >> 2] : g) | 0, (h ? e[c + 404 >> 2] : o) | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                    break U;
                                                                                                  h = e[o + 4 >> 2], e[r >> 2] = e[o >> 2], e[r + 4 >> 2] = h, e[r + 8 >> 2] = e[o + 8 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0;
                                                                                                  L: {
                                                                                                    if ($[c + 411 | 0] >= 0 || (Sr(e[c + 400 >> 2]), $[o + 11 | 0] >= 0))
                                                                                                      break L;
                                                                                                    Sr(e[o >> 2]);
                                                                                                  }
                                                                                                  if ($[y + 11 | 0] < 0 && Sr(e[y >> 2]), $[c + 195 | 0] >= 0)
                                                                                                    break h;
                                                                                                  Sr(e[c + 184 >> 2]);
                                                                                                  break h;
                                                                                                }
                                                                                                o = Vr() | 0;
                                                                                                break q;
                                                                                              }
                                                                                              o = Vr() | 0;
                                                                                              break O;
                                                                                            }
                                                                                            o = Vr() | 0;
                                                                                            break Q;
                                                                                          }
                                                                                          if (o = Vr() | 0, $[c + 411 | 0] >= 0)
                                                                                            break Q;
                                                                                          Sr(e[c + 400 >> 2]);
                                                                                        }
                                                                                        if ($[c + 459 | 0] >= 0)
                                                                                          break O;
                                                                                        Sr(e[c + 448 >> 2]);
                                                                                      }
                                                                                      if ($[c + 475 | 0] >= 0)
                                                                                        break q;
                                                                                      Sr(e[c + 464 >> 2]);
                                                                                    }
                                                                                    if ($[c + 195 | 0] >= 0)
                                                                                      break e;
                                                                                    Sr(e[c + 184 >> 2]);
                                                                                    break e;
                                                                                  }
                                                                                  $[c + 183 | 0] = 2, $[c + 174 | 0] = 0, Vs[c + 172 >> 1] = 14954, e[5996] = 0, y = c + 464 | 0, as(161, y | 0, o | 0, c + 172 | 0), h = e[5996], e[5996] = 0;
                                                                                  P: {
                                                                                    q: {
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              if ((h | 0) != 1) {
                                                                                                if (e[5996] = 0, y = On(97, y | 0, 5574) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                  break F;
                                                                                                if (e[c + 456 >> 2] = e[y + 8 >> 2], h = e[y + 4 >> 2], e[c + 448 >> 2] = e[y >> 2], e[c + 452 >> 2] = h, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, o = e[e[o >> 2] + 32 >> 2], e[5996] = 0, h = c + 400 | 0, di(141, h | 0, o | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                                  break U;
                                                                                                if (e[5996] = 0, g = h, o = ye[c + 411 | 0], h = o << 24 >> 24 < 0, o = Si(100, c + 448 | 0, (h ? e[c + 400 >> 2] : g) | 0, (h ? e[c + 404 >> 2] : o) | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                  break Q;
                                                                                                h = e[o + 4 >> 2], e[r >> 2] = e[o >> 2], e[r + 4 >> 2] = h, e[r + 8 >> 2] = e[o + 8 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0;
                                                                                                M: {
                                                                                                  if ($[c + 411 | 0] >= 0 || (Sr(e[c + 400 >> 2]), $[o + 11 | 0] >= 0))
                                                                                                    break M;
                                                                                                  Sr(e[o >> 2]);
                                                                                                }
                                                                                                if ($[y + 11 | 0] < 0 && Sr(e[y >> 2]), $[c + 183 | 0] >= 0)
                                                                                                  break h;
                                                                                                Sr(e[c + 172 >> 2]);
                                                                                                break h;
                                                                                              }
                                                                                              o = Vr() | 0;
                                                                                              break P;
                                                                                            }
                                                                                            o = Vr() | 0;
                                                                                            break q;
                                                                                          }
                                                                                          o = Vr() | 0;
                                                                                          break O;
                                                                                        }
                                                                                        if (o = Vr() | 0, $[c + 411 | 0] >= 0)
                                                                                          break O;
                                                                                        Sr(e[c + 400 >> 2]);
                                                                                      }
                                                                                      if ($[c + 459 | 0] >= 0)
                                                                                        break q;
                                                                                      Sr(e[c + 448 >> 2]);
                                                                                    }
                                                                                    if ($[c + 475 | 0] >= 0)
                                                                                      break P;
                                                                                    Sr(e[c + 464 >> 2]);
                                                                                  }
                                                                                  if ($[c + 183 | 0] >= 0)
                                                                                    break e;
                                                                                  Sr(e[c + 172 >> 2]);
                                                                                  break e;
                                                                                }
                                                                                $[c + 164 | 0] = ye[1271], $[c + 171 | 0] = 5, $[c + 165 | 0] = 0, e[5996] = 0, e[c + 160 >> 2] = ye[1267] | ye[1268] << 8 | (ye[1269] << 16 | ye[1270] << 24), y = c + 368 | 0, as(161, y | 0, o | 0, c + 160 | 0), h = e[5996], e[5996] = 0;
                                                                                D: {
                                                                                  P: {
                                                                                    q: {
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    K: {
                                                                                                      W: {
                                                                                                        G: {
                                                                                                          V: {
                                                                                                            if ((h | 0) != 1) {
                                                                                                              if (e[5996] = 0, y = On(97, y | 0, 3673) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                                break V;
                                                                                                              if (e[c + 392 >> 2] = e[y + 8 >> 2], h = e[y + 4 >> 2], e[c + 384 >> 2] = e[y >> 2], e[c + 388 >> 2] = h, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, h = e[e[o >> 2] + 32 >> 2], e[5996] = 0, g = c + 144 | 0, di(141, g | 0, h | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                                break G;
                                                                                                              if (e[5996] = 0, S = g, h = ye[c + 155 | 0], g = h << 24 >> 24 < 0, h = Si(100, c + 384 | 0, (g ? e[c + 144 >> 2] : S) | 0, (g ? e[c + 148 >> 2] : h) | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                                                break W;
                                                                                                              if (e[c + 408 >> 2] = e[h + 8 >> 2], g = e[h + 4 >> 2], e[c + 400 >> 2] = e[h >> 2], e[c + 404 >> 2] = g, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, g = On(97, c + 400 | 0, 3613) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                                break K;
                                                                                                              if (e[c + 472 >> 2] = e[g + 8 >> 2], S = e[g + 4 >> 2], e[c + 464 >> 2] = e[g >> 2], e[c + 468 >> 2] = S, e[g >> 2] = 0, e[g + 4 >> 2] = 0, e[g + 8 >> 2] = 0, o = e[e[o >> 2] + 32 >> 2], e[5996] = 0, S = c + 128 | 0, di(141, S | 0, o + 8 | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                                                break H;
                                                                                                              if (e[5996] = 0, G = S, o = ye[c + 139 | 0], S = o << 24 >> 24 < 0, S = Si(100, c + 464 | 0, (S ? e[c + 128 >> 2] : G) | 0, (S ? e[c + 132 >> 2] : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                                                break L;
                                                                                                              if (e[c + 456 >> 2] = e[S + 8 >> 2], o = e[S + 4 >> 2], e[c + 448 >> 2] = e[S >> 2], e[c + 452 >> 2] = o, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, e[5996] = 0, o = On(97, c + 448 | 0, 3570) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                                                                break M;
                                                                                                              if (G = e[o + 4 >> 2], e[r >> 2] = e[o >> 2], e[r + 4 >> 2] = G, e[r + 8 >> 2] = e[o + 8 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, $[c + 139 | 0] < 0 && Sr(e[c + 128 >> 2]), $[S + 11 | 0] < 0 && Sr(e[S >> 2]), $[g + 11 | 0] < 0 && Sr(e[g >> 2]), $[c + 155 | 0] < 0 && Sr(e[c + 144 >> 2]), $[h + 11 | 0] < 0 && Sr(e[h >> 2]), $[y + 11 | 0] < 0 && Sr(e[y >> 2]), $[c + 171 | 0] >= 0)
                                                                                                                break h;
                                                                                                              Sr(e[c + 160 >> 2]);
                                                                                                              break h;
                                                                                                            }
                                                                                                            o = Vr() | 0;
                                                                                                            break D;
                                                                                                          }
                                                                                                          o = Vr() | 0;
                                                                                                          break P;
                                                                                                        }
                                                                                                        o = Vr() | 0;
                                                                                                        break q;
                                                                                                      }
                                                                                                      o = Vr() | 0;
                                                                                                      break O;
                                                                                                    }
                                                                                                    o = Vr() | 0;
                                                                                                    break Q;
                                                                                                  }
                                                                                                  o = Vr() | 0;
                                                                                                  break U;
                                                                                                }
                                                                                                o = Vr() | 0;
                                                                                                break F;
                                                                                              }
                                                                                              if (o = Vr() | 0, $[c + 459 | 0] >= 0)
                                                                                                break F;
                                                                                              Sr(e[c + 448 >> 2]);
                                                                                            }
                                                                                            if ($[c + 139 | 0] >= 0)
                                                                                              break U;
                                                                                            Sr(e[c + 128 >> 2]);
                                                                                          }
                                                                                          if ($[c + 475 | 0] >= 0)
                                                                                            break Q;
                                                                                          Sr(e[c + 464 >> 2]);
                                                                                        }
                                                                                        if ($[c + 411 | 0] >= 0)
                                                                                          break O;
                                                                                        Sr(e[c + 400 >> 2]);
                                                                                      }
                                                                                      if ($[c + 155 | 0] >= 0)
                                                                                        break q;
                                                                                      Sr(e[c + 144 >> 2]);
                                                                                    }
                                                                                    if ($[c + 395 | 0] >= 0)
                                                                                      break P;
                                                                                    Sr(e[c + 384 >> 2]);
                                                                                  }
                                                                                  if ($[c + 379 | 0] >= 0)
                                                                                    break D;
                                                                                  Sr(e[c + 368 >> 2]);
                                                                                }
                                                                                if ($[c + 171 | 0] >= 0)
                                                                                  break e;
                                                                                Sr(e[c + 160 >> 2]);
                                                                                break e;
                                                                              }
                                                                              $[c + 120 | 0] = ye[2551], $[c + 127 | 0] = 5, $[c + 121 | 0] = 0, e[5996] = 0, e[c + 116 >> 2] = ye[2547] | ye[2548] << 8 | (ye[2549] << 16 | ye[2550] << 24), y = c + 368 | 0, as(161, y | 0, o | 0, c + 116 | 0), h = e[5996], e[5996] = 0;
                                                                              y: {
                                                                                D: {
                                                                                  P: {
                                                                                    q: {
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    K: {
                                                                                                      W: {
                                                                                                        G: {
                                                                                                          if ((h | 0) != 1) {
                                                                                                            if (e[5996] = 0, y = On(97, y | 0, 3673) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                              break G;
                                                                                                            if (e[c + 392 >> 2] = e[y + 8 >> 2], h = e[y + 4 >> 2], e[c + 384 >> 2] = e[y >> 2], e[c + 388 >> 2] = h, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, h = e[e[o >> 2] + 32 >> 2], e[5996] = 0, g = c + 144 | 0, di(141, g | 0, h | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                              break W;
                                                                                                            if (e[5996] = 0, S = g, h = ye[c + 155 | 0], g = h << 24 >> 24 < 0, h = Si(100, c + 384 | 0, (g ? e[c + 144 >> 2] : S) | 0, (g ? e[c + 148 >> 2] : h) | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                                              break K;
                                                                                                            if (e[c + 408 >> 2] = e[h + 8 >> 2], g = e[h + 4 >> 2], e[c + 400 >> 2] = e[h >> 2], e[c + 404 >> 2] = g, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, g = On(97, c + 400 | 0, 3613) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                              break H;
                                                                                                            if (e[c + 472 >> 2] = e[g + 8 >> 2], S = e[g + 4 >> 2], e[c + 464 >> 2] = e[g >> 2], e[c + 468 >> 2] = S, e[g >> 2] = 0, e[g + 4 >> 2] = 0, e[g + 8 >> 2] = 0, o = e[e[o >> 2] + 32 >> 2], e[5996] = 0, S = c + 128 | 0, di(141, S | 0, o + 8 | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                                              break L;
                                                                                                            if (e[5996] = 0, G = S, o = ye[c + 139 | 0], S = o << 24 >> 24 < 0, S = Si(100, c + 464 | 0, (S ? e[c + 128 >> 2] : G) | 0, (S ? e[c + 132 >> 2] : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                                              break M;
                                                                                                            if (e[c + 456 >> 2] = e[S + 8 >> 2], o = e[S + 4 >> 2], e[c + 448 >> 2] = e[S >> 2], e[c + 452 >> 2] = o, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, e[5996] = 0, o = On(97, c + 448 | 0, 3570) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                                                              break F;
                                                                                                            if (G = e[o + 4 >> 2], e[r >> 2] = e[o >> 2], e[r + 4 >> 2] = G, e[r + 8 >> 2] = e[o + 8 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, $[c + 139 | 0] < 0 && Sr(e[c + 128 >> 2]), $[S + 11 | 0] < 0 && Sr(e[S >> 2]), $[g + 11 | 0] < 0 && Sr(e[g >> 2]), $[c + 155 | 0] < 0 && Sr(e[c + 144 >> 2]), $[h + 11 | 0] < 0 && Sr(e[h >> 2]), $[y + 11 | 0] < 0 && Sr(e[y >> 2]), $[c + 127 | 0] >= 0)
                                                                                                              break h;
                                                                                                            Sr(e[c + 116 >> 2]);
                                                                                                            break h;
                                                                                                          }
                                                                                                          o = Vr() | 0;
                                                                                                          break y;
                                                                                                        }
                                                                                                        o = Vr() | 0;
                                                                                                        break D;
                                                                                                      }
                                                                                                      o = Vr() | 0;
                                                                                                      break P;
                                                                                                    }
                                                                                                    o = Vr() | 0;
                                                                                                    break q;
                                                                                                  }
                                                                                                  o = Vr() | 0;
                                                                                                  break O;
                                                                                                }
                                                                                                o = Vr() | 0;
                                                                                                break Q;
                                                                                              }
                                                                                              o = Vr() | 0;
                                                                                              break U;
                                                                                            }
                                                                                            if (o = Vr() | 0, $[c + 459 | 0] >= 0)
                                                                                              break U;
                                                                                            Sr(e[c + 448 >> 2]);
                                                                                          }
                                                                                          if ($[c + 139 | 0] >= 0)
                                                                                            break Q;
                                                                                          Sr(e[c + 128 >> 2]);
                                                                                        }
                                                                                        if ($[c + 475 | 0] >= 0)
                                                                                          break O;
                                                                                        Sr(e[c + 464 >> 2]);
                                                                                      }
                                                                                      if ($[c + 411 | 0] >= 0)
                                                                                        break q;
                                                                                      Sr(e[c + 400 >> 2]);
                                                                                    }
                                                                                    if ($[c + 155 | 0] >= 0)
                                                                                      break P;
                                                                                    Sr(e[c + 144 >> 2]);
                                                                                  }
                                                                                  if ($[c + 395 | 0] >= 0)
                                                                                    break D;
                                                                                  Sr(e[c + 384 >> 2]);
                                                                                }
                                                                                if ($[c + 379 | 0] >= 0)
                                                                                  break y;
                                                                                Sr(e[c + 368 >> 2]);
                                                                              }
                                                                              if ($[c + 127 | 0] >= 0)
                                                                                break e;
                                                                              Sr(e[c + 116 >> 2]);
                                                                              break e;
                                                                            }
                                                                            $[c + 115 | 0] = 4, $[c + 108 | 0] = 0, e[c + 104 >> 2] = 1650422383, e[5996] = 0, y = c + 368 | 0, as(161, y | 0, o | 0, c + 104 | 0), h = e[5996], e[5996] = 0;
                                                                            C: {
                                                                              y: {
                                                                                D: {
                                                                                  P: {
                                                                                    q: {
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    K: {
                                                                                                      W: {
                                                                                                        if ((h | 0) != 1) {
                                                                                                          if (e[5996] = 0, y = On(97, y | 0, 3673) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                            break W;
                                                                                                          if (e[c + 392 >> 2] = e[y + 8 >> 2], h = e[y + 4 >> 2], e[c + 384 >> 2] = e[y >> 2], e[c + 388 >> 2] = h, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, h = e[e[o >> 2] + 32 >> 2], e[5996] = 0, g = c + 144 | 0, di(141, g | 0, h | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                            break K;
                                                                                                          if (e[5996] = 0, S = g, h = ye[c + 155 | 0], g = h << 24 >> 24 < 0, h = Si(100, c + 384 | 0, (g ? e[c + 144 >> 2] : S) | 0, (g ? e[c + 148 >> 2] : h) | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                                            break H;
                                                                                                          if (e[c + 408 >> 2] = e[h + 8 >> 2], g = e[h + 4 >> 2], e[c + 400 >> 2] = e[h >> 2], e[c + 404 >> 2] = g, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, g = On(97, c + 400 | 0, 3613) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                            break L;
                                                                                                          if (e[c + 472 >> 2] = e[g + 8 >> 2], S = e[g + 4 >> 2], e[c + 464 >> 2] = e[g >> 2], e[c + 468 >> 2] = S, e[g >> 2] = 0, e[g + 4 >> 2] = 0, e[g + 8 >> 2] = 0, o = e[e[o >> 2] + 32 >> 2], e[5996] = 0, S = c + 128 | 0, di(141, S | 0, o + 8 | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                                            break M;
                                                                                                          if (e[5996] = 0, G = S, o = ye[c + 139 | 0], S = o << 24 >> 24 < 0, S = Si(100, c + 464 | 0, (S ? e[c + 128 >> 2] : G) | 0, (S ? e[c + 132 >> 2] : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                                            break F;
                                                                                                          if (e[c + 456 >> 2] = e[S + 8 >> 2], o = e[S + 4 >> 2], e[c + 448 >> 2] = e[S >> 2], e[c + 452 >> 2] = o, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, e[5996] = 0, o = On(97, c + 448 | 0, 3570) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                                                            break U;
                                                                                                          if (G = e[o + 4 >> 2], e[r >> 2] = e[o >> 2], e[r + 4 >> 2] = G, e[r + 8 >> 2] = e[o + 8 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, $[c + 139 | 0] < 0 && Sr(e[c + 128 >> 2]), $[S + 11 | 0] < 0 && Sr(e[S >> 2]), $[g + 11 | 0] < 0 && Sr(e[g >> 2]), $[c + 155 | 0] < 0 && Sr(e[c + 144 >> 2]), $[h + 11 | 0] < 0 && Sr(e[h >> 2]), $[y + 11 | 0] < 0 && Sr(e[y >> 2]), $[c + 115 | 0] >= 0)
                                                                                                            break h;
                                                                                                          Sr(e[c + 104 >> 2]);
                                                                                                          break h;
                                                                                                        }
                                                                                                        o = Vr() | 0;
                                                                                                        break C;
                                                                                                      }
                                                                                                      o = Vr() | 0;
                                                                                                      break y;
                                                                                                    }
                                                                                                    o = Vr() | 0;
                                                                                                    break D;
                                                                                                  }
                                                                                                  o = Vr() | 0;
                                                                                                  break P;
                                                                                                }
                                                                                                o = Vr() | 0;
                                                                                                break q;
                                                                                              }
                                                                                              o = Vr() | 0;
                                                                                              break O;
                                                                                            }
                                                                                            o = Vr() | 0;
                                                                                            break Q;
                                                                                          }
                                                                                          if (o = Vr() | 0, $[c + 459 | 0] >= 0)
                                                                                            break Q;
                                                                                          Sr(e[c + 448 >> 2]);
                                                                                        }
                                                                                        if ($[c + 139 | 0] >= 0)
                                                                                          break O;
                                                                                        Sr(e[c + 128 >> 2]);
                                                                                      }
                                                                                      if ($[c + 475 | 0] >= 0)
                                                                                        break q;
                                                                                      Sr(e[c + 464 >> 2]);
                                                                                    }
                                                                                    if ($[c + 411 | 0] >= 0)
                                                                                      break P;
                                                                                    Sr(e[c + 400 >> 2]);
                                                                                  }
                                                                                  if ($[c + 155 | 0] >= 0)
                                                                                    break D;
                                                                                  Sr(e[c + 144 >> 2]);
                                                                                }
                                                                                if ($[c + 395 | 0] >= 0)
                                                                                  break y;
                                                                                Sr(e[c + 384 >> 2]);
                                                                              }
                                                                              if ($[c + 379 | 0] >= 0)
                                                                                break C;
                                                                              Sr(e[c + 368 >> 2]);
                                                                            }
                                                                            if ($[c + 115 | 0] >= 0)
                                                                              break e;
                                                                            Sr(e[c + 104 >> 2]);
                                                                            break e;
                                                                          }
                                                                          $[c + 103 | 0] = 4, $[c + 96 | 0] = 0, e[c + 92 >> 2] = 1667199599, e[5996] = 0, y = c + 368 | 0, as(161, y | 0, o | 0, c + 92 | 0), h = e[5996], e[5996] = 0;
                                                                          E: {
                                                                            C: {
                                                                              y: {
                                                                                D: {
                                                                                  P: {
                                                                                    q: {
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    K: {
                                                                                                      if ((h | 0) != 1) {
                                                                                                        if (e[5996] = 0, y = On(97, y | 0, 3673) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                          break K;
                                                                                                        if (e[c + 392 >> 2] = e[y + 8 >> 2], h = e[y + 4 >> 2], e[c + 384 >> 2] = e[y >> 2], e[c + 388 >> 2] = h, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, h = e[e[o >> 2] + 32 >> 2], e[5996] = 0, g = c + 144 | 0, di(141, g | 0, h | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                          break H;
                                                                                                        if (e[5996] = 0, S = g, h = ye[c + 155 | 0], g = h << 24 >> 24 < 0, h = Si(100, c + 384 | 0, (g ? e[c + 144 >> 2] : S) | 0, (g ? e[c + 148 >> 2] : h) | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                                          break L;
                                                                                                        if (e[c + 408 >> 2] = e[h + 8 >> 2], g = e[h + 4 >> 2], e[c + 400 >> 2] = e[h >> 2], e[c + 404 >> 2] = g, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, g = On(97, c + 400 | 0, 3613) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                          break M;
                                                                                                        if (e[c + 472 >> 2] = e[g + 8 >> 2], S = e[g + 4 >> 2], e[c + 464 >> 2] = e[g >> 2], e[c + 468 >> 2] = S, e[g >> 2] = 0, e[g + 4 >> 2] = 0, e[g + 8 >> 2] = 0, o = e[e[o >> 2] + 32 >> 2], e[5996] = 0, S = c + 128 | 0, di(141, S | 0, o + 8 | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                                          break F;
                                                                                                        if (e[5996] = 0, G = S, o = ye[c + 139 | 0], S = o << 24 >> 24 < 0, S = Si(100, c + 464 | 0, (S ? e[c + 128 >> 2] : G) | 0, (S ? e[c + 132 >> 2] : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                                          break U;
                                                                                                        if (e[c + 456 >> 2] = e[S + 8 >> 2], o = e[S + 4 >> 2], e[c + 448 >> 2] = e[S >> 2], e[c + 452 >> 2] = o, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, e[5996] = 0, o = On(97, c + 448 | 0, 3570) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                                                          break Q;
                                                                                                        if (G = e[o + 4 >> 2], e[r >> 2] = e[o >> 2], e[r + 4 >> 2] = G, e[r + 8 >> 2] = e[o + 8 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, $[c + 139 | 0] < 0 && Sr(e[c + 128 >> 2]), $[S + 11 | 0] < 0 && Sr(e[S >> 2]), $[g + 11 | 0] < 0 && Sr(e[g >> 2]), $[c + 155 | 0] < 0 && Sr(e[c + 144 >> 2]), $[h + 11 | 0] < 0 && Sr(e[h >> 2]), $[y + 11 | 0] < 0 && Sr(e[y >> 2]), $[c + 103 | 0] >= 0)
                                                                                                          break h;
                                                                                                        Sr(e[c + 92 >> 2]);
                                                                                                        break h;
                                                                                                      }
                                                                                                      o = Vr() | 0;
                                                                                                      break E;
                                                                                                    }
                                                                                                    o = Vr() | 0;
                                                                                                    break C;
                                                                                                  }
                                                                                                  o = Vr() | 0;
                                                                                                  break y;
                                                                                                }
                                                                                                o = Vr() | 0;
                                                                                                break D;
                                                                                              }
                                                                                              o = Vr() | 0;
                                                                                              break P;
                                                                                            }
                                                                                            o = Vr() | 0;
                                                                                            break q;
                                                                                          }
                                                                                          o = Vr() | 0;
                                                                                          break O;
                                                                                        }
                                                                                        if (o = Vr() | 0, $[c + 459 | 0] >= 0)
                                                                                          break O;
                                                                                        Sr(e[c + 448 >> 2]);
                                                                                      }
                                                                                      if ($[c + 139 | 0] >= 0)
                                                                                        break q;
                                                                                      Sr(e[c + 128 >> 2]);
                                                                                    }
                                                                                    if ($[c + 475 | 0] >= 0)
                                                                                      break P;
                                                                                    Sr(e[c + 464 >> 2]);
                                                                                  }
                                                                                  if ($[c + 411 | 0] >= 0)
                                                                                    break D;
                                                                                  Sr(e[c + 400 >> 2]);
                                                                                }
                                                                                if ($[c + 155 | 0] >= 0)
                                                                                  break y;
                                                                                Sr(e[c + 144 >> 2]);
                                                                              }
                                                                              if ($[c + 395 | 0] >= 0)
                                                                                break C;
                                                                              Sr(e[c + 384 >> 2]);
                                                                            }
                                                                            if ($[c + 379 | 0] >= 0)
                                                                              break E;
                                                                            Sr(e[c + 368 >> 2]);
                                                                          }
                                                                          if ($[c + 103 | 0] >= 0)
                                                                            break e;
                                                                          Sr(e[c + 92 >> 2]);
                                                                          break e;
                                                                        }
                                                                        $[c + 91 | 0] = 4, $[c + 84 | 0] = 0, e[c + 80 >> 2] = 1683976815, e[5996] = 0, y = c + 368 | 0, as(161, y | 0, o | 0, c + 80 | 0), h = e[5996], e[5996] = 0;
                                                                        R: {
                                                                          E: {
                                                                            C: {
                                                                              y: {
                                                                                D: {
                                                                                  P: {
                                                                                    q: {
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    if ((h | 0) != 1) {
                                                                                                      if (e[5996] = 0, y = On(97, y | 0, 3673) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                        break H;
                                                                                                      if (e[c + 392 >> 2] = e[y + 8 >> 2], h = e[y + 4 >> 2], e[c + 384 >> 2] = e[y >> 2], e[c + 388 >> 2] = h, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, h = e[e[o >> 2] + 32 >> 2], e[5996] = 0, g = c + 144 | 0, di(141, g | 0, h | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                        break L;
                                                                                                      if (e[5996] = 0, S = g, h = ye[c + 155 | 0], g = h << 24 >> 24 < 0, h = Si(100, c + 384 | 0, (g ? e[c + 144 >> 2] : S) | 0, (g ? e[c + 148 >> 2] : h) | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                                        break M;
                                                                                                      if (e[c + 408 >> 2] = e[h + 8 >> 2], g = e[h + 4 >> 2], e[c + 400 >> 2] = e[h >> 2], e[c + 404 >> 2] = g, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, g = On(97, c + 400 | 0, 3613) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                        break F;
                                                                                                      if (e[c + 472 >> 2] = e[g + 8 >> 2], S = e[g + 4 >> 2], e[c + 464 >> 2] = e[g >> 2], e[c + 468 >> 2] = S, e[g >> 2] = 0, e[g + 4 >> 2] = 0, e[g + 8 >> 2] = 0, o = e[e[o >> 2] + 32 >> 2], e[5996] = 0, S = c + 128 | 0, di(141, S | 0, o + 8 | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                                        break U;
                                                                                                      if (e[5996] = 0, G = S, o = ye[c + 139 | 0], S = o << 24 >> 24 < 0, S = Si(100, c + 464 | 0, (S ? e[c + 128 >> 2] : G) | 0, (S ? e[c + 132 >> 2] : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                                        break Q;
                                                                                                      if (e[c + 456 >> 2] = e[S + 8 >> 2], o = e[S + 4 >> 2], e[c + 448 >> 2] = e[S >> 2], e[c + 452 >> 2] = o, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, e[5996] = 0, o = On(97, c + 448 | 0, 3570) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                                                        break O;
                                                                                                      if (G = e[o + 4 >> 2], e[r >> 2] = e[o >> 2], e[r + 4 >> 2] = G, e[r + 8 >> 2] = e[o + 8 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, $[c + 139 | 0] < 0 && Sr(e[c + 128 >> 2]), $[S + 11 | 0] < 0 && Sr(e[S >> 2]), $[g + 11 | 0] < 0 && Sr(e[g >> 2]), $[c + 155 | 0] < 0 && Sr(e[c + 144 >> 2]), $[h + 11 | 0] < 0 && Sr(e[h >> 2]), $[y + 11 | 0] < 0 && Sr(e[y >> 2]), $[c + 91 | 0] >= 0)
                                                                                                        break h;
                                                                                                      Sr(e[c + 80 >> 2]);
                                                                                                      break h;
                                                                                                    }
                                                                                                    o = Vr() | 0;
                                                                                                    break R;
                                                                                                  }
                                                                                                  o = Vr() | 0;
                                                                                                  break E;
                                                                                                }
                                                                                                o = Vr() | 0;
                                                                                                break C;
                                                                                              }
                                                                                              o = Vr() | 0;
                                                                                              break y;
                                                                                            }
                                                                                            o = Vr() | 0;
                                                                                            break D;
                                                                                          }
                                                                                          o = Vr() | 0;
                                                                                          break P;
                                                                                        }
                                                                                        o = Vr() | 0;
                                                                                        break q;
                                                                                      }
                                                                                      if (o = Vr() | 0, $[c + 459 | 0] >= 0)
                                                                                        break q;
                                                                                      Sr(e[c + 448 >> 2]);
                                                                                    }
                                                                                    if ($[c + 139 | 0] >= 0)
                                                                                      break P;
                                                                                    Sr(e[c + 128 >> 2]);
                                                                                  }
                                                                                  if ($[c + 475 | 0] >= 0)
                                                                                    break D;
                                                                                  Sr(e[c + 464 >> 2]);
                                                                                }
                                                                                if ($[c + 411 | 0] >= 0)
                                                                                  break y;
                                                                                Sr(e[c + 400 >> 2]);
                                                                              }
                                                                              if ($[c + 155 | 0] >= 0)
                                                                                break C;
                                                                              Sr(e[c + 144 >> 2]);
                                                                            }
                                                                            if ($[c + 395 | 0] >= 0)
                                                                              break E;
                                                                            Sr(e[c + 384 >> 2]);
                                                                          }
                                                                          if ($[c + 379 | 0] >= 0)
                                                                            break R;
                                                                          Sr(e[c + 368 >> 2]);
                                                                        }
                                                                        if ($[c + 91 | 0] >= 0)
                                                                          break e;
                                                                        Sr(e[c + 80 >> 2]);
                                                                        break e;
                                                                      }
                                                                      $[c + 79 | 0] = 4, $[c + 72 | 0] = 0, e[c + 68 >> 2] = 1767862895, e[5996] = 0, y = c + 368 | 0, as(161, y | 0, o | 0, c + 68 | 0), h = e[5996], e[5996] = 0;
                                                                      B: {
                                                                        R: {
                                                                          E: {
                                                                            C: {
                                                                              y: {
                                                                                D: {
                                                                                  P: {
                                                                                    q: {
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  if ((h | 0) != 1) {
                                                                                                    if (e[5996] = 0, y = On(97, y | 0, 3673) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                      break L;
                                                                                                    if (e[c + 392 >> 2] = e[y + 8 >> 2], h = e[y + 4 >> 2], e[c + 384 >> 2] = e[y >> 2], e[c + 388 >> 2] = h, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, h = e[e[o >> 2] + 32 >> 2], e[5996] = 0, g = c + 144 | 0, di(141, g | 0, h | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                      break M;
                                                                                                    if (e[5996] = 0, S = g, h = ye[c + 155 | 0], g = h << 24 >> 24 < 0, h = Si(100, c + 384 | 0, (g ? e[c + 144 >> 2] : S) | 0, (g ? e[c + 148 >> 2] : h) | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                                      break F;
                                                                                                    if (e[c + 408 >> 2] = e[h + 8 >> 2], g = e[h + 4 >> 2], e[c + 400 >> 2] = e[h >> 2], e[c + 404 >> 2] = g, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, g = On(97, c + 400 | 0, 3613) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                      break U;
                                                                                                    if (e[c + 472 >> 2] = e[g + 8 >> 2], S = e[g + 4 >> 2], e[c + 464 >> 2] = e[g >> 2], e[c + 468 >> 2] = S, e[g >> 2] = 0, e[g + 4 >> 2] = 0, e[g + 8 >> 2] = 0, o = e[e[o >> 2] + 32 >> 2], e[5996] = 0, S = c + 128 | 0, di(141, S | 0, o + 8 | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                                      break Q;
                                                                                                    if (e[5996] = 0, G = S, o = ye[c + 139 | 0], S = o << 24 >> 24 < 0, S = Si(100, c + 464 | 0, (S ? e[c + 128 >> 2] : G) | 0, (S ? e[c + 132 >> 2] : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                                      break O;
                                                                                                    if (e[c + 456 >> 2] = e[S + 8 >> 2], o = e[S + 4 >> 2], e[c + 448 >> 2] = e[S >> 2], e[c + 452 >> 2] = o, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, e[5996] = 0, o = On(97, c + 448 | 0, 3570) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                                                      break q;
                                                                                                    if (G = e[o + 4 >> 2], e[r >> 2] = e[o >> 2], e[r + 4 >> 2] = G, e[r + 8 >> 2] = e[o + 8 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, $[c + 139 | 0] < 0 && Sr(e[c + 128 >> 2]), $[S + 11 | 0] < 0 && Sr(e[S >> 2]), $[g + 11 | 0] < 0 && Sr(e[g >> 2]), $[c + 155 | 0] < 0 && Sr(e[c + 144 >> 2]), $[h + 11 | 0] < 0 && Sr(e[h >> 2]), $[y + 11 | 0] < 0 && Sr(e[y >> 2]), $[c + 79 | 0] >= 0)
                                                                                                      break h;
                                                                                                    Sr(e[c + 68 >> 2]);
                                                                                                    break h;
                                                                                                  }
                                                                                                  o = Vr() | 0;
                                                                                                  break B;
                                                                                                }
                                                                                                o = Vr() | 0;
                                                                                                break R;
                                                                                              }
                                                                                              o = Vr() | 0;
                                                                                              break E;
                                                                                            }
                                                                                            o = Vr() | 0;
                                                                                            break C;
                                                                                          }
                                                                                          o = Vr() | 0;
                                                                                          break y;
                                                                                        }
                                                                                        o = Vr() | 0;
                                                                                        break D;
                                                                                      }
                                                                                      o = Vr() | 0;
                                                                                      break P;
                                                                                    }
                                                                                    if (o = Vr() | 0, $[c + 459 | 0] >= 0)
                                                                                      break P;
                                                                                    Sr(e[c + 448 >> 2]);
                                                                                  }
                                                                                  if ($[c + 139 | 0] >= 0)
                                                                                    break D;
                                                                                  Sr(e[c + 128 >> 2]);
                                                                                }
                                                                                if ($[c + 475 | 0] >= 0)
                                                                                  break y;
                                                                                Sr(e[c + 464 >> 2]);
                                                                              }
                                                                              if ($[c + 411 | 0] >= 0)
                                                                                break C;
                                                                              Sr(e[c + 400 >> 2]);
                                                                            }
                                                                            if ($[c + 155 | 0] >= 0)
                                                                              break E;
                                                                            Sr(e[c + 144 >> 2]);
                                                                          }
                                                                          if ($[c + 395 | 0] >= 0)
                                                                            break R;
                                                                          Sr(e[c + 384 >> 2]);
                                                                        }
                                                                        if ($[c + 379 | 0] >= 0)
                                                                          break B;
                                                                        Sr(e[c + 368 >> 2]);
                                                                      }
                                                                      if ($[c + 79 | 0] >= 0)
                                                                        break e;
                                                                      Sr(e[c + 68 >> 2]);
                                                                      break e;
                                                                    }
                                                                    Vs[c - -64 >> 1] = ye[2600] | ye[2601] << 8, Vs[c + 66 >> 1] = 2560, e[5996] = 0, y = ye[2596] | ye[2597] << 8 | (ye[2598] << 16 | ye[2599] << 24), e[c + 56 >> 2] = ye[2592] | ye[2593] << 8 | (ye[2594] << 16 | ye[2595] << 24), e[c + 60 >> 2] = y, y = c + 128 | 0, as(161, y | 0, o | 0, c + 56 | 0), h = e[5996], e[5996] = 0;
                                                                    m: {
                                                                      B: {
                                                                        R: {
                                                                          E: {
                                                                            C: {
                                                                              y: {
                                                                                D: {
                                                                                  P: {
                                                                                    q: {
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    K: {
                                                                                                      W: {
                                                                                                        G: {
                                                                                                          V: {
                                                                                                            if ((h | 0) != 1) {
                                                                                                              if (e[5996] = 0, y = On(97, y | 0, 3623) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                                break V;
                                                                                                              if (e[c + 152 >> 2] = e[y + 8 >> 2], h = e[y + 4 >> 2], e[c + 144 >> 2] = e[y >> 2], e[c + 148 >> 2] = h, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, h = e[e[o >> 2] + 32 >> 2], e[5996] = 0, g = c + 40 | 0, di(141, g | 0, h | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                                                break G;
                                                                                                              if (e[5996] = 0, S = g, h = ye[c + 51 | 0], g = h << 24 >> 24 < 0, h = Si(100, c + 144 | 0, (g ? e[c + 40 >> 2] : S) | 0, (g ? e[c + 44 >> 2] : h) | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                                                break W;
                                                                                                              if (e[c + 376 >> 2] = e[h + 8 >> 2], g = e[h + 4 >> 2], e[c + 368 >> 2] = e[h >> 2], e[c + 372 >> 2] = g, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, g = On(97, c + 368 | 0, 3613) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                                break K;
                                                                                                              if (e[c + 392 >> 2] = e[g + 8 >> 2], S = e[g + 4 >> 2], e[c + 384 >> 2] = e[g >> 2], e[c + 388 >> 2] = S, e[g >> 2] = 0, e[g + 4 >> 2] = 0, e[g + 8 >> 2] = 0, S = e[e[o >> 2] + 32 >> 2], e[5996] = 0, G = c + 28 | 0, di(141, G | 0, S + 8 | 0), S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                                break H;
                                                                                                              if (e[5996] = 0, ke = G, S = ye[c + 39 | 0], G = S << 24 >> 24 < 0, S = Si(100, c + 384 | 0, (G ? e[c + 28 >> 2] : ke) | 0, (G ? e[c + 32 >> 2] : S) | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                                                                break L;
                                                                                                              if (e[c + 408 >> 2] = e[S + 8 >> 2], G = e[S + 4 >> 2], e[c + 400 >> 2] = e[S >> 2], e[c + 404 >> 2] = G, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, e[5996] = 0, G = On(97, c + 400 | 0, 3603) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                                                                break M;
                                                                                                              if (e[c + 472 >> 2] = e[G + 8 >> 2], ke = e[G + 4 >> 2], e[c + 464 >> 2] = e[G >> 2], e[c + 468 >> 2] = ke, e[G >> 2] = 0, e[G + 4 >> 2] = 0, e[G + 8 >> 2] = 0, o = e[e[o >> 2] + 32 >> 2], e[5996] = 0, ke = c + 16 | 0, di(141, ke | 0, o + 16 | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                                                break F;
                                                                                                              if (e[5996] = 0, Fe = ke, o = ye[c + 27 | 0], ke = o << 24 >> 24 < 0, ke = Si(100, c + 464 | 0, (ke ? e[c + 16 >> 2] : Fe) | 0, (ke ? e[c + 20 >> 2] : o) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                                                break U;
                                                                                                              if (e[c + 456 >> 2] = e[ke + 8 >> 2], o = e[ke + 4 >> 2], e[c + 448 >> 2] = e[ke >> 2], e[c + 452 >> 2] = o, e[ke >> 2] = 0, e[ke + 4 >> 2] = 0, e[ke + 8 >> 2] = 0, e[5996] = 0, o = On(97, c + 448 | 0, 3570) | 0, Fe = e[5996], e[5996] = 0, (Fe | 0) == 1)
                                                                                                                break Q;
                                                                                                              if (Fe = e[o + 4 >> 2], e[r >> 2] = e[o >> 2], e[r + 4 >> 2] = Fe, e[r + 8 >> 2] = e[o + 8 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, $[c + 27 | 0] < 0 && Sr(e[c + 16 >> 2]), $[ke + 11 | 0] < 0 && Sr(e[ke >> 2]), $[G + 11 | 0] < 0 && Sr(e[G >> 2]), $[c + 39 | 0] < 0 && Sr(e[c + 28 >> 2]), $[S + 11 | 0] < 0 && Sr(e[S >> 2]), $[g + 11 | 0] < 0 && Sr(e[g >> 2]), $[c + 51 | 0] < 0 && Sr(e[c + 40 >> 2]), $[h + 11 | 0] < 0 && Sr(e[h >> 2]), $[y + 11 | 0] < 0 && Sr(e[y >> 2]), $[c + 67 | 0] >= 0)
                                                                                                                break h;
                                                                                                              Sr(e[c + 56 >> 2]);
                                                                                                              break h;
                                                                                                            }
                                                                                                            o = Vr() | 0;
                                                                                                            break m;
                                                                                                          }
                                                                                                          o = Vr() | 0;
                                                                                                          break B;
                                                                                                        }
                                                                                                        o = Vr() | 0;
                                                                                                        break R;
                                                                                                      }
                                                                                                      o = Vr() | 0;
                                                                                                      break E;
                                                                                                    }
                                                                                                    o = Vr() | 0;
                                                                                                    break C;
                                                                                                  }
                                                                                                  o = Vr() | 0;
                                                                                                  break y;
                                                                                                }
                                                                                                o = Vr() | 0;
                                                                                                break D;
                                                                                              }
                                                                                              o = Vr() | 0;
                                                                                              break P;
                                                                                            }
                                                                                            o = Vr() | 0;
                                                                                            break q;
                                                                                          }
                                                                                          o = Vr() | 0;
                                                                                          break O;
                                                                                        }
                                                                                        if (o = Vr() | 0, $[c + 459 | 0] >= 0)
                                                                                          break O;
                                                                                        Sr(e[c + 448 >> 2]);
                                                                                      }
                                                                                      if ($[c + 27 | 0] >= 0)
                                                                                        break q;
                                                                                      Sr(e[c + 16 >> 2]);
                                                                                    }
                                                                                    if ($[c + 475 | 0] >= 0)
                                                                                      break P;
                                                                                    Sr(e[c + 464 >> 2]);
                                                                                  }
                                                                                  if ($[c + 411 | 0] >= 0)
                                                                                    break D;
                                                                                  Sr(e[c + 400 >> 2]);
                                                                                }
                                                                                if ($[c + 39 | 0] >= 0)
                                                                                  break y;
                                                                                Sr(e[c + 28 >> 2]);
                                                                              }
                                                                              if ($[c + 395 | 0] >= 0)
                                                                                break C;
                                                                              Sr(e[c + 384 >> 2]);
                                                                            }
                                                                            if ($[c + 379 | 0] >= 0)
                                                                              break E;
                                                                            Sr(e[c + 368 >> 2]);
                                                                          }
                                                                          if ($[c + 51 | 0] >= 0)
                                                                            break R;
                                                                          Sr(e[c + 40 >> 2]);
                                                                        }
                                                                        if ($[c + 155 | 0] >= 0)
                                                                          break B;
                                                                        Sr(e[c + 144 >> 2]);
                                                                      }
                                                                      if ($[c + 139 | 0] >= 0)
                                                                        break m;
                                                                      Sr(e[c + 128 >> 2]);
                                                                    }
                                                                    if ($[c + 67 | 0] >= 0)
                                                                      break e;
                                                                    Sr(e[c + 56 >> 2]);
                                                                    break e;
                                                                  }
                                                                  if (h = c + 144 | 0, kc(h, e[y + 4 >> 2]), e[5996] = 0, y = Si(99, h | 0, 0, 5302) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                    break b;
                                                                  if (e[c + 376 >> 2] = e[y + 8 >> 2], h = e[y + 4 >> 2], e[c + 368 >> 2] = e[y >> 2], e[c + 372 >> 2] = h, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, h = On(97, c + 368 | 0, 5417) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                    break w;
                                                                  if (e[c + 392 >> 2] = e[h + 8 >> 2], g = e[h + 4 >> 2], e[c + 384 >> 2] = e[h >> 2], e[c + 388 >> 2] = g, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, g = e[o >> 2], S = e[g + 36 >> 2], g = e[g + 32 >> 2], e[5996] = 0, G = c + 128 | 0, di(115, G | 0, S - g >> 3), g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                    break v;
                                                                  if (e[5996] = 0, g = ye[c + 139 | 0], S = g << 24 >> 24 < 0, g = Si(100, c + 384 | 0, (S ? e[c + 128 >> 2] : G) | 0, (S ? e[c + 132 >> 2] : g) | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                    break T;
                                                                  if (e[c + 408 >> 2] = e[g + 8 >> 2], S = e[g + 4 >> 2], e[c + 400 >> 2] = e[g >> 2], e[c + 404 >> 2] = S, e[g >> 2] = 0, e[g + 4 >> 2] = 0, e[g + 8 >> 2] = 0, e[5996] = 0, S = On(97, c + 400 | 0, 5242) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                    break S;
                                                                  if (e[c + 8 >> 2] = e[S + 8 >> 2], G = e[S + 4 >> 2], e[c >> 2] = e[S >> 2], e[c + 4 >> 2] = G, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, e[5996] = 0, G = c + 464 | 0, as(161, G | 0, o | 0, c | 0), ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                    break N;
                                                                  if (e[5996] = 0, G = On(97, G | 0, 3726) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                    break k;
                                                                  if (e[c + 456 >> 2] = e[G + 8 >> 2], ke = e[G + 4 >> 2], e[c + 448 >> 2] = e[G >> 2], e[c + 452 >> 2] = ke, e[G >> 2] = 0, e[G + 4 >> 2] = 0, e[G + 8 >> 2] = 0, $[c + 11 | 0] < 0 && Sr(e[c >> 2]), $[S + 11 | 0] < 0 && Sr(e[S >> 2]), $[c + 139 | 0] < 0 && Sr(e[c + 128 >> 2]), $[g + 11 | 0] < 0 && Sr(e[g >> 2]), $[h + 11 | 0] < 0 && Sr(e[h >> 2]), $[y + 11 | 0] < 0 && Sr(e[y >> 2]), o = e[o >> 2], h = e[o + 32 >> 2], g = e[o + 36 >> 2], (h | 0) != (g | 0))
                                                                    for (; ; ) {
                                                                      if (e[5996] = 0, o = c + 28 | 0, di(141, o | 0, h | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                        break d;
                                                                      if (e[5996] = 0, o = Si(99, o | 0, 0, 3708) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                        break f;
                                                                      if (e[c + 48 >> 2] = e[o + 8 >> 2], y = e[o + 4 >> 2], e[c + 40 >> 2] = e[o >> 2], e[c + 44 >> 2] = y, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[5996] = 0, y = On(97, c + 40 | 0, 3713) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                        break l;
                                                                      if (e[c + 136 >> 2] = e[y + 8 >> 2], S = e[y + 4 >> 2], e[c + 128 >> 2] = e[y >> 2], e[c + 132 >> 2] = S, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, S = ye[c + 139 | 0], G = S << 24 >> 24 < 0, Si(100, c + 448 | 0, (G ? e[c + 128 >> 2] : c + 128 | 0) | 0, (G ? e[c + 132 >> 2] : S) | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                        break o;
                                                                      if ($[c + 139 | 0] < 0 && Sr(e[c + 128 >> 2]), $[c + 51 | 0] < 0 && Sr(e[y >> 2]), $[c + 39 | 0] < 0 && Sr(e[o >> 2]), h = h + 8 | 0, (g | 0) == (h | 0))
                                                                        break;
                                                                    }
                                                                  if (e[5996] = 0, o = On(97, c + 448 | 0, 3575) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                    break i;
                                                                  y = e[o + 4 >> 2], e[r >> 2] = e[o >> 2], e[r + 4 >> 2] = y, e[r + 8 >> 2] = e[o + 8 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0;
                                                                }
                                                                Yr = c + 496 | 0;
                                                                return;
                                                              }
                                                              o = Vr() | 0;
                                                              break c;
                                                            }
                                                            o = Vr() | 0;
                                                            break u;
                                                          }
                                                          o = Vr() | 0;
                                                          break g;
                                                        }
                                                        o = Vr() | 0;
                                                        break A;
                                                      }
                                                      o = Vr() | 0;
                                                      break p;
                                                    }
                                                    o = Vr() | 0;
                                                    break I;
                                                  }
                                                  if (o = Vr() | 0, $[c + 475 | 0] >= 0)
                                                    break I;
                                                  Sr(e[c + 464 >> 2]);
                                                }
                                                if ($[c + 11 | 0] >= 0)
                                                  break p;
                                                Sr(e[c >> 2]);
                                              }
                                              if ($[c + 411 | 0] >= 0)
                                                break A;
                                              Sr(e[c + 400 >> 2]);
                                            }
                                            if ($[c + 139 | 0] >= 0)
                                              break g;
                                            Sr(e[c + 128 >> 2]);
                                          }
                                          if ($[c + 395 | 0] >= 0)
                                            break u;
                                          Sr(e[c + 384 >> 2]);
                                        }
                                        if ($[c + 379 | 0] >= 0)
                                          break c;
                                        Sr(e[c + 368 >> 2]);
                                      }
                                      if ($[c + 155 | 0] >= 0)
                                        break e;
                                      Sr(e[c + 144 >> 2]);
                                      break e;
                                    }
                                    o = Vr() | 0;
                                    break n;
                                  }
                                  o = Vr() | 0;
                                  break s;
                                }
                                o = Vr() | 0;
                                break a;
                              }
                              if (o = Vr() | 0, $[c + 139 | 0] >= 0)
                                break a;
                              Sr(e[c + 128 >> 2]);
                            }
                            if ($[c + 51 | 0] >= 0)
                              break s;
                            Sr(e[c + 40 >> 2]);
                          }
                          if ($[c + 39 | 0] >= 0)
                            break n;
                          Sr(e[c + 28 >> 2]);
                          break n;
                        }
                        o = Vr() | 0;
                      }
                      if ($[c + 459 | 0] >= 0)
                        break e;
                      Sr(e[c + 448 >> 2]);
                      break e;
                    }
                    if (!ye[c + 460 | 0] | $[c + 459 | 0] >= 0)
                      break e;
                    Sr(e[c + 448 >> 2]);
                    break e;
                  }
                  if ($[c + 475 | 0] >= 0)
                    break e;
                  Sr(e[c + 464 >> 2]);
                }
                Ki(o | 0), ri();
              }
              function jd(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0;
                G = Yr - 48 | 0, Yr = G, e[G + 24 >> 2] = 0, e[G + 16 >> 2] = 0, e[G + 20 >> 2] = 0;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  f: {
                                    d: {
                                      c: {
                                        u: {
                                          g: {
                                            A: {
                                              p: {
                                                I: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v:
                                                            switch (e[r >> 2]) {
                                                              case 1:
                                                                if (e[5996] = 0, o = ii(3, 56) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                  break n;
                                                                if (e[5996] = 0, r = On(32, G + 28 | 0, r + 28 | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                  break T;
                                                                if (e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[o >> 2] = 2, e[o + 12 >> 2] = 0, e[o + 16 >> 2] = e[r >> 2], e[o + 20 >> 2] = e[r + 4 >> 2], e[o + 24 >> 2] = e[r + 8 >> 2], e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[o + 44 >> 2] = 0, e[o + 36 >> 2] = 0, e[o + 40 >> 2] = 0, e[o + 28 >> 2] = 0, e[o + 32 >> 2] = 0, e[5996] = 0, di(33, c | 0, o | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                  break n;
                                                                if (h = e[G + 20 >> 2], g = e[G + 24 >> 2], h >>> 0 < g >>> 0) {
                                                                  e[h >> 2] = o, e[G + 20 >> 2] = h + 4;
                                                                  break A;
                                                                }
                                                                if (r = e[G + 16 >> 2], y = h - r >> 2, S = y + 1 | 0, S >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, Ri(34), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                    break n;
                                                                  break e;
                                                                }
                                                                if (g = g - r | 0, ke = g >> 1, S = g >>> 0 >= 2147483644 ? 1073741823 : S >>> 0 < ke >>> 0 ? ke : S, S) {
                                                                  if (S >>> 0 >= 1073741824) {
                                                                    if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                      break e;
                                                                    break n;
                                                                  }
                                                                  if (e[5996] = 0, Fe = ii(3, S << 2) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                    break n;
                                                                }
                                                                if (y = (y << 2) + Fe | 0, e[y >> 2] = o, g = y + 4 | 0, (r | 0) != (h | 0)) {
                                                                  for (; y = y - 4 | 0, h = h - 4 | 0, e[y >> 2] = e[h >> 2], (r | 0) != (h | 0); )
                                                                    ;
                                                                  h = e[G + 16 >> 2];
                                                                }
                                                                if (e[G + 24 >> 2] = (S << 2) + Fe, e[G + 20 >> 2] = g, e[G + 16 >> 2] = y, !h)
                                                                  break g;
                                                                Sr(h);
                                                                break A;
                                                              case 2:
                                                                if (r = e[r + 52 >> 2], e[5996] = 0, o = ii(3, 56) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1 || (e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[o >> 2] = 4, e[o + 40 >> 2] = r, e[o + 44 >> 2] = 0, e[o + 12 >> 2] = 0, e[o + 16 >> 2] = 0, e[o + 20 >> 2] = 0, e[o + 24 >> 2] = 0, e[o + 28 >> 2] = 0, e[o + 32 >> 2] = 0, e[o + 36 >> 2] = 0, e[5996] = 0, di(33, c | 0, o | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                                                                  break i;
                                                                if (h = e[G + 20 >> 2], g = e[G + 24 >> 2], h >>> 0 < g >>> 0) {
                                                                  e[h >> 2] = o, e[G + 20 >> 2] = h + 4;
                                                                  break A;
                                                                }
                                                                if (r = e[G + 16 >> 2], y = h - r >> 2, S = y + 1 | 0, S >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, Ri(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                    break e;
                                                                  break i;
                                                                }
                                                                if (g = g - r | 0, ke = g >> 1, S = g >>> 0 >= 2147483644 ? 1073741823 : S >>> 0 < ke >>> 0 ? ke : S, S) {
                                                                  if (S >>> 0 >= 1073741824) {
                                                                    if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                      break e;
                                                                    break i;
                                                                  }
                                                                  if (e[5996] = 0, Fe = ii(3, S << 2) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                    break i;
                                                                }
                                                                if (y = (y << 2) + Fe | 0, e[y >> 2] = o, g = y + 4 | 0, (r | 0) != (h | 0)) {
                                                                  for (; y = y - 4 | 0, h = h - 4 | 0, e[y >> 2] = e[h >> 2], (r | 0) != (h | 0); )
                                                                    ;
                                                                  h = e[G + 16 >> 2];
                                                                }
                                                                if (e[G + 24 >> 2] = (S << 2) + Fe, e[G + 20 >> 2] = g, e[G + 16 >> 2] = y, !h)
                                                                  break g;
                                                                Sr(h);
                                                                break A;
                                                              case 3:
                                                                if (r = e[r + 52 >> 2], e[5996] = 0, o = ii(3, 56) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1 || (e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[o >> 2] = 5, e[o + 40 >> 2] = r, e[o + 44 >> 2] = 0, e[o + 12 >> 2] = 0, e[o + 16 >> 2] = 0, e[o + 20 >> 2] = 0, e[o + 24 >> 2] = 0, e[o + 28 >> 2] = 0, e[o + 32 >> 2] = 0, e[o + 36 >> 2] = 0, e[5996] = 0, di(33, c | 0, o | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                                                                  break s;
                                                                if (h = e[G + 20 >> 2], g = e[G + 24 >> 2], h >>> 0 < g >>> 0) {
                                                                  e[h >> 2] = o, e[G + 20 >> 2] = h + 4;
                                                                  break A;
                                                                }
                                                                if (r = e[G + 16 >> 2], y = h - r >> 2, S = y + 1 | 0, S >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, Ri(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                    break e;
                                                                  break s;
                                                                }
                                                                if (g = g - r | 0, ke = g >> 1, S = g >>> 0 >= 2147483644 ? 1073741823 : S >>> 0 < ke >>> 0 ? ke : S, S) {
                                                                  if (S >>> 0 >= 1073741824) {
                                                                    if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                      break e;
                                                                    break s;
                                                                  }
                                                                  if (e[5996] = 0, Fe = ii(3, S << 2) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                    break s;
                                                                }
                                                                if (y = (y << 2) + Fe | 0, e[y >> 2] = o, g = y + 4 | 0, (r | 0) != (h | 0)) {
                                                                  for (; y = y - 4 | 0, h = h - 4 | 0, e[y >> 2] = e[h >> 2], (r | 0) != (h | 0); )
                                                                    ;
                                                                  h = e[G + 16 >> 2];
                                                                }
                                                                if (e[G + 24 >> 2] = (S << 2) + Fe, e[G + 20 >> 2] = g, e[G + 16 >> 2] = y, !h)
                                                                  break g;
                                                                Sr(h);
                                                                break A;
                                                              case 5:
                                                                if (o = e[r + 20 >> 2], r = e[r + 16 >> 2], e[5996] = 0, S = da(36, c | 0, 7, r | 0, o | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                  break a;
                                                                if (h = e[G + 20 >> 2], g = e[G + 24 >> 2], h >>> 0 < g >>> 0) {
                                                                  e[h >> 2] = S, e[G + 20 >> 2] = h + 4;
                                                                  break A;
                                                                }
                                                                if (r = e[G + 16 >> 2], y = h - r >> 2, o = y + 1 | 0, o >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, Ri(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                    break e;
                                                                  break a;
                                                                }
                                                                if (g = g - r | 0, ke = g >> 1, o = g >>> 0 >= 2147483644 ? 1073741823 : o >>> 0 < ke >>> 0 ? ke : o, o) {
                                                                  if (o >>> 0 >= 1073741824) {
                                                                    if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                      break e;
                                                                    break a;
                                                                  }
                                                                  if (e[5996] = 0, Fe = ii(3, o << 2) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                    break a;
                                                                }
                                                                if (y = (y << 2) + Fe | 0, e[y >> 2] = S, g = y + 4 | 0, (r | 0) != (h | 0)) {
                                                                  for (; y = y - 4 | 0, h = h - 4 | 0, e[y >> 2] = e[h >> 2], (r | 0) != (h | 0); )
                                                                    ;
                                                                  h = e[G + 16 >> 2];
                                                                }
                                                                if (e[G + 24 >> 2] = (o << 2) + Fe, e[G + 20 >> 2] = g, e[G + 16 >> 2] = y, !h)
                                                                  break g;
                                                                Sr(h);
                                                                break A;
                                                              case 4:
                                                                if (o = e[r + 20 >> 2], r = e[r + 16 >> 2], e[5996] = 0, S = da(36, c | 0, 6, r | 0, o | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                  break o;
                                                                if (h = e[G + 20 >> 2], g = e[G + 24 >> 2], h >>> 0 < g >>> 0) {
                                                                  e[h >> 2] = S, e[G + 20 >> 2] = h + 4;
                                                                  break A;
                                                                }
                                                                if (r = e[G + 16 >> 2], y = h - r >> 2, o = y + 1 | 0, o >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, Ri(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                    break e;
                                                                  break o;
                                                                }
                                                                if (g = g - r | 0, ke = g >> 1, o = g >>> 0 >= 2147483644 ? 1073741823 : o >>> 0 < ke >>> 0 ? ke : o, o) {
                                                                  if (o >>> 0 >= 1073741824) {
                                                                    if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                      break e;
                                                                    break o;
                                                                  }
                                                                  if (e[5996] = 0, Fe = ii(3, o << 2) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                    break o;
                                                                }
                                                                if (y = (y << 2) + Fe | 0, e[y >> 2] = S, g = y + 4 | 0, (r | 0) != (h | 0)) {
                                                                  for (; y = y - 4 | 0, h = h - 4 | 0, e[y >> 2] = e[h >> 2], (r | 0) != (h | 0); )
                                                                    ;
                                                                  h = e[G + 16 >> 2];
                                                                }
                                                                if (e[G + 24 >> 2] = (o << 2) + Fe, e[G + 20 >> 2] = g, e[G + 16 >> 2] = y, !h)
                                                                  break g;
                                                                Sr(h);
                                                                break A;
                                                              case 7:
                                                                if (o = e[r + 20 >> 2], r = e[r + 16 >> 2], e[5996] = 0, S = da(36, c | 0, 8, r | 0, o | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                  break l;
                                                                if (h = e[G + 20 >> 2], g = e[G + 24 >> 2], h >>> 0 < g >>> 0) {
                                                                  e[h >> 2] = S, e[G + 20 >> 2] = h + 4;
                                                                  break A;
                                                                }
                                                                if (r = e[G + 16 >> 2], y = h - r >> 2, o = y + 1 | 0, o >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, Ri(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                    break e;
                                                                  break l;
                                                                }
                                                                if (g = g - r | 0, ke = g >> 1, o = g >>> 0 >= 2147483644 ? 1073741823 : o >>> 0 < ke >>> 0 ? ke : o, o) {
                                                                  if (o >>> 0 >= 1073741824) {
                                                                    if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                      break e;
                                                                    break l;
                                                                  }
                                                                  if (e[5996] = 0, Fe = ii(3, o << 2) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                    break l;
                                                                }
                                                                if (y = (y << 2) + Fe | 0, e[y >> 2] = S, g = y + 4 | 0, (r | 0) != (h | 0)) {
                                                                  for (; y = y - 4 | 0, h = h - 4 | 0, e[y >> 2] = e[h >> 2], (r | 0) != (h | 0); )
                                                                    ;
                                                                  h = e[G + 16 >> 2];
                                                                }
                                                                if (e[G + 24 >> 2] = (o << 2) + Fe, e[G + 20 >> 2] = g, e[G + 16 >> 2] = y, !h)
                                                                  break g;
                                                                Sr(h);
                                                                break A;
                                                              case 6:
                                                                if (o = e[r + 20 >> 2], r = e[r + 16 >> 2], e[5996] = 0, S = da(36, c | 0, 9, r | 0, o | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                  break f;
                                                                if (h = e[G + 20 >> 2], g = e[G + 24 >> 2], h >>> 0 < g >>> 0) {
                                                                  e[h >> 2] = S, e[G + 20 >> 2] = h + 4;
                                                                  break A;
                                                                }
                                                                if (r = e[G + 16 >> 2], y = h - r >> 2, o = y + 1 | 0, o >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, Ri(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                    break e;
                                                                  break f;
                                                                }
                                                                if (g = g - r | 0, ke = g >> 1, o = g >>> 0 >= 2147483644 ? 1073741823 : o >>> 0 < ke >>> 0 ? ke : o, o) {
                                                                  if (o >>> 0 >= 1073741824) {
                                                                    if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                      break e;
                                                                    break f;
                                                                  }
                                                                  if (e[5996] = 0, Fe = ii(3, o << 2) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                    break f;
                                                                }
                                                                if (y = (y << 2) + Fe | 0, e[y >> 2] = S, g = y + 4 | 0, (r | 0) != (h | 0)) {
                                                                  for (; y = y - 4 | 0, h = h - 4 | 0, e[y >> 2] = e[h >> 2], (r | 0) != (h | 0); )
                                                                    ;
                                                                  h = e[G + 16 >> 2];
                                                                }
                                                                if (e[G + 24 >> 2] = (o << 2) + Fe, e[G + 20 >> 2] = g, e[G + 16 >> 2] = y, !h)
                                                                  break g;
                                                                Sr(h);
                                                                break A;
                                                              case 8:
                                                                if (h = e[r + 4 >> 2], (e[r + 8 >> 2] - h | 0) != 112)
                                                                  break u;
                                                                e[5996] = 0, S = Si(37, h | 0, o | 0, c | 0) | 0, h = e[5996], e[5996] = 0;
                                                                w: {
                                                                  b: {
                                                                    h: {
                                                                      x: {
                                                                        m: {
                                                                          B: {
                                                                            R: {
                                                                              if ((h | 0) != 1) {
                                                                                if (r = e[r + 4 >> 2], e[5996] = 0, g = Si(37, r + 56 | 0, o | 0, c | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                  break R;
                                                                                if (!S | !g)
                                                                                  break u;
                                                                                if (e[5996] = 0, r = ii(3, 8) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                  break x;
                                                                                if (e[r + 4 >> 2] = g, e[r >> 2] = S, e[5996] = 0, o = ii(3, 56) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                  break h;
                                                                                if (e[o + 16 >> 2] = 0, e[o + 20 >> 2] = 0, e[o + 4 >> 2] = r, e[o >> 2] = 10, r = r + 8 | 0, e[o + 12 >> 2] = r, e[o + 8 >> 2] = r, e[o + 24 >> 2] = 0, e[o + 28 >> 2] = 0, e[o + 32 >> 2] = 0, e[o + 36 >> 2] = 0, e[o + 40 >> 2] = 0, e[o + 44 >> 2] = 0, e[5996] = 0, di(33, c | 0, o | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                  break d;
                                                                                if (y = e[G + 20 >> 2], h = e[G + 24 >> 2], y >>> 0 >= h >>> 0)
                                                                                  break B;
                                                                                e[y >> 2] = o, e[G + 20 >> 2] = y + 4;
                                                                                break m;
                                                                              }
                                                                              c = Vr() | 0;
                                                                              break r;
                                                                            }
                                                                            c = Vr() | 0;
                                                                            break r;
                                                                          }
                                                                          if (ke = e[G + 16 >> 2], Ar = y - ke >> 2, r = Ar + 1 | 0, r >>> 0 >= 1073741824) {
                                                                            if (e[5996] = 0, Ri(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                              break e;
                                                                            break d;
                                                                          }
                                                                          h = h - ke | 0, Fe = h >> 1, Fe = h >>> 0 >= 2147483644 ? 1073741823 : r >>> 0 < Fe >>> 0 ? Fe : r;
                                                                          B: {
                                                                            if (!Fe) {
                                                                              r = 0;
                                                                              break B;
                                                                            }
                                                                            if (Fe >>> 0 >= 1073741824) {
                                                                              if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                break e;
                                                                              break d;
                                                                            }
                                                                            if (e[5996] = 0, r = ii(3, Fe << 2) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                              break d;
                                                                          }
                                                                          if (h = (Ar << 2) + r | 0, e[h >> 2] = o, o = h + 4 | 0, (y | 0) != (ke | 0)) {
                                                                            for (; h = h - 4 | 0, y = y - 4 | 0, e[h >> 2] = e[y >> 2], (y | 0) != (ke | 0); )
                                                                              ;
                                                                            y = e[G + 16 >> 2];
                                                                          }
                                                                          if (e[G + 24 >> 2] = (Fe << 2) + r, e[G + 20 >> 2] = o, e[G + 16 >> 2] = h, !y)
                                                                            break m;
                                                                          Sr(y);
                                                                        }
                                                                        if (e[5996] = 0, o = ii(3, 12) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                          break b;
                                                                        if (e[o + 4 >> 2] = g, e[o >> 2] = S, e[o + 8 >> 2] = e[6079], e[5996] = 0, r = ii(3, 56) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                          break w;
                                                                        if (e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 4 >> 2] = o, e[r >> 2] = 12, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 1072693248, o = o + 12 | 0, e[r + 12 >> 2] = o, e[r + 8 >> 2] = o, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[5996] = 0, di(33, c | 0, r | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                          break c;
                                                                        if (h = e[G + 20 >> 2], g = e[G + 24 >> 2], h >>> 0 < g >>> 0) {
                                                                          e[h >> 2] = r, e[G + 20 >> 2] = h + 4;
                                                                          break A;
                                                                        }
                                                                        if (o = e[G + 16 >> 2], y = h - o >> 2, S = y + 1 | 0, S >>> 0 >= 1073741824) {
                                                                          if (e[5996] = 0, Ri(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                            break e;
                                                                          break c;
                                                                        }
                                                                        g = g - o | 0, ke = g >> 1, S = g >>> 0 >= 2147483644 ? 1073741823 : S >>> 0 < ke >>> 0 ? ke : S;
                                                                        m: {
                                                                          if (!S) {
                                                                            Fe = 0;
                                                                            break m;
                                                                          }
                                                                          if (S >>> 0 >= 1073741824) {
                                                                            if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                              break e;
                                                                            break c;
                                                                          }
                                                                          if (e[5996] = 0, Fe = ii(3, S << 2) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                            break c;
                                                                        }
                                                                        if (y = (y << 2) + Fe | 0, e[y >> 2] = r, g = y + 4 | 0, (o | 0) != (h | 0)) {
                                                                          for (; y = y - 4 | 0, h = h - 4 | 0, e[y >> 2] = e[h >> 2], (o | 0) != (h | 0); )
                                                                            ;
                                                                          h = e[G + 16 >> 2];
                                                                        }
                                                                        if (e[G + 24 >> 2] = (S << 2) + Fe, e[G + 20 >> 2] = g, e[G + 16 >> 2] = y, !h)
                                                                          break g;
                                                                        Sr(h);
                                                                        break A;
                                                                      }
                                                                      c = Vr() | 0;
                                                                      break r;
                                                                    }
                                                                    c = Vr() | 0, Sr(r);
                                                                    break r;
                                                                  }
                                                                  c = Vr() | 0;
                                                                  break r;
                                                                }
                                                                c = Vr() | 0, Sr(o);
                                                                break r;
                                                              case 9:
                                                                if (h = e[r + 4 >> 2], (e[r + 8 >> 2] - h | 0) != 112 || (S = e[r + 40 >> 2], g = e[S + 4 >> 2], ke = e[S >> 2], Fe = ke + g | 0, g >>> 0 > Fe >>> 0))
                                                                  break u;
                                                                e[5996] = 0, S = Si(37, h | 0, o | 0, c | 0) | 0, h = e[5996], e[5996] = 0;
                                                                w: {
                                                                  b: {
                                                                    if ((h | 0) != 1) {
                                                                      if (h = e[r + 4 >> 2], e[5996] = 0, g = Si(37, h + 56 | 0, o | 0, c | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                        break b;
                                                                      if (!S | !g)
                                                                        break u;
                                                                      if (Rn = +(ke >>> 0) / +(Fe >>> 0), y = e[r + 4 >> 2], e[y >> 2] != 8)
                                                                        break p;
                                                                      if (h = e[y + 4 >> 2], (e[y + 8 >> 2] - h | 0) == 112)
                                                                        break w;
                                                                      break p;
                                                                    }
                                                                    c = Vr() | 0;
                                                                    break r;
                                                                  }
                                                                  c = Vr() | 0;
                                                                  break r;
                                                                }
                                                                e[5996] = 0, ke = Si(37, h | 0, o | 0, c | 0) | 0, h = e[5996], e[5996] = 0;
                                                                w: {
                                                                  b: {
                                                                    h: {
                                                                      if ((h | 0) != 1) {
                                                                        if (h = e[e[r + 4 >> 2] + 4 >> 2], e[5996] = 0, Fe = Si(37, h + 56 | 0, o | 0, c | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                          break h;
                                                                        if (y = 0, !ke | !Fe)
                                                                          break u;
                                                                        if (e[5996] = 0, h = ii(3, 12) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                          break b;
                                                                        if (e[G + 28 >> 2] = h, y = h + 12 | 0, e[G + 36 >> 2] = y, e[h + 8 >> 2] = g, e[h + 4 >> 2] = Fe, e[h >> 2] = ke, e[5996] = 0, e[G + 32 >> 2] = y, h = Mf(38, c | 0, 12, G + 28 | 0, +Rn) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1 || (e[5996] = 0, di(39, G + 16 | 0, h | 0), h = e[5996], e[5996] = 0, (h | 0) == 1))
                                                                          break w;
                                                                        h = e[G + 28 >> 2], h && Sr(h), y = e[r + 4 >> 2];
                                                                        break p;
                                                                      }
                                                                      c = Vr() | 0;
                                                                      break r;
                                                                    }
                                                                    c = Vr() | 0;
                                                                    break r;
                                                                  }
                                                                  c = Vr() | 0;
                                                                  break r;
                                                                }
                                                                if (c = Vr() | 0, r = e[G + 28 >> 2], !r)
                                                                  break r;
                                                                Sr(r);
                                                                break r;
                                                              case 0:
                                                                break u;
                                                              case 10:
                                                                break v;
                                                              default:
                                                                break A;
                                                            }
                                                          if (S = e[r + 4 >> 2], hr = e[r + 8 >> 2], (S | 0) == (hr | 0))
                                                            break N;
                                                          for (; ; ) {
                                                            v: {
                                                              if (e[5996] = 0, h = Si(37, S | 0, o | 0, c | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                break v;
                                                              w: {
                                                                if (y >>> 0 < Fe >>> 0) {
                                                                  e[y >> 2] = h, y = y + 4 | 0;
                                                                  break w;
                                                                }
                                                                if (ln = y - g >> 2, ke = ln + 1 | 0, ke >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, Ri(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                    break e;
                                                                  break k;
                                                                }
                                                                Fe = Fe - g | 0, Ar = Fe >> 1, Ar = Fe >>> 0 >= 2147483644 ? 1073741823 : ke >>> 0 < Ar >>> 0 ? Ar : ke;
                                                                b: {
                                                                  if (!Ar) {
                                                                    Fe = 0;
                                                                    break b;
                                                                  }
                                                                  if (Ar >>> 0 >= 1073741824) {
                                                                    if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                      break e;
                                                                    break k;
                                                                  }
                                                                  if (e[5996] = 0, Fe = ii(3, Ar << 2) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                                    break v;
                                                                }
                                                                if (ke = (ln << 2) + Fe | 0, e[ke >> 2] = h, h = ke, (y | 0) != (g | 0))
                                                                  for (; h = h - 4 | 0, y = y - 4 | 0, e[h >> 2] = e[y >> 2], (y | 0) != (g | 0); )
                                                                    ;
                                                                Fe = (Ar << 2) + Fe | 0, y = ke + 4 | 0, g && Sr(g), g = h;
                                                              }
                                                              if (S = S + 56 | 0, (hr | 0) != (S | 0))
                                                                continue;
                                                              break S;
                                                            }
                                                            break;
                                                          }
                                                          c = Vr() | 0;
                                                          break I;
                                                        }
                                                        c = Vr() | 0, Sr(o);
                                                        break r;
                                                      }
                                                      if ((y | 0) == (g | 0)) {
                                                        g = y;
                                                        break N;
                                                      }
                                                      for (h = g; ; ) {
                                                        if (e[h >> 2]) {
                                                          if (h = h + 4 | 0, (y | 0) != (h | 0))
                                                            continue;
                                                          break N;
                                                        }
                                                        break;
                                                      }
                                                      if (y = 0, !g)
                                                        break u;
                                                      Sr(g);
                                                      break u;
                                                    }
                                                    N: {
                                                      S: {
                                                        ln = e[r + 8 >> 2], ke = e[r + 4 >> 2];
                                                        T: {
                                                          if ((ln - ke | 0) / 56 >>> 0 > 20)
                                                            break T;
                                                          v: {
                                                            w: {
                                                              if ((ke | 0) != (ln | 0)) {
                                                                for (h = ke; ; ) {
                                                                  if (e[h >> 2] != 1)
                                                                    break T;
                                                                  if (h = h + 56 | 0, (ln | 0) == (h | 0))
                                                                    break;
                                                                }
                                                                break w;
                                                              }
                                                              e[G + 12 >> 2] = 0, e[G + 4 >> 2] = 0, e[G + 8 >> 2] = 0;
                                                              break v;
                                                            }
                                                            for (e[G + 12 >> 2] = 0, e[G + 4 >> 2] = 0, e[G + 8 >> 2] = 0, ei = G + 12 | 0; ; ) {
                                                              o = e[ke + 28 >> 2];
                                                              w: {
                                                                b: {
                                                                  if (h = e[G + 8 >> 2], (h | 0) != e[G + 12 >> 2]) {
                                                                    if ($[o + 11 | 0] >= 0) {
                                                                      S = e[o + 4 >> 2], e[h >> 2] = e[o >> 2], e[h + 4 >> 2] = S, e[h + 8 >> 2] = e[o + 8 >> 2];
                                                                      break b;
                                                                    }
                                                                    if (S = e[o + 4 >> 2], o = e[o >> 2], e[5996] = 0, as(40, h | 0, o | 0, S | 0), o = e[5996], e[5996] = 0, (o | 0) != 1)
                                                                      break b;
                                                                    c = Vr() | 0, e[G + 8 >> 2] = h;
                                                                    break N;
                                                                  }
                                                                  h: {
                                                                    x: {
                                                                      m: {
                                                                        B: {
                                                                          S = e[G + 4 >> 2], Ar = (h - S | 0) / 12 | 0, hr = Ar + 1 | 0;
                                                                          R: {
                                                                            if (hr >>> 0 >= 357913942) {
                                                                              e[5996] = 0, Ri(41);
                                                                              break R;
                                                                            }
                                                                            if (e[G + 44 >> 2] = ei, Tr = Ar << 1, Tr = Ar >>> 0 >= 178956970 ? 357913941 : hr >>> 0 < Tr >>> 0 ? Tr : hr, !Tr) {
                                                                              hr = 0;
                                                                              break m;
                                                                            }
                                                                            if (Tr >>> 0 < 357913942)
                                                                              break B;
                                                                            e[5996] = 0, Ri(35);
                                                                          }
                                                                          if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                            break e;
                                                                          c = Vr() | 0;
                                                                          break N;
                                                                        }
                                                                        if (e[5996] = 0, hr = ii(3, vi(Tr, 12) | 0) | 0, Mn = e[5996], e[5996] = 0, (Mn | 0) == 1)
                                                                          break x;
                                                                      }
                                                                      e[G + 28 >> 2] = hr, Ar = vi(Ar, 12) + hr | 0, e[G + 36 >> 2] = Ar, hr = vi(Tr, 12) + hr | 0, e[G + 40 >> 2] = hr, e[G + 32 >> 2] = Ar;
                                                                      m: {
                                                                        if ($[o + 11 | 0] >= 0) {
                                                                          Tr = e[o + 4 >> 2], e[Ar >> 2] = e[o >> 2], e[Ar + 4 >> 2] = Tr, e[Ar + 8 >> 2] = e[o + 8 >> 2];
                                                                          break m;
                                                                        }
                                                                        if (h = e[o + 4 >> 2], o = e[o >> 2], e[5996] = 0, as(40, Ar | 0, o | 0, h | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                          break h;
                                                                        S = e[G + 4 >> 2], h = e[G + 8 >> 2];
                                                                      }
                                                                      if (Tr = Ar + 12 | 0, (h | 0) == (S | 0))
                                                                        o = S;
                                                                      else {
                                                                        for (; h = h - 12 | 0, Mn = e[h + 4 >> 2], Ar = Ar - 12 | 0, o = Ar, e[o >> 2] = e[h >> 2], e[o + 4 >> 2] = Mn, e[o + 8 >> 2] = e[h + 8 >> 2], e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, (h | 0) != (S | 0); )
                                                                          ;
                                                                        S = e[G + 8 >> 2], o = e[G + 4 >> 2];
                                                                      }
                                                                      if (e[G + 32 >> 2] = o, e[G + 4 >> 2] = Ar, e[G + 8 >> 2] = Tr, h = e[G + 12 >> 2], e[G + 12 >> 2] = hr, e[G + 40 >> 2] = h, e[G + 28 >> 2] = o, (o | 0) != (S | 0)) {
                                                                        for (; h = S - 12 | 0, e[G + 36 >> 2] = h, $[S - 1 | 0] < 0 && Sr(e[h >> 2]), S = h, (h | 0) != (o | 0); )
                                                                          ;
                                                                        S = o;
                                                                      }
                                                                      if (!S)
                                                                        break w;
                                                                      Sr(S);
                                                                      break w;
                                                                    }
                                                                    c = Vr() | 0;
                                                                    break N;
                                                                  }
                                                                  if (c = Vr() | 0, r = e[G + 36 >> 2], h = e[G + 32 >> 2], (r | 0) != (h | 0))
                                                                    for (; o = r - 12 | 0, e[G + 36 >> 2] = o, $[r - 1 | 0] >= 0 ? r = o : (Sr(e[o >> 2]), r = e[G + 36 >> 2]), (h | 0) != (r | 0); )
                                                                      ;
                                                                  r = e[G + 28 >> 2], r && Sr(r);
                                                                  break N;
                                                                }
                                                                e[G + 8 >> 2] = h + 12;
                                                              }
                                                              if (ke = ke + 56 | 0, (ln | 0) == (ke | 0))
                                                                break;
                                                            }
                                                          }
                                                          if (o = e[r + 52 >> 2], e[5996] = 0, ke = ii(3, 56) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1 || (h = e[G + 12 >> 2], e[G + 12 >> 2] = 0, S = e[G + 4 >> 2], Ar = e[G + 8 >> 2], e[G + 4 >> 2] = 0, e[G + 8 >> 2] = 0, e[ke + 4 >> 2] = 0, e[ke + 8 >> 2] = 0, e[ke >> 2] = 3, e[ke + 12 >> 2] = 0, e[ke + 40 >> 2] = o, e[ke + 44 >> 2] = 0, e[ke + 36 >> 2] = 0, e[ke + 28 >> 2] = 0, e[ke + 32 >> 2] = 0, e[ke + 24 >> 2] = h, e[ke + 16 >> 2] = S, e[ke + 20 >> 2] = Ar, e[5996] = 0, di(33, c | 0, ke | 0), o = e[5996], e[5996] = 0, (o | 0) == 1))
                                                            break S;
                                                          h = e[G + 20 >> 2], Ar = e[G + 24 >> 2];
                                                          v: {
                                                            if (h >>> 0 < Ar >>> 0) {
                                                              e[h >> 2] = ke, e[G + 20 >> 2] = h + 4;
                                                              break v;
                                                            }
                                                            if (o = e[G + 16 >> 2], ln = h - o >> 2, S = ln + 1 | 0, S >>> 0 >= 1073741824) {
                                                              if (e[5996] = 0, Ri(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                break e;
                                                              break S;
                                                            }
                                                            Ar = Ar - o | 0, hr = Ar >> 1, Ar = Ar >>> 0 >= 2147483644 ? 1073741823 : S >>> 0 < hr >>> 0 ? hr : S;
                                                            w: {
                                                              if (!Ar) {
                                                                hr = 0;
                                                                break w;
                                                              }
                                                              if (Ar >>> 0 >= 1073741824) {
                                                                if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                  break e;
                                                                break S;
                                                              }
                                                              if (e[5996] = 0, hr = ii(3, Ar << 2) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                break S;
                                                            }
                                                            if (S = (ln << 2) + hr | 0, e[S >> 2] = ke, ke = S + 4 | 0, (o | 0) != (h | 0)) {
                                                              for (; S = S - 4 | 0, h = h - 4 | 0, e[S >> 2] = e[h >> 2], (o | 0) != (h | 0); )
                                                                ;
                                                              h = e[G + 16 >> 2];
                                                            }
                                                            if (e[G + 24 >> 2] = (Ar << 2) + hr, e[G + 20 >> 2] = ke, e[G + 16 >> 2] = S, !h)
                                                              break v;
                                                            Sr(h);
                                                          }
                                                          if (o = e[G + 4 >> 2], !o)
                                                            break T;
                                                          if (h = o, S = e[G + 8 >> 2], (h | 0) != (S | 0)) {
                                                            for (; h = S - 12 | 0, $[S - 1 | 0] < 0 && Sr(e[h >> 2]), S = h, (h | 0) != (o | 0); )
                                                              ;
                                                            h = e[G + 4 >> 2];
                                                          }
                                                          e[G + 8 >> 2] = o, Sr(h);
                                                        }
                                                        o = e[r + 52 >> 2];
                                                        T: {
                                                          if ((o | 0) != 1 & (o | 0) != ((e[r + 8 >> 2] - e[r + 4 >> 2] | 0) / 56 | 0))
                                                            break T;
                                                          v: {
                                                            w: {
                                                              b: {
                                                                h: {
                                                                  x: {
                                                                    m: {
                                                                      if (o = y - g | 0, o >>> 0 >= 5)
                                                                        for (; ; ) {
                                                                          if (Ar = e[r + 52 >> 2], e[5996] = 0, ke = ii(3, 8) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                            break m;
                                                                          if (h = y - 8 | 0, e[ke >> 2] = e[h >> 2], y = y - 4 | 0, e[ke + 4 >> 2] = e[y >> 2], e[5996] = 0, S = ii(3, 56) | 0, hr = e[5996], e[5996] = 0, (hr | 0) == 1)
                                                                            break x;
                                                                          if (e[S + 16 >> 2] = 0, e[S + 20 >> 2] = 0, e[S + 4 >> 2] = ke, e[S >> 2] = (Ar | 0) == 1 ? 11 : 10, ke = ke + 8 | 0, e[S + 12 >> 2] = ke, e[S + 8 >> 2] = ke, e[S + 24 >> 2] = 0, e[S + 28 >> 2] = 0, e[S + 32 >> 2] = 0, e[S + 36 >> 2] = 0, e[S + 40 >> 2] = 0, e[S + 44 >> 2] = 0, Fi[S + 48 >> 3] = 1 / +(o >> 2 >>> 0), e[5996] = 0, di(33, c | 0, S | 0), o = e[5996], e[5996] = 0, (o | 0) == 1) {
                                                                            c = Vr() | 0;
                                                                            break I;
                                                                          }
                                                                          if (e[5996] = 0, ke = ii(3, 4) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                            break h;
                                                                          if (e[ke >> 2] = S, e[5996] = 0, o = ii(3, 56) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                            break w;
                                                                          if (e[o + 16 >> 2] = 0, e[o + 20 >> 2] = 0, e[o + 4 >> 2] = ke, e[o >> 2] = 21, S = ke + 4 | 0, e[o + 12 >> 2] = S, e[o + 8 >> 2] = S, e[o + 24 >> 2] = 0, e[o + 28 >> 2] = 0, e[o + 32 >> 2] = 0, e[o + 36 >> 2] = 0, e[o + 40 >> 2] = 0, e[o + 44 >> 2] = 0, e[5996] = 0, di(33, c | 0, o | 0), S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                            break b;
                                                                          B: {
                                                                            if (h >>> 0 < Fe >>> 0) {
                                                                              e[h >> 2] = o;
                                                                              break B;
                                                                            }
                                                                            R: {
                                                                              E: {
                                                                                ke = h - g >> 2, S = ke + 1 | 0;
                                                                                C: {
                                                                                  if (S >>> 0 >= 1073741824) {
                                                                                    e[5996] = 0, Ri(34);
                                                                                    break C;
                                                                                  }
                                                                                  if (y = Fe - g | 0, Fe = y >> 1, y = y >>> 0 >= 2147483644 ? 1073741823 : S >>> 0 < Fe >>> 0 ? Fe : S, !y) {
                                                                                    Fe = 0;
                                                                                    break R;
                                                                                  }
                                                                                  if (y >>> 0 < 1073741824)
                                                                                    break E;
                                                                                  e[5996] = 0, Ri(35);
                                                                                }
                                                                                if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                  break e;
                                                                                c = Vr() | 0;
                                                                                break I;
                                                                              }
                                                                              if (e[5996] = 0, Fe = ii(3, y << 2) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                break b;
                                                                            }
                                                                            S = (ke << 2) + Fe | 0, e[S >> 2] = o, Fe = (y << 2) + Fe | 0, y = S + 4 | 0;
                                                                            R: {
                                                                              if ((h | 0) != (g | 0)) {
                                                                                for (; S = S - 4 | 0, h = h - 4 | 0, e[S >> 2] = e[h >> 2], (h | 0) != (g | 0); )
                                                                                  ;
                                                                                if (!g)
                                                                                  break R;
                                                                              }
                                                                              Sr(g);
                                                                            }
                                                                            g = S;
                                                                          }
                                                                          if (o = y - g | 0, !(o >>> 0 > 4))
                                                                            break;
                                                                        }
                                                                      if (Fe = e[g >> 2], h = e[G + 20 >> 2], (h | 0) == e[G + 24 >> 2])
                                                                        break v;
                                                                      e[h >> 2] = Fe, e[G + 20 >> 2] = h + 4;
                                                                      break T;
                                                                    }
                                                                    c = Vr() | 0;
                                                                    break I;
                                                                  }
                                                                  c = Vr() | 0, Sr(ke);
                                                                  break I;
                                                                }
                                                                c = Vr() | 0;
                                                                break I;
                                                              }
                                                              c = Vr() | 0;
                                                              break I;
                                                            }
                                                            c = Vr() | 0, Sr(ke);
                                                            break I;
                                                          }
                                                          if (Ar = e[G + 16 >> 2], o = h - Ar | 0, hr = o >> 2, S = hr + 1 | 0, S >>> 0 >= 1073741824) {
                                                            if (e[5996] = 0, Ri(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                              break e;
                                                            break k;
                                                          }
                                                          ke = o >> 1, o = o >>> 0 >= 2147483644 ? 1073741823 : S >>> 0 < ke >>> 0 ? ke : S;
                                                          v: {
                                                            if (!o) {
                                                              ke = 0;
                                                              break v;
                                                            }
                                                            if (o >>> 0 >= 1073741824) {
                                                              if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                break e;
                                                              break k;
                                                            }
                                                            if (e[5996] = 0, ke = ii(3, o << 2) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                              break k;
                                                          }
                                                          if (S = (hr << 2) + ke | 0, e[S >> 2] = Fe, Fe = S + 4 | 0, (h | 0) != (Ar | 0)) {
                                                            for (; S = S - 4 | 0, h = h - 4 | 0, e[S >> 2] = e[h >> 2], (h | 0) != (Ar | 0); )
                                                              ;
                                                            h = e[G + 16 >> 2];
                                                          }
                                                          if (e[G + 24 >> 2] = (o << 2) + ke, e[G + 20 >> 2] = Fe, e[G + 16 >> 2] = S, !h)
                                                            break T;
                                                          Sr(h);
                                                        }
                                                        Fe = e[r + 52 >> 2], o = 0, e[5996] = 0, r = ii(3, 56) | 0, h = e[5996], e[5996] = 0;
                                                        T: {
                                                          v: {
                                                            if ((h | 0) == 1)
                                                              break v;
                                                            if (S = y - g | 0, Ar = S >> 2, ke = 0, h = 0, (y | 0) != (g | 0)) {
                                                              if ((S | 0) < 0) {
                                                                if (e[5996] = 0, Ri(34), o = e[5996], e[5996] = 0, (o | 0) != 1)
                                                                  break e;
                                                                break T;
                                                              }
                                                              if (e[5996] = 0, h = ii(3, S | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                break T;
                                                              S = (S - 4 & -4) + 4 | 0, y = _s(h, g, S), o = y + (Ar << 2) | 0, ke = y + S | 0;
                                                            }
                                                            if (e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 4 >> 2] = h, e[r >> 2] = 13, Fi[r + 48 >> 3] = +(Fe >>> 0) / +(Ar >>> 0), e[r + 12 >> 2] = o, e[r + 8 >> 2] = ke, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = Fe, e[r + 44 >> 2] = 0, e[5996] = 0, di(33, c | 0, r | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                              break v;
                                                            y = e[G + 20 >> 2], h = e[G + 24 >> 2];
                                                            w: {
                                                              if (y >>> 0 < h >>> 0) {
                                                                e[y >> 2] = r, e[G + 20 >> 2] = y + 4;
                                                                break w;
                                                              }
                                                              if (S = e[G + 16 >> 2], Fe = y - S >> 2, o = Fe + 1 | 0, o >>> 0 >= 1073741824) {
                                                                if (e[5996] = 0, Ri(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                  break e;
                                                                break v;
                                                              }
                                                              h = h - S | 0, ke = h >> 1, ke = h >>> 0 >= 2147483644 ? 1073741823 : o >>> 0 < ke >>> 0 ? ke : o;
                                                              b: {
                                                                if (!ke) {
                                                                  o = 0;
                                                                  break b;
                                                                }
                                                                if (ke >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                    break e;
                                                                  break v;
                                                                }
                                                                if (e[5996] = 0, o = ii(3, ke << 2) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                  break v;
                                                              }
                                                              if (h = (Fe << 2) + o | 0, e[h >> 2] = r, r = h + 4 | 0, (y | 0) != (S | 0)) {
                                                                for (; h = h - 4 | 0, y = y - 4 | 0, e[h >> 2] = e[y >> 2], (y | 0) != (S | 0); )
                                                                  ;
                                                                y = e[G + 16 >> 2];
                                                              }
                                                              if (e[G + 24 >> 2] = (ke << 2) + o, e[G + 20 >> 2] = r, e[G + 16 >> 2] = h, !y)
                                                                break w;
                                                              Sr(y);
                                                            }
                                                            if (!g)
                                                              break A;
                                                            Sr(g);
                                                            break A;
                                                          }
                                                          c = Vr() | 0;
                                                          break I;
                                                        }
                                                        c = Vr() | 0, Sr(r);
                                                        break I;
                                                      }
                                                      c = Vr() | 0;
                                                    }
                                                    Wo(G + 4 | 0);
                                                    break I;
                                                  }
                                                  c = Vr() | 0;
                                                }
                                                if (!g)
                                                  break r;
                                                Sr(g);
                                                break r;
                                              }
                                              p: {
                                                I: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              b: {
                                                                if (e[y + 56 >> 2] != 8 || (h = e[y + 60 >> 2], (e[y - -64 >> 2] - h | 0) != 112))
                                                                  break b;
                                                                if (e[5996] = 0, h = Si(37, h | 0, o | 0, c | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                  break w;
                                                                if (r = e[e[r + 4 >> 2] + 60 >> 2], e[5996] = 0, o = Si(37, r + 56 | 0, o | 0, c | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                  break v;
                                                                if (y = 0, !h | !o)
                                                                  break u;
                                                                if (e[5996] = 0, r = ii(3, 12) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                  break T;
                                                                if (e[G + 28 >> 2] = r, y = r + 12 | 0, e[G + 36 >> 2] = y, e[r + 8 >> 2] = S, e[r + 4 >> 2] = o, e[r >> 2] = h, e[5996] = 0, e[G + 32 >> 2] = y, r = E4(42, c | 0, G + 28 | 0, +(1 - Rn)) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1 || (e[5996] = 0, di(39, G + 16 | 0, r | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                                                                  break S;
                                                                if (r = e[G + 28 >> 2], !r)
                                                                  break b;
                                                                Sr(r);
                                                              }
                                                              if (e[5996] = 0, r = ii(3, 12) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                break N;
                                                              if (e[G + 28 >> 2] = r, o = r + 12 | 0, e[G + 36 >> 2] = o, e[r >> 2] = S, h = e[6080], e[r + 8 >> 2] = g, e[r + 4 >> 2] = h, e[5996] = 0, e[G + 32 >> 2] = o, r = Mf(38, c | 0, 12, G + 28 | 0, +Rn) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1 || (e[5996] = 0, di(39, G + 16 | 0, r | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                                                                break k;
                                                              if (r = e[G + 28 >> 2], r && Sr(r), e[5996] = 0, r = ii(3, 8) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                break I;
                                                              if (e[G + 28 >> 2] = r, o = r + 8 | 0, e[G + 36 >> 2] = o, e[r + 4 >> 2] = g, e[r >> 2] = S, e[5996] = 0, e[G + 32 >> 2] = o, r = Mf(38, c | 0, 11, G + 28 | 0, +Rn) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1 || (e[5996] = 0, di(39, G + 16 | 0, r | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                                                                break p;
                                                              if (r = e[G + 28 >> 2], !r)
                                                                break A;
                                                              Sr(r);
                                                              break A;
                                                            }
                                                            c = Vr() | 0;
                                                            break r;
                                                          }
                                                          c = Vr() | 0;
                                                          break r;
                                                        }
                                                        c = Vr() | 0;
                                                        break r;
                                                      }
                                                      if (c = Vr() | 0, r = e[G + 28 >> 2], !r)
                                                        break r;
                                                      Sr(r);
                                                      break r;
                                                    }
                                                    c = Vr() | 0;
                                                    break r;
                                                  }
                                                  if (c = Vr() | 0, r = e[G + 28 >> 2], !r)
                                                    break r;
                                                  Sr(r);
                                                  break r;
                                                }
                                                c = Vr() | 0;
                                                break r;
                                              }
                                              if (c = Vr() | 0, r = e[G + 28 >> 2], !r)
                                                break r;
                                              Sr(r);
                                              break r;
                                            }
                                            g = e[G + 20 >> 2], y = e[G + 16 >> 2];
                                          }
                                          g: {
                                            A: {
                                              p: {
                                                I: {
                                                  if ((g - y | 0) == 4)
                                                    break I;
                                                  if (o = e[G + 24 >> 2], e[G + 24 >> 2] = 0, e[G + 16 >> 2] = 0, e[G + 20 >> 2] = 0, e[5996] = 0, r = ii(3, 56) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                    break p;
                                                  if (e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 4 >> 2] = y, e[r >> 2] = 20, e[r + 12 >> 2] = o, e[r + 8 >> 2] = g, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[5996] = 0, di(33, c | 0, r | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                    break g;
                                                  if (y = e[G + 20 >> 2], S = e[G + 24 >> 2], y >>> 0 < S >>> 0) {
                                                    e[y >> 2] = r, e[G + 20 >> 2] = y + 4;
                                                    break I;
                                                  }
                                                  if (o = e[G + 16 >> 2], g = y - o >> 2, h = g + 1 | 0, h >>> 0 >= 1073741824) {
                                                    if (e[5996] = 0, Ri(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                      break e;
                                                    break g;
                                                  }
                                                  S = S - o | 0, ke = S >> 1, S = S >>> 0 >= 2147483644 ? 1073741823 : h >>> 0 < ke >>> 0 ? ke : h;
                                                  k: {
                                                    if (!S) {
                                                      Fe = 0;
                                                      break k;
                                                    }
                                                    if (S >>> 0 >= 1073741824) {
                                                      if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                        break e;
                                                      break g;
                                                    }
                                                    if (e[5996] = 0, Fe = ii(3, S << 2) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                      break g;
                                                  }
                                                  if (h = (g << 2) + Fe | 0, e[h >> 2] = r, r = h + 4 | 0, (o | 0) != (y | 0)) {
                                                    for (; h = h - 4 | 0, y = y - 4 | 0, e[h >> 2] = e[y >> 2], (o | 0) != (y | 0); )
                                                      ;
                                                    y = e[G + 16 >> 2];
                                                  }
                                                  if (e[G + 24 >> 2] = (S << 2) + Fe, e[G + 20 >> 2] = r, e[G + 16 >> 2] = h, !y)
                                                    break I;
                                                  Sr(y);
                                                }
                                                if (e[5996] = 0, y = ii(3, 56) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1 && (r = e[G + 24 >> 2], e[G + 24 >> 2] = 0, o = e[G + 16 >> 2], h = e[G + 20 >> 2], e[G + 16 >> 2] = 0, e[G + 20 >> 2] = 0, e[y + 16 >> 2] = 0, e[y + 20 >> 2] = 0, e[y + 12 >> 2] = r, e[y + 4 >> 2] = o, e[y + 8 >> 2] = h, e[y >> 2] = 21, e[y + 24 >> 2] = 0, e[y + 28 >> 2] = 0, e[y + 32 >> 2] = 0, e[y + 36 >> 2] = 0, e[y + 40 >> 2] = 0, e[y + 44 >> 2] = 0, e[5996] = 0, di(33, c | 0, y | 0), r = e[5996], e[5996] = 0, (r | 0) != 1))
                                                  break A;
                                                c = Vr() | 0;
                                                break r;
                                              }
                                              if (c = Vr() | 0, !y)
                                                break t;
                                              Sr(y);
                                              break r;
                                            }
                                            if (e[5996] = 0, o = ii(3, 4) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) {
                                              c = Vr() | 0;
                                              break r;
                                            }
                                            e[o >> 2] = y, e[5996] = 0, r = ii(3, 56) | 0, h = e[5996], e[5996] = 0;
                                            A: {
                                              p: {
                                                I: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              b: {
                                                                h: {
                                                                  x: {
                                                                    m: {
                                                                      B: {
                                                                        R: {
                                                                          if ((h | 0) != 1) {
                                                                            if (e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 4 >> 2] = o, e[r >> 2] = 15, o = o + 4 | 0, e[r + 12 >> 2] = o, e[r + 8 >> 2] = o, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[5996] = 0, di(33, c | 0, r | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                              break A;
                                                                            h = e[y + 8 >> 2], g = e[y + 12 >> 2];
                                                                            E: {
                                                                              if (h >>> 0 < g >>> 0) {
                                                                                e[h >> 2] = r, e[y + 8 >> 2] = h + 4;
                                                                                break E;
                                                                              }
                                                                              if (S = e[y + 4 >> 2], Fe = h - S >> 2, o = Fe + 1 | 0, o >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, Ri(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                  break e;
                                                                                break A;
                                                                              }
                                                                              g = g - S | 0, ke = g >> 1, ke = g >>> 0 >= 2147483644 ? 1073741823 : o >>> 0 < ke >>> 0 ? ke : o;
                                                                              C: {
                                                                                if (!ke) {
                                                                                  o = 0;
                                                                                  break C;
                                                                                }
                                                                                if (ke >>> 0 >= 1073741824) {
                                                                                  if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                    break e;
                                                                                  break A;
                                                                                }
                                                                                if (e[5996] = 0, o = ii(3, ke << 2) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                  break A;
                                                                              }
                                                                              if (g = (Fe << 2) + o | 0, e[g >> 2] = r, r = g + 4 | 0, (h | 0) != (S | 0)) {
                                                                                for (; g = g - 4 | 0, h = h - 4 | 0, e[g >> 2] = e[h >> 2], (h | 0) != (S | 0); )
                                                                                  ;
                                                                                h = e[y + 4 >> 2];
                                                                              }
                                                                              if (e[y + 12 >> 2] = (ke << 2) + o, e[y + 8 >> 2] = r, e[y + 4 >> 2] = g, !h)
                                                                                break E;
                                                                              Sr(h);
                                                                            }
                                                                            if (e[5996] = 0, o = ii(3, 4) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) {
                                                                              c = Vr() | 0;
                                                                              break r;
                                                                            }
                                                                            if (e[o >> 2] = y, e[5996] = 0, r = ii(3, 56) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                              break R;
                                                                            if (e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 4 >> 2] = o, e[r >> 2] = 17, o = o + 4 | 0, e[r + 12 >> 2] = o, e[r + 8 >> 2] = o, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[5996] = 0, di(33, c | 0, r | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                              break p;
                                                                            h = e[y + 8 >> 2], g = e[y + 12 >> 2];
                                                                            E: {
                                                                              if (h >>> 0 < g >>> 0) {
                                                                                e[h >> 2] = r, e[y + 8 >> 2] = h + 4;
                                                                                break E;
                                                                              }
                                                                              if (S = e[y + 4 >> 2], Fe = h - S >> 2, o = Fe + 1 | 0, o >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, Ri(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                  break e;
                                                                                break p;
                                                                              }
                                                                              g = g - S | 0, ke = g >> 1, ke = g >>> 0 >= 2147483644 ? 1073741823 : o >>> 0 < ke >>> 0 ? ke : o;
                                                                              C: {
                                                                                if (!ke) {
                                                                                  o = 0;
                                                                                  break C;
                                                                                }
                                                                                if (ke >>> 0 >= 1073741824) {
                                                                                  if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                    break e;
                                                                                  break p;
                                                                                }
                                                                                if (e[5996] = 0, o = ii(3, ke << 2) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                  break p;
                                                                              }
                                                                              if (g = (Fe << 2) + o | 0, e[g >> 2] = r, r = g + 4 | 0, (h | 0) != (S | 0)) {
                                                                                for (; g = g - 4 | 0, h = h - 4 | 0, e[g >> 2] = e[h >> 2], (h | 0) != (S | 0); )
                                                                                  ;
                                                                                h = e[y + 4 >> 2];
                                                                              }
                                                                              if (e[y + 12 >> 2] = (ke << 2) + o, e[y + 8 >> 2] = r, e[y + 4 >> 2] = g, !h)
                                                                                break E;
                                                                              Sr(h);
                                                                            }
                                                                            if (e[5996] = 0, r = e[6080], o = ii(3, 8) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1) {
                                                                              c = Vr() | 0;
                                                                              break r;
                                                                            }
                                                                            if (e[o + 4 >> 2] = r, e[o >> 2] = y, e[5996] = 0, r = ii(3, 56) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                              break B;
                                                                            if (e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 4 >> 2] = o, e[r >> 2] = 10, o = o + 8 | 0, e[r + 12 >> 2] = o, e[r + 8 >> 2] = o, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[5996] = 0, di(33, c | 0, r | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                              break I;
                                                                            h = e[y + 8 >> 2], g = e[y + 12 >> 2];
                                                                            E: {
                                                                              if (h >>> 0 < g >>> 0) {
                                                                                e[h >> 2] = r, e[y + 8 >> 2] = h + 4;
                                                                                break E;
                                                                              }
                                                                              if (S = e[y + 4 >> 2], Fe = h - S >> 2, o = Fe + 1 | 0, o >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, Ri(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                  break e;
                                                                                break I;
                                                                              }
                                                                              g = g - S | 0, ke = g >> 1, ke = g >>> 0 >= 2147483644 ? 1073741823 : o >>> 0 < ke >>> 0 ? ke : o;
                                                                              C: {
                                                                                if (!ke) {
                                                                                  o = 0;
                                                                                  break C;
                                                                                }
                                                                                if (ke >>> 0 >= 1073741824) {
                                                                                  if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                    break e;
                                                                                  break I;
                                                                                }
                                                                                if (e[5996] = 0, o = ii(3, ke << 2) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                  break I;
                                                                              }
                                                                              if (g = (Fe << 2) + o | 0, e[g >> 2] = r, r = g + 4 | 0, (h | 0) != (S | 0)) {
                                                                                for (; g = g - 4 | 0, h = h - 4 | 0, e[g >> 2] = e[h >> 2], (h | 0) != (S | 0); )
                                                                                  ;
                                                                                h = e[y + 4 >> 2];
                                                                              }
                                                                              if (e[y + 12 >> 2] = (ke << 2) + o, e[y + 8 >> 2] = r, e[y + 4 >> 2] = g, !h)
                                                                                break E;
                                                                              Sr(h);
                                                                            }
                                                                            if (e[5996] = 0, o = ii(3, 4) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) {
                                                                              c = Vr() | 0;
                                                                              break r;
                                                                            }
                                                                            if (e[o >> 2] = y, e[5996] = 0, r = ii(3, 56) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                              break m;
                                                                            if (e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 4 >> 2] = o, e[r >> 2] = 19, o = o + 4 | 0, e[r + 12 >> 2] = o, e[r + 8 >> 2] = o, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[5996] = 0, di(33, c | 0, r | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                              break k;
                                                                            h = e[y + 8 >> 2], g = e[y + 12 >> 2];
                                                                            E: {
                                                                              if (h >>> 0 < g >>> 0) {
                                                                                e[h >> 2] = r, e[y + 8 >> 2] = h + 4;
                                                                                break E;
                                                                              }
                                                                              if (S = e[y + 4 >> 2], Fe = h - S >> 2, o = Fe + 1 | 0, o >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, Ri(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                  break e;
                                                                                break k;
                                                                              }
                                                                              g = g - S | 0, ke = g >> 1, ke = g >>> 0 >= 2147483644 ? 1073741823 : o >>> 0 < ke >>> 0 ? ke : o;
                                                                              C: {
                                                                                if (!ke) {
                                                                                  o = 0;
                                                                                  break C;
                                                                                }
                                                                                if (ke >>> 0 >= 1073741824) {
                                                                                  if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                    break e;
                                                                                  break k;
                                                                                }
                                                                                if (e[5996] = 0, o = ii(3, ke << 2) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                  break k;
                                                                              }
                                                                              if (g = (Fe << 2) + o | 0, e[g >> 2] = r, r = g + 4 | 0, (h | 0) != (S | 0)) {
                                                                                for (; g = g - 4 | 0, h = h - 4 | 0, e[g >> 2] = e[h >> 2], (h | 0) != (S | 0); )
                                                                                  ;
                                                                                h = e[y + 4 >> 2];
                                                                              }
                                                                              if (e[y + 12 >> 2] = (ke << 2) + o, e[y + 8 >> 2] = r, e[y + 4 >> 2] = g, !h)
                                                                                break E;
                                                                              Sr(h);
                                                                            }
                                                                            if (e[5996] = 0, o = ii(3, 4) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) {
                                                                              c = Vr() | 0;
                                                                              break r;
                                                                            }
                                                                            if (e[o >> 2] = y, e[5996] = 0, r = ii(3, 56) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                              break x;
                                                                            if (e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 4 >> 2] = o, e[r >> 2] = 16, o = o + 4 | 0, e[r + 12 >> 2] = o, e[r + 8 >> 2] = o, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[5996] = 0, di(33, c | 0, r | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                              break N;
                                                                            h = e[y + 8 >> 2], g = e[y + 12 >> 2];
                                                                            E: {
                                                                              if (h >>> 0 < g >>> 0) {
                                                                                e[h >> 2] = r, e[y + 8 >> 2] = h + 4;
                                                                                break E;
                                                                              }
                                                                              if (S = e[y + 4 >> 2], Fe = h - S >> 2, o = Fe + 1 | 0, o >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, Ri(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                  break e;
                                                                                break N;
                                                                              }
                                                                              g = g - S | 0, ke = g >> 1, ke = g >>> 0 >= 2147483644 ? 1073741823 : o >>> 0 < ke >>> 0 ? ke : o;
                                                                              C: {
                                                                                if (!ke) {
                                                                                  o = 0;
                                                                                  break C;
                                                                                }
                                                                                if (ke >>> 0 >= 1073741824) {
                                                                                  if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                    break e;
                                                                                  break N;
                                                                                }
                                                                                if (e[5996] = 0, o = ii(3, ke << 2) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                  break N;
                                                                              }
                                                                              if (g = (Fe << 2) + o | 0, e[g >> 2] = r, r = g + 4 | 0, (h | 0) != (S | 0)) {
                                                                                for (; g = g - 4 | 0, h = h - 4 | 0, e[g >> 2] = e[h >> 2], (h | 0) != (S | 0); )
                                                                                  ;
                                                                                h = e[y + 4 >> 2];
                                                                              }
                                                                              if (e[y + 12 >> 2] = (ke << 2) + o, e[y + 8 >> 2] = r, e[y + 4 >> 2] = g, !h)
                                                                                break E;
                                                                              Sr(h);
                                                                            }
                                                                            if (e[5996] = 0, o = ii(3, 4) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) {
                                                                              c = Vr() | 0;
                                                                              break r;
                                                                            }
                                                                            if (e[o >> 2] = y, e[5996] = 0, r = ii(3, 56) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                              break h;
                                                                            if (e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 4 >> 2] = o, e[r >> 2] = 18, o = o + 4 | 0, e[r + 12 >> 2] = o, e[r + 8 >> 2] = o, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[5996] = 0, di(33, c | 0, r | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                              break S;
                                                                            h = e[y + 8 >> 2], g = e[y + 12 >> 2];
                                                                            E: {
                                                                              if (h >>> 0 < g >>> 0) {
                                                                                e[h >> 2] = r, e[y + 8 >> 2] = h + 4;
                                                                                break E;
                                                                              }
                                                                              if (S = e[y + 4 >> 2], Fe = h - S >> 2, o = Fe + 1 | 0, o >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, Ri(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                  break e;
                                                                                break S;
                                                                              }
                                                                              g = g - S | 0, ke = g >> 1, ke = g >>> 0 >= 2147483644 ? 1073741823 : o >>> 0 < ke >>> 0 ? ke : o;
                                                                              C: {
                                                                                if (!ke) {
                                                                                  o = 0;
                                                                                  break C;
                                                                                }
                                                                                if (ke >>> 0 >= 1073741824) {
                                                                                  if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                    break e;
                                                                                  break S;
                                                                                }
                                                                                if (e[5996] = 0, o = ii(3, ke << 2) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                  break S;
                                                                              }
                                                                              if (g = (Fe << 2) + o | 0, e[g >> 2] = r, r = g + 4 | 0, (h | 0) != (S | 0)) {
                                                                                for (; g = g - 4 | 0, h = h - 4 | 0, e[g >> 2] = e[h >> 2], (h | 0) != (S | 0); )
                                                                                  ;
                                                                                h = e[y + 4 >> 2];
                                                                              }
                                                                              if (e[y + 12 >> 2] = (ke << 2) + o, e[y + 8 >> 2] = r, e[y + 4 >> 2] = g, !h)
                                                                                break E;
                                                                              Sr(h);
                                                                            }
                                                                            if (e[5996] = 0, r = e[6079], o = ii(3, 8) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1) {
                                                                              c = Vr() | 0;
                                                                              break r;
                                                                            }
                                                                            if (e[o + 4 >> 2] = r, e[o >> 2] = y, e[5996] = 0, r = ii(3, 56) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                              break b;
                                                                            if (e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 4 >> 2] = o, e[r >> 2] = 11, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 1072693248, o = o + 8 | 0, e[r + 12 >> 2] = o, e[r + 8 >> 2] = o, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[5996] = 0, di(33, c | 0, r | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                              break T;
                                                                            h = e[y + 8 >> 2], g = e[y + 12 >> 2];
                                                                            E: {
                                                                              if (h >>> 0 < g >>> 0) {
                                                                                e[h >> 2] = r, e[y + 8 >> 2] = h + 4;
                                                                                break E;
                                                                              }
                                                                              if (S = e[y + 4 >> 2], Fe = h - S >> 2, o = Fe + 1 | 0, o >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, Ri(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                  break e;
                                                                                break T;
                                                                              }
                                                                              g = g - S | 0, ke = g >> 1, ke = g >>> 0 >= 2147483644 ? 1073741823 : o >>> 0 < ke >>> 0 ? ke : o;
                                                                              C: {
                                                                                if (!ke) {
                                                                                  o = 0;
                                                                                  break C;
                                                                                }
                                                                                if (ke >>> 0 >= 1073741824) {
                                                                                  if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                    break e;
                                                                                  break T;
                                                                                }
                                                                                if (e[5996] = 0, o = ii(3, ke << 2) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                  break T;
                                                                              }
                                                                              if (g = (Fe << 2) + o | 0, e[g >> 2] = r, r = g + 4 | 0, (h | 0) != (S | 0)) {
                                                                                for (; g = g - 4 | 0, h = h - 4 | 0, e[g >> 2] = e[h >> 2], (h | 0) != (S | 0); )
                                                                                  ;
                                                                                h = e[y + 4 >> 2];
                                                                              }
                                                                              if (e[y + 12 >> 2] = (ke << 2) + o, e[y + 8 >> 2] = r, e[y + 4 >> 2] = g, !h)
                                                                                break E;
                                                                              Sr(h);
                                                                            }
                                                                            if (e[5996] = 0, o = ii(3, 4) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) {
                                                                              c = Vr() | 0;
                                                                              break r;
                                                                            }
                                                                            if (e[o >> 2] = y, e[5996] = 0, r = ii(3, 56) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                              break w;
                                                                            if (e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 4 >> 2] = o, e[r >> 2] = 14, o = o + 4 | 0, e[r + 12 >> 2] = o, e[r + 8 >> 2] = o, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[5996] = 0, di(33, c | 0, r | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                              break v;
                                                                            if (h = e[y + 8 >> 2], S = e[y + 12 >> 2], h >>> 0 < S >>> 0) {
                                                                              e[h >> 2] = r, e[y + 8 >> 2] = h + 4;
                                                                              break u;
                                                                            }
                                                                            if (o = e[y + 4 >> 2], g = h - o >> 2, c = g + 1 | 0, c >>> 0 >= 1073741824) {
                                                                              if (e[5996] = 0, Ri(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                break e;
                                                                              break v;
                                                                            }
                                                                            S = S - o | 0, ke = S >> 1, c = S >>> 0 >= 2147483644 ? 1073741823 : c >>> 0 < ke >>> 0 ? ke : c;
                                                                            E: {
                                                                              if (!c) {
                                                                                Fe = 0;
                                                                                break E;
                                                                              }
                                                                              if (c >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                  break e;
                                                                                break v;
                                                                              }
                                                                              if (e[5996] = 0, Fe = ii(3, c << 2) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                break v;
                                                                            }
                                                                            if (g = (g << 2) + Fe | 0, e[g >> 2] = r, r = g + 4 | 0, (o | 0) != (h | 0)) {
                                                                              for (; g = g - 4 | 0, h = h - 4 | 0, e[g >> 2] = e[h >> 2], (o | 0) != (h | 0); )
                                                                                ;
                                                                              h = e[y + 4 >> 2];
                                                                            }
                                                                            if (e[y + 12 >> 2] = (c << 2) + Fe, e[y + 8 >> 2] = r, e[y + 4 >> 2] = g, !h)
                                                                              break u;
                                                                            Sr(h);
                                                                            break u;
                                                                          }
                                                                          c = Vr() | 0, Sr(o);
                                                                          break r;
                                                                        }
                                                                        c = Vr() | 0, Sr(o);
                                                                        break r;
                                                                      }
                                                                      c = Vr() | 0, Sr(o);
                                                                      break r;
                                                                    }
                                                                    c = Vr() | 0, Sr(o);
                                                                    break r;
                                                                  }
                                                                  c = Vr() | 0, Sr(o);
                                                                  break r;
                                                                }
                                                                c = Vr() | 0, Sr(o);
                                                                break r;
                                                              }
                                                              c = Vr() | 0, Sr(o);
                                                              break r;
                                                            }
                                                            c = Vr() | 0, Sr(o);
                                                            break r;
                                                          }
                                                          c = Vr() | 0;
                                                          break r;
                                                        }
                                                        c = Vr() | 0;
                                                        break r;
                                                      }
                                                      c = Vr() | 0;
                                                      break r;
                                                    }
                                                    c = Vr() | 0;
                                                    break r;
                                                  }
                                                  c = Vr() | 0;
                                                  break r;
                                                }
                                                c = Vr() | 0;
                                                break r;
                                              }
                                              c = Vr() | 0;
                                              break r;
                                            }
                                            c = Vr() | 0;
                                            break r;
                                          }
                                          c = Vr() | 0;
                                          break r;
                                        }
                                        return r = e[G + 16 >> 2], r && (e[G + 20 >> 2] = r, Sr(r)), Yr = G + 48 | 0, y | 0;
                                      }
                                      c = Vr() | 0;
                                      break r;
                                    }
                                    c = Vr() | 0;
                                    break r;
                                  }
                                  c = Vr() | 0;
                                  break r;
                                }
                                c = Vr() | 0;
                                break r;
                              }
                              c = Vr() | 0;
                              break r;
                            }
                            c = Vr() | 0;
                            break r;
                          }
                          c = Vr() | 0;
                          break r;
                        }
                        c = Vr() | 0;
                        break r;
                      }
                      c = Vr() | 0;
                    }
                    if (r = e[G + 16 >> 2], !r)
                      break t;
                    e[G + 20 >> 2] = r, Sr(r);
                  }
                  Ki(c | 0), ri();
                }
                ri();
              }
              function zu(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0, Qi = 0, Ji = 0, ss = 0, As = 0, Rs = 0, oo = 0;
                e: {
                  t: {
                    r: {
                      if (e[r >> 2] != 24 || (c = e[r + 32 >> 2], S = e[r + 36 >> 2], (c | 0) == (S | 0)))
                        break r;
                      for (; ; ) {
                        Fe = e[e[c >> 2] + 80 >> 2];
                        n: {
                          if (g >>> 0 > ke >>> 0) {
                            e[ke >> 2] = Fe, ke = ke + 4 | 0;
                            break n;
                          }
                          if (G = ke - o >> 2, h = G + 1 | 0, h >>> 0 >= 1073741824) {
                            if (e[5996] = 0, Ri(94), r = e[5996], e[5996] = 0, (r | 0) == 1)
                              break t;
                            break e;
                          }
                          y = g - o | 0, g = y >> 1, g = y >>> 0 >= 2147483644 ? 1073741823 : h >>> 0 < g >>> 0 ? g : h;
                          i: {
                            if (!g) {
                              y = 0;
                              break i;
                            }
                            if (g >>> 0 >= 1073741824) {
                              if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                break e;
                              break t;
                            }
                            if (e[5996] = 0, y = ii(3, g << 2) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                              break t;
                          }
                          if (h = (G << 2) + y | 0, e[h >> 2] = Fe, ss = h, (o | 0) != (ke | 0))
                            for (; ss = ss - 4 | 0, ke = ke - 4 | 0, e[ss >> 2] = e[ke >> 2], (o | 0) != (ke | 0); )
                              ;
                          g = (g << 2) + y | 0, ke = h + 4 | 0, o && Sr(o), o = ss;
                        }
                        if (c = c + 8 | 0, (S | 0) == (c | 0))
                          break;
                      }
                    }
                    Fe = e[r + 36 >> 2], g = e[r + 32 >> 2], c = Fe - g | 0;
                    r: {
                      if ((g | 0) == (Fe | 0)) {
                        h = 0, G = 0;
                        break r;
                      }
                      if (G = e[e[g >> 2] + 80 >> 2], c >>> 0 < 9) {
                        h = 0;
                        break r;
                      }
                      if (h = e[e[g + 8 >> 2] + 80 >> 2], c >>> 0 < 17)
                        break r;
                      Tr = e[e[g + 16 >> 2] + 80 >> 2];
                    }
                    gi = c >> 3, Ar = e[r + 24 >> 2], Rn = e[r + 20 >> 2], y = Ar - Rn | 0, Ji = e[r + 12 >> 2], As = e[r + 8 >> 2], Rs = Ji - As | 0, S = (Rs | 0) / 12 | 0, ln = e[r + 4 >> 2];
                    r: {
                      n: {
                        i: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  f: {
                                    d: {
                                      c: {
                                        u: {
                                          g: {
                                            A: {
                                              p: {
                                                I:
                                                  switch (o = e[r >> 2], r = o & -2, r - 6 | 0) {
                                                    case 2:
                                                      break p;
                                                    case 0:
                                                      break I;
                                                    default:
                                                      break A;
                                                  }
                                                if ((y | 0) == 32)
                                                  break g;
                                                y = 2369, r = 39, S = 3984;
                                                break n;
                                              }
                                              if ((y | 0) == 20)
                                                break g;
                                              y = 2369, r = 41, S = 4224;
                                              break n;
                                            }
                                            if (y = 2369, (Ar | 0) != (Rn | 0)) {
                                              r = 43, S = 4337;
                                              break n;
                                            }
                                            if ((r | 0) != 4)
                                              break g;
                                            if ((ln | 0) > 0)
                                              break u;
                                            r = 47, S = 3134;
                                            break n;
                                          }
                                          g:
                                            switch (o - 24 | 0) {
                                              case 1:
                                                if (S >>> 0 > ln - 1 >>> 0)
                                                  break c;
                                                y = 2369, r = 49, S = 1397;
                                                break n;
                                              case 0:
                                                if (gi >>> 0 > ln - 1 >>> 0)
                                                  break f;
                                                y = 2369, r = 51, S = 1654;
                                                break n;
                                              default:
                                                break g;
                                            }
                                          if (y = 2369, ln) {
                                            r = 53, S = 4330;
                                            break n;
                                          }
                                          if (o - 17 >>> 0 > 5)
                                            break u;
                                          if ((c | 0) == 16)
                                            break d;
                                          r = 58, S = 4003;
                                          break n;
                                        }
                                        if (o - 10 >>> 0 >= 7) {
                                          if ((o | 0) != 23)
                                            break c;
                                          if ((c | 0) == 24)
                                            break f;
                                          r = 60, S = 3946;
                                          break n;
                                        }
                                        if ((c | 0) == 8)
                                          break f;
                                        r = 64, S = 4090;
                                        break n;
                                      }
                                      if ((o | 0) == 24 | (g | 0) == (Fe | 0))
                                        break d;
                                      y = 2369, r = 66, S = 4311;
                                      break n;
                                    }
                                    if ((r | 0) == 2) {
                                      if ((Rs | 0) == 12)
                                        break l;
                                      y = 2369, r = 70, S = 4063;
                                      break n;
                                    }
                                    if ((o | 0) != 25)
                                      break f;
                                    if (S - 1 >>> 0 < 20)
                                      break o;
                                    y = 2369, r = 72, S = 4240;
                                    break n;
                                  }
                                  if ((Ji | 0) == (As | 0))
                                    break l;
                                  y = 2369, r = 74, S = 4299;
                                  break n;
                                }
                                c = 10, g = 2108, y = 2369, r = 247, S = 2350;
                                l:
                                  switch (o | 0) {
                                    case 3:
                                      c = 9, g = 2119;
                                      break a;
                                    case 4:
                                      if (e[5996] = 0, r = On(54, 2295, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1 || (e[5996] = 0, o = On(54, 2278, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1) || (e[5996] = 0, c = On(54, 2129, 6) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1))
                                        break r;
                                      o = c | (ln & 4194304 ? r : o);
                                      break i;
                                    case 5:
                                      if (e[5996] = 0, r = On(54, 2174, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1 || (e[5996] = 0, o = On(54, 2170, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1) || (e[5996] = 0, c = On(54, 2129, 6) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1))
                                        break r;
                                      o = c | ((ln >>> 0 < 5e8 ? o : 0) | (ln >>> 0 > 499999999 ? r : 0));
                                      break i;
                                    case 6:
                                    case 7:
                                    case 8:
                                    case 9:
                                      c = 7, g = 2153;
                                      break a;
                                    case 1:
                                      c = 7, g = 2136;
                                      break a;
                                    case 0:
                                      c = 9, g = 2098;
                                      break a;
                                    case 10:
                                      if (e[5996] = 0, r = On(54, 2777, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1 || (e[5996] = 0, o = On(54, 3557, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1) || (e[5996] = 0, c = On(54, 2161, 5) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1) || (e[5996] = 0, h = On(54, 1600, 6) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, y = On(54, 1239, 1) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1))
                                        break r;
                                      o = (c | h) & G | (y | (o & (G ^ -1) ? 0 : r));
                                      break i;
                                    case 11:
                                      if (e[5996] = 0, r = On(54, 2777, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1 || (e[5996] = 0, o = On(54, 1958, 2) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1) || (e[5996] = 0, c = On(54, 2161, 5) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1) || (e[5996] = 0, h = On(54, 1197, 7) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1))
                                        break r;
                                      o = (c | h) & G | (o & (G ^ -1) ? 0 : r);
                                      break i;
                                    case 12:
                                      if (e[5996] = 0, r = On(54, 3557, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1 || (e[5996] = 0, o = On(54, 3310, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1) || (e[5996] = 0, c = On(54, 2161, 5) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1) || (e[5996] = 0, h = On(54, 2035, 6) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, y = On(54, 1419, 2) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1))
                                        break r;
                                      o = (c | h) & G | (y | (o & (G ^ -1) ? 0 : r));
                                      break i;
                                    case 13:
                                      if (e[5996] = 0, o = On(54, 3557, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, c = On(54, 1028, 2) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, r = On(54, 1959, 1) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1) || (e[5996] = 0, h = On(54, 1029, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, y = On(54, 2451, 1) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1) || (e[5996] = 0, g = On(54, 2315, 1) | 0, Fe = e[5996], e[5996] = 0, (Fe | 0) == 1) || (e[5996] = 0, Fe = On(54, 2161, 5) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) || (e[5996] = 0, S = On(54, 1640, 2) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1) || (e[5996] = 0, ke = On(54, 1208, 3) | 0, ln = e[5996], e[5996] = 0, (ln | 0) == 1))
                                        break r;
                                      Ar = r, r = G ^ -1, o = (S | Fe) & G | (ke | ((r & h ? 0 : Ar) | (r & c ? 0 : o) | (r & g ? 0 : y)));
                                      break i;
                                    case 14:
                                      if (e[5996] = 0, r = On(54, 2796, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1 || (e[5996] = 0, o = On(54, 3557, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1) || (e[5996] = 0, c = On(54, 2161, 5) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1) || (e[5996] = 0, h = On(54, 1486, 5) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, y = On(54, 1205, 2) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1))
                                        break r;
                                      o = (c | h) & G | (y | (o & (G ^ -1) ? 0 : r));
                                      break i;
                                    case 15:
                                      if (e[5996] = 0, r = On(54, 3557, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1 || (e[5996] = 0, o = On(54, 2028, 2) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1) || (e[5996] = 0, c = On(54, 2451, 1) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1) || (e[5996] = 0, h = On(54, 2315, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, y = On(54, 2161, 5) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1) || (e[5996] = 0, g = On(54, 1430, 4) | 0, Fe = e[5996], e[5996] = 0, (Fe | 0) == 1) || (e[5996] = 0, Fe = On(54, 1208, 3) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1))
                                        break r;
                                      S = c, c = G ^ -1, o = (y | g) & G | (Fe | ((c & h ? 0 : S) | (o & c ? 0 : r)));
                                      break i;
                                    case 16:
                                      if (e[5996] = 0, r = On(54, 2161, 5) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1 || (e[5996] = 0, o = On(54, 1607, 9) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1) || (e[5996] = 0, c = On(54, 1149, 2) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1))
                                        break r;
                                      o = c | (r | o) & G;
                                      break i;
                                    case 17:
                                      if (e[5996] = 0, Fe = On(54, 3540, 3) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, S = On(54, 2796, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, ke = On(54, 2029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, ln = On(54, 2029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Tr = On(54, 1029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, gi = On(54, 1959, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Ar = On(54, 1029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Rn = On(54, 1024, 3) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Ji = On(54, 1681, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, r = On(54, 2315, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1) || (e[5996] = 0, o = On(54, 2315, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1))
                                        break r;
                                      y = G ^ -1, g = h ^ -1;
                                      f: {
                                        if (g & o) {
                                          if (c = 0, e[5996] = 0, o = On(54, 1681, 1) | 0, As = e[5996], e[5996] = 0, (As | 0) == 1)
                                            break r;
                                          if (o & y)
                                            break f;
                                        }
                                        c = r;
                                      }
                                      if (e[5996] = 0, As = On(54, 1149, 2) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, Rs = On(54, 2167, 4) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, r = On(54, 2165, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1) || (e[5996] = 0, ei = On(54, 2165, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1))
                                        break r;
                                      o = 0, Mn = h & G;
                                      f: {
                                        if (ei & (Mn ^ -1))
                                          break f;
                                        if (e[5996] = 0, o = On(54, 2295, 1) | 0, ei = e[5996], e[5996] = 0, (ei | 0) == 1)
                                          break r;
                                        if (!(o & y)) {
                                          if (o = 0, e[5996] = 0, ei = On(54, 2278, 1) | 0, ci = e[5996], e[5996] = 0, (ci | 0) == 1)
                                            break r;
                                          if (!(g & ei))
                                            break f;
                                        }
                                        if (e[5996] = 0, o = On(54, 2278, 1) | 0, ei = e[5996], e[5996] = 0, (ei | 0) == 1)
                                          break r;
                                        if (!(o & y)) {
                                          if (o = 0, e[5996] = 0, ei = On(54, 2295, 1) | 0, ci = e[5996], e[5996] = 0, (ci | 0) == 1)
                                            break r;
                                          if (!(g & ei))
                                            break f;
                                        }
                                        if (e[5996] = 0, o = On(54, 2174, 1) | 0, ei = e[5996], e[5996] = 0, (ei | 0) == 1)
                                          break r;
                                        if (!(o & y)) {
                                          if (o = 0, e[5996] = 0, ei = On(54, 2170, 1) | 0, ci = e[5996], e[5996] = 0, (ci | 0) == 1)
                                            break r;
                                          if (!(g & ei))
                                            break f;
                                        }
                                        if (e[5996] = 0, o = On(54, 2170, 1) | 0, ei = e[5996], e[5996] = 0, (ei | 0) == 1)
                                          break r;
                                        if (!(o & y)) {
                                          if (o = 0, e[5996] = 0, ei = On(54, 2174, 1) | 0, ci = e[5996], e[5996] = 0, (ci | 0) == 1)
                                            break r;
                                          if (!(g & ei))
                                            break f;
                                        }
                                        o = r;
                                      }
                                      r = h | G, o = h & As | (Rn & Mn | (G & ke | (y & S ? 0 : h & Fe) | (y & Tr ? 0 : h & ln)) | (Ar & (r ^ -1) ? 0 : r & gi) | r & Ji | c) | r & Rs | o;
                                      break i;
                                    case 18:
                                      if (e[5996] = 0, ke = On(54, 3557, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, ln = On(54, 2777, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Tr = On(54, 1959, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, gi = On(54, 1029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Ar = On(54, 2029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Rn = On(54, 2029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Ji = On(54, 1029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, As = On(54, 2451, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Rs = On(54, 1681, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, ei = On(54, 2031, 3) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, r = On(54, 2315, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1) || (e[5996] = 0, y = On(54, 2315, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1))
                                        break r;
                                      o = h ^ -1, c = G ^ -1, g = h & G, S = g ^ -1;
                                      f: {
                                        d: {
                                          if (!(S & y))
                                            break d;
                                          if (e[5996] = 0, y = On(54, 2297, 2) | 0, Fe = e[5996], e[5996] = 0, (Fe | 0) == 1)
                                            break r;
                                          if (!(c & y))
                                            break d;
                                          if (Fe = 0, e[5996] = 0, y = On(54, 2297, 2) | 0, Mn = e[5996], e[5996] = 0, (Mn | 0) == 1)
                                            break r;
                                          if (o & y)
                                            break f;
                                        }
                                        Fe = r;
                                      }
                                      if (e[5996] = 0, Mn = On(54, 1681, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, ci = On(54, 1149, 2) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, oo = On(54, 2167, 4) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, r = On(54, 2165, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) || (y = 0, e[5996] = 0, hr = On(54, 2165, 1) | 0, Qi = e[5996], e[5996] = 0, (Qi | 0) == 1))
                                        break r;
                                      f: {
                                        if (S & hr)
                                          break f;
                                        if (e[5996] = 0, y = On(54, 2295, 1) | 0, hr = e[5996], e[5996] = 0, (hr | 0) == 1)
                                          break r;
                                        if (!(c & y)) {
                                          if (y = 0, e[5996] = 0, hr = On(54, 2278, 1) | 0, Qi = e[5996], e[5996] = 0, (Qi | 0) == 1)
                                            break r;
                                          if (!(o & hr))
                                            break f;
                                        }
                                        if (e[5996] = 0, y = On(54, 2278, 1) | 0, hr = e[5996], e[5996] = 0, (hr | 0) == 1)
                                          break r;
                                        if (!(c & y)) {
                                          if (y = 0, e[5996] = 0, hr = On(54, 2295, 1) | 0, Qi = e[5996], e[5996] = 0, (Qi | 0) == 1)
                                            break r;
                                          if (!(o & hr))
                                            break f;
                                        }
                                        if (e[5996] = 0, y = On(54, 2174, 1) | 0, hr = e[5996], e[5996] = 0, (hr | 0) == 1)
                                          break r;
                                        if (!(c & y)) {
                                          if (y = 0, e[5996] = 0, hr = On(54, 2170, 1) | 0, Qi = e[5996], e[5996] = 0, (Qi | 0) == 1)
                                            break r;
                                          if (!(o & hr))
                                            break f;
                                        }
                                        if (e[5996] = 0, y = On(54, 2170, 1) | 0, hr = e[5996], e[5996] = 0, (hr | 0) == 1)
                                          break r;
                                        if (!(c & y)) {
                                          if (y = 0, e[5996] = 0, hr = On(54, 2174, 1) | 0, Qi = e[5996], e[5996] = 0, (Qi | 0) == 1)
                                            break r;
                                          if (!(o & hr))
                                            break f;
                                        }
                                        y = r;
                                      }
                                      r = h | G, o = ci | (g & ei | (G & Ar | (o & ln ? 0 : G & ke) | (gi & (r ^ -1) ? 0 : r & Tr) | (c & Ji ? 0 : h & Rn)) | (S & Rs ? 0 : g & As) | Fe | r & Mn) | r & oo | y;
                                      break i;
                                    case 19:
                                      if (e[5996] = 0, r = On(54, 3557, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1 || (e[5996] = 0, o = On(54, 2504, 2) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1))
                                        break r;
                                      if (c = 0, !((G ^ -1) & o)) {
                                        if (e[5996] = 0, o = On(54, 2501, 2) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                          break r;
                                        c = o & (h ^ -1) ? 0 : r;
                                      }
                                      if (e[5996] = 0, y = On(54, 1959, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, Fe = On(54, 1029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, S = On(54, 2049, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (g = 0, e[5996] = 0, o = On(54, 1681, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1))
                                        break r;
                                      if (r = h & G, Ar = o, o = h | G, h = o ^ -1, !(Ar & h)) {
                                        if (e[5996] = 0, g = On(54, 2451, 1) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                          break r;
                                        g = g & (r ^ -1) ? 0 : r & S;
                                      }
                                      if (e[5996] = 0, S = On(54, 2340, 3) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1 || (e[5996] = 0, G = On(54, 1148, 3) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1) || (e[5996] = 0, ke = On(54, 2167, 4) | 0, ln = e[5996], e[5996] = 0, (ln | 0) == 1) || (e[5996] = 0, ln = On(54, 2165, 1) | 0, Tr = e[5996], e[5996] = 0, (Tr | 0) == 1))
                                        break r;
                                      o = r & ln | (o & ke | (G | (r & S | ((h & Fe ? 0 : o & y) | c | g))));
                                      break i;
                                    case 21:
                                      if (e[5996] = 0, y = On(54, 3557, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, g = On(54, 1293, 3) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Fe = On(54, 1959, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, S = On(54, 1029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, r = On(54, 2049, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1) || (e[5996] = 0, c = On(54, 2451, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1))
                                        break r;
                                      o = h & G, ke = G ^ -1;
                                      f: {
                                        if (ke & c) {
                                          r = h | G, c = 0;
                                          break f;
                                        }
                                        if (e[5996] = 0, c = On(54, 1681, 1) | 0, ln = e[5996], e[5996] = 0, (ln | 0) == 1)
                                          break r;
                                        Ar = r & o, r = h | G, c = c & (r ^ -1) ? 0 : Ar;
                                      }
                                      if (e[5996] = 0, ln = On(54, 1650, 3) | 0, Tr = e[5996], e[5996] = 0, (Tr | 0) == 1 || (e[5996] = 0, Tr = On(54, 2468, 3) | 0, gi = e[5996], e[5996] = 0, (gi | 0) == 1) || (e[5996] = 0, gi = On(54, 1239, 1) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1) || (e[5996] = 0, Ar = On(54, 2167, 4) | 0, Rn = e[5996], e[5996] = 0, (Rn | 0) == 1) || (e[5996] = 0, Rn = On(54, 2165, 1) | 0, Ji = e[5996], e[5996] = 0, (Ji | 0) == 1))
                                        break r;
                                      o = o & Rn | (r & Ar | (gi | (h & Tr | (o & ln | (c | ((S & (h ^ -1) ? 0 : G & Fe) | (g & ke ? 0 : h & y)))))));
                                      break i;
                                    case 20:
                                      if (e[5996] = 0, y = On(54, 2796, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, g = On(54, 1293, 3) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Fe = On(54, 1959, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, S = On(54, 1029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, r = On(54, 2049, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1) || (e[5996] = 0, c = On(54, 2451, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1))
                                        break r;
                                      o = h & G, ke = G ^ -1;
                                      f: {
                                        if (ke & c) {
                                          r = h | G, c = 0;
                                          break f;
                                        }
                                        if (e[5996] = 0, c = On(54, 1681, 1) | 0, ln = e[5996], e[5996] = 0, (ln | 0) == 1)
                                          break r;
                                        Ar = r & o, r = h | G, c = c & (r ^ -1) ? 0 : Ar;
                                      }
                                      if (e[5996] = 0, ln = On(54, 1394, 2) | 0, Tr = e[5996], e[5996] = 0, (Tr | 0) == 1 || (e[5996] = 0, Tr = On(54, 1205, 2) | 0, gi = e[5996], e[5996] = 0, (gi | 0) == 1) || (e[5996] = 0, gi = On(54, 2167, 4) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1) || (e[5996] = 0, Ar = On(54, 2165, 1) | 0, Rn = e[5996], e[5996] = 0, (Rn | 0) == 1))
                                        break r;
                                      o = o & Ar | (r & gi | (Tr | (o & ln | (c | ((S & (h ^ -1) ? 0 : G & Fe) | (g & ke ? 0 : h & y))))));
                                      break i;
                                    case 22:
                                      if (e[5996] = 0, y = On(54, 1643, 6) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, o = On(54, 1959, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, g = On(54, 1029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Fe = On(54, 2451, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, S = On(54, 2315, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, ke = On(54, 2049, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, ln = On(54, 1681, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Tr = On(54, 2522, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, gi = On(54, 1239, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Ar = On(54, 2167, 4) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Rn = On(54, 2165, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1))
                                        break r;
                                      r = h | G, c = r ^ -1, hr = o, o = h & G, o = r & Ar | (gi | (r & Tr | ((g & (o ^ -1) ? 0 : hr) | o & y | (c & S ? 0 : r & Fe))) | (c & ln ? 0 : o & ke)) | o & Rn;
                                      break i;
                                    case 24:
                                      break s;
                                    case 2:
                                      break a;
                                    case 25:
                                      break o;
                                    case 23:
                                      break l;
                                    default:
                                      break n;
                                  }
                                if (e[5996] = 0, gi = On(54, 2779, 3) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, Ar = On(54, 1293, 3) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Rn = On(54, 1029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Ji = On(54, 1959, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, As = On(54, 1029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Rs = On(54, 1295, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, r = On(54, 2315, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1) || (e[5996] = 0, o = On(54, 1681, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1))
                                  break r;
                                c = G ^ -1;
                                l: {
                                  if (c & o) {
                                    if (y = 0, e[5996] = 0, o = On(54, 2315, 1) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                      break r;
                                    if ((h ^ -1) & o)
                                      break l;
                                  }
                                  y = r & Tr;
                                }
                                if (e[5996] = 0, ei = On(54, 2522, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, r = On(54, 2451, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1) || (e[5996] = 0, o = On(54, 1681, 1) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1))
                                  break r;
                                l: {
                                  if (o & c) {
                                    if (Fe = 0, e[5996] = 0, o = On(54, 2315, 1) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                      break r;
                                    if ((h ^ -1) & o)
                                      break l;
                                  }
                                  Fe = r & G & Tr;
                                }
                                if (e[5996] = 0, r = On(54, 2049, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1 || (e[5996] = 0, o = On(54, 2451, 1) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1))
                                  break r;
                                ln = h & G & Tr;
                                l: {
                                  if (o & c) {
                                    S = h | G, ke = Tr | S, r = 0;
                                    break l;
                                  }
                                  if (e[5996] = 0, o = On(54, 1681, 1) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                    break r;
                                  S = h | G, ke = Tr | S, r = o & (ke ^ -1) ? 0 : r & ln;
                                }
                                if (e[5996] = 0, Mn = On(54, 1681, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1 || (e[5996] = 0, ci = On(54, 1239, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1) || (e[5996] = 0, oo = On(54, 2167, 4) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1) || (e[5996] = 0, o = On(54, 2165, 1) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1) || (g = 0, e[5996] = 0, hr = On(54, 2165, 1) | 0, Qi = e[5996], e[5996] = 0, (Qi | 0) == 1))
                                  break r;
                                l: {
                                  if (hr & (ln ^ -1))
                                    break l;
                                  if (e[5996] = 0, g = On(54, 2295, 1) | 0, hr = e[5996], e[5996] = 0, (hr | 0) == 1)
                                    break r;
                                  if (!(c & g)) {
                                    if (g = 0, e[5996] = 0, hr = On(54, 2278, 1) | 0, Qi = e[5996], e[5996] = 0, (Qi | 0) == 1)
                                      break r;
                                    if (!((h ^ -1) & hr))
                                      break l;
                                  }
                                  if (e[5996] = 0, g = On(54, 2278, 1) | 0, hr = e[5996], e[5996] = 0, (hr | 0) == 1)
                                    break r;
                                  if (!(c & g)) {
                                    if (g = 0, e[5996] = 0, hr = On(54, 2295, 1) | 0, Qi = e[5996], e[5996] = 0, (Qi | 0) == 1)
                                      break r;
                                    if (!((h ^ -1) & hr))
                                      break l;
                                  }
                                  if (e[5996] = 0, g = On(54, 2174, 1) | 0, hr = e[5996], e[5996] = 0, (hr | 0) == 1)
                                    break r;
                                  if (!(c & g)) {
                                    if (g = 0, e[5996] = 0, hr = On(54, 2170, 1) | 0, Qi = e[5996], e[5996] = 0, (Qi | 0) == 1)
                                      break r;
                                    if (!((h ^ -1) & hr))
                                      break l;
                                  }
                                  if (e[5996] = 0, g = On(54, 2170, 1) | 0, hr = e[5996], e[5996] = 0, (hr | 0) == 1)
                                    break r;
                                  if (!(c & g)) {
                                    if (g = 0, e[5996] = 0, hr = On(54, 2174, 1) | 0, Qi = e[5996], e[5996] = 0, (Qi | 0) == 1)
                                      break r;
                                    if (!((h ^ -1) & hr))
                                      break l;
                                  }
                                  g = o;
                                }
                                o = h & Tr, h = o | G, o = ke & oo | (S & Mn & Tr | (ci | (r | (Tr & ei | (o & Rs | (ln & Rn | (c & Ar ? 0 : o & gi)) | (As & (h ^ -1) ? 0 : h & Ji) | y) | Fe)))) | g;
                                break i;
                              }
                              c = 8, g = 2144;
                            }
                            if (e[5996] = 0, o = On(54, g | 0, c | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1)
                              break i;
                            break r;
                          }
                          if (g = 0, e[5996] = 0, Fe = 1, c = On(54, 2165, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                            break r;
                          s: {
                            if ((ke | 0) == (ss | 0)) {
                              r = 1, G = 0;
                              break s;
                            }
                            if (y = e[ss >> 2], o = 0, e[5996] = 0, r = On(54, 1293, 3) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                              break r;
                            if (h = y ^ -1, h & r)
                              break i;
                            if (e[5996] = 0, S = On(54, 2451, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, G = On(54, 2049, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Tr = On(54, 1681, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, r = On(54, 1029, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1))
                              break r;
                            if (r & h) {
                              if (e[5996] = 0, r = On(54, 1959, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                break r;
                              g = r & h ? 2 : 1;
                            }
                            if (e[5996] = 0, Ar = On(54, 2167, 4) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, r = On(54, 2165, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1) || (e[5996] = 0, Fe = On(54, 2165, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1))
                              break r;
                            o = 0;
                            a: {
                              if (Fe & (c & y ^ -1))
                                break a;
                              o: {
                                if (ln >>> 0 < 2)
                                  break o;
                                if (e[5996] = 0, o = On(54, 2295, 1) | 0, Fe = e[5996], e[5996] = 0, (Fe | 0) == 1)
                                  break r;
                                if (Fe = c ^ -1, !(Fe & o)) {
                                  if (o = 0, e[5996] = 0, Rn = On(54, 2278, 1) | 0, Ji = e[5996], e[5996] = 0, (Ji | 0) == 1)
                                    break r;
                                  if (!(h & Rn))
                                    break a;
                                }
                                if (e[5996] = 0, o = On(54, 2278, 1) | 0, Rn = e[5996], e[5996] = 0, (Rn | 0) == 1)
                                  break r;
                                if (!(o & Fe)) {
                                  if (o = 0, e[5996] = 0, Rn = On(54, 2295, 1) | 0, Ji = e[5996], e[5996] = 0, (Ji | 0) == 1)
                                    break r;
                                  if (!(h & Rn))
                                    break a;
                                }
                                if (e[5996] = 0, o = On(54, 2174, 1) | 0, Rn = e[5996], e[5996] = 0, (Rn | 0) == 1)
                                  break r;
                                if (!(o & Fe)) {
                                  if (o = 0, e[5996] = 0, Rn = On(54, 2170, 1) | 0, Ji = e[5996], e[5996] = 0, (Ji | 0) == 1)
                                    break r;
                                  if (!(h & Rn))
                                    break a;
                                }
                                if (e[5996] = 0, o = On(54, 2170, 1) | 0, Rn = e[5996], e[5996] = 0, (Rn | 0) == 1)
                                  break r;
                                if (o & Fe)
                                  break o;
                                if (o = 0, e[5996] = 0, Fe = On(54, 2174, 1) | 0, Rn = e[5996], e[5996] = 0, (Rn | 0) == 1)
                                  break r;
                                if (!(h & Fe))
                                  break a;
                              }
                              o = r;
                            }
                            if (r = !(h & S), Fe = !(h & G), G = !(h & Tr), c = Ar & (c | y) | o, o = ke - ss | 0, o >>> 0 < 5)
                              break s;
                            for (o = o >> 2, Rn = o >>> 0 <= 2 ? 2 : o, y = 1; ; ) {
                              if (Tr = e[(y << 2) + ss >> 2], e[5996] = 0, o = On(54, 1289, 3) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                break t;
                              if (ke = Tr ^ -1, ke & o) {
                                o = 0;
                                break i;
                              }
                              if (e[5996] = 0, Ji = On(54, 2451, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1 || (e[5996] = 0, As = On(54, 2049, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1) || (e[5996] = 0, Rs = On(54, 1681, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1) || (e[5996] = 0, o = On(54, 1029, 1) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1))
                                break t;
                              if (o & ke) {
                                if (e[5996] = 0, o = On(54, 1959, 1) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                  break t;
                                o = o & ke ? 2 : 1;
                              } else
                                o = 0;
                              if (e[5996] = 0, ei = On(54, 2167, 4) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1 || (e[5996] = 0, S = On(54, 2165, 1) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1) || (e[5996] = 0, Ar = On(54, 2165, 1) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1))
                                break t;
                              h = 0;
                              a: {
                                if (Ar & (c & Tr ^ -1))
                                  break a;
                                o: {
                                  if (ln >>> 0 < 2)
                                    break o;
                                  if (e[5996] = 0, Ar = On(54, 2295, 1) | 0, Mn = e[5996], e[5996] = 0, (Mn | 0) == 1)
                                    break t;
                                  if (hr = Ar, Ar = c ^ -1, !(hr & Ar)) {
                                    if (e[5996] = 0, Mn = On(54, 2278, 1) | 0, ci = e[5996], e[5996] = 0, (ci | 0) == 1)
                                      break t;
                                    if (!(ke & Mn))
                                      break a;
                                  }
                                  if (e[5996] = 0, Mn = On(54, 2278, 1) | 0, ci = e[5996], e[5996] = 0, (ci | 0) == 1)
                                    break t;
                                  if (!(Ar & Mn)) {
                                    if (e[5996] = 0, Mn = On(54, 2295, 1) | 0, ci = e[5996], e[5996] = 0, (ci | 0) == 1)
                                      break t;
                                    if (!(ke & Mn))
                                      break a;
                                  }
                                  if (e[5996] = 0, Mn = On(54, 2174, 1) | 0, ci = e[5996], e[5996] = 0, (ci | 0) == 1)
                                    break t;
                                  if (!(Ar & Mn)) {
                                    if (e[5996] = 0, Mn = On(54, 2170, 1) | 0, ci = e[5996], e[5996] = 0, (ci | 0) == 1)
                                      break t;
                                    if (!(ke & Mn))
                                      break a;
                                  }
                                  if (e[5996] = 0, Mn = On(54, 2170, 1) | 0, ci = e[5996], e[5996] = 0, (ci | 0) == 1)
                                    break t;
                                  if (Ar & Mn)
                                    break o;
                                  if (e[5996] = 0, Ar = On(54, 2174, 1) | 0, Mn = e[5996], e[5996] = 0, (Mn | 0) == 1)
                                    break t;
                                  if (!(ke & Ar))
                                    break a;
                                }
                                h = S;
                              }
                              if (r = !(ke & Ji) & r, Fe = !(ke & As) & Fe, G = !(ke & Rs) + G | 0, g = o + g | 0, c = ei & (c | Tr) | h, y = y + 1 | 0, (Rn | 0) == (y | 0))
                                break;
                            }
                          }
                          if (e[5996] = 0, o = On(54, 1293, 3) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1 || (e[5996] = 0, h = On(54, 1029, 1) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, y = On(54, 1959, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) || (e[5996] = 0, S = On(54, 2451, 1) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1) || (e[5996] = 0, ke = On(54, 2049, 1) | 0, Tr = e[5996], e[5996] = 0, (Tr | 0) == 1) || (e[5996] = 0, Tr = On(54, 1681, 1) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1))
                            break r;
                          o = o | c | (g ? 0 : h) | ((g | 0) == 1 ? y : 0) | (r && (G | 0) == (gi | 0) ? S : 0), c = r & Fe ? ke : 0, r = gi - ln | 0, o = o | (r >>> 0 <= G >>> 0 ? c : 0) | (r + 1 >>> 0 <= G >>> 0 ? Tr : 0);
                        }
                        if (e[5996] = 0, c = On(54, 3310, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, h = On(54, 2796, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, g = On(54, 3557, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Fe = On(54, 2777, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1))
                          break r;
                        y = 2356, r = 19, S = 4075;
                        i: {
                          s:
                            switch (Ar = h, h = o ^ -1, c = ((!(Ar & h) + !(c & h) | 0) + !(h & g) | 0) + !(h & Fe) | 0, c | 0) {
                              case 0:
                                break i;
                              case 1:
                                break s;
                              default:
                                break n;
                            }
                          if (e[5996] = 0, r = On(54, 1029, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                            break r;
                          s: {
                            if (r & h)
                              break s;
                            if (e[5996] = 0, r = On(54, 1959, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                              break r;
                            if (r & h)
                              break s;
                            r = 20, S = 4494;
                            break n;
                          }
                          if (e[5996] = 0, r = On(54, 2029, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                            break r;
                          s: {
                            if (r & h)
                              break s;
                            if (e[5996] = 0, r = On(54, 1029, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                              break r;
                            if (r & h)
                              break s;
                            r = 21, S = 4356;
                            break n;
                          }
                          if (e[5996] = 0, r = On(54, 2029, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                            break r;
                          s: {
                            if (r & h)
                              break s;
                            if (e[5996] = 0, r = On(54, 2777, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                              break r;
                            if (r & h)
                              break s;
                            r = 22, S = 4771;
                            break n;
                          }
                          if (e[5996] = 0, r = On(54, 2796, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                            break r;
                          s: {
                            if (r & h)
                              break s;
                            if (e[5996] = 0, r = On(54, 2522, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                              break r;
                            if (r & h)
                              break s;
                            r = 23, S = 4702;
                            break n;
                          }
                          if (e[5996] = 0, r = On(54, 3310, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                            break r;
                          s: {
                            if (r & h)
                              break s;
                            if (e[5996] = 0, r = On(54, 1295, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                              break r;
                            if (!(r & h))
                              break s;
                            r = 24, S = 4426;
                            break n;
                          }
                          if (e[5996] = 0, r = On(54, 2796, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                            break r;
                          s: {
                            if (r & h)
                              break s;
                            if (e[5996] = 0, r = On(54, 1295, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                              break r;
                            if (r & h)
                              break s;
                            r = 25, S = 4391;
                            break n;
                          }
                          if (e[5996] = 0, r = On(54, 2451, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                            break r;
                          s: {
                            if (r & h)
                              break s;
                            if (e[5996] = 0, r = On(54, 2315, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                              break r;
                            if (r & h)
                              break s;
                            r = 26, S = 4563;
                            break n;
                          }
                          if (e[5996] = 0, r = On(54, 2451, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                            break r;
                          s: {
                            if (r & h)
                              break s;
                            if (e[5996] = 0, r = On(54, 2522, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                              break r;
                            if (!(r & h))
                              break s;
                            r = 27, S = 4737;
                            break n;
                          }
                          if (e[5996] = 0, r = On(54, 2796, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                            break r;
                          s: {
                            if (r & h)
                              break s;
                            if (e[5996] = 0, r = On(54, 2451, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                              break r;
                            if (r & h)
                              break s;
                            r = 28, S = 4667;
                            break n;
                          }
                          if (e[5996] = 0, r = On(54, 2522, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                            break r;
                          s: {
                            if (r & h)
                              break s;
                            if (e[5996] = 0, r = On(54, 2315, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                              break r;
                            if (r & h)
                              break s;
                            r = 29, S = 4598;
                            break n;
                          }
                          if (e[5996] = 0, r = On(54, 2796, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                            break r;
                          s: {
                            if (r & h)
                              break s;
                            if (e[5996] = 0, r = On(54, 2315, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                              break r;
                            if (!(r & h))
                              break s;
                            r = 30, S = 4633;
                            break n;
                          }
                          if (e[5996] = 0, r = On(54, 3310, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                            break r;
                          s: {
                            if (r & h)
                              break s;
                            if (e[5996] = 0, r = On(54, 1681, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                              break r;
                            if (!(r & h))
                              break s;
                            r = 31, S = 4460;
                            break n;
                          }
                          if (e[5996] = 0, r = On(54, 1029, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                            break r;
                          if (r & h) {
                            c = o;
                            break i;
                          }
                          if (e[5996] = 0, r = On(54, 2049, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                            break r;
                          if (c = o, !(r & h))
                            break i;
                          r = 32, S = 4529;
                          break n;
                        }
                        return ss && Sr(ss), c | 0;
                      }
                      if (e[5996] = 0, Qs(44, S | 0, 1859, r | 0, y | 0), r = e[5996], e[5996] = 0, (r | 0) != 1)
                        break e;
                    }
                  }
                  r = Vr() | 0, ss && Sr(ss), Ki(r | 0), ri();
                }
                ri();
              }
              function Ju(r, o, c, h, y, g, S, G, ke, Fe, Ar) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, G = G | 0, ke = ke | 0, Fe = Fe | 0, Ar = Ar | 0;
                var hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0, Qi = 0, Ji = 0, ss = 0;
                hr = Yr - 304 | 0, Yr = hr;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  f: {
                                    d: {
                                      c: {
                                        u: {
                                          g: {
                                            A: {
                                              p: {
                                                I: {
                                                  k: {
                                                    N: {
                                                      if (Tr = Da(r), Tr >>> 0 >= 2147483632) {
                                                        if (e[5996] = 0, Ri(2), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                          break N;
                                                        break e;
                                                      }
                                                      S: {
                                                        if (Tr >>> 0 <= 10) {
                                                          $[hr + 155 | 0] = Tr, ln = hr + 144 | 0;
                                                          break S;
                                                        }
                                                        if (e[5996] = 0, Rn = (Tr | 15) + 1 | 0, ln = ii(3, Rn | 0) | 0, Mn = e[5996], e[5996] = 0, (Mn | 0) == 1)
                                                          break N;
                                                        e[hr + 144 >> 2] = ln, e[hr + 148 >> 2] = Tr, e[hr + 152 >> 2] = Rn | -2147483648;
                                                      }
                                                      $[_s(ln, r, Tr) + Tr | 0] = 0, ei = e[hr + 144 >> 2], r = ye[hr + 155 | 0], ci = r << 24 >> 24, Tr = (ci | 0) < 0, Mn = Tr ? ei : hr + 144 | 0, gi = Tr ? e[hr + 148 >> 2] : r, Tr = Mn + gi | 0, ln = -1;
                                                      S: {
                                                        for (; ; ) {
                                                          if ((Tr | 0) == (Mn | 0))
                                                            break S;
                                                          if (Tr = Tr - 1 | 0, Rn = ye[Tr | 0], ss = Rn >>> 0 <= 63, r = Rn & 31, (Rn & 63) >>> 0 >= 32 ? (Rn = 1 << r, Qi = 0) : (Qi = 1 << r, Rn = Qi - 1 & 1 >>> 32 - r), r = Qi & 9728, !(ss & (Rn & 1 | (r | 0) != 0)))
                                                            break;
                                                        }
                                                        ln = Tr - Mn | 0;
                                                      }
                                                      if (r = ln + 1 | 0, r >>> 0 > gi >>> 0) {
                                                        if (e[5996] = 0, Ri(108), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                          break e;
                                                        Tr = Ts(22864) | 0, r = uo;
                                                        break u;
                                                      }
                                                      S: {
                                                        if ((ci | 0) < 0) {
                                                          e[hr + 148 >> 2] = r;
                                                          break S;
                                                        }
                                                        $[hr + 155 | 0] = r, ei = hr + 144 | 0;
                                                      }
                                                      $[r + ei | 0] = 0, e[hr + 12 >> 2] = 0, e[hr + 16 >> 2] = 0;
                                                      S: {
                                                        if ($[hr + 155 | 0] >= 0) {
                                                          e[hr + 120 >> 2] = e[hr + 152 >> 2], r = e[hr + 148 >> 2], e[hr + 112 >> 2] = e[hr + 144 >> 2], e[hr + 116 >> 2] = r;
                                                          break S;
                                                        }
                                                        if (e[5996] = 0, as(40, hr + 112 | 0, e[hr + 144 >> 2], e[hr + 148 >> 2]), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                          break k;
                                                      }
                                                      if (e[5996] = 0, Tr = hr + 128 | 0, di(109, Tr | 0, hr + 112 | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                        break I;
                                                      ln = $[hr + 139 | 0], r = (ln | 0) < 0, e[hr + 180 >> 2] = r ? e[hr + 132 >> 2] : ln & 255, e[hr + 176 >> 2] = r ? e[hr + 128 >> 2] : Tr, e[5996] = 0, di(29, hr + 248 | 0, hr + 176 | 0), r = e[5996], e[5996] = 0;
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              if ((r | 0) != 1) {
                                                                if (!e[hr + 180 >> 2])
                                                                  break w;
                                                                e[hr + 240 >> 2] = 0, e[hr + 244 >> 2] = 0, e[hr + 232 >> 2] = 0, e[hr + 236 >> 2] = 0, e[hr + 224 >> 2] = 0, e[hr + 228 >> 2] = 0, e[hr + 216 >> 2] = 0, e[hr + 220 >> 2] = 0, e[hr + 208 >> 2] = 0, e[hr + 212 >> 2] = 0, e[hr + 200 >> 2] = 0, e[hr + 204 >> 2] = 0, e[hr + 192 >> 2] = 0, e[hr + 196 >> 2] = 0;
                                                                break v;
                                                              }
                                                              if (Tr = mu(22528, 22864) | 0, r = uo, (r | 0) != (vl(22528) | 0))
                                                                break S;
                                                              if (yu(Tr | 0) | 0, e[hr + 240 >> 2] = 0, e[hr + 244 >> 2] = 0, e[hr + 232 >> 2] = 0, e[hr + 236 >> 2] = 0, e[hr + 224 >> 2] = 0, e[hr + 228 >> 2] = 0, e[hr + 216 >> 2] = 0, e[hr + 220 >> 2] = 0, e[hr + 208 >> 2] = 0, e[hr + 212 >> 2] = 0, e[hr + 200 >> 2] = 0, e[hr + 204 >> 2] = 0, e[hr + 192 >> 2] = 0, e[hr + 196 >> 2] = 0, e[5996] = 0, Ri(110), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                break T;
                                                              Tr = Ts(22864) | 0, r = uo;
                                                              break S;
                                                            }
                                                            r = e[hr + 260 >> 2], Tr = e[hr + 264 >> 2], e[hr + 260 >> 2] = 0, e[hr + 264 >> 2] = 0, e[hr + 204 >> 2] = r, e[hr + 208 >> 2] = Tr, r = e[hr + 268 >> 2], Tr = e[hr + 272 >> 2], e[hr + 268 >> 2] = 0, e[hr + 272 >> 2] = 0, e[hr + 212 >> 2] = r, e[hr + 216 >> 2] = Tr, e[hr + 228 >> 2] = e[hr + 284 >> 2], r = e[hr + 288 >> 2], e[hr + 284 >> 2] = 0, e[hr + 288 >> 2] = 0, e[hr + 192 >> 2] = e[hr + 248 >> 2], Tr = e[hr + 252 >> 2], ln = e[hr + 256 >> 2], e[hr + 252 >> 2] = 0, e[hr + 256 >> 2] = 0, e[hr + 196 >> 2] = Tr, e[hr + 200 >> 2] = ln, Tr = e[hr + 280 >> 2], e[hr + 220 >> 2] = e[hr + 276 >> 2], e[hr + 224 >> 2] = Tr, e[hr + 276 >> 2] = 0, e[hr + 280 >> 2] = 0, e[hr + 232 >> 2] = r, e[hr + 236 >> 2] = e[hr + 292 >> 2], e[hr + 292 >> 2] = 0, r = e[hr + 296 >> 2], e[hr + 296 >> 2] = 0, e[hr + 240 >> 2] = r, e[hr + 244 >> 2] = e[hr + 300 >> 2];
                                                          }
                                                          Ra(hr + 248 | 0);
                                                        }
                                                        if (!e[hr + 192 >> 2]) {
                                                          ln = 0;
                                                          break A;
                                                        }
                                                        e[hr + 184 >> 2] = 0, e[hr + 176 >> 2] = 0, e[hr + 180 >> 2] = 0, e[hr + 256 >> 2] = 0, e[hr + 260 >> 2] = 0, e[5996] = 0, e[hr + 248 >> 2] = 0, e[hr + 252 >> 2] = 0, e[hr + 264 >> 2] = 1065353216, Rn = Si(111, hr + 192 | 0, hr + 248 | 0, hr + 176 | 0) | 0, r = e[5996], e[5996] = 0;
                                                        T: {
                                                          if ((r | 0) != 1) {
                                                            if (Tr = e[hr + 256 >> 2], Tr)
                                                              for (; r = e[Tr >> 2], Sr(Tr), Tr = r, !!r; )
                                                                ;
                                                            r = e[hr + 248 >> 2], ln = 0, e[hr + 248 >> 2] = 0, r && Sr(r);
                                                            v: {
                                                              w: {
                                                                if (Rn) {
                                                                  if (e[hr + 252 >> 2] = 0, e[hr + 256 >> 2] = 0, e[5996] = 0, e[hr + 248 >> 2] = hr + 252, r = lc(50, Rn | 0, 1, 0, hr + 248 | 0) | 0, Tr = e[5996], e[5996] = 0, (Tr | 0) == 1)
                                                                    break w;
                                                                  e[5996] = 0, Tr = On(54, 1639, 3) | 0, ln = e[5996], e[5996] = 0;
                                                                  b: {
                                                                    h: {
                                                                      x: {
                                                                        m: {
                                                                          if ((ln | 0) == 1 || (ln = e[r >> 2], r = e[r + 4 >> 2], e[5996] = 0, eu(51, hr + 160 | 0, ln | 0, r | 0, Tr | 0, 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                                                                            break m;
                                                                          if (Tr = e[hr + 164 >> 2], ln = e[hr + 160 >> 2], Rn = Tr - ln | 0, (Rn | 0) != 32)
                                                                            break x;
                                                                          Tr = e[ln >> 2], Mn = e[ln + 4 >> 2], e[ln >> 2] = 0, e[ln + 4 >> 2] = 0, r = e[hr + 16 >> 2], e[hr + 12 >> 2] = Tr, e[hr + 16 >> 2] = Mn;
                                                                          B: {
                                                                            if (!r || (Tr = e[r + 4 >> 2], e[r + 4 >> 2] = Tr - 1, Tr))
                                                                              break B;
                                                                            _n[e[e[r >> 2] + 8 >> 2]](r), cs(r);
                                                                          }
                                                                          ln = e[hr + 160 >> 2], Ji = Fi[ln + 8 >> 3], Tr = e[hr + 164 >> 2];
                                                                          break h;
                                                                        }
                                                                        Tr = Ts(22864) | 0;
                                                                        break v;
                                                                      }
                                                                      if (!ln)
                                                                        break b;
                                                                    }
                                                                    if ((Tr | 0) != (ln | 0)) {
                                                                      for (; ; ) {
                                                                        Tr = Tr - 32 | 0, r = e[Tr + 4 >> 2];
                                                                        h: {
                                                                          if (!r || (Mn = e[r + 4 >> 2], e[r + 4 >> 2] = Mn - 1, Mn))
                                                                            break h;
                                                                          _n[e[e[r >> 2] + 8 >> 2]](r), cs(r);
                                                                        }
                                                                        if ((Tr | 0) == (ln | 0))
                                                                          break;
                                                                      }
                                                                      Tr = e[hr + 160 >> 2];
                                                                    }
                                                                    e[hr + 164 >> 2] = ln, Sr(Tr);
                                                                  }
                                                                  sl(e[hr + 252 >> 2]), ln = (Rn | 0) == 32;
                                                                }
                                                                if (r = e[hr + 176 >> 2], !r)
                                                                  break A;
                                                                if (Tr = e[hr + 180 >> 2], (r | 0) != (Tr | 0)) {
                                                                  for (; Tr = Tr - 4 | 0, ol(Tr), (r | 0) != (Tr | 0); )
                                                                    ;
                                                                  r = e[hr + 176 >> 2];
                                                                }
                                                                Sr(r);
                                                                break A;
                                                              }
                                                              Tr = Ts(22864) | 0;
                                                            }
                                                            r = uo, sl(e[hr + 252 >> 2]);
                                                            break T;
                                                          }
                                                          if (Tr = Ts(22864) | 0, r = uo, G = e[hr + 256 >> 2], G)
                                                            for (; ke = e[G >> 2], Sr(G), G = ke, !!G; )
                                                              ;
                                                          G = e[hr + 248 >> 2], e[hr + 248 >> 2] = 0, G && Sr(G);
                                                        }
                                                        if (G = e[hr + 176 >> 2], G) {
                                                          if (Fe = e[hr + 180 >> 2], ke = G, (Fe | 0) != (G | 0)) {
                                                            for (; Fe = Fe - 4 | 0, ol(Fe), (G | 0) != (Fe | 0); )
                                                              ;
                                                            ke = e[hr + 176 >> 2];
                                                          }
                                                          e[hr + 180 >> 2] = G, Sr(ke);
                                                        }
                                                        Ra(hr + 192 | 0);
                                                      }
                                                      if ($[hr + 139 | 0] >= 0)
                                                        break p;
                                                      Sr(e[hr + 128 >> 2]);
                                                      break p;
                                                    }
                                                    Tr = Ts(22864) | 0, r = uo;
                                                    break c;
                                                  }
                                                  Tr = Ts(22864) | 0, r = uo;
                                                  break g;
                                                }
                                                Tr = Ts(22864) | 0, r = uo;
                                              }
                                              if ($[hr + 123 | 0] >= 0)
                                                break g;
                                              Sr(e[hr + 112 >> 2]);
                                              break g;
                                            }
                                            Ra(hr + 192 | 0), $[hr + 139 | 0] < 0 && Sr(e[hr + 128 >> 2]), $[hr + 123 | 0] < 0 && Sr(e[hr + 112 >> 2]);
                                            A: {
                                              p: {
                                                I: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            if (!ln) {
                                                              e[5996] = 0, r = ii(3, 16) | 0, G = e[5996], e[5996] = 0;
                                                              w: {
                                                                b: {
                                                                  if ((G | 0) != 1) {
                                                                    if ($[r + 15 | 0] = 0, G = ye[2587] | ye[2588] << 8 | (ye[2589] << 16 | ye[2590] << 24), ke = ye[2583] | ye[2584] << 8 | (ye[2585] << 16 | ye[2586] << 24), $[r + 7 | 0] = ke, $[r + 8 | 0] = ke >>> 8, $[r + 9 | 0] = ke >>> 16, $[r + 10 | 0] = ke >>> 24, $[r + 11 | 0] = G, $[r + 12 | 0] = G >>> 8, $[r + 13 | 0] = G >>> 16, $[r + 14 | 0] = G >>> 24, G = ye[2580] | ye[2581] << 8 | (ye[2582] << 16 | ye[2583] << 24), ke = ye[2576] | ye[2577] << 8 | (ye[2578] << 16 | ye[2579] << 24), $[r | 0] = ke, $[r + 1 | 0] = ke >>> 8, $[r + 2 | 0] = ke >>> 16, $[r + 3 | 0] = ke >>> 24, $[r + 4 | 0] = G, $[r + 5 | 0] = G >>> 8, $[r + 6 | 0] = G >>> 16, $[r + 7 | 0] = G >>> 24, G = ((c | 0) >= 16 ? 16 : c) - 1 | 0, $[_s(o, r, G) + G | 0] = 0, Sr(r), e[5996] = 0, Ar = ii(3, 16) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                      break b;
                                                                    if ($[Ar + 15 | 0] = 0, G = ye[2587] | ye[2588] << 8 | (ye[2589] << 16 | ye[2590] << 24), ke = G, r = ye[2583] | ye[2584] << 8 | (ye[2585] << 16 | ye[2586] << 24), $[Ar + 7 | 0] = r, ln = r >>> 8 | 0, $[Ar + 8 | 0] = ln, Rn = r >>> 16 | 0, $[Ar + 9 | 0] = Rn, Mn = r >>> 24 | 0, $[Ar + 10 | 0] = Mn, $[Ar + 11 | 0] = G, $[Ar + 12 | 0] = G >>> 8, $[Ar + 13 | 0] = G >>> 16, $[Ar + 14 | 0] = G >>> 24, Fe = ye[2580] | ye[2581] << 8 | (ye[2582] << 16 | ye[2583] << 24), G = ye[2576] | ye[2577] << 8 | (ye[2578] << 16 | ye[2579] << 24), $[Ar | 0] = G, $[Ar + 1 | 0] = G >>> 8, $[Ar + 2 | 0] = G >>> 16, $[Ar + 3 | 0] = G >>> 24, $[Ar + 4 | 0] = Fe, $[Ar + 5 | 0] = Fe >>> 8, $[Ar + 6 | 0] = Fe >>> 16, $[Ar + 7 | 0] = Fe >>> 24, Tr = ((y | 0) >= 16 ? 16 : y) - 1 | 0, $[_s(h, Ar, Tr) + Tr | 0] = 0, Sr(Ar), e[5996] = 0, Ar = ii(3, 16) | 0, Tr = e[5996], e[5996] = 0, (Tr | 0) == 1)
                                                                      break w;
                                                                    $[Ar + 15 | 0] = 0, $[Ar + 7 | 0] = r, $[Ar + 8 | 0] = ln, $[Ar + 9 | 0] = Rn, $[Ar + 10 | 0] = Mn, r = ke, $[Ar + 11 | 0] = r, $[Ar + 12 | 0] = r >>> 8, $[Ar + 13 | 0] = r >>> 16, $[Ar + 14 | 0] = r >>> 24, $[Ar | 0] = G, $[Ar + 1 | 0] = G >>> 8, $[Ar + 2 | 0] = G >>> 16, $[Ar + 3 | 0] = G >>> 24, r = Fe, $[Ar + 4 | 0] = r, $[Ar + 5 | 0] = r >>> 8, $[Ar + 6 | 0] = r >>> 16, $[Ar + 7 | 0] = r >>> 24, r = ((S | 0) >= 16 ? 16 : S) - 1 | 0, $[_s(g, Ar, r) + r | 0] = 0, Sr(Ar);
                                                                    break v;
                                                                  }
                                                                  Tr = Ts(22864) | 0, r = uo;
                                                                  break g;
                                                                }
                                                                Tr = Ts(22864) | 0, r = uo;
                                                                break g;
                                                              }
                                                              Tr = Ts(22864) | 0, r = uo;
                                                              break g;
                                                            }
                                                            if (e[5996] = 0, r = e[hr + 12 >> 2], e[hr + 200 >> 2] = 0, e[hr + 192 >> 2] = 0, e[hr + 196 >> 2] = 0, Mn = ii(3, 12) | 0, Tr = e[5996], e[5996] = 0, (Tr | 0) == 1)
                                                              break A;
                                                            $[Mn + 8 | 0] = 0, e[Mn + 4 >> 2] = 0, e[Mn >> 2] = r, Tr = Mn + 12 | 0, Qi = Tr;
                                                            w: {
                                                              b: {
                                                                h: {
                                                                  for (; ; ) {
                                                                    x: {
                                                                      ci = Tr - 12 | 0, Rn = e[ci + 4 >> 2], r = e[ci >> 2], ln = e[r + 32 >> 2], gi = e[r + 36 >> 2] - ln >> 3;
                                                                      m: {
                                                                        if (gi >>> 0 > Rn >>> 0) {
                                                                          gi = 1, e[ci + 4 >> 2] = Rn + 1, r = e[r >> 2];
                                                                          B: {
                                                                            if (r - 10 >>> 0 < 7)
                                                                              break B;
                                                                            R:
                                                                              switch (r - 17 | 0) {
                                                                                case 0:
                                                                                  gi = e[e[ln + 8 >> 2] >> 2] == 1;
                                                                                  break B;
                                                                                case 5:
                                                                                  if (!e[e[ln >> 2] >> 2])
                                                                                    break B;
                                                                                  gi = !e[e[ln + 8 >> 2] >> 2];
                                                                                  break B;
                                                                                default:
                                                                                  break R;
                                                                              }
                                                                            gi = 0;
                                                                          }
                                                                          if (r = e[ln + (Rn << 3) >> 2], Tr >>> 0 < Qi >>> 0) {
                                                                            $[Tr + 8 | 0] = gi, e[Tr + 4 >> 2] = 0, e[Tr >> 2] = r, Tr = Tr + 12 | 0;
                                                                            break m;
                                                                          }
                                                                          B: {
                                                                            ci = (Tr - Mn | 0) / 12 | 0, ln = ci + 1 | 0;
                                                                            R: {
                                                                              if (ln >>> 0 >= 357913942) {
                                                                                e[5996] = 0, Ri(112);
                                                                                break R;
                                                                              }
                                                                              if (Rn = (Qi - Mn | 0) / 12 | 0, ei = Rn << 1, ln = Rn >>> 0 >= 178956970 ? 357913941 : ln >>> 0 < ei >>> 0 ? ei : ln, ln >>> 0 < 357913942)
                                                                                break B;
                                                                              e[5996] = 0, Ri(35);
                                                                            }
                                                                            if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                              break e;
                                                                            Tr = Ts(22864) | 0;
                                                                            break I;
                                                                          }
                                                                          if (e[5996] = 0, ei = vi(ln, 12), Rn = ii(3, ei | 0) | 0, ln = e[5996], e[5996] = 0, (ln | 0) == 1)
                                                                            break k;
                                                                          if (ln = Rn + vi(ci, 12) | 0, $[ln + 8 | 0] = gi, e[ln + 4 >> 2] = 0, e[ln >> 2] = r, r = ln, (Tr | 0) != (Mn | 0))
                                                                            for (; Tr = Tr - 12 | 0, ci = e[Tr + 4 >> 2], r = r - 12 | 0, e[r >> 2] = e[Tr >> 2], e[r + 4 >> 2] = ci, e[r + 8 >> 2] = e[Tr + 8 >> 2], (Tr | 0) != (Mn | 0); )
                                                                              ;
                                                                          Qi = Rn + ei | 0, Tr = ln + 12 | 0, Mn && Sr(Mn), Mn = r;
                                                                          break m;
                                                                        }
                                                                        if (ei = e[hr + 192 >> 2], ln = (e[hr + 196 >> 2] - ei | 0) / 12 | 0, ln >>> 0 < gi >>> 0) {
                                                                          if (e[5996] = 0, Qs(44, 5135, 2210, 439, 2439), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                            break e;
                                                                          Tr = Ts(22864) | 0;
                                                                          break I;
                                                                        }
                                                                        Tr = ye[Tr - 4 | 0], e[5996] = 0, eu(113, hr + 248 | 0, Tr | 0, r | 0, (vi(ln, 12) + ei | 0) + vi(gi, -12) | 0, gi | 0), Tr = e[5996], e[5996] = 0;
                                                                        B: {
                                                                          if ((Tr | 0) != 1) {
                                                                            if (ye[hr + 260 | 0])
                                                                              break B;
                                                                            gi = 0;
                                                                            break w;
                                                                          }
                                                                          Tr = Ts(22864) | 0;
                                                                          break I;
                                                                        }
                                                                        ln = e[hr + 196 >> 2], Tr = e[r + 36 >> 2] - e[r + 32 >> 2] >> 3, r = e[hr + 192 >> 2], Rn = ((ln + vi(Tr, -12) | 0) - r | 0) / 12 | 0;
                                                                        B: {
                                                                          if (!vi(Tr, -12)) {
                                                                            Tr = ln;
                                                                            break B;
                                                                          }
                                                                          if (Rn = r + vi(Rn, 12) | 0, r = Rn, Tr = r + vi((vi(Tr, 12) | 0) / 12 | 0, 12) | 0, (ln | 0) != (Tr | 0)) {
                                                                            for (; $[r + 11 | 0] < 0 && Sr(e[r >> 2]), ei = e[Tr + 4 >> 2], e[r >> 2] = e[Tr >> 2], e[r + 4 >> 2] = ei, e[r + 8 >> 2] = e[Tr + 8 >> 2], $[Tr + 11 | 0] = 0, $[Tr | 0] = 0, r = r + 12 | 0, Tr = Tr + 12 | 0, (ln | 0) != (Tr | 0); )
                                                                              ;
                                                                            ln = e[hr + 196 >> 2];
                                                                          }
                                                                          if (Tr = Rn + vi((r - Rn | 0) / 12 | 0, 12) | 0, (ln | 0) != (Tr | 0))
                                                                            for (; r = ln - 12 | 0, $[ln - 1 | 0] < 0 && Sr(e[r >> 2]), ln = r, (r | 0) != (Tr | 0); )
                                                                              ;
                                                                          e[hr + 196 >> 2] = Tr;
                                                                        }
                                                                        Rn = e[hr + 200 >> 2];
                                                                        B: {
                                                                          if (Rn >>> 0 > Tr >>> 0) {
                                                                            r = e[hr + 252 >> 2], e[Tr >> 2] = e[hr + 248 >> 2], e[Tr + 4 >> 2] = r, e[Tr + 8 >> 2] = e[hr + 256 >> 2], e[hr + 256 >> 2] = 0, e[hr + 248 >> 2] = 0, e[hr + 252 >> 2] = 0, e[hr + 196 >> 2] = Tr + 12;
                                                                            break B;
                                                                          }
                                                                          R: {
                                                                            E: {
                                                                              ln = e[hr + 192 >> 2], gi = (Tr - ln | 0) / 12 | 0, r = gi + 1 | 0;
                                                                              C: {
                                                                                if (r >>> 0 >= 357913942) {
                                                                                  e[5996] = 0, Ri(41);
                                                                                  break C;
                                                                                }
                                                                                if (Rn = (Rn - ln | 0) / 12 | 0, ei = Rn << 1, ei = Rn >>> 0 >= 178956970 ? 357913941 : r >>> 0 < ei >>> 0 ? ei : r, !ei) {
                                                                                  Rn = 0;
                                                                                  break R;
                                                                                }
                                                                                if (ei >>> 0 < 357913942)
                                                                                  break E;
                                                                                e[5996] = 0, Ri(35);
                                                                              }
                                                                              if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                break e;
                                                                              Tr = Ts(22864) | 0;
                                                                              break h;
                                                                            }
                                                                            if (e[5996] = 0, Rn = ii(3, vi(ei, 12) | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                              break x;
                                                                          }
                                                                          r = vi(gi, 12) + Rn | 0, gi = e[hr + 252 >> 2], e[r >> 2] = e[hr + 248 >> 2], e[r + 4 >> 2] = gi, e[r + 8 >> 2] = e[hr + 256 >> 2], e[hr + 256 >> 2] = 0, e[hr + 248 >> 2] = 0, e[hr + 252 >> 2] = 0, Rn = vi(ei, 12) + Rn | 0, ei = r + 12 | 0;
                                                                          R: {
                                                                            if ((Tr | 0) == (ln | 0)) {
                                                                              e[hr + 200 >> 2] = Rn, e[hr + 196 >> 2] = ei, e[hr + 192 >> 2] = r;
                                                                              break R;
                                                                            }
                                                                            for (; Tr = Tr - 12 | 0, gi = e[Tr + 4 >> 2], r = r - 12 | 0, e[r >> 2] = e[Tr >> 2], e[r + 4 >> 2] = gi, e[r + 8 >> 2] = e[Tr + 8 >> 2], e[Tr >> 2] = 0, e[Tr + 4 >> 2] = 0, e[Tr + 8 >> 2] = 0, (Tr | 0) != (ln | 0); )
                                                                              ;
                                                                            if (e[hr + 200 >> 2] = Rn, ln = e[hr + 196 >> 2], e[hr + 196 >> 2] = ei, Tr = e[hr + 192 >> 2], e[hr + 192 >> 2] = r, (Tr | 0) == (ln | 0))
                                                                              break R;
                                                                            for (; r = ln - 12 | 0, $[ln - 1 | 0] < 0 && Sr(e[r >> 2]), ln = r, (r | 0) != (Tr | 0); )
                                                                              ;
                                                                          }
                                                                          if (!Tr)
                                                                            break B;
                                                                          Sr(Tr);
                                                                        }
                                                                        !ye[hr + 260 | 0] | $[hr + 259 | 0] >= 0 || Sr(e[hr + 248 >> 2]), Tr = ci;
                                                                      }
                                                                      if ((Tr | 0) != (Mn | 0))
                                                                        continue;
                                                                      break b;
                                                                    }
                                                                    break;
                                                                  }
                                                                  Tr = Ts(22864) | 0;
                                                                }
                                                                if (r = uo, !ye[hr + 260 | 0] | $[hr + 259 | 0] >= 0)
                                                                  break p;
                                                                Sr(e[hr + 248 >> 2]);
                                                                break p;
                                                              }
                                                              if (r = e[hr + 192 >> 2], (e[hr + 196 >> 2] - r | 0) != 12) {
                                                                if (e[5996] = 0, Qs(44, 4102, 2210, 450, 2439), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                  break e;
                                                                Tr = Ts(22864) | 0;
                                                                break I;
                                                              }
                                                              gi = e[r >> 2], e[hr + 160 >> 2] = e[r + 4 >> 2], Tr = ye[r + 7 | 0] | ye[r + 8 | 0] << 8 | (ye[r + 9 | 0] << 16 | ye[r + 10 | 0] << 24), $[hr + 163 | 0] = Tr, $[hr + 164 | 0] = Tr >>> 8, $[hr + 165 | 0] = Tr >>> 16, $[hr + 166 | 0] = Tr >>> 24, e[r >> 2] = 0, e[r + 4 >> 2] = 0, ei = ye[r + 11 | 0], e[r + 8 >> 2] = 0;
                                                            }
                                                            if (ln = e[hr + 192 >> 2], ln) {
                                                              if (r = e[hr + 196 >> 2], Tr = ln, (r | 0) != (Tr | 0)) {
                                                                for (; Tr = r - 12 | 0, $[r - 1 | 0] < 0 && Sr(e[Tr >> 2]), r = Tr, (ln | 0) != (r | 0); )
                                                                  ;
                                                                Tr = e[hr + 192 >> 2];
                                                              }
                                                              e[hr + 196 >> 2] = ln, Sr(Tr);
                                                            }
                                                            Mn && Sr(Mn), r = ye[hr + 163 | 0] | ye[hr + 164 | 0] << 8 | (ye[hr + 165 | 0] << 16 | ye[hr + 166 | 0] << 24), $[hr + 103 | 0] = r, $[hr + 104 | 0] = r >>> 8, $[hr + 105 | 0] = r >>> 16, $[hr + 106 | 0] = r >>> 24, e[hr + 100 >> 2] = e[hr + 160 >> 2], e[hr + 96 >> 2] = gi, e[hr + 160 >> 2] = 0, $[hr + 163 | 0] = 0, $[hr + 164 | 0] = 0, $[hr + 165 | 0] = 0, $[hr + 166 | 0] = 0, $[hr + 107 | 0] = ei;
                                                            w: {
                                                              b: {
                                                                h: {
                                                                  x: {
                                                                    m: {
                                                                      B: {
                                                                        R: {
                                                                          E: {
                                                                            C: {
                                                                              y: {
                                                                                D: {
                                                                                  P: {
                                                                                    q: {
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    K: {
                                                                                                      W: {
                                                                                                        Mn = e[hr + 100 >> 2], r = ei << 24 >> 24 < 0, Tr = r ? Mn : ei & 255;
                                                                                                        G: {
                                                                                                          if ((Tr | 0) < 72)
                                                                                                            break G;
                                                                                                          for (Rn = r ? gi : hr + 96 | 0, ln = Rn + Tr | 0; ; ) {
                                                                                                            for (r = Rn; ; ) {
                                                                                                              if (r = nu(r, 115, Tr - 71 | 0), !r)
                                                                                                                break G;
                                                                                                              if (pa(r, 5034, 72)) {
                                                                                                                if (r = r + 1 | 0, Tr = ln - r | 0, (Tr | 0) >= 72)
                                                                                                                  continue;
                                                                                                                break G;
                                                                                                              }
                                                                                                              break;
                                                                                                            }
                                                                                                            if ((r | 0) == (ln | 0) || (r = r - Rn | 0, (r | 0) == -1))
                                                                                                              break G;
                                                                                                            if (e[5996] = 0, Tr = hr + 96 | 0, Qs(114, Tr | 0, r | 0, 72, 4824), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                              break W;
                                                                                                            if (gi = e[hr + 96 >> 2], ln = Tr, r = ye[hr + 107 | 0], ei = r << 24 >> 24, Tr = (ei | 0) < 0, Rn = Tr ? gi : ln, Mn = e[hr + 100 >> 2], Tr = Tr ? Mn : r, ln = Rn + Tr | 0, !((Tr | 0) > 71))
                                                                                                              break;
                                                                                                          }
                                                                                                        }
                                                                                                        G: {
                                                                                                          r = ei << 24 >> 24, Tr = (r | 0) < 0 ? Mn : ei & 255;
                                                                                                          V: {
                                                                                                            if ((Tr | 0) < 73)
                                                                                                              break V;
                                                                                                            for (Rn = (r | 0) < 0 ? gi : hr + 96 | 0, ln = Rn + Tr | 0; ; ) {
                                                                                                              for (r = Rn; ; ) {
                                                                                                                if (r = nu(r, 104, Tr - 72 | 0), !r)
                                                                                                                  break V;
                                                                                                                if (pa(r, 4960, 73)) {
                                                                                                                  if (r = r + 1 | 0, Tr = ln - r | 0, (Tr | 0) >= 73)
                                                                                                                    continue;
                                                                                                                  break V;
                                                                                                                }
                                                                                                                break;
                                                                                                              }
                                                                                                              if ((r | 0) == (ln | 0) || (r = r - Rn | 0, (r | 0) == -1))
                                                                                                                break V;
                                                                                                              if (e[5996] = 0, Tr = hr + 96 | 0, Qs(114, Tr | 0, r | 0, 73, 4813), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                break G;
                                                                                                              if (gi = e[hr + 96 >> 2], ln = Tr, r = ye[hr + 107 | 0], ei = r << 24 >> 24, Tr = (ei | 0) < 0, Rn = Tr ? gi : ln, Mn = e[hr + 100 >> 2], Tr = Tr ? Mn : r, ln = Rn + Tr | 0, !((Tr | 0) > 72))
                                                                                                                break;
                                                                                                            }
                                                                                                          }
                                                                                                          V: {
                                                                                                            r = ei << 24 >> 24 < 0, Tr = r ? Mn : ei & 255;
                                                                                                            z: {
                                                                                                              if ((Tr | 0) < 51)
                                                                                                                break z;
                                                                                                              for (Rn = r ? gi : hr + 96 | 0, ln = Rn + Tr | 0; ; ) {
                                                                                                                for (r = Rn; ; ) {
                                                                                                                  if (r = nu(r, 114, Tr - 50 | 0), !r)
                                                                                                                    break z;
                                                                                                                  if (pa(r, 4908, 51)) {
                                                                                                                    if (r = r + 1 | 0, Tr = ln - r | 0, (Tr | 0) >= 51)
                                                                                                                      continue;
                                                                                                                    break z;
                                                                                                                  }
                                                                                                                  break;
                                                                                                                }
                                                                                                                if ((r | 0) == (ln | 0) || (r = r - Rn | 0, (r | 0) == -1))
                                                                                                                  break z;
                                                                                                                if (e[5996] = 0, Tr = hr + 96 | 0, Qs(114, Tr | 0, r | 0, 51, 4845), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                  break V;
                                                                                                                if (gi = e[hr + 96 >> 2], ln = Tr, r = ye[hr + 107 | 0], ei = r << 24 >> 24, Tr = (ei | 0) < 0, Rn = Tr ? gi : ln, Mn = e[hr + 100 >> 2], Tr = Tr ? Mn : r, ln = Rn + Tr | 0, !((Tr | 0) > 50))
                                                                                                                  break;
                                                                                                              }
                                                                                                            }
                                                                                                            z: {
                                                                                                              r = ei << 24 >> 24, Tr = (r | 0) < 0 ? Mn : ei & 255;
                                                                                                              j: {
                                                                                                                if ((Tr | 0) < 49)
                                                                                                                  break j;
                                                                                                                for (Mn = (r | 0) < 0 ? gi : hr + 96 | 0, ln = Mn + Tr | 0; ; ) {
                                                                                                                  for (r = Mn; ; ) {
                                                                                                                    if (r = nu(r, 104, Tr - 48 | 0), !r)
                                                                                                                      break j;
                                                                                                                    if (pa(r, 4858, 49)) {
                                                                                                                      if (r = r + 1 | 0, Tr = ln - r | 0, (Tr | 0) >= 49)
                                                                                                                        continue;
                                                                                                                      break j;
                                                                                                                    }
                                                                                                                    break;
                                                                                                                  }
                                                                                                                  if ((r | 0) == (ln | 0) || (r = r - Mn | 0, (r | 0) == -1))
                                                                                                                    break j;
                                                                                                                  if (e[5996] = 0, Tr = hr + 96 | 0, Qs(114, Tr | 0, r | 0, 49, 4834), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                    break z;
                                                                                                                  if (ln = Tr, r = ye[hr + 107 | 0], Tr = r << 24 >> 24 < 0, Mn = Tr ? e[hr + 96 >> 2] : ln, Tr = Tr ? e[hr + 100 >> 2] : r, ln = Mn + Tr | 0, !((Tr | 0) > 48))
                                                                                                                    break;
                                                                                                                }
                                                                                                              }
                                                                                                              e[hr + 184 >> 2] = e[hr + 104 >> 2], e[hr + 104 >> 2] = 0, Tr = e[hr + 100 >> 2], r = e[hr + 96 >> 2], e[hr + 176 >> 2] = r, e[hr + 180 >> 2] = Tr, e[hr + 96 >> 2] = 0, e[hr + 100 >> 2] = 0, Tr = ye[hr + 187 | 0], ln = Tr << 24 >> 24, Rn = (ln | 0) < 0, Mn = Rn ? r : hr + 176 | 0, Tr = Rn ? e[hr + 180 >> 2] : Tr, Rn = c - 1 | 0, Tr = (Tr | 0) < (Rn | 0) ? Tr : Rn, $[_s(o, Mn, Tr) + Tr | 0] = 0;
                                                                                                              j: {
                                                                                                                if ((ln | 0) >= 0 || (Sr(r), $[hr + 107 | 0] >= 0))
                                                                                                                  break j;
                                                                                                                Sr(e[hr + 96 >> 2]);
                                                                                                              }
                                                                                                              if (r = e[e[hr + 12 >> 2] + 84 >> 2], e[5996] = 0, Tr = hr + 36 | 0, di(115, Tr | 0, r | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                break H;
                                                                                                              if (e[5996] = 0, r = Si(99, Tr | 0, 0, 5442) | 0, Tr = e[5996], e[5996] = 0, (Tr | 0) == 1)
                                                                                                                break L;
                                                                                                              if (e[hr + 56 >> 2] = e[r + 8 >> 2], Tr = e[r + 4 >> 2], e[hr + 48 >> 2] = e[r >> 2], e[hr + 52 >> 2] = Tr, e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[5996] = 0, Tr = On(97, hr + 48 | 0, 5422) | 0, ln = e[5996], e[5996] = 0, (ln | 0) == 1)
                                                                                                                break M;
                                                                                                              if (e[hr + 72 >> 2] = e[Tr + 8 >> 2], ln = e[Tr + 4 >> 2], e[hr + 64 >> 2] = e[Tr >> 2], e[hr + 68 >> 2] = ln, e[Tr >> 2] = 0, e[Tr + 4 >> 2] = 0, e[Tr + 8 >> 2] = 0, e[5996] = 0, ln = hr + 248 | 0, Kd(116, ln | 0, +Ji), Rn = e[5996], e[5996] = 0, (Rn | 0) == 1)
                                                                                                                break F;
                                                                                                              if (e[5996] = 0, Mn = ln, ln = ye[hr + 259 | 0], Rn = ln << 24 >> 24 < 0, ln = Si(100, hr - -64 | 0, (Rn ? e[hr + 248 >> 2] : Mn) | 0, (Rn ? e[hr + 252 >> 2] : ln) | 0) | 0, Rn = e[5996], e[5996] = 0, (Rn | 0) == 1)
                                                                                                                break U;
                                                                                                              if (e[hr + 88 >> 2] = e[ln + 8 >> 2], Rn = e[ln + 4 >> 2], e[hr + 80 >> 2] = e[ln >> 2], e[hr + 84 >> 2] = Rn, e[ln >> 2] = 0, e[ln + 4 >> 2] = 0, e[ln + 8 >> 2] = 0, e[5996] = 0, Rn = On(97, hr + 80 | 0, 5504) | 0, Mn = e[5996], e[5996] = 0, (Mn | 0) == 1)
                                                                                                                break Q;
                                                                                                              if (e[hr + 136 >> 2] = e[Rn + 8 >> 2], Mn = e[Rn + 4 >> 2], e[hr + 128 >> 2] = e[Rn >> 2], e[hr + 132 >> 2] = Mn, e[Rn >> 2] = 0, e[Rn + 4 >> 2] = 0, e[Rn + 8 >> 2] = 0, Mn = e[e[hr + 12 >> 2] + 84 >> 2], e[5996] = 0, ci = hr + 192 | 0, Kd(116, ci | 0, +(Ji + +(Mn >>> 0))), Mn = e[5996], e[5996] = 0, (Mn | 0) == 1)
                                                                                                                break O;
                                                                                                              if (e[5996] = 0, Qi = ci, Mn = ye[hr + 203 | 0], ci = Mn << 24 >> 24 < 0, Mn = Si(100, hr + 128 | 0, (ci ? e[hr + 192 >> 2] : Qi) | 0, (ci ? e[hr + 196 >> 2] : Mn) | 0) | 0, ci = e[5996], e[5996] = 0, (ci | 0) == 1)
                                                                                                                break q;
                                                                                                              if (e[hr + 168 >> 2] = e[Mn + 8 >> 2], ci = e[Mn + 4 >> 2], e[hr + 160 >> 2] = e[Mn >> 2], e[hr + 164 >> 2] = ci, e[Mn >> 2] = 0, e[Mn + 4 >> 2] = 0, e[Mn + 8 >> 2] = 0, e[5996] = 0, ci = On(97, hr + 160 | 0, 3567) | 0, ei = e[5996], e[5996] = 0, (ei | 0) == 1)
                                                                                                                break P;
                                                                                                              if (e[hr + 184 >> 2] = e[ci + 8 >> 2], ei = e[ci + 4 >> 2], e[hr + 176 >> 2] = e[ci >> 2], e[hr + 180 >> 2] = ei, e[ci >> 2] = 0, e[ci + 4 >> 2] = 0, e[ci + 8 >> 2] = 0, $[hr + 203 | 0] < 0 && Sr(e[hr + 192 >> 2]), $[Mn + 11 | 0] < 0 && Sr(e[Mn >> 2]), $[Rn + 11 | 0] < 0 && Sr(e[Rn >> 2]), $[hr + 259 | 0] < 0 && Sr(e[hr + 248 >> 2]), $[ln + 11 | 0] < 0 && Sr(e[ln >> 2]), $[Tr + 11 | 0] < 0 && Sr(e[Tr >> 2]), $[r + 11 | 0] < 0 && Sr(e[r >> 2]), ln = e[hr + 176 >> 2], r = ye[hr + 187 | 0], Rn = r << 24 >> 24, Tr = (Rn | 0) < 0, Mn = Tr ? ln : hr + 176 | 0, r = Tr ? e[hr + 180 >> 2] : r, Tr = y - 1 | 0, r = (r | 0) < (Tr | 0) ? r : Tr, $[_s(h, Mn, r) + r | 0] = 0, e[5996] = 0, Tr = hr + 248 | 0, di(117, Tr | 0, e[hr + 12 >> 2]), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                break x;
                                                                                                              if (e[hr + 220 >> 2] = e[hr + 276 >> 2], r = e[hr + 272 >> 2], e[hr + 212 >> 2] = e[hr + 268 >> 2], e[hr + 216 >> 2] = r, r = e[hr + 264 >> 2], e[hr + 204 >> 2] = e[hr + 260 >> 2], e[hr + 208 >> 2] = r, r = e[hr + 256 >> 2], e[hr + 196 >> 2] = e[hr + 252 >> 2], e[hr + 200 >> 2] = r, r = e[hr + 248 >> 2], e[hr + 192 >> 2] = r, e[5996] = 0, Mn = r >>> 0 < 29, ci = Mn ? hr + 196 | 0 : e[hr + 200 >> 2], e[hr + 248 >> 2] = ci, ei = hr + 24 | 0, Qs(102, ei | 0, Tr | 0, ci + (Mn ? r : r - 29 | 0) | 0, 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                break h;
                                                                                                              if (r = e[hr + 24 >> 2], Tr = ye[hr + 35 | 0], Mn = Tr << 24 >> 24, ci = (Mn | 0) < 0, Qi = ci ? r : ei, Tr = ci ? e[hr + 28 >> 2] : Tr, ci = S - 1 | 0, Tr = (Tr | 0) < (ci | 0) ? Tr : ci, $[_s(g, Qi, Tr) + Tr | 0] = 0, (Mn | 0) < 0 && Sr(r), Ps[hr + 192 >> 2] >= 29 && Sr(e[hr + 200 >> 2]), r = e[hr + 12 >> 2], Tr = e[r + 80 >> 2], !Tr | Ps[r + 84 >> 2] > 3600 | (e[r + 52 >> 2] + e[r + 44 >> 2] >>> 0 > 201 | Ps[r + 68 >> 2] > 100))
                                                                                                                break b;
                                                                                                              if (e[5996] = 0, Mn = On(54, 2049, 1) | 0, ci = e[5996], e[5996] = 0, (ci | 0) == 1)
                                                                                                                break T;
                                                                                                              if ((Tr ^ -1) & Mn)
                                                                                                                break b;
                                                                                                              if (Tr = e[r + 80 >> 2], e[5996] = 0, Mn = On(54, 2165, 1) | 0, ci = e[5996], e[5996] = 0, (ci | 0) == 1)
                                                                                                                break T;
                                                                                                              if (ye[r + 88 | 0] | (Tr ^ -1) & Mn)
                                                                                                                break b;
                                                                                                              $[hr + 252 | 0] = 0, e[hr + 248 >> 2] = 1702195828, $[hr + 259 | 0] = 4, r = ((Ar | 0) >= 5 ? 5 : Ar) - 1 | 0, $[_s(Fe, hr + 248 | 0, r) + r | 0] = 0;
                                                                                                              break w;
                                                                                                            }
                                                                                                            Tr = Ts(22864) | 0;
                                                                                                            break K;
                                                                                                          }
                                                                                                          Tr = Ts(22864) | 0;
                                                                                                          break K;
                                                                                                        }
                                                                                                        Tr = Ts(22864) | 0;
                                                                                                        break K;
                                                                                                      }
                                                                                                      Tr = Ts(22864) | 0;
                                                                                                    }
                                                                                                    if (r = uo, $[hr + 107 | 0] >= 0)
                                                                                                      break g;
                                                                                                    Sr(e[hr + 96 >> 2]);
                                                                                                    break g;
                                                                                                  }
                                                                                                  Tr = Ts(22864) | 0, r = uo;
                                                                                                  break g;
                                                                                                }
                                                                                                Tr = Ts(22864) | 0, r = uo;
                                                                                                break m;
                                                                                              }
                                                                                              Tr = Ts(22864) | 0, r = uo;
                                                                                              break B;
                                                                                            }
                                                                                            Tr = Ts(22864) | 0, r = uo;
                                                                                            break R;
                                                                                          }
                                                                                          Tr = Ts(22864) | 0, r = uo;
                                                                                          break E;
                                                                                        }
                                                                                        Tr = Ts(22864) | 0, r = uo;
                                                                                        break C;
                                                                                      }
                                                                                      Tr = Ts(22864) | 0, r = uo;
                                                                                      break y;
                                                                                    }
                                                                                    Tr = Ts(22864) | 0, r = uo;
                                                                                    break D;
                                                                                  }
                                                                                  if (Tr = Ts(22864) | 0, r = uo, $[hr + 171 | 0] >= 0)
                                                                                    break D;
                                                                                  Sr(e[hr + 160 >> 2]);
                                                                                }
                                                                                if ($[hr + 203 | 0] >= 0)
                                                                                  break y;
                                                                                Sr(e[hr + 192 >> 2]);
                                                                              }
                                                                              if ($[hr + 139 | 0] >= 0)
                                                                                break C;
                                                                              Sr(e[hr + 128 >> 2]);
                                                                            }
                                                                            if ($[hr + 91 | 0] >= 0)
                                                                              break E;
                                                                            Sr(e[hr + 80 >> 2]);
                                                                          }
                                                                          if ($[hr + 259 | 0] >= 0)
                                                                            break R;
                                                                          Sr(e[hr + 248 >> 2]);
                                                                        }
                                                                        if ($[hr + 75 | 0] >= 0)
                                                                          break B;
                                                                        Sr(e[hr + 64 >> 2]);
                                                                      }
                                                                      if ($[hr + 59 | 0] >= 0)
                                                                        break m;
                                                                      Sr(e[hr + 48 >> 2]);
                                                                    }
                                                                    if ($[hr + 47 | 0] >= 0)
                                                                      break g;
                                                                    Sr(e[hr + 36 >> 2]);
                                                                    break g;
                                                                  }
                                                                  Tr = Ts(22864) | 0;
                                                                  break S;
                                                                }
                                                                if (Tr = Ts(22864) | 0, r = uo, Ps[hr + 192 >> 2] < 29)
                                                                  break N;
                                                                Sr(e[hr + 200 >> 2]);
                                                                break N;
                                                              }
                                                              $[hr + 252 | 0] = ye[2354], $[hr + 259 | 0] = 5, $[hr + 253 | 0] = 0, e[hr + 248 >> 2] = ye[2350] | ye[2351] << 8 | (ye[2352] << 16 | ye[2353] << 24), r = ((Ar | 0) >= 6 ? 6 : Ar) - 1 | 0, $[_s(Fe, hr + 248 | 0, r) + r | 0] = 0;
                                                            }
                                                            if (e[5996] = 0, r = ii(118, e[hr + 12 >> 2]) | 0, Fe = e[5996], e[5996] = 0, (Fe | 0) == 1)
                                                              break T;
                                                            w: {
                                                              if (r) {
                                                                $[hr + 252 | 0] = 0, e[hr + 248 >> 2] = 1702195828, $[hr + 259 | 0] = 4, r = ((ke | 0) >= 5 ? 5 : ke) - 1 | 0, $[_s(G, hr + 248 | 0, r) + r | 0] = 0;
                                                                break w;
                                                              }
                                                              $[hr + 252 | 0] = ye[2354], $[hr + 259 | 0] = 5, $[hr + 253 | 0] = 0, e[hr + 248 >> 2] = ye[2350] | ye[2351] << 8 | (ye[2352] << 16 | ye[2353] << 24), r = ((ke | 0) >= 6 ? 6 : ke) - 1 | 0, $[_s(G, hr + 248 | 0, r) + r | 0] = 0;
                                                            }
                                                            if ((Rn | 0) >= 0)
                                                              break v;
                                                            Sr(ln);
                                                          }
                                                          r = e[hr + 16 >> 2];
                                                          v: {
                                                            if (!r || (o = e[r + 4 >> 2], e[r + 4 >> 2] = o - 1, o))
                                                              break v;
                                                            _n[e[e[r >> 2] + 8 >> 2]](r), cs(r);
                                                          }
                                                          if ($[hr + 155 | 0] >= 0)
                                                            break d;
                                                          Sr(e[hr + 144 >> 2]);
                                                          break d;
                                                        }
                                                        Tr = Ts(22864) | 0;
                                                      }
                                                      r = uo;
                                                    }
                                                    if ((Rn | 0) >= 0)
                                                      break g;
                                                    Sr(ln);
                                                    break g;
                                                  }
                                                  Tr = Ts(22864) | 0;
                                                }
                                                r = uo;
                                              }
                                              if (Wo(hr + 192 | 0), !Mn)
                                                break g;
                                              Sr(Mn);
                                              break g;
                                            }
                                            Tr = Ts(22864) | 0, r = uo, Wo(hr + 192 | 0);
                                          }
                                          No(hr + 12 | 0);
                                        }
                                        if ($[hr + 155 | 0] >= 0)
                                          break c;
                                        Sr(e[hr + 144 >> 2]);
                                      }
                                      if ((vl(22864) | 0) != (r | 0))
                                        break r;
                                      if (r = yu(Tr | 0) | 0, r = _n[e[e[r >> 2] + 8 >> 2]](r) | 0, e[5996] = 0, ke = On(30, hr + 24 | 0, r | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                        break f;
                                      if (e[5996] = 0, r = Si(99, ke | 0, 0, 5474) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                        break l;
                                      if (e[hr + 152 >> 2] = e[r + 8 >> 2], G = e[r + 4 >> 2], e[hr + 144 >> 2] = e[r >> 2], e[hr + 148 >> 2] = G, e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[5996] = 0, G = On(97, hr + 144 | 0, 2611) | 0, Fe = e[5996], e[5996] = 0, (Fe | 0) == 1)
                                        break o;
                                      e[hr + 184 >> 2] = e[G + 8 >> 2], ke = e[G + 4 >> 2], e[hr + 176 >> 2] = e[G >> 2], e[hr + 180 >> 2] = ke, e[G >> 2] = 0, e[G + 4 >> 2] = 0, e[G + 8 >> 2] = 0, Tr = o, o = e[hr + 176 >> 2], ke = ye[hr + 187 | 0], Fe = ke << 24 >> 24, Ar = (Fe | 0) < 0, ke = Ar ? e[hr + 180 >> 2] : ke, c = c - 1 | 0, c = (c | 0) > (ke | 0) ? ke : c, $[_s(Tr, Ar ? o : hr + 176 | 0, c) + c | 0] = 0;
                                      c: {
                                        if ((Fe | 0) >= 0 || (Sr(o), $[G + 11 | 0] >= 0))
                                          break c;
                                        Sr(e[G >> 2]);
                                      }
                                      if ($[r + 11 | 0] < 0 && Sr(e[r >> 2]), e[5996] = 0, r = On(30, hr + 176 | 0, 5575) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                        break s;
                                      if (ke = h, o = e[r >> 2], c = ye[r + 11 | 0], h = c << 24 >> 24, G = (h | 0) < 0, Fe = G ? o : r, r = G ? e[r + 4 >> 2] : c, c = y - 1 | 0, r = (r | 0) < (c | 0) ? r : c, $[_s(ke, Fe, r) + r | 0] = 0, (h | 0) < 0 && Sr(o), e[5996] = 0, r = On(30, hr + 12 | 0, 5575) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                        break i;
                                      o = e[r >> 2], c = ye[r + 11 | 0], h = c << 24 >> 24, y = (h | 0) < 0, G = y ? o : r, r = y ? e[r + 4 >> 2] : c, c = S - 1 | 0, r = (r | 0) < (c | 0) ? r : c, $[_s(g, G, r) + r | 0] = 0, (h | 0) < 0 && Sr(o), Wu();
                                    }
                                    Yr = hr + 304 | 0;
                                    return;
                                  }
                                  Tr = Vr() | 0;
                                  break n;
                                }
                                Tr = Vr() | 0;
                                break a;
                              }
                              if (Tr = Vr() | 0, $[hr + 155 | 0] >= 0)
                                break a;
                              Sr(e[hr + 144 >> 2]);
                            }
                            if ($[ke + 11 | 0] >= 0)
                              break n;
                            Sr(e[ke >> 2]);
                            break n;
                          }
                          Tr = Vr() | 0;
                          break n;
                        }
                        Tr = Vr() | 0;
                      }
                      if (e[5996] = 0, Ri(110), r = e[5996], e[5996] = 0, (r | 0) == 1)
                        break t;
                    }
                    Ki(Tr | 0), ri();
                  }
                  Ts(0) | 0, va(), ri();
                }
                ri();
              }
              function Rl(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0, Qi = 0, Ji = 0, ss = 0;
                g = Yr - 144 | 0, Yr = g, hr = Fi[o + 24 >> 3], Tr = Fi[o + 16 >> 3];
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  f: {
                                    d: {
                                      c: {
                                        u: {
                                          g: {
                                            A: {
                                              p: {
                                                I: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              b: {
                                                                h: {
                                                                  x: {
                                                                    m: {
                                                                      B:
                                                                        switch (y = e[r >> 2], y | 0) {
                                                                          case 9:
                                                                            break f;
                                                                          case 8:
                                                                            break d;
                                                                          case 2:
                                                                            break c;
                                                                          case 3:
                                                                            break u;
                                                                          case 14:
                                                                            break g;
                                                                          case 15:
                                                                            break A;
                                                                          case 16:
                                                                            break p;
                                                                          case 19:
                                                                            break I;
                                                                          case 18:
                                                                            break k;
                                                                          case 17:
                                                                            break N;
                                                                          case 10:
                                                                            break S;
                                                                          case 11:
                                                                            break T;
                                                                          case 12:
                                                                            break v;
                                                                          case 13:
                                                                            break w;
                                                                          case 0:
                                                                            break b;
                                                                          case 4:
                                                                          case 5:
                                                                            break h;
                                                                          case 1:
                                                                            break x;
                                                                          case 21:
                                                                            break m;
                                                                          case 20:
                                                                            break B;
                                                                          case 6:
                                                                            break o;
                                                                          case 7:
                                                                            break l;
                                                                          default:
                                                                            break a;
                                                                        }
                                                                      if (h = e[r + 4 >> 2], r = e[r + 8 >> 2], (h | 0) == (r | 0))
                                                                        break a;
                                                                      for (; Rl(e[h >> 2], o, c), h = h + 4 | 0, (r | 0) != (h | 0); )
                                                                        ;
                                                                      break a;
                                                                    }
                                                                    if (r = Ol(r, Tr, hr, c), h = e[r >> 2], c = e[r + 4 >> 2], (h | 0) == (c | 0))
                                                                      break a;
                                                                    for (; e[g + 56 >> 2] = e[h >> 2], r = e[h + 4 >> 2], e[g + 60 >> 2] = r, r && (e[r + 4 >> 2] = e[r + 4 >> 2] + 1), r = e[g + 60 >> 2], e[g >> 2] = e[g + 56 >> 2], e[g + 4 >> 2] = r, _d(o, h + 8 | 0, g), h = h + 32 | 0, (c | 0) != (h | 0); )
                                                                      ;
                                                                    break a;
                                                                  }
                                                                  Iu(o, c, 1, r + 4 | 0, 0, 0);
                                                                  break a;
                                                                }
                                                                if (ln = (y | 0) == 4 ? 4 : 5, vc(g + 56 | 0, ln, Tr, hr, 0, 0), e[5996] = 0, h = ii(46, ln | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                  break s;
                                                                if (e[g + 88 >> 2] = 0, e[g + 80 >> 2] = 0, e[g + 84 >> 2] = 0, $[g + 136 | 0] = 0, e[g + 132 >> 2] = g + 80, y = e[h + 4 >> 2], G = e[h >> 2], Ar = y - G | 0, S = (Ar | 0) / 12 | 0, (y | 0) != (G | 0)) {
                                                                  h: {
                                                                    x: {
                                                                      m: {
                                                                        if (S >>> 0 >= 357913942) {
                                                                          if (e[5996] = 0, Ri(47), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                            break m;
                                                                          break n;
                                                                        }
                                                                        if (e[5996] = 0, y = ii(3, Ar | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                          break m;
                                                                        if (e[g + 84 >> 2] = y, e[g + 80 >> 2] = y, e[g + 88 >> 2] = y + vi(S, 12), S = e[h + 4 >> 2], h = e[h >> 2], e[5996] = 0, h = da(48, g + 88 | 0, h | 0, S | 0, y | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1)
                                                                          break h;
                                                                        h = Vr() | 0, e[g + 84 >> 2] = y;
                                                                        break x;
                                                                      }
                                                                      h = Vr() | 0;
                                                                    }
                                                                    i2(g + 132 | 0);
                                                                    break r;
                                                                  }
                                                                  e[g + 84 >> 2] = h;
                                                                }
                                                                if (e[g + 140 >> 2] = 0, e[g + 132 >> 2] = 0, e[g + 136 >> 2] = 0, y = e[r + 8 >> 2], h = e[r + 4 >> 2], e[5996] = 0, di(49, g + 132 | 0, y - h >> 2), y = e[5996], e[5996] = 0, (y | 0) != 1) {
                                                                  if (h = e[g + 84 >> 2], y = e[g + 80 >> 2], (h | 0) != (y | 0))
                                                                    for (Ji = r + 40 | 0, h = y; ; ) {
                                                                      e[g + 128 >> 2] = 0, e[g + 120 >> 2] = 0, e[g + 124 >> 2] = 0;
                                                                      h: {
                                                                        x: {
                                                                          m: {
                                                                            B: {
                                                                              if (S = e[r + 8 >> 2], y = e[r + 4 >> 2], ei = vi(gi, 12), h = ei + h | 0, S - y >> 2 == e[h + 4 >> 2] - e[h >> 2] >> 3) {
                                                                                if (G = 0, Rn = 1, Fe = 0, (y | 0) != (S | 0))
                                                                                  break B;
                                                                                break m;
                                                                              }
                                                                              if (e[5996] = 0, Qs(44, 5170, 1900, 642, 2497), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                break n;
                                                                              h = Vr() | 0;
                                                                              break x;
                                                                            }
                                                                            B: {
                                                                              R: {
                                                                                for (; ; ) {
                                                                                  E: {
                                                                                    if (h = Fe << 3, hr = Fi[h + e[g + 68 >> 2] >> 3], Tr = Fi[h + e[g + 56 >> 2] >> 3], y = e[(Fe << 2) + y >> 2], e[5996] = 0, y = lc(50, y | 0, +Tr, +hr, c | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                      break E;
                                                                                    if (h = h + e[ei + e[g + 80 >> 2] >> 2] | 0, S = e[h >> 2], h = e[h + 4 >> 2], Ar = e[y + 4 >> 2], y = e[y >> 2], e[5996] = 0, eu(51, g + 100 | 0, y | 0, Ar | 0, S | 0, h | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                      break R;
                                                                                    S = e[g + 128 >> 2];
                                                                                    C: {
                                                                                      if (S >>> 0 > G >>> 0) {
                                                                                        e[G + 8 >> 2] = 0, e[G >> 2] = 0, e[G + 4 >> 2] = 0, e[G >> 2] = e[g + 100 >> 2], e[G + 4 >> 2] = e[g + 104 >> 2], e[G + 8 >> 2] = e[g + 108 >> 2], e[g + 124 >> 2] = G + 12;
                                                                                        break C;
                                                                                      }
                                                                                      y: {
                                                                                        y = e[g + 120 >> 2], Ar = (G - y | 0) / 12 | 0, h = Ar + 1 | 0;
                                                                                        D: {
                                                                                          if (h >>> 0 >= 357913942) {
                                                                                            e[5996] = 0, Ri(52);
                                                                                            break D;
                                                                                          }
                                                                                          if (S = (S - y | 0) / 12 | 0, ke = S << 1, h = S >>> 0 >= 178956970 ? 357913941 : h >>> 0 < ke >>> 0 ? ke : h, h >>> 0 < 357913942)
                                                                                            break y;
                                                                                          e[5996] = 0, Ri(35);
                                                                                        }
                                                                                        if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                          break n;
                                                                                        break B;
                                                                                      }
                                                                                      if (e[5996] = 0, ke = vi(h, 12), S = ii(3, ke | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                        break B;
                                                                                      h = S + vi(Ar, 12) | 0, e[h >> 2] = e[g + 100 >> 2], e[h + 4 >> 2] = e[g + 104 >> 2], e[h + 8 >> 2] = e[g + 108 >> 2], e[g + 108 >> 2] = 0, e[g + 100 >> 2] = 0, e[g + 104 >> 2] = 0, S = S + ke | 0, Ar = h + 12 | 0;
                                                                                      y: {
                                                                                        if ((y | 0) == (G | 0)) {
                                                                                          e[g + 128 >> 2] = S, e[g + 124 >> 2] = Ar, e[g + 120 >> 2] = h;
                                                                                          break y;
                                                                                        }
                                                                                        for (; h = h - 12 | 0, G = G - 12 | 0, e[h >> 2] = e[G >> 2], e[h + 4 >> 2] = e[G + 4 >> 2], e[h + 8 >> 2] = e[G + 8 >> 2], e[G + 8 >> 2] = 0, e[G >> 2] = 0, e[G + 4 >> 2] = 0, (y | 0) != (G | 0); )
                                                                                          ;
                                                                                        if (e[g + 128 >> 2] = S, y = e[g + 124 >> 2], e[g + 124 >> 2] = Ar, G = e[g + 120 >> 2], e[g + 120 >> 2] = h, (y | 0) == (G | 0))
                                                                                          break y;
                                                                                        for (; ; ) {
                                                                                          if (ke = y - 12 | 0, Ar = e[ke >> 2], Ar) {
                                                                                            if (ci = y - 8 | 0, h = e[ci >> 2], S = Ar, (h | 0) != (S | 0)) {
                                                                                              for (; ; ) {
                                                                                                h = h - 32 | 0, y = e[h + 4 >> 2];
                                                                                                D: {
                                                                                                  if (!y || (S = e[y + 4 >> 2], e[y + 4 >> 2] = S - 1, S))
                                                                                                    break D;
                                                                                                  _n[e[e[y >> 2] + 8 >> 2]](y), cs(y);
                                                                                                }
                                                                                                if ((h | 0) == (Ar | 0))
                                                                                                  break;
                                                                                              }
                                                                                              S = e[ke >> 2];
                                                                                            }
                                                                                            e[ci >> 2] = Ar, Sr(S);
                                                                                          }
                                                                                          if (y = ke, (G | 0) == (y | 0))
                                                                                            break;
                                                                                        }
                                                                                      }
                                                                                      if (G && Sr(G), S = e[g + 100 >> 2], !S)
                                                                                        break C;
                                                                                      if (y = S, h = e[g + 104 >> 2], (y | 0) != (h | 0)) {
                                                                                        for (; ; ) {
                                                                                          h = h - 32 | 0, y = e[h + 4 >> 2];
                                                                                          y: {
                                                                                            if (!y || (G = e[y + 4 >> 2], e[y + 4 >> 2] = G - 1, G))
                                                                                              break y;
                                                                                            _n[e[e[y >> 2] + 8 >> 2]](y), cs(y);
                                                                                          }
                                                                                          if ((h | 0) == (S | 0))
                                                                                            break;
                                                                                        }
                                                                                        y = e[g + 100 >> 2];
                                                                                      }
                                                                                      e[g + 104 >> 2] = S, Sr(y);
                                                                                    }
                                                                                    if (G = e[g + 124 >> 2], y = G - 12 | 0, Rn = vi(e[y + 4 >> 2] - e[y >> 2] >> 5, Rn), Fe = Fe + 1 | 0, y = e[r + 4 >> 2], Fe >>> 0 < e[r + 8 >> 2] - y >> 2 >>> 0)
                                                                                      continue;
                                                                                    break m;
                                                                                  }
                                                                                  break;
                                                                                }
                                                                                h = Vr() | 0;
                                                                                break x;
                                                                              }
                                                                              h = Vr() | 0;
                                                                              break x;
                                                                            }
                                                                            h = Vr() | 0, lu(g + 100 | 0);
                                                                            break x;
                                                                          }
                                                                          for (G = 0, Ar = e[g + 132 >> 2]; ; ) {
                                                                            if ((G | 0) == (Rn | 0))
                                                                              break h;
                                                                            if (e[r + 8 >> 2] != e[r + 4 >> 2])
                                                                              for (h = 0, S = e[g + 120 >> 2], y = G; ke = vi(h, 12), Fe = ke + S | 0, S = e[Fe >> 2], e[Ar + (h << 2) >> 2] = S + ((y >>> 0) % (e[Fe + 4 >> 2] - S >> 5 >>> 0) << 5), Fe = y, S = e[g + 120 >> 2], y = ke + S | 0, y = (Fe >>> 0) / (e[y + 4 >> 2] - e[y >> 2] >> 5 >>> 0) | 0, h = h + 1 | 0, h >>> 0 < e[r + 8 >> 2] - e[r + 4 >> 2] >> 2 >>> 0; )
                                                                                ;
                                                                            if (e[5996] = 0, Ou(53, o | 0, ln | 0, g + 132 | 0, 0, Ji | 0), y = e[5996], e[5996] = 0, G = G + 1 | 0, (y | 0) == 1)
                                                                              break;
                                                                          }
                                                                          h = Vr() | 0;
                                                                        }
                                                                        mf(g + 120 | 0);
                                                                        break i;
                                                                      }
                                                                      if (S = e[g + 120 >> 2], S) {
                                                                        if (h = e[g + 124 >> 2], (S | 0) != (h | 0)) {
                                                                          for (; ; ) {
                                                                            if (Ar = h - 12 | 0, G = e[Ar >> 2], G) {
                                                                              if (y = G, ke = h - 8 | 0, h = e[ke >> 2], (y | 0) != (h | 0)) {
                                                                                for (; ; ) {
                                                                                  h = h - 32 | 0, y = e[h + 4 >> 2];
                                                                                  h: {
                                                                                    if (!y || (Fe = e[y + 4 >> 2], e[y + 4 >> 2] = Fe - 1, Fe))
                                                                                      break h;
                                                                                    _n[e[e[y >> 2] + 8 >> 2]](y), cs(y);
                                                                                  }
                                                                                  if ((h | 0) == (G | 0))
                                                                                    break;
                                                                                }
                                                                                y = e[Ar >> 2];
                                                                              }
                                                                              e[ke >> 2] = G, Sr(y);
                                                                            }
                                                                            if (h = Ar, (S | 0) == (h | 0))
                                                                              break;
                                                                          }
                                                                          S = e[g + 120 >> 2];
                                                                        }
                                                                        Sr(S);
                                                                      }
                                                                      if (gi = gi + 1 | 0, h = e[g + 80 >> 2], !(gi >>> 0 < (e[g + 84 >> 2] - h | 0) / 12 >>> 0))
                                                                        break;
                                                                    }
                                                                  if (r = e[g + 132 >> 2], r && (Sr(r), h = e[g + 80 >> 2]), h) {
                                                                    if (y = h, S = e[g + 84 >> 2], (y | 0) != (S | 0)) {
                                                                      for (; r = S - 12 | 0, o = e[r >> 2], o && (e[S - 8 >> 2] = o, Sr(o)), S = r, (r | 0) != (h | 0); )
                                                                        ;
                                                                      y = e[g + 80 >> 2];
                                                                    }
                                                                    e[g + 84 >> 2] = h, Sr(y);
                                                                  }
                                                                  if (r = e[g + 68 >> 2], r && (e[g + 72 >> 2] = r, Sr(r)), r = e[g + 56 >> 2], !r)
                                                                    break a;
                                                                  e[g + 60 >> 2] = r, Sr(r);
                                                                  break a;
                                                                }
                                                                h = Vr() | 0;
                                                                break i;
                                                              }
                                                              Iu(o, c, 0, r + 4 | 0, 0, 0);
                                                              break a;
                                                            }
                                                            vc(g + 56 | 0, 24, Tr, hr, Fi[r + 48 >> 3], e[r + 8 >> 2] - e[r + 4 >> 2] >> 2), e[g + 88 >> 2] = 0, e[g + 80 >> 2] = 0, e[g + 84 >> 2] = 0, e[g + 140 >> 2] = 0, e[g + 132 >> 2] = 0, e[g + 136 >> 2] = 0;
                                                            w: {
                                                              b: {
                                                                h: {
                                                                  x: {
                                                                    m: {
                                                                      B: {
                                                                        R: {
                                                                          E: {
                                                                            C: {
                                                                              S = e[r + 4 >> 2];
                                                                              y: {
                                                                                if ((S | 0) == e[r + 8 >> 2]) {
                                                                                  Ar = -1, y = S, h = 0;
                                                                                  break y;
                                                                                }
                                                                                hr = -1, y = S, Ar = -1;
                                                                                D: {
                                                                                  for (; ; ) {
                                                                                    if (h = G << 3, Tr = Fi[h + e[g + 68 >> 2] >> 3], Mn = Fi[h + e[g + 56 >> 2] >> 3], y = e[(G << 2) + y >> 2], e[5996] = 0, y = lc(50, y | 0, +Mn, +Tr, c | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                      break C;
                                                                                    e[5996] = 0, h = On(54, 1283, 5) | 0, S = e[5996], e[5996] = 0;
                                                                                    P: {
                                                                                      q: {
                                                                                        O: {
                                                                                          Q: {
                                                                                            U: {
                                                                                              if ((S | 0) == 1 || (S = e[y >> 2], ke = e[y + 4 >> 2], e[5996] = 0, eu(51, g + 120 | 0, S | 0, ke | 0, h | 0, 0), h = e[5996], e[5996] = 0, (h | 0) == 1))
                                                                                                break U;
                                                                                              switch (ke = 1, S = e[g + 120 >> 2], e[g + 124 >> 2] - S >> 5) {
                                                                                                case 0:
                                                                                                  break q;
                                                                                                case 1:
                                                                                                  break O;
                                                                                                default:
                                                                                                  break Q;
                                                                                              }
                                                                                            }
                                                                                            h = Vr() | 0;
                                                                                            break w;
                                                                                          }
                                                                                          if (e[5996] = 0, Qs(44, 4164, 1900, 807, 2386), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                            break n;
                                                                                          h = Vr() | 0;
                                                                                          break b;
                                                                                        }
                                                                                        if (e[5996] = 0, di(55, g + 80 | 0, S | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                          break E;
                                                                                        if (e[5996] = 0, h = On(54, 1277, 5) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1 || (S = e[y >> 2], y = e[y + 4 >> 2], e[5996] = 0, eu(51, g + 100 | 0, S | 0, y | 0, h | 0, 0), y = e[5996], e[5996] = 0, (y | 0) == 1))
                                                                                          break P;
                                                                                        O: {
                                                                                          Q: {
                                                                                            U:
                                                                                              switch (y = e[g + 100 >> 2], e[g + 104 >> 2] - y >> 5) {
                                                                                                case 0:
                                                                                                  break O;
                                                                                                case 1:
                                                                                                  break Q;
                                                                                                default:
                                                                                                  break U;
                                                                                              }
                                                                                            if (e[5996] = 0, Qs(44, 4146, 1900, 811, 2386), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                              break n;
                                                                                            break h;
                                                                                          }
                                                                                          if (e[5996] = 0, di(55, g + 132 | 0, y | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                            break h;
                                                                                          if (ke = 0, Tr = Fi[e[g + 136 >> 2] - 8 >> 3] - Fi[e[g + 84 >> 2] - 8 >> 3], !(Tr > hr))
                                                                                            break O;
                                                                                          Ar = G, hr = Tr;
                                                                                        }
                                                                                        if (S = e[g + 100 >> 2], S) {
                                                                                          if (y = S, h = e[g + 104 >> 2], (y | 0) != (h | 0)) {
                                                                                            for (; ; ) {
                                                                                              h = h - 32 | 0, y = e[h + 4 >> 2];
                                                                                              O: {
                                                                                                if (!y || (Fe = e[y + 4 >> 2], e[y + 4 >> 2] = Fe - 1, Fe))
                                                                                                  break O;
                                                                                                _n[e[e[y >> 2] + 8 >> 2]](y), cs(y);
                                                                                              }
                                                                                              if ((h | 0) == (S | 0))
                                                                                                break;
                                                                                            }
                                                                                            y = e[g + 100 >> 2];
                                                                                          }
                                                                                          e[g + 104 >> 2] = S, Sr(y);
                                                                                        }
                                                                                        S = e[g + 120 >> 2];
                                                                                      }
                                                                                      if (S) {
                                                                                        if (y = S, h = e[g + 124 >> 2], (y | 0) != (h | 0)) {
                                                                                          for (; ; ) {
                                                                                            h = h - 32 | 0, y = e[h + 4 >> 2];
                                                                                            q: {
                                                                                              if (!y || (Fe = e[y + 4 >> 2], e[y + 4 >> 2] = Fe - 1, Fe))
                                                                                                break q;
                                                                                              _n[e[e[y >> 2] + 8 >> 2]](y), cs(y);
                                                                                            }
                                                                                            if ((h | 0) == (S | 0))
                                                                                              break;
                                                                                          }
                                                                                          y = e[g + 120 >> 2];
                                                                                        }
                                                                                        e[g + 124 >> 2] = S, Sr(y);
                                                                                      }
                                                                                      if (ke)
                                                                                        break x;
                                                                                      if (G = G + 1 | 0, S = e[r + 8 >> 2], y = e[r + 4 >> 2], G >>> 0 >= S - y >> 2 >>> 0)
                                                                                        break D;
                                                                                      continue;
                                                                                    }
                                                                                    break;
                                                                                  }
                                                                                  h = Vr() | 0;
                                                                                  break b;
                                                                                }
                                                                                h = e[g + 80 >> 2];
                                                                              }
                                                                              if (e[5996] = 0, c = ii(3, 4) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                                break R;
                                                                              if (e[c >> 2] = h + (Ar << 5), h = c + 4 | 0, e[g + 128 >> 2] = h, e[g + 124 >> 2] = h, e[g + 120 >> 2] = c, (y | 0) != (S | 0))
                                                                                for (G = 0; ; ) {
                                                                                  y: {
                                                                                    if ((G | 0) == (Ar | 0))
                                                                                      break y;
                                                                                    if (c = e[g + 132 >> 2] + (G << 5) | 0, ke = e[g + 128 >> 2], ke >>> 0 > h >>> 0) {
                                                                                      e[h >> 2] = c, h = h + 4 | 0, e[g + 124 >> 2] = h;
                                                                                      break y;
                                                                                    }
                                                                                    D: {
                                                                                      P: {
                                                                                        S = e[g + 120 >> 2], Rn = h - S >> 2, y = Rn + 1 | 0;
                                                                                        q: {
                                                                                          if (y >>> 0 >= 1073741824) {
                                                                                            e[5996] = 0, Ri(56);
                                                                                            break q;
                                                                                          }
                                                                                          if (ke = ke - S | 0, Fe = ke >> 1, ke = ke >>> 0 >= 2147483644 ? 1073741823 : y >>> 0 < Fe >>> 0 ? Fe : y, !ke) {
                                                                                            Fe = 0;
                                                                                            break D;
                                                                                          }
                                                                                          if (ke >>> 0 < 1073741824)
                                                                                            break P;
                                                                                          e[5996] = 0, Ri(35);
                                                                                        }
                                                                                        if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                          break n;
                                                                                        h = Vr() | 0;
                                                                                        break m;
                                                                                      }
                                                                                      if (e[5996] = 0, Fe = ii(3, ke << 2) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                        break B;
                                                                                    }
                                                                                    if (y = (Rn << 2) + Fe | 0, e[y >> 2] = c, c = y + 4 | 0, (h | 0) != (S | 0)) {
                                                                                      for (; y = y - 4 | 0, h = h - 4 | 0, e[y >> 2] = e[h >> 2], (h | 0) != (S | 0); )
                                                                                        ;
                                                                                      h = e[g + 120 >> 2];
                                                                                    }
                                                                                    e[g + 128 >> 2] = (ke << 2) + Fe, e[g + 124 >> 2] = c, e[g + 120 >> 2] = y, h && Sr(h), h = c;
                                                                                  }
                                                                                  if (G = G + 1 | 0, !(G >>> 0 < e[r + 8 >> 2] - e[r + 4 >> 2] >> 2 >>> 0))
                                                                                    break;
                                                                                }
                                                                              if (hr = Fi[r + 48 >> 3], e[5996] = 0, Ou(53, o | 0, 24, g + 120 | 0, +hr, r + 40 | 0), r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                                                                if (r = e[g + 120 >> 2], !r)
                                                                                  break x;
                                                                                Sr(r);
                                                                                break x;
                                                                              }
                                                                              h = Vr() | 0, S = e[g + 120 >> 2];
                                                                              break m;
                                                                            }
                                                                            h = Vr() | 0;
                                                                            break w;
                                                                          }
                                                                          h = Vr() | 0;
                                                                          break b;
                                                                        }
                                                                        h = Vr() | 0;
                                                                        break w;
                                                                      }
                                                                      h = Vr() | 0;
                                                                    }
                                                                    if (!S)
                                                                      break w;
                                                                    Sr(S);
                                                                    break w;
                                                                  }
                                                                  if (r = e[g + 132 >> 2], r) {
                                                                    if (h = e[g + 136 >> 2], (r | 0) != (h | 0)) {
                                                                      for (; ; ) {
                                                                        h = h - 32 | 0, o = e[h + 4 >> 2];
                                                                        x: {
                                                                          if (!o || (c = e[o + 4 >> 2], e[o + 4 >> 2] = c - 1, c))
                                                                            break x;
                                                                          _n[e[e[o >> 2] + 8 >> 2]](o), cs(o);
                                                                        }
                                                                        if ((r | 0) == (h | 0))
                                                                          break;
                                                                      }
                                                                      r = e[g + 132 >> 2];
                                                                    }
                                                                    Sr(r);
                                                                  }
                                                                  if (r = e[g + 80 >> 2], r) {
                                                                    if (h = e[g + 84 >> 2], (r | 0) != (h | 0)) {
                                                                      for (; ; ) {
                                                                        h = h - 32 | 0, o = e[h + 4 >> 2];
                                                                        x: {
                                                                          if (!o || (c = e[o + 4 >> 2], e[o + 4 >> 2] = c - 1, c))
                                                                            break x;
                                                                          _n[e[e[o >> 2] + 8 >> 2]](o), cs(o);
                                                                        }
                                                                        if ((r | 0) == (h | 0))
                                                                          break;
                                                                      }
                                                                      r = e[g + 80 >> 2];
                                                                    }
                                                                    Sr(r);
                                                                  }
                                                                  if (r = e[g + 68 >> 2], r && (e[g + 72 >> 2] = r, Sr(r)), r = e[g + 56 >> 2], !r)
                                                                    break a;
                                                                  e[g + 60 >> 2] = r, Sr(r);
                                                                  break a;
                                                                }
                                                                h = Vr() | 0, lu(g + 100 | 0);
                                                              }
                                                              lu(g + 120 | 0);
                                                            }
                                                            lu(g + 132 | 0), lu(g + 80 | 0);
                                                            break r;
                                                          }
                                                          y = e[r + 4 >> 2], h = e[y + 4 >> 2], S = e[y >> 2], G = e[y + 8 >> 2], y = xs(12), e[g + 56 >> 2] = y, Ar = y + 12 | 0, e[g + 64 >> 2] = Ar, e[y + 8 >> 2] = G, e[y + 4 >> 2] = S, e[y >> 2] = h, e[g + 60 >> 2] = Ar, hr = Fi[r + 48 >> 3], e[5996] = 0, Ta(57, o | 0, c | 0, 23, r + 4 | 0, +hr, 0), r = e[5996], e[5996] = 0;
                                                          v: {
                                                            if ((r | 0) == 1 || (e[5996] = 0, Ta(57, o | 0, c | 0, 23, g + 56 | 0, +hr, 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                                                              break v;
                                                            Sr(y);
                                                            break a;
                                                          }
                                                          break e;
                                                        }
                                                        y = e[r + 4 >> 2], h = e[y >> 2], S = e[y + 4 >> 2], y = xs(8), e[g + 56 >> 2] = y, G = y + 8 | 0, e[g + 64 >> 2] = G, e[y >> 2] = hd(h, S, 32), e[y + 4 >> 2] = vs, e[g + 60 >> 2] = G, h = r + 4 | 0, Tr = Fi[r + 48 >> 3], Mn = 1 - Tr;
                                                        T: {
                                                          if (hr == 0 && (e[5996] = 0, Ta(57, o | 0, c | 0, 20, h | 0, +Tr, 0), r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, Ta(57, o | 0, c | 0, 20, g + 56 | 0, +Mn, 0), r = e[5996], e[5996] = 0, (r | 0) == 1)) || (e[5996] = 0, Ta(57, o | 0, c | 0, 19, h | 0, +Tr, 0), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, r = g + 56 | 0, Ta(57, o | 0, c | 0, 19, r | 0, +Mn, 0), S = e[5996], e[5996] = 0, (S | 0) == 1) || (e[5996] = 0, Ta(57, o | 0, c | 0, 21, h | 0, +Tr, 0), S = e[5996], e[5996] = 0, (S | 0) == 1) || (e[5996] = 0, Ta(57, o | 0, c | 0, 21, r | 0, +Mn, 0), S = e[5996], e[5996] = 0, (S | 0) == 1) || (e[5996] = 0, Ta(57, o | 0, c | 0, 22, h | 0, +Tr, 0), S = e[5996], e[5996] = 0, (S | 0) == 1) || (e[5996] = 0, Ta(57, o | 0, c | 0, 22, r | 0, +Mn, 0), S = e[5996], e[5996] = 0, (S | 0) == 1) || (e[5996] = 0, Ta(57, o | 0, c | 0, 22, h | 0, +Tr, 1), h = e[5996], e[5996] = 0, (h | 0) == 1) || (e[5996] = 0, Ta(57, o | 0, c | 0, 22, r | 0, +Mn, 1), r = e[5996], e[5996] = 0, (r | 0) == 1))
                                                            break T;
                                                          Sr(y);
                                                          break a;
                                                        }
                                                        break e;
                                                      }
                                                      y = e[r + 4 >> 2], h = e[y >> 2], S = e[y + 4 >> 2], y = xs(8), e[g + 56 >> 2] = y, G = y + 8 | 0, e[g + 64 >> 2] = G, e[y >> 2] = hd(h, S, 32), e[y + 4 >> 2] = vs, e[g + 60 >> 2] = G, r = r + 4 | 0;
                                                      S: {
                                                        if (hr == 0 && (e[5996] = 0, Ta(57, o | 0, c | 0, 17, r | 0, 0, 0), h = e[5996], e[5996] = 0, (h | 0) == 1 || (e[5996] = 0, Ta(57, o | 0, c | 0, 17, g + 56 | 0, 0, 0), h = e[5996], e[5996] = 0, (h | 0) == 1)) || (e[5996] = 0, Ta(57, o | 0, c | 0, 18, r | 0, 0, 0), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Ta(57, o | 0, c | 0, 18, g + 56 | 0, 0, 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                                                          break S;
                                                        Sr(y);
                                                        break a;
                                                      }
                                                      break e;
                                                    }
                                                    Iu(o, c, 14, r + 4 | 0, 0, 0);
                                                    break a;
                                                  }
                                                  Iu(o, c, 15, r + 4 | 0, 0, 0);
                                                  break a;
                                                }
                                                Iu(o, c, 16, r + 4 | 0, 0, 0);
                                                break a;
                                              }
                                              Iu(o, c, 13, r + 4 | 0, 0, 0);
                                              break a;
                                            }
                                            Iu(o, c, 12, r + 4 | 0, 0, 0);
                                            break a;
                                          }
                                          r = r + 4 | 0, Iu(o, c, 10, r, 0, 0), Iu(o, c, 11, r, 0, 0);
                                          break a;
                                        }
                                        y = e[r + 40 >> 2], Ar = e[r + 44 >> 2], ye[24588] || (e[6145] = 0, e[6146] = 0, e[6143] = 0, e[6144] = 0, e[6141] = 0, e[6142] = 0, $[24588] = 1), ln = ff(g + 56 | 0), e[5996] = 0, h = ii(46, 25) | 0, S = e[5996], e[5996] = 0;
                                        u: {
                                          g: {
                                            if ((S | 0) != 1) {
                                              if (e[g + 52 >> 2] = 0, e[g + 44 >> 2] = 0, e[g + 48 >> 2] = 0, $[g + 84 | 0] = 0, e[g + 80 >> 2] = g + 44, S = e[h + 4 >> 2], ke = e[h >> 2], Fe = S - ke | 0, G = (Fe | 0) / 12 | 0, (S | 0) != (ke | 0)) {
                                                if (G >>> 0 >= 357913942) {
                                                  if (e[5996] = 0, Ri(47), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                    break n;
                                                  break g;
                                                }
                                                if (e[5996] = 0, S = ii(3, Fe | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                  break g;
                                                if (e[g + 48 >> 2] = S, e[g + 44 >> 2] = S, e[g + 52 >> 2] = S + vi(G, 12), G = e[h + 4 >> 2], h = e[h >> 2], e[5996] = 0, h = da(48, g + 52 | 0, h | 0, G | 0, S | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1) {
                                                  h = Vr() | 0, e[g + 48 >> 2] = S;
                                                  break u;
                                                }
                                                e[g + 48 >> 2] = h;
                                              }
                                              e[g + 40 >> 2] = 0, e[g + 32 >> 2] = 0, e[g + 36 >> 2] = 0, h = e[r + 8 >> 2], S = e[r + 4 >> 2], e[5996] = 0, di(49, g + 32 | 0, h - S >> 2), h = e[5996], e[5996] = 0;
                                              A: {
                                                if ((h | 0) != 1) {
                                                  p: {
                                                    I: {
                                                      if (h = e[g + 48 >> 2], S = e[g + 44 >> 2], (h | 0) != (S | 0))
                                                        for (Ji = r + 16 | 0, hr = +(y >>> 0) + +(Ar | 0) * 4294967296, Tr = hr + 1, hr = hr * 73 + 1, h = S; ; ) {
                                                          if (e[g + 28 >> 2] = 0, e[g + 20 >> 2] = 0, e[g + 24 >> 2] = 0, S = e[r + 8 >> 2], y = e[r + 4 >> 2], ei = vi(gi, 12), h = ei + h | 0, S - y >> 2 != e[h + 4 >> 2] - e[h >> 2] >> 3)
                                                            break I;
                                                          G = 0, Rn = 1, Fe = 0;
                                                          k: {
                                                            if ((y | 0) != (S | 0)) {
                                                              N: {
                                                                S: {
                                                                  T: {
                                                                    for (; ; ) {
                                                                      if (h = Fe << 3, Mn = Fi[h + e[ln + 12 >> 2] >> 3], ss = Fi[h + e[ln >> 2] >> 3], y = e[(Fe << 2) + y >> 2], e[5996] = 0, y = lc(50, y | 0, +ss, +Mn, c | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                        break S;
                                                                      if (h = h + e[ei + e[g + 44 >> 2] >> 2] | 0, S = e[h >> 2], h = e[h + 4 >> 2], Ar = e[y + 4 >> 2], y = e[y >> 2], e[5996] = 0, eu(51, g + 80 | 0, y | 0, Ar | 0, S | 0, h | 0), y = e[5996], e[5996] = 0, (y | 0) != 1) {
                                                                        S = e[g + 28 >> 2];
                                                                        v: {
                                                                          if (S >>> 0 > G >>> 0) {
                                                                            e[G + 8 >> 2] = 0, e[G >> 2] = 0, e[G + 4 >> 2] = 0, e[G >> 2] = e[g + 80 >> 2], e[G + 4 >> 2] = e[g + 84 >> 2], e[G + 8 >> 2] = e[g + 88 >> 2], e[g + 24 >> 2] = G + 12;
                                                                            break v;
                                                                          }
                                                                          w: {
                                                                            y = e[g + 20 >> 2], Ar = (G - y | 0) / 12 | 0, h = Ar + 1 | 0;
                                                                            b: {
                                                                              if (h >>> 0 >= 357913942) {
                                                                                e[5996] = 0, Ri(52);
                                                                                break b;
                                                                              }
                                                                              if (S = (S - y | 0) / 12 | 0, ke = S << 1, h = S >>> 0 >= 178956970 ? 357913941 : h >>> 0 < ke >>> 0 ? ke : h, h >>> 0 < 357913942)
                                                                                break w;
                                                                              e[5996] = 0, Ri(35);
                                                                            }
                                                                            if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                              break n;
                                                                            break T;
                                                                          }
                                                                          if (e[5996] = 0, ke = vi(h, 12), S = ii(3, ke | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                            break T;
                                                                          h = S + vi(Ar, 12) | 0, e[h >> 2] = e[g + 80 >> 2], e[h + 4 >> 2] = e[g + 84 >> 2], e[h + 8 >> 2] = e[g + 88 >> 2], e[g + 88 >> 2] = 0, e[g + 80 >> 2] = 0, e[g + 84 >> 2] = 0, S = S + ke | 0, Ar = h + 12 | 0;
                                                                          w: {
                                                                            if ((y | 0) == (G | 0)) {
                                                                              e[g + 28 >> 2] = S, e[g + 24 >> 2] = Ar, e[g + 20 >> 2] = h;
                                                                              break w;
                                                                            }
                                                                            for (; h = h - 12 | 0, G = G - 12 | 0, e[h >> 2] = e[G >> 2], e[h + 4 >> 2] = e[G + 4 >> 2], e[h + 8 >> 2] = e[G + 8 >> 2], e[G + 8 >> 2] = 0, e[G >> 2] = 0, e[G + 4 >> 2] = 0, (y | 0) != (G | 0); )
                                                                              ;
                                                                            if (e[g + 28 >> 2] = S, y = e[g + 24 >> 2], e[g + 24 >> 2] = Ar, G = e[g + 20 >> 2], e[g + 20 >> 2] = h, (y | 0) == (G | 0))
                                                                              break w;
                                                                            for (; ; ) {
                                                                              if (ke = y - 12 | 0, Ar = e[ke >> 2], Ar) {
                                                                                if (ci = y - 8 | 0, h = e[ci >> 2], S = Ar, (h | 0) != (S | 0)) {
                                                                                  for (; ; ) {
                                                                                    h = h - 32 | 0, y = e[h + 4 >> 2];
                                                                                    b: {
                                                                                      if (!y || (S = e[y + 4 >> 2], e[y + 4 >> 2] = S - 1, S))
                                                                                        break b;
                                                                                      _n[e[e[y >> 2] + 8 >> 2]](y), cs(y);
                                                                                    }
                                                                                    if ((h | 0) == (Ar | 0))
                                                                                      break;
                                                                                  }
                                                                                  S = e[ke >> 2];
                                                                                }
                                                                                e[ci >> 2] = Ar, Sr(S);
                                                                              }
                                                                              if (y = ke, (G | 0) == (y | 0))
                                                                                break;
                                                                            }
                                                                          }
                                                                          if (G && Sr(G), S = e[g + 80 >> 2], !S)
                                                                            break v;
                                                                          if (y = S, h = e[g + 84 >> 2], (y | 0) != (h | 0)) {
                                                                            for (; ; ) {
                                                                              h = h - 32 | 0, y = e[h + 4 >> 2];
                                                                              w: {
                                                                                if (!y || (G = e[y + 4 >> 2], e[y + 4 >> 2] = G - 1, G))
                                                                                  break w;
                                                                                _n[e[e[y >> 2] + 8 >> 2]](y), cs(y);
                                                                              }
                                                                              if ((h | 0) == (S | 0))
                                                                                break;
                                                                            }
                                                                            y = e[g + 80 >> 2];
                                                                          }
                                                                          e[g + 84 >> 2] = S, Sr(y);
                                                                        }
                                                                        if (G = e[g + 24 >> 2], y = G - 12 | 0, Rn = vi(e[y + 4 >> 2] - e[y >> 2] >> 5, Rn), Fe = Fe + 1 | 0, y = e[r + 4 >> 2], Fe >>> 0 >= e[r + 8 >> 2] - y >> 2 >>> 0)
                                                                          break N;
                                                                        continue;
                                                                      }
                                                                      break;
                                                                    }
                                                                    h = Vr() | 0;
                                                                    break p;
                                                                  }
                                                                  h = Vr() | 0, lu(g + 80 | 0);
                                                                  break p;
                                                                }
                                                                h = Vr() | 0;
                                                                break p;
                                                              }
                                                              if (!Rn)
                                                                break k;
                                                            }
                                                            Ar = 0;
                                                            N: {
                                                              S: {
                                                                T: {
                                                                  v: {
                                                                    for (; ; ) {
                                                                      if (G = e[g + 32 >> 2], e[r + 8 >> 2] != e[r + 4 >> 2])
                                                                        for (h = 0, S = e[g + 20 >> 2], y = Ar; ke = vi(h, 12), Fe = ke + S | 0, S = e[Fe >> 2], e[(h << 2) + G >> 2] = S + ((y >>> 0) % (e[Fe + 4 >> 2] - S >> 5 >>> 0) << 5), Fe = y, S = e[g + 20 >> 2], y = ke + S | 0, y = (Fe >>> 0) / (e[y + 4 >> 2] - e[y >> 2] >> 5 >>> 0) | 0, h = h + 1 | 0, h >>> 0 < e[r + 8 >> 2] - e[r + 4 >> 2] >> 2 >>> 0; )
                                                                          ;
                                                                      e[g + 108 >> 2] = 0, e[g + 100 >> 2] = 0, e[g + 104 >> 2] = 0;
                                                                      w: {
                                                                        b: {
                                                                          if (ei = e[g + 36 >> 2], (ei | 0) != (G | 0))
                                                                            for (; ; ) {
                                                                              ke = e[G >> 2], h = e[g + 104 >> 2];
                                                                              h: {
                                                                                if ((h | 0) != e[g + 108 >> 2]) {
                                                                                  e[h >> 2] = e[ke >> 2], y = e[ke + 4 >> 2], e[h + 4 >> 2] = y, y && (e[y + 4 >> 2] = e[y + 4 >> 2] + 1), e[g + 104 >> 2] = h + 8;
                                                                                  break h;
                                                                                }
                                                                                x: {
                                                                                  S = e[g + 100 >> 2], y = h - S | 0, ci = y >> 3, Fe = ci + 1 | 0;
                                                                                  m: {
                                                                                    if (Fe >>> 0 >= 536870912) {
                                                                                      e[5996] = 0, Ri(59);
                                                                                      break m;
                                                                                    }
                                                                                    if (Qi = y >> 2, y = y >>> 0 >= 2147483640 ? 536870911 : Fe >>> 0 < Qi >>> 0 ? Qi : Fe, y >>> 0 < 536870912)
                                                                                      break x;
                                                                                    e[5996] = 0, Ri(35);
                                                                                  }
                                                                                  if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                    break n;
                                                                                  h = Vr() | 0;
                                                                                  break N;
                                                                                }
                                                                                if (e[5996] = 0, Qi = y << 3, Fe = ii(3, Qi | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                  break b;
                                                                                y = Fe + (ci << 3) | 0, e[y >> 2] = e[ke >> 2], ke = e[ke + 4 >> 2], e[y + 4 >> 2] = ke, ke && (e[ke + 4 >> 2] = e[ke + 4 >> 2] + 1, h = e[g + 104 >> 2]), ke = Fe + Qi | 0, Fe = y + 8 | 0;
                                                                                x: {
                                                                                  if ((h | 0) == (S | 0)) {
                                                                                    e[g + 108 >> 2] = ke, e[g + 104 >> 2] = Fe, e[g + 100 >> 2] = y;
                                                                                    break x;
                                                                                  }
                                                                                  for (; y = y - 8 | 0, h = h - 8 | 0, e[y >> 2] = e[h >> 2], e[y + 4 >> 2] = e[h + 4 >> 2], e[h >> 2] = 0, e[h + 4 >> 2] = 0, (h | 0) != (S | 0); )
                                                                                    ;
                                                                                  if (e[g + 108 >> 2] = ke, h = e[g + 104 >> 2], e[g + 104 >> 2] = Fe, S = e[g + 100 >> 2], e[g + 100 >> 2] = y, (h | 0) == (S | 0))
                                                                                    break x;
                                                                                  for (; ; ) {
                                                                                    h = h - 8 | 0, y = e[h + 4 >> 2];
                                                                                    m: {
                                                                                      if (!y || (ke = e[y + 4 >> 2], e[y + 4 >> 2] = ke - 1, ke))
                                                                                        break m;
                                                                                      _n[e[e[y >> 2] + 8 >> 2]](y), cs(y);
                                                                                    }
                                                                                    if ((h | 0) == (S | 0))
                                                                                      break;
                                                                                  }
                                                                                }
                                                                                if (!S)
                                                                                  break h;
                                                                                Sr(S);
                                                                              }
                                                                              if (G = G + 4 | 0, (ei | 0) == (G | 0))
                                                                                break;
                                                                            }
                                                                          if (Fi[g + 88 >> 3] = Tr, Fi[g + 80 >> 3] = hr, e[5996] = 0, G = ii(3, 104) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1)
                                                                            break w;
                                                                          break S;
                                                                        }
                                                                        h = Vr() | 0;
                                                                        break N;
                                                                      }
                                                                      if (e[G >> 2] = 7e3, e[G + 4 >> 2] = 0, e[G + 8 >> 2] = 0, e[5996] = 0, e[g + 132 >> 2] = e[g + 100 >> 2], y = e[g + 104 >> 2], h = e[g + 108 >> 2], e[g + 108 >> 2] = 0, e[g + 136 >> 2] = y, e[g + 140 >> 2] = h, e[g + 100 >> 2] = 0, e[g + 104 >> 2] = 0, ke = On(32, g + 120 | 0, Ji | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1) {
                                                                        if (y = e[r + 40 >> 2], e[5996] = 0, Fe = Cl(60, G + 12 | 0, 25, g + 132 | 0, ke | 0, y | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                          break v;
                                                                        if (S = e[ke >> 2], S) {
                                                                          if (y = e[g + 124 >> 2], h = S, (y | 0) != (h | 0)) {
                                                                            for (; h = y - 12 | 0, $[y - 1 | 0] < 0 && Sr(e[h >> 2]), y = h, (y | 0) != (S | 0); )
                                                                              ;
                                                                            h = e[ke >> 2];
                                                                          }
                                                                          e[g + 124 >> 2] = S, Sr(h);
                                                                        }
                                                                        if (y = e[g + 132 >> 2], y) {
                                                                          if (h = e[g + 136 >> 2], (y | 0) != (h | 0)) {
                                                                            for (; ; ) {
                                                                              h = h - 8 | 0, S = e[h + 4 >> 2];
                                                                              w: {
                                                                                if (!S || (ke = e[S + 4 >> 2], e[S + 4 >> 2] = ke - 1, ke))
                                                                                  break w;
                                                                                _n[e[e[S >> 2] + 8 >> 2]](S), cs(S);
                                                                              }
                                                                              if ((h | 0) == (y | 0))
                                                                                break;
                                                                            }
                                                                            y = e[g + 132 >> 2];
                                                                          }
                                                                          Sr(y);
                                                                        }
                                                                        if (e[g + 116 >> 2] = G, e[g + 112 >> 2] = Fe, e[5996] = 0, y = e[g + 116 >> 2], e[g + 8 >> 2] = e[g + 112 >> 2], e[g + 12 >> 2] = y, as(61, o | 0, g + 80 | 0, g + 8 | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                          break S;
                                                                        if (y = e[g + 100 >> 2], y) {
                                                                          if (h = e[g + 104 >> 2], (y | 0) != (h | 0)) {
                                                                            for (; ; ) {
                                                                              h = h - 8 | 0, S = e[h + 4 >> 2];
                                                                              w: {
                                                                                if (!S || (G = e[S + 4 >> 2], e[S + 4 >> 2] = G - 1, G))
                                                                                  break w;
                                                                                _n[e[e[S >> 2] + 8 >> 2]](S), cs(S);
                                                                              }
                                                                              if ((h | 0) == (y | 0))
                                                                                break;
                                                                            }
                                                                            y = e[g + 100 >> 2];
                                                                          }
                                                                          Sr(y);
                                                                        }
                                                                        if (Ar = Ar + 1 | 0, (Rn | 0) != (Ar | 0))
                                                                          continue;
                                                                        break k;
                                                                      }
                                                                      break;
                                                                    }
                                                                    h = Vr() | 0;
                                                                    break T;
                                                                  }
                                                                  h = Vr() | 0, Wo(ke);
                                                                }
                                                                xo(g + 132 | 0), Sr(G);
                                                                break N;
                                                              }
                                                              h = Vr() | 0;
                                                            }
                                                            xo(g + 100 | 0);
                                                            break p;
                                                          }
                                                          if (S = e[g + 20 >> 2], S) {
                                                            if (h = e[g + 24 >> 2], (S | 0) != (h | 0)) {
                                                              for (; ; ) {
                                                                if (Ar = h - 12 | 0, G = e[Ar >> 2], G) {
                                                                  if (y = G, ke = h - 8 | 0, h = e[ke >> 2], (y | 0) != (h | 0)) {
                                                                    for (; ; ) {
                                                                      h = h - 32 | 0, y = e[h + 4 >> 2];
                                                                      k: {
                                                                        if (!y || (Fe = e[y + 4 >> 2], e[y + 4 >> 2] = Fe - 1, Fe))
                                                                          break k;
                                                                        _n[e[e[y >> 2] + 8 >> 2]](y), cs(y);
                                                                      }
                                                                      if ((h | 0) == (G | 0))
                                                                        break;
                                                                    }
                                                                    y = e[Ar >> 2];
                                                                  }
                                                                  e[ke >> 2] = G, Sr(y);
                                                                }
                                                                if (h = Ar, (S | 0) == (h | 0))
                                                                  break;
                                                              }
                                                              S = e[g + 20 >> 2];
                                                            }
                                                            Sr(S);
                                                          }
                                                          if (gi = gi + 1 | 0, h = e[g + 44 >> 2], !(gi >>> 0 < (e[g + 48 >> 2] - h | 0) / 12 >>> 0))
                                                            break;
                                                        }
                                                      if (r = e[g + 32 >> 2], r && (Sr(r), h = e[g + 44 >> 2]), h) {
                                                        if (y = h, S = e[g + 48 >> 2], (y | 0) != (S | 0)) {
                                                          for (; r = S - 12 | 0, o = e[r >> 2], o && (e[S - 8 >> 2] = o, Sr(o)), S = r, (r | 0) != (h | 0); )
                                                            ;
                                                          y = e[g + 44 >> 2];
                                                        }
                                                        e[g + 48 >> 2] = h, Sr(y);
                                                      }
                                                      if (r = e[ln + 12 >> 2], r && (e[ln + 16 >> 2] = r, Sr(r)), r = e[ln >> 2], !r)
                                                        break a;
                                                      e[ln + 4 >> 2] = r, Sr(r);
                                                      break a;
                                                    }
                                                    if (e[5996] = 0, Qs(44, 5170, 1900, 642, 2497), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                      break n;
                                                    h = Vr() | 0;
                                                  }
                                                  mf(g + 20 | 0);
                                                  break A;
                                                }
                                                h = Vr() | 0;
                                              }
                                              r = e[g + 32 >> 2], r && Sr(r), Qc(g + 44 | 0);
                                              break t;
                                            }
                                            r = Vr() | 0, ca(ln), Ki(r | 0), ri();
                                          }
                                          h = Vr() | 0;
                                        }
                                        i2(g + 80 | 0);
                                        break t;
                                      }
                                      y = r + 4 | 0, r = r + 16 | 0, zd(o, c, 2, y, r), zd(o, c, 3, y, r);
                                      break a;
                                    }
                                    sf(o, c, 6, r + 4 | 0, r + 28 | 0);
                                    break a;
                                  }
                                  sf(o, c, 8, r + 4 | 0, r + 28 | 0);
                                  break a;
                                }
                                sf(o, c, 7, r + 4 | 0, r + 28 | 0);
                                break a;
                              }
                              sf(o, c, 9, r + 4 | 0, r + 28 | 0);
                            }
                            Yr = g + 144 | 0;
                            return;
                          }
                          h = Vr() | 0;
                          break r;
                        }
                        r = e[g + 132 >> 2], r && Sr(r), Qc(g + 80 | 0);
                        break r;
                      }
                      ri();
                    }
                    ca(g + 56 | 0), Ki(h | 0), ri();
                  }
                  ca(ln), Ki(h | 0), ri();
                }
                r = Vr() | 0, Sr(y), Ki(r | 0), ri();
              }
              function Vd(r, o, c, h) {
                var y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0, Qi = 0, Ji = 0, ss = 0, As = 0, Rs = 0, oo = 0, Go = 0, Jo = 0, ta = 0, sa = 0, Ea = 0, Wa = 0;
                ei = Yr - 48 | 0, Yr = ei;
                e: {
                  if (c >>> 0 <= 2) {
                    for (c = c << 2, Go = e[c + 8972 >> 2], Jo = e[c + 8960 >> 2]; ; ) {
                      c = e[o + 4 >> 2];
                      t: {
                        if ((c | 0) != e[o + 104 >> 2]) {
                          e[o + 4 >> 2] = c + 1, c = ye[c | 0];
                          break t;
                        }
                        c = go(o);
                      }
                      if (!((c | 0) == 32 | c - 9 >>> 0 < 5))
                        break;
                    }
                    Qi = 1;
                    t: {
                      r:
                        switch (c - 43 | 0) {
                          case 0:
                          case 2:
                            break r;
                          default:
                            break t;
                        }
                      if (Qi = (c | 0) == 45 ? -1 : 1, c = e[o + 4 >> 2], (c | 0) != e[o + 104 >> 2]) {
                        e[o + 4 >> 2] = c + 1, c = ye[c | 0];
                        break t;
                      }
                      c = go(o);
                    }
                    t: {
                      r: {
                        for (; ; ) {
                          if ($[S + 1031 | 0] == (c | 32)) {
                            n: {
                              if (S >>> 0 > 6)
                                break n;
                              if (c = e[o + 4 >> 2], (c | 0) != e[o + 104 >> 2]) {
                                e[o + 4 >> 2] = c + 1, c = ye[c | 0];
                                break n;
                              }
                              c = go(o);
                            }
                            if (S = S + 1 | 0, (S | 0) != 8)
                              continue;
                            break r;
                          }
                          break;
                        }
                        if ((S | 0) != 3) {
                          if (Tr = (S | 0) == 8, Tr)
                            break r;
                          if (!h | S >>> 0 < 4)
                            break t;
                          if (Tr)
                            break r;
                        }
                        if (c = e[o + 116 >> 2], (c | 0) > 0 | (c | 0) >= 0 && (e[o + 4 >> 2] = e[o + 4 >> 2] - 1), !h | S >>> 0 < 4)
                          break r;
                        for (c = (c | 0) < 0; c || (e[o + 4 >> 2] = e[o + 4 >> 2] - 1), S = S - 1 | 0, S >>> 0 > 3; )
                          ;
                      }
                      hr = Yr - 16 | 0, Yr = hr, G = (Vo(la(la(Qi | 0) * la(1 / 0))), js(2)), o = G & 2147483647;
                      r: {
                        if (o - 8388608 >>> 0 <= 2130706431) {
                          c = o, o = o >>> 7 | 0, c = c << 25, h = o + 1065353216 | 0;
                          break r;
                        }
                        if (c = G << 25, h = G >>> 7 | 2147418112, o >>> 0 >= 2139095040 || (c = 0, h = 0, !o))
                          break r;
                        c = o, o = Do(o), ha(hr, c, 0, 0, 0, o + 81 | 0), Fe = e[hr >> 2], ke = e[hr + 4 >> 2], c = e[hr + 8 >> 2], h = e[hr + 12 >> 2] ^ 65536 | 16265 - o << 16;
                      }
                      e[ei >> 2] = Fe, e[ei + 4 >> 2] = ke, e[ei + 8 >> 2] = c, e[ei + 12 >> 2] = G & -2147483648 | h, Yr = hr + 16 | 0, Fe = e[ei + 8 >> 2], ke = e[ei + 12 >> 2], G = e[ei >> 2], Ar = e[ei + 4 >> 2];
                      break e;
                    }
                    t: {
                      r: {
                        n: {
                          if (S)
                            break n;
                          for (S = 0; ; ) {
                            if ($[S + 2020 | 0] != (c | 32))
                              break n;
                            i: {
                              if (S >>> 0 > 1)
                                break i;
                              if (c = e[o + 4 >> 2], (c | 0) != e[o + 104 >> 2]) {
                                e[o + 4 >> 2] = c + 1, c = ye[c | 0];
                                break i;
                              }
                              c = go(o);
                            }
                            if (S = S + 1 | 0, (S | 0) == 3)
                              break;
                          }
                          break r;
                        }
                        n:
                          switch (S | 0) {
                            case 0:
                              i: {
                                if ((c | 0) != 48)
                                  break i;
                                S = e[o + 4 >> 2];
                                s: {
                                  if ((S | 0) != e[o + 104 >> 2]) {
                                    e[o + 4 >> 2] = S + 1, S = ye[S | 0];
                                    break s;
                                  }
                                  S = go(o);
                                }
                                if ((S & -33) == 88) {
                                  Tr = 0, g = Yr - 432 | 0, Yr = g, c = e[o + 4 >> 2];
                                  s: {
                                    if ((c | 0) != e[o + 104 >> 2]) {
                                      e[o + 4 >> 2] = c + 1, S = ye[c | 0];
                                      break s;
                                    }
                                    S = go(o);
                                  }
                                  s: {
                                    a: {
                                      for (; ; ) {
                                        if ((S | 0) != 48)
                                          o: {
                                            if ((S | 0) != 46)
                                              break s;
                                            if (c = e[o + 4 >> 2], (c | 0) == e[o + 104 >> 2])
                                              break o;
                                            e[o + 4 >> 2] = c + 1, S = ye[c | 0];
                                            break a;
                                          }
                                        else {
                                          c = e[o + 4 >> 2], (c | 0) != e[o + 104 >> 2] ? (y = 1, e[o + 4 >> 2] = c + 1, S = ye[c | 0]) : (y = 1, S = go(o));
                                          continue;
                                        }
                                        break;
                                      }
                                      S = go(o);
                                    }
                                    if (Mn = 1, (S | 0) != 48)
                                      break s;
                                    for (; ; ) {
                                      c = ci, ci = c - 1 | 0, gi = gi - !c | 0, c = e[o + 4 >> 2];
                                      a: {
                                        if ((c | 0) != e[o + 104 >> 2]) {
                                          e[o + 4 >> 2] = c + 1, S = ye[c | 0];
                                          break a;
                                        }
                                        S = go(o);
                                      }
                                      if ((S | 0) != 48)
                                        break;
                                    }
                                    y = 1;
                                  }
                                  Ar = 1073676288;
                                  s: {
                                    for (; ; ) {
                                      a: {
                                        c = S | 32;
                                        o: {
                                          l: {
                                            if (sa = S - 48 | 0, sa >>> 0 < 10)
                                              break l;
                                            if (Ea = (S | 0) != 46, Ea & c - 97 >>> 0 > 5)
                                              break s;
                                            if (Ea)
                                              break l;
                                            if (Mn)
                                              break a;
                                            Mn = 1, ci = Fe, gi = ke;
                                            break o;
                                          }
                                          c = (S | 0) > 57 ? c - 87 | 0 : sa;
                                          l: {
                                            if ((ke | 0) <= 0 & Fe >>> 0 <= 7 | (ke | 0) < 0) {
                                              Tr = c + (Tr << 4) | 0;
                                              break l;
                                            }
                                            if (!ke & Fe >>> 0 <= 28) {
                                              Ha(g + 48 | 0, c), To(g + 32 | 0, Rs, oo, G, Ar, 0, 0, 0, 1073414144), Rs = e[g + 32 >> 2], oo = e[g + 36 >> 2], G = e[g + 40 >> 2], Ar = e[g + 44 >> 2], To(g + 16 | 0, e[g + 48 >> 2], e[g + 52 >> 2], e[g + 56 >> 2], e[g + 60 >> 2], Rs, oo, G, Ar), qa(g, e[g + 16 >> 2], e[g + 20 >> 2], e[g + 24 >> 2], e[g + 28 >> 2], hr, Rn, ss, As), ss = e[g + 8 >> 2], As = e[g + 12 >> 2], hr = e[g >> 2], Rn = e[g + 4 >> 2];
                                              break l;
                                            }
                                            if (ta | !c)
                                              break l;
                                            To(g + 80 | 0, Rs, oo, G, Ar, 0, 0, 0, 1073610752), qa(g - -64 | 0, e[g + 80 >> 2], e[g + 84 >> 2], e[g + 88 >> 2], e[g + 92 >> 2], hr, Rn, ss, As), ss = e[g + 72 >> 2], As = e[g + 76 >> 2], ta = 1, hr = e[g + 64 >> 2], Rn = e[g + 68 >> 2];
                                          }
                                          Fe = Fe + 1 | 0, ke = Fe ? ke : ke + 1 | 0, y = 1;
                                        }
                                        c = e[o + 4 >> 2], (c | 0) != e[o + 104 >> 2] ? (e[o + 4 >> 2] = c + 1, S = ye[c | 0]) : S = go(o);
                                        continue;
                                      }
                                      break;
                                    }
                                    S = 46;
                                  }
                                  s: {
                                    if (!y) {
                                      c = e[o + 116 >> 2];
                                      a: {
                                        o: {
                                          if ((c | 0) > 0 | (c | 0) >= 0) {
                                            if (c = e[o + 4 >> 2], e[o + 4 >> 2] = c - 1, !h)
                                              break o;
                                            if (e[o + 4 >> 2] = c - 2, !Mn)
                                              break a;
                                            e[o + 4 >> 2] = c - 3;
                                            break a;
                                          }
                                          if (h)
                                            break a;
                                        }
                                        du(o, 0, 0);
                                      }
                                      vu(g + 96 | 0, +(Qi | 0) * 0), hr = e[g + 96 >> 2], Rn = e[g + 100 >> 2], c = e[g + 108 >> 2], o = e[g + 104 >> 2];
                                      break s;
                                    }
                                    if ((ke | 0) <= 0 & Fe >>> 0 <= 7 | (ke | 0) < 0)
                                      for (G = Fe, Ar = ke; Tr = Tr << 4, G = G + 1 | 0, Ar = G ? Ar : Ar + 1 | 0, !!((G | 0) != 8 | Ar); )
                                        ;
                                    a: {
                                      o: {
                                        l: {
                                          if ((S & -33) == 80) {
                                            if (G = wu(o, h), c = vs, Ar = c, G | (c | 0) != -2147483648)
                                              break a;
                                            if (h) {
                                              if (c = e[o + 116 >> 2], (c | 0) > 0 | (c | 0) >= 0)
                                                break l;
                                              break o;
                                            }
                                            hr = 0, Rn = 0, du(o, 0, 0), c = 0, o = 0;
                                            break s;
                                          }
                                          if (G = 0, Ar = 0, e[o + 116 >> 2] < 0)
                                            break a;
                                        }
                                        e[o + 4 >> 2] = e[o + 4 >> 2] - 1;
                                      }
                                      G = 0, Ar = 0;
                                    }
                                    if (!Tr) {
                                      vu(g + 112 | 0, +(Qi | 0) * 0), hr = e[g + 112 >> 2], Rn = e[g + 116 >> 2], c = e[g + 124 >> 2], o = e[g + 120 >> 2];
                                      break s;
                                    }
                                    if (o = Mn ? ci : Fe, ke = (Mn ? gi : ke) << 2 | o >>> 30, c = G + (o << 2) | 0, o = ke + Ar | 0, Fe = c - 32 | 0, ke = (c >>> 0 < G >>> 0 ? o + 1 | 0 : o) - (c >>> 0 < 32) | 0, o = ke, Fe >>> 0 > 0 - Go >>> 0 & (o | 0) >= 0 | (o | 0) > 0) {
                                      e[5732] = 68, Ha(g + 160 | 0, Qi), To(g + 144 | 0, e[g + 160 >> 2], e[g + 164 >> 2], e[g + 168 >> 2], e[g + 172 >> 2], -1, -1, -1, 2147418111), To(g + 128 | 0, e[g + 144 >> 2], e[g + 148 >> 2], e[g + 152 >> 2], e[g + 156 >> 2], -1, -1, -1, 2147418111), hr = e[g + 128 >> 2], Rn = e[g + 132 >> 2], c = e[g + 140 >> 2], o = e[g + 136 >> 2];
                                      break s;
                                    }
                                    if (o = Go - 226 | 0, c = o >> 31, (ke | 0) >= (c | 0) & o >>> 0 <= Fe >>> 0 | (c | 0) < (ke | 0)) {
                                      if ((Tr | 0) >= 0)
                                        for (; qa(g + 416 | 0, hr, Rn, ss, As, 0, 0, 0, -1073807360), o = Dh(hr, Rn, ss, As, 1073610752), c = (o | 0) >= 0, o = c, qa(g + 400 | 0, hr, Rn, ss, As, o ? e[g + 416 >> 2] : hr, o ? e[g + 420 >> 2] : Rn, o ? e[g + 424 >> 2] : ss, o ? e[g + 428 >> 2] : As), o = Fe, Fe = o - 1 | 0, ke = ke - !o | 0, ss = e[g + 408 >> 2], As = e[g + 412 >> 2], hr = e[g + 400 >> 2], Rn = e[g + 404 >> 2], Tr = c | Tr << 1, (Tr | 0) >= 0; )
                                          ;
                                      o = ke - ((Go >> 31) + (Fe >>> 0 < Go >>> 0) | 0) | 0, c = (Fe - Go | 0) + 32 | 0, o = c >>> 0 < 32 ? o + 1 | 0 : o, c = c >>> 0 < Jo >>> 0 & (o | 0) <= 0 | (o | 0) < 0 ? (c | 0) > 0 ? c : 0 : Jo;
                                      a: {
                                        if ((c | 0) >= 113) {
                                          Ha(g + 384 | 0, Qi), ci = e[g + 392 >> 2], gi = e[g + 396 >> 2], Rs = e[g + 384 >> 2], oo = e[g + 388 >> 2], G = 0, o = 0;
                                          break a;
                                        }
                                        vu(g + 352 | 0, md(144 - c | 0)), Ha(g + 336 | 0, Qi), Rs = e[g + 336 >> 2], oo = e[g + 340 >> 2], ci = e[g + 344 >> 2], gi = e[g + 348 >> 2], a1(g + 368 | 0, e[g + 352 >> 2], e[g + 356 >> 2], e[g + 360 >> 2], e[g + 364 >> 2], Rs, oo, ci, gi), ln = e[g + 376 >> 2], Ji = e[g + 380 >> 2], G = e[g + 372 >> 2], o = e[g + 368 >> 2];
                                      }
                                      h = !(Tr & 1) & ((Lu(hr, Rn, ss, As, 0, 0, 0, 0) | 0) != 0 & (c | 0) < 32), Oc(g + 320 | 0, h + Tr | 0), To(g + 304 | 0, Rs, oo, ci, gi, e[g + 320 >> 2], e[g + 324 >> 2], e[g + 328 >> 2], e[g + 332 >> 2]), c = o, qa(g + 272 | 0, e[g + 304 >> 2], e[g + 308 >> 2], e[g + 312 >> 2], e[g + 316 >> 2], o, G, ln, Ji), o = h, To(g + 288 | 0, Rs, oo, ci, gi, o ? 0 : hr, o ? 0 : Rn, o ? 0 : ss, o ? 0 : As), qa(g + 256 | 0, e[g + 288 >> 2], e[g + 292 >> 2], e[g + 296 >> 2], e[g + 300 >> 2], e[g + 272 >> 2], e[g + 276 >> 2], e[g + 280 >> 2], e[g + 284 >> 2]), Ws(g + 240 | 0, e[g + 256 >> 2], e[g + 260 >> 2], e[g + 264 >> 2], e[g + 268 >> 2], c, G, ln, Ji), o = e[g + 240 >> 2], h = e[g + 244 >> 2], c = e[g + 248 >> 2], G = e[g + 252 >> 2], Lu(o, h, c, G, 0, 0, 0, 0) || (e[5732] = 68), Ah(g + 224 | 0, o, h, c, G, Fe), hr = e[g + 224 >> 2], Rn = e[g + 228 >> 2], c = e[g + 236 >> 2], o = e[g + 232 >> 2];
                                      break s;
                                    }
                                    e[5732] = 68, Ha(g + 208 | 0, Qi), To(g + 192 | 0, e[g + 208 >> 2], e[g + 212 >> 2], e[g + 216 >> 2], e[g + 220 >> 2], 0, 0, 0, 65536), To(g + 176 | 0, e[g + 192 >> 2], e[g + 196 >> 2], e[g + 200 >> 2], e[g + 204 >> 2], 0, 0, 0, 65536), hr = e[g + 176 >> 2], Rn = e[g + 180 >> 2], c = e[g + 188 >> 2], o = e[g + 184 >> 2];
                                  }
                                  e[ei + 16 >> 2] = hr, e[ei + 20 >> 2] = Rn, e[ei + 24 >> 2] = o, e[ei + 28 >> 2] = c, Yr = g + 432 | 0, Fe = e[ei + 24 >> 2], ke = e[ei + 28 >> 2], G = e[ei + 16 >> 2], Ar = e[ei + 20 >> 2];
                                  break e;
                                }
                                if (e[o + 116 >> 2] < 0)
                                  break i;
                                e[o + 4 >> 2] = e[o + 4 >> 2] - 1;
                              }
                              S = o, Tr = c, g = h, h = 0, y = Yr - 8976 | 0, Yr = y, Ea = 0 - Go | 0, sa = Ea - Jo | 0;
                              i: {
                                s: {
                                  for (; ; ) {
                                    if ((Tr | 0) != 48)
                                      a: {
                                        if ((Tr | 0) != 46)
                                          break i;
                                        if (o = e[S + 4 >> 2], (o | 0) == e[S + 104 >> 2])
                                          break a;
                                        e[S + 4 >> 2] = o + 1, Tr = ye[o | 0];
                                        break s;
                                      }
                                    else {
                                      o = e[S + 4 >> 2], (o | 0) != e[S + 104 >> 2] ? (e[S + 4 >> 2] = o + 1, Tr = ye[o | 0]) : Tr = go(S), h = 1;
                                      continue;
                                    }
                                    break;
                                  }
                                  Tr = go(S);
                                }
                                if (ta = 1, (Tr | 0) != 48)
                                  break i;
                                for (; ; ) {
                                  o = Fe, Fe = o - 1 | 0, ke = ke - !o | 0, o = e[S + 4 >> 2];
                                  s: {
                                    if ((o | 0) != e[S + 104 >> 2]) {
                                      e[S + 4 >> 2] = o + 1, Tr = ye[o | 0];
                                      break s;
                                    }
                                    Tr = go(S);
                                  }
                                  if ((Tr | 0) != 48)
                                    break;
                                }
                                h = 1;
                              }
                              e[y + 784 >> 2] = 0;
                              i: {
                                s: {
                                  o = (Tr | 0) == 46, c = Tr - 48 | 0;
                                  a: {
                                    o: {
                                      l: {
                                        if (o | c >>> 0 <= 9)
                                          for (; ; ) {
                                            f: {
                                              if (o & 1) {
                                                if (!ta) {
                                                  Fe = G, ke = Ar, ta = 1;
                                                  break f;
                                                }
                                                o = !h;
                                                break l;
                                              }
                                              if (G = G + 1 | 0, Ar = G ? Ar : Ar + 1 | 0, (Mn | 0) <= 2044) {
                                                Ji = (Tr | 0) == 48 ? Ji : G, o = (y + 784 | 0) + (Mn << 2) | 0, ln && (c = (vi(e[o >> 2], 10) + Tr | 0) - 48 | 0), e[o >> 2] = c, h = 1, c = ln + 1 | 0, o = (c | 0) == 9, ln = o ? 0 : c, Mn = o + Mn | 0;
                                                break f;
                                              }
                                              if ((Tr | 0) == 48)
                                                break f;
                                              e[y + 8960 >> 2] = e[y + 8960 >> 2] | 1, Ji = 18396;
                                            }
                                            o = e[S + 4 >> 2];
                                            f: {
                                              if ((o | 0) != e[S + 104 >> 2]) {
                                                e[S + 4 >> 2] = o + 1, Tr = ye[o | 0];
                                                break f;
                                              }
                                              Tr = go(S);
                                            }
                                            if (o = (Tr | 0) == 46, c = Tr - 48 | 0, !(o | c >>> 0 < 10))
                                              break;
                                          }
                                        if (Fe = ta ? Fe : G, ke = ta ? ke : Ar, !(!h | (Tr & -33) != 69)) {
                                          hr = wu(S, g), o = vs, Rn = o;
                                          f: {
                                            if (hr | (o | 0) != -2147483648)
                                              break f;
                                            if (!g)
                                              break a;
                                            if (hr = 0, Rn = 0, e[S + 116 >> 2] < 0)
                                              break f;
                                            e[S + 4 >> 2] = e[S + 4 >> 2] - 1;
                                          }
                                          ke = ke + Rn | 0, Fe = Fe + hr | 0, ke = Fe >>> 0 < hr >>> 0 ? ke + 1 | 0 : ke;
                                          break s;
                                        }
                                        if (o = !h, (Tr | 0) < 0)
                                          break o;
                                      }
                                      if (e[S + 116 >> 2] < 0)
                                        break o;
                                      e[S + 4 >> 2] = e[S + 4 >> 2] - 1;
                                    }
                                    if (!o)
                                      break s;
                                    e[5732] = 28;
                                  }
                                  G = 0, Ar = 0, du(S, 0, 0), c = 0, o = 0;
                                  break i;
                                }
                                if (o = e[y + 784 >> 2], !o) {
                                  vu(y, +(Qi | 0) * 0), G = e[y >> 2], Ar = e[y + 4 >> 2], c = e[y + 12 >> 2], o = e[y + 8 >> 2];
                                  break i;
                                }
                                if (!(G >>> 0 > 9 & (Ar | 0) >= 0 | (Ar | 0) > 0 | ((G | 0) != (Fe | 0) | (ke | 0) != (Ar | 0)) | (o >>> Jo | 0 ? (Jo | 0) <= 30 : 0))) {
                                  Ha(y + 48 | 0, Qi), Oc(y + 32 | 0, o), To(y + 16 | 0, e[y + 48 >> 2], e[y + 52 >> 2], e[y + 56 >> 2], e[y + 60 >> 2], e[y + 32 >> 2], e[y + 36 >> 2], e[y + 40 >> 2], e[y + 44 >> 2]), G = e[y + 16 >> 2], Ar = e[y + 20 >> 2], c = e[y + 28 >> 2], o = e[y + 24 >> 2];
                                  break i;
                                }
                                if (Fe >>> 0 > Ea >>> 1 >>> 0 & (ke | 0) >= 0 | (ke | 0) > 0) {
                                  e[5732] = 68, Ha(y + 96 | 0, Qi), To(y + 80 | 0, e[y + 96 >> 2], e[y + 100 >> 2], e[y + 104 >> 2], e[y + 108 >> 2], -1, -1, -1, 2147418111), To(y - -64 | 0, e[y + 80 >> 2], e[y + 84 >> 2], e[y + 88 >> 2], e[y + 92 >> 2], -1, -1, -1, 2147418111), G = e[y + 64 >> 2], Ar = e[y + 68 >> 2], c = e[y + 76 >> 2], o = e[y + 72 >> 2];
                                  break i;
                                }
                                if (o = Go - 226 | 0, c = Fe >>> 0 < o >>> 0, o = o >> 31, c & (ke | 0) <= (o | 0) | (o | 0) > (ke | 0)) {
                                  e[5732] = 68, Ha(y + 144 | 0, Qi), To(y + 128 | 0, e[y + 144 >> 2], e[y + 148 >> 2], e[y + 152 >> 2], e[y + 156 >> 2], 0, 0, 0, 65536), To(y + 112 | 0, e[y + 128 >> 2], e[y + 132 >> 2], e[y + 136 >> 2], e[y + 140 >> 2], 0, 0, 0, 65536), G = e[y + 112 >> 2], Ar = e[y + 116 >> 2], c = e[y + 124 >> 2], o = e[y + 120 >> 2];
                                  break i;
                                }
                                if (ln) {
                                  if ((ln | 0) <= 8) {
                                    for (o = (y + 784 | 0) + (Mn << 2) | 0, S = e[o >> 2]; S = vi(S, 10), ln = ln + 1 | 0, (ln | 0) != 9; )
                                      ;
                                    e[o >> 2] = S;
                                  }
                                  Mn = Mn + 1 | 0;
                                }
                                ln = Fe;
                                s: {
                                  if ((Fe | 0) < (Ji | 0) | (Ji | 0) >= 9 | (Fe | 0) > 17)
                                    break s;
                                  if ((Fe | 0) == 9) {
                                    Ha(y + 192 | 0, Qi), Oc(y + 176 | 0, e[y + 784 >> 2]), To(y + 160 | 0, e[y + 192 >> 2], e[y + 196 >> 2], e[y + 200 >> 2], e[y + 204 >> 2], e[y + 176 >> 2], e[y + 180 >> 2], e[y + 184 >> 2], e[y + 188 >> 2]), G = e[y + 160 >> 2], Ar = e[y + 164 >> 2], c = e[y + 172 >> 2], o = e[y + 168 >> 2];
                                    break i;
                                  }
                                  if ((ln | 0) <= 8) {
                                    Ha(y + 272 | 0, Qi), Oc(y + 256 | 0, e[y + 784 >> 2]), To(y + 240 | 0, e[y + 272 >> 2], e[y + 276 >> 2], e[y + 280 >> 2], e[y + 284 >> 2], e[y + 256 >> 2], e[y + 260 >> 2], e[y + 264 >> 2], e[y + 268 >> 2]), Ha(y + 224 | 0, e[(0 - ln << 2) + 8960 >> 2]), Dl(y + 208 | 0, e[y + 240 >> 2], e[y + 244 >> 2], e[y + 248 >> 2], e[y + 252 >> 2], e[y + 224 >> 2], e[y + 228 >> 2], e[y + 232 >> 2], e[y + 236 >> 2]), G = e[y + 208 >> 2], Ar = e[y + 212 >> 2], c = e[y + 220 >> 2], o = e[y + 216 >> 2];
                                    break i;
                                  }
                                  if (o = (vi(ln, -3) + Jo | 0) + 27 | 0, c = e[y + 784 >> 2], c >>> o | 0 && (o | 0) <= 30)
                                    break s;
                                  Ha(y + 352 | 0, Qi), Oc(y + 336 | 0, c), To(y + 320 | 0, e[y + 352 >> 2], e[y + 356 >> 2], e[y + 360 >> 2], e[y + 364 >> 2], e[y + 336 >> 2], e[y + 340 >> 2], e[y + 344 >> 2], e[y + 348 >> 2]), Ha(y + 304 | 0, e[(ln << 2) + 8888 >> 2]), To(y + 288 | 0, e[y + 320 >> 2], e[y + 324 >> 2], e[y + 328 >> 2], e[y + 332 >> 2], e[y + 304 >> 2], e[y + 308 >> 2], e[y + 312 >> 2], e[y + 316 >> 2]), G = e[y + 288 >> 2], Ar = e[y + 292 >> 2], c = e[y + 300 >> 2], o = e[y + 296 >> 2];
                                  break i;
                                }
                                for (; o = Mn, Mn = o - 1 | 0, !e[(y + 784 | 0) + (Mn << 2) >> 2]; )
                                  ;
                                Ji = 0, h = (ln | 0) % 9 | 0;
                                s: {
                                  if (!h) {
                                    c = 0;
                                    break s;
                                  }
                                  c = 0, h = (ln | 0) < 0 ? h + 9 | 0 : h;
                                  a: {
                                    if (!o) {
                                      o = 0;
                                      break a;
                                    }
                                    for (Fe = e[(0 - h << 2) + 8960 >> 2], hr = 1e9 / (Fe | 0) | 0, Tr = 0, S = 0; G = Tr, ke = y + 784 | 0, Ar = ke + (S << 2) | 0, Tr = e[Ar >> 2], Mn = (Tr >>> 0) / (Fe >>> 0) | 0, G = G + Mn | 0, e[Ar >> 2] = G, G = !G & (c | 0) == (S | 0), c = G ? c + 1 & 2047 : c, ln = G ? ln - 9 | 0 : ln, Tr = vi(hr, Tr - vi(Fe, Mn) | 0), S = S + 1 | 0, (S | 0) != (o | 0); )
                                      ;
                                    if (!Tr)
                                      break a;
                                    e[ke + (o << 2) >> 2] = Tr, o = o + 1 | 0;
                                  }
                                  ln = (ln - h | 0) + 9 | 0;
                                }
                                for (; ; ) {
                                  S = (y + 784 | 0) + (c << 2) | 0;
                                  s: {
                                    for (; ; ) {
                                      a: {
                                        if ((ln | 0) < 36)
                                          break a;
                                        if ((ln | 0) != 36)
                                          break s;
                                        if (Ps[S >> 2] <= 10384592)
                                          break a;
                                        ln = 36;
                                        break s;
                                      }
                                      for (Mn = o + 2047 | 0, h = 0; G = o, hr = Mn & 2047, Tr = (y + 784 | 0) + (hr << 2) | 0, o = e[Tr >> 2], Ar = o >>> 3 | 0, Fe = h, h = o << 29, Fe = Fe + h | 0, o = Ar, ke = h >>> 0 > Fe >>> 0 ? o + 1 | 0 : o, !ke & Fe >>> 0 < 1000000001 ? h = 0 : (h = _l(Fe, ke, 1e9), o = so(h, vs, -1e9, -1), Fe = o + Fe | 0), e[Tr >> 2] = Fe, o = (c | 0) == (hr | 0) || Fe ? G : hr, Fe = G - 1 & 2047, o = (Fe | 0) != (hr | 0) ? G : o, Mn = hr - 1 | 0, (c | 0) != (hr | 0); )
                                        ;
                                      if (Ji = Ji - 29 | 0, o = G, !!h)
                                        break;
                                    }
                                    c = c - 1 & 2047, (c | 0) == (o | 0) && (S = (o + 2046 & 2047) << 2, o = y + 784 | 0, G = S + o | 0, e[G >> 2] = e[G >> 2] | e[o + (Fe << 2) >> 2], o = Fe), ln = ln + 9 | 0, e[(y + 784 | 0) + (c << 2) >> 2] = h;
                                    continue;
                                  }
                                  break;
                                }
                                s: {
                                  a: for (; ; ) {
                                    for (Fe = o + 1 & 2047, hr = (y + 784 | 0) + ((o - 1 & 2047) << 2) | 0; ; ) {
                                      G = (ln | 0) > 45 ? 9 : 1;
                                      o: {
                                        for (; ; ) {
                                          h = c, S = 0;
                                          l: {
                                            for (; ; ) {
                                              f: {
                                                if (c = h + S & 2047, (c | 0) == (o | 0) || (c = e[(y + 784 | 0) + (c << 2) >> 2], ke = e[(S << 2) + 8912 >> 2], c >>> 0 < ke >>> 0))
                                                  break f;
                                                if (c >>> 0 > ke >>> 0)
                                                  break l;
                                                if (S = S + 1 | 0, (S | 0) != 4)
                                                  continue;
                                              }
                                              break;
                                            }
                                            if ((ln | 0) != 36)
                                              break l;
                                            for (S = 0, Fe = 0, ke = 0, G = 0, Ar = 0; c = h + S & 2047, (c | 0) == (o | 0) && (o = o + 1 & 2047, e[(y + (o << 2) | 0) + 780 >> 2] = 0), Oc(y + 768 | 0, e[(y + 784 | 0) + (c << 2) >> 2]), To(y + 752 | 0, Fe, ke, G, Ar, 0, 0, 1342177280, 1075633366), qa(y + 736 | 0, e[y + 752 >> 2], e[y + 756 >> 2], e[y + 760 >> 2], e[y + 764 >> 2], e[y + 768 >> 2], e[y + 772 >> 2], e[y + 776 >> 2], e[y + 780 >> 2]), G = e[y + 744 >> 2], Ar = e[y + 748 >> 2], Fe = e[y + 736 >> 2], ke = e[y + 740 >> 2], S = S + 1 | 0, (S | 0) != 4; )
                                              ;
                                            if (Ha(y + 720 | 0, Qi), To(y + 704 | 0, Fe, ke, G, Ar, e[y + 720 >> 2], e[y + 724 >> 2], e[y + 728 >> 2], e[y + 732 >> 2]), G = e[y + 712 >> 2], Ar = e[y + 716 >> 2], Fe = 0, ke = 0, hr = e[y + 704 >> 2], Rn = e[y + 708 >> 2], Mn = Ji + 113 | 0, S = Mn - Go | 0, Tr = (S | 0) < (Jo | 0), c = Tr ? (S | 0) > 0 ? S : 0 : Jo, (c | 0) <= 112)
                                              break o;
                                            break s;
                                          }
                                          if (Ji = G + Ji | 0, c = o, (o | 0) != (h | 0))
                                            break;
                                        }
                                        for (Ar = 1e9 >>> G | 0, Tr = -1 << G ^ -1, S = 0, c = h; ke = S, Mn = y + 784 | 0, S = Mn + (h << 2) | 0, g = e[S >> 2], ke = ke + (g >>> G | 0) | 0, e[S >> 2] = ke, ke = !ke & (c | 0) == (h | 0), c = ke ? c + 1 & 2047 : c, ln = ke ? ln - 9 | 0 : ln, S = vi(Ar, g & Tr), h = h + 1 & 2047, (h | 0) != (o | 0); )
                                          ;
                                        if (!S)
                                          continue;
                                        if ((c | 0) != (Fe | 0)) {
                                          e[Mn + (o << 2) >> 2] = S, o = Fe;
                                          continue a;
                                        }
                                        e[hr >> 2] = e[hr >> 2] | 1;
                                        continue;
                                      }
                                      break;
                                    }
                                    break;
                                  }
                                  vu(y + 656 | 0, md(225 - c | 0)), a1(y + 688 | 0, e[y + 656 >> 2], e[y + 660 >> 2], e[y + 664 >> 2], e[y + 668 >> 2], hr, Rn, G, Ar), Rs = e[y + 696 >> 2], oo = e[y + 700 >> 2], ss = e[y + 688 >> 2], As = e[y + 692 >> 2], vu(y + 640 | 0, md(113 - c | 0)), Ql(y + 672 | 0, hr, Rn, G, Ar, e[y + 640 >> 2], e[y + 644 >> 2], e[y + 648 >> 2], e[y + 652 >> 2]), Fe = e[y + 672 >> 2], ke = e[y + 676 >> 2], ci = e[y + 680 >> 2], gi = e[y + 684 >> 2], Ws(y + 624 | 0, hr, Rn, G, Ar, Fe, ke, ci, gi), qa(y + 608 | 0, ss, As, Rs, oo, e[y + 624 >> 2], e[y + 628 >> 2], e[y + 632 >> 2], e[y + 636 >> 2]), G = e[y + 616 >> 2], Ar = e[y + 620 >> 2], hr = e[y + 608 >> 2], Rn = e[y + 612 >> 2];
                                }
                                ln = h + 4 & 2047;
                                s: {
                                  if ((ln | 0) == (o | 0))
                                    break s;
                                  ln = e[(y + 784 | 0) + (ln << 2) >> 2];
                                  a: {
                                    if (ln >>> 0 <= 499999999) {
                                      if (!ln & (h + 5 & 2047) == (o | 0))
                                        break a;
                                      vu(y + 496 | 0, +(Qi | 0) * 0.25), qa(y + 480 | 0, Fe, ke, ci, gi, e[y + 496 >> 2], e[y + 500 >> 2], e[y + 504 >> 2], e[y + 508 >> 2]), ci = e[y + 488 >> 2], gi = e[y + 492 >> 2], Fe = e[y + 480 >> 2], ke = e[y + 484 >> 2];
                                      break a;
                                    }
                                    if ((ln | 0) != 5e8) {
                                      vu(y + 592 | 0, +(Qi | 0) * 0.75), qa(y + 576 | 0, Fe, ke, ci, gi, e[y + 592 >> 2], e[y + 596 >> 2], e[y + 600 >> 2], e[y + 604 >> 2]), ci = e[y + 584 >> 2], gi = e[y + 588 >> 2], Fe = e[y + 576 >> 2], ke = e[y + 580 >> 2];
                                      break a;
                                    }
                                    if (Wa = +(Qi | 0), (h + 5 & 2047) == (o | 0)) {
                                      vu(y + 528 | 0, Wa * 0.5), qa(y + 512 | 0, Fe, ke, ci, gi, e[y + 528 >> 2], e[y + 532 >> 2], e[y + 536 >> 2], e[y + 540 >> 2]), ci = e[y + 520 >> 2], gi = e[y + 524 >> 2], Fe = e[y + 512 >> 2], ke = e[y + 516 >> 2];
                                      break a;
                                    }
                                    vu(y + 560 | 0, Wa * 0.75), qa(y + 544 | 0, Fe, ke, ci, gi, e[y + 560 >> 2], e[y + 564 >> 2], e[y + 568 >> 2], e[y + 572 >> 2]), ci = e[y + 552 >> 2], gi = e[y + 556 >> 2], Fe = e[y + 544 >> 2], ke = e[y + 548 >> 2];
                                  }
                                  if ((c | 0) > 111 || (Ql(y + 464 | 0, Fe, ke, ci, gi, 0, 0, 0, 1073676288), Lu(e[y + 464 >> 2], e[y + 468 >> 2], e[y + 472 >> 2], e[y + 476 >> 2], 0, 0, 0, 0)))
                                    break s;
                                  qa(y + 448 | 0, Fe, ke, ci, gi, 0, 0, 0, 1073676288), ci = e[y + 456 >> 2], gi = e[y + 460 >> 2], Fe = e[y + 448 >> 2], ke = e[y + 452 >> 2];
                                }
                                qa(y + 432 | 0, hr, Rn, G, Ar, Fe, ke, ci, gi), Ws(y + 416 | 0, e[y + 432 >> 2], e[y + 436 >> 2], e[y + 440 >> 2], e[y + 444 >> 2], ss, As, Rs, oo), G = e[y + 424 >> 2], Ar = e[y + 428 >> 2], hr = e[y + 416 >> 2], Rn = e[y + 420 >> 2];
                                s: {
                                  if ((sa - 2 | 0) >= (Mn & 2147483647) || (e[y + 408 >> 2] = G, e[y + 412 >> 2] = Ar & 2147483647, e[y + 400 >> 2] = hr, e[y + 404 >> 2] = Rn, To(y + 384 | 0, hr, Rn, G, Ar, 0, 0, 0, 1073610752), h = Dh(e[y + 400 >> 2], e[y + 404 >> 2], e[y + 408 >> 2], e[y + 412 >> 2], 1081081856), o = (h | 0) >= 0, G = o ? e[y + 392 >> 2] : G, Ar = o ? e[y + 396 >> 2] : Ar, hr = o ? e[y + 384 >> 2] : hr, Rn = o ? e[y + 388 >> 2] : Rn, Ji = o + Ji | 0, !(Tr & ((c | 0) != (S | 0) | (h | 0) < 0) & (Lu(Fe, ke, ci, gi, 0, 0, 0, 0) | 0) != 0) & (Ji + 110 | 0) <= (sa | 0)))
                                    break s;
                                  e[5732] = 68;
                                }
                                Ah(y + 368 | 0, hr, Rn, G, Ar, Ji), G = e[y + 368 >> 2], Ar = e[y + 372 >> 2], c = e[y + 380 >> 2], o = e[y + 376 >> 2];
                              }
                              e[ei + 40 >> 2] = o, e[ei + 44 >> 2] = c, e[ei + 32 >> 2] = G, e[ei + 36 >> 2] = Ar, Yr = y + 8976 | 0, Fe = e[ei + 40 >> 2], ke = e[ei + 44 >> 2], G = e[ei + 32 >> 2], Ar = e[ei + 36 >> 2];
                              break e;
                            case 3:
                              break r;
                            default:
                              break n;
                          }
                        c = e[o + 116 >> 2], (c | 0) > 0 | (c | 0) >= 0 && (e[o + 4 >> 2] = e[o + 4 >> 2] - 1);
                        break t;
                      }
                      r: {
                        c = e[o + 4 >> 2];
                        n: {
                          if ((c | 0) != e[o + 104 >> 2]) {
                            e[o + 4 >> 2] = c + 1, c = ye[c | 0];
                            break n;
                          }
                          c = go(o);
                        }
                        if ((c | 0) == 40) {
                          S = 1;
                          break r;
                        }
                        if (ke = 2147450880, e[o + 116 >> 2] < 0)
                          break e;
                        e[o + 4 >> 2] = e[o + 4 >> 2] - 1;
                        break e;
                      }
                      for (; ; ) {
                        r: {
                          c = e[o + 4 >> 2];
                          n: {
                            if ((c | 0) != e[o + 104 >> 2]) {
                              e[o + 4 >> 2] = c + 1, c = ye[c | 0];
                              break n;
                            }
                            c = go(o);
                          }
                          if (!(c - 48 >>> 0 < 10 | c - 65 >>> 0 < 26 | (c | 0) == 95) && c - 97 >>> 0 >= 26)
                            break r;
                          S = S + 1 | 0;
                          continue;
                        }
                        break;
                      }
                      if (ke = 2147450880, (c | 0) == 41)
                        break e;
                      c = e[o + 116 >> 2], (c | 0) > 0 | (c | 0) >= 0 && (e[o + 4 >> 2] = e[o + 4 >> 2] - 1);
                      r: {
                        if (h) {
                          if (S)
                            break r;
                          break e;
                        }
                        break t;
                      }
                      for (; (c | 0) > 0 | (c | 0) >= 0 && (e[o + 4 >> 2] = e[o + 4 >> 2] - 1), S = S - 1 | 0, !!S; )
                        ;
                      break e;
                    }
                    e[5732] = 28, du(o, 0, 0);
                  }
                  ke = 0;
                }
                e[r >> 2] = G, e[r + 4 >> 2] = Ar, e[r + 8 >> 2] = Fe, e[r + 12 >> 2] = ke, Yr = ei + 48 | 0;
              }
              function nf(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0;
                c = Yr - 112 | 0, Yr = c, g = e[o >> 2], y = g, ke = e[o + 4 >> 2];
                e: {
                  if (!ke)
                    break e;
                  for (h = g + ke | 0; ; ) {
                    S = ye[y | 0];
                    t: {
                      if (!((S | 0) != 123 & (S | 0) != 40)) {
                        G = G + 1 | 0;
                        break t;
                      }
                      if (G) {
                        if ((S | 0) != 125 & (S | 0) != 41)
                          break t;
                        G = G - 1 | 0;
                        break t;
                      }
                      G = 0;
                      r:
                        switch (S - 41 | 0) {
                          case 0:
                          case 3:
                            break e;
                          case 1:
                          case 2:
                            break t;
                          default:
                            break r;
                        }
                      if ((S | 0) == 125)
                        break e;
                    }
                    if (y = y + 1 | 0, (h | 0) == (y | 0))
                      break;
                  }
                  y = h;
                }
                e[c + 104 >> 2] = g, h = y - g | 0, e[c + 108 >> 2] = h, e[o + 4 >> 2] = ke - h, e[o >> 2] = y, $[c + 18 | 0] = 0, Vs[c + 16 >> 1] = 27504, $[c + 27 | 0] = 2;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            a: {
                              o: {
                                if (ye[g + 2 | 0] != 40 | h >>> 0 < 4 | (ye[(h + g | 0) - 1 | 0] != 41 | ye[c + 16 | 0] != ye[g | 0]) || ye[c + 17 | 0] != ye[g + 1 | 0])
                                  break o;
                                if (o = h - 4 | 0, e[c + 108 >> 2] = o, h = g + 3 | 0, e[c + 104 >> 2] = h, !(!o | (o | 0) > 17)) {
                                  if (o >>> 0 >= 2147483632)
                                    break n;
                                  l: {
                                    if (o >>> 0 <= 10) {
                                      $[c + 27 | 0] = o, G = c + 16 | 0;
                                      break l;
                                    }
                                    y = (o | 15) + 1 | 0, G = xs(y), e[c + 24 >> 2] = y | -2147483648, e[c + 16 >> 2] = G, e[c + 20 >> 2] = o;
                                  }
                                  if ($[_s(G, h, o) + o | 0] = 0, e[c + 88 >> 2] = e[c + 20 >> 2], o = ye[c + 23 | 0] | ye[c + 24 | 0] << 8 | (ye[c + 25 | 0] << 16 | ye[c + 26 | 0] << 24), $[c + 91 | 0] = o, $[c + 92 | 0] = o >>> 8, $[c + 93 | 0] = o >>> 16, $[c + 94 | 0] = o >>> 24, e[5996] = 0, h = e[c + 16 >> 2], g = $[c + 27 | 0], e[c + 24 >> 2] = 0, e[c + 16 >> 2] = 0, e[c + 20 >> 2] = 0, o = ii(3, 12) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1) {
                                    e[o >> 2] = h, e[o + 4 >> 2] = e[c + 88 >> 2], h = ye[c + 91 | 0] | ye[c + 92 | 0] << 8 | (ye[c + 93 | 0] << 16 | ye[c + 94 | 0] << 24), $[o + 7 | 0] = h, $[o + 8 | 0] = h >>> 8, $[o + 9 | 0] = h >>> 16, $[o + 10 | 0] = h >>> 24, $[o + 11 | 0] = g, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[r >> 2] = 1, e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, h = o + 12 | 0, e[r + 36 >> 2] = h, e[r + 32 >> 2] = h, e[r + 28 >> 2] = o, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0;
                                    break i;
                                  }
                                  if (y = Vr() | 0, Wo(c + 16 | 0), (g | 0) >= 0)
                                    break a;
                                  Sr(h), Ki(y | 0), ri();
                                }
                                e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                break i;
                              }
                              $[c + 21 | 0] = 0, $[c + 20 | 0] = ye[1777], $[c + 27 | 0] = 5, e[c + 16 >> 2] = ye[1773] | ye[1774] << 8 | (ye[1775] << 16 | ye[1776] << 24);
                              o: {
                                if (o = h >>> 0 < 7, o | ye[g + 5 | 0] != 40 | (ye[(h + g | 0) - 1 | 0] != 41 | ye[c + 16 | 0] != ye[g | 0]) || ye[c + 17 | 0] != ye[g + 1 | 0] | ye[c + 18 | 0] != ye[g + 2 | 0] | (ye[c + 19 | 0] != ye[g + 3 | 0] | ye[c + 20 | 0] != ye[g + 4 | 0]))
                                  break o;
                                if (S = h - 7 | 0, e[c + 108 >> 2] = S, h = g + 6 | 0, e[c + 104 >> 2] = h, S >>> 0 >= 2147483632)
                                  break n;
                                l: {
                                  f: {
                                    if (S >>> 0 >= 11) {
                                      o = (S | 15) + 1 | 0, y = xs(o), e[c + 24 >> 2] = o | -2147483648, e[c + 16 >> 2] = y, e[c + 20 >> 2] = S;
                                      break f;
                                    }
                                    if ($[c + 27 | 0] = S, y = c + 16 | 0, !S)
                                      break l;
                                  }
                                  g = S - 1 | 0, ke = S & 7;
                                  f: {
                                    if (!ke) {
                                      o = h;
                                      break f;
                                    }
                                    for (G = 0, o = h; $[y | 0] = ye[o | 0], y = y + 1 | 0, o = o + 1 | 0, G = G + 1 | 0, (ke | 0) != (G | 0); )
                                      ;
                                  }
                                  if (g >>> 0 < 7)
                                    break l;
                                  for (h = h + S | 0; $[y | 0] = ye[o | 0], $[y + 1 | 0] = ye[o + 1 | 0], $[y + 2 | 0] = ye[o + 2 | 0], $[y + 3 | 0] = ye[o + 3 | 0], $[y + 4 | 0] = ye[o + 4 | 0], $[y + 5 | 0] = ye[o + 5 | 0], $[y + 6 | 0] = ye[o + 6 | 0], $[y + 7 | 0] = ye[o + 7 | 0], y = y + 8 | 0, o = o + 8 | 0, (h | 0) != (o | 0); )
                                    ;
                                }
                                if ($[y | 0] = 0, o = ud(c + 16 | 0, c + 88 | 0), $[c + 27 | 0] < 0 && Sr(e[c + 16 >> 2]), !o) {
                                  e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                  break i;
                                }
                                if (o = e[c + 88 >> 2], h = o - 1 | 0, e[c + 92 >> 2] == (!o | 0) & h >>> 0 <= 2147483646) {
                                  e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[r >> 2] = 3, e[r + 52 >> 2] = o, e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 48 >> 2] = 0;
                                  break i;
                                }
                                e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                break i;
                              }
                              $[c + 21 | 0] = 0, $[c + 20 | 0] = ye[1783], $[c + 27 | 0] = 5, e[c + 16 >> 2] = ye[1779] | ye[1780] << 8 | (ye[1781] << 16 | ye[1782] << 24);
                              o: {
                                if (ye[g + 5 | 0] != 40 | o | (ye[(h + g | 0) - 1 | 0] != 41 | ye[c + 16 | 0] != ye[g | 0]) || ye[c + 17 | 0] != ye[g + 1 | 0] | ye[c + 18 | 0] != ye[g + 2 | 0] | (ye[c + 19 | 0] != ye[g + 3 | 0] | ye[c + 20 | 0] != ye[g + 4 | 0]))
                                  break o;
                                if (S = h - 7 | 0, e[c + 108 >> 2] = S, h = g + 6 | 0, e[c + 104 >> 2] = h, S >>> 0 >= 2147483632)
                                  break n;
                                l: {
                                  f: {
                                    if (S >>> 0 >= 11) {
                                      o = (S | 15) + 1 | 0, y = xs(o), e[c + 24 >> 2] = o | -2147483648, e[c + 16 >> 2] = y, e[c + 20 >> 2] = S;
                                      break f;
                                    }
                                    if ($[c + 27 | 0] = S, y = c + 16 | 0, !S)
                                      break l;
                                  }
                                  g = S - 1 | 0, ke = S & 7;
                                  f: {
                                    if (!ke) {
                                      o = h;
                                      break f;
                                    }
                                    for (G = 0, o = h; $[y | 0] = ye[o | 0], y = y + 1 | 0, o = o + 1 | 0, G = G + 1 | 0, (ke | 0) != (G | 0); )
                                      ;
                                  }
                                  if (g >>> 0 < 7)
                                    break l;
                                  for (h = h + S | 0; $[y | 0] = ye[o | 0], $[y + 1 | 0] = ye[o + 1 | 0], $[y + 2 | 0] = ye[o + 2 | 0], $[y + 3 | 0] = ye[o + 3 | 0], $[y + 4 | 0] = ye[o + 4 | 0], $[y + 5 | 0] = ye[o + 5 | 0], $[y + 6 | 0] = ye[o + 6 | 0], $[y + 7 | 0] = ye[o + 7 | 0], y = y + 8 | 0, o = o + 8 | 0, (h | 0) != (o | 0); )
                                    ;
                                }
                                if ($[y | 0] = 0, o = ud(c + 16 | 0, c + 88 | 0), $[c + 27 | 0] < 0 && Sr(e[c + 16 >> 2]), !o) {
                                  e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                  break i;
                                }
                                if (o = e[c + 88 >> 2], h = o - 1 | 0, e[c + 92 >> 2] == (!o | 0) & h >>> 0 <= 2147483646) {
                                  e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[r >> 2] = 2, e[r + 52 >> 2] = o, e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 48 >> 2] = 0;
                                  break i;
                                }
                                e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                break i;
                              }
                              $[c + 22 | 0] = 0, Vs[c + 20 >> 1] = ye[3881] | ye[3882] << 8, $[c + 27 | 0] = 6, e[c + 16 >> 2] = ye[3877] | ye[3878] << 8 | (ye[3879] << 16 | ye[3880] << 24);
                              o: {
                                if (ye[g + 6 | 0] != 40 | h >>> 0 < 8 | (ye[(h + g | 0) - 1 | 0] != 41 | ye[c + 16 | 0] != ye[g | 0]) || ye[c + 17 | 0] != ye[g + 1 | 0] | ye[c + 18 | 0] != ye[g + 2 | 0] | (ye[c + 19 | 0] != ye[g + 3 | 0] | ye[c + 20 | 0] != ye[g + 4 | 0]) || ye[c + 21 | 0] != ye[g + 5 | 0])
                                  break o;
                                if (o = h - 8 | 0, e[c + 108 >> 2] = o, h = g + 7 | 0, e[c + 104 >> 2] = h, Af(c + 16 | 0, h, o, 32), o = e[c + 20 >> 2], h = e[c + 16 >> 2], (o | 0) != (h | 0)) {
                                  e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[r >> 2] = 7, e[r + 16 >> 2] = h, e[r + 12 >> 2] = 0, e[r + 20 >> 2] = o, o = e[c + 24 >> 2], e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 24 >> 2] = o, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0;
                                  break i;
                                }
                                if (e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, !o)
                                  break i;
                                Sr(o);
                                break i;
                              }
                              $[c + 25 | 0] = 0, $[c + 24 | 0] = ye[4198], $[c + 27 | 0] = 9, o = ye[4194] | ye[4195] << 8 | (ye[4196] << 16 | ye[4197] << 24), e[c + 16 >> 2] = ye[4190] | ye[4191] << 8 | (ye[4192] << 16 | ye[4193] << 24), e[c + 20 >> 2] = o;
                              o: {
                                if (ye[g + 9 | 0] != 40 | h >>> 0 < 11 | (ye[(h + g | 0) - 1 | 0] != 41 | ye[c + 16 | 0] != ye[g | 0]) || ye[c + 17 | 0] != ye[g + 1 | 0] | ye[c + 18 | 0] != ye[g + 2 | 0] | (ye[c + 19 | 0] != ye[g + 3 | 0] | ye[c + 20 | 0] != ye[g + 4 | 0]) || ye[c + 21 | 0] != ye[g + 5 | 0] | ye[c + 22 | 0] != ye[g + 6 | 0] | (ye[c + 23 | 0] != ye[g + 7 | 0] | ye[c + 24 | 0] != ye[g + 8 | 0]))
                                  break o;
                                if (o = h - 11 | 0, e[c + 108 >> 2] = o, h = g + 10 | 0, e[c + 104 >> 2] = h, Af(c + 16 | 0, h, o, 20), o = e[c + 20 >> 2], h = e[c + 16 >> 2], (o | 0) != (h | 0)) {
                                  e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[r >> 2] = 6, e[r + 16 >> 2] = h, e[r + 12 >> 2] = 0, e[r + 20 >> 2] = o, o = e[c + 24 >> 2], e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 24 >> 2] = o, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0;
                                  break i;
                                }
                                if (e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, !o)
                                  break i;
                                Sr(o);
                                break i;
                              }
                              $[c + 27 | 0] = 7, $[c + 23 | 0] = 0, e[c + 16 >> 2] = ye[3869] | ye[3870] << 8 | (ye[3871] << 16 | ye[3872] << 24), o = ye[3872] | ye[3873] << 8 | (ye[3874] << 16 | ye[3875] << 24), $[c + 19 | 0] = o, $[c + 20 | 0] = o >>> 8, $[c + 21 | 0] = o >>> 16, $[c + 22 | 0] = o >>> 24;
                              o: {
                                if (ye[g + 7 | 0] != 40 | h >>> 0 < 9 | (ye[(h + g | 0) - 1 | 0] != 41 | ye[c + 16 | 0] != ye[g | 0]) || ye[c + 17 | 0] != ye[g + 1 | 0] | ye[c + 18 | 0] != ye[g + 2 | 0] | (ye[c + 19 | 0] != ye[g + 3 | 0] | ye[c + 20 | 0] != ye[g + 4 | 0]) || ye[c + 21 | 0] != ye[g + 5 | 0] | ye[c + 22 | 0] != ye[g + 6 | 0])
                                  break o;
                                if (o = h - 9 | 0, e[c + 108 >> 2] = o, h = g + 8 | 0, e[c + 104 >> 2] = h, Af(c + 16 | 0, h, o, 32), o = e[c + 20 >> 2], h = e[c + 16 >> 2], (o | 0) != (h | 0)) {
                                  e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[r >> 2] = 5, e[r + 16 >> 2] = h, e[r + 12 >> 2] = 0, e[r + 20 >> 2] = o, o = e[c + 24 >> 2], e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 24 >> 2] = o, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0;
                                  break i;
                                }
                                if (e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, !o)
                                  break i;
                                Sr(o);
                                break i;
                              }
                              if (o = Ga(c + 16 | 0, 4182), h = nl(o, c + 104 | 0), $[o + 11 | 0] < 0 && Sr(e[o >> 2]), h) {
                                if (Af(c + 16 | 0, e[c + 104 >> 2], e[c + 108 >> 2], 20), o = e[c + 20 >> 2], h = e[c + 16 >> 2], (o | 0) != (h | 0)) {
                                  e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[r >> 2] = 4, e[r + 16 >> 2] = h, e[r + 12 >> 2] = 0, e[r + 20 >> 2] = o, o = e[c + 24 >> 2], e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 24 >> 2] = o, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0;
                                  break i;
                                }
                                if (e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, !o)
                                  break i;
                                Sr(o);
                                break i;
                              }
                              if (o = Ga(c + 16 | 0, 1743), h = nl(o, c + 104 | 0), $[o + 11 | 0] < 0 && Sr(e[o >> 2]), h) {
                                if (e[c + 96 >> 2] = 0, e[c + 88 >> 2] = 0, e[c + 92 >> 2] = 0, e[c + 84 >> 2] = 0, e[c + 76 >> 2] = 0, e[c + 80 >> 2] = 0, e[5996] = 0, o = c + 16 | 0, as(26, o | 0, c + 104 | 0, c + 8 | 0), h = e[5996], e[5996] = 0, (h | 0) != 1) {
                                  e[5996] = 0, di(27, c + 88 | 0, o | 0), h = e[5996], e[5996] = 0;
                                  o: {
                                    l: {
                                      if ((h | 0) != 1) {
                                        if (Ra(o), o = e[c + 92 >> 2], e[o - 56 >> 2])
                                          break l;
                                        e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                        break o;
                                      }
                                      y = Vr() | 0, Ra(c + 16 | 0);
                                      break t;
                                    }
                                    if (e[5996] = 0, di(28, c + 76 | 0, e[c + 8 >> 2]), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                      break r;
                                    l: {
                                      f: {
                                        if (!e[c + 108 >> 2])
                                          break f;
                                        d: {
                                          c: {
                                            for (; ; ) {
                                              if (Vs[c + 16 >> 1] = 44, $[c + 27 | 0] = 1, o = c + 16 | 0, h = c + 104 | 0, !ga(o, h))
                                                break l;
                                              if (e[5996] = 0, as(26, o | 0, h | 0, c + 8 | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                break c;
                                              if (e[5996] = 0, di(27, c + 88 | 0, o | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                break d;
                                              if (Ra(o), o = e[c + 92 >> 2], !e[o - 56 >> 2])
                                                break l;
                                              if (e[5996] = 0, di(28, c + 76 | 0, e[c + 8 >> 2]), h = e[5996], e[5996] = 0, (h | 0) != 1) {
                                                if (!e[c + 108 >> 2])
                                                  break f;
                                                continue;
                                              }
                                              break;
                                            }
                                            y = Vr() | 0;
                                            break t;
                                          }
                                          y = Vr() | 0;
                                          break t;
                                        }
                                        y = Vr() | 0, Ra(c + 16 | 0);
                                        break t;
                                      }
                                      e[r >> 2] = 9, h = e[c + 88 >> 2], e[r + 8 >> 2] = o, e[r + 4 >> 2] = h, e[r + 12 >> 2] = e[c + 96 >> 2], e[c + 96 >> 2] = 0, e[c + 88 >> 2] = 0, e[c + 92 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 40 >> 2] = e[c + 76 >> 2], e[r + 44 >> 2] = e[c + 80 >> 2], o = e[c + 84 >> 2], e[r + 52 >> 2] = 0, e[r + 48 >> 2] = o;
                                      break o;
                                    }
                                    if (o = e[c + 76 >> 2], e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, !o)
                                      break o;
                                    Sr(o);
                                  }
                                  Oa(c + 88 | 0);
                                  break i;
                                }
                                y = Vr() | 0;
                                break t;
                              }
                              if (o = Ga(c + 16 | 0, 2464), h = nl(o, c + 104 | 0), $[o + 11 | 0] < 0 && Sr(e[o >> 2]), h) {
                                e[c + 96 >> 2] = 0, e[c + 88 >> 2] = 0, e[c + 92 >> 2] = 0, e[5996] = 0, o = c + 16 | 0, di(29, o | 0, c + 104 | 0), h = e[5996], e[5996] = 0;
                                o: {
                                  if ((h | 0) != 1) {
                                    e[5996] = 0, di(27, c + 88 | 0, o | 0), h = e[5996], e[5996] = 0;
                                    l: {
                                      f: {
                                        d: {
                                          if ((h | 0) != 1) {
                                            if (Ra(o), y = e[c + 92 >> 2], e[y - 56 >> 2]) {
                                              if (!e[c + 108 >> 2])
                                                break f;
                                              break d;
                                            }
                                            e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                            break l;
                                          }
                                          y = Vr() | 0, Ra(c + 16 | 0);
                                          break o;
                                        }
                                        d: {
                                          c: {
                                            for (; ; ) {
                                              e[5996] = 0, o = On(30, c + 76 | 0, 4354) | 0, h = e[5996], e[5996] = 0;
                                              u: {
                                                if ((h | 0) != 1) {
                                                  if (h = ga(o, c + 104 | 0), $[c + 87 | 0] < 0 && Sr(e[o >> 2]), h)
                                                    break u;
                                                  e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                                  break l;
                                                }
                                                y = Vr() | 0;
                                                break o;
                                              }
                                              if (e[5996] = 0, o = c + 16 | 0, di(29, o | 0, c + 104 | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                break c;
                                              if (e[5996] = 0, di(27, c + 88 | 0, o | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                break d;
                                              if (Ra(o), y = e[c + 92 >> 2], e[y - 56 >> 2]) {
                                                if (!e[c + 108 >> 2])
                                                  break f;
                                                continue;
                                              }
                                              break;
                                            }
                                            e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                            break l;
                                          }
                                          y = Vr() | 0;
                                          break o;
                                        }
                                        y = Vr() | 0, Ra(c + 16 | 0);
                                        break o;
                                      }
                                      e[r >> 2] = 8, o = e[c + 88 >> 2], e[r + 8 >> 2] = y, e[r + 4 >> 2] = o, e[r + 12 >> 2] = e[c + 96 >> 2], e[c + 96 >> 2] = 0, e[c + 88 >> 2] = 0, e[c + 92 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0;
                                    }
                                    Oa(c + 88 | 0);
                                    break i;
                                  }
                                  y = Vr() | 0;
                                }
                                break e;
                              }
                              if (o = Ga(c + 16 | 0, 2197), h = nl(o, c + 104 | 0), $[o + 11 | 0] < 0 && Sr(e[o >> 2]), !h)
                                break s;
                              y = 0, G = e[c + 104 >> 2], o = G, S = e[c + 108 >> 2];
                              o: {
                                if (!S)
                                  break o;
                                for (h = o + S | 0; ; ) {
                                  g = ye[o | 0];
                                  l: {
                                    if (!((g | 0) != 123 & (g | 0) != 40)) {
                                      y = y + 1 | 0;
                                      break l;
                                    }
                                    if (y) {
                                      if ((g | 0) != 125 & (g | 0) != 41)
                                        break l;
                                      y = y - 1 | 0;
                                      break l;
                                    }
                                    y = 0;
                                    f:
                                      switch (g - 41 | 0) {
                                        case 0:
                                        case 3:
                                          break o;
                                        case 1:
                                        case 2:
                                          break l;
                                        default:
                                          break f;
                                      }
                                    if ((g | 0) == 125)
                                      break o;
                                  }
                                  if (o = o + 1 | 0, (h | 0) == (o | 0))
                                    break;
                                }
                                o = h;
                              }
                              e[c + 8 >> 2] = G, h = o - G | 0, e[c + 12 >> 2] = h, e[c + 108 >> 2] = S - h, e[c + 104 >> 2] = o, o = e[c + 8 >> 2], h = sd(c + 16 | 0, o, o + e[c + 12 >> 2] | 0), g = c + 4 | 0, o = 0, y = Yr - 16 | 0, Yr = y, S = ye[h + 11 | 0], G = S << 24 >> 24, G = (G | 0) < 0, S = G ? e[h + 4 >> 2] : S;
                              o: {
                                if (!S || (G = G ? e[h >> 2] : h, ke = ye[G | 0], Fe = ke - 9 & 255, Fe >>> 0 < 24 & (8388639 >>> Fe & 1)) || (Fe = ye[(S + G | 0) - 1 | 0] - 9 | 0, (Fe & 255) >>> 0 < 24 & (8388639 >>> Fe & 1)) || (ke | 0) == 45 | (Da(G) | 0) != (S | 0) || (e[y + 12 >> 2] = 0, e[5732] = 0, G = zl($[h + 11 | 0] < 0 ? e[h >> 2] : h, y + 12 | 0, 10, -1, 0), g && (e[g >> 2] = G), g = e[y + 12 >> 2], !g | ye[g | 0]))
                                  break o;
                                o = !e[5732];
                              }
                              if (Yr = y + 16 | 0, $[h + 11 | 0] < 0 && Sr(e[h >> 2]), !o) {
                                e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                break i;
                              }
                              if (!e[c + 4 >> 2]) {
                                e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                break i;
                              }
                              o = 0, e[c + 96 >> 2] = 0, e[c + 88 >> 2] = 0, e[c + 92 >> 2] = 0, y = 0;
                              o: {
                                l: {
                                  f: {
                                    if (e[c + 108 >> 2]) {
                                      d: {
                                        c: {
                                          u: {
                                            for (; ; ) {
                                              if (e[5996] = 0, o = On(30, c + 76 | 0, 4354) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                break l;
                                              if (h = ga(o, c + 104 | 0), $[c + 87 | 0] < 0 && Sr(e[o >> 2]), !h) {
                                                e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                                break f;
                                              }
                                              if (e[5996] = 0, o = c + 16 | 0, di(29, o | 0, c + 104 | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                break u;
                                              if (e[5996] = 0, di(27, c + 88 | 0, o | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                break c;
                                              if (Ra(o), y = e[c + 92 >> 2], e[y - 56 >> 2]) {
                                                if (!e[c + 108 >> 2])
                                                  break d;
                                                continue;
                                              }
                                              break;
                                            }
                                            e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                            break f;
                                          }
                                          y = Vr() | 0;
                                          break o;
                                        }
                                        y = Vr() | 0, Ra(c + 16 | 0);
                                        break o;
                                      }
                                      o = e[c + 88 >> 2];
                                    }
                                    d: {
                                      if (h = (y - o | 0) / 56 | 0, h >>> 0 <= 100 && (g = h, h = e[c + 4 >> 2], g >>> 0 >= h >>> 0))
                                        break d;
                                      e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                      break f;
                                    }
                                    e[r + 4 >> 2] = o, e[r >> 2] = 10, e[r + 8 >> 2] = y, e[r + 12 >> 2] = e[c + 96 >> 2], e[c + 96 >> 2] = 0, e[c + 88 >> 2] = 0, e[c + 92 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 52 >> 2] = h;
                                  }
                                  Oa(c + 88 | 0);
                                  break i;
                                }
                                y = Vr() | 0;
                              }
                              Oa(c + 88 | 0);
                            }
                            Ki(y | 0), ri();
                          }
                          e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                        }
                        Yr = c + 112 | 0;
                        return;
                      }
                      ba(), ri();
                    }
                    y = Vr() | 0;
                  }
                  r = e[c + 76 >> 2], r && Sr(r);
                }
                Oa(c + 88 | 0), Ki(y | 0), ri();
              }
              function O1(r, o, c, h) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0;
                var y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0;
                g = Yr - 160 | 0, Yr = g, e[g + 152 >> 2] = 0, e[g + 144 >> 2] = 0, e[g + 148 >> 2] = 0, Rn = h + 1 | 0, hr = 1;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  f: {
                                    for (; ; ) {
                                      if (y = ye[o | 0] | ye[o + 1 | 0] << 8 | (ye[o + 2 | 0] << 16 | ye[o + 3 | 0] << 24), (y | 0) == (c | 0))
                                        break f;
                                      d: {
                                        c: {
                                          u: {
                                            g: {
                                              A: {
                                                p: {
                                                  I: {
                                                    k: {
                                                      N: {
                                                        S: {
                                                          T: {
                                                            v: {
                                                              w: {
                                                                b: {
                                                                  h: {
                                                                    x: {
                                                                      m: {
                                                                        if ((c - y | 0) <= 0 | c >>> 0 <= y >>> 0)
                                                                          break m;
                                                                        G = y + 1 | 0, S = 0, Ar = ye[y | 0];
                                                                        B: {
                                                                          if (Ar >>> 0 > 78) {
                                                                            ke = 0;
                                                                            break B;
                                                                          }
                                                                          ke = Ar;
                                                                          R: {
                                                                            if (ke >>> 0 < 76)
                                                                              break R;
                                                                            E:
                                                                              switch (ke - 76 | 0) {
                                                                                case 0:
                                                                                  if ((c - G | 0) <= 0)
                                                                                    break m;
                                                                                  G = y + 2 | 0, ke = ye[y + 1 | 0];
                                                                                  break R;
                                                                                case 1:
                                                                                  if ((c - G | 0) < 2)
                                                                                    break m;
                                                                                  G = y + 3 | 0, ke = ye[y + 1 | 0] | ye[y + 2 | 0] << 8;
                                                                                  break R;
                                                                                default:
                                                                                  break E;
                                                                              }
                                                                            if ((c - G | 0) < 4)
                                                                              break m;
                                                                            G = y + 5 | 0, ke = ye[y + 1 | 0] | ye[y + 2 | 0] << 8 | (ye[y + 3 | 0] << 16 | ye[y + 4 | 0] << 24);
                                                                          }
                                                                          if (S = c - G | 0, (S | 0) < 0 || (y = ke, S >>> 0 < y >>> 0))
                                                                            break m;
                                                                          R: {
                                                                            if (!y) {
                                                                              ke = 0, S = 0;
                                                                              break R;
                                                                            }
                                                                            if ((y | 0) < 0) {
                                                                              if (e[5996] = 0, Ri(8), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                break x;
                                                                              break e;
                                                                            }
                                                                            if (e[5996] = 0, ke = ii(3, y | 0) | 0, Fe = e[5996], e[5996] = 0, S = 0, (Fe | 0) == 1)
                                                                              break s;
                                                                            S = _s(ke, G, y) + y | 0;
                                                                          }
                                                                          G = y + G | 0;
                                                                        }
                                                                        if (y = 3, Ar - 103 >>> 0 < 2)
                                                                          break d;
                                                                        if ($[o | 0] = G, $[o + 1 | 0] = G >>> 8, $[o + 2 | 0] = G >>> 16, $[o + 3 | 0] = G >>> 24, !hr)
                                                                          break h;
                                                                        if (y = 0, (h | 0) <= 0)
                                                                          break b;
                                                                        for (; ; ) {
                                                                          if (e[5996] = 0, On(97, g + 144 | 0, 5573) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                            break w;
                                                                          if (y = y + 1 | 0, (y | 0) == (h | 0))
                                                                            break;
                                                                        }
                                                                        break b;
                                                                      }
                                                                      if (o = ye[g + 155 | 0], h = o << 24 >> 24, ke = (h | 0) < 0 ? e[g + 148 >> 2] : o, c = ke + 8 | 0, c >>> 0 >= 2147483632) {
                                                                        if (e[5996] = 0, Ri(2), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                          break e;
                                                                        y = Vr() | 0;
                                                                        break n;
                                                                      }
                                                                      m: {
                                                                        if (c >>> 0 <= 10) {
                                                                          e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, $[r + 11 | 0] = c;
                                                                          break m;
                                                                        }
                                                                        if (e[5996] = 0, y = (c | 15) + 1 | 0, o = ii(3, y | 0) | 0, G = e[5996], e[5996] = 0, S = 0, (G | 0) == 1)
                                                                          break s;
                                                                        e[r + 4 >> 2] = c, e[r >> 2] = o, e[r + 8 >> 2] = y | -2147483648, r = o;
                                                                      }
                                                                      r = Ks(r, (h | 0) < 0 ? e[g + 144 >> 2] : g + 144 | 0, ke) + ke | 0, $[r + 8 | 0] = 0, $[r | 0] = 32, $[r + 1 | 0] = 91, $[r + 2 | 0] = 101, $[r + 3 | 0] = 114, $[r + 4 | 0] = 114, $[r + 5 | 0] = 111, $[r + 6 | 0] = 114, $[r + 7 | 0] = 93;
                                                                      break r;
                                                                    }
                                                                    y = Vr() | 0;
                                                                    break n;
                                                                  }
                                                                  if (e[5996] = 0, di(98, g + 144 | 0, 32), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                    break a;
                                                                  y = ye[g + 155 | 0], Mn = (y << 24 >> 24 < 0 ? e[g + 148 >> 2] : y) - 1 | 0;
                                                                }
                                                                b: {
                                                                  h: {
                                                                    x: {
                                                                      m: {
                                                                        B:
                                                                          switch (Tr = S - ke | 0, Tr | 0) {
                                                                            case 0:
                                                                              break b;
                                                                            case 33:
                                                                              break x;
                                                                            case 32:
                                                                              break m;
                                                                            case 20:
                                                                              break B;
                                                                            default:
                                                                              break h;
                                                                          }
                                                                        if (e[5996] = 0, Fe = ii(3, 20) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) {
                                                                          y = Vr() | 0;
                                                                          break o;
                                                                        }
                                                                        if (y = Fe, $[y | 0] = 153, $[y + 1 | 0] = 153, $[y + 2 | 0] = 153, $[y + 3 | 0] = 153, $[y + 4 | 0] = 153, $[y + 5 | 0] = 153, $[y + 6 | 0] = 153, $[y + 7 | 0] = 153, $[y + 16 | 0] = 153, $[y + 17 | 0] = 153, $[y + 18 | 0] = 153, $[y + 19 | 0] = 153, $[y + 8 | 0] = 153, $[y + 9 | 0] = 153, $[y + 10 | 0] = 153, $[y + 11 | 0] = 153, $[y + 12 | 0] = 153, $[y + 13 | 0] = 153, $[y + 14 | 0] = 153, $[y + 15 | 0] = 153, G = ke, (S | 0) == (G | 0))
                                                                          break p;
                                                                        for (; ; ) {
                                                                          if (ye[G | 0] == ye[y | 0]) {
                                                                            if (y = y + 1 | 0, G = G + 1 | 0, (S | 0) != (G | 0))
                                                                              continue;
                                                                            break p;
                                                                          }
                                                                          break;
                                                                        }
                                                                        if (Sr(Fe), !(ye[ke | 0] != 80 | ye[ke + 1 | 0] != 75 | ye[ke + 2 | 0] != 104)) {
                                                                          B: {
                                                                            R: {
                                                                              for (; ; ) {
                                                                                if (y = S - 1 | 0, !ye[y | 0]) {
                                                                                  if (S = y, (y | 0) != (ke | 0))
                                                                                    continue;
                                                                                  break R;
                                                                                }
                                                                                break;
                                                                              }
                                                                              if (S = (S - ke | 0) - 3 | 0, S >>> 0 < 2147483632)
                                                                                break B;
                                                                            }
                                                                            if (e[5996] = 0, Ri(2), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                              break e;
                                                                            y = Vr() | 0;
                                                                            break o;
                                                                          }
                                                                          B: {
                                                                            R: {
                                                                              E: {
                                                                                C: {
                                                                                  y: {
                                                                                    D: {
                                                                                      P: {
                                                                                        if (S >>> 0 <= 10) {
                                                                                          $[g + 111 | 0] = S, G = g + 100 | 0;
                                                                                          break P;
                                                                                        }
                                                                                        if (e[5996] = 0, y = (S | 15) + 1 | 0, G = ii(3, y | 0) | 0, Fe = e[5996], e[5996] = 0, (Fe | 0) == 1)
                                                                                          break D;
                                                                                        e[g + 100 >> 2] = G, e[g + 104 >> 2] = S, e[g + 108 >> 2] = y | -2147483648;
                                                                                      }
                                                                                      if ($[Ks(G, ke + 3 | 0, S) + S | 0] = 0, e[5996] = 0, S = Si(99, g + 100 | 0, 0, 5383) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                        break y;
                                                                                      if (e[g + 120 >> 2] = e[S + 8 >> 2], y = e[S + 4 >> 2], e[g + 112 >> 2] = e[S >> 2], e[g + 116 >> 2] = y, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, e[5996] = 0, y = On(97, g + 112 | 0, 3723) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                                        break C;
                                                                                      if (e[g + 136 >> 2] = e[y + 8 >> 2], G = e[y + 4 >> 2], e[g + 128 >> 2] = e[y >> 2], e[g + 132 >> 2] = G, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, G = ye[g + 139 | 0], Fe = G << 24 >> 24 < 0, Si(100, g + 144 | 0, (Fe ? e[g + 128 >> 2] : g + 128 | 0) | 0, (Fe ? e[g + 132 >> 2] : G) | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                                        break E;
                                                                                      if ($[g + 139 | 0] < 0 && Sr(e[g + 128 >> 2]), $[g + 123 | 0] < 0 && Sr(e[y >> 2]), $[g + 111 | 0] < 0 && Sr(e[S >> 2]), !hr)
                                                                                        break u;
                                                                                      break c;
                                                                                    }
                                                                                    y = Vr() | 0;
                                                                                    break o;
                                                                                  }
                                                                                  y = Vr() | 0;
                                                                                  break B;
                                                                                }
                                                                                y = Vr() | 0;
                                                                                break R;
                                                                              }
                                                                              if (y = Vr() | 0, $[g + 139 | 0] >= 0)
                                                                                break R;
                                                                              Sr(e[g + 128 >> 2]);
                                                                            }
                                                                            if ($[g + 123 | 0] >= 0)
                                                                              break B;
                                                                            Sr(e[g + 112 >> 2]);
                                                                          }
                                                                          if ($[g + 111 | 0] >= 0)
                                                                            break o;
                                                                          Sr(e[g + 100 >> 2]);
                                                                          break o;
                                                                        }
                                                                        if (e[g + 80 >> 2] = 0, e[5996] = 0, e[g + 72 >> 2] = 0, e[g + 76 >> 2] = 0, di(101, g + 72 | 0, 40), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                          break k;
                                                                        if (S >>> 0 > ke >>> 0)
                                                                          for (G = ke + 20 | 0, y = ke; ; ) {
                                                                            if (S = ye[y | 0], e[5996] = 0, Fe = g + 72 | 0, di(98, Fe | 0, $[(S >>> 4 | 0) + 6976 | 0]), Ar = e[5996], e[5996] = 0, (Ar | 0) == 1 || (e[5996] = 0, di(98, Fe | 0, $[(S & 15) + 6976 | 0]), S = e[5996], e[5996] = 0, (S | 0) == 1))
                                                                              break k;
                                                                            if (y = y + 1 | 0, (G | 0) == (y | 0))
                                                                              break;
                                                                          }
                                                                        e[5996] = 0, S = Si(99, g + 72 | 0, 0, 3762) | 0, y = e[5996], e[5996] = 0;
                                                                        B: {
                                                                          R: {
                                                                            E: {
                                                                              C: {
                                                                                if ((y | 0) != 1) {
                                                                                  if (e[g + 96 >> 2] = e[S + 8 >> 2], y = e[S + 4 >> 2], e[g + 88 >> 2] = e[S >> 2], e[g + 92 >> 2] = y, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, e[5996] = 0, y = On(97, g + 88 | 0, 3760) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                                    break C;
                                                                                  if (e[g + 136 >> 2] = e[y + 8 >> 2], G = e[y + 4 >> 2], e[g + 128 >> 2] = e[y >> 2], e[g + 132 >> 2] = G, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, G = ye[g + 139 | 0], Fe = G << 24 >> 24 < 0, Si(100, g + 144 | 0, (Fe ? e[g + 128 >> 2] : g + 128 | 0) | 0, (Fe ? e[g + 132 >> 2] : G) | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                                    break E;
                                                                                  if ($[g + 139 | 0] < 0 && Sr(e[g + 128 >> 2]), $[g + 99 | 0] < 0 && Sr(e[y >> 2]), $[g + 83 | 0] < 0 && Sr(e[S >> 2]), !hr)
                                                                                    break u;
                                                                                  break c;
                                                                                }
                                                                                y = Vr() | 0;
                                                                                break B;
                                                                              }
                                                                              y = Vr() | 0;
                                                                              break R;
                                                                            }
                                                                            if (y = Vr() | 0, $[g + 139 | 0] >= 0)
                                                                              break R;
                                                                            Sr(e[g + 128 >> 2]);
                                                                          }
                                                                          if ($[g + 99 | 0] >= 0)
                                                                            break B;
                                                                          Sr(e[g + 88 >> 2]);
                                                                        }
                                                                        break I;
                                                                      }
                                                                      if (e[5996] = 0, Fe = ii(3, 32) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) {
                                                                        y = Vr() | 0;
                                                                        break o;
                                                                      }
                                                                      if (y = Fe, $[y | 0] = 136, $[y + 1 | 0] = 136, $[y + 2 | 0] = 136, $[y + 3 | 0] = 136, $[y + 4 | 0] = 136, $[y + 5 | 0] = 136, $[y + 6 | 0] = 136, $[y + 7 | 0] = 136, $[y + 24 | 0] = 136, $[y + 25 | 0] = 136, $[y + 26 | 0] = 136, $[y + 27 | 0] = 136, $[y + 28 | 0] = 136, $[y + 29 | 0] = 136, $[y + 30 | 0] = 136, $[y + 31 | 0] = 136, $[y + 16 | 0] = 136, $[y + 17 | 0] = 136, $[y + 18 | 0] = 136, $[y + 19 | 0] = 136, $[y + 20 | 0] = 136, $[y + 21 | 0] = 136, $[y + 22 | 0] = 136, $[y + 23 | 0] = 136, $[y + 8 | 0] = 136, $[y + 9 | 0] = 136, $[y + 10 | 0] = 136, $[y + 11 | 0] = 136, $[y + 12 | 0] = 136, $[y + 13 | 0] = 136, $[y + 14 | 0] = 136, $[y + 15 | 0] = 136, G = ke, (S | 0) == (G | 0))
                                                                        break p;
                                                                      for (; ei = ye[G | 0], ci = ye[y | 0], (ei | 0) == (ci | 0) && (y = y + 1 | 0, G = G + 1 | 0, (S | 0) != (G | 0)); )
                                                                        ;
                                                                      if (Sr(Fe), (ei | 0) == (ci | 0))
                                                                        break A;
                                                                      if (!Tr)
                                                                        break b;
                                                                      if ((Tr | 0) != 33)
                                                                        break h;
                                                                    }
                                                                    if (ye[ke | 0] != 2 | ye[ke + 1 | 0] != 80 | (ye[ke + 2 | 0] != 75 | ye[ke + 3 | 0] != 98))
                                                                      break h;
                                                                    x: {
                                                                      if ((S | 0) != (ke | 0)) {
                                                                        m: {
                                                                          for (; ; ) {
                                                                            if (y = S - 1 | 0, !ye[y | 0]) {
                                                                              if (S = y, (y | 0) != (ke | 0))
                                                                                continue;
                                                                              break m;
                                                                            }
                                                                            break;
                                                                          }
                                                                          if (S = (S - ke | 0) - 4 | 0, S >>> 0 < 2147483632)
                                                                            break x;
                                                                        }
                                                                        S = ke;
                                                                      }
                                                                      if (e[5996] = 0, Ri(2), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                        break e;
                                                                      y = Vr() | 0;
                                                                      break i;
                                                                    }
                                                                    x: {
                                                                      m: {
                                                                        B: {
                                                                          R: {
                                                                            E: {
                                                                              C: {
                                                                                y: {
                                                                                  if (S >>> 0 <= 10) {
                                                                                    $[g + 55 | 0] = S, G = g + 44 | 0;
                                                                                    break y;
                                                                                  }
                                                                                  if (e[5996] = 0, y = (S | 15) + 1 | 0, G = ii(3, y | 0) | 0, Fe = e[5996], e[5996] = 0, (Fe | 0) == 1)
                                                                                    break C;
                                                                                  e[g + 44 >> 2] = G, e[g + 48 >> 2] = S, e[g + 52 >> 2] = y | -2147483648;
                                                                                }
                                                                                if ($[Ks(G, ke + 4 | 0, S) + S | 0] = 0, e[5996] = 0, S = Si(99, g + 44 | 0, 0, 3762) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                  break E;
                                                                                if (e[g - -64 >> 2] = e[S + 8 >> 2], y = e[S + 4 >> 2], e[g + 56 >> 2] = e[S >> 2], e[g + 60 >> 2] = y, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, e[5996] = 0, y = On(97, g + 56 | 0, 3760) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                                  break R;
                                                                                if (e[g + 136 >> 2] = e[y + 8 >> 2], G = e[y + 4 >> 2], e[g + 128 >> 2] = e[y >> 2], e[g + 132 >> 2] = G, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, G = ye[g + 139 | 0], Fe = G << 24 >> 24 < 0, Si(100, g + 144 | 0, (Fe ? e[g + 128 >> 2] : g + 128 | 0) | 0, (Fe ? e[g + 132 >> 2] : G) | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                                  break B;
                                                                                if ($[g + 139 | 0] < 0 && Sr(e[g + 128 >> 2]), $[g + 67 | 0] < 0 && Sr(e[y >> 2]), $[g + 55 | 0] < 0 && Sr(e[S >> 2]), hr)
                                                                                  break c;
                                                                                break u;
                                                                              }
                                                                              y = Vr() | 0;
                                                                              break o;
                                                                            }
                                                                            y = Vr() | 0;
                                                                            break x;
                                                                          }
                                                                          y = Vr() | 0;
                                                                          break m;
                                                                        }
                                                                        if (y = Vr() | 0, $[g + 139 | 0] >= 0)
                                                                          break m;
                                                                        Sr(e[g + 128 >> 2]);
                                                                      }
                                                                      if ($[g + 67 | 0] >= 0)
                                                                        break x;
                                                                      Sr(e[g + 56 >> 2]);
                                                                    }
                                                                    if ($[g + 55 | 0] >= 0)
                                                                      break o;
                                                                    Sr(e[g + 44 >> 2]);
                                                                    break o;
                                                                  }
                                                                  if (e[g + 24 >> 2] = 0, e[5996] = 0, e[g + 16 >> 2] = 0, e[g + 20 >> 2] = 0, di(101, g + 16 | 0, Tr << 1), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                    break S;
                                                                  if (S >>> 0 > ke >>> 0)
                                                                    for (G = ke + Tr | 0, y = ke; ; ) {
                                                                      if (S = ye[y | 0], e[5996] = 0, Fe = g + 16 | 0, di(98, Fe | 0, $[(S >>> 4 | 0) + 6976 | 0]), Ar = e[5996], e[5996] = 0, (Ar | 0) == 1 || (e[5996] = 0, di(98, Fe | 0, $[(S & 15) + 6976 | 0]), S = e[5996], e[5996] = 0, (S | 0) == 1))
                                                                        break S;
                                                                      if (y = y + 1 | 0, (G | 0) == (y | 0))
                                                                        break;
                                                                    }
                                                                  e[5996] = 0, S = Si(99, g + 16 | 0, 0, 3762) | 0, y = e[5996], e[5996] = 0;
                                                                  h: {
                                                                    x: {
                                                                      m: {
                                                                        B: {
                                                                          if ((y | 0) != 1) {
                                                                            if (e[g + 40 >> 2] = e[S + 8 >> 2], y = e[S + 4 >> 2], e[g + 32 >> 2] = e[S >> 2], e[g + 36 >> 2] = y, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, e[5996] = 0, y = On(97, g + 32 | 0, 3760) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                              break B;
                                                                            if (e[g + 136 >> 2] = e[y + 8 >> 2], G = e[y + 4 >> 2], e[g + 128 >> 2] = e[y >> 2], e[g + 132 >> 2] = G, e[y >> 2] = 0, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[5996] = 0, G = ye[g + 139 | 0], Fe = G << 24 >> 24 < 0, Si(100, g + 144 | 0, (Fe ? e[g + 128 >> 2] : g + 128 | 0) | 0, (Fe ? e[g + 132 >> 2] : G) | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                              break m;
                                                                            if ($[g + 139 | 0] < 0 && Sr(e[g + 128 >> 2]), $[g + 43 | 0] < 0 && Sr(e[y >> 2]), $[g + 27 | 0] < 0 && Sr(e[S >> 2]), !hr)
                                                                              break u;
                                                                            break c;
                                                                          }
                                                                          y = Vr() | 0;
                                                                          break h;
                                                                        }
                                                                        y = Vr() | 0;
                                                                        break x;
                                                                      }
                                                                      if (y = Vr() | 0, $[g + 139 | 0] >= 0)
                                                                        break x;
                                                                      Sr(e[g + 128 >> 2]);
                                                                    }
                                                                    if ($[g + 43 | 0] >= 0)
                                                                      break h;
                                                                    Sr(e[g + 32 >> 2]);
                                                                  }
                                                                  break N;
                                                                }
                                                                if (y = e[(Ar << 2) + 5840 >> 2], S = Da(y), S >>> 0 >= 2147483632) {
                                                                  if (e[5996] = 0, Ri(2), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                    break e;
                                                                  y = Vr() | 0;
                                                                  break o;
                                                                }
                                                                b: {
                                                                  h: {
                                                                    x: {
                                                                      m: {
                                                                        B: {
                                                                          R: {
                                                                            E: {
                                                                              C: {
                                                                                y: {
                                                                                  D: {
                                                                                    P: {
                                                                                      q: {
                                                                                        O: {
                                                                                          Q: {
                                                                                            U: {
                                                                                              F: {
                                                                                                M: {
                                                                                                  L: {
                                                                                                    H: {
                                                                                                      if (S >>> 0 <= 10) {
                                                                                                        $[g + 139 | 0] = S, G = g + 128 | 0;
                                                                                                        break H;
                                                                                                      }
                                                                                                      if (e[5996] = 0, Fe = (S | 15) + 1 | 0, G = ii(3, Fe | 0) | 0, Tr = e[5996], e[5996] = 0, (Tr | 0) == 1)
                                                                                                        break L;
                                                                                                      e[g + 128 >> 2] = G, e[g + 132 >> 2] = S, e[g + 136 >> 2] = Fe | -2147483648;
                                                                                                    }
                                                                                                    if ($[Ks(G, y, S) + S | 0] = 0, e[5996] = 0, S = ye[g + 139 | 0], y = S << 24 >> 24 < 0, S = Si(100, g + 144 | 0, (y ? e[g + 128 >> 2] : g + 128 | 0) | 0, (y ? e[g + 132 >> 2] : S) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                      break M;
                                                                                                    if ($[g + 139 | 0] < 0 && Sr(e[g + 128 >> 2]), Ar - 99 >>> 0 > 1)
                                                                                                      break g;
                                                                                                    if (e[5996] = 0, di(98, S | 0, 10), y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                                      break a;
                                                                                                    if (e[5996] = 0, y = g + 128 | 0, Qs(102, y | 0, o | 0, c | 0, Rn | 0), G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                                                      break F;
                                                                                                    if (e[5996] = 0, Fe = S, G = y, S = ye[g + 139 | 0], y = S << 24 >> 24 < 0, Fe = Si(100, Fe | 0, (y ? e[g + 128 >> 2] : G) | 0, (y ? e[g + 132 >> 2] : S) | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                      break U;
                                                                                                    if ($[g + 139 | 0] < 0 && Sr(e[g + 128 >> 2]), G = ye[o | 0] | ye[o + 1 | 0] << 8 | (ye[o + 2 | 0] << 16 | ye[o + 3 | 0] << 24), (G | 0) == (c | 0))
                                                                                                      break B;
                                                                                                    if (ye[G | 0] != 103)
                                                                                                      break O;
                                                                                                    if (y = 0, (h | 0) > 0) {
                                                                                                      for (; ; ) {
                                                                                                        if (e[5996] = 0, On(97, Fe | 0, 5573) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                                          break v;
                                                                                                        if (y = y + 1 | 0, (y | 0) == (h | 0))
                                                                                                          break;
                                                                                                      }
                                                                                                      G = ye[o | 0] | ye[o + 1 | 0] << 8 | (ye[o + 2 | 0] << 16 | ye[o + 3 | 0] << 24);
                                                                                                    }
                                                                                                    if (S = G + 1 | 0, $[o | 0] = S, $[o + 1 | 0] = S >>> 8, $[o + 2 | 0] = S >>> 16, $[o + 3 | 0] = S >>> 24, y = e[(ye[G | 0] << 2) + 5840 >> 2], S = Da(y), S >>> 0 < 2147483632)
                                                                                                      break Q;
                                                                                                    if (e[5996] = 0, Ri(2), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                      break e;
                                                                                                    y = Vr() | 0;
                                                                                                    break o;
                                                                                                  }
                                                                                                  y = Vr() | 0;
                                                                                                  break o;
                                                                                                }
                                                                                                if (y = Vr() | 0, $[g + 139 | 0] >= 0)
                                                                                                  break o;
                                                                                                Sr(e[g + 128 >> 2]);
                                                                                                break o;
                                                                                              }
                                                                                              y = Vr() | 0;
                                                                                              break o;
                                                                                            }
                                                                                            if (y = Vr() | 0, $[g + 139 | 0] >= 0)
                                                                                              break o;
                                                                                            Sr(e[g + 128 >> 2]);
                                                                                            break o;
                                                                                          }
                                                                                          Q: {
                                                                                            if (S >>> 0 <= 10) {
                                                                                              $[g + 11 | 0] = S, G = g;
                                                                                              break Q;
                                                                                            }
                                                                                            if (e[5996] = 0, Ar = (S | 15) + 1 | 0, G = ii(3, Ar | 0) | 0, hr = e[5996], e[5996] = 0, (hr | 0) == 1)
                                                                                              break q;
                                                                                            e[g >> 2] = G, e[g + 4 >> 2] = S, e[g + 8 >> 2] = Ar | -2147483648;
                                                                                          }
                                                                                          if ($[Ks(G, y, S) + S | 0] = 0, e[5996] = 0, di(98, g | 0, 10), S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                            break P;
                                                                                          if (e[g + 136 >> 2] = e[g + 8 >> 2], e[g + 8 >> 2] = 0, y = e[g + 4 >> 2], S = e[g >> 2], e[g + 128 >> 2] = S, e[g + 132 >> 2] = y, e[g >> 2] = 0, e[g + 4 >> 2] = 0, e[5996] = 0, G = S, S = $[g + 139 | 0], y = (S | 0) < 0, S = Si(100, Fe | 0, (y ? G : g + 128 | 0) | 0, (y ? e[g + 132 >> 2] : S & 255) | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                                                            break D;
                                                                                          if ($[g + 139 | 0] < 0 && Sr(e[g + 128 >> 2]), $[g + 11 | 0] < 0 && Sr(e[g >> 2]), e[5996] = 0, y = g + 128 | 0, Qs(102, y | 0, o | 0, c | 0, Rn | 0), G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                                                            break C;
                                                                                          if (e[5996] = 0, Ar = S, G = y, S = ye[g + 139 | 0], y = S << 24 >> 24 < 0, Si(100, Ar | 0, (y ? e[g + 128 >> 2] : G) | 0, (y ? e[g + 132 >> 2] : S) | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                            break E;
                                                                                          $[g + 139 | 0] < 0 && Sr(e[g + 128 >> 2]), G = ye[o | 0] | ye[o + 1 | 0] << 8 | (ye[o + 2 | 0] << 16 | ye[o + 3 | 0] << 24);
                                                                                        }
                                                                                        if ((c | 0) == (G | 0) | ye[G | 0] != 104)
                                                                                          break B;
                                                                                        if (y = 0, (h | 0) > 0) {
                                                                                          for (; ; ) {
                                                                                            if (e[5996] = 0, On(97, Fe | 0, 5573) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                              break T;
                                                                                            if (y = y + 1 | 0, (y | 0) == (h | 0))
                                                                                              break;
                                                                                          }
                                                                                          G = ye[o | 0] | ye[o + 1 | 0] << 8 | (ye[o + 2 | 0] << 16 | ye[o + 3 | 0] << 24);
                                                                                        }
                                                                                        if (S = G + 1 | 0, $[o | 0] = S, $[o + 1 | 0] = S >>> 8, $[o + 2 | 0] = S >>> 16, $[o + 3 | 0] = S >>> 24, y = e[(ye[G | 0] << 2) + 5840 >> 2], S = Da(y), S >>> 0 < 2147483632)
                                                                                          break R;
                                                                                        if (e[5996] = 0, Ri(2), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                          break e;
                                                                                        y = Vr() | 0;
                                                                                        break o;
                                                                                      }
                                                                                      y = Vr() | 0;
                                                                                      break o;
                                                                                    }
                                                                                    y = Vr() | 0;
                                                                                    break y;
                                                                                  }
                                                                                  if (y = Vr() | 0, $[g + 139 | 0] >= 0)
                                                                                    break y;
                                                                                  Sr(e[g + 128 >> 2]);
                                                                                }
                                                                                if ($[g + 11 | 0] >= 0)
                                                                                  break o;
                                                                                Sr(e[g >> 2]);
                                                                                break o;
                                                                              }
                                                                              y = Vr() | 0;
                                                                              break o;
                                                                            }
                                                                            if (y = Vr() | 0, $[g + 139 | 0] >= 0)
                                                                              break o;
                                                                            Sr(e[g + 128 >> 2]);
                                                                            break o;
                                                                          }
                                                                          R: {
                                                                            if (S >>> 0 <= 10) {
                                                                              $[g + 11 | 0] = S, G = g;
                                                                              break R;
                                                                            }
                                                                            if (e[5996] = 0, Ar = (S | 15) + 1 | 0, G = ii(3, Ar | 0) | 0, hr = e[5996], e[5996] = 0, (hr | 0) == 1)
                                                                              break m;
                                                                            e[g >> 2] = G, e[g + 4 >> 2] = S, e[g + 8 >> 2] = Ar | -2147483648;
                                                                          }
                                                                          if ($[Ks(G, y, S) + S | 0] = 0, e[5996] = 0, di(98, g | 0, 10), S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                            break x;
                                                                          if (e[g + 136 >> 2] = e[g + 8 >> 2], e[g + 8 >> 2] = 0, y = e[g + 4 >> 2], S = e[g >> 2], e[g + 128 >> 2] = S, e[g + 132 >> 2] = y, e[g >> 2] = 0, e[g + 4 >> 2] = 0, e[5996] = 0, G = S, S = $[g + 139 | 0], y = (S | 0) < 0, Si(100, Fe | 0, (y ? G : g + 128 | 0) | 0, (y ? e[g + 132 >> 2] : S & 255) | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                            break h;
                                                                          if ($[g + 139 | 0] < 0 && Sr(e[g + 128 >> 2]), $[g + 11 | 0] >= 0)
                                                                            break B;
                                                                          Sr(e[g >> 2]);
                                                                        }
                                                                        S = ye[g + 155 | 0], ln = S << 24 >> 24 < 0 ? e[g + 148 >> 2] : S;
                                                                        break c;
                                                                      }
                                                                      y = Vr() | 0;
                                                                      break o;
                                                                    }
                                                                    y = Vr() | 0;
                                                                    break b;
                                                                  }
                                                                  if (y = Vr() | 0, $[g + 139 | 0] >= 0)
                                                                    break b;
                                                                  Sr(e[g + 128 >> 2]);
                                                                }
                                                                if ($[g + 11 | 0] >= 0)
                                                                  break o;
                                                                Sr(e[g >> 2]);
                                                                break o;
                                                              }
                                                              y = Vr() | 0;
                                                              break o;
                                                            }
                                                            y = Vr() | 0;
                                                            break o;
                                                          }
                                                          y = Vr() | 0;
                                                          break o;
                                                        }
                                                        y = Vr() | 0;
                                                      }
                                                      if ($[g + 27 | 0] >= 0)
                                                        break o;
                                                      Sr(e[g + 16 >> 2]);
                                                      break o;
                                                    }
                                                    y = Vr() | 0;
                                                  }
                                                  if ($[g + 83 | 0] >= 0)
                                                    break o;
                                                  Sr(e[g + 72 >> 2]);
                                                  break o;
                                                }
                                                Sr(Fe);
                                              }
                                              if (e[5996] = 0, On(97, g + 144 | 0, 3719) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                break a;
                                            }
                                            if (hr)
                                              break c;
                                          }
                                          if (y = ye[g + 155 | 0], S = y << 24 >> 24, G = (S | 0) < 0, (G ? e[g + 148 >> 2] : y) - ln >>> 0 < 81 || (y = 0, $[(G ? e[g + 144 >> 2] : g + 144 | 0) + Mn | 0] = 10, ln = Mn + 1 | 0, (h | 0) <= 0))
                                            break c;
                                          for (; ; ) {
                                            if (e[5996] = 0, Si(99, g + 144 | 0, ln | 0, 5573) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                              break l;
                                            if (y = y + 1 | 0, (y | 0) == (h | 0))
                                              break;
                                          }
                                        }
                                        S = ye[g + 155 | 0], hr = ((S << 24 >> 24 < 0 ? e[g + 148 >> 2] : S) | 0) == (ln | 0), y = 0;
                                      }
                                      if (ke && Sr(ke), !!y)
                                        break;
                                    }
                                    if ((y | 0) != 3)
                                      break r;
                                  }
                                  f: {
                                    if (!hr && (e[5996] = 0, di(98, g + 144 | 0, 10), o = e[5996], e[5996] = 0, (o | 0) == 1))
                                      break f;
                                    o = e[g + 148 >> 2], e[r >> 2] = e[g + 144 >> 2], e[r + 4 >> 2] = o, e[r + 8 >> 2] = e[g + 152 >> 2];
                                    break t;
                                  }
                                  y = Vr() | 0;
                                  break n;
                                }
                                y = Vr() | 0;
                              }
                              S = ke;
                              break i;
                            }
                            S = ke;
                          }
                          y = Vr() | 0;
                        }
                        if (!S)
                          break n;
                        Sr(S);
                      }
                      $[g + 155 | 0] < 0 && Sr(e[g + 144 >> 2]), Ki(y | 0), ri();
                    }
                    if ($[g + 155 | 0] >= 0)
                      break t;
                    Sr(e[g + 144 >> 2]);
                  }
                  Yr = g + 160 | 0;
                  return;
                }
                ri();
              }
              function Q1() {
                for (var r = 0, o = 0, c = 0, h = 0, y = 0, g = 0, S = 0; o = r << 4, c = o + 22944 | 0, e[o + 22948 >> 2] = c, e[o + 22952 >> 2] = c, r = r + 1 | 0, (r | 0) != 64; )
                  ;
                zf(48), r = Yr - 16 | 0, Yr = r;
                e: {
                  if (B1(r + 12 | 0, r + 8 | 0) | 0 || (o = ia((e[r + 12 >> 2] << 2) + 4 | 0), e[6181] = o, !o) || (o = ia(e[r + 8 >> 2]), o && (c = e[6181], e[c + (e[r + 12 >> 2] << 2) >> 2] = 0, !(Qu(c | 0, o | 0) | 0))))
                    break e;
                  e[6181] = 0;
                }
                Yr = r + 16 | 0, r = xs(64), e[5998] = r, e[5999] = 62, e[6e3] = -2147483584, o = ye[3832] | ye[3833] << 8 | (ye[3834] << 16 | ye[3835] << 24), c = ye[3828] | ye[3829] << 8 | (ye[3830] << 16 | ye[3831] << 24), $[r + 54 | 0] = c, $[r + 55 | 0] = c >>> 8, $[r + 56 | 0] = c >>> 16, $[r + 57 | 0] = c >>> 24, $[r + 58 | 0] = o, $[r + 59 | 0] = o >>> 8, $[r + 60 | 0] = o >>> 16, $[r + 61 | 0] = o >>> 24, o = ye[3826] | ye[3827] << 8 | (ye[3828] << 16 | ye[3829] << 24), c = ye[3822] | ye[3823] << 8 | (ye[3824] << 16 | ye[3825] << 24), $[r + 48 | 0] = c, $[r + 49 | 0] = c >>> 8, $[r + 50 | 0] = c >>> 16, $[r + 51 | 0] = c >>> 24, $[r + 52 | 0] = o, $[r + 53 | 0] = o >>> 8, $[r + 54 | 0] = o >>> 16, $[r + 55 | 0] = o >>> 24, o = ye[3818] | ye[3819] << 8 | (ye[3820] << 16 | ye[3821] << 24), c = ye[3814] | ye[3815] << 8 | (ye[3816] << 16 | ye[3817] << 24), $[r + 40 | 0] = c, $[r + 41 | 0] = c >>> 8, $[r + 42 | 0] = c >>> 16, $[r + 43 | 0] = c >>> 24, $[r + 44 | 0] = o, $[r + 45 | 0] = o >>> 8, $[r + 46 | 0] = o >>> 16, $[r + 47 | 0] = o >>> 24, o = ye[3810] | ye[3811] << 8 | (ye[3812] << 16 | ye[3813] << 24), c = ye[3806] | ye[3807] << 8 | (ye[3808] << 16 | ye[3809] << 24), $[r + 32 | 0] = c, $[r + 33 | 0] = c >>> 8, $[r + 34 | 0] = c >>> 16, $[r + 35 | 0] = c >>> 24, $[r + 36 | 0] = o, $[r + 37 | 0] = o >>> 8, $[r + 38 | 0] = o >>> 16, $[r + 39 | 0] = o >>> 24, o = ye[3802] | ye[3803] << 8 | (ye[3804] << 16 | ye[3805] << 24), c = ye[3798] | ye[3799] << 8 | (ye[3800] << 16 | ye[3801] << 24), $[r + 24 | 0] = c, $[r + 25 | 0] = c >>> 8, $[r + 26 | 0] = c >>> 16, $[r + 27 | 0] = c >>> 24, $[r + 28 | 0] = o, $[r + 29 | 0] = o >>> 8, $[r + 30 | 0] = o >>> 16, $[r + 31 | 0] = o >>> 24, o = ye[3794] | ye[3795] << 8 | (ye[3796] << 16 | ye[3797] << 24), c = ye[3790] | ye[3791] << 8 | (ye[3792] << 16 | ye[3793] << 24), $[r + 16 | 0] = c, $[r + 17 | 0] = c >>> 8, $[r + 18 | 0] = c >>> 16, $[r + 19 | 0] = c >>> 24, $[r + 20 | 0] = o, $[r + 21 | 0] = o >>> 8, $[r + 22 | 0] = o >>> 16, $[r + 23 | 0] = o >>> 24, o = ye[3786] | ye[3787] << 8 | (ye[3788] << 16 | ye[3789] << 24), c = ye[3782] | ye[3783] << 8 | (ye[3784] << 16 | ye[3785] << 24), $[r + 8 | 0] = c, $[r + 9 | 0] = c >>> 8, $[r + 10 | 0] = c >>> 16, $[r + 11 | 0] = c >>> 24, $[r + 12 | 0] = o, $[r + 13 | 0] = o >>> 8, $[r + 14 | 0] = o >>> 16, $[r + 15 | 0] = o >>> 24, o = ye[3778] | ye[3779] << 8 | (ye[3780] << 16 | ye[3781] << 24), c = ye[3774] | ye[3775] << 8 | (ye[3776] << 16 | ye[3777] << 24), $[r | 0] = c, $[r + 1 | 0] = c >>> 8, $[r + 2 | 0] = c >>> 16, $[r + 3 | 0] = c >>> 24, $[r + 4 | 0] = o, $[r + 5 | 0] = o >>> 8, $[r + 6 | 0] = o >>> 16, $[r + 7 | 0] = o >>> 24, $[r + 62 | 0] = 0, r = ye[24003], o = r << 24 >> 24;
                e: {
                  t: {
                    if (h = (o | 0) < 0 ? e[5999] : r, r = h + 12 | 0, r >>> 0 < 2147483632) {
                      r: {
                        if (r >>> 0 <= 10) {
                          e[6004] = 0, e[6005] = 0, e[6006] = 0, $[24027] = r, c = 24016;
                          break r;
                        }
                        y = (r | 15) + 1 | 0, c = xs(y), e[6005] = r, e[6004] = c, e[6006] = y | -2147483648;
                      }
                      r = c, c = (o | 0) >= 0 ? 23992 : e[5998], r = Ks(r, c, h) + h | 0, $[r + 12 | 0] = 0, o = ye[5207] | ye[5208] << 8 | (ye[5209] << 16 | ye[5210] << 24), $[r + 8 | 0] = o, $[r + 9 | 0] = o >>> 8, $[r + 10 | 0] = o >>> 16, $[r + 11 | 0] = o >>> 24, o = ye[5203] | ye[5204] << 8 | (ye[5205] << 16 | ye[5206] << 24), y = ye[5199] | ye[5200] << 8 | (ye[5201] << 16 | ye[5202] << 24), $[r | 0] = y, $[r + 1 | 0] = y >>> 8, $[r + 2 | 0] = y >>> 16, $[r + 3 | 0] = y >>> 24, $[r + 4 | 0] = o, $[r + 5 | 0] = o >>> 8, $[r + 6 | 0] = o >>> 16, $[r + 7 | 0] = o >>> 24;
                      r: {
                        r = h + 8 | 0;
                        n: {
                          if (r >>> 0 >= 2147483632) {
                            if (e[5996] = 0, Ri(2), o = e[5996], e[5996] = 0, r = 24028, (o | 0) == 1)
                              break n;
                            break t;
                          }
                          i: {
                            if (r >>> 0 <= 10) {
                              e[6007] = 0, e[6008] = 0, e[6009] = 0, $[24039] = r, o = 24028;
                              break i;
                            }
                            if (e[5996] = 0, y = (r | 15) + 1 | 0, o = ii(3, y | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1) {
                              r = 24028;
                              break n;
                            }
                            e[6008] = r, e[6007] = o, e[6009] = y | -2147483648;
                          }
                          if (r = Ks(o, c, h) + h | 0, $[r + 8 | 0] = 0, $[r | 0] = 32, $[r + 1 | 0] = 46, $[r + 2 | 0] = 44, $[r + 3 | 0] = 59, $[r + 4 | 0] = 45, $[r + 5 | 0] = 95, $[r + 6 | 0] = 63, $[r + 7 | 0] = 64, r = h + 3 | 0, r >>> 0 >= 2147483632) {
                            if (e[5996] = 0, Ri(2), o = e[5996], e[5996] = 0, r = 24040, (o | 0) != 1)
                              break t;
                            break n;
                          }
                          i: {
                            if (r >>> 0 <= 10) {
                              e[6010] = 0, e[6011] = 0, e[6012] = 0, $[24051] = r, o = 24040;
                              break i;
                            }
                            if (e[5996] = 0, y = (r | 15) + 1 | 0, o = ii(3, y | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1) {
                              r = 24040;
                              break n;
                            }
                            e[6011] = r, e[6010] = o, e[6012] = y | -2147483648;
                          }
                          if (r = Ks(o, c, h) + h | 0, $[r + 3 | 0] = 0, $[r + 2 | 0] = ye[2557], o = ye[2555] | ye[2556] << 8, $[r | 0] = o, $[r + 1 | 0] = o >>> 8, r = h + 23 | 0, r >>> 0 >= 2147483632) {
                            if (e[5996] = 0, Ri(2), o = e[5996], e[5996] = 0, r = 24052, (o | 0) != 1)
                              break t;
                            break n;
                          }
                          if (e[5996] = 0, y = (r | 15) + 1 | 0, o = ii(3, y | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) != 1)
                            break r;
                          r = 24052;
                        }
                        for (c = Vr() | 0; o = r - 12 | 0, $[r - 1 | 0] < 0 && Sr(e[o >> 2]), r = o, (r | 0) != 24016; )
                          ;
                        Ki(c | 0), ri();
                      }
                      e[6014] = r, e[6013] = o, e[6015] = y | -2147483648, r = Ks(o, c, h) + h | 0, $[r + 23 | 0] = 0, o = ye[5412] | ye[5413] << 8 | (ye[5414] << 16 | ye[5415] << 24), c = ye[5408] | ye[5409] << 8 | (ye[5410] << 16 | ye[5411] << 24), $[r + 15 | 0] = c, $[r + 16 | 0] = c >>> 8, $[r + 17 | 0] = c >>> 16, $[r + 18 | 0] = c >>> 24, $[r + 19 | 0] = o, $[r + 20 | 0] = o >>> 8, $[r + 21 | 0] = o >>> 16, $[r + 22 | 0] = o >>> 24, o = ye[5405] | ye[5406] << 8 | (ye[5407] << 16 | ye[5408] << 24), c = ye[5401] | ye[5402] << 8 | (ye[5403] << 16 | ye[5404] << 24), $[r + 8 | 0] = c, $[r + 9 | 0] = c >>> 8, $[r + 10 | 0] = c >>> 16, $[r + 11 | 0] = c >>> 24, $[r + 12 | 0] = o, $[r + 13 | 0] = o >>> 8, $[r + 14 | 0] = o >>> 16, $[r + 15 | 0] = o >>> 24, o = ye[5397] | ye[5398] << 8 | (ye[5399] << 16 | ye[5400] << 24), c = ye[5393] | ye[5394] << 8 | (ye[5395] << 16 | ye[5396] << 24), $[r | 0] = c, $[r + 1 | 0] = c >>> 8, $[r + 2 | 0] = c >>> 16, $[r + 3 | 0] = c >>> 24, $[r + 4 | 0] = o, $[r + 5 | 0] = o >>> 8, $[r + 6 | 0] = o >>> 16, $[r + 7 | 0] = o >>> 24;
                      break e;
                    }
                    ba(), ri();
                  }
                  ri();
                }
                h = Yr - 48 | 0, Yr = h, e[h + 20 >> 2] = 0, e[h + 12 >> 2] = 0, e[h + 16 >> 2] = 0, e[5996] = 0, On(9, 24064, h + 12 | 0) | 0, r = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  f: {
                                    if ((r | 0) != 1) {
                                      if (r = e[h + 12 >> 2], r && Sr(r), r = xs(32), e[h + 36 >> 2] = r, o = r + 32 | 0, e[h + 44 >> 2] = o, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, $[r | 0] = 0, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 4 | 0] = 0, $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, e[5996] = 0, e[h + 40 >> 2] = o, g = On(9, h + 12 | 0, h + 36 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                        break i;
                                      if ($[g + 5 | 0] = 1, e[6024] = e[g + 8 >> 2], r = e[g + 4 >> 2], e[6022] = e[g >> 2], e[6023] = r, e[6025] = 0, e[6026] = 0, e[6027] = 0, c = e[g + 16 >> 2], o = e[g + 12 >> 2], r = c - o | 0, y = (r | 0) / 12 | 0, (o | 0) == (c | 0))
                                        break s;
                                      if (y >>> 0 < 357913942)
                                        break f;
                                      if (e[5996] = 0, Ri(11), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                        break l;
                                      ri();
                                    }
                                    if (y = Vr() | 0, r = e[h + 12 >> 2], !r)
                                      break e;
                                    Sr(r);
                                    break e;
                                  }
                                  if (e[5996] = 0, r = ii(3, r | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                    break l;
                                  if (e[6026] = r, e[6025] = r, e[6027] = r + vi(y, 12), e[5996] = 0, o = da(12, 24108, o | 0, c | 0, r | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1)
                                    break a;
                                  y = Vr() | 0, e[6026] = r;
                                  break o;
                                }
                                y = Vr() | 0;
                              }
                              if (c = e[6025], c) {
                                if (r = e[6026], o = c, (r | 0) != (o | 0)) {
                                  for (; o = r - 12 | 0, S = e[o >> 2], S && (e[r - 8 >> 2] = S, Sr(S)), r = o, (c | 0) != (r | 0); )
                                    ;
                                  o = e[6025];
                                }
                                e[6026] = c, Sr(o);
                              }
                              if (c = e[g + 12 >> 2], !c)
                                break t;
                              if (r = e[g + 16 >> 2], o = c, (r | 0) != (o | 0)) {
                                for (; o = r - 12 | 0, S = e[o >> 2], S && (e[r - 8 >> 2] = S, Sr(S)), r = o, (c | 0) != (r | 0); )
                                  ;
                                o = e[g + 12 >> 2];
                              }
                              e[g + 16 >> 2] = c, Sr(o);
                              break t;
                            }
                            e[6026] = o, c = e[g + 12 >> 2];
                          }
                          if (c) {
                            if (r = e[g + 16 >> 2], o = c, (r | 0) != (o | 0)) {
                              for (; o = r - 12 | 0, y = e[o >> 2], y && (e[r - 8 >> 2] = y, Sr(y)), r = o, (c | 0) != (r | 0); )
                                ;
                              o = e[g + 12 >> 2];
                            }
                            e[g + 16 >> 2] = c, Sr(o);
                          }
                          if (r = e[h + 36 >> 2], r && Sr(r), r = xs(1), e[h + 36 >> 2] = r, o = r + 1 | 0, e[h + 44 >> 2] = o, $[r | 0] = 1, e[5996] = 0, e[h + 40 >> 2] = o, On(9, 24112, h + 36 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                            break n;
                          r = e[h + 36 >> 2], r && Sr(r), e[6036] = 0, e[6037] = 0, e[6034] = 1, e[6038] = 0, e[6039] = 0, $[24142] = 0, Vs[12070] = 0, e[6044] = 0, e[6045] = 0, e[6042] = -1, e[6043] = 0, $[24163] = 0, $[24164] = 0, $[24165] = 0, $[24166] = 0, e[6040] = 0, Yr = h + 48 | 0;
                          break r;
                        }
                        y = Vr() | 0;
                        break t;
                      }
                      y = Vr() | 0;
                      break t;
                    }
                    h = Yr - 48 | 0, Yr = h, e[h + 20 >> 2] = 0, e[h + 12 >> 2] = 0, e[h + 16 >> 2] = 0, e[5996] = 0, On(9, 24184, h + 12 | 0) | 0, r = e[5996], e[5996] = 0;
                    r: {
                      n: {
                        i: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  f: {
                                    d: {
                                      c: {
                                        if ((r | 0) != 1) {
                                          if (r = e[h + 12 >> 2], r && Sr(r), r = xs(32), e[h + 36 >> 2] = r, o = r + 32 | 0, e[h + 44 >> 2] = o, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, $[r | 0] = 0, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 4 | 0] = 0, $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, e[5996] = 0, e[h + 40 >> 2] = o, g = On(9, h + 12 | 0, h + 36 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                            break a;
                                          if ($[g + 5 | 0] = 1, e[6054] = e[g + 8 >> 2], r = e[g + 4 >> 2], e[6052] = e[g >> 2], e[6053] = r, e[6055] = 0, e[6056] = 0, e[6057] = 0, c = e[g + 16 >> 2], o = e[g + 12 >> 2], r = c - o | 0, y = (r | 0) / 12 | 0, (o | 0) == (c | 0))
                                            break o;
                                          if (y >>> 0 < 357913942)
                                            break c;
                                          if (e[5996] = 0, Ri(11), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                            break d;
                                          ri();
                                        }
                                        if (y = Vr() | 0, r = e[h + 12 >> 2], !r)
                                          break e;
                                        Sr(r);
                                        break e;
                                      }
                                      if (e[5996] = 0, r = ii(3, r | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                        break d;
                                      if (e[6056] = r, e[6055] = r, e[6057] = r + vi(y, 12), e[5996] = 0, o = da(12, 24228, o | 0, c | 0, r | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1)
                                        break l;
                                      y = Vr() | 0, e[6056] = r;
                                      break f;
                                    }
                                    y = Vr() | 0;
                                  }
                                  if (c = e[6055], c) {
                                    if (r = c, o = e[6056], (r | 0) != (o | 0)) {
                                      for (; r = o - 12 | 0, S = e[r >> 2], S && (e[o - 8 >> 2] = S, Sr(S)), o = r, (r | 0) != (c | 0); )
                                        ;
                                      r = e[6055];
                                    }
                                    e[6056] = c, Sr(r);
                                  }
                                  if (c = e[g + 12 >> 2], !c)
                                    break t;
                                  if (r = c, o = e[g + 16 >> 2], (r | 0) != (o | 0)) {
                                    for (; r = o - 12 | 0, S = e[r >> 2], S && (e[o - 8 >> 2] = S, Sr(S)), o = r, (r | 0) != (c | 0); )
                                      ;
                                    r = e[g + 12 >> 2];
                                  }
                                  e[g + 16 >> 2] = c, Sr(r);
                                  break t;
                                }
                                e[6056] = o, c = e[g + 12 >> 2];
                              }
                              if (c) {
                                if (r = c, o = e[g + 16 >> 2], (r | 0) != (o | 0)) {
                                  for (; r = o - 12 | 0, y = e[r >> 2], y && (e[o - 8 >> 2] = y, Sr(y)), o = r, (r | 0) != (c | 0); )
                                    ;
                                  r = e[g + 12 >> 2];
                                }
                                e[g + 16 >> 2] = c, Sr(r);
                              }
                              if (r = e[h + 36 >> 2], r && Sr(r), r = xs(1), e[h + 36 >> 2] = r, o = r + 1 | 0, e[h + 44 >> 2] = o, $[r | 0] = 1, e[5996] = 0, e[h + 40 >> 2] = o, On(9, 24232, h + 36 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                break s;
                              if (r = e[h + 36 >> 2], r && Sr(r), e[6066] = 0, e[6067] = 0, e[6064] = 1, e[6068] = 0, e[6069] = 0, $[24262] = 0, Vs[12130] = 0, e[6074] = 0, e[6075] = 0, e[6072] = -1, e[6073] = 0, $[24283] = 0, $[24284] = 0, $[24285] = 0, $[24286] = 0, e[6070] = 0, e[6076] = 0, e[6077] = 0, e[6078] = 0, o = xs(56), e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 40 >> 2] = 0, e[o + 44 >> 2] = 0, e[o + 32 >> 2] = 0, e[o + 36 >> 2] = 0, e[o + 24 >> 2] = 0, e[o + 28 >> 2] = 0, e[o + 16 >> 2] = 0, e[o + 20 >> 2] = 0, e[o + 8 >> 2] = 0, e[o + 12 >> 2] = 0, _u(24304, o), r = xs(4), e[r >> 2] = o, e[5996] = 0, o = ii(3, 56) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1)
                                break i;
                              break n;
                            }
                            y = Vr() | 0;
                            break t;
                          }
                          y = Vr() | 0;
                          break t;
                        }
                        if (e[o + 16 >> 2] = 0, e[o + 20 >> 2] = 0, e[o + 4 >> 2] = r, e[o >> 2] = 21, r = r + 4 | 0, e[o + 12 >> 2] = r, e[o + 8 >> 2] = r, e[o + 24 >> 2] = 0, e[o + 28 >> 2] = 0, e[o + 32 >> 2] = 0, e[o + 36 >> 2] = 0, e[o + 40 >> 2] = 0, e[o + 44 >> 2] = 0, _u(24304, o), e[6079] = o, o = xs(56), e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[o >> 2] = 1, e[o + 12 >> 2] = 0, e[o + 16 >> 2] = 0, e[o + 20 >> 2] = 0, e[o + 24 >> 2] = 0, e[o + 28 >> 2] = 0, e[o + 32 >> 2] = 0, e[o + 36 >> 2] = 0, e[o + 40 >> 2] = 0, e[o + 44 >> 2] = 0, _u(24304, o), r = xs(4), e[r >> 2] = o, e[5996] = 0, o = ii(3, 56) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                          break n;
                        e[o + 16 >> 2] = 0, e[o + 20 >> 2] = 0, e[o + 4 >> 2] = r, e[o >> 2] = 21, r = r + 4 | 0, e[o + 12 >> 2] = r, e[o + 8 >> 2] = r, e[o + 24 >> 2] = 0, e[o + 28 >> 2] = 0, e[o + 32 >> 2] = 0, e[o + 36 >> 2] = 0, e[o + 40 >> 2] = 0, e[o + 44 >> 2] = 0, _u(24304, o), e[6080] = o, Yr = h + 48 | 0;
                        break r;
                      }
                      o = Vr() | 0, Sr(r), Ki(o | 0), ri();
                    }
                    h = Yr - 48 | 0, Yr = h, e[h + 20 >> 2] = 0, e[h + 12 >> 2] = 0, e[h + 16 >> 2] = 0, e[5996] = 0, On(9, 24592, h + 12 | 0) | 0, r = e[5996], e[5996] = 0;
                    r: {
                      n: {
                        i: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  f: {
                                    if ((r | 0) != 1) {
                                      if (r = e[h + 12 >> 2], r && Sr(r), r = xs(32), e[h + 36 >> 2] = r, o = r + 32 | 0, e[h + 44 >> 2] = o, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, $[r | 0] = 0, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 4 | 0] = 0, $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, e[5996] = 0, e[h + 40 >> 2] = o, g = On(9, h + 12 | 0, h + 36 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                        break i;
                                      if ($[g + 5 | 0] = 1, e[6156] = e[g + 8 >> 2], r = e[g + 4 >> 2], e[6154] = e[g >> 2], e[6155] = r, e[6157] = 0, e[6158] = 0, e[6159] = 0, c = e[g + 16 >> 2], o = e[g + 12 >> 2], r = c - o | 0, y = (r | 0) / 12 | 0, (o | 0) == (c | 0))
                                        break s;
                                      if (y >>> 0 < 357913942)
                                        break f;
                                      if (e[5996] = 0, Ri(11), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                        break l;
                                      ri();
                                    }
                                    if (y = Vr() | 0, r = e[h + 12 >> 2], !r)
                                      break e;
                                    Sr(r);
                                    break e;
                                  }
                                  if (e[5996] = 0, r = ii(3, r | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                    break l;
                                  if (e[6158] = r, e[6157] = r, e[6159] = r + vi(y, 12), e[5996] = 0, o = da(12, 24636, o | 0, c | 0, r | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1)
                                    break a;
                                  y = Vr() | 0, e[6158] = r;
                                  break o;
                                }
                                y = Vr() | 0;
                              }
                              if (c = e[6157], c) {
                                if (r = e[6158], o = c, (r | 0) != (o | 0)) {
                                  for (; o = r - 12 | 0, S = e[o >> 2], S && (e[r - 8 >> 2] = S, Sr(S)), r = o, (c | 0) != (r | 0); )
                                    ;
                                  o = e[6157];
                                }
                                e[6158] = c, Sr(o);
                              }
                              if (c = e[g + 12 >> 2], !c)
                                break t;
                              if (r = e[g + 16 >> 2], o = c, (r | 0) != (o | 0)) {
                                for (; o = r - 12 | 0, S = e[o >> 2], S && (e[r - 8 >> 2] = S, Sr(S)), r = o, (c | 0) != (r | 0); )
                                  ;
                                o = e[g + 12 >> 2];
                              }
                              e[g + 16 >> 2] = c, Sr(o);
                              break t;
                            }
                            e[6158] = o, c = e[g + 12 >> 2];
                          }
                          if (c) {
                            if (r = e[g + 16 >> 2], o = c, (r | 0) != (o | 0)) {
                              for (; o = r - 12 | 0, y = e[o >> 2], y && (e[r - 8 >> 2] = y, Sr(y)), r = o, (c | 0) != (r | 0); )
                                ;
                              o = e[g + 12 >> 2];
                            }
                            e[g + 16 >> 2] = c, Sr(o);
                          }
                          if (r = e[h + 36 >> 2], r && Sr(r), r = xs(1), e[h + 36 >> 2] = r, o = r + 1 | 0, e[h + 44 >> 2] = o, $[r | 0] = 1, e[5996] = 0, e[h + 40 >> 2] = o, On(9, 24640, h + 36 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                            break n;
                          r = e[h + 36 >> 2], r && Sr(r), e[6168] = 0, e[6169] = 0, e[6166] = 1, e[6170] = 0, e[6171] = 0, $[24670] = 0, Vs[12334] = 0, e[6176] = 0, e[6177] = 0, e[6174] = -1, e[6175] = 0, $[24691] = 0, $[24692] = 0, $[24693] = 0, $[24694] = 0, e[6172] = 0, Yr = h + 48 | 0;
                          break r;
                        }
                        y = Vr() | 0;
                        break t;
                      }
                      y = Vr() | 0;
                      break t;
                    }
                    e[6178] = 24816;
                    return;
                  }
                  if (r = e[h + 36 >> 2], !r)
                    break e;
                  Sr(r);
                }
                Ki(y | 0), ri();
              }
              function U1(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0;
                S = Yr - 96 | 0, Yr = S, e[S + 36 >> 2] = 0, e[S + 28 >> 2] = 0, e[S + 32 >> 2] = 0, e[5996] = 0, Ar = ii(3, 12) | 0, c = e[5996], e[5996] = 0;
                e: {
                  if ((c | 0) != 1) {
                    ci = S + 36 | 0, $[Ar + 8 | 0] = 0, e[Ar + 4 >> 2] = 0, e[Ar >> 2] = o, g = Ar + 12 | 0, ei = g;
                    t: {
                      for (; ; ) {
                        ke = g - 12 | 0, c = ke, Fe = e[c + 4 >> 2], ln = e[c >> 2], h = e[ln + 32 >> 2];
                        r: {
                          n: {
                            i: {
                              if (G = e[ln + 36 >> 2] - h >> 3, G >>> 0 > Fe >>> 0) {
                                o = 1, e[c + 4 >> 2] = Fe + 1, y = ye[g - 4 | 0];
                                s: {
                                  a: {
                                    o:
                                      switch (c = e[ln >> 2], c - 11 | 0) {
                                        case 0:
                                          break a;
                                        case 3:
                                          break s;
                                        default:
                                          break o;
                                      }
                                    if (o = 0, (Fe | 0) != 1 | (c | 0) != 17)
                                      break s;
                                  }
                                  o = (y | 0) != 0;
                                }
                                if (Fe = e[h + (Fe << 3) >> 2], g >>> 0 < ei >>> 0) {
                                  $[g + 8 | 0] = o, e[g + 4 >> 2] = 0, e[g >> 2] = Fe, g = g + 12 | 0;
                                  break r;
                                }
                                s: {
                                  h = (g - Ar | 0) / 12 | 0, ke = h + 1 | 0;
                                  a: {
                                    if (ke >>> 0 >= 357913942) {
                                      if (e[5996] = 0, Ri(121), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                        break a;
                                      break e;
                                    }
                                    if (y = (ei - Ar | 0) / 12 | 0, c = y << 1, c = y >>> 0 >= 178956970 ? 357913941 : c >>> 0 > ke >>> 0 ? c : ke, c >>> 0 < 357913942)
                                      break s;
                                    if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                      break e;
                                  }
                                  hr = Vr() | 0;
                                  break t;
                                }
                                if (e[5996] = 0, ke = vi(c, 12), G = ii(3, ke | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                  break i;
                                if (c = G + vi(h, 12) | 0, $[c + 8 | 0] = o, e[c + 4 >> 2] = 0, e[c >> 2] = Fe, o = c, (g | 0) != (Ar | 0))
                                  for (; g = g - 12 | 0, h = g, y = e[h + 4 >> 2], o = o - 12 | 0, e[o >> 2] = e[h >> 2], e[o + 4 >> 2] = y, e[o + 8 >> 2] = e[h + 8 >> 2], (h | 0) != (Ar | 0); )
                                    ;
                                ei = G + ke | 0, g = c + 12 | 0, Ar && Sr(Ar), Ar = o;
                                break r;
                              }
                              if (y = e[S + 28 >> 2], c = e[S + 32 >> 2] - y >> 5, c >>> 0 < G >>> 0) {
                                if (e[5996] = 0, Qs(44, 5135, 2210, 439, 2439), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                  break e;
                                hr = Vr() | 0;
                                break t;
                              }
                              if (o = ye[g - 4 | 0], e[5996] = 0, eu(122, S + 40 | 0, o | 0, ln | 0, (y + (c << 5) | 0) - (G << 5) | 0, G | 0), o = e[5996], e[5996] = 0, (o | 0) == 1) {
                                hr = Vr() | 0;
                                break t;
                              }
                              o = e[S + 64 >> 2], e[S + 16 >> 2] = e[S + 60 >> 2], e[S + 20 >> 2] = o, e[S + 24 >> 2] = e[S + 68 >> 2], o = e[S + 56 >> 2], e[S + 8 >> 2] = e[S + 52 >> 2], e[S + 12 >> 2] = o, Rn = e[S + 48 >> 2], Tr = e[S + 44 >> 2], Fe = e[S + 40 >> 2], o = e[S + 32 >> 2], y = e[ln + 36 >> 2], c = e[ln + 32 >> 2];
                              s: {
                                if ((y | 0) == (c | 0)) {
                                  c = o;
                                  break s;
                                }
                                if (y = y - c << 2, c = o - y | 0, g = c + (y & -32) | 0, (g | 0) != (o | 0))
                                  for (; h = S - -64 | 0, e[h >> 2] = ye[c + 28 | 0] | ye[c + 29 | 0] << 8 | (ye[c + 30 | 0] << 16 | ye[c + 31 | 0] << 24), y = ye[c + 24 | 0] | ye[c + 25 | 0] << 8 | (ye[c + 26 | 0] << 16 | ye[c + 27 | 0] << 24), e[S + 56 >> 2] = ye[c + 20 | 0] | ye[c + 21 | 0] << 8 | (ye[c + 22 | 0] << 16 | ye[c + 23 | 0] << 24), e[S + 60 >> 2] = y, y = ye[c + 16 | 0] | ye[c + 17 | 0] << 8 | (ye[c + 18 | 0] << 16 | ye[c + 19 | 0] << 24), e[S + 48 >> 2] = ye[c + 12 | 0] | ye[c + 13 | 0] << 8 | (ye[c + 14 | 0] << 16 | ye[c + 15 | 0] << 24), e[S + 52 >> 2] = y, y = ye[c + 8 | 0] | ye[c + 9 | 0] << 8 | (ye[c + 10 | 0] << 16 | ye[c + 11 | 0] << 24), e[S + 40 >> 2] = ye[c + 4 | 0] | ye[c + 5 | 0] << 8 | (ye[c + 6 | 0] << 16 | ye[c + 7 | 0] << 24), e[S + 44 >> 2] = y, y = ye[g + 28 | 0] | ye[g + 29 | 0] << 8 | (ye[g + 30 | 0] << 16 | ye[g + 31 | 0] << 24), $[c + 28 | 0] = y, $[c + 29 | 0] = y >>> 8, $[c + 30 | 0] = y >>> 16, $[c + 31 | 0] = y >>> 24, G = ye[g + 24 | 0] | ye[g + 25 | 0] << 8 | (ye[g + 26 | 0] << 16 | ye[g + 27 | 0] << 24), y = ye[g + 20 | 0] | ye[g + 21 | 0] << 8 | (ye[g + 22 | 0] << 16 | ye[g + 23 | 0] << 24), $[c + 20 | 0] = y, $[c + 21 | 0] = y >>> 8, $[c + 22 | 0] = y >>> 16, $[c + 23 | 0] = y >>> 24, $[c + 24 | 0] = G, $[c + 25 | 0] = G >>> 8, $[c + 26 | 0] = G >>> 16, $[c + 27 | 0] = G >>> 24, G = ye[g + 16 | 0] | ye[g + 17 | 0] << 8 | (ye[g + 18 | 0] << 16 | ye[g + 19 | 0] << 24), y = ye[g + 12 | 0] | ye[g + 13 | 0] << 8 | (ye[g + 14 | 0] << 16 | ye[g + 15 | 0] << 24), $[c + 12 | 0] = y, $[c + 13 | 0] = y >>> 8, $[c + 14 | 0] = y >>> 16, $[c + 15 | 0] = y >>> 24, $[c + 16 | 0] = G, $[c + 17 | 0] = G >>> 8, $[c + 18 | 0] = G >>> 16, $[c + 19 | 0] = G >>> 24, G = ye[g + 8 | 0] | ye[g + 9 | 0] << 8 | (ye[g + 10 | 0] << 16 | ye[g + 11 | 0] << 24), y = ye[g + 4 | 0] | ye[g + 5 | 0] << 8 | (ye[g + 6 | 0] << 16 | ye[g + 7 | 0] << 24), $[c + 4 | 0] = y, $[c + 5 | 0] = y >>> 8, $[c + 6 | 0] = y >>> 16, $[c + 7 | 0] = y >>> 24, $[c + 8 | 0] = G, $[c + 9 | 0] = G >>> 8, $[c + 10 | 0] = G >>> 16, $[c + 11 | 0] = G >>> 24, y = e[h >> 2], $[g + 28 | 0] = y, $[g + 29 | 0] = y >>> 8, $[g + 30 | 0] = y >>> 16, $[g + 31 | 0] = y >>> 24, h = e[S + 60 >> 2], y = e[S + 56 >> 2], $[g + 20 | 0] = y, $[g + 21 | 0] = y >>> 8, $[g + 22 | 0] = y >>> 16, $[g + 23 | 0] = y >>> 24, $[g + 24 | 0] = h, $[g + 25 | 0] = h >>> 8, $[g + 26 | 0] = h >>> 16, $[g + 27 | 0] = h >>> 24, h = e[S + 52 >> 2], y = e[S + 48 >> 2], $[g + 12 | 0] = y, $[g + 13 | 0] = y >>> 8, $[g + 14 | 0] = y >>> 16, $[g + 15 | 0] = y >>> 24, $[g + 16 | 0] = h, $[g + 17 | 0] = h >>> 8, $[g + 18 | 0] = h >>> 16, $[g + 19 | 0] = h >>> 24, h = e[S + 44 >> 2], y = e[S + 40 >> 2], $[g + 4 | 0] = y, $[g + 5 | 0] = y >>> 8, $[g + 6 | 0] = y >>> 16, $[g + 7 | 0] = y >>> 24, $[g + 8 | 0] = h, $[g + 9 | 0] = h >>> 8, $[g + 10 | 0] = h >>> 16, $[g + 11 | 0] = h >>> 24, y = e[c >> 2], e[c >> 2] = e[g >> 2], e[g >> 2] = y, c = c + 32 | 0, g = g + 32 | 0, (g | 0) != (o | 0); )
                                    ;
                                if ((o | 0) != (c | 0))
                                  for (; y = o - 32 | 0, (ye[y | 0] | ye[y + 1 | 0] << 8 | (ye[y + 2 | 0] << 16 | ye[y + 3 | 0] << 24)) >>> 0 >= 29 && (o = o - 24 | 0, Sr(ye[o | 0] | ye[o + 1 | 0] << 8 | (ye[o + 2 | 0] << 16 | ye[o + 3 | 0] << 24)), $[o | 0] = 0, $[o + 1 | 0] = 0, $[o + 2 | 0] = 0, $[o + 3 | 0] = 0), o = y, (c | 0) != (o | 0); )
                                    ;
                                e[S + 32 >> 2] = c;
                              }
                              if (g = e[S + 36 >> 2], g >>> 0 > c >>> 0) {
                                $[c + 4 | 0] = 0, $[c + 5 | 0] = 0, $[c + 6 | 0] = 0, $[c + 7 | 0] = 0, $[c + 8 | 0] = 0, $[c + 9 | 0] = 0, $[c + 10 | 0] = 0, $[c + 11 | 0] = 0, $[c + 28 | 0] = 0, $[c + 29 | 0] = 0, $[c + 30 | 0] = 0, $[c + 31 | 0] = 0, $[c + 20 | 0] = 0, $[c + 21 | 0] = 0, $[c + 22 | 0] = 0, $[c + 23 | 0] = 0, $[c + 24 | 0] = 0, $[c + 25 | 0] = 0, $[c + 26 | 0] = 0, $[c + 27 | 0] = 0, $[c + 12 | 0] = 0, $[c + 13 | 0] = 0, $[c + 14 | 0] = 0, $[c + 15 | 0] = 0, $[c + 16 | 0] = 0, $[c + 17 | 0] = 0, $[c + 18 | 0] = 0, $[c + 19 | 0] = 0, $[c + 8 | 0] = Rn, $[c + 9 | 0] = Rn >>> 8, $[c + 10 | 0] = Rn >>> 16, $[c + 11 | 0] = Rn >>> 24, $[c + 4 | 0] = Tr, $[c + 5 | 0] = Tr >>> 8, $[c + 6 | 0] = Tr >>> 16, $[c + 7 | 0] = Tr >>> 24, y = e[S + 12 >> 2], o = e[S + 8 >> 2], $[c + 12 | 0] = o, $[c + 13 | 0] = o >>> 8, $[c + 14 | 0] = o >>> 16, $[c + 15 | 0] = o >>> 24, $[c + 16 | 0] = y, $[c + 17 | 0] = y >>> 8, $[c + 18 | 0] = y >>> 16, $[c + 19 | 0] = y >>> 24, y = e[S + 20 >> 2], o = e[S + 16 >> 2], $[c + 20 | 0] = o, $[c + 21 | 0] = o >>> 8, $[c + 22 | 0] = o >>> 16, $[c + 23 | 0] = o >>> 24, $[c + 24 | 0] = y, $[c + 25 | 0] = y >>> 8, $[c + 26 | 0] = y >>> 16, $[c + 27 | 0] = y >>> 24, o = e[S + 24 >> 2], $[c + 28 | 0] = o, $[c + 29 | 0] = o >>> 8, $[c + 30 | 0] = o >>> 16, $[c + 31 | 0] = o >>> 24, e[c >> 2] = Fe, e[S + 32 >> 2] = c + 32;
                                break n;
                              }
                              s: {
                                a: {
                                  o: {
                                    Mn = e[S + 28 >> 2], h = c - Mn >> 5, G = h + 1 | 0;
                                    l: {
                                      if (G >>> 0 >= 134217728) {
                                        e[5996] = 0, Ri(123);
                                        break l;
                                      }
                                      if (e[S + 92 >> 2] = ci, y = g - Mn | 0, o = y >> 4, G = y >>> 0 >= 2147483616 ? 134217727 : o >>> 0 > G >>> 0 ? o : G, !G) {
                                        o = 0;
                                        break a;
                                      }
                                      if (G >>> 0 < 134217728)
                                        break o;
                                      e[5996] = 0, Ri(35);
                                    }
                                    if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                      break e;
                                    break s;
                                  }
                                  if (e[5996] = 0, o = ii(3, G << 5) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                    break s;
                                }
                                e[S + 76 >> 2] = o, hr = (G << 5) + o | 0, e[S + 88 >> 2] = hr, G = (h << 5) + o | 0, e[S + 80 >> 2] = G, h = G, $[h + 24 | 0] = 0, $[h + 25 | 0] = 0, $[h + 26 | 0] = 0, $[h + 27 | 0] = 0, $[h + 28 | 0] = 0, $[h + 29 | 0] = 0, $[h + 30 | 0] = 0, $[h + 31 | 0] = 0, $[h + 16 | 0] = 0, $[h + 17 | 0] = 0, $[h + 18 | 0] = 0, $[h + 19 | 0] = 0, $[h + 20 | 0] = 0, $[h + 21 | 0] = 0, $[h + 22 | 0] = 0, $[h + 23 | 0] = 0, $[h + 8 | 0] = 0, $[h + 9 | 0] = 0, $[h + 10 | 0] = 0, $[h + 11 | 0] = 0, $[h + 12 | 0] = 0, $[h + 13 | 0] = 0, $[h + 14 | 0] = 0, $[h + 15 | 0] = 0, $[h | 0] = 0, $[h + 1 | 0] = 0, $[h + 2 | 0] = 0, $[h + 3 | 0] = 0, $[h + 4 | 0] = 0, $[h + 5 | 0] = 0, $[h + 6 | 0] = 0, $[h + 7 | 0] = 0, e[S + 56 >> 2] = ye[h + 28 | 0] | ye[h + 29 | 0] << 8 | (ye[h + 30 | 0] << 16 | ye[h + 31 | 0] << 24), o = ye[h + 24 | 0] | ye[h + 25 | 0] << 8 | (ye[h + 26 | 0] << 16 | ye[h + 27 | 0] << 24), e[S + 48 >> 2] = ye[h + 20 | 0] | ye[h + 21 | 0] << 8 | (ye[h + 22 | 0] << 16 | ye[h + 23 | 0] << 24), e[S + 52 >> 2] = o, o = ye[h + 16 | 0] | ye[h + 17 | 0] << 8 | (ye[h + 18 | 0] << 16 | ye[h + 19 | 0] << 24), e[S + 40 >> 2] = ye[h + 12 | 0] | ye[h + 13 | 0] << 8 | (ye[h + 14 | 0] << 16 | ye[h + 15 | 0] << 24), e[S + 44 >> 2] = o, $[h + 8 | 0] = Rn, $[h + 9 | 0] = Rn >>> 8, $[h + 10 | 0] = Rn >>> 16, $[h + 11 | 0] = Rn >>> 24, $[h + 4 | 0] = Tr, $[h + 5 | 0] = Tr >>> 8, $[h + 6 | 0] = Tr >>> 16, $[h + 7 | 0] = Tr >>> 24, o = e[S + 24 >> 2], $[h + 28 | 0] = o, $[h + 29 | 0] = o >>> 8, $[h + 30 | 0] = o >>> 16, $[h + 31 | 0] = o >>> 24, y = e[S + 20 >> 2], o = e[S + 16 >> 2], $[h + 20 | 0] = o, $[h + 21 | 0] = o >>> 8, $[h + 22 | 0] = o >>> 16, $[h + 23 | 0] = o >>> 24, $[h + 24 | 0] = y, $[h + 25 | 0] = y >>> 8, $[h + 26 | 0] = y >>> 16, $[h + 27 | 0] = y >>> 24, y = e[S + 12 >> 2], o = e[S + 8 >> 2], $[h + 12 | 0] = o, $[h + 13 | 0] = o >>> 8, $[h + 14 | 0] = o >>> 16, $[h + 15 | 0] = o >>> 24, $[h + 16 | 0] = y, $[h + 17 | 0] = y >>> 8, $[h + 18 | 0] = y >>> 16, $[h + 19 | 0] = y >>> 24, o = e[S + 52 >> 2], e[S + 16 >> 2] = e[S + 48 >> 2], e[S + 20 >> 2] = o, e[S + 24 >> 2] = e[S + 56 >> 2], o = e[S + 44 >> 2], e[S + 8 >> 2] = e[S + 40 >> 2], e[S + 12 >> 2] = o, e[h >> 2] = Fe, o = h + 32 | 0, e[S + 84 >> 2] = o;
                                a: {
                                  if ((c | 0) == (Mn | 0))
                                    y = c;
                                  else {
                                    for (; ; ) {
                                      if (o = h, h = h - 32 | 0, $[h | 0] = 0, $[h + 1 | 0] = 0, $[h + 2 | 0] = 0, $[h + 3 | 0] = 0, $[h + 4 | 0] = 0, $[h + 5 | 0] = 0, $[h + 6 | 0] = 0, $[h + 7 | 0] = 0, $[h + 24 | 0] = 0, $[h + 25 | 0] = 0, $[h + 26 | 0] = 0, $[h + 27 | 0] = 0, $[h + 28 | 0] = 0, $[h + 29 | 0] = 0, $[h + 30 | 0] = 0, $[h + 31 | 0] = 0, $[h + 16 | 0] = 0, $[h + 17 | 0] = 0, $[h + 18 | 0] = 0, $[h + 19 | 0] = 0, $[h + 20 | 0] = 0, $[h + 21 | 0] = 0, $[h + 22 | 0] = 0, $[h + 23 | 0] = 0, $[h + 8 | 0] = 0, $[h + 9 | 0] = 0, $[h + 10 | 0] = 0, $[h + 11 | 0] = 0, $[h + 12 | 0] = 0, $[h + 13 | 0] = 0, $[h + 14 | 0] = 0, $[h + 15 | 0] = 0, y = c, c = c - 32 | 0, g = ye[c | 0] | ye[c + 1 | 0] << 8 | (ye[c + 2 | 0] << 16 | ye[c + 3 | 0] << 24), e[5996] = 0, Fe = g >>> 0 < 29 ? g : g - 29 | 0, di(124, h | 0, Fe | 0), g = e[5996], e[5996] = 0, (g | 0) == 1)
                                        break a;
                                      Tr = Fe + (ye[h | 0] | ye[h + 1 | 0] << 8 | (ye[h + 2 | 0] << 16 | ye[h + 3 | 0] << 24)) | 0, $[h | 0] = Tr, $[h + 1 | 0] = Tr >>> 8, $[h + 2 | 0] = Tr >>> 16, $[h + 3 | 0] = Tr >>> 24, g = ye[c | 0] | ye[c + 1 | 0] << 8 | (ye[c + 2 | 0] << 16 | ye[c + 3 | 0] << 24), Fe = g >>> 0 < 29, ln = Fe ? g : g - 29 | 0;
                                      o: {
                                        if (!ln)
                                          break o;
                                        if (g = o - 28 | 0, o = o - 24 | 0, g = Tr >>> 0 < 29 ? g : ye[o | 0] | ye[o + 1 | 0] << 8 | (ye[o + 2 | 0] << 16 | ye[o + 3 | 0] << 24), hr = 0, o = y - 24 | 0, Fe = Fe ? y - 28 | 0 : ye[o | 0] | ye[o + 1 | 0] << 8 | (ye[o + 2 | 0] << 16 | ye[o + 3 | 0] << 24), o = Fe, y = ln & 7, y)
                                          for (; $[g | 0] = ye[o | 0], o = o + 1 | 0, g = g + 1 | 0, hr = hr + 1 | 0, (y | 0) != (hr | 0); )
                                            ;
                                        if (ln >>> 0 < 8)
                                          break o;
                                        for (y = Fe + ln | 0; $[g | 0] = ye[o | 0], $[g + 1 | 0] = ye[o + 1 | 0], $[g + 2 | 0] = ye[o + 2 | 0], $[g + 3 | 0] = ye[o + 3 | 0], $[g + 4 | 0] = ye[o + 4 | 0], $[g + 5 | 0] = ye[o + 5 | 0], $[g + 6 | 0] = ye[o + 6 | 0], $[g + 7 | 0] = ye[o + 7 | 0], g = g + 8 | 0, o = o + 8 | 0, (y | 0) != (o | 0); )
                                          ;
                                      }
                                      if ((c | 0) == (Mn | 0))
                                        break;
                                    }
                                    hr = e[S + 88 >> 2], g = e[S + 36 >> 2], o = e[S + 84 >> 2], c = e[S + 32 >> 2], y = e[S + 28 >> 2];
                                  }
                                  if (e[S + 80 >> 2] = y, e[S + 28 >> 2] = h, e[S + 32 >> 2] = o, e[S + 36 >> 2] = hr, e[S + 88 >> 2] = g, e[S + 76 >> 2] = y, e[S + 84 >> 2] = c, (c | 0) != (y | 0)) {
                                    for (; o = c - 32 | 0, e[S + 84 >> 2] = o, (ye[o | 0] | ye[o + 1 | 0] << 8 | (ye[o + 2 | 0] << 16 | ye[o + 3 | 0] << 24)) >>> 0 >= 29 && (o = c - 24 | 0, Sr(ye[o | 0] | ye[o + 1 | 0] << 8 | (ye[o + 2 | 0] << 16 | ye[o + 3 | 0] << 24)), $[o | 0] = 0, $[o + 1 | 0] = 0, $[o + 2 | 0] = 0, $[o + 3 | 0] = 0, o = e[S + 84 >> 2]), c = o, (y | 0) != (c | 0); )
                                      ;
                                    c = e[S + 76 >> 2];
                                  }
                                  if (!c)
                                    break n;
                                  Sr(c), g = ke;
                                  break r;
                                }
                                if (hr = Vr() | 0, (o | 0) != (G | 0))
                                  for (; (ye[o | 0] | ye[o + 1 | 0] << 8 | (ye[o + 2 | 0] << 16 | ye[o + 3 | 0] << 24)) >>> 0 >= 29 && (Sr(ye[o + 8 | 0] | ye[o + 9 | 0] << 8 | (ye[o + 10 | 0] << 16 | ye[o + 11 | 0] << 24)), $[o + 8 | 0] = 0, $[o + 9 | 0] = 0, $[o + 10 | 0] = 0, $[o + 11 | 0] = 0), o = o + 32 | 0, (G | 0) != (o | 0); )
                                    ;
                                if (o = e[S + 84 >> 2], c = e[S + 80 >> 2], (o | 0) != (c | 0))
                                  for (; r = o - 32 | 0, e[S + 84 >> 2] = r, (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) >>> 0 >= 29 && (r = o - 24 | 0, Sr(ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)), $[r | 0] = 0, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, r = e[S + 84 >> 2]), o = r, (c | 0) != (o | 0); )
                                    ;
                                r = e[S + 76 >> 2], r && Sr(r);
                                break t;
                              }
                              if (hr = Vr() | 0, Fe >>> 0 < 29)
                                break t;
                              Sr(Rn);
                              break t;
                            }
                            hr = Vr() | 0;
                            break t;
                          }
                          g = ke;
                        }
                        if ((g | 0) == (Ar | 0))
                          break;
                      }
                      if (o = e[S + 32 >> 2], c = e[S + 28 >> 2], (o - c | 0) != 32) {
                        if (e[5996] = 0, Qs(44, 4102, 2210, 450, 2439), r = e[5996], e[5996] = 0, (r | 0) != 1)
                          break e;
                        hr = Vr() | 0;
                        break t;
                      }
                      if ($[r | 0] = 0, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 4 | 0] = 0, $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, ke = S - -64 | 0, e[ke >> 2] = ye[r + 28 | 0] | ye[r + 29 | 0] << 8 | (ye[r + 30 | 0] << 16 | ye[r + 31 | 0] << 24), y = ye[r + 24 | 0] | ye[r + 25 | 0] << 8 | (ye[r + 26 | 0] << 16 | ye[r + 27 | 0] << 24), e[S + 56 >> 2] = ye[r + 20 | 0] | ye[r + 21 | 0] << 8 | (ye[r + 22 | 0] << 16 | ye[r + 23 | 0] << 24), e[S + 60 >> 2] = y, y = ye[r + 16 | 0] | ye[r + 17 | 0] << 8 | (ye[r + 18 | 0] << 16 | ye[r + 19 | 0] << 24), e[S + 48 >> 2] = ye[r + 12 | 0] | ye[r + 13 | 0] << 8 | (ye[r + 14 | 0] << 16 | ye[r + 15 | 0] << 24), e[S + 52 >> 2] = y, y = ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24), e[S + 40 >> 2] = ye[r + 4 | 0] | ye[r + 5 | 0] << 8 | (ye[r + 6 | 0] << 16 | ye[r + 7 | 0] << 24), e[S + 44 >> 2] = y, y = ye[c + 28 | 0] | ye[c + 29 | 0] << 8 | (ye[c + 30 | 0] << 16 | ye[c + 31 | 0] << 24), $[r + 28 | 0] = y, $[r + 29 | 0] = y >>> 8, $[r + 30 | 0] = y >>> 16, $[r + 31 | 0] = y >>> 24, h = ye[c + 24 | 0] | ye[c + 25 | 0] << 8 | (ye[c + 26 | 0] << 16 | ye[c + 27 | 0] << 24), y = ye[c + 20 | 0] | ye[c + 21 | 0] << 8 | (ye[c + 22 | 0] << 16 | ye[c + 23 | 0] << 24), $[r + 20 | 0] = y, $[r + 21 | 0] = y >>> 8, $[r + 22 | 0] = y >>> 16, $[r + 23 | 0] = y >>> 24, $[r + 24 | 0] = h, $[r + 25 | 0] = h >>> 8, $[r + 26 | 0] = h >>> 16, $[r + 27 | 0] = h >>> 24, h = ye[c + 16 | 0] | ye[c + 17 | 0] << 8 | (ye[c + 18 | 0] << 16 | ye[c + 19 | 0] << 24), y = ye[c + 12 | 0] | ye[c + 13 | 0] << 8 | (ye[c + 14 | 0] << 16 | ye[c + 15 | 0] << 24), $[r + 12 | 0] = y, $[r + 13 | 0] = y >>> 8, $[r + 14 | 0] = y >>> 16, $[r + 15 | 0] = y >>> 24, $[r + 16 | 0] = h, $[r + 17 | 0] = h >>> 8, $[r + 18 | 0] = h >>> 16, $[r + 19 | 0] = h >>> 24, h = ye[c + 8 | 0] | ye[c + 9 | 0] << 8 | (ye[c + 10 | 0] << 16 | ye[c + 11 | 0] << 24), y = ye[c + 4 | 0] | ye[c + 5 | 0] << 8 | (ye[c + 6 | 0] << 16 | ye[c + 7 | 0] << 24), $[r + 4 | 0] = y, $[r + 5 | 0] = y >>> 8, $[r + 6 | 0] = y >>> 16, $[r + 7 | 0] = y >>> 24, $[r + 8 | 0] = h, $[r + 9 | 0] = h >>> 8, $[r + 10 | 0] = h >>> 16, $[r + 11 | 0] = h >>> 24, y = e[ke >> 2], $[c + 28 | 0] = y, $[c + 29 | 0] = y >>> 8, $[c + 30 | 0] = y >>> 16, $[c + 31 | 0] = y >>> 24, ke = e[S + 60 >> 2], y = e[S + 56 >> 2], $[c + 20 | 0] = y, $[c + 21 | 0] = y >>> 8, $[c + 22 | 0] = y >>> 16, $[c + 23 | 0] = y >>> 24, $[c + 24 | 0] = ke, $[c + 25 | 0] = ke >>> 8, $[c + 26 | 0] = ke >>> 16, $[c + 27 | 0] = ke >>> 24, ke = e[S + 52 >> 2], y = e[S + 48 >> 2], $[c + 12 | 0] = y, $[c + 13 | 0] = y >>> 8, $[c + 14 | 0] = y >>> 16, $[c + 15 | 0] = y >>> 24, $[c + 16 | 0] = ke, $[c + 17 | 0] = ke >>> 8, $[c + 18 | 0] = ke >>> 16, $[c + 19 | 0] = ke >>> 24, ke = e[S + 44 >> 2], y = e[S + 40 >> 2], $[c + 4 | 0] = y, $[c + 5 | 0] = y >>> 8, $[c + 6 | 0] = y >>> 16, $[c + 7 | 0] = y >>> 24, $[c + 8 | 0] = ke, $[c + 9 | 0] = ke >>> 8, $[c + 10 | 0] = ke >>> 16, $[c + 11 | 0] = ke >>> 24, e[r >> 2] = e[c >> 2], e[c >> 2] = 0, $[r + 32 | 0] = 1, (o | 0) != (c | 0)) {
                        for (; r = o - 32 | 0, (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) >>> 0 >= 29 && (o = o - 24 | 0, Sr(ye[o | 0] | ye[o + 1 | 0] << 8 | (ye[o + 2 | 0] << 16 | ye[o + 3 | 0] << 24)), $[o | 0] = 0, $[o + 1 | 0] = 0, $[o + 2 | 0] = 0, $[o + 3 | 0] = 0), o = r, (c | 0) != (o | 0); )
                          ;
                        o = e[S + 28 >> 2];
                      }
                      e[S + 32 >> 2] = c, Sr(o), Ar && Sr(Ar), Yr = S + 96 | 0;
                      return;
                    }
                    La(S + 28 | 0), Ar && Sr(Ar), Ki(hr | 0), ri();
                  }
                  r = Vr() | 0, La(S + 28 | 0), Ki(r | 0), ri();
                }
                ri();
              }
              function M1(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0, Qi = 0, Ji = 0, ss = 0, As = 0, Rs = 0, oo = 0, Go = 0, Jo = 0, ta = 0, sa = 0;
                S = Yr - 48 | 0, Yr = S, e[S + 32 >> 2] = 0, e[S + 24 >> 2] = 0, e[S + 28 >> 2] = 0, e[5996] = 0, Rn = ii(3, 12) | 0, h = e[5996], e[5996] = 0;
                e: {
                  if ((h | 0) != 1) {
                    e[Rn + 4 >> 2] = 0, e[Rn >> 2] = o, ci = S + 40 | 0, Rs = S + 12 | 0, oo = Rn + 12 | 0, g = oo;
                    t: {
                      r: {
                        n: {
                          for (; ; ) {
                            i: {
                              sa = g - 12 | 0, o = sa, h = e[o + 4 >> 2];
                              s: {
                                a: {
                                  o: {
                                    l: {
                                      f: {
                                        if (gi = e[o >> 2], ln = e[gi + 36 >> 2], Go = e[gi + 32 >> 2], Jo = ln - Go >> 3, h >>> 0 < Jo >>> 0) {
                                          if (e[o + 4 >> 2] = h + 1, ke = e[(h << 3) + Go >> 2], g >>> 0 < oo >>> 0) {
                                            e[g + 4 >> 2] = 0, e[g >> 2] = ke, g = g + 12 | 0;
                                            break s;
                                          }
                                          d: {
                                            y = (g - Rn | 0) / 12 | 0, G = y + 1 | 0;
                                            c: {
                                              if (G >>> 0 >= 357913942) {
                                                if (e[5996] = 0, Ri(95), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                  break c;
                                                break e;
                                              }
                                              if (h = (oo - Rn | 0) / 12 | 0, o = h << 1, o = h >>> 0 >= 178956970 ? 357913941 : o >>> 0 > G >>> 0 ? o : G, o >>> 0 < 357913942)
                                                break d;
                                              if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                break e;
                                            }
                                            o = Vr() | 0;
                                            break t;
                                          }
                                          if (e[5996] = 0, G = vi(o, 12), Fe = ii(3, G | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                            break f;
                                          if (h = Fe + vi(y, 12) | 0, e[h + 4 >> 2] = 0, e[h >> 2] = ke, o = h, (g | 0) != (Rn | 0))
                                            for (; g = g - 12 | 0, y = e[g + 4 >> 2], o = o - 12 | 0, e[o >> 2] = e[g >> 2], e[o + 4 >> 2] = y, e[o + 8 >> 2] = e[g + 8 >> 2], (g | 0) != (Rn | 0); )
                                              ;
                                          oo = G + Fe | 0, g = h + 12 | 0, Rn && Sr(Rn), Rn = o;
                                          break s;
                                        }
                                        if (Ar = e[S + 24 >> 2], Fe = (e[S + 28 >> 2] - Ar | 0) / 12 | 0, Fe >>> 0 < Jo >>> 0) {
                                          if (e[5996] = 0, Qs(44, 5135, 2210, 439, 2439), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                            break e;
                                          o = Vr() | 0;
                                          break t;
                                        }
                                        if (ye[gi + 88 | 0] && e[c >> 2] != (gi | 0))
                                          break o;
                                        if (ta = e[gi + 12 >> 2], hr = e[gi + 8 >> 2], e[S + 36 >> 2] = ci, e[S + 40 >> 2] = 0, e[S + 44 >> 2] = 0, ss = (ta - hr | 0) / 12 | 0, Tr = 0, o = ci, y = 0, (hr | 0) == (ta | 0))
                                          break l;
                                        for (; ; ) {
                                          d: {
                                            c: {
                                              u: {
                                                g: {
                                                  g = ci;
                                                  A: {
                                                    if ((g | 0) == (o | 0))
                                                      break A;
                                                    h = g, o = y;
                                                    p: {
                                                      if (y) {
                                                        for (; ; )
                                                          if (g = o, o = e[o + 4 >> 2], !o)
                                                            break p;
                                                      }
                                                      for (; g = e[h + 8 >> 2], o = e[g >> 2] == (h | 0), h = g, !!o; )
                                                        ;
                                                    }
                                                    As = e[hr >> 2], Mn = ye[hr + 11 | 0], G = Mn << 24 >> 24, Qi = (G | 0) < 0, o = ye[g + 27 | 0], Ji = o << 24 >> 24 < 0;
                                                    p: {
                                                      if (h = e[hr + 4 >> 2], ei = Qi ? h : Mn, ke = Ji ? e[g + 20 >> 2] : o, o = ke >>> 0 > ei >>> 0 ? ei : ke, o && (o = pa(Ji ? e[g + 16 >> 2] : g + 16 | 0, Qi ? As : hr, o), o))
                                                        break p;
                                                      if (ke >>> 0 < ei >>> 0)
                                                        break A;
                                                      break g;
                                                    }
                                                    if ((o | 0) >= 0)
                                                      break g;
                                                  }
                                                  o = y ? g : ci, ke = y ? g + 4 | 0 : ci;
                                                  break u;
                                                }
                                                if (o = ci, ke = o, !y)
                                                  break u;
                                                for (o = (G | 0) >= 0, Qi = o ? hr : As, As = o ? Mn : h, h = y; ; ) {
                                                  o = h, g = ye[h + 27 | 0], Ji = g << 24 >> 24 < 0, Mn = Ji ? e[h + 20 >> 2] : g, ei = Mn >>> 0 < As >>> 0;
                                                  g: {
                                                    A: {
                                                      p: {
                                                        I: {
                                                          G = ei ? Mn : As;
                                                          k: {
                                                            if (G) {
                                                              if (g = Ji ? e[h + 16 >> 2] : h + 16 | 0, h = pa(Qi, g, G), !h) {
                                                                if (Mn >>> 0 > As >>> 0)
                                                                  break k;
                                                                break I;
                                                              }
                                                              if ((h | 0) >= 0)
                                                                break I;
                                                              break k;
                                                            }
                                                            if (Mn >>> 0 <= As >>> 0)
                                                              break p;
                                                          }
                                                          if (ke = o, h = e[o >> 2], h)
                                                            continue;
                                                          break c;
                                                        }
                                                        if (h = pa(g, Qi, G), h)
                                                          break A;
                                                      }
                                                      if (!ei)
                                                        break u;
                                                      break g;
                                                    }
                                                    if ((h | 0) >= 0)
                                                      break u;
                                                  }
                                                  if (ke = o + 4 | 0, h = e[o + 4 >> 2], !h)
                                                    break;
                                                }
                                                break c;
                                              }
                                              if (e[ke >> 2])
                                                break d;
                                            }
                                            e[5996] = 0, g = ii(3, 28) | 0, h = e[5996], e[5996] = 0;
                                            c: {
                                              if ((h | 0) != 1) {
                                                if (G = g + 16 | 0, $[hr + 11 | 0] >= 0) {
                                                  h = e[hr + 4 >> 2], e[G >> 2] = e[hr >> 2], e[G + 4 >> 2] = h, e[G + 8 >> 2] = e[hr + 8 >> 2];
                                                  break c;
                                                }
                                                if (y = e[hr + 4 >> 2], h = e[hr >> 2], e[5996] = 0, as(40, G | 0, h | 0, y | 0), h = e[5996], e[5996] = 0, (h | 0) != 1)
                                                  break c;
                                                o = Vr() | 0, Sr(g), Je(e[S + 40 >> 2]);
                                                break t;
                                              }
                                              o = Vr() | 0, Je(y);
                                              break t;
                                            }
                                            e[g + 8 >> 2] = o, e[g >> 2] = 0, e[g + 4 >> 2] = 0, e[ke >> 2] = g, o = e[e[S + 36 >> 2] >> 2], o && (e[S + 36 >> 2] = o, g = e[ke >> 2]), Cc(e[S + 40 >> 2], g), Tr = e[S + 44 >> 2] + 1 | 0, e[S + 44 >> 2] = Tr;
                                          }
                                          if (hr = hr + 12 | 0, (ta | 0) == (hr | 0))
                                            break l;
                                          o = e[S + 36 >> 2], y = e[S + 40 >> 2];
                                        }
                                      }
                                      o = Vr() | 0;
                                      break t;
                                    }
                                    l: {
                                      f: {
                                        if ((Tr | 0) != (ss | 0))
                                          break f;
                                        if ((ln | 0) != (Go | 0))
                                          for (Qi = Ar + vi(Fe, 12) | 0, Tr = Qi + vi(Jo, -12) | 0; ; ) {
                                            if (h = e[Tr + 8 >> 2], h >>> 0 > ss >>> 0 && (o = e[S + 36 >> 2], e[S + 36 >> 2] = e[Tr >> 2], e[Tr >> 2] = o, o = e[S + 40 >> 2], e[S + 40 >> 2] = e[Tr + 4 >> 2], e[Tr + 4 >> 2] = o, o = e[S + 44 >> 2], e[S + 44 >> 2] = h, e[Tr + 8 >> 2] = o, e[(e[S + 44 >> 2] ? e[S + 40 >> 2] + 8 | 0 : S + 36 | 0) >> 2] = ci, e[(o ? e[Tr + 4 >> 2] + 8 | 0 : Tr) >> 2] = Tr + 4), ss = h + ss | 0, Fe = e[Tr >> 2], Ji = Tr + 4 | 0, (Fe | 0) != (Ji | 0))
                                              for (; ; ) {
                                                G = 0, h = e[S + 40 >> 2];
                                                d: {
                                                  if (!h) {
                                                    g = ci, hr = g;
                                                    break d;
                                                  }
                                                  for (y = ye[Fe + 27 | 0], o = y << 24 >> 24 >= 0, ln = o ? Fe + 16 | 0 : e[Fe + 16 >> 2], Mn = o ? y : e[Fe + 20 >> 2], hr = ci; ; ) {
                                                    g = h, o = ye[h + 27 | 0], Ar = o << 24 >> 24 < 0, ei = Ar ? e[h + 20 >> 2] : o, ke = ei >>> 0 < Mn >>> 0;
                                                    c: {
                                                      u: {
                                                        g: {
                                                          A: {
                                                            y = ke ? ei : Mn;
                                                            p: {
                                                              if (y) {
                                                                if (h = Ar ? e[h + 16 >> 2] : h + 16 | 0, o = pa(ln, h, y), !o) {
                                                                  if (Mn >>> 0 < ei >>> 0)
                                                                    break p;
                                                                  break A;
                                                                }
                                                                if ((o | 0) >= 0)
                                                                  break A;
                                                                break p;
                                                              }
                                                              if (Mn >>> 0 >= ei >>> 0)
                                                                break g;
                                                            }
                                                            if (hr = g, h = e[g >> 2], h)
                                                              continue;
                                                            break d;
                                                          }
                                                          if (o = pa(h, ln, y), o)
                                                            break u;
                                                        }
                                                        if (ke)
                                                          break c;
                                                        G = g;
                                                        break d;
                                                      }
                                                      if ((o | 0) < 0)
                                                        break c;
                                                      G = g;
                                                      break d;
                                                    }
                                                    if (hr = g + 4 | 0, h = e[g + 4 >> 2], !h)
                                                      break;
                                                  }
                                                }
                                                y = Fe, ke = e[y + 4 >> 2], h = ke;
                                                d: {
                                                  if (h) {
                                                    for (; ; )
                                                      if (o = h, h = e[h >> 2], !h)
                                                        break d;
                                                  }
                                                  for (; o = e[y + 8 >> 2], h = e[o >> 2] != (y | 0), y = o, !!h; )
                                                    ;
                                                }
                                                if (!G) {
                                                  y = Fe;
                                                  d: {
                                                    if (ke) {
                                                      for (; ; )
                                                        if (h = ke, ke = e[h >> 2], !ke)
                                                          break d;
                                                    }
                                                    for (; h = e[y + 8 >> 2], G = e[h >> 2] != (y | 0), y = h, !!G; )
                                                      ;
                                                  }
                                                  e[Tr >> 2] == (Fe | 0) && (e[Tr >> 2] = h), e[Tr + 8 >> 2] = e[Tr + 8 >> 2] - 1, ke = e[Tr + 4 >> 2];
                                                  d: {
                                                    c: {
                                                      if (y = Fe, G = e[y >> 2], G) {
                                                        if (h = e[y + 4 >> 2], !h)
                                                          break c;
                                                        for (; y = h, h = e[h >> 2], !!h; )
                                                          ;
                                                      }
                                                      if (G = e[y + 4 >> 2], G)
                                                        break c;
                                                      G = 0, Ar = 1;
                                                      break d;
                                                    }
                                                    e[G + 8 >> 2] = e[y + 8 >> 2], Ar = 0;
                                                  }
                                                  ln = e[y + 8 >> 2], h = e[ln >> 2];
                                                  d: {
                                                    if ((y | 0) == (h | 0)) {
                                                      if (e[ln >> 2] = G, (y | 0) == (ke | 0)) {
                                                        h = 0, ke = G;
                                                        break d;
                                                      }
                                                      h = e[ln + 4 >> 2];
                                                      break d;
                                                    }
                                                    e[ln + 4 >> 2] = G;
                                                  }
                                                  Mn = !ye[y + 12 | 0], (y | 0) != (Fe | 0) && (ln = e[Fe + 8 >> 2], e[y + 8 >> 2] = ln, e[ln + ((e[e[Fe + 8 >> 2] >> 2] != (Fe | 0)) << 2) >> 2] = y, ln = e[Fe >> 2], e[y >> 2] = ln, e[ln + 8 >> 2] = y, ln = e[Fe + 4 >> 2], e[y + 4 >> 2] = ln, ln && (e[ln + 8 >> 2] = y), $[y + 12 | 0] = ye[Fe + 12 | 0], ke = (ke | 0) == (Fe | 0) ? y : ke);
                                                  d: {
                                                    if (Mn | !ke)
                                                      break d;
                                                    if (!Ar) {
                                                      $[G + 12 | 0] = 1;
                                                      break d;
                                                    }
                                                    c: {
                                                      u: {
                                                        for (; ; ) {
                                                          g: {
                                                            y = ye[h + 12 | 0], Ar = e[h + 8 >> 2];
                                                            A: {
                                                              if (e[Ar >> 2] != (h | 0)) {
                                                                y || ($[h + 12 | 0] = 1, $[Ar + 12 | 0] = 0, G = e[Ar + 4 >> 2], y = e[G >> 2], e[Ar + 4 >> 2] = y, y && (e[y + 8 >> 2] = Ar), e[G + 8 >> 2] = e[Ar + 8 >> 2], y = e[Ar + 8 >> 2], e[(((Ar | 0) != e[y >> 2]) << 2) + y >> 2] = G, e[G >> 2] = Ar, e[Ar + 8 >> 2] = G, y = h, h = e[h >> 2], ke = (h | 0) == (ke | 0) ? y : ke, h = e[h + 4 >> 2]), y = e[h >> 2];
                                                                p: {
                                                                  if (!(!ye[y + 12 | 0] && y)) {
                                                                    if (G = e[h + 4 >> 2], !(!G | ye[G + 12 | 0])) {
                                                                      y = h;
                                                                      break p;
                                                                    }
                                                                    if ($[h + 12 | 0] = 0, h = e[h + 8 >> 2], (ke | 0) == (h | 0)) {
                                                                      $[ke + 12 | 0] = 1;
                                                                      break d;
                                                                    }
                                                                    if (ye[h + 12 | 0])
                                                                      break A;
                                                                    $[h + 12 | 0] = 1;
                                                                    break d;
                                                                  }
                                                                  if (G = e[h + 4 >> 2], !(!G | ye[G + 12 | 0])) {
                                                                    y = h;
                                                                    break p;
                                                                  }
                                                                  $[y + 12 | 0] = 1, $[h + 12 | 0] = 0, G = e[y + 4 >> 2], e[h >> 2] = G, G && (e[G + 8 >> 2] = h), e[y + 8 >> 2] = e[h + 8 >> 2], G = e[h + 8 >> 2], e[((e[G >> 2] != (h | 0)) << 2) + G >> 2] = y, e[y + 4 >> 2] = h, e[h + 8 >> 2] = y, G = h;
                                                                }
                                                                ke = e[y + 8 >> 2], $[y + 12 | 0] = ye[ke + 12 | 0], $[ke + 12 | 0] = 1, $[G + 12 | 0] = 1, y = e[ke + 4 >> 2], h = e[y >> 2], e[ke + 4 >> 2] = h, h && (e[h + 8 >> 2] = ke), e[y + 8 >> 2] = e[ke + 8 >> 2], h = e[ke + 8 >> 2], e[(((ke | 0) != e[h >> 2]) << 2) + h >> 2] = y, e[y >> 2] = ke, e[ke + 8 >> 2] = y;
                                                                break d;
                                                              }
                                                              if (y || ($[h + 12 | 0] = 1, $[Ar + 12 | 0] = 0, y = e[h + 4 >> 2], e[Ar >> 2] = y, y && (e[y + 8 >> 2] = Ar), e[h + 8 >> 2] = e[Ar + 8 >> 2], y = e[Ar + 8 >> 2], e[(((Ar | 0) != e[y >> 2]) << 2) + y >> 2] = h, e[h + 4 >> 2] = Ar, e[Ar + 8 >> 2] = h, ke = (ke | 0) == (Ar | 0) ? h : ke, h = e[Ar >> 2]), G = e[h >> 2], !(!G | ye[G + 12 | 0])) {
                                                                y = h;
                                                                break c;
                                                              }
                                                              if (y = e[h + 4 >> 2], !ye[y + 12 | 0] && y)
                                                                break u;
                                                              if ($[h + 12 | 0] = 0, h = e[h + 8 >> 2], !ye[h + 12 | 0] | (h | 0) == (ke | 0))
                                                                break g;
                                                            }
                                                            y = h, h = e[h + 8 >> 2], h = e[(((y | 0) == e[h >> 2]) << 2) + h >> 2];
                                                            continue;
                                                          }
                                                          break;
                                                        }
                                                        $[h + 12 | 0] = 1;
                                                        break d;
                                                      }
                                                      if (!(ye[G + 12 | 0] | !G)) {
                                                        y = h;
                                                        break c;
                                                      }
                                                      $[y + 12 | 0] = 1, $[h + 12 | 0] = 0, G = e[y >> 2], e[h + 4 >> 2] = G, G && (e[G + 8 >> 2] = h), e[y + 8 >> 2] = e[h + 8 >> 2], G = e[h + 8 >> 2], e[((e[G >> 2] != (h | 0)) << 2) + G >> 2] = y, e[y >> 2] = h, e[h + 8 >> 2] = y, G = h;
                                                    }
                                                    ke = e[y + 8 >> 2], $[y + 12 | 0] = ye[ke + 12 | 0], $[ke + 12 | 0] = 1, $[G + 12 | 0] = 1, y = e[ke >> 2], h = e[y + 4 >> 2], e[ke >> 2] = h, h && (e[h + 8 >> 2] = ke), e[y + 8 >> 2] = e[ke + 8 >> 2], h = e[ke + 8 >> 2], e[(((ke | 0) != e[h >> 2]) << 2) + h >> 2] = y, e[y + 4 >> 2] = ke, e[ke + 8 >> 2] = y;
                                                  }
                                                  e[Fe + 8 >> 2] = g, e[Fe >> 2] = 0, e[Fe + 4 >> 2] = 0, e[hr >> 2] = Fe, h = e[e[S + 36 >> 2] >> 2], h && (e[S + 36 >> 2] = h, Fe = e[hr >> 2]), Cc(e[S + 40 >> 2], Fe), e[S + 44 >> 2] = e[S + 44 >> 2] + 1;
                                                }
                                                if (Fe = o, (o | 0) == (Ji | 0))
                                                  break;
                                              }
                                            if (e[S + 44 >> 2] != (ss | 0))
                                              break f;
                                            if (Tr = Tr + 12 | 0, (Qi | 0) == (Tr | 0))
                                              break;
                                          }
                                        e[S + 8 >> 2] = e[S + 36 >> 2], e[S + 16 >> 2] = ss, o = e[S + 40 >> 2], e[S + 12 >> 2] = o;
                                        d: {
                                          if (!ss) {
                                            e[S + 8 >> 2] = Rs;
                                            break d;
                                          }
                                          e[o + 8 >> 2] = Rs, e[S + 40 >> 2] = 0, e[S + 44 >> 2] = 0, e[S + 36 >> 2] = ci;
                                        }
                                        o = 1;
                                        break l;
                                      }
                                      $[S + 8 | 0] = 0, o = 0;
                                    }
                                    if ($[S + 20 | 0] = o, Je(e[S + 40 >> 2]), ye[S + 20 | 0])
                                      break a;
                                  }
                                  $[r + 12 | 0] = 0, $[r | 0] = 0;
                                  break r;
                                }
                                h = e[S + 28 >> 2], G = e[gi + 36 >> 2] - e[gi + 32 >> 2] >> 3, y = e[S + 24 >> 2], o = ((h + vi(G, -12) | 0) - y | 0) / 12 | 0;
                                a: {
                                  if (!vi(G, -12)) {
                                    g = h;
                                    break a;
                                  }
                                  if (ke = y + vi(o, 12) | 0, g = ke, o = g + vi((vi(G, 12) | 0) / 12 | 0, 12) | 0, (h | 0) != (o | 0)) {
                                    for (; ; ) {
                                      Je(e[g + 4 >> 2]), e[g >> 2] = e[o >> 2], G = e[o + 4 >> 2], e[g + 4 >> 2] = G, y = e[o + 8 >> 2], e[g + 8 >> 2] = y, Fe = g + 4 | 0;
                                      o: {
                                        if (!y) {
                                          e[g >> 2] = Fe;
                                          break o;
                                        }
                                        e[G + 8 >> 2] = Fe, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[o >> 2] = o + 4;
                                      }
                                      if (g = g + 12 | 0, o = o + 12 | 0, (h | 0) == (o | 0))
                                        break;
                                    }
                                    h = e[S + 28 >> 2];
                                  }
                                  if (g = ke + vi((g - ke | 0) / 12 | 0, 12) | 0, (g | 0) != (h | 0))
                                    for (; h = h - 12 | 0, Je(e[h + 4 >> 2]), (h | 0) != (g | 0); )
                                      ;
                                  e[S + 28 >> 2] = g;
                                }
                                o = e[S + 32 >> 2];
                                a: {
                                  if (o >>> 0 > g >>> 0) {
                                    e[g >> 2] = e[S + 8 >> 2], h = e[S + 12 >> 2], e[g + 4 >> 2] = h, o = e[S + 16 >> 2], e[g + 8 >> 2] = o, y = g + 4 | 0;
                                    o: {
                                      if (!o) {
                                        e[g >> 2] = y;
                                        break o;
                                      }
                                      e[h + 8 >> 2] = y, e[S + 12 >> 2] = 0, e[S + 16 >> 2] = 0, e[S + 8 >> 2] = Rs;
                                    }
                                    e[S + 28 >> 2] = g + 12;
                                    break a;
                                  }
                                  o: {
                                    l: {
                                      Ar = e[S + 24 >> 2], G = (g - Ar | 0) / 12 | 0, y = G + 1 | 0;
                                      f: {
                                        if (y >>> 0 >= 357913942) {
                                          e[5996] = 0, Ri(96);
                                          break f;
                                        }
                                        if (h = (o - Ar | 0) / 12 | 0, o = h << 1, h = h >>> 0 >= 178956970 ? 357913941 : o >>> 0 > y >>> 0 ? o : y, !h) {
                                          y = 0;
                                          break o;
                                        }
                                        if (h >>> 0 < 357913942)
                                          break l;
                                        e[5996] = 0, Ri(35);
                                      }
                                      if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                        break e;
                                      break i;
                                    }
                                    if (e[5996] = 0, y = ii(3, vi(h, 12) | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                      break i;
                                  }
                                  o = vi(G, 12) + y | 0, e[o >> 2] = e[S + 8 >> 2], Fe = e[S + 12 >> 2], e[o + 4 >> 2] = Fe, G = e[S + 16 >> 2], e[o + 8 >> 2] = G, h = vi(h, 12), ke = o + 4 | 0;
                                  o: {
                                    if (!G) {
                                      e[o >> 2] = ke;
                                      break o;
                                    }
                                    e[Fe + 8 >> 2] = ke, e[S + 12 >> 2] = 0, e[S + 16 >> 2] = 0, e[S + 8 >> 2] = Rs;
                                  }
                                  hr = h + y | 0, ke = o + 12 | 0;
                                  o: {
                                    if ((g | 0) == (Ar | 0)) {
                                      e[S + 32 >> 2] = hr, e[S + 28 >> 2] = ke, e[S + 24 >> 2] = o;
                                      break o;
                                    }
                                    for (; ; ) {
                                      o = o - 12 | 0, g = g - 12 | 0, e[o >> 2] = e[g >> 2], Fe = o + 4 | 0, G = g + 4 | 0, y = e[G >> 2], e[Fe >> 2] = y, h = e[g + 8 >> 2], e[o + 8 >> 2] = h;
                                      l: {
                                        if (!h) {
                                          e[o >> 2] = Fe;
                                          break l;
                                        }
                                        e[y + 8 >> 2] = Fe, e[g >> 2] = G, e[g + 4 >> 2] = 0, e[g + 8 >> 2] = 0;
                                      }
                                      if ((g | 0) == (Ar | 0))
                                        break;
                                    }
                                    if (e[S + 32 >> 2] = hr, h = e[S + 28 >> 2], e[S + 28 >> 2] = ke, g = e[S + 24 >> 2], e[S + 24 >> 2] = o, (h | 0) == (g | 0))
                                      break o;
                                    for (; h = h - 12 | 0, Je(e[h + 4 >> 2]), (h | 0) != (g | 0); )
                                      ;
                                  }
                                  if (!g)
                                    break a;
                                  Sr(g);
                                }
                                ye[S + 20 | 0] && Je(e[S + 12 >> 2]), g = sa;
                              }
                              if ((g | 0) != (Rn | 0))
                                continue;
                              break n;
                            }
                            break;
                          }
                          if (o = Vr() | 0, !ye[S + 20 | 0])
                            break t;
                          Je(e[S + 12 >> 2]);
                          break t;
                        }
                        if (y = e[S + 24 >> 2], (e[S + 28 >> 2] - y | 0) != 12) {
                          if (e[5996] = 0, Qs(44, 4102, 2210, 450, 2439), r = e[5996], e[5996] = 0, (r | 0) != 1)
                            break e;
                          o = Vr() | 0;
                          break t;
                        }
                        e[r >> 2] = e[y >> 2], c = e[y + 4 >> 2], e[r + 4 >> 2] = c, o = e[y + 8 >> 2], e[r + 8 >> 2] = o, h = r + 4 | 0;
                        n: {
                          if (!o) {
                            e[r >> 2] = h;
                            break n;
                          }
                          e[c + 8 >> 2] = h, e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[y >> 2] = y + 4;
                        }
                        $[r + 12 | 0] = 1;
                      }
                      if (r = e[S + 24 >> 2], r) {
                        if (g = e[S + 28 >> 2], (r | 0) != (g | 0))
                          for (; g = g - 12 | 0, Je(e[g + 4 >> 2]), (r | 0) != (g | 0); )
                            ;
                        Sr(r);
                      }
                      Rn && Sr(Rn), Yr = S + 48 | 0;
                      return;
                    }
                    pA(S + 24 | 0), Rn && Sr(Rn), Ki(o | 0), ri();
                  }
                  r = Vr() | 0, pA(S + 24 | 0), Ki(r | 0), ri();
                }
                ri();
              }
              function Wd(r, o, c) {
                var h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0, Qi = 0, Ji = 0, ss = 0, As = 0, Rs = 0;
                y = Yr - 144 | 0, Yr = y, h = Ya(y, 0, 144), e[h + 76 >> 2] = -1, e[h + 44 >> 2] = r, e[h + 32 >> 2] = 178, e[h + 84 >> 2] = r, gi = c, r = 0, Fe = Yr - 304 | 0, Yr = Fe;
                e: {
                  t: {
                    r: {
                      n: {
                        if (e[h + 4 >> 2] || (Kh(h), e[h + 4 >> 2]))
                          break n;
                        break r;
                      }
                      if (G = ye[o | 0], !G)
                        break e;
                      n: {
                        i: {
                          s: {
                            a: {
                              for (; ; ) {
                                o: {
                                  c = G & 255;
                                  l: {
                                    if ((c | 0) == 32 | c - 9 >>> 0 < 5) {
                                      for (; G = o, o = o + 1 | 0, c = ye[G + 1 | 0], !!((c | 0) == 32 | c - 9 >>> 0 < 5); )
                                        ;
                                      for (du(h, 0, 0); ; ) {
                                        o = e[h + 4 >> 2];
                                        f: {
                                          if ((o | 0) != e[h + 104 >> 2]) {
                                            e[h + 4 >> 2] = o + 1, o = ye[o | 0];
                                            break f;
                                          }
                                          o = go(h);
                                        }
                                        if (!((o | 0) == 32 | o - 9 >>> 0 < 5))
                                          break;
                                      }
                                      o = e[h + 4 >> 2], c = e[h + 116 >> 2], (c | 0) > 0 | (c | 0) >= 0 && (o = o - 1 | 0, e[h + 4 >> 2] = o), o = o - e[h + 44 >> 2] | 0, y = o, ke = Rn + e[h + 124 >> 2] | 0, c = o >> 31, o = Tr + e[h + 120 >> 2] | 0, ke = c + (o >>> 0 < Tr >>> 0 ? ke + 1 | 0 : ke) | 0, Tr = o + y | 0, Rn = Tr >>> 0 < o >>> 0 ? ke + 1 | 0 : ke;
                                      break l;
                                    }
                                    f: {
                                      d: {
                                        c: {
                                          if ((c | 0) == 37) {
                                            if (c = ye[o + 1 | 0], (c | 0) == 42)
                                              break c;
                                            if ((c | 0) != 37)
                                              break d;
                                          }
                                          du(h, 0, 0);
                                          u: {
                                            if (ye[o | 0] == 37) {
                                              for (; ; ) {
                                                c = e[h + 4 >> 2];
                                                g: {
                                                  if ((c | 0) != e[h + 104 >> 2]) {
                                                    e[h + 4 >> 2] = c + 1, G = ye[c | 0];
                                                    break g;
                                                  }
                                                  G = go(h);
                                                }
                                                if (!((G | 0) == 32 | G - 9 >>> 0 < 5))
                                                  break;
                                              }
                                              o = o + 1 | 0;
                                              break u;
                                            }
                                            if (c = e[h + 4 >> 2], (c | 0) != e[h + 104 >> 2]) {
                                              e[h + 4 >> 2] = c + 1, G = ye[c | 0];
                                              break u;
                                            }
                                            G = go(h);
                                          }
                                          if (ye[o | 0] != (G | 0)) {
                                            if (o = e[h + 116 >> 2], (o | 0) > 0 | (o | 0) >= 0 && (e[h + 4 >> 2] = e[h + 4 >> 2] - 1), (G | 0) >= 0 || (S = 0, Qi))
                                              break e;
                                            break r;
                                          }
                                          c = e[h + 4 >> 2] - e[h + 44 >> 2] | 0, G = c, g = Rn + e[h + 124 >> 2] | 0, y = c >> 31, c = Tr + e[h + 120 >> 2] | 0, S = y + (c >>> 0 < Tr >>> 0 ? g + 1 | 0 : g) | 0, Tr = c + G | 0, Rn = Tr >>> 0 < c >>> 0 ? S + 1 | 0 : S, G = o;
                                          break l;
                                        }
                                        hr = 0, o = o + 2 | 0;
                                        break f;
                                      }
                                      if (y = c - 48 | 0, !(ye[o + 2 | 0] != 36 | y >>> 0 >= 10)) {
                                        c = Yr - 16 | 0, e[c + 12 >> 2] = gi, g = c, c = (y >>> 0 > 1 ? (y << 2) - 4 | 0 : 0) + gi | 0, e[g + 8 >> 2] = c + 4, hr = e[c >> 2], o = o + 3 | 0;
                                        break f;
                                      }
                                      hr = e[gi >> 2], gi = gi + 4 | 0, o = o + 1 | 0;
                                    }
                                    for (c = 0; ; ) {
                                      if (g = ye[o | 0], g - 48 >>> 0 < 10) {
                                        o = o + 1 | 0, c = (vi(c, 10) + g | 0) - 48 | 0;
                                        continue;
                                      }
                                      break;
                                    }
                                    ci = 0, (g | 0) == 109 && (Mn = 0, ci = (hr | 0) != 0, g = ye[o + 1 | 0], o = o + 1 | 0, r = 0), G = o + 1 | 0, Ar = 3, S = ci;
                                    f: {
                                      d:
                                        switch ((g & 255) - 65 | 0) {
                                          case 39:
                                            y = o + 2 | 0, o = ye[o + 1 | 0] == 104, G = o ? y : G, Ar = o ? -2 : -1;
                                            break f;
                                          case 43:
                                            y = o + 2 | 0, o = ye[o + 1 | 0] == 108, G = o ? y : G, Ar = o ? 3 : 1;
                                            break f;
                                          case 51:
                                          case 57:
                                            Ar = 1;
                                            break f;
                                          case 11:
                                            Ar = 2;
                                            break f;
                                          case 41:
                                            break f;
                                          case 0:
                                          case 2:
                                          case 4:
                                          case 5:
                                          case 6:
                                          case 18:
                                          case 23:
                                          case 26:
                                          case 32:
                                          case 34:
                                          case 35:
                                          case 36:
                                          case 37:
                                          case 38:
                                          case 40:
                                          case 45:
                                          case 46:
                                          case 47:
                                          case 50:
                                          case 52:
                                          case 55:
                                            break d;
                                          default:
                                            break n;
                                        }
                                      Ar = 0, G = o;
                                    }
                                    y = ye[G | 0], o = (y & 47) == 3, Ji = o ? 1 : Ar, ei = o ? y | 32 : y;
                                    f: {
                                      if ((ei | 0) == 91)
                                        break f;
                                      d: {
                                        if ((ei | 0) != 110) {
                                          if ((ei | 0) != 99)
                                            break d;
                                          c = (c | 0) <= 1 ? 1 : c;
                                          break f;
                                        }
                                        Bf(hr, Ji, Tr, Rn);
                                        break l;
                                      }
                                      for (du(h, 0, 0); ; ) {
                                        o = e[h + 4 >> 2];
                                        d: {
                                          if ((o | 0) != e[h + 104 >> 2]) {
                                            e[h + 4 >> 2] = o + 1, o = ye[o | 0];
                                            break d;
                                          }
                                          o = go(h);
                                        }
                                        if (!((o | 0) == 32 | o - 9 >>> 0 < 5))
                                          break;
                                      }
                                      o = e[h + 4 >> 2], y = e[h + 116 >> 2], (y | 0) > 0 | (y | 0) >= 0 && (o = o - 1 | 0, e[h + 4 >> 2] = o), o = o - e[h + 44 >> 2] | 0, g = o, ke = Rn + e[h + 124 >> 2] | 0, y = o >> 31, o = Tr + e[h + 120 >> 2] | 0, Rn = y + (o >>> 0 < Tr >>> 0 ? ke + 1 | 0 : ke) | 0, Tr = o + g | 0, Rn = Tr >>> 0 < o >>> 0 ? Rn + 1 | 0 : Rn;
                                    }
                                    ke = c, ln = c >> 31, du(h, c, ln), o = e[h + 4 >> 2];
                                    f: {
                                      if ((o | 0) != e[h + 104 >> 2]) {
                                        e[h + 4 >> 2] = o + 1;
                                        break f;
                                      }
                                      if ((go(h) | 0) < 0)
                                        break i;
                                    }
                                    o = e[h + 116 >> 2], (o | 0) > 0 | (o | 0) >= 0 && (e[h + 4 >> 2] = e[h + 4 >> 2] - 1), o = 16;
                                    f: {
                                      d: {
                                        c: {
                                          u: {
                                            g:
                                              switch (ei - 88 | 0) {
                                                default:
                                                  if (o = ei - 65 | 0, o >>> 0 > 6 | !(1 << o & 113))
                                                    break f;
                                                case 9:
                                                case 13:
                                                case 14:
                                                case 15:
                                                  if (Vd(Fe + 8 | 0, h, Ji, 0), c = e[h + 4 >> 2] - e[h + 44 >> 2] | 0, e[h + 120 >> 2] != (0 - c | 0) | e[h + 124 >> 2] != (0 - ((c >> 31) + ((c | 0) != 0) | 0) | 0))
                                                    break c;
                                                  break s;
                                                case 3:
                                                case 11:
                                                case 27:
                                                  if ((ei | 16) == 115) {
                                                    if (Ya(Fe + 32 | 0, -1, 257), $[Fe + 32 | 0] = 0, (ei | 0) != 115)
                                                      break d;
                                                    $[Fe + 65 | 0] = 0, $[Fe + 46 | 0] = 0, Vs[Fe + 42 >> 1] = 0, Vs[Fe + 44 >> 1] = 0;
                                                    break d;
                                                  }
                                                  g = ye[G + 1 | 0], y = (g | 0) == 94, Ya(Fe + 32 | 0, y, 257), $[Fe + 32 | 0] = 0, o = y ? G + 2 | 0 : G + 1 | 0;
                                                  A: {
                                                    p: {
                                                      I: {
                                                        if (y = ye[(y ? 2 : 1) + G | 0], (y | 0) != 45) {
                                                          if ((y | 0) == 93)
                                                            break I;
                                                          Ar = (g | 0) != 94;
                                                          break A;
                                                        }
                                                        Ar = (g | 0) != 94, $[Fe + 78 | 0] = Ar;
                                                        break p;
                                                      }
                                                      Ar = (g | 0) != 94, $[Fe + 126 | 0] = Ar;
                                                    }
                                                    o = o + 1 | 0;
                                                  }
                                                  for (G = o; ; ) {
                                                    g = ye[G | 0];
                                                    A: {
                                                      if ((g | 0) != 45) {
                                                        if (!g)
                                                          break i;
                                                        if ((g | 0) == 93)
                                                          break d;
                                                        break A;
                                                      }
                                                      if (g = 45, S = ye[G + 1 | 0], !S | (S | 0) == 93)
                                                        break A;
                                                      y = G + 1 | 0, o = ye[G - 1 | 0];
                                                      p: {
                                                        if (S >>> 0 <= o >>> 0) {
                                                          g = S;
                                                          break p;
                                                        }
                                                        for (; o = o + 1 | 0, $[o + (Fe + 32 | 0) | 0] = Ar, g = ye[y | 0], g >>> 0 > o >>> 0; )
                                                          ;
                                                      }
                                                      G = y;
                                                    }
                                                    $[(g + Fe | 0) + 33 | 0] = Ar, G = G + 1 | 0;
                                                  }
                                                case 23:
                                                  o = 8;
                                                  break u;
                                                case 12:
                                                case 29:
                                                  o = 10;
                                                  break u;
                                                case 1:
                                                case 2:
                                                case 4:
                                                case 5:
                                                case 6:
                                                case 7:
                                                case 8:
                                                case 10:
                                                case 16:
                                                case 18:
                                                case 19:
                                                case 20:
                                                case 21:
                                                case 22:
                                                case 25:
                                                case 26:
                                                case 28:
                                                case 30:
                                                case 31:
                                                  break f;
                                                case 0:
                                                case 24:
                                                case 32:
                                                  break u;
                                                case 17:
                                                  break g;
                                              }
                                            o = 0;
                                          }
                                          y = 0, ke = 0, g = 0, S = 0, As = 0, ss = Yr - 16 | 0, Yr = ss;
                                          u: {
                                            if ((o | 0) == 1) {
                                              e[5732] = 28;
                                              break u;
                                            }
                                            for (; ; ) {
                                              c = e[h + 4 >> 2];
                                              g: {
                                                if ((c | 0) != e[h + 104 >> 2]) {
                                                  e[h + 4 >> 2] = c + 1, c = ye[c | 0];
                                                  break g;
                                                }
                                                c = go(h);
                                              }
                                              if (!((c | 0) == 32 | c - 9 >>> 0 < 5))
                                                break;
                                            }
                                            g: {
                                              A:
                                                switch (c - 43 | 0) {
                                                  case 0:
                                                  case 2:
                                                    break A;
                                                  default:
                                                    break g;
                                                }
                                              if (As = (c | 0) == 45 ? -1 : 0, c = e[h + 4 >> 2], (c | 0) != e[h + 104 >> 2]) {
                                                e[h + 4 >> 2] = c + 1, c = ye[c | 0];
                                                break g;
                                              }
                                              c = go(h);
                                            }
                                            g: {
                                              A: {
                                                p: {
                                                  I: {
                                                    if (!((o | 0) != 0 & (o | 0) != 16 | (c | 0) != 48)) {
                                                      c = e[h + 4 >> 2];
                                                      k: {
                                                        if ((c | 0) != e[h + 104 >> 2]) {
                                                          e[h + 4 >> 2] = c + 1, c = ye[c | 0];
                                                          break k;
                                                        }
                                                        c = go(h);
                                                      }
                                                      if ((c & -33) == 88) {
                                                        o = 16, c = e[h + 4 >> 2];
                                                        k: {
                                                          if ((c | 0) != e[h + 104 >> 2]) {
                                                            e[h + 4 >> 2] = c + 1, c = ye[c | 0];
                                                            break k;
                                                          }
                                                          c = go(h);
                                                        }
                                                        if (ye[c + 8641 | 0] < 16)
                                                          break p;
                                                        o = e[h + 116 >> 2], (o | 0) > 0 | (o | 0) >= 0 && (e[h + 4 >> 2] = e[h + 4 >> 2] - 1), du(h, 0, 0);
                                                        break u;
                                                      }
                                                      if (o)
                                                        break I;
                                                      o = 8;
                                                      break p;
                                                    }
                                                    if (o = o || 10, o >>> 0 > ye[c + 8641 | 0])
                                                      break I;
                                                    o = e[h + 116 >> 2], (o | 0) > 0 | (o | 0) >= 0 && (e[h + 4 >> 2] = e[h + 4 >> 2] - 1), du(h, 0, 0), e[5732] = 28;
                                                    break u;
                                                  }
                                                  if ((o | 0) != 10)
                                                    break p;
                                                  if (g = c - 48 | 0, g >>> 0 <= 9) {
                                                    for (c = 0; ; ) {
                                                      c = vi(c, 10) + g | 0, S = c >>> 0 < 429496729, y = e[h + 4 >> 2];
                                                      I: {
                                                        if ((y | 0) != e[h + 104 >> 2]) {
                                                          e[h + 4 >> 2] = y + 1, o = ye[y | 0];
                                                          break I;
                                                        }
                                                        o = go(h);
                                                      }
                                                      if (g = o - 48 | 0, !(S & g >>> 0 <= 9))
                                                        break;
                                                    }
                                                    y = c;
                                                  }
                                                  if (g >>> 0 > 9)
                                                    break g;
                                                  for (o = so(y, 0, 10, 0), S = vs; ; ) {
                                                    y = o + g | 0, ke = y >>> 0 < g >>> 0 ? S + 1 | 0 : S, o = (ke | 0) == 429496729 & y >>> 0 < 2576980378 | ke >>> 0 < 429496729, c = e[h + 4 >> 2];
                                                    I: {
                                                      if ((c | 0) != e[h + 104 >> 2]) {
                                                        e[h + 4 >> 2] = c + 1, c = ye[c | 0];
                                                        break I;
                                                      }
                                                      c = go(h);
                                                    }
                                                    if (Ar = c - 48 | 0, !(o & Ar >>> 0 <= 9)) {
                                                      if (o = 10, Ar >>> 0 <= 9)
                                                        break A;
                                                      break g;
                                                    }
                                                    if (o = so(y, ke, 10, 0), S = vs, g = Ar, !((S | 0) == -1 & (g ^ -1) >>> 0 >= o >>> 0 | (S | 0) != -1))
                                                      break;
                                                  }
                                                  o = 10;
                                                  break A;
                                                }
                                                if (o - 1 & o) {
                                                  if (S = ye[c + 8641 | 0], S >>> 0 < o >>> 0) {
                                                    for (; ; ) {
                                                      g = vi(o, g) + S | 0, y = g >>> 0 < 119304647, c = e[h + 4 >> 2];
                                                      p: {
                                                        if ((c | 0) != e[h + 104 >> 2]) {
                                                          e[h + 4 >> 2] = c + 1, c = ye[c | 0];
                                                          break p;
                                                        }
                                                        c = go(h);
                                                      }
                                                      if (S = ye[c + 8641 | 0], !(y & S >>> 0 < o >>> 0))
                                                        break;
                                                    }
                                                    y = g;
                                                  }
                                                  if (o >>> 0 <= S >>> 0)
                                                    break A;
                                                  for (ln = o; ; ) {
                                                    if (g = so(y, ke, ln, 0), Ar = vs, S = S & 255, (Ar | 0) == -1 & (S ^ -1) >>> 0 < g >>> 0)
                                                      break A;
                                                    ke = Ar, y = g + S | 0, ke = y >>> 0 < S >>> 0 ? ke + 1 | 0 : ke, c = e[h + 4 >> 2];
                                                    p: {
                                                      if ((c | 0) != e[h + 104 >> 2]) {
                                                        e[h + 4 >> 2] = c + 1, c = ye[c | 0];
                                                        break p;
                                                      }
                                                      c = go(h);
                                                    }
                                                    if (S = ye[c + 8641 | 0], o >>> 0 <= S >>> 0)
                                                      break A;
                                                    if (oa(ss, ln, 0, 0, 0, y, ke, 0, 0), !!(e[ss + 8 >> 2] | e[ss + 12 >> 2]))
                                                      break;
                                                  }
                                                  break A;
                                                }
                                                if (Ar = $[(vi(o, 23) >>> 5 & 7) + 8897 | 0], g = ye[c + 8641 | 0], g >>> 0 < o >>> 0) {
                                                  for (; ; ) {
                                                    S = S << Ar | g, y = S >>> 0 < 134217728, c = e[h + 4 >> 2];
                                                    p: {
                                                      if ((c | 0) != e[h + 104 >> 2]) {
                                                        e[h + 4 >> 2] = c + 1, c = ye[c | 0];
                                                        break p;
                                                      }
                                                      c = go(h);
                                                    }
                                                    if (g = ye[c + 8641 | 0], !(y & g >>> 0 < o >>> 0))
                                                      break;
                                                  }
                                                  y = S;
                                                }
                                                if (o >>> 0 <= g >>> 0 || (ln = Ar & 31, (Ar & 63) >>> 0 >= 32 ? (S = 0, ln = -1 >>> ln | 0) : (S = -1 >>> ln | 0, ln = S | (1 << ln) - 1 << 32 - ln), !S & y >>> 0 > ln >>> 0))
                                                  break A;
                                                for (; ; ) {
                                                  Rs = g & 255, c = y, g = Ar & 31, (Ar & 63) >>> 0 >= 32 ? (ke = c << g, c = 0) : (ke = (1 << g) - 1 & c >>> 32 - g | ke << g, c = c << g), y = Rs | c, c = e[h + 4 >> 2];
                                                  p: {
                                                    if ((c | 0) != e[h + 104 >> 2]) {
                                                      e[h + 4 >> 2] = c + 1, c = ye[c | 0];
                                                      break p;
                                                    }
                                                    c = go(h);
                                                  }
                                                  if (g = ye[c + 8641 | 0], o >>> 0 <= g >>> 0)
                                                    break A;
                                                  if (!((S | 0) == (ke | 0) & y >>> 0 <= ln >>> 0 | S >>> 0 > ke >>> 0))
                                                    break;
                                                }
                                              }
                                              if (ye[c + 8641 | 0] >= o >>> 0)
                                                break g;
                                              for (; ; ) {
                                                c = e[h + 4 >> 2];
                                                A: {
                                                  if ((c | 0) != e[h + 104 >> 2]) {
                                                    e[h + 4 >> 2] = c + 1, c = ye[c | 0];
                                                    break A;
                                                  }
                                                  c = go(h);
                                                }
                                                if (!(ye[c + 8641 | 0] < o >>> 0))
                                                  break;
                                              }
                                              e[5732] = 68, y = -1, ke = -1, As = 0;
                                            }
                                            o = e[h + 116 >> 2], (o | 0) > 0 | (o | 0) >= 0 && (e[h + 4 >> 2] = e[h + 4 >> 2] - 1), o = As, g = o ^ y, y = g - o | 0, c = o >> 31, ke = (c ^ ke) - ((o >>> 0 > g >>> 0) + c | 0) | 0;
                                          }
                                          if (Yr = ss + 16 | 0, c = e[h + 4 >> 2] - e[h + 44 >> 2] | 0, e[h + 120 >> 2] == (0 - c | 0) & e[h + 124 >> 2] == (0 - ((c >> 31) + ((c | 0) != 0) | 0) | 0))
                                            break s;
                                          if (!(!hr | (ei | 0) != 112)) {
                                            e[hr >> 2] = y;
                                            break f;
                                          }
                                          Bf(hr, Ji, y, ke);
                                          break f;
                                        }
                                        if (!hr)
                                          break f;
                                        c = e[Fe + 16 >> 2], g = e[Fe + 20 >> 2], o = e[Fe + 8 >> 2], y = e[Fe + 12 >> 2];
                                        c:
                                          switch (Ji | 0) {
                                            case 0:
                                              ef[hr >> 2] = lh(o, y, c, g);
                                              break f;
                                            case 1:
                                              Fi[hr >> 3] = Eu(o, y, c, g);
                                              break f;
                                            case 2:
                                              break c;
                                            default:
                                              break f;
                                          }
                                        e[hr >> 2] = o, e[hr + 4 >> 2] = y, e[hr + 8 >> 2] = c, e[hr + 12 >> 2] = g;
                                        break f;
                                      }
                                      Ar = (ei | 0) != 99, c = Ar ? 31 : c + 1 | 0;
                                      d: {
                                        if ((Ji | 0) == 1) {
                                          if (g = hr, ci && (g = ia(c << 2), !g))
                                            break a;
                                          for (e[Fe + 296 >> 2] = 0, e[Fe + 300 >> 2] = 0, o = 0; ; ) {
                                            r = g;
                                            c: {
                                              for (; ; ) {
                                                y = e[h + 4 >> 2];
                                                u: {
                                                  if ((y | 0) != e[h + 104 >> 2]) {
                                                    e[h + 4 >> 2] = y + 1, y = ye[y | 0];
                                                    break u;
                                                  }
                                                  y = go(h);
                                                }
                                                if (!ye[(y + Fe | 0) + 33 | 0])
                                                  break c;
                                                if ($[Fe + 27 | 0] = y, y = Zf(Fe + 28 | 0, Fe + 27 | 0, 1, Fe + 296 | 0), (y | 0) != -2) {
                                                  if (Mn = 0, (y | 0) == -1)
                                                    break i;
                                                  if (r && (e[(o << 2) + r >> 2] = e[Fe + 28 >> 2], o = o + 1 | 0), !(!ci | (o | 0) != (c | 0)))
                                                    break;
                                                }
                                              }
                                              if (S = 1, o = c, c = o << 1 | 1, g = of(r, c << 2), g)
                                                continue;
                                              break n;
                                            }
                                            break;
                                          }
                                          if (Mn = 0, c = r, Fe + 296 | 0 && e[Fe + 296 >> 2])
                                            break i;
                                          break d;
                                        }
                                        if (ci) {
                                          if (o = 0, g = ia(c), !g)
                                            break a;
                                          for (; ; ) {
                                            for (r = g; ; ) {
                                              y = e[h + 4 >> 2];
                                              c: {
                                                if ((y | 0) != e[h + 104 >> 2]) {
                                                  e[h + 4 >> 2] = y + 1, y = ye[y | 0];
                                                  break c;
                                                }
                                                y = go(h);
                                              }
                                              if (!ye[(y + Fe | 0) + 33 | 0]) {
                                                c = 0, Mn = r;
                                                break d;
                                              }
                                              if ($[r + o | 0] = y, o = o + 1 | 0, (c | 0) == (o | 0))
                                                break;
                                            }
                                            if (S = 1, o = c, c = o << 1 | 1, g = of(r, c), !g)
                                              break;
                                          }
                                          Mn = r, r = 0;
                                          break n;
                                        }
                                        if (o = 0, hr)
                                          for (; ; ) {
                                            r = e[h + 4 >> 2];
                                            c: {
                                              if ((r | 0) != e[h + 104 >> 2]) {
                                                e[h + 4 >> 2] = r + 1, r = ye[r | 0];
                                                break c;
                                              }
                                              r = go(h);
                                            }
                                            if (ye[(r + Fe | 0) + 33 | 0]) {
                                              $[o + hr | 0] = r, o = o + 1 | 0;
                                              continue;
                                            } else {
                                              c = 0, r = hr, Mn = r;
                                              break d;
                                            }
                                          }
                                        for (; ; ) {
                                          r = e[h + 4 >> 2];
                                          c: {
                                            if ((r | 0) != e[h + 104 >> 2]) {
                                              e[h + 4 >> 2] = r + 1, r = ye[r | 0];
                                              break c;
                                            }
                                            r = go(h);
                                          }
                                          if (!ye[(r + Fe | 0) + 33 | 0])
                                            break;
                                        }
                                        r = 0, Mn = 0, c = 0;
                                      }
                                      if (g = e[h + 4 >> 2], y = e[h + 116 >> 2], (y | 0) > 0 | (y | 0) >= 0 && (g = g - 1 | 0, e[h + 4 >> 2] = g), y = g - e[h + 44 >> 2] | 0, g = y + e[h + 120 >> 2] | 0, S = e[h + 124 >> 2] + (y >> 31) | 0, S = g >>> 0 < y >>> 0 ? S + 1 | 0 : S, !(S | g) | !(Ar | (g | 0) == (ke | 0) & (S | 0) == (ln | 0)))
                                        break o;
                                      ci && (e[hr >> 2] = r);
                                      d: {
                                        if ((ei | 0) == 99)
                                          break d;
                                        if (c && (e[(o << 2) + c >> 2] = 0), !Mn) {
                                          Mn = 0;
                                          break d;
                                        }
                                        $[o + Mn | 0] = 0;
                                      }
                                      r = c;
                                    }
                                    o = e[h + 4 >> 2] - e[h + 44 >> 2] | 0, y = o, g = Rn + e[h + 124 >> 2] | 0, c = o >> 31, o = Tr + e[h + 120 >> 2] | 0, ke = c + (o >>> 0 < Tr >>> 0 ? g + 1 | 0 : g) | 0, Tr = o + y | 0, Rn = Tr >>> 0 < o >>> 0 ? ke + 1 | 0 : ke, Qi = ((hr | 0) != 0) + Qi | 0;
                                  }
                                  if (o = G + 1 | 0, G = ye[G + 1 | 0], G)
                                    continue;
                                  break e;
                                }
                                break;
                              }
                              r = c;
                              break s;
                            }
                            S = 1, Mn = 0, r = 0;
                            break n;
                          }
                          S = ci;
                          break t;
                        }
                        S = ci;
                      }
                      if (Qi)
                        break t;
                    }
                    Qi = -1;
                  }
                  if (!S)
                    break e;
                  Sr(Mn), Sr(r);
                }
                return Yr = Fe + 304 | 0, Yr = h + 144 | 0, Qi;
              }
              function F1(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0, y = 0, g = 0, S = 0;
                h = Yr - 320 | 0, Yr = h;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  f: {
                                    d: {
                                      c: {
                                        u: {
                                          g: {
                                            A: {
                                              p: {
                                                I: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              if (!ye[24336]) {
                                                                if (e[h + 208 >> 2] = 0, e[h + 200 >> 2] = 0, e[h + 204 >> 2] = 0, e[5996] = 0, Si(66, 24324, h + 200 | 0, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                  break w;
                                                                o = e[h + 200 >> 2], o && (e[h + 204 >> 2] = o, Sr(o)), $[24336] = 1;
                                                              }
                                                              if (!ye[24352]) {
                                                                if (e[5996] = 0, o = h + 200 | 0, as(68, o | 0, 1598, 8), c = e[5996], e[5996] = 0, (c | 0) == 1 || (e[5996] = 0, o = Si(69, h + 308 | 0, o | 0, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, Si(66, 24340, o | 0, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                  break v;
                                                                c = e[o >> 2], c && (e[o + 4 >> 2] = c, Sr(c)), $[24352] = 1;
                                                              }
                                                              if (!ye[24368]) {
                                                                if (e[5996] = 0, o = h + 200 | 0, as(68, o | 0, 1194, 10), c = e[5996], e[5996] = 0, (c | 0) == 1 || (e[5996] = 0, o = Si(69, h + 296 | 0, o | 0, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, Si(66, 24356, o | 0, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                  break T;
                                                                c = e[o >> 2], c && (e[o + 4 >> 2] = c, Sr(c)), $[24368] = 1;
                                                              }
                                                              if (!ye[24384]) {
                                                                if (e[5996] = 0, o = h + 200 | 0, as(68, o | 0, 2432, 6), c = e[5996], e[5996] = 0, (c | 0) == 1 || (e[5996] = 0, o = Si(69, h + 284 | 0, o | 0, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, Si(66, 24372, o | 0, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                  break S;
                                                                c = e[o >> 2], c && (e[o + 4 >> 2] = c, Sr(c)), $[24384] = 1;
                                                              }
                                                              if (!ye[24400]) {
                                                                if (e[5996] = 0, o = h + 200 | 0, as(68, o | 0, 1492, 6), c = e[5996], e[5996] = 0, (c | 0) == 1 || (e[5996] = 0, o = Si(69, h + 272 | 0, o | 0, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, Si(66, 24388, o | 0, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                  break N;
                                                                c = e[o >> 2], c && (e[o + 4 >> 2] = c, Sr(c)), $[24400] = 1;
                                                              }
                                                              if (!ye[24416]) {
                                                                if (e[5996] = 0, o = h + 200 | 0, as(68, o | 0, 1152, 8), c = e[5996], e[5996] = 0, (c | 0) == 1 || (e[5996] = 0, o = Si(69, h + 260 | 0, o | 0, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, Si(66, 24404, o | 0, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                  break k;
                                                                c = e[o >> 2], c && (e[o + 4 >> 2] = c, Sr(c)), $[24416] = 1;
                                                              }
                                                              if (!ye[24432]) {
                                                                if (e[5996] = 0, o = h + 200 | 0, as(68, o | 0, 1526, 8), c = e[5996], e[5996] = 0, (c | 0) == 1 || (e[5996] = 0, o = Si(69, h + 248 | 0, o | 0, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, Si(66, 24420, o | 0, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                  break I;
                                                                c = e[o >> 2], c && (e[o + 4 >> 2] = c, Sr(c)), $[24432] = 1;
                                                              }
                                                              if (!ye[24448]) {
                                                                if (e[5996] = 0, o = h + 200 | 0, as(68, o | 0, 1628, 10), c = e[5996], e[5996] = 0, (c | 0) == 1 || (e[5996] = 0, o = Si(69, h + 236 | 0, o | 0, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, Si(66, 24436, o | 0, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                  break p;
                                                                c = e[o >> 2], c && (e[o + 4 >> 2] = c, Sr(c)), $[24448] = 1;
                                                              }
                                                              if (!ye[24464]) {
                                                                if (e[5996] = 0, o = h + 116 | 0, as(68, o | 0, 1435, 7), c = e[5996], e[5996] = 0, (c | 0) == 1 || (e[5996] = 0, as(68, h + 124 | 0, 1183, 10), c = e[5996], e[5996] = 0, (c | 0) == 1) || (e[5996] = 0, c = Si(69, h + 200 | 0, o | 0, 2) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, y = h + 80 | 0, as(68, y | 0, 1478, 7), g = e[5996], e[5996] = 0, o = c + 12 | 0, (g | 0) == 1 || (e[5996] = 0, as(68, h + 88 | 0, 1172, 10), g = e[5996], e[5996] = 0, (g | 0) == 1) || (e[5996] = 0, g = Si(69, o | 0, y | 0, 2) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, y = h + 56 | 0, as(68, y | 0, 1435, 7), S = e[5996], e[5996] = 0, o = c + 24 | 0, (S | 0) == 1) || (e[5996] = 0, as(68, h - -64 | 0, 1161, 10), S = e[5996], e[5996] = 0, (S | 0) == 1) || (e[5996] = 0, S = Si(69, o | 0, y | 0, 2) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1))
                                                                  break g;
                                                                if (e[5996] = 0, Si(66, 24452, c | 0, 3) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                  break A;
                                                                o = e[S >> 2], o && (e[c + 28 >> 2] = o, Sr(o)), o = e[g >> 2], o && (e[c + 16 >> 2] = o, Sr(o)), o = e[c >> 2], o && (e[c + 4 >> 2] = o, Sr(o)), $[24464] = 1;
                                                              }
                                                              if (!ye[24480]) {
                                                                if (e[5996] = 0, o = h + 116 | 0, as(68, o | 0, 1628, 10), c = e[5996], e[5996] = 0, (c | 0) == 1 || (e[5996] = 0, as(68, h + 124 | 0, 1617, 10), c = e[5996], e[5996] = 0, (c | 0) == 1) || (e[5996] = 0, o = Si(69, h + 188 | 0, o | 0, 2) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, Si(66, 24468, o | 0, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                  break u;
                                                                c = e[o >> 2], c && (e[o + 4 >> 2] = c, Sr(c)), $[24480] = 1;
                                                              }
                                                              if (!ye[24496]) {
                                                                if (e[5996] = 0, o = h + 116 | 0, as(68, o | 0, 1462, 8), c = e[5996], e[5996] = 0, (c | 0) == 1 || (e[5996] = 0, as(68, h + 124 | 0, 1453, 8), c = e[5996], e[5996] = 0, (c | 0) == 1) || (e[5996] = 0, o = Si(69, h + 176 | 0, o | 0, 2) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, Si(66, 24484, o | 0, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                  break c;
                                                                c = e[o >> 2], c && (e[o + 4 >> 2] = c, Sr(c)), $[24496] = 1;
                                                              }
                                                              if (!ye[24512]) {
                                                                if (e[5996] = 0, o = h + 116 | 0, as(68, o | 0, 1443, 9), c = e[5996], e[5996] = 0, (c | 0) == 1 || (e[5996] = 0, as(68, h + 124 | 0, 1587, 10), c = e[5996], e[5996] = 0, (c | 0) == 1) || (e[5996] = 0, o = Si(69, h + 164 | 0, o | 0, 2) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, Si(66, 24500, o | 0, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                  break d;
                                                                c = e[o >> 2], c && (e[o + 4 >> 2] = c, Sr(c)), $[24512] = 1;
                                                              }
                                                              if (!ye[24528]) {
                                                                if (e[5996] = 0, o = h + 116 | 0, as(68, o | 0, 1443, 9), c = e[5996], e[5996] = 0, (c | 0) == 1 || (e[5996] = 0, as(68, h + 124 | 0, 1471, 6), c = e[5996], e[5996] = 0, (c | 0) == 1) || (e[5996] = 0, o = Si(69, h + 152 | 0, o | 0, 2) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, Si(66, 24516, o | 0, 1) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                  break f;
                                                                c = e[o >> 2], c && (e[o + 4 >> 2] = c, Sr(c)), $[24528] = 1;
                                                              }
                                                              if (!ye[24544]) {
                                                                if (e[5996] = 0, o = h + 80 | 0, as(68, o | 0, 1535, 9), c = e[5996], e[5996] = 0, (c | 0) == 1 || (e[5996] = 0, as(68, h + 88 | 0, 1535, 9), c = e[5996], e[5996] = 0, (c | 0) == 1) || (e[5996] = 0, c = Si(69, h + 116 | 0, o | 0, 2) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, y = h + 56 | 0, as(68, y | 0, 1555, 9), g = e[5996], e[5996] = 0, o = c + 12 | 0, (g | 0) == 1 || (e[5996] = 0, as(68, h - -64 | 0, 1555, 9), g = e[5996], e[5996] = 0, (g | 0) == 1) || (e[5996] = 0, g = Si(69, o | 0, y | 0, 2) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, y = h + 32 | 0, as(68, y | 0, 1545, 9), S = e[5996], e[5996] = 0, o = c + 24 | 0, (S | 0) == 1) || (e[5996] = 0, as(68, h + 40 | 0, 1545, 9), S = e[5996], e[5996] = 0, (S | 0) == 1) || (e[5996] = 0, S = Si(69, o | 0, y | 0, 2) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1))
                                                                  break o;
                                                                if (e[5996] = 0, Si(66, 24532, c | 0, 3) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                  break l;
                                                                o = e[S >> 2], o && (e[c + 28 >> 2] = o, Sr(o)), o = e[g >> 2], o && (e[c + 16 >> 2] = o, Sr(o)), o = e[c >> 2], o && (e[c + 4 >> 2] = o, Sr(o)), $[24544] = 1;
                                                              }
                                                              if (!ye[24560]) {
                                                                if (e[5996] = 0, o = h + 56 | 0, as(68, o | 0, 1443, 9), c = e[5996], e[5996] = 0, (c | 0) == 1 || (e[5996] = 0, as(68, h - -64 | 0, 1517, 8), c = e[5996], e[5996] = 0, (c | 0) == 1) || (e[5996] = 0, as(68, h + 72 | 0, 1587, 10), c = e[5996], e[5996] = 0, (c | 0) == 1) || (e[5996] = 0, c = Si(69, h + 80 | 0, o | 0, 3) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, y = h + 32 | 0, as(68, y | 0, 1443, 9), g = e[5996], e[5996] = 0, o = c + 12 | 0, (g | 0) == 1 || (e[5996] = 0, as(68, h + 40 | 0, 1508, 8), g = e[5996], e[5996] = 0, (g | 0) == 1) || (e[5996] = 0, as(68, h + 48 | 0, 1576, 10), g = e[5996], e[5996] = 0, (g | 0) == 1) || (e[5996] = 0, g = Si(69, o | 0, y | 0, 3) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1) || (e[5996] = 0, y = h + 8 | 0, as(68, y | 0, 1443, 9), S = e[5996], e[5996] = 0, o = c + 24 | 0, (S | 0) == 1) || (e[5996] = 0, as(68, h + 16 | 0, 1499, 8), S = e[5996], e[5996] = 0, (S | 0) == 1) || (e[5996] = 0, as(68, h + 24 | 0, 1565, 10), S = e[5996], e[5996] = 0, (S | 0) == 1) || (e[5996] = 0, S = Si(69, o | 0, y | 0, 3) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1))
                                                                  break s;
                                                                if (e[5996] = 0, Si(66, 24548, c | 0, 3) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                  break a;
                                                                o = e[S >> 2], o && (e[c + 28 >> 2] = o, Sr(o)), o = e[g >> 2], o && (e[c + 16 >> 2] = o, Sr(o)), o = e[c >> 2], o && (e[c + 4 >> 2] = o, Sr(o)), $[24560] = 1;
                                                              }
                                                              if (!(50331647 >>> r & 1))
                                                                break i;
                                                              return Yr = h + 320 | 0, e[(r << 2) + 6864 >> 2];
                                                            }
                                                            if (y = Vr() | 0, r = e[h + 200 >> 2], !r)
                                                              break n;
                                                            e[h + 204 >> 2] = r, Sr(r);
                                                            break n;
                                                          }
                                                          if (y = Vr() | 0, r = e[o >> 2], !r)
                                                            break n;
                                                          break t;
                                                        }
                                                        if (y = Vr() | 0, r = e[o >> 2], !r)
                                                          break n;
                                                        break t;
                                                      }
                                                      if (y = Vr() | 0, r = e[o >> 2], !r)
                                                        break n;
                                                      break t;
                                                    }
                                                    if (y = Vr() | 0, r = e[o >> 2], !r)
                                                      break n;
                                                    break t;
                                                  }
                                                  if (y = Vr() | 0, r = e[o >> 2], !r)
                                                    break n;
                                                  break t;
                                                }
                                                if (y = Vr() | 0, r = e[o >> 2], !r)
                                                  break n;
                                                break t;
                                              }
                                              if (y = Vr() | 0, r = e[o >> 2], !r)
                                                break n;
                                              break t;
                                            }
                                            if (y = Vr() | 0, r = e[S >> 2], r && (e[c + 28 >> 2] = r, Sr(r)), r = e[g >> 2], r && (e[c + 16 >> 2] = r, Sr(r)), r = e[c >> 2], !r)
                                              break n;
                                            break e;
                                          }
                                          for (y = Vr() | 0; r = o - 12 | 0, h = e[r >> 2], h && (e[o - 8 >> 2] = h, Sr(h)), o = r, (o | 0) != (c | 0); )
                                            ;
                                          break n;
                                        }
                                        if (y = Vr() | 0, r = e[o >> 2], !r)
                                          break n;
                                        break t;
                                      }
                                      if (y = Vr() | 0, r = e[o >> 2], !r)
                                        break n;
                                      break t;
                                    }
                                    if (y = Vr() | 0, r = e[o >> 2], !r)
                                      break n;
                                    break t;
                                  }
                                  if (y = Vr() | 0, r = e[o >> 2], !r)
                                    break n;
                                  break t;
                                }
                                if (y = Vr() | 0, r = e[S >> 2], r && (e[c + 28 >> 2] = r, Sr(r)), r = e[g >> 2], r && (e[c + 16 >> 2] = r, Sr(r)), r = e[c >> 2], !r)
                                  break n;
                                break e;
                              }
                              for (y = Vr() | 0; r = o - 12 | 0, h = e[r >> 2], h && (e[o - 8 >> 2] = h, Sr(h)), o = r, (o | 0) != (c | 0); )
                                ;
                              break n;
                            }
                            if (y = Vr() | 0, r = e[S >> 2], r && (e[c + 28 >> 2] = r, Sr(r)), r = e[g >> 2], r && (e[c + 16 >> 2] = r, Sr(r)), r = e[c >> 2], !r)
                              break n;
                            break e;
                          }
                          for (y = Vr() | 0; r = o - 12 | 0, h = e[r >> 2], h && (e[o - 8 >> 2] = h, Sr(h)), o = r, (o | 0) != (c | 0); )
                            ;
                          break n;
                        }
                        aa(2350, 1900, 622, 1759), ri();
                      }
                      Ki(y | 0), ri();
                    }
                    Ki(Vr() | 0), ri();
                  }
                  e[o + 4 >> 2] = r, Sr(r), Ki(y | 0), ri();
                }
                e[c + 4 >> 2] = r, Sr(r), Ki(y | 0), ri();
              }
              function sf(r, o, c, h, y) {
                var g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0, Qi = 0, Ji = 0, ss = 0, As = 0;
                G = Yr - 144 | 0, Yr = G, vc(G + 56 | 0, c, Fi[r + 16 >> 3], Fi[r + 24 >> 3], 0, 0), e[5996] = 0, g = ii(46, c | 0) | 0, S = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((S | 0) != 1) {
                        if (e[G + 52 >> 2] = 0, e[G + 44 >> 2] = 0, e[G + 48 >> 2] = 0, $[G + 128 | 0] = 0, e[G + 124 >> 2] = G + 44, S = e[g + 4 >> 2], Fe = e[g >> 2], Ar = S - Fe | 0, ke = (Ar | 0) / 12 | 0, (S | 0) != (Fe | 0)) {
                          n: {
                            i: {
                              s: {
                                if (ke >>> 0 >= 357913942) {
                                  if (e[5996] = 0, Ri(47), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                    break s;
                                  break e;
                                }
                                if (e[5996] = 0, S = ii(3, Ar | 0) | 0, Fe = e[5996], e[5996] = 0, (Fe | 0) == 1)
                                  break s;
                                if (e[G + 48 >> 2] = S, e[G + 44 >> 2] = S, e[G + 52 >> 2] = S + vi(ke, 12), ke = e[g + 4 >> 2], g = e[g >> 2], e[5996] = 0, g = da(48, G + 52 | 0, g | 0, ke | 0, S | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) != 1)
                                  break n;
                                g = Vr() | 0, e[G + 48 >> 2] = S;
                                break i;
                              }
                              g = Vr() | 0;
                            }
                            i2(G + 124 | 0);
                            break r;
                          }
                          e[G + 48 >> 2] = g;
                        }
                        e[G + 40 >> 2] = 0, e[G + 32 >> 2] = 0, e[G + 36 >> 2] = 0, g = e[h + 4 >> 2], S = e[h >> 2], e[5996] = 0, di(49, G + 32 | 0, g - S >> 2), g = e[5996], e[5996] = 0;
                        n: {
                          if ((g | 0) != 1) {
                            if (g = e[G + 48 >> 2], S = e[G + 44 >> 2], (g | 0) == (S | 0))
                              break t;
                            g = S;
                            i: {
                              for (; ; ) {
                                s: {
                                  if (e[G + 28 >> 2] = 0, e[G + 20 >> 2] = 0, e[G + 24 >> 2] = 0, ke = e[h + 4 >> 2], S = e[h >> 2], ln = vi(gi, 12), g = ln + g | 0, ke - S >> 2 != e[g + 4 >> 2] - e[g >> 2] >> 3)
                                    break s;
                                  Fe = 0, ci = 1, Ar = 0;
                                  a: {
                                    if ((S | 0) != (ke | 0)) {
                                      o: {
                                        l: {
                                          f: {
                                            for (; ; ) {
                                              if (g = Ar << 3, ss = Fi[g + e[G + 68 >> 2] >> 3], As = Fi[g + e[G + 56 >> 2] >> 3], S = e[(Ar << 2) + S >> 2], e[5996] = 0, S = lc(50, S | 0, +As, +ss, o | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                break l;
                                              if (g = g + e[ln + e[G + 44 >> 2] >> 2] | 0, ke = e[g >> 2], g = e[g + 4 >> 2], Tr = e[S + 4 >> 2], S = e[S >> 2], e[5996] = 0, eu(51, G + 124 | 0, S | 0, Tr | 0, ke | 0, g | 0), g = e[5996], e[5996] = 0, (g | 0) != 1) {
                                                ke = e[G + 28 >> 2];
                                                d: {
                                                  if (ke >>> 0 > Fe >>> 0) {
                                                    e[Fe + 8 >> 2] = 0, e[Fe >> 2] = 0, e[Fe + 4 >> 2] = 0, e[Fe >> 2] = e[G + 124 >> 2], e[Fe + 4 >> 2] = e[G + 128 >> 2], e[Fe + 8 >> 2] = e[G + 132 >> 2], e[G + 24 >> 2] = Fe + 12;
                                                    break d;
                                                  }
                                                  c: {
                                                    S = e[G + 20 >> 2], Tr = (Fe - S | 0) / 12 | 0, g = Tr + 1 | 0;
                                                    u: {
                                                      if (g >>> 0 >= 357913942) {
                                                        e[5996] = 0, Ri(52);
                                                        break u;
                                                      }
                                                      if (ke = (ke - S | 0) / 12 | 0, hr = ke << 1, g = ke >>> 0 >= 178956970 ? 357913941 : g >>> 0 < hr >>> 0 ? hr : g, g >>> 0 < 357913942)
                                                        break c;
                                                      e[5996] = 0, Ri(35);
                                                    }
                                                    if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                      break e;
                                                    break f;
                                                  }
                                                  if (e[5996] = 0, hr = vi(g, 12), ke = ii(3, hr | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                    break f;
                                                  g = ke + vi(Tr, 12) | 0, e[g >> 2] = e[G + 124 >> 2], e[g + 4 >> 2] = e[G + 128 >> 2], e[g + 8 >> 2] = e[G + 132 >> 2], e[G + 132 >> 2] = 0, e[G + 124 >> 2] = 0, e[G + 128 >> 2] = 0, ke = ke + hr | 0, Tr = g + 12 | 0;
                                                  c: {
                                                    if ((S | 0) == (Fe | 0)) {
                                                      e[G + 28 >> 2] = ke, e[G + 24 >> 2] = Tr, e[G + 20 >> 2] = g;
                                                      break c;
                                                    }
                                                    for (; g = g - 12 | 0, Fe = Fe - 12 | 0, e[g >> 2] = e[Fe >> 2], e[g + 4 >> 2] = e[Fe + 4 >> 2], e[g + 8 >> 2] = e[Fe + 8 >> 2], e[Fe + 8 >> 2] = 0, e[Fe >> 2] = 0, e[Fe + 4 >> 2] = 0, (S | 0) != (Fe | 0); )
                                                      ;
                                                    if (e[G + 28 >> 2] = ke, S = e[G + 24 >> 2], e[G + 24 >> 2] = Tr, Fe = e[G + 20 >> 2], e[G + 20 >> 2] = g, (S | 0) == (Fe | 0))
                                                      break c;
                                                    for (; ; ) {
                                                      if (hr = S - 12 | 0, Tr = e[hr >> 2], Tr) {
                                                        if (Rn = S - 8 | 0, g = e[Rn >> 2], ke = Tr, (g | 0) != (ke | 0)) {
                                                          for (; ; ) {
                                                            g = g - 32 | 0, S = e[g + 4 >> 2];
                                                            u: {
                                                              if (!S || (ke = e[S + 4 >> 2], e[S + 4 >> 2] = ke - 1, ke))
                                                                break u;
                                                              _n[e[e[S >> 2] + 8 >> 2]](S), cs(S);
                                                            }
                                                            if ((g | 0) == (Tr | 0))
                                                              break;
                                                          }
                                                          ke = e[hr >> 2];
                                                        }
                                                        e[Rn >> 2] = Tr, Sr(ke);
                                                      }
                                                      if (S = hr, (Fe | 0) == (S | 0))
                                                        break;
                                                    }
                                                  }
                                                  if (Fe && Sr(Fe), ke = e[G + 124 >> 2], !ke)
                                                    break d;
                                                  if (g = e[G + 128 >> 2], S = ke, (g | 0) != (S | 0)) {
                                                    for (; ; ) {
                                                      g = g - 32 | 0, S = e[g + 4 >> 2];
                                                      c: {
                                                        if (!S || (Fe = e[S + 4 >> 2], e[S + 4 >> 2] = Fe - 1, Fe))
                                                          break c;
                                                        _n[e[e[S >> 2] + 8 >> 2]](S), cs(S);
                                                      }
                                                      if ((g | 0) == (ke | 0))
                                                        break;
                                                    }
                                                    S = e[G + 124 >> 2];
                                                  }
                                                  e[G + 128 >> 2] = ke, Sr(S);
                                                }
                                                if (Fe = e[G + 24 >> 2], g = Fe - 12 | 0, ci = vi(e[g + 4 >> 2] - e[g >> 2] >> 5, ci), Ar = Ar + 1 | 0, S = e[h >> 2], Ar >>> 0 >= e[h + 4 >> 2] - S >> 2 >>> 0)
                                                  break o;
                                                continue;
                                              }
                                              break;
                                            }
                                            g = Vr() | 0;
                                            break i;
                                          }
                                          g = Vr() | 0, lu(G + 124 | 0);
                                          break i;
                                        }
                                        g = Vr() | 0;
                                        break i;
                                      }
                                      if (!ci)
                                        break a;
                                    }
                                    Tr = 0;
                                    o: {
                                      l: {
                                        f: {
                                          d: {
                                            for (; ; ) {
                                              if (Fe = e[G + 32 >> 2], e[h + 4 >> 2] != e[h >> 2])
                                                for (g = 0, ke = e[G + 20 >> 2], S = Tr; Ar = vi(g, 12), hr = Ar + ke | 0, ke = e[hr >> 2], e[(g << 2) + Fe >> 2] = ke + ((S >>> 0) % (e[hr + 4 >> 2] - ke >> 5 >>> 0) << 5), hr = S, ke = e[G + 20 >> 2], S = Ar + ke | 0, S = (hr >>> 0) / (e[S + 4 >> 2] - e[S >> 2] >> 5 >>> 0) | 0, g = g + 1 | 0, g >>> 0 < e[h + 4 >> 2] - e[h >> 2] >> 2 >>> 0; )
                                                  ;
                                              if (e[G + 108 >> 2] = 0, e[G + 100 >> 2] = 0, e[G + 104 >> 2] = 0, g = Fe, ln = e[G + 36 >> 2], (g | 0) != (ln | 0)) {
                                                c: {
                                                  for (; ; ) {
                                                    u: {
                                                      Ar = e[Fe >> 2], g = e[G + 104 >> 2];
                                                      g: {
                                                        if ((g | 0) != e[G + 108 >> 2]) {
                                                          e[g >> 2] = e[Ar >> 2], S = e[Ar + 4 >> 2], e[g + 4 >> 2] = S, S && (e[S + 4 >> 2] = e[S + 4 >> 2] + 1), e[G + 104 >> 2] = g + 8;
                                                          break g;
                                                        }
                                                        A: {
                                                          ke = e[G + 100 >> 2], S = g - ke | 0, Rn = S >> 3, hr = Rn + 1 | 0;
                                                          p: {
                                                            if (hr >>> 0 >= 536870912) {
                                                              e[5996] = 0, Ri(59);
                                                              break p;
                                                            }
                                                            if (Mn = S >> 2, S = S >>> 0 >= 2147483640 ? 536870911 : hr >>> 0 < Mn >>> 0 ? Mn : hr, S >>> 0 < 536870912)
                                                              break A;
                                                            e[5996] = 0, Ri(35);
                                                          }
                                                          if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                            break e;
                                                          g = Vr() | 0;
                                                          break o;
                                                        }
                                                        if (e[5996] = 0, Mn = S << 3, hr = ii(3, Mn | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                          break u;
                                                        S = hr + (Rn << 3) | 0, e[S >> 2] = e[Ar >> 2], Ar = e[Ar + 4 >> 2], e[S + 4 >> 2] = Ar, Ar && (e[Ar + 4 >> 2] = e[Ar + 4 >> 2] + 1, g = e[G + 104 >> 2]), Ar = hr + Mn | 0, hr = S + 8 | 0;
                                                        A: {
                                                          if ((g | 0) == (ke | 0)) {
                                                            e[G + 108 >> 2] = Ar, e[G + 104 >> 2] = hr, e[G + 100 >> 2] = S;
                                                            break A;
                                                          }
                                                          for (; S = S - 8 | 0, g = g - 8 | 0, e[S >> 2] = e[g >> 2], e[S + 4 >> 2] = e[g + 4 >> 2], e[g >> 2] = 0, e[g + 4 >> 2] = 0, (g | 0) != (ke | 0); )
                                                            ;
                                                          if (e[G + 108 >> 2] = Ar, g = e[G + 104 >> 2], e[G + 104 >> 2] = hr, ke = e[G + 100 >> 2], e[G + 100 >> 2] = S, (g | 0) == (ke | 0))
                                                            break A;
                                                          for (; ; ) {
                                                            g = g - 8 | 0, S = e[g + 4 >> 2];
                                                            p: {
                                                              if (!S || (Ar = e[S + 4 >> 2], e[S + 4 >> 2] = Ar - 1, Ar))
                                                                break p;
                                                              _n[e[e[S >> 2] + 8 >> 2]](S), cs(S);
                                                            }
                                                            if ((g | 0) == (ke | 0))
                                                              break;
                                                          }
                                                        }
                                                        if (!ke)
                                                          break g;
                                                        Sr(ke);
                                                      }
                                                      if (Fe = Fe + 4 | 0, (ln | 0) != (Fe | 0))
                                                        continue;
                                                      break c;
                                                    }
                                                    break;
                                                  }
                                                  g = Vr() | 0;
                                                  break o;
                                                }
                                                Fe = e[G + 36 >> 2], g = e[G + 32 >> 2];
                                              }
                                              if (e[5996] = 0, rf(63, G + 80 | 0, c | 0, g | 0, Fe | 0, 0), g = e[5996], e[5996] = 0, (g | 0) == 1 || (e[5996] = 0, Fe = ii(3, 104) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1))
                                                break l;
                                              e[Fe >> 2] = 7e3, e[Fe + 4 >> 2] = 0, e[Fe + 8 >> 2] = 0, Mn = e[G + 100 >> 2], e[G + 112 >> 2] = Mn, ei = e[G + 104 >> 2], e[G + 116 >> 2] = ei, hr = e[G + 108 >> 2], g = 0, e[G + 108 >> 2] = 0, e[G + 120 >> 2] = hr, e[G + 100 >> 2] = 0, e[G + 104 >> 2] = 0, S = e[y >> 2], ln = e[y + 4 >> 2];
                                              c: {
                                                if ((S | 0) == (ln | 0)) {
                                                  Ar = 0, ke = 0;
                                                  break c;
                                                }
                                                if (Rn = ln - S | 0, (Rn | 0) < 0) {
                                                  if (e[5996] = 0, Ri(8), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                    break e;
                                                  g = Vr() | 0;
                                                  break f;
                                                }
                                                if (e[5996] = 0, Ar = ii(3, Rn | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                  break d;
                                                if (Qi = ln + (S ^ -1) | 0, ke = 0, g = Ar, Ji = Rn & 7, Ji)
                                                  for (; $[g | 0] = ye[S | 0], g = g + 1 | 0, S = S + 1 | 0, ke = ke + 1 | 0, (Ji | 0) != (ke | 0); )
                                                    ;
                                                if (ke = Ar + Rn | 0, Qi >>> 0 < 7)
                                                  break c;
                                                for (; $[g | 0] = ye[S | 0], $[g + 1 | 0] = ye[S + 1 | 0], $[g + 2 | 0] = ye[S + 2 | 0], $[g + 3 | 0] = ye[S + 3 | 0], $[g + 4 | 0] = ye[S + 4 | 0], $[g + 5 | 0] = ye[S + 5 | 0], $[g + 6 | 0] = ye[S + 6 | 0], $[g + 7 | 0] = ye[S + 7 | 0], g = g + 8 | 0, S = S + 8 | 0, (ln | 0) != (S | 0); )
                                                  ;
                                                hr = e[G + 120 >> 2], ei = e[G + 116 >> 2], Mn = e[G + 112 >> 2];
                                              }
                                              e[Fe + 12 >> 2] = c, e[Fe + 16 >> 2] = 0, e[Fe + 20 >> 2] = 0, e[Fe + 24 >> 2] = 0, e[Fe + 28 >> 2] = 0, e[Fe + 52 >> 2] = hr, e[Fe + 48 >> 2] = ei, Rn = Fe + 44 | 0, e[Rn >> 2] = Mn, e[Fe + 40 >> 2] = ke, e[Fe + 36 >> 2] = g, e[Fe + 32 >> 2] = Ar, e[G + 120 >> 2] = 0, e[G + 112 >> 2] = 0, e[G + 116 >> 2] = 0, e[5996] = 0, ke = Fe + 12 | 0, di(86, Fe + 56 | 0, ke | 0), g = e[5996], e[5996] = 0;
                                              c: {
                                                if ((g | 0) == 1 || (e[5996] = 0, di(87, Fe + 76 | 0, ke | 0), g = e[5996], e[5996] = 0, (g | 0) == 1) || (e[5996] = 0, g = ii(88, ke | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1))
                                                  break c;
                                                if (e[Fe + 92 >> 2] = g, S = 0, hr = 0, Ar = e[Fe + 44 >> 2], g = Ar, ln = e[Fe + 48 >> 2], (g | 0) != (ln | 0)) {
                                                  for (; S = e[e[g >> 2] + 84 >> 2] + S | 0, g = g + 8 | 0, (ln | 0) != (g | 0); )
                                                    ;
                                                  hr = e[e[Ar >> 2] + 80 >> 2];
                                                }
                                                if (g = e[Fe + 16 >> 2], Mn = e[Fe + 12 >> 2], ei = e[Fe + 20 >> 2], Qi = e[Fe + 24 >> 2], e[5996] = 0, g = Fa(89, Mn | 0, hr | 0, S | 0, g | 0, ln - Ar >> 3, (Qi - ei | 0) / 12 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1 || (e[Fe + 96 >> 2] = g, e[5996] = 0, e[G + 140 >> 2] = ke, as(90, G + 124 | 0, ke | 0, G + 140 | 0), g = e[5996], e[5996] = 0, (g | 0) == 1))
                                                  break c;
                                                if (g = ye[G + 136 | 0], g && Je(e[G + 128 >> 2]), $[Fe + 100 | 0] = g ^ 1, e[G + 128 >> 2] = Fe, e[G + 124 >> 2] = ke, e[5996] = 0, g = e[G + 128 >> 2], e[G + 8 >> 2] = e[G + 124 >> 2], e[G + 12 >> 2] = g, as(61, r | 0, G + 80 | 0, G + 8 | 0), g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                  break l;
                                                if (S = e[G + 100 >> 2], S) {
                                                  if (g = e[G + 104 >> 2], (S | 0) != (g | 0)) {
                                                    for (; ; ) {
                                                      g = g - 8 | 0, ke = e[g + 4 >> 2];
                                                      u: {
                                                        if (!ke || (Fe = e[ke + 4 >> 2], e[ke + 4 >> 2] = Fe - 1, Fe))
                                                          break u;
                                                        _n[e[e[ke >> 2] + 8 >> 2]](ke), cs(ke);
                                                      }
                                                      if ((g | 0) == (S | 0))
                                                        break;
                                                    }
                                                    S = e[G + 100 >> 2];
                                                  }
                                                  Sr(S);
                                                }
                                                if (Tr = Tr + 1 | 0, (ci | 0) != (Tr | 0))
                                                  continue;
                                                break a;
                                              }
                                              break;
                                            }
                                            g = Vr() | 0, xo(Rn), r = e[Fe + 32 >> 2], r && (e[Fe + 36 >> 2] = r, Sr(r)), Wo(Fe + 20 | 0);
                                            break f;
                                          }
                                          g = Vr() | 0;
                                        }
                                        xo(G + 112 | 0), Sr(Fe);
                                        break o;
                                      }
                                      g = Vr() | 0;
                                    }
                                    xo(G + 100 | 0);
                                    break i;
                                  }
                                  if (ke = e[G + 20 >> 2], ke) {
                                    if (g = e[G + 24 >> 2], (ke | 0) != (g | 0)) {
                                      for (; ; ) {
                                        if (Ar = g - 12 | 0, Fe = e[Ar >> 2], Fe) {
                                          if (Tr = g - 8 | 0, g = e[Tr >> 2], S = Fe, (g | 0) != (S | 0)) {
                                            for (; ; ) {
                                              g = g - 32 | 0, S = e[g + 4 >> 2];
                                              a: {
                                                if (!S || (hr = e[S + 4 >> 2], e[S + 4 >> 2] = hr - 1, hr))
                                                  break a;
                                                _n[e[e[S >> 2] + 8 >> 2]](S), cs(S);
                                              }
                                              if ((g | 0) == (Fe | 0))
                                                break;
                                            }
                                            S = e[Ar >> 2];
                                          }
                                          e[Tr >> 2] = Fe, Sr(S);
                                        }
                                        if (g = Ar, (ke | 0) == (g | 0))
                                          break;
                                      }
                                      ke = e[G + 20 >> 2];
                                    }
                                    Sr(ke);
                                  }
                                  if (gi = gi + 1 | 0, g = e[G + 44 >> 2], gi >>> 0 < (e[G + 48 >> 2] - g | 0) / 12 >>> 0)
                                    continue;
                                  break t;
                                }
                                break;
                              }
                              if (e[5996] = 0, Qs(44, 5170, 1900, 642, 2497), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                break e;
                              g = Vr() | 0;
                            }
                            mf(G + 20 | 0);
                            break n;
                          }
                          g = Vr() | 0;
                        }
                        r = e[G + 32 >> 2], r && Sr(r), Qc(G + 44 | 0);
                        break r;
                      }
                      g = Vr() | 0;
                    }
                    ca(G + 56 | 0), Ki(g | 0), ri();
                  }
                  if (r = e[G + 32 >> 2], r && (Sr(r), g = e[G + 44 >> 2]), g) {
                    if (S = g, ke = e[G + 48 >> 2], (ke | 0) != (g | 0)) {
                      for (; r = ke - 12 | 0, o = e[r >> 2], o && (e[ke - 8 >> 2] = o, Sr(o)), ke = r, (ke | 0) != (g | 0); )
                        ;
                      S = e[G + 44 >> 2];
                    }
                    e[G + 48 >> 2] = g, Sr(S);
                  }
                  r = e[G + 68 >> 2], r && (e[G + 72 >> 2] = r, Sr(r)), r = e[G + 56 >> 2], r && (e[G + 60 >> 2] = r, Sr(r)), Yr = G + 144 | 0;
                  return;
                }
                ri();
              }
              function L1(r, o, c, h, y, g, S, G, ke) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, G = G | 0, ke = ke | 0;
                var Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0;
                Fe = Yr - 208 | 0, Yr = Fe;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  f: {
                                    d: {
                                      c: {
                                        u: {
                                          g: {
                                            A: {
                                              p: {
                                                I: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              b: {
                                                                h: {
                                                                  x: {
                                                                    if (Ar = Da(r), Ar >>> 0 >= 2147483632) {
                                                                      if (e[5996] = 0, Ri(2), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                        break x;
                                                                      break e;
                                                                    }
                                                                    m: {
                                                                      if (Ar >>> 0 <= 10) {
                                                                        $[Fe + 171 | 0] = Ar, ln = Fe + 160 | 0;
                                                                        break m;
                                                                      }
                                                                      if (e[5996] = 0, Tr = (Ar | 15) + 1 | 0, ln = ii(3, Tr | 0) | 0, hr = e[5996], e[5996] = 0, (hr | 0) == 1)
                                                                        break x;
                                                                      e[Fe + 160 >> 2] = ln, e[Fe + 164 >> 2] = Ar, e[Fe + 168 >> 2] = Tr | -2147483648;
                                                                    }
                                                                    $[_s(ln, r, Ar) + Ar | 0] = 0, hr = e[Fe + 160 >> 2], r = ye[Fe + 171 | 0], Mn = r << 24 >> 24, Ar = (Mn | 0) < 0, Rn = Ar ? hr : Fe + 160 | 0, ci = Ar ? e[Fe + 164 >> 2] : r, Ar = Rn + ci | 0, ln = -1;
                                                                    m: {
                                                                      for (; ; ) {
                                                                        if ((Ar | 0) == (Rn | 0))
                                                                          break m;
                                                                        if (Ar = Ar - 1 | 0, Tr = ye[Ar | 0], gi = Tr >>> 0 <= 63, r = Tr & 31, (Tr & 63) >>> 0 >= 32 ? (Tr = 1 << r, r = 0) : (ei = 1 << r, Tr = ei - 1 & 1 >>> 32 - r, r = ei), r = r & 9728, !(gi & (Tr & 1 | (r | 0) != 0)))
                                                                          break;
                                                                      }
                                                                      ln = Ar - Rn | 0;
                                                                    }
                                                                    if (r = ln + 1 | 0, r >>> 0 > ci >>> 0) {
                                                                      if (e[5996] = 0, Ri(108), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                        break e;
                                                                      Ar = Ts(22864) | 0, r = uo;
                                                                      break c;
                                                                    }
                                                                    m: {
                                                                      if ((Mn | 0) < 0) {
                                                                        e[Fe + 164 >> 2] = r;
                                                                        break m;
                                                                      }
                                                                      $[Fe + 171 | 0] = r, hr = Fe + 160 | 0;
                                                                    }
                                                                    $[r + hr | 0] = 0, e[Fe + 152 >> 2] = 0, e[Fe + 156 >> 2] = 0;
                                                                    m: {
                                                                      if ($[Fe + 171 | 0] >= 0) {
                                                                        e[Fe + 144 >> 2] = e[Fe + 168 >> 2], r = e[Fe + 164 >> 2], e[Fe + 136 >> 2] = e[Fe + 160 >> 2], e[Fe + 140 >> 2] = r;
                                                                        break m;
                                                                      }
                                                                      if (e[5996] = 0, as(40, Fe + 136 | 0, e[Fe + 160 >> 2], e[Fe + 164 >> 2]), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                        break h;
                                                                    }
                                                                    if (e[5996] = 0, r = Fe + 172 | 0, di(109, r | 0, Fe + 136 | 0), Ar = e[5996], e[5996] = 0, (Ar | 0) == 1)
                                                                      break b;
                                                                    if (Tr = r, r = $[Fe + 183 | 0], Ar = (r | 0) < 0, e[Fe + 104 >> 2] = Ar ? e[Fe + 172 >> 2] : Tr, e[Fe + 108 >> 2] = Ar ? e[Fe + 176 >> 2] : r & 255, e[5996] = 0, r = e[Fe + 108 >> 2], e[Fe + 8 >> 2] = e[Fe + 104 >> 2], e[Fe + 12 >> 2] = r, di(140, Fe + 16 | 0, Fe + 8 | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                      break w;
                                                                    r = e[Fe + 20 >> 2], e[Fe + 156 >> 2] = r, Ar = e[Fe + 16 >> 2], e[Fe + 152 >> 2] = Ar, $[Fe + 183 | 0] < 0 && Sr(e[Fe + 172 >> 2]), $[Fe + 147 | 0] < 0 && Sr(e[Fe + 136 >> 2]);
                                                                    m: {
                                                                      if (!Ar || (ln = e[Ar + 80 >> 2], !ln | Ps[Ar + 84 >> 2] > 3600))
                                                                        break m;
                                                                      if (e[5996] = 0, Tr = On(54, 3557, 1) | 0, hr = e[5996], e[5996] = 0, (hr | 0) == 1)
                                                                        break T;
                                                                      if (!((ln ^ -1) & Tr))
                                                                        break k;
                                                                    }
                                                                    if (e[5996] = 0, g = ii(3, 32) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                      break S;
                                                                    if ($[g + 16 | 0] = 0, S = ye[2571] | ye[2572] << 8 | (ye[2573] << 16 | ye[2574] << 24), G = ye[2567] | ye[2568] << 8 | (ye[2569] << 16 | ye[2570] << 24), $[g + 8 | 0] = G, $[g + 9 | 0] = G >>> 8, $[g + 10 | 0] = G >>> 16, $[g + 11 | 0] = G >>> 24, $[g + 12 | 0] = S, $[g + 13 | 0] = S >>> 8, $[g + 14 | 0] = S >>> 16, $[g + 15 | 0] = S >>> 24, S = ye[2563] | ye[2564] << 8 | (ye[2565] << 16 | ye[2566] << 24), G = ye[2559] | ye[2560] << 8 | (ye[2561] << 16 | ye[2562] << 24), $[g | 0] = G, $[g + 1 | 0] = G >>> 8, $[g + 2 | 0] = G >>> 16, $[g + 3 | 0] = G >>> 24, $[g + 4 | 0] = S, $[g + 5 | 0] = S >>> 8, $[g + 6 | 0] = S >>> 16, $[g + 7 | 0] = S >>> 24, S = ((c | 0) >= 17 ? 17 : c) - 1 | 0, $[_s(o, g, S) + S | 0] = 0, Sr(g), e[5996] = 0, g = ii(3, 32) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                      break N;
                                                                    $[g + 16 | 0] = 0, c = ye[2571] | ye[2572] << 8 | (ye[2573] << 16 | ye[2574] << 24), o = g, g = ye[2567] | ye[2568] << 8 | (ye[2569] << 16 | ye[2570] << 24), $[o + 8 | 0] = g, $[o + 9 | 0] = g >>> 8, $[o + 10 | 0] = g >>> 16, $[o + 11 | 0] = g >>> 24, $[o + 12 | 0] = c, $[o + 13 | 0] = c >>> 8, $[o + 14 | 0] = c >>> 16, $[o + 15 | 0] = c >>> 24, c = ye[2563] | ye[2564] << 8 | (ye[2565] << 16 | ye[2566] << 24), g = ye[2559] | ye[2560] << 8 | (ye[2561] << 16 | ye[2562] << 24), $[o | 0] = g, $[o + 1 | 0] = g >>> 8, $[o + 2 | 0] = g >>> 16, $[o + 3 | 0] = g >>> 24, $[o + 4 | 0] = c, $[o + 5 | 0] = c >>> 8, $[o + 6 | 0] = c >>> 16, $[o + 7 | 0] = c >>> 24, c = ((y | 0) >= 17 ? 17 : y) - 1 | 0, $[_s(h, o, c) + c | 0] = 0, Sr(o);
                                                                    break I;
                                                                  }
                                                                  Ar = Ts(22864) | 0, r = uo;
                                                                  break d;
                                                                }
                                                                Ar = Ts(22864) | 0, r = uo;
                                                                break u;
                                                              }
                                                              Ar = Ts(22864) | 0, r = uo;
                                                              break v;
                                                            }
                                                            if (Ar = Ts(22864) | 0, r = uo, $[Fe + 183 | 0] >= 0)
                                                              break v;
                                                            Sr(e[Fe + 172 >> 2]);
                                                          }
                                                          if ($[Fe + 147 | 0] >= 0)
                                                            break u;
                                                          Sr(e[Fe + 136 >> 2]);
                                                          break u;
                                                        }
                                                        Ar = Ts(22864) | 0, r = uo;
                                                        break u;
                                                      }
                                                      Ar = Ts(22864) | 0, r = uo;
                                                      break u;
                                                    }
                                                    Ar = Ts(22864) | 0, r = uo;
                                                    break u;
                                                  }
                                                  r = e[Ar + 84 >> 2], e[5996] = 0, ln = Fe + 60 | 0, di(115, ln | 0, r | 0), r = e[5996], e[5996] = 0;
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              b: {
                                                                h: {
                                                                  x: {
                                                                    m: {
                                                                      B: {
                                                                        R: {
                                                                          E: {
                                                                            if ((r | 0) != 1) {
                                                                              if (e[5996] = 0, r = Si(99, ln | 0, 0, 5546) | 0, ln = e[5996], e[5996] = 0, (ln | 0) == 1)
                                                                                break E;
                                                                              if (e[Fe + 80 >> 2] = e[r + 8 >> 2], ln = e[r + 4 >> 2], e[Fe + 72 >> 2] = e[r >> 2], e[Fe + 76 >> 2] = ln, e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[5996] = 0, ln = On(97, Fe + 72 | 0, 3581) | 0, Tr = e[5996], e[5996] = 0, (Tr | 0) == 1)
                                                                                break R;
                                                                              if (e[Fe + 96 >> 2] = e[ln + 8 >> 2], Tr = e[ln + 4 >> 2], e[Fe + 88 >> 2] = e[ln >> 2], e[Fe + 92 >> 2] = Tr, e[ln >> 2] = 0, e[ln + 4 >> 2] = 0, e[ln + 8 >> 2] = 0, e[5996] = 0, Tr = Fe + 172 | 0, di(141, Tr | 0, Fe + 152 | 0), hr = e[5996], e[5996] = 0, (hr | 0) == 1)
                                                                                break B;
                                                                              if (e[5996] = 0, ei = Tr, Tr = ye[Fe + 183 | 0], hr = Tr << 24 >> 24 < 0, Tr = Si(100, Fe + 88 | 0, (hr ? e[Fe + 172 >> 2] : ei) | 0, (hr ? e[Fe + 176 >> 2] : Tr) | 0) | 0, hr = e[5996], e[5996] = 0, (hr | 0) == 1)
                                                                                break m;
                                                                              if (e[Fe + 112 >> 2] = e[Tr + 8 >> 2], hr = e[Tr + 4 >> 2], e[Fe + 104 >> 2] = e[Tr >> 2], e[Fe + 108 >> 2] = hr, e[Tr >> 2] = 0, e[Tr + 4 >> 2] = 0, e[Tr + 8 >> 2] = 0, e[5996] = 0, hr = On(97, Fe + 104 | 0, 3570) | 0, Rn = e[5996], e[5996] = 0, (Rn | 0) == 1)
                                                                                break x;
                                                                              if (e[Fe + 128 >> 2] = e[hr + 8 >> 2], Rn = e[hr + 4 >> 2], e[Fe + 120 >> 2] = e[hr >> 2], e[Fe + 124 >> 2] = Rn, e[hr >> 2] = 0, e[hr + 4 >> 2] = 0, e[hr + 8 >> 2] = 0, $[Fe + 183 | 0] < 0 && Sr(e[Fe + 172 >> 2]), $[Tr + 11 | 0] < 0 && Sr(e[Tr >> 2]), $[ln + 11 | 0] < 0 && Sr(e[ln >> 2]), $[r + 11 | 0] < 0 && Sr(e[r >> 2]), ln = e[Fe + 120 >> 2], r = ye[Fe + 131 | 0], Tr = r << 24 >> 24, hr = (Tr | 0) < 0, ei = hr ? ln : Fe + 120 | 0, r = hr ? e[Fe + 124 >> 2] : r, hr = c - 1 | 0, r = (r | 0) < (hr | 0) ? r : hr, $[_s(o, ei, r) + r | 0] = 0, e[5996] = 0, hr = Fe + 172 | 0, di(117, hr | 0, Ar | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                break T;
                                                                              if (e[Fe + 44 >> 2] = e[Fe + 200 >> 2], r = e[Fe + 196 >> 2], e[Fe + 36 >> 2] = e[Fe + 192 >> 2], e[Fe + 40 >> 2] = r, r = e[Fe + 188 >> 2], e[Fe + 28 >> 2] = e[Fe + 184 >> 2], e[Fe + 32 >> 2] = r, r = e[Fe + 180 >> 2], e[Fe + 20 >> 2] = e[Fe + 176 >> 2], e[Fe + 24 >> 2] = r, r = e[Fe + 172 >> 2], e[Fe + 16 >> 2] = r, e[5996] = 0, Rn = r >>> 0 < 29, Mn = Rn ? Fe + 20 | 0 : e[Fe + 24 >> 2], e[Fe + 172 >> 2] = Mn, ci = Fe + 48 | 0, Qs(102, ci | 0, hr | 0, Mn + (Rn ? r : r - 29 | 0) | 0, 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                break S;
                                                                              if (r = e[Fe + 48 >> 2], hr = ye[Fe + 59 | 0], Rn = hr << 24 >> 24, Mn = (Rn | 0) < 0, ei = Mn ? r : ci, hr = Mn ? e[Fe + 52 >> 2] : hr, Mn = y - 1 | 0, hr = (hr | 0) < (Mn | 0) ? hr : Mn, $[_s(h, ei, hr) + hr | 0] = 0, (Rn | 0) < 0 && Sr(r), Ps[Fe + 16 >> 2] >= 29 && (Sr(e[Fe + 24 >> 2]), Ar = e[Fe + 152 >> 2]), r = e[Ar + 80 >> 2], !r | Ps[Ar + 84 >> 2] > 3600 | (e[Ar + 52 >> 2] + e[Ar + 44 >> 2] >>> 0 > 201 | Ps[Ar + 68 >> 2] > 100))
                                                                                break N;
                                                                              if (e[5996] = 0, hr = On(54, 2049, 1) | 0, Rn = e[5996], e[5996] = 0, (Rn | 0) == 1)
                                                                                break p;
                                                                              if ((r ^ -1) & hr)
                                                                                break N;
                                                                              if (r = e[Ar + 80 >> 2], e[5996] = 0, hr = On(54, 2165, 1) | 0, Rn = e[5996], e[5996] = 0, (Rn | 0) == 1)
                                                                                break p;
                                                                              if (ye[Ar + 88 | 0] | (r ^ -1) & hr)
                                                                                break N;
                                                                              $[Fe + 176 | 0] = 0, e[Fe + 172 >> 2] = 1702195828, $[Fe + 183 | 0] = 4, r = ((ke | 0) >= 5 ? 5 : ke) - 1 | 0, $[_s(G, Fe + 172 | 0, r) + r | 0] = 0;
                                                                              break k;
                                                                            }
                                                                            Ar = Ts(22864) | 0, r = uo;
                                                                            break u;
                                                                          }
                                                                          Ar = Ts(22864) | 0, r = uo;
                                                                          break v;
                                                                        }
                                                                        Ar = Ts(22864) | 0, r = uo;
                                                                        break w;
                                                                      }
                                                                      Ar = Ts(22864) | 0, r = uo;
                                                                      break b;
                                                                    }
                                                                    Ar = Ts(22864) | 0, r = uo;
                                                                    break h;
                                                                  }
                                                                  if (Ar = Ts(22864) | 0, r = uo, $[Fe + 115 | 0] >= 0)
                                                                    break h;
                                                                  Sr(e[Fe + 104 >> 2]);
                                                                }
                                                                if ($[Fe + 183 | 0] >= 0)
                                                                  break b;
                                                                Sr(e[Fe + 172 >> 2]);
                                                              }
                                                              if ($[Fe + 99 | 0] >= 0)
                                                                break w;
                                                              Sr(e[Fe + 88 >> 2]);
                                                            }
                                                            if ($[Fe + 83 | 0] >= 0)
                                                              break v;
                                                            Sr(e[Fe + 72 >> 2]);
                                                          }
                                                          if ($[Fe + 71 | 0] >= 0)
                                                            break u;
                                                          Sr(e[Fe + 60 >> 2]);
                                                          break u;
                                                        }
                                                        Ar = Ts(22864) | 0;
                                                        break A;
                                                      }
                                                      if (Ar = Ts(22864) | 0, r = uo, Ps[Fe + 16 >> 2] < 29)
                                                        break g;
                                                      Sr(e[Fe + 24 >> 2]);
                                                      break g;
                                                    }
                                                    $[Fe + 176 | 0] = ye[2354], $[Fe + 183 | 0] = 5, $[Fe + 177 | 0] = 0, e[Fe + 172 >> 2] = ye[2350] | ye[2351] << 8 | (ye[2352] << 16 | ye[2353] << 24), r = ((ke | 0) >= 6 ? 6 : ke) - 1 | 0, $[_s(G, Fe + 172 | 0, r) + r | 0] = 0;
                                                  }
                                                  if (e[5996] = 0, r = ii(118, Ar | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                                    break p;
                                                  k: {
                                                    if (r) {
                                                      $[Fe + 176 | 0] = 0, e[Fe + 172 >> 2] = 1702195828, $[Fe + 183 | 0] = 4, r = ((S | 0) >= 5 ? 5 : S) - 1 | 0, $[_s(g, Fe + 172 | 0, r) + r | 0] = 0;
                                                      break k;
                                                    }
                                                    $[Fe + 176 | 0] = ye[2354], $[Fe + 183 | 0] = 5, $[Fe + 177 | 0] = 0, e[Fe + 172 >> 2] = ye[2350] | ye[2351] << 8 | (ye[2352] << 16 | ye[2353] << 24), r = ((S | 0) >= 6 ? 6 : S) - 1 | 0, $[_s(g, Fe + 172 | 0, r) + r | 0] = 0;
                                                  }
                                                  (Tr | 0) < 0 && Sr(ln), r = e[Fe + 156 >> 2];
                                                }
                                                I: {
                                                  if (!r || (o = e[r + 4 >> 2], e[r + 4 >> 2] = o - 1, o))
                                                    break I;
                                                  _n[e[e[r >> 2] + 8 >> 2]](r), cs(r);
                                                }
                                                if ($[Fe + 171 | 0] >= 0)
                                                  break f;
                                                Sr(e[Fe + 160 >> 2]);
                                                break f;
                                              }
                                              Ar = Ts(22864) | 0;
                                            }
                                            r = uo;
                                          }
                                          if ((Tr | 0) >= 0)
                                            break u;
                                          Sr(ln);
                                        }
                                        No(Fe + 152 | 0);
                                      }
                                      if ($[Fe + 171 | 0] >= 0)
                                        break d;
                                      Sr(e[Fe + 160 >> 2]);
                                    }
                                    if ((vl(22864) | 0) != (r | 0))
                                      break r;
                                    if (r = yu(Ar | 0) | 0, r = _n[e[e[r >> 2] + 8 >> 2]](r) | 0, e[5996] = 0, S = On(30, Fe + 120 | 0, r | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                      break l;
                                    if (e[5996] = 0, r = Si(99, S | 0, 0, 5474) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                      break o;
                                    if (e[Fe + 168 >> 2] = e[r + 8 >> 2], g = e[r + 4 >> 2], e[Fe + 160 >> 2] = e[r >> 2], e[Fe + 164 >> 2] = g, e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[5996] = 0, g = On(97, Fe + 160 | 0, 2611) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                      break a;
                                    e[Fe + 24 >> 2] = e[g + 8 >> 2], S = e[g + 4 >> 2], e[Fe + 16 >> 2] = e[g >> 2], e[Fe + 20 >> 2] = S, e[g >> 2] = 0, e[g + 4 >> 2] = 0, e[g + 8 >> 2] = 0, Ar = o, o = e[Fe + 16 >> 2], S = ye[Fe + 27 | 0], G = S << 24 >> 24, ke = (G | 0) < 0, S = ke ? e[Fe + 20 >> 2] : S, c = c - 1 | 0, c = (c | 0) > (S | 0) ? S : c, $[_s(Ar, ke ? o : Fe + 16 | 0, c) + c | 0] = 0;
                                    d: {
                                      if ((G | 0) >= 0 || (Sr(o), $[g + 11 | 0] >= 0))
                                        break d;
                                      Sr(e[g >> 2]);
                                    }
                                    if ($[r + 11 | 0] < 0 && Sr(e[r >> 2]), e[5996] = 0, r = On(30, Fe + 16 | 0, 5575) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                      break i;
                                    S = h, o = e[r >> 2], c = ye[r + 11 | 0], h = c << 24 >> 24, g = (h | 0) < 0, G = g ? o : r, r = g ? e[r + 4 >> 2] : c, c = y - 1 | 0, r = (r | 0) < (c | 0) ? r : c, $[_s(S, G, r) + r | 0] = 0, (h | 0) < 0 && Sr(o), Wu();
                                  }
                                  Yr = Fe + 208 | 0;
                                  return;
                                }
                                Ar = Vr() | 0;
                                break n;
                              }
                              Ar = Vr() | 0;
                              break s;
                            }
                            if (Ar = Vr() | 0, $[Fe + 171 | 0] >= 0)
                              break s;
                            Sr(e[Fe + 160 >> 2]);
                          }
                          if ($[S + 11 | 0] >= 0)
                            break n;
                          Sr(e[S >> 2]);
                          break n;
                        }
                        Ar = Vr() | 0;
                      }
                      if (e[5996] = 0, Ri(110), r = e[5996], e[5996] = 0, (r | 0) == 1)
                        break t;
                    }
                    Ki(Ar | 0), ri();
                  }
                  Ts(0) | 0, va(), ri();
                }
                ri();
              }
              function zd(r, o, c, h, y) {
                var g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0, Qi = 0, Ji = 0;
                G = Yr - 160 | 0, Yr = G, vc(G + 48 | 0, c, Fi[r + 16 >> 3], Fi[r + 24 >> 3], 0, 0), e[5996] = 0, S = ii(46, c | 0) | 0, g = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((g | 0) != 1) {
                        if (e[G + 44 >> 2] = 0, e[G + 36 >> 2] = 0, e[G + 40 >> 2] = 0, $[G + 140 | 0] = 0, e[G + 136 >> 2] = G + 36, g = e[S + 4 >> 2], Fe = e[S >> 2], Tr = g - Fe | 0, ke = (Tr | 0) / 12 | 0, (g | 0) != (Fe | 0)) {
                          n: {
                            i: {
                              s: {
                                if (ke >>> 0 >= 357913942) {
                                  if (e[5996] = 0, Ri(47), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                    break s;
                                  break e;
                                }
                                if (e[5996] = 0, g = ii(3, Tr | 0) | 0, Fe = e[5996], e[5996] = 0, (Fe | 0) == 1)
                                  break s;
                                if (e[G + 40 >> 2] = g, e[G + 36 >> 2] = g, e[G + 44 >> 2] = g + vi(ke, 12), ke = e[S + 4 >> 2], S = e[S >> 2], e[5996] = 0, S = da(48, G + 44 | 0, S | 0, ke | 0, g | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) != 1)
                                  break n;
                                S = Vr() | 0, e[G + 40 >> 2] = g;
                                break i;
                              }
                              S = Vr() | 0;
                            }
                            i2(G + 136 | 0);
                            break r;
                          }
                          e[G + 40 >> 2] = S;
                        }
                        e[G + 32 >> 2] = 0, e[G + 24 >> 2] = 0, e[G + 28 >> 2] = 0, g = e[h + 4 >> 2], S = e[h >> 2], e[5996] = 0, di(49, G + 24 | 0, g - S >> 2), g = e[5996], e[5996] = 0;
                        n: {
                          if ((g | 0) != 1) {
                            if (S = e[G + 40 >> 2], g = e[G + 36 >> 2], (S | 0) == (g | 0))
                              break t;
                            gi = G + 112 | 0, S = g;
                            i: {
                              for (; ; ) {
                                s: {
                                  if (e[G + 20 >> 2] = 0, e[G + 12 >> 2] = 0, e[G + 16 >> 2] = 0, ke = e[h + 4 >> 2], g = e[h >> 2], ln = vi(ci, 12), S = ln + S | 0, ke - g >> 2 != e[S + 4 >> 2] - e[S >> 2] >> 3)
                                    break s;
                                  Fe = 0, Rn = 1, hr = 0;
                                  a: {
                                    if ((g | 0) != (ke | 0)) {
                                      o: {
                                        l: {
                                          f: {
                                            for (; ; ) {
                                              if (S = hr << 3, Qi = Fi[S + e[G + 60 >> 2] >> 3], Ji = Fi[S + e[G + 48 >> 2] >> 3], g = e[(hr << 2) + g >> 2], e[5996] = 0, g = lc(50, g | 0, +Ji, +Qi, o | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                break l;
                                              if (S = S + e[ln + e[G + 36 >> 2] >> 2] | 0, ke = e[S >> 2], S = e[S + 4 >> 2], Tr = e[g + 4 >> 2], g = e[g >> 2], e[5996] = 0, eu(51, G + 136 | 0, g | 0, Tr | 0, ke | 0, S | 0), g = e[5996], e[5996] = 0, (g | 0) != 1) {
                                                ke = e[G + 20 >> 2];
                                                d: {
                                                  if (ke >>> 0 > Fe >>> 0) {
                                                    e[Fe + 8 >> 2] = 0, e[Fe >> 2] = 0, e[Fe + 4 >> 2] = 0, e[Fe >> 2] = e[G + 136 >> 2], e[Fe + 4 >> 2] = e[G + 140 >> 2], e[Fe + 8 >> 2] = e[G + 144 >> 2], e[G + 16 >> 2] = Fe + 12;
                                                    break d;
                                                  }
                                                  c: {
                                                    g = e[G + 12 >> 2], Tr = (Fe - g | 0) / 12 | 0, S = Tr + 1 | 0;
                                                    u: {
                                                      if (S >>> 0 >= 357913942) {
                                                        e[5996] = 0, Ri(52);
                                                        break u;
                                                      }
                                                      if (ke = (ke - g | 0) / 12 | 0, Ar = ke << 1, S = ke >>> 0 >= 178956970 ? 357913941 : S >>> 0 < Ar >>> 0 ? Ar : S, S >>> 0 < 357913942)
                                                        break c;
                                                      e[5996] = 0, Ri(35);
                                                    }
                                                    if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                      break e;
                                                    break f;
                                                  }
                                                  if (e[5996] = 0, Ar = vi(S, 12), ke = ii(3, Ar | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                    break f;
                                                  S = ke + vi(Tr, 12) | 0, e[S >> 2] = e[G + 136 >> 2], e[S + 4 >> 2] = e[G + 140 >> 2], e[S + 8 >> 2] = e[G + 144 >> 2], e[G + 144 >> 2] = 0, e[G + 136 >> 2] = 0, e[G + 140 >> 2] = 0, ke = ke + Ar | 0, Tr = S + 12 | 0;
                                                  c: {
                                                    if ((g | 0) == (Fe | 0)) {
                                                      e[G + 20 >> 2] = ke, e[G + 16 >> 2] = Tr, e[G + 12 >> 2] = S;
                                                      break c;
                                                    }
                                                    for (; S = S - 12 | 0, Fe = Fe - 12 | 0, e[S >> 2] = e[Fe >> 2], e[S + 4 >> 2] = e[Fe + 4 >> 2], e[S + 8 >> 2] = e[Fe + 8 >> 2], e[Fe + 8 >> 2] = 0, e[Fe >> 2] = 0, e[Fe + 4 >> 2] = 0, (g | 0) != (Fe | 0); )
                                                      ;
                                                    if (e[G + 20 >> 2] = ke, g = e[G + 16 >> 2], e[G + 16 >> 2] = Tr, Fe = e[G + 12 >> 2], e[G + 12 >> 2] = S, (g | 0) == (Fe | 0))
                                                      break c;
                                                    for (; ; ) {
                                                      if (Ar = g - 12 | 0, Tr = e[Ar >> 2], Tr) {
                                                        if (Mn = g - 8 | 0, S = e[Mn >> 2], ke = Tr, (S | 0) != (ke | 0)) {
                                                          for (; ; ) {
                                                            S = S - 32 | 0, g = e[S + 4 >> 2];
                                                            u: {
                                                              if (!g || (ke = e[g + 4 >> 2], e[g + 4 >> 2] = ke - 1, ke))
                                                                break u;
                                                              _n[e[e[g >> 2] + 8 >> 2]](g), cs(g);
                                                            }
                                                            if ((S | 0) == (Tr | 0))
                                                              break;
                                                          }
                                                          ke = e[Ar >> 2];
                                                        }
                                                        e[Mn >> 2] = Tr, Sr(ke);
                                                      }
                                                      if (g = Ar, (Fe | 0) == (g | 0))
                                                        break;
                                                    }
                                                  }
                                                  if (Fe && Sr(Fe), ke = e[G + 136 >> 2], !ke)
                                                    break d;
                                                  if (g = ke, S = e[G + 140 >> 2], (g | 0) != (S | 0)) {
                                                    for (; ; ) {
                                                      S = S - 32 | 0, g = e[S + 4 >> 2];
                                                      c: {
                                                        if (!g || (Fe = e[g + 4 >> 2], e[g + 4 >> 2] = Fe - 1, Fe))
                                                          break c;
                                                        _n[e[e[g >> 2] + 8 >> 2]](g), cs(g);
                                                      }
                                                      if ((S | 0) == (ke | 0))
                                                        break;
                                                    }
                                                    g = e[G + 136 >> 2];
                                                  }
                                                  e[G + 140 >> 2] = ke, Sr(g);
                                                }
                                                if (Fe = e[G + 16 >> 2], g = Fe - 12 | 0, Rn = vi(e[g + 4 >> 2] - e[g >> 2] >> 5, Rn), hr = hr + 1 | 0, g = e[h >> 2], hr >>> 0 >= e[h + 4 >> 2] - g >> 2 >>> 0)
                                                  break o;
                                                continue;
                                              }
                                              break;
                                            }
                                            S = Vr() | 0;
                                            break i;
                                          }
                                          S = Vr() | 0, lu(G + 136 | 0);
                                          break i;
                                        }
                                        S = Vr() | 0;
                                        break i;
                                      }
                                      if (!Rn)
                                        break a;
                                    }
                                    Tr = 0;
                                    o: {
                                      l: {
                                        f: {
                                          d: {
                                            c: {
                                              u: {
                                                for (; ; ) {
                                                  if (Fe = e[G + 24 >> 2], e[h + 4 >> 2] != e[h >> 2])
                                                    for (S = 0, ke = e[G + 12 >> 2], g = Tr; Ar = vi(S, 12), hr = Ar + ke | 0, ke = e[hr >> 2], e[(S << 2) + Fe >> 2] = ke + ((g >>> 0) % (e[hr + 4 >> 2] - ke >> 5 >>> 0) << 5), hr = g, ke = e[G + 12 >> 2], g = Ar + ke | 0, g = (hr >>> 0) / (e[g + 4 >> 2] - e[g >> 2] >> 5 >>> 0) | 0, S = S + 1 | 0, S >>> 0 < e[h + 4 >> 2] - e[h >> 2] >> 2 >>> 0; )
                                                      ;
                                                  if (e[G + 100 >> 2] = 0, e[G + 92 >> 2] = 0, e[G + 96 >> 2] = 0, S = Fe, ln = e[G + 28 >> 2], (S | 0) != (ln | 0)) {
                                                    g: {
                                                      for (; ; ) {
                                                        A: {
                                                          Ar = e[Fe >> 2], S = e[G + 96 >> 2];
                                                          p: {
                                                            if ((S | 0) != e[G + 100 >> 2]) {
                                                              e[S >> 2] = e[Ar >> 2], g = e[Ar + 4 >> 2], e[S + 4 >> 2] = g, g && (e[g + 4 >> 2] = e[g + 4 >> 2] + 1), e[G + 96 >> 2] = S + 8;
                                                              break p;
                                                            }
                                                            I: {
                                                              ke = e[G + 92 >> 2], g = S - ke | 0, Mn = g >> 3, hr = Mn + 1 | 0;
                                                              k: {
                                                                if (hr >>> 0 >= 536870912) {
                                                                  e[5996] = 0, Ri(59);
                                                                  break k;
                                                                }
                                                                if (ei = g >> 2, g = g >>> 0 >= 2147483640 ? 536870911 : hr >>> 0 < ei >>> 0 ? ei : hr, g >>> 0 < 536870912)
                                                                  break I;
                                                                e[5996] = 0, Ri(35);
                                                              }
                                                              if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                break e;
                                                              S = Vr() | 0;
                                                              break o;
                                                            }
                                                            if (e[5996] = 0, ei = g << 3, hr = ii(3, ei | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                              break A;
                                                            g = hr + (Mn << 3) | 0, e[g >> 2] = e[Ar >> 2], Ar = e[Ar + 4 >> 2], e[g + 4 >> 2] = Ar, Ar && (e[Ar + 4 >> 2] = e[Ar + 4 >> 2] + 1, S = e[G + 96 >> 2]), Ar = hr + ei | 0, hr = g + 8 | 0;
                                                            I: {
                                                              if ((S | 0) == (ke | 0)) {
                                                                e[G + 100 >> 2] = Ar, e[G + 96 >> 2] = hr, e[G + 92 >> 2] = g;
                                                                break I;
                                                              }
                                                              for (; g = g - 8 | 0, S = S - 8 | 0, e[g >> 2] = e[S >> 2], e[g + 4 >> 2] = e[S + 4 >> 2], e[S >> 2] = 0, e[S + 4 >> 2] = 0, (S | 0) != (ke | 0); )
                                                                ;
                                                              if (e[G + 100 >> 2] = Ar, S = e[G + 96 >> 2], e[G + 96 >> 2] = hr, ke = e[G + 92 >> 2], e[G + 92 >> 2] = g, (S | 0) == (ke | 0))
                                                                break I;
                                                              for (; ; ) {
                                                                S = S - 8 | 0, g = e[S + 4 >> 2];
                                                                k: {
                                                                  if (!g || (Ar = e[g + 4 >> 2], e[g + 4 >> 2] = Ar - 1, Ar))
                                                                    break k;
                                                                  _n[e[e[g >> 2] + 8 >> 2]](g), cs(g);
                                                                }
                                                                if ((S | 0) == (ke | 0))
                                                                  break;
                                                              }
                                                            }
                                                            if (!ke)
                                                              break p;
                                                            Sr(ke);
                                                          }
                                                          if (Fe = Fe + 4 | 0, (ln | 0) != (Fe | 0))
                                                            continue;
                                                          break g;
                                                        }
                                                        break;
                                                      }
                                                      S = Vr() | 0;
                                                      break o;
                                                    }
                                                    Fe = e[G + 28 >> 2], S = e[G + 24 >> 2];
                                                  }
                                                  if (e[5996] = 0, rf(63, G + 72 | 0, c | 0, S | 0, Fe | 0, 0), g = e[5996], e[5996] = 0, (g | 0) == 1 || (e[5996] = 0, Fe = ii(3, 104) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1))
                                                    break c;
                                                  e[Fe >> 2] = 7e3, e[Fe + 4 >> 2] = 0, e[Fe + 8 >> 2] = 0, e[G + 112 >> 2] = 0, e[G + 104 >> 2] = 0, e[G + 108 >> 2] = 0, e[G + 116 >> 2] = e[G + 92 >> 2], g = e[G + 100 >> 2], S = e[G + 96 >> 2], e[G + 100 >> 2] = 0, e[G + 120 >> 2] = S, e[G + 124 >> 2] = g, e[G + 92 >> 2] = 0, e[G + 96 >> 2] = 0, $[G + 132 | 0] = 0, e[G + 128 >> 2] = G + 104, Ar = e[y + 4 >> 2], S = e[y >> 2], ke = Ar - S | 0, g = (ke | 0) / 12 | 0;
                                                  g: {
                                                    if ((S | 0) != (Ar | 0)) {
                                                      if (g >>> 0 >= 357913942) {
                                                        if (e[5996] = 0, Ri(41), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                          break e;
                                                        S = Vr() | 0;
                                                        break f;
                                                      }
                                                      if (e[5996] = 0, ke = ii(3, ke | 0) | 0, hr = e[5996], e[5996] = 0, (hr | 0) == 1)
                                                        break g;
                                                      for (e[G + 108 >> 2] = ke, e[G + 104 >> 2] = ke, e[G + 112 >> 2] = ke + vi(g, 12), e[G + 156 >> 2] = ke, e[G + 152 >> 2] = ke, $[G + 148 | 0] = 0, e[G + 136 >> 2] = gi, e[G + 144 >> 2] = G + 156, e[G + 140 >> 2] = G + 152, g = ke; ; ) {
                                                        A: {
                                                          if ($[S + 11 | 0] >= 0) {
                                                            hr = e[S + 4 >> 2], e[g >> 2] = e[S >> 2], e[g + 4 >> 2] = hr, e[g + 8 >> 2] = e[S + 8 >> 2];
                                                            break A;
                                                          }
                                                          if (hr = e[S + 4 >> 2], ln = e[S >> 2], e[5996] = 0, as(40, g | 0, ln | 0, hr | 0), g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                            break d;
                                                          g = e[G + 156 >> 2];
                                                        }
                                                        if (g = g + 12 | 0, e[G + 156 >> 2] = g, S = S + 12 | 0, (Ar | 0) == (S | 0))
                                                          break;
                                                      }
                                                      e[G + 108 >> 2] = g;
                                                    }
                                                    if (e[5996] = 0, Ar = Cl(60, Fe + 12 | 0, c | 0, G + 116 | 0, G + 104 | 0, 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                      break u;
                                                    if (ke = e[G + 104 >> 2], ke) {
                                                      if (g = e[G + 108 >> 2], S = ke, (g | 0) != (S | 0)) {
                                                        for (; S = g - 12 | 0, $[g - 1 | 0] < 0 && Sr(e[S >> 2]), g = S, (ke | 0) != (g | 0); )
                                                          ;
                                                        S = e[G + 104 >> 2];
                                                      }
                                                      e[G + 108 >> 2] = ke, Sr(S);
                                                    }
                                                    if (g = e[G + 116 >> 2], g) {
                                                      if (S = e[G + 120 >> 2], (g | 0) != (S | 0)) {
                                                        for (; ; ) {
                                                          S = S - 8 | 0, ke = e[S + 4 >> 2];
                                                          A: {
                                                            if (!ke || (hr = e[ke + 4 >> 2], e[ke + 4 >> 2] = hr - 1, hr))
                                                              break A;
                                                            _n[e[e[ke >> 2] + 8 >> 2]](ke), cs(ke);
                                                          }
                                                          if ((g | 0) == (S | 0))
                                                            break;
                                                        }
                                                        g = e[G + 116 >> 2];
                                                      }
                                                      Sr(g);
                                                    }
                                                    if (e[G + 140 >> 2] = Fe, e[G + 136 >> 2] = Ar, e[5996] = 0, g = e[G + 140 >> 2], e[G >> 2] = e[G + 136 >> 2], e[G + 4 >> 2] = g, as(61, r | 0, G + 72 | 0, G | 0), g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                      break c;
                                                    if (g = e[G + 92 >> 2], g) {
                                                      if (S = e[G + 96 >> 2], (g | 0) != (S | 0)) {
                                                        for (; ; ) {
                                                          S = S - 8 | 0, ke = e[S + 4 >> 2];
                                                          A: {
                                                            if (!ke || (Fe = e[ke + 4 >> 2], e[ke + 4 >> 2] = Fe - 1, Fe))
                                                              break A;
                                                            _n[e[e[ke >> 2] + 8 >> 2]](ke), cs(ke);
                                                          }
                                                          if ((g | 0) == (S | 0))
                                                            break;
                                                        }
                                                        g = e[G + 92 >> 2];
                                                      }
                                                      Sr(g);
                                                    }
                                                    if (Tr = Tr + 1 | 0, (Rn | 0) != (Tr | 0))
                                                      continue;
                                                    break a;
                                                  }
                                                  break;
                                                }
                                                S = Vr() | 0;
                                                break f;
                                              }
                                              S = Vr() | 0, Wo(G + 104 | 0);
                                              break l;
                                            }
                                            S = Vr() | 0;
                                            break o;
                                          }
                                          S = Vr() | 0, Pa(G + 136 | 0), e[G + 108 >> 2] = ke;
                                        }
                                        Gh(G + 128 | 0);
                                      }
                                      xo(G + 116 | 0), Sr(Fe);
                                    }
                                    xo(G + 92 | 0);
                                    break i;
                                  }
                                  if (ke = e[G + 12 >> 2], ke) {
                                    if (S = e[G + 16 >> 2], (ke | 0) != (S | 0)) {
                                      for (; ; ) {
                                        if (Tr = S - 12 | 0, Fe = e[Tr >> 2], Fe) {
                                          if (g = Fe, Ar = S - 8 | 0, S = e[Ar >> 2], (g | 0) != (S | 0)) {
                                            for (; ; ) {
                                              S = S - 32 | 0, g = e[S + 4 >> 2];
                                              a: {
                                                if (!g || (Rn = e[g + 4 >> 2], e[g + 4 >> 2] = Rn - 1, Rn))
                                                  break a;
                                                _n[e[e[g >> 2] + 8 >> 2]](g), cs(g);
                                              }
                                              if ((S | 0) == (Fe | 0))
                                                break;
                                            }
                                            g = e[Tr >> 2];
                                          }
                                          e[Ar >> 2] = Fe, Sr(g);
                                        }
                                        if (S = Tr, (ke | 0) == (S | 0))
                                          break;
                                      }
                                      ke = e[G + 12 >> 2];
                                    }
                                    Sr(ke);
                                  }
                                  if (ci = ci + 1 | 0, S = e[G + 36 >> 2], ci >>> 0 < (e[G + 40 >> 2] - S | 0) / 12 >>> 0)
                                    continue;
                                  break t;
                                }
                                break;
                              }
                              if (e[5996] = 0, Qs(44, 5170, 1900, 642, 2497), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                break e;
                              S = Vr() | 0;
                            }
                            mf(G + 12 | 0);
                            break n;
                          }
                          S = Vr() | 0;
                        }
                        r = e[G + 24 >> 2], r && Sr(r), Qc(G + 36 | 0);
                        break r;
                      }
                      S = Vr() | 0;
                    }
                    ca(G + 48 | 0), Ki(S | 0), ri();
                  }
                  if (r = e[G + 24 >> 2], r && (Sr(r), S = e[G + 36 >> 2]), S) {
                    if (g = S, ke = e[G + 40 >> 2], (g | 0) != (ke | 0)) {
                      for (; r = ke - 12 | 0, o = e[r >> 2], o && (e[ke - 8 >> 2] = o, Sr(o)), ke = r, (ke | 0) != (S | 0); )
                        ;
                      g = e[G + 36 >> 2];
                    }
                    e[G + 40 >> 2] = S, Sr(g);
                  }
                  r = e[G + 60 >> 2], r && (e[G - -64 >> 2] = r, Sr(r)), r = e[G + 48 >> 2], r && (e[G + 52 >> 2] = r, Sr(r)), Yr = G + 160 | 0;
                  return;
                }
                ri();
              }
              function Dl(r, o, c, h, y, g, S, G, ke) {
                var Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0, Qi = 0, Ji = 0, ss = 0, As = 0, Rs = 0, oo = 0, Go = 0, Jo = 0, ta = 0, sa = 0, Ea = 0, Wa = 0, qu = 0, Vu = 0, fc = 0, Ec = 0, Yc = 0, Xc = 0, _c = 0, qf = 0, Of = 0, Qf = 0;
                Ar = Yr - 336 | 0, Yr = Ar, Tr = G, ln = ke & 65535, Rn = h, Mn = y & 65535, Qi = (y ^ ke) & -2147483648, ci = ke >>> 16 & 32767, gi = y >>> 16 & 32767;
                e: {
                  t: {
                    if (ci - 32767 >>> 0 > 4294934529 & gi - 32767 >>> 0 >= 4294934530)
                      break t;
                    if (Fe = y & 2147483647, !(!h & (Fe | 0) == 2147418112 ? !(o | c) : Fe >>> 0 < 2147418112)) {
                      ei = h, Qi = y | 32768;
                      break e;
                    }
                    if (y = ke & 2147483647, !(!G & (y | 0) == 2147418112 ? !(g | S) : y >>> 0 < 2147418112)) {
                      ei = G, Qi = ke | 32768, o = g, c = S;
                      break e;
                    }
                    if (!(o | h | (Fe ^ 2147418112 | c))) {
                      if (!(g | G | (y ^ 2147418112 | S))) {
                        o = 0, c = 0, Qi = 2147450880;
                        break e;
                      }
                      Qi = Qi | 2147418112, o = 0, c = 0;
                      break e;
                    }
                    if (!(g | G | (y ^ 2147418112 | S))) {
                      o = 0, c = 0;
                      break e;
                    }
                    if (!(o | h | (c | Fe))) {
                      o = !(g | G | (y | S)), ei = o ? 0 : ei, Qi = o ? 2147450880 : Qi, o = 0, c = 0;
                      break e;
                    }
                    if (!(g | G | (y | S))) {
                      Qi = Qi | 2147418112, o = 0, c = 0;
                      break e;
                    }
                    if ((Fe | 0) == 65535 | Fe >>> 0 < 65535 && (h = !(Rn | Mn), ke = h, Fe = h ? o : Rn, h = h << 6, ke = Do(ke ? c : Mn), h = h + ((ke | 0) == 32 ? Do(Fe) + 32 | 0 : ke) | 0, ha(Ar + 320 | 0, o, c, Rn, Mn, h - 15 | 0), Ji = 16 - h | 0, Rn = e[Ar + 328 >> 2], Mn = e[Ar + 332 >> 2], c = e[Ar + 324 >> 2], o = e[Ar + 320 >> 2]), y >>> 0 > 65535)
                      break t;
                    h = !(ln | Tr), G = h, ke = h ? g : Tr, h = h << 6, G = Do(G ? S : ln), h = h + ((G | 0) == 32 ? Do(ke) + 32 | 0 : G) | 0, ha(Ar + 304 | 0, g, S, Tr, ln, h - 15 | 0), Ji = (h + Ji | 0) - 16 | 0, Tr = e[Ar + 312 >> 2], ln = e[Ar + 316 >> 2], g = e[Ar + 304 >> 2], S = e[Ar + 308 >> 2];
                  }
                  y = ln | 65536, Go = y, Jo = Tr, h = Tr, Fe = y << 15 | h >>> 17, y = h << 15 | S >>> 17, h = y, ke = 0 - h | 0, G = Fe, Fe = 1963258675 - (Fe + ((h | 0) != 0) | 0) | 0, oa(Ar + 288 | 0, h, G, 0, 0, ke, Fe, 0, 0), h = e[Ar + 296 >> 2], oa(Ar + 272 | 0, 0 - h | 0, 0 - (e[Ar + 300 >> 2] + ((h | 0) != 0) | 0) | 0, 0, 0, ke, Fe, 0, 0), h = e[Ar + 280 >> 2], ke = h << 1 | e[Ar + 276 >> 2] >>> 31, h = e[Ar + 284 >> 2] << 1 | h >>> 31, oa(Ar + 256 | 0, ke, h, 0, 0, y, G, 0, 0), Fe = e[Ar + 264 >> 2], oa(Ar + 240 | 0, ke, h, 0, 0, 0 - Fe | 0, 0 - (e[Ar + 268 >> 2] + ((Fe | 0) != 0) | 0) | 0, 0, 0), ke = e[Ar + 248 >> 2], Fe = ke << 1 | e[Ar + 244 >> 2] >>> 31, h = e[Ar + 252 >> 2] << 1 | ke >>> 31, oa(Ar + 224 | 0, Fe, h, 0, 0, y, G, 0, 0), ke = e[Ar + 232 >> 2], oa(Ar + 208 | 0, Fe, h, 0, 0, 0 - ke | 0, 0 - (e[Ar + 236 >> 2] + ((ke | 0) != 0) | 0) | 0, 0, 0), h = e[Ar + 216 >> 2], ke = h << 1 | e[Ar + 212 >> 2] >>> 31, h = e[Ar + 220 >> 2] << 1 | h >>> 31, oa(Ar + 192 | 0, ke, h, 0, 0, y, G, 0, 0), Fe = e[Ar + 200 >> 2], oa(Ar + 176 | 0, ke, h, 0, 0, 0 - Fe | 0, 0 - (e[Ar + 204 >> 2] + ((Fe | 0) != 0) | 0) | 0, 0, 0), ke = y, y = e[Ar + 184 >> 2], h = G, Tr = y << 1 | e[Ar + 180 >> 2] >>> 31, G = Tr - 1 | 0, y = (e[Ar + 188 >> 2] << 1 | y >>> 31) - !Tr | 0, oa(Ar + 160 | 0, ke, h, 0, 0, G, y, 0, 0), h = G, oa(Ar + 144 | 0, g << 15, S << 15 | g >>> 17, 0, 0, h, y, 0, 0), As = Ar + 112 | 0, Rs = e[Ar + 168 >> 2], G = e[Ar + 172 >> 2], Tr = e[Ar + 160 >> 2], ke = e[Ar + 152 >> 2], hr = Tr + ke | 0, ln = e[Ar + 164 >> 2], Fe = ln + e[Ar + 156 >> 2] | 0, Fe = ke >>> 0 > hr >>> 0 ? Fe + 1 | 0 : Fe, ke = Fe, Fe = (ln | 0) == (Fe | 0) & hr >>> 0 < Tr >>> 0 | Fe >>> 0 < ln >>> 0, ln = Fe + Rs | 0, Fe = Fe >>> 0 > ln >>> 0 ? G + 1 | 0 : G, Tr = !ke & hr >>> 0 > 1 | (ke | 0) != 0, G = ln + Tr | 0, Fe = Tr >>> 0 > G >>> 0 ? Fe + 1 | 0 : Fe, oa(As, h, y, 0, 0, 0 - G | 0, 0 - (((G | 0) != 0) + Fe | 0) | 0, 0, 0), oa(Ar + 128 | 0, 1 - hr | 0, 0 - ((hr >>> 0 > 1) + ke | 0) | 0, 0, 0, h, y, 0, 0), Ec = (gi - ci | 0) + Ji | 0, y = e[Ar + 116 >> 2], As = y, h = e[Ar + 112 >> 2], Fe = y << 1 | h >>> 31, ke = h << 1, ln = Fe, h = Fe, G = e[Ar + 140 >> 2], oo = G, y = e[Ar + 136 >> 2], Fe = G << 1 | y >>> 31, hr = y << 1 | e[Ar + 132 >> 2] >>> 31, G = hr + ke | 0, h = h + Fe | 0, h = G >>> 0 < hr >>> 0 ? h + 1 | 0 : h, y = h, h = h - (G >>> 0 < 13927) | 0, ss = h, Rs = h, hr = 0, Fe = Mn | 65536, Yc = Fe, Xc = Rn, h = Rn, Fe = Fe << 1 | h >>> 31, qf = h << 1, Of = Fe, Wa = Fe, h = so(ss, hr, Fe, 0), Fe = vs, ta = h, sa = Fe, Ji = o << 1, h = c << 1 | o >>> 31, ci = h, Fe = 0, gi = Fe, Tr = G - 13927 | 0, ss = (y | 0) == (ss | 0) & Tr >>> 0 < G >>> 0 | y >>> 0 > ss >>> 0, y = (y | 0) == (ln | 0) & G >>> 0 < ke >>> 0 | y >>> 0 < ln >>> 0, h = e[Ar + 120 >> 2], G = e[Ar + 124 >> 2] << 1 | h >>> 31, h = h << 1 | As >>> 31, hr = oo >>> 31 | 0, h = hr + h | 0, Fe = G, Fe = h >>> 0 < hr >>> 0 ? Fe + 1 | 0 : Fe, G = h, h = h + y | 0, Fe = G >>> 0 > h >>> 0 ? Fe + 1 | 0 : Fe, y = h, h = h + ss | 0, hr = y >>> 0 > h >>> 0 ? Fe + 1 | 0 : Fe, y = h - 1 | 0, Ea = hr - !h | 0, oo = 0, ke = so(ci, gi, Ea, oo), h = ke + ta | 0, G = vs + sa | 0, G = h >>> 0 < ke >>> 0 ? G + 1 | 0 : G, ln = (sa | 0) == (G | 0) & h >>> 0 < ta >>> 0 | G >>> 0 < sa >>> 0, ta = y, _c = c >>> 31 | 0, Vu = _c | Rn << 1, ss = 0, y = so(y, 0, Vu, ss), Rn = y + h | 0, Fe = vs + G | 0, hr = 0, Fe = y >>> 0 > Rn >>> 0 ? Fe + 1 | 0 : Fe, Mn = Fe, h = (Fe | 0) == (G | 0) & h >>> 0 > Rn >>> 0 | G >>> 0 > Fe >>> 0, y = h, h = h + ln | 0, hr = y >>> 0 > h >>> 0 ? 1 : hr, y = so(Wa, gi, Ea, oo), h = y + h | 0, Fe = vs + hr | 0, ln = h, h = h >>> 0 < y >>> 0 ? Fe + 1 | 0 : Fe, y = so(Wa, gi, ta, ss), hr = vs, G = y, y = so(Vu, ss, Ea, oo), ke = G + y | 0, Fe = vs + hr | 0, Fe = y >>> 0 > ke >>> 0 ? Fe + 1 | 0 : Fe, y = Fe, Fe = (hr | 0) == (Fe | 0) & G >>> 0 > ke >>> 0 | Fe >>> 0 < hr >>> 0, hr = ln + y | 0, h = h + Fe | 0, h = hr >>> 0 < y >>> 0 ? h + 1 | 0 : h, ln = hr, hr = h, y = 0, h = y + Rn | 0, Fe = ke + Mn | 0, Fe = h >>> 0 < y >>> 0 ? Fe + 1 | 0 : Fe, y = Fe, G = (Fe | 0) == (Mn | 0) & h >>> 0 < Rn >>> 0 | Fe >>> 0 < Mn >>> 0, Fe = hr, ke = G, G = G + ln | 0, Fe = ke >>> 0 > G >>> 0 ? Fe + 1 | 0 : Fe, qu = G, hr = Fe, As = h, Rn = h, sa = Tr, h = so(Tr, 0, Vu, ss), ke = vs, G = h, Tr = so(Rs, ei, ci, ei), h = h + Tr | 0, Fe = vs + ke | 0, Fe = h >>> 0 < Tr >>> 0 ? Fe + 1 | 0 : Fe, Tr = (ke | 0) == (Fe | 0) & h >>> 0 < G >>> 0 | ke >>> 0 > Fe >>> 0, G = Fe, fc = Ji & -2, ke = so(ta, ss, fc, 0), Mn = ke + h | 0, Fe = vs + Fe | 0, Fe = ke >>> 0 > Mn >>> 0 ? Fe + 1 | 0 : Fe, ke = Fe, h = (Fe | 0) == (G | 0) & h >>> 0 > Mn >>> 0 | G >>> 0 > Fe >>> 0, G = 0, Fe = h + Tr | 0, h = (Fe >>> 0 < h >>> 0 ? 1 : G) + y | 0, ln = Fe + Rn | 0, h = ln >>> 0 < Fe >>> 0 ? h + 1 | 0 : h, Fe = hr, Rn = h, h = (h | 0) == (y | 0) & ln >>> 0 < As >>> 0 | h >>> 0 < y >>> 0, y = h, h = h + qu | 0, Fe = y >>> 0 > h >>> 0 ? Fe + 1 | 0 : Fe, Qf = h, As = Fe, h = so(Wa, gi, sa, ei), qu = vs, Wa = h, y = so(Ea, oo, fc, ei), h = h + y | 0, Fe = vs + qu | 0, Fe = h >>> 0 < y >>> 0 ? Fe + 1 | 0 : Fe, Tr = h, hr = so(Rs, ei, Vu, ss), y = h + hr | 0, G = Fe, h = Fe + vs | 0, h = y >>> 0 < hr >>> 0 ? h + 1 | 0 : h, gi = y, Fe = so(ci, ei, ta, ss), y = y + Fe | 0, hr = vs + h | 0, hr = y >>> 0 < Fe >>> 0 ? hr + 1 | 0 : hr, Ea = (h | 0) == (hr | 0) & y >>> 0 < gi >>> 0 | h >>> 0 > hr >>> 0, Fe = (G | 0) == (qu | 0) & Tr >>> 0 < Wa >>> 0 | G >>> 0 < qu >>> 0, h = (h | 0) == (G | 0) & Tr >>> 0 > gi >>> 0 | h >>> 0 < G >>> 0, h = h + Fe | 0, h = h + Ea | 0, G = hr, gi = G + ln | 0, Fe = (h | oo) + Rn | 0, Fe = G >>> 0 > gi >>> 0 ? Fe + 1 | 0 : Fe, Tr = Fe, h = (Rn | 0) == (Fe | 0) & ln >>> 0 > gi >>> 0 | Fe >>> 0 < Rn >>> 0, Fe = As, G = h, h = h + Qf | 0, Fe = G >>> 0 > h >>> 0 ? Fe + 1 | 0 : Fe, oo = h, Rn = Fe, h = so(Rs, ei, fc, ei), Rs = vs, ln = h, G = so(ci, ei, sa, ei), h = h + G | 0, Fe = vs + Rs | 0, Fe = h >>> 0 < G >>> 0 ? Fe + 1 | 0 : Fe, As = 0, G = (Fe | 0) == (Rs | 0) & h >>> 0 < ln >>> 0 | Fe >>> 0 < Rs >>> 0, ln = Fe, h = Fe + Mn | 0, Fe = (G | As) + ke | 0, Fe = h >>> 0 < ln >>> 0 ? Fe + 1 | 0 : Fe, ke = (ke | 0) == (Fe | 0) & h >>> 0 < Mn >>> 0 | ke >>> 0 > Fe >>> 0, G = Fe, Fe = y, Mn = 0, y = Mn + h | 0, hr = G + Fe | 0, Fe = 0, hr = y >>> 0 < Mn >>> 0 ? hr + 1 | 0 : hr, h = (G | 0) == (hr | 0) & h >>> 0 > y >>> 0 | G >>> 0 > hr >>> 0, y = h, h = h + ke | 0, Fe = (y >>> 0 > h >>> 0 ? 1 : Fe) + Tr | 0, hr = Rn, y = h, h = h + gi | 0, Fe = y >>> 0 > h >>> 0 ? Fe + 1 | 0 : Fe, y = Fe, G = (Tr | 0) == (Fe | 0) & h >>> 0 < gi >>> 0 | Fe >>> 0 < Tr >>> 0, ke = G, G = G + oo | 0, hr = ke >>> 0 > G >>> 0 ? hr + 1 | 0 : hr, ke = hr;
                  t: {
                    if ((hr | 0) == 131071 | hr >>> 0 < 131071) {
                      Xc = qf | _c, Yc = ss | Of, oa(Ar + 80 | 0, h, Fe, G, hr, g, S, Jo, Go), hr = e[Ar + 84 >> 2], ln = hr, Fe = o << 17, Tr = 0, Mn = e[Ar + 88 >> 2], c = Tr - Mn | 0, o = e[Ar + 80 >> 2], hr = (hr | o) != 0, Rn = c - hr | 0, Mn = (Fe - (e[Ar + 92 >> 2] + (Tr >>> 0 < Mn >>> 0) | 0) | 0) - (c >>> 0 < hr >>> 0) | 0, Tr = 0 - o | 0, ln = 0 - (((o | 0) != 0) + ln | 0) | 0, o = Ec + 16382 | 0;
                      break t;
                    }
                    h = (y & 1) << 31 | h >>> 1, y = G << 31 | y >>> 1, G = (ke & 1) << 31 | G >>> 1, ke = ke >>> 1 | 0, oa(Ar + 96 | 0, h, y, G, ke, g, S, Jo, Go), Rn = e[Ar + 100 >> 2], ci = Rn, ln = 0, Ji = e[Ar + 104 >> 2], Tr = ln - Ji | 0, hr = e[Ar + 96 >> 2], Mn = (Rn | hr) != 0, Rn = Tr - Mn | 0, Mn = ((o << 16) - (e[Ar + 108 >> 2] + (ln >>> 0 < Ji >>> 0) | 0) | 0) - (Tr >>> 0 < Mn >>> 0) | 0, Tr = 0 - hr | 0, ln = 0 - (((hr | 0) != 0) + ci | 0) | 0, Ji = o, ci = c, o = Ec + 16383 | 0;
                  }
                  if ((o | 0) >= 32767) {
                    Qi = Qi | 2147418112, o = 0, c = 0;
                    break e;
                  }
                  t: {
                    if ((o | 0) > 0) {
                      hr = Mn << 1 | Rn >>> 31, Rn = Rn << 1 | ln >>> 31, Mn = hr, Ji = G, ci = ke & 65535 | o << 16, hr = ln << 1 | Tr >>> 31, ke = Tr << 1;
                      break t;
                    }
                    if ((o | 0) <= -113) {
                      o = 0, c = 0;
                      break e;
                    }
                    Ac(Ar - -64 | 0, h, y, G, ke, 1 - o | 0), ha(Ar + 48 | 0, Ji, ci, Xc, Yc, o + 112 | 0), h = e[Ar + 64 >> 2], y = e[Ar + 68 >> 2], Ji = e[Ar + 72 >> 2], ci = e[Ar + 76 >> 2], oa(Ar + 32 | 0, g, S, Jo, Go, h, y, Ji, ci), o = e[Ar + 40 >> 2], c = e[Ar + 56 >> 2], hr = e[Ar + 36 >> 2], Rn = o << 1 | hr >>> 31, Tr = c - Rn | 0, Mn = e[Ar + 60 >> 2] - ((e[Ar + 44 >> 2] << 1 | o >>> 31) + (c >>> 0 < Rn >>> 0) | 0) | 0, o = e[Ar + 32 >> 2], G = hr << 1 | o >>> 31, Fe = o << 1, ke = e[Ar + 52 >> 2], c = e[Ar + 48 >> 2], o = (G | 0) == (ke | 0) & Fe >>> 0 > c >>> 0 | G >>> 0 > ke >>> 0, Rn = Tr - o | 0, Mn = Mn - (o >>> 0 > Tr >>> 0) | 0, hr = ke - ((c >>> 0 < Fe >>> 0) + G | 0) | 0, ke = c - Fe | 0;
                  }
                  o = ke, oa(Ar + 16 | 0, g, S, Jo, Go, 3, 0, 0, 0), oa(Ar, g, S, Jo, Go, 5, 0, 0, 0), c = 0, G = hr + c | 0, Fe = h & 1, o = o + Fe | 0, G = ke >>> 0 > o >>> 0 ? G + 1 | 0 : G, ke = o, S = (G | 0) == (S | 0) & g >>> 0 < ke >>> 0 | S >>> 0 < G >>> 0, hr = Mn, o = (c | 0) == (G | 0) & ke >>> 0 < Fe >>> 0 | c >>> 0 > G >>> 0, g = o + Rn | 0, hr = o >>> 0 > g >>> 0 ? hr + 1 | 0 : hr, Fe = y, o = (hr | 0) == (Go | 0), o = o & (g | 0) == (Jo | 0) ? S : o & g >>> 0 > Jo >>> 0 | hr >>> 0 > Go >>> 0, c = o, o = o + h | 0, Fe = c >>> 0 > o >>> 0 ? Fe + 1 | 0 : Fe, c = Fe, h = (y | 0) == (Fe | 0) & o >>> 0 < h >>> 0 | y >>> 0 > Fe >>> 0, Fe = ci, y = h, h = h + Ji | 0, Fe = y >>> 0 > h >>> 0 ? Fe + 1 | 0 : Fe, S = h, y = e[Ar + 20 >> 2], ln = (y | 0) == (G | 0) & Ps[Ar + 16 >> 2] < ke >>> 0 | y >>> 0 < G >>> 0, y = e[Ar + 28 >> 2], h = e[Ar + 24 >> 2], y = Fe >>> 0 < 2147418112 & ((h | 0) == (g | 0) & (y | 0) == (hr | 0) ? ln : (y | 0) == (hr | 0) & h >>> 0 < g >>> 0 | y >>> 0 < hr >>> 0), h = c, ln = y, y = o + y | 0, h = ln >>> 0 > y >>> 0 ? h + 1 | 0 : h, o = (c | 0) == (h | 0) & o >>> 0 > y >>> 0 | c >>> 0 > h >>> 0, c = o, o = o + S | 0, Fe = c >>> 0 > o >>> 0 ? Fe + 1 | 0 : Fe, S = o, c = e[Ar + 4 >> 2], G = (c | 0) == (G | 0) & Ps[Ar >> 2] < ke >>> 0 | c >>> 0 < G >>> 0, c = e[Ar + 12 >> 2], o = e[Ar + 8 >> 2], o = Fe >>> 0 < 2147418112 & ((o | 0) == (g | 0) & (c | 0) == (hr | 0) ? G : (c | 0) == (hr | 0) & o >>> 0 < g >>> 0 | c >>> 0 < hr >>> 0), c = o, o = o + y | 0, hr = c >>> 0 > o >>> 0 ? h + 1 | 0 : h, c = hr, y = (h | 0) == (hr | 0) & o >>> 0 < y >>> 0 | h >>> 0 > hr >>> 0, h = Fe, g = y, y = y + S | 0, h = g >>> 0 > y >>> 0 ? h + 1 | 0 : h, ei = y | ei, Qi = h | Qi;
                }
                e[r >> 2] = o, e[r + 4 >> 2] = c, e[r + 8 >> 2] = ei, e[r + 12 >> 2] = Qi, Yr = Ar + 336 | 0;
              }
              function Iu(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = +y, g = g | 0;
                var S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0, Qi = 0;
                G = Yr - 128 | 0, Yr = G, vc(G + 56 | 0, c, Fi[r + 16 >> 3], Fi[r + 24 >> 3], y, g), e[5996] = 0, g = ii(46, c | 0) | 0, S = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((S | 0) != 1) {
                        if (e[G + 52 >> 2] = 0, e[G + 44 >> 2] = 0, e[G + 48 >> 2] = 0, $[G + 84 | 0] = 0, e[G + 80 >> 2] = G + 44, S = e[g + 4 >> 2], Fe = e[g >> 2], hr = S - Fe | 0, ke = (hr | 0) / 12 | 0, (S | 0) != (Fe | 0)) {
                          n: {
                            i: {
                              s: {
                                if (ke >>> 0 >= 357913942) {
                                  if (e[5996] = 0, Ri(47), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                    break s;
                                  break e;
                                }
                                if (e[5996] = 0, S = ii(3, hr | 0) | 0, Fe = e[5996], e[5996] = 0, (Fe | 0) == 1)
                                  break s;
                                if (e[G + 48 >> 2] = S, e[G + 44 >> 2] = S, e[G + 52 >> 2] = S + vi(ke, 12), ke = e[g + 4 >> 2], g = e[g >> 2], e[5996] = 0, g = da(48, G + 52 | 0, g | 0, ke | 0, S | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) != 1)
                                  break n;
                                g = Vr() | 0, e[G + 48 >> 2] = S;
                                break i;
                              }
                              g = Vr() | 0;
                            }
                            i2(G + 80 | 0);
                            break r;
                          }
                          e[G + 48 >> 2] = g;
                        }
                        e[G + 40 >> 2] = 0, e[G + 32 >> 2] = 0, e[G + 36 >> 2] = 0, g = e[h + 4 >> 2], S = e[h >> 2], e[5996] = 0, di(49, G + 32 | 0, g - S >> 2), g = e[5996], e[5996] = 0;
                        n: {
                          if ((g | 0) != 1) {
                            if (g = e[G + 48 >> 2], S = e[G + 44 >> 2], (g | 0) == (S | 0))
                              break t;
                            g = S;
                            i: {
                              for (; ; ) {
                                s: {
                                  if (e[G + 28 >> 2] = 0, e[G + 20 >> 2] = 0, e[G + 24 >> 2] = 0, ke = e[h + 4 >> 2], S = e[h >> 2], Rn = vi(ci, 12), g = Rn + g | 0, ke - S >> 2 != e[g + 4 >> 2] - e[g >> 2] >> 3)
                                    break s;
                                  Fe = 0, ln = 1, Tr = 0;
                                  a: {
                                    if ((S | 0) != (ke | 0)) {
                                      o: {
                                        l: {
                                          f: {
                                            for (; ; ) {
                                              if (g = Tr << 3, gi = Fi[g + e[G + 68 >> 2] >> 3], Qi = Fi[g + e[G + 56 >> 2] >> 3], S = e[(Tr << 2) + S >> 2], e[5996] = 0, S = lc(50, S | 0, +Qi, +gi, o | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                                break l;
                                              if (g = g + e[Rn + e[G + 44 >> 2] >> 2] | 0, ke = e[g >> 2], g = e[g + 4 >> 2], hr = e[S + 4 >> 2], S = e[S >> 2], e[5996] = 0, eu(51, G + 80 | 0, S | 0, hr | 0, ke | 0, g | 0), g = e[5996], e[5996] = 0, (g | 0) != 1) {
                                                ke = e[G + 28 >> 2];
                                                d: {
                                                  if (ke >>> 0 > Fe >>> 0) {
                                                    e[Fe + 8 >> 2] = 0, e[Fe >> 2] = 0, e[Fe + 4 >> 2] = 0, e[Fe >> 2] = e[G + 80 >> 2], e[Fe + 4 >> 2] = e[G + 84 >> 2], e[Fe + 8 >> 2] = e[G + 88 >> 2], e[G + 24 >> 2] = Fe + 12;
                                                    break d;
                                                  }
                                                  c: {
                                                    S = e[G + 20 >> 2], hr = (Fe - S | 0) / 12 | 0, g = hr + 1 | 0;
                                                    u: {
                                                      if (g >>> 0 >= 357913942) {
                                                        e[5996] = 0, Ri(52);
                                                        break u;
                                                      }
                                                      if (ke = (ke - S | 0) / 12 | 0, Ar = ke << 1, g = ke >>> 0 >= 178956970 ? 357913941 : g >>> 0 < Ar >>> 0 ? Ar : g, g >>> 0 < 357913942)
                                                        break c;
                                                      e[5996] = 0, Ri(35);
                                                    }
                                                    if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                      break e;
                                                    break f;
                                                  }
                                                  if (e[5996] = 0, Ar = vi(g, 12), ke = ii(3, Ar | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                    break f;
                                                  g = ke + vi(hr, 12) | 0, e[g >> 2] = e[G + 80 >> 2], e[g + 4 >> 2] = e[G + 84 >> 2], e[g + 8 >> 2] = e[G + 88 >> 2], e[G + 88 >> 2] = 0, e[G + 80 >> 2] = 0, e[G + 84 >> 2] = 0, ke = ke + Ar | 0, hr = g + 12 | 0;
                                                  c: {
                                                    if ((S | 0) == (Fe | 0)) {
                                                      e[G + 28 >> 2] = ke, e[G + 24 >> 2] = hr, e[G + 20 >> 2] = g;
                                                      break c;
                                                    }
                                                    for (; g = g - 12 | 0, Fe = Fe - 12 | 0, e[g >> 2] = e[Fe >> 2], e[g + 4 >> 2] = e[Fe + 4 >> 2], e[g + 8 >> 2] = e[Fe + 8 >> 2], e[Fe + 8 >> 2] = 0, e[Fe >> 2] = 0, e[Fe + 4 >> 2] = 0, (S | 0) != (Fe | 0); )
                                                      ;
                                                    if (e[G + 28 >> 2] = ke, S = e[G + 24 >> 2], e[G + 24 >> 2] = hr, Fe = e[G + 20 >> 2], e[G + 20 >> 2] = g, (S | 0) == (Fe | 0))
                                                      break c;
                                                    for (; ; ) {
                                                      if (Ar = S - 12 | 0, hr = e[Ar >> 2], hr) {
                                                        if (Mn = S - 8 | 0, g = e[Mn >> 2], ke = hr, (g | 0) != (ke | 0)) {
                                                          for (; ; ) {
                                                            g = g - 32 | 0, S = e[g + 4 >> 2];
                                                            u: {
                                                              if (!S || (ke = e[S + 4 >> 2], e[S + 4 >> 2] = ke - 1, ke))
                                                                break u;
                                                              _n[e[e[S >> 2] + 8 >> 2]](S), cs(S);
                                                            }
                                                            if ((g | 0) == (hr | 0))
                                                              break;
                                                          }
                                                          ke = e[Ar >> 2];
                                                        }
                                                        e[Mn >> 2] = hr, Sr(ke);
                                                      }
                                                      if (S = Ar, (Fe | 0) == (S | 0))
                                                        break;
                                                    }
                                                  }
                                                  if (Fe && Sr(Fe), ke = e[G + 80 >> 2], !ke)
                                                    break d;
                                                  if (g = e[G + 84 >> 2], S = ke, (g | 0) != (S | 0)) {
                                                    for (; ; ) {
                                                      g = g - 32 | 0, S = e[g + 4 >> 2];
                                                      c: {
                                                        if (!S || (Fe = e[S + 4 >> 2], e[S + 4 >> 2] = Fe - 1, Fe))
                                                          break c;
                                                        _n[e[e[S >> 2] + 8 >> 2]](S), cs(S);
                                                      }
                                                      if ((g | 0) == (ke | 0))
                                                        break;
                                                    }
                                                    S = e[G + 80 >> 2];
                                                  }
                                                  e[G + 84 >> 2] = ke, Sr(S);
                                                }
                                                if (Fe = e[G + 24 >> 2], g = Fe - 12 | 0, ln = vi(e[g + 4 >> 2] - e[g >> 2] >> 5, ln), Tr = Tr + 1 | 0, S = e[h >> 2], Tr >>> 0 >= e[h + 4 >> 2] - S >> 2 >>> 0)
                                                  break o;
                                                continue;
                                              }
                                              break;
                                            }
                                            g = Vr() | 0;
                                            break i;
                                          }
                                          g = Vr() | 0, lu(G + 80 | 0);
                                          break i;
                                        }
                                        g = Vr() | 0;
                                        break i;
                                      }
                                      if (!ln)
                                        break a;
                                    }
                                    hr = 0;
                                    o: {
                                      l: {
                                        for (; ; ) {
                                          if (Fe = e[G + 32 >> 2], e[h + 4 >> 2] != e[h >> 2])
                                            for (g = 0, ke = e[G + 20 >> 2], S = hr; Ar = vi(g, 12), Tr = Ar + ke | 0, ke = e[Tr >> 2], e[(g << 2) + Fe >> 2] = ke + ((S >>> 0) % (e[Tr + 4 >> 2] - ke >> 5 >>> 0) << 5), Tr = S, ke = e[G + 20 >> 2], S = Ar + ke | 0, S = (Tr >>> 0) / (e[S + 4 >> 2] - e[S >> 2] >> 5 >>> 0) | 0, g = g + 1 | 0, g >>> 0 < e[h + 4 >> 2] - e[h >> 2] >> 2 >>> 0; )
                                              ;
                                          if (e[G + 104 >> 2] = 0, e[G + 96 >> 2] = 0, e[G + 100 >> 2] = 0, g = Fe, Rn = e[G + 36 >> 2], (g | 0) != (Rn | 0)) {
                                            f: {
                                              for (; ; ) {
                                                d: {
                                                  Ar = e[Fe >> 2], g = e[G + 100 >> 2];
                                                  c: {
                                                    if ((g | 0) != e[G + 104 >> 2]) {
                                                      e[g >> 2] = e[Ar >> 2], S = e[Ar + 4 >> 2], e[g + 4 >> 2] = S, S && (e[S + 4 >> 2] = e[S + 4 >> 2] + 1), e[G + 100 >> 2] = g + 8;
                                                      break c;
                                                    }
                                                    u: {
                                                      ke = e[G + 96 >> 2], S = g - ke | 0, Mn = S >> 3, Tr = Mn + 1 | 0;
                                                      g: {
                                                        if (Tr >>> 0 >= 536870912) {
                                                          e[5996] = 0, Ri(59);
                                                          break g;
                                                        }
                                                        if (ei = S >> 2, S = S >>> 0 >= 2147483640 ? 536870911 : Tr >>> 0 < ei >>> 0 ? ei : Tr, S >>> 0 < 536870912)
                                                          break u;
                                                        e[5996] = 0, Ri(35);
                                                      }
                                                      if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                        break e;
                                                      g = Vr() | 0;
                                                      break o;
                                                    }
                                                    if (e[5996] = 0, ei = S << 3, Tr = ii(3, ei | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                      break d;
                                                    S = Tr + (Mn << 3) | 0, e[S >> 2] = e[Ar >> 2], Ar = e[Ar + 4 >> 2], e[S + 4 >> 2] = Ar, Ar && (e[Ar + 4 >> 2] = e[Ar + 4 >> 2] + 1, g = e[G + 100 >> 2]), Ar = Tr + ei | 0, Tr = S + 8 | 0;
                                                    u: {
                                                      if ((g | 0) == (ke | 0)) {
                                                        e[G + 104 >> 2] = Ar, e[G + 100 >> 2] = Tr, e[G + 96 >> 2] = S;
                                                        break u;
                                                      }
                                                      for (; S = S - 8 | 0, g = g - 8 | 0, e[S >> 2] = e[g >> 2], e[S + 4 >> 2] = e[g + 4 >> 2], e[g >> 2] = 0, e[g + 4 >> 2] = 0, (g | 0) != (ke | 0); )
                                                        ;
                                                      if (e[G + 104 >> 2] = Ar, g = e[G + 100 >> 2], e[G + 100 >> 2] = Tr, ke = e[G + 96 >> 2], e[G + 96 >> 2] = S, (g | 0) == (ke | 0))
                                                        break u;
                                                      for (; ; ) {
                                                        g = g - 8 | 0, S = e[g + 4 >> 2];
                                                        g: {
                                                          if (!S || (Ar = e[S + 4 >> 2], e[S + 4 >> 2] = Ar - 1, Ar))
                                                            break g;
                                                          _n[e[e[S >> 2] + 8 >> 2]](S), cs(S);
                                                        }
                                                        if ((g | 0) == (ke | 0))
                                                          break;
                                                      }
                                                    }
                                                    if (!ke)
                                                      break c;
                                                    Sr(ke);
                                                  }
                                                  if (Fe = Fe + 4 | 0, (Rn | 0) != (Fe | 0))
                                                    continue;
                                                  break f;
                                                }
                                                break;
                                              }
                                              g = Vr() | 0;
                                              break o;
                                            }
                                            Fe = e[G + 36 >> 2], g = e[G + 32 >> 2];
                                          }
                                          if (e[5996] = 0, rf(63, G + 80 | 0, c | 0, g | 0, Fe | 0, +y), g = e[5996], e[5996] = 0, (g | 0) == 1 || (e[5996] = 0, ke = ii(3, 104) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1))
                                            break l;
                                          if (e[ke >> 2] = 7e3, e[ke + 4 >> 2] = 0, e[ke + 8 >> 2] = 0, e[5996] = 0, e[G + 116 >> 2] = e[G + 96 >> 2], g = e[G + 104 >> 2], S = e[G + 100 >> 2], e[G + 104 >> 2] = 0, e[G + 120 >> 2] = S, e[G + 124 >> 2] = g, e[G + 96 >> 2] = 0, e[G + 100 >> 2] = 0, Ar = da(64, ke + 12 | 0, c | 0, G + 116 | 0, 0) | 0, g = e[5996], e[5996] = 0, (g | 0) != 1) {
                                            if (S = e[G + 116 >> 2], S) {
                                              if (g = e[G + 120 >> 2], (S | 0) != (g | 0)) {
                                                for (; ; ) {
                                                  g = g - 8 | 0, Fe = e[g + 4 >> 2];
                                                  f: {
                                                    if (!Fe || (Tr = e[Fe + 4 >> 2], e[Fe + 4 >> 2] = Tr - 1, Tr))
                                                      break f;
                                                    _n[e[e[Fe >> 2] + 8 >> 2]](Fe), cs(Fe);
                                                  }
                                                  if ((g | 0) == (S | 0))
                                                    break;
                                                }
                                                S = e[G + 116 >> 2];
                                              }
                                              Sr(S);
                                            }
                                            if (e[G + 112 >> 2] = ke, e[G + 108 >> 2] = Ar, e[5996] = 0, g = e[G + 112 >> 2], e[G + 8 >> 2] = e[G + 108 >> 2], e[G + 12 >> 2] = g, as(61, r | 0, G + 80 | 0, G + 8 | 0), g = e[5996], e[5996] = 0, (g | 0) == 1)
                                              break l;
                                            if (S = e[G + 96 >> 2], S) {
                                              if (g = e[G + 100 >> 2], (S | 0) != (g | 0)) {
                                                for (; ; ) {
                                                  g = g - 8 | 0, ke = e[g + 4 >> 2];
                                                  f: {
                                                    if (!ke || (Fe = e[ke + 4 >> 2], e[ke + 4 >> 2] = Fe - 1, Fe))
                                                      break f;
                                                    _n[e[e[ke >> 2] + 8 >> 2]](ke), cs(ke);
                                                  }
                                                  if ((g | 0) == (S | 0))
                                                    break;
                                                }
                                                S = e[G + 96 >> 2];
                                              }
                                              Sr(S);
                                            }
                                            if (hr = hr + 1 | 0, (ln | 0) != (hr | 0))
                                              continue;
                                            break a;
                                          }
                                          break;
                                        }
                                        g = Vr() | 0, xo(G + 116 | 0), Sr(ke);
                                        break o;
                                      }
                                      g = Vr() | 0;
                                    }
                                    xo(G + 96 | 0);
                                    break i;
                                  }
                                  if (ke = e[G + 20 >> 2], ke) {
                                    if (g = e[G + 24 >> 2], (ke | 0) != (g | 0)) {
                                      for (; ; ) {
                                        if (hr = g - 12 | 0, Fe = e[hr >> 2], Fe) {
                                          if (Ar = g - 8 | 0, g = e[Ar >> 2], S = Fe, (g | 0) != (S | 0)) {
                                            for (; ; ) {
                                              g = g - 32 | 0, S = e[g + 4 >> 2];
                                              a: {
                                                if (!S || (ln = e[S + 4 >> 2], e[S + 4 >> 2] = ln - 1, ln))
                                                  break a;
                                                _n[e[e[S >> 2] + 8 >> 2]](S), cs(S);
                                              }
                                              if ((g | 0) == (Fe | 0))
                                                break;
                                            }
                                            S = e[hr >> 2];
                                          }
                                          e[Ar >> 2] = Fe, Sr(S);
                                        }
                                        if (g = hr, (ke | 0) == (g | 0))
                                          break;
                                      }
                                      ke = e[G + 20 >> 2];
                                    }
                                    Sr(ke);
                                  }
                                  if (ci = ci + 1 | 0, g = e[G + 44 >> 2], ci >>> 0 < (e[G + 48 >> 2] - g | 0) / 12 >>> 0)
                                    continue;
                                  break t;
                                }
                                break;
                              }
                              if (e[5996] = 0, Qs(44, 5170, 1900, 642, 2497), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                break e;
                              g = Vr() | 0;
                            }
                            mf(G + 20 | 0);
                            break n;
                          }
                          g = Vr() | 0;
                        }
                        r = e[G + 32 >> 2], r && Sr(r), Qc(G + 44 | 0);
                        break r;
                      }
                      g = Vr() | 0;
                    }
                    ca(G + 56 | 0), Ki(g | 0), ri();
                  }
                  if (r = e[G + 32 >> 2], r && (Sr(r), g = e[G + 44 >> 2]), g) {
                    if (S = g, ke = e[G + 48 >> 2], (ke | 0) != (g | 0)) {
                      for (; r = ke - 12 | 0, o = e[r >> 2], o && (e[ke - 8 >> 2] = o, Sr(o)), ke = r, (ke | 0) != (g | 0); )
                        ;
                      S = e[G + 44 >> 2];
                    }
                    e[G + 48 >> 2] = g, Sr(S);
                  }
                  r = e[G + 68 >> 2], r && (e[G + 72 >> 2] = r, Sr(r)), r = e[G + 56 >> 2], r && (e[G + 60 >> 2] = r, Sr(r)), Yr = G + 128 | 0;
                  return;
                }
                ri();
              }
              function H1(r, o, c, h, y, g, S, G, ke, Fe, Ar) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, G = G | 0, ke = ke | 0, Fe = Fe | 0, Ar = Ar | 0;
                var hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0, Qi = 0, Ji = 0, ss = 0, As = 0, Rs = 0;
                hr = Yr - 528 | 0, Yr = hr, e[hr + 520 >> 2] = Ar, e[hr + 524 >> 2] = o;
                e: {
                  t: {
                    if (Pu(r, hr + 524 | 0)) {
                      e[g >> 2] = e[g >> 2] | 4, r = 0;
                      break t;
                    }
                    if (e[hr + 72 >> 2] = 220, Qi = hr + 104 | 0, e[Qi >> 2] = hr + 112, gi = hr + 72 | 0, e[Qi + 4 >> 2] = e[gi >> 2], Rn = e[Qi >> 2], e[hr + 100 >> 2] = Rn, e[hr + 96 >> 2] = Rn + 400, e[gi >> 2] = 0, e[gi + 4 >> 2] = 0, e[gi + 8 >> 2] = 0, Mn = hr + 60 | 0, e[Mn >> 2] = 0, e[Mn + 4 >> 2] = 0, e[Mn + 8 >> 2] = 0, Tr = hr + 48 | 0, e[Tr >> 2] = 0, e[Tr + 4 >> 2] = 0, e[Tr + 8 >> 2] = 0, ln = hr + 36 | 0, e[ln >> 2] = 0, e[ln + 4 >> 2] = 0, e[ln + 8 >> 2] = 0, ei = hr + 24 | 0, e[ei >> 2] = 0, e[ei + 4 >> 2] = 0, e[ei + 8 >> 2] = 0, o = e[h >> 2], e[5996] = 0, Bc(229, c | 0, o | 0, hr + 92 | 0, hr + 88 | 0, hr + 84 | 0, gi | 0, Mn | 0, Tr | 0, ln | 0, hr + 20 | 0), o = e[5996], e[5996] = 0, (o | 0) != 1)
                      for (e[Fe >> 2] = e[ke >> 2], ss = y & 512, Ji = e[hr + 20 >> 2], y = 0; ; ) {
                        r: {
                          n: {
                            i: {
                              s: {
                                a: {
                                  if ((y | 0) == 4)
                                    break a;
                                  if (e[5996] = 0, o = On(202, r | 0, hr + 524 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                    break e;
                                  if (o)
                                    break a;
                                  o: {
                                    l: {
                                      f: {
                                        d: {
                                          c:
                                            switch ($[(hr + 92 | 0) + y | 0]) {
                                              case 1:
                                                if ((y | 0) == 3)
                                                  break r;
                                                if (o = e[r >> 2], e[5996] = 0, o = ii(203, o | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1 || (e[5996] = 0, o = Si(230, G | 0, 1, o | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1))
                                                  break e;
                                                if (o) {
                                                  if (e[5996] = 0, di(231, hr + 12 | 0, r | 0), o = e[5996], e[5996] = 0, (o | 0) != 1 && (e[5996] = 0, di(232, ei | 0, e[hr + 12 >> 2]), o = e[5996], e[5996] = 0, (o | 0) != 1))
                                                    break d;
                                                  break e;
                                                }
                                                e[g >> 2] = e[g >> 2] | 4, r = 0;
                                                break n;
                                              case 4:
                                                break o;
                                              case 2:
                                                break l;
                                              case 3:
                                                break f;
                                              case 0:
                                                break c;
                                              default:
                                                break r;
                                            }
                                          if ((y | 0) == 3)
                                            break r;
                                        }
                                        for (; ; ) {
                                          if (e[5996] = 0, o = On(202, r | 0, hr + 524 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                            break e;
                                          if (o)
                                            break r;
                                          if (o = e[r >> 2], e[5996] = 0, o = ii(203, o | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1 || (e[5996] = 0, o = Si(230, G | 0, 1, o | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1))
                                            break e;
                                          if (!o)
                                            break r;
                                          if (e[5996] = 0, di(231, hr + 12 | 0, r | 0), o = e[5996], e[5996] = 0, !((o | 0) != 1 && (e[5996] = 0, di(232, ei | 0, e[hr + 12 >> 2]), o = e[5996], e[5996] = 0, (o | 0) != 1)))
                                            break;
                                        }
                                        break e;
                                      }
                                      f: {
                                        if (o = ye[Tr + 11 | 0], !((o & 128) >>> 7 | 0 ? e[Tr + 4 >> 2] : o & 127))
                                          break f;
                                        if (o = e[r >> 2], e[5996] = 0, o = ii(203, o | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                          break e;
                                        if (e[((ye[Tr + 11 | 0] & 128) >>> 7 | 0 ? e[Tr >> 2] : Tr) >> 2] != (o | 0))
                                          break f;
                                        if (e[5996] = 0, ii(205, r | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                          break e;
                                        $[S | 0] = 0, o = ye[Tr + 11 | 0], ci = ((o & 128) >>> 7 | 0 ? e[Tr + 4 >> 2] : o & 127) >>> 0 > 1 ? Tr : ci;
                                        break r;
                                      }
                                      f: {
                                        d: {
                                          if (Ar = e[ln + 4 >> 2], o = ye[ln + 11 | 0], (o & 128) >>> 7 | 0 ? Ar : o & 127) {
                                            if (o = e[r >> 2], e[5996] = 0, o = ii(203, o | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                              break e;
                                            if (e[((ye[ln + 11 | 0] & 128) >>> 7 | 0 ? e[ln >> 2] : ln) >> 2] == (o | 0))
                                              break d;
                                            Ar = e[ln + 4 >> 2], o = ye[ln + 11 | 0];
                                          }
                                          if (c = ye[Tr + 11 | 0], c = (c & 128) >>> 7 | 0 ? e[Tr + 4 >> 2] : c & 127, !c | !((o & 128) >>> 7 | 0 ? Ar : o & 127))
                                            break f;
                                          e[g >> 2] = e[g >> 2] | 4, r = 0;
                                          break n;
                                        }
                                        if (e[5996] = 0, ii(205, r | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                          break e;
                                        $[S | 0] = 1, o = ye[ln + 11 | 0], ci = ((o & 128) >>> 7 | 0 ? e[ln + 4 >> 2] : o & 127) >>> 0 > 1 ? ln : ci;
                                        break r;
                                      }
                                      if (o = (o & 128) >>> 7 | 0 ? Ar : o & 127, !(o | c))
                                        break r;
                                      $[S | 0] = !o;
                                      break r;
                                    }
                                    if (!(ci | y >>> 0 < 2 | ((y | 0) == 2 & ye[hr + 95 | 0] != 0 | ss))) {
                                      ci = 0;
                                      break r;
                                    }
                                    e[hr + 12 >> 2] = Qa(Mn);
                                    l: {
                                      if (!y | ye[(y + hr | 0) + 91 | 0] > 1)
                                        break l;
                                      f: {
                                        for (; ; ) {
                                          if (c = Ia(Mn), o = e[hr + 12 >> 2], (c | 0) == (o | 0))
                                            break f;
                                          if (o = e[o >> 2], e[5996] = 0, o = Si(230, G | 0, 1, o | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                                            if (!o)
                                              break f;
                                            e[hr + 12 >> 2] = e[hr + 12 >> 2] + 4;
                                            continue;
                                          }
                                          break;
                                        }
                                        break e;
                                      }
                                      if (o = Qa(Mn), o = e[hr + 12 >> 2] - o >> 2, c = ye[ei + 11 | 0], o >>> 0 <= ((c & 128) >>> 7 | 0 ? e[ei + 4 >> 2] : c & 127) >>> 0) {
                                        for (c = Pd(Ia(ei), 0 - o | 0), h = Ia(ei), Ar = Qa(Mn), o = Yr - 16 | 0, Yr = o, e[o + 8 >> 2] = Ar, e[o + 12 >> 2] = c; ; ) {
                                          if (Ar = (c | 0) != (h | 0), !(!Ar | e[c >> 2] != e[e[o + 8 >> 2] >> 2])) {
                                            e[o + 12 >> 2] = e[o + 12 >> 2] + 4, e[o + 8 >> 2] = e[o + 8 >> 2] + 4, c = e[o + 12 >> 2];
                                            continue;
                                          }
                                          break;
                                        }
                                        if (Yr = o + 16 | 0, !Ar)
                                          break l;
                                      }
                                      e[hr + 8 >> 2] = Qa(Mn), e[hr + 12 >> 2] = e[hr + 8 >> 2];
                                    }
                                    e[hr + 8 >> 2] = e[hr + 12 >> 2];
                                    l: {
                                      for (; ; ) {
                                        if ((Ia(Mn) | 0) == e[hr + 8 >> 2])
                                          break l;
                                        e[5996] = 0, o = On(202, r | 0, hr + 524 | 0) | 0, c = e[5996], e[5996] = 0;
                                        f: {
                                          if ((c | 0) == 1)
                                            break f;
                                          if (o)
                                            break l;
                                          if (o = e[r >> 2], e[5996] = 0, o = ii(203, o | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                            break f;
                                          if (e[e[hr + 8 >> 2] >> 2] != (o | 0))
                                            break l;
                                          if (e[5996] = 0, ii(205, r | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                            break e;
                                          e[hr + 8 >> 2] = e[hr + 8 >> 2] + 4;
                                          continue;
                                        }
                                        break;
                                      }
                                      break e;
                                    }
                                    if (!ss || (Ia(Mn) | 0) == e[hr + 8 >> 2])
                                      break r;
                                    e[g >> 2] = e[g >> 2] | 4, r = 0;
                                    break n;
                                  }
                                  o = 0, As = e[hr + 84 >> 2], c = Rn;
                                  o: {
                                    for (; ; ) {
                                      l: {
                                        if (e[5996] = 0, h = On(202, r | 0, hr + 524 | 0) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1)
                                          break l;
                                        if (h)
                                          break o;
                                        if (h = e[r >> 2], e[5996] = 0, Ar = ii(203, h | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1 || (e[5996] = 0, h = Si(230, G | 0, 64, Ar | 0) | 0, Rs = e[5996], e[5996] = 0, (Rs | 0) == 1))
                                          break e;
                                        f: {
                                          if (h) {
                                            if (h = e[Fe >> 2], (h | 0) == e[hr + 520 >> 2]) {
                                              if (e[5996] = 0, as(233, ke | 0, Fe | 0, hr + 520 | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                break e;
                                              h = e[Fe >> 2];
                                            }
                                            e[Fe >> 2] = h + 4, e[h >> 2] = Ar, o = o + 1 | 0;
                                            break f;
                                          }
                                          if (h = ye[gi + 11 | 0], !((h & 128) >>> 7 | 0 ? e[gi + 4 >> 2] : h & 127) | !o | (Ar | 0) != (As | 0))
                                            break o;
                                          if (e[hr + 96 >> 2] == (Rn | 0)) {
                                            if (e[5996] = 0, as(226, Qi | 0, hr + 100 | 0, hr + 96 | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                              break e;
                                            Rn = e[hr + 100 >> 2];
                                          }
                                          c = Rn + 4 | 0, e[hr + 100 >> 2] = c, e[Rn >> 2] = o, Rn = c, o = 0;
                                        }
                                        if (e[5996] = 0, ii(205, r | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) != 1)
                                          continue;
                                      }
                                      break;
                                    }
                                    break e;
                                  }
                                  if (!o | e[Qi >> 2] == (c | 0))
                                    break s;
                                  if (e[hr + 96 >> 2] == (c | 0)) {
                                    if (e[5996] = 0, as(226, Qi | 0, hr + 100 | 0, hr + 96 | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                      break e;
                                    c = e[hr + 100 >> 2];
                                  }
                                  Rn = c + 4 | 0, e[hr + 100 >> 2] = Rn, e[c >> 2] = o;
                                  break i;
                                }
                                e[hr + 20 >> 2] = Ji;
                                a: {
                                  if (!ci)
                                    break a;
                                  for (Ar = 1; ; ) {
                                    if (o = ye[ci + 11 | 0], ((o & 128) >>> 7 | 0 ? e[ci + 4 >> 2] : o & 127) >>> 0 <= Ar >>> 0)
                                      break a;
                                    e[5996] = 0, o = On(202, r | 0, hr + 524 | 0) | 0, c = e[5996], e[5996] = 0;
                                    o: {
                                      if ((c | 0) == 1)
                                        break o;
                                      l: {
                                        if (!o) {
                                          if (o = e[r >> 2], e[5996] = 0, o = ii(203, o | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                            break o;
                                          if (e[(Ar << 2) + ((ye[ci + 11 | 0] & 128) >>> 7 | 0 ? e[ci >> 2] : ci) >> 2] == (o | 0))
                                            break l;
                                        }
                                        e[g >> 2] = e[g >> 2] | 4, r = 0;
                                        break n;
                                      }
                                      if (e[5996] = 0, ii(205, r | 0) | 0, o = e[5996], e[5996] = 0, Ar = Ar + 1 | 0, (o | 0) != 1)
                                        continue;
                                    }
                                    break;
                                  }
                                  break e;
                                }
                                if (r = 1, o = e[Qi >> 2], (o | 0) == (Rn | 0))
                                  break n;
                                if (r = 0, e[hr + 12 >> 2] = 0, ma(gi, o, Rn, hr + 12 | 0), e[hr + 12 >> 2]) {
                                  e[g >> 2] = e[g >> 2] | 4;
                                  break n;
                                }
                                r = 1;
                                break n;
                              }
                              Rn = c;
                            }
                            i: {
                              if ((Ji | 0) <= 0)
                                break i;
                              if (e[5996] = 0, o = On(202, r | 0, hr + 524 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                break e;
                              s: {
                                if (!o) {
                                  if (o = e[r >> 2], e[5996] = 0, o = ii(203, o | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                    break e;
                                  if (e[hr + 88 >> 2] == (o | 0))
                                    break s;
                                }
                                e[g >> 2] = e[g >> 2] | 4, r = 0;
                                break n;
                              }
                              if (e[5996] = 0, o = ii(205, r | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                break e;
                              for (; ; ) {
                                if ((Ji | 0) <= 0) {
                                  Ji = 0;
                                  break i;
                                }
                                e[5996] = 0, c = On(202, o | 0, hr + 524 | 0) | 0, h = e[5996], e[5996] = 0;
                                s: {
                                  if ((h | 0) == 1)
                                    break s;
                                  a: {
                                    if (!c) {
                                      if (c = e[o >> 2], e[5996] = 0, c = ii(203, c | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1 || (e[5996] = 0, c = Si(230, G | 0, 64, c | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1))
                                        break s;
                                      if (c)
                                        break a;
                                    }
                                    e[g >> 2] = e[g >> 2] | 4, r = 0;
                                    break n;
                                  }
                                  if (e[Fe >> 2] == e[hr + 520 >> 2] && (e[5996] = 0, as(233, ke | 0, Fe | 0, hr + 520 | 0), c = e[5996], e[5996] = 0, (c | 0) == 1) || (c = e[o >> 2], e[5996] = 0, c = ii(203, c | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1))
                                    break s;
                                  if (h = e[Fe >> 2], e[Fe >> 2] = h + 4, e[h >> 2] = c, e[5996] = 0, ii(205, o | 0) | 0, c = e[5996], e[5996] = 0, Ji = Ji - 1 | 0, (c | 0) != 1)
                                    continue;
                                }
                                break;
                              }
                              break e;
                            }
                            if (e[Fe >> 2] != e[ke >> 2])
                              break r;
                            e[g >> 2] = e[g >> 2] | 4, r = 0;
                          }
                          qi(ei), qi(ln), qi(Tr), qi(Mn), qi(gi), Js(Qi);
                          break t;
                        }
                        y = y + 1 | 0;
                      }
                    break e;
                  }
                  return Yr = hr + 528 | 0, r | 0;
                }
                r = Vr() | 0, qi(ei), qi(ln), qi(Tr), qi(Mn), qi(gi), Js(Qi), Ki(r | 0), ri();
              }
              function Jd(r, o, c, h, y, g, S, G, ke, Fe, Ar) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, G = G | 0, ke = ke | 0, Fe = Fe | 0, Ar = Ar | 0;
                var hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0, Qi = 0, Ji = 0, ss = 0, As = 0, Rs = 0, oo = 0, Go = 0;
                hr = Yr - 528 | 0, Yr = hr, e[hr + 520 >> 2] = Ar, e[hr + 524 >> 2] = o;
                e: {
                  t: {
                    if (Nu(r, hr + 524 | 0)) {
                      e[g >> 2] = e[g >> 2] | 4, r = 0;
                      break t;
                    }
                    if (e[hr + 76 >> 2] = 220, Qi = hr + 104 | 0, e[Qi >> 2] = hr + 112, gi = hr + 76 | 0, e[Qi + 4 >> 2] = e[gi >> 2], Rn = e[Qi >> 2], e[hr + 100 >> 2] = Rn, e[hr + 96 >> 2] = Rn + 400, e[gi >> 2] = 0, e[gi + 4 >> 2] = 0, e[gi + 8 >> 2] = 0, Mn = hr - -64 | 0, e[Mn >> 2] = 0, e[Mn + 4 >> 2] = 0, e[Mn + 8 >> 2] = 0, Tr = hr + 52 | 0, e[Tr >> 2] = 0, e[Tr + 4 >> 2] = 0, e[Tr + 8 >> 2] = 0, ln = hr + 40 | 0, e[ln >> 2] = 0, e[ln + 4 >> 2] = 0, e[ln + 8 >> 2] = 0, ei = hr + 28 | 0, e[ei >> 2] = 0, e[ei + 4 >> 2] = 0, e[ei + 8 >> 2] = 0, o = e[h >> 2], e[5996] = 0, Bc(223, c | 0, o | 0, hr + 92 | 0, hr + 91 | 0, hr + 90 | 0, gi | 0, Mn | 0, Tr | 0, ln | 0, hr + 24 | 0), o = e[5996], e[5996] = 0, (o | 0) != 1)
                      for (e[Fe >> 2] = e[ke >> 2], As = y & 512, Ji = e[hr + 24 >> 2], Rs = ye[hr + 95 | 0], oo = ye[hr + 91 | 0], Go = ye[hr + 90 | 0], h = Rn, y = 0; ; ) {
                        r: {
                          n: {
                            i: {
                              s: {
                                if ((y | 0) == 4)
                                  break s;
                                if (e[5996] = 0, o = On(186, r | 0, hr + 524 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                  break e;
                                if (o)
                                  break s;
                                o = 0;
                                a: {
                                  o: {
                                    l: {
                                      f: {
                                        d:
                                          switch ($[(hr + 92 | 0) + y | 0]) {
                                            case 1:
                                              if ((y | 0) == 3)
                                                break r;
                                              if (o = e[r >> 2], e[5996] = 0, o = ii(187, o | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                break e;
                                              if (c = e[G + 8 >> 2], e[c + ((o & 255) << 2) >> 2] & 1 & (o | 0) >= 0) {
                                                if (e[5996] = 0, di(224, hr + 16 | 0, r | 0), o = e[5996], e[5996] = 0, (o | 0) != 1 && (e[5996] = 0, di(98, ei | 0, $[hr + 16 | 0]), o = e[5996], e[5996] = 0, (o | 0) != 1))
                                                  break f;
                                                break e;
                                              }
                                              e[g >> 2] = e[g >> 2] | 4, r = 0;
                                              break n;
                                            case 4:
                                              break a;
                                            case 2:
                                              break o;
                                            case 3:
                                              break l;
                                            case 0:
                                              break d;
                                            default:
                                              break r;
                                          }
                                        if ((y | 0) == 3)
                                          break r;
                                      }
                                      for (; ; ) {
                                        if (e[5996] = 0, o = On(186, r | 0, hr + 524 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                          break e;
                                        if (o)
                                          break r;
                                        if (o = e[r >> 2], e[5996] = 0, o = ii(187, o | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                          break e;
                                        if (c = e[G + 8 >> 2], !(e[c + ((o & 255) << 2) >> 2] & 1 & (o | 0) >= 0))
                                          break r;
                                        if (e[5996] = 0, di(224, hr + 16 | 0, r | 0), o = e[5996], e[5996] = 0, !((o | 0) != 1 && (e[5996] = 0, di(98, ei | 0, $[hr + 16 | 0]), o = e[5996], e[5996] = 0, (o | 0) != 1)))
                                          break;
                                      }
                                      break e;
                                    }
                                    l: {
                                      if (o = ye[Tr + 11 | 0], !((o & 128) >>> 7 | 0 ? e[Tr + 4 >> 2] : o & 127))
                                        break l;
                                      if (o = e[r >> 2], e[5996] = 0, o = ii(187, o | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                        break e;
                                      if (ye[((ye[Tr + 11 | 0] & 128) >>> 7 | 0 ? e[Tr >> 2] : Tr) | 0] != (o & 255))
                                        break l;
                                      if (e[5996] = 0, ii(189, r | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                        break e;
                                      $[S | 0] = 0, o = ye[Tr + 11 | 0], ci = ((o & 128) >>> 7 | 0 ? e[Tr + 4 >> 2] : o & 127) >>> 0 > 1 ? Tr : ci;
                                      break r;
                                    }
                                    l: {
                                      f: {
                                        if (Ar = e[ln + 4 >> 2], o = ye[ln + 11 | 0], (o & 128) >>> 7 | 0 ? Ar : o & 127) {
                                          if (o = e[r >> 2], e[5996] = 0, o = ii(187, o | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                            break e;
                                          if (ye[((ye[ln + 11 | 0] & 128) >>> 7 | 0 ? e[ln >> 2] : ln) | 0] == (o & 255))
                                            break f;
                                          Ar = e[ln + 4 >> 2], o = ye[ln + 11 | 0];
                                        }
                                        if (c = ye[Tr + 11 | 0], c = (c & 128) >>> 7 | 0 ? e[Tr + 4 >> 2] : c & 127, !c | !((o & 128) >>> 7 | 0 ? Ar : o & 127))
                                          break l;
                                        e[g >> 2] = e[g >> 2] | 4, r = 0;
                                        break n;
                                      }
                                      if (e[5996] = 0, ii(189, r | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                        break e;
                                      $[S | 0] = 1, o = ye[ln + 11 | 0], ci = ((o & 128) >>> 7 | 0 ? e[ln + 4 >> 2] : o & 127) >>> 0 > 1 ? ln : ci;
                                      break r;
                                    }
                                    if (o = (o & 128) >>> 7 | 0 ? Ar : o & 127, !(o | c))
                                      break r;
                                    $[S | 0] = !o;
                                    break r;
                                  }
                                  if (!(ci | y >>> 0 < 2 | ((y | 0) == 2 & (Rs | 0) != 0 | As))) {
                                    ci = 0;
                                    break r;
                                  }
                                  e[hr + 16 >> 2] = Qa(Mn);
                                  o: {
                                    if (!y | ye[(y + hr | 0) + 91 | 0] > 1)
                                      break o;
                                    for (; ; ) {
                                      l: {
                                        if (c = gu(Mn), o = e[hr + 16 >> 2], (c | 0) == (o | 0) || (c = e[G + 8 >> 2], o = $[o | 0], (o | 0) >= 0 ? o = e[c + ((o & 255) << 2) >> 2] & 1 : o = 0, !o))
                                          break l;
                                        e[hr + 16 >> 2] = e[hr + 16 >> 2] + 1;
                                        continue;
                                      }
                                      break;
                                    }
                                    if (o = Qa(Mn), o = e[hr + 16 >> 2] - o | 0, c = ye[ei + 11 | 0], o >>> 0 <= ((c & 128) >>> 7 | 0 ? e[ei + 4 >> 2] : c & 127) >>> 0) {
                                      for (c = qd(gu(ei), 0 - o | 0), Ar = gu(ei), ss = Qa(Mn), o = Yr - 16 | 0, Yr = o, e[o + 8 >> 2] = ss, e[o + 12 >> 2] = c; ; ) {
                                        if (ss = (c | 0) != (Ar | 0), !(!ss | ye[c | 0] != ye[e[o + 8 >> 2]])) {
                                          e[o + 12 >> 2] = e[o + 12 >> 2] + 1, e[o + 8 >> 2] = e[o + 8 >> 2] + 1, c = e[o + 12 >> 2];
                                          continue;
                                        }
                                        break;
                                      }
                                      if (Yr = o + 16 | 0, !ss)
                                        break o;
                                    }
                                    e[hr + 12 >> 2] = Qa(Mn), e[hr + 16 >> 2] = e[hr + 12 >> 2];
                                  }
                                  e[hr + 12 >> 2] = e[hr + 16 >> 2];
                                  o: {
                                    for (; ; ) {
                                      if ((gu(Mn) | 0) == e[hr + 12 >> 2])
                                        break o;
                                      e[5996] = 0, o = On(186, r | 0, hr + 524 | 0) | 0, c = e[5996], e[5996] = 0;
                                      l: {
                                        if ((c | 0) == 1)
                                          break l;
                                        if (o)
                                          break o;
                                        if (o = e[r >> 2], e[5996] = 0, o = ii(187, o | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                          break l;
                                        if (ye[e[hr + 12 >> 2]] != (o & 255))
                                          break o;
                                        if (e[5996] = 0, ii(189, r | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                          break e;
                                        e[hr + 12 >> 2] = e[hr + 12 >> 2] + 1;
                                        continue;
                                      }
                                      break;
                                    }
                                    break e;
                                  }
                                  if (!As || (gu(Mn) | 0) == e[hr + 12 >> 2])
                                    break r;
                                  e[g >> 2] = e[g >> 2] | 4, r = 0;
                                  break n;
                                }
                                a: {
                                  for (; ; ) {
                                    o: {
                                      if (e[5996] = 0, c = On(186, r | 0, hr + 524 | 0) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1)
                                        break o;
                                      if (c)
                                        break a;
                                      if (c = e[r >> 2], e[5996] = 0, Ar = ii(187, c | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                        break e;
                                      c = e[G + 8 >> 2];
                                      l: {
                                        if ((Ar | 0) >= 0 && e[c + ((Ar & 255) << 2) >> 2] & 64) {
                                          if (c = e[Fe >> 2], (c | 0) == e[hr + 520 >> 2]) {
                                            if (e[5996] = 0, as(225, ke | 0, Fe | 0, hr + 520 | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                              break e;
                                            c = e[Fe >> 2];
                                          }
                                          e[Fe >> 2] = c + 1, $[c | 0] = Ar, o = o + 1 | 0;
                                          break l;
                                        }
                                        if (c = ye[gi + 11 | 0], !((c & 128) >>> 7 | 0 ? e[gi + 4 >> 2] : c & 127) | !o | (Ar & 255) != (Go | 0))
                                          break a;
                                        if (e[hr + 96 >> 2] == (h | 0)) {
                                          if (e[5996] = 0, as(226, Qi | 0, hr + 100 | 0, hr + 96 | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                            break e;
                                          h = e[hr + 100 >> 2];
                                        }
                                        Rn = h + 4 | 0, e[hr + 100 >> 2] = Rn, e[h >> 2] = o, h = Rn, o = 0;
                                      }
                                      if (e[5996] = 0, ii(189, r | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1)
                                        continue;
                                    }
                                    break;
                                  }
                                  break e;
                                }
                                if (!(!o | e[Qi >> 2] == (Rn | 0))) {
                                  if (e[hr + 96 >> 2] == (Rn | 0)) {
                                    if (e[5996] = 0, as(226, Qi | 0, hr + 100 | 0, hr + 96 | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                      break e;
                                    Rn = e[hr + 100 >> 2];
                                  }
                                  c = Rn + 4 | 0, e[hr + 100 >> 2] = c, e[Rn >> 2] = o, Rn = c;
                                }
                                if ((Ji | 0) <= 0)
                                  break i;
                                if (e[5996] = 0, o = On(186, r | 0, hr + 524 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                  break e;
                                a: {
                                  if (!o) {
                                    if (o = e[r >> 2], e[5996] = 0, o = ii(187, o | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                      break e;
                                    if ((o & 255) == (oo | 0))
                                      break a;
                                  }
                                  e[g >> 2] = e[g >> 2] | 4, r = 0;
                                  break n;
                                }
                                if (e[5996] = 0, o = ii(189, r | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                  break e;
                                for (; ; ) {
                                  if ((Ji | 0) <= 0) {
                                    Ji = 0;
                                    break i;
                                  }
                                  e[5996] = 0, c = On(186, o | 0, hr + 524 | 0) | 0, h = e[5996], e[5996] = 0;
                                  a: {
                                    if ((h | 0) == 1)
                                      break a;
                                    o: {
                                      if (!c) {
                                        if (c = e[o >> 2], e[5996] = 0, c = ii(187, c | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                          break a;
                                        if (h = e[G + 8 >> 2], (c | 0) >= 0 && e[h + ((c & 255) << 2) >> 2] & 64)
                                          break o;
                                      }
                                      e[g >> 2] = e[g >> 2] | 4, r = 0;
                                      break n;
                                    }
                                    if (e[Fe >> 2] == e[hr + 520 >> 2] && (e[5996] = 0, as(225, ke | 0, Fe | 0, hr + 520 | 0), c = e[5996], e[5996] = 0, (c | 0) == 1) || (c = e[o >> 2], e[5996] = 0, c = ii(187, c | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1))
                                      break a;
                                    if (h = e[Fe >> 2], e[Fe >> 2] = h + 1, $[h | 0] = c, e[5996] = 0, ii(189, o | 0) | 0, c = e[5996], e[5996] = 0, Ji = Ji - 1 | 0, (c | 0) != 1)
                                      continue;
                                  }
                                  break;
                                }
                                break e;
                              }
                              e[hr + 24 >> 2] = Ji;
                              s: {
                                if (!ci)
                                  break s;
                                for (Ar = 1; ; ) {
                                  if (o = ye[ci + 11 | 0], ((o & 128) >>> 7 | 0 ? e[ci + 4 >> 2] : o & 127) >>> 0 <= Ar >>> 0)
                                    break s;
                                  e[5996] = 0, o = On(186, r | 0, hr + 524 | 0) | 0, c = e[5996], e[5996] = 0;
                                  a: {
                                    if ((c | 0) == 1)
                                      break a;
                                    o: {
                                      if (!o) {
                                        if (o = e[r >> 2], e[5996] = 0, o = ii(187, o | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                          break a;
                                        if (ye[((ye[ci + 11 | 0] & 128) >>> 7 | 0 ? e[ci >> 2] : ci) + Ar | 0] == (o & 255))
                                          break o;
                                      }
                                      e[g >> 2] = e[g >> 2] | 4, r = 0;
                                      break n;
                                    }
                                    if (e[5996] = 0, ii(189, r | 0) | 0, o = e[5996], e[5996] = 0, Ar = Ar + 1 | 0, (o | 0) != 1)
                                      continue;
                                  }
                                  break;
                                }
                                break e;
                              }
                              if (r = 1, o = e[Qi >> 2], (o | 0) == (Rn | 0))
                                break n;
                              if (r = 0, e[hr + 16 >> 2] = 0, ma(gi, o, Rn, hr + 16 | 0), e[hr + 16 >> 2]) {
                                e[g >> 2] = e[g >> 2] | 4;
                                break n;
                              }
                              r = 1;
                              break n;
                            }
                            if (h = Rn, e[Fe >> 2] != e[ke >> 2])
                              break r;
                            e[g >> 2] = e[g >> 2] | 4, r = 0;
                          }
                          qi(ei), qi(ln), qi(Tr), qi(Mn), qi(gi), Js(Qi);
                          break t;
                        }
                        y = y + 1 | 0;
                      }
                    break e;
                  }
                  return Yr = hr + 528 | 0, r | 0;
                }
                r = Vr() | 0, qi(ei), qi(ln), qi(Tr), qi(Mn), qi(gi), Js(Qi), Ki(r | 0), ri();
              }
              function K1(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            a:
                              switch (e[o >> 2]) {
                                case 0:
                                  e[r + 12 >> 2] = 1, e[r + 16 >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[r >> 2] = 0;
                                  return;
                                case 2:
                                  e[r + 12 >> 2] = 1, e[r + 16 >> 2] = 0;
                                  break t;
                                case 3:
                                  e[r + 12 >> 2] = 1, e[r + 16 >> 2] = 0, e[r + 4 >> 2] = 1, e[r + 8 >> 2] = 0, e[r >> 2] = 3;
                                  return;
                                case 4:
                                case 5:
                                  e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 4 >> 2] = 1, e[r + 8 >> 2] = 0, e[r >> 2] = 1;
                                  return;
                                case 6:
                                case 7:
                                case 8:
                                case 9:
                                  e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 4 >> 2] = 1, e[r + 8 >> 2] = 0, e[r >> 2] = 4;
                                  return;
                                case 17:
                                  o = e[o + 32 >> 2], c = e[o + 8 >> 2], G = e[c + 52 >> 2], o = e[o >> 2], g = e[o + 52 >> 2], y = ye[o + 48 | 0], S = ye[c + 48 | 0], c = e[c + 44 >> 2], o = e[o + 44 >> 2], e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0, e[r >> 2] = o + c;
                                  break e;
                                case 18:
                                  o = e[o + 32 >> 2], Tr = e[o + 8 >> 2], G = e[Tr + 52 >> 2], Fe = e[o >> 2], g = e[Fe + 52 >> 2], y = ye[Fe + 48 | 0], S = ye[Tr + 48 | 0], ke = e[Tr + 60 >> 2], h = e[Fe + 60 >> 2], c = ye[Fe + 56 | 0], o = ye[Tr + 56 | 0], e[r >> 2] = (e[Fe + 44 >> 2] + e[Tr + 44 >> 2] | 0) + 1, c = (c | 0) != 0 & (o | 0) != 0, o = c & 0, e[r + 12 >> 2] = o | c, e[r + 16 >> 2] = c ? h + ke | 0 : 0;
                                  break e;
                                case 19:
                                  o = e[o + 32 >> 2], G = e[o >> 2], S = e[G + 60 >> 2], g = ye[G + 56 | 0] != 0, c = e[o + 8 >> 2], hr = g & ye[c + 48 | 0] != 0, y = hr ? S + e[c + 52 >> 2] | 0 : 0, o = (e[G + 44 >> 2] + e[c + 44 >> 2] | 0) + 1 | 0, ke = e[c + 60 >> 2], h = ye[c + 56 | 0], !ye[G + 48 | 0] | !h || (c = ke + e[G + 52 >> 2] | 0, y = hr ? c >>> 0 > y >>> 0 ? c : y : c, hr = 1), e[r >> 2] = o, e[r + 4 >> 2] = hr, e[r + 8 >> 2] = y, y = g & (h | 0) != 0, o = y & 0, e[r + 12 >> 2] = o | y, e[r + 16 >> 2] = y ? S + ke | 0 : 0;
                                  return;
                                case 21:
                                  o = e[o + 32 >> 2], c = e[o >> 2], Fe = e[c + 60 >> 2], Tr = e[o + 8 >> 2], y = Fe + e[Tr + 52 >> 2] | 0, G = ye[c + 56 | 0], o = ye[Tr + 48 | 0] != 0 & (G | 0) != 0, S = (e[c + 44 >> 2] + e[Tr + 44 >> 2] | 0) + 3 | 0, h = o ? y : 0;
                                  o: {
                                    if (!ye[c + 48 | 0])
                                      break o;
                                    if (!o) {
                                      o = e[c + 48 >> 2], g = o & -256, h = e[c + 52 >> 2];
                                      break o;
                                    }
                                    o = 1, c = e[c + 52 >> 2], h = c >>> 0 > y >>> 0 ? c : y;
                                  }
                                  ke = e[Tr + 60 >> 2], y = ye[Tr + 56 | 0], e[r >> 2] = S, c = o & 255, o = 0, e[r + 4 >> 2] = c | (g | o), e[r + 8 >> 2] = h | Mn, c = (G | 0) != 0 & (y | 0) != 0, o = c ? o : 0, e[r + 12 >> 2] = o | c, e[r + 16 >> 2] = c ? ke + Fe | 0 : 0;
                                  return;
                                case 20:
                                  o = e[o + 32 >> 2], ke = e[o >> 2], c = e[o + 8 >> 2], h = e[ke + 60 >> 2] + e[c + 52 >> 2] | 0, o = ye[c + 48 | 0] != 0 & ye[ke + 56 | 0] != 0, y = (e[ke + 44 >> 2] + e[c + 44 >> 2] | 0) + 2 | 0, c = o ? h : 0;
                                  o: {
                                    if (!ye[ke + 48 | 0])
                                      break o;
                                    if (!o) {
                                      o = e[ke + 48 >> 2], g = o & -256, c = e[ke + 52 >> 2];
                                      break o;
                                    }
                                    o = 1, c = e[ke + 52 >> 2], c = c >>> 0 > h >>> 0 ? c : h;
                                  }
                                  e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0, e[r >> 2] = y, e[r + 4 >> 2] = g | o & 255, e[r + 8 >> 2] = c | Mn;
                                  return;
                                case 22:
                                  o = e[o + 32 >> 2], h = e[o >> 2], Fe = e[o + 8 >> 2], g = e[h + 44 >> 2] + e[Fe + 44 >> 2] | 0;
                                  o: {
                                    if (!ye[h + 48 | 0]) {
                                      o = e[Fe + 48 >> 2], G = o & -256, y = e[Fe + 52 >> 2];
                                      break o;
                                    }
                                    if (!ye[Fe + 48 | 0]) {
                                      o = e[h + 48 >> 2], G = o & -256, y = e[h + 52 >> 2];
                                      break o;
                                    }
                                    o = 1, y = e[h + 52 >> 2], c = e[Fe + 52 >> 2], y = c >>> 0 < y >>> 0 ? y : c;
                                  }
                                  ke = g + 3 | 0;
                                  o: {
                                    if (!ye[h + 56 | 0]) {
                                      g = e[Fe + 56 >> 2], S = g & -256, c = e[Fe + 60 >> 2];
                                      break o;
                                    }
                                    if (!ye[Fe + 56 | 0]) {
                                      g = e[h + 56 >> 2], S = g & -256, c = e[h + 60 >> 2];
                                      break o;
                                    }
                                    g = 1, h = e[h + 60 >> 2], c = e[Fe + 60 >> 2], c = c >>> 0 < h >>> 0 ? h : c;
                                  }
                                  e[r >> 2] = ke, e[r + 12 >> 2] = g & 255 | S & -256, h = 0, e[r + 16 >> 2] = h | (c | h), e[r + 4 >> 2] = o & 255 | G & -256, g = 0, e[r + 8 >> 2] = g | (y | g);
                                  return;
                                case 23:
                                  o = e[o + 32 >> 2], G = e[o + 16 >> 2], g = e[o >> 2], S = e[g + 60 >> 2], ke = ye[g + 56 | 0] != 0, h = ke & ye[G + 48 | 0] != 0, y = h ? e[G + 52 >> 2] + S | 0 : 0, o = e[o + 8 >> 2], c = (e[G + 44 >> 2] + (e[g + 44 >> 2] + e[o + 44 >> 2] | 0) | 0) + 3 | 0, !ye[o + 48 | 0] | !ye[g + 48 | 0] || (o = e[g + 52 >> 2] + e[o + 52 >> 2] | 0, y = h ? o >>> 0 > y >>> 0 ? o : y : o, h = 1), g = e[G + 60 >> 2], o = ye[G + 56 | 0], e[r >> 2] = c, e[r + 4 >> 2] = h, e[r + 8 >> 2] = y, y = ke & (o | 0) != 0, o = y & 0, e[r + 12 >> 2] = o | y, e[r + 16 >> 2] = y ? g + S | 0 : 0;
                                  return;
                                case 25:
                                  c = e[o + 12 >> 2], o = e[o + 8 >> 2], e[r >> 2] = 1, o = (c - o | 0) / 12 | 0, c = 1, e[r + 12 >> 2] = c, e[r + 16 >> 2] = o, e[r + 4 >> 2] = c, e[r + 8 >> 2] = o;
                                  return;
                                case 11:
                                case 12:
                                case 16:
                                  h = e[e[o + 32 >> 2] >> 2], g = e[h + 48 >> 2], y = e[h + 52 >> 2], c = e[h + 44 >> 2], o = e[h + 60 >> 2], e[r + 12 >> 2] = e[h + 56 >> 2], e[r + 16 >> 2] = o, e[r + 4 >> 2] = g, e[r + 8 >> 2] = y, e[r >> 2] = c + 1;
                                  return;
                                case 10:
                                  h = e[e[o + 32 >> 2] >> 2], g = e[h + 48 >> 2], y = e[h + 52 >> 2], c = e[h + 44 >> 2], o = e[h + 60 >> 2], e[r + 12 >> 2] = e[h + 56 >> 2], e[r + 16 >> 2] = o, e[r + 4 >> 2] = g, e[r + 8 >> 2] = y, e[r >> 2] = c + 2;
                                  return;
                                case 13:
                                  o = e[e[o + 32 >> 2] >> 2], y = e[o + 48 >> 2], c = e[o + 52 >> 2], o = e[o + 44 >> 2], e[r + 12 >> 2] = 1, e[r + 16 >> 2] = 0, e[r + 4 >> 2] = y, e[r + 8 >> 2] = c, e[r >> 2] = o + 3;
                                  return;
                                case 15:
                                  o = e[e[o + 32 >> 2] >> 2], y = e[o + 48 >> 2], c = e[o + 52 >> 2], o = e[o + 44 >> 2], e[r + 12 >> 2] = 1, e[r + 16 >> 2] = 0, e[r + 4 >> 2] = y, e[r + 8 >> 2] = c, e[r >> 2] = o + 4;
                                  return;
                                case 14:
                                  c = e[e[o + 32 >> 2] >> 2], h = e[c + 44 >> 2], g = e[c + 80 >> 2], y = uu(1239, 1), o = e[e[o + 32 >> 2] >> 2], c = e[o + 48 >> 2], o = e[o + 52 >> 2], e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 4 >> 2] = c, e[r + 8 >> 2] = o, e[r >> 2] = h + !(y & (g ^ -1));
                                  return;
                                case 24:
                                  if (c = xs(8), e[c >> 2] = 1, e[c + 4 >> 2] = 0, hr = c + 8 | 0, ln = e[o + 32 >> 2], Mn = e[o + 36 >> 2], (ln | 0) != (Mn | 0))
                                    for (; ; ) {
                                      y = e[ln >> 2], G = e[y + 60 >> 2], S = ye[y + 56 | 0], h = e[c + 4 >> 2], ke = c, g = ye[c | 0], Tr = e[y + 44 >> 2], e[5996] = 0, y = ii(3, 8) | 0, c = e[5996], e[5996] = 0;
                                      o: {
                                        l: {
                                          if ((c | 0) != 1) {
                                            if (c = h + G | 0, h = (g | 0) != 0 & (S | 0) != 0, g = h & 0, e[y >> 2] = h | g, e[y + 4 >> 2] = h ? c : 0, S = y + 8 | 0, c = hr - ke | 0, ci = c >> 3, c >>> 0 >= 9)
                                              break l;
                                            g = S;
                                            break o;
                                          }
                                          g = Vr() | 0, c = ke;
                                          break i;
                                        }
                                        for (Fe = ci >>> 0 <= 2 ? 2 : ci, hr = 1, g = S; ; ) {
                                          ei = e[ln >> 2], c = ke + (hr << 3) | 0, Ar = e[ei + 60 >> 2] + e[c + 4 >> 2] | 0, h = c - 8 | 0, Rn = ye[h | 0] != 0 & ye[ei + 48 | 0] != 0, G = ye[c | 0] != 0 & ye[ei + 56 | 0] != 0, c = G ? Ar : 0, h = Rn ? e[ei + 52 >> 2] + e[h + 4 >> 2] | 0 : 0, c = G ? Rn ? c >>> 0 > h >>> 0 ? c : h : Ar : h, Rn = G | Rn;
                                          l: {
                                            if (g >>> 0 < S >>> 0) {
                                              e[g >> 2] = Rn, e[g + 4 >> 2] = c, h = g;
                                              break l;
                                            }
                                            if (G = g - y >> 3, Ar = G + 1 | 0, Ar >>> 0 >= 536870912) {
                                              if (e[5996] = 0, Ri(93), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                break s;
                                              break r;
                                            }
                                            S = S - y | 0, h = S >> 2, Ar = S >>> 0 >= 2147483640 ? 536870911 : h >>> 0 > Ar >>> 0 ? h : Ar;
                                            f: {
                                              if (!Ar) {
                                                S = 0;
                                                break f;
                                              }
                                              if (Ar >>> 0 >= 536870912) {
                                                if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                  break r;
                                                break s;
                                              }
                                              if (e[5996] = 0, S = ii(3, Ar << 3) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                break s;
                                            }
                                            h = (G << 3) + S | 0, e[h >> 2] = Rn, e[h + 4 >> 2] = c, S = (Ar << 3) + S | 0, c = h;
                                            f: {
                                              if ((y | 0) != (g | 0)) {
                                                for (; g = g - 8 | 0, G = e[g + 4 >> 2], c = c - 8 | 0, e[c >> 2] = e[g >> 2], e[c + 4 >> 2] = G, (y | 0) != (g | 0); )
                                                  ;
                                                if (!y)
                                                  break f;
                                              }
                                              Sr(y);
                                            }
                                            y = c;
                                          }
                                          if (g = h + 8 | 0, hr = hr + 1 | 0, (Fe | 0) == (hr | 0))
                                            break;
                                        }
                                      }
                                      h = (ke + (ci << 3) | 0) - 8 | 0, c = e[ln >> 2], Ar = ye[h | 0] != 0 & ye[c + 48 | 0] != 0, h = Ar ? e[c + 52 >> 2] + e[h + 4 >> 2] | 0 : 0;
                                      o: {
                                        if (g >>> 0 < S >>> 0) {
                                          e[g >> 2] = Ar, e[g + 4 >> 2] = h, hr = g + 8 | 0, c = y;
                                          break o;
                                        }
                                        l: {
                                          f: {
                                            G = g - y >> 3, Fe = G + 1 | 0;
                                            d: {
                                              if (Fe >>> 0 >= 536870912) {
                                                e[5996] = 0, Ri(93);
                                                break d;
                                              }
                                              if (S = S - y | 0, c = S >> 2, c = S >>> 0 >= 2147483640 ? 536870911 : c >>> 0 > Fe >>> 0 ? c : Fe, !c) {
                                                c = 0;
                                                break l;
                                              }
                                              if (c >>> 0 < 536870912)
                                                break f;
                                              e[5996] = 0, Ri(35);
                                            }
                                            if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                              break r;
                                            break s;
                                          }
                                          if (e[5996] = 0, c = ii(3, c << 3) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                            break s;
                                        }
                                        if (c = (G << 3) + c | 0, e[c >> 2] = Ar, e[c + 4 >> 2] = h, hr = c + 8 | 0, (y | 0) != (g | 0)) {
                                          for (; g = g - 8 | 0, h = e[g + 4 >> 2], c = c - 8 | 0, e[c >> 2] = e[g >> 2], e[c + 4 >> 2] = h, (y | 0) != (g | 0); )
                                            ;
                                          if (!y)
                                            break o;
                                        }
                                        Sr(y);
                                      }
                                      if (gi = (Tr + gi | 0) + 1 | 0, Sr(ke), ln = ln + 8 | 0, (Mn | 0) == (ln | 0))
                                        break;
                                    }
                                  if (o = e[o + 4 >> 2], o >>> 0 <= hr - c >> 3 >>> 0) {
                                    o = (o << 3) + c | 0, g = e[o >> 2], y = e[o + 4 >> 2], o = e[c + 4 >> 2], e[r + 12 >> 2] = e[c >> 2], e[r + 16 >> 2] = o, e[r + 4 >> 2] = g, e[r + 8 >> 2] = y, e[r >> 2] = gi, Sr(c);
                                    return;
                                  }
                                  if (e[5996] = 0, Qs(44, 5118, 2210, 799, 1422), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                    break r;
                                  if (g = Vr() | 0, !c)
                                    break n;
                                  break i;
                                default:
                                  aa(2350, 2210, 803, 1422), ri();
                                case 1:
                                  break a;
                              }
                            e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0;
                            break t;
                          }
                          if (g = Vr() | 0, !y) {
                            c = ke;
                            break i;
                          }
                          Sr(y), c = ke;
                        }
                        Sr(c);
                      }
                      Ki(g | 0), ri();
                    }
                    ri();
                  }
                  e[r + 4 >> 2] = 1, e[r + 8 >> 2] = 0, e[r >> 2] = 0;
                  return;
                }
                y = (y | 0) != 0 & (S | 0) != 0, o = y & 0, e[r + 4 >> 2] = o | y, e[r + 8 >> 2] = y ? g + G | 0 : 0;
              }
              function G1(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0, G = 0;
                y = Yr - 80 | 0, Yr = y, h = xs(32), e[y + 68 >> 2] = h, e[y + 72 >> 2] = 19, e[y + 76 >> 2] = -2147483616, g = ye[5568] | ye[5569] << 8 | (ye[5570] << 16 | ye[5571] << 24), $[h + 15 | 0] = g, $[h + 16 | 0] = g >>> 8, $[h + 17 | 0] = g >>> 16, $[h + 18 | 0] = g >>> 24, g = ye[5565] | ye[5566] << 8 | (ye[5567] << 16 | ye[5568] << 24), S = ye[5561] | ye[5562] << 8 | (ye[5563] << 16 | ye[5564] << 24), $[h + 8 | 0] = S, $[h + 9 | 0] = S >>> 8, $[h + 10 | 0] = S >>> 16, $[h + 11 | 0] = S >>> 24, $[h + 12 | 0] = g, $[h + 13 | 0] = g >>> 8, $[h + 14 | 0] = g >>> 16, $[h + 15 | 0] = g >>> 24, g = ye[5557] | ye[5558] << 8 | (ye[5559] << 16 | ye[5560] << 24), S = ye[5553] | ye[5554] << 8 | (ye[5555] << 16 | ye[5556] << 24), $[h | 0] = S, $[h + 1 | 0] = S >>> 8, $[h + 2 | 0] = S >>> 16, $[h + 3 | 0] = S >>> 24, $[h + 4 | 0] = g, $[h + 5 | 0] = g >>> 8, $[h + 6 | 0] = g >>> 16, $[h + 7 | 0] = g >>> 24, $[h + 19 | 0] = 0;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  f: {
                                    d: {
                                      c: {
                                        u: {
                                          g: {
                                            A: {
                                              p: {
                                                h = e[e[o >> 2] + 80 >> 2];
                                                I: {
                                                  if (!h) {
                                                    if (e[5996] = 0, On(97, y + 68 | 0, 2603) | 0, h = e[5996], e[5996] = 0, (h | 0) != 1)
                                                      break I;
                                                    break t;
                                                  }
                                                  if (e[5996] = 0, g = On(54, 3557, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                    break p;
                                                  if (!((h ^ -1) & g) && (e[5996] = 0, di(98, y + 68 | 0, 66), h = e[5996], e[5996] = 0, (h | 0) == 1))
                                                    break t;
                                                  if (h = e[e[o >> 2] + 80 >> 2], e[5996] = 0, g = On(54, 2796, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                    break A;
                                                  if (!((h ^ -1) & g) && (e[5996] = 0, di(98, y + 68 | 0, 86), h = e[5996], e[5996] = 0, (h | 0) == 1))
                                                    break t;
                                                  if (h = e[e[o >> 2] + 80 >> 2], e[5996] = 0, g = On(54, 2777, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                    break g;
                                                  if (!((h ^ -1) & g) && (e[5996] = 0, di(98, y + 68 | 0, 87), h = e[5996], e[5996] = 0, (h | 0) == 1))
                                                    break t;
                                                  if (h = e[e[o >> 2] + 80 >> 2], e[5996] = 0, g = On(54, 3310, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                    break u;
                                                  if (!((h ^ -1) & g) && (e[5996] = 0, di(98, y + 68 | 0, 75), h = e[5996], e[5996] = 0, (h | 0) == 1))
                                                    break t;
                                                  if (h = e[e[o >> 2] + 80 >> 2], e[5996] = 0, g = On(54, 1029, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                    break c;
                                                  if (!((h ^ -1) & g) && (e[5996] = 0, di(98, y + 68 | 0, 122), h = e[5996], e[5996] = 0, (h | 0) == 1))
                                                    break t;
                                                  if (h = e[e[o >> 2] + 80 >> 2], e[5996] = 0, g = On(54, 1959, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                    break d;
                                                  if (!((h ^ -1) & g) && (e[5996] = 0, di(98, y + 68 | 0, 111), h = e[5996], e[5996] = 0, (h | 0) == 1))
                                                    break t;
                                                  if (h = e[e[o >> 2] + 80 >> 2], e[5996] = 0, g = On(54, 2029, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                    break f;
                                                  if (!((h ^ -1) & g) && (e[5996] = 0, di(98, y + 68 | 0, 110), h = e[5996], e[5996] = 0, (h | 0) == 1))
                                                    break t;
                                                  if (h = e[e[o >> 2] + 80 >> 2], e[5996] = 0, g = On(54, 2522, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                    break l;
                                                  if (!((h ^ -1) & g) && (e[5996] = 0, di(98, y + 68 | 0, 100), h = e[5996], e[5996] = 0, (h | 0) == 1))
                                                    break t;
                                                  if (h = e[e[o >> 2] + 80 >> 2], e[5996] = 0, g = On(54, 2315, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                    break o;
                                                  if (!((h ^ -1) & g) && (e[5996] = 0, di(98, y + 68 | 0, 102), h = e[5996], e[5996] = 0, (h | 0) == 1))
                                                    break t;
                                                  if (h = e[e[o >> 2] + 80 >> 2], e[5996] = 0, g = On(54, 2451, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                    break a;
                                                  if (!((h ^ -1) & g) && (e[5996] = 0, di(98, y + 68 | 0, 101), h = e[5996], e[5996] = 0, (h | 0) == 1))
                                                    break t;
                                                  if (h = e[e[o >> 2] + 80 >> 2], e[5996] = 0, g = On(54, 2049, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                    break s;
                                                  if (!((h ^ -1) & g) && (e[5996] = 0, di(98, y + 68 | 0, 109), h = e[5996], e[5996] = 0, (h | 0) == 1))
                                                    break t;
                                                  if (h = e[e[o >> 2] + 80 >> 2], e[5996] = 0, g = On(54, 1295, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                    break i;
                                                  if (!((h ^ -1) & g) && (e[5996] = 0, di(98, y + 68 | 0, 117), h = e[5996], e[5996] = 0, (h | 0) == 1))
                                                    break t;
                                                  if (h = e[e[o >> 2] + 80 >> 2], e[5996] = 0, g = On(54, 1681, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                    break n;
                                                  if (!((h ^ -1) & g) && (e[5996] = 0, di(98, y + 68 | 0, 115), h = e[5996], e[5996] = 0, (h | 0) == 1))
                                                    break t;
                                                  if (h = e[e[o >> 2] + 80 >> 2], e[5996] = 0, g = On(54, 2165, 1) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                    break r;
                                                  if ((h ^ -1) & g)
                                                    break I;
                                                  if (e[5996] = 0, di(98, y + 68 | 0, 107), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                    break t;
                                                }
                                                h = e[e[o >> 2] + 84 >> 2], e[5996] = 0, g = y + 44 | 0, di(115, g | 0, h | 0), h = e[5996], e[5996] = 0;
                                                I: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              b: {
                                                                h: {
                                                                  x: {
                                                                    m: {
                                                                      B: {
                                                                        R: {
                                                                          E: {
                                                                            C: {
                                                                              if ((h | 0) != 1) {
                                                                                if (e[5996] = 0, h = Si(99, g | 0, 0, 5487) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                  break C;
                                                                                if (e[y - -64 >> 2] = e[h + 8 >> 2], g = e[h + 4 >> 2], e[y + 56 >> 2] = e[h >> 2], e[y + 60 >> 2] = g, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, g = ye[y + 67 | 0], S = g << 24 >> 24 < 0, g = Si(100, y + 68 | 0, (S ? e[y + 56 >> 2] : y + 56 | 0) | 0, (S ? e[y + 60 >> 2] : g) | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                  break E;
                                                                                if ($[y + 67 | 0] < 0 && Sr(e[y + 56 >> 2]), $[h + 11 | 0] < 0 && Sr(e[h >> 2]), h = e[o >> 2], S = e[h + 52 >> 2], h = e[h + 44 >> 2], e[5996] = 0, G = y + 32 | 0, di(164, G | 0, h + S | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                  break B;
                                                                                if (e[5996] = 0, h = Si(99, G | 0, 0, 5459) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                  break m;
                                                                                if (e[y - -64 >> 2] = e[h + 8 >> 2], S = e[h + 4 >> 2], e[y + 56 >> 2] = e[h >> 2], e[y + 60 >> 2] = S, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, G = g, g = ye[y + 67 | 0], S = g << 24 >> 24 < 0, g = Si(100, G | 0, (S ? e[y + 56 >> 2] : y + 56 | 0) | 0, (S ? e[y + 60 >> 2] : g) | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                                                                  break x;
                                                                                if ($[y + 67 | 0] < 0 && Sr(e[y + 56 >> 2]), $[h + 11 | 0] < 0 && Sr(e[h >> 2]), o = e[e[o >> 2] + 68 >> 2], e[5996] = 0, h = y + 20 | 0, di(164, h | 0, o + 1 | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                  break b;
                                                                                if (e[5996] = 0, o = Si(99, h | 0, 0, 5524) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                                                                                  break w;
                                                                                if (e[y - -64 >> 2] = e[o + 8 >> 2], h = e[o + 4 >> 2], e[y + 56 >> 2] = e[o >> 2], e[y + 60 >> 2] = h, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[5996] = 0, G = g, h = ye[y + 67 | 0], g = h << 24 >> 24 < 0, h = Si(100, G | 0, (g ? e[y + 56 >> 2] : y + 56 | 0) | 0, (g ? e[y + 60 >> 2] : h) | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                  break v;
                                                                                if ($[y + 67 | 0] < 0 && Sr(e[y + 56 >> 2]), $[o + 11 | 0] < 0 && Sr(e[o >> 2]), e[5996] = 0, h = On(97, h | 0, 3759) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                                                                  break S;
                                                                                if (e[y + 16 >> 2] = e[h + 8 >> 2], o = e[h + 4 >> 2], e[y + 8 >> 2] = e[h >> 2], e[y + 12 >> 2] = o, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, g = e[c >> 2], S = e[c + 4 >> 2], o = ye[c + 11 | 0], e[5996] = 0, G = c, c = o << 24 >> 24 < 0, o = Si(100, y + 8 | 0, (c ? g : G) | 0, (c ? S : o) | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                                                                  break N;
                                                                                if (e[y - -64 >> 2] = e[o + 8 >> 2], c = e[o + 4 >> 2], e[y + 56 >> 2] = e[o >> 2], e[y + 60 >> 2] = c, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[5996] = 0, c = On(97, y + 56 | 0, 3559) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                                                                  break k;
                                                                                g = e[c + 4 >> 2], e[r >> 2] = e[c >> 2], e[r + 4 >> 2] = g, e[r + 8 >> 2] = e[c + 8 >> 2], e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, $[o + 11 | 0] < 0 && Sr(e[o >> 2]), $[h + 11 | 0] < 0 && Sr(e[h >> 2]), Yr = y + 80 | 0;
                                                                                return;
                                                                              }
                                                                              o = Vr() | 0;
                                                                              break e;
                                                                            }
                                                                            o = Vr() | 0;
                                                                            break R;
                                                                          }
                                                                          if (o = Vr() | 0, $[y + 67 | 0] >= 0)
                                                                            break R;
                                                                          Sr(e[y + 56 >> 2]);
                                                                        }
                                                                        if ($[y + 55 | 0] >= 0)
                                                                          break e;
                                                                        Sr(e[y + 44 >> 2]);
                                                                        break e;
                                                                      }
                                                                      o = Vr() | 0;
                                                                      break e;
                                                                    }
                                                                    o = Vr() | 0;
                                                                    break h;
                                                                  }
                                                                  if (o = Vr() | 0, $[y + 67 | 0] >= 0)
                                                                    break h;
                                                                  Sr(e[y + 56 >> 2]);
                                                                }
                                                                if ($[y + 43 | 0] >= 0)
                                                                  break e;
                                                                Sr(e[y + 32 >> 2]);
                                                                break e;
                                                              }
                                                              o = Vr() | 0;
                                                              break e;
                                                            }
                                                            o = Vr() | 0;
                                                            break T;
                                                          }
                                                          if (o = Vr() | 0, $[y + 67 | 0] >= 0)
                                                            break T;
                                                          Sr(e[y + 56 >> 2]);
                                                        }
                                                        if ($[y + 31 | 0] >= 0)
                                                          break e;
                                                        Sr(e[y + 20 >> 2]);
                                                        break e;
                                                      }
                                                      o = Vr() | 0;
                                                      break e;
                                                    }
                                                    o = Vr() | 0;
                                                    break I;
                                                  }
                                                  if (o = Vr() | 0, $[y + 67 | 0] >= 0)
                                                    break I;
                                                  Sr(e[y + 56 >> 2]);
                                                }
                                                if ($[y + 19 | 0] >= 0)
                                                  break e;
                                                Sr(e[y + 8 >> 2]);
                                                break e;
                                              }
                                              o = Vr() | 0;
                                              break e;
                                            }
                                            o = Vr() | 0;
                                            break e;
                                          }
                                          o = Vr() | 0;
                                          break e;
                                        }
                                        o = Vr() | 0;
                                        break e;
                                      }
                                      o = Vr() | 0;
                                      break e;
                                    }
                                    o = Vr() | 0;
                                    break e;
                                  }
                                  o = Vr() | 0;
                                  break e;
                                }
                                o = Vr() | 0;
                                break e;
                              }
                              o = Vr() | 0;
                              break e;
                            }
                            o = Vr() | 0;
                            break e;
                          }
                          o = Vr() | 0;
                          break e;
                        }
                        o = Vr() | 0;
                        break e;
                      }
                      o = Vr() | 0;
                      break e;
                    }
                    o = Vr() | 0;
                    break e;
                  }
                  o = Vr() | 0;
                }
                $[y + 79 | 0] < 0 && Sr(e[y + 68 >> 2]), Ki(o | 0), ri();
              }
              function Nl(r, o, c, h, y, g) {
                r = r | 0, o = +o, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0, Qi = 0, Ji = 0, ss = 0, As = 0, Rs = 0, oo = 0;
                Tr = Yr - 560 | 0, Yr = Tr, e[Tr + 44 >> 2] = 0, ya(+o), S = js(1) | 0, js(0) | 0;
                e: {
                  if ((S | 0) < 0) {
                    gi = 1, As = 1222, o = -o, ya(+o), S = js(1) | 0, js(0) | 0;
                    break e;
                  }
                  if (y & 2048) {
                    gi = 1, As = 1225;
                    break e;
                  }
                  gi = y & 1, As = gi ? 1228 : 1223, oo = !gi;
                }
                e: {
                  if ((S & 2146435072) == 2146435072) {
                    S = gi + 3 | 0, ua(r, 32, c, S, y & -65537), Aa(r, As, gi), h = g & 32, Aa(r, o != o ? h ? 2020 : 3082 : h ? 2300 : 3355, 3), ua(r, 32, c, S, y ^ 8192), Rn = (c | 0) < (S | 0) ? S : c;
                    break e;
                  }
                  Ji = Tr + 16 | 0;
                  t: {
                    r: {
                      n: {
                        if (o = bf(o, Tr + 44 | 0), o = o + o, o != 0) {
                          if (S = e[Tr + 44 >> 2], e[Tr + 44 >> 2] = S - 1, ss = g | 32, (ss | 0) != 97)
                            break n;
                          break t;
                        }
                        if (ss = g | 32, (ss | 0) == 97)
                          break t;
                        Fe = e[Tr + 44 >> 2], hr = (h | 0) < 0 ? 6 : h;
                        break r;
                      }
                      Fe = S - 29 | 0, e[Tr + 44 >> 2] = Fe, o = o * 268435456, hr = (h | 0) < 0 ? 6 : h;
                    }
                    for (ei = (Tr + 48 | 0) + ((Fe | 0) >= 0 ? 288 : 0) | 0, G = ei; o < 4294967296 & o >= 0 ? h = ~~o >>> 0 : h = 0, e[G >> 2] = h, G = G + 4 | 0, o = (o - +(h >>> 0)) * 1e9, o != 0; )
                      ;
                    r: {
                      if ((Fe | 0) <= 0) {
                        h = Fe, S = G, ke = ei;
                        break r;
                      }
                      for (ke = ei, h = Fe; ; ) {
                        Ar = (h | 0) >= 29 ? 29 : h, S = G - 4 | 0;
                        n: {
                          if (ke >>> 0 > S >>> 0)
                            break n;
                          for (ln = 0; h = e[S >> 2], Rn = Ar & 31, Rs = ln, (Ar & 63) >>> 0 >= 32 ? (ln = h << Rn, h = 0) : (ln = (1 << Rn) - 1 & h >>> 32 - Rn, h = h << Rn), Rn = Rs + h | 0, ln = ln + Mn | 0, ln = _l(Rn, h >>> 0 > Rn >>> 0 ? ln + 1 | 0 : ln, 1e9), h = so(ln, vs, -1e9, 0) + Rn | 0, e[S >> 2] = h, S = S - 4 | 0, ke >>> 0 <= S >>> 0; )
                            ;
                          if (!ln)
                            break n;
                          ke = ke - 4 | 0, e[ke >> 2] = ln;
                        }
                        for (; S = G, ke >>> 0 < S >>> 0 && (G = S - 4 | 0, !e[G >> 2]); )
                          ;
                        if (h = e[Tr + 44 >> 2] - Ar | 0, e[Tr + 44 >> 2] = h, G = S, !((h | 0) > 0))
                          break;
                      }
                    }
                    if ((h | 0) < 0)
                      for (Qi = ((hr + 25 >>> 0) / 9 | 0) + 1 | 0, Mn = (ss | 0) == 102; ; ) {
                        h = 0 - h | 0, Rn = (h | 0) >= 9 ? 9 : h;
                        r: {
                          if (S >>> 0 <= ke >>> 0) {
                            G = e[ke >> 2];
                            break r;
                          }
                          for (ln = 1e9 >>> Rn | 0, Ar = -1 << Rn ^ -1, h = 0, G = ke; Rs = h, h = e[G >> 2], e[G >> 2] = Rs + (h >>> Rn | 0), h = vi(ln, h & Ar), G = G + 4 | 0, G >>> 0 < S >>> 0; )
                            ;
                          if (G = e[ke >> 2], !h)
                            break r;
                          e[S >> 2] = h, S = S + 4 | 0;
                        }
                        if (h = Rn + e[Tr + 44 >> 2] | 0, e[Tr + 44 >> 2] = h, ke = (!G << 2) + ke | 0, G = Mn ? ei : ke, S = S - G >> 2 > (Qi | 0) ? G + (Qi << 2) | 0 : S, !((h | 0) < 0))
                          break;
                      }
                    h = 0;
                    r: {
                      if (S >>> 0 <= ke >>> 0 || (h = vi(ei - ke >> 2, 9), G = 10, Ar = e[ke >> 2], Ar >>> 0 < 10))
                        break r;
                      for (; h = h + 1 | 0, G = vi(G, 10), Ar >>> 0 >= G >>> 0; )
                        ;
                    }
                    if (G = (hr - ((ss | 0) != 102 ? h : 0) | 0) - ((ss | 0) == 103 & (hr | 0) != 0) | 0, (G | 0) < (vi(S - ei >> 2, 9) - 9 | 0)) {
                      if (ln = G + 9216 | 0, Ar = (ln | 0) / 9 | 0, Fe = ((((Fe | 0) < 0 ? 4 : 292) + Tr | 0) + (Ar << 2) | 0) - 4048 | 0, G = 10, Rn = ln + vi(Ar, -9) | 0, (Rn | 0) <= 7)
                        for (; G = vi(G, 10), Rn = Rn + 1 | 0, (Rn | 0) != 8; )
                          ;
                      ln = e[Fe >> 2], Qi = (ln >>> 0) / (G >>> 0) | 0, Mn = vi(Qi, G), Ar = Fe + 4 | 0;
                      r: {
                        if ((ln | 0) == (Mn | 0) & (Ar | 0) == (S | 0))
                          break r;
                        ln = ln - Mn | 0;
                        n: {
                          if (!(Qi & 1) && (o = 9007199254740992, !($[Fe - 4 | 0] & 1) | ((G | 0) != 1e9 | ke >>> 0 >= Fe >>> 0)))
                            break n;
                          o = 9007199254740994;
                        }
                        if (ci = (S | 0) == (Ar | 0) ? 1 : 1.5, Ar = G >>> 1 | 0, ci = Ar >>> 0 > ln >>> 0 ? 0.5 : (Ar | 0) == (ln | 0) ? ci : 1.5, ye[As | 0] != 45 | oo || (ci = -ci, o = -o), e[Fe >> 2] = Mn, o + ci == o)
                          break r;
                        if (h = G + Mn | 0, e[Fe >> 2] = h, h >>> 0 >= 1e9)
                          for (; e[Fe >> 2] = 0, Fe = Fe - 4 | 0, Fe >>> 0 < ke >>> 0 && (ke = ke - 4 | 0, e[ke >> 2] = 0), h = e[Fe >> 2] + 1 | 0, e[Fe >> 2] = h, h >>> 0 > 999999999; )
                            ;
                        if (h = vi(ei - ke >> 2, 9), G = 10, Ar = e[ke >> 2], Ar >>> 0 < 10)
                          break r;
                        for (; h = h + 1 | 0, G = vi(G, 10), Ar >>> 0 >= G >>> 0; )
                          ;
                      }
                      G = Fe + 4 | 0, S = S >>> 0 > G >>> 0 ? G : S;
                    }
                    for (; Ar = S, ln = S >>> 0 <= ke >>> 0, !ln && (S = S - 4 | 0, !e[S >> 2]); )
                      ;
                    r: {
                      if ((ss | 0) != 103) {
                        Fe = y & 8;
                        break r;
                      }
                      if (G = hr || 1, S = (G | 0) > (h | 0) & (h | 0) > -5, hr = (S ? h ^ -1 : -1) + G | 0, g = (S ? -1 : -2) + g | 0, Fe = y & 8, Fe)
                        break r;
                      S = -9;
                      n: {
                        if (ln || (Fe = e[Ar - 4 >> 2], !Fe) || (Rn = 10, S = 0, (Fe >>> 0) % 10 | 0))
                          break n;
                        for (; G = S, S = S + 1 | 0, Rn = vi(Rn, 10), !((Fe >>> 0) % (Rn >>> 0) | 0); )
                          ;
                        S = G ^ -1;
                      }
                      if (G = vi(Ar - ei >> 2, 9), (g & -33) == 70) {
                        Fe = 0, S = (S + G | 0) - 9 | 0, S = (S | 0) > 0 ? S : 0, hr = (S | 0) > (hr | 0) ? hr : S;
                        break r;
                      }
                      Fe = 0, S = ((h + G | 0) + S | 0) - 9 | 0, S = (S | 0) > 0 ? S : 0, hr = (S | 0) > (hr | 0) ? hr : S;
                    }
                    if (Rn = -1, ln = Fe | hr, ((ln ? 2147483645 : 2147483646) | 0) < (hr | 0))
                      break e;
                    Mn = (((ln | 0) != 0) + hr | 0) + 1 | 0, G = g & -33;
                    r: {
                      if ((G | 0) == 70) {
                        if ((Mn ^ 2147483647) < (h | 0))
                          break e;
                        S = (h | 0) > 0 ? h : 0;
                        break r;
                      }
                      if (S = h >> 31, S = qc((S ^ h) - S | 0, 0, Ji), (Ji - S | 0) <= 1)
                        for (; S = S - 1 | 0, $[S | 0] = 48, (Ji - S | 0) < 2; )
                          ;
                      if (Qi = S - 2 | 0, $[Qi | 0] = g, $[S - 1 | 0] = (h | 0) < 0 ? 45 : 43, S = Ji - Qi | 0, (S | 0) > (Mn ^ 2147483647))
                        break e;
                    }
                    if (h = S + Mn | 0, (h | 0) > (gi ^ 2147483647))
                      break e;
                    Mn = h + gi | 0, ua(r, 32, c, Mn, y), Aa(r, As, gi), ua(r, 48, c, Mn, y ^ 65536);
                    r: {
                      n: {
                        i: {
                          if ((G | 0) == 70) {
                            for (g = Tr + 16 | 0, h = g | 8, Fe = g | 9, G = ke >>> 0 > ei >>> 0 ? ei : ke, ke = G; ; ) {
                              S = qc(e[ke >> 2], 0, Fe);
                              s: {
                                if ((G | 0) != (ke | 0)) {
                                  if (Tr + 16 >>> 0 >= S >>> 0)
                                    break s;
                                  for (; S = S - 1 | 0, $[S | 0] = 48, Tr + 16 >>> 0 < S >>> 0; )
                                    ;
                                  break s;
                                }
                                if ((S | 0) != (Fe | 0))
                                  break s;
                                $[Tr + 24 | 0] = 48, S = h;
                              }
                              if (Aa(r, S, Fe - S | 0), ke = ke + 4 | 0, !(ei >>> 0 >= ke >>> 0))
                                break;
                            }
                            if (ln && Aa(r, 4352, 1), (hr | 0) <= 0 | ke >>> 0 >= Ar >>> 0)
                              break i;
                            for (; ; ) {
                              if (S = qc(e[ke >> 2], 0, Fe), S >>> 0 > Tr + 16 >>> 0)
                                for (; S = S - 1 | 0, $[S | 0] = 48, Tr + 16 >>> 0 < S >>> 0; )
                                  ;
                              if (Aa(r, S, (hr | 0) >= 9 ? 9 : hr), S = hr - 9 | 0, ke = ke + 4 | 0, Ar >>> 0 <= ke >>> 0)
                                break n;
                              if (h = (hr | 0) > 9, hr = S, !h)
                                break;
                            }
                            break n;
                          }
                          s: {
                            if ((hr | 0) < 0)
                              break s;
                            for (ei = ke >>> 0 < Ar >>> 0 ? Ar : ke + 4 | 0, g = Tr + 16 | 0, h = g | 8, Ar = g | 9, G = ke; ; ) {
                              S = qc(e[G >> 2], 0, Ar), (Ar | 0) == (S | 0) && ($[Tr + 24 | 0] = 48, S = h);
                              a: {
                                if ((G | 0) != (ke | 0)) {
                                  if (Tr + 16 >>> 0 >= S >>> 0)
                                    break a;
                                  for (; S = S - 1 | 0, $[S | 0] = 48, Tr + 16 >>> 0 < S >>> 0; )
                                    ;
                                  break a;
                                }
                                if (Aa(r, S, 1), S = S + 1 | 0, !(Fe | hr))
                                  break a;
                                Aa(r, 4352, 1);
                              }
                              if (g = Ar - S | 0, Aa(r, S, (g | 0) < (hr | 0) ? g : hr), hr = hr - g | 0, G = G + 4 | 0, ei >>> 0 <= G >>> 0)
                                break s;
                              if (!((hr | 0) >= 0))
                                break;
                            }
                          }
                          ua(r, 48, hr + 18 | 0, 18, 0), Aa(r, Qi, Ji - Qi | 0);
                          break r;
                        }
                        S = hr;
                      }
                      ua(r, 48, S + 9 | 0, 9, 0);
                    }
                    ua(r, 32, c, Mn, y ^ 8192), Rn = (c | 0) < (Mn | 0) ? Mn : c;
                    break e;
                  }
                  Fe = (g << 26 >> 31 & 9) + As | 0;
                  t: {
                    if (h >>> 0 > 11)
                      break t;
                    for (S = 12 - h | 0, ci = 16; ci = ci * 16, S = S - 1 | 0, !!S; )
                      ;
                    if (ye[Fe | 0] == 45) {
                      o = -(ci + (-o - ci));
                      break t;
                    }
                    o = o + ci - ci;
                  }
                  for (ei = gi | 2, ke = g & 32, G = e[Tr + 44 >> 2], S = G >> 31, S = qc((S ^ G) - S | 0, 0, Ji), (Ji | 0) == (S | 0) && ($[Tr + 15 | 0] = 48, S = Tr + 15 | 0), hr = S - 2 | 0, $[hr | 0] = g + 15, $[S - 1 | 0] = (G | 0) < 0 ? 45 : 43, S = y & 8, G = Tr + 16 | 0; g = G, Fd(o) < 2147483648 ? Ar = ~~o : Ar = -2147483648, $[G | 0] = ke | ye[Ar + 7488 | 0], o = (o - +(Ar | 0)) * 16, G = g + 1 | 0, !((h | 0) > 0 | S) & o == 0 | (G - (Tr + 16 | 0) | 0) != 1 || ($[g + 1 | 0] = 46, G = g + 2 | 0), o != 0; )
                    ;
                  if (Rn = -1, S = Ji - hr | 0, g = S + ei | 0, (2147483645 - g | 0) < (h | 0))
                    break e;
                  Ar = g, g = Tr + 16 | 0, ke = G - g | 0, h = h && (ke - 2 | 0) < (h | 0) ? h + 2 | 0 : ke, G = Ar + h | 0, ua(r, 32, c, G, y), Aa(r, Fe, ei), ua(r, 48, c, G, y ^ 65536), Aa(r, g, ke), ua(r, 48, h - ke | 0, 0, 0), Aa(r, hr, S), ua(r, 32, c, G, y ^ 8192), Rn = (c | 0) < (G | 0) ? G : c;
                }
                return Yr = Tr + 560 | 0, Rn | 0;
              }
              function Yd(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            a:
                              switch (e[o >> 2]) {
                                case 1:
                                case 4:
                                case 5:
                                  e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, e[r >> 2] = 1, e[r + 4 >> 2] = 0;
                                  return;
                                case 2:
                                  e[r + 8 >> 2] = 1, e[r + 12 >> 2] = 1;
                                  break e;
                                case 3:
                                  e[r + 8 >> 2] = 1, e[r + 12 >> 2] = 2, e[r >> 2] = 1, e[r + 4 >> 2] = 2;
                                  return;
                                case 6:
                                case 7:
                                case 8:
                                case 9:
                                  e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                  break e;
                                case 23:
                                  h = e[o + 32 >> 2], o = e[h + 16 >> 2], c = e[h >> 2], y = e[c + 76 >> 2], Fe = ye[c + 72 | 0] != 0, ke = Fe & ye[o + 64 | 0] != 0, g = ke ? e[o + 68 >> 2] + y | 0 : 0;
                                  o: {
                                    if (!ye[c + 64 | 0] || (h = e[h + 8 >> 2], !ye[h + 64 | 0]))
                                      break o;
                                    c = e[h + 68 >> 2] + e[c + 68 >> 2] | 0, g = ke ? c >>> 0 > g >>> 0 ? c : g : c, ke = 1;
                                  }
                                  h = e[o + 76 >> 2], o = ye[o + 72 | 0], e[r >> 2] = ke, e[r + 4 >> 2] = g, o = Fe & (o | 0) != 0, c = o & 0, e[r + 8 >> 2] = o | c, e[r + 12 >> 2] = o ? h + y | 0 : 0;
                                  return;
                                case 17:
                                  o = e[o + 32 >> 2], c = e[o + 8 >> 2], h = e[c + 68 >> 2], o = e[o >> 2], g = e[o + 68 >> 2], o = ye[o + 64 | 0], y = ye[c + 64 | 0], e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, c = h + g | 0, o = (o | 0) != 0 & (y | 0) != 0, h = o & 0, e[r >> 2] = o | h, e[r + 4 >> 2] = o ? c : 0;
                                  return;
                                case 18:
                                  c = e[o + 32 >> 2], o = e[c + 8 >> 2], g = e[o + 68 >> 2], h = e[c >> 2], y = e[h + 68 >> 2], Fe = ye[h + 64 | 0], S = ye[o + 64 | 0], c = e[o + 76 >> 2] + e[h + 76 >> 2] | 0, o = ye[h + 72 | 0] != 0 & ye[o + 72 | 0] != 0, h = o & 0, e[r + 8 >> 2] = o | h, e[r + 12 >> 2] = o ? c : 0, o = (Fe | 0) != 0 & (S | 0) != 0, h = o & 0, e[r >> 2] = o | h, e[r + 4 >> 2] = o ? y + g | 0 : 0;
                                  return;
                                case 19:
                                  c = e[o + 32 >> 2], o = e[c + 8 >> 2], g = e[o + 76 >> 2], Fe = ye[o + 72 | 0] != 0, h = e[c >> 2], ke = Fe & ye[h + 64 | 0] != 0, c = ke ? g + e[h + 68 >> 2] | 0 : 0, y = e[h + 76 >> 2], S = ye[h + 72 | 0], !S | !ye[o + 64 | 0] || (o = y + e[o + 68 >> 2] | 0, c = ke ? o >>> 0 > c >>> 0 ? o : c : o, ke = 1), e[r >> 2] = ke, e[r + 4 >> 2] = c, o = Fe & (S | 0) != 0, h = o & 0, e[r + 8 >> 2] = o | h, e[r + 12 >> 2] = o ? y + g | 0 : 0;
                                  return;
                                case 20:
                                  o = e[o + 32 >> 2], y = e[o + 8 >> 2], c = e[o >> 2], h = e[y + 68 >> 2] + e[c + 76 >> 2] | 0, o = ye[c + 72 | 0] != 0 & ye[y + 64 | 0] != 0, y = o ? h : 0;
                                  o: {
                                    if (!ye[c + 64 | 0])
                                      break o;
                                    if (!o) {
                                      o = e[c + 64 >> 2], g = o & -256, y = e[c + 68 >> 2];
                                      break o;
                                    }
                                    o = 1, c = e[c + 68 >> 2], y = c >>> 0 > h >>> 0 ? c : h;
                                  }
                                  c = y, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, e[r >> 2] = g | o & 255, e[r + 4 >> 2] = c | Fe;
                                  return;
                                case 21:
                                  o = e[o + 32 >> 2], h = e[o + 8 >> 2], c = e[o >> 2], S = e[c + 76 >> 2], y = e[h + 68 >> 2] + S | 0, ke = ye[c + 72 | 0], o = (ke | 0) != 0 & ye[h + 64 | 0] != 0, G = o ? y : 0;
                                  o: {
                                    if (!ye[c + 64 | 0])
                                      break o;
                                    if (!o) {
                                      o = e[c + 64 >> 2], g = o & -256, G = e[c + 68 >> 2];
                                      break o;
                                    }
                                    o = 1, c = e[c + 68 >> 2], G = c >>> 0 > y >>> 0 ? c : y;
                                  }
                                  y = G, c = e[h + 76 >> 2], h = ye[h + 72 | 0], G = o & 255, o = 0, e[r >> 2] = G | (g | o), e[r + 4 >> 2] = y | Fe, y = c + S | 0, c = o, o = (ke | 0) != 0 & (h | 0) != 0, c = o ? c : 0, e[r + 8 >> 2] = o | c, e[r + 12 >> 2] = o ? y : 0;
                                  return;
                                case 22:
                                  h = e[o + 32 >> 2], o = e[h + 8 >> 2], g = ye[o + 64 | 0], c = g ? e[o + 68 >> 2] + 1 | 0 : 0, y = e[h >> 2], ye[y + 64 | 0] && (h = e[y + 68 >> 2] + 1 | 0, c = g ? c >>> 0 < h >>> 0 ? h : c : h, g = 1), Fe = e[o + 76 >> 2] + 1 | 0, o = ye[o + 72 | 0], h = o ? Fe : 0, ye[y + 72 | 0] && (y = e[y + 76 >> 2] + 1 | 0, h = o ? h >>> 0 < y >>> 0 ? y : h : y, o = 1), Fe = o, o = 0, e[r + 8 >> 2] = Fe | o, e[r + 12 >> 2] = h, e[r >> 2] = o | g, e[r + 4 >> 2] = c;
                                  return;
                                case 25:
                                  c = e[o + 4 >> 2] + 1 | 0, o = 1, e[r + 8 >> 2] = o, e[r + 12 >> 2] = c;
                                  break t;
                                case 10:
                                case 11:
                                case 12:
                                case 16:
                                  o = e[e[o + 32 >> 2] >> 2], c = e[o + 68 >> 2], e[r >> 2] = e[o + 64 >> 2], e[r + 4 >> 2] = c, c = e[o + 76 >> 2], e[r + 8 >> 2] = e[o + 72 >> 2], e[r + 12 >> 2] = c;
                                  return;
                                case 13:
                                  o = e[e[o + 32 >> 2] >> 2], c = e[o + 68 >> 2], o = ye[o + 64 | 0], e[r + 8 >> 2] = 1, e[r + 12 >> 2] = 1, Fe = o, o = !o, e[r >> 2] = Fe | o & 0, e[r + 4 >> 2] = o ? 0 : c + 1 | 0;
                                  return;
                                case 14:
                                  c = e[e[o + 32 >> 2] >> 2], o = e[c + 64 >> 2], c = e[c + 68 >> 2], e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                  break t;
                                case 15:
                                  c = e[e[o + 32 >> 2] >> 2], o = e[c + 64 >> 2], c = e[c + 68 >> 2], e[r + 8 >> 2] = 1, e[r + 12 >> 2] = 1;
                                  break t;
                                case 24:
                                  if (c = xs(8), e[c >> 2] = 1, e[c + 4 >> 2] = 0, ke = c + 8 | 0, hr = e[o + 32 >> 2], Rn = e[o + 36 >> 2], (hr | 0) != (Rn | 0))
                                    for (; ; ) {
                                      h = e[hr >> 2], y = e[h + 76 >> 2], h = ye[h + 72 | 0], S = e[c + 4 >> 2], Fe = c, Ar = ye[c | 0], e[5996] = 0, g = ii(3, 8) | 0, c = e[5996], e[5996] = 0;
                                      o: {
                                        l: {
                                          if ((c | 0) != 1) {
                                            if (c = y + S | 0, h = (Ar | 0) != 0 & (h | 0) != 0, y = h & 0, e[g >> 2] = h | y, e[g + 4 >> 2] = h ? c : 0, S = g + 8 | 0, c = ke - Fe | 0, Ar = c >> 3, c >>> 0 >= 9)
                                              break l;
                                            h = S;
                                            break o;
                                          }
                                          h = Vr() | 0, c = Fe;
                                          break i;
                                        }
                                        for (ei = Ar >>> 0 <= 2 ? 2 : Ar, ke = 1, h = S; ; ) {
                                          c = e[hr >> 2], G = Fe + (ke << 3) | 0, Tr = e[c + 76 >> 2] + e[G + 4 >> 2] | 0, ln = G - 8 | 0, y = ye[ln | 0] != 0 & ye[c + 64 | 0] != 0, G = ye[G | 0] != 0 & ye[c + 72 | 0] != 0, Mn = G ? Tr : 0, c = y ? e[c + 68 >> 2] + e[ln + 4 >> 2] | 0 : 0, c = G ? y ? c >>> 0 < Mn >>> 0 ? Mn : c : Tr : c, Tr = y | G;
                                          l: {
                                            if (h >>> 0 < S >>> 0) {
                                              e[h >> 2] = Tr, e[h + 4 >> 2] = c, y = h;
                                              break l;
                                            }
                                            if (ln = h - g >> 3, y = ln + 1 | 0, y >>> 0 >= 536870912) {
                                              if (e[5996] = 0, Ri(93), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                break s;
                                              break r;
                                            }
                                            S = S - g | 0, G = S >> 2, G = S >>> 0 >= 2147483640 ? 536870911 : y >>> 0 < G >>> 0 ? G : y;
                                            f: {
                                              if (!G) {
                                                S = 0;
                                                break f;
                                              }
                                              if (G >>> 0 >= 536870912) {
                                                if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                  break r;
                                                break s;
                                              }
                                              if (e[5996] = 0, S = ii(3, G << 3) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1)
                                                break s;
                                            }
                                            y = (ln << 3) + S | 0, e[y >> 2] = Tr, e[y + 4 >> 2] = c, S = (G << 3) + S | 0, c = y;
                                            f: {
                                              if ((h | 0) != (g | 0)) {
                                                for (; h = h - 8 | 0, G = e[h + 4 >> 2], c = c - 8 | 0, e[c >> 2] = e[h >> 2], e[c + 4 >> 2] = G, (h | 0) != (g | 0); )
                                                  ;
                                                if (!g)
                                                  break f;
                                              }
                                              Sr(g);
                                            }
                                            g = c;
                                          }
                                          if (h = y + 8 | 0, ke = ke + 1 | 0, (ei | 0) == (ke | 0))
                                            break;
                                        }
                                      }
                                      c = (Fe + (Ar << 3) | 0) - 8 | 0, y = e[hr >> 2], ke = ye[c | 0] != 0 & ye[y + 64 | 0] != 0, y = ke ? e[y + 68 >> 2] + e[c + 4 >> 2] | 0 : 0;
                                      o: {
                                        if (h >>> 0 < S >>> 0) {
                                          e[h >> 2] = ke, e[h + 4 >> 2] = y, ke = h + 8 | 0, c = g;
                                          break o;
                                        }
                                        l: {
                                          f: {
                                            Ar = h - g >> 3, c = Ar + 1 | 0;
                                            d: {
                                              if (c >>> 0 >= 536870912) {
                                                e[5996] = 0, Ri(93);
                                                break d;
                                              }
                                              if (S = S - g | 0, G = S >> 2, c = S >>> 0 >= 2147483640 ? 536870911 : c >>> 0 < G >>> 0 ? G : c, !c) {
                                                c = 0;
                                                break l;
                                              }
                                              if (c >>> 0 < 536870912)
                                                break f;
                                              e[5996] = 0, Ri(35);
                                            }
                                            if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                              break r;
                                            break s;
                                          }
                                          if (e[5996] = 0, c = ii(3, c << 3) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                            break s;
                                        }
                                        if (c = (Ar << 3) + c | 0, e[c >> 2] = ke, e[c + 4 >> 2] = y, ke = c + 8 | 0, (h | 0) != (g | 0)) {
                                          for (; h = h - 8 | 0, y = e[h + 4 >> 2], c = c - 8 | 0, e[c >> 2] = e[h >> 2], e[c + 4 >> 2] = y, (h | 0) != (g | 0); )
                                            ;
                                          if (!g)
                                            break o;
                                        }
                                        Sr(g);
                                      }
                                      if (Sr(Fe), hr = hr + 8 | 0, (Rn | 0) == (hr | 0))
                                        break;
                                    }
                                  if (o = e[o + 4 >> 2], o >>> 0 <= ke - c >> 3 >>> 0) {
                                    o = (o << 3) + c | 0, h = e[o >> 2], o = e[o + 4 >> 2], g = e[c + 4 >> 2], e[r + 8 >> 2] = e[c >> 2], e[r + 12 >> 2] = g, e[r >> 2] = h, e[r + 4 >> 2] = o, Sr(c);
                                    return;
                                  }
                                  if (e[5996] = 0, Qs(44, 5118, 2210, 850, 2317), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                    break r;
                                  if (h = Vr() | 0, !c)
                                    break n;
                                  break i;
                                default:
                                  aa(2350, 2210, 854, 2317), ri();
                                case 0:
                                  break a;
                              }
                            e[r + 8 >> 2] = 1, e[r + 12 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                            return;
                          }
                          if (h = Vr() | 0, !g) {
                            c = Fe;
                            break i;
                          }
                          Sr(g), c = Fe;
                        }
                        Sr(c);
                      }
                      Ki(h | 0), ri();
                    }
                    ri();
                  }
                  e[r >> 2] = o, e[r + 4 >> 2] = c;
                  return;
                }
                e[r >> 2] = 1, e[r + 4 >> 2] = 1;
              }
              function Pl(r, o, c, h, y) {
                var g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0, Qi = 0, Ji = 0, ss = 0, As = 0, Rs = 0;
                G = Yr - 80 | 0, Yr = G, e[G + 76 >> 2] = o, Rs = G + 55 | 0, ei = G + 56 | 0;
                e: {
                  t: {
                    r: {
                      n: for (; ; ) {
                        g = 0;
                        i: for (; ; ) {
                          if (Ar = o, (Mn ^ 2147483647) < (g | 0))
                            break r;
                          Mn = g + Mn | 0;
                          s: {
                            a: {
                              o: {
                                if (g = o, S = ye[g | 0], S)
                                  for (; ; ) {
                                    l: {
                                      o = S & 255;
                                      f: {
                                        if (!o) {
                                          o = g;
                                          break f;
                                        }
                                        if ((o | 0) != 37)
                                          break l;
                                        for (S = g; ; ) {
                                          if (ye[S + 1 | 0] != 37) {
                                            o = S;
                                            break f;
                                          }
                                          if (g = g + 1 | 0, hr = ye[S + 2 | 0], o = S + 2 | 0, S = o, (hr | 0) != 37)
                                            break;
                                        }
                                      }
                                      if (g = g - Ar | 0, As = Mn ^ 2147483647, (g | 0) > (As | 0))
                                        break r;
                                      if (r && Aa(r, Ar, g), g)
                                        continue i;
                                      e[G + 76 >> 2] = o, g = o + 1 | 0, Rn = -1, S = $[o + 1 | 0], ye[o + 2 | 0] != 36 | S - 48 >>> 0 >= 10 || (Rn = S - 48 | 0, ci = 1, g = o + 3 | 0), e[G + 76 >> 2] = g, Tr = 0, S = $[g | 0], o = S - 32 | 0;
                                      f: {
                                        if (o >>> 0 > 31) {
                                          hr = g;
                                          break f;
                                        }
                                        if (hr = g, o = 1 << o, !(o & 75913))
                                          break f;
                                        for (; ; ) {
                                          if (hr = g + 1 | 0, e[G + 76 >> 2] = hr, Tr = o | Tr, S = $[g + 1 | 0], o = S - 32 | 0, o >>> 0 >= 32)
                                            break f;
                                          if (g = hr, o = 1 << o, !(o & 75913))
                                            break;
                                        }
                                      }
                                      f: {
                                        if ((S | 0) == 42) {
                                          o = $[hr + 1 | 0];
                                          d: {
                                            if (!(ye[hr + 2 | 0] != 36 | o - 48 >>> 0 >= 10)) {
                                              o = o - 48 | 0;
                                              c: {
                                                if (!r) {
                                                  e[(o << 2) + y >> 2] = 10, ln = 0;
                                                  break c;
                                                }
                                                ln = e[(o << 3) + h >> 2];
                                              }
                                              o = hr + 3 | 0, ci = 1;
                                              break d;
                                            }
                                            if (ci)
                                              break o;
                                            if (o = hr + 1 | 0, !r) {
                                              e[G + 76 >> 2] = o, ci = 0, ln = 0;
                                              break f;
                                            }
                                            g = e[c >> 2], e[c >> 2] = g + 4, ln = e[g >> 2], ci = 0;
                                          }
                                          if (e[G + 76 >> 2] = o, (ln | 0) >= 0)
                                            break f;
                                          ln = 0 - ln | 0, Tr = Tr | 8192;
                                          break f;
                                        }
                                        if (ln = Cd(G + 76 | 0), (ln | 0) < 0)
                                          break r;
                                        o = e[G + 76 >> 2];
                                      }
                                      g = 0, ke = -1, S = 0;
                                      f: {
                                        if (ye[o | 0] != 46)
                                          break f;
                                        if (ye[o + 1 | 0] == 42) {
                                          S = $[o + 2 | 0];
                                          d: {
                                            if (!(ye[o + 3 | 0] != 36 | S - 48 >>> 0 >= 10)) {
                                              S = S - 48 | 0, o = o + 4 | 0;
                                              c: {
                                                if (!r) {
                                                  e[(S << 2) + y >> 2] = 10, ke = 0;
                                                  break c;
                                                }
                                                ke = e[(S << 3) + h >> 2];
                                              }
                                              break d;
                                            }
                                            if (ci)
                                              break o;
                                            if (o = o + 2 | 0, ke = 0, !r)
                                              break d;
                                            S = e[c >> 2], e[c >> 2] = S + 4, ke = e[S >> 2];
                                          }
                                          e[G + 76 >> 2] = o, S = (ke ^ -1) >>> 31 | 0;
                                          break f;
                                        }
                                        e[G + 76 >> 2] = o + 1, ke = Cd(G + 76 | 0), o = e[G + 76 >> 2], S = 1;
                                      }
                                      for (Qi = S; ; ) {
                                        if (gi = g, Fe = 28, Ji = o, S = $[o | 0], S - 123 >>> 0 < 4294967238)
                                          break t;
                                        if (o = o + 1 | 0, g = ye[(S + vi(g, 58) | 0) + 6959 | 0], !(g - 1 >>> 0 < 8))
                                          break;
                                      }
                                      e[G + 76 >> 2] = o;
                                      f: {
                                        if ((g | 0) != 27) {
                                          if (!g)
                                            break t;
                                          if ((Rn | 0) >= 0) {
                                            if (!r) {
                                              e[(Rn << 2) + y >> 2] = g;
                                              continue n;
                                            }
                                            g = (Rn << 3) + h | 0, S = e[g + 4 >> 2], e[G + 64 >> 2] = e[g >> 2], e[G + 68 >> 2] = S;
                                            break f;
                                          }
                                          if (!r)
                                            break s;
                                          hf(G - -64 | 0, g, c);
                                          break f;
                                        }
                                        if ((Rn | 0) >= 0)
                                          break t;
                                        if (g = 0, !r)
                                          continue i;
                                      }
                                      if (Fe = -1, ye[r | 0] & 32)
                                        break e;
                                      S = Tr & -65537, Tr = Tr & 8192 ? S : Tr, Rn = 0, ss = 1212, hr = ei;
                                      f: {
                                        d: {
                                          c: {
                                            u: {
                                              g: {
                                                A: {
                                                  p: {
                                                    I: {
                                                      k: {
                                                        N: {
                                                          S: {
                                                            T: {
                                                              v: {
                                                                w: {
                                                                  b: {
                                                                    h:
                                                                      switch (g = $[Ji | 0], g = gi && (g & 15) == 3 ? g & -33 : g, g - 88 | 0) {
                                                                        case 11:
                                                                          break f;
                                                                        case 9:
                                                                        case 13:
                                                                        case 14:
                                                                        case 15:
                                                                          break d;
                                                                        case 27:
                                                                          break p;
                                                                        case 12:
                                                                        case 17:
                                                                          break N;
                                                                        case 23:
                                                                          break S;
                                                                        case 0:
                                                                        case 32:
                                                                          break T;
                                                                        case 24:
                                                                          break v;
                                                                        case 22:
                                                                          break w;
                                                                        case 29:
                                                                          break b;
                                                                        case 1:
                                                                        case 2:
                                                                        case 3:
                                                                        case 4:
                                                                        case 5:
                                                                        case 6:
                                                                        case 7:
                                                                        case 8:
                                                                        case 10:
                                                                        case 16:
                                                                        case 18:
                                                                        case 19:
                                                                        case 20:
                                                                        case 21:
                                                                        case 25:
                                                                        case 26:
                                                                        case 28:
                                                                        case 30:
                                                                        case 31:
                                                                          break a;
                                                                        default:
                                                                          break h;
                                                                      }
                                                                    h:
                                                                      switch (g - 65 | 0) {
                                                                        case 0:
                                                                        case 4:
                                                                        case 5:
                                                                        case 6:
                                                                          break d;
                                                                        case 2:
                                                                          break g;
                                                                        case 1:
                                                                        case 3:
                                                                          break a;
                                                                        default:
                                                                          break h;
                                                                      }
                                                                    if ((g | 0) == 83)
                                                                      break A;
                                                                    break a;
                                                                  }
                                                                  S = e[G + 64 >> 2], Fe = e[G + 68 >> 2], g = 1212;
                                                                  break k;
                                                                }
                                                                g = 0;
                                                                w:
                                                                  switch (gi & 255) {
                                                                    case 0:
                                                                      e[e[G + 64 >> 2] >> 2] = Mn;
                                                                      continue i;
                                                                    case 1:
                                                                      e[e[G + 64 >> 2] >> 2] = Mn;
                                                                      continue i;
                                                                    case 2:
                                                                      S = e[G + 64 >> 2], e[S >> 2] = Mn, e[S + 4 >> 2] = Mn >> 31;
                                                                      continue i;
                                                                    case 3:
                                                                      Vs[e[G + 64 >> 2] >> 1] = Mn;
                                                                      continue i;
                                                                    case 4:
                                                                      $[e[G + 64 >> 2]] = Mn;
                                                                      continue i;
                                                                    case 6:
                                                                      e[e[G + 64 >> 2] >> 2] = Mn;
                                                                      continue i;
                                                                    case 7:
                                                                      break w;
                                                                    default:
                                                                      continue i;
                                                                  }
                                                                S = e[G + 64 >> 2], e[S >> 2] = Mn, e[S + 4 >> 2] = Mn >> 31;
                                                                continue i;
                                                              }
                                                              ke = ke >>> 0 <= 8 ? 8 : ke, Tr = Tr | 8, g = 120;
                                                            }
                                                            if (Ar = ei, Ji = g & 32, S = e[G + 64 >> 2], Fe = e[G + 68 >> 2], S | Fe)
                                                              for (; Ar = Ar - 1 | 0, $[Ar | 0] = Ji | ye[(S & 15) + 7488 | 0], gi = !Fe & S >>> 0 > 15 | (Fe | 0) != 0, S = (Fe & 15) << 28 | S >>> 4, Fe = Fe >>> 4 | 0, !!gi; )
                                                                ;
                                                            if (!(e[G + 64 >> 2] | e[G + 68 >> 2]) | !(Tr & 8))
                                                              break I;
                                                            ss = (g >>> 4 | 0) + 1212 | 0, Rn = 2;
                                                            break I;
                                                          }
                                                          if (g = ei, Ar = e[G + 68 >> 2], Fe = Ar, S = e[G + 64 >> 2], Ar | S)
                                                            for (; g = g - 1 | 0, $[g | 0] = S & 7 | 48, gi = !Fe & S >>> 0 > 7 | (Fe | 0) != 0, S = (Fe & 7) << 29 | S >>> 3, Fe = Fe >>> 3 | 0, !!gi; )
                                                              ;
                                                          if (Ar = g, !(Tr & 8))
                                                            break I;
                                                          g = ei - g | 0, ke = (g | 0) < (ke | 0) ? ke : g + 1 | 0;
                                                          break I;
                                                        }
                                                        if (S = e[G + 64 >> 2], g = e[G + 68 >> 2], Fe = g, (g | 0) < 0) {
                                                          Ar = 0 - (g + ((S | 0) != 0) | 0) | 0, Fe = Ar, S = 0 - S | 0, e[G + 64 >> 2] = S, e[G + 68 >> 2] = Ar, Rn = 1, g = 1212;
                                                          break k;
                                                        }
                                                        if (Tr & 2048) {
                                                          Rn = 1, g = 1213;
                                                          break k;
                                                        }
                                                        Rn = Tr & 1, g = Rn ? 1214 : 1212;
                                                      }
                                                      ss = g, Ar = qc(S, Fe, ei);
                                                    }
                                                    if ((ke | 0) < 0 && Qi)
                                                      break r;
                                                    if (Tr = Qi ? Tr & -65537 : Tr, g = e[G + 64 >> 2], S = e[G + 68 >> 2], !(ke | (g | S) != 0)) {
                                                      Ar = ei, ke = 0;
                                                      break a;
                                                    }
                                                    g = !(g | S) + (ei - Ar | 0) | 0, ke = (g | 0) < (ke | 0) ? ke : g;
                                                    break a;
                                                  }
                                                  if (g = e[G + 64 >> 2], Ar = g || 4806, g = Ar, hr = ke >>> 0 >= 2147483647 ? 2147483647 : ke, Fe = nu(g, 0, hr), g = Fe ? Fe - g | 0 : hr, hr = g + Ar | 0, (ke | 0) >= 0) {
                                                    Tr = S, ke = g;
                                                    break a;
                                                  }
                                                  if (Tr = S, ke = g, ye[hr | 0])
                                                    break r;
                                                  break a;
                                                }
                                                if (ke) {
                                                  S = e[G + 64 >> 2];
                                                  break u;
                                                }
                                                g = 0, ua(r, 32, ln, 0, Tr);
                                                break c;
                                              }
                                              e[G + 12 >> 2] = 0, e[G + 8 >> 2] = e[G + 64 >> 2], S = G + 8 | 0, e[G + 64 >> 2] = S, ke = -1;
                                            }
                                            g = 0;
                                            u: {
                                              for (; ; ) {
                                                if (Ar = e[S >> 2], !Ar)
                                                  break u;
                                                if (Ar = Y4(G + 4 | 0, Ar), hr = (Ar | 0) < 0, !(hr | Ar >>> 0 > ke - g >>> 0)) {
                                                  if (S = S + 4 | 0, g = g + Ar | 0, ke >>> 0 > g >>> 0)
                                                    continue;
                                                  break u;
                                                }
                                                break;
                                              }
                                              if (hr)
                                                break e;
                                            }
                                            if (Fe = 61, (g | 0) < 0)
                                              break t;
                                            if (ua(r, 32, ln, g, Tr), !g) {
                                              g = 0;
                                              break c;
                                            }
                                            for (hr = 0, S = e[G + 64 >> 2]; ; ) {
                                              if (Ar = e[S >> 2], !Ar || (Fe = G + 4 | 0, Ar = Y4(Fe, Ar), hr = Ar + hr | 0, hr >>> 0 > g >>> 0))
                                                break c;
                                              if (Aa(r, Fe, Ar), S = S + 4 | 0, !(g >>> 0 > hr >>> 0))
                                                break;
                                            }
                                          }
                                          ua(r, 32, ln, g, Tr ^ 8192), g = (g | 0) < (ln | 0) ? ln : g;
                                          continue i;
                                        }
                                        if ((ke | 0) < 0 && Qi)
                                          break r;
                                        if (Fe = 61, g = Nl(r, Fi[G + 64 >> 3], ln, ke, Tr, g), (g | 0) >= 0)
                                          continue i;
                                        break t;
                                      }
                                      $[G + 55 | 0] = e[G + 64 >> 2], ke = 1, Ar = Rs, Tr = S;
                                      break a;
                                    }
                                    S = ye[g + 1 | 0], g = g + 1 | 0;
                                  }
                                if (Fe = Mn, r)
                                  break e;
                                if (!ci)
                                  break s;
                                for (g = 1; ; ) {
                                  if (r = e[(g << 2) + y >> 2], r) {
                                    if (hf((g << 3) + h | 0, r, c), Fe = 1, g = g + 1 | 0, (g | 0) != 10)
                                      continue;
                                    break e;
                                  }
                                  break;
                                }
                                if (Fe = 1, g >>> 0 >= 10)
                                  break e;
                                for (; ; ) {
                                  if (e[(g << 2) + y >> 2])
                                    break o;
                                  if (g = g + 1 | 0, (g | 0) == 10)
                                    break;
                                }
                                break e;
                              }
                              Fe = 28;
                              break t;
                            }
                            if (hr = hr - Ar | 0, ke = (ke | 0) > (hr | 0) ? ke : hr, (ke | 0) > (Rn ^ 2147483647))
                              break r;
                            if (Fe = 61, S = ke + Rn | 0, g = (S | 0) < (ln | 0) ? ln : S, (As | 0) < (g | 0))
                              break t;
                            ua(r, 32, g, S, Tr), Aa(r, ss, Rn), ua(r, 48, g, S, Tr ^ 65536), ua(r, 48, ke, hr, 0), Aa(r, Ar, hr), ua(r, 32, g, S, Tr ^ 8192);
                            continue;
                          }
                          break;
                        }
                        break;
                      }
                      Fe = 0;
                      break e;
                    }
                    Fe = 61;
                  }
                  e[5732] = Fe, Fe = -1;
                }
                return Yr = G + 80 | 0, Fe;
              }
              function j1(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0, y = 0, g = 0;
                e: {
                  if (r >>> 0 <= 211) {
                    h = e[zh(7504, 7696, r) >> 2];
                    break e;
                  }
                  for (r >>> 0 >= 4294967292 && (r = ru(8), e[5996] = 0, h = ii(167, r | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) != 1 && (xa(h | 0, 22716, 92), ri()), h = Vr() | 0, Ku(r), Ki(h | 0), ri()), g = (r >>> 0) / 210 | 0, h = vi(g, 210), y = zh(7696, 7888, r - h | 0) - 7696 >> 2; ; ) {
                    for (h = e[(y << 2) + 7696 >> 2] + h | 0, r = 5; ; ) {
                      t: {
                        if ((r | 0) == 47) {
                          for (r = 211; ; ) {
                            if (o = (h >>> 0) / (r >>> 0) | 0, o >>> 0 < r >>> 0)
                              break e;
                            if ((vi(r, o) | 0) == (h | 0))
                              break t;
                            if (o = r + 10 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 12 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 16 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 18 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 22 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 28 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 30 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 36 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 40 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 42 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 46 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 52 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 58 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 60 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 66 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 70 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 72 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 78 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 82 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 88 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 96 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 100 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 102 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 106 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 108 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 112 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 120 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 126 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 130 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 136 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 138 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 142 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 148 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 150 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 156 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 162 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 166 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 168 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 172 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 178 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 180 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 186 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 190 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 192 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 196 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 198 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if ((vi(o, c) | 0) == (h | 0))
                              break t;
                            if (o = r + 208 | 0, c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                              break e;
                            if (r = r + 210 | 0, (vi(o, c) | 0) == (h | 0))
                              break;
                          }
                          break t;
                        }
                        if (o = e[(r << 2) + 7504 >> 2], c = (h >>> 0) / (o >>> 0) | 0, o >>> 0 > c >>> 0)
                          break e;
                        if (r = r + 1 | 0, (vi(o, c) | 0) != (h | 0))
                          continue;
                      }
                      break;
                    }
                    h = y + 1 | 0, r = (h | 0) == 48, y = r ? 0 : h, g = r + g | 0, h = vi(g, 210);
                  }
                }
                return h | 0;
              }
              function To(r, o, c, h, y, g, S, G, ke) {
                var Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0, Qi = 0, Ji = 0, ss = 0, As = 0, Rs = 0, oo = 0, Go = 0, Jo = 0, ta = 0, sa = 0, Ea = 0, Wa = 0, qu = 0, Vu = 0, fc = 0, Ec = 0, Yc = 0, Xc = 0, _c = 0, qf = 0, Of = 0, Qf = 0, p4 = 0, y4 = 0;
                Ar = Yr - 96 | 0, Yr = Ar, Ji = ke & 65535, Rn = (y ^ ke) & -2147483648, ci = y & 65535, oo = ci, p4 = ke >>> 16 & 32767, y4 = y >>> 16 & 32767;
                e: {
                  t: {
                    if (p4 - 32767 >>> 0 > 4294934529 & y4 - 32767 >>> 0 >= 4294934530)
                      break t;
                    if (gi = y & 2147483647, ei = gi, Fe = h, !(!h & (ei | 0) == 2147418112 ? !(o | c) : ei >>> 0 < 2147418112)) {
                      Tr = h, Rn = y | 32768;
                      break e;
                    }
                    if (gi = ke & 2147483647, Mn = gi, y = G, !(!y & (Mn | 0) == 2147418112 ? !(g | S) : Mn >>> 0 < 2147418112)) {
                      Tr = y, Rn = ke | 32768, o = g, c = S;
                      break e;
                    }
                    if (!(o | Fe | (ei ^ 2147418112 | c))) {
                      if (!(y | g | (S | Mn))) {
                        Rn = 2147450880, o = 0, c = 0;
                        break e;
                      }
                      Rn = Rn | 2147418112, o = 0, c = 0;
                      break e;
                    }
                    if (!(y | g | (Mn ^ 2147418112 | S))) {
                      if (y = o | Fe, h = c | ei, o = 0, c = 0, !(h | y)) {
                        Rn = 2147450880;
                        break e;
                      }
                      Rn = Rn | 2147418112;
                      break e;
                    }
                    if (!(o | Fe | (c | ei))) {
                      o = 0, c = 0;
                      break e;
                    }
                    if (!(y | g | (S | Mn))) {
                      o = 0, c = 0;
                      break e;
                    }
                    if ((ei | 0) == 65535 | ei >>> 0 < 65535 && (Fe = !(h | ci), ke = Fe ? o : h, gi = Fe << 6, y = Do(ke) + 32 | 0, ke = Do(Fe ? c : ci), ke = gi + ((ke | 0) == 32 ? y : ke) | 0, ha(Ar + 80 | 0, o, c, h, ci, ke - 15 | 0), Qi = 16 - ke | 0, h = e[Ar + 88 >> 2], oo = e[Ar + 92 >> 2], c = e[Ar + 84 >> 2], o = e[Ar + 80 >> 2]), Mn >>> 0 > 65535)
                      break t;
                    ke = !(G | Ji), y = ke ? g : G, ci = ke << 6, Fe = Do(y) + 32 | 0, y = Do(ke ? S : Ji), y = ci + ((y | 0) == 32 ? Fe : y) | 0, ha(Ar - -64 | 0, g, S, G, Ji, y - 15 | 0), Qi = (Qi - y | 0) + 16 | 0, G = e[Ar + 72 >> 2], Ji = e[Ar + 76 >> 2], g = e[Ar + 64 >> 2], S = e[Ar + 68 >> 2];
                  }
                  y = g, g = S << 15 | g >>> 17, ke = y << 15, y = 0, ss = ke & -32768, Yc = c, gi = so(ss, y, c, 0), y = vs, Go = y, Xc = g, ei = o, c = so(g, 0, o, 0), o = c + gi | 0, g = vs + y | 0, ke = o, c = o >>> 0 < c >>> 0 ? g + 1 | 0 : g, g = o, Fe = 0, o = so(ei, hr, ss, hr), Mn = Fe + o | 0, y = vs + g | 0, y = o >>> 0 > Mn >>> 0 ? y + 1 | 0 : y, ci = y, _c = (g | 0) == (y | 0) & Fe >>> 0 > Mn >>> 0 | y >>> 0 < g >>> 0, qf = h, As = so(ss, hr, h, 0), Of = vs, o = so(Yc, hr, Xc, hr), Rs = o + As | 0, Fe = vs + Of | 0, Fe = o >>> 0 > Rs >>> 0 ? Fe + 1 | 0 : Fe, o = Ji << 15 | G >>> 17, Jo = G << 15 | S >>> 17, h = so(Jo, 0, ei, hr), ta = h + Rs | 0, g = vs + Fe | 0, g = h >>> 0 > ta >>> 0 ? g + 1 | 0 : g, sa = g, h = (c | 0) == (Go | 0) & ke >>> 0 < gi >>> 0 | c >>> 0 < Go >>> 0, Ea = c + ta | 0, g = h + g | 0, g = c >>> 0 > Ea >>> 0 ? g + 1 | 0 : g, Ji = g, S = Ea, c = g, Wa = oo | 65536, oo = so(ss, hr, Wa, ln), Qf = vs, h = so(qf, Tr, Xc, hr), qu = h + oo | 0, y = vs + Qf | 0, y = h >>> 0 > qu >>> 0 ? y + 1 | 0 : y, ke = y, Vu = o | -2147483648, o = so(Vu, 0, ei, hr), fc = o + qu | 0, g = vs + y | 0, g = o >>> 0 > fc >>> 0 ? g + 1 | 0 : g, h = so(Jo, Tr, Yc, hr), o = h + fc | 0, Ec = g, g = g + vs | 0, Go = o, gi = o >>> 0 < h >>> 0 ? g + 1 | 0 : g, g = o, o = 0, ei = o + S | 0, y = c + g | 0, y = o >>> 0 > ei >>> 0 ? y + 1 | 0 : y, ss = y, g = y, o = ei + _c | 0, c = o >>> 0 < ei >>> 0 ? g + 1 | 0 : g, Qi = ((y4 + p4 | 0) + Qi | 0) - 16383 | 0, h = so(Vu, Tr, Yc, hr), G = vs, y = so(Wa, Tr, Xc, hr), S = y + h | 0, g = vs + G | 0, g = y >>> 0 > S >>> 0 ? g + 1 | 0 : g, ln = (G | 0) == (g | 0) & h >>> 0 > S >>> 0 | g >>> 0 < G >>> 0, G = g, y = so(Jo, Tr, qf, Tr), h = y + S | 0, g = vs + g | 0, g = h >>> 0 < y >>> 0 ? g + 1 | 0 : g, y = g, S = (g | 0) == (G | 0) & h >>> 0 < S >>> 0 | g >>> 0 < G >>> 0, g = 0, G = S, S = S + ln | 0, g = G >>> 0 > S >>> 0 ? 1 : g, G = S, S = so(Vu, Tr, Wa, Tr), G = G + S | 0, g = vs + g | 0, _c = G, S = S >>> 0 > G >>> 0 ? g + 1 | 0 : g, G = h, hr = y, y = (Fe | 0) == (Of | 0) & As >>> 0 > Rs >>> 0 | Fe >>> 0 < Of >>> 0, g = 0, Fe = (Fe | 0) == (sa | 0) & Rs >>> 0 > ta >>> 0 | Fe >>> 0 > sa >>> 0, ln = Fe, Fe = y + Fe | 0, y = (ln >>> 0 > Fe >>> 0 ? 1 : g) + hr | 0, g = S, h = h + Fe | 0, y = h >>> 0 < Fe >>> 0 ? y + 1 | 0 : y, ln = y, As = h, h = (y | 0) == (hr | 0) & h >>> 0 < G >>> 0 | y >>> 0 < hr >>> 0, y = h, h = h + _c | 0, g = y >>> 0 > h >>> 0 ? g + 1 | 0 : g, Fe = h, G = g, y = so(Jo, Tr, Wa, Tr), hr = vs, S = so(Vu, Tr, qf, Tr), h = S + y | 0, g = vs + hr | 0, g = h >>> 0 < S >>> 0 ? g + 1 | 0 : g, S = g, g = (hr | 0) == (g | 0) & h >>> 0 < y >>> 0 | g >>> 0 < hr >>> 0, Rs = S + Fe | 0, y = g + G | 0, y = S >>> 0 > Rs >>> 0 ? y + 1 | 0 : y, hr = Rs, G = y, Fe = h, y = 0, h = y + As | 0, g = Fe + ln | 0, g = h >>> 0 < y >>> 0 ? g + 1 | 0 : g, y = g, S = (ln | 0) == (g | 0) & h >>> 0 < As >>> 0 | g >>> 0 < ln >>> 0, g = G, G = S, S = S + hr | 0, g = G >>> 0 > S >>> 0 ? g + 1 | 0 : g, As = S, S = g, G = h, Fe = y, y = (gi | 0) == (Ec | 0) & Go >>> 0 < fc >>> 0 | gi >>> 0 < Ec >>> 0, h = (ke | 0) == (Qf | 0) & oo >>> 0 > qu >>> 0 | ke >>> 0 < Qf >>> 0, ke = (ke | 0) == (Ec | 0) & qu >>> 0 > fc >>> 0 | ke >>> 0 > Ec >>> 0, h = h + ke | 0, h = h + y | 0, ln = gi, ke = ln + G | 0, y = h + Fe | 0, g = S, h = ke, y = h >>> 0 < ln >>> 0 ? y + 1 | 0 : y, G = (y | 0) == (Fe | 0) & G >>> 0 > h >>> 0 | y >>> 0 < Fe >>> 0, S = G + As | 0, g = G >>> 0 > S >>> 0 ? g + 1 | 0 : g, Fe = S, S = g, G = h, g = 0, ke = y, ln = (Ji | 0) == (ss | 0) & ei >>> 0 < Ea >>> 0 | Ji >>> 0 > ss >>> 0, hr = ln, ln = ln + ((Ji | 0) == (sa | 0) & ta >>> 0 > Ea >>> 0 | Ji >>> 0 < sa >>> 0) | 0, y = y + (hr >>> 0 > ln >>> 0 ? 1 : g) | 0, g = S, h = h + ln | 0, y = h >>> 0 < ln >>> 0 ? y + 1 | 0 : y, G = (y | 0) == (ke | 0) & h >>> 0 < G >>> 0 | y >>> 0 < ke >>> 0, S = G, G = G + Fe | 0, g = S >>> 0 > G >>> 0 ? g + 1 | 0 : g, ke = g;
                  t: {
                    if (g & 65536) {
                      Qi = Qi + 1 | 0;
                      break t;
                    }
                    Fe = ci >>> 31 | 0, S = 0, g = ke << 1 | G >>> 31, G = G << 1 | y >>> 31, ke = g, g = y << 1 | h >>> 31, h = h << 1 | c >>> 31, y = g, g = ci << 1 | Mn >>> 31, Mn = Mn << 1, ci = g, g = c << 1 | o >>> 31, o = o << 1 | Fe, c = g | S;
                  }
                  if ((Qi | 0) >= 32767) {
                    Rn = Rn | 2147418112, o = 0, c = 0;
                    break e;
                  }
                  t: {
                    if ((Qi | 0) <= 0) {
                      if (S = 1 - Qi | 0, S >>> 0 <= 127) {
                        g = Qi + 127 | 0, ha(Ar + 48 | 0, Mn, ci, o, c, g), ha(Ar + 32 | 0, h, y, G, ke, g), Ac(Ar + 16 | 0, Mn, ci, o, c, S), Ac(Ar, h, y, G, ke, S), Mn = e[Ar + 32 >> 2] | e[Ar + 16 >> 2] | (e[Ar + 48 >> 2] | e[Ar + 56 >> 2] | (e[Ar + 52 >> 2] | e[Ar + 60 >> 2])) != 0, ci = e[Ar + 36 >> 2] | e[Ar + 20 >> 2], o = e[Ar + 40 >> 2] | e[Ar + 24 >> 2], c = e[Ar + 44 >> 2] | e[Ar + 28 >> 2], h = e[Ar >> 2], y = e[Ar + 4 >> 2], S = e[Ar + 8 >> 2], g = e[Ar + 12 >> 2];
                        break t;
                      }
                      o = 0, c = 0;
                      break e;
                    }
                    S = G, g = ke & 65535 | Qi << 16;
                  }
                  if (Tr = S | Tr, Rn = g | Rn, !(!o & (c | 0) == -2147483648 ? !(Mn | ci) : (c | 0) > 0 | (c | 0) >= 0)) {
                    o = h + 1 | 0, Fe = o ? y : y + 1 | 0, y = Rn, c = Fe, h = !(Fe | o), Tr = h + Tr | 0, Rn = h >>> 0 > Tr >>> 0 ? y + 1 | 0 : y;
                    break e;
                  }
                  if (o | Mn | (c ^ -2147483648 | ci)) {
                    o = h, c = y;
                    break e;
                  }
                  g = y, o = h & 1, c = o, o = o + h | 0, c = c >>> 0 > o >>> 0 ? g + 1 | 0 : g, h = (g | 0) == (c | 0) & o >>> 0 < h >>> 0 | c >>> 0 < g >>> 0, g = Rn, Tr = h + Tr | 0, Rn = Tr >>> 0 < h >>> 0 ? g + 1 | 0 : g;
                }
                e[r >> 2] = o, e[r + 4 >> 2] = c, e[r + 8 >> 2] = Tr, e[r + 12 >> 2] = Rn, Yr = Ar + 96 | 0;
              }
              function ql() {
                var r = 0, o = 0, c = 0;
                if (ye[25020])
                  return e[6254];
                e[6663] = 0, e[6662] = 22008, e[6662] = 14144, e[6662] = 12664, r = Yr - 16 | 0, Yr = r, e[6664] = 0, e[6665] = 0, e[6666] = 0, $[26792] = 0, e[r + 4 >> 2] = 26656, c = e[r + 4 >> 2], o = r + 8 | 0, $[o + 4 | 0] = 0, e[o >> 2] = c, e[5996] = 0, ko(273, 26656), c = e[5996], e[5996] = 0;
                e: {
                  if ((c | 0) != 1) {
                    bd(26656, 30), $[o + 4 | 0] = 1, s6(o), Yr = r + 16 | 0;
                    break e;
                  }
                  o = Vr() | 0, s6(r + 8 | 0), Ki(o | 0), ri();
                }
                e[5996] = 0, o = On(30, 26800, 3538) | 0, r = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((r | 0) != 1) {
                        if (A6(26656), e[6581] = 0, e[6580] = 22008, e[6580] = 14144, e[6580] = 15252, e[5996] = 0, ko(240, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[6583] = 0, e[6582] = 22008, e[6582] = 14144, e[6582] = 15284, e[5996] = 0, ko(241, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6585] = 0, e[6584] = 22008, e[6584] = 14144, $[26348] = 0, e[6586] = 0, e[6584] = 12684, e[6586] = 12736, e[5996] = 0, ko(242, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6589] = 0, e[6588] = 22008, e[6588] = 14144, e[6588] = 14200, e[5996] = 0, ko(243, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6591] = 0, e[6590] = 22008, e[6590] = 14144, e[6590] = 14348, e[5996] = 0, ko(244, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Ri(245), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, ko(246, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6597] = 0, e[6596] = 22008, e[6596] = 14144, e[6596] = 14496, e[5996] = 0, ko(247, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6599] = 0, e[6598] = 22008, e[6598] = 14144, e[6598] = 14728, e[5996] = 0, ko(248, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6601] = 0, e[6600] = 22008, e[6600] = 14144, e[6600] = 14612, e[5996] = 0, ko(249, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6603] = 0, e[6602] = 22008, e[6602] = 14144, e[6602] = 14844, e[5996] = 0, ko(250, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6605] = 0, e[6604] = 22008, e[6604] = 14144, Vs[13212] = 11310, e[6604] = 13816, e[6607] = 0, e[6608] = 0, e[6609] = 0, e[5996] = 0, ko(251, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6611] = 0, e[6610] = 22008, e[6610] = 14144, e[6612] = 46, e[6613] = 44, e[6610] = 13856, e[6614] = 0, e[6615] = 0, e[6616] = 0, e[5996] = 0, ko(252, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6619] = 0, e[6618] = 22008, e[6618] = 14144, e[6618] = 15316, e[5996] = 0, ko(253, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6621] = 0, e[6620] = 22008, e[6620] = 14144, e[6620] = 15560, e[5996] = 0, ko(254, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6623] = 0, e[6622] = 22008, e[6622] = 14144, e[6622] = 15772, e[5996] = 0, ko(255, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6625] = 0, e[6624] = 22008, e[6624] = 14144, e[6624] = 16004, e[5996] = 0, ko(256, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6627] = 0, e[6626] = 22008, e[6626] = 14144, e[6626] = 16988, e[5996] = 0, ko(257, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6629] = 0, e[6628] = 22008, e[6628] = 14144, e[6628] = 17136, e[5996] = 0, ko(258, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6631] = 0, e[6630] = 22008, e[6630] = 14144, e[6630] = 17252, e[5996] = 0, ko(259, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6633] = 0, e[6632] = 22008, e[6632] = 14144, e[6632] = 17368, e[5996] = 0, ko(260, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6635] = 0, e[6634] = 22008, e[6634] = 14144, e[6634] = 17484, e[5996] = 0, ko(261, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6637] = 0, e[6636] = 22008, e[6636] = 14144, e[6636] = 17648, e[5996] = 0, ko(262, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6639] = 0, e[6638] = 22008, e[6638] = 14144, e[6638] = 17812, e[5996] = 0, ko(263, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6641] = 0, e[6640] = 22008, e[6640] = 14144, e[6640] = 17976, e[5996] = 0, ko(264, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6643] = 0, e[6642] = 22008, e[6642] = 14144, e[6644] = 19232, e[6644] = 16252, e[6642] = 16204, e[5996] = 0, ko(265, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6647] = 0, e[6646] = 22008, e[6646] = 14144, e[6648] = 19268, e[6648] = 16516, e[6646] = 16468, e[5996] = 0, ko(266, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Ri(267), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, ko(268, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Ri(269), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, ko(270, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6659] = 0, e[6658] = 22008, e[6658] = 14144, e[6658] = 18140, e[5996] = 0, ko(271, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6661] = 0, e[6660] = 22008, e[6660] = 14144, e[6660] = 18260, e[5996] = 0, ko(272, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1))
                          break r;
                        break e;
                      }
                      r = Vr() | 0;
                      break t;
                    }
                    r = Vr() | 0, qi(o);
                  }
                  Ko(26656), Ki(r | 0), ri();
                }
                return e[6253] = 26648, $[25020] = 1, e[6254] = 25012, 25012;
              }
              function Xd(r, o, c, h, y, g, S, G) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, G = G | 0;
                var ke = 0, Fe = 0, Ar = 0;
                G = Yr - 48 | 0, Yr = G, e[G + 44 >> 2] = o, e[y >> 2] = 0, ke = e[h + 28 >> 2], e[G >> 2] = ke, e[ke + 4 >> 2] = e[ke + 4 >> 2] + 1, e[5996] = 0, ke = ii(197, e[G >> 2]) | 0, Fe = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  f: {
                                    d: {
                                      c: {
                                        u: {
                                          g: {
                                            A: {
                                              p: {
                                                I: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              b: {
                                                                h: {
                                                                  x: {
                                                                    m: {
                                                                      if ((Fe | 0) != 1)
                                                                        switch (Fe = e[G >> 2], Ar = e[Fe + 4 >> 2] - 1 | 0, e[Fe + 4 >> 2] = Ar, (Ar | 0) == -1 && _n[e[e[Fe >> 2] + 8 >> 2]](Fe), S - 65 | 0) {
                                                                          case 54:
                                                                            break f;
                                                                          case 19:
                                                                            break d;
                                                                          case 18:
                                                                            break c;
                                                                          case 17:
                                                                            break u;
                                                                          case 49:
                                                                            break g;
                                                                          case 47:
                                                                            break A;
                                                                          case 45:
                                                                          case 51:
                                                                            break p;
                                                                          case 12:
                                                                            break I;
                                                                          case 44:
                                                                            break k;
                                                                          case 41:
                                                                            break N;
                                                                          case 8:
                                                                            break S;
                                                                          case 7:
                                                                            break T;
                                                                          case 5:
                                                                            break v;
                                                                          case 3:
                                                                            break w;
                                                                          case 35:
                                                                          case 36:
                                                                            break b;
                                                                          case 34:
                                                                            break h;
                                                                          case 1:
                                                                          case 33:
                                                                          case 39:
                                                                            break x;
                                                                          case 0:
                                                                          case 32:
                                                                            break m;
                                                                          case 2:
                                                                          case 4:
                                                                          case 6:
                                                                          case 9:
                                                                          case 10:
                                                                          case 11:
                                                                          case 13:
                                                                          case 14:
                                                                          case 15:
                                                                          case 16:
                                                                          case 20:
                                                                          case 21:
                                                                          case 22:
                                                                          case 25:
                                                                          case 26:
                                                                          case 27:
                                                                          case 28:
                                                                          case 29:
                                                                          case 30:
                                                                          case 31:
                                                                          case 37:
                                                                          case 38:
                                                                          case 40:
                                                                          case 42:
                                                                          case 43:
                                                                          case 46:
                                                                          case 48:
                                                                          case 50:
                                                                          case 52:
                                                                          case 53:
                                                                            break n;
                                                                          case 24:
                                                                            break s;
                                                                          case 56:
                                                                            break a;
                                                                          case 23:
                                                                            break o;
                                                                          case 55:
                                                                            break l;
                                                                          default:
                                                                            break i;
                                                                        }
                                                                      c = Vr() | 0, r = e[G >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
                                                                    }
                                                                    n1(r, g + 24 | 0, G + 44 | 0, c, y, ke);
                                                                    break t;
                                                                  }
                                                                  e1(r, g + 16 | 0, G + 44 | 0, c, y, ke);
                                                                  break t;
                                                                }
                                                                S = _n[e[e[r + 8 >> 2] + 12 >> 2]](r + 8 | 0) | 0, ke = ye[S + 11 | 0], Fe = r, Ar = o, o = (ke & 128) >>> 7 | 0, r = o ? e[S >> 2] : S, e[G + 44 >> 2] = Mu(Fe, Ar, c, h, y, g, r, r + ((o ? e[S + 4 >> 2] : ke & 127) << 2) | 0);
                                                                break t;
                                                              }
                                                              r = cu(G + 44 | 0, c, y, ke, 2), o = e[y >> 2];
                                                              b: {
                                                                if (!(r - 1 >>> 0 > 30 | o & 4)) {
                                                                  e[g + 12 >> 2] = r;
                                                                  break b;
                                                                }
                                                                e[y >> 2] = o | 4;
                                                              }
                                                              break t;
                                                            }
                                                            S = e[3127], e[G + 24 >> 2] = e[3126], e[G + 28 >> 2] = S, S = e[3125], e[G + 16 >> 2] = e[3124], e[G + 20 >> 2] = S, S = e[3123], e[G + 8 >> 2] = e[3122], e[G + 12 >> 2] = S, S = e[3121], e[G >> 2] = e[3120], e[G + 4 >> 2] = S, e[G + 44 >> 2] = Mu(r, o, c, h, y, g, G, G + 32 | 0);
                                                            break t;
                                                          }
                                                          S = e[3135], e[G + 24 >> 2] = e[3134], e[G + 28 >> 2] = S, S = e[3133], e[G + 16 >> 2] = e[3132], e[G + 20 >> 2] = S, S = e[3131], e[G + 8 >> 2] = e[3130], e[G + 12 >> 2] = S, S = e[3129], e[G >> 2] = e[3128], e[G + 4 >> 2] = S, e[G + 44 >> 2] = Mu(r, o, c, h, y, g, G, G + 32 | 0);
                                                          break t;
                                                        }
                                                        r = cu(G + 44 | 0, c, y, ke, 2), o = e[y >> 2];
                                                        T: {
                                                          if (!((r | 0) > 23 | o & 4)) {
                                                            e[g + 8 >> 2] = r;
                                                            break T;
                                                          }
                                                          e[y >> 2] = o | 4;
                                                        }
                                                        break t;
                                                      }
                                                      r = cu(G + 44 | 0, c, y, ke, 2), o = e[y >> 2];
                                                      S: {
                                                        if (!(r - 1 >>> 0 > 11 | o & 4)) {
                                                          e[g + 8 >> 2] = r;
                                                          break S;
                                                        }
                                                        e[y >> 2] = o | 4;
                                                      }
                                                      break t;
                                                    }
                                                    r = cu(G + 44 | 0, c, y, ke, 3), o = e[y >> 2];
                                                    N: {
                                                      if (!((r | 0) > 365 | o & 4)) {
                                                        e[g + 28 >> 2] = r;
                                                        break N;
                                                      }
                                                      e[y >> 2] = o | 4;
                                                    }
                                                    break t;
                                                  }
                                                  o = cu(G + 44 | 0, c, y, ke, 2) - 1 | 0, r = e[y >> 2];
                                                  k: {
                                                    if (!(o >>> 0 > 11 | r & 4)) {
                                                      e[g + 16 >> 2] = o;
                                                      break k;
                                                    }
                                                    e[y >> 2] = r | 4;
                                                  }
                                                  break t;
                                                }
                                                r = cu(G + 44 | 0, c, y, ke, 2), o = e[y >> 2];
                                                I: {
                                                  if (!((r | 0) > 59 | o & 4)) {
                                                    e[g + 4 >> 2] = r;
                                                    break I;
                                                  }
                                                  e[y >> 2] = o | 4;
                                                }
                                                break t;
                                              }
                                              for (r = G + 44 | 0, o = Yr - 16 | 0, Yr = o, e[o + 12 >> 2] = c; ; ) {
                                                p: {
                                                  if (Pu(r, o + 12 | 0))
                                                    break p;
                                                  c = e[r >> 2], h = e[c + 12 >> 2];
                                                  I: {
                                                    if ((h | 0) == e[c + 16 >> 2]) {
                                                      c = _n[e[e[c >> 2] + 36 >> 2]](c) | 0;
                                                      break I;
                                                    }
                                                    c = e[h >> 2];
                                                  }
                                                  if (!(_n[e[e[ke >> 2] + 12 >> 2]](ke, 1, c) | 0))
                                                    break p;
                                                  Bl(r);
                                                  continue;
                                                }
                                                break;
                                              }
                                              Pu(r, o + 12 | 0) && (e[y >> 2] = e[y >> 2] | 2), Yr = o + 16 | 0;
                                              break t;
                                            }
                                            h = G + 44 | 0, r = _n[e[e[r + 8 >> 2] + 8 >> 2]](r + 8 | 0) | 0, o = ye[r + 11 | 0], S = (o & 128) >>> 7 | 0 ? e[r + 4 >> 2] : o & 127, o = ye[r + 23 | 0];
                                            A: {
                                              if ((S | 0) == (0 - ((o & 128) >>> 7 | 0 ? e[r + 16 >> 2] : o & 127) | 0)) {
                                                e[y >> 2] = e[y >> 2] | 4;
                                                break A;
                                              }
                                              if (c = Gf(h, c, r, r + 24 | 0, ke, y, 0), o = e[g + 8 >> 2], !((c | 0) != (r | 0) | (o | 0) != 12)) {
                                                e[g + 8 >> 2] = 0;
                                                break A;
                                              }
                                              (c - r | 0) != 12 | (o | 0) > 11 || (e[g + 8 >> 2] = o + 12);
                                            }
                                            break t;
                                          }
                                          S = _s(G, 12544, 44), e[S + 44 >> 2] = Mu(r, o, c, h, y, g, S, S + 44 | 0);
                                          break t;
                                        }
                                        e[G + 16 >> 2] = e[3152], S = e[3151], e[G + 8 >> 2] = e[3150], e[G + 12 >> 2] = S, S = e[3149], e[G >> 2] = e[3148], e[G + 4 >> 2] = S, e[G + 44 >> 2] = Mu(r, o, c, h, y, g, G, G + 20 | 0);
                                        break t;
                                      }
                                      r = cu(G + 44 | 0, c, y, ke, 2), o = e[y >> 2];
                                      c: {
                                        if (!((r | 0) > 60 | o & 4)) {
                                          e[g >> 2] = r;
                                          break c;
                                        }
                                        e[y >> 2] = o | 4;
                                      }
                                      break t;
                                    }
                                    S = e[3163], e[G + 24 >> 2] = e[3162], e[G + 28 >> 2] = S, S = e[3161], e[G + 16 >> 2] = e[3160], e[G + 20 >> 2] = S, S = e[3159], e[G + 8 >> 2] = e[3158], e[G + 12 >> 2] = S, S = e[3157], e[G >> 2] = e[3156], e[G + 4 >> 2] = S, e[G + 44 >> 2] = Mu(r, o, c, h, y, g, G, G + 32 | 0);
                                    break t;
                                  }
                                  r = cu(G + 44 | 0, c, y, ke, 1), o = e[y >> 2];
                                  f: {
                                    if (!((r | 0) > 6 | o & 4)) {
                                      e[g + 24 >> 2] = r;
                                      break f;
                                    }
                                    e[y >> 2] = o | 4;
                                  }
                                  break t;
                                }
                                r = _n[e[e[r >> 2] + 20 >> 2]](r, o, c, h, y, g) | 0;
                                break e;
                              }
                              S = _n[e[e[r + 8 >> 2] + 24 >> 2]](r + 8 | 0) | 0, ke = ye[S + 11 | 0], Fe = r, Ar = o, o = (ke & 128) >>> 7 | 0, r = o ? e[S >> 2] : S, e[G + 44 >> 2] = Mu(Fe, Ar, c, h, y, g, r, r + ((o ? e[S + 4 >> 2] : ke & 127) << 2) | 0);
                              break t;
                            }
                            f1(g + 20 | 0, G + 44 | 0, c, y, ke);
                            break t;
                          }
                          r = cu(G + 44 | 0, c, y, ke, 4), ye[y | 0] & 4 || (e[g + 20 >> 2] = r - 1900);
                          break t;
                        }
                        if ((S | 0) == 37)
                          break r;
                      }
                      e[y >> 2] = e[y >> 2] | 4;
                      break t;
                    }
                    r = Yr - 16 | 0, Yr = r, e[r + 12 >> 2] = c, o = 6, h = G + 44 | 0, S = r + 12 | 0;
                    r: {
                      n: {
                        if (Pu(h, S))
                          break n;
                        o = 4, c = e[h >> 2], g = e[c + 12 >> 2];
                        i: {
                          if ((g | 0) == e[c + 16 >> 2]) {
                            c = _n[e[e[c >> 2] + 36 >> 2]](c) | 0;
                            break i;
                          }
                          c = e[g >> 2];
                        }
                        if ((_n[e[e[ke >> 2] + 52 >> 2]](ke, c, 0) | 0) != 37)
                          break n;
                        if (o = 2, !Pu(Bl(h), S))
                          break r;
                      }
                      e[y >> 2] = e[y >> 2] | o;
                    }
                    Yr = r + 16 | 0;
                  }
                  r = e[G + 44 >> 2];
                }
                return Yr = G + 48 | 0, r | 0;
              }
              function V1(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0;
                S = e[o + 4 >> 2] - e[o >> 2] | 0;
                e: {
                  if (S >>> 0 <= 75) {
                    c = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), h = c - 29 | 0, y = c >>> 0 < 29 ? c : h, g = y + 1 | 0, g >>> 0 > (c >>> 0 <= 28 ? 28 : ye[r + 4 | 0] | ye[r + 5 | 0] << 8 | (ye[r + 6 | 0] << 16 | ye[r + 7 | 0] << 24)) >>> 0 && (tu(r, g + (g >>> 1 | 0) | 0), c = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), h = c - 29 | 0), G = c >>> 0 < 29, g = y + (G ? r + 4 | 0 : ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)) | 0, Ks(g + 1 | 0, g, (G ? c : h) - y | 0), c = (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) + 1 | 0, $[r | 0] = c, $[r + 1 | 0] = c >>> 8, $[r + 2 | 0] = c >>> 16, $[r + 3 | 0] = c >>> 24, $[g | 0] = S;
                    break e;
                  }
                  if (S >>> 0 <= 255) {
                    c = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), h = c - 29 | 0, y = c >>> 0 < 29 ? c : h, g = y + 1 | 0, g >>> 0 > (c >>> 0 <= 28 ? 28 : ye[r + 4 | 0] | ye[r + 5 | 0] << 8 | (ye[r + 6 | 0] << 16 | ye[r + 7 | 0] << 24)) >>> 0 && (tu(r, g + (g >>> 1 | 0) | 0), c = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), h = c - 29 | 0), G = r + 4 | 0, S = c >>> 0 < 29, g = y + (S ? G : ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)) | 0, Ks(g + 1 | 0, g, (S ? c : h) - y | 0), c = (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) + 1 | 0, $[r | 0] = c, $[r + 1 | 0] = c >>> 8, $[r + 2 | 0] = c >>> 16, $[r + 3 | 0] = c >>> 24, $[g | 0] = 76, S = e[o + 4 >> 2] - e[o >> 2] | 0, c = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), h = c - 29 | 0, y = c >>> 0 < 29 ? c : h, g = y + 1 | 0, g >>> 0 > (c >>> 0 <= 28 ? 28 : ye[r + 4 | 0] | ye[r + 5 | 0] << 8 | (ye[r + 6 | 0] << 16 | ye[r + 7 | 0] << 24)) >>> 0 && (tu(r, g + (g >>> 1 | 0) | 0), c = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), h = c - 29 | 0), ke = G, G = c >>> 0 < 29, g = y + (G ? ke : ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)) | 0, Ks(g + 1 | 0, g, (G ? c : h) - y | 0), c = (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) + 1 | 0, $[r | 0] = c, $[r + 1 | 0] = c >>> 8, $[r + 2 | 0] = c >>> 16, $[r + 3 | 0] = c >>> 24, $[g | 0] = S;
                    break e;
                  }
                  if (c = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), y = c - 29 | 0, g = c >>> 0 < 29 ? c : y, h = g + 1 | 0, ke = c >>> 0 <= 28 ? 28 : ye[r + 4 | 0] | ye[r + 5 | 0] << 8 | (ye[r + 6 | 0] << 16 | ye[r + 7 | 0] << 24), G = r + 4 | 0, S >>> 0 <= 65535) {
                    h >>> 0 > ke >>> 0 && (tu(r, h + (h >>> 1 | 0) | 0), c = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), y = c - 29 | 0), S = c >>> 0 < 29, h = g + (S ? G : ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)) | 0, Ks(h + 1 | 0, h, (S ? c : y) - g | 0), c = (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) + 1 | 0, $[r | 0] = c, $[r + 1 | 0] = c >>> 8, $[r + 2 | 0] = c >>> 16, $[r + 3 | 0] = c >>> 24, $[h | 0] = 77, g = e[o + 4 >> 2] - e[o >> 2] | 0, c = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), h = c - 29 | 0, S = c >>> 0 < 29 ? c : h, y = S + 2 | 0, y >>> 0 > (c >>> 0 <= 28 ? 28 : ye[r + 4 | 0] | ye[r + 5 | 0] << 8 | (ye[r + 6 | 0] << 16 | ye[r + 7 | 0] << 24)) >>> 0 && (tu(r, y + (y >>> 1 | 0) | 0), c = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), h = c - 29 | 0), ke = G, G = c >>> 0 < 29, y = S + (G ? ke : ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)) | 0, Ks(y + 2 | 0, y, (G ? c : h) - S | 0), c = (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) + 2 | 0, $[r | 0] = c, $[r + 1 | 0] = c >>> 8, $[r + 2 | 0] = c >>> 16, $[r + 3 | 0] = c >>> 24, $[y | 0] = g, $[y + 1 | 0] = g >>> 8;
                    break e;
                  }
                  h >>> 0 > ke >>> 0 && (tu(r, h + (h >>> 1 | 0) | 0), c = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), y = c - 29 | 0), S = c >>> 0 < 29, h = g + (S ? G : ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)) | 0, Ks(h + 1 | 0, h, (S ? c : y) - g | 0), c = (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) + 1 | 0, $[r | 0] = c, $[r + 1 | 0] = c >>> 8, $[r + 2 | 0] = c >>> 16, $[r + 3 | 0] = c >>> 24, $[h | 0] = 78, g = e[o + 4 >> 2] - e[o >> 2] | 0, c = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), h = c - 29 | 0, S = c >>> 0 < 29 ? c : h, y = S + 4 | 0, y >>> 0 > (c >>> 0 <= 28 ? 28 : ye[r + 4 | 0] | ye[r + 5 | 0] << 8 | (ye[r + 6 | 0] << 16 | ye[r + 7 | 0] << 24)) >>> 0 && (tu(r, y + (y >>> 1 | 0) | 0), c = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), h = c - 29 | 0), ke = G, G = c >>> 0 < 29, y = S + (G ? ke : ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)) | 0, Ks(y + 4 | 0, y, (G ? c : h) - S | 0), c = (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) + 4 | 0, $[r | 0] = c, $[r + 1 | 0] = c >>> 8, $[r + 2 | 0] = c >>> 16, $[r + 3 | 0] = c >>> 24, $[y | 0] = g, $[y + 1 | 0] = g >>> 8, $[y + 2 | 0] = g >>> 16, $[y + 3 | 0] = g >>> 24;
                }
                h = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), y = h - 29 | 0, g = e[o + 4 >> 2], o = e[o >> 2], G = g - o | 0, S = h >>> 0 < 29 ? h : y, c = G + S | 0, c >>> 0 > (h >>> 0 <= 28 ? 28 : ye[r + 4 | 0] | ye[r + 5 | 0] << 8 | (ye[r + 6 | 0] << 16 | ye[r + 7 | 0] << 24)) >>> 0 && (tu(r, c + (c >>> 1 | 0) | 0), h = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), y = h - 29 | 0), ke = h >>> 0 < 29, c = S + (ke ? r + 4 | 0 : ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)) | 0, Ks(G + c | 0, c, (ke ? h : y) - S | 0), h = G + (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) | 0, $[r | 0] = h, $[r + 1 | 0] = h >>> 8, $[r + 2 | 0] = h >>> 16, $[r + 3 | 0] = h >>> 24;
                e: {
                  if ((o | 0) == (g | 0))
                    break e;
                  if (y = g + (o ^ -1) | 0, G = G & 7, G)
                    for (h = 0; $[c | 0] = ye[o | 0], o = o + 1 | 0, c = c + 1 | 0, h = h + 1 | 0, (G | 0) != (h | 0); )
                      ;
                  if (y >>> 0 < 7)
                    break e;
                  for (; $[c | 0] = ye[o | 0], $[c + 1 | 0] = ye[o + 1 | 0], $[c + 2 | 0] = ye[o + 2 | 0], $[c + 3 | 0] = ye[o + 3 | 0], $[c + 4 | 0] = ye[o + 4 | 0], $[c + 5 | 0] = ye[o + 5 | 0], $[c + 6 | 0] = ye[o + 6 | 0], $[c + 7 | 0] = ye[o + 7 | 0], c = c + 8 | 0, o = o + 8 | 0, (g | 0) != (o | 0); )
                    ;
                }
                return r | 0;
              }
              function W1(r, o, c, h, y, g, S, G) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, G = G | 0;
                var ke = 0, Fe = 0, Ar = 0;
                G = Yr - 16 | 0, Yr = G, e[G + 12 >> 2] = o, e[y >> 2] = 0, ke = e[h + 28 >> 2], e[G >> 2] = ke, e[ke + 4 >> 2] = e[ke + 4 >> 2] + 1, e[5996] = 0, ke = ii(170, e[G >> 2]) | 0, Fe = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  f: {
                                    d: {
                                      c: {
                                        u: {
                                          g: {
                                            A: {
                                              p: {
                                                I: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              b: {
                                                                h: {
                                                                  x: {
                                                                    m: {
                                                                      if ((Fe | 0) != 1)
                                                                        switch (Fe = e[G >> 2], Ar = e[Fe + 4 >> 2] - 1 | 0, e[Fe + 4 >> 2] = Ar, (Ar | 0) == -1 && _n[e[e[Fe >> 2] + 8 >> 2]](Fe), S - 65 | 0) {
                                                                          case 54:
                                                                            break f;
                                                                          case 19:
                                                                            break d;
                                                                          case 18:
                                                                            break c;
                                                                          case 17:
                                                                            break u;
                                                                          case 49:
                                                                            break g;
                                                                          case 47:
                                                                            break A;
                                                                          case 45:
                                                                          case 51:
                                                                            break p;
                                                                          case 12:
                                                                            break I;
                                                                          case 44:
                                                                            break k;
                                                                          case 41:
                                                                            break N;
                                                                          case 8:
                                                                            break S;
                                                                          case 7:
                                                                            break T;
                                                                          case 5:
                                                                            break v;
                                                                          case 3:
                                                                            break w;
                                                                          case 35:
                                                                          case 36:
                                                                            break b;
                                                                          case 34:
                                                                            break h;
                                                                          case 1:
                                                                          case 33:
                                                                          case 39:
                                                                            break x;
                                                                          case 0:
                                                                          case 32:
                                                                            break m;
                                                                          case 2:
                                                                          case 4:
                                                                          case 6:
                                                                          case 9:
                                                                          case 10:
                                                                          case 11:
                                                                          case 13:
                                                                          case 14:
                                                                          case 15:
                                                                          case 16:
                                                                          case 20:
                                                                          case 21:
                                                                          case 22:
                                                                          case 25:
                                                                          case 26:
                                                                          case 27:
                                                                          case 28:
                                                                          case 29:
                                                                          case 30:
                                                                          case 31:
                                                                          case 37:
                                                                          case 38:
                                                                          case 40:
                                                                          case 42:
                                                                          case 43:
                                                                          case 46:
                                                                          case 48:
                                                                          case 50:
                                                                          case 52:
                                                                          case 53:
                                                                            break n;
                                                                          case 24:
                                                                            break s;
                                                                          case 56:
                                                                            break a;
                                                                          case 23:
                                                                            break o;
                                                                          case 55:
                                                                            break l;
                                                                          default:
                                                                            break i;
                                                                        }
                                                                      c = Vr() | 0, r = e[G >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
                                                                    }
                                                                    r1(r, g + 24 | 0, G + 12 | 0, c, y, ke);
                                                                    break t;
                                                                  }
                                                                  Sd(r, g + 16 | 0, G + 12 | 0, c, y, ke);
                                                                  break t;
                                                                }
                                                                S = _n[e[e[r + 8 >> 2] + 12 >> 2]](r + 8 | 0) | 0, ke = ye[S + 11 | 0], Fe = r, Ar = o, o = (ke & 128) >>> 7 | 0, r = o ? e[S >> 2] : S, e[G + 12 >> 2] = Uu(Fe, Ar, c, h, y, g, r, r + (o ? e[S + 4 >> 2] : ke & 127) | 0);
                                                                break t;
                                                              }
                                                              r = Bu(G + 12 | 0, c, y, ke, 2), o = e[y >> 2];
                                                              b: {
                                                                if (!(r - 1 >>> 0 > 30 | o & 4)) {
                                                                  e[g + 12 >> 2] = r;
                                                                  break b;
                                                                }
                                                                e[y >> 2] = o | 4;
                                                              }
                                                              break t;
                                                            }
                                                            e[G >> 2] = 623865125, e[G + 4 >> 2] = 2032480100, e[G + 12 >> 2] = Uu(r, o, c, h, y, g, G, G + 8 | 0);
                                                            break t;
                                                          }
                                                          e[G >> 2] = 623728933, e[G + 4 >> 2] = 1680158061, e[G + 12 >> 2] = Uu(r, o, c, h, y, g, G, G + 8 | 0);
                                                          break t;
                                                        }
                                                        r = Bu(G + 12 | 0, c, y, ke, 2), o = e[y >> 2];
                                                        T: {
                                                          if (!((r | 0) > 23 | o & 4)) {
                                                            e[g + 8 >> 2] = r;
                                                            break T;
                                                          }
                                                          e[y >> 2] = o | 4;
                                                        }
                                                        break t;
                                                      }
                                                      r = Bu(G + 12 | 0, c, y, ke, 2), o = e[y >> 2];
                                                      S: {
                                                        if (!(r - 1 >>> 0 > 11 | o & 4)) {
                                                          e[g + 8 >> 2] = r;
                                                          break S;
                                                        }
                                                        e[y >> 2] = o | 4;
                                                      }
                                                      break t;
                                                    }
                                                    r = Bu(G + 12 | 0, c, y, ke, 3), o = e[y >> 2];
                                                    N: {
                                                      if (!((r | 0) > 365 | o & 4)) {
                                                        e[g + 28 >> 2] = r;
                                                        break N;
                                                      }
                                                      e[y >> 2] = o | 4;
                                                    }
                                                    break t;
                                                  }
                                                  o = Bu(G + 12 | 0, c, y, ke, 2) - 1 | 0, r = e[y >> 2];
                                                  k: {
                                                    if (!(o >>> 0 > 11 | r & 4)) {
                                                      e[g + 16 >> 2] = o;
                                                      break k;
                                                    }
                                                    e[y >> 2] = r | 4;
                                                  }
                                                  break t;
                                                }
                                                r = Bu(G + 12 | 0, c, y, ke, 2), o = e[y >> 2];
                                                I: {
                                                  if (!((r | 0) > 59 | o & 4)) {
                                                    e[g + 4 >> 2] = r;
                                                    break I;
                                                  }
                                                  e[y >> 2] = o | 4;
                                                }
                                                break t;
                                              }
                                              for (r = G + 12 | 0, o = Yr - 16 | 0, Yr = o, e[o + 12 >> 2] = c; ; ) {
                                                p: {
                                                  if (Nu(r, o + 12 | 0))
                                                    break p;
                                                  c = e[r >> 2], h = e[c + 12 >> 2];
                                                  I: {
                                                    if ((h | 0) == e[c + 16 >> 2]) {
                                                      c = _n[e[e[c >> 2] + 36 >> 2]](c) | 0;
                                                      break I;
                                                    }
                                                    c = ye[h | 0];
                                                  }
                                                  if (h = e[ke + 8 >> 2], c = c << 24 >> 24, (c | 0) >= 0 ? c = e[h + ((c & 255) << 2) >> 2] & 1 : c = 0, !c)
                                                    break p;
                                                  El(r);
                                                  continue;
                                                }
                                                break;
                                              }
                                              Nu(r, o + 12 | 0) && (e[y >> 2] = e[y >> 2] | 2), Yr = o + 16 | 0;
                                              break t;
                                            }
                                            h = G + 12 | 0, r = _n[e[e[r + 8 >> 2] + 8 >> 2]](r + 8 | 0) | 0, o = ye[r + 11 | 0], S = (o & 128) >>> 7 | 0 ? e[r + 4 >> 2] : o & 127, o = ye[r + 23 | 0];
                                            A: {
                                              if ((S | 0) == (0 - ((o & 128) >>> 7 | 0 ? e[r + 16 >> 2] : o & 127) | 0)) {
                                                e[y >> 2] = e[y >> 2] | 4;
                                                break A;
                                              }
                                              if (c = Kf(h, c, r, r + 24 | 0, ke, y, 0), o = e[g + 8 >> 2], !((c | 0) != (r | 0) | (o | 0) != 12)) {
                                                e[g + 8 >> 2] = 0;
                                                break A;
                                              }
                                              (c - r | 0) != 12 | (o | 0) > 11 || (e[g + 8 >> 2] = o + 12);
                                            }
                                            break t;
                                          }
                                          S = ye[12456] | ye[12457] << 8 | (ye[12458] << 16 | ye[12459] << 24), $[G + 7 | 0] = S, $[G + 8 | 0] = S >>> 8, $[G + 9 | 0] = S >>> 16, $[G + 10 | 0] = S >>> 24, S = ye[12453] | ye[12454] << 8 | (ye[12455] << 16 | ye[12456] << 24), e[G >> 2] = ye[12449] | ye[12450] << 8 | (ye[12451] << 16 | ye[12452] << 24), e[G + 4 >> 2] = S, e[G + 12 >> 2] = Uu(r, o, c, h, y, g, G, G + 11 | 0);
                                          break t;
                                        }
                                        $[G + 4 | 0] = ye[12464], e[G >> 2] = ye[12460] | ye[12461] << 8 | (ye[12462] << 16 | ye[12463] << 24), e[G + 12 >> 2] = Uu(r, o, c, h, y, g, G, G + 5 | 0);
                                        break t;
                                      }
                                      r = Bu(G + 12 | 0, c, y, ke, 2), o = e[y >> 2];
                                      c: {
                                        if (!((r | 0) > 60 | o & 4)) {
                                          e[g >> 2] = r;
                                          break c;
                                        }
                                        e[y >> 2] = o | 4;
                                      }
                                      break t;
                                    }
                                    e[G >> 2] = 624576549, e[G + 4 >> 2] = 1394948685, e[G + 12 >> 2] = Uu(r, o, c, h, y, g, G, G + 8 | 0);
                                    break t;
                                  }
                                  r = Bu(G + 12 | 0, c, y, ke, 1), o = e[y >> 2];
                                  f: {
                                    if (!((r | 0) > 6 | o & 4)) {
                                      e[g + 24 >> 2] = r;
                                      break f;
                                    }
                                    e[y >> 2] = o | 4;
                                  }
                                  break t;
                                }
                                r = _n[e[e[r >> 2] + 20 >> 2]](r, o, c, h, y, g) | 0;
                                break e;
                              }
                              S = _n[e[e[r + 8 >> 2] + 24 >> 2]](r + 8 | 0) | 0, ke = ye[S + 11 | 0], Fe = r, Ar = o, o = (ke & 128) >>> 7 | 0, r = o ? e[S >> 2] : S, e[G + 12 >> 2] = Uu(Fe, Ar, c, h, y, g, r, r + (o ? e[S + 4 >> 2] : ke & 127) | 0);
                              break t;
                            }
                            l1(g + 20 | 0, G + 12 | 0, c, y, ke);
                            break t;
                          }
                          r = Bu(G + 12 | 0, c, y, ke, 4), ye[y | 0] & 4 || (e[g + 20 >> 2] = r - 1900);
                          break t;
                        }
                        if ((S | 0) == 37)
                          break r;
                      }
                      e[y >> 2] = e[y >> 2] | 4;
                      break t;
                    }
                    r = Yr - 16 | 0, Yr = r, e[r + 12 >> 2] = c, o = 6, h = G + 12 | 0, S = r + 12 | 0;
                    r: {
                      n: {
                        if (Nu(h, S))
                          break n;
                        o = 4, c = e[h >> 2], g = e[c + 12 >> 2];
                        i: {
                          if ((g | 0) == e[c + 16 >> 2]) {
                            c = _n[e[e[c >> 2] + 36 >> 2]](c) | 0;
                            break i;
                          }
                          c = ye[g | 0];
                        }
                        if ((_n[e[e[ke >> 2] + 36 >> 2]](ke, c << 24 >> 24, 0) | 0) != 37)
                          break n;
                        if (o = 2, !Nu(El(h), S))
                          break r;
                      }
                      e[y >> 2] = e[y >> 2] | o;
                    }
                    Yr = r + 16 | 0;
                  }
                  r = e[G + 12 >> 2];
                }
                return Yr = G + 16 | 0, r | 0;
              }
              function vc(r, o, c, h, y, g) {
                var S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0;
                S = Yr - 32 | 0, Yr = S, ye[24588] || (e[6145] = 0, e[6146] = 0, e[6143] = 0, e[6144] = 0, e[6141] = 0, e[6142] = 0, $[24588] = 1), ke = 1 - y;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s:
                            switch (o | 0) {
                              case 10:
                              case 11:
                              case 12:
                              case 16:
                                if (o = xs(8), e[S + 20 >> 2] = o, g = o + 8 | 0, e[S + 28 >> 2] = g, Fi[o >> 3] = c, e[S + 24 >> 2] = g, e[5996] = 0, g = ii(3, 8) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                  break t;
                                if (e[S + 8 >> 2] = g, G = g + 8 | 0, e[S + 16 >> 2] = G, Fi[g >> 3] = h, e[5996] = 0, e[S + 12 >> 2] = G, Si(65, r | 0, S + 20 | 0, S + 8 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                  Sr(g), Sr(o);
                                  break i;
                                }
                                break r;
                              case 13:
                              case 14:
                              case 15:
                                if (o = xs(8), e[S + 20 >> 2] = o, g = o + 8 | 0, e[S + 28 >> 2] = g, Fi[o >> 3] = c, e[S + 24 >> 2] = g, e[5996] = 0, g = ii(3, 8) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                  break t;
                                if (e[S + 8 >> 2] = g, G = g + 8 | 0, e[S + 16 >> 2] = G, e[g >> 2] = 0, e[g + 4 >> 2] = 0, e[5996] = 0, e[S + 12 >> 2] = G, Si(65, r | 0, S + 20 | 0, S + 8 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                  Sr(g), Sr(o);
                                  break i;
                                }
                                break r;
                              case 17:
                              case 18:
                                if (o = xs(16), e[S + 20 >> 2] = o, g = o + 16 | 0, e[S + 28 >> 2] = g, Fi[o + 8 >> 3] = c, Fi[o >> 3] = c, e[S + 24 >> 2] = g, e[5996] = 0, g = ii(3, 16) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                  break t;
                                if (e[S + 8 >> 2] = g, G = g + 16 | 0, e[S + 16 >> 2] = G, Fi[g + 8 >> 3] = h, Fi[g >> 3] = h, e[5996] = 0, e[S + 12 >> 2] = G, Si(65, r | 0, S + 20 | 0, S + 8 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                  Sr(g), Sr(o);
                                  break i;
                                }
                                break r;
                              case 19:
                                if (o = xs(16), e[S + 20 >> 2] = o, g = o + 16 | 0, e[S + 28 >> 2] = g, ke = ke * c, Fi[o + 8 >> 3] = ke, c = c * y, Fi[o >> 3] = c, e[S + 24 >> 2] = g, e[5996] = 0, g = ii(3, 16) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                  break t;
                                if (e[S + 8 >> 2] = g, G = g + 16 | 0, e[S + 16 >> 2] = G, Fi[g + 8 >> 3] = c + h, Fi[g >> 3] = ke + h, e[5996] = 0, e[S + 12 >> 2] = G, Si(65, r | 0, S + 20 | 0, S + 8 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                  Sr(g), Sr(o);
                                  break i;
                                }
                                break r;
                              case 21:
                                if (o = xs(16), e[S + 20 >> 2] = o, g = o + 16 | 0, e[S + 28 >> 2] = g, ke = ke * c, Fi[o + 8 >> 3] = ke, Fi[o >> 3] = c * y, e[S + 24 >> 2] = g, e[5996] = 0, g = ii(3, 16) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                  break t;
                                if (e[S + 8 >> 2] = g, G = g + 16 | 0, e[S + 16 >> 2] = G, Fi[g + 8 >> 3] = h, Fi[g >> 3] = ke + h, e[5996] = 0, e[S + 12 >> 2] = G, Si(65, r | 0, S + 20 | 0, S + 8 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                  Sr(g), Sr(o);
                                  break i;
                                }
                                break r;
                              case 20:
                                if (o = xs(16), e[S + 20 >> 2] = o, g = o + 16 | 0, e[S + 28 >> 2] = g, h = ke * c, Fi[o + 8 >> 3] = h, Fi[o >> 3] = c * y, e[S + 24 >> 2] = g, e[5996] = 0, g = ii(3, 16) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                  break t;
                                if (e[S + 8 >> 2] = g, G = g + 16 | 0, e[S + 16 >> 2] = G, e[g + 8 >> 2] = 0, e[g + 12 >> 2] = 0, Fi[g >> 3] = h, e[5996] = 0, e[S + 12 >> 2] = G, Si(65, r | 0, S + 20 | 0, S + 8 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                  Sr(g), Sr(o);
                                  break i;
                                }
                                break r;
                              case 22:
                                if (o = xs(16), e[S + 20 >> 2] = o, G = o + 16 | 0, e[S + 28 >> 2] = G, Fi[o + 8 >> 3] = ke * c, Fi[o >> 3] = c * y, e[S + 24 >> 2] = G, e[5996] = 0, G = ii(3, 16) | 0, Fe = e[5996], e[5996] = 0, (Fe | 0) == 1)
                                  break t;
                                if (e[S + 8 >> 2] = G, Fe = G + 16 | 0, e[S + 16 >> 2] = Fe, Fi[G + 8 >> 3] = (g | 0) == 1 ? h : 0, Fi[G >> 3] = g ? 0 : h, e[5996] = 0, e[S + 12 >> 2] = Fe, Si(65, r | 0, S + 20 | 0, S + 8 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                  Sr(G), Sr(o);
                                  break i;
                                }
                                r = Vr() | 0, Sr(G);
                                break e;
                              case 23:
                                if (o = xs(24), e[S + 20 >> 2] = o, g = o + 24 | 0, e[S + 28 >> 2] = g, ke = ke * c, Fi[o + 16 >> 3] = ke, c = c * y, Fi[o + 8 >> 3] = c, Fi[o >> 3] = c, e[S + 24 >> 2] = g, e[5996] = 0, g = ii(3, 24) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                  break t;
                                if (e[S + 8 >> 2] = g, G = g + 24 | 0, e[S + 16 >> 2] = G, Fi[g + 16 >> 3] = h, e[g + 8 >> 2] = 0, e[g + 12 >> 2] = 0, Fi[g >> 3] = ke + h, e[5996] = 0, e[S + 12 >> 2] = G, Si(65, r | 0, S + 20 | 0, S + 8 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                  Sr(g), Sr(o);
                                  break i;
                                }
                                break r;
                              case 24:
                                a: {
                                  o: {
                                    if (!g) {
                                      g = 0;
                                      break o;
                                    }
                                    if (g >>> 0 >= 536870912)
                                      break n;
                                    if (y = c * y, G = g << 3, Ar = xs(G), o = Ar, hr = g & 7, hr)
                                      for (; Fi[o >> 3] = y, o = o + 8 | 0, Fe = Fe + 1 | 0, (hr | 0) != (Fe | 0); )
                                        ;
                                    if (Tr = G + Ar | 0, ln = g - 1 & 536870911, ln >>> 0 >= 7)
                                      for (; Fi[o + 56 >> 3] = y, Fi[o + 48 >> 3] = y, Fi[o + 40 >> 3] = y, Fi[o + 32 >> 3] = y, Fi[o + 24 >> 3] = y, Fi[o + 16 >> 3] = y, Fi[o + 8 >> 3] = y, Fi[o >> 3] = y, o = o - -64 | 0, (Tr | 0) != (o | 0); )
                                        ;
                                    if (Fe = 0, e[5996] = 0, G = ii(3, G | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                      break a;
                                    if (c = c * ke + h, o = G, hr)
                                      for (; Fi[o >> 3] = c, o = o + 8 | 0, Fe = Fe + 1 | 0, (hr | 0) != (Fe | 0); )
                                        ;
                                    if (g = (g << 3) + G | 0, ln >>> 0 < 7)
                                      break o;
                                    for (; Fi[o + 56 >> 3] = c, Fi[o + 48 >> 3] = c, Fi[o + 40 >> 3] = c, Fi[o + 32 >> 3] = c, Fi[o + 24 >> 3] = c, Fi[o + 16 >> 3] = c, Fi[o + 8 >> 3] = c, Fi[o >> 3] = c, o = o - -64 | 0, (g | 0) != (o | 0); )
                                      ;
                                  }
                                  e[r + 12 >> 2] = G, e[r + 8 >> 2] = Tr, e[r + 4 >> 2] = Tr, e[r >> 2] = Ar, e[r + 20 >> 2] = g, e[r + 16 >> 2] = g;
                                  break i;
                                }
                                r = Vr() | 0, Sr(Ar), Ki(r | 0), ri();
                              default:
                                aa(2350, 1900, 558, 1676), ri();
                              case 0:
                              case 1:
                              case 2:
                              case 3:
                              case 4:
                              case 5:
                              case 6:
                              case 7:
                              case 8:
                              case 9:
                              case 25:
                                break s;
                            }
                          ff(r);
                        }
                        Yr = S + 32 | 0;
                        return;
                      }
                      Lo(), ri();
                    }
                    r = Vr() | 0, Sr(g);
                    break e;
                  }
                  r = Vr() | 0;
                }
                Sr(o), Ki(r | 0), ri();
              }
              function _d(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0;
                e: {
                  t: {
                    y = e[c >> 2], h = e[y + 80 >> 2];
                    r: {
                      if (!h | Ps[y + 84 >> 2] > 3600 | (e[y + 52 >> 2] + e[y + 44 >> 2] >>> 0 > 201 | Ps[y + 68 >> 2] > 100))
                        break r;
                      if (e[5996] = 0, G = On(54, 2049, 1) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                        break t;
                      if ((h ^ -1) & G)
                        break r;
                      if (h = e[y + 80 >> 2], e[5996] = 0, G = On(54, 2165, 1) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                        break t;
                      if (ye[y + 88 | 0] | (h ^ -1) & G || (ke = Fi[r + 24 >> 3], Ar = ke == 0 ? 0 : ke * Fi[o + 8 >> 3], ke = Fi[r + 16 >> 3], S = e[y + 84 >> 2], ke = Ar + ((ke == 0 ? 0 : ke * Fi[o >> 3]) + +(S >>> 0)), ke > 1e4))
                        break r;
                      g = e[y + 80 >> 2];
                      n: {
                        i: {
                          if (h = e[r >> 2], G = e[r + 4 >> 2], (h | 0) == (G | 0))
                            break i;
                          for (y = h; ; ) {
                            Fe = e[y >> 2];
                            s: {
                              if (g & (e[Fe + 80 >> 2] ^ -1))
                                break s;
                              if (Ar = Fi[y + 24 >> 3], Ar < ke)
                                break r;
                              if (ke < Ar)
                                break s;
                              if (S >>> 0 <= Ps[Fe + 84 >> 2])
                                break r;
                            }
                            if (y = y + 32 | 0, (G | 0) == (y | 0))
                              break;
                          }
                          for (y = g ^ -1; ; ) {
                            Fe = e[h >> 2];
                            s: {
                              if (y & e[Fe + 80 >> 2] || (Ar = Fi[h + 24 >> 3], Ar < ke))
                                break s;
                              if (S >>> 0 >= Ps[Fe + 84 >> 2] | ke < Ar)
                                break i;
                            }
                            if (h = h + 32 | 0, (G | 0) == (h | 0))
                              break;
                          }
                          y = G;
                          break n;
                        }
                        if ((h | 0) == (G | 0)) {
                          y = G;
                          break n;
                        }
                        S = h + 32 | 0;
                        i: {
                          if ((S | 0) == (G | 0)) {
                            y = h;
                            break i;
                          }
                          for (Fe = g ^ -1, y = h; ; ) {
                            g = h, h = S, S = e[g + 32 >> 2];
                            s: {
                              a: {
                                if (Fe & e[S + 80 >> 2] || (Ar = Fi[g + 56 >> 3], Ar < ke))
                                  break a;
                                if (Ps[S + 84 >> 2] <= Ps[e[c >> 2] + 84 >> 2] | ke < Ar)
                                  break s;
                              }
                              hr = e[g + 36 >> 2], e[h >> 2] = 0, e[g + 36 >> 2] = 0, e[y >> 2] = S, S = e[y + 4 >> 2], e[y + 4 >> 2] = hr;
                              a: {
                                if (!S || (hr = e[S + 4 >> 2], e[S + 4 >> 2] = hr - 1, hr))
                                  break a;
                                _n[e[e[S >> 2] + 8 >> 2]](S), cs(S);
                              }
                              S = e[g + 60 >> 2], e[y + 24 >> 2] = e[g + 56 >> 2], e[y + 28 >> 2] = S, S = e[g + 52 >> 2], e[y + 16 >> 2] = e[g + 48 >> 2], e[y + 20 >> 2] = S, S = e[g + 44 >> 2], e[y + 8 >> 2] = e[g + 40 >> 2], e[y + 12 >> 2] = S, y = y + 32 | 0;
                            }
                            if (S = h + 32 | 0, (S | 0) == (G | 0))
                              break;
                          }
                          G = e[r + 4 >> 2];
                        }
                        if ((y | 0) == (G | 0)) {
                          y = G;
                          break n;
                        }
                        if (h = (G - y | 0) + y | 0, (G | 0) != (h | 0)) {
                          for (; ; ) {
                            S = e[h >> 2], Fe = e[h + 4 >> 2], e[h >> 2] = 0, e[h + 4 >> 2] = 0, g = e[y + 4 >> 2], e[y >> 2] = S, e[y + 4 >> 2] = Fe;
                            i: {
                              if (!g || (S = e[g + 4 >> 2], e[g + 4 >> 2] = S - 1, S))
                                break i;
                              _n[e[e[g >> 2] + 8 >> 2]](g), cs(g);
                            }
                            if (g = e[h + 12 >> 2], e[y + 8 >> 2] = e[h + 8 >> 2], e[y + 12 >> 2] = g, g = e[h + 28 >> 2], e[y + 24 >> 2] = e[h + 24 >> 2], e[y + 28 >> 2] = g, g = e[h + 20 >> 2], e[y + 16 >> 2] = e[h + 16 >> 2], e[y + 20 >> 2] = g, y = y + 32 | 0, h = h + 32 | 0, (G | 0) == (h | 0))
                              break;
                          }
                          G = e[r + 4 >> 2];
                        }
                        if ((y | 0) != (G | 0))
                          for (; ; ) {
                            G = G - 32 | 0, h = e[G + 4 >> 2];
                            i: {
                              if (!h || (g = e[h + 4 >> 2], e[h + 4 >> 2] = g - 1, g))
                                break i;
                              _n[e[e[h >> 2] + 8 >> 2]](h), cs(h);
                            }
                            if ((y | 0) == (G | 0))
                              break;
                          }
                        e[r + 4 >> 2] = y;
                      }
                      g = e[r + 8 >> 2];
                      n: {
                        if (g >>> 0 > y >>> 0) {
                          e[y >> 2] = e[c >> 2], e[y + 4 >> 2] = e[c + 4 >> 2], e[c >> 2] = 0, e[c + 4 >> 2] = 0, h = e[o + 12 >> 2], e[y + 16 >> 2] = e[o + 8 >> 2], e[y + 20 >> 2] = h, h = e[o + 4 >> 2], e[y + 8 >> 2] = e[o >> 2], e[y + 12 >> 2] = h, Fi[y + 24 >> 3] = ke, e[r + 4 >> 2] = y + 32;
                          break n;
                        }
                        if (G = e[r >> 2], S = y - G >> 5, h = S + 1 | 0, h >>> 0 >= 134217728) {
                          if (e[5996] = 0, Ri(62), r = e[5996], e[5996] = 0, (r | 0) == 1)
                            break t;
                          break e;
                        }
                        if (g = g - G | 0, Fe = g >> 4, h = g >>> 0 >= 2147483616 ? 134217727 : h >>> 0 < Fe >>> 0 ? Fe : h, h >>> 0 >= 134217728) {
                          if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                            break e;
                          break t;
                        }
                        if (e[5996] = 0, Fe = h << 5, g = ii(3, Fe | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                          break t;
                        h = g + (S << 5) | 0, e[h >> 2] = e[c >> 2], e[h + 4 >> 2] = e[c + 4 >> 2], e[c >> 2] = 0, e[c + 4 >> 2] = 0, S = e[o + 12 >> 2], e[h + 16 >> 2] = e[o + 8 >> 2], e[h + 20 >> 2] = S, S = e[o + 4 >> 2], e[h + 8 >> 2] = e[o >> 2], e[h + 12 >> 2] = S, Fi[h + 24 >> 3] = ke, o = g + Fe | 0, g = h + 32 | 0;
                        i: {
                          if ((y | 0) != (G | 0)) {
                            for (; h = h - 32 | 0, y = y - 32 | 0, e[h >> 2] = e[y >> 2], e[h + 4 >> 2] = e[y + 4 >> 2], e[y >> 2] = 0, e[y + 4 >> 2] = 0, S = e[y + 28 >> 2], e[h + 24 >> 2] = e[y + 24 >> 2], e[h + 28 >> 2] = S, S = e[y + 20 >> 2], e[h + 16 >> 2] = e[y + 16 >> 2], e[h + 20 >> 2] = S, S = e[y + 12 >> 2], e[h + 8 >> 2] = e[y + 8 >> 2], e[h + 12 >> 2] = S, (y | 0) != (G | 0); )
                              ;
                            if (e[r + 8 >> 2] = o, o = e[r + 4 >> 2], e[r + 4 >> 2] = g, y = e[r >> 2], e[r >> 2] = h, (o | 0) == (y | 0))
                              break i;
                            for (; ; ) {
                              o = o - 32 | 0, h = e[o + 4 >> 2];
                              s: {
                                if (!h || (G = e[h + 4 >> 2], e[h + 4 >> 2] = G - 1, G))
                                  break s;
                                _n[e[e[h >> 2] + 8 >> 2]](h), cs(h);
                              }
                              if ((o | 0) == (y | 0))
                                break;
                            }
                            break i;
                          }
                          e[r + 8 >> 2] = o, e[r + 4 >> 2] = g, e[r >> 2] = h;
                        }
                        if (!y)
                          break n;
                        Sr(y);
                      }
                      e[r + 32 >> 2] = e[r + 32 >> 2] + 1;
                    }
                    r = e[c + 4 >> 2];
                    r: {
                      if (!r || (o = e[r + 4 >> 2], e[r + 4 >> 2] = o - 1, o))
                        break r;
                      _n[e[e[r >> 2] + 8 >> 2]](r), cs(r);
                    }
                    return;
                  }
                  r = Vr() | 0, No(c), Ki(r | 0), ri();
                }
                ri();
              }
              function Zd(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0, G = 0, ke = la(0), Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = la(0), Rn = 0;
                h = vi(r, 1540483477), h = vi(h >>> 24 ^ h, 1540483477) ^ 1866966612, h = vi(h >>> 13 ^ h, 1540483477), S = h >>> 15 ^ h;
                e: {
                  t: {
                    r: {
                      n: {
                        G = e[o + 4 >> 2];
                        i: {
                          if (!G)
                            break i;
                          y = e[o >> 2], Ar = Cs(G), h = G - 1 & S;
                          s: {
                            if (Ar >>> 0 <= 1 || (h = S, h >>> 0 < G >>> 0))
                              break s;
                            h = (h >>> 0) % (G >>> 0) | 0;
                          }
                          if (g = h, h = e[y + (g << 2) >> 2], !h || (h = e[h >> 2], !h))
                            break i;
                          if (Ar >>> 0 <= 1) {
                            for (y = G - 1 | 0; ; ) {
                              G = e[h + 4 >> 2];
                              s: {
                                if ((G | 0) != (S | 0)) {
                                  if ((g | 0) == (y & G))
                                    break s;
                                  break i;
                                }
                                if (e[h + 8 >> 2] == (r | 0))
                                  break n;
                              }
                              if (h = e[h >> 2], !h)
                                break;
                            }
                            break i;
                          }
                          for (; ; ) {
                            y = e[h + 4 >> 2];
                            s: {
                              if ((y | 0) != (S | 0)) {
                                if (y >>> 0 >= G >>> 0 && (y = (y >>> 0) % (G >>> 0) | 0), (y | 0) == (g | 0))
                                  break s;
                                break i;
                              }
                              if (e[h + 8 >> 2] == (r | 0))
                                break n;
                            }
                            if (h = e[h >> 2], !h)
                              break;
                          }
                        }
                        if (Tr = jd(r, o, c), !Tr)
                          return 0;
                        if (h = e[o + 4 >> 2], !h)
                          break r;
                        if (y = h - 1 | 0, y & h) {
                          if (c = h >>> 0 <= S >>> 0 ? (S >>> 0) % (h >>> 0) | 0 : S, g = e[e[o >> 2] + (c << 2) >> 2], !g)
                            break r;
                          for (; ; ) {
                            if (g = e[g >> 2], !g || (y = e[g + 4 >> 2], (y | 0) != (S | 0) && (h >>> 0 <= y >>> 0 && (y = (y >>> 0) % (h >>> 0) | 0), (c | 0) != (y | 0))))
                              break r;
                            if (e[g + 8 >> 2] == (r | 0))
                              break;
                          }
                          break t;
                        }
                        if (c = y & S, g = e[e[o >> 2] + (c << 2) >> 2], !g)
                          break r;
                        for (; ; ) {
                          if (g = e[g >> 2], !g || (G = e[g + 4 >> 2], (G | 0) != (S | 0) & (y & G) != (c | 0)))
                            break r;
                          if (e[g + 8 >> 2] == (r | 0))
                            break;
                        }
                        break t;
                      }
                      return e[h + 12 >> 2];
                    }
                    G = xs(16), e[G + 8 >> 2] = r, e[G + 4 >> 2] = S, e[G >> 2] = 0, e[G + 12 >> 2] = Tr, Ar = o + 8 | 0, ln = la(e[o + 12 >> 2] + 1 >>> 0), ke = ef[o + 16 >> 2];
                    r: {
                      if (!(!h | ln > la(ke * la(h >>> 0)))) {
                        S = c;
                        break r;
                      }
                      y = 2, c = (h - 1 & h) != 0 | h >>> 0 < 3 | h << 1, ke = la(Ld(la(ln / ke)));
                      n: {
                        if (ke < la(4294967296) & ke >= la(0)) {
                          r = ~~ke >>> 0;
                          break n;
                        }
                        r = 0;
                      }
                      r = r >>> 0 < c >>> 0 ? c : r;
                      n: {
                        if ((r | 0) == 1)
                          break n;
                        if (!(r & r - 1)) {
                          y = r;
                          break n;
                        }
                        if (e[5996] = 0, y = ii(43, r | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                          break e;
                        h = e[o + 4 >> 2];
                      }
                      n: {
                        i: {
                          if (h >>> 0 >= y >>> 0) {
                            if (h >>> 0 <= y >>> 0)
                              break n;
                            c = h >>> 0 < 3, ke = la(Ld(la(la(Ps[o + 12 >> 2]) / ef[o + 16 >> 2])));
                            s: {
                              if (ke < la(4294967296) & ke >= la(0)) {
                                r = ~~ke >>> 0;
                                break s;
                              }
                              r = 0;
                            }
                            s: {
                              a: {
                                if (c || Cs(h) >>> 0 > 1)
                                  break a;
                                r = r >>> 0 < 2 ? r : 1 << 32 - Do(r - 1 | 0);
                                break s;
                              }
                              if (e[5996] = 0, r = ii(43, r | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                break e;
                            }
                            if (y = r >>> 0 < y >>> 0 ? y : r, y >>> 0 >= h >>> 0) {
                              h = e[o + 4 >> 2];
                              break n;
                            }
                            if (!y)
                              break i;
                          }
                          if (y >>> 0 >= 1073741824) {
                            if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) == 1)
                              break e;
                            ri();
                          }
                          if (e[5996] = 0, c = ii(3, y << 2) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                            break e;
                          if (r = e[o >> 2], e[o >> 2] = c, r && Sr(r), e[o + 4 >> 2] = y, g = 0, h = 0, Fe = y - 1 | 0, Fe >>> 0 >= 3)
                            for (c = y & -4; r = h << 2, e[r + e[o >> 2] >> 2] = 0, e[e[o >> 2] + (r | 4) >> 2] = 0, e[e[o >> 2] + (r | 8) >> 2] = 0, e[e[o >> 2] + (r | 12) >> 2] = 0, h = h + 4 | 0, (c | 0) != (h | 0); )
                              ;
                          if (r = y & 3, r)
                            for (; e[e[o >> 2] + (h << 2) >> 2] = 0, h = h + 1 | 0, g = g + 1 | 0, (r | 0) != (g | 0); )
                              ;
                          if (h = e[o + 8 >> 2], !h) {
                            h = y;
                            break n;
                          }
                          c = e[h + 4 >> 2];
                          s: {
                            if (y - 1 & y) {
                              if (c = c >>> 0 >= y >>> 0 ? (c >>> 0) % (y >>> 0) | 0 : c, e[e[o >> 2] + (c << 2) >> 2] = Ar, g = e[h >> 2], g)
                                break s;
                              h = y;
                              break n;
                            }
                            if (c = c & Fe, e[e[o >> 2] + (c << 2) >> 2] = Ar, r = e[h >> 2], !r) {
                              h = y;
                              break n;
                            }
                            for (; ; ) {
                              g = Fe & e[r + 4 >> 2];
                              a: {
                                if ((g | 0) == (c | 0)) {
                                  h = r;
                                  break a;
                                }
                                if (hr = g << 2, Rn = hr + e[o >> 2] | 0, e[Rn >> 2]) {
                                  e[h >> 2] = e[r >> 2], e[r >> 2] = e[e[hr + e[o >> 2] >> 2] >> 2], e[e[hr + e[o >> 2] >> 2] >> 2] = r;
                                  break a;
                                }
                                e[Rn >> 2] = h, h = r, c = g;
                              }
                              if (r = e[h >> 2], !r)
                                break;
                            }
                            h = y;
                            break n;
                          }
                          for (; ; ) {
                            r = e[g + 4 >> 2], y >>> 0 <= r >>> 0 && (r = (r >>> 0) % (y >>> 0) | 0);
                            s: {
                              if ((r | 0) == (c | 0)) {
                                h = g;
                                break s;
                              }
                              if (Fe = r << 2, hr = Fe + e[o >> 2] | 0, !e[hr >> 2]) {
                                e[hr >> 2] = h, h = g, c = r;
                                break s;
                              }
                              e[h >> 2] = e[g >> 2], e[g >> 2] = e[e[Fe + e[o >> 2] >> 2] >> 2], e[e[Fe + e[o >> 2] >> 2] >> 2] = g;
                            }
                            if (g = e[h >> 2], !g)
                              break;
                          }
                          h = y;
                          break n;
                        }
                        r = e[o >> 2], h = 0, e[o >> 2] = 0, r && Sr(r), e[o + 4 >> 2] = 0;
                      }
                      if (r = h - 1 | 0, !(r & h)) {
                        S = r & S;
                        break r;
                      }
                      if (h >>> 0 > S >>> 0)
                        break r;
                      S = (S >>> 0) % (h >>> 0) | 0;
                    }
                    r = e[o >> 2] + (S << 2) | 0, S = e[r >> 2];
                    r: {
                      n: {
                        if (!S) {
                          if (e[G >> 2] = e[o + 8 >> 2], e[o + 8 >> 2] = G, e[r >> 2] = Ar, r = e[G >> 2], !r)
                            break r;
                          S = e[r + 4 >> 2], r = h - 1 | 0;
                          i: {
                            if (!(r & h)) {
                              S = r & S;
                              break i;
                            }
                            if (h >>> 0 > S >>> 0)
                              break i;
                            S = (S >>> 0) % (h >>> 0) | 0;
                          }
                          S = e[o >> 2] + (S << 2) | 0;
                          break n;
                        }
                        e[G >> 2] = e[S >> 2];
                      }
                      e[S >> 2] = G;
                    }
                    e[o + 12 >> 2] = e[o + 12 >> 2] + 1;
                  }
                  return Tr | 0;
                }
                r = Vr() | 0, Sr(G), Ki(r | 0), ri();
              }
              function z1(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0;
                var g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0;
                ke = Yr - 16 | 0, Yr = ke, e[ke + 8 >> 2] = 0, e[ke + 12 >> 2] = 0, Ar = ke + 8 | 0, e[ke + 4 >> 2] = Ar;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          if ((o | 0) != (c | 0))
                            for (; ; ) {
                              Fe = e[o >> 2], S = e[Fe + 80 >> 2];
                              s: {
                                if ((S ^ -1) & h)
                                  break s;
                                hr = y & S, G = Ar, S = G;
                                a: {
                                  Tr = e[ke + 8 >> 2], g = Tr;
                                  o: {
                                    if (!g)
                                      break o;
                                    for (; ; ) {
                                      if (S = g, g = e[S + 16 >> 2], g >>> 0 > hr >>> 0) {
                                        if (G = S, g = e[S >> 2], g)
                                          continue;
                                        break o;
                                      }
                                      if (g >>> 0 >= hr >>> 0)
                                        break a;
                                      if (g = e[S + 4 >> 2], !g)
                                        break;
                                    }
                                    G = S + 4 | 0;
                                  }
                                  if (e[5996] = 0, g = ii(3, 56) | 0, Mn = e[5996], e[5996] = 0, (Mn | 0) == 1)
                                    break i;
                                  e[g + 16 >> 2] = hr, e[g + 24 >> 2] = Fe, Fe = e[o + 4 >> 2], e[g + 28 >> 2] = Fe, Fe && (e[Fe + 4 >> 2] = e[Fe + 4 >> 2] + 1), Fe = e[o + 12 >> 2], e[g + 32 >> 2] = e[o + 8 >> 2], e[g + 36 >> 2] = Fe, Fe = e[o + 28 >> 2], e[g + 48 >> 2] = e[o + 24 >> 2], e[g + 52 >> 2] = Fe, Fe = e[o + 20 >> 2], e[g + 40 >> 2] = e[o + 16 >> 2], e[g + 44 >> 2] = Fe, e[g + 8 >> 2] = S, e[g >> 2] = 0, e[g + 4 >> 2] = 0, e[G >> 2] = g, S = e[e[ke + 4 >> 2] >> 2], S && (e[ke + 4 >> 2] = S, g = e[G >> 2]), Cc(e[ke + 8 >> 2], g), e[ke + 12 >> 2] = e[ke + 12 >> 2] + 1;
                                  break s;
                                }
                                if (ln = Fi[o + 24 >> 3], Rn = Fi[S + 48 >> 3], !(ln < Rn) & (Ps[Fe + 84 >> 2] <= Ps[e[S + 24 >> 2] + 84 >> 2] | ln > Rn))
                                  break s;
                                G = e[o + 4 >> 2], G && (e[G + 4 >> 2] = e[G + 4 >> 2] + 1), e[S + 24 >> 2] = Fe, g = e[S + 28 >> 2], e[S + 28 >> 2] = G;
                                a: {
                                  if (!g || (G = e[g + 4 >> 2], e[g + 4 >> 2] = G - 1, G))
                                    break a;
                                  _n[e[e[g >> 2] + 8 >> 2]](g), cs(g);
                                }
                                g = e[o + 12 >> 2], e[S + 32 >> 2] = e[o + 8 >> 2], e[S + 36 >> 2] = g, g = e[o + 28 >> 2], e[S + 48 >> 2] = e[o + 24 >> 2], e[S + 52 >> 2] = g, g = e[o + 20 >> 2], e[S + 40 >> 2] = e[o + 16 >> 2], e[S + 44 >> 2] = g;
                              }
                              if (o = o + 32 | 0, (c | 0) == (o | 0))
                                break n;
                            }
                          e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                          break e;
                        }
                        S = Vr() | 0;
                        break r;
                      }
                      if (h = e[ke + 4 >> 2], e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, (h | 0) == (Ar | 0))
                        break e;
                      for (; ; ) {
                        n: {
                          S = e[r + 4 >> 2];
                          i: {
                            if ((S | 0) != e[r + 8 >> 2]) {
                              e[S >> 2] = e[h + 24 >> 2], o = e[h + 28 >> 2], e[S + 4 >> 2] = o, o && (e[o + 4 >> 2] = e[o + 4 >> 2] + 1), o = e[h + 52 >> 2], e[S + 24 >> 2] = e[h + 48 >> 2], e[S + 28 >> 2] = o, o = e[h + 44 >> 2], e[S + 16 >> 2] = e[h + 40 >> 2], e[S + 20 >> 2] = o, o = e[h + 36 >> 2], e[S + 8 >> 2] = e[h + 32 >> 2], e[S + 12 >> 2] = o, e[r + 4 >> 2] = S + 32;
                              break i;
                            }
                            if (o = e[r >> 2], c = S - o | 0, g = c >> 5, y = g + 1 | 0, y >>> 0 >= 134217728) {
                              if (e[5996] = 0, Ri(62), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                break n;
                              break t;
                            }
                            G = c >> 4, y = c >>> 0 >= 2147483616 ? 134217727 : y >>> 0 < G >>> 0 ? G : y;
                            s: {
                              if (!y) {
                                c = 0;
                                break s;
                              }
                              if (y >>> 0 >= 134217728) {
                                if (e[5996] = 0, Ri(35), o = e[5996], e[5996] = 0, (o | 0) != 1)
                                  break t;
                                break n;
                              }
                              if (e[5996] = 0, c = ii(3, y << 5) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                break n;
                            }
                            g = (g << 5) + c | 0, e[g >> 2] = e[h + 24 >> 2], G = e[h + 28 >> 2], e[g + 4 >> 2] = G, G && (e[G + 4 >> 2] = e[G + 4 >> 2] + 1, S = e[r + 4 >> 2], o = e[r >> 2]), c = (y << 5) + c | 0, y = e[h + 36 >> 2], e[g + 8 >> 2] = e[h + 32 >> 2], e[g + 12 >> 2] = y, y = e[h + 52 >> 2], e[g + 24 >> 2] = e[h + 48 >> 2], e[g + 28 >> 2] = y, y = e[h + 44 >> 2], e[g + 16 >> 2] = e[h + 40 >> 2], e[g + 20 >> 2] = y, y = g + 32 | 0;
                            s: {
                              if ((o | 0) == (S | 0)) {
                                e[r + 8 >> 2] = c, e[r + 4 >> 2] = y, e[r >> 2] = g;
                                break s;
                              }
                              for (; g = g - 32 | 0, S = S - 32 | 0, e[g >> 2] = e[S >> 2], e[g + 4 >> 2] = e[S + 4 >> 2], e[S >> 2] = 0, e[S + 4 >> 2] = 0, G = e[S + 28 >> 2], e[g + 24 >> 2] = e[S + 24 >> 2], e[g + 28 >> 2] = G, G = e[S + 20 >> 2], e[g + 16 >> 2] = e[S + 16 >> 2], e[g + 20 >> 2] = G, G = e[S + 12 >> 2], e[g + 8 >> 2] = e[S + 8 >> 2], e[g + 12 >> 2] = G, (o | 0) != (S | 0); )
                                ;
                              if (e[r + 8 >> 2] = c, S = e[r + 4 >> 2], e[r + 4 >> 2] = y, o = e[r >> 2], e[r >> 2] = g, (o | 0) == (S | 0))
                                break s;
                              for (; ; ) {
                                S = S - 32 | 0, c = e[S + 4 >> 2];
                                a: {
                                  if (!c || (y = e[c + 4 >> 2], e[c + 4 >> 2] = y - 1, y))
                                    break a;
                                  _n[e[e[c >> 2] + 8 >> 2]](c), cs(c);
                                }
                                if ((o | 0) == (S | 0))
                                  break;
                              }
                            }
                            if (!o)
                              break i;
                            Sr(o);
                          }
                          g = e[h + 4 >> 2];
                          i: {
                            if (g) {
                              for (; ; )
                                if (S = g, g = e[S >> 2], !g)
                                  break i;
                            }
                            for (; S = e[h + 8 >> 2], o = e[S >> 2] != (h | 0), h = S, !!o; )
                              ;
                          }
                          if (h = S, (S | 0) != (Ar | 0))
                            continue;
                          break e;
                        }
                        break;
                      }
                      S = Vr() | 0, lu(r), Tr = e[ke + 8 >> 2];
                    }
                    dl(Tr), Ki(S | 0), ri();
                  }
                  ri();
                }
                dl(e[ke + 8 >> 2]), Yr = ke + 16 | 0;
              }
              function qa(r, o, c, h, y, g, S, G, ke) {
                var Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0, Qi = 0;
                Fe = Yr - 112 | 0, Yr = Fe, Ar = ke & 2147483647;
                e: {
                  t: {
                    if (Tr = y & 2147483647, hr = 2147418112, ln = !(o | c), !(h | Tr ? Tr - hr >>> 0 < 2147549184 : ln) && (Mn = Ar - hr | 0, !G & (Mn | 0) == -2147418112 ? g | S : (Mn | 0) == -2147418112 & (G | 0) != 0 | Mn >>> 0 > 2147549184))
                      break t;
                    if (!(!h & (Tr | 0) == 2147418112 ? ln : Tr >>> 0 < 2147418112)) {
                      G = h, ke = y | 32768, g = o, S = c;
                      break e;
                    }
                    if (!(!G & (Ar | 0) == 2147418112 ? !(g | S) : Ar >>> 0 < 2147418112)) {
                      ke = ke | 32768;
                      break e;
                    }
                    if (!(o | h | (Tr ^ 2147418112 | c))) {
                      hr = h, h = !(o ^ g | h ^ G | (c ^ S | y ^ ke ^ -2147483648)), G = h ? 0 : hr, ke = h ? 2147450880 : y, g = h ? 0 : o, S = h ? 0 : c;
                      break e;
                    }
                    if (hr = g | G, !(hr | (Ar ^ 2147418112 | S)))
                      break e;
                    if (!(o | h | (c | Tr))) {
                      if (S | Ar | hr)
                        break e;
                      g = o & g, S = c & S, G = h & G, ke = y & ke;
                      break e;
                    }
                    if (g | G | (S | Ar))
                      break t;
                    g = o, S = c, G = h, ke = y;
                    break e;
                  }
                  hr = (Ar | 0) == (Tr | 0), gi = hr & (h | 0) == (G | 0) ? (c | 0) == (S | 0) & o >>> 0 < g >>> 0 | c >>> 0 < S >>> 0 : hr & h >>> 0 < G >>> 0 | Ar >>> 0 > Tr >>> 0, ln = gi, Tr = ln ? g : o, Mn = ln ? S : c, hr = ln ? ke : y, Qi = hr, ln = ln ? G : h, ei = hr & 65535, h = gi ? h : G, y = gi ? y : ke, ci = y, hr = y >>> 16 & 32767, Rn = Qi >>> 16 & 32767, Rn || (y = !(ln | ei), ke = y, Ar = y ? Tr : ln, y = y << 6, ke = Do(ke ? Mn : ei), y = y + ((ke | 0) == 32 ? Do(Ar) + 32 | 0 : ke) | 0, ha(Fe + 96 | 0, Tr, Mn, ln, ei, y - 15 | 0), ln = e[Fe + 104 >> 2], ei = e[Fe + 108 >> 2], Mn = e[Fe + 100 >> 2], Rn = 16 - y | 0, Tr = e[Fe + 96 >> 2]), g = gi ? o : g, S = gi ? c : S, G = h, ke = ci & 65535, hr || (o = !(h | ke), y = o, Ar = o ? g : h, o = o << 6, y = Do(y ? S : ke), o = o + ((y | 0) == 32 ? Do(Ar) + 32 | 0 : y) | 0, ha(Fe + 80 | 0, g, S, h, ke, o - 15 | 0), hr = 16 - o | 0, G = e[Fe + 88 >> 2], ke = e[Fe + 92 >> 2], S = e[Fe + 84 >> 2], g = e[Fe + 80 >> 2]), c = ke << 3 | G >>> 29, o = G << 3 | S >>> 29, c = c | 524288, y = ei << 3 | ln >>> 29, ei = ln << 3 | Mn >>> 29, G = y, ke = ci ^ Qi, Ar = S << 3 | g >>> 29, h = g << 3;
                  t: {
                    if ((hr | 0) == (Rn | 0))
                      break t;
                    if (y = Rn - hr | 0, y >>> 0 > 127) {
                      o = 0, c = 0, Ar = 0, h = 1;
                      break t;
                    }
                    ha(Fe - -64 | 0, h, Ar, o, c, 128 - y | 0), Ac(Fe + 48 | 0, h, Ar, o, c, y), o = e[Fe + 56 >> 2], c = e[Fe + 60 >> 2], Ar = e[Fe + 52 >> 2], h = e[Fe + 48 >> 2] | (e[Fe + 64 >> 2] | e[Fe + 72 >> 2] | (e[Fe + 68 >> 2] | e[Fe + 76 >> 2])) != 0;
                  }
                  ln = h, hr = Ar, ci = G | 524288, Ar = Mn << 3 | Tr >>> 29, Tr = Tr << 3;
                  t: {
                    if ((ke | 0) < 0) {
                      if (g = 0, S = 0, G = 0, ke = 0, !(Tr ^ ln | o ^ ei | (Ar ^ hr | c ^ ci)))
                        break e;
                      if (h = Tr - ln | 0, y = Ar - ((Tr >>> 0 < ln >>> 0) + hr | 0) | 0, g = ei - o | 0, S = (Ar | 0) == (hr | 0) & Tr >>> 0 < ln >>> 0 | Ar >>> 0 < hr >>> 0, G = g - S | 0, o = (ci - ((o >>> 0 > ei >>> 0) + c | 0) | 0) - (g >>> 0 < S >>> 0) | 0, ke = o, o >>> 0 > 524287)
                        break t;
                      c = !(o | G), S = c, ke = S ? h : G, c = S << 6, S = Do(S ? y : o), c = c + ((S | 0) == 32 ? Do(ke) + 32 | 0 : S) | 0, g = o, o = c - 12 | 0, ha(Fe + 32 | 0, h, y, G, g, o), Rn = Rn - o | 0, G = e[Fe + 40 >> 2], ke = e[Fe + 44 >> 2], h = e[Fe + 32 >> 2], y = e[Fe + 36 >> 2];
                      break t;
                    }
                    if (Ar = Ar + hr | 0, h = Tr + ln | 0, y = h >>> 0 < Tr >>> 0 ? Ar + 1 | 0 : Ar, g = (hr | 0) == (y | 0) & h >>> 0 < ln >>> 0 | y >>> 0 < hr >>> 0, Ar = c + ci | 0, o = o + ei | 0, Ar = o >>> 0 < ei >>> 0 ? Ar + 1 | 0 : Ar, G = o + g | 0, ke = G >>> 0 < o >>> 0 ? Ar + 1 | 0 : Ar, !(ke & 1048576))
                      break t;
                    h = ln & 1 | ((y & 1) << 31 | h >>> 1), y = G << 31 | y >>> 1, Rn = Rn + 1 | 0, G = (ke & 1) << 31 | G >>> 1, ke = ke >>> 1 | 0;
                  }
                  if (c = 0, o = Qi & -2147483648, Mn = o, (Rn | 0) >= 32767) {
                    G = c, ke = o | 2147418112, g = 0, S = 0;
                    break e;
                  }
                  hr = 0;
                  t: {
                    if ((Rn | 0) > 0) {
                      hr = Rn;
                      break t;
                    }
                    ha(Fe + 16 | 0, h, y, G, ke, Rn + 127 | 0), Ac(Fe, h, y, G, ke, 1 - Rn | 0), h = e[Fe >> 2] | (e[Fe + 16 >> 2] | e[Fe + 24 >> 2] | (e[Fe + 20 >> 2] | e[Fe + 28 >> 2])) != 0, y = e[Fe + 4 >> 2], G = e[Fe + 8 >> 2], ke = e[Fe + 12 >> 2];
                  }
                  Tr = h & 7, h = (y & 7) << 29 | h >>> 3, g = (Tr >>> 0 > 4) + h | 0, o = G << 29 | y >>> 3, S = h >>> 0 > g >>> 0 ? o + 1 | 0 : o, h = (o | 0) == (S | 0) & h >>> 0 > g >>> 0 | o >>> 0 > S >>> 0, o = c | ((ke & 7) << 29 | G >>> 3), G = h + o | 0, ke = Mn | (ke >>> 3 & 65535 | hr << 16), ke = o >>> 0 > G >>> 0 ? ke + 1 | 0 : ke;
                  t: {
                    if ((Tr | 0) == 4) {
                      o = 0, Ar = S + o | 0, h = g, c = g & 1, g = g + c | 0, S = h >>> 0 > g >>> 0 ? Ar + 1 | 0 : Ar, o = (o | 0) == (S | 0) & c >>> 0 > g >>> 0 | o >>> 0 > S >>> 0, G = o + G | 0, ke = o >>> 0 > G >>> 0 ? ke + 1 | 0 : ke;
                      break t;
                    }
                    if (!Tr)
                      break e;
                  }
                }
                e[r >> 2] = g, e[r + 4 >> 2] = S, e[r + 8 >> 2] = G, e[r + 12 >> 2] = ke, Yr = Fe + 112 | 0;
              }
              function J1(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0;
                S = Yr - 16 | 0, Yr = S;
                e: {
                  if (g = c - !o | 0, !((!g & o - 1 >>> 0 > 15 | (g | 0) != 0) & (o & c) != -1)) {
                    h = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), y = h - 29 | 0, c = (h >>> 0 < 29 ? h : y) + 1 | 0, c >>> 0 > (h >>> 0 <= 28 ? 28 : ye[r + 4 | 0] | ye[r + 5 | 0] << 8 | (ye[r + 6 | 0] << 16 | ye[r + 7 | 0] << 24)) >>> 0 && (tu(r, c + (c >>> 1 | 0) | 0), h = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), y = h - 29 | 0), c = h >>> 0 < 29, $[(c ? r + 4 | 0 : ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)) + (c ? h : y) | 0] = o + 80, o = (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) + 1 | 0, $[r | 0] = o, $[r + 1 | 0] = o >>> 8, $[r + 2 | 0] = o >>> 16, $[r + 3 | 0] = o >>> 24;
                    break e;
                  }
                  if (!(o | c)) {
                    h = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), y = h - 29 | 0, o = (h >>> 0 < 29 ? h : y) + 1 | 0, o >>> 0 > (h >>> 0 <= 28 ? 28 : ye[r + 4 | 0] | ye[r + 5 | 0] << 8 | (ye[r + 6 | 0] << 16 | ye[r + 7 | 0] << 24)) >>> 0 && (tu(r, o + (o >>> 1 | 0) | 0), h = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), y = h - 29 | 0), o = h >>> 0 < 29, $[(o ? r + 4 | 0 : ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)) + (o ? h : y) | 0] = 0, o = (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) + 1 | 0, $[r | 0] = o, $[r + 1 | 0] = o >>> 8, $[r + 2 | 0] = o >>> 16, $[r + 3 | 0] = o >>> 24;
                    break e;
                  }
                  e[S + 12 >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, g = o, o = c >> 31, g = g ^ o, G = g - o | 0, o = (o ^ c) - ((g >>> 0 < o >>> 0) + o | 0) | 0;
                  t: {
                    r: {
                      n: {
                        for (; ; ) {
                          Fe = o, Ar = G;
                          i: {
                            if (h >>> 0 < y >>> 0) {
                              $[h | 0] = G, g = h;
                              break i;
                            }
                            if (Tr = h - ke | 0, G = Tr + 1 | 0, (G | 0) < 0) {
                              if (e[5996] = 0, Ri(8), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                break n;
                              break t;
                            }
                            g = y - ke | 0, o = g << 1, ln = g >>> 0 >= 1073741823 ? 2147483647 : o >>> 0 > G >>> 0 ? o : G;
                            s: {
                              if (!ln) {
                                G = 0;
                                break s;
                              }
                              if (e[5996] = 0, G = ii(3, ln | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                break n;
                            }
                            if (g = G + Tr | 0, $[g | 0] = Ar, (h | 0) == (ke | 0))
                              o = g;
                            else {
                              if (Rn = (ke ^ -1) + h | 0, hr = 0, y = g, o = Tr & 3, o)
                                for (; y = y - 1 | 0, h = h - 1 | 0, $[y | 0] = ye[h | 0], hr = hr + 1 | 0, (o | 0) != (hr | 0); )
                                  ;
                              if (Rn >>> 0 >= 3)
                                for (; $[y - 1 | 0] = ye[h - 1 | 0], $[y - 2 | 0] = ye[h - 2 | 0], $[y - 3 | 0] = ye[h - 3 | 0], y = y - 4 | 0, h = h - 4 | 0, $[y | 0] = ye[h | 0], (h | 0) != (ke | 0); )
                                  ;
                              h = ke, o = G;
                            }
                            if (ke = o, y = G + ln | 0, !h)
                              break i;
                            Sr(h);
                          }
                          if (o = Fe >>> 8 | 0, G = (Fe & 255) << 24 | Ar >>> 8, h = g + 1 | 0, !(!Fe & Ar >>> 0 >= 256 | Fe))
                            break;
                        }
                        e[S + 8 >> 2] = h, e[S + 4 >> 2] = ke, e[S + 12 >> 2] = y;
                        i: {
                          s: {
                            a: {
                              if (o = $[g | 0], (o | 0) < 0) {
                                if (G = c >>> 24 & 128, h >>> 0 < y >>> 0) {
                                  $[g + 1 | 0] = G, e[S + 8 >> 2] = g + 2;
                                  break i;
                                }
                                if (Ar = h - ke | 0, g = Ar + 1 | 0, (g | 0) < 0) {
                                  if (e[5996] = 0, Ri(8), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                    break t;
                                  break n;
                                }
                                c = y - ke | 0, o = c << 1, c = c >>> 0 >= 1073741823 ? 2147483647 : o >>> 0 > g >>> 0 ? o : g;
                                o: {
                                  if (!c) {
                                    g = 0;
                                    break o;
                                  }
                                  if (e[5996] = 0, g = ii(3, c | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                    break n;
                                }
                                if (y = g + Ar | 0, $[y | 0] = G, Fe = c + g | 0, G = y + 1 | 0, (h | 0) == (ke | 0))
                                  break a;
                                if (c = (ke ^ -1) + h | 0, o = Ar & 3, o)
                                  for (hr = 0; y = y - 1 | 0, h = h - 1 | 0, $[y | 0] = ye[h | 0], hr = hr + 1 | 0, (o | 0) != (hr | 0); )
                                    ;
                                if (c >>> 0 >= 3)
                                  for (; $[y - 1 | 0] = ye[h - 1 | 0], $[y - 2 | 0] = ye[h - 2 | 0], $[y - 3 | 0] = ye[h - 3 | 0], y = y - 4 | 0, h = h - 4 | 0, $[y | 0] = ye[h | 0], (h | 0) != (ke | 0); )
                                    ;
                                if (e[S + 12 >> 2] = Fe, e[S + 8 >> 2] = G, e[S + 4 >> 2] = g, !ke)
                                  break i;
                                break s;
                              }
                              if ((c | 0) > 0 | (c | 0) >= 0)
                                break i;
                              $[g | 0] = o | 128;
                              break i;
                            }
                            e[S + 12 >> 2] = Fe, e[S + 8 >> 2] = G, e[S + 4 >> 2] = y;
                          }
                          Sr(ke);
                        }
                        if (e[5996] = 0, On(19, r | 0, S + 4 | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1) {
                          if (o = e[S + 4 >> 2], !o)
                            break e;
                          Sr(o);
                          break e;
                        }
                        if (h = Vr() | 0, r = e[S + 4 >> 2], !r)
                          break r;
                        Sr(r), Ki(h | 0), ri();
                      }
                      if (h = Vr() | 0, !ke)
                        break r;
                      Sr(ke);
                    }
                    Ki(h | 0), ri();
                  }
                  ri();
                }
                return Yr = S + 16 | 0, r | 0;
              }
              function Hf(r, o, c, h) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0;
                var y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0;
                $[r | 0] = 0, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 4 | 0] = 0, $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, Ar = ye[o + 8 | 0] | ye[o + 9 | 0] << 8 | (ye[o + 10 | 0] << 16 | ye[o + 11 | 0] << 24), g = -29, S = ye[o | 0] | ye[o + 1 | 0] << 8 | (ye[o + 2 | 0] << 16 | ye[o + 3 | 0] << 24), ke = S >>> 0 < 29;
                e: {
                  if (S = ke ? S : S - 29 | 0, S >>> 0 >= 29) {
                    if (e[5996] = 0, di(124, r | 0, S + (S >>> 1 | 0) | 0), g = e[5996], e[5996] = 0, (g | 0) == 1)
                      break e;
                    y = ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24), G = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), g = G - 29 | 0;
                  }
                  Fe = r + 4 | 0, hr = G >>> 0 < 29, y = hr ? Fe : y, Ks(S + y | 0, y, hr ? G : g), g = S + (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) | 0, $[r | 0] = g, $[r + 1 | 0] = g >>> 8, $[r + 2 | 0] = g >>> 16, $[r + 3 | 0] = g >>> 24;
                  t: {
                    if (!S)
                      break t;
                    g = ke ? o + 4 | 0 : Ar, ke = S & 7;
                    r: {
                      if (!ke) {
                        o = g;
                        break r;
                      }
                      for (G = 0, o = g; $[y | 0] = ye[o | 0], o = o + 1 | 0, y = y + 1 | 0, G = G + 1 | 0, (ke | 0) != (G | 0); )
                        ;
                    }
                    if (S >>> 0 < 8)
                      break t;
                    for (g = g + S | 0; $[y | 0] = ye[o | 0], $[y + 1 | 0] = ye[o + 1 | 0], $[y + 2 | 0] = ye[o + 2 | 0], $[y + 3 | 0] = ye[o + 3 | 0], $[y + 4 | 0] = ye[o + 4 | 0], $[y + 5 | 0] = ye[o + 5 | 0], $[y + 6 | 0] = ye[o + 6 | 0], $[y + 7 | 0] = ye[o + 7 | 0], y = y + 8 | 0, o = o + 8 | 0, (g | 0) != (o | 0); )
                      ;
                  }
                  if (Ar = ye[c + 8 | 0] | ye[c + 9 | 0] << 8 | (ye[c + 10 | 0] << 16 | ye[c + 11 | 0] << 24), y = ye[c | 0] | ye[c + 1 | 0] << 8 | (ye[c + 2 | 0] << 16 | ye[c + 3 | 0] << 24), G = y >>> 0 < 29, o = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), g = o - 29 | 0, S = G ? y : y - 29 | 0, ke = o >>> 0 < 29 ? o : g, y = S + ke | 0, y >>> 0 > (o >>> 0 <= 28 ? 28 : ye[r + 4 | 0] | ye[r + 5 | 0] << 8 | (ye[r + 6 | 0] << 16 | ye[r + 7 | 0] << 24)) >>> 0) {
                    if (e[5996] = 0, di(124, r | 0, y + (y >>> 1 | 0) | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                      break e;
                    o = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), g = o - 29 | 0;
                  }
                  y = Fe, Fe = o >>> 0 < 29, y = ke + (Fe ? y : ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)) | 0, Ks(S + y | 0, y, (Fe ? o : g) - ke | 0), o = S + (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) | 0, $[r | 0] = o, $[r + 1 | 0] = o >>> 8, $[r + 2 | 0] = o >>> 16, $[r + 3 | 0] = o >>> 24;
                  t: {
                    if (!S)
                      break t;
                    c = G ? c + 4 | 0 : Ar, g = S & 7;
                    r: {
                      if (!g) {
                        o = c;
                        break r;
                      }
                      for (G = 0, o = c; $[y | 0] = ye[o | 0], o = o + 1 | 0, y = y + 1 | 0, G = G + 1 | 0, (g | 0) != (G | 0); )
                        ;
                    }
                    if (S >>> 0 < 8)
                      break t;
                    for (c = c + S | 0; $[y | 0] = ye[o | 0], $[y + 1 | 0] = ye[o + 1 | 0], $[y + 2 | 0] = ye[o + 2 | 0], $[y + 3 | 0] = ye[o + 3 | 0], $[y + 4 | 0] = ye[o + 4 | 0], $[y + 5 | 0] = ye[o + 5 | 0], $[y + 6 | 0] = ye[o + 6 | 0], $[y + 7 | 0] = ye[o + 7 | 0], y = y + 8 | 0, o = o + 8 | 0, (c | 0) != (o | 0); )
                      ;
                  }
                  if (o = e[h >> 2], e[5996] = 0, On(127, r | 0, o | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                    break e;
                  return;
                }
                o = Vr() | 0, (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) >>> 0 >= 29 && (Sr(ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)), $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0), Ki(o | 0), ri();
              }
              function Y1(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = +h, y = y | 0;
                var g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0;
                g = Yr + -64 | 0, Yr = g, e[g + 40 >> 2] = 0, e[g + 32 >> 2] = 0, e[g + 36 >> 2] = 0, Ar = e[c >> 2], ln = e[c + 4 >> 2];
                e: {
                  t: {
                    if ((Ar | 0) == (ln | 0)) {
                      c = Ar;
                      break t;
                    }
                    r: {
                      n: {
                        for (; ; ) {
                          i: {
                            Fe = e[Ar >> 2], S = e[g + 36 >> 2];
                            s: {
                              if ((S | 0) != e[g + 40 >> 2]) {
                                e[S >> 2] = e[Fe >> 2], ke = e[Fe + 4 >> 2], e[S + 4 >> 2] = ke, ke && (e[ke + 4 >> 2] = e[ke + 4 >> 2] + 1), e[g + 36 >> 2] = S + 8;
                                break s;
                              }
                              a: {
                                ke = e[g + 32 >> 2], G = S - ke | 0, Rn = G >> 3, hr = Rn + 1 | 0;
                                o: {
                                  if (hr >>> 0 >= 536870912) {
                                    if (e[5996] = 0, Ri(59), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                      break o;
                                    break n;
                                  }
                                  if (Tr = G >> 2, G = G >>> 0 >= 2147483640 ? 536870911 : hr >>> 0 < Tr >>> 0 ? Tr : hr, G >>> 0 < 536870912)
                                    break a;
                                  if (e[5996] = 0, Ri(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                    break n;
                                }
                                S = Vr() | 0;
                                break e;
                              }
                              if (e[5996] = 0, Tr = G << 3, hr = ii(3, Tr | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                                break i;
                              G = hr + (Rn << 3) | 0, e[G >> 2] = e[Fe >> 2], Fe = e[Fe + 4 >> 2], e[G + 4 >> 2] = Fe, Fe && (e[Fe + 4 >> 2] = e[Fe + 4 >> 2] + 1, S = e[g + 36 >> 2]), Fe = hr + Tr | 0, hr = G + 8 | 0;
                              a: {
                                if ((S | 0) == (ke | 0)) {
                                  e[g + 40 >> 2] = Fe, e[g + 36 >> 2] = hr, e[g + 32 >> 2] = G;
                                  break a;
                                }
                                for (; G = G - 8 | 0, S = S - 8 | 0, e[G >> 2] = e[S >> 2], e[G + 4 >> 2] = e[S + 4 >> 2], e[S >> 2] = 0, e[S + 4 >> 2] = 0, (S | 0) != (ke | 0); )
                                  ;
                                if (e[g + 40 >> 2] = Fe, S = e[g + 36 >> 2], e[g + 36 >> 2] = hr, ke = e[g + 32 >> 2], e[g + 32 >> 2] = G, (S | 0) == (ke | 0))
                                  break a;
                                for (; ; ) {
                                  S = S - 8 | 0, G = e[S + 4 >> 2];
                                  o: {
                                    if (!G || (Fe = e[G + 4 >> 2], e[G + 4 >> 2] = Fe - 1, Fe))
                                      break o;
                                    _n[e[e[G >> 2] + 8 >> 2]](G), cs(G);
                                  }
                                  if ((S | 0) == (ke | 0))
                                    break;
                                }
                              }
                              if (!ke)
                                break s;
                              Sr(ke);
                            }
                            if (Ar = Ar + 4 | 0, (ln | 0) != (Ar | 0))
                              continue;
                            break r;
                          }
                          break;
                        }
                        S = Vr() | 0;
                        break e;
                      }
                      ri();
                    }
                    Ar = e[c + 4 >> 2], c = e[c >> 2];
                  }
                  e[5996] = 0, rf(63, g + 16 | 0, o | 0, c | 0, Ar | 0, +h), c = e[5996], e[5996] = 0;
                  t: {
                    if ((c | 0) == 1 || (e[5996] = 0, c = ii(3, 104) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1))
                      break t;
                    if (e[c >> 2] = 7e3, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, e[g + 52 >> 2] = e[g + 32 >> 2], Ar = e[g + 40 >> 2], S = e[g + 36 >> 2], e[g + 40 >> 2] = 0, e[g + 56 >> 2] = S, e[g + 60 >> 2] = Ar, e[g + 32 >> 2] = 0, e[g + 36 >> 2] = 0, y = e[y >> 2], e[5996] = 0, Ar = da(64, c + 12 | 0, o | 0, g + 52 | 0, y | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1) {
                      if (o = e[g + 52 >> 2], o) {
                        if (S = e[g + 56 >> 2], (o | 0) != (S | 0)) {
                          for (; ; ) {
                            S = S - 8 | 0, y = e[S + 4 >> 2];
                            r: {
                              if (!y || (ke = e[y + 4 >> 2], e[y + 4 >> 2] = ke - 1, ke))
                                break r;
                              _n[e[e[y >> 2] + 8 >> 2]](y), cs(y);
                            }
                            if ((o | 0) == (S | 0))
                              break;
                          }
                          o = e[g + 52 >> 2];
                        }
                        Sr(o);
                      }
                      if (e[g + 48 >> 2] = c, e[g + 44 >> 2] = Ar, e[5996] = 0, o = e[g + 48 >> 2], e[g + 8 >> 2] = e[g + 44 >> 2], e[g + 12 >> 2] = o, as(61, r | 0, g + 16 | 0, g + 8 | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                        break t;
                      if (r = e[g + 32 >> 2], r) {
                        if (S = e[g + 36 >> 2], (r | 0) != (S | 0)) {
                          for (; ; ) {
                            S = S - 8 | 0, o = e[S + 4 >> 2];
                            r: {
                              if (!o || (c = e[o + 4 >> 2], e[o + 4 >> 2] = c - 1, c))
                                break r;
                              _n[e[e[o >> 2] + 8 >> 2]](o), cs(o);
                            }
                            if ((r | 0) == (S | 0))
                              break;
                          }
                          r = e[g + 32 >> 2];
                        }
                        Sr(r);
                      }
                      Yr = g - -64 | 0;
                      return;
                    }
                    S = Vr() | 0, xo(g + 52 | 0), Sr(c);
                    break e;
                  }
                  S = Vr() | 0;
                }
                xo(g + 32 | 0), Ki(S | 0), ri();
              }
              function Ol(r, o, c, h) {
                r = r | 0, o = +o, c = +c, h = h | 0;
                var y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0;
                S = Yr - 48 | 0, Yr = S;
                e: {
                  t: {
                    if (e[r >> 2] == 21) {
                      Fe = h + 4 | 0;
                      r: {
                        n: {
                          i: {
                            s: {
                              if (y = e[h + 4 >> 2], !y)
                                break s;
                              for (g = Fe; ; ) {
                                a: {
                                  o: {
                                    l: {
                                      if (ke = e[y + 16 >> 2], ke >>> 0 < r >>> 0)
                                        break l;
                                      if (r >>> 0 < ke >>> 0)
                                        break o;
                                      if (Ar = Fi[y + 24 >> 3], Ar < o)
                                        break l;
                                      if (o < Ar)
                                        break o;
                                      G = Fi[y + 32 >> 3] < c, ke = G ? y + 4 | 0 : y, g = G ? g : y;
                                      break a;
                                    }
                                    ke = y + 4 | 0;
                                    break a;
                                  }
                                  ke = y, g = y;
                                }
                                if (y = e[ke >> 2], !y)
                                  break;
                              }
                              if ((g | 0) == (Fe | 0) || (y = e[g + 16 >> 2], y >>> 0 > r >>> 0))
                                break s;
                              a: {
                                if (r >>> 0 > y >>> 0)
                                  break a;
                                if (Ar = Fi[g + 24 >> 3], Ar > o)
                                  break s;
                                if (o > Ar)
                                  break a;
                                if (Fi[g + 32 >> 3] > c)
                                  break s;
                              }
                              if (Fi[g + 56 >> 3] != o)
                                break i;
                              if (Fi[g - -64 >> 3] != c)
                                break n;
                              hr = g + 40 | 0;
                              break e;
                            }
                            if (e[S + 40 >> 2] = 0, Fi[S + 32 >> 3] = c, Fi[S + 24 >> 3] = o, e[S + 16 >> 2] = 0, e[S + 8 >> 2] = 0, e[S + 12 >> 2] = 0, y = e[r + 4 >> 2], (y | 0) == e[r + 8 >> 2]) {
                              if (e[5996] = 0, Qs(44, 4277, 1900, 673, 1984), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                break r;
                              break t;
                            }
                            if (y = e[y >> 2], e[5996] = 0, as(45, y | 0, S + 8 | 0, h | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                              break t;
                            s: {
                              a: {
                                y = Fe, ke = e[y >> 2];
                                o: {
                                  if (!ke)
                                    break o;
                                  for (; ; ) {
                                    l: {
                                      f: {
                                        y = ke, g = e[y + 16 >> 2];
                                        d: {
                                          if (g >>> 0 > r >>> 0)
                                            break d;
                                          if (r >>> 0 > g >>> 0)
                                            break l;
                                          if (Ar = Fi[y + 24 >> 3], Ar > o)
                                            break d;
                                          if (o > Ar)
                                            break l;
                                          if (Ar = Fi[y + 32 >> 3], !(Ar > c))
                                            break f;
                                        }
                                        if (Fe = y, ke = e[y >> 2], ke)
                                          continue;
                                        break o;
                                      }
                                      if (!(c > Ar))
                                        break a;
                                    }
                                    if (ke = e[y + 4 >> 2], !ke)
                                      break;
                                  }
                                  Fe = y + 4 | 0;
                                }
                                if (e[5996] = 0, G = ii(3, 80) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                  break t;
                                if (e[G + 16 >> 2] = r, Fi[G + 32 >> 3] = c, Fi[G + 24 >> 3] = o, hr = G + 40 | 0, e[hr >> 2] = e[S + 8 >> 2], e[G + 44 >> 2] = e[S + 12 >> 2], e[G + 48 >> 2] = e[S + 16 >> 2], e[S + 16 >> 2] = 0, e[S + 8 >> 2] = 0, e[S + 12 >> 2] = 0, e[G + 72 >> 2] = e[S + 40 >> 2], ke = e[S + 36 >> 2], g = G - -64 | 0, e[g >> 2] = e[S + 32 >> 2], e[g + 4 >> 2] = ke, g = e[S + 28 >> 2], e[G + 56 >> 2] = e[S + 24 >> 2], e[G + 60 >> 2] = g, e[G + 8 >> 2] = y, e[G >> 2] = 0, e[G + 4 >> 2] = 0, e[Fe >> 2] = G, y = G, g = e[e[h >> 2] >> 2], g && (e[h >> 2] = g, y = e[Fe >> 2]), Cc(e[h + 4 >> 2], y), e[h + 8 >> 2] = e[h + 8 >> 2] + 1, Fe = e[r + 4 >> 2], e[r + 8 >> 2] - Fe >>> 0 >= 5)
                                  for (g = e[G + 72 >> 2], ke = 1, y = 1; ; ) {
                                    if (Fe = e[(y << 2) + Fe >> 2], e[5996] = 0, as(45, Fe | 0, hr | 0, h | 0), Fe = e[5996], e[5996] = 0, (Fe | 0) == 1)
                                      break s;
                                    if (Fe = g, g = e[G + 72 >> 2], ke = (Fe | 0) == (g | 0) ? ke : y, y = y + 1 | 0, Fe = e[r + 4 >> 2], y = (y | 0) == e[r + 8 >> 2] - Fe >> 2 ? 1 : y, (ke | 0) == (y | 0))
                                      break;
                                  }
                                if (h = e[S + 8 >> 2], !h)
                                  break e;
                                if (r = e[S + 12 >> 2], (h | 0) != (r | 0)) {
                                  for (; ; ) {
                                    r = r - 32 | 0, y = e[r + 4 >> 2];
                                    o: {
                                      if (!y || (g = e[y + 4 >> 2], e[y + 4 >> 2] = g - 1, g))
                                        break o;
                                      _n[e[e[y >> 2] + 8 >> 2]](y), cs(y);
                                    }
                                    if ((r | 0) == (h | 0))
                                      break;
                                  }
                                  h = e[S + 8 >> 2];
                                }
                                Sr(h);
                                break e;
                              }
                              if (e[5996] = 0, Qs(44, 2453, 1900, 676, 1984), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                break r;
                              break t;
                            }
                            break t;
                          }
                          aa(1940, 1900, 668, 1984), ri();
                        }
                        aa(1841, 1900, 669, 1984);
                      }
                      ri();
                    }
                    aa(3430, 1900, 664, 1984), ri();
                  }
                  r = Vr() | 0, lu(S + 8 | 0), Ki(r | 0), ri();
                }
                return Yr = S + 48 | 0, hr | 0;
              }
              function $d(r, o, c, h, y, g, S, G, ke) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, G = G | 0, ke = ke | 0;
                var Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0;
                Fe = Yr - 1056 | 0, Yr = Fe, e[Fe + 16 >> 2] = g, e[Fe + 20 >> 2] = S, e[Fe + 24 >> 2] = G, e[Fe + 28 >> 2] = ke, r = Fe + 944 | 0, e[Fe + 940 >> 2] = r, hr = wl(r, 100, 2304, Fe + 16 | 0), e[Fe + 48 >> 2] = 184, ln = Fe + 520 | 0, e[ln >> 2] = 0, e[ln + 4 >> 2] = e[Fe + 48 >> 2], e[Fe + 48 >> 2] = 184, Tr = Fe + 512 | 0, e[Tr >> 2] = 0, e[Tr + 4 >> 2] = e[Fe + 48 >> 2];
                e: {
                  t: {
                    r: {
                      n: {
                        if (hr >>> 0 < 100) {
                          G = Fe + 528 | 0;
                          break n;
                        }
                        if (r = mo(), e[Fe >> 2] = g, e[Fe + 4 >> 2] = S, e[Fe + 8 >> 2] = G, e[Fe + 12 >> 2] = ke, hr = fu(Fe + 940 | 0, r, 2304, Fe), (hr | 0) != -1 && (r = e[Fe + 940 >> 2], Yo(ln, r), Yo(Tr, ia(hr << 2)), G = e[Tr >> 2], G))
                          break n;
                        if (e[5996] = 0, Ri(185), r = e[5996], e[5996] = 0, (r | 0) != 1)
                          break e;
                        hr = Vr() | 0;
                        break r;
                      }
                      g = e[h + 28 >> 2], e[Fe + 508 >> 2] = g, e[g + 4 >> 2] = e[g + 4 >> 2] + 1, e[5996] = 0, ci = ii(197, e[Fe + 508 >> 2]) | 0, g = e[5996], e[5996] = 0;
                      n: {
                        i: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  if ((g | 0) == 1 || (e[5996] = 0, Qs(208, ci | 0, r | 0, r + hr | 0, G | 0), g = e[5996], e[5996] = 0, (g | 0) == 1))
                                    break l;
                                  if (Mn = (hr | 0) > 0 ? ye[r | 0] == 45 : Mn, S = Fe + 484 | 0, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, r = Fe + 472 | 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, g = Fe + 460 | 0, e[g >> 2] = 0, e[g + 4 >> 2] = 0, e[g + 8 >> 2] = 0, e[5996] = 0, Bc(238, c | 0, Mn | 0, e[Fe + 508 >> 2], Fe + 504 | 0, Fe + 500 | 0, Fe + 496 | 0, S | 0, r | 0, g | 0, Fe + 456 | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                    break o;
                                  e[Fe + 36 >> 2] = 184, c = Fe + 40 | 0, e[c >> 2] = 0, e[c + 4 >> 2] = e[Fe + 36 >> 2], ke = Fe + 48 | 0, Rn = e[Fe + 456 >> 2];
                                  f: {
                                    if ((Rn | 0) < (hr | 0)) {
                                      Ar = ye[g + 11 | 0], ei = (hr - Rn << 1) + ((Ar & 128) >>> 7 | 0 ? e[g + 4 >> 2] : Ar & 127) | 0, Ar = ye[r + 11 | 0], Ar = (ei + ((Ar & 128) >>> 7 | 0 ? e[r + 4 >> 2] : Ar & 127) | 0) + 1 | 0;
                                      break f;
                                    }
                                    Ar = ye[g + 11 | 0], ei = (Ar & 128) >>> 7 | 0 ? e[g + 4 >> 2] : Ar & 127, Ar = ye[r + 11 | 0], Ar = (ei + ((Ar & 128) >>> 7 | 0 ? e[r + 4 >> 2] : Ar & 127) | 0) + 2 | 0;
                                  }
                                  if (Ar = Ar + Rn | 0, Ar >>> 0 < 101 || (Yo(c, ia(Ar << 2)), ke = e[c >> 2], ke))
                                    break a;
                                  if (e[5996] = 0, Ri(185), o = e[5996], e[5996] = 0, (o | 0) != 1)
                                    break e;
                                  break s;
                                }
                                hr = Vr() | 0;
                                break n;
                              }
                              hr = Vr() | 0;
                              break i;
                            }
                            if (Ar = e[h + 4 >> 2], e[5996] = 0, Uf(239, ke | 0, Fe + 36 | 0, Fe + 32 | 0, Ar | 0, G | 0, (hr << 2) + G | 0, ci | 0, Mn | 0, Fe + 504 | 0, e[Fe + 500 >> 2], e[Fe + 496 >> 2], S | 0, r | 0, g | 0, Rn | 0), G = e[5996], e[5996] = 0, (G | 0) != 1 && (e[5996] = 0, h = Fa(219, o | 0, ke | 0, e[Fe + 36 >> 2], e[Fe + 32 >> 2], h | 0, y | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1))
                              break t;
                          }
                          hr = Vr() | 0, Js(c);
                        }
                        qi(g), qi(r), qi(S);
                      }
                      r = e[Fe + 508 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r);
                    }
                    Js(Tr), Js(ln), Ki(hr | 0), ri();
                  }
                  return Js(c), qi(g), qi(r), qi(S), r = e[Fe + 508 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Js(Tr), Js(ln), Yr = Fe + 1056 | 0, h | 0;
                }
                ri();
              }
              function eh(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0;
                if (c = e[r + 4 >> 2], h = e[r + 8 >> 2], c >>> 0 < h >>> 0) {
                  h = e[o >> 2], e[c + 12 >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, e[c >> 2] = h, e[c + 4 >> 2] = e[o + 4 >> 2], e[c + 8 >> 2] = e[o + 8 >> 2], e[c + 12 >> 2] = e[o + 12 >> 2], e[o + 12 >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[c + 24 >> 2] = 0, e[c + 16 >> 2] = 0, e[c + 20 >> 2] = 0, e[c + 16 >> 2] = e[o + 16 >> 2], e[c + 20 >> 2] = e[o + 20 >> 2], e[c + 24 >> 2] = e[o + 24 >> 2], e[o + 24 >> 2] = 0, e[o + 16 >> 2] = 0, e[o + 20 >> 2] = 0, e[c + 36 >> 2] = 0, e[c + 28 >> 2] = 0, e[c + 32 >> 2] = 0, e[c + 28 >> 2] = e[o + 28 >> 2], e[c + 32 >> 2] = e[o + 32 >> 2], e[c + 36 >> 2] = e[o + 36 >> 2], e[o + 36 >> 2] = 0, e[o + 28 >> 2] = 0, e[o + 32 >> 2] = 0, e[c + 48 >> 2] = 0, e[c + 40 >> 2] = 0, e[c + 44 >> 2] = 0, e[c + 40 >> 2] = e[o + 40 >> 2], e[c + 44 >> 2] = e[o + 44 >> 2], e[c + 48 >> 2] = e[o + 48 >> 2], e[o + 48 >> 2] = 0, e[o + 40 >> 2] = 0, e[o + 44 >> 2] = 0, e[c + 52 >> 2] = e[o + 52 >> 2], e[r + 4 >> 2] = c + 56;
                  return;
                }
                e: {
                  t: {
                    r: {
                      if (y = e[r >> 2], g = (c - y | 0) / 56 | 0, c = g + 1 | 0, c >>> 0 < 76695845) {
                        if (h = (h - y | 0) / 56 | 0, y = h << 1, c = h >>> 0 >= 38347922 ? 76695844 : c >>> 0 < y >>> 0 ? y : c, c >>> 0 >= 76695845)
                          break r;
                        if (h = vi(c, 56), y = xs(h), c = y + vi(g, 56) | 0, e[c >> 2] = e[o >> 2], e[c + 4 >> 2] = e[o + 4 >> 2], e[c + 8 >> 2] = e[o + 8 >> 2], e[c + 12 >> 2] = e[o + 12 >> 2], e[o + 12 >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[c + 16 >> 2] = e[o + 16 >> 2], e[c + 20 >> 2] = e[o + 20 >> 2], e[c + 24 >> 2] = e[o + 24 >> 2], e[o + 24 >> 2] = 0, e[o + 16 >> 2] = 0, e[o + 20 >> 2] = 0, e[c + 28 >> 2] = e[o + 28 >> 2], e[c + 32 >> 2] = e[o + 32 >> 2], e[c + 36 >> 2] = e[o + 36 >> 2], e[o + 36 >> 2] = 0, e[o + 28 >> 2] = 0, e[o + 32 >> 2] = 0, e[c + 40 >> 2] = e[o + 40 >> 2], e[c + 44 >> 2] = e[o + 44 >> 2], e[c + 48 >> 2] = e[o + 48 >> 2], e[o + 48 >> 2] = 0, e[o + 40 >> 2] = 0, e[o + 44 >> 2] = 0, e[c + 52 >> 2] = e[o + 52 >> 2], h = h + y | 0, y = c + 56 | 0, o = e[r + 4 >> 2], g = e[r >> 2], (o | 0) == (g | 0))
                          break t;
                        for (; c = c - 56 | 0, o = o - 56 | 0, e[c >> 2] = e[o >> 2], e[c + 4 >> 2] = e[o + 4 >> 2], e[c + 8 >> 2] = e[o + 8 >> 2], e[c + 12 >> 2] = e[o + 12 >> 2], e[o + 12 >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[c + 16 >> 2] = e[o + 16 >> 2], e[c + 20 >> 2] = e[o + 20 >> 2], e[c + 24 >> 2] = e[o + 24 >> 2], e[o + 24 >> 2] = 0, e[o + 16 >> 2] = 0, e[o + 20 >> 2] = 0, e[c + 28 >> 2] = e[o + 28 >> 2], e[c + 32 >> 2] = e[o + 32 >> 2], e[c + 36 >> 2] = e[o + 36 >> 2], e[o + 36 >> 2] = 0, e[o + 28 >> 2] = 0, e[o + 32 >> 2] = 0, e[c + 40 >> 2] = e[o + 40 >> 2], e[c + 44 >> 2] = e[o + 44 >> 2], e[c + 48 >> 2] = e[o + 48 >> 2], e[o + 48 >> 2] = 0, e[o + 40 >> 2] = 0, e[o + 44 >> 2] = 0, e[c + 52 >> 2] = e[o + 52 >> 2], (o | 0) != (g | 0); )
                          ;
                        if (e[r + 8 >> 2] = h, h = e[r + 4 >> 2], e[r + 4 >> 2] = y, o = e[r >> 2], e[r >> 2] = c, (o | 0) == (h | 0))
                          break e;
                        for (; h = Ra(h - 56 | 0), (h | 0) != (o | 0); )
                          ;
                        break e;
                      }
                      Lo(), ri();
                    }
                    su(), ri();
                  }
                  e[r + 8 >> 2] = h, e[r + 4 >> 2] = y, e[r >> 2] = c;
                }
                o && Sr(o);
              }
              function X1(r, o, c, h, y, g, S, G, ke) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, G = G | 0, ke = ke | 0;
                var Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0;
                Fe = Yr - 448 | 0, Yr = Fe, e[Fe + 16 >> 2] = g, e[Fe + 20 >> 2] = S, e[Fe + 24 >> 2] = G, e[Fe + 28 >> 2] = ke, r = Fe + 336 | 0, e[Fe + 332 >> 2] = r, hr = wl(r, 100, 2304, Fe + 16 | 0), e[Fe + 48 >> 2] = 184, ln = Fe + 216 | 0, e[ln >> 2] = 0, e[ln + 4 >> 2] = e[Fe + 48 >> 2], e[Fe + 48 >> 2] = 184, Tr = Fe + 208 | 0, e[Tr >> 2] = 0, e[Tr + 4 >> 2] = e[Fe + 48 >> 2];
                e: {
                  t: {
                    r: {
                      n: {
                        if (hr >>> 0 < 100) {
                          G = Fe + 224 | 0;
                          break n;
                        }
                        if (r = mo(), e[Fe >> 2] = g, e[Fe + 4 >> 2] = S, e[Fe + 8 >> 2] = G, e[Fe + 12 >> 2] = ke, hr = fu(Fe + 332 | 0, r, 2304, Fe), (hr | 0) != -1 && (r = e[Fe + 332 >> 2], Yo(ln, r), Yo(Tr, ia(hr)), G = e[Tr >> 2], G))
                          break n;
                        if (e[5996] = 0, Ri(185), r = e[5996], e[5996] = 0, (r | 0) != 1)
                          break e;
                        hr = Vr() | 0;
                        break r;
                      }
                      g = e[h + 28 >> 2], e[Fe + 204 >> 2] = g, e[g + 4 >> 2] = e[g + 4 >> 2] + 1, e[5996] = 0, ci = ii(170, e[Fe + 204 >> 2]) | 0, g = e[5996], e[5996] = 0;
                      n: {
                        i: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  if ((g | 0) == 1 || (e[5996] = 0, Qs(195, ci | 0, r | 0, r + hr | 0, G | 0), g = e[5996], e[5996] = 0, (g | 0) == 1))
                                    break l;
                                  if (Mn = (hr | 0) > 0 ? ye[r | 0] == 45 : Mn, S = Fe + 184 | 0, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, r = Fe + 172 | 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, g = Fe + 160 | 0, e[g >> 2] = 0, e[g + 4 >> 2] = 0, e[g + 8 >> 2] = 0, e[5996] = 0, Bc(236, c | 0, Mn | 0, e[Fe + 204 >> 2], Fe + 200 | 0, Fe + 199 | 0, Fe + 198 | 0, S | 0, r | 0, g | 0, Fe + 156 | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                                    break o;
                                  e[Fe + 36 >> 2] = 184, c = Fe + 40 | 0, e[c >> 2] = 0, e[c + 4 >> 2] = e[Fe + 36 >> 2], ke = Fe + 48 | 0, Rn = e[Fe + 156 >> 2];
                                  f: {
                                    if ((Rn | 0) < (hr | 0)) {
                                      Ar = ye[g + 11 | 0], ei = (hr - Rn << 1) + ((Ar & 128) >>> 7 | 0 ? e[g + 4 >> 2] : Ar & 127) | 0, Ar = ye[r + 11 | 0], Ar = (ei + ((Ar & 128) >>> 7 | 0 ? e[r + 4 >> 2] : Ar & 127) | 0) + 1 | 0;
                                      break f;
                                    }
                                    Ar = ye[g + 11 | 0], ei = (Ar & 128) >>> 7 | 0 ? e[g + 4 >> 2] : Ar & 127, Ar = ye[r + 11 | 0], Ar = (ei + ((Ar & 128) >>> 7 | 0 ? e[r + 4 >> 2] : Ar & 127) | 0) + 2 | 0;
                                  }
                                  if (Ar = Ar + Rn | 0, Ar >>> 0 < 101 || (Yo(c, ia(Ar)), ke = e[c >> 2], ke))
                                    break a;
                                  if (e[5996] = 0, Ri(185), o = e[5996], e[5996] = 0, (o | 0) != 1)
                                    break e;
                                  break s;
                                }
                                hr = Vr() | 0;
                                break n;
                              }
                              hr = Vr() | 0;
                              break i;
                            }
                            if (Ar = e[h + 4 >> 2], e[5996] = 0, Uf(237, ke | 0, Fe + 36 | 0, Fe + 32 | 0, Ar | 0, G | 0, G + hr | 0, ci | 0, Mn | 0, Fe + 200 | 0, $[Fe + 199 | 0], $[Fe + 198 | 0], S | 0, r | 0, g | 0, Rn | 0), G = e[5996], e[5996] = 0, (G | 0) != 1 && (e[5996] = 0, h = Fa(213, o | 0, ke | 0, e[Fe + 36 >> 2], e[Fe + 32 >> 2], h | 0, y | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1))
                              break t;
                          }
                          hr = Vr() | 0, Js(c);
                        }
                        qi(g), qi(r), qi(S);
                      }
                      r = e[Fe + 204 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r);
                    }
                    Js(Tr), Js(ln), Ki(hr | 0), ri();
                  }
                  return Js(c), qi(g), qi(r), qi(S), r = e[Fe + 204 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Js(Tr), Js(ln), Yr = Fe + 448 | 0, h | 0;
                }
                ri();
              }
              function th(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = +y;
                var g = 0, S = 0, G = 0, ke = 0, Fe = 0;
                e: {
                  t: {
                    if (!(o - 19 >>> 0 >= 7 & y != 0)) {
                      g = 1 - y;
                      r:
                        switch (o | 0) {
                          case 24:
                            if ((c | 0) != (h | 0))
                              for (; o = e[c >> 2], G = G + Fi[o + 8 >> 3], S = S + Fi[o + 16 >> 3], c = c + 4 | 0, (h | 0) != (c | 0); )
                                ;
                            Fi[r + 8 >> 3] = S, Fi[r >> 3] = (g == 0 ? 0 : g * S) + (y == 0 ? 0 : G * y);
                            return;
                          case 3:
                            e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 1078034432, e[r >> 2] = 0, e[r + 4 >> 2] = 1079689216;
                            return;
                          case 6:
                          case 7:
                          case 8:
                          case 9:
                            e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 1077968896, e[r >> 2] = 0, e[r + 4 >> 2] = 1077968896;
                            return;
                          case 10:
                          case 11:
                          case 12:
                          case 16:
                            o = e[c >> 2], c = e[o + 12 >> 2], e[r >> 2] = e[o + 8 >> 2], e[r + 4 >> 2] = c, c = e[o + 20 >> 2], e[r + 8 >> 2] = e[o + 16 >> 2], e[r + 12 >> 2] = c;
                            return;
                          case 13:
                            y = Fi[e[c >> 2] + 8 >> 3], e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 1072693248, Fi[r >> 3] = y + 2;
                            return;
                          case 14:
                            y = Fi[e[c >> 2] + 8 >> 3], e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 2146435072, Fi[r >> 3] = y;
                            return;
                          case 15:
                            y = Fi[e[c >> 2] + 8 >> 3], e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 1072693248, Fi[r >> 3] = y;
                            return;
                          case 0:
                            e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 2146435072;
                            return;
                          case 17:
                            y = Fi[e[c + 4 >> 2] + 8 >> 3], g = Fi[e[c >> 2] + 8 >> 3], e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 2146435072, Fi[r >> 3] = g + y;
                            return;
                          case 18:
                            o = e[c + 4 >> 2], y = Fi[o + 16 >> 3], c = e[c >> 2], g = Fi[c + 16 >> 3], Fi[r >> 3] = Fi[c + 8 >> 3] + Fi[o + 8 >> 3], Fi[r + 8 >> 3] = g + y;
                            return;
                          case 19:
                            o = e[c >> 2], S = Fi[o + 8 >> 3], c = e[c + 4 >> 2], G = Fi[c + 8 >> 3], ke = Fi[c + 16 >> 3], Fe = Fi[o + 16 >> 3], Fi[r + 8 >> 3] = ke + Fe, Fi[r >> 3] = (y == 0 ? 0 : (S + ke) * y) + (g == 0 ? 0 : g * (Fe + G));
                            return;
                          case 20:
                          case 21:
                            o = e[c + 4 >> 2], S = Fi[o + 8 >> 3], c = e[c >> 2], G = Fi[c + 8 >> 3], ke = Fi[c + 16 >> 3], Fi[r + 8 >> 3] = ke + Fi[o + 16 >> 3], Fi[r >> 3] = (y == 0 ? 0 : G * y) + (g == 0 ? 0 : g * (ke + S));
                            return;
                          case 22:
                            o = e[c >> 2], S = Fi[o + 8 >> 3], c = e[c + 4 >> 2], G = Fi[c + 8 >> 3], ke = Fi[c + 16 >> 3] + 1, Fe = Fi[o + 16 >> 3] + 2, Fi[r + 8 >> 3] = ke < Fe ? ke : Fe, Fi[r >> 3] = (y == 0 ? 0 : (S + 2) * y) + (g == 0 ? 0 : g * (G + 1));
                            return;
                          case 23:
                            o = e[c + 8 >> 2], S = Fi[o + 8 >> 3], G = Fi[e[c + 4 >> 2] + 8 >> 3], c = e[c >> 2], ke = Fi[c + 8 >> 3], Fe = Fi[c + 16 >> 3], Fi[r + 8 >> 3] = Fe + Fi[o + 16 >> 3], Fi[r >> 3] = (y == 0 ? 0 : (ke + G) * y) + (g == 0 ? 0 : g * (Fe + S));
                            return;
                          default:
                            if (r = ru(8), e[5996] = 0, o = On(91, r | 0, 1318) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1)
                              break t;
                            o = Vr() | 0, Ku(r), Ki(o | 0), ri();
                          case 1:
                          case 4:
                          case 5:
                            break e;
                          case 2:
                            break r;
                        }
                      e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 1072693248, e[r >> 2] = 0, e[r + 4 >> 2] = 1079132160;
                      return;
                    }
                    aa(4323, 1900, 476, 1746), ri();
                  }
                  xa(o | 0, 22664, 92), ri();
                }
                e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 2146435072, e[r >> 2] = 0, e[r + 4 >> 2] = 0;
              }
              function Ql(r, o, c, h, y, g, S, G, ke) {
                var Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0, Qi = 0;
                Fe = Yr - 128 | 0, Yr = Fe;
                e: {
                  t: {
                    r: {
                      if (!Lu(g, S, G, ke, 0, 0, 0, 0))
                        break r;
                      Ar = ke & 65535, ln = ke >>> 16 & 32767;
                      n:
                        i: {
                          if ((ln | 0) != 32767) {
                            if (hr = 4, ln)
                              break i;
                            hr = g | G | (S | Ar) ? 3 : 2;
                            break n;
                          }
                          hr = !(g | G | (S | Ar));
                        }
                      if (gi = y >>> 16 | 0, Rn = gi & 32767, (Rn | 0) == 32767)
                        break r;
                      if (hr)
                        break t;
                    }
                    To(Fe + 16 | 0, o, c, h, y, g, S, G, ke), o = e[Fe + 16 >> 2], h = e[Fe + 20 >> 2], y = e[Fe + 24 >> 2], c = e[Fe + 28 >> 2], Dl(Fe, o, h, y, c, o, h, y, c), h = e[Fe + 8 >> 2], y = e[Fe + 12 >> 2], G = e[Fe >> 2], ke = e[Fe + 4 >> 2];
                    break e;
                  }
                  if (hr = h, Mn = y & 2147483647, Ar = Mn, ln = G, Tr = ke & 2147483647, (Lu(o, c, hr, Ar, g, S, G, Tr) | 0) <= 0) {
                    if (Lu(o, c, hr, Ar, g, S, G, Tr)) {
                      G = o, ke = c;
                      break e;
                    }
                    To(Fe + 112 | 0, o, c, h, y, 0, 0, 0, 0), h = e[Fe + 120 >> 2], y = e[Fe + 124 >> 2], G = e[Fe + 112 >> 2], ke = e[Fe + 116 >> 2];
                    break e;
                  }
                  if (ei = ke >>> 16 & 32767, Rn ? (ke = c, G = o) : (To(Fe + 96 | 0, o, c, hr, Mn, 0, 0, 0, 1081540608), hr = e[Fe + 104 >> 2], G = e[Fe + 108 >> 2], Mn = G, Rn = (G >>> 16 | 0) - 120 | 0, ke = e[Fe + 100 >> 2], G = e[Fe + 96 >> 2]), ei || (To(Fe + 80 | 0, g, S, ln, Tr, 0, 0, 0, 1081540608), ln = e[Fe + 88 >> 2], g = e[Fe + 92 >> 2], Tr = g, ei = (g >>> 16 | 0) - 120 | 0, S = e[Fe + 84 >> 2], g = e[Fe + 80 >> 2]), ci = ln, Qi = Tr & 65535 | 65536, Mn = Mn & 65535 | 65536, (Rn | 0) > (ei | 0)) {
                    for (; ; ) {
                      Tr = hr - ci | 0, Ar = (S | 0) == (ke | 0) & g >>> 0 > G >>> 0 | S >>> 0 > ke >>> 0, ln = Tr - Ar | 0, Ar = (Mn - ((hr >>> 0 < ci >>> 0) + Qi | 0) | 0) - (Ar >>> 0 > Tr >>> 0) | 0;
                      t: {
                        if ((Ar | 0) > 0 | (Ar | 0) >= 0) {
                          if (hr = G, G = G - g | 0, ke = ke - ((g >>> 0 > hr >>> 0) + S | 0) | 0, !(G | ln | (ke | Ar))) {
                            To(Fe + 32 | 0, o, c, h, y, 0, 0, 0, 0), h = e[Fe + 40 >> 2], y = e[Fe + 44 >> 2], G = e[Fe + 32 >> 2], ke = e[Fe + 36 >> 2];
                            break e;
                          }
                          Ar = Ar << 1 | ln >>> 31, hr = ln << 1 | ke >>> 31;
                          break t;
                        }
                        Ar = Mn << 1 | hr >>> 31, hr = hr << 1 | ke >>> 31;
                      }
                      if (Mn = Ar, Ar = ke << 1 | G >>> 31, G = G << 1, ke = Ar, Rn = Rn - 1 | 0, !((Rn | 0) > (ei | 0)))
                        break;
                    }
                    Rn = ei;
                  }
                  Tr = hr - ci | 0, Ar = (S | 0) == (ke | 0) & g >>> 0 > G >>> 0 | S >>> 0 > ke >>> 0, ln = Tr - Ar | 0, Ar = (Mn - ((hr >>> 0 < ci >>> 0) + Qi | 0) | 0) - (Ar >>> 0 > Tr >>> 0) | 0, Tr = Ar;
                  t: {
                    if ((Ar | 0) < 0) {
                      ln = hr, Tr = Mn;
                      break t;
                    }
                    if (hr = G, G = G - g | 0, ke = ke - ((g >>> 0 > hr >>> 0) + S | 0) | 0, G | ln | (ke | Tr))
                      break t;
                    To(Fe + 48 | 0, o, c, h, y, 0, 0, 0, 0), h = e[Fe + 56 >> 2], y = e[Fe + 60 >> 2], G = e[Fe + 48 >> 2], ke = e[Fe + 52 >> 2];
                    break e;
                  }
                  if ((Tr | 0) == 65535 | Tr >>> 0 < 65535)
                    for (; o = ke >>> 31 | 0, Rn = Rn - 1 | 0, Mn = ke << 1 | G >>> 31, G = G << 1, ke = Mn, c = o, o = Tr << 1 | ln >>> 31, ln = c | ln << 1, Tr = o, o >>> 0 < 65536; )
                      ;
                  if (o = gi & 32768, (Rn | 0) <= 0) {
                    To(Fe - -64 | 0, G, ke, ln, Tr & 65535 | (o | Rn + 120) << 16, 0, 0, 0, 1065811968), h = e[Fe + 72 >> 2], y = e[Fe + 76 >> 2], G = e[Fe + 64 >> 2], ke = e[Fe + 68 >> 2];
                    break e;
                  }
                  h = ln, y = Tr & 65535 | (o | Rn) << 16;
                }
                e[r >> 2] = G, e[r + 4 >> 2] = ke, e[r + 8 >> 2] = h, e[r + 12 >> 2] = y, Yr = Fe + 128 | 0;
              }
              function rh(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0;
                G = e[o >> 2], g = ye[o + 11 | 0], S = g << 24 >> 24, c = (S | 0) < 0, ke = e[o + 4 >> 2], h = c ? ke : g;
                e: {
                  if ((h | 0) < 9)
                    break e;
                  for (g = c ? G : o, y = g + h | 0; ; ) {
                    for (c = g; ; ) {
                      if (c = nu(c, 115, h - 8 | 0), !c)
                        break e;
                      if (pa(c, 4824, 9)) {
                        if (c = c + 1 | 0, h = y - c | 0, (h | 0) >= 9)
                          continue;
                        break e;
                      }
                      break;
                    }
                    if ((c | 0) == (y | 0) || (c = c - g | 0, (c | 0) == -1))
                      break e;
                    if (df(o, c, 9, 5034), G = e[o >> 2], c = ye[o + 11 | 0], S = c << 24 >> 24, y = (S | 0) < 0, g = y ? G : o, ke = e[o + 4 >> 2], h = y ? ke : c, y = g + h | 0, !((h | 0) > 8))
                      break;
                  }
                }
                c = S << 24 >> 24, h = (c | 0) < 0 ? ke : S & 255;
                e: {
                  if ((h | 0) < 10)
                    break e;
                  for (g = (c | 0) < 0 ? G : o, y = g + h | 0; ; ) {
                    for (c = g; ; ) {
                      if (c = nu(c, 104, h - 9 | 0), !c)
                        break e;
                      if (pa(c, 4813, 10)) {
                        if (c = c + 1 | 0, h = y - c | 0, (h | 0) >= 10)
                          continue;
                        break e;
                      }
                      break;
                    }
                    if ((c | 0) == (y | 0) || (c = c - g | 0, (c | 0) == -1))
                      break e;
                    if (df(o, c, 10, 4960), G = e[o >> 2], c = ye[o + 11 | 0], S = c << 24 >> 24, y = (S | 0) < 0, g = y ? G : o, ke = e[o + 4 >> 2], h = y ? ke : c, y = g + h | 0, !((h | 0) > 9))
                      break;
                  }
                }
                c = S << 24 >> 24 < 0, h = c ? ke : S & 255;
                e: {
                  if ((h | 0) < 12)
                    break e;
                  for (g = c ? G : o, y = g + h | 0; ; ) {
                    for (c = g; ; ) {
                      if (c = nu(c, 114, h - 11 | 0), !c)
                        break e;
                      if (pa(c, 4845, 12)) {
                        if (c = c + 1 | 0, h = y - c | 0, (h | 0) >= 12)
                          continue;
                        break e;
                      }
                      break;
                    }
                    if ((c | 0) == (y | 0) || (c = c - g | 0, (c | 0) == -1))
                      break e;
                    if (df(o, c, 12, 4908), G = e[o >> 2], c = ye[o + 11 | 0], S = c << 24 >> 24, y = (S | 0) < 0, g = y ? G : o, ke = e[o + 4 >> 2], h = y ? ke : c, y = g + h | 0, !((h | 0) > 11))
                      break;
                  }
                }
                c = S << 24 >> 24, h = (c | 0) < 0 ? ke : S & 255;
                e: {
                  if ((h | 0) < 10)
                    break e;
                  for (g = (c | 0) < 0 ? G : o, y = g + h | 0; ; ) {
                    for (c = g; ; ) {
                      if (c = nu(c, 104, h - 9 | 0), !c)
                        break e;
                      if (pa(c, 4834, 10)) {
                        if (c = c + 1 | 0, h = y - c | 0, (h | 0) >= 10)
                          continue;
                        break e;
                      }
                      break;
                    }
                    if ((c | 0) == (y | 0) || (c = c - g | 0, (c | 0) == -1))
                      break e;
                    if (df(o, c, 10, 4858), G = e[o >> 2], c = ye[o + 11 | 0], S = c << 24 >> 24, y = (S | 0) < 0, g = y ? G : o, ke = e[o + 4 >> 2], h = y ? ke : c, y = g + h | 0, !((h | 0) > 9))
                      break;
                  }
                }
                c = S << 24 >> 24 < 0, h = c ? ke : S & 255;
                e: {
                  if ((h | 0) <= 0)
                    break e;
                  for (y = c ? G : o, S = y + h | 0; ; ) {
                    for (c = y; ; ) {
                      if (c = nu(c, 32, h), !c)
                        break e;
                      if (ye[c | 0] != 32) {
                        if (c = c + 1 | 0, h = S - c | 0, (h | 0) > 0)
                          continue;
                        break e;
                      }
                      break;
                    }
                    if ((c | 0) == (S | 0) || (c = c - y | 0, (c | 0) == -1))
                      break e;
                    if (df(o, c, 1, 5575), c = ye[o + 11 | 0], g = c << 24 >> 24 < 0, y = g ? e[o >> 2] : o, h = g ? e[o + 4 >> 2] : c, S = y + h | 0, !((h | 0) > 0))
                      break;
                  }
                }
                c = e[o + 4 >> 2], e[r >> 2] = e[o >> 2], e[r + 4 >> 2] = c, e[r + 8 >> 2] = e[o + 8 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0;
              }
              function nh(r, o, c, h, y, g, S) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0;
                var G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0;
                Ar = Yr - 16 | 0, Yr = Ar, hr = a4(e[S >> 2]), Rn = c4(e[S >> 2]), S = Rn, _n[e[e[S >> 2] + 20 >> 2]](Ar + 4 | 0, S), e[g >> 2] = h;
                e: {
                  t: {
                    r:
                      switch (ke = r, S = ye[ke | 0], S - 43 | 0) {
                        case 0:
                        case 2:
                          break r;
                        default:
                          break t;
                      }
                    if (e[5996] = 0, S = On(216, hr | 0, S << 24 >> 24) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                      break e;
                    ke = e[g >> 2], e[g >> 2] = ke + 4, e[ke >> 2] = S, ke = r + 1 | 0;
                  }
                  t: {
                    if (S = ke, !((c - S | 0) <= 1 | ye[S | 0] != 48 | (ye[S + 1 | 0] | 32) != 120)) {
                      if (e[5996] = 0, ke = On(216, hr | 0, 48) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1 || (G = e[g >> 2], e[g >> 2] = G + 4, e[G >> 2] = ke, ke = $[S + 1 | 0], e[5996] = 0, ke = On(216, hr | 0, ke | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1))
                        break e;
                      for (G = e[g >> 2], e[g >> 2] = G + 4, e[G >> 2] = ke, ke = S + 2 | 0, S = ke; ; ) {
                        if (c >>> 0 <= S >>> 0 || (G = $[S | 0], mo(), !(G - 48 >>> 0 < 10 | (G | 32) - 97 >>> 0 < 6)))
                          break t;
                        S = S + 1 | 0;
                      }
                    }
                    for (; ; ) {
                      if (c >>> 0 <= S >>> 0 || (G = $[S | 0], mo(), G - 48 >>> 0 >= 10))
                        break t;
                      S = S + 1 | 0;
                    }
                  }
                  t: {
                    if (G = ye[Ar + 15 | 0], !((G & 128) >>> 7 | 0 ? e[Ar + 8 >> 2] : G & 127)) {
                      if (G = e[g >> 2], e[5996] = 0, Qs(208, hr | 0, ke | 0, S | 0, G | 0), G = e[5996], e[5996] = 0, (G | 0) == 1)
                        break e;
                      e[g >> 2] = e[g >> 2] + (S - ke << 2);
                      break t;
                    }
                    if (iu(ke, S), e[5996] = 0, ei = ii(206, Rn | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                      break e;
                    for (G = ke; ; ) {
                      if (S >>> 0 <= G >>> 0) {
                        D2((ke - r << 2) + h | 0, e[g >> 2]);
                        break t;
                      }
                      if (Fe = Ar + 4 | 0, Tr = (ye[Fe + 11 | 0] & 128) >>> 7 | 0, $[(Tr ? e[Fe >> 2] : Fe) + ln | 0] <= 0 | $[(Tr ? e[Fe >> 2] : Fe) + ln | 0] != (Mn | 0) || (Fe = e[g >> 2], e[g >> 2] = Fe + 4, e[Fe >> 2] = ei, Mn = 0, Fe = ye[Ar + 15 | 0], ln = (((Fe & 128) >>> 7 | 0 ? e[Ar + 8 >> 2] : Fe & 127) - 1 >>> 0 > ln >>> 0) + ln | 0), Fe = $[G | 0], e[5996] = 0, Fe = On(216, hr | 0, Fe | 0) | 0, Tr = e[5996], e[5996] = 0, (Tr | 0) != 1) {
                        Tr = e[g >> 2], e[g >> 2] = Tr + 4, e[Tr >> 2] = Fe, G = G + 1 | 0, Mn = Mn + 1 | 0;
                        continue;
                      }
                      break;
                    }
                    break e;
                  }
                  t: {
                    for (; ; ) {
                      if (c >>> 0 > S >>> 0) {
                        if (ke = ye[S | 0], (ke | 0) == 46) {
                          if (e[5996] = 0, ke = ii(209, Rn | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                            break e;
                          Fe = e[g >> 2], G = Fe + 4 | 0, e[g >> 2] = G, e[Fe >> 2] = ke, S = S + 1 | 0;
                          break t;
                        }
                        if (e[5996] = 0, ke = On(216, hr | 0, ke << 24 >> 24) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                          break e;
                        G = e[g >> 2], e[g >> 2] = G + 4, e[G >> 2] = ke, S = S + 1 | 0;
                        continue;
                      }
                      break;
                    }
                    G = e[g >> 2];
                  }
                  if (e[5996] = 0, Qs(208, hr | 0, S | 0, c | 0, G | 0), ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                    break e;
                  ke = g, g = e[g >> 2] + (c - S << 2) | 0, e[ke >> 2] = g, e[y >> 2] = (o | 0) == (c | 0) ? g : (o - r << 2) + h | 0, qi(Ar + 4 | 0), Yr = Ar + 16 | 0;
                  return;
                }
                r = Vr() | 0, qi(Ar + 4 | 0), Ki(r | 0), ri();
              }
              function Z1(r, o, c, h, y, g, S) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0;
                var G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0;
                Ar = Yr - 16 | 0, Yr = Ar, hr = s4(e[S >> 2]), Rn = u4(e[S >> 2]), S = Rn, _n[e[e[S >> 2] + 20 >> 2]](Ar + 4 | 0, S), e[g >> 2] = h;
                e: {
                  t: {
                    r:
                      switch (ke = r, S = ye[ke | 0], S - 43 | 0) {
                        case 0:
                        case 2:
                          break r;
                        default:
                          break t;
                      }
                    if (e[5996] = 0, S = On(171, hr | 0, S << 24 >> 24) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                      break e;
                    ke = e[g >> 2], e[g >> 2] = ke + 1, $[ke | 0] = S, ke = r + 1 | 0;
                  }
                  t: {
                    if (S = ke, !((c - S | 0) <= 1 | ye[S | 0] != 48 | (ye[S + 1 | 0] | 32) != 120)) {
                      if (e[5996] = 0, ke = On(171, hr | 0, 48) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1 || (G = e[g >> 2], e[g >> 2] = G + 1, $[G | 0] = ke, ke = $[S + 1 | 0], e[5996] = 0, ke = On(171, hr | 0, ke | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1))
                        break e;
                      for (G = e[g >> 2], e[g >> 2] = G + 1, $[G | 0] = ke, ke = S + 2 | 0, S = ke; ; ) {
                        if (c >>> 0 <= S >>> 0 || (G = $[S | 0], mo(), !(G - 48 >>> 0 < 10 | (G | 32) - 97 >>> 0 < 6)))
                          break t;
                        S = S + 1 | 0;
                      }
                    }
                    for (; ; ) {
                      if (c >>> 0 <= S >>> 0 || (G = $[S | 0], mo(), G - 48 >>> 0 >= 10))
                        break t;
                      S = S + 1 | 0;
                    }
                  }
                  t: {
                    if (G = ye[Ar + 15 | 0], !((G & 128) >>> 7 | 0 ? e[Ar + 8 >> 2] : G & 127)) {
                      if (G = e[g >> 2], e[5996] = 0, Qs(195, hr | 0, ke | 0, S | 0, G | 0), G = e[5996], e[5996] = 0, (G | 0) == 1)
                        break e;
                      e[g >> 2] = e[g >> 2] + (S - ke | 0);
                      break t;
                    }
                    if (iu(ke, S), e[5996] = 0, ei = ii(193, Rn | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                      break e;
                    for (G = ke; ; ) {
                      if (S >>> 0 <= G >>> 0) {
                        iu((ke - r | 0) + h | 0, e[g >> 2]);
                        break t;
                      }
                      if (Fe = Ar + 4 | 0, Tr = (ye[Fe + 11 | 0] & 128) >>> 7 | 0, $[(Tr ? e[Fe >> 2] : Fe) + ln | 0] <= 0 | $[(Tr ? e[Fe >> 2] : Fe) + ln | 0] != (Mn | 0) || (Fe = e[g >> 2], e[g >> 2] = Fe + 1, $[Fe | 0] = ei, Mn = 0, Fe = ye[Ar + 15 | 0], ln = (((Fe & 128) >>> 7 | 0 ? e[Ar + 8 >> 2] : Fe & 127) - 1 >>> 0 > ln >>> 0) + ln | 0), Fe = $[G | 0], e[5996] = 0, Fe = On(171, hr | 0, Fe | 0) | 0, Tr = e[5996], e[5996] = 0, (Tr | 0) != 1) {
                        Tr = e[g >> 2], e[g >> 2] = Tr + 1, $[Tr | 0] = Fe, G = G + 1 | 0, Mn = Mn + 1 | 0;
                        continue;
                      }
                      break;
                    }
                    break e;
                  }
                  for (; ; ) {
                    t: {
                      if (c >>> 0 > S >>> 0) {
                        if (ke = ye[S | 0], (ke | 0) != 46)
                          break t;
                        if (e[5996] = 0, ke = ii(196, Rn | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                          break e;
                        G = e[g >> 2], e[g >> 2] = G + 1, $[G | 0] = ke, S = S + 1 | 0;
                      }
                      if (ke = e[g >> 2], e[5996] = 0, Qs(195, hr | 0, S | 0, c | 0, ke | 0), ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                        break e;
                      ke = g, g = e[g >> 2] + (c - S | 0) | 0, e[ke >> 2] = g, e[y >> 2] = (o | 0) == (c | 0) ? g : (o - r | 0) + h | 0, qi(Ar + 4 | 0), Yr = Ar + 16 | 0;
                      return;
                    }
                    if (e[5996] = 0, ke = On(171, hr | 0, ke << 24 >> 24) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                      break e;
                    G = e[g >> 2], e[g >> 2] = G + 1, $[G | 0] = ke, S = S + 1 | 0;
                  }
                }
                r = Vr() | 0, qi(Ar + 4 | 0), Ki(r | 0), ri();
              }
              function ih(r, o, c, h) {
                var y = 0, g = 0, S = 0, G = 0, ke = 0;
                y = e[o >> 2];
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  f: {
                                    d: {
                                      c: {
                                        if (!h || (S = e[h >> 2], !S))
                                          break c;
                                        if (!r) {
                                          h = c;
                                          break f;
                                        }
                                        e[h >> 2] = 0, h = c;
                                        break d;
                                      }
                                      c: {
                                        if (!e[e[6178] >> 2]) {
                                          if (!r)
                                            break c;
                                          if (!c)
                                            break e;
                                          for (S = c; ; ) {
                                            if (h = $[y | 0], h) {
                                              if (e[r >> 2] = h & 57343, r = r + 4 | 0, y = y + 1 | 0, S = S - 1 | 0, S)
                                                continue;
                                              break e;
                                            }
                                            break;
                                          }
                                          return e[r >> 2] = 0, e[o >> 2] = 0, c - S | 0;
                                        }
                                        if (h = c, !r)
                                          break l;
                                        break a;
                                      }
                                      return Da(y);
                                    }
                                    g = 1;
                                    break a;
                                  }
                                  g = 0;
                                  break o;
                                }
                                g = 1;
                              }
                              for (; ; ) {
                                if (!g) {
                                  if (g = ye[y | 0] >>> 3 | 0, (g - 16 | g + (S >> 26)) >>> 0 > 7)
                                    break s;
                                  g = y + 1 | 0;
                                  o: {
                                    if (!(S & 33554432))
                                      break o;
                                    if ((ye[g | 0] & 192) != 128) {
                                      y = y - 1 | 0;
                                      break n;
                                    }
                                    if (g = y + 2 | 0, !(S & 524288))
                                      break o;
                                    if ((ye[g | 0] & 192) != 128) {
                                      y = y - 1 | 0;
                                      break n;
                                    }
                                    g = y + 3 | 0;
                                  }
                                  y = g, h = h - 1 | 0, g = 1;
                                  continue;
                                }
                                for (; ; ) {
                                  S = ye[y | 0];
                                  o: {
                                    if (y & 3 | S - 1 >>> 0 > 126 || (S = e[y >> 2], (S | S - 16843009) & -2139062144))
                                      break o;
                                    for (; h = h - 4 | 0, S = e[y + 4 >> 2], y = y + 4 | 0, !((S - 16843009 | S) & -2139062144); )
                                      ;
                                  }
                                  if (g = S & 255, g - 1 >>> 0 <= 126) {
                                    h = h - 1 | 0, y = y + 1 | 0;
                                    continue;
                                  }
                                  break;
                                }
                                if (g = g - 194 | 0, g >>> 0 > 50)
                                  break i;
                                y = y + 1 | 0, S = e[(g << 2) + 12208 >> 2], g = 0;
                              }
                            }
                            for (; ; ) {
                              if (!g) {
                                if (!h)
                                  break e;
                                for (; ; ) {
                                  a: {
                                    g = ye[y | 0], G = g - 1 | 0;
                                    o: {
                                      l: {
                                        if (G >>> 0 > 126) {
                                          S = g;
                                          break l;
                                        }
                                        if (y & 3 | h >>> 0 < 5)
                                          break o;
                                        f: {
                                          for (; ; ) {
                                            if (S = e[y >> 2], (S | S - 16843009) & -2139062144)
                                              break f;
                                            if (e[r >> 2] = S & 255, e[r + 4 >> 2] = ye[y + 1 | 0], e[r + 8 >> 2] = ye[y + 2 | 0], e[r + 12 >> 2] = ye[y + 3 | 0], r = r + 16 | 0, y = y + 4 | 0, h = h - 4 | 0, !(h >>> 0 > 4))
                                              break;
                                          }
                                          S = ye[y | 0];
                                        }
                                        g = S & 255, G = g - 1 | 0;
                                      }
                                      if (G >>> 0 > 126)
                                        break a;
                                    }
                                    if (e[r >> 2] = g, r = r + 4 | 0, y = y + 1 | 0, h = h - 1 | 0, h)
                                      continue;
                                    break e;
                                  }
                                  break;
                                }
                                if (g = g - 194 | 0, g >>> 0 > 50)
                                  break i;
                                y = y + 1 | 0, S = e[(g << 2) + 12208 >> 2], g = 1;
                                continue;
                              }
                              if (ke = ye[y | 0], g = ke >>> 3 | 0, (g - 16 | g + (S >> 26)) >>> 0 > 7)
                                break s;
                              a: {
                                o: {
                                  G = y + 1 | 0, g = ke - 128 | S << 6;
                                  l: {
                                    if ((g | 0) >= 0)
                                      break l;
                                    if (ke = ye[G | 0] - 128 | 0, ke >>> 0 > 63)
                                      break o;
                                    if (G = y + 2 | 0, g = ke | g << 6, (g | 0) >= 0)
                                      break l;
                                    if (G = ye[G | 0] - 128 | 0, G >>> 0 > 63)
                                      break o;
                                    g = G | g << 6, G = y + 3 | 0;
                                  }
                                  y = G, e[r >> 2] = g, h = h - 1 | 0, r = r + 4 | 0;
                                  break a;
                                }
                                e[5732] = 25, y = y - 1 | 0;
                                break r;
                              }
                              g = 0;
                            }
                          }
                          if (y = y - 1 | 0, S)
                            break n;
                          S = ye[y | 0];
                        }
                        if (S & 255)
                          break n;
                        return r && (e[r >> 2] = 0, e[o >> 2] = 0), c - h | 0;
                      }
                      if (e[5732] = 25, !r)
                        break t;
                    }
                    e[o >> 2] = y;
                  }
                  return -1;
                }
                return e[o >> 2] = y, c;
              }
              function sh(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0;
                r = Yr - 256 | 0, Yr = r, e[r + 248 >> 2] = c, e[r + 252 >> 2] = o, G = r + 196 | 0, e[G >> 2] = 0, e[G + 4 >> 2] = 0, e[G + 8 >> 2] = 0, S = r + 16 | 0, o = e[h + 28 >> 2], e[S >> 2] = o, e[o + 4 >> 2] = e[o + 4 >> 2] + 1, e[5996] = 0, o = ii(170, e[r + 16 >> 2]) | 0, c = e[5996], e[5996] = 0;
                e: {
                  t: {
                    if ((c | 0) == 1 || (e[5996] = 0, Qs(195, o | 0, 12416, 12442, r + 208 | 0), o = e[5996], e[5996] = 0, (o | 0) == 1))
                      break t;
                    if (o = e[r + 16 >> 2], c = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = c, (c | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o), c = r + 184 | 0, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, o = (ye[c + 11 | 0] & 128) >>> 7 | 0 ? (e[c + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, c | 0, o | 0), o = e[5996], e[5996] = 0, (o | 0) != 1)
                      r:
                        for (o = (ye[c + 11 | 0] & 128) >>> 7 | 0 ? e[c >> 2] : c, e[r + 180 >> 2] = o, e[r + 12 >> 2] = S, e[r + 8 >> 2] = 0; ; ) {
                          n: {
                            if (e[5996] = 0, S = On(186, r + 252 | 0, r + 248 | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                              break n;
                            h = e[r + 180 >> 2];
                            i: {
                              if (!S) {
                                if (S = h, h = ye[c + 11 | 0], h = (h & 128) >>> 7 | 0 ? e[c + 4 >> 2] : h & 127, (S | 0) == (h + o | 0)) {
                                  if (e[5996] = 0, di(172, c | 0, h << 1), o = e[5996], e[5996] = 0, (o | 0) == 1 || (o = (ye[c + 11 | 0] & 128) >>> 7 | 0 ? (e[c + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, c | 0, o | 0), o = e[5996], e[5996] = 0, (o | 0) == 1))
                                    break r;
                                  o = (ye[c + 11 | 0] & 128) >>> 7 | 0 ? e[c >> 2] : c, e[r + 180 >> 2] = h + o;
                                }
                                if (e[5996] = 0, h = ii(187, e[r + 252 >> 2]) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                  break n;
                                if (!Tc(h, 16, o, r + 180 | 0, r + 8 | 0, 0, e[G + 4 >> 2], ye[G + 11 | 0], r + 16 | 0, r + 12 | 0, r + 208 | 0))
                                  break i;
                                h = e[r + 180 >> 2];
                              }
                              if (e[5996] = 0, di(172, c | 0, h - o | 0), o = e[5996], e[5996] = 0, (o | 0) == 1 || (o = e[c >> 2], h = (ye[c + 11 | 0] & 128) >>> 7 | 0, S = mo(), e[r >> 2] = g, (mc(h ? o : c, S, r) | 0) != 1 && (e[y >> 2] = 4), e[5996] = 0, o = On(186, r + 252 | 0, r + 248 | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1))
                                break n;
                              return o && (e[y >> 2] = e[y >> 2] | 2), o = e[r + 252 >> 2], qi(c), qi(G), Yr = r + 256 | 0, o | 0;
                            }
                            if (e[5996] = 0, ii(189, r + 252 | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) != 1)
                              continue;
                          }
                          break;
                        }
                    o = Vr() | 0, qi(c);
                    break e;
                  }
                  o = Vr() | 0, r = e[r + 16 >> 2], c = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = c, (c | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r);
                }
                qi(G), Ki(o | 0), ri();
              }
              function $1(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0;
                r = Yr - 320 | 0, Yr = r, e[r + 312 >> 2] = c, e[r + 316 >> 2] = o, G = r + 196 | 0, e[G >> 2] = 0, e[G + 4 >> 2] = 0, e[G + 8 >> 2] = 0, S = r + 16 | 0, o = e[h + 28 >> 2], e[S >> 2] = o, e[o + 4 >> 2] = e[o + 4 >> 2] + 1, e[5996] = 0, o = ii(197, e[r + 16 >> 2]) | 0, c = e[5996], e[5996] = 0;
                e: {
                  t: {
                    if ((c | 0) == 1 || (e[5996] = 0, Qs(208, o | 0, 12416, 12442, r + 208 | 0), o = e[5996], e[5996] = 0, (o | 0) == 1))
                      break t;
                    if (o = e[r + 16 >> 2], c = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = c, (c | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o), c = r + 184 | 0, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, o = (ye[c + 11 | 0] & 128) >>> 7 | 0 ? (e[c + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, c | 0, o | 0), o = e[5996], e[5996] = 0, (o | 0) != 1)
                      r:
                        for (o = (ye[c + 11 | 0] & 128) >>> 7 | 0 ? e[c >> 2] : c, e[r + 180 >> 2] = o, e[r + 12 >> 2] = S, e[r + 8 >> 2] = 0; ; ) {
                          n: {
                            if (e[5996] = 0, S = On(202, r + 316 | 0, r + 312 | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                              break n;
                            h = e[r + 180 >> 2];
                            i: {
                              if (!S) {
                                if (S = h, h = ye[c + 11 | 0], h = (h & 128) >>> 7 | 0 ? e[c + 4 >> 2] : h & 127, (S | 0) == (h + o | 0)) {
                                  if (e[5996] = 0, di(172, c | 0, h << 1), o = e[5996], e[5996] = 0, (o | 0) == 1 || (o = (ye[c + 11 | 0] & 128) >>> 7 | 0 ? (e[c + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, c | 0, o | 0), o = e[5996], e[5996] = 0, (o | 0) == 1))
                                    break r;
                                  o = (ye[c + 11 | 0] & 128) >>> 7 | 0 ? e[c >> 2] : c, e[r + 180 >> 2] = h + o;
                                }
                                if (e[5996] = 0, h = ii(203, e[r + 316 >> 2]) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                                  break n;
                                if (!xc(h, 16, o, r + 180 | 0, r + 8 | 0, 0, e[G + 4 >> 2], ye[G + 11 | 0], r + 16 | 0, r + 12 | 0, r + 208 | 0))
                                  break i;
                                h = e[r + 180 >> 2];
                              }
                              if (e[5996] = 0, di(172, c | 0, h - o | 0), o = e[5996], e[5996] = 0, (o | 0) == 1 || (o = e[c >> 2], h = (ye[c + 11 | 0] & 128) >>> 7 | 0, S = mo(), e[r >> 2] = g, (mc(h ? o : c, S, r) | 0) != 1 && (e[y >> 2] = 4), e[5996] = 0, o = On(202, r + 316 | 0, r + 312 | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1))
                                break n;
                              return o && (e[y >> 2] = e[y >> 2] | 2), o = e[r + 316 >> 2], qi(c), qi(G), Yr = r + 320 | 0, o | 0;
                            }
                            if (e[5996] = 0, ii(205, r + 316 | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) != 1)
                              continue;
                          }
                          break;
                        }
                    o = Vr() | 0, qi(c);
                    break e;
                  }
                  o = Vr() | 0, r = e[r + 16 >> 2], c = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = c, (c | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r);
                }
                qi(G), Ki(o | 0), ri();
              }
              function eg(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0;
                r = Yr - 480 | 0, Yr = r, S = e[h + 28 >> 2], e[r + 476 >> 2] = S, e[S + 4 >> 2] = e[S + 4 >> 2] + 1, e[5996] = 0, Rn = ii(197, e[r + 476 >> 2]) | 0, S = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          if ((S | 0) != 1) {
                            if (ke = ye[g + 11 | 0], S = (ke & 128) >>> 7 | 0, S ? e[g + 4 >> 2] : ke & 127) {
                              if (S = e[(S ? e[g >> 2] : g) >> 2], e[5996] = 0, ke = On(216, Rn | 0, 45) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1)
                                break i;
                              Mn = (S | 0) == (ke | 0);
                            }
                            if (Ar = r + 452 | 0, e[Ar >> 2] = 0, e[Ar + 4 >> 2] = 0, e[Ar + 8 >> 2] = 0, S = r + 440 | 0, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, ke = r + 428 | 0, e[ke >> 2] = 0, e[ke + 4 >> 2] = 0, e[ke + 8 >> 2] = 0, e[5996] = 0, Bc(238, c | 0, Mn | 0, e[r + 476 >> 2], r + 472 | 0, r + 468 | 0, r + 464 | 0, Ar | 0, S | 0, ke | 0, r + 424 | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                              break n;
                            e[r + 4 >> 2] = 184, hr = r + 8 | 0, e[hr >> 2] = 0, e[hr + 4 >> 2] = e[r + 4 >> 2], c = r + 16 | 0, Fe = ye[g + 11 | 0], Fe = (Fe & 128) >>> 7 | 0 ? e[g + 4 >> 2] : Fe & 127, Tr = e[r + 424 >> 2];
                            s: {
                              if ((Fe | 0) > (Tr | 0)) {
                                G = ye[ke + 11 | 0], ln = (Fe - Tr << 1) + ((G & 128) >>> 7 | 0 ? e[ke + 4 >> 2] : G & 127) | 0, G = ye[S + 11 | 0], G = (ln + ((G & 128) >>> 7 | 0 ? e[S + 4 >> 2] : G & 127) | 0) + 1 | 0;
                                break s;
                              }
                              G = ye[ke + 11 | 0], ln = (G & 128) >>> 7 | 0 ? e[ke + 4 >> 2] : G & 127, G = ye[S + 11 | 0], G = (ln + ((G & 128) >>> 7 | 0 ? e[S + 4 >> 2] : G & 127) | 0) + 2 | 0;
                            }
                            s: {
                              if (G = G + Tr | 0, G >>> 0 >= 101) {
                                if (Yo(hr, ia(G << 2)), c = e[hr >> 2], !c)
                                  break s;
                                Fe = ye[g + 11 | 0], Fe = (Fe & 128) >>> 7 | 0 ? e[g + 4 >> 2] : Fe & 127;
                              }
                              if (G = e[h + 4 >> 2], g = (ye[g + 11 | 0] & 128) >>> 7 | 0 ? e[g >> 2] : g, e[5996] = 0, Uf(239, c | 0, r + 4 | 0, r | 0, G | 0, g | 0, g + (Fe << 2) | 0, Rn | 0, Mn | 0, r + 472 | 0, e[r + 468 >> 2], e[r + 464 >> 2], Ar | 0, S | 0, ke | 0, Tr | 0), g = e[5996], e[5996] = 0, (g | 0) == 1 || (e[5996] = 0, h = Fa(219, o | 0, c | 0, e[r + 4 >> 2], e[r >> 2], h | 0, y | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1))
                                break r;
                              return Js(hr), qi(ke), qi(S), qi(Ar), o = e[r + 476 >> 2], c = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = c, (c | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o), Yr = r + 480 | 0, h | 0;
                            }
                            if (e[5996] = 0, Ri(185), o = e[5996], e[5996] = 0, (o | 0) == 1)
                              break r;
                            ri();
                          }
                          g = Vr() | 0;
                          break e;
                        }
                        g = Vr() | 0;
                        break e;
                      }
                      g = Vr() | 0;
                      break t;
                    }
                    g = Vr() | 0, Js(hr);
                  }
                  qi(ke), qi(S), qi(Ar);
                }
                r = e[r + 476 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(g | 0), ri();
              }
              function tg(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0;
                r = Yr - 176 | 0, Yr = r, S = e[h + 28 >> 2], e[r + 172 >> 2] = S, e[S + 4 >> 2] = e[S + 4 >> 2] + 1, e[5996] = 0, Rn = ii(170, e[r + 172 >> 2]) | 0, S = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          if ((S | 0) != 1) {
                            if (ke = ye[g + 11 | 0], S = (ke & 128) >>> 7 | 0, S ? e[g + 4 >> 2] : ke & 127) {
                              if (S = ye[(S ? e[g >> 2] : g) | 0], e[5996] = 0, ke = On(171, Rn | 0, 45) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) == 1)
                                break i;
                              Mn = (ke & 255) == (S | 0);
                            }
                            if (Ar = r + 152 | 0, e[Ar >> 2] = 0, e[Ar + 4 >> 2] = 0, e[Ar + 8 >> 2] = 0, S = r + 140 | 0, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[S + 8 >> 2] = 0, ke = r + 128 | 0, e[ke >> 2] = 0, e[ke + 4 >> 2] = 0, e[ke + 8 >> 2] = 0, e[5996] = 0, Bc(236, c | 0, Mn | 0, e[r + 172 >> 2], r + 168 | 0, r + 167 | 0, r + 166 | 0, Ar | 0, S | 0, ke | 0, r + 124 | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)
                              break n;
                            e[r + 4 >> 2] = 184, hr = r + 8 | 0, e[hr >> 2] = 0, e[hr + 4 >> 2] = e[r + 4 >> 2], c = r + 16 | 0, Fe = ye[g + 11 | 0], Fe = (Fe & 128) >>> 7 | 0 ? e[g + 4 >> 2] : Fe & 127, Tr = e[r + 124 >> 2];
                            s: {
                              if ((Fe | 0) > (Tr | 0)) {
                                G = ye[ke + 11 | 0], ln = (Fe - Tr << 1) + ((G & 128) >>> 7 | 0 ? e[ke + 4 >> 2] : G & 127) | 0, G = ye[S + 11 | 0], G = (ln + ((G & 128) >>> 7 | 0 ? e[S + 4 >> 2] : G & 127) | 0) + 1 | 0;
                                break s;
                              }
                              G = ye[ke + 11 | 0], ln = (G & 128) >>> 7 | 0 ? e[ke + 4 >> 2] : G & 127, G = ye[S + 11 | 0], G = (ln + ((G & 128) >>> 7 | 0 ? e[S + 4 >> 2] : G & 127) | 0) + 2 | 0;
                            }
                            s: {
                              if (G = G + Tr | 0, G >>> 0 >= 101) {
                                if (Yo(hr, ia(G)), c = e[hr >> 2], !c)
                                  break s;
                                Fe = ye[g + 11 | 0], Fe = (Fe & 128) >>> 7 | 0 ? e[g + 4 >> 2] : Fe & 127;
                              }
                              if (G = e[h + 4 >> 2], g = (ye[g + 11 | 0] & 128) >>> 7 | 0 ? e[g >> 2] : g, e[5996] = 0, Uf(237, c | 0, r + 4 | 0, r | 0, G | 0, g | 0, g + Fe | 0, Rn | 0, Mn | 0, r + 168 | 0, $[r + 167 | 0], $[r + 166 | 0], Ar | 0, S | 0, ke | 0, Tr | 0), g = e[5996], e[5996] = 0, (g | 0) == 1 || (e[5996] = 0, h = Fa(213, o | 0, c | 0, e[r + 4 >> 2], e[r >> 2], h | 0, y | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1))
                                break r;
                              return Js(hr), qi(ke), qi(S), qi(Ar), o = e[r + 172 >> 2], c = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = c, (c | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o), Yr = r + 176 | 0, h | 0;
                            }
                            if (e[5996] = 0, Ri(185), o = e[5996], e[5996] = 0, (o | 0) == 1)
                              break r;
                            ri();
                          }
                          g = Vr() | 0;
                          break e;
                        }
                        g = Vr() | 0;
                        break e;
                      }
                      g = Vr() | 0;
                      break t;
                    }
                    g = Vr() | 0, Js(hr);
                  }
                  qi(ke), qi(S), qi(Ar);
                }
                r = e[r + 172 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(g | 0), ri();
              }
              function rg(r, o, c, h, y, g, S, G, ke, Fe, Ar, hr, Tr, ln, Rn) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, G = G | 0, ke = ke | 0, Fe = Fe | 0, Ar = Ar | 0, hr = hr | 0, Tr = Tr | 0, ln = ln | 0, Rn = Rn | 0;
                var Mn = 0, ei = 0, ci = 0, gi = 0, Qi = 0, Ji = 0, ss = 0, As = 0, Rs = 0;
                for (e[c >> 2] = r, ss = h & 512, As = G << 2; ; ) {
                  if ((Ji | 0) == 4)
                    y = ye[ln + 11 | 0], ((y & 128) >>> 7 | 0 ? e[ln + 4 >> 2] : y & 127) >>> 0 > 1 && (e[c >> 2] = Lh(Pd(Qa(ln), 1), Ia(ln), e[c >> 2])), h = h & 176, (h | 0) != 16 && ((h | 0) == 32 && (r = e[c >> 2]), e[o >> 2] = r);
                  else {
                    e: {
                      t:
                        switch ($[ke + Ji | 0]) {
                          case 0:
                            e[o >> 2] = e[c >> 2];
                            break e;
                          case 1:
                            e[o >> 2] = e[c >> 2], G = _n[e[e[S >> 2] + 44 >> 2]](S, 32) | 0, Mn = e[c >> 2], e[c >> 2] = Mn + 4, e[Mn >> 2] = G;
                            break e;
                          case 3:
                            if (G = ye[ln + 11 | 0], ci = G & 127, G = (G & 128) >>> 7 | 0, !(G ? e[ln + 4 >> 2] : ci))
                              break e;
                            G = e[(G ? e[ln >> 2] : ln) >> 2], Mn = e[c >> 2], e[c >> 2] = Mn + 4, e[Mn >> 2] = G;
                            break e;
                          case 2:
                            if (!ss || (G = ye[Tr + 11 | 0], !((G & 128) >>> 7 | 0 ? e[Tr + 4 >> 2] : G & 127)))
                              break e;
                            e[c >> 2] = Lh(Qa(Tr), Ia(Tr), e[c >> 2]);
                            break e;
                          case 4:
                            break t;
                          default:
                            break e;
                        }
                      for (Rs = e[c >> 2], y = y + As | 0, G = y; ; ) {
                        t: {
                          if (g >>> 0 <= G >>> 0 || !(_n[e[e[S >> 2] + 12 >> 2]](S, 64, e[G >> 2]) | 0))
                            break t;
                          G = G + 4 | 0;
                          continue;
                        }
                        break;
                      }
                      if ((Rn | 0) > 0) {
                        for (Mn = e[c >> 2], ei = Rn; ; ) {
                          if (!(!ei | y >>> 0 >= G >>> 0)) {
                            ei = ei - 1 | 0, G = G - 4 | 0, gi = e[G >> 2], ci = Mn + 4 | 0, e[c >> 2] = ci, e[Mn >> 2] = gi, Mn = ci;
                            continue;
                          }
                          break;
                        }
                        t: {
                          if (!ei) {
                            gi = 0;
                            break t;
                          }
                          gi = _n[e[e[S >> 2] + 44 >> 2]](S, 48) | 0, Mn = e[c >> 2];
                        }
                        for (; ; ) {
                          if (ci = Mn + 4 | 0, (ei | 0) > 0) {
                            e[Mn >> 2] = gi, ei = ei - 1 | 0, Mn = ci;
                            continue;
                          }
                          break;
                        }
                        e[c >> 2] = ci, e[Mn >> 2] = Fe;
                      }
                      t: {
                        if ((y | 0) == (G | 0)) {
                          Mn = _n[e[e[S >> 2] + 44 >> 2]](S, 48) | 0, ei = e[c >> 2], G = ei + 4 | 0, e[c >> 2] = G, e[ei >> 2] = Mn;
                          break t;
                        }
                        for (gi = -1, Mn = ye[hr + 11 | 0], ci = (Mn & 128) >>> 7 | 0, (ci ? e[hr + 4 >> 2] : Mn & 127) && (gi = $[(ci ? e[hr >> 2] : hr) | 0]), ei = 0, Qi = 0; ; ) {
                          if ((y | 0) != (G | 0)) {
                            ci = e[c >> 2];
                            r: {
                              if ((ei | 0) != (gi | 0)) {
                                Mn = ci, ci = ei;
                                break r;
                              }
                              if (Mn = ci + 4 | 0, e[c >> 2] = Mn, e[ci >> 2] = Ar, ci = 0, Qi = Qi + 1 | 0, gi = ye[hr + 11 | 0], Qi >>> 0 >= ((gi & 128) >>> 7 | 0 ? e[hr + 4 >> 2] : gi & 127) >>> 0) {
                                gi = ei;
                                break r;
                              }
                              if (gi = -1, ei = ((ye[hr + 11 | 0] & 128) >>> 7 | 0 ? e[hr >> 2] : hr) + Qi | 0, ye[ei | 0] == 127)
                                break r;
                              gi = $[ei | 0];
                            }
                            G = G - 4 | 0, ei = e[G >> 2], e[c >> 2] = Mn + 4, e[Mn >> 2] = ei, ei = ci + 1 | 0;
                            continue;
                          }
                          break;
                        }
                        G = e[c >> 2];
                      }
                      D2(Rs, G);
                    }
                    Ji = Ji + 1 | 0;
                    continue;
                  }
                  break;
                }
              }
              function ng(r, o, c, h, y, g, S, G, ke, Fe, Ar, hr, Tr, ln, Rn) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, G = G | 0, ke = ke | 0, Fe = Fe | 0, Ar = Ar | 0, hr = hr | 0, Tr = Tr | 0, ln = ln | 0, Rn = Rn | 0;
                var Mn = 0, ei = 0, ci = 0, gi = 0, Qi = 0, Ji = 0, ss = 0, As = 0, Rs = 0;
                for (e[c >> 2] = r, As = h & 512; ; ) {
                  if ((Ji | 0) == 4)
                    y = ye[ln + 11 | 0], ((y & 128) >>> 7 | 0 ? e[ln + 4 >> 2] : y & 127) >>> 0 > 1 && (e[c >> 2] = Hh(qd(Qa(ln), 1), gu(ln), e[c >> 2])), h = h & 176, (h | 0) != 16 && ((h | 0) == 32 && (r = e[c >> 2]), e[o >> 2] = r);
                  else {
                    e: {
                      t:
                        switch ($[ke + Ji | 0]) {
                          case 0:
                            e[o >> 2] = e[c >> 2];
                            break e;
                          case 1:
                            e[o >> 2] = e[c >> 2], Mn = _n[e[e[S >> 2] + 28 >> 2]](S, 32) | 0, ei = e[c >> 2], e[c >> 2] = ei + 1, $[ei | 0] = Mn;
                            break e;
                          case 3:
                            if (Mn = ye[ln + 11 | 0], ei = (Mn & 128) >>> 7 | 0, !(ei ? e[ln + 4 >> 2] : Mn & 127))
                              break e;
                            Mn = ye[(ei ? e[ln >> 2] : ln) | 0], ei = e[c >> 2], e[c >> 2] = ei + 1, $[ei | 0] = Mn;
                            break e;
                          case 2:
                            if (!As || (Mn = ye[Tr + 11 | 0], !((Mn & 128) >>> 7 | 0 ? e[Tr + 4 >> 2] : Mn & 127)))
                              break e;
                            e[c >> 2] = Hh(Qa(Tr), gu(Tr), e[c >> 2]);
                            break e;
                          case 4:
                            break t;
                          default:
                            break e;
                        }
                      for (ei = e[S + 8 >> 2], Rs = e[c >> 2], y = y + G | 0, ci = y; ; ) {
                        t: {
                          if (g >>> 0 <= ci >>> 0 || (Mn = $[ci | 0], (Mn | 0) >= 0 ? Mn = (e[ei + ((Mn & 255) << 2) >> 2] & 64) != 0 : Mn = 0, !Mn))
                            break t;
                          ci = ci + 1 | 0;
                          continue;
                        }
                        break;
                      }
                      if (Mn = Rn, (Mn | 0) > 0) {
                        for (; ; ) {
                          if (!(!Mn | y >>> 0 >= ci >>> 0)) {
                            Mn = Mn - 1 | 0, ci = ci - 1 | 0, ei = ye[ci | 0], gi = e[c >> 2], e[c >> 2] = gi + 1, $[gi | 0] = ei;
                            continue;
                          }
                          break;
                        }
                        for (Mn ? ei = _n[e[e[S >> 2] + 28 >> 2]](S, 48) | 0 : ei = 0; ; ) {
                          if (gi = e[c >> 2], e[c >> 2] = gi + 1, (Mn | 0) > 0) {
                            $[gi | 0] = ei, Mn = Mn - 1 | 0;
                            continue;
                          }
                          break;
                        }
                        $[gi | 0] = Fe;
                      }
                      t: {
                        if ((y | 0) == (ci | 0)) {
                          Mn = _n[e[e[S >> 2] + 28 >> 2]](S, 48) | 0, ei = e[c >> 2], e[c >> 2] = ei + 1, $[ei | 0] = Mn;
                          break t;
                        }
                        for (ei = -1, Mn = ye[hr + 11 | 0], gi = Mn & 127, Mn = (Mn & 128) >>> 7 | 0, (Mn ? e[hr + 4 >> 2] : gi) && (ei = $[(Mn ? e[hr >> 2] : hr) | 0]), Mn = 0, Qi = 0; ; ) {
                          if ((y | 0) == (ci | 0))
                            break t;
                          r: {
                            if ((Mn | 0) != (ei | 0)) {
                              gi = Mn;
                              break r;
                            }
                            if (ei = e[c >> 2], e[c >> 2] = ei + 1, $[ei | 0] = Ar, gi = 0, Qi = Qi + 1 | 0, ei = ye[hr + 11 | 0], Qi >>> 0 >= ((ei & 128) >>> 7 | 0 ? e[hr + 4 >> 2] : ei & 127) >>> 0) {
                              ei = Mn;
                              break r;
                            }
                            if (ei = -1, Mn = ((ye[hr + 11 | 0] & 128) >>> 7 | 0 ? e[hr >> 2] : hr) + Qi | 0, ye[Mn | 0] == 127)
                              break r;
                            ei = $[Mn | 0];
                          }
                          ci = ci - 1 | 0, Mn = ye[ci | 0], ss = e[c >> 2], e[c >> 2] = ss + 1, $[ss | 0] = Mn, Mn = gi + 1 | 0;
                        }
                      }
                      iu(Rs, e[c >> 2]);
                    }
                    Ji = Ji + 1 | 0;
                    continue;
                  }
                  break;
                }
              }
              function ig(r, o, c, h, y, g, S, G) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, G = G | 0;
                var ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0, Qi = 0, Ji = 0, ss = 0;
                for (ci = Yr - 16 | 0, Yr = ci, Fe = c; ; ) {
                  e: {
                    if ((h | 0) == (Fe | 0)) {
                      Fe = h;
                      break e;
                    }
                    if (!ye[Fe | 0])
                      break e;
                    Fe = Fe + 1 | 0;
                    continue;
                  }
                  break;
                }
                for (e[G >> 2] = g, e[y >> 2] = c; ; ) {
                  e: {
                    t: {
                      r: {
                        if ((c | 0) == (h | 0) | (g | 0) == (S | 0))
                          break r;
                        ke = e[o + 4 >> 2], e[ci + 8 >> 2] = e[o >> 2], e[ci + 12 >> 2] = ke, gi = Yr - 16 | 0, Yr = gi, ss = xu(gi + 12 | 0, e[r + 8 >> 2]), Tr = Fe - c | 0, Ar = 0, ln = 0, Rn = Yr - 1040 | 0, Yr = Rn, ei = e[y >> 2], e[Rn + 12 >> 2] = ei, Mn = g || Rn + 16 | 0, hr = g ? S - g >> 2 : 256;
                        n: {
                          i: {
                            s: {
                              if (!(!ei | !hr)) {
                                for (; ; ) {
                                  if (ke = Tr >>> 2 | 0, !(Tr >>> 0 > 131 | ke >>> 0 >= hr >>> 0)) {
                                    ke = ei;
                                    break i;
                                  }
                                  if (Qi = ih(Mn, Rn + 12 | 0, ke >>> 0 < hr >>> 0 ? ke : hr, o), ke = e[Rn + 12 >> 2], (Qi | 0) == -1) {
                                    hr = 0, Ar = -1;
                                    break s;
                                  }
                                  if (Ji = (Rn + 16 | 0) != (Mn | 0) ? Qi : 0, hr = hr - Ji | 0, Mn = (Ji << 2) + Mn | 0, Tr = ke ? (Tr + ei | 0) - ke | 0 : 0, Ar = Ar + Qi | 0, !ke)
                                    break s;
                                  if (ei = ke, !hr)
                                    break;
                                }
                                break s;
                              }
                              ke = ei;
                            }
                            if (!ke)
                              break n;
                          }
                          if (!(!hr | !Tr)) {
                            for (ln = ke, ke = Ar; ; ) {
                              i: {
                                Ar = Zf(Mn, ln, Tr, o);
                                s: {
                                  if (Ar + 2 >>> 0 <= 2) {
                                    a:
                                      switch (Ar + 1 | 0) {
                                        case 1:
                                          ln = 0;
                                          break s;
                                        case 0:
                                          break n;
                                        default:
                                          break a;
                                      }
                                    e[o >> 2] = 0;
                                    break s;
                                  }
                                  if (ln = Ar + ln | 0, e[Rn + 12 >> 2] = ln, ke = ke + 1 | 0, hr = hr - 1 | 0, hr)
                                    break i;
                                }
                                Ar = ke;
                                break n;
                              }
                              if (Mn = Mn + 4 | 0, Tr = Tr - Ar | 0, Ar = ke, !Tr)
                                break;
                            }
                            break n;
                          }
                          ln = ke;
                        }
                        g && (e[y >> 2] = ln), Yr = Rn + 1040 | 0, ke = e[ss >> 2], ke && (e[6178] = (ke | 0) == -1 ? 24816 : ke), Yr = gi + 16 | 0;
                        n: {
                          i: {
                            s: {
                              a: {
                                if ((Ar | 0) == -1) {
                                  for (; ; ) {
                                    o: {
                                      if (e[G >> 2] = g, e[y >> 2] == (c | 0))
                                        break o;
                                      S = 1;
                                      l: {
                                        f: {
                                          d:
                                            switch (o = wA(g, c, Fe - c | 0, ci + 8 | 0, e[r + 8 >> 2]), o + 2 | 0) {
                                              case 0:
                                                break i;
                                              case 2:
                                                break l;
                                              case 1:
                                                break d;
                                              default:
                                                break f;
                                            }
                                          e[y >> 2] = c;
                                          break a;
                                        }
                                        S = o;
                                      }
                                      c = c + S | 0, g = e[G >> 2] + 4 | 0;
                                      continue;
                                    }
                                    break;
                                  }
                                  e[y >> 2] = c;
                                  break r;
                                }
                                if (g = e[G >> 2] + (Ar << 2) | 0, e[G >> 2] = g, (g | 0) == (S | 0))
                                  break n;
                                if (c = e[y >> 2], (h | 0) == (Fe | 0)) {
                                  Fe = h;
                                  continue;
                                }
                                if (!wA(g, c, 1, o, e[r + 8 >> 2]))
                                  break s;
                              }
                              r = 2;
                              break t;
                            }
                            for (e[G >> 2] = e[G >> 2] + 4, c = e[y >> 2] + 1 | 0, e[y >> 2] = c, Fe = c; ; ) {
                              if ((h | 0) == (Fe | 0)) {
                                Fe = h;
                                break e;
                              }
                              if (!ye[Fe | 0])
                                break e;
                              Fe = Fe + 1 | 0;
                            }
                          }
                          e[y >> 2] = c, r = 1;
                          break t;
                        }
                        c = e[y >> 2];
                      }
                      r = (c | 0) != (h | 0);
                    }
                    return Yr = ci + 16 | 0, r | 0;
                  }
                  g = e[G >> 2];
                }
              }
              function Kf(r, o, c, h, y, g, S) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0;
                var G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0;
                Fe = Yr - 128 | 0, Yr = Fe, e[Fe + 124 >> 2] = o, e[Fe + 4 >> 2] = 184, o = Fe + 8 | 0, e[o >> 2] = 0, e[o + 4 >> 2] = e[Fe + 4 >> 2], Rn = o, Ar = Fe + 16 | 0, hr = (h - c | 0) / 12 | 0;
                e: {
                  t: {
                    if (hr >>> 0 >= 101) {
                      if (Ar = ia(hr), !Ar) {
                        if (e[5996] = 0, Ri(185), r = e[5996], e[5996] = 0, (r | 0) != 1)
                          break e;
                        break t;
                      }
                      Yo(Rn, Ar);
                    }
                    G = Ar, o = c;
                    r: {
                      n: {
                        for (; ; ) {
                          if ((o | 0) == (h | 0))
                            i: for (; ; ) {
                              s: {
                                if (e[5996] = 0, G = On(186, r | 0, Fe + 124 | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                  break s;
                                if ((!hr | G) == 1) {
                                  if (e[5996] = 0, o = On(186, r | 0, Fe + 124 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                    break r;
                                  if (!o)
                                    break n;
                                  e[g >> 2] = e[g >> 2] | 2;
                                  break n;
                                }
                                o = e[r >> 2], e[5996] = 0, Mn = ii(187, o | 0) | 0, o = e[5996], e[5996] = 0;
                                a: {
                                  if ((o | 0) != 1 && (S || (e[5996] = 0, Mn = On(188, y | 0, Mn | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)))
                                    break a;
                                  break t;
                                }
                                for (ke = ei + 1 | 0, gi = 0, G = Ar, o = c; ; ) {
                                  if ((o | 0) == (h | 0)) {
                                    if (ei = ke, !gi)
                                      continue i;
                                    if (e[5996] = 0, ii(189, r | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1) {
                                      if (G = Ar, o = c, hr + Tr >>> 0 < 2)
                                        continue i;
                                      for (; ; ) {
                                        if ((o | 0) == (h | 0))
                                          continue i;
                                        a: {
                                          if (ye[G | 0] != 2 || (ke = ye[o + 11 | 0], (((ke & 128) >>> 7 | 0 ? e[o + 4 >> 2] : ke & 127) | 0) == (ei | 0)))
                                            break a;
                                          $[G | 0] = 0, Tr = Tr - 1 | 0;
                                        }
                                        G = G + 1 | 0, o = o + 12 | 0;
                                      }
                                    }
                                    break t;
                                  }
                                  a: {
                                    if (ye[G | 0] != 1)
                                      break a;
                                    ci = ye[((ye[o + 11 | 0] & 128) >>> 7 | 0 ? e[o >> 2] : o) + ei | 0];
                                    o: {
                                      if (S || (e[5996] = 0, ci = On(188, y | 0, ci << 24 >> 24) | 0, ln = e[5996], e[5996] = 0, (ln | 0) != 1))
                                        break o;
                                      break t;
                                    }
                                    o: {
                                      if ((Mn & 255) == (ci & 255)) {
                                        if (gi = 1, ln = ye[o + 11 | 0], (ke | 0) != (((ln & 128) >>> 7 | 0 ? e[o + 4 >> 2] : ln & 127) | 0))
                                          break a;
                                        $[G | 0] = 2, Tr = Tr + 1 | 0;
                                        break o;
                                      }
                                      $[G | 0] = 0;
                                    }
                                    hr = hr - 1 | 0;
                                  }
                                  G = G + 1 | 0, o = o + 12 | 0;
                                }
                              }
                              break;
                            }
                          else {
                            ke = ye[o + 11 | 0], ke = !((ke & 128) >>> 7 | 0 ? e[o + 4 >> 2] : ke & 127), $[G | 0] = ke ? 2 : 1, Tr = ke + Tr | 0, hr = hr - ke | 0, G = G + 1 | 0, o = o + 12 | 0;
                            continue;
                          }
                          break;
                        }
                        break t;
                      }
                      n: {
                        i: {
                          for (; ; ) {
                            if ((c | 0) == (h | 0))
                              break i;
                            if (ye[Ar | 0] != 2) {
                              Ar = Ar + 1 | 0, c = c + 12 | 0;
                              continue;
                            }
                            break;
                          }
                          h = c;
                          break n;
                        }
                        e[g >> 2] = e[g >> 2] | 4;
                      }
                      return Js(Rn), Yr = Fe + 128 | 0, h | 0;
                    }
                  }
                  r = Vr() | 0, Js(Rn), Ki(r | 0);
                }
                ri();
              }
              function Gf(r, o, c, h, y, g, S) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0;
                var G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0;
                Fe = Yr - 128 | 0, Yr = Fe, e[Fe + 124 >> 2] = o, e[Fe + 4 >> 2] = 184, o = Fe + 8 | 0, e[o >> 2] = 0, e[o + 4 >> 2] = e[Fe + 4 >> 2], Rn = o, Ar = Fe + 16 | 0, hr = (h - c | 0) / 12 | 0;
                e: {
                  t: {
                    if (hr >>> 0 >= 101) {
                      if (Ar = ia(hr), !Ar) {
                        if (e[5996] = 0, Ri(185), r = e[5996], e[5996] = 0, (r | 0) != 1)
                          break e;
                        break t;
                      }
                      Yo(Rn, Ar);
                    }
                    G = Ar, o = c;
                    r: {
                      n: {
                        for (; ; ) {
                          if ((o | 0) == (h | 0))
                            i: for (; ; ) {
                              s: {
                                if (e[5996] = 0, G = On(202, r | 0, Fe + 124 | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                  break s;
                                if ((!hr | G) == 1) {
                                  if (e[5996] = 0, o = On(202, r | 0, Fe + 124 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                    break r;
                                  if (!o)
                                    break n;
                                  e[g >> 2] = e[g >> 2] | 2;
                                  break n;
                                }
                                o = e[r >> 2], e[5996] = 0, Mn = ii(203, o | 0) | 0, o = e[5996], e[5996] = 0;
                                a: {
                                  if ((o | 0) != 1 && (S || (e[5996] = 0, Mn = On(204, y | 0, Mn | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)))
                                    break a;
                                  break t;
                                }
                                for (ke = ei + 1 | 0, gi = 0, G = Ar, o = c; ; ) {
                                  if ((o | 0) == (h | 0)) {
                                    if (ei = ke, !gi)
                                      continue i;
                                    if (e[5996] = 0, ii(205, r | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1) {
                                      if (G = Ar, o = c, hr + Tr >>> 0 < 2)
                                        continue i;
                                      for (; ; ) {
                                        if ((o | 0) == (h | 0))
                                          continue i;
                                        a: {
                                          if (ye[G | 0] != 2 || (ke = ye[o + 11 | 0], (((ke & 128) >>> 7 | 0 ? e[o + 4 >> 2] : ke & 127) | 0) == (ei | 0)))
                                            break a;
                                          $[G | 0] = 0, Tr = Tr - 1 | 0;
                                        }
                                        G = G + 1 | 0, o = o + 12 | 0;
                                      }
                                    }
                                    break t;
                                  }
                                  a: {
                                    if (ye[G | 0] != 1)
                                      break a;
                                    ci = e[(ei << 2) + ((ye[o + 11 | 0] & 128) >>> 7 | 0 ? e[o >> 2] : o) >> 2];
                                    o: {
                                      if (S || (e[5996] = 0, ci = On(204, y | 0, ci | 0) | 0, ln = e[5996], e[5996] = 0, (ln | 0) != 1))
                                        break o;
                                      break t;
                                    }
                                    o: {
                                      if ((Mn | 0) == (ci | 0)) {
                                        if (gi = 1, ln = ye[o + 11 | 0], (ke | 0) != (((ln & 128) >>> 7 | 0 ? e[o + 4 >> 2] : ln & 127) | 0))
                                          break a;
                                        $[G | 0] = 2, Tr = Tr + 1 | 0;
                                        break o;
                                      }
                                      $[G | 0] = 0;
                                    }
                                    hr = hr - 1 | 0;
                                  }
                                  G = G + 1 | 0, o = o + 12 | 0;
                                }
                              }
                              break;
                            }
                          else {
                            ke = ye[o + 11 | 0], ke = !((ke & 128) >>> 7 | 0 ? e[o + 4 >> 2] : ke & 127), $[G | 0] = ke ? 2 : 1, Tr = ke + Tr | 0, hr = hr - ke | 0, G = G + 1 | 0, o = o + 12 | 0;
                            continue;
                          }
                          break;
                        }
                        break t;
                      }
                      n: {
                        i: {
                          for (; ; ) {
                            if ((c | 0) == (h | 0))
                              break i;
                            if (ye[Ar | 0] != 2) {
                              Ar = Ar + 1 | 0, c = c + 12 | 0;
                              continue;
                            }
                            break;
                          }
                          h = c;
                          break n;
                        }
                        e[g >> 2] = e[g >> 2] | 4;
                      }
                      return Js(Rn), Yr = Fe + 128 | 0, h | 0;
                    }
                  }
                  r = Vr() | 0, Js(Rn), Ki(r | 0);
                }
                ri();
              }
              function sg(r, o, c, h, y, g, S) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0;
                var G = 0, ke = 0, Fe = 0, Ar = 0;
                G = Yr - 624 | 0, Yr = G, e[G + 616 >> 2] = c, e[G + 620 >> 2] = o, e[G + 16 >> 2] = 220, ke = G + 200 | 0, e[ke >> 2] = G + 208, r = G + 16 | 0, e[ke + 4 >> 2] = e[r >> 2], Fe = G + 192 | 0, o = e[y + 28 >> 2], e[Fe >> 2] = o, e[o + 4 >> 2] = e[o + 4 >> 2] + 1, e[5996] = 0, Ar = ii(197, e[G + 192 >> 2]) | 0, o = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            a: {
                              if ((o | 0) != 1) {
                                if ($[G + 191 | 0] = 0, o = e[y + 4 >> 2], e[5996] = 0, o = tf(228, G + 620 | 0, c | 0, h | 0, Fe | 0, o | 0, g | 0, G + 191 | 0, Ar | 0, ke | 0, G + 196 | 0, G + 608 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                  break n;
                                if (!o)
                                  break i;
                                if (o = ye[3833] | ye[3834] << 8 | (ye[3835] << 16 | ye[3836] << 24), $[G + 183 | 0] = o, $[G + 184 | 0] = o >>> 8, $[G + 185 | 0] = o >>> 16, $[G + 186 | 0] = o >>> 24, o = ye[3830] | ye[3831] << 8 | (ye[3832] << 16 | ye[3833] << 24), e[G + 176 >> 2] = ye[3826] | ye[3827] << 8 | (ye[3828] << 16 | ye[3829] << 24), e[G + 180 >> 2] = o, e[5996] = 0, Qs(208, Ar | 0, G + 176 | 0, G + 186 | 0, G + 128 | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                  break a;
                                if (e[G + 4 >> 2] = 184, h = G + 8 | 0, e[h >> 2] = 0, e[h + 4 >> 2] = e[G + 4 >> 2], y = r, o = e[G + 196 >> 2], r = o - e[ke >> 2] | 0, (r | 0) < 393 || (Yo(h, ia((r >> 2) + 2 | 0)), y = e[h >> 2], y))
                                  break s;
                                if (e[5996] = 0, Ri(185), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                  break r;
                                break e;
                              }
                              c = Vr() | 0;
                              break t;
                            }
                            c = Vr() | 0;
                            break t;
                          }
                          for (ye[G + 191 | 0] && ($[y | 0] = 45, y = y + 1 | 0), c = e[ke >> 2]; ; ) {
                            if (o >>> 0 <= c >>> 0) {
                              if ($[y | 0] = 0, e[G >> 2] = S, (Qd(G + 16 | 0, G) | 0) != 1) {
                                if (e[5996] = 0, ko(222, 1730), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                  break e;
                                break r;
                              }
                              Js(h);
                            } else {
                              r = G + 128 | 0, $[y | 0] = ye[(G + 176 | 0) + (Rd(r, r + 40 | 0, e[c >> 2]) - r >> 2) | 0], y = y + 1 | 0, c = c + 4 | 0, o = e[G + 196 >> 2];
                              continue;
                            }
                            break;
                          }
                        }
                        if (e[5996] = 0, r = On(202, G + 620 | 0, G + 616 | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                          break n;
                        return r && (e[g >> 2] = e[g >> 2] | 2), c = e[G + 620 >> 2], r = e[G + 192 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Js(ke), Yr = G + 624 | 0, c | 0;
                      }
                      c = Vr() | 0;
                      break t;
                    }
                    c = Vr() | 0, Js(h);
                  }
                  r = e[G + 192 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Js(ke), Ki(c | 0), ri();
                }
                ri();
              }
              function og(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0;
                if (y = e[r + 4 >> 2], c = e[r >> 2], h = y - c >> 2, h >>> 0 < o >>> 0) {
                  G = Yr - 32 | 0, Yr = G, g = o - h | 0;
                  e: {
                    if (g >>> 0 <= e[r + 8 >> 2] - y >> 2 >>> 0) {
                      bd(r, g);
                      break e;
                    }
                    S = r + 16 | 0, h = G + 12 | 0, c = Yr - 16 | 0, Yr = c, y = g + (y - e[r >> 2] >> 2) | 0, e[c + 12 >> 2] = y;
                    t: {
                      if (o = Fc(), y >>> 0 <= o >>> 0) {
                        y = e[r + 8 >> 2] - e[r >> 2] >> 2, y >>> 0 < o >>> 1 >>> 0 && (e[c + 8 >> 2] = y << 1, o = e[(Ps[c + 8 >> 2] < Ps[c + 12 >> 2] ? c + 12 | 0 : c + 8 | 0) >> 2]), Yr = c + 16 | 0;
                        break t;
                      }
                      Lo(), ri();
                    }
                    ke = e[r + 4 >> 2] - e[r >> 2] >> 2, y = Yr - 16 | 0, Yr = y, e[h + 12 >> 2] = 0, e[h + 16 >> 2] = S;
                    t: {
                      if (!o) {
                        c = 0, o = 0;
                        break t;
                      }
                      t4(y + 8 | 0, e[h + 16 >> 2], o), c = e[y + 8 >> 2], o = e[y + 12 >> 2];
                    }
                    for (e[h >> 2] = c, S = c + (ke << 2) | 0, e[h + 8 >> 2] = S, e[h + 4 >> 2] = S, e[h + 12 >> 2] = c + (o << 2), Yr = y + 16 | 0, c = Yr - 16 | 0, Yr = c, e[c + 4 >> 2] = e[h + 8 >> 2], o = e[h + 8 >> 2], e[c + 12 >> 2] = h + 8, e[c + 8 >> 2] = o + (g << 2), o = e[c + 4 >> 2]; ; ) {
                      if (e[c + 8 >> 2] != (o | 0)) {
                        e[o >> 2] = 0, o = e[c + 4 >> 2] + 4 | 0, e[c + 4 >> 2] = o;
                        continue;
                      }
                      break;
                    }
                    for (e[e[c + 12 >> 2] >> 2] = e[c + 4 >> 2], Yr = c + 16 | 0, y = Yr - 16 | 0, Yr = y, e[y + 12 >> 2] = e[r + 4 >> 2], e[y + 8 >> 2] = e[r >> 2], e[y + 4 >> 2] = e[h + 4 >> 2], g = e[y + 12 >> 2], ke = e[y + 4 >> 2], S = Yr - 16 | 0, Yr = S, o = Yr - 32 | 0, Yr = o, c = Yr - 16 | 0, Yr = c, e[c + 12 >> 2] = e[y + 8 >> 2], e[o + 24 >> 2] = g, e[o + 28 >> 2] = e[c + 12 >> 2], Yr = c + 16 | 0, g = e[o + 24 >> 2], Fe = e[o + 28 >> 2], c = Yr - 16 | 0, Yr = c, e[c + 8 >> 2] = ke, e[c + 12 >> 2] = g; ; ) {
                      if ((g | 0) != (Fe | 0)) {
                        e[e[c + 8 >> 2] - 4 >> 2] = e[g - 4 >> 2], e[c + 12 >> 2] = e[c + 12 >> 2] - 4, e[c + 8 >> 2] = e[c + 8 >> 2] - 4, g = e[c + 12 >> 2];
                        continue;
                      }
                      break;
                    }
                    for (e[o + 16 >> 2] = g, e[o + 20 >> 2] = e[c + 8 >> 2], Yr = c + 16 | 0, c = e[o + 16 >> 2], e[o + 12 >> 2] = e[o + 20 >> 2], e[S + 8 >> 2] = c, e[S + 12 >> 2] = e[o + 12 >> 2], Yr = o + 32 | 0, Yr = S + 16 | 0, e[h + 4 >> 2] = e[S + 12 >> 2], o = e[r >> 2], e[r >> 2] = e[h + 4 >> 2], e[h + 4 >> 2] = o, o = e[r + 4 >> 2], e[r + 4 >> 2] = e[h + 8 >> 2], e[h + 8 >> 2] = o, o = e[r + 8 >> 2], e[r + 8 >> 2] = e[h + 12 >> 2], e[h + 12 >> 2] = o, e[h >> 2] = e[h + 4 >> 2], Yr = y + 16 | 0, o = e[h + 4 >> 2], r = e[h + 8 >> 2]; ; ) {
                      if ((r | 0) != (o | 0)) {
                        r = r - 4 | 0, e[h + 8 >> 2] = r;
                        continue;
                      }
                      break;
                    }
                    r = e[h >> 2], r && Md(e[h + 16 >> 2], r);
                  }
                  Yr = G + 32 | 0;
                  return;
                }
                o >>> 0 < h >>> 0 && r4(r, c + (o << 2) | 0);
              }
              function Ul(r, o, c, h, y, g, S) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0;
                var G = 0, ke = 0, Fe = 0, Ar = 0;
                G = Yr - 272 | 0, Yr = G, e[G + 264 >> 2] = c, e[G + 268 >> 2] = o, e[G + 16 >> 2] = 220, ke = G + 152 | 0, e[ke >> 2] = G + 160, r = G + 16 | 0, e[ke + 4 >> 2] = e[r >> 2], Fe = G + 144 | 0, o = e[y + 28 >> 2], e[Fe >> 2] = o, e[o + 4 >> 2] = e[o + 4 >> 2] + 1, e[5996] = 0, Ar = ii(170, e[G + 144 >> 2]) | 0, o = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            a: {
                              if ((o | 0) != 1) {
                                if ($[G + 143 | 0] = 0, o = e[y + 4 >> 2], e[5996] = 0, o = tf(221, G + 268 | 0, c | 0, h | 0, Fe | 0, o | 0, g | 0, G + 143 | 0, Ar | 0, ke | 0, G + 148 | 0, G + 260 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                  break n;
                                if (!o)
                                  break i;
                                if (o = ye[3833] | ye[3834] << 8 | (ye[3835] << 16 | ye[3836] << 24), $[G + 135 | 0] = o, $[G + 136 | 0] = o >>> 8, $[G + 137 | 0] = o >>> 16, $[G + 138 | 0] = o >>> 24, o = ye[3830] | ye[3831] << 8 | (ye[3832] << 16 | ye[3833] << 24), e[G + 128 >> 2] = ye[3826] | ye[3827] << 8 | (ye[3828] << 16 | ye[3829] << 24), e[G + 132 >> 2] = o, e[5996] = 0, Qs(195, Ar | 0, G + 128 | 0, G + 138 | 0, G + 118 | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                  break a;
                                if (e[G + 4 >> 2] = 184, h = G + 8 | 0, e[h >> 2] = 0, e[h + 4 >> 2] = e[G + 4 >> 2], y = r, o = e[G + 148 >> 2], r = o - e[ke >> 2] | 0, (r | 0) < 99 || (Yo(h, ia(r + 2 | 0)), y = e[h >> 2], y))
                                  break s;
                                if (e[5996] = 0, Ri(185), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                  break r;
                                break e;
                              }
                              c = Vr() | 0;
                              break t;
                            }
                            c = Vr() | 0;
                            break t;
                          }
                          for (ye[G + 143 | 0] && ($[y | 0] = 45, y = y + 1 | 0), c = e[ke >> 2]; ; ) {
                            if (o >>> 0 <= c >>> 0) {
                              if ($[y | 0] = 0, e[G >> 2] = S, (Qd(G + 16 | 0, G) | 0) != 1) {
                                if (e[5996] = 0, ko(222, 1730), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                  break e;
                                break r;
                              }
                              Js(h);
                            } else {
                              r = G + 118 | 0, $[y | 0] = ye[((xd(r, r + 10 | 0, ye[c | 0]) - G | 0) + G | 0) + 10 | 0], y = y + 1 | 0, c = c + 1 | 0, o = e[G + 148 >> 2];
                              continue;
                            }
                            break;
                          }
                        }
                        if (e[5996] = 0, r = On(186, G + 268 | 0, G + 264 | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                          break n;
                        return r && (e[g >> 2] = e[g >> 2] | 2), c = e[G + 268 >> 2], r = e[G + 144 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Js(ke), Yr = G + 272 | 0, c | 0;
                      }
                      c = Vr() | 0;
                      break t;
                    }
                    c = Vr() | 0, Js(h);
                  }
                  r = e[G + 144 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Js(ke), Ki(c | 0), ri();
                }
                ri();
              }
              function Ml(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0;
                h = e[h + 28 >> 2], r = Yr - 272 | 0, Yr = r, e[r + 264 >> 2] = c, e[r + 268 >> 2] = o, td(r + 208 | 0, h, r + 224 | 0, r + 223 | 0, r + 222 | 0), h = r + 196 | 0, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, o = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, o | 0), o = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((o | 0) != 1) {
                        for (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 192 >> 2] = c, e[r + 28 >> 2] = r + 32, e[r + 24 >> 2] = 0, $[r + 23 | 0] = 1, $[r + 22 | 0] = 69, S = ye[r + 222 | 0] << 24 >> 24, ke = ye[r + 223 | 0] << 24 >> 24; ; ) {
                          n: {
                            if (e[5996] = 0, o = On(186, r + 268 | 0, r + 264 | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (o)
                              break r;
                            if (o = ye[h + 11 | 0], o = (o & 128) >>> 7 | 0 ? e[h + 4 >> 2] : o & 127, e[r + 192 >> 2] == (o + c | 0)) {
                              if (e[5996] = 0, di(172, h | 0, o << 1), c = e[5996], e[5996] = 0, (c | 0) == 1 || (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0, (c | 0) == 1))
                                break t;
                              c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 192 >> 2] = o + c;
                            }
                            if (e[5996] = 0, o = ii(187, e[r + 268 >> 2]) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (cf(o, r + 23 | 0, r + 22 | 0, c, r + 192 | 0, ke, S, r + 208 | 0, r + 32 | 0, r + 28 | 0, r + 24 | 0, r + 224 | 0))
                              break r;
                            if (e[5996] = 0, ii(189, r + 268 | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    o = ye[r + 219 | 0];
                    r: {
                      if (!((o & 128) >>> 7 | 0 ? e[r + 212 >> 2] : o & 127) | !ye[r + 23 | 0] || (o = e[r + 28 >> 2], (o - (r + 32 | 0) | 0) > 159))
                        break r;
                      e[r + 28 >> 2] = o + 4, e[o >> 2] = e[r + 24 >> 2];
                    }
                    if (hh(r, c, e[r + 192 >> 2], y), o = e[r >> 2], c = e[r + 4 >> 2], S = e[r + 12 >> 2], e[g + 8 >> 2] = e[r + 8 >> 2], e[g + 12 >> 2] = S, e[g >> 2] = o, e[g + 4 >> 2] = c, ma(r + 208 | 0, r + 32 | 0, e[r + 28 >> 2], y), e[5996] = 0, o = On(186, r + 268 | 0, r + 264 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                      o && (e[y >> 2] = e[y >> 2] | 2), o = e[r + 268 >> 2], qi(h), qi(r + 208 | 0), Yr = r + 272 | 0;
                      break e;
                    }
                  }
                  o = Vr() | 0, qi(h), qi(r + 208 | 0), Ki(o | 0), ri();
                }
                return o | 0;
              }
              function ag(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0;
                h = e[h + 28 >> 2], r = Yr - 384 | 0, Yr = r, e[r + 376 >> 2] = c, e[r + 380 >> 2] = o, ed(r + 220 | 0, h, r + 240 | 0, r + 236 | 0, r + 232 | 0), h = r + 208 | 0, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, o = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, o | 0), o = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((o | 0) != 1) {
                        for (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 204 >> 2] = c, e[r + 28 >> 2] = r + 32, e[r + 24 >> 2] = 0, $[r + 23 | 0] = 1, $[r + 22 | 0] = 69, S = e[r + 232 >> 2], ke = e[r + 236 >> 2]; ; ) {
                          n: {
                            if (e[5996] = 0, o = On(202, r + 380 | 0, r + 376 | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (o)
                              break r;
                            if (o = ye[h + 11 | 0], o = (o & 128) >>> 7 | 0 ? e[h + 4 >> 2] : o & 127, e[r + 204 >> 2] == (o + c | 0)) {
                              if (e[5996] = 0, di(172, h | 0, o << 1), c = e[5996], e[5996] = 0, (c | 0) == 1 || (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0, (c | 0) == 1))
                                break t;
                              c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 204 >> 2] = o + c;
                            }
                            if (e[5996] = 0, o = ii(203, e[r + 380 >> 2]) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (Wf(o, r + 23 | 0, r + 22 | 0, c, r + 204 | 0, ke, S, r + 220 | 0, r + 32 | 0, r + 28 | 0, r + 24 | 0, r + 240 | 0))
                              break r;
                            if (e[5996] = 0, ii(205, r + 380 | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    o = ye[r + 231 | 0];
                    r: {
                      if (!((o & 128) >>> 7 | 0 ? e[r + 224 >> 2] : o & 127) | !ye[r + 23 | 0] || (o = e[r + 28 >> 2], (o - (r + 32 | 0) | 0) > 159))
                        break r;
                      e[r + 28 >> 2] = o + 4, e[o >> 2] = e[r + 24 >> 2];
                    }
                    if (hh(r, c, e[r + 204 >> 2], y), o = e[r >> 2], c = e[r + 4 >> 2], S = e[r + 12 >> 2], e[g + 8 >> 2] = e[r + 8 >> 2], e[g + 12 >> 2] = S, e[g >> 2] = o, e[g + 4 >> 2] = c, ma(r + 220 | 0, r + 32 | 0, e[r + 28 >> 2], y), e[5996] = 0, o = On(202, r + 380 | 0, r + 376 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                      o && (e[y >> 2] = e[y >> 2] | 2), o = e[r + 380 >> 2], qi(h), qi(r + 220 | 0), Yr = r + 384 | 0;
                      break e;
                    }
                  }
                  o = Vr() | 0, qi(h), qi(r + 220 | 0), Ki(o | 0), ri();
                }
                return o | 0;
              }
              function ug(r, o, c, h, y, g, S, G) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, G = G | 0;
                var ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0;
                ln = o, ke = Yr - 256 | 0, Yr = ke, e[ke + 248 >> 2] = 37, e[ke + 252 >> 2] = 0, o = ke + 248 | 0, hr = If(o | 1, 3264, e[c + 4 >> 2]), Fe = ke + 208 | 0, e[ke + 204 >> 2] = Fe, r = mo();
                e: {
                  if (hr) {
                    Ar = e[c + 8 >> 2], Tr = ke - -64 | 0, e[Tr >> 2] = S, e[Tr + 4 >> 2] = G, e[ke + 56 >> 2] = y, e[ke + 60 >> 2] = g, e[ke + 48 >> 2] = Ar, Fe = Zo(Fe, 30, r, o, ke + 48 | 0);
                    break e;
                  }
                  e[ke + 80 >> 2] = y, e[ke + 84 >> 2] = g, e[ke + 88 >> 2] = S, e[ke + 92 >> 2] = G, Fe = Zo(ke + 208 | 0, 30, r, ke + 248 | 0, ke + 80 | 0);
                }
                e[ke + 128 >> 2] = 184, Ar = ke + 196 | 0, e[Ar >> 2] = 0, e[Ar + 4 >> 2] = e[ke + 128 >> 2], o = ke + 208 | 0, r = o;
                e: {
                  t: {
                    r: {
                      n: {
                        if ((Fe | 0) >= 30) {
                          r = mo();
                          i: {
                            if (hr) {
                              Fe = e[c + 8 >> 2], e[ke + 16 >> 2] = S, e[ke + 20 >> 2] = G, e[ke + 8 >> 2] = y, e[ke + 12 >> 2] = g, e[ke >> 2] = Fe, Fe = fu(ke + 204 | 0, r, ke + 248 | 0, ke);
                              break i;
                            }
                            e[ke + 32 >> 2] = y, e[ke + 36 >> 2] = g, e[ke + 40 >> 2] = S, e[ke + 44 >> 2] = G, Fe = fu(ke + 204 | 0, r, ke + 248 | 0, ke + 32 | 0);
                          }
                          if ((Fe | 0) == -1) {
                            if (e[5996] = 0, Ri(185), r = e[5996], e[5996] = 0, (r | 0) == 1)
                              break r;
                            break n;
                          }
                          r = e[ke + 204 >> 2], Yo(Ar, r);
                        }
                        S = r + Fe | 0, G = Ka(r, S, e[c + 4 >> 2]), e[ke + 116 >> 2] = 184, y = ke + 120 | 0, e[y >> 2] = 0, e[y + 4 >> 2] = e[ke + 116 >> 2];
                        i: {
                          s: {
                            if ((ke + 208 | 0) == (r | 0)) {
                              Fe = ke + 128 | 0;
                              break s;
                            }
                            if (Fe = ia(Fe << 1), !Fe) {
                              if (e[5996] = 0, Ri(185), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                break n;
                              r = Vr() | 0;
                              break i;
                            }
                            Yo(y, Fe), o = r;
                          }
                          r = ke + 108 | 0, g = e[c + 28 >> 2], e[r >> 2] = g, e[g + 4 >> 2] = e[g + 4 >> 2] + 1, e[5996] = 0, $a(212, o | 0, G | 0, S | 0, Fe | 0, ke + 116 | 0, ke + 112 | 0, r | 0), o = e[5996], e[5996] = 0;
                          s: {
                            if ((o | 0) != 1) {
                              if (r = e[r >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), e[5996] = 0, r = Fa(213, ln | 0, Fe | 0, e[ke + 116 >> 2], e[ke + 112 >> 2], c | 0, h | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                break s;
                              Js(y), Js(Ar), Yr = ke + 256 | 0;
                              break e;
                            }
                            r = Vr() | 0, o = e[ke + 108 >> 2], c = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = c, (c | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o);
                            break i;
                          }
                          r = Vr() | 0;
                        }
                        Js(y);
                        break t;
                      }
                      ri();
                    }
                    r = Vr() | 0;
                  }
                  Js(Ar), Ki(r | 0), ri();
                }
                return r | 0;
              }
              function cg(r, o, c, h, y, g, S, G) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, G = G | 0;
                var ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0;
                ln = o, ke = Yr - 416 | 0, Yr = ke, e[ke + 408 >> 2] = 37, e[ke + 412 >> 2] = 0, o = ke + 408 | 0, hr = If(o | 1, 3264, e[c + 4 >> 2]), Fe = ke + 368 | 0, e[ke + 364 >> 2] = Fe, r = mo();
                e: {
                  if (hr) {
                    Ar = e[c + 8 >> 2], Tr = ke - -64 | 0, e[Tr >> 2] = S, e[Tr + 4 >> 2] = G, e[ke + 56 >> 2] = y, e[ke + 60 >> 2] = g, e[ke + 48 >> 2] = Ar, Fe = Zo(Fe, 30, r, o, ke + 48 | 0);
                    break e;
                  }
                  e[ke + 80 >> 2] = y, e[ke + 84 >> 2] = g, e[ke + 88 >> 2] = S, e[ke + 92 >> 2] = G, Fe = Zo(ke + 368 | 0, 30, r, ke + 408 | 0, ke + 80 | 0);
                }
                e[ke + 128 >> 2] = 184, Ar = ke + 356 | 0, e[Ar >> 2] = 0, e[Ar + 4 >> 2] = e[ke + 128 >> 2], o = ke + 368 | 0, r = o;
                e: {
                  t: {
                    r: {
                      n: {
                        if ((Fe | 0) >= 30) {
                          r = mo();
                          i: {
                            if (hr) {
                              Fe = e[c + 8 >> 2], e[ke + 16 >> 2] = S, e[ke + 20 >> 2] = G, e[ke + 8 >> 2] = y, e[ke + 12 >> 2] = g, e[ke >> 2] = Fe, Fe = fu(ke + 364 | 0, r, ke + 408 | 0, ke);
                              break i;
                            }
                            e[ke + 32 >> 2] = y, e[ke + 36 >> 2] = g, e[ke + 40 >> 2] = S, e[ke + 44 >> 2] = G, Fe = fu(ke + 364 | 0, r, ke + 408 | 0, ke + 32 | 0);
                          }
                          if ((Fe | 0) == -1) {
                            if (e[5996] = 0, Ri(185), r = e[5996], e[5996] = 0, (r | 0) == 1)
                              break r;
                            break n;
                          }
                          r = e[ke + 364 >> 2], Yo(Ar, r);
                        }
                        S = r + Fe | 0, G = Ka(r, S, e[c + 4 >> 2]), e[ke + 116 >> 2] = 184, y = ke + 120 | 0, e[y >> 2] = 0, e[y + 4 >> 2] = e[ke + 116 >> 2];
                        i: {
                          s: {
                            if ((ke + 368 | 0) == (r | 0)) {
                              Fe = ke + 128 | 0;
                              break s;
                            }
                            if (Fe = ia(Fe << 3), !Fe) {
                              if (e[5996] = 0, Ri(185), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                break n;
                              r = Vr() | 0;
                              break i;
                            }
                            Yo(y, Fe), o = r;
                          }
                          r = ke + 108 | 0, g = e[c + 28 >> 2], e[r >> 2] = g, e[g + 4 >> 2] = e[g + 4 >> 2] + 1, e[5996] = 0, $a(218, o | 0, G | 0, S | 0, Fe | 0, ke + 116 | 0, ke + 112 | 0, r | 0), o = e[5996], e[5996] = 0;
                          s: {
                            if ((o | 0) != 1) {
                              if (r = e[r >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), e[5996] = 0, r = Fa(219, ln | 0, Fe | 0, e[ke + 116 >> 2], e[ke + 112 >> 2], c | 0, h | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                break s;
                              Js(y), Js(Ar), Yr = ke + 416 | 0;
                              break e;
                            }
                            r = Vr() | 0, o = e[ke + 108 >> 2], c = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = c, (c | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o);
                            break i;
                          }
                          r = Vr() | 0;
                        }
                        Js(y);
                        break t;
                      }
                      ri();
                    }
                    r = Vr() | 0;
                  }
                  Js(Ar), Ki(r | 0), ri();
                }
                return r | 0;
              }
              function Fl(r, o, c) {
                var h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0;
                $[r | 0] = 0, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 4 | 0] = 0, $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, Fe = ye[o + 8 | 0] | ye[o + 9 | 0] << 8 | (ye[o + 10 | 0] << 16 | ye[o + 11 | 0] << 24), y = -29, g = ye[o | 0] | ye[o + 1 | 0] << 8 | (ye[o + 2 | 0] << 16 | ye[o + 3 | 0] << 24), G = g >>> 0 < 29;
                e: {
                  if (g = G ? g : g - 29 | 0, g >>> 0 >= 29) {
                    if (e[5996] = 0, di(124, r | 0, g + (g >>> 1 | 0) | 0), y = e[5996], e[5996] = 0, (y | 0) == 1)
                      break e;
                    h = ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24), S = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), y = S - 29 | 0;
                  }
                  ke = S >>> 0 < 29, h = ke ? r + 4 | 0 : h, Ks(g + h | 0, h, ke ? S : y), y = g + (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) | 0, $[r | 0] = y, $[r + 1 | 0] = y >>> 8, $[r + 2 | 0] = y >>> 16, $[r + 3 | 0] = y >>> 24;
                  t: {
                    if (!g)
                      break t;
                    y = G ? o + 4 | 0 : Fe, G = g & 7;
                    r: {
                      if (!G) {
                        o = y;
                        break r;
                      }
                      for (S = 0, o = y; $[h | 0] = ye[o | 0], o = o + 1 | 0, h = h + 1 | 0, S = S + 1 | 0, (G | 0) != (S | 0); )
                        ;
                    }
                    if (g >>> 0 < 8)
                      break t;
                    for (y = y + g | 0; $[h | 0] = ye[o | 0], $[h + 1 | 0] = ye[o + 1 | 0], $[h + 2 | 0] = ye[o + 2 | 0], $[h + 3 | 0] = ye[o + 3 | 0], $[h + 4 | 0] = ye[o + 4 | 0], $[h + 5 | 0] = ye[o + 5 | 0], $[h + 6 | 0] = ye[o + 6 | 0], $[h + 7 | 0] = ye[o + 7 | 0], h = h + 8 | 0, o = o + 8 | 0, (y | 0) != (o | 0); )
                      ;
                  }
                  if (o = e[c >> 2], e[5996] = 0, On(127, r | 0, o | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                    break e;
                  return;
                }
                o = Vr() | 0, (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) >>> 0 >= 29 && (Sr(ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)), $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0), Ki(o | 0), ri();
              }
              function fg(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0;
                h = e[h + 28 >> 2], r = Yr - 256 | 0, Yr = r, e[r + 248 >> 2] = c, e[r + 252 >> 2] = o, td(r + 192 | 0, h, r + 208 | 0, r + 207 | 0, r + 206 | 0), h = r + 180 | 0, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, o = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, o | 0), o = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((o | 0) != 1) {
                        for (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 176 >> 2] = c, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0, $[r + 7 | 0] = 1, $[r + 6 | 0] = 69, G = ye[r + 206 | 0] << 24 >> 24, ke = ye[r + 207 | 0] << 24 >> 24; ; ) {
                          n: {
                            if (e[5996] = 0, o = On(186, r + 252 | 0, r + 248 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                              break n;
                            if (o)
                              break r;
                            if (o = ye[h + 11 | 0], o = (o & 128) >>> 7 | 0 ? e[h + 4 >> 2] : o & 127, e[r + 176 >> 2] == (o + c | 0)) {
                              if (e[5996] = 0, di(172, h | 0, o << 1), c = e[5996], e[5996] = 0, (c | 0) == 1 || (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0, (c | 0) == 1))
                                break t;
                              c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 176 >> 2] = o + c;
                            }
                            if (e[5996] = 0, o = ii(187, e[r + 252 >> 2]) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                              break n;
                            if (cf(o, r + 7 | 0, r + 6 | 0, c, r + 176 | 0, ke, G, r + 192 | 0, r + 16 | 0, r + 12 | 0, r + 8 | 0, r + 208 | 0))
                              break r;
                            if (e[5996] = 0, ii(189, r + 252 | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    o = ye[r + 203 | 0];
                    r: {
                      if (!((o & 128) >>> 7 | 0 ? e[r + 196 >> 2] : o & 127) | !ye[r + 7 | 0] || (o = e[r + 12 >> 2], (o - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = o + 4, e[o >> 2] = e[r + 8 >> 2];
                    }
                    if (ef[g >> 2] = qh(c, e[r + 176 >> 2], y), ma(r + 192 | 0, r + 16 | 0, e[r + 12 >> 2], y), e[5996] = 0, o = On(186, r + 252 | 0, r + 248 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                      o && (e[y >> 2] = e[y >> 2] | 2), o = e[r + 252 >> 2], qi(h), qi(r + 192 | 0), Yr = r + 256 | 0;
                      break e;
                    }
                  }
                  o = Vr() | 0, qi(h), qi(r + 192 | 0), Ki(o | 0), ri();
                }
                return o | 0;
              }
              function no(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0;
                h = e[h + 28 >> 2], r = Yr - 256 | 0, Yr = r, e[r + 248 >> 2] = c, e[r + 252 >> 2] = o, td(r + 192 | 0, h, r + 208 | 0, r + 207 | 0, r + 206 | 0), h = r + 180 | 0, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, o = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, o | 0), o = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((o | 0) != 1) {
                        for (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 176 >> 2] = c, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0, $[r + 7 | 0] = 1, $[r + 6 | 0] = 69, G = ye[r + 206 | 0] << 24 >> 24, ke = ye[r + 207 | 0] << 24 >> 24; ; ) {
                          n: {
                            if (e[5996] = 0, o = On(186, r + 252 | 0, r + 248 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                              break n;
                            if (o)
                              break r;
                            if (o = ye[h + 11 | 0], o = (o & 128) >>> 7 | 0 ? e[h + 4 >> 2] : o & 127, e[r + 176 >> 2] == (o + c | 0)) {
                              if (e[5996] = 0, di(172, h | 0, o << 1), c = e[5996], e[5996] = 0, (c | 0) == 1 || (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0, (c | 0) == 1))
                                break t;
                              c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 176 >> 2] = o + c;
                            }
                            if (e[5996] = 0, o = ii(187, e[r + 252 >> 2]) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                              break n;
                            if (cf(o, r + 7 | 0, r + 6 | 0, c, r + 176 | 0, ke, G, r + 192 | 0, r + 16 | 0, r + 12 | 0, r + 8 | 0, r + 208 | 0))
                              break r;
                            if (e[5996] = 0, ii(189, r + 252 | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    o = ye[r + 203 | 0];
                    r: {
                      if (!((o & 128) >>> 7 | 0 ? e[r + 196 >> 2] : o & 127) | !ye[r + 7 | 0] || (o = e[r + 12 >> 2], (o - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = o + 4, e[o >> 2] = e[r + 8 >> 2];
                    }
                    if (Fi[g >> 3] = Oh(c, e[r + 176 >> 2], y), ma(r + 192 | 0, r + 16 | 0, e[r + 12 >> 2], y), e[5996] = 0, o = On(186, r + 252 | 0, r + 248 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                      o && (e[y >> 2] = e[y >> 2] | 2), o = e[r + 252 >> 2], qi(h), qi(r + 192 | 0), Yr = r + 256 | 0;
                      break e;
                    }
                  }
                  o = Vr() | 0, qi(h), qi(r + 192 | 0), Ki(o | 0), ri();
                }
                return o | 0;
              }
              function Uu(r, o, c, h, y, g, S, G) {
                var ke = 0, Fe = 0, Ar = 0;
                if (ke = Yr - 16 | 0, Yr = ke, e[ke + 8 >> 2] = c, e[ke + 12 >> 2] = o, o = e[h + 28 >> 2], e[ke + 4 >> 2] = o, e[o + 4 >> 2] = e[o + 4 >> 2] + 1, c = 0, e[5996] = 0, Fe = ii(170, e[ke + 4 >> 2]) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1) {
                  o = e[ke + 4 >> 2], Ar = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = Ar, (Ar | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o), e[y >> 2] = 0;
                  e: {
                    for (; ; ) {
                      if (c | (S | 0) == (G | 0))
                        break e;
                      t: {
                        if (Nu(ke + 12 | 0, ke + 8 | 0))
                          break t;
                        r: {
                          if ((_n[e[e[Fe >> 2] + 36 >> 2]](Fe, $[S | 0], 0) | 0) == 37) {
                            if ((S + 1 | 0) == (G | 0))
                              break t;
                            c = _n[e[e[Fe >> 2] + 36 >> 2]](Fe, $[S + 1 | 0], 0) | 0;
                            n: {
                              if (!((c | 0) == 69 | (c & 255) == 48)) {
                                o = 0, Ar = 1;
                                break n;
                              }
                              if ((S + 2 | 0) == (G | 0))
                                break t;
                              o = c, c = _n[e[e[Fe >> 2] + 36 >> 2]](Fe, $[S + 2 | 0], 0) | 0, Ar = 2;
                            }
                            e[ke + 12 >> 2] = _n[e[e[r >> 2] + 36 >> 2]](r, e[ke + 12 >> 2], e[ke + 8 >> 2], h, y, g, c, o), S = (S + Ar | 0) + 1 | 0;
                            break r;
                          }
                          if (o = e[Fe + 8 >> 2], c = $[S | 0], (c | 0) >= 0 ? c = e[o + ((c & 255) << 2) >> 2] & 1 : c = 0, c) {
                            for (; ; ) {
                              n: {
                                if (S = S + 1 | 0, (G | 0) == (S | 0)) {
                                  S = G;
                                  break n;
                                }
                                if (c = $[S | 0], (c | 0) >= 0 ? c = e[o + ((c & 255) << 2) >> 2] & 1 : c = 0, c)
                                  continue;
                              }
                              break;
                            }
                            for (; ; ) {
                              if (Ar = ke + 12 | 0, Nu(Ar, ke + 8 | 0))
                                break r;
                              o = e[ke + 12 >> 2], c = e[o + 12 >> 2];
                              n: {
                                if ((c | 0) == e[o + 16 >> 2]) {
                                  o = _n[e[e[o >> 2] + 36 >> 2]](o) | 0;
                                  break n;
                                }
                                o = ye[c | 0];
                              }
                              if (c = e[Fe + 8 >> 2], o = o << 24 >> 24, (o | 0) >= 0 ? o = e[c + ((o & 255) << 2) >> 2] & 1 : o = 0, !o)
                                break r;
                              El(Ar);
                            }
                          }
                          o = e[ke + 12 >> 2], c = e[o + 12 >> 2];
                          n: {
                            if ((c | 0) == e[o + 16 >> 2]) {
                              o = _n[e[e[o >> 2] + 36 >> 2]](o) | 0;
                              break n;
                            }
                            o = ye[c | 0];
                          }
                          if ((_n[e[e[Fe >> 2] + 12 >> 2]](Fe, o << 24 >> 24) | 0) == (_n[e[e[Fe >> 2] + 12 >> 2]](Fe, $[S | 0]) | 0)) {
                            S = S + 1 | 0, El(ke + 12 | 0);
                            break r;
                          }
                          e[y >> 2] = 4;
                        }
                        c = e[y >> 2];
                        continue;
                      }
                      break;
                    }
                    e[y >> 2] = 4;
                  }
                  return Nu(ke + 12 | 0, ke + 8 | 0) && (e[y >> 2] = e[y >> 2] | 2), Yr = ke + 16 | 0, e[ke + 12 >> 2];
                }
                c = Vr() | 0, r = e[ke + 4 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
              }
              function lg(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0;
                h = e[h + 28 >> 2], r = Yr - 368 | 0, Yr = r, e[r + 360 >> 2] = c, e[r + 364 >> 2] = o, ed(r + 204 | 0, h, r + 224 | 0, r + 220 | 0, r + 216 | 0), h = r + 192 | 0, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, o = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, o | 0), o = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((o | 0) != 1) {
                        for (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 188 >> 2] = c, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0, $[r + 7 | 0] = 1, $[r + 6 | 0] = 69, G = e[r + 216 >> 2], ke = e[r + 220 >> 2]; ; ) {
                          n: {
                            if (e[5996] = 0, o = On(202, r + 364 | 0, r + 360 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                              break n;
                            if (o)
                              break r;
                            if (o = ye[h + 11 | 0], o = (o & 128) >>> 7 | 0 ? e[h + 4 >> 2] : o & 127, e[r + 188 >> 2] == (o + c | 0)) {
                              if (e[5996] = 0, di(172, h | 0, o << 1), c = e[5996], e[5996] = 0, (c | 0) == 1 || (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0, (c | 0) == 1))
                                break t;
                              c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 188 >> 2] = o + c;
                            }
                            if (e[5996] = 0, o = ii(203, e[r + 364 >> 2]) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                              break n;
                            if (Wf(o, r + 7 | 0, r + 6 | 0, c, r + 188 | 0, ke, G, r + 204 | 0, r + 16 | 0, r + 12 | 0, r + 8 | 0, r + 224 | 0))
                              break r;
                            if (e[5996] = 0, ii(205, r + 364 | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    o = ye[r + 215 | 0];
                    r: {
                      if (!((o & 128) >>> 7 | 0 ? e[r + 208 >> 2] : o & 127) | !ye[r + 7 | 0] || (o = e[r + 12 >> 2], (o - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = o + 4, e[o >> 2] = e[r + 8 >> 2];
                    }
                    if (ef[g >> 2] = qh(c, e[r + 188 >> 2], y), ma(r + 204 | 0, r + 16 | 0, e[r + 12 >> 2], y), e[5996] = 0, o = On(202, r + 364 | 0, r + 360 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                      o && (e[y >> 2] = e[y >> 2] | 2), o = e[r + 364 >> 2], qi(h), qi(r + 204 | 0), Yr = r + 368 | 0;
                      break e;
                    }
                  }
                  o = Vr() | 0, qi(h), qi(r + 204 | 0), Ki(o | 0), ri();
                }
                return o | 0;
              }
              function dg(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0;
                h = e[h + 28 >> 2], r = Yr - 368 | 0, Yr = r, e[r + 360 >> 2] = c, e[r + 364 >> 2] = o, ed(r + 204 | 0, h, r + 224 | 0, r + 220 | 0, r + 216 | 0), h = r + 192 | 0, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, o = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, o | 0), o = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((o | 0) != 1) {
                        for (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 188 >> 2] = c, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0, $[r + 7 | 0] = 1, $[r + 6 | 0] = 69, G = e[r + 216 >> 2], ke = e[r + 220 >> 2]; ; ) {
                          n: {
                            if (e[5996] = 0, o = On(202, r + 364 | 0, r + 360 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                              break n;
                            if (o)
                              break r;
                            if (o = ye[h + 11 | 0], o = (o & 128) >>> 7 | 0 ? e[h + 4 >> 2] : o & 127, e[r + 188 >> 2] == (o + c | 0)) {
                              if (e[5996] = 0, di(172, h | 0, o << 1), c = e[5996], e[5996] = 0, (c | 0) == 1 || (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0, (c | 0) == 1))
                                break t;
                              c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 188 >> 2] = o + c;
                            }
                            if (e[5996] = 0, o = ii(203, e[r + 364 >> 2]) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                              break n;
                            if (Wf(o, r + 7 | 0, r + 6 | 0, c, r + 188 | 0, ke, G, r + 204 | 0, r + 16 | 0, r + 12 | 0, r + 8 | 0, r + 224 | 0))
                              break r;
                            if (e[5996] = 0, ii(205, r + 364 | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    o = ye[r + 215 | 0];
                    r: {
                      if (!((o & 128) >>> 7 | 0 ? e[r + 208 >> 2] : o & 127) | !ye[r + 7 | 0] || (o = e[r + 12 >> 2], (o - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = o + 4, e[o >> 2] = e[r + 8 >> 2];
                    }
                    if (Fi[g >> 3] = Oh(c, e[r + 188 >> 2], y), ma(r + 204 | 0, r + 16 | 0, e[r + 12 >> 2], y), e[5996] = 0, o = On(202, r + 364 | 0, r + 360 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                      o && (e[y >> 2] = e[y >> 2] | 2), o = e[r + 364 >> 2], qi(h), qi(r + 204 | 0), Yr = r + 368 | 0;
                      break e;
                    }
                  }
                  o = Vr() | 0, qi(h), qi(r + 204 | 0), Ki(o | 0), ri();
                }
                return o | 0;
              }
              function jf(r, o) {
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0;
                e: {
                  t: {
                    if (r - 1 & r | o >>> 0 > 4294967239)
                      break t;
                    for (; ; ) {
                      r = r >>> 0 <= 8 ? 8 : r, y = e[5995], g = e[5994], o = o >>> 0 <= 8 ? 8 : o + 3 & -4;
                      r: {
                        if (o >>> 0 <= 127) {
                          S = (o >>> 3 | 0) - 1 | 0;
                          break r;
                        }
                        if (h = Do(o), S = ((o >>> 29 - h ^ 4) - (h << 2) | 0) + 110 | 0, o >>> 0 <= 4095)
                          break r;
                        h = ((o >>> 30 - h ^ 2) - (h << 1) | 0) + 71 | 0, S = h >>> 0 >= 63 ? 63 : h;
                      }
                      if (c = S & 31, (S & 63) >>> 0 >= 32 ? (h = 0, c = y >>> c | 0) : (h = y >>> c | 0, c = ((1 << c) - 1 & y) << 32 - c | g >>> c), c | h) {
                        for (; ; ) {
                          y = c;
                          r: {
                            if (h | y) {
                              g = h - 1 | 0, G = g + 1 | 0, c = g, g = y - 1 | 0, G = (g | 0) != -1 ? G : c, c = Do(h ^ G), c = (c | 0) == 32 ? Do(y ^ g) + 32 | 0 : c, g = 63 - c | 0, vs = 0 - (c >>> 0 > 63) | 0;
                              break r;
                            }
                            vs = 0, g = 64;
                          }
                          G = g, g = G & 31, (G & 63) >>> 0 >= 32 ? (c = 0, g = h >>> g | 0) : (c = h >>> g | 0, g = ((1 << g) - 1 & h) << 32 - g | y >>> g), h = c, S = S + G | 0, G = S << 4, y = e[G + 22952 >> 2], ke = G + 22944 | 0;
                          r: {
                            if ((y | 0) != (ke | 0)) {
                              if (c = $l(y, r, o), c)
                                break t;
                              c = e[y + 4 >> 2], e[c + 8 >> 2] = e[y + 8 >> 2], e[e[y + 8 >> 2] + 4 >> 2] = c, e[y + 8 >> 2] = ke, c = G + 22948 | 0, e[y + 4 >> 2] = e[c >> 2], e[c >> 2] = y, e[e[y + 4 >> 2] + 8 >> 2] = y, S = S + 1 | 0, c = (h & 1) << 31 | g >>> 1, h = h >>> 1 | 0;
                              break r;
                            }
                            c = e[5995], e[5994] = e[5994] & hd(-2, -1, S), e[5995] = vs & c, c = g ^ 1;
                          }
                          if (!(h | c))
                            break;
                        }
                        g = e[5994], y = e[5995];
                      }
                      r: {
                        if (y | g) {
                          h = Do(y), G = 63 - ((h | 0) == 32 ? Do(g) + 32 | 0 : h) | 0, c = G << 4, h = e[c + 22952 >> 2];
                          n: {
                            if (!y & g >>> 0 < 1073741824 || (S = 99, y = c + 22944 | 0, (y | 0) == (h | 0)))
                              break n;
                            for (; ; ) {
                              if (!S)
                                break n;
                              if (c = $l(h, r, o), c)
                                break t;
                              if (S = S - 1 | 0, h = e[h + 8 >> 2], (y | 0) == (h | 0))
                                break;
                            }
                            h = y;
                          }
                          if (zf(o + 48 | 0))
                            break r;
                          if (!h || (y = (G << 4) + 22944 | 0, (y | 0) == (h | 0)))
                            break e;
                          for (; ; ) {
                            if (c = $l(h, r, o), c)
                              break t;
                            if (h = e[h + 8 >> 2], (y | 0) == (h | 0))
                              break;
                          }
                          break e;
                        }
                        if (!zf(o + 48 | 0))
                          break e;
                      }
                      if (c = 0, r - 1 & r)
                        break t;
                      if (!(o >>> 0 <= 4294967239))
                        break;
                    }
                  }
                  return c;
                }
                return 0;
              }
              function hg(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0;
                r = Yr - 336 | 0, Yr = r, e[r + 328 >> 2] = c, e[r + 332 >> 2] = o, o = Gu(e[h + 4 >> 2]), ke = Dc(e[h + 28 >> 2], r + 208 | 0), gf(r + 196 | 0, e[h + 28 >> 2], r + 324 | 0), h = r + 184 | 0, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((c | 0) != 1) {
                        for (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 180 >> 2] = c, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0; ; ) {
                          n: {
                            if (e[5996] = 0, S = On(202, r + 332 | 0, r + 328 | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (S)
                              break r;
                            if (S = ye[h + 11 | 0], S = (S & 128) >>> 7 | 0 ? e[h + 4 >> 2] : S & 127, e[r + 180 >> 2] == (S + c | 0)) {
                              if (e[5996] = 0, di(172, h | 0, S << 1), c = e[5996], e[5996] = 0, (c | 0) == 1 || (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0, (c | 0) == 1))
                                break t;
                              c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 180 >> 2] = S + c;
                            }
                            if (e[5996] = 0, S = ii(203, e[r + 332 >> 2]) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (xc(S, o, c, r + 180 | 0, r + 8 | 0, e[r + 324 >> 2], e[r + 200 >> 2], ye[r + 207 | 0], r + 16 | 0, r + 12 | 0, ke))
                              break r;
                            if (e[5996] = 0, ii(205, r + 332 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    S = ye[r + 207 | 0];
                    r: {
                      if (!((S & 128) >>> 7 | 0 ? e[r + 200 >> 2] : S & 127) || (S = e[r + 12 >> 2], (S - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = S + 4, e[S >> 2] = e[r + 8 >> 2];
                    }
                    if (e[g >> 2] = Mh(c, e[r + 180 >> 2], y, o), e[g + 4 >> 2] = vs, ma(r + 196 | 0, r + 16 | 0, e[r + 12 >> 2], y), e[5996] = 0, o = On(202, r + 332 | 0, r + 328 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                      o && (e[y >> 2] = e[y >> 2] | 2), o = e[r + 332 >> 2], qi(h), qi(r + 196 | 0), Yr = r + 336 | 0;
                      break e;
                    }
                  }
                  o = Vr() | 0, qi(h), qi(r + 196 | 0), Ki(o | 0), ri();
                }
                return o | 0;
              }
              function Ag(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0;
                r = Yr - 336 | 0, Yr = r, e[r + 328 >> 2] = c, e[r + 332 >> 2] = o, o = Gu(e[h + 4 >> 2]), ke = Dc(e[h + 28 >> 2], r + 208 | 0), gf(r + 196 | 0, e[h + 28 >> 2], r + 324 | 0), h = r + 184 | 0, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((c | 0) != 1) {
                        for (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 180 >> 2] = c, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0; ; ) {
                          n: {
                            if (e[5996] = 0, S = On(202, r + 332 | 0, r + 328 | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (S)
                              break r;
                            if (S = ye[h + 11 | 0], S = (S & 128) >>> 7 | 0 ? e[h + 4 >> 2] : S & 127, e[r + 180 >> 2] == (S + c | 0)) {
                              if (e[5996] = 0, di(172, h | 0, S << 1), c = e[5996], e[5996] = 0, (c | 0) == 1 || (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0, (c | 0) == 1))
                                break t;
                              c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 180 >> 2] = S + c;
                            }
                            if (e[5996] = 0, S = ii(203, e[r + 332 >> 2]) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (xc(S, o, c, r + 180 | 0, r + 8 | 0, e[r + 324 >> 2], e[r + 200 >> 2], ye[r + 207 | 0], r + 16 | 0, r + 12 | 0, ke))
                              break r;
                            if (e[5996] = 0, ii(205, r + 332 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    S = ye[r + 207 | 0];
                    r: {
                      if (!((S & 128) >>> 7 | 0 ? e[r + 200 >> 2] : S & 127) || (S = e[r + 12 >> 2], (S - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = S + 4, e[S >> 2] = e[r + 8 >> 2];
                    }
                    if (e[g >> 2] = Zu(c, e[r + 180 >> 2], y, o), e[g + 4 >> 2] = vs, ma(r + 196 | 0, r + 16 | 0, e[r + 12 >> 2], y), e[5996] = 0, o = On(202, r + 332 | 0, r + 328 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                      o && (e[y >> 2] = e[y >> 2] | 2), o = e[r + 332 >> 2], qi(h), qi(r + 196 | 0), Yr = r + 336 | 0;
                      break e;
                    }
                  }
                  o = Vr() | 0, qi(h), qi(r + 196 | 0), Ki(o | 0), ri();
                }
                return o | 0;
              }
              function gg(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0;
                r = Yr - 336 | 0, Yr = r, e[r + 328 >> 2] = c, e[r + 332 >> 2] = o, o = Gu(e[h + 4 >> 2]), ke = Dc(e[h + 28 >> 2], r + 208 | 0), gf(r + 196 | 0, e[h + 28 >> 2], r + 324 | 0), h = r + 184 | 0, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((c | 0) != 1) {
                        for (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 180 >> 2] = c, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0; ; ) {
                          n: {
                            if (e[5996] = 0, S = On(202, r + 332 | 0, r + 328 | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (S)
                              break r;
                            if (S = ye[h + 11 | 0], S = (S & 128) >>> 7 | 0 ? e[h + 4 >> 2] : S & 127, e[r + 180 >> 2] == (S + c | 0)) {
                              if (e[5996] = 0, di(172, h | 0, S << 1), c = e[5996], e[5996] = 0, (c | 0) == 1 || (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0, (c | 0) == 1))
                                break t;
                              c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 180 >> 2] = S + c;
                            }
                            if (e[5996] = 0, S = ii(203, e[r + 332 >> 2]) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (xc(S, o, c, r + 180 | 0, r + 8 | 0, e[r + 324 >> 2], e[r + 200 >> 2], ye[r + 207 | 0], r + 16 | 0, r + 12 | 0, ke))
                              break r;
                            if (e[5996] = 0, ii(205, r + 332 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    S = ye[r + 207 | 0];
                    r: {
                      if (!((S & 128) >>> 7 | 0 ? e[r + 200 >> 2] : S & 127) || (S = e[r + 12 >> 2], (S - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = S + 4, e[S >> 2] = e[r + 8 >> 2];
                    }
                    if (e[g >> 2] = od(c, e[r + 180 >> 2], y, o), ma(r + 196 | 0, r + 16 | 0, e[r + 12 >> 2], y), e[5996] = 0, o = On(202, r + 332 | 0, r + 328 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                      o && (e[y >> 2] = e[y >> 2] | 2), o = e[r + 332 >> 2], qi(h), qi(r + 196 | 0), Yr = r + 336 | 0;
                      break e;
                    }
                  }
                  o = Vr() | 0, qi(h), qi(r + 196 | 0), Ki(o | 0), ri();
                }
                return o | 0;
              }
              function pg(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0;
                r = Yr - 336 | 0, Yr = r, e[r + 328 >> 2] = c, e[r + 332 >> 2] = o, o = Gu(e[h + 4 >> 2]), ke = Dc(e[h + 28 >> 2], r + 208 | 0), gf(r + 196 | 0, e[h + 28 >> 2], r + 324 | 0), h = r + 184 | 0, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((c | 0) != 1) {
                        for (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 180 >> 2] = c, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0; ; ) {
                          n: {
                            if (e[5996] = 0, S = On(202, r + 332 | 0, r + 328 | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (S)
                              break r;
                            if (S = ye[h + 11 | 0], S = (S & 128) >>> 7 | 0 ? e[h + 4 >> 2] : S & 127, e[r + 180 >> 2] == (S + c | 0)) {
                              if (e[5996] = 0, di(172, h | 0, S << 1), c = e[5996], e[5996] = 0, (c | 0) == 1 || (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0, (c | 0) == 1))
                                break t;
                              c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 180 >> 2] = S + c;
                            }
                            if (e[5996] = 0, S = ii(203, e[r + 332 >> 2]) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (xc(S, o, c, r + 180 | 0, r + 8 | 0, e[r + 324 >> 2], e[r + 200 >> 2], ye[r + 207 | 0], r + 16 | 0, r + 12 | 0, ke))
                              break r;
                            if (e[5996] = 0, ii(205, r + 332 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    S = ye[r + 207 | 0];
                    r: {
                      if (!((S & 128) >>> 7 | 0 ? e[r + 200 >> 2] : S & 127) || (S = e[r + 12 >> 2], (S - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = S + 4, e[S >> 2] = e[r + 8 >> 2];
                    }
                    if (Vs[g >> 1] = xh(c, e[r + 180 >> 2], y, o), ma(r + 196 | 0, r + 16 | 0, e[r + 12 >> 2], y), e[5996] = 0, o = On(202, r + 332 | 0, r + 328 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                      o && (e[y >> 2] = e[y >> 2] | 2), o = e[r + 332 >> 2], qi(h), qi(r + 196 | 0), Yr = r + 336 | 0;
                      break e;
                    }
                  }
                  o = Vr() | 0, qi(h), qi(r + 196 | 0), Ki(o | 0), ri();
                }
                return o | 0;
              }
              function oh(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0;
                r = Yr - 336 | 0, Yr = r, e[r + 328 >> 2] = c, e[r + 332 >> 2] = o, o = Gu(e[h + 4 >> 2]), ke = Dc(e[h + 28 >> 2], r + 208 | 0), gf(r + 196 | 0, e[h + 28 >> 2], r + 324 | 0), h = r + 184 | 0, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((c | 0) != 1) {
                        for (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 180 >> 2] = c, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0; ; ) {
                          n: {
                            if (e[5996] = 0, S = On(202, r + 332 | 0, r + 328 | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (S)
                              break r;
                            if (S = ye[h + 11 | 0], S = (S & 128) >>> 7 | 0 ? e[h + 4 >> 2] : S & 127, e[r + 180 >> 2] == (S + c | 0)) {
                              if (e[5996] = 0, di(172, h | 0, S << 1), c = e[5996], e[5996] = 0, (c | 0) == 1 || (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0, (c | 0) == 1))
                                break t;
                              c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 180 >> 2] = S + c;
                            }
                            if (e[5996] = 0, S = ii(203, e[r + 332 >> 2]) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (xc(S, o, c, r + 180 | 0, r + 8 | 0, e[r + 324 >> 2], e[r + 200 >> 2], ye[r + 207 | 0], r + 16 | 0, r + 12 | 0, ke))
                              break r;
                            if (e[5996] = 0, ii(205, r + 332 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    S = ye[r + 207 | 0];
                    r: {
                      if (!((S & 128) >>> 7 | 0 ? e[r + 200 >> 2] : S & 127) || (S = e[r + 12 >> 2], (S - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = S + 4, e[S >> 2] = e[r + 8 >> 2];
                    }
                    if (e[g >> 2] = Pc(c, e[r + 180 >> 2], y, o), ma(r + 196 | 0, r + 16 | 0, e[r + 12 >> 2], y), e[5996] = 0, o = On(202, r + 332 | 0, r + 328 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                      o && (e[y >> 2] = e[y >> 2] | 2), o = e[r + 332 >> 2], qi(h), qi(r + 196 | 0), Yr = r + 336 | 0;
                      break e;
                    }
                  }
                  o = Vr() | 0, qi(h), qi(r + 196 | 0), Ki(o | 0), ri();
                }
                return o | 0;
              }
              function yg(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0;
                S = e[h + 4 >> 2], h = e[h + 28 >> 2], r = Yr - 224 | 0, Yr = r, e[r + 216 >> 2] = c, e[r + 220 >> 2] = o, o = Gu(S), pf(r + 200 | 0, h, r + 215 | 0), h = r + 188 | 0, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((c | 0) != 1) {
                        for (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 184 >> 2] = c, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0; ; ) {
                          n: {
                            if (e[5996] = 0, S = On(186, r + 220 | 0, r + 216 | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (S)
                              break r;
                            if (S = ye[h + 11 | 0], S = (S & 128) >>> 7 | 0 ? e[h + 4 >> 2] : S & 127, e[r + 184 >> 2] == (S + c | 0)) {
                              if (e[5996] = 0, di(172, h | 0, S << 1), c = e[5996], e[5996] = 0, (c | 0) == 1 || (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0, (c | 0) == 1))
                                break t;
                              c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 184 >> 2] = S + c;
                            }
                            if (e[5996] = 0, S = ii(187, e[r + 220 >> 2]) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (Tc(S, o, c, r + 184 | 0, r + 8 | 0, $[r + 215 | 0], e[r + 204 >> 2], ye[r + 211 | 0], r + 16 | 0, r + 12 | 0, 12416))
                              break r;
                            if (e[5996] = 0, ii(189, r + 220 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    S = ye[r + 211 | 0];
                    r: {
                      if (!((S & 128) >>> 7 | 0 ? e[r + 204 >> 2] : S & 127) || (S = e[r + 12 >> 2], (S - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = S + 4, e[S >> 2] = e[r + 8 >> 2];
                    }
                    if (e[g >> 2] = Mh(c, e[r + 184 >> 2], y, o), e[g + 4 >> 2] = vs, ma(r + 200 | 0, r + 16 | 0, e[r + 12 >> 2], y), e[5996] = 0, o = On(186, r + 220 | 0, r + 216 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                      o && (e[y >> 2] = e[y >> 2] | 2), o = e[r + 220 >> 2], qi(h), qi(r + 200 | 0), Yr = r + 224 | 0;
                      break e;
                    }
                  }
                  o = Vr() | 0, qi(h), qi(r + 200 | 0), Ki(o | 0), ri();
                }
                return o | 0;
              }
              function mg(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0;
                S = e[h + 4 >> 2], h = e[h + 28 >> 2], r = Yr - 224 | 0, Yr = r, e[r + 216 >> 2] = c, e[r + 220 >> 2] = o, o = Gu(S), pf(r + 200 | 0, h, r + 215 | 0), h = r + 188 | 0, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((c | 0) != 1) {
                        for (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 184 >> 2] = c, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0; ; ) {
                          n: {
                            if (e[5996] = 0, S = On(186, r + 220 | 0, r + 216 | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (S)
                              break r;
                            if (S = ye[h + 11 | 0], S = (S & 128) >>> 7 | 0 ? e[h + 4 >> 2] : S & 127, e[r + 184 >> 2] == (S + c | 0)) {
                              if (e[5996] = 0, di(172, h | 0, S << 1), c = e[5996], e[5996] = 0, (c | 0) == 1 || (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0, (c | 0) == 1))
                                break t;
                              c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 184 >> 2] = S + c;
                            }
                            if (e[5996] = 0, S = ii(187, e[r + 220 >> 2]) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (Tc(S, o, c, r + 184 | 0, r + 8 | 0, $[r + 215 | 0], e[r + 204 >> 2], ye[r + 211 | 0], r + 16 | 0, r + 12 | 0, 12416))
                              break r;
                            if (e[5996] = 0, ii(189, r + 220 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    S = ye[r + 211 | 0];
                    r: {
                      if (!((S & 128) >>> 7 | 0 ? e[r + 204 >> 2] : S & 127) || (S = e[r + 12 >> 2], (S - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = S + 4, e[S >> 2] = e[r + 8 >> 2];
                    }
                    if (e[g >> 2] = Zu(c, e[r + 184 >> 2], y, o), e[g + 4 >> 2] = vs, ma(r + 200 | 0, r + 16 | 0, e[r + 12 >> 2], y), e[5996] = 0, o = On(186, r + 220 | 0, r + 216 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                      o && (e[y >> 2] = e[y >> 2] | 2), o = e[r + 220 >> 2], qi(h), qi(r + 200 | 0), Yr = r + 224 | 0;
                      break e;
                    }
                  }
                  o = Vr() | 0, qi(h), qi(r + 200 | 0), Ki(o | 0), ri();
                }
                return o | 0;
              }
              function of(r, o) {
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0;
                e: {
                  if (!r) {
                    r = jf(8, o);
                    break e;
                  }
                  if (!o) {
                    Sr(r), r = 0;
                    break e;
                  }
                  t: {
                    if (o >>> 0 > 4294967239)
                      break t;
                    G = o >>> 0 <= 8 ? 8 : o + 3 & -4, o = G + 8 | 0;
                    r: {
                      n: {
                        Ar = r - 4 | 0, g = Ar, y = e[g >> 2], c = y + g | 0, Fe = e[c >> 2], S = Fe + c | 0;
                        i: {
                          s: {
                            if (e[S - 4 >> 2] != (Fe | 0)) {
                              if (h = o + g | 0, h + 16 >>> 0 <= S >>> 0) {
                                y = e[c + 4 >> 2], e[y + 8 >> 2] = e[c + 8 >> 2], e[e[c + 8 >> 2] + 4 >> 2] = y, c = S - h | 0, e[h >> 2] = c, e[(h + (c & -4) | 0) - 4 >> 2] = c | 1, y = e[h >> 2] - 8 | 0;
                                a: {
                                  if (y >>> 0 <= 127) {
                                    c = (y >>> 3 | 0) - 1 | 0;
                                    break a;
                                  }
                                  if (S = Do(y), c = ((y >>> 29 - S ^ 4) - (S << 2) | 0) + 110 | 0, y >>> 0 <= 4095)
                                    break a;
                                  c = ((y >>> 30 - S ^ 2) - (S << 1) | 0) + 71 | 0, c = c >>> 0 >= 63 ? 63 : c;
                                }
                                y = c << 4, e[h + 4 >> 2] = y + 22944, y = y + 22952 | 0, e[h + 8 >> 2] = e[y >> 2], e[y >> 2] = h, e[e[h + 8 >> 2] + 4 >> 2] = h, y = e[5995], h = c & 31, (c & 63) >>> 0 >= 32 ? (c = 1 << h, S = 0) : (S = 1 << h, c = S - 1 & 1 >>> 32 - h), e[5994] = S | e[5994], e[5995] = c | y, e[g >> 2] = o;
                                break n;
                              }
                              if (h >>> 0 > S >>> 0)
                                break s;
                              o = e[c + 4 >> 2], e[o + 8 >> 2] = e[c + 8 >> 2], e[e[c + 8 >> 2] + 4 >> 2] = o, o = y + Fe | 0, e[g >> 2] = o;
                              break n;
                            }
                            if (y >>> 0 >= o + 16 >>> 0) {
                              e[g >> 2] = o, e[(g + (o & -4) | 0) - 4 >> 2] = o, h = o + g | 0, o = y - o | 0, e[h >> 2] = o, e[(h + (o & -4) | 0) - 4 >> 2] = o | 1, c = e[h >> 2] - 8 | 0;
                              a: {
                                if (c >>> 0 <= 127) {
                                  o = (c >>> 3 | 0) - 1 | 0;
                                  break a;
                                }
                                if (g = Do(c), o = ((c >>> 29 - g ^ 4) - (g << 2) | 0) + 110 | 0, c >>> 0 <= 4095)
                                  break a;
                                o = ((c >>> 30 - g ^ 2) - (g << 1) | 0) + 71 | 0, o = o >>> 0 >= 63 ? 63 : o;
                              }
                              c = o << 4, e[h + 4 >> 2] = c + 22944, c = c + 22952 | 0, e[h + 8 >> 2] = e[c >> 2], e[c >> 2] = h, e[e[h + 8 >> 2] + 4 >> 2] = h, c = e[5995], h = o & 31, (o & 63) >>> 0 >= 32 ? (o = 1 << h, y = 0) : (y = 1 << h, o = y - 1 & 1 >>> 32 - h), e[5994] = y | e[5994], e[5995] = o | c, h = 1;
                              break r;
                            }
                            if (h = 1, o >>> 0 <= y >>> 0)
                              break i;
                          }
                          h = 0;
                        }
                        break r;
                      }
                      e[(g + (o & -4) | 0) - 4 >> 2] = o, h = 1;
                    }
                    if (h)
                      break e;
                    if (o = jf(8, G), !o)
                      break t;
                    ke = e[Ar >> 2] - 8 | 0, _s(o, r, G >>> 0 < ke >>> 0 ? G : ke), Sr(r), ke = o;
                  }
                  r = ke;
                }
                return r;
              }
              function Ig(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0;
                h = Yr - 160 | 0, Yr = h, e[h + 72 >> 2] = 8356, e[h + 16 >> 2] = 8336, G = h + 72 | 0, c = G, e[c + 20 >> 2] = 0, y = h + 20 | 0, e[c + 24 >> 2] = y, e[c + 12 >> 2] = 0, e[c + 4 >> 2] = 4098, e[c + 8 >> 2] = 6, e[c + 16 >> 2] = !y, Ya(c + 32 | 0, 0, 40), ku(c + 28 | 0), e[h + 72 >> 2] = 8316, e[h + 16 >> 2] = 8296, e[h + 144 >> 2] = 0, e[h + 148 >> 2] = -1, e[y >> 2] = 7896, ku(y + 4 | 0), e[y + 24 >> 2] = 0, e[y + 28 >> 2] = 0, e[y + 16 >> 2] = 0, e[y + 20 >> 2] = 0, e[y + 8 >> 2] = 0, e[y + 12 >> 2] = 0, e[y >> 2] = 7960, e[h + 60 >> 2] = 0, e[h + 64 >> 2] = 0, e[h + 52 >> 2] = 0, e[h + 56 >> 2] = 0, e[h + 68 >> 2] = 16, c = e[e[h + 16 >> 2] - 12 >> 2], e[5996] = 0, S = kl(129) | 0, g = e[5996], e[5996] = 0;
                e: {
                  t: {
                    if ((g | 0) == 1)
                      break t;
                    g = c + (h + 16 | 0) | 0, c = e[g + 28 >> 2], e[h + 12 >> 2] = c, e[c + 4 >> 2] = e[c + 4 >> 2] + 1, e[5996] = 0, as(130, h + 156 | 0, g | 0, S | 0), c = e[5996], e[5996] = 0;
                    r: {
                      if ((c | 0) == 1)
                        break r;
                      if (c = e[h + 156 >> 2], ke = e[c + 4 >> 2] - 1 | 0, e[c + 4 >> 2] = ke, (ke | 0) == -1 && _n[e[e[c >> 2] + 8 >> 2]](c), c = e[g + 24 >> 2], c) {
                        if (g = e[e[c >> 2] + 8 >> 2], e[5996] = 0, di(g | 0, c | 0, S | 0), g = e[5996], e[5996] = 0, (g | 0) == 1)
                          break r;
                        g = e[c + 4 >> 2], e[h + 152 >> 2] = g, e[g + 4 >> 2] = e[g + 4 >> 2] + 1, $o(c + 4 | 0, S), c = e[h + 152 >> 2], S = e[c + 4 >> 2] - 1 | 0, e[c + 4 >> 2] = S, (S | 0) == -1 && _n[e[e[c >> 2] + 8 >> 2]](c);
                      }
                      if (c = e[h + 12 >> 2], S = e[c + 4 >> 2] - 1 | 0, e[c + 4 >> 2] = S, (S | 0) == -1 && _n[e[e[c >> 2] + 8 >> 2]](c), o = e[o >> 2], e[5996] = 0, o = On(131, h + 16 | 0, o | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1 || (e[5996] = 0, di(132, r | 0, y | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                        break t;
                      e[o >> 2] = 8296, e[h + 72 >> 2] = 8316, e[y >> 2] = 7960, $[o + 47 | 0] < 0 && Sr(e[h + 52 >> 2]), Hc(y), A4(G), Yr = h + 160 | 0;
                      return;
                    }
                    r = Vr() | 0, o = e[h + 12 >> 2], y = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = y, (y | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o);
                    break e;
                  }
                  r = Vr() | 0;
                }
                yl(h + 16 | 0), Ki(r | 0), ri();
              }
              function af(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0;
                S = e[h + 4 >> 2], h = e[h + 28 >> 2], r = Yr - 224 | 0, Yr = r, e[r + 216 >> 2] = c, e[r + 220 >> 2] = o, o = Gu(S), pf(r + 200 | 0, h, r + 215 | 0), h = r + 188 | 0, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((c | 0) != 1) {
                        for (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 184 >> 2] = c, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0; ; ) {
                          n: {
                            if (e[5996] = 0, S = On(186, r + 220 | 0, r + 216 | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (S)
                              break r;
                            if (S = ye[h + 11 | 0], S = (S & 128) >>> 7 | 0 ? e[h + 4 >> 2] : S & 127, e[r + 184 >> 2] == (S + c | 0)) {
                              if (e[5996] = 0, di(172, h | 0, S << 1), c = e[5996], e[5996] = 0, (c | 0) == 1 || (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0, (c | 0) == 1))
                                break t;
                              c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 184 >> 2] = S + c;
                            }
                            if (e[5996] = 0, S = ii(187, e[r + 220 >> 2]) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (Tc(S, o, c, r + 184 | 0, r + 8 | 0, $[r + 215 | 0], e[r + 204 >> 2], ye[r + 211 | 0], r + 16 | 0, r + 12 | 0, 12416))
                              break r;
                            if (e[5996] = 0, ii(189, r + 220 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    S = ye[r + 211 | 0];
                    r: {
                      if (!((S & 128) >>> 7 | 0 ? e[r + 204 >> 2] : S & 127) || (S = e[r + 12 >> 2], (S - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = S + 4, e[S >> 2] = e[r + 8 >> 2];
                    }
                    if (e[g >> 2] = Pc(c, e[r + 184 >> 2], y, o), ma(r + 200 | 0, r + 16 | 0, e[r + 12 >> 2], y), e[5996] = 0, o = On(186, r + 220 | 0, r + 216 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                      o && (e[y >> 2] = e[y >> 2] | 2), o = e[r + 220 >> 2], qi(h), qi(r + 200 | 0), Yr = r + 224 | 0;
                      break e;
                    }
                  }
                  o = Vr() | 0, qi(h), qi(r + 200 | 0), Ki(o | 0), ri();
                }
                return o | 0;
              }
              function Ll(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0;
                S = e[h + 4 >> 2], h = e[h + 28 >> 2], r = Yr - 224 | 0, Yr = r, e[r + 216 >> 2] = c, e[r + 220 >> 2] = o, o = Gu(S), pf(r + 200 | 0, h, r + 215 | 0), h = r + 188 | 0, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((c | 0) != 1) {
                        for (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 184 >> 2] = c, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0; ; ) {
                          n: {
                            if (e[5996] = 0, S = On(186, r + 220 | 0, r + 216 | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (S)
                              break r;
                            if (S = ye[h + 11 | 0], S = (S & 128) >>> 7 | 0 ? e[h + 4 >> 2] : S & 127, e[r + 184 >> 2] == (S + c | 0)) {
                              if (e[5996] = 0, di(172, h | 0, S << 1), c = e[5996], e[5996] = 0, (c | 0) == 1 || (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0, (c | 0) == 1))
                                break t;
                              c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 184 >> 2] = S + c;
                            }
                            if (e[5996] = 0, S = ii(187, e[r + 220 >> 2]) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (Tc(S, o, c, r + 184 | 0, r + 8 | 0, $[r + 215 | 0], e[r + 204 >> 2], ye[r + 211 | 0], r + 16 | 0, r + 12 | 0, 12416))
                              break r;
                            if (e[5996] = 0, ii(189, r + 220 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    S = ye[r + 211 | 0];
                    r: {
                      if (!((S & 128) >>> 7 | 0 ? e[r + 204 >> 2] : S & 127) || (S = e[r + 12 >> 2], (S - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = S + 4, e[S >> 2] = e[r + 8 >> 2];
                    }
                    if (e[g >> 2] = od(c, e[r + 184 >> 2], y, o), ma(r + 200 | 0, r + 16 | 0, e[r + 12 >> 2], y), e[5996] = 0, o = On(186, r + 220 | 0, r + 216 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                      o && (e[y >> 2] = e[y >> 2] | 2), o = e[r + 220 >> 2], qi(h), qi(r + 200 | 0), Yr = r + 224 | 0;
                      break e;
                    }
                  }
                  o = Vr() | 0, qi(h), qi(r + 200 | 0), Ki(o | 0), ri();
                }
                return o | 0;
              }
              function wg(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0;
                S = e[h + 4 >> 2], h = e[h + 28 >> 2], r = Yr - 224 | 0, Yr = r, e[r + 216 >> 2] = c, e[r + 220 >> 2] = o, o = Gu(S), pf(r + 200 | 0, h, r + 215 | 0), h = r + 188 | 0, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((c | 0) != 1) {
                        for (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 184 >> 2] = c, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0; ; ) {
                          n: {
                            if (e[5996] = 0, S = On(186, r + 220 | 0, r + 216 | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (S)
                              break r;
                            if (S = ye[h + 11 | 0], S = (S & 128) >>> 7 | 0 ? e[h + 4 >> 2] : S & 127, e[r + 184 >> 2] == (S + c | 0)) {
                              if (e[5996] = 0, di(172, h | 0, S << 1), c = e[5996], e[5996] = 0, (c | 0) == 1 || (c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? (e[h + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, h | 0, c | 0), c = e[5996], e[5996] = 0, (c | 0) == 1))
                                break t;
                              c = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 184 >> 2] = S + c;
                            }
                            if (e[5996] = 0, S = ii(187, e[r + 220 >> 2]) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                              break n;
                            if (Tc(S, o, c, r + 184 | 0, r + 8 | 0, $[r + 215 | 0], e[r + 204 >> 2], ye[r + 211 | 0], r + 16 | 0, r + 12 | 0, 12416))
                              break r;
                            if (e[5996] = 0, ii(189, r + 220 | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    S = ye[r + 211 | 0];
                    r: {
                      if (!((S & 128) >>> 7 | 0 ? e[r + 204 >> 2] : S & 127) || (S = e[r + 12 >> 2], (S - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = S + 4, e[S >> 2] = e[r + 8 >> 2];
                    }
                    if (Vs[g >> 1] = xh(c, e[r + 184 >> 2], y, o), ma(r + 200 | 0, r + 16 | 0, e[r + 12 >> 2], y), e[5996] = 0, o = On(186, r + 220 | 0, r + 216 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                      o && (e[y >> 2] = e[y >> 2] | 2), o = e[r + 220 >> 2], qi(h), qi(r + 200 | 0), Yr = r + 224 | 0;
                      break e;
                    }
                  }
                  o = Vr() | 0, qi(h), qi(r + 200 | 0), Ki(o | 0), ri();
                }
                return o | 0;
              }
              function Mu(r, o, c, h, y, g, S, G) {
                var ke = 0, Fe = 0, Ar = 0;
                if (ke = Yr - 16 | 0, Yr = ke, e[ke + 8 >> 2] = c, e[ke + 12 >> 2] = o, o = e[h + 28 >> 2], e[ke + 4 >> 2] = o, e[o + 4 >> 2] = e[o + 4 >> 2] + 1, o = 0, e[5996] = 0, Fe = ii(197, e[ke + 4 >> 2]) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                  c = e[ke + 4 >> 2], Ar = e[c + 4 >> 2] - 1 | 0, e[c + 4 >> 2] = Ar, (Ar | 0) == -1 && _n[e[e[c >> 2] + 8 >> 2]](c), e[y >> 2] = 0;
                  e: {
                    for (; ; ) {
                      if (o | (S | 0) == (G | 0))
                        break e;
                      t: {
                        if (Pu(ke + 12 | 0, ke + 8 | 0))
                          break t;
                        r: {
                          if ((_n[e[e[Fe >> 2] + 52 >> 2]](Fe, e[S >> 2], 0) | 0) == 37) {
                            if ((S + 4 | 0) == (G | 0))
                              break t;
                            o = _n[e[e[Fe >> 2] + 52 >> 2]](Fe, e[S + 4 >> 2], 0) | 0;
                            n: {
                              if (!((o | 0) == 69 | (o & 255) == 48)) {
                                c = 0, Ar = 1;
                                break n;
                              }
                              if ((S + 8 | 0) == (G | 0))
                                break t;
                              c = o, o = _n[e[e[Fe >> 2] + 52 >> 2]](Fe, e[S + 8 >> 2], 0) | 0, Ar = 2;
                            }
                            e[ke + 12 >> 2] = _n[e[e[r >> 2] + 36 >> 2]](r, e[ke + 12 >> 2], e[ke + 8 >> 2], h, y, g, o, c), S = ((Ar << 2) + S | 0) + 4 | 0;
                            break r;
                          }
                          if (_n[e[e[Fe >> 2] + 12 >> 2]](Fe, 1, e[S >> 2]) | 0) {
                            for (; ; ) {
                              n: {
                                if (S = S + 4 | 0, (G | 0) == (S | 0)) {
                                  S = G;
                                  break n;
                                }
                                if (_n[e[e[Fe >> 2] + 12 >> 2]](Fe, 1, e[S >> 2]) | 0)
                                  continue;
                              }
                              break;
                            }
                            for (; ; ) {
                              if (Ar = ke + 12 | 0, Pu(Ar, ke + 8 | 0))
                                break r;
                              o = e[ke + 12 >> 2], c = e[o + 12 >> 2];
                              n: {
                                if ((c | 0) == e[o + 16 >> 2]) {
                                  o = _n[e[e[o >> 2] + 36 >> 2]](o) | 0;
                                  break n;
                                }
                                o = e[c >> 2];
                              }
                              if (!(_n[e[e[Fe >> 2] + 12 >> 2]](Fe, 1, o) | 0))
                                break r;
                              Bl(Ar);
                            }
                          }
                          o = e[ke + 12 >> 2], c = e[o + 12 >> 2];
                          n: {
                            if ((c | 0) == e[o + 16 >> 2]) {
                              o = _n[e[e[o >> 2] + 36 >> 2]](o) | 0;
                              break n;
                            }
                            o = e[c >> 2];
                          }
                          if ((_n[e[e[Fe >> 2] + 28 >> 2]](Fe, o) | 0) == (_n[e[e[Fe >> 2] + 28 >> 2]](Fe, e[S >> 2]) | 0)) {
                            S = S + 4 | 0, Bl(ke + 12 | 0);
                            break r;
                          }
                          e[y >> 2] = 4;
                        }
                        o = e[y >> 2];
                        continue;
                      }
                      break;
                    }
                    e[y >> 2] = 4;
                  }
                  return Pu(ke + 12 | 0, ke + 8 | 0) && (e[y >> 2] = e[y >> 2] | 2), Yr = ke + 16 | 0, e[ke + 12 >> 2];
                }
                c = Vr() | 0, r = e[ke + 4 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
              }
              function bg(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = +y;
                var g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0;
                hr = o, g = Yr - 208 | 0, Yr = g, e[g + 200 >> 2] = 37, e[g + 204 >> 2] = 0, o = g + 200 | 0, G = If(o | 1, 5575, e[c + 4 >> 2]), S = g + 160 | 0, e[g + 156 >> 2] = S, r = mo();
                e: {
                  if (G) {
                    ke = e[c + 8 >> 2], Fi[g + 40 >> 3] = y, e[g + 32 >> 2] = ke, S = Zo(S, 30, r, o, g + 32 | 0);
                    break e;
                  }
                  Fi[g + 48 >> 3] = y, S = Zo(g + 160 | 0, 30, r, g + 200 | 0, g + 48 | 0);
                }
                e[g + 80 >> 2] = 184, ke = g + 148 | 0, e[ke >> 2] = 0, e[ke + 4 >> 2] = e[g + 80 >> 2], o = g + 160 | 0, r = o;
                e: {
                  t: {
                    r: {
                      n: {
                        if ((S | 0) >= 30) {
                          r = mo();
                          i: {
                            if (G) {
                              S = e[c + 8 >> 2], Fi[g + 8 >> 3] = y, e[g >> 2] = S, S = fu(g + 156 | 0, r, g + 200 | 0, g);
                              break i;
                            }
                            Fi[g + 16 >> 3] = y, S = fu(g + 156 | 0, r, g + 200 | 0, g + 16 | 0);
                          }
                          if ((S | 0) == -1) {
                            if (e[5996] = 0, Ri(185), r = e[5996], e[5996] = 0, (r | 0) == 1)
                              break r;
                            break n;
                          }
                          r = e[g + 156 >> 2], Yo(ke, r);
                        }
                        Ar = r + S | 0, Tr = Ka(r, Ar, e[c + 4 >> 2]), e[g + 68 >> 2] = 184, G = g + 72 | 0, e[G >> 2] = 0, e[G + 4 >> 2] = e[g + 68 >> 2];
                        i: {
                          s: {
                            if ((g + 160 | 0) == (r | 0)) {
                              S = g + 80 | 0;
                              break s;
                            }
                            if (S = ia(S << 1), !S) {
                              if (e[5996] = 0, Ri(185), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                break n;
                              r = Vr() | 0;
                              break i;
                            }
                            Yo(G, S), o = r;
                          }
                          r = g + 60 | 0, Fe = e[c + 28 >> 2], e[r >> 2] = Fe, e[Fe + 4 >> 2] = e[Fe + 4 >> 2] + 1, e[5996] = 0, $a(212, o | 0, Tr | 0, Ar | 0, S | 0, g + 68 | 0, g - -64 | 0, r | 0), o = e[5996], e[5996] = 0;
                          s: {
                            if ((o | 0) != 1) {
                              if (r = e[r >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), e[5996] = 0, r = Fa(213, hr | 0, S | 0, e[g + 68 >> 2], e[g + 64 >> 2], c | 0, h | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                break s;
                              Js(G), Js(ke), Yr = g + 208 | 0;
                              break e;
                            }
                            r = Vr() | 0, o = e[g + 60 >> 2], c = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = c, (c | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o);
                            break i;
                          }
                          r = Vr() | 0;
                        }
                        Js(G);
                        break t;
                      }
                      ri();
                    }
                    r = Vr() | 0;
                  }
                  Js(ke), Ki(r | 0), ri();
                }
                return r | 0;
              }
              function Hl(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = +y;
                var g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0;
                hr = o, g = Yr - 368 | 0, Yr = g, e[g + 360 >> 2] = 37, e[g + 364 >> 2] = 0, o = g + 360 | 0, G = If(o | 1, 5575, e[c + 4 >> 2]), S = g + 320 | 0, e[g + 316 >> 2] = S, r = mo();
                e: {
                  if (G) {
                    ke = e[c + 8 >> 2], Fi[g + 40 >> 3] = y, e[g + 32 >> 2] = ke, S = Zo(S, 30, r, o, g + 32 | 0);
                    break e;
                  }
                  Fi[g + 48 >> 3] = y, S = Zo(g + 320 | 0, 30, r, g + 360 | 0, g + 48 | 0);
                }
                e[g + 80 >> 2] = 184, ke = g + 308 | 0, e[ke >> 2] = 0, e[ke + 4 >> 2] = e[g + 80 >> 2], o = g + 320 | 0, r = o;
                e: {
                  t: {
                    r: {
                      n: {
                        if ((S | 0) >= 30) {
                          r = mo();
                          i: {
                            if (G) {
                              S = e[c + 8 >> 2], Fi[g + 8 >> 3] = y, e[g >> 2] = S, S = fu(g + 316 | 0, r, g + 360 | 0, g);
                              break i;
                            }
                            Fi[g + 16 >> 3] = y, S = fu(g + 316 | 0, r, g + 360 | 0, g + 16 | 0);
                          }
                          if ((S | 0) == -1) {
                            if (e[5996] = 0, Ri(185), r = e[5996], e[5996] = 0, (r | 0) == 1)
                              break r;
                            break n;
                          }
                          r = e[g + 316 >> 2], Yo(ke, r);
                        }
                        Ar = r + S | 0, Tr = Ka(r, Ar, e[c + 4 >> 2]), e[g + 68 >> 2] = 184, G = g + 72 | 0, e[G >> 2] = 0, e[G + 4 >> 2] = e[g + 68 >> 2];
                        i: {
                          s: {
                            if ((g + 320 | 0) == (r | 0)) {
                              S = g + 80 | 0;
                              break s;
                            }
                            if (S = ia(S << 3), !S) {
                              if (e[5996] = 0, Ri(185), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                break n;
                              r = Vr() | 0;
                              break i;
                            }
                            Yo(G, S), o = r;
                          }
                          r = g + 60 | 0, Fe = e[c + 28 >> 2], e[r >> 2] = Fe, e[Fe + 4 >> 2] = e[Fe + 4 >> 2] + 1, e[5996] = 0, $a(218, o | 0, Tr | 0, Ar | 0, S | 0, g + 68 | 0, g - -64 | 0, r | 0), o = e[5996], e[5996] = 0;
                          s: {
                            if ((o | 0) != 1) {
                              if (r = e[r >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), e[5996] = 0, r = Fa(219, hr | 0, S | 0, e[g + 68 >> 2], e[g + 64 >> 2], c | 0, h | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                break s;
                              Js(G), Js(ke), Yr = g + 368 | 0;
                              break e;
                            }
                            r = Vr() | 0, o = e[g + 60 >> 2], c = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = c, (c | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o);
                            break i;
                          }
                          r = Vr() | 0;
                        }
                        Js(G);
                        break t;
                      }
                      ri();
                    }
                    r = Vr() | 0;
                  }
                  Js(ke), Ki(r | 0), ri();
                }
                return r | 0;
              }
              function uf(r, o, c, h, y, g, S, G) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, G = G | 0;
                var ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0;
                for (ln = Yr - 16 | 0, Yr = ln, o = c; ; ) {
                  e: {
                    if ((o | 0) == (h | 0)) {
                      o = h;
                      break e;
                    }
                    if (!e[o >> 2])
                      break e;
                    o = o + 4 | 0;
                    continue;
                  }
                  break;
                }
                for (e[G >> 2] = g, e[y >> 2] = c; ; ) {
                  e: {
                    t: {
                      if (!((c | 0) == (h | 0) | (g | 0) == (S | 0))) {
                        ei = 1, ci = Yr - 16 | 0, Yr = ci, gi = xu(ci + 12 | 0, e[r + 8 >> 2]), ke = g, Fe = S - ke | 0, Tr = 0, Rn = Yr - 16 | 0, Yr = Rn, Ar = e[y >> 2], Mn = o - c >> 2;
                        r: {
                          if (!Ar | !Mn)
                            break r;
                          for (Fe = ke ? Fe : 0; ; ) {
                            if (hr = cd(Fe >>> 0 < 4 ? Rn + 12 | 0 : ke, e[Ar >> 2]), (hr | 0) == -1) {
                              Tr = -1;
                              break r;
                            }
                            if (ke) {
                              if (Fe >>> 0 <= 3) {
                                if (Fe >>> 0 < hr >>> 0)
                                  break r;
                                _s(ke, Rn + 12 | 0, hr);
                              }
                              Fe = Fe - hr | 0, ke = ke + hr | 0;
                            } else
                              ke = 0;
                            if (!e[Ar >> 2]) {
                              Ar = 0;
                              break r;
                            }
                            if (Tr = Tr + hr | 0, Ar = Ar + 4 | 0, Mn = Mn - 1 | 0, !Mn)
                              break;
                          }
                        }
                        ke && (e[y >> 2] = Ar), Yr = Rn + 16 | 0, ke = e[gi >> 2], ke && (e[6178] = (ke | 0) == -1 ? 24816 : ke), Yr = ci + 16 | 0;
                        r: {
                          n: {
                            i: {
                              s:
                                switch (Tr + 1 | 0) {
                                  case 0:
                                    for (e[G >> 2] = g; ; ) {
                                      a: {
                                        if (e[y >> 2] == (c | 0) || (o = ml(g, e[c >> 2], e[r + 8 >> 2]), (o | 0) == -1))
                                          break a;
                                        g = o + e[G >> 2] | 0, e[G >> 2] = g, c = c + 4 | 0;
                                        continue;
                                      }
                                      break;
                                    }
                                    e[y >> 2] = c;
                                    break i;
                                  case 1:
                                    break t;
                                  default:
                                    break s;
                                }
                              if (g = Tr + e[G >> 2] | 0, e[G >> 2] = g, (g | 0) == (S | 0))
                                break r;
                              if ((o | 0) == (h | 0)) {
                                c = e[y >> 2], o = h;
                                continue;
                              }
                              if (o = ml(ln + 12 | 0, 0, e[r + 8 >> 2]), (o | 0) != -1)
                                break n;
                            }
                            ei = 2;
                            break t;
                          }
                          if (c = ln + 12 | 0, S - e[G >> 2] >>> 0 < o >>> 0)
                            break t;
                          for (; ; ) {
                            if (o) {
                              g = ye[c | 0], ke = e[G >> 2], e[G >> 2] = ke + 1, $[ke | 0] = g, o = o - 1 | 0, c = c + 1 | 0;
                              continue;
                            }
                            break;
                          }
                          for (c = e[y >> 2] + 4 | 0, e[y >> 2] = c, o = c; ; ) {
                            if ((o | 0) == (h | 0)) {
                              o = h;
                              break e;
                            }
                            if (!e[o >> 2])
                              break e;
                            o = o + 4 | 0;
                          }
                        }
                        c = e[y >> 2];
                      }
                      ei = (c | 0) != (h | 0);
                    }
                    return Yr = ln + 16 | 0, ei | 0;
                  }
                  g = e[G >> 2];
                }
              }
              function ah(r, o, c, h, y, g, S) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0;
                var G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0;
                Ar = Yr - 16 | 0, Yr = Ar, Tr = a4(e[S >> 2]), S = c4(e[S >> 2]), _n[e[e[S >> 2] + 20 >> 2]](Ar + 4 | 0, S);
                e: {
                  Fe = ye[Ar + 15 | 0];
                  t: {
                    if (!((Fe & 128) >>> 7 | 0 ? e[Ar + 8 >> 2] : Fe & 127)) {
                      if (e[5996] = 0, Qs(208, Tr | 0, r | 0, c | 0, h | 0), S = e[5996], e[5996] = 0, (S | 0) == 1)
                        break t;
                      S = (c - r << 2) + h | 0, e[g >> 2] = S;
                      break e;
                    }
                    e[g >> 2] = h;
                    r: {
                      n:
                        switch (Fe = r, ke = ye[Fe | 0], ke - 43 | 0) {
                          case 0:
                          case 2:
                            break n;
                          default:
                            break r;
                        }
                      if (e[5996] = 0, Fe = On(216, Tr | 0, ke << 24 >> 24) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                        break t;
                      ke = e[g >> 2], e[g >> 2] = ke + 4, e[ke >> 2] = Fe, Fe = r + 1 | 0;
                    }
                    if (!(ye[Fe | 0] != 48 | (c - Fe | 0) < 2 | (ye[Fe + 1 | 0] | 32) != 120)) {
                      if (e[5996] = 0, ke = On(216, Tr | 0, 48) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1 || (G = e[g >> 2], e[g >> 2] = G + 4, e[G >> 2] = ke, ke = $[Fe + 1 | 0], e[5996] = 0, ke = On(216, Tr | 0, ke | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1))
                        break t;
                      G = e[g >> 2], e[g >> 2] = G + 4, e[G >> 2] = ke, Fe = Fe + 2 | 0;
                    }
                    if (iu(Fe, c), e[5996] = 0, Rn = ii(206, S | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                      break t;
                    for (ke = 0, S = Fe; ; ) {
                      if (c >>> 0 <= S >>> 0) {
                        D2((Fe - r << 2) + h | 0, e[g >> 2]), S = e[g >> 2];
                        break e;
                      }
                      if (G = Ar + 4 | 0, hr = (ye[G + 11 | 0] & 128) >>> 7 | 0, !ye[(hr ? e[G >> 2] : G) + ke | 0] | $[(hr ? e[G >> 2] : G) + ke | 0] != (ln | 0) || (G = e[g >> 2], e[g >> 2] = G + 4, e[G >> 2] = Rn, ln = 0, hr = ke, ke = ye[Ar + 15 | 0], ke = hr + (hr >>> 0 < ((ke & 128) >>> 7 | 0 ? e[Ar + 8 >> 2] : ke & 127) - 1 >>> 0) | 0), G = $[S | 0], e[5996] = 0, G = On(216, Tr | 0, G | 0) | 0, hr = e[5996], e[5996] = 0, (hr | 0) != 1) {
                        hr = e[g >> 2], e[g >> 2] = hr + 4, e[hr >> 2] = G, S = S + 1 | 0, ln = ln + 1 | 0;
                        continue;
                      }
                      break;
                    }
                  }
                  r = Vr() | 0, qi(Ar + 4 | 0), Ki(r | 0), ri();
                }
                e[y >> 2] = (o | 0) == (c | 0) ? S : (o - r << 2) + h | 0, qi(Ar + 4 | 0), Yr = Ar + 16 | 0;
              }
              function Gl(r, o, c, h, y, g, S) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0;
                var G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0;
                Ar = Yr - 16 | 0, Yr = Ar, Tr = s4(e[S >> 2]), S = u4(e[S >> 2]), _n[e[e[S >> 2] + 20 >> 2]](Ar + 4 | 0, S);
                e: {
                  Fe = ye[Ar + 15 | 0];
                  t: {
                    if (!((Fe & 128) >>> 7 | 0 ? e[Ar + 8 >> 2] : Fe & 127)) {
                      if (e[5996] = 0, Qs(195, Tr | 0, r | 0, c | 0, h | 0), S = e[5996], e[5996] = 0, (S | 0) == 1)
                        break t;
                      S = (c - r | 0) + h | 0, e[g >> 2] = S;
                      break e;
                    }
                    e[g >> 2] = h;
                    r: {
                      n:
                        switch (Fe = r, ke = ye[Fe | 0], ke - 43 | 0) {
                          case 0:
                          case 2:
                            break n;
                          default:
                            break r;
                        }
                      if (e[5996] = 0, Fe = On(171, Tr | 0, ke << 24 >> 24) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                        break t;
                      ke = e[g >> 2], e[g >> 2] = ke + 1, $[ke | 0] = Fe, Fe = r + 1 | 0;
                    }
                    if (!(ye[Fe | 0] != 48 | (c - Fe | 0) < 2 | (ye[Fe + 1 | 0] | 32) != 120)) {
                      if (e[5996] = 0, ke = On(171, Tr | 0, 48) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1 || (G = e[g >> 2], e[g >> 2] = G + 1, $[G | 0] = ke, ke = $[Fe + 1 | 0], e[5996] = 0, ke = On(171, Tr | 0, ke | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1))
                        break t;
                      G = e[g >> 2], e[g >> 2] = G + 1, $[G | 0] = ke, Fe = Fe + 2 | 0;
                    }
                    if (iu(Fe, c), e[5996] = 0, Rn = ii(193, S | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                      break t;
                    for (ke = 0, S = Fe; ; ) {
                      if (c >>> 0 <= S >>> 0) {
                        iu((Fe - r | 0) + h | 0, e[g >> 2]), S = e[g >> 2];
                        break e;
                      }
                      if (G = Ar + 4 | 0, hr = (ye[G + 11 | 0] & 128) >>> 7 | 0, !ye[(hr ? e[G >> 2] : G) + ke | 0] | $[(hr ? e[G >> 2] : G) + ke | 0] != (ln | 0) || (G = e[g >> 2], e[g >> 2] = G + 1, $[G | 0] = Rn, ln = 0, hr = ke, ke = ye[Ar + 15 | 0], ke = hr + (hr >>> 0 < ((ke & 128) >>> 7 | 0 ? e[Ar + 8 >> 2] : ke & 127) - 1 >>> 0) | 0), G = $[S | 0], e[5996] = 0, G = On(171, Tr | 0, G | 0) | 0, hr = e[5996], e[5996] = 0, (hr | 0) != 1) {
                        hr = e[g >> 2], e[g >> 2] = hr + 1, $[hr | 0] = G, S = S + 1 | 0, ln = ln + 1 | 0;
                        continue;
                      }
                      break;
                    }
                  }
                  r = Vr() | 0, qi(Ar + 4 | 0), Ki(r | 0), ri();
                }
                e[y >> 2] = (o | 0) == (c | 0) ? S : (o - r | 0) + h | 0, qi(Ar + 4 | 0), Yr = Ar + 16 | 0;
              }
              function jl(r, o, c, h, y, g, S, G) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, G = G | 0;
                var ke = 0, Fe = 0, Ar = 0;
                r = Yr - 16 | 0, Yr = r, e[r + 12 >> 2] = c, e[r + 8 >> 2] = g, e[r + 12 >> 2] = c, e[r + 8 >> 2] = g;
                e: {
                  t: {
                    r: {
                      for (; ; ) {
                        if (c = e[r + 12 >> 2], !(c >>> 0 >= h >>> 0 | g >>> 0 >= S >>> 0)) {
                          ke = $[c | 0], Fe = ke & 255;
                          n: {
                            if ((ke | 0) >= 0) {
                              Vs[g >> 1] = Fe, o = c + 1 | 0;
                              break n;
                            }
                            if (o = 2, ke >>> 0 < 4294967234)
                              break t;
                            if (ke >>> 0 <= 4294967263) {
                              if ((h - c | 0) < 2)
                                break r;
                              if (ke = ye[c + 1 | 0], (ke & 192) != 128)
                                break e;
                              Vs[g >> 1] = ke & 63 | Fe << 6 & 1984, o = c + 2 | 0;
                              break n;
                            }
                            if (ke >>> 0 <= 4294967279) {
                              if ((h - c | 0) < 3)
                                break r;
                              Ar = ye[c + 2 | 0], ke = ye[c + 1 | 0];
                              i: {
                                s: {
                                  if ((Fe | 0) != 237) {
                                    if ((Fe | 0) != 224)
                                      break s;
                                    if ((ke & 224) == 160)
                                      break i;
                                    break e;
                                  }
                                  if ((ke & 224) == 128)
                                    break i;
                                  break e;
                                }
                                if ((ke & 192) != 128)
                                  break e;
                              }
                              if ((Ar & 192) != 128)
                                break e;
                              Vs[g >> 1] = Ar & 63 | ((ke & 63) << 6 | Fe << 12), o = c + 3 | 0;
                              break n;
                            }
                            if (ke >>> 0 > 4294967284)
                              break t;
                            if (o = 1, (h - c | 0) < 4)
                              break e;
                            Ar = ye[c + 3 | 0], ke = ye[c + 2 | 0], c = ye[c + 1 | 0];
                            i: {
                              s:
                                switch (Fe - 240 | 0) {
                                  case 0:
                                    if ((c + 112 & 255) >>> 0 >= 48)
                                      break t;
                                    break i;
                                  case 4:
                                    if ((c & 240) != 128)
                                      break t;
                                    break i;
                                  default:
                                    break s;
                                }
                              if ((c & 192) != 128)
                                break t;
                            }
                            if ((ke & 192) != 128 | (Ar & 192) != 128)
                              break t;
                            if ((S - g | 0) < 4 || (o = 2, Fe = Fe & 7, (c << 12 & 196608 | Fe << 18) >>> 0 > 1114111))
                              break e;
                            o = c << 2, Vs[g >> 1] = (ke >>> 4 & 3 | (o & 192 | Fe << 8 | o & 60)) + 16320 | 55296, e[r + 8 >> 2] = g + 2, Vs[g + 2 >> 1] = ke << 6 & 960 | Ar & 63 | 56320, o = e[r + 12 >> 2] + 4 | 0;
                          }
                          e[r + 12 >> 2] = o, g = e[r + 8 >> 2] + 2 | 0, e[r + 8 >> 2] = g;
                          continue;
                        }
                        break;
                      }
                      o = c >>> 0 < h >>> 0;
                      break e;
                    }
                    o = 1;
                    break e;
                  }
                  o = 2;
                }
                return e[y >> 2] = e[r + 12 >> 2], e[G >> 2] = e[r + 8 >> 2], Yr = r + 16 | 0, o | 0;
              }
              function Eg(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0;
                S = Yr - 32 | 0, Yr = S, e[S + 28 >> 2] = o;
                e: {
                  t: {
                    if (!($[h + 4 | 0] & 1)) {
                      e[S >> 2] = -1, o = _n[e[e[r >> 2] + 16 >> 2]](r, o, c, h, y, S) | 0;
                      r:
                        switch (e[S >> 2]) {
                          case 1:
                            $[g | 0] = 1;
                            break e;
                          case 0:
                            break t;
                          default:
                            break r;
                        }
                      $[g | 0] = 1, e[y >> 2] = 4;
                      break e;
                    }
                    r = e[h + 28 >> 2], e[S >> 2] = r, e[r + 4 >> 2] = e[r + 4 >> 2] + 1, e[5996] = 0, G = ii(197, e[S >> 2]) | 0, r = e[5996], e[5996] = 0;
                    r: {
                      n: {
                        i: {
                          s: {
                            if ((r | 0) != 1) {
                              if (r = e[S >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), r = e[h + 28 >> 2], e[S >> 2] = r, e[r + 4 >> 2] = e[r + 4 >> 2] + 1, e[5996] = 0, o = ii(198, e[S >> 2]) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                break s;
                              if (r = e[S >> 2], h = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = h, (h | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), e[5996] = 0, di(199, S | 0, o | 0), r = e[5996], e[5996] = 0, (r | 0) == 1) {
                                o = Vr() | 0;
                                break r;
                              }
                              if (e[5996] = 0, di(200, S | 12, o | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                break i;
                              if (e[5996] = 0, h = S + 24 | 0, r = Lf(201, S + 28 | 0, c | 0, S | 0, h | 0, G | 0, y | 0, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                break n;
                              for ($[g | 0] = (r | 0) == (S | 0), o = e[S + 28 >> 2]; h = qi(h - 12 | 0), (S | 0) != (h | 0); )
                                ;
                              break e;
                            }
                            o = Vr() | 0, r = e[S >> 2], c = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = c, (c | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r);
                            break r;
                          }
                          o = Vr() | 0, r = e[S >> 2], c = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = c, (c | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r);
                          break r;
                        }
                        o = Vr() | 0, qi(S);
                        break r;
                      }
                      for (o = Vr() | 0; h = qi(h - 12 | 0), (S | 0) != (h | 0); )
                        ;
                    }
                    Ki(o | 0), ri();
                  }
                  $[g | 0] = 0;
                }
                return Yr = S + 32 | 0, o | 0;
              }
              function Bg(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0;
                S = Yr - 32 | 0, Yr = S, e[S + 28 >> 2] = o;
                e: {
                  t: {
                    if (!($[h + 4 | 0] & 1)) {
                      e[S >> 2] = -1, o = _n[e[e[r >> 2] + 16 >> 2]](r, o, c, h, y, S) | 0;
                      r:
                        switch (e[S >> 2]) {
                          case 1:
                            $[g | 0] = 1;
                            break e;
                          case 0:
                            break t;
                          default:
                            break r;
                        }
                      $[g | 0] = 1, e[y >> 2] = 4;
                      break e;
                    }
                    r = e[h + 28 >> 2], e[S >> 2] = r, e[r + 4 >> 2] = e[r + 4 >> 2] + 1, e[5996] = 0, G = ii(170, e[S >> 2]) | 0, r = e[5996], e[5996] = 0;
                    r: {
                      n: {
                        i: {
                          s: {
                            if ((r | 0) != 1) {
                              if (r = e[S >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), r = e[h + 28 >> 2], e[S >> 2] = r, e[r + 4 >> 2] = e[r + 4 >> 2] + 1, e[5996] = 0, o = ii(180, e[S >> 2]) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                break s;
                              if (r = e[S >> 2], h = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = h, (h | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), e[5996] = 0, di(181, S | 0, o | 0), r = e[5996], e[5996] = 0, (r | 0) == 1) {
                                o = Vr() | 0;
                                break r;
                              }
                              if (e[5996] = 0, di(182, S | 12, o | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                break i;
                              if (e[5996] = 0, h = S + 24 | 0, r = Lf(183, S + 28 | 0, c | 0, S | 0, h | 0, G | 0, y | 0, 1) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                                break n;
                              for ($[g | 0] = (r | 0) == (S | 0), o = e[S + 28 >> 2]; h = qi(h - 12 | 0), (S | 0) != (h | 0); )
                                ;
                              break e;
                            }
                            o = Vr() | 0, r = e[S >> 2], c = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = c, (c | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r);
                            break r;
                          }
                          o = Vr() | 0, r = e[S >> 2], c = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = c, (c | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r);
                          break r;
                        }
                        o = Vr() | 0, qi(S);
                        break r;
                      }
                      for (o = Vr() | 0; h = qi(h - 12 | 0), (S | 0) != (h | 0); )
                        ;
                    }
                    Ki(o | 0), ri();
                  }
                  $[g | 0] = 0;
                }
                return Yr = S + 32 | 0, o | 0;
              }
              function vg(r, o, c, h) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0;
                var y = 0, g = 0, S = 0, G = 0, ke = 0;
                y = Yr - 32 | 0, Yr = y;
                e: {
                  t: {
                    r: {
                      if ((c | 0) <= 0)
                        break r;
                      for (; ; ) {
                        if (G = o + S | 0, ye[G | 0] != 41) {
                          if (S = S + 1 | 0, (c | 0) != (S | 0))
                            continue;
                          break r;
                        }
                        break;
                      }
                      if (S)
                        break t;
                    }
                    $[r + 16 | 0] = 0, $[r | 0] = 0;
                    break e;
                  }
                  if (S >>> 0 < 2147483632) {
                    t: {
                      if (S >>> 0 <= 10) {
                        $[y + 31 | 0] = S, c = y + 20 | 0;
                        break t;
                      }
                      g = (S | 15) + 1 | 0, c = xs(g), e[y + 28 >> 2] = g | -2147483648, e[y + 20 >> 2] = c, e[y + 24 >> 2] = S;
                    }
                    if (ke = S & 7, ke)
                      for (g = 0; $[c | 0] = ye[o | 0], c = c + 1 | 0, o = o + 1 | 0, g = g + 1 | 0, (ke | 0) != (g | 0); )
                        ;
                    if (S >>> 0 >= 8)
                      for (; $[c | 0] = ye[o | 0], $[c + 1 | 0] = ye[o + 1 | 0], $[c + 2 | 0] = ye[o + 2 | 0], $[c + 3 | 0] = ye[o + 3 | 0], $[c + 4 | 0] = ye[o + 4 | 0], $[c + 5 | 0] = ye[o + 5 | 0], $[c + 6 | 0] = ye[o + 6 | 0], $[c + 7 | 0] = ye[o + 7 | 0], c = c + 8 | 0, o = o + 8 | 0, (G | 0) != (o | 0); )
                        ;
                    $[c | 0] = 0, g = ye[y + 31 | 0], c = g << 24 >> 24, o = (c | 0) < 0;
                    t: {
                      r: {
                        n: {
                          g = o ? e[y + 24 >> 2] : g;
                          i: {
                            if (!g)
                              break i;
                            for (o = o ? e[y + 20 >> 2] : y + 20 | 0, G = g + o | 0; ; ) {
                              if ($[ye[o | 0] + 5584 | 0] < 0)
                                break i;
                              if (o = o + 1 | 0, (G | 0) == (o | 0))
                                break;
                            }
                            if (!(g & 1))
                              break n;
                          }
                          $[r + 16 | 0] = 0, $[r | 0] = 0;
                          break r;
                        }
                        if (e[5996] = 0, di(31, y + 8 | 0, y + 20 | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                          break t;
                        c = e[y + 12 >> 2], o = e[y + 8 >> 2];
                        n: {
                          if ((c - o | 0) == (h | 0)) {
                            h = e[y + 16 >> 2], $[r + 16 | 0] = 1, e[r + 12 >> 2] = S, e[r + 8 >> 2] = h, e[r + 4 >> 2] = c, e[r >> 2] = o;
                            break n;
                          }
                          if ($[r + 16 | 0] = 0, $[r | 0] = 0, !o)
                            break n;
                          Sr(o);
                        }
                        c = ye[y + 31 | 0];
                      }
                      if (c << 24 >> 24 >= 0)
                        break e;
                      Sr(e[y + 20 >> 2]);
                      break e;
                    }
                    r = Vr() | 0, $[y + 31 | 0] < 0 && Sr(e[y + 20 >> 2]), Ki(r | 0), ri();
                  }
                  ba(), ri();
                }
                Yr = y + 32 | 0;
              }
              function Cg(r, o, c, h, y, g, S) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0;
                var G = 0, ke = 0, Fe = 0, Ar = 0;
                if (r = Yr - 144 | 0, Yr = r, e[r + 136 >> 2] = c, e[r + 140 >> 2] = o, e[r + 20 >> 2] = 220, o = r + 24 | 0, e[o >> 2] = r + 32, ke = r + 20 | 0, e[o + 4 >> 2] = e[ke >> 2], Fe = r + 16 | 0, G = e[y + 28 >> 2], e[Fe >> 2] = G, e[G + 4 >> 2] = e[G + 4 >> 2] + 1, e[5996] = 0, G = ii(170, e[r + 16 >> 2]) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) != 1)
                  e: {
                    if ($[r + 15 | 0] = 0, y = e[y + 4 >> 2], e[5996] = 0, c = tf(221, r + 140 | 0, c | 0, h | 0, Fe | 0, y | 0, g | 0, r + 15 | 0, G | 0, o | 0, ke | 0, r + 132 | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                      break e;
                    t: {
                      r: {
                        if (!c)
                          break r;
                        n: {
                          if ((ye[S + 11 | 0] & 128) >>> 7 | 0) {
                            $[e[S >> 2]] = 0, e[S + 4 >> 2] = 0;
                            break n;
                          }
                          $[S | 0] = 0, $[S + 11 | 0] = 0;
                        }
                        if (ye[r + 15 | 0] && (e[5996] = 0, c = On(171, G | 0, 45) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1 || (e[5996] = 0, di(98, S | 0, c | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)))
                          break e;
                        if (e[5996] = 0, h = On(171, G | 0, 48) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                          break t;
                        for (y = e[r + 20 >> 2], G = y - 1 | 0, c = e[o >> 2], h = h & 255; ; ) {
                          if (!((h | 0) != ye[c | 0] | c >>> 0 >= G >>> 0)) {
                            c = c + 1 | 0;
                            continue;
                          }
                          break;
                        }
                        if (e[5996] = 0, Si(227, S | 0, c | 0, y | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1)
                          break r;
                        break e;
                      }
                      if (e[5996] = 0, c = On(186, r + 140 | 0, r + 136 | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                        break e;
                      return c && (e[g >> 2] = e[g >> 2] | 2), y = e[r + 140 >> 2], c = e[r + 16 >> 2], h = e[c + 4 >> 2] - 1 | 0, e[c + 4 >> 2] = h, (h | 0) == -1 && _n[e[e[c >> 2] + 8 >> 2]](c), Js(o), Yr = r + 144 | 0, y | 0;
                    }
                  }
                h = Vr() | 0, r = e[r + 16 >> 2], c = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = c, (c | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Js(o), Ki(h | 0), ri();
              }
              function kg(r, o, c, h, y, g, S) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0;
                var G = 0, ke = 0, Fe = 0, Ar = 0;
                if (r = Yr - 448 | 0, Yr = r, e[r + 440 >> 2] = c, e[r + 444 >> 2] = o, e[r + 20 >> 2] = 220, o = r + 24 | 0, e[o >> 2] = r + 32, ke = r + 20 | 0, e[o + 4 >> 2] = e[ke >> 2], Fe = r + 16 | 0, G = e[y + 28 >> 2], e[Fe >> 2] = G, e[G + 4 >> 2] = e[G + 4 >> 2] + 1, e[5996] = 0, G = ii(197, e[r + 16 >> 2]) | 0, Ar = e[5996], e[5996] = 0, (Ar | 0) != 1)
                  e: {
                    if ($[r + 15 | 0] = 0, y = e[y + 4 >> 2], e[5996] = 0, c = tf(228, r + 444 | 0, c | 0, h | 0, Fe | 0, y | 0, g | 0, r + 15 | 0, G | 0, o | 0, ke | 0, r + 432 | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                      break e;
                    t: {
                      r: {
                        if (!c)
                          break r;
                        n: {
                          if ((ye[S + 11 | 0] & 128) >>> 7 | 0) {
                            e[e[S >> 2] >> 2] = 0, e[S + 4 >> 2] = 0;
                            break n;
                          }
                          e[S >> 2] = 0, $[S + 11 | 0] = 0;
                        }
                        if (ye[r + 15 | 0] && (e[5996] = 0, c = On(216, G | 0, 45) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1 || (e[5996] = 0, di(232, S | 0, c | 0), c = e[5996], e[5996] = 0, (c | 0) == 1)))
                          break e;
                        if (e[5996] = 0, h = On(216, G | 0, 48) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                          break t;
                        for (y = e[r + 20 >> 2], G = y - 4 | 0, c = e[o >> 2]; ; ) {
                          if (!((h | 0) != e[c >> 2] | c >>> 0 >= G >>> 0)) {
                            c = c + 4 | 0;
                            continue;
                          }
                          break;
                        }
                        if (e[5996] = 0, Si(234, S | 0, c | 0, y | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1)
                          break r;
                        break e;
                      }
                      if (e[5996] = 0, c = On(202, r + 444 | 0, r + 440 | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                        break e;
                      return c && (e[g >> 2] = e[g >> 2] | 2), y = e[r + 444 >> 2], c = e[r + 16 >> 2], h = e[c + 4 >> 2] - 1 | 0, e[c + 4 >> 2] = h, (h | 0) == -1 && _n[e[e[c >> 2] + 8 >> 2]](c), Js(o), Yr = r + 448 | 0, y | 0;
                    }
                  }
                h = Vr() | 0, r = e[r + 16 >> 2], c = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = c, (c | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Js(o), Ki(h | 0), ri();
              }
              function Sg(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0;
                var g = 0, S = 0, G = 0;
                if (Va(r, e[o + 8 >> 2], y)) {
                  e[o + 28 >> 2] == 1 | e[o + 4 >> 2] != (c | 0) || (e[o + 28 >> 2] = h);
                  return;
                }
                e: {
                  if (Va(r, e[o >> 2], y)) {
                    if (!(e[o + 16 >> 2] != (c | 0) & e[o + 20 >> 2] != (c | 0))) {
                      if ((h | 0) != 1)
                        break e;
                      e[o + 32 >> 2] = 1;
                      return;
                    }
                    e[o + 32 >> 2] = h;
                    t: {
                      if (e[o + 44 >> 2] == 4)
                        break t;
                      g = r + 16 | 0, G = g + (e[r + 12 >> 2] << 3) | 0, h = 0;
                      r: {
                        n: {
                          for (; ; ) {
                            i: {
                              if (g >>> 0 >= G >>> 0 || (Vs[o + 52 >> 1] = 0, Dd(e[g >> 2], e[g + 4 >> 2], o, c, c, 1, y), ye[o + 54 | 0]))
                                break i;
                              s: {
                                if (!ye[o + 53 | 0])
                                  break s;
                                if (ye[o + 52 | 0]) {
                                  if (e[o + 24 >> 2] != 1 && (h = 1, S = 1, ye[r + 8 | 0] & 2))
                                    break s;
                                  e[o + 44 >> 2] = 3;
                                  return;
                                }
                                if (h = 1, !($[r + 8 | 0] & 1))
                                  break n;
                              }
                              g = g + 8 | 0;
                              continue;
                            }
                            break;
                          }
                          if (!h)
                            break r;
                        }
                        if (e[o + 44 >> 2] = 3, !S)
                          break t;
                        break e;
                      }
                      if (e[o + 44 >> 2] = 4, S)
                        break e;
                    }
                    if (e[o + 20 >> 2] = c, e[o + 40 >> 2] = e[o + 40 >> 2] + 1, e[o + 36 >> 2] != 1 | e[o + 24 >> 2] != 2)
                      break e;
                    $[o + 54 | 0] = 1;
                    return;
                  }
                  if (S = e[r + 12 >> 2], Il(e[r + 16 >> 2], e[r + 20 >> 2], o, c, h, y), g = r + 24 | 0, S = (r + 16 | 0) + (S << 3) | 0, g >>> 0 >= S >>> 0)
                    break e;
                  if (r = e[r + 8 >> 2], !(!(r & 2) & e[o + 36 >> 2] != 1)) {
                    for (; ; ) {
                      if (ye[o + 54 | 0])
                        break e;
                      if (Il(e[g >> 2], e[g + 4 >> 2], o, c, h, y), g = g + 8 | 0, !(S >>> 0 > g >>> 0))
                        break;
                    }
                    break e;
                  }
                  if (!(r & 1))
                    for (; ; ) {
                      if (ye[o + 54 | 0] | e[o + 36 >> 2] == 1)
                        break e;
                      if (Il(e[g >> 2], e[g + 4 >> 2], o, c, h, y), g = g + 8 | 0, !(S >>> 0 > g >>> 0))
                        break e;
                    }
                  for (; ; ) {
                    if (ye[o + 54 | 0] | e[o + 36 >> 2] == 1 & e[o + 24 >> 2] == 1)
                      break e;
                    if (Il(e[g >> 2], e[g + 4 >> 2], o, c, h, y), g = g + 8 | 0, !(S >>> 0 > g >>> 0))
                      break;
                  }
                }
              }
              function Vl(r, o, c, h, y, g, S, G) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, G = G | 0;
                var ke = 0;
                r = Yr - 16 | 0, Yr = r, e[r + 12 >> 2] = c, e[r + 8 >> 2] = g, e[r + 12 >> 2] = c, e[r + 8 >> 2] = g, c = e[r + 12 >> 2];
                e: {
                  for (; ; ) {
                    if (c >>> 0 >= h >>> 0) {
                      g = 0;
                      break e;
                    }
                    t: {
                      o = fa[c >> 1];
                      r: {
                        if (o >>> 0 <= 127) {
                          if (g = 1, c = e[r + 8 >> 2], (S - c | 0) <= 0)
                            break e;
                          e[r + 8 >> 2] = c + 1, $[c | 0] = o;
                          break r;
                        }
                        if (o >>> 0 <= 2047) {
                          if (c = e[r + 8 >> 2], (S - c | 0) < 2)
                            break t;
                          e[r + 8 >> 2] = c + 1, $[c | 0] = o >>> 6 | 192, c = e[r + 8 >> 2], e[r + 8 >> 2] = c + 1, $[c | 0] = o & 63 | 128;
                          break r;
                        }
                        if (o >>> 0 <= 55295) {
                          if (c = e[r + 8 >> 2], (S - c | 0) < 3)
                            break t;
                          e[r + 8 >> 2] = c + 1, $[c | 0] = o >>> 12 | 224, c = e[r + 8 >> 2], e[r + 8 >> 2] = c + 1, $[c | 0] = o >>> 6 & 63 | 128, c = e[r + 8 >> 2], e[r + 8 >> 2] = c + 1, $[c | 0] = o & 63 | 128;
                          break r;
                        }
                        n: {
                          i: {
                            if (o >>> 0 <= 56319) {
                              if (g = 1, (h - c | 0) < 4)
                                break e;
                              if (ke = fa[c + 2 >> 1], (ke & 64512) != 56320)
                                break i;
                              if ((S - e[r + 8 >> 2] | 0) < 4)
                                break e;
                              e[r + 12 >> 2] = c + 2, c = e[r + 8 >> 2], e[r + 8 >> 2] = c + 1, g = c, c = (o >>> 6 & 15) + 1 | 0, $[g | 0] = c >>> 2 | 240, g = e[r + 8 >> 2], e[r + 8 >> 2] = g + 1, $[g | 0] = c << 4 & 48 | o >>> 2 & 15 | 128, c = e[r + 8 >> 2], e[r + 8 >> 2] = c + 1, $[c | 0] = ke >>> 6 & 15 | o << 4 & 48 | 128, o = e[r + 8 >> 2], e[r + 8 >> 2] = o + 1, $[o | 0] = ke & 63 | 128;
                              break r;
                            }
                            if (o >>> 0 >= 57344)
                              break n;
                          }
                          g = 2;
                          break e;
                        }
                        if (c = e[r + 8 >> 2], (S - c | 0) < 3)
                          break t;
                        e[r + 8 >> 2] = c + 1, $[c | 0] = o >>> 12 | 224, c = e[r + 8 >> 2], e[r + 8 >> 2] = c + 1, $[c | 0] = o >>> 6 & 63 | 128, c = e[r + 8 >> 2], e[r + 8 >> 2] = c + 1, $[c | 0] = o & 63 | 128;
                      }
                      c = e[r + 12 >> 2] + 2 | 0, e[r + 12 >> 2] = c;
                      continue;
                    }
                    break;
                  }
                  g = 1;
                }
                return e[y >> 2] = e[r + 12 >> 2], e[G >> 2] = e[r + 8 >> 2], Yr = r + 16 | 0, g | 0;
              }
              function Ba(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0;
                if (c = e[r + 4 >> 2], h = e[r + 8 >> 2], c >>> 0 < h >>> 0) {
                  e[c >> 2] = e[o >> 2], e[c + 4 >> 2] = e[o + 4 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, y = e[o + 28 >> 2], e[c + 24 >> 2] = e[o + 24 >> 2], e[c + 28 >> 2] = y, y = e[o + 20 >> 2], e[c + 16 >> 2] = e[o + 16 >> 2], e[c + 20 >> 2] = y, y = e[o + 12 >> 2], e[c + 8 >> 2] = e[o + 8 >> 2], e[c + 12 >> 2] = y, e[r + 4 >> 2] = c + 32;
                  return;
                }
                e: {
                  if (G = e[r >> 2], g = c - G >> 5, y = g + 1 | 0, y >>> 0 < 134217728) {
                    if (h = h - G | 0, S = h >> 4, S = h >>> 0 >= 2147483616 ? 134217727 : y >>> 0 < S >>> 0 ? S : y, S) {
                      if (S >>> 0 >= 134217728)
                        break e;
                      y = xs(S << 5);
                    } else
                      y = 0;
                    if (h = y + (g << 5) | 0, e[h >> 2] = e[o >> 2], e[h + 4 >> 2] = e[o + 4 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, g = e[o + 28 >> 2], e[h + 24 >> 2] = e[o + 24 >> 2], e[h + 28 >> 2] = g, g = e[o + 20 >> 2], e[h + 16 >> 2] = e[o + 16 >> 2], e[h + 20 >> 2] = g, g = e[o + 12 >> 2], e[h + 8 >> 2] = e[o + 8 >> 2], e[h + 12 >> 2] = g, g = h + 32 | 0, (c | 0) != (G | 0))
                      for (; h = h - 32 | 0, c = c - 32 | 0, e[h >> 2] = e[c >> 2], e[h + 4 >> 2] = e[c + 4 >> 2], e[c >> 2] = 0, e[c + 4 >> 2] = 0, o = e[c + 28 >> 2], e[h + 24 >> 2] = e[c + 24 >> 2], e[h + 28 >> 2] = o, o = e[c + 20 >> 2], e[h + 16 >> 2] = e[c + 16 >> 2], e[h + 20 >> 2] = o, o = e[c + 12 >> 2], e[h + 8 >> 2] = e[c + 8 >> 2], e[h + 12 >> 2] = o, (c | 0) != (G | 0); )
                        ;
                    if (e[r + 8 >> 2] = y + (S << 5), o = e[r >> 2], e[r >> 2] = h, c = e[r + 4 >> 2], e[r + 4 >> 2] = g, (o | 0) != (c | 0))
                      for (; ; ) {
                        c = c - 32 | 0, r = e[c + 4 >> 2];
                        t: {
                          if (!r || (y = e[r + 4 >> 2], e[r + 4 >> 2] = y - 1, y))
                            break t;
                          _n[e[e[r >> 2] + 8 >> 2]](r), cs(r);
                        }
                        if ((o | 0) == (c | 0))
                          break;
                      }
                    o && Sr(o);
                    return;
                  }
                  Lo(), ri();
                }
                su(), ri();
              }
              function wu(r, o) {
                var c = 0, h = 0, y = 0, g = 0, S = 0;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            c = e[r + 4 >> 2];
                            a: {
                              if ((c | 0) != e[r + 104 >> 2]) {
                                e[r + 4 >> 2] = c + 1, c = ye[c | 0];
                                break a;
                              }
                              c = go(r);
                            }
                            switch (c - 43 | 0) {
                              case 0:
                              case 2:
                                break s;
                              default:
                                break i;
                            }
                          }
                          S = (c | 0) == 45, o = !o, c = e[r + 4 >> 2];
                          s: {
                            if ((c | 0) != e[r + 104 >> 2]) {
                              e[r + 4 >> 2] = c + 1, c = ye[c | 0];
                              break s;
                            }
                            c = go(r);
                          }
                          if (h = c - 58 | 0, o | h >>> 0 > 4294967285)
                            break n;
                          if (o = e[r + 116 >> 2], (o | 0) > 0 | (o | 0) >= 0)
                            break r;
                          break e;
                        }
                        h = c - 58 | 0;
                      }
                      if (h >>> 0 <= 4294967285) {
                        if (e[r + 116 >> 2] < 0)
                          break e;
                        break t;
                      }
                      n: {
                        if (c - 48 >>> 0 >= 10)
                          break n;
                        for (; ; ) {
                          y = (vi(y, 10) + c | 0) - 48 | 0, g = (y | 0) < 214748364, c = e[r + 4 >> 2];
                          i: {
                            if ((c | 0) != e[r + 104 >> 2]) {
                              e[r + 4 >> 2] = c + 1, c = ye[c | 0];
                              break i;
                            }
                            c = go(r);
                          }
                          if (o = c - 48 | 0, !(g & o >>> 0 <= 9))
                            break;
                        }
                        if (g = y >> 31, o >>> 0 >= 10)
                          break n;
                        for (; ; ) {
                          o = c, c = so(y, g, 10, 0), h = o + c | 0, o = vs, y = h - 48 | 0, h = (c >>> 0 > h >>> 0 ? o + 1 | 0 : o) - (h >>> 0 < 48) | 0, g = h, h = y >>> 0 < 2061584302 & (h | 0) <= 21474836 | (h | 0) < 21474836, c = e[r + 4 >> 2];
                          i: {
                            if ((c | 0) != e[r + 104 >> 2]) {
                              e[r + 4 >> 2] = c + 1, c = ye[c | 0];
                              break i;
                            }
                            c = go(r);
                          }
                          if (o = c - 48 | 0, !(h & o >>> 0 <= 9))
                            break;
                        }
                        if (o >>> 0 >= 10)
                          break n;
                        for (; ; ) {
                          o = e[r + 4 >> 2];
                          i: {
                            if ((o | 0) != e[r + 104 >> 2]) {
                              e[r + 4 >> 2] = o + 1, o = ye[o | 0];
                              break i;
                            }
                            o = go(r);
                          }
                          if (!(o - 48 >>> 0 < 10))
                            break;
                        }
                      }
                      return o = e[r + 116 >> 2], (o | 0) > 0 | (o | 0) >= 0 && (e[r + 4 >> 2] = e[r + 4 >> 2] - 1), vs = S ? 0 - (((y | 0) != 0) + g | 0) | 0 : g, S ? 0 - y | 0 : y;
                    }
                    e[r + 4 >> 2] = e[r + 4 >> 2] - 1;
                  }
                  e[r + 4 >> 2] = e[r + 4 >> 2] - 1;
                }
                return vs = -2147483648, 0;
              }
              function uh(r, o, c, h, y, g, S, G) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, G = G | 0;
                var ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0;
                r = Yr - 16 | 0, Yr = r, e[r + 12 >> 2] = c, e[r + 8 >> 2] = g, e[r + 12 >> 2] = c, e[r + 8 >> 2] = g;
                e: {
                  t: {
                    for (; ; ) {
                      if (o = e[r + 12 >> 2], !(h >>> 0 <= o >>> 0 | g >>> 0 >= S >>> 0)) {
                        ke = $[o | 0], c = ke & 255;
                        r: {
                          if ((ke | 0) >= 0) {
                            ke = 1;
                            break r;
                          }
                          if (Ar = 2, ke >>> 0 < 4294967234)
                            break e;
                          if (ke >>> 0 <= 4294967263) {
                            if ((h - o | 0) < 2)
                              break t;
                            if (ke = ye[o + 1 | 0], (ke & 192) != 128)
                              break e;
                            c = ke & 63 | c << 6 & 1984, ke = 2;
                            break r;
                          }
                          if (ke >>> 0 <= 4294967279) {
                            if ((h - o | 0) < 3)
                              break t;
                            Fe = ye[o + 2 | 0], ke = ye[o + 1 | 0];
                            n: {
                              i: {
                                if ((c | 0) != 237) {
                                  if ((c | 0) != 224)
                                    break i;
                                  if ((ke & 224) == 160)
                                    break n;
                                  break e;
                                }
                                if ((ke & 224) == 128)
                                  break n;
                                break e;
                              }
                              if ((ke & 192) != 128)
                                break e;
                            }
                            if ((Fe & 192) != 128)
                              break e;
                            c = Fe & 63 | (c << 12 & 61440 | (ke & 63) << 6), ke = 3;
                            break r;
                          }
                          if (ke >>> 0 > 4294967284)
                            break e;
                          if ((h - o | 0) < 4)
                            break t;
                          hr = ye[o + 3 | 0], Tr = ye[o + 2 | 0], Fe = ye[o + 1 | 0];
                          n: {
                            i:
                              switch (c - 240 | 0) {
                                case 0:
                                  if ((Fe + 112 & 255) >>> 0 < 48)
                                    break n;
                                  break e;
                                case 4:
                                  if ((Fe & 240) == 128)
                                    break n;
                                  break e;
                                default:
                                  break i;
                              }
                            if ((Fe & 192) != 128)
                              break e;
                          }
                          if ((Tr & 192) != 128 | (hr & 192) != 128 || (ke = 4, c = hr & 63 | (Tr << 6 & 4032 | (c << 18 & 1835008 | (Fe & 63) << 12)), c >>> 0 > 1114111))
                            break e;
                        }
                        e[g >> 2] = c, e[r + 12 >> 2] = o + ke, g = e[r + 8 >> 2] + 4 | 0, e[r + 8 >> 2] = g;
                        continue;
                      }
                      break;
                    }
                    Ar = o >>> 0 < h >>> 0;
                    break e;
                  }
                  Ar = 1;
                }
                return e[y >> 2] = e[r + 12 >> 2], e[G >> 2] = e[r + 8 >> 2], Yr = r + 16 | 0, Ar | 0;
              }
              function Tg(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0;
                var g = 0, S = 0, G = 0, ke = 0, Fe = 0;
                g = Yr - 32 | 0, Yr = g, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, e[r + 4 >> 2] = y, e[r >> 2] = o, e[r + 16 >> 2] = 0, e[r + 8 >> 2] = e[h >> 2], e[r + 12 >> 2] = e[h + 4 >> 2], e[r + 16 >> 2] = e[h + 8 >> 2], e[h + 8 >> 2] = 0, e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 32 >> 2] = e[c >> 2], e[r + 36 >> 2] = e[c + 4 >> 2], e[r + 40 >> 2] = e[c + 8 >> 2], e[c + 8 >> 2] = 0, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[5996] = 0, di(86, r + 44 | 0, r | 0), o = e[5996], e[5996] = 0;
                e: {
                  if ((o | 0) == 1 || (e[5996] = 0, di(87, r - -64 | 0, r | 0), o = e[5996], e[5996] = 0, (o | 0) == 1) || (c = 0, e[5996] = 0, o = ii(88, r | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1))
                    break e;
                  if (e[r + 80 >> 2] = o, o = e[r + 32 >> 2], y = e[r + 36 >> 2], (o | 0) == (y | 0))
                    h = 0;
                  else {
                    for (h = o; c = e[e[h >> 2] + 84 >> 2] + c | 0, h = h + 8 | 0, (y | 0) != (h | 0); )
                      ;
                    h = e[e[o >> 2] + 80 >> 2];
                  }
                  if (S = e[r + 4 >> 2], G = e[r >> 2], ke = e[r + 8 >> 2], Fe = e[r + 12 >> 2], e[5996] = 0, o = Fa(89, G | 0, h | 0, c | 0, S | 0, y - o >> 3, (Fe - ke | 0) / 12 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1 || (e[r + 84 >> 2] = o, e[5996] = 0, e[g + 28 >> 2] = r, as(90, g + 12 | 0, r | 0, g + 28 | 0), o = e[5996], e[5996] = 0, (o | 0) == 1))
                    break e;
                  return o = ye[g + 24 | 0], o && Je(e[g + 16 >> 2]), $[r + 88 | 0] = o ^ 1, Yr = g + 32 | 0, r | 0;
                }
                c = Vr() | 0, xo(r + 32 | 0), o = e[r + 20 >> 2], o && (e[r + 24 >> 2] = o, Sr(o)), Wo(r + 8 | 0), Ki(c | 0), ri();
              }
              function Wl(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0;
                S = Yr - 32 | 0, Yr = S, h = xs(104), e[h >> 2] = 7e3, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, y = e[c + 8 >> 2], e[c + 8 >> 2] = 0, g = e[c >> 2], G = e[c + 4 >> 2], e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[h + 16 >> 2] = 0, e[h + 20 >> 2] = 0, e[h + 12 >> 2] = o, e[h + 24 >> 2] = 0, e[h + 28 >> 2] = 0, e[h + 52 >> 2] = 0, ke = h + 44 | 0, o = ke, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[h + 40 >> 2] = y, e[h + 32 >> 2] = g, e[h + 36 >> 2] = G, e[5996] = 0, g = h + 12 | 0, di(86, h + 56 | 0, g | 0), o = e[5996], e[5996] = 0;
                e: {
                  if ((o | 0) == 1 || (e[5996] = 0, di(87, h + 76 | 0, g | 0), o = e[5996], e[5996] = 0, (o | 0) == 1) || (o = 0, e[5996] = 0, c = ii(88, g | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1))
                    break e;
                  if (e[h + 92 >> 2] = c, G = e[h + 48 >> 2], y = e[h + 44 >> 2], (G | 0) == (y | 0))
                    c = 0;
                  else {
                    for (c = y; o = e[e[c >> 2] + 84 >> 2] + o | 0, c = c + 8 | 0, (G | 0) != (c | 0); )
                      ;
                    c = e[e[y >> 2] + 80 >> 2];
                  }
                  if (Fe = e[h + 16 >> 2], Ar = e[h + 12 >> 2], hr = e[h + 20 >> 2], Tr = e[h + 24 >> 2], e[5996] = 0, o = Fa(89, Ar | 0, c | 0, o | 0, Fe | 0, G - y >> 3, (Tr - hr | 0) / 12 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1 || (e[h + 96 >> 2] = o, e[5996] = 0, e[S + 28 >> 2] = g, as(90, S + 12 | 0, g | 0, S + 28 | 0), o = e[5996], e[5996] = 0, (o | 0) == 1))
                    break e;
                  o = ye[S + 24 | 0], o && Je(e[S + 16 >> 2]), $[h + 100 | 0] = o ^ 1, e[r + 4 >> 2] = h, e[r >> 2] = g, Yr = S + 32 | 0;
                  return;
                }
                o = Vr() | 0, xo(ke), r = e[h + 32 >> 2], r && (e[h + 36 >> 2] = r, Sr(r)), Wo(h + 20 | 0), Sr(h), Ki(o | 0), ri();
              }
              function xg(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0;
                S = Yr - 32 | 0, Yr = S, G = 1;
                e: {
                  t: {
                    r: {
                      n:
                        switch (r | 0) {
                          case 3:
                            G = 24;
                            break r;
                          case 4:
                          case 5:
                            if (e[S + 24 >> 2] = 0, e[S + 28 >> 2] = 0, e[S + 16 >> 2] = 0, e[S + 20 >> 2] = 0, e[S + 8 >> 2] = 0, e[S + 12 >> 2] = 0, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[5996] = 0, r = zc(S, h, 0), o = e[5996], e[5996] = 0, (o | 0) == 1) {
                              if (G = Vr() | 0, Ps[S >> 2] < 29)
                                break e;
                              break t;
                            }
                            if (r = e[r >> 2], o = r >>> 0 < 29, G = (o ? r : r - 29 | 0) + 1 | 0, o)
                              break r;
                            Sr(e[S + 8 >> 2]);
                            break r;
                          case 6:
                          case 7:
                            G = 39;
                            break r;
                          case 8:
                          case 9:
                            G = 27;
                            break r;
                          case 25:
                            G = (vi(g, 34) | h >>> 0 > 16) + (g >>> 0 > 16 ? 4 : 3) | 0;
                            break r;
                          case 17:
                            G = c;
                            break r;
                          case 14:
                            G = !(uu(1239, 1) & (o ^ -1)) + c | 0;
                            break r;
                          case 11:
                          case 12:
                          case 16:
                          case 18:
                          case 19:
                            G = c + 1 | 0;
                            break r;
                          case 10:
                          case 20:
                            G = c + 2 | 0;
                            break r;
                          case 13:
                          case 21:
                          case 22:
                          case 23:
                            G = c + 3 | 0;
                            break r;
                          case 15:
                            G = c + 4 | 0;
                            break r;
                          case 24:
                            if (e[S + 24 >> 2] = 0, e[S + 28 >> 2] = 0, e[S + 16 >> 2] = 0, e[S + 20 >> 2] = 0, e[S + 8 >> 2] = 0, e[S + 12 >> 2] = 0, e[S >> 2] = 0, e[S + 4 >> 2] = 0, e[5996] = 0, r = zc(S, h, 0), o = e[5996], e[5996] = 0, (o | 0) == 1) {
                              if (G = Vr() | 0, Ps[S >> 2] >= 29)
                                break t;
                              break e;
                            }
                            if (r = e[r >> 2], o = r >>> 0 < 29, G = (c + y | 0) + (o ? r : r - 29 | 0) | 0, o)
                              break r;
                            Sr(e[S + 8 >> 2]);
                            break r;
                          default:
                            aa(2350, 1859, 280, 2003), ri();
                          case 0:
                          case 1:
                            break r;
                          case 2:
                            break n;
                        }
                      G = 34;
                    }
                    return Yr = S + 32 | 0, G | 0;
                  }
                  Sr(e[S + 8 >> 2]);
                }
                Ki(G | 0), ri();
              }
              function ch(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0;
                if (S = e[r + 8 >> 2], y = e[r + 4 >> 2], S - y >>> 0 >= o >>> 0) {
                  if (h = y, G = o & 7, G)
                    for (; $[h | 0] = ye[c | 0], h = h + 1 | 0, g = g + 1 | 0, (G | 0) != (g | 0); )
                      ;
                  for (o = o + y | 0; $[h | 0] = ye[c | 0], $[h + 1 | 0] = ye[c | 0], $[h + 2 | 0] = ye[c | 0], $[h + 3 | 0] = ye[c | 0], $[h + 4 | 0] = ye[c | 0], $[h + 5 | 0] = ye[c | 0], $[h + 6 | 0] = ye[c | 0], $[h + 7 | 0] = ye[c | 0], h = h + 8 | 0, (o | 0) != (h | 0); )
                    ;
                  e[r + 4 >> 2] = o;
                  return;
                }
                if (h = e[r >> 2], g = y - h | 0, ke = g + o | 0, (ke | 0) >= 0) {
                  if (S = S - h | 0, h = S << 1, ke = S >>> 0 >= 1073741823 ? 2147483647 : h >>> 0 > ke >>> 0 ? h : ke, ke && (Fe = xs(ke)), g = g + Fe | 0, h = g, S = o & 7, S)
                    for (; $[h | 0] = ye[c | 0], h = h + 1 | 0, G = G + 1 | 0, (S | 0) != (G | 0); )
                      ;
                  for (G = o + g | 0; $[h | 0] = ye[c | 0], $[h + 1 | 0] = ye[c | 0], $[h + 2 | 0] = ye[c | 0], $[h + 3 | 0] = ye[c | 0], $[h + 4 | 0] = ye[c | 0], $[h + 5 | 0] = ye[c | 0], $[h + 6 | 0] = ye[c | 0], $[h + 7 | 0] = ye[c | 0], h = h + 8 | 0, (G | 0) != (h | 0); )
                    ;
                  if (S = e[r >> 2], (S | 0) != (y | 0)) {
                    if (h = (S ^ -1) + y | 0, o = y - S & 3, o)
                      for (c = 0; g = g - 1 | 0, y = y - 1 | 0, $[g | 0] = ye[y | 0], c = c + 1 | 0, (o | 0) != (c | 0); )
                        ;
                    if (h >>> 0 >= 3)
                      for (; $[g - 1 | 0] = ye[y - 1 | 0], $[g - 2 | 0] = ye[y - 2 | 0], $[g - 3 | 0] = ye[y - 3 | 0], g = g - 4 | 0, y = y - 4 | 0, $[g | 0] = ye[y | 0], (y | 0) != (S | 0); )
                        ;
                    y = e[r >> 2];
                  }
                  e[r + 8 >> 2] = ke + Fe, e[r + 4 >> 2] = G, e[r >> 2] = g, y && Sr(y);
                  return;
                }
                Lo(), ri();
              }
              function zl(r, o, c, h, y) {
                var g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0;
                Tr = Yr - 16 | 0, Yr = Tr, S = ye[r | 0];
                e: {
                  if (!S) {
                    g = r;
                    break e;
                  }
                  g = r;
                  t: {
                    for (; ; ) {
                      if (ke = S << 24 >> 24, !((ke | 0) == 32 | ke - 9 >>> 0 < 5))
                        break t;
                      if (S = ye[g + 1 | 0], g = g + 1 | 0, !S)
                        break;
                    }
                    break e;
                  }
                  t:
                    switch (S = S & 255, S - 43 | 0) {
                      case 0:
                      case 2:
                        break t;
                      default:
                        break e;
                    }
                  Fe = (S | 0) == 45 ? -1 : 0, g = g + 1 | 0;
                }
                e: {
                  if (!((c | 16) != 16 | ye[g | 0] != 48)) {
                    if (Rn = 1, (ye[g + 1 | 0] & 223) == 88) {
                      g = g + 2 | 0, ke = 16;
                      break e;
                    }
                    g = g + 1 | 0, ke = c || 8;
                    break e;
                  }
                  ke = c || 10;
                }
                for (c = 0; ; ) {
                  e: {
                    S = -48, Ar = $[g | 0];
                    t: {
                      if ((Ar - 48 & 255) >>> 0 < 10 || (S = -87, (Ar - 97 & 255) >>> 0 < 26))
                        break t;
                      if (S = -55, (Ar - 65 & 255) >>> 0 > 25)
                        break e;
                    }
                    if (ln = S + Ar | 0, (ln | 0) >= (ke | 0))
                      break e;
                    oa(Tr, ke, 0, 0, 0, hr, G, 0, 0), S = 1;
                    t: {
                      if (e[Tr + 8 >> 2] | e[Tr + 12 >> 2] || (Mn = so(hr, G, ke, 0), Ar = vs, (Ar | 0) == -1 & (ln ^ -1) >>> 0 < Mn >>> 0))
                        break t;
                      G = Ar, hr = ln + Mn | 0, G = hr >>> 0 < ln >>> 0 ? G + 1 | 0 : G, Rn = 1, S = c;
                    }
                    g = g + 1 | 0, c = S;
                    continue;
                  }
                  break;
                }
                o && (e[o >> 2] = Rn ? g : r);
                e: {
                  t: {
                    r: {
                      if (c) {
                        e[5732] = 68, r = h & 1, Fe = r ? 0 : Fe, hr = h, G = y;
                        break r;
                      }
                      if ((y | 0) == (G | 0) & h >>> 0 > hr >>> 0 | y >>> 0 > G >>> 0)
                        break t;
                      r = h & 1;
                    }
                    if (!(r | Fe)) {
                      e[5732] = 68, r = h, h = r - 1 | 0, y = y - !r | 0;
                      break e;
                    }
                    if ((y | 0) == (G | 0) & h >>> 0 >= hr >>> 0 | y >>> 0 > G >>> 0)
                      break t;
                    e[5732] = 68;
                    break e;
                  }
                  r = Fe ^ hr, h = r - Fe | 0, o = Fe >> 31, y = (o ^ G) - ((r >>> 0 < Fe >>> 0) + o | 0) | 0;
                }
                return Yr = Tr + 16 | 0, vs = y, h;
              }
              function Rg(r, o, c, h, y, g, S, G, ke, Fe) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, G = G | 0, ke = ke | 0, Fe = Fe | 0;
                var Ar = 0;
                Ar = Yr - 16 | 0, Yr = Ar;
                e: {
                  if (r) {
                    r = u6(c);
                    t: {
                      if (o) {
                        o = Ar + 4 | 0, _n[e[e[r >> 2] + 44 >> 2]](o, r), c = e[Ar + 4 >> 2], $[h | 0] = c, $[h + 1 | 0] = c >>> 8, $[h + 2 | 0] = c >>> 16, $[h + 3 | 0] = c >>> 24, _n[e[e[r >> 2] + 32 >> 2]](o, r);
                        break t;
                      }
                      o = Ar + 4 | 0, _n[e[e[r >> 2] + 40 >> 2]](o, r), c = e[Ar + 4 >> 2], $[h | 0] = c, $[h + 1 | 0] = c >>> 8, $[h + 2 | 0] = c >>> 16, $[h + 3 | 0] = c >>> 24, _n[e[e[r >> 2] + 28 >> 2]](o, r);
                    }
                    ja(ke, o), qi(o), e[y >> 2] = _n[e[e[r >> 2] + 12 >> 2]](r), e[g >> 2] = _n[e[e[r >> 2] + 16 >> 2]](r), o = Ar + 4 | 0, _n[e[e[r >> 2] + 20 >> 2]](o, r), ra(S, o), qi(o), _n[e[e[r >> 2] + 24 >> 2]](o, r), ja(G, o), qi(o), r = _n[e[e[r >> 2] + 36 >> 2]](r) | 0;
                    break e;
                  }
                  r = c6(c);
                  t: {
                    if (o) {
                      o = Ar + 4 | 0, _n[e[e[r >> 2] + 44 >> 2]](o, r), c = e[Ar + 4 >> 2], $[h | 0] = c, $[h + 1 | 0] = c >>> 8, $[h + 2 | 0] = c >>> 16, $[h + 3 | 0] = c >>> 24, _n[e[e[r >> 2] + 32 >> 2]](o, r);
                      break t;
                    }
                    o = Ar + 4 | 0, _n[e[e[r >> 2] + 40 >> 2]](o, r), c = e[Ar + 4 >> 2], $[h | 0] = c, $[h + 1 | 0] = c >>> 8, $[h + 2 | 0] = c >>> 16, $[h + 3 | 0] = c >>> 24, _n[e[e[r >> 2] + 28 >> 2]](o, r);
                  }
                  ja(ke, o), qi(o), e[y >> 2] = _n[e[e[r >> 2] + 12 >> 2]](r), e[g >> 2] = _n[e[e[r >> 2] + 16 >> 2]](r), o = Ar + 4 | 0, _n[e[e[r >> 2] + 20 >> 2]](o, r), ra(S, o), qi(o), _n[e[e[r >> 2] + 24 >> 2]](o, r), ja(G, o), qi(o), r = _n[e[e[r >> 2] + 36 >> 2]](r) | 0;
                }
                e[Fe >> 2] = r, Yr = Ar + 16 | 0;
              }
              function _s(r, o, c) {
                var h = 0, y = 0, g = 0;
                if (c >>> 0 >= 512)
                  return Sl(r | 0, o | 0, c | 0), r;
                y = r + c | 0;
                e: {
                  if (!((r ^ o) & 3)) {
                    t: {
                      if (!(r & 3)) {
                        c = r;
                        break t;
                      }
                      if (!c) {
                        c = r;
                        break t;
                      }
                      for (c = r; ; ) {
                        if ($[c | 0] = ye[o | 0], o = o + 1 | 0, c = c + 1 | 0, !(c & 3))
                          break t;
                        if (!(c >>> 0 < y >>> 0))
                          break;
                      }
                    }
                    h = y & -4;
                    t: {
                      if (h >>> 0 < 64 || (g = h + -64 | 0, g >>> 0 < c >>> 0))
                        break t;
                      for (; e[c >> 2] = e[o >> 2], e[c + 4 >> 2] = e[o + 4 >> 2], e[c + 8 >> 2] = e[o + 8 >> 2], e[c + 12 >> 2] = e[o + 12 >> 2], e[c + 16 >> 2] = e[o + 16 >> 2], e[c + 20 >> 2] = e[o + 20 >> 2], e[c + 24 >> 2] = e[o + 24 >> 2], e[c + 28 >> 2] = e[o + 28 >> 2], e[c + 32 >> 2] = e[o + 32 >> 2], e[c + 36 >> 2] = e[o + 36 >> 2], e[c + 40 >> 2] = e[o + 40 >> 2], e[c + 44 >> 2] = e[o + 44 >> 2], e[c + 48 >> 2] = e[o + 48 >> 2], e[c + 52 >> 2] = e[o + 52 >> 2], e[c + 56 >> 2] = e[o + 56 >> 2], e[c + 60 >> 2] = e[o + 60 >> 2], o = o - -64 | 0, c = c - -64 | 0, g >>> 0 >= c >>> 0; )
                        ;
                    }
                    if (c >>> 0 >= h >>> 0)
                      break e;
                    for (; e[c >> 2] = e[o >> 2], o = o + 4 | 0, c = c + 4 | 0, h >>> 0 > c >>> 0; )
                      ;
                    break e;
                  }
                  if (y >>> 0 < 4) {
                    c = r;
                    break e;
                  }
                  if (h = y - 4 | 0, h >>> 0 < r >>> 0) {
                    c = r;
                    break e;
                  }
                  for (c = r; $[c | 0] = ye[o | 0], $[c + 1 | 0] = ye[o + 1 | 0], $[c + 2 | 0] = ye[o + 2 | 0], $[c + 3 | 0] = ye[o + 3 | 0], o = o + 4 | 0, c = c + 4 | 0, h >>> 0 >= c >>> 0; )
                    ;
                }
                if (c >>> 0 < y >>> 0)
                  for (; $[c | 0] = ye[o | 0], o = o + 1 | 0, c = c + 1 | 0, (y | 0) != (c | 0); )
                    ;
                return r;
              }
              function B4(r, o, c, h, y, g, S, G, ke, Fe) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, G = G | 0, ke = ke | 0, Fe = Fe | 0;
                var Ar = 0;
                Ar = Yr - 16 | 0, Yr = Ar;
                e: {
                  if (r) {
                    r = o6(c);
                    t: {
                      if (o) {
                        o = Ar + 4 | 0, _n[e[e[r >> 2] + 44 >> 2]](o, r), c = e[Ar + 4 >> 2], $[h | 0] = c, $[h + 1 | 0] = c >>> 8, $[h + 2 | 0] = c >>> 16, $[h + 3 | 0] = c >>> 24, _n[e[e[r >> 2] + 32 >> 2]](o, r);
                        break t;
                      }
                      o = Ar + 4 | 0, _n[e[e[r >> 2] + 40 >> 2]](o, r), c = e[Ar + 4 >> 2], $[h | 0] = c, $[h + 1 | 0] = c >>> 8, $[h + 2 | 0] = c >>> 16, $[h + 3 | 0] = c >>> 24, _n[e[e[r >> 2] + 28 >> 2]](o, r);
                    }
                    ra(ke, o), qi(o), $[y | 0] = _n[e[e[r >> 2] + 12 >> 2]](r), $[g | 0] = _n[e[e[r >> 2] + 16 >> 2]](r), o = Ar + 4 | 0, _n[e[e[r >> 2] + 20 >> 2]](o, r), ra(S, o), qi(o), _n[e[e[r >> 2] + 24 >> 2]](o, r), ra(G, o), qi(o), r = _n[e[e[r >> 2] + 36 >> 2]](r) | 0;
                    break e;
                  }
                  r = a6(c);
                  t: {
                    if (o) {
                      o = Ar + 4 | 0, _n[e[e[r >> 2] + 44 >> 2]](o, r), c = e[Ar + 4 >> 2], $[h | 0] = c, $[h + 1 | 0] = c >>> 8, $[h + 2 | 0] = c >>> 16, $[h + 3 | 0] = c >>> 24, _n[e[e[r >> 2] + 32 >> 2]](o, r);
                      break t;
                    }
                    o = Ar + 4 | 0, _n[e[e[r >> 2] + 40 >> 2]](o, r), c = e[Ar + 4 >> 2], $[h | 0] = c, $[h + 1 | 0] = c >>> 8, $[h + 2 | 0] = c >>> 16, $[h + 3 | 0] = c >>> 24, _n[e[e[r >> 2] + 28 >> 2]](o, r);
                  }
                  ra(ke, o), qi(o), $[y | 0] = _n[e[e[r >> 2] + 12 >> 2]](r), $[g | 0] = _n[e[e[r >> 2] + 16 >> 2]](r), o = Ar + 4 | 0, _n[e[e[r >> 2] + 20 >> 2]](o, r), ra(S, o), qi(o), _n[e[e[r >> 2] + 24 >> 2]](o, r), ra(G, o), qi(o), r = _n[e[e[r >> 2] + 36 >> 2]](r) | 0;
                }
                e[Fe >> 2] = r, Yr = Ar + 16 | 0;
              }
              function dc(r, o, c, h) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0;
                var y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0;
                y = Yr - 32 | 0, Yr = y, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, e[r + 4 >> 2] = h, e[r >> 2] = o, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, S = r + 32 | 0, o = S, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[r + 40 >> 2] = 0, e[o >> 2] = e[c >> 2], e[r + 36 >> 2] = e[c + 4 >> 2], e[r + 40 >> 2] = e[c + 8 >> 2], e[c + 8 >> 2] = 0, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[5996] = 0, di(86, r + 44 | 0, r | 0), o = e[5996], e[5996] = 0;
                e: {
                  if ((o | 0) == 1 || (e[5996] = 0, di(87, r - -64 | 0, r | 0), o = e[5996], e[5996] = 0, (o | 0) == 1) || (h = 0, e[5996] = 0, o = ii(88, r | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1))
                    break e;
                  if (e[r + 80 >> 2] = o, g = e[r + 36 >> 2], o = e[r + 32 >> 2], (g | 0) == (o | 0))
                    c = 0;
                  else {
                    for (c = o; h = e[e[c >> 2] + 84 >> 2] + h | 0, c = c + 8 | 0, (g | 0) != (c | 0); )
                      ;
                    c = e[e[o >> 2] + 80 >> 2];
                  }
                  if (G = e[r + 4 >> 2], ke = e[r >> 2], Fe = e[r + 8 >> 2], Ar = e[r + 12 >> 2], e[5996] = 0, o = Fa(89, ke | 0, c | 0, h | 0, G | 0, g - o >> 3, (Ar - Fe | 0) / 12 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1 || (e[r + 84 >> 2] = o, e[5996] = 0, e[y + 28 >> 2] = r, as(90, y + 12 | 0, r | 0, y + 28 | 0), o = e[5996], e[5996] = 0, (o | 0) == 1))
                    break e;
                  return o = ye[y + 24 | 0], o && Je(e[y + 16 >> 2]), $[r + 88 | 0] = o ^ 1, Yr = y + 32 | 0, r | 0;
                }
                c = Vr() | 0, xo(S), o = e[r + 20 >> 2], o && (e[r + 24 >> 2] = o, Sr(o)), Wo(r + 8 | 0), Ki(c | 0), ri();
              }
              function Dg(r, o, c, h) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0;
                var y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0;
                y = Yr - 32 | 0, Yr = y, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, e[r + 4 >> 2] = h, e[r >> 2] = o, e[r + 16 >> 2] = 0, e[r + 8 >> 2] = e[c >> 2], e[r + 12 >> 2] = e[c + 4 >> 2], e[r + 16 >> 2] = e[c + 8 >> 2], e[c + 8 >> 2] = 0, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 24 >> 2] = 0, e[5996] = 0, di(86, r + 44 | 0, r | 0), o = e[5996], e[5996] = 0;
                e: {
                  if ((o | 0) == 1 || (e[5996] = 0, di(87, r - -64 | 0, r | 0), o = e[5996], e[5996] = 0, (o | 0) == 1) || (h = 0, e[5996] = 0, o = ii(88, r | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1))
                    break e;
                  if (e[r + 80 >> 2] = o, g = e[r + 36 >> 2], o = e[r + 32 >> 2], (g | 0) == (o | 0))
                    c = 0;
                  else {
                    for (c = o; h = e[e[c >> 2] + 84 >> 2] + h | 0, c = c + 8 | 0, (g | 0) != (c | 0); )
                      ;
                    c = e[e[o >> 2] + 80 >> 2];
                  }
                  if (S = e[r + 4 >> 2], G = e[r >> 2], ke = e[r + 8 >> 2], Fe = e[r + 12 >> 2], e[5996] = 0, o = Fa(89, G | 0, c | 0, h | 0, S | 0, g - o >> 3, (Fe - ke | 0) / 12 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1 || (e[r + 84 >> 2] = o, e[5996] = 0, e[y + 28 >> 2] = r, as(90, y + 12 | 0, r | 0, y + 28 | 0), o = e[5996], e[5996] = 0, (o | 0) == 1))
                    break e;
                  return o = ye[y + 24 | 0], o && Je(e[y + 16 >> 2]), $[r + 88 | 0] = o ^ 1, Yr = y + 32 | 0, r | 0;
                }
                c = Vr() | 0, xo(r + 32 | 0), o = e[r + 20 >> 2], o && (e[r + 24 >> 2] = o, Sr(o)), Wo(r + 8 | 0), Ki(c | 0), ri();
              }
              function Jl(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0;
                h = Yr - 16 | 0, Yr = h, e[5996] = 0, g = On(134, h + 8 | 0, r | 0) | 0, c = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((c | 0) != 1) {
                        n: {
                          if (!ye[g | 0])
                            break n;
                          c = e[(e[e[r >> 2] - 12 >> 2] + r | 0) + 28 >> 2], e[h + 4 >> 2] = c, e[c + 4 >> 2] = e[c + 4 >> 2] + 1, e[5996] = 0, G = ii(135, e[h + 4 >> 2]) | 0, c = e[5996], e[5996] = 0;
                          i: {
                            s: {
                              if ((c | 0) != 1) {
                                if (c = e[h + 4 >> 2], y = e[c + 4 >> 2] - 1 | 0, e[c + 4 >> 2] = y, (y | 0) == -1 && _n[e[e[c >> 2] + 8 >> 2]](c), e[h + 4 >> 2] = e[(e[e[r >> 2] - 12 >> 2] + r | 0) + 24 >> 2], c = e[e[r >> 2] - 12 >> 2], e[5996] = 0, c = r + c | 0, y = ii(136, c | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1 || (S = e[h + 4 >> 2], e[5996] = 0, o = Cl(137, G | 0, S | 0, c | 0, y | 0, o | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1))
                                  break s;
                                if (o || (o = e[e[r >> 2] - 12 >> 2], e[5996] = 0, di(138, r + o | 0, 5), o = e[5996], e[5996] = 0, (o | 0) != 1))
                                  break n;
                                o = Ts(0) | 0;
                                break i;
                              }
                              o = Ts(0) | 0, c = e[h + 4 >> 2], y = e[c + 4 >> 2] - 1 | 0, e[c + 4 >> 2] = y, (y | 0) == -1 && _n[e[e[c >> 2] + 8 >> 2]](c);
                              break i;
                            }
                            o = Ts(0) | 0;
                          }
                          tl(g);
                          break r;
                        }
                        tl(g);
                        break t;
                      }
                      o = Ts(0) | 0;
                    }
                    if (yu(o | 0) | 0, o = e[e[r >> 2] - 12 >> 2], e[5996] = 0, ko(139, r + o | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                      break e;
                    Wu();
                  }
                  return Yr = h + 16 | 0, r | 0;
                }
                r = Vr() | 0, e[5996] = 0, Ri(110), o = e[5996], e[5996] = 0, (o | 0) != 1 && (Ki(r | 0), ri()), Ts(0) | 0, va(), ri();
              }
              function bu(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0;
                y = Yr - 32 | 0, Yr = y, e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, $[y + 4 | 0] = 0, e[y >> 2] = r;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          if (c) {
                            if (c >>> 0 >= 357913942) {
                              if (e[5996] = 0, Ri(47), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                break r;
                              break e;
                            }
                            if (e[5996] = 0, c = vi(c, 12), S = ii(3, c | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                              break r;
                            for (e[r + 4 >> 2] = S, e[r >> 2] = S, e[r + 8 >> 2] = c + S, e[y + 24 >> 2] = S, $[y + 20 | 0] = 0, e[y + 8 >> 2] = r + 8, Fe = o + c | 0, e[y + 16 >> 2] = y + 28, e[y + 12 >> 2] = y + 24, h = S; ; ) {
                              if (e[h + 8 >> 2] = 0, e[h >> 2] = 0, e[h + 4 >> 2] = 0, g = e[o >> 2], c = e[o + 4 >> 2], (g | 0) != (c | 0)) {
                                if (G = c - g | 0, (G | 0) < 0) {
                                  if (e[5996] = 0, e[y + 28 >> 2] = h, Ri(84), o = e[5996], e[5996] = 0, (o | 0) != 1)
                                    break e;
                                  if (c = Vr() | 0, o = e[h >> 2], !o)
                                    break n;
                                  e[h + 4 >> 2] = o, Sr(o);
                                  break n;
                                }
                                if (e[5996] = 0, c = ii(3, G | 0) | 0, ke = e[5996], e[5996] = 0, (ke | 0) == 1)
                                  break i;
                                if (e[h + 4 >> 2] = c, e[h >> 2] = c, e[h + 8 >> 2] = (G & -8) + c, G = e[o + 4 >> 2], (G | 0) != (g | 0))
                                  for (; ke = e[g + 4 >> 2], e[c >> 2] = e[g >> 2], e[c + 4 >> 2] = ke, c = c + 8 | 0, g = g + 8 | 0, (G | 0) != (g | 0); )
                                    ;
                                e[h + 4 >> 2] = c;
                              }
                              if (h = h + 12 | 0, o = o + 12 | 0, (Fe | 0) == (o | 0))
                                break;
                            }
                            e[r + 4 >> 2] = h;
                          }
                          return Yr = y + 32 | 0, r | 0;
                        }
                        c = Vr() | 0, e[y + 28 >> 2] = h;
                      }
                      Ed(y + 8 | 0), e[r + 4 >> 2] = S;
                      break t;
                    }
                    c = Vr() | 0;
                  }
                  i2(y), Ki(c | 0), ri();
                }
                ri();
              }
              function C4(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0;
                G = e[o >> 2], c = $[o + 11 | 0], e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, o = (c | 0) < 0 ? G : o, c = 0, G = 0;
                e: {
                  t: {
                    r: {
                      for (; ; ) {
                        for (y = h, S = c, g = G; ; ) {
                          if (c = ye[o | 0], !(c - 9 >>> 0 >= 5 & (c | 0) != 32)) {
                            o = o + 1 | 0;
                            continue;
                          }
                          if (h = ye[c + 5584 | 0], (h | 0) == 255 || (c = ye[ye[o + 1 | 0] + 5584 | 0], (c | 0) == 255))
                            break e;
                          if (o = o + 2 | 0, G = c | h << 4, (y | 0) != (g | 0)) {
                            $[g | 0] = G, g = g + 1 | 0, e[r + 4 >> 2] = g;
                            continue;
                          }
                          break;
                        }
                        if (ke = g - S | 0, h = ke + 1 | 0, (h | 0) < 0) {
                          if (e[5996] = 0, Ri(8), o = e[5996], e[5996] = 0, (o | 0) == 1)
                            break r;
                          ri();
                        }
                        n: {
                          c = ke << 1, h = ke >>> 0 >= 1073741823 ? 2147483647 : c >>> 0 > h >>> 0 ? c : h;
                          i: {
                            if (!h) {
                              Fe = 0;
                              break i;
                            }
                            if (e[5996] = 0, Fe = ii(3, h | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                              break n;
                          }
                          if (c = ke + Fe | 0, $[c | 0] = G, h = h + Fe | 0, G = c + 1 | 0, (y | 0) != (S | 0)) {
                            if (Ar = (S ^ -1) + g | 0, g = 0, ke = ke & 3, ke)
                              for (; c = c - 1 | 0, y = y - 1 | 0, $[c | 0] = ye[y | 0], g = g + 1 | 0, (ke | 0) != (g | 0); )
                                ;
                            if (Ar >>> 0 >= 3)
                              for (; $[c - 1 | 0] = ye[y - 1 | 0], $[c - 2 | 0] = ye[y - 2 | 0], $[c - 3 | 0] = ye[y - 3 | 0], c = c - 4 | 0, y = y - 4 | 0, $[c | 0] = ye[y | 0], (y | 0) != (S | 0); )
                                ;
                            c = Fe;
                          }
                          if (e[r + 8 >> 2] = h, e[r + 4 >> 2] = G, e[r >> 2] = c, !S)
                            continue;
                          Sr(S);
                          continue;
                        }
                        break;
                      }
                      o = Vr() | 0;
                      break t;
                    }
                    o = Vr() | 0, S = e[r >> 2];
                  }
                  S && (e[r + 4 >> 2] = S, Sr(S)), Ki(o | 0), ri();
                }
              }
              function Vf(r, o, c, h, y, g) {
                var S = 0, G = 0;
                if ($[r | 0] = 0, $[r + 1 | 0] = 0, $[r + 2 | 0] = 0, $[r + 3 | 0] = 0, $[r + 4 | 0] = 0, $[r + 5 | 0] = 0, $[r + 6 | 0] = 0, $[r + 7 | 0] = 0, $[r + 24 | 0] = 0, $[r + 25 | 0] = 0, $[r + 26 | 0] = 0, $[r + 27 | 0] = 0, $[r + 28 | 0] = 0, $[r + 29 | 0] = 0, $[r + 30 | 0] = 0, $[r + 31 | 0] = 0, $[r + 16 | 0] = 0, $[r + 17 | 0] = 0, $[r + 18 | 0] = 0, $[r + 19 | 0] = 0, $[r + 20 | 0] = 0, $[r + 21 | 0] = 0, $[r + 22 | 0] = 0, $[r + 23 | 0] = 0, $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0, $[r + 12 | 0] = 0, $[r + 13 | 0] = 0, $[r + 14 | 0] = 0, $[r + 15 | 0] = 0, e[5996] = 0, S = On(127, r | 0, 130) | 0, G = e[5996], e[5996] = 0, (G | 0) != 1)
                  e: {
                    if (o = e[o >> 2], e[5996] = 0, o = zc(S, o, o >> 31), S = e[5996], e[5996] = 0, (S | 0) == 1 || (c = e[c >> 2], e[5996] = 0, o = On(127, o | 0, c | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1) || (c = e[h >> 2], e[5996] = 0, o = On(127, o | 0, c | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1) || (e[5996] = 0, o = On(19, o | 0, y | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1) || (c = e[g >> 2], e[5996] = 0, On(127, o | 0, c | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1))
                      break e;
                    return;
                  }
                o = Vr() | 0, (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) >>> 0 >= 29 && (Sr(ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)), $[r + 8 | 0] = 0, $[r + 9 | 0] = 0, $[r + 10 | 0] = 0, $[r + 11 | 0] = 0), Ki(o | 0), ri();
              }
              function cf(r, o, c, h, y, g, S, G, ke, Fe, Ar, hr) {
                e: {
                  t: {
                    if ((r | 0) == (g | 0)) {
                      if (!ye[o | 0])
                        break e;
                      if (g = 0, $[o | 0] = 0, r = e[y >> 2], e[y >> 2] = r + 1, $[r | 0] = 46, r = ye[G + 11 | 0], !((r & 128) >>> 7 | 0 ? e[G + 4 >> 2] : r & 127) || (r = e[Fe >> 2], (r - ke | 0) > 159))
                        break t;
                      return o = e[Ar >> 2], e[Fe >> 2] = r + 4, e[r >> 2] = o, 0;
                    }
                    r: {
                      if ((r | 0) != (S | 0) || (g = ye[G + 11 | 0], !((g & 128) >>> 7 | 0 ? e[G + 4 >> 2] : g & 127)))
                        break r;
                      if (!ye[o | 0])
                        break e;
                      if (g = 0, r = e[Fe >> 2], (r - ke | 0) > 159)
                        break t;
                      return o = e[Ar >> 2], e[Fe >> 2] = r + 4, e[r >> 2] = o, e[Ar >> 2] = 0, 0;
                    }
                    if (g = -1, S = xd(hr, hr + 32 | 0, r) - hr | 0, (S | 0) > 31)
                      break t;
                    r = $[S + 12416 | 0];
                    r: {
                      n:
                        switch ((S & -2) - 22 | 0) {
                          case 2:
                            if (o = e[y >> 2], (o | 0) != (h | 0) && (h = $[o - 1 | 0], c = $[c | 0], ((h - 97 >>> 0 < 26 ? h & 95 : h) | 0) != ((c - 97 >>> 0 < 26 ? c & 95 : c) | 0)))
                              break t;
                            return e[y >> 2] = o + 1, $[o | 0] = r, 0;
                          case 0:
                            $[c | 0] = 80;
                            break r;
                          default:
                            break n;
                        }
                      if (h = r - 97 >>> 0 < 26 ? r & 95 : r, (h | 0) != $[c | 0] || ($[c | 0] = h - 65 >>> 0 < 26 ? h | 32 : h, !ye[o | 0]) || ($[o | 0] = 0, o = ye[G + 11 | 0], !((o & 128) >>> 7 | 0 ? e[G + 4 >> 2] : o & 127)) || (o = e[Fe >> 2], (o - ke | 0) > 159))
                        break r;
                      c = e[Ar >> 2], e[Fe >> 2] = o + 4, e[o >> 2] = c;
                    }
                    if (o = e[y >> 2], e[y >> 2] = o + 1, $[o | 0] = r, g = 0, (S | 0) > 21)
                      break t;
                    e[Ar >> 2] = e[Ar >> 2] + 1;
                  }
                  return g;
                }
                return -1;
              }
              function Wf(r, o, c, h, y, g, S, G, ke, Fe, Ar, hr) {
                e: {
                  t: {
                    if ((r | 0) == (g | 0)) {
                      if (!ye[o | 0])
                        break e;
                      if (g = 0, $[o | 0] = 0, r = e[y >> 2], e[y >> 2] = r + 1, $[r | 0] = 46, r = ye[G + 11 | 0], !((r & 128) >>> 7 | 0 ? e[G + 4 >> 2] : r & 127) || (r = e[Fe >> 2], (r - ke | 0) > 159))
                        break t;
                      return o = e[Ar >> 2], e[Fe >> 2] = r + 4, e[r >> 2] = o, 0;
                    }
                    r: {
                      if ((r | 0) != (S | 0) || (g = ye[G + 11 | 0], !((g & 128) >>> 7 | 0 ? e[G + 4 >> 2] : g & 127)))
                        break r;
                      if (!ye[o | 0])
                        break e;
                      if (g = 0, r = e[Fe >> 2], (r - ke | 0) > 159)
                        break t;
                      return o = e[Ar >> 2], e[Fe >> 2] = r + 4, e[r >> 2] = o, e[Ar >> 2] = 0, 0;
                    }
                    if (g = -1, S = Rd(hr, hr + 128 | 0, r) - hr | 0, (S | 0) > 124)
                      break t;
                    r = $[(S >> 2) + 12416 | 0];
                    r: {
                      n: {
                        if (hr = S & -5, (hr | 0) != 88) {
                          if ((hr | 0) != 96)
                            break n;
                          if (o = e[y >> 2], (o | 0) != (h | 0) && (h = $[o - 1 | 0], c = $[c | 0], ((h - 97 >>> 0 < 26 ? h & 95 : h) | 0) != ((c - 97 >>> 0 < 26 ? c & 95 : c) | 0)))
                            break t;
                          return e[y >> 2] = o + 1, $[o | 0] = r, 0;
                        }
                        $[c | 0] = 80;
                        break r;
                      }
                      if (h = r - 97 >>> 0 < 26 ? r & 95 : r, (h | 0) != $[c | 0] || ($[c | 0] = h - 65 >>> 0 < 26 ? h | 32 : h, !ye[o | 0]) || ($[o | 0] = 0, o = ye[G + 11 | 0], !((o & 128) >>> 7 | 0 ? e[G + 4 >> 2] : o & 127)) || (o = e[Fe >> 2], (o - ke | 0) > 159))
                        break r;
                      c = e[Ar >> 2], e[Fe >> 2] = o + 4, e[o >> 2] = c;
                    }
                    if (o = e[y >> 2], e[y >> 2] = o + 1, $[o | 0] = r, g = 0, (S | 0) > 84)
                      break t;
                    e[Ar >> 2] = e[Ar >> 2] + 1;
                  }
                  return g;
                }
                return -1;
              }
              function hc(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0, Mn = 0, ei = 0, ci = 0, gi = 0;
                if ((c | 0) != 1) {
                  hr = Yr - 1040 | 0, Yr = hr, ei = e[5732];
                  e: {
                    t: {
                      if (S = hr + 16 | 0, ln = fa[((c >>> 0 <= 153 ? c : 0) << 1) + 21296 >> 1] + 19372 | 0, o = e[e[6178] + 20 >> 2], o) {
                        G = e[o + 4 >> 2], h = e[o >> 2], g = e[h >> 2] + 1794895138 | 0, ke = ka(e[h + 8 >> 2], g), Fe = ka(e[h + 12 >> 2], g), y = ka(e[h + 16 >> 2], g);
                        r: {
                          if (G >>> 2 >>> 0 <= ke >>> 0 || (o = G - (ke << 2) | 0, (y | Fe) & 3 | (o >>> 0 <= Fe >>> 0 | o >>> 0 <= y >>> 0)))
                            break r;
                          for (ci = y >>> 2 | 0, gi = Fe >>> 2 | 0; ; ) {
                            if (Tr = ke >>> 1 | 0, Fe = Tr + Rn | 0, y = Fe << 1, o = h + (y + gi << 2) | 0, Mn = ka(e[o >> 2], g), o = ka(e[o + 4 >> 2], g), o >>> 0 >= G >>> 0 | G - o >>> 0 <= Mn >>> 0 | ye[h + (o + Mn | 0) | 0])
                              break r;
                            if (o = Uc(ln, o + h | 0), !o) {
                              if (o = h + (y + ci << 2) | 0, y = ka(e[o >> 2], g), o = ka(e[o + 4 >> 2], g), o >>> 0 >= G >>> 0 | y >>> 0 >= G - o >>> 0)
                                break r;
                              Ar = ye[h + (o + y | 0) | 0] ? 0 : o + h | 0;
                              break r;
                            }
                            if ((ke | 0) == 1)
                              break r;
                            o = (o | 0) < 0, ke = o ? Tr : ke - Tr | 0, Rn = o ? Rn : Fe;
                          }
                        }
                      }
                      Ar = Ar || ln, o = Da(Ar);
                      r: {
                        if (o >>> 0 >= 1024) {
                          _s(S, Ar, 1023), $[S + 1023 | 0] = 0, o = 68;
                          break r;
                        }
                        _s(S, Ar, o + 1 | 0), o = 0;
                      }
                      if (o) {
                        if ((o | 0) != 28)
                          break t;
                        o = 5575;
                      } else
                        o = S;
                      break e;
                    }
                    Ff(), ri();
                  }
                  ye[o | 0] || (e[hr >> 2] = c, wl(S, 1024, 2507, hr), o = S), e[5732] = ei, Ga(r, o), Yr = hr + 1040 | 0;
                  return;
                }
                Ga(r, 1694);
              }
              function Ng(r, o, c, h) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0;
                var y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0;
                g = Yr - 32 | 0, Yr = g, e[g + 28 >> 2] = h, e[g + 24 >> 2] = h, $[g + 20 | 0] = 0, e[g + 8 >> 2] = r, e[g + 16 >> 2] = g + 28, e[g + 12 >> 2] = g + 24;
                e: {
                  t: {
                    r: {
                      if ((o | 0) != (c | 0))
                        for (; ; ) {
                          if (e[h + 8 >> 2] = 0, e[h >> 2] = 0, e[h + 4 >> 2] = 0, r = e[o + 4 >> 2], y = e[o >> 2], (r | 0) != (y | 0)) {
                            if (y = r - y | 0, (y | 0) < 0) {
                              if (e[5996] = 0, Ri(8), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                break r;
                              ri();
                            }
                            if (e[5996] = 0, r = ii(3, y | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                              break t;
                            e[h + 4 >> 2] = r, e[h >> 2] = r, e[h + 8 >> 2] = r + y, y = e[o >> 2], S = e[o + 4 >> 2];
                            n: {
                              if ((y | 0) == (S | 0))
                                break n;
                              if (Fe = (y ^ -1) + S | 0, G = 0, ke = S - y & 7, ke)
                                for (; $[r | 0] = ye[y | 0], r = r + 1 | 0, y = y + 1 | 0, G = G + 1 | 0, (ke | 0) != (G | 0); )
                                  ;
                              if (Fe >>> 0 < 7)
                                break n;
                              for (; $[r | 0] = ye[y | 0], $[r + 1 | 0] = ye[y + 1 | 0], $[r + 2 | 0] = ye[y + 2 | 0], $[r + 3 | 0] = ye[y + 3 | 0], $[r + 4 | 0] = ye[y + 4 | 0], $[r + 5 | 0] = ye[y + 5 | 0], $[r + 6 | 0] = ye[y + 6 | 0], $[r + 7 | 0] = ye[y + 7 | 0], r = r + 8 | 0, y = y + 8 | 0, (S | 0) != (y | 0); )
                                ;
                            }
                            e[h + 4 >> 2] = r;
                          }
                          if (h = h + 12 | 0, e[g + 28 >> 2] = h, o = o + 12 | 0, (c | 0) == (o | 0))
                            break;
                        }
                      return Yr = g + 32 | 0, h | 0;
                    }
                    if (r = Vr() | 0, o = e[h >> 2], !o)
                      break e;
                    e[h + 4 >> 2] = o, Sr(o);
                    break e;
                  }
                  r = Vr() | 0;
                }
                Ed(g + 8 | 0), Ki(r | 0), ri();
              }
              function Cc(r, o) {
                var c = 0, h = 0, y = 0;
                c = (r | 0) == (o | 0), $[o + 12 | 0] = c;
                e: {
                  if (c)
                    break e;
                  for (; ; ) {
                    if (h = e[o + 8 >> 2], ye[h + 12 | 0])
                      break e;
                    t: {
                      if (c = e[h + 8 >> 2], y = e[c >> 2], (y | 0) == (h | 0)) {
                        if (y = e[c + 4 >> 2], !(!y | ye[y + 12 | 0]))
                          break t;
                        r: {
                          if (e[h >> 2] == (o | 0)) {
                            o = h;
                            break r;
                          }
                          o = e[h + 4 >> 2], r = e[o >> 2], e[h + 4 >> 2] = r, r && (e[r + 8 >> 2] = h, c = e[h + 8 >> 2]), e[o + 8 >> 2] = c, r = e[h + 8 >> 2], e[((e[r >> 2] != (h | 0)) << 2) + r >> 2] = o, e[o >> 2] = h, e[h + 8 >> 2] = o, c = e[o + 8 >> 2], h = e[c >> 2];
                        }
                        $[o + 12 | 0] = 1, $[c + 12 | 0] = 0, r = e[h + 4 >> 2], e[c >> 2] = r, r && (e[r + 8 >> 2] = c), e[h + 8 >> 2] = e[c + 8 >> 2], r = e[c + 8 >> 2], e[((e[r >> 2] != (c | 0)) << 2) + r >> 2] = h, e[h + 4 >> 2] = c, e[c + 8 >> 2] = h;
                        return;
                      }
                      if (!(ye[y + 12 | 0] | !y))
                        break t;
                      r: {
                        if (e[h >> 2] != (o | 0)) {
                          o = h;
                          break r;
                        }
                        r = e[o + 4 >> 2], e[h >> 2] = r, r && (e[r + 8 >> 2] = h, c = e[h + 8 >> 2]), e[o + 8 >> 2] = c, r = e[h + 8 >> 2], e[((e[r >> 2] != (h | 0)) << 2) + r >> 2] = o, e[o + 4 >> 2] = h, e[h + 8 >> 2] = o, c = e[o + 8 >> 2];
                      }
                      $[o + 12 | 0] = 1, $[c + 12 | 0] = 0, r = e[c + 4 >> 2], o = e[r >> 2], e[c + 4 >> 2] = o, o && (e[o + 8 >> 2] = c), e[r + 8 >> 2] = e[c + 8 >> 2], o = e[c + 8 >> 2], e[((e[o >> 2] != (c | 0)) << 2) + o >> 2] = r, e[r >> 2] = c, e[c + 8 >> 2] = r;
                      break e;
                    }
                    if ($[h + 12 | 0] = 1, $[c + 12 | 0] = (r | 0) == (c | 0), $[y + 12 | 0] = 1, o = c, (r | 0) == (c | 0))
                      break;
                  }
                }
              }
              function Pg(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0;
                e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            if (y = e[o + 4 >> 2], h = e[o >> 2], (y | 0) != (h | 0)) {
                              if (h = y - h | 0, (h | 0) < 0) {
                                if (e[5996] = 0, Ri(85), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                  break s;
                                break e;
                              }
                              if (e[5996] = 0, y = ii(3, h | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                break s;
                              if (e[r + 4 >> 2] = y, e[r >> 2] = y, e[r + 8 >> 2] = (h & -8) + y, h = e[o >> 2], o = e[o + 4 >> 2], (h | 0) != (o | 0))
                                for (; Fi[y >> 3] = Fi[h >> 3], y = y + 8 | 0, h = h + 8 | 0, (o | 0) != (h | 0); )
                                  ;
                              e[r + 4 >> 2] = y;
                            }
                            if (e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, o = e[c + 4 >> 2], y = e[c >> 2], (o | 0) == (y | 0))
                              break n;
                            if (o = o - y | 0, (o | 0) >= 0)
                              break i;
                            if (e[5996] = 0, Ri(85), o = e[5996], e[5996] = 0, (o | 0) != 1)
                              break e;
                            break r;
                          }
                          h = Vr() | 0;
                          break t;
                        }
                        if (e[5996] = 0, y = ii(3, o | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1)
                          break r;
                        if (e[r + 16 >> 2] = y, e[r + 12 >> 2] = y, e[r + 20 >> 2] = (o & -8) + y, h = e[c >> 2], o = e[c + 4 >> 2], (h | 0) != (o | 0))
                          for (; Fi[y >> 3] = Fi[h >> 3], y = y + 8 | 0, h = h + 8 | 0, (o | 0) != (h | 0); )
                            ;
                        e[r + 16 >> 2] = y;
                      }
                      return r | 0;
                    }
                    if (h = Vr() | 0, o = e[r + 12 >> 2], !o)
                      break t;
                    e[r + 16 >> 2] = o, Sr(o);
                  }
                  o = e[r >> 2], o && (e[r + 4 >> 2] = o, Sr(o)), Ki(h | 0), ri();
                }
                ri();
              }
              function qg(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0;
                h = Yr - 32 | 0, Yr = h, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, e[r + 4 >> 2] = c, e[r >> 2] = o, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, g = r + 32 | 0, e[g >> 2] = 0, e[g + 4 >> 2] = 0, e[r + 40 >> 2] = 0, e[5996] = 0, di(86, r + 44 | 0, r | 0), o = e[5996], e[5996] = 0;
                e: {
                  if ((o | 0) == 1 || (e[5996] = 0, di(87, r - -64 | 0, r | 0), o = e[5996], e[5996] = 0, (o | 0) == 1) || (o = 0, e[5996] = 0, c = ii(88, r | 0) | 0, y = e[5996], e[5996] = 0, (y | 0) == 1))
                    break e;
                  if (e[r + 80 >> 2] = c, y = e[r + 32 >> 2], S = e[r + 36 >> 2], (y | 0) == (S | 0))
                    c = 0;
                  else {
                    for (c = y; o = e[e[c >> 2] + 84 >> 2] + o | 0, c = c + 8 | 0, (S | 0) != (c | 0); )
                      ;
                    c = e[e[y >> 2] + 80 >> 2];
                  }
                  if (G = e[r + 4 >> 2], ke = e[r >> 2], Fe = e[r + 8 >> 2], Ar = e[r + 12 >> 2], e[5996] = 0, o = Fa(89, ke | 0, c | 0, o | 0, G | 0, S - y >> 3, (Ar - Fe | 0) / 12 | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1 || (e[r + 84 >> 2] = o, e[5996] = 0, e[h + 28 >> 2] = r, as(90, h + 12 | 0, r | 0, h + 28 | 0), o = e[5996], e[5996] = 0, (o | 0) == 1))
                    break e;
                  return o = ye[h + 24 | 0], o && Je(e[h + 16 >> 2]), $[r + 88 | 0] = o ^ 1, Yr = h + 32 | 0, r | 0;
                }
                c = Vr() | 0, xo(g), o = e[r + 20 >> 2], o && (e[r + 24 >> 2] = o, Sr(o)), Wo(r + 8 | 0), Ki(c | 0), ri();
              }
              function Og(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0;
                e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                e: {
                  if (c) {
                    if (c >>> 0 >= 536870912) {
                      if (e[5996] = 0, Ri(84), o = e[5996], e[5996] = 0, (o | 0) == 1)
                        break e;
                      ri();
                    }
                    if (e[5996] = 0, y = c << 3, h = ii(3, y | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                      break e;
                    e[r + 4 >> 2] = h, e[r >> 2] = h, e[r + 8 >> 2] = h + y, g = c - 1 & 536870911, S = c & 7;
                    t: {
                      if (!S) {
                        c = o;
                        break t;
                      }
                      for (c = o; ke = e[c + 4 >> 2], e[h >> 2] = e[c >> 2], e[h + 4 >> 2] = ke, h = h + 8 | 0, c = c + 8 | 0, G = G + 1 | 0, (G | 0) != (S | 0); )
                        ;
                    }
                    if (g >>> 0 >= 7)
                      for (o = o + y | 0; y = e[c + 4 >> 2], e[h >> 2] = e[c >> 2], e[h + 4 >> 2] = y, y = e[c + 12 >> 2], e[h + 8 >> 2] = e[c + 8 >> 2], e[h + 12 >> 2] = y, y = e[c + 20 >> 2], e[h + 16 >> 2] = e[c + 16 >> 2], e[h + 20 >> 2] = y, y = e[c + 28 >> 2], e[h + 24 >> 2] = e[c + 24 >> 2], e[h + 28 >> 2] = y, y = e[c + 36 >> 2], e[h + 32 >> 2] = e[c + 32 >> 2], e[h + 36 >> 2] = y, y = e[c + 44 >> 2], e[h + 40 >> 2] = e[c + 40 >> 2], e[h + 44 >> 2] = y, y = e[c + 52 >> 2], e[h + 48 >> 2] = e[c + 48 >> 2], e[h + 52 >> 2] = y, y = e[c + 60 >> 2], e[h + 56 >> 2] = e[c + 56 >> 2], e[h + 60 >> 2] = y, h = h - -64 | 0, c = c - -64 | 0, (o | 0) != (c | 0); )
                        ;
                    e[r + 4 >> 2] = h;
                  }
                  return r | 0;
                }
                c = Vr() | 0, o = e[r >> 2], o && (e[r + 4 >> 2] = o, Sr(o)), Ki(c | 0), ri();
              }
              function Eu(r, o, c, h) {
                var y = 0, g = 0, S = 0, G = 0;
                S = Yr - 32 | 0, Yr = S, y = h & 2147483647, G = y, g = y - 1006698496 | 0, y = y - 1140785152 | 0;
                e: {
                  if ((g | 0) == (y | 0) & 0 | y >>> 0 > g >>> 0) {
                    if (y = c << 4 | o >>> 28, c = h << 4 | c >>> 28, o = o & 268435455, (o | 0) == 134217728 & (r | 0) != 0 | o >>> 0 > 134217728) {
                      g = c + 1073741824 | 0, y = y + 1 | 0, g = y ? g : g + 1 | 0;
                      break e;
                    }
                    if (g = c + 1073741824 | 0, r | (o | 0) != 134217728)
                      break e;
                    r = y & 1, y = r + y | 0, g = r >>> 0 > y >>> 0 ? g + 1 | 0 : g;
                    break e;
                  }
                  if (!(!c & (G | 0) == 2147418112 ? !(r | o) : G >>> 0 < 2147418112)) {
                    r = h << 4 | c >>> 28, y = c << 4 | o >>> 28, g = r & 524287 | 2146959360;
                    break e;
                  }
                  if (y = 0, g = 2146435072, G >>> 0 > 1140785151 || (g = 0, G = G >>> 16 | 0, G >>> 0 < 15249))
                    break e;
                  if (y = h & 65535 | 65536, ha(S + 16 | 0, r, o, c, y, G - 15233 | 0), Ac(S, r, o, c, y, 15361 - G | 0), o = e[S + 8 >> 2], y = o << 4, o = e[S + 12 >> 2] << 4 | o >>> 28, c = e[S >> 2], g = e[S + 4 >> 2], G = g, y = g >>> 28 | y, g = o, r = G & 268435455, o = c | (e[S + 16 >> 2] | e[S + 24 >> 2] | (e[S + 20 >> 2] | e[S + 28 >> 2])) != 0, (r | 0) == 134217728 & (o | 0) != 0 | r >>> 0 > 134217728) {
                    y = y + 1 | 0, g = y ? g : g + 1 | 0;
                    break e;
                  }
                  if (o | (r | 0) != 134217728)
                    break e;
                  r = y, y = y + (y & 1) | 0, g = r >>> 0 > y >>> 0 ? g + 1 | 0 : g;
                }
                return Yr = S + 32 | 0, jo(0, y | 0), jo(1, h & -2147483648 | g), +za();
              }
              function Yu(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0;
                if (h = Yr - 16 | 0, Yr = h, e[h + 12 >> 2] = o, o >>> 0 < 2147483632) {
                  e: {
                    if (((ye[r + 11 | 0] & 128) >>> 7 | 0 ? (e[r + 8 >> 2] & 2147483647) - 1 | 0 : 10) >>> 0 >= o >>> 0 || (o = ye[r + 11 | 0], e[h + 8 >> 2] = (o & 128) >>> 7 | 0 ? e[r + 4 >> 2] : o & 127, c = e[(Ps[h + 12 >> 2] < Ps[h + 8 >> 2] ? h + 8 | 0 : h + 12 | 0) >> 2], c >>> 0 >= 11 ? (c = c + 16 & -16, y = c - 1 | 0, c = (y | 0) == 11 ? c : y) : c = 10, (c | 0) == (((ye[r + 11 | 0] & 128) >>> 7 | 0 ? (e[r + 8 >> 2] & 2147483647) - 1 | 0 : 10) | 0)))
                      break e;
                    g = Yr - 16 | 0, Yr = g, o = ye[r + 11 | 0], y = (o & 128) >>> 7 | 0 ? e[r + 4 >> 2] : o & 127;
                    t: {
                      r: {
                        ke = c >>> 0 < 11;
                        n: {
                          if (ke) {
                            Fe = 1, S = c + 1 | 0, G = e[r >> 2], c = y, o = r;
                            break n;
                          }
                          S = c + 1 | 0;
                          i: {
                            if (c >>> 0 > ((ye[r + 11 | 0] & 128) >>> 7 | 0 ? (e[r + 8 >> 2] & 2147483647) - 1 | 0 : 10) >>> 0) {
                              bc(g + 8 | 0, S);
                              break i;
                            }
                            if (e[5996] = 0, di(289, g + 8 | 0, S | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                              break r;
                          }
                          S = e[g + 12 >> 2], c = ye[r + 11 | 0], o = (c & 128) >>> 7 | 0, Fe = o, G = o ? e[r >> 2] : r, c = o ? e[r + 4 >> 2] : c & 127, o = e[g + 8 >> 2];
                        }
                        if (o = uc(o, G, c + 1 | 0), Fe && Sr(G), !ke) {
                          e[r + 8 >> 2] = S | -2147483648, e[r + 4 >> 2] = y, e[r >> 2] = o;
                          break t;
                        }
                        $[r + 11 | 0] = y;
                        break t;
                      }
                      yu(Ts(0) | 0) | 0, Wu();
                    }
                    Yr = g + 16 | 0;
                  }
                  Yr = h + 16 | 0;
                  return;
                }
                ba(), ri();
              }
              function zf(r) {
                var o = 0, c = 0, h = 0, y = 0, g = 0;
                h = e[5726], c = r + 7 & -8, o = h + c | 0;
                e: {
                  t: {
                    if (o >>> 0 <= h >>> 0 && c || o >>> 0 > s8() << 16 >>> 0 && !(xl(o | 0) | 0))
                      break t;
                    e[5726] = o;
                    break e;
                  }
                  e[5732] = 48, h = -1;
                }
                if ((h | 0) != -1) {
                  r = r + h | 0, e[r - 4 >> 2] = 16, c = r - 16 | 0, e[c >> 2] = 16, o = e[5992], o ? g = e[o + 8 >> 2] : g = 0;
                  e: {
                    t: {
                      if ((g | 0) == (h | 0)) {
                        if (y = h - (e[h - 4 >> 2] & -2) | 0, g = e[y - 4 >> 2], e[o + 8 >> 2] = r, r = y - (g & -2) | 0, o = -16, !($[(r + e[r >> 2] | 0) - 4 | 0] & 1))
                          break t;
                        o = e[r + 4 >> 2], e[o + 8 >> 2] = e[r + 8 >> 2], e[e[r + 8 >> 2] + 4 >> 2] = o, o = c - r | 0, e[r >> 2] = o;
                        break e;
                      }
                      e[h + 12 >> 2] = 16, e[h >> 2] = 16, e[h + 8 >> 2] = r, e[h + 4 >> 2] = o, e[5992] = h, o = 16;
                    }
                    r = o + h | 0, o = c - r | 0, e[r >> 2] = o;
                  }
                  e[((o & -4) + r | 0) - 4 >> 2] = o | 1, c = e[r >> 2] - 8 | 0;
                  e: {
                    if (c >>> 0 <= 127) {
                      o = (c >>> 3 | 0) - 1 | 0;
                      break e;
                    }
                    if (y = Do(c), o = ((c >>> 29 - y ^ 4) - (y << 2) | 0) + 110 | 0, c >>> 0 <= 4095)
                      break e;
                    o = ((c >>> 30 - y ^ 2) - (y << 1) | 0) + 71 | 0, o = o >>> 0 >= 63 ? 63 : o;
                  }
                  c = o << 4, e[r + 4 >> 2] = c + 22944, c = c + 22952 | 0, e[r + 8 >> 2] = e[c >> 2], e[c >> 2] = r, e[e[r + 8 >> 2] + 4 >> 2] = r, c = e[5994], y = e[5995], r = o & 31, (o & 63) >>> 0 >= 32 ? (o = 1 << r, g = 0) : (g = 1 << r, o = g - 1 & 1 >>> 32 - r), e[5994] = g | c, e[5995] = o | y;
                }
                return (h | 0) != -1;
              }
              function fh(r, o, c, h, y, g, S, G) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, G = G | 0, r = Yr - 16 | 0, Yr = r, e[r + 12 >> 2] = c, e[r + 8 >> 2] = g, e[r + 12 >> 2] = c, e[r + 8 >> 2] = g, o = e[r + 12 >> 2];
                e: {
                  for (; ; ) {
                    if (o >>> 0 >= h >>> 0) {
                      c = 0;
                      break e;
                    }
                    if (c = 2, o = e[o >> 2], o >>> 0 > 1114111 | (o & -2048) == 55296)
                      break e;
                    t: {
                      r: {
                        if (o >>> 0 <= 127) {
                          if (c = 1, g = e[r + 8 >> 2], (S - g | 0) <= 0)
                            break e;
                          e[r + 8 >> 2] = g + 1, $[g | 0] = o;
                          break r;
                        }
                        if (o >>> 0 <= 2047) {
                          if (c = e[r + 8 >> 2], (S - c | 0) < 2)
                            break t;
                          e[r + 8 >> 2] = c + 1, $[c | 0] = o >>> 6 | 192, c = e[r + 8 >> 2], e[r + 8 >> 2] = c + 1, $[c | 0] = o & 63 | 128;
                          break r;
                        }
                        if (c = e[r + 8 >> 2], g = S - c | 0, o >>> 0 <= 65535) {
                          if ((g | 0) < 3)
                            break t;
                          e[r + 8 >> 2] = c + 1, $[c | 0] = o >>> 12 | 224, c = e[r + 8 >> 2], e[r + 8 >> 2] = c + 1, $[c | 0] = o >>> 6 & 63 | 128, c = e[r + 8 >> 2], e[r + 8 >> 2] = c + 1, $[c | 0] = o & 63 | 128;
                          break r;
                        }
                        if ((g | 0) < 4)
                          break t;
                        e[r + 8 >> 2] = c + 1, $[c | 0] = o >>> 18 | 240, c = e[r + 8 >> 2], e[r + 8 >> 2] = c + 1, $[c | 0] = o >>> 12 & 63 | 128, c = e[r + 8 >> 2], e[r + 8 >> 2] = c + 1, $[c | 0] = o >>> 6 & 63 | 128, c = e[r + 8 >> 2], e[r + 8 >> 2] = c + 1, $[c | 0] = o & 63 | 128;
                      }
                      o = e[r + 12 >> 2] + 4 | 0, e[r + 12 >> 2] = o;
                      continue;
                    }
                    break;
                  }
                  c = 1;
                }
                return e[y >> 2] = e[r + 12 >> 2], e[G >> 2] = e[r + 8 >> 2], Yr = r + 16 | 0, c | 0;
              }
              function ff(r) {
                var o = 0, c = 0, h = 0, y = 0, g = 0;
                e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            if (c = e[6141], h = e[6142], (c | 0) != (h | 0)) {
                              if (y = h - c | 0, (y | 0) < 0) {
                                if (e[5996] = 0, Ri(85), o = e[5996], e[5996] = 0, (o | 0) == 1)
                                  break s;
                                break e;
                              }
                              if (e[5996] = 0, o = ii(3, y | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                                break s;
                              for (e[r + 4 >> 2] = o, e[r >> 2] = o, e[r + 8 >> 2] = (y & -8) + o; Fi[o >> 3] = Fi[c >> 3], o = o + 8 | 0, c = c + 8 | 0, (h | 0) != (c | 0); )
                                ;
                              e[r + 4 >> 2] = o;
                            }
                            if (e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, c = e[6144], h = e[6145], (c | 0) == (h | 0))
                              break n;
                            if (y = h - c | 0, (y | 0) >= 0)
                              break i;
                            if (e[5996] = 0, Ri(85), o = e[5996], e[5996] = 0, (o | 0) != 1)
                              break e;
                            break r;
                          }
                          c = Vr() | 0;
                          break t;
                        }
                        if (e[5996] = 0, o = ii(3, y | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                          break r;
                        for (e[r + 16 >> 2] = o, e[r + 12 >> 2] = o, e[r + 20 >> 2] = (y & -8) + o; Fi[o >> 3] = Fi[c >> 3], o = o + 8 | 0, c = c + 8 | 0, (h | 0) != (c | 0); )
                          ;
                        e[r + 16 >> 2] = o;
                      }
                      return r;
                    }
                    if (c = Vr() | 0, o = e[r + 12 >> 2], !o)
                      break t;
                    e[r + 16 >> 2] = o, Sr(o);
                  }
                  o = e[r >> 2], o && (e[r + 4 >> 2] = o, Sr(o)), Ki(c | 0), ri();
                }
                ri();
              }
              function lf(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0;
                var g = 0, S = 0, G = 0, ke = 0;
                for (o = 0, r = c; ; ) {
                  e: {
                    if (r >>> 0 >= h >>> 0 | o >>> 0 >= y >>> 0)
                      break e;
                    S = 1, g = $[r | 0];
                    t: {
                      if ((g | 0) >= 0)
                        break t;
                      if (g >>> 0 < 4294967234)
                        break e;
                      if (g >>> 0 <= 4294967263) {
                        if ((h - r | 0) < 2 || (S = 2, (ye[r + 1 | 0] & 192) != 128))
                          break e;
                        break t;
                      }
                      if (S = g & 255, g >>> 0 <= 4294967279) {
                        if ((h - r | 0) < 3)
                          break e;
                        G = ye[r + 2 | 0], g = ye[r + 1 | 0];
                        r: {
                          n: {
                            if ((S | 0) != 237) {
                              if ((S | 0) != 224)
                                break n;
                              if ((g & 224) == 160)
                                break r;
                              break e;
                            }
                            if ((g & 224) != 128)
                              break e;
                            break r;
                          }
                          if ((g & 192) != 128)
                            break e;
                        }
                        if (S = 3, (G & 192) != 128)
                          break e;
                        break t;
                      }
                      if ((h - r | 0) < 4 | g >>> 0 > 4294967284 | y - o >>> 0 < 2)
                        break e;
                      G = ye[r + 3 | 0], ke = ye[r + 2 | 0], g = ye[r + 1 | 0];
                      r: {
                        n:
                          switch (S - 240 | 0) {
                            case 0:
                              if ((g + 112 & 255) >>> 0 >= 48)
                                break e;
                              break r;
                            case 4:
                              if ((g & 240) != 128)
                                break e;
                              break r;
                            default:
                              break n;
                          }
                        if ((g & 192) != 128)
                          break e;
                      }
                      if ((ke & 192) != 128 | (G & 192) != 128 | (S << 18 & 1835008 | (g & 48) << 12) >>> 0 > 1114111)
                        break e;
                      o = o + 1 | 0, S = 4;
                    }
                    o = o + 1 | 0, r = r + S | 0;
                    continue;
                  }
                  break;
                }
                return r - c | 0;
              }
              function Yl(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0;
                c = Yr - 32 | 0, Yr = c, e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, $[c + 4 | 0] = 0, e[c >> 2] = r, y = e[o + 4 >> 2], g = e[o >> 2], S = y - g | 0, h = (S | 0) / 12 | 0;
                e: {
                  t: {
                    r: {
                      if ((y | 0) != (g | 0)) {
                        if (h >>> 0 >= 357913942) {
                          if (e[5996] = 0, Ri(41), r = e[5996], e[5996] = 0, (r | 0) == 1)
                            break r;
                          ri();
                        }
                        if (e[5996] = 0, y = ii(3, S | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                          break r;
                        e[r + 4 >> 2] = y, e[r >> 2] = y, e[r + 8 >> 2] = y + vi(h, 12), g = e[o + 4 >> 2], o = e[o >> 2], e[c + 28 >> 2] = y, e[c + 24 >> 2] = y, $[c + 20 | 0] = 0, e[c + 8 >> 2] = r + 8, e[c + 16 >> 2] = c + 28, e[c + 12 >> 2] = c + 24;
                        n: {
                          if ((o | 0) == (g | 0)) {
                            h = y;
                            break n;
                          }
                          for (h = y; ; ) {
                            i: {
                              if ($[o + 11 | 0] >= 0) {
                                S = e[o + 4 >> 2], e[h >> 2] = e[o >> 2], e[h + 4 >> 2] = S, e[h + 8 >> 2] = e[o + 8 >> 2];
                                break i;
                              }
                              if (S = e[o + 4 >> 2], G = e[o >> 2], e[5996] = 0, as(40, h | 0, G | 0, S | 0), h = e[5996], e[5996] = 0, (h | 0) == 1)
                                break t;
                              h = e[c + 28 >> 2];
                            }
                            if (h = h + 12 | 0, e[c + 28 >> 2] = h, o = o + 12 | 0, (g | 0) == (o | 0))
                              break;
                          }
                        }
                        e[r + 4 >> 2] = h;
                      }
                      return Yr = c + 32 | 0, r | 0;
                    }
                    o = Vr() | 0;
                    break e;
                  }
                  o = Vr() | 0, Pa(c + 8 | 0), e[r + 4 >> 2] = y;
                }
                Gh(c), Ki(o | 0), ri();
              }
              function Xl(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0;
                var g = 0, S = 0, G = 0, ke = 0;
                for (r = c; ; ) {
                  e: {
                    if (y >>> 0 <= ke >>> 0 | r >>> 0 >= h >>> 0)
                      break e;
                    g = 1, o = $[r | 0];
                    t: {
                      if ((o | 0) >= 0)
                        break t;
                      if (o >>> 0 < 4294967234)
                        break e;
                      if (o >>> 0 <= 4294967263) {
                        if ((h - r | 0) < 2 || (g = 2, (ye[r + 1 | 0] & 192) != 128))
                          break e;
                        break t;
                      }
                      if (S = o & 255, o >>> 0 <= 4294967279) {
                        if ((h - r | 0) < 3)
                          break e;
                        G = ye[r + 2 | 0], o = ye[r + 1 | 0];
                        r: {
                          n: {
                            if ((S | 0) != 237) {
                              if ((S | 0) != 224)
                                break n;
                              if ((o & 224) == 160)
                                break r;
                              break e;
                            }
                            if ((o & 224) != 128)
                              break e;
                            break r;
                          }
                          if ((o & 192) != 128)
                            break e;
                        }
                        if (g = 3, (G & 192) != 128)
                          break e;
                        break t;
                      }
                      if ((h - r | 0) < 4 | o >>> 0 > 4294967284)
                        break e;
                      g = ye[r + 3 | 0], G = ye[r + 2 | 0], o = ye[r + 1 | 0];
                      r: {
                        n:
                          switch (S - 240 | 0) {
                            case 0:
                              if ((o + 112 & 255) >>> 0 >= 48)
                                break e;
                              break r;
                            case 4:
                              if ((o & 240) != 128)
                                break e;
                              break r;
                            default:
                              break n;
                          }
                        if ((o & 192) != 128)
                          break e;
                      }
                      if ((G & 192) != 128 | (g & 192) != 128 || (g = 4, (S << 18 & 1835008 | (o & 48) << 12) >>> 0 > 1114111))
                        break e;
                    }
                    ke = ke + 1 | 0, r = r + g | 0;
                    continue;
                  }
                  break;
                }
                return r - c | 0;
              }
              function Qg(r, o, c, h, y, g, S, G, ke, Fe) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, G = G | 0, ke = ke | 0, Fe = Fe | 0;
                var Ar = 0, hr = 0;
                Ar = Yr - 16 | 0, Yr = Ar, hr = Fe;
                e: {
                  if (r) {
                    Fe = Ar + 4 | 0, r = o6(o), _n[e[e[r >> 2] + 44 >> 2]](Fe, r), o = e[Ar + 4 >> 2], $[c | 0] = o, $[c + 1 | 0] = o >>> 8, $[c + 2 | 0] = o >>> 16, $[c + 3 | 0] = o >>> 24, _n[e[e[r >> 2] + 32 >> 2]](Fe, r), ra(ke, Fe), qi(Fe), _n[e[e[r >> 2] + 28 >> 2]](Fe, r), ra(G, Fe), qi(Fe), $[h | 0] = _n[e[e[r >> 2] + 12 >> 2]](r), $[y | 0] = _n[e[e[r >> 2] + 16 >> 2]](r), _n[e[e[r >> 2] + 20 >> 2]](Fe, r), ra(g, Fe), qi(Fe), _n[e[e[r >> 2] + 24 >> 2]](Fe, r), ra(S, Fe), qi(Ar + 4 | 0), r = _n[e[e[r >> 2] + 36 >> 2]](r) | 0;
                    break e;
                  }
                  Fe = Ar + 4 | 0, r = a6(o), _n[e[e[r >> 2] + 44 >> 2]](Fe, r), o = e[Ar + 4 >> 2], $[c | 0] = o, $[c + 1 | 0] = o >>> 8, $[c + 2 | 0] = o >>> 16, $[c + 3 | 0] = o >>> 24, _n[e[e[r >> 2] + 32 >> 2]](Fe, r), ra(ke, Fe), qi(Fe), _n[e[e[r >> 2] + 28 >> 2]](Fe, r), ra(G, Fe), qi(Fe), $[h | 0] = _n[e[e[r >> 2] + 12 >> 2]](r), $[y | 0] = _n[e[e[r >> 2] + 16 >> 2]](r), _n[e[e[r >> 2] + 20 >> 2]](Fe, r), ra(g, Fe), qi(Fe), _n[e[e[r >> 2] + 24 >> 2]](Fe, r), ra(S, Fe), qi(Ar + 4 | 0), r = _n[e[e[r >> 2] + 36 >> 2]](r) | 0;
                }
                e[hr >> 2] = r, Yr = Ar + 16 | 0;
              }
              function Ug(r, o, c, h, y, g, S, G, ke, Fe) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, G = G | 0, ke = ke | 0, Fe = Fe | 0;
                var Ar = 0, hr = 0;
                Ar = Yr - 16 | 0, Yr = Ar, hr = Fe;
                e: {
                  if (r) {
                    Fe = Ar + 4 | 0, r = u6(o), _n[e[e[r >> 2] + 44 >> 2]](Fe, r), o = e[Ar + 4 >> 2], $[c | 0] = o, $[c + 1 | 0] = o >>> 8, $[c + 2 | 0] = o >>> 16, $[c + 3 | 0] = o >>> 24, _n[e[e[r >> 2] + 32 >> 2]](Fe, r), ja(ke, Fe), qi(Fe), _n[e[e[r >> 2] + 28 >> 2]](Fe, r), ja(G, Fe), qi(Fe), e[h >> 2] = _n[e[e[r >> 2] + 12 >> 2]](r), e[y >> 2] = _n[e[e[r >> 2] + 16 >> 2]](r), _n[e[e[r >> 2] + 20 >> 2]](Fe, r), ra(g, Fe), qi(Fe), _n[e[e[r >> 2] + 24 >> 2]](Fe, r), ja(S, Fe), qi(Fe), r = _n[e[e[r >> 2] + 36 >> 2]](r) | 0;
                    break e;
                  }
                  Fe = Ar + 4 | 0, r = c6(o), _n[e[e[r >> 2] + 44 >> 2]](Fe, r), o = e[Ar + 4 >> 2], $[c | 0] = o, $[c + 1 | 0] = o >>> 8, $[c + 2 | 0] = o >>> 16, $[c + 3 | 0] = o >>> 24, _n[e[e[r >> 2] + 32 >> 2]](Fe, r), ja(ke, Fe), qi(Fe), _n[e[e[r >> 2] + 28 >> 2]](Fe, r), ja(G, Fe), qi(Fe), e[h >> 2] = _n[e[e[r >> 2] + 12 >> 2]](r), e[y >> 2] = _n[e[e[r >> 2] + 16 >> 2]](r), _n[e[e[r >> 2] + 20 >> 2]](Fe, r), ra(g, Fe), qi(Fe), _n[e[e[r >> 2] + 24 >> 2]](Fe, r), ja(S, Fe), qi(Fe), r = _n[e[e[r >> 2] + 36 >> 2]](r) | 0;
                }
                e[hr >> 2] = r, Yr = Ar + 16 | 0;
              }
              function go(r) {
                var o = 0, c = 0, h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0;
                o = e[r + 112 >> 2], h = e[r + 116 >> 2], S = (o | h) != 0, G = o, c = e[r + 4 >> 2], g = e[r + 44 >> 2], o = c - g | 0, ke = o, y = o + e[r + 120 >> 2] | 0, o = e[r + 124 >> 2] + (o >> 31) | 0;
                e: {
                  if (o = y >>> 0 < ke >>> 0 ? o + 1 | 0 : o, !(((o | 0) >= (h | 0) & y >>> 0 >= G >>> 0 | (o | 0) > (h | 0)) & S)) {
                    h = Yr - 16 | 0, Yr = h, c = -1;
                    t: {
                      if (Kh(r) || (_n[e[r + 32 >> 2]](r, h + 15 | 0, 1) | 0) != 1)
                        break t;
                      c = ye[h + 15 | 0];
                    }
                    if (Yr = h + 16 | 0, h = c, (c | 0) >= 0)
                      break e;
                    g = e[r + 44 >> 2], c = e[r + 4 >> 2];
                  }
                  return e[r + 112 >> 2] = -1, e[r + 116 >> 2] = -1, e[r + 104 >> 2] = c, h = g - c | 0, c = h + y | 0, o = (h >> 31) + o | 0, e[r + 120 >> 2] = c, e[r + 124 >> 2] = c >>> 0 < h >>> 0 ? o + 1 | 0 : o, -1;
                }
                c = y + 1 | 0, o = c ? o : o + 1 | 0, G = e[r + 4 >> 2], g = e[r + 8 >> 2], y = e[r + 116 >> 2], ke = y, S = e[r + 112 >> 2];
                e: {
                  if (!(y | S) || (y = S - c | 0, S = ke - (o + (c >>> 0 > S >>> 0) | 0) | 0, Fe = g - G | 0, ke = Fe >> 31, (S | 0) >= (ke | 0) & y >>> 0 >= Fe >>> 0 | (S | 0) > (ke | 0)))
                    break e;
                  g = y + G | 0;
                }
                return e[r + 104 >> 2] = g, y = e[r + 44 >> 2], g = y - G | 0, c = g + c | 0, o = (g >> 31) + o | 0, e[r + 120 >> 2] = c, e[r + 124 >> 2] = c >>> 0 < g >>> 0 ? o + 1 | 0 : o, y >>> 0 >= G >>> 0 && ($[G - 1 | 0] = h), h;
              }
              function Mg(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0;
                S = Yr - 16 | 0, Yr = S;
                e: {
                  t: {
                    if ((o | 0) != -1) {
                      if (ke = e[r + 8 >> 2], Fe = e[r + 12 >> 2], h = e[r + 24 >> 2], (h | 0) == e[r + 28 >> 2]) {
                        if (y = -1, !(ye[r + 48 | 0] & 16))
                          break e;
                        if (Ar = e[r + 44 >> 2], G = e[r + 20 >> 2], e[5996] = 0, c = r + 32 | 0, di(98, c | 0, 0), g = e[5996], e[5996] = 0, (g | 0) == 1 || (g = (ye[c + 11 | 0] & 128) >>> 7 | 0 ? (e[c + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, c | 0, g | 0), g = e[5996], e[5996] = 0, (g | 0) == 1))
                          break t;
                        c = (ye[c + 11 | 0] & 128) >>> 7 | 0 ? e[c >> 2] : c, y = ye[r + 43 | 0], e[r + 28 >> 2] = c + ((y & 128) >>> 7 | 0 ? e[r + 36 >> 2] : y & 127), e[r + 20 >> 2] = c, e[r + 24 >> 2] = c, e[r + 24 >> 2] = e[r + 24 >> 2] + (h - G | 0), e[r + 44 >> 2] = e[r + 20 >> 2] + (Ar - G | 0), h = e[r + 24 >> 2];
                      }
                      e[S + 12 >> 2] = h + 1, h = r + 44 | 0, c = S + 12 | 0, c = e[(Ps[c >> 2] < Ps[h >> 2] ? h : c) >> 2], e[r + 44 >> 2] = c, ye[r + 48 | 0] & 8 && (h = r + 32 | 0, h = (ye[h + 11 | 0] & 128) >>> 7 | 0 ? e[h >> 2] : h, e[r + 16 >> 2] = c, e[r + 12 >> 2] = h + (Fe - ke | 0), e[r + 8 >> 2] = h), y = Df(r, o << 24 >> 24);
                      break e;
                    }
                    y = (o | 0) != -1 ? o : 0;
                    break e;
                  }
                  yu(Ts(0) | 0) | 0, Wu();
                }
                return Yr = S + 16 | 0, y | 0;
              }
              function lh(r, o, c, h) {
                var y = 0, g = 0, S = 0, G = 0;
                S = Yr - 32 | 0, Yr = S, g = h & 2147483647, y = g - 1065418752 | 0, G = g - 1082064896 | 0;
                e: {
                  if ((y | 0) == (G | 0) & 0 | y >>> 0 < G >>> 0) {
                    if (g = (h & 33554431) << 7 | c >>> 25, y = 0, G = y, c = c & 33554431, !(!y & (c | 0) == 16777216 ? !(r | o) : !y & c >>> 0 < 16777216)) {
                      y = g + 1073741825 | 0;
                      break e;
                    }
                    if (y = g + 1073741824 | 0, c ^ 16777216 | r | (o | G))
                      break e;
                    y = (g & 1) + y | 0;
                    break e;
                  }
                  if (!(!c & (g | 0) == 2147418112 ? !(r | o) : g >>> 0 < 2147418112)) {
                    y = ((h & 33554431) << 7 | c >>> 25) & 4194303 | 2143289344;
                    break e;
                  }
                  if (y = 2139095040, g >>> 0 > 1082064895 || (y = 0, g = g >>> 16 | 0, g >>> 0 < 16145))
                    break e;
                  if (y = h & 65535 | 65536, ha(S + 16 | 0, r, o, c, y, g - 16129 | 0), Ac(S, r, o, c, y, 16257 - g | 0), r = e[S + 8 >> 2], y = (e[S + 12 >> 2] & 33554431) << 7 | r >>> 25, c = e[S >> 2] | (e[S + 16 >> 2] | e[S + 24 >> 2] | (e[S + 20 >> 2] | e[S + 28 >> 2])) != 0, g = e[S + 4 >> 2], o = 0, r = r & 33554431, !(!o & (r | 0) == 16777216 ? !(c | g) : !o & r >>> 0 < 16777216)) {
                    y = y + 1 | 0;
                    break e;
                  }
                  if (r ^ 16777216 | c | (o | g))
                    break e;
                  y = (y & 1) + y | 0;
                }
                return Yr = S + 32 | 0, jo(2, h & -2147483648 | y), io();
              }
              function _l(r, o, c) {
                var h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0;
                e: {
                  t: {
                    r: {
                      n: {
                        i: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  f: {
                                    if (o) {
                                      if (!c)
                                        break f;
                                      break l;
                                    }
                                    vs = 0, r = (r >>> 0) / (c >>> 0) | 0;
                                    break e;
                                  }
                                  if (!r)
                                    break o;
                                  break a;
                                }
                                if (!(c - 1 & c))
                                  break s;
                                g = (Do(c) + 33 | 0) - Do(o) | 0, S = 0 - g | 0;
                                break n;
                              }
                              vs = 0, r = (o >>> 0) / 0 | 0;
                              break e;
                            }
                            if (h = 32 - Do(o) | 0, h >>> 0 < 31)
                              break i;
                            break r;
                          }
                          if ((c | 0) == 1)
                            break t;
                          g = c ? 31 - Do(c - 1 ^ c) | 0 : 32, c = g & 31, (g & 63) >>> 0 >= 32 ? r = o >>> c | 0 : (h = o >>> c | 0, r = ((1 << c) - 1 & o) << 32 - c | r >>> c), vs = h;
                          break e;
                        }
                        g = h + 1 | 0, S = 63 - h | 0;
                      }
                      if (h = g & 63, y = h & 31, h >>> 0 >= 32 ? (h = 0, G = o >>> y | 0) : (h = o >>> y | 0, G = ((1 << y) - 1 & o) << 32 - y | r >>> y), S = S & 63, y = S & 31, S >>> 0 >= 32 ? (o = r << y, r = 0) : (o = (1 << y) - 1 & r >>> 32 - y | o << y, r = r << y), g)
                        for (S = c - 1 | 0, hr = (S | 0) == -1 ? -1 : 0; ke = h << 1 | G >>> 31, h = G << 1 | o >>> 31, y = hr - (ke + (h >>> 0 > S >>> 0) | 0) >> 31, Fe = c & y, G = h - Fe | 0, h = ke - (h >>> 0 < Fe >>> 0) | 0, o = o << 1 | r >>> 31, r = Ar | r << 1, Ar = y & 1, g = g - 1 | 0, !!g; )
                          ;
                      vs = o << 1 | r >>> 31, r = Ar | r << 1;
                      break e;
                    }
                    r = 0, o = 0;
                  }
                  vs = o;
                }
                return r;
              }
              function Fg(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0;
                ke = e[o + 44 >> 2], Fe = e[o + 24 >> 2], ke >>> 0 < Fe >>> 0 && (e[o + 44 >> 2] = Fe, ke = Fe), Tr = -1, ln = -1, Rn = g & 24;
                e: {
                  if (!Rn | (y | 0) == 1 & (Rn | 0) == 24)
                    break e;
                  ke && (S = o + 32 | 0, S = ke - ((ye[S + 11 | 0] & 128) >>> 7 | 0 ? e[S >> 2] : S) | 0, Ar = S >> 31);
                  t: {
                    r:
                      switch (y | 0) {
                        case 1:
                          if (g & 8) {
                            G = e[o + 12 >> 2] - e[o + 8 >> 2] | 0, hr = G >> 31;
                            break t;
                          }
                          G = Fe - e[o + 20 >> 2] | 0, hr = G >> 31;
                          break t;
                        case 0:
                          break t;
                        case 2:
                          break r;
                        default:
                          break e;
                      }
                    G = S, hr = Ar;
                  }
                  if (h = h + hr | 0, c = c + G | 0, h = G >>> 0 > c >>> 0 ? h + 1 | 0 : h, (h | 0) < 0 | (c >>> 0 > S >>> 0 & (h | 0) >= (Ar | 0) | (h | 0) > (Ar | 0)))
                    break e;
                  y = g & 8;
                  t: {
                    if (!(c | h))
                      break t;
                    if (!e[o + 12 >> 2] && y)
                      break e;
                    if (!(g & 16))
                      break t;
                    if (!Fe)
                      break e;
                  }
                  y && (y = e[o + 8 >> 2], e[o + 16 >> 2] = ke, e[o + 12 >> 2] = c + y, e[o + 8 >> 2] = y), g & 16 && (y = e[o + 20 >> 2], e[o + 28 >> 2] = e[o + 28 >> 2], e[o + 20 >> 2] = y, e[o + 24 >> 2] = y, e[o + 24 >> 2] = c + e[o + 24 >> 2]), Tr = c, ln = h;
                }
                e[r + 8 >> 2] = Tr, e[r + 12 >> 2] = ln, e[r >> 2] = 0, e[r + 4 >> 2] = 0;
              }
              function Zl(r) {
                var o = 0, c = 0, h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0;
                o = r;
                e: {
                  if (o & 3)
                    for (; ; ) {
                      if (c = ye[o | 0], !c | (c | 0) == 61)
                        break e;
                      if (o = o + 1 | 0, !(o & 3))
                        break;
                    }
                  c = e[o >> 2];
                  t: {
                    if ((c ^ -1) & c - 16843009 & -2139062144)
                      break t;
                    for (; ; ) {
                      if ((c ^ 1027423549) - 16843009 & (c ^ -1) & -2139062144)
                        break t;
                      if (c = e[o + 4 >> 2], o = o + 4 | 0, !!(c - 16843009 & (c ^ -1) & -2139062144))
                        break;
                    }
                  }
                  for (; c = o, h = ye[o | 0], !!((h | 0) != 61 && (o = o + 1 | 0, h)); )
                    ;
                  o = c;
                }
                if ((r | 0) == (o | 0))
                  return 0;
                g = o - r | 0;
                e: {
                  if (ye[g + r | 0] || (y = e[6181], !y) || (o = e[y >> 2], !o))
                    break e;
                  for (; ; ) {
                    t: {
                      S = r, c = o, G = g, h = 0;
                      r: {
                        if (!g)
                          break r;
                        if (h = ye[r | 0], h)
                          n: {
                            for (; ; ) {
                              if (ke = ye[c | 0], (ke | 0) != (h | 0) | !ke || (G = G - 1 | 0, !G))
                                break n;
                              if (c = c + 1 | 0, h = ye[S + 1 | 0], S = S + 1 | 0, !h)
                                break;
                            }
                            h = 0;
                          }
                        else
                          h = 0;
                        h = h - ye[c | 0] | 0;
                      }
                      if (!h && (o = o + g | 0, ye[o | 0] == 61))
                        break t;
                      if (o = e[y + 4 >> 2], y = y + 4 | 0, o)
                        continue;
                      break e;
                    }
                    break;
                  }
                  Fe = o + 1 | 0;
                }
                return Fe;
              }
              function tu(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0;
                h = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24);
                e: {
                  t: {
                    r: {
                      if (o >>> 0 <= 28) {
                        if (h >>> 0 < 29)
                          break r;
                        o = ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24), _s(r + 4 | 0, o, h - 29 | 0), Sr(o), o = (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) - 29 | 0, $[r | 0] = o, $[r + 1 | 0] = o >>> 8, $[r + 2 | 0] = o >>> 16, $[r + 3 | 0] = o >>> 24;
                        return;
                      }
                      if (h >>> 0 >= 29) {
                        if (c = of(ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24), o), $[r + 8 | 0] = c, $[r + 9 | 0] = c >>> 8, $[r + 10 | 0] = c >>> 16, $[r + 11 | 0] = c >>> 24, !c)
                          break t;
                        $[r + 4 | 0] = o, $[r + 5 | 0] = o >>> 8, $[r + 6 | 0] = o >>> 16, $[r + 7 | 0] = o >>> 24;
                        return;
                      }
                      if (c = ia(o), !c)
                        break e;
                      c = _s(c, r + 4 | 0, h), $[r + 4 | 0] = o, $[r + 5 | 0] = o >>> 8, $[r + 6 | 0] = o >>> 16, $[r + 7 | 0] = o >>> 24, $[r + 8 | 0] = c, $[r + 9 | 0] = c >>> 8, $[r + 10 | 0] = c >>> 16, $[r + 11 | 0] = c >>> 24, o = h + 29 | 0, $[r | 0] = o, $[r + 1 | 0] = o >>> 8, $[r + 2 | 0] = o >>> 16, $[r + 3 | 0] = o >>> 24;
                    }
                    return;
                  }
                  aa(1370, 2249, 181, 1040), ri();
                }
                aa(1357, 2249, 185, 1040), ri();
              }
              function Jf(r, o, c, h) {
                var y = 0, g = 0, S = 0;
                y = Yr - 160 | 0, Yr = y, g = o ? r : y + 158 | 0, e[y + 148 >> 2] = g, r = -1, S = o - 1 | 0, e[y + 152 >> 2] = o >>> 0 >= S >>> 0 ? S : 0, y = Ya(y, 0, 144), e[y + 76 >> 2] = -1, e[y + 36 >> 2] = 179, e[y + 80 >> 2] = -1, e[y + 44 >> 2] = y + 159, e[y + 84 >> 2] = y + 148;
                e: {
                  if ((o | 0) < 0) {
                    e[5732] = 61;
                    break e;
                  }
                  $[g | 0] = 0, g = 0, o = Yr - 208 | 0, Yr = o, e[o + 204 >> 2] = h, r = o + 160 | 0, Ya(r, 0, 40), e[o + 200 >> 2] = e[o + 204 >> 2];
                  t: {
                    if ((Pl(0, c, o + 200 | 0, o + 80 | 0, r) | 0) < 0) {
                      r = -1;
                      break t;
                    }
                    h = e[y + 76 >> 2] >= 0, S = e[y >> 2], e[y >> 2] = S & -33;
                    r: {
                      n: {
                        i: {
                          if (!e[y + 48 >> 2]) {
                            e[y + 48 >> 2] = 80, e[y + 28 >> 2] = 0, e[y + 16 >> 2] = 0, e[y + 20 >> 2] = 0, g = e[y + 44 >> 2], e[y + 44 >> 2] = o;
                            break i;
                          }
                          if (e[y + 16 >> 2])
                            break n;
                        }
                        if (r = -1, vf(y))
                          break r;
                      }
                      r = Pl(y, c, o + 200 | 0, o + 80 | 0, o + 160 | 0);
                    }
                    if (c = r, g && (_n[e[y + 36 >> 2]](y, 0, 0) | 0, e[y + 48 >> 2] = 0, e[y + 44 >> 2] = g, e[y + 28 >> 2] = 0, r = e[y + 20 >> 2], e[y + 16 >> 2] = 0, e[y + 20 >> 2] = 0, c = r ? c : -1), r = e[y >> 2], e[y >> 2] = r | S & 32, r = r & 32 ? -1 : c, !h)
                      break t;
                  }
                  Yr = o + 208 | 0;
                }
                return Yr = y + 160 | 0, r;
              }
              function Lg(r, o, c, h, y, g, S) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0;
                var G = 0, ke = 0;
                for (G = Yr - 416 | 0, Yr = G, h = G + 416 | 0, e[G + 12 >> 2] = h, c = Yr - 144 | 0, Yr = c, e[c + 28 >> 2] = c + 132, ke = c + 32 | 0, Rp(e[r + 8 >> 2], ke, c + 28 | 0, y, g, S), e[c + 16 >> 2] = 0, e[c + 20 >> 2] = 0, e[c + 12 >> 2] = ke, y = G + 16 | 0, S = e[G + 12 >> 2] - y >> 2, g = Yr - 16 | 0, Yr = g, r = xu(g + 12 | 0, e[r + 8 >> 2]), S = ih(y, c + 12 | 0, S, c + 16 | 0), r = e[r >> 2], r && (e[6178] = (r | 0) == -1 ? 24816 : r), Yr = g + 16 | 0, (S | 0) == -1 && (Sf(2472), ri()), e[G + 12 >> 2] = y + (S << 2), Yr = c + 144 | 0, c = Yr - 16 | 0, Yr = c, r = Yr - 32 | 0, Yr = r, g = Yr - 16 | 0, Yr = g, e[g + 12 >> 2] = e[G + 12 >> 2], e[r + 24 >> 2] = y, e[r + 28 >> 2] = e[g + 12 >> 2], Yr = g + 16 | 0, g = e[r + 24 >> 2], S = e[r + 28 >> 2], y = Yr - 16 | 0, Yr = y, e[y + 12 >> 2] = o; ; ) {
                  if ((g | 0) != (S | 0)) {
                    ul(y + 12 | 0, e[g >> 2]), g = g + 4 | 0;
                    continue;
                  }
                  break;
                }
                return e[r + 16 >> 2] = S, e[r + 20 >> 2] = e[y + 12 >> 2], Yr = y + 16 | 0, o = e[r + 16 >> 2], e[r + 12 >> 2] = e[r + 20 >> 2], e[c + 8 >> 2] = o, e[c + 12 >> 2] = e[r + 12 >> 2], Yr = r + 32 | 0, Yr = c + 16 | 0, Yr = h, e[c + 12 >> 2];
              }
              function kc(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0;
                y = Yr - 32 | 0, Yr = y, G = y + 32 | 0, c = G, h = y + 21 | 0, g = c - h | 0;
                e: {
                  if ((g | 0) <= 9 && (ke = g, g = vi(32 - Do(o | 1) | 0, 1233) >>> 12 | 0, S = 61, (ke | 0) < ((Ps[(g << 2) + 21616 >> 2] <= o >>> 0) + g | 0)))
                    break e;
                  t: {
                    if (o >>> 0 <= 999999) {
                      if (o >>> 0 <= 9999) {
                        if (o >>> 0 <= 99) {
                          if (o >>> 0 <= 9) {
                            $[h | 0] = o + 48, c = h + 1 | 0;
                            break t;
                          }
                          c = Pf(h, o);
                          break t;
                        }
                        if (o >>> 0 <= 999) {
                          c = (o >>> 0) / 100 | 0, $[h | 0] = c + 48, c = Pf(h + 1 | 0, vi(c, -100) + o | 0);
                          break t;
                        }
                        c = Ms(h, o);
                        break t;
                      }
                      if (o >>> 0 <= 99999) {
                        c = (o >>> 0) / 1e4 | 0, $[h | 0] = c + 48, c = Ms(h + 1 | 0, vi(c, -1e4) + o | 0);
                        break t;
                      }
                      c = Os(h, o);
                      break t;
                    }
                    if (o >>> 0 <= 99999999) {
                      if (o >>> 0 <= 9999999) {
                        c = (o >>> 0) / 1e6 | 0, $[h | 0] = c + 48, c = Os(h + 1 | 0, vi(c, -1e6) + o | 0);
                        break t;
                      }
                      c = Hs(h, o);
                      break t;
                    }
                    if (o >>> 0 <= 999999999) {
                      c = (o >>> 0) / 1e8 | 0, $[h | 0] = c + 48, c = Hs(h + 1 | 0, vi(c, -1e8) + o | 0);
                      break t;
                    }
                    c = (o >>> 0) / 1e8 | 0, c = Hs(Pf(h, c), vi(c, -1e8) + o | 0);
                  }
                  S = 0;
                }
                e[y + 16 >> 2] = S, e[y + 12 >> 2] = c, rl(r, h, e[y + 12 >> 2]), Yr = G;
              }
              function $l(r, o, c) {
                var h = 0, y = 0, g = 0, S = 0;
                if (h = r + 4 | 0, y = (h + o | 0) - 1 & 0 - o, o = e[r >> 2], y + c >>> 0 <= (o + r | 0) - 4 >>> 0) {
                  g = e[r + 4 >> 2], e[g + 8 >> 2] = e[r + 8 >> 2], e[e[r + 8 >> 2] + 4 >> 2] = g, (h | 0) != (y | 0) && (y = y - h | 0, g = r - (e[r - 4 >> 2] & -2) | 0, h = y + e[g >> 2] | 0, e[g >> 2] = h, e[(g + (h & -4) | 0) - 4 >> 2] = h, r = r + y | 0, o = o - y | 0, e[r >> 2] = o);
                  e: {
                    if (c + 24 >>> 0 <= o >>> 0) {
                      h = (r + c | 0) + 8 | 0, o = (o - c | 0) - 8 | 0, e[h >> 2] = o, e[(h + (o & -4) | 0) - 4 >> 2] = o | 1, y = e[h >> 2] - 8 | 0;
                      t: {
                        if (y >>> 0 <= 127) {
                          o = (y >>> 3 | 0) - 1 | 0;
                          break t;
                        }
                        if (g = Do(y), o = ((y >>> 29 - g ^ 4) - (g << 2) | 0) + 110 | 0, y >>> 0 <= 4095)
                          break t;
                        o = ((y >>> 30 - g ^ 2) - (g << 1) | 0) + 71 | 0, o = o >>> 0 >= 63 ? 63 : o;
                      }
                      y = o << 4, e[h + 4 >> 2] = y + 22944, y = y + 22952 | 0, e[h + 8 >> 2] = e[y >> 2], e[y >> 2] = h, e[e[h + 8 >> 2] + 4 >> 2] = h, y = e[5994], g = e[5995], h = o & 31, (o & 63) >>> 0 >= 32 ? (o = 1 << h, h = 0) : (S = 1 << h, o = S - 1 & 1 >>> 32 - h, h = S), e[5994] = h | y, e[5995] = o | g, o = c + 8 | 0, e[r >> 2] = o, e[((o & -4) + r | 0) - 4 >> 2] = o;
                      break e;
                    }
                    e[(r + o | 0) - 4 >> 2] = o;
                  }
                  r = r + 4 | 0;
                } else
                  r = 0;
                return r;
              }
              function Hg(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0;
                e: {
                  t: {
                    r: {
                      if (h = e[r >> 2], g = (e[r + 4 >> 2] - h | 0) / 12 | 0, c = g + 1 | 0, c >>> 0 < 357913942) {
                        if (h = (e[r + 8 >> 2] - h | 0) / 12 | 0, S = h << 1, h = h >>> 0 >= 178956970 ? 357913941 : c >>> 0 < S >>> 0 ? S : c, h) {
                          if (h >>> 0 >= 357913942)
                            break r;
                          y = xs(vi(h, 12));
                        }
                        if (c = vi(g, 12) + y | 0, g = e[o + 4 >> 2], e[c >> 2] = e[o >> 2], e[c + 4 >> 2] = g, e[c + 8 >> 2] = e[o + 8 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, y = vi(h, 12) + y | 0, h = c + 12 | 0, o = e[r + 4 >> 2], g = e[r >> 2], (o | 0) == (g | 0))
                          break t;
                        for (; o = o - 12 | 0, S = e[o + 4 >> 2], c = c - 12 | 0, e[c >> 2] = e[o >> 2], e[c + 4 >> 2] = S, e[c + 8 >> 2] = e[o + 8 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, (o | 0) != (g | 0); )
                          ;
                        if (e[r + 8 >> 2] = y, y = e[r + 4 >> 2], e[r + 4 >> 2] = h, o = e[r >> 2], e[r >> 2] = c, (o | 0) == (y | 0))
                          break e;
                        for (; r = y - 12 | 0, $[y - 1 | 0] < 0 && Sr(e[r >> 2]), y = r, (r | 0) != (o | 0); )
                          ;
                        break e;
                      }
                      Lo(), ri();
                    }
                    su(), ri();
                  }
                  e[r + 8 >> 2] = y, e[r + 4 >> 2] = h, e[r >> 2] = c;
                }
                o && Sr(o);
              }
              function hh(r, o, c, h) {
                var y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0, Tr = 0, ln = 0, Rn = 0;
                ke = Yr - 32 | 0, Yr = ke;
                e: {
                  t: {
                    r: {
                      if ((o | 0) != (c | 0)) {
                        if (Ar = e[5732], e[5732] = 0, S = Yr - 16 | 0, Yr = S, mo(), g = Yr - 16 | 0, Yr = g, y = Yr - 16 | 0, Yr = y, wd(y, o, ke + 28 | 0, 2), G = e[y >> 2], Fe = e[y + 4 >> 2], o = g, g = e[y + 12 >> 2], e[o + 8 >> 2] = e[y + 8 >> 2], e[o + 12 >> 2] = g, e[o >> 2] = G, e[o + 4 >> 2] = Fe, Yr = y + 16 | 0, g = e[o >> 2], G = e[o + 4 >> 2], y = S, S = e[o + 12 >> 2], e[y + 8 >> 2] = e[o + 8 >> 2], e[y + 12 >> 2] = S, e[y >> 2] = g, e[y + 4 >> 2] = G, Yr = o + 16 | 0, S = e[y >> 2], g = e[y + 4 >> 2], G = e[y + 12 >> 2], o = ke, e[o + 16 >> 2] = e[y + 8 >> 2], e[o + 20 >> 2] = G, e[o + 8 >> 2] = S, e[o + 12 >> 2] = g, Yr = y + 16 | 0, y = e[o + 16 >> 2], g = e[o + 20 >> 2], S = e[o + 8 >> 2], G = e[o + 12 >> 2], Fe = e[5732], !Fe)
                          break r;
                        if (e[o + 28 >> 2] != (c | 0))
                          break t;
                        if (hr = S, Tr = G, ln = y, Rn = g, (Fe | 0) != 68)
                          break e;
                        break t;
                      }
                      e[h >> 2] = 4;
                      break e;
                    }
                    if (e[5732] = Ar, e[ke + 28 >> 2] == (c | 0))
                      break e;
                  }
                  e[h >> 2] = 4, S = hr, G = Tr, y = ln, g = Rn;
                }
                e[r >> 2] = S, e[r + 4 >> 2] = G, e[r + 8 >> 2] = y, e[r + 12 >> 2] = g, Yr = ke + 32 | 0;
              }
              function k4(r, o, c, h) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0;
                var y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0;
                if (g = e[r + 4 >> 2], y = e[r + 8 >> 2], g >>> 0 < y >>> 0) {
                  e[g >> 2] = o, e[g + 8 >> 2] = c, e[g + 12 >> 2] = c >> 31, o = e[h + 4 >> 2], e[g + 16 >> 2] = e[h >> 2], e[g + 20 >> 2] = o, e[r + 4 >> 2] = g + 24;
                  return;
                }
                e: {
                  if (ke = e[r >> 2], S = (g - ke | 0) / 24 | 0, G = S + 1 | 0, G >>> 0 < 178956971) {
                    if (Fe = vi(S, 24), y = (y - ke | 0) / 24 | 0, S = y << 1, S = y >>> 0 >= 89478485 ? 178956970 : S >>> 0 > G >>> 0 ? S : G, S) {
                      if (S >>> 0 >= 178956971)
                        break e;
                      G = xs(vi(S, 24));
                    } else
                      G = 0;
                    if (y = Fe + G | 0, e[y + 8 >> 2] = c, e[y + 12 >> 2] = c >> 31, e[y >> 2] = o, o = e[h + 4 >> 2], e[y + 16 >> 2] = e[h >> 2], e[y + 20 >> 2] = o, o = y + 24 | 0, (g | 0) != (ke | 0)) {
                      for (; g = g - 24 | 0, h = e[g + 4 >> 2], y = y - 24 | 0, e[y >> 2] = e[g >> 2], e[y + 4 >> 2] = h, c = e[g + 20 >> 2], e[y + 16 >> 2] = e[g + 16 >> 2], e[y + 20 >> 2] = c, c = e[g + 12 >> 2], e[y + 8 >> 2] = e[g + 8 >> 2], e[y + 12 >> 2] = c, (g | 0) != (ke | 0); )
                        ;
                      g = e[r >> 2];
                    }
                    e[r + 8 >> 2] = G + vi(S, 24), e[r + 4 >> 2] = o, e[r >> 2] = y, g && Sr(g);
                    return;
                  }
                  Lo(), ri();
                }
                su(), ri();
              }
              function S4(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0;
                var g = 0;
                g = Yr - 32 | 0, Yr = g, e[g + 28 >> 2] = o;
                e: {
                  if (!($[c + 4 | 0] & 1)) {
                    c = _n[e[e[r >> 2] + 24 >> 2]](r, o, c, h, y) | 0;
                    break e;
                  }
                  h = g + 16 | 0, r = e[c + 28 >> 2], e[h >> 2] = r, e[r + 4 >> 2] = e[r + 4 >> 2] + 1, e[5996] = 0, r = ii(198, e[g + 16 >> 2]) | 0, o = e[5996], e[5996] = 0;
                  t: {
                    if ((o | 0) != 1) {
                      o = e[h >> 2], c = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = c, (c | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o);
                      r: {
                        if (y) {
                          _n[e[e[r >> 2] + 24 >> 2]](h, r);
                          break r;
                        }
                        _n[e[e[r >> 2] + 28 >> 2]](g + 16 | 0, r);
                      }
                      for (e[g + 12 >> 2] = Qa(g + 16 | 0); ; ) {
                        if (r = g + 16 | 0, c = Ia(r), o = e[g + 12 >> 2], (c | 0) == (o | 0)) {
                          c = e[g + 28 >> 2], qi(r);
                          break e;
                        }
                        if (r = e[o >> 2], e[5996] = 0, On(214, g + 28 | 0, r | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1) {
                          e[g + 12 >> 2] = e[g + 12 >> 2] + 4;
                          continue;
                        }
                        break;
                      }
                      c = Vr() | 0, qi(g + 16 | 0);
                      break t;
                    }
                    c = Vr() | 0, r = e[g + 16 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r);
                  }
                  Ki(c | 0), ri();
                }
                return Yr = g + 32 | 0, c | 0;
              }
              function T4(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0;
                var g = 0;
                g = Yr - 32 | 0, Yr = g, e[g + 28 >> 2] = o;
                e: {
                  if (!($[c + 4 | 0] & 1)) {
                    c = _n[e[e[r >> 2] + 24 >> 2]](r, o, c, h, y) | 0;
                    break e;
                  }
                  h = g + 16 | 0, r = e[c + 28 >> 2], e[h >> 2] = r, e[r + 4 >> 2] = e[r + 4 >> 2] + 1, e[5996] = 0, r = ii(180, e[g + 16 >> 2]) | 0, o = e[5996], e[5996] = 0;
                  t: {
                    if ((o | 0) != 1) {
                      o = e[h >> 2], c = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = c, (c | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o);
                      r: {
                        if (y) {
                          _n[e[e[r >> 2] + 24 >> 2]](h, r);
                          break r;
                        }
                        _n[e[e[r >> 2] + 28 >> 2]](g + 16 | 0, r);
                      }
                      for (e[g + 12 >> 2] = Qa(g + 16 | 0); ; ) {
                        if (r = g + 16 | 0, c = gu(r), o = e[g + 12 >> 2], (c | 0) == (o | 0)) {
                          c = e[g + 28 >> 2], qi(r);
                          break e;
                        }
                        if (r = $[o | 0], e[5996] = 0, On(210, g + 28 | 0, r | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1) {
                          e[g + 12 >> 2] = e[g + 12 >> 2] + 1;
                          continue;
                        }
                        break;
                      }
                      c = Vr() | 0, qi(g + 16 | 0);
                      break t;
                    }
                    c = Vr() | 0, r = e[g + 16 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r);
                  }
                  Ki(c | 0), ri();
                }
                return Yr = g + 32 | 0, c | 0;
              }
              function x4(r, o, c, h) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0;
                var y = 0, g = 0, S = 0, G = 0;
                g = Yr - 32 | 0, Yr = g, e[g + 24 >> 2] = h, $[g + 20 | 0] = 0, e[g + 8 >> 2] = r, e[g + 16 >> 2] = g + 28, e[g + 12 >> 2] = g + 24;
                e: {
                  t: {
                    r: {
                      if ((o | 0) != (c | 0))
                        for (; ; ) {
                          if (e[h + 8 >> 2] = 0, e[h >> 2] = 0, e[h + 4 >> 2] = 0, r = e[o + 4 >> 2], y = e[o >> 2], (r | 0) != (y | 0)) {
                            if (y = r - y | 0, (y | 0) < 0) {
                              if (e[5996] = 0, e[g + 28 >> 2] = h, Ri(84), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                break r;
                              ri();
                            }
                            if (e[5996] = 0, r = ii(3, y | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                              break t;
                            if (e[h + 4 >> 2] = r, e[h >> 2] = r, e[h + 8 >> 2] = (y & -8) + r, y = e[o >> 2], S = e[o + 4 >> 2], (y | 0) != (S | 0))
                              for (; G = e[y + 4 >> 2], e[r >> 2] = e[y >> 2], e[r + 4 >> 2] = G, r = r + 8 | 0, y = y + 8 | 0, (S | 0) != (y | 0); )
                                ;
                            e[h + 4 >> 2] = r;
                          }
                          if (h = h + 12 | 0, o = o + 12 | 0, (c | 0) == (o | 0))
                            break;
                        }
                      return Yr = g + 32 | 0, h | 0;
                    }
                    if (r = Vr() | 0, o = e[h >> 2], !o)
                      break e;
                    e[h + 4 >> 2] = o, Sr(o);
                    break e;
                  }
                  r = Vr() | 0, e[g + 28 >> 2] = h;
                }
                Ed(g + 8 | 0), Ki(r | 0), ri();
              }
              function R4(r, o, c, h) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0;
                var y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0;
                if (g = e[r + 4 >> 2], y = e[r + 8 >> 2], g >>> 0 < y >>> 0) {
                  e[g >> 2] = o, e[g + 16 >> 2] = h, e[g + 20 >> 2] = h >> 31, e[g + 8 >> 2] = c, e[g + 12 >> 2] = c >> 31, e[r + 4 >> 2] = g + 24;
                  return;
                }
                e: {
                  if (ke = e[r >> 2], S = (g - ke | 0) / 24 | 0, G = S + 1 | 0, G >>> 0 < 178956971) {
                    if (Fe = vi(S, 24), y = (y - ke | 0) / 24 | 0, S = y << 1, S = y >>> 0 >= 89478485 ? 178956970 : S >>> 0 > G >>> 0 ? S : G, S) {
                      if (S >>> 0 >= 178956971)
                        break e;
                      G = xs(vi(S, 24));
                    } else
                      G = 0;
                    if (y = Fe + G | 0, e[y + 16 >> 2] = h, e[y + 20 >> 2] = h >> 31, e[y + 8 >> 2] = c, e[y + 12 >> 2] = c >> 31, e[y >> 2] = o, o = y + 24 | 0, (g | 0) != (ke | 0)) {
                      for (; g = g - 24 | 0, h = e[g + 4 >> 2], y = y - 24 | 0, e[y >> 2] = e[g >> 2], e[y + 4 >> 2] = h, c = e[g + 20 >> 2], e[y + 16 >> 2] = e[g + 16 >> 2], e[y + 20 >> 2] = c, c = e[g + 12 >> 2], e[y + 8 >> 2] = e[g + 8 >> 2], e[y + 12 >> 2] = c, (g | 0) != (ke | 0); )
                        ;
                      g = e[r >> 2];
                    }
                    e[r + 8 >> 2] = G + vi(S, 24), e[r + 4 >> 2] = o, e[r >> 2] = y, g && Sr(g);
                    return;
                  }
                  Lo(), ri();
                }
                su(), ri();
              }
              function df(r, o, c, h) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0;
                var y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0;
                S = h, h = Da(h), ke = Yr - 16 | 0, Yr = ke, e[ke + 12 >> 2] = c, c = r;
                e: {
                  t: {
                    if (y = e[r + 4 >> 2], r = ye[r + 11 | 0], G = (r & 128) >>> 7 | 0 ? y : r & 127, G >>> 0 >= o >>> 0) {
                      if (y = G - o | 0, e[ke + 8 >> 2] = y, r = ke + 8 | 0, g = ke + 12 | 0, r = e[(Ps[r >> 2] < Ps[g >> 2] ? r : g) >> 2], g = (ye[c + 11 | 0] & 128) >>> 7 | 0 ? (e[c + 8 >> 2] & 2147483647) - 1 | 0 : 10, r + (g - G | 0) >>> 0 >= h >>> 0) {
                        g = (ye[c + 11 | 0] & 128) >>> 7 | 0 ? e[c >> 2] : c;
                        r: {
                          if ((r | 0) == (h | 0)) {
                            r = h;
                            break r;
                          }
                          if ((r | 0) == (y | 0)) {
                            r = y;
                            break r;
                          }
                          if (Fe = y - r | 0, y = o + g | 0, r >>> 0 > h >>> 0)
                            break t;
                          n: {
                            if (g + G >>> 0 <= S >>> 0 | y >>> 0 >= S >>> 0)
                              break n;
                            if (r + y >>> 0 <= S >>> 0) {
                              S = (h - r | 0) + S | 0;
                              break n;
                            }
                            Jc(y, S, r), y = h - r | 0, S = h + S | 0, o = r + o | 0, r = 0, h = y;
                          }
                          y = o + g | 0, Jc(y + h | 0, r + y | 0, Fe);
                        }
                        Jc(o + g | 0, S, h), Gc(c, g, (h + G | 0) - r | 0);
                        break e;
                      }
                      Rc(c, g, h + G - (r + g) | 0, G, o, r, h, S);
                      break e;
                    }
                    tc(), ri();
                  }
                  o = Jc(y, S, h), Jc(o + h | 0, r + o | 0, Fe), Gc(c, g, (h + G | 0) - r | 0);
                }
                Yr = ke + 16 | 0;
              }
              function D4(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0;
                G = Yr - 16 | 0, Yr = G, h = ye[r + 11 | 0], y = h & 127, h = (h & 128) >>> 7 | 0, y = h ? e[r + 4 >> 2] : y, h = h ? (e[r + 8 >> 2] & 2147483647) - 1 | 0 : 1, g = c - o >> 2;
                e: {
                  if (!g)
                    break e;
                  t: {
                    if (S = ye[r + 11 | 0], ke = (S & 128) >>> 7 | 0 ? e[r >> 2] : r, ke >>> 0 <= o >>> 0 ? S = (((S & 128) >>> 7 | 0 ? e[r + 4 >> 2] : S & 127) << 2) + ke >>> 0 >= o >>> 0 : S = 0, !S)
                      for (h - y >>> 0 < g >>> 0 && Sh(r, h, (y - h | 0) + g | 0, y, y), h = (y << 2) + ((ye[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r) | 0; ; ) {
                        if ((o | 0) == (c | 0))
                          break t;
                        e[h >> 2] = e[o >> 2], o = o + 4 | 0, h = h + 4 | 0;
                      }
                    if (o = Ph(G + 4 | 0, o, c), c = ye[o + 11 | 0], g = (c & 128) >>> 7 | 0, h = g ? e[o >> 2] : o, y = e[o + 4 >> 2], e[5996] = 0, Si(235, r | 0, h | 0, (g ? y : c & 127) | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                      qi(o);
                      break e;
                    }
                    r = Vr() | 0, qi(o), Ki(r | 0), ri();
                  }
                  e[h >> 2] = 0, o = y + g | 0;
                  t: {
                    if ((ye[r + 11 | 0] & 128) >>> 7 | 0) {
                      e[r + 4 >> 2] = o;
                      break t;
                    }
                    $[r + 11 | 0] = o;
                  }
                }
                return Yr = G + 16 | 0, r | 0;
              }
              function yo(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0;
                if (e[r + 4 >> 2] = o, $[r | 0] = 0, o = e[e[o >> 2] - 12 >> 2] + o | 0, !e[o + 16 >> 2]) {
                  if (o = e[o + 72 >> 2], o)
                    e: {
                      y = Yr - 16 | 0, Yr = y;
                      t: {
                        r: {
                          if (!e[(o + e[e[o >> 2] - 12 >> 2] | 0) + 24 >> 2])
                            break r;
                          e[5996] = 0, h = On(134, y + 8 | 0, o | 0) | 0, c = e[5996], e[5996] = 0;
                          n: {
                            if ((c | 0) != 1) {
                              i: {
                                if (!ye[h | 0] || (c = e[(o + e[e[o >> 2] - 12 >> 2] | 0) + 24 >> 2], e[5996] = 0, c = ii(169, c | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) != 1 && ((c | 0) != -1 || (c = e[e[o >> 2] - 12 >> 2], e[5996] = 0, di(138, o + c | 0, 1), c = e[5996], e[5996] = 0, (c | 0) != 1))))
                                  break i;
                                c = Ts(0) | 0, tl(h);
                                break n;
                              }
                              tl(h);
                              break r;
                            }
                            c = Ts(0) | 0;
                          }
                          if (yu(c | 0) | 0, h = e[e[o >> 2] - 12 >> 2], e[5996] = 0, ko(139, o + h | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                            break t;
                          Wu();
                        }
                        Yr = y + 16 | 0;
                        break e;
                      }
                      r = Vr() | 0, e[5996] = 0, Ri(110), o = e[5996], e[5996] = 0, (o | 0) != 1 && (Ki(r | 0), ri()), Ts(0) | 0, va(), ri();
                    }
                  $[r | 0] = 1;
                }
                return r | 0;
              }
              function Kg(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0;
                h = Yr - 32 | 0, Yr = h;
                e: {
                  t: {
                    r: {
                      if ((c | 0) <= 0)
                        break r;
                      for (; ; ) {
                        if (ye[o + y | 0] != 41) {
                          if (y = y + 1 | 0, (c | 0) != (y | 0))
                            continue;
                          break r;
                        }
                        break;
                      }
                      if (y)
                        break t;
                    }
                    $[r + 16 | 0] = 0, $[r | 0] = 0;
                    break e;
                  }
                  t: {
                    r: {
                      if (y >>> 0 <= 17) {
                        if (y >>> 0 > 10)
                          break r;
                        $[h + 31 | 0] = y, c = h + 20 | 0;
                        break t;
                      }
                      $[r + 16 | 0] = 0, $[r | 0] = 0;
                      break e;
                    }
                    g = (y | 15) + 1 | 0, c = xs(g), e[h + 28 >> 2] = g | -2147483648, e[h + 20 >> 2] = c, e[h + 24 >> 2] = y;
                  }
                  $[_s(c, o, y) + y | 0] = 0, c = e[h + 20 >> 2], o = ye[h + 27 | 0] | ye[h + 28 | 0] << 8 | (ye[h + 29 | 0] << 16 | ye[h + 30 | 0] << 24), $[h + 15 | 0] = o, $[h + 16 | 0] = o >>> 8, $[h + 17 | 0] = o >>> 16, $[h + 18 | 0] = o >>> 24, e[h + 12 >> 2] = e[h + 24 >> 2], g = ye[h + 31 | 0], e[r >> 2] = c, e[r + 4 >> 2] = e[h + 12 >> 2], o = ye[h + 15 | 0] | ye[h + 16 | 0] << 8 | (ye[h + 17 | 0] << 16 | ye[h + 18 | 0] << 24), $[r + 7 | 0] = o, $[r + 8 | 0] = o >>> 8, $[r + 9 | 0] = o >>> 16, $[r + 10 | 0] = o >>> 24, $[r + 16 | 0] = 1, e[r + 12 >> 2] = y, $[r + 11 | 0] = g;
                }
                Yr = h + 32 | 0;
              }
              function Sc(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0, Fe = 0;
                S = Yr - 16 | 0, Yr = S;
                e: {
                  t: {
                    r: {
                      if (!r || (ke = e[y + 12 >> 2], Fe = c - o | 0, (Fe | 0) > 0 && (_n[e[e[r >> 2] + 48 >> 2]](r, o, Fe) | 0) != (Fe | 0)))
                        break r;
                      if (o = h - o | 0, o = (o | 0) < (ke | 0) ? ke - o | 0 : 0, (o | 0) > 0) {
                        if (o >>> 0 >= 2147483632)
                          break e;
                        n: {
                          if (o >>> 0 >= 11) {
                            ke = (o | 15) + 1 | 0, G = xs(ke), e[S + 12 >> 2] = ke | -2147483648, e[S + 4 >> 2] = G, e[S + 8 >> 2] = o;
                            break n;
                          }
                          $[S + 15 | 0] = o, G = S + 4 | 0;
                        }
                        if ($[Ya(G, g, o) + o | 0] = 0, g = e[e[r >> 2] + 48 >> 2], e[5996] = 0, g = Si(g | 0, r | 0, ($[S + 15 | 0] < 0 ? e[S + 4 >> 2] : S + 4 | 0) | 0, o | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                          break t;
                        if ($[S + 15 | 0] < 0 && Sr(e[S + 4 >> 2]), G = 0, (o | 0) != (g | 0))
                          break r;
                      }
                      if (o = h - c | 0, (o | 0) > 0 && (_n[e[e[r >> 2] + 48 >> 2]](r, c, o) | 0) != (o | 0))
                        break r;
                      e[y + 12 >> 2] = 0, G = r;
                    }
                    return Yr = S + 16 | 0, G | 0;
                  }
                  r = Vr() | 0, $[S + 15 | 0] < 0 && Sr(e[S + 4 >> 2]), Ki(r | 0), ri();
                }
                ba(), ri();
              }
              function Xu(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0;
                G = Yr - 16 | 0, Yr = G, h = ye[r + 11 | 0], y = h & 127, h = (h & 128) >>> 7 | 0, y = h ? e[r + 4 >> 2] : y, h = h ? (e[r + 8 >> 2] & 2147483647) - 1 | 0 : 10, g = c - o | 0;
                e: {
                  if (!g)
                    break e;
                  t: {
                    if (S = ye[r + 11 | 0], ke = (S & 128) >>> 7 | 0 ? e[r >> 2] : r, ke >>> 0 <= o >>> 0 ? S = ((S & 128) >>> 7 | 0 ? e[r + 4 >> 2] : S & 127) + ke >>> 0 >= o >>> 0 : S = 0, !S)
                      for (h - y >>> 0 < g >>> 0 && el(r, h, (y - h | 0) + g | 0, y, y), h = y + ((ye[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r) | 0; ; ) {
                        if ((o | 0) == (c | 0))
                          break t;
                        $[h | 0] = ye[o | 0], o = o + 1 | 0, h = h + 1 | 0;
                      }
                    if (o = rl(G + 4 | 0, o, c), c = ye[o + 11 | 0], g = (c & 128) >>> 7 | 0, h = g ? e[o >> 2] : o, y = e[o + 4 >> 2], e[5996] = 0, Si(100, r | 0, h | 0, (g ? y : c & 127) | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1) {
                      qi(o);
                      break e;
                    }
                    r = Vr() | 0, qi(o), Ki(r | 0), ri();
                  }
                  $[h | 0] = 0, o = y + g | 0;
                  t: {
                    if ((ye[r + 11 | 0] & 128) >>> 7 | 0) {
                      e[r + 4 >> 2] = o;
                      break t;
                    }
                    $[r + 11 | 0] = o;
                  }
                }
                return Yr = G + 16 | 0, r | 0;
              }
              function Ks(r, o, c) {
                var h = 0, y = 0;
                e: {
                  if ((r | 0) == (o | 0))
                    break e;
                  if (y = r + c | 0, o - y >>> 0 <= 0 - (c << 1) >>> 0)
                    return _s(r, o, c);
                  h = (r ^ o) & 3;
                  t: {
                    r: {
                      if (r >>> 0 < o >>> 0) {
                        if (h) {
                          h = r;
                          break t;
                        }
                        if (!(r & 3)) {
                          h = r;
                          break r;
                        }
                        for (h = r; ; ) {
                          if (!c)
                            break e;
                          if ($[h | 0] = ye[o | 0], o = o + 1 | 0, c = c - 1 | 0, h = h + 1 | 0, !(h & 3))
                            break;
                        }
                        break r;
                      }
                      n: {
                        if (h)
                          break n;
                        if (y & 3)
                          for (; ; ) {
                            if (!c)
                              break e;
                            if (c = c - 1 | 0, h = c + r | 0, $[h | 0] = ye[o + c | 0], !(h & 3))
                              break;
                          }
                        if (c >>> 0 <= 3)
                          break n;
                        for (; c = c - 4 | 0, e[c + r >> 2] = e[o + c >> 2], c >>> 0 > 3; )
                          ;
                      }
                      if (!c)
                        break e;
                      for (; c = c - 1 | 0, $[c + r | 0] = ye[o + c | 0], !!c; )
                        ;
                      break e;
                    }
                    if (c >>> 0 <= 3)
                      break t;
                    for (; e[h >> 2] = e[o >> 2], o = o + 4 | 0, h = h + 4 | 0, c = c - 4 | 0, c >>> 0 > 3; )
                      ;
                  }
                  if (!c)
                    break e;
                  for (; $[h | 0] = ye[o | 0], h = h + 1 | 0, o = o + 1 | 0, c = c - 1 | 0, !!c; )
                    ;
                }
                return r;
              }
              function hf(r, o, c) {
                e:
                  switch (o - 9 | 0) {
                    case 0:
                      o = e[c >> 2], e[c >> 2] = o + 4, e[r >> 2] = e[o >> 2];
                      return;
                    case 6:
                      o = e[c >> 2], e[c >> 2] = o + 4, o = Vs[o >> 1], e[r >> 2] = o, e[r + 4 >> 2] = o >> 31;
                      return;
                    case 7:
                      o = e[c >> 2], e[c >> 2] = o + 4, e[r >> 2] = fa[o >> 1], e[r + 4 >> 2] = 0;
                      return;
                    case 8:
                      o = e[c >> 2], e[c >> 2] = o + 4, o = $[o | 0], e[r >> 2] = o, e[r + 4 >> 2] = o >> 31;
                      return;
                    case 9:
                      o = e[c >> 2], e[c >> 2] = o + 4, e[r >> 2] = ye[o | 0], e[r + 4 >> 2] = 0;
                      return;
                    case 16:
                      o = e[c >> 2] + 7 & -8, e[c >> 2] = o + 8, Fi[r >> 3] = Fi[o >> 3];
                      return;
                    case 17:
                      o1(r, c);
                    default:
                      return;
                    case 1:
                    case 4:
                    case 14:
                      o = e[c >> 2], e[c >> 2] = o + 4, o = e[o >> 2], e[r >> 2] = o, e[r + 4 >> 2] = o >> 31;
                      return;
                    case 2:
                    case 5:
                    case 11:
                    case 15:
                      o = e[c >> 2], e[c >> 2] = o + 4, e[r >> 2] = e[o >> 2], e[r + 4 >> 2] = 0;
                      return;
                    case 3:
                    case 10:
                    case 12:
                    case 13:
                      break e;
                  }
                o = e[c >> 2] + 7 & -8, e[c >> 2] = o + 8, c = e[o + 4 >> 2], e[r >> 2] = e[o >> 2], e[r + 4 >> 2] = c;
              }
              function ed(r, o, c, h, y) {
                var g = 0, S = 0;
                g = Yr - 16 | 0, Yr = g, e[g + 12 >> 2] = o, e[o + 4 >> 2] = e[o + 4 >> 2] + 1, e[5996] = 0, o = ii(197, e[g + 12 >> 2]) | 0, S = e[5996], e[5996] = 0;
                e: {
                  if ((S | 0) == 1 || (e[5996] = 0, Qs(208, o | 0, 12416, 12448, c | 0), o = e[5996], e[5996] = 0, (o | 0) == 1) || (e[5996] = 0, o = ii(198, e[g + 12 >> 2]) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1) || (e[5996] = 0, c = ii(209, o | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) || (e[h >> 2] = c, e[5996] = 0, c = ii(206, o | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1) || (e[y >> 2] = c, e[5996] = 0, di(207, r | 0, o | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                    break e;
                  r = e[g + 12 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Yr = g + 16 | 0;
                  return;
                }
                c = Vr() | 0, r = e[g + 12 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
              }
              function td(r, o, c, h, y) {
                var g = 0, S = 0;
                g = Yr - 16 | 0, Yr = g, e[g + 12 >> 2] = o, e[o + 4 >> 2] = e[o + 4 >> 2] + 1, e[5996] = 0, o = ii(170, e[g + 12 >> 2]) | 0, S = e[5996], e[5996] = 0;
                e: {
                  if ((S | 0) == 1 || (e[5996] = 0, Qs(195, o | 0, 12416, 12448, c | 0), o = e[5996], e[5996] = 0, (o | 0) == 1) || (e[5996] = 0, o = ii(180, e[g + 12 >> 2]) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1) || (e[5996] = 0, c = ii(196, o | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1) || ($[h | 0] = c, e[5996] = 0, c = ii(193, o | 0) | 0, h = e[5996], e[5996] = 0, (h | 0) == 1) || ($[y | 0] = c, e[5996] = 0, di(194, r | 0, o | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                    break e;
                  r = e[g + 12 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Yr = g + 16 | 0;
                  return;
                }
                c = Vr() | 0, r = e[g + 12 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
              }
              function Ah(r, o, c, h, y, g) {
                var S = 0;
                S = Yr - 80 | 0, Yr = S;
                e: {
                  if ((g | 0) >= 16384) {
                    if (To(S + 32 | 0, o, c, h, y, 0, 0, 0, 2147352576), h = e[S + 40 >> 2], y = e[S + 44 >> 2], o = e[S + 32 >> 2], c = e[S + 36 >> 2], g >>> 0 < 32767) {
                      g = g - 16383 | 0;
                      break e;
                    }
                    To(S + 16 | 0, o, c, h, y, 0, 0, 0, 2147352576), g = ((g | 0) >= 49149 ? 49149 : g) - 32766 | 0, h = e[S + 24 >> 2], y = e[S + 28 >> 2], o = e[S + 16 >> 2], c = e[S + 20 >> 2];
                    break e;
                  }
                  if ((g | 0) > -16383)
                    break e;
                  if (To(S - -64 | 0, o, c, h, y, 0, 0, 0, 7471104), h = e[S + 72 >> 2], y = e[S + 76 >> 2], o = e[S + 64 >> 2], c = e[S + 68 >> 2], g >>> 0 > 4294934644) {
                    g = g + 16269 | 0;
                    break e;
                  }
                  To(S + 48 | 0, o, c, h, y, 0, 0, 0, 7471104), g = ((g | 0) <= -48920 ? -48920 : g) + 32538 | 0, h = e[S + 56 >> 2], y = e[S + 60 >> 2], o = e[S + 48 >> 2], c = e[S + 52 >> 2];
                }
                To(S, o, c, h, y, 0, 0, 0, g + 16383 << 16), o = e[S + 12 >> 2], e[r + 8 >> 2] = e[S + 8 >> 2], e[r + 12 >> 2] = o, o = e[S + 4 >> 2], e[r >> 2] = e[S >> 2], e[r + 4 >> 2] = o, Yr = S + 80 | 0;
              }
              function Bu(r, o, c, h, y) {
                var g = 0, S = 0, G = 0, ke = 0;
                G = Yr - 16 | 0, Yr = G, e[G + 12 >> 2] = o, o = 0, S = 6;
                e: {
                  t: {
                    if (Nu(r, G + 12 | 0))
                      break t;
                    S = e[r >> 2], g = e[S + 12 >> 2];
                    r: {
                      if ((g | 0) == e[S + 16 >> 2]) {
                        g = _n[e[e[S >> 2] + 36 >> 2]](S) | 0;
                        break r;
                      }
                      g = ye[g | 0];
                    }
                    if (S = 4, ke = e[h + 8 >> 2], g = g << 24 >> 24, (g | 0) >= 0 ? ke = (e[((g & 255) << 2) + ke >> 2] & 64) != 0 : ke = 0, !ke)
                      break t;
                    for (o = _n[e[e[h >> 2] + 36 >> 2]](h, g, 0) | 0; ; ) {
                      r: {
                        if (o = o - 48 | 0, g = El(r), Nu(g, G + 12 | 0) | (y | 0) < 2)
                          break r;
                        S = e[g >> 2], g = e[S + 12 >> 2];
                        n: {
                          if ((g | 0) == e[S + 16 >> 2]) {
                            S = _n[e[e[S >> 2] + 36 >> 2]](S) | 0;
                            break n;
                          }
                          S = ye[g | 0];
                        }
                        if (g = e[h + 8 >> 2], S = S << 24 >> 24, (S | 0) >= 0 ? g = (e[g + ((S & 255) << 2) >> 2] & 64) != 0 : g = 0, !g)
                          break e;
                        y = y - 1 | 0, o = (_n[e[e[h >> 2] + 36 >> 2]](h, S, 0) | 0) + vi(o, 10) | 0;
                        continue;
                      }
                      break;
                    }
                    if (S = 2, !Nu(g, G + 12 | 0))
                      break e;
                  }
                  e[c >> 2] = e[c >> 2] | S;
                }
                return Yr = G + 16 | 0, o;
              }
              function uu(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0;
                e: {
                  if ((o | 0) > 0)
                    for (h = r + o | 0; ; ) {
                      o = 1;
                      t: {
                        r:
                          switch (ye[r | 0] - 66 | 0) {
                            default:
                              if (r = ru(8), e[5996] = 0, o = On(17, r | 0, 2064) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1)
                                break e;
                              xa(o | 0, 22528, 7), ri();
                            case 20:
                              o = 2;
                              break t;
                            case 9:
                              o = 4;
                              break t;
                            case 21:
                              o = 8;
                              break t;
                            case 56:
                              o = 16;
                              break t;
                            case 45:
                              o = 32;
                              break t;
                            case 44:
                              o = 64;
                              break t;
                            case 34:
                              o = 128;
                              break t;
                            case 51:
                              o = 256;
                              break t;
                            case 35:
                              o = 512;
                              break t;
                            case 36:
                              o = 1024;
                              break t;
                            case 49:
                              o = 2048;
                              break t;
                            case 43:
                              o = 4096;
                              break t;
                            case 54:
                              o = 8192;
                              break t;
                            case 37:
                              o = 16384;
                              break t;
                            case 38:
                              o = 32768;
                              break t;
                            case 39:
                              o = 65536;
                              break t;
                            case 40:
                              o = 131072;
                              break t;
                            case 0:
                              break t;
                            case 41:
                              break r;
                          }
                        o = 262144;
                      }
                      if (c = o | c, r = r + 1 | 0, !(h >>> 0 > r >>> 0))
                        break;
                    }
                  return c | 0;
                }
                o = Vr() | 0, Ku(r), Ki(o | 0), ri();
              }
              function Ya(r, o, c) {
                var h = 0, y = 0, g = 0, S = 0;
                e: {
                  if (!c || ($[r | 0] = o, h = r + c | 0, $[h - 1 | 0] = o, c >>> 0 < 3) || ($[r + 2 | 0] = o, $[r + 1 | 0] = o, $[h - 3 | 0] = o, $[h - 2 | 0] = o, c >>> 0 < 7) || ($[r + 3 | 0] = o, $[h - 4 | 0] = o, c >>> 0 < 9) || (h = 0 - r & 3, y = h + r | 0, o = vi(o & 255, 16843009), e[y >> 2] = o, h = c - h & -4, c = h + y | 0, e[c - 4 >> 2] = o, h >>> 0 < 9) || (e[y + 8 >> 2] = o, e[y + 4 >> 2] = o, e[c - 8 >> 2] = o, e[c - 12 >> 2] = o, h >>> 0 < 25) || (e[y + 24 >> 2] = o, e[y + 20 >> 2] = o, e[y + 16 >> 2] = o, e[y + 12 >> 2] = o, e[c - 16 >> 2] = o, e[c - 20 >> 2] = o, e[c - 24 >> 2] = o, e[c - 28 >> 2] = o, S = y & 4 | 24, c = h - S | 0, c >>> 0 < 32))
                    break e;
                  for (h = so(o, 0, 1, 1), g = vs, o = y + S | 0; e[o + 24 >> 2] = h, e[o + 28 >> 2] = g, e[o + 16 >> 2] = h, e[o + 20 >> 2] = g, e[o + 8 >> 2] = h, e[o + 12 >> 2] = g, e[o >> 2] = h, e[o + 4 >> 2] = g, o = o + 32 | 0, c = c - 32 | 0, c >>> 0 > 31; )
                    ;
                }
                return r;
              }
              function rd(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0;
                e: {
                  if (h = e[r + 4 >> 2], G = e[r >> 2], g = h - G >> 3, c = g + 1 | 0, c >>> 0 < 536870912) {
                    if (S = e[r + 8 >> 2] - G | 0, y = S >> 2, c = S >>> 0 >= 2147483640 ? 536870911 : c >>> 0 < y >>> 0 ? y : c, c >>> 0 >= 536870912)
                      break e;
                    if (y = g << 3, g = c << 3, S = xs(g), c = y + S | 0, e[c >> 2] = e[o >> 2], e[c + 4 >> 2] = e[o + 4 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, y = c + 8 | 0, (h | 0) != (G | 0))
                      for (; c = c - 8 | 0, h = h - 8 | 0, e[c >> 2] = e[h >> 2], e[c + 4 >> 2] = e[h + 4 >> 2], e[h >> 2] = 0, e[h + 4 >> 2] = 0, (h | 0) != (G | 0); )
                        ;
                    if (e[r + 8 >> 2] = g + S, o = e[r >> 2], e[r >> 2] = c, h = e[r + 4 >> 2], e[r + 4 >> 2] = y, (o | 0) != (h | 0))
                      for (; ; ) {
                        h = h - 8 | 0, r = e[h + 4 >> 2];
                        t: {
                          if (!r || (c = e[r + 4 >> 2], e[r + 4 >> 2] = c - 1, c))
                            break t;
                          _n[e[e[r >> 2] + 8 >> 2]](r), cs(r);
                        }
                        if ((o | 0) == (h | 0))
                          break;
                      }
                    o && Sr(o);
                    return;
                  }
                  Lo(), ri();
                }
                su(), ri();
              }
              function mo() {
                var r = 0, o = 0, c = 0, h = 0;
                if (ye[25008])
                  return e[6251];
                c = Yr - 32 | 0, Yr = c;
                e: {
                  t: {
                    for (; ; ) {
                      if (o = c + 8 | 0, h = nd(r, 1 << r & 2147483647 ? 3538 : 5575), e[o + (r << 2) >> 2] = h, (h | 0) == -1)
                        break t;
                      if (r = r + 1 | 0, (r | 0) == 6)
                        break;
                    }
                    if (r = 19324, !pa(o, 19324, 24) || (r = 19348, !pa(o, 19348, 24)))
                      break e;
                    if (r = 0, !ye[24780]) {
                      for (; e[(r << 2) + 24732 >> 2] = nd(r, 5575), r = r + 1 | 0, (r | 0) != 6; )
                        ;
                      $[24780] = 1, e[6189] = e[6183];
                    }
                    if (r = 24732, o = c + 8 | 0, !pa(o, 24732, 24) || (r = 24756, !pa(o, 24756, 24)))
                      break e;
                    if (r = ia(24), !r)
                      break t;
                    o = e[c + 12 >> 2], e[r >> 2] = e[c + 8 >> 2], e[r + 4 >> 2] = o, o = e[c + 28 >> 2], e[r + 16 >> 2] = e[c + 24 >> 2], e[r + 20 >> 2] = o, o = e[c + 20 >> 2], e[r + 8 >> 2] = e[c + 16 >> 2], e[r + 12 >> 2] = o;
                    break e;
                  }
                  r = 0;
                }
                return Yr = c + 32 | 0, $[25008] = 1, e[6251] = r, r;
              }
              function Yf(r, o) {
                var c = 0, h = 0, y = 0, g = 0;
                c = Yr + -64 | 0, Yr = c, h = e[r >> 2], y = e[h - 4 >> 2], g = e[h - 8 >> 2], e[c + 28 >> 2] = 0, e[c + 32 >> 2] = 0, e[c + 36 >> 2] = 0, e[c + 40 >> 2] = 0, e[c + 44 >> 2] = 0, e[c + 48 >> 2] = 0, e[c + 52 >> 2] = 0, e[c + 56 >> 2] = 0, h = 0, $[c + 59 | 0] = 0, $[c + 60 | 0] = 0, $[c + 61 | 0] = 0, $[c + 62 | 0] = 0, e[c + 20 >> 2] = 0, e[c + 24 >> 2] = 0, e[c + 16 >> 2] = 22056, e[c + 12 >> 2] = r, e[c + 8 >> 2] = o, r = r + g | 0;
                e: {
                  if (Va(y, o, 0)) {
                    e[c + 56 >> 2] = 1, _n[e[e[y >> 2] + 20 >> 2]](y, c + 8 | 0, r, r, 1, 0), h = e[c + 32 >> 2] == 1 ? r : 0;
                    break e;
                  }
                  _n[e[e[y >> 2] + 24 >> 2]](y, c + 8 | 0, r, 1, 0);
                  t:
                    switch (e[c + 44 >> 2]) {
                      case 0:
                        h = e[c + 48 >> 2] == 1 && e[c + 36 >> 2] == 1 && e[c + 40 >> 2] == 1 ? e[c + 28 >> 2] : 0;
                        break e;
                      case 1:
                        break t;
                      default:
                        break e;
                    }
                  if (e[c + 32 >> 2] != 1 && e[c + 48 >> 2] | e[c + 36 >> 2] != 1 | e[c + 40 >> 2] != 1)
                    break e;
                  h = e[c + 24 >> 2];
                }
                return Yr = c - -64 | 0, h;
              }
              function nd(r, o) {
                var c = 0, h = 0, y = 0;
                e: {
                  if (ye[o | 0] || (o = Zl(3169), ye[o | 0] && o) || (o = Zl(vi(r, 12) + 9024 | 0), ye[o | 0] && o) || (o = Zl(3321), ye[o | 0] && o))
                    break e;
                  o = 3845;
                }
                e: {
                  for (; ; ) {
                    if (h = ye[o + c | 0], !(!h | (h | 0) == 47)) {
                      if (h = 23, c = c + 1 | 0, (c | 0) != 23)
                        continue;
                      break e;
                    }
                    break;
                  }
                  h = c;
                }
                y = 3845;
                e: {
                  t: {
                    c = ye[o | 0];
                    r: {
                      n: {
                        if (!(ye[o + h | 0] | (c | 0) == 46) && (y = o, (c | 0) != 67))
                          break n;
                        if (!ye[y + 1 | 0])
                          break r;
                      }
                      if (!Uc(y, 3845))
                        break r;
                      if (Uc(y, 2764))
                        break t;
                    }
                    if (!r && (c = 9096, ye[y + 1 | 0] == 46))
                      break e;
                    return 0;
                  }
                  if (c = e[6182], c)
                    for (; ; ) {
                      if (!Uc(y, c + 8 | 0))
                        break e;
                      if (c = e[c + 32 >> 2], !c)
                        break;
                    }
                  c = ia(36), c && (e[c + 4 >> 2] = 20, e[c >> 2] = 8992, o = c + 8 | 0, _s(o, y, h), $[o + h | 0] = 0, e[c + 32 >> 2] = e[6182], e[6182] = c), c = r | c ? c : 9096;
                }
                return c;
              }
              function Sr(r) {
                var o = 0, c = 0, h = 0, y = 0, g = 0;
                if (r) {
                  o = r - 4 | 0, y = e[o >> 2], h = y, c = o, g = e[r - 8 >> 2], r = g & -2, (r | 0) != (g | 0) && (c = o - r | 0, g = e[c + 4 >> 2], e[g + 8 >> 2] = e[c + 8 >> 2], e[e[c + 8 >> 2] + 4 >> 2] = g, h = r + h | 0), r = o + y | 0, o = e[r >> 2], (o | 0) != e[(r + o | 0) - 4 >> 2] && (y = e[r + 4 >> 2], e[y + 8 >> 2] = e[r + 8 >> 2], e[e[r + 8 >> 2] + 4 >> 2] = y, h = o + h | 0), e[c >> 2] = h, e[((h & -4) + c | 0) - 4 >> 2] = h | 1, o = e[c >> 2] - 8 | 0;
                  e: {
                    if (o >>> 0 <= 127) {
                      r = (o >>> 3 | 0) - 1 | 0;
                      break e;
                    }
                    if (h = Do(o), r = ((o >>> 29 - h ^ 4) - (h << 2) | 0) + 110 | 0, o >>> 0 <= 4095)
                      break e;
                    r = ((o >>> 30 - h ^ 2) - (h << 1) | 0) + 71 | 0, r = r >>> 0 >= 63 ? 63 : r;
                  }
                  o = r << 4, e[c + 4 >> 2] = o + 22944, o = o + 22952 | 0, e[c + 8 >> 2] = e[o >> 2], e[o >> 2] = c, e[e[c + 8 >> 2] + 4 >> 2] = c, o = e[5994], h = e[5995], c = r & 31, (r & 63) >>> 0 >= 32 ? (r = 1 << c, y = 0) : (y = 1 << c, r = y - 1 & 1 >>> 32 - c), e[5994] = y | o, e[5995] = r | h;
                }
              }
              function Tc(r, o, c, h, y, g, S, G, ke, Fe, Ar) {
                var hr = 0, Tr = 0, ln = 0;
                e: {
                  t: {
                    if (hr = e[h >> 2], (hr | 0) != (c | 0) || (Tr = 43, ln = r & 255, (ln | 0) != ye[Ar + 24 | 0] && (Tr = 45, ye[Ar + 25 | 0] != (ln | 0))))
                      break t;
                    e[h >> 2] = c + 1, $[c | 0] = Tr;
                    break e;
                  }
                  t: {
                    if (!(!((G & 128) >>> 7 | 0 ? S : G & 127) | (r | 0) != (g | 0))) {
                      if (G = 0, r = e[Fe >> 2], (r - ke | 0) > 159)
                        break t;
                      o = e[y >> 2], e[Fe >> 2] = r + 4, e[r >> 2] = o;
                      break e;
                    }
                    if (G = -1, r = xd(Ar, Ar + 26 | 0, r) - Ar | 0, (r | 0) > 23)
                      break t;
                    r: {
                      n:
                        switch (o - 8 | 0) {
                          case 0:
                          case 2:
                            if ((r | 0) < (o | 0))
                              break r;
                            break t;
                          case 1:
                            break r;
                          default:
                            break n;
                        }
                      if ((o | 0) != 16 | (r | 0) < 22)
                        break r;
                      if ((c | 0) == (hr | 0) | (hr - c | 0) > 2 | ye[hr - 1 | 0] != 48)
                        break t;
                      return e[y >> 2] = 0, e[h >> 2] = hr + 1, $[hr | 0] = ye[r + 12416 | 0], 0;
                    }
                    e[h >> 2] = hr + 1, $[hr | 0] = ye[r + 12416 | 0], e[y >> 2] = e[y >> 2] + 1, G = 0;
                  }
                  return G;
                }
                return e[y >> 2] = 0, 0;
              }
              function xc(r, o, c, h, y, g, S, G, ke, Fe, Ar) {
                var hr = 0, Tr = 0;
                e: {
                  t: {
                    if (hr = e[h >> 2], (hr | 0) != (c | 0) || (Tr = 43, e[Ar + 96 >> 2] != (r | 0) && (Tr = 45, e[Ar + 100 >> 2] != (r | 0))))
                      break t;
                    e[h >> 2] = c + 1, $[c | 0] = Tr;
                    break e;
                  }
                  t: {
                    if (!(!((G & 128) >>> 7 | 0 ? S : G & 127) | (r | 0) != (g | 0))) {
                      if (G = 0, r = e[Fe >> 2], (r - ke | 0) > 159)
                        break t;
                      o = e[y >> 2], e[Fe >> 2] = r + 4, e[r >> 2] = o;
                      break e;
                    }
                    if (G = -1, g = Rd(Ar, Ar + 104 | 0, r) - Ar | 0, (g | 0) > 92)
                      break t;
                    r = g >> 2;
                    r: {
                      n:
                        switch (o - 8 | 0) {
                          case 0:
                          case 2:
                            if ((r | 0) < (o | 0))
                              break r;
                            break t;
                          case 1:
                            break r;
                          default:
                            break n;
                        }
                      if ((o | 0) != 16 | (g | 0) < 88)
                        break r;
                      if ((c | 0) == (hr | 0) | (hr - c | 0) > 2 | ye[hr - 1 | 0] != 48)
                        break t;
                      return e[y >> 2] = 0, e[h >> 2] = hr + 1, $[hr | 0] = ye[r + 12416 | 0], 0;
                    }
                    e[h >> 2] = hr + 1, $[hr | 0] = ye[r + 12416 | 0], e[y >> 2] = e[y >> 2] + 1, G = 0;
                  }
                  return G;
                }
                return e[y >> 2] = 0, 0;
              }
              function _u(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0;
                if (c = e[r + 4 >> 2], h = e[r + 8 >> 2], c >>> 0 < h >>> 0) {
                  e[c >> 2] = o, e[r + 4 >> 2] = c + 4;
                  return;
                }
                e: {
                  t: {
                    r: {
                      if (S = e[r >> 2], y = c - S >> 2, g = y + 1 | 0, g >>> 0 < 1073741824) {
                        if (G = y << 2, h = h - S | 0, y = h >> 1, h = h >>> 0 >= 2147483644 ? 1073741823 : g >>> 0 < y >>> 0 ? y : g, h) {
                          if (h >>> 0 >= 1073741824)
                            break r;
                          y = xs(h << 2);
                        } else
                          y = 0;
                        if (g = G + y | 0, e[g >> 2] = o, o = y + (h << 2) | 0, h = g + 4 | 0, (c | 0) == (S | 0))
                          break t;
                        for (; c = c - 4 | 0, y = e[c >> 2], e[c >> 2] = 0, g = g - 4 | 0, e[g >> 2] = y, (c | 0) != (S | 0); )
                          ;
                        if (e[r + 8 >> 2] = o, o = e[r + 4 >> 2], e[r + 4 >> 2] = h, c = e[r >> 2], e[r >> 2] = g, (o | 0) == (c | 0))
                          break e;
                        for (; o = o - 4 | 0, ol(o), (o | 0) != (c | 0); )
                          ;
                        break e;
                      }
                      Lo(), ri();
                    }
                    su(), ri();
                  }
                  e[r + 8 >> 2] = o, e[r + 4 >> 2] = h, e[r >> 2] = g;
                }
                c && Sr(c);
              }
              function Xf(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0;
                e: {
                  if (o >>> 0 >= 256) {
                    if (r = ru(8), e[5996] = 0, o = On(91, r | 0, 2394) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1)
                      break e;
                    o = Vr() | 0, Ku(r), Ki(o | 0), ri();
                  }
                  return c = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), y = c - 29 | 0, g = c >>> 0 < 29 ? c : y, h = g + 1 | 0, h >>> 0 > (c >>> 0 <= 28 ? 28 : ye[r + 4 | 0] | ye[r + 5 | 0] << 8 | (ye[r + 6 | 0] << 16 | ye[r + 7 | 0] << 24)) >>> 0 && (tu(r, h + (h >>> 1 | 0) | 0), c = ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24), y = c - 29 | 0), S = c >>> 0 < 29, h = (S ? r + 4 | 0 : ye[r + 8 | 0] | ye[r + 9 | 0] << 8 | (ye[r + 10 | 0] << 16 | ye[r + 11 | 0] << 24)) + g | 0, Ks(h + 1 | 0, h, (S ? c : y) - g | 0), c = (ye[r | 0] | ye[r + 1 | 0] << 8 | (ye[r + 2 | 0] << 16 | ye[r + 3 | 0] << 24)) + 1 | 0, $[r | 0] = c, $[r + 1 | 0] = c >>> 8, $[r + 2 | 0] = c >>> 16, $[r + 3 | 0] = c >>> 24, $[h | 0] = o, r | 0;
                }
                xa(o | 0, 22664, 92), ri();
              }
              function gh(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0;
                S = Yr - 256 | 0, Yr = S, e[S + 248 >> 2] = 37, e[S + 252 >> 2] = 0, G = S + 248 | 0, Cu(G | 1, 2055, 1, e[c + 4 >> 2]), ke = mo(), e[S >> 2] = y, e[S + 4 >> 2] = g, r = S + 224 | 0, y = Zo(r, 24, ke, G, S) + r | 0, ke = Ka(r, y, e[c + 4 >> 2]), g = S + 20 | 0, G = e[c + 28 >> 2], e[g >> 2] = G, e[G + 4 >> 2] = e[G + 4 >> 2] + 1, e[5996] = 0, G = S + 32 | 0, $a(215, r | 0, ke | 0, y | 0, G | 0, S + 28 | 0, S + 24 | 0, g | 0), r = e[5996], e[5996] = 0;
                e: {
                  if ((r | 0) != 1) {
                    r = e[g >> 2], y = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = y, (y | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), r = Hu(o, G, e[S + 28 >> 2], e[S + 24 >> 2], c, h), Yr = S + 256 | 0;
                    break e;
                  }
                  c = Vr() | 0, r = e[S + 20 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
                }
                return r | 0;
              }
              function _f(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0;
                S = Yr - 256 | 0, Yr = S, e[S + 248 >> 2] = 37, e[S + 252 >> 2] = 0, G = S + 248 | 0, Cu(G | 1, 2055, 0, e[c + 4 >> 2]), ke = mo(), e[S >> 2] = y, e[S + 4 >> 2] = g, r = S + 224 | 0, y = Zo(r, 24, ke, G, S) + r | 0, ke = Ka(r, y, e[c + 4 >> 2]), g = S + 20 | 0, G = e[c + 28 >> 2], e[g >> 2] = G, e[G + 4 >> 2] = e[G + 4 >> 2] + 1, e[5996] = 0, G = S + 32 | 0, $a(215, r | 0, ke | 0, y | 0, G | 0, S + 28 | 0, S + 24 | 0, g | 0), r = e[5996], e[5996] = 0;
                e: {
                  if ((r | 0) != 1) {
                    r = e[g >> 2], y = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = y, (y | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), r = Hu(o, G, e[S + 28 >> 2], e[S + 24 >> 2], c, h), Yr = S + 256 | 0;
                    break e;
                  }
                  c = Vr() | 0, r = e[S + 20 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
                }
                return r | 0;
              }
              function Gg(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0;
                S = Yr - 112 | 0, Yr = S, e[S + 104 >> 2] = 37, e[S + 108 >> 2] = 0, G = S + 104 | 0, Cu(G | 1, 2055, 1, e[c + 4 >> 2]), ke = mo(), e[S >> 2] = y, e[S + 4 >> 2] = g, r = S + 80 | 0, y = Zo(r, 24, ke, G, S) + r | 0, ke = Ka(r, y, e[c + 4 >> 2]), g = S + 20 | 0, G = e[c + 28 >> 2], e[g >> 2] = G, e[G + 4 >> 2] = e[G + 4 >> 2] + 1, e[5996] = 0, G = S + 32 | 0, $a(211, r | 0, ke | 0, y | 0, G | 0, S + 28 | 0, S + 24 | 0, g | 0), r = e[5996], e[5996] = 0;
                e: {
                  if ((r | 0) != 1) {
                    r = e[g >> 2], y = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = y, (y | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), r = Sc(o, G, e[S + 28 >> 2], e[S + 24 >> 2], c, h), Yr = S + 112 | 0;
                    break e;
                  }
                  c = Vr() | 0, r = e[S + 20 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
                }
                return r | 0;
              }
              function jg(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0;
                S = Yr - 112 | 0, Yr = S, e[S + 104 >> 2] = 37, e[S + 108 >> 2] = 0, G = S + 104 | 0, Cu(G | 1, 2055, 0, e[c + 4 >> 2]), ke = mo(), e[S >> 2] = y, e[S + 4 >> 2] = g, r = S + 80 | 0, y = Zo(r, 24, ke, G, S) + r | 0, ke = Ka(r, y, e[c + 4 >> 2]), g = S + 20 | 0, G = e[c + 28 >> 2], e[g >> 2] = G, e[G + 4 >> 2] = e[G + 4 >> 2] + 1, e[5996] = 0, G = S + 32 | 0, $a(211, r | 0, ke | 0, y | 0, G | 0, S + 28 | 0, S + 24 | 0, g | 0), r = e[5996], e[5996] = 0;
                e: {
                  if ((r | 0) != 1) {
                    r = e[g >> 2], y = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = y, (y | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), r = Sc(o, G, e[S + 28 >> 2], e[S + 24 >> 2], c, h), Yr = S + 112 | 0;
                    break e;
                  }
                  c = Vr() | 0, r = e[S + 20 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
                }
                return r | 0;
              }
              function ph(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0, Fe = 0, Ar = 0, hr = 0;
                if (Va(r, e[o + 8 >> 2], g)) {
                  pd(o, c, h, y);
                  return;
                }
                S = ye[o + 53 | 0], ke = e[r + 12 >> 2], $[o + 53 | 0] = 0, G = ye[o + 52 | 0], $[o + 52 | 0] = 0, Dd(e[r + 16 >> 2], e[r + 20 >> 2], o, c, h, y, g), Fe = ye[o + 52 | 0], G = (G | Fe) != 0, Ar = ye[o + 53 | 0], hr = (S | Ar) != 0, S = r + 24 | 0, ke = (r + 16 | 0) + (ke << 3) | 0;
                e: {
                  if (S >>> 0 >= ke >>> 0)
                    break e;
                  for (; ; ) {
                    if (ye[o + 54 | 0])
                      break e;
                    t: {
                      if (Fe) {
                        if (e[o + 24 >> 2] == 1)
                          break e;
                        if (ye[r + 8 | 0] & 2)
                          break t;
                        break e;
                      }
                      if (!Ar)
                        break t;
                      if (!($[r + 8 | 0] & 1))
                        break e;
                    }
                    if (Vs[o + 52 >> 1] = 0, Dd(e[S >> 2], e[S + 4 >> 2], o, c, h, y, g), Ar = ye[o + 53 | 0], hr = (Ar | hr) != 0, Fe = ye[o + 52 | 0], G = (Fe | G) != 0, S = S + 8 | 0, !(ke >>> 0 > S >>> 0))
                      break;
                  }
                }
                $[o + 53 | 0] = hr, $[o + 52 | 0] = G;
              }
              function cu(r, o, c, h, y) {
                var g = 0, S = 0, G = 0, ke = 0;
                G = Yr - 16 | 0, Yr = G, e[G + 12 >> 2] = o, o = 0, S = 6;
                e: {
                  t: {
                    if (Pu(r, G + 12 | 0))
                      break t;
                    S = 4, g = e[r >> 2], ke = e[g + 12 >> 2];
                    r: {
                      if ((ke | 0) == e[g + 16 >> 2]) {
                        g = _n[e[e[g >> 2] + 36 >> 2]](g) | 0;
                        break r;
                      }
                      g = e[ke >> 2];
                    }
                    if (!(_n[e[e[h >> 2] + 12 >> 2]](h, 64, g) | 0))
                      break t;
                    for (o = _n[e[e[h >> 2] + 52 >> 2]](h, g, 0) | 0; ; ) {
                      r: {
                        if (o = o - 48 | 0, g = Bl(r), Pu(g, G + 12 | 0) | (y | 0) < 2)
                          break r;
                        S = e[g >> 2], g = e[S + 12 >> 2];
                        n: {
                          if ((g | 0) == e[S + 16 >> 2]) {
                            S = _n[e[e[S >> 2] + 36 >> 2]](S) | 0;
                            break n;
                          }
                          S = e[g >> 2];
                        }
                        if (!(_n[e[e[h >> 2] + 12 >> 2]](h, 64, S) | 0))
                          break e;
                        y = y - 1 | 0, o = (_n[e[e[h >> 2] + 52 >> 2]](h, S, 0) | 0) + vi(o, 10) | 0;
                        continue;
                      }
                      break;
                    }
                    if (S = 2, !Pu(g, G + 12 | 0))
                      break e;
                  }
                  e[c >> 2] = e[c >> 2] | S;
                }
                return Yr = G + 16 | 0, o;
              }
              function Zf(r, o, c, h) {
                var y = 0, g = 0, S = 0, G = 0;
                S = h || 24720, h = e[S >> 2];
                e: {
                  t: {
                    r: {
                      if (!o) {
                        if (h)
                          break r;
                        return 0;
                      }
                      if (y = -2, !c)
                        break t;
                      n: {
                        if (h) {
                          y = c;
                          break n;
                        }
                        if (h = ye[o | 0], g = h << 24 >> 24, (g | 0) >= 0)
                          return r && (e[r >> 2] = h), (g | 0) != 0;
                        if (!e[e[6178] >> 2]) {
                          if (y = 1, !r)
                            break t;
                          return e[r >> 2] = g & 57343, 1;
                        }
                        if (h = h - 194 | 0, h >>> 0 > 50)
                          break r;
                        if (h = e[(h << 2) + 12208 >> 2], y = c - 1 | 0, !y)
                          break e;
                        o = o + 1 | 0;
                      }
                      if (g = ye[o | 0], G = g >>> 3 | 0, (G - 16 | (h >> 26) + G) >>> 0 > 7)
                        break r;
                      for (; ; ) {
                        if (y = y - 1 | 0, h = g - 128 | h << 6, (h | 0) >= 0)
                          return e[S >> 2] = 0, r && (e[r >> 2] = h), c - y | 0;
                        if (!y)
                          break e;
                        if (o = o + 1 | 0, g = ye[o | 0], (g & 192) != 128)
                          break;
                      }
                    }
                    e[S >> 2] = 0, e[5732] = 25, y = -1;
                  }
                  return y;
                }
                return e[S >> 2] = h, -2;
              }
              function Fu(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0;
                var g = 0, S = 0, G = 0, ke = 0;
                g = Yr - 144 | 0, Yr = g, e[g + 136 >> 2] = 37, e[g + 140 >> 2] = 0, G = g + 136 | 0, Cu(G | 1, 2096, 1, e[c + 4 >> 2]), S = mo(), e[g >> 2] = y, r = g + 123 | 0, y = Zo(r, 13, S, G, g) + r | 0, ke = Ka(r, y, e[c + 4 >> 2]), G = g + 4 | 0, S = e[c + 28 >> 2], e[G >> 2] = S, e[S + 4 >> 2] = e[S + 4 >> 2] + 1, e[5996] = 0, S = g + 16 | 0, $a(215, r | 0, ke | 0, y | 0, S | 0, g + 12 | 0, g + 8 | 0, G | 0), r = e[5996], e[5996] = 0;
                e: {
                  if ((r | 0) != 1) {
                    r = e[G >> 2], y = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = y, (y | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), r = Hu(o, S, e[g + 12 >> 2], e[g + 8 >> 2], c, h), Yr = g + 144 | 0;
                    break e;
                  }
                  c = Vr() | 0, r = e[g + 4 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
                }
                return r | 0;
              }
              function $f(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0;
                var g = 0, S = 0, G = 0, ke = 0;
                g = Yr - 144 | 0, Yr = g, e[g + 136 >> 2] = 37, e[g + 140 >> 2] = 0, G = g + 136 | 0, Cu(G | 1, 2096, 0, e[c + 4 >> 2]), S = mo(), e[g >> 2] = y, r = g + 123 | 0, y = Zo(r, 13, S, G, g) + r | 0, ke = Ka(r, y, e[c + 4 >> 2]), G = g + 4 | 0, S = e[c + 28 >> 2], e[G >> 2] = S, e[S + 4 >> 2] = e[S + 4 >> 2] + 1, e[5996] = 0, S = g + 16 | 0, $a(215, r | 0, ke | 0, y | 0, S | 0, g + 12 | 0, g + 8 | 0, G | 0), r = e[5996], e[5996] = 0;
                e: {
                  if ((r | 0) != 1) {
                    r = e[G >> 2], y = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = y, (y | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), r = Hu(o, S, e[g + 12 >> 2], e[g + 8 >> 2], c, h), Yr = g + 144 | 0;
                    break e;
                  }
                  c = Vr() | 0, r = e[g + 4 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
                }
                return r | 0;
              }
              function Vg(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0;
                var g = 0, S = 0, G = 0, ke = 0;
                g = Yr + -64 | 0, Yr = g, e[g + 56 >> 2] = 37, e[g + 60 >> 2] = 0, G = g + 56 | 0, Cu(G | 1, 2096, 1, e[c + 4 >> 2]), S = mo(), e[g >> 2] = y, r = g + 43 | 0, y = Zo(r, 13, S, G, g) + r | 0, ke = Ka(r, y, e[c + 4 >> 2]), G = g + 4 | 0, S = e[c + 28 >> 2], e[G >> 2] = S, e[S + 4 >> 2] = e[S + 4 >> 2] + 1, e[5996] = 0, S = g + 16 | 0, $a(211, r | 0, ke | 0, y | 0, S | 0, g + 12 | 0, g + 8 | 0, G | 0), r = e[5996], e[5996] = 0;
                e: {
                  if ((r | 0) != 1) {
                    r = e[G >> 2], y = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = y, (y | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), r = Sc(o, S, e[g + 12 >> 2], e[g + 8 >> 2], c, h), Yr = g - -64 | 0;
                    break e;
                  }
                  c = Vr() | 0, r = e[g + 4 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
                }
                return r | 0;
              }
              function Wg(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0;
                var g = 0, S = 0, G = 0, ke = 0;
                g = Yr + -64 | 0, Yr = g, e[g + 56 >> 2] = 37, e[g + 60 >> 2] = 0, G = g + 56 | 0, Cu(G | 1, 2096, 0, e[c + 4 >> 2]), S = mo(), e[g >> 2] = y, r = g + 43 | 0, y = Zo(r, 13, S, G, g) + r | 0, ke = Ka(r, y, e[c + 4 >> 2]), G = g + 4 | 0, S = e[c + 28 >> 2], e[G >> 2] = S, e[S + 4 >> 2] = e[S + 4 >> 2] + 1, e[5996] = 0, S = g + 16 | 0, $a(211, r | 0, ke | 0, y | 0, S | 0, g + 12 | 0, g + 8 | 0, G | 0), r = e[5996], e[5996] = 0;
                e: {
                  if ((r | 0) != 1) {
                    r = e[G >> 2], y = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = y, (y | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), r = Sc(o, S, e[g + 12 >> 2], e[g + 8 >> 2], c, h), Yr = g - -64 | 0;
                    break e;
                  }
                  c = Vr() | 0, r = e[g + 4 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
                }
                return r | 0;
              }
              function zg(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0;
                e[c >> 2] = 0;
                e: {
                  if (y = e[o + 4 >> 2], !y)
                    break e;
                  g = e[o >> 2];
                  t: {
                    r: {
                      n: {
                        for (; ; ) {
                          if (h = $[g | 0], S = e[c >> 2], (h | 0) < ((S ? 48 : 49) | 0) | (h | 0) > 57)
                            break n;
                          if (h = (h + vi(S, 10) | 0) - 48 | 0, e[c >> 2] = h >>> 0 >= 65535 ? 65535 : h, y = y - 1 | 0, e[o + 4 >> 2] = y, g = g + 1 | 0, e[o >> 2] = g, !y)
                            break;
                        }
                        if (e[c >> 2])
                          break r;
                        break e;
                      }
                      if (!S)
                        break e;
                      if ((h | 0) == 64)
                        break t;
                    }
                    e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                    return;
                  }
                  e[o + 4 >> 2] = y - 1, e[o >> 2] = g + 1, nf(r, o);
                  return;
                }
                e[c >> 2] = 1, nf(r, o);
              }
              function Lu(r, o, c, h, y, g, S, G) {
                var ke = 0, Fe = 0, Ar = 0, hr = 0;
                Fe = 1, ke = h & 2147483647, hr = ke, Ar = (ke | 0) == 2147418112;
                e: {
                  if ((Ar & !c ? r | o : Ar & (c | 0) != 0 | ke >>> 0 > 2147418112) || (ke = G & 2147483647, !S & (ke | 0) == 2147418112 ? y | g : (ke | 0) == 2147418112 & (S | 0) != 0 | ke >>> 0 > 2147418112))
                    break e;
                  if (!(r | y | (c | S) | (o | g | (ke | hr))))
                    return 0;
                  if (Fe = h & G, (Fe | 0) > 0 | (Fe | 0) >= 0) {
                    if (Fe = -1, (c | 0) == (S | 0) & (h | 0) == (G | 0) ? (o | 0) == (g | 0) & r >>> 0 < y >>> 0 | o >>> 0 < g >>> 0 : c >>> 0 < S >>> 0 & (h | 0) <= (G | 0) | (h | 0) < (G | 0))
                      break e;
                    return (r ^ y | c ^ S | (o ^ g | h ^ G)) != 0;
                  }
                  if (Fe = -1, (c | 0) == (S | 0) & (h | 0) == (G | 0) ? (o | 0) == (g | 0) & r >>> 0 > y >>> 0 | o >>> 0 > g >>> 0 : c >>> 0 > S >>> 0 & (h | 0) >= (G | 0) | (h | 0) > (G | 0))
                    break e;
                  Fe = (r ^ y | c ^ S | (o ^ g | h ^ G)) != 0;
                }
                return Fe;
              }
              function yh(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0;
                e: {
                  t: {
                    y = e[r + 4 >> 2], g = e[r >> 2], h = y - g >> 2;
                    r: {
                      if (h >>> 0 < o >>> 0) {
                        if (S = o - h | 0, c = e[r + 8 >> 2], S >>> 0 <= c - y >> 2 >>> 0) {
                          o = r, r = S << 2, e[o + 4 >> 2] = Ya(y, 0, r) + r;
                          return;
                        }
                        if (o >>> 0 >= 1073741824)
                          break t;
                        if (c = c - g | 0, G = c >> 1, o = c >>> 0 >= 2147483644 ? 1073741823 : o >>> 0 < G >>> 0 ? G : o, o >>> 0 >= 1073741824)
                          break e;
                        if (c = o << 2, o = xs(c), c = o + c | 0, o = o + (h << 2) | 0, h = S << 2, h = Ya(o, 0, h) + h | 0, (y | 0) != (g | 0))
                          for (; o = o - 4 | 0, y = y - 4 | 0, e[o >> 2] = e[y >> 2], (y | 0) != (g | 0); )
                            ;
                        if (e[r + 8 >> 2] = c, e[r + 4 >> 2] = h, e[r >> 2] = o, !g)
                          break r;
                        Sr(g);
                        return;
                      }
                      if (o >>> 0 >= h >>> 0)
                        break r;
                      e[r + 4 >> 2] = (o << 2) + g;
                    }
                    return;
                  }
                  Lo(), ri();
                }
                su(), ri();
              }
              function mh(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0;
                var g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0;
                if (r = Yr - 208 | 0, Yr = r, S = mo(), e[r >> 2] = y, y = r + 176 | 0, G = Zo(y, 20, S, 1937, r), S = G + y | 0, ke = Ka(y, S, e[c + 4 >> 2]), g = e[c + 28 >> 2], e[r + 12 >> 2] = g, e[g + 4 >> 2] = e[g + 4 >> 2] + 1, e[5996] = 0, Fe = ii(197, e[r + 12 >> 2]) | 0, g = e[5996], e[5996] = 0, (g | 0) != 1)
                  return g = e[r + 12 >> 2], Ar = e[g + 4 >> 2] - 1 | 0, e[g + 4 >> 2] = Ar, (Ar | 0) == -1 && _n[e[e[g >> 2] + 8 >> 2]](g), g = y, y = r + 16 | 0, _n[e[e[Fe >> 2] + 48 >> 2]](Fe, g, S, y) | 0, g = o, o = y + (G << 2) | 0, o = Hu(g, y, (S | 0) == (ke | 0) ? o : (r + (ke - r << 2) | 0) - 688 | 0, o, c, h), Yr = r + 208 | 0, o | 0;
                c = Vr() | 0, r = e[r + 12 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
              }
              function ru(r) {
                var o = 0, c = 0, h = 0, y = 0, g = 0;
                if (g = r + 27 & -4, r = g, o = r >>> 0 <= 1 ? 1 : r, r = o, c = r + 15 & -16, r = r >>> 0 < c >>> 0 ? c : r, r & 15 ? r = 0 : r = jf(16, r), !r)
                  e:
                    for (c = 0, r = e[6705], r || (e[6705] = 26844, Vs[13423] = 125, Vs[13422] = 128, r = e[6705]), h = (o + 3 >>> 2 | 0) + 1 | 0; ; ) {
                      o = 0;
                      t: {
                        if (!r | (r | 0) == 27344)
                          r = o;
                        else {
                          if (o = fa[r + 2 >> 1], y = h + (o >>> 0 > h >>> 0 ? o - h & 3 : 0) | 0, y >>> 0 < o >>> 0) {
                            c = o - y | 0, Vs[r + 2 >> 1] = c, r = ((c & 65535) << 2) + r | 0, Vs[r + 2 >> 1] = y, Vs[r >> 1] = 0, r = r + 4 | 0;
                            break e;
                          }
                          if (o >>> 0 < h >>> 0)
                            break t;
                          o = fa[r >> 1];
                          r: {
                            if (!c) {
                              e[6705] = (o << 2) + 26832;
                              break r;
                            }
                            Vs[c >> 1] = o;
                          }
                          Vs[r >> 1] = 0, r = r + 4 | 0;
                        }
                        break e;
                      }
                      c = r, r = (fa[r >> 1] << 2) + 26832 | 0;
                    }
                return r || (va(), ri()), Ya(r, 0, g) + 24 | 0;
              }
              function Jg(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0;
                var g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0;
                if (r = Yr - 96 | 0, Yr = r, S = mo(), e[r >> 2] = y, y = r - -64 | 0, G = Zo(y, 20, S, 1937, r), S = G + y | 0, ke = Ka(y, S, e[c + 4 >> 2]), g = e[c + 28 >> 2], e[r + 12 >> 2] = g, e[g + 4 >> 2] = e[g + 4 >> 2] + 1, e[5996] = 0, Fe = ii(170, e[r + 12 >> 2]) | 0, g = e[5996], e[5996] = 0, (g | 0) != 1)
                  return g = e[r + 12 >> 2], Ar = e[g + 4 >> 2] - 1 | 0, e[g + 4 >> 2] = Ar, (Ar | 0) == -1 && _n[e[e[g >> 2] + 8 >> 2]](g), g = y, y = r + 16 | 0, _n[e[e[Fe >> 2] + 32 >> 2]](Fe, g, S, y) | 0, g = o, o = y + G | 0, o = Sc(g, y, (S | 0) == (ke | 0) ? o : (r + (ke - r | 0) | 0) - 48 | 0, o, c, h), Yr = r + 96 | 0, o | 0;
                c = Vr() | 0, r = e[r + 12 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
              }
              function Ih(r, o, c, h, y, g, S, G) {
                var ke = 0, Fe = 0, Ar = 0, hr = 0;
                if (ke = Yr - 16 | 0, Yr = ke, 1073741806 - o >>> 0 >= c >>> 0) {
                  Ar = (ye[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r, Fe = ke + 4 | 0, hr = Fe, o >>> 0 <= 536870886 ? (e[ke + 12 >> 2] = o << 1, e[ke + 4 >> 2] = o + c, c = e[(Ps[Fe >> 2] < Ps[ke + 12 >> 2] ? ke + 12 | 0 : Fe) >> 2], c >>> 0 >= 2 ? (Fe = c + 4 & -4, c = Fe - 1 | 0, c = (c | 0) == 2 ? Fe : c) : c = 1, c = c + 1 | 0) : c = 1073741807, bl(hr, c), c = e[ke + 4 >> 2], y && nc(c, Ar, y), S && nc(c + (y << 2) | 0, G, S), Fe = y + g | 0, G = h - Fe | 0, (h | 0) != (Fe | 0) && (h = y << 2, nc((h + c | 0) + (S << 2) | 0, (h + Ar | 0) + (g << 2) | 0, G)), (o | 0) != 1 && Sr(Ar), e[r >> 2] = c, e[r + 8 >> 2] = e[ke + 8 >> 2] | -2147483648, o = r, r = G + (y + S | 0) | 0, e[o + 4 >> 2] = r, e[c + (r << 2) >> 2] = 0, Yr = ke + 16 | 0;
                  return;
                }
                ba(), ri();
              }
              function sd(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0;
                if (y = c - o | 0, y >>> 0 < 2147483632) {
                  e: {
                    if (y >>> 0 <= 10) {
                      $[r + 11 | 0] = y, h = r;
                      break e;
                    }
                    g = (y | 15) + 1 | 0, h = xs(g), e[r + 8 >> 2] = g | -2147483648, e[r >> 2] = h, e[r + 4 >> 2] = y;
                  }
                  e: {
                    if ((o | 0) == (c | 0))
                      break e;
                    if (g = (o ^ -1) + c | 0, S = y & 7, S)
                      for (y = 0; $[h | 0] = ye[o | 0], h = h + 1 | 0, o = o + 1 | 0, y = y + 1 | 0, (S | 0) != (y | 0); )
                        ;
                    if (g >>> 0 < 7)
                      break e;
                    for (; $[h | 0] = ye[o | 0], $[h + 1 | 0] = ye[o + 1 | 0], $[h + 2 | 0] = ye[o + 2 | 0], $[h + 3 | 0] = ye[o + 3 | 0], $[h + 4 | 0] = ye[o + 4 | 0], $[h + 5 | 0] = ye[o + 5 | 0], $[h + 6 | 0] = ye[o + 6 | 0], $[h + 7 | 0] = ye[o + 7 | 0], h = h + 8 | 0, o = o + 8 | 0, (c | 0) != (o | 0); )
                      ;
                  }
                  return $[h | 0] = 0, r | 0;
                }
                ba(), ri();
              }
              function Af(r, o, c, h) {
                var y = 0, g = 0, S = 0;
                if (y = Yr - 32 | 0, Yr = y, c >>> 0 < 2147483632) {
                  e: {
                    t: {
                      if (c >>> 0 >= 11) {
                        S = (c | 15) + 1 | 0, g = xs(S), e[y + 16 >> 2] = S | -2147483648, e[y + 8 >> 2] = g, e[y + 12 >> 2] = c;
                        break t;
                      }
                      if ($[y + 19 | 0] = c, g = y + 8 | 0, !c)
                        break e;
                    }
                    g = _s(g, o, c) + c | 0;
                  }
                  $[g | 0] = 0, e[5996] = 0, di(31, y + 20 | 0, y + 8 | 0), o = e[5996], e[5996] = 0;
                  e: {
                    t: {
                      if ((o | 0) != 1) {
                        if ($[y + 19 | 0] < 0 && Sr(e[y + 8 >> 2]), c = e[y + 24 >> 2], o = e[y + 20 >> 2], (c - o | 0) != (h | 0))
                          break t;
                        e[r + 4 >> 2] = c, e[r >> 2] = o, e[r + 8 >> 2] = e[y + 28 >> 2];
                        break e;
                      }
                      r = Vr() | 0, $[y + 19 | 0] < 0 && Sr(e[y + 8 >> 2]), Ki(r | 0), ri();
                    }
                    if (e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, !o)
                      break e;
                    Sr(o);
                  }
                  Yr = y + 32 | 0;
                  return;
                }
                ba(), ri();
              }
              function Rc(r, o, c, h, y, g, S, G) {
                var ke = 0, Fe = 0, Ar = 0, hr = 0;
                if (ke = Yr - 16 | 0, Yr = ke, 2147483630 - o >>> 0 >= c >>> 0) {
                  Ar = (ye[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r, Fe = ke + 4 | 0, hr = Fe, o >>> 0 <= 1073741798 ? (e[ke + 12 >> 2] = o << 1, e[ke + 4 >> 2] = o + c, c = e[(Ps[Fe >> 2] < Ps[ke + 12 >> 2] ? ke + 12 | 0 : Fe) >> 2], c >>> 0 >= 11 ? (Fe = c + 16 & -16, c = Fe - 1 | 0, c = (c | 0) == 11 ? Fe : c) : c = 10, c = c + 1 | 0) : c = 2147483631, bc(hr, c), c = e[ke + 4 >> 2], y && uc(c, Ar, y), S && uc(c + y | 0, G, S), Fe = y + g | 0, G = h - Fe | 0, (h | 0) != (Fe | 0) && uc((c + y | 0) + S | 0, (y + Ar | 0) + g | 0, G), (o | 0) != 10 && Sr(Ar), e[r >> 2] = c, e[r + 8 >> 2] = e[ke + 8 >> 2] | -2147483648, o = r, r = G + (y + S | 0) | 0, e[o + 4 >> 2] = r, $[r + c | 0] = 0, Yr = ke + 16 | 0;
                  return;
                }
                ba(), ri();
              }
              function Hu(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0, Fe = 0;
                ke = Yr - 16 | 0, Yr = ke;
                e: {
                  t: {
                    if (!r || (S = e[y + 12 >> 2], G = c - o | 0, (G | 0) > 0 && (G = G >>> 2 | 0, (_n[e[e[r >> 2] + 48 >> 2]](r, o, G) | 0) != (G | 0))))
                      break t;
                    if (o = h - o >> 2, S = (o | 0) < (S | 0) ? S - o | 0 : 0, (S | 0) > 0) {
                      if (o = Nh(ke + 4 | 0, S, g), g = (ye[o + 11 | 0] & 128) >>> 7 | 0 ? e[o >> 2] : o, e[5996] = 0, g = Si(217, r | 0, g | 0, S | 0) | 0, G = e[5996], e[5996] = 0, (G | 0) == 1)
                        break e;
                      if (qi(o), (g | 0) != (S | 0))
                        break t;
                    }
                    if (o = h - c | 0, (o | 0) > 0 && (o = o >>> 2 | 0, (_n[e[e[r >> 2] + 48 >> 2]](r, c, o) | 0) != (o | 0)))
                      break t;
                    e[y + 12 >> 2] = 0, Fe = r;
                  }
                  return Yr = ke + 16 | 0, Fe | 0;
                }
                r = Vr() | 0, qi(o), Ki(r | 0), ri();
              }
              function wh(r, o, c, h, y) {
                if (r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, Va(r, e[o + 8 >> 2], y)) {
                  e[o + 28 >> 2] == 1 | e[o + 4 >> 2] != (c | 0) || (e[o + 28 >> 2] = h);
                  return;
                }
                e: {
                  if (Va(r, e[o >> 2], y)) {
                    if (!(e[o + 16 >> 2] != (c | 0) & e[o + 20 >> 2] != (c | 0))) {
                      if ((h | 0) != 1)
                        break e;
                      e[o + 32 >> 2] = 1;
                      return;
                    }
                    e[o + 32 >> 2] = h;
                    t: {
                      if (e[o + 44 >> 2] == 4)
                        break t;
                      if (Vs[o + 52 >> 1] = 0, r = e[r + 8 >> 2], _n[e[e[r >> 2] + 20 >> 2]](r, o, c, c, 1, y), ye[o + 53 | 0]) {
                        if (e[o + 44 >> 2] = 3, !ye[o + 52 | 0])
                          break t;
                        break e;
                      }
                      e[o + 44 >> 2] = 4;
                    }
                    if (e[o + 20 >> 2] = c, e[o + 40 >> 2] = e[o + 40 >> 2] + 1, e[o + 36 >> 2] != 1 | e[o + 24 >> 2] != 2)
                      break e;
                    $[o + 54 | 0] = 1;
                    return;
                  }
                  r = e[r + 8 >> 2], _n[e[e[r >> 2] + 24 >> 2]](r, o, c, h, y);
                }
              }
              function Mo(r) {
                var o = 0, c = 0, h = 0, y = 0;
                if (y = Yr - 16 | 0, Yr = y, o = y + 4 | 0, e[o + 4 >> 2] = 190, e[o >> 2] = r, e[o + 8 >> 2] = 0, h = Yr - 16 | 0, Yr = h, e[r >> 2] != -1)
                  e: {
                    for (c = h + 12 | 0, e[c >> 2] = o, o = h + 8 | 0, e[o >> 2] = c; c = e[r >> 2], (c | 0) == 1; )
                      ;
                    t: {
                      if (!c) {
                        if (e[r >> 2] = 1, o = e[e[o >> 2] >> 2], e[5996] = 0, ko(191, o | 0), o = e[5996], e[5996] = 0, (o | 0) == 1)
                          break t;
                        e[r >> 2] = -1;
                      }
                      break e;
                    }
                    yu(Ts(0) | 0) | 0, e[r >> 2] = 0, e[5996] = 0, Ri(192), r = e[5996], e[5996] = 0;
                    t: {
                      if ((r | 0) == 1) {
                        if (r = Vr() | 0, e[5996] = 0, Ri(110), o = e[5996], e[5996] = 0, (o | 0) != 1)
                          break t;
                        Ts(0) | 0, va();
                      }
                      ri();
                    }
                    Ki(r | 0), ri();
                  }
                return Yr = h + 16 | 0, Yr = y + 16 | 0, e[r + 4 >> 2] - 1 | 0;
              }
              function bh(r, o, c, h, y, g, S) {
                for (r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, S = S | 0, c = Yr - 128 | 0, Yr = c, e[c + 12 >> 2] = c + 116, h = e[r + 8 >> 2], r = c + 16 | 0, Rp(h, r, c + 12 | 0, y, g, S), y = Yr - 16 | 0, Yr = y, S = Yr - 32 | 0, Yr = S, h = Yr - 16 | 0, Yr = h, e[h + 12 >> 2] = e[c + 12 >> 2], e[S + 24 >> 2] = r, e[S + 28 >> 2] = e[h + 12 >> 2], Yr = h + 16 | 0, g = e[S + 24 >> 2], r = e[S + 28 >> 2], h = Yr - 16 | 0, Yr = h, e[h + 12 >> 2] = o; ; ) {
                  if ((r | 0) != (g | 0)) {
                    c1(h + 12 | 0, $[g | 0]), g = g + 1 | 0;
                    continue;
                  }
                  break;
                }
                return e[S + 16 >> 2] = r, e[S + 20 >> 2] = e[h + 12 >> 2], Yr = h + 16 | 0, r = e[S + 16 >> 2], e[S + 12 >> 2] = e[S + 20 >> 2], e[y + 8 >> 2] = r, e[y + 12 >> 2] = e[S + 12 >> 2], Yr = S + 32 | 0, Yr = y + 16 | 0, Yr = c + 128 | 0, e[y + 12 >> 2];
              }
              function Eh(r, o, c, h) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0;
                var y = 0, g = 0;
                e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[5996] = 0, y = ii(3, 24) | 0, g = e[5996], e[5996] = 0;
                e: {
                  if ((g | 0) != 1) {
                    if (e[r + 4 >> 2] = y, e[r >> 2] = y, g = y + 24 | 0, e[r + 8 >> 2] = g, e[y >> 2] = e[o >> 2], e[y + 4 >> 2] = e[o + 4 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[r + 4 >> 2] = y + 8, e[y + 8 >> 2] = e[c >> 2], e[y + 12 >> 2] = e[c + 4 >> 2], e[c >> 2] = 0, e[c + 4 >> 2] = 0, o = y + 16 | 0, e[r + 4 >> 2] = o, o >>> 0 < g >>> 0) {
                      e[o >> 2] = e[h >> 2], e[o + 4 >> 2] = e[h + 4 >> 2], e[h >> 2] = 0, e[h + 4 >> 2] = 0, e[r + 4 >> 2] = o + 8;
                      break e;
                    }
                    if (e[5996] = 0, di(162, r | 0, h | 0), o = e[5996], e[5996] = 0, (o | 0) != 1)
                      break e;
                  }
                  o = Vr() | 0, xo(r), Ki(o | 0), ri();
                }
              }
              function Yg(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0;
                if (h = Yr - 16 | 0, Yr = h, e[r >> 2] = 7e3, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[h + 4 >> 2] = e[c >> 2], e[h + 8 >> 2] = e[c + 4 >> 2], e[h + 12 >> 2] = e[c + 8 >> 2], e[c + 8 >> 2] = 0, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[5996] = 0, da(64, r + 12 | 0, o | 0, h + 4 | 0, 0) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1) {
                  if (o = e[h + 4 >> 2], o) {
                    if (c = e[h + 8 >> 2], (o | 0) != (c | 0)) {
                      for (; ; ) {
                        c = c - 8 | 0, y = e[c + 4 >> 2];
                        e: {
                          if (!y || (g = e[y + 4 >> 2], e[y + 4 >> 2] = g - 1, g))
                            break e;
                          _n[e[e[y >> 2] + 8 >> 2]](y), cs(y);
                        }
                        if ((o | 0) == (c | 0))
                          break;
                      }
                      o = e[h + 4 >> 2];
                    }
                    Sr(o);
                  }
                  return Yr = h + 16 | 0, r | 0;
                }
                r = Vr() | 0, xo(h + 4 | 0), Ki(r | 0), ri();
              }
              function vu(r, o) {
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0;
                y = Yr - 16 | 0, Yr = y, ya(+o), S = js(1) | 0, c = js(0) | 0, h = S & 2147483647, g = h + -1048576 | 0;
                e: {
                  if ((g | 0) == 2145386495 | g >>> 0 < 2145386495) {
                    G = c << 28, c = (h & 15) << 28 | c >>> 4, h = (h >>> 4 | 0) + 1006632960 | 0;
                    break e;
                  }
                  if ((h | 0) == 2146435072 | h >>> 0 > 2146435072) {
                    G = c << 28, c = (S & 15) << 28 | c >>> 4, h = S >>> 4 | 2147418112;
                    break e;
                  }
                  if (!(c | h)) {
                    c = 0, h = 0;
                    break e;
                  }
                  g = c, c = h ? Do(h) : Do(c) + 32 | 0, ha(y, g, h, 0, 0, c + 49 | 0), ke = e[y >> 2], G = e[y + 4 >> 2], g = 15372 - c << 16, c = e[y + 8 >> 2], h = g | e[y + 12 >> 2] ^ 65536;
                }
                e[r >> 2] = ke, e[r + 4 >> 2] = G, e[r + 8 >> 2] = c, e[r + 12 >> 2] = S & -2147483648 | h, Yr = y + 16 | 0;
              }
              function Xg(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0, y = 0;
                if (c = e[r + 76 >> 2], (c | 0) == -1) {
                  c = r, h = Yr - 16 | 0, Yr = h, r = e[r + 28 >> 2], e[h + 12 >> 2] = r, e[r + 4 >> 2] = e[r + 4 >> 2] + 1, e[5996] = 0, r = ii(170, e[h + 12 >> 2]) | 0, o = e[5996], e[5996] = 0;
                  e: {
                    t: {
                      if ((o | 0) == 1 || (e[5996] = 0, r = On(171, r | 0, 32) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1))
                        break t;
                      o = e[h + 12 >> 2], y = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = y, (y | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o), Yr = h + 16 | 0;
                      break e;
                    }
                    o = Vr() | 0, r = e[h + 12 >> 2], c = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = c, (c | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(o | 0), ri();
                  }
                  o = c, c = r, e[o + 76 >> 2] = r;
                }
                return c << 24 >> 24;
              }
              function Bh(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0;
                if (c = e[r + 4 >> 2], h = e[r + 8 >> 2], c >>> 0 < h >>> 0) {
                  e[c >> 2] = o, e[r + 4 >> 2] = c + 4;
                  return;
                }
                e: {
                  if (S = e[r >> 2], y = c - S >> 2, g = y + 1 | 0, g >>> 0 < 1073741824) {
                    if (G = y << 2, h = h - S | 0, y = h >> 1, y = h >>> 0 >= 2147483644 ? 1073741823 : y >>> 0 > g >>> 0 ? y : g, y) {
                      if (y >>> 0 >= 1073741824)
                        break e;
                      g = xs(y << 2);
                    } else
                      g = 0;
                    if (h = G + g | 0, e[h >> 2] = o, o = h + 4 | 0, (c | 0) != (S | 0)) {
                      for (; h = h - 4 | 0, c = c - 4 | 0, e[h >> 2] = e[c >> 2], (c | 0) != (S | 0); )
                        ;
                      c = e[r >> 2];
                    }
                    e[r + 8 >> 2] = g + (y << 2), e[r + 4 >> 2] = o, e[r >> 2] = h, c && Sr(c);
                    return;
                  }
                  Lo(), ri();
                }
                su(), ri();
              }
              function vh(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0;
                var g = 0, S = 0;
                if (y = Yr - 16 | 0, Yr = y, g = xs(104), e[g >> 2] = 7e3, e[g + 4 >> 2] = 0, e[g + 8 >> 2] = 0, e[y + 4 >> 2] = e[c >> 2], e[y + 8 >> 2] = e[c + 4 >> 2], e[y + 12 >> 2] = e[c + 8 >> 2], e[c + 8 >> 2] = 0, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[5996] = 0, S = da(163, g + 12 | 0, o | 0, y + 4 | 0, h | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1) {
                  if (h = e[y + 4 >> 2], h) {
                    if (o = e[y + 8 >> 2], (h | 0) != (o | 0))
                      for (; c = o - 12 | 0, $[o - 1 | 0] < 0 && Sr(e[c >> 2]), o = c, (c | 0) != (h | 0); )
                        ;
                    Sr(h);
                  }
                  e[r + 4 >> 2] = g, e[r >> 2] = S, Yr = y + 16 | 0;
                  return;
                }
                r = Vr() | 0, Wo(y + 4 | 0), Sr(g), Ki(r | 0), ri();
              }
              function od(r, o, c, h) {
                var y = 0, g = 0, S = 0;
                y = Yr - 16 | 0, Yr = y;
                e: {
                  t: {
                    if ((r | 0) != (o | 0))
                      r: {
                        S = e[5732], e[5732] = 0, mo(), r = t6(r, y + 12 | 0, h), h = vs;
                        n: {
                          if (g = e[5732], g) {
                            if (e[y + 12 >> 2] != (o | 0))
                              break r;
                            if ((g | 0) != 68)
                              break n;
                            if (e[c >> 2] = 4, o = 2147483647, !!r & (h | 0) >= 0 | (h | 0) > 0)
                              break e;
                            break t;
                          }
                          if (e[5732] = S, e[y + 12 >> 2] == (o | 0))
                            break n;
                          break r;
                        }
                        if ((h | 0) < 0 & r >>> 0 <= 2147483647 | (h | 0) < -1) {
                          e[c >> 2] = 4;
                          break t;
                        }
                        if ((h | 0) >= 0 & r >>> 0 >= 2147483648 | (h | 0) > 0) {
                          e[c >> 2] = 4, o = 2147483647;
                          break e;
                        }
                        o = r;
                        break e;
                      }
                    e[c >> 2] = 4, o = 0;
                    break e;
                  }
                  o = -2147483648;
                }
                return Yr = y + 16 | 0, o;
              }
              function Ac(r, o, c, h, y, g) {
                var S = 0, G = 0, ke = 0, Fe = 0;
                e: {
                  if (g & 64) {
                    c = g + -64 | 0, o = c & 31, (c & 63) >>> 0 >= 32 ? (c = 0, o = y >>> o | 0) : (c = y >>> o | 0, o = ((1 << o) - 1 & y) << 32 - o | h >>> o), h = 0, y = 0;
                    break e;
                  }
                  if (!g)
                    break e;
                  ke = h, G = 64 - g | 0, S = G & 31, (G & 63) >>> 0 >= 32 ? (G = h << S, Fe = 0) : (G = (1 << S) - 1 & ke >>> 32 - S | y << S, Fe = ke << S), ke = o, o = g & 31, (g & 63) >>> 0 >= 32 ? (S = 0, o = c >>> o | 0) : (S = c >>> o | 0, o = ((1 << o) - 1 & c) << 32 - o | ke >>> o), o = Fe | o, c = S | G, S = h, h = g & 31, (g & 63) >>> 0 >= 32 ? (G = 0, h = y >>> h | 0) : (G = y >>> h | 0, h = ((1 << h) - 1 & y) << 32 - h | S >>> h), y = G;
                }
                e[r >> 2] = o, e[r + 4 >> 2] = c, e[r + 8 >> 2] = h, e[r + 12 >> 2] = y;
              }
              function gf(r, o, c) {
                var h = 0, y = 0, g = 0;
                h = Yr - 16 | 0, Yr = h, e[h + 12 >> 2] = o, e[o + 4 >> 2] = e[o + 4 >> 2] + 1, e[5996] = 0, o = ii(198, e[h + 12 >> 2]) | 0, y = e[5996], e[5996] = 0;
                e: {
                  if ((y | 0) == 1 || (e[5996] = 0, y = ii(206, o | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1) || (e[c >> 2] = y, e[5996] = 0, di(207, r | 0, o | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                    break e;
                  r = e[h + 12 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Yr = h + 16 | 0;
                  return;
                }
                c = Vr() | 0, r = e[h + 12 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
              }
              function pf(r, o, c) {
                var h = 0, y = 0, g = 0;
                h = Yr - 16 | 0, Yr = h, e[h + 12 >> 2] = o, e[o + 4 >> 2] = e[o + 4 >> 2] + 1, e[5996] = 0, o = ii(180, e[h + 12 >> 2]) | 0, y = e[5996], e[5996] = 0;
                e: {
                  if ((y | 0) == 1 || (e[5996] = 0, y = ii(193, o | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1) || ($[c | 0] = y, e[5996] = 0, di(194, r | 0, o | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                    break e;
                  r = e[h + 12 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Yr = h + 16 | 0;
                  return;
                }
                c = Vr() | 0, r = e[h + 12 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
              }
              function Ch(r) {
                return ye[25148] ? e[6286] : (ye[26240] || ($[26240] = 1), Io(25952, 18680), Io(25964, 18712), Io(25976, 18748), Io(25988, 18772), Io(26e3, 18796), Io(26012, 18812), Io(26024, 18832), Io(26036, 18852), Io(26048, 18880), Io(26060, 18920), Io(26072, 18952), Io(26084, 18988), Io(26096, 19024), Io(26108, 19040), Io(26120, 19056), Io(26132, 19072), Io(26144, 18796), Io(26156, 19088), Io(26168, 19104), Io(26180, 19120), Io(26192, 19136), Io(26204, 19152), Io(26216, 19168), Io(26228, 19184), $[25148] = 1, e[6286] = 25952, 25952);
              }
              function ad(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0, G = 0;
                g = Da(c);
                e: {
                  if (h = ye[r + 11 | 0], y = h & 127, h = (h & 128) >>> 7 | 0, y = h ? e[r + 4 >> 2] : y, y >>> 0 >= o >>> 0) {
                    if (h = h ? (e[r + 8 >> 2] & 2147483647) - 1 | 0 : 10, h - y >>> 0 >= g >>> 0) {
                      if (!g)
                        break e;
                      h = (ye[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r, G = h + o | 0, (o | 0) != (y | 0) && (S = o + h | 0, Jc(S + g | 0, S, y - o | 0), c = (c >>> 0 >= S >>> 0 && h + y >>> 0 > c >>> 0 ? g : 0) + c | 0), Jc(G, c, g), o = g + y | 0;
                      t: {
                        if ((ye[r + 11 | 0] & 128) >>> 7 | 0) {
                          e[r + 4 >> 2] = o;
                          break t;
                        }
                        $[r + 11 | 0] = o;
                      }
                      $[o + h | 0] = 0;
                      break e;
                    }
                    Rc(r, h, (g + y | 0) - h | 0, y, o, 0, g, c);
                    break e;
                  }
                  tc(), ri();
                }
                return r | 0;
              }
              function _g(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0;
                if (y = e[r + 4 >> 2], (y | 0) != e[r + 8 >> 2]) {
                  e[y >> 2] = o, e[r + 4 >> 2] = y + 4;
                  return;
                }
                e: {
                  if (S = e[r >> 2], g = y - S | 0, c = g >> 2, h = c + 1 | 0, h >>> 0 < 1073741824) {
                    if (G = c << 2, c = g >> 1, c = g >>> 0 >= 2147483644 ? 1073741823 : c >>> 0 > h >>> 0 ? c : h, c) {
                      if (c >>> 0 >= 1073741824)
                        break e;
                      g = xs(c << 2);
                    } else
                      g = 0;
                    if (h = G + g | 0, e[h >> 2] = o, o = h + 4 | 0, (y | 0) != (S | 0))
                      for (; h = h - 4 | 0, y = y - 4 | 0, e[h >> 2] = e[y >> 2], (y | 0) != (S | 0); )
                        ;
                    e[r + 8 >> 2] = g + (c << 2), e[r + 4 >> 2] = o, e[r >> 2] = h, S && Sr(S);
                    return;
                  }
                  Lo(), ri();
                }
                su(), ri();
              }
              function ha(r, o, c, h, y, g) {
                var S = 0, G = 0, ke = 0;
                e: {
                  if (g & 64) {
                    y = g + -64 | 0, g = o, h = y & 31, (y & 63) >>> 0 >= 32 ? (y = g << h, h = 0) : (y = (1 << h) - 1 & g >>> 32 - h | c << h, h = g << h), o = 0, c = 0;
                    break e;
                  }
                  if (!g)
                    break e;
                  G = h, S = g & 31, (g & 63) >>> 0 >= 32 ? (ke = h << S, G = 0) : (ke = (1 << S) - 1 & G >>> 32 - S | y << S, G = G << S), S = o, y = 64 - g | 0, h = y & 31, (y & 63) >>> 0 >= 32 ? (y = 0, h = c >>> h | 0) : (y = c >>> h | 0, h = ((1 << h) - 1 & c) << 32 - h | S >>> h), h = G | h, y = y | ke, G = o, S = g & 31, (g & 63) >>> 0 >= 32 ? (ke = o << S, o = 0) : (ke = (1 << S) - 1 & G >>> 32 - S | c << S, o = G << S), c = ke;
                }
                e[r >> 2] = o, e[r + 4 >> 2] = c, e[r + 8 >> 2] = h, e[r + 12 >> 2] = y;
              }
              function kh(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0, y = 0;
                if (y = e[r + 44 >> 2], y) {
                  if (o = y, h = e[r + 48 >> 2], (o | 0) != (h | 0)) {
                    for (; ; ) {
                      h = h - 8 | 0, c = e[h + 4 >> 2];
                      e: {
                        if (!c || (o = e[c + 4 >> 2], e[c + 4 >> 2] = o - 1, o))
                          break e;
                        _n[e[e[c >> 2] + 8 >> 2]](c), cs(c);
                      }
                      if ((h | 0) == (y | 0))
                        break;
                    }
                    o = e[r + 44 >> 2];
                  }
                  e[r + 48 >> 2] = y, Sr(o);
                }
                if (o = e[r + 32 >> 2], o && (e[r + 36 >> 2] = o, Sr(o)), c = e[r + 20 >> 2], c) {
                  if (h = c, o = e[r + 24 >> 2], (c | 0) != (o | 0)) {
                    for (; y = o - 12 | 0, $[o - 1 | 0] < 0 && Sr(e[y >> 2]), o = y, (c | 0) != (o | 0); )
                      ;
                    h = e[r + 20 >> 2];
                  }
                  e[r + 24 >> 2] = c, Sr(h);
                }
              }
              function Zg(r, o, c, h) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0;
                var y = 0, g = 0;
                y = Yr - 16 | 0, Yr = y, e[y >> 2] = c, e[y + 4 >> 2] = h, e[y + 8 >> 2] = c, e[y + 12 >> 2] = h, c = Yr - 32 | 0, Yr = c, o = Ga(c + 8 | 0, o), e[5996] = 0, h = c + 20 | 0, as(174, h | 0, y | 0, o | 0), g = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((g | 0) != 1) {
                        if (e[5996] = 0, r = On(175, r | 0, h | 0) | 0, g = e[5996], e[5996] = 0, (g | 0) == 1)
                          break r;
                        qi(h), qi(o), e[r >> 2] = 21872, o = e[y + 4 >> 2], e[r + 8 >> 2] = e[y >> 2], e[r + 12 >> 2] = o, Yr = c + 32 | 0;
                        break e;
                      }
                      r = Vr() | 0;
                      break t;
                    }
                    r = Vr() | 0, qi(c + 20 | 0);
                  }
                  qi(o), Ki(r | 0), ri();
                }
                return e[r >> 2] = 8492, Yr = y + 16 | 0, r | 0;
              }
              function $g(r) {
                return ye[25140] ? e[6284] : (ye[25936] || ($[25936] = 1), lo(25648, 1065), lo(25660, 1056), lo(25672, 2204), lo(25684, 2058), lo(25696, 1135), lo(25708, 2381), lo(25720, 1073), lo(25732, 1297), lo(25744, 1802), lo(25756, 1785), lo(25768, 1793), lo(25780, 1812), lo(25792, 2024), lo(25804, 2543), lo(25816, 1837), lo(25828, 1683), lo(25840, 1135), lo(25852, 1965), lo(25864, 2051), lo(25876, 2280), lo(25888, 1924), lo(25900, 1386), lo(25912, 1263), lo(25924, 2539), $[25140] = 1, e[6284] = 25648, 25648);
              }
              function Sh(r, o, c, h, y) {
                var g = 0, S = 0, G = 0, ke = 0;
                if (g = Yr - 16 | 0, Yr = g, 1073741807 - o >>> 0 >= c >>> 0) {
                  G = (ye[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r, S = g + 4 | 0, ke = S, o >>> 0 <= 536870886 ? (e[g + 12 >> 2] = o << 1, e[g + 4 >> 2] = o + c, c = e[(Ps[S >> 2] < Ps[g + 12 >> 2] ? g + 12 | 0 : S) >> 2], c >>> 0 >= 2 ? (S = c + 4 & -4, c = S - 1 | 0, c = (c | 0) == 2 ? S : c) : c = 1, c = c + 1 | 0) : c = 1073741807, bl(ke, c), c = e[g + 4 >> 2], y && nc(c, G, y), (h | 0) != (y | 0) && (S = y << 2, nc(S + c | 0, S + G | 0, h - y | 0)), (o | 0) != 1 && Sr(G), e[r >> 2] = c, e[r + 8 >> 2] = e[g + 8 >> 2] | -2147483648, Yr = g + 16 | 0;
                  return;
                }
                ba(), ri();
              }
              function el(r, o, c, h, y) {
                var g = 0, S = 0, G = 0, ke = 0;
                if (g = Yr - 16 | 0, Yr = g, 2147483631 - o >>> 0 >= c >>> 0) {
                  G = (ye[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r, S = g + 4 | 0, ke = S, o >>> 0 <= 1073741798 ? (e[g + 12 >> 2] = o << 1, e[g + 4 >> 2] = o + c, c = e[(Ps[S >> 2] < Ps[g + 12 >> 2] ? g + 12 | 0 : S) >> 2], c >>> 0 >= 11 ? (S = c + 16 & -16, c = S - 1 | 0, c = (c | 0) == 11 ? S : c) : c = 10, c = c + 1 | 0) : c = 2147483631, bc(ke, c), c = e[g + 4 >> 2], y && uc(c, G, y), (h | 0) != (y | 0) && uc(c + y | 0, y + G | 0, h - y | 0), (o | 0) != 10 && Sr(G), e[r >> 2] = c, e[r + 8 >> 2] = e[g + 8 >> 2] | -2147483648, Yr = g + 16 | 0;
                  return;
                }
                ba(), ri();
              }
              function ep(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0, G = 0;
                for (y = Yr - 16 | 0, Yr = y; ; ) {
                  e: {
                    if ((c | 0) <= (g | 0))
                      break e;
                    S = e[r + 16 >> 2], h = e[r + 12 >> 2];
                    t: {
                      if (S >>> 0 > h >>> 0) {
                        e[y + 12 >> 2] = 2147483647, e[y + 8 >> 2] = S - h, e[y + 4 >> 2] = c - g, G = o, S = h, o = y + 4 | 0, h = y + 8 | 0, o = e[o >> 2] < e[h >> 2] ? o : h, h = y + 12 | 0, h = e[(e[o >> 2] < e[h >> 2] ? o : h) >> 2], o = uc(G, S, h), e[r + 12 >> 2] = e[r + 12 >> 2] + h, o = o + h | 0;
                        break t;
                      }
                      if (h = _n[e[e[r >> 2] + 40 >> 2]](r) | 0, (h | 0) == -1)
                        break e;
                      $[o | 0] = h << 24 >> 24, h = 1, o = o + 1 | 0;
                    }
                    g = h + g | 0;
                    continue;
                  }
                  break;
                }
                return Yr = y + 16 | 0, g | 0;
              }
              function Th(r, o, c, h) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0;
                var y = 0, g = 0, S = 0;
                y = xs(56);
                e: {
                  t: {
                    if ((c | 0) == (h | 0)) {
                      h = 0, c = 0;
                      break t;
                    }
                    if (g = h - c | 0, (g | 0) < 0) {
                      if (e[5996] = 0, Ri(8), r = e[5996], e[5996] = 0, (r | 0) == 1)
                        break e;
                      ri();
                    }
                    if (e[5996] = 0, h = ii(3, g | 0) | 0, S = e[5996], e[5996] = 0, (S | 0) == 1)
                      break e;
                    c = _s(h, c, g) + g | 0;
                  }
                  return e[y + 4 >> 2] = 0, e[y + 8 >> 2] = 0, e[y >> 2] = o, e[y + 40 >> 2] = 0, e[y + 44 >> 2] = 0, e[y + 28 >> 2] = h, e[y + 12 >> 2] = 0, e[y + 16 >> 2] = 0, e[y + 20 >> 2] = 0, e[y + 24 >> 2] = 0, e[y + 36 >> 2] = c, e[y + 32 >> 2] = c, _u(r, y), y | 0;
                }
                r = Vr() | 0, Sr(y), Ki(r | 0), ri();
              }
              function nu(r, o, c) {
                var h = 0, y = 0;
                h = (c | 0) != 0;
                e: {
                  t: {
                    r: {
                      if (!(r & 3) | !c)
                        break r;
                      for (y = o & 255; ; ) {
                        if ((y | 0) == ye[r | 0])
                          break t;
                        if (c = c - 1 | 0, h = (c | 0) != 0, r = r + 1 | 0, !(r & 3))
                          break r;
                        if (!c)
                          break;
                      }
                    }
                    if (!h)
                      break e;
                    if (h = o & 255, !((h | 0) == ye[r | 0] | c >>> 0 < 4))
                      for (h = vi(h, 16843009); ; ) {
                        if (y = h ^ e[r >> 2], (y ^ -1) & y - 16843009 & -2139062144)
                          break t;
                        if (r = r + 4 | 0, c = c - 4 | 0, !(c >>> 0 > 3))
                          break;
                      }
                    if (!c)
                      break e;
                  }
                  for (o = o & 255; ; ) {
                    if ((o | 0) == ye[r | 0])
                      return r;
                    if (r = r + 1 | 0, c = c - 1 | 0, !c)
                      break;
                  }
                }
                return 0;
              }
              function tp(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0;
                e: {
                  if (!((ye[g + 11 | 0] & 128) >>> 7 | 0)) {
                    o = e[g + 4 >> 2], e[r >> 2] = e[g >> 2], e[r + 4 >> 2] = o, e[r + 8 >> 2] = e[g + 8 >> 2];
                    break e;
                  }
                  y = e[g >> 2], h = Yr - 16 | 0, Yr = h;
                  t: {
                    r: {
                      c = e[g + 4 >> 2];
                      n: {
                        if (c >>> 0 < 2) {
                          $[r + 11 | 0] = c;
                          break n;
                        }
                        if (c >>> 0 >= 1073741808)
                          break r;
                        S = h + 8 | 0, c >>> 0 >= 2 ? (g = c + 4 & -4, o = g - 1 | 0, o = (o | 0) == 2 ? g : o) : o = 1, bl(S, o + 1 | 0), o = e[h + 8 >> 2], e[r >> 2] = o, e[r + 8 >> 2] = e[h + 12 >> 2] | -2147483648, e[r + 4 >> 2] = c, r = o;
                      }
                      nc(r, y, c + 1 | 0), Yr = h + 16 | 0;
                      break t;
                    }
                    ba(), ri();
                  }
                }
              }
              function tl(r) {
                var o = 0, c = 0;
                e: {
                  o = e[r + 4 >> 2], o = e[e[o >> 2] - 12 >> 2] + o | 0;
                  t: {
                    if (!e[o + 24 >> 2] | e[o + 16 >> 2] | !(ye[o + 5 | 0] & 32) || (C1() | 0) > 0 || (o = e[r + 4 >> 2], o = e[(e[e[o >> 2] - 12 >> 2] + o | 0) + 24 >> 2], e[5996] = 0, o = ii(169, o | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1 && ((o | 0) != -1 || (r = e[r + 4 >> 2], o = e[e[r >> 2] - 12 >> 2], e[5996] = 0, di(138, r + o | 0, 1), r = e[5996], e[5996] = 0, (r | 0) != 1))))
                      break t;
                    if (yu(Ts(0) | 0) | 0, e[5996] = 0, Ri(110), r = e[5996], e[5996] = 0, (r | 0) == 1)
                      break e;
                  }
                  return;
                }
                Ts(0) | 0, va(), ri();
              }
              function xh(r, o, c, h) {
                var y = 0, g = 0, S = 0, G = 0;
                y = Yr - 16 | 0, Yr = y;
                e: {
                  t: {
                    if ((r | 0) != (o | 0))
                      r: {
                        n: {
                          if (g = ye[r | 0], (g | 0) != 45 || (r = r + 1 | 0, (o | 0) != (r | 0)))
                            break n;
                          break r;
                        }
                        G = e[5732], e[5732] = 0, mo(), r = f4(r, y + 12 | 0, h), h = vs, S = e[5732];
                        n: {
                          if (S) {
                            if (e[y + 12 >> 2] != (o | 0))
                              break r;
                            if (!h & r >>> 0 > 65535 | h | (S | 0) == 68)
                              break n;
                            break t;
                          }
                          if (e[5732] = G, e[y + 12 >> 2] != (o | 0))
                            break r;
                          if (!h & r >>> 0 < 65536)
                            break t;
                        }
                        e[c >> 2] = 4, r = 65535;
                        break e;
                      }
                    e[c >> 2] = 4, r = 0;
                    break e;
                  }
                  r = (g | 0) == 45 ? 0 - r | 0 : r;
                }
                return Yr = y + 16 | 0, r & 65535;
              }
              function ud(r, o) {
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0;
                y = Yr - 16 | 0, Yr = y, h = ye[r + 11 | 0], c = h << 24 >> 24, c = (c | 0) < 0, h = c ? e[r + 4 >> 2] : h;
                e: {
                  if (!h || (c = c ? e[r >> 2] : r, S = ye[c | 0], g = S - 9 & 255, g >>> 0 < 24 & (8388639 >>> g & 1)) || (g = ye[(c + h | 0) - 1 | 0] - 9 | 0, (g & 255) >>> 0 < 24 & (8388639 >>> g & 1)) || (S | 0) == 45 | (Da(c) | 0) != (h | 0) || (e[y + 12 >> 2] = 0, e[5732] = 0, r = _4($[r + 11 | 0] < 0 ? e[r >> 2] : r, y + 12 | 0, 10), c = vs, o && (e[o >> 2] = r, e[o + 4 >> 2] = c), r = e[y + 12 >> 2], !r | ye[r | 0]))
                    break e;
                  G = !e[5732];
                }
                return Yr = y + 16 | 0, G;
              }
              function Zu(r, o, c, h) {
                var y = 0, g = 0, S = 0, G = 0;
                y = Yr - 16 | 0, Yr = y;
                e: {
                  if ((r | 0) != (o | 0))
                    t: {
                      r: {
                        if (g = ye[r | 0], (g | 0) != 45 || (r = r + 1 | 0, (o | 0) != (r | 0)))
                          break r;
                        break t;
                      }
                      G = e[5732], e[5732] = 0, mo(), r = f4(r, y + 12 | 0, h), h = vs;
                      r: {
                        if (S = e[5732], S) {
                          if (e[y + 12 >> 2] != (o | 0))
                            break t;
                          if ((S | 0) != 68)
                            break r;
                          e[c >> 2] = 4, r = -1, o = -1;
                          break e;
                        }
                        if (e[5732] = G, e[y + 12 >> 2] == (o | 0))
                          break r;
                        break t;
                      }
                      o = r, c = (g | 0) == 45, r = c ? 0 - o | 0 : o, o = c ? 0 - (h + ((o | 0) != 0) | 0) | 0 : h;
                      break e;
                    }
                  e[c >> 2] = 4, r = 0, o = 0;
                }
                return Yr = y + 16 | 0, vs = o, r;
              }
              function rp(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0;
                if (h = Yr - 16 | 0, Yr = h, e[r >> 2] = 7e3, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[h + 4 >> 2] = e[c >> 2], e[h + 8 >> 2] = e[c + 4 >> 2], e[h + 12 >> 2] = e[c + 8 >> 2], e[c + 8 >> 2] = 0, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[5996] = 0, da(163, r + 12 | 0, o | 0, h + 4 | 0, 0) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1) {
                  if (y = e[h + 4 >> 2], y) {
                    if (o = e[h + 8 >> 2], (y | 0) != (o | 0))
                      for (; c = o - 12 | 0, $[o - 1 | 0] < 0 && Sr(e[c >> 2]), o = c, (c | 0) != (y | 0); )
                        ;
                    Sr(y);
                  }
                  return Yr = h + 16 | 0, r | 0;
                }
                r = Vr() | 0, Wo(h + 4 | 0), Ki(r | 0), ri();
              }
              function yf(r, o) {
                var c = 0, h = 0, y = 0, g = 0, S = 0;
                y = Yr - 16 | 0, Yr = y, h = ye[r + 11 | 0], c = h << 24 >> 24, c = (c | 0) < 0, h = c ? e[r + 4 >> 2] : h;
                e: {
                  if (!h || (c = c ? e[r >> 2] : r, g = ye[c | 0] - 9 & 255, g >>> 0 < 24 & (8388639 >>> g & 1)) || (g = ye[(c + h | 0) - 1 | 0] - 9 | 0, (g & 255) >>> 0 < 24 & (8388639 >>> g & 1)) || (Da(c) | 0) != (h | 0) || (e[y + 12 >> 2] = 0, e[5732] = 0, r = V4($[r + 11 | 0] < 0 ? e[r >> 2] : r, y + 12 | 0, 10), c = vs, o && (e[o >> 2] = r, e[o + 4 >> 2] = c), r = e[y + 12 >> 2], !r | ye[r | 0]))
                    break e;
                  S = !e[5732];
                }
                return Yr = y + 16 | 0, S;
              }
              function Dc(r, o) {
                var c = 0, h = 0;
                c = Yr - 16 | 0, Yr = c, e[c + 12 >> 2] = r, e[r + 4 >> 2] = e[r + 4 >> 2] + 1, e[5996] = 0, r = ii(197, e[c + 12 >> 2]) | 0, h = e[5996], e[5996] = 0;
                e: {
                  t: {
                    if ((h | 0) == 1 || (e[5996] = 0, Qs(208, r | 0, 12416, 12442, o | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                      break t;
                    r = e[c + 12 >> 2], h = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = h, (h | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Yr = c + 16 | 0;
                    break e;
                  }
                  h = Vr() | 0, r = e[c + 12 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(h | 0), ri();
                }
                return o;
              }
              function np(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0;
                if (S = Yr - 16 | 0, Yr = S, e[S + 12 >> 2] = o, o = e[h + 28 >> 2], e[S + 8 >> 2] = o, e[o + 4 >> 2] = e[o + 4 >> 2] + 1, e[5996] = 0, G = ii(170, e[S + 8 >> 2]) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)
                  return o = e[S + 8 >> 2], h = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = h, (h | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o), r1(r, g + 24 | 0, S + 12 | 0, c, y, G), Yr = S + 16 | 0, e[S + 12 >> 2];
                c = Vr() | 0, r = e[S + 8 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
              }
              function ip(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0;
                if (S = Yr - 16 | 0, Yr = S, e[S + 12 >> 2] = o, o = e[h + 28 >> 2], e[S + 8 >> 2] = o, e[o + 4 >> 2] = e[o + 4 >> 2] + 1, e[5996] = 0, G = ii(170, e[S + 8 >> 2]) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)
                  return o = e[S + 8 >> 2], h = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = h, (h | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o), Sd(r, g + 16 | 0, S + 12 | 0, c, y, G), Yr = S + 16 | 0, e[S + 12 >> 2];
                c = Vr() | 0, r = e[S + 8 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
              }
              function sp(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0;
                if (S = Yr - 16 | 0, Yr = S, e[S + 12 >> 2] = o, o = e[h + 28 >> 2], e[S + 8 >> 2] = o, e[o + 4 >> 2] = e[o + 4 >> 2] + 1, e[5996] = 0, G = ii(197, e[S + 8 >> 2]) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)
                  return o = e[S + 8 >> 2], h = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = h, (h | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o), n1(r, g + 24 | 0, S + 12 | 0, c, y, G), Yr = S + 16 | 0, e[S + 12 >> 2];
                c = Vr() | 0, r = e[S + 8 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
              }
              function Rh(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0;
                if (S = Yr - 16 | 0, Yr = S, e[S + 12 >> 2] = o, o = e[h + 28 >> 2], e[S + 8 >> 2] = o, e[o + 4 >> 2] = e[o + 4 >> 2] + 1, e[5996] = 0, G = ii(197, e[S + 8 >> 2]) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)
                  return o = e[S + 8 >> 2], h = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = h, (h | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o), e1(r, g + 16 | 0, S + 12 | 0, c, y, G), Yr = S + 16 | 0, e[S + 12 >> 2];
                c = Vr() | 0, r = e[S + 8 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
              }
              function cd(r, o) {
                e: {
                  if (r) {
                    if (o >>> 0 <= 127)
                      break e;
                    t: {
                      if (!e[e[6178] >> 2]) {
                        if ((o & -128) == 57216)
                          break e;
                        break t;
                      }
                      if (o >>> 0 <= 2047)
                        return $[r + 1 | 0] = o & 63 | 128, $[r | 0] = o >>> 6 | 192, 2;
                      if (!((o & -8192) != 57344 & o >>> 0 >= 55296))
                        return $[r + 2 | 0] = o & 63 | 128, $[r | 0] = o >>> 12 | 224, $[r + 1 | 0] = o >>> 6 & 63 | 128, 3;
                      if (o - 65536 >>> 0 <= 1048575)
                        return $[r + 3 | 0] = o & 63 | 128, $[r | 0] = o >>> 18 | 240, $[r + 2 | 0] = o >>> 6 & 63 | 128, $[r + 1 | 0] = o >>> 12 & 63 | 128, 4;
                    }
                    e[5732] = 25, r = -1;
                  } else
                    r = 1;
                  return r;
                }
                return $[r | 0] = o, 1;
              }
              function Ku(r) {
                var o = 0, c = 0, h = 0, y = 0, g = 0;
                e: {
                  if (h = r - 24 | 0, r = h, r >>> 0 < 27344 & r >>> 0 >= 26832) {
                    for (o = r - 4 | 0, y = e[6705], c = y; ; ) {
                      if (r = c, !(!r | (r | 0) == 27344)) {
                        if (c = fa[r + 2 >> 1], (r + (c << 2) | 0) == (o | 0)) {
                          Vs[r + 2 >> 1] = c + fa[h - 2 >> 1];
                          break e;
                        }
                        if ((r | 0) == ((fa[o + 2 >> 1] << 2) + o | 0)) {
                          if (c = h - 2 | 0, Vs[c >> 1] = fa[r + 2 >> 1] + fa[c >> 1], !g) {
                            e[6705] = o, Vs[o >> 1] = fa[r >> 1];
                            break e;
                          }
                          Vs[g >> 1] = o - 26832 >>> 2;
                          break e;
                        } else {
                          c = (fa[r >> 1] << 2) + 26832 | 0, g = r;
                          continue;
                        }
                      }
                      break;
                    }
                    Vs[o >> 1] = y - 26832 >>> 2, e[6705] = o;
                    break e;
                  }
                  Sr(h);
                }
              }
              function Dh(r, o, c, h, y) {
                var g = 0, S = 0, G = 0;
                G = -1, S = h & 2147483647, g = (S | 0) == 2147418112;
                e: {
                  if ((g & !c ? r | o : g & (c | 0) != 0 | S >>> 0 > 2147418112) || (g = y & 2147483647, ((g | 0) == 2147418112 & 0 | g >>> 0 > 2147418112) & (g | 0) != 2147418112))
                    break e;
                  if (!(r | c | (g | S | o)))
                    return 0;
                  if (g = h & y, (g | 0) > 0 | (g | 0) >= 0) {
                    if (((c | 0) != 0 | (h | 0) != (y | 0)) & (h | 0) < (y | 0))
                      break e;
                    return (r | c | (h ^ y | o)) != 0;
                  }
                  if (!c & (h | 0) == (y | 0) ? r | o : (c | 0) != 0 & (h | 0) >= (y | 0) | (h | 0) > (y | 0))
                    break e;
                  G = (r | c | (h ^ y | o)) != 0;
                }
                return G;
              }
              function fd(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0;
                if (r = Yr - 16 | 0, Yr = r, e[r + 12 >> 2] = o, o = e[h + 28 >> 2], e[r + 8 >> 2] = o, e[o + 4 >> 2] = e[o + 4 >> 2] + 1, e[5996] = 0, S = ii(170, e[r + 8 >> 2]) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)
                  return o = e[r + 8 >> 2], h = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = h, (h | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o), l1(g + 20 | 0, r + 12 | 0, c, y, S), Yr = r + 16 | 0, e[r + 12 >> 2];
                c = Vr() | 0, r = e[r + 8 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
              }
              function Nc(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0;
                if (r = Yr - 16 | 0, Yr = r, e[r + 12 >> 2] = o, o = e[h + 28 >> 2], e[r + 8 >> 2] = o, e[o + 4 >> 2] = e[o + 4 >> 2] + 1, e[5996] = 0, S = ii(197, e[r + 8 >> 2]) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1)
                  return o = e[r + 8 >> 2], h = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = h, (h | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o), f1(g + 20 | 0, r + 12 | 0, c, y, S), Yr = r + 16 | 0, e[r + 12 >> 2];
                c = Vr() | 0, r = e[r + 8 >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri();
              }
              function Nh(r, o, c) {
                var h = 0, y = 0, g = 0, S = 0, G = 0;
                y = r, S = Yr - 16 | 0, Yr = S;
                e: {
                  if (o >>> 0 < 1073741808) {
                    t: {
                      if (o >>> 0 < 2) {
                        $[y + 11 | 0] = o;
                        break t;
                      }
                      G = S + 8 | 0, o >>> 0 >= 2 ? (g = o + 4 & -4, h = g - 1 | 0, h = (h | 0) == 2 ? g : h) : h = 1, bl(G, h + 1 | 0), h = e[S + 8 >> 2], e[y >> 2] = h, e[y + 8 >> 2] = e[S + 12 >> 2] | -2147483648, e[y + 4 >> 2] = o, y = h;
                    }
                    for (g = Yr - 16 | 0, Yr = g, e[g + 12 >> 2] = c, c = y, h = o; ; ) {
                      if (h) {
                        e[c >> 2] = e[g + 12 >> 2], h = h - 1 | 0, c = c + 4 | 0;
                        continue;
                      }
                      break;
                    }
                    Yr = g + 16 | 0, e[(o << 2) + y >> 2] = 0, Yr = S + 16 | 0;
                    break e;
                  }
                  ba(), ri();
                }
                return r;
              }
              function oa(r, o, c, h, y, g, S, G, ke) {
                var Fe = 0, Ar = 0, hr = 0, Tr = 0;
                ke = so(o, c, G, ke), G = vs, y = so(h, y, g, S), ke = y + ke | 0, h = vs + G | 0, G = y >>> 0 > ke >>> 0 ? h + 1 | 0 : h, Fe = S, y = 0, Ar = c, h = 0, c = so(S, y, c, h), S = c + ke | 0, ke = vs + G | 0, hr = S, c = c >>> 0 > S >>> 0 ? ke + 1 | 0 : ke, S = so(g, 0, o, 0), G = vs, ke = 0, h = so(g, ke, Ar, h), G = G + h | 0, g = vs + ke | 0, g = h >>> 0 > G >>> 0 ? g + 1 | 0 : g, ke = g + hr | 0, h = c, g = g >>> 0 > ke >>> 0 ? h + 1 | 0 : h, o = so(o, Tr, Fe, y) + G | 0, y = vs, y = o >>> 0 < G >>> 0 ? y + 1 | 0 : y, G = y + ke | 0, ke = g, e[r + 8 >> 2] = G, e[r + 12 >> 2] = y >>> 0 > G >>> 0 ? ke + 1 | 0 : ke, e[r >> 2] = S, e[r + 4 >> 2] = o;
              }
              function Pc(r, o, c, h) {
                var y = 0, g = 0, S = 0, G = 0;
                y = Yr - 16 | 0, Yr = y;
                e: {
                  t: {
                    if ((r | 0) != (o | 0))
                      r: {
                        n: {
                          if (g = ye[r | 0], (g | 0) != 45 || (r = r + 1 | 0, (o | 0) != (r | 0)))
                            break n;
                          break r;
                        }
                        G = e[5732], e[5732] = 0, mo(), r = f4(r, y + 12 | 0, h), h = vs, S = e[5732];
                        n: {
                          if (S) {
                            if (e[y + 12 >> 2] != (o | 0))
                              break r;
                            if ((S | 0) == 68 | h)
                              break n;
                            break t;
                          }
                          if (e[5732] = G, e[y + 12 >> 2] != (o | 0))
                            break r;
                          if (!h)
                            break t;
                        }
                        e[c >> 2] = 4, r = -1;
                        break e;
                      }
                    e[c >> 2] = 4, r = 0;
                    break e;
                  }
                  r = (g | 0) == 45 ? 0 - r | 0 : r;
                }
                return Yr = y + 16 | 0, r;
              }
              function gc(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0;
                e: {
                  if (h = ye[r + 11 | 0], c = h & 127, h = (h & 128) >>> 7 | 0, c = h ? e[r + 4 >> 2] : c, c >>> 0 < o >>> 0) {
                    if (o = o - c | 0, o) {
                      h = h ? (e[r + 8 >> 2] & 2147483647) - 1 | 0 : 10, c = ye[r + 11 | 0], c = (c & 128) >>> 7 | 0 ? e[r + 4 >> 2] : c & 127, h - c >>> 0 < o >>> 0 && el(r, h, c + (o - h | 0) | 0, c, c), h = (ye[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r, Lc(h + c | 0, o, 0), o = o + c | 0;
                      t: {
                        if ((ye[r + 11 | 0] & 128) >>> 7 | 0) {
                          e[r + 4 >> 2] = o;
                          break t;
                        }
                        $[r + 11 | 0] = o;
                      }
                      $[o + h | 0] = 0;
                    }
                    break e;
                  }
                  Gc(r, (ye[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r, o);
                }
              }
              function Oo(r, o, c) {
                var h = 0, y = 0, g = 0;
                y = Yr - 16 | 0, Yr = y, e[o + 4 >> 2] = e[o + 4 >> 2] + 1, g = r + 8 | 0, h = y + 12 | 0, e[h >> 2] = o;
                e: {
                  if (o = e[r + 12 >> 2], r = e[r + 8 >> 2], o - r >> 2 >>> 0 <= c >>> 0) {
                    if (e[5996] = 0, di(274, g | 0, c + 1 | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                      break e;
                    r = e[g >> 2];
                  }
                  r = (c << 2) + r | 0, o = e[r >> 2], o && (r = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = r, (r | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o), r = e[g >> 2] + (c << 2) | 0), o = e[h >> 2], e[h >> 2] = 0, e[r >> 2] = o, u1(h), Yr = y + 16 | 0;
                  return;
                }
                r = Vr() | 0, u1(h), Ki(r | 0), ri();
              }
              function op(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0;
                h = Yr - 16 | 0, Yr = h;
                e: {
                  t: {
                    r: {
                      if ((o | 0) != (c | 0) && (c = c - o | 0, (c | 0) < 18))
                        break r;
                      $[r + 12 | 0] = 0, $[r | 0] = 0;
                      break t;
                    }
                    if (c >>> 0 >= 2147483632)
                      break e;
                    r: {
                      if (c >>> 0 <= 10) {
                        $[h + 15 | 0] = c, y = h + 4 | 0;
                        break r;
                      }
                      g = (c | 15) + 1 | 0, y = xs(g), e[h + 12 >> 2] = g | -2147483648, e[h + 4 >> 2] = y, e[h + 8 >> 2] = c;
                    }
                    $[_s(y, o, c) + c | 0] = 0, e[r + 8 >> 2] = e[h + 12 >> 2], o = e[h + 8 >> 2], e[r >> 2] = e[h + 4 >> 2], e[r + 4 >> 2] = o, $[r + 12 | 0] = 1;
                  }
                  Yr = h + 16 | 0;
                  return;
                }
                ba(), ri();
              }
              function $u(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0;
                y = Yr - 16 | 0, Yr = y;
                e: {
                  if (g = e[o >> 2], g) {
                    if (h = ye[c + 11 | 0], ((h & 128) >>> 7 | 0 ? e[c + 4 >> 2] : h & 127) && (J4(c, 5570), g = e[o >> 2]), h = y + 4 | 0, o = e[o + 4 >> 2], _n[e[e[o >> 2] + 24 >> 2]](h, o, g), e[5996] = 0, On(290, c | 0, h | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1)
                      break e;
                    qi(h);
                  }
                  o = e[c + 4 >> 2], e[r >> 2] = e[c >> 2], e[r + 4 >> 2] = o, e[r + 8 >> 2] = e[c + 8 >> 2], e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, Yr = y + 16 | 0;
                  return;
                }
                r = Vr() | 0, qi(y + 4 | 0), Ki(r | 0), ri();
              }
              function Ra(r) {
                var o = 0, c = 0, h = 0;
                if (o = e[r + 40 >> 2], o && (e[r + 44 >> 2] = o, Sr(o)), c = e[r + 28 >> 2], c) {
                  if (h = c, o = e[r + 32 >> 2], (c | 0) != (o | 0)) {
                    for (; h = o - 12 | 0, $[o - 1 | 0] < 0 && Sr(e[h >> 2]), o = h, (c | 0) != (o | 0); )
                      ;
                    h = e[r + 28 >> 2];
                  }
                  e[r + 32 >> 2] = c, Sr(h);
                }
                if (o = e[r + 16 >> 2], o && (e[r + 20 >> 2] = o, Sr(o)), c = e[r + 4 >> 2], c) {
                  if (o = c, h = e[r + 8 >> 2], (o | 0) != (h | 0)) {
                    for (; h = Ra(h - 56 | 0), (c | 0) != (h | 0); )
                      ;
                    o = e[r + 4 >> 2];
                  }
                  e[r + 8 >> 2] = c, Sr(o);
                }
                return r;
              }
              function ma(r, o, c, h) {
                var y = 0, g = 0, S = 0;
                e: {
                  if (y = ye[r + 11 | 0], !((y & 128) >>> 7 | 0 ? e[r + 4 >> 2] : y & 127) | (c - o | 0) < 5)
                    break e;
                  D2(o, c), y = c - 4 | 0, c = (ye[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r, g = e[r + 4 >> 2], r = ye[r + 11 | 0], S = c + ((r & 128) >>> 7 | 0 ? g : r & 127) | 0;
                  t: {
                    for (; ; ) {
                      r: {
                        if (r = $[c | 0], g = r - 127 | 0, o >>> 0 >= y >>> 0)
                          break r;
                        if ((r | 0) != e[o >> 2] & (g & 255) >>> 0 >= 130)
                          break t;
                        o = o + 4 | 0, c = ((S - c | 0) > 1) + c | 0;
                        continue;
                      }
                      break;
                    }
                    if ((g & 255) >>> 0 < 130 | r >>> 0 > e[y >> 2] - 1 >>> 0)
                      break e;
                  }
                  e[h >> 2] = 4;
                }
              }
              function mf(r) {
                var o = 0, c = 0, h = 0, y = 0, g = 0, S = 0, G = 0;
                if (h = e[r >> 2], h) {
                  if (o = h, c = e[r + 4 >> 2], (o | 0) != (c | 0)) {
                    for (; ; ) {
                      if (g = c - 12 | 0, y = e[g >> 2], y) {
                        if (o = y, S = c - 8 | 0, c = e[S >> 2], (o | 0) != (c | 0)) {
                          for (; ; ) {
                            c = c - 32 | 0, o = e[c + 4 >> 2];
                            e: {
                              if (!o || (G = e[o + 4 >> 2], e[o + 4 >> 2] = G - 1, G))
                                break e;
                              _n[e[e[o >> 2] + 8 >> 2]](o), cs(o);
                            }
                            if ((c | 0) == (y | 0))
                              break;
                          }
                          o = e[g >> 2];
                        }
                        e[S >> 2] = y, Sr(o);
                      }
                      if (c = g, (h | 0) == (c | 0))
                        break;
                    }
                    o = e[r >> 2];
                  }
                  e[r + 4 >> 2] = h, Sr(o);
                }
              }
              function rl(r, o, c) {
                var h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0;
                h = r, S = Yr - 16 | 0, Yr = S;
                e: {
                  if (g = c - o | 0, g >>> 0 < 2147483632) {
                    t: {
                      if (g >>> 0 < 11) {
                        $[h + 11 | 0] = g;
                        break t;
                      }
                      ke = S + 8 | 0, g >>> 0 >= 11 ? (G = g + 16 & -16, y = G - 1 | 0, y = (y | 0) == 11 ? G : y) : y = 10, bc(ke, y + 1 | 0), y = e[S + 8 >> 2], e[h >> 2] = y, e[h + 8 >> 2] = e[S + 12 >> 2] | -2147483648, e[h + 4 >> 2] = g, h = y;
                    }
                    for (; ; ) {
                      if ((o | 0) != (c | 0)) {
                        $[h | 0] = ye[o | 0], h = h + 1 | 0, o = o + 1 | 0;
                        continue;
                      }
                      break;
                    }
                    $[h | 0] = 0, Yr = S + 16 | 0;
                    break e;
                  }
                  ba(), ri();
                }
                return r;
              }
              function Ph(r, o, c) {
                var h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0;
                h = r, S = Yr - 16 | 0, Yr = S;
                e: {
                  if (g = c - o >> 2, g >>> 0 < 1073741808) {
                    t: {
                      if (g >>> 0 < 2) {
                        $[h + 11 | 0] = g;
                        break t;
                      }
                      ke = S + 8 | 0, g >>> 0 >= 2 ? (G = g + 4 & -4, y = G - 1 | 0, y = (y | 0) == 2 ? G : y) : y = 1, bl(ke, y + 1 | 0), y = e[S + 8 >> 2], e[h >> 2] = y, e[h + 8 >> 2] = e[S + 12 >> 2] | -2147483648, e[h + 4 >> 2] = g, h = y;
                    }
                    for (; ; ) {
                      if ((o | 0) != (c | 0)) {
                        e[h >> 2] = e[o >> 2], h = h + 4 | 0, o = o + 4 | 0;
                        continue;
                      }
                      break;
                    }
                    e[h >> 2] = 0, Yr = S + 16 | 0;
                    break e;
                  }
                  ba(), ri();
                }
                return r;
              }
              function ld(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0;
                o = !e[r + 24 >> 2] | (e[r + 16 >> 2] | o), e[r + 16 >> 2] = o, o & e[r + 20 >> 2] && (r = Yr - 16 | 0, Yr = r, c = ru(16), r = r + 8 | 0, o = Yr - 16 | 0, Yr = o, ye[24716] || ($[24716] = 1), e[o + 12 >> 2] = 22908, e[o + 8 >> 2] = 1, h = e[o + 12 >> 2], e[r >> 2] = e[o + 8 >> 2], e[r + 4 >> 2] = h, Yr = o + 16 | 0, o = e[r + 4 >> 2], r = e[r >> 2], e[5996] = 0, r = k1(176, c | 0, 1821, r | 0, o | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1 && (xa(r | 0, 8576, 177), ri()), r = Vr() | 0, Ku(c), Ki(r | 0), ri());
              }
              function dd(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0, G = 0;
                for (y = Yr - 16 | 0, Yr = y; ; ) {
                  e: {
                    if ((c | 0) <= (g | 0))
                      break e;
                    if (h = e[r + 24 >> 2], S = e[r + 28 >> 2], h >>> 0 >= S >>> 0) {
                      if ((_n[e[e[r >> 2] + 52 >> 2]](r, ye[o | 0]) | 0) == -1)
                        break e;
                      g = g + 1 | 0, o = o + 1 | 0;
                    } else
                      e[y + 12 >> 2] = S - h, e[y + 8 >> 2] = c - g, G = h, h = y + 8 | 0, S = y + 12 | 0, h = e[(e[h >> 2] < e[S >> 2] ? h : S) >> 2], uc(G, o, h), e[r + 24 >> 2] = h + e[r + 24 >> 2], g = h + g | 0, o = o + h | 0;
                    continue;
                  }
                  break;
                }
                return Yr = y + 16 | 0, g | 0;
              }
              function hd(r, o, c) {
                var h = 0, y = 0, g = 0, S = 0;
                return S = c & 63, g = S, y = g & 31, g >>> 0 >= 32 ? g = -1 >>> y | 0 : (h = -1 >>> y | 0, g = h | (1 << y) - 1 << 32 - y), g = g & r, h = o & h, y = S & 31, S >>> 0 >= 32 ? (h = g << y, S = 0) : (h = (1 << y) - 1 & g >>> 32 - y | h << y, S = g << y), g = h, y = 0 - c & 63, h = y & 31, y >>> 0 >= 32 ? (h = -1 << h, c = 0) : (c = -1 << h, h = c | (1 << h) - 1 & -1 >>> 32 - h), r = c & r, o = o & h, h = y & 31, y >>> 0 >= 32 ? (c = 0, r = o >>> h | 0) : (c = o >>> h | 0, r = ((1 << h) - 1 & o) << 32 - h | r >>> h), r = r | S, vs = c | g, r;
              }
              function Aa(r, o, c) {
                var h = 0, y = 0, g = 0;
                if (!(ye[r | 0] & 32))
                  e: {
                    h = o, o = r, r = e[o + 16 >> 2];
                    t: {
                      if (!r) {
                        if (vf(o))
                          break t;
                        r = e[o + 16 >> 2];
                      }
                      if (g = e[o + 20 >> 2], r - g >>> 0 < c >>> 0) {
                        _n[e[o + 36 >> 2]](o, h, c) | 0;
                        break e;
                      }
                      r: {
                        if (e[o + 80 >> 2] < 0)
                          break r;
                        for (r = c; ; ) {
                          if (y = r, !r)
                            break r;
                          if (r = r - 1 | 0, ye[h + r | 0] == 10)
                            break;
                        }
                        if (_n[e[o + 36 >> 2]](o, h, y) >>> 0 < y >>> 0)
                          break t;
                        h = h + y | 0, c = c - y | 0, g = e[o + 20 >> 2];
                      }
                      _s(g, h, c), e[o + 20 >> 2] = e[o + 20 >> 2] + c;
                    }
                  }
              }
              function ap(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0, g = 0, S = 0;
                y = e[r + 44 >> 2], c = e[r + 24 >> 2], y >>> 0 < c >>> 0 && (e[r + 44 >> 2] = c, y = c), c = e[r + 12 >> 2], g = e[r + 8 >> 2], h = -1;
                e: {
                  if (c >>> 0 <= g >>> 0)
                    break e;
                  if ((o | 0) == -1)
                    return e[r + 16 >> 2] = y, e[r + 12 >> 2] = c - 1, e[r + 8 >> 2] = g, ((o | 0) != -1 ? o : 0) | 0;
                  if (S = o << 24 >> 24, !(e[r + 48 >> 2] & 16) && (h = -1, (S | 0) != $[c - 1 | 0]))
                    break e;
                  e[r + 16 >> 2] = y, e[r + 12 >> 2] = c - 1, e[r + 8 >> 2] = g, $[e[r + 12 >> 2]] = S, h = o;
                }
                return h | 0;
              }
              function up(r, o, c) {
                r = r | 0, o = o | 0, c = +c;
                var h = 0, y = 0, g = 0;
                for (g = Yr - 16 | 0, Yr = g, h = ye[o + 11 | 0], h = (h & 128) >>> 7 | 0 ? e[o + 4 >> 2] : h & 127; ; ) {
                  e: {
                    y = (ye[o + 11 | 0] & 128) >>> 7 | 0 ? e[o >> 2] : o, Fi[g >> 3] = c, y = wl(y, h + 1 | 0, 2314, g);
                    t: {
                      if ((y | 0) >= 0) {
                        if (h >>> 0 >= y >>> 0)
                          break e;
                        h = y;
                        break t;
                      }
                      h = h << 1 | 1;
                    }
                    gc(o, h);
                    continue;
                  }
                  break;
                }
                gc(o, y), h = e[o + 4 >> 2], e[r >> 2] = e[o >> 2], e[r + 4 >> 2] = h, e[r + 8 >> 2] = e[o + 8 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, Yr = g + 16 | 0;
              }
              function qh(r, o, c) {
                var h = 0, y = 0, g = la(0), S = 0, G = la(0);
                y = Yr - 16 | 0, Yr = y;
                e: {
                  t: {
                    r: {
                      if ((r | 0) != (o | 0)) {
                        if (S = e[5732], e[5732] = 0, mo(), h = Yr - 16 | 0, Yr = h, wd(h, r, y + 12 | 0, 0), g = lh(e[h >> 2], e[h + 4 >> 2], e[h + 8 >> 2], e[h + 12 >> 2]), Yr = h + 16 | 0, r = e[5732], !r)
                          break r;
                        if (e[y + 12 >> 2] != (o | 0))
                          break t;
                        if (G = g, (r | 0) != 68)
                          break e;
                        break t;
                      }
                      e[c >> 2] = 4;
                      break e;
                    }
                    if (e[5732] = S, e[y + 12 >> 2] == (o | 0))
                      break e;
                  }
                  e[c >> 2] = 4, g = G;
                }
                return Yr = y + 16 | 0, g;
              }
              function Oh(r, o, c) {
                var h = 0, y = 0, g = 0, S = 0, G = 0;
                y = Yr - 16 | 0, Yr = y;
                e: {
                  t: {
                    r: {
                      if ((r | 0) != (o | 0)) {
                        if (S = e[5732], e[5732] = 0, mo(), h = Yr - 16 | 0, Yr = h, wd(h, r, y + 12 | 0, 1), g = Eu(e[h >> 2], e[h + 4 >> 2], e[h + 8 >> 2], e[h + 12 >> 2]), Yr = h + 16 | 0, r = e[5732], !r)
                          break r;
                        if (e[y + 12 >> 2] != (o | 0))
                          break t;
                        if (G = g, (r | 0) != 68)
                          break e;
                        break t;
                      }
                      e[c >> 2] = 4;
                      break e;
                    }
                    if (e[5732] = S, e[y + 12 >> 2] == (o | 0))
                      break e;
                  }
                  e[c >> 2] = 4, g = G;
                }
                return Yr = y + 16 | 0, g;
              }
              function cp(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0;
                y = (ye[r + 11 | 0] & 128) >>> 7 | 0 ? (e[r + 8 >> 2] & 2147483647) - 1 | 0 : 1, g = ye[r + 11 | 0], h = g, h = (h & 128) >>> 7 | 0 ? e[r + 4 >> 2] : h & 127;
                e: {
                  if (y - h >>> 0 >= c >>> 0) {
                    if (!c)
                      break e;
                    y = (g & 128) >>> 7 | 0 ? e[r >> 2] : r, nc(y + (h << 2) | 0, o, c), o = c + h | 0;
                    t: {
                      if ((ye[r + 11 | 0] & 128) >>> 7 | 0) {
                        e[r + 4 >> 2] = o;
                        break t;
                      }
                      $[r + 11 | 0] = o;
                    }
                    return e[y + (o << 2) >> 2] = 0, r | 0;
                  }
                  Ih(r, y, h + (c - y | 0) | 0, h, h, 0, c, o);
                }
                return r | 0;
              }
              function Qh(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0;
                for (var g = 0, S = 0, G = 0, ke = 0, Fe = 0, Ar = 0; ; ) {
                  e: {
                    if ((c | 0) == (h | 0) | y >>> 0 <= ke >>> 0)
                      break e;
                    S = 1, G = Yr - 16 | 0, Yr = G, g = xu(G + 12 | 0, e[r + 8 >> 2]), Fe = Zf(0, c, h - c | 0, o || 24840), g = e[g >> 2], g && (e[6178] = (g | 0) == -1 ? 24816 : g), Yr = G + 16 | 0;
                    t:
                      switch (Fe + 2 | 0) {
                        default:
                          S = Fe;
                          break;
                        case 0:
                        case 1:
                          break e;
                        case 2:
                          break t;
                      }
                    ke = ke + 1 | 0, Ar = S + Ar | 0, c = c + S | 0;
                    continue;
                  }
                  break;
                }
                return Ar | 0;
              }
              function If(r, o, c) {
                var h = 0, y = 0;
                for (c & 2048 && ($[r | 0] = 43, r = r + 1 | 0), c & 1024 && ($[r | 0] = 35, r = r + 1 | 0), h = c & 260, (h | 0) != 260 && ($[r | 0] = 46, $[r + 1 | 0] = 42, r = r + 2 | 0), c = c & 16384; ; ) {
                  if (y = ye[o | 0], y) {
                    $[r | 0] = y, r = r + 1 | 0, o = o + 1 | 0;
                    continue;
                  }
                  break;
                }
                e: {
                  t: {
                    if ((h | 0) != 256) {
                      if ((h | 0) != 4)
                        break t;
                      o = c ? 70 : 102;
                      break e;
                    }
                    o = c ? 69 : 101;
                    break e;
                  }
                  if (o = c ? 65 : 97, (h | 0) == 260)
                    break e;
                  o = c ? 71 : 103;
                }
                return $[r | 0] = o, (h | 0) != 260;
              }
              function Ad(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0;
                y = (ye[r + 11 | 0] & 128) >>> 7 | 0 ? (e[r + 8 >> 2] & 2147483647) - 1 | 0 : 10, g = ye[r + 11 | 0], h = g, h = (h & 128) >>> 7 | 0 ? e[r + 4 >> 2] : h & 127;
                e: {
                  if (y - h >>> 0 >= c >>> 0) {
                    if (!c)
                      break e;
                    y = (g & 128) >>> 7 | 0 ? e[r >> 2] : r, uc(y + h | 0, o, c), o = c + h | 0;
                    t: {
                      if ((ye[r + 11 | 0] & 128) >>> 7 | 0) {
                        e[r + 4 >> 2] = o;
                        break t;
                      }
                      $[r + 11 | 0] = o;
                    }
                    return $[o + y | 0] = 0, r | 0;
                  }
                  Rc(r, y, h + (c - y | 0) | 0, h, h, 0, c, o);
                }
                return r | 0;
              }
              function fp(r, o, c, h, y) {
                if (r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, Va(r, e[o + 8 >> 2], y)) {
                  e[o + 28 >> 2] == 1 | e[o + 4 >> 2] != (c | 0) || (e[o + 28 >> 2] = h);
                  return;
                }
                e: {
                  if (!Va(r, e[o >> 2], y))
                    break e;
                  if (!(e[o + 16 >> 2] != (c | 0) & e[o + 20 >> 2] != (c | 0))) {
                    if ((h | 0) != 1)
                      break e;
                    e[o + 32 >> 2] = 1;
                    return;
                  }
                  e[o + 20 >> 2] = c, e[o + 32 >> 2] = h, e[o + 40 >> 2] = e[o + 40 >> 2] + 1, e[o + 36 >> 2] != 1 | e[o + 24 >> 2] != 2 || ($[o + 54 | 0] = 1), e[o + 44 >> 2] = 4;
                }
              }
              function Uh(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0;
                if (y = Yr - 16 | 0, Yr = y, ke = e[o >> 2], h = e[c >> 2], S = e[r >> 2], g = h - S | 0, g = g >>> 0 >= 2147483647 ? -1 : (h | 0) == (S | 0) ? 4 : g << 1, h = e[r + 4 >> 2] == 220, G = of(h ? 0 : S, g), G) {
                  h || (e[r >> 2] = 0), e[y + 4 >> 2] = 184, h = y + 8 | 0, e[h >> 2] = G, e[h + 4 >> 2] = e[y + 4 >> 2], r = li(r, h), Js(h), e[o >> 2] = e[r >> 2] + (ke - S | 0), e[c >> 2] = e[r >> 2] + (g & -4), Yr = y + 16 | 0;
                  return;
                }
                bs(), ri();
              }
              function gd(r, o) {
                r = r | 0, o = +o;
                var c = 0, h = 0, y = 0;
                if (h = Yr - 16 | 0, Yr = h, c = h + 4 | 0, e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[c + 8 >> 2] = 0, y = (ye[c + 11 | 0] & 128) >>> 7 | 0 ? (e[c + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, di(172, c | 0, y | 0), y = e[5996], e[5996] = 0, (y | 0) == 1 && (r = Vr() | 0, qi(c), Ki(r | 0), ri()), e[5996] = 0, Tl(120, r | 0, c | 0, +o), r = e[5996], e[5996] = 0, (r | 0) != 1) {
                  qi(c), Yr = h + 16 | 0;
                  return;
                }
                r = Vr() | 0, qi(h + 4 | 0), Ki(r | 0), ri();
              }
              function nl(r, o) {
                var c = 0, h = 0, y = 0, g = 0, S = 0, G = 0;
                c = ye[r + 11 | 0], h = c << 24 >> 24, g = e[o + 4 >> 2], h = (h | 0) < 0, c = h ? e[r + 4 >> 2] : c;
                e: {
                  if (g >>> 0 < c + 2 >>> 0 || (y = e[o >> 2], S = c + y | 0, ye[S | 0] != 40 | ye[(y + g | 0) - 1 | 0] != 41))
                    break e;
                  if (c)
                    for (r = h ? e[r >> 2] : r, h = c + r | 0; ; ) {
                      if (ye[r | 0] != ye[y | 0])
                        return 0;
                      if (y = y + 1 | 0, r = r + 1 | 0, (h | 0) == (r | 0))
                        break;
                    }
                  e[o + 4 >> 2] = (g - c | 0) - 2, G = 1, e[o >> 2] = S + 1;
                }
                return G;
              }
              function Mh(r, o, c, h) {
                var y = 0, g = 0, S = 0;
                y = Yr - 16 | 0, Yr = y;
                e: {
                  if ((r | 0) != (o | 0)) {
                    S = e[5732], e[5732] = 0, mo(), r = t6(r, y + 12 | 0, h), h = vs, g = e[5732];
                    t: {
                      if (g) {
                        if (e[y + 12 >> 2] != (o | 0))
                          break t;
                        if ((g | 0) != 68)
                          break e;
                        e[c >> 2] = 4, o = !!r & (h | 0) >= 0 | (h | 0) > 0, r = o ? -1 : 0, h = o ? 2147483647 : -2147483648;
                        break e;
                      }
                      if (e[5732] = S, e[y + 12 >> 2] == (o | 0))
                        break e;
                    }
                  }
                  e[c >> 2] = 4, r = 0, h = 0;
                }
                return Yr = y + 16 | 0, vs = h, r;
              }
              function lp(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0, G = 0;
                return y = e[r + 84 >> 2], g = e[y >> 2], h = e[y + 4 >> 2], G = e[r + 28 >> 2], S = e[r + 20 >> 2] - G | 0, S = h >>> 0 < S >>> 0 ? h : S, S && (_s(g, G, S), g = S + e[y >> 2] | 0, e[y >> 2] = g, h = e[y + 4 >> 2] - S | 0, e[y + 4 >> 2] = h), h = c >>> 0 > h >>> 0 ? h : c, h && (_s(g, o, h), g = h + e[y >> 2] | 0, e[y >> 2] = g, e[y + 4 >> 2] = e[y + 4 >> 2] - h), $[g | 0] = 0, o = e[r + 44 >> 2], e[r + 28 >> 2] = o, e[r + 20 >> 2] = o, c | 0;
              }
              function dp(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0, G = 0, ke = 0;
                if (y = Yr - 16 | 0, Yr = y, ke = e[o >> 2], S = e[r >> 2], h = e[c >> 2] - S | 0, g = h << 1, g = h >>> 0 >= 2147483647 ? -1 : g >>> 0 <= 1 ? 1 : g, h = e[r + 4 >> 2] == 220, G = of(h ? 0 : S, g), G) {
                  h || (e[r >> 2] = 0), e[y + 4 >> 2] = 184, h = y + 8 | 0, e[h >> 2] = G, e[h + 4 >> 2] = e[y + 4 >> 2], r = li(r, h), Js(h), e[o >> 2] = e[r >> 2] + (ke - S | 0), e[c >> 2] = g + e[r >> 2], Yr = y + 16 | 0;
                  return;
                }
                bs(), ri();
              }
              function pd(r, o, c, h) {
                $[r + 53 | 0] = 1;
                e: {
                  if (e[r + 4 >> 2] != (c | 0))
                    break e;
                  $[r + 52 | 0] = 1, c = e[r + 16 >> 2];
                  t: {
                    if (!c) {
                      if (e[r + 36 >> 2] = 1, e[r + 24 >> 2] = h, e[r + 16 >> 2] = o, (h | 0) != 1)
                        break e;
                      if (e[r + 48 >> 2] == 1)
                        break t;
                      break e;
                    }
                    if ((o | 0) == (c | 0)) {
                      if (c = e[r + 24 >> 2], (c | 0) == 2 && (e[r + 24 >> 2] = h, c = h), e[r + 48 >> 2] != 1)
                        break e;
                      if ((c | 0) == 1)
                        break t;
                      break e;
                    }
                    e[r + 36 >> 2] = e[r + 36 >> 2] + 1;
                  }
                  $[r + 54 | 0] = 1;
                }
              }
              function hp(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0;
                h = Yr + -64 | 0, Yr = h, y = 1;
                e: {
                  if (Va(r, o, 0) || (y = 0, !o) || (o = Yf(o, 22104), y = 0, !o))
                    break e;
                  Ya(h + 12 | 0, 0, 52), e[h + 56 >> 2] = 1, e[h + 20 >> 2] = -1, e[h + 16 >> 2] = r, e[h + 8 >> 2] = o, _n[e[e[o >> 2] + 28 >> 2]](o, h + 8 | 0, e[c >> 2], 1), r = e[h + 32 >> 2], (r | 0) == 1 && (e[c >> 2] = e[h + 24 >> 2]), y = (r | 0) == 1;
                }
                return r = y, Yr = h - -64 | 0, r | 0;
              }
              function Fh(r) {
                return ye[25132] ? e[6282] : (ye[25640] || ($[25640] = 1), Io(25472, 18340), Io(25484, 18368), Io(25496, 18396), Io(25508, 18428), Io(25520, 18468), Io(25532, 18504), Io(25544, 18532), Io(25556, 18568), Io(25568, 18584), Io(25580, 18600), Io(25592, 18616), Io(25604, 18632), Io(25616, 18648), Io(25628, 18664), $[25132] = 1, e[6282] = 25472, 25472);
              }
              function yd(r) {
                r = r | 0;
                var o = 0, c = 0;
                o = e[r + 80 >> 2];
                e: {
                  if (!o | Ps[r + 84 >> 2] > 3600 || uu(3557, 1) & (o ^ -1) || (o = e[r + 80 >> 2], !o | Ps[r + 84 >> 2] > 3600 | (e[r + 52 >> 2] + e[r + 44 >> 2] >>> 0 > 201 | Ps[r + 68 >> 2] > 100)) || uu(2049, 1) & (o ^ -1) || (o = e[r + 80 >> 2], uu(2165, 1) & (o ^ -1) | ye[r + 88 | 0]))
                    break e;
                  r = e[r + 80 >> 2], c = !(uu(1681, 1) & (r ^ -1));
                }
                return c | 0;
              }
              function il(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0, S = 0;
                y = Yr - 16 | 0, Yr = y;
                e: {
                  t: {
                    if (c >>> 0 < 11) {
                      $[r + 11 | 0] = c;
                      break t;
                    }
                    if (c >>> 0 >= 2147483632)
                      break e;
                    S = y + 8 | 0, c >>> 0 >= 11 ? (g = c + 16 & -16, h = g - 1 | 0, h = (h | 0) == 11 ? g : h) : h = 10, bc(S, h + 1 | 0), h = e[y + 8 >> 2], e[r >> 2] = h, e[r + 8 >> 2] = e[y + 12 >> 2] | -2147483648, e[r + 4 >> 2] = c, r = h;
                  }
                  uc(r, o, c + 1 | 0), Yr = y + 16 | 0;
                  return;
                }
                ba(), ri();
              }
              function Io(r, o) {
                var c = 0, h = 0, y = 0, g = 0;
                e: {
                  if (c = A1(o), h = (ye[r + 11 | 0] & 128) >>> 7 | 0 ? (e[r + 8 >> 2] & 2147483647) - 1 | 0 : 1, c >>> 0 <= h >>> 0) {
                    o = Ks((ye[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r, o, c << 2);
                    t: {
                      if ((ye[r + 11 | 0] & 128) >>> 7 | 0) {
                        e[r + 4 >> 2] = c;
                        break t;
                      }
                      $[r + 11 | 0] = c;
                    }
                    e[(c << 2) + o >> 2] = 0;
                    break e;
                  }
                  y = r, g = e[r + 4 >> 2], r = ye[r + 11 | 0], r = (r & 128) >>> 7 | 0 ? g : r & 127, Ih(y, h, c - h | 0, r, 0, r, c, o);
                }
              }
              function La(r) {
                var o = 0, c = 0, h = 0;
                if (h = e[r >> 2], h) {
                  if (o = e[r + 4 >> 2], c = h, (o | 0) != (c | 0)) {
                    for (; c = o - 32 | 0, (ye[c | 0] | ye[c + 1 | 0] << 8 | (ye[c + 2 | 0] << 16 | ye[c + 3 | 0] << 24)) >>> 0 >= 29 && (o = o - 24 | 0, Sr(ye[o | 0] | ye[o + 1 | 0] << 8 | (ye[o + 2 | 0] << 16 | ye[o + 3 | 0] << 24)), $[o | 0] = 0, $[o + 1 | 0] = 0, $[o + 2 | 0] = 0, $[o + 3 | 0] = 0), o = c, (h | 0) != (o | 0); )
                      ;
                    c = e[r >> 2];
                  }
                  e[r + 4 >> 2] = h, Sr(c);
                }
              }
              function Ap(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0;
                return $[r + 6 | 0] = 0, Vs[r + 4 >> 1] = 0, e[r >> 2] = 1, c = e[o >> 2], h = e[o + 4 >> 2], e[r + 20 >> 2] = 0, e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 8 >> 2] = (h - c | 0) + 1, c = xs(12), e[r + 16 >> 2] = c, e[r + 12 >> 2] = c, h = c + 12 | 0, e[r + 20 >> 2] = h, e[c >> 2] = e[o >> 2], e[c + 4 >> 2] = e[o + 4 >> 2], e[c + 8 >> 2] = e[o + 8 >> 2], e[o + 8 >> 2] = 0, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[r + 16 >> 2] = h, r | 0;
              }
              function gp(r, o, c, h) {
                r = r | 0, o = o | 0, c = c | 0, h = +h;
                var y = 0, g = 0, S = 0, G = 0;
                return y = xs(56), g = e[c + 8 >> 2], e[c + 8 >> 2] = 0, S = e[c >> 2], G = e[c + 4 >> 2], e[c >> 2] = 0, e[c + 4 >> 2] = 0, e[y + 16 >> 2] = 0, e[y + 20 >> 2] = 0, e[y + 12 >> 2] = g, e[y + 4 >> 2] = S, e[y + 8 >> 2] = G, e[y >> 2] = o, e[y + 24 >> 2] = 0, e[y + 28 >> 2] = 0, e[y + 32 >> 2] = 0, e[y + 36 >> 2] = 0, e[y + 40 >> 2] = 0, e[y + 44 >> 2] = 0, Fi[y + 48 >> 3] = h, _u(r, y), y | 0;
              }
              function pp(r) {
                return ye[25124] ? e[6280] : (ye[25464] || ($[25464] = 1), lo(25296, 1114), lo(25308, 1121), lo(25320, 1087), lo(25332, 1095), lo(25344, 1078), lo(25356, 1128), lo(25368, 1105), lo(25380, 1961), lo(25392, 1999), lo(25404, 2336), lo(25416, 2493), lo(25428, 1273), lo(25440, 2172), lo(25452, 1390), $[25124] = 1, e[6280] = 25296, 25296);
              }
              function pc(r, o) {
                var c = 0, h = 0, y = 0, g = 0, S = 0;
                e: {
                  if (c = A1(o), y = Yr - 16 | 0, Yr = y, c >>> 0 < 1073741808) {
                    t: {
                      if (c >>> 0 < 2) {
                        $[r + 11 | 0] = c;
                        break t;
                      }
                      S = y + 8 | 0, c >>> 0 >= 2 ? (g = c + 4 & -4, h = g - 1 | 0, h = (h | 0) == 2 ? g : h) : h = 1, bl(S, h + 1 | 0), h = e[y + 8 >> 2], e[r >> 2] = h, e[r + 8 >> 2] = e[y + 12 >> 2] | -2147483648, e[r + 4 >> 2] = c, r = h;
                    }
                    e[nc(r, o, c) + (c << 2) >> 2] = 0, Yr = y + 16 | 0;
                    break e;
                  }
                  ba(), ri();
                }
              }
              function fu(r, o, c, h) {
                var y = 0, g = 0, S = 0, G = 0;
                y = Yr - 16 | 0, Yr = y, e[y + 12 >> 2] = h, S = xu(y + 8 | 0, o), o = Yr - 16 | 0, Yr = o, h = e[y + 12 >> 2], e[o + 12 >> 2] = h, e[o + 8 >> 2] = h, g = -1, h = Jf(0, 0, c, h);
                e: {
                  if ((h | 0) < 0 || (G = r, h = h + 1 | 0, r = ia(h), e[G >> 2] = r, !r))
                    break e;
                  g = Jf(r, h, c, e[o + 12 >> 2]);
                }
                return Yr = o + 16 | 0, r = e[S >> 2], r && (e[6178] = (r | 0) == -1 ? 24816 : r), Yr = y + 16 | 0, g;
              }
              function yp(r, o, c) {
                r = r | 0, o = o | 0, c = +c;
                var h = 0, y = 0, g = 0, S = 0;
                return h = xs(56), y = e[o + 8 >> 2], e[o + 8 >> 2] = 0, g = e[o >> 2], S = e[o + 4 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[h + 16 >> 2] = 0, e[h + 20 >> 2] = 0, e[h + 12 >> 2] = y, e[h + 4 >> 2] = g, e[h + 8 >> 2] = S, e[h >> 2] = 12, e[h + 24 >> 2] = 0, e[h + 28 >> 2] = 0, e[h + 32 >> 2] = 0, e[h + 36 >> 2] = 0, e[h + 40 >> 2] = 0, e[h + 44 >> 2] = 0, Fi[h + 48 >> 3] = c, _u(r, h), h | 0;
              }
              function md(r) {
                var o = 0;
                o = 1;
                e: {
                  if ((r | 0) >= 1024) {
                    if (o = 898846567431158e293, r >>> 0 < 2047) {
                      r = r - 1023 | 0;
                      break e;
                    }
                    o = 1 / 0, r = ((r | 0) >= 3069 ? 3069 : r) - 2046 | 0;
                    break e;
                  }
                  if ((r | 0) > -1023)
                    break e;
                  if (o = 2004168360008973e-307, r >>> 0 > 4294965304) {
                    r = r + 969 | 0;
                    break e;
                  }
                  o = 0, r = ((r | 0) <= -2960 ? -2960 : r) + 1938 | 0;
                }
                return jo(0, 0), jo(1, r + 1023 << 20), o * +za();
              }
              function sl(r) {
                var o = 0, c = 0, h = 0, y = 0;
                if (r) {
                  if (sl(e[r >> 2]), sl(e[r + 4 >> 2]), h = e[r + 40 >> 2], h) {
                    if (o = h, c = e[r + 44 >> 2], (o | 0) != (c | 0)) {
                      for (; ; ) {
                        c = c - 32 | 0, o = e[c + 4 >> 2];
                        e: {
                          if (!o || (y = e[o + 4 >> 2], e[o + 4 >> 2] = y - 1, y))
                            break e;
                          _n[e[e[o >> 2] + 8 >> 2]](o), cs(o);
                        }
                        if ((h | 0) == (c | 0))
                          break;
                      }
                      o = e[r + 40 >> 2];
                    }
                    e[r + 44 >> 2] = h, Sr(o);
                  }
                  Sr(r);
                }
              }
              function mp(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0;
                var g = 0, S = 0;
                S = Yr - 16 | 0, Yr = S, e[y >> 2] = c, o = S + 12 | 0, r = ml(o, 0, e[r + 8 >> 2]), g = 2;
                e: {
                  if (r + 1 >>> 0 < 2 || (c = r - 1 | 0, g = 1, c >>> 0 > h - e[y >> 2] >>> 0))
                    break e;
                  for (; ; ) {
                    if (c) {
                      r = ye[o | 0], h = e[y >> 2], e[y >> 2] = h + 1, $[h | 0] = r, c = c - 1 | 0, o = o + 1 | 0;
                      continue;
                    }
                    break;
                  }
                  g = 0;
                }
                return r = g, Yr = S + 16 | 0, r | 0;
              }
              function Cu(r, o, c, h) {
                var y = 0;
                e: {
                  if (!(h & 2048) || (y = h & 74, !c | ((y | 0) == 8 | (y | 0) == 64)))
                    break e;
                  $[r | 0] = 43, r = r + 1 | 0;
                }
                for (h & 512 && ($[r | 0] = 35, r = r + 1 | 0); ; ) {
                  if (y = ye[o | 0], y) {
                    $[r | 0] = y, r = r + 1 | 0, o = o + 1 | 0;
                    continue;
                  }
                  break;
                }
                y = h & 74, o = 111;
                e: {
                  if ((y | 0) == 64 || (o = h & 16384 ? 88 : 120, (y | 0) == 8))
                    break e;
                  o = c ? 100 : 117;
                }
                $[r | 0] = o;
              }
              function ol(r) {
                var o = 0, c = 0, h = 0;
                if (o = e[r >> 2], e[r >> 2] = 0, o) {
                  if (r = e[o + 28 >> 2], r && (e[o + 32 >> 2] = r, Sr(r)), c = e[o + 16 >> 2], c) {
                    if (r = c, h = e[o + 20 >> 2], (r | 0) != (h | 0)) {
                      for (; r = h - 12 | 0, $[h - 1 | 0] < 0 && Sr(e[r >> 2]), h = r, (r | 0) != (c | 0); )
                        ;
                      r = e[o + 16 >> 2];
                    }
                    e[o + 20 >> 2] = c, Sr(r);
                  }
                  r = e[o + 4 >> 2], r && (e[o + 8 >> 2] = r, Sr(r)), Sr(o);
                }
              }
              function Ip(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0;
                if (e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[5996] = 0, c = ii(3, 12) | 0, h = e[5996], e[5996] = 0, (h | 0) != 1) {
                  e[r >> 2] = c, h = c + 12 | 0, e[r + 8 >> 2] = h, e[c + 8 >> 2] = e[o + 8 >> 2], y = e[o + 4 >> 2], e[c >> 2] = e[o >> 2], e[c + 4 >> 2] = y, e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[o + 8 >> 2] = 0, e[r + 4 >> 2] = h;
                  return;
                }
                o = Vr() | 0, Wo(r), Ki(o | 0), ri();
              }
              function wp(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0;
                return S = Yr - 32 | 0, Yr = S, G = e[3163], e[S + 24 >> 2] = e[3162], e[S + 28 >> 2] = G, G = e[3161], e[S + 16 >> 2] = e[3160], e[S + 20 >> 2] = G, G = e[3159], e[S + 8 >> 2] = e[3158], e[S + 12 >> 2] = G, G = e[3157], e[S >> 2] = e[3156], e[S + 4 >> 2] = G, G = r, r = S + 32 | 0, o = Mu(G, o, c, h, y, g, S, r), Yr = r, o | 0;
              }
              function bp(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0, y = 0;
                c = e[r + 44 >> 2], o = e[r + 24 >> 2], c >>> 0 < o >>> 0 && (e[r + 44 >> 2] = o, c = o), h = -1;
                e: {
                  if (!(ye[r + 48 | 0] & 8) || (o = e[r + 16 >> 2], o >>> 0 < c >>> 0 && (y = e[r + 8 >> 2], o = e[r + 12 >> 2], e[r + 16 >> 2] = c, e[r + 12 >> 2] = o, e[r + 8 >> 2] = y, o = e[r + 16 >> 2]), r = e[r + 12 >> 2], r >>> 0 >= o >>> 0))
                    break e;
                  h = ye[r | 0];
                }
                return h | 0;
              }
              function Ep(r, o, c, h) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0;
                var y = 0, g = 0;
                if (Va(r, e[o + 8 >> 2], 0)) {
                  cl(o, c, h);
                  return;
                }
                g = e[r + 12 >> 2], rc(e[r + 16 >> 2], e[r + 20 >> 2], o, c, h), y = r + 24 | 0, r = (r + 16 | 0) + (g << 3) | 0;
                e: {
                  if (y >>> 0 >= r >>> 0)
                    break e;
                  for (; ; ) {
                    if (rc(e[y >> 2], e[y + 4 >> 2], o, c, h), ye[o + 54 | 0])
                      break e;
                    if (y = y + 8 | 0, !(r >>> 0 > y >>> 0))
                      break;
                  }
                }
              }
              function ga(r, o) {
                var c = 0, h = 0, y = 0, g = 0, S = 0;
                if (h = ye[r + 11 | 0], c = h << 24 >> 24, c = (c | 0) < 0, y = c ? e[r + 4 >> 2] : h, g = e[o + 4 >> 2], y >>> 0 <= g >>> 0) {
                  if (h = e[o >> 2], y)
                    for (r = c ? e[r >> 2] : r, S = y + r | 0, c = h; ; ) {
                      if (ye[r | 0] != ye[c | 0])
                        return 0;
                      if (c = c + 1 | 0, r = r + 1 | 0, (S | 0) == (r | 0))
                        break;
                    }
                  e[o + 4 >> 2] = g - y, e[o >> 2] = h + y, r = 1;
                } else
                  r = 0;
                return r;
              }
              function Da(r) {
                var o = 0, c = 0, h = 0;
                e: {
                  t: {
                    if (o = r, !(o & 3))
                      break t;
                    if (!ye[o | 0])
                      return 0;
                    for (; ; ) {
                      if (o = o + 1 | 0, !(o & 3))
                        break t;
                      if (!ye[o | 0])
                        break;
                    }
                    break e;
                  }
                  for (; c = o, o = o + 4 | 0, h = e[c >> 2], !((h ^ -1) & h - 16843009 & -2139062144); )
                    ;
                  for (; o = c, c = o + 1 | 0, !!ye[o | 0]; )
                    ;
                }
                return o - r | 0;
              }
              function pa(r, o, c) {
                var h = 0, y = 0;
                e: {
                  t: {
                    if (c >>> 0 >= 4) {
                      if ((r | o) & 3)
                        break t;
                      for (; ; ) {
                        if (e[r >> 2] != e[o >> 2])
                          break t;
                        if (o = o + 4 | 0, r = r + 4 | 0, c = c - 4 | 0, !(c >>> 0 > 3))
                          break;
                      }
                    }
                    if (!c)
                      break e;
                  }
                  for (; ; ) {
                    if (h = ye[r | 0], y = ye[o | 0], (h | 0) == (y | 0)) {
                      if (o = o + 1 | 0, r = r + 1 | 0, c = c - 1 | 0, c)
                        continue;
                      break e;
                    }
                    break;
                  }
                  return h - y | 0;
                }
                return 0;
              }
              function Bp(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0;
                e: {
                  t: {
                    c = ye[r + 11 | 0];
                    r: {
                      n: {
                        if ((c & 128) >>> 7 | 0) {
                          if (h = (e[r + 8 >> 2] & 2147483647) - 1 | 0, c = e[r + 4 >> 2], (h | 0) == (c | 0))
                            break n;
                          break r;
                        }
                        if (h = 1, c = c & 127, (c | 0) != 1)
                          break t;
                      }
                      Sh(r, h, 1, h, h), c = h;
                    }
                    h = e[r >> 2], e[r + 4 >> 2] = c + 1;
                    break e;
                  }
                  $[r + 11 | 0] = c + 1, h = r;
                }
                r = (c << 2) + h | 0, e[r >> 2] = o, e[r + 4 >> 2] = 0;
              }
              function Ha(r, o) {
                var c = 0, h = 0, y = 0, g = 0;
                h = Yr - 16 | 0, Yr = h;
                e: {
                  if (!o) {
                    o = 0;
                    break e;
                  }
                  c = o >> 31, y = (c ^ o) - c | 0, c = Do(y), ha(h, y, 0, 0, 0, c + 81 | 0), y = 0 + e[h + 8 >> 2] | 0, c = (e[h + 12 >> 2] ^ 65536) + (16414 - c << 16) | 0, c = y >>> 0 < g >>> 0 ? c + 1 | 0 : c, g = o & -2147483648 | c, c = e[h + 4 >> 2], o = e[h >> 2];
                }
                e[r >> 2] = o, e[r + 4 >> 2] = c, e[r + 8 >> 2] = y, e[r + 12 >> 2] = g, Yr = h + 16 | 0;
              }
              function Lh(r, o, c) {
                var h = 0, y = 0, g = 0;
                return y = Yr - 16 | 0, Yr = y, h = Yr - 32 | 0, Yr = h, g = Yr - 16 | 0, Yr = g, e[g + 12 >> 2] = o, e[h + 24 >> 2] = r, e[h + 28 >> 2] = e[g + 12 >> 2], Yr = g + 16 | 0, Td(h + 16 | 0, e[h + 24 >> 2], e[h + 28 >> 2], c), r = Pd(r, e[h + 16 >> 2] - r >> 2), e[h + 12 >> 2] = e[h + 20 >> 2], e[y + 8 >> 2] = r, e[y + 12 >> 2] = e[h + 12 >> 2], Yr = h + 32 | 0, Yr = y + 16 | 0, e[y + 12 >> 2];
              }
              function wd(r, o, c, h) {
                var y = 0, g = 0, S = 0, G = 0;
                y = Yr - 160 | 0, Yr = y, e[y + 60 >> 2] = o, e[y + 20 >> 2] = o, e[y + 24 >> 2] = -1, g = y + 16 | 0, du(g, 0, 0), Vd(y, g, h, 1), h = e[y + 8 >> 2], S = e[y + 12 >> 2], g = e[y >> 2], G = e[y + 4 >> 2], c && (e[c >> 2] = ((e[y + 20 >> 2] + e[y + 136 >> 2] | 0) - e[y + 60 >> 2] | 0) + o), e[r + 8 >> 2] = h, e[r + 12 >> 2] = S, e[r >> 2] = g, e[r + 4 >> 2] = G, Yr = y + 160 | 0;
              }
              function Hh(r, o, c) {
                var h = 0, y = 0, g = 0;
                return y = Yr - 16 | 0, Yr = y, h = Yr - 32 | 0, Yr = h, g = Yr - 16 | 0, Yr = g, e[g + 12 >> 2] = o, e[h + 24 >> 2] = r, e[h + 28 >> 2] = e[g + 12 >> 2], Yr = g + 16 | 0, Td(h + 16 | 0, e[h + 24 >> 2], e[h + 28 >> 2], c), r = qd(r, e[h + 16 >> 2] - r | 0), e[h + 12 >> 2] = e[h + 20 >> 2], e[y + 8 >> 2] = r, e[y + 12 >> 2] = e[h + 12 >> 2], Yr = h + 32 | 0, Yr = y + 16 | 0, e[y + 12 >> 2];
              }
              function vp(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0;
                e: {
                  t: {
                    c = ye[r + 11 | 0];
                    r: {
                      n: {
                        if ((c & 128) >>> 7 | 0) {
                          if (h = (e[r + 8 >> 2] & 2147483647) - 1 | 0, c = e[r + 4 >> 2], (h | 0) == (c | 0))
                            break n;
                          break r;
                        }
                        if (h = 10, c = c & 127, (c | 0) != 10)
                          break t;
                      }
                      el(r, h, 1, h, h), c = h;
                    }
                    h = e[r >> 2], e[r + 4 >> 2] = c + 1;
                    break e;
                  }
                  $[r + 11 | 0] = c + 1, h = r;
                }
                r = h + c | 0, $[r | 0] = o, $[r + 1 | 0] = 0;
              }
              function Cp(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0;
                var g = 0, S = 0, G = 0;
                G = (y - h | 0) + o | 0;
                e: {
                  for (; ; ) {
                    if ((h | 0) != (y | 0)) {
                      if (r = -1, (o | 0) == (c | 0) || (g = $[o | 0], S = $[h | 0], (g | 0) < (S | 0)))
                        break e;
                      if ((g | 0) > (S | 0))
                        return 1;
                      h = h + 1 | 0, o = o + 1 | 0;
                      continue;
                    }
                    break;
                  }
                  r = (c | 0) != (G | 0);
                }
                return r | 0;
              }
              function al(r) {
                r = r | 0;
                var o = 0, c = 0;
                if (e[r >> 2] = 8512, e[5996] = 0, di(133, r | 0, 0), o = e[5996], e[5996] = 0, (o | 0) != 1)
                  return o = e[r + 28 >> 2], c = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = c, (c | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o), Sr(e[r + 32 >> 2]), Sr(e[r + 36 >> 2]), Sr(e[r + 48 >> 2]), Sr(e[r + 60 >> 2]), r | 0;
                Ts(0) | 0, va(), ri();
              }
              function qc(r, o, c) {
                var h = 0, y = 0, g = 0;
                e: {
                  if (!o) {
                    h = r;
                    break e;
                  }
                  for (; h = _l(r, o, 10), y = vs, r = so(h, y, 246, 0) + r | 0, c = c - 1 | 0, $[c | 0] = r | 48, g = o >>> 0 > 9, r = h, o = y, !!g; )
                    ;
                }
                if (h)
                  for (; c = c - 1 | 0, r = (h >>> 0) / 10 | 0, $[c | 0] = vi(r, 246) + h | 48, o = h >>> 0 > 9, h = r, !!o; )
                    ;
                return c;
              }
              function lu(r) {
                var o = 0, c = 0, h = 0, y = 0;
                if (h = e[r >> 2], h) {
                  if (o = h, c = e[r + 4 >> 2], (o | 0) != (c | 0)) {
                    for (; ; ) {
                      c = c - 32 | 0, o = e[c + 4 >> 2];
                      e: {
                        if (!o || (y = e[o + 4 >> 2], e[o + 4 >> 2] = y - 1, y))
                          break e;
                        _n[e[e[o >> 2] + 8 >> 2]](o), cs(o);
                      }
                      if ((h | 0) == (c | 0))
                        break;
                    }
                    o = e[r >> 2];
                  }
                  e[r + 4 >> 2] = h, Sr(o);
                }
              }
              function xo(r) {
                var o = 0, c = 0, h = 0, y = 0;
                if (h = e[r >> 2], h) {
                  if (o = h, c = e[r + 4 >> 2], (o | 0) != (c | 0)) {
                    for (; ; ) {
                      c = c - 8 | 0, o = e[c + 4 >> 2];
                      e: {
                        if (!o || (y = e[o + 4 >> 2], e[o + 4 >> 2] = y - 1, y))
                          break e;
                        _n[e[e[o >> 2] + 8 >> 2]](o), cs(o);
                      }
                      if ((h | 0) == (c | 0))
                        break;
                    }
                    o = e[r >> 2];
                  }
                  e[r + 4 >> 2] = h, Sr(o);
                }
              }
              function Oc(r, o) {
                var c = 0, h = 0, y = 0, g = 0;
                c = Yr - 16 | 0, Yr = c;
                e: {
                  if (!o) {
                    o = 0;
                    break e;
                  }
                  h = o, o = Do(o), ha(c, h, 0, 0, 0, o + 81 | 0), h = 0 + e[c + 8 >> 2] | 0, o = (e[c + 12 >> 2] ^ 65536) + (16414 - o << 16) | 0, g = y >>> 0 > h >>> 0 ? o + 1 | 0 : o, y = e[c + 4 >> 2], o = e[c >> 2];
                }
                e[r >> 2] = o, e[r + 4 >> 2] = y, e[r + 8 >> 2] = h, e[r + 12 >> 2] = g, Yr = c + 16 | 0;
              }
              function kp(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0;
                h = e[o + 28 >> 2], e[r >> 2] = h, e[h + 4 >> 2] = e[h + 4 >> 2] + 1, $o(o + 28 | 0, c), e[5996] = 0, di(133, o | 0, 1), o = e[5996], e[5996] = 0, (o | 0) == 1 && (c = Vr() | 0, r = e[r >> 2], o = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = o, (o | 0) == -1 && _n[e[e[r >> 2] + 8 >> 2]](r), Ki(c | 0), ri());
              }
              function Sp(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0;
                var g = 0, S = 0;
                e: {
                  for (; ; ) {
                    if ((h | 0) != (y | 0)) {
                      if (r = -1, (o | 0) == (c | 0) || (g = e[o >> 2], S = e[h >> 2], (g | 0) < (S | 0)))
                        break e;
                      if ((g | 0) > (S | 0))
                        return 1;
                      h = h + 4 | 0, o = o + 4 | 0;
                      continue;
                    }
                    break;
                  }
                  r = (o | 0) != (c | 0);
                }
                return r | 0;
              }
              function wf(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0, y = 0;
                for (e[r >> 2] = 12664, y = r + 8 | 0; ; ) {
                  if (o = e[r + 8 >> 2], e[r + 12 >> 2] - o >> 2 >>> 0 > c >>> 0) {
                    o = e[o + (c << 2) >> 2], o && (h = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = h, (h | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o)), c = c + 1 | 0;
                    continue;
                  }
                  break;
                }
                return qi(r + 152 | 0), Ko(y), r | 0;
              }
              function i2(r) {
                var o = 0, c = 0, h = 0, y = 0, g = 0;
                e: {
                  if (ye[r + 4 | 0] || (y = e[r >> 2], o = e[y >> 2], !o))
                    break e;
                  if (c = o, h = e[y + 4 >> 2], (h | 0) != (o | 0)) {
                    for (; c = h - 12 | 0, g = e[c >> 2], g && (e[h - 8 >> 2] = g, Sr(g)), h = c, (h | 0) != (o | 0); )
                      ;
                    c = e[e[r >> 2] >> 2];
                  }
                  e[y + 4 >> 2] = o, Sr(c);
                }
              }
              function Kh(r) {
                var o = 0, c = 0;
                return o = e[r + 72 >> 2], e[r + 72 >> 2] = o - 1 | o, e[r + 20 >> 2] != e[r + 28 >> 2] && _n[e[r + 36 >> 2]](r, 0, 0) | 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, o = e[r >> 2], o & 4 ? (e[r >> 2] = o | 32, -1) : (c = e[r + 44 >> 2] + e[r + 48 >> 2] | 0, e[r + 8 >> 2] = c, e[r + 4 >> 2] = c, o << 27 >> 31);
              }
              function lo(r, o) {
                var c = 0, h = 0, y = 0, g = 0;
                e: {
                  if (c = Da(o), h = (ye[r + 11 | 0] & 128) >>> 7 | 0 ? (e[r + 8 >> 2] & 2147483647) - 1 | 0 : 10, c >>> 0 <= h >>> 0) {
                    Gc(r, Jc((ye[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r, o, c), c);
                    break e;
                  }
                  y = r, g = e[r + 4 >> 2], r = ye[r + 11 | 0], r = (r & 128) >>> 7 | 0 ? g : r & 127, Rc(y, h, c - h | 0, r, 0, r, c, o);
                }
              }
              function du(r, o, c) {
                var h = 0, y = 0, g = 0, S = 0;
                e[r + 112 >> 2] = o, e[r + 116 >> 2] = c, y = e[r + 4 >> 2], h = e[r + 44 >> 2] - y | 0, e[r + 120 >> 2] = h, e[r + 124 >> 2] = h >> 31, h = e[r + 8 >> 2];
                e: {
                  if (!(o | c) || (g = h - y | 0, S = g >> 31, (c | 0) >= (S | 0) & o >>> 0 >= g >>> 0 | (c | 0) > (S | 0)))
                    break e;
                  h = o + y | 0;
                }
                e[r + 104 >> 2] = h;
              }
              function bf(r, o) {
                var c = 0, h = 0, y = 0;
                if (ya(+r), h = js(1) | 0, y = js(0) | 0, c = h >>> 20 & 2047, (c | 0) != 2047) {
                  if (!c)
                    return r == 0 ? c = 0 : (r = bf(r * 18446744073709552e3, o), c = e[o >> 2] + -64 | 0), e[o >> 2] = c, r;
                  e[o >> 2] = c - 1022, jo(0, y | 0), jo(1, h & -2146435073 | 1071644672), r = +za();
                }
                return r;
              }
              function Gh(r) {
                var o = 0, c = 0, h = 0, y = 0;
                e: {
                  if (ye[r + 4 | 0] || (y = e[r >> 2], o = e[y >> 2], !o))
                    break e;
                  if (c = o, h = e[y + 4 >> 2], (o | 0) != (h | 0)) {
                    for (; c = h - 12 | 0, $[h - 1 | 0] < 0 && Sr(e[c >> 2]), h = c, (h | 0) != (o | 0); )
                      ;
                    c = e[e[r >> 2] >> 2];
                  }
                  e[y + 4 >> 2] = o, Sr(c);
                }
              }
              function bd(r, o) {
                var c = 0, h = 0;
                for (h = Yr - 16 | 0, Yr = h, c = h + 4 | 0, e[c >> 2] = r, r = e[r + 4 >> 2], e[c + 4 >> 2] = r, e[c + 8 >> 2] = r + (o << 2), o = e[c + 4 >> 2], r = e[c + 8 >> 2]; ; ) {
                  if ((r | 0) == (o | 0))
                    e[e[c >> 2] + 4 >> 2] = e[c + 4 >> 2], Yr = h + 16 | 0;
                  else {
                    e[o >> 2] = 0, o = o + 4 | 0, e[c + 4 >> 2] = o;
                    continue;
                  }
                  break;
                }
              }
              function va() {
                var r = 0;
                r = e[5728], e[5996] = 0, Ri(r | 0), r = e[5996], e[5996] = 0;
                e: {
                  if ((r | 0) != 1 && (e[5996] = 0, Ri(291), r = e[5996], e[5996] = 0, (r | 0) != 1) || (yu(Ts(0) | 0) | 0, e[5996] = 0, Ri(291), r = e[5996], e[5996] = 0, (r | 0) != 1))
                    break e;
                  Ts(0) | 0, va();
                }
                ri();
              }
              function jh(r, o, c, h) {
                var y = 0, g = 0;
                y = Yr - 32 | 0, Yr = y, g = Yr - 16 | 0, Yr = g, e[g + 12 >> 2] = c, e[y + 24 >> 2] = o, e[y + 28 >> 2] = e[g + 12 >> 2], Yr = g + 16 | 0, Td(y + 16 | 0, e[y + 24 >> 2], e[y + 28 >> 2], h), o = e[y + 16 >> 2], e[y + 12 >> 2] = e[y + 20 >> 2], e[r >> 2] = o, e[r + 4 >> 2] = e[y + 12 >> 2], Yr = y + 32 | 0;
              }
              function Ka(r, o, c) {
                if (c = c & 176, (c | 0) == 32)
                  return o;
                e: {
                  if ((c | 0) != 16)
                    break e;
                  t: {
                    r:
                      switch (c = ye[r | 0], c - 43 | 0) {
                        case 0:
                        case 2:
                          break r;
                        default:
                          break t;
                      }
                    return r + 1 | 0;
                  }
                  if ((c | 0) != 48 | (o - r | 0) < 2 | (ye[r + 1 | 0] | 32) != 120)
                    break e;
                  r = r + 2 | 0;
                }
                return r;
              }
              function Vh(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0;
                if (c = e[o + 48 >> 2], c & 16) {
                  h = e[o + 44 >> 2], c = e[o + 24 >> 2], h >>> 0 < c >>> 0 && (e[o + 44 >> 2] = c, h = c), rl(r, e[o + 20 >> 2], h);
                  return;
                }
                if (c & 8) {
                  rl(r, e[o + 8 >> 2], e[o + 16 >> 2]);
                  return;
                }
                e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0;
              }
              function Wh(r) {
                r = r | 0;
                var o = 0, c = 0;
                e: {
                  t: {
                    if (!r || (o = r - 24 | 0, c = e[o >> 2] - 1 | 0, e[o >> 2] = c, ye[o + 13 | 0] | c))
                      break t;
                    if (o = e[o + 8 >> 2], o && (e[5996] = 0, ii(o | 0, r | 0) | 0, o = e[5996], e[5996] = 0, (o | 0) == 1))
                      break e;
                    Ku(r);
                  }
                  return;
                }
                Ts(0) | 0, va(), ri();
              }
              function zh(r, o, c) {
                var h = 0, y = 0, g = 0, S = 0;
                for (h = Yr - 16 | 0, Yr = h, o = o - r >> 2; ; ) {
                  if (o) {
                    e[h + 12 >> 2] = r, y = o >>> 1 | 0, e[h + 12 >> 2] = e[h + 12 >> 2] + (y << 2), g = e[h + 12 >> 2], S = Ps[g >> 2] < c >>> 0, r = S ? g + 4 | 0 : r, o = S ? (y ^ -1) + o | 0 : y;
                    continue;
                  }
                  break;
                }
                return Yr = h + 16 | 0, r;
              }
              function Ga(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0, y = 0;
                if (c = Da(o), c >>> 0 < 2147483632) {
                  e: {
                    if (c >>> 0 <= 10) {
                      $[r + 11 | 0] = c, h = r;
                      break e;
                    }
                    y = (c | 15) + 1 | 0, h = xs(y), e[r + 8 >> 2] = y | -2147483648, e[r >> 2] = h, e[r + 4 >> 2] = c;
                  }
                  return $[Ks(h, o, c) + c | 0] = 0, r | 0;
                }
                ba(), ri();
              }
              function Tp(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0, Fe = 0;
                return S = _n[e[e[r + 8 >> 2] + 20 >> 2]](r + 8 | 0) | 0, G = ye[S + 11 | 0], ke = r, Fe = o, o = (G & 128) >>> 7 | 0, r = o ? e[S >> 2] : S, Mu(ke, Fe, c, h, y, g, r, r + ((o ? e[S + 4 >> 2] : G & 127) << 2) | 0) | 0;
              }
              function xp(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0;
                e: {
                  if (ye[o | 0] != 47)
                    for (; ; ) {
                      if ((c | 0) == (h | 0)) {
                        y = uu(o, c), o = 0;
                        break e;
                      }
                      if (h = h + 1 | 0, ye[h + o | 0] == 47)
                        break;
                    }
                  y = uu(o, h), o = uu((o + h | 0) + 1 | 0, (h ^ -1) + c | 0);
                }
                e[r + 4 >> 2] = o, e[r >> 2] = y;
              }
              function so(r, o, c, h) {
                var y = 0, g = 0, S = 0, G = 0, ke = 0, Fe = 0;
                return y = c >>> 16 | 0, g = r >>> 16 | 0, Fe = vi(y, g), S = c & 65535, G = r & 65535, ke = vi(S, G), g = (ke >>> 16 | 0) + vi(g, S) | 0, y = (g & 65535) + vi(y, G) | 0, vs = (vi(o, c) + Fe | 0) + vi(r, h) + (g >>> 16) + (y >>> 16) | 0, ke & 65535 | y << 16;
              }
              function Jh(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0, ke = 0, Fe = 0;
                return S = _n[e[e[r + 8 >> 2] + 20 >> 2]](r + 8 | 0) | 0, G = ye[S + 11 | 0], ke = r, Fe = o, o = (G & 128) >>> 7 | 0, r = o ? e[S >> 2] : S, Uu(ke, Fe, c, h, y, g, r, r + (o ? e[S + 4 >> 2] : G & 127) | 0) | 0;
              }
              function ul(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0;
                c = e[r >> 2];
                e: {
                  if (!c)
                    break e;
                  h = e[c + 24 >> 2];
                  t: {
                    if ((h | 0) == e[c + 28 >> 2]) {
                      o = _n[e[e[c >> 2] + 52 >> 2]](c, o) | 0;
                      break t;
                    }
                    e[c + 24 >> 2] = h + 4, e[h >> 2] = o;
                  }
                  if ((o | 0) != -1)
                    break e;
                  e[r >> 2] = 0;
                }
                return r | 0;
              }
              function Yh(r, o, c, h) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, h = xs(104), e[h >> 2] = 7e3, e[h + 4 >> 2] = 0, e[h + 8 >> 2] = 0, e[5996] = 0, o = Si(143, h + 12 | 0, o | 0, c | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1 && (r = Vr() | 0, Sr(h), Ki(r | 0), ri()), e[r + 4 >> 2] = h, e[r >> 2] = o;
              }
              function cl(r, o, c) {
                var h = 0;
                if (h = e[r + 16 >> 2], !h) {
                  e[r + 36 >> 2] = 1, e[r + 24 >> 2] = c, e[r + 16 >> 2] = o;
                  return;
                }
                e: {
                  if ((o | 0) == (h | 0)) {
                    if (e[r + 24 >> 2] != 2)
                      break e;
                    e[r + 24 >> 2] = c;
                    return;
                  }
                  $[r + 54 | 0] = 1, e[r + 24 >> 2] = 2, e[r + 36 >> 2] = e[r + 36 >> 2] + 1;
                }
              }
              function Ed(r) {
                var o = 0, c = 0, h = 0;
                e: {
                  if (ye[r + 12 | 0] || (o = e[e[r + 8 >> 2] >> 2], h = e[e[r + 4 >> 2] >> 2], (o | 0) == (h | 0)))
                    break e;
                  for (; r = o - 12 | 0, c = e[r >> 2], c && (e[o - 8 >> 2] = c, Sr(c)), o = r, (r | 0) != (h | 0); )
                    ;
                }
              }
              function Rp(r, o, c, h, y, g) {
                var S = 0;
                S = Yr - 16 | 0, Yr = S, $[S + 15 | 0] = 0, $[S + 14 | 0] = g, $[S + 13 | 0] = y, $[S + 12 | 0] = 37, g && (y = ye[S + 13 | 0], $[S + 13 | 0] = ye[S + 14 | 0], $[S + 14 | 0] = y), e[c >> 2] = (R1(o | 0, e[c >> 2] - o | 0, S + 12 | 0, h | 0, r | 0) | 0) + o, Yr = S + 16 | 0;
              }
              function ua(r, o, c, h, y) {
                var g = 0;
                if (g = Yr - 256 | 0, Yr = g, !(y & 73728 | (c | 0) <= (h | 0))) {
                  if (h = c - h | 0, c = h >>> 0 < 256, Ya(g, o & 255, c ? h : 256), !c)
                    for (; Aa(r, g, 256), h = h - 256 | 0, h >>> 0 > 255; )
                      ;
                  Aa(r, g, h);
                }
                Yr = g + 256 | 0;
              }
              function Qc(r) {
                var o = 0, c = 0, h = 0, y = 0;
                if (o = e[r >> 2], o) {
                  if (c = o, h = e[r + 4 >> 2], (h | 0) != (o | 0)) {
                    for (; c = h - 12 | 0, y = e[c >> 2], y && (e[h - 8 >> 2] = y, Sr(y)), h = c, (h | 0) != (o | 0); )
                      ;
                    c = e[r >> 2];
                  }
                  e[r + 4 >> 2] = o, Sr(c);
                }
              }
              function N4(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6019], r) {
                  if (o = r, c = e[6020], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6019];
                  }
                  e[6020] = r, Sr(o);
                }
              }
              function P4(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6049], r) {
                  if (o = r, c = e[6050], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6049];
                  }
                  e[6050] = r, Sr(o);
                }
              }
              function Dp(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6151], r) {
                  if (o = r, c = e[6152], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6151];
                  }
                  e[6152] = r, Sr(o);
                }
              }
              function Xh(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6055], r) {
                  if (o = r, c = e[6056], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6055];
                  }
                  e[6056] = r, Sr(o);
                }
              }
              function _h(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6157], r) {
                  if (o = r, c = e[6158], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6157];
                  }
                  e[6158] = r, Sr(o);
                }
              }
              function Np(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6061], r) {
                  if (o = r, c = e[6062], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6061];
                  }
                  e[6062] = r, Sr(o);
                }
              }
              function yc(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6163], r) {
                  if (o = r, c = e[6164], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6163];
                  }
                  e[6164] = r, Sr(o);
                }
              }
              function Pp(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6067], r) {
                  if (o = r, c = e[6068], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6067];
                  }
                  e[6068] = r, Sr(o);
                }
              }
              function Zh(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6169], r) {
                  if (o = r, c = e[6170], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6169];
                  }
                  e[6170] = r, Sr(o);
                }
              }
              function Bd(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6073], r) {
                  if (o = r, c = e[6074], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6073];
                  }
                  e[6074] = r, Sr(o);
                }
              }
              function $h(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6175], r) {
                  if (o = r, c = e[6176], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6175];
                  }
                  e[6176] = r, Sr(o);
                }
              }
              function eA(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6025], r) {
                  if (o = r, c = e[6026], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6025];
                  }
                  e[6026] = r, Sr(o);
                }
              }
              function qp(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6031], r) {
                  if (o = r, c = e[6032], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6031];
                  }
                  e[6032] = r, Sr(o);
                }
              }
              function Op(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6081], r) {
                  if (o = r, c = e[6082], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6081];
                  }
                  e[6082] = r, Sr(o);
                }
              }
              function Fo(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6037], r) {
                  if (o = r, c = e[6038], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6037];
                  }
                  e[6038] = r, Sr(o);
                }
              }
              function vd(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6085], r) {
                  if (o = r, c = e[6086], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6085];
                  }
                  e[6086] = r, Sr(o);
                }
              }
              function Ns(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6089], r) {
                  if (o = r, c = e[6090], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6089];
                  }
                  e[6090] = r, Sr(o);
                }
              }
              function l2(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6093], r) {
                  if (o = r, c = e[6094], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6093];
                  }
                  e[6094] = r, Sr(o);
                }
              }
              function ys(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6097], r) {
                  if (o = r, c = e[6098], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6097];
                  }
                  e[6098] = r, Sr(o);
                }
              }
              function Qp(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6101], r) {
                  if (o = r, c = e[6102], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6101];
                  }
                  e[6102] = r, Sr(o);
                }
              }
              function hu(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6105], r) {
                  if (o = r, c = e[6106], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6105];
                  }
                  e[6106] = r, Sr(o);
                }
              }
              function Ef(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6043], r) {
                  if (o = r, c = e[6044], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6043];
                  }
                  e[6044] = r, Sr(o);
                }
              }
              function Cd(r) {
                var o = 0, c = 0, h = 0;
                for (h = e[r >> 2]; ; ) {
                  if (c = $[h | 0], c - 48 >>> 0 < 10) {
                    h = h + 1 | 0, e[r >> 2] = h, o >>> 0 <= 214748364 ? (c = c - 48 | 0, o = vi(o, 10), o = (c | 0) > (o ^ 2147483647) ? -1 : c + o | 0) : o = -1;
                    continue;
                  }
                  break;
                }
                return o;
              }
              function Up(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6109], r) {
                  if (o = r, c = e[6110], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6109];
                  }
                  e[6110] = r, Sr(o);
                }
              }
              function fl(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6113], r) {
                  if (o = r, c = e[6114], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6113];
                  }
                  e[6114] = r, Sr(o);
                }
              }
              function ll(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6117], r) {
                  if (o = r, c = e[6118], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6117];
                  }
                  e[6118] = r, Sr(o);
                }
              }
              function Mp(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6121], r) {
                  if (o = r, c = e[6122], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6121];
                  }
                  e[6122] = r, Sr(o);
                }
              }
              function qs(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6125], r) {
                  if (o = r, c = e[6126], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6125];
                  }
                  e[6126] = r, Sr(o);
                }
              }
              function Na(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6129], r) {
                  if (o = r, c = e[6130], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6129];
                  }
                  e[6130] = r, Sr(o);
                }
              }
              function ao(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6133], r) {
                  if (o = r, c = e[6134], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6133];
                  }
                  e[6134] = r, Sr(o);
                }
              }
              function sA(r) {
                r = r | 0;
                var o = 0, c = 0, h = 0;
                if (r = e[6137], r) {
                  if (o = r, c = e[6138], (c | 0) != (r | 0)) {
                    for (; o = c - 12 | 0, h = e[o >> 2], h && (e[c - 8 >> 2] = h, Sr(h)), c = o, (c | 0) != (r | 0); )
                      ;
                    o = e[6137];
                  }
                  e[6138] = r, Sr(o);
                }
              }
              function Pa(r) {
                var o = 0, c = 0;
                e: {
                  if (ye[r + 12 | 0] || (o = e[e[r + 8 >> 2] >> 2], c = e[e[r + 4 >> 2] >> 2], (o | 0) == (c | 0)))
                    break e;
                  for (; r = o - 12 | 0, $[o - 1 | 0] < 0 && Sr(e[r >> 2]), o = r, (r | 0) != (c | 0); )
                    ;
                }
              }
              function Au(r, o) {
                var c = 0;
                return o = Mo(o), c = e[r + 12 >> 2], r = e[r + 8 >> 2], o >>> 0 < c - r >> 2 >>> 0 ? c = e[r + (o << 2) >> 2] != 0 : c = 0, c || (r = ru(4), e[r >> 2] = 22892, e[r >> 2] = 22736, xa(r | 0, 22872, 173), ri()), e[r + (o << 2) >> 2];
              }
              function Wo(r) {
                var o = 0, c = 0, h = 0;
                if (o = e[r >> 2], o) {
                  if (c = o, h = e[r + 4 >> 2], (o | 0) != (h | 0)) {
                    for (; c = h - 12 | 0, $[h - 1 | 0] < 0 && Sr(e[c >> 2]), h = c, (h | 0) != (o | 0); )
                      ;
                    c = e[r >> 2];
                  }
                  e[r + 4 >> 2] = o, Sr(c);
                }
              }
              function Bf(r, o, c, h) {
                e: {
                  if (!r)
                    break e;
                  t:
                    switch (o + 2 | 0) {
                      case 0:
                        $[r | 0] = c;
                        return;
                      case 1:
                        Vs[r >> 1] = c;
                        return;
                      case 2:
                      case 3:
                        e[r >> 2] = c;
                        return;
                      case 5:
                        break t;
                      default:
                        break e;
                    }
                  e[r >> 2] = c, e[r + 4 >> 2] = h;
                }
              }
              function vf(r) {
                var o = 0;
                return o = e[r + 72 >> 2], e[r + 72 >> 2] = o - 1 | o, o = e[r >> 2], o & 8 ? (e[r >> 2] = o | 32, -1) : (e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, o = e[r + 44 >> 2], e[r + 28 >> 2] = o, e[r + 20 >> 2] = o, e[r + 16 >> 2] = o + e[r + 48 >> 2], 0);
              }
              function Ws(r, o, c, h, y, g, S, G, ke) {
                var Fe = 0;
                Fe = Yr - 16 | 0, Yr = Fe, qa(Fe, o, c, h, y, g, S, G, ke ^ -2147483648), h = e[Fe >> 2], c = e[Fe + 4 >> 2], o = e[Fe + 12 >> 2], e[r + 8 >> 2] = e[Fe + 8 >> 2], e[r + 12 >> 2] = o, e[r >> 2] = h, e[r + 4 >> 2] = c, Yr = Fe + 16 | 0;
              }
              function xs(r) {
                r = r | 0;
                var o = 0;
                r = r >>> 0 <= 1 ? 1 : r;
                e: {
                  for (; ; ) {
                    if (o = ia(r), o)
                      break e;
                    if (o = e[6704], o) {
                      _n[o | 0]();
                      continue;
                    }
                    break;
                  }
                  r = ru(4), e[r >> 2] = 22892, e[r >> 2] = 22364, xa(r | 0, 22448, 5), ri();
                }
                return o | 0;
              }
              function Uc(r, o) {
                var c = 0, h = 0;
                c = ye[r | 0], h = ye[o | 0];
                e: {
                  if (!c | (c | 0) != (h | 0))
                    break e;
                  for (; ; ) {
                    if (h = ye[o + 1 | 0], c = ye[r + 1 | 0], !c)
                      break e;
                    if (o = o + 1 | 0, r = r + 1 | 0, (c | 0) != (h | 0))
                      break;
                  }
                }
                return c - h | 0;
              }
              function po(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0, y = 0, g = 0;
                return y = e[r + 84 >> 2], h = c + 256 | 0, g = nu(y, 0, h), h = g ? g - y | 0 : h, c = c >>> 0 > h >>> 0 ? h : c, _s(o, y, c), o = y + h | 0, e[r + 84 >> 2] = o, e[r + 8 >> 2] = o, e[r + 4 >> 2] = c + y, c | 0;
              }
              function Eo(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0;
                var S = 0, G = 0;
                return S = Yr - 16 | 0, Yr = S, e[S + 8 >> 2] = 624576549, e[S + 12 >> 2] = 1394948685, G = r, r = S + 16 | 0, o = Uu(G, o, c, h, y, g, S + 8 | 0, r), Yr = r, o | 0;
              }
              function Lp(r, o, c, h) {
                for (r = r | 0, o = o | 0, c = c | 0, h = h | 0; ; ) {
                  if ((o | 0) != (c | 0)) {
                    r = e[o >> 2], r >>> 0 <= 127 ? r = e[(r << 2) + 12736 >> 2] : r = 0, e[h >> 2] = r, h = h + 4 | 0, o = o + 4 | 0;
                    continue;
                  }
                  break;
                }
                return c | 0;
              }
              function lA(r) {
                var o = 0, c = 0;
                if (o = e[r >> 2], o) {
                  c = e[o + 12 >> 2];
                  e: {
                    if ((c | 0) == e[o + 16 >> 2]) {
                      o = _n[e[e[o >> 2] + 36 >> 2]](o) | 0;
                      break e;
                    }
                    o = e[c >> 2];
                  }
                  if ((o | 0) != -1)
                    return !e[r >> 2];
                  e[r >> 2] = 0;
                }
                return 1;
              }
              function dA(r) {
                var o = 0, c = 0;
                if (o = e[r >> 2], o) {
                  c = e[o + 12 >> 2];
                  e: {
                    if ((c | 0) == e[o + 16 >> 2]) {
                      o = _n[e[e[o >> 2] + 36 >> 2]](o) | 0;
                      break e;
                    }
                    o = ye[c | 0];
                  }
                  if ((o | 0) != -1)
                    return !e[r >> 2];
                  e[r >> 2] = 0;
                }
                return 1;
              }
              function pA(r) {
                var o = 0, c = 0, h = 0;
                if (o = e[r >> 2], o) {
                  if (h = o, c = e[r + 4 >> 2], (c | 0) != (o | 0)) {
                    for (; c = c - 12 | 0, Je(e[c + 4 >> 2]), (o | 0) != (c | 0); )
                      ;
                    h = e[r >> 2];
                  }
                  e[r + 4 >> 2] = o, Sr(h);
                }
              }
              function Hp(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0;
                h = xs(104), e[5996] = 0, o = Si(147, h | 0, o | 0, c | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) == 1 && (r = Vr() | 0, Sr(h), Ki(r | 0), ri()), e[r + 4 >> 2] = o, e[r >> 2] = o + 12;
              }
              function Kp(r, o, c, h) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0;
                e: {
                  for (; ; ) {
                    if ((c | 0) == (h | 0))
                      break e;
                    if (r = e[c >> 2], !(r >>> 0 > 127 | !(e[(r << 2) + 12736 >> 2] & o))) {
                      c = c + 4 | 0;
                      continue;
                    }
                    break;
                  }
                  h = c;
                }
                return h | 0;
              }
              function Gp(r, o, c, h) {
                for (r = r | 0, o = o | 0, c = c | 0, h = h | 0; ; ) {
                  e: {
                    if ((c | 0) != (h | 0)) {
                      if (r = e[c >> 2], r >>> 0 > 127 | !(e[(r << 2) + 12736 >> 2] & o))
                        break e;
                    } else
                      c = h;
                    return c | 0;
                  }
                  c = c + 4 | 0;
                }
              }
              function jp(r) {
                r = r | 0;
                var o = 0, c = 0;
                return o = Yr - 16 | 0, Yr = o, c = e[xu(o + 12 | 0, e[r + 8 >> 2]) >> 2], c && (e[6178] = (c | 0) == -1 ? 24816 : c), Yr = o + 16 | 0, r = e[r + 8 >> 2], r ? (Rf(r) | 0) == 1 | 0 : 1;
              }
              function dl(r) {
                var o = 0, c = 0;
                if (r) {
                  dl(e[r >> 2]), dl(e[r + 4 >> 2]), o = e[r + 28 >> 2];
                  e: {
                    if (!o || (c = e[o + 4 >> 2], e[o + 4 >> 2] = c - 1, c))
                      break e;
                    _n[e[e[o >> 2] + 8 >> 2]](o), cs(o);
                  }
                  Sr(r);
                }
              }
              function Vp(r) {
                r = r | 0;
                var o = 0, c = 0;
                o = Yr - 16 | 0, Yr = o, Fc() >>> 0 <= 29 && (Lo(), ri()), t4(o + 8 | 0, r + 16 | 0, 30), c = e[o + 8 >> 2], e[r + 4 >> 2] = c, e[r >> 2] = c, e[r + 8 >> 2] = (e[o + 12 >> 2] << 2) + c, Yr = o + 16 | 0;
              }
              function Oa(r) {
                var o = 0, c = 0, h = 0;
                if (o = e[r >> 2], o) {
                  if (h = o, c = e[r + 4 >> 2], (c | 0) != (o | 0)) {
                    for (; c = Ra(c - 56 | 0), (c | 0) != (o | 0); )
                      ;
                    h = e[r >> 2];
                  }
                  e[r + 4 >> 2] = o, Sr(h);
                }
              }
              function Wp(r) {
                r = r | 0;
                var o = 0, c = 0;
                if (r = e[6076], r) {
                  if (c = r, o = e[6077], (o | 0) != (r | 0)) {
                    for (; o = o - 4 | 0, ol(o), (r | 0) != (o | 0); )
                      ;
                    c = e[6076];
                  }
                  e[6077] = r, Sr(c);
                }
              }
              function E2(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0;
                return h = Yr - 16 | 0, Yr = h, e[h + 12 >> 2] = e[c >> 2], r = _n[e[e[r >> 2] + 16 >> 2]](r, o, h + 12 | 0) | 0, r && (e[c >> 2] = e[h + 12 >> 2]), Yr = h + 16 | 0, r | 0;
              }
              function x2(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0;
                for (r = 0; ; ) {
                  if ((o | 0) != (c | 0)) {
                    r = e[o >> 2] + (r << 4) | 0, h = r & -268435456, r = (h | h >>> 24) ^ r, o = o + 4 | 0;
                    continue;
                  }
                  break;
                }
                return r | 0;
              }
              function Cf(r, o, c, h, y) {
                return r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, r = Yr - 16 | 0, Yr = r, e[r + 12 >> 2] = y, e[r + 8 >> 2] = h - c, Yr = r + 16 | 0, o = r + 8 | 0, r = r + 12 | 0, e[(Ps[o >> 2] < Ps[r >> 2] ? o : r) >> 2];
              }
              function Zo(r, o, c, h, y) {
                var g = 0;
                return g = Yr - 16 | 0, Yr = g, e[g + 12 >> 2] = y, c = xu(g + 8 | 0, c), o = Jf(r, o, h, e[g + 12 >> 2]), r = e[c >> 2], r && (e[6178] = (r | 0) == -1 ? 24816 : r), Yr = g + 16 | 0, o;
              }
              function hl(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0;
                for (r = 0; ; ) {
                  if ((o | 0) != (c | 0)) {
                    r = $[o | 0] + (r << 4) | 0, h = r & -268435456, r = (h | h >>> 24) ^ r, o = o + 1 | 0;
                    continue;
                  }
                  break;
                }
                return r | 0;
              }
              function kf(r, o) {
                r = r | 0, o = o | 0;
                var c = 0;
                if (c = e[r + 4 >> 2], c >>> 0 < Ps[r + 8 >> 2]) {
                  e[c >> 2] = e[o >> 2], e[c + 4 >> 2] = e[o + 4 >> 2], e[o >> 2] = 0, e[o + 4 >> 2] = 0, e[r + 4 >> 2] = c + 8;
                  return;
                }
                rd(r, o);
              }
              function Yo(r, o) {
                var c = 0;
                c = e[r >> 2], e[r >> 2] = o;
                e: {
                  if (c && (r = e[r + 4 >> 2], e[5996] = 0, ko(r | 0, c | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                    break e;
                  return;
                }
                Ts(0) | 0, va(), ri();
              }
              function mc(r, o, c) {
                var h = 0;
                return h = Yr - 16 | 0, Yr = h, e[h + 12 >> 2] = c, o = xu(h + 8 | 0, o), c = Wd(r, 1937, e[h + 12 >> 2]), r = e[o >> 2], r && (e[6178] = (r | 0) == -1 ? 24816 : r), Yr = h + 16 | 0, c;
              }
              function Ic(r, o, c) {
                for (r = r | 0, o = o | 0, c = c | 0; ; ) {
                  if ((o | 0) != (c | 0)) {
                    r = e[o >> 2], r >>> 0 <= 127 && (r = e[(r << 2) + 11184 >> 2]), e[o >> 2] = r, o = o + 4 | 0;
                    continue;
                  }
                  break;
                }
                return c | 0;
              }
              function ku(r) {
                var o = 0, c = 0;
                if (e[5996] = 0, c = kl(168) | 0, o = e[5996], e[5996] = 0, (o | 0) != 1) {
                  o = r, r = e[c >> 2], e[o >> 2] = r, e[r + 4 >> 2] = e[r + 4 >> 2] + 1;
                  return;
                }
                Ts(0) | 0, va(), ri();
              }
              function Al(r, o, c) {
                for (r = r | 0, o = o | 0, c = c | 0; ; ) {
                  if ((o | 0) != (c | 0)) {
                    r = e[o >> 2], r >>> 0 <= 127 && (r = e[(r << 2) + 9648 >> 2]), e[o >> 2] = r, o = o + 4 | 0;
                    continue;
                  }
                  break;
                }
                return c | 0;
              }
              function Ia(r) {
                var o = 0, c = 0, h = 0;
                return o = Yr - 16 | 0, Yr = o, c = ye[r + 11 | 0], h = (c & 128) >>> 7 | 0, e[o + 12 >> 2] = (h ? e[r >> 2] : r) + ((h ? e[r + 4 >> 2] : c & 127) << 2), Yr = o + 16 | 0, e[o + 12 >> 2];
              }
              function Mc(r, o, c, h, y) {
                for (r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0; ; ) {
                  if ((o | 0) != (c | 0)) {
                    r = e[o >> 2], $[y | 0] = r >>> 0 < 128 ? r : h, y = y + 1 | 0, o = o + 4 | 0;
                    continue;
                  }
                  break;
                }
                return c | 0;
              }
              function $o(r, o) {
                var c = 0, h = 0;
                c = e[o >> 2], e[c + 4 >> 2] = e[c + 4 >> 2] + 1, c = e[r >> 2], h = e[c + 4 >> 2] - 1 | 0, e[c + 4 >> 2] = h, (h | 0) == -1 && _n[e[e[c >> 2] + 8 >> 2]](c), e[r >> 2] = e[o >> 2];
              }
              function D2(r, o) {
                var c = 0;
                e: {
                  if ((r | 0) == (o | 0))
                    break e;
                  for (; ; ) {
                    if (o = o - 4 | 0, o >>> 0 <= r >>> 0)
                      break e;
                    c = e[r >> 2], e[r >> 2] = e[o >> 2], e[o >> 2] = c, r = r + 4 | 0;
                  }
                }
              }
              function gl(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0;
                var h = 0;
                return h = Yr - 16 | 0, Yr = h, _n[e[e[r >> 2] + 12 >> 2]](h + 8 | 0, r, o), Yr = h + 16 | 0, e[h + 12 >> 2] == e[c + 4 >> 2] & e[h + 8 >> 2] == e[c >> 2];
              }
              function Sf(r) {
                r = r | 0;
                var o = 0, c = 0;
                o = ru(8), e[5996] = 0, r = On(91, o | 0, r | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1 && (xa(r | 0, 22664, 92), ri()), r = Vr() | 0, Ku(o), Ki(r | 0), ri();
              }
              function kd(r, o, c) {
                for (r = r | 0, o = o | 0, c = c | 0; ; ) {
                  if ((o | 0) != (c | 0)) {
                    r = $[o | 0], (r | 0) >= 0 && (r = e[(r << 2) + 11184 >> 2]), $[o | 0] = r, o = o + 1 | 0;
                    continue;
                  }
                  break;
                }
                return c | 0;
              }
              function Tf(r, o, c, h, y) {
                for (r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0; ; ) {
                  if ((o | 0) != (c | 0)) {
                    r = $[o | 0], $[y | 0] = (r | 0) < 0 ? h : r, y = y + 1 | 0, o = o + 1 | 0;
                    continue;
                  }
                  break;
                }
                return c | 0;
              }
              function Su(r, o, c) {
                for (r = r | 0, o = o | 0, c = c | 0; ; ) {
                  if ((o | 0) != (c | 0)) {
                    r = $[o | 0], (r | 0) >= 0 && (r = e[(r << 2) + 9648 >> 2]), $[o | 0] = r, o = o + 1 | 0;
                    continue;
                  }
                  break;
                }
                return c | 0;
              }
              function xf(r, o, c, h, y, g) {
                if (r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, Va(r, e[o + 8 >> 2], g)) {
                  pd(o, c, h, y);
                  return;
                }
                r = e[r + 8 >> 2], _n[e[e[r >> 2] + 20 >> 2]](r, o, c, h, y, g);
              }
              function gu(r) {
                var o = 0, c = 0, h = 0;
                return o = Yr - 16 | 0, Yr = o, c = ye[r + 11 | 0], h = (c & 128) >>> 7 | 0, e[o + 12 >> 2] = (h ? e[r >> 2] : r) + (h ? e[r + 4 >> 2] : c & 127), Yr = o + 16 | 0, e[o + 12 >> 2];
              }
              function wc(r, o) {
                r = r | 0, o = o | 0;
                var c = 0, h = 0;
                for (c = e[r + 40 >> 2]; ; ) {
                  if (c) {
                    c = c - 1 | 0, h = c << 2, _n[e[e[r + 32 >> 2] + h >> 2]](o, r, e[h + e[r + 36 >> 2] >> 2]);
                    continue;
                  }
                  break;
                }
              }
              function iu(r, o) {
                var c = 0;
                e: {
                  if ((r | 0) == (o | 0))
                    break e;
                  for (; ; ) {
                    if (o = o - 1 | 0, o >>> 0 <= r >>> 0)
                      break e;
                    c = ye[r | 0], $[r | 0] = ye[o | 0], $[o | 0] = c, r = r + 1 | 0;
                  }
                }
              }
              function Fc() {
                var r = 0, o = 0;
                return r = Yr - 16 | 0, Yr = r, e[r + 12 >> 2] = 1073741823, e[r + 8 >> 2] = 2147483647, Yr = r + 16 | 0, o = r + 8 | 0, r = r + 12 | 0, e[(Ps[o >> 2] < Ps[r >> 2] ? o : r) >> 2];
              }
              function ja(r, o) {
                var c = 0;
                (ye[r + 11 | 0] & 128) >>> 7 | 0 && Sr(e[r >> 2]), c = e[o + 4 >> 2], e[r >> 2] = e[o >> 2], e[r + 4 >> 2] = c, e[r + 8 >> 2] = e[o + 8 >> 2], $[o + 11 | 0] = 0, e[o >> 2] = 0;
              }
              function pl(r, o) {
                var c = 0;
                if (!((ye[o + 11 | 0] & 128) >>> 7 | 0)) {
                  c = e[o + 4 >> 2], e[r >> 2] = e[o >> 2], e[r + 4 >> 2] = c, e[r + 8 >> 2] = e[o + 8 >> 2];
                  return;
                }
                il(r, e[o >> 2], e[o + 4 >> 2]);
              }
              function N2(r) {
                return ye[25164] ? e[6290] : (ye[26312] || ($[26312] = 1), Io(26288, 19200), Io(26300, 19212), $[25164] = 1, e[6290] = 26288, 26288);
              }
              function ra(r, o) {
                var c = 0;
                (ye[r + 11 | 0] & 128) >>> 7 | 0 && Sr(e[r >> 2]), c = e[o + 4 >> 2], e[r >> 2] = e[o >> 2], e[r + 4 >> 2] = c, e[r + 8 >> 2] = e[o + 8 >> 2], $[o + 11 | 0] = 0, $[o | 0] = 0;
              }
              function tc() {
                var r = 0, o = 0, c = 0;
                o = ru(8), e[5996] = 0, r = ii(125, o | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1 && (xa(r | 0, 22632, 7), ri()), r = Vr() | 0, Ku(o), Ki(r | 0), ri();
              }
              function pu(r) {
                return ye[25156] ? e[6288] : (ye[26280] || ($[26280] = 1), lo(26256, 3116), lo(26268, 3113), $[25156] = 1, e[6288] = 26256, 26256);
              }
              function Tu(r) {
                var o = 0, c = 0;
                o = ru(8), e[5996] = 0, r = On(6, o | 0, r | 0) | 0, c = e[5996], e[5996] = 0, (c | 0) != 1 && (xa(r | 0, 22580, 7), ri()), r = Vr() | 0, Ku(o), Ki(r | 0), ri();
              }
              function rc(r, o, c, h, y) {
                var g = 0;
                g = c, c = 0;
                e: {
                  if (!h || (c = o >> 8, !(o & 1)))
                    break e;
                  c = e[c + e[h >> 2] >> 2];
                }
                _n[e[e[r >> 2] + 28 >> 2]](r, g, c + h | 0, o & 2 ? y : 2);
              }
              function Lc(r, o, c) {
                var h = 0;
                for (h = Yr - 16 | 0, Yr = h, $[h + 15 | 0] = c, c = r; ; ) {
                  if (o) {
                    $[c | 0] = ye[h + 15 | 0], o = o - 1 | 0, c = c + 1 | 0;
                    continue;
                  }
                  break;
                }
                return Yr = h + 16 | 0, r;
              }
              function Rf(r) {
                var o = 0, c = 0;
                return o = Yr - 16 | 0, Yr = o, r = xu(o + 12 | 0, r), c = e[e[6178] >> 2] ? 4 : 1, r = e[r >> 2], r && (e[6178] = (r | 0) == -1 ? 24816 : r), Yr = o + 16 | 0, c;
              }
              function Df(r, o) {
                var c = 0;
                return c = e[r + 24 >> 2], (c | 0) == e[r + 28 >> 2] ? _n[e[e[r >> 2] + 52 >> 2]](r, o & 255) | 0 : (e[r + 24 >> 2] = c + 1, $[c | 0] = o, o & 255);
              }
              function wA(r, o, c, h, y) {
                var g = 0;
                return g = Yr - 16 | 0, Yr = g, y = xu(g + 12 | 0, y), o = Zf(r, o, c, h), r = e[y >> 2], r && (e[6178] = (r | 0) == -1 ? 24816 : r), Yr = g + 16 | 0, o;
              }
              function Hc(r) {
                r = r | 0;
                var o = 0, c = 0;
                return e[r >> 2] = 7896, o = e[r + 4 >> 2], c = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = c, (c | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o), r | 0;
              }
              function Nf() {
                var r = 0;
                return ye[25032] ? e[6257] : (r = e[ql() >> 2], e[6256] = r, e[r + 4 >> 2] = e[r + 4 >> 2] + 1, $[25032] = 1, e[6257] = 25024, 25024);
              }
              function PA(r) {
                $[24063] < 0 && Sr(e[6013]), $[24051] < 0 && Sr(e[6010]), $[24039] < 0 && Sr(e[6007]), $[24027] < 0 && Sr(e[6004]);
              }
              function zp(r) {
                r = r | 0;
                var o = 0;
                o = e[r + 12 >> 2];
                e: {
                  if ((o | 0) == e[r + 16 >> 2]) {
                    r = _n[e[e[r >> 2] + 36 >> 2]](r) | 0;
                    break e;
                  }
                  r = ye[o | 0];
                }
                return r << 24 >> 24;
              }
              function eo(r, o, c, h) {
                for (o = o | 0, c = c | 0, h = h | 0; ; ) {
                  if ((o | 0) != (c | 0)) {
                    e[h >> 2] = $[o | 0], h = h + 4 | 0, o = o + 1 | 0;
                    continue;
                  }
                  break;
                }
                return c | 0;
              }
              function yl(r) {
                return r = r | 0, e[r + 56 >> 2] = 8316, e[r >> 2] = 8296, e[r + 4 >> 2] = 7960, $[r + 47 | 0] < 0 && Sr(e[r + 36 >> 2]), Hc(r + 4 | 0), A4(r + 56 | 0), r | 0;
              }
              function ml(r, o, c) {
                var h = 0;
                return h = Yr - 16 | 0, Yr = h, c = xu(h + 12 | 0, c), o = cd(r, o), r = e[c >> 2], r && (e[6178] = (r | 0) == -1 ? 24816 : r), Yr = h + 16 | 0, o;
              }
              function Sd(r, o, c, h, y, g) {
                r = _n[e[e[r + 8 >> 2] + 4 >> 2]](r + 8 | 0) | 0, r = Kf(c, h, r, r + 288 | 0, g, y, 0) - r | 0, (r | 0) <= 287 && (e[o >> 2] = ((r | 0) / 12 | 0) % 12);
              }
              function e1(r, o, c, h, y, g) {
                r = _n[e[e[r + 8 >> 2] + 4 >> 2]](r + 8 | 0) | 0, r = Gf(c, h, r, r + 288 | 0, g, y, 0) - r | 0, (r | 0) <= 287 && (e[o >> 2] = ((r | 0) / 12 | 0) % 12);
              }
              function Jp(r) {
                r = r | 0;
                var o = 0;
                return (_n[e[e[r >> 2] + 36 >> 2]](r) | 0) != -1 ? (o = r, r = e[r + 12 >> 2], e[o + 12 >> 2] = r + 1, r = ye[r | 0]) : r = -1, r | 0;
              }
              function t1(r, o, c, h) {
                for (o = o | 0, c = c | 0, h = h | 0; ; ) {
                  if ((o | 0) != (c | 0)) {
                    $[h | 0] = ye[o | 0], h = h + 1 | 0, o = o + 1 | 0;
                    continue;
                  }
                  break;
                }
                return c | 0;
              }
              function cs(r) {
                var o = 0, c = 0;
                e: {
                  if (o = r + 8 | 0, e[o >> 2] && (c = o, o = e[o >> 2] - 1 | 0, e[c >> 2] = o, (o | 0) != -1))
                    break e;
                  _n[e[e[r >> 2] + 16 >> 2]](r);
                }
              }
              function Yp(r, o, c, h) {
                if (r = r | 0, o = o | 0, c = c | 0, h = h | 0, Va(r, e[o + 8 >> 2], 0)) {
                  cl(o, c, h);
                  return;
                }
                r = e[r + 8 >> 2], _n[e[e[r >> 2] + 28 >> 2]](r, o, c, h);
              }
              function r1(r, o, c, h, y, g) {
                r = _n[e[e[r + 8 >> 2] >> 2]](r + 8 | 0) | 0, r = Kf(c, h, r, r + 168 | 0, g, y, 0) - r | 0, (r | 0) <= 167 && (e[o >> 2] = ((r | 0) / 12 | 0) % 7);
              }
              function n1(r, o, c, h, y, g) {
                r = _n[e[e[r + 8 >> 2] >> 2]](r + 8 | 0) | 0, r = Gf(c, h, r, r + 168 | 0, g, y, 0) - r | 0, (r | 0) <= 167 && (e[o >> 2] = ((r | 0) / 12 | 0) % 7);
              }
              function Td(r, o, c, h) {
                var y = 0, g = 0;
                y = Yr - 16 | 0, Yr = y, g = o, o = c - o | 0, e[y + 12 >> 2] = Ks(h, g, o) + o, e[r >> 2] = c, e[r + 4 >> 2] = e[y + 12 >> 2], Yr = y + 16 | 0;
              }
              function Xp(r) {
                r = r | 0;
                var o = 0;
                o = e[r + 12 >> 2];
                e: {
                  if ((o | 0) == e[r + 16 >> 2]) {
                    r = _n[e[e[r >> 2] + 36 >> 2]](r) | 0;
                    break e;
                  }
                  r = e[o >> 2];
                }
                return r | 0;
              }
              function No(r) {
                var o = 0;
                e: {
                  if (r = e[r + 4 >> 2], !r || (o = e[r + 4 >> 2], e[r + 4 >> 2] = o - 1, o))
                    break e;
                  _n[e[e[r >> 2] + 8 >> 2]](r), cs(r);
                }
              }
              function _p(r, o) {
                r = r | 0, o = o | 0;
                var c = 0;
                return c = r, r = ye[o + 11 | 0], Ad(c, (r & 128) >>> 7 | 0 ? e[o >> 2] : o, (r & 128) >>> 7 | 0 ? e[o + 4 >> 2] : r & 127) | 0;
              }
              function i1(r) {
                var o = 0;
                return o = e[r + 12 >> 2], (o | 0) == e[r + 16 >> 2] ? _n[e[e[r >> 2] + 40 >> 2]](r) | 0 : (e[r + 12 >> 2] = o + 4, e[o >> 2]);
              }
              function s1(r) {
                var o = 0;
                return o = e[r + 12 >> 2], (o | 0) == e[r + 16 >> 2] ? _n[e[e[r >> 2] + 40 >> 2]](r) | 0 : (e[r + 12 >> 2] = o + 1, ye[o | 0]);
              }
              function o1(r, o) {
                r = r | 0, o = o | 0;
                var c = 0;
                c = o, o = e[o >> 2] + 7 & -8, e[c >> 2] = o + 16, Fi[r >> 3] = Eu(e[o >> 2], e[o + 4 >> 2], e[o + 8 >> 2], e[o + 12 >> 2]);
              }
              function xd(r, o, c) {
                for (c = c & 255; ; ) {
                  e: {
                    if ((r | 0) != (o | 0)) {
                      if ((c | 0) != ye[r | 0])
                        break e;
                    } else
                      r = o;
                    return r;
                  }
                  r = r + 1 | 0;
                }
              }
              function Zp(r) {
                r = r | 0;
                var o = 0, c = 0;
                c = e[r + 4 >> 2], o = e[r >> 2], r = e[r + 8 >> 2], o = o + (r >> 1) | 0, r & 1 && (c = e[c + e[o >> 2] >> 2]), _n[c | 0](o);
              }
              function a1(r, o, c, h, y, g, S, G, ke) {
                e[r >> 2] = o, e[r + 4 >> 2] = c, e[r + 8 >> 2] = h, e[r + 12 >> 2] = y & 65535 | (ke >>> 16 & 32768 | y >>> 16 & 32767) << 16;
              }
              function u1(r) {
                var o = 0;
                o = e[r >> 2], e[r >> 2] = 0, o && (r = e[o + 4 >> 2] - 1 | 0, e[o + 4 >> 2] = r, (r | 0) == -1 && _n[e[e[o >> 2] + 8 >> 2]](o));
              }
              function c1(r, o) {
                r = r | 0, o = o | 0;
                var c = 0;
                c = e[r >> 2];
                e: {
                  if (!c || (Df(c, o) | 0) != -1)
                    break e;
                  e[r >> 2] = 0;
                }
                return r | 0;
              }
              function Rd(r, o, c) {
                for (; ; ) {
                  e: {
                    if ((r | 0) != (o | 0)) {
                      if (e[r >> 2] != (c | 0))
                        break e;
                    } else
                      r = o;
                    return r;
                  }
                  r = r + 4 | 0;
                }
              }
              function Dd(r, o, c, h, y, g, S) {
                var G = 0;
                G = o >> 8, o & 1 && (G = e[e[y >> 2] + G >> 2]), _n[e[e[r >> 2] + 20 >> 2]](r, c, h, y + G | 0, o & 2 ? g : 2, S);
              }
              function Nd(r, o) {
                var c = 0, h = 0;
                c = Da(o), h = xs(c + 13 | 0), e[h + 8 >> 2] = 0, e[h + 4 >> 2] = c, e[h >> 2] = c, e[r >> 2] = _s(h + 12 | 0, o, c + 1 | 0);
              }
              function Va(r, o, c) {
                return c ? (r | 0) == (o | 0) ? 1 : !Uc(e[r + 4 >> 2], e[o + 4 >> 2]) : e[r + 4 >> 2] == e[o + 4 >> 2];
              }
              function $p(r, o, c, h, y, g) {
                r = r | 0, e[r + 8 >> 2] = -1, e[r + 12 >> 2] = -1, e[r >> 2] = 0, e[r + 4 >> 2] = 0;
              }
              function e4(r, o) {
                return r = r | 0, o = o | 0, e[r >> 2] = 22892, e[r >> 2] = 22500, Nd(r + 4 | 0, (ye[o + 11 | 0] & 128) >>> 7 | 0 ? e[o >> 2] : o), r | 0;
              }
              function Pd(r, o) {
                var c = 0;
                return c = Yr - 16 | 0, Yr = c, e[c + 12 >> 2] = r, r = c + 12 | 0, e[r >> 2] = e[r >> 2] + (o << 2), Yr = c + 16 | 0, e[r >> 2];
              }
              function f1(r, o, c, h, y) {
                o = cu(o, c, h, y, 4), ye[h | 0] & 4 || (e[r >> 2] = ((o | 0) < 69 ? o + 2e3 | 0 : (o | 0) < 100 ? o + 1900 | 0 : o) - 1900);
              }
              function Qa(r) {
                var o = 0;
                return o = Yr - 16 | 0, Yr = o, e[o + 12 >> 2] = (ye[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r, Yr = o + 16 | 0, e[o + 12 >> 2];
              }
              function l1(r, o, c, h, y) {
                o = Bu(o, c, h, y, 4), ye[h | 0] & 4 || (e[r >> 2] = ((o | 0) < 69 ? o + 2e3 | 0 : (o | 0) < 100 ? o + 1900 | 0 : o) - 1900);
              }
              function Il(r, o, c, h, y, g) {
                var S = 0;
                S = o >> 8, o & 1 && (S = e[e[h >> 2] + S >> 2]), _n[e[e[r >> 2] + 24 >> 2]](r, c, h + S | 0, o & 2 ? y : 2, g);
              }
              function d1(r, o, c, h, y, g, S, G) {
                return c = c | 0, y = y | 0, g = g | 0, G = G | 0, e[y >> 2] = c, e[G >> 2] = g, 3;
              }
              function qd(r, o) {
                var c = 0;
                return c = Yr - 16 | 0, Yr = c, e[c + 12 >> 2] = r, r = c + 12 | 0, e[r >> 2] = e[r >> 2] + o, Yr = c + 16 | 0, e[r >> 2];
              }
              function Gu(r) {
                e: {
                  if (r = r & 74, r) {
                    if ((r | 0) == 64)
                      return 8;
                    if ((r | 0) != 8)
                      break e;
                    return 16;
                  }
                  return 0;
                }
                return 10;
              }
              function xu(r, o) {
                var c = 0;
                return c = e[6178], o && (e[6178] = (o | 0) == -1 ? 24816 : o), e[r >> 2] = (c | 0) == 24816 ? -1 : c, r;
              }
              function t4(r, o, c) {
                e: {
                  if (!(ye[o + 120 | 0] | c >>> 0 > 30)) {
                    $[o + 120 | 0] = 1;
                    break e;
                  }
                  o = U4(c);
                }
                e[r + 4 >> 2] = c, e[r >> 2] = o;
              }
              function r4(r, o) {
                e[r + 4 >> 2], e[r + 4 >> 2] = o;
              }
              function q4(r, o, c, h) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, _n[e[e[o >> 2] + 16 >> 2]](r, o, e[c + 8 >> 2], e[c + 12 >> 2], 0, h);
              }
              function ca(r) {
                var o = 0;
                o = e[r + 12 >> 2], o && (e[r + 16 >> 2] = o, Sr(o)), o = e[r >> 2], o && (e[r + 4 >> 2] = o, Sr(o));
              }
              function h1(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, Va(r, e[o + 8 >> 2], g) && pd(o, c, h, y);
              }
              function n4(r, o, c, h) {
                r = r | 0, e[r + 8 >> 2] = -1, e[r + 12 >> 2] = -1, e[r >> 2] = 0, e[r + 4 >> 2] = 0;
              }
              function Kc(r, o, c, h, y) {
                return r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, _n[e[e[r >> 2] + 24 >> 2]](r, o, c, h, y) | 0;
              }
              function A1(r) {
                var o = 0, c = 0;
                for (c = r; o = c, c = o + 4 | 0, !!e[o >> 2]; )
                  ;
                return o - r >> 2;
              }
              function Od(r) {
                r = r | 0;
                var o = 0;
                return e[r >> 2] = 12684, o = e[r + 8 >> 2], !o | !ye[r + 12 | 0] || Sr(o), r | 0;
              }
              function su() {
                var r = 0;
                r = ru(4), e[r >> 2] = 22892, e[r >> 2] = 22364, e[r >> 2] = 22384, xa(r | 0, 22460, 5), ri();
              }
              function Gc(r, o, c) {
                e: {
                  if ((ye[r + 11 | 0] & 128) >>> 7 | 0) {
                    e[r + 4 >> 2] = c;
                    break e;
                  }
                  $[r + 11 | 0] = c;
                }
                $[o + c | 0] = 0;
              }
              function wl(r, o, c, h) {
                var y = 0;
                return y = Yr - 16 | 0, Yr = y, e[y + 12 >> 2] = h, r = Jf(r, o, c, h), Yr = y + 16 | 0, r;
              }
              function Qd(r, o) {
                var c = 0;
                return c = Yr - 16 | 0, Yr = c, e[c + 12 >> 2] = o, r = Wd(r, 2310, o), Yr = c + 16 | 0, r;
              }
              function g1(r) {
                (r | 0) != 0 & (r | 0) != 19324 & (r | 0) != 19348 & (r | 0) != 24732 & (r | 0) != 24756 && Sr(r);
              }
              function O4(r, o) {
                r = r | 0, o = o | 0;
                var c = 0;
                c = s1(e[o >> 2]), e[r + 4 >> 2] = e[o >> 2], $[r | 0] = c << 24 >> 24;
              }
              function p1(r, o) {
                r = r | 0, o = o | 0, o = Yr - 16 | 0, Yr = o, $[r + 11 | 0] = 1, $[Lc(r, 1, 45) + 1 | 0] = 0, Yr = o + 16 | 0;
              }
              function nc(r, o, c) {
                var h = 0;
                return h = Yr - 16 | 0, Yr = h, jh(h + 8 | 0, o, (c << 2) + o | 0, r), Yr = h + 16 | 0, r;
              }
              function ho(r, o) {
                return o = o | 0, (o | 0) >= 0 && (o = e[((o & 255) << 2) + 11184 >> 2]), o << 24 >> 24;
              }
              function Bo(r) {
                r = r | 0, r = e[6144], r && (e[6145] = r, Sr(r)), r = e[6141], r && (e[6142] = r, Sr(r));
              }
              function na(r, o, c) {
                var h = 0;
                return h = Yr - 16 | 0, Yr = h, jh(h + 8 | 0, r, o, c), Yr = h + 16 | 0, e[h + 12 >> 2];
              }
              function ea(r, o) {
                return o = o | 0, (o | 0) >= 0 && (o = e[((o & 255) << 2) + 9648 >> 2]), o << 24 >> 24;
              }
              function ar(r) {
                var o = 0;
                r = e[r >> 2] - 12 | 0, o = e[r + 8 >> 2] - 1 | 0, e[r + 8 >> 2] = o, (o | 0) < 0 && Sr(r);
              }
              function Je(r) {
                r && (Je(e[r >> 2]), Je(e[r + 4 >> 2]), $[r + 27 | 0] < 0 && Sr(e[r + 16 >> 2]), Sr(r));
              }
              function pr(r) {
                for (r = r | 0, r = 26312; r = qi(r - 12 | 0), (r | 0) != 26288; )
                  ;
              }
              function Lr(r) {
                for (r = r | 0, r = 26240; r = qi(r - 12 | 0), (r | 0) != 25952; )
                  ;
              }
              function hn(r) {
                for (r = r | 0, r = 25640; r = qi(r - 12 | 0), (r | 0) != 25472; )
                  ;
              }
              function mn(r) {
                for (r = r | 0, r = 26280; r = qi(r - 12 | 0), (r | 0) != 26256; )
                  ;
              }
              function qn(r) {
                for (r = r | 0, r = 25936; r = qi(r - 12 | 0), (r | 0) != 25648; )
                  ;
              }
              function Vn(r) {
                for (r = r | 0, r = 25464; r = qi(r - 12 | 0), (r | 0) != 25296; )
                  ;
              }
              function oi(r) {
                return r = r | 0, e[r >> 2] = 13768, e[r + 8 >> 2] != (mo() | 0) && g1(e[r + 8 >> 2]), r | 0;
              }
              function li(r, o) {
                var c = 0;
                return c = e[o >> 2], e[o >> 2] = 0, Yo(r, c), e[r + 4 >> 2] = e[o + 4 >> 2], r;
              }
              function Di(r) {
                var o = 0;
                o = e[r >> 2], e[o >> 2] && (A6(o), r = e[r >> 2], Md(r + 16 | 0, e[r >> 2]));
              }
              function mi(r, o, c) {
                return o = o | 0, c = c | 0, (e[(c << 2) + 12736 >> 2] & o) != 0 & c >>> 0 <= 127;
              }
              function is(r, o, c, h, y, g) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, g = g | 0, _n[r | 0](o, c, h, y, g);
              }
              function es(r, o) {
                return r = r | 0, o = o | 0, e[r >> 2] = 22892, e[r >> 2] = 22480, Nd(r + 4 | 0, o), r | 0;
              }
              function fs(r, o) {
                return r = r | 0, o = o | 0, e[r >> 2] = 22892, e[r >> 2] = 22500, Nd(r + 4 | 0, o), r | 0;
              }
              function Yi(r, o, c, h, y) {
                return r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, _n[r | 0](o, c, h, y) | 0;
              }
              function os(r, o) {
                r = r | 0, o = o | 0;
                var c = 0;
                c = i1(e[o >> 2]), e[r + 4 >> 2] = e[o >> 2], e[r >> 2] = c;
              }
              function ls() {
                e[6593] = 0, e[6592] = 22008, e[6592] = 14144, e[6592] = 13768, e[6594] = mo();
              }
              function Cs(r) {
                for (var o = 0; ; ) {
                  if (r) {
                    r = r - 1 & r, o = o + 1 | 0;
                    continue;
                  }
                  break;
                }
                return o;
              }
              function bs() {
                var r = 0;
                r = ru(4), e[r >> 2] = 22892, e[r >> 2] = 22364, xa(r | 0, 22448, 5), ri();
              }
              function Zs(r, o, c, h) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, Va(r, e[o + 8 >> 2], 0) && cl(o, c, h);
              }
              function Ms(r, o) {
                var c = 0;
                return c = r, r = (o >>> 0) / 100 | 0, Pf(Pf(c, r), vi(r, -100) + o | 0);
              }
              function Os(r, o) {
                var c = 0;
                return c = r, r = (o >>> 0) / 1e4 | 0, Ms(Pf(c, r), vi(r, -1e4) + o | 0);
              }
              function Hs(r, o) {
                var c = 0;
                return c = r, r = (o >>> 0) / 1e6 | 0, Os(Pf(c, r), vi(r, -1e6) + o | 0);
              }
              function Ys(r, o, c, h) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, _n[e[e[r >> 2] + 32 >> 2]](r, o, c, h) | 0;
              }
              function Xo(r, o, c, h) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, _n[e[e[r >> 2] + 48 >> 2]](r, o, c, h) | 0;
              }
              function Ko(r) {
                var o = 0, c = 0;
                o = Yr - 16 | 0, Yr = o, c = o + 12 | 0, e[c >> 2] = r, Di(c), Yr = o + 16 | 0;
              }
              function Qo(r, o) {
                return o = o | 0, o >>> 0 <= 127 && (o = e[(o << 2) + 11184 >> 2]), o | 0;
              }
              function wa(r, o, c) {
                return r = r | 0, o = o | 0, c = c | 0, e[o + 4 >> 2] == (r | 0) & e[o >> 2] == (c | 0);
              }
              function Ca() {
                e[6651] = 0, e[6650] = 22008, e[6650] = 14144, g6(26608), e[6650] = 16704;
              }
              function Ru() {
                e[6655] = 0, e[6654] = 22008, e[6654] = 14144, g6(26624), e[6654] = 16860;
              }
              function Ss(r, o) {
                return o = o | 0, o >>> 0 <= 127 && (o = e[(o << 2) + 9648 >> 2]), o | 0;
              }
              function Fs(r) {
                return ye[25260] || (pc(25248, 14004), $[25260] = 1), 25248;
              }
              function So(r) {
                return ye[25292] || (pc(25280, 14088), $[25292] = 1), 25280;
              }
              function _o(r) {
                return ye[25196] || (pc(25184, 13932), $[25196] = 1), 25184;
              }
              function zo(r) {
                return ye[25228] || (pc(25216, 13968), $[25228] = 1), 25216;
              }
              function Ua(r, o, c) {
                return r = r | 0, o = o | 0, c = c | 0, _n[e[e[r >> 2] + 12 >> 2]](r, o, c) | 0;
              }
              function ou(r, o, c) {
                return r = r | 0, o = o | 0, c = c | 0, _n[e[e[r >> 2] + 48 >> 2]](r, o, c) | 0;
              }
              function Xa(r) {
                return ye[25244] || (Ga(25232, 2743), $[25244] = 1), 25232;
              }
              function ic(r) {
                return ye[25276] || (Ga(25264, 1928), $[25276] = 1), 25264;
              }
              function sc(r) {
                return ye[25180] || (Ga(25168, 1139), $[25180] = 1), 25168;
              }
              function jc(r) {
                return ye[25212] || (Ga(25200, 2881), $[25212] = 1), 25200;
              }
              function ju(r, o, c, h, y) {
                return c = c | 0, y = y | 0, e[y >> 2] = c, 3;
              }
              function Ma(r, o) {
                r = r | 0, $[r | 0] = 2, $[r + 1 | 0] = 3, $[r + 2 | 0] = 0, $[r + 3 | 0] = 4;
              }
              function Ud(r) {
                r = r | 0, e[r + 16 >> 2] = e[r + 16 >> 2] | 1, $[r + 20 | 0] & 1 && (Hd(), ri());
              }
              function oc(r, o, c, h, y) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, y = y | 0, _n[r | 0](o, c, h, y);
              }
              function ac(r) {
                return r = r | 0, e[r + 8 >> 2] != (mo() | 0) && g1(e[r + 8 >> 2]), r | 0;
              }
              function y1(r, o, c, h) {
                return r = r | 0, o = o | 0, c = c | 0, h = h | 0, _n[r | 0](o, c, h) | 0;
              }
              function Vc(r, o, c, h, y, g) {
                r = r | 0, g = g | 0, pl(r, g);
              }
              function ka(r, o) {
                return o ? r << 24 | (r & 65280) << 8 | (r >>> 8 & 65280 | r >>> 24) : r;
              }
              function Wc(r, o, c) {
                return o = o | 0, c = c | 0, (o >>> 0 < 128 ? o : c) << 24 >> 24;
              }
              function bc(r, o) {
                r = r | 0, o = o | 0;
                var c = 0;
                c = xs(o), e[r + 4 >> 2] = o, e[r >> 2] = c;
              }
              function Md(r, o) {
                e: {
                  if ((r | 0) == (o | 0)) {
                    $[o + 120 | 0] = 0;
                    break e;
                  }
                  Sr(o);
                }
              }
              function m6(r) {
                r = r | 0;
                var o = 0;
                o = e[6259] + 1 | 0, e[6259] = o, e[r + 4 >> 2] = o;
              }
              function Q4(r, o) {
                return r = r | 0, o = o | 0, _n[e[e[r >> 2] + 28 >> 2]](r, o) | 0;
              }
              function I6(r, o) {
                return r = r | 0, o = o | 0, r = es(r, o), e[r >> 2] = 22548, r | 0;
              }
              function w6(r, o) {
                return r = r | 0, o = o | 0, _n[e[e[r >> 2] + 44 >> 2]](r, o) | 0;
              }
              function b6(r, o) {
                return r = r | 0, o = o | 0, _n[e[e[r >> 2] + 12 >> 2]](r, o) | 0;
              }
              function E6(r) {
                return r = r | 0, r ? (Yf(r, 22200) | 0) != 0 | 0 : 0;
              }
              function B6(r) {
                return r = r | 0, r = e[r + 8 >> 2], r ? Rf(r) | 0 : 1;
              }
              function C6(r, o) {
                r = r | 0, o = o | 0, e[5996] || (e[5996] = r, e[5997] = o);
              }
              function Du(r, o) {
                r = r | 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0;
              }
              function qi(r) {
                return (ye[r + 11 | 0] & 128) >>> 7 | 0 && Sr(e[r >> 2]), r;
              }
              function U4(r) {
                return r >>> 0 >= 1073741824 && (su(), ri()), xs(r << 2);
              }
              function k6(r, o, c, h) {
                r = r | 0, o = o | 0, c = c | 0, h = h | 0, _n[r | 0](o, c, h);
              }
              function M4(r) {
                return r = r | 0, e[r >> 2] = 7960, qi(r + 32 | 0), Hc(r) | 0;
              }
              function S6(r, o, c) {
                return o = o | 0, c = c | 0, ((o | 0) < 0 ? c : o) | 0;
              }
              function T6(r) {
                return r = r | 0, r = es(r, 2284), e[r >> 2] = 22600, r | 0;
              }
              function x6(r, o, c) {
                r = r | 0, o = o | 0, c = c | 0, e[r + 4 >> 2] = o, e[r >> 2] = c;
              }
              function R6(r) {
                return r = r | 0, r = fs(r, 1241), e[r >> 2] = 22684, r | 0;
              }
              function F4(r) {
                return r = r | 0, e[r >> 2] = 13856, qi(r + 16 | 0), r | 0;
              }
              function L4(r) {
                return r = r | 0, e[r >> 2] = 13816, qi(r + 12 | 0), r | 0;
              }
              function i4(r) {
                return r = r | 0, e[r >> 2] = 22500, ar(r + 4 | 0), r | 0;
              }
              function H4(r) {
                return r = r | 0, e[r >> 2] = 22480, ar(r + 4 | 0), r | 0;
              }
              function Pf(r, o) {
                return o = (o << 1) + 21664 | 0, na(o, o + 2 | 0, r);
              }
              function D6(r) {
                return r = r | 0, o4(e[e[r >> 2] - 12 >> 2] + r | 0) | 0;
              }
              function K4(r, o) {
                r = r | 0, o = o | 0, _n[e[e[o >> 2] + 24 >> 2]](r, o);
              }
              function G4(r, o) {
                r = r | 0, o = o | 0, _n[e[e[o >> 2] + 28 >> 2]](r, o);
              }
              function N6(r) {
                return r = r | 0, yl(e[e[r >> 2] - 12 >> 2] + r | 0) | 0;
              }
              function j4(r, o) {
                r = r | 0, o = o | 0, _n[e[e[o >> 2] + 20 >> 2]](r, o);
              }
              function P6(r) {
                r = r | 0, r && (r = r - 24 | 0, e[r >> 2] = e[r >> 2] + 1);
              }
              function q6(r, o, c, h) {
                r = r | 0, c = c | 0, h = h | 0, sd(r, c, h);
              }
              function O6(r, o, c, h) {
                r = r | 0, c = c | 0, h = h | 0, Ph(r, c, h);
              }
              function bl(r, o) {
                var c = 0;
                c = U4(o), e[r + 4 >> 2] = o, e[r >> 2] = c;
              }
              function Q6(r) {
                return r = r | 0, _n[e[e[r >> 2] + 24 >> 2]](r) | 0;
              }
              function V4(r, o, c) {
                return r = zl(r, o, c, 0, -2147483648), r;
              }
              function W4(r) {
                return r = r | 0, _n[e[e[r >> 2] + 16 >> 2]](r) | 0;
              }
              function z4(r) {
                return r = r | 0, _n[e[e[r >> 2] + 12 >> 2]](r) | 0;
              }
              function J4(r, o) {
                return r = r | 0, o = o | 0, Ad(r, o, Da(o)) | 0;
              }
              function Nu(r, o) {
                return r = r | 0, o = o | 0, dA(r) ^ dA(o) ^ 1;
              }
              function Pu(r, o) {
                return r = r | 0, o = o | 0, lA(r) ^ lA(o) ^ 1;
              }
              function U6(r) {
                $[24003] < 0 && Sr(e[5998]);
              }
              function M6(r) {
                return r = r | 0, r = Yr - r & -16, Yr = r, r | 0;
              }
              function Y4(r, o) {
                return r ? cd(r, o) : 0;
              }
              function F6(r, o, c) {
                return r = r | 0, r | 0;
              }
              function zc(r, o, c) {
                return b4(18, r | 0, o | 0, c | 0) | 0;
              }
              function X4(r, o, c) {
                return -1;
              }
              function L6(r) {
                r = r | 0, f6(e[e[r >> 2] - 12 >> 2] + r | 0);
              }
              function _4(r, o, c) {
                return r = zl(r, o, c, -1, -1), r;
              }
              function H6(r) {
                r = r | 0, l6(e[e[r >> 2] - 12 >> 2] + r | 0);
              }
              function m1(r, o, c, h) {
                T1(152, r | 0, o | 0, c | 0, h | 0);
              }
              function Z4(r, o, c, h) {
                S1(155, r | 0, o | 0, c | 0, h | 0);
              }
              function K6(r) {
                return r = r | 0, e[r >> 2] = 7e3, r | 0;
              }
              function G6(r) {
                r = r | 0, _n[e[e[r >> 2] + 4 >> 2]](r);
              }
              function El(r) {
                return r = r | 0, s1(e[r >> 2]), r | 0;
              }
              function Bl(r) {
                return r = r | 0, i1(e[r >> 2]), r | 0;
              }
              function j6(r) {
                r = r | 0, Oo(r, 26616, Mo(24916));
              }
              function V6(r) {
                r = r | 0, Oo(r, 26632, Mo(24988));
              }
              function W6(r) {
                r = r | 0, Oo(r, 26640, Mo(24996));
              }
              function z6(r) {
                r = r | 0, Oo(r, 26320, Mo(24844));
              }
              function J6(r) {
                r = r | 0, Oo(r, 26328, Mo(24852));
              }
              function Y6(r) {
                r = r | 0, Oo(r, 26352, Mo(25040));
              }
              function X6(r) {
                r = r | 0, Oo(r, 26360, Mo(25056));
              }
              function _6(r) {
                r = r | 0, Oo(r, 26368, Mo(25064));
              }
              function Z6(r) {
                r = r | 0, Oo(r, 26384, Mo(25072));
              }
              function $6(r) {
                r = r | 0, Oo(r, 26392, Mo(25088));
              }
              function ey(r) {
                r = r | 0, Oo(r, 26400, Mo(25080));
              }
              function ty(r) {
                r = r | 0, Oo(r, 26408, Mo(25096));
              }
              function ry(r) {
                r = r | 0, Oo(r, 26416, Mo(25104));
              }
              function ny(r) {
                r = r | 0, Oo(r, 26440, Mo(25112));
              }
              function iy(r) {
                r = r | 0, Oo(r, 26472, Mo(24860));
              }
              function sy(r) {
                r = r | 0, Oo(r, 26480, Mo(24868));
              }
              function oy(r) {
                r = r | 0, Oo(r, 26488, Mo(24876));
              }
              function ay(r) {
                r = r | 0, Oo(r, 26496, Mo(24884));
              }
              function uy(r) {
                r = r | 0, Oo(r, 26504, Mo(24924));
              }
              function cy(r) {
                r = r | 0, Oo(r, 26512, Mo(24932));
              }
              function fy(r) {
                r = r | 0, Oo(r, 26520, Mo(24940));
              }
              function ly(r) {
                r = r | 0, Oo(r, 26528, Mo(24948));
              }
              function dy(r) {
                r = r | 0, Oo(r, 26536, Mo(24956));
              }
              function hy(r) {
                r = r | 0, Oo(r, 26544, Mo(24964));
              }
              function Ay(r) {
                r = r | 0, Oo(r, 26552, Mo(24972));
              }
              function gy(r) {
                r = r | 0, Oo(r, 26560, Mo(24980));
              }
              function py(r) {
                r = r | 0, Oo(r, 26568, Mo(24892));
              }
              function yy(r) {
                r = r | 0, Oo(r, 26584, Mo(24900));
              }
              function my(r) {
                r = r | 0, Oo(r, 26600, Mo(24908));
              }
              function Iy(r) {
                r = r | 0, Oo(r, 26336, Mo(25048));
              }
              function s4(r) {
                return r = r | 0, Au(r, 25048) | 0;
              }
              function o4(r) {
                return r = r | 0, A4(r + 4 | 0), r | 0;
              }
              function a4(r) {
                return r = r | 0, Au(r, 25040) | 0;
              }
              function wy(r) {
                return r = r | 0, Au(r, 24876) | 0;
              }
              function uc(r, o, c) {
                return na(o, o + c | 0, r), r;
              }
              function u4(r) {
                return r = r | 0, Au(r, 25104) | 0;
              }
              function c4(r) {
                return r = r | 0, Au(r, 25112) | 0;
              }
              function by(r, o) {
                r = r | 0, o = o | 0, pl(r, o + 16 | 0);
              }
              function Ey(r, o) {
                r = r | 0, o = o | 0, pl(r, o + 12 | 0);
              }
              function By(r, o) {
                r = r | 0, pc(r, 13888);
              }
              function vy(r, o) {
                r = r | 0, pc(r, 13908);
              }
              function $4(r, o) {
                return o = o | 0, o | 0;
              }
              function e6(r, o) {
                r = r | 0, Nh(r, 1, 45);
              }
              function f4(r, o, c) {
                return r = _4(r, o, c), r;
              }
              function t6(r, o, c) {
                return r = V4(r, o, c), r;
              }
              function Cy(r, o) {
                r = r | 0, Ga(r, 2331);
              }
              function ky(r, o) {
                r = r | 0, Ga(r, 2350);
              }
              function I1(r) {
                return 2147483647;
              }
              function Sy(r) {
                return r = r | 0, e[r + 12 >> 2];
              }
              function ia(r) {
                return r = r | 0, jf(8, r) | 0;
              }
              function Ty(r) {
                return r = r | 0, e[r + 8 >> 2];
              }
              function r6(r, o) {
                return -1;
              }
              function n6(r) {
                return r = r | 0, e[r + 4 >> 2];
              }
              function xy(r, o) {
                return 0;
              }
              function Ry(r) {
                return r = r | 0, $[r + 8 | 0];
              }
              function Dy(r) {
                return r = r | 0, $[r + 9 | 0];
              }
              function Jc(r, o, c) {
                return Ks(r, o, c);
              }
              function i6(r) {
                return r = r | 0, i4(r) | 0;
              }
              function s6(r) {
                ye[r + 4 | 0] || Di(r);
              }
              function o6(r) {
                return Au(r, 24932);
              }
              function a6(r) {
                return Au(r, 24924);
              }
              function u6(r) {
                return Au(r, 24948);
              }
              function c6(r) {
                return Au(r, 24940);
              }
              function Ny(r) {
                return 2176;
              }
              function Py(r) {
                return 1304;
              }
              function qy(r) {
                return 2042;
              }
              function Oy(r) {
                return 1969;
              }
              function Qy(r) {
                return 2524;
              }
              function w1(r) {
                return 127;
              }
              function cc(r) {
                return r = r | 0, r | 0;
              }
              function f6(r) {
                r = r | 0, Sr(o4(r));
              }
              function b1(r) {
                r = r | 0, Sr(i4(r));
              }
              function Uy(r) {
                qi(25248);
              }
              function My(r) {
                qi(25280);
              }
              function Fy(r) {
                r = r | 0, Sr(Od(r));
              }
              function l6(r) {
                r = r | 0, Sr(yl(r));
              }
              function Ly(r) {
                qi(25184);
              }
              function Hy(r) {
                qi(25216);
              }
              function Ky(r) {
                r = r | 0, Sr(wf(r));
              }
              function Gy(r) {
                qi(25232);
              }
              function jy(r) {
                r = r | 0, Sr(M4(r));
              }
              function Vy(r) {
                qi(25168);
              }
              function Wy(r) {
                qi(25200);
              }
              function d6(r) {
                r = r | 0, Sr(ac(r));
              }
              function zy(r) {
                r = r | 0, Sr(F4(r));
              }
              function Jy(r) {
                r = r | 0, Sr(al(r));
              }
              function Yy(r) {
                r = r | 0, Sr(L4(r));
              }
              function Xy(r) {
                r = r | 0, Sr(oi(r));
              }
              function l4(r) {
                r = r | 0, Sr(H4(r));
              }
              function _y(r) {
                r = r | 0, Sr(Hc(r));
              }
              function Zy(r) {
                qi(25264);
              }
              function $y(r) {
                return -1;
              }
              function E1(r) {
                return 4;
              }
              function d4(r) {
                return 1;
              }
              function Za(r) {
                return 0;
              }
              function h6(r) {
                return 2;
              }
              function h4(r, o) {
              }
              function A6(r) {
                r4(r, e[r >> 2]);
              }
              function g6(r) {
                e[r >> 2] = mo();
              }
              function ba() {
                Tu(2284), ri();
              }
              function Lo() {
                Tu(1687), ri();
              }
              function Po(r) {
                r = r | 0, Sr(r);
              }
              function e8(r) {
                r = r | 0, uo = r;
              }
              function t8() {
                return Yr | 0;
              }
              function r8(r) {
                r = r | 0, Yr = r;
              }
              function n8(r) {
                ri();
              }
              function Js(r) {
                Yo(r, 0);
              }
              function i8() {
                p6(), ri();
              }
              function p6() {
                Ff(), ri();
              }
              function A4(r) {
                al(r);
              }
              function g4(r) {
              }
              ji = ye, bo();
              var _n = ns([null, U6, ba, xs, PA, cc, I6, H4, Lo, Ap, N4, Lo, Ng, eA, qp, Fo, Ef, es, J1, V1, P4, Xh, Np, Pp, Bd, Wp, zg, eh, _g, nf, Ga, C4, Yl, _u, Lo, su, Th, Zd, gp, Bh, il, Lo, yp, j1, aa, Rl, F1, Lo, x4, yh, Ol, z1, Lo, Y1, uu, Ba, Lo, Iu, Bo, Lo, Tg, _d, Lo, th, dc, Pg, bu, Op, xp, Og, vd, Ns, l2, ys, Qp, hu, Up, fl, ll, Mp, qs, Na, ao, sA, Lo, Lo, K1, Yd, zu, xg, M1, fs, i4, Lo, Lo, Lo, Lo, J4, vp, ad, Ad, Yu, O1, Dp, _h, yc, Zh, $h, tc, rh, Wu, jd, Lo, N1, df, kc, gd, U1, yd, Ig, up, Lo, P1, Lo, tu, T6, ch, Xf, Hf, ql, kp, Jl, Vh, wc, yo, wy, Xg, Kc, ld, Ud, D1, q1, Lo, qg, rd, Eh, Yg, rp, Kg, Ip, Hp, kf, vg, Wl, sd, Yh, op, Hg, vh, k4, R4, G1, rd, Dg, kc, Nl, o1, R6, Nf, Q6, s4, Q4, gc, cc, $u, e4, Zg, i6, po, lp, u4, K4, G4, Kf, Po, bs, Nu, zp, b6, El, m6, Zp, Hd, W4, j4, Ys, z4, a4, c4, K4, G4, Gf, Pu, Xp, Q4, Bl, W4, j4, Xo, z4, c1, Gl, Z1, Sc, ul, ah, w6, ou, nh, Hu, g4, Jd, Sf, Qg, O4, dp, Uh, Xu, H1, Ug, Ua, os, Bp, Uh, D4, cp, B4, ng, Rg, rg, z6, J6, Iy, Y6, X6, ls, _6, Z6, $6, ey, ty, ry, ny, iy, sy, oy, ay, uy, cy, fy, ly, dy, hy, Ay, gy, py, yy, Ca, my, Ru, j6, V6, W6, Vp, og, hn, Lr, pr, Uy, My, Ly, Hy, Vn, qn, mn, Gy, Zy, Vy, Wy, bc, _p, p6, K6, Po, kh, xy, Po, Hc, _y, h4, F6, $p, n4, Za, Za, ep, $y, Jp, r6, dd, r6, M4, jy, Fg, q4, bp, ap, Mg, yl, l6, N6, H6, o4, f6, D6, L6, cc, Po, qy, x6, gl, wa, hc, b1, n6, al, Jy, wf, Ky, G6, Od, Fy, ho, kd, ea, Su, $4, t1, S6, Tf, oi, Xy, uf, ig, mp, jp, Za, Qh, B6, L4, Yy, Ry, Dy, Ey, Cy, ky, F4, zy, Ty, Sy, by, By, vy, cc, Po, Po, mi, Lp, Gp, Kp, Qo, Ic, Ss, Al, $4, eo, Wc, Mc, Po, d1, d1, ju, d4, d4, Cf, d4, Po, Vl, jl, ju, Za, Za, lf, E1, Po, Vl, jl, ju, Za, Za, lf, E1, Po, fh, uh, ju, Za, Za, Xl, E1, Po, fh, uh, ju, Za, Za, Xl, E1, cc, Po, Cp, q6, hl, cc, Po, Sp, O6, x2, Po, Bg, Ll, yg, wg, af, af, mg, fg, no, Ml, sh, Po, Eg, gg, hg, pg, oh, oh, Ag, lg, dg, ag, $1, Po, T4, Vg, Gg, Wg, jg, bg, ug, Jg, Po, S4, Fu, gh, $f, _f, Hl, cg, mh, cc, Po, h6, Eo, Jh, np, ip, fd, W1, pp, $g, pu, Xa, ic, sc, jc, cc, Po, h6, wp, Tp, sp, Rh, Nc, Xd, Fh, Ch, N2, Fs, So, _o, zo, ac, d6, bh, ac, d6, Lg, Po, w1, w1, Du, Du, Du, p1, Za, Ma, Ma, Po, w1, w1, Du, Du, Du, p1, Za, Ma, Ma, Po, I1, I1, Du, Du, Du, e6, Za, Ma, Ma, Po, I1, I1, Du, Du, Du, e6, Za, Ma, Ma, Po, Ul, Cg, Po, sg, kg, Po, X1, tg, Po, $d, eg, Po, X4, Vc, h4, Po, X4, tp, h4, i6, b1, cc, n8, i8, Ff, cc, Po, g4, g4, hp, ph, Sg, Ep, Po, Qy, Po, Ny, l4, n6, b1, l4, l4, b1, Po, Py, Po, h1, fp, Zs, Po, xf, wh, Yp, Po, Oy]);
              function s8() {
                return Ja.byteLength / 65536 | 0;
              }
              return { Y: Q1, Z: Po, _: ia, $: Ju, aa: L1, ba: _n, ca: C6, da: e8, ea: t8, fa: r8, ga: M6, ha: Wh, ia: P6, ja: E2, ka: E6, la: y1, ma: k6, na: oc, oa: oc, pa: is, qa: Yi };
            }
            return Sa(Wi);
          }(bi);
        }, RuntimeError: Error };
        rr = [], typeof er != "object" && si("no native wasm support detected");
        var ir, sr = !1;
        function nr(pi, bi) {
          pi || si(bi);
        }
        var fr, lr, br, Br;
        function Fr() {
          var pi = ir.buffer;
          xe.HEAP8 = fr = new Int8Array(pi), xe.HEAP16 = new Int16Array(pi), xe.HEAPU8 = lr = new Uint8Array(pi), xe.HEAPU16 = new Uint16Array(pi), xe.HEAP32 = br = new Int32Array(pi), xe.HEAPU32 = Br = new Uint32Array(pi), xe.HEAPF32 = new Float32Array(pi), xe.HEAPF64 = new Float64Array(pi);
        }
        var Gr = xe.INITIAL_MEMORY || 16777216;
        nr(Gr >= 65536, "INITIAL_MEMORY should be larger than STACK_SIZE, was " + Gr + "! (STACK_SIZE=65536)"), xe.wasmMemory ? ir = xe.wasmMemory : ir = new er.Memory({ initial: Gr / 65536, maximum: Gr / 65536 }), Fr(), Gr = ir.buffer.byteLength;
        var qr, Hr = [], un = [], Dr = [];
        function wr() {
          if (xe.preRun)
            for (typeof xe.preRun == "function" && (xe.preRun = [xe.preRun]); xe.preRun.length; )
              _r(xe.preRun.shift());
          Zr(Hr);
        }
        function yr() {
          Zr(un);
        }
        function Qr() {
          if (xe.postRun)
            for (typeof xe.postRun == "function" && (xe.postRun = [xe.postRun]); xe.postRun.length; )
              fn(xe.postRun.shift());
          Zr(Dr);
        }
        function _r(pi) {
          Hr.unshift(pi);
        }
        function Jr(pi) {
          un.unshift(pi);
        }
        function fn(pi) {
          Dr.unshift(pi);
        }
        var jr = 0, dn = null;
        function Tn(pi) {
          jr++, xe.monitorRunDependencies && xe.monitorRunDependencies(jr);
        }
        function Yn(pi) {
          if (jr--, xe.monitorRunDependencies && xe.monitorRunDependencies(jr), jr == 0 && dn) {
            var bi = dn;
            dn = null, bi();
          }
        }
        function si(pi) {
          xe.onAbort && xe.onAbort(pi), pi = "Aborted(" + pi + ")", Ne(pi), sr = !0, pi += ". Build with -sASSERTIONS for more info.";
          var bi = new er.RuntimeError(pi);
          throw He(bi), bi;
        }
        var vn = "data:application/octet-stream;base64,";
        function Cn(pi) {
          return pi.startsWith(vn);
        }
        var Xr;
        Xr = "bindings.wasm", Cn(Xr) || (Xr = Se(Xr));
        function In(pi) {
          if (pi == Xr && rr)
            return new Uint8Array(rr);
          var bi = Co(pi);
          if (bi)
            return bi;
          throw "sync fetching of the wasm failed: you can preload it to Module['wasmBinary'] manually, or emcc.py will do that for you when generating HTML (but not JS)";
        }
        function zr(pi, bi) {
          var Ni, Wi = In(pi);
          Ni = new er.Module(Wi);
          var ns = new er.Instance(Ni, bi);
          return [ns, Ni];
        }
        function En() {
          var pi = { a: Be };
          function bi(Wi, ns) {
            var ji = Wi.exports;
            return Me = ji, qr = Me.ba, Jr(Me.Y), Yn(), ji;
          }
          if (Tn(), xe.instantiateWasm)
            try {
              return xe.instantiateWasm(pi, bi);
            } catch (Wi) {
              Ne(`Module.instantiateWasm callback failed with error: ${Wi}`), He(Wi);
            }
          var Ni = zr(Xr, pi);
          return bi(Ni[0]);
        }
        var Zr = (pi) => {
          for (; pi.length > 0; )
            pi.shift()(xe);
        }, kr = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0, Rr = (pi, bi, Ni) => {
          for (var Wi = bi + Ni, ns = bi; pi[ns] && !(ns >= Wi); ) ++ns;
          if (ns - bi > 16 && pi.buffer && kr)
            return kr.decode(pi.subarray(bi, ns));
          for (var ji = ""; bi < ns; ) {
            var rs = pi[bi++];
            if (!(rs & 128)) {
              ji += String.fromCharCode(rs);
              continue;
            }
            var Is = pi[bi++] & 63;
            if ((rs & 224) == 192) {
              ji += String.fromCharCode((rs & 31) << 6 | Is);
              continue;
            }
            var ds = pi[bi++] & 63;
            if ((rs & 240) == 224 ? rs = (rs & 15) << 12 | Is << 6 | ds : rs = (rs & 7) << 18 | Is << 12 | ds << 6 | pi[bi++] & 63, rs < 65536)
              ji += String.fromCharCode(rs);
            else {
              var bo = rs - 65536;
              ji += String.fromCharCode(55296 | bo >> 10, 56320 | bo & 1023);
            }
          }
          return ji;
        }, Er = (pi, bi) => pi ? Rr(lr, pi, bi) : "", Or = (pi, bi, Ni, Wi) => {
          si(`Assertion failed: ${Er(pi)}, at: ` + [bi ? Er(bi) : "unknown filename", Ni, Wi ? Er(Wi) : "unknown function"]);
        }, wn = [], Kn = 0, Ln = (pi) => {
          var bi = new hi(pi);
          return bi.get_caught() || (bi.set_caught(!0), Kn--), bi.set_rethrown(!1), wn.push(bi), xr(bi.excPtr), bi.get_exception_ptr();
        }, Wn = 0, Sn = () => {
          tr(0, 0);
          var pi = wn.pop();
          Ir(pi.excPtr), Wn = 0;
        };
        function hi(pi) {
          this.excPtr = pi, this.ptr = pi - 24, this.set_type = function(bi) {
            Br[this.ptr + 4 >> 2] = bi;
          }, this.get_type = function() {
            return Br[this.ptr + 4 >> 2];
          }, this.set_destructor = function(bi) {
            Br[this.ptr + 8 >> 2] = bi;
          }, this.get_destructor = function() {
            return Br[this.ptr + 8 >> 2];
          }, this.set_caught = function(bi) {
            bi = bi ? 1 : 0, fr[this.ptr + 12 >> 0] = bi;
          }, this.get_caught = function() {
            return fr[this.ptr + 12 >> 0] != 0;
          }, this.set_rethrown = function(bi) {
            bi = bi ? 1 : 0, fr[this.ptr + 13 >> 0] = bi;
          }, this.get_rethrown = function() {
            return fr[this.ptr + 13 >> 0] != 0;
          }, this.init = function(bi, Ni) {
            this.set_adjusted_ptr(0), this.set_type(bi), this.set_destructor(Ni);
          }, this.set_adjusted_ptr = function(bi) {
            Br[this.ptr + 16 >> 2] = bi;
          }, this.get_adjusted_ptr = function() {
            return Br[this.ptr + 16 >> 2];
          }, this.get_exception_ptr = function() {
            var bi = Wr(this.get_type());
            if (bi)
              return Br[this.excPtr >> 2];
            var Ni = this.get_adjusted_ptr();
            return Ni !== 0 ? Ni : this.excPtr;
          };
        }
        var ki = (pi) => {
          throw Wn || (Wn = pi), Wn;
        }, xi = (pi) => {
          var bi = Wn;
          if (!bi)
            return or(0), 0;
          var Ni = new hi(bi);
          Ni.set_adjusted_ptr(bi);
          var Wi = Ni.get_type();
          if (!Wi)
            return or(0), bi;
          for (var ns in pi) {
            var ji = pi[ns];
            if (ji === 0 || ji === Wi)
              break;
            var rs = Ni.ptr + 16;
            if (Mr(ji, Wi, rs))
              return or(ji), bi;
          }
          return or(Wi), bi;
        }, _i = () => xi([]), Li = (pi) => xi([pi]), ms = (pi, bi) => xi([pi, bi]), Ui = () => {
          var pi = wn.pop();
          pi || si("no exception to throw");
          var bi = pi.excPtr;
          throw pi.get_rethrown() || (wn.push(pi), pi.set_rethrown(!0), pi.set_caught(!1), Kn++), Wn = bi, Wn;
        }, Mi = (pi, bi, Ni) => {
          var Wi = new hi(pi);
          throw Wi.init(bi, Ni), Wn = pi, Kn++, Wn;
        }, Ls = () => Kn, Ds = () => {
          si("");
        }, Pr = (pi, bi, Ni) => lr.copyWithin(pi, bi, bi + Ni), vr = (pi) => {
          si("OOM");
        }, Cr = (pi) => {
          lr.length, vr();
        }, yn = {}, Pn = () => we || "./this.program", $n = () => {
          if (!$n.strings) {
            var pi = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", bi = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: pi, _: Pn() };
            for (var Ni in yn)
              yn[Ni] === void 0 ? delete bi[Ni] : bi[Ni] = yn[Ni];
            var Wi = [];
            for (var Ni in bi)
              Wi.push(`${Ni}=${bi[Ni]}`);
            $n.strings = Wi;
          }
          return $n.strings;
        }, ui = (pi, bi) => {
          for (var Ni = 0; Ni < pi.length; ++Ni)
            fr[bi++ >> 0] = pi.charCodeAt(Ni);
          fr[bi >> 0] = 0;
        }, Ei = (pi, bi) => {
          var Ni = 0;
          return $n().forEach((Wi, ns) => {
            var ji = bi + Ni;
            Br[pi + ns * 4 >> 2] = ji, ui(Wi, ji), Ni += Wi.length + 1;
          }), 0;
        }, zi = (pi, bi) => {
          var Ni = $n();
          Br[pi >> 2] = Ni.length;
          var Wi = 0;
          return Ni.forEach((ns) => Wi += ns.length + 1), Br[bi >> 2] = Wi, 0;
        }, Gi = (pi) => pi, Vi = (pi) => pi % 4 === 0 && (pi % 100 !== 0 || pi % 400 === 0), Ur = (pi, bi) => {
          for (var Ni = 0, Wi = 0; Wi <= bi; Ni += pi[Wi++])
            ;
          return Ni;
        }, $i = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Es = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], pn = (pi, bi) => {
          for (var Ni = new Date(pi.getTime()); bi > 0; ) {
            var Wi = Vi(Ni.getFullYear()), ns = Ni.getMonth(), ji = (Wi ? $i : Es)[ns];
            if (bi > ji - Ni.getDate())
              bi -= ji - Ni.getDate() + 1, Ni.setDate(1), ns < 11 ? Ni.setMonth(ns + 1) : (Ni.setMonth(0), Ni.setFullYear(Ni.getFullYear() + 1));
            else
              return Ni.setDate(Ni.getDate() + bi), Ni;
          }
          return Ni;
        }, Nr = (pi) => {
          for (var bi = 0, Ni = 0; Ni < pi.length; ++Ni) {
            var Wi = pi.charCodeAt(Ni);
            Wi <= 127 ? bi++ : Wi <= 2047 ? bi += 2 : Wi >= 55296 && Wi <= 57343 ? (bi += 4, ++Ni) : bi += 3;
          }
          return bi;
        }, Qn = (pi, bi, Ni, Wi) => {
          if (!(Wi > 0)) return 0;
          for (var ns = Ni, ji = Ni + Wi - 1, rs = 0; rs < pi.length; ++rs) {
            var Is = pi.charCodeAt(rs);
            if (Is >= 55296 && Is <= 57343) {
              var ds = pi.charCodeAt(++rs);
              Is = 65536 + ((Is & 1023) << 10) | ds & 1023;
            }
            if (Is <= 127) {
              if (Ni >= ji) break;
              bi[Ni++] = Is;
            } else if (Is <= 2047) {
              if (Ni + 1 >= ji) break;
              bi[Ni++] = 192 | Is >> 6, bi[Ni++] = 128 | Is & 63;
            } else if (Is <= 65535) {
              if (Ni + 2 >= ji) break;
              bi[Ni++] = 224 | Is >> 12, bi[Ni++] = 128 | Is >> 6 & 63, bi[Ni++] = 128 | Is & 63;
            } else {
              if (Ni + 3 >= ji) break;
              bi[Ni++] = 240 | Is >> 18, bi[Ni++] = 128 | Is >> 12 & 63, bi[Ni++] = 128 | Is >> 6 & 63, bi[Ni++] = 128 | Is & 63;
            }
          }
          return bi[Ni] = 0, Ni - ns;
        };
        function zn(pi, bi, Ni) {
          var Wi = Nr(pi) + 1, ns = new Array(Wi);
          return Qn(pi, ns, 0, ns.length), ns;
        }
        var ti = (pi, bi) => {
          fr.set(pi, bi);
        }, v = (pi, bi, Ni, Wi) => {
          var ns = Br[Wi + 40 >> 2], ji = { tm_sec: br[Wi >> 2], tm_min: br[Wi + 4 >> 2], tm_hour: br[Wi + 8 >> 2], tm_mday: br[Wi + 12 >> 2], tm_mon: br[Wi + 16 >> 2], tm_year: br[Wi + 20 >> 2], tm_wday: br[Wi + 24 >> 2], tm_yday: br[Wi + 28 >> 2], tm_isdst: br[Wi + 32 >> 2], tm_gmtoff: br[Wi + 36 >> 2], tm_zone: ns ? Er(ns) : "" }, rs = Er(Ni), Is = { "%c": "%a %b %d %H:%M:%S %Y", "%D": "%m/%d/%y", "%F": "%Y-%m-%d", "%h": "%b", "%r": "%I:%M:%S %p", "%R": "%H:%M", "%T": "%H:%M:%S", "%x": "%m/%d/%y", "%X": "%H:%M:%S", "%Ec": "%c", "%EC": "%C", "%Ex": "%m/%d/%y", "%EX": "%H:%M:%S", "%Ey": "%y", "%EY": "%Y", "%Od": "%d", "%Oe": "%e", "%OH": "%H", "%OI": "%I", "%Om": "%m", "%OM": "%M", "%OS": "%S", "%Ou": "%u", "%OU": "%U", "%OV": "%V", "%Ow": "%w", "%OW": "%W", "%Oy": "%y" };
          for (var ds in Is)
            rs = rs.replace(new RegExp(ds, "g"), Is[ds]);
          var bo = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], Uo = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
          function Ho(ri, io, Vo) {
            for (var Sa = typeof ri == "number" ? ri.toString() : ri || ""; Sa.length < io; )
              Sa = Vo[0] + Sa;
            return Sa;
          }
          function Ro(ri, io) {
            return Ho(ri, io, "0");
          }
          function vo(ri, io) {
            function Vo(qo) {
              return qo < 0 ? -1 : qo > 0 ? 1 : 0;
            }
            var Sa;
            return (Sa = Vo(ri.getFullYear() - io.getFullYear())) === 0 && (Sa = Vo(ri.getMonth() - io.getMonth())) === 0 && (Sa = Vo(ri.getDate() - io.getDate())), Sa;
          }
          function js(ri) {
            switch (ri.getDay()) {
              case 0:
                return new Date(ri.getFullYear() - 1, 11, 29);
              case 1:
                return ri;
              case 2:
                return new Date(ri.getFullYear(), 0, 3);
              case 3:
                return new Date(ri.getFullYear(), 0, 2);
              case 4:
                return new Date(ri.getFullYear(), 0, 1);
              case 5:
                return new Date(ri.getFullYear() - 1, 11, 31);
              case 6:
                return new Date(ri.getFullYear() - 1, 11, 30);
            }
          }
          function jo(ri) {
            var io = pn(new Date(ri.tm_year + 1900, 0, 1), ri.tm_yday), Vo = new Date(io.getFullYear(), 0, 4), Sa = new Date(io.getFullYear() + 1, 0, 4), qo = js(Vo), Us = js(Sa);
            return vo(qo, io) <= 0 ? vo(Us, io) <= 0 ? io.getFullYear() + 1 : io.getFullYear() : io.getFullYear() - 1;
          }
          var za = { "%a": (ri) => bo[ri.tm_wday].substring(0, 3), "%A": (ri) => bo[ri.tm_wday], "%b": (ri) => Uo[ri.tm_mon].substring(0, 3), "%B": (ri) => Uo[ri.tm_mon], "%C": (ri) => {
            var io = ri.tm_year + 1900;
            return Ro(io / 100 | 0, 2);
          }, "%d": (ri) => Ro(ri.tm_mday, 2), "%e": (ri) => Ho(ri.tm_mday, 2, " "), "%g": (ri) => jo(ri).toString().substring(2), "%G": (ri) => jo(ri), "%H": (ri) => Ro(ri.tm_hour, 2), "%I": (ri) => {
            var io = ri.tm_hour;
            return io == 0 ? io = 12 : io > 12 && (io -= 12), Ro(io, 2);
          }, "%j": (ri) => Ro(ri.tm_mday + Ur(Vi(ri.tm_year + 1900) ? $i : Es, ri.tm_mon - 1), 3), "%m": (ri) => Ro(ri.tm_mon + 1, 2), "%M": (ri) => Ro(ri.tm_min, 2), "%n": () => `
`, "%p": (ri) => ri.tm_hour >= 0 && ri.tm_hour < 12 ? "AM" : "PM", "%S": (ri) => Ro(ri.tm_sec, 2), "%t": () => "	", "%u": (ri) => ri.tm_wday || 7, "%U": (ri) => {
            var io = ri.tm_yday + 7 - ri.tm_wday;
            return Ro(Math.floor(io / 7), 2);
          }, "%V": (ri) => {
            var io = Math.floor((ri.tm_yday + 7 - (ri.tm_wday + 6) % 7) / 7);
            if ((ri.tm_wday + 371 - ri.tm_yday - 2) % 7 <= 2 && io++, io) {
              if (io == 53) {
                var Sa = (ri.tm_wday + 371 - ri.tm_yday) % 7;
                Sa != 4 && (Sa != 3 || !Vi(ri.tm_year)) && (io = 1);
              }
            } else {
              io = 52;
              var Vo = (ri.tm_wday + 7 - ri.tm_yday - 1) % 7;
              (Vo == 4 || Vo == 5 && Vi(ri.tm_year % 400 - 1)) && io++;
            }
            return Ro(io, 2);
          }, "%w": (ri) => ri.tm_wday, "%W": (ri) => {
            var io = ri.tm_yday + 7 - (ri.tm_wday + 6) % 7;
            return Ro(Math.floor(io / 7), 2);
          }, "%y": (ri) => (ri.tm_year + 1900).toString().substring(2), "%Y": (ri) => ri.tm_year + 1900, "%z": (ri) => {
            var io = ri.tm_gmtoff, Vo = io >= 0;
            return io = Math.abs(io) / 60, io = io / 60 * 100 + io % 60, (Vo ? "+" : "-") + ("0000" + io).slice(-4);
          }, "%Z": (ri) => ri.tm_zone, "%%": () => "%" };
          rs = rs.replace(/%%/g, "\0\0");
          for (var ds in za)
            rs.includes(ds) && (rs = rs.replace(new RegExp(ds, "g"), za[ds](ji)));
          rs = rs.replace(/\0\0/g, "%");
          var ya = zn(rs);
          return ya.length > bi ? 0 : (ti(ya, pi), ya.length - 1);
        }, d = (pi, bi, Ni, Wi, ns) => v(pi, bi, Ni, Wi), I = [], n = (pi) => {
          var bi = I[pi];
          return bi || (pi >= I.length && (I.length = pi + 1), I[pi] = bi = qr.get(pi)), bi;
        }, a = (pi) => {
          var bi = xe["_" + pi];
          return bi;
        }, E = (pi, bi, Ni) => Qn(pi, lr, bi, Ni), T = (pi) => {
          var bi = Nr(pi) + 1, Ni = gr(bi);
          return E(pi, Ni, bi), Ni;
        }, L = (pi, bi, Ni, Wi, ns) => {
          var ji = { string: (js) => {
            var jo = 0;
            return js != null && js !== 0 && (jo = T(js)), jo;
          }, array: (js) => {
            var jo = gr(js.length);
            return ti(js, jo), jo;
          } };
          function rs(js) {
            return bi === "string" ? Er(js) : bi === "boolean" ? !!js : js;
          }
          var Is = a(pi), ds = [], bo = 0;
          if (Wi)
            for (var Uo = 0; Uo < Wi.length; Uo++) {
              var Ho = ji[Ni[Uo]];
              Ho ? (bo === 0 && (bo = cr()), ds[Uo] = Ho(Wi[Uo])) : ds[Uo] = Wi[Uo];
            }
          var Ro = Is.apply(null, ds);
          function vo(js) {
            return bo !== 0 && dr(bo), rs(js);
          }
          return Ro = vo(Ro), Ro;
        }, he = (pi, bi, Ni, Wi) => {
          var ns = !Ni || Ni.every((rs) => rs === "number" || rs === "boolean"), ji = bi !== "string";
          return ji && ns && !Wi ? a(pi) : function() {
            return L(pi, bi, Ni, arguments);
          };
        }, Be = { p: Or, t: Ln, v: Sn, b: _i, j: Li, V: ms, E: Ui, r: Mi, L: Ls, h: ki, D: Ds, M: Pr, U: Cr, J: Ei, K: zi, G: us, d: jn, u: wi, c: Xn, W: yi, f: Zn, C: Ai, m: ni, B: Hi, o: Zi, F: ws, y: Bs, N: Ao, S: Gs, g: Gn, l: hs, H: ts, e: fi, T: zs, i: ai, I: Ti, k: Ii, z: Xi, n: Oi, s: Bi, q: ks, w: gs, x: ps, O: Xs, P: $s, R: to, Q: ro, A: Gi, a: ir, X: d }, Me = En();
        Me.Y, Me.__errno_location, Me.__cxa_free_exception, xe._free = Me.Z, xe._malloc = Me._, xe._miniscript_compile = Me.$, xe._miniscript_analyze = Me.aa;
        var tr = Me.ca, or = Me.da, cr = Me.ea, dr = Me.fa, gr = Me.ga, Ir = Me.ha, xr = Me.ia, Mr = Me.ja, Wr = Me.ka, $r = xe.dynCall_iij = Me.la, gn = xe.dynCall_vij = Me.ma, Bn = xe.dynCall_viji = Me.na, kn = xe.dynCall_viij = Me.oa, xn = xe.dynCall_viiij = Me.pa, Un = xe.dynCall_iiij = Me.qa;
        function Gn(pi) {
          var bi = cr();
          try {
            n(pi)();
          } catch (Ni) {
            if (dr(bi), Ni !== Ni + 0) throw Ni;
            tr(1, 0);
          }
        }
        function jn(pi, bi) {
          var Ni = cr();
          try {
            return n(pi)(bi);
          } catch (Wi) {
            if (dr(Ni), Wi !== Wi + 0) throw Wi;
            tr(1, 0);
          }
        }
        function Xn(pi, bi, Ni) {
          var Wi = cr();
          try {
            return n(pi)(bi, Ni);
          } catch (ns) {
            if (dr(Wi), ns !== ns + 0) throw ns;
            tr(1, 0);
          }
        }
        function Zn(pi, bi, Ni, Wi) {
          var ns = cr();
          try {
            return n(pi)(bi, Ni, Wi);
          } catch (ji) {
            if (dr(ns), ji !== ji + 0) throw ji;
            tr(1, 0);
          }
        }
        function ni(pi, bi, Ni, Wi, ns) {
          var ji = cr();
          try {
            return n(pi)(bi, Ni, Wi, ns);
          } catch (rs) {
            if (dr(ji), rs !== rs + 0) throw rs;
            tr(1, 0);
          }
        }
        function ai(pi, bi, Ni, Wi) {
          var ns = cr();
          try {
            n(pi)(bi, Ni, Wi);
          } catch (ji) {
            if (dr(ns), ji !== ji + 0) throw ji;
            tr(1, 0);
          }
        }
        function fi(pi, bi, Ni) {
          var Wi = cr();
          try {
            n(pi)(bi, Ni);
          } catch (ns) {
            if (dr(Wi), ns !== ns + 0) throw ns;
            tr(1, 0);
          }
        }
        function Ai(pi, bi, Ni, Wi, ns) {
          var ji = cr();
          try {
            return n(pi)(bi, Ni, Wi, ns);
          } catch (rs) {
            if (dr(ji), rs !== rs + 0) throw rs;
            tr(1, 0);
          }
        }
        function yi(pi, bi, Ni, Wi) {
          var ns = cr();
          try {
            return n(pi)(bi, Ni, Wi);
          } catch (ji) {
            if (dr(ns), ji !== ji + 0) throw ji;
            tr(1, 0);
          }
        }
        function Ii(pi, bi, Ni, Wi, ns) {
          var ji = cr();
          try {
            n(pi)(bi, Ni, Wi, ns);
          } catch (rs) {
            if (dr(ji), rs !== rs + 0) throw rs;
            tr(1, 0);
          }
        }
        function wi(pi, bi, Ni, Wi, ns) {
          var ji = cr();
          try {
            return n(pi)(bi, Ni, Wi, ns);
          } catch (rs) {
            if (dr(ji), rs !== rs + 0) throw rs;
            tr(1, 0);
          }
        }
        function Bi(pi, bi, Ni, Wi, ns, ji) {
          var rs = cr();
          try {
            n(pi)(bi, Ni, Wi, ns, ji);
          } catch (Is) {
            if (dr(rs), Is !== Is + 0) throw Is;
            tr(1, 0);
          }
        }
        function Ti(pi, bi, Ni, Wi, ns, ji) {
          var rs = cr();
          try {
            n(pi)(bi, Ni, Wi, ns, ji);
          } catch (Is) {
            if (dr(rs), Is !== Is + 0) throw Is;
            tr(1, 0);
          }
        }
        function Oi(pi, bi, Ni, Wi, ns, ji, rs) {
          var Is = cr();
          try {
            n(pi)(bi, Ni, Wi, ns, ji, rs);
          } catch (ds) {
            if (dr(Is), ds !== ds + 0) throw ds;
            tr(1, 0);
          }
        }
        function Hi(pi, bi, Ni, Wi, ns, ji) {
          var rs = cr();
          try {
            return n(pi)(bi, Ni, Wi, ns, ji);
          } catch (Is) {
            if (dr(rs), Is !== Is + 0) throw Is;
            tr(1, 0);
          }
        }
        function Xi(pi, bi, Ni, Wi, ns, ji) {
          var rs = cr();
          try {
            n(pi)(bi, Ni, Wi, ns, ji);
          } catch (Is) {
            if (dr(rs), Is !== Is + 0) throw Is;
            tr(1, 0);
          }
        }
        function Zi(pi, bi, Ni, Wi, ns, ji, rs) {
          var Is = cr();
          try {
            return n(pi)(bi, Ni, Wi, ns, ji, rs);
          } catch (ds) {
            if (dr(Is), ds !== ds + 0) throw ds;
            tr(1, 0);
          }
        }
        function ts(pi, bi, Ni) {
          var Wi = cr();
          try {
            n(pi)(bi, Ni);
          } catch (ns) {
            if (dr(Wi), ns !== ns + 0) throw ns;
            tr(1, 0);
          }
        }
        function us(pi) {
          var bi = cr();
          try {
            return n(pi)();
          } catch (Ni) {
            if (dr(bi), Ni !== Ni + 0) throw Ni;
            tr(1, 0);
          }
        }
        function hs(pi, bi) {
          var Ni = cr();
          try {
            n(pi)(bi);
          } catch (Wi) {
            if (dr(Ni), Wi !== Wi + 0) throw Wi;
            tr(1, 0);
          }
        }
        function ws(pi, bi, Ni, Wi, ns, ji, rs, Is) {
          var ds = cr();
          try {
            return n(pi)(bi, Ni, Wi, ns, ji, rs, Is);
          } catch (bo) {
            if (dr(ds), bo !== bo + 0) throw bo;
            tr(1, 0);
          }
        }
        function ks(pi, bi, Ni, Wi, ns, ji, rs, Is) {
          var ds = cr();
          try {
            n(pi)(bi, Ni, Wi, ns, ji, rs, Is);
          } catch (bo) {
            if (dr(ds), bo !== bo + 0) throw bo;
            tr(1, 0);
          }
        }
        function Bs(pi, bi, Ni, Wi, ns, ji, rs, Is, ds, bo, Uo, Ho) {
          var Ro = cr();
          try {
            return n(pi)(bi, Ni, Wi, ns, ji, rs, Is, ds, bo, Uo, Ho);
          } catch (vo) {
            if (dr(Ro), vo !== vo + 0) throw vo;
            tr(1, 0);
          }
        }
        function gs(pi, bi, Ni, Wi, ns, ji, rs, Is, ds, bo, Uo) {
          var Ho = cr();
          try {
            n(pi)(bi, Ni, Wi, ns, ji, rs, Is, ds, bo, Uo);
          } catch (Ro) {
            if (dr(Ho), Ro !== Ro + 0) throw Ro;
            tr(1, 0);
          }
        }
        function ps(pi, bi, Ni, Wi, ns, ji, rs, Is, ds, bo, Uo, Ho, Ro, vo, js, jo) {
          var za = cr();
          try {
            n(pi)(bi, Ni, Wi, ns, ji, rs, Is, ds, bo, Uo, Ho, Ro, vo, js, jo);
          } catch (ya) {
            if (dr(za), ya !== ya + 0) throw ya;
            tr(1, 0);
          }
        }
        function zs(pi, bi, Ni, Wi) {
          var ns = cr();
          try {
            n(pi)(bi, Ni, Wi);
          } catch (ji) {
            if (dr(ns), ji !== ji + 0) throw ji;
            tr(1, 0);
          }
        }
        function Gs(pi, bi, Ni, Wi) {
          var ns = cr();
          try {
            return $r(pi, bi, Ni, Wi);
          } catch (ji) {
            if (dr(ns), ji !== ji + 0) throw ji;
            tr(1, 0);
          }
        }
        function to(pi, bi, Ni, Wi) {
          var ns = cr();
          try {
            gn(pi, bi, Ni, Wi);
          } catch (ji) {
            if (dr(ns), ji !== ji + 0) throw ji;
            tr(1, 0);
          }
        }
        function ro(pi, bi, Ni, Wi, ns) {
          var ji = cr();
          try {
            Bn(pi, bi, Ni, Wi, ns);
          } catch (rs) {
            if (dr(ji), rs !== rs + 0) throw rs;
            tr(1, 0);
          }
        }
        function $s(pi, bi, Ni, Wi, ns) {
          var ji = cr();
          try {
            kn(pi, bi, Ni, Wi, ns);
          } catch (rs) {
            if (dr(ji), rs !== rs + 0) throw rs;
            tr(1, 0);
          }
        }
        function Xs(pi, bi, Ni, Wi, ns, ji) {
          var rs = cr();
          try {
            xn(pi, bi, Ni, Wi, ns, ji);
          } catch (Is) {
            if (dr(rs), Is !== Is + 0) throw Is;
            tr(1, 0);
          }
        }
        function Ao(pi, bi, Ni, Wi, ns) {
          var ji = cr();
          try {
            return Un(pi, bi, Ni, Wi, ns);
          } catch (rs) {
            if (dr(ji), rs !== rs + 0) throw rs;
            tr(1, 0);
          }
        }
        function co(pi) {
          try {
            for (var bi = atob(pi), Ni = new Uint8Array(bi.length), Wi = 0; Wi < bi.length; ++Wi)
              Ni[Wi] = bi.charCodeAt(Wi);
            return Ni;
          } catch {
            throw new Error("Converting base64 string to bytes failed.");
          }
        }
        function Co(pi) {
          if (Cn(pi))
            return co(pi.slice(vn.length));
        }
        xe.cwrap = he, xe.UTF8ToString = Er;
        var wo;
        dn = function pi() {
          wo || fo(), wo || (dn = pi);
        };
        function fo() {
          if (jr > 0 || (wr(), jr > 0))
            return;
          function pi() {
            wo || (wo = !0, xe.calledRun = !0, !sr && (yr(), Ee(xe), xe.onRuntimeInitialized && xe.onRuntimeInitialized(), Qr()));
          }
          xe.setStatus ? (xe.setStatus("Running..."), setTimeout(function() {
            setTimeout(function() {
              xe.setStatus("");
            }, 1), pi();
          }, 1)) : pi();
        }
        if (xe.preInit)
          for (typeof xe.preInit == "function" && (xe.preInit = [xe.preInit]); xe.preInit.length > 0; )
            xe.preInit.pop()();
        return fo(), Qe;
      };
    })();
    Ie.exports = Pe;
  });
  const k = b(), C = k.cwrap("miniscript_compile", "none", [
    "string",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number"
  ]), B = k.cwrap("miniscript_analyze", "none", [
    "string",
    "number",
    "number",
    "number",
    "number"
  ]), Q = (Ie) => Ie.trim().replace(/\n/g, " ").replace(/ +(?= )/g, ""), P = (Ie) => {
    const be = k._malloc(1e4), Pe = k._malloc(500), Te = k._malloc(1e5), Qe = k._malloc(10), xe = k._malloc(10);
    C(
      Ie,
      be,
      1e4,
      Pe,
      500,
      Te,
      1e5,
      Qe,
      10,
      xe,
      10
    );
    const Ee = {
      miniscript: k.UTF8ToString(be),
      asm: Q(k.UTF8ToString(Te)),
      issane: k.UTF8ToString(Qe) === "true",
      issanesublevel: k.UTF8ToString(xe) === "true"
    };
    return k._free(be), k._free(Pe), k._free(Te), k._free(Qe), k._free(xe), Ee;
  }, x = (Ie) => {
    const be = k._malloc(5e4), Pe = k._malloc(1e5), Te = k._malloc(10), Qe = k._malloc(10);
    B(
      Ie,
      be,
      5e4,
      Pe,
      1e5,
      Te,
      10,
      Qe,
      10
    );
    const xe = k.UTF8ToString(Pe), Ee = k.UTF8ToString(Te), He = k.UTF8ToString(Qe);
    return k._free(be), k._free(Pe), k._free(Te), k._free(Qe), {
      asm: Q(xe),
      issane: Ee === "true",
      issanesublevel: He === "true"
    };
  };
  function M(Ie) {
    const be = Ie.split(" ");
    let Pe = 0;
    for (const Te of be)
      if (Te !== "") if (Te.startsWith("<sig"))
        Pe += 74;
      else if (Te.startsWith("<sha256_preimage(") || Te.startsWith("<hash256_preimage(") || Te.startsWith("<ripemd160_preimage(") || Te.startsWith("<hash160_preimage(") || Te.startsWith("<random_preimage()>"))
        Pe += 33;
      else if (Te.startsWith("<"))
        Pe += 34;
      else if (Te === "1" || Te === "0")
        Pe += 1;
      else
        throw new Error(`Invalid witness substring ${Te}`);
    return Pe;
  }
  function F(Ie) {
    Ie = Ie.map((Te) => (Te = { ...Te }, Te.signatures = Te.asm.split(" ").filter((Qe) => Qe.startsWith("<sig")), Te.signatures.length === 0 && (Te.dontuse = !0), Te.asm.includes("<random_preimage()>") && (Te.dontuse = !0), Te)).sort((Te, Qe) => M(Te.asm) - M(Qe.asm));
    for (const Te of Ie)
      for (const Qe of Ie)
        Qe !== Te && //for the same nLockTime and nSequence
        Qe.nLockTime === Te.nLockTime && Qe.nSequence === Te.nSequence && //is otherSat.signatures equal or a subset of sat.signatures?
        Qe.signatures.every((xe) => Te.signatures.includes(xe)) && (Te.dontuse = !0);
    const be = Ie.filter((Te) => !Te.dontuse), Pe = Ie.filter((Te) => Te.dontuse);
    for (const Te of [be, Pe])
      Te.forEach((Qe) => {
        delete Qe.signatures, delete Qe.dontuse;
      });
    return { nonMalleableSats: be, malleableSats: Pe };
  }
  function le(Ie, be) {
    switch (Ie) {
      case "pk_k":
      case "pk_h":
      case "older":
      case "after":
      case "sha256":
      case "ripemd160":
      case "hash256":
      case "hash160":
      case "multi":
        return !0;
      case "thresh":
        if (be === 0) return !0;
    }
    return !1;
  }
  const ge = (Ie) => {
    if (typeof Ie != "string")
      throw new Error("Invalid expression: " + Ie);
    for (; Ie.match(/^[a-z]{2,}:/); )
      Ie = Ie.replace(
        /^[a-z]{2,}:/,
        (Ee) => Ee.replace(Ee[0], Ee[0] + ":")
      );
    Ie = Ie.replace(/^pk\(/, "c:pk_k(").replace(/^pkh\(/, "c:pk_h(").replace(
      /^and_n\(.*\)/,
      (Ee) => Ee.replace("and_n", "andor").replace(/\)$/, ",0)")
    ).replace(/^t:(.*)/, (Ee) => Ee.replace("t:", "and_v(") + ",1)").replace(/^l:(.*)/, (Ee) => Ee.replace("l:", "or_i(0,") + ")").replace(/^u:(.*)/, (Ee) => Ee.replace("u:", "or_i(") + ",0)");
    const be = String.raw`([^\(:]*)`, Pe = Ie.match(be);
    if (!Pe) throw new Error("Invalid expression: " + Ie);
    const Te = Pe[0];
    if (typeof l[Te] != "function")
      throw new Error(Te + " not implemented");
    let Qe;
    Ie[Te.length] === "(" ? Qe = Ie.substring(Te.length + 1, Ie.length - 1) : Ie[Te.length] === ":" && (Qe = Ie.substring(Te.length + 1));
    const xe = [];
    if (Qe) {
      let Ee = -1, He = 0, ve = 0;
      for (let we = 0; we < Qe.length; we++)
        if (Qe[we] === "(" && He++, Qe[we] === ")" && He--, He === 0) {
          let Ce;
          Qe[we] === "," ? (Ce = Qe.substring(Ee + 1, we), Ee = we) : we === Qe.length - 1 && (Ce = Qe.substring(Ee + 1)), Ce && (le(Te, ve) ? xe.push(Ce) : xe.push(ge(Ce)), ve++);
        }
    }
    return l[Te](...xe);
  }, pe = (Ie, be = {}) => {
    let { unknowns: Pe, knowns: Te } = be;
    const { issane: Qe, issanesublevel: xe } = x(Ie);
    if (!Qe)
      throw new Error(`Miniscript ${Ie} is not sane.`);
    if (typeof Pe > "u" && typeof Te > "u")
      Pe = [];
    else {
      if (typeof Pe < "u" && typeof Te < "u")
        throw new Error("Cannot pass both knowns and unknowns");
      if (Te && !Array.isArray(Te) || Pe && !Array.isArray(Pe))
        throw new Error("Incorrect types for unknowns / knowns");
    }
    const Ee = [], He = [];
    return (ge(Ie).sats || []).map((we) => {
      typeof we.nSequence > "u" && delete we.nSequence, typeof we.nLockTime > "u" && delete we.nLockTime, we.asm = we.asm.replace(/  +/g, " ").trim(), Pe ? Pe.some((Ce) => we.asm.includes(Ce)) ? He.push(we) : Ee.push(we) : Te.reduce(
        (Se, Ne) => Se.replace(Ne, ""),
        we.asm
      ).match(
        /<sig\(|<sha256_preimage\(|<hash256_preimage\(|<ripemd160_preimage\(|<hash160_preimage\(/
      ) ? He.push(we) : Ee.push(we);
    }), { ...F(Ee), unknownSats: He };
  };
  return dist.compileMiniscript = x, dist.compilePolicy = P, dist.satisfier = pe, dist;
}
var hasRequiredMiniscript;
function requireMiniscript() {
  if (hasRequiredMiniscript) return miniscript;
  hasRequiredMiniscript = 1;
  var s = miniscript && miniscript.__createBinding || (Object.create ? function(P, x, M, F) {
    F === void 0 && (F = M);
    var le = Object.getOwnPropertyDescriptor(x, M);
    (!le || ("get" in le ? !x.__esModule : le.writable || le.configurable)) && (le = { enumerable: !0, get: function() {
      return x[M];
    } }), Object.defineProperty(P, F, le);
  } : function(P, x, M, F) {
    F === void 0 && (F = M), P[F] = x[M];
  }), A = miniscript && miniscript.__setModuleDefault || (Object.create ? function(P, x) {
    Object.defineProperty(P, "default", { enumerable: !0, value: x });
  } : function(P, x) {
    P.default = x;
  }), u = miniscript && miniscript.__importStar || function(P) {
    if (P && P.__esModule) return P;
    var x = {};
    if (P != null) for (var M in P) M !== "default" && Object.prototype.hasOwnProperty.call(P, M) && s(x, P, M);
    return A(x, P), x;
  };
  Object.defineProperty(miniscript, "__esModule", { value: !0 }), miniscript.numberEncodeAsm = miniscript.satisfyMiniscript = miniscript.miniscript2Script = miniscript.expandMiniscript = void 0;
  const p = requireSrc$3(), t = requireKeyExpressions(), l = u(requireRe()), m = requireDist$1();
  function b({ miniscript: P, isSegwit: x, network: M = p.networks.bitcoin, ECPair: F, BIP32: le }) {
    const ge = {}, pe = P.replace(RegExp(l.reKeyExp, "g"), (be) => {
      const Pe = "@" + Object.keys(ge).length;
      return ge[Pe] = (0, t.parseKeyExpression)({
        keyExpression: be,
        isSegwit: x,
        network: M,
        ECPair: F,
        BIP32: le
      }), Pe;
    }), Ie = Object.values(ge).filter((be) => be.keyExpression.indexOf("*") === -1).map((be) => {
      if (!be.pubkey)
        throw new Error(`Error: keyExpression ${be.keyExpression} does not have a pubkey`);
      return be.pubkey.toString("hex");
    });
    if (new Set(Ie).size !== Ie.length)
      throw new Error(`Error: miniscript ${P} is not sane: contains duplicate public keys.`);
    return { expandedMiniscript: pe, expansionMap: ge };
  }
  miniscript.expandMiniscript = b;
  function k({ expandedAsm: P, expansionMap: x }) {
    let M = Object.keys(x).reduce((F, le) => {
      var pe;
      const ge = (pe = x[le]) == null ? void 0 : pe.pubkey;
      if (!ge)
        throw new Error(`Error: invalid expansionMap for ${le}`);
      return F.replaceAll(`<${le}>`, `<${ge.toString("hex")}>`).replaceAll(`<HASH160(${le})>`, `<${p.crypto.hash160(ge).toString("hex")}>`);
    }, P);
    return M = M.trim().replace(/\s+/g, " ").replace(/(<\d+>)|\b\d+\b/g, (F) => F.startsWith("<") ? F : Q(Number(F))).replace(/[<>]/g, ""), M;
  }
  function C({ expandedMiniscript: P, expansionMap: x }) {
    const M = (0, m.compileMiniscript)(P);
    if (M.issane !== !0)
      throw new Error(`Error: Miniscript ${P} is not sane`);
    return p.script.fromASM(k({ expandedAsm: M.asm, expansionMap: x }));
  }
  miniscript.miniscript2Script = C;
  function B({ expandedMiniscript: P, expansionMap: x, signatures: M = [], preimages: F = [], timeConstraints: le }) {
    const ge = {};
    F.forEach((Ee) => {
      ge["<" + Ee.digest.replace("(", "_preimage(") + ">"] = "<" + Ee.preimage + ">";
    });
    const pe = {};
    M.forEach((Ee) => {
      const He = Ee.pubkey.toString("hex"), ve = Object.keys(x).find((we) => {
        var Ce, Se;
        return ((Se = (Ce = x[we]) == null ? void 0 : Ce.pubkey) == null ? void 0 : Se.toString("hex")) === He;
      });
      pe["<sig(" + ve + ")>"] = "<" + Ee.signature.toString("hex") + ">";
    });
    const Ie = { ...ge, ...pe }, be = Object.keys(Ie), { nonMalleableSats: Pe } = (0, m.satisfier)(P, { knowns: be });
    if (!Array.isArray(Pe) || !Pe[0])
      throw new Error(`Error: unresolvable miniscript ${P}`);
    let Te;
    if (!le)
      Te = Pe[0];
    else if (Te = Pe.find((Ee) => Ee.nSequence === le.nSequence && Ee.nLockTime === le.nLockTime), Te === void 0)
      throw new Error(`Error: unresolvable miniscript ${P}. Could not find solutions for sequence ${le.nSequence} & locktime=${le.nLockTime}. Signatures are applied to a hash that depends on sequence and locktime. Did you provide all the signatures wrt the signers keys declared and include all preimages?`);
    let Qe = Te.asm;
    for (const Ee in Ie) {
      const He = Ie[Ee];
      if (!He || He === "<>")
        throw new Error("Error: invalid expandedKnownsMap");
      Qe = Qe.replaceAll(Ee, He);
    }
    return {
      scriptSatisfaction: p.script.fromASM(k({ expandedAsm: Qe, expansionMap: x })),
      nLockTime: Te.nLockTime,
      nSequence: Te.nSequence
    };
  }
  miniscript.satisfyMiniscript = B;
  function Q(P) {
    if (Number.isSafeInteger(P) === !1)
      throw new Error(`Error: invalid number ${P}`);
    return P === 0 ? "OP_0" : p.script.number.encode(P).toString("hex");
  }
  return miniscript.numberEncodeAsm = Q, miniscript;
}
var hasRequiredDescriptors;
function requireDescriptors() {
  if (hasRequiredDescriptors) return descriptors;
  hasRequiredDescriptors = 1;
  var s = descriptors && descriptors.__createBinding || (Object.create ? function(Ee, He, ve, we) {
    we === void 0 && (we = ve);
    var Ce = Object.getOwnPropertyDescriptor(He, ve);
    (!Ce || ("get" in Ce ? !He.__esModule : Ce.writable || Ce.configurable)) && (Ce = { enumerable: !0, get: function() {
      return He[ve];
    } }), Object.defineProperty(Ee, we, Ce);
  } : function(Ee, He, ve, we) {
    we === void 0 && (we = ve), Ee[we] = He[ve];
  }), A = descriptors && descriptors.__setModuleDefault || (Object.create ? function(Ee, He) {
    Object.defineProperty(Ee, "default", { enumerable: !0, value: He });
  } : function(Ee, He) {
    Ee.default = He;
  }), u = descriptors && descriptors.__importStar || function(Ee) {
    if (Ee && Ee.__esModule) return Ee;
    var He = {};
    if (Ee != null) for (var ve in Ee) ve !== "default" && Object.prototype.hasOwnProperty.call(Ee, ve) && s(He, Ee, ve);
    return A(He, Ee), He;
  }, p = descriptors && descriptors.__classPrivateFieldSet || function(Ee, He, ve, we, Ce) {
    if (we === "m") throw new TypeError("Private method is not writable");
    if (we === "a" && !Ce) throw new TypeError("Private accessor was defined without a setter");
    if (typeof He == "function" ? Ee !== He || !Ce : !He.has(Ee)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return we === "a" ? Ce.call(Ee, ve) : Ce ? Ce.value = ve : He.set(Ee, ve), ve;
  }, t = descriptors && descriptors.__classPrivateFieldGet || function(Ee, He, ve, we) {
    if (ve === "a" && !we) throw new TypeError("Private accessor was defined without a getter");
    if (typeof He == "function" ? Ee !== He || !we : !He.has(Ee)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return ve === "m" ? we : ve === "a" ? we.call(Ee) : we ? we.value : He.get(Ee);
  };
  Object.defineProperty(descriptors, "__esModule", { value: !0 }), descriptors.DescriptorsFactory = void 0;
  const l = requireSrc$3(), { p2sh: m, p2wpkh: b, p2pkh: k, p2pk: C, p2wsh: B, p2tr: Q } = l.payments, P = requireSrc$1(), x = requireSrc(), M = requirePsbt$2(), F = requireChecksum(), le = requireKeyExpressions(), ge = u(requireRe()), pe = requireMiniscript(), Ie = 520, be = 3600, Pe = 201;
  function Te(Ee) {
    const He = l.script.decompile(Ee);
    if (!He)
      throw new Error(`Error: cound not decompile ${Ee}`);
    return He.filter((ve) => typeof ve == "number" && ve > l.script.OPS.OP_16).length;
  }
  function Qe({ expression: Ee, checksumRequired: He, index: ve }) {
    const we = Ee.match(String.raw`(${ge.reChecksum})$`);
    if (we === null && He === !0)
      throw new Error(`Error: descriptor ${Ee} has not checksum`);
    let Ce = Ee;
    if (we !== null) {
      const Se = we[0].substring(1);
      if (Ce = Ee.substring(0, Ee.length - we[0].length), Se !== (0, F.DescriptorChecksum)(Ce))
        throw new Error(`Error: invalid descriptor checksum for ${Ee}`);
    }
    if (ve !== void 0) {
      const Se = Ce.match(/\*/g);
      if (Se && Se.length > 0)
        Ce = Ce.replaceAll("*", ve.toString());
      else
        throw new Error(`Error: index passed for non-ranged descriptor: ${Ee}`);
    }
    return Ce;
  }
  function xe(Ee) {
    var He, ve, we, Ce, Se, Ne, rr, er, ir, sr, nr, fr, lr, br;
    const Br = (0, P.BIP32Factory)(Ee), Fr = (0, x.ECPairFactory)(Ee), Gr = (wr, yr, Qr) => Fr.fromPublicKey(wr).verify(yr, Qr), qr = ({ keyExpression: wr, isSegwit: yr, network: Qr = l.networks.bitcoin }) => (0, le.parseKeyExpression)({
      keyExpression: wr,
      network: Qr,
      ...typeof yr == "boolean" ? { isSegwit: yr } : {},
      ECPair: Fr,
      BIP32: Br
    }), Hr = ({ expression: wr, index: yr, checksumRequired: Qr = !1, network: _r = l.networks.bitcoin, allowMiniscriptInP2SH: Jr = !1 }) => {
      var En, Zr, kr, Rr, Er, Or, wn, Kn, Ln, Wn;
      let fn, jr, dn, Tn, Yn, si, vn, Cn;
      const Xr = wr.indexOf("*") !== -1;
      if (yr !== void 0 && (!Number.isInteger(yr) || yr < 0))
        throw new Error(`Error: invalid index ${yr}`);
      const In = Qe({
        expression: wr,
        ...yr !== void 0 ? { index: yr } : {},
        checksumRequired: Qr
      }), zr = In.indexOf("*") !== -1;
      if (In.match(ge.reAddrAnchored)) {
        if (Xr)
          throw new Error("Error: addr() cannot be ranged");
        const Sn = (En = In.match(ge.reAddrAnchored)) == null ? void 0 : En[1];
        if (!Sn)
          throw new Error(`Error: could not get an address in ${wr}`);
        let hi;
        try {
          hi = l.address.toOutputScript(Sn, _r);
        } catch {
          throw new Error(`Error: invalid address ${Sn}`);
        }
        try {
          si = k({ output: hi, network: _r });
        } catch {
        }
        try {
          si = m({ output: hi, network: _r });
        } catch {
        }
        try {
          si = b({ output: hi, network: _r });
        } catch {
        }
        try {
          si = B({ output: hi, network: _r });
        } catch {
        }
        try {
          si = Q({ output: hi, network: _r });
        } catch {
        }
        if (!si)
          throw new Error(`Error: invalid address ${Sn}`);
      } else if (In.match(ge.rePkAnchored)) {
        Tn = !1;
        const Sn = (Zr = In.match(ge.reKeyExp)) == null ? void 0 : Zr[0];
        if (!Sn)
          throw new Error("Error: keyExpression could not me extracted");
        if (In !== `pk(${Sn})`)
          throw new Error(`Error: invalid expression ${wr}`);
        fn = "pk(@0)";
        const hi = qr({ keyExpression: Sn, network: _r, isSegwit: Tn });
        if (dn = { "@0": hi }, !zr) {
          const ki = hi.pubkey;
          if (!ki)
            throw new Error(`Error: could not extract a pubkey from ${wr}`);
          si = C({ pubkey: ki, network: _r });
        }
      } else if (In.match(ge.rePkhAnchored)) {
        Tn = !1;
        const Sn = (kr = In.match(ge.reKeyExp)) == null ? void 0 : kr[0];
        if (!Sn)
          throw new Error("Error: keyExpression could not me extracted");
        if (In !== `pkh(${Sn})`)
          throw new Error(`Error: invalid expression ${wr}`);
        fn = "pkh(@0)";
        const hi = qr({ keyExpression: Sn, network: _r, isSegwit: Tn });
        if (dn = { "@0": hi }, !zr) {
          const ki = hi.pubkey;
          if (!ki)
            throw new Error(`Error: could not extract a pubkey from ${wr}`);
          si = k({ pubkey: ki, network: _r });
        }
      } else if (In.match(ge.reShWpkhAnchored)) {
        Tn = !0;
        const Sn = (Rr = In.match(ge.reKeyExp)) == null ? void 0 : Rr[0];
        if (!Sn)
          throw new Error("Error: keyExpression could not me extracted");
        if (In !== `sh(wpkh(${Sn}))`)
          throw new Error(`Error: invalid expression ${wr}`);
        fn = "sh(wpkh(@0))";
        const hi = qr({ keyExpression: Sn, network: _r, isSegwit: Tn });
        if (dn = { "@0": hi }, !zr) {
          const ki = hi.pubkey;
          if (!ki)
            throw new Error(`Error: could not extract a pubkey from ${wr}`);
          if (si = m({ redeem: b({ pubkey: ki, network: _r }), network: _r }), Cn = (Er = si.redeem) == null ? void 0 : Er.output, !Cn)
            throw new Error(`Error: could not calculate redeemScript for ${wr}`);
        }
      } else if (In.match(ge.reWpkhAnchored)) {
        Tn = !0;
        const Sn = (Or = In.match(ge.reKeyExp)) == null ? void 0 : Or[0];
        if (!Sn)
          throw new Error("Error: keyExpression could not me extracted");
        if (In !== `wpkh(${Sn})`)
          throw new Error(`Error: invalid expression ${wr}`);
        fn = "wpkh(@0)";
        const hi = qr({ keyExpression: Sn, network: _r, isSegwit: Tn });
        if (dn = { "@0": hi }, !zr) {
          const ki = hi.pubkey;
          if (!ki)
            throw new Error(`Error: could not extract a pubkey from ${wr}`);
          si = b({ pubkey: ki, network: _r });
        }
      } else if (In.match(ge.reShWshMiniscriptAnchored)) {
        if (Tn = !0, jr = (wn = In.match(ge.reShWshMiniscriptAnchored)) == null ? void 0 : wn[1], !jr)
          throw new Error(`Error: could not get miniscript in ${wr}`);
        if ({ expandedMiniscript: Yn, expansionMap: dn } = un({
          miniscript: jr,
          isSegwit: Tn,
          network: _r
        }), fn = `sh(wsh(${Yn}))`, !zr) {
          const Sn = (0, pe.miniscript2Script)({ expandedMiniscript: Yn, expansionMap: dn });
          if (vn = Sn, Sn.byteLength > be)
            throw new Error(`Error: script is too large, ${Sn.byteLength} bytes is larger than ${be} bytes`);
          const hi = Te(Sn);
          if (hi > Pe)
            throw new Error(`Error: too many non-push ops, ${hi} non-push ops is larger than ${Pe}`);
          if (si = m({
            redeem: B({ redeem: { output: Sn, network: _r }, network: _r }),
            network: _r
          }), Cn = (Kn = si.redeem) == null ? void 0 : Kn.output, !Cn)
            throw new Error(`Error: could not calculate redeemScript for ${wr}`);
        }
      } else if (In.match(ge.reShMiniscriptAnchored)) {
        if (Tn = !1, jr = (Ln = In.match(ge.reShMiniscriptAnchored)) == null ? void 0 : Ln[1], !jr)
          throw new Error(`Error: could not get miniscript in ${wr}`);
        if (Jr === !1 && //These top-level expressions within sh are allowed within sh.
        //They can be parsed with miniscript2Script, but first we must make sure
        //that other expressions are not accepted (unless forced with allowMiniscriptInP2SH).
        jr.search(/^(pk\(|pkh\(|wpkh\(|combo\(|multi\(|sortedmulti\(|multi_a\(|sortedmulti_a\()/) !== 0)
          throw new Error("Error: Miniscript expressions can only be used in wsh");
        if ({ expandedMiniscript: Yn, expansionMap: dn } = un({
          miniscript: jr,
          isSegwit: Tn,
          network: _r
        }), fn = `sh(${Yn})`, !zr) {
          const Sn = (0, pe.miniscript2Script)({ expandedMiniscript: Yn, expansionMap: dn });
          if (Cn = Sn, Sn.byteLength > Ie)
            throw new Error(`Error: P2SH script is too large, ${Sn.byteLength} bytes is larger than ${Ie} bytes`);
          const hi = Te(Sn);
          if (hi > Pe)
            throw new Error(`Error: too many non-push ops, ${hi} non-push ops is larger than ${Pe}`);
          si = m({ redeem: { output: Sn, network: _r }, network: _r });
        }
      } else if (In.match(ge.reWshMiniscriptAnchored)) {
        if (Tn = !0, jr = (Wn = In.match(ge.reWshMiniscriptAnchored)) == null ? void 0 : Wn[1], !jr)
          throw new Error(`Error: could not get miniscript in ${wr}`);
        if ({ expandedMiniscript: Yn, expansionMap: dn } = un({
          miniscript: jr,
          isSegwit: Tn,
          network: _r
        }), fn = `wsh(${Yn})`, !zr) {
          const Sn = (0, pe.miniscript2Script)({ expandedMiniscript: Yn, expansionMap: dn });
          if (vn = Sn, Sn.byteLength > be)
            throw new Error(`Error: script is too large, ${Sn.byteLength} bytes is larger than ${be} bytes`);
          const hi = Te(Sn);
          if (hi > Pe)
            throw new Error(`Error: too many non-push ops, ${hi} non-push ops is larger than ${Pe}`);
          si = B({ redeem: { output: Sn, network: _r }, network: _r });
        }
      } else
        throw new Error(`Error: Could not parse descriptor ${wr}`);
      return {
        ...si !== void 0 ? { payment: si } : {},
        ...fn !== void 0 ? { expandedExpression: fn } : {},
        ...jr !== void 0 ? { miniscript: jr } : {},
        ...dn !== void 0 ? { expansionMap: dn } : {},
        ...Tn !== void 0 ? { isSegwit: Tn } : {},
        ...Yn !== void 0 ? { expandedMiniscript: Yn } : {},
        ...Cn !== void 0 ? { redeemScript: Cn } : {},
        ...vn !== void 0 ? { witnessScript: vn } : {},
        isRanged: Xr,
        canonicalExpression: In
      };
    };
    function un({ miniscript: wr, isSegwit: yr, network: Qr = l.networks.bitcoin }) {
      return (0, pe.expandMiniscript)({
        miniscript: wr,
        isSegwit: yr,
        network: Qr,
        BIP32: Br,
        ECPair: Fr
      });
    }
    class Dr {
      /**
       * @param options
       * @throws {Error} - when descriptor is invalid
       */
      constructor({ expression: yr, index: Qr, checksumRequired: _r = !1, allowMiniscriptInP2SH: Jr = !1, network: fn = l.networks.bitcoin, preimages: jr = [], signersPubKeys: dn }) {
        if (He.add(this), ve.set(this, void 0), we.set(this, []), Ce.set(this, void 0), Se.set(this, void 0), Ne.set(this, void 0), rr.set(this, void 0), er.set(this, void 0), ir.set(this, void 0), sr.set(this, void 0), nr.set(this, void 0), fr.set(this, void 0), p(this, fr, fn, "f"), p(this, we, jr, "f"), typeof yr != "string")
          throw new Error("Error: invalid descriptor type");
        const Tn = Hr({
          expression: yr,
          ...Qr !== void 0 ? { index: Qr } : {},
          checksumRequired: _r,
          network: fn,
          allowMiniscriptInP2SH: Jr
        });
        if (Tn.isRanged && Qr === void 0)
          throw new Error("Error: index was not provided for ranged descriptor");
        if (!Tn.payment)
          throw new Error(`Error: could not extract a payment from ${yr}`);
        if (p(this, ve, Tn.payment, "f"), Tn.expandedExpression !== void 0 && p(this, ir, Tn.expandedExpression, "f"), Tn.miniscript !== void 0 && p(this, Se, Tn.miniscript, "f"), Tn.expansionMap !== void 0 && p(this, nr, Tn.expansionMap, "f"), Tn.isSegwit !== void 0 && p(this, er, Tn.isSegwit, "f"), Tn.expandedMiniscript !== void 0 && p(this, sr, Tn.expandedMiniscript, "f"), Tn.redeemScript !== void 0 && p(this, rr, Tn.redeemScript, "f"), Tn.witnessScript !== void 0 && p(this, Ne, Tn.witnessScript, "f"), dn)
          p(this, Ce, dn, "f");
        else if (t(this, nr, "f"))
          p(this, Ce, Object.values(t(this, nr, "f")).map((Yn) => {
            const si = Yn.pubkey;
            if (!si)
              throw new Error(`Error: could not extract a pubkey from ${yr}`);
            return si;
          }), "f");
        else {
          if (!Tn.canonicalExpression.match(ge.reAddrAnchored))
            throw new Error(`Error: expansionMap not available for expression ${yr} that is not an address`);
          p(this, Ce, [this.getScriptPubKey()], "f");
        }
      }
      getPayment() {
        return t(this, ve, "f");
      }
      /**
       * Returns the Bitcoin Address
       */
      getAddress() {
        if (!t(this, ve, "f").address)
          throw new Error("Error: could extract an address from the payment");
        return t(this, ve, "f").address;
      }
      getScriptPubKey() {
        if (!t(this, ve, "f").output)
          throw new Error("Error: could extract output.script from the payment");
        return t(this, ve, "f").output;
      }
      /**
       * Returns the compiled script satisfaction
       * @param {PartialSig[]} signatures An array of signatures using this format: `interface PartialSig { pubkey: Buffer; signature: Buffer; }`
       * @returns {Buffer}
       */
      getScriptSatisfaction(yr) {
        const Qr = t(this, Se, "f"), _r = t(this, sr, "f"), Jr = t(this, nr, "f");
        if (Qr === void 0 || _r === void 0 || Jr === void 0)
          throw new Error(`Error: cannot get satisfaction from not expanded miniscript ${Qr}`);
        const fn = (0, pe.satisfyMiniscript)({
          expandedMiniscript: _r,
          expansionMap: Jr,
          signatures: yr,
          preimages: t(this, we, "f"),
          //Here we pass the TimeConstraints obtained using signersPubKeys to
          //verify that the solutions found using the final signatures have not
          //changed
          timeConstraints: {
            nLockTime: this.getLockTime(),
            nSequence: this.getSequence()
          }
        }).scriptSatisfaction;
        if (!fn)
          throw new Error("Error: could not produce a valid satisfaction");
        return fn;
      }
      getSequence() {
        var yr;
        return (yr = t(this, He, "m", lr).call(this)) == null ? void 0 : yr.nSequence;
      }
      getLockTime() {
        var yr;
        return (yr = t(this, He, "m", lr).call(this)) == null ? void 0 : yr.nLockTime;
      }
      getWitnessScript() {
        return t(this, Ne, "f");
      }
      getRedeemScript() {
        return t(this, rr, "f");
      }
      getNetwork() {
        return t(this, fr, "f");
      }
      isSegwit() {
        return t(this, er, "f");
      }
      /**
       * Updates a Psbt where the descriptor describes an utxo.
       * The txHex (nonWitnessUtxo) and vout of the utxo must be passed.
       *
       * updatePsbt adds an input to the psbt and updates the tx locktime if needed.
       * It also adds a new input to the Psbt based on txHex
       * It returns the number of the input that is added.
       * psbt and vout are mandatory. Also pass txHex.
       *
       * The following is not recommended but, alternatively, ONLY for Segwit inputs,
       * you can pass txId and value, instead of txHex.
       * If you do so, it is your responsibility to make sure that `value` is
       * correct to avoid possible fee vulnerability attacks:
       * https://github.com/bitcoinjs/bitcoinjs-lib/issues/1625
       * Note that HW wallets require the full txHex also for Segwit anyways:
       * https://blog.trezor.io/details-of-firmware-updates-for-trezor-one-version-1-9-1-and-trezor-model-t-version-2-3-1-1eba8f60f2dd
       *
       * In doubt, simply pass txHex (and you can skip passing txId and value) and
       * you shall be fine.
       */
      updatePsbt({
        psbt: yr,
        txHex: Qr,
        txId: _r,
        value: Jr,
        vout: fn
        //vector output index
      }) {
        Qr === void 0 && console.warn("Warning: missing txHex may allow fee attacks");
        const jr = this.isSegwit();
        if (jr === void 0)
          throw new Error("Error: could not determine whether this is a segwit descriptor");
        return (0, M.updatePsbt)({
          psbt: yr,
          vout: fn,
          ...Qr !== void 0 ? { txHex: Qr } : {},
          ..._r !== void 0 ? { txId: _r } : {},
          ...Jr !== void 0 ? { value: Jr } : {},
          sequence: this.getSequence(),
          locktime: this.getLockTime(),
          keysInfo: t(this, nr, "f") ? Object.values(t(this, nr, "f")) : [],
          scriptPubKey: this.getScriptPubKey(),
          isSegwit: jr,
          witnessScript: this.getWitnessScript(),
          redeemScript: this.getRedeemScript()
        });
      }
      finalizePsbtInput({ index: yr, psbt: Qr, validate: _r = !0 }) {
        var fn;
        if (_r && !Qr.validateSignaturesOfInput(yr, Gr))
          throw new Error(`Error: invalid signatures on input ${yr}`);
        const Jr = (fn = Qr.data.inputs[yr]) == null ? void 0 : fn.partialSig;
        if (!Jr)
          throw new Error("Error: cannot finalize without signatures");
        if (t(this, He, "m", br).call(this, { index: yr, psbt: Qr }), !t(this, Se, "f"))
          Qr.finalizeInput(yr);
        else {
          const jr = this.getScriptSatisfaction(Jr);
          Qr.finalizeInput(yr, (0, M.finalScriptsFuncFactory)(jr, t(this, fr, "f")));
        }
      }
      expand() {
        return {
          ...t(this, ir, "f") !== void 0 ? { expandedExpression: t(this, ir, "f") } : {},
          ...t(this, Se, "f") !== void 0 ? { miniscript: t(this, Se, "f") } : {},
          ...t(this, sr, "f") !== void 0 ? { expandedMiniscript: t(this, sr, "f") } : {},
          ...t(this, nr, "f") !== void 0 ? { expansionMap: t(this, nr, "f") } : {}
        };
      }
    }
    return ve = /* @__PURE__ */ new WeakMap(), we = /* @__PURE__ */ new WeakMap(), Ce = /* @__PURE__ */ new WeakMap(), Se = /* @__PURE__ */ new WeakMap(), Ne = /* @__PURE__ */ new WeakMap(), rr = /* @__PURE__ */ new WeakMap(), er = /* @__PURE__ */ new WeakMap(), ir = /* @__PURE__ */ new WeakMap(), sr = /* @__PURE__ */ new WeakMap(), nr = /* @__PURE__ */ new WeakMap(), fr = /* @__PURE__ */ new WeakMap(), He = /* @__PURE__ */ new WeakSet(), lr = function() {
      const yr = t(this, Se, "f"), Qr = t(this, we, "f"), _r = t(this, sr, "f"), Jr = t(this, nr, "f"), fn = t(this, Ce, "f");
      if (yr) {
        if (_r === void 0 || Jr === void 0)
          throw new Error(`Error: cannot get time constraints from not expanded miniscript ${yr}`);
        const jr = fn.map((Yn) => ({
          pubkey: Yn,
          signature: Buffer.alloc(64, 0)
        })), { nLockTime: dn, nSequence: Tn } = (0, pe.satisfyMiniscript)({
          expandedMiniscript: _r,
          expansionMap: Jr,
          signatures: jr,
          preimages: Qr
        });
        return { nLockTime: dn, nSequence: Tn };
      } else
        return;
    }, br = function({ psbt: yr, index: Qr }) {
      const _r = yr.data.inputs[Qr], Jr = yr.txInputs[Qr];
      if (!_r || !Jr)
        throw new Error("Error: invalid input or txInput");
      const { sequence: fn, index: jr } = Jr;
      let dn;
      if (_r.witnessUtxo)
        dn = _r.witnessUtxo.script;
      else {
        if (!_r.nonWitnessUtxo)
          throw new Error("Error: input should have either witnessUtxo or nonWitnessUtxo");
        const vn = l.Transaction.fromBuffer(_r.nonWitnessUtxo).outs[jr];
        if (!vn)
          throw new Error("Error: utxo should exist");
        dn = vn.script;
      }
      const Tn = this.getLockTime() || 0;
      let Yn = this.getSequence();
      if (Yn === void 0 && Tn !== 0 && (Yn = 4294967294), Yn === void 0 && Tn === 0 && (Yn = 4294967295), Buffer.compare(dn, this.getScriptPubKey()) !== 0 || Yn !== fn || Tn !== yr.locktime || this.getWitnessScript() !== _r.witnessScript || this.getRedeemScript() !== _r.redeemScript)
        throw new Error(`Error: cannot finalize psbt index ${Qr} since it does not correspond to this descriptor`);
    }, { Descriptor: Dr, parseKeyExpression: qr, expand: Hr, ECPair: Fr, BIP32: Br };
  }
  return descriptors.DescriptorsFactory = xe, descriptors;
}
var signers = {}, hasRequiredSigners;
function requireSigners() {
  if (hasRequiredSigners) return signers;
  hasRequiredSigners = 1, Object.defineProperty(signers, "__esModule", { value: !0 }), signers.signLedger = signers.signInputLedger = signers.signBIP32 = signers.signInputBIP32 = signers.signECPair = signers.signInputECPair = void 0;
  const s = requireLedger();
  function A({ psbt: k, index: C, ecpair: B }) {
    k.signInput(C, B);
  }
  signers.signInputECPair = A;
  function u({ psbt: k, ecpair: C }) {
    k.signAllInputs(C);
  }
  signers.signECPair = u;
  function p({ psbt: k, index: C, node: B }) {
    k.signInputHD(C, B);
  }
  signers.signInputBIP32 = p;
  function t({ psbt: k, masterNode: C }) {
    k.signAllInputsHD(C);
  }
  signers.signBIP32 = t;
  const l = (k, C) => C.filter(([B]) => B === k).map(([B, Q]) => ({
    pubkey: Q.pubkey,
    signature: Q.signature
  }));
  async function m({ psbt: k, index: C, descriptor: B, ledgerClient: Q, ledgerState: P }) {
    const { PsbtV2: x, DefaultWalletPolicy: M, WalletPolicy: F, AppClient: le } = await (0, s.importAndValidateLedgerBitcoin)(Q);
    if (!(Q instanceof le))
      throw new Error("Error: pass a valid ledgerClient");
    const ge = await (0, s.descriptorToLedgerFormat)({
      descriptor: B,
      ledgerClient: Q,
      ledgerState: P
    });
    if (!ge)
      throw new Error("Error: descriptor does not have a ledger input");
    const { ledgerTemplate: pe, keyRoots: Ie } = ge;
    let be;
    if (await (0, s.ledgerPolicyFromStandard)({
      descriptor: B,
      ledgerClient: Q,
      ledgerState: P
    }))
      be = await Q.signPsbt(new x().fromBitcoinJS(k), new M(pe, Ie[0]), null);
    else {
      const Te = await (0, s.ledgerPolicyFromState)({
        descriptor: B,
        ledgerClient: Q,
        ledgerState: P
      });
      if (!Te || !Te.policyName || !Te.policyHmac)
        throw new Error("Error: the descriptor's policy is not registered");
      const Qe = new F(Te.policyName, pe, Ie);
      be = await Q.signPsbt(new x().fromBitcoinJS(k), Qe, Te.policyHmac);
    }
    k.updateInput(C, {
      partialSig: l(C, be)
    });
  }
  signers.signInputLedger = m;
  async function b({ psbt: k, descriptors: C, ledgerClient: B, ledgerState: Q }) {
    const { PsbtV2: P, DefaultWalletPolicy: x, WalletPolicy: M, AppClient: F } = await (0, s.importAndValidateLedgerBitcoin)(B);
    if (!(B instanceof F))
      throw new Error("Error: pass a valid ledgerClient");
    const le = [];
    for (const pe of C) {
      const Ie = await (0, s.ledgerPolicyFromState)({
        descriptor: pe,
        ledgerClient: B,
        ledgerState: Q
      }) || await (0, s.ledgerPolicyFromStandard)({
        descriptor: pe,
        ledgerClient: B,
        ledgerState: Q
      });
      Ie && le.push(Ie);
    }
    if (le.length === 0)
      throw new Error("Error: there are no inputs which could be signed");
    const ge = [];
    for (const pe of le)
      ge.find((Ie) => (0, s.comparePolicies)(Ie, pe)) || ge.push(pe);
    for (const pe of ge) {
      let Ie;
      if (pe.policyName && pe.policyHmac && pe.policyId) {
        const be = new M(pe.policyName, pe.ledgerTemplate, pe.keyRoots);
        Ie = await B.signPsbt(new P().fromBitcoinJS(k), be, pe.policyHmac);
      } else
        Ie = await B.signPsbt(new P().fromBitcoinJS(k), new x(pe.ledgerTemplate, pe.keyRoots[0]), null);
      for (const [be, ,] of Ie)
        k.updateInput(be, {
          partialSig: l(be, Ie)
        });
    }
  }
  return signers.signLedger = b, signers;
}
var scriptExpressions = {}, hasRequiredScriptExpressions;
function requireScriptExpressions() {
  if (hasRequiredScriptExpressions) return scriptExpressions;
  hasRequiredScriptExpressions = 1, Object.defineProperty(scriptExpressions, "__esModule", { value: !0 }), scriptExpressions.wpkhLedger = scriptExpressions.shWpkhLedger = scriptExpressions.pkhLedger = scriptExpressions.wpkhBIP32 = scriptExpressions.shWpkhBIP32 = scriptExpressions.pkhBIP32 = void 0;
  const s = requireSrc$3(), A = requireKeyExpressions();
  function u(l) {
    if (!/^\/[01]\/(\d+|\*)$/.test(l))
      throw new Error("Error: Key path must be in the format '/change/index', where change is either 0 or 1 and index is a non-negative integer.");
  }
  function p(l, m) {
    function b({ masterNode: k, network: C = s.networks.bitcoin, keyPath: B, account: Q, change: P, index: x, isPublic: M = !0 }) {
      const F = `/${l}'/${C === s.networks.bitcoin ? 0 : 1}'/${Q}'`;
      B !== void 0 && u(B);
      const le = (0, A.keyExpressionBIP32)({
        masterNode: k,
        originPath: F,
        keyPath: B,
        change: P,
        index: x,
        isPublic: M
      });
      return m.replace("KEYEXPRESSION", le);
    }
    return b;
  }
  scriptExpressions.pkhBIP32 = p(44, "pkh(KEYEXPRESSION)"), scriptExpressions.shWpkhBIP32 = p(49, "sh(wpkh(KEYEXPRESSION))"), scriptExpressions.wpkhBIP32 = p(84, "wpkh(KEYEXPRESSION)");
  function t(l, m) {
    async function b({ ledgerClient: k, ledgerState: C, network: B = s.networks.bitcoin, account: Q, keyPath: P, change: x, index: M }) {
      const F = `/${l}'/${B === s.networks.bitcoin ? 0 : 1}'/${Q}'`;
      P !== void 0 && u(P);
      const le = await (0, A.keyExpressionLedger)({
        ledgerClient: k,
        ledgerState: C,
        originPath: F,
        keyPath: P,
        change: x,
        index: M
      });
      return m.replace("KEYEXPRESSION", le);
    }
    return b;
  }
  return scriptExpressions.pkhLedger = t(44, "pkh(KEYEXPRESSION)"), scriptExpressions.shWpkhLedger = t(49, "sh(wpkh(KEYEXPRESSION))"), scriptExpressions.wpkhLedger = t(84, "wpkh(KEYEXPRESSION)"), scriptExpressions;
}
var hasRequiredDist;
function requireDist() {
  return hasRequiredDist || (hasRequiredDist = 1, function(s) {
    var A = dist$1 && dist$1.__createBinding || (Object.create ? function(Q, P, x, M) {
      M === void 0 && (M = x);
      var F = Object.getOwnPropertyDescriptor(P, x);
      (!F || ("get" in F ? !P.__esModule : F.writable || F.configurable)) && (F = { enumerable: !0, get: function() {
        return P[x];
      } }), Object.defineProperty(Q, M, F);
    } : function(Q, P, x, M) {
      M === void 0 && (M = x), Q[M] = P[x];
    }), u = dist$1 && dist$1.__setModuleDefault || (Object.create ? function(Q, P) {
      Object.defineProperty(Q, "default", { enumerable: !0, value: P });
    } : function(Q, P) {
      Q.default = P;
    }), p = dist$1 && dist$1.__importStar || function(Q) {
      if (Q && Q.__esModule) return Q;
      var P = {};
      if (Q != null) for (var x in Q) x !== "default" && Object.prototype.hasOwnProperty.call(Q, x) && A(P, Q, x);
      return u(P, Q), P;
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), s.ledger = s.scriptExpressions = s.keyExpressionLedger = s.keyExpressionBIP32 = s.finalizePsbt = s.signers = s.checksum = s.DescriptorsFactory = void 0;
    var t = requireDescriptors();
    Object.defineProperty(s, "DescriptorsFactory", { enumerable: !0, get: function() {
      return t.DescriptorsFactory;
    } });
    var l = requireChecksum();
    Object.defineProperty(s, "checksum", { enumerable: !0, get: function() {
      return l.DescriptorChecksum;
    } });
    const m = p(requireSigners());
    s.signers = m;
    function b({ psbt: Q, descriptors: P, validate: x = !0 }) {
      P.forEach((M, F) => M.finalizePsbtInput({ index: F, psbt: Q, validate: x }));
    }
    s.finalizePsbt = b;
    var k = requireKeyExpressions();
    Object.defineProperty(s, "keyExpressionBIP32", { enumerable: !0, get: function() {
      return k.keyExpressionBIP32;
    } }), Object.defineProperty(s, "keyExpressionLedger", { enumerable: !0, get: function() {
      return k.keyExpressionLedger;
    } });
    const C = p(requireScriptExpressions());
    s.scriptExpressions = C;
    const B = requireLedger();
    s.ledger = {
      getLedgerMasterFingerPrint: B.getLedgerMasterFingerPrint,
      getLedgerXpub: B.getLedgerXpub,
      registerLedgerWallet: B.registerLedgerWallet,
      assertLedgerApp: B.assertLedgerApp
    };
  }(dist$1)), dist$1;
}
var bip32$1 = {}, hasRequiredBip32$1;
function requireBip32$1() {
  if (hasRequiredBip32$1) return bip32$1;
  hasRequiredBip32$1 = 1;
  var s = bip32$1 && bip32$1.__importDefault || function(B) {
    return B && B.__esModule ? B : { default: B };
  };
  Object.defineProperty(bip32$1, "__esModule", { value: !0 }), bip32$1.hardenedPathOf = bip32$1.getXpubComponents = bip32$1.pubkeyFromXpub = bip32$1.pathStringToArray = bip32$1.pathArrayToString = bip32$1.bip32asBuffer = bip32$1.pathElementsToBuffer = void 0;
  const A = s(requireBip32Path()), u = s(requireBs58check$1());
  function p(B) {
    const Q = Buffer.alloc(1 + B.length * 4);
    return Q[0] = B.length, B.forEach((P, x) => {
      Q.writeUInt32BE(P, 1 + 4 * x);
    }), Q;
  }
  bip32$1.pathElementsToBuffer = p;
  function t(B) {
    const Q = B ? m(B) : [];
    return p(Q);
  }
  bip32$1.bip32asBuffer = t;
  function l(B) {
    return B.length == 0 ? "m" : A.default.fromPathArray(B).toString();
  }
  bip32$1.pathArrayToString = l;
  function m(B) {
    return B == "m" || B == "" ? [] : A.default.fromString(B).toPathArray();
  }
  bip32$1.pathStringToArray = m;
  function b(B) {
    const Q = Buffer.from(u.default.decode(B));
    return Q.slice(Q.length - 33);
  }
  bip32$1.pubkeyFromXpub = b;
  function k(B) {
    const Q = Buffer.from(u.default.decode(B));
    return {
      chaincode: Q.slice(13, 45),
      pubkey: Q.slice(Q.length - 33),
      version: Q.readUInt32BE(0)
    };
  }
  bip32$1.getXpubComponents = k;
  function C(B) {
    for (let Q = B.length - 1; Q >= 0; Q--)
      if (B[Q] >= 2147483648)
        return B.slice(0, Q + 1);
    return [];
  }
  return bip32$1.hardenedPathOf = C, bip32$1;
}
var clientCommands$1 = {}, buffertools$1 = {}, varint$1 = {}, hasRequiredVarint$1;
function requireVarint$1() {
  if (hasRequiredVarint$1) return varint$1;
  hasRequiredVarint$1 = 1, Object.defineProperty(varint$1, "__esModule", { value: !0 }), varint$1.createVarint = varint$1.parseVarint = varint$1.sanitizeBigintToNumber = void 0;
  function s(m, b, k, C) {
    for (let B = 0; B < b; B++) {
      if (k[B + C] == null)
        throw Error("Buffer too small");
      k[B + C] = Number(m % BigInt(256)), m = m >> BigInt(8);
    }
  }
  function A(m, b, k) {
    let C = BigInt(0);
    for (let B = 0; B < k; B++) {
      if (m[B + b] == null)
        throw Error("Buffer too small");
      C += BigInt(m[B + b]) << BigInt(B * 8);
    }
    return C;
  }
  function u(m) {
    if (m < 0)
      throw RangeError("Negative bigint is not a valid varint");
    if (m > Number.MAX_SAFE_INTEGER)
      throw RangeError("Too large for a Number");
    return Number(m);
  }
  varint$1.sanitizeBigintToNumber = u;
  function p(m) {
    if (typeof m == "number" && (m = u(m)), m < BigInt(0))
      throw new RangeError("Negative numbers are not supported");
    if (m >= BigInt(1) << BigInt(64))
      throw new RangeError("Too large for a Bitcoin-style varint");
    return m < BigInt(253) ? 1 : m <= BigInt(65535) ? 3 : m <= BigInt(4294967295) ? 5 : 9;
  }
  function t(m, b) {
    if (b < 0)
      throw RangeError("Negative offset is invalid");
    if (m[b] == null)
      throw Error("Buffer too small");
    if (m[b] < 253)
      return [BigInt(m[b]), 1];
    {
      let k;
      return m[b] === 253 ? k = 2 : m[b] === 254 ? k = 4 : k = 8, [A(m, b + 1, k), k + 1];
    }
  }
  varint$1.parseVarint = t;
  function l(m) {
    typeof m == "number" && (m = u(m));
    const b = p(m);
    m = BigInt(m);
    const k = Buffer.alloc(b);
    return b == 1 ? k[0] = Number(m) : (b == 3 ? k[0] = 253 : b === 5 ? k[0] = 254 : k[0] = 255, s(m, b - 1, k, 1)), k;
  }
  return varint$1.createVarint = l, varint$1;
}
var hasRequiredBuffertools$1;
function requireBuffertools$1() {
  if (hasRequiredBuffertools$1) return buffertools$1;
  hasRequiredBuffertools$1 = 1, Object.defineProperty(buffertools$1, "__esModule", { value: !0 }), buffertools$1.BufferReader = buffertools$1.BufferWriter = buffertools$1.numberToLE = buffertools$1.unsafeFrom64bitLE = buffertools$1.unsafeTo64bitLE = void 0;
  const s = requireVarint$1();
  function A(m) {
    if (m > Number.MAX_SAFE_INTEGER)
      throw new Error("Can't convert numbers > MAX_SAFE_INT");
    const b = Buffer.alloc(8, 0);
    for (let k = 0; k < b.length; k++) {
      const C = m & 255;
      b[k] = C, m = (m - C) / 256;
    }
    return b;
  }
  buffertools$1.unsafeTo64bitLE = A;
  function u(m) {
    let b = 0;
    if (m.length != 8)
      throw new Error("Expected Bufffer of lenght 8");
    if (m[7] != 0)
      throw new Error("Can't encode numbers > MAX_SAFE_INT");
    if (m[6] > 31)
      throw new Error("Can't encode numbers > MAX_SAFE_INT");
    for (let k = m.length - 1; k >= 0; k--)
      b = b * 256 + m[k];
    return b;
  }
  buffertools$1.unsafeFrom64bitLE = u;
  function p(m, b = 32) {
    if (!Number.isInteger(m) || m < 0)
      throw new RangeError("value must be a non-negative integer");
    if (!Number.isInteger(b) || b < 1)
      throw new RangeError("byteLen must be a positive integer");
    const k = Math.pow(256, b);
    if (m >= k)
      throw new RangeError(`value too large to fit in ${b} bytes (max ${k - 1})`);
    const C = Buffer.alloc(b);
    let B = m;
    for (let Q = 0; Q < b; Q++)
      C[Q] = B % 256, B = Math.floor(B / 256);
    return C;
  }
  buffertools$1.numberToLE = p;
  class t {
    constructor() {
      this.bufs = [];
    }
    write(b, k) {
      const C = Buffer.alloc(b);
      k(C), this.bufs.push(C);
    }
    writeUInt8(b) {
      this.write(1, (k) => k.writeUInt8(b, 0));
    }
    writeInt32(b) {
      this.write(4, (k) => k.writeInt32LE(b, 0));
    }
    writeUInt32(b) {
      this.write(4, (k) => k.writeUInt32LE(b, 0));
    }
    writeUInt64(b) {
      const k = A(b);
      this.writeSlice(k);
    }
    writeVarInt(b) {
      this.bufs.push((0, s.createVarint)(b));
    }
    writeSlice(b) {
      this.bufs.push(Buffer.from(b));
    }
    writeVarSlice(b) {
      this.writeVarInt(b.length), this.writeSlice(b);
    }
    buffer() {
      return Buffer.concat(this.bufs);
    }
  }
  buffertools$1.BufferWriter = t;
  class l {
    constructor(b, k = 0) {
      this.buffer = b, this.offset = k;
    }
    available() {
      return this.buffer.length - this.offset;
    }
    readUInt8() {
      const b = this.buffer.readUInt8(this.offset);
      return this.offset++, b;
    }
    readInt32() {
      const b = this.buffer.readInt32LE(this.offset);
      return this.offset += 4, b;
    }
    readUInt32() {
      const b = this.buffer.readUInt32LE(this.offset);
      return this.offset += 4, b;
    }
    readUInt64() {
      const b = this.readSlice(8);
      return u(b);
    }
    readVarInt() {
      const [b, k] = (0, s.parseVarint)(this.buffer, this.offset);
      return this.offset += k, b;
    }
    readSlice(b) {
      if (this.buffer.length < this.offset + b)
        throw new Error("Cannot read slice out of bounds");
      const k = this.buffer.slice(this.offset, this.offset + b);
      return this.offset += b, k;
    }
    readVarSlice() {
      const b = (0, s.sanitizeBigintToNumber)(this.readVarInt());
      return this.readSlice(b);
    }
    readVector() {
      const b = this.readVarInt(), k = [];
      for (let C = 0; C < b; C++)
        k.push(this.readVarSlice());
      return k;
    }
  }
  return buffertools$1.BufferReader = l, buffertools$1;
}
var merkle$1 = {}, hasRequiredMerkle$1;
function requireMerkle$1() {
  if (hasRequiredMerkle$1) return merkle$1;
  hasRequiredMerkle$1 = 1, Object.defineProperty(merkle$1, "__esModule", { value: !0 }), merkle$1.hashLeaf = merkle$1.Merkle = void 0;
  const s = requireSrc$3();
  class A {
    constructor(C, B = s.crypto.sha256) {
      this.leaves = C, this.h = B;
      const Q = this.calculateRoot(C);
      this.rootNode = Q.root, this.leafNodes = Q.leaves;
    }
    getRoot() {
      return this.rootNode.hash;
    }
    size() {
      return this.leaves.length;
    }
    getLeaves() {
      return this.leaves;
    }
    getLeafHash(C) {
      return this.leafNodes[C].hash;
    }
    getProof(C) {
      if (C >= this.leaves.length)
        throw Error("Index out of bounds");
      return l(this.leafNodes[C]);
    }
    calculateRoot(C) {
      const B = C.length;
      if (B == 0)
        return {
          root: new t(void 0, void 0, Buffer.alloc(32, 0)),
          leaves: []
        };
      if (B == 1) {
        const pe = new t(void 0, void 0, C[0]);
        return { root: pe, leaves: [pe] };
      }
      const Q = m(B), P = this.calculateRoot(C.slice(0, Q)), x = this.calculateRoot(C.slice(Q)), M = P.root, F = x.root, le = this.hashNode(M.hash, F.hash), ge = new t(M, F, le);
      return M.parent = ge, F.parent = ge, { root: ge, leaves: P.leaves.concat(x.leaves) };
    }
    hashNode(C, B) {
      return this.h(Buffer.concat([Buffer.from([1]), C, B]));
    }
  }
  merkle$1.Merkle = A;
  function u(k, C = s.crypto.sha256) {
    return p(Buffer.from([0]), k, C);
  }
  merkle$1.hashLeaf = u;
  function p(k, C, B) {
    return B(Buffer.concat([k, C]));
  }
  class t {
    constructor(C, B, Q) {
      this.leftChild = C, this.rightChild = B, this.hash = Q;
    }
    isLeaf() {
      return this.leftChild == null;
    }
  }
  function l(k) {
    if (!k.parent)
      return [];
    if (k.parent.leftChild == k) {
      if (!k.parent.rightChild)
        throw new Error("Expected right child to exist");
      return [k.parent.rightChild.hash, ...l(k.parent)];
    } else {
      if (!k.parent.leftChild)
        throw new Error("Expected left child to exist");
      return [k.parent.leftChild.hash, ...l(k.parent)];
    }
  }
  function m(k) {
    if (k < 2)
      throw Error("Expected n >= 2");
    return b(k) ? k / 2 : 1 << Math.floor(Math.log2(k));
  }
  function b(k) {
    return (k & k - 1) == 0;
  }
  return merkle$1;
}
var hasRequiredClientCommands$1;
function requireClientCommands$1() {
  if (hasRequiredClientCommands$1) return clientCommands$1;
  hasRequiredClientCommands$1 = 1, Object.defineProperty(clientCommands$1, "__esModule", { value: !0 }), clientCommands$1.ClientCommandInterpreter = clientCommands$1.GetMoreElementsCommand = clientCommands$1.GetMerkleLeafIndexCommand = clientCommands$1.GetMerkleLeafProofCommand = clientCommands$1.GetPreimageCommand = clientCommands$1.YieldCommand = void 0;
  const s = requireSrc$3(), A = requireBuffertools$1(), u = requireMerkle$1(), p = requireVarint$1();
  var t;
  (function(P) {
    P[P.YIELD = 16] = "YIELD", P[P.GET_PREIMAGE = 64] = "GET_PREIMAGE", P[P.GET_MERKLE_LEAF_PROOF = 65] = "GET_MERKLE_LEAF_PROOF", P[P.GET_MERKLE_LEAF_INDEX = 66] = "GET_MERKLE_LEAF_INDEX", P[P.GET_MORE_ELEMENTS = 160] = "GET_MORE_ELEMENTS";
  })(t || (t = {}));
  class l {
  }
  class m extends l {
    constructor(x, M) {
      super(), this.progressCallback = M, this.code = t.YIELD, this.results = x;
    }
    execute(x) {
      return this.results.push(Buffer.from(x.subarray(1))), this.progressCallback && this.progressCallback(), Buffer.from("");
    }
  }
  clientCommands$1.YieldCommand = m;
  class b extends l {
    constructor(x, M) {
      super(), this.code = t.GET_PREIMAGE, this.known_preimages = x, this.queue = M;
    }
    execute(x) {
      const M = Buffer.from(x.subarray(1));
      if (M.length != 33)
        throw new Error("Invalid request, unexpected trailing data");
      if (M[0] != 0)
        throw new Error("Unsupported request, the first byte should be 0");
      const F = Buffer.alloc(32);
      for (let pe = 0; pe < 32; pe++)
        F[pe] = M[1 + pe];
      const le = F.toString("hex"), ge = this.known_preimages.get(le);
      if (ge != null) {
        const pe = (0, p.createVarint)(ge.length), Ie = 255 - pe.length - 1, be = Math.min(Ie, ge.length);
        if (be < ge.length)
          for (let Pe = be; Pe < ge.length; Pe++)
            this.queue.push(Buffer.from([ge[Pe]]));
        return Buffer.concat([
          pe,
          Buffer.from([be]),
          Buffer.from(ge.subarray(0, be))
        ]);
      }
      throw Error(`Requested unknown preimage for: ${le}`);
    }
  }
  clientCommands$1.GetPreimageCommand = b;
  class k extends l {
    constructor(x, M) {
      super(), this.code = t.GET_MERKLE_LEAF_PROOF, this.known_trees = x, this.queue = M;
    }
    execute(x) {
      const M = Buffer.from(x.subarray(1));
      if (M.length < 34)
        throw new Error("Invalid request, expected at least 34 bytes");
      const F = new A.BufferReader(M), ge = F.readSlice(32).toString("hex");
      let pe, Ie;
      try {
        pe = (0, p.sanitizeBigintToNumber)(F.readVarInt()), Ie = (0, p.sanitizeBigintToNumber)(F.readVarInt());
      } catch {
        throw new Error("Invalid request, couldn't parse tree_size or leaf_index");
      }
      const be = this.known_trees.get(ge);
      if (!be)
        throw Error(`Requested Merkle leaf proof for unknown tree: ${ge}`);
      if (Ie >= pe || be.size() != pe)
        throw Error("Invalid index or tree size.");
      if (this.queue.length != 0)
        throw Error("This command should not execute when the queue is not empty.");
      const Pe = be.getProof(Ie), Te = Math.min(Math.floor(221 / 32), Pe.length), Qe = Pe.length - Te;
      return Qe > 0 && this.queue.push(...Pe.slice(-Qe)), Buffer.concat([
        be.getLeafHash(Ie),
        Buffer.from([Pe.length]),
        Buffer.from([Te]),
        ...Pe.slice(0, Te)
      ]);
    }
  }
  clientCommands$1.GetMerkleLeafProofCommand = k;
  class C extends l {
    constructor(x) {
      super(), this.code = t.GET_MERKLE_LEAF_INDEX, this.known_trees = x;
    }
    execute(x) {
      const M = Buffer.from(x.subarray(1));
      if (M.length != 64)
        throw new Error("Invalid request, unexpected trailing data");
      const F = Buffer.alloc(32);
      for (let Te = 0; Te < 32; Te++)
        F[Te] = M.readUInt8(Te);
      const le = F.toString("hex"), ge = Buffer.alloc(32);
      for (let Te = 0; Te < 32; Te++)
        ge[Te] = M.readUInt8(32 + Te);
      const pe = ge.toString("hex"), Ie = this.known_trees.get(le);
      if (!Ie)
        throw Error(`Requested Merkle leaf index for unknown root: ${le}`);
      let be = 0, Pe = 0;
      for (let Te = 0; Te < Ie.size(); Te++)
        if (Ie.getLeafHash(Te).toString("hex") == pe) {
          Pe = 1, be = Te;
          break;
        }
      return Buffer.concat([Buffer.from([Pe]), (0, p.createVarint)(be)]);
    }
  }
  clientCommands$1.GetMerkleLeafIndexCommand = C;
  class B extends l {
    constructor(x) {
      super(), this.code = t.GET_MORE_ELEMENTS, this.queue = x;
    }
    execute(x) {
      if (x.length != 1)
        throw new Error("Invalid request, unexpected trailing data");
      if (this.queue.length === 0)
        throw new Error("No elements to get");
      const M = this.queue[0].length;
      if (this.queue.some((pe) => pe.length != M))
        throw new Error("The queue contains elements with different byte length, which is not expected");
      const F = Math.floor(253 / M), le = Math.min(F, this.queue.length), ge = this.queue.splice(0, le);
      return Buffer.concat([
        Buffer.from([le]),
        Buffer.from([M]),
        ...ge
      ]);
    }
  }
  clientCommands$1.GetMoreElementsCommand = B;
  class Q {
    constructor(x) {
      this.roots = /* @__PURE__ */ new Map(), this.preimages = /* @__PURE__ */ new Map(), this.yielded = [], this.queue = [], this.commands = /* @__PURE__ */ new Map();
      const M = [
        new m(this.yielded, x),
        new b(this.preimages, this.queue),
        new C(this.roots),
        new k(this.roots, this.queue),
        new B(this.queue)
      ];
      for (const F of M) {
        if (this.commands.has(F.code))
          throw new Error(`Multiple commands with code ${F.code}`);
        this.commands.set(F.code, F);
      }
    }
    getYielded() {
      return this.yielded;
    }
    addKnownPreimage(x) {
      this.preimages.set(s.crypto.sha256(x).toString("hex"), x);
    }
    addKnownList(x) {
      for (const F of x) {
        const le = Buffer.concat([Buffer.from([0]), F]);
        this.addKnownPreimage(le);
      }
      const M = new u.Merkle(x.map((F) => (0, u.hashLeaf)(F)));
      this.roots.set(M.getRoot().toString("hex"), M);
    }
    addKnownMapping(x) {
      this.addKnownList(x.keys), this.addKnownList(x.values);
    }
    addKnownWalletPolicy(x) {
      this.addKnownPreimage(x.serialize()), this.addKnownList(x.keys.map((M) => Buffer.from(M, "ascii"))), this.addKnownPreimage(Buffer.from(x.descriptorTemplate));
    }
    execute(x) {
      if (x.length == 0)
        throw new Error("Unexpected empty command");
      const M = x[0], F = this.commands.get(M);
      if (!F)
        throw new Error(`Unexpected command code ${M}`);
      return F.execute(x);
    }
  }
  return clientCommands$1.ClientCommandInterpreter = Q, clientCommands$1;
}
var merkelizedPsbt$1 = {}, merkleMap$1 = {}, hasRequiredMerkleMap$1;
function requireMerkleMap$1() {
  if (hasRequiredMerkleMap$1) return merkleMap$1;
  hasRequiredMerkleMap$1 = 1, Object.defineProperty(merkleMap$1, "__esModule", { value: !0 }), merkleMap$1.MerkleMap = void 0;
  const s = requireMerkle$1(), A = requireVarint$1();
  class u {
    /**
     * @param keys Sorted list of (unhashed) keys
     * @param values values, in corresponding order as the keys, and of equal length
     */
    constructor(t, l) {
      if (t.length != l.length)
        throw new Error("keys and values should have the same length");
      for (let m = 0; m < t.length - 1; m++)
        if (t[m].toString("hex") >= t[m + 1].toString("hex"))
          throw new Error("keys must be in strictly increasing order");
      this.keys = t, this.keysTree = new s.Merkle(t.map((m) => (0, s.hashLeaf)(m))), this.values = l, this.valuesTree = new s.Merkle(l.map((m) => (0, s.hashLeaf)(m)));
    }
    commitment() {
      return Buffer.concat([
        (0, A.createVarint)(this.keys.length),
        this.keysTree.getRoot(),
        this.valuesTree.getRoot()
      ]);
    }
  }
  return merkleMap$1.MerkleMap = u, merkleMap$1;
}
var psbtv2$1 = {}, hasRequiredPsbtv2$1;
function requirePsbtv2$1() {
  return hasRequiredPsbtv2$1 || (hasRequiredPsbtv2$1 = 1, function(s) {
    var A = psbtv2$1 && psbtv2$1.__createBinding || (Object.create ? function(xe, Ee, He, ve) {
      ve === void 0 && (ve = He);
      var we = Object.getOwnPropertyDescriptor(Ee, He);
      (!we || ("get" in we ? !Ee.__esModule : we.writable || we.configurable)) && (we = { enumerable: !0, get: function() {
        return Ee[He];
      } }), Object.defineProperty(xe, ve, we);
    } : function(xe, Ee, He, ve) {
      ve === void 0 && (ve = He), xe[ve] = Ee[He];
    }), u = psbtv2$1 && psbtv2$1.__setModuleDefault || (Object.create ? function(xe, Ee) {
      Object.defineProperty(xe, "default", { enumerable: !0, value: Ee });
    } : function(xe, Ee) {
      xe.default = Ee;
    }), p = psbtv2$1 && psbtv2$1.__importStar || function(xe) {
      if (xe && xe.__esModule) return xe;
      var Ee = {};
      if (xe != null) for (var He in xe) He !== "default" && Object.prototype.hasOwnProperty.call(xe, He) && A(Ee, xe, He);
      return u(Ee, xe), Ee;
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), s.PsbtV2 = s.NoSuchEntry = s.psbtOut = s.psbtIn = s.psbtGlobal = void 0;
    const t = p(requireSrc$3()), l = requireBuffertools$1(), m = requireVarint$1();
    var b;
    (function(xe) {
      xe[xe.UNSIGNED_TX = 0] = "UNSIGNED_TX", xe[xe.XPUB = 1] = "XPUB", xe[xe.TX_VERSION = 2] = "TX_VERSION", xe[xe.FALLBACK_LOCKTIME = 3] = "FALLBACK_LOCKTIME", xe[xe.INPUT_COUNT = 4] = "INPUT_COUNT", xe[xe.OUTPUT_COUNT = 5] = "OUTPUT_COUNT", xe[xe.TX_MODIFIABLE = 6] = "TX_MODIFIABLE", xe[xe.VERSION = 251] = "VERSION";
    })(b = s.psbtGlobal || (s.psbtGlobal = {}));
    var k;
    (function(xe) {
      xe[xe.NON_WITNESS_UTXO = 0] = "NON_WITNESS_UTXO", xe[xe.WITNESS_UTXO = 1] = "WITNESS_UTXO", xe[xe.PARTIAL_SIG = 2] = "PARTIAL_SIG", xe[xe.SIGHASH_TYPE = 3] = "SIGHASH_TYPE", xe[xe.REDEEM_SCRIPT = 4] = "REDEEM_SCRIPT", xe[xe.WITNESS_SCRIPT = 5] = "WITNESS_SCRIPT", xe[xe.BIP32_DERIVATION = 6] = "BIP32_DERIVATION", xe[xe.FINAL_SCRIPTSIG = 7] = "FINAL_SCRIPTSIG", xe[xe.FINAL_SCRIPTWITNESS = 8] = "FINAL_SCRIPTWITNESS", xe[xe.PREVIOUS_TXID = 14] = "PREVIOUS_TXID", xe[xe.OUTPUT_INDEX = 15] = "OUTPUT_INDEX", xe[xe.SEQUENCE = 16] = "SEQUENCE", xe[xe.TAP_KEY_SIG = 19] = "TAP_KEY_SIG", xe[xe.TAP_BIP32_DERIVATION = 22] = "TAP_BIP32_DERIVATION";
    })(k = s.psbtIn || (s.psbtIn = {}));
    var C;
    (function(xe) {
      xe[xe.REDEEM_SCRIPT = 0] = "REDEEM_SCRIPT", xe[xe.WITNESS_SCRIPT = 1] = "WITNESS_SCRIPT", xe[xe.BIP_32_DERIVATION = 2] = "BIP_32_DERIVATION", xe[xe.AMOUNT = 3] = "AMOUNT", xe[xe.SCRIPT = 4] = "SCRIPT", xe[xe.TAP_BIP32_DERIVATION = 7] = "TAP_BIP32_DERIVATION";
    })(C = s.psbtOut || (s.psbtOut = {}));
    const B = Buffer.from([112, 115, 98, 116, 255]);
    class Q extends Error {
    }
    s.NoSuchEntry = Q;
    class P {
      constructor() {
        this.globalMap = /* @__PURE__ */ new Map(), this.inputMaps = [], this.outputMaps = [];
      }
      setGlobalTxVersion(Ee) {
        this.setGlobal(b.TX_VERSION, be(Ee));
      }
      getGlobalTxVersion() {
        return this.getGlobal(b.TX_VERSION).readUInt32LE(0);
      }
      setGlobalFallbackLocktime(Ee) {
        this.setGlobal(b.FALLBACK_LOCKTIME, be(Ee));
      }
      getGlobalFallbackLocktime() {
        var Ee;
        return (Ee = this.getGlobalOptional(b.FALLBACK_LOCKTIME)) === null || Ee === void 0 ? void 0 : Ee.readUInt32LE(0);
      }
      setGlobalInputCount(Ee) {
        this.setGlobal(b.INPUT_COUNT, Te(Ee));
      }
      getGlobalInputCount() {
        return Qe(this.getGlobal(b.INPUT_COUNT));
      }
      setGlobalOutputCount(Ee) {
        this.setGlobal(b.OUTPUT_COUNT, Te(Ee));
      }
      getGlobalOutputCount() {
        return Qe(this.getGlobal(b.OUTPUT_COUNT));
      }
      setGlobalTxModifiable(Ee) {
        this.setGlobal(b.TX_MODIFIABLE, Ee);
      }
      getGlobalTxModifiable() {
        return this.getGlobalOptional(b.TX_MODIFIABLE);
      }
      setGlobalPsbtVersion(Ee) {
        this.setGlobal(b.VERSION, be(Ee));
      }
      getGlobalPsbtVersion() {
        return this.getGlobal(b.VERSION).readUInt32LE(0);
      }
      setInputNonWitnessUtxo(Ee, He) {
        this.setInput(Ee, k.NON_WITNESS_UTXO, pe(), He);
      }
      getInputNonWitnessUtxo(Ee) {
        return this.getInputOptional(Ee, k.NON_WITNESS_UTXO, pe());
      }
      setInputWitnessUtxo(Ee, He, ve) {
        const we = new l.BufferWriter();
        we.writeSlice(Pe(He)), we.writeVarSlice(ve), this.setInput(Ee, k.WITNESS_UTXO, pe(), we.buffer());
      }
      getInputWitnessUtxo(Ee) {
        const He = this.getInputOptional(Ee, k.WITNESS_UTXO, pe());
        if (!He)
          return;
        const ve = new l.BufferReader(He);
        return {
          amount: (0, l.unsafeFrom64bitLE)(ve.readSlice(8)),
          scriptPubKey: ve.readVarSlice()
        };
      }
      setInputPartialSig(Ee, He, ve) {
        this.setInput(Ee, k.PARTIAL_SIG, He, ve);
      }
      getInputPartialSig(Ee, He) {
        return this.getInputOptional(Ee, k.PARTIAL_SIG, He);
      }
      setInputSighashType(Ee, He) {
        this.setInput(Ee, k.SIGHASH_TYPE, pe(), be(He));
      }
      getInputSighashType(Ee) {
        const He = this.getInputOptional(Ee, k.SIGHASH_TYPE, pe());
        if (He)
          return He.readUInt32LE(0);
      }
      setInputRedeemScript(Ee, He) {
        this.setInput(Ee, k.REDEEM_SCRIPT, pe(), He);
      }
      getInputRedeemScript(Ee) {
        return this.getInputOptional(Ee, k.REDEEM_SCRIPT, pe());
      }
      setInputWitnessScript(Ee, He) {
        this.setInput(Ee, k.WITNESS_SCRIPT, pe(), He);
      }
      getInputWitnessScript(Ee) {
        return this.getInputOptional(Ee, k.WITNESS_SCRIPT, pe());
      }
      setInputBip32Derivation(Ee, He, ve, we) {
        if (He.length != 33)
          throw new Error("Invalid pubkey length: " + He.length);
        this.setInput(Ee, k.BIP32_DERIVATION, He, this.encodeBip32Derivation(ve, we));
      }
      getInputBip32Derivation(Ee, He) {
        const ve = this.getInputOptional(Ee, k.BIP32_DERIVATION, He);
        if (ve)
          return this.decodeBip32Derivation(ve);
      }
      setInputFinalScriptsig(Ee, He) {
        this.setInput(Ee, k.FINAL_SCRIPTSIG, pe(), He);
      }
      getInputFinalScriptsig(Ee) {
        return this.getInputOptional(Ee, k.FINAL_SCRIPTSIG, pe());
      }
      setInputFinalScriptwitness(Ee, He) {
        this.setInput(Ee, k.FINAL_SCRIPTWITNESS, pe(), He);
      }
      getInputFinalScriptwitness(Ee) {
        return this.getInput(Ee, k.FINAL_SCRIPTWITNESS, pe());
      }
      setInputPreviousTxId(Ee, He) {
        this.setInput(Ee, k.PREVIOUS_TXID, pe(), He);
      }
      getInputPreviousTxid(Ee) {
        return this.getInput(Ee, k.PREVIOUS_TXID, pe());
      }
      setInputOutputIndex(Ee, He) {
        this.setInput(Ee, k.OUTPUT_INDEX, pe(), be(He));
      }
      getInputOutputIndex(Ee) {
        return this.getInput(Ee, k.OUTPUT_INDEX, pe()).readUInt32LE(0);
      }
      setInputSequence(Ee, He) {
        this.setInput(Ee, k.SEQUENCE, pe(), be(He));
      }
      getInputSequence(Ee) {
        var He, ve;
        return (ve = (He = this.getInputOptional(Ee, k.SEQUENCE, pe())) === null || He === void 0 ? void 0 : He.readUInt32LE(0)) !== null && ve !== void 0 ? ve : 4294967295;
      }
      setInputTapKeySig(Ee, He) {
        this.setInput(Ee, k.TAP_KEY_SIG, pe(), He);
      }
      getInputTapKeySig(Ee) {
        return this.getInputOptional(Ee, k.TAP_KEY_SIG, pe());
      }
      setInputTapBip32Derivation(Ee, He, ve, we, Ce) {
        if (He.length != 32)
          throw new Error("Invalid pubkey length: " + He.length);
        const Se = this.encodeTapBip32Derivation(ve, we, Ce);
        this.setInput(Ee, k.TAP_BIP32_DERIVATION, He, Se);
      }
      getInputTapBip32Derivation(Ee, He) {
        const ve = this.getInput(Ee, k.TAP_BIP32_DERIVATION, He);
        return this.decodeTapBip32Derivation(ve);
      }
      getInputKeyDatas(Ee, He) {
        return this.getKeyDatas(this.inputMaps[Ee], He);
      }
      setOutputRedeemScript(Ee, He) {
        this.setOutput(Ee, C.REDEEM_SCRIPT, pe(), He);
      }
      getOutputRedeemScript(Ee) {
        return this.getOutput(Ee, C.REDEEM_SCRIPT, pe());
      }
      setOutputBip32Derivation(Ee, He, ve, we) {
        this.setOutput(Ee, C.BIP_32_DERIVATION, He, this.encodeBip32Derivation(ve, we));
      }
      getOutputBip32Derivation(Ee, He) {
        const ve = this.getOutput(Ee, C.BIP_32_DERIVATION, He);
        return this.decodeBip32Derivation(ve);
      }
      setOutputAmount(Ee, He) {
        this.setOutput(Ee, C.AMOUNT, pe(), Pe(He));
      }
      getOutputAmount(Ee) {
        const He = this.getOutput(Ee, C.AMOUNT, pe());
        return (0, l.unsafeFrom64bitLE)(He);
      }
      setOutputScript(Ee, He) {
        this.setOutput(Ee, C.SCRIPT, pe(), He);
      }
      getOutputScript(Ee) {
        return this.getOutput(Ee, C.SCRIPT, pe());
      }
      setOutputTapBip32Derivation(Ee, He, ve, we, Ce) {
        const Se = this.encodeTapBip32Derivation(ve, we, Ce);
        this.setOutput(Ee, C.TAP_BIP32_DERIVATION, He, Se);
      }
      getOutputTapBip32Derivation(Ee, He) {
        const ve = this.getOutput(Ee, C.TAP_BIP32_DERIVATION, He);
        return this.decodeTapBip32Derivation(ve);
      }
      deleteInputEntries(Ee, He) {
        this.inputMaps[Ee].forEach((we, Ce, Se) => {
          this.isKeyType(Ce, He) && Se.delete(Ce);
        });
      }
      copy(Ee) {
        this.copyMap(this.globalMap, Ee.globalMap), this.copyMaps(this.inputMaps, Ee.inputMaps), this.copyMaps(this.outputMaps, Ee.outputMaps);
      }
      copyMaps(Ee, He) {
        Ee.forEach((ve, we) => {
          const Ce = /* @__PURE__ */ new Map();
          this.copyMap(ve, Ce), He[we] = Ce;
        });
      }
      copyMap(Ee, He) {
        Ee.forEach((ve, we) => He.set(we, Buffer.from(ve)));
      }
      serialize() {
        const Ee = new l.BufferWriter();
        return Ee.writeSlice(B), ge(Ee, this.globalMap), this.inputMaps.forEach((He) => {
          ge(Ee, He);
        }), this.outputMaps.forEach((He) => {
          ge(Ee, He);
        }), Ee.buffer();
      }
      deserialize(Ee) {
        const He = new l.BufferReader(Ee);
        if (!He.readSlice(5).equals(B))
          throw new Error("Invalid magic bytes");
        for (; this.readKeyPair(this.globalMap, He); )
          ;
        let ve;
        try {
          ve = this.getGlobalPsbtVersion();
        } catch {
          ve = 0;
        }
        if (ve !== 0 && ve !== 2)
          throw new Error("Only PSBTs of version 0 or 2 are supported");
        let we, Ce;
        if (ve == 0) {
          const Se = this.getGlobal(b.UNSIGNED_TX), Ne = t.Transaction.fromBuffer(Se);
          we = Ne.ins.length, Ce = Ne.outs.length;
        } else
          we = this.getGlobalInputCount(), Ce = this.getGlobalOutputCount();
        for (let Se = 0; Se < we; Se++)
          for (this.inputMaps[Se] = /* @__PURE__ */ new Map(); this.readKeyPair(this.inputMaps[Se], He); )
            ;
        for (let Se = 0; Se < Ce; Se++)
          for (this.outputMaps[Se] = /* @__PURE__ */ new Map(); this.readKeyPair(this.outputMaps[Se], He); )
            ;
        this.normalizeToV2();
      }
      normalizeToV2() {
        var Ee;
        const He = (Ee = this.getGlobalOptional(b.VERSION)) === null || Ee === void 0 ? void 0 : Ee.readInt32LE(0);
        if (He === 2)
          return;
        if (He !== void 0)
          throw new Error("Invalid or unsupported value for PSBT_GLOBAL_VERSION");
        const ve = this.getGlobal(b.UNSIGNED_TX), we = t.Transaction.fromBuffer(ve);
        this.setGlobalPsbtVersion(2), this.setGlobalTxVersion(we.version), this.setGlobalFallbackLocktime(we.locktime), this.setGlobalInputCount(we.ins.length), this.setGlobalOutputCount(we.outs.length);
        for (let Ce = 0; Ce < we.ins.length; Ce++)
          this.setInputPreviousTxId(Ce, we.ins[Ce].hash), this.setInputOutputIndex(Ce, we.ins[Ce].index), this.setInputSequence(Ce, we.ins[Ce].sequence);
        for (let Ce = 0; Ce < we.outs.length; Ce++)
          this.setOutputAmount(Ce, we.outs[Ce].value), this.setOutputScript(Ce, we.outs[Ce].script);
        this.globalMap.delete(b.UNSIGNED_TX.toString(16).padStart(2, "0"));
      }
      /**
       * Imports a BitcoinJS (bitcoinjs-lib) Psbt object.
       * https://github.com/bitcoinjs/bitcoinjs-lib/blob/master/ts_src/psbt.ts
       *
       * Prepares the fields required for signing a Psbt on a Ledger
       * device. It should be used exclusively before calling
       * `appClient.signPsbt()` and not as a general Psbt conversion method.
       *
       * Note: This method supports all the policies that the Ledger is able to
       * sign, with the exception of taproot: tr(@0).
       */
      fromBitcoinJS(Ee) {
        function He(ve) {
          let we;
          try {
            t.payments.p2tr({ output: ve.witnessUtxo.script }), we = !0;
          } catch {
            we = !1;
          }
          return ve && !!(ve.tapInternalKey || ve.tapMerkleRoot || ve.tapLeafScript && ve.tapLeafScript.length || ve.tapBip32Derivation && ve.tapBip32Derivation.length || we);
        }
        return this.setGlobalPsbtVersion(2), this.setGlobalTxVersion(Ee.version), this.setGlobalInputCount(Ee.data.inputs.length), this.setGlobalOutputCount(Ee.txOutputs.length), Ee.locktime !== void 0 && this.setGlobalFallbackLocktime(Ee.locktime), Ee.data.inputs.forEach((ve, we) => {
          if (He(ve))
            throw new Error("Taproot inputs not supported");
          this.setInputPreviousTxId(we, Ee.txInputs[we].hash), Ee.txInputs[we].sequence !== void 0 && this.setInputSequence(we, Ee.txInputs[we].sequence), this.setInputOutputIndex(we, Ee.txInputs[we].index), ve.sighashType !== void 0 && this.setInputSighashType(we, ve.sighashType), ve.nonWitnessUtxo && this.setInputNonWitnessUtxo(we, ve.nonWitnessUtxo), ve.witnessUtxo && this.setInputWitnessUtxo(we, ve.witnessUtxo.value, ve.witnessUtxo.script), ve.witnessScript && this.setInputWitnessScript(we, ve.witnessScript), ve.redeemScript && this.setInputRedeemScript(we, ve.redeemScript), Ee.data.inputs[we].bip32Derivation.forEach((Ce) => {
            if (!/^m\//i.test(Ce.path))
              throw new Error("Invalid input bip32 derivation");
            const Se = Ce.path.replace(/m\//i, "").split("/").map((Ne) => Ne.match(/['h]/i) ? parseInt(Ne) + 2147483648 : Number(Ne));
            this.setInputBip32Derivation(we, Ce.pubkey, Ce.masterFingerprint, Se);
          });
        }), Ee.txOutputs.forEach((ve, we) => {
          this.setOutputAmount(we, ve.value), this.setOutputScript(we, ve.script);
        }), this;
      }
      readKeyPair(Ee, He) {
        const ve = (0, m.sanitizeBigintToNumber)(He.readVarInt());
        if (ve == 0)
          return !1;
        const we = He.readUInt8(), Ce = He.readSlice(ve - 1), Se = He.readVarSlice();
        return Ie(Ee, we, Ce, Se), !0;
      }
      getKeyDatas(Ee, He) {
        const ve = [];
        return Ee.forEach((we, Ce) => {
          this.isKeyType(Ce, [He]) && ve.push(Buffer.from(Ce.substring(2), "hex"));
        }), ve;
      }
      isKeyType(Ee, He) {
        const ve = Buffer.from(Ee.substring(0, 2), "hex").readUInt8(0);
        return He.some((we) => we == ve);
      }
      setGlobal(Ee, He) {
        const ve = new M(Ee, Buffer.from([]));
        this.globalMap.set(ve.toString(), He);
      }
      getGlobal(Ee) {
        return x(this.globalMap, Ee, pe(), !1);
      }
      getGlobalOptional(Ee) {
        return x(this.globalMap, Ee, pe(), !0);
      }
      setInput(Ee, He, ve, we) {
        Ie(this.getMap(Ee, this.inputMaps), He, ve, we);
      }
      getInput(Ee, He, ve) {
        return x(this.inputMaps[Ee], He, ve, !1);
      }
      getInputOptional(Ee, He, ve) {
        return x(this.inputMaps[Ee], He, ve, !0);
      }
      setOutput(Ee, He, ve, we) {
        Ie(this.getMap(Ee, this.outputMaps), He, ve, we);
      }
      getOutput(Ee, He, ve) {
        return x(this.outputMaps[Ee], He, ve, !1);
      }
      getMap(Ee, He) {
        return He[Ee] ? He[Ee] : He[Ee] = /* @__PURE__ */ new Map();
      }
      encodeBip32Derivation(Ee, He) {
        const ve = new l.BufferWriter();
        return this.writeBip32Derivation(ve, Ee, He), ve.buffer();
      }
      decodeBip32Derivation(Ee) {
        const He = new l.BufferReader(Ee);
        return this.readBip32Derivation(He);
      }
      writeBip32Derivation(Ee, He, ve) {
        Ee.writeSlice(He), ve.forEach((we) => {
          Ee.writeUInt32(we);
        });
      }
      readBip32Derivation(Ee) {
        const He = Ee.readSlice(4), ve = [];
        for (; Ee.offset < Ee.buffer.length; )
          ve.push(Ee.readUInt32());
        return { masterFingerprint: He, path: ve };
      }
      encodeTapBip32Derivation(Ee, He, ve) {
        const we = new l.BufferWriter();
        return we.writeVarInt(Ee.length), Ee.forEach((Ce) => {
          we.writeSlice(Ce);
        }), this.writeBip32Derivation(we, He, ve), we.buffer();
      }
      decodeTapBip32Derivation(Ee) {
        const He = new l.BufferReader(Ee), ve = (0, m.sanitizeBigintToNumber)(He.readVarInt()), we = [];
        for (let Se = 0; Se < ve; Se++)
          we.push(He.readSlice(32));
        const Ce = this.readBip32Derivation(He);
        return Object.assign({ hashes: we }, Ce);
      }
    }
    s.PsbtV2 = P;
    function x(xe, Ee, He, ve) {
      if (!xe)
        throw Error("No such map");
      const we = new M(Ee, He), Ce = xe.get(we.toString());
      if (!Ce) {
        if (ve)
          return;
        throw new Q(we.toString());
      }
      return Buffer.from(Ce);
    }
    class M {
      constructor(Ee, He) {
        this.keyType = Ee, this.keyData = He;
      }
      toString() {
        const Ee = new l.BufferWriter();
        return this.toBuffer(Ee), Ee.buffer().toString("hex");
      }
      serialize(Ee) {
        Ee.writeVarInt(1 + this.keyData.length), this.toBuffer(Ee);
      }
      toBuffer(Ee) {
        Ee.writeUInt8(this.keyType), Ee.writeSlice(this.keyData);
      }
    }
    class F {
      constructor(Ee, He) {
        this.key = Ee, this.value = He;
      }
      serialize(Ee) {
        this.key.serialize(Ee), Ee.writeVarSlice(this.value);
      }
    }
    function le(xe) {
      return new M(xe.readUInt8(0), xe.slice(1));
    }
    function ge(xe, Ee) {
      for (let [He, ve] of [...Ee].sort(([we], [Ce]) => we.localeCompare(Ce)))
        new F(le(Buffer.from(He, "hex")), ve).serialize(xe);
      xe.writeUInt8(0);
    }
    function pe() {
      return Buffer.from([]);
    }
    function Ie(xe, Ee, He, ve) {
      const we = new M(Ee, He);
      xe.set(we.toString(), ve);
    }
    function be(xe) {
      const Ee = Buffer.alloc(4);
      return Ee.writeUInt32LE(xe, 0), Ee;
    }
    function Pe(xe) {
      return (0, l.unsafeTo64bitLE)(xe);
    }
    function Te(xe) {
      const Ee = new l.BufferWriter();
      return Ee.writeVarInt(xe), Ee.buffer();
    }
    function Qe(xe) {
      return (0, m.sanitizeBigintToNumber)(new l.BufferReader(xe).readVarInt());
    }
  }(psbtv2$1)), psbtv2$1;
}
var hasRequiredMerkelizedPsbt$1;
function requireMerkelizedPsbt$1() {
  if (hasRequiredMerkelizedPsbt$1) return merkelizedPsbt$1;
  hasRequiredMerkelizedPsbt$1 = 1, Object.defineProperty(merkelizedPsbt$1, "__esModule", { value: !0 }), merkelizedPsbt$1.MerkelizedPsbt = void 0;
  const s = requireMerkleMap$1(), A = requirePsbtv2$1();
  class u extends A.PsbtV2 {
    constructor(t) {
      super(), this.inputMerkleMaps = [], this.outputMerkleMaps = [], t.copy(this), this.globalMerkleMap = u.createMerkleMap(this.globalMap);
      for (let l = 0; l < this.getGlobalInputCount(); l++)
        this.inputMerkleMaps.push(u.createMerkleMap(this.inputMaps[l]));
      this.inputMapCommitments = [...this.inputMerkleMaps.values()].map((l) => l.commitment());
      for (let l = 0; l < this.getGlobalOutputCount(); l++)
        this.outputMerkleMaps.push(u.createMerkleMap(this.outputMaps[l]));
      this.outputMapCommitments = [...this.outputMerkleMaps.values()].map((l) => l.commitment());
    }
    // These public functions are for MerkelizedPsbt.
    getGlobalSize() {
      return this.globalMap.size;
    }
    getGlobalKeysValuesRoot() {
      return this.globalMerkleMap.commitment();
    }
    static createMerkleMap(t) {
      const l = [...t.keys()].sort(), m = l.map((k) => {
        const C = t.get(k);
        if (!C)
          throw new Error("No value for key " + k);
        return C;
      }), b = l.map((k) => Buffer.from(k, "hex"));
      return new s.MerkleMap(b, m);
    }
  }
  return merkelizedPsbt$1.MerkelizedPsbt = u, merkelizedPsbt$1;
}
var hasRequiredAppClient$1;
function requireAppClient$1() {
  if (hasRequiredAppClient$1) return appClient$2;
  hasRequiredAppClient$1 = 1;
  var s = appClient$2 && appClient$2.__createBinding || (Object.create ? function(Pe, Te, Qe, xe) {
    xe === void 0 && (xe = Qe);
    var Ee = Object.getOwnPropertyDescriptor(Te, Qe);
    (!Ee || ("get" in Ee ? !Te.__esModule : Ee.writable || Ee.configurable)) && (Ee = { enumerable: !0, get: function() {
      return Te[Qe];
    } }), Object.defineProperty(Pe, xe, Ee);
  } : function(Pe, Te, Qe, xe) {
    xe === void 0 && (xe = Qe), Pe[xe] = Te[Qe];
  }), A = appClient$2 && appClient$2.__setModuleDefault || (Object.create ? function(Pe, Te) {
    Object.defineProperty(Pe, "default", { enumerable: !0, value: Te });
  } : function(Pe, Te) {
    Pe.default = Te;
  }), u = appClient$2 && appClient$2.__importStar || function(Pe) {
    if (Pe && Pe.__esModule) return Pe;
    var Te = {};
    if (Pe != null) for (var Qe in Pe) Qe !== "default" && Object.prototype.hasOwnProperty.call(Pe, Qe) && s(Te, Pe, Qe);
    return A(Te, Pe), Te;
  };
  Object.defineProperty(appClient$2, "__esModule", { value: !0 }), appClient$2.AppClient = appClient$2.PartialSignature = void 0;
  const p = u(requireDist()), t = u(requireDist$l()), { Descriptor: l } = p.DescriptorsFactory(t), m = requireSrc$3(), b = requireBip32$1(), k = requireClientCommands$1(), C = requireMerkelizedPsbt$1(), B = requireMerkle$1(), Q = requirePsbtv2$1(), P = requireVarint$1(), x = 225, M = 248, F = 1;
  var le;
  (function(Pe) {
    Pe[Pe.GET_PUBKEY = 0] = "GET_PUBKEY", Pe[Pe.REGISTER_WALLET = 2] = "REGISTER_WALLET", Pe[Pe.GET_WALLET_ADDRESS = 3] = "GET_WALLET_ADDRESS", Pe[Pe.SIGN_PSBT = 4] = "SIGN_PSBT", Pe[Pe.GET_MASTER_FINGERPRINT = 5] = "GET_MASTER_FINGERPRINT", Pe[Pe.SIGN_MESSAGE = 16] = "SIGN_MESSAGE";
  })(le || (le = {}));
  var ge;
  (function(Pe) {
    Pe[Pe.CONTINUE_INTERRUPTED = 1] = "CONTINUE_INTERRUPTED";
  })(ge || (ge = {}));
  class pe {
    constructor(Te, Qe, xe) {
      this.pubkey = Te, this.signature = Qe, this.tapleafHash = xe;
    }
  }
  appClient$2.PartialSignature = pe;
  function Ie(Pe, Te) {
    if (Pe.length == 64)
      return new pe(Pe.slice(0, 32), Te, Pe.slice(32, 64));
    if (Pe.length == 32 || Pe.length == 33)
      return new pe(Pe, Te);
    throw new Error(`Invalid length for pubkeyAugm: ${Pe.length} bytes.`);
  }
  class be {
    constructor(Te) {
      this.transport = Te;
    }
    async makeRequest(Te, Qe, xe) {
      let Ee = await this.transport.send(x, Te, 0, F, Qe, [36864, 57344]);
      for (; Ee.readUInt16BE(Ee.length - 2) === 57344; ) {
        if (!xe)
          throw new Error("Unexpected SW_INTERRUPTED_EXECUTION");
        const He = Ee.slice(0, -2), ve = xe.execute(He);
        Ee = await this.transport.send(M, ge.CONTINUE_INTERRUPTED, 0, 0, ve, [36864, 57344]);
      }
      return Ee.slice(0, -2);
    }
    /**
     * Returns an object containing the currently running app's name, version and the device status flags.
     *
     * @returns an object with app name, version and device status flags.
     */
    async getAppAndVersion() {
      const Te = await this.transport.send(176, 1, 0, 0);
      let Qe = 0;
      if (Te[Qe++] !== 1)
        throw new Error("Unexpected response");
      const Ee = Te[Qe++], He = Te.slice(Qe, Qe += Ee).toString("ascii"), ve = Te[Qe++], we = Te.slice(Qe, Qe += ve).toString("ascii"), Ce = Te[Qe++], Se = Te.slice(Qe, Qe += Ce);
      return {
        name: He,
        version: we,
        flags: Se
      };
    }
    /**
     * Requests the BIP-32 extended pubkey to the hardware wallet.
     * If `display` is `false`, only standard paths will be accepted; an error is returned if an unusual path is
     * requested.
     * If `display` is `true`, the requested path is shown on screen for user verification; unusual paths can be
     * requested, and a warning is shown to the user in that case.
     *
     * @param path the requested BIP-32 path as a string
     * @param display `false` to silently retrieve a pubkey for a standard path, `true` to display the path on screen
     * @returns the base58-encoded serialized extended pubkey (xpub)
     */
    async getExtendedPubkey(Te, Qe = !1) {
      const xe = (0, b.pathStringToArray)(Te);
      if (xe.length > 6)
        throw new Error("Path too long. At most 6 levels allowed.");
      return (await this.makeRequest(le.GET_PUBKEY, Buffer.concat([
        Buffer.from(Qe ? [1] : [0]),
        (0, b.pathElementsToBuffer)(xe)
      ]))).toString("ascii");
    }
    /**
     * Registers a `WalletPolicy`, after interactive verification from the user.
     * On success, after user's approval, this function returns the id (which is the same that can be computed with
     * `walletPolicy.getid()`), followed by the 32-byte hmac. The client should store the hmac to use it for future
     * requests to `getWalletAddress` or `signPsbt` using this `WalletPolicy`.
     *
     * @param walletPolicy the `WalletPolicy` to register
     * @returns a pair of two 32-byte arrays: the id of the Wallet Policy, followed by the policy hmac
     */
    async registerWallet(Te) {
      const Qe = new k.ClientCommandInterpreter();
      Qe.addKnownWalletPolicy(Te);
      const xe = Te.serialize(), Ee = await this.makeRequest(le.REGISTER_WALLET, Buffer.concat([
        (0, P.createVarint)(xe.length),
        xe
      ]), Qe);
      if (Ee.length != 64)
        throw Error(`Invalid response length. Expected 64 bytes, got ${Ee.length}`);
      const He = Ee.subarray(0, 32), ve = Ee.subarray(32), we = await this.getWalletAddress(Te, ve, 0, 0, !1);
      return await this.validateAddress(we, Te, 0, 0), [He, ve];
    }
    /**
     * Returns the address of `walletPolicy` for the given `change` and `addressIndex`.
     *
     * @param walletPolicy the `WalletPolicy` to use
     * @param walletHMAC the 32-byte hmac returned during wallet registration for a registered policy; otherwise
     * `null` for a standard policy
     * @param change `0` for a normal receive address, `1` for a change address
     * @param addressIndex the address index to retrieve
     * @param display `True` to show the address on screen, `False` to retrieve it silently
     * @returns the address, as an ascii string.
     */
    async getWalletAddress(Te, Qe, xe, Ee, He) {
      if (xe !== 0 && xe !== 1)
        throw new Error("Change can only be 0 or 1");
      if (Ee < 0 || !Number.isInteger(Ee))
        throw new Error("Invalid address index");
      if (Qe != null && Qe.length != 32)
        throw new Error("Invalid HMAC length");
      const ve = new k.ClientCommandInterpreter();
      ve.addKnownWalletPolicy(Te);
      const we = Buffer.alloc(4);
      we.writeUInt32BE(Ee, 0);
      const Se = (await this.makeRequest(le.GET_WALLET_ADDRESS, Buffer.concat([
        Buffer.from(He ? [1] : [0]),
        Te.getId(),
        Qe || Buffer.alloc(32, 0),
        Buffer.from([xe]),
        we
      ]), ve)).toString("ascii");
      return await this.validateAddress(Se, Te, xe, Ee), Se;
    }
    /**
     * Signs a psbt using a (standard or registered) `WalletPolicy`. This is an interactive command, as user validation
     * is necessary using the device's secure screen.
     * On success, a map of input indexes and signatures is returned.
     * @param psbt a base64-encoded string, or a psbt in a binary Buffer. Using the `PsbtV2` type is deprecated.
     * @param walletPolicy the `WalletPolicy` to use for signing
     * @param walletHMAC the 32-byte hmac obtained during wallet policy registration, or `null` for a standard policy
     * @param progressCallback optionally, a callback that will be called every time a signature is produced during
     * the signing process. The callback does not receive any argument, but can be used to track progress.
     * @returns an array of of tuples with 2 elements containing:
     *    - the index of the input being signed;
     *    - an instance of PartialSignature
     */
    async signPsbt(Te, Qe, xe, Ee) {
      if (typeof Te == "string" && (Te = Buffer.from(Te, "base64")), Buffer.isBuffer(Te)) {
        const rr = new Q.PsbtV2();
        rr.deserialize(Te), Te = rr;
      }
      const He = new C.MerkelizedPsbt(Te);
      if (xe != null && xe.length != 32)
        throw new Error("Invalid HMAC length");
      const ve = new k.ClientCommandInterpreter(Ee);
      ve.addKnownWalletPolicy(Qe), ve.addKnownMapping(He.globalMerkleMap);
      for (const rr of He.inputMerkleMaps)
        ve.addKnownMapping(rr);
      for (const rr of He.outputMerkleMaps)
        ve.addKnownMapping(rr);
      ve.addKnownList(He.inputMapCommitments);
      const we = new B.Merkle(He.inputMapCommitments.map((rr) => (0, B.hashLeaf)(rr))).getRoot();
      ve.addKnownList(He.outputMapCommitments);
      const Ce = new B.Merkle(He.outputMapCommitments.map((rr) => (0, B.hashLeaf)(rr))).getRoot();
      await this.makeRequest(le.SIGN_PSBT, Buffer.concat([
        He.getGlobalKeysValuesRoot(),
        (0, P.createVarint)(He.getGlobalInputCount()),
        we,
        (0, P.createVarint)(He.getGlobalOutputCount()),
        Ce,
        Qe.getId(),
        xe || Buffer.alloc(32, 0)
      ]), ve);
      const Se = ve.getYielded(), Ne = [];
      for (const rr of Se) {
        const [er, ir] = (0, P.parseVarint)(rr, 0), sr = rr[ir], nr = rr.subarray(ir + 1, ir + 1 + sr), fr = rr.subarray(ir + 1 + sr), lr = Ie(nr, fr);
        Ne.push([Number(er), lr]);
      }
      return Ne;
    }
    /**
     * Returns the fingerprint of the master public key, as per BIP-32 standard.
     * @returns the master key fingerprint as a string of 8 hexadecimal digits.
     */
    async getMasterFingerprint() {
      return (await this.makeRequest(le.GET_MASTER_FINGERPRINT, Buffer.from([]))).toString("hex");
    }
    /**
     * Signs a message using the legacy Bitcoin Message Signing standard. The signed message is
     * the double-sha256 hash of the concatenation of:
     * - "\x18Bitcoin Signed Message:\n";
     * - the length of `message`, encoded as a Bitcoin-style variable length integer;
     * - `message`.
     *
     * @param message the serialized message to sign
     * @param path the BIP-32 path of the key used to sign the message
     * @returns base64-encoded signature of the message.
     */
    async signMessage(Te, Qe) {
      const xe = (0, b.pathStringToArray)(Qe), Ee = new k.ClientCommandInterpreter(), He = Math.ceil(Te.length / 64), ve = [];
      for (let Se = 0; Se < He; Se++)
        ve.push(Te.subarray(64 * Se, 64 * Se + 64));
      Ee.addKnownList(ve);
      const we = new B.Merkle(ve.map((Se) => (0, B.hashLeaf)(Se))).getRoot();
      return (await this.makeRequest(le.SIGN_MESSAGE, Buffer.concat([
        (0, b.pathElementsToBuffer)(xe),
        (0, P.createVarint)(Te.length),
        we
      ]), Ee)).toString("base64");
    }
    /* Performs any additional check on the generated address before returning it.*/
    async validateAddress(Te, Qe, xe, Ee) {
      if (xe !== 0 && xe !== 1)
        throw new Error("Change can only be 0 or 1");
      const He = xe === 1;
      if (Ee < 0 || !Number.isInteger(Ee))
        throw new Error("Invalid address index");
      const ve = await this.getAppAndVersion();
      let we;
      if (ve.name === "Babylon BTC Test")
        we = m.networks.testnet;
      else if (ve.name === "Babylon BTC Staking")
        we = m.networks.bitcoin;
      else
        throw new Error(`Invalid app: ${ve.name}. Expected 'Babylon BTC Test' or 'Babylon BTC Staking'.`);
      let Ce = Qe.descriptorTemplate;
      Ce = Ce.replace(/\/\*\*/g, "/<0;1>/*");
      const Se = new RegExp("/<(\\d+);(\\d+)>", "g");
      let Ne;
      for (; (Ne = Se.exec(Ce)) !== null; ) {
        const [ir, sr] = [parseInt(Ne[1], 10), parseInt(Ne[2], 10)];
        Ce = Ce.replace(`/<${ir};${sr}>`, `/${He ? sr : ir}`);
      }
      Ce = Ce.replace(/\/\*/g, `/${Ee}`);
      for (let ir = Qe.keys.length - 1; ir >= 0; ir--)
        Ce = Ce.replace(new RegExp(`@${ir}`, "g"), Qe.keys[ir]);
      let rr = !0, er;
      try {
        er = new l({
          expression: Ce,
          network: we
        }).getAddress();
      } catch {
        rr = !1;
      }
      if (rr && Te !== er)
        throw new Error(`Third party address validation mismatch: ${Te} != ${er}`);
    }
  }
  return appClient$2.AppClient = be, appClient$2.default = be, appClient$2;
}
var policy$1 = {}, hasRequiredPolicy$1;
function requirePolicy$1() {
  if (hasRequiredPolicy$1) return policy$1;
  hasRequiredPolicy$1 = 1, Object.defineProperty(policy$1, "__esModule", { value: !0 }), policy$1.DefaultWalletPolicy = policy$1.WalletPolicy = void 0;
  const s = requireSrc$3(), A = requireBuffertools$1(), u = requireMerkle$1(), p = 2;
  class t {
    /**
     * Creates and instance of a wallet policy.
     * @param name an ascii string, up to 16 bytes long; it must be an empty string for default wallet policies
     * @param descriptorTemplate the wallet policy template
     * @param keys and array of the keys, with the key derivation information
     */
    constructor(b, k, C) {
      this.name = b, this.descriptorTemplate = k, this.keys = C;
    }
    /**
     * Returns the unique 32-bytes id of this wallet policy.
     */
    getId() {
      return s.crypto.sha256(this.serialize());
    }
    /**
     * Serializes the wallet policy for transmission via the hardware wallet protocol.
     * @returns the serialized wallet policy
     */
    serialize() {
      const b = this.keys.map((B) => Buffer.from(B, "ascii")), k = new u.Merkle(b.map((B) => (0, u.hashLeaf)(B))), C = new A.BufferWriter();
      return C.writeUInt8(p), C.writeVarSlice(Buffer.from(this.name, "ascii")), C.writeVarInt(this.descriptorTemplate.length), C.writeSlice(s.crypto.sha256(Buffer.from(this.descriptorTemplate))), C.writeVarInt(this.keys.length), C.writeSlice(k.getRoot()), C.buffer();
    }
  }
  policy$1.WalletPolicy = t;
  class l extends t {
    constructor(b, k) {
      super("", b, [k]);
    }
  }
  return policy$1.DefaultWalletPolicy = l, policy$1;
}
var babylon$1 = {}, main$1 = {}, hasRequiredMain$2;
function requireMain$2() {
  var ho;
  if (hasRequiredMain$2) return main$1;
  hasRequiredMain$2 = 1;
  function s(ar) {
    if (!Number.isSafeInteger(ar) || ar < 0)
      throw new Error(`Wrong positive integer: ${ar}`);
  }
  function A(ar) {
    if (typeof ar != "boolean")
      throw new Error(`Expected boolean, not ${ar}`);
  }
  function u(ar, ...Je) {
    if (!(ar instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (Je.length > 0 && !Je.includes(ar.length))
      throw new TypeError(`Expected Uint8Array of length ${Je}, not of length=${ar.length}`);
  }
  function p(ar) {
    if (typeof ar != "function" || typeof ar.create != "function")
      throw new Error("Hash should be wrapped by utils.wrapConstructor");
    s(ar.outputLen), s(ar.blockLen);
  }
  function t(ar, Je = !0) {
    if (ar.destroyed)
      throw new Error("Hash instance has been destroyed");
    if (Je && ar.finished)
      throw new Error("Hash#digest() has already been called");
  }
  function l(ar, Je) {
    u(ar);
    const pr = Je.outputLen;
    if (ar.length < pr)
      throw new Error(`digestInto() expects output buffer of length at least ${pr}`);
  }
  var b = {
    number: s,
    bool: A,
    bytes: u,
    hash: p,
    exists: t,
    output: l
  };
  const k = (ar) => new DataView(ar.buffer, ar.byteOffset, ar.byteLength), C = (ar, Je) => ar << 32 - Je | ar >>> Je;
  if (!(new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68))
    throw new Error("Non little-endian hardware is not supported");
  Array.from({ length: 256 }, (ar, Je) => Je.toString(16).padStart(2, "0"));
  function Q(ar) {
    if (typeof ar != "string")
      throw new TypeError(`utf8ToBytes expected string, got ${typeof ar}`);
    return new TextEncoder().encode(ar);
  }
  function P(ar) {
    if (typeof ar == "string" && (ar = Q(ar)), !(ar instanceof Uint8Array))
      throw new TypeError(`Expected input type is Uint8Array (got ${typeof ar})`);
    return ar;
  }
  let x = class {
    // Safe version that clones internal state
    clone() {
      return this._cloneInto();
    }
  };
  function M(ar) {
    const Je = (Lr) => ar().update(P(Lr)).digest(), pr = ar();
    return Je.outputLen = pr.outputLen, Je.blockLen = pr.blockLen, Je.create = () => ar(), Je;
  }
  function F(ar, Je, pr, Lr) {
    if (typeof ar.setBigUint64 == "function")
      return ar.setBigUint64(Je, pr, Lr);
    const hn = BigInt(32), mn = BigInt(4294967295), qn = Number(pr >> hn & mn), Vn = Number(pr & mn), oi = Lr ? 4 : 0, li = Lr ? 0 : 4;
    ar.setUint32(Je + oi, qn, Lr), ar.setUint32(Je + li, Vn, Lr);
  }
  let le = class extends x {
    constructor(Je, pr, Lr, hn) {
      super(), this.blockLen = Je, this.outputLen = pr, this.padOffset = Lr, this.isLE = hn, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(Je), this.view = k(this.buffer);
    }
    update(Je) {
      b.exists(this);
      const { view: pr, buffer: Lr, blockLen: hn } = this;
      Je = P(Je);
      const mn = Je.length;
      for (let qn = 0; qn < mn; ) {
        const Vn = Math.min(hn - this.pos, mn - qn);
        if (Vn === hn) {
          const oi = k(Je);
          for (; hn <= mn - qn; qn += hn)
            this.process(oi, qn);
          continue;
        }
        Lr.set(Je.subarray(qn, qn + Vn), this.pos), this.pos += Vn, qn += Vn, this.pos === hn && (this.process(pr, 0), this.pos = 0);
      }
      return this.length += Je.length, this.roundClean(), this;
    }
    digestInto(Je) {
      b.exists(this), b.output(Je, this), this.finished = !0;
      const { buffer: pr, view: Lr, blockLen: hn, isLE: mn } = this;
      let { pos: qn } = this;
      pr[qn++] = 128, this.buffer.subarray(qn).fill(0), this.padOffset > hn - qn && (this.process(Lr, 0), qn = 0);
      for (let mi = qn; mi < hn; mi++)
        pr[mi] = 0;
      F(Lr, hn - 8, BigInt(this.length * 8), mn), this.process(Lr, 0);
      const Vn = k(Je), oi = this.outputLen;
      if (oi % 4)
        throw new Error("_sha2: outputLen should be aligned to 32bit");
      const li = oi / 4, Di = this.get();
      if (li > Di.length)
        throw new Error("_sha2: outputLen bigger than state");
      for (let mi = 0; mi < li; mi++)
        Vn.setUint32(4 * mi, Di[mi], mn);
    }
    digest() {
      const { buffer: Je, outputLen: pr } = this;
      this.digestInto(Je);
      const Lr = Je.slice(0, pr);
      return this.destroy(), Lr;
    }
    _cloneInto(Je) {
      Je || (Je = new this.constructor()), Je.set(...this.get());
      const { blockLen: pr, buffer: Lr, length: hn, finished: mn, destroyed: qn, pos: Vn } = this;
      return Je.length = hn, Je.pos = Vn, Je.finished = mn, Je.destroyed = qn, hn % pr && Je.buffer.set(Lr), Je;
    }
  };
  const ge = (ar, Je, pr) => ar & Je ^ ~ar & pr, pe = (ar, Je, pr) => ar & Je ^ ar & pr ^ Je & pr, Ie = new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]), be = new Uint32Array([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ]), Pe = new Uint32Array(64);
  let Te = class extends le {
    constructor() {
      super(64, 32, 8, !1), this.A = be[0] | 0, this.B = be[1] | 0, this.C = be[2] | 0, this.D = be[3] | 0, this.E = be[4] | 0, this.F = be[5] | 0, this.G = be[6] | 0, this.H = be[7] | 0;
    }
    get() {
      const { A: Je, B: pr, C: Lr, D: hn, E: mn, F: qn, G: Vn, H: oi } = this;
      return [Je, pr, Lr, hn, mn, qn, Vn, oi];
    }
    // prettier-ignore
    set(Je, pr, Lr, hn, mn, qn, Vn, oi) {
      this.A = Je | 0, this.B = pr | 0, this.C = Lr | 0, this.D = hn | 0, this.E = mn | 0, this.F = qn | 0, this.G = Vn | 0, this.H = oi | 0;
    }
    process(Je, pr) {
      for (let mi = 0; mi < 16; mi++, pr += 4)
        Pe[mi] = Je.getUint32(pr, !1);
      for (let mi = 16; mi < 64; mi++) {
        const is = Pe[mi - 15], es = Pe[mi - 2], fs = C(is, 7) ^ C(is, 18) ^ is >>> 3, Yi = C(es, 17) ^ C(es, 19) ^ es >>> 10;
        Pe[mi] = Yi + Pe[mi - 7] + fs + Pe[mi - 16] | 0;
      }
      let { A: Lr, B: hn, C: mn, D: qn, E: Vn, F: oi, G: li, H: Di } = this;
      for (let mi = 0; mi < 64; mi++) {
        const is = C(Vn, 6) ^ C(Vn, 11) ^ C(Vn, 25), es = Di + is + ge(Vn, oi, li) + Ie[mi] + Pe[mi] | 0, Yi = (C(Lr, 2) ^ C(Lr, 13) ^ C(Lr, 22)) + pe(Lr, hn, mn) | 0;
        Di = li, li = oi, oi = Vn, Vn = qn + es | 0, qn = mn, mn = hn, hn = Lr, Lr = es + Yi | 0;
      }
      Lr = Lr + this.A | 0, hn = hn + this.B | 0, mn = mn + this.C | 0, qn = qn + this.D | 0, Vn = Vn + this.E | 0, oi = oi + this.F | 0, li = li + this.G | 0, Di = Di + this.H | 0, this.set(Lr, hn, mn, qn, Vn, oi, li, Di);
    }
    roundClean() {
      Pe.fill(0);
    }
    destroy() {
      this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
    }
  }, Qe = class extends Te {
    constructor() {
      super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
    }
  };
  const xe = M(() => new Te());
  M(() => new Qe());
  function Ee(ar, Je) {
    if (ar.length > Je)
      throw new TypeError(`Data is larger than array size: ${ar.length} > ${Je}`);
  }
  function He(ar) {
    if (ar.match(/[^a-fA-f0-9]/) !== null)
      throw new TypeError("Invalid characters in hex string: " + ar);
    if (ar.length % 2 !== 0)
      throw new Error(`Length of hex string is invalid: ${ar.length}`);
  }
  function ve(ar) {
    if (ar > Number.MAX_SAFE_INTEGER)
      throw new TypeError("Number exceeds safe bounds!");
  }
  const { getRandomValues: we } = crypto ?? globalThis.crypto ?? window.crypto;
  function Ce(ar = 32) {
    if (typeof we == "function")
      return crypto.getRandomValues(new Uint8Array(ar));
    throw new Error("Crypto module missing getRandomValues!");
  }
  function Se(ar, Je, pr = "be") {
    Je === void 0 && (Je = ar.length), Ee(ar, Je);
    const Lr = new Uint8Array(Je).fill(0), hn = pr === "be" ? 0 : Je - ar.length;
    return Lr.set(ar, hn), Lr;
  }
  function Ne(ar) {
    let Je, pr = 0;
    const Lr = ar.reduce((mn, qn) => mn + qn.length, 0), hn = new Uint8Array(Lr);
    for (Je = 0; Je < ar.length; Je++) {
      const mn = ar[Je];
      hn.set(mn, pr), pr += mn.length;
    }
    return hn;
  }
  const rr = new TextEncoder(), er = [
    {
      name: "base58",
      charset: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
    }
  ];
  function ir(ar) {
    for (const Je of er)
      if (Je.name === ar)
        return Je.charset;
    throw TypeError("Charset does not exist: " + ar);
  }
  function sr(ar, Je, pr = !1) {
    typeof ar == "string" && (ar = rr.encode(ar));
    const Lr = ir(Je), hn = Lr.length, mn = [];
    let qn = "", Vn, oi = 0, li, Di;
    for (Vn = 0; Vn < ar.length; Vn++)
      for (oi = 0, li = ar[Vn], qn += li > 0 || (qn.length ^ Vn) > 0 ? "" : "1"; oi in mn || li > 0; )
        Di = mn[oi], Di = Di > 0 ? Di * 256 + li : li, li = Di / hn | 0, mn[oi] = Di % hn, oi++;
    for (; oi-- > 0; )
      qn += Lr[mn[oi]];
    return pr && qn.length % 4 > 0 ? qn + "=".repeat(4 - qn.length % 4) : qn;
  }
  function nr(ar, Je) {
    const pr = ir(Je), Lr = pr.length, hn = [], mn = [];
    ar = ar.replace("=", "");
    let qn, Vn = 0, oi, li;
    for (qn = 0; qn < ar.length; qn++) {
      if (Vn = 0, oi = pr.indexOf(ar[qn]), oi < 0)
        throw new Error(`Character range out of bounds: ${oi}`);
      for (oi > 0 || (mn.length ^ qn) > 0 || mn.push(0); Vn in hn || oi > 0; )
        li = hn[Vn], li = li > 0 ? li * Lr + oi : oi, oi = li >> 8, hn[Vn] = li % 256, Vn++;
    }
    for (; Vn-- > 0; )
      mn.push(hn[Vn]);
    return new Uint8Array(mn);
  }
  function fr(ar) {
    return xe(xe(ar));
  }
  function lr(ar) {
    const Je = fr(ar);
    return Ne([ar, Je.slice(0, 4)]);
  }
  function br(ar) {
    const Je = ar.slice(0, -4), pr = ar.slice(-4);
    if (fr(Je).slice(0, 4).toString() !== pr.toString())
      throw new Error("Invalid checksum!");
    return Je;
  }
  const Br = {
    encode: sr,
    decode: nr
  }, Fr = {
    encode: (ar) => {
      const Je = lr(ar);
      return Br.encode(Je, "base58");
    },
    decode: (ar) => {
      const Je = Br.decode(ar, "base58");
      return br(Je);
    }
  }, Gr = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", qr = [996825010, 642813549, 513874426, 1027748829, 705979059], Hr = [
    { version: 0, name: "bech32", const: 1 },
    { version: 1, name: "bech32m", const: 734539939 }
  ];
  function un(ar) {
    let Je = 1;
    for (let pr = 0; pr < ar.length; ++pr) {
      const Lr = Je >> 25;
      Je = (Je & 33554431) << 5 ^ ar[pr];
      for (let hn = 0; hn < 5; ++hn)
        (Lr >> hn & 1) !== 0 && (Je ^= qr[hn]);
    }
    return Je;
  }
  function Dr(ar) {
    const Je = [];
    let pr;
    for (pr = 0; pr < ar.length; ++pr)
      Je.push(ar.charCodeAt(pr) >> 5);
    for (Je.push(0), pr = 0; pr < ar.length; ++pr)
      Je.push(ar.charCodeAt(pr) & 31);
    return Je;
  }
  function wr(ar, Je, pr) {
    const Lr = Dr(ar).concat(Je);
    return un(Lr) === pr.const;
  }
  function yr(ar, Je, pr) {
    const Lr = Dr(ar).concat(Je).concat([0, 0, 0, 0, 0, 0]), hn = un(Lr) ^ pr.const, mn = [];
    for (let qn = 0; qn < 6; ++qn)
      mn.push(hn >> 5 * (5 - qn) & 31);
    return mn;
  }
  function Qr(ar, Je, pr, Lr = !0) {
    const hn = [];
    let mn = 0, qn = 0;
    const Vn = (1 << pr) - 1, oi = (1 << Je + pr - 1) - 1;
    for (const li of ar) {
      if (li < 0 || li >> Je > 0)
        throw new Error("Failed to perform base conversion. Invalid value: " + String(li));
      for (mn = (mn << Je | li) & oi, qn += Je; qn >= pr; )
        qn -= pr, hn.push(mn >> qn & Vn);
    }
    if (Lr)
      qn > 0 && hn.push(mn << pr - qn & Vn);
    else if (qn >= Je || (mn << pr - qn & Vn) > 0)
      throw new Error("Failed to perform base conversion. Invalid Size!");
    return hn;
  }
  function _r(ar, Je, pr) {
    const Lr = Je.concat(yr(ar, Je, pr));
    let hn = ar + "1";
    for (let mn = 0; mn < Lr.length; ++mn)
      hn += Gr.charAt(Lr[mn]);
    return hn;
  }
  function Jr(ar) {
    if (!fn(ar))
      throw new Error("Encoded string goes out of bounds!");
    if (ar = ar.toLowerCase(), !jr(ar))
      throw new Error("Encoded string has invalid separator!");
    const Je = [], pr = ar.lastIndexOf("1"), Lr = ar.substring(0, pr);
    for (let mn = pr + 1; mn < ar.length; ++mn) {
      const qn = Gr.indexOf(ar.charAt(mn));
      if (qn === -1)
        throw new Error("Character idx out of bounds: " + String(mn));
      Je.push(qn);
    }
    const hn = Hr.find((mn) => mn.version === Je[0]) ?? Hr[0];
    if (!wr(Lr, Je, hn))
      throw new Error("Checksum verification failed!");
    return [Lr, Je.slice(0, Je.length - 6)];
  }
  function fn(ar) {
    let Je, pr, Lr = !1, hn = !1;
    for (Je = 0; Je < ar.length; ++Je) {
      if (pr = ar.charCodeAt(Je), pr < 33 || pr > 126)
        return !1;
      pr >= 97 && pr <= 122 && (Lr = !0), pr >= 65 && pr <= 90 && (hn = !0);
    }
    return !(Lr && hn);
  }
  function jr(ar) {
    const Je = ar.lastIndexOf("1");
    return !(Je < 1 || Je + 7 > ar.length || ar.length > 90);
  }
  function dn(ar, Je = "bc", pr = 0) {
    const Lr = [pr, ...Qr([...ar], 8, 5)], hn = Hr.find((qn) => qn.version === pr) ?? Hr[0], mn = _r(Je, Lr, hn);
    return Tn(mn), mn;
  }
  function Tn(ar) {
    ar = ar.toLowerCase();
    const Je = ar.split("1", 1)[0], [pr, Lr] = Jr(ar), hn = Qr(Lr.slice(1), 5, 8, !1), mn = hn.length;
    switch (!0) {
      case Je !== pr:
        throw new Error("Returned hrp string is invalid.");
      case (hn === null || mn < 2 || mn > 40):
        throw new Error("Decoded string is invalid or out of spec.");
      case Lr[0] > 16:
        throw new Error("Returned version bit is out of range.");
      default:
        return Uint8Array.from(hn);
    }
  }
  function Yn(ar) {
    ar = ar.toLowerCase();
    const [Je, pr] = Jr(ar);
    return pr[0];
  }
  const si = {
    encode: dn,
    decode: Tn,
    version: Yn
  }, vn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Cn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_", Xr = new TextEncoder();
  function In(ar, Je = !1, pr = !0) {
    typeof ar == "string" && (ar = Xr.encode(ar));
    const Lr = Je ? Cn : vn;
    let hn = "", mn = 0, qn = 0;
    for (let Vn = 0; Vn < ar.length; Vn++)
      for (qn = qn << 8 | ar[Vn], mn += 8; mn >= 6; )
        mn -= 6, hn += Lr[qn >> mn & 63];
    if (mn > 0)
      for (qn <<= 6 - mn, hn += Lr[qn & 63]; mn < 6; )
        hn += pr ? "=" : "", mn += 2;
    return hn;
  }
  function zr(ar, Je = !1) {
    const pr = Je || ar.includes("-") || ar.includes("_") ? Cn.split("") : vn.split("");
    ar = ar.replace(/=+$/, "");
    const Lr = ar.split("");
    let hn = 0, mn = 0;
    const qn = [];
    for (let Vn = 0; Vn < Lr.length; Vn++) {
      const oi = Lr[Vn], li = pr.indexOf(oi);
      if (li === -1)
        throw new Error("Invalid character: " + oi);
      hn += 6, mn <<= 6, mn |= li, hn >= 8 && (hn -= 8, qn.push(mn >>> hn & 255));
    }
    return new Uint8Array(qn);
  }
  const En = {
    encode: In,
    decode: zr
  }, Zr = {
    encode: (ar) => In(ar, !0, !1),
    decode: (ar) => zr(ar, !0)
  }, kr = BigInt(0), Rr = BigInt(255), Er = BigInt(256);
  function Or(ar) {
    if (ar <= 0xffn)
      return 1;
    if (ar <= 0xffffn)
      return 2;
    if (ar <= 0xffffffffn)
      return 4;
    if (ar <= 0xffffffffffffffffn)
      return 8;
    if (ar <= 0xffffffffffffffffffffffffffffffffn)
      return 16;
    if (ar <= 0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffn)
      return 32;
    throw new TypeError("Must specify a fixed buffer size for bigints greater than 32 bytes.");
  }
  function wn(ar, Je, pr = "be") {
    Je === void 0 && (Je = Or(ar));
    const Lr = pr === "le", hn = new ArrayBuffer(Je), mn = new DataView(hn);
    let qn = Lr ? 0 : Je - 1;
    for (; ar > kr; ) {
      const Vn = ar & Rr, oi = Number(Vn);
      Lr ? mn.setUint8(qn++, oi) : mn.setUint8(qn--, oi), ar = (ar - Vn) / Er;
    }
    return new Uint8Array(hn);
  }
  function Kn(ar) {
    let Je = BigInt(0);
    for (let pr = ar.length - 1; pr >= 0; pr--)
      Je = Je * Er + BigInt(ar[pr]);
    return BigInt(Je);
  }
  function Ln(ar) {
    const Je = ar.split("").map(Number);
    if (Je.length % 8 !== 0)
      throw new Error(`Binary array is invalid length: ${ar.length}`);
    const pr = new Uint8Array(Je.length / 8);
    for (let Lr = 0, hn = 0; Lr < Je.length; Lr += 8, hn++) {
      let mn = 0;
      for (let qn = 0; qn < 8; qn++)
        mn |= Je[Lr + qn] << 7 - qn;
      pr[hn] = mn;
    }
    return pr;
  }
  function Wn(ar) {
    const Je = new Array(ar.length * 8);
    let pr = 0;
    for (const Lr of ar) {
      if (Lr > 255)
        throw new Error(`Invalid byte value: ${Lr}. Byte values must be between 0 and 255.`);
      for (let hn = 7; hn >= 0; hn--, pr++)
        Je[pr] = Lr >> hn & 1;
    }
    return Je.join("");
  }
  function Sn(ar) {
    if (ar <= 255)
      return 1;
    if (ar <= 65535)
      return 2;
    if (ar <= 4294967295)
      return 4;
    throw new TypeError("Numbers larger than 4 bytes must specify a fixed size!");
  }
  function hi(ar, Je, pr = "be") {
    Je === void 0 && (Je = Sn(ar));
    const Lr = pr === "le", hn = new ArrayBuffer(Je), mn = new DataView(hn);
    let qn = Lr ? 0 : Je - 1;
    for (; ar > 0; ) {
      const Vn = ar & 255;
      Lr ? mn.setUint8(qn++, ar) : mn.setUint8(qn--, ar), ar = (ar - Vn) / 256;
    }
    return new Uint8Array(hn);
  }
  function ki(ar) {
    let Je = 0;
    for (let pr = ar.length - 1; pr >= 0; pr--)
      Je = Je * 256 + ar[pr], ve(Je);
    return Je;
  }
  const xi = new TextEncoder(), _i = new TextDecoder();
  function Li(ar) {
    return xi.encode(ar);
  }
  function ms(ar) {
    return _i.decode(ar);
  }
  function Ui(ar, Je) {
    He(ar);
    const pr = ar.length / 2;
    if (Je === void 0 && (Je = pr), pr > Je)
      throw new TypeError(`Hex string is larger than array size: ${pr} > ${Je}`);
    return Je;
  }
  function Mi(ar, Je, pr = "le") {
    Je = Ui(ar, Je);
    const Lr = pr === "le", hn = new ArrayBuffer(Je), mn = new DataView(hn);
    let qn = Lr ? 0 : Je - 1;
    for (let Vn = 0; Vn < ar.length; Vn += 2) {
      const oi = ar.substring(Vn, Vn + 2), li = parseInt(oi, 16);
      Lr ? mn.setUint8(qn++, li) : mn.setUint8(qn--, li);
    }
    return new Uint8Array(hn);
  }
  function Ls(ar) {
    let Je = "";
    for (let pr = 0; pr < ar.length; pr++)
      Je += ar[pr].toString(16).padStart(2, "0");
    return Je;
  }
  function Ds(ar) {
    const Je = JSON.stringify(ar, (pr, Lr) => typeof Lr == "bigint" ? `${Lr}n` : Lr);
    return Li(Je);
  }
  function Pr(ar, Je, pr) {
    if (ar instanceof ArrayBuffer)
      return new Uint8Array(ar);
    if (ar instanceof Uint8Array)
      return Se(ar, Je, pr);
    if (typeof ar == "string")
      return Mi(ar, Je, pr);
    if (typeof ar == "bigint")
      return wn(ar, Je, pr);
    if (typeof ar == "number")
      return hi(ar, Je, pr);
    if (typeof ar == "boolean")
      return Uint8Array.of(ar ? 1 : 0);
    throw TypeError("Unsupported format:" + typeof ar);
  }
  let vr = (ho = class extends Uint8Array {
    static random(Je = 32) {
      const pr = Ce(Je);
      return new ho(pr, Je);
    }
    constructor(Je, pr, Lr) {
      const hn = Pr(Je, pr, Lr);
      super(hn);
    }
    get arr() {
      return [...this];
    }
    get num() {
      return this.toNum();
    }
    get big() {
      return this.toBig();
    }
    get str() {
      return this.toStr();
    }
    get hex() {
      return this.toHex();
    }
    get raw() {
      return new Uint8Array(this);
    }
    get bin() {
      return this.toBin();
    }
    get b58chk() {
      return this.tob58chk();
    }
    get base64() {
      return this.toBase64();
    }
    get b64url() {
      return this.toB64url();
    }
    get digest() {
      return this.toHash();
    }
    get id() {
      return this.toHash().hex;
    }
    get stream() {
      return new pn(this);
    }
    toNum(Je = "be") {
      const pr = Je === "be" ? this.reverse() : this;
      return ki(pr);
    }
    toBin() {
      return Wn(this);
    }
    toBig(Je = "be") {
      const pr = Je === "be" ? this.reverse() : this;
      return Kn(pr);
    }
    toHash() {
      const Je = xe(this);
      return new ho(Je);
    }
    toJson() {
      const Je = ms(this);
      return JSON.parse(Je);
    }
    toBech32(Je, pr = 0) {
      return si.encode(this, Je, pr);
    }
    toStr() {
      return ms(this);
    }
    toHex() {
      return Ls(this);
    }
    toBytes() {
      return new Uint8Array(this);
    }
    tob58chk() {
      return Fr.encode(this);
    }
    toBase64() {
      return En.encode(this);
    }
    toB64url() {
      return Zr.encode(this);
    }
    prepend(Je) {
      return ho.join([ho.bytes(Je), this]);
    }
    append(Je) {
      return ho.join([this, ho.bytes(Je)]);
    }
    slice(Je, pr) {
      const Lr = new Uint8Array(this).slice(Je, pr);
      return new ho(Lr);
    }
    subarray(Je, pr) {
      const Lr = new Uint8Array(this).subarray(Je, pr);
      return new ho(Lr);
    }
    reverse() {
      const Je = new Uint8Array(this).reverse();
      return new ho(Je);
    }
    write(Je, pr) {
      const Lr = ho.bytes(Je);
      this.set(Lr, pr);
    }
    prefixSize(Je) {
      const pr = ho.varInt(this.length, Je);
      return ho.join([pr, this]);
    }
    static from(Je) {
      return new ho(Uint8Array.from(Je));
    }
    static of(...Je) {
      return new ho(Uint8Array.of(...Je));
    }
    static join(Je) {
      const pr = Je.map((hn) => ho.bytes(hn)), Lr = Ne(pr);
      return new ho(Lr);
    }
    static varInt(Je, pr) {
      if (Je < 253)
        return ho.num(Je, 1);
      if (Je < 65536)
        return ho.of(253, ...ho.num(Je, 2, pr));
      if (Je < 4294967296)
        return ho.of(254, ...ho.num(Je, 4, pr));
      if (BigInt(Je) < 0x10000000000000000n)
        return ho.of(255, ...ho.num(Je, 8, pr));
      throw new Error(`Value is too large: ${Je}`);
    }
  }, ho.num = Cr, ho.big = Pn, ho.bin = yn, ho.raw = $n, ho.str = ui, ho.hex = Ei, ho.bytes = zi, ho.json = Gi, ho.base64 = Vi, ho.b64url = Ur, ho.bech32 = $i, ho.b58chk = Es, ho.encode = Li, ho.decode = ms, ho);
  function Cr(ar, Je, pr) {
    return new vr(ar, Je, pr);
  }
  function yn(ar, Je, pr) {
    return new vr(Ln(ar), Je, pr);
  }
  function Pn(ar, Je, pr) {
    return new vr(ar, Je, pr);
  }
  function $n(ar, Je, pr) {
    return new vr(ar, Je, pr);
  }
  function ui(ar, Je, pr) {
    return new vr(Li(ar), Je, pr);
  }
  function Ei(ar, Je, pr) {
    return new vr(ar, Je, pr);
  }
  function zi(ar, Je, pr) {
    return new vr(ar, Je, pr);
  }
  function Gi(ar) {
    return new vr(Ds(ar));
  }
  function Vi(ar) {
    return new vr(En.decode(ar));
  }
  function Ur(ar) {
    return new vr(Zr.decode(ar));
  }
  function $i(ar) {
    return new vr(si.decode(ar));
  }
  function Es(ar) {
    return new vr(Fr.decode(ar));
  }
  let pn = class {
    constructor(Je) {
      this.data = vr.bytes(Je), this.size = this.data.length;
    }
    peek(Je) {
      if (Je > this.size)
        throw new Error(`Size greater than stream: ${Je} > ${this.size}`);
      return new vr(this.data.slice(0, Je));
    }
    read(Je) {
      Je = Je ?? this.readSize();
      const pr = this.peek(Je);
      return this.data = this.data.slice(Je), this.size = this.data.length, pr;
    }
    readSize(Je) {
      const pr = this.read(1).num;
      switch (!0) {
        case (pr >= 0 && pr < 253):
          return pr;
        case pr === 253:
          return this.read(2).toNum(Je);
        case pr === 254:
          return this.read(4).toNum(Je);
        case pr === 255:
          return this.read(8).toNum(Je);
        default:
          throw new Error(`Varint is out of range: ${pr}`);
      }
    }
  };
  function Nr(ar, Je) {
    const pr = vr.bytes(ar);
    if (pr.length !== Je)
      throw new Error(`Invalid input size: ${pr.hex} !== ${Je}`);
  }
  function Qn(ar, Je) {
    if (Je)
      throw new Error(ar);
    return !1;
  }
  function zn(ar, ...Je) {
    const pr = vr.str(ar).digest.raw, Lr = Je.map((hn) => vr.bytes(hn));
    return vr.join([pr, pr, vr.join(Lr)]).digest;
  }
  const ti = {
    OP_0: 0,
    OP_PUSHDATA1: 76,
    OP_PUSHDATA2: 77,
    OP_PUSHDATA4: 78,
    OP_1NEGATE: 79,
    OP_SUCCESS80: 80,
    OP_1: 81,
    OP_2: 82,
    OP_3: 83,
    OP_4: 84,
    OP_5: 85,
    OP_6: 86,
    OP_7: 87,
    OP_8: 88,
    OP_9: 89,
    OP_10: 90,
    OP_11: 91,
    OP_12: 92,
    OP_13: 93,
    OP_14: 94,
    OP_15: 95,
    OP_16: 96,
    OP_NOP: 97,
    OP_SUCCESS98: 98,
    OP_IF: 99,
    OP_NOTIF: 100,
    OP_ELSE: 103,
    OP_ENDIF: 104,
    OP_VERIFY: 105,
    OP_RETURN: 106,
    OP_TOALTSTACK: 107,
    OP_FROMALTSTACK: 108,
    OP_2DROP: 109,
    OP_2DUP: 110,
    OP_3DUP: 111,
    OP_2OVER: 112,
    OP_2ROT: 113,
    OP_2SWAP: 114,
    OP_IFDUP: 115,
    OP_DEPTH: 116,
    OP_DROP: 117,
    OP_DUP: 118,
    OP_NIP: 119,
    OP_OVER: 120,
    OP_PICK: 121,
    OP_ROLL: 122,
    OP_ROT: 123,
    OP_SWAP: 124,
    OP_TUCK: 125,
    OP_SUCCESS126: 126,
    OP_SUCCESS127: 127,
    OP_SUCCESS128: 128,
    OP_SUCCESS129: 129,
    OP_SIZE: 130,
    OP_SUCCESS131: 131,
    OP_SUCCESS132: 132,
    OP_SUCCESS133: 133,
    OP_SUCCESS134: 134,
    OP_EQUAL: 135,
    OP_EQUALVERIFY: 136,
    OP_SUCCESS137: 137,
    OP_SUCCESS138: 138,
    OP_1ADD: 139,
    OP_1SUB: 140,
    OP_SUCCESS141: 141,
    OP_SUCCESS142: 142,
    OP_NEGATE: 143,
    OP_ABS: 144,
    OP_NOT: 145,
    OP_0NOTEQUAL: 146,
    OP_ADD: 147,
    OP_SUB: 148,
    OP_SUCCESS149: 149,
    OP_SUCCESS150: 150,
    OP_SUCCESS151: 151,
    OP_SUCCESS152: 152,
    OP_SUCCESS153: 153,
    OP_BOOLAND: 154,
    OP_BOOLOR: 155,
    OP_NUMEQUAL: 156,
    OP_NUMEQUALVERIFY: 157,
    OP_NUMNOTEQUAL: 158,
    OP_LESSTHAN: 159,
    OP_GREATERTHAN: 160,
    OP_LESSTHANOREQUAL: 161,
    OP_GREATERTHANOREQUAL: 162,
    OP_MIN: 163,
    OP_MAX: 164,
    OP_WITHIN: 165,
    OP_RIPEMD160: 166,
    OP_SHA1: 167,
    OP_SHA256: 168,
    OP_HASH160: 169,
    OP_HASH256: 170,
    OP_CODESEPARATOR: 171,
    OP_CHECKSIG: 172,
    OP_CHECKSIGVERIFY: 173,
    OP_CHECKMULTISIG: 174,
    OP_CHECKMULTISIGVERIFY: 175,
    OP_NOP1: 176,
    OP_CHECKLOCKTIMEVERIFY: 177,
    OP_CHECKSEQUENCEVERIFY: 178,
    OP_NOP4: 179,
    OP_NOP5: 180,
    OP_NOP6: 181,
    OP_NOP7: 182,
    OP_NOP8: 183,
    OP_NOP9: 184,
    OP_NOP10: 185,
    OP_CHECKSIGADD: 186,
    OP_SUCCESS187: 187,
    OP_SUCCESS188: 188,
    OP_SUCCESS189: 189,
    OP_SUCCESS190: 190,
    OP_SUCCESS191: 191,
    OP_SUCCESS192: 192,
    OP_SUCCESS193: 193,
    OP_SUCCESS194: 194,
    OP_SUCCESS195: 195,
    OP_SUCCESS196: 196,
    OP_SUCCESS197: 197,
    OP_SUCCESS198: 198,
    OP_SUCCESS199: 199,
    OP_SUCCESS200: 200,
    OP_SUCCESS201: 201,
    OP_SUCCESS202: 202,
    OP_SUCCESS203: 203,
    OP_SUCCESS204: 204,
    OP_SUCCESS205: 205,
    OP_SUCCESS206: 206,
    OP_SUCCESS207: 207,
    OP_SUCCESS208: 208,
    OP_SUCCESS209: 209,
    OP_SUCCESS210: 210,
    OP_SUCCESS211: 211,
    OP_SUCCESS212: 212,
    OP_SUCCESS213: 213,
    OP_SUCCESS214: 214,
    OP_SUCCESS215: 215,
    OP_SUCCESS216: 216,
    OP_SUCCESS217: 217,
    OP_SUCCESS218: 218,
    OP_SUCCESS219: 219,
    OP_SUCCESS220: 220,
    OP_SUCCESS221: 221,
    OP_SUCCESS222: 222,
    OP_SUCCESS223: 223,
    OP_SUCCESS224: 224,
    OP_SUCCESS225: 225,
    OP_SUCCESS226: 226,
    OP_SUCCESS227: 227,
    OP_SUCCESS228: 228,
    OP_SUCCESS229: 229,
    OP_SUCCESS230: 230,
    OP_SUCCESS231: 231,
    OP_SUCCESS232: 232,
    OP_SUCCESS233: 233,
    OP_SUCCESS234: 234,
    OP_SUCCESS235: 235,
    OP_SUCCESS236: 236,
    OP_SUCCESS237: 237,
    OP_SUCCESS238: 238,
    OP_SUCCESS239: 239,
    OP_SUCCESS240: 240,
    OP_SUCCESS241: 241,
    OP_SUCCESS242: 242,
    OP_SUCCESS243: 243,
    OP_SUCCESS244: 244,
    OP_SUCCESS245: 245,
    OP_SUCCESS246: 246,
    OP_SUCCESS247: 247,
    OP_SUCCESS248: 248,
    OP_SUCCESS249: 249,
    OP_SUCCESS250: 250,
    OP_SUCCESS251: 251,
    OP_SUCCESS252: 252,
    OP_SUCCESS253: 253,
    OP_SUCCESS254: 254
  };
  function v(ar) {
    if (ar > 186 && ar < 255)
      return "OP_SUCCESS" + String(ar);
    for (const [Je, pr] of Object.entries(ti))
      if (pr === ar)
        return Je;
    throw new Error("OPCODE not found:" + String(ar));
  }
  function d(ar) {
    for (const [Je, pr] of Object.entries(ti))
      if (Je === ar)
        return Number(pr);
    throw new Error("OPCODE not found:" + ar);
  }
  function I(ar) {
    switch (!0) {
      case ar === 0:
        return "opcode";
      case (ar >= 1 && ar <= 75):
        return "varint";
      case ar === 76:
        return "pushdata1";
      case ar === 77:
        return "pushdata2";
      case ar === 78:
        return "pushdata4";
      case ar <= 254:
        return "opcode";
      default:
        throw new Error(`Invalid word range: ${ar}`);
    }
  }
  function n(ar) {
    const Lr = [];
    switch (!0) {
      case typeof ar != "number":
        return !1;
      case ar === 0:
        return !0;
      case Lr.includes(ar):
        return !1;
      case (75 < ar && ar < 254):
        return !0;
      default:
        return !1;
    }
  }
  function a(ar) {
    return typeof ar == "string" && ar.length % 2 === 0 && /[0-9a-fA-F]/.test(ar);
  }
  function E(ar) {
    return a(ar) || ar instanceof Uint8Array;
  }
  const T = 520;
  function L(ar = [], Je = !0) {
    let pr = vr.num(0);
    return Array.isArray(ar) && (pr = vr.raw(he(ar))), a(ar) && (pr = vr.hex(ar)), ar instanceof Uint8Array && (pr = vr.raw(ar)), Je && (pr = pr.prefixSize("le")), pr;
  }
  function he(ar) {
    const Je = [];
    for (const pr of ar)
      Je.push(Be(pr));
    return Je.length > 0 ? vr.join(Je) : new Uint8Array();
  }
  function Be(ar) {
    let Je = new Uint8Array();
    if (typeof ar == "string") {
      if (ar.startsWith("OP_"))
        return vr.num(d(ar), 1);
      a(ar) ? Je = vr.hex(ar) : Je = vr.str(ar);
    } else
      Je = vr.bytes(ar);
    if (Je.length === 1)
      return Je[0] !== 0 && Je[0] <= 16 ? (Je[0] += 80, Je) : (Je[0] > 128 && Je[0] <= 255 && (Je = new Uint8Array([Je[0], 0])), vr.join([Me(Je.length), Je]));
    if (Je.length > T) {
      const pr = tr(Je);
      return he(pr);
    } else
      return vr.join([Me(Je.length), Je]);
  }
  function Me(ar) {
    const Je = vr.num(76, 1), pr = vr.num(77, 1);
    switch (!0) {
      case ar <= 75:
        return vr.num(ar);
      case (ar > 75 && ar < 256):
        return vr.join([Je, vr.num(ar, 1, "le")]);
      case (ar >= 256 && ar <= T):
        return vr.join([pr, vr.num(ar, 2, "le")]);
      default:
        throw new Error("Invalid word size:" + ar.toString());
    }
  }
  function tr(ar) {
    const Je = [], pr = new pn(ar);
    for (; pr.size > T; )
      Je.push(pr.read(T));
    return Je.push(pr.read(pr.size)), Je;
  }
  function or(ar, Je = !1) {
    let pr = vr.bytes(ar);
    if (Je) {
      const hn = pr.stream.readSize("le");
      if (pr = pr.slice(1), pr.length !== hn)
        throw new Error(`Varint does not match stream size: ${hn} !== ${pr.length}`);
    }
    return cr(pr);
  }
  function cr(ar) {
    const Je = new pn(ar), pr = [], Lr = Je.size;
    let hn, mn, qn, Vn = 0;
    for (; Vn < Lr; )
      switch (hn = Je.read(1).num, mn = I(hn), Vn++, mn) {
        case "varint":
          pr.push(Je.read(hn).hex), Vn += hn;
          break;
        case "pushdata1":
          qn = Je.read(1).reverse().num, pr.push(Je.read(qn).hex), Vn += qn + 1;
          break;
        case "pushdata2":
          qn = Je.read(2).reverse().num, pr.push(Je.read(qn).hex), Vn += qn + 2;
          break;
        case "pushdata4":
          qn = Je.read(4).reverse().num, pr.push(Je.read(qn).hex), Vn += qn + 4;
          break;
        case "opcode":
          if (!n(hn))
            throw new Error(`Invalid OPCODE: ${hn}`);
          pr.push(v(hn));
          break;
        default:
          throw new Error(`Word type undefined: ${hn}`);
      }
    return pr;
  }
  function dr(ar, Je) {
    if (Array.isArray(ar) && (ar = L(ar, Je)), ar instanceof Uint8Array || a(ar))
      return or(ar, Je);
    throw new Error("Invalid format: " + typeof ar);
  }
  function gr(ar, Je) {
    if ((ar instanceof Uint8Array || a(ar)) && (ar = or(ar, Je)), Array.isArray(ar))
      return L(ar, Je);
    throw new Error("Invalid format: " + typeof ar);
  }
  function Ir(ar) {
    if (!Array.isArray(ar))
      return vr.bytes(ar);
    throw new Error("Invalid format: " + typeof ar);
  }
  const Mr = {
    encode: L,
    decode: or,
    fmt: {
      toAsm: dr,
      toBytes: gr,
      toParam: Ir
    }
  };
  function Wr(ar) {
    if (!Number.isSafeInteger(ar) || ar < 0)
      throw new Error(`Wrong positive integer: ${ar}`);
  }
  function $r(ar) {
    if (typeof ar != "boolean")
      throw new Error(`Expected boolean, not ${ar}`);
  }
  function gn(ar, ...Je) {
    if (!(ar instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (Je.length > 0 && !Je.includes(ar.length))
      throw new TypeError(`Expected Uint8Array of length ${Je}, not of length=${ar.length}`);
  }
  function Bn(ar) {
    if (typeof ar != "function" || typeof ar.create != "function")
      throw new Error("Hash should be wrapped by utils.wrapConstructor");
    Wr(ar.outputLen), Wr(ar.blockLen);
  }
  function kn(ar, Je = !0) {
    if (ar.destroyed)
      throw new Error("Hash instance has been destroyed");
    if (Je && ar.finished)
      throw new Error("Hash#digest() has already been called");
  }
  function xn(ar, Je) {
    gn(ar);
    const pr = Je.outputLen;
    if (ar.length < pr)
      throw new Error(`digestInto() expects output buffer of length at least ${pr}`);
  }
  var Gn = {
    number: Wr,
    bool: $r,
    bytes: gn,
    hash: Bn,
    exists: kn,
    output: xn
  };
  const jn = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
  const Xn = (ar) => new DataView(ar.buffer, ar.byteOffset, ar.byteLength), Zn = (ar, Je) => ar << 32 - Je | ar >>> Je;
  if (!(new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68))
    throw new Error("Non little-endian hardware is not supported");
  Array.from({ length: 256 }, (ar, Je) => Je.toString(16).padStart(2, "0"));
  function ai(ar) {
    if (typeof ar != "string")
      throw new TypeError(`utf8ToBytes expected string, got ${typeof ar}`);
    return new TextEncoder().encode(ar);
  }
  function fi(ar) {
    if (typeof ar == "string" && (ar = ai(ar)), !(ar instanceof Uint8Array))
      throw new TypeError(`Expected input type is Uint8Array (got ${typeof ar})`);
    return ar;
  }
  function Ai(...ar) {
    if (!ar.every((Lr) => Lr instanceof Uint8Array))
      throw new Error("Uint8Array list expected");
    if (ar.length === 1)
      return ar[0];
    const Je = ar.reduce((Lr, hn) => Lr + hn.length, 0), pr = new Uint8Array(Je);
    for (let Lr = 0, hn = 0; Lr < ar.length; Lr++) {
      const mn = ar[Lr];
      pr.set(mn, hn), hn += mn.length;
    }
    return pr;
  }
  let yi = class {
    // Safe version that clones internal state
    clone() {
      return this._cloneInto();
    }
  };
  function Ii(ar) {
    const Je = (Lr) => ar().update(fi(Lr)).digest(), pr = ar();
    return Je.outputLen = pr.outputLen, Je.blockLen = pr.blockLen, Je.create = () => ar(), Je;
  }
  function wi(ar = 32) {
    if (jn && typeof jn.getRandomValues == "function")
      return jn.getRandomValues(new Uint8Array(ar));
    throw new Error("crypto.getRandomValues must be defined");
  }
  function Bi(ar, Je, pr, Lr) {
    if (typeof ar.setBigUint64 == "function")
      return ar.setBigUint64(Je, pr, Lr);
    const hn = BigInt(32), mn = BigInt(4294967295), qn = Number(pr >> hn & mn), Vn = Number(pr & mn), oi = Lr ? 4 : 0, li = Lr ? 0 : 4;
    ar.setUint32(Je + oi, qn, Lr), ar.setUint32(Je + li, Vn, Lr);
  }
  let Ti = class extends yi {
    constructor(Je, pr, Lr, hn) {
      super(), this.blockLen = Je, this.outputLen = pr, this.padOffset = Lr, this.isLE = hn, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(Je), this.view = Xn(this.buffer);
    }
    update(Je) {
      Gn.exists(this);
      const { view: pr, buffer: Lr, blockLen: hn } = this;
      Je = fi(Je);
      const mn = Je.length;
      for (let qn = 0; qn < mn; ) {
        const Vn = Math.min(hn - this.pos, mn - qn);
        if (Vn === hn) {
          const oi = Xn(Je);
          for (; hn <= mn - qn; qn += hn)
            this.process(oi, qn);
          continue;
        }
        Lr.set(Je.subarray(qn, qn + Vn), this.pos), this.pos += Vn, qn += Vn, this.pos === hn && (this.process(pr, 0), this.pos = 0);
      }
      return this.length += Je.length, this.roundClean(), this;
    }
    digestInto(Je) {
      Gn.exists(this), Gn.output(Je, this), this.finished = !0;
      const { buffer: pr, view: Lr, blockLen: hn, isLE: mn } = this;
      let { pos: qn } = this;
      pr[qn++] = 128, this.buffer.subarray(qn).fill(0), this.padOffset > hn - qn && (this.process(Lr, 0), qn = 0);
      for (let mi = qn; mi < hn; mi++)
        pr[mi] = 0;
      Bi(Lr, hn - 8, BigInt(this.length * 8), mn), this.process(Lr, 0);
      const Vn = Xn(Je), oi = this.outputLen;
      if (oi % 4)
        throw new Error("_sha2: outputLen should be aligned to 32bit");
      const li = oi / 4, Di = this.get();
      if (li > Di.length)
        throw new Error("_sha2: outputLen bigger than state");
      for (let mi = 0; mi < li; mi++)
        Vn.setUint32(4 * mi, Di[mi], mn);
    }
    digest() {
      const { buffer: Je, outputLen: pr } = this;
      this.digestInto(Je);
      const Lr = Je.slice(0, pr);
      return this.destroy(), Lr;
    }
    _cloneInto(Je) {
      Je || (Je = new this.constructor()), Je.set(...this.get());
      const { blockLen: pr, buffer: Lr, length: hn, finished: mn, destroyed: qn, pos: Vn } = this;
      return Je.length = hn, Je.pos = Vn, Je.finished = mn, Je.destroyed = qn, hn % pr && Je.buffer.set(Lr), Je;
    }
  };
  const Oi = (ar, Je, pr) => ar & Je ^ ~ar & pr, Hi = (ar, Je, pr) => ar & Je ^ ar & pr ^ Je & pr, Xi = new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]), Zi = new Uint32Array([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ]), ts = new Uint32Array(64);
  let us = class extends Ti {
    constructor() {
      super(64, 32, 8, !1), this.A = Zi[0] | 0, this.B = Zi[1] | 0, this.C = Zi[2] | 0, this.D = Zi[3] | 0, this.E = Zi[4] | 0, this.F = Zi[5] | 0, this.G = Zi[6] | 0, this.H = Zi[7] | 0;
    }
    get() {
      const { A: Je, B: pr, C: Lr, D: hn, E: mn, F: qn, G: Vn, H: oi } = this;
      return [Je, pr, Lr, hn, mn, qn, Vn, oi];
    }
    // prettier-ignore
    set(Je, pr, Lr, hn, mn, qn, Vn, oi) {
      this.A = Je | 0, this.B = pr | 0, this.C = Lr | 0, this.D = hn | 0, this.E = mn | 0, this.F = qn | 0, this.G = Vn | 0, this.H = oi | 0;
    }
    process(Je, pr) {
      for (let mi = 0; mi < 16; mi++, pr += 4)
        ts[mi] = Je.getUint32(pr, !1);
      for (let mi = 16; mi < 64; mi++) {
        const is = ts[mi - 15], es = ts[mi - 2], fs = Zn(is, 7) ^ Zn(is, 18) ^ is >>> 3, Yi = Zn(es, 17) ^ Zn(es, 19) ^ es >>> 10;
        ts[mi] = Yi + ts[mi - 7] + fs + ts[mi - 16] | 0;
      }
      let { A: Lr, B: hn, C: mn, D: qn, E: Vn, F: oi, G: li, H: Di } = this;
      for (let mi = 0; mi < 64; mi++) {
        const is = Zn(Vn, 6) ^ Zn(Vn, 11) ^ Zn(Vn, 25), es = Di + is + Oi(Vn, oi, li) + Xi[mi] + ts[mi] | 0, Yi = (Zn(Lr, 2) ^ Zn(Lr, 13) ^ Zn(Lr, 22)) + Hi(Lr, hn, mn) | 0;
        Di = li, li = oi, oi = Vn, Vn = qn + es | 0, qn = mn, mn = hn, hn = Lr, Lr = es + Yi | 0;
      }
      Lr = Lr + this.A | 0, hn = hn + this.B | 0, mn = mn + this.C | 0, qn = qn + this.D | 0, Vn = Vn + this.E | 0, oi = oi + this.F | 0, li = li + this.G | 0, Di = Di + this.H | 0, this.set(Lr, hn, mn, qn, Vn, oi, li, Di);
    }
    roundClean() {
      ts.fill(0);
    }
    destroy() {
      this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
    }
  }, hs = class extends us {
    constructor() {
      super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
    }
  };
  const ws = Ii(() => new us());
  Ii(() => new hs());
  const ks = BigInt(0), Bs = BigInt(1), gs = BigInt(2), ps = (ar) => ar instanceof Uint8Array, zs = Array.from({ length: 256 }, (ar, Je) => Je.toString(16).padStart(2, "0"));
  function Gs(ar) {
    if (!ps(ar))
      throw new Error("Uint8Array expected");
    let Je = "";
    for (let pr = 0; pr < ar.length; pr++)
      Je += zs[ar[pr]];
    return Je;
  }
  function to(ar) {
    const Je = ar.toString(16);
    return Je.length & 1 ? `0${Je}` : Je;
  }
  function ro(ar) {
    if (typeof ar != "string")
      throw new Error("hex string expected, got " + typeof ar);
    return BigInt(ar === "" ? "0" : `0x${ar}`);
  }
  function $s(ar) {
    if (typeof ar != "string")
      throw new Error("hex string expected, got " + typeof ar);
    if (ar.length % 2)
      throw new Error("hex string is invalid: unpadded " + ar.length);
    const Je = new Uint8Array(ar.length / 2);
    for (let pr = 0; pr < Je.length; pr++) {
      const Lr = pr * 2, hn = ar.slice(Lr, Lr + 2), mn = Number.parseInt(hn, 16);
      if (Number.isNaN(mn) || mn < 0)
        throw new Error("invalid byte sequence");
      Je[pr] = mn;
    }
    return Je;
  }
  function Xs(ar) {
    return ro(Gs(ar));
  }
  function Ao(ar) {
    if (!ps(ar))
      throw new Error("Uint8Array expected");
    return ro(Gs(Uint8Array.from(ar).reverse()));
  }
  const co = (ar, Je) => $s(ar.toString(16).padStart(Je * 2, "0")), Co = (ar, Je) => co(ar, Je).reverse(), wo = (ar) => $s(to(ar));
  function fo(ar, Je, pr) {
    let Lr;
    if (typeof Je == "string")
      try {
        Lr = $s(Je);
      } catch (mn) {
        throw new Error(`${ar} must be valid hex string, got "${Je}". Cause: ${mn}`);
      }
    else if (ps(Je))
      Lr = Uint8Array.from(Je);
    else
      throw new Error(`${ar} must be hex string or Uint8Array`);
    const hn = Lr.length;
    if (typeof pr == "number" && hn !== pr)
      throw new Error(`${ar} expected ${pr} bytes, got ${hn}`);
    return Lr;
  }
  function pi(...ar) {
    const Je = new Uint8Array(ar.reduce((Lr, hn) => Lr + hn.length, 0));
    let pr = 0;
    return ar.forEach((Lr) => {
      if (!ps(Lr))
        throw new Error("Uint8Array expected");
      Je.set(Lr, pr), pr += Lr.length;
    }), Je;
  }
  function bi(ar, Je) {
    if (ar.length !== Je.length)
      return !1;
    for (let pr = 0; pr < ar.length; pr++)
      if (ar[pr] !== Je[pr])
        return !1;
    return !0;
  }
  function Ni(ar) {
    if (typeof ar != "string")
      throw new Error(`utf8ToBytes expected string, got ${typeof ar}`);
    return new TextEncoder().encode(ar);
  }
  function Wi(ar) {
    let Je;
    for (Je = 0; ar > 0n; ar >>= Bs, Je += 1)
      ;
    return Je;
  }
  const ns = (ar, Je) => ar >> BigInt(Je) & 1n, ji = (ar, Je, pr) => ar | (pr ? Bs : ks) << BigInt(Je), rs = (ar) => (gs << BigInt(ar - 1)) - Bs, Is = (ar) => new Uint8Array(ar), ds = (ar) => Uint8Array.from(ar);
  function bo(ar, Je, pr) {
    if (typeof ar != "number" || ar < 2)
      throw new Error("hashLen must be a number");
    if (typeof Je != "number" || Je < 2)
      throw new Error("qByteLen must be a number");
    if (typeof pr != "function")
      throw new Error("hmacFn must be a function");
    let Lr = Is(ar), hn = Is(ar), mn = 0;
    const qn = () => {
      Lr.fill(1), hn.fill(0), mn = 0;
    }, Vn = (...mi) => pr(hn, Lr, ...mi), oi = (mi = Is()) => {
      hn = Vn(ds([0]), mi), Lr = Vn(), mi.length !== 0 && (hn = Vn(ds([1]), mi), Lr = Vn());
    }, li = () => {
      if (mn++ >= 1e3)
        throw new Error("drbg: tried 1000 values");
      let mi = 0;
      const is = [];
      for (; mi < Je; ) {
        Lr = Vn();
        const es = Lr.slice();
        is.push(es), mi += Lr.length;
      }
      return pi(...is);
    };
    return (mi, is) => {
      qn(), oi(mi);
      let es;
      for (; !(es = is(li())); )
        oi();
      return qn(), es;
    };
  }
  const Uo = {
    bigint: (ar) => typeof ar == "bigint",
    function: (ar) => typeof ar == "function",
    boolean: (ar) => typeof ar == "boolean",
    string: (ar) => typeof ar == "string",
    isSafeInteger: (ar) => Number.isSafeInteger(ar),
    array: (ar) => Array.isArray(ar),
    field: (ar, Je) => Je.Fp.isValid(ar),
    hash: (ar) => typeof ar == "function" && Number.isSafeInteger(ar.outputLen)
  };
  function Ho(ar, Je, pr = {}) {
    const Lr = (hn, mn, qn) => {
      const Vn = Uo[mn];
      if (typeof Vn != "function")
        throw new Error(`Invalid validator "${mn}", expected function`);
      const oi = ar[hn];
      if (!(qn && oi === void 0) && !Vn(oi, ar))
        throw new Error(`Invalid param ${String(hn)}=${oi} (${typeof oi}), expected ${mn}`);
    };
    for (const [hn, mn] of Object.entries(Je))
      Lr(hn, mn, !1);
    for (const [hn, mn] of Object.entries(pr))
      Lr(hn, mn, !0);
    return ar;
  }
  var Ro = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    bitGet: ns,
    bitLen: Wi,
    bitMask: rs,
    bitSet: ji,
    bytesToHex: Gs,
    bytesToNumberBE: Xs,
    bytesToNumberLE: Ao,
    concatBytes: pi,
    createHmacDrbg: bo,
    ensureBytes: fo,
    equalBytes: bi,
    hexToBytes: $s,
    hexToNumber: ro,
    numberToBytesBE: co,
    numberToBytesLE: Co,
    numberToHexUnpadded: to,
    numberToVarBytesBE: wo,
    utf8ToBytes: Ni,
    validateObject: Ho
  });
  const vo = BigInt(0), js = BigInt(1), jo = BigInt(2), za = BigInt(3), ya = BigInt(4), ri = BigInt(5), io = BigInt(8);
  BigInt(9), BigInt(16);
  function Vo(ar, Je) {
    const pr = ar % Je;
    return pr >= vo ? pr : Je + pr;
  }
  function Sa(ar, Je, pr) {
    if (pr <= vo || Je < vo)
      throw new Error("Expected power/modulo > 0");
    if (pr === js)
      return vo;
    let Lr = js;
    for (; Je > vo; )
      Je & js && (Lr = Lr * ar % pr), ar = ar * ar % pr, Je >>= js;
    return Lr;
  }
  function qo(ar, Je, pr) {
    let Lr = ar;
    for (; Je-- > vo; )
      Lr *= Lr, Lr %= pr;
    return Lr;
  }
  function Us(ar, Je) {
    if (ar === vo || Je <= vo)
      throw new Error(`invert: expected positive integers, got n=${ar} mod=${Je}`);
    let pr = Vo(ar, Je), Lr = Je, hn = vo, mn = js;
    for (; pr !== vo; ) {
      const Vn = Lr / pr, oi = Lr % pr, li = hn - mn * Vn;
      Lr = pr, pr = oi, hn = mn, mn = li;
    }
    if (Lr !== js)
      throw new Error("invert: does not exist");
    return Vo(hn, Je);
  }
  function au(ar) {
    const Je = (ar - js) / jo;
    let pr, Lr, hn;
    for (pr = ar - js, Lr = 0; pr % jo === vo; pr /= jo, Lr++)
      ;
    for (hn = jo; hn < ar && Sa(hn, Je, ar) !== ar - js; hn++)
      ;
    if (Lr === 1) {
      const qn = (ar + js) / ya;
      return function(oi, li) {
        const Di = oi.pow(li, qn);
        if (!oi.eql(oi.sqr(Di), li))
          throw new Error("Cannot find square root");
        return Di;
      };
    }
    const mn = (pr + js) / jo;
    return function(Vn, oi) {
      if (Vn.pow(oi, Je) === Vn.neg(Vn.ONE))
        throw new Error("Cannot find square root");
      let li = Lr, Di = Vn.pow(Vn.mul(Vn.ONE, hn), pr), mi = Vn.pow(oi, mn), is = Vn.pow(oi, pr);
      for (; !Vn.eql(is, Vn.ONE); ) {
        if (Vn.eql(is, Vn.ZERO))
          return Vn.ZERO;
        let es = 1;
        for (let Yi = Vn.sqr(is); es < li && !Vn.eql(Yi, Vn.ONE); es++)
          Yi = Vn.sqr(Yi);
        const fs = Vn.pow(Di, js << BigInt(li - es - 1));
        Di = Vn.sqr(fs), mi = Vn.mul(mi, fs), is = Vn.mul(is, Di), li = es;
      }
      return mi;
    };
  }
  function Ja(ar) {
    if (ar % ya === za) {
      const Je = (ar + js) / ya;
      return function(Lr, hn) {
        const mn = Lr.pow(hn, Je);
        if (!Lr.eql(Lr.sqr(mn), hn))
          throw new Error("Cannot find square root");
        return mn;
      };
    }
    if (ar % io === ri) {
      const Je = (ar - ri) / io;
      return function(Lr, hn) {
        const mn = Lr.mul(hn, jo), qn = Lr.pow(mn, Je), Vn = Lr.mul(hn, qn), oi = Lr.mul(Lr.mul(Vn, jo), qn), li = Lr.mul(Vn, Lr.sub(oi, Lr.ONE));
        if (!Lr.eql(Lr.sqr(li), hn))
          throw new Error("Cannot find square root");
        return li;
      };
    }
    return au(ar);
  }
  const $ = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
  ];
  function Vs(ar) {
    const Je = {
      ORDER: "bigint",
      MASK: "bigint",
      BYTES: "isSafeInteger",
      BITS: "isSafeInteger"
    }, pr = $.reduce((Lr, hn) => (Lr[hn] = "function", Lr), Je);
    return Ho(ar, pr);
  }
  function e(ar, Je, pr) {
    if (pr < vo)
      throw new Error("Expected power > 0");
    if (pr === vo)
      return ar.ONE;
    if (pr === js)
      return Je;
    let Lr = ar.ONE, hn = Je;
    for (; pr > vo; )
      pr & js && (Lr = ar.mul(Lr, hn)), hn = ar.sqr(hn), pr >>= js;
    return Lr;
  }
  function ye(ar, Je) {
    const pr = new Array(Je.length), Lr = Je.reduce((mn, qn, Vn) => ar.is0(qn) ? mn : (pr[Vn] = mn, ar.mul(mn, qn)), ar.ONE), hn = ar.inv(Lr);
    return Je.reduceRight((mn, qn, Vn) => ar.is0(qn) ? mn : (pr[Vn] = ar.mul(mn, pr[Vn]), ar.mul(mn, qn)), hn), pr;
  }
  function fa(ar, Je) {
    const pr = Je !== void 0 ? Je : ar.toString(2).length, Lr = Math.ceil(pr / 8);
    return { nBitLength: pr, nByteLength: Lr };
  }
  function Ps(ar, Je, pr = !1, Lr = {}) {
    if (ar <= vo)
      throw new Error(`Expected Fp ORDER > 0, got ${ar}`);
    const { nBitLength: hn, nByteLength: mn } = fa(ar, Je);
    if (mn > 2048)
      throw new Error("Field lengths over 2048 bytes are not supported");
    const qn = Ja(ar), Vn = Object.freeze({
      ORDER: ar,
      BITS: hn,
      BYTES: mn,
      MASK: rs(hn),
      ZERO: vo,
      ONE: js,
      create: (oi) => Vo(oi, ar),
      isValid: (oi) => {
        if (typeof oi != "bigint")
          throw new Error(`Invalid field element: expected bigint, got ${typeof oi}`);
        return vo <= oi && oi < ar;
      },
      is0: (oi) => oi === vo,
      isOdd: (oi) => (oi & js) === js,
      neg: (oi) => Vo(-oi, ar),
      eql: (oi, li) => oi === li,
      sqr: (oi) => Vo(oi * oi, ar),
      add: (oi, li) => Vo(oi + li, ar),
      sub: (oi, li) => Vo(oi - li, ar),
      mul: (oi, li) => Vo(oi * li, ar),
      pow: (oi, li) => e(Vn, oi, li),
      div: (oi, li) => Vo(oi * Us(li, ar), ar),
      // Same as above, but doesn't normalize
      sqrN: (oi) => oi * oi,
      addN: (oi, li) => oi + li,
      subN: (oi, li) => oi - li,
      mulN: (oi, li) => oi * li,
      inv: (oi) => Us(oi, ar),
      sqrt: Lr.sqrt || ((oi) => qn(Vn, oi)),
      invertBatch: (oi) => ye(Vn, oi),
      // TODO: do we really need constant cmov?
      // We don't have const-time bigints anyway, so probably will be not very useful
      cmov: (oi, li, Di) => Di ? li : oi,
      toBytes: (oi) => pr ? Co(oi, mn) : co(oi, mn),
      fromBytes: (oi) => {
        if (oi.length !== mn)
          throw new Error(`Fp.fromBytes: expected ${mn}, got ${oi.length}`);
        return pr ? Ao(oi) : Xs(oi);
      }
    });
    return Object.freeze(Vn);
  }
  function ef(ar, Je, pr = !1) {
    ar = fo("privateHash", ar);
    const Lr = ar.length, hn = fa(Je).nByteLength + 8;
    if (hn < 24 || Lr < hn || Lr > 1024)
      throw new Error(`hashToPrivateScalar: expected ${hn}-1024 bytes of input, got ${Lr}`);
    const mn = pr ? Ao(ar) : Xs(ar);
    return Vo(mn, Je - js) + js;
  }
  const Fi = BigInt(0), vi = BigInt(1);
  function la(ar, Je) {
    const pr = (hn, mn) => {
      const qn = mn.negate();
      return hn ? qn : mn;
    }, Lr = (hn) => {
      const mn = Math.ceil(Je / hn) + 1, qn = 2 ** (hn - 1);
      return { windows: mn, windowSize: qn };
    };
    return {
      constTimeNegate: pr,
      // non-const time multiplication ladder
      unsafeLadder(hn, mn) {
        let qn = ar.ZERO, Vn = hn;
        for (; mn > Fi; )
          mn & vi && (qn = qn.add(Vn)), Vn = Vn.double(), mn >>= vi;
        return qn;
      },
      /**
       * Creates a wNAF precomputation window. Used for caching.
       * Default window size is set by `utils.precompute()` and is equal to 8.
       * Number of precomputed points depends on the curve size:
       * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
       * - 𝑊 is the window size
       * - 𝑛 is the bitlength of the curve order.
       * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
       * @returns precomputed point tables flattened to a single array
       */
      precomputeWindow(hn, mn) {
        const { windows: qn, windowSize: Vn } = Lr(mn), oi = [];
        let li = hn, Di = li;
        for (let mi = 0; mi < qn; mi++) {
          Di = li, oi.push(Di);
          for (let is = 1; is < Vn; is++)
            Di = Di.add(li), oi.push(Di);
          li = Di.double();
        }
        return oi;
      },
      /**
       * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
       * @param W window size
       * @param precomputes precomputed tables
       * @param n scalar (we don't check here, but should be less than curve order)
       * @returns real and fake (for const-time) points
       */
      wNAF(hn, mn, qn) {
        const { windows: Vn, windowSize: oi } = Lr(hn);
        let li = ar.ZERO, Di = ar.BASE;
        const mi = BigInt(2 ** hn - 1), is = 2 ** hn, es = BigInt(hn);
        for (let fs = 0; fs < Vn; fs++) {
          const Yi = fs * oi;
          let os = Number(qn & mi);
          qn >>= es, os > oi && (os -= is, qn += vi);
          const ls = Yi, Cs = Yi + Math.abs(os) - 1, bs = fs % 2 !== 0, Zs = os < 0;
          os === 0 ? Di = Di.add(pr(bs, mn[ls])) : li = li.add(pr(Zs, mn[Cs]));
        }
        return { p: li, f: Di };
      },
      wNAFCached(hn, mn, qn, Vn) {
        const oi = hn._WINDOW_SIZE || 1;
        let li = mn.get(hn);
        return li || (li = this.precomputeWindow(hn, oi), oi !== 1 && mn.set(hn, Vn(li))), this.wNAF(oi, li, qn);
      }
    };
  }
  function Fd(ar) {
    return Vs(ar.Fp), Ho(ar, {
      n: "bigint",
      h: "bigint",
      Gx: "field",
      Gy: "field"
    }, {
      nBitLength: "isSafeInteger",
      nByteLength: "isSafeInteger"
    }), Object.freeze({
      ...fa(ar.n, ar.nBitLength),
      ...ar,
      p: ar.Fp.ORDER
    });
  }
  function Do(ar) {
    const Je = Fd(ar);
    Ho(Je, {
      a: "field",
      b: "field"
    }, {
      allowedPrivateKeyLengths: "array",
      wrapPrivateKey: "boolean",
      isTorsionFree: "function",
      clearCofactor: "function",
      allowInfinityPoint: "boolean",
      fromBytes: "function",
      toBytes: "function"
    });
    const { endo: pr, Fp: Lr, a: hn } = Je;
    if (pr) {
      if (!Lr.eql(hn, Lr.ZERO))
        throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
      if (typeof pr != "object" || typeof pr.beta != "bigint" || typeof pr.splitScalar != "function")
        throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({ ...Je });
  }
  const { bytesToNumberBE: Ld, hexToBytes: Vr } = Ro, On = {
    // asn.1 DER encoding utils
    Err: class extends Error {
      constructor(Je = "") {
        super(Je);
      }
    },
    _parseInt(ar) {
      const { Err: Je } = On;
      if (ar.length < 2 || ar[0] !== 2)
        throw new Je("Invalid signature integer tag");
      const pr = ar[1], Lr = ar.subarray(2, pr + 2);
      if (!pr || Lr.length !== pr)
        throw new Je("Invalid signature integer: wrong length");
      if (Lr[0] === 0 && Lr[1] <= 127)
        throw new Je("Invalid signature integer: trailing length");
      return { d: Ld(Lr), l: ar.subarray(pr + 2) };
    },
    toSig(ar) {
      const { Err: Je } = On, pr = typeof ar == "string" ? Vr(ar) : ar;
      if (!(pr instanceof Uint8Array))
        throw new Error("ui8a expected");
      let Lr = pr.length;
      if (Lr < 2 || pr[0] != 48)
        throw new Je("Invalid signature tag");
      if (pr[1] !== Lr - 2)
        throw new Je("Invalid signature: incorrect length");
      const { d: hn, l: mn } = On._parseInt(pr.subarray(2)), { d: qn, l: Vn } = On._parseInt(mn);
      if (Vn.length)
        throw new Je("Invalid signature: left bytes after parsing");
      return { r: hn, s: qn };
    },
    hexFromSig(ar) {
      const Je = (li) => Number.parseInt(li[0], 16) >= 8 ? "00" + li : li, pr = (li) => {
        const Di = li.toString(16);
        return Di.length & 1 ? `0${Di}` : Di;
      }, Lr = Je(pr(ar.s)), hn = Je(pr(ar.r)), mn = Lr.length / 2, qn = hn.length / 2, Vn = pr(mn), oi = pr(qn);
      return `30${pr(qn + mn + 4)}02${oi}${hn}02${Vn}${Lr}`;
    }
  }, ii = BigInt(0), di = BigInt(1), Si = BigInt(2), Ri = BigInt(3), Ki = BigInt(4);
  function as(ar) {
    const Je = Do(ar), { Fp: pr } = Je, Lr = Je.toBytes || ((fs, Yi, os) => {
      const ls = Yi.toAffine();
      return pi(Uint8Array.from([4]), pr.toBytes(ls.x), pr.toBytes(ls.y));
    }), hn = Je.fromBytes || ((fs) => {
      const Yi = fs.subarray(1), os = pr.fromBytes(Yi.subarray(0, pr.BYTES)), ls = pr.fromBytes(Yi.subarray(pr.BYTES, 2 * pr.BYTES));
      return { x: os, y: ls };
    });
    function mn(fs) {
      const { a: Yi, b: os } = Je, ls = pr.sqr(fs), Cs = pr.mul(ls, fs);
      return pr.add(pr.add(Cs, pr.mul(fs, Yi)), os);
    }
    function qn(fs) {
      return typeof fs == "bigint" && ii < fs && fs < Je.n;
    }
    function Vn(fs) {
      if (!qn(fs))
        throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    function oi(fs) {
      const { allowedPrivateKeyLengths: Yi, nByteLength: os, wrapPrivateKey: ls, n: Cs } = Je;
      if (Yi && typeof fs != "bigint") {
        if (fs instanceof Uint8Array && (fs = Gs(fs)), typeof fs != "string" || !Yi.includes(fs.length))
          throw new Error("Invalid key");
        fs = fs.padStart(os * 2, "0");
      }
      let bs;
      try {
        bs = typeof fs == "bigint" ? fs : Xs(fo("private key", fs, os));
      } catch {
        throw new Error(`private key must be ${os} bytes, hex or bigint, not ${typeof fs}`);
      }
      return ls && (bs = Vo(bs, Cs)), Vn(bs), bs;
    }
    const li = /* @__PURE__ */ new Map();
    function Di(fs) {
      if (!(fs instanceof mi))
        throw new Error("ProjectivePoint expected");
    }
    class mi {
      constructor(Yi, os, ls) {
        if (this.px = Yi, this.py = os, this.pz = ls, Yi == null || !pr.isValid(Yi))
          throw new Error("x required");
        if (os == null || !pr.isValid(os))
          throw new Error("y required");
        if (ls == null || !pr.isValid(ls))
          throw new Error("z required");
      }
      // Does not validate if the point is on-curve.
      // Use fromHex instead, or call assertValidity() later.
      static fromAffine(Yi) {
        const { x: os, y: ls } = Yi || {};
        if (!Yi || !pr.isValid(os) || !pr.isValid(ls))
          throw new Error("invalid affine point");
        if (Yi instanceof mi)
          throw new Error("projective point not allowed");
        const Cs = (bs) => pr.eql(bs, pr.ZERO);
        return Cs(os) && Cs(ls) ? mi.ZERO : new mi(os, ls, pr.ONE);
      }
      get x() {
        return this.toAffine().x;
      }
      get y() {
        return this.toAffine().y;
      }
      /**
       * Takes a bunch of Projective Points but executes only one
       * inversion on all of them. Inversion is very slow operation,
       * so this improves performance massively.
       * Optimization: converts a list of projective points to a list of identical points with Z=1.
       */
      static normalizeZ(Yi) {
        const os = pr.invertBatch(Yi.map((ls) => ls.pz));
        return Yi.map((ls, Cs) => ls.toAffine(os[Cs])).map(mi.fromAffine);
      }
      /**
       * Converts hash string or Uint8Array to Point.
       * @param hex short/long ECDSA hex
       */
      static fromHex(Yi) {
        const os = mi.fromAffine(hn(fo("pointHex", Yi)));
        return os.assertValidity(), os;
      }
      // Multiplies generator point by privateKey.
      static fromPrivateKey(Yi) {
        return mi.BASE.multiply(oi(Yi));
      }
      // "Private method", don't use it directly
      _setWindowSize(Yi) {
        this._WINDOW_SIZE = Yi, li.delete(this);
      }
      // A point on curve is valid if it conforms to equation.
      assertValidity() {
        if (this.is0()) {
          if (Je.allowInfinityPoint)
            return;
          throw new Error("bad point: ZERO");
        }
        const { x: Yi, y: os } = this.toAffine();
        if (!pr.isValid(Yi) || !pr.isValid(os))
          throw new Error("bad point: x or y not FE");
        const ls = pr.sqr(os), Cs = mn(Yi);
        if (!pr.eql(ls, Cs))
          throw new Error("bad point: equation left != right");
        if (!this.isTorsionFree())
          throw new Error("bad point: not in prime-order subgroup");
      }
      hasEvenY() {
        const { y: Yi } = this.toAffine();
        if (pr.isOdd)
          return !pr.isOdd(Yi);
        throw new Error("Field doesn't support isOdd");
      }
      /**
       * Compare one point to another.
       */
      equals(Yi) {
        Di(Yi);
        const { px: os, py: ls, pz: Cs } = this, { px: bs, py: Zs, pz: Ms } = Yi, Os = pr.eql(pr.mul(os, Ms), pr.mul(bs, Cs)), Hs = pr.eql(pr.mul(ls, Ms), pr.mul(Zs, Cs));
        return Os && Hs;
      }
      /**
       * Flips point to one corresponding to (x, -y) in Affine coordinates.
       */
      negate() {
        return new mi(this.px, pr.neg(this.py), this.pz);
      }
      // Renes-Costello-Batina exception-free doubling formula.
      // There is 30% faster Jacobian formula, but it is not complete.
      // https://eprint.iacr.org/2015/1060, algorithm 3
      // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
      double() {
        const { a: Yi, b: os } = Je, ls = pr.mul(os, Ri), { px: Cs, py: bs, pz: Zs } = this;
        let Ms = pr.ZERO, Os = pr.ZERO, Hs = pr.ZERO, Ys = pr.mul(Cs, Cs), Xo = pr.mul(bs, bs), Ko = pr.mul(Zs, Zs), Qo = pr.mul(Cs, bs);
        return Qo = pr.add(Qo, Qo), Hs = pr.mul(Cs, Zs), Hs = pr.add(Hs, Hs), Ms = pr.mul(Yi, Hs), Os = pr.mul(ls, Ko), Os = pr.add(Ms, Os), Ms = pr.sub(Xo, Os), Os = pr.add(Xo, Os), Os = pr.mul(Ms, Os), Ms = pr.mul(Qo, Ms), Hs = pr.mul(ls, Hs), Ko = pr.mul(Yi, Ko), Qo = pr.sub(Ys, Ko), Qo = pr.mul(Yi, Qo), Qo = pr.add(Qo, Hs), Hs = pr.add(Ys, Ys), Ys = pr.add(Hs, Ys), Ys = pr.add(Ys, Ko), Ys = pr.mul(Ys, Qo), Os = pr.add(Os, Ys), Ko = pr.mul(bs, Zs), Ko = pr.add(Ko, Ko), Ys = pr.mul(Ko, Qo), Ms = pr.sub(Ms, Ys), Hs = pr.mul(Ko, Xo), Hs = pr.add(Hs, Hs), Hs = pr.add(Hs, Hs), new mi(Ms, Os, Hs);
      }
      // Renes-Costello-Batina exception-free addition formula.
      // There is 30% faster Jacobian formula, but it is not complete.
      // https://eprint.iacr.org/2015/1060, algorithm 1
      // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
      add(Yi) {
        Di(Yi);
        const { px: os, py: ls, pz: Cs } = this, { px: bs, py: Zs, pz: Ms } = Yi;
        let Os = pr.ZERO, Hs = pr.ZERO, Ys = pr.ZERO;
        const Xo = Je.a, Ko = pr.mul(Je.b, Ri);
        let Qo = pr.mul(os, bs), wa = pr.mul(ls, Zs), Ca = pr.mul(Cs, Ms), Ru = pr.add(os, ls), Ss = pr.add(bs, Zs);
        Ru = pr.mul(Ru, Ss), Ss = pr.add(Qo, wa), Ru = pr.sub(Ru, Ss), Ss = pr.add(os, Cs);
        let Fs = pr.add(bs, Ms);
        return Ss = pr.mul(Ss, Fs), Fs = pr.add(Qo, Ca), Ss = pr.sub(Ss, Fs), Fs = pr.add(ls, Cs), Os = pr.add(Zs, Ms), Fs = pr.mul(Fs, Os), Os = pr.add(wa, Ca), Fs = pr.sub(Fs, Os), Ys = pr.mul(Xo, Ss), Os = pr.mul(Ko, Ca), Ys = pr.add(Os, Ys), Os = pr.sub(wa, Ys), Ys = pr.add(wa, Ys), Hs = pr.mul(Os, Ys), wa = pr.add(Qo, Qo), wa = pr.add(wa, Qo), Ca = pr.mul(Xo, Ca), Ss = pr.mul(Ko, Ss), wa = pr.add(wa, Ca), Ca = pr.sub(Qo, Ca), Ca = pr.mul(Xo, Ca), Ss = pr.add(Ss, Ca), Qo = pr.mul(wa, Ss), Hs = pr.add(Hs, Qo), Qo = pr.mul(Fs, Ss), Os = pr.mul(Ru, Os), Os = pr.sub(Os, Qo), Qo = pr.mul(Ru, wa), Ys = pr.mul(Fs, Ys), Ys = pr.add(Ys, Qo), new mi(Os, Hs, Ys);
      }
      subtract(Yi) {
        return this.add(Yi.negate());
      }
      is0() {
        return this.equals(mi.ZERO);
      }
      wNAF(Yi) {
        return es.wNAFCached(this, li, Yi, (os) => {
          const ls = pr.invertBatch(os.map((Cs) => Cs.pz));
          return os.map((Cs, bs) => Cs.toAffine(ls[bs])).map(mi.fromAffine);
        });
      }
      /**
       * Non-constant-time multiplication. Uses double-and-add algorithm.
       * It's faster, but should only be used when you don't care about
       * an exposed private key e.g. sig verification, which works over *public* keys.
       */
      multiplyUnsafe(Yi) {
        const os = mi.ZERO;
        if (Yi === ii)
          return os;
        if (Vn(Yi), Yi === di)
          return this;
        const { endo: ls } = Je;
        if (!ls)
          return es.unsafeLadder(this, Yi);
        let { k1neg: Cs, k1: bs, k2neg: Zs, k2: Ms } = ls.splitScalar(Yi), Os = os, Hs = os, Ys = this;
        for (; bs > ii || Ms > ii; )
          bs & di && (Os = Os.add(Ys)), Ms & di && (Hs = Hs.add(Ys)), Ys = Ys.double(), bs >>= di, Ms >>= di;
        return Cs && (Os = Os.negate()), Zs && (Hs = Hs.negate()), Hs = new mi(pr.mul(Hs.px, ls.beta), Hs.py, Hs.pz), Os.add(Hs);
      }
      /**
       * Constant time multiplication.
       * Uses wNAF method. Windowed method may be 10% faster,
       * but takes 2x longer to generate and consumes 2x memory.
       * Uses precomputes when available.
       * Uses endomorphism for Koblitz curves.
       * @param scalar by which the point would be multiplied
       * @returns New point
       */
      multiply(Yi) {
        Vn(Yi);
        let os = Yi, ls, Cs;
        const { endo: bs } = Je;
        if (bs) {
          const { k1neg: Zs, k1: Ms, k2neg: Os, k2: Hs } = bs.splitScalar(os);
          let { p: Ys, f: Xo } = this.wNAF(Ms), { p: Ko, f: Qo } = this.wNAF(Hs);
          Ys = es.constTimeNegate(Zs, Ys), Ko = es.constTimeNegate(Os, Ko), Ko = new mi(pr.mul(Ko.px, bs.beta), Ko.py, Ko.pz), ls = Ys.add(Ko), Cs = Xo.add(Qo);
        } else {
          const { p: Zs, f: Ms } = this.wNAF(os);
          ls = Zs, Cs = Ms;
        }
        return mi.normalizeZ([ls, Cs])[0];
      }
      /**
       * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
       * Not using Strauss-Shamir trick: precomputation tables are faster.
       * The trick could be useful if both P and Q are not G (not in our case).
       * @returns non-zero affine point
       */
      multiplyAndAddUnsafe(Yi, os, ls) {
        const Cs = mi.BASE, bs = (Ms, Os) => Os === ii || Os === di || !Ms.equals(Cs) ? Ms.multiplyUnsafe(Os) : Ms.multiply(Os), Zs = bs(this, os).add(bs(Yi, ls));
        return Zs.is0() ? void 0 : Zs;
      }
      // Converts Projective point to affine (x, y) coordinates.
      // Can accept precomputed Z^-1 - for example, from invertBatch.
      // (x, y, z) ∋ (x=x/z, y=y/z)
      toAffine(Yi) {
        const { px: os, py: ls, pz: Cs } = this, bs = this.is0();
        Yi == null && (Yi = bs ? pr.ONE : pr.inv(Cs));
        const Zs = pr.mul(os, Yi), Ms = pr.mul(ls, Yi), Os = pr.mul(Cs, Yi);
        if (bs)
          return { x: pr.ZERO, y: pr.ZERO };
        if (!pr.eql(Os, pr.ONE))
          throw new Error("invZ was invalid");
        return { x: Zs, y: Ms };
      }
      isTorsionFree() {
        const { h: Yi, isTorsionFree: os } = Je;
        if (Yi === di)
          return !0;
        if (os)
          return os(mi, this);
        throw new Error("isTorsionFree() has not been declared for the elliptic curve");
      }
      clearCofactor() {
        const { h: Yi, clearCofactor: os } = Je;
        return Yi === di ? this : os ? os(mi, this) : this.multiplyUnsafe(Je.h);
      }
      toRawBytes(Yi = !0) {
        return this.assertValidity(), Lr(mi, this, Yi);
      }
      toHex(Yi = !0) {
        return Gs(this.toRawBytes(Yi));
      }
    }
    mi.BASE = new mi(Je.Gx, Je.Gy, pr.ONE), mi.ZERO = new mi(pr.ZERO, pr.ONE, pr.ZERO);
    const is = Je.nBitLength, es = la(mi, Je.endo ? Math.ceil(is / 2) : is);
    return {
      CURVE: Je,
      ProjectivePoint: mi,
      normPrivateKeyToScalar: oi,
      weierstrassEquation: mn,
      isWithinCurveOrder: qn
    };
  }
  function Ts(ar) {
    const Je = Fd(ar);
    return Ho(Je, {
      hash: "hash",
      hmac: "function",
      randomBytes: "function"
    }, {
      bits2int: "function",
      bits2int_modN: "function",
      lowS: "boolean"
    }), Object.freeze({ lowS: !0, ...Je });
  }
  function Qs(ar) {
    const Je = Ts(ar), { Fp: pr, n: Lr } = Je, hn = pr.BYTES + 1, mn = 2 * pr.BYTES + 1;
    function qn(Ss) {
      return ii < Ss && Ss < pr.ORDER;
    }
    function Vn(Ss) {
      return Vo(Ss, Lr);
    }
    function oi(Ss) {
      return Us(Ss, Lr);
    }
    const { ProjectivePoint: li, normPrivateKeyToScalar: Di, weierstrassEquation: mi, isWithinCurveOrder: is } = as({
      ...Je,
      toBytes(Ss, Fs, So) {
        const _o = Fs.toAffine(), zo = pr.toBytes(_o.x), Ua = pi;
        return So ? Ua(Uint8Array.from([Fs.hasEvenY() ? 2 : 3]), zo) : Ua(Uint8Array.from([4]), zo, pr.toBytes(_o.y));
      },
      fromBytes(Ss) {
        const Fs = Ss.length, So = Ss[0], _o = Ss.subarray(1);
        if (Fs === hn && (So === 2 || So === 3)) {
          const zo = Xs(_o);
          if (!qn(zo))
            throw new Error("Point is not on curve");
          const Ua = mi(zo);
          let ou = pr.sqrt(Ua);
          const Xa = (ou & di) === di;
          return (So & 1) === 1 !== Xa && (ou = pr.neg(ou)), { x: zo, y: ou };
        } else if (Fs === mn && So === 4) {
          const zo = pr.fromBytes(_o.subarray(0, pr.BYTES)), Ua = pr.fromBytes(_o.subarray(pr.BYTES, 2 * pr.BYTES));
          return { x: zo, y: Ua };
        } else
          throw new Error(`Point of length ${Fs} was invalid. Expected ${hn} compressed bytes or ${mn} uncompressed bytes`);
      }
    }), es = (Ss) => Gs(co(Ss, Je.nByteLength));
    function fs(Ss) {
      const Fs = Lr >> di;
      return Ss > Fs;
    }
    function Yi(Ss) {
      return fs(Ss) ? Vn(-Ss) : Ss;
    }
    const os = (Ss, Fs, So) => Xs(Ss.slice(Fs, So));
    class ls {
      constructor(Fs, So, _o) {
        this.r = Fs, this.s = So, this.recovery = _o, this.assertValidity();
      }
      // pair (bytes of r, bytes of s)
      static fromCompact(Fs) {
        const So = Je.nByteLength;
        return Fs = fo("compactSignature", Fs, So * 2), new ls(os(Fs, 0, So), os(Fs, So, 2 * So));
      }
      // DER encoded ECDSA signature
      // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
      static fromDER(Fs) {
        const { r: So, s: _o } = On.toSig(fo("DER", Fs));
        return new ls(So, _o);
      }
      assertValidity() {
        if (!is(this.r))
          throw new Error("r must be 0 < r < CURVE.n");
        if (!is(this.s))
          throw new Error("s must be 0 < s < CURVE.n");
      }
      addRecoveryBit(Fs) {
        return new ls(this.r, this.s, Fs);
      }
      recoverPublicKey(Fs) {
        const { r: So, s: _o, recovery: zo } = this, Ua = Hs(fo("msgHash", Fs));
        if (zo == null || ![0, 1, 2, 3].includes(zo))
          throw new Error("recovery id invalid");
        const ou = zo === 2 || zo === 3 ? So + Je.n : So;
        if (ou >= pr.ORDER)
          throw new Error("recovery id 2 or 3 invalid");
        const Xa = (zo & 1) === 0 ? "02" : "03", ic = li.fromHex(Xa + es(ou)), sc = oi(ou), jc = Vn(-Ua * sc), ju = Vn(_o * sc), Ma = li.BASE.multiplyAndAddUnsafe(ic, jc, ju);
        if (!Ma)
          throw new Error("point at infinify");
        return Ma.assertValidity(), Ma;
      }
      // Signatures should be low-s, to prevent malleability.
      hasHighS() {
        return fs(this.s);
      }
      normalizeS() {
        return this.hasHighS() ? new ls(this.r, Vn(-this.s), this.recovery) : this;
      }
      // DER-encoded
      toDERRawBytes() {
        return $s(this.toDERHex());
      }
      toDERHex() {
        return On.hexFromSig({ r: this.r, s: this.s });
      }
      // padded bytes of r, then padded bytes of s
      toCompactRawBytes() {
        return $s(this.toCompactHex());
      }
      toCompactHex() {
        return es(this.r) + es(this.s);
      }
    }
    const Cs = {
      isValidPrivateKey(Ss) {
        try {
          return Di(Ss), !0;
        } catch {
          return !1;
        }
      },
      normPrivateKeyToScalar: Di,
      /**
       * Produces cryptographically secure private key from random of size (nBitLength+64)
       * as per FIPS 186 B.4.1 with modulo bias being neglible.
       */
      randomPrivateKey: () => {
        const Ss = Je.randomBytes(pr.BYTES + 8), Fs = ef(Ss, Lr);
        return co(Fs, Je.nByteLength);
      },
      /**
       * Creates precompute table for an arbitrary EC point. Makes point "cached".
       * Allows to massively speed-up `point.multiply(scalar)`.
       * @returns cached point
       * @example
       * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
       * fast.multiply(privKey); // much faster ECDH now
       */
      precompute(Ss = 8, Fs = li.BASE) {
        return Fs._setWindowSize(Ss), Fs.multiply(BigInt(3)), Fs;
      }
    };
    function bs(Ss, Fs = !0) {
      return li.fromPrivateKey(Ss).toRawBytes(Fs);
    }
    function Zs(Ss) {
      const Fs = Ss instanceof Uint8Array, So = typeof Ss == "string", _o = (Fs || So) && Ss.length;
      return Fs ? _o === hn || _o === mn : So ? _o === 2 * hn || _o === 2 * mn : Ss instanceof li;
    }
    function Ms(Ss, Fs, So = !0) {
      if (Zs(Ss))
        throw new Error("first arg must be private key");
      if (!Zs(Fs))
        throw new Error("second arg must be public key");
      return li.fromHex(Fs).multiply(Di(Ss)).toRawBytes(So);
    }
    const Os = Je.bits2int || function(Ss) {
      const Fs = Xs(Ss), So = Ss.length * 8 - Je.nBitLength;
      return So > 0 ? Fs >> BigInt(So) : Fs;
    }, Hs = Je.bits2int_modN || function(Ss) {
      return Vn(Os(Ss));
    }, Ys = rs(Je.nBitLength);
    function Xo(Ss) {
      if (typeof Ss != "bigint")
        throw new Error("bigint expected");
      if (!(ii <= Ss && Ss < Ys))
        throw new Error(`bigint expected < 2^${Je.nBitLength}`);
      return co(Ss, Je.nByteLength);
    }
    function Ko(Ss, Fs, So = Qo) {
      if (["recovered", "canonical"].some((oc) => oc in So))
        throw new Error("sign() legacy options not supported");
      const { hash: _o, randomBytes: zo } = Je;
      let { lowS: Ua, prehash: ou, extraEntropy: Xa } = So;
      Ua == null && (Ua = !0), Ss = fo("msgHash", Ss), ou && (Ss = fo("prehashed msgHash", _o(Ss)));
      const ic = Hs(Ss), sc = Di(Fs), jc = [Xo(sc), Xo(ic)];
      if (Xa != null) {
        const oc = Xa === !0 ? zo(pr.BYTES) : Xa;
        jc.push(fo("extraEntropy", oc, pr.BYTES));
      }
      const ju = pi(...jc), Ma = ic;
      function Ud(oc) {
        const ac = Os(oc);
        if (!is(ac))
          return;
        const y1 = oi(ac), Vc = li.BASE.multiply(ac).toAffine(), ka = Vn(Vc.x);
        if (ka === ii)
          return;
        const Wc = Vn(y1 * Vn(Ma + ka * sc));
        if (Wc === ii)
          return;
        let bc = (Vc.x === ka ? 0 : 2) | Number(Vc.y & di), Md = Wc;
        return Ua && fs(Wc) && (Md = Yi(Wc), bc ^= 1), new ls(ka, Md, bc);
      }
      return { seed: ju, k2sig: Ud };
    }
    const Qo = { lowS: Je.lowS, prehash: !1 }, wa = { lowS: Je.lowS, prehash: !1 };
    function Ca(Ss, Fs, So = Qo) {
      const { seed: _o, k2sig: zo } = Ko(Ss, Fs, So);
      return bo(Je.hash.outputLen, Je.nByteLength, Je.hmac)(_o, zo);
    }
    li.BASE._setWindowSize(8);
    function Ru(Ss, Fs, So, _o = wa) {
      var Vc;
      const zo = Ss;
      if (Fs = fo("msgHash", Fs), So = fo("publicKey", So), "strict" in _o)
        throw new Error("options.strict was renamed to lowS");
      const { lowS: Ua, prehash: ou } = _o;
      let Xa, ic;
      try {
        if (typeof zo == "string" || zo instanceof Uint8Array)
          try {
            Xa = ls.fromDER(zo);
          } catch (ka) {
            if (!(ka instanceof On.Err))
              throw ka;
            Xa = ls.fromCompact(zo);
          }
        else if (typeof zo == "object" && typeof zo.r == "bigint" && typeof zo.s == "bigint") {
          const { r: ka, s: Wc } = zo;
          Xa = new ls(ka, Wc);
        } else
          throw new Error("PARSE");
        ic = li.fromHex(So);
      } catch (ka) {
        if (ka.message === "PARSE")
          throw new Error("signature must be Signature instance, Uint8Array or hex string");
        return !1;
      }
      if (Ua && Xa.hasHighS())
        return !1;
      ou && (Fs = Je.hash(Fs));
      const { r: sc, s: jc } = Xa, ju = Hs(Fs), Ma = oi(jc), Ud = Vn(ju * Ma), oc = Vn(sc * Ma), ac = (Vc = li.BASE.multiplyAndAddUnsafe(ic, Ud, oc)) == null ? void 0 : Vc.toAffine();
      return ac ? Vn(ac.x) === sc : !1;
    }
    return {
      CURVE: Je,
      getPublicKey: bs,
      getSharedSecret: Ms,
      sign: Ca,
      verify: Ru,
      ProjectivePoint: li,
      Signature: ls,
      utils: Cs
    };
  }
  function ko(ar, Je) {
    const pr = ar.ORDER;
    let Lr = ii;
    for (let is = pr - di; is % Si === ii; is /= Si)
      Lr += di;
    const hn = Lr, mn = (pr - di) / Si ** hn, qn = (mn - di) / Si, Vn = Si ** hn - di, oi = Si ** (hn - di), li = ar.pow(Je, mn), Di = ar.pow(Je, (mn + di) / Si);
    let mi = (is, es) => {
      let fs = li, Yi = ar.pow(es, Vn), os = ar.sqr(Yi);
      os = ar.mul(os, es);
      let ls = ar.mul(is, os);
      ls = ar.pow(ls, qn), ls = ar.mul(ls, Yi), Yi = ar.mul(ls, es), os = ar.mul(ls, is);
      let Cs = ar.mul(os, Yi);
      ls = ar.pow(Cs, oi);
      let bs = ar.eql(ls, ar.ONE);
      Yi = ar.mul(os, Di), ls = ar.mul(Cs, fs), os = ar.cmov(Yi, os, bs), Cs = ar.cmov(ls, Cs, bs);
      for (let Zs = hn; Zs > 1; Zs--) {
        let Ms = Si ** (Zs - Si), Os = ar.pow(Cs, Ms);
        const Hs = ar.eql(Os, ar.ONE);
        Yi = ar.mul(os, fs), fs = ar.mul(fs, fs), Os = ar.mul(Cs, fs), os = ar.cmov(Yi, os, Hs), Cs = ar.cmov(Os, Cs, Hs);
      }
      return { isValid: bs, value: os };
    };
    if (ar.ORDER % Ki === Ri) {
      const is = (ar.ORDER - Ri) / Ki, es = ar.sqrt(ar.neg(Je));
      mi = (fs, Yi) => {
        let os = ar.sqr(Yi);
        const ls = ar.mul(fs, Yi);
        os = ar.mul(os, ls);
        let Cs = ar.pow(os, is);
        Cs = ar.mul(Cs, ls);
        const bs = ar.mul(Cs, es), Zs = ar.mul(ar.sqr(Cs), Yi), Ms = ar.eql(Zs, fs);
        let Os = ar.cmov(bs, Cs, Ms);
        return { isValid: Ms, value: Os };
      };
    }
    return mi;
  }
  function da(ar, Je) {
    if (Vs(ar), !ar.isValid(Je.A) || !ar.isValid(Je.B) || !ar.isValid(Je.Z))
      throw new Error("mapToCurveSimpleSWU: invalid opts");
    const pr = ko(ar, Je.Z);
    if (!ar.isOdd)
      throw new Error("Fp.isOdd is not implemented!");
    return (Lr) => {
      let hn, mn, qn, Vn, oi, li, Di, mi;
      hn = ar.sqr(Lr), hn = ar.mul(hn, Je.Z), mn = ar.sqr(hn), mn = ar.add(mn, hn), qn = ar.add(mn, ar.ONE), qn = ar.mul(qn, Je.B), Vn = ar.cmov(Je.Z, ar.neg(mn), !ar.eql(mn, ar.ZERO)), Vn = ar.mul(Vn, Je.A), mn = ar.sqr(qn), li = ar.sqr(Vn), oi = ar.mul(li, Je.A), mn = ar.add(mn, oi), mn = ar.mul(mn, qn), li = ar.mul(li, Vn), oi = ar.mul(li, Je.B), mn = ar.add(mn, oi), Di = ar.mul(hn, qn);
      const { isValid: is, value: es } = pr(mn, li);
      mi = ar.mul(hn, Lr), mi = ar.mul(mi, es), Di = ar.cmov(Di, qn, is), mi = ar.cmov(mi, es, is);
      const fs = ar.isOdd(Lr) === ar.isOdd(mi);
      return mi = ar.cmov(ar.neg(mi), mi, fs), Di = ar.div(Di, Vn), { x: Di, y: mi };
    };
  }
  function Ta(ar) {
    if (ar instanceof Uint8Array)
      return ar;
    if (typeof ar == "string")
      return Ni(ar);
    throw new Error("DST must be Uint8Array or string");
  }
  const Fa = Xs;
  function aa(ar, Je) {
    if (ar < 0 || ar >= 1 << 8 * Je)
      throw new Error(`bad I2OSP call: value=${ar} length=${Je}`);
    const pr = Array.from({ length: Je }).fill(0);
    for (let Lr = Je - 1; Lr >= 0; Lr--)
      pr[Lr] = ar & 255, ar >>>= 8;
    return new Uint8Array(pr);
  }
  function $a(ar, Je) {
    const pr = new Uint8Array(ar.length);
    for (let Lr = 0; Lr < ar.length; Lr++)
      pr[Lr] = ar[Lr] ^ Je[Lr];
    return pr;
  }
  function xa(ar) {
    if (!(ar instanceof Uint8Array))
      throw new Error("Uint8Array expected");
  }
  function eu(ar) {
    if (!Number.isSafeInteger(ar))
      throw new Error("number expected");
  }
  function yu(ar, Je, pr, Lr) {
    xa(ar), xa(Je), eu(pr), Je.length > 255 && (Je = Lr(pi(Ni("H2C-OVERSIZE-DST-"), Je)));
    const { outputLen: hn, blockLen: mn } = Lr, qn = Math.ceil(pr / hn);
    if (qn > 255)
      throw new Error("Invalid xmd length");
    const Vn = pi(Je, aa(Je.length, 1)), oi = aa(0, mn), li = aa(pr, 2), Di = new Array(qn), mi = Lr(pi(oi, ar, li, aa(0, 1), Vn));
    Di[0] = Lr(pi(mi, aa(1, 1), Vn));
    for (let es = 1; es <= qn; es++) {
      const fs = [$a(mi, Di[es - 1]), aa(es + 1, 1), Vn];
      Di[es] = Lr(pi(...fs));
    }
    return pi(...Di).slice(0, pr);
  }
  function lc(ar, Je, pr, Lr, hn) {
    if (xa(ar), xa(Je), eu(pr), Je.length > 255) {
      const mn = Math.ceil(2 * Lr / 8);
      Je = hn.create({ dkLen: mn }).update(Ni("H2C-OVERSIZE-DST-")).update(Je).digest();
    }
    if (pr > 65535 || Je.length > 255)
      throw new Error("expand_message_xof: invalid lenInBytes");
    return hn.create({ dkLen: pr }).update(ar).update(aa(pr, 2)).update(Je).update(aa(Je.length, 1)).digest();
  }
  function Wu(ar, Je, pr) {
    Ho(pr, {
      DST: "string",
      p: "bigint",
      m: "isSafeInteger",
      k: "isSafeInteger",
      hash: "hash"
    });
    const { p: Lr, k: hn, m: mn, hash: qn, expand: Vn, DST: oi } = pr;
    xa(ar), eu(Je);
    const li = Ta(oi), Di = Lr.toString(2).length, mi = Math.ceil((Di + hn) / 8), is = Je * mn * mi;
    let es;
    if (Vn === "xmd")
      es = yu(ar, li, is, qn);
    else if (Vn === "xof")
      es = lc(ar, li, is, hn, qn);
    else if (Vn === void 0)
      es = ar;
    else
      throw new Error('expand must be "xmd", "xof" or undefined');
    const fs = new Array(Je);
    for (let Yi = 0; Yi < Je; Yi++) {
      const os = new Array(mn);
      for (let ls = 0; ls < mn; ls++) {
        const Cs = mi * (ls + Yi * mn), bs = es.subarray(Cs, Cs + mi);
        os[ls] = Vo(Fa(bs), Lr);
      }
      fs[Yi] = os;
    }
    return fs;
  }
  function Bc(ar, Je) {
    const pr = Je.map((Lr) => Array.from(Lr).reverse());
    return (Lr, hn) => {
      const [mn, qn, Vn, oi] = pr.map((li) => li.reduce((Di, mi) => ar.add(ar.mul(Di, Lr), mi)));
      return Lr = ar.div(mn, qn), hn = ar.mul(hn, ar.div(Vn, oi)), { x: Lr, y: hn };
    };
  }
  function Uf(ar, Je, pr) {
    if (typeof Je != "function")
      throw new Error("mapToCurve() must be defined");
    return {
      // Encodes byte string to elliptic curve
      // https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-16#section-3
      hashToCurve(Lr, hn) {
        const mn = Wu(Lr, 2, { ...pr, DST: pr.DST, ...hn }), qn = ar.fromAffine(Je(mn[0])), Vn = ar.fromAffine(Je(mn[1])), oi = qn.add(Vn).clearCofactor();
        return oi.assertValidity(), oi;
      },
      // https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-16#section-3
      encodeToCurve(Lr, hn) {
        const mn = Wu(Lr, 1, { ...pr, DST: pr.encodeDST, ...hn }), qn = ar.fromAffine(Je(mn[0])).clearCofactor();
        return qn.assertValidity(), qn;
      }
    };
  }
  let tf = class extends yi {
    constructor(Je, pr) {
      super(), this.finished = !1, this.destroyed = !1, Gn.hash(Je);
      const Lr = fi(pr);
      if (this.iHash = Je.create(), typeof this.iHash.update != "function")
        throw new TypeError("Expected instance of class which extends utils.Hash");
      this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
      const hn = this.blockLen, mn = new Uint8Array(hn);
      mn.set(Lr.length > hn ? Je.create().update(Lr).digest() : Lr);
      for (let qn = 0; qn < mn.length; qn++)
        mn[qn] ^= 54;
      this.iHash.update(mn), this.oHash = Je.create();
      for (let qn = 0; qn < mn.length; qn++)
        mn[qn] ^= 106;
      this.oHash.update(mn), mn.fill(0);
    }
    update(Je) {
      return Gn.exists(this), this.iHash.update(Je), this;
    }
    digestInto(Je) {
      Gn.exists(this), Gn.bytes(Je, this.outputLen), this.finished = !0, this.iHash.digestInto(Je), this.oHash.update(Je), this.oHash.digestInto(Je), this.destroy();
    }
    digest() {
      const Je = new Uint8Array(this.oHash.outputLen);
      return this.digestInto(Je), Je;
    }
    _cloneInto(Je) {
      Je || (Je = Object.create(Object.getPrototypeOf(this), {}));
      const { oHash: pr, iHash: Lr, finished: hn, destroyed: mn, blockLen: qn, outputLen: Vn } = this;
      return Je = Je, Je.finished = hn, Je.destroyed = mn, Je.blockLen = qn, Je.outputLen = Vn, Je.oHash = pr._cloneInto(Je.oHash), Je.iHash = Lr._cloneInto(Je.iHash), Je;
    }
    destroy() {
      this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
    }
  };
  const rf = (ar, Je, pr) => new tf(ar, Je).update(pr).digest();
  rf.create = (ar, Je) => new tf(ar, Je);
  function vl(ar) {
    return {
      hash: ar,
      hmac: (Je, ...pr) => rf(ar, Je, Ai(...pr)),
      randomBytes: wi
    };
  }
  function Cl(ar, Je) {
    const pr = (Lr) => Qs({ ...ar, ...vl(Lr) });
    return Object.freeze({ ...pr(Je), create: pr });
  }
  const Mf = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), Ff = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), Hd = BigInt(1), Lf = BigInt(2), kl = (ar, Je) => (ar + Je / Lf) / Je;
  function Kd(ar) {
    const Je = Mf, pr = BigInt(3), Lr = BigInt(6), hn = BigInt(11), mn = BigInt(22), qn = BigInt(23), Vn = BigInt(44), oi = BigInt(88), li = ar * ar * ar % Je, Di = li * li * ar % Je, mi = qo(Di, pr, Je) * Di % Je, is = qo(mi, pr, Je) * Di % Je, es = qo(is, Lf, Je) * li % Je, fs = qo(es, hn, Je) * es % Je, Yi = qo(fs, mn, Je) * fs % Je, os = qo(Yi, Vn, Je) * Yi % Je, ls = qo(os, oi, Je) * os % Je, Cs = qo(ls, Vn, Je) * Yi % Je, bs = qo(Cs, pr, Je) * Di % Je, Zs = qo(bs, qn, Je) * fs % Je, Ms = qo(Zs, Lr, Je) * li % Je, Os = qo(Ms, Lf, Je);
    if (!Ou.eql(Ou.sqr(Os), ar))
      throw new Error("Cannot find square root");
    return Os;
  }
  const Ou = Ps(Mf, void 0, void 0, { sqrt: Kd }), Qu = Cl({
    a: BigInt(0),
    b: BigInt(7),
    Fp: Ou,
    n: Ff,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: !0,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */
    endo: {
      beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
      splitScalar: (ar) => {
        const Je = Ff, pr = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), Lr = -Hd * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), hn = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), mn = pr, qn = BigInt("0x100000000000000000000000000000000"), Vn = kl(mn * ar, Je), oi = kl(-Lr * ar, Je);
        let li = Vo(ar - Vn * pr - oi * hn, Je), Di = Vo(-Vn * Lr - oi * mn, Je);
        const mi = li > qn, is = Di > qn;
        if (mi && (li = Je - li), is && (Di = Je - Di), li > qn || Di > qn)
          throw new Error("splitScalar: Endomorphism failed, k=" + ar);
        return { k1neg: mi, k1: li, k2neg: is, k2: Di };
      }
    }
  }, ws);
  BigInt(0), Qu.ProjectivePoint, Qu.utils.randomPrivateKey;
  const B1 = Bc(Ou, [
    // xNum
    [
      "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
      "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
      "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
      "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
    ],
    // xDen
    [
      "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
      "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
      "0x0000000000000000000000000000000000000000000000000000000000000001"
      // LAST 1
    ],
    // yNum
    [
      "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
      "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
      "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
      "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
    ],
    // yDen
    [
      "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
      "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
      "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
      "0x0000000000000000000000000000000000000000000000000000000000000001"
      // LAST 1
    ]
  ].map((ar) => ar.map((Je) => BigInt(Je)))), C1 = da(Ou, {
    A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
    B: BigInt("1771"),
    Z: Ou.create(BigInt("-11"))
  });
  Uf(Qu.ProjectivePoint, (ar) => {
    const { x: Je, y: pr } = C1(Ou.create(ar[0]));
    return B1(Je, pr);
  }, {
    DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
    encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
    p: Ou.ORDER,
    m: 1,
    k: 128,
    expand: "xmd",
    hash: ws
  });
  function Sl(ar) {
    if (!Number.isSafeInteger(ar) || ar < 0)
      throw new Error(`Wrong positive integer: ${ar}`);
  }
  function k1(ar) {
    if (typeof ar != "boolean")
      throw new Error(`Expected boolean, not ${ar}`);
  }
  function Gd(ar, ...Je) {
    if (!(ar instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (Je.length > 0 && !Je.includes(ar.length))
      throw new TypeError(`Expected Uint8Array of length ${Je}, not of length=${ar.length}`);
  }
  function S1(ar) {
    if (typeof ar != "function" || typeof ar.create != "function")
      throw new Error("Hash should be wrapped by utils.wrapConstructor");
    Sl(ar.outputLen), Sl(ar.blockLen);
  }
  function T1(ar, Je = !0) {
    if (ar.destroyed)
      throw new Error("Hash instance has been destroyed");
    if (Je && ar.finished)
      throw new Error("Hash#digest() has already been called");
  }
  function x1(ar, Je) {
    Gd(ar);
    const pr = Je.outputLen;
    if (ar.length < pr)
      throw new Error(`digestInto() expects output buffer of length at least ${pr}`);
  }
  var Tl = {
    number: Sl,
    bool: k1,
    bytes: Gd,
    hash: S1,
    exists: T1,
    output: x1
  };
  const xl = (ar) => new DataView(ar.buffer, ar.byteOffset, ar.byteLength), mu = (ar, Je) => ar << 32 - Je | ar >>> Je;
  if (!(new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68))
    throw new Error("Non little-endian hardware is not supported");
  Array.from({ length: 256 }, (ar, Je) => Je.toString(16).padStart(2, "0"));
  function R1(ar) {
    if (typeof ar != "string")
      throw new TypeError(`utf8ToBytes expected string, got ${typeof ar}`);
    return new TextEncoder().encode(ar);
  }
  function Yr(ar) {
    if (typeof ar == "string" && (ar = R1(ar)), !(ar instanceof Uint8Array))
      throw new TypeError(`Expected input type is Uint8Array (got ${typeof ar})`);
    return ar;
  }
  let uo = class {
    // Safe version that clones internal state
    clone() {
      return this._cloneInto();
    }
  };
  function vs(ar) {
    const Je = (Lr) => ar().update(Yr(Lr)).digest(), pr = ar();
    return Je.outputLen = pr.outputLen, Je.blockLen = pr.blockLen, Je.create = () => ar(), Je;
  }
  function D1(ar, Je, pr, Lr) {
    if (typeof ar.setBigUint64 == "function")
      return ar.setBigUint64(Je, pr, Lr);
    const hn = BigInt(32), mn = BigInt(4294967295), qn = Number(pr >> hn & mn), Vn = Number(pr & mn), oi = Lr ? 4 : 0, li = Lr ? 0 : 4;
    ar.setUint32(Je + oi, qn, Lr), ar.setUint32(Je + li, Vn, Lr);
  }
  let N1 = class extends uo {
    constructor(Je, pr, Lr, hn) {
      super(), this.blockLen = Je, this.outputLen = pr, this.padOffset = Lr, this.isLE = hn, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(Je), this.view = xl(this.buffer);
    }
    update(Je) {
      Tl.exists(this);
      const { view: pr, buffer: Lr, blockLen: hn } = this;
      Je = Yr(Je);
      const mn = Je.length;
      for (let qn = 0; qn < mn; ) {
        const Vn = Math.min(hn - this.pos, mn - qn);
        if (Vn === hn) {
          const oi = xl(Je);
          for (; hn <= mn - qn; qn += hn)
            this.process(oi, qn);
          continue;
        }
        Lr.set(Je.subarray(qn, qn + Vn), this.pos), this.pos += Vn, qn += Vn, this.pos === hn && (this.process(pr, 0), this.pos = 0);
      }
      return this.length += Je.length, this.roundClean(), this;
    }
    digestInto(Je) {
      Tl.exists(this), Tl.output(Je, this), this.finished = !0;
      const { buffer: pr, view: Lr, blockLen: hn, isLE: mn } = this;
      let { pos: qn } = this;
      pr[qn++] = 128, this.buffer.subarray(qn).fill(0), this.padOffset > hn - qn && (this.process(Lr, 0), qn = 0);
      for (let mi = qn; mi < hn; mi++)
        pr[mi] = 0;
      D1(Lr, hn - 8, BigInt(this.length * 8), mn), this.process(Lr, 0);
      const Vn = xl(Je), oi = this.outputLen;
      if (oi % 4)
        throw new Error("_sha2: outputLen should be aligned to 32bit");
      const li = oi / 4, Di = this.get();
      if (li > Di.length)
        throw new Error("_sha2: outputLen bigger than state");
      for (let mi = 0; mi < li; mi++)
        Vn.setUint32(4 * mi, Di[mi], mn);
    }
    digest() {
      const { buffer: Je, outputLen: pr } = this;
      this.digestInto(Je);
      const Lr = Je.slice(0, pr);
      return this.destroy(), Lr;
    }
    _cloneInto(Je) {
      Je || (Je = new this.constructor()), Je.set(...this.get());
      const { blockLen: pr, buffer: Lr, length: hn, finished: mn, destroyed: qn, pos: Vn } = this;
      return Je.length = hn, Je.pos = Vn, Je.finished = mn, Je.destroyed = qn, hn % pr && Je.buffer.set(Lr), Je;
    }
  };
  const P1 = (ar, Je, pr) => ar & Je ^ ~ar & pr, q1 = (ar, Je, pr) => ar & Je ^ ar & pr ^ Je & pr, jd = new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]), zu = new Uint32Array([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ]), Ju = new Uint32Array(64);
  let Rl = class extends N1 {
    constructor() {
      super(64, 32, 8, !1), this.A = zu[0] | 0, this.B = zu[1] | 0, this.C = zu[2] | 0, this.D = zu[3] | 0, this.E = zu[4] | 0, this.F = zu[5] | 0, this.G = zu[6] | 0, this.H = zu[7] | 0;
    }
    get() {
      const { A: Je, B: pr, C: Lr, D: hn, E: mn, F: qn, G: Vn, H: oi } = this;
      return [Je, pr, Lr, hn, mn, qn, Vn, oi];
    }
    // prettier-ignore
    set(Je, pr, Lr, hn, mn, qn, Vn, oi) {
      this.A = Je | 0, this.B = pr | 0, this.C = Lr | 0, this.D = hn | 0, this.E = mn | 0, this.F = qn | 0, this.G = Vn | 0, this.H = oi | 0;
    }
    process(Je, pr) {
      for (let mi = 0; mi < 16; mi++, pr += 4)
        Ju[mi] = Je.getUint32(pr, !1);
      for (let mi = 16; mi < 64; mi++) {
        const is = Ju[mi - 15], es = Ju[mi - 2], fs = mu(is, 7) ^ mu(is, 18) ^ is >>> 3, Yi = mu(es, 17) ^ mu(es, 19) ^ es >>> 10;
        Ju[mi] = Yi + Ju[mi - 7] + fs + Ju[mi - 16] | 0;
      }
      let { A: Lr, B: hn, C: mn, D: qn, E: Vn, F: oi, G: li, H: Di } = this;
      for (let mi = 0; mi < 64; mi++) {
        const is = mu(Vn, 6) ^ mu(Vn, 11) ^ mu(Vn, 25), es = Di + is + P1(Vn, oi, li) + jd[mi] + Ju[mi] | 0, Yi = (mu(Lr, 2) ^ mu(Lr, 13) ^ mu(Lr, 22)) + q1(Lr, hn, mn) | 0;
        Di = li, li = oi, oi = Vn, Vn = qn + es | 0, qn = mn, mn = hn, hn = Lr, Lr = es + Yi | 0;
      }
      Lr = Lr + this.A | 0, hn = hn + this.B | 0, mn = mn + this.C | 0, qn = qn + this.D | 0, Vn = Vn + this.E | 0, oi = oi + this.F | 0, li = li + this.G | 0, Di = Di + this.H | 0, this.set(Lr, hn, mn, qn, Vn, oi, li, Di);
    }
    roundClean() {
      Ju.fill(0);
    }
    destroy() {
      this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
    }
  }, Vd = class extends Rl {
    constructor() {
      super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
    }
  };
  const nf = vs(() => new Rl());
  vs(() => new Vd());
  function O1(ar, Je) {
    if (ar.length > Je)
      throw new TypeError(`Data is larger than array size: ${ar.length} > ${Je}`);
  }
  function Q1(ar) {
    if (ar.match(/[^a-fA-f0-9]/) !== null)
      throw new TypeError("Invalid characters in hex string: " + ar);
    if (ar.length % 2 !== 0)
      throw new Error(`Length of hex string is invalid: ${ar.length}`);
  }
  function U1(ar) {
    if (ar > Number.MAX_SAFE_INTEGER)
      throw new TypeError("Number exceeds safe bounds!");
  }
  const { getRandomValues: M1 } = crypto ?? globalThis.crypto ?? window.crypto;
  function Wd(ar = 32) {
    if (typeof M1 == "function")
      return crypto.getRandomValues(new Uint8Array(ar));
    throw new Error("Crypto module missing getRandomValues!");
  }
  function F1(ar, Je, pr = "be") {
    Je === void 0 && (Je = ar.length), O1(ar, Je);
    const Lr = new Uint8Array(Je).fill(0), hn = pr === "be" ? 0 : Je - ar.length;
    return Lr.set(ar, hn), Lr;
  }
  function sf(ar) {
    let Je, pr = 0;
    const Lr = ar.reduce((mn, qn) => mn + qn.length, 0), hn = new Uint8Array(Lr);
    for (Je = 0; Je < ar.length; Je++) {
      const mn = ar[Je];
      hn.set(mn, pr), pr += mn.length;
    }
    return hn;
  }
  const L1 = new TextEncoder(), zd = [
    {
      name: "base58",
      charset: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
    }
  ];
  function Dl(ar) {
    for (const Je of zd)
      if (Je.name === ar)
        return Je.charset;
    throw TypeError("Charset does not exist: " + ar);
  }
  function Iu(ar, Je, pr = !1) {
    typeof ar == "string" && (ar = L1.encode(ar));
    const Lr = Dl(Je), hn = Lr.length, mn = [];
    let qn = "", Vn, oi = 0, li, Di;
    for (Vn = 0; Vn < ar.length; Vn++)
      for (oi = 0, li = ar[Vn], qn += li > 0 || (qn.length ^ Vn) > 0 ? "" : "1"; oi in mn || li > 0; )
        Di = mn[oi], Di = Di > 0 ? Di * 256 + li : li, li = Di / hn | 0, mn[oi] = Di % hn, oi++;
    for (; oi-- > 0; )
      qn += Lr[mn[oi]];
    return pr && qn.length % 4 > 0 ? qn + "=".repeat(4 - qn.length % 4) : qn;
  }
  function H1(ar, Je) {
    const pr = Dl(Je), Lr = pr.length, hn = [], mn = [];
    ar = ar.replace("=", "");
    let qn, Vn = 0, oi, li;
    for (qn = 0; qn < ar.length; qn++) {
      if (Vn = 0, oi = pr.indexOf(ar[qn]), oi < 0)
        throw new Error(`Character range out of bounds: ${oi}`);
      for (oi > 0 || (mn.length ^ qn) > 0 || mn.push(0); Vn in hn || oi > 0; )
        li = hn[Vn], li = li > 0 ? li * Lr + oi : oi, oi = li >> 8, hn[Vn] = li % 256, Vn++;
    }
    for (; Vn-- > 0; )
      mn.push(hn[Vn]);
    return new Uint8Array(mn);
  }
  function Jd(ar) {
    return nf(nf(ar));
  }
  function K1(ar) {
    const Je = Jd(ar);
    return sf([ar, Je.slice(0, 4)]);
  }
  function G1(ar) {
    const Je = ar.slice(0, -4), pr = ar.slice(-4);
    if (Jd(Je).slice(0, 4).toString() !== pr.toString())
      throw new Error("Invalid checksum!");
    return Je;
  }
  const Nl = {
    encode: Iu,
    decode: H1
  }, Yd = {
    encode: (ar) => {
      const Je = K1(ar);
      return Nl.encode(Je, "base58");
    },
    decode: (ar) => {
      const Je = Nl.decode(ar, "base58");
      return G1(Je);
    }
  }, Pl = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", j1 = [996825010, 642813549, 513874426, 1027748829, 705979059], To = [
    { version: 0, name: "bech32", const: 1 },
    { version: 1, name: "bech32m", const: 734539939 }
  ];
  function ql(ar) {
    let Je = 1;
    for (let pr = 0; pr < ar.length; ++pr) {
      const Lr = Je >> 25;
      Je = (Je & 33554431) << 5 ^ ar[pr];
      for (let hn = 0; hn < 5; ++hn)
        (Lr >> hn & 1) !== 0 && (Je ^= j1[hn]);
    }
    return Je;
  }
  function Xd(ar) {
    const Je = [];
    let pr;
    for (pr = 0; pr < ar.length; ++pr)
      Je.push(ar.charCodeAt(pr) >> 5);
    for (Je.push(0), pr = 0; pr < ar.length; ++pr)
      Je.push(ar.charCodeAt(pr) & 31);
    return Je;
  }
  function V1(ar, Je, pr) {
    const Lr = Xd(ar).concat(Je);
    return ql(Lr) === pr.const;
  }
  function W1(ar, Je, pr) {
    const Lr = Xd(ar).concat(Je).concat([0, 0, 0, 0, 0, 0]), hn = ql(Lr) ^ pr.const, mn = [];
    for (let qn = 0; qn < 6; ++qn)
      mn.push(hn >> 5 * (5 - qn) & 31);
    return mn;
  }
  function vc(ar, Je, pr, Lr = !0) {
    const hn = [];
    let mn = 0, qn = 0;
    const Vn = (1 << pr) - 1, oi = (1 << Je + pr - 1) - 1;
    for (const li of ar) {
      if (li < 0 || li >> Je > 0)
        throw new Error("Failed to perform base conversion. Invalid value: " + String(li));
      for (mn = (mn << Je | li) & oi, qn += Je; qn >= pr; )
        qn -= pr, hn.push(mn >> qn & Vn);
    }
    if (Lr)
      qn > 0 && hn.push(mn << pr - qn & Vn);
    else if (qn >= Je || (mn << pr - qn & Vn) > 0)
      throw new Error("Failed to perform base conversion. Invalid Size!");
    return hn;
  }
  function _d(ar, Je, pr) {
    const Lr = Je.concat(W1(ar, Je, pr));
    let hn = ar + "1";
    for (let mn = 0; mn < Lr.length; ++mn)
      hn += Pl.charAt(Lr[mn]);
    return hn;
  }
  function Zd(ar) {
    if (!z1(ar))
      throw new Error("Encoded string goes out of bounds!");
    if (ar = ar.toLowerCase(), !qa(ar))
      throw new Error("Encoded string has invalid separator!");
    const Je = [], pr = ar.lastIndexOf("1"), Lr = ar.substring(0, pr);
    for (let mn = pr + 1; mn < ar.length; ++mn) {
      const qn = Pl.indexOf(ar.charAt(mn));
      if (qn === -1)
        throw new Error("Character idx out of bounds: " + String(mn));
      Je.push(qn);
    }
    const hn = To.find((mn) => mn.version === Je[0]) ?? To[0];
    if (!V1(Lr, Je, hn))
      throw new Error("Checksum verification failed!");
    return [Lr, Je.slice(0, Je.length - 6)];
  }
  function z1(ar) {
    let Je, pr, Lr = !1, hn = !1;
    for (Je = 0; Je < ar.length; ++Je) {
      if (pr = ar.charCodeAt(Je), pr < 33 || pr > 126)
        return !1;
      pr >= 97 && pr <= 122 && (Lr = !0), pr >= 65 && pr <= 90 && (hn = !0);
    }
    return !(Lr && hn);
  }
  function qa(ar) {
    const Je = ar.lastIndexOf("1");
    return !(Je < 1 || Je + 7 > ar.length || ar.length > 90);
  }
  function J1(ar, Je = "bc", pr = 0) {
    const Lr = [pr, ...vc([...ar], 8, 5)], hn = To.find((qn) => qn.version === pr) ?? To[0], mn = _d(Je, Lr, hn);
    return Hf(mn), mn;
  }
  function Hf(ar) {
    ar = ar.toLowerCase();
    const Je = ar.split("1", 1)[0], [pr, Lr] = Zd(ar), hn = vc(Lr.slice(1), 5, 8, !1), mn = hn.length;
    switch (!0) {
      case Je !== pr:
        throw new Error("Returned hrp string is invalid.");
      case (hn === null || mn < 2 || mn > 40):
        throw new Error("Decoded string is invalid or out of spec.");
      case Lr[0] > 16:
        throw new Error("Returned version bit is out of range.");
      default:
        return Uint8Array.from(hn);
    }
  }
  function Y1(ar) {
    ar = ar.toLowerCase();
    const [Je, pr] = Zd(ar);
    return pr[0];
  }
  const Ol = {
    encode: J1,
    decode: Hf,
    version: Y1
  }, $d = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", eh = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_", X1 = new TextEncoder();
  function th(ar, Je = !1, pr = !0) {
    typeof ar == "string" && (ar = X1.encode(ar));
    const Lr = Je ? eh : $d;
    let hn = "", mn = 0, qn = 0;
    for (let Vn = 0; Vn < ar.length; Vn++)
      for (qn = qn << 8 | ar[Vn], mn += 8; mn >= 6; )
        mn -= 6, hn += Lr[qn >> mn & 63];
    if (mn > 0)
      for (qn <<= 6 - mn, hn += Lr[qn & 63]; mn < 6; )
        hn += pr ? "=" : "", mn += 2;
    return hn;
  }
  function Ql(ar, Je = !1) {
    const pr = Je || ar.includes("-") || ar.includes("_") ? eh.split("") : $d.split("");
    ar = ar.replace(/=+$/, "");
    const Lr = ar.split("");
    let hn = 0, mn = 0;
    const qn = [];
    for (let Vn = 0; Vn < Lr.length; Vn++) {
      const oi = Lr[Vn], li = pr.indexOf(oi);
      if (li === -1)
        throw new Error("Invalid character: " + oi);
      hn += 6, mn <<= 6, mn |= li, hn >= 8 && (hn -= 8, qn.push(mn >>> hn & 255));
    }
    return new Uint8Array(qn);
  }
  const rh = {
    encode: th,
    decode: Ql
  }, nh = {
    encode: (ar) => th(ar, !0, !1),
    decode: (ar) => Ql(ar, !0)
  }, Z1 = BigInt(0), ih = BigInt(255), sh = BigInt(256);
  function $1(ar) {
    if (ar <= 0xffn)
      return 1;
    if (ar <= 0xffffn)
      return 2;
    if (ar <= 0xffffffffn)
      return 4;
    if (ar <= 0xffffffffffffffffn)
      return 8;
    if (ar <= 0xffffffffffffffffffffffffffffffffn)
      return 16;
    if (ar <= 0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffn)
      return 32;
    throw new TypeError("Must specify a fixed buffer size for bigints greater than 32 bytes.");
  }
  function eg(ar, Je, pr = "be") {
    Je === void 0 && (Je = $1(ar));
    const Lr = pr === "le", hn = new ArrayBuffer(Je), mn = new DataView(hn);
    let qn = Lr ? 0 : Je - 1;
    for (; ar > Z1; ) {
      const Vn = ar & ih, oi = Number(Vn);
      Lr ? mn.setUint8(qn++, oi) : mn.setUint8(qn--, oi), ar = (ar - Vn) / sh;
    }
    return new Uint8Array(hn);
  }
  function tg(ar) {
    let Je = BigInt(0);
    for (let pr = ar.length - 1; pr >= 0; pr--)
      Je = Je * sh + BigInt(ar[pr]);
    return BigInt(Je);
  }
  function rg(ar) {
    const Je = ar.split("").map(Number);
    if (Je.length % 8 !== 0)
      throw new Error(`Binary array is invalid length: ${ar.length}`);
    const pr = new Uint8Array(Je.length / 8);
    for (let Lr = 0, hn = 0; Lr < Je.length; Lr += 8, hn++) {
      let mn = 0;
      for (let qn = 0; qn < 8; qn++)
        mn |= Je[Lr + qn] << 7 - qn;
      pr[hn] = mn;
    }
    return pr;
  }
  function ng(ar) {
    const Je = new Array(ar.length * 8);
    let pr = 0;
    for (const Lr of ar) {
      if (Lr > 255)
        throw new Error(`Invalid byte value: ${Lr}. Byte values must be between 0 and 255.`);
      for (let hn = 7; hn >= 0; hn--, pr++)
        Je[pr] = Lr >> hn & 1;
    }
    return Je.join("");
  }
  function ig(ar) {
    if (ar <= 255)
      return 1;
    if (ar <= 65535)
      return 2;
    if (ar <= 4294967295)
      return 4;
    throw new TypeError("Numbers larger than 4 bytes must specify a fixed size!");
  }
  function Kf(ar, Je, pr = "be") {
    Je === void 0 && (Je = ig(ar));
    const Lr = pr === "le", hn = new ArrayBuffer(Je), mn = new DataView(hn);
    let qn = Lr ? 0 : Je - 1;
    for (; ar > 0; ) {
      const Vn = ar & 255;
      Lr ? mn.setUint8(qn++, ar) : mn.setUint8(qn--, ar), ar = (ar - Vn) / 256;
    }
    return new Uint8Array(hn);
  }
  function Gf(ar) {
    let Je = 0;
    for (let pr = ar.length - 1; pr >= 0; pr--)
      Je = Je * 256 + ar[pr], U1(Je);
    return Je;
  }
  const sg = new TextEncoder(), og = new TextDecoder();
  function Ul(ar) {
    return sg.encode(ar);
  }
  function Ml(ar) {
    return og.decode(ar);
  }
  function ag(ar, Je) {
    Q1(ar);
    const pr = ar.length / 2;
    if (Je === void 0 && (Je = pr), pr > Je)
      throw new TypeError(`Hex string is larger than array size: ${pr} > ${Je}`);
    return Je;
  }
  function ug(ar, Je, pr = "le") {
    Je = ag(ar, Je);
    const Lr = pr === "le", hn = new ArrayBuffer(Je), mn = new DataView(hn);
    let qn = Lr ? 0 : Je - 1;
    for (let Vn = 0; Vn < ar.length; Vn += 2) {
      const oi = ar.substring(Vn, Vn + 2), li = parseInt(oi, 16);
      Lr ? mn.setUint8(qn++, li) : mn.setUint8(qn--, li);
    }
    return new Uint8Array(hn);
  }
  function cg(ar) {
    let Je = "";
    for (let pr = 0; pr < ar.length; pr++)
      Je += ar[pr].toString(16).padStart(2, "0");
    return Je;
  }
  function Fl(ar) {
    const Je = JSON.stringify(ar, (pr, Lr) => typeof Lr == "bigint" ? `${Lr}n` : Lr);
    return Ul(Je);
  }
  function fg(ar, Je, pr) {
    if (ar instanceof ArrayBuffer)
      return new Uint8Array(ar);
    if (ar instanceof Uint8Array)
      return F1(ar, Je, pr);
    if (typeof ar == "string")
      return ug(ar, Je, pr);
    if (typeof ar == "bigint")
      return eg(ar, Je, pr);
    if (typeof ar == "number")
      return Kf(ar, Je, pr);
    if (typeof ar == "boolean")
      return Uint8Array.of(ar ? 1 : 0);
    throw TypeError("Unsupported format:" + typeof ar);
  }
  const Bo = class Bo extends Uint8Array {
    static random(Je = 32) {
      const pr = Wd(Je);
      return new Bo(pr, Je);
    }
    constructor(Je, pr, Lr) {
      const hn = fg(Je, pr, Lr);
      super(hn);
    }
    get arr() {
      return [...this];
    }
    get num() {
      return this.toNum();
    }
    get big() {
      return this.toBig();
    }
    get str() {
      return this.toStr();
    }
    get hex() {
      return this.toHex();
    }
    get raw() {
      return new Uint8Array(this);
    }
    get bin() {
      return this.toBin();
    }
    get b58chk() {
      return this.tob58chk();
    }
    get base64() {
      return this.toBase64();
    }
    get b64url() {
      return this.toB64url();
    }
    get digest() {
      return this.toHash();
    }
    get id() {
      return this.toHash().hex;
    }
    get stream() {
      return new Ig(this);
    }
    toNum(Je = "be") {
      const pr = Je === "be" ? this.reverse() : this;
      return Gf(pr);
    }
    toBin() {
      return ng(this);
    }
    toBig(Je = "be") {
      const pr = Je === "be" ? this.reverse() : this;
      return tg(pr);
    }
    toHash() {
      const Je = nf(this);
      return new Bo(Je);
    }
    toJson() {
      const Je = Ml(this);
      return JSON.parse(Je);
    }
    toBech32(Je, pr = 0) {
      return Ol.encode(this, Je, pr);
    }
    toStr() {
      return Ml(this);
    }
    toHex() {
      return cg(this);
    }
    toBytes() {
      return new Uint8Array(this);
    }
    tob58chk() {
      return Yd.encode(this);
    }
    toBase64() {
      return rh.encode(this);
    }
    toB64url() {
      return nh.encode(this);
    }
    prepend(Je) {
      return Bo.join([Bo.bytes(Je), this]);
    }
    append(Je) {
      return Bo.join([this, Bo.bytes(Je)]);
    }
    slice(Je, pr) {
      const Lr = new Uint8Array(this).slice(Je, pr);
      return new Bo(Lr);
    }
    subarray(Je, pr) {
      const Lr = new Uint8Array(this).subarray(Je, pr);
      return new Bo(Lr);
    }
    reverse() {
      const Je = new Uint8Array(this).reverse();
      return new Bo(Je);
    }
    write(Je, pr) {
      const Lr = Bo.bytes(Je);
      this.set(Lr, pr);
    }
    prefixSize(Je) {
      const pr = Bo.varInt(this.length, Je);
      return Bo.join([pr, this]);
    }
    static from(Je) {
      return new Bo(Uint8Array.from(Je));
    }
    static of(...Je) {
      return new Bo(Uint8Array.of(...Je));
    }
    static join(Je) {
      const pr = Je.map((hn) => Bo.bytes(hn)), Lr = sf(pr);
      return new Bo(Lr);
    }
    static varInt(Je, pr) {
      if (Je < 253)
        return Bo.num(Je, 1);
      if (Je < 65536)
        return Bo.of(253, ...Bo.num(Je, 2, pr));
      if (Je < 4294967296)
        return Bo.of(254, ...Bo.num(Je, 4, pr));
      if (BigInt(Je) < 0x10000000000000000n)
        return Bo.of(255, ...Bo.num(Je, 8, pr));
      throw new Error(`Value is too large: ${Je}`);
    }
  };
  Bo.num = Uu, Bo.big = dg, Bo.bin = lg, Bo.raw = jf, Bo.str = hg, Bo.hex = Ag, Bo.bytes = gg, Bo.json = pg, Bo.base64 = oh, Bo.b64url = yg, Bo.bech32 = mg, Bo.b58chk = of, Bo.encode = Ul, Bo.decode = Ml;
  let no = Bo;
  function Uu(ar, Je, pr) {
    return new no(ar, Je, pr);
  }
  function lg(ar, Je, pr) {
    return new no(rg(ar), Je, pr);
  }
  function dg(ar, Je, pr) {
    return new no(ar, Je, pr);
  }
  function jf(ar, Je, pr) {
    return new no(ar, Je, pr);
  }
  function hg(ar, Je, pr) {
    return new no(Ul(ar), Je, pr);
  }
  function Ag(ar, Je, pr) {
    return new no(ar, Je, pr);
  }
  function gg(ar, Je, pr) {
    return new no(ar, Je, pr);
  }
  function pg(ar) {
    return new no(Fl(ar));
  }
  function oh(ar) {
    return new no(rh.decode(ar));
  }
  function yg(ar) {
    return new no(nh.decode(ar));
  }
  function mg(ar) {
    return new no(Ol.decode(ar));
  }
  function of(ar) {
    return new no(Yd.decode(ar));
  }
  class Ig {
    constructor(Je) {
      this.data = no.bytes(Je), this.size = this.data.length;
    }
    peek(Je) {
      if (Je > this.size)
        throw new Error(`Size greater than stream: ${Je} > ${this.size}`);
      return new no(this.data.slice(0, Je));
    }
    read(Je) {
      Je = Je ?? this.readSize();
      const pr = this.peek(Je);
      return this.data = this.data.slice(Je), this.size = this.data.length, pr;
    }
    readSize(Je) {
      const pr = this.read(1).num;
      switch (!0) {
        case (pr >= 0 && pr < 253):
          return pr;
        case pr === 253:
          return this.read(2).toNum(Je);
        case pr === 254:
          return this.read(4).toNum(Je);
        case pr === 255:
          return this.read(8).toNum(Je);
        default:
          throw new Error(`Varint is out of range: ${pr}`);
      }
    }
  }
  const af = Qu.CURVE, Ll = af.n, wg = af.p, Mu = { x: af.Gx, y: af.Gy }, bg = BigInt(0);
  BigInt(1), BigInt(2), BigInt(3), BigInt(4);
  const Hl = { N: Ll, P: wg, G: Mu, _0n: bg }, uf = Ps(Ll, 32, !0), ah = (ar) => Vo(ar, Ll);
  function Gl(ar, Je = !1) {
    if (Je)
      throw new Error(ar);
    return !1;
  }
  function jl(ar) {
    return no.random(ar);
  }
  function Eg(ar) {
    const Je = no.bytes(ar).big;
    return no.big(ah(Je), 32);
  }
  var Bg = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    fail: Gl,
    mod_bytes: Eg,
    random: jl
  });
  const { N: vg, _0n: Cg } = Hl;
  function kg(ar, Je, pr) {
    const Lr = no.bytes(ar);
    return Lr.length !== Je ? Gl(`Invalid byte size: ${Lr.hex} !== ${Je}`, pr) : !0;
  }
  function Sg(ar, Je) {
    return typeof ar == "bigint" && Cg < ar && ar < vg || Gl("x value is not in the field!", Je), !0;
  }
  const Vl = Qu.ProjectivePoint, na = class na extends Uint8Array {
    static mod(Je) {
      return new na(Je);
    }
    static is_valid(Je, pr) {
      const Lr = no.bytes(Je, 32).big;
      return Sg(Lr, pr);
    }
    constructor(Je) {
      let pr = uh(Je);
      pr = ah(pr), na.is_valid(pr, !0), super(no.big(pr, 32), 32);
    }
    get buff() {
      return new no(this);
    }
    get raw() {
      return this.buff.raw;
    }
    get big() {
      return this.buff.big;
    }
    get hex() {
      return this.buff.hex;
    }
    get point() {
      return this.generate();
    }
    get hasOddY() {
      return this.point.hasOddY;
    }
    get negated() {
      return this.hasOddY ? this.negate() : this;
    }
    gt(Je) {
      return new na(Je).big > this.big;
    }
    lt(Je) {
      return new na(Je).big < this.big;
    }
    eq(Je) {
      return new na(Je).big === this.big;
    }
    ne(Je) {
      return new na(Je).big !== this.big;
    }
    add(Je) {
      const pr = na.mod(Je), Lr = uf.add(this.big, pr.big);
      return new na(Lr);
    }
    sub(Je) {
      const pr = na.mod(Je), Lr = uf.sub(this.big, pr.big);
      return new na(Lr);
    }
    mul(Je) {
      const pr = na.mod(Je), Lr = uf.mul(this.big, pr.big);
      return new na(Lr);
    }
    pow(Je) {
      const pr = na.mod(Je), Lr = uf.pow(this.big, pr.big);
      return new na(Lr);
    }
    div(Je) {
      const pr = na.mod(Je), Lr = uf.div(this.big, pr.big);
      return new na(Lr);
    }
    negate() {
      return new na(na.N - this.big);
    }
    generate() {
      const pr = Qu.ProjectivePoint.BASE.multiply(this.big);
      return wu.import(pr);
    }
  };
  na.N = Qu.CURVE.n;
  let Ba = na;
  const ea = class ea {
    static from_x(Je) {
      let pr = Tg(Je);
      pr.length === 32 && (pr = pr.prepend(2)), kg(pr, 33);
      const Lr = Vl.fromHex(pr.hex);
      return Lr.assertValidity(), new ea(Lr.x, Lr.y);
    }
    static generate(Je) {
      const pr = Ba.mod(Je), Lr = ea.base.multiply(pr.big);
      return ea.import(Lr);
    }
    static import(Je) {
      const pr = Je instanceof ea ? { x: Je.x.big, y: Je.y.big } : { x: Je.x, y: Je.y };
      return new ea(pr.x, pr.y);
    }
    constructor(Je, pr) {
      this._p = new Vl(Je, pr, 1n), this.p.assertValidity();
    }
    get p() {
      return this._p;
    }
    get x() {
      return no.big(this.p.x, 32);
    }
    get y() {
      return no.big(this.p.y, 32);
    }
    get buff() {
      return no.raw(this.p.toRawBytes(!0));
    }
    get raw() {
      return this.buff.raw;
    }
    get hex() {
      return this.buff.hex;
    }
    get hasEvenY() {
      return this.p.hasEvenY();
    }
    get hasOddY() {
      return !this.p.hasEvenY();
    }
    eq(Je) {
      const pr = Je instanceof ea ? Je : ea.from_x(Je);
      return this.x.big === pr.x.big && this.y.big === pr.y.big;
    }
    add(Je) {
      return Je instanceof ea ? ea.import(this.p.add(Je.p)) : ea.import(this.p.add(ea.generate(Je).p));
    }
    sub(Je) {
      return Je instanceof ea ? ea.import(this.p.subtract(Je.p)) : ea.import(this.p.subtract(ea.generate(Je).p));
    }
    mul(Je) {
      return Je instanceof ea ? ea.import(this.p.multiply(Je.x.big)) : ea.import(this.p.multiply(Ba.mod(Je).big));
    }
    negate() {
      return ea.import(this.p.negate());
    }
  };
  ea.P = Hl.P, ea.G = Hl.G, ea.base = Qu.ProjectivePoint.BASE;
  let wu = ea;
  function uh(ar) {
    if (ar instanceof Ba)
      return ar.big;
    if (ar instanceof wu)
      return ar.x.big;
    if (ar instanceof Uint8Array)
      return no.raw(ar).big;
    if (typeof ar == "string")
      return no.hex(ar).big;
    if (typeof ar == "number")
      return no.num(ar).big;
    if (typeof ar == "bigint")
      return BigInt(ar);
    throw TypeError("Invalid input type:" + typeof ar);
  }
  function Tg(ar) {
    if (ar instanceof Ba)
      return ar.point.buff;
    if (ar instanceof wu)
      return ar.buff;
    if (ar instanceof Uint8Array || typeof ar == "string")
      return no.bytes(ar);
    if (typeof ar == "number" || typeof ar == "bigint")
      return no.bytes(ar, 32);
    throw new TypeError(`Unknown type: ${typeof ar}`);
  }
  function Wl(ar) {
    if (!Number.isSafeInteger(ar) || ar < 0)
      throw new Error(`Wrong positive integer: ${ar}`);
  }
  function xg(ar) {
    if (typeof ar != "boolean")
      throw new Error(`Expected boolean, not ${ar}`);
  }
  function ch(ar, ...Je) {
    if (!(ar instanceof Uint8Array))
      throw new Error("Expected Uint8Array");
    if (Je.length > 0 && !Je.includes(ar.length))
      throw new Error(`Expected Uint8Array of length ${Je}, not of length=${ar.length}`);
  }
  function zl(ar) {
    if (typeof ar != "function" || typeof ar.create != "function")
      throw new Error("Hash should be wrapped by utils.wrapConstructor");
    Wl(ar.outputLen), Wl(ar.blockLen);
  }
  function Rg(ar, Je = !0) {
    if (ar.destroyed)
      throw new Error("Hash instance has been destroyed");
    if (Je && ar.finished)
      throw new Error("Hash#digest() has already been called");
  }
  function _s(ar, Je) {
    ch(ar);
    const pr = Je.outputLen;
    if (ar.length < pr)
      throw new Error(`digestInto() expects output buffer of length at least ${pr}`);
  }
  var dc = {
    number: Wl,
    bool: xg,
    bytes: ch,
    hash: zl,
    exists: Rg,
    output: _s
  };
  const Dg = (ar) => ar instanceof Uint8Array, Jl = (ar) => new DataView(ar.buffer, ar.byteOffset, ar.byteLength), bu = (ar, Je) => ar << 32 - Je | ar >>> Je;
  if (!(new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68))
    throw new Error("Non little-endian hardware is not supported");
  Array.from({ length: 256 }, (ar, Je) => Je.toString(16).padStart(2, "0"));
  function Vf(ar) {
    if (typeof ar != "string")
      throw new Error(`utf8ToBytes expected string, got ${typeof ar}`);
    return new Uint8Array(new TextEncoder().encode(ar));
  }
  function cf(ar) {
    if (typeof ar == "string" && (ar = Vf(ar)), !Dg(ar))
      throw new Error(`expected Uint8Array, got ${typeof ar}`);
    return ar;
  }
  class Wf {
    // Safe version that clones internal state
    clone() {
      return this._cloneInto();
    }
  }
  function hc(ar) {
    const Je = (Lr) => ar().update(cf(Lr)).digest(), pr = ar();
    return Je.outputLen = pr.outputLen, Je.blockLen = pr.blockLen, Je.create = () => ar(), Je;
  }
  function Ng(ar, Je, pr, Lr) {
    if (typeof ar.setBigUint64 == "function")
      return ar.setBigUint64(Je, pr, Lr);
    const hn = BigInt(32), mn = BigInt(4294967295), qn = Number(pr >> hn & mn), Vn = Number(pr & mn), oi = Lr ? 4 : 0, li = Lr ? 0 : 4;
    ar.setUint32(Je + oi, qn, Lr), ar.setUint32(Je + li, Vn, Lr);
  }
  class Cc extends Wf {
    constructor(Je, pr, Lr, hn) {
      super(), this.blockLen = Je, this.outputLen = pr, this.padOffset = Lr, this.isLE = hn, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(Je), this.view = Jl(this.buffer);
    }
    update(Je) {
      dc.exists(this);
      const { view: pr, buffer: Lr, blockLen: hn } = this;
      Je = cf(Je);
      const mn = Je.length;
      for (let qn = 0; qn < mn; ) {
        const Vn = Math.min(hn - this.pos, mn - qn);
        if (Vn === hn) {
          const oi = Jl(Je);
          for (; hn <= mn - qn; qn += hn)
            this.process(oi, qn);
          continue;
        }
        Lr.set(Je.subarray(qn, qn + Vn), this.pos), this.pos += Vn, qn += Vn, this.pos === hn && (this.process(pr, 0), this.pos = 0);
      }
      return this.length += Je.length, this.roundClean(), this;
    }
    digestInto(Je) {
      dc.exists(this), dc.output(Je, this), this.finished = !0;
      const { buffer: pr, view: Lr, blockLen: hn, isLE: mn } = this;
      let { pos: qn } = this;
      pr[qn++] = 128, this.buffer.subarray(qn).fill(0), this.padOffset > hn - qn && (this.process(Lr, 0), qn = 0);
      for (let mi = qn; mi < hn; mi++)
        pr[mi] = 0;
      Ng(Lr, hn - 8, BigInt(this.length * 8), mn), this.process(Lr, 0);
      const Vn = Jl(Je), oi = this.outputLen;
      if (oi % 4)
        throw new Error("_sha2: outputLen should be aligned to 32bit");
      const li = oi / 4, Di = this.get();
      if (li > Di.length)
        throw new Error("_sha2: outputLen bigger than state");
      for (let mi = 0; mi < li; mi++)
        Vn.setUint32(4 * mi, Di[mi], mn);
    }
    digest() {
      const { buffer: Je, outputLen: pr } = this;
      this.digestInto(Je);
      const Lr = Je.slice(0, pr);
      return this.destroy(), Lr;
    }
    _cloneInto(Je) {
      Je || (Je = new this.constructor()), Je.set(...this.get());
      const { blockLen: pr, buffer: Lr, length: hn, finished: mn, destroyed: qn, pos: Vn } = this;
      return Je.length = hn, Je.pos = Vn, Je.finished = mn, Je.destroyed = qn, hn % pr && Je.buffer.set(Lr), Je;
    }
  }
  const Pg = (ar, Je, pr) => ar & Je ^ ~ar & pr, qg = (ar, Je, pr) => ar & Je ^ ar & pr ^ Je & pr, Og = new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]), Eu = new Uint32Array([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ]), Yu = new Uint32Array(64);
  class zf extends Cc {
    constructor() {
      super(64, 32, 8, !1), this.A = Eu[0] | 0, this.B = Eu[1] | 0, this.C = Eu[2] | 0, this.D = Eu[3] | 0, this.E = Eu[4] | 0, this.F = Eu[5] | 0, this.G = Eu[6] | 0, this.H = Eu[7] | 0;
    }
    get() {
      const { A: Je, B: pr, C: Lr, D: hn, E: mn, F: qn, G: Vn, H: oi } = this;
      return [Je, pr, Lr, hn, mn, qn, Vn, oi];
    }
    // prettier-ignore
    set(Je, pr, Lr, hn, mn, qn, Vn, oi) {
      this.A = Je | 0, this.B = pr | 0, this.C = Lr | 0, this.D = hn | 0, this.E = mn | 0, this.F = qn | 0, this.G = Vn | 0, this.H = oi | 0;
    }
    process(Je, pr) {
      for (let mi = 0; mi < 16; mi++, pr += 4)
        Yu[mi] = Je.getUint32(pr, !1);
      for (let mi = 16; mi < 64; mi++) {
        const is = Yu[mi - 15], es = Yu[mi - 2], fs = bu(is, 7) ^ bu(is, 18) ^ is >>> 3, Yi = bu(es, 17) ^ bu(es, 19) ^ es >>> 10;
        Yu[mi] = Yi + Yu[mi - 7] + fs + Yu[mi - 16] | 0;
      }
      let { A: Lr, B: hn, C: mn, D: qn, E: Vn, F: oi, G: li, H: Di } = this;
      for (let mi = 0; mi < 64; mi++) {
        const is = bu(Vn, 6) ^ bu(Vn, 11) ^ bu(Vn, 25), es = Di + is + Pg(Vn, oi, li) + Og[mi] + Yu[mi] | 0, Yi = (bu(Lr, 2) ^ bu(Lr, 13) ^ bu(Lr, 22)) + qg(Lr, hn, mn) | 0;
        Di = li, li = oi, oi = Vn, Vn = qn + es | 0, qn = mn, mn = hn, hn = Lr, Lr = es + Yi | 0;
      }
      Lr = Lr + this.A | 0, hn = hn + this.B | 0, mn = mn + this.C | 0, qn = qn + this.D | 0, Vn = Vn + this.E | 0, oi = oi + this.F | 0, li = li + this.G | 0, Di = Di + this.H | 0, this.set(Lr, hn, mn, qn, Vn, oi, li, Di);
    }
    roundClean() {
      Yu.fill(0);
    }
    destroy() {
      this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
    }
  }
  class fh extends zf {
    constructor() {
      super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
    }
  }
  const ff = hc(() => new zf());
  hc(() => new fh());
  const lf = BigInt(2 ** 32 - 1), Yl = BigInt(32);
  function Xl(ar, Je = !1) {
    return Je ? { h: Number(ar & lf), l: Number(ar >> Yl & lf) } : { h: Number(ar >> Yl & lf) | 0, l: Number(ar & lf) | 0 };
  }
  function Qg(ar, Je = !1) {
    let pr = new Uint32Array(ar.length), Lr = new Uint32Array(ar.length);
    for (let hn = 0; hn < ar.length; hn++) {
      const { h: mn, l: qn } = Xl(ar[hn], Je);
      [pr[hn], Lr[hn]] = [mn, qn];
    }
    return [pr, Lr];
  }
  const Ug = (ar, Je) => BigInt(ar >>> 0) << Yl | BigInt(Je >>> 0), go = (ar, Je, pr) => ar >>> pr, Mg = (ar, Je, pr) => ar << 32 - pr | Je >>> pr, lh = (ar, Je, pr) => ar >>> pr | Je << 32 - pr, _l = (ar, Je, pr) => ar << 32 - pr | Je >>> pr, Fg = (ar, Je, pr) => ar << 64 - pr | Je >>> pr - 32, Zl = (ar, Je, pr) => ar >>> pr - 32 | Je << 64 - pr, tu = (ar, Je) => Je, Jf = (ar, Je) => ar, Lg = (ar, Je, pr) => ar << pr | Je >>> 32 - pr, kc = (ar, Je, pr) => Je << pr | ar >>> 32 - pr, $l = (ar, Je, pr) => Je << pr - 32 | ar >>> 64 - pr, Hg = (ar, Je, pr) => ar << pr - 32 | Je >>> 64 - pr;
  function hh(ar, Je, pr, Lr) {
    const hn = (Je >>> 0) + (Lr >>> 0);
    return { h: ar + pr + (hn / 2 ** 32 | 0) | 0, l: hn | 0 };
  }
  var yo = {
    fromBig: Xl,
    split: Qg,
    toBig: Ug,
    shrSH: go,
    shrSL: Mg,
    rotrSH: lh,
    rotrSL: _l,
    rotrBH: Fg,
    rotrBL: Zl,
    rotr32H: tu,
    rotr32L: Jf,
    rotlSH: Lg,
    rotlSL: kc,
    rotlBH: $l,
    rotlBL: Hg,
    add: hh,
    add3L: (ar, Je, pr) => (ar >>> 0) + (Je >>> 0) + (pr >>> 0),
    add3H: (ar, Je, pr, Lr) => Je + pr + Lr + (ar / 2 ** 32 | 0) | 0,
    add4L: (ar, Je, pr, Lr) => (ar >>> 0) + (Je >>> 0) + (pr >>> 0) + (Lr >>> 0),
    add4H: (ar, Je, pr, Lr, hn) => Je + pr + Lr + hn + (ar / 2 ** 32 | 0) | 0,
    add5H: (ar, Je, pr, Lr, hn, mn) => Je + pr + Lr + hn + mn + (ar / 2 ** 32 | 0) | 0,
    add5L: (ar, Je, pr, Lr, hn) => (ar >>> 0) + (Je >>> 0) + (pr >>> 0) + (Lr >>> 0) + (hn >>> 0)
  };
  const [Kg, Sc] = yo.split([
    "0x428a2f98d728ae22",
    "0x7137449123ef65cd",
    "0xb5c0fbcfec4d3b2f",
    "0xe9b5dba58189dbbc",
    "0x3956c25bf348b538",
    "0x59f111f1b605d019",
    "0x923f82a4af194f9b",
    "0xab1c5ed5da6d8118",
    "0xd807aa98a3030242",
    "0x12835b0145706fbe",
    "0x243185be4ee4b28c",
    "0x550c7dc3d5ffb4e2",
    "0x72be5d74f27b896f",
    "0x80deb1fe3b1696b1",
    "0x9bdc06a725c71235",
    "0xc19bf174cf692694",
    "0xe49b69c19ef14ad2",
    "0xefbe4786384f25e3",
    "0x0fc19dc68b8cd5b5",
    "0x240ca1cc77ac9c65",
    "0x2de92c6f592b0275",
    "0x4a7484aa6ea6e483",
    "0x5cb0a9dcbd41fbd4",
    "0x76f988da831153b5",
    "0x983e5152ee66dfab",
    "0xa831c66d2db43210",
    "0xb00327c898fb213f",
    "0xbf597fc7beef0ee4",
    "0xc6e00bf33da88fc2",
    "0xd5a79147930aa725",
    "0x06ca6351e003826f",
    "0x142929670a0e6e70",
    "0x27b70a8546d22ffc",
    "0x2e1b21385c26c926",
    "0x4d2c6dfc5ac42aed",
    "0x53380d139d95b3df",
    "0x650a73548baf63de",
    "0x766a0abb3c77b2a8",
    "0x81c2c92e47edaee6",
    "0x92722c851482353b",
    "0xa2bfe8a14cf10364",
    "0xa81a664bbc423001",
    "0xc24b8b70d0f89791",
    "0xc76c51a30654be30",
    "0xd192e819d6ef5218",
    "0xd69906245565a910",
    "0xf40e35855771202a",
    "0x106aa07032bbd1b8",
    "0x19a4c116b8d2d0c8",
    "0x1e376c085141ab53",
    "0x2748774cdf8eeb99",
    "0x34b0bcb5e19b48a8",
    "0x391c0cb3c5c95a63",
    "0x4ed8aa4ae3418acb",
    "0x5b9cca4f7763e373",
    "0x682e6ff3d6b2b8a3",
    "0x748f82ee5defb2fc",
    "0x78a5636f43172f60",
    "0x84c87814a1f0ab72",
    "0x8cc702081a6439ec",
    "0x90befffa23631e28",
    "0xa4506cebde82bde9",
    "0xbef9a3f7b2c67915",
    "0xc67178f2e372532b",
    "0xca273eceea26619c",
    "0xd186b8c721c0c207",
    "0xeada7dd6cde0eb1e",
    "0xf57d4f7fee6ed178",
    "0x06f067aa72176fba",
    "0x0a637dc5a2c898a6",
    "0x113f9804bef90dae",
    "0x1b710b35131c471b",
    "0x28db77f523047d84",
    "0x32caab7b40c72493",
    "0x3c9ebe0a15c9bebc",
    "0x431d67c49c100d4c",
    "0x4cc5d4becb3e42b6",
    "0x597f299cfc657e2a",
    "0x5fcb6fab3ad6faec",
    "0x6c44198c4a475817"
  ].map((ar) => BigInt(ar))), Xu = new Uint32Array(80), Ks = new Uint32Array(80);
  class hf extends Cc {
    constructor() {
      super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
      const { Ah: Je, Al: pr, Bh: Lr, Bl: hn, Ch: mn, Cl: qn, Dh: Vn, Dl: oi, Eh: li, El: Di, Fh: mi, Fl: is, Gh: es, Gl: fs, Hh: Yi, Hl: os } = this;
      return [Je, pr, Lr, hn, mn, qn, Vn, oi, li, Di, mi, is, es, fs, Yi, os];
    }
    // prettier-ignore
    set(Je, pr, Lr, hn, mn, qn, Vn, oi, li, Di, mi, is, es, fs, Yi, os) {
      this.Ah = Je | 0, this.Al = pr | 0, this.Bh = Lr | 0, this.Bl = hn | 0, this.Ch = mn | 0, this.Cl = qn | 0, this.Dh = Vn | 0, this.Dl = oi | 0, this.Eh = li | 0, this.El = Di | 0, this.Fh = mi | 0, this.Fl = is | 0, this.Gh = es | 0, this.Gl = fs | 0, this.Hh = Yi | 0, this.Hl = os | 0;
    }
    process(Je, pr) {
      for (let bs = 0; bs < 16; bs++, pr += 4)
        Xu[bs] = Je.getUint32(pr), Ks[bs] = Je.getUint32(pr += 4);
      for (let bs = 16; bs < 80; bs++) {
        const Zs = Xu[bs - 15] | 0, Ms = Ks[bs - 15] | 0, Os = yo.rotrSH(Zs, Ms, 1) ^ yo.rotrSH(Zs, Ms, 8) ^ yo.shrSH(Zs, Ms, 7), Hs = yo.rotrSL(Zs, Ms, 1) ^ yo.rotrSL(Zs, Ms, 8) ^ yo.shrSL(Zs, Ms, 7), Ys = Xu[bs - 2] | 0, Xo = Ks[bs - 2] | 0, Ko = yo.rotrSH(Ys, Xo, 19) ^ yo.rotrBH(Ys, Xo, 61) ^ yo.shrSH(Ys, Xo, 6), Qo = yo.rotrSL(Ys, Xo, 19) ^ yo.rotrBL(Ys, Xo, 61) ^ yo.shrSL(Ys, Xo, 6), wa = yo.add4L(Hs, Qo, Ks[bs - 7], Ks[bs - 16]), Ca = yo.add4H(wa, Os, Ko, Xu[bs - 7], Xu[bs - 16]);
        Xu[bs] = Ca | 0, Ks[bs] = wa | 0;
      }
      let { Ah: Lr, Al: hn, Bh: mn, Bl: qn, Ch: Vn, Cl: oi, Dh: li, Dl: Di, Eh: mi, El: is, Fh: es, Fl: fs, Gh: Yi, Gl: os, Hh: ls, Hl: Cs } = this;
      for (let bs = 0; bs < 80; bs++) {
        const Zs = yo.rotrSH(mi, is, 14) ^ yo.rotrSH(mi, is, 18) ^ yo.rotrBH(mi, is, 41), Ms = yo.rotrSL(mi, is, 14) ^ yo.rotrSL(mi, is, 18) ^ yo.rotrBL(mi, is, 41), Os = mi & es ^ ~mi & Yi, Hs = is & fs ^ ~is & os, Ys = yo.add5L(Cs, Ms, Hs, Sc[bs], Ks[bs]), Xo = yo.add5H(Ys, ls, Zs, Os, Kg[bs], Xu[bs]), Ko = Ys | 0, Qo = yo.rotrSH(Lr, hn, 28) ^ yo.rotrBH(Lr, hn, 34) ^ yo.rotrBH(Lr, hn, 39), wa = yo.rotrSL(Lr, hn, 28) ^ yo.rotrBL(Lr, hn, 34) ^ yo.rotrBL(Lr, hn, 39), Ca = Lr & mn ^ Lr & Vn ^ mn & Vn, Ru = hn & qn ^ hn & oi ^ qn & oi;
        ls = Yi | 0, Cs = os | 0, Yi = es | 0, os = fs | 0, es = mi | 0, fs = is | 0, { h: mi, l: is } = yo.add(li | 0, Di | 0, Xo | 0, Ko | 0), li = Vn | 0, Di = oi | 0, Vn = mn | 0, oi = qn | 0, mn = Lr | 0, qn = hn | 0;
        const Ss = yo.add3L(Ko, wa, Ru);
        Lr = yo.add3H(Ss, Xo, Qo, Ca), hn = Ss | 0;
      }
      ({ h: Lr, l: hn } = yo.add(this.Ah | 0, this.Al | 0, Lr | 0, hn | 0)), { h: mn, l: qn } = yo.add(this.Bh | 0, this.Bl | 0, mn | 0, qn | 0), { h: Vn, l: oi } = yo.add(this.Ch | 0, this.Cl | 0, Vn | 0, oi | 0), { h: li, l: Di } = yo.add(this.Dh | 0, this.Dl | 0, li | 0, Di | 0), { h: mi, l: is } = yo.add(this.Eh | 0, this.El | 0, mi | 0, is | 0), { h: es, l: fs } = yo.add(this.Fh | 0, this.Fl | 0, es | 0, fs | 0), { h: Yi, l: os } = yo.add(this.Gh | 0, this.Gl | 0, Yi | 0, os | 0), { h: ls, l: Cs } = yo.add(this.Hh | 0, this.Hl | 0, ls | 0, Cs | 0), this.set(Lr, hn, mn, qn, Vn, oi, li, Di, mi, is, es, fs, Yi, os, ls, Cs);
    }
    roundClean() {
      Xu.fill(0), Ks.fill(0);
    }
    destroy() {
      this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
  }
  class ed extends hf {
    constructor() {
      super(), this.Ah = -1942145080, this.Al = 424955298, this.Bh = 1944164710, this.Bl = -1982016298, this.Ch = 502970286, this.Cl = 855612546, this.Dh = 1738396948, this.Dl = 1479516111, this.Eh = 258812777, this.El = 2077511080, this.Fh = 2011393907, this.Fl = 79989058, this.Gh = 1067287976, this.Gl = 1780299464, this.Hh = 286451373, this.Hl = -1848208735, this.outputLen = 28;
    }
  }
  class td extends hf {
    constructor() {
      super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
    }
  }
  class Ah extends hf {
    constructor() {
      super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
    }
  }
  const Bu = hc(() => new hf());
  hc(() => new ed()), hc(() => new td()), hc(() => new Ah());
  const uu = new Uint8Array([7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8]), Ya = Uint8Array.from({ length: 16 }, (ar, Je) => Je), rd = Ya.map((ar) => (9 * ar + 5) % 16);
  let mo = [Ya], Yf = [rd];
  for (let ar = 0; ar < 4; ar++)
    for (let Je of [mo, Yf])
      Je.push(Je[ar].map((pr) => uu[pr]));
  const nd = [
    [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
    [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
    [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
    [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
    [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
  ].map((ar) => new Uint8Array(ar)), Sr = mo.map((ar, Je) => ar.map((pr) => nd[Je][pr])), Tc = Yf.map((ar, Je) => ar.map((pr) => nd[Je][pr])), xc = new Uint32Array([0, 1518500249, 1859775393, 2400959708, 2840853838]), _u = new Uint32Array([1352829926, 1548603684, 1836072691, 2053994217, 0]), Xf = (ar, Je) => ar << Je | ar >>> 32 - Je;
  function gh(ar, Je, pr, Lr) {
    return ar === 0 ? Je ^ pr ^ Lr : ar === 1 ? Je & pr | ~Je & Lr : ar === 2 ? (Je | ~pr) ^ Lr : ar === 3 ? Je & Lr | pr & ~Lr : Je ^ (pr | ~Lr);
  }
  const _f = new Uint32Array(16);
  class Gg extends Cc {
    constructor() {
      super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
    }
    get() {
      const { h0: Je, h1: pr, h2: Lr, h3: hn, h4: mn } = this;
      return [Je, pr, Lr, hn, mn];
    }
    set(Je, pr, Lr, hn, mn) {
      this.h0 = Je | 0, this.h1 = pr | 0, this.h2 = Lr | 0, this.h3 = hn | 0, this.h4 = mn | 0;
    }
    process(Je, pr) {
      for (let es = 0; es < 16; es++, pr += 4)
        _f[es] = Je.getUint32(pr, !0);
      let Lr = this.h0 | 0, hn = Lr, mn = this.h1 | 0, qn = mn, Vn = this.h2 | 0, oi = Vn, li = this.h3 | 0, Di = li, mi = this.h4 | 0, is = mi;
      for (let es = 0; es < 5; es++) {
        const fs = 4 - es, Yi = xc[es], os = _u[es], ls = mo[es], Cs = Yf[es], bs = Sr[es], Zs = Tc[es];
        for (let Ms = 0; Ms < 16; Ms++) {
          const Os = Xf(Lr + gh(es, mn, Vn, li) + _f[ls[Ms]] + Yi, bs[Ms]) + mi | 0;
          Lr = mi, mi = li, li = Xf(Vn, 10) | 0, Vn = mn, mn = Os;
        }
        for (let Ms = 0; Ms < 16; Ms++) {
          const Os = Xf(hn + gh(fs, qn, oi, Di) + _f[Cs[Ms]] + os, Zs[Ms]) + is | 0;
          hn = is, is = Di, Di = Xf(oi, 10) | 0, oi = qn, qn = Os;
        }
      }
      this.set(this.h1 + Vn + Di | 0, this.h2 + li + is | 0, this.h3 + mi + hn | 0, this.h4 + Lr + qn | 0, this.h0 + mn + oi | 0);
    }
    roundClean() {
      _f.fill(0);
    }
    destroy() {
      this.destroyed = !0, this.buffer.fill(0), this.set(0, 0, 0, 0, 0);
    }
  }
  const jg = hc(() => new Gg());
  class ph extends Wf {
    constructor(Je, pr) {
      super(), this.finished = !1, this.destroyed = !1, dc.hash(Je);
      const Lr = cf(pr);
      if (this.iHash = Je.create(), typeof this.iHash.update != "function")
        throw new Error("Expected instance of class which extends utils.Hash");
      this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
      const hn = this.blockLen, mn = new Uint8Array(hn);
      mn.set(Lr.length > hn ? Je.create().update(Lr).digest() : Lr);
      for (let qn = 0; qn < mn.length; qn++)
        mn[qn] ^= 54;
      this.iHash.update(mn), this.oHash = Je.create();
      for (let qn = 0; qn < mn.length; qn++)
        mn[qn] ^= 106;
      this.oHash.update(mn), mn.fill(0);
    }
    update(Je) {
      return dc.exists(this), this.iHash.update(Je), this;
    }
    digestInto(Je) {
      dc.exists(this), dc.bytes(Je, this.outputLen), this.finished = !0, this.iHash.digestInto(Je), this.oHash.update(Je), this.oHash.digestInto(Je), this.destroy();
    }
    digest() {
      const Je = new Uint8Array(this.oHash.outputLen);
      return this.digestInto(Je), Je;
    }
    _cloneInto(Je) {
      Je || (Je = Object.create(Object.getPrototypeOf(this), {}));
      const { oHash: pr, iHash: Lr, finished: hn, destroyed: mn, blockLen: qn, outputLen: Vn } = this;
      return Je = Je, Je.finished = hn, Je.destroyed = mn, Je.blockLen = qn, Je.outputLen = Vn, Je.oHash = pr._cloneInto(Je.oHash), Je.iHash = Lr._cloneInto(Je.iHash), Je;
    }
    destroy() {
      this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
    }
  }
  const cu = (ar, Je, pr) => new ph(ar, Je).update(pr).digest();
  cu.create = (ar, Je) => new ph(ar, Je);
  function Zf(ar) {
    const Je = no.bytes(ar);
    return no.raw(ff(Je));
  }
  function Fu(ar) {
    const Je = no.bytes(ar);
    return no.raw(ff(ff(Je)));
  }
  function $f(ar) {
    const Je = no.bytes(ar);
    return no.raw(jg(ff(Je)));
  }
  function Vg(ar, Je) {
    const pr = no.bytes(ar), Lr = no.bytes(Je);
    return no.raw(cu(Bu, pr, Lr));
  }
  function Wg(ar) {
    const Je = no.str(ar).digest;
    return no.join([Je, Je]);
  }
  function zg(ar = 32) {
    return Lu(jl(ar));
  }
  function Lu(ar) {
    return Ba.mod(ar).buff;
  }
  function yh(ar, Je = !1) {
    const pr = Ba.mod(ar).point;
    return Je ? pr.x : pr.buff;
  }
  function mh(ar, Je) {
    const pr = wu.from_x(Je), Lr = Ba.mod(ar);
    return pr.mul(Lr).buff;
  }
  function ru(ar, Je, pr = "ecdh/code") {
    const Lr = Wg(pr), hn = Lu(ar), mn = yh(hn), qn = no.bytes(Je), Vn = mh(hn, qn), oi = [mn.hex, qn.hex];
    return oi.sort(), Vg(Vn, no.join([Lr, ...oi]));
  }
  function Jg(ar) {
    const Je = no.bytes(ar);
    switch (!0) {
      case Je.length === 32:
        return !0;
      case (Je.length === 33 && Je[0] === 2):
        return !0;
      case (Je.length === 33 && Je[0] === 3):
        return !1;
      default:
        throw new TypeError(`Invalid public key: ${Je.hex}`);
    }
  }
  function Ih(ar) {
    const Je = no.bytes(ar);
    switch (Je.length) {
      case 32:
        return Je;
      case 33:
        return Je.slice(1, 33);
      default:
        throw new Error(`Invalid key length: ${Je.length}`);
    }
  }
  var sd = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    genSecretKey: zg,
    getPublicKey: yh,
    getSecretKey: Lu,
    getSharedCode: ru,
    getSharedKey: mh,
    is_even_pub: Jg,
    xonly_pub: Ih
  });
  no.random(32);
  const Af = { secp: Qu }, Rc = { ...sd, ...Bg };
  function Hu(ar) {
    const Je = vr.bytes(ar);
    return Nr(Je, 33), $f(Je);
  }
  function wh(ar) {
    const Je = Mr.fmt.toBytes(ar, !1);
    return $f(Je);
  }
  function Mo(ar) {
    const Je = Mr.fmt.toBytes(ar, !1);
    return Zf(Je);
  }
  function bh(ar, Je = "main") {
    const pr = Je === "main" ? ["1"] : ["m", "n"];
    for (const Lr of pr)
      if (ar.startsWith(Lr))
        return !0;
    return !1;
  }
  function Eh(ar, Je = "main") {
    const pr = vr.bytes(ar), Lr = Je === "main" ? vr.num(0) : vr.num(111);
    return Nr(ar, 20), pr.prepend(Lr).tob58chk();
  }
  function Yg(ar, Je = "main") {
    if (!bh(ar, Je))
      throw new TypeError("Invalid p2pkh address!");
    return vr.b58chk(ar).slice(1);
  }
  function vu(ar) {
    const Je = vr.bytes(ar);
    return Nr(Je, 20), ["OP_DUP", "OP_HASH160", Je.hex, "OP_EQUALVERIFY", "OP_CHECKSIG"];
  }
  function Xg(ar, Je) {
    const pr = Hu(ar);
    return Eh(pr, Je);
  }
  const Bh = { check: bh, encode: Eh, decode: Yg, hash: Hu, scriptPubKey: vu, fromPubKey: Xg };
  function vh(ar, Je = "main") {
    const pr = Je === "main" ? ["3"] : ["2"];
    for (const Lr of pr)
      if (ar.startsWith(Lr))
        return !0;
    return !1;
  }
  function od(ar, Je = "main") {
    const pr = Je === "main" ? vr.num(5) : vr.num(196), Lr = vr.bytes(ar);
    return Nr(Lr, 20), Lr.prepend(pr).tob58chk();
  }
  function Ac(ar, Je = "main") {
    if (!vh(ar, Je))
      throw new TypeError(`Invalid p2sh address for network ${Je}:` + ar);
    return vr.b58chk(ar).slice(1);
  }
  function gf(ar) {
    return ["OP_HASH160", vr.bytes(ar).hex, "OP_EQUAL"];
  }
  function pf(ar, Je) {
    const pr = wh(ar);
    return od(pr, Je);
  }
  const Ch = { check: vh, encode: od, decode: Ac, hash: wh, scriptPubKey: gf, fromScript: pf }, ad = {
    main: "bc",
    testnet: "tb",
    signet: "tb",
    regtest: "bcrt"
  }, _g = ["bc1q", "tb1q", "bcrt1q"];
  function ha(ar) {
    for (const Je of _g)
      if (ar.startsWith(Je))
        return !0;
    return !1;
  }
  function kh(ar, Je = "main") {
    const pr = ad[Je], Lr = vr.bytes(ar);
    return Nr(Lr, 20), Lr.toBech32(pr, 0);
  }
  function Zg(ar) {
    if (!ha(ar))
      throw new TypeError("Invalid segwit address!");
    return vr.bech32(ar);
  }
  function $g(ar) {
    const Je = vr.bytes(ar);
    return Nr(Je, 20), ["OP_0", Je.hex];
  }
  function Sh(ar, Je) {
    const pr = Hu(ar);
    return kh(pr, Je);
  }
  const el = { check: ha, encode: kh, decode: Zg, hash: Hu, scriptPubKey: $g, fromPubKey: Sh }, ep = ["bc1q", "tb1q", "bcrt1q"];
  function Th(ar) {
    for (const Je of ep)
      if (ar.startsWith(Je))
        return !0;
    return !1;
  }
  function nu(ar, Je = "main") {
    const pr = ad[Je], Lr = vr.bytes(ar);
    return Nr(Lr, 32), Lr.toBech32(pr, 0);
  }
  function tp(ar) {
    if (!Th(ar))
      throw new TypeError("Invalid segwit address!");
    return vr.bech32(ar);
  }
  function tl(ar) {
    const Je = vr.bytes(ar);
    return Nr(Je, 32), ["OP_0", Je.hex];
  }
  function xh(ar, Je) {
    const pr = Mo(ar);
    return nu(pr, Je);
  }
  const ud = { check: Th, encode: nu, decode: tp, hash: Mo, scriptPubKey: tl, fromScript: xh };
  function Zu(ar) {
    const Je = vr.bytes(ar);
    return Je.length > 32 ? Je.slice(1, 33) : Je;
  }
  const rp = ["bc1p", "tb1p", "bcrt1p"];
  function yf(ar) {
    for (const Je of rp)
      if (ar.startsWith(Je))
        return !0;
    return !1;
  }
  function Dc(ar, Je = "main") {
    const pr = ad[Je], Lr = vr.bytes(ar);
    return Nr(Lr, 32), Lr.toBech32(pr, 1);
  }
  function np(ar) {
    if (!yf(ar))
      throw new TypeError("Invalid taproot address!");
    return vr.bech32(ar);
  }
  function ip(ar) {
    const Je = vr.bytes(ar);
    return Nr(Je, 32), ["OP_1", Je.hex];
  }
  function sp(ar, Je) {
    const pr = Zu(ar);
    return Dc(pr, Je);
  }
  const Rh = { check: yf, encode: Dc, decode: np, scriptPubKey: ip, fromPubKey: sp }, cd = {
    version: 2,
    vin: [],
    vout: [],
    locktime: 0
  }, Ku = {
    scriptSig: [],
    sequence: 4294967293,
    witness: []
  }, Dh = {
    value: 0n,
    scriptPubKey: []
  };
  function fd(ar) {
    const Je = { ...cd, ...ar };
    return Je.vin = Je.vin.map((pr) => ({ ...Ku, ...pr })), Je.vout = Je.vout.map((pr) => ({ ...Dh, ...pr })), Je;
  }
  function Nc(ar, Je) {
    const { version: pr, vin: Lr, vout: hn, locktime: mn } = fd(ar), qn = Je !== !0 && Nh(Lr), Vn = [oa(pr)];
    qn && Vn.push(vr.hex("0001")), Vn.push(op(Lr)), Vn.push(Ra(hn));
    for (const oi of Lr)
      qn && Vn.push(mf(oi.witness));
    return Vn.push(ld(mn)), vr.join(Vn);
  }
  function Nh(ar) {
    for (const Je of ar) {
      const { witness: pr } = Je;
      if (typeof pr == "string" || pr instanceof Uint8Array || Array.isArray(pr) && pr.length > 0)
        return !0;
    }
    return !1;
  }
  function oa(ar) {
    return vr.num(ar, 4).reverse();
  }
  function Pc(ar) {
    return vr.hex(ar, 32).reverse();
  }
  function gc(ar) {
    return vr.num(ar, 4).reverse();
  }
  function Oo(ar) {
    if (typeof ar == "string")
      return vr.hex(ar, 4).reverse();
    if (typeof ar == "number")
      return vr.num(ar, 4).reverse();
    throw new Error("Unrecognized format: " + String(ar));
  }
  function op(ar) {
    const Je = [vr.varInt(ar.length, "le")];
    for (const pr of ar) {
      const { txid: Lr, vout: hn, scriptSig: mn, sequence: qn } = pr;
      Je.push(Pc(Lr)), Je.push(gc(hn)), Je.push(L(mn, !0)), Je.push(Oo(qn));
    }
    return vr.join(Je);
  }
  function $u(ar) {
    if (typeof ar == "number") {
      if (ar % 1 !== 0)
        throw new Error("Value must be an integer:" + String(ar));
      return vr.num(ar, 8).reverse();
    }
    return vr.big(ar, 8).reverse();
  }
  function Ra(ar) {
    const Je = [vr.varInt(ar.length, "le")];
    for (const pr of ar)
      Je.push(ma(pr));
    return vr.join(Je);
  }
  function ma(ar) {
    const { value: Je, scriptPubKey: pr } = ar, Lr = [];
    return Lr.push($u(Je)), Lr.push(L(pr, !0)), vr.join(Lr);
  }
  function mf(ar = []) {
    const Je = [];
    if (Array.isArray(ar)) {
      const pr = vr.varInt(ar.length);
      Je.push(pr);
      for (const Lr of ar)
        Je.push(rl(Lr));
      return vr.join(Je);
    } else
      return vr.bytes(ar);
  }
  function rl(ar) {
    return Ph(ar) ? new vr(0) : L(ar, !0);
  }
  function Ph(ar) {
    if (Array.isArray(ar))
      return ar.length === 0;
    if (typeof ar == "string" && ar === "")
      return !0;
    const Je = vr.bytes(ar);
    return Je.length === 1 && Je[0] === 0;
  }
  function ld(ar) {
    if (typeof ar == "string")
      return vr.hex(ar, 4);
    if (typeof ar == "number")
      return vr.num(ar, 4).reverse();
    throw new Error("Unrecognized format: " + String(ar));
  }
  function dd(ar) {
    typeof ar == "string" && (ar = vr.hex(ar).raw);
    const Je = new pn(ar), pr = hd(Je), Lr = Aa(Je), hn = ap(Je), mn = qh(Je);
    if (Lr)
      for (const Vn of hn)
        Vn.witness = cp(Je);
    const qn = Ad(Je);
    return { version: pr, vin: hn, vout: mn, locktime: qn };
  }
  function hd(ar) {
    return ar.read(4).reverse().toNum();
  }
  function Aa(ar) {
    const [Je, pr] = [...ar.peek(2)];
    if (Je === 0) {
      if (ar.read(2), pr === 1)
        return !0;
      throw new Error(`Invalid witness flag: ${pr}`);
    }
    return !1;
  }
  function ap(ar) {
    const Je = [], pr = ar.readSize("le");
    for (let Lr = 0; Lr < pr; Lr++)
      Je.push(up(ar));
    return Je;
  }
  function up(ar) {
    return {
      txid: ar.read(32).reverse().toHex(),
      vout: ar.read(4).reverse().toNum(),
      scriptSig: If(ar),
      sequence: ar.read(4).reverse().toHex(),
      witness: []
    };
  }
  function qh(ar) {
    const Je = [], pr = ar.readSize("le");
    for (let Lr = 0; Lr < pr; Lr++)
      Je.push(Oh(ar));
    return Je;
  }
  function Oh(ar) {
    return {
      value: ar.read(8).reverse().big,
      scriptPubKey: If(ar)
    };
  }
  function cp(ar) {
    const Je = [], pr = ar.readSize();
    for (let Lr = 0; Lr < pr; Lr++) {
      const hn = Qh(ar);
      Je.push(hn ?? "");
    }
    return Je;
  }
  function Qh(ar, Je) {
    const pr = ar.readSize("le");
    return pr > 0 ? ar.read(pr).hex : null;
  }
  function If(ar, Je) {
    const pr = Qh(ar);
    return pr !== null ? pr : [];
  }
  function Ad(ar) {
    return ar.read(4).reverse().toNum();
  }
  function fp(ar) {
    if (E(ar))
      return dd(ar);
    if (typeof ar == "object" && !(ar instanceof Uint8Array))
      return Nc(ar), fd(ar);
    throw new Error("Invalid format: " + typeof ar);
  }
  function Uh(ar) {
    if (E(ar))
      return dd(ar), vr.bytes(ar);
    if (typeof ar == "object")
      return Nc(ar);
    throw new Error("Invalid format: " + typeof ar);
  }
  const gd = {
    toBytes: Uh,
    toJson: fp
  }, nl = [
    ["p2pkh", /^76a914(?<hash>\w{40})88ac$/],
    ["p2sh", /^a914(?<hash>\w{40})87$/],
    ["p2w-pkh", /^0014(?<hash>\w{40})$/],
    ["p2w-sh", /^0020(?<hash>\w{64})$/],
    ["p2tr", /^5120(?<hash>\w{64})$/]
  ], Mh = [
    192,
    194,
    196,
    198,
    200,
    202,
    204,
    206,
    208,
    210,
    212,
    214,
    216,
    218,
    220,
    222,
    224,
    226,
    228,
    230,
    232,
    234,
    236,
    238,
    240,
    242,
    244,
    246,
    248,
    250,
    252,
    254,
    102,
    126,
    128,
    132,
    150,
    152,
    186,
    188,
    190
  ];
  function lp(ar) {
    let Je = ar.at(-1);
    return a(Je) && (Je = vr.hex(Je)), ar.length > 1 && Je instanceof Uint8Array && Je[0] === 80 ? (ar.pop(), vr.raw(Je)) : null;
  }
  function dp(ar) {
    let Je = ar.at(-1);
    return a(Je) && (Je = vr.hex(Je)), ar.length > 1 && Je instanceof Uint8Array && Je.length > 32 && Mh.includes(Je[0] & 254) ? (ar.pop(), vr.raw(Je)) : null;
  }
  function pd(ar) {
    if (ar.length > 1) {
      const Je = ar.at(-1);
      try {
        const pr = Mr.fmt.toBytes(Je);
        return ar.pop(), pr;
      } catch {
        return null;
      }
    }
    return null;
  }
  function hp(ar) {
    const Je = [];
    for (const pr of ar)
      if (a(pr) || pr instanceof Uint8Array || typeof pr == "number")
        Je.push(vr.bytes(pr));
      else
        throw new Error("unrecognized value: " + String(pr));
    return Je;
  }
  function Fh(ar = []) {
    const Je = [...ar], pr = lp(Je), Lr = dp(Je), hn = pd(Je), mn = hp(Je);
    return { annex: pr, cblock: Lr, script: hn, params: mn };
  }
  function yd(ar) {
    const Je = Mr.fmt.toBytes(ar, !1).hex;
    for (const [pr, Lr] of nl) {
      const hn = pr, { groups: mn } = Lr.exec(Je) ?? {}, { hash: qn } = mn ?? {};
      if (a(qn))
        return { type: hn, data: vr.hex(qn) };
    }
    return { type: "raw", data: vr.hex(Je) };
  }
  function il(ar) {
    const Je = gd.toJson(ar), pr = Nc(Je, !0);
    return Fu(pr).reverse().hex;
  }
  function Io(ar) {
    const Je = gd.toJson(ar), pr = Nc(Je, !0).length, Lr = Nc(Je, !1).length, hn = pr * 3 + Lr, mn = hn % 4 > 0 ? 1 : 0, qn = Math.floor(hn / 4) + mn;
    return { size: Lr, bsize: pr, vsize: qn, weight: hn };
  }
  const La = {
    create: fd,
    encode: Nc,
    decode: dd,
    fmt: gd,
    util: {
      getTxSize: Io,
      getTxid: il,
      readScriptPubKey: yd,
      readWitness: Fh
    }
  }, Ap = [
    ["1", "p2pkh", "main", 20, "base58"],
    ["3", "p2sh", "main", 20, "base58"],
    ["m", "p2pkh", "testnet", 20, "base58"],
    ["n", "p2pkh", "testnet", 20, "base58"],
    ["2", "p2sh", "testnet", 20, "base58"],
    ["bc1q", "p2w-pkh", "main", 20, "bech32"],
    ["tb1q", "p2w-pkh", "testnet", 20, "bech32"],
    ["bcrt1q", "p2w-pkh", "regtest", 20, "bech32"],
    ["bc1q", "p2w-sh", "main", 32, "bech32"],
    ["tb1q", "p2w-sh", "testnet", 32, "bech32"],
    ["bcrt1q", "p2w-sh", "regtest", 32, "bech32"],
    ["bc1p", "p2tr", "main", 32, "bech32m"],
    ["tb1p", "p2tr", "testnet", 32, "bech32m"],
    ["bcrt1p", "p2tr", "regtest", 32, "bech32m"]
  ];
  function gp(ar, Je) {
    switch (Je) {
      case "base58":
        return vr.b58chk(ar).slice(1);
      case "bech32":
        return vr.bech32(ar);
      case "bech32m":
        return vr.bech32(ar);
      default:
        throw new Error("Invalid address format: " + Je);
    }
  }
  function pp(ar) {
    for (const Je of Ap) {
      const [pr, Lr, hn, mn, qn] = Je;
      if (ar.startsWith(pr) && gp(ar, qn).length === mn)
        return Je;
    }
    throw new Error("Invalid address: " + ar);
  }
  function pc(ar) {
    switch (ar) {
      case "p2pkh":
        return Bh;
      case "p2sh":
        return Ch;
      case "p2w-pkh":
        return el;
      case "p2w-sh":
        return ud;
      case "p2tr":
        return Rh;
      default:
        throw new Error("Invalid address type: " + ar);
    }
  }
  function fu(ar) {
    const [Je, pr, Lr] = pp(ar), hn = pc(pr), mn = hn.decode(ar, Lr), qn = hn.scriptPubKey(mn);
    return { prefix: Je, type: pr, network: Lr, data: mn, script: qn };
  }
  function yp(ar, Je) {
    const { type: pr, data: Lr } = La.util.readScriptPubKey(ar);
    return pc(pr).encode(Lr, Je);
  }
  function md(ar) {
    const { script: Je } = fu(ar);
    return Mr.fmt.toAsm(Je, !1);
  }
  const sl = {
    p2pkh: Bh,
    p2sh: Ch,
    p2wpkh: el,
    p2wsh: ud,
    p2tr: Rh,
    decode: fu,
    fromScriptPubKey: yp,
    toScriptPubKey: md
  }, mp = [1, 2, 3];
  function Cu(ar, Je, pr = {}) {
    const { sigflag: Lr = 1 } = pr, hn = (Lr & 128) === 128, mn = Lr % 128;
    if (!mp.includes(mn))
      throw new Error("Invalid hash type: " + String(Lr));
    const qn = La.fmt.toJson(ar), { version: Vn, vin: oi, vout: li, locktime: Di } = qn, { txid: mi, vout: is, prevout: es, sequence: fs } = oi[Je], { value: Yi } = es ?? {};
    if (Yi === void 0)
      throw new Error("Prevout value is empty!");
    let os = pr.script;
    if (os === void 0 && pr.pubkey !== void 0 && (os = `76a914${$f(pr.pubkey).hex}88ac`), os === void 0)
      throw new Error("No pubkey / script has been set!");
    if (Mr.fmt.toAsm(os).includes("OP_CODESEPARATOR"))
      throw new Error("This library does not currently support the use of OP_CODESEPARATOR in segwit scripts.");
    const ls = [
      oa(Vn),
      ol(oi, hn),
      Ip(oi, mn, hn),
      Pc(mi),
      gc(is),
      Mr.encode(os, !0),
      $u(Yi),
      Oo(fs),
      wp(li, Je, mn),
      ld(Di),
      vr.num(Lr, 4).reverse()
    ];
    return Fu(vr.join(ls));
  }
  function ol(ar, Je) {
    if (Je === !0)
      return vr.num(0, 32);
    const pr = [];
    for (const { txid: Lr, vout: hn } of ar)
      pr.push(Pc(Lr)), pr.push(gc(hn));
    return Fu(vr.join(pr));
  }
  function Ip(ar, Je, pr) {
    if (pr || Je !== 1)
      return vr.num(0, 32);
    const Lr = [];
    for (const { sequence: hn } of ar)
      Lr.push(Oo(hn));
    return Fu(vr.join(Lr));
  }
  function wp(ar, Je, pr) {
    const Lr = [];
    if (pr === 1) {
      for (const { value: hn, scriptPubKey: mn } of ar)
        Lr.push($u(hn)), Lr.push(Mr.encode(mn, !0));
      return Fu(vr.join(Lr));
    }
    if (pr === 3 && Je < ar.length) {
      const { value: hn, scriptPubKey: mn } = ar[Je];
      return Lr.push($u(hn)), Lr.push(Mr.encode(mn, !0)), Fu(vr.join(Lr));
    }
    return vr.num(0, 32);
  }
  function bp(ar, Je, pr, Lr = {}) {
    const { sigflag: hn = 1 } = Lr, mn = Cu(Je, pr, Lr), qn = Af.secp.sign(mn, ar).toDERRawBytes(!0);
    return vr.join([qn, hn]);
  }
  function Ep(ar, Je, pr = {}) {
    const Lr = La.fmt.toJson(ar), { throws: hn = !1 } = pr, { witness: mn = [] } = Lr.vin[Je], qn = La.util.readWitness(mn), { script: Vn, params: oi } = qn;
    let li = null;
    if (oi.length < 1)
      return Qn("Invalid witness data: " + String(mn), hn);
    if (pr.script === void 0 && Vn !== null && (pr.script = Vn), pr.pubkey !== void 0)
      li = vr.bytes(pr.pubkey);
    else if (oi.length > 1 && oi[1].length === 33)
      li = vr.bytes(oi[1]);
    else
      return Qn("No pubkey provided!", hn);
    const Di = Mr.fmt.toParam(oi[0]), mi = Di.slice(0, -1), is = Di.slice(-1)[0], es = Cu(Lr, Je, { ...pr, sigflag: is });
    return Af.secp.verify(mi, es, li) ? !0 : Qn("Invalid signature!", hn);
  }
  const ga = {
    hash: Cu,
    sign: bp,
    verify: Ep
  }, Da = [0, 1, 2, 3, 129, 130, 131];
  function pa(ar, Je, pr = {}) {
    const { extension: Lr, sigflag: hn = 0, extflag: mn = 0, key_version: qn = 0, separator_pos: Vn = 4294967295 } = pr, oi = La.fmt.toJson(ar), { version: li, vin: Di, vout: mi, locktime: is } = oi;
    if (Je >= Di.length)
      throw new Error("Index out of bounds: " + String(Je));
    if (!Da.includes(hn))
      throw new Error("Invalid hash type: " + String(hn));
    if (mn < 0 || mn > 127)
      throw new Error("Extention flag out of range: " + String(mn));
    const { txid: es, vout: fs, sequence: Yi, witness: os = [] } = Di[Je], ls = (hn & 128) === 128, Cs = Cp(os), bs = Cs !== void 0 ? 1 : 0, Ms = (mn + (Lr !== void 0 ? 1 : 0)) * 2 + bs, Os = vr.str("TapSighash").digest, Hs = [
      Os,
      Os,
      vr.num(0, 1),
      vr.num(hn, 1),
      oa(li),
      ld(is)
    ];
    if (!ls) {
      const Ys = Di.map((Xo) => al(Xo));
      Hs.push(Bp(Di), Lh(Ys), wd(Ys), Ha(Di));
    }
    if (((hn & 3) < 2 || (hn & 3) > 3) && Hs.push(Hh(mi)), Hs.push(vr.num(Ms, 1)), ls) {
      const { value: Ys, scriptPubKey: Xo } = al(Di[Je]);
      Hs.push(Pc(es), gc(fs), $u(Ys), Mr.encode(Xo, !0), Oo(Yi));
    } else
      Hs.push(vr.num(Je, 4).reverse());
    return Cs !== void 0 && Hs.push(Cs), (hn & 3) === 3 && Hs.push(vp(mi[Je])), Lr !== void 0 && Hs.push(vr.bytes(Lr), vr.num(qn), vr.num(Vn, 4, "le")), vr.join(Hs).digest;
  }
  function Bp(ar) {
    const Je = [];
    for (const { txid: pr, vout: Lr } of ar)
      Je.push(Pc(pr)), Je.push(gc(Lr));
    return vr.join(Je).digest;
  }
  function Ha(ar) {
    const Je = [];
    for (const { sequence: pr } of ar)
      Je.push(Oo(pr));
    return vr.join(Je).digest;
  }
  function Lh(ar) {
    const Je = [];
    for (const { value: pr } of ar)
      Je.push($u(pr));
    return vr.join(Je).digest;
  }
  function wd(ar) {
    const Je = [];
    for (const { scriptPubKey: pr } of ar)
      Je.push(L(pr, !0));
    return vr.join(Je).digest;
  }
  function Hh(ar) {
    const Je = [];
    for (const { value: pr, scriptPubKey: Lr } of ar)
      Je.push($u(pr)), Je.push(Mr.encode(Lr, !0));
    return vr.join(Je).digest;
  }
  function vp(ar) {
    return vr.join([
      $u(ar.value),
      Mr.encode(ar.scriptPubKey, !0)
    ]).digest;
  }
  function Cp(ar) {
    if (ar === void 0 || ar.length < 2)
      return;
    let Je = ar.at(-1);
    if (typeof Je == "string" && (Je = vr.hex(Je)), Je instanceof Uint8Array && Je[0] === 80)
      return vr.raw(Je).prefixSize("be").digest;
  }
  function al(ar) {
    if (ar.prevout === void 0)
      throw new Error("Prevout data missing for input: " + String(ar.txid));
    return ar.prevout;
  }
  const qc = 0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2fn, lu = 0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141n;
  function xo(ar, Je, pr, Lr = {}) {
    const { sigflag: hn = 0 } = Lr, mn = pa(Je, pr, Lr), qn = Oc(ar, mn);
    return hn === 0 ? vr.raw(qn) : vr.join([qn, hn]);
  }
  function Oc(ar, Je, pr = vr.random(32)) {
    const Lr = vr.bytes(Je), hn = new Ba(ar), mn = hn.point, qn = mn.hasEvenY ? hn.big : hn.negated.big, Vn = zn("BIP0340/aux", vr.bytes(pr)), oi = qn ^ Vn.big, li = zn("BIP0340/nonce", oi, mn.x.raw, Lr), Di = new Ba(li), mi = Di.point, is = mi.hasEvenY ? Di.big : Di.negated.big, es = new Ba(zn("BIP0340/challenge", mi.x.raw, mn.x.raw, Lr)), fs = new Ba(is + es.big * qn);
    return vr.join([mi.x.raw, fs.raw]);
  }
  function kp(ar, Je, pr, Lr = !1) {
    const hn = wu.from_x(Zu(pr)), mn = vr.bytes(Je), qn = vr.bytes(ar).stream;
    qn.size < 64 && Qn("Signature length is too small: " + String(qn.size), Lr);
    const Vn = qn.read(32);
    Vn.big > qc && Qn("Signature r value greater than field size!", Lr);
    const oi = qn.read(32);
    oi.big > lu && Qn("Signature s value greater than curve order!", Lr);
    const li = new Ba(zn("BIP0340/challenge", Vn.raw, hn.x.raw, mn)), Di = new Ba(oi).point, mi = hn.mul(li.big), is = Di.sub(mi);
    return is.hasOddY && Qn("Signature R value has odd Y coordinate!", Lr), is.x.big === 0n && Qn("Signature R value is infinite!", Lr), is.x.big === Vn.big;
  }
  const Sp = 192;
  function wf(ar) {
    const Je = vr.str(ar).digest;
    return vr.join([Je, Je]);
  }
  function i2(ar, Je = Sp) {
    return vr.join([
      wf("TapLeaf"),
      Gh(Je),
      vr.bytes(ar)
    ]).digest.hex;
  }
  function Kh(ar, Je) {
    return i2(Mr.fmt.toBytes(ar), Je);
  }
  function lo(ar, Je) {
    return Je < ar && ([ar, Je] = [Je, ar]), vr.join([
      wf("TapBranch"),
      vr.hex(ar).raw,
      vr.hex(Je).raw
    ]).digest.hex;
  }
  function du(ar) {
    return vr.hex(bf(ar)[0]);
  }
  function bf(ar, Je, pr = []) {
    const Lr = [], hn = [];
    if (ar.length < 1)
      throw new Error("Tree is empty!");
    for (let mn = 0; mn < ar.length; mn++) {
      const qn = ar[mn];
      if (Array.isArray(qn)) {
        const [Vn, oi, li] = bf(qn, Je);
        Je = oi, Lr.push(Vn);
        for (const Di of li)
          pr.push(Di);
      } else
        Lr.push(qn);
    }
    if (Lr.length === 1)
      return [Lr[0], Je, pr];
    Lr.sort(), Lr.length % 2 !== 0 && Lr.push(Lr[Lr.length - 1]);
    for (let mn = 0; mn < Lr.length - 1; mn += 2) {
      const qn = lo(Lr[mn], Lr[mn + 1]);
      hn.push(qn), typeof Je == "string" && (Je === Lr[mn] ? (pr.push(Lr[mn + 1]), Je = qn) : Je === Lr[mn + 1] && (pr.push(Lr[mn]), Je = qn));
    }
    return bf(hn, Je, pr);
  }
  function Gh(ar = 192) {
    return ar & 254;
  }
  function bd(ar, Je = new Uint8Array(), pr = !1) {
    const Lr = pr ? new Ba(ar).point.x.raw : Zu(ar);
    return vr.join([wf("TapTweak"), Lr, vr.bytes(Je)]).digest;
  }
  function va(ar, Je, pr = !1) {
    Je === void 0 && (Je = new Uint8Array());
    const Lr = vr.bytes(ar), hn = bd(ar, Je, pr);
    return pr ? Vh(Lr, hn) : Wh(Lr, hn);
  }
  function jh(ar, Je) {
    return va(ar, Je);
  }
  function Ka(ar, Je) {
    return va(ar, Je, !0);
  }
  function Vh(ar, Je) {
    let pr = new Ba(ar);
    return pr.point.hasOddY && (pr = pr.negate()), vr.raw(pr.add(Je).raw);
  }
  function Wh(ar, Je) {
    ar = Zu(ar);
    const Lr = wu.from_x(ar).add(Je);
    return vr.raw(Lr.raw);
  }
  function zh() {
    const ar = vr.hex("0479be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8");
    return wu.from_x(ar.digest).x;
  }
  const Ga = zh(), Tp = 192;
  function xp(ar, Je = {}) {
    return Jh(ar, { ...Je, isPrivate: !0 });
  }
  function so(ar, Je = {}) {
    return Jh(ar, { ...Je, isPrivate: !1 });
  }
  function Jh(ar, Je = {}) {
    const { isPrivate: pr = !1, tree: Lr = [], version: hn = Tp } = Je, mn = pr ? Rc.getPublicKey(ar, !0) : Zu(ar);
    let { target: qn } = Je;
    qn !== void 0 && (qn = vr.bytes(qn).hex);
    let Vn, oi = [];
    if (Lr.length > 0) {
      const [es, fs, Yi] = bf(Lr, qn);
      oi = Yi, Vn = va(ar, es, pr);
    } else
      qn !== void 0 ? Vn = va(ar, qn, pr) : Vn = va(ar, void 0, pr);
    const li = pr ? Rc.getPublicKey(Vn)[0] : Vn[0], mi = [vr.num(hn + cl(li)), mn];
    oi.length > 0 && oi.forEach((es) => mi.push(vr.hex(es)));
    const is = vr.join(mi);
    if (qn !== void 0 && !ul(Vn, qn, is, Je))
      throw new Error("Path checking failed! Unable to generate path.");
    return [Zu(Vn).hex, is.hex];
  }
  function ul(ar, Je, pr, Lr = {}) {
    const { isPrivate: hn = !1, throws: mn = !1 } = Lr, { parity: qn, paths: Vn, intkey: oi } = Yh(pr), li = hn ? Rc.getPublicKey(ar, !0) : Zu(ar), Di = vr.join([qn, li]);
    if (Di.length !== 33)
      return Qn("Invalid tapkey: " + Di.hex, mn);
    let mi = vr.bytes(Je).hex;
    for (const es of Vn)
      mi = lo(mi, es);
    const is = va(oi, mi);
    return vr.raw(is).hex === vr.raw(Di).hex;
  }
  function Yh(ar) {
    const Je = new pn(vr.bytes(ar)), pr = Je.read(1).num, Lr = Je.read(32), [hn, mn] = pr % 2 === 0 ? [pr, 2] : [pr - 1, 3], qn = [];
    for (; Je.size >= 32; )
      qn.push(Je.read(32).hex);
    if (Je.size !== 0)
      throw new Error("Non-empty buffer on control block: " + String(Je));
    return { intkey: Lr, paths: qn, parity: mn, version: hn };
  }
  function cl(ar = 2) {
    if (ar === 0 || ar === 1)
      return ar;
    if (ar === 2 || ar === "02")
      return 0;
    if (ar === 3 || ar === "03")
      return 1;
    throw new Error("Invalid parity bit: " + String(ar));
  }
  function Ed(ar, Je, pr = {}) {
    const Lr = La.fmt.toJson(ar), { throws: hn = !1 } = pr, { prevout: mn, witness: qn = [] } = Lr.vin[Je], Vn = La.util.readWitness(qn), { cblock: oi, script: li, params: Di } = Vn;
    let mi;
    if (Di.length < 1)
      return Qn("Invalid witness data: " + String(qn), hn);
    const { scriptPubKey: is } = mn ?? {};
    if (is === void 0)
      return Qn("Prevout scriptPubKey is empty!", hn);
    const { type: es, data: fs } = La.util.readScriptPubKey(is);
    if (es !== "p2tr")
      return Qn("Prevout script is not a valid taproot output:" + fs.hex, hn);
    if (fs.length !== 32)
      return Qn("Invalid tapkey length: " + String(fs.length), hn);
    if (oi !== null && li !== null) {
      const bs = oi[0] & 254, Zs = i2(li, bs);
      if (pr.extension = Zs, !ul(fs, Zs, oi, { throws: hn }))
        return Qn("cblock verification failed!", hn);
    }
    pr.pubkey !== void 0 ? mi = vr.bytes(pr.pubkey) : Di.length > 1 && Di[1].length === 32 ? mi = vr.bytes(Di[1]) : mi = vr.bytes(fs);
    const Yi = Mr.fmt.toParam(Di[0]), os = new pn(Yi), ls = os.read(64).raw;
    if (os.size === 1 && (pr.sigflag = os.read(1).num, pr.sigflag === 0))
      return Qn("0x00 is not a valid appended sigflag!", hn);
    const Cs = pa(Lr, Je, pr);
    return kp(ls, Cs, mi, hn) ? !0 : Qn("Invalid signature!", hn);
  }
  const ua = {
    segwit: ga,
    taproot: {
      hash: pa,
      sign: xo,
      verify: Ed
    }
  }, Qc = {
    getTag: wf,
    getLeaf: i2,
    getBranch: lo,
    getRoot: du
  }, Dp = {
    getPubKey: so,
    getSecKey: xp,
    encodeScript: Kh,
    checkPath: ul,
    tree: Qc,
    tweak: {
      getPubKey: jh,
      getSecKey: Ka,
      getTweak: bd,
      tweakSecKey: Vh,
      tweakPubKey: Wh
    },
    util: {
      readCtrlBlock: Yh,
      readParityBit: cl
    },
    SCRIPT_PUBKEY: Ga
  };
  class Xh {
    constructor(Je) {
      this._buff = vr.raw(L(Je));
    }
    get raw() {
      return this._buff.raw;
    }
    get hex() {
      return this._buff.hex;
    }
    get asm() {
      return or(this._buff);
    }
    getHash(Je, pr) {
      switch (Je) {
        case "p2w":
          return Fu(this._buff).hex;
        case "p2sh":
          return $f(this._buff).hex;
        case "p2tr":
          return Qc.getLeaf(this._buff, pr);
        default:
          throw new Error("Unrecognized format: " + Je);
      }
    }
    toJSON() {
      return this.asm ?? [];
    }
  }
  const _h = 4294967295, Np = 1 << 31, yc = 512, Pp = 1 << 22;
  class Zh {
    constructor(Je) {
      typeof Je == "string" ? this.value = parseInt(Je, 16) : this.value = Je;
    }
    get isReplaceable() {
      return this.value < _h;
    }
    get isLocked() {
      return !(this.value !== _h || (this.value & Np) !== 0);
    }
    get isTimelock() {
      return (this.value & Pp) !== 0;
    }
    get timestamp() {
      return this.isLocked ? this.isTimelock ? this.value * yc : this.value * yc * 600 : 0;
    }
    set timestamp(Je) {
      this.value = Math.ceil(Je / yc);
    }
    get blockheight() {
      return this.isLocked ? this.isTimelock ? Math.ceil(this.value * yc / 600) : this.value : 0;
    }
    set blockheight(Je) {
      this.value = Je;
    }
    get estDate() {
      return this.isTimelock ? new Date(Date.now() + this.value * yc * 1e3) : new Date(Date.now() + this.value * 600 * 1e3);
    }
    set estDate(Je) {
      const pr = Je.getTime() - Date.now();
      this.value = pr > yc * 1e3 ? Math.ceil(pr / 1e3 / yc) : 1;
    }
    toJSON() {
      return this.value;
    }
  }
  let Bd = class {
    constructor(Je) {
      this.value = BigInt(Je.value), this.scriptPubKey = new Xh(Je.scriptPubKey);
    }
    get type() {
      const { type: Je } = yd(this.scriptPubKey.raw);
      return Je;
    }
  };
  class $h {
    constructor(Je, pr) {
      this._data = Je, this._meta = Fh(Je), this.format = pr;
    }
    get length() {
      return this._data.length;
    }
    get annex() {
      const Je = this._meta.annex;
      return Je !== null ? vr.raw(Je).hex : void 0;
    }
    get cblock() {
      const Je = this._meta.cblock;
      return Je !== null ? vr.raw(Je).hex : void 0;
    }
    get script() {
      const Je = this._meta.script;
      return Je !== null ? Mr.decode(Je) : void 0;
    }
    get params() {
      return this._meta.params;
    }
    toJSON() {
      return this._data;
    }
  }
  let eA = class {
    constructor(Je, pr) {
      this._tx = Je, this.idx = pr;
    }
    get data() {
      return this._tx.vin[this.idx];
    }
    get txid() {
      return this.data.txid;
    }
    get vout() {
      return this.data.vout;
    }
    get prevout() {
      return this.data.prevout !== void 0 ? new Bd(this.data.prevout) : void 0;
    }
    get scriptSig() {
      return new Xh(this.data.scriptSig);
    }
    get sequence() {
      return new Zh(this.data.sequence);
    }
    get witness() {
      return new $h(this.data.witness);
    }
    get type() {
      if (this.prevout !== void 0) {
        const Je = this.prevout.scriptPubKey.raw, { type: pr } = yd(Je);
        if (pr === "p2sh") {
          const Lr = this.scriptSig.asm;
          if (Lr[0] === "OP_0") {
            if (Lr[1].length === 20)
              return "p2w-p2pkh";
            if (Lr[1].length === 32)
              return "p2w-p2sh";
          }
          return "p2sh";
        }
        return pr;
      }
      return "raw";
    }
    sign(Je, pr) {
      if (this.type.startsWith("p2w"))
        return ua.segwit.sign(Je, this._tx, this.idx, pr);
      if (this.type.startsWith("p2tr"))
        return ua.taproot.sign(Je, this._tx, this.idx, pr);
      throw this.type.startsWith("p2pkh") || this.type.startsWith("p2sh") ? new Error("This library does not support signing legacy transactions.") : new Error("Unable to sign this input type:" + String(this.type));
    }
  };
  const qp = 5e8;
  class Op {
    constructor(Je = 0) {
      this.value = vr.bytes(Je).num;
    }
    get isTimelock() {
      return this.value > qp;
    }
    get timestamp() {
      return this.isTimelock ? this.value : this.value * 600;
    }
    set timestamp(Je) {
      this.value = Je;
    }
    get blockheight() {
      return this.isTimelock ? Math.floor(this.value / 600) : this.value;
    }
    set blockheight(Je) {
      this.value = Je;
    }
    get estDate() {
      return this.isTimelock ? new Date(Date.now() + this.value * 1e3) : new Date(Date.now() + this.value * 600 * 1e3);
    }
    set estDate(Je) {
      this.value = Math.floor((Je.getTime() - Date.now()) / 1e3);
    }
    toJSON() {
      return this.value;
    }
  }
  var Fo;
  (function(ar) {
    ar.assertEqual = (hn) => hn;
    function Je(hn) {
    }
    ar.assertIs = Je;
    function pr(hn) {
      throw new Error();
    }
    ar.assertNever = pr, ar.arrayToEnum = (hn) => {
      const mn = {};
      for (const qn of hn)
        mn[qn] = qn;
      return mn;
    }, ar.getValidEnumValues = (hn) => {
      const mn = ar.objectKeys(hn).filter((Vn) => typeof hn[hn[Vn]] != "number"), qn = {};
      for (const Vn of mn)
        qn[Vn] = hn[Vn];
      return ar.objectValues(qn);
    }, ar.objectValues = (hn) => ar.objectKeys(hn).map(function(mn) {
      return hn[mn];
    }), ar.objectKeys = typeof Object.keys == "function" ? (hn) => Object.keys(hn) : (hn) => {
      const mn = [];
      for (const qn in hn)
        Object.prototype.hasOwnProperty.call(hn, qn) && mn.push(qn);
      return mn;
    }, ar.find = (hn, mn) => {
      for (const qn of hn)
        if (mn(qn))
          return qn;
    }, ar.isInteger = typeof Number.isInteger == "function" ? (hn) => Number.isInteger(hn) : (hn) => typeof hn == "number" && isFinite(hn) && Math.floor(hn) === hn;
    function Lr(hn, mn = " | ") {
      return hn.map((qn) => typeof qn == "string" ? `'${qn}'` : qn).join(mn);
    }
    ar.joinValues = Lr, ar.jsonStringifyReplacer = (hn, mn) => typeof mn == "bigint" ? mn.toString() : mn;
  })(Fo || (Fo = {}));
  var vd;
  (function(ar) {
    ar.mergeShapes = (Je, pr) => ({
      ...Je,
      ...pr
      // second overwrites first
    });
  })(vd || (vd = {}));
  const Ns = Fo.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
  ]), l2 = (ar) => {
    switch (typeof ar) {
      case "undefined":
        return Ns.undefined;
      case "string":
        return Ns.string;
      case "number":
        return isNaN(ar) ? Ns.nan : Ns.number;
      case "boolean":
        return Ns.boolean;
      case "function":
        return Ns.function;
      case "bigint":
        return Ns.bigint;
      case "symbol":
        return Ns.symbol;
      case "object":
        return Array.isArray(ar) ? Ns.array : ar === null ? Ns.null : ar.then && typeof ar.then == "function" && ar.catch && typeof ar.catch == "function" ? Ns.promise : typeof Map < "u" && ar instanceof Map ? Ns.map : typeof Set < "u" && ar instanceof Set ? Ns.set : typeof Date < "u" && ar instanceof Date ? Ns.date : Ns.object;
      default:
        return Ns.unknown;
    }
  }, ys = Fo.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
  ]), Qp = (ar) => JSON.stringify(ar, null, 2).replace(/"([^"]+)":/g, "$1:");
  class hu extends Error {
    constructor(Je) {
      super(), this.issues = [], this.addIssue = (Lr) => {
        this.issues = [...this.issues, Lr];
      }, this.addIssues = (Lr = []) => {
        this.issues = [...this.issues, ...Lr];
      };
      const pr = new.target.prototype;
      Object.setPrototypeOf ? Object.setPrototypeOf(this, pr) : this.__proto__ = pr, this.name = "ZodError", this.issues = Je;
    }
    get errors() {
      return this.issues;
    }
    format(Je) {
      const pr = Je || function(mn) {
        return mn.message;
      }, Lr = { _errors: [] }, hn = (mn) => {
        for (const qn of mn.issues)
          if (qn.code === "invalid_union")
            qn.unionErrors.map(hn);
          else if (qn.code === "invalid_return_type")
            hn(qn.returnTypeError);
          else if (qn.code === "invalid_arguments")
            hn(qn.argumentsError);
          else if (qn.path.length === 0)
            Lr._errors.push(pr(qn));
          else {
            let Vn = Lr, oi = 0;
            for (; oi < qn.path.length; ) {
              const li = qn.path[oi];
              oi === qn.path.length - 1 ? (Vn[li] = Vn[li] || { _errors: [] }, Vn[li]._errors.push(pr(qn))) : Vn[li] = Vn[li] || { _errors: [] }, Vn = Vn[li], oi++;
            }
          }
      };
      return hn(this), Lr;
    }
    toString() {
      return this.message;
    }
    get message() {
      return JSON.stringify(this.issues, Fo.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
      return this.issues.length === 0;
    }
    flatten(Je = (pr) => pr.message) {
      const pr = {}, Lr = [];
      for (const hn of this.issues)
        hn.path.length > 0 ? (pr[hn.path[0]] = pr[hn.path[0]] || [], pr[hn.path[0]].push(Je(hn))) : Lr.push(Je(hn));
      return { formErrors: Lr, fieldErrors: pr };
    }
    get formErrors() {
      return this.flatten();
    }
  }
  hu.create = (ar) => new hu(ar);
  const Ef = (ar, Je) => {
    let pr;
    switch (ar.code) {
      case ys.invalid_type:
        ar.received === Ns.undefined ? pr = "Required" : pr = `Expected ${ar.expected}, received ${ar.received}`;
        break;
      case ys.invalid_literal:
        pr = `Invalid literal value, expected ${JSON.stringify(ar.expected, Fo.jsonStringifyReplacer)}`;
        break;
      case ys.unrecognized_keys:
        pr = `Unrecognized key(s) in object: ${Fo.joinValues(ar.keys, ", ")}`;
        break;
      case ys.invalid_union:
        pr = "Invalid input";
        break;
      case ys.invalid_union_discriminator:
        pr = `Invalid discriminator value. Expected ${Fo.joinValues(ar.options)}`;
        break;
      case ys.invalid_enum_value:
        pr = `Invalid enum value. Expected ${Fo.joinValues(ar.options)}, received '${ar.received}'`;
        break;
      case ys.invalid_arguments:
        pr = "Invalid function arguments";
        break;
      case ys.invalid_return_type:
        pr = "Invalid function return type";
        break;
      case ys.invalid_date:
        pr = "Invalid date";
        break;
      case ys.invalid_string:
        typeof ar.validation == "object" ? "includes" in ar.validation ? (pr = `Invalid input: must include "${ar.validation.includes}"`, typeof ar.validation.position == "number" && (pr = `${pr} at one or more positions greater than or equal to ${ar.validation.position}`)) : "startsWith" in ar.validation ? pr = `Invalid input: must start with "${ar.validation.startsWith}"` : "endsWith" in ar.validation ? pr = `Invalid input: must end with "${ar.validation.endsWith}"` : Fo.assertNever(ar.validation) : ar.validation !== "regex" ? pr = `Invalid ${ar.validation}` : pr = "Invalid";
        break;
      case ys.too_small:
        ar.type === "array" ? pr = `Array must contain ${ar.exact ? "exactly" : ar.inclusive ? "at least" : "more than"} ${ar.minimum} element(s)` : ar.type === "string" ? pr = `String must contain ${ar.exact ? "exactly" : ar.inclusive ? "at least" : "over"} ${ar.minimum} character(s)` : ar.type === "number" ? pr = `Number must be ${ar.exact ? "exactly equal to " : ar.inclusive ? "greater than or equal to " : "greater than "}${ar.minimum}` : ar.type === "date" ? pr = `Date must be ${ar.exact ? "exactly equal to " : ar.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(ar.minimum))}` : pr = "Invalid input";
        break;
      case ys.too_big:
        ar.type === "array" ? pr = `Array must contain ${ar.exact ? "exactly" : ar.inclusive ? "at most" : "less than"} ${ar.maximum} element(s)` : ar.type === "string" ? pr = `String must contain ${ar.exact ? "exactly" : ar.inclusive ? "at most" : "under"} ${ar.maximum} character(s)` : ar.type === "number" ? pr = `Number must be ${ar.exact ? "exactly" : ar.inclusive ? "less than or equal to" : "less than"} ${ar.maximum}` : ar.type === "bigint" ? pr = `BigInt must be ${ar.exact ? "exactly" : ar.inclusive ? "less than or equal to" : "less than"} ${ar.maximum}` : ar.type === "date" ? pr = `Date must be ${ar.exact ? "exactly" : ar.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(ar.maximum))}` : pr = "Invalid input";
        break;
      case ys.custom:
        pr = "Invalid input";
        break;
      case ys.invalid_intersection_types:
        pr = "Intersection results could not be merged";
        break;
      case ys.not_multiple_of:
        pr = `Number must be a multiple of ${ar.multipleOf}`;
        break;
      case ys.not_finite:
        pr = "Number must be finite";
        break;
      default:
        pr = Je.defaultError, Fo.assertNever(ar);
    }
    return { message: pr };
  };
  let Cd = Ef;
  function Up(ar) {
    Cd = ar;
  }
  function fl() {
    return Cd;
  }
  const ll = (ar) => {
    const { data: Je, path: pr, errorMaps: Lr, issueData: hn } = ar, mn = [...pr, ...hn.path || []], qn = {
      ...hn,
      path: mn
    };
    let Vn = "";
    const oi = Lr.filter((li) => !!li).slice().reverse();
    for (const li of oi)
      Vn = li(qn, { data: Je, defaultError: Vn }).message;
    return {
      ...hn,
      path: mn,
      message: hn.message || Vn
    };
  }, Mp = [];
  function qs(ar, Je) {
    const pr = ll({
      issueData: Je,
      data: ar.data,
      path: ar.path,
      errorMaps: [
        ar.common.contextualErrorMap,
        ar.schemaErrorMap,
        fl(),
        Ef
        // then global default map
      ].filter((Lr) => !!Lr)
    });
    ar.common.issues.push(pr);
  }
  class Na {
    constructor() {
      this.value = "valid";
    }
    dirty() {
      this.value === "valid" && (this.value = "dirty");
    }
    abort() {
      this.value !== "aborted" && (this.value = "aborted");
    }
    static mergeArray(Je, pr) {
      const Lr = [];
      for (const hn of pr) {
        if (hn.status === "aborted")
          return ao;
        hn.status === "dirty" && Je.dirty(), Lr.push(hn.value);
      }
      return { status: Je.value, value: Lr };
    }
    static async mergeObjectAsync(Je, pr) {
      const Lr = [];
      for (const hn of pr)
        Lr.push({
          key: await hn.key,
          value: await hn.value
        });
      return Na.mergeObjectSync(Je, Lr);
    }
    static mergeObjectSync(Je, pr) {
      const Lr = {};
      for (const hn of pr) {
        const { key: mn, value: qn } = hn;
        if (mn.status === "aborted" || qn.status === "aborted")
          return ao;
        mn.status === "dirty" && Je.dirty(), qn.status === "dirty" && Je.dirty(), (typeof qn.value < "u" || hn.alwaysSet) && (Lr[mn.value] = qn.value);
      }
      return { status: Je.value, value: Lr };
    }
  }
  const ao = Object.freeze({
    status: "aborted"
  }), sA = (ar) => ({ status: "dirty", value: ar }), Pa = (ar) => ({ status: "valid", value: ar }), Au = (ar) => ar.status === "aborted", Wo = (ar) => ar.status === "dirty", Bf = (ar) => ar.status === "valid", vf = (ar) => typeof Promise < "u" && ar instanceof Promise;
  var Ws;
  (function(ar) {
    ar.errToObj = (Je) => typeof Je == "string" ? { message: Je } : Je || {}, ar.toString = (Je) => typeof Je == "string" ? Je : Je == null ? void 0 : Je.message;
  })(Ws || (Ws = {}));
  class xs {
    constructor(Je, pr, Lr, hn) {
      this._cachedPath = [], this.parent = Je, this.data = pr, this._path = Lr, this._key = hn;
    }
    get path() {
      return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
    }
  }
  const Uc = (ar, Je) => {
    if (Bf(Je))
      return { success: !0, data: Je.value };
    if (!ar.common.issues.length)
      throw new Error("Validation failed but no issues detected.");
    return {
      success: !1,
      get error() {
        if (this._error)
          return this._error;
        const pr = new hu(ar.common.issues);
        return this._error = pr, this._error;
      }
    };
  };
  function po(ar) {
    if (!ar)
      return {};
    const { errorMap: Je, invalid_type_error: pr, required_error: Lr, description: hn } = ar;
    if (Je && (pr || Lr))
      throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    return Je ? { errorMap: Je, description: hn } : { errorMap: (qn, Vn) => qn.code !== "invalid_type" ? { message: Vn.defaultError } : typeof Vn.data > "u" ? { message: Lr ?? Vn.defaultError } : { message: pr ?? Vn.defaultError }, description: hn };
  }
  class Eo {
    constructor(Je) {
      this.spa = this.safeParseAsync, this._def = Je, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
    }
    get description() {
      return this._def.description;
    }
    _getType(Je) {
      return l2(Je.data);
    }
    _getOrReturnCtx(Je, pr) {
      return pr || {
        common: Je.parent.common,
        data: Je.data,
        parsedType: l2(Je.data),
        schemaErrorMap: this._def.errorMap,
        path: Je.path,
        parent: Je.parent
      };
    }
    _processInputParams(Je) {
      return {
        status: new Na(),
        ctx: {
          common: Je.parent.common,
          data: Je.data,
          parsedType: l2(Je.data),
          schemaErrorMap: this._def.errorMap,
          path: Je.path,
          parent: Je.parent
        }
      };
    }
    _parseSync(Je) {
      const pr = this._parse(Je);
      if (vf(pr))
        throw new Error("Synchronous parse encountered promise.");
      return pr;
    }
    _parseAsync(Je) {
      const pr = this._parse(Je);
      return Promise.resolve(pr);
    }
    parse(Je, pr) {
      const Lr = this.safeParse(Je, pr);
      if (Lr.success)
        return Lr.data;
      throw Lr.error;
    }
    safeParse(Je, pr) {
      var Lr;
      const hn = {
        common: {
          issues: [],
          async: (Lr = pr == null ? void 0 : pr.async) !== null && Lr !== void 0 ? Lr : !1,
          contextualErrorMap: pr == null ? void 0 : pr.errorMap
        },
        path: (pr == null ? void 0 : pr.path) || [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data: Je,
        parsedType: l2(Je)
      }, mn = this._parseSync({ data: Je, path: hn.path, parent: hn });
      return Uc(hn, mn);
    }
    async parseAsync(Je, pr) {
      const Lr = await this.safeParseAsync(Je, pr);
      if (Lr.success)
        return Lr.data;
      throw Lr.error;
    }
    async safeParseAsync(Je, pr) {
      const Lr = {
        common: {
          issues: [],
          contextualErrorMap: pr == null ? void 0 : pr.errorMap,
          async: !0
        },
        path: (pr == null ? void 0 : pr.path) || [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data: Je,
        parsedType: l2(Je)
      }, hn = this._parse({ data: Je, path: Lr.path, parent: Lr }), mn = await (vf(hn) ? hn : Promise.resolve(hn));
      return Uc(Lr, mn);
    }
    refine(Je, pr) {
      const Lr = (hn) => typeof pr == "string" || typeof pr > "u" ? { message: pr } : typeof pr == "function" ? pr(hn) : pr;
      return this._refinement((hn, mn) => {
        const qn = Je(hn), Vn = () => mn.addIssue({
          code: ys.custom,
          ...Lr(hn)
        });
        return typeof Promise < "u" && qn instanceof Promise ? qn.then((oi) => oi ? !0 : (Vn(), !1)) : qn ? !0 : (Vn(), !1);
      });
    }
    refinement(Je, pr) {
      return this._refinement((Lr, hn) => Je(Lr) ? !0 : (hn.addIssue(typeof pr == "function" ? pr(Lr, hn) : pr), !1));
    }
    _refinement(Je) {
      return new pu({
        schema: this,
        typeName: eo.ZodEffects,
        effect: { type: "refinement", refinement: Je }
      });
    }
    superRefine(Je) {
      return this._refinement(Je);
    }
    optional() {
      return Tu.create(this, this._def);
    }
    nullable() {
      return rc.create(this, this._def);
    }
    nullish() {
      return this.nullable().optional();
    }
    array() {
      return Ia.create(this, this._def);
    }
    promise() {
      return tc.create(this, this._def);
    }
    or(Je) {
      return D2.create([this, Je], this._def);
    }
    and(Je) {
      return Tf.create(this, Je, this._def);
    }
    transform(Je) {
      return new pu({
        ...po(this._def),
        schema: this,
        typeName: eo.ZodEffects,
        effect: { type: "transform", transform: Je }
      });
    }
    default(Je) {
      const pr = typeof Je == "function" ? Je : () => Je;
      return new Lc({
        ...po(this._def),
        innerType: this,
        defaultValue: pr,
        typeName: eo.ZodDefault
      });
    }
    brand() {
      return new Hc({
        typeName: eo.ZodBranded,
        type: this,
        ...po(this._def)
      });
    }
    catch(Je) {
      const pr = typeof Je == "function" ? Je : () => Je;
      return new Rf({
        ...po(this._def),
        innerType: this,
        catchValue: pr,
        typeName: eo.ZodCatch
      });
    }
    describe(Je) {
      const pr = this.constructor;
      return new pr({
        ...this._def,
        description: Je
      });
    }
    pipe(Je) {
      return Nf.create(this, Je);
    }
    isOptional() {
      return this.safeParse(void 0).success;
    }
    isNullable() {
      return this.safeParse(null).success;
    }
  }
  const Lp = /^c[^\s-]{8,}$/i, lA = /^[a-z][a-z0-9]*$/, dA = /[0-9A-HJKMNP-TV-Z]{26}/, pA = /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i, Hp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/, Kp = new RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u"), Gp = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, jp = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, dl = (ar) => ar.precision ? ar.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${ar.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${ar.precision}}Z$`) : ar.precision === 0 ? ar.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : ar.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
  function Vp(ar, Je) {
    return !!((Je === "v4" || !Je) && Gp.test(ar) || (Je === "v6" || !Je) && jp.test(ar));
  }
  class Oa extends Eo {
    constructor() {
      super(...arguments), this._regex = (Je, pr, Lr) => this.refinement((hn) => Je.test(hn), {
        validation: pr,
        code: ys.invalid_string,
        ...Ws.errToObj(Lr)
      }), this.nonempty = (Je) => this.min(1, Ws.errToObj(Je)), this.trim = () => new Oa({
        ...this._def,
        checks: [...this._def.checks, { kind: "trim" }]
      }), this.toLowerCase = () => new Oa({
        ...this._def,
        checks: [...this._def.checks, { kind: "toLowerCase" }]
      }), this.toUpperCase = () => new Oa({
        ...this._def,
        checks: [...this._def.checks, { kind: "toUpperCase" }]
      });
    }
    _parse(Je) {
      if (this._def.coerce && (Je.data = String(Je.data)), this._getType(Je) !== Ns.string) {
        const mn = this._getOrReturnCtx(Je);
        return qs(
          mn,
          {
            code: ys.invalid_type,
            expected: Ns.string,
            received: mn.parsedType
          }
          //
        ), ao;
      }
      const Lr = new Na();
      let hn;
      for (const mn of this._def.checks)
        if (mn.kind === "min")
          Je.data.length < mn.value && (hn = this._getOrReturnCtx(Je, hn), qs(hn, {
            code: ys.too_small,
            minimum: mn.value,
            type: "string",
            inclusive: !0,
            exact: !1,
            message: mn.message
          }), Lr.dirty());
        else if (mn.kind === "max")
          Je.data.length > mn.value && (hn = this._getOrReturnCtx(Je, hn), qs(hn, {
            code: ys.too_big,
            maximum: mn.value,
            type: "string",
            inclusive: !0,
            exact: !1,
            message: mn.message
          }), Lr.dirty());
        else if (mn.kind === "length") {
          const qn = Je.data.length > mn.value, Vn = Je.data.length < mn.value;
          (qn || Vn) && (hn = this._getOrReturnCtx(Je, hn), qn ? qs(hn, {
            code: ys.too_big,
            maximum: mn.value,
            type: "string",
            inclusive: !0,
            exact: !0,
            message: mn.message
          }) : Vn && qs(hn, {
            code: ys.too_small,
            minimum: mn.value,
            type: "string",
            inclusive: !0,
            exact: !0,
            message: mn.message
          }), Lr.dirty());
        } else if (mn.kind === "email")
          Hp.test(Je.data) || (hn = this._getOrReturnCtx(Je, hn), qs(hn, {
            validation: "email",
            code: ys.invalid_string,
            message: mn.message
          }), Lr.dirty());
        else if (mn.kind === "emoji")
          Kp.test(Je.data) || (hn = this._getOrReturnCtx(Je, hn), qs(hn, {
            validation: "emoji",
            code: ys.invalid_string,
            message: mn.message
          }), Lr.dirty());
        else if (mn.kind === "uuid")
          pA.test(Je.data) || (hn = this._getOrReturnCtx(Je, hn), qs(hn, {
            validation: "uuid",
            code: ys.invalid_string,
            message: mn.message
          }), Lr.dirty());
        else if (mn.kind === "cuid")
          Lp.test(Je.data) || (hn = this._getOrReturnCtx(Je, hn), qs(hn, {
            validation: "cuid",
            code: ys.invalid_string,
            message: mn.message
          }), Lr.dirty());
        else if (mn.kind === "cuid2")
          lA.test(Je.data) || (hn = this._getOrReturnCtx(Je, hn), qs(hn, {
            validation: "cuid2",
            code: ys.invalid_string,
            message: mn.message
          }), Lr.dirty());
        else if (mn.kind === "ulid")
          dA.test(Je.data) || (hn = this._getOrReturnCtx(Je, hn), qs(hn, {
            validation: "ulid",
            code: ys.invalid_string,
            message: mn.message
          }), Lr.dirty());
        else if (mn.kind === "url")
          try {
            new URL(Je.data);
          } catch {
            hn = this._getOrReturnCtx(Je, hn), qs(hn, {
              validation: "url",
              code: ys.invalid_string,
              message: mn.message
            }), Lr.dirty();
          }
        else mn.kind === "regex" ? (mn.regex.lastIndex = 0, mn.regex.test(Je.data) || (hn = this._getOrReturnCtx(Je, hn), qs(hn, {
          validation: "regex",
          code: ys.invalid_string,
          message: mn.message
        }), Lr.dirty())) : mn.kind === "trim" ? Je.data = Je.data.trim() : mn.kind === "includes" ? Je.data.includes(mn.value, mn.position) || (hn = this._getOrReturnCtx(Je, hn), qs(hn, {
          code: ys.invalid_string,
          validation: { includes: mn.value, position: mn.position },
          message: mn.message
        }), Lr.dirty()) : mn.kind === "toLowerCase" ? Je.data = Je.data.toLowerCase() : mn.kind === "toUpperCase" ? Je.data = Je.data.toUpperCase() : mn.kind === "startsWith" ? Je.data.startsWith(mn.value) || (hn = this._getOrReturnCtx(Je, hn), qs(hn, {
          code: ys.invalid_string,
          validation: { startsWith: mn.value },
          message: mn.message
        }), Lr.dirty()) : mn.kind === "endsWith" ? Je.data.endsWith(mn.value) || (hn = this._getOrReturnCtx(Je, hn), qs(hn, {
          code: ys.invalid_string,
          validation: { endsWith: mn.value },
          message: mn.message
        }), Lr.dirty()) : mn.kind === "datetime" ? dl(mn).test(Je.data) || (hn = this._getOrReturnCtx(Je, hn), qs(hn, {
          code: ys.invalid_string,
          validation: "datetime",
          message: mn.message
        }), Lr.dirty()) : mn.kind === "ip" ? Vp(Je.data, mn.version) || (hn = this._getOrReturnCtx(Je, hn), qs(hn, {
          validation: "ip",
          code: ys.invalid_string,
          message: mn.message
        }), Lr.dirty()) : Fo.assertNever(mn);
      return { status: Lr.value, value: Je.data };
    }
    _addCheck(Je) {
      return new Oa({
        ...this._def,
        checks: [...this._def.checks, Je]
      });
    }
    email(Je) {
      return this._addCheck({ kind: "email", ...Ws.errToObj(Je) });
    }
    url(Je) {
      return this._addCheck({ kind: "url", ...Ws.errToObj(Je) });
    }
    emoji(Je) {
      return this._addCheck({ kind: "emoji", ...Ws.errToObj(Je) });
    }
    uuid(Je) {
      return this._addCheck({ kind: "uuid", ...Ws.errToObj(Je) });
    }
    cuid(Je) {
      return this._addCheck({ kind: "cuid", ...Ws.errToObj(Je) });
    }
    cuid2(Je) {
      return this._addCheck({ kind: "cuid2", ...Ws.errToObj(Je) });
    }
    ulid(Je) {
      return this._addCheck({ kind: "ulid", ...Ws.errToObj(Je) });
    }
    ip(Je) {
      return this._addCheck({ kind: "ip", ...Ws.errToObj(Je) });
    }
    datetime(Je) {
      var pr;
      return typeof Je == "string" ? this._addCheck({
        kind: "datetime",
        precision: null,
        offset: !1,
        message: Je
      }) : this._addCheck({
        kind: "datetime",
        precision: typeof (Je == null ? void 0 : Je.precision) > "u" ? null : Je == null ? void 0 : Je.precision,
        offset: (pr = Je == null ? void 0 : Je.offset) !== null && pr !== void 0 ? pr : !1,
        ...Ws.errToObj(Je == null ? void 0 : Je.message)
      });
    }
    regex(Je, pr) {
      return this._addCheck({
        kind: "regex",
        regex: Je,
        ...Ws.errToObj(pr)
      });
    }
    includes(Je, pr) {
      return this._addCheck({
        kind: "includes",
        value: Je,
        position: pr == null ? void 0 : pr.position,
        ...Ws.errToObj(pr == null ? void 0 : pr.message)
      });
    }
    startsWith(Je, pr) {
      return this._addCheck({
        kind: "startsWith",
        value: Je,
        ...Ws.errToObj(pr)
      });
    }
    endsWith(Je, pr) {
      return this._addCheck({
        kind: "endsWith",
        value: Je,
        ...Ws.errToObj(pr)
      });
    }
    min(Je, pr) {
      return this._addCheck({
        kind: "min",
        value: Je,
        ...Ws.errToObj(pr)
      });
    }
    max(Je, pr) {
      return this._addCheck({
        kind: "max",
        value: Je,
        ...Ws.errToObj(pr)
      });
    }
    length(Je, pr) {
      return this._addCheck({
        kind: "length",
        value: Je,
        ...Ws.errToObj(pr)
      });
    }
    get isDatetime() {
      return !!this._def.checks.find((Je) => Je.kind === "datetime");
    }
    get isEmail() {
      return !!this._def.checks.find((Je) => Je.kind === "email");
    }
    get isURL() {
      return !!this._def.checks.find((Je) => Je.kind === "url");
    }
    get isEmoji() {
      return !!this._def.checks.find((Je) => Je.kind === "emoji");
    }
    get isUUID() {
      return !!this._def.checks.find((Je) => Je.kind === "uuid");
    }
    get isCUID() {
      return !!this._def.checks.find((Je) => Je.kind === "cuid");
    }
    get isCUID2() {
      return !!this._def.checks.find((Je) => Je.kind === "cuid2");
    }
    get isULID() {
      return !!this._def.checks.find((Je) => Je.kind === "ulid");
    }
    get isIP() {
      return !!this._def.checks.find((Je) => Je.kind === "ip");
    }
    get minLength() {
      let Je = null;
      for (const pr of this._def.checks)
        pr.kind === "min" && (Je === null || pr.value > Je) && (Je = pr.value);
      return Je;
    }
    get maxLength() {
      let Je = null;
      for (const pr of this._def.checks)
        pr.kind === "max" && (Je === null || pr.value < Je) && (Je = pr.value);
      return Je;
    }
  }
  Oa.create = (ar) => {
    var Je;
    return new Oa({
      checks: [],
      typeName: eo.ZodString,
      coerce: (Je = ar == null ? void 0 : ar.coerce) !== null && Je !== void 0 ? Je : !1,
      ...po(ar)
    });
  };
  function Wp(ar, Je) {
    const pr = (ar.toString().split(".")[1] || "").length, Lr = (Je.toString().split(".")[1] || "").length, hn = pr > Lr ? pr : Lr, mn = parseInt(ar.toFixed(hn).replace(".", "")), qn = parseInt(Je.toFixed(hn).replace(".", ""));
    return mn % qn / Math.pow(10, hn);
  }
  class E2 extends Eo {
    constructor() {
      super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
    }
    _parse(Je) {
      if (this._def.coerce && (Je.data = Number(Je.data)), this._getType(Je) !== Ns.number) {
        const mn = this._getOrReturnCtx(Je);
        return qs(mn, {
          code: ys.invalid_type,
          expected: Ns.number,
          received: mn.parsedType
        }), ao;
      }
      let Lr;
      const hn = new Na();
      for (const mn of this._def.checks)
        mn.kind === "int" ? Fo.isInteger(Je.data) || (Lr = this._getOrReturnCtx(Je, Lr), qs(Lr, {
          code: ys.invalid_type,
          expected: "integer",
          received: "float",
          message: mn.message
        }), hn.dirty()) : mn.kind === "min" ? (mn.inclusive ? Je.data < mn.value : Je.data <= mn.value) && (Lr = this._getOrReturnCtx(Je, Lr), qs(Lr, {
          code: ys.too_small,
          minimum: mn.value,
          type: "number",
          inclusive: mn.inclusive,
          exact: !1,
          message: mn.message
        }), hn.dirty()) : mn.kind === "max" ? (mn.inclusive ? Je.data > mn.value : Je.data >= mn.value) && (Lr = this._getOrReturnCtx(Je, Lr), qs(Lr, {
          code: ys.too_big,
          maximum: mn.value,
          type: "number",
          inclusive: mn.inclusive,
          exact: !1,
          message: mn.message
        }), hn.dirty()) : mn.kind === "multipleOf" ? Wp(Je.data, mn.value) !== 0 && (Lr = this._getOrReturnCtx(Je, Lr), qs(Lr, {
          code: ys.not_multiple_of,
          multipleOf: mn.value,
          message: mn.message
        }), hn.dirty()) : mn.kind === "finite" ? Number.isFinite(Je.data) || (Lr = this._getOrReturnCtx(Je, Lr), qs(Lr, {
          code: ys.not_finite,
          message: mn.message
        }), hn.dirty()) : Fo.assertNever(mn);
      return { status: hn.value, value: Je.data };
    }
    gte(Je, pr) {
      return this.setLimit("min", Je, !0, Ws.toString(pr));
    }
    gt(Je, pr) {
      return this.setLimit("min", Je, !1, Ws.toString(pr));
    }
    lte(Je, pr) {
      return this.setLimit("max", Je, !0, Ws.toString(pr));
    }
    lt(Je, pr) {
      return this.setLimit("max", Je, !1, Ws.toString(pr));
    }
    setLimit(Je, pr, Lr, hn) {
      return new E2({
        ...this._def,
        checks: [
          ...this._def.checks,
          {
            kind: Je,
            value: pr,
            inclusive: Lr,
            message: Ws.toString(hn)
          }
        ]
      });
    }
    _addCheck(Je) {
      return new E2({
        ...this._def,
        checks: [...this._def.checks, Je]
      });
    }
    int(Je) {
      return this._addCheck({
        kind: "int",
        message: Ws.toString(Je)
      });
    }
    positive(Je) {
      return this._addCheck({
        kind: "min",
        value: 0,
        inclusive: !1,
        message: Ws.toString(Je)
      });
    }
    negative(Je) {
      return this._addCheck({
        kind: "max",
        value: 0,
        inclusive: !1,
        message: Ws.toString(Je)
      });
    }
    nonpositive(Je) {
      return this._addCheck({
        kind: "max",
        value: 0,
        inclusive: !0,
        message: Ws.toString(Je)
      });
    }
    nonnegative(Je) {
      return this._addCheck({
        kind: "min",
        value: 0,
        inclusive: !0,
        message: Ws.toString(Je)
      });
    }
    multipleOf(Je, pr) {
      return this._addCheck({
        kind: "multipleOf",
        value: Je,
        message: Ws.toString(pr)
      });
    }
    finite(Je) {
      return this._addCheck({
        kind: "finite",
        message: Ws.toString(Je)
      });
    }
    safe(Je) {
      return this._addCheck({
        kind: "min",
        inclusive: !0,
        value: Number.MIN_SAFE_INTEGER,
        message: Ws.toString(Je)
      })._addCheck({
        kind: "max",
        inclusive: !0,
        value: Number.MAX_SAFE_INTEGER,
        message: Ws.toString(Je)
      });
    }
    get minValue() {
      let Je = null;
      for (const pr of this._def.checks)
        pr.kind === "min" && (Je === null || pr.value > Je) && (Je = pr.value);
      return Je;
    }
    get maxValue() {
      let Je = null;
      for (const pr of this._def.checks)
        pr.kind === "max" && (Je === null || pr.value < Je) && (Je = pr.value);
      return Je;
    }
    get isInt() {
      return !!this._def.checks.find((Je) => Je.kind === "int" || Je.kind === "multipleOf" && Fo.isInteger(Je.value));
    }
    get isFinite() {
      let Je = null, pr = null;
      for (const Lr of this._def.checks) {
        if (Lr.kind === "finite" || Lr.kind === "int" || Lr.kind === "multipleOf")
          return !0;
        Lr.kind === "min" ? (pr === null || Lr.value > pr) && (pr = Lr.value) : Lr.kind === "max" && (Je === null || Lr.value < Je) && (Je = Lr.value);
      }
      return Number.isFinite(pr) && Number.isFinite(Je);
    }
  }
  E2.create = (ar) => new E2({
    checks: [],
    typeName: eo.ZodNumber,
    coerce: (ar == null ? void 0 : ar.coerce) || !1,
    ...po(ar)
  });
  class x2 extends Eo {
    constructor() {
      super(...arguments), this.min = this.gte, this.max = this.lte;
    }
    _parse(Je) {
      if (this._def.coerce && (Je.data = BigInt(Je.data)), this._getType(Je) !== Ns.bigint) {
        const mn = this._getOrReturnCtx(Je);
        return qs(mn, {
          code: ys.invalid_type,
          expected: Ns.bigint,
          received: mn.parsedType
        }), ao;
      }
      let Lr;
      const hn = new Na();
      for (const mn of this._def.checks)
        mn.kind === "min" ? (mn.inclusive ? Je.data < mn.value : Je.data <= mn.value) && (Lr = this._getOrReturnCtx(Je, Lr), qs(Lr, {
          code: ys.too_small,
          type: "bigint",
          minimum: mn.value,
          inclusive: mn.inclusive,
          message: mn.message
        }), hn.dirty()) : mn.kind === "max" ? (mn.inclusive ? Je.data > mn.value : Je.data >= mn.value) && (Lr = this._getOrReturnCtx(Je, Lr), qs(Lr, {
          code: ys.too_big,
          type: "bigint",
          maximum: mn.value,
          inclusive: mn.inclusive,
          message: mn.message
        }), hn.dirty()) : mn.kind === "multipleOf" ? Je.data % mn.value !== BigInt(0) && (Lr = this._getOrReturnCtx(Je, Lr), qs(Lr, {
          code: ys.not_multiple_of,
          multipleOf: mn.value,
          message: mn.message
        }), hn.dirty()) : Fo.assertNever(mn);
      return { status: hn.value, value: Je.data };
    }
    gte(Je, pr) {
      return this.setLimit("min", Je, !0, Ws.toString(pr));
    }
    gt(Je, pr) {
      return this.setLimit("min", Je, !1, Ws.toString(pr));
    }
    lte(Je, pr) {
      return this.setLimit("max", Je, !0, Ws.toString(pr));
    }
    lt(Je, pr) {
      return this.setLimit("max", Je, !1, Ws.toString(pr));
    }
    setLimit(Je, pr, Lr, hn) {
      return new x2({
        ...this._def,
        checks: [
          ...this._def.checks,
          {
            kind: Je,
            value: pr,
            inclusive: Lr,
            message: Ws.toString(hn)
          }
        ]
      });
    }
    _addCheck(Je) {
      return new x2({
        ...this._def,
        checks: [...this._def.checks, Je]
      });
    }
    positive(Je) {
      return this._addCheck({
        kind: "min",
        value: BigInt(0),
        inclusive: !1,
        message: Ws.toString(Je)
      });
    }
    negative(Je) {
      return this._addCheck({
        kind: "max",
        value: BigInt(0),
        inclusive: !1,
        message: Ws.toString(Je)
      });
    }
    nonpositive(Je) {
      return this._addCheck({
        kind: "max",
        value: BigInt(0),
        inclusive: !0,
        message: Ws.toString(Je)
      });
    }
    nonnegative(Je) {
      return this._addCheck({
        kind: "min",
        value: BigInt(0),
        inclusive: !0,
        message: Ws.toString(Je)
      });
    }
    multipleOf(Je, pr) {
      return this._addCheck({
        kind: "multipleOf",
        value: Je,
        message: Ws.toString(pr)
      });
    }
    get minValue() {
      let Je = null;
      for (const pr of this._def.checks)
        pr.kind === "min" && (Je === null || pr.value > Je) && (Je = pr.value);
      return Je;
    }
    get maxValue() {
      let Je = null;
      for (const pr of this._def.checks)
        pr.kind === "max" && (Je === null || pr.value < Je) && (Je = pr.value);
      return Je;
    }
  }
  x2.create = (ar) => {
    var Je;
    return new x2({
      checks: [],
      typeName: eo.ZodBigInt,
      coerce: (Je = ar == null ? void 0 : ar.coerce) !== null && Je !== void 0 ? Je : !1,
      ...po(ar)
    });
  };
  class Cf extends Eo {
    _parse(Je) {
      if (this._def.coerce && (Je.data = !!Je.data), this._getType(Je) !== Ns.boolean) {
        const Lr = this._getOrReturnCtx(Je);
        return qs(Lr, {
          code: ys.invalid_type,
          expected: Ns.boolean,
          received: Lr.parsedType
        }), ao;
      }
      return Pa(Je.data);
    }
  }
  Cf.create = (ar) => new Cf({
    typeName: eo.ZodBoolean,
    coerce: (ar == null ? void 0 : ar.coerce) || !1,
    ...po(ar)
  });
  class Zo extends Eo {
    _parse(Je) {
      if (this._def.coerce && (Je.data = new Date(Je.data)), this._getType(Je) !== Ns.date) {
        const mn = this._getOrReturnCtx(Je);
        return qs(mn, {
          code: ys.invalid_type,
          expected: Ns.date,
          received: mn.parsedType
        }), ao;
      }
      if (isNaN(Je.data.getTime())) {
        const mn = this._getOrReturnCtx(Je);
        return qs(mn, {
          code: ys.invalid_date
        }), ao;
      }
      const Lr = new Na();
      let hn;
      for (const mn of this._def.checks)
        mn.kind === "min" ? Je.data.getTime() < mn.value && (hn = this._getOrReturnCtx(Je, hn), qs(hn, {
          code: ys.too_small,
          message: mn.message,
          inclusive: !0,
          exact: !1,
          minimum: mn.value,
          type: "date"
        }), Lr.dirty()) : mn.kind === "max" ? Je.data.getTime() > mn.value && (hn = this._getOrReturnCtx(Je, hn), qs(hn, {
          code: ys.too_big,
          message: mn.message,
          inclusive: !0,
          exact: !1,
          maximum: mn.value,
          type: "date"
        }), Lr.dirty()) : Fo.assertNever(mn);
      return {
        status: Lr.value,
        value: new Date(Je.data.getTime())
      };
    }
    _addCheck(Je) {
      return new Zo({
        ...this._def,
        checks: [...this._def.checks, Je]
      });
    }
    min(Je, pr) {
      return this._addCheck({
        kind: "min",
        value: Je.getTime(),
        message: Ws.toString(pr)
      });
    }
    max(Je, pr) {
      return this._addCheck({
        kind: "max",
        value: Je.getTime(),
        message: Ws.toString(pr)
      });
    }
    get minDate() {
      let Je = null;
      for (const pr of this._def.checks)
        pr.kind === "min" && (Je === null || pr.value > Je) && (Je = pr.value);
      return Je != null ? new Date(Je) : null;
    }
    get maxDate() {
      let Je = null;
      for (const pr of this._def.checks)
        pr.kind === "max" && (Je === null || pr.value < Je) && (Je = pr.value);
      return Je != null ? new Date(Je) : null;
    }
  }
  Zo.create = (ar) => new Zo({
    checks: [],
    coerce: (ar == null ? void 0 : ar.coerce) || !1,
    typeName: eo.ZodDate,
    ...po(ar)
  });
  class hl extends Eo {
    _parse(Je) {
      if (this._getType(Je) !== Ns.symbol) {
        const Lr = this._getOrReturnCtx(Je);
        return qs(Lr, {
          code: ys.invalid_type,
          expected: Ns.symbol,
          received: Lr.parsedType
        }), ao;
      }
      return Pa(Je.data);
    }
  }
  hl.create = (ar) => new hl({
    typeName: eo.ZodSymbol,
    ...po(ar)
  });
  class kf extends Eo {
    _parse(Je) {
      if (this._getType(Je) !== Ns.undefined) {
        const Lr = this._getOrReturnCtx(Je);
        return qs(Lr, {
          code: ys.invalid_type,
          expected: Ns.undefined,
          received: Lr.parsedType
        }), ao;
      }
      return Pa(Je.data);
    }
  }
  kf.create = (ar) => new kf({
    typeName: eo.ZodUndefined,
    ...po(ar)
  });
  class Yo extends Eo {
    _parse(Je) {
      if (this._getType(Je) !== Ns.null) {
        const Lr = this._getOrReturnCtx(Je);
        return qs(Lr, {
          code: ys.invalid_type,
          expected: Ns.null,
          received: Lr.parsedType
        }), ao;
      }
      return Pa(Je.data);
    }
  }
  Yo.create = (ar) => new Yo({
    typeName: eo.ZodNull,
    ...po(ar)
  });
  class mc extends Eo {
    constructor() {
      super(...arguments), this._any = !0;
    }
    _parse(Je) {
      return Pa(Je.data);
    }
  }
  mc.create = (ar) => new mc({
    typeName: eo.ZodAny,
    ...po(ar)
  });
  class Ic extends Eo {
    constructor() {
      super(...arguments), this._unknown = !0;
    }
    _parse(Je) {
      return Pa(Je.data);
    }
  }
  Ic.create = (ar) => new Ic({
    typeName: eo.ZodUnknown,
    ...po(ar)
  });
  class ku extends Eo {
    _parse(Je) {
      const pr = this._getOrReturnCtx(Je);
      return qs(pr, {
        code: ys.invalid_type,
        expected: Ns.never,
        received: pr.parsedType
      }), ao;
    }
  }
  ku.create = (ar) => new ku({
    typeName: eo.ZodNever,
    ...po(ar)
  });
  class Al extends Eo {
    _parse(Je) {
      if (this._getType(Je) !== Ns.undefined) {
        const Lr = this._getOrReturnCtx(Je);
        return qs(Lr, {
          code: ys.invalid_type,
          expected: Ns.void,
          received: Lr.parsedType
        }), ao;
      }
      return Pa(Je.data);
    }
  }
  Al.create = (ar) => new Al({
    typeName: eo.ZodVoid,
    ...po(ar)
  });
  class Ia extends Eo {
    _parse(Je) {
      const { ctx: pr, status: Lr } = this._processInputParams(Je), hn = this._def;
      if (pr.parsedType !== Ns.array)
        return qs(pr, {
          code: ys.invalid_type,
          expected: Ns.array,
          received: pr.parsedType
        }), ao;
      if (hn.exactLength !== null) {
        const qn = pr.data.length > hn.exactLength.value, Vn = pr.data.length < hn.exactLength.value;
        (qn || Vn) && (qs(pr, {
          code: qn ? ys.too_big : ys.too_small,
          minimum: Vn ? hn.exactLength.value : void 0,
          maximum: qn ? hn.exactLength.value : void 0,
          type: "array",
          inclusive: !0,
          exact: !0,
          message: hn.exactLength.message
        }), Lr.dirty());
      }
      if (hn.minLength !== null && pr.data.length < hn.minLength.value && (qs(pr, {
        code: ys.too_small,
        minimum: hn.minLength.value,
        type: "array",
        inclusive: !0,
        exact: !1,
        message: hn.minLength.message
      }), Lr.dirty()), hn.maxLength !== null && pr.data.length > hn.maxLength.value && (qs(pr, {
        code: ys.too_big,
        maximum: hn.maxLength.value,
        type: "array",
        inclusive: !0,
        exact: !1,
        message: hn.maxLength.message
      }), Lr.dirty()), pr.common.async)
        return Promise.all([...pr.data].map((qn, Vn) => hn.type._parseAsync(new xs(pr, qn, pr.path, Vn)))).then((qn) => Na.mergeArray(Lr, qn));
      const mn = [...pr.data].map((qn, Vn) => hn.type._parseSync(new xs(pr, qn, pr.path, Vn)));
      return Na.mergeArray(Lr, mn);
    }
    get element() {
      return this._def.type;
    }
    min(Je, pr) {
      return new Ia({
        ...this._def,
        minLength: { value: Je, message: Ws.toString(pr) }
      });
    }
    max(Je, pr) {
      return new Ia({
        ...this._def,
        maxLength: { value: Je, message: Ws.toString(pr) }
      });
    }
    length(Je, pr) {
      return new Ia({
        ...this._def,
        exactLength: { value: Je, message: Ws.toString(pr) }
      });
    }
    nonempty(Je) {
      return this.min(1, Je);
    }
  }
  Ia.create = (ar, Je) => new Ia({
    type: ar,
    minLength: null,
    maxLength: null,
    exactLength: null,
    typeName: eo.ZodArray,
    ...po(Je)
  });
  function Mc(ar) {
    if (ar instanceof $o) {
      const Je = {};
      for (const pr in ar.shape) {
        const Lr = ar.shape[pr];
        Je[pr] = Tu.create(Mc(Lr));
      }
      return new $o({
        ...ar._def,
        shape: () => Je
      });
    } else return ar instanceof Ia ? new Ia({
      ...ar._def,
      type: Mc(ar.element)
    }) : ar instanceof Tu ? Tu.create(Mc(ar.unwrap())) : ar instanceof rc ? rc.create(Mc(ar.unwrap())) : ar instanceof Su ? Su.create(ar.items.map((Je) => Mc(Je))) : ar;
  }
  class $o extends Eo {
    constructor() {
      super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
    }
    _getCached() {
      if (this._cached !== null)
        return this._cached;
      const Je = this._def.shape(), pr = Fo.objectKeys(Je);
      return this._cached = { shape: Je, keys: pr };
    }
    _parse(Je) {
      if (this._getType(Je) !== Ns.object) {
        const li = this._getOrReturnCtx(Je);
        return qs(li, {
          code: ys.invalid_type,
          expected: Ns.object,
          received: li.parsedType
        }), ao;
      }
      const { status: Lr, ctx: hn } = this._processInputParams(Je), { shape: mn, keys: qn } = this._getCached(), Vn = [];
      if (!(this._def.catchall instanceof ku && this._def.unknownKeys === "strip"))
        for (const li in hn.data)
          qn.includes(li) || Vn.push(li);
      const oi = [];
      for (const li of qn) {
        const Di = mn[li], mi = hn.data[li];
        oi.push({
          key: { status: "valid", value: li },
          value: Di._parse(new xs(hn, mi, hn.path, li)),
          alwaysSet: li in hn.data
        });
      }
      if (this._def.catchall instanceof ku) {
        const li = this._def.unknownKeys;
        if (li === "passthrough")
          for (const Di of Vn)
            oi.push({
              key: { status: "valid", value: Di },
              value: { status: "valid", value: hn.data[Di] }
            });
        else if (li === "strict")
          Vn.length > 0 && (qs(hn, {
            code: ys.unrecognized_keys,
            keys: Vn
          }), Lr.dirty());
        else if (li !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
      } else {
        const li = this._def.catchall;
        for (const Di of Vn) {
          const mi = hn.data[Di];
          oi.push({
            key: { status: "valid", value: Di },
            value: li._parse(
              new xs(hn, mi, hn.path, Di)
              //, ctx.child(key), value, getParsedType(value)
            ),
            alwaysSet: Di in hn.data
          });
        }
      }
      return hn.common.async ? Promise.resolve().then(async () => {
        const li = [];
        for (const Di of oi) {
          const mi = await Di.key;
          li.push({
            key: mi,
            value: await Di.value,
            alwaysSet: Di.alwaysSet
          });
        }
        return li;
      }).then((li) => Na.mergeObjectSync(Lr, li)) : Na.mergeObjectSync(Lr, oi);
    }
    get shape() {
      return this._def.shape();
    }
    strict(Je) {
      return new $o({
        ...this._def,
        unknownKeys: "strict",
        ...Je !== void 0 ? {
          errorMap: (pr, Lr) => {
            var hn, mn, qn, Vn;
            const oi = (qn = (mn = (hn = this._def).errorMap) === null || mn === void 0 ? void 0 : mn.call(hn, pr, Lr).message) !== null && qn !== void 0 ? qn : Lr.defaultError;
            return pr.code === "unrecognized_keys" ? {
              message: (Vn = Ws.errToObj(Je).message) !== null && Vn !== void 0 ? Vn : oi
            } : {
              message: oi
            };
          }
        } : {}
      });
    }
    strip() {
      return new $o({
        ...this._def,
        unknownKeys: "strip"
      });
    }
    passthrough() {
      return new $o({
        ...this._def,
        unknownKeys: "passthrough"
      });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(Je) {
      return new $o({
        ...this._def,
        shape: () => ({
          ...this._def.shape(),
          ...Je
        })
      });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */
    merge(Je) {
      return new $o({
        unknownKeys: Je._def.unknownKeys,
        catchall: Je._def.catchall,
        shape: () => ({
          ...this._def.shape(),
          ...Je._def.shape()
        }),
        typeName: eo.ZodObject
      });
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(Je, pr) {
      return this.augment({ [Je]: pr });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(Je) {
      return new $o({
        ...this._def,
        catchall: Je
      });
    }
    pick(Je) {
      const pr = {};
      return Fo.objectKeys(Je).forEach((Lr) => {
        Je[Lr] && this.shape[Lr] && (pr[Lr] = this.shape[Lr]);
      }), new $o({
        ...this._def,
        shape: () => pr
      });
    }
    omit(Je) {
      const pr = {};
      return Fo.objectKeys(this.shape).forEach((Lr) => {
        Je[Lr] || (pr[Lr] = this.shape[Lr]);
      }), new $o({
        ...this._def,
        shape: () => pr
      });
    }
    /**
     * @deprecated
     */
    deepPartial() {
      return Mc(this);
    }
    partial(Je) {
      const pr = {};
      return Fo.objectKeys(this.shape).forEach((Lr) => {
        const hn = this.shape[Lr];
        Je && !Je[Lr] ? pr[Lr] = hn : pr[Lr] = hn.optional();
      }), new $o({
        ...this._def,
        shape: () => pr
      });
    }
    required(Je) {
      const pr = {};
      return Fo.objectKeys(this.shape).forEach((Lr) => {
        if (Je && !Je[Lr])
          pr[Lr] = this.shape[Lr];
        else {
          let mn = this.shape[Lr];
          for (; mn instanceof Tu; )
            mn = mn._def.innerType;
          pr[Lr] = mn;
        }
      }), new $o({
        ...this._def,
        shape: () => pr
      });
    }
    keyof() {
      return pl(Fo.objectKeys(this.shape));
    }
  }
  $o.create = (ar, Je) => new $o({
    shape: () => ar,
    unknownKeys: "strip",
    catchall: ku.create(),
    typeName: eo.ZodObject,
    ...po(Je)
  }), $o.strictCreate = (ar, Je) => new $o({
    shape: () => ar,
    unknownKeys: "strict",
    catchall: ku.create(),
    typeName: eo.ZodObject,
    ...po(Je)
  }), $o.lazycreate = (ar, Je) => new $o({
    shape: ar,
    unknownKeys: "strip",
    catchall: ku.create(),
    typeName: eo.ZodObject,
    ...po(Je)
  });
  class D2 extends Eo {
    _parse(Je) {
      const { ctx: pr } = this._processInputParams(Je), Lr = this._def.options;
      function hn(mn) {
        for (const Vn of mn)
          if (Vn.result.status === "valid")
            return Vn.result;
        for (const Vn of mn)
          if (Vn.result.status === "dirty")
            return pr.common.issues.push(...Vn.ctx.common.issues), Vn.result;
        const qn = mn.map((Vn) => new hu(Vn.ctx.common.issues));
        return qs(pr, {
          code: ys.invalid_union,
          unionErrors: qn
        }), ao;
      }
      if (pr.common.async)
        return Promise.all(Lr.map(async (mn) => {
          const qn = {
            ...pr,
            common: {
              ...pr.common,
              issues: []
            },
            parent: null
          };
          return {
            result: await mn._parseAsync({
              data: pr.data,
              path: pr.path,
              parent: qn
            }),
            ctx: qn
          };
        })).then(hn);
      {
        let mn;
        const qn = [];
        for (const oi of Lr) {
          const li = {
            ...pr,
            common: {
              ...pr.common,
              issues: []
            },
            parent: null
          }, Di = oi._parseSync({
            data: pr.data,
            path: pr.path,
            parent: li
          });
          if (Di.status === "valid")
            return Di;
          Di.status === "dirty" && !mn && (mn = { result: Di, ctx: li }), li.common.issues.length && qn.push(li.common.issues);
        }
        if (mn)
          return pr.common.issues.push(...mn.ctx.common.issues), mn.result;
        const Vn = qn.map((oi) => new hu(oi));
        return qs(pr, {
          code: ys.invalid_union,
          unionErrors: Vn
        }), ao;
      }
    }
    get options() {
      return this._def.options;
    }
  }
  D2.create = (ar, Je) => new D2({
    options: ar,
    typeName: eo.ZodUnion,
    ...po(Je)
  });
  const gl = (ar) => ar instanceof Fc ? gl(ar.schema) : ar instanceof pu ? gl(ar.innerType()) : ar instanceof ja ? [ar.value] : ar instanceof N2 ? ar.options : ar instanceof ra ? Object.keys(ar.enum) : ar instanceof Lc ? gl(ar._def.innerType) : ar instanceof kf ? [void 0] : ar instanceof Yo ? [null] : null;
  class Sf extends Eo {
    _parse(Je) {
      const { ctx: pr } = this._processInputParams(Je);
      if (pr.parsedType !== Ns.object)
        return qs(pr, {
          code: ys.invalid_type,
          expected: Ns.object,
          received: pr.parsedType
        }), ao;
      const Lr = this.discriminator, hn = pr.data[Lr], mn = this.optionsMap.get(hn);
      return mn ? pr.common.async ? mn._parseAsync({
        data: pr.data,
        path: pr.path,
        parent: pr
      }) : mn._parseSync({
        data: pr.data,
        path: pr.path,
        parent: pr
      }) : (qs(pr, {
        code: ys.invalid_union_discriminator,
        options: Array.from(this.optionsMap.keys()),
        path: [Lr]
      }), ao);
    }
    get discriminator() {
      return this._def.discriminator;
    }
    get options() {
      return this._def.options;
    }
    get optionsMap() {
      return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */
    static create(Je, pr, Lr) {
      const hn = /* @__PURE__ */ new Map();
      for (const mn of pr) {
        const qn = gl(mn.shape[Je]);
        if (!qn)
          throw new Error(`A discriminator value for key \`${Je}\` could not be extracted from all schema options`);
        for (const Vn of qn) {
          if (hn.has(Vn))
            throw new Error(`Discriminator property ${String(Je)} has duplicate value ${String(Vn)}`);
          hn.set(Vn, mn);
        }
      }
      return new Sf({
        typeName: eo.ZodDiscriminatedUnion,
        discriminator: Je,
        options: pr,
        optionsMap: hn,
        ...po(Lr)
      });
    }
  }
  function kd(ar, Je) {
    const pr = l2(ar), Lr = l2(Je);
    if (ar === Je)
      return { valid: !0, data: ar };
    if (pr === Ns.object && Lr === Ns.object) {
      const hn = Fo.objectKeys(Je), mn = Fo.objectKeys(ar).filter((Vn) => hn.indexOf(Vn) !== -1), qn = { ...ar, ...Je };
      for (const Vn of mn) {
        const oi = kd(ar[Vn], Je[Vn]);
        if (!oi.valid)
          return { valid: !1 };
        qn[Vn] = oi.data;
      }
      return { valid: !0, data: qn };
    } else if (pr === Ns.array && Lr === Ns.array) {
      if (ar.length !== Je.length)
        return { valid: !1 };
      const hn = [];
      for (let mn = 0; mn < ar.length; mn++) {
        const qn = ar[mn], Vn = Je[mn], oi = kd(qn, Vn);
        if (!oi.valid)
          return { valid: !1 };
        hn.push(oi.data);
      }
      return { valid: !0, data: hn };
    } else return pr === Ns.date && Lr === Ns.date && +ar == +Je ? { valid: !0, data: ar } : { valid: !1 };
  }
  class Tf extends Eo {
    _parse(Je) {
      const { status: pr, ctx: Lr } = this._processInputParams(Je), hn = (mn, qn) => {
        if (Au(mn) || Au(qn))
          return ao;
        const Vn = kd(mn.value, qn.value);
        return Vn.valid ? ((Wo(mn) || Wo(qn)) && pr.dirty(), { status: pr.value, value: Vn.data }) : (qs(Lr, {
          code: ys.invalid_intersection_types
        }), ao);
      };
      return Lr.common.async ? Promise.all([
        this._def.left._parseAsync({
          data: Lr.data,
          path: Lr.path,
          parent: Lr
        }),
        this._def.right._parseAsync({
          data: Lr.data,
          path: Lr.path,
          parent: Lr
        })
      ]).then(([mn, qn]) => hn(mn, qn)) : hn(this._def.left._parseSync({
        data: Lr.data,
        path: Lr.path,
        parent: Lr
      }), this._def.right._parseSync({
        data: Lr.data,
        path: Lr.path,
        parent: Lr
      }));
    }
  }
  Tf.create = (ar, Je, pr) => new Tf({
    left: ar,
    right: Je,
    typeName: eo.ZodIntersection,
    ...po(pr)
  });
  class Su extends Eo {
    _parse(Je) {
      const { status: pr, ctx: Lr } = this._processInputParams(Je);
      if (Lr.parsedType !== Ns.array)
        return qs(Lr, {
          code: ys.invalid_type,
          expected: Ns.array,
          received: Lr.parsedType
        }), ao;
      if (Lr.data.length < this._def.items.length)
        return qs(Lr, {
          code: ys.too_small,
          minimum: this._def.items.length,
          inclusive: !0,
          exact: !1,
          type: "array"
        }), ao;
      !this._def.rest && Lr.data.length > this._def.items.length && (qs(Lr, {
        code: ys.too_big,
        maximum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), pr.dirty());
      const mn = [...Lr.data].map((qn, Vn) => {
        const oi = this._def.items[Vn] || this._def.rest;
        return oi ? oi._parse(new xs(Lr, qn, Lr.path, Vn)) : null;
      }).filter((qn) => !!qn);
      return Lr.common.async ? Promise.all(mn).then((qn) => Na.mergeArray(pr, qn)) : Na.mergeArray(pr, mn);
    }
    get items() {
      return this._def.items;
    }
    rest(Je) {
      return new Su({
        ...this._def,
        rest: Je
      });
    }
  }
  Su.create = (ar, Je) => {
    if (!Array.isArray(ar))
      throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new Su({
      items: ar,
      typeName: eo.ZodTuple,
      rest: null,
      ...po(Je)
    });
  };
  class xf extends Eo {
    get keySchema() {
      return this._def.keyType;
    }
    get valueSchema() {
      return this._def.valueType;
    }
    _parse(Je) {
      const { status: pr, ctx: Lr } = this._processInputParams(Je);
      if (Lr.parsedType !== Ns.object)
        return qs(Lr, {
          code: ys.invalid_type,
          expected: Ns.object,
          received: Lr.parsedType
        }), ao;
      const hn = [], mn = this._def.keyType, qn = this._def.valueType;
      for (const Vn in Lr.data)
        hn.push({
          key: mn._parse(new xs(Lr, Vn, Lr.path, Vn)),
          value: qn._parse(new xs(Lr, Lr.data[Vn], Lr.path, Vn))
        });
      return Lr.common.async ? Na.mergeObjectAsync(pr, hn) : Na.mergeObjectSync(pr, hn);
    }
    get element() {
      return this._def.valueType;
    }
    static create(Je, pr, Lr) {
      return pr instanceof Eo ? new xf({
        keyType: Je,
        valueType: pr,
        typeName: eo.ZodRecord,
        ...po(Lr)
      }) : new xf({
        keyType: Oa.create(),
        valueType: Je,
        typeName: eo.ZodRecord,
        ...po(pr)
      });
    }
  }
  class gu extends Eo {
    _parse(Je) {
      const { status: pr, ctx: Lr } = this._processInputParams(Je);
      if (Lr.parsedType !== Ns.map)
        return qs(Lr, {
          code: ys.invalid_type,
          expected: Ns.map,
          received: Lr.parsedType
        }), ao;
      const hn = this._def.keyType, mn = this._def.valueType, qn = [...Lr.data.entries()].map(([Vn, oi], li) => ({
        key: hn._parse(new xs(Lr, Vn, Lr.path, [li, "key"])),
        value: mn._parse(new xs(Lr, oi, Lr.path, [li, "value"]))
      }));
      if (Lr.common.async) {
        const Vn = /* @__PURE__ */ new Map();
        return Promise.resolve().then(async () => {
          for (const oi of qn) {
            const li = await oi.key, Di = await oi.value;
            if (li.status === "aborted" || Di.status === "aborted")
              return ao;
            (li.status === "dirty" || Di.status === "dirty") && pr.dirty(), Vn.set(li.value, Di.value);
          }
          return { status: pr.value, value: Vn };
        });
      } else {
        const Vn = /* @__PURE__ */ new Map();
        for (const oi of qn) {
          const li = oi.key, Di = oi.value;
          if (li.status === "aborted" || Di.status === "aborted")
            return ao;
          (li.status === "dirty" || Di.status === "dirty") && pr.dirty(), Vn.set(li.value, Di.value);
        }
        return { status: pr.value, value: Vn };
      }
    }
  }
  gu.create = (ar, Je, pr) => new gu({
    valueType: Je,
    keyType: ar,
    typeName: eo.ZodMap,
    ...po(pr)
  });
  class wc extends Eo {
    _parse(Je) {
      const { status: pr, ctx: Lr } = this._processInputParams(Je);
      if (Lr.parsedType !== Ns.set)
        return qs(Lr, {
          code: ys.invalid_type,
          expected: Ns.set,
          received: Lr.parsedType
        }), ao;
      const hn = this._def;
      hn.minSize !== null && Lr.data.size < hn.minSize.value && (qs(Lr, {
        code: ys.too_small,
        minimum: hn.minSize.value,
        type: "set",
        inclusive: !0,
        exact: !1,
        message: hn.minSize.message
      }), pr.dirty()), hn.maxSize !== null && Lr.data.size > hn.maxSize.value && (qs(Lr, {
        code: ys.too_big,
        maximum: hn.maxSize.value,
        type: "set",
        inclusive: !0,
        exact: !1,
        message: hn.maxSize.message
      }), pr.dirty());
      const mn = this._def.valueType;
      function qn(oi) {
        const li = /* @__PURE__ */ new Set();
        for (const Di of oi) {
          if (Di.status === "aborted")
            return ao;
          Di.status === "dirty" && pr.dirty(), li.add(Di.value);
        }
        return { status: pr.value, value: li };
      }
      const Vn = [...Lr.data.values()].map((oi, li) => mn._parse(new xs(Lr, oi, Lr.path, li)));
      return Lr.common.async ? Promise.all(Vn).then((oi) => qn(oi)) : qn(Vn);
    }
    min(Je, pr) {
      return new wc({
        ...this._def,
        minSize: { value: Je, message: Ws.toString(pr) }
      });
    }
    max(Je, pr) {
      return new wc({
        ...this._def,
        maxSize: { value: Je, message: Ws.toString(pr) }
      });
    }
    size(Je, pr) {
      return this.min(Je, pr).max(Je, pr);
    }
    nonempty(Je) {
      return this.min(1, Je);
    }
  }
  wc.create = (ar, Je) => new wc({
    valueType: ar,
    minSize: null,
    maxSize: null,
    typeName: eo.ZodSet,
    ...po(Je)
  });
  class iu extends Eo {
    constructor() {
      super(...arguments), this.validate = this.implement;
    }
    _parse(Je) {
      const { ctx: pr } = this._processInputParams(Je);
      if (pr.parsedType !== Ns.function)
        return qs(pr, {
          code: ys.invalid_type,
          expected: Ns.function,
          received: pr.parsedType
        }), ao;
      function Lr(Vn, oi) {
        return ll({
          data: Vn,
          path: pr.path,
          errorMaps: [
            pr.common.contextualErrorMap,
            pr.schemaErrorMap,
            fl(),
            Ef
          ].filter((li) => !!li),
          issueData: {
            code: ys.invalid_arguments,
            argumentsError: oi
          }
        });
      }
      function hn(Vn, oi) {
        return ll({
          data: Vn,
          path: pr.path,
          errorMaps: [
            pr.common.contextualErrorMap,
            pr.schemaErrorMap,
            fl(),
            Ef
          ].filter((li) => !!li),
          issueData: {
            code: ys.invalid_return_type,
            returnTypeError: oi
          }
        });
      }
      const mn = { errorMap: pr.common.contextualErrorMap }, qn = pr.data;
      return this._def.returns instanceof tc ? Pa(async (...Vn) => {
        const oi = new hu([]), li = await this._def.args.parseAsync(Vn, mn).catch((is) => {
          throw oi.addIssue(Lr(Vn, is)), oi;
        }), Di = await qn(...li);
        return await this._def.returns._def.type.parseAsync(Di, mn).catch((is) => {
          throw oi.addIssue(hn(Di, is)), oi;
        });
      }) : Pa((...Vn) => {
        const oi = this._def.args.safeParse(Vn, mn);
        if (!oi.success)
          throw new hu([Lr(Vn, oi.error)]);
        const li = qn(...oi.data), Di = this._def.returns.safeParse(li, mn);
        if (!Di.success)
          throw new hu([hn(li, Di.error)]);
        return Di.data;
      });
    }
    parameters() {
      return this._def.args;
    }
    returnType() {
      return this._def.returns;
    }
    args(...Je) {
      return new iu({
        ...this._def,
        args: Su.create(Je).rest(Ic.create())
      });
    }
    returns(Je) {
      return new iu({
        ...this._def,
        returns: Je
      });
    }
    implement(Je) {
      return this.parse(Je);
    }
    strictImplement(Je) {
      return this.parse(Je);
    }
    static create(Je, pr, Lr) {
      return new iu({
        args: Je || Su.create([]).rest(Ic.create()),
        returns: pr || Ic.create(),
        typeName: eo.ZodFunction,
        ...po(Lr)
      });
    }
  }
  class Fc extends Eo {
    get schema() {
      return this._def.getter();
    }
    _parse(Je) {
      const { ctx: pr } = this._processInputParams(Je);
      return this._def.getter()._parse({ data: pr.data, path: pr.path, parent: pr });
    }
  }
  Fc.create = (ar, Je) => new Fc({
    getter: ar,
    typeName: eo.ZodLazy,
    ...po(Je)
  });
  class ja extends Eo {
    _parse(Je) {
      if (Je.data !== this._def.value) {
        const pr = this._getOrReturnCtx(Je);
        return qs(pr, {
          received: pr.data,
          code: ys.invalid_literal,
          expected: this._def.value
        }), ao;
      }
      return { status: "valid", value: Je.data };
    }
    get value() {
      return this._def.value;
    }
  }
  ja.create = (ar, Je) => new ja({
    value: ar,
    typeName: eo.ZodLiteral,
    ...po(Je)
  });
  function pl(ar, Je) {
    return new N2({
      values: ar,
      typeName: eo.ZodEnum,
      ...po(Je)
    });
  }
  class N2 extends Eo {
    _parse(Je) {
      if (typeof Je.data != "string") {
        const pr = this._getOrReturnCtx(Je), Lr = this._def.values;
        return qs(pr, {
          expected: Fo.joinValues(Lr),
          received: pr.parsedType,
          code: ys.invalid_type
        }), ao;
      }
      if (this._def.values.indexOf(Je.data) === -1) {
        const pr = this._getOrReturnCtx(Je), Lr = this._def.values;
        return qs(pr, {
          received: pr.data,
          code: ys.invalid_enum_value,
          options: Lr
        }), ao;
      }
      return Pa(Je.data);
    }
    get options() {
      return this._def.values;
    }
    get enum() {
      const Je = {};
      for (const pr of this._def.values)
        Je[pr] = pr;
      return Je;
    }
    get Values() {
      const Je = {};
      for (const pr of this._def.values)
        Je[pr] = pr;
      return Je;
    }
    get Enum() {
      const Je = {};
      for (const pr of this._def.values)
        Je[pr] = pr;
      return Je;
    }
    extract(Je) {
      return N2.create(Je);
    }
    exclude(Je) {
      return N2.create(this.options.filter((pr) => !Je.includes(pr)));
    }
  }
  N2.create = pl;
  class ra extends Eo {
    _parse(Je) {
      const pr = Fo.getValidEnumValues(this._def.values), Lr = this._getOrReturnCtx(Je);
      if (Lr.parsedType !== Ns.string && Lr.parsedType !== Ns.number) {
        const hn = Fo.objectValues(pr);
        return qs(Lr, {
          expected: Fo.joinValues(hn),
          received: Lr.parsedType,
          code: ys.invalid_type
        }), ao;
      }
      if (pr.indexOf(Je.data) === -1) {
        const hn = Fo.objectValues(pr);
        return qs(Lr, {
          received: Lr.data,
          code: ys.invalid_enum_value,
          options: hn
        }), ao;
      }
      return Pa(Je.data);
    }
    get enum() {
      return this._def.values;
    }
  }
  ra.create = (ar, Je) => new ra({
    values: ar,
    typeName: eo.ZodNativeEnum,
    ...po(Je)
  });
  class tc extends Eo {
    unwrap() {
      return this._def.type;
    }
    _parse(Je) {
      const { ctx: pr } = this._processInputParams(Je);
      if (pr.parsedType !== Ns.promise && pr.common.async === !1)
        return qs(pr, {
          code: ys.invalid_type,
          expected: Ns.promise,
          received: pr.parsedType
        }), ao;
      const Lr = pr.parsedType === Ns.promise ? pr.data : Promise.resolve(pr.data);
      return Pa(Lr.then((hn) => this._def.type.parseAsync(hn, {
        path: pr.path,
        errorMap: pr.common.contextualErrorMap
      })));
    }
  }
  tc.create = (ar, Je) => new tc({
    type: ar,
    typeName: eo.ZodPromise,
    ...po(Je)
  });
  class pu extends Eo {
    innerType() {
      return this._def.schema;
    }
    sourceType() {
      return this._def.schema._def.typeName === eo.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(Je) {
      const { status: pr, ctx: Lr } = this._processInputParams(Je), hn = this._def.effect || null;
      if (hn.type === "preprocess") {
        const qn = hn.transform(Lr.data);
        return Lr.common.async ? Promise.resolve(qn).then((Vn) => this._def.schema._parseAsync({
          data: Vn,
          path: Lr.path,
          parent: Lr
        })) : this._def.schema._parseSync({
          data: qn,
          path: Lr.path,
          parent: Lr
        });
      }
      const mn = {
        addIssue: (qn) => {
          qs(Lr, qn), qn.fatal ? pr.abort() : pr.dirty();
        },
        get path() {
          return Lr.path;
        }
      };
      if (mn.addIssue = mn.addIssue.bind(mn), hn.type === "refinement") {
        const qn = (Vn) => {
          const oi = hn.refinement(Vn, mn);
          if (Lr.common.async)
            return Promise.resolve(oi);
          if (oi instanceof Promise)
            throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
          return Vn;
        };
        if (Lr.common.async === !1) {
          const Vn = this._def.schema._parseSync({
            data: Lr.data,
            path: Lr.path,
            parent: Lr
          });
          return Vn.status === "aborted" ? ao : (Vn.status === "dirty" && pr.dirty(), qn(Vn.value), { status: pr.value, value: Vn.value });
        } else
          return this._def.schema._parseAsync({ data: Lr.data, path: Lr.path, parent: Lr }).then((Vn) => Vn.status === "aborted" ? ao : (Vn.status === "dirty" && pr.dirty(), qn(Vn.value).then(() => ({ status: pr.value, value: Vn.value }))));
      }
      if (hn.type === "transform")
        if (Lr.common.async === !1) {
          const qn = this._def.schema._parseSync({
            data: Lr.data,
            path: Lr.path,
            parent: Lr
          });
          if (!Bf(qn))
            return qn;
          const Vn = hn.transform(qn.value, mn);
          if (Vn instanceof Promise)
            throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
          return { status: pr.value, value: Vn };
        } else
          return this._def.schema._parseAsync({ data: Lr.data, path: Lr.path, parent: Lr }).then((qn) => Bf(qn) ? Promise.resolve(hn.transform(qn.value, mn)).then((Vn) => ({ status: pr.value, value: Vn })) : qn);
      Fo.assertNever(hn);
    }
  }
  pu.create = (ar, Je, pr) => new pu({
    schema: ar,
    typeName: eo.ZodEffects,
    effect: Je,
    ...po(pr)
  }), pu.createWithPreprocess = (ar, Je, pr) => new pu({
    schema: Je,
    effect: { type: "preprocess", transform: ar },
    typeName: eo.ZodEffects,
    ...po(pr)
  });
  class Tu extends Eo {
    _parse(Je) {
      return this._getType(Je) === Ns.undefined ? Pa(void 0) : this._def.innerType._parse(Je);
    }
    unwrap() {
      return this._def.innerType;
    }
  }
  Tu.create = (ar, Je) => new Tu({
    innerType: ar,
    typeName: eo.ZodOptional,
    ...po(Je)
  });
  class rc extends Eo {
    _parse(Je) {
      return this._getType(Je) === Ns.null ? Pa(null) : this._def.innerType._parse(Je);
    }
    unwrap() {
      return this._def.innerType;
    }
  }
  rc.create = (ar, Je) => new rc({
    innerType: ar,
    typeName: eo.ZodNullable,
    ...po(Je)
  });
  class Lc extends Eo {
    _parse(Je) {
      const { ctx: pr } = this._processInputParams(Je);
      let Lr = pr.data;
      return pr.parsedType === Ns.undefined && (Lr = this._def.defaultValue()), this._def.innerType._parse({
        data: Lr,
        path: pr.path,
        parent: pr
      });
    }
    removeDefault() {
      return this._def.innerType;
    }
  }
  Lc.create = (ar, Je) => new Lc({
    innerType: ar,
    typeName: eo.ZodDefault,
    defaultValue: typeof Je.default == "function" ? Je.default : () => Je.default,
    ...po(Je)
  });
  class Rf extends Eo {
    _parse(Je) {
      const { ctx: pr } = this._processInputParams(Je), Lr = {
        ...pr,
        common: {
          ...pr.common,
          issues: []
        }
      }, hn = this._def.innerType._parse({
        data: Lr.data,
        path: Lr.path,
        parent: {
          ...Lr
        }
      });
      return vf(hn) ? hn.then((mn) => ({
        status: "valid",
        value: mn.status === "valid" ? mn.value : this._def.catchValue({
          get error() {
            return new hu(Lr.common.issues);
          },
          input: Lr.data
        })
      })) : {
        status: "valid",
        value: hn.status === "valid" ? hn.value : this._def.catchValue({
          get error() {
            return new hu(Lr.common.issues);
          },
          input: Lr.data
        })
      };
    }
    removeCatch() {
      return this._def.innerType;
    }
  }
  Rf.create = (ar, Je) => new Rf({
    innerType: ar,
    typeName: eo.ZodCatch,
    catchValue: typeof Je.catch == "function" ? Je.catch : () => Je.catch,
    ...po(Je)
  });
  class Df extends Eo {
    _parse(Je) {
      if (this._getType(Je) !== Ns.nan) {
        const Lr = this._getOrReturnCtx(Je);
        return qs(Lr, {
          code: ys.invalid_type,
          expected: Ns.nan,
          received: Lr.parsedType
        }), ao;
      }
      return { status: "valid", value: Je.data };
    }
  }
  Df.create = (ar) => new Df({
    typeName: eo.ZodNaN,
    ...po(ar)
  });
  const wA = Symbol("zod_brand");
  class Hc extends Eo {
    _parse(Je) {
      const { ctx: pr } = this._processInputParams(Je), Lr = pr.data;
      return this._def.type._parse({
        data: Lr,
        path: pr.path,
        parent: pr
      });
    }
    unwrap() {
      return this._def.type;
    }
  }
  class Nf extends Eo {
    _parse(Je) {
      const { status: pr, ctx: Lr } = this._processInputParams(Je);
      if (Lr.common.async)
        return (async () => {
          const mn = await this._def.in._parseAsync({
            data: Lr.data,
            path: Lr.path,
            parent: Lr
          });
          return mn.status === "aborted" ? ao : mn.status === "dirty" ? (pr.dirty(), sA(mn.value)) : this._def.out._parseAsync({
            data: mn.value,
            path: Lr.path,
            parent: Lr
          });
        })();
      {
        const hn = this._def.in._parseSync({
          data: Lr.data,
          path: Lr.path,
          parent: Lr
        });
        return hn.status === "aborted" ? ao : hn.status === "dirty" ? (pr.dirty(), {
          status: "dirty",
          value: hn.value
        }) : this._def.out._parseSync({
          data: hn.value,
          path: Lr.path,
          parent: Lr
        });
      }
    }
    static create(Je, pr) {
      return new Nf({
        in: Je,
        out: pr,
        typeName: eo.ZodPipeline
      });
    }
  }
  const PA = (ar, Je = {}, pr) => ar ? mc.create().superRefine((Lr, hn) => {
    var mn, qn;
    if (!ar(Lr)) {
      const Vn = typeof Je == "function" ? Je(Lr) : typeof Je == "string" ? { message: Je } : Je, oi = (qn = (mn = Vn.fatal) !== null && mn !== void 0 ? mn : pr) !== null && qn !== void 0 ? qn : !0, li = typeof Vn == "string" ? { message: Vn } : Vn;
      hn.addIssue({ code: "custom", ...li, fatal: oi });
    }
  }) : mc.create(), zp = {
    object: $o.lazycreate
  };
  var eo;
  (function(ar) {
    ar.ZodString = "ZodString", ar.ZodNumber = "ZodNumber", ar.ZodNaN = "ZodNaN", ar.ZodBigInt = "ZodBigInt", ar.ZodBoolean = "ZodBoolean", ar.ZodDate = "ZodDate", ar.ZodSymbol = "ZodSymbol", ar.ZodUndefined = "ZodUndefined", ar.ZodNull = "ZodNull", ar.ZodAny = "ZodAny", ar.ZodUnknown = "ZodUnknown", ar.ZodNever = "ZodNever", ar.ZodVoid = "ZodVoid", ar.ZodArray = "ZodArray", ar.ZodObject = "ZodObject", ar.ZodUnion = "ZodUnion", ar.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", ar.ZodIntersection = "ZodIntersection", ar.ZodTuple = "ZodTuple", ar.ZodRecord = "ZodRecord", ar.ZodMap = "ZodMap", ar.ZodSet = "ZodSet", ar.ZodFunction = "ZodFunction", ar.ZodLazy = "ZodLazy", ar.ZodLiteral = "ZodLiteral", ar.ZodEnum = "ZodEnum", ar.ZodEffects = "ZodEffects", ar.ZodNativeEnum = "ZodNativeEnum", ar.ZodOptional = "ZodOptional", ar.ZodNullable = "ZodNullable", ar.ZodDefault = "ZodDefault", ar.ZodCatch = "ZodCatch", ar.ZodPromise = "ZodPromise", ar.ZodBranded = "ZodBranded", ar.ZodPipeline = "ZodPipeline";
  })(eo || (eo = {}));
  const yl = (ar, Je = {
    message: `Input not instance of ${ar.name}`
  }) => PA((pr) => pr instanceof ar, Je), ml = Oa.create, Sd = E2.create, e1 = Df.create, Jp = x2.create, t1 = Cf.create, cs = Zo.create, Yp = hl.create, r1 = kf.create, n1 = Yo.create, Td = mc.create, Xp = Ic.create, No = ku.create, _p = Al.create, i1 = Ia.create, s1 = $o.create, o1 = $o.strictCreate, xd = D2.create, Zp = Sf.create, a1 = Tf.create, u1 = Su.create, c1 = xf.create, Rd = gu.create, Dd = wc.create, Nd = iu.create, Va = Fc.create, $p = ja.create, e4 = N2.create, Pd = ra.create, f1 = tc.create, Qa = pu.create, l1 = Tu.create, Il = rc.create, d1 = pu.createWithPreprocess, qd = Nf.create;
  var ca = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    defaultErrorMap: Ef,
    setErrorMap: Up,
    getErrorMap: fl,
    makeIssue: ll,
    EMPTY_PATH: Mp,
    addIssueToContext: qs,
    ParseStatus: Na,
    INVALID: ao,
    DIRTY: sA,
    OK: Pa,
    isAborted: Au,
    isDirty: Wo,
    isValid: Bf,
    isAsync: vf,
    get util() {
      return Fo;
    },
    get objectUtil() {
      return vd;
    },
    ZodParsedType: Ns,
    getParsedType: l2,
    ZodType: Eo,
    ZodString: Oa,
    ZodNumber: E2,
    ZodBigInt: x2,
    ZodBoolean: Cf,
    ZodDate: Zo,
    ZodSymbol: hl,
    ZodUndefined: kf,
    ZodNull: Yo,
    ZodAny: mc,
    ZodUnknown: Ic,
    ZodNever: ku,
    ZodVoid: Al,
    ZodArray: Ia,
    ZodObject: $o,
    ZodUnion: D2,
    ZodDiscriminatedUnion: Sf,
    ZodIntersection: Tf,
    ZodTuple: Su,
    ZodRecord: xf,
    ZodMap: gu,
    ZodSet: wc,
    ZodFunction: iu,
    ZodLazy: Fc,
    ZodLiteral: ja,
    ZodEnum: N2,
    ZodNativeEnum: ra,
    ZodPromise: tc,
    ZodEffects: pu,
    ZodTransformer: pu,
    ZodOptional: Tu,
    ZodNullable: rc,
    ZodDefault: Lc,
    ZodCatch: Rf,
    ZodNaN: Df,
    BRAND: wA,
    ZodBranded: Hc,
    ZodPipeline: Nf,
    custom: PA,
    Schema: Eo,
    ZodSchema: Eo,
    late: zp,
    get ZodFirstPartyTypeKind() {
      return eo;
    },
    coerce: {
      string: (ar) => Oa.create({ ...ar, coerce: !0 }),
      number: (ar) => E2.create({ ...ar, coerce: !0 }),
      boolean: (ar) => Cf.create({
        ...ar,
        coerce: !0
      }),
      bigint: (ar) => x2.create({ ...ar, coerce: !0 }),
      date: (ar) => Zo.create({ ...ar, coerce: !0 })
    },
    any: Td,
    array: i1,
    bigint: Jp,
    boolean: t1,
    date: cs,
    discriminatedUnion: Zp,
    effect: Qa,
    enum: e4,
    function: Nd,
    instanceof: yl,
    intersection: a1,
    lazy: Va,
    literal: $p,
    map: Rd,
    nan: e1,
    nativeEnum: Pd,
    never: No,
    null: n1,
    nullable: Il,
    number: Sd,
    object: s1,
    oboolean: () => t1().optional(),
    onumber: () => Sd().optional(),
    optional: l1,
    ostring: () => ml().optional(),
    pipeline: qd,
    preprocess: d1,
    promise: f1,
    record: c1,
    set: Dd,
    strictObject: o1,
    string: ml,
    symbol: Yp,
    transformer: Qa,
    tuple: u1,
    undefined: r1,
    union: xd,
    unknown: Xp,
    void: _p,
    NEVER: ao,
    ZodIssueCode: ys,
    quotelessJson: Qp,
    ZodError: hu
  });
  const h1 = ca.string().regex(/^[a-fA-F0-9]$/), n4 = ca.string().regex(/^[a-fA-F0-9]{64}$/), Kc = ca.number().min(0).max(4294967295), A1 = ca.bigint(), Od = ca.instanceof(Uint8Array), su = ca.union([h1, Kc, ca.string(), Od]).array(), Gc = ca.union([su, h1, Od]), wl = ca.array(Gc), Qd = ca.object({
    value: ca.union([Kc, A1]),
    scriptPubKey: Gc
  }), g1 = ca.object({
    txid: n4,
    vout: Kc,
    scriptSig: Gc,
    sequence: Kc,
    prevout: Qd.optional(),
    witness: wl
  }), p1 = {
    TxData: ca.object({
      version: Kc,
      vin: ca.array(g1),
      vout: ca.array(Qd),
      locktime: Kc
    })
  };
  class nc {
    constructor(Je) {
      typeof Je == "string" && (Je = vr.hex(Je)), Je instanceof Uint8Array && (Je = La.decode(Je));
      const pr = p1.TxData;
      this._data = pr.parse(La.create(Je));
    }
    get data() {
      return this._data;
    }
    get version() {
      return this.data.version;
    }
    get vin() {
      return this.data.vin.map((Je, pr) => new eA(this.data, pr));
    }
    get vout() {
      return this.data.vout.map((Je) => new Bd(Je));
    }
    get locktime() {
      return new Op(this.data.locktime);
    }
    get base() {
      return La.encode(this.data, !0);
    }
    get buff() {
      return La.encode(this.data);
    }
    get raw() {
      return this.buff.raw;
    }
    get hex() {
      return this.buff.hex;
    }
    get size() {
      return this.raw.length;
    }
    get bsize() {
      return this.base.length;
    }
    get weight() {
      return this.bsize * 3 + this.size;
    }
    get vsize() {
      const Je = this.weight % 4 > 0 ? 1 : 0;
      return Math.floor(this.weight / 4) + Je;
    }
    get hash() {
      return Fu(this.buff).reverse().hex;
    }
    get txid() {
      return Fu(this.base).reverse().hex;
    }
    async export() {
      const { size: Je, weight: pr, vsize: Lr, hex: hn } = this, mn = this.txid, qn = this.hash;
      return { txid: mn, hash: qn, ...this.data, size: Je, weight: pr, vsize: Lr, hex: hn };
    }
  }
  return main$1.Address = sl, main$1.Input = eA, main$1.Output = Bd, main$1.Script = Mr, main$1.Sequence = Zh, main$1.Signer = ua, main$1.Tap = Dp, main$1.Transaction = nc, main$1.Tx = La, main$1.Witness = $h, main$1;
}
var build = {}, ascii = {}, hasRequiredAscii;
function requireAscii() {
  if (hasRequiredAscii) return ascii;
  hasRequiredAscii = 1, Object.defineProperty(ascii, "__esModule", { value: !0 }), ascii.fromAscii = ascii.toAscii = void 0;
  function s(u) {
    const p = (t) => t.split("").map((l) => {
      const m = l.charCodeAt(0);
      if (m < 32 || m > 126)
        throw new Error("Cannot encode character that is out of printable ASCII range: " + m);
      return m;
    });
    return Uint8Array.from(p(u));
  }
  ascii.toAscii = s;
  function A(u) {
    return ((t) => t.map((l) => {
      if (l < 32 || l > 126)
        throw new Error("Cannot decode character that is out of printable ASCII range: " + l);
      return String.fromCharCode(l);
    }))(Array.from(u)).join("");
  }
  return ascii.fromAscii = A, ascii;
}
var base64 = {}, hasRequiredBase64;
function requireBase64() {
  if (hasRequiredBase64) return base64;
  hasRequiredBase64 = 1;
  var s = base64 && base64.__createBinding || (Object.create ? function(m, b, k, C) {
    C === void 0 && (C = k);
    var B = Object.getOwnPropertyDescriptor(b, k);
    (!B || ("get" in B ? !b.__esModule : B.writable || B.configurable)) && (B = { enumerable: !0, get: function() {
      return b[k];
    } }), Object.defineProperty(m, C, B);
  } : function(m, b, k, C) {
    C === void 0 && (C = k), m[C] = b[k];
  }), A = base64 && base64.__setModuleDefault || (Object.create ? function(m, b) {
    Object.defineProperty(m, "default", { enumerable: !0, value: b });
  } : function(m, b) {
    m.default = b;
  }), u = base64 && base64.__importStar || function(m) {
    if (m && m.__esModule) return m;
    var b = {};
    if (m != null) for (var k in m) k !== "default" && Object.prototype.hasOwnProperty.call(m, k) && s(b, m, k);
    return A(b, m), b;
  };
  Object.defineProperty(base64, "__esModule", { value: !0 }), base64.fromBase64 = base64.toBase64 = void 0;
  const p = u(requireBase64Js());
  function t(m) {
    return p.fromByteArray(m);
  }
  base64.toBase64 = t;
  function l(m) {
    if (!m.match(/^[a-zA-Z0-9+/]*={0,2}$/))
      throw new Error("Invalid base64 string format");
    return p.toByteArray(m);
  }
  return base64.fromBase64 = l, base64;
}
var bech32 = {}, hasRequiredBech32;
function requireBech32() {
  if (hasRequiredBech32) return bech32;
  hasRequiredBech32 = 1;
  var s = bech32 && bech32.__createBinding || (Object.create ? function(b, k, C, B) {
    B === void 0 && (B = C);
    var Q = Object.getOwnPropertyDescriptor(k, C);
    (!Q || ("get" in Q ? !k.__esModule : Q.writable || Q.configurable)) && (Q = { enumerable: !0, get: function() {
      return k[C];
    } }), Object.defineProperty(b, B, Q);
  } : function(b, k, C, B) {
    B === void 0 && (B = C), b[B] = k[C];
  }), A = bech32 && bech32.__setModuleDefault || (Object.create ? function(b, k) {
    Object.defineProperty(b, "default", { enumerable: !0, value: k });
  } : function(b, k) {
    b.default = k;
  }), u = bech32 && bech32.__importStar || function(b) {
    if (b && b.__esModule) return b;
    var k = {};
    if (b != null) for (var C in b) C !== "default" && Object.prototype.hasOwnProperty.call(b, C) && s(k, b, C);
    return A(k, b), k;
  };
  Object.defineProperty(bech32, "__esModule", { value: !0 }), bech32.normalizeBech32 = bech32.fromBech32 = bech32.toBech32 = void 0;
  const p = u(requireBech32$2());
  function t(b, k, C) {
    return p.encode(b, p.toWords(k), C);
  }
  bech32.toBech32 = t;
  function l(b, k = 1 / 0) {
    const C = p.decode(b, k);
    return {
      prefix: C.prefix,
      data: new Uint8Array(p.fromWords(C.words))
    };
  }
  bech32.fromBech32 = l;
  function m(b) {
    const { prefix: k, data: C } = l(b);
    return t(k, C);
  }
  return bech32.normalizeBech32 = m, bech32;
}
var hex = {}, hasRequiredHex;
function requireHex() {
  if (hasRequiredHex) return hex;
  hasRequiredHex = 1, Object.defineProperty(hex, "__esModule", { value: !0 }), hex.fromHex = hex.toHex = void 0;
  function s(u) {
    let p = "";
    for (const t of u)
      p += ("0" + t.toString(16)).slice(-2);
    return p;
  }
  hex.toHex = s;
  function A(u) {
    if (u.length % 2 !== 0)
      throw new Error("hex string length must be a multiple of 2");
    const p = new Uint8Array(u.length / 2);
    for (let t = 0; t < p.length; t++) {
      const l = 2 * t, m = u.slice(l, l + 2);
      if (!m.match(/[0-9a-f]{2}/i))
        throw new Error("hex string contains invalid characters");
      p[t] = parseInt(m, 16);
    }
    return p;
  }
  return hex.fromHex = A, hex;
}
var rfc3339 = {}, hasRequiredRfc3339;
function requireRfc3339() {
  if (hasRequiredRfc3339) return rfc3339;
  hasRequiredRfc3339 = 1, Object.defineProperty(rfc3339, "__esModule", { value: !0 }), rfc3339.toRfc3339 = rfc3339.fromRfc3339 = void 0;
  const s = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
  function A(t, l = 2) {
    return t.toString().padStart(l, "0");
  }
  function u(t) {
    const l = s.exec(t);
    if (!l)
      throw new Error("Date string is not in RFC3339 format");
    const m = +l[1], b = +l[2], k = +l[3], C = +l[4], B = +l[5], Q = +l[6], P = l[7] ? Math.floor(+l[7] * 1e3) : 0;
    let x, M, F;
    l[8] === "Z" ? (x = 1, M = 0, F = 0) : (x = l[8].substring(0, 1) === "-" ? -1 : 1, M = +l[8].substring(1, 3), F = +l[8].substring(4, 6));
    const le = x * (M * 60 + F) * 60, ge = /* @__PURE__ */ new Date();
    return ge.setUTCFullYear(m, b - 1, k), ge.setUTCHours(C, B, Q, P), new Date(ge.getTime() - le * 1e3);
  }
  rfc3339.fromRfc3339 = u;
  function p(t) {
    const l = t.getUTCFullYear(), m = A(t.getUTCMonth() + 1), b = A(t.getUTCDate()), k = A(t.getUTCHours()), C = A(t.getUTCMinutes()), B = A(t.getUTCSeconds()), Q = A(t.getUTCMilliseconds(), 3);
    return `${l}-${m}-${b}T${k}:${C}:${B}.${Q}Z`;
  }
  return rfc3339.toRfc3339 = p, rfc3339;
}
var utf8 = {}, hasRequiredUtf8;
function requireUtf8() {
  if (hasRequiredUtf8) return utf8;
  hasRequiredUtf8 = 1, Object.defineProperty(utf8, "__esModule", { value: !0 }), utf8.fromUtf8 = utf8.toUtf8 = void 0;
  function s(u) {
    return new TextEncoder().encode(u);
  }
  utf8.toUtf8 = s;
  function A(u, p = !1) {
    const t = !p;
    return new TextDecoder("utf-8", { fatal: t }).decode(u);
  }
  return utf8.fromUtf8 = A, utf8;
}
var hasRequiredBuild;
function requireBuild() {
  return hasRequiredBuild || (hasRequiredBuild = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.toUtf8 = s.fromUtf8 = s.toRfc3339 = s.fromRfc3339 = s.toHex = s.fromHex = s.toBech32 = s.normalizeBech32 = s.fromBech32 = s.toBase64 = s.fromBase64 = s.toAscii = s.fromAscii = void 0;
    var A = requireAscii();
    Object.defineProperty(s, "fromAscii", { enumerable: !0, get: function() {
      return A.fromAscii;
    } }), Object.defineProperty(s, "toAscii", { enumerable: !0, get: function() {
      return A.toAscii;
    } });
    var u = requireBase64();
    Object.defineProperty(s, "fromBase64", { enumerable: !0, get: function() {
      return u.fromBase64;
    } }), Object.defineProperty(s, "toBase64", { enumerable: !0, get: function() {
      return u.toBase64;
    } });
    var p = requireBech32();
    Object.defineProperty(s, "fromBech32", { enumerable: !0, get: function() {
      return p.fromBech32;
    } }), Object.defineProperty(s, "normalizeBech32", { enumerable: !0, get: function() {
      return p.normalizeBech32;
    } }), Object.defineProperty(s, "toBech32", { enumerable: !0, get: function() {
      return p.toBech32;
    } });
    var t = requireHex();
    Object.defineProperty(s, "fromHex", { enumerable: !0, get: function() {
      return t.fromHex;
    } }), Object.defineProperty(s, "toHex", { enumerable: !0, get: function() {
      return t.toHex;
    } });
    var l = requireRfc3339();
    Object.defineProperty(s, "fromRfc3339", { enumerable: !0, get: function() {
      return l.fromRfc3339;
    } }), Object.defineProperty(s, "toRfc3339", { enumerable: !0, get: function() {
      return l.toRfc3339;
    } });
    var m = requireUtf8();
    Object.defineProperty(s, "fromUtf8", { enumerable: !0, get: function() {
      return m.fromUtf8;
    } }), Object.defineProperty(s, "toUtf8", { enumerable: !0, get: function() {
      return m.toUtf8;
    } });
  }(build)), build;
}
var lib$1 = {}, hasRequiredLib$1;
function requireLib$1() {
  return hasRequiredLib$1 || (hasRequiredLib$1 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.bytes = s.stringToBytes = s.str = s.bytesToString = s.hex = s.utf8 = s.bech32m = s.bech32 = s.base58check = s.createBase58check = s.base58xmr = s.base58xrp = s.base58flickr = s.base58 = s.base64urlnopad = s.base64url = s.base64nopad = s.base64 = s.base32crockford = s.base32hexnopad = s.base32hex = s.base32nopad = s.base32 = s.base16 = s.utils = void 0, s.assertNumber = A;
    // @__NO_SIDE_EFFECTS__
    function A(we) {
      if (!Number.isSafeInteger(we))
        throw new Error(`Wrong integer: ${we}`);
    }
    function u(we) {
      return we instanceof Uint8Array || we != null && typeof we == "object" && we.constructor.name === "Uint8Array";
    }
    // @__NO_SIDE_EFFECTS__
    function p(...we) {
      const Ce = (er) => er, Se = (er, ir) => (sr) => er(ir(sr)), Ne = we.map((er) => er.encode).reduceRight(Se, Ce), rr = we.map((er) => er.decode).reduce(Se, Ce);
      return { encode: Ne, decode: rr };
    }
    // @__NO_SIDE_EFFECTS__
    function t(we) {
      return {
        encode: (Ce) => {
          if (!Array.isArray(Ce) || Ce.length && typeof Ce[0] != "number")
            throw new Error("alphabet.encode input should be an array of numbers");
          return Ce.map((Se) => {
            if (Se < 0 || Se >= we.length)
              throw new Error(`Digit index outside alphabet: ${Se} (alphabet: ${we.length})`);
            return we[Se];
          });
        },
        decode: (Ce) => {
          if (!Array.isArray(Ce) || Ce.length && typeof Ce[0] != "string")
            throw new Error("alphabet.decode input should be array of strings");
          return Ce.map((Se) => {
            if (typeof Se != "string")
              throw new Error(`alphabet.decode: not string element=${Se}`);
            const Ne = we.indexOf(Se);
            if (Ne === -1)
              throw new Error(`Unknown letter: "${Se}". Allowed: ${we}`);
            return Ne;
          });
        }
      };
    }
    // @__NO_SIDE_EFFECTS__
    function l(we = "") {
      if (typeof we != "string")
        throw new Error("join separator should be string");
      return {
        encode: (Ce) => {
          if (!Array.isArray(Ce) || Ce.length && typeof Ce[0] != "string")
            throw new Error("join.encode input should be array of strings");
          for (let Se of Ce)
            if (typeof Se != "string")
              throw new Error(`join.encode: non-string input=${Se}`);
          return Ce.join(we);
        },
        decode: (Ce) => {
          if (typeof Ce != "string")
            throw new Error("join.decode input should be string");
          return Ce.split(we);
        }
      };
    }
    // @__NO_SIDE_EFFECTS__
    function m(we, Ce = "=") {
      if (typeof Ce != "string")
        throw new Error("padding chr should be string");
      return {
        encode(Se) {
          if (!Array.isArray(Se) || Se.length && typeof Se[0] != "string")
            throw new Error("padding.encode input should be array of strings");
          for (let Ne of Se)
            if (typeof Ne != "string")
              throw new Error(`padding.encode: non-string input=${Ne}`);
          for (; Se.length * we % 8; )
            Se.push(Ce);
          return Se;
        },
        decode(Se) {
          if (!Array.isArray(Se) || Se.length && typeof Se[0] != "string")
            throw new Error("padding.encode input should be array of strings");
          for (let rr of Se)
            if (typeof rr != "string")
              throw new Error(`padding.decode: non-string input=${rr}`);
          let Ne = Se.length;
          if (Ne * we % 8)
            throw new Error("Invalid padding: string should have whole number of bytes");
          for (; Ne > 0 && Se[Ne - 1] === Ce; Ne--)
            if (!((Ne - 1) * we % 8))
              throw new Error("Invalid padding: string has too much padding");
          return Se.slice(0, Ne);
        }
      };
    }
    // @__NO_SIDE_EFFECTS__
    function b(we) {
      if (typeof we != "function")
        throw new Error("normalize fn should be function");
      return { encode: (Ce) => Ce, decode: (Ce) => we(Ce) };
    }
    // @__NO_SIDE_EFFECTS__
    function k(we, Ce, Se) {
      if (Ce < 2)
        throw new Error(`convertRadix: wrong from=${Ce}, base cannot be less than 2`);
      if (Se < 2)
        throw new Error(`convertRadix: wrong to=${Se}, base cannot be less than 2`);
      if (!Array.isArray(we))
        throw new Error("convertRadix: data should be array");
      if (!we.length)
        return [];
      let Ne = 0;
      const rr = [], er = Array.from(we);
      for (er.forEach((ir) => {
        if (ir < 0 || ir >= Ce)
          throw new Error(`Wrong integer: ${ir}`);
      }); ; ) {
        let ir = 0, sr = !0;
        for (let nr = Ne; nr < er.length; nr++) {
          const fr = er[nr], lr = Ce * ir + fr;
          if (!Number.isSafeInteger(lr) || Ce * ir / Ce !== ir || lr - fr !== Ce * ir)
            throw new Error("convertRadix: carry overflow");
          ir = lr % Se;
          const br = Math.floor(lr / Se);
          if (er[nr] = br, !Number.isSafeInteger(br) || br * Se + ir !== lr)
            throw new Error("convertRadix: carry overflow");
          if (sr)
            br ? sr = !1 : Ne = nr;
          else continue;
        }
        if (rr.push(ir), sr)
          break;
      }
      for (let ir = 0; ir < we.length - 1 && we[ir] === 0; ir++)
        rr.push(0);
      return rr.reverse();
    }
    const C = /* @__NO_SIDE_EFFECTS__ */ (we, Ce) => Ce ? /* @__PURE__ */ C(Ce, we % Ce) : we, B = /* @__NO_SIDE_EFFECTS__ */ (we, Ce) => we + (Ce - /* @__PURE__ */ C(we, Ce));
    // @__NO_SIDE_EFFECTS__
    function Q(we, Ce, Se, Ne) {
      if (!Array.isArray(we))
        throw new Error("convertRadix2: data should be array");
      if (Ce <= 0 || Ce > 32)
        throw new Error(`convertRadix2: wrong from=${Ce}`);
      if (Se <= 0 || Se > 32)
        throw new Error(`convertRadix2: wrong to=${Se}`);
      if (/* @__PURE__ */ B(Ce, Se) > 32)
        throw new Error(`convertRadix2: carry overflow from=${Ce} to=${Se} carryBits=${/* @__PURE__ */ B(Ce, Se)}`);
      let rr = 0, er = 0;
      const ir = 2 ** Se - 1, sr = [];
      for (const nr of we) {
        if (nr >= 2 ** Ce)
          throw new Error(`convertRadix2: invalid data word=${nr} from=${Ce}`);
        if (rr = rr << Ce | nr, er + Ce > 32)
          throw new Error(`convertRadix2: carry overflow pos=${er} from=${Ce}`);
        for (er += Ce; er >= Se; er -= Se)
          sr.push((rr >> er - Se & ir) >>> 0);
        rr &= 2 ** er - 1;
      }
      if (rr = rr << Se - er & ir, !Ne && er >= Ce)
        throw new Error("Excess padding");
      if (!Ne && rr)
        throw new Error(`Non-zero padding: ${rr}`);
      return Ne && er > 0 && sr.push(rr >>> 0), sr;
    }
    // @__NO_SIDE_EFFECTS__
    function P(we) {
      return {
        encode: (Ce) => {
          if (!u(Ce))
            throw new Error("radix.encode input should be Uint8Array");
          return /* @__PURE__ */ k(Array.from(Ce), 2 ** 8, we);
        },
        decode: (Ce) => {
          if (!Array.isArray(Ce) || Ce.length && typeof Ce[0] != "number")
            throw new Error("radix.decode input should be array of numbers");
          return Uint8Array.from(/* @__PURE__ */ k(Ce, we, 2 ** 8));
        }
      };
    }
    // @__NO_SIDE_EFFECTS__
    function x(we, Ce = !1) {
      if (we <= 0 || we > 32)
        throw new Error("radix2: bits should be in (0..32]");
      if (/* @__PURE__ */ B(8, we) > 32 || /* @__PURE__ */ B(we, 8) > 32)
        throw new Error("radix2: carry overflow");
      return {
        encode: (Se) => {
          if (!u(Se))
            throw new Error("radix2.encode input should be Uint8Array");
          return /* @__PURE__ */ Q(Array.from(Se), 8, we, !Ce);
        },
        decode: (Se) => {
          if (!Array.isArray(Se) || Se.length && typeof Se[0] != "number")
            throw new Error("radix2.decode input should be array of numbers");
          return Uint8Array.from(/* @__PURE__ */ Q(Se, we, 8, Ce));
        }
      };
    }
    // @__NO_SIDE_EFFECTS__
    function M(we) {
      if (typeof we != "function")
        throw new Error("unsafeWrapper fn should be function");
      return function(...Ce) {
        try {
          return we.apply(null, Ce);
        } catch {
        }
      };
    }
    // @__NO_SIDE_EFFECTS__
    function F(we, Ce) {
      if (typeof Ce != "function")
        throw new Error("checksum fn should be function");
      return {
        encode(Se) {
          if (!u(Se))
            throw new Error("checksum.encode: input should be Uint8Array");
          const Ne = Ce(Se).slice(0, we), rr = new Uint8Array(Se.length + we);
          return rr.set(Se), rr.set(Ne, Se.length), rr;
        },
        decode(Se) {
          if (!u(Se))
            throw new Error("checksum.decode: input should be Uint8Array");
          const Ne = Se.slice(0, -we), rr = Ce(Ne).slice(0, we), er = Se.slice(-we);
          for (let ir = 0; ir < we; ir++)
            if (rr[ir] !== er[ir])
              throw new Error("Invalid checksum");
          return Ne;
        }
      };
    }
    s.utils = {
      alphabet: t,
      chain: p,
      checksum: F,
      convertRadix: k,
      convertRadix2: Q,
      radix: P,
      radix2: x,
      join: l,
      padding: m
    }, s.base16 = /* @__PURE__ */ p(/* @__PURE__ */ x(4), /* @__PURE__ */ t("0123456789ABCDEF"), /* @__PURE__ */ l("")), s.base32 = /* @__PURE__ */ p(/* @__PURE__ */ x(5), /* @__PURE__ */ t("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), /* @__PURE__ */ m(5), /* @__PURE__ */ l("")), s.base32nopad = /* @__PURE__ */ p(/* @__PURE__ */ x(5), /* @__PURE__ */ t("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), /* @__PURE__ */ l("")), s.base32hex = /* @__PURE__ */ p(/* @__PURE__ */ x(5), /* @__PURE__ */ t("0123456789ABCDEFGHIJKLMNOPQRSTUV"), /* @__PURE__ */ m(5), /* @__PURE__ */ l("")), s.base32hexnopad = /* @__PURE__ */ p(/* @__PURE__ */ x(5), /* @__PURE__ */ t("0123456789ABCDEFGHIJKLMNOPQRSTUV"), /* @__PURE__ */ l("")), s.base32crockford = /* @__PURE__ */ p(/* @__PURE__ */ x(5), /* @__PURE__ */ t("0123456789ABCDEFGHJKMNPQRSTVWXYZ"), /* @__PURE__ */ l(""), /* @__PURE__ */ b((we) => we.toUpperCase().replace(/O/g, "0").replace(/[IL]/g, "1"))), s.base64 = /* @__PURE__ */ p(/* @__PURE__ */ x(6), /* @__PURE__ */ t("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), /* @__PURE__ */ m(6), /* @__PURE__ */ l("")), s.base64nopad = /* @__PURE__ */ p(/* @__PURE__ */ x(6), /* @__PURE__ */ t("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), /* @__PURE__ */ l("")), s.base64url = /* @__PURE__ */ p(/* @__PURE__ */ x(6), /* @__PURE__ */ t("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), /* @__PURE__ */ m(6), /* @__PURE__ */ l("")), s.base64urlnopad = /* @__PURE__ */ p(/* @__PURE__ */ x(6), /* @__PURE__ */ t("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), /* @__PURE__ */ l(""));
    const le = (we) => /* @__PURE__ */ p(/* @__PURE__ */ P(58), /* @__PURE__ */ t(we), /* @__PURE__ */ l(""));
    s.base58 = le("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"), s.base58flickr = le("123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"), s.base58xrp = le("rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz");
    const ge = [0, 2, 3, 5, 6, 7, 9, 10, 11];
    s.base58xmr = {
      encode(we) {
        let Ce = "";
        for (let Se = 0; Se < we.length; Se += 8) {
          const Ne = we.subarray(Se, Se + 8);
          Ce += s.base58.encode(Ne).padStart(ge[Ne.length], "1");
        }
        return Ce;
      },
      decode(we) {
        let Ce = [];
        for (let Se = 0; Se < we.length; Se += 11) {
          const Ne = we.slice(Se, Se + 11), rr = ge.indexOf(Ne.length), er = s.base58.decode(Ne);
          for (let ir = 0; ir < er.length - rr; ir++)
            if (er[ir] !== 0)
              throw new Error("base58xmr: wrong padding");
          Ce = Ce.concat(Array.from(er.slice(er.length - rr)));
        }
        return Uint8Array.from(Ce);
      }
    };
    const pe = (we) => /* @__PURE__ */ p(/* @__PURE__ */ F(4, (Ce) => we(we(Ce))), s.base58);
    s.createBase58check = pe, s.base58check = s.createBase58check;
    const Ie = /* @__PURE__ */ p(/* @__PURE__ */ t("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), /* @__PURE__ */ l("")), be = [996825010, 642813549, 513874426, 1027748829, 705979059];
    // @__NO_SIDE_EFFECTS__
    function Pe(we) {
      const Ce = we >> 25;
      let Se = (we & 33554431) << 5;
      for (let Ne = 0; Ne < be.length; Ne++)
        (Ce >> Ne & 1) === 1 && (Se ^= be[Ne]);
      return Se;
    }
    // @__NO_SIDE_EFFECTS__
    function Te(we, Ce, Se = 1) {
      const Ne = we.length;
      let rr = 1;
      for (let er = 0; er < Ne; er++) {
        const ir = we.charCodeAt(er);
        if (ir < 33 || ir > 126)
          throw new Error(`Invalid prefix (${we})`);
        rr = /* @__PURE__ */ Pe(rr) ^ ir >> 5;
      }
      rr = /* @__PURE__ */ Pe(rr);
      for (let er = 0; er < Ne; er++)
        rr = /* @__PURE__ */ Pe(rr) ^ we.charCodeAt(er) & 31;
      for (let er of Ce)
        rr = /* @__PURE__ */ Pe(rr) ^ er;
      for (let er = 0; er < 6; er++)
        rr = /* @__PURE__ */ Pe(rr);
      return rr ^= Se, Ie.encode(/* @__PURE__ */ Q([rr % 2 ** 30], 30, 5, !1));
    }
    // @__NO_SIDE_EFFECTS__
    function Qe(we) {
      const Ce = we === "bech32" ? 1 : 734539939, Se = /* @__PURE__ */ x(5), Ne = Se.decode, rr = Se.encode, er = /* @__PURE__ */ M(Ne);
      function ir(br, Br, Fr = 90) {
        if (typeof br != "string")
          throw new Error(`bech32.encode prefix should be string, not ${typeof br}`);
        if (Br instanceof Uint8Array && (Br = Array.from(Br)), !Array.isArray(Br) || Br.length && typeof Br[0] != "number")
          throw new Error(`bech32.encode words should be array of numbers, not ${typeof Br}`);
        if (br.length === 0)
          throw new TypeError(`Invalid prefix length ${br.length}`);
        const Gr = br.length + 7 + Br.length;
        if (Fr !== !1 && Gr > Fr)
          throw new TypeError(`Length ${Gr} exceeds limit ${Fr}`);
        const qr = br.toLowerCase(), Hr = /* @__PURE__ */ Te(qr, Br, Ce);
        return `${qr}1${Ie.encode(Br)}${Hr}`;
      }
      function sr(br, Br = 90) {
        if (typeof br != "string")
          throw new Error(`bech32.decode input should be string, not ${typeof br}`);
        if (br.length < 8 || Br !== !1 && br.length > Br)
          throw new TypeError(`Wrong string length: ${br.length} (${br}). Expected (8..${Br})`);
        const Fr = br.toLowerCase();
        if (br !== Fr && br !== br.toUpperCase())
          throw new Error("String must be lowercase or uppercase");
        const Gr = Fr.lastIndexOf("1");
        if (Gr === 0 || Gr === -1)
          throw new Error('Letter "1" must be present between prefix and data only');
        const qr = Fr.slice(0, Gr), Hr = Fr.slice(Gr + 1);
        if (Hr.length < 6)
          throw new Error("Data must be at least 6 characters long");
        const un = Ie.decode(Hr).slice(0, -6), Dr = /* @__PURE__ */ Te(qr, un, Ce);
        if (!Hr.endsWith(Dr))
          throw new Error(`Invalid checksum in ${br}: expected "${Dr}"`);
        return { prefix: qr, words: un };
      }
      const nr = /* @__PURE__ */ M(sr);
      function fr(br) {
        const { prefix: Br, words: Fr } = sr(br, !1);
        return { prefix: Br, words: Fr, bytes: Ne(Fr) };
      }
      function lr(br, Br) {
        return ir(br, rr(Br));
      }
      return {
        encode: ir,
        decode: sr,
        encodeFromBytes: lr,
        decodeToBytes: fr,
        decodeUnsafe: nr,
        fromWords: Ne,
        fromWordsUnsafe: er,
        toWords: rr
      };
    }
    s.bech32 = /* @__PURE__ */ Qe("bech32"), s.bech32m = /* @__PURE__ */ Qe("bech32m"), s.utf8 = {
      encode: (we) => new TextDecoder().decode(we),
      decode: (we) => new TextEncoder().encode(we)
    }, s.hex = /* @__PURE__ */ p(/* @__PURE__ */ x(4), /* @__PURE__ */ t("0123456789abcdef"), /* @__PURE__ */ l(""), /* @__PURE__ */ b((we) => {
      if (typeof we != "string" || we.length % 2)
        throw new TypeError(`hex.decode: expected string, got ${typeof we} with length ${we.length}`);
      return we.toLowerCase();
    }));
    const xe = {
      utf8: s.utf8,
      hex: s.hex,
      base16: s.base16,
      base32: s.base32,
      base64: s.base64,
      base64url: s.base64url,
      base58: s.base58,
      base58xmr: s.base58xmr
    }, Ee = "Invalid encoding type. Available types: utf8, hex, base16, base32, base64, base64url, base58, base58xmr", He = (we, Ce) => {
      if (typeof we != "string" || !xe.hasOwnProperty(we))
        throw new TypeError(Ee);
      if (!u(Ce))
        throw new TypeError("bytesToString() expects Uint8Array");
      return xe[we].encode(Ce);
    };
    s.bytesToString = He, s.str = s.bytesToString;
    const ve = (we, Ce) => {
      if (!xe.hasOwnProperty(we))
        throw new TypeError(Ee);
      if (typeof Ce != "string")
        throw new TypeError("stringToBytes() expects string");
      return xe[we].decode(Ce);
    };
    s.stringToBytes = ve, s.bytes = s.stringToBytes;
  }(lib$1)), lib$1;
}
var btcSigner = {}, utils$1 = {}, lib = {}, hasRequiredLib;
function requireLib() {
  return hasRequiredLib || (hasRequiredLib = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s._TEST = s.ZeroPad = s.magicBytes = s.flag = s.cstring = s.string = s.hex = s.bytes = s.bool = s.F64LE = s.F64BE = s.F32LE = s.F32BE = s.I8 = s.U8 = s.I16BE = s.I16LE = s.U16BE = s.U16LE = s.I32BE = s.I32LE = s.U32BE = s.U32LE = s.int = s.I64BE = s.I64LE = s.U64BE = s.U64LE = s.I128BE = s.I128LE = s.U128BE = s.U128LE = s.I256BE = s.I256LE = s.U256BE = s.U256LE = s.bigint = s.bits = s.coders = s.wrap = s.utils = s.NULL = s.EMPTY = void 0, s.validate = le, s.isCoder = Ie, s.prefix = ir, s.apply = fr, s.lazy = lr, s.flagged = Br, s.optional = Fr, s.magic = Gr, s.constant = Hr, s.struct = Dr, s.tuple = wr, s.array = yr, s.map = Qr, s.tag = _r, s.mappedTag = Jr, s.bitset = fn, s.padLeft = Tn, s.padRight = Yn, s.pointer = si;
    const A = /* @__PURE__ */ requireLib$2();
    s.EMPTY = new Uint8Array(), s.NULL = new Uint8Array([0]);
    function u(vn, Cn) {
      if (vn.length !== Cn.length)
        return !1;
      for (let Xr = 0; Xr < vn.length; Xr++)
        if (vn[Xr] !== Cn[Xr])
          return !1;
      return !0;
    }
    function p(vn) {
      return vn instanceof Uint8Array || ArrayBuffer.isView(vn) && vn.constructor.name === "Uint8Array";
    }
    function t(...vn) {
      let Cn = 0;
      for (let In = 0; In < vn.length; In++) {
        const zr = vn[In];
        if (!p(zr))
          throw new Error("Uint8Array expected");
        Cn += zr.length;
      }
      const Xr = new Uint8Array(Cn);
      for (let In = 0, zr = 0; In < vn.length; In++) {
        const En = vn[In];
        Xr.set(En, zr), zr += En.length;
      }
      return Xr;
    }
    const l = (vn) => new DataView(vn.buffer, vn.byteOffset, vn.byteLength);
    function m(vn) {
      return Object.prototype.toString.call(vn) === "[object Object]";
    }
    function b(vn) {
      return Number.isSafeInteger(vn);
    }
    s.utils = {
      equalBytes: u,
      isBytes: p,
      isCoder: Ie,
      checkBounds: M,
      concatBytes: t,
      createView: l,
      isPlainObject: m
    };
    const k = (vn) => {
      if (vn !== null && typeof vn != "string" && !Ie(vn) && !p(vn) && !b(vn))
        throw new Error(`lengthCoder: expected null | number | Uint8Array | CoderType, got ${vn} (${typeof vn})`);
      return {
        encodeStream(Cn, Xr) {
          if (vn === null)
            return;
          if (Ie(vn))
            return vn.encodeStream(Cn, Xr);
          let In;
          if (typeof vn == "number" ? In = vn : typeof vn == "string" && (In = B.resolve(Cn.stack, vn)), typeof In == "bigint" && (In = Number(In)), In === void 0 || In !== Xr)
            throw Cn.err(`Wrong length: ${In} len=${vn} exp=${Xr} (${typeof Xr})`);
        },
        decodeStream(Cn) {
          let Xr;
          if (Ie(vn) ? Xr = Number(vn.decodeStream(Cn)) : typeof vn == "number" ? Xr = vn : typeof vn == "string" && (Xr = B.resolve(Cn.stack, vn)), typeof Xr == "bigint" && (Xr = Number(Xr)), typeof Xr != "number")
            throw Cn.err(`Wrong length: ${Xr}`);
          return Xr;
        }
      };
    }, C = {
      BITS: 32,
      FULL_MASK: -1 >>> 0,
      // 1<<32 will overflow
      len: (vn) => Math.ceil(vn / 32),
      create: (vn) => new Uint32Array(C.len(vn)),
      clean: (vn) => vn.fill(0),
      debug: (vn) => Array.from(vn).map((Cn) => (Cn >>> 0).toString(2).padStart(32, "0")),
      checkLen: (vn, Cn) => {
        if (C.len(Cn) !== vn.length)
          throw new Error(`wrong length=${vn.length}. Expected: ${C.len(Cn)}`);
      },
      chunkLen: (vn, Cn, Xr) => {
        if (Cn < 0)
          throw new Error(`wrong pos=${Cn}`);
        if (Cn + Xr > vn)
          throw new Error(`wrong range=${Cn}/${Xr} of ${vn}`);
      },
      set: (vn, Cn, Xr, In = !0) => !In && (vn[Cn] & Xr) !== 0 ? !1 : (vn[Cn] |= Xr, !0),
      pos: (vn, Cn) => ({
        chunk: Math.floor((vn + Cn) / 32),
        mask: 1 << 32 - (vn + Cn) % 32 - 1
      }),
      indices: (vn, Cn, Xr = !1) => {
        C.checkLen(vn, Cn);
        const { FULL_MASK: In, BITS: zr } = C, En = zr - Cn % zr, Zr = En ? In >>> En << En : In, kr = [];
        for (let Rr = 0; Rr < vn.length; Rr++) {
          let Er = vn[Rr];
          if (Xr && (Er = ~Er), Rr === vn.length - 1 && (Er &= Zr), Er !== 0)
            for (let Or = 0; Or < zr; Or++) {
              const wn = 1 << zr - Or - 1;
              Er & wn && kr.push(Rr * zr + Or);
            }
        }
        return kr;
      },
      range: (vn) => {
        const Cn = [];
        let Xr;
        for (const In of vn)
          Xr === void 0 || In !== Xr.pos + Xr.length ? Cn.push(Xr = { pos: In, length: 1 }) : Xr.length += 1;
        return Cn;
      },
      rangeDebug: (vn, Cn, Xr = !1) => `[${C.range(C.indices(vn, Cn, Xr)).map((In) => `(${In.pos}/${In.length})`).join(", ")}]`,
      setRange: (vn, Cn, Xr, In, zr = !0) => {
        C.chunkLen(Cn, Xr, In);
        const { FULL_MASK: En, BITS: Zr } = C, kr = Xr % Zr ? Math.floor(Xr / Zr) : void 0, Rr = Xr + In, Er = Rr % Zr ? Math.floor(Rr / Zr) : void 0;
        if (kr !== void 0 && kr === Er)
          return C.set(vn, kr, En >>> Zr - In << Zr - In - Xr, zr);
        if (kr !== void 0 && !C.set(vn, kr, En >>> Xr % Zr, zr))
          return !1;
        const Or = kr !== void 0 ? kr + 1 : Xr / Zr, wn = Er !== void 0 ? Er : Rr / Zr;
        for (let Kn = Or; Kn < wn; Kn++)
          if (!C.set(vn, Kn, En, zr))
            return !1;
        return !(Er !== void 0 && kr !== Er && !C.set(vn, Er, En << Zr - Rr % Zr, zr));
      }
    }, B = {
      /**
       * Internal method for handling stack of paths (debug, errors, dynamic fields via path)
       * This is looks ugly (callback), but allows us to force stack cleaning by construction (.pop always after function).
       * Also, this makes impossible:
       * - pushing field when stack is empty
       * - pushing field inside of field (real bug)
       * NOTE: we don't want to do '.pop' on error!
       */
      pushObj: (vn, Cn, Xr) => {
        const In = { obj: Cn };
        vn.push(In), Xr((zr, En) => {
          In.field = zr, En(), In.field = void 0;
        }), vn.pop();
      },
      path: (vn) => {
        const Cn = [];
        for (const Xr of vn)
          Xr.field !== void 0 && Cn.push(Xr.field);
        return Cn.join("/");
      },
      err: (vn, Cn, Xr) => {
        const In = new Error(`${vn}(${B.path(Cn)}): ${typeof Xr == "string" ? Xr : Xr.message}`);
        return Xr instanceof Error && Xr.stack && (In.stack = Xr.stack), In;
      },
      resolve: (vn, Cn) => {
        const Xr = Cn.split("/"), In = vn.map((Zr) => Zr.obj);
        let zr = 0;
        for (; zr < Xr.length && Xr[zr] === ".."; zr++)
          In.pop();
        let En = In.pop();
        for (; zr < Xr.length; zr++) {
          if (!En || En[Xr[zr]] === void 0)
            return;
          En = En[Xr[zr]];
        }
        return En;
      }
    };
    class Q {
      constructor(Cn, Xr = {}, In = [], zr = void 0, En = 0) {
        this.pos = 0, this.bitBuf = 0, this.bitPos = 0, this.data = Cn, this.opts = Xr, this.stack = In, this.parent = zr, this.parentOffset = En, this.view = l(Cn);
      }
      /** Internal method for pointers. */
      _enablePointers() {
        if (this.parent)
          return this.parent._enablePointers();
        this.bs || (this.bs = C.create(this.data.length), C.setRange(this.bs, this.data.length, 0, this.pos, this.opts.allowMultipleReads));
      }
      markBytesBS(Cn, Xr) {
        return this.parent ? this.parent.markBytesBS(this.parentOffset + Cn, Xr) : !Xr || !this.bs ? !0 : C.setRange(this.bs, this.data.length, Cn, Xr, !1);
      }
      markBytes(Cn) {
        const Xr = this.pos;
        this.pos += Cn;
        const In = this.markBytesBS(Xr, Cn);
        if (!this.opts.allowMultipleReads && !In)
          throw this.err(`multiple read pos=${this.pos} len=${Cn}`);
        return In;
      }
      pushObj(Cn, Xr) {
        return B.pushObj(this.stack, Cn, Xr);
      }
      readView(Cn, Xr) {
        if (!Number.isFinite(Cn))
          throw this.err(`readView: wrong length=${Cn}`);
        if (this.pos + Cn > this.data.length)
          throw this.err("readView: Unexpected end of buffer");
        const In = Xr(this.view, this.pos);
        return this.markBytes(Cn), In;
      }
      // read bytes by absolute offset
      absBytes(Cn) {
        if (Cn > this.data.length)
          throw new Error("Unexpected end of buffer");
        return this.data.subarray(Cn);
      }
      finish() {
        if (!this.opts.allowUnreadBytes) {
          if (this.bitPos)
            throw this.err(`${this.bitPos} bits left after unpack: ${A.hex.encode(this.data.slice(this.pos))}`);
          if (this.bs && !this.parent) {
            const Cn = C.indices(this.bs, this.data.length, !0);
            if (Cn.length) {
              const Xr = C.range(Cn).map(({ pos: In, length: zr }) => `(${In}/${zr})[${A.hex.encode(this.data.subarray(In, In + zr))}]`).join(", ");
              throw this.err(`unread byte ranges: ${Xr} (total=${this.data.length})`);
            } else
              return;
          }
          if (!this.isEnd())
            throw this.err(`${this.leftBytes} bytes ${this.bitPos} bits left after unpack: ${A.hex.encode(this.data.slice(this.pos))}`);
        }
      }
      // User methods
      err(Cn) {
        return B.err("Reader", this.stack, Cn);
      }
      offsetReader(Cn) {
        if (Cn > this.data.length)
          throw this.err("offsetReader: Unexpected end of buffer");
        return new Q(this.absBytes(Cn), this.opts, this.stack, this, Cn);
      }
      bytes(Cn, Xr = !1) {
        if (this.bitPos)
          throw this.err("readBytes: bitPos not empty");
        if (!Number.isFinite(Cn))
          throw this.err(`readBytes: wrong length=${Cn}`);
        if (this.pos + Cn > this.data.length)
          throw this.err("readBytes: Unexpected end of buffer");
        const In = this.data.subarray(this.pos, this.pos + Cn);
        return Xr || this.markBytes(Cn), In;
      }
      byte(Cn = !1) {
        if (this.bitPos)
          throw this.err("readByte: bitPos not empty");
        if (this.pos + 1 > this.data.length)
          throw this.err("readBytes: Unexpected end of buffer");
        const Xr = this.data[this.pos];
        return Cn || this.markBytes(1), Xr;
      }
      get leftBytes() {
        return this.data.length - this.pos;
      }
      get totalBytes() {
        return this.data.length;
      }
      isEnd() {
        return this.pos >= this.data.length && !this.bitPos;
      }
      // bits are read in BE mode (left to right): (0b1000_0000).readBits(1) == 1
      bits(Cn) {
        if (Cn > 32)
          throw this.err("BitReader: cannot read more than 32 bits in single call");
        let Xr = 0;
        for (; Cn; ) {
          this.bitPos || (this.bitBuf = this.byte(), this.bitPos = 8);
          const In = Math.min(Cn, this.bitPos);
          this.bitPos -= In, Xr = Xr << In | this.bitBuf >> this.bitPos & 2 ** In - 1, this.bitBuf &= 2 ** this.bitPos - 1, Cn -= In;
        }
        return Xr >>> 0;
      }
      find(Cn, Xr = this.pos) {
        if (!p(Cn))
          throw this.err(`find: needle is not bytes! ${Cn}`);
        if (this.bitPos)
          throw this.err("findByte: bitPos not empty");
        if (!Cn.length)
          throw this.err("find: needle is empty");
        for (let In = Xr; (In = this.data.indexOf(Cn[0], In)) !== -1; In++) {
          if (In === -1 || this.data.length - In < Cn.length)
            return;
          if (u(Cn, this.data.subarray(In, In + Cn.length)))
            return In;
        }
      }
    }
    class P {
      constructor(Cn = []) {
        this.pos = 0, this.buffers = [], this.ptrs = [], this.bitBuf = 0, this.bitPos = 0, this.viewBuf = new Uint8Array(8), this.finished = !1, this.stack = Cn, this.view = l(this.viewBuf);
      }
      pushObj(Cn, Xr) {
        return B.pushObj(this.stack, Cn, Xr);
      }
      writeView(Cn, Xr) {
        if (this.finished)
          throw this.err("buffer: finished");
        if (!b(Cn) || Cn > 8)
          throw new Error(`wrong writeView length=${Cn}`);
        Xr(this.view), this.bytes(this.viewBuf.slice(0, Cn)), this.viewBuf.fill(0);
      }
      // User methods
      err(Cn) {
        if (this.finished)
          throw this.err("buffer: finished");
        return B.err("Reader", this.stack, Cn);
      }
      bytes(Cn) {
        if (this.finished)
          throw this.err("buffer: finished");
        if (this.bitPos)
          throw this.err("writeBytes: ends with non-empty bit buffer");
        this.buffers.push(Cn), this.pos += Cn.length;
      }
      byte(Cn) {
        if (this.finished)
          throw this.err("buffer: finished");
        if (this.bitPos)
          throw this.err("writeByte: ends with non-empty bit buffer");
        this.buffers.push(new Uint8Array([Cn])), this.pos++;
      }
      finish(Cn = !0) {
        if (this.finished)
          throw this.err("buffer: finished");
        if (this.bitPos)
          throw this.err("buffer: ends with non-empty bit buffer");
        const Xr = this.buffers.concat(this.ptrs.map((En) => En.buffer)), In = Xr.map((En) => En.length).reduce((En, Zr) => En + Zr, 0), zr = new Uint8Array(In);
        for (let En = 0, Zr = 0; En < Xr.length; En++) {
          const kr = Xr[En];
          zr.set(kr, Zr), Zr += kr.length;
        }
        for (let En = this.pos, Zr = 0; Zr < this.ptrs.length; Zr++) {
          const kr = this.ptrs[Zr];
          zr.set(kr.ptr.encode(En), kr.pos), En += kr.buffer.length;
        }
        if (Cn) {
          this.buffers = [];
          for (const En of this.ptrs)
            En.buffer.fill(0);
          this.ptrs = [], this.finished = !0, this.bitBuf = 0;
        }
        return zr;
      }
      bits(Cn, Xr) {
        if (Xr > 32)
          throw this.err("writeBits: cannot write more than 32 bits in single call");
        if (Cn >= 2 ** Xr)
          throw this.err(`writeBits: value (${Cn}) >= 2**bits (${Xr})`);
        for (; Xr; ) {
          const In = Math.min(Xr, 8 - this.bitPos);
          this.bitBuf = this.bitBuf << In | Cn >> Xr - In, this.bitPos += In, Xr -= In, Cn &= 2 ** Xr - 1, this.bitPos === 8 && (this.bitPos = 0, this.buffers.push(new Uint8Array([this.bitBuf])), this.pos++);
        }
      }
    }
    const x = (vn) => Uint8Array.from(vn).reverse();
    function M(vn, Cn, Xr) {
      if (Xr) {
        const In = 2n ** (Cn - 1n);
        if (vn < -In || vn >= In)
          throw new Error(`value out of signed bounds. Expected ${-In} <= ${vn} < ${In}`);
      } else if (0n > vn || vn >= 2n ** Cn)
        throw new Error(`value out of unsigned bounds. Expected 0 <= ${vn} < ${2n ** Cn}`);
    }
    function F(vn) {
      return {
        // NOTE: we cannot export validate here, since it is likely mistake.
        encodeStream: vn.encodeStream,
        decodeStream: vn.decodeStream,
        size: vn.size,
        encode: (Cn) => {
          const Xr = new P();
          return vn.encodeStream(Xr, Cn), Xr.finish();
        },
        decode: (Cn, Xr = {}) => {
          const In = new Q(Cn, Xr), zr = vn.decodeStream(In);
          return In.finish(), zr;
        }
      };
    }
    function le(vn, Cn) {
      if (!Ie(vn))
        throw new Error(`validate: invalid inner value ${vn}`);
      if (typeof Cn != "function")
        throw new Error("validate: fn should be function");
      return F({
        size: vn.size,
        encodeStream: (Xr, In) => {
          let zr;
          try {
            zr = Cn(In);
          } catch (En) {
            throw Xr.err(En);
          }
          vn.encodeStream(Xr, zr);
        },
        decodeStream: (Xr) => {
          const In = vn.decodeStream(Xr);
          try {
            return Cn(In);
          } catch (zr) {
            throw Xr.err(zr);
          }
        }
      });
    }
    const ge = (vn) => {
      const Cn = F(vn);
      return vn.validate ? le(Cn, vn.validate) : Cn;
    };
    s.wrap = ge;
    const pe = (vn) => m(vn) && typeof vn.decode == "function" && typeof vn.encode == "function";
    function Ie(vn) {
      return m(vn) && pe(vn) && typeof vn.encodeStream == "function" && typeof vn.decodeStream == "function" && (vn.size === void 0 || b(vn.size));
    }
    function be() {
      return {
        encode: (vn) => {
          if (!Array.isArray(vn))
            throw new Error("array expected");
          const Cn = {};
          for (const Xr of vn) {
            if (!Array.isArray(Xr) || Xr.length !== 2)
              throw new Error("array of two elements expected");
            const In = Xr[0], zr = Xr[1];
            if (Cn[In] !== void 0)
              throw new Error(`key(${In}) appears twice in struct`);
            Cn[In] = zr;
          }
          return Cn;
        },
        decode: (vn) => {
          if (!m(vn))
            throw new Error(`expected plain object, got ${vn}`);
          return Object.entries(vn);
        }
      };
    }
    const Pe = {
      encode: (vn) => {
        if (typeof vn != "bigint")
          throw new Error(`expected bigint, got ${typeof vn}`);
        if (vn > BigInt(Number.MAX_SAFE_INTEGER))
          throw new Error(`element bigger than MAX_SAFE_INTEGER=${vn}`);
        return Number(vn);
      },
      decode: (vn) => {
        if (!b(vn))
          throw new Error("element is not a safe integer");
        return BigInt(vn);
      }
    };
    function Te(vn) {
      if (!m(vn))
        throw new Error("plain object expected");
      return {
        encode: (Cn) => {
          if (!b(Cn) || !(Cn in vn))
            throw new Error(`wrong value ${Cn}`);
          return vn[Cn];
        },
        decode: (Cn) => {
          if (typeof Cn != "string")
            throw new Error(`wrong value ${typeof Cn}`);
          return vn[Cn];
        }
      };
    }
    function Qe(vn, Cn = !1) {
      if (!b(vn))
        throw new Error(`decimal/precision: wrong value ${vn}`);
      if (typeof Cn != "boolean")
        throw new Error(`decimal/round: expected boolean, got ${typeof Cn}`);
      const Xr = 10n ** BigInt(vn);
      return {
        encode: (In) => {
          if (typeof In != "bigint")
            throw new Error(`expected bigint, got ${typeof In}`);
          let zr = (In < 0n ? -In : In).toString(10), En = zr.length - vn;
          En < 0 && (zr = zr.padStart(zr.length - En, "0"), En = 0);
          let Zr = zr.length - 1;
          for (; Zr >= En && zr[Zr] === "0"; Zr--)
            ;
          let kr = zr.slice(0, En), Rr = zr.slice(En, Zr + 1);
          return kr || (kr = "0"), In < 0n && (kr = "-" + kr), Rr ? `${kr}.${Rr}` : kr;
        },
        decode: (In) => {
          if (typeof In != "string")
            throw new Error(`expected string, got ${typeof In}`);
          if (In === "-0")
            throw new Error("negative zero is not allowed");
          let zr = !1;
          if (In.startsWith("-") && (zr = !0, In = In.slice(1)), !/^(0|[1-9]\d*)(\.\d+)?$/.test(In))
            throw new Error(`wrong string value=${In}`);
          let En = In.indexOf(".");
          En = En === -1 ? In.length : En;
          const Zr = In.slice(0, En), kr = In.slice(En + 1).replace(/0+$/, ""), Rr = BigInt(Zr) * Xr;
          if (!Cn && kr.length > vn)
            throw new Error(`fractional part cannot be represented with this precision (num=${In}, prec=${vn})`);
          const Er = Math.min(kr.length, vn), Or = BigInt(kr.slice(0, Er)) * 10n ** BigInt(vn - Er), wn = Rr + Or;
          return zr ? -wn : wn;
        }
      };
    }
    function xe(vn) {
      if (!Array.isArray(vn))
        throw new Error(`expected array, got ${typeof vn}`);
      for (const Cn of vn)
        if (!pe(Cn))
          throw new Error(`wrong base coder ${Cn}`);
      return {
        encode: (Cn) => {
          for (const Xr of vn) {
            const In = Xr.encode(Cn);
            if (In !== void 0)
              return In;
          }
          throw new Error(`match/encode: cannot find match in ${Cn}`);
        },
        decode: (Cn) => {
          for (const Xr of vn) {
            const In = Xr.decode(Cn);
            if (In !== void 0)
              return In;
          }
          throw new Error(`match/decode: cannot find match in ${Cn}`);
        }
      };
    }
    const Ee = (vn) => {
      if (!pe(vn))
        throw new Error("BaseCoder expected");
      return { encode: vn.decode, decode: vn.encode };
    };
    s.coders = { dict: be, numberBigint: Pe, tsEnum: Te, decimal: Qe, match: xe, reverse: Ee };
    const He = (vn) => {
      if (!b(vn))
        throw new Error(`bits: wrong length ${vn} (${typeof vn})`);
      return (0, s.wrap)({
        encodeStream: (Cn, Xr) => Cn.bits(Xr, vn),
        decodeStream: (Cn) => Cn.bits(vn),
        validate: (Cn) => {
          if (!b(Cn))
            throw new Error(`bits: wrong value ${Cn}`);
          return Cn;
        }
      });
    };
    s.bits = He;
    const ve = (vn, Cn = !1, Xr = !1, In = !0) => {
      if (!b(vn))
        throw new Error(`bigint/size: wrong value ${vn}`);
      if (typeof Cn != "boolean")
        throw new Error(`bigint/le: expected boolean, got ${typeof Cn}`);
      if (typeof Xr != "boolean")
        throw new Error(`bigint/signed: expected boolean, got ${typeof Xr}`);
      if (typeof In != "boolean")
        throw new Error(`bigint/sized: expected boolean, got ${typeof In}`);
      const zr = BigInt(vn), En = 2n ** (8n * zr - 1n);
      return (0, s.wrap)({
        size: In ? vn : void 0,
        encodeStream: (Zr, kr) => {
          Xr && kr < 0 && (kr = kr | En);
          const Rr = [];
          for (let Or = 0; Or < vn; Or++)
            Rr.push(Number(kr & 255n)), kr >>= 8n;
          let Er = new Uint8Array(Rr).reverse();
          if (!In) {
            let Or = 0;
            for (Or = 0; Or < Er.length && Er[Or] === 0; Or++)
              ;
            Er = Er.subarray(Or);
          }
          Zr.bytes(Cn ? Er.reverse() : Er);
        },
        decodeStream: (Zr) => {
          const kr = Zr.bytes(In ? vn : Math.min(vn, Zr.leftBytes)), Rr = Cn ? kr : x(kr);
          let Er = 0n;
          for (let Or = 0; Or < Rr.length; Or++)
            Er |= BigInt(Rr[Or]) << 8n * BigInt(Or);
          return Xr && Er & En && (Er = (Er ^ En) - En), Er;
        },
        validate: (Zr) => {
          if (typeof Zr != "bigint")
            throw new Error(`bigint: invalid value: ${Zr}`);
          return M(Zr, 8n * zr, !!Xr), Zr;
        }
      });
    };
    s.bigint = ve, s.U256LE = (0, s.bigint)(32, !0), s.U256BE = (0, s.bigint)(32, !1), s.I256LE = (0, s.bigint)(32, !0, !0), s.I256BE = (0, s.bigint)(32, !1, !0), s.U128LE = (0, s.bigint)(16, !0), s.U128BE = (0, s.bigint)(16, !1), s.I128LE = (0, s.bigint)(16, !0, !0), s.I128BE = (0, s.bigint)(16, !1, !0), s.U64LE = (0, s.bigint)(8, !0), s.U64BE = (0, s.bigint)(8, !1), s.I64LE = (0, s.bigint)(8, !0, !0), s.I64BE = (0, s.bigint)(8, !1, !0);
    const we = (vn, Cn = !1, Xr = !1, In = !0) => {
      if (!b(vn))
        throw new Error(`int/size: wrong value ${vn}`);
      if (typeof Cn != "boolean")
        throw new Error(`int/le: expected boolean, got ${typeof Cn}`);
      if (typeof Xr != "boolean")
        throw new Error(`int/signed: expected boolean, got ${typeof Xr}`);
      if (typeof In != "boolean")
        throw new Error(`int/sized: expected boolean, got ${typeof In}`);
      if (vn > 6)
        throw new Error("int supports size up to 6 bytes (48 bits): use bigints instead");
      return fr((0, s.bigint)(vn, Cn, Xr, In), s.coders.numberBigint);
    };
    s.int = we;
    const Ce = (vn, Cn) => (0, s.wrap)({
      size: vn,
      encodeStream: (Xr, In) => Xr.writeView(vn, (zr) => Cn.write(zr, In)),
      decodeStream: (Xr) => Xr.readView(vn, Cn.read),
      validate: (Xr) => {
        if (typeof Xr != "number")
          throw new Error(`viewCoder: expected number, got ${typeof Xr}`);
        return Cn.validate && Cn.validate(Xr), Xr;
      }
    }), Se = (vn, Cn, Xr) => {
      const In = vn * 8, zr = 2 ** (In - 1), En = (Rr) => {
        if (!b(Rr))
          throw new Error(`sintView: value is not safe integer: ${Rr}`);
        if (Rr < -zr || Rr >= zr)
          throw new Error(`sintView: value out of bounds. Expected ${-zr} <= ${Rr} < ${zr}`);
      }, Zr = 2 ** In, kr = (Rr) => {
        if (!b(Rr))
          throw new Error(`uintView: value is not safe integer: ${Rr}`);
        if (0 > Rr || Rr >= Zr)
          throw new Error(`uintView: value out of bounds. Expected 0 <= ${Rr} < ${Zr}`);
      };
      return Ce(vn, {
        write: Xr.write,
        read: Xr.read,
        validate: Cn ? En : kr
      });
    };
    s.U32LE = Se(4, !1, {
      read: (vn, Cn) => vn.getUint32(Cn, !0),
      write: (vn, Cn) => vn.setUint32(0, Cn, !0)
    }), s.U32BE = Se(4, !1, {
      read: (vn, Cn) => vn.getUint32(Cn, !1),
      write: (vn, Cn) => vn.setUint32(0, Cn, !1)
    }), s.I32LE = Se(4, !0, {
      read: (vn, Cn) => vn.getInt32(Cn, !0),
      write: (vn, Cn) => vn.setInt32(0, Cn, !0)
    }), s.I32BE = Se(4, !0, {
      read: (vn, Cn) => vn.getInt32(Cn, !1),
      write: (vn, Cn) => vn.setInt32(0, Cn, !1)
    }), s.U16LE = Se(2, !1, {
      read: (vn, Cn) => vn.getUint16(Cn, !0),
      write: (vn, Cn) => vn.setUint16(0, Cn, !0)
    }), s.U16BE = Se(2, !1, {
      read: (vn, Cn) => vn.getUint16(Cn, !1),
      write: (vn, Cn) => vn.setUint16(0, Cn, !1)
    }), s.I16LE = Se(2, !0, {
      read: (vn, Cn) => vn.getInt16(Cn, !0),
      write: (vn, Cn) => vn.setInt16(0, Cn, !0)
    }), s.I16BE = Se(2, !0, {
      read: (vn, Cn) => vn.getInt16(Cn, !1),
      write: (vn, Cn) => vn.setInt16(0, Cn, !1)
    }), s.U8 = Se(1, !1, {
      read: (vn, Cn) => vn.getUint8(Cn),
      write: (vn, Cn) => vn.setUint8(0, Cn)
    }), s.I8 = Se(1, !0, {
      read: (vn, Cn) => vn.getInt8(Cn),
      write: (vn, Cn) => vn.setInt8(0, Cn)
    });
    const Ne = (vn) => Ce(4, {
      read: (Cn, Xr) => Cn.getFloat32(Xr, vn),
      write: (Cn, Xr) => Cn.setFloat32(0, Xr, vn),
      validate: (Cn) => {
        if (Math.fround(Cn) !== Cn && !Number.isNaN(Cn))
          throw new Error(`f32: wrong value=${Cn}`);
      }
    }), rr = (vn) => Ce(8, {
      read: (Cn, Xr) => Cn.getFloat64(Xr, vn),
      write: (Cn, Xr) => Cn.setFloat64(0, Xr, vn)
    });
    s.F32BE = Ne(!1), s.F32LE = Ne(!0), s.F64BE = rr(!1), s.F64LE = rr(!0), s.bool = (0, s.wrap)({
      size: 1,
      encodeStream: (vn, Cn) => vn.byte(Cn ? 1 : 0),
      decodeStream: (vn) => {
        const Cn = vn.byte();
        if (Cn !== 0 && Cn !== 1)
          throw vn.err(`bool: invalid value ${Cn}`);
        return Cn === 1;
      },
      validate: (vn) => {
        if (typeof vn != "boolean")
          throw new Error(`bool: invalid value ${vn}`);
        return vn;
      }
    });
    const er = (vn, Cn = !1) => {
      if (typeof Cn != "boolean")
        throw new Error(`bytes/le: expected boolean, got ${typeof Cn}`);
      const Xr = k(vn), In = p(vn);
      return (0, s.wrap)({
        size: typeof vn == "number" ? vn : void 0,
        encodeStream: (zr, En) => {
          In || Xr.encodeStream(zr, En.length), zr.bytes(Cn ? x(En) : En), In && zr.bytes(vn);
        },
        decodeStream: (zr) => {
          let En;
          if (In) {
            const Zr = zr.find(vn);
            if (!Zr)
              throw zr.err("bytes: cannot find terminator");
            En = zr.bytes(Zr - zr.pos), zr.bytes(vn.length);
          } else
            En = zr.bytes(vn === null ? zr.leftBytes : Xr.decodeStream(zr));
          return Cn ? x(En) : En;
        },
        validate: (zr) => {
          if (!p(zr))
            throw new Error(`bytes: invalid value ${zr}`);
          return zr;
        }
      });
    };
    s.bytes = er;
    function ir(vn, Cn) {
      if (!Ie(Cn))
        throw new Error(`prefix: invalid inner value ${Cn}`);
      return fr(er(vn), Ee(Cn));
    }
    const sr = (vn, Cn = !1) => le(fr(er(vn, Cn), A.utf8), (Xr) => {
      if (typeof Xr != "string")
        throw new Error(`expected string, got ${typeof Xr}`);
      return Xr;
    });
    s.string = sr, s.cstring = (0, s.string)(s.NULL);
    const nr = (vn, Cn = { isLE: !1, with0x: !1 }) => {
      let Xr = fr(er(vn, Cn.isLE), A.hex);
      const In = Cn.with0x;
      if (typeof In != "boolean")
        throw new Error(`hex/with0x: expected boolean, got ${typeof In}`);
      return In && (Xr = fr(Xr, {
        encode: (zr) => `0x${zr}`,
        decode: (zr) => {
          if (!zr.startsWith("0x"))
            throw new Error("hex(with0x=true).encode input should start with 0x");
          return zr.slice(2);
        }
      })), Xr;
    };
    s.hex = nr;
    function fr(vn, Cn) {
      if (!Ie(vn))
        throw new Error(`apply: invalid inner value ${vn}`);
      if (!pe(Cn))
        throw new Error(`apply: invalid base value ${vn}`);
      return (0, s.wrap)({
        size: vn.size,
        encodeStream: (Xr, In) => {
          let zr;
          try {
            zr = Cn.decode(In);
          } catch (En) {
            throw Xr.err("" + En);
          }
          return vn.encodeStream(Xr, zr);
        },
        decodeStream: (Xr) => {
          const In = vn.decodeStream(Xr);
          try {
            return Cn.encode(In);
          } catch (zr) {
            throw Xr.err("" + zr);
          }
        }
      });
    }
    function lr(vn) {
      if (typeof vn != "function")
        throw new Error(`lazy: expected function, got ${typeof vn}`);
      return (0, s.wrap)({
        encodeStream: (Cn, Xr) => vn().encodeStream(Cn, Xr),
        decodeStream: (Cn) => vn().decodeStream(Cn)
      });
    }
    const br = (vn, Cn = !1) => {
      if (!p(vn))
        throw new Error(`flag/flagValue: expected Uint8Array, got ${typeof vn}`);
      if (typeof Cn != "boolean")
        throw new Error(`flag/xor: expected boolean, got ${typeof Cn}`);
      return (0, s.wrap)({
        size: vn.length,
        encodeStream: (Xr, In) => {
          !!In !== Cn && Xr.bytes(vn);
        },
        decodeStream: (Xr) => {
          let In = Xr.leftBytes >= vn.length;
          return In && (In = u(Xr.bytes(vn.length, !0), vn), In && Xr.bytes(vn.length)), In !== Cn;
        },
        validate: (Xr) => {
          if (Xr !== void 0 && typeof Xr != "boolean")
            throw new Error(`flag: expected boolean value or undefined, got ${typeof Xr}`);
          return Xr;
        }
      });
    };
    s.flag = br;
    function Br(vn, Cn, Xr) {
      if (!Ie(Cn))
        throw new Error(`flagged: invalid inner value ${Cn}`);
      if (typeof vn != "string" && !Ie(Cn))
        throw new Error(`flagged: wrong path=${vn}`);
      return (0, s.wrap)({
        encodeStream: (In, zr) => {
          typeof vn == "string" ? B.resolve(In.stack, vn) ? Cn.encodeStream(In, zr) : Xr && Cn.encodeStream(In, Xr) : (vn.encodeStream(In, !!zr), zr ? Cn.encodeStream(In, zr) : Xr && Cn.encodeStream(In, Xr));
        },
        decodeStream: (In) => {
          let zr = !1;
          if (typeof vn == "string" ? zr = !!B.resolve(In.stack, vn) : zr = vn.decodeStream(In), zr)
            return Cn.decodeStream(In);
          Xr && Cn.decodeStream(In);
        }
      });
    }
    function Fr(vn, Cn, Xr) {
      if (!Ie(vn) || !Ie(Cn))
        throw new Error(`optional: invalid flag or inner value flag=${vn} inner=${Cn}`);
      return (0, s.wrap)({
        size: Xr !== void 0 && vn.size && Cn.size ? vn.size + Cn.size : void 0,
        encodeStream: (In, zr) => {
          vn.encodeStream(In, !!zr), zr ? Cn.encodeStream(In, zr) : Xr !== void 0 && Cn.encodeStream(In, Xr);
        },
        decodeStream: (In) => {
          if (vn.decodeStream(In))
            return Cn.decodeStream(In);
          Xr !== void 0 && Cn.decodeStream(In);
        }
      });
    }
    function Gr(vn, Cn, Xr = !0) {
      if (!Ie(vn))
        throw new Error(`magic: invalid inner value ${vn}`);
      if (typeof Xr != "boolean")
        throw new Error(`magic: expected boolean, got ${typeof Xr}`);
      return (0, s.wrap)({
        size: vn.size,
        encodeStream: (In, zr) => vn.encodeStream(In, Cn),
        decodeStream: (In) => {
          const zr = vn.decodeStream(In);
          if (Xr && typeof zr != "object" && zr !== Cn || p(Cn) && !u(Cn, zr))
            throw In.err(`magic: invalid value: ${zr} !== ${Cn}`);
        },
        validate: (In) => {
          if (In !== void 0)
            throw new Error(`magic: wrong value=${typeof In}`);
          return In;
        }
      });
    }
    const qr = (vn) => {
      const Cn = typeof vn == "string" ? A.utf8.decode(vn) : vn;
      return Gr(er(Cn.length), Cn);
    };
    s.magicBytes = qr;
    function Hr(vn) {
      return (0, s.wrap)({
        encodeStream: (Cn, Xr) => {
          if (Xr !== vn)
            throw new Error(`constant: invalid value ${Xr} (exp: ${vn})`);
        },
        decodeStream: (Cn) => vn
      });
    }
    function un(vn) {
      let Cn = 0;
      for (const Xr of vn) {
        if (Xr.size === void 0)
          return;
        if (!b(Xr.size))
          throw new Error(`sizeof: wrong element size=${Cn}`);
        Cn += Xr.size;
      }
      return Cn;
    }
    function Dr(vn) {
      if (!m(vn))
        throw new Error(`struct: expected plain object, got ${vn}`);
      for (const Cn in vn)
        if (!Ie(vn[Cn]))
          throw new Error(`struct: field ${Cn} is not CoderType`);
      return (0, s.wrap)({
        size: un(Object.values(vn)),
        encodeStream: (Cn, Xr) => {
          Cn.pushObj(Xr, (In) => {
            for (const zr in vn)
              In(zr, () => vn[zr].encodeStream(Cn, Xr[zr]));
          });
        },
        decodeStream: (Cn) => {
          const Xr = {};
          return Cn.pushObj(Xr, (In) => {
            for (const zr in vn)
              In(zr, () => Xr[zr] = vn[zr].decodeStream(Cn));
          }), Xr;
        },
        validate: (Cn) => {
          if (typeof Cn != "object" || Cn === null)
            throw new Error(`struct: invalid value ${Cn}`);
          return Cn;
        }
      });
    }
    function wr(vn) {
      if (!Array.isArray(vn))
        throw new Error(`Packed.Tuple: got ${typeof vn} instead of array`);
      for (let Cn = 0; Cn < vn.length; Cn++)
        if (!Ie(vn[Cn]))
          throw new Error(`tuple: field ${Cn} is not CoderType`);
      return (0, s.wrap)({
        size: un(vn),
        encodeStream: (Cn, Xr) => {
          if (!Array.isArray(Xr))
            throw Cn.err(`tuple: invalid value ${Xr}`);
          Cn.pushObj(Xr, (In) => {
            for (let zr = 0; zr < vn.length; zr++)
              In(`${zr}`, () => vn[zr].encodeStream(Cn, Xr[zr]));
          });
        },
        decodeStream: (Cn) => {
          const Xr = [];
          return Cn.pushObj(Xr, (In) => {
            for (let zr = 0; zr < vn.length; zr++)
              In(`${zr}`, () => Xr.push(vn[zr].decodeStream(Cn)));
          }), Xr;
        },
        validate: (Cn) => {
          if (!Array.isArray(Cn))
            throw new Error(`tuple: invalid value ${Cn}`);
          if (Cn.length !== vn.length)
            throw new Error(`tuple: wrong length=${Cn.length}, expected ${vn.length}`);
          return Cn;
        }
      });
    }
    function yr(vn, Cn) {
      if (!Ie(Cn))
        throw new Error(`array: invalid inner value ${Cn}`);
      const Xr = k(typeof vn == "string" ? `../${vn}` : vn);
      return (0, s.wrap)({
        size: typeof vn == "number" && Cn.size ? vn * Cn.size : void 0,
        encodeStream: (In, zr) => {
          const En = In;
          En.pushObj(zr, (Zr) => {
            p(vn) || Xr.encodeStream(In, zr.length);
            for (let kr = 0; kr < zr.length; kr++)
              Zr(`${kr}`, () => {
                const Rr = zr[kr], Er = In.pos;
                if (Cn.encodeStream(In, Rr), p(vn)) {
                  if (vn.length > En.pos - Er)
                    return;
                  const Or = En.finish(!1).subarray(Er, En.pos);
                  if (u(Or.subarray(0, vn.length), vn))
                    throw En.err(`array: inner element encoding same as separator. elm=${Rr} data=${Or}`);
                }
              });
          }), p(vn) && In.bytes(vn);
        },
        decodeStream: (In) => {
          const zr = [];
          return In.pushObj(zr, (En) => {
            if (vn === null)
              for (let Zr = 0; !In.isEnd() && (En(`${Zr}`, () => zr.push(Cn.decodeStream(In))), !(Cn.size && In.leftBytes < Cn.size)); Zr++)
                ;
            else if (p(vn))
              for (let Zr = 0; ; Zr++) {
                if (u(In.bytes(vn.length, !0), vn)) {
                  In.bytes(vn.length);
                  break;
                }
                En(`${Zr}`, () => zr.push(Cn.decodeStream(In)));
              }
            else {
              let Zr;
              En("arrayLen", () => Zr = Xr.decodeStream(In));
              for (let kr = 0; kr < Zr; kr++)
                En(`${kr}`, () => zr.push(Cn.decodeStream(In)));
            }
          }), zr;
        },
        validate: (In) => {
          if (!Array.isArray(In))
            throw new Error(`array: invalid value ${In}`);
          return In;
        }
      });
    }
    function Qr(vn, Cn) {
      if (!Ie(vn))
        throw new Error(`map: invalid inner value ${vn}`);
      if (!m(Cn))
        throw new Error("map: variants should be plain object");
      const Xr = /* @__PURE__ */ new Map();
      for (const In in Cn)
        Xr.set(Cn[In], In);
      return (0, s.wrap)({
        size: vn.size,
        encodeStream: (In, zr) => vn.encodeStream(In, Cn[zr]),
        decodeStream: (In) => {
          const zr = vn.decodeStream(In), En = Xr.get(zr);
          if (En === void 0)
            throw In.err(`Enum: unknown value: ${zr} ${Array.from(Xr.keys())}`);
          return En;
        },
        validate: (In) => {
          if (typeof In != "string")
            throw new Error(`map: invalid value ${In}`);
          if (!(In in Cn))
            throw new Error(`Map: unknown variant: ${In}`);
          return In;
        }
      });
    }
    function _r(vn, Cn) {
      if (!Ie(vn))
        throw new Error(`tag: invalid tag value ${vn}`);
      if (!m(Cn))
        throw new Error("tag: variants should be plain object");
      for (const Xr in Cn)
        if (!Ie(Cn[Xr]))
          throw new Error(`tag: variant ${Xr} is not CoderType`);
      return (0, s.wrap)({
        size: vn.size,
        encodeStream: (Xr, In) => {
          const { TAG: zr, data: En } = In, Zr = Cn[zr];
          vn.encodeStream(Xr, zr), Zr.encodeStream(Xr, En);
        },
        decodeStream: (Xr) => {
          const In = vn.decodeStream(Xr), zr = Cn[In];
          if (!zr)
            throw Xr.err(`Tag: invalid tag ${In}`);
          return { TAG: In, data: zr.decodeStream(Xr) };
        },
        validate: (Xr) => {
          const { TAG: In } = Xr;
          if (!Cn[In])
            throw new Error(`Tag: invalid tag ${In.toString()}`);
          return Xr;
        }
      });
    }
    function Jr(vn, Cn) {
      if (!Ie(vn))
        throw new Error(`mappedTag: invalid tag value ${_r}`);
      if (!m(Cn))
        throw new Error("mappedTag: variants should be plain object");
      const Xr = {}, In = {};
      for (const zr in Cn) {
        const En = Cn[zr];
        Xr[zr] = En[0], In[zr] = En[1];
      }
      return _r(Qr(vn, Xr), In);
    }
    function fn(vn, Cn = !1) {
      if (typeof Cn != "boolean")
        throw new Error(`bitset/pad: expected boolean, got ${typeof Cn}`);
      if (!Array.isArray(vn))
        throw new Error("bitset/names: expected array");
      for (const Xr of vn)
        if (typeof Xr != "string")
          throw new Error("bitset/names: expected array of strings");
      return (0, s.wrap)({
        encodeStream: (Xr, In) => {
          for (let zr = 0; zr < vn.length; zr++)
            Xr.bits(+In[vn[zr]], 1);
          Cn && vn.length % 8 && Xr.bits(0, 8 - vn.length % 8);
        },
        decodeStream: (Xr) => {
          const In = {};
          for (let zr = 0; zr < vn.length; zr++)
            In[vn[zr]] = !!Xr.bits(1);
          return Cn && vn.length % 8 && Xr.bits(8 - vn.length % 8), In;
        },
        validate: (Xr) => {
          if (!m(Xr))
            throw new Error(`bitset: invalid value ${Xr}`);
          for (const In of Object.values(Xr))
            if (typeof In != "boolean")
              throw new Error("expected boolean");
          return Xr;
        }
      });
    }
    const jr = (vn) => 0;
    s.ZeroPad = jr;
    function dn(vn, Cn) {
      return Cn % vn === 0 ? 0 : vn - Cn % vn;
    }
    function Tn(vn, Cn, Xr) {
      if (!b(vn) || vn <= 0)
        throw new Error(`padLeft: wrong blockSize=${vn}`);
      if (!Ie(Cn))
        throw new Error(`padLeft: invalid inner value ${Cn}`);
      if (Xr !== void 0 && typeof Xr != "function")
        throw new Error(`padLeft: wrong padFn=${typeof Xr}`);
      const In = Xr || s.ZeroPad;
      if (!Cn.size)
        throw new Error("padLeft cannot have dynamic size");
      return (0, s.wrap)({
        size: Cn.size + dn(vn, Cn.size),
        encodeStream: (zr, En) => {
          const Zr = dn(vn, Cn.size);
          for (let kr = 0; kr < Zr; kr++)
            zr.byte(In(kr));
          Cn.encodeStream(zr, En);
        },
        decodeStream: (zr) => (zr.bytes(dn(vn, Cn.size)), Cn.decodeStream(zr))
      });
    }
    function Yn(vn, Cn, Xr) {
      if (!Ie(Cn))
        throw new Error(`padRight: invalid inner value ${Cn}`);
      if (!b(vn) || vn <= 0)
        throw new Error(`padLeft: wrong blockSize=${vn}`);
      if (Xr !== void 0 && typeof Xr != "function")
        throw new Error(`padRight: wrong padFn=${typeof Xr}`);
      const In = Xr || s.ZeroPad;
      return (0, s.wrap)({
        size: Cn.size ? Cn.size + dn(vn, Cn.size) : void 0,
        encodeStream: (zr, En) => {
          const Zr = zr, kr = Zr.pos;
          Cn.encodeStream(zr, En);
          const Rr = dn(vn, Zr.pos - kr);
          for (let Er = 0; Er < Rr; Er++)
            zr.byte(In(Er));
        },
        decodeStream: (zr) => {
          const En = zr.pos, Zr = Cn.decodeStream(zr);
          return zr.bytes(dn(vn, zr.pos - En)), Zr;
        }
      });
    }
    function si(vn, Cn, Xr = !1) {
      if (!Ie(vn))
        throw new Error(`pointer: invalid ptr value ${vn}`);
      if (!Ie(Cn))
        throw new Error(`pointer: invalid inner value ${Cn}`);
      if (typeof Xr != "boolean")
        throw new Error(`pointer/sized: expected boolean, got ${typeof Xr}`);
      if (!vn.size)
        throw new Error("unsized pointer");
      return (0, s.wrap)({
        size: Xr ? vn.size : void 0,
        encodeStream: (In, zr) => {
          const En = In, Zr = En.pos;
          vn.encodeStream(In, 0), En.ptrs.push({ pos: Zr, ptr: vn, buffer: Cn.encode(zr) });
        },
        decodeStream: (In) => {
          const zr = vn.decodeStream(In);
          return In._enablePointers(), Cn.decodeStream(In.offsetReader(zr));
        }
      });
    }
    s._TEST = { _bitset: C, _Reader: Q, _Writer: P, Path: B };
  }(lib)), lib;
}
var hasRequiredUtils$1;
function requireUtils$1() {
  return hasRequiredUtils$1 || (hasRequiredUtils$1 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.TEST_NETWORK = s.NETWORK = s.TAPROOT_UNSPENDABLE_KEY = s.PubT = s.tagSchnorr = s.signSchnorr = s.pubECDSA = s.pubSchnorr = s.randomPrivateKeyBytes = s.sha256x2 = s.hash160 = s.sha256 = s.isBytes = s.equalBytes = s.concatBytes = void 0, s.signECDSA = x, s.validatePubkey = F, s.tapTweak = le, s.taprootTweakPrivKey = ge, s.taprootTweakPubkey = pe, s.compareBytes = Ie;
    const A = /* @__PURE__ */ requireSecp256k1$5(), u = /* @__PURE__ */ requireLegacy$1(), p = /* @__PURE__ */ requireSha2();
    Object.defineProperty(s, "sha256", { enumerable: !0, get: function() {
      return p.sha256;
    } });
    const t = /* @__PURE__ */ requireLib(), l = A.secp256k1.ProjectivePoint, m = A.secp256k1.CURVE.n, b = t.utils.isBytes;
    s.isBytes = b;
    const k = t.utils.concatBytes;
    s.concatBytes = k;
    const C = t.utils.equalBytes;
    s.equalBytes = C;
    const B = (be) => (0, u.ripemd160)((0, p.sha256)(be));
    s.hash160 = B;
    const Q = (...be) => (0, p.sha256)((0, p.sha256)(k(...be)));
    s.sha256x2 = Q, s.randomPrivateKeyBytes = A.schnorr.utils.randomPrivateKey, s.pubSchnorr = A.schnorr.getPublicKey, s.pubECDSA = A.secp256k1.getPublicKey;
    const P = (be) => be.r < m / 2n;
    function x(be, Pe, Te = !1) {
      let Qe = A.secp256k1.sign(be, Pe);
      if (Te && !P(Qe)) {
        const xe = new Uint8Array(32);
        let Ee = 0;
        for (; !P(Qe); )
          if (xe.set(t.U32LE.encode(Ee++)), Qe = A.secp256k1.sign(be, Pe, { extraEntropy: xe }), Ee > 4294967295)
            throw new Error("lowR counter overflow: report the error");
      }
      return Qe.toDERRawBytes();
    }
    s.signSchnorr = A.schnorr.sign, s.tagSchnorr = A.schnorr.utils.taggedHash;
    var M;
    (function(be) {
      be[be.ecdsa = 0] = "ecdsa", be[be.schnorr = 1] = "schnorr";
    })(M || (s.PubT = M = {}));
    function F(be, Pe) {
      const Te = be.length;
      if (Pe === M.ecdsa) {
        if (Te === 32)
          throw new Error("Expected non-Schnorr key");
        return l.fromHex(be), be;
      } else if (Pe === M.schnorr) {
        if (Te !== 32)
          throw new Error("Expected 32-byte Schnorr key");
        return A.schnorr.utils.lift_x(A.schnorr.utils.bytesToNumberBE(be)), be;
      } else
        throw new Error("Unknown key type");
    }
    function le(be, Pe) {
      const Te = A.schnorr.utils, Qe = Te.taggedHash("TapTweak", be, Pe), xe = Te.bytesToNumberBE(Qe);
      if (xe >= m)
        throw new Error("tweak higher than curve order");
      return xe;
    }
    function ge(be, Pe = Uint8Array.of()) {
      const Te = A.schnorr.utils, Qe = Te.bytesToNumberBE(be), xe = l.fromPrivateKey(Qe), Ee = xe.hasEvenY() ? Qe : Te.mod(-Qe, m), He = Te.pointToBytes(xe), ve = le(He, Pe);
      return Te.numberToBytesBE(Te.mod(Ee + ve, m), 32);
    }
    function pe(be, Pe) {
      const Te = A.schnorr.utils, Qe = le(be, Pe), Ee = Te.lift_x(Te.bytesToNumberBE(be)).add(l.fromPrivateKey(Qe)), He = Ee.hasEvenY() ? 0 : 1;
      return [Te.pointToBytes(Ee), He];
    }
    s.TAPROOT_UNSPENDABLE_KEY = (0, p.sha256)(l.BASE.toRawBytes(!1)), s.NETWORK = {
      bech32: "bc",
      pubKeyHash: 0,
      scriptHash: 5,
      wif: 128
    }, s.TEST_NETWORK = {
      bech32: "tb",
      pubKeyHash: 111,
      scriptHash: 196,
      wif: 239
    };
    function Ie(be, Pe) {
      if (!b(be) || !b(Pe))
        throw new Error(`cmp: wrong type a=${typeof be} b=${typeof Pe}`);
      const Te = Math.min(be.length, Pe.length);
      for (let Qe = 0; Qe < Te; Qe++)
        if (be[Qe] != Pe[Qe])
          return Math.sign(be[Qe] - Pe[Qe]);
      return Math.sign(be.length - Pe.length);
    }
  }(utils$1)), utils$1;
}
var payment = {}, psbt$1 = {}, script = {}, hasRequiredScript;
function requireScript() {
  return hasRequiredScript || (hasRequiredScript = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.RawOldTx = s.RawTx = s.RawOutput = s.RawInput = s.BTCArray = s.RawWitness = s.VarBytes = s.CompactSizeLen = s.CompactSize = s.Script = s.OP = s.MAX_SCRIPT_BYTE_LENGTH = void 0, s.ScriptNum = t, s.OpToNum = l;
    const A = /* @__PURE__ */ requireLib(), u = /* @__PURE__ */ requireUtils$1();
    s.MAX_SCRIPT_BYTE_LENGTH = 520;
    var p;
    (function(B) {
      B[B.OP_0 = 0] = "OP_0", B[B.PUSHDATA1 = 76] = "PUSHDATA1", B[B.PUSHDATA2 = 77] = "PUSHDATA2", B[B.PUSHDATA4 = 78] = "PUSHDATA4", B[B["1NEGATE"] = 79] = "1NEGATE", B[B.RESERVED = 80] = "RESERVED", B[B.OP_1 = 81] = "OP_1", B[B.OP_2 = 82] = "OP_2", B[B.OP_3 = 83] = "OP_3", B[B.OP_4 = 84] = "OP_4", B[B.OP_5 = 85] = "OP_5", B[B.OP_6 = 86] = "OP_6", B[B.OP_7 = 87] = "OP_7", B[B.OP_8 = 88] = "OP_8", B[B.OP_9 = 89] = "OP_9", B[B.OP_10 = 90] = "OP_10", B[B.OP_11 = 91] = "OP_11", B[B.OP_12 = 92] = "OP_12", B[B.OP_13 = 93] = "OP_13", B[B.OP_14 = 94] = "OP_14", B[B.OP_15 = 95] = "OP_15", B[B.OP_16 = 96] = "OP_16", B[B.NOP = 97] = "NOP", B[B.VER = 98] = "VER", B[B.IF = 99] = "IF", B[B.NOTIF = 100] = "NOTIF", B[B.VERIF = 101] = "VERIF", B[B.VERNOTIF = 102] = "VERNOTIF", B[B.ELSE = 103] = "ELSE", B[B.ENDIF = 104] = "ENDIF", B[B.VERIFY = 105] = "VERIFY", B[B.RETURN = 106] = "RETURN", B[B.TOALTSTACK = 107] = "TOALTSTACK", B[B.FROMALTSTACK = 108] = "FROMALTSTACK", B[B["2DROP"] = 109] = "2DROP", B[B["2DUP"] = 110] = "2DUP", B[B["3DUP"] = 111] = "3DUP", B[B["2OVER"] = 112] = "2OVER", B[B["2ROT"] = 113] = "2ROT", B[B["2SWAP"] = 114] = "2SWAP", B[B.IFDUP = 115] = "IFDUP", B[B.DEPTH = 116] = "DEPTH", B[B.DROP = 117] = "DROP", B[B.DUP = 118] = "DUP", B[B.NIP = 119] = "NIP", B[B.OVER = 120] = "OVER", B[B.PICK = 121] = "PICK", B[B.ROLL = 122] = "ROLL", B[B.ROT = 123] = "ROT", B[B.SWAP = 124] = "SWAP", B[B.TUCK = 125] = "TUCK", B[B.CAT = 126] = "CAT", B[B.SUBSTR = 127] = "SUBSTR", B[B.LEFT = 128] = "LEFT", B[B.RIGHT = 129] = "RIGHT", B[B.SIZE = 130] = "SIZE", B[B.INVERT = 131] = "INVERT", B[B.AND = 132] = "AND", B[B.OR = 133] = "OR", B[B.XOR = 134] = "XOR", B[B.EQUAL = 135] = "EQUAL", B[B.EQUALVERIFY = 136] = "EQUALVERIFY", B[B.RESERVED1 = 137] = "RESERVED1", B[B.RESERVED2 = 138] = "RESERVED2", B[B["1ADD"] = 139] = "1ADD", B[B["1SUB"] = 140] = "1SUB", B[B["2MUL"] = 141] = "2MUL", B[B["2DIV"] = 142] = "2DIV", B[B.NEGATE = 143] = "NEGATE", B[B.ABS = 144] = "ABS", B[B.NOT = 145] = "NOT", B[B["0NOTEQUAL"] = 146] = "0NOTEQUAL", B[B.ADD = 147] = "ADD", B[B.SUB = 148] = "SUB", B[B.MUL = 149] = "MUL", B[B.DIV = 150] = "DIV", B[B.MOD = 151] = "MOD", B[B.LSHIFT = 152] = "LSHIFT", B[B.RSHIFT = 153] = "RSHIFT", B[B.BOOLAND = 154] = "BOOLAND", B[B.BOOLOR = 155] = "BOOLOR", B[B.NUMEQUAL = 156] = "NUMEQUAL", B[B.NUMEQUALVERIFY = 157] = "NUMEQUALVERIFY", B[B.NUMNOTEQUAL = 158] = "NUMNOTEQUAL", B[B.LESSTHAN = 159] = "LESSTHAN", B[B.GREATERTHAN = 160] = "GREATERTHAN", B[B.LESSTHANOREQUAL = 161] = "LESSTHANOREQUAL", B[B.GREATERTHANOREQUAL = 162] = "GREATERTHANOREQUAL", B[B.MIN = 163] = "MIN", B[B.MAX = 164] = "MAX", B[B.WITHIN = 165] = "WITHIN", B[B.RIPEMD160 = 166] = "RIPEMD160", B[B.SHA1 = 167] = "SHA1", B[B.SHA256 = 168] = "SHA256", B[B.HASH160 = 169] = "HASH160", B[B.HASH256 = 170] = "HASH256", B[B.CODESEPARATOR = 171] = "CODESEPARATOR", B[B.CHECKSIG = 172] = "CHECKSIG", B[B.CHECKSIGVERIFY = 173] = "CHECKSIGVERIFY", B[B.CHECKMULTISIG = 174] = "CHECKMULTISIG", B[B.CHECKMULTISIGVERIFY = 175] = "CHECKMULTISIGVERIFY", B[B.NOP1 = 176] = "NOP1", B[B.CHECKLOCKTIMEVERIFY = 177] = "CHECKLOCKTIMEVERIFY", B[B.CHECKSEQUENCEVERIFY = 178] = "CHECKSEQUENCEVERIFY", B[B.NOP4 = 179] = "NOP4", B[B.NOP5 = 180] = "NOP5", B[B.NOP6 = 181] = "NOP6", B[B.NOP7 = 182] = "NOP7", B[B.NOP8 = 183] = "NOP8", B[B.NOP9 = 184] = "NOP9", B[B.NOP10 = 185] = "NOP10", B[B.CHECKSIGADD = 186] = "CHECKSIGADD", B[B.INVALID = 255] = "INVALID";
    })(p || (s.OP = p = {}));
    function t(B = 6, Q = !1) {
      return A.wrap({
        encodeStream: (P, x) => {
          if (x === 0n)
            return;
          const M = x < 0, F = BigInt(x), le = [];
          for (let ge = M ? -F : F; ge; ge >>= 8n)
            le.push(Number(ge & 0xffn));
          le[le.length - 1] >= 128 ? le.push(M ? 128 : 0) : M && (le[le.length - 1] |= 128), P.bytes(new Uint8Array(le));
        },
        decodeStream: (P) => {
          const x = P.leftBytes;
          if (x > B)
            throw new Error(`ScriptNum: number (${x}) bigger than limit=${B}`);
          if (x === 0)
            return 0n;
          if (Q) {
            const le = P.bytes(x, !0);
            if ((le[le.length - 1] & 127) === 0 && (x <= 1 || (le[le.length - 2] & 128) === 0))
              throw new Error("Non-minimally encoded ScriptNum");
          }
          let M = 0, F = 0n;
          for (let le = 0; le < x; ++le)
            M = P.byte(), F |= BigInt(M) << 8n * BigInt(le);
          return M >= 128 && (F &= 2n ** BigInt(x * 8) - 1n >> 1n, F = -F), F;
        }
      });
    }
    function l(B, Q = 4, P = !0) {
      if (typeof B == "number")
        return B;
      if ((0, u.isBytes)(B))
        try {
          const x = t(Q, P).decode(B);
          return x > Number.MAX_SAFE_INTEGER ? void 0 : Number(x);
        } catch {
          return;
        }
    }
    s.Script = A.wrap({
      encodeStream: (B, Q) => {
        for (let P of Q) {
          if (typeof P == "string") {
            if (p[P] === void 0)
              throw new Error(`Unknown opcode=${P}`);
            B.byte(p[P]);
            continue;
          } else if (typeof P == "number") {
            if (P === 0) {
              B.byte(0);
              continue;
            } else if (1 <= P && P <= 16) {
              B.byte(p.OP_1 - 1 + P);
              continue;
            }
          }
          if (typeof P == "number" && (P = t().encode(BigInt(P))), !(0, u.isBytes)(P))
            throw new Error(`Wrong Script OP=${P} (${typeof P})`);
          const x = P.length;
          x < p.PUSHDATA1 ? B.byte(x) : x <= 255 ? (B.byte(p.PUSHDATA1), B.byte(x)) : x <= 65535 ? (B.byte(p.PUSHDATA2), B.bytes(A.U16LE.encode(x))) : (B.byte(p.PUSHDATA4), B.bytes(A.U32LE.encode(x))), B.bytes(P);
        }
      },
      decodeStream: (B) => {
        const Q = [];
        for (; !B.isEnd(); ) {
          const P = B.byte();
          if (p.OP_0 < P && P <= p.PUSHDATA4) {
            let x;
            if (P < p.PUSHDATA1)
              x = P;
            else if (P === p.PUSHDATA1)
              x = A.U8.decodeStream(B);
            else if (P === p.PUSHDATA2)
              x = A.U16LE.decodeStream(B);
            else if (P === p.PUSHDATA4)
              x = A.U32LE.decodeStream(B);
            else
              throw new Error("Should be not possible");
            Q.push(B.bytes(x));
          } else if (P === 0)
            Q.push(0);
          else if (p.OP_1 <= P && P <= p.OP_16)
            Q.push(P - (p.OP_1 - 1));
          else {
            const x = p[P];
            if (x === void 0)
              throw new Error(`Unknown opcode=${P.toString(16)}`);
            Q.push(x);
          }
        }
        return Q;
      }
    });
    const m = {
      253: [253, 2, 253n, 65535n],
      254: [254, 4, 65536n, 4294967295n],
      255: [255, 8, 4294967296n, 18446744073709551615n]
    };
    s.CompactSize = A.wrap({
      encodeStream: (B, Q) => {
        if (typeof Q == "number" && (Q = BigInt(Q)), 0n <= Q && Q <= 252n)
          return B.byte(Number(Q));
        for (const [P, x, M, F] of Object.values(m))
          if (!(M > Q || Q > F)) {
            B.byte(P);
            for (let le = 0; le < x; le++)
              B.byte(Number(Q >> 8n * BigInt(le) & 0xffn));
            return;
          }
        throw B.err(`VarInt too big: ${Q}`);
      },
      decodeStream: (B) => {
        const Q = B.byte();
        if (Q <= 252)
          return BigInt(Q);
        const [P, x, M] = m[Q];
        let F = 0n;
        for (let le = 0; le < x; le++)
          F |= BigInt(B.byte()) << 8n * BigInt(le);
        if (F < M)
          throw B.err(`Wrong CompactSize(${8 * x})`);
        return F;
      }
    }), s.CompactSizeLen = A.apply(s.CompactSize, A.coders.numberBigint), s.VarBytes = A.bytes(s.CompactSize), s.RawWitness = A.array(s.CompactSizeLen, s.VarBytes);
    const b = (B) => A.array(s.CompactSize, B);
    s.BTCArray = b, s.RawInput = A.struct({
      txid: A.bytes(32, !0),
      // hash(prev_tx),
      index: A.U32LE,
      // output number of previous tx
      finalScriptSig: s.VarBytes,
      // btc merges input and output script, executes it. If ok = tx passes
      sequence: A.U32LE
      // ?
    }), s.RawOutput = A.struct({ amount: A.U64LE, script: s.VarBytes });
    const k = A.struct({
      version: A.I32LE,
      segwitFlag: A.flag(new Uint8Array([0, 1])),
      inputs: (0, s.BTCArray)(s.RawInput),
      outputs: (0, s.BTCArray)(s.RawOutput),
      witnesses: A.flagged("segwitFlag", A.array("inputs/length", s.RawWitness)),
      // < 500000000	Block number at which this transaction is unlocked
      // >= 500000000	UNIX timestamp at which this transaction is unlocked
      // Handled as part of PSBTv2
      lockTime: A.U32LE
    });
    function C(B) {
      if (B.segwitFlag && B.witnesses && !B.witnesses.length)
        throw new Error("Segwit flag with empty witnesses array");
      return B;
    }
    s.RawTx = A.validate(k, C), s.RawOldTx = A.struct({
      version: A.I32LE,
      inputs: (0, s.BTCArray)(s.RawInput),
      outputs: (0, s.BTCArray)(s.RawOutput),
      lockTime: A.U32LE
    });
  }(script)), script;
}
var hasRequiredPsbt$1;
function requirePsbt$1() {
  return hasRequiredPsbt$1 || (hasRequiredPsbt$1 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.RawPSBTV2 = s.RawPSBTV0 = s._DebugPSBT = s._RawPSBTV2 = s._RawPSBTV0 = s.PSBTOutputCoder = s.PSBTInputCoder = s.PSBTOutputUnsignedKeys = s.PSBTOutput = s.PSBTInputUnsignedKeys = s.PSBTInputFinalKeys = s.PSBTInput = s.PSBTGlobal = s.TaprootControlBlock = void 0, s.cleanPSBTFields = Te, s.mergeKeyMap = xe;
    const A = /* @__PURE__ */ requireLib$2(), u = /* @__PURE__ */ requireLib(), p = /* @__PURE__ */ requireScript(), t = /* @__PURE__ */ requireUtils$1(), l = u.validate(u.bytes(null), (Ee) => (0, t.validatePubkey)(Ee, t.PubT.ecdsa)), m = u.validate(u.bytes(32), (Ee) => (0, t.validatePubkey)(Ee, t.PubT.schnorr)), b = u.validate(u.bytes(null), (Ee) => {
      if (Ee.length !== 64 && Ee.length !== 65)
        throw new Error("Schnorr signature should be 64 or 65 bytes long");
      return Ee;
    }), k = u.struct({
      fingerprint: u.U32BE,
      path: u.array(null, u.U32LE)
    }), C = u.struct({
      hashes: u.array(p.CompactSizeLen, u.bytes(32)),
      der: k
    }), B = u.bytes(78), Q = u.struct({ pubKey: m, leafHash: u.bytes(32) }), P = u.struct({
      version: u.U8,
      // With parity :(
      internalKey: u.bytes(32),
      merklePath: u.array(null, u.bytes(32))
    });
    s.TaprootControlBlock = u.validate(P, (Ee) => {
      if (Ee.merklePath.length > 128)
        throw new Error("TaprootControlBlock: merklePath should be of length 0..128 (inclusive)");
      return Ee;
    });
    const x = u.array(null, u.struct({
      depth: u.U8,
      version: u.U8,
      script: p.VarBytes
    })), M = u.bytes(null), F = u.bytes(20), le = u.bytes(32);
    s.PSBTGlobal = {
      unsignedTx: [0, !1, p.RawOldTx, [0], [0], !1],
      xpub: [1, B, k, [], [0, 2], !1],
      txVersion: [2, !1, u.U32LE, [2], [2], !1],
      fallbackLocktime: [3, !1, u.U32LE, [], [2], !1],
      inputCount: [4, !1, p.CompactSizeLen, [2], [2], !1],
      outputCount: [5, !1, p.CompactSizeLen, [2], [2], !1],
      txModifiable: [6, !1, u.U8, [], [2], !1],
      // TODO: bitfield
      version: [251, !1, u.U32LE, [], [0, 2], !1],
      proprietary: [252, M, M, [], [0, 2], !1]
    }, s.PSBTInput = {
      nonWitnessUtxo: [0, !1, p.RawTx, [], [0, 2], !1],
      witnessUtxo: [1, !1, p.RawOutput, [], [0, 2], !1],
      partialSig: [2, l, M, [], [0, 2], !1],
      sighashType: [3, !1, u.U32LE, [], [0, 2], !1],
      redeemScript: [4, !1, M, [], [0, 2], !1],
      witnessScript: [5, !1, M, [], [0, 2], !1],
      bip32Derivation: [6, l, k, [], [0, 2], !1],
      finalScriptSig: [7, !1, M, [], [0, 2], !1],
      finalScriptWitness: [8, !1, p.RawWitness, [], [0, 2], !1],
      porCommitment: [9, !1, M, [], [0, 2], !1],
      ripemd160: [10, F, M, [], [0, 2], !1],
      sha256: [11, le, M, [], [0, 2], !1],
      hash160: [12, F, M, [], [0, 2], !1],
      hash256: [13, le, M, [], [0, 2], !1],
      txid: [14, !1, le, [2], [2], !0],
      index: [15, !1, u.U32LE, [2], [2], !0],
      sequence: [16, !1, u.U32LE, [], [2], !0],
      requiredTimeLocktime: [17, !1, u.U32LE, [], [2], !1],
      requiredHeightLocktime: [18, !1, u.U32LE, [], [2], !1],
      tapKeySig: [19, !1, b, [], [0, 2], !1],
      tapScriptSig: [20, Q, b, [], [0, 2], !1],
      tapLeafScript: [21, s.TaprootControlBlock, M, [], [0, 2], !1],
      tapBip32Derivation: [22, le, C, [], [0, 2], !1],
      tapInternalKey: [23, !1, m, [], [0, 2], !1],
      tapMerkleRoot: [24, !1, le, [], [0, 2], !1],
      proprietary: [252, M, M, [], [0, 2], !1]
    }, s.PSBTInputFinalKeys = [
      "txid",
      "sequence",
      "index",
      "witnessUtxo",
      "nonWitnessUtxo",
      "finalScriptSig",
      "finalScriptWitness",
      "unknown"
    ], s.PSBTInputUnsignedKeys = [
      "partialSig",
      "finalScriptSig",
      "finalScriptWitness",
      "tapKeySig",
      "tapScriptSig"
    ], s.PSBTOutput = {
      redeemScript: [0, !1, M, [], [0, 2], !1],
      witnessScript: [1, !1, M, [], [0, 2], !1],
      bip32Derivation: [2, l, k, [], [0, 2], !1],
      amount: [3, !1, u.I64LE, [2], [2], !0],
      script: [4, !1, M, [2], [2], !0],
      tapInternalKey: [5, !1, m, [], [0, 2], !1],
      tapTree: [6, !1, x, [], [0, 2], !1],
      tapBip32Derivation: [7, m, C, [], [0, 2], !1],
      proprietary: [252, M, M, [], [0, 2], !1]
    }, s.PSBTOutputUnsignedKeys = [];
    const ge = u.array(u.NULL, u.struct({
      //  <key> := <keylen> <keytype> <keydata> WHERE keylen = len(keytype)+len(keydata)
      key: u.prefix(p.CompactSizeLen, u.struct({ type: p.CompactSizeLen, key: u.bytes(null) })),
      //  <value> := <valuelen> <valuedata>
      value: u.bytes(p.CompactSizeLen)
    }));
    function pe(Ee) {
      const [He, ve, we, Ce, Se, Ne] = Ee;
      return { type: He, kc: ve, vc: we, reqInc: Ce, allowInc: Se, silentIgnore: Ne };
    }
    u.struct({ type: p.CompactSizeLen, key: u.bytes(null) });
    function Ie(Ee) {
      const He = {};
      for (const ve in Ee) {
        const [we, Ce, Se] = Ee[ve];
        He[we] = [ve, Ce, Se];
      }
      return u.wrap({
        encodeStream: (ve, we) => {
          let Ce = [];
          for (const Se in Ee) {
            const Ne = we[Se];
            if (Ne === void 0)
              continue;
            const [rr, er, ir] = Ee[Se];
            if (!er)
              Ce.push({ key: { type: rr, key: u.EMPTY }, value: ir.encode(Ne) });
            else {
              const sr = Ne.map(([nr, fr]) => [
                er.encode(nr),
                ir.encode(fr)
              ]);
              sr.sort((nr, fr) => (0, t.compareBytes)(nr[0], fr[0]));
              for (const [nr, fr] of sr)
                Ce.push({ key: { key: nr, type: rr }, value: fr });
            }
          }
          if (we.unknown) {
            we.unknown.sort((Se, Ne) => (0, t.compareBytes)(Se[0].key, Ne[0].key));
            for (const [Se, Ne] of we.unknown)
              Ce.push({ key: Se, value: Ne });
          }
          ge.encodeStream(ve, Ce);
        },
        decodeStream: (ve) => {
          const we = ge.decodeStream(ve), Ce = {}, Se = {};
          for (const Ne of we) {
            let rr = "unknown", er = Ne.key.key, ir = Ne.value;
            if (He[Ne.key.type]) {
              const [sr, nr, fr] = He[Ne.key.type];
              if (rr = sr, !nr && er.length)
                throw new Error(`PSBT: Non-empty key for ${rr} (key=${A.hex.encode(er)} value=${A.hex.encode(ir)}`);
              if (er = nr ? nr.decode(er) : void 0, ir = fr.decode(ir), !nr) {
                if (Ce[rr])
                  throw new Error(`PSBT: Same keys: ${rr} (key=${er} value=${ir})`);
                Ce[rr] = ir, Se[rr] = !0;
                continue;
              }
            } else
              er = { type: Ne.key.type, key: Ne.key.key };
            if (Se[rr])
              throw new Error(`PSBT: Key type with empty key and no key=${rr} val=${ir}`);
            Ce[rr] || (Ce[rr] = []), Ce[rr].push([er, ir]);
          }
          return Ce;
        }
      });
    }
    s.PSBTInputCoder = u.validate(Ie(s.PSBTInput), (Ee) => {
      if (Ee.finalScriptWitness && !Ee.finalScriptWitness.length)
        throw new Error("validateInput: empty finalScriptWitness");
      if (Ee.partialSig && !Ee.partialSig.length)
        throw new Error("Empty partialSig");
      if (Ee.partialSig)
        for (const [He] of Ee.partialSig)
          (0, t.validatePubkey)(He, t.PubT.ecdsa);
      if (Ee.bip32Derivation)
        for (const [He] of Ee.bip32Derivation)
          (0, t.validatePubkey)(He, t.PubT.ecdsa);
      if (Ee.requiredTimeLocktime !== void 0 && Ee.requiredTimeLocktime < 5e8)
        throw new Error(`validateInput: wrong timeLocktime=${Ee.requiredTimeLocktime}`);
      if (Ee.requiredHeightLocktime !== void 0 && (Ee.requiredHeightLocktime <= 0 || Ee.requiredHeightLocktime >= 5e8))
        throw new Error(`validateInput: wrong heighLocktime=${Ee.requiredHeightLocktime}`);
      if (Ee.tapLeafScript)
        for (const [He, ve] of Ee.tapLeafScript) {
          if ((He.version & 254) !== ve[ve.length - 1])
            throw new Error("validateInput: tapLeafScript version mimatch");
          if (ve[ve.length - 1] & 1)
            throw new Error("validateInput: tapLeafScript version has parity bit!");
        }
      return Ee;
    }), s.PSBTOutputCoder = u.validate(Ie(s.PSBTOutput), (Ee) => {
      if (Ee.bip32Derivation)
        for (const [He] of Ee.bip32Derivation)
          (0, t.validatePubkey)(He, t.PubT.ecdsa);
      return Ee;
    });
    const be = u.validate(Ie(s.PSBTGlobal), (Ee) => {
      if ((Ee.version || 0) === 0) {
        if (!Ee.unsignedTx)
          throw new Error("PSBTv0: missing unsignedTx");
        for (const ve of Ee.unsignedTx.inputs)
          if (ve.finalScriptSig && ve.finalScriptSig.length)
            throw new Error("PSBTv0: input scriptSig found in unsignedTx");
      }
      return Ee;
    });
    s._RawPSBTV0 = u.struct({
      magic: u.magic(u.string(new Uint8Array([255])), "psbt"),
      global: be,
      inputs: u.array("global/unsignedTx/inputs/length", s.PSBTInputCoder),
      outputs: u.array(null, s.PSBTOutputCoder)
    }), s._RawPSBTV2 = u.struct({
      magic: u.magic(u.string(new Uint8Array([255])), "psbt"),
      global: be,
      inputs: u.array("global/inputCount", s.PSBTInputCoder),
      outputs: u.array("global/outputCount", s.PSBTOutputCoder)
    }), s._DebugPSBT = u.struct({
      magic: u.magic(u.string(new Uint8Array([255])), "psbt"),
      items: u.array(null, u.apply(u.array(u.NULL, u.tuple([u.hex(p.CompactSizeLen), u.bytes(p.CompactSize)])), u.coders.dict()))
    });
    function Pe(Ee, He, ve) {
      for (const we in ve) {
        if (we === "unknown" || !He[we])
          continue;
        const { allowInc: Ce } = pe(He[we]);
        if (!Ce.includes(Ee))
          throw new Error(`PSBTv${Ee}: field ${we} is not allowed`);
      }
      for (const we in He) {
        const { reqInc: Ce } = pe(He[we]);
        if (Ce.includes(Ee) && ve[we] === void 0)
          throw new Error(`PSBTv${Ee}: missing required field ${we}`);
      }
    }
    function Te(Ee, He, ve) {
      const we = {};
      for (const Ce in ve) {
        const Se = Ce;
        if (Se !== "unknown") {
          if (!He[Se])
            continue;
          const { allowInc: Ne, silentIgnore: rr } = pe(He[Se]);
          if (!Ne.includes(Ee)) {
            if (rr)
              continue;
            throw new Error(`Failed to serialize in PSBTv${Ee}: ${Se} but versions allows inclusion=${Ne}`);
          }
        }
        we[Se] = ve[Se];
      }
      return we;
    }
    function Qe(Ee) {
      const He = Ee && Ee.global && Ee.global.version || 0;
      Pe(He, s.PSBTGlobal, Ee.global);
      for (const Ne of Ee.inputs)
        Pe(He, s.PSBTInput, Ne);
      for (const Ne of Ee.outputs)
        Pe(He, s.PSBTOutput, Ne);
      const ve = He ? Ee.global.inputCount : Ee.global.unsignedTx.inputs.length;
      if (Ee.inputs.length < ve)
        throw new Error("Not enough inputs");
      const we = Ee.inputs.slice(ve);
      if (we.length > 1 || we.length && Object.keys(we[0]).length)
        throw new Error(`Unexpected inputs left in tx=${we}`);
      const Ce = He ? Ee.global.outputCount : Ee.global.unsignedTx.outputs.length;
      if (Ee.outputs.length < Ce)
        throw new Error("Not outputs inputs");
      const Se = Ee.outputs.slice(Ce);
      if (Se.length > 1 || Se.length && Object.keys(Se[0]).length)
        throw new Error(`Unexpected outputs left in tx=${Se}`);
      return Ee;
    }
    function xe(Ee, He, ve, we, Ce) {
      const Se = { ...ve, ...He };
      for (const Ne in Ee) {
        const rr = Ne, [er, ir, sr] = Ee[rr], nr = we && !we.includes(Ne);
        if (He[Ne] === void 0 && Ne in He) {
          if (nr)
            throw new Error(`Cannot remove signed field=${Ne}`);
          delete Se[Ne];
        } else if (ir) {
          const fr = ve && ve[Ne] ? ve[Ne] : [];
          let lr = He[rr];
          if (lr) {
            if (!Array.isArray(lr))
              throw new Error(`keyMap(${Ne}): KV pairs should be [k, v][]`);
            lr = lr.map((Fr) => {
              if (Fr.length !== 2)
                throw new Error(`keyMap(${Ne}): KV pairs should be [k, v][]`);
              return [
                typeof Fr[0] == "string" ? ir.decode(A.hex.decode(Fr[0])) : Fr[0],
                typeof Fr[1] == "string" ? sr.decode(A.hex.decode(Fr[1])) : Fr[1]
              ];
            });
            const br = {}, Br = (Fr, Gr, qr) => {
              if (br[Fr] === void 0) {
                br[Fr] = [Gr, qr];
                return;
              }
              const Hr = A.hex.encode(sr.encode(br[Fr][1])), un = A.hex.encode(sr.encode(qr));
              if (Hr !== un)
                throw new Error(`keyMap(${rr}): same key=${Fr} oldVal=${Hr} newVal=${un}`);
            };
            for (const [Fr, Gr] of fr) {
              const qr = A.hex.encode(ir.encode(Fr));
              Br(qr, Fr, Gr);
            }
            for (const [Fr, Gr] of lr) {
              const qr = A.hex.encode(ir.encode(Fr));
              if (Gr === void 0) {
                if (nr)
                  throw new Error(`Cannot remove signed field=${rr}/${Fr}`);
                delete br[qr];
              } else
                Br(qr, Fr, Gr);
            }
            Se[rr] = Object.values(br);
          }
        } else if (typeof Se[Ne] == "string")
          Se[Ne] = sr.decode(A.hex.decode(Se[Ne]));
        else if (nr && Ne in He && ve && ve[Ne] !== void 0 && !(0, t.equalBytes)(sr.encode(He[Ne]), sr.encode(ve[Ne])))
          throw new Error(`Cannot change signed field=${Ne}`);
      }
      for (const Ne in Se)
        if (!Ee[Ne]) {
          if (Ce && Ne === "unknown")
            continue;
          delete Se[Ne];
        }
      return Se;
    }
    s.RawPSBTV0 = u.validate(s._RawPSBTV0, Qe), s.RawPSBTV2 = u.validate(s._RawPSBTV2, Qe);
  }(psbt$1)), psbt$1;
}
var hasRequiredPayment;
function requirePayment() {
  return hasRequiredPayment || (hasRequiredPayment = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s._sortPubkeys = s.p2tr_pk = s.p2tr_ns = s.tapLeafHash = s.TAP_LEAF_VERSION = s.p2ms = s.p2wpkh = s.p2wsh = s.p2sh = s.p2pkh = s.p2pk = s.OutScript = void 0, s.checkScript = Te, s.taprootListToTree = Ne, s.p2tr = nr, s.combinations = fr, s.p2tr_ms = Br, s.getAddress = Fr, s.multisig = qr, s.sortedMultisig = Hr, s.WIF = Qr, s.Address = _r;
    const A = /* @__PURE__ */ requireLib$2(), u = /* @__PURE__ */ requireLib(), p = /* @__PURE__ */ requirePsbt$1(), t = /* @__PURE__ */ requireScript(), l = /* @__PURE__ */ requireUtils$1(), m = /* @__PURE__ */ requireUtils$1(), b = {
      encode(Jr) {
        if (!(Jr.length !== 2 || Jr[0] !== 1 || !l.isBytes(Jr[1]) || A.hex.encode(Jr[1]) !== "4e73"))
          return { type: "p2a", script: t.Script.encode(Jr) };
      },
      decode: (Jr) => {
        if (Jr.type === "p2a")
          return [1, A.hex.decode("4e73")];
      }
    };
    function k(Jr, fn) {
      try {
        return l.validatePubkey(Jr, fn), !0;
      } catch {
        return !1;
      }
    }
    const Ie = [
      b,
      {
        encode(Jr) {
          if (!(Jr.length !== 2 || !l.isBytes(Jr[0]) || !k(Jr[0], l.PubT.ecdsa) || Jr[1] !== "CHECKSIG"))
            return { type: "pk", pubkey: Jr[0] };
        },
        decode: (Jr) => Jr.type === "pk" ? [Jr.pubkey, "CHECKSIG"] : void 0
      },
      {
        encode(Jr) {
          if (!(Jr.length !== 5 || Jr[0] !== "DUP" || Jr[1] !== "HASH160" || !l.isBytes(Jr[2])) && !(Jr[3] !== "EQUALVERIFY" || Jr[4] !== "CHECKSIG"))
            return { type: "pkh", hash: Jr[2] };
        },
        decode: (Jr) => Jr.type === "pkh" ? ["DUP", "HASH160", Jr.hash, "EQUALVERIFY", "CHECKSIG"] : void 0
      },
      {
        encode(Jr) {
          if (!(Jr.length !== 3 || Jr[0] !== "HASH160" || !l.isBytes(Jr[1]) || Jr[2] !== "EQUAL"))
            return { type: "sh", hash: Jr[1] };
        },
        decode: (Jr) => Jr.type === "sh" ? ["HASH160", Jr.hash, "EQUAL"] : void 0
      },
      {
        encode(Jr) {
          if (!(Jr.length !== 2 || Jr[0] !== 0 || !l.isBytes(Jr[1])) && Jr[1].length === 32)
            return { type: "wsh", hash: Jr[1] };
        },
        decode: (Jr) => Jr.type === "wsh" ? [0, Jr.hash] : void 0
      },
      {
        encode(Jr) {
          if (!(Jr.length !== 2 || Jr[0] !== 0 || !l.isBytes(Jr[1])) && Jr[1].length === 20)
            return { type: "wpkh", hash: Jr[1] };
        },
        decode: (Jr) => Jr.type === "wpkh" ? [0, Jr.hash] : void 0
      },
      {
        encode(Jr) {
          const fn = Jr.length - 1;
          if (Jr[fn] !== "CHECKMULTISIG")
            return;
          const jr = Jr[0], dn = Jr[fn - 1];
          if (typeof jr != "number" || typeof dn != "number")
            return;
          const Tn = Jr.slice(1, -2);
          if (dn === Tn.length) {
            for (const Yn of Tn)
              if (!l.isBytes(Yn))
                return;
            return { type: "ms", m: jr, pubkeys: Tn };
          }
        },
        // checkmultisig(n, ..pubkeys, m)
        decode: (Jr) => Jr.type === "ms" ? [Jr.m, ...Jr.pubkeys, Jr.pubkeys.length, "CHECKMULTISIG"] : void 0
      },
      {
        encode(Jr) {
          if (!(Jr.length !== 2 || Jr[0] !== 1 || !l.isBytes(Jr[1])))
            return { type: "tr", pubkey: Jr[1] };
        },
        decode: (Jr) => Jr.type === "tr" ? [1, Jr.pubkey] : void 0
      },
      {
        encode(Jr) {
          const fn = Jr.length - 1;
          if (Jr[fn] !== "CHECKSIG")
            return;
          const jr = [];
          for (let dn = 0; dn < fn; dn++) {
            const Tn = Jr[dn];
            if (dn & 1) {
              if (Tn !== "CHECKSIGVERIFY" || dn === fn - 1)
                return;
              continue;
            }
            if (!l.isBytes(Tn))
              return;
            jr.push(Tn);
          }
          return { type: "tr_ns", pubkeys: jr };
        },
        decode: (Jr) => {
          if (Jr.type !== "tr_ns")
            return;
          const fn = [];
          for (let jr = 0; jr < Jr.pubkeys.length - 1; jr++)
            fn.push(Jr.pubkeys[jr], "CHECKSIGVERIFY");
          return fn.push(Jr.pubkeys[Jr.pubkeys.length - 1], "CHECKSIG"), fn;
        }
      },
      {
        encode(Jr) {
          const fn = Jr.length - 1;
          if (Jr[fn] !== "NUMEQUAL" || Jr[1] !== "CHECKSIG")
            return;
          const jr = [], dn = (0, t.OpToNum)(Jr[fn - 1]);
          if (typeof dn == "number") {
            for (let Tn = 0; Tn < fn - 1; Tn++) {
              const Yn = Jr[Tn];
              if (Tn & 1) {
                if (Yn !== (Tn === 1 ? "CHECKSIG" : "CHECKSIGADD"))
                  throw new Error("OutScript.encode/tr_ms: wrong element");
                continue;
              }
              if (!l.isBytes(Yn))
                throw new Error("OutScript.encode/tr_ms: wrong key element");
              jr.push(Yn);
            }
            return { type: "tr_ms", pubkeys: jr, m: dn };
          }
        },
        decode: (Jr) => {
          if (Jr.type !== "tr_ms")
            return;
          const fn = [Jr.pubkeys[0], "CHECKSIG"];
          for (let jr = 1; jr < Jr.pubkeys.length; jr++)
            fn.push(Jr.pubkeys[jr], "CHECKSIGADD");
          return fn.push(Jr.m, "NUMEQUAL"), fn;
        }
      },
      {
        encode(Jr) {
          return { type: "unknown", script: t.Script.encode(Jr) };
        },
        decode: (Jr) => Jr.type === "unknown" ? t.Script.decode(Jr.script) : void 0
      }
    ], be = u.apply(t.Script, u.coders.match(Ie));
    s.OutScript = u.validate(be, (Jr) => {
      if (Jr.type === "pk" && !k(Jr.pubkey, l.PubT.ecdsa))
        throw new Error("OutScript/pk: wrong key");
      if ((Jr.type === "pkh" || Jr.type === "sh" || Jr.type === "wpkh") && (!l.isBytes(Jr.hash) || Jr.hash.length !== 20))
        throw new Error(`OutScript/${Jr.type}: wrong hash`);
      if (Jr.type === "wsh" && (!l.isBytes(Jr.hash) || Jr.hash.length !== 32))
        throw new Error("OutScript/wsh: wrong hash");
      if (Jr.type === "tr" && (!l.isBytes(Jr.pubkey) || !k(Jr.pubkey, l.PubT.schnorr)))
        throw new Error("OutScript/tr: wrong taproot public key");
      if ((Jr.type === "ms" || Jr.type === "tr_ns" || Jr.type === "tr_ms") && !Array.isArray(Jr.pubkeys))
        throw new Error("OutScript/multisig: wrong pubkeys array");
      if (Jr.type === "ms") {
        const fn = Jr.pubkeys.length;
        for (const jr of Jr.pubkeys)
          if (!k(jr, l.PubT.ecdsa))
            throw new Error("OutScript/multisig: wrong pubkey");
        if (Jr.m <= 0 || fn > 16 || Jr.m > fn)
          throw new Error("OutScript/multisig: invalid params");
      }
      if (Jr.type === "tr_ns" || Jr.type === "tr_ms") {
        for (const fn of Jr.pubkeys)
          if (!k(fn, l.PubT.schnorr))
            throw new Error(`OutScript/${Jr.type}: wrong pubkey`);
      }
      if (Jr.type === "tr_ms") {
        const fn = Jr.pubkeys.length;
        if (Jr.m <= 0 || fn > 999 || Jr.m > fn)
          throw new Error("OutScript/tr_ms: invalid params");
      }
      return Jr;
    });
    function Pe(Jr, fn) {
      if (!l.equalBytes(Jr.hash, l.sha256(fn)))
        throw new Error("checkScript: wsh wrong witnessScript hash");
      const jr = s.OutScript.decode(fn);
      if (jr.type === "tr" || jr.type === "tr_ns" || jr.type === "tr_ms")
        throw new Error(`checkScript: P2${jr.type} cannot be wrapped in P2SH`);
      if (jr.type === "wpkh" || jr.type === "sh")
        throw new Error(`checkScript: P2${jr.type} cannot be wrapped in P2WSH`);
    }
    function Te(Jr, fn, jr) {
      if (Jr) {
        const dn = s.OutScript.decode(Jr);
        if (dn.type === "tr_ns" || dn.type === "tr_ms" || dn.type === "ms" || dn.type == "pk")
          throw new Error(`checkScript: non-wrapped ${dn.type}`);
        if (dn.type === "sh" && fn) {
          if (!l.equalBytes(dn.hash, l.hash160(fn)))
            throw new Error("checkScript: sh wrong redeemScript hash");
          const Tn = s.OutScript.decode(fn);
          if (Tn.type === "tr" || Tn.type === "tr_ns" || Tn.type === "tr_ms")
            throw new Error(`checkScript: P2${Tn.type} cannot be wrapped in P2SH`);
          if (Tn.type === "sh")
            throw new Error("checkScript: P2SH cannot be wrapped in P2SH");
        }
        dn.type === "wsh" && jr && Pe(dn, jr);
      }
      if (fn) {
        const dn = s.OutScript.decode(fn);
        dn.type === "wsh" && jr && Pe(dn, jr);
      }
    }
    function Qe(Jr) {
      const fn = {};
      for (const jr of Jr) {
        const dn = A.hex.encode(jr);
        if (fn[dn])
          throw new Error(`Multisig: non-uniq pubkey: ${Jr.map(A.hex.encode)}`);
        fn[dn] = !0;
      }
    }
    const xe = (Jr, fn = m.NETWORK) => {
      if (!k(Jr, l.PubT.ecdsa))
        throw new Error("P2PK: invalid publicKey");
      return { type: "pk", script: s.OutScript.encode({ type: "pk", pubkey: Jr }) };
    };
    s.p2pk = xe;
    const Ee = (Jr, fn = m.NETWORK) => {
      if (!k(Jr, l.PubT.ecdsa))
        throw new Error("P2PKH: invalid publicKey");
      const jr = l.hash160(Jr);
      return {
        type: "pkh",
        script: s.OutScript.encode({ type: "pkh", hash: jr }),
        address: _r(fn).encode({ type: "pkh", hash: jr }),
        hash: jr
      };
    };
    s.p2pkh = Ee;
    const He = (Jr, fn = m.NETWORK) => {
      const jr = Jr.script;
      if (!l.isBytes(jr))
        throw new Error(`Wrong script: ${typeof Jr.script}, expected Uint8Array`);
      const dn = l.hash160(jr), Tn = s.OutScript.encode({ type: "sh", hash: dn });
      return Te(Tn, jr, Jr.witnessScript), Jr.witnessScript ? {
        type: "sh",
        redeemScript: jr,
        script: s.OutScript.encode({ type: "sh", hash: dn }),
        address: _r(fn).encode({ type: "sh", hash: dn }),
        hash: dn,
        witnessScript: Jr.witnessScript
      } : {
        type: "sh",
        redeemScript: jr,
        script: s.OutScript.encode({ type: "sh", hash: dn }),
        address: _r(fn).encode({ type: "sh", hash: dn }),
        hash: dn
      };
    };
    s.p2sh = He;
    const ve = (Jr, fn = m.NETWORK) => {
      const jr = Jr.script;
      if (!l.isBytes(jr))
        throw new Error(`Wrong script: ${typeof jr}, expected Uint8Array`);
      const dn = l.sha256(jr), Tn = s.OutScript.encode({ type: "wsh", hash: dn });
      return Te(Tn, void 0, jr), {
        type: "wsh",
        witnessScript: jr,
        script: s.OutScript.encode({ type: "wsh", hash: dn }),
        address: _r(fn).encode({ type: "wsh", hash: dn }),
        hash: dn
      };
    };
    s.p2wsh = ve;
    const we = (Jr, fn = m.NETWORK) => {
      if (!k(Jr, l.PubT.ecdsa))
        throw new Error("P2WPKH: invalid publicKey");
      if (Jr.length === 65)
        throw new Error("P2WPKH: uncompressed public key");
      const jr = l.hash160(Jr);
      return {
        type: "wpkh",
        script: s.OutScript.encode({ type: "wpkh", hash: jr }),
        address: _r(fn).encode({ type: "wpkh", hash: jr }),
        hash: jr
      };
    };
    s.p2wpkh = we;
    const Ce = (Jr, fn, jr = !1) => (jr || Qe(fn), {
      type: "ms",
      script: s.OutScript.encode({ type: "ms", pubkeys: fn, m: Jr })
    });
    s.p2ms = Ce;
    function Se(Jr, fn, jr = !1, dn) {
      const Tn = s.OutScript.decode(Jr);
      if (Tn.type === "unknown") {
        if (dn) {
          const vn = u.apply(t.Script, u.coders.match(dn)).decode(Jr);
          if (vn !== void 0) {
            if (typeof vn.type != "string" || !vn.type.startsWith("tr_"))
              throw new Error(`P2TR: invalid custom type=${vn.type}`);
            return;
          }
        }
        if (jr)
          return;
      }
      if (!["tr_ns", "tr_ms"].includes(Tn.type))
        throw new Error(`P2TR: invalid leaf script=${Tn.type}`);
      const Yn = Tn;
      if (!jr && Yn.pubkeys)
        for (const si of Yn.pubkeys) {
          if (l.equalBytes(si, l.TAPROOT_UNSPENDABLE_KEY))
            throw new Error("Unspendable taproot key in leaf script");
          if (l.equalBytes(si, fn))
            throw new Error("Using P2TR with leaf script with same key as internal key is not supported");
        }
    }
    function Ne(Jr) {
      const fn = Array.from(Jr);
      for (; fn.length >= 2; ) {
        fn.sort((si, vn) => (vn.weight || 1) - (si.weight || 1));
        const dn = fn.pop(), Tn = fn.pop(), Yn = ((Tn == null ? void 0 : Tn.weight) || 1) + ((dn == null ? void 0 : dn.weight) || 1);
        fn.push({
          weight: Yn,
          // Unwrap children array
          // TODO: Very hard to remove any here
          childs: [(Tn == null ? void 0 : Tn.childs) || Tn, (dn == null ? void 0 : dn.childs) || dn]
        });
      }
      const jr = fn[0];
      return (jr == null ? void 0 : jr.childs) || jr;
    }
    function rr(Jr, fn = []) {
      if (!Jr)
        throw new Error("taprootAddPath: empty tree");
      if (Jr.type === "leaf")
        return { ...Jr, path: fn };
      if (Jr.type !== "branch")
        throw new Error(`taprootAddPath: wrong type=${Jr}`);
      return {
        ...Jr,
        path: fn,
        // Left element has right hash in path and otherwise
        left: rr(Jr.left, [Jr.right.hash, ...fn]),
        right: rr(Jr.right, [Jr.left.hash, ...fn])
      };
    }
    function er(Jr) {
      if (!Jr)
        throw new Error("taprootAddPath: empty tree");
      if (Jr.type === "leaf")
        return [Jr];
      if (Jr.type !== "branch")
        throw new Error(`taprootWalkTree: wrong type=${Jr}`);
      return [...er(Jr.left), ...er(Jr.right)];
    }
    function ir(Jr, fn, jr = !1, dn) {
      if (!Jr)
        throw new Error("taprootHashTree: empty tree");
      if (Array.isArray(Jr) && Jr.length === 1 && (Jr = Jr[0]), !Array.isArray(Jr)) {
        const { leafVersion: Cn, script: Xr } = Jr;
        if (Jr.tapLeafScript || Jr.tapMerkleRoot && !l.equalBytes(Jr.tapMerkleRoot, u.EMPTY))
          throw new Error("P2TR: tapRoot leafScript cannot have tree");
        const In = typeof Xr == "string" ? A.hex.decode(Xr) : Xr;
        if (!l.isBytes(In))
          throw new Error(`checkScript: wrong script type=${In}`);
        return Se(In, fn, jr, dn), {
          type: "leaf",
          version: Cn,
          script: In,
          hash: (0, s.tapLeafHash)(In, Cn)
        };
      }
      if (Jr.length !== 2 && (Jr = Ne(Jr)), Jr.length !== 2)
        throw new Error("hashTree: non binary tree!");
      const Tn = ir(Jr[0], fn, jr, dn), Yn = ir(Jr[1], fn, jr, dn);
      let [si, vn] = [Tn.hash, Yn.hash];
      return l.compareBytes(vn, si) === -1 && ([si, vn] = [vn, si]), { type: "branch", left: Tn, right: Yn, hash: l.tagSchnorr("TapBranch", si, vn) };
    }
    s.TAP_LEAF_VERSION = 192;
    const sr = (Jr, fn = s.TAP_LEAF_VERSION) => l.tagSchnorr("TapLeaf", new Uint8Array([fn]), t.VarBytes.encode(Jr));
    s.tapLeafHash = sr;
    function nr(Jr, fn, jr = m.NETWORK, dn = !1, Tn) {
      if (!Jr && !fn)
        throw new Error("p2tr: should have pubKey or scriptTree (or both)");
      const Yn = typeof Jr == "string" ? A.hex.decode(Jr) : Jr || l.TAPROOT_UNSPENDABLE_KEY;
      if (!k(Yn, l.PubT.schnorr))
        throw new Error("p2tr: non-schnorr pubkey");
      if (fn) {
        let si = rr(ir(fn, Yn, dn, Tn));
        const vn = si.hash, [Cn, Xr] = l.taprootTweakPubkey(Yn, vn), In = er(si).map((zr) => ({
          ...zr,
          controlBlock: p.TaprootControlBlock.encode({
            version: (zr.version || s.TAP_LEAF_VERSION) + Xr,
            internalKey: Yn,
            merklePath: zr.path
          })
        }));
        return {
          type: "tr",
          script: s.OutScript.encode({ type: "tr", pubkey: Cn }),
          address: _r(jr).encode({ type: "tr", pubkey: Cn }),
          // For tests
          tweakedPubkey: Cn,
          // PSBT stuff
          tapInternalKey: Yn,
          leaves: In,
          tapLeafScript: In.map((zr) => [
            p.TaprootControlBlock.decode(zr.controlBlock),
            l.concatBytes(zr.script, new Uint8Array([zr.version || s.TAP_LEAF_VERSION]))
          ]),
          tapMerkleRoot: vn
        };
      } else {
        const si = l.taprootTweakPubkey(Yn, u.EMPTY)[0];
        return {
          type: "tr",
          script: s.OutScript.encode({ type: "tr", pubkey: si }),
          address: _r(jr).encode({ type: "tr", pubkey: si }),
          // For tests
          tweakedPubkey: si,
          // PSBT stuff
          tapInternalKey: Yn
        };
      }
    }
    function fr(Jr, fn) {
      const jr = [];
      if (!Array.isArray(fn))
        throw new Error("combinations: lst arg should be array");
      const dn = fn.length;
      if (Jr > dn)
        throw new Error("combinations: m > lst.length, no combinations possible");
      const Tn = Array.from({ length: Jr }, (si, vn) => vn), Yn = Tn.length - 1;
      e: for (; ; ) {
        jr.push(Tn.map((vn) => fn[vn])), Tn[Yn] += 1;
        let si = Yn;
        for (; si >= 0 && Tn[si] > dn - Jr + si; si--) {
          if (Tn[si] = 0, si === 0)
            break e;
          Tn[si - 1] += 1;
        }
        for (si += 1; si < Tn.length; si++)
          Tn[si] = Tn[si - 1] + 1;
      }
      return jr;
    }
    const lr = (Jr, fn, jr = !1) => (jr || Qe(fn), fr(Jr, fn).map((dn) => ({
      type: "tr_ns",
      script: s.OutScript.encode({ type: "tr_ns", pubkeys: dn })
    })));
    s.p2tr_ns = lr;
    const br = (Jr) => (0, s.p2tr_ns)(1, [Jr], void 0)[0];
    s.p2tr_pk = br;
    function Br(Jr, fn, jr = !1) {
      return jr || Qe(fn), {
        type: "tr_ms",
        script: s.OutScript.encode({ type: "tr_ms", pubkeys: fn, m: Jr })
      };
    }
    function Fr(Jr, fn, jr = m.NETWORK) {
      if (Jr === "tr")
        return nr(l.pubSchnorr(fn), void 0, jr).address;
      const dn = l.pubECDSA(fn);
      if (Jr === "pkh")
        return (0, s.p2pkh)(dn, jr).address;
      if (Jr === "wpkh")
        return (0, s.p2wpkh)(dn, jr).address;
      throw new Error(`getAddress: unknown type=${Jr}`);
    }
    const Gr = (Jr) => Array.from(Jr).sort(l.compareBytes);
    s._sortPubkeys = Gr;
    function qr(Jr, fn, jr = !1, dn = !1, Tn = m.NETWORK) {
      const Yn = (0, s.p2ms)(Jr, jr ? (0, s._sortPubkeys)(fn) : fn);
      return dn ? (0, s.p2wsh)(Yn, Tn) : (0, s.p2sh)(Yn, Tn);
    }
    function Hr(Jr, fn, jr = !1, dn = m.NETWORK) {
      return qr(Jr, fn, !0, jr, dn);
    }
    const un = (0, A.createBase58check)(l.sha256);
    function Dr(Jr, fn) {
      if (fn.length < 2 || fn.length > 40)
        throw new Error("Witness: invalid length");
      if (Jr > 16)
        throw new Error("Witness: invalid version");
      if (Jr === 0 && !(fn.length === 20 || fn.length === 32))
        throw new Error("Witness: invalid length for version");
    }
    function wr(Jr, fn, jr = m.NETWORK) {
      Dr(Jr, fn);
      const dn = Jr === 0 ? A.bech32 : A.bech32m;
      return dn.encode(jr.bech32, [Jr].concat(dn.toWords(fn)));
    }
    function yr(Jr, fn) {
      return un.encode(l.concatBytes(Uint8Array.from(fn), Jr));
    }
    function Qr(Jr = m.NETWORK) {
      return {
        encode(fn) {
          const jr = l.concatBytes(fn, new Uint8Array([1]));
          return yr(jr.subarray(0, 33), [Jr.wif]);
        },
        decode(fn) {
          let jr = un.decode(fn);
          if (jr[0] !== Jr.wif)
            throw new Error("Wrong WIF prefix");
          if (jr = jr.subarray(1), jr.length !== 33)
            throw new Error("Wrong WIF length");
          if (jr[32] !== 1)
            throw new Error("Wrong WIF postfix");
          return jr.subarray(0, -1);
        }
      };
    }
    function _r(Jr = m.NETWORK) {
      return {
        encode(fn) {
          const { type: jr } = fn;
          if (jr === "wpkh")
            return wr(0, fn.hash, Jr);
          if (jr === "wsh")
            return wr(0, fn.hash, Jr);
          if (jr === "tr")
            return wr(1, fn.pubkey, Jr);
          if (jr === "pkh")
            return yr(fn.hash, [Jr.pubKeyHash]);
          if (jr === "sh")
            return yr(fn.hash, [Jr.scriptHash]);
          throw new Error(`Unknown address type=${jr}`);
        },
        decode(fn) {
          if (fn.length < 14 || fn.length > 74)
            throw new Error("Invalid address length");
          if (Jr.bech32 && fn.toLowerCase().startsWith(`${Jr.bech32}1`)) {
            let dn;
            try {
              if (dn = A.bech32.decode(fn), dn.words[0] !== 0)
                throw new Error(`bech32: wrong version=${dn.words[0]}`);
            } catch {
              if (dn = A.bech32m.decode(fn), dn.words[0] === 0)
                throw new Error(`bech32m: wrong version=${dn.words[0]}`);
            }
            if (dn.prefix !== Jr.bech32)
              throw new Error(`wrong bech32 prefix=${dn.prefix}`);
            const [Tn, ...Yn] = dn.words, si = A.bech32.fromWords(Yn);
            if (Dr(Tn, si), Tn === 0 && si.length === 32)
              return { type: "wsh", hash: si };
            if (Tn === 0 && si.length === 20)
              return { type: "wpkh", hash: si };
            if (Tn === 1 && si.length === 32)
              return { type: "tr", pubkey: si };
            throw new Error("Unknown witness program");
          }
          const jr = un.decode(fn);
          if (jr.length !== 21)
            throw new Error("Invalid base58 address");
          if (jr[0] === Jr.pubKeyHash)
            return { type: "pkh", hash: jr.slice(1) };
          if (jr[0] === Jr.scriptHash)
            return {
              type: "sh",
              hash: jr.slice(1)
            };
          throw new Error(`Invalid address prefix=${jr[0]}`);
        }
      };
    }
  }(payment)), payment;
}
var transaction = {}, hasRequiredTransaction;
function requireTransaction() {
  return hasRequiredTransaction || (hasRequiredTransaction = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.Transaction = s.SigHash = s.SignatureHash = s.def = s.Decimal = s.DEFAULT_SEQUENCE = s.DEFAULT_LOCKTIME = s.DEFAULT_VERSION = s.PRECISION = s.toVsize = void 0, s.cloneDeep = P, s.inputBeforeSign = ge, s.getPrevOut = xe, s.normalizeInput = Ee, s.getInputType = He, s.PSBTCombine = we, s.bip32Path = Se;
    const A = /* @__PURE__ */ requireLib$2(), u = /* @__PURE__ */ requireLib(), p = /* @__PURE__ */ requirePayment(), t = /* @__PURE__ */ requirePsbt$1(), l = /* @__PURE__ */ requireScript(), m = /* @__PURE__ */ requireUtils$1(), b = /* @__PURE__ */ requireUtils$1(), k = new Uint8Array(32), C = {
      amount: 0xffffffffffffffffn,
      script: u.EMPTY
    }, B = (Ne) => Math.ceil(Ne / 4);
    s.toVsize = B, s.PRECISION = 8, s.DEFAULT_VERSION = 2, s.DEFAULT_LOCKTIME = 0, s.DEFAULT_SEQUENCE = 4294967295, s.Decimal = u.coders.decimal(s.PRECISION);
    const Q = (Ne, rr) => Ne === void 0 ? rr : Ne;
    s.def = Q;
    function P(Ne) {
      if (Array.isArray(Ne))
        return Ne.map((rr) => P(rr));
      if ((0, b.isBytes)(Ne))
        return Uint8Array.from(Ne);
      if (["number", "bigint", "boolean", "string", "undefined"].includes(typeof Ne))
        return Ne;
      if (Ne === null)
        return Ne;
      if (typeof Ne == "object")
        return Object.fromEntries(Object.entries(Ne).map(([rr, er]) => [rr, P(er)]));
      throw new Error(`cloneDeep: unknown type=${Ne} (${typeof Ne})`);
    }
    var x;
    (function(Ne) {
      Ne[Ne.DEFAULT = 0] = "DEFAULT", Ne[Ne.ALL = 1] = "ALL", Ne[Ne.NONE = 2] = "NONE", Ne[Ne.SINGLE = 3] = "SINGLE", Ne[Ne.ANYONECANPAY = 128] = "ANYONECANPAY";
    })(x || (s.SignatureHash = x = {}));
    var M;
    (function(Ne) {
      Ne[Ne.DEFAULT = 0] = "DEFAULT", Ne[Ne.ALL = 1] = "ALL", Ne[Ne.NONE = 2] = "NONE", Ne[Ne.SINGLE = 3] = "SINGLE", Ne[Ne.DEFAULT_ANYONECANPAY = 128] = "DEFAULT_ANYONECANPAY", Ne[Ne.ALL_ANYONECANPAY = 129] = "ALL_ANYONECANPAY", Ne[Ne.NONE_ANYONECANPAY = 130] = "NONE_ANYONECANPAY", Ne[Ne.SINGLE_ANYONECANPAY = 131] = "SINGLE_ANYONECANPAY";
    })(M || (s.SigHash = M = {}));
    function F(Ne, rr, er, ir = u.EMPTY) {
      return (0, b.equalBytes)(er, rr) && (Ne = m.taprootTweakPrivKey(Ne, ir), rr = m.pubSchnorr(Ne)), { privKey: Ne, pubKey: rr };
    }
    function le(Ne) {
      if (Ne.script === void 0 || Ne.amount === void 0)
        throw new Error("Transaction/output: script and amount required");
      return { script: Ne.script, amount: Ne.amount };
    }
    function ge(Ne) {
      if (Ne.txid === void 0 || Ne.index === void 0)
        throw new Error("Transaction/input: txid and index required");
      return {
        txid: Ne.txid,
        index: Ne.index,
        sequence: (0, s.def)(Ne.sequence, s.DEFAULT_SEQUENCE),
        finalScriptSig: (0, s.def)(Ne.finalScriptSig, u.EMPTY)
      };
    }
    function pe(Ne) {
      for (const rr in Ne) {
        const er = rr;
        t.PSBTInputFinalKeys.includes(er) || delete Ne[er];
      }
    }
    const Ie = u.struct({ txid: u.bytes(32, !0), index: u.U32LE });
    function be(Ne) {
      if (typeof Ne != "number" || typeof M[Ne] != "string")
        throw new Error(`Invalid SigHash=${Ne}`);
      return Ne;
    }
    function Pe(Ne) {
      const rr = Ne & 31;
      return {
        isAny: !!(Ne & x.ANYONECANPAY),
        isNone: rr === x.NONE,
        isSingle: rr === x.SINGLE
      };
    }
    function Te(Ne) {
      if (Ne !== void 0 && {}.toString.call(Ne) !== "[object Object]")
        throw new Error(`Wrong object type for transaction options: ${Ne}`);
      const rr = {
        ...Ne,
        // Defaults
        version: (0, s.def)(Ne.version, s.DEFAULT_VERSION),
        lockTime: (0, s.def)(Ne.lockTime, 0),
        PSBTVersion: (0, s.def)(Ne.PSBTVersion, 0)
      };
      if (typeof rr.allowUnknowInput < "u" && (Ne.allowUnknownInputs = rr.allowUnknowInput), typeof rr.allowUnknowOutput < "u" && (Ne.allowUnknownOutputs = rr.allowUnknowOutput), typeof rr.lockTime != "number")
        throw new Error("Transaction lock time should be number");
      if (u.U32LE.encode(rr.lockTime), rr.PSBTVersion !== 0 && rr.PSBTVersion !== 2)
        throw new Error(`Unknown PSBT version ${rr.PSBTVersion}`);
      for (const er of [
        "allowUnknownVersion",
        "allowUnknownOutputs",
        "allowUnknownInputs",
        "disableScriptCheck",
        "bip174jsCompat",
        "allowLegacyWitnessUtxo",
        "lowR"
      ]) {
        const ir = rr[er];
        if (ir !== void 0 && typeof ir != "boolean")
          throw new Error(`Transation options wrong type: ${er}=${ir} (${typeof ir})`);
      }
      if (rr.allowUnknownVersion ? typeof rr.version == "number" : ![-1, 0, 1, 2, 3].includes(rr.version))
        throw new Error(`Unknown version: ${rr.version}`);
      if (rr.customScripts !== void 0) {
        const er = rr.customScripts;
        if (!Array.isArray(er))
          throw new Error(`wrong custom scripts type (expected array): customScripts=${er} (${typeof er})`);
        for (const ir of er) {
          if (typeof ir.encode != "function" || typeof ir.decode != "function")
            throw new Error(`wrong script=${ir} (${typeof ir})`);
          if (ir.finalizeTaproot !== void 0 && typeof ir.finalizeTaproot != "function")
            throw new Error(`wrong script=${ir} (${typeof ir})`);
        }
      }
      return Object.freeze(rr);
    }
    function Qe(Ne) {
      if (Ne.nonWitnessUtxo && Ne.index !== void 0) {
        const rr = Ne.nonWitnessUtxo.outputs.length - 1;
        if (Ne.index > rr)
          throw new Error(`validateInput: index(${Ne.index}) not in nonWitnessUtxo`);
        const er = Ne.nonWitnessUtxo.outputs[Ne.index];
        if (Ne.witnessUtxo && (!(0, b.equalBytes)(Ne.witnessUtxo.script, er.script) || Ne.witnessUtxo.amount !== er.amount))
          throw new Error("validateInput: witnessUtxo different from nonWitnessUtxo");
        if (Ne.txid) {
          if (Ne.nonWitnessUtxo.outputs.length - 1 < Ne.index)
            throw new Error("nonWitnessUtxo: incorect output index");
          const sr = ve.fromRaw(l.RawTx.encode(Ne.nonWitnessUtxo), {
            allowUnknownOutputs: !0,
            disableScriptCheck: !0,
            allowUnknownInputs: !0
          }), nr = A.hex.encode(Ne.txid);
          if (sr.isFinal && sr.id !== nr)
            throw new Error(`nonWitnessUtxo: wrong txid, exp=${nr} got=${sr.id}`);
        }
      }
      return Ne;
    }
    function xe(Ne) {
      if (Ne.nonWitnessUtxo) {
        if (Ne.index === void 0)
          throw new Error("Unknown input index");
        return Ne.nonWitnessUtxo.outputs[Ne.index];
      } else {
        if (Ne.witnessUtxo)
          return Ne.witnessUtxo;
        throw new Error("Cannot find previous output info");
      }
    }
    function Ee(Ne, rr, er, ir = !1, sr = !1) {
      let { nonWitnessUtxo: nr, txid: fr } = Ne;
      typeof nr == "string" && (nr = A.hex.decode(nr)), (0, b.isBytes)(nr) && (nr = l.RawTx.decode(nr)), !("nonWitnessUtxo" in Ne) && nr === void 0 && (nr = rr == null ? void 0 : rr.nonWitnessUtxo), typeof fr == "string" && (fr = A.hex.decode(fr)), fr === void 0 && (fr = rr == null ? void 0 : rr.txid);
      let lr = { ...rr, ...Ne, nonWitnessUtxo: nr, txid: fr };
      !("nonWitnessUtxo" in Ne) && lr.nonWitnessUtxo === void 0 && delete lr.nonWitnessUtxo, lr.sequence === void 0 && (lr.sequence = s.DEFAULT_SEQUENCE), lr.tapMerkleRoot === null && delete lr.tapMerkleRoot, lr = t.mergeKeyMap(t.PSBTInput, lr, rr, er, sr), t.PSBTInputCoder.encode(lr);
      let br;
      return lr.nonWitnessUtxo && lr.index !== void 0 ? br = lr.nonWitnessUtxo.outputs[lr.index] : lr.witnessUtxo && (br = lr.witnessUtxo), br && !ir && (0, p.checkScript)(br && br.script, lr.redeemScript, lr.witnessScript), lr;
    }
    function He(Ne, rr = !1) {
      let er = "legacy", ir = x.ALL;
      const sr = xe(Ne), nr = p.OutScript.decode(sr.script);
      let fr = nr.type, lr = nr;
      const br = [nr];
      if (nr.type === "tr")
        return ir = x.DEFAULT, {
          txType: "taproot",
          type: "tr",
          last: nr,
          lastScript: sr.script,
          defaultSighash: ir,
          sighash: Ne.sighashType || ir
        };
      {
        if ((nr.type === "wpkh" || nr.type === "wsh") && (er = "segwit"), nr.type === "sh") {
          if (!Ne.redeemScript)
            throw new Error("inputType: sh without redeemScript");
          let qr = p.OutScript.decode(Ne.redeemScript);
          (qr.type === "wpkh" || qr.type === "wsh") && (er = "segwit"), br.push(qr), lr = qr, fr += `-${qr.type}`;
        }
        if (lr.type === "wsh") {
          if (!Ne.witnessScript)
            throw new Error("inputType: wsh without witnessScript");
          let qr = p.OutScript.decode(Ne.witnessScript);
          qr.type === "wsh" && (er = "segwit"), br.push(qr), lr = qr, fr += `-${qr.type}`;
        }
        const Br = br[br.length - 1];
        if (Br.type === "sh" || Br.type === "wsh")
          throw new Error("inputType: sh/wsh cannot be terminal type");
        const Fr = p.OutScript.encode(Br), Gr = {
          type: fr,
          txType: er,
          last: Br,
          lastScript: Fr,
          defaultSighash: ir,
          sighash: Ne.sighashType || ir
        };
        if (er === "legacy" && !rr && !Ne.nonWitnessUtxo)
          throw new Error("Transaction/sign: legacy input without nonWitnessUtxo, can result in attack that forces paying higher fees. Pass allowLegacyWitnessUtxo=true, if you sure");
        return Gr;
      }
    }
    class ve {
      constructor(rr = {}) {
        this.global = {}, this.inputs = [], this.outputs = [];
        const er = this.opts = Te(rr);
        er.lockTime !== s.DEFAULT_LOCKTIME && (this.global.fallbackLocktime = er.lockTime), this.global.txVersion = er.version;
      }
      // Import
      static fromRaw(rr, er = {}) {
        const ir = l.RawTx.decode(rr), sr = new ve({ ...er, version: ir.version, lockTime: ir.lockTime });
        for (const nr of ir.outputs)
          sr.addOutput(nr);
        if (sr.outputs = ir.outputs, sr.inputs = ir.inputs, ir.witnesses)
          for (let nr = 0; nr < ir.witnesses.length; nr++)
            sr.inputs[nr].finalScriptWitness = ir.witnesses[nr];
        return sr;
      }
      // PSBT
      static fromPSBT(rr, er = {}) {
        let ir;
        try {
          ir = t.RawPSBTV0.decode(rr);
        } catch (Gr) {
          try {
            ir = t.RawPSBTV2.decode(rr);
          } catch {
            throw Gr;
          }
        }
        const sr = ir.global.version || 0;
        if (sr !== 0 && sr !== 2)
          throw new Error(`Wrong PSBT version=${sr}`);
        const nr = ir.global.unsignedTx, fr = sr === 0 ? nr == null ? void 0 : nr.version : ir.global.txVersion, lr = sr === 0 ? nr == null ? void 0 : nr.lockTime : ir.global.fallbackLocktime, br = new ve({ ...er, version: fr, lockTime: lr, PSBTVersion: sr }), Br = sr === 0 ? nr == null ? void 0 : nr.inputs.length : ir.global.inputCount;
        br.inputs = ir.inputs.slice(0, Br).map((Gr, qr) => {
          var Hr;
          return Qe({
            finalScriptSig: u.EMPTY,
            ...(Hr = ir.global.unsignedTx) == null ? void 0 : Hr.inputs[qr],
            ...Gr
          });
        });
        const Fr = sr === 0 ? nr == null ? void 0 : nr.outputs.length : ir.global.outputCount;
        return br.outputs = ir.outputs.slice(0, Fr).map((Gr, qr) => {
          var Hr;
          return {
            ...Gr,
            ...(Hr = ir.global.unsignedTx) == null ? void 0 : Hr.outputs[qr]
          };
        }), br.global = { ...ir.global, txVersion: fr }, lr !== s.DEFAULT_LOCKTIME && (br.global.fallbackLocktime = lr), br;
      }
      toPSBT(rr = this.opts.PSBTVersion) {
        if (rr !== 0 && rr !== 2)
          throw new Error(`Wrong PSBT version=${rr}`);
        const er = this.inputs.map((nr) => Qe(t.cleanPSBTFields(rr, t.PSBTInput, nr)));
        for (const nr of er)
          nr.partialSig && !nr.partialSig.length && delete nr.partialSig, nr.finalScriptSig && !nr.finalScriptSig.length && delete nr.finalScriptSig, nr.finalScriptWitness && !nr.finalScriptWitness.length && delete nr.finalScriptWitness;
        const ir = this.outputs.map((nr) => t.cleanPSBTFields(rr, t.PSBTOutput, nr)), sr = { ...this.global };
        return rr === 0 ? (sr.unsignedTx = l.RawOldTx.decode(l.RawOldTx.encode({
          version: this.version,
          lockTime: this.lockTime,
          inputs: this.inputs.map(ge).map((nr) => ({
            ...nr,
            finalScriptSig: u.EMPTY
          })),
          outputs: this.outputs.map(le)
        })), delete sr.fallbackLocktime, delete sr.txVersion) : (sr.version = rr, sr.txVersion = this.version, sr.inputCount = this.inputs.length, sr.outputCount = this.outputs.length, sr.fallbackLocktime && sr.fallbackLocktime === s.DEFAULT_LOCKTIME && delete sr.fallbackLocktime), this.opts.bip174jsCompat && (er.length || er.push({}), ir.length || ir.push({})), (rr === 0 ? t.RawPSBTV0 : t.RawPSBTV2).encode({
          global: sr,
          inputs: er,
          outputs: ir
        });
      }
      // BIP370 lockTime (https://github.com/bitcoin/bips/blob/master/bip-0370.mediawiki#determining-lock-time)
      get lockTime() {
        let rr = s.DEFAULT_LOCKTIME, er = 0, ir = s.DEFAULT_LOCKTIME, sr = 0;
        for (const nr of this.inputs)
          nr.requiredHeightLocktime && (rr = Math.max(rr, nr.requiredHeightLocktime), er++), nr.requiredTimeLocktime && (ir = Math.max(ir, nr.requiredTimeLocktime), sr++);
        return er && er >= sr ? rr : ir !== s.DEFAULT_LOCKTIME ? ir : this.global.fallbackLocktime || s.DEFAULT_LOCKTIME;
      }
      get version() {
        if (this.global.txVersion === void 0)
          throw new Error("No global.txVersion");
        return this.global.txVersion;
      }
      inputStatus(rr) {
        this.checkInputIdx(rr);
        const er = this.inputs[rr];
        return er.finalScriptSig && er.finalScriptSig.length || er.finalScriptWitness && er.finalScriptWitness.length ? "finalized" : er.tapKeySig || er.tapScriptSig && er.tapScriptSig.length || er.partialSig && er.partialSig.length ? "signed" : "unsigned";
      }
      // Cannot replace unpackSighash, tests rely on very generic implemenetation with signing inputs outside of range
      // We will lose some vectors -> smaller test coverage of preimages (very important!)
      inputSighash(rr) {
        this.checkInputIdx(rr);
        const er = this.inputs[rr].sighashType, ir = er === void 0 ? x.DEFAULT : er, sr = ir === x.DEFAULT ? x.ALL : ir & 3;
        return { sigInputs: ir & x.ANYONECANPAY, sigOutputs: sr };
      }
      // Very nice for debug purposes, but slow. If there is too much inputs/outputs to add, will be quadratic.
      // Some cache will be nice, but there chance to have bugs with cache invalidation
      signStatus() {
        let rr = !0, er = !0, ir = [], sr = [];
        for (let nr = 0; nr < this.inputs.length; nr++) {
          if (this.inputStatus(nr) === "unsigned")
            continue;
          const { sigInputs: lr, sigOutputs: br } = this.inputSighash(nr);
          if (lr === x.ANYONECANPAY ? ir.push(nr) : rr = !1, br === x.ALL)
            er = !1;
          else if (br === x.SINGLE)
            sr.push(nr);
          else if (br !== x.NONE) throw new Error(`Wrong signature hash output type: ${br}`);
        }
        return { addInput: rr, addOutput: er, inputs: ir, outputs: sr };
      }
      get isFinal() {
        for (let rr = 0; rr < this.inputs.length; rr++)
          if (this.inputStatus(rr) !== "finalized")
            return !1;
        return !0;
      }
      // Info utils
      get hasWitnesses() {
        let rr = !1;
        for (const er of this.inputs)
          er.finalScriptWitness && er.finalScriptWitness.length && (rr = !0);
        return rr;
      }
      // https://en.bitcoin.it/wiki/Weight_units
      get weight() {
        if (!this.isFinal)
          throw new Error("Transaction is not finalized");
        let rr = 32;
        const er = this.outputs.map(le);
        rr += 4 * l.CompactSizeLen.encode(this.outputs.length).length;
        for (const ir of er)
          rr += 32 + 4 * l.VarBytes.encode(ir.script).length;
        this.hasWitnesses && (rr += 2), rr += 4 * l.CompactSizeLen.encode(this.inputs.length).length;
        for (const ir of this.inputs)
          rr += 160 + 4 * l.VarBytes.encode(ir.finalScriptSig || u.EMPTY).length, this.hasWitnesses && ir.finalScriptWitness && (rr += l.RawWitness.encode(ir.finalScriptWitness).length);
        return rr;
      }
      get vsize() {
        return (0, s.toVsize)(this.weight);
      }
      toBytes(rr = !1, er = !1) {
        return l.RawTx.encode({
          version: this.version,
          lockTime: this.lockTime,
          inputs: this.inputs.map(ge).map((ir) => ({
            ...ir,
            finalScriptSig: rr && ir.finalScriptSig || u.EMPTY
          })),
          outputs: this.outputs.map(le),
          witnesses: this.inputs.map((ir) => ir.finalScriptWitness || []),
          segwitFlag: er && this.hasWitnesses
        });
      }
      get unsignedTx() {
        return this.toBytes(!1, !1);
      }
      get hex() {
        return A.hex.encode(this.toBytes(!0, this.hasWitnesses));
      }
      get hash() {
        if (!this.isFinal)
          throw new Error("Transaction is not finalized");
        return A.hex.encode(m.sha256x2(this.toBytes(!0)));
      }
      get id() {
        if (!this.isFinal)
          throw new Error("Transaction is not finalized");
        return A.hex.encode(m.sha256x2(this.toBytes(!0)).reverse());
      }
      // Input stuff
      checkInputIdx(rr) {
        if (!Number.isSafeInteger(rr) || 0 > rr || rr >= this.inputs.length)
          throw new Error(`Wrong input index=${rr}`);
      }
      getInput(rr) {
        return this.checkInputIdx(rr), P(this.inputs[rr]);
      }
      get inputsLength() {
        return this.inputs.length;
      }
      // Modification
      addInput(rr, er = !1) {
        if (!er && !this.signStatus().addInput)
          throw new Error("Tx has signed inputs, cannot add new one");
        return this.inputs.push(Ee(rr, void 0, void 0, this.opts.disableScriptCheck)), this.inputs.length - 1;
      }
      updateInput(rr, er, ir = !1) {
        this.checkInputIdx(rr);
        let sr;
        if (!ir) {
          const nr = this.signStatus();
          (!nr.addInput || nr.inputs.includes(rr)) && (sr = t.PSBTInputUnsignedKeys);
        }
        this.inputs[rr] = Ee(er, this.inputs[rr], sr, this.opts.disableScriptCheck, this.opts.allowUnknown);
      }
      // Output stuff
      checkOutputIdx(rr) {
        if (!Number.isSafeInteger(rr) || 0 > rr || rr >= this.outputs.length)
          throw new Error(`Wrong output index=${rr}`);
      }
      getOutput(rr) {
        return this.checkOutputIdx(rr), P(this.outputs[rr]);
      }
      getOutputAddress(rr, er = b.NETWORK) {
        const ir = this.getOutput(rr);
        if (ir.script)
          return (0, p.Address)(er).encode(p.OutScript.decode(ir.script));
      }
      get outputsLength() {
        return this.outputs.length;
      }
      normalizeOutput(rr, er, ir) {
        let { amount: sr, script: nr } = rr;
        if (sr === void 0 && (sr = er == null ? void 0 : er.amount), typeof sr != "bigint")
          throw new Error(`Wrong amount type, should be of type bigint in sats, but got ${sr} of type ${typeof sr}`);
        typeof nr == "string" && (nr = A.hex.decode(nr)), nr === void 0 && (nr = er == null ? void 0 : er.script);
        let fr = { ...er, ...rr, amount: sr, script: nr };
        if (fr.amount === void 0 && delete fr.amount, fr = t.mergeKeyMap(t.PSBTOutput, fr, er, ir, this.opts.allowUnknown), t.PSBTOutputCoder.encode(fr), fr.script && !this.opts.allowUnknownOutputs && p.OutScript.decode(fr.script).type === "unknown")
          throw new Error("Transaction/output: unknown output script type, there is a chance that input is unspendable. Pass allowUnknownOutputs=true, if you sure");
        return this.opts.disableScriptCheck || (0, p.checkScript)(fr.script, fr.redeemScript, fr.witnessScript), fr;
      }
      addOutput(rr, er = !1) {
        if (!er && !this.signStatus().addOutput)
          throw new Error("Tx has signed outputs, cannot add new one");
        return this.outputs.push(this.normalizeOutput(rr)), this.outputs.length - 1;
      }
      updateOutput(rr, er, ir = !1) {
        this.checkOutputIdx(rr);
        let sr;
        if (!ir) {
          const nr = this.signStatus();
          (!nr.addOutput || nr.outputs.includes(rr)) && (sr = t.PSBTOutputUnsignedKeys);
        }
        this.outputs[rr] = this.normalizeOutput(er, this.outputs[rr], sr);
      }
      addOutputAddress(rr, er, ir = b.NETWORK) {
        return this.addOutput({ script: p.OutScript.encode((0, p.Address)(ir).decode(rr)), amount: er });
      }
      // Utils
      get fee() {
        let rr = 0n;
        for (const ir of this.inputs) {
          const sr = xe(ir);
          if (!sr)
            throw new Error("Empty input amount");
          rr += sr.amount;
        }
        const er = this.outputs.map(le);
        for (const ir of er)
          rr -= ir.amount;
        return rr;
      }
      // Signing
      // Based on https://github.com/bitcoin/bitcoin/blob/5871b5b5ab57a0caf9b7514eb162c491c83281d5/test/functional/test_framework/script.py#L624
      // There is optimization opportunity to re-use hashes for multiple inputs for witness v0/v1,
      // but we are trying to be less complicated for audit purpose for now.
      preimageLegacy(rr, er, ir) {
        const { isAny: sr, isNone: nr, isSingle: fr } = Pe(ir);
        if (rr < 0 || !Number.isSafeInteger(rr))
          throw new Error(`Invalid input idx=${rr}`);
        if (fr && rr >= this.outputs.length || rr >= this.inputs.length)
          return u.U256BE.encode(1n);
        er = l.Script.encode(l.Script.decode(er).filter((Fr) => Fr !== "CODESEPARATOR"));
        let lr = this.inputs.map(ge).map((Fr, Gr) => ({
          ...Fr,
          finalScriptSig: Gr === rr ? er : u.EMPTY
        }));
        sr ? lr = [lr[rr]] : (nr || fr) && (lr = lr.map((Fr, Gr) => ({
          ...Fr,
          sequence: Gr === rr ? Fr.sequence : 0
        })));
        let br = this.outputs.map(le);
        nr ? br = [] : fr && (br = br.slice(0, rr).fill(C).concat([br[rr]]));
        const Br = l.RawTx.encode({
          lockTime: this.lockTime,
          version: this.version,
          segwitFlag: !1,
          inputs: lr,
          outputs: br
        });
        return m.sha256x2(Br, u.I32LE.encode(ir));
      }
      preimageWitnessV0(rr, er, ir, sr) {
        const { isAny: nr, isNone: fr, isSingle: lr } = Pe(ir);
        let br = k, Br = k, Fr = k;
        const Gr = this.inputs.map(ge), qr = this.outputs.map(le);
        nr || (br = m.sha256x2(...Gr.map(Ie.encode))), !nr && !lr && !fr && (Br = m.sha256x2(...Gr.map((un) => u.U32LE.encode(un.sequence)))), !lr && !fr ? Fr = m.sha256x2(...qr.map(l.RawOutput.encode)) : lr && rr < qr.length && (Fr = m.sha256x2(l.RawOutput.encode(qr[rr])));
        const Hr = Gr[rr];
        return m.sha256x2(u.I32LE.encode(this.version), br, Br, u.bytes(32, !0).encode(Hr.txid), u.U32LE.encode(Hr.index), l.VarBytes.encode(er), u.U64LE.encode(sr), u.U32LE.encode(Hr.sequence), Fr, u.U32LE.encode(this.lockTime), u.U32LE.encode(ir));
      }
      preimageWitnessV1(rr, er, ir, sr, nr = -1, fr, lr = 192, br) {
        if (!Array.isArray(sr) || this.inputs.length !== sr.length)
          throw new Error(`Invalid amounts array=${sr}`);
        if (!Array.isArray(er) || this.inputs.length !== er.length)
          throw new Error(`Invalid prevOutScript array=${er}`);
        const Br = [
          u.U8.encode(0),
          u.U8.encode(ir),
          // U8 sigHash
          u.I32LE.encode(this.version),
          u.U32LE.encode(this.lockTime)
        ], Fr = ir === x.DEFAULT ? x.ALL : ir & 3, Gr = ir & x.ANYONECANPAY, qr = this.inputs.map(ge), Hr = this.outputs.map(le);
        Gr !== x.ANYONECANPAY && Br.push(...[
          qr.map(Ie.encode),
          sr.map(u.U64LE.encode),
          er.map(l.VarBytes.encode),
          qr.map((Dr) => u.U32LE.encode(Dr.sequence))
        ].map((Dr) => m.sha256((0, b.concatBytes)(...Dr)))), Fr === x.ALL && Br.push(m.sha256((0, b.concatBytes)(...Hr.map(l.RawOutput.encode))));
        const un = (br ? 1 : 0) | (fr ? 2 : 0);
        if (Br.push(new Uint8Array([un])), Gr === x.ANYONECANPAY) {
          const Dr = qr[rr];
          Br.push(Ie.encode(Dr), u.U64LE.encode(sr[rr]), l.VarBytes.encode(er[rr]), u.U32LE.encode(Dr.sequence));
        } else
          Br.push(u.U32LE.encode(rr));
        return un & 1 && Br.push(m.sha256(l.VarBytes.encode(br || u.EMPTY))), Fr === x.SINGLE && Br.push(rr < Hr.length ? m.sha256(l.RawOutput.encode(Hr[rr])) : k), fr && Br.push((0, p.tapLeafHash)(fr, lr), u.U8.encode(0), u.I32LE.encode(nr)), m.tagSchnorr("TapSighash", ...Br);
      }
      // Signer can be privateKey OR instance of bip32 HD stuff
      signIdx(rr, er, ir, sr) {
        this.checkInputIdx(er);
        const nr = this.inputs[er], fr = He(nr, this.opts.allowLegacyWitnessUtxo);
        if (!(0, b.isBytes)(rr)) {
          if (!nr.bip32Derivation || !nr.bip32Derivation.length)
            throw new Error("bip32Derivation: empty");
          const Fr = nr.bip32Derivation.filter((qr) => qr[1].fingerprint == rr.fingerprint).map(([qr, { path: Hr }]) => {
            let un = rr;
            for (const Dr of Hr)
              un = un.deriveChild(Dr);
            if (!(0, b.equalBytes)(un.publicKey, qr))
              throw new Error("bip32Derivation: wrong pubKey");
            if (!un.privateKey)
              throw new Error("bip32Derivation: no privateKey");
            return un;
          });
          if (!Fr.length)
            throw new Error(`bip32Derivation: no items with fingerprint=${rr.fingerprint}`);
          let Gr = !1;
          for (const qr of Fr)
            this.signIdx(qr.privateKey, er) && (Gr = !0);
          return Gr;
        }
        ir ? ir.forEach(be) : ir = [fr.defaultSighash];
        const lr = fr.sighash;
        if (!ir.includes(lr))
          throw new Error(`Input with not allowed sigHash=${lr}. Allowed: ${ir.join(", ")}`);
        const { sigOutputs: br } = this.inputSighash(er);
        if (br === x.SINGLE && er >= this.outputs.length)
          throw new Error(`Input with sighash SINGLE, but there is no output with corresponding index=${er}`);
        const Br = xe(nr);
        if (fr.txType === "taproot") {
          const Fr = this.inputs.map(xe), Gr = Fr.map((wr) => wr.script), qr = Fr.map((wr) => wr.amount);
          let Hr = !1, un = m.pubSchnorr(rr), Dr = nr.tapMerkleRoot || u.EMPTY;
          if (nr.tapInternalKey) {
            const { pubKey: wr, privKey: yr } = F(rr, un, nr.tapInternalKey, Dr), [Qr, _r] = m.taprootTweakPubkey(nr.tapInternalKey, Dr);
            if ((0, b.equalBytes)(Qr, wr)) {
              const Jr = this.preimageWitnessV1(er, Gr, lr, qr), fn = (0, b.concatBytes)(m.signSchnorr(Jr, yr, sr), lr !== x.DEFAULT ? new Uint8Array([lr]) : u.EMPTY);
              this.updateInput(er, { tapKeySig: fn }, !0), Hr = !0;
            }
          }
          if (nr.tapLeafScript) {
            nr.tapScriptSig = nr.tapScriptSig || [];
            for (const [wr, yr] of nr.tapLeafScript) {
              const Qr = yr.subarray(0, -1), _r = l.Script.decode(Qr), Jr = yr[yr.length - 1], fn = (0, p.tapLeafHash)(Qr, Jr);
              if (_r.findIndex((Yn) => (0, b.isBytes)(Yn) && (0, b.equalBytes)(Yn, un)) === -1)
                continue;
              const dn = this.preimageWitnessV1(er, Gr, lr, qr, void 0, Qr, Jr), Tn = (0, b.concatBytes)(m.signSchnorr(dn, rr, sr), lr !== x.DEFAULT ? new Uint8Array([lr]) : u.EMPTY);
              this.updateInput(er, { tapScriptSig: [[{ pubKey: un, leafHash: fn }, Tn]] }, !0), Hr = !0;
            }
          }
          if (!Hr)
            throw new Error("No taproot scripts signed");
          return !0;
        } else {
          const Fr = m.pubECDSA(rr);
          let Gr = !1;
          const qr = m.hash160(Fr);
          for (const Dr of l.Script.decode(fr.lastScript))
            (0, b.isBytes)(Dr) && ((0, b.equalBytes)(Dr, Fr) || (0, b.equalBytes)(Dr, qr)) && (Gr = !0);
          if (!Gr)
            throw new Error(`Input script doesn't have pubKey: ${fr.lastScript}`);
          let Hr;
          if (fr.txType === "legacy")
            Hr = this.preimageLegacy(er, fr.lastScript, lr);
          else if (fr.txType === "segwit") {
            let Dr = fr.lastScript;
            fr.last.type === "wpkh" && (Dr = p.OutScript.encode({ type: "pkh", hash: fr.last.hash })), Hr = this.preimageWitnessV0(er, Dr, lr, Br.amount);
          } else
            throw new Error(`Transaction/sign: unknown tx type: ${fr.txType}`);
          const un = m.signECDSA(Hr, rr, this.opts.lowR);
          this.updateInput(er, {
            partialSig: [[Fr, (0, b.concatBytes)(un, new Uint8Array([lr]))]]
          }, !0);
        }
        return !0;
      }
      // This is bad API. Will work if user creates and signs tx, but if
      // there is some complex workflow with exchanging PSBT and signing them,
      // then it is better to validate which output user signs. How could a better API look like?
      // Example: user adds input, sends to another party, then signs received input (mixer etc),
      // another user can add different input for same key and user will sign it.
      // Even worse: another user can add bip32 derivation, and spend money from different address.
      // Better api: signIdx
      sign(rr, er, ir) {
        let sr = 0;
        for (let nr = 0; nr < this.inputs.length; nr++)
          try {
            this.signIdx(rr, nr, er, ir) && sr++;
          } catch {
          }
        if (!sr)
          throw new Error("No inputs signed");
        return sr;
      }
      finalizeIdx(rr) {
        if (this.checkInputIdx(rr), this.fee < 0n)
          throw new Error("Outputs spends more than inputs amount");
        const er = this.inputs[rr], ir = He(er, this.opts.allowLegacyWitnessUtxo);
        if (ir.txType === "taproot") {
          if (er.tapKeySig)
            er.finalScriptWitness = [er.tapKeySig];
          else if (er.tapLeafScript && er.tapScriptSig) {
            const br = er.tapLeafScript.sort((Br, Fr) => t.TaprootControlBlock.encode(Br[0]).length - t.TaprootControlBlock.encode(Fr[0]).length);
            for (const [Br, Fr] of br) {
              const Gr = Fr.slice(0, -1), qr = Fr[Fr.length - 1], Hr = p.OutScript.decode(Gr), un = (0, p.tapLeafHash)(Gr, qr), Dr = er.tapScriptSig.filter((yr) => (0, b.equalBytes)(yr[0].leafHash, un));
              let wr = [];
              if (Hr.type === "tr_ms") {
                const yr = Hr.m, Qr = Hr.pubkeys;
                let _r = 0;
                for (const Jr of Qr) {
                  const fn = Dr.findIndex((jr) => (0, b.equalBytes)(jr[0].pubKey, Jr));
                  if (_r === yr || fn === -1) {
                    wr.push(u.EMPTY);
                    continue;
                  }
                  wr.push(Dr[fn][1]), _r++;
                }
                if (_r !== yr)
                  continue;
              } else if (Hr.type === "tr_ns") {
                for (const yr of Hr.pubkeys) {
                  const Qr = Dr.findIndex((_r) => (0, b.equalBytes)(_r[0].pubKey, yr));
                  Qr !== -1 && wr.push(Dr[Qr][1]);
                }
                if (wr.length !== Hr.pubkeys.length)
                  continue;
              } else if (Hr.type === "unknown" && this.opts.allowUnknownInputs) {
                const yr = l.Script.decode(Gr);
                if (wr = Dr.map(([{ pubKey: Qr }, _r]) => {
                  const Jr = yr.findIndex((fn) => (0, b.isBytes)(fn) && (0, b.equalBytes)(fn, Qr));
                  if (Jr === -1)
                    throw new Error("finalize/taproot: cannot find position of pubkey in script");
                  return { signature: _r, pos: Jr };
                }).sort((Qr, _r) => Qr.pos - _r.pos).map((Qr) => Qr.signature), !wr.length)
                  continue;
              } else {
                const yr = this.opts.customScripts;
                if (yr)
                  for (const Qr of yr) {
                    if (!Qr.finalizeTaproot)
                      continue;
                    const _r = l.Script.decode(Gr), Jr = Qr.encode(_r);
                    if (Jr === void 0)
                      continue;
                    const fn = Qr.finalizeTaproot(Gr, Jr, Dr);
                    if (fn) {
                      er.finalScriptWitness = fn.concat(t.TaprootControlBlock.encode(Br)), er.finalScriptSig = u.EMPTY, pe(er);
                      return;
                    }
                  }
                throw new Error("Finalize: Unknown tapLeafScript");
              }
              er.finalScriptWitness = wr.reverse().concat([Gr, t.TaprootControlBlock.encode(Br)]);
              break;
            }
            if (!er.finalScriptWitness)
              throw new Error("finalize/taproot: empty witness");
          } else
            throw new Error("finalize/taproot: unknown input");
          er.finalScriptSig = u.EMPTY, pe(er);
          return;
        }
        if (!er.partialSig || !er.partialSig.length)
          throw new Error("Not enough partial sign");
        let sr = u.EMPTY, nr = [];
        if (ir.last.type === "ms") {
          const br = ir.last.m, Br = ir.last.pubkeys;
          let Fr = [];
          for (const Gr of Br) {
            const qr = er.partialSig.find((Hr) => (0, b.equalBytes)(Gr, Hr[0]));
            qr && Fr.push(qr[1]);
          }
          if (Fr = Fr.slice(0, br), Fr.length !== br)
            throw new Error(`Multisig: wrong signatures count, m=${br} n=${Br.length} signatures=${Fr.length}`);
          sr = l.Script.encode([0, ...Fr]);
        } else if (ir.last.type === "pk")
          sr = l.Script.encode([er.partialSig[0][1]]);
        else if (ir.last.type === "pkh")
          sr = l.Script.encode([er.partialSig[0][1], er.partialSig[0][0]]);
        else if (ir.last.type === "wpkh")
          sr = u.EMPTY, nr = [er.partialSig[0][1], er.partialSig[0][0]];
        else if (ir.last.type === "unknown" && !this.opts.allowUnknownInputs)
          throw new Error("Unknown inputs not allowed");
        let fr, lr;
        if (ir.type.includes("wsh-") && (sr.length && ir.lastScript.length && (nr = l.Script.decode(sr).map((br) => {
          if (br === 0)
            return u.EMPTY;
          if ((0, b.isBytes)(br))
            return br;
          throw new Error(`Wrong witness op=${br}`);
        })), nr = nr.concat(ir.lastScript)), ir.txType === "segwit" && (lr = nr), ir.type.startsWith("sh-wsh-") ? fr = l.Script.encode([l.Script.encode([0, m.sha256(ir.lastScript)])]) : ir.type.startsWith("sh-") ? fr = l.Script.encode([...l.Script.decode(sr), ir.lastScript]) : ir.type.startsWith("wsh-") || ir.txType !== "segwit" && (fr = sr), !fr && !lr)
          throw new Error("Unknown error finalizing input");
        fr && (er.finalScriptSig = fr), lr && (er.finalScriptWitness = lr), pe(er);
      }
      finalize() {
        for (let rr = 0; rr < this.inputs.length; rr++)
          this.finalizeIdx(rr);
      }
      extract() {
        if (!this.isFinal)
          throw new Error("Transaction has unfinalized inputs");
        if (!this.outputs.length)
          throw new Error("Transaction has no outputs");
        if (this.fee < 0n)
          throw new Error("Outputs spends more than inputs amount");
        return this.toBytes(!0, !0);
      }
      combine(rr) {
        for (const sr of ["PSBTVersion", "version", "lockTime"])
          if (this.opts[sr] !== rr.opts[sr])
            throw new Error(`Transaction/combine: different ${sr} this=${this.opts[sr]} other=${rr.opts[sr]}`);
        for (const sr of ["inputs", "outputs"])
          if (this[sr].length !== rr[sr].length)
            throw new Error(`Transaction/combine: different ${sr} length this=${this[sr].length} other=${rr[sr].length}`);
        const er = this.global.unsignedTx ? l.RawOldTx.encode(this.global.unsignedTx) : u.EMPTY, ir = rr.global.unsignedTx ? l.RawOldTx.encode(rr.global.unsignedTx) : u.EMPTY;
        if (!(0, b.equalBytes)(er, ir))
          throw new Error("Transaction/combine: different unsigned tx");
        this.global = t.mergeKeyMap(t.PSBTGlobal, this.global, rr.global, void 0, this.opts.allowUnknown);
        for (let sr = 0; sr < this.inputs.length; sr++)
          this.updateInput(sr, rr.inputs[sr], !0);
        for (let sr = 0; sr < this.outputs.length; sr++)
          this.updateOutput(sr, rr.outputs[sr], !0);
        return this;
      }
      clone() {
        return ve.fromPSBT(this.toPSBT(this.opts.PSBTVersion), this.opts);
      }
    }
    s.Transaction = ve;
    function we(Ne) {
      if (!Ne || !Array.isArray(Ne) || !Ne.length)
        throw new Error("PSBTCombine: wrong PSBT list");
      const rr = ve.fromPSBT(Ne[0]);
      for (let er = 1; er < Ne.length; er++)
        rr.combine(ve.fromPSBT(Ne[er]));
      return rr.toPSBT();
    }
    const Ce = 2147483648;
    function Se(Ne) {
      const rr = [];
      if (!/^[mM]'?/.test(Ne))
        throw new Error('Path must start with "m" or "M"');
      if (/^[mM]'?$/.test(Ne))
        return rr;
      const er = Ne.replace(/^[mM]'?\//, "").split("/");
      for (const ir of er) {
        const sr = /^(\d+)('?)$/.exec(ir);
        if (!sr || sr.length !== 3)
          throw new Error(`Invalid child index: ${ir}`);
        let nr = +sr[1];
        if (!Number.isSafeInteger(nr) || nr >= Ce)
          throw new Error("Invalid index");
        sr[2] === "'" && (nr += Ce), rr.push(nr);
      }
      return rr;
    }
  }(transaction)), transaction;
}
var utxo = {}, hasRequiredUtxo;
function requireUtxo() {
  return hasRequiredUtxo || (hasRequiredUtxo = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s._Estimator = s._cmpBig = void 0, s.selectUTXO = M;
    const A = /* @__PURE__ */ requireLib$2(), u = /* @__PURE__ */ requireLib(), p = /* @__PURE__ */ requirePayment(), t = /* @__PURE__ */ requirePsbt$1(), l = /* @__PURE__ */ requireScript(), m = /* @__PURE__ */ requireTransaction(), b = /* @__PURE__ */ requireUtils$1(), k = (F) => t.TaprootControlBlock.encode(F);
    function C(F, le, ge) {
      if (!F || !F.length)
        throw new Error("no leafs");
      const pe = () => new Uint8Array(le), Ie = F.sort((be, Pe) => k(be[0]).length - k(Pe[0]).length);
      for (const [be, Pe] of Ie) {
        const Te = Pe.slice(0, -1), Qe = Pe[Pe.length - 1], xe = p.OutScript.decode(Te);
        let Ee = [];
        if (xe.type === "tr_ms") {
          const He = xe.m, ve = xe.pubkeys.length - He;
          for (let we = 0; we < He; we++)
            Ee.push(pe());
          for (let we = 0; we < ve; we++)
            Ee.push(u.EMPTY);
        } else if (xe.type === "tr_ns")
          for (const He of xe.pubkeys)
            Ee.push(pe());
        else {
          if (!ge)
            throw new Error("Finalize: Unknown tapLeafScript");
          const He = (0, p.tapLeafHash)(Te, Qe);
          for (const ve of ge) {
            if (!ve.finalizeTaproot)
              continue;
            const we = l.Script.decode(Te), Ce = ve.encode(we);
            if (Ce === void 0)
              continue;
            const Se = we.filter((rr) => {
              if (!(0, b.isBytes)(rr))
                return !1;
              try {
                return (0, b.validatePubkey)(rr, b.PubT.schnorr), !0;
              } catch {
                return !1;
              }
            }), Ne = ve.finalizeTaproot(Te, Ce, Se.map((rr) => [{ pubKey: rr, leafHash: He }, pe()]));
            if (Ne)
              return Ne.concat(k(be));
          }
        }
        return Ee.reverse().concat([Te, k(be)]);
      }
      throw new Error("there was no witness");
    }
    function B(F, le, ge) {
      let pe = u.EMPTY, Ie;
      if (F.txType === "taproot") {
        const Te = F.sighash !== m.SignatureHash.DEFAULT ? 65 : 64;
        if (le.tapInternalKey && !(0, b.equalBytes)(le.tapInternalKey, b.TAPROOT_UNSPENDABLE_KEY))
          Ie = [new Uint8Array(Te)];
        else if (le.tapLeafScript)
          Ie = C(le.tapLeafScript, Te, ge.customScripts);
        else
          throw new Error("estimateInput/taproot: unknown input");
      } else {
        const Te = () => new Uint8Array(72), Qe = () => new Uint8Array(33);
        let xe = u.EMPTY, Ee = [];
        const He = F.last.type;
        if (He === "ms") {
          const ve = F.last.m, we = [0];
          for (let Ce = 0; Ce < ve; Ce++)
            we.push(Te());
          xe = l.Script.encode(we);
        } else if (He === "pk")
          xe = l.Script.encode([Te()]);
        else if (He === "pkh")
          xe = l.Script.encode([Te(), Qe()]);
        else if (He === "wpkh")
          xe = u.EMPTY, Ee = [Te(), Qe()];
        else if (He === "unknown" && !ge.allowUnknownInputs)
          throw new Error("Unknown inputs are not allowed");
        F.type.includes("wsh-") && (xe.length && F.lastScript.length && (Ee = l.Script.decode(xe).map((ve) => {
          if (ve === 0)
            return u.EMPTY;
          if ((0, b.isBytes)(ve))
            return ve;
          throw new Error(`Wrong witness op=${ve}`);
        })), Ee = Ee.concat(F.lastScript)), F.txType === "segwit" && (Ie = Ee), F.type.startsWith("sh-wsh-") ? pe = l.Script.encode([l.Script.encode([0, new Uint8Array(b.sha256.outputLen)])]) : F.type.startsWith("sh-") ? pe = l.Script.encode([...l.Script.decode(xe), F.lastScript]) : F.type.startsWith("wsh-") || F.txType !== "segwit" && (pe = xe);
      }
      let be = 160 + 4 * l.VarBytes.encode(pe).length, Pe = !1;
      return Ie && (be += l.RawWitness.encode(Ie).length, Pe = !0), { weight: be, hasWitnesses: Pe };
    }
    const Q = (F, le) => {
      const ge = F - le;
      return ge < 0n ? -1 : ge > 0n ? 1 : 0;
    };
    s._cmpBig = Q;
    function P(F, le = {}, ge = b.NETWORK) {
      let pe;
      if ("script" in F && (0, b.isBytes)(F.script) && (pe = F.script), "address" in F) {
        if (typeof F.address != "string")
          throw new Error(`Estimator: wrong output address=${F.address}`);
        pe = p.OutScript.encode((0, p.Address)(ge).decode(F.address));
      }
      if (!pe)
        throw new Error("Estimator: wrong output script");
      if (typeof F.amount != "bigint")
        throw new Error(`Estimator: wrong output amount=${F.amount}, should be of type bigint but got ${typeof F.amount}.`);
      if (pe && !le.allowUnknownOutputs && p.OutScript.decode(pe).type === "unknown")
        throw new Error("Estimator: unknown output script type, there is a chance that input is unspendable. Pass allowUnknownOutputs=true, if you sure");
      return le.disableScriptCheck || (0, p.checkScript)(pe), pe;
    }
    class x {
      constructor(le, ge, pe) {
        if (this.requiredIndices = [], this.outputs = ge, this.opts = pe, typeof pe.feePerByte != "bigint")
          throw new Error(`Estimator: wrong feePerByte=${pe.feePerByte}, should be of type bigint but got ${typeof pe.feePerByte}.`);
        const Pe = pe.dust === void 0 ? BigInt(148 + 34) : pe.dust;
        if (typeof Pe != "bigint")
          throw new Error(`Estimator: wrong dust=${pe.dust}, should be of type bigint but got ${typeof pe.dust}.`);
        const Te = pe.dustRelayFeeRate === void 0 ? 3n : pe.dustRelayFeeRate;
        if (typeof Te != "bigint")
          throw new Error(`Estimator: wrong dustRelayFeeRate=${pe.dustRelayFeeRate}, should be of type bigint but got ${typeof pe.dustRelayFeeRate}.`);
        if (this.dust = Pe * Te, pe.requiredInputs !== void 0 && !Array.isArray(pe.requiredInputs))
          throw new Error(`Estimator: wrong required inputs=${pe.requiredInputs}`);
        const Qe = pe.network || b.NETWORK;
        let xe = 0n, Ee = 32;
        for (const Ce of ge) {
          const Se = P(Ce, pe, pe.network);
          Ee += 32 + 4 * l.VarBytes.encode(Se).length, xe += Ce.amount;
        }
        if (typeof pe.changeAddress != "string")
          throw new Error(`Estimator: wrong change address=${pe.changeAddress}`);
        let He = Ee + 32 + 4 * l.VarBytes.encode(p.OutScript.encode((0, p.Address)(Qe).decode(pe.changeAddress))).length;
        Ee += 4 * l.CompactSizeLen.encode(ge.length).length, He += 4 * l.CompactSizeLen.encode(ge.length + 1).length, this.baseWeight = Ee, this.changeWeight = He, this.amount = xe;
        const ve = Array.from(le);
        if (pe.requiredInputs)
          for (let Ce = 0; Ce < pe.requiredInputs.length; Ce++)
            this.requiredIndices.push(ve.push(pe.requiredInputs[Ce]) - 1);
        const we = /* @__PURE__ */ new Set();
        this.normalizedInputs = ve.map((Ce) => {
          const Se = (0, m.normalizeInput)(Ce, void 0, void 0, pe.disableScriptCheck, pe.allowUnknown);
          (0, m.inputBeforeSign)(Se);
          const Ne = `${A.hex.encode(Se.txid)}:${Se.index}`;
          if (!pe.allowSameUtxo && we.has(Ne))
            throw new Error(`Estimator: same input passed multiple times: ${Ne}`);
          we.add(Ne);
          const rr = (0, m.getInputType)(Se, pe.allowLegacyWitnessUtxo), er = (0, m.getPrevOut)(Se), ir = B(rr, Se, this.opts), sr = er.amount - pe.feePerByte * BigInt((0, m.toVsize)(ir.weight));
          return { inputType: rr, normalized: Se, amount: er.amount, value: sr, estimate: ir };
        });
      }
      checkInputIdx(le) {
        if (!Number.isSafeInteger(le) || 0 > le || le >= this.normalizedInputs.length)
          throw new Error(`Wrong input index=${le}`);
        return le;
      }
      sortIndices(le) {
        return le.slice().sort((ge, pe) => {
          const Ie = this.normalizedInputs[this.checkInputIdx(ge)], be = this.normalizedInputs[this.checkInputIdx(pe)], Pe = (0, b.compareBytes)(Ie.normalized.txid, be.normalized.txid);
          return Pe !== 0 ? Pe : Ie.normalized.index - be.normalized.index;
        });
      }
      sortOutputs(le) {
        const ge = le.map((Ie) => P(Ie, this.opts, this.opts.network));
        return le.map((Ie, be) => be).sort((Ie, be) => {
          const Pe = le[Ie].amount, Te = le[be].amount, Qe = (0, s._cmpBig)(Pe, Te);
          return Qe !== 0 ? Qe : (0, b.compareBytes)(ge[Ie], ge[be]);
        });
      }
      getSatoshi(le) {
        return this.opts.feePerByte * BigInt((0, m.toVsize)(le));
      }
      // Sort by value instead of amount
      get biggest() {
        return this.normalizedInputs.map((le, ge) => ge).sort((le, ge) => (0, s._cmpBig)(this.normalizedInputs[ge].value, this.normalizedInputs[le].value));
      }
      get smallest() {
        return this.biggest.reverse();
      }
      // These assume that UTXO array has historical order.
      // Otherwise, we have no way to know which tx is oldest
      // Explorers usually give UTXO in this order.
      get oldest() {
        return this.normalizedInputs.map((le, ge) => ge);
      }
      get newest() {
        return this.oldest.reverse();
      }
      // exact - like blackjack from coinselect.
      // exact(biggest) will select one big utxo which is closer to targetValue+dust, if possible.
      // If not, it will accumulate largest utxo until value is close to targetValue+dust.
      accumulate(le, ge = !1, pe = !0, Ie = !1) {
        let be = this.opts.alwaysChange ? this.changeWeight : this.baseWeight, Pe = !1, Te = 0, Qe = 0n;
        const xe = this.amount, Ee = /* @__PURE__ */ new Set();
        let He;
        for (const ve of this.requiredIndices) {
          if (this.checkInputIdx(ve), Ee.has(ve))
            throw new Error("required input encountered multiple times");
          const { estimate: we, amount: Ce } = this.normalizedInputs[ve];
          let Se = be + we.weight;
          !Pe && we.hasWitnesses && (Se += 2);
          const Ne = Se + 4 * l.CompactSizeLen.encode(Te).length;
          if (He = this.getSatoshi(Ne), be = Se, we.hasWitnesses && (Pe = !0), Te++, Qe += Ce, Ee.add(ve), !Ie && xe + He <= Qe && Te >= this.requiredIndices.length)
            return { indices: Array.from(Ee), fee: He, weight: Ne, total: Qe };
        }
        for (const ve of le) {
          if (this.checkInputIdx(ve), Ee.has(ve))
            continue;
          const { estimate: we, amount: Ce, value: Se } = this.normalizedInputs[ve];
          let Ne = be + we.weight;
          !Pe && we.hasWitnesses && (Ne += 2);
          const rr = Ne + 4 * l.CompactSizeLen.encode(Te).length;
          if (He = this.getSatoshi(rr), !(ge && Ce + Qe > xe + He + this.dust) && !(pe && Se <= 0n) && (be = Ne, we.hasWitnesses && (Pe = !0), Te++, Qe += Ce, Ee.add(ve), !Ie && xe + He <= Qe))
            return { indices: Array.from(Ee), fee: He, weight: rr, total: Qe };
        }
        if (Ie) {
          const ve = be + 4 * l.CompactSizeLen.encode(Te).length;
          return { indices: Array.from(Ee), fee: He, weight: ve, total: Qe };
        }
      }
      // Works like coinselect default method
      default() {
        const { biggest: le } = this, ge = this.accumulate(le, !0, !1);
        return ge || this.accumulate(le);
      }
      select(le) {
        if (le === "all")
          return this.accumulate(this.normalizedInputs.map((pe, Ie) => Ie), !1, !0, !0);
        if (le === "default")
          return this.default();
        const ge = {
          Oldest: () => this.oldest,
          Newest: () => this.newest,
          Smallest: () => this.smallest,
          Biggest: () => this.biggest
        };
        if (le.startsWith("exact")) {
          const [pe, Ie] = le.slice(5).split("/");
          if (!ge[pe])
            throw new Error(`Estimator.select: wrong strategy=${le}`);
          le = Ie;
          const be = this.accumulate(ge[pe](), !0, !0);
          if (be)
            return be;
        }
        if (le.startsWith("accum")) {
          const pe = le.slice(5);
          if (!ge[pe])
            throw new Error(`Estimator.select: wrong strategy=${le}`);
          return this.accumulate(ge[pe]());
        }
        throw new Error(`Estimator.select: wrong strategy=${le}`);
      }
      result(le) {
        const ge = this.select(le);
        if (!ge)
          return;
        const { indices: pe, weight: Ie, total: be } = ge;
        let Pe = this.opts.alwaysChange;
        const Te = this.opts.alwaysChange ? Ie : Ie + (this.changeWeight - this.baseWeight), Qe = this.getSatoshi(Te);
        let xe = ge.fee;
        const Ee = be - this.amount - Qe;
        Ee > this.dust && (Pe = !0);
        let He = pe, ve = Array.from(this.outputs);
        if (Pe) {
          if (xe = Qe, Ee < 0n)
            throw new Error(`Estimator.result: negative change=${Ee}`);
          ve.push({ address: this.opts.changeAddress, amount: Ee });
        }
        this.opts.bip69 && (He = this.sortIndices(He), ve = this.sortOutputs(ve).map((Se) => ve[Se]));
        const we = {
          inputs: He.map((Se) => this.normalizedInputs[Se].normalized),
          outputs: ve,
          fee: xe,
          weight: this.opts.alwaysChange ? ge.weight : Te,
          change: !!Pe
        };
        let Ce;
        if (this.opts.createTx) {
          const { inputs: Se, outputs: Ne } = we;
          Ce = new m.Transaction(this.opts);
          for (const rr of Se)
            Ce.addInput(rr);
          for (const rr of Ne)
            Ce.addOutput({ ...rr, script: P(rr, this.opts, this.opts.network) });
        }
        return Object.assign(we, { tx: Ce });
      }
    }
    s._Estimator = x;
    function M(F, le, ge, pe) {
      const Ie = { createTx: !0, bip69: !0, ...pe };
      return new x(F, le, Ie).result(ge);
    }
  }(utxo)), utxo;
}
var hasRequiredBtcSigner;
function requireBtcSigner() {
  return hasRequiredBtcSigner || (hasRequiredBtcSigner = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s._Estimator = s._cmpBig = s.SigHash = s.PSBTCombine = s.DEFAULT_SEQUENCE = s.Decimal = s.bip32Path = s.TaprootControlBlock = s._DebugPSBT = s.WIF = s.taprootListToTree = s.sortedMultisig = s.OutScript = s.getAddress = s.combinations = s.Address = s._sortPubkeys = s.utils = s.selectUTXO = s.TEST_NETWORK = s.TAPROOT_UNSPENDABLE_KEY = s.NETWORK = s.Transaction = s.getInputType = s.ScriptNum = s.Script = s.RawWitness = s.RawTx = s.OP = s.MAX_SCRIPT_BYTE_LENGTH = s.CompactSize = s.p2wsh = s.p2wpkh = s.p2tr_pk = s.p2tr_ns = s.p2tr_ms = s.p2tr = s.p2sh = s.p2pkh = s.p2pk = s.p2ms = s.multisig = void 0;
    const A = /* @__PURE__ */ requireUtils$1();
    var u = /* @__PURE__ */ requirePayment();
    Object.defineProperty(s, "multisig", { enumerable: !0, get: function() {
      return u.multisig;
    } }), Object.defineProperty(s, "p2ms", { enumerable: !0, get: function() {
      return u.p2ms;
    } }), Object.defineProperty(s, "p2pk", { enumerable: !0, get: function() {
      return u.p2pk;
    } }), Object.defineProperty(s, "p2pkh", { enumerable: !0, get: function() {
      return u.p2pkh;
    } }), Object.defineProperty(s, "p2sh", { enumerable: !0, get: function() {
      return u.p2sh;
    } }), Object.defineProperty(s, "p2tr", { enumerable: !0, get: function() {
      return u.p2tr;
    } }), Object.defineProperty(s, "p2tr_ms", { enumerable: !0, get: function() {
      return u.p2tr_ms;
    } }), Object.defineProperty(s, "p2tr_ns", { enumerable: !0, get: function() {
      return u.p2tr_ns;
    } }), Object.defineProperty(s, "p2tr_pk", { enumerable: !0, get: function() {
      return u.p2tr_pk;
    } }), Object.defineProperty(s, "p2wpkh", { enumerable: !0, get: function() {
      return u.p2wpkh;
    } }), Object.defineProperty(s, "p2wsh", { enumerable: !0, get: function() {
      return u.p2wsh;
    } });
    var p = /* @__PURE__ */ requireScript();
    Object.defineProperty(s, "CompactSize", { enumerable: !0, get: function() {
      return p.CompactSize;
    } }), Object.defineProperty(s, "MAX_SCRIPT_BYTE_LENGTH", { enumerable: !0, get: function() {
      return p.MAX_SCRIPT_BYTE_LENGTH;
    } }), Object.defineProperty(s, "OP", { enumerable: !0, get: function() {
      return p.OP;
    } }), Object.defineProperty(s, "RawTx", { enumerable: !0, get: function() {
      return p.RawTx;
    } }), Object.defineProperty(s, "RawWitness", { enumerable: !0, get: function() {
      return p.RawWitness;
    } }), Object.defineProperty(s, "Script", { enumerable: !0, get: function() {
      return p.Script;
    } }), Object.defineProperty(s, "ScriptNum", { enumerable: !0, get: function() {
      return p.ScriptNum;
    } });
    var t = /* @__PURE__ */ requireTransaction();
    Object.defineProperty(s, "getInputType", { enumerable: !0, get: function() {
      return t.getInputType;
    } }), Object.defineProperty(s, "Transaction", { enumerable: !0, get: function() {
      return t.Transaction;
    } });
    var l = /* @__PURE__ */ requireUtils$1();
    Object.defineProperty(s, "NETWORK", { enumerable: !0, get: function() {
      return l.NETWORK;
    } }), Object.defineProperty(s, "TAPROOT_UNSPENDABLE_KEY", { enumerable: !0, get: function() {
      return l.TAPROOT_UNSPENDABLE_KEY;
    } }), Object.defineProperty(s, "TEST_NETWORK", { enumerable: !0, get: function() {
      return l.TEST_NETWORK;
    } });
    var m = /* @__PURE__ */ requireUtxo();
    Object.defineProperty(s, "selectUTXO", { enumerable: !0, get: function() {
      return m.selectUTXO;
    } }), s.utils = {
      isBytes: A.isBytes,
      concatBytes: A.concatBytes,
      compareBytes: A.compareBytes,
      pubSchnorr: A.pubSchnorr,
      randomPrivateKeyBytes: A.randomPrivateKeyBytes,
      taprootTweakPubkey: A.taprootTweakPubkey
    };
    var b = /* @__PURE__ */ requirePayment();
    Object.defineProperty(s, "_sortPubkeys", { enumerable: !0, get: function() {
      return b._sortPubkeys;
    } }), Object.defineProperty(s, "Address", { enumerable: !0, get: function() {
      return b.Address;
    } }), Object.defineProperty(s, "combinations", { enumerable: !0, get: function() {
      return b.combinations;
    } }), Object.defineProperty(s, "getAddress", { enumerable: !0, get: function() {
      return b.getAddress;
    } }), Object.defineProperty(s, "OutScript", { enumerable: !0, get: function() {
      return b.OutScript;
    } }), Object.defineProperty(s, "sortedMultisig", { enumerable: !0, get: function() {
      return b.sortedMultisig;
    } }), Object.defineProperty(s, "taprootListToTree", { enumerable: !0, get: function() {
      return b.taprootListToTree;
    } }), Object.defineProperty(s, "WIF", { enumerable: !0, get: function() {
      return b.WIF;
    } });
    var k = /* @__PURE__ */ requirePsbt$1();
    Object.defineProperty(s, "_DebugPSBT", { enumerable: !0, get: function() {
      return k._DebugPSBT;
    } }), Object.defineProperty(s, "TaprootControlBlock", { enumerable: !0, get: function() {
      return k.TaprootControlBlock;
    } });
    var C = /* @__PURE__ */ requireTransaction();
    Object.defineProperty(s, "bip32Path", { enumerable: !0, get: function() {
      return C.bip32Path;
    } }), Object.defineProperty(s, "Decimal", { enumerable: !0, get: function() {
      return C.Decimal;
    } }), Object.defineProperty(s, "DEFAULT_SEQUENCE", { enumerable: !0, get: function() {
      return C.DEFAULT_SEQUENCE;
    } }), Object.defineProperty(s, "PSBTCombine", { enumerable: !0, get: function() {
      return C.PSBTCombine;
    } }), Object.defineProperty(s, "SigHash", { enumerable: !0, get: function() {
      return C.SigHash;
    } });
    var B = /* @__PURE__ */ requireUtxo();
    Object.defineProperty(s, "_cmpBig", { enumerable: !0, get: function() {
      return B._cmpBig;
    } }), Object.defineProperty(s, "_Estimator", { enumerable: !0, get: function() {
      return B._Estimator;
    } });
  }(btcSigner)), btcSigner;
}
var bip322$1 = {}, types$1 = {}, hasRequiredTypes$1;
function requireTypes$1() {
  return hasRequiredTypes$1 || (hasRequiredTypes$1 = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.MagicCode = s.MessageSigningProtocols = s.AddressType = void 0, function(A) {
      A.p2pkh = "p2pkh", A.p2sh = "p2sh", A.p2wpkh = "p2wpkh", A.p2wsh = "p2wsh", A.p2tr = "p2tr";
    }(s.AddressType || (s.AddressType = {})), function(A) {
      A.ECDSA = "ECDSA", A.BIP322 = "BIP322";
    }(s.MessageSigningProtocols || (s.MessageSigningProtocols = {})), function(A) {
      A.LEAFHASH_DISPLAY_FP = "69846d00", A.LEAFHASH_CHECK_ONLY_FP = "3b9f9680", A.FINALITY_PUB_FP = "ff119473", A.BIP322_MESSAGE_FP = "83871619", A.BIP322_TAP_PUBKEY_FP = "25270417", A.BIP322_HASH_FP = "04040816";
    }(s.MagicCode || (s.MagicCode = {}));
  }(types$1)), types$1;
}
var hasRequiredBip322$1;
function requireBip322$1() {
  if (hasRequiredBip322$1) return bip322$1;
  hasRequiredBip322$1 = 1;
  var s = bip322$1 && bip322$1.__createBinding || (Object.create ? function(xe, Ee, He, ve) {
    ve === void 0 && (ve = He);
    var we = Object.getOwnPropertyDescriptor(Ee, He);
    (!we || ("get" in we ? !Ee.__esModule : we.writable || we.configurable)) && (we = { enumerable: !0, get: function() {
      return Ee[He];
    } }), Object.defineProperty(xe, ve, we);
  } : function(xe, Ee, He, ve) {
    ve === void 0 && (ve = He), xe[ve] = Ee[He];
  }), A = bip322$1 && bip322$1.__setModuleDefault || (Object.create ? function(xe, Ee) {
    Object.defineProperty(xe, "default", { enumerable: !0, value: Ee });
  } : function(xe, Ee) {
    xe.default = Ee;
  }), u = bip322$1 && bip322$1.__importStar || function(xe) {
    if (xe && xe.__esModule) return xe;
    var Ee = {};
    if (xe != null) for (var He in xe) He !== "default" && Object.prototype.hasOwnProperty.call(xe, He) && s(Ee, xe, He);
    return A(Ee, xe), Ee;
  };
  Object.defineProperty(bip322$1, "__esModule", { value: !0 }), bip322$1.createTaprootBip322Signature = bip322$1.createSegwitBip322Signature = bip322$1.bip0322Hash = void 0;
  const p = u(requireDist$l()), t = requireSrc$3(), l = requireSrc$1(), m = requireVaruintBitcoin(), b = requireMain$1(), k = requireBabylon$1(), C = requireTypes$1(), B = (0, l.BIP32Factory)(p), Q = (xe) => Buffer.concat([(0, m.encode)(xe.byteLength), xe]), P = Buffer.from("0000000000000000000000000000000000000000000000000000000000000000", "hex"), x = 4294967295, M = 0;
  function F(xe) {
    const { sha256: Ee } = t.crypto, ve = Ee(Buffer.from("BIP0322-signed-message"));
    return Ee(Buffer.concat([ve, ve, Buffer.from(xe)])).toString("hex");
  }
  bip322$1.bip0322Hash = F;
  const le = async (xe, Ee, He, ve, we, Ce) => {
    const Se = Buffer.concat([
      Buffer.from("0020", "hex"),
      Buffer.from(F(He), "hex")
    ]), Ne = new t.Transaction();
    Ne.version = 0, Ne.addInput(P, x, M, Se), Ne.addOutput(ve, 0);
    const rr = new t.Psbt();
    rr.setVersion(0), rr.addInput(Object.assign({ hash: Ne.getHash(), index: 0, sequence: 0, witnessUtxo: {
      script: ve,
      value: 0
    } }, we)), rr.addOutput({ script: Buffer.from("6a", "hex"), value: 0 });
    const er = await xe.signPsbt(rr.toBase64(), Ee, null);
    for (const lr of er)
      Ce ? rr.updateInput(lr[0], {
        partialSig: [lr[1]]
      }) : rr.updateInput(lr[0], {
        tapKeySig: lr[1].signature
      });
    rr.finalizeAllInputs();
    const ir = rr.extractTransaction(), sr = (0, m.encode)(ir.ins[0].witness.length);
    return {
      signature: Buffer.concat([
        sr,
        ...ir.ins[0].witness.map((lr) => Q(lr))
      ]).toString("base64"),
      protocol: C.MessageSigningProtocols.BIP322
    };
  };
  function ge(xe, Ee, He) {
    const ve = He ? t.networks.testnet : t.networks.bitcoin, { publicKey: we } = B.fromBase58(xe, ve).derivePath(`0/${Ee}`);
    return we;
  }
  function pe(xe, Ee, He = !1) {
    (0, t.initEccLib)(p);
    const ve = ge(xe, Ee, He), we = He ? t.networks.testnet : t.networks.bitcoin, Ce = t.payments.p2wpkh({ pubkey: ve, network: we }), Se = Ce.address;
    if (!Se)
      throw new Error("Address is null");
    if (!Ce.output)
      throw new Error("p2wpkh output is null");
    return {
      publicKey: ve,
      address: Se,
      witnessScript: Ce.output
    };
  }
  async function Ie({ message: xe, app: Ee, derivationPath: He = "m/84'/0'/0'", isTestnet: ve = !1 }) {
    const we = await Ee.getMasterFingerprint(), Ce = await Ee.getExtendedPubkey(He), { publicKey: Se, witnessScript: Ne } = pe(Ce, 0, ve), rr = {
      path: `${He}/0/0`,
      pubkey: Se,
      masterFingerprint: Buffer.from(we, "hex")
    }, er = new b.WalletPolicy("Sign message", "wpkh(@0/**)", [
      `[${He.replace("m/", `${we}/`)}]${Ce}`
    ]);
    return le(Ee, er, xe, Ne, {
      bip32Derivation: [rr]
    }, !0);
  }
  bip322$1.createSegwitBip322Signature = Ie;
  function be(xe, Ee, He = !1) {
    (0, t.initEccLib)(p);
    const ve = ge(xe, Ee, He), we = t.payments.p2tr({
      internalPubkey: ve.slice(1),
      network: He ? t.networks.testnet : t.networks.bitcoin
    });
    if (!we.output || !we.address || !we.internalPubkey)
      throw new Error("p2tr output, address or internalPubkey is null");
    return {
      publicKey: ve,
      address: we.address,
      internalPubkey: we.internalPubkey,
      taprootScript: we.output
    };
  }
  function Pe(xe, Ee) {
    let we = Ee.toString(16).padStart(2, "0") + xe;
    const Ce = 64 - we.length;
    return Ce > 0 && (we += "fc".repeat(Ce / 2)), we;
  }
  function Te(xe, Ee) {
    let He = "";
    for (let Ce = 0; Ce < xe.length; Ce++) {
      const Se = xe[Ce].toString(16).padStart(2, "0");
      He += Se;
    }
    const ve = Buffer.from(Ee, "ascii"), we = ve.length.toString(16).padStart(2, "0");
    return He += we + ve.toString("hex"), Pe(He, xe.length);
  }
  async function Qe({ message: xe, app: Ee, derivationPath: He = "m/86'/0'/0'", isTestnet: ve = !1 }) {
    const we = xe;
    let Ce, Se;
    xe.length > 96 ? (Ce = xe.slice(0, 64), xe = xe.slice(64), Se = (0, k.formatKey)(Ce, ve)) : (Ce = Buffer.alloc(32, 255).toString("hex"), Se = (0, k.formatKey)(Ce, ve));
    const Ne = await Ee.getMasterFingerprint(), rr = await Ee.getExtendedPubkey(He), { internalPubkey: er, taprootScript: ir } = be(rr, 0, ve), sr = {
      path: `${He}/0/0`,
      pubkey: er,
      masterFingerprint: Buffer.from(Ne, "hex"),
      leafHashes: []
    }, nr = (0, k.validadteAddress)(xe);
    if (!nr || !nr.data)
      throw new Error("The message should be a valid bbn address.");
    const fr = nr.data, lr = new b.WalletPolicy("Sign message", "tr(@0/**,and_v(pk_k(@1/**),and_v(pk_k(@2/**),pk_k(@3/**))))", [
      `[${He.replace("m/", `${Ne}/`)}]${rr}`,
      `[${He.replace("m/", `${C.MagicCode.BIP322_MESSAGE_FP}/`)}]${(0, k.formatKey)(Te(fr, nr.prefix), ve)}`,
      `[${He.replace("m/", `${C.MagicCode.BIP322_TAP_PUBKEY_FP}/`)}]${(0, k.formatKey)(ir.slice(2), ve)}`,
      `[${He.replace("m/", `${C.MagicCode.BIP322_HASH_FP}/`)}]${Se}`
    ]);
    return le(Ee, lr, we, ir, {
      tapBip32Derivation: [sr],
      tapInternalKey: er
    }, !1);
  }
  return bip322$1.createTaprootBip322Signature = Qe, bip322$1;
}
var psbt = {}, hasRequiredPsbt;
function requirePsbt() {
  if (hasRequiredPsbt) return psbt;
  hasRequiredPsbt = 1;
  var s = psbt && psbt.__createBinding || (Object.create ? function(C, B, Q, P) {
    P === void 0 && (P = Q);
    var x = Object.getOwnPropertyDescriptor(B, Q);
    (!x || ("get" in x ? !B.__esModule : x.writable || x.configurable)) && (x = { enumerable: !0, get: function() {
      return B[Q];
    } }), Object.defineProperty(C, P, x);
  } : function(C, B, Q, P) {
    P === void 0 && (P = Q), C[P] = B[Q];
  }), A = psbt && psbt.__setModuleDefault || (Object.create ? function(C, B) {
    Object.defineProperty(C, "default", { enumerable: !0, value: B });
  } : function(C, B) {
    C.default = B;
  }), u = psbt && psbt.__importStar || function(C) {
    if (C && C.__esModule) return C;
    var B = {};
    if (C != null) for (var Q in C) Q !== "default" && Object.prototype.hasOwnProperty.call(C, Q) && s(B, C, Q);
    return A(B, C), B;
  };
  Object.defineProperty(psbt, "__esModule", { value: !0 }), psbt.getLeafHash = psbt.getTaprootScript = void 0;
  const p = u(requireCryptoBrowserify()), t = requireSrc$3();
  function l(C) {
    const B = Buffer.from(C, "base64"), Q = t.Psbt.fromBuffer(B);
    for (const P of Q.data.inputs)
      if (P.tapLeafScript && P.tapLeafScript.length > 0)
        for (const x of P.tapLeafScript)
          return x.script;
  }
  psbt.getTaprootScript = l;
  function m(C, B) {
    const Q = p.createHash("sha256").update(C).digest();
    return p.createHash("sha256").update(Buffer.concat([Q, Q, B])).digest();
  }
  function b(C) {
    if (C < 253)
      return Buffer.from([C]);
    if (C <= 65535) {
      const B = Buffer.alloc(3);
      return B.writeUInt8(253, 0), B.writeUInt16LE(C, 1), B;
    } else if (C <= 4294967295) {
      const B = Buffer.alloc(5);
      return B.writeUInt8(254, 0), B.writeUInt32LE(C, 1), B;
    } else {
      const B = Buffer.alloc(9);
      return B.writeUInt8(255, 0), B.writeUInt32LE(C, 1), B.writeBigUInt64LE(BigInt(C), 5), B;
    }
  }
  function k(C) {
    const B = Buffer.from([192]), Q = C.length, P = b(Q), x = Buffer.concat([B, P, C]);
    return m(Buffer.from("TapLeaf"), x);
  }
  return psbt.getLeafHash = k, psbt;
}
var xpub = {}, cjs$1 = {}, cjs = {}, hasRequiredCjs$1;
function requireCjs$1() {
  if (hasRequiredCjs$1) return cjs;
  hasRequiredCjs$1 = 1, Object.defineProperty(cjs, "__esModule", { value: !0 });
  function s(A) {
    if (A.length >= 255)
      throw new TypeError("Alphabet too long");
    const u = new Uint8Array(256);
    for (let B = 0; B < u.length; B++)
      u[B] = 255;
    for (let B = 0; B < A.length; B++) {
      const Q = A.charAt(B), P = Q.charCodeAt(0);
      if (u[P] !== 255)
        throw new TypeError(Q + " is ambiguous");
      u[P] = B;
    }
    const p = A.length, t = A.charAt(0), l = Math.log(p) / Math.log(256), m = Math.log(256) / Math.log(p);
    function b(B) {
      if (B instanceof Uint8Array || (ArrayBuffer.isView(B) ? B = new Uint8Array(B.buffer, B.byteOffset, B.byteLength) : Array.isArray(B) && (B = Uint8Array.from(B))), !(B instanceof Uint8Array))
        throw new TypeError("Expected Uint8Array");
      if (B.length === 0)
        return "";
      let Q = 0, P = 0, x = 0;
      const M = B.length;
      for (; x !== M && B[x] === 0; )
        x++, Q++;
      const F = (M - x) * m + 1 >>> 0, le = new Uint8Array(F);
      for (; x !== M; ) {
        let Ie = B[x], be = 0;
        for (let Pe = F - 1; (Ie !== 0 || be < P) && Pe !== -1; Pe--, be++)
          Ie += 256 * le[Pe] >>> 0, le[Pe] = Ie % p >>> 0, Ie = Ie / p >>> 0;
        if (Ie !== 0)
          throw new Error("Non-zero carry");
        P = be, x++;
      }
      let ge = F - P;
      for (; ge !== F && le[ge] === 0; )
        ge++;
      let pe = t.repeat(Q);
      for (; ge < F; ++ge)
        pe += A.charAt(le[ge]);
      return pe;
    }
    function k(B) {
      if (typeof B != "string")
        throw new TypeError("Expected String");
      if (B.length === 0)
        return new Uint8Array();
      let Q = 0, P = 0, x = 0;
      for (; B[Q] === t; )
        P++, Q++;
      const M = (B.length - Q) * l + 1 >>> 0, F = new Uint8Array(M);
      for (; Q < B.length; ) {
        const Ie = B.charCodeAt(Q);
        if (Ie > 255)
          return;
        let be = u[Ie];
        if (be === 255)
          return;
        let Pe = 0;
        for (let Te = M - 1; (be !== 0 || Pe < x) && Te !== -1; Te--, Pe++)
          be += p * F[Te] >>> 0, F[Te] = be % 256 >>> 0, be = be / 256 >>> 0;
        if (be !== 0)
          throw new Error("Non-zero carry");
        x = Pe, Q++;
      }
      let le = M - x;
      for (; le !== M && F[le] === 0; )
        le++;
      const ge = new Uint8Array(P + (M - le));
      let pe = P;
      for (; le !== M; )
        ge[pe++] = F[le++];
      return ge;
    }
    function C(B) {
      const Q = k(B);
      if (Q)
        return Q;
      throw new Error("Non-base" + p + " character");
    }
    return {
      encode: b,
      decodeUnsafe: k,
      decode: C
    };
  }
  return cjs.default = s, cjs;
}
var hasRequiredCjs;
function requireCjs() {
  if (hasRequiredCjs) return cjs$1;
  hasRequiredCjs = 1;
  var s = cjs$1 && cjs$1.__importDefault || function(p) {
    return p && p.__esModule ? p : { default: p };
  };
  Object.defineProperty(cjs$1, "__esModule", { value: !0 });
  var A = s(requireCjs$1()), u = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  return cjs$1.default = (0, A.default)(u), cjs$1;
}
var hasRequiredXpub;
function requireXpub() {
  if (hasRequiredXpub) return xpub;
  hasRequiredXpub = 1;
  var s = xpub && xpub.__createBinding || (Object.create ? function(k, C, B, Q) {
    Q === void 0 && (Q = B);
    var P = Object.getOwnPropertyDescriptor(C, B);
    (!P || ("get" in P ? !C.__esModule : P.writable || P.configurable)) && (P = { enumerable: !0, get: function() {
      return C[B];
    } }), Object.defineProperty(k, Q, P);
  } : function(k, C, B, Q) {
    Q === void 0 && (Q = B), k[Q] = C[B];
  }), A = xpub && xpub.__setModuleDefault || (Object.create ? function(k, C) {
    Object.defineProperty(k, "default", { enumerable: !0, value: C });
  } : function(k, C) {
    k.default = C;
  }), u = xpub && xpub.__importStar || function(k) {
    if (k && k.__esModule) return k;
    var C = {};
    if (k != null) for (var B in k) B !== "default" && Object.prototype.hasOwnProperty.call(k, B) && s(C, k, B);
    return A(C, k), C;
  }, p = xpub && xpub.__importDefault || function(k) {
    return k && k.__esModule ? k : { default: k };
  };
  Object.defineProperty(xpub, "__esModule", { value: !0 }), xpub.createExtendedPubkey = void 0;
  const t = u(requireCryptoBrowserify()), l = p(requireCjs());
  function m(k) {
    return t.createHash("sha256").update(t.createHash("sha256").update(k).digest()).digest();
  }
  function b(k, C = 0, B = Buffer.from("00000000", "hex"), Q = 0, P = Buffer.from("0000000000000000000000000000000000000000000000000000000000000000", "hex"), x) {
    let M;
    if (k === "Mainnet")
      M = Buffer.from("0488b21e", "hex");
    else if (k === "Testnet")
      M = Buffer.from("043587cf", "hex");
    else
      throw new Error("Invalid network. Use 'Mainnet' or 'Testnet'.");
    const F = Buffer.concat([
      M,
      Buffer.from([C]),
      B,
      Buffer.from([
        Q >> 24,
        Q >> 16 & 255,
        Q >> 8 & 255,
        Q & 255
      ]),
      P,
      x
      // 33 bytes: compressed public key
    ]), le = m(F).slice(0, 4);
    return l.default.encode(Buffer.concat([F, le]));
  }
  return xpub.createExtendedPubkey = b, xpub;
}
var hasRequiredBabylon$1;
function requireBabylon$1() {
  if (hasRequiredBabylon$1) return babylon$1;
  hasRequiredBabylon$1 = 1;
  var s = babylon$1 && babylon$1.__importDefault || function(rr) {
    return rr && rr.__esModule ? rr : { default: rr };
  };
  Object.defineProperty(babylon$1, "__esModule", { value: !0 }), babylon$1.tryParsePsbt = babylon$1.stakingTxPolicy = babylon$1.timelockPathPolicy = babylon$1.unbondingPathPolicy = babylon$1.slashingPathPolicy = babylon$1.formatKey = babylon$1.computeLeafHash = babylon$1.signMessage = babylon$1.validadteAddress = babylon$1.signPsbt = void 0;
  const A = requireCryptoBrowserify(), u = requireMain$2(), p = requireBuild(), t = /* @__PURE__ */ requireLib$1(), l = /* @__PURE__ */ requireBtcSigner(), m = s(requireAppClient$1()), b = requireBuffertools$1(), k = requirePolicy$1(), C = requireBip322$1(), B = requirePsbt(), Q = requireTypes$1(), P = requireXpub();
  async function x({ transport: rr, psbt: er, policy: ir }) {
    const sr = new m.default(rr), nr = er instanceof Uint8Array ? t.base64.encode(er) : er, fr = await sr.signPsbt(nr, ir, null), lr = !!(0, B.getTaprootScript)(nr), br = l.Transaction.fromPSBT(t.base64.decode(nr));
    for (const Br of fr) {
      const Fr = Br[0];
      lr ? br.updateInput(Fr, {
        tapScriptSig: [
          [
            {
              pubKey: Br[1].pubkey,
              leafHash: Br[1].tapleafHash
            },
            Br[1].signature
          ]
        ]
      }, !0) : br.updateInput(Fr, {
        tapKeySig: Br[1].signature
      }, !0);
    }
    return br;
  }
  babylon$1.signPsbt = x;
  function M(rr) {
    try {
      const { prefix: er, data: ir } = (0, p.fromBech32)(rr);
      if (ir.length === 20 && er.length <= 10)
        return { prefix: er, data: ir };
      console.log("Validation FAILED - data.length:", ir.length, "prefix.length:", er.length);
    } catch (er) {
      console.log("fromBech32 threw error:", er);
    }
  }
  babylon$1.validadteAddress = M;
  async function F(rr) {
    var er;
    const ir = (er = rr.derivationPath) !== null && er !== void 0 ? er : "m/86'/0'/0'";
    if (rr.type === "bip322-simple") {
      const { transport: fr, message: lr, addressType: br = Q.AddressType.p2tr, isTestnet: Br = !1 } = rr;
      return ge({
        transport: fr,
        message: lr,
        addressType: br,
        derivationPath: ir,
        isTestnet: Br
      });
    }
    const { transport: sr, message: nr } = rr;
    return le({
      transport: sr,
      message: nr,
      derivationPath: ir
    });
  }
  babylon$1.signMessage = F;
  async function le({ transport: rr, message: er, derivationPath: ir = "m/86'/0'/0'" }) {
    return {
      signature: await new m.default(rr).signMessage(Buffer.from(er), `${ir}/0/0`),
      protocol: Q.MessageSigningProtocols.ECDSA
    };
  }
  async function ge({ transport: rr, message: er, addressType: ir = Q.AddressType.p2tr, derivationPath: sr = "m/86'/0'/0'", isTestnet: nr = !1 }) {
    const fr = new m.default(rr);
    return ir === Q.AddressType.p2tr ? (0, C.createTaprootBip322Signature)({
      message: er,
      app: fr,
      derivationPath: sr,
      isTestnet: nr
    }) : (0, C.createSegwitBip322Signature)({
      message: er,
      app: fr,
      derivationPath: sr,
      isTestnet: nr
    });
  }
  function pe(rr) {
    const er = rr instanceof Uint8Array ? t.base64.encode(rr) : rr, ir = (0, B.getTaprootScript)(er);
    if (!ir)
      throw new Error("The psbt does not contain a taproot script.");
    return (0, B.getLeafHash)(ir);
  }
  babylon$1.computeLeafHash = pe;
  function Ie(rr, er) {
    const ir = rr instanceof Buffer ? rr : Buffer.from(rr, "hex");
    return (0, P.createExtendedPubkey)(er ? "Testnet" : "Mainnet", 0, Buffer.from("00000000", "hex"), 0, (0, A.createHash)("sha256").update(ir).digest().subarray(0, 32), Buffer.concat([Buffer.from("02", "hex"), ir]));
  }
  babylon$1.formatKey = Ie;
  async function be(rr, er) {
    const ir = new m.default(rr), sr = await ir.getMasterFingerprint(), nr = await ir.getExtendedPubkey(er);
    return [sr, nr];
  }
  function Pe(rr) {
    if (!rr || rr.length === 0)
      throw new Error("Must provide at least one finality provider.");
    if (rr.length > 1)
      throw new Error("Currently only a single finality provider is supported.");
    return rr[0];
  }
  function Te(rr, er) {
    if (rr < 2)
      throw new Error(`Invalid value for covenantThreshold: ${rr}. It should be greater than or equal to 2.`);
    const ir = er ? er.length : 0;
    if (ir < 2)
      throw new Error(`covenantPks must have at least 2 elements. Current length: ${ir}`);
    if (ir < rr)
      throw new Error(`The length of covenantPks (${ir}) is less than the required covenantThreshold (${rr}).`);
    if (new Set(er).size < ir)
      throw new Error("All covenantPks must be unique");
    return er.map((sr) => Buffer.from(sr, "hex")).sort(Buffer.compare).map((sr) => sr.toString("hex"));
  }
  async function Qe({ policyName: rr = "Consent to slashing", transport: er, params: ir, derivationPath: sr, displayLeafHash: nr = !0, isTestnet: fr = !1 }) {
    sr = sr || `m/86'/${fr ? 1 : 0}'/0'`;
    const { leafHash: lr, timelockBlocks: br, finalityProviders: Br, covenantThreshold: Fr, covenantPks: Gr, slashingPkScriptHex: qr, slashingFeeSat: Hr } = ir, [un, Dr] = await be(er, sr), wr = [], yr = nr ? Q.MagicCode.LEAFHASH_DISPLAY_FP : Q.MagicCode.LEAFHASH_CHECK_ONLY_FP;
    wr.push(`[${sr.replace("m/", `${yr}/`)}]${Ie(lr, fr)}`), wr.push(`[${sr.replace("m/", `${un}/`)}]${Dr}`);
    const Qr = Pe(Br);
    wr.push(`[${sr.replace("m/", `${Q.MagicCode.FINALITY_PUB_FP}/`)}]${Ie(Qr, fr)}`);
    const _r = Te(Fr, Gr), Jr = _r.length;
    for (let jr = 0; jr < Jr; jr++) {
      const dn = _r[jr];
      wr.push(Ie(dn, fr));
    }
    wr.push(Ie(qr.padEnd(64, "0"), fr)), wr.push(Ie((0, b.numberToLE)(Hr), fr));
    const fn = `tr(@0/**,and_v(and_v(pk_k(@1/**),and_v(pk_k(@2/**),multi_a(${Fr},${Array.from({ length: Jr }, (jr, dn) => dn).map((jr) => `@${3 + jr}/**`).join(",")},@${3 + Jr}/**,@${3 + Jr + 1}/**))),older(${br})))`;
    return new k.WalletPolicy(rr, fn, wr);
  }
  babylon$1.slashingPathPolicy = Qe;
  async function xe({ policyName: rr = "Unbonding", transport: er, params: ir, derivationPath: sr, displayLeafHash: nr = !0, isTestnet: fr = !1 }) {
    sr = sr || `m/86'/${fr ? 1 : 0}'/0'`;
    const { leafHash: lr, timelockBlocks: br, finalityProviders: Br, covenantThreshold: Fr, covenantPks: Gr, unbondingFeeSat: qr } = ir, [Hr, un] = await be(er, sr), Dr = [], wr = nr ? Q.MagicCode.LEAFHASH_DISPLAY_FP : Q.MagicCode.LEAFHASH_CHECK_ONLY_FP;
    Dr.push(`[${sr.replace("m/", `${wr}/`)}]${Ie(lr, fr)}`), Dr.push(`[${sr.replace("m/", `${Hr}/`)}]${un}`);
    const yr = Pe(Br);
    Dr.push(`[${sr.replace("m/", `${Q.MagicCode.FINALITY_PUB_FP}/`)}]${Ie(yr, fr)}`);
    const Qr = Te(Fr, Gr), _r = Qr.length;
    for (let fn = 0; fn < _r; fn++) {
      const jr = Qr[fn];
      Dr.push(Ie(jr, fr));
    }
    Dr.push(Ie((0, b.numberToLE)(qr), fr));
    const Jr = `tr(@0/**,and_v(and_v(pk_k(@1/**),and_v(pk_k(@2/**),multi_a(${Fr},${Array.from({ length: _r }, (fn, jr) => jr).map((fn) => `@${3 + fn}/**`).join(",")},@${3 + _r}/**))),older(${br})))`;
    return new k.WalletPolicy(rr, Jr, Dr);
  }
  babylon$1.unbondingPathPolicy = xe;
  async function Ee({ policyName: rr = "Withdraw", transport: er, params: ir, derivationPath: sr, displayLeafHash: nr = !0, isTestnet: fr = !1 }) {
    sr = sr || `m/86'/${fr ? 1 : 0}'/0'`;
    const { leafHash: lr, timelockBlocks: br } = ir, [Br, Fr] = await be(er, sr), Gr = [], qr = nr ? Q.MagicCode.LEAFHASH_DISPLAY_FP : Q.MagicCode.LEAFHASH_CHECK_ONLY_FP;
    Gr.push(`[${sr.replace("m/", `${qr}/`)}]${Ie(lr, fr)}`), Gr.push(`[${sr.replace("m/", `${Br}/`)}]${Fr}`);
    const Hr = `tr(@0/**,and_v(pk_k(@1/**),older(${br})))`;
    return new k.WalletPolicy(rr, Hr, Gr);
  }
  babylon$1.timelockPathPolicy = Ee;
  async function He({ policyName: rr = "Staking transaction", transport: er, params: ir, derivationPath: sr, isTestnet: nr = !1 }) {
    sr = sr || `m/86'/${nr ? 1 : 0}'/0'`;
    const { timelockBlocks: fr, finalityProviders: lr, covenantThreshold: br, covenantPks: Br } = ir, [Fr, Gr] = await be(er, sr), qr = [];
    qr.push("[69846d00/86'/1'/0']tpubD6NzVbkrYhZ4WLczPJWReQycCJdd6YVWXubbVUFnJ5KgU5MDQrD998ZJLSmaB7GVcCnJSDWprxmrGkJ6SvgQC6QAffVpqSvonXmeizXcrkN"), qr.push(`[${sr.replace("m/", `${Fr}/`)}]${Gr}`);
    const Hr = Pe(lr);
    qr.push(`[${sr.replace("m/", `${Q.MagicCode.FINALITY_PUB_FP}/`)}]${Ie(Hr, nr)}`);
    const un = Te(br, Br), Dr = un.length;
    for (let yr = 0; yr < Dr; yr++) {
      const Qr = un[yr];
      qr.push(Ie(Qr, nr));
    }
    const wr = `tr(@0/**,and_v(and_v(pk_k(@1/**),and_v(pk_k(@2/**),multi_a(${br},${Array.from({ length: Dr }, (yr, Qr) => Qr).map((yr) => `@${3 + yr}/**`).join(",")}))),older(${fr})))`;
    return new k.WalletPolicy(rr, wr, qr);
  }
  babylon$1.stakingTxPolicy = He;
  const ve = /^([a-f0-9]{64}) OP_CHECKSIGVERIFY OP_(0|[1-9]|1[0-6]) OP_CHECKSEQUENCEVERIFY$/, we = /^([a-f0-9]{64}) OP_CHECKSIGVERIFY ([a-f0-9]{2,6}) OP_CHECKSEQUENCEVERIFY$/;
  function Ce(rr) {
    var er, ir;
    if (rr.length % 2 !== 0)
      throw new Error("Invalid timelock: odd-length hex string");
    return (ir = (er = rr.match(/.{2}/g)) === null || er === void 0 ? void 0 : er.reverse().join("")) !== null && ir !== void 0 ? ir : "";
  }
  function Se(rr) {
    const er = rr.join(" ");
    let ir = er.match(ve);
    if (ir) {
      const [, lr, br] = ir;
      return [lr, Number(br).toString(16)];
    }
    if (ir = er.match(we), !ir)
      return;
    const [sr, nr, fr] = ir;
    return [nr, Ce(fr)];
  }
  async function Ne(rr, er, ir = !1, sr) {
    const nr = `m/86'/${ir ? 1 : 0}'/0'`, fr = (0, B.getTaprootScript)(er);
    if (!fr)
      throw new Error("No script found in psbt");
    sr = sr || pe(er);
    const lr = u.Script.decode(fr), br = Se(lr);
    if (br)
      return Ee({
        transport: rr,
        params: {
          leafHash: sr,
          timelockBlocks: +`0x${br[br.length - 1]}`
        },
        derivationPath: nr,
        isTestnet: ir
      });
  }
  return babylon$1.tryParsePsbt = Ne, babylon$1;
}
var hasRequiredMain$1;
function requireMain$1() {
  return hasRequiredMain$1 || (hasRequiredMain$1 = 1, function(s) {
    var A = main$3 && main$3.__createBinding || (Object.create ? function(k, C, B, Q) {
      Q === void 0 && (Q = B);
      var P = Object.getOwnPropertyDescriptor(C, B);
      (!P || ("get" in P ? !C.__esModule : P.writable || P.configurable)) && (P = { enumerable: !0, get: function() {
        return C[B];
      } }), Object.defineProperty(k, Q, P);
    } : function(k, C, B, Q) {
      Q === void 0 && (Q = B), k[Q] = C[B];
    }), u = main$3 && main$3.__setModuleDefault || (Object.create ? function(k, C) {
      Object.defineProperty(k, "default", { enumerable: !0, value: C });
    } : function(k, C) {
      k.default = C;
    }), p = main$3 && main$3.__importStar || function(k) {
      if (k && k.__esModule) return k;
      var C = {};
      if (k != null) for (var B in k) B !== "default" && Object.prototype.hasOwnProperty.call(k, B) && A(C, k, B);
      return u(C, k), C;
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), s.tryParsePsbt = s.signPsbt = s.stakingTxPolicy = s.timelockPathPolicy = s.unbondingPathPolicy = s.slashingPathPolicy = s.computeLeafHash = s.signMessage = s.PartialSignature = s.PsbtV2 = s.AppClient = s.WalletPolicy = s.DefaultWalletPolicy = void 0;
    const t = p(requireAppClient$1());
    s.AppClient = t.default, Object.defineProperty(s, "PartialSignature", { enumerable: !0, get: function() {
      return t.PartialSignature;
    } });
    const l = requirePolicy$1();
    Object.defineProperty(s, "DefaultWalletPolicy", { enumerable: !0, get: function() {
      return l.DefaultWalletPolicy;
    } }), Object.defineProperty(s, "WalletPolicy", { enumerable: !0, get: function() {
      return l.WalletPolicy;
    } });
    const m = requireBabylon$1();
    Object.defineProperty(s, "computeLeafHash", { enumerable: !0, get: function() {
      return m.computeLeafHash;
    } }), Object.defineProperty(s, "signMessage", { enumerable: !0, get: function() {
      return m.signMessage;
    } }), Object.defineProperty(s, "tryParsePsbt", { enumerable: !0, get: function() {
      return m.tryParsePsbt;
    } }), Object.defineProperty(s, "signPsbt", { enumerable: !0, get: function() {
      return m.signPsbt;
    } }), Object.defineProperty(s, "slashingPathPolicy", { enumerable: !0, get: function() {
      return m.slashingPathPolicy;
    } }), Object.defineProperty(s, "stakingTxPolicy", { enumerable: !0, get: function() {
      return m.stakingTxPolicy;
    } }), Object.defineProperty(s, "timelockPathPolicy", { enumerable: !0, get: function() {
      return m.timelockPathPolicy;
    } }), Object.defineProperty(s, "unbondingPathPolicy", { enumerable: !0, get: function() {
      return m.unbondingPathPolicy;
    } });
    const b = requirePsbtv2$1();
    Object.defineProperty(s, "PsbtV2", { enumerable: !0, get: function() {
      return b.PsbtV2;
    } }), s.default = t.default;
  }(main$3)), main$3;
}
var mainExports$1 = requireMain$1();
const AppClient$1 = /* @__PURE__ */ getDefaultExportFromCjs(mainExports$1);
var ActionName = /* @__PURE__ */ ((s) => (s.SIGN_BTC_STAKING_TRANSACTION = "sign-btc-staking-transaction", s.SIGN_BTC_STAKING_EXPANSION_TRANSACTION = "sign-btc-staking-expansion-transaction", s.SIGN_BTC_UNBONDING_TRANSACTION = "sign-btc-unbonding-transaction", s.SIGN_BTC_WITHDRAW_TRANSACTION = "sign-btc-withdraw-transaction", s.SIGN_BTC_SLASHING_TRANSACTION = "sign-btc-slashing-transaction", s.SIGN_BTC_UNBONDING_SLASHING_TRANSACTION = "sign-btc-unbonding-slashing-transaction", s))(ActionName || {});
const BABYLON_SIGNING_CONTRACTS = {
  STAKING: "babylon:staking",
  STAKING_EXPANSION: "babylon:staking-expansion",
  UNBONDING: "babylon:unbonding",
  SLASHING: "babylon:slashing",
  SLASHING_BURN: "babylon:slashing-burn",
  WITHDRAW: "babylon:withdraw"
}, sortPkHexes = (s) => s.map((A) => Buffer.from(A, "hex")).sort(Buffer.compare).map((A) => A.toString("hex")), UNBONDING_POLICY = "Unbonding", SLASHING_POLICY = "Consent to slashing", UNBONDING_SLASHING_POLICY = "Consent to unbonding slashing", STAKING_POLICY = "Staking transaction", WITHDRAWAL_POLICY = "Withdraw", getPolicyForTransaction$1 = async (s, A, u, p, {
  contracts: t,
  action: l
}) => {
  const m = A !== Network.MAINNET;
  switch (l.name) {
    case ActionName.SIGN_BTC_STAKING_TRANSACTION:
      return getStakingPolicy$1(t, u, s, m);
    case ActionName.SIGN_BTC_STAKING_EXPANSION_TRANSACTION:
      throw new Error("Staking expansion transactions are not yet supported on Ledger app.");
    case ActionName.SIGN_BTC_UNBONDING_TRANSACTION:
      return getUnbondingPolicy$1(t, u, s, m, p);
    case ActionName.SIGN_BTC_SLASHING_TRANSACTION:
      return getSlashingPolicy$1(t, u, s, m, p);
    case ActionName.SIGN_BTC_UNBONDING_SLASHING_TRANSACTION:
      return getUnbondingSlashingPolicy$1(t, u, s, m, p);
    case ActionName.SIGN_BTC_WITHDRAW_TRANSACTION:
      return getWithdrawPolicy$1(t, u, p, s, m);
    default:
      throw new Error(`Unknown action: ${l.name}`);
  }
}, getStakingPolicy$1 = (s, A, u, p) => {
  const t = s.find((C) => C.id === BABYLON_SIGNING_CONTRACTS.STAKING);
  if (!t)
    throw new Error("Staking contract is required");
  const { finalityProviders: l, covenantThreshold: m, covenantPks: b, stakingDuration: k } = t.params;
  return mainExports$1.stakingTxPolicy({
    policyName: STAKING_POLICY,
    transport: u,
    params: {
      finalityProviders: l,
      covenantThreshold: m,
      covenantPks: sortPkHexes(b),
      timelockBlocks: k
    },
    derivationPath: A,
    isTestnet: p
  });
}, getUnbondingPolicy$1 = (s, A, u, p, t) => {
  const l = s.find((P) => P.id === BABYLON_SIGNING_CONTRACTS.UNBONDING);
  if (!l)
    throw new Error("Unbonding contract is required");
  const m = mainExports$1.computeLeafHash(t);
  if (!m)
    throw new Error("Could not compute leaf hash");
  const { finalityProviders: b, covenantThreshold: k, covenantPks: C, unbondingTimeBlocks: B, unbondingFeeSat: Q } = l.params;
  return mainExports$1.unbondingPathPolicy({
    policyName: UNBONDING_POLICY,
    transport: u,
    params: {
      finalityProviders: b,
      covenantThreshold: k,
      covenantPks: sortPkHexes(C),
      leafHash: m,
      timelockBlocks: B,
      unbondingFeeSat: Q
    },
    derivationPath: A,
    isTestnet: p
  });
}, getSlashingPolicy$1 = (s, A, u, p, t) => {
  const l = s.find((F) => F.id === BABYLON_SIGNING_CONTRACTS.SLASHING);
  if (!l)
    throw new Error("Slashing contract is required in slashing transaction");
  const m = s.find((F) => F.id === BABYLON_SIGNING_CONTRACTS.STAKING);
  if (!m)
    throw new Error("Staking contract is required in slashing transaction");
  const b = s.find((F) => F.id === BABYLON_SIGNING_CONTRACTS.SLASHING_BURN);
  if (!b)
    throw new Error("Slashing burn contract is required in unbonding slashing transaction");
  const { unbondingTimeBlocks: k, slashingFeeSat: C } = l.params, { covenantPks: B, finalityProviders: Q, covenantThreshold: P } = m.params, { slashingPkScriptHex: x } = b.params, M = mainExports$1.computeLeafHash(t);
  if (!M)
    throw new Error("Could not compute leaf hash");
  return mainExports$1.slashingPathPolicy({
    policyName: SLASHING_POLICY,
    transport: u,
    params: {
      leafHash: M,
      timelockBlocks: k,
      finalityProviders: Q,
      covenantThreshold: P,
      covenantPks: sortPkHexes(B),
      slashingPkScriptHex: x,
      slashingFeeSat: C
    },
    derivationPath: A,
    isTestnet: p
  });
}, getUnbondingSlashingPolicy$1 = (s, A, u, p, t) => {
  const l = s.find((F) => F.id === BABYLON_SIGNING_CONTRACTS.SLASHING);
  if (!l)
    throw new Error("Slashing contract is required in unbonding slashing transaction");
  const m = s.find((F) => F.id === BABYLON_SIGNING_CONTRACTS.UNBONDING);
  if (!m)
    throw new Error("Unbonding contract is required in unbonding slashing transaction");
  const b = s.find((F) => F.id === BABYLON_SIGNING_CONTRACTS.SLASHING_BURN);
  if (!b)
    throw new Error("Slashing burn contract is required in unbonding slashing transaction");
  const { unbondingTimeBlocks: k, slashingFeeSat: C } = l.params, { covenantPks: B, finalityProviders: Q, covenantThreshold: P } = m.params, { slashingPkScriptHex: x } = b.params, M = mainExports$1.computeLeafHash(t);
  if (!M)
    throw new Error("Could not compute leaf hash");
  return mainExports$1.slashingPathPolicy({
    policyName: UNBONDING_SLASHING_POLICY,
    transport: u,
    params: {
      leafHash: M,
      timelockBlocks: k,
      finalityProviders: Q,
      covenantThreshold: P,
      covenantPks: sortPkHexes(B),
      slashingPkScriptHex: x,
      slashingFeeSat: C
    },
    derivationPath: A,
    isTestnet: p
  });
}, getWithdrawPolicy$1 = (s, A, u, p, t) => {
  const l = s.find((k) => k.id === BABYLON_SIGNING_CONTRACTS.WITHDRAW);
  if (!l)
    throw new Error("Withdraw timelock expired contract is required");
  const { timelockBlocks: m } = l.params, b = mainExports$1.computeLeafHash(u);
  if (!b)
    throw new Error("Could not compute leaf hash");
  return mainExports$1.timelockPathPolicy({
    policyName: WITHDRAWAL_POLICY,
    transport: p,
    params: {
      leafHash: b,
      timelockBlocks: m
    },
    derivationPath: A,
    isTestnet: t
  });
}, WALLET_PROVIDER_NAME$5 = "Ledger";
class LedgerProvider {
  constructor(A, u) {
    Ci(this, "ledgerWalletInfo");
    Ci(this, "config");
    Ci(this, "connectWallet", async () => {
      const A = await this.createAppClient(), u = await A.getMasterFingerprint(), p = this.getDerivationPath(), t = await A.getExtendedPubkey(p), l = await this.getWalletPolicy(A, u, p);
      if (!l) throw new Error("Could not retrieve the policy");
      const { address: m, publicKeyHex: b } = await this.getTaprootAccount(
        A,
        l,
        t
      );
      this.ledgerWalletInfo = {
        app: A,
        policy: l,
        mfp: u,
        extendedPublicKey: t,
        path: p,
        address: m,
        publicKeyHex: b
      };
    });
    Ci(this, "getAddress", async () => {
      var A;
      if (!((A = this.ledgerWalletInfo) != null && A.address)) throw new Error("Could not retrieve the address");
      return this.ledgerWalletInfo.address;
    });
    Ci(this, "getPublicKeyHex", async () => {
      var A;
      if (!((A = this.ledgerWalletInfo) != null && A.publicKeyHex)) throw new Error("Could not retrieve the BTC public key");
      return this.ledgerWalletInfo.publicKeyHex;
    });
    Ci(this, "signPsbt", async (A, u) => {
      var C, B, Q;
      if (!((C = this.ledgerWalletInfo) != null && C.address) || !((B = this.ledgerWalletInfo) != null && B.publicKeyHex))
        throw new Error("Ledger is not connected");
      if (!A) throw new Error("psbt hex is required");
      const p = Buffer$1.from(A, "hex").toString("base64"), t = this.ledgerWalletInfo.app.transport;
      if (!t || !(t instanceof Transport))
        throw new Error("Transport is required to sign psbt");
      if (!this.ledgerWalletInfo.path)
        throw new Error("Derivation path is required to sign psbt");
      if (!(u != null && u.contracts) || (u == null ? void 0 : u.contracts.length) === 0)
        throw new Error("Contracts are required to sign psbt in ledger");
      if (!((Q = u == null ? void 0 : u.action) != null && Q.name))
        throw new Error("Action name is required to sign psbt in ledger");
      const l = await getPolicyForTransaction$1(
        t,
        this.config.network,
        this.ledgerWalletInfo.path,
        p,
        {
          contracts: u.contracts,
          action: u.action
        }
      ), m = await mainExports$1.signPsbt({
        transport: t,
        psbt: p,
        policy: l
      }), b = Transaction.fromPSBT(m.toPSBT(), {
        allowUnknownInputs: !0,
        allowUnknownOutputs: !0
      });
      return b.finalize(), Buffer$1.from(b.toPSBT()).toString("hex");
    });
    Ci(this, "signPsbts", async (A, u) => {
      var t, l, m;
      if (!((t = this.ledgerWalletInfo) != null && t.address) || !((l = this.ledgerWalletInfo) != null && l.publicKeyHex) || !((m = this.ledgerWalletInfo) != null && m.policy))
        throw new Error("Ledger is not connected");
      if (!A || !Array.isArray(A) || A.length === 0)
        throw new Error("psbts hexes are required");
      const p = [];
      for (let b = 0; b < A.length; b++) {
        const k = A[b], C = u ? u[b] : void 0;
        if (!k)
          throw new Error(`psbt hex at index ${b} is required`);
        if (typeof k != "string")
          throw new Error(`psbt hex at index ${b} must be a string`);
        const B = await this.signPsbt(k, C);
        p.push(B);
      }
      return p;
    });
    Ci(this, "getNetwork", async () => this.config.network);
    Ci(this, "signMessage", async (A, u) => {
      var l, m, b;
      if (!((l = this.ledgerWalletInfo) != null && l.app.transport) || !((m = this.ledgerWalletInfo) != null && m.path))
        throw new Error("Ledger is not connected");
      const p = this.config.network !== Network.MAINNET;
      return (await mainExports$1.signMessage({
        transport: (b = this.ledgerWalletInfo) == null ? void 0 : b.app.transport,
        message: A,
        type: u,
        isTestnet: p,
        derivationPath: this.ledgerWalletInfo.path
      })).signature;
    });
    Ci(this, "getInscriptions", async () => {
      throw new Error("Method not implemented.");
    });
    // Not implemented because of the hardware wallet nature
    Ci(this, "on", () => {
    });
    Ci(this, "off", () => {
    });
    Ci(this, "getWalletProviderName", async () => WALLET_PROVIDER_NAME$5);
    Ci(this, "getWalletProviderIcon", async () => logo$4);
    this.config = u;
  }
  // Create a transport instance for Ledger devices
  // It first tries to create a WebUSB transport
  // and if that fails, it falls back to WebHID
  async createTransport() {
    try {
      return await TransportWebUSB.create();
    } catch (A) {
      try {
        return await TransportWebHID.create();
      } catch (u) {
        throw new Error(
          `Could not connect to Ledger device: ${A.message || A}, ${u.message || u}`
        );
      }
    }
  }
  // Get the network derivation index based on the network
  // 0 for MAINNET, 1 for TESTNET
  getNetworkDerivationIndex() {
    return this.config.network === Network.MAINNET ? 0 : 1;
  }
  getDerivationPath() {
    return `m/86'/${this.getNetworkDerivationIndex()}'/0'`;
  }
  // Create a new AppClient instance using the transport
  async createAppClient() {
    const A = await this.createTransport();
    return new AppClient$1(A);
  }
  async getWalletPolicy(A, u, p) {
    const t = await A.getExtendedPubkey(p);
    if (!t)
      throw new Error("Could not retrieve the extended public key for policy");
    const l = this.getNetworkDerivationIndex(), m = new mainExports$1.DefaultWalletPolicy("tr(@0/**)", `[${u}/86'/${l}'/0']${t}`);
    if (!m)
      throw new Error("Could not create the wallet policy");
    return m;
  }
  async getTaprootAccount(A, u, p) {
    const t = await A.getWalletAddress(
      u,
      null,
      0,
      // 0 - normal, 1 - change
      0,
      // address index
      !0
      // show address on the wallet's screen
    ), l = await this.getNetwork(), m = getPublicKeyFromXpub(p, "M/0/0", toNetwork(l));
    return { address: t, publicKeyHex: m.toString("hex") };
  }
}
const metadata$8 = {
  id: "ledger_btc",
  name: WALLET_PROVIDER_NAME$5,
  icon: logo$4,
  docs: "https://www.ledger.com/ledger-live",
  createProvider: (s, A) => new LedgerProvider(s, A),
  networks: [Network.SIGNET, Network.MAINNET],
  label: "Hardware wallet"
}, logo$3 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='157'%20height='157'%3e%3cpath%20fill='%23000'%20fill-rule='nonzero'%20d='M5%20106.655V143h55.308v-8.06h-47.25v-28.285H5Zm138.98%200v28.285H96.731v8.058h55.308v-36.343h-8.059Zm-83.592-55.31v55.308h36.343v-7.269H68.446V51.345h-8.058ZM5%2015v36.345h8.058V23.058h47.25V15H5Zm91.731%200v8.058h47.249v28.287h8.059V15H96.731Z'/%3e%3c/svg%3e";
var main = {}, appClient = {}, bip32 = {}, hasRequiredBip32;
function requireBip32() {
  if (hasRequiredBip32) return bip32;
  hasRequiredBip32 = 1;
  var s = bip32 && bip32.__importDefault || function(B) {
    return B && B.__esModule ? B : { default: B };
  };
  Object.defineProperty(bip32, "__esModule", { value: !0 }), bip32.hardenedPathOf = bip32.getXpubComponents = bip32.pubkeyFromXpub = bip32.pathStringToArray = bip32.pathArrayToString = bip32.bip32asBuffer = bip32.pathElementsToBuffer = void 0;
  const A = s(requireBip32Path()), u = s(requireBs58check$1());
  function p(B) {
    const Q = Buffer.alloc(1 + B.length * 4);
    return Q[0] = B.length, B.forEach((P, x) => {
      Q.writeUInt32BE(P, 1 + 4 * x);
    }), Q;
  }
  bip32.pathElementsToBuffer = p;
  function t(B) {
    const Q = B ? m(B) : [];
    return p(Q);
  }
  bip32.bip32asBuffer = t;
  function l(B) {
    return B.length == 0 ? "m" : A.default.fromPathArray(B).toString();
  }
  bip32.pathArrayToString = l;
  function m(B) {
    return B == "m" || B == "" ? [] : A.default.fromString(B).toPathArray();
  }
  bip32.pathStringToArray = m;
  function b(B) {
    const Q = Buffer.from(u.default.decode(B));
    return Q.slice(Q.length - 33);
  }
  bip32.pubkeyFromXpub = b;
  function k(B) {
    const Q = Buffer.from(u.default.decode(B));
    return {
      chaincode: Q.slice(13, 45),
      pubkey: Q.slice(Q.length - 33),
      version: Q.readUInt32BE(0)
    };
  }
  bip32.getXpubComponents = k;
  function C(B) {
    for (let Q = B.length - 1; Q >= 0; Q--)
      if (B[Q] >= 2147483648)
        return B.slice(0, Q + 1);
    return [];
  }
  return bip32.hardenedPathOf = C, bip32;
}
var clientCommands = {}, buffertools = {}, varint = {}, hasRequiredVarint;
function requireVarint() {
  if (hasRequiredVarint) return varint;
  hasRequiredVarint = 1, Object.defineProperty(varint, "__esModule", { value: !0 }), varint.createVarint = varint.parseVarint = varint.sanitizeBigintToNumber = void 0;
  function s(m, b, k, C) {
    for (let B = 0; B < b; B++) {
      if (k[B + C] == null)
        throw Error("Buffer too small");
      k[B + C] = Number(m % BigInt(256)), m = m >> BigInt(8);
    }
  }
  function A(m, b, k) {
    let C = BigInt(0);
    for (let B = 0; B < k; B++) {
      if (m[B + b] == null)
        throw Error("Buffer too small");
      C += BigInt(m[B + b]) << BigInt(B * 8);
    }
    return C;
  }
  function u(m) {
    if (m < 0)
      throw RangeError("Negative bigint is not a valid varint");
    if (m > Number.MAX_SAFE_INTEGER)
      throw RangeError("Too large for a Number");
    return Number(m);
  }
  varint.sanitizeBigintToNumber = u;
  function p(m) {
    if (typeof m == "number" && (m = u(m)), m < BigInt(0))
      throw new RangeError("Negative numbers are not supported");
    if (m >= BigInt(1) << BigInt(64))
      throw new RangeError("Too large for a Bitcoin-style varint");
    return m < BigInt(253) ? 1 : m <= BigInt(65535) ? 3 : m <= BigInt(4294967295) ? 5 : 9;
  }
  function t(m, b) {
    if (b < 0)
      throw RangeError("Negative offset is invalid");
    if (m[b] == null)
      throw Error("Buffer too small");
    if (m[b] < 253)
      return [BigInt(m[b]), 1];
    {
      let k;
      return m[b] === 253 ? k = 2 : m[b] === 254 ? k = 4 : k = 8, [A(m, b + 1, k), k + 1];
    }
  }
  varint.parseVarint = t;
  function l(m) {
    typeof m == "number" && (m = u(m));
    const b = p(m);
    m = BigInt(m);
    const k = Buffer.alloc(b);
    return b == 1 ? k[0] = Number(m) : (b == 3 ? k[0] = 253 : b === 5 ? k[0] = 254 : k[0] = 255, s(m, b - 1, k, 1)), k;
  }
  return varint.createVarint = l, varint;
}
var hasRequiredBuffertools;
function requireBuffertools() {
  if (hasRequiredBuffertools) return buffertools;
  hasRequiredBuffertools = 1, Object.defineProperty(buffertools, "__esModule", { value: !0 }), buffertools.BufferReader = buffertools.BufferWriter = buffertools.numberToLE = buffertools.unsafeFrom64bitLE = buffertools.unsafeTo64bitLE = void 0;
  const s = requireVarint();
  function A(m) {
    if (m > Number.MAX_SAFE_INTEGER)
      throw new Error("Can't convert numbers > MAX_SAFE_INT");
    const b = Buffer.alloc(8, 0);
    for (let k = 0; k < b.length; k++) {
      const C = m & 255;
      b[k] = C, m = (m - C) / 256;
    }
    return b;
  }
  buffertools.unsafeTo64bitLE = A;
  function u(m) {
    let b = 0;
    if (m.length != 8)
      throw new Error("Expected Bufffer of lenght 8");
    if (m[7] != 0)
      throw new Error("Can't encode numbers > MAX_SAFE_INT");
    if (m[6] > 31)
      throw new Error("Can't encode numbers > MAX_SAFE_INT");
    for (let k = m.length - 1; k >= 0; k--)
      b = b * 256 + m[k];
    return b;
  }
  buffertools.unsafeFrom64bitLE = u;
  function p(m, b = 32) {
    if (!Number.isInteger(m) || m < 0)
      throw new RangeError("value must be a non-negative integer");
    if (!Number.isInteger(b) || b < 1)
      throw new RangeError("byteLen must be a positive integer");
    const k = Math.pow(256, b);
    if (m >= k)
      throw new RangeError(`value too large to fit in ${b} bytes (max ${k - 1})`);
    const C = Buffer.alloc(b);
    let B = m;
    for (let Q = 0; Q < b; Q++)
      C[Q] = B % 256, B = Math.floor(B / 256);
    return C;
  }
  buffertools.numberToLE = p;
  class t {
    constructor() {
      this.bufs = [];
    }
    write(b, k) {
      const C = Buffer.alloc(b);
      k(C), this.bufs.push(C);
    }
    writeUInt8(b) {
      this.write(1, (k) => k.writeUInt8(b, 0));
    }
    writeInt32(b) {
      this.write(4, (k) => k.writeInt32LE(b, 0));
    }
    writeUInt32(b) {
      this.write(4, (k) => k.writeUInt32LE(b, 0));
    }
    writeUInt64(b) {
      const k = A(b);
      this.writeSlice(k);
    }
    writeVarInt(b) {
      this.bufs.push((0, s.createVarint)(b));
    }
    writeSlice(b) {
      this.bufs.push(Buffer.from(b));
    }
    writeVarSlice(b) {
      this.writeVarInt(b.length), this.writeSlice(b);
    }
    buffer() {
      return Buffer.concat(this.bufs);
    }
  }
  buffertools.BufferWriter = t;
  class l {
    constructor(b, k = 0) {
      this.buffer = b, this.offset = k;
    }
    available() {
      return this.buffer.length - this.offset;
    }
    readUInt8() {
      const b = this.buffer.readUInt8(this.offset);
      return this.offset++, b;
    }
    readInt32() {
      const b = this.buffer.readInt32LE(this.offset);
      return this.offset += 4, b;
    }
    readUInt32() {
      const b = this.buffer.readUInt32LE(this.offset);
      return this.offset += 4, b;
    }
    readUInt64() {
      const b = this.readSlice(8);
      return u(b);
    }
    readVarInt() {
      const [b, k] = (0, s.parseVarint)(this.buffer, this.offset);
      return this.offset += k, b;
    }
    readSlice(b) {
      if (this.buffer.length < this.offset + b)
        throw new Error("Cannot read slice out of bounds");
      const k = this.buffer.slice(this.offset, this.offset + b);
      return this.offset += b, k;
    }
    readVarSlice() {
      const b = (0, s.sanitizeBigintToNumber)(this.readVarInt());
      return this.readSlice(b);
    }
    readVector() {
      const b = this.readVarInt(), k = [];
      for (let C = 0; C < b; C++)
        k.push(this.readVarSlice());
      return k;
    }
  }
  return buffertools.BufferReader = l, buffertools;
}
var merkle = {}, hasRequiredMerkle;
function requireMerkle() {
  if (hasRequiredMerkle) return merkle;
  hasRequiredMerkle = 1, Object.defineProperty(merkle, "__esModule", { value: !0 }), merkle.hashLeaf = merkle.Merkle = void 0;
  const s = requireSrc$3();
  class A {
    constructor(C, B = s.crypto.sha256) {
      this.leaves = C, this.h = B;
      const Q = this.calculateRoot(C);
      this.rootNode = Q.root, this.leafNodes = Q.leaves;
    }
    getRoot() {
      return this.rootNode.hash;
    }
    size() {
      return this.leaves.length;
    }
    getLeaves() {
      return this.leaves;
    }
    getLeafHash(C) {
      return this.leafNodes[C].hash;
    }
    getProof(C) {
      if (C >= this.leaves.length)
        throw Error("Index out of bounds");
      return l(this.leafNodes[C]);
    }
    calculateRoot(C) {
      const B = C.length;
      if (B == 0)
        return {
          root: new t(void 0, void 0, Buffer.alloc(32, 0)),
          leaves: []
        };
      if (B == 1) {
        const pe = new t(void 0, void 0, C[0]);
        return { root: pe, leaves: [pe] };
      }
      const Q = m(B), P = this.calculateRoot(C.slice(0, Q)), x = this.calculateRoot(C.slice(Q)), M = P.root, F = x.root, le = this.hashNode(M.hash, F.hash), ge = new t(M, F, le);
      return M.parent = ge, F.parent = ge, { root: ge, leaves: P.leaves.concat(x.leaves) };
    }
    hashNode(C, B) {
      return this.h(Buffer.concat([Buffer.from([1]), C, B]));
    }
  }
  merkle.Merkle = A;
  function u(k, C = s.crypto.sha256) {
    return p(Buffer.from([0]), k, C);
  }
  merkle.hashLeaf = u;
  function p(k, C, B) {
    return B(Buffer.concat([k, C]));
  }
  class t {
    constructor(C, B, Q) {
      this.leftChild = C, this.rightChild = B, this.hash = Q;
    }
    isLeaf() {
      return this.leftChild == null;
    }
  }
  function l(k) {
    if (!k.parent)
      return [];
    if (k.parent.leftChild == k) {
      if (!k.parent.rightChild)
        throw new Error("Expected right child to exist");
      return [k.parent.rightChild.hash, ...l(k.parent)];
    } else {
      if (!k.parent.leftChild)
        throw new Error("Expected left child to exist");
      return [k.parent.leftChild.hash, ...l(k.parent)];
    }
  }
  function m(k) {
    if (k < 2)
      throw Error("Expected n >= 2");
    return b(k) ? k / 2 : 1 << Math.floor(Math.log2(k));
  }
  function b(k) {
    return (k & k - 1) == 0;
  }
  return merkle;
}
var hasRequiredClientCommands;
function requireClientCommands() {
  if (hasRequiredClientCommands) return clientCommands;
  hasRequiredClientCommands = 1, Object.defineProperty(clientCommands, "__esModule", { value: !0 }), clientCommands.ClientCommandInterpreter = clientCommands.GetMoreElementsCommand = clientCommands.GetMerkleLeafIndexCommand = clientCommands.GetMerkleLeafProofCommand = clientCommands.GetPreimageCommand = clientCommands.YieldCommand = void 0;
  const s = requireSrc$3(), A = requireBuffertools(), u = requireMerkle(), p = requireVarint();
  var t;
  (function(P) {
    P[P.YIELD = 16] = "YIELD", P[P.GET_PREIMAGE = 64] = "GET_PREIMAGE", P[P.GET_MERKLE_LEAF_PROOF = 65] = "GET_MERKLE_LEAF_PROOF", P[P.GET_MERKLE_LEAF_INDEX = 66] = "GET_MERKLE_LEAF_INDEX", P[P.GET_MORE_ELEMENTS = 160] = "GET_MORE_ELEMENTS";
  })(t || (t = {}));
  class l {
  }
  class m extends l {
    constructor(x, M) {
      super(), this.progressCallback = M, this.code = t.YIELD, this.results = x;
    }
    execute(x) {
      return this.results.push(Buffer.from(x.subarray(1))), this.progressCallback && this.progressCallback(), Buffer.from("");
    }
  }
  clientCommands.YieldCommand = m;
  class b extends l {
    constructor(x, M) {
      super(), this.code = t.GET_PREIMAGE, this.known_preimages = x, this.queue = M;
    }
    execute(x) {
      const M = Buffer.from(x.subarray(1));
      if (M.length != 33)
        throw new Error("Invalid request, unexpected trailing data");
      if (M[0] != 0)
        throw new Error("Unsupported request, the first byte should be 0");
      const F = Buffer.alloc(32);
      for (let pe = 0; pe < 32; pe++)
        F[pe] = M[1 + pe];
      const le = F.toString("hex"), ge = this.known_preimages.get(le);
      if (ge != null) {
        const pe = (0, p.createVarint)(ge.length), Ie = 255 - pe.length - 1, be = Math.min(Ie, ge.length);
        if (be < ge.length)
          for (let Pe = be; Pe < ge.length; Pe++)
            this.queue.push(Buffer.from([ge[Pe]]));
        return Buffer.concat([
          pe,
          Buffer.from([be]),
          Buffer.from(ge.subarray(0, be))
        ]);
      }
      throw Error(`Requested unknown preimage for: ${le}`);
    }
  }
  clientCommands.GetPreimageCommand = b;
  class k extends l {
    constructor(x, M) {
      super(), this.code = t.GET_MERKLE_LEAF_PROOF, this.known_trees = x, this.queue = M;
    }
    execute(x) {
      const M = Buffer.from(x.subarray(1));
      if (M.length < 34)
        throw new Error("Invalid request, expected at least 34 bytes");
      const F = new A.BufferReader(M), ge = F.readSlice(32).toString("hex");
      let pe, Ie;
      try {
        pe = (0, p.sanitizeBigintToNumber)(F.readVarInt()), Ie = (0, p.sanitizeBigintToNumber)(F.readVarInt());
      } catch {
        throw new Error("Invalid request, couldn't parse tree_size or leaf_index");
      }
      const be = this.known_trees.get(ge);
      if (!be)
        throw Error(`Requested Merkle leaf proof for unknown tree: ${ge}`);
      if (Ie >= pe || be.size() != pe)
        throw Error("Invalid index or tree size.");
      if (this.queue.length != 0)
        throw Error("This command should not execute when the queue is not empty.");
      const Pe = be.getProof(Ie), Te = Math.min(Math.floor(221 / 32), Pe.length), Qe = Pe.length - Te;
      return Qe > 0 && this.queue.push(...Pe.slice(-Qe)), Buffer.concat([
        be.getLeafHash(Ie),
        Buffer.from([Pe.length]),
        Buffer.from([Te]),
        ...Pe.slice(0, Te)
      ]);
    }
  }
  clientCommands.GetMerkleLeafProofCommand = k;
  class C extends l {
    constructor(x) {
      super(), this.code = t.GET_MERKLE_LEAF_INDEX, this.known_trees = x;
    }
    execute(x) {
      const M = Buffer.from(x.subarray(1));
      if (M.length != 64)
        throw new Error("Invalid request, unexpected trailing data");
      const F = Buffer.alloc(32);
      for (let Te = 0; Te < 32; Te++)
        F[Te] = M.readUInt8(Te);
      const le = F.toString("hex"), ge = Buffer.alloc(32);
      for (let Te = 0; Te < 32; Te++)
        ge[Te] = M.readUInt8(32 + Te);
      const pe = ge.toString("hex"), Ie = this.known_trees.get(le);
      if (!Ie)
        throw Error(`Requested Merkle leaf index for unknown root: ${le}`);
      let be = 0, Pe = 0;
      for (let Te = 0; Te < Ie.size(); Te++)
        if (Ie.getLeafHash(Te).toString("hex") == pe) {
          Pe = 1, be = Te;
          break;
        }
      return Buffer.concat([Buffer.from([Pe]), (0, p.createVarint)(be)]);
    }
  }
  clientCommands.GetMerkleLeafIndexCommand = C;
  class B extends l {
    constructor(x) {
      super(), this.code = t.GET_MORE_ELEMENTS, this.queue = x;
    }
    execute(x) {
      if (x.length != 1)
        throw new Error("Invalid request, unexpected trailing data");
      if (this.queue.length === 0)
        throw new Error("No elements to get");
      const M = this.queue[0].length;
      if (this.queue.some((pe) => pe.length != M))
        throw new Error("The queue contains elements with different byte length, which is not expected");
      const F = Math.floor(253 / M), le = Math.min(F, this.queue.length), ge = this.queue.splice(0, le);
      return Buffer.concat([
        Buffer.from([le]),
        Buffer.from([M]),
        ...ge
      ]);
    }
  }
  clientCommands.GetMoreElementsCommand = B;
  class Q {
    constructor(x) {
      this.roots = /* @__PURE__ */ new Map(), this.preimages = /* @__PURE__ */ new Map(), this.yielded = [], this.queue = [], this.commands = /* @__PURE__ */ new Map();
      const M = [
        new m(this.yielded, x),
        new b(this.preimages, this.queue),
        new C(this.roots),
        new k(this.roots, this.queue),
        new B(this.queue)
      ];
      for (const F of M) {
        if (this.commands.has(F.code))
          throw new Error(`Multiple commands with code ${F.code}`);
        this.commands.set(F.code, F);
      }
    }
    getYielded() {
      return this.yielded;
    }
    addKnownPreimage(x) {
      this.preimages.set(s.crypto.sha256(x).toString("hex"), x);
    }
    addKnownList(x) {
      for (const F of x) {
        const le = Buffer.concat([Buffer.from([0]), F]);
        this.addKnownPreimage(le);
      }
      const M = new u.Merkle(x.map((F) => (0, u.hashLeaf)(F)));
      this.roots.set(M.getRoot().toString("hex"), M);
    }
    addKnownMapping(x) {
      this.addKnownList(x.keys), this.addKnownList(x.values);
    }
    addKnownWalletPolicy(x) {
      this.addKnownPreimage(x.serialize()), this.addKnownList(x.keys.map((M) => Buffer.from(M, "ascii"))), this.addKnownPreimage(Buffer.from(x.descriptorTemplate));
    }
    execute(x) {
      if (x.length == 0)
        throw new Error("Unexpected empty command");
      const M = x[0], F = this.commands.get(M);
      if (!F)
        throw new Error(`Unexpected command code ${M}`);
      return F.execute(x);
    }
  }
  return clientCommands.ClientCommandInterpreter = Q, clientCommands;
}
var merkelizedPsbt = {}, merkleMap = {}, hasRequiredMerkleMap;
function requireMerkleMap() {
  if (hasRequiredMerkleMap) return merkleMap;
  hasRequiredMerkleMap = 1, Object.defineProperty(merkleMap, "__esModule", { value: !0 }), merkleMap.MerkleMap = void 0;
  const s = requireMerkle(), A = requireVarint();
  class u {
    /**
     * @param keys Sorted list of (unhashed) keys
     * @param values values, in corresponding order as the keys, and of equal length
     */
    constructor(t, l) {
      if (t.length != l.length)
        throw new Error("keys and values should have the same length");
      for (let m = 0; m < t.length - 1; m++)
        if (t[m].toString("hex") >= t[m + 1].toString("hex"))
          throw new Error("keys must be in strictly increasing order");
      this.keys = t, this.keysTree = new s.Merkle(t.map((m) => (0, s.hashLeaf)(m))), this.values = l, this.valuesTree = new s.Merkle(l.map((m) => (0, s.hashLeaf)(m)));
    }
    commitment() {
      return Buffer.concat([
        (0, A.createVarint)(this.keys.length),
        this.keysTree.getRoot(),
        this.valuesTree.getRoot()
      ]);
    }
  }
  return merkleMap.MerkleMap = u, merkleMap;
}
var psbtv2 = {}, hasRequiredPsbtv2;
function requirePsbtv2() {
  return hasRequiredPsbtv2 || (hasRequiredPsbtv2 = 1, function(s) {
    var A = psbtv2 && psbtv2.__createBinding || (Object.create ? function(xe, Ee, He, ve) {
      ve === void 0 && (ve = He);
      var we = Object.getOwnPropertyDescriptor(Ee, He);
      (!we || ("get" in we ? !Ee.__esModule : we.writable || we.configurable)) && (we = { enumerable: !0, get: function() {
        return Ee[He];
      } }), Object.defineProperty(xe, ve, we);
    } : function(xe, Ee, He, ve) {
      ve === void 0 && (ve = He), xe[ve] = Ee[He];
    }), u = psbtv2 && psbtv2.__setModuleDefault || (Object.create ? function(xe, Ee) {
      Object.defineProperty(xe, "default", { enumerable: !0, value: Ee });
    } : function(xe, Ee) {
      xe.default = Ee;
    }), p = psbtv2 && psbtv2.__importStar || function(xe) {
      if (xe && xe.__esModule) return xe;
      var Ee = {};
      if (xe != null) for (var He in xe) He !== "default" && Object.prototype.hasOwnProperty.call(xe, He) && A(Ee, xe, He);
      return u(Ee, xe), Ee;
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), s.PsbtV2 = s.NoSuchEntry = s.psbtOut = s.psbtIn = s.psbtGlobal = void 0;
    const t = p(requireSrc$3()), l = requireBuffertools(), m = requireVarint();
    var b;
    (function(xe) {
      xe[xe.UNSIGNED_TX = 0] = "UNSIGNED_TX", xe[xe.XPUB = 1] = "XPUB", xe[xe.TX_VERSION = 2] = "TX_VERSION", xe[xe.FALLBACK_LOCKTIME = 3] = "FALLBACK_LOCKTIME", xe[xe.INPUT_COUNT = 4] = "INPUT_COUNT", xe[xe.OUTPUT_COUNT = 5] = "OUTPUT_COUNT", xe[xe.TX_MODIFIABLE = 6] = "TX_MODIFIABLE", xe[xe.VERSION = 251] = "VERSION";
    })(b = s.psbtGlobal || (s.psbtGlobal = {}));
    var k;
    (function(xe) {
      xe[xe.NON_WITNESS_UTXO = 0] = "NON_WITNESS_UTXO", xe[xe.WITNESS_UTXO = 1] = "WITNESS_UTXO", xe[xe.PARTIAL_SIG = 2] = "PARTIAL_SIG", xe[xe.SIGHASH_TYPE = 3] = "SIGHASH_TYPE", xe[xe.REDEEM_SCRIPT = 4] = "REDEEM_SCRIPT", xe[xe.WITNESS_SCRIPT = 5] = "WITNESS_SCRIPT", xe[xe.BIP32_DERIVATION = 6] = "BIP32_DERIVATION", xe[xe.FINAL_SCRIPTSIG = 7] = "FINAL_SCRIPTSIG", xe[xe.FINAL_SCRIPTWITNESS = 8] = "FINAL_SCRIPTWITNESS", xe[xe.PREVIOUS_TXID = 14] = "PREVIOUS_TXID", xe[xe.OUTPUT_INDEX = 15] = "OUTPUT_INDEX", xe[xe.SEQUENCE = 16] = "SEQUENCE", xe[xe.TAP_KEY_SIG = 19] = "TAP_KEY_SIG", xe[xe.TAP_BIP32_DERIVATION = 22] = "TAP_BIP32_DERIVATION";
    })(k = s.psbtIn || (s.psbtIn = {}));
    var C;
    (function(xe) {
      xe[xe.REDEEM_SCRIPT = 0] = "REDEEM_SCRIPT", xe[xe.WITNESS_SCRIPT = 1] = "WITNESS_SCRIPT", xe[xe.BIP_32_DERIVATION = 2] = "BIP_32_DERIVATION", xe[xe.AMOUNT = 3] = "AMOUNT", xe[xe.SCRIPT = 4] = "SCRIPT", xe[xe.TAP_BIP32_DERIVATION = 7] = "TAP_BIP32_DERIVATION";
    })(C = s.psbtOut || (s.psbtOut = {}));
    const B = Buffer.from([112, 115, 98, 116, 255]);
    class Q extends Error {
    }
    s.NoSuchEntry = Q;
    class P {
      constructor() {
        this.globalMap = /* @__PURE__ */ new Map(), this.inputMaps = [], this.outputMaps = [];
      }
      setGlobalTxVersion(Ee) {
        this.setGlobal(b.TX_VERSION, be(Ee));
      }
      getGlobalTxVersion() {
        return this.getGlobal(b.TX_VERSION).readUInt32LE(0);
      }
      setGlobalFallbackLocktime(Ee) {
        this.setGlobal(b.FALLBACK_LOCKTIME, be(Ee));
      }
      getGlobalFallbackLocktime() {
        var Ee;
        return (Ee = this.getGlobalOptional(b.FALLBACK_LOCKTIME)) === null || Ee === void 0 ? void 0 : Ee.readUInt32LE(0);
      }
      setGlobalInputCount(Ee) {
        this.setGlobal(b.INPUT_COUNT, Te(Ee));
      }
      getGlobalInputCount() {
        return Qe(this.getGlobal(b.INPUT_COUNT));
      }
      setGlobalOutputCount(Ee) {
        this.setGlobal(b.OUTPUT_COUNT, Te(Ee));
      }
      getGlobalOutputCount() {
        return Qe(this.getGlobal(b.OUTPUT_COUNT));
      }
      setGlobalTxModifiable(Ee) {
        this.setGlobal(b.TX_MODIFIABLE, Ee);
      }
      getGlobalTxModifiable() {
        return this.getGlobalOptional(b.TX_MODIFIABLE);
      }
      setGlobalPsbtVersion(Ee) {
        this.setGlobal(b.VERSION, be(Ee));
      }
      getGlobalPsbtVersion() {
        return this.getGlobal(b.VERSION).readUInt32LE(0);
      }
      setInputNonWitnessUtxo(Ee, He) {
        this.setInput(Ee, k.NON_WITNESS_UTXO, pe(), He);
      }
      getInputNonWitnessUtxo(Ee) {
        return this.getInputOptional(Ee, k.NON_WITNESS_UTXO, pe());
      }
      setInputWitnessUtxo(Ee, He, ve) {
        const we = new l.BufferWriter();
        we.writeSlice(Pe(He)), we.writeVarSlice(ve), this.setInput(Ee, k.WITNESS_UTXO, pe(), we.buffer());
      }
      getInputWitnessUtxo(Ee) {
        const He = this.getInputOptional(Ee, k.WITNESS_UTXO, pe());
        if (!He)
          return;
        const ve = new l.BufferReader(He);
        return {
          amount: (0, l.unsafeFrom64bitLE)(ve.readSlice(8)),
          scriptPubKey: ve.readVarSlice()
        };
      }
      setInputPartialSig(Ee, He, ve) {
        this.setInput(Ee, k.PARTIAL_SIG, He, ve);
      }
      getInputPartialSig(Ee, He) {
        return this.getInputOptional(Ee, k.PARTIAL_SIG, He);
      }
      setInputSighashType(Ee, He) {
        this.setInput(Ee, k.SIGHASH_TYPE, pe(), be(He));
      }
      getInputSighashType(Ee) {
        const He = this.getInputOptional(Ee, k.SIGHASH_TYPE, pe());
        if (He)
          return He.readUInt32LE(0);
      }
      setInputRedeemScript(Ee, He) {
        this.setInput(Ee, k.REDEEM_SCRIPT, pe(), He);
      }
      getInputRedeemScript(Ee) {
        return this.getInputOptional(Ee, k.REDEEM_SCRIPT, pe());
      }
      setInputWitnessScript(Ee, He) {
        this.setInput(Ee, k.WITNESS_SCRIPT, pe(), He);
      }
      getInputWitnessScript(Ee) {
        return this.getInputOptional(Ee, k.WITNESS_SCRIPT, pe());
      }
      setInputBip32Derivation(Ee, He, ve, we) {
        if (He.length != 33)
          throw new Error("Invalid pubkey length: " + He.length);
        this.setInput(Ee, k.BIP32_DERIVATION, He, this.encodeBip32Derivation(ve, we));
      }
      getInputBip32Derivation(Ee, He) {
        const ve = this.getInputOptional(Ee, k.BIP32_DERIVATION, He);
        if (ve)
          return this.decodeBip32Derivation(ve);
      }
      setInputFinalScriptsig(Ee, He) {
        this.setInput(Ee, k.FINAL_SCRIPTSIG, pe(), He);
      }
      getInputFinalScriptsig(Ee) {
        return this.getInputOptional(Ee, k.FINAL_SCRIPTSIG, pe());
      }
      setInputFinalScriptwitness(Ee, He) {
        this.setInput(Ee, k.FINAL_SCRIPTWITNESS, pe(), He);
      }
      getInputFinalScriptwitness(Ee) {
        return this.getInput(Ee, k.FINAL_SCRIPTWITNESS, pe());
      }
      setInputPreviousTxId(Ee, He) {
        this.setInput(Ee, k.PREVIOUS_TXID, pe(), He);
      }
      getInputPreviousTxid(Ee) {
        return this.getInput(Ee, k.PREVIOUS_TXID, pe());
      }
      setInputOutputIndex(Ee, He) {
        this.setInput(Ee, k.OUTPUT_INDEX, pe(), be(He));
      }
      getInputOutputIndex(Ee) {
        return this.getInput(Ee, k.OUTPUT_INDEX, pe()).readUInt32LE(0);
      }
      setInputSequence(Ee, He) {
        this.setInput(Ee, k.SEQUENCE, pe(), be(He));
      }
      getInputSequence(Ee) {
        var He, ve;
        return (ve = (He = this.getInputOptional(Ee, k.SEQUENCE, pe())) === null || He === void 0 ? void 0 : He.readUInt32LE(0)) !== null && ve !== void 0 ? ve : 4294967295;
      }
      setInputTapKeySig(Ee, He) {
        this.setInput(Ee, k.TAP_KEY_SIG, pe(), He);
      }
      getInputTapKeySig(Ee) {
        return this.getInputOptional(Ee, k.TAP_KEY_SIG, pe());
      }
      setInputTapBip32Derivation(Ee, He, ve, we, Ce) {
        if (He.length != 32)
          throw new Error("Invalid pubkey length: " + He.length);
        const Se = this.encodeTapBip32Derivation(ve, we, Ce);
        this.setInput(Ee, k.TAP_BIP32_DERIVATION, He, Se);
      }
      getInputTapBip32Derivation(Ee, He) {
        const ve = this.getInput(Ee, k.TAP_BIP32_DERIVATION, He);
        return this.decodeTapBip32Derivation(ve);
      }
      getInputKeyDatas(Ee, He) {
        return this.getKeyDatas(this.inputMaps[Ee], He);
      }
      setOutputRedeemScript(Ee, He) {
        this.setOutput(Ee, C.REDEEM_SCRIPT, pe(), He);
      }
      getOutputRedeemScript(Ee) {
        return this.getOutput(Ee, C.REDEEM_SCRIPT, pe());
      }
      setOutputBip32Derivation(Ee, He, ve, we) {
        this.setOutput(Ee, C.BIP_32_DERIVATION, He, this.encodeBip32Derivation(ve, we));
      }
      getOutputBip32Derivation(Ee, He) {
        const ve = this.getOutput(Ee, C.BIP_32_DERIVATION, He);
        return this.decodeBip32Derivation(ve);
      }
      setOutputAmount(Ee, He) {
        this.setOutput(Ee, C.AMOUNT, pe(), Pe(He));
      }
      getOutputAmount(Ee) {
        const He = this.getOutput(Ee, C.AMOUNT, pe());
        return (0, l.unsafeFrom64bitLE)(He);
      }
      setOutputScript(Ee, He) {
        this.setOutput(Ee, C.SCRIPT, pe(), He);
      }
      getOutputScript(Ee) {
        return this.getOutput(Ee, C.SCRIPT, pe());
      }
      setOutputTapBip32Derivation(Ee, He, ve, we, Ce) {
        const Se = this.encodeTapBip32Derivation(ve, we, Ce);
        this.setOutput(Ee, C.TAP_BIP32_DERIVATION, He, Se);
      }
      getOutputTapBip32Derivation(Ee, He) {
        const ve = this.getOutput(Ee, C.TAP_BIP32_DERIVATION, He);
        return this.decodeTapBip32Derivation(ve);
      }
      deleteInputEntries(Ee, He) {
        this.inputMaps[Ee].forEach((we, Ce, Se) => {
          this.isKeyType(Ce, He) && Se.delete(Ce);
        });
      }
      copy(Ee) {
        this.copyMap(this.globalMap, Ee.globalMap), this.copyMaps(this.inputMaps, Ee.inputMaps), this.copyMaps(this.outputMaps, Ee.outputMaps);
      }
      copyMaps(Ee, He) {
        Ee.forEach((ve, we) => {
          const Ce = /* @__PURE__ */ new Map();
          this.copyMap(ve, Ce), He[we] = Ce;
        });
      }
      copyMap(Ee, He) {
        Ee.forEach((ve, we) => He.set(we, Buffer.from(ve)));
      }
      serialize() {
        const Ee = new l.BufferWriter();
        return Ee.writeSlice(B), ge(Ee, this.globalMap), this.inputMaps.forEach((He) => {
          ge(Ee, He);
        }), this.outputMaps.forEach((He) => {
          ge(Ee, He);
        }), Ee.buffer();
      }
      deserialize(Ee) {
        const He = new l.BufferReader(Ee);
        if (!He.readSlice(5).equals(B))
          throw new Error("Invalid magic bytes");
        for (; this.readKeyPair(this.globalMap, He); )
          ;
        let ve;
        try {
          ve = this.getGlobalPsbtVersion();
        } catch {
          ve = 0;
        }
        if (ve !== 0 && ve !== 2)
          throw new Error("Only PSBTs of version 0 or 2 are supported");
        let we, Ce;
        if (ve == 0) {
          const Se = this.getGlobal(b.UNSIGNED_TX), Ne = t.Transaction.fromBuffer(Se);
          we = Ne.ins.length, Ce = Ne.outs.length;
        } else
          we = this.getGlobalInputCount(), Ce = this.getGlobalOutputCount();
        for (let Se = 0; Se < we; Se++)
          for (this.inputMaps[Se] = /* @__PURE__ */ new Map(); this.readKeyPair(this.inputMaps[Se], He); )
            ;
        for (let Se = 0; Se < Ce; Se++)
          for (this.outputMaps[Se] = /* @__PURE__ */ new Map(); this.readKeyPair(this.outputMaps[Se], He); )
            ;
        this.normalizeToV2();
      }
      normalizeToV2() {
        var Ee;
        const He = (Ee = this.getGlobalOptional(b.VERSION)) === null || Ee === void 0 ? void 0 : Ee.readInt32LE(0);
        if (He === 2)
          return;
        if (He !== void 0)
          throw new Error("Invalid or unsupported value for PSBT_GLOBAL_VERSION");
        const ve = this.getGlobal(b.UNSIGNED_TX), we = t.Transaction.fromBuffer(ve);
        this.setGlobalPsbtVersion(2), this.setGlobalTxVersion(we.version), this.setGlobalFallbackLocktime(we.locktime), this.setGlobalInputCount(we.ins.length), this.setGlobalOutputCount(we.outs.length);
        for (let Ce = 0; Ce < we.ins.length; Ce++)
          this.setInputPreviousTxId(Ce, we.ins[Ce].hash), this.setInputOutputIndex(Ce, we.ins[Ce].index), this.setInputSequence(Ce, we.ins[Ce].sequence);
        for (let Ce = 0; Ce < we.outs.length; Ce++)
          this.setOutputAmount(Ce, we.outs[Ce].value), this.setOutputScript(Ce, we.outs[Ce].script);
        this.globalMap.delete(b.UNSIGNED_TX.toString(16).padStart(2, "0"));
      }
      /**
       * Imports a BitcoinJS (bitcoinjs-lib) Psbt object.
       * https://github.com/bitcoinjs/bitcoinjs-lib/blob/master/ts_src/psbt.ts
       *
       * Prepares the fields required for signing a Psbt on a Ledger
       * device. It should be used exclusively before calling
       * `appClient.signPsbt()` and not as a general Psbt conversion method.
       *
       * Note: This method supports all the policies that the Ledger is able to
       * sign, with the exception of taproot: tr(@0).
       */
      fromBitcoinJS(Ee) {
        function He(ve) {
          let we;
          try {
            t.payments.p2tr({ output: ve.witnessUtxo.script }), we = !0;
          } catch {
            we = !1;
          }
          return ve && !!(ve.tapInternalKey || ve.tapMerkleRoot || ve.tapLeafScript && ve.tapLeafScript.length || ve.tapBip32Derivation && ve.tapBip32Derivation.length || we);
        }
        return this.setGlobalPsbtVersion(2), this.setGlobalTxVersion(Ee.version), this.setGlobalInputCount(Ee.data.inputs.length), this.setGlobalOutputCount(Ee.txOutputs.length), Ee.locktime !== void 0 && this.setGlobalFallbackLocktime(Ee.locktime), Ee.data.inputs.forEach((ve, we) => {
          if (He(ve))
            throw new Error("Taproot inputs not supported");
          this.setInputPreviousTxId(we, Ee.txInputs[we].hash), Ee.txInputs[we].sequence !== void 0 && this.setInputSequence(we, Ee.txInputs[we].sequence), this.setInputOutputIndex(we, Ee.txInputs[we].index), ve.sighashType !== void 0 && this.setInputSighashType(we, ve.sighashType), ve.nonWitnessUtxo && this.setInputNonWitnessUtxo(we, ve.nonWitnessUtxo), ve.witnessUtxo && this.setInputWitnessUtxo(we, ve.witnessUtxo.value, ve.witnessUtxo.script), ve.witnessScript && this.setInputWitnessScript(we, ve.witnessScript), ve.redeemScript && this.setInputRedeemScript(we, ve.redeemScript), Ee.data.inputs[we].bip32Derivation.forEach((Ce) => {
            if (!/^m\//i.test(Ce.path))
              throw new Error("Invalid input bip32 derivation");
            const Se = Ce.path.replace(/m\//i, "").split("/").map((Ne) => Ne.match(/['h]/i) ? parseInt(Ne) + 2147483648 : Number(Ne));
            this.setInputBip32Derivation(we, Ce.pubkey, Ce.masterFingerprint, Se);
          });
        }), Ee.txOutputs.forEach((ve, we) => {
          this.setOutputAmount(we, ve.value), this.setOutputScript(we, ve.script);
        }), this;
      }
      readKeyPair(Ee, He) {
        const ve = (0, m.sanitizeBigintToNumber)(He.readVarInt());
        if (ve == 0)
          return !1;
        const we = He.readUInt8(), Ce = He.readSlice(ve - 1), Se = He.readVarSlice();
        return Ie(Ee, we, Ce, Se), !0;
      }
      getKeyDatas(Ee, He) {
        const ve = [];
        return Ee.forEach((we, Ce) => {
          this.isKeyType(Ce, [He]) && ve.push(Buffer.from(Ce.substring(2), "hex"));
        }), ve;
      }
      isKeyType(Ee, He) {
        const ve = Buffer.from(Ee.substring(0, 2), "hex").readUInt8(0);
        return He.some((we) => we == ve);
      }
      setGlobal(Ee, He) {
        const ve = new M(Ee, Buffer.from([]));
        this.globalMap.set(ve.toString(), He);
      }
      getGlobal(Ee) {
        return x(this.globalMap, Ee, pe(), !1);
      }
      getGlobalOptional(Ee) {
        return x(this.globalMap, Ee, pe(), !0);
      }
      setInput(Ee, He, ve, we) {
        Ie(this.getMap(Ee, this.inputMaps), He, ve, we);
      }
      getInput(Ee, He, ve) {
        return x(this.inputMaps[Ee], He, ve, !1);
      }
      getInputOptional(Ee, He, ve) {
        return x(this.inputMaps[Ee], He, ve, !0);
      }
      setOutput(Ee, He, ve, we) {
        Ie(this.getMap(Ee, this.outputMaps), He, ve, we);
      }
      getOutput(Ee, He, ve) {
        return x(this.outputMaps[Ee], He, ve, !1);
      }
      getMap(Ee, He) {
        return He[Ee] ? He[Ee] : He[Ee] = /* @__PURE__ */ new Map();
      }
      encodeBip32Derivation(Ee, He) {
        const ve = new l.BufferWriter();
        return this.writeBip32Derivation(ve, Ee, He), ve.buffer();
      }
      decodeBip32Derivation(Ee) {
        const He = new l.BufferReader(Ee);
        return this.readBip32Derivation(He);
      }
      writeBip32Derivation(Ee, He, ve) {
        Ee.writeSlice(He), ve.forEach((we) => {
          Ee.writeUInt32(we);
        });
      }
      readBip32Derivation(Ee) {
        const He = Ee.readSlice(4), ve = [];
        for (; Ee.offset < Ee.buffer.length; )
          ve.push(Ee.readUInt32());
        return { masterFingerprint: He, path: ve };
      }
      encodeTapBip32Derivation(Ee, He, ve) {
        const we = new l.BufferWriter();
        return we.writeVarInt(Ee.length), Ee.forEach((Ce) => {
          we.writeSlice(Ce);
        }), this.writeBip32Derivation(we, He, ve), we.buffer();
      }
      decodeTapBip32Derivation(Ee) {
        const He = new l.BufferReader(Ee), ve = (0, m.sanitizeBigintToNumber)(He.readVarInt()), we = [];
        for (let Se = 0; Se < ve; Se++)
          we.push(He.readSlice(32));
        const Ce = this.readBip32Derivation(He);
        return Object.assign({ hashes: we }, Ce);
      }
    }
    s.PsbtV2 = P;
    function x(xe, Ee, He, ve) {
      if (!xe)
        throw Error("No such map");
      const we = new M(Ee, He), Ce = xe.get(we.toString());
      if (!Ce) {
        if (ve)
          return;
        throw new Q(we.toString());
      }
      return Buffer.from(Ce);
    }
    class M {
      constructor(Ee, He) {
        this.keyType = Ee, this.keyData = He;
      }
      toString() {
        const Ee = new l.BufferWriter();
        return this.toBuffer(Ee), Ee.buffer().toString("hex");
      }
      serialize(Ee) {
        Ee.writeVarInt(1 + this.keyData.length), this.toBuffer(Ee);
      }
      toBuffer(Ee) {
        Ee.writeUInt8(this.keyType), Ee.writeSlice(this.keyData);
      }
    }
    class F {
      constructor(Ee, He) {
        this.key = Ee, this.value = He;
      }
      serialize(Ee) {
        this.key.serialize(Ee), Ee.writeVarSlice(this.value);
      }
    }
    function le(xe) {
      return new M(xe.readUInt8(0), xe.slice(1));
    }
    function ge(xe, Ee) {
      for (let [He, ve] of [...Ee].sort(([we], [Ce]) => we.localeCompare(Ce)))
        new F(le(Buffer.from(He, "hex")), ve).serialize(xe);
      xe.writeUInt8(0);
    }
    function pe() {
      return Buffer.from([]);
    }
    function Ie(xe, Ee, He, ve) {
      const we = new M(Ee, He);
      xe.set(we.toString(), ve);
    }
    function be(xe) {
      const Ee = Buffer.alloc(4);
      return Ee.writeUInt32LE(xe, 0), Ee;
    }
    function Pe(xe) {
      return (0, l.unsafeTo64bitLE)(xe);
    }
    function Te(xe) {
      const Ee = new l.BufferWriter();
      return Ee.writeVarInt(xe), Ee.buffer();
    }
    function Qe(xe) {
      return (0, m.sanitizeBigintToNumber)(new l.BufferReader(xe).readVarInt());
    }
  }(psbtv2)), psbtv2;
}
var hasRequiredMerkelizedPsbt;
function requireMerkelizedPsbt() {
  if (hasRequiredMerkelizedPsbt) return merkelizedPsbt;
  hasRequiredMerkelizedPsbt = 1, Object.defineProperty(merkelizedPsbt, "__esModule", { value: !0 }), merkelizedPsbt.MerkelizedPsbt = void 0;
  const s = requireMerkleMap(), A = requirePsbtv2();
  class u extends A.PsbtV2 {
    constructor(t) {
      super(), this.inputMerkleMaps = [], this.outputMerkleMaps = [], t.copy(this), this.globalMerkleMap = u.createMerkleMap(this.globalMap);
      for (let l = 0; l < this.getGlobalInputCount(); l++)
        this.inputMerkleMaps.push(u.createMerkleMap(this.inputMaps[l]));
      this.inputMapCommitments = [...this.inputMerkleMaps.values()].map((l) => l.commitment());
      for (let l = 0; l < this.getGlobalOutputCount(); l++)
        this.outputMerkleMaps.push(u.createMerkleMap(this.outputMaps[l]));
      this.outputMapCommitments = [...this.outputMerkleMaps.values()].map((l) => l.commitment());
    }
    // These public functions are for MerkelizedPsbt.
    getGlobalSize() {
      return this.globalMap.size;
    }
    getGlobalKeysValuesRoot() {
      return this.globalMerkleMap.commitment();
    }
    static createMerkleMap(t) {
      const l = [...t.keys()].sort(), m = l.map((k) => {
        const C = t.get(k);
        if (!C)
          throw new Error("No value for key " + k);
        return C;
      }), b = l.map((k) => Buffer.from(k, "hex"));
      return new s.MerkleMap(b, m);
    }
  }
  return merkelizedPsbt.MerkelizedPsbt = u, merkelizedPsbt;
}
var hasRequiredAppClient;
function requireAppClient() {
  if (hasRequiredAppClient) return appClient;
  hasRequiredAppClient = 1;
  var s = appClient && appClient.__createBinding || (Object.create ? function(xe, Ee, He, ve) {
    ve === void 0 && (ve = He);
    var we = Object.getOwnPropertyDescriptor(Ee, He);
    (!we || ("get" in we ? !Ee.__esModule : we.writable || we.configurable)) && (we = { enumerable: !0, get: function() {
      return Ee[He];
    } }), Object.defineProperty(xe, ve, we);
  } : function(xe, Ee, He, ve) {
    ve === void 0 && (ve = He), xe[ve] = Ee[He];
  }), A = appClient && appClient.__setModuleDefault || (Object.create ? function(xe, Ee) {
    Object.defineProperty(xe, "default", { enumerable: !0, value: Ee });
  } : function(xe, Ee) {
    xe.default = Ee;
  }), u = appClient && appClient.__importStar || function(xe) {
    if (xe && xe.__esModule) return xe;
    var Ee = {};
    if (xe != null) for (var He in xe) He !== "default" && Object.prototype.hasOwnProperty.call(xe, He) && s(Ee, xe, He);
    return A(Ee, xe), Ee;
  };
  Object.defineProperty(appClient, "__esModule", { value: !0 }), appClient.sendMerkleizedDataWithStatus = appClient.sendMerkleizedData = appClient.AppClient = appClient.PartialSignature = void 0;
  const p = u(requireDist()), t = u(requireDist$l()), { Descriptor: l } = p.DescriptorsFactory(t), m = requireSrc$3(), b = requireBip32(), k = requireClientCommands(), C = requireMerkelizedPsbt(), B = requireMerkle(), Q = requirePsbtv2(), P = requireVarint(), x = 225, M = 248, F = 187, le = 1;
  var ge;
  (function(xe) {
    xe[xe.GET_PUBKEY = 0] = "GET_PUBKEY", xe[xe.REGISTER_WALLET = 2] = "REGISTER_WALLET", xe[xe.GET_WALLET_ADDRESS = 3] = "GET_WALLET_ADDRESS", xe[xe.SIGN_PSBT = 4] = "SIGN_PSBT", xe[xe.GET_MASTER_FINGERPRINT = 5] = "GET_MASTER_FINGERPRINT", xe[xe.SIGN_MESSAGE = 16] = "SIGN_MESSAGE";
  })(ge || (ge = {}));
  var pe;
  (function(xe) {
    xe[xe.CONTINUE_INTERRUPTED = 1] = "CONTINUE_INTERRUPTED";
  })(pe || (pe = {}));
  class Ie {
    constructor(Ee, He, ve) {
      this.pubkey = Ee, this.signature = He, this.tapleafHash = ve;
    }
  }
  appClient.PartialSignature = Ie;
  function be(xe, Ee) {
    if (xe.length == 64)
      return new Ie(xe.slice(0, 32), Ee, xe.slice(32, 64));
    if (xe.length == 32 || xe.length == 33)
      return new Ie(xe, Ee);
    throw new Error(`Invalid length for pubkeyAugm: ${xe.length} bytes.`);
  }
  class Pe {
    constructor(Ee) {
      this.transport = Ee;
    }
    async makeRequest(Ee, He, ve) {
      let we = await this.transport.send(x, Ee, 0, le, He, [36864, 57344]);
      for (; we.readUInt16BE(we.length - 2) === 57344; ) {
        if (!ve)
          throw new Error("Unexpected SW_INTERRUPTED_EXECUTION");
        const Ce = we.slice(0, -2), Se = ve.execute(Ce);
        we = await this.transport.send(M, pe.CONTINUE_INTERRUPTED, 0, 0, Se, [36864, 57344]);
      }
      return we.slice(0, -2);
    }
    /**
     * Returns an object containing the currently running app's name, version and the device status flags.
     *
     * @returns an object with app name, version and device status flags.
     */
    async getAppAndVersion() {
      const Ee = await this.transport.send(176, 1, 0, 0);
      let He = 0;
      if (Ee[He++] !== 1)
        throw new Error("Unexpected response");
      const we = Ee[He++], Ce = Ee.slice(He, He += we).toString("ascii"), Se = Ee[He++], Ne = Ee.slice(He, He += Se).toString("ascii"), rr = Ee[He++], er = Ee.slice(He, He += rr);
      return {
        name: Ce,
        version: Ne,
        flags: er
      };
    }
    /**
     * Requests the BIP-32 extended pubkey to the hardware wallet.
     * If `display` is `false`, only standard paths will be accepted; an error is returned if an unusual path is
     * requested.
     * If `display` is `true`, the requested path is shown on screen for user verification; unusual paths can be
     * requested, and a warning is shown to the user in that case.
     *
     * @param path the requested BIP-32 path as a string
     * @param display `false` to silently retrieve a pubkey for a standard path, `true` to display the path on screen
     * @returns the base58-encoded serialized extended pubkey (xpub)
     */
    async getExtendedPubkey(Ee, He = !1) {
      const ve = (0, b.pathStringToArray)(Ee);
      if (ve.length > 6)
        throw new Error("Path too long. At most 6 levels allowed.");
      return (await this.makeRequest(ge.GET_PUBKEY, Buffer.concat([
        Buffer.from(He ? [1] : [0]),
        (0, b.pathElementsToBuffer)(ve)
      ]))).toString("ascii");
    }
    /**
     * Registers a `WalletPolicy`, after interactive verification from the user.
     * On success, after user's approval, this function returns the id (which is the same that can be computed with
     * `walletPolicy.getid()`), followed by the 32-byte hmac. The client should store the hmac to use it for future
     * requests to `getWalletAddress` or `signPsbt` using this `WalletPolicy`.
     *
     * @param walletPolicy the `WalletPolicy` to register
     * @returns a pair of two 32-byte arrays: the id of the Wallet Policy, followed by the policy hmac
     */
    async registerWallet(Ee) {
      const He = new k.ClientCommandInterpreter();
      He.addKnownWalletPolicy(Ee);
      const ve = Ee.serialize(), we = await this.makeRequest(ge.REGISTER_WALLET, Buffer.concat([
        (0, P.createVarint)(ve.length),
        ve
      ]), He);
      if (we.length != 64)
        throw Error(`Invalid response length. Expected 64 bytes, got ${we.length}`);
      const Ce = we.subarray(0, 32), Se = we.subarray(32), Ne = await this.getWalletAddress(Ee, Se, 0, 0, !1);
      return await this.validateAddress(Ne, Ee, 0, 0), [Ce, Se];
    }
    /**
     * Returns the address of `walletPolicy` for the given `change` and `addressIndex`.
     *
     * @param walletPolicy the `WalletPolicy` to use
     * @param walletHMAC the 32-byte hmac returned during wallet registration for a registered policy; otherwise
     * `null` for a standard policy
     * @param change `0` for a normal receive address, `1` for a change address
     * @param addressIndex the address index to retrieve
     * @param display `True` to show the address on screen, `False` to retrieve it silently
     * @returns the address, as an ascii string.
     */
    async getWalletAddress(Ee, He, ve, we, Ce) {
      if (ve !== 0 && ve !== 1)
        throw new Error("Change can only be 0 or 1");
      if (we < 0 || !Number.isInteger(we))
        throw new Error("Invalid address index");
      if (He != null && He.length != 32)
        throw new Error("Invalid HMAC length");
      const Se = new k.ClientCommandInterpreter();
      Se.addKnownWalletPolicy(Ee);
      const Ne = Buffer.alloc(4);
      Ne.writeUInt32BE(we, 0);
      const er = (await this.makeRequest(ge.GET_WALLET_ADDRESS, Buffer.concat([
        Buffer.from(Ce ? [1] : [0]),
        Ee.getId(),
        He || Buffer.alloc(32, 0),
        Buffer.from([ve]),
        Ne
      ]), Se)).toString("ascii");
      return await this.validateAddress(er, Ee, ve, we), er;
    }
    /**
     * Prepares data for signing by sending it to the device.
     * This method uses a custom instruction to send merkleized data.
     * @param ins the instruction byte to use
     * @param payload the data payload to send
     * @returns the complete response including status word
     */
    async dataPrepare(Ee) {
      return await Qe(this, F, Ee);
    }
    /**
     * Signs a psbt using a (standard or registered) `WalletPolicy`. This is an interactive command, as user validation
     * is necessary using the device's secure screen.
     * On success, a map of input indexes and signatures is returned.
     * @param psbt a base64-encoded string, or a psbt in a binary Buffer. Using the `PsbtV2` type is deprecated.
     * @param walletPolicy the `WalletPolicy` to use for signing
     * @param walletHMAC the 32-byte hmac obtained during wallet policy registration, or `null` for a standard policy
     * @param progressCallback optionally, a callback that will be called every time a signature is produced during
     * the signing process. The callback does not receive any argument, but can be used to track progress.
     * @returns an array of of tuples with 2 elements containing:
     *    - the index of the input being signed;
     *    - an instance of PartialSignature
     */
    async signPsbt(Ee, He, ve, we) {
      if (typeof Ee == "string" && (Ee = Buffer.from(Ee, "base64")), Buffer.isBuffer(Ee)) {
        const sr = new Q.PsbtV2();
        sr.deserialize(Ee), Ee = sr;
      }
      const Ce = new C.MerkelizedPsbt(Ee);
      if (ve != null && ve.length != 32)
        throw new Error("Invalid HMAC length");
      const Se = new k.ClientCommandInterpreter(we);
      Se.addKnownWalletPolicy(He), Se.addKnownMapping(Ce.globalMerkleMap);
      for (const sr of Ce.inputMerkleMaps)
        Se.addKnownMapping(sr);
      for (const sr of Ce.outputMerkleMaps)
        Se.addKnownMapping(sr);
      Se.addKnownList(Ce.inputMapCommitments);
      const Ne = new B.Merkle(Ce.inputMapCommitments.map((sr) => (0, B.hashLeaf)(sr))).getRoot();
      Se.addKnownList(Ce.outputMapCommitments);
      const rr = new B.Merkle(Ce.outputMapCommitments.map((sr) => (0, B.hashLeaf)(sr))).getRoot();
      await this.makeRequest(ge.SIGN_PSBT, Buffer.concat([
        Ce.getGlobalKeysValuesRoot(),
        (0, P.createVarint)(Ce.getGlobalInputCount()),
        Ne,
        (0, P.createVarint)(Ce.getGlobalOutputCount()),
        rr,
        He.getId(),
        ve || Buffer.alloc(32, 0)
      ]), Se);
      const er = Se.getYielded(), ir = [];
      for (const sr of er) {
        const [nr, fr] = (0, P.parseVarint)(sr, 0), lr = sr[fr], br = sr.subarray(fr + 1, fr + 1 + lr), Br = sr.subarray(fr + 1 + lr), Fr = be(br, Br);
        ir.push([Number(nr), Fr]);
      }
      return ir;
    }
    /**
     * Returns the fingerprint of the master public key, as per BIP-32 standard.
     * @returns the master key fingerprint as a string of 8 hexadecimal digits.
     */
    async getMasterFingerprint() {
      return (await this.makeRequest(ge.GET_MASTER_FINGERPRINT, Buffer.from([]))).toString("hex");
    }
    /**
     * Signs a message using the legacy Bitcoin Message Signing standard. The signed message is
     * the double-sha256 hash of the concatenation of:
     * - "\x18Bitcoin Signed Message:\n";
     * - the length of `message`, encoded as a Bitcoin-style variable length integer;
     * - `message`.
     *
     * @param message the serialized message to sign
     * @param path the BIP-32 path of the key used to sign the message
     * @returns base64-encoded signature of the message.
     */
    async signMessage(Ee, He) {
      const ve = (0, b.pathStringToArray)(He), we = new k.ClientCommandInterpreter(), Ce = Math.ceil(Ee.length / 64), Se = [];
      for (let er = 0; er < Ce; er++)
        Se.push(Ee.subarray(64 * er, 64 * er + 64));
      we.addKnownList(Se);
      const Ne = new B.Merkle(Se.map((er) => (0, B.hashLeaf)(er))).getRoot();
      return (await this.makeRequest(ge.SIGN_MESSAGE, Buffer.concat([
        (0, b.pathElementsToBuffer)(ve),
        (0, P.createVarint)(Ee.length),
        Ne
      ]), we)).toString("base64");
    }
    /* Performs any additional check on the generated address before returning it.*/
    async validateAddress(Ee, He, ve, we) {
      if (ve !== 0 && ve !== 1)
        throw new Error("Change can only be 0 or 1");
      const Ce = ve === 1;
      if (we < 0 || !Number.isInteger(we))
        throw new Error("Invalid address index");
      const Se = await this.getAppAndVersion();
      let Ne;
      if (Se.name === "Babylon BTC Test")
        Ne = m.networks.testnet;
      else if (Se.name === "Babylon BTC Staking")
        Ne = m.networks.bitcoin;
      else
        throw new Error(`Invalid app: ${Se.name}. Expected 'Babylon BTC Test' or 'Babylon BTC Staking'.`);
      let rr = He.descriptorTemplate;
      rr = rr.replace(/\/\*\*/g, "/<0;1>/*");
      const er = new RegExp("/<(\\d+);(\\d+)>", "g");
      let ir;
      for (; (ir = er.exec(rr)) !== null; ) {
        const [fr, lr] = [parseInt(ir[1], 10), parseInt(ir[2], 10)];
        rr = rr.replace(`/<${fr};${lr}>`, `/${Ce ? lr : fr}`);
      }
      rr = rr.replace(/\/\*/g, `/${we}`);
      for (let fr = He.keys.length - 1; fr >= 0; fr--)
        rr = rr.replace(new RegExp(`@${fr}`, "g"), He.keys[fr]);
      let sr = !0, nr;
      try {
        nr = new l({
          expression: rr,
          network: Ne
        }).getAddress();
      } catch {
        sr = !1;
      }
      if (sr && Ee !== nr)
        throw new Error(`Third party address validation mismatch: ${Ee} != ${nr}`);
    }
  }
  appClient.AppClient = Pe;
  async function Te(xe, Ee, He) {
    const ve = [];
    for (let Ne = 0; Ne < He.length; Ne += 64)
      ve.push(He.subarray(Ne, Ne + 64));
    const we = new k.ClientCommandInterpreter();
    we.addKnownList(ve);
    const Ce = new B.Merkle(ve.map((Ne) => (0, B.hashLeaf)(Ne))).getRoot(), Se = Buffer.concat([
      (0, P.createVarint)(He.length),
      Ce
    ]);
    return await xe.makeRequest(Ee, Se, we);
  }
  appClient.sendMerkleizedData = Te;
  async function Qe(xe, Ee, He) {
    const ve = [];
    for (let rr = 0; rr < He.length; rr += 64)
      ve.push(He.subarray(rr, rr + 64));
    const we = new k.ClientCommandInterpreter();
    we.addKnownList(ve);
    const Ce = new B.Merkle(ve.map((rr) => (0, B.hashLeaf)(rr))).getRoot(), Se = Buffer.concat([
      (0, P.createVarint)(He.length),
      Ce
    ]);
    let Ne = await xe.transport.send(x, Ee, 0, le, Se, [36864, 57344]);
    for (; Ne.readUInt16BE(Ne.length - 2) === 57344; ) {
      const rr = Ne.slice(0, -2), er = we.execute(rr);
      Ne = await xe.transport.send(M, pe.CONTINUE_INTERRUPTED, 0, 0, er, [36864, 57344]);
    }
    return Ne;
  }
  return appClient.sendMerkleizedDataWithStatus = Qe, appClient.default = Pe, appClient;
}
var policy = {}, hasRequiredPolicy;
function requirePolicy() {
  if (hasRequiredPolicy) return policy;
  hasRequiredPolicy = 1, Object.defineProperty(policy, "__esModule", { value: !0 }), policy.DefaultWalletPolicy = policy.WalletPolicy = void 0;
  const s = requireSrc$3(), A = requireBuffertools(), u = requireMerkle(), p = 2;
  class t {
    /**
     * Creates and instance of a wallet policy.
     * @param name an ascii string, up to 16 bytes long; it must be an empty string for default wallet policies
     * @param descriptorTemplate the wallet policy template
     * @param keys and array of the keys, with the key derivation information
     */
    constructor(b, k, C) {
      this.name = b, this.descriptorTemplate = k, this.keys = C;
    }
    /**
     * Returns the unique 32-bytes id of this wallet policy.
     */
    getId() {
      return s.crypto.sha256(this.serialize());
    }
    /**
     * Serializes the wallet policy for transmission via the hardware wallet protocol.
     * @returns the serialized wallet policy
     */
    serialize() {
      const b = this.keys.map((B) => Buffer.from(B, "ascii")), k = new u.Merkle(b.map((B) => (0, u.hashLeaf)(B))), C = new A.BufferWriter();
      return C.writeUInt8(p), C.writeVarSlice(Buffer.from(this.name, "ascii")), C.writeVarInt(this.descriptorTemplate.length), C.writeSlice(s.crypto.sha256(Buffer.from(this.descriptorTemplate))), C.writeVarInt(this.keys.length), C.writeSlice(k.getRoot()), C.buffer();
    }
  }
  policy.WalletPolicy = t;
  class l extends t {
    constructor(b, k) {
      super("", b, [k]);
    }
  }
  return policy.DefaultWalletPolicy = l, policy;
}
var babylon = {}, bip322 = {}, types = {}, hasRequiredTypes;
function requireTypes() {
  return hasRequiredTypes || (hasRequiredTypes = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.MessageSigningProtocols = s.AddressType = void 0, function(A) {
      A.p2pkh = "p2pkh", A.p2sh = "p2sh", A.p2wpkh = "p2wpkh", A.p2wsh = "p2wsh", A.p2tr = "p2tr";
    }(s.AddressType || (s.AddressType = {})), function(A) {
      A.ECDSA = "ECDSA", A.BIP322 = "BIP322";
    }(s.MessageSigningProtocols || (s.MessageSigningProtocols = {}));
  }(types)), types;
}
var utils = {}, hasRequiredUtils;
function requireUtils() {
  if (hasRequiredUtils) return utils;
  hasRequiredUtils = 1, Object.defineProperty(utils, "__esModule", { value: !0 }), utils.getAddressTypeFromPath = utils.isFullFiveLevelPath = utils.isTestnetPath = void 0;
  const s = requireTypes();
  function A(t) {
    const l = t.split("/");
    return l.length < 3 ? !1 : l[2] === "1'";
  }
  utils.isTestnetPath = A;
  function u(t) {
    const l = t.split("/");
    return l.length === 6 && l[0] === "m";
  }
  utils.isFullFiveLevelPath = u;
  function p(t) {
    const l = t.split("/");
    if (l.length < 2)
      return;
    switch (l[1].replace("'", "")) {
      case "86":
        return s.AddressType.p2tr;
      case "84":
        return s.AddressType.p2wpkh;
      case "49":
        return s.AddressType.p2sh;
      case "44":
      case "45":
        return s.AddressType.p2pkh;
      default:
        return;
    }
  }
  return utils.getAddressTypeFromPath = p, utils;
}
var prepare = {}, data = {}, hasRequiredData;
function requireData() {
  if (hasRequiredData) return data;
  hasRequiredData = 1, Object.defineProperty(data, "__esModule", { value: !0 }), data.encodeGetVersionTLV = data.encodeExpansionPolicyToTLV = data.encodeSignMessagePolicyToTLV = data.encodeWithdrawPolicyToTLV = data.encodeUnbondPolicyToTLV = data.encodeSlashingTxPolicyToTLV = data.encodeStakingTxPolicyToTLV = void 0;
  function s(k) {
    const C = k.split("/");
    if (C[0] !== "m" || C.length !== 6)
      throw new Error("Invalid BIP32 path");
    return C.slice(1).map((B) => B.endsWith("'") ? (parseInt(B.replace("'", ""), 10) | 2147483648) >>> 0 : parseInt(B, 10) >>> 0);
  }
  function A(k, C, B, Q, P) {
    const x = [];
    x.push(Buffer.from([119])), x.push(Buffer.from([0, 1])), x.push(Buffer.from([2]));
    const M = s(k), F = Buffer.alloc(4 * M.length);
    M.forEach((Ie, be) => F.writeUInt32BE(Ie, be * 4)), x.push(Buffer.from([55])), x.push(Buffer.from([0, F.length])), x.push(F);
    const le = B.length;
    if (x.push(Buffer.from([249])), x.push(Buffer.from([0, le])), x.push(Buffer.from([le])), le > 0) {
      x.push(Buffer.from([248]));
      const Ie = 32 * le;
      x.push(Buffer.from([Math.floor(Ie / 256), Ie % 256]));
      for (const be of B) {
        const Pe = Buffer.from(be, "hex");
        if (Pe.length !== 32)
          throw new Error(`Invalid finality provider pubkey length: ${Pe.length}, expected 32`);
        x.push(Pe);
      }
    }
    const ge = P.length;
    if (x.push(Buffer.from([192])), x.push(Buffer.from([0, 1])), x.push(Buffer.from([ge])), ge > 0) {
      x.push(Buffer.from([193]));
      const Ie = 32 * ge;
      x.push(Buffer.from([Math.floor(Ie / 256), Ie % 256]));
      for (const be of P) {
        const Pe = Buffer.from(be, "hex");
        if (Pe.length !== 32)
          throw new Error(`Invalid covenant pubkey length: ${Pe.length}, expected 32`);
        x.push(Pe);
      }
    }
    x.push(Buffer.from([1])), x.push(Buffer.from([0, 1])), x.push(Buffer.from([Q])), x.push(Buffer.from([113])), x.push(Buffer.from([0, 8]));
    const pe = Buffer.alloc(8);
    return pe.writeUInt32BE(Math.floor(C / 4294967296), 0), pe.writeUInt32BE(C % 4294967296, 4), x.push(pe), Buffer.concat(x);
  }
  data.encodeStakingTxPolicyToTLV = A;
  function u(k, C, B, Q, P, x, M) {
    if (!P)
      throw new Error("covenantPks is required");
    const F = [];
    F.push(Buffer.from([119])), F.push(Buffer.from([0, 1])), F.push(Buffer.from([0]));
    const le = s(k), ge = Buffer.alloc(4 * le.length);
    le.forEach((Qe, xe) => ge.writeUInt32BE(Qe, xe * 4)), F.push(Buffer.from([55])), F.push(Buffer.from([0, ge.length])), F.push(ge);
    const pe = B.length;
    if (F.push(Buffer.from([249])), F.push(Buffer.from([0, pe])), F.push(Buffer.from([pe])), pe > 0) {
      F.push(Buffer.from([248]));
      const Qe = 32 * pe;
      F.push(Buffer.from([Math.floor(Qe / 256), Qe % 256]));
      for (const xe of B) {
        const Ee = Buffer.from(xe, "hex");
        if (Ee.length !== 32)
          throw new Error(`Invalid finality provider pubkey length: ${Ee.length}, expected 32`);
        F.push(Ee);
      }
    }
    const Ie = P.length;
    if (F.push(Buffer.from([192])), F.push(Buffer.from([0, 1])), F.push(Buffer.from([Ie])), Ie > 0) {
      F.push(Buffer.from([193]));
      const Qe = 32 * Ie;
      F.push(Buffer.from([Math.floor(Qe / 256), Qe % 256]));
      for (const xe of P) {
        const Ee = Buffer.from(xe, "hex");
        if (Ee.length !== 32)
          throw new Error(`Invalid covenant pubkey length: ${Ee.length}, expected 32`);
        F.push(Ee);
      }
    }
    F.push(Buffer.from([1])), F.push(Buffer.from([0, 1])), F.push(Buffer.from([Q])), F.push(Buffer.from([254])), F.push(Buffer.from([0, 8]));
    const be = Buffer.alloc(8);
    be.writeUInt32BE(Math.floor(M / 4294967296), 0), be.writeUInt32BE(M % 4294967296, 4), F.push(be);
    const Pe = Buffer.from(x, "hex");
    F.push(Buffer.from([54])), F.push(Buffer.from([0, Pe.length])), F.push(Pe), F.push(Buffer.from([113])), F.push(Buffer.from([0, 8]));
    const Te = Buffer.alloc(8);
    return Te.writeUInt32BE(Math.floor(C / 4294967296), 0), Te.writeUInt32BE(C % 4294967296, 4), F.push(Te), Buffer.concat(F);
  }
  data.encodeSlashingTxPolicyToTLV = u;
  function p(k, C, B, Q, P, x) {
    if (!P)
      throw new Error("covenantPks is required");
    const M = [];
    M.push(Buffer.from([119])), M.push(Buffer.from([0, 1])), M.push(Buffer.from([3]));
    const F = s(k), le = Buffer.alloc(4 * F.length);
    F.forEach((Pe, Te) => le.writeUInt32BE(Pe, Te * 4)), M.push(Buffer.from([55])), M.push(Buffer.from([0, le.length])), M.push(le);
    const ge = B.length;
    if (M.push(Buffer.from([249])), M.push(Buffer.from([0, ge])), M.push(Buffer.from([ge])), ge > 0) {
      M.push(Buffer.from([248]));
      const Pe = 32 * ge;
      M.push(Buffer.from([Math.floor(Pe / 256), Pe % 256]));
      for (const Te of B) {
        const Qe = Buffer.from(Te, "hex");
        if (Qe.length !== 32)
          throw new Error(`Invalid finality provider pubkey length: ${Qe.length}, expected 32`);
        M.push(Qe);
      }
    }
    const pe = P.length;
    if (M.push(Buffer.from([192])), M.push(Buffer.from([0, 1])), M.push(Buffer.from([pe])), pe > 0) {
      M.push(Buffer.from([193]));
      const Pe = 32 * pe;
      M.push(Buffer.from([Math.floor(Pe / 256), Pe % 256]));
      for (const Te of P) {
        const Qe = Buffer.from(Te, "hex");
        if (Qe.length !== 32)
          throw new Error(`Invalid covenant pubkey length: ${Qe.length}, expected 32`);
        M.push(Qe);
      }
    }
    M.push(Buffer.from([1])), M.push(Buffer.from([0, 1])), M.push(Buffer.from([Q])), M.push(Buffer.from([255])), M.push(Buffer.from([0, 8]));
    const Ie = Buffer.alloc(8);
    Ie.writeUInt32BE(Math.floor(x / 4294967296), 0), Ie.writeUInt32BE(x % 4294967296, 4), M.push(Ie), M.push(Buffer.from([113])), M.push(Buffer.from([0, 8]));
    const be = Buffer.alloc(8);
    return be.writeUInt32BE(Math.floor(C / 4294967296), 0), be.writeUInt32BE(C % 4294967296, 4), M.push(be), Buffer.concat(M);
  }
  data.encodeUnbondPolicyToTLV = p;
  function t(k, C) {
    const B = [];
    B.push(Buffer.from([119])), B.push(Buffer.from([0, 1])), B.push(Buffer.from([4]));
    const Q = s(k), P = Buffer.alloc(4 * Q.length);
    Q.forEach((M, F) => P.writeUInt32BE(M, F * 4)), B.push(Buffer.from([55])), B.push(Buffer.from([0, P.length])), B.push(P), B.push(Buffer.from([113])), B.push(Buffer.from([0, 8]));
    const x = Buffer.alloc(8);
    return x.writeUInt32BE(Math.floor(C / 4294967296), 0), x.writeUInt32BE(C % 4294967296, 4), B.push(x), Buffer.concat(B);
  }
  data.encodeWithdrawPolicyToTLV = t;
  function l(k, C, B) {
    const Q = [];
    Q.push(Buffer.from([119])), Q.push(Buffer.from([0, 1])), Q.push(Buffer.from([5]));
    const P = s(k), x = Buffer.alloc(4 * P.length);
    return P.forEach((M, F) => x.writeUInt32BE(M, F * 4)), Q.push(Buffer.from([55])), Q.push(Buffer.from([0, x.length])), Q.push(x), console.log("Message Buffer:", C), console.log("Message Length:", C.length), Q.push(Buffer.from([51])), Q.push(Buffer.from([0, C.length])), Q.push(C), B.length == 32 && (Q.push(Buffer.from([52])), Q.push(Buffer.from([0, 32])), Q.push(B)), Buffer.concat(Q);
  }
  data.encodeSignMessagePolicyToTLV = l;
  function m(k, C, B, Q, P) {
    const x = [];
    x.push(Buffer.from([119])), x.push(Buffer.from([0, 1])), x.push(Buffer.from([6]));
    const M = s(k), F = Buffer.alloc(4 * M.length);
    M.forEach((Ie, be) => F.writeUInt32BE(Ie, be * 4)), x.push(Buffer.from([55])), x.push(Buffer.from([0, F.length])), x.push(F);
    const le = B.length;
    if (x.push(Buffer.from([249])), x.push(Buffer.from([0, le])), x.push(Buffer.from([le])), le > 0) {
      x.push(Buffer.from([248]));
      const Ie = 32 * le;
      x.push(Buffer.from([Math.floor(Ie / 256), Ie % 256]));
      for (const be of B) {
        const Pe = Buffer.from(be, "hex");
        if (Pe.length !== 32)
          throw new Error(`Invalid finality provider pubkey length: ${Pe.length}, expected 32`);
        x.push(Pe);
      }
    }
    const ge = P.length;
    if (x.push(Buffer.from([192])), x.push(Buffer.from([0, 1])), x.push(Buffer.from([ge])), ge > 0) {
      x.push(Buffer.from([193]));
      const Ie = 32 * ge;
      x.push(Buffer.from([Math.floor(Ie / 256), Ie % 256]));
      for (const be of P) {
        const Pe = Buffer.from(be, "hex");
        if (Pe.length !== 32)
          throw new Error(`Invalid covenant pubkey length: ${Pe.length}, expected 32`);
        x.push(Pe);
      }
    }
    x.push(Buffer.from([1])), x.push(Buffer.from([0, 1])), x.push(Buffer.from([Q])), x.push(Buffer.from([113])), x.push(Buffer.from([0, 8]));
    const pe = Buffer.alloc(8);
    return pe.writeUInt32BE(Math.floor(C / 4294967296), 0), pe.writeUInt32BE(C % 4294967296, 4), x.push(pe), Buffer.concat(x);
  }
  data.encodeExpansionPolicyToTLV = m;
  function b() {
    const k = [];
    return k.push(Buffer.from([119])), k.push(Buffer.from([0, 1])), k.push(Buffer.from([16])), Buffer.concat(k);
  }
  return data.encodeGetVersionTLV = b, data;
}
var hasRequiredPrepare;
function requirePrepare() {
  if (hasRequiredPrepare) return prepare;
  hasRequiredPrepare = 1;
  var s = prepare && prepare.__importDefault || function(F) {
    return F && F.__esModule ? F : { default: F };
  };
  Object.defineProperty(prepare, "__esModule", { value: !0 }), prepare.getBbnVersion = prepare.expansionTxPolicy = prepare.signMessagePathPolicy = prepare.withdrawPathPolicy = prepare.unbondingPathPolicy = prepare.stakingTxPolicy = prepare.slashingPathPolicy = void 0;
  const A = requireData(), u = s(requireAppClient()), p = requirePolicy(), t = requireUtils(), l = requireTypes();
  async function m(F, le) {
    const ge = new u.default(F), pe = await ge.getMasterFingerprint(), Ie = await ge.getExtendedPubkey(le);
    return [pe, Ie];
  }
  async function b({ transport: F, params: le, derivationPath: ge }) {
    const { timelockBlocks: pe, finalityProviders: Ie, covenantThreshold: be, covenantPks: Pe, slashingPkScriptHex: Te, slashingFeeSat: Qe } = le;
    if (!(0, t.isFullFiveLevelPath)(ge))
      throw new Error("The derivation path should be a full five-level path.");
    const xe = ge.split("/").slice(0, 4).join("/"), [Ee, He] = await m(F, xe), ve = (0, t.getAddressTypeFromPath)(ge);
    let we;
    if (ve === l.AddressType.p2wpkh)
      we = "wpkh(@0/**)";
    else if (ve === l.AddressType.p2tr)
      we = "tr(@0/**)";
    else
      throw new Error("Only p2tr and segwit address types are supported for slashing transactions.");
    const Ce = [];
    Ce.push(`[${xe.replace("m/", `${Ee}/`)}]${He}`);
    const Se = (0, A.encodeSlashingTxPolicyToTLV)(ge, pe, Ie, be, Pe, Te, Qe), Ne = new u.default(F);
    try {
      await Ne.dataPrepare(Se);
    } catch (rr) {
      throw console.error("Error in dataPrepare:", rr), rr;
    }
    return new p.WalletPolicy("", we, Ce);
  }
  prepare.slashingPathPolicy = b;
  async function k({ transport: F, params: le, derivationPath: ge }) {
    if (!(0, t.isFullFiveLevelPath)(ge))
      throw new Error("The derivation path should be a full five-level path.");
    const pe = (0, t.getAddressTypeFromPath)(ge), Ie = ge.split("/").slice(0, 4).join("/"), [be, Pe] = await m(F, Ie), Te = [];
    let Qe;
    if (pe === l.AddressType.p2wpkh)
      Qe = "wpkh(@0/**)";
    else if (pe === l.AddressType.p2tr)
      Qe = "tr(@0/**)";
    else
      throw new Error("Only p2tr and segwit address types are supported for staking transactions.");
    Te.push(`[${Ie.replace("m/", `${be}/`)}]${Pe}`);
    const { timelockBlocks: xe, finalityProviders: Ee, covenantThreshold: He, covenantPks: ve } = le, we = (0, A.encodeStakingTxPolicyToTLV)(ge, xe, Ee, He, ve || []), Ce = new u.default(F);
    try {
      await Ce.dataPrepare(we);
    } catch (Se) {
      throw console.error("Error in dataPrepare:", Se), Se;
    }
    return new p.WalletPolicy("", Qe, Te);
  }
  prepare.stakingTxPolicy = k;
  async function C({ transport: F, params: le, derivationPath: ge }) {
    const { timelockBlocks: pe, finalityProviders: Ie, covenantThreshold: be, covenantPks: Pe, unbondingFeeSat: Te } = le;
    if (!(0, t.isFullFiveLevelPath)(ge))
      throw new Error("The derivation path should be a full five-level path.");
    const Qe = ge.split("/").slice(0, 4).join("/"), [xe, Ee] = await m(F, Qe), He = (0, t.getAddressTypeFromPath)(ge);
    let ve;
    if (He === l.AddressType.p2wpkh)
      ve = "wpkh(@0/**)";
    else if (He === l.AddressType.p2tr)
      ve = "tr(@0/**)";
    else
      throw new Error("Only p2tr and segwit address types are supported for slashing transactions.");
    const we = [];
    we.push(`[${Qe.replace("m/", `${xe}/`)}]${Ee}`);
    const Ce = (0, A.encodeUnbondPolicyToTLV)(ge, pe, Ie, be, Pe, Te), Se = new u.default(F);
    try {
      await Se.dataPrepare(Ce);
    } catch (Ne) {
      throw console.error("Error in dataPrepare:", Ne), Ne;
    }
    return new p.WalletPolicy("", ve, we);
  }
  prepare.unbondingPathPolicy = C;
  async function B({ transport: F, params: le, derivationPath: ge }) {
    const { timelockBlocks: pe } = le;
    if (!(0, t.isFullFiveLevelPath)(ge))
      throw new Error("The derivation path should be a full five-level path.");
    const Ie = ge.split("/").slice(0, 4).join("/"), [be, Pe] = await m(F, Ie), Te = (0, t.getAddressTypeFromPath)(ge);
    let Qe;
    if (Te === l.AddressType.p2wpkh)
      Qe = "wpkh(@0/**)";
    else if (Te === l.AddressType.p2tr)
      Qe = "tr(@0/**)";
    else
      throw new Error("Only p2tr and segwit address types are supported for slashing transactions.");
    const xe = [];
    xe.push(`[${Ie.replace("m/", `${be}/`)}]${Pe}`);
    const Ee = (0, A.encodeWithdrawPolicyToTLV)(ge, pe), He = new u.default(F);
    try {
      await He.dataPrepare(Ee);
    } catch (ve) {
      throw console.error("Error in dataPrepare:", ve), ve;
    }
    return new p.WalletPolicy("", Qe, xe);
  }
  prepare.withdrawPathPolicy = B;
  async function Q({ transport: F, params: le, derivationPath: ge }) {
    if (!(0, t.isFullFiveLevelPath)(ge))
      throw new Error("The derivation path should be a full five-level path.");
    const pe = ge.split("/").slice(0, 4).join("/"), { message: Ie, pubkey: be } = le, [Pe, Te] = await m(F, pe), Qe = [], xe = (0, t.getAddressTypeFromPath)(ge);
    let Ee;
    if (xe === l.AddressType.p2wpkh)
      Ee = "wpkh(@0/**)";
    else if (xe === l.AddressType.p2tr)
      Ee = "tr(@0/**)";
    else
      throw new Error("Only p2tr and segwit address types are supported for slashing transactions.");
    if (console.log("Derivation Path for Sign Message Policy:", ge), console.log("descriptorTemplate:", Ee), Qe.push(`[${pe.replace("m/", `${Pe}/`)}]${Te}`), Ie.length == 0 || Ie.length > 128)
      throw new Error("The message should be a non-empty string with a maximum length of 128 characters.");
    console.log("message:", Ie);
    const He = (0, A.encodeSignMessagePolicyToTLV)(ge, Buffer.from(Ie), be), ve = new u.default(F);
    try {
      await ve.dataPrepare(He);
    } catch (we) {
      throw console.error("Error in dataPrepare:", we), we;
    }
    return new p.WalletPolicy("", Ee, Qe);
  }
  prepare.signMessagePathPolicy = Q;
  async function P({ transport: F, params: le, derivationPath: ge }) {
    if (!(0, t.isFullFiveLevelPath)(ge))
      throw new Error("The derivation path should be a full five-level path.");
    const pe = (0, t.getAddressTypeFromPath)(ge), Ie = ge.split("/").slice(0, 4).join("/"), [be, Pe] = await m(F, Ie), Te = [];
    let Qe;
    if (pe === l.AddressType.p2wpkh)
      Qe = "wpkh(@0/**)";
    else if (pe === l.AddressType.p2tr)
      Qe = "tr(@0/**)";
    else
      throw new Error("Only p2tr and segwit address types are supported for staking transactions.");
    Te.push(`[${Ie.replace("m/", `${be}/`)}]${Pe}`);
    const { timelockBlocks: xe, finalityProviders: Ee, covenantThreshold: He, covenantPks: ve } = le, we = (0, A.encodeExpansionPolicyToTLV)(ge, xe, Ee, He, ve || []), Ce = new u.default(F);
    try {
      await Ce.dataPrepare(we);
    } catch (Se) {
      throw console.error("Error in dataPrepare:", Se), Se;
    }
    return new p.WalletPolicy("", Qe, Te);
  }
  prepare.expansionTxPolicy = P;
  const x = {
    v1: 1,
    v2: 2
  };
  async function M(F) {
    var le;
    const ge = new u.default(F), pe = (0, A.encodeGetVersionTLV)();
    try {
      return await ge.dataPrepare(pe), console.log("[getVersion] Device responded successfully, firmware version: v2"), x.v2;
    } catch (Ie) {
      return (Ie == null ? void 0 : Ie.statusCode) === 27904 || !((le = Ie == null ? void 0 : Ie.message) === null || le === void 0) && le.includes("6d00") ? (console.log("[getVersion] Device returned 0x6d00 (instruction not supported), firmware version: v1"), x.v1) : (console.warn("[getVersion] Error querying version, defaulting to v1:", Ie), x.v1);
    }
  }
  return prepare.getBbnVersion = M, prepare;
}
var hasRequiredBip322;
function requireBip322() {
  if (hasRequiredBip322) return bip322;
  hasRequiredBip322 = 1;
  var s = bip322 && bip322.__createBinding || (Object.create ? function(He, ve, we, Ce) {
    Ce === void 0 && (Ce = we);
    var Se = Object.getOwnPropertyDescriptor(ve, we);
    (!Se || ("get" in Se ? !ve.__esModule : Se.writable || Se.configurable)) && (Se = { enumerable: !0, get: function() {
      return ve[we];
    } }), Object.defineProperty(He, Ce, Se);
  } : function(He, ve, we, Ce) {
    Ce === void 0 && (Ce = we), He[Ce] = ve[we];
  }), A = bip322 && bip322.__setModuleDefault || (Object.create ? function(He, ve) {
    Object.defineProperty(He, "default", { enumerable: !0, value: ve });
  } : function(He, ve) {
    He.default = ve;
  }), u = bip322 && bip322.__importStar || function(He) {
    if (He && He.__esModule) return He;
    var ve = {};
    if (He != null) for (var we in He) we !== "default" && Object.prototype.hasOwnProperty.call(He, we) && s(ve, He, we);
    return A(ve, He), ve;
  }, p = bip322 && bip322.__importDefault || function(He) {
    return He && He.__esModule ? He : { default: He };
  };
  Object.defineProperty(bip322, "__esModule", { value: !0 }), bip322.signMessageBIP322 = bip322.createTaprootBip322Signature = bip322.createSegwitBip322Signature = bip322.bip0322Hash = void 0;
  const t = u(requireDist$l()), l = requireSrc$3(), m = requireSrc$1(), b = requireVaruintBitcoin(), k = p(requireMain()), C = requireTypes(), B = requireUtils(), Q = requireTypes(), P = requirePrepare(), x = (0, m.BIP32Factory)(t), M = (He) => Buffer.concat([(0, b.encode)(He.byteLength), He]), F = Buffer.from("0000000000000000000000000000000000000000000000000000000000000000", "hex"), le = 4294967295, ge = 0;
  function pe(He) {
    const { sha256: ve } = l.crypto, Ce = ve(Buffer.from("BIP0322-signed-message"));
    return ve(Buffer.concat([Ce, Ce, Buffer.from(He)])).toString("hex");
  }
  bip322.bip0322Hash = pe;
  const Ie = async (He, ve, we, Ce, Se, Ne) => {
    const rr = Buffer.concat([
      Buffer.from("0020", "hex"),
      Buffer.from(pe(we), "hex")
    ]), er = new l.Transaction();
    er.version = 0, er.addInput(F, le, ge, rr), er.addOutput(Ce, 0);
    const ir = new l.Psbt();
    ir.setVersion(0), ir.addInput(Object.assign({ hash: er.getHash(), index: 0, sequence: 0, witnessUtxo: {
      script: Ce,
      value: 0
    } }, Se)), ir.addOutput({ script: Buffer.from("6a", "hex"), value: 0 });
    const sr = await He.signPsbt(ir.toBase64(), ve, null);
    for (const Br of sr)
      Ne ? ir.updateInput(Br[0], {
        partialSig: [Br[1]]
      }) : ir.updateInput(Br[0], {
        tapKeySig: Br[1].signature
      });
    ir.finalizeAllInputs();
    const nr = ir.extractTransaction(), fr = (0, b.encode)(nr.ins[0].witness.length);
    return {
      signature: Buffer.concat([
        fr,
        ...nr.ins[0].witness.map((Br) => M(Br))
      ]).toString("base64"),
      protocol: C.MessageSigningProtocols.BIP322
    };
  };
  function be(He, ve, we) {
    const Ce = we ? l.networks.testnet : l.networks.bitcoin, { publicKey: Se } = x.fromBase58(He, Ce).derivePath(`0/${ve}`);
    return Se;
  }
  function Pe(He, ve, we = !1) {
    (0, l.initEccLib)(t);
    const Ce = be(He, ve, we), Se = we ? l.networks.testnet : l.networks.bitcoin, Ne = l.payments.p2wpkh({ pubkey: Ce, network: Se }), rr = Ne.address;
    if (!rr)
      throw new Error("Address is null");
    if (!Ne.output)
      throw new Error("p2wpkh output is null");
    return {
      publicKey: Ce,
      address: rr,
      witnessScript: Ne.output
    };
  }
  async function Te({ message: He, app: ve, derivationPath: we, isTestnet: Ce = !1 }) {
    const Se = ve.transport, Ne = await ve.getMasterFingerprint();
    console.log("Master Fingerprint:", Ne), console.log("Derivation Path:", we);
    const rr = we.split("/").slice(0, 4).join("/");
    console.log("Three Level Path:", rr);
    const er = await ve.getExtendedPubkey(rr);
    console.log("Extended Public Key:", er), console.log("extendedPublicKey:", er);
    const { publicKey: ir, witnessScript: sr } = Pe(er, 0, Ce);
    console.log("createSegwitBip322Signature Public Key:", ir.toString("hex"));
    const nr = {
      path: we,
      pubkey: ir,
      masterFingerprint: Buffer.from(Ne, "hex")
    };
    console.log("Input Derivation:", nr);
    const fr = {
      message: He,
      pubkey: Buffer.from(sr.slice(2))
    }, lr = await (0, P.signMessagePathPolicy)({
      transport: Se,
      params: fr,
      derivationPath: we,
      isTestnet: Ce
    });
    return console.log("Policy created"), console.log("policy:", lr), Ie(ve, lr, He, sr, {
      bip32Derivation: [nr]
    }, !0);
  }
  bip322.createSegwitBip322Signature = Te;
  function Qe(He, ve, we = !1) {
    (0, l.initEccLib)(t);
    const Ce = be(He, ve, we), Se = l.payments.p2tr({
      internalPubkey: Ce.slice(1),
      network: we ? l.networks.testnet : l.networks.bitcoin
    });
    if (!Se.output || !Se.address || !Se.internalPubkey)
      throw new Error("p2tr output, address or internalPubkey is null");
    return {
      publicKey: Ce,
      address: Se.address,
      internalPubkey: Se.internalPubkey,
      taprootScript: Se.output
    };
  }
  async function xe({ message: He, app: ve, derivationPath: we, isTestnet: Ce = !1 }) {
    const Se = ve.transport, Ne = await ve.getMasterFingerprint(), rr = we.split("/").slice(0, 4).join("/"), er = await ve.getExtendedPubkey(rr), { internalPubkey: ir, taprootScript: sr } = Qe(er, 0, Ce);
    console.log("createTaprootBip322Signature Internal Public Key:", ir.toString("hex"));
    const nr = {
      path: we,
      pubkey: ir,
      masterFingerprint: Buffer.from(Ne, "hex"),
      leafHashes: []
    }, fr = {
      message: He,
      pubkey: Buffer.from(sr.slice(2))
    }, lr = await (0, P.signMessagePathPolicy)({
      transport: Se,
      params: fr,
      derivationPath: we,
      isTestnet: Ce
    });
    return Ie(ve, lr, He, sr, {
      tapBip32Derivation: [nr],
      tapInternalKey: ir
    }, !1);
  }
  bip322.createTaprootBip322Signature = xe;
  async function Ee({ transport: He, message: ve, derivationPath: we, isTestnet: Ce = !1 }) {
    console.log("Derivation Path:", we);
    const Se = (0, B.getAddressTypeFromPath)(we);
    if (console.log("Address Type:", Se), !Se)
      throw new Error("The derivation path is not valid.");
    const Ne = new k.default(He);
    return Se === Q.AddressType.p2tr ? (console.log("Creating Taproot BIP322 Signature"), xe({
      message: ve,
      app: Ne,
      derivationPath: we,
      isTestnet: Ce
    })) : (console.log("12 Creating Segwit BIP322 Signature"), Te({
      message: ve,
      app: Ne,
      derivationPath: we,
      isTestnet: Ce
    }));
  }
  return bip322.signMessageBIP322 = Ee, bip322;
}
var hasRequiredBabylon;
function requireBabylon() {
  return hasRequiredBabylon || (hasRequiredBabylon = 1, function(s) {
    var A = babylon && babylon.__importDefault || function(x) {
      return x && x.__esModule ? x : { default: x };
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), s.getBbnVersion = s.expansionTxPolicy = s.unbondingPathPolicy = s.stakingTxPolicy = s.slashingPathPolicy = s.withdrawPathPolicy = s.signMessage = s.signPsbt = void 0;
    const u = /* @__PURE__ */ requireLib$1(), p = /* @__PURE__ */ requireBtcSigner(), t = A(requireAppClient()), l = requireBip322(), m = requireUtils(), b = requirePsbtv2();
    function k(x, M) {
      try {
        const F = new b.PsbtV2();
        F.deserialize(Buffer.from(u.base64.decode(x)));
        const le = F.getInputWitnessUtxo(M);
        if (le) {
          const ge = le.scriptPubKey;
          if (console.log(`[detectInputAddressType] Input ${M}: scriptPubKey length=${ge.length}, hex=${ge.toString("hex").substring(0, 20)}...`), ge.length === 34 && ge[0] === 81 && ge[1] === 32)
            return console.log(`[detectInputAddressType] Input ${M}: detected as p2tr (Taproot)`), "p2tr";
          if (ge.length === 22 && ge[0] === 0 && ge[1] === 20)
            return console.log(`[detectInputAddressType] Input ${M}: detected as p2wpkh (Native SegWit)`), "p2wpkh";
        }
        console.log(`[detectInputAddressType] Input ${M}: unknown address type`);
      } catch (F) {
        console.warn(`[detectInputAddressType] Input ${M}: Failed to detect address type:`, F);
      }
      return "unknown";
    }
    function C(x, M) {
      try {
        const F = Buffer.from(x, "base64"), pe = requireSrc$3().Psbt.fromBuffer(F).data.inputs[M], Ie = !!(pe && pe.tapLeafScript && pe.tapLeafScript.length > 0);
        return console.log(`[hasInputTaprootScript] Input ${M}: ${Ie ? "HAS" : "NO"} taproot script`), Ie;
      } catch (F) {
        return console.warn(`[hasInputTaprootScript] Input ${M}: Failed to check taproot script:`, F), !1;
      }
    }
    async function B({ transport: x, psbt: M, policy: F }) {
      const le = new t.default(x), ge = M instanceof Uint8Array ? u.base64.encode(M) : M;
      console.log("[signPsbt] Starting PSBT signing process...");
      const pe = await le.signPsbt(ge, F, null);
      console.log(`[signPsbt] Received ${pe.length} signature(s) from Ledger`);
      const Ie = p.Transaction.fromPSBT(u.base64.decode(ge));
      for (const be of pe) {
        const Pe = be[0];
        console.log(`
[signPsbt] === Processing signature for input ${Pe} ===`);
        const Te = k(ge, Pe), Qe = C(ge, Pe);
        if (console.log(`[signPsbt] Input ${Pe}: addressType=${Te}, hasScript=${Qe}`), console.log(`[signPsbt] Input ${Pe}: signature length=${be[1].signature.length} bytes`), console.log(`[signPsbt] Input ${Pe}: pubkey length=${be[1].pubkey.length} bytes`), be[1].tapleafHash && console.log(`[signPsbt] Input ${Pe}: tapleafHash present (${be[1].tapleafHash.length} bytes)`), Qe) {
          console.log(`[signPsbt] Input ${Pe}: Using tapScriptSig (script path)`);
          let xe = be[1].signature;
          if (Te === "p2tr" && xe.length > 64)
            if (xe.length === 65)
              console.log(`[signPsbt] Input ${Pe}: Trimming Schnorr signature from 65 to 64 bytes`), xe = xe.slice(0, 64);
            else
              throw new Error(`Invalid Schnorr signature length: ${xe.length} bytes. Expected 64 or 65 bytes.`);
          Ie.updateInput(Pe, {
            tapScriptSig: [
              [
                {
                  pubKey: new Uint8Array(be[1].pubkey),
                  leafHash: new Uint8Array(be[1].tapleafHash || Buffer.alloc(32))
                },
                new Uint8Array(xe)
              ]
            ]
          }, !0), console.log(`[signPsbt] Input ${Pe}: tapScriptSig added successfully`);
        } else {
          let xe = be[1].signature;
          if (Te === "p2tr") {
            if (console.log(`[signPsbt] Input ${Pe}: Using tapKeySig (Taproot key path)`), xe.length > 64)
              if (xe.length === 65)
                console.log(`[signPsbt] Input ${Pe}: Trimming Schnorr signature from 65 to 64 bytes`), xe = xe.slice(0, 64);
              else
                throw new Error(`Invalid Schnorr signature length: ${xe.length} bytes. Expected 64 or 65 bytes.`);
            Ie.updateInput(Pe, {
              tapKeySig: new Uint8Array(xe)
            }, !0), console.log(`[signPsbt] Input ${Pe}: tapKeySig added successfully (${xe.length} bytes)`);
          } else Te === "p2wpkh" ? (console.log(`[signPsbt] Input ${Pe}: Using partialSig (Native SegWit ECDSA)`), Ie.updateInput(Pe, {
            partialSig: [
              [new Uint8Array(be[1].pubkey), new Uint8Array(xe)]
            ]
          }, !0), console.log(`[signPsbt] Input ${Pe}: partialSig added successfully (${xe.length} bytes ECDSA/DER)`)) : (console.warn(`[signPsbt] Input ${Pe}: Unknown address type, defaulting to taproot key path`), xe.length > 64 && xe.length === 65 && (console.log(`[signPsbt] Input ${Pe}: Trimming signature from 65 to 64 bytes`), xe = xe.slice(0, 64)), Ie.updateInput(Pe, {
            tapKeySig: new Uint8Array(xe)
          }, !0), console.log(`[signPsbt] Input ${Pe}: tapKeySig added (fallback)`));
        }
      }
      return console.log(`[signPsbt] All signatures processed successfully
`), Ie;
    }
    s.signPsbt = B;
    async function Q(x) {
      const { transport: M, message: F, derivationPath: le } = x;
      if (!M)
        throw new Error("signMessage: transport is required");
      if (typeof F != "string" || F.length === 0)
        throw new Error("signMessage: message must be a non-empty string");
      if (console.log("Signing message:", F), !(0, m.isFullFiveLevelPath)(le))
        throw new Error("The derivation path should be a full five-level path.");
      const ge = (0, m.isTestnetPath)(le);
      return (0, l.signMessageBIP322)({
        transport: M,
        message: F,
        derivationPath: le,
        isTestnet: ge
      });
    }
    s.signMessage = Q;
    var P = requirePrepare();
    Object.defineProperty(s, "withdrawPathPolicy", { enumerable: !0, get: function() {
      return P.withdrawPathPolicy;
    } }), Object.defineProperty(s, "slashingPathPolicy", { enumerable: !0, get: function() {
      return P.slashingPathPolicy;
    } }), Object.defineProperty(s, "stakingTxPolicy", { enumerable: !0, get: function() {
      return P.stakingTxPolicy;
    } }), Object.defineProperty(s, "unbondingPathPolicy", { enumerable: !0, get: function() {
      return P.unbondingPathPolicy;
    } }), Object.defineProperty(s, "expansionTxPolicy", { enumerable: !0, get: function() {
      return P.expansionTxPolicy;
    } }), Object.defineProperty(s, "getBbnVersion", { enumerable: !0, get: function() {
      return P.getBbnVersion;
    } });
  }(babylon)), babylon;
}
var hasRequiredMain;
function requireMain() {
  return hasRequiredMain || (hasRequiredMain = 1, function(s) {
    var A = main && main.__createBinding || (Object.create ? function(C, B, Q, P) {
      P === void 0 && (P = Q);
      var x = Object.getOwnPropertyDescriptor(B, Q);
      (!x || ("get" in x ? !B.__esModule : x.writable || x.configurable)) && (x = { enumerable: !0, get: function() {
        return B[Q];
      } }), Object.defineProperty(C, P, x);
    } : function(C, B, Q, P) {
      P === void 0 && (P = Q), C[P] = B[Q];
    }), u = main && main.__setModuleDefault || (Object.create ? function(C, B) {
      Object.defineProperty(C, "default", { enumerable: !0, value: B });
    } : function(C, B) {
      C.default = B;
    }), p = main && main.__importStar || function(C) {
      if (C && C.__esModule) return C;
      var B = {};
      if (C != null) for (var Q in C) Q !== "default" && Object.prototype.hasOwnProperty.call(C, Q) && A(B, C, Q);
      return u(B, C), B;
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), s.getBbnVersion = s.signMessage = s.signPsbt = s.expansionTxPolicy = s.stakingTxPolicy = s.withdrawPathPolicy = s.unbondingPathPolicy = s.slashingPathPolicy = s.PartialSignature = s.PsbtV2 = s.AppClient = s.WalletPolicy = s.DefaultWalletPolicy = void 0;
    const t = p(requireAppClient());
    s.AppClient = t.default, Object.defineProperty(s, "PartialSignature", { enumerable: !0, get: function() {
      return t.PartialSignature;
    } });
    const l = requirePolicy();
    Object.defineProperty(s, "DefaultWalletPolicy", { enumerable: !0, get: function() {
      return l.DefaultWalletPolicy;
    } }), Object.defineProperty(s, "WalletPolicy", { enumerable: !0, get: function() {
      return l.WalletPolicy;
    } });
    const m = requireBabylon();
    Object.defineProperty(s, "signMessage", { enumerable: !0, get: function() {
      return m.signMessage;
    } }), Object.defineProperty(s, "signPsbt", { enumerable: !0, get: function() {
      return m.signPsbt;
    } }), Object.defineProperty(s, "slashingPathPolicy", { enumerable: !0, get: function() {
      return m.slashingPathPolicy;
    } }), Object.defineProperty(s, "stakingTxPolicy", { enumerable: !0, get: function() {
      return m.stakingTxPolicy;
    } }), Object.defineProperty(s, "withdrawPathPolicy", { enumerable: !0, get: function() {
      return m.withdrawPathPolicy;
    } }), Object.defineProperty(s, "unbondingPathPolicy", { enumerable: !0, get: function() {
      return m.unbondingPathPolicy;
    } }), Object.defineProperty(s, "expansionTxPolicy", { enumerable: !0, get: function() {
      return m.expansionTxPolicy;
    } });
    const b = requirePrepare();
    Object.defineProperty(s, "getBbnVersion", { enumerable: !0, get: function() {
      return b.getBbnVersion;
    } });
    const k = requirePsbtv2();
    Object.defineProperty(s, "PsbtV2", { enumerable: !0, get: function() {
      return k.PsbtV2;
    } }), s.default = t.default;
  }(main)), main;
}
var mainExports = requireMain();
const AppClient = /* @__PURE__ */ getDefaultExportFromCjs(mainExports), getPolicyForTransaction = async (s, A, {
  contracts: u,
  action: p,
  addressIndex: t
}) => {
  const l = `${A}/0/${t}`;
  switch (p.name) {
    case ActionName.SIGN_BTC_STAKING_TRANSACTION:
      return getStakingPolicy(u, l, s);
    case ActionName.SIGN_BTC_STAKING_EXPANSION_TRANSACTION:
      return getExpansionPolicy(u, l, s);
    case ActionName.SIGN_BTC_UNBONDING_TRANSACTION:
      return getUnbondingPolicy(u, l, s);
    case ActionName.SIGN_BTC_SLASHING_TRANSACTION:
      return getSlashingPolicy(u, l, s);
    case ActionName.SIGN_BTC_UNBONDING_SLASHING_TRANSACTION:
      return getUnbondingSlashingPolicy(u, l, s);
    case ActionName.SIGN_BTC_WITHDRAW_TRANSACTION:
      return getWithdrawPolicy(u, l, s);
    default:
      throw new Error(`Unknown action: ${p.name}`);
  }
}, getStakingPolicy = (s, A, u) => {
  const p = s.find((k) => k.id === BABYLON_SIGNING_CONTRACTS.STAKING);
  if (!p)
    throw new Error("Staking contract is required");
  const { finalityProviders: t, covenantThreshold: l, covenantPks: m, stakingDuration: b } = p.params;
  return mainExports.stakingTxPolicy({
    transport: u,
    params: {
      finalityProviders: t,
      covenantThreshold: l,
      covenantPks: sortPkHexes(m),
      timelockBlocks: b
    },
    derivationPath: A
  });
}, getExpansionPolicy = (s, A, u) => {
  const p = s.find((k) => k.id === BABYLON_SIGNING_CONTRACTS.STAKING_EXPANSION);
  if (!p)
    throw new Error("Expansion contract is required");
  const { finalityProviders: t, covenantThreshold: l, covenantPks: m, stakingDuration: b } = p.params;
  return mainExports.expansionTxPolicy({
    transport: u,
    params: {
      finalityProviders: t,
      covenantThreshold: l,
      covenantPks: sortPkHexes(m),
      timelockBlocks: b
    },
    derivationPath: A
  });
}, getUnbondingPolicy = (s, A, u) => {
  const p = s.find((C) => C.id === BABYLON_SIGNING_CONTRACTS.UNBONDING);
  if (!p)
    throw new Error("Unbonding contract is required");
  const { finalityProviders: t, covenantThreshold: l, covenantPks: m, unbondingTimeBlocks: b, unbondingFeeSat: k } = p.params;
  return mainExports.unbondingPathPolicy({
    transport: u,
    params: {
      finalityProviders: t,
      covenantThreshold: l,
      covenantPks: sortPkHexes(m),
      timelockBlocks: b,
      unbondingFeeSat: k
    },
    derivationPath: A
  });
}, getSlashingPolicy = (s, A, u) => {
  const p = s.find((P) => P.id === BABYLON_SIGNING_CONTRACTS.SLASHING);
  if (!p)
    throw new Error("Slashing contract is required in slashing transaction");
  const t = s.find((P) => P.id === BABYLON_SIGNING_CONTRACTS.STAKING);
  if (!t)
    throw new Error("Staking contract is required in slashing transaction");
  const l = s.find((P) => P.id === BABYLON_SIGNING_CONTRACTS.SLASHING_BURN);
  if (!l)
    throw new Error("Slashing burn contract is required in unbonding slashing transaction");
  const { unbondingTimeBlocks: m, slashingFeeSat: b } = p.params, { covenantPks: k, finalityProviders: C, covenantThreshold: B } = t.params, { slashingPkScriptHex: Q } = l.params;
  return mainExports.slashingPathPolicy({
    transport: u,
    params: {
      timelockBlocks: m,
      finalityProviders: C,
      covenantThreshold: B,
      covenantPks: sortPkHexes(k),
      slashingPkScriptHex: Q,
      slashingFeeSat: b
    },
    derivationPath: A
  });
}, getUnbondingSlashingPolicy = (s, A, u) => {
  const p = s.find((P) => P.id === BABYLON_SIGNING_CONTRACTS.SLASHING);
  if (!p)
    throw new Error("Slashing contract is required in unbonding slashing transaction");
  const t = s.find((P) => P.id === BABYLON_SIGNING_CONTRACTS.UNBONDING);
  if (!t)
    throw new Error("Unbonding contract is required in unbonding slashing transaction");
  const l = s.find((P) => P.id === BABYLON_SIGNING_CONTRACTS.SLASHING_BURN);
  if (!l)
    throw new Error("Slashing burn contract is required in unbonding slashing transaction");
  const { unbondingTimeBlocks: m, slashingFeeSat: b } = p.params, { covenantPks: k, finalityProviders: C, covenantThreshold: B } = t.params, { slashingPkScriptHex: Q } = l.params;
  return mainExports.slashingPathPolicy({
    transport: u,
    params: {
      timelockBlocks: m,
      finalityProviders: C,
      covenantThreshold: B,
      covenantPks: sortPkHexes(k),
      slashingPkScriptHex: Q,
      slashingFeeSat: b
    },
    derivationPath: A
  });
}, getWithdrawPolicy = (s, A, u) => {
  const p = s.find((l) => l.id === BABYLON_SIGNING_CONTRACTS.WITHDRAW);
  if (!p)
    throw new Error("Withdraw timelock expired contract is required");
  const { timelockBlocks: t } = p.params;
  return mainExports.withdrawPathPolicy({
    transport: u,
    params: {
      timelockBlocks: t
    },
    derivationPath: A
  });
}, WALLET_PROVIDER_NAME$4 = "Ledger";
class LedgerProviderV2 {
  constructor(A, u) {
    Ci(this, "ledgerWalletInfo");
    Ci(this, "config");
    Ci(this, "derivationConfig");
    Ci(this, "connectWallet", async () => {
      const A = await this.createAppClient(), u = await mainExports.getBbnVersion(A.transport);
      if (u < 2)
        throw new Error(`Ledger firmware version too low. Required: v2 or higher, Found: v${u}`);
      const p = await A.getMasterFingerprint(), t = this.getDerivationPath(), l = await A.getExtendedPubkey(t), m = await this.getWalletPolicy(A, p, t);
      if (!m) throw new Error("Could not retrieve the policy");
      const { address: b, publicKeyHex: k } = await this.getLedgerAccount(A, m, l);
      this.ledgerWalletInfo = {
        app: A,
        policy: m,
        mfp: p,
        extendedPublicKey: l,
        path: t,
        address: b,
        publicKeyHex: k
      };
    });
    Ci(this, "getAddress", async () => {
      var A;
      if (!((A = this.ledgerWalletInfo) != null && A.address)) throw new Error("Could not retrieve the address");
      return this.ledgerWalletInfo.address;
    });
    Ci(this, "getPublicKeyHex", async () => {
      var A;
      if (!((A = this.ledgerWalletInfo) != null && A.publicKeyHex)) throw new Error("Could not retrieve the BTC public key");
      return this.ledgerWalletInfo.publicKeyHex;
    });
    Ci(this, "signPsbt", async (A, u) => {
      var C, B, Q;
      if (!((C = this.ledgerWalletInfo) != null && C.address) || !((B = this.ledgerWalletInfo) != null && B.publicKeyHex))
        throw new Error("Ledger is not connected");
      if (!A) throw new Error("psbt hex is required");
      const p = Buffer$1.from(A, "hex").toString("base64"), t = this.ledgerWalletInfo.app.transport;
      if (!t || !(t instanceof Transport))
        throw new Error("Transport is required to sign psbt");
      if (!this.ledgerWalletInfo.path)
        throw new Error("Derivation path is required to sign psbt");
      if (!(u != null && u.contracts) || (u == null ? void 0 : u.contracts.length) === 0)
        throw new Error("Contracts are required to sign psbt in ledger");
      if (!((Q = u == null ? void 0 : u.action) != null && Q.name))
        throw new Error("Action name is required to sign psbt in ledger");
      const l = await getPolicyForTransaction(t, this.ledgerWalletInfo.path, {
        contracts: u.contracts,
        action: u.action,
        addressIndex: this.derivationConfig.addressIndex
      }), m = await mainExports.signPsbt({
        transport: t,
        psbt: p,
        policy: l
      }), b = Transaction.fromPSBT(m.toPSBT(), {
        allowUnknownInputs: !0,
        allowUnknownOutputs: !0
      });
      return b.finalize(), Buffer$1.from(b.toPSBT()).toString("hex");
    });
    Ci(this, "signPsbts", async (A, u) => {
      var t, l, m;
      if (!((t = this.ledgerWalletInfo) != null && t.address) || !((l = this.ledgerWalletInfo) != null && l.publicKeyHex) || !((m = this.ledgerWalletInfo) != null && m.policy))
        throw new Error("Ledger is not connected");
      if (!A || !Array.isArray(A) || A.length === 0)
        throw new Error("psbts hexes are required");
      const p = [];
      for (let b = 0; b < A.length; b++) {
        const k = A[b], C = u ? u[b] : void 0;
        if (!k)
          throw new Error(`psbt hex at index ${b} is required`);
        if (typeof k != "string")
          throw new Error(`psbt hex at index ${b} must be a string`);
        const B = await this.signPsbt(k, C);
        p.push(B);
      }
      return p;
    });
    Ci(this, "getNetwork", async () => this.config.network);
    Ci(this, "signMessage", async (A) => {
      var t, l, m;
      if (!((t = this.ledgerWalletInfo) != null && t.app.transport) || !((l = this.ledgerWalletInfo) != null && l.path))
        throw new Error("Ledger is not connected");
      const u = `${this.ledgerWalletInfo.path}/0/${this.derivationConfig.addressIndex}`;
      return (await mainExports.signMessage({
        transport: (m = this.ledgerWalletInfo) == null ? void 0 : m.app.transport,
        message: A,
        derivationPath: u
      })).signature;
    });
    Ci(this, "getInscriptions", async () => {
      throw new Error("Method not implemented.");
    });
    // Not implemented because of the hardware wallet nature
    Ci(this, "on", () => {
    });
    Ci(this, "off", () => {
    });
    Ci(this, "getWalletProviderName", async () => WALLET_PROVIDER_NAME$4);
    Ci(this, "getWalletProviderIcon", async () => logo$3);
    this.config = u, this.derivationConfig = {
      purpose: 84,
      addressIndex: 0
    };
  }
  /**
   * Set the derivation configuration for address generation
   * @param config - Partial derivation config to merge with current settings
   */
  setDerivationConfig(A) {
    this.derivationConfig = {
      ...this.derivationConfig,
      ...A
    };
  }
  /**
   * Get the current derivation configuration
   * @returns A copy of the current derivation config
   */
  getDerivationConfig() {
    return { ...this.derivationConfig };
  }
  // Create a transport instance for Ledger devices
  // It first tries to create a WebUSB transport
  // and if that fails, it falls back to WebHID
  async createTransport() {
    try {
      return await TransportWebUSB.create();
    } catch (A) {
      try {
        return await TransportWebHID.create();
      } catch (u) {
        throw new Error(
          `Could not connect to Ledger device: ${A.message || A}, ${u.message || u}`
        );
      }
    }
  }
  // Get the network derivation index based on the network
  // 0 for MAINNET, 1 for TESTNET
  getNetworkDerivationIndex() {
    return this.config.network === Network.MAINNET ? 0 : 1;
  }
  getDerivationPath() {
    const A = this.getNetworkDerivationIndex();
    return `m/${this.derivationConfig.purpose}'/${A}'/0'`;
  }
  // Create a new AppClient instance using the transport
  async createAppClient() {
    const A = await this.createTransport();
    return new AppClient(A);
  }
  async getWalletPolicy(A, u, p) {
    const t = await A.getExtendedPubkey(p);
    if (!t)
      throw new Error("Could not retrieve the extended public key for policy");
    const l = this.getNetworkDerivationIndex(), m = this.derivationConfig.purpose;
    let b;
    if (m === 86)
      b = "tr(@0/**)";
    else if (m === 84)
      b = "wpkh(@0/**)";
    else
      throw new Error(`Unsupported purpose ${m}. Only 84 (wpkh) and 86 (tr) are supported.`);
    const k = `[${u}/${m}'/${l}'/0']${t}`, C = new mainExports.DefaultWalletPolicy(b, k);
    if (!C)
      throw new Error("Could not create the wallet policy");
    return C;
  }
  async getLedgerAccount(A, u, p) {
    const t = await A.getWalletAddress(
      u,
      null,
      0,
      // 0 - normal, 1 - change
      this.derivationConfig.addressIndex,
      !0
      // show address on the wallet's screen
    ), l = await this.getNetwork(), m = getPublicKeyFromXpub(
      p,
      `M/0/${this.derivationConfig.addressIndex}`,
      toNetwork(l)
    );
    return { address: t, publicKeyHex: m.toString("hex") };
  }
}
const metadata$7 = {
  id: "ledger_btc_v2",
  name: `${WALLET_PROVIDER_NAME$4} v2`,
  icon: logo$3,
  docs: "https://www.ledger.com/ledger-live",
  createProvider: (s, A) => new LedgerProviderV2(s, A),
  networks: [Network.SIGNET, Network.MAINNET],
  label: "Hardware wallet"
}, logo$2 = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20width='225px'%20height='224px'%20viewBox='0%200%20225%20224'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3ctitle%3eokx%3c/title%3e%3cg%20id='Page-1'%20stroke='none'%20strokeWidth='1'%20fill='none'%20fill-rule='evenodd'%3e%3cg%20id='okx'%20transform='translate(0.401000,%200.006000)'%20fill='%23000000'%20fill-rule='nonzero'%3e%3cpath%20d='M144.382,74.667%20L79.673,74.667%20C76.924,74.667%2074.695,76.895%2074.695,79.644%20L74.695,144.354%20C74.695,147.103%2076.924,149.332%2079.673,149.332%20L144.382,149.332%20C147.131,149.332%20149.36,147.103%20149.36,144.354%20L149.36,79.644%20C149.36,76.895%20147.131,74.667%20144.382,74.667%20Z'%20id='Path'%3e%3c/path%3e%3cpath%20d='M69.687,0%20L4.978,0%20C2.229,0%200,2.228%200,4.978%20L0,69.687%20C0,72.436%202.229,74.665%204.978,74.665%20L69.687,74.665%20C72.437,74.665%2074.665,72.436%2074.665,69.687%20L74.665,4.978%20C74.665,2.228%2072.437,0%2069.687,0%20Z'%20id='Path'%3e%3c/path%3e%3cpath%20d='M219.017,0%20L154.307,0%20C151.558,0%20149.329,2.228%20149.329,4.978%20L149.329,69.687%20C149.329,72.436%20151.558,74.665%20154.307,74.665%20L219.017,74.665%20C221.766,74.665%20223.994,72.436%20223.994,69.687%20L223.994,4.978%20C223.994,2.228%20221.766,0%20219.017,0%20Z'%20id='Path'%3e%3c/path%3e%3cpath%20d='M69.687,149.328%20L4.978,149.328%20C2.229,149.328%200,151.556%200,154.305%20L0,219.015%20C0,221.764%202.229,223.993%204.978,223.993%20L69.687,223.993%20C72.437,223.993%2074.665,221.764%2074.665,219.015%20L74.665,154.305%20C74.665,151.556%2072.437,149.328%2069.687,149.328%20Z'%20id='Path'%3e%3c/path%3e%3cpath%20d='M219.017,149.328%20L154.307,149.328%20C151.558,149.328%20149.329,151.556%20149.329,154.305%20L149.329,219.015%20C149.329,221.764%20151.558,223.993%20154.307,223.993%20L219.017,223.993%20C221.766,223.993%20223.994,221.764%20223.994,219.015%20L223.994,154.305%20C223.994,151.556%20221.766,149.328%20219.017,149.328%20Z'%20id='Path'%3e%3c/path%3e%3c/g%3e%3c/g%3e%3c/svg%3e", PROVIDER_NAMES = {
  [Network.MAINNET]: "bitcoin",
  [Network.TESTNET]: "bitcoinTestnet",
  [Network.SIGNET]: "bitcoinSignet"
}, WALLET_PROVIDER_NAME$3 = "OKX";
class OKXProvider {
  constructor(A, u) {
    Ci(this, "provider");
    Ci(this, "walletInfo");
    Ci(this, "config");
    Ci(this, "connectWallet", async () => {
      var t;
      let A;
      try {
        A = await this.provider.connect();
      } catch (l) {
        throw (t = l == null ? void 0 : l.message) != null && t.includes("rejected") ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "Connection to OKX Wallet was rejected",
          wallet: WALLET_PROVIDER_NAME$3
        }) : new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: (l == null ? void 0 : l.message) || "Failed to connect to OKX Wallet",
          wallet: WALLET_PROVIDER_NAME$3
        });
      }
      const { address: u, compressedPublicKey: p } = A;
      if (p && u)
        this.walletInfo = {
          publicKeyHex: p,
          address: u
        };
      else
        throw new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: "Could not connect to OKX Wallet",
          wallet: WALLET_PROVIDER_NAME$3
        });
    });
    Ci(this, "getAddress", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$3
        });
      return this.walletInfo.address;
    });
    Ci(this, "getPublicKeyHex", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$3
        });
      return this.walletInfo.publicKeyHex;
    });
    Ci(this, "signPsbt", async (A, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$3
        });
      if (u != null && u.signInputs && u.signInputs.length > 0) {
        const p = {
          autoFinalized: u.autoFinalized ?? !1,
          toSignInputs: u.signInputs.map((t) => ({
            index: t.index,
            publicKey: t.publicKey,
            address: t.address,
            sighashTypes: t.sighashTypes,
            disableTweakSigner: t.disableTweakSigner
          }))
        };
        return await this.provider.signPsbt(A, p);
      }
      return await this.provider.signPsbt(A);
    });
    Ci(this, "signPsbts", async (A) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$3
        });
      return await this.provider.signPsbts(A);
    });
    Ci(this, "getNetwork", async () => {
      if (!this.config.network)
        throw new WalletError({
          code: ERROR_CODES.INVALID_PARAMS,
          // Or a new code like CONFIG_ERROR
          message: "Network not set in config",
          wallet: WALLET_PROVIDER_NAME$3
        });
      return this.config.network;
    });
    Ci(this, "signMessage", async (A, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$3
        });
      return await this.provider.signMessage(A, u);
    });
    // Inscriptions are only available on OKX Wallet BTC mainnet (i.e okxWallet.bitcoin)
    Ci(this, "getInscriptions", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$3
        });
      if (this.config.network !== Network.MAINNET)
        throw new WalletError({
          code: ERROR_CODES.INSCRIPTIONS_UNSUPPORTED_NETWORK,
          message: "Inscriptions are only available on OKX Wallet BTC mainnet",
          wallet: WALLET_PROVIDER_NAME$3,
          chainId: this.config.network
        });
      const A = 100, u = 100, p = [];
      let t = 0, l = 0;
      try {
        for (; l < A; ) {
          const { list: m } = await this.provider.getInscriptions(t, u), b = m.map((k) => {
            const [C, B] = k.output.split(":");
            return {
              txid: C,
              vout: B
            };
          });
          if (p.push(...b), m.length < u)
            break;
          if (t += u, l++, l >= A)
            throw new WalletError({
              code: ERROR_CODES.MAX_ITERATION_EXCEEDED,
              message: "Exceeded maximum iterations when fetching inscriptions",
              wallet: WALLET_PROVIDER_NAME$3
            });
        }
      } catch {
        throw new WalletError({
          code: ERROR_CODES.INSCRIPTION_FETCH_ERROR,
          message: "Failed to get inscriptions from OKX Wallet",
          wallet: WALLET_PROVIDER_NAME$3
        });
      }
      return p;
    });
    Ci(this, "on", (A, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$3
        });
      if (A === "accountChanged")
        return this.provider.on(A, u);
    });
    Ci(this, "off", (A, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$3
        });
      if (A === "accountChanged")
        return this.provider.off(A, u);
    });
    Ci(this, "getWalletProviderName", async () => WALLET_PROVIDER_NAME$3);
    Ci(this, "getWalletProviderIcon", async () => logo$2);
    if (this.config = u, !A)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "OKX Wallet extension not found",
        wallet: WALLET_PROVIDER_NAME$3
      });
    const p = PROVIDER_NAMES[u.network];
    if (!p)
      throw new WalletError({
        code: ERROR_CODES.UNSUPPORTED_NETWORK,
        message: "Unsupported network",
        wallet: WALLET_PROVIDER_NAME$3
      });
    this.provider = A[p];
  }
}
const metadata$6 = {
  id: "okx",
  name: WALLET_PROVIDER_NAME$3,
  icon: logo$2,
  docs: "https://www.okx.com/web3",
  wallet: "okxwallet",
  createProvider: (s, A) => new OKXProvider(s, A),
  networks: [Network.MAINNET, Network.SIGNET]
}, logo$1 = "data:image/svg+xml,%3csvg%20width='288'%20height='288'%20viewBox='72%2072%20144%20144'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M144%20216C193.706%20216%20216%20193.706%20216%20144C216%2094.2944%20193.706%2072%20144%2072C94.2944%2072%2072%2094.2944%2072%20144C72%20193.706%2094.2944%20216%20144%20216ZM130.475%20102.531H150.505V135.538H138.086V113.156H126.961L130.475%20102.531ZM144%20185.469C156.616%20185.469%20166.844%20175.242%20166.844%20162.626C166.844%20150.01%20156.616%20139.783%20144%20139.783C131.384%20139.783%20121.157%20150.01%20121.157%20162.626C121.157%20175.242%20131.384%20185.469%20144%20185.469ZM144%20175.099C150.889%20175.099%20156.473%20169.515%20156.473%20162.626C156.473%20155.738%20150.889%20150.153%20144%20150.153C137.112%20150.153%20131.528%20155.738%20131.528%20162.626C131.528%20169.515%20137.112%20175.099%20144%20175.099Z'%20fill='black'%20style='fill:black;fill-opacity:1;'/%3e%3c/svg%3e", INTERNAL_NETWORK_NAMES = {
  [Network.MAINNET]: "livenet",
  [Network.TESTNET]: "testnet",
  [Network.SIGNET]: "signet"
}, WALLET_PROVIDER_NAME$2 = "OneKey";
class OneKeyProvider {
  constructor(A, u) {
    Ci(this, "provider");
    Ci(this, "walletInfo");
    Ci(this, "config");
    Ci(this, "connectWallet", async () => {
      var p;
      try {
        await this.provider.connectWallet();
      } catch (t) {
        throw (p = t == null ? void 0 : t.message) != null && p.includes("rejected") ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "Connection to OneKey Wallet was rejected",
          wallet: WALLET_PROVIDER_NAME$2
        }) : new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: (t == null ? void 0 : t.message) || "Failed to connect to OneKey Wallet",
          wallet: WALLET_PROVIDER_NAME$2
        });
      }
      const A = await this.provider.getAddress(), u = await this.provider.getPublicKeyHex();
      if (u && A)
        this.walletInfo = {
          publicKeyHex: u,
          address: A
        };
      else
        throw new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: "Could not connect to OneKey Wallet",
          wallet: WALLET_PROVIDER_NAME$2
        });
    });
    Ci(this, "getAddress", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      return this.walletInfo.address;
    });
    Ci(this, "getPublicKeyHex", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      return this.walletInfo.publicKeyHex;
    });
    Ci(this, "signPsbt", async (A, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      if (!A)
        throw new WalletError({
          code: ERROR_CODES.PSBT_HEX_REQUIRED,
          message: "psbt hex is required",
          wallet: WALLET_PROVIDER_NAME$2
        });
      if (u != null && u.signInputs && u.signInputs.length > 0) {
        const p = {
          autoFinalized: u.autoFinalized ?? !1,
          toSignInputs: u.signInputs.map((t) => ({
            index: t.index,
            publicKey: t.publicKey,
            address: t.address,
            sighashTypes: t.sighashTypes,
            disableTweakSigner: t.disableTweakSigner
          }))
        };
        return await this.provider.signPsbt(A, p);
      }
      return this.provider.signPsbt(A);
    });
    Ci(this, "signPsbts", async (A) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      if (!A || !Array.isArray(A) || A.length === 0)
        throw new WalletError({
          code: ERROR_CODES.PSBTS_HEXES_REQUIRED,
          message: "psbts hexes are required and must be a non-empty array",
          wallet: WALLET_PROVIDER_NAME$2
        });
      return this.provider.signPsbts(A);
    });
    Ci(this, "getNetwork", async () => {
      const A = await this.provider.getNetwork();
      for (const [u, p] of Object.entries(INTERNAL_NETWORK_NAMES)) {
        if (p === "testnet")
          return Network.SIGNET;
        if (p === A)
          return u;
      }
      throw new WalletError({
        code: ERROR_CODES.UNSUPPORTED_NETWORK,
        message: "Unsupported network from OneKey Wallet",
        wallet: WALLET_PROVIDER_NAME$2
      });
    });
    Ci(this, "signMessage", async (A, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      return await this.provider.signMessage(A, u);
    });
    // Inscriptions are only available on OneKey Wallet BTC mainnet
    Ci(this, "getInscriptions", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      if (this.config.network !== Network.MAINNET)
        throw new WalletError({
          code: ERROR_CODES.INSCRIPTIONS_UNSUPPORTED_NETWORK,
          message: "Inscriptions are only available on OneKey Wallet BTC Mainnet",
          wallet: WALLET_PROVIDER_NAME$2,
          chainId: this.config.network
        });
      const A = 100, u = 100, p = [];
      let t = 0, l = 0;
      try {
        for (; l < A; ) {
          const { list: m } = await this.provider.getInscriptions(t, u), b = m.map((k) => {
            const [C, B] = k.output.split(":");
            return {
              txid: C,
              vout: B
            };
          });
          if (p.push(...b), m.length < u)
            break;
          if (t += u, l++, l >= A)
            throw new WalletError({
              code: ERROR_CODES.MAX_ITERATION_EXCEEDED,
              message: "Exceeded maximum iterations when fetching inscriptions",
              wallet: WALLET_PROVIDER_NAME$2
            });
        }
      } catch {
        throw new WalletError({
          code: ERROR_CODES.INSCRIPTION_FETCH_ERROR,
          message: "Failed to get inscriptions from OneKey Wallet",
          wallet: WALLET_PROVIDER_NAME$2
        });
      }
      return p;
    });
    Ci(this, "on", (A, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      if (A === "accountChanged")
        return this.provider.on(A, u);
    });
    Ci(this, "off", (A, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      if (A === "accountChanged")
        return this.provider.off(A, u);
    });
    Ci(this, "getWalletProviderName", async () => WALLET_PROVIDER_NAME$2);
    Ci(this, "getWalletProviderIcon", async () => logo$1);
    if (this.config = u, !(A != null && A.btcwallet))
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "OneKey Wallet extension not found",
        wallet: WALLET_PROVIDER_NAME$2
      });
    this.provider = A.btcwallet;
  }
}
const metadata$5 = {
  id: "onekey",
  name: WALLET_PROVIDER_NAME$2,
  icon: logo$1,
  docs: "https://onekey.so/download",
  wallet: "$onekey",
  createProvider: (s, A) => new OneKeyProvider(s, A),
  networks: [Network.MAINNET, Network.SIGNET]
}, logo = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='59'%20height='59'%3e%3cdefs%3e%3clinearGradient%20id='a'%20x1='91.9%25'%20x2='5.127%25'%20y1='28.561%25'%20y2='67.452%25'%3e%3cstop%20offset='0%25'%20stop-color='%23070100'/%3e%3cstop%20offset='36%25'%20stop-color='%2377390D'/%3e%3cstop%20offset='67%25'%20stop-color='%23EA8101'/%3e%3cstop%20offset='100%25'%20stop-color='%23F4B852'/%3e%3c/linearGradient%3e%3clinearGradient%20id='b'%20x1='10.514%25'%20x2='111.046%25'%20y1='63.228%25'%20y2='37.55%25'%3e%3cstop%20offset='0%25'%20stop-color='%23070100'/%3e%3cstop%20offset='37%25'%20stop-color='%2377390D'/%3e%3cstop%20offset='67%25'%20stop-color='%23EA8101'/%3e%3cstop%20offset='100%25'%20stop-color='%23F4FB52'/%3e%3c/linearGradient%3e%3cradialGradient%20id='c'%20cx='49.933%25'%20cy='50.067%25'%20r='50%25'%20fx='49.933%25'%20fy='50.067%25'%3e%3cstop%20offset='0%25'%20stop-color='%23F4B852'/%3e%3cstop%20offset='33%25'%20stop-color='%23EA8101'/%3e%3cstop%20offset='64%25'%20stop-color='%2377390D'/%3e%3cstop%20offset='100%25'%20stop-color='%23070100'/%3e%3c/radialGradient%3e%3c/defs%3e%3cg%20fill='none'%20fill-rule='nonzero'%20transform='translate(7%201)'%3e%3cpath%20fill='url(%23a)'%20d='m31.764%205.2%2011.761%2011.745c1%20.997%201.492%202.006%201.475%203.027-.018%201.014-.446%201.947-1.29%202.787-.879.88-1.827%201.33-2.845%201.347-1.017.018-2.023-.478-3.03-1.475L25.81%2010.617c-1.365-1.364-2.683-2.332-3.955-2.898-1.267-.566-2.602-.653-4.002-.268-1.399.385-2.902%201.382-4.51%202.991-2.22%202.217-3.278%204.298-3.168%206.246.11%201.948%201.208%203.96%203.301%206.054L25.6%2034.854c1.012%201.01%201.51%202.018%201.492%203.021-.017%201.003-.45%201.936-1.307%202.788-.855.851-1.792%201.3-2.821%201.335-1.024.035-2.041-.455-3.053-1.464L8.16%2028.79c-1.913-1.913-3.295-3.72-4.145-5.423-.85-1.703-1.168-3.633-.949-5.785.197-1.843.787-3.628%201.758-5.36.977-1.732%202.37-3.499%204.18-5.313%202.157-2.157%204.216-3.808%206.182-4.957C17.153.803%2019.049.161%2020.882.027c1.833-.134%203.643.233%205.435%201.102%201.787.869%203.603%202.222%205.453%204.07h-.006Z'/%3e%3cpath%20fill='url(%23b)'%20d='M13.234%2051.841%201.474%2040.188c-1-.99-1.49-1.99-1.474-3.003.018-1.012.446-1.932%201.29-2.766.878-.873%201.827-1.319%202.844-1.336%201.018-.017%202.024.469%203.03%201.464l12.025%2011.919c1.37%201.354%202.682%202.314%203.954%202.876%201.272.56%202.602.648%204%20.266%201.4-.382%202.903-1.372%204.51-2.968%202.22-2.2%203.278-4.265%203.169-6.197-.11-1.933-1.209-3.935-3.302-6.006l-6.457-6.347c-1.012-1.001-1.51-2.002-1.492-2.998.017-.995.451-1.92%201.307-2.765.855-.845%201.792-1.29%202.82-1.325%201.024-.035%202.042.451%203.053%201.452l6.088%205.983c1.914%201.898%203.296%203.691%204.145%205.38.85%201.69%201.168%203.605.949%205.74-.197%201.829-.787%203.6-1.758%205.318-.977%201.718-2.37%203.471-4.18%205.27-2.156%202.142-4.214%203.78-6.18%204.919-1.966%201.14-3.862%201.776-5.695%201.91-1.832.132-3.642-.232-5.434-1.094-1.787-.862-3.608-2.205-5.452-4.039Z'/%3e%3ccircle%20cx='20'%20cy='18'%20r='4'%20fill='url(%23c)'/%3e%3c/g%3e%3c/svg%3e", WALLET_PROVIDER_NAME$1 = "Unisat";
class UnisatProvider {
  constructor(A, u) {
    Ci(this, "provider");
    Ci(this, "walletInfo");
    Ci(this, "config");
    Ci(this, "connectWallet", async () => {
      var t;
      let A;
      try {
        A = await this.provider.requestAccounts();
      } catch (l) {
        throw (t = l == null ? void 0 : l.message) != null && t.includes("rejected") ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "Connection to Unisat Wallet was rejected",
          wallet: WALLET_PROVIDER_NAME$1
        }) : new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: (l == null ? void 0 : l.message) || "Failed to request accounts from Unisat Wallet",
          wallet: WALLET_PROVIDER_NAME$1
        });
      }
      const u = A[0], p = await this.provider.getPublicKey();
      if (p && u)
        this.walletInfo = {
          publicKeyHex: p,
          address: u
        };
      else
        throw new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: "Could not connect to Unisat Wallet",
          wallet: WALLET_PROVIDER_NAME$1
        });
    });
    Ci(this, "getAddress", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      return this.walletInfo.address;
    });
    Ci(this, "getPublicKeyHex", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      return this.walletInfo.publicKeyHex;
    });
    Ci(this, "signPsbt", async (A, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      if (!A)
        throw new WalletError({
          code: ERROR_CODES.PSBT_HEX_REQUIRED,
          message: "psbt hex is required",
          wallet: WALLET_PROVIDER_NAME$1
        });
      const p = await this.getNetwork();
      try {
        let t;
        if (u != null && u.signInputs && u.signInputs.length > 0)
          t = {
            autoFinalized: u.autoFinalized ?? !1,
            toSignInputs: u.signInputs.map((m) => ({
              index: m.index,
              publicKey: m.publicKey,
              address: m.address,
              sighashTypes: m.sighashTypes,
              disableTweakSigner: m.disableTweakSigner,
              useTweakedSigner: m.useTweakedSigner
            }))
          };
        else {
          const m = this.getSignPsbtDefaultOptions(A, p);
          t = {
            ...m,
            autoFinalized: (u == null ? void 0 : u.autoFinalized) ?? m.autoFinalized
          };
        }
        return await this.provider.signPsbt(A, t);
      } catch (t) {
        throw new WalletError({
          code: ERROR_CODES.SIGNATURE_EXTRACT_ERROR,
          message: (t == null ? void 0 : t.message) || "Failed to sign PSBT with Unisat Wallet",
          wallet: WALLET_PROVIDER_NAME$1
        });
      }
    });
    // Order of PSBTs in the array must be the same as the order of options
    Ci(this, "signPsbts", async (A, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      if (!A || !Array.isArray(A) || A.length === 0)
        throw new WalletError({
          code: ERROR_CODES.PSBTS_HEXES_REQUIRED,
          message: "psbts hexes are required and must be a non-empty array",
          wallet: WALLET_PROVIDER_NAME$1
        });
      const p = await this.getNetwork();
      try {
        const t = A.map((m) => this.getSignPsbtDefaultOptions(m, p)), l = u == null ? void 0 : u.map((m, b) => ({
          ...t[b],
          ...m
        }));
        return await this.provider.signPsbts(A, l);
      } catch (t) {
        throw new WalletError({
          code: ERROR_CODES.SIGNATURE_EXTRACT_ERROR,
          message: (t == null ? void 0 : t.message) || "Failed to sign PSBTs with Unisat Wallet",
          wallet: WALLET_PROVIDER_NAME$1
        });
      }
    });
    Ci(this, "getNetwork", async () => {
      switch ((await this.provider.getChain()).enum) {
        case "BITCOIN_MAINNET":
          return Network.MAINNET;
        case "BITCOIN_SIGNET":
          return Network.SIGNET;
        case "BITCOIN_TESTNET":
          return Network.SIGNET;
        default:
          throw new WalletError({
            code: ERROR_CODES.UNSUPPORTED_NETWORK,
            message: "Unsupported network from Unisat Wallet",
            wallet: WALLET_PROVIDER_NAME$1
          });
      }
    });
    Ci(this, "signMessage", async (A, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      return await this.provider.signMessage(A, u);
    });
    Ci(this, "getInscriptions", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      if (this.config.network !== Network.MAINNET)
        throw new WalletError({
          code: ERROR_CODES.INSCRIPTIONS_UNSUPPORTED_NETWORK,
          message: "Inscriptions are only available on Unisat Wallet BTC Mainnet",
          wallet: WALLET_PROVIDER_NAME$1,
          chainId: this.config.network
        });
      const A = 100, u = 100, p = [];
      let t = 0, l = 0;
      try {
        for (; l < A; ) {
          const { list: m } = await this.provider.getInscriptions(t, u), b = m.map((k) => {
            const [C, B] = k.output.split(":");
            return {
              txid: C,
              vout: B
            };
          });
          if (p.push(...b), m.length < u)
            break;
          if (t += u, l++, l >= A)
            throw new WalletError({
              code: ERROR_CODES.MAX_ITERATION_EXCEEDED,
              message: "Exceeded maximum iterations when fetching inscriptions",
              wallet: WALLET_PROVIDER_NAME$1
            });
        }
      } catch {
        throw new WalletError({
          code: ERROR_CODES.INSCRIPTION_FETCH_ERROR,
          message: "Failed to get inscriptions from Unisat Wallet",
          wallet: WALLET_PROVIDER_NAME$1
        });
      }
      return p;
    });
    Ci(this, "on", (A, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      if (A === "accountChanged")
        return this.provider.on("accountsChanged", u);
    });
    Ci(this, "off", (A, u) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      if (A === "accountChanged")
        return this.provider.removeListener("accountsChanged", u);
    });
    Ci(this, "getWalletProviderName", async () => WALLET_PROVIDER_NAME$1);
    Ci(this, "getWalletProviderIcon", async () => logo);
    if (this.config = u, !A)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "Unisat Wallet extension not found",
        wallet: WALLET_PROVIDER_NAME$1
      });
    this.provider = A;
  }
  getSignPsbtDefaultOptions(A, u) {
    const p = [];
    return srcExports.Psbt.fromHex(A).data.inputs.forEach((l, m) => {
      var C, B;
      let b = !1;
      if (l.witnessUtxo && l.witnessUtxo.script) {
        let Q = srcExports.networks.bitcoin;
        (u === Network.TESTNET || u === Network.SIGNET) && (Q = srcExports.networks.testnet);
        let P;
        try {
          P = srcExports.address.fromOutputScript(l.witnessUtxo.script, Q);
        } catch (F) {
          if (F instanceof Error && F.message.toLowerCase().includes("has no matching address"))
            initBTCCurve(), P = srcExports.address.fromOutputScript(l.witnessUtxo.script, Q);
          else
            throw new WalletError({
              code: ERROR_CODES.UNKNOWN_ERROR,
              // Or a more specific address generation error
              message: (F == null ? void 0 : F.message) || "Failed to determine address from output script",
              wallet: WALLET_PROVIDER_NAME$1
            });
        }
        const x = P.indexOf("tb1p") === 0 || P.indexOf("bc1p") === 0, M = P === ((C = this.walletInfo) == null ? void 0 : C.address);
        x && M && (b = !0);
      }
      l.finalScriptSig || l.finalScriptWitness || p.push({
        index: m,
        publicKey: (B = this.walletInfo) == null ? void 0 : B.publicKeyHex,
        sighashTypes: void 0,
        useTweakedSigner: b
      });
    }), {
      autoFinalized: !0,
      toSignInputs: p
    };
  }
}
const metadata$4 = {
  id: "unisat",
  name: WALLET_PROVIDER_NAME$1,
  icon: logo,
  docs: "https://unisat.io/download",
  wallet: (s) => s.unisat_wallet ?? s.unisat,
  createProvider: (s, A) => new UnisatProvider(s, A),
  networks: [Network.MAINNET, Network.SIGNET]
}, metadata$3 = {
  chain: "BTC",
  name: "Bitcoin",
  icon: icon$1,
  wallets: [metadata$6, metadata$a, metadata$b, metadata$5, metadata$4, metadata$8, metadata$7, metadata$9]
}, multicall3Abi = [
  {
    inputs: [
      {
        components: [
          {
            name: "target",
            type: "address"
          },
          {
            name: "allowFailure",
            type: "bool"
          },
          {
            name: "callData",
            type: "bytes"
          }
        ],
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "aggregate3",
    outputs: [
      {
        components: [
          {
            name: "success",
            type: "bool"
          },
          {
            name: "returnData",
            type: "bytes"
          }
        ],
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getCurrentBlockTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
], batchGatewayAbi = [
  {
    name: "query",
    type: "function",
    stateMutability: "view",
    inputs: [
      {
        type: "tuple[]",
        name: "queries",
        components: [
          {
            type: "address",
            name: "sender"
          },
          {
            type: "string[]",
            name: "urls"
          },
          {
            type: "bytes",
            name: "data"
          }
        ]
      }
    ],
    outputs: [
      {
        type: "bool[]",
        name: "failures"
      },
      {
        type: "bytes[]",
        name: "responses"
      }
    ]
  },
  {
    name: "HttpError",
    type: "error",
    inputs: [
      {
        type: "uint16",
        name: "status"
      },
      {
        type: "string",
        name: "message"
      }
    ]
  }
];
function formatAbiItem$1(s, { includeName: A = !1 } = {}) {
  if (s.type !== "function" && s.type !== "event" && s.type !== "error")
    throw new InvalidDefinitionTypeError(s.type);
  return `${s.name}(${formatAbiParams(s.inputs, { includeName: A })})`;
}
function formatAbiParams(s, { includeName: A = !1 } = {}) {
  return s ? s.map((u) => formatAbiParam(u, { includeName: A })).join(A ? ", " : ",") : "";
}
function formatAbiParam(s, { includeName: A }) {
  return s.type.startsWith("tuple") ? `(${formatAbiParams(s.components, { includeName: A })})${s.type.slice(5)}` : s.type + (A && s.name ? ` ${s.name}` : "");
}
function isHex(s, { strict: A = !0 } = {}) {
  return !s || typeof s != "string" ? !1 : A ? /^0x[0-9a-fA-F]*$/.test(s) : s.startsWith("0x");
}
function size(s) {
  return isHex(s, { strict: !1 }) ? Math.ceil((s.length - 2) / 2) : s.length;
}
const version$3 = "2.38.2";
let errorConfig = {
  getDocsUrl: ({ docsBaseUrl: s, docsPath: A = "", docsSlug: u }) => A ? `${s ?? "https://viem.sh"}${A}${u ? `#${u}` : ""}` : void 0,
  version: `viem@${version$3}`
}, BaseError$3 = class m4 extends Error {
  constructor(A, u = {}) {
    var b;
    const p = (() => {
      var k;
      return u.cause instanceof m4 ? u.cause.details : (k = u.cause) != null && k.message ? u.cause.message : u.details;
    })(), t = u.cause instanceof m4 && u.cause.docsPath || u.docsPath, l = (b = errorConfig.getDocsUrl) == null ? void 0 : b.call(errorConfig, { ...u, docsPath: t }), m = [
      A || "An error occurred.",
      "",
      ...u.metaMessages ? [...u.metaMessages, ""] : [],
      ...l ? [`Docs: ${l}`] : [],
      ...p ? [`Details: ${p}`] : [],
      ...errorConfig.version ? [`Version: ${errorConfig.version}`] : []
    ].join(`
`);
    super(m, u.cause ? { cause: u.cause } : void 0), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "version", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BaseError"
    }), this.details = p, this.docsPath = t, this.metaMessages = u.metaMessages, this.name = u.name ?? this.name, this.shortMessage = A, this.version = version$3;
  }
  walk(A) {
    return walk$1(this, A);
  }
};
function walk$1(s, A) {
  return A != null && A(s) ? s : s && typeof s == "object" && "cause" in s && s.cause !== void 0 ? walk$1(s.cause, A) : A ? null : s;
}
class AbiConstructorNotFoundError extends BaseError$3 {
  constructor({ docsPath: A }) {
    super([
      "A constructor was not found on the ABI.",
      "Make sure you are using the correct ABI and that the constructor exists on it."
    ].join(`
`), {
      docsPath: A,
      name: "AbiConstructorNotFoundError"
    });
  }
}
class AbiConstructorParamsNotFoundError extends BaseError$3 {
  constructor({ docsPath: A }) {
    super([
      "Constructor arguments were provided (`args`), but a constructor parameters (`inputs`) were not found on the ABI.",
      "Make sure you are using the correct ABI, and that the `inputs` attribute on the constructor exists."
    ].join(`
`), {
      docsPath: A,
      name: "AbiConstructorParamsNotFoundError"
    });
  }
}
class AbiDecodingDataSizeTooSmallError extends BaseError$3 {
  constructor({ data: A, params: u, size: p }) {
    super([`Data size of ${p} bytes is too small for given parameters.`].join(`
`), {
      metaMessages: [
        `Params: (${formatAbiParams(u, { includeName: !0 })})`,
        `Data:   ${A} (${p} bytes)`
      ],
      name: "AbiDecodingDataSizeTooSmallError"
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "params", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "size", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = A, this.params = u, this.size = p;
  }
}
class AbiDecodingZeroDataError extends BaseError$3 {
  constructor() {
    super('Cannot decode zero data ("0x") with ABI parameters.', {
      name: "AbiDecodingZeroDataError"
    });
  }
}
class AbiEncodingArrayLengthMismatchError extends BaseError$3 {
  constructor({ expectedLength: A, givenLength: u, type: p }) {
    super([
      `ABI encoding array length mismatch for type ${p}.`,
      `Expected length: ${A}`,
      `Given length: ${u}`
    ].join(`
`), { name: "AbiEncodingArrayLengthMismatchError" });
  }
}
class AbiEncodingBytesSizeMismatchError extends BaseError$3 {
  constructor({ expectedSize: A, value: u }) {
    super(`Size of bytes "${u}" (bytes${size(u)}) does not match expected size (bytes${A}).`, { name: "AbiEncodingBytesSizeMismatchError" });
  }
}
class AbiEncodingLengthMismatchError extends BaseError$3 {
  constructor({ expectedLength: A, givenLength: u }) {
    super([
      "ABI encoding params/values length mismatch.",
      `Expected length (params): ${A}`,
      `Given length (values): ${u}`
    ].join(`
`), { name: "AbiEncodingLengthMismatchError" });
  }
}
class AbiErrorInputsNotFoundError extends BaseError$3 {
  constructor(A, { docsPath: u }) {
    super([
      `Arguments (\`args\`) were provided to "${A}", but "${A}" on the ABI does not contain any parameters (\`inputs\`).`,
      "Cannot encode error result without knowing what the parameter types are.",
      "Make sure you are using the correct ABI and that the inputs exist on it."
    ].join(`
`), {
      docsPath: u,
      name: "AbiErrorInputsNotFoundError"
    });
  }
}
class AbiErrorNotFoundError extends BaseError$3 {
  constructor(A, { docsPath: u } = {}) {
    super([
      `Error ${A ? `"${A}" ` : ""}not found on ABI.`,
      "Make sure you are using the correct ABI and that the error exists on it."
    ].join(`
`), {
      docsPath: u,
      name: "AbiErrorNotFoundError"
    });
  }
}
class AbiErrorSignatureNotFoundError extends BaseError$3 {
  constructor(A, { docsPath: u }) {
    super([
      `Encoded error signature "${A}" not found on ABI.`,
      "Make sure you are using the correct ABI and that the error exists on it.",
      `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${A}.`
    ].join(`
`), {
      docsPath: u,
      name: "AbiErrorSignatureNotFoundError"
    }), Object.defineProperty(this, "signature", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.signature = A;
  }
}
class AbiFunctionNotFoundError extends BaseError$3 {
  constructor(A, { docsPath: u } = {}) {
    super([
      `Function ${A ? `"${A}" ` : ""}not found on ABI.`,
      "Make sure you are using the correct ABI and that the function exists on it."
    ].join(`
`), {
      docsPath: u,
      name: "AbiFunctionNotFoundError"
    });
  }
}
class AbiFunctionOutputsNotFoundError extends BaseError$3 {
  constructor(A, { docsPath: u }) {
    super([
      `Function "${A}" does not contain any \`outputs\` on ABI.`,
      "Cannot decode function result without knowing what the parameter types are.",
      "Make sure you are using the correct ABI and that the function exists on it."
    ].join(`
`), {
      docsPath: u,
      name: "AbiFunctionOutputsNotFoundError"
    });
  }
}
class AbiFunctionSignatureNotFoundError extends BaseError$3 {
  constructor(A, { docsPath: u }) {
    super([
      `Encoded function signature "${A}" not found on ABI.`,
      "Make sure you are using the correct ABI and that the function exists on it.",
      `You can look up the signature here: https://openchain.xyz/signatures?query=${A}.`
    ].join(`
`), {
      docsPath: u,
      name: "AbiFunctionSignatureNotFoundError"
    });
  }
}
class AbiItemAmbiguityError extends BaseError$3 {
  constructor(A, u) {
    super("Found ambiguous types in overloaded ABI items.", {
      metaMessages: [
        `\`${A.type}\` in \`${formatAbiItem$1(A.abiItem)}\`, and`,
        `\`${u.type}\` in \`${formatAbiItem$1(u.abiItem)}\``,
        "",
        "These types encode differently and cannot be distinguished at runtime.",
        "Remove one of the ambiguous items in the ABI."
      ],
      name: "AbiItemAmbiguityError"
    });
  }
}
class BytesSizeMismatchError extends BaseError$3 {
  constructor({ expectedSize: A, givenSize: u }) {
    super(`Expected bytes${A}, got bytes${u}.`, {
      name: "BytesSizeMismatchError"
    });
  }
}
class InvalidAbiEncodingTypeError extends BaseError$3 {
  constructor(A, { docsPath: u }) {
    super([
      `Type "${A}" is not a valid encoding type.`,
      "Please provide a valid ABI type."
    ].join(`
`), { docsPath: u, name: "InvalidAbiEncodingType" });
  }
}
class InvalidAbiDecodingTypeError extends BaseError$3 {
  constructor(A, { docsPath: u }) {
    super([
      `Type "${A}" is not a valid decoding type.`,
      "Please provide a valid ABI type."
    ].join(`
`), { docsPath: u, name: "InvalidAbiDecodingType" });
  }
}
class InvalidArrayError extends BaseError$3 {
  constructor(A) {
    super([`Value "${A}" is not a valid array.`].join(`
`), {
      name: "InvalidArrayError"
    });
  }
}
class InvalidDefinitionTypeError extends BaseError$3 {
  constructor(A) {
    super([
      `"${A}" is not a valid definition type.`,
      'Valid types: "function", "event", "error"'
    ].join(`
`), { name: "InvalidDefinitionTypeError" });
  }
}
class InvalidAddressError extends BaseError$3 {
  constructor({ address: A }) {
    super(`Address "${A}" is invalid.`, {
      metaMessages: [
        "- Address must be a hex value of 20 bytes (40 hex characters).",
        "- Address must match its checksum counterpart."
      ],
      name: "InvalidAddressError"
    });
  }
}
class SliceOffsetOutOfBoundsError extends BaseError$3 {
  constructor({ offset: A, position: u, size: p }) {
    super(`Slice ${u === "start" ? "starting" : "ending"} at offset "${A}" is out-of-bounds (size: ${p}).`, { name: "SliceOffsetOutOfBoundsError" });
  }
}
let SizeExceedsPaddingSizeError$1 = class extends BaseError$3 {
  constructor({ size: A, targetSize: u, type: p }) {
    super(`${p.charAt(0).toUpperCase()}${p.slice(1).toLowerCase()} size (${A}) exceeds padding size (${u}).`, { name: "SizeExceedsPaddingSizeError" });
  }
};
class InvalidBytesLengthError extends BaseError$3 {
  constructor({ size: A, targetSize: u, type: p }) {
    super(`${p.charAt(0).toUpperCase()}${p.slice(1).toLowerCase()} is expected to be ${u} ${p} long, but is ${A} ${p} long.`, { name: "InvalidBytesLengthError" });
  }
}
function pad$1(s, { dir: A, size: u = 32 } = {}) {
  return typeof s == "string" ? padHex(s, { dir: A, size: u }) : padBytes(s, { dir: A, size: u });
}
function padHex(s, { dir: A, size: u = 32 } = {}) {
  if (u === null)
    return s;
  const p = s.replace("0x", "");
  if (p.length > u * 2)
    throw new SizeExceedsPaddingSizeError$1({
      size: Math.ceil(p.length / 2),
      targetSize: u,
      type: "hex"
    });
  return `0x${p[A === "right" ? "padEnd" : "padStart"](u * 2, "0")}`;
}
function padBytes(s, { dir: A, size: u = 32 } = {}) {
  if (u === null)
    return s;
  if (s.length > u)
    throw new SizeExceedsPaddingSizeError$1({
      size: s.length,
      targetSize: u,
      type: "bytes"
    });
  const p = new Uint8Array(u);
  for (let t = 0; t < u; t++) {
    const l = A === "right";
    p[l ? t : u - t - 1] = s[l ? t : s.length - t - 1];
  }
  return p;
}
let IntegerOutOfRangeError$1 = class extends BaseError$3 {
  constructor({ max: A, min: u, signed: p, size: t, value: l }) {
    super(`Number "${l}" is not in safe ${t ? `${t * 8}-bit ${p ? "signed" : "unsigned"} ` : ""}integer range ${A ? `(${u} to ${A})` : `(above ${u})`}`, { name: "IntegerOutOfRangeError" });
  }
};
class InvalidBytesBooleanError extends BaseError$3 {
  constructor(A) {
    super(`Bytes value "${A}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`, {
      name: "InvalidBytesBooleanError"
    });
  }
}
class SizeOverflowError extends BaseError$3 {
  constructor({ givenSize: A, maxSize: u }) {
    super(`Size cannot exceed ${u} bytes. Given size: ${A} bytes.`, { name: "SizeOverflowError" });
  }
}
function trim(s, { dir: A = "left" } = {}) {
  let u = typeof s == "string" ? s.replace("0x", "") : s, p = 0;
  for (let t = 0; t < u.length - 1 && u[A === "left" ? t : u.length - t - 1].toString() === "0"; t++)
    p++;
  return u = A === "left" ? u.slice(p) : u.slice(0, u.length - p), typeof s == "string" ? (u.length === 1 && A === "right" && (u = `${u}0`), `0x${u.length % 2 === 1 ? `0${u}` : u}`) : u;
}
function assertSize(s, { size: A }) {
  if (size(s) > A)
    throw new SizeOverflowError({
      givenSize: size(s),
      maxSize: A
    });
}
function hexToBigInt(s, A = {}) {
  const { signed: u } = A;
  A.size && assertSize(s, { size: A.size });
  const p = BigInt(s);
  if (!u)
    return p;
  const t = (s.length - 2) / 2, l = (1n << BigInt(t) * 8n - 1n) - 1n;
  return p <= l ? p : p - BigInt(`0x${"f".padStart(t * 2, "f")}`) - 1n;
}
function hexToNumber(s, A = {}) {
  return Number(hexToBigInt(s, A));
}
const hexes = /* @__PURE__ */ Array.from({ length: 256 }, (s, A) => A.toString(16).padStart(2, "0"));
function toHex(s, A = {}) {
  return typeof s == "number" || typeof s == "bigint" ? numberToHex(s, A) : typeof s == "string" ? stringToHex(s, A) : typeof s == "boolean" ? boolToHex(s, A) : bytesToHex(s, A);
}
function boolToHex(s, A = {}) {
  const u = `0x${Number(s)}`;
  return typeof A.size == "number" ? (assertSize(u, { size: A.size }), pad$1(u, { size: A.size })) : u;
}
function bytesToHex(s, A = {}) {
  let u = "";
  for (let t = 0; t < s.length; t++)
    u += hexes[s[t]];
  const p = `0x${u}`;
  return typeof A.size == "number" ? (assertSize(p, { size: A.size }), pad$1(p, { dir: "right", size: A.size })) : p;
}
function numberToHex(s, A = {}) {
  const { signed: u, size: p } = A, t = BigInt(s);
  let l;
  p ? u ? l = (1n << BigInt(p) * 8n - 1n) - 1n : l = 2n ** (BigInt(p) * 8n) - 1n : typeof s == "number" && (l = BigInt(Number.MAX_SAFE_INTEGER));
  const m = typeof l == "bigint" && u ? -l - 1n : 0;
  if (l && t > l || t < m) {
    const k = typeof s == "bigint" ? "n" : "";
    throw new IntegerOutOfRangeError$1({
      max: l ? `${l}${k}` : void 0,
      min: `${m}${k}`,
      signed: u,
      size: p,
      value: `${s}${k}`
    });
  }
  const b = `0x${(u && t < 0 ? (1n << BigInt(p * 8)) + BigInt(t) : t).toString(16)}`;
  return p ? pad$1(b, { size: p }) : b;
}
const encoder$1 = /* @__PURE__ */ new TextEncoder();
function stringToHex(s, A = {}) {
  const u = encoder$1.encode(s);
  return bytesToHex(u, A);
}
const encoder = /* @__PURE__ */ new TextEncoder();
function toBytes(s, A = {}) {
  return typeof s == "number" || typeof s == "bigint" ? numberToBytes(s, A) : typeof s == "boolean" ? boolToBytes(s, A) : isHex(s) ? hexToBytes(s, A) : stringToBytes(s, A);
}
function boolToBytes(s, A = {}) {
  const u = new Uint8Array(1);
  return u[0] = Number(s), typeof A.size == "number" ? (assertSize(u, { size: A.size }), pad$1(u, { size: A.size })) : u;
}
const charCodeMap = {
  zero: 48,
  nine: 57,
  A: 65,
  F: 70,
  a: 97,
  f: 102
};
function charCodeToBase16(s) {
  if (s >= charCodeMap.zero && s <= charCodeMap.nine)
    return s - charCodeMap.zero;
  if (s >= charCodeMap.A && s <= charCodeMap.F)
    return s - (charCodeMap.A - 10);
  if (s >= charCodeMap.a && s <= charCodeMap.f)
    return s - (charCodeMap.a - 10);
}
function hexToBytes(s, A = {}) {
  let u = s;
  A.size && (assertSize(u, { size: A.size }), u = pad$1(u, { dir: "right", size: A.size }));
  let p = u.slice(2);
  p.length % 2 && (p = `0${p}`);
  const t = p.length / 2, l = new Uint8Array(t);
  for (let m = 0, b = 0; m < t; m++) {
    const k = charCodeToBase16(p.charCodeAt(b++)), C = charCodeToBase16(p.charCodeAt(b++));
    if (k === void 0 || C === void 0)
      throw new BaseError$3(`Invalid byte sequence ("${p[b - 2]}${p[b - 1]}" in "${p}").`);
    l[m] = k * 16 + C;
  }
  return l;
}
function numberToBytes(s, A) {
  const u = numberToHex(s, A);
  return hexToBytes(u);
}
function stringToBytes(s, A = {}) {
  const u = encoder.encode(s);
  return typeof A.size == "number" ? (assertSize(u, { size: A.size }), pad$1(u, { dir: "right", size: A.size })) : u;
}
const _0n = BigInt(0), _1n = BigInt(1), _2n = BigInt(2), _7n = BigInt(7), _256n = BigInt(256), _0x71n = BigInt(113), SHA3_PI = [], SHA3_ROTL = [], _SHA3_IOTA = [];
for (let s = 0, A = _1n, u = 1, p = 0; s < 24; s++) {
  [u, p] = [p, (2 * u + 3 * p) % 5], SHA3_PI.push(2 * (5 * p + u)), SHA3_ROTL.push((s + 1) * (s + 2) / 2 % 64);
  let t = _0n;
  for (let l = 0; l < 7; l++)
    A = (A << _1n ^ (A >> _7n) * _0x71n) % _256n, A & _2n && (t ^= _1n << (_1n << /* @__PURE__ */ BigInt(l)) - _1n);
  _SHA3_IOTA.push(t);
}
const IOTAS = split(_SHA3_IOTA, !0), SHA3_IOTA_H = IOTAS[0], SHA3_IOTA_L = IOTAS[1], rotlH = (s, A, u) => u > 32 ? rotlBH(s, A, u) : rotlSH(s, A, u), rotlL = (s, A, u) => u > 32 ? rotlBL(s, A, u) : rotlSL(s, A, u);
function keccakP(s, A = 24) {
  const u = new Uint32Array(10);
  for (let p = 24 - A; p < 24; p++) {
    for (let m = 0; m < 10; m++)
      u[m] = s[m] ^ s[m + 10] ^ s[m + 20] ^ s[m + 30] ^ s[m + 40];
    for (let m = 0; m < 10; m += 2) {
      const b = (m + 8) % 10, k = (m + 2) % 10, C = u[k], B = u[k + 1], Q = rotlH(C, B, 1) ^ u[b], P = rotlL(C, B, 1) ^ u[b + 1];
      for (let x = 0; x < 50; x += 10)
        s[m + x] ^= Q, s[m + x + 1] ^= P;
    }
    let t = s[2], l = s[3];
    for (let m = 0; m < 24; m++) {
      const b = SHA3_ROTL[m], k = rotlH(t, l, b), C = rotlL(t, l, b), B = SHA3_PI[m];
      t = s[B], l = s[B + 1], s[B] = k, s[B + 1] = C;
    }
    for (let m = 0; m < 50; m += 10) {
      for (let b = 0; b < 10; b++)
        u[b] = s[m + b];
      for (let b = 0; b < 10; b++)
        s[m + b] ^= ~u[(b + 2) % 10] & u[(b + 4) % 10];
    }
    s[0] ^= SHA3_IOTA_H[p], s[1] ^= SHA3_IOTA_L[p];
  }
  clean(u);
}
class Keccak extends Hash {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(A, u, p, t = !1, l = 24) {
    if (super(), this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, this.enableXOF = !1, this.blockLen = A, this.suffix = u, this.outputLen = p, this.enableXOF = t, this.rounds = l, anumber$1(p), !(0 < A && A < 200))
      throw new Error("only keccak-f1600 function is supported");
    this.state = new Uint8Array(200), this.state32 = u32(this.state);
  }
  clone() {
    return this._cloneInto();
  }
  keccak() {
    swap32IfBE(this.state32), keccakP(this.state32, this.rounds), swap32IfBE(this.state32), this.posOut = 0, this.pos = 0;
  }
  update(A) {
    aexists(this), A = toBytes$1(A), abytes$1(A);
    const { blockLen: u, state: p } = this, t = A.length;
    for (let l = 0; l < t; ) {
      const m = Math.min(u - this.pos, t - l);
      for (let b = 0; b < m; b++)
        p[this.pos++] ^= A[l++];
      this.pos === u && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: A, suffix: u, pos: p, blockLen: t } = this;
    A[p] ^= u, (u & 128) !== 0 && p === t - 1 && this.keccak(), A[t - 1] ^= 128, this.keccak();
  }
  writeInto(A) {
    aexists(this, !1), abytes$1(A), this.finish();
    const u = this.state, { blockLen: p } = this;
    for (let t = 0, l = A.length; t < l; ) {
      this.posOut >= p && this.keccak();
      const m = Math.min(p - this.posOut, l - t);
      A.set(u.subarray(this.posOut, this.posOut + m), t), this.posOut += m, t += m;
    }
    return A;
  }
  xofInto(A) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(A);
  }
  xof(A) {
    return anumber$1(A), this.xofInto(new Uint8Array(A));
  }
  digestInto(A) {
    if (aoutput(A, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(A), this.destroy(), A;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, clean(this.state);
  }
  _cloneInto(A) {
    const { blockLen: u, suffix: p, outputLen: t, rounds: l, enableXOF: m } = this;
    return A || (A = new Keccak(u, p, t, m, l)), A.state32.set(this.state32), A.pos = this.pos, A.posOut = this.posOut, A.finished = this.finished, A.rounds = l, A.suffix = p, A.outputLen = t, A.enableXOF = m, A.destroyed = this.destroyed, A;
  }
}
const gen = (s, A, u) => createHasher(() => new Keccak(A, s, u)), keccak_256 = gen(1, 136, 256 / 8);
function keccak256(s, A) {
  const u = A || "hex", p = keccak_256(isHex(s, { strict: !1 }) ? toBytes(s) : s);
  return u === "bytes" ? p : toHex(p);
}
class LruMap extends Map {
  constructor(A) {
    super(), Object.defineProperty(this, "maxSize", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.maxSize = A;
  }
  get(A) {
    const u = super.get(A);
    return super.has(A) && u !== void 0 && (this.delete(A), super.set(A, u)), u;
  }
  set(A, u) {
    if (super.set(A, u), this.maxSize && this.size > this.maxSize) {
      const p = this.keys().next().value;
      p && this.delete(p);
    }
    return this;
  }
}
const addressRegex = /^0x[a-fA-F0-9]{40}$/, isAddressCache = /* @__PURE__ */ new LruMap(8192);
function isAddress(s, A) {
  const { strict: u = !0 } = A ?? {}, p = `${s}.${u}`;
  if (isAddressCache.has(p))
    return isAddressCache.get(p);
  const t = addressRegex.test(s) ? s.toLowerCase() === s ? !0 : u ? checksumAddress(s) === s : !0 : !1;
  return isAddressCache.set(p, t), t;
}
const checksumAddressCache = /* @__PURE__ */ new LruMap(8192);
function checksumAddress(s, A) {
  if (checksumAddressCache.has(`${s}.${A}`))
    return checksumAddressCache.get(`${s}.${A}`);
  const u = s.substring(2).toLowerCase(), p = keccak256(stringToBytes(u), "bytes"), t = u.split("");
  for (let m = 0; m < 40; m += 2)
    p[m >> 1] >> 4 >= 8 && t[m] && (t[m] = t[m].toUpperCase()), (p[m >> 1] & 15) >= 8 && t[m + 1] && (t[m + 1] = t[m + 1].toUpperCase());
  const l = `0x${t.join("")}`;
  return checksumAddressCache.set(`${s}.${A}`, l), l;
}
function getAddress(s, A) {
  if (!isAddress(s, { strict: !1 }))
    throw new InvalidAddressError({ address: s });
  return checksumAddress(s, A);
}
class NegativeOffsetError extends BaseError$3 {
  constructor({ offset: A }) {
    super(`Offset \`${A}\` cannot be negative.`, {
      name: "NegativeOffsetError"
    });
  }
}
class PositionOutOfBoundsError extends BaseError$3 {
  constructor({ length: A, position: u }) {
    super(`Position \`${u}\` is out of bounds (\`0 < position < ${A}\`).`, { name: "PositionOutOfBoundsError" });
  }
}
class RecursiveReadLimitExceededError extends BaseError$3 {
  constructor({ count: A, limit: u }) {
    super(`Recursive read limit of \`${u}\` exceeded (recursive read count: \`${A}\`).`, { name: "RecursiveReadLimitExceededError" });
  }
}
const staticCursor = {
  bytes: new Uint8Array(),
  dataView: new DataView(new ArrayBuffer(0)),
  position: 0,
  positionReadCount: /* @__PURE__ */ new Map(),
  recursiveReadCount: 0,
  recursiveReadLimit: Number.POSITIVE_INFINITY,
  assertReadLimit() {
    if (this.recursiveReadCount >= this.recursiveReadLimit)
      throw new RecursiveReadLimitExceededError({
        count: this.recursiveReadCount + 1,
        limit: this.recursiveReadLimit
      });
  },
  assertPosition(s) {
    if (s < 0 || s > this.bytes.length - 1)
      throw new PositionOutOfBoundsError({
        length: this.bytes.length,
        position: s
      });
  },
  decrementPosition(s) {
    if (s < 0)
      throw new NegativeOffsetError({ offset: s });
    const A = this.position - s;
    this.assertPosition(A), this.position = A;
  },
  getReadCount(s) {
    return this.positionReadCount.get(s || this.position) || 0;
  },
  incrementPosition(s) {
    if (s < 0)
      throw new NegativeOffsetError({ offset: s });
    const A = this.position + s;
    this.assertPosition(A), this.position = A;
  },
  inspectByte(s) {
    const A = s ?? this.position;
    return this.assertPosition(A), this.bytes[A];
  },
  inspectBytes(s, A) {
    const u = A ?? this.position;
    return this.assertPosition(u + s - 1), this.bytes.subarray(u, u + s);
  },
  inspectUint8(s) {
    const A = s ?? this.position;
    return this.assertPosition(A), this.bytes[A];
  },
  inspectUint16(s) {
    const A = s ?? this.position;
    return this.assertPosition(A + 1), this.dataView.getUint16(A);
  },
  inspectUint24(s) {
    const A = s ?? this.position;
    return this.assertPosition(A + 2), (this.dataView.getUint16(A) << 8) + this.dataView.getUint8(A + 2);
  },
  inspectUint32(s) {
    const A = s ?? this.position;
    return this.assertPosition(A + 3), this.dataView.getUint32(A);
  },
  pushByte(s) {
    this.assertPosition(this.position), this.bytes[this.position] = s, this.position++;
  },
  pushBytes(s) {
    this.assertPosition(this.position + s.length - 1), this.bytes.set(s, this.position), this.position += s.length;
  },
  pushUint8(s) {
    this.assertPosition(this.position), this.bytes[this.position] = s, this.position++;
  },
  pushUint16(s) {
    this.assertPosition(this.position + 1), this.dataView.setUint16(this.position, s), this.position += 2;
  },
  pushUint24(s) {
    this.assertPosition(this.position + 2), this.dataView.setUint16(this.position, s >> 8), this.dataView.setUint8(this.position + 2, s & 255), this.position += 3;
  },
  pushUint32(s) {
    this.assertPosition(this.position + 3), this.dataView.setUint32(this.position, s), this.position += 4;
  },
  readByte() {
    this.assertReadLimit(), this._touch();
    const s = this.inspectByte();
    return this.position++, s;
  },
  readBytes(s, A) {
    this.assertReadLimit(), this._touch();
    const u = this.inspectBytes(s);
    return this.position += A ?? s, u;
  },
  readUint8() {
    this.assertReadLimit(), this._touch();
    const s = this.inspectUint8();
    return this.position += 1, s;
  },
  readUint16() {
    this.assertReadLimit(), this._touch();
    const s = this.inspectUint16();
    return this.position += 2, s;
  },
  readUint24() {
    this.assertReadLimit(), this._touch();
    const s = this.inspectUint24();
    return this.position += 3, s;
  },
  readUint32() {
    this.assertReadLimit(), this._touch();
    const s = this.inspectUint32();
    return this.position += 4, s;
  },
  get remaining() {
    return this.bytes.length - this.position;
  },
  setPosition(s) {
    const A = this.position;
    return this.assertPosition(s), this.position = s, () => this.position = A;
  },
  _touch() {
    if (this.recursiveReadLimit === Number.POSITIVE_INFINITY)
      return;
    const s = this.getReadCount();
    this.positionReadCount.set(this.position, s + 1), s > 0 && this.recursiveReadCount++;
  }
};
function createCursor(s, { recursiveReadLimit: A = 8192 } = {}) {
  const u = Object.create(staticCursor);
  return u.bytes = s, u.dataView = new DataView(s.buffer, s.byteOffset, s.byteLength), u.positionReadCount = /* @__PURE__ */ new Map(), u.recursiveReadLimit = A, u;
}
function slice(s, A, u, { strict: p } = {}) {
  return isHex(s, { strict: !1 }) ? sliceHex(s, A, u, {
    strict: p
  }) : sliceBytes(s, A, u, {
    strict: p
  });
}
function assertStartOffset(s, A) {
  if (typeof A == "number" && A > 0 && A > size(s) - 1)
    throw new SliceOffsetOutOfBoundsError({
      offset: A,
      position: "start",
      size: size(s)
    });
}
function assertEndOffset(s, A, u) {
  if (typeof A == "number" && typeof u == "number" && size(s) !== u - A)
    throw new SliceOffsetOutOfBoundsError({
      offset: u,
      position: "end",
      size: size(s)
    });
}
function sliceBytes(s, A, u, { strict: p } = {}) {
  assertStartOffset(s, A);
  const t = s.slice(A, u);
  return p && assertEndOffset(t, A, u), t;
}
function sliceHex(s, A, u, { strict: p } = {}) {
  assertStartOffset(s, A);
  const t = `0x${s.replace("0x", "").slice((A ?? 0) * 2, (u ?? s.length) * 2)}`;
  return p && assertEndOffset(t, A, u), t;
}
function bytesToBigInt(s, A = {}) {
  typeof A.size < "u" && assertSize(s, { size: A.size });
  const u = bytesToHex(s, A);
  return hexToBigInt(u, A);
}
function bytesToBool(s, A = {}) {
  let u = s;
  if (typeof A.size < "u" && (assertSize(u, { size: A.size }), u = trim(u)), u.length > 1 || u[0] > 1)
    throw new InvalidBytesBooleanError(u);
  return !!u[0];
}
function bytesToNumber(s, A = {}) {
  typeof A.size < "u" && assertSize(s, { size: A.size });
  const u = bytesToHex(s, A);
  return hexToNumber(u, A);
}
function bytesToString(s, A = {}) {
  let u = s;
  return typeof A.size < "u" && (assertSize(u, { size: A.size }), u = trim(u, { dir: "right" })), new TextDecoder().decode(u);
}
function concat(s) {
  return typeof s[0] == "string" ? concatHex(s) : concatBytes(s);
}
function concatBytes(s) {
  let A = 0;
  for (const t of s)
    A += t.length;
  const u = new Uint8Array(A);
  let p = 0;
  for (const t of s)
    u.set(t, p), p += t.length;
  return u;
}
function concatHex(s) {
  return `0x${s.reduce((A, u) => A + u.replace("0x", ""), "")}`;
}
const bytesRegex$1 = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/, integerRegex$1 = /^(u?int)(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;
function encodeAbiParameters(s, A) {
  if (s.length !== A.length)
    throw new AbiEncodingLengthMismatchError({
      expectedLength: s.length,
      givenLength: A.length
    });
  const u = prepareParams({
    params: s,
    values: A
  }), p = encodeParams(u);
  return p.length === 0 ? "0x" : p;
}
function prepareParams({ params: s, values: A }) {
  const u = [];
  for (let p = 0; p < s.length; p++)
    u.push(prepareParam({ param: s[p], value: A[p] }));
  return u;
}
function prepareParam({ param: s, value: A }) {
  const u = getArrayComponents(s.type);
  if (u) {
    const [p, t] = u;
    return encodeArray(A, { length: p, param: { ...s, type: t } });
  }
  if (s.type === "tuple")
    return encodeTuple(A, {
      param: s
    });
  if (s.type === "address")
    return encodeAddress(A);
  if (s.type === "bool")
    return encodeBool(A);
  if (s.type.startsWith("uint") || s.type.startsWith("int")) {
    const p = s.type.startsWith("int"), [, , t = "256"] = integerRegex$1.exec(s.type) ?? [];
    return encodeNumber(A, {
      signed: p,
      size: Number(t)
    });
  }
  if (s.type.startsWith("bytes"))
    return encodeBytes(A, { param: s });
  if (s.type === "string")
    return encodeString(A);
  throw new InvalidAbiEncodingTypeError(s.type, {
    docsPath: "/docs/contract/encodeAbiParameters"
  });
}
function encodeParams(s) {
  let A = 0;
  for (let l = 0; l < s.length; l++) {
    const { dynamic: m, encoded: b } = s[l];
    m ? A += 32 : A += size(b);
  }
  const u = [], p = [];
  let t = 0;
  for (let l = 0; l < s.length; l++) {
    const { dynamic: m, encoded: b } = s[l];
    m ? (u.push(numberToHex(A + t, { size: 32 })), p.push(b), t += size(b)) : u.push(b);
  }
  return concat([...u, ...p]);
}
function encodeAddress(s) {
  if (!isAddress(s))
    throw new InvalidAddressError({ address: s });
  return { dynamic: !1, encoded: padHex(s.toLowerCase()) };
}
function encodeArray(s, { length: A, param: u }) {
  const p = A === null;
  if (!Array.isArray(s))
    throw new InvalidArrayError(s);
  if (!p && s.length !== A)
    throw new AbiEncodingArrayLengthMismatchError({
      expectedLength: A,
      givenLength: s.length,
      type: `${u.type}[${A}]`
    });
  let t = !1;
  const l = [];
  for (let m = 0; m < s.length; m++) {
    const b = prepareParam({ param: u, value: s[m] });
    b.dynamic && (t = !0), l.push(b);
  }
  if (p || t) {
    const m = encodeParams(l);
    if (p) {
      const b = numberToHex(l.length, { size: 32 });
      return {
        dynamic: !0,
        encoded: l.length > 0 ? concat([b, m]) : b
      };
    }
    if (t)
      return { dynamic: !0, encoded: m };
  }
  return {
    dynamic: !1,
    encoded: concat(l.map(({ encoded: m }) => m))
  };
}
function encodeBytes(s, { param: A }) {
  const [, u] = A.type.split("bytes"), p = size(s);
  if (!u) {
    let t = s;
    return p % 32 !== 0 && (t = padHex(t, {
      dir: "right",
      size: Math.ceil((s.length - 2) / 2 / 32) * 32
    })), {
      dynamic: !0,
      encoded: concat([padHex(numberToHex(p, { size: 32 })), t])
    };
  }
  if (p !== Number.parseInt(u, 10))
    throw new AbiEncodingBytesSizeMismatchError({
      expectedSize: Number.parseInt(u, 10),
      value: s
    });
  return { dynamic: !1, encoded: padHex(s, { dir: "right" }) };
}
function encodeBool(s) {
  if (typeof s != "boolean")
    throw new BaseError$3(`Invalid boolean value: "${s}" (type: ${typeof s}). Expected: \`true\` or \`false\`.`);
  return { dynamic: !1, encoded: padHex(boolToHex(s)) };
}
function encodeNumber(s, { signed: A, size: u = 256 }) {
  if (typeof u == "number") {
    const p = 2n ** (BigInt(u) - (A ? 1n : 0n)) - 1n, t = A ? -p - 1n : 0n;
    if (s > p || s < t)
      throw new IntegerOutOfRangeError$1({
        max: p.toString(),
        min: t.toString(),
        signed: A,
        size: u / 8,
        value: s.toString()
      });
  }
  return {
    dynamic: !1,
    encoded: numberToHex(s, {
      size: 32,
      signed: A
    })
  };
}
function encodeString(s) {
  const A = stringToHex(s), u = Math.ceil(size(A) / 32), p = [];
  for (let t = 0; t < u; t++)
    p.push(padHex(slice(A, t * 32, (t + 1) * 32), {
      dir: "right"
    }));
  return {
    dynamic: !0,
    encoded: concat([
      padHex(numberToHex(size(A), { size: 32 })),
      ...p
    ])
  };
}
function encodeTuple(s, { param: A }) {
  let u = !1;
  const p = [];
  for (let t = 0; t < A.components.length; t++) {
    const l = A.components[t], m = Array.isArray(s) ? t : l.name, b = prepareParam({
      param: l,
      value: s[m]
    });
    p.push(b), b.dynamic && (u = !0);
  }
  return {
    dynamic: u,
    encoded: u ? encodeParams(p) : concat(p.map(({ encoded: t }) => t))
  };
}
function getArrayComponents(s) {
  const A = s.match(/^(.*)\[(\d+)?\]$/);
  return A ? (
    // Return `null` if the array is dynamic.
    [A[2] ? Number(A[2]) : null, A[1]]
  ) : void 0;
}
function decodeAbiParameters(s, A) {
  const u = typeof A == "string" ? hexToBytes(A) : A, p = createCursor(u);
  if (size(u) === 0 && s.length > 0)
    throw new AbiDecodingZeroDataError();
  if (size(A) && size(A) < 32)
    throw new AbiDecodingDataSizeTooSmallError({
      data: typeof A == "string" ? A : bytesToHex(A),
      params: s,
      size: size(A)
    });
  let t = 0;
  const l = [];
  for (let m = 0; m < s.length; ++m) {
    const b = s[m];
    p.setPosition(t);
    const [k, C] = decodeParameter(p, b, {
      staticPosition: 0
    });
    t += C, l.push(k);
  }
  return l;
}
function decodeParameter(s, A, { staticPosition: u }) {
  const p = getArrayComponents(A.type);
  if (p) {
    const [t, l] = p;
    return decodeArray(s, { ...A, type: l }, { length: t, staticPosition: u });
  }
  if (A.type === "tuple")
    return decodeTuple(s, A, { staticPosition: u });
  if (A.type === "address")
    return decodeAddress(s);
  if (A.type === "bool")
    return decodeBool(s);
  if (A.type.startsWith("bytes"))
    return decodeBytes(s, A, { staticPosition: u });
  if (A.type.startsWith("uint") || A.type.startsWith("int"))
    return decodeNumber(s, A);
  if (A.type === "string")
    return decodeString(s, { staticPosition: u });
  throw new InvalidAbiDecodingTypeError(A.type, {
    docsPath: "/docs/contract/decodeAbiParameters"
  });
}
const sizeOfLength = 32, sizeOfOffset = 32;
function decodeAddress(s) {
  const A = s.readBytes(32);
  return [checksumAddress(bytesToHex(sliceBytes(A, -20))), 32];
}
function decodeArray(s, A, { length: u, staticPosition: p }) {
  if (!u) {
    const m = bytesToNumber(s.readBytes(sizeOfOffset)), b = p + m, k = b + sizeOfLength;
    s.setPosition(b);
    const C = bytesToNumber(s.readBytes(sizeOfLength)), B = hasDynamicChild(A);
    let Q = 0;
    const P = [];
    for (let x = 0; x < C; ++x) {
      s.setPosition(k + (B ? x * 32 : Q));
      const [M, F] = decodeParameter(s, A, {
        staticPosition: k
      });
      Q += F, P.push(M);
    }
    return s.setPosition(p + 32), [P, 32];
  }
  if (hasDynamicChild(A)) {
    const m = bytesToNumber(s.readBytes(sizeOfOffset)), b = p + m, k = [];
    for (let C = 0; C < u; ++C) {
      s.setPosition(b + C * 32);
      const [B] = decodeParameter(s, A, {
        staticPosition: b
      });
      k.push(B);
    }
    return s.setPosition(p + 32), [k, 32];
  }
  let t = 0;
  const l = [];
  for (let m = 0; m < u; ++m) {
    const [b, k] = decodeParameter(s, A, {
      staticPosition: p + t
    });
    t += k, l.push(b);
  }
  return [l, t];
}
function decodeBool(s) {
  return [bytesToBool(s.readBytes(32), { size: 32 }), 32];
}
function decodeBytes(s, A, { staticPosition: u }) {
  const [p, t] = A.type.split("bytes");
  if (!t) {
    const m = bytesToNumber(s.readBytes(32));
    s.setPosition(u + m);
    const b = bytesToNumber(s.readBytes(32));
    if (b === 0)
      return s.setPosition(u + 32), ["0x", 32];
    const k = s.readBytes(b);
    return s.setPosition(u + 32), [bytesToHex(k), 32];
  }
  return [bytesToHex(s.readBytes(Number.parseInt(t, 10), 32)), 32];
}
function decodeNumber(s, A) {
  const u = A.type.startsWith("int"), p = Number.parseInt(A.type.split("int")[1] || "256", 10), t = s.readBytes(32);
  return [
    p > 48 ? bytesToBigInt(t, { signed: u }) : bytesToNumber(t, { signed: u }),
    32
  ];
}
function decodeTuple(s, A, { staticPosition: u }) {
  const p = A.components.length === 0 || A.components.some(({ name: m }) => !m), t = p ? [] : {};
  let l = 0;
  if (hasDynamicChild(A)) {
    const m = bytesToNumber(s.readBytes(sizeOfOffset)), b = u + m;
    for (let k = 0; k < A.components.length; ++k) {
      const C = A.components[k];
      s.setPosition(b + l);
      const [B, Q] = decodeParameter(s, C, {
        staticPosition: b
      });
      l += Q, t[p ? k : C == null ? void 0 : C.name] = B;
    }
    return s.setPosition(u + 32), [t, 32];
  }
  for (let m = 0; m < A.components.length; ++m) {
    const b = A.components[m], [k, C] = decodeParameter(s, b, {
      staticPosition: u
    });
    t[p ? m : b == null ? void 0 : b.name] = k, l += C;
  }
  return [t, l];
}
function decodeString(s, { staticPosition: A }) {
  const u = bytesToNumber(s.readBytes(32)), p = A + u;
  s.setPosition(p);
  const t = bytesToNumber(s.readBytes(32));
  if (t === 0)
    return s.setPosition(A + 32), ["", 32];
  const l = s.readBytes(t, 32), m = bytesToString(trim(l));
  return s.setPosition(A + 32), [m, 32];
}
function hasDynamicChild(s) {
  var p;
  const { type: A } = s;
  if (A === "string" || A === "bytes" || A.endsWith("[]"))
    return !0;
  if (A === "tuple")
    return (p = s.components) == null ? void 0 : p.some(hasDynamicChild);
  const u = getArrayComponents(s.type);
  return !!(u && hasDynamicChild({ ...s, type: u[1] }));
}
const hash = (s) => keccak256(toBytes(s));
function hashSignature(s) {
  return hash(s);
}
const version$2 = "1.1.0";
let BaseError$2 = class I4 extends Error {
  constructor(A, u = {}) {
    var m;
    const p = u.cause instanceof I4 ? u.cause.details : (m = u.cause) != null && m.message ? u.cause.message : u.details, t = u.cause instanceof I4 && u.cause.docsPath || u.docsPath, l = [
      A || "An error occurred.",
      "",
      ...u.metaMessages ? [...u.metaMessages, ""] : [],
      ...t ? [`Docs: https://abitype.dev${t}`] : [],
      ...p ? [`Details: ${p}`] : [],
      `Version: abitype@${version$2}`
    ].join(`
`);
    super(l), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiTypeError"
    }), u.cause && (this.cause = u.cause), this.details = p, this.docsPath = t, this.metaMessages = u.metaMessages, this.shortMessage = A;
  }
};
function execTyped(s, A) {
  const u = s.exec(A);
  return u == null ? void 0 : u.groups;
}
const bytesRegex = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/, integerRegex = /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/, isTupleRegex = /^\(.+?\).*?$/, tupleRegex = /^tuple(?<array>(\[(\d*)\])*)$/;
function formatAbiParameter(s) {
  let A = s.type;
  if (tupleRegex.test(s.type) && "components" in s) {
    A = "(";
    const u = s.components.length;
    for (let t = 0; t < u; t++) {
      const l = s.components[t];
      A += formatAbiParameter(l), t < u - 1 && (A += ", ");
    }
    const p = execTyped(tupleRegex, s.type);
    return A += `)${(p == null ? void 0 : p.array) ?? ""}`, formatAbiParameter({
      ...s,
      type: A
    });
  }
  return "indexed" in s && s.indexed && (A = `${A} indexed`), s.name ? `${A} ${s.name}` : A;
}
function formatAbiParameters(s) {
  let A = "";
  const u = s.length;
  for (let p = 0; p < u; p++) {
    const t = s[p];
    A += formatAbiParameter(t), p !== u - 1 && (A += ", ");
  }
  return A;
}
function formatAbiItem(s) {
  var A;
  return s.type === "function" ? `function ${s.name}(${formatAbiParameters(s.inputs)})${s.stateMutability && s.stateMutability !== "nonpayable" ? ` ${s.stateMutability}` : ""}${(A = s.outputs) != null && A.length ? ` returns (${formatAbiParameters(s.outputs)})` : ""}` : s.type === "event" ? `event ${s.name}(${formatAbiParameters(s.inputs)})` : s.type === "error" ? `error ${s.name}(${formatAbiParameters(s.inputs)})` : s.type === "constructor" ? `constructor(${formatAbiParameters(s.inputs)})${s.stateMutability === "payable" ? " payable" : ""}` : s.type === "fallback" ? `fallback() external${s.stateMutability === "payable" ? " payable" : ""}` : "receive() external payable";
}
const errorSignatureRegex = /^error (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function isErrorSignature(s) {
  return errorSignatureRegex.test(s);
}
function execErrorSignature(s) {
  return execTyped(errorSignatureRegex, s);
}
const eventSignatureRegex = /^event (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function isEventSignature(s) {
  return eventSignatureRegex.test(s);
}
function execEventSignature(s) {
  return execTyped(eventSignatureRegex, s);
}
const functionSignatureRegex = /^function (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)(?: (?<scope>external|public{1}))?(?: (?<stateMutability>pure|view|nonpayable|payable{1}))?(?: returns\s?\((?<returns>.*?)\))?$/;
function isFunctionSignature(s) {
  return functionSignatureRegex.test(s);
}
function execFunctionSignature(s) {
  return execTyped(functionSignatureRegex, s);
}
const structSignatureRegex = /^struct (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*) \{(?<properties>.*?)\}$/;
function isStructSignature(s) {
  return structSignatureRegex.test(s);
}
function execStructSignature(s) {
  return execTyped(structSignatureRegex, s);
}
const constructorSignatureRegex = /^constructor\((?<parameters>.*?)\)(?:\s(?<stateMutability>payable{1}))?$/;
function isConstructorSignature(s) {
  return constructorSignatureRegex.test(s);
}
function execConstructorSignature(s) {
  return execTyped(constructorSignatureRegex, s);
}
const fallbackSignatureRegex = /^fallback\(\) external(?:\s(?<stateMutability>payable{1}))?$/;
function isFallbackSignature(s) {
  return fallbackSignatureRegex.test(s);
}
function execFallbackSignature(s) {
  return execTyped(fallbackSignatureRegex, s);
}
const receiveSignatureRegex = /^receive\(\) external payable$/;
function isReceiveSignature(s) {
  return receiveSignatureRegex.test(s);
}
const eventModifiers = /* @__PURE__ */ new Set(["indexed"]), functionModifiers = /* @__PURE__ */ new Set([
  "calldata",
  "memory",
  "storage"
]);
class UnknownTypeError extends BaseError$2 {
  constructor({ type: A }) {
    super("Unknown type.", {
      metaMessages: [
        `Type "${A}" is not a valid ABI type. Perhaps you forgot to include a struct signature?`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnknownTypeError"
    });
  }
}
class UnknownSolidityTypeError extends BaseError$2 {
  constructor({ type: A }) {
    super("Unknown type.", {
      metaMessages: [`Type "${A}" is not a valid ABI type.`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnknownSolidityTypeError"
    });
  }
}
class InvalidParameterError extends BaseError$2 {
  constructor({ param: A }) {
    super("Invalid ABI parameter.", {
      details: A
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidParameterError"
    });
  }
}
class SolidityProtectedKeywordError extends BaseError$2 {
  constructor({ param: A, name: u }) {
    super("Invalid ABI parameter.", {
      details: A,
      metaMessages: [
        `"${u}" is a protected Solidity keyword. More info: https://docs.soliditylang.org/en/latest/cheatsheet.html`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SolidityProtectedKeywordError"
    });
  }
}
class InvalidModifierError extends BaseError$2 {
  constructor({ param: A, type: u, modifier: p }) {
    super("Invalid ABI parameter.", {
      details: A,
      metaMessages: [
        `Modifier "${p}" not allowed${u ? ` in "${u}" type` : ""}.`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidModifierError"
    });
  }
}
class InvalidFunctionModifierError extends BaseError$2 {
  constructor({ param: A, type: u, modifier: p }) {
    super("Invalid ABI parameter.", {
      details: A,
      metaMessages: [
        `Modifier "${p}" not allowed${u ? ` in "${u}" type` : ""}.`,
        `Data location can only be specified for array, struct, or mapping types, but "${p}" was given.`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidFunctionModifierError"
    });
  }
}
class InvalidAbiTypeParameterError extends BaseError$2 {
  constructor({ abiParameter: A }) {
    super("Invalid ABI parameter.", {
      details: JSON.stringify(A, null, 2),
      metaMessages: ["ABI parameter type is invalid."]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidAbiTypeParameterError"
    });
  }
}
class InvalidSignatureError extends BaseError$2 {
  constructor({ signature: A, type: u }) {
    super(`Invalid ${u} signature.`, {
      details: A
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidSignatureError"
    });
  }
}
class UnknownSignatureError extends BaseError$2 {
  constructor({ signature: A }) {
    super("Unknown signature.", {
      details: A
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnknownSignatureError"
    });
  }
}
class InvalidStructSignatureError extends BaseError$2 {
  constructor({ signature: A }) {
    super("Invalid struct signature.", {
      details: A,
      metaMessages: ["No properties exist."]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidStructSignatureError"
    });
  }
}
class CircularReferenceError extends BaseError$2 {
  constructor({ type: A }) {
    super("Circular reference detected.", {
      metaMessages: [`Struct "${A}" is a circular reference.`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "CircularReferenceError"
    });
  }
}
class InvalidParenthesisError extends BaseError$2 {
  constructor({ current: A, depth: u }) {
    super("Unbalanced parentheses.", {
      metaMessages: [
        `"${A.trim()}" has too many ${u > 0 ? "opening" : "closing"} parentheses.`
      ],
      details: `Depth "${u}"`
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidParenthesisError"
    });
  }
}
function getParameterCacheKey(s, A, u) {
  let p = "";
  if (u)
    for (const t of Object.entries(u)) {
      if (!t)
        continue;
      let l = "";
      for (const m of t[1])
        l += `[${m.type}${m.name ? `:${m.name}` : ""}]`;
      p += `(${t[0]}{${l}})`;
    }
  return A ? `${A}:${s}${p}` : s;
}
const parameterCache = /* @__PURE__ */ new Map([
  // Unnamed
  ["address", { type: "address" }],
  ["bool", { type: "bool" }],
  ["bytes", { type: "bytes" }],
  ["bytes32", { type: "bytes32" }],
  ["int", { type: "int256" }],
  ["int256", { type: "int256" }],
  ["string", { type: "string" }],
  ["uint", { type: "uint256" }],
  ["uint8", { type: "uint8" }],
  ["uint16", { type: "uint16" }],
  ["uint24", { type: "uint24" }],
  ["uint32", { type: "uint32" }],
  ["uint64", { type: "uint64" }],
  ["uint96", { type: "uint96" }],
  ["uint112", { type: "uint112" }],
  ["uint160", { type: "uint160" }],
  ["uint192", { type: "uint192" }],
  ["uint256", { type: "uint256" }],
  // Named
  ["address owner", { type: "address", name: "owner" }],
  ["address to", { type: "address", name: "to" }],
  ["bool approved", { type: "bool", name: "approved" }],
  ["bytes _data", { type: "bytes", name: "_data" }],
  ["bytes data", { type: "bytes", name: "data" }],
  ["bytes signature", { type: "bytes", name: "signature" }],
  ["bytes32 hash", { type: "bytes32", name: "hash" }],
  ["bytes32 r", { type: "bytes32", name: "r" }],
  ["bytes32 root", { type: "bytes32", name: "root" }],
  ["bytes32 s", { type: "bytes32", name: "s" }],
  ["string name", { type: "string", name: "name" }],
  ["string symbol", { type: "string", name: "symbol" }],
  ["string tokenURI", { type: "string", name: "tokenURI" }],
  ["uint tokenId", { type: "uint256", name: "tokenId" }],
  ["uint8 v", { type: "uint8", name: "v" }],
  ["uint256 balance", { type: "uint256", name: "balance" }],
  ["uint256 tokenId", { type: "uint256", name: "tokenId" }],
  ["uint256 value", { type: "uint256", name: "value" }],
  // Indexed
  [
    "event:address indexed from",
    { type: "address", name: "from", indexed: !0 }
  ],
  ["event:address indexed to", { type: "address", name: "to", indexed: !0 }],
  [
    "event:uint indexed tokenId",
    { type: "uint256", name: "tokenId", indexed: !0 }
  ],
  [
    "event:uint256 indexed tokenId",
    { type: "uint256", name: "tokenId", indexed: !0 }
  ]
]);
function parseSignature(s, A = {}) {
  if (isFunctionSignature(s))
    return parseFunctionSignature(s, A);
  if (isEventSignature(s))
    return parseEventSignature(s, A);
  if (isErrorSignature(s))
    return parseErrorSignature(s, A);
  if (isConstructorSignature(s))
    return parseConstructorSignature(s, A);
  if (isFallbackSignature(s))
    return parseFallbackSignature(s);
  if (isReceiveSignature(s))
    return {
      type: "receive",
      stateMutability: "payable"
    };
  throw new UnknownSignatureError({ signature: s });
}
function parseFunctionSignature(s, A = {}) {
  const u = execFunctionSignature(s);
  if (!u)
    throw new InvalidSignatureError({ signature: s, type: "function" });
  const p = splitParameters(u.parameters), t = [], l = p.length;
  for (let b = 0; b < l; b++)
    t.push(parseAbiParameter(p[b], {
      modifiers: functionModifiers,
      structs: A,
      type: "function"
    }));
  const m = [];
  if (u.returns) {
    const b = splitParameters(u.returns), k = b.length;
    for (let C = 0; C < k; C++)
      m.push(parseAbiParameter(b[C], {
        modifiers: functionModifiers,
        structs: A,
        type: "function"
      }));
  }
  return {
    name: u.name,
    type: "function",
    stateMutability: u.stateMutability ?? "nonpayable",
    inputs: t,
    outputs: m
  };
}
function parseEventSignature(s, A = {}) {
  const u = execEventSignature(s);
  if (!u)
    throw new InvalidSignatureError({ signature: s, type: "event" });
  const p = splitParameters(u.parameters), t = [], l = p.length;
  for (let m = 0; m < l; m++)
    t.push(parseAbiParameter(p[m], {
      modifiers: eventModifiers,
      structs: A,
      type: "event"
    }));
  return { name: u.name, type: "event", inputs: t };
}
function parseErrorSignature(s, A = {}) {
  const u = execErrorSignature(s);
  if (!u)
    throw new InvalidSignatureError({ signature: s, type: "error" });
  const p = splitParameters(u.parameters), t = [], l = p.length;
  for (let m = 0; m < l; m++)
    t.push(parseAbiParameter(p[m], { structs: A, type: "error" }));
  return { name: u.name, type: "error", inputs: t };
}
function parseConstructorSignature(s, A = {}) {
  const u = execConstructorSignature(s);
  if (!u)
    throw new InvalidSignatureError({ signature: s, type: "constructor" });
  const p = splitParameters(u.parameters), t = [], l = p.length;
  for (let m = 0; m < l; m++)
    t.push(parseAbiParameter(p[m], { structs: A, type: "constructor" }));
  return {
    type: "constructor",
    stateMutability: u.stateMutability ?? "nonpayable",
    inputs: t
  };
}
function parseFallbackSignature(s) {
  const A = execFallbackSignature(s);
  if (!A)
    throw new InvalidSignatureError({ signature: s, type: "fallback" });
  return {
    type: "fallback",
    stateMutability: A.stateMutability ?? "nonpayable"
  };
}
const abiParameterWithoutTupleRegex = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*(?:\spayable)?)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/, abiParameterWithTupleRegex = /^\((?<type>.+?)\)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/, dynamicIntegerRegex = /^u?int$/;
function parseAbiParameter(s, A) {
  var Q, P;
  const u = getParameterCacheKey(s, A == null ? void 0 : A.type, A == null ? void 0 : A.structs);
  if (parameterCache.has(u))
    return parameterCache.get(u);
  const p = isTupleRegex.test(s), t = execTyped(p ? abiParameterWithTupleRegex : abiParameterWithoutTupleRegex, s);
  if (!t)
    throw new InvalidParameterError({ param: s });
  if (t.name && isSolidityKeyword(t.name))
    throw new SolidityProtectedKeywordError({ param: s, name: t.name });
  const l = t.name ? { name: t.name } : {}, m = t.modifier === "indexed" ? { indexed: !0 } : {}, b = (A == null ? void 0 : A.structs) ?? {};
  let k, C = {};
  if (p) {
    k = "tuple";
    const x = splitParameters(t.type), M = [], F = x.length;
    for (let le = 0; le < F; le++)
      M.push(parseAbiParameter(x[le], { structs: b }));
    C = { components: M };
  } else if (t.type in b)
    k = "tuple", C = { components: b[t.type] };
  else if (dynamicIntegerRegex.test(t.type))
    k = `${t.type}256`;
  else if (t.type === "address payable")
    k = "address";
  else if (k = t.type, (A == null ? void 0 : A.type) !== "struct" && !isSolidityType(k))
    throw new UnknownSolidityTypeError({ type: k });
  if (t.modifier) {
    if (!((P = (Q = A == null ? void 0 : A.modifiers) == null ? void 0 : Q.has) != null && P.call(Q, t.modifier)))
      throw new InvalidModifierError({
        param: s,
        type: A == null ? void 0 : A.type,
        modifier: t.modifier
      });
    if (functionModifiers.has(t.modifier) && !isValidDataLocation(k, !!t.array))
      throw new InvalidFunctionModifierError({
        param: s,
        type: A == null ? void 0 : A.type,
        modifier: t.modifier
      });
  }
  const B = {
    type: `${k}${t.array ?? ""}`,
    ...l,
    ...m,
    ...C
  };
  return parameterCache.set(u, B), B;
}
function splitParameters(s, A = [], u = "", p = 0) {
  const t = s.trim().length;
  for (let l = 0; l < t; l++) {
    const m = s[l], b = s.slice(l + 1);
    switch (m) {
      case ",":
        return p === 0 ? splitParameters(b, [...A, u.trim()]) : splitParameters(b, A, `${u}${m}`, p);
      case "(":
        return splitParameters(b, A, `${u}${m}`, p + 1);
      case ")":
        return splitParameters(b, A, `${u}${m}`, p - 1);
      default:
        return splitParameters(b, A, `${u}${m}`, p);
    }
  }
  if (u === "")
    return A;
  if (p !== 0)
    throw new InvalidParenthesisError({ current: u, depth: p });
  return A.push(u.trim()), A;
}
function isSolidityType(s) {
  return s === "address" || s === "bool" || s === "function" || s === "string" || bytesRegex.test(s) || integerRegex.test(s);
}
const protectedKeywordsRegex = /^(?:after|alias|anonymous|apply|auto|byte|calldata|case|catch|constant|copyof|default|defined|error|event|external|false|final|function|immutable|implements|in|indexed|inline|internal|let|mapping|match|memory|mutable|null|of|override|partial|private|promise|public|pure|reference|relocatable|return|returns|sizeof|static|storage|struct|super|supports|switch|this|true|try|typedef|typeof|var|view|virtual)$/;
function isSolidityKeyword(s) {
  return s === "address" || s === "bool" || s === "function" || s === "string" || s === "tuple" || bytesRegex.test(s) || integerRegex.test(s) || protectedKeywordsRegex.test(s);
}
function isValidDataLocation(s, A) {
  return A || s === "bytes" || s === "string" || s === "tuple";
}
function parseStructs(s) {
  const A = {}, u = s.length;
  for (let m = 0; m < u; m++) {
    const b = s[m];
    if (!isStructSignature(b))
      continue;
    const k = execStructSignature(b);
    if (!k)
      throw new InvalidSignatureError({ signature: b, type: "struct" });
    const C = k.properties.split(";"), B = [], Q = C.length;
    for (let P = 0; P < Q; P++) {
      const M = C[P].trim();
      if (!M)
        continue;
      const F = parseAbiParameter(M, {
        type: "struct"
      });
      B.push(F);
    }
    if (!B.length)
      throw new InvalidStructSignatureError({ signature: b });
    A[k.name] = B;
  }
  const p = {}, t = Object.entries(A), l = t.length;
  for (let m = 0; m < l; m++) {
    const [b, k] = t[m];
    p[b] = resolveStructs(k, A);
  }
  return p;
}
const typeWithoutTupleRegex = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?$/;
function resolveStructs(s, A, u = /* @__PURE__ */ new Set()) {
  const p = [], t = s.length;
  for (let l = 0; l < t; l++) {
    const m = s[l];
    if (isTupleRegex.test(m.type))
      p.push(m);
    else {
      const k = execTyped(typeWithoutTupleRegex, m.type);
      if (!(k != null && k.type))
        throw new InvalidAbiTypeParameterError({ abiParameter: m });
      const { array: C, type: B } = k;
      if (B in A) {
        if (u.has(B))
          throw new CircularReferenceError({ type: B });
        p.push({
          ...m,
          type: `tuple${C ?? ""}`,
          components: resolveStructs(A[B] ?? [], A, /* @__PURE__ */ new Set([...u, B]))
        });
      } else if (isSolidityType(B))
        p.push(m);
      else
        throw new UnknownTypeError({ type: B });
    }
  }
  return p;
}
function parseAbi(s) {
  const A = parseStructs(s), u = [], p = s.length;
  for (let t = 0; t < p; t++) {
    const l = s[t];
    isStructSignature(l) || u.push(parseSignature(l, A));
  }
  return u;
}
function normalizeSignature(s) {
  let A = !0, u = "", p = 0, t = "", l = !1;
  for (let m = 0; m < s.length; m++) {
    const b = s[m];
    if (["(", ")", ","].includes(b) && (A = !0), b === "(" && p++, b === ")" && p--, !!A) {
      if (p === 0) {
        if (b === " " && ["event", "function", ""].includes(t))
          t = "";
        else if (t += b, b === ")") {
          l = !0;
          break;
        }
        continue;
      }
      if (b === " ") {
        s[m - 1] !== "," && u !== "," && u !== ",(" && (u = "", A = !1);
        continue;
      }
      t += b, u += b;
    }
  }
  if (!l)
    throw new BaseError$3("Unable to normalize signature.");
  return t;
}
const toSignature = (s) => {
  const A = typeof s == "string" ? s : formatAbiItem(s);
  return normalizeSignature(A);
};
function toSignatureHash(s) {
  return hashSignature(toSignature(s));
}
const toEventSelector = toSignatureHash, toFunctionSelector = (s) => slice(toSignatureHash(s), 0, 4);
function getAbiItem(s) {
  const { abi: A, args: u = [], name: p } = s, t = isHex(p, { strict: !1 }), l = A.filter((b) => t ? b.type === "function" ? toFunctionSelector(b) === p : b.type === "event" ? toEventSelector(b) === p : !1 : "name" in b && b.name === p);
  if (l.length === 0)
    return;
  if (l.length === 1)
    return l[0];
  let m;
  for (const b of l) {
    if (!("inputs" in b))
      continue;
    if (!u || u.length === 0) {
      if (!b.inputs || b.inputs.length === 0)
        return b;
      continue;
    }
    if (!b.inputs || b.inputs.length === 0 || b.inputs.length !== u.length)
      continue;
    if (u.every((C, B) => {
      const Q = "inputs" in b && b.inputs[B];
      return Q ? isArgOfType(C, Q) : !1;
    })) {
      if (m && "inputs" in m && m.inputs) {
        const C = getAmbiguousTypes(b.inputs, m.inputs, u);
        if (C)
          throw new AbiItemAmbiguityError({
            abiItem: b,
            type: C[0]
          }, {
            abiItem: m,
            type: C[1]
          });
      }
      m = b;
    }
  }
  return m || l[0];
}
function isArgOfType(s, A) {
  const u = typeof s, p = A.type;
  switch (p) {
    case "address":
      return isAddress(s, { strict: !1 });
    case "bool":
      return u === "boolean";
    case "function":
      return u === "string";
    case "string":
      return u === "string";
    default:
      return p === "tuple" && "components" in A ? Object.values(A.components).every((t, l) => isArgOfType(Object.values(s)[l], t)) : /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(p) ? u === "number" || u === "bigint" : /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(p) ? u === "string" || s instanceof Uint8Array : /[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(p) ? Array.isArray(s) && s.every((t) => isArgOfType(t, {
        ...A,
        // Pop off `[]` or `[M]` from end of type
        type: p.replace(/(\[[0-9]{0,}\])$/, "")
      })) : !1;
  }
}
function getAmbiguousTypes(s, A, u) {
  for (const p in s) {
    const t = s[p], l = A[p];
    if (t.type === "tuple" && l.type === "tuple" && "components" in t && "components" in l)
      return getAmbiguousTypes(t.components, l.components, u[p]);
    const m = [t.type, l.type];
    if (m.includes("address") && m.includes("bytes20") ? !0 : m.includes("address") && m.includes("string") ? isAddress(u[p], { strict: !1 }) : m.includes("address") && m.includes("bytes") ? isAddress(u[p], { strict: !1 }) : !1)
      return m;
  }
}
const docsPath$2 = "/docs/contract/decodeFunctionResult";
function decodeFunctionResult(s) {
  const { abi: A, args: u, functionName: p, data: t } = s;
  let l = A[0];
  if (p) {
    const b = getAbiItem({ abi: A, args: u, name: p });
    if (!b)
      throw new AbiFunctionNotFoundError(p, { docsPath: docsPath$2 });
    l = b;
  }
  if (l.type !== "function")
    throw new AbiFunctionNotFoundError(void 0, { docsPath: docsPath$2 });
  if (!l.outputs)
    throw new AbiFunctionOutputsNotFoundError(l.name, { docsPath: docsPath$2 });
  const m = decodeAbiParameters(l.outputs, t);
  if (m && m.length > 1)
    return m;
  if (m && m.length === 1)
    return m[0];
}
const docsPath$1 = "/docs/contract/encodeFunctionData";
function prepareEncodeFunctionData(s) {
  const { abi: A, args: u, functionName: p } = s;
  let t = A[0];
  if (p) {
    const l = getAbiItem({
      abi: A,
      args: u,
      name: p
    });
    if (!l)
      throw new AbiFunctionNotFoundError(p, { docsPath: docsPath$1 });
    t = l;
  }
  if (t.type !== "function")
    throw new AbiFunctionNotFoundError(void 0, { docsPath: docsPath$1 });
  return {
    abi: [t],
    functionName: toFunctionSelector(formatAbiItem$1(t))
  };
}
function encodeFunctionData(s) {
  const { args: A } = s, { abi: u, functionName: p } = (() => {
    var b;
    return s.abi.length === 1 && ((b = s.functionName) != null && b.startsWith("0x")) ? s : prepareEncodeFunctionData(s);
  })(), t = u[0], l = p, m = "inputs" in t && t.inputs ? encodeAbiParameters(t.inputs, A ?? []) : void 0;
  return concatHex([l, m ?? "0x"]);
}
class ChainDoesNotSupportContract extends BaseError$3 {
  constructor({ blockNumber: A, chain: u, contract: p }) {
    super(`Chain "${u.name}" does not support contract "${p.name}".`, {
      metaMessages: [
        "This could be due to any of the following:",
        ...A && p.blockCreated && p.blockCreated > A ? [
          `- The contract "${p.name}" was not deployed until block ${p.blockCreated} (current block ${A}).`
        ] : [
          `- The chain does not have the contract "${p.name}" configured.`
        ]
      ],
      name: "ChainDoesNotSupportContract"
    });
  }
}
class ChainMismatchError extends BaseError$3 {
  constructor({ chain: A, currentChainId: u }) {
    super(`The current chain of the wallet (id: ${u}) does not match the target chain for the transaction (id: ${A.id} – ${A.name}).`, {
      metaMessages: [
        `Current Chain ID:  ${u}`,
        `Expected Chain ID: ${A.id} – ${A.name}`
      ],
      name: "ChainMismatchError"
    });
  }
}
class ChainNotFoundError extends BaseError$3 {
  constructor() {
    super([
      "No chain was provided to the request.",
      "Please provide a chain with the `chain` argument on the Action, or by supplying a `chain` to WalletClient."
    ].join(`
`), {
      name: "ChainNotFoundError"
    });
  }
}
class ClientChainNotConfiguredError extends BaseError$3 {
  constructor() {
    super("No chain was provided to the Client.", {
      name: "ClientChainNotConfiguredError"
    });
  }
}
function getChainContractAddress({ blockNumber: s, chain: A, contract: u }) {
  var t;
  const p = (t = A == null ? void 0 : A.contracts) == null ? void 0 : t[u];
  if (!p)
    throw new ChainDoesNotSupportContract({
      chain: A,
      contract: { name: u }
    });
  if (s && p.blockCreated && p.blockCreated > s)
    throw new ChainDoesNotSupportContract({
      blockNumber: s,
      chain: A,
      contract: {
        name: u,
        blockCreated: p.blockCreated
      }
    });
  return p.address;
}
function parseAccount(s) {
  return typeof s == "string" ? { address: s, type: "json-rpc" } : s;
}
const panicReasons = {
  1: "An `assert` condition failed.",
  17: "Arithmetic operation resulted in underflow or overflow.",
  18: "Division or modulo by zero (e.g. `5 / 0` or `23 % 0`).",
  33: "Attempted to convert to an invalid type.",
  34: "Attempted to access a storage byte array that is incorrectly encoded.",
  49: "Performed `.pop()` on an empty array",
  50: "Array index is out of bounds.",
  65: "Allocated too much memory or created an array which is too large.",
  81: "Attempted to call a zero-initialized variable of internal function type."
}, solidityError = {
  inputs: [
    {
      name: "message",
      type: "string"
    }
  ],
  name: "Error",
  type: "error"
}, solidityPanic = {
  inputs: [
    {
      name: "reason",
      type: "uint256"
    }
  ],
  name: "Panic",
  type: "error"
};
function decodeErrorResult(s) {
  const { abi: A, data: u } = s, p = slice(u, 0, 4);
  if (p === "0x")
    throw new AbiDecodingZeroDataError();
  const l = [...A || [], solidityError, solidityPanic].find((m) => m.type === "error" && p === toFunctionSelector(formatAbiItem$1(m)));
  if (!l)
    throw new AbiErrorSignatureNotFoundError(p, {
      docsPath: "/docs/contract/decodeErrorResult"
    });
  return {
    abiItem: l,
    args: "inputs" in l && l.inputs && l.inputs.length > 0 ? decodeAbiParameters(l.inputs, slice(u, 4)) : void 0,
    errorName: l.name
  };
}
const stringify = (s, A, u) => JSON.stringify(s, (p, t) => typeof t == "bigint" ? t.toString() : t, u);
function formatAbiItemWithArgs({ abiItem: s, args: A, includeFunctionName: u = !0, includeName: p = !1 }) {
  if ("name" in s && "inputs" in s && s.inputs)
    return `${u ? s.name : ""}(${s.inputs.map((t, l) => `${p && t.name ? `${t.name}: ` : ""}${typeof A[l] == "object" ? stringify(A[l]) : A[l]}`).join(", ")})`;
}
const etherUnits = {
  gwei: 9,
  wei: 18
}, gweiUnits = {
  ether: -9,
  wei: 9
};
function formatUnits(s, A) {
  let u = s.toString();
  const p = u.startsWith("-");
  p && (u = u.slice(1)), u = u.padStart(A, "0");
  let [t, l] = [
    u.slice(0, u.length - A),
    u.slice(u.length - A)
  ];
  return l = l.replace(/(0+)$/, ""), `${p ? "-" : ""}${t || "0"}${l ? `.${l}` : ""}`;
}
function formatEther(s, A = "wei") {
  return formatUnits(s, etherUnits[A]);
}
function formatGwei(s, A = "wei") {
  return formatUnits(s, gweiUnits[A]);
}
class AccountStateConflictError extends BaseError$3 {
  constructor({ address: A }) {
    super(`State for account "${A}" is set multiple times.`, {
      name: "AccountStateConflictError"
    });
  }
}
class StateAssignmentConflictError extends BaseError$3 {
  constructor() {
    super("state and stateDiff are set on the same account.", {
      name: "StateAssignmentConflictError"
    });
  }
}
function prettyStateMapping(s) {
  return s.reduce((A, { slot: u, value: p }) => `${A}        ${u}: ${p}
`, "");
}
function prettyStateOverride(s) {
  return s.reduce((A, { address: u, ...p }) => {
    let t = `${A}    ${u}:
`;
    return p.nonce && (t += `      nonce: ${p.nonce}
`), p.balance && (t += `      balance: ${p.balance}
`), p.code && (t += `      code: ${p.code}
`), p.state && (t += `      state:
`, t += prettyStateMapping(p.state)), p.stateDiff && (t += `      stateDiff:
`, t += prettyStateMapping(p.stateDiff)), t;
  }, `  State Override:
`).slice(0, -1);
}
function prettyPrint(s) {
  const A = Object.entries(s).map(([p, t]) => t === void 0 || t === !1 ? null : [p, t]).filter(Boolean), u = A.reduce((p, [t]) => Math.max(p, t.length), 0);
  return A.map(([p, t]) => `  ${`${p}:`.padEnd(u + 1)}  ${t}`).join(`
`);
}
class FeeConflictError extends BaseError$3 {
  constructor() {
    super([
      "Cannot specify both a `gasPrice` and a `maxFeePerGas`/`maxPriorityFeePerGas`.",
      "Use `maxFeePerGas`/`maxPriorityFeePerGas` for EIP-1559 compatible networks, and `gasPrice` for others."
    ].join(`
`), { name: "FeeConflictError" });
  }
}
class InvalidSerializableTransactionError extends BaseError$3 {
  constructor({ transaction: A }) {
    super("Cannot infer a transaction type from provided transaction.", {
      metaMessages: [
        "Provided Transaction:",
        "{",
        prettyPrint(A),
        "}",
        "",
        "To infer the type, either provide:",
        "- a `type` to the Transaction, or",
        "- an EIP-1559 Transaction with `maxFeePerGas`, or",
        "- an EIP-2930 Transaction with `gasPrice` & `accessList`, or",
        "- an EIP-4844 Transaction with `blobs`, `blobVersionedHashes`, `sidecars`, or",
        "- an EIP-7702 Transaction with `authorizationList`, or",
        "- a Legacy Transaction with `gasPrice`"
      ],
      name: "InvalidSerializableTransactionError"
    });
  }
}
class TransactionExecutionError extends BaseError$3 {
  constructor(A, { account: u, docsPath: p, chain: t, data: l, gas: m, gasPrice: b, maxFeePerGas: k, maxPriorityFeePerGas: C, nonce: B, to: Q, value: P }) {
    var M;
    const x = prettyPrint({
      chain: t && `${t == null ? void 0 : t.name} (id: ${t == null ? void 0 : t.id})`,
      from: u == null ? void 0 : u.address,
      to: Q,
      value: typeof P < "u" && `${formatEther(P)} ${((M = t == null ? void 0 : t.nativeCurrency) == null ? void 0 : M.symbol) || "ETH"}`,
      data: l,
      gas: m,
      gasPrice: typeof b < "u" && `${formatGwei(b)} gwei`,
      maxFeePerGas: typeof k < "u" && `${formatGwei(k)} gwei`,
      maxPriorityFeePerGas: typeof C < "u" && `${formatGwei(C)} gwei`,
      nonce: B
    });
    super(A.shortMessage, {
      cause: A,
      docsPath: p,
      metaMessages: [
        ...A.metaMessages ? [...A.metaMessages, " "] : [],
        "Request Arguments:",
        x
      ].filter(Boolean),
      name: "TransactionExecutionError"
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.cause = A;
  }
}
const getContractAddress = (s) => s, getUrl = (s) => s;
class CallExecutionError extends BaseError$3 {
  constructor(A, { account: u, docsPath: p, chain: t, data: l, gas: m, gasPrice: b, maxFeePerGas: k, maxPriorityFeePerGas: C, nonce: B, to: Q, value: P, stateOverride: x }) {
    var le;
    const M = u ? parseAccount(u) : void 0;
    let F = prettyPrint({
      from: M == null ? void 0 : M.address,
      to: Q,
      value: typeof P < "u" && `${formatEther(P)} ${((le = t == null ? void 0 : t.nativeCurrency) == null ? void 0 : le.symbol) || "ETH"}`,
      data: l,
      gas: m,
      gasPrice: typeof b < "u" && `${formatGwei(b)} gwei`,
      maxFeePerGas: typeof k < "u" && `${formatGwei(k)} gwei`,
      maxPriorityFeePerGas: typeof C < "u" && `${formatGwei(C)} gwei`,
      nonce: B
    });
    x && (F += `
${prettyStateOverride(x)}`), super(A.shortMessage, {
      cause: A,
      docsPath: p,
      metaMessages: [
        ...A.metaMessages ? [...A.metaMessages, " "] : [],
        "Raw Call Arguments:",
        F
      ].filter(Boolean),
      name: "CallExecutionError"
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.cause = A;
  }
}
class ContractFunctionExecutionError extends BaseError$3 {
  constructor(A, { abi: u, args: p, contractAddress: t, docsPath: l, functionName: m, sender: b }) {
    const k = getAbiItem({ abi: u, args: p, name: m }), C = k ? formatAbiItemWithArgs({
      abiItem: k,
      args: p,
      includeFunctionName: !1,
      includeName: !1
    }) : void 0, B = k ? formatAbiItem$1(k, { includeName: !0 }) : void 0, Q = prettyPrint({
      address: t && getContractAddress(t),
      function: B,
      args: C && C !== "()" && `${[...Array((m == null ? void 0 : m.length) ?? 0).keys()].map(() => " ").join("")}${C}`,
      sender: b
    });
    super(A.shortMessage || `An unknown error occurred while executing the contract function "${m}".`, {
      cause: A,
      docsPath: l,
      metaMessages: [
        ...A.metaMessages ? [...A.metaMessages, " "] : [],
        Q && "Contract Call:",
        Q
      ].filter(Boolean),
      name: "ContractFunctionExecutionError"
    }), Object.defineProperty(this, "abi", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "args", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "contractAddress", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "formattedArgs", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "functionName", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "sender", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.abi = u, this.args = p, this.cause = A, this.contractAddress = t, this.functionName = m, this.sender = b;
  }
}
class ContractFunctionRevertedError extends BaseError$3 {
  constructor({ abi: A, data: u, functionName: p, message: t }) {
    let l, m, b, k;
    if (u && u !== "0x")
      try {
        m = decodeErrorResult({ abi: A, data: u });
        const { abiItem: B, errorName: Q, args: P } = m;
        if (Q === "Error")
          k = P[0];
        else if (Q === "Panic") {
          const [x] = P;
          k = panicReasons[x];
        } else {
          const x = B ? formatAbiItem$1(B, { includeName: !0 }) : void 0, M = B && P ? formatAbiItemWithArgs({
            abiItem: B,
            args: P,
            includeFunctionName: !1,
            includeName: !1
          }) : void 0;
          b = [
            x ? `Error: ${x}` : "",
            M && M !== "()" ? `       ${[...Array((Q == null ? void 0 : Q.length) ?? 0).keys()].map(() => " ").join("")}${M}` : ""
          ];
        }
      } catch (B) {
        l = B;
      }
    else t && (k = t);
    let C;
    l instanceof AbiErrorSignatureNotFoundError && (C = l.signature, b = [
      `Unable to decode signature "${C}" as it was not found on the provided ABI.`,
      "Make sure you are using the correct ABI and that the error exists on it.",
      `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${C}.`
    ]), super(k && k !== "execution reverted" || C ? [
      `The contract function "${p}" reverted with the following ${C ? "signature" : "reason"}:`,
      k || C
    ].join(`
`) : `The contract function "${p}" reverted.`, {
      cause: l,
      metaMessages: b,
      name: "ContractFunctionRevertedError"
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "raw", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "reason", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "signature", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = m, this.raw = u, this.reason = k, this.signature = C;
  }
}
class ContractFunctionZeroDataError extends BaseError$3 {
  constructor({ functionName: A }) {
    super(`The contract function "${A}" returned no data ("0x").`, {
      metaMessages: [
        "This could be due to any of the following:",
        `  - The contract does not have the function "${A}",`,
        "  - The parameters passed to the contract function may be invalid, or",
        "  - The address is not a contract."
      ],
      name: "ContractFunctionZeroDataError"
    });
  }
}
class CounterfactualDeploymentFailedError extends BaseError$3 {
  constructor({ factory: A }) {
    super(`Deployment for counterfactual contract call failed${A ? ` for factory "${A}".` : ""}`, {
      metaMessages: [
        "Please ensure:",
        "- The `factory` is a valid contract deployment factory (ie. Create2 Factory, ERC-4337 Factory, etc).",
        "- The `factoryData` is a valid encoded function call for contract deployment function on the factory."
      ],
      name: "CounterfactualDeploymentFailedError"
    });
  }
}
class RawContractError extends BaseError$3 {
  constructor({ data: A, message: u }) {
    super(u || "", { name: "RawContractError" }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 3
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = A;
  }
}
function getAction$1(s, A, u) {
  const p = s[A.name];
  if (typeof p == "function")
    return p;
  const t = s[u];
  return typeof t == "function" ? t : (l) => A(s, l);
}
class HttpRequestError extends BaseError$3 {
  constructor({ body: A, cause: u, details: p, headers: t, status: l, url: m }) {
    super("HTTP request failed.", {
      cause: u,
      details: p,
      metaMessages: [
        l && `Status: ${l}`,
        `URL: ${getUrl(m)}`,
        A && `Request body: ${stringify(A)}`
      ].filter(Boolean),
      name: "HttpRequestError"
    }), Object.defineProperty(this, "body", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "headers", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "status", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "url", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.body = A, this.headers = t, this.status = l, this.url = m;
  }
}
class RpcRequestError extends BaseError$3 {
  constructor({ body: A, error: u, url: p }) {
    super("RPC Request failed.", {
      cause: u,
      details: u.message,
      metaMessages: [`URL: ${getUrl(p)}`, `Request body: ${stringify(A)}`],
      name: "RpcRequestError"
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.code = u.code, this.data = u.data;
  }
}
const unknownErrorCode = -1;
class RpcError extends BaseError$3 {
  constructor(A, { code: u, docsPath: p, metaMessages: t, name: l, shortMessage: m }) {
    super(m, {
      cause: A,
      docsPath: p,
      metaMessages: t || (A == null ? void 0 : A.metaMessages),
      name: l || "RpcError"
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = l || A.name, this.code = A instanceof RpcRequestError ? A.code : u ?? unknownErrorCode;
  }
}
class InternalRpcError extends RpcError {
  constructor(A) {
    super(A, {
      code: InternalRpcError.code,
      name: "InternalRpcError",
      shortMessage: "An internal error was received."
    });
  }
}
Object.defineProperty(InternalRpcError, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32603
});
const EXECUTION_REVERTED_ERROR_CODE = 3;
function getContractError(s, { abi: A, address: u, args: p, docsPath: t, functionName: l, sender: m }) {
  const b = s instanceof RawContractError ? s : s instanceof BaseError$3 ? s.walk((M) => "data" in M) || s.walk() : {}, { code: k, data: C, details: B, message: Q, shortMessage: P } = b, x = s instanceof AbiDecodingZeroDataError ? new ContractFunctionZeroDataError({ functionName: l }) : [EXECUTION_REVERTED_ERROR_CODE, InternalRpcError.code].includes(k) && (C || B || Q || P) ? new ContractFunctionRevertedError({
    abi: A,
    data: typeof C == "object" ? C.data : C,
    functionName: l,
    message: b instanceof RpcRequestError ? B : P ?? Q
  }) : s;
  return new ContractFunctionExecutionError(x, {
    abi: A,
    args: p,
    contractAddress: u,
    docsPath: t,
    functionName: l,
    sender: m
  });
}
const version$1 = "0.1.1";
function getVersion$1() {
  return version$1;
}
let BaseError$1 = class w4 extends Error {
  constructor(A, u = {}) {
    const p = (() => {
      var k;
      if (u.cause instanceof w4) {
        if (u.cause.details)
          return u.cause.details;
        if (u.cause.shortMessage)
          return u.cause.shortMessage;
      }
      return u.cause && "details" in u.cause && typeof u.cause.details == "string" ? u.cause.details : (k = u.cause) != null && k.message ? u.cause.message : u.details;
    })(), t = u.cause instanceof w4 && u.cause.docsPath || u.docsPath, m = `https://oxlib.sh${t ?? ""}`, b = [
      A || "An error occurred.",
      ...u.metaMessages ? ["", ...u.metaMessages] : [],
      ...p || t ? [
        "",
        p ? `Details: ${p}` : void 0,
        t ? `See: ${m}` : void 0
      ] : []
    ].filter((k) => typeof k == "string").join(`
`);
    super(b, u.cause ? { cause: u.cause } : void 0), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docs", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BaseError"
    }), Object.defineProperty(this, "version", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: `ox@${getVersion$1()}`
    }), this.cause = u.cause, this.details = p, this.docs = m, this.docsPath = t, this.shortMessage = A;
  }
  walk(A) {
    return walk(this, A);
  }
};
function walk(s, A) {
  return A != null && A(s) ? s : s && typeof s == "object" && "cause" in s && s.cause ? walk(s.cause, A) : A ? null : s;
}
function pad(s, A = {}) {
  const { dir: u, size: p = 32 } = A;
  if (p === 0)
    return s;
  const t = s.replace("0x", "");
  if (t.length > p * 2)
    throw new SizeExceedsPaddingSizeError({
      size: Math.ceil(t.length / 2),
      targetSize: p,
      type: "Hex"
    });
  return `0x${t[u === "right" ? "padEnd" : "padStart"](p * 2, "0")}`;
}
function fromNumber(s, A = {}) {
  const { signed: u, size: p } = A, t = BigInt(s);
  let l;
  p ? u ? l = (1n << BigInt(p) * 8n - 1n) - 1n : l = 2n ** (BigInt(p) * 8n) - 1n : typeof s == "number" && (l = BigInt(Number.MAX_SAFE_INTEGER));
  const m = typeof l == "bigint" && u ? -l - 1n : 0;
  if (l && t > l || t < m) {
    const C = typeof s == "bigint" ? "n" : "";
    throw new IntegerOutOfRangeError({
      max: l ? `${l}${C}` : void 0,
      min: `${m}${C}`,
      signed: u,
      size: p,
      value: `${s}${C}`
    });
  }
  const k = `0x${(u && t < 0 ? (1n << BigInt(p * 8)) + BigInt(t) : t).toString(16)}`;
  return p ? padLeft(k, p) : k;
}
function padLeft(s, A) {
  return pad(s, { dir: "left", size: A });
}
class IntegerOutOfRangeError extends BaseError$1 {
  constructor({ max: A, min: u, signed: p, size: t, value: l }) {
    super(`Number \`${l}\` is not in safe${t ? ` ${t * 8}-bit` : ""}${p ? " signed" : " unsigned"} integer range ${A ? `(\`${u}\` to \`${A}\`)` : `(above \`${u}\`)`}`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "Hex.IntegerOutOfRangeError"
    });
  }
}
class SizeExceedsPaddingSizeError extends BaseError$1 {
  constructor({ size: A, targetSize: u, type: p }) {
    super(`${p.charAt(0).toUpperCase()}${p.slice(1).toLowerCase()} size (\`${A}\`) exceeds padding size (\`${u}\`).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "Hex.SizeExceedsPaddingSizeError"
    });
  }
}
function toRpc$1(s) {
  return {
    address: s.address,
    amount: fromNumber(s.amount),
    index: fromNumber(s.index),
    validatorIndex: fromNumber(s.validatorIndex)
  };
}
function toRpc(s) {
  return {
    ...typeof s.baseFeePerGas == "bigint" && {
      baseFeePerGas: fromNumber(s.baseFeePerGas)
    },
    ...typeof s.blobBaseFee == "bigint" && {
      blobBaseFee: fromNumber(s.blobBaseFee)
    },
    ...typeof s.feeRecipient == "string" && {
      feeRecipient: s.feeRecipient
    },
    ...typeof s.gasLimit == "bigint" && {
      gasLimit: fromNumber(s.gasLimit)
    },
    ...typeof s.number == "bigint" && {
      number: fromNumber(s.number)
    },
    ...typeof s.prevRandao == "bigint" && {
      prevRandao: fromNumber(s.prevRandao)
    },
    ...typeof s.time == "bigint" && {
      time: fromNumber(s.time)
    },
    ...s.withdrawals && {
      withdrawals: s.withdrawals.map(toRpc$1)
    }
  };
}
const aggregate3Signature = "0x82ad56cb", deploylessCallViaBytecodeBytecode = "0x608060405234801561001057600080fd5b5060405161018e38038061018e83398101604081905261002f91610124565b6000808351602085016000f59050803b61004857600080fd5b6000808351602085016000855af16040513d6000823e81610067573d81fd5b3d81f35b634e487b7160e01b600052604160045260246000fd5b600082601f83011261009257600080fd5b81516001600160401b038111156100ab576100ab61006b565b604051601f8201601f19908116603f011681016001600160401b03811182821017156100d9576100d961006b565b6040528181528382016020018510156100f157600080fd5b60005b82811015610110576020818601810151838301820152016100f4565b506000918101602001919091529392505050565b6000806040838503121561013757600080fd5b82516001600160401b0381111561014d57600080fd5b61015985828601610081565b602085015190935090506001600160401b0381111561017757600080fd5b61018385828601610081565b915050925092905056fe", deploylessCallViaFactoryBytecode = "0x608060405234801561001057600080fd5b506040516102c03803806102c083398101604081905261002f916101e6565b836001600160a01b03163b6000036100e457600080836001600160a01b03168360405161005c9190610270565b6000604051808303816000865af19150503d8060008114610099576040519150601f19603f3d011682016040523d82523d6000602084013e61009e565b606091505b50915091508115806100b857506001600160a01b0386163b155b156100e1578060405163101bb98d60e01b81526004016100d8919061028c565b60405180910390fd5b50505b6000808451602086016000885af16040513d6000823e81610103573d81fd5b3d81f35b80516001600160a01b038116811461011e57600080fd5b919050565b634e487b7160e01b600052604160045260246000fd5b60005b8381101561015457818101518382015260200161013c565b50506000910152565b600082601f83011261016e57600080fd5b81516001600160401b0381111561018757610187610123565b604051601f8201601f19908116603f011681016001600160401b03811182821017156101b5576101b5610123565b6040528181528382016020018510156101cd57600080fd5b6101de826020830160208701610139565b949350505050565b600080600080608085870312156101fc57600080fd5b61020585610107565b60208601519094506001600160401b0381111561022157600080fd5b61022d8782880161015d565b93505061023c60408601610107565b60608601519092506001600160401b0381111561025857600080fd5b6102648782880161015d565b91505092959194509250565b60008251610282818460208701610139565b9190910192915050565b60208152600082518060208401526102ab816040850160208701610139565b601f01601f1916919091016040019291505056fe", multicall3Bytecode = "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", docsPath = "/docs/contract/encodeDeployData";
function encodeDeployData(s) {
  const { abi: A, args: u, bytecode: p } = s;
  if (!u || u.length === 0)
    return p;
  const t = A.find((m) => "type" in m && m.type === "constructor");
  if (!t)
    throw new AbiConstructorNotFoundError({ docsPath });
  if (!("inputs" in t))
    throw new AbiConstructorParamsNotFoundError({ docsPath });
  if (!t.inputs || t.inputs.length === 0)
    throw new AbiConstructorParamsNotFoundError({ docsPath });
  const l = encodeAbiParameters(t.inputs, u);
  return concatHex([p, l]);
}
class ExecutionRevertedError extends BaseError$3 {
  constructor({ cause: A, message: u } = {}) {
    var t;
    const p = (t = u == null ? void 0 : u.replace("execution reverted: ", "")) == null ? void 0 : t.replace("execution reverted", "");
    super(`Execution reverted ${p ? `with reason: ${p}` : "for an unknown reason"}.`, {
      cause: A,
      name: "ExecutionRevertedError"
    });
  }
}
Object.defineProperty(ExecutionRevertedError, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 3
});
Object.defineProperty(ExecutionRevertedError, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /execution reverted/
});
class FeeCapTooHighError extends BaseError$3 {
  constructor({ cause: A, maxFeePerGas: u } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${u ? ` = ${formatGwei(u)} gwei` : ""}) cannot be higher than the maximum allowed value (2^256-1).`, {
      cause: A,
      name: "FeeCapTooHighError"
    });
  }
}
Object.defineProperty(FeeCapTooHighError, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
class FeeCapTooLowError extends BaseError$3 {
  constructor({ cause: A, maxFeePerGas: u } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${u ? ` = ${formatGwei(u)}` : ""} gwei) cannot be lower than the block base fee.`, {
      cause: A,
      name: "FeeCapTooLowError"
    });
  }
}
Object.defineProperty(FeeCapTooLowError, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max fee per gas less than block base fee|fee cap less than block base fee|transaction is outdated/
});
class NonceTooHighError extends BaseError$3 {
  constructor({ cause: A, nonce: u } = {}) {
    super(`Nonce provided for the transaction ${u ? `(${u}) ` : ""}is higher than the next one expected.`, { cause: A, name: "NonceTooHighError" });
  }
}
Object.defineProperty(NonceTooHighError, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce too high/
});
class NonceTooLowError extends BaseError$3 {
  constructor({ cause: A, nonce: u } = {}) {
    super([
      `Nonce provided for the transaction ${u ? `(${u}) ` : ""}is lower than the current nonce of the account.`,
      "Try increasing the nonce or find the latest nonce with `getTransactionCount`."
    ].join(`
`), { cause: A, name: "NonceTooLowError" });
  }
}
Object.defineProperty(NonceTooLowError, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce too low|transaction already imported|already known/
});
class NonceMaxValueError extends BaseError$3 {
  constructor({ cause: A, nonce: u } = {}) {
    super(`Nonce provided for the transaction ${u ? `(${u}) ` : ""}exceeds the maximum allowed nonce.`, { cause: A, name: "NonceMaxValueError" });
  }
}
Object.defineProperty(NonceMaxValueError, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce has max value/
});
class InsufficientFundsError extends BaseError$3 {
  constructor({ cause: A } = {}) {
    super([
      "The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account."
    ].join(`
`), {
      cause: A,
      metaMessages: [
        "This error could arise when the account does not have enough funds to:",
        " - pay for the total gas fee,",
        " - pay for the value to send.",
        " ",
        "The cost of the transaction is calculated as `gas * gas fee + value`, where:",
        " - `gas` is the amount of gas needed for transaction to execute,",
        " - `gas fee` is the gas fee,",
        " - `value` is the amount of ether to send to the recipient."
      ],
      name: "InsufficientFundsError"
    });
  }
}
Object.defineProperty(InsufficientFundsError, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /insufficient funds|exceeds transaction sender account balance/
});
class IntrinsicGasTooHighError extends BaseError$3 {
  constructor({ cause: A, gas: u } = {}) {
    super(`The amount of gas ${u ? `(${u}) ` : ""}provided for the transaction exceeds the limit allowed for the block.`, {
      cause: A,
      name: "IntrinsicGasTooHighError"
    });
  }
}
Object.defineProperty(IntrinsicGasTooHighError, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /intrinsic gas too high|gas limit reached/
});
class IntrinsicGasTooLowError extends BaseError$3 {
  constructor({ cause: A, gas: u } = {}) {
    super(`The amount of gas ${u ? `(${u}) ` : ""}provided for the transaction is too low.`, {
      cause: A,
      name: "IntrinsicGasTooLowError"
    });
  }
}
Object.defineProperty(IntrinsicGasTooLowError, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /intrinsic gas too low/
});
class TransactionTypeNotSupportedError extends BaseError$3 {
  constructor({ cause: A }) {
    super("The transaction type is not supported for this chain.", {
      cause: A,
      name: "TransactionTypeNotSupportedError"
    });
  }
}
Object.defineProperty(TransactionTypeNotSupportedError, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /transaction type not valid/
});
class TipAboveFeeCapError extends BaseError$3 {
  constructor({ cause: A, maxPriorityFeePerGas: u, maxFeePerGas: p } = {}) {
    super([
      `The provided tip (\`maxPriorityFeePerGas\`${u ? ` = ${formatGwei(u)} gwei` : ""}) cannot be higher than the fee cap (\`maxFeePerGas\`${p ? ` = ${formatGwei(p)} gwei` : ""}).`
    ].join(`
`), {
      cause: A,
      name: "TipAboveFeeCapError"
    });
  }
}
Object.defineProperty(TipAboveFeeCapError, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});
class UnknownNodeError extends BaseError$3 {
  constructor({ cause: A }) {
    super(`An error occurred while executing: ${A == null ? void 0 : A.shortMessage}`, {
      cause: A,
      name: "UnknownNodeError"
    });
  }
}
function getNodeError(s, A) {
  const u = (s.details || "").toLowerCase(), p = s instanceof BaseError$3 ? s.walk((t) => (t == null ? void 0 : t.code) === ExecutionRevertedError.code) : s;
  return p instanceof BaseError$3 ? new ExecutionRevertedError({
    cause: s,
    message: p.details
  }) : ExecutionRevertedError.nodeMessage.test(u) ? new ExecutionRevertedError({
    cause: s,
    message: s.details
  }) : FeeCapTooHighError.nodeMessage.test(u) ? new FeeCapTooHighError({
    cause: s,
    maxFeePerGas: A == null ? void 0 : A.maxFeePerGas
  }) : FeeCapTooLowError.nodeMessage.test(u) ? new FeeCapTooLowError({
    cause: s,
    maxFeePerGas: A == null ? void 0 : A.maxFeePerGas
  }) : NonceTooHighError.nodeMessage.test(u) ? new NonceTooHighError({ cause: s, nonce: A == null ? void 0 : A.nonce }) : NonceTooLowError.nodeMessage.test(u) ? new NonceTooLowError({ cause: s, nonce: A == null ? void 0 : A.nonce }) : NonceMaxValueError.nodeMessage.test(u) ? new NonceMaxValueError({ cause: s, nonce: A == null ? void 0 : A.nonce }) : InsufficientFundsError.nodeMessage.test(u) ? new InsufficientFundsError({ cause: s }) : IntrinsicGasTooHighError.nodeMessage.test(u) ? new IntrinsicGasTooHighError({ cause: s, gas: A == null ? void 0 : A.gas }) : IntrinsicGasTooLowError.nodeMessage.test(u) ? new IntrinsicGasTooLowError({ cause: s, gas: A == null ? void 0 : A.gas }) : TransactionTypeNotSupportedError.nodeMessage.test(u) ? new TransactionTypeNotSupportedError({ cause: s }) : TipAboveFeeCapError.nodeMessage.test(u) ? new TipAboveFeeCapError({
    cause: s,
    maxFeePerGas: A == null ? void 0 : A.maxFeePerGas,
    maxPriorityFeePerGas: A == null ? void 0 : A.maxPriorityFeePerGas
  }) : new UnknownNodeError({
    cause: s
  });
}
function getCallError(s, { docsPath: A, ...u }) {
  const p = (() => {
    const t = getNodeError(s, u);
    return t instanceof UnknownNodeError ? s : t;
  })();
  return new CallExecutionError(p, {
    docsPath: A,
    ...u
  });
}
function extract(s, { format: A }) {
  if (!A)
    return {};
  const u = {};
  function p(l) {
    const m = Object.keys(l);
    for (const b of m)
      b in s && (u[b] = s[b]), l[b] && typeof l[b] == "object" && !Array.isArray(l[b]) && p(l[b]);
  }
  const t = A(s || {});
  return p(t), u;
}
const rpcTransactionType = {
  legacy: "0x0",
  eip2930: "0x1",
  eip1559: "0x2",
  eip4844: "0x3",
  eip7702: "0x4"
};
function formatTransactionRequest(s, A) {
  const u = {};
  return typeof s.authorizationList < "u" && (u.authorizationList = formatAuthorizationList$1(s.authorizationList)), typeof s.accessList < "u" && (u.accessList = s.accessList), typeof s.blobVersionedHashes < "u" && (u.blobVersionedHashes = s.blobVersionedHashes), typeof s.blobs < "u" && (typeof s.blobs[0] != "string" ? u.blobs = s.blobs.map((p) => bytesToHex(p)) : u.blobs = s.blobs), typeof s.data < "u" && (u.data = s.data), typeof s.from < "u" && (u.from = s.from), typeof s.gas < "u" && (u.gas = numberToHex(s.gas)), typeof s.gasPrice < "u" && (u.gasPrice = numberToHex(s.gasPrice)), typeof s.maxFeePerBlobGas < "u" && (u.maxFeePerBlobGas = numberToHex(s.maxFeePerBlobGas)), typeof s.maxFeePerGas < "u" && (u.maxFeePerGas = numberToHex(s.maxFeePerGas)), typeof s.maxPriorityFeePerGas < "u" && (u.maxPriorityFeePerGas = numberToHex(s.maxPriorityFeePerGas)), typeof s.nonce < "u" && (u.nonce = numberToHex(s.nonce)), typeof s.to < "u" && (u.to = s.to), typeof s.type < "u" && (u.type = rpcTransactionType[s.type]), typeof s.value < "u" && (u.value = numberToHex(s.value)), u;
}
function formatAuthorizationList$1(s) {
  return s.map((A) => ({
    address: A.address,
    r: A.r ? numberToHex(BigInt(A.r)) : A.r,
    s: A.s ? numberToHex(BigInt(A.s)) : A.s,
    chainId: numberToHex(A.chainId),
    nonce: numberToHex(A.nonce),
    ...typeof A.yParity < "u" ? { yParity: numberToHex(A.yParity) } : {},
    ...typeof A.v < "u" && typeof A.yParity > "u" ? { v: numberToHex(A.v) } : {}
  }));
}
function withResolvers() {
  let s = () => {
  }, A = () => {
  };
  return { promise: new Promise((p, t) => {
    s = p, A = t;
  }), resolve: s, reject: A };
}
const schedulerCache = /* @__PURE__ */ new Map();
function createBatchScheduler({ fn: s, id: A, shouldSplitBatch: u, wait: p = 0, sort: t }) {
  const l = async () => {
    const B = k();
    m();
    const Q = B.map(({ args: P }) => P);
    Q.length !== 0 && s(Q).then((P) => {
      t && Array.isArray(P) && P.sort(t);
      for (let x = 0; x < B.length; x++) {
        const { resolve: M } = B[x];
        M == null || M([P[x], P]);
      }
    }).catch((P) => {
      for (let x = 0; x < B.length; x++) {
        const { reject: M } = B[x];
        M == null || M(P);
      }
    });
  }, m = () => schedulerCache.delete(A), b = () => k().map(({ args: B }) => B), k = () => schedulerCache.get(A) || [], C = (B) => schedulerCache.set(A, [...k(), B]);
  return {
    flush: m,
    async schedule(B) {
      const { promise: Q, resolve: P, reject: x } = withResolvers();
      return (u == null ? void 0 : u([...b(), B])) && l(), k().length > 0 ? (C({ args: B, resolve: P, reject: x }), Q) : (C({ args: B, resolve: P, reject: x }), setTimeout(l, p), Q);
    }
  };
}
function serializeStateMapping(s) {
  if (!(!s || s.length === 0))
    return s.reduce((A, { slot: u, value: p }) => {
      if (u.length !== 66)
        throw new InvalidBytesLengthError({
          size: u.length,
          targetSize: 66,
          type: "hex"
        });
      if (p.length !== 66)
        throw new InvalidBytesLengthError({
          size: p.length,
          targetSize: 66,
          type: "hex"
        });
      return A[u] = p, A;
    }, {});
}
function serializeAccountStateOverride(s) {
  const { balance: A, nonce: u, state: p, stateDiff: t, code: l } = s, m = {};
  if (l !== void 0 && (m.code = l), A !== void 0 && (m.balance = numberToHex(A)), u !== void 0 && (m.nonce = numberToHex(u)), p !== void 0 && (m.state = serializeStateMapping(p)), t !== void 0) {
    if (m.state)
      throw new StateAssignmentConflictError();
    m.stateDiff = serializeStateMapping(t);
  }
  return m;
}
function serializeStateOverride(s) {
  if (!s)
    return;
  const A = {};
  for (const { address: u, ...p } of s) {
    if (!isAddress(u, { strict: !1 }))
      throw new InvalidAddressError({ address: u });
    if (A[u])
      throw new AccountStateConflictError({ address: u });
    A[u] = serializeAccountStateOverride(p);
  }
  return A;
}
const maxUint256 = 2n ** 256n - 1n;
function assertRequest(s) {
  const { account: A, gasPrice: u, maxFeePerGas: p, maxPriorityFeePerGas: t, to: l } = s, m = A ? parseAccount(A) : void 0;
  if (m && !isAddress(m.address))
    throw new InvalidAddressError({ address: m.address });
  if (l && !isAddress(l))
    throw new InvalidAddressError({ address: l });
  if (typeof u < "u" && (typeof p < "u" || typeof t < "u"))
    throw new FeeConflictError();
  if (p && p > maxUint256)
    throw new FeeCapTooHighError({ maxFeePerGas: p });
  if (t && p && t > p)
    throw new TipAboveFeeCapError({ maxFeePerGas: p, maxPriorityFeePerGas: t });
}
async function call(s, A) {
  var Ce, Se, Ne, rr;
  const { account: u = s.account, authorizationList: p, batch: t = !!((Ce = s.batch) != null && Ce.multicall), blockNumber: l, blockTag: m = s.experimental_blockTag ?? "latest", accessList: b, blobs: k, blockOverrides: C, code: B, data: Q, factory: P, factoryData: x, gas: M, gasPrice: F, maxFeePerBlobGas: le, maxFeePerGas: ge, maxPriorityFeePerGas: pe, nonce: Ie, to: be, value: Pe, stateOverride: Te, ...Qe } = A, xe = u ? parseAccount(u) : void 0;
  if (B && (P || x))
    throw new BaseError$3("Cannot provide both `code` & `factory`/`factoryData` as parameters.");
  if (B && be)
    throw new BaseError$3("Cannot provide both `code` & `to` as parameters.");
  const Ee = B && Q, He = P && x && be && Q, ve = Ee || He, we = Ee ? toDeploylessCallViaBytecodeData({
    code: B,
    data: Q
  }) : He ? toDeploylessCallViaFactoryData({
    data: Q,
    factory: P,
    factoryData: x,
    to: be
  }) : Q;
  try {
    assertRequest(A);
    const ir = (typeof l == "bigint" ? numberToHex(l) : void 0) || m, sr = C ? toRpc(C) : void 0, nr = serializeStateOverride(Te), fr = (rr = (Ne = (Se = s.chain) == null ? void 0 : Se.formatters) == null ? void 0 : Ne.transactionRequest) == null ? void 0 : rr.format, br = (fr || formatTransactionRequest)({
      // Pick out extra data that might exist on the chain's transaction request type.
      ...extract(Qe, { format: fr }),
      from: xe == null ? void 0 : xe.address,
      accessList: b,
      authorizationList: p,
      blobs: k,
      data: we,
      gas: M,
      gasPrice: F,
      maxFeePerBlobGas: le,
      maxFeePerGas: ge,
      maxPriorityFeePerGas: pe,
      nonce: Ie,
      to: ve ? void 0 : be,
      value: Pe
    }, "call");
    if (t && shouldPerformMulticall({ request: br }) && !nr && !sr)
      try {
        return await scheduleMulticall(s, {
          ...br,
          blockNumber: l,
          blockTag: m
        });
      } catch (Gr) {
        if (!(Gr instanceof ClientChainNotConfiguredError) && !(Gr instanceof ChainDoesNotSupportContract))
          throw Gr;
      }
    const Br = (() => {
      const Gr = [
        br,
        ir
      ];
      return nr && sr ? [...Gr, nr, sr] : nr ? [...Gr, nr] : sr ? [...Gr, {}, sr] : Gr;
    })(), Fr = await s.request({
      method: "eth_call",
      params: Br
    });
    return Fr === "0x" ? { data: void 0 } : { data: Fr };
  } catch (er) {
    const ir = getRevertErrorData(er), { offchainLookup: sr, offchainLookupSignature: nr } = await import("./ccip-DQQjip18.js");
    if (s.ccipRead !== !1 && (ir == null ? void 0 : ir.slice(0, 10)) === nr && be)
      return { data: await sr(s, { data: ir, to: be }) };
    throw ve && (ir == null ? void 0 : ir.slice(0, 10)) === "0x101bb98d" ? new CounterfactualDeploymentFailedError({ factory: P }) : getCallError(er, {
      ...A,
      account: xe,
      chain: s.chain
    });
  }
}
function shouldPerformMulticall({ request: s }) {
  const { data: A, to: u, ...p } = s;
  return !(!A || A.startsWith(aggregate3Signature) || !u || Object.values(p).filter((t) => typeof t < "u").length > 0);
}
async function scheduleMulticall(s, A) {
  var F;
  const { batchSize: u = 1024, deployless: p = !1, wait: t = 0 } = typeof ((F = s.batch) == null ? void 0 : F.multicall) == "object" ? s.batch.multicall : {}, { blockNumber: l, blockTag: m = s.experimental_blockTag ?? "latest", data: b, to: k } = A, C = (() => {
    if (p)
      return null;
    if (A.multicallAddress)
      return A.multicallAddress;
    if (s.chain)
      return getChainContractAddress({
        blockNumber: l,
        chain: s.chain,
        contract: "multicall3"
      });
    throw new ClientChainNotConfiguredError();
  })(), Q = (typeof l == "bigint" ? numberToHex(l) : void 0) || m, { schedule: P } = createBatchScheduler({
    id: `${s.uid}.${Q}`,
    wait: t,
    shouldSplitBatch(le) {
      return le.reduce((pe, { data: Ie }) => pe + (Ie.length - 2), 0) > u * 2;
    },
    fn: async (le) => {
      const ge = le.map((be) => ({
        allowFailure: !0,
        callData: be.data,
        target: be.to
      })), pe = encodeFunctionData({
        abi: multicall3Abi,
        args: [ge],
        functionName: "aggregate3"
      }), Ie = await s.request({
        method: "eth_call",
        params: [
          {
            ...C === null ? {
              data: toDeploylessCallViaBytecodeData({
                code: multicall3Bytecode,
                data: pe
              })
            } : { to: C, data: pe }
          },
          Q
        ]
      });
      return decodeFunctionResult({
        abi: multicall3Abi,
        args: [ge],
        functionName: "aggregate3",
        data: Ie || "0x"
      });
    }
  }), [{ returnData: x, success: M }] = await P({ data: b, to: k });
  if (!M)
    throw new RawContractError({ data: x });
  return x === "0x" ? { data: void 0 } : { data: x };
}
function toDeploylessCallViaBytecodeData(s) {
  const { code: A, data: u } = s;
  return encodeDeployData({
    abi: parseAbi(["constructor(bytes, bytes)"]),
    bytecode: deploylessCallViaBytecodeBytecode,
    args: [A, u]
  });
}
function toDeploylessCallViaFactoryData(s) {
  const { data: A, factory: u, factoryData: p, to: t } = s;
  return encodeDeployData({
    abi: parseAbi(["constructor(address, bytes, address, bytes)"]),
    bytecode: deploylessCallViaFactoryBytecode,
    args: [t, A, u, p]
  });
}
function getRevertErrorData(s) {
  var u;
  if (!(s instanceof BaseError$3))
    return;
  const A = s.walk();
  return typeof (A == null ? void 0 : A.data) == "object" ? (u = A.data) == null ? void 0 : u.data : A.data;
}
async function readContract$1(s, A) {
  const { abi: u, address: p, args: t, functionName: l, ...m } = A, b = encodeFunctionData({
    abi: u,
    args: t,
    functionName: l
  });
  try {
    const { data: k } = await getAction$1(s, call, "call")({
      ...m,
      data: b,
      to: p
    });
    return decodeFunctionResult({
      abi: u,
      args: t,
      functionName: l,
      data: k || "0x"
    });
  } catch (k) {
    throw getContractError(k, {
      abi: u,
      address: p,
      args: t,
      docsPath: "/docs/contract/readContract",
      functionName: l
    });
  }
}
function publicKeyToAddress(s) {
  const A = keccak256(`0x${s.substring(4)}`).substring(26);
  return checksumAddress(`0x${A}`);
}
async function recoverPublicKey({ hash: s, signature: A }) {
  const u = isHex(s) ? s : toHex(s), { secp256k1: p } = await import("./secp256k1-Ed1TXo0c.js");
  return `0x${(() => {
    if (typeof A == "object" && "r" in A && "s" in A) {
      const { r: C, s: B, v: Q, yParity: P } = A, x = Number(P ?? Q), M = toRecoveryBit(x);
      return new p.Signature(hexToBigInt(C), hexToBigInt(B)).addRecoveryBit(M);
    }
    const m = isHex(A) ? A : toHex(A);
    if (size(m) !== 65)
      throw new Error("invalid signature length");
    const b = hexToNumber(`0x${m.slice(130)}`), k = toRecoveryBit(b);
    return p.Signature.fromCompact(m.substring(2, 130)).addRecoveryBit(k);
  })().recoverPublicKey(u.substring(2)).toHex(!1)}`;
}
function toRecoveryBit(s) {
  if (s === 0 || s === 1)
    return s;
  if (s === 27)
    return 0;
  if (s === 28)
    return 1;
  throw new Error("Invalid yParityOrV value");
}
async function recoverAddress({ hash: s, signature: A }) {
  return publicKeyToAddress(await recoverPublicKey({ hash: s, signature: A }));
}
function toRlp(s, A = "hex") {
  const u = getEncodable(s), p = createCursor(new Uint8Array(u.length));
  return u.encode(p), A === "hex" ? bytesToHex(p.bytes) : p.bytes;
}
function getEncodable(s) {
  return Array.isArray(s) ? getEncodableList(s.map((A) => getEncodable(A))) : getEncodableBytes(s);
}
function getEncodableList(s) {
  const A = s.reduce((t, l) => t + l.length, 0), u = getSizeOfLength(A);
  return {
    length: A <= 55 ? 1 + A : 1 + u + A,
    encode(t) {
      A <= 55 ? t.pushByte(192 + A) : (t.pushByte(247 + u), u === 1 ? t.pushUint8(A) : u === 2 ? t.pushUint16(A) : u === 3 ? t.pushUint24(A) : t.pushUint32(A));
      for (const { encode: l } of s)
        l(t);
    }
  };
}
function getEncodableBytes(s) {
  const A = typeof s == "string" ? hexToBytes(s) : s, u = getSizeOfLength(A.length);
  return {
    length: A.length === 1 && A[0] < 128 ? 1 : A.length <= 55 ? 1 + A.length : 1 + u + A.length,
    encode(t) {
      A.length === 1 && A[0] < 128 ? t.pushBytes(A) : A.length <= 55 ? (t.pushByte(128 + A.length), t.pushBytes(A)) : (t.pushByte(183 + u), u === 1 ? t.pushUint8(A.length) : u === 2 ? t.pushUint16(A.length) : u === 3 ? t.pushUint24(A.length) : t.pushUint32(A.length), t.pushBytes(A));
    }
  };
}
function getSizeOfLength(s) {
  if (s < 2 ** 8)
    return 1;
  if (s < 2 ** 16)
    return 2;
  if (s < 2 ** 24)
    return 3;
  if (s < 2 ** 32)
    return 4;
  throw new BaseError$3("Length is too large.");
}
function hashAuthorization(s) {
  const { chainId: A, nonce: u, to: p } = s, t = s.contractAddress ?? s.address, l = keccak256(concatHex([
    "0x05",
    toRlp([
      A ? numberToHex(A) : "0x",
      t,
      u ? numberToHex(u) : "0x"
    ])
  ]));
  return p === "bytes" ? hexToBytes(l) : l;
}
async function recoverAuthorizationAddress(s) {
  const { authorization: A, signature: u } = s;
  return recoverAddress({
    hash: hashAuthorization(A),
    signature: u ?? A
  });
}
class EstimateGasExecutionError extends BaseError$3 {
  constructor(A, { account: u, docsPath: p, chain: t, data: l, gas: m, gasPrice: b, maxFeePerGas: k, maxPriorityFeePerGas: C, nonce: B, to: Q, value: P }) {
    var M;
    const x = prettyPrint({
      from: u == null ? void 0 : u.address,
      to: Q,
      value: typeof P < "u" && `${formatEther(P)} ${((M = t == null ? void 0 : t.nativeCurrency) == null ? void 0 : M.symbol) || "ETH"}`,
      data: l,
      gas: m,
      gasPrice: typeof b < "u" && `${formatGwei(b)} gwei`,
      maxFeePerGas: typeof k < "u" && `${formatGwei(k)} gwei`,
      maxPriorityFeePerGas: typeof C < "u" && `${formatGwei(C)} gwei`,
      nonce: B
    });
    super(A.shortMessage, {
      cause: A,
      docsPath: p,
      metaMessages: [
        ...A.metaMessages ? [...A.metaMessages, " "] : [],
        "Estimate Gas Arguments:",
        x
      ].filter(Boolean),
      name: "EstimateGasExecutionError"
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.cause = A;
  }
}
function getEstimateGasError(s, { docsPath: A, ...u }) {
  const p = (() => {
    const t = getNodeError(s, u);
    return t instanceof UnknownNodeError ? s : t;
  })();
  return new EstimateGasExecutionError(p, {
    docsPath: A,
    ...u
  });
}
class BaseFeeScalarError extends BaseError$3 {
  constructor() {
    super("`baseFeeMultiplier` must be greater than 1.", {
      name: "BaseFeeScalarError"
    });
  }
}
class Eip1559FeesNotSupportedError extends BaseError$3 {
  constructor() {
    super("Chain does not support EIP-1559 fees.", {
      name: "Eip1559FeesNotSupportedError"
    });
  }
}
class MaxFeePerGasTooLowError extends BaseError$3 {
  constructor({ maxPriorityFeePerGas: A }) {
    super(`\`maxFeePerGas\` cannot be less than the \`maxPriorityFeePerGas\` (${formatGwei(A)} gwei).`, { name: "MaxFeePerGasTooLowError" });
  }
}
class BlockNotFoundError extends BaseError$3 {
  constructor({ blockHash: A, blockNumber: u }) {
    let p = "Block";
    A && (p = `Block at hash "${A}"`), u && (p = `Block at number "${u}"`), super(`${p} could not be found.`, { name: "BlockNotFoundError" });
  }
}
const transactionType = {
  "0x0": "legacy",
  "0x1": "eip2930",
  "0x2": "eip1559",
  "0x3": "eip4844",
  "0x4": "eip7702"
};
function formatTransaction(s, A) {
  const u = {
    ...s,
    blockHash: s.blockHash ? s.blockHash : null,
    blockNumber: s.blockNumber ? BigInt(s.blockNumber) : null,
    chainId: s.chainId ? hexToNumber(s.chainId) : void 0,
    gas: s.gas ? BigInt(s.gas) : void 0,
    gasPrice: s.gasPrice ? BigInt(s.gasPrice) : void 0,
    maxFeePerBlobGas: s.maxFeePerBlobGas ? BigInt(s.maxFeePerBlobGas) : void 0,
    maxFeePerGas: s.maxFeePerGas ? BigInt(s.maxFeePerGas) : void 0,
    maxPriorityFeePerGas: s.maxPriorityFeePerGas ? BigInt(s.maxPriorityFeePerGas) : void 0,
    nonce: s.nonce ? hexToNumber(s.nonce) : void 0,
    to: s.to ? s.to : null,
    transactionIndex: s.transactionIndex ? Number(s.transactionIndex) : null,
    type: s.type ? transactionType[s.type] : void 0,
    typeHex: s.type ? s.type : void 0,
    value: s.value ? BigInt(s.value) : void 0,
    v: s.v ? BigInt(s.v) : void 0
  };
  return s.authorizationList && (u.authorizationList = formatAuthorizationList(s.authorizationList)), u.yParity = (() => {
    if (s.yParity)
      return Number(s.yParity);
    if (typeof u.v == "bigint") {
      if (u.v === 0n || u.v === 27n)
        return 0;
      if (u.v === 1n || u.v === 28n)
        return 1;
      if (u.v >= 35n)
        return u.v % 2n === 0n ? 1 : 0;
    }
  })(), u.type === "legacy" && (delete u.accessList, delete u.maxFeePerBlobGas, delete u.maxFeePerGas, delete u.maxPriorityFeePerGas, delete u.yParity), u.type === "eip2930" && (delete u.maxFeePerBlobGas, delete u.maxFeePerGas, delete u.maxPriorityFeePerGas), u.type === "eip1559" && delete u.maxFeePerBlobGas, u;
}
function formatAuthorizationList(s) {
  return s.map((A) => ({
    address: A.address,
    chainId: Number(A.chainId),
    nonce: Number(A.nonce),
    r: A.r,
    s: A.s,
    yParity: Number(A.yParity)
  }));
}
function formatBlock(s, A) {
  const u = (s.transactions ?? []).map((p) => typeof p == "string" ? p : formatTransaction(p));
  return {
    ...s,
    baseFeePerGas: s.baseFeePerGas ? BigInt(s.baseFeePerGas) : null,
    blobGasUsed: s.blobGasUsed ? BigInt(s.blobGasUsed) : void 0,
    difficulty: s.difficulty ? BigInt(s.difficulty) : void 0,
    excessBlobGas: s.excessBlobGas ? BigInt(s.excessBlobGas) : void 0,
    gasLimit: s.gasLimit ? BigInt(s.gasLimit) : void 0,
    gasUsed: s.gasUsed ? BigInt(s.gasUsed) : void 0,
    hash: s.hash ? s.hash : null,
    logsBloom: s.logsBloom ? s.logsBloom : null,
    nonce: s.nonce ? s.nonce : null,
    number: s.number ? BigInt(s.number) : null,
    size: s.size ? BigInt(s.size) : void 0,
    timestamp: s.timestamp ? BigInt(s.timestamp) : void 0,
    transactions: u,
    totalDifficulty: s.totalDifficulty ? BigInt(s.totalDifficulty) : null
  };
}
async function getBlock(s, { blockHash: A, blockNumber: u, blockTag: p = s.experimental_blockTag ?? "latest", includeTransactions: t } = {}) {
  var C, B, Q;
  const l = t ?? !1, m = u !== void 0 ? numberToHex(u) : void 0;
  let b = null;
  if (A ? b = await s.request({
    method: "eth_getBlockByHash",
    params: [A, l]
  }, { dedupe: !0 }) : b = await s.request({
    method: "eth_getBlockByNumber",
    params: [m || p, l]
  }, { dedupe: !!m }), !b)
    throw new BlockNotFoundError({ blockHash: A, blockNumber: u });
  return (((Q = (B = (C = s.chain) == null ? void 0 : C.formatters) == null ? void 0 : B.block) == null ? void 0 : Q.format) || formatBlock)(b, "getBlock");
}
async function getGasPrice(s) {
  const A = await s.request({
    method: "eth_gasPrice"
  });
  return BigInt(A);
}
async function internal_estimateMaxPriorityFeePerGas(s, A) {
  var l, m;
  const { block: u, chain: p = s.chain, request: t } = A || {};
  try {
    const b = ((l = p == null ? void 0 : p.fees) == null ? void 0 : l.maxPriorityFeePerGas) ?? ((m = p == null ? void 0 : p.fees) == null ? void 0 : m.defaultPriorityFee);
    if (typeof b == "function") {
      const C = u || await getAction$1(s, getBlock, "getBlock")({}), B = await b({
        block: C,
        client: s,
        request: t
      });
      if (B === null)
        throw new Error();
      return B;
    }
    if (typeof b < "u")
      return b;
    const k = await s.request({
      method: "eth_maxPriorityFeePerGas"
    });
    return hexToBigInt(k);
  } catch {
    const [b, k] = await Promise.all([
      u ? Promise.resolve(u) : getAction$1(s, getBlock, "getBlock")({}),
      getAction$1(s, getGasPrice, "getGasPrice")({})
    ]);
    if (typeof b.baseFeePerGas != "bigint")
      throw new Eip1559FeesNotSupportedError();
    const C = k - b.baseFeePerGas;
    return C < 0n ? 0n : C;
  }
}
async function internal_estimateFeesPerGas(s, A) {
  var P, x;
  const { block: u, chain: p = s.chain, request: t, type: l = "eip1559" } = A || {}, m = await (async () => {
    var M, F;
    return typeof ((M = p == null ? void 0 : p.fees) == null ? void 0 : M.baseFeeMultiplier) == "function" ? p.fees.baseFeeMultiplier({
      block: u,
      client: s,
      request: t
    }) : ((F = p == null ? void 0 : p.fees) == null ? void 0 : F.baseFeeMultiplier) ?? 1.2;
  })();
  if (m < 1)
    throw new BaseFeeScalarError();
  const k = 10 ** (((P = m.toString().split(".")[1]) == null ? void 0 : P.length) ?? 0), C = (M) => M * BigInt(Math.ceil(m * k)) / BigInt(k), B = u || await getAction$1(s, getBlock, "getBlock")({});
  if (typeof ((x = p == null ? void 0 : p.fees) == null ? void 0 : x.estimateFeesPerGas) == "function") {
    const M = await p.fees.estimateFeesPerGas({
      block: u,
      client: s,
      multiply: C,
      request: t,
      type: l
    });
    if (M !== null)
      return M;
  }
  if (l === "eip1559") {
    if (typeof B.baseFeePerGas != "bigint")
      throw new Eip1559FeesNotSupportedError();
    const M = typeof (t == null ? void 0 : t.maxPriorityFeePerGas) == "bigint" ? t.maxPriorityFeePerGas : await internal_estimateMaxPriorityFeePerGas(s, {
      block: B,
      chain: p,
      request: t
    }), F = C(B.baseFeePerGas);
    return {
      maxFeePerGas: (t == null ? void 0 : t.maxFeePerGas) ?? F + M,
      maxPriorityFeePerGas: M
    };
  }
  return {
    gasPrice: (t == null ? void 0 : t.gasPrice) ?? C(await getAction$1(s, getGasPrice, "getGasPrice")({}))
  };
}
async function getTransactionCount$1(s, { address: A, blockTag: u = "latest", blockNumber: p }) {
  const t = await s.request({
    method: "eth_getTransactionCount",
    params: [
      A,
      typeof p == "bigint" ? numberToHex(p) : u
    ]
  }, {
    dedupe: !!p
  });
  return hexToNumber(t);
}
function blobsToCommitments(s) {
  const { kzg: A } = s, u = s.to ?? (typeof s.blobs[0] == "string" ? "hex" : "bytes"), p = typeof s.blobs[0] == "string" ? s.blobs.map((l) => hexToBytes(l)) : s.blobs, t = [];
  for (const l of p)
    t.push(Uint8Array.from(A.blobToKzgCommitment(l)));
  return u === "bytes" ? t : t.map((l) => bytesToHex(l));
}
function blobsToProofs(s) {
  const { kzg: A } = s, u = s.to ?? (typeof s.blobs[0] == "string" ? "hex" : "bytes"), p = typeof s.blobs[0] == "string" ? s.blobs.map((m) => hexToBytes(m)) : s.blobs, t = typeof s.commitments[0] == "string" ? s.commitments.map((m) => hexToBytes(m)) : s.commitments, l = [];
  for (let m = 0; m < p.length; m++) {
    const b = p[m], k = t[m];
    l.push(Uint8Array.from(A.computeBlobKzgProof(b, k)));
  }
  return u === "bytes" ? l : l.map((m) => bytesToHex(m));
}
const sha256$1 = sha256$2;
function sha256(s, A) {
  return sha256$1(isHex(s, { strict: !1 }) ? toBytes(s) : s);
}
function commitmentToVersionedHash(s) {
  const { commitment: A, version: u = 1 } = s, p = s.to ?? (typeof A == "string" ? "hex" : "bytes"), t = sha256(A);
  return t.set([u], 0), p === "bytes" ? t : bytesToHex(t);
}
function commitmentsToVersionedHashes(s) {
  const { commitments: A, version: u } = s, p = s.to, t = [];
  for (const l of A)
    t.push(commitmentToVersionedHash({
      commitment: l,
      to: p,
      version: u
    }));
  return t;
}
const blobsPerTransaction = 6, bytesPerFieldElement = 32, fieldElementsPerBlob = 4096, bytesPerBlob = bytesPerFieldElement * fieldElementsPerBlob, maxBytesPerTransaction = bytesPerBlob * blobsPerTransaction - // terminator byte (0x80).
1 - // zero byte (0x00) appended to each field element.
1 * fieldElementsPerBlob * blobsPerTransaction;
class BlobSizeTooLargeError extends BaseError$3 {
  constructor({ maxSize: A, size: u }) {
    super("Blob size is too large.", {
      metaMessages: [`Max: ${A} bytes`, `Given: ${u} bytes`],
      name: "BlobSizeTooLargeError"
    });
  }
}
class EmptyBlobError extends BaseError$3 {
  constructor() {
    super("Blob data must not be empty.", { name: "EmptyBlobError" });
  }
}
function toBlobs(s) {
  const A = typeof s.data == "string" ? hexToBytes(s.data) : s.data, u = size(A);
  if (!u)
    throw new EmptyBlobError();
  if (u > maxBytesPerTransaction)
    throw new BlobSizeTooLargeError({
      maxSize: maxBytesPerTransaction,
      size: u
    });
  const p = [];
  let t = !0, l = 0;
  for (; t; ) {
    const m = createCursor(new Uint8Array(bytesPerBlob));
    let b = 0;
    for (; b < fieldElementsPerBlob; ) {
      const k = A.slice(l, l + (bytesPerFieldElement - 1));
      if (m.pushByte(0), m.pushBytes(k), k.length < 31) {
        m.pushByte(128), t = !1;
        break;
      }
      b++, l += 31;
    }
    p.push(m);
  }
  return p.map((m) => bytesToHex(m.bytes));
}
function toBlobSidecars(s) {
  const { data: A, kzg: u, to: p } = s, t = s.blobs ?? toBlobs({ data: A }), l = s.commitments ?? blobsToCommitments({ blobs: t, kzg: u, to: p }), m = s.proofs ?? blobsToProofs({ blobs: t, commitments: l, kzg: u, to: p }), b = [];
  for (let k = 0; k < t.length; k++)
    b.push({
      blob: t[k],
      commitment: l[k],
      proof: m[k]
    });
  return b;
}
function getTransactionType(s) {
  if (s.type)
    return s.type;
  if (typeof s.authorizationList < "u")
    return "eip7702";
  if (typeof s.blobs < "u" || typeof s.blobVersionedHashes < "u" || typeof s.maxFeePerBlobGas < "u" || typeof s.sidecars < "u")
    return "eip4844";
  if (typeof s.maxFeePerGas < "u" || typeof s.maxPriorityFeePerGas < "u")
    return "eip1559";
  if (typeof s.gasPrice < "u")
    return typeof s.accessList < "u" ? "eip2930" : "legacy";
  throw new InvalidSerializableTransactionError({ transaction: s });
}
async function getChainId(s) {
  const A = await s.request({
    method: "eth_chainId"
  }, { dedupe: !0 });
  return hexToNumber(A);
}
const defaultParameters = [
  "blobVersionedHashes",
  "chainId",
  "fees",
  "gas",
  "nonce",
  "type"
], eip1559NetworkCache = /* @__PURE__ */ new Map();
async function prepareTransactionRequest(s, A) {
  const { account: u = s.account, blobs: p, chain: t, gas: l, kzg: m, nonce: b, nonceManager: k, parameters: C = defaultParameters, type: B } = A, Q = u && parseAccount(u), P = { ...A, ...Q ? { from: Q == null ? void 0 : Q.address } : {} };
  let x;
  async function M() {
    return x || (x = await getAction$1(s, getBlock, "getBlock")({ blockTag: "latest" }), x);
  }
  let F;
  async function le() {
    return F || (t ? t.id : typeof A.chainId < "u" ? A.chainId : (F = await getAction$1(s, getChainId, "getChainId")({}), F));
  }
  if (C.includes("nonce") && typeof b > "u" && Q)
    if (k) {
      const ge = await le();
      P.nonce = await k.consume({
        address: Q.address,
        chainId: ge,
        client: s
      });
    } else
      P.nonce = await getAction$1(s, getTransactionCount$1, "getTransactionCount")({
        address: Q.address,
        blockTag: "pending"
      });
  if ((C.includes("blobVersionedHashes") || C.includes("sidecars")) && p && m) {
    const ge = blobsToCommitments({ blobs: p, kzg: m });
    if (C.includes("blobVersionedHashes")) {
      const pe = commitmentsToVersionedHashes({
        commitments: ge,
        to: "hex"
      });
      P.blobVersionedHashes = pe;
    }
    if (C.includes("sidecars")) {
      const pe = blobsToProofs({ blobs: p, commitments: ge, kzg: m }), Ie = toBlobSidecars({
        blobs: p,
        commitments: ge,
        proofs: pe,
        to: "hex"
      });
      P.sidecars = Ie;
    }
  }
  if (C.includes("chainId") && (P.chainId = await le()), (C.includes("fees") || C.includes("type")) && typeof B > "u")
    try {
      P.type = getTransactionType(P);
    } catch {
      let ge = eip1559NetworkCache.get(s.uid);
      if (typeof ge > "u") {
        const pe = await M();
        ge = typeof (pe == null ? void 0 : pe.baseFeePerGas) == "bigint", eip1559NetworkCache.set(s.uid, ge);
      }
      P.type = ge ? "eip1559" : "legacy";
    }
  if (C.includes("fees"))
    if (P.type !== "legacy" && P.type !== "eip2930") {
      if (typeof P.maxFeePerGas > "u" || typeof P.maxPriorityFeePerGas > "u") {
        const ge = await M(), { maxFeePerGas: pe, maxPriorityFeePerGas: Ie } = await internal_estimateFeesPerGas(s, {
          block: ge,
          chain: t,
          request: P
        });
        if (typeof A.maxPriorityFeePerGas > "u" && A.maxFeePerGas && A.maxFeePerGas < Ie)
          throw new MaxFeePerGasTooLowError({
            maxPriorityFeePerGas: Ie
          });
        P.maxPriorityFeePerGas = Ie, P.maxFeePerGas = pe;
      }
    } else {
      if (typeof A.maxFeePerGas < "u" || typeof A.maxPriorityFeePerGas < "u")
        throw new Eip1559FeesNotSupportedError();
      if (typeof A.gasPrice > "u") {
        const ge = await M(), { gasPrice: pe } = await internal_estimateFeesPerGas(s, {
          block: ge,
          chain: t,
          request: P,
          type: "legacy"
        });
        P.gasPrice = pe;
      }
    }
  return C.includes("gas") && typeof l > "u" && (P.gas = await getAction$1(s, estimateGas$1, "estimateGas")({
    ...P,
    account: Q && { address: Q.address, type: "json-rpc" }
  })), assertRequest(P), delete P.parameters, P;
}
async function estimateGas$1(s, A) {
  var t, l, m;
  const { account: u = s.account } = A, p = u ? parseAccount(u) : void 0;
  try {
    const { accessList: b, authorizationList: k, blobs: C, blobVersionedHashes: B, blockNumber: Q, blockTag: P, data: x, gas: M, gasPrice: F, maxFeePerBlobGas: le, maxFeePerGas: ge, maxPriorityFeePerGas: pe, nonce: Ie, value: be, stateOverride: Pe, ...Te } = await prepareTransactionRequest(s, {
      ...A,
      parameters: (
        // Some RPC Providers do not compute versioned hashes from blobs. We will need
        // to compute them.
        (p == null ? void 0 : p.type) === "local" ? void 0 : ["blobVersionedHashes"]
      )
    }), xe = (typeof Q == "bigint" ? numberToHex(Q) : void 0) || P, Ee = serializeStateOverride(Pe), He = await (async () => {
      if (Te.to)
        return Te.to;
      if (k && k.length > 0)
        return await recoverAuthorizationAddress({
          authorization: k[0]
        }).catch(() => {
          throw new BaseError$3("`to` is required. Could not infer from `authorizationList`");
        });
    })();
    assertRequest(A);
    const ve = (m = (l = (t = s.chain) == null ? void 0 : t.formatters) == null ? void 0 : l.transactionRequest) == null ? void 0 : m.format, Ce = (ve || formatTransactionRequest)({
      // Pick out extra data that might exist on the chain's transaction request type.
      ...extract(Te, { format: ve }),
      from: p == null ? void 0 : p.address,
      accessList: b,
      authorizationList: k,
      blobs: C,
      blobVersionedHashes: B,
      data: x,
      gas: M,
      gasPrice: F,
      maxFeePerBlobGas: le,
      maxFeePerGas: ge,
      maxPriorityFeePerGas: pe,
      nonce: Ie,
      to: He,
      value: be
    }, "estimateGas");
    return BigInt(await s.request({
      method: "eth_estimateGas",
      params: Ee ? [
        Ce,
        xe ?? s.experimental_blockTag ?? "latest",
        Ee
      ] : xe ? [Ce, xe] : [Ce]
    }));
  } catch (b) {
    throw getEstimateGasError(b, {
      ...A,
      account: p,
      chain: s.chain
    });
  }
}
async function getBalance$1(s, { address: A, blockNumber: u, blockTag: p = s.experimental_blockTag ?? "latest" }) {
  const t = typeof u == "bigint" ? numberToHex(u) : void 0, l = await s.request({
    method: "eth_getBalance",
    params: [A, t || p]
  });
  return BigInt(l);
}
function assertCurrentChain({ chain: s, currentChainId: A }) {
  if (!s)
    throw new ChainNotFoundError();
  if (A !== s.id)
    throw new ChainMismatchError({ chain: s, currentChainId: A });
}
function getTransactionError(s, { docsPath: A, ...u }) {
  const p = (() => {
    const t = getNodeError(s, u);
    return t instanceof UnknownNodeError ? s : t;
  })();
  return new TransactionExecutionError(p, {
    docsPath: A,
    ...u
  });
}
class InvalidDomainError extends BaseError$3 {
  constructor({ domain: A }) {
    super(`Invalid domain "${stringify(A)}".`, {
      metaMessages: ["Must be a valid EIP-712 domain."]
    });
  }
}
class InvalidPrimaryTypeError extends BaseError$3 {
  constructor({ primaryType: A, types: u }) {
    super(`Invalid primary type \`${A}\` must be one of \`${JSON.stringify(Object.keys(u))}\`.`, {
      docsPath: "/api/glossary/Errors#typeddatainvalidprimarytypeerror",
      metaMessages: ["Check that the primary type is a key in `types`."]
    });
  }
}
class InvalidStructTypeError extends BaseError$3 {
  constructor({ type: A }) {
    super(`Struct type "${A}" is invalid.`, {
      metaMessages: ["Struct type must not be a Solidity type."],
      name: "InvalidStructTypeError"
    });
  }
}
function serializeTypedData(s) {
  const { domain: A, message: u, primaryType: p, types: t } = s, l = (k, C) => {
    const B = { ...C };
    for (const Q of k) {
      const { name: P, type: x } = Q;
      x === "address" && (B[P] = B[P].toLowerCase());
    }
    return B;
  }, m = t.EIP712Domain ? A ? l(t.EIP712Domain, A) : {} : {}, b = (() => {
    if (p !== "EIP712Domain")
      return l(t[p], u);
  })();
  return stringify({ domain: m, message: b, primaryType: p, types: t });
}
function validateTypedData(s) {
  const { domain: A, message: u, primaryType: p, types: t } = s, l = (m, b) => {
    for (const k of m) {
      const { name: C, type: B } = k, Q = b[C], P = B.match(integerRegex$1);
      if (P && (typeof Q == "number" || typeof Q == "bigint")) {
        const [F, le, ge] = P;
        numberToHex(Q, {
          signed: le === "int",
          size: Number.parseInt(ge, 10) / 8
        });
      }
      if (B === "address" && typeof Q == "string" && !isAddress(Q))
        throw new InvalidAddressError({ address: Q });
      const x = B.match(bytesRegex$1);
      if (x) {
        const [F, le] = x;
        if (le && size(Q) !== Number.parseInt(le, 10))
          throw new BytesSizeMismatchError({
            expectedSize: Number.parseInt(le, 10),
            givenSize: size(Q)
          });
      }
      const M = t[B];
      M && (validateReference(B), l(M, Q));
    }
  };
  if (t.EIP712Domain && A) {
    if (typeof A != "object")
      throw new InvalidDomainError({ domain: A });
    l(t.EIP712Domain, A);
  }
  if (p !== "EIP712Domain")
    if (t[p])
      l(t[p], u);
    else
      throw new InvalidPrimaryTypeError({ primaryType: p, types: t });
}
function getTypesForEIP712Domain({ domain: s }) {
  return [
    typeof (s == null ? void 0 : s.name) == "string" && { name: "name", type: "string" },
    (s == null ? void 0 : s.version) && { name: "version", type: "string" },
    (typeof (s == null ? void 0 : s.chainId) == "number" || typeof (s == null ? void 0 : s.chainId) == "bigint") && {
      name: "chainId",
      type: "uint256"
    },
    (s == null ? void 0 : s.verifyingContract) && {
      name: "verifyingContract",
      type: "address"
    },
    (s == null ? void 0 : s.salt) && { name: "salt", type: "bytes32" }
  ].filter(Boolean);
}
function validateReference(s) {
  if (s === "address" || s === "bool" || s === "string" || s.startsWith("bytes") || s.startsWith("uint") || s.startsWith("int"))
    throw new InvalidStructTypeError({ type: s });
}
async function multicall$1(s, A) {
  var pe;
  const { account: u, authorizationList: p, allowFailure: t = !0, blockNumber: l, blockOverrides: m, blockTag: b, stateOverride: k } = A, C = A.contracts, { batchSize: B = A.batchSize ?? 1024, deployless: Q = A.deployless ?? !1 } = typeof ((pe = s.batch) == null ? void 0 : pe.multicall) == "object" ? s.batch.multicall : {}, P = (() => {
    if (A.multicallAddress)
      return A.multicallAddress;
    if (Q)
      return null;
    if (s.chain)
      return getChainContractAddress({
        blockNumber: l,
        chain: s.chain,
        contract: "multicall3"
      });
    throw new Error("client chain not configured. multicallAddress is required.");
  })(), x = [[]];
  let M = 0, F = 0;
  for (let Ie = 0; Ie < C.length; Ie++) {
    const { abi: be, address: Pe, args: Te, functionName: Qe } = C[Ie];
    try {
      const xe = encodeFunctionData({ abi: be, args: Te, functionName: Qe });
      F += (xe.length - 2) / 2, // Check if batching is enabled.
      B > 0 && // Check if the current size of the batch exceeds the size limit.
      F > B && // Check if the current chunk is not already empty.
      x[M].length > 0 && (M++, F = (xe.length - 2) / 2, x[M] = []), x[M] = [
        ...x[M],
        {
          allowFailure: !0,
          callData: xe,
          target: Pe
        }
      ];
    } catch (xe) {
      const Ee = getContractError(xe, {
        abi: be,
        address: Pe,
        args: Te,
        docsPath: "/docs/contract/multicall",
        functionName: Qe,
        sender: u
      });
      if (!t)
        throw Ee;
      x[M] = [
        ...x[M],
        {
          allowFailure: !0,
          callData: "0x",
          target: Pe
        }
      ];
    }
  }
  const le = await Promise.allSettled(x.map((Ie) => getAction$1(s, readContract$1, "readContract")({
    ...P === null ? { code: multicall3Bytecode } : { address: P },
    abi: multicall3Abi,
    account: u,
    args: [Ie],
    authorizationList: p,
    blockNumber: l,
    blockOverrides: m,
    blockTag: b,
    functionName: "aggregate3",
    stateOverride: k
  }))), ge = [];
  for (let Ie = 0; Ie < le.length; Ie++) {
    const be = le[Ie];
    if (be.status === "rejected") {
      if (!t)
        throw be.reason;
      for (let Te = 0; Te < x[Ie].length; Te++)
        ge.push({
          status: "failure",
          error: be.reason,
          result: void 0
        });
      continue;
    }
    const Pe = be.value;
    for (let Te = 0; Te < Pe.length; Te++) {
      const { returnData: Qe, success: xe } = Pe[Te], { callData: Ee } = x[Ie][Te], { abi: He, address: ve, functionName: we, args: Ce } = C[ge.length];
      try {
        if (Ee === "0x")
          throw new AbiDecodingZeroDataError();
        if (!xe)
          throw new RawContractError({ data: Qe });
        const Se = decodeFunctionResult({
          abi: He,
          args: Ce,
          data: Qe,
          functionName: we
        });
        ge.push(t ? { result: Se, status: "success" } : Se);
      } catch (Se) {
        const Ne = getContractError(Se, {
          abi: He,
          address: ve,
          args: Ce,
          docsPath: "/docs/contract/multicall",
          functionName: we
        });
        if (!t)
          throw Ne;
        ge.push({ error: Ne, result: void 0, status: "failure" });
      }
    }
  }
  if (ge.length !== C.length)
    throw new BaseError$3("multicall results mismatch");
  return ge;
}
class AccountNotFoundError extends BaseError$3 {
  constructor({ docsPath: A } = {}) {
    super([
      "Could not find an Account to execute with this Action.",
      "Please provide an Account with the `account` argument on the Action, or by supplying an `account` to the Client."
    ].join(`
`), {
      docsPath: A,
      docsSlug: "account",
      name: "AccountNotFoundError"
    });
  }
}
class AccountTypeNotSupportedError extends BaseError$3 {
  constructor({ docsPath: A, metaMessages: u, type: p }) {
    super(`Account type "${p}" is not supported.`, {
      docsPath: A,
      metaMessages: u,
      name: "AccountTypeNotSupportedError"
    });
  }
}
async function sendRawTransaction(s, { serializedTransaction: A }) {
  return s.request({
    method: "eth_sendRawTransaction",
    params: [A]
  }, { retryCount: 0 });
}
const supportsWalletNamespace = new LruMap(128);
async function sendTransaction$1(s, A) {
  var pe, Ie, be, Pe;
  const { account: u = s.account, chain: p = s.chain, accessList: t, authorizationList: l, blobs: m, data: b, gas: k, gasPrice: C, maxFeePerBlobGas: B, maxFeePerGas: Q, maxPriorityFeePerGas: P, nonce: x, type: M, value: F, ...le } = A;
  if (typeof u > "u")
    throw new AccountNotFoundError({
      docsPath: "/docs/actions/wallet/sendTransaction"
    });
  const ge = u ? parseAccount(u) : null;
  try {
    assertRequest(A);
    const Te = await (async () => {
      if (A.to)
        return A.to;
      if (A.to !== null && l && l.length > 0)
        return await recoverAuthorizationAddress({
          authorization: l[0]
        }).catch(() => {
          throw new BaseError$3("`to` is required. Could not infer from `authorizationList`.");
        });
    })();
    if ((ge == null ? void 0 : ge.type) === "json-rpc" || ge === null) {
      let Qe;
      p !== null && (Qe = await getAction$1(s, getChainId, "getChainId")({}), assertCurrentChain({
        currentChainId: Qe,
        chain: p
      }));
      const xe = (be = (Ie = (pe = s.chain) == null ? void 0 : pe.formatters) == null ? void 0 : Ie.transactionRequest) == null ? void 0 : be.format, He = (xe || formatTransactionRequest)({
        // Pick out extra data that might exist on the chain's transaction request type.
        ...extract(le, { format: xe }),
        accessList: t,
        authorizationList: l,
        blobs: m,
        chainId: Qe,
        data: b,
        from: ge == null ? void 0 : ge.address,
        gas: k,
        gasPrice: C,
        maxFeePerBlobGas: B,
        maxFeePerGas: Q,
        maxPriorityFeePerGas: P,
        nonce: x,
        to: Te,
        type: M,
        value: F
      }, "sendTransaction"), ve = supportsWalletNamespace.get(s.uid), we = ve ? "wallet_sendTransaction" : "eth_sendTransaction";
      try {
        return await s.request({
          method: we,
          params: [He]
        }, { retryCount: 0 });
      } catch (Ce) {
        if (ve === !1)
          throw Ce;
        const Se = Ce;
        if (Se.name === "InvalidInputRpcError" || Se.name === "InvalidParamsRpcError" || Se.name === "MethodNotFoundRpcError" || Se.name === "MethodNotSupportedRpcError")
          return await s.request({
            method: "wallet_sendTransaction",
            params: [He]
          }, { retryCount: 0 }).then((Ne) => (supportsWalletNamespace.set(s.uid, !0), Ne)).catch((Ne) => {
            const rr = Ne;
            throw rr.name === "MethodNotFoundRpcError" || rr.name === "MethodNotSupportedRpcError" ? (supportsWalletNamespace.set(s.uid, !1), Se) : rr;
          });
        throw Se;
      }
    }
    if ((ge == null ? void 0 : ge.type) === "local") {
      const Qe = await getAction$1(s, prepareTransactionRequest, "prepareTransactionRequest")({
        account: ge,
        accessList: t,
        authorizationList: l,
        blobs: m,
        chain: p,
        data: b,
        gas: k,
        gasPrice: C,
        maxFeePerBlobGas: B,
        maxFeePerGas: Q,
        maxPriorityFeePerGas: P,
        nonce: x,
        nonceManager: ge.nonceManager,
        parameters: [...defaultParameters, "sidecars"],
        type: M,
        value: F,
        ...le,
        to: Te
      }), xe = (Pe = p == null ? void 0 : p.serializers) == null ? void 0 : Pe.transaction, Ee = await ge.signTransaction(Qe, {
        serializer: xe
      });
      return await getAction$1(s, sendRawTransaction, "sendRawTransaction")({
        serializedTransaction: Ee
      });
    }
    throw (ge == null ? void 0 : ge.type) === "smart" ? new AccountTypeNotSupportedError({
      metaMessages: [
        "Consider using the `sendUserOperation` Action instead."
      ],
      docsPath: "/docs/actions/bundler/sendUserOperation",
      type: "smart"
    }) : new AccountTypeNotSupportedError({
      docsPath: "/docs/actions/wallet/sendTransaction",
      type: ge == null ? void 0 : ge.type
    });
  } catch (Te) {
    throw Te instanceof AccountTypeNotSupportedError ? Te : getTransactionError(Te, {
      ...A,
      account: ge,
      chain: A.chain || void 0
    });
  }
}
async function signMessage$1(s, { account: A = s.account, message: u }) {
  if (!A)
    throw new AccountNotFoundError({
      docsPath: "/docs/actions/wallet/signMessage"
    });
  const p = parseAccount(A);
  if (p.signMessage)
    return p.signMessage({ message: u });
  const t = typeof u == "string" ? stringToHex(u) : u.raw instanceof Uint8Array ? toHex(u.raw) : u.raw;
  return s.request({
    method: "personal_sign",
    params: [t, p.address]
  }, { retryCount: 0 });
}
async function signTypedData$1(s, A) {
  const { account: u = s.account, domain: p, message: t, primaryType: l } = A;
  if (!u)
    throw new AccountNotFoundError({
      docsPath: "/docs/actions/wallet/signTypedData"
    });
  const m = parseAccount(u), b = {
    EIP712Domain: getTypesForEIP712Domain({ domain: p }),
    ...A.types
  };
  if (validateTypedData({ domain: p, message: t, primaryType: l, types: b }), m.signTypedData)
    return m.signTypedData({ domain: p, message: t, primaryType: l, types: b });
  const k = serializeTypedData({ domain: p, message: t, primaryType: l, types: b });
  return s.request({
    method: "eth_signTypedData_v4",
    params: [m.address, k]
  }, { retryCount: 0 });
}
function getAction(s, A, u) {
  const p = s[A.name];
  if (typeof p == "function")
    return p;
  const t = s[u];
  return typeof t == "function" ? t : (l) => A(s, l);
}
const version = "2.22.1", getVersion = () => `@wagmi/core@${version}`;
var __classPrivateFieldGet = function(s, A, u, p) {
  if (u === "a" && !p) throw new TypeError("Private accessor was defined without a getter");
  if (typeof A == "function" ? s !== A || !p : !A.has(s)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return u === "m" ? p : u === "a" ? p.call(s) : p ? p.value : A.get(s);
}, _BaseError_instances, _BaseError_walk;
class BaseError extends Error {
  get docsBaseUrl() {
    return "https://wagmi.sh/core";
  }
  get version() {
    return getVersion();
  }
  constructor(A, u = {}) {
    var l;
    super(), _BaseError_instances.add(this), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WagmiCoreError"
    });
    const p = u.cause instanceof BaseError ? u.cause.details : (l = u.cause) != null && l.message ? u.cause.message : u.details, t = u.cause instanceof BaseError && u.cause.docsPath || u.docsPath;
    this.message = [
      A || "An error occurred.",
      "",
      ...u.metaMessages ? [...u.metaMessages, ""] : [],
      ...t ? [
        `Docs: ${this.docsBaseUrl}${t}.html${u.docsSlug ? `#${u.docsSlug}` : ""}`
      ] : [],
      ...p ? [`Details: ${p}`] : [],
      `Version: ${this.version}`
    ].join(`
`), u.cause && (this.cause = u.cause), this.details = p, this.docsPath = t, this.metaMessages = u.metaMessages, this.shortMessage = A;
  }
  walk(A) {
    return __classPrivateFieldGet(this, _BaseError_instances, "m", _BaseError_walk).call(this, this, A);
  }
}
_BaseError_instances = /* @__PURE__ */ new WeakSet(), _BaseError_walk = function s(A, u) {
  return u != null && u(A) ? A : A.cause ? __classPrivateFieldGet(this, _BaseError_instances, "m", s).call(this, A.cause, u) : A;
};
class ChainNotConfiguredError extends BaseError {
  constructor() {
    super("Chain not configured."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ChainNotConfiguredError"
    });
  }
}
class ConnectorAlreadyConnectedError extends BaseError {
  constructor() {
    super("Connector already connected."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorAlreadyConnectedError"
    });
  }
}
class ConnectorNotConnectedError extends BaseError {
  constructor() {
    super("Connector not connected."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorNotConnectedError"
    });
  }
}
class ConnectorAccountNotFoundError extends BaseError {
  constructor({ address: A, connector: u }) {
    super(`Account "${A}" not found for connector "${u.name}".`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorAccountNotFoundError"
    });
  }
}
class ConnectorChainMismatchError extends BaseError {
  constructor({ connectionChainId: A, connectorChainId: u }) {
    super(`The current chain of the connector (id: ${u}) does not match the connection's chain (id: ${A}).`, {
      metaMessages: [
        `Current Chain ID:  ${u}`,
        `Expected Chain ID: ${A}`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorChainMismatchError"
    });
  }
}
class ConnectorUnavailableReconnectingError extends BaseError {
  constructor({ connector: A }) {
    super(`Connector "${A.name}" unavailable while reconnecting.`, {
      details: [
        "During the reconnection step, the only connector methods guaranteed to be available are: `id`, `name`, `type`, `uid`.",
        "All other methods are not guaranteed to be available until reconnection completes and connectors are fully restored.",
        "This error commonly occurs for connectors that asynchronously inject after reconnection has already started."
      ].join(" ")
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorUnavailableReconnectingError"
    });
  }
}
async function connect(s, A) {
  var p;
  let u;
  if (typeof A.connector == "function" ? u = s._internal.connectors.setup(A.connector) : u = A.connector, u.uid === s.state.current)
    throw new ConnectorAlreadyConnectedError();
  try {
    s.setState((b) => ({ ...b, status: "connecting" })), u.emitter.emit("message", { type: "connecting" });
    const { connector: t, ...l } = A, m = await u.connect(l);
    return u.emitter.off("connect", s._internal.events.connect), u.emitter.on("change", s._internal.events.change), u.emitter.on("disconnect", s._internal.events.disconnect), await ((p = s.storage) == null ? void 0 : p.setItem("recentConnectorId", u.id)), s.setState((b) => ({
      ...b,
      connections: new Map(b.connections).set(u.uid, {
        accounts: l.withCapabilities ? m.accounts.map((k) => typeof k == "object" ? k.address : k) : m.accounts,
        chainId: m.chainId,
        connector: u
      }),
      current: u.uid,
      status: "connected"
    })), {
      // TODO(v3): Remove `withCapabilities: true` default behavior so remove compat marshalling
      // Workaround so downstream connectors work with `withCapabilities` without any changes required
      accounts: l.withCapabilities ? m.accounts.map((b) => typeof b == "object" ? b : { address: b, capabilities: {} }) : m.accounts,
      chainId: m.chainId
    };
  } catch (t) {
    throw s.setState((l) => ({
      ...l,
      // Keep existing connector connected in case of error
      status: l.current ? "connected" : "disconnected"
    })), t;
  }
}
async function getConnectorClient(s, A = {}) {
  const { assertChainId: u = !0 } = A;
  let p;
  if (A.connector) {
    const { connector: B } = A;
    if (s.state.status === "reconnecting" && !B.getAccounts && !B.getChainId)
      throw new ConnectorUnavailableReconnectingError({ connector: B });
    const [Q, P] = await Promise.all([
      B.getAccounts().catch((x) => {
        if (A.account === null)
          return [];
        throw x;
      }),
      B.getChainId()
    ]);
    p = {
      accounts: Q,
      chainId: P,
      connector: B
    };
  } else
    p = s.state.connections.get(s.state.current);
  if (!p)
    throw new ConnectorNotConnectedError();
  const t = A.chainId ?? p.chainId, l = await p.connector.getChainId();
  if (u && l !== t)
    throw new ConnectorChainMismatchError({
      connectionChainId: t,
      connectorChainId: l
    });
  const m = p.connector;
  if (m.getClient)
    return m.getClient({ chainId: t });
  const b = parseAccount(A.account ?? p.accounts[0]);
  if (b && (b.address = getAddress(b.address)), A.account && !p.accounts.some((B) => B.toLowerCase() === b.address.toLowerCase()))
    throw new ConnectorAccountNotFoundError({
      address: b.address,
      connector: m
    });
  const k = s.chains.find((B) => B.id === t), C = await p.connector.getProvider({ chainId: t });
  return createClient({
    account: b,
    chain: k,
    name: "Connector Client",
    transport: (B) => custom(C)({ ...B, retryCount: 0 })
  });
}
async function disconnect(s, A = {}) {
  var t, l;
  let u;
  if (A.connector)
    u = A.connector;
  else {
    const { connections: m, current: b } = s.state, k = m.get(b);
    u = k == null ? void 0 : k.connector;
  }
  const p = s.state.connections;
  u && (await u.disconnect(), u.emitter.off("change", s._internal.events.change), u.emitter.off("disconnect", s._internal.events.disconnect), u.emitter.on("connect", s._internal.events.connect), p.delete(u.uid)), s.setState((m) => {
    if (p.size === 0)
      return {
        ...m,
        connections: /* @__PURE__ */ new Map(),
        current: null,
        status: "disconnected"
      };
    const b = p.values().next().value;
    return {
      ...m,
      connections: new Map(p),
      current: b.connector.uid
    };
  });
  {
    const m = s.state.current;
    if (!m)
      return;
    const b = (t = s.state.connections.get(m)) == null ? void 0 : t.connector;
    if (!b)
      return;
    await ((l = s.storage) == null ? void 0 : l.setItem("recentConnectorId", b.id));
  }
}
function getUnit(s) {
  return typeof s == "number" ? s : s === "wei" ? 0 : Math.abs(weiUnits[s]);
}
async function estimateGas(s, A) {
  const { chainId: u, connector: p, ...t } = A;
  let l;
  A.account ? l = A.account : l = (await getConnectorClient(s, {
    account: A.account,
    assertChainId: !1,
    chainId: u,
    connector: p
  })).account;
  const m = s.getClient({ chainId: u });
  return getAction(m, estimateGas$1, "estimateGas")({ ...t, account: l });
}
function getAccount(s) {
  const A = s.state.current, u = s.state.connections.get(A), p = u == null ? void 0 : u.accounts, t = p == null ? void 0 : p[0], l = s.chains.find((b) => b.id === (u == null ? void 0 : u.chainId)), m = s.state.status;
  switch (m) {
    case "connected":
      return {
        address: t,
        addresses: p,
        chain: l,
        chainId: u == null ? void 0 : u.chainId,
        connector: u == null ? void 0 : u.connector,
        isConnected: !0,
        isConnecting: !1,
        isDisconnected: !1,
        isReconnecting: !1,
        status: m
      };
    case "reconnecting":
      return {
        address: t,
        addresses: p,
        chain: l,
        chainId: u == null ? void 0 : u.chainId,
        connector: u == null ? void 0 : u.connector,
        isConnected: !!t,
        isConnecting: !1,
        isDisconnected: !1,
        isReconnecting: !0,
        status: m
      };
    case "connecting":
      return {
        address: t,
        addresses: p,
        chain: l,
        chainId: u == null ? void 0 : u.chainId,
        connector: u == null ? void 0 : u.connector,
        isConnected: !1,
        isConnecting: !0,
        isDisconnected: !1,
        isReconnecting: !1,
        status: m
      };
    case "disconnected":
      return {
        address: void 0,
        addresses: void 0,
        chain: void 0,
        chainId: void 0,
        connector: void 0,
        isConnected: !1,
        isConnecting: !1,
        isDisconnected: !0,
        isReconnecting: !1,
        status: m
      };
  }
}
async function multicall(s, A) {
  const { allowFailure: u = !0, chainId: p, contracts: t, ...l } = A, m = s.getClient({ chainId: p });
  return getAction(m, multicall$1, "multicall")({
    allowFailure: u,
    contracts: t,
    ...l
  });
}
function readContract(s, A) {
  const { chainId: u, ...p } = A, t = s.getClient({ chainId: u });
  return getAction(t, readContract$1, "readContract")(p);
}
async function readContracts(s, A) {
  var b;
  const { allowFailure: u = !0, blockNumber: p, blockTag: t, ...l } = A, m = A.contracts;
  try {
    const k = {};
    for (const [P, x] of m.entries()) {
      const M = x.chainId ?? s.state.chainId;
      k[M] || (k[M] = []), (b = k[M]) == null || b.push({ contract: x, index: P });
    }
    const C = () => Object.entries(k).map(([P, x]) => multicall(s, {
      ...l,
      allowFailure: u,
      blockNumber: p,
      blockTag: t,
      chainId: Number.parseInt(P, 10),
      contracts: x.map(({ contract: M }) => M)
    })), B = (await Promise.all(C())).flat(), Q = Object.values(k).flatMap((P) => P.map(({ index: x }) => x));
    return B.reduce((P, x, M) => (P && (P[Q[M]] = x), P), []);
  } catch (k) {
    if (k instanceof ContractFunctionExecutionError$1)
      throw k;
    const C = () => m.map((B) => readContract(s, { ...B, blockNumber: p, blockTag: t }));
    return u ? (await Promise.allSettled(C())).map((B) => B.status === "fulfilled" ? { result: B.value, status: "success" } : { error: B.reason, result: void 0, status: "failure" }) : await Promise.all(C());
  }
}
async function getBalance(s, A) {
  const { address: u, blockNumber: p, blockTag: t, chainId: l, token: m, unit: b = "ether" } = A;
  if (m)
    try {
      return await getTokenBalance(s, {
        balanceAddress: u,
        chainId: l,
        symbolType: "string",
        tokenAddress: m
      });
    } catch (P) {
      if (P.name === "ContractFunctionExecutionError") {
        const x = await getTokenBalance(s, {
          balanceAddress: u,
          chainId: l,
          symbolType: "bytes32",
          tokenAddress: m
        }), M = hexToString(trim$1(x.symbol, { dir: "right" }));
        return { ...x, symbol: M };
      }
      throw P;
    }
  const k = s.getClient({ chainId: l }), B = await getAction(k, getBalance$1, "getBalance")(p ? { address: u, blockNumber: p } : { address: u, blockTag: t }), Q = s.chains.find((P) => P.id === l) ?? k.chain;
  return {
    decimals: Q.nativeCurrency.decimals,
    formatted: formatUnits$1(B, getUnit(b)),
    symbol: Q.nativeCurrency.symbol,
    value: B
  };
}
async function getTokenBalance(s, A) {
  const { balanceAddress: u, chainId: p, symbolType: t, tokenAddress: l, unit: m } = A, b = {
    abi: [
      {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [{ type: "address" }],
        outputs: [{ type: "uint256" }]
      },
      {
        type: "function",
        name: "decimals",
        stateMutability: "view",
        inputs: [],
        outputs: [{ type: "uint8" }]
      },
      {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [{ type: t }]
      }
    ],
    address: l
  }, [k, C, B] = await readContracts(s, {
    allowFailure: !1,
    contracts: [
      {
        ...b,
        functionName: "balanceOf",
        args: [u],
        chainId: p
      },
      { ...b, functionName: "decimals", chainId: p },
      { ...b, functionName: "symbol", chainId: p }
    ]
  }), Q = formatUnits$1(k ?? "0", getUnit(m ?? C));
  return { decimals: C, formatted: Q, symbol: B, value: k };
}
function deepEqual(s, A) {
  if (s === A)
    return !0;
  if (s && A && typeof s == "object" && typeof A == "object") {
    if (s.constructor !== A.constructor)
      return !1;
    let u, p;
    if (Array.isArray(s) && Array.isArray(A)) {
      if (u = s.length, u !== A.length)
        return !1;
      for (p = u; p-- !== 0; )
        if (!deepEqual(s[p], A[p]))
          return !1;
      return !0;
    }
    if (typeof s.valueOf == "function" && s.valueOf !== Object.prototype.valueOf)
      return s.valueOf() === A.valueOf();
    if (typeof s.toString == "function" && s.toString !== Object.prototype.toString)
      return s.toString() === A.toString();
    const t = Object.keys(s);
    if (u = t.length, u !== Object.keys(A).length)
      return !1;
    for (p = u; p-- !== 0; )
      if (!Object.hasOwn(A, t[p]))
        return !1;
    for (p = u; p-- !== 0; ) {
      const l = t[p];
      if (l && !deepEqual(s[l], A[l]))
        return !1;
    }
    return !0;
  }
  return s !== s && A !== A;
}
async function getTransactionCount(s, A) {
  const { address: u, blockNumber: p, blockTag: t, chainId: l } = A, m = s.getClient({ chainId: l });
  return getAction(m, getTransactionCount$1, "getTransactionCount")(p ? { address: u, blockNumber: p } : { address: u, blockTag: t });
}
async function sendTransaction(s, A) {
  const { account: u, chainId: p, connector: t, ...l } = A;
  let m;
  return typeof u == "object" && (u == null ? void 0 : u.type) === "local" ? m = s.getClient({ chainId: p }) : m = await getConnectorClient(s, {
    account: u ?? void 0,
    assertChainId: !1,
    chainId: p,
    connector: t
  }), await getAction(m, sendTransaction$1, "sendTransaction")({
    ...l,
    ...u ? { account: u } : {},
    chain: p ? { id: p } : null,
    gas: l.gas ?? void 0
  });
}
async function signMessage(s, A) {
  const { account: u, connector: p, ...t } = A;
  let l;
  return typeof u == "object" && u.type === "local" ? l = s.getClient() : l = await getConnectorClient(s, { account: u, connector: p }), getAction(l, signMessage$1, "signMessage")({
    ...t,
    ...u ? { account: u } : {}
  });
}
async function signTypedData(s, A) {
  const { account: u, connector: p, ...t } = A;
  let l;
  return typeof u == "object" && u.type === "local" ? l = s.getClient() : l = await getConnectorClient(s, { account: u, connector: p }), getAction(l, signTypedData$1, "signTypedData")({
    ...t,
    ...u ? { account: u } : {}
  });
}
class ProviderNotFoundError extends BaseError {
  constructor() {
    super("Provider not found."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ProviderNotFoundError"
    });
  }
}
class SwitchChainNotSupportedError extends BaseError {
  constructor({ connector: A }) {
    super(`"${A.name}" does not support programmatic chain switching.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SwitchChainNotSupportedError"
    });
  }
}
async function switchChain(s, A) {
  var m;
  const { addEthereumChainParameter: u, chainId: p } = A, t = s.state.connections.get(((m = A.connector) == null ? void 0 : m.uid) ?? s.state.current);
  if (t) {
    const b = t.connector;
    if (!b.switchChain)
      throw new SwitchChainNotSupportedError({ connector: b });
    return await b.switchChain({
      addEthereumChainParameter: u,
      chainId: p
    });
  }
  const l = s.chains.find((b) => b.id === p);
  if (!l)
    throw new ChainNotConfiguredError();
  return s.setState((b) => ({ ...b, chainId: p })), l;
}
function watchAccount(s, A) {
  const { onChange: u } = A;
  return s.subscribe(() => getAccount(s), u, {
    equalityFn(p, t) {
      const { connector: l, ...m } = p, { connector: b, ...k } = t;
      return deepEqual(m, k) && // check connector separately
      (l == null ? void 0 : l.id) === (b == null ? void 0 : b.id) && (l == null ? void 0 : l.uid) === (b == null ? void 0 : b.uid);
    }
  });
}
function watchChainId(s, A) {
  const { onChange: u } = A;
  return s.subscribe((p) => p.chainId, u);
}
function createConnector(s) {
  return s;
}
function extractRpcUrls(s) {
  var l, m, b;
  const { chain: A } = s, u = A.rpcUrls.default.http[0];
  if (!s.transports)
    return [u];
  const p = (m = (l = s.transports) == null ? void 0 : l[A.id]) == null ? void 0 : m.call(l, { chain: A });
  return (((b = p == null ? void 0 : p.value) == null ? void 0 : b.transports) || [p]).map(({ value: k }) => (k == null ? void 0 : k.url) || u);
}
walletConnect.type = "walletConnect";
function walletConnect(s) {
  const A = s.isNewChainsStale ?? !0;
  let u, p;
  const t = "eip155";
  let l, m, b, k, C, B;
  return (Q) => ({
    id: "walletConnect",
    name: "WalletConnect",
    type: walletConnect.type,
    async setup() {
      const P = await this.getProvider().catch(() => null);
      P && (b || (b = this.onConnect.bind(this), P.on("connect", b)), C || (C = this.onSessionDelete.bind(this), P.on("session_delete", C)));
    },
    async connect({ chainId: P, withCapabilities: x, ...M } = {}) {
      var F, le;
      try {
        const ge = await this.getProvider();
        if (!ge)
          throw new ProviderNotFoundError();
        k || (k = this.onDisplayUri, ge.on("display_uri", k));
        let pe = P;
        if (!pe) {
          const Te = await ((F = Q.storage) == null ? void 0 : F.getItem("state")) ?? {};
          Q.chains.some((xe) => xe.id === Te.chainId) ? pe = Te.chainId : pe = (le = Q.chains[0]) == null ? void 0 : le.id;
        }
        if (!pe)
          throw new Error("No chains found on connector.");
        const Ie = await this.isChainsStale();
        if (ge.session && Ie && await ge.disconnect(), !ge.session || Ie) {
          const Te = Q.chains.filter((Qe) => Qe.id !== pe).map((Qe) => Qe.id);
          await ge.connect({
            optionalChains: [pe, ...Te],
            ..."pairingTopic" in M ? { pairingTopic: M.pairingTopic } : {}
          }), this.setRequestedChainsIds(Q.chains.map((Qe) => Qe.id));
        }
        const be = (await ge.enable()).map((Te) => getAddress$1(Te));
        let Pe = await this.getChainId();
        if (P && Pe !== P) {
          const Te = await this.switchChain({ chainId: P }).catch((Qe) => {
            var xe;
            if (Qe.code === UserRejectedRequestError.code && ((xe = Qe.cause) == null ? void 0 : xe.message) !== "Missing or invalid. request() method: wallet_addEthereumChain")
              throw Qe;
            return { id: Pe };
          });
          Pe = (Te == null ? void 0 : Te.id) ?? Pe;
        }
        return k && (ge.removeListener("display_uri", k), k = void 0), b && (ge.removeListener("connect", b), b = void 0), l || (l = this.onAccountsChanged.bind(this), ge.on("accountsChanged", l)), m || (m = this.onChainChanged.bind(this), ge.on("chainChanged", m)), B || (B = this.onDisconnect.bind(this), ge.on("disconnect", B)), C || (C = this.onSessionDelete.bind(this), ge.on("session_delete", C)), {
          accounts: x ? be.map((Te) => ({ address: Te, capabilities: {} })) : be,
          chainId: Pe
        };
      } catch (ge) {
        throw /(user rejected|connection request reset)/i.test(ge == null ? void 0 : ge.message) ? new UserRejectedRequestError(ge) : ge;
      }
    },
    async disconnect() {
      const P = await this.getProvider();
      try {
        await (P == null ? void 0 : P.disconnect());
      } catch (x) {
        if (!/No matching key/i.test(x.message))
          throw x;
      } finally {
        m && (P == null || P.removeListener("chainChanged", m), m = void 0), B && (P == null || P.removeListener("disconnect", B), B = void 0), b || (b = this.onConnect.bind(this), P == null || P.on("connect", b)), l && (P == null || P.removeListener("accountsChanged", l), l = void 0), C && (P == null || P.removeListener("session_delete", C), C = void 0), this.setRequestedChainsIds([]);
      }
    },
    async getAccounts() {
      return (await this.getProvider()).accounts.map((x) => getAddress$1(x));
    },
    async getProvider({ chainId: P } = {}) {
      var M;
      async function x() {
        const F = Q.chains.map((ge) => ge.id);
        if (!F.length)
          return;
        const { EthereumProvider: le } = await import("./index.es-CcK463wX.js");
        return await le.init({
          ...s,
          disableProviderPing: !0,
          optionalChains: F,
          projectId: s.projectId,
          rpcMap: Object.fromEntries(Q.chains.map((ge) => {
            const [pe] = extractRpcUrls({
              chain: ge,
              transports: Q.transports
            });
            return [ge.id, pe];
          })),
          showQrModal: s.showQrModal ?? !0
        });
      }
      return u || (p || (p = x()), u = await p, u == null || u.events.setMaxListeners(Number.POSITIVE_INFINITY)), P && await ((M = this.switchChain) == null ? void 0 : M.call(this, { chainId: P })), u;
    },
    async getChainId() {
      return (await this.getProvider()).chainId;
    },
    async isAuthorized() {
      try {
        const [P, x] = await Promise.all([
          this.getAccounts(),
          this.getProvider()
        ]);
        return P.length ? await this.isChainsStale() && x.session ? (await x.disconnect().catch(() => {
        }), !1) : !0 : !1;
      } catch {
        return !1;
      }
    },
    async switchChain({ addEthereumChainParameter: P, chainId: x }) {
      var le, ge, pe;
      const M = await this.getProvider();
      if (!M)
        throw new ProviderNotFoundError();
      const F = Q.chains.find((Ie) => Ie.id === x);
      if (!F)
        throw new SwitchChainError(new ChainNotConfiguredError());
      try {
        await Promise.all([
          new Promise((be) => {
            const Pe = ({ chainId: Te }) => {
              Te === x && (Q.emitter.off("change", Pe), be());
            };
            Q.emitter.on("change", Pe);
          }),
          M.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: numberToHex$1(x) }]
          })
        ]);
        const Ie = await this.getRequestedChainsIds();
        return this.setRequestedChainsIds([...Ie, x]), F;
      } catch (Ie) {
        const be = Ie;
        if (/(user rejected)/i.test(be.message))
          throw new UserRejectedRequestError(be);
        try {
          let Pe;
          P != null && P.blockExplorerUrls ? Pe = P.blockExplorerUrls : Pe = (le = F.blockExplorers) != null && le.default.url ? [(ge = F.blockExplorers) == null ? void 0 : ge.default.url] : [];
          let Te;
          (pe = P == null ? void 0 : P.rpcUrls) != null && pe.length ? Te = P.rpcUrls : Te = [...F.rpcUrls.default.http];
          const Qe = {
            blockExplorerUrls: Pe,
            chainId: numberToHex$1(x),
            chainName: (P == null ? void 0 : P.chainName) ?? F.name,
            iconUrls: P == null ? void 0 : P.iconUrls,
            nativeCurrency: (P == null ? void 0 : P.nativeCurrency) ?? F.nativeCurrency,
            rpcUrls: Te
          };
          await M.request({
            method: "wallet_addEthereumChain",
            params: [Qe]
          });
          const xe = await this.getRequestedChainsIds();
          return this.setRequestedChainsIds([...xe, x]), F;
        } catch (Pe) {
          throw new UserRejectedRequestError(Pe);
        }
      }
    },
    onAccountsChanged(P) {
      P.length === 0 ? this.onDisconnect() : Q.emitter.emit("change", {
        accounts: P.map((x) => getAddress$1(x))
      });
    },
    onChainChanged(P) {
      const x = Number(P);
      Q.emitter.emit("change", { chainId: x });
    },
    async onConnect(P) {
      const x = Number(P.chainId), M = await this.getAccounts();
      Q.emitter.emit("connect", { accounts: M, chainId: x });
    },
    async onDisconnect(P) {
      this.setRequestedChainsIds([]), Q.emitter.emit("disconnect");
      const x = await this.getProvider();
      l && (x.removeListener("accountsChanged", l), l = void 0), m && (x.removeListener("chainChanged", m), m = void 0), B && (x.removeListener("disconnect", B), B = void 0), C && (x.removeListener("session_delete", C), C = void 0), b || (b = this.onConnect.bind(this), x.on("connect", b));
    },
    onDisplayUri(P) {
      Q.emitter.emit("message", { type: "display_uri", data: P });
    },
    onSessionDelete() {
      this.onDisconnect();
    },
    getNamespaceChainsIds() {
      var x, M, F;
      return u ? ((F = (M = (x = u.session) == null ? void 0 : x.namespaces[t]) == null ? void 0 : M.accounts) == null ? void 0 : F.map((le) => Number.parseInt(le.split(":")[1] || "", 10))) ?? [] : [];
    },
    async getRequestedChainsIds() {
      var P;
      return await ((P = Q.storage) == null ? void 0 : P.getItem(this.requestedChainsStorageKey)) ?? [];
    },
    /**
     * Checks if the target chains match the chains that were
     * initially requested by the connector for the WalletConnect session.
     * If there is a mismatch, this means that the chains on the connector
     * are considered stale, and need to be revalidated at a later point (via
     * connection).
     *
     * There may be a scenario where a dapp adds a chain to the
     * connector later on, however, this chain will not have been approved or rejected
     * by the wallet. In this case, the chain is considered stale.
     */
    async isChainsStale() {
      if (!A)
        return !1;
      const P = Q.chains.map((F) => F.id), x = this.getNamespaceChainsIds();
      if (x.length && !x.some((F) => P.includes(F)))
        return !1;
      const M = await this.getRequestedChainsIds();
      return !P.every((F) => M.includes(F));
    },
    async setRequestedChainsIds(P) {
      var x;
      await ((x = Q.storage) == null ? void 0 : x.setItem(this.requestedChainsStorageKey, P));
    },
    get requestedChainsStorageKey() {
      return `${this.id}.requestedChains`;
    }
  });
}
let sharedWagmiConfig = null;
function setSharedWagmiConfig(s) {
  sharedWagmiConfig && sharedWagmiConfig !== s && console.warn("Shared wagmi config is being replaced. This might indicate multiple initializations."), sharedWagmiConfig = s;
}
function getSharedWagmiConfig() {
  if (!sharedWagmiConfig)
    throw new Error(
      "Shared wagmi config not initialized. Make sure to call setSharedWagmiConfig() in your app before using AppKit."
    );
  return sharedWagmiConfig;
}
function hasSharedWagmiConfig() {
  return sharedWagmiConfig !== null;
}
class AppKitProvider {
  constructor(A) {
    Ci(this, "config");
    Ci(this, "address");
    Ci(this, "chainId");
    Ci(this, "eventHandlers", /* @__PURE__ */ new Map());
    Ci(this, "unwatchFunctions", []);
    this.config = A, this.setupEventWatchers();
  }
  /**
   * Get the shared wagmi config (throws if not set)
   * This ensures we never create multiple wagmi instances
   */
  getWagmiConfig() {
    if (!hasSharedWagmiConfig())
      throw new Error(
        "AppKit ETH not initialized. Ensure AppKit modal is initialized at application startup by calling initializeAppKitModal() with eth config in your app's entry point."
      );
    return getSharedWagmiConfig();
  }
  setupEventWatchers() {
    const A = this.getWagmiConfig(), u = getAccount(A);
    u.address && u.status === "connected" && (this.address = u.address, this.chainId = u.chainId, setTimeout(() => {
      this.emit("accountsChanged", [u.address]);
    }, 100));
    const p = watchAccount(A, {
      onChange: (l) => {
        const m = this.address;
        this.address = l.address, this.chainId = l.chainId, m !== l.address && this.emit("accountsChanged", l.address ? [l.address] : []);
      }
    }), t = watchChainId(A, {
      onChange: (l) => {
        const m = this.chainId;
        this.chainId = l, m !== l && this.emit("chainChanged", `0x${l.toString(16)}`);
      }
    });
    this.unwatchFunctions.push(p, t);
  }
  emit(A, u) {
    const p = this.eventHandlers.get(A);
    p && p.forEach((t) => t(u));
  }
  async connectWallet() {
    try {
      const A = this.getWagmiConfig(), u = getAccount(A);
      if (u.address) {
        this.address = u.address, this.chainId = u.chainId;
        return;
      }
      if (typeof window < "u") {
        window.dispatchEvent(new CustomEvent(APPKIT_OPEN_EVENT)), await new Promise((b, k) => {
          const C = setTimeout(() => {
            B(), k(new Error("Connection timeout"));
          }, 6e4), B = watchAccount(A, {
            onChange: (Q) => {
              Q.address && (clearTimeout(C), B(), this.address = Q.address, this.chainId = Q.chainId, b());
            }
          });
        });
        return;
      }
      const p = process$1.env.NEXT_PUBLIC_REOWN_PROJECT_ID;
      if (!p)
        throw new Error("NEXT_PUBLIC_REOWN_PROJECT_ID environment variable is required");
      const t = walletConnect({
        projectId: p,
        metadata: {
          name: "Babylon Vault",
          description: "",
          url: "",
          icons: [""]
        }
      }), l = await connect(A, { connector: t });
      this.address = l.accounts[0], this.chainId = l.chainId;
    } catch (A) {
      throw console.error("Failed to connect wallet:", A), new Error(`Failed to connect wallet: ${A instanceof Error ? A.message : "Unknown error"}`);
    }
  }
  async disconnect() {
    const A = this.getWagmiConfig();
    try {
      await disconnect(A);
    } finally {
      this.address = void 0, this.chainId = void 0;
    }
  }
  async getAddress() {
    const A = this.getWagmiConfig(), u = getAccount(A);
    if (u.address)
      return this.address = u.address, this.chainId = u.chainId, this.address;
    if (this.address)
      return this.address;
    throw new Error("Wallet not connected");
  }
  async getPublicKeyHex() {
    return this.getAddress();
  }
  async signMessage(A) {
    try {
      const u = this.getWagmiConfig(), p = await this.getAddress();
      return await signMessage(u, {
        message: A,
        account: p
      });
    } catch (u) {
      throw new Error(`Failed to sign message: ${u}`);
    }
  }
  async signTypedData(A) {
    try {
      const u = this.getWagmiConfig(), p = await this.getAddress();
      return await signTypedData(u, {
        account: p,
        domain: {
          ...A.domain,
          salt: A.domain.salt,
          verifyingContract: A.domain.verifyingContract
        },
        types: A.types,
        primaryType: A.primaryType,
        message: A.message
      });
    } catch (u) {
      throw new Error(`Failed to sign typed data: ${u}`);
    }
  }
  async sendTransaction(A) {
    try {
      const u = this.getWagmiConfig(), p = await this.getAddress();
      return await sendTransaction(u, {
        account: p,
        to: A.to,
        value: A.value ? parseEther(A.value) : void 0,
        data: A.data,
        gas: A.gasLimit,
        maxFeePerGas: A.maxFeePerGas,
        maxPriorityFeePerGas: A.maxPriorityFeePerGas,
        nonce: A.nonce
      });
    } catch (u) {
      throw new Error(`Failed to send transaction: ${u}`);
    }
  }
  async estimateGas(A) {
    try {
      const u = this.getWagmiConfig(), p = await this.getAddress();
      return await estimateGas(u, {
        account: p,
        to: A.to,
        value: A.value ? parseEther(A.value) : void 0,
        data: A.data
      });
    } catch (u) {
      throw new Error(`Failed to estimate gas: ${u}`);
    }
  }
  async getChainId() {
    if (this.chainId)
      return this.chainId;
    const A = this.getWagmiConfig(), u = getAccount(A);
    return u.chainId ? (this.chainId = u.chainId, this.chainId) : this.config.chainId;
  }
  async switchChain(A) {
    try {
      const u = this.getWagmiConfig();
      if (![1, 11155111, 31337].includes(A))
        throw new Error(`Unsupported chain ID: ${A}`);
      await switchChain(u, { chainId: A }), this.chainId = A;
    } catch (u) {
      throw new Error(`Failed to switch chain: ${u}`);
    }
  }
  async getBalance() {
    try {
      const A = this.getWagmiConfig(), u = await this.getAddress();
      return (await getBalance(A, {
        address: u
      })).value;
    } catch (A) {
      throw new Error(`Failed to get balance: ${A}`);
    }
  }
  async getNonce() {
    try {
      const A = this.getWagmiConfig(), u = await this.getAddress();
      return await getTransactionCount(A, {
        address: u
      });
    } catch (A) {
      throw new Error(`Failed to get nonce: ${A}`);
    }
  }
  async getNetworkInfo() {
    const A = await this.getChainId();
    return {
      name: this.config.chainName || "Ethereum",
      chainId: A.toString()
    };
  }
  getWalletProviderName() {
    return "AppKit";
  }
  getWalletProviderIcon() {
    return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIgZmlsbD0iIzYyN0VFQSIvPgogIDxwYXRoIGQ9Ik0xNiA0TDcuNSAxNi4yNUwxNiAyMkwyNC41IDE2LjI1TDE2IDR6IiBmaWxsPSJ3aGl0ZSIvPgogIDxwYXRoIGQ9Ik0xNiAyMi43NUw3LjUgMTdMMTYgMjhMMjQuNSAxN0wxNiAyMi43NXoiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuNiIvPgo8L3N2Zz4=";
  }
  on(A, u) {
    this.eventHandlers.has(A) || this.eventHandlers.set(A, /* @__PURE__ */ new Set()), this.eventHandlers.get(A).add(u);
  }
  off(A, u) {
    const p = this.eventHandlers.get(A);
    p && p.delete(u);
  }
  // Cleanup method for proper resource management
  destroy() {
    this.unwatchFunctions.forEach((A) => A()), this.eventHandlers.clear();
  }
}
const WALLET_PROVIDER_NAME = "AppKit", APPKIT_ETH_CONNECTOR_ID = "appkit-eth-connector", metadata$2 = {
  id: APPKIT_ETH_CONNECTOR_ID,
  name: WALLET_PROVIDER_NAME,
  icon: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIgZmlsbD0iIzYyN0VFQSIvPgogIDxwYXRoIGQ9Ik0xNiA0TDcuNSAxNi4yNUwxNiAyMkwyNC41IDE2LjI1TDE2IDR6IiBmaWxsPSJ3aGl0ZSIvPgogIDxwYXRoIGQ9Ik0xNiAyMi43NUw3LjUgMTdMMTYgMjhMMjQuNSAxN0wxNiAyMi43NXoiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuNiIvPgo8L3N2Zz4=",
  docs: "https://docs.reown.com/appkit/overview",
  wallet: "ethereum",
  // Global identifier for Ethereum providers
  createProvider: (s, A) => new AppKitProvider(A),
  networks: [
    Network.MAINNET,
    // ETH mainnet (chainId: 1)
    Network.TESTNET,
    // ETH testnet (chainId: 11155111 - Sepolia)
    Network.SIGNET
    // Also allow SIGNET/devnet/localhost environments
  ],
  label: "Connect ETH Wallet"
}, icon = "data:image/svg+xml,%3csvg%20enable-background='new%200%200%201920%201920'%20viewBox='0%200%201920%201920'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='m959.8%2080.7-539.7%20895.6%20539.7-245.3z'%20fill='%238a92b2'/%3e%3cpath%20d='m959.8%20731-539.7%20245.3%20539.7%20319.1z'%20fill='%2362688f'/%3e%3cpath%20d='m1499.6%20976.3-539.8-895.6v650.3z'%20fill='%2362688f'/%3e%3cpath%20d='m959.8%201295.4%20539.8-319.1-539.8-245.3z'%20fill='%23454a75'/%3e%3cpath%20d='m420.1%201078.7%20539.7%20760.6v-441.7z'%20fill='%238a92b2'/%3e%3cpath%20d='m959.8%201397.6v441.7l540.1-760.6z'%20fill='%2362688f'/%3e%3c/svg%3e", metadata$1 = {
  chain: "ETH",
  name: "Ethereum",
  // icon: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIgZmlsbD0iIzYyN0VFQSIvPgogIDxwYXRoIGQ9Ik0xNiA0TDcuNSAxNi4yNUwxNiAyMkwyNC41IDE2LjI1TDE2IDR6IiBmaWxsPSJ3aGl0ZSIvPgogIDxwYXRoIGQ9Ik0xNiAyMi43NUw3LjUgMTdMMTYgMjhMMjQuNSAxN0wxNiAyMi43NXoiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuNiIvPgo8L3N2Zz4=",
  icon,
  wallets: [metadata$2]
}, metadata = { BTC: metadata$3, BBN: metadata$c, ETH: metadata$1 };
function usePersistState(s, A, u) {
  function p() {
    const m = u;
    if (typeof A > "u")
      return m;
    const b = A.getItem(s);
    return (b ? JSON.parse(b) : null) ?? m;
  }
  const [t, l] = useState(p);
  return useEffect(
    function() {
      A.setItem(s, JSON.stringify(t ?? ""));
    },
    [s, A, t]
  ), [t, l];
}
const Context$2 = createContext({ lockInscriptions: !0, showAgain: !0 });
function InscriptionProvider({ children: s, context: A }) {
  const [u, p] = usePersistState("bwc-inscription-modal-show-again", A.localStorage, !0), [t, l] = usePersistState(
    "bwc-inscription-modal-lock",
    A.localStorage,
    !0
  ), m = useMemo(
    () => ({
      showAgain: u,
      lockInscriptions: t,
      toggleLockInscriptions: l,
      toggleShowAgain: p
    }),
    [u, t, l, p]
  );
  return /* @__PURE__ */ jsx(Context$2.Provider, { value: m, children: s });
}
const useInscriptionProvider = () => useContext(Context$2), defaultState$2 = {
  confirmed: !1,
  visible: !1,
  screen: { type: "TERMS_OF_SERVICE" },
  chains: {},
  selectedWallets: {}
}, StateContext = createContext(defaultState$2);
function filterWalletsByValidChains(s, A) {
  return Object.keys(s).reduce((u, p) => (A.has(p) && (u[p] = s[p]), u), {});
}
function StateProvider({ children: s, chains: A }) {
  const [u, p] = useState(defaultState$2);
  useEffect(() => {
    p((m) => {
      const b = A.reduce((B, Q) => ({ ...B, [Q.id]: Q }), {}), k = new Set(A.map((B) => B.id)), C = filterWalletsByValidChains(m.selectedWallets, k);
      return { ...m, chains: b, selectedWallets: C };
    });
  }, [A]);
  const t = useMemo(
    () => ({
      open: () => {
        p((m) => ({ ...m, visible: !0 }));
      },
      close: () => {
        p((m) => ({ ...m, visible: !1 }));
      },
      reset: () => {
        p(({ chains: m }) => ({ ...defaultState$2, chains: m }));
      },
      displayLoader: (m = "") => {
        p((b) => ({ ...b, screen: { type: "LOADER", params: { message: m } } }));
      },
      displayTermsOfService: () => {
        p((m) => ({ ...m, screen: { type: "TERMS_OF_SERVICE" } }));
      },
      displayChains: () => {
        p((m) => ({ ...m, screen: { type: "CHAINS" } }));
      },
      displayWallets: (m) => {
        p((b) => ({ ...b, screen: { type: "WALLETS", params: { chain: m } } }));
      },
      displayInscriptions: () => {
        p((m) => ({ ...m, screen: { type: "INSCRIPTIONS" } }));
      },
      displayError: (m) => {
        p((b) => ({ ...b, screen: { type: "ERROR", params: m } }));
      },
      selectWallet: (m, b) => {
        p((k) => ({
          ...k,
          selectedWallets: { ...k.selectedWallets, [m]: b }
        }));
      },
      removeWallet: (m) => {
        p((b) => ({
          ...b,
          selectedWallets: { ...b.selectedWallets, [m]: void 0 }
        }));
      },
      confirm: () => {
        p((m) => ({ ...m, confirmed: !0 }));
      }
    }),
    []
  ), l = useMemo(
    () => ({
      ...u,
      ...t
    }),
    [u, t]
  );
  return /* @__PURE__ */ jsx(StateContext.Provider, { value: l, children: s });
}
const defaultState$1 = {
  BTC: null,
  BBN: null,
  ETH: null
}, Context$1 = createContext(defaultState$1);
function ChainProvider({
  persistent: s,
  storage: A,
  children: u,
  context: p,
  config: t,
  onError: l,
  disabledWallets: m,
  requiredChains: b
}) {
  const [k, C] = useState(defaultState$1), B = useCallback(async () => {
    const x = t.filter((F) => metadata[F.chain]).map(
      ({ chain: F, config: le }) => createWalletConnector({
        persistent: s,
        metadata: metadata[F],
        context: p,
        config: le,
        accountStorage: A,
        disabledWallets: m
      })
    );
    return (await Promise.all(x)).reduce((F, le) => ({ ...F, [le.id]: le }), {});
  }, [s, t, p, A, m]);
  useEffect(() => {
    B().then((x) => {
      C(x);
    }).catch(l);
  }, [C, B, l]);
  const Q = useMemo(() => Object.values(k).filter(Boolean), [k]), P = useMemo(
    () => b && b.length ? Q.filter((x) => b.includes(x.id)) : Q,
    [Q, b]
  );
  return /* @__PURE__ */ jsx(InscriptionProvider, { context: p, children: /* @__PURE__ */ jsx(StateProvider, { chains: P, children: /* @__PURE__ */ jsx(Context$1.Provider, { value: k, children: u }) }) });
}
const useChainProviders = () => useContext(Context$1), Context = createContext({});
function LifeCycleHooksProvider({ children: s, value: A }) {
  const u = useMemo(() => A ?? {}, [A]);
  return /* @__PURE__ */ jsx(Context.Provider, { value: u, children: s });
}
const useLifeCycleHooks = () => useContext(Context), CONFIG_ADAPTERS = {
  BTC: (s) => ({
    id: 1,
    name: s.networkName,
    type: "bitcoin",
    network: s.network,
    backendUrls: {
      mempoolUrl: s.mempoolApiUrl + "/api/"
    }
  }),
  BBN: (s) => ({
    id: 2,
    name: s.chainData.chainName,
    type: "cosmos",
    network: s.chainId,
    modularData: s.chainData,
    backendUrls: {
      rpcUrl: s.rpc
    },
    logo: s.chainData.chainSymbolImageUrl
  }),
  ETH: (s) => ({
    id: 3,
    name: s.chainName,
    type: "ethereum",
    chainId: s.chainId,
    rpcUrl: s.rpcUrl,
    explorerUrl: s.explorerUrl,
    nativeCurrency: s.nativeCurrency
  })
}, TomoConnectionProvider = ({ children: s, theme: A, config: u }) => {
  const p = useMemo(
    () => u.reduce(
      (t, l) => {
        var m;
        return { ...t, [l.chain]: (m = CONFIG_ADAPTERS[l.chain]) == null ? void 0 : m.call(CONFIG_ADAPTERS, l.config) };
      },
      {}
    ),
    [u]
  );
  return /* @__PURE__ */ jsx(
    Dn,
    {
      autoReconnect: !1,
      bitcoinChains: [p.BTC],
      chainTypes: ["bitcoin", "cosmos"],
      cosmosChains: [p.BBN],
      style: {
        rounded: "medium",
        theme: A,
        primaryColor: "#FF7C2A"
      },
      children: s
    }
  );
}, CONNECTED_ACCOUNTS_KEY = "baby-connected-wallet-accounts", createAccountStorage = (s) => ({
  get: (A) => {
    const u = localStorage.getItem(CONNECTED_ACCOUNTS_KEY) ? JSON.parse(localStorage.getItem(CONNECTED_ACCOUNTS_KEY) || "{}") : {};
    if (!(u._timestamp && Date.now() - u._timestamp > s))
      return u[A];
  },
  has: (A) => {
    const u = localStorage.getItem(CONNECTED_ACCOUNTS_KEY) ? JSON.parse(localStorage.getItem(CONNECTED_ACCOUNTS_KEY) || "{}") : {};
    return u._timestamp && Date.now() - u._timestamp > s ? !1 : !!u[A];
  },
  set: (A, u) => {
    const p = localStorage.getItem(CONNECTED_ACCOUNTS_KEY) ? JSON.parse(localStorage.getItem(CONNECTED_ACCOUNTS_KEY) || "{}") : {};
    p[A] = u, p._timestamp = Date.now(), localStorage.setItem(CONNECTED_ACCOUNTS_KEY, JSON.stringify(p));
  },
  delete: (A) => {
    const u = localStorage.getItem(CONNECTED_ACCOUNTS_KEY) ? JSON.parse(localStorage.getItem(CONNECTED_ACCOUNTS_KEY) || "{}") : {}, p = Reflect.deleteProperty(u, A);
    return localStorage.setItem(CONNECTED_ACCOUNTS_KEY, JSON.stringify(u)), p;
  }
});
let appKitModal = null, wagmiAdapter = null, bitcoinAdapter = null;
function getAppKitModal() {
  return appKitModal;
}
function initializeAppKitModal(s) {
  var l, m, b;
  if (appKitModal)
    return {
      modal: appKitModal,
      wagmiConfig: wagmiAdapter == null ? void 0 : wagmiAdapter.wagmiConfig,
      bitcoinAdapter
    };
  if (!s.projectId)
    return null;
  const A = s.projectId, u = s.metadata, p = [], t = [];
  if ((l = s.eth) != null && l.chain) {
    const k = [s.eth.chain];
    p.push(...k);
    const C = createStorage({
      storage: cookieStorage
    });
    wagmiAdapter = new WagmiAdapter({
      networks: k,
      projectId: A,
      ssr: !1,
      storage: C
    }), t.push(wagmiAdapter), setSharedWagmiConfig(wagmiAdapter.wagmiConfig);
  }
  if ((m = s.btc) != null && m.network) {
    const k = s.btc.network === "mainnet" ? bitcoin$2 : bitcoinSignet;
    p.push(k), bitcoinAdapter = new BitcoinAdapter({
      networks: [k]
    }), t.push(bitcoinAdapter);
  }
  return p.length === 0 ? null : (appKitModal = createAppKit({
    adapters: t,
    networks: p,
    projectId: A,
    metadata: u
  }), bitcoinAdapter && ((b = s.btc) != null && b.network) && setSharedBtcAppKitConfig({
    modal: appKitModal,
    adapter: bitcoinAdapter,
    network: s.btc.network
  }), {
    modal: appKitModal,
    wagmiConfig: wagmiAdapter == null ? void 0 : wagmiAdapter.wagmiConfig,
    bitcoinAdapter
  });
}
const useAppKitOpenListener = () => {
  useEffect(() => {
    const s = () => {
      try {
        const A = getAppKitModal();
        A && A.open();
      } catch (A) {
        console.warn("AppKit modal not available:", A);
      }
    };
    return window.addEventListener(APPKIT_OPEN_EVENT, s), () => window.removeEventListener(APPKIT_OPEN_EVENT, s);
  }, []);
};
function useChainConnector(s) {
  const A = useChainProviders();
  return (A == null ? void 0 : A[s]) ?? null;
}
const createProvider$1 = (s) => ({
  connectWallet: async () => void await s.connectWallet(),
  getAddress: () => s.getAddress(),
  getPublicKeyHex: () => s.getPublicKeyHex(),
  getWalletProviderName: () => s.getWalletProviderName(),
  getWalletProviderIcon: () => s.getWalletProviderIcon(),
  getOfflineSigner: () => s.getOfflineSigner(),
  on: () => {
  },
  off: () => {
  }
}), TomoBBNConnector = memo(({ persistent: s, storage: A }) => {
  const u = Fn(), p = Nn("cosmos"), { cosmosProvider: t } = Hn(), l = Jn(), m = _0(), b = useChainConnector("BBN"), k = useMemo(() => {
    const { connected: B, walletId: Q } = u.cosmos ?? {};
    return B && Q ? p.find((P) => P.id === Q) ?? null : null;
  }, [u.cosmos, p]), C = useCallback(
    async (B, Q) => {
      if (!b) return;
      const P = createExternalWallet({
        id: `tomo.${B.id}`,
        name: B.name,
        icon: B.img,
        provider: createProvider$1(Q)
      });
      await b.connect(P);
    },
    [b]
  );
  return useEffect(() => {
    if (!s) return;
    const B = A.get("BBN");
    if (!B || !B.startsWith("tomo.")) return;
    const Q = B.replace("tomo.", ""), P = p.find((x) => x.id === Q);
    P && m(P);
  }, [p, s, A]), useEffect(() => {
    k && t && C(k, t);
  }, [k, t, C]), useEffect(() => b ? b.on("disconnect", (Q) => {
    Q != null && Q.id.startsWith("tomo.") && l.disconnect();
  }) : void 0, [b, l]), null;
});
TomoBBNConnector.displayName = "TomoBBNConnector";
const createProvider = (s) => ({
  connectWallet: async () => void await s.connectWallet(),
  getAddress: () => s.getAddress(),
  getPublicKeyHex: () => s.getPublicKeyHex(),
  signPsbt: (A, u) => s.signPsbt(A, u),
  signPsbts: (A, u) => s.signPsbts(A, u),
  getNetwork: () => s.getNetwork(),
  signMessage: (A, u) => s.signMessage(A, u),
  on: (A, u) => s.on(A, u),
  off: (A, u) => s.off(A, u),
  getWalletProviderName: () => s.getWalletProviderName(),
  getWalletProviderIcon: () => s.getWalletProviderIcon(),
  getInscriptions: () => s.getInscriptions().then(
    (A) => (A.list || []).map((u) => ({
      txid: u.inscriptionId,
      vout: u.outputValue
    }))
  )
}), TomoBTCConnector = memo(({ persistent: s, storage: A }) => {
  const u = Fn(), p = Nn("bitcoin"), { bitcoinProvider: t } = Hn(), l = Jn(), m = _0(), b = useChainConnector("BTC"), k = useMemo(() => {
    const { connected: B, walletId: Q } = u.bitcoin ?? {};
    return B && Q ? p.find((P) => P.id === Q) ?? null : null;
  }, [u.bitcoin, p]), C = useCallback(
    async (B, Q) => {
      if (!b) return;
      const P = createExternalWallet({
        id: `tomo.${B.id}`,
        name: B.name,
        icon: B.img,
        provider: createProvider(Q)
      });
      await b.connect(P);
    },
    [b]
  );
  return useEffect(() => {
    if (!s) return;
    const B = A.get("BTC");
    if (!B || !B.startsWith("tomo.")) return;
    const Q = B.replace("tomo.", ""), P = p.find((x) => x.id === Q);
    P && m(P);
  }, [p, s, A]), useEffect(() => {
    k && t && C(k, t);
  }, [k, t, C]), useEffect(() => b ? b.on("disconnect", (Q) => {
    Q != null && Q.id.startsWith("tomo.") && l.disconnect();
  }) : void 0, [b, l]), null;
});
TomoBTCConnector.displayName = "TomoBTCConnector";
var lodash_debounce, hasRequiredLodash_debounce;
function requireLodash_debounce() {
  if (hasRequiredLodash_debounce) return lodash_debounce;
  hasRequiredLodash_debounce = 1;
  var s = "Expected a function", A = NaN, u = "[object Symbol]", p = /^\s+|\s+$/g, t = /^[-+]0x[0-9a-f]+$/i, l = /^0b[01]+$/i, m = /^0o[0-7]+$/i, b = parseInt, k = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, C = typeof self == "object" && self && self.Object === Object && self, B = k || C || Function("return this")(), Q = Object.prototype, P = Q.toString, x = Math.max, M = Math.min, F = function() {
    return B.Date.now();
  };
  function le(Pe, Te, Qe) {
    var xe, Ee, He, ve, we, Ce, Se = 0, Ne = !1, rr = !1, er = !0;
    if (typeof Pe != "function")
      throw new TypeError(s);
    Te = be(Te) || 0, ge(Qe) && (Ne = !!Qe.leading, rr = "maxWait" in Qe, He = rr ? x(be(Qe.maxWait) || 0, Te) : He, er = "trailing" in Qe ? !!Qe.trailing : er);
    function ir(qr) {
      var Hr = xe, un = Ee;
      return xe = Ee = void 0, Se = qr, ve = Pe.apply(un, Hr), ve;
    }
    function sr(qr) {
      return Se = qr, we = setTimeout(lr, Te), Ne ? ir(qr) : ve;
    }
    function nr(qr) {
      var Hr = qr - Ce, un = qr - Se, Dr = Te - Hr;
      return rr ? M(Dr, He - un) : Dr;
    }
    function fr(qr) {
      var Hr = qr - Ce, un = qr - Se;
      return Ce === void 0 || Hr >= Te || Hr < 0 || rr && un >= He;
    }
    function lr() {
      var qr = F();
      if (fr(qr))
        return br(qr);
      we = setTimeout(lr, nr(qr));
    }
    function br(qr) {
      return we = void 0, er && xe ? ir(qr) : (xe = Ee = void 0, ve);
    }
    function Br() {
      we !== void 0 && clearTimeout(we), Se = 0, xe = Ce = Ee = we = void 0;
    }
    function Fr() {
      return we === void 0 ? ve : br(F());
    }
    function Gr() {
      var qr = F(), Hr = fr(qr);
      if (xe = arguments, Ee = this, Ce = qr, Hr) {
        if (we === void 0)
          return sr(Ce);
        if (rr)
          return we = setTimeout(lr, Te), ir(Ce);
      }
      return we === void 0 && (we = setTimeout(lr, Te)), ve;
    }
    return Gr.cancel = Br, Gr.flush = Fr, Gr;
  }
  function ge(Pe) {
    var Te = typeof Pe;
    return !!Pe && (Te == "object" || Te == "function");
  }
  function pe(Pe) {
    return !!Pe && typeof Pe == "object";
  }
  function Ie(Pe) {
    return typeof Pe == "symbol" || pe(Pe) && P.call(Pe) == u;
  }
  function be(Pe) {
    if (typeof Pe == "number")
      return Pe;
    if (Ie(Pe))
      return A;
    if (ge(Pe)) {
      var Te = typeof Pe.valueOf == "function" ? Pe.valueOf() : Pe;
      Pe = ge(Te) ? Te + "" : Te;
    }
    if (typeof Pe != "string")
      return Pe === 0 ? Pe : +Pe;
    Pe = Pe.replace(p, "");
    var Qe = l.test(Pe);
    return Qe || m.test(Pe) ? b(Pe.slice(2), Qe ? 2 : 8) : t.test(Pe) ? A : +Pe;
  }
  return lodash_debounce = le, lodash_debounce;
}
requireLodash_debounce();
var useIsomorphicLayoutEffect = typeof window < "u" ? useLayoutEffect : useEffect, IS_SERVER2 = typeof window > "u";
function useMediaQuery(s, {
  defaultValue: A = !1,
  initializeWithValue: u = !0
} = {}) {
  const p = (b) => IS_SERVER2 ? A : window.matchMedia(b).matches, [t, l] = useState(() => u ? p(s) : A);
  function m() {
    l(p(s));
  }
  return useIsomorphicLayoutEffect(() => {
    const b = window.matchMedia(s);
    return m(), b.addListener ? b.addListener(m) : b.addEventListener("change", m), () => {
      b.removeListener ? b.removeListener(m) : b.removeEventListener("change", m);
    };
  }, [s]), t;
}
const useIsMobileView = () => useMediaQuery("(max-width: 768px)");
function ResponsiveDialog(s) {
  const u = useIsMobileView() ? MobileDialog : Dialog;
  return /* @__PURE__ */ jsx(u, { ...s });
}
const useWidgetState = () => useContext(StateContext);
function useWalletConnect() {
  const { confirmed: s, chains: A, selectedWallets: u, open: p, reset: t } = useWidgetState(), l = useChainProviders(), m = useCallback(() => {
    t == null || t(), p == null || p();
  }, [p, t]), b = useCallback(async () => {
    for (const C of Object.values(l))
      C && await C.disconnect();
    t == null || t();
  }, [l, t]), k = useMemo(() => Object.values(A).filter(Boolean).map((Q) => u[Q.id]).every(Boolean), [A, u]);
  return {
    selected: k,
    connected: k && s,
    open: m,
    disconnect: b
  };
}
function useWalletConnectors({ persistent: s, accountStorage: A, onError: u }) {
  const p = useChainProviders(), {
    visible: t,
    selectWallet: l,
    removeWallet: m,
    displayLoader: b,
    displayChains: k,
    displayInscriptions: C,
    displayError: B,
    confirm: Q,
    close: P,
    reset: x,
    chains: M
  } = useWidgetState(), { showAgain: F } = useInscriptionProvider(), { verifyBTCAddress: le, acceptTermsOfService: ge } = useLifeCycleHooks();
  useEffect(() => {
    if (!t) return;
    const Pe = Object.values(p).filter(Boolean).map(
      (Te) => Te.on("connecting", (Qe) => {
        b == null || b(Qe);
      })
    );
    return () => Pe.forEach((Te) => Te());
  }, [t, b, p]), useEffect(() => {
    const be = Object.values(p).filter(Boolean), Pe = {
      BTC: (Qe) => async (xe) => {
        var Ee, He, ve, we;
        try {
          if (!xe || !xe.account || (l == null || l("BTC", xe), s && ((Ee = xe.account) != null && Ee.address) && A.set(Qe.id, xe.id), !t)) return;
          validateAddress(Qe.config.network, xe.account.address), await (ge == null ? void 0 : ge({
            address: xe.account.address,
            public_key: xe.account.publicKeyHex
          }));
          const Ce = () => void (F ? C == null ? void 0 : C() : k == null ? void 0 : k());
          if (!validateAddressWithPK(
            ((He = xe.account) == null ? void 0 : He.address) ?? "",
            ((ve = xe.account) == null ? void 0 : ve.publicKeyHex) ?? "",
            Qe.config.network
          )) {
            B == null || B({
              title: "Public Key Mismatch",
              description: "The Bitcoin address and Public Key for this wallet do not match. Please contact your wallet provider for support.",
              onSubmit: Ce,
              onCancel: () => {
                Qe.disconnect(), m == null || m(Qe.id), k == null || k();
              }
            });
            return;
          }
          if (le && !await le(((we = xe.account) == null ? void 0 : we.address) ?? "")) {
            B == null || B({
              title: "Staking Currently Unavailable",
              description: "Staking is temporarily disabled due to network downtime. New stakes are paused until the network resumes.",
              submitButton: "",
              cancelButton: "Done",
              onCancel: async () => {
                Qe.disconnect(), m == null || m(Qe.id), k == null || k();
              }
            });
            return;
          }
          Ce();
        } catch (Ce) {
          Qe.disconnect(), m == null || m(Qe.id), B == null || B({
            title: "Connection Failed",
            description: Ce.message,
            submitButton: "",
            cancelButton: "Done",
            onCancel: async () => {
              k == null || k();
            }
          });
        }
      },
      BBN: (Qe) => (xe) => {
        var Ee;
        xe && (l == null || l(Qe.id, xe), s && ((Ee = xe.account) != null && Ee.address) && A.set(Qe.id, xe.id)), k == null || k();
      },
      ETH: (Qe) => (xe) => {
        var Ee;
        xe && (l == null || l(Qe.id, xe), s && ((Ee = xe.account) != null && Ee.address) && A.set(Qe.id, xe.id)), k == null || k();
      }
    }, Te = be.map(
      (Qe) => {
        var xe;
        return Qe.on("connect", (xe = Pe[Qe.id]) == null ? void 0 : xe.call(Pe, Qe));
      }
    );
    return be.forEach((Qe) => {
      l == null || l(Qe.id, Qe.connectedWallet);
    }), () => Te.forEach((Qe) => Qe());
  }, [
    u,
    l,
    m,
    C,
    k,
    le,
    x,
    P,
    p,
    F,
    s,
    t
  ]), useEffect(() => {
    const Pe = Object.values(p).filter(Boolean).map(
      (Te) => Te.on("disconnect", (Qe) => {
        Qe && (m == null || m(Te.id), k == null || k(), s && A.delete(Te.id));
      })
    );
    return () => Pe.forEach((Te) => Te());
  }, [m, k, p, s]), useEffect(() => {
    const Pe = Object.values(p).filter(Boolean).map(
      (Te) => Te.on("error", (Qe) => {
        u == null || u(Qe), k == null || k();
      })
    );
    return () => Pe.forEach((Te) => Te());
  }, [u, k, p]), useEffect(() => {
    const be = Object.values(M).filter(Boolean).map((Ee) => Ee.id), Te = Object.values(p).filter(Boolean).filter(
      (Ee) => be.includes(Ee.id)
    ), Qe = Te.every((Ee) => A.has(Ee.id)), xe = Te.every((Ee) => Ee.connectedWallet !== null);
    s && Te.length && Qe && xe && (Q == null || Q(), k == null || k());
  }, [
    s,
    p,
    M,
    Q,
    k,
    A
  ]);
  const pe = useCallback(
    async (be, Pe) => {
      const Te = p[be.id];
      await (Te == null ? void 0 : Te.connect(Pe.id));
    },
    [p]
  ), Ie = useCallback(
    async (be) => {
      const Pe = p[be];
      await (Pe == null ? void 0 : Pe.disconnect());
    },
    [p]
  );
  return { connect: pe, disconnect: Ie };
}
function useWalletWidgets(s, A, u) {
  const p = useCallback(
    (t, l) => /* @__PURE__ */ jsx(Fragment, { children: l.map(({ id: m, widget: b }) => /* @__PURE__ */ jsx(
      b,
      {
        id: m,
        connector: s[t],
        createWallet: createExternalWallet,
        onError: u
      },
      m
    )) }),
    [s, u]
  );
  return useMemo(
    () => A.reduce(
      (t, l) => ({
        ...t,
        [l.chain]: p(l.chain, l.connectors ?? [])
      }),
      {}
    ),
    [p, A]
  );
}
function ChainButton({ className: s, disabled: A, alt: u, logo: p, title: t, children: l, onClick: m }) {
  const b = typeof p == "string" ? /* @__PURE__ */ jsx(Avatar, { url: p, alt: u }) : /* @__PURE__ */ jsx(Avatar, { children: p }), k = () => {
    if (typeof t == "string") {
      if (t.includes("Bitcoin")) return "select-bitcoin-wallet-button";
      if (t.includes("Babylon")) return "select-babylon-wallet-button";
    }
    return "chain-button";
  };
  return /* @__PURE__ */ jsxs(
    Text,
    {
      disabled: A,
      as: A ? "div" : "button",
      className: twMerge(
        "flex w-full flex-col gap-2.5 rounded border border-secondary-strokeLight bg-surface p-4 text-accent-primary",
        A ? "pointer-events-none" : "pointer-events-auto",
        A ? "cursor-default" : "cursor-pointer",
        s
      ),
      onClick: m,
      "data-testid": k(),
      children: [
        /* @__PURE__ */ jsxs("div", { className: "flex w-full items-center gap-2.5", children: [
          /* @__PURE__ */ jsx("div", { className: "flex items-center", children: b }),
          t,
          !A && /* @__PURE__ */ jsx(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              className: "ml-auto block",
              children: /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M8.58984 16.59L13.1698 12L8.58984 7.41L9.99984 6L15.9998 12L9.99984 18L8.58984 16.59Z",
                  fill: "currentColor"
                }
              )
            }
          )
        ] }),
        l && /* @__PURE__ */ jsx("div", { className: "pointer-events-auto w-full", onClick: (C) => C.stopPropagation(), children: l })
      ]
    }
  );
}
const formatAddress = (s, A = 8) => s.length <= A ? s : A === 0 ? "..." : `${s.slice(0, A / 2)}...${s.slice(-A / 2)}`, ConnectedWallet = memo(
  ({ className: s, chainId: A, logo: u, name: p, address: t, onDisconnect: l }) => /* @__PURE__ */ jsxs(
    "div",
    {
      className: twMerge("flex shrink-0 items-center gap-2.5 rounded border border-secondary-main/30 p-2", s),
      children: [
        /* @__PURE__ */ jsx(Avatar, { variant: "rounded", size: "medium", url: u }),
        /* @__PURE__ */ jsxs("div", { className: "flex flex-1 flex-col items-start", children: [
          /* @__PURE__ */ jsx(Text, { as: "div", variant: "body2", className: "leading-4 text-accent-primary", children: p }),
          !!t && /* @__PURE__ */ jsx(Text, { as: "div", variant: "caption", className: "leading-4 text-accent-secondary", children: formatAddress(t) })
        ] }),
        /* @__PURE__ */ jsx("button", { className: "shrink-0 cursor-pointer", onClick: () => void (l == null ? void 0 : l(A)), children: /* @__PURE__ */ jsx(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            className: "text-secondary-main",
            fill: "none",
            children: /* @__PURE__ */ jsx(
              "path",
              {
                d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
                fill: "currentColor"
              }
            )
          }
        ) })
      ]
    }
  )
), Chains = memo(
  ({
    disabled: s = !1,
    chains: A,
    selectedWallets: u = {},
    className: p,
    onClose: t,
    onConfirm: l,
    onSelectChain: m,
    onDisconnectWallet: b
  }) => {
    const C = `Connect to both ${A.map((B) => B.name).join(" and ")} Wallets`;
    return /* @__PURE__ */ jsxs("div", { className: twMerge("flex flex-1 flex-col text-accent-primary", p), children: [
      /* @__PURE__ */ jsx(DialogHeader, { className: "mb-10", title: "Connect Wallets", onClose: t, children: /* @__PURE__ */ jsx(Text, { className: "text-accent-secondary", children: C }) }),
      /* @__PURE__ */ jsx(DialogBody, { className: "flex flex-col gap-6", children: A.map((B) => {
        var P;
        const Q = u[B.id];
        return /* @__PURE__ */ jsx(
          ChainButton,
          {
            disabled: !!Q,
            title: `Select ${B.name} Wallet`,
            logo: B.icon,
            alt: B.name,
            onClick: () => void (m == null ? void 0 : m(B)),
            children: Q && /* @__PURE__ */ jsx(
              ConnectedWallet,
              {
                chainId: B.id,
                logo: Q.icon,
                name: Q.name,
                address: ((P = Q.account) == null ? void 0 : P.address) ?? "",
                onDisconnect: b
              }
            )
          },
          B.id
        );
      }) }),
      /* @__PURE__ */ jsxs(DialogFooter, { className: "mt-auto flex gap-4 pt-10", children: [
        /* @__PURE__ */ jsx(Button, { variant: "outlined", fluid: !0, onClick: t, children: "Cancel" }),
        /* @__PURE__ */ jsx(Button, { disabled: s, fluid: !0, onClick: l, "data-testid": "chains-done-button", children: "Done" })
      ] })
    ] });
  }
);
function ChainsContainer(s) {
  const { chains: A, selectedWallets: u, displayWallets: p } = useWidgetState(), { selected: t } = useWalletConnect(), l = useChainProviders(), m = useMemo(() => Object.values(A), [A]), b = useCallback(
    async (k) => {
      if (k.id === "ETH") {
        const C = l.ETH, B = C == null ? void 0 : C.wallets.find((Q) => Q.id === APPKIT_ETH_CONNECTOR_ID);
        if (B && (C == null ? void 0 : C.wallets.length) === 1) {
          try {
            await C.connect(B);
          } catch (Q) {
            console.error("Failed to connect AppKit:", Q);
          }
          return;
        }
      }
      if (k.id === "BTC") {
        const C = l.BTC, B = C == null ? void 0 : C.wallets.find((Q) => Q.id === APPKIT_BTC_CONNECTOR_ID);
        if (B && (C == null ? void 0 : C.wallets.length) === 1) {
          try {
            await C.connect(B);
          } catch (Q) {
            console.error("Failed to connect AppKit BTC:", Q);
          }
          return;
        }
      }
      p == null || p(k.id);
    },
    [p, l]
  );
  return /* @__PURE__ */ jsx(
    Chains,
    {
      disabled: !t,
      chains: m,
      selectedWallets: u,
      onSelectChain: b,
      ...s
    }
  );
}
const DEFAULT_ICON = /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "52", height: "52", viewBox: "0 0 52 52", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M2.16675 46.5837H49.8334L26.0001 5.41699L2.16675 46.5837ZM28.1667 40.0837H23.8334V35.7503H28.1667V40.0837ZM28.1667 31.417H23.8334V22.7503H28.1667V31.417Z",
    fill: "#387085"
  }
) });
function Error$1({
  className: s,
  icon: A = DEFAULT_ICON,
  title: u,
  description: p,
  cancelButton: t = "Cancel",
  submitButton: l = /* @__PURE__ */ jsxs(Fragment, { children: [
    "Continue ",
    /* @__PURE__ */ jsx("span", { className: "hidden md:inline", children: "Anyway" })
  ] }),
  onCancel: m,
  onSubmit: b
}) {
  return /* @__PURE__ */ jsxs("div", { className: s, children: [
    /* @__PURE__ */ jsxs(DialogBody, { className: "py-16 text-center", children: [
      /* @__PURE__ */ jsx("div", { className: "mb-6 inline-flex size-20 items-center justify-center bg-primary-contrast text-primary-light", children: A }),
      /* @__PURE__ */ jsx(Heading, { variant: "h4", className: "mb-4 text-accent-primary", children: u }),
      /* @__PURE__ */ jsx(Text, { as: "div", className: "text-accent-secondary", children: p })
    ] }),
    /* @__PURE__ */ jsxs(DialogFooter, { className: "flex gap-4", children: [
      t && /* @__PURE__ */ jsx(Button, { variant: "outlined", fluid: !0, onClick: m, children: t }),
      l && /* @__PURE__ */ jsx(Button, { fluid: !0, onClick: b, "data-testid": "error-continue-button", children: l })
    ] })
  ] });
}
function ErrorContainer({ className: s }) {
  const { screen: A } = useWidgetState(), { icon: u, title: p, description: t, cancelButton: l, submitButton: m, onCancel: b, onSubmit: k } = A.params ?? {};
  return /* @__PURE__ */ jsx(
    Error$1,
    {
      className: s,
      icon: u,
      title: p,
      description: t,
      cancelButton: l,
      submitButton: m,
      onCancel: b,
      onSubmit: k
    }
  );
}
function FieldControl({ label: s, className: A, children: u }) {
  return /* @__PURE__ */ jsxs(
    "label",
    {
      className: twMerge(
        "flex cursor-pointer gap-4 rounded border border-secondary-strokeLight text-accent-primary p-4",
        A
      ),
      children: [
        u,
        s
      ]
    }
  );
}
function Inscriptions({ className: s, config: A, onSubmit: u }) {
  const [p = !0, t] = useState(), [l = !0, m] = useState();
  if (!A) return null;
  const { coinName: b } = A;
  return /* @__PURE__ */ jsxs("div", { className: twMerge("flex flex-1 flex-col", s), children: [
    /* @__PURE__ */ jsx(
      DialogHeader,
      {
        title: `Manage ${b} Inscriptions`,
        className: "mb-4 text-accent-primary",
        onClose: () => void (u == null ? void 0 : u(p, l))
      }
    ),
    /* @__PURE__ */ jsxs(DialogBody, { children: [
      /* @__PURE__ */ jsxs(Text, { className: "mb-8 text-accent-secondary", children: [
        "By default, we will not use ",
        b,
        " that contains Inscriptions - such as Ordinals, NFTs, or Runes - in your stakeable balance. This helps prevent any accidental loss of your Inscriptions due to staking, unbonding, or withdrawal fees."
      ] }),
      /* @__PURE__ */ jsxs(Text, { className: "mb-10 text-accent-secondary", children: [
        "If you would like to include ",
        b,
        " with Inscriptions in your stakeable balance, please select the option below."
      ] }),
      /* @__PURE__ */ jsxs("form", { action: "", children: [
        /* @__PURE__ */ jsx(
          FieldControl,
          {
            label: /* @__PURE__ */ jsxs("div", { children: [
              /* @__PURE__ */ jsx("strong", { className: "mr-2", children: "Do not use" }),
              " ",
              b,
              " with Inscriptions for staking. (Recommended)"
            ] }),
            className: "mb-8",
            children: /* @__PURE__ */ jsx(Radio, { name: "inscriptions", checked: p, onChange: () => t(!0) })
          }
        ),
        /* @__PURE__ */ jsx(
          FieldControl,
          {
            label: /* @__PURE__ */ jsxs("div", { children: [
              /* @__PURE__ */ jsx("strong", { className: "mr-2", children: "Use" }),
              " ",
              b,
              " with Inscriptions in my stakable balance."
            ] }),
            className: "mb-8",
            children: /* @__PURE__ */ jsx(Radio, { name: "inscriptions", checked: !p, onChange: () => t(!1) })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsxs(DialogFooter, { className: "mt-auto pt-10", children: [
      /* @__PURE__ */ jsx(
        Checkbox,
        {
          checked: !l,
          label: "Do not show again",
          labelClassName: "mb-6",
          onChange: (k) => m(!k)
        }
      ),
      /* @__PURE__ */ jsx(Button, { fluid: !0, onClick: () => void (u == null ? void 0 : u(p, l)), children: "Save" })
    ] })
  ] });
}
function InscriptionsContainer({ className: s, onSubmit: A }) {
  var p;
  const { chains: u } = useWidgetState();
  return /* @__PURE__ */ jsx(Inscriptions, { className: s, onSubmit: A, config: (p = u.BTC) == null ? void 0 : p.config });
}
function LoaderScreen({ className: s, title: A }) {
  return /* @__PURE__ */ jsxs("div", { className: twMerge("flex flex-col items-center justify-center gap-6", s), children: [
    /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center bg-primary-contrast p-6", children: /* @__PURE__ */ jsx(Loader, { className: "text-primary-light" }) }),
    A && /* @__PURE__ */ jsx(Heading, { variant: "h4", className: "capitalize text-accent-primary", children: A })
  ] });
}
const defaultState = {
  termsOfUse: !1,
  inscriptions: !1,
  staking: !1
};
function TermsOfService({ className: s, onClose: A, onSubmit: u }) {
  const [p, t] = useState(defaultState), l = useMemo(() => Object.values(p).every((b) => b), [p]), m = useCallback(
    (b) => (k = !1) => {
      t((C) => ({ ...C, [b]: k }));
    },
    []
  );
  return /* @__PURE__ */ jsxs("div", { className: twMerge("flex flex-1 flex-col", s), children: [
    /* @__PURE__ */ jsx(DialogHeader, { className: "mb-6 text-accent-primary", title: "Connect Wallets", onClose: A, children: /* @__PURE__ */ jsx(Text, { className: "text-accent-secondary", children: "Please read and accept the following terms" }) }),
    /* @__PURE__ */ jsxs(DialogBody, { children: [
      /* @__PURE__ */ jsx(
        FieldControl,
        {
          label: /* @__PURE__ */ jsxs("div", { className: "block", children: [
            "I certify that I have read and accept the updated",
            " ",
            /* @__PURE__ */ jsx(
              "a",
              {
                href: "https://babylonlabs.io/terms-of-use",
                target: "_blank",
                rel: "noopener noreferrer",
                className: "underline",
                children: "Terms of Use"
              }
            ),
            " ",
            "and",
            " ",
            /* @__PURE__ */ jsx(
              "a",
              {
                href: "https://babylonlabs.io/privacy-policy",
                target: "_blank",
                rel: "noopener noreferrer",
                className: "underline",
                children: "Privacy Policy"
              }
            ),
            "."
          ] }),
          className: "mb-4",
          children: /* @__PURE__ */ jsx(Checkbox, { checked: p.termsOfUse, onChange: m("termsOfUse") })
        }
      ),
      /* @__PURE__ */ jsx(
        FieldControl,
        {
          label: "I certify that I wish to stake bitcoin and agree that doing so may cause some or all of the bitcoin ordinals, NFTs, Runes, and other inscriptions in the connected bitcoin wallet to be lost. I acknowledge that this interface will not detect all Inscriptions.",
          className: "mb-4",
          children: /* @__PURE__ */ jsx(Checkbox, { checked: p.inscriptions, onChange: m("inscriptions") })
        }
      ),
      /* @__PURE__ */ jsx(FieldControl, { label: "I acknowledge that the following are the only hardware wallets supporting Bitcoin Staking: (1) Keystone -- via QR code and (2) OneKey -- via the OneKey Chrome extension and the hardware devices (a) OneKey Pro and (b) OneKey Classic 1s (experimental, 3.10.1 firmware or higher) using Taproot only. Using any other hardware wallet through any means (such as connection to a software/extension/mobile wallet) can lead to permanent inability to withdraw the stake.", children: /* @__PURE__ */ jsx(Checkbox, { checked: p.staking, onChange: m("staking") }) })
    ] }),
    /* @__PURE__ */ jsx(DialogFooter, { className: "mt-auto pt-6", children: /* @__PURE__ */ jsx(Button, { disabled: !l, fluid: !0, onClick: u, "data-testid": "terms-next-button", children: "Next" }) })
  ] });
}
function TermsOfServiceContainer(s) {
  var u;
  const { chains: A } = useWidgetState();
  return /* @__PURE__ */ jsx(TermsOfService, { ...s, config: (u = A.BTC) == null ? void 0 : u.config });
}
function WalletButton({
  className: s,
  disabled: A = !1,
  name: u,
  logo: p,
  label: t,
  fallbackLink: l,
  installed: m = !0,
  onClick: b
}) {
  const k = m ? { as: "button", disabled: A, onClick: b } : { as: "a", href: l, target: "_blank" }, C = () => {
    const B = u.toLowerCase();
    return B.includes("okx") ? "wallet-option-okx" : B.includes("keplr") ? "wallet-option-keplr" : B.includes("leap") ? "wallet-option-leap" : `wallet-option-${B.replace(/\s+/g, "-")}`;
  };
  return /* @__PURE__ */ jsxs(
    Text,
    {
      className: twMerge(
        "flex h-14 w-full cursor-pointer items-center gap-2.5 rounded border border-secondary-strokeLight text-accent-primary px-2",
        A ? "cursor-default" : "cursor-pointer",
        s
      ),
      ...k,
      "data-testid": C(),
      children: [
        /* @__PURE__ */ jsx(Avatar, { variant: "rounded", className: "shrink-0", alt: u, url: p }),
        u,
        t && /* @__PURE__ */ jsx(Chip, { className: "ml-auto shrink-0", children: t })
      ]
    }
  );
}
const Wallets = memo(({ chain: s, className: A, append: u, onClose: p, onBack: t, onSelectWallet: l }) => {
  const m = useMemo(
    () => s.wallets.filter((k) => k.id === "injectable" ? k.installed : !0),
    [s]
  ), b = useCallback(
    async (k) => {
      l == null || l(s, k);
    },
    [s, l]
  );
  return /* @__PURE__ */ jsxs("div", { className: twMerge("flex flex-1 flex-col", A), children: [
    /* @__PURE__ */ jsx(DialogHeader, { className: "mb-10 text-accent-primary", title: "Select Wallet", onClose: p, children: /* @__PURE__ */ jsxs(Text, { className: "text-accent-secondary", children: [
      "Connect a ",
      s.name,
      " Wallet"
    ] }) }),
    /* @__PURE__ */ jsxs(DialogBody, { children: [
      /* @__PURE__ */ jsx("div", { className: twMerge("grid gap-6", m.length > 1 ? "grid-cols-1 md:grid-cols-2" : "grid-cols-1"), children: m.map((k) => /* @__PURE__ */ jsx(
        WalletButton,
        {
          installed: k.installed,
          name: k.name,
          logo: k.icon,
          label: k.label,
          fallbackLink: k.docs,
          onClick: () => b(k)
        },
        k.id
      )) }),
      u
    ] }),
    /* @__PURE__ */ jsx(DialogFooter, { className: "mt-auto pt-10", children: /* @__PURE__ */ jsx(Button, { variant: "outlined", fluid: !0, onClick: t, children: "Back" }) })
  ] });
});
function WalletsContainer({ widgets: s = {}, ...A }) {
  var k;
  const { chains: u, screen: p, displayChains: t } = useWidgetState(), l = ((k = p.params) == null ? void 0 : k.chain) ?? "", m = u == null ? void 0 : u[l], b = s == null ? void 0 : s[l];
  return /* @__PURE__ */ jsx(Wallets, { append: b, chain: m, onBack: t, ...A });
}
const SCREENS = {
  TERMS_OF_SERVICE: ({ className: s, onClose: A, onAccepTermsOfService: u }) => /* @__PURE__ */ jsx(TermsOfServiceContainer, { className: s, onClose: A, onSubmit: u }),
  CHAINS: ({ className: s, onClose: A, onConfirm: u, onDisconnectWallet: p }) => /* @__PURE__ */ jsx(ChainsContainer, { className: s, onClose: A, onConfirm: u, onDisconnectWallet: p }),
  WALLETS: ({ className: s, widgets: A, onClose: u, onSelectWallet: p }) => /* @__PURE__ */ jsx(WalletsContainer, { widgets: A, className: s, onClose: u, onSelectWallet: p }),
  INSCRIPTIONS: ({ className: s, onToggleInscriptions: A }) => /* @__PURE__ */ jsx(InscriptionsContainer, { className: s, onSubmit: A }),
  LOADER: ({ className: s, current: A }) => {
    var u;
    return /* @__PURE__ */ jsx(LoaderScreen, { className: s, title: (u = A == null ? void 0 : A.params) == null ? void 0 : u.message });
  },
  ERROR: () => /* @__PURE__ */ jsx(ErrorContainer, { className: "min-h-0 md:w-[600px]" }),
  EMPTY: ({ className: s }) => /* @__PURE__ */ jsx("div", { className: s })
};
function Screen(s) {
  const A = SCREENS[s.current.type] ?? SCREENS.EMPTY;
  return /* @__PURE__ */ jsx(A, { ...s });
}
const ANIMATION_DELAY = 1e3;
function WalletDialog({ persistent: s, storage: A, config: u, onError: p }) {
  const { visible: t, screen: l, confirmed: m, close: b, confirm: k, displayChains: C } = useWidgetState(), { toggleShowAgain: B, toggleLockInscriptions: Q } = useInscriptionProvider(), P = useChainProviders(), x = useWalletWidgets(P, u, p), { connect: M, disconnect: F } = useWalletConnectors({ persistent: s, accountStorage: A, onError: p }), { disconnect: le } = useWalletConnect(), ge = useCallback(() => {
    C == null || C();
  }, [C]), pe = useCallback(
    (Pe, Te) => {
      B == null || B(Te), Q == null || Q(Pe), C == null || C();
    },
    [B, Q, C]
  ), Ie = useCallback(() => {
    b == null || b(), m || setTimeout(le, ANIMATION_DELAY);
  }, [b, le, m]), be = useCallback(() => {
    k == null || k(), b == null || b();
  }, [k]);
  return /* @__PURE__ */ jsx(ResponsiveDialog, { className: "min-h-[80%]", open: t, onClose: Ie, children: /* @__PURE__ */ jsx(
    Screen,
    {
      current: l,
      widgets: x,
      className: "min-h-0 md:size-[600px]",
      onClose: Ie,
      onConfirm: be,
      onSelectWallet: M,
      onAccepTermsOfService: ge,
      onToggleInscriptions: pe,
      onDisconnectWallet: F
    }
  ) });
}
const BBN_TESTNET_RPC_URL = "https://rpc-dapp.testnet.babylonlabs.io/", BBN_TESTNET_LCD_URL = "https://lcd-dapp.testnet.babylonlabs.io/", bbnTestnet = {
  chainId: "bbn-test-6",
  chainName: "Babylon Testnet",
  chainSymbolImageUrl: "https://raw.githubusercontent.com/chainapsis/keplr-chain-registry/main/images/bbn-test/chain.png",
  rpc: BBN_TESTNET_RPC_URL,
  rest: BBN_TESTNET_LCD_URL,
  nodeProvider: {
    name: "Babylonlabs",
    email: "contact@babylonlabs.io",
    website: "https://babylonlabs.io/"
  },
  bip44: {
    coinType: 118
  },
  bech32Config: {
    bech32PrefixAccAddr: "bbn",
    bech32PrefixAccPub: "bbnpub",
    bech32PrefixValAddr: "bbnvaloper",
    bech32PrefixValPub: "bbnvaloperpub",
    bech32PrefixConsAddr: "bbnvalcons",
    bech32PrefixConsPub: "bbnvalconspub"
  },
  currencies: [
    {
      coinDenom: "BABY",
      coinMinimalDenom: "ubbn",
      coinDecimals: 6,
      coinImageUrl: "https://raw.githubusercontent.com/chainapsis/keplr-chain-registry/main/images/bbn-test/chain.png"
    }
  ],
  feeCurrencies: [
    {
      coinDenom: "BABY",
      coinMinimalDenom: "ubbn",
      coinDecimals: 6,
      coinImageUrl: "https://raw.githubusercontent.com/chainapsis/keplr-chain-registry/main/images/bbn-test/chain.png",
      gasPriceStep: {
        low: 7e-3,
        average: 7e-3,
        high: 0.01
      }
    }
  ],
  stakeCurrency: {
    coinDenom: "BABY",
    coinMinimalDenom: "ubbn",
    coinDecimals: 6,
    coinImageUrl: "https://raw.githubusercontent.com/chainapsis/keplr-chain-registry/main/images/bbn-test/chain.png"
  },
  features: ["cosmwasm"]
}, ONE_HOUR = 3600 * 1e3;
Network.SIGNET, bbnTestnet.currencies[0].coinDenom, bbnTestnet.chainName, bbnTestnet.currencies[0].coinDenom, bbnTestnet.chainId;
function WalletProvider({
  ttl: s = ONE_HOUR,
  persistent: A = !1,
  theme: u,
  lifecycleHooks: p,
  children: t,
  config: l,
  context: m = window,
  onError: b,
  disabledWallets: k = [],
  requiredChains: C,
  appKitConfig: B
}) {
  const Q = useMemo(() => createAccountStorage(s), [s]);
  return useMemo(() => {
    if (B)
      try {
        initializeAppKitModal(B);
      } catch (P) {
        console.error("Failed to initialize AppKit modal:", P);
      }
  }, [B]), useAppKitOpenListener(), /* @__PURE__ */ jsx(TomoConnectionProvider, { theme: u, config: l, children: /* @__PURE__ */ jsx(LifeCycleHooksProvider, { value: p, children: /* @__PURE__ */ jsxs(
    ChainProvider,
    {
      persistent: A,
      storage: Q,
      context: m,
      config: l,
      onError: b,
      disabledWallets: k,
      requiredChains: C,
      children: [
        t,
        /* @__PURE__ */ jsx(TomoBTCConnector, { persistent: A, storage: Q }),
        /* @__PURE__ */ jsx(TomoBBNConnector, { persistent: A, storage: Q }),
        /* @__PURE__ */ jsx(WalletDialog, { persistent: A, storage: Q, config: l, onError: b })
      ]
    }
  ) }) });
}
function createWalletConfig({ chains: s, networkConfigs: A }) {
  const u = [];
  return s.includes("BTC") && A.BTC && u.push({
    chain: "BTC",
    connectors: [
      {
        id: "tomo-btc-connector",
        widget: ({ onError: p }) => /* @__PURE__ */ jsx(ExternalWallets, { chainName: "bitcoin", onError: p })
      }
    ],
    config: A.BTC
  }), s.includes("BBN") && A.BBN && u.push({
    chain: "BBN",
    connectors: [
      {
        id: "tomo-bbn-connector",
        widget: ({ onError: p }) => /* @__PURE__ */ jsx(ExternalWallets, { chainName: "cosmos", onError: p })
      }
    ],
    config: A.BBN
  }), s.includes("ETH") && A.ETH && u.push({
    chain: "ETH",
    config: A.ETH
  }), u;
}
const BTCWalletContext = createContext({
  loading: !0,
  network: void 0,
  connected: !1,
  publicKeyNoCoord: "",
  address: "",
  disconnect: () => {
  },
  open: () => {
  },
  getAddress: async () => "",
  getPublicKeyHex: async () => "",
  signPsbt: async () => "",
  signPsbts: async () => [],
  getNetwork: async () => ({}),
  signMessage: async () => "",
  getInscriptions: async () => []
}), BTCWalletProvider = ({ children: s, callbacks: A }) => {
  const [u, p] = useState(!0), [t, l] = useState(), [m, b] = useState(), [k, C] = useState(""), [B, Q] = useState(""), P = useChainConnector("BTC"), { open: x = () => {
  } } = useWalletConnect(), M = useCallback(async () => {
    var xe;
    l(void 0), b(void 0), C(""), Q("");
    try {
      await ((xe = A == null ? void 0 : A.onDisconnect) == null ? void 0 : xe.call(A));
    } catch (Ee) {
      console.error("Error in onDisconnect callback:", Ee);
    }
  }, [A]), F = useCallback(
    async (xe) => {
      var Ee, He;
      if (xe) {
        p(!0);
        try {
          const ve = await xe.getAddress();
          if (!ve)
            throw new Error("BTC wallet provider returned an empty address");
          const we = await xe.getPublicKeyHex();
          if (!we)
            throw new Error("BTC wallet provider returned an empty public key");
          const Ce = we.length === 66 ? we.slice(2) : we;
          if (!Ce)
            throw new Error("Processed BTC public key (no coordinates) is empty");
          l(xe), Q(ve), C(Ce), p(!1), await ((Ee = A == null ? void 0 : A.onConnect) == null ? void 0 : Ee.call(A, ve, Ce));
        } catch (ve) {
          throw p(!1), (He = A == null ? void 0 : A.onError) == null || He.call(A, ve, { address: B, publicKeyNoCoord: k }), ve;
        }
      }
    },
    [A, B, k]
  );
  useEffect(() => (p(!1), P ? (P.connectedWallet && F(P == null ? void 0 : P.connectedWallet.provider), P == null ? void 0 : P.on("connect", (Ee) => {
    Ee.provider && F(Ee.provider);
  })) : void 0), [P, F]), useEffect(() => P ? P.on("disconnect", () => {
    M();
  }) : void 0, [P, M]), useEffect(() => {
    if (!t) return;
    const xe = async () => {
      var Ee, He;
      try {
        const ve = await t.getAddress();
        ve && ve !== B && (Q(ve), await ((Ee = A == null ? void 0 : A.onAddressChange) == null ? void 0 : Ee.call(A, ve)));
      } catch (ve) {
        (He = A == null ? void 0 : A.onError) == null || He.call(A, ve);
      }
    };
    return typeof t.on == "function" && t.on("accountsChanged", xe), () => {
      typeof t.off == "function" && t.off("accountsChanged", xe);
    };
  }, [t, B, A]);
  const le = useMemo(
    () => !!(t && B && k),
    [t, B, k]
  ), ge = useCallback(async () => {
    if (!t) throw new Error("BTC Wallet not connected");
    return t.getAddress();
  }, [t]), pe = useCallback(async () => {
    if (!t) throw new Error("BTC Wallet not connected");
    return t.getPublicKeyHex();
  }, [t]), Ie = useCallback(
    async (xe, Ee) => {
      if (!t) throw new Error("BTC Wallet not connected");
      return t.signPsbt(xe, Ee);
    },
    [t]
  ), be = useCallback(
    async (xe, Ee) => {
      if (!t) throw new Error("BTC Wallet not connected");
      return t.signPsbts(xe, Ee);
    },
    [t]
  ), Pe = useCallback(async () => {
    if (!t) throw new Error("BTC Wallet not connected");
    return t.getNetwork();
  }, [t]), Te = useCallback(
    async (xe, Ee) => {
      if (!t) throw new Error("BTC Wallet not connected");
      return t.signMessage(xe, Ee);
    },
    [t]
  ), Qe = useCallback(async () => {
    if (!t) throw new Error("BTC Wallet not connected");
    return t.getInscriptions();
  }, [t]);
  return /* @__PURE__ */ jsx(
    BTCWalletContext.Provider,
    {
      value: {
        loading: u,
        network: m,
        connected: le,
        publicKeyNoCoord: k,
        address: B,
        disconnect: M,
        open: x,
        getAddress: ge,
        getPublicKeyHex: pe,
        signPsbt: Ie,
        signPsbts: be,
        getNetwork: Pe,
        signMessage: Te,
        getInscriptions: Qe
      },
      children: s
    }
  );
}, useBTCWallet = () => useContext(BTCWalletContext), CosmosWalletContext = createContext({
  loading: !0,
  bech32Address: "",
  connected: !1,
  disconnect: () => {
  },
  open: () => {
  },
  signingStargateClient: void 0,
  walletName: ""
}), CosmosWalletProvider = ({
  children: s,
  config: A,
  callbacks: u
}) => {
  const [p, t] = useState(!0), [l, m] = useState(), [b, k] = useState(""), [C, B] = useState(), [Q, P] = useState(""), { open: x = () => {
  } } = useWalletConnect(), M = useChainConnector("BBN"), F = useCallback(async () => {
    var pe;
    m(void 0), k(""), B(void 0), P("");
    try {
      await ((pe = u == null ? void 0 : u.onDisconnect) == null ? void 0 : pe.call(u));
    } catch (Ie) {
      console.error("Error in onDisconnect callback:", Ie);
    }
  }, [u]), le = useCallback(
    async (pe) => {
      var Ie, be;
      if (pe) {
        t(!0);
        try {
          const Pe = pe.getOfflineSignerAuto ? await pe.getOfflineSignerAuto() : await pe.getOfflineSigner();
          if (Pe.chainId && Pe.chainId !== A.chainId)
            throw new Error(
              `Cosmos wallet chain ID does not match configured chain ID (${A.chainId}).`
            );
          const Te = await pe.getAddress();
          if (!Te)
            throw new Error("Cosmos wallet provider returned an empty address");
          const Qe = await pe.getWalletProviderName();
          if (!Qe)
            throw new Error("Cosmos wallet provider returned an empty wallet name");
          const xe = {};
          A.registry && (xe.registry = A.registry), A.aminoTypes && (xe.aminoTypes = A.aminoTypes);
          const Ee = await SigningStargateClient.connectWithSigner(
            A.rpc,
            Pe,
            xe
          );
          B(Ee), m(pe), k(Te), P(Qe || "Unknown Wallet"), t(!1), await ((Ie = u == null ? void 0 : u.onConnect) == null ? void 0 : Ie.call(u, Te));
        } catch (Pe) {
          throw t(!1), (be = u == null ? void 0 : u.onError) == null || be.call(u, Pe, { address: b, walletName: Q }), Pe;
        }
      }
    },
    [A, u, b, Q]
  );
  useEffect(() => (t(!1), M ? (M.connectedWallet && le(M == null ? void 0 : M.connectedWallet.provider), M.on("connect", (Ie) => {
    Ie.provider && le(Ie.provider);
  })) : void 0), [M, le]), useEffect(() => M ? M.on("disconnect", () => {
    F();
  }) : void 0, [M, F]);
  const ge = !!(l && b && C);
  return /* @__PURE__ */ jsx(
    CosmosWalletContext.Provider,
    {
      value: {
        loading: p,
        bech32Address: b,
        connected: ge,
        disconnect: F,
        open: x,
        signingStargateClient: C,
        walletName: Q
      },
      children: s
    }
  );
}, useCosmosWallet = () => useContext(CosmosWalletContext), ETHWalletContext = createContext({
  loading: !0,
  connected: !1,
  address: void 0,
  disconnect: () => {
  },
  open: () => {
  }
}), ETHWalletProvider = ({ children: s, callbacks: A }) => {
  const [u, p] = useState(!0), [t, l] = useState(), { open: m } = useWalletConnect(), b = useChainConnector("ETH"), k = useCallback(async () => {
    var Q;
    l(void 0), b == null || b.disconnect();
    try {
      await ((Q = A == null ? void 0 : A.onDisconnect) == null ? void 0 : Q.call(A));
    } catch (P) {
      console.error("Error in onDisconnect callback:", P);
    }
  }, [b, A]), C = useCallback(
    async (Q) => {
      var P, x;
      try {
        l(Q), p(!1), await ((P = A == null ? void 0 : A.onConnect) == null ? void 0 : P.call(A, Q));
      } catch (M) {
        p(!1), (x = A == null ? void 0 : A.onError) == null || x.call(A, M, { address: Q });
      }
    },
    [A]
  );
  useEffect(() => (p(!1), b ? ((async () => {
    var x;
    try {
      if ((x = b.connectedWallet) != null && x.provider && !t) {
        const M = await b.connectedWallet.provider.getAddress();
        M && C(M);
        return;
      }
      if (!t && b.wallets.length > 0) {
        const M = b.wallets[0];
        if (M.provider)
          try {
            await M.provider.getAddress() && await b.connect(M);
          } catch {
          }
      }
    } catch {
    }
  })(), b.on("connect", async (x) => {
    if (x.provider)
      try {
        const M = await x.provider.getAddress();
        M && C(M);
      } catch (M) {
        console.error("Error getting ETH address:", M);
      }
  })) : void 0), [b, C, t]), useEffect(() => b ? b.on("disconnect", () => {
    k();
  }) : void 0, [b, k]);
  const B = useMemo(
    () => !!t,
    [t]
  );
  return /* @__PURE__ */ jsx(
    ETHWalletContext.Provider,
    {
      value: {
        loading: u,
        connected: B,
        address: t,
        disconnect: k,
        open: m
      },
      children: s
    }
  );
}, useETHWallet = () => useContext(ETHWalletContext), useAppKitBtcBridge = ({ onError: s } = {}) => {
  const { isConnected: A, address: u, allAccounts: p } = useAppKitAccount({ namespace: "bip122" }), t = useChainConnector("BTC"), l = useRef(null), m = useCallback(
    async (b) => {
      try {
        try {
          const { adapter: C, network: B } = getSharedBtcAppKitConfig(), P = {
            mainnet: bitcoin$2,
            signet: bitcoinSignet
          }[B];
          await C.switchNetwork({ caipNetwork: P });
        } catch (C) {
          console.warn("[AppKit BTC Bridge] Failed to switch network:", C);
        }
        let k;
        try {
          const C = p == null ? void 0 : p.find((B) => B.address === b);
          C != null && C.publicKey ? k = C.publicKey : console.warn("[AppKit BTC Bridge] Public key not available in current account");
        } catch (C) {
          console.error("[AppKit BTC Bridge] Error fetching public key:", C);
        }
        if (typeof window < "u") {
          const C = { address: b, publicKey: k };
          window.dispatchEvent(
            new CustomEvent(APPKIT_BTC_CONNECTED_EVENT, {
              detail: C
            })
          ), l.current = b;
        }
      } catch (k) {
        console.error("[AppKit BTC Bridge] Failed to process connection:", k), s == null || s(k);
      }
    },
    [p, s]
  );
  return useEffect(() => {
    const b = () => {
      l.current = null, A && u && m(u);
    };
    if (typeof window < "u")
      return window.addEventListener(APPKIT_OPEN_EVENT, b), () => window.removeEventListener(APPKIT_OPEN_EVENT, b);
  }, [A, u, p, m]), useEffect(() => {
    var b;
    if (A && u) {
      if (l.current === u)
        return;
      m(u);
    } else !A && ((b = t == null ? void 0 : t.connectedWallet) == null ? void 0 : b.id) === APPKIT_BTC_CONNECTOR_ID && (l.current = null, t.disconnect().catch((k) => {
      console.error("Failed to disconnect from babylon-wallet-connector:", k);
    }));
  }, [A, u, t, s, m]), {
    isAppKitBtcConnected: A,
    appKitBtcAddress: u
  };
};
export {
  initializeAppKitModal as $,
  AbiFunctionSignatureNotFoundError as A,
  Buffer as B,
  BaseError$3 as C,
  getUrl as D,
  stringify as E,
  decodeErrorResult as F,
  call as G,
  concat as H,
  InvalidArrayError as I,
  HttpRequestError as J,
  isHex as K,
  ExternalWallets as L,
  createWalletConfig as M,
  Nt as N,
  useChainConnector as O,
  useWalletConnect as P,
  useWidgetState as Q,
  useAppKitBtcBridge as R,
  useAppKitOpenListener as S,
  useInscriptionProvider as T,
  createExternalWallet as U,
  setSharedWagmiConfig as V,
  WalletProvider as W,
  getSharedWagmiConfig as X,
  hasSharedWagmiConfig as Y,
  APPKIT_ETH_CONNECTOR_ID as Z,
  APPKIT_BTC_CONNECTOR_ID as _,
  global$1 as a,
  setSharedBtcAppKitConfig as a0,
  getSharedBtcAppKitConfig as a1,
  hasSharedBtcAppKitConfig as a2,
  BTCWalletProvider as a3,
  useBTCWallet as a4,
  CosmosWalletProvider as a5,
  useCosmosWallet as a6,
  ETHWalletProvider as a7,
  useETHWallet as a8,
  StateContext as a9,
  StateProvider as aa,
  Network as ab,
  getDefaultExportFromCjs as b,
  commonjsGlobal as c,
  anumber$1 as d,
  eventsExports as e,
  concatBytes$3 as f,
  getAugmentedNamespace as g,
  hmac as h,
  slice as i,
  formatAbiItem$1 as j,
  decodeAbiParameters as k,
  getAbiItem as l,
  AbiErrorNotFoundError as m,
  AbiErrorInputsNotFoundError as n,
  encodeAbiParameters as o,
  process$1 as p,
  concatHex as q,
  randomBytes as r,
  sha256$2 as s,
  toFunctionSelector as t,
  AbiFunctionNotFoundError as u,
  AbiFunctionOutputsNotFoundError as v,
  batchGatewayAbi as w,
  solidityError as x,
  isAddress as y,
  InvalidAddressError as z
};
//# sourceMappingURL=index-CQUkO-kV.js.map
